
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire29bb"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire29bb"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ayMG0", function(module, exports) {
"use strict";

module.exports = (parcelRequire("1b2ls"));

});
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
"use strict";
parcelRequire("8coUR");

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$g = 60103;
$0db8a335f84591c1$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $0db8a335f84591c1$var$h = Symbol.for;
    $0db8a335f84591c1$var$g = $0db8a335f84591c1$var$h("react.element");
    $0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$h("react.fragment");
}
var $0db8a335f84591c1$var$m = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$n = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$0db8a335f84591c1$var$n.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $0db8a335f84591c1$var$m.current
    };
}
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("8coUR", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $5f82c58e3d599bd6$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $5f82c58e3d599bd6$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $5f82c58e3d599bd6$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $5f82c58e3d599bd6$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $5f82c58e3d599bd6$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $5f82c58e3d599bd6$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $5f82c58e3d599bd6$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($5f82c58e3d599bd6$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($5f82c58e3d599bd6$var$getOwnPropertySymbols) {
            symbols = $5f82c58e3d599bd6$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($5f82c58e3d599bd6$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});

parcelRegister("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$83d89fbfd8236492;
"use strict";

var $8coUR = parcelRequire("8coUR");
var $1c29a66706a62afd$var$n = 60103, $1c29a66706a62afd$var$p = 60106;
$1c29a66706a62afd$export$ffb0004e005737fa = 60107;
$1c29a66706a62afd$export$5f8d39834fd61797 = 60108;
$1c29a66706a62afd$export$e2c29f18771995cb = 60114;
var $1c29a66706a62afd$var$q = 60109, $1c29a66706a62afd$var$r = 60110, $1c29a66706a62afd$var$t = 60112;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = 60113;
var $1c29a66706a62afd$var$u = 60115, $1c29a66706a62afd$var$v = 60116;
if ("function" === typeof Symbol && Symbol.for) {
    var $1c29a66706a62afd$var$w = Symbol.for;
    $1c29a66706a62afd$var$n = $1c29a66706a62afd$var$w("react.element");
    $1c29a66706a62afd$var$p = $1c29a66706a62afd$var$w("react.portal");
    $1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$w("react.fragment");
    $1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$w("react.strict_mode");
    $1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$w("react.profiler");
    $1c29a66706a62afd$var$q = $1c29a66706a62afd$var$w("react.provider");
    $1c29a66706a62afd$var$r = $1c29a66706a62afd$var$w("react.context");
    $1c29a66706a62afd$var$t = $1c29a66706a62afd$var$w("react.forward_ref");
    $1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w("react.suspense");
    $1c29a66706a62afd$var$u = $1c29a66706a62afd$var$w("react.memo");
    $1c29a66706a62afd$var$v = $1c29a66706a62afd$var$w("react.lazy");
}
var $1c29a66706a62afd$var$x = "function" === typeof Symbol && Symbol.iterator;
function $1c29a66706a62afd$var$y(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$x && a[$1c29a66706a62afd$var$x] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function $1c29a66706a62afd$var$z(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $1c29a66706a62afd$var$A = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$B = {};
function $1c29a66706a62afd$var$C(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$B;
    this.updater = c || $1c29a66706a62afd$var$A;
}
$1c29a66706a62afd$var$C.prototype.isReactComponent = {};
$1c29a66706a62afd$var$C.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($1c29a66706a62afd$var$z(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$C.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$D() {}
$1c29a66706a62afd$var$D.prototype = $1c29a66706a62afd$var$C.prototype;
function $1c29a66706a62afd$var$E(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$B;
    this.updater = c || $1c29a66706a62afd$var$A;
}
var $1c29a66706a62afd$var$F = $1c29a66706a62afd$var$E.prototype = new $1c29a66706a62afd$var$D;
$1c29a66706a62afd$var$F.constructor = $1c29a66706a62afd$var$E;
$8coUR($1c29a66706a62afd$var$F, $1c29a66706a62afd$var$C.prototype);
$1c29a66706a62afd$var$F.isPureReactComponent = !0;
var $1c29a66706a62afd$var$G = {
    current: null
}, $1c29a66706a62afd$var$H = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$I = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$J(a, b, c) {
    var e, d = {}, k = null, h = null;
    if (null != b) for(e in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$H.call(b, e) && !$1c29a66706a62afd$var$I.hasOwnProperty(e) && (d[e] = b[e]);
    var g = arguments.length - 2;
    if (1 === g) d.children = c;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        d.children = f;
    }
    if (a && a.defaultProps) for(e in g = a.defaultProps, g)void 0 === d[e] && (d[e] = g[e]);
    return {
        $$typeof: $1c29a66706a62afd$var$n,
        type: a,
        key: k,
        ref: h,
        props: d,
        _owner: $1c29a66706a62afd$var$G.current
    };
}
function $1c29a66706a62afd$var$K(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$n,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$L(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$n;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$M = /\/+/g;
function $1c29a66706a62afd$var$N(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$O(a, b, c, e, d) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$n:
                case $1c29a66706a62afd$var$p:
                    h = !0;
            }
    }
    if (h) return h = a, d = d(h), a = "" === e ? "." + $1c29a66706a62afd$var$N(h, 0) : e, Array.isArray(d) ? (c = "", null != a && (c = a.replace($1c29a66706a62afd$var$M, "$&/") + "/"), $1c29a66706a62afd$var$O(d, b, c, "", function(a) {
        return a;
    })) : null != d && ($1c29a66706a62afd$var$L(d) && (d = $1c29a66706a62afd$var$K(d, c + (!d.key || h && h.key === d.key ? "" : ("" + d.key).replace($1c29a66706a62afd$var$M, "$&/") + "/") + a)), b.push(d)), 1;
    h = 0;
    e = "" === e ? "." : e + ":";
    if (Array.isArray(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = e + $1c29a66706a62afd$var$N(k, g);
        h += $1c29a66706a62afd$var$O(k, b, c, f, d);
    }
    else if (f = $1c29a66706a62afd$var$y(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = e + $1c29a66706a62afd$var$N(k, g++), h += $1c29a66706a62afd$var$O(k, b, c, f, d);
    else if ("object" === k) throw b = "" + a, Error($1c29a66706a62afd$var$z(31, "[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b));
    return h;
}
function $1c29a66706a62afd$var$P(a, b, c) {
    if (null == a) return a;
    var e = [], d = 0;
    $1c29a66706a62afd$var$O(a, e, "", "", function(a) {
        return b.call(c, a, d++);
    });
    return e;
}
function $1c29a66706a62afd$var$Q(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        a._status = 0;
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
    if (1 === a._status) return a._result;
    throw a._result;
}
var $1c29a66706a62afd$var$R = {
    current: null
};
function $1c29a66706a62afd$var$S() {
    var a = $1c29a66706a62afd$var$R.current;
    if (null === a) throw Error($1c29a66706a62afd$var$z(321));
    return a;
}
var $1c29a66706a62afd$var$T = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$R,
    ReactCurrentBatchConfig: {
        transition: 0
    },
    ReactCurrentOwner: $1c29a66706a62afd$var$G,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $8coUR
};
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$P,
    forEach: function(a, b, c) {
        $1c29a66706a62afd$var$P(a, function() {
            b.apply(this, arguments);
        }, c);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$P(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$P(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$L(a)) throw Error($1c29a66706a62afd$var$z(143));
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$C;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$T;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($1c29a66706a62afd$var$z(267, a));
    var e = $8coUR({}, a.props), d = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$G.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$H.call(b, f) && !$1c29a66706a62afd$var$I.hasOwnProperty(f) && (e[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) e.children = c;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        e.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$n,
        type: a.type,
        key: d,
        ref: k,
        props: e,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $1c29a66706a62afd$var$r,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$q,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$J;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$J.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$t,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$L;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$Q
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$u,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$S().useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a, b) {
    return $1c29a66706a62afd$var$S().useContext(a, b);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$S().useEffect(a, b);
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, c) {
    return $1c29a66706a62afd$var$S().useImperativeHandle(a, b, c);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$S().useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$S().useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, c) {
    return $1c29a66706a62afd$var$S().useReducer(a, b, c);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$S().useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$S().useState(a);
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "17.0.2";

});




parcelRegister("1u0KT", function(module, exports) {
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("Xw6Mv"));

});
parcelRegister("Xw6Mv", function(module, exports) {
/** @license React v17.0.2
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";

var $acw62 = parcelRequire("acw62");

var $8coUR = parcelRequire("8coUR");

var $fO90s = parcelRequire("fO90s");
function y(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$acw62) throw Error(y(227));
var ba = new Set, ca = {};
function da(a, b) {
    ea(a, b);
    ea(a + "Capture", b);
}
function ea(a, b) {
    ca[a] = b;
    for(a = 0; a < b.length; a++)ba.add(b[a]);
}
var fa = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), ha = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, ia = Object.prototype.hasOwnProperty, ja = {}, ka = {};
function la(a) {
    if (ia.call(ka, a)) return !0;
    if (ia.call(ja, a)) return !1;
    if (ha.test(a)) return ka[a] = !0;
    ja[a] = !0;
    return !1;
}
function ma(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function na(a, b, c, d) {
    if (null === b || "undefined" === typeof b || ma(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function B(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var D = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    D[a] = new B(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    D[b] = new B(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    D[a] = new B(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    D[a] = new B(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    D[a] = new B(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    D[a] = new B(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    D[a] = new B(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    D[a] = new B(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var oa = /[\-:]([a-z])/g;
function pa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(oa, pa);
    D[b] = new B(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
D.xlinkHref = new B("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    D[a] = new B(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function qa(a, b, c, d) {
    var e = D.hasOwnProperty(b) ? D[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (na(b, c, e, d) && (c = null), d || null === e ? la(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var ra = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, sa = 60103, ta = 60106, ua = 60107, wa = 60108, xa = 60114, ya = 60109, za = 60110, Aa = 60112, Ba = 60113, Ca = 60120, Da = 60115, Ea = 60116, Fa = 60121, Ga = 60128, Ha = 60129, Ia = 60130, Ja = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var E = Symbol.for;
    sa = E("react.element");
    ta = E("react.portal");
    ua = E("react.fragment");
    wa = E("react.strict_mode");
    xa = E("react.profiler");
    ya = E("react.provider");
    za = E("react.context");
    Aa = E("react.forward_ref");
    Ba = E("react.suspense");
    Ca = E("react.suspense_list");
    Da = E("react.memo");
    Ea = E("react.lazy");
    Fa = E("react.block");
    E("react.scope");
    Ga = E("react.opaque.id");
    Ha = E("react.debug_trace_mode");
    Ia = E("react.offscreen");
    Ja = E("react.legacy_hidden");
}
var Ka = "function" === typeof Symbol && Symbol.iterator;
function La(a) {
    if (null === a || "object" !== typeof a) return null;
    a = Ka && a[Ka] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var Ma;
function Na(a) {
    if (void 0 === Ma) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        Ma = b && b[1] || "";
    }
    return "\n" + Ma + a;
}
var Oa = !1;
function Pa(a, b) {
    if (!a || Oa) return "";
    Oa = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (k) {
                    var d = k;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (k) {
                    d = k;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (k) {
                d = k;
            }
            a();
        }
    } catch (k) {
        if (k && d && "string" === typeof k.stack) {
            for(var e = k.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) return "\n" + e[g].replace(" at new ", " at ");
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        Oa = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? Na(a) : "";
}
function Qa(a) {
    switch(a.tag){
        case 5:
            return Na(a.type);
        case 16:
            return Na("Lazy");
        case 13:
            return Na("Suspense");
        case 19:
            return Na("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = Pa(a.type, !1), a;
        case 11:
            return a = Pa(a.type.render, !1), a;
        case 22:
            return a = Pa(a.type._render, !1), a;
        case 1:
            return a = Pa(a.type, !0), a;
        default:
            return "";
    }
}
function Ra(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ua:
            return "Fragment";
        case ta:
            return "Portal";
        case xa:
            return "Profiler";
        case wa:
            return "StrictMode";
        case Ba:
            return "Suspense";
        case Ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case za:
            return (a.displayName || "Context") + ".Consumer";
        case ya:
            return (a._context.displayName || "Context") + ".Provider";
        case Aa:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case Da:
            return Ra(a.type);
        case Fa:
            return Ra(a._render);
        case Ea:
            b = a._payload;
            a = a._init;
            try {
                return Ra(a(b));
            } catch (c) {}
    }
    return null;
}
function Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function Ua(a) {
    var b = Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function Va(a) {
    a._valueTracker || (a._valueTracker = Ua(a));
}
function Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function Ya(a, b) {
    var c = b.checked;
    return $8coUR({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a(a, b) {
    b = b.checked;
    null != b && qa(a, "checked", b, !1);
}
function ab(a, b) {
    $a(a, b);
    var c = Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && bb(a, b.type, Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function bb(a, b, c) {
    if ("number" !== b || Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function db(a) {
    var b = "";
    $acw62.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function eb(a, b) {
    a = $8coUR({
        children: void 0
    }, b);
    if (b = db(b.children)) a.children = b;
    return a;
}
function fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(y(91));
    return $8coUR({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(y(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(y(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: Sa(c)
    };
}
function ib(a, b) {
    var c = Sa(b.value), d = Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var kb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function lb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function mb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? lb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var nb, ob = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== kb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        nb = nb || document.createElement("div");
        nb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = nb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function pb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var qb = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, rb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(qb).forEach(function(a) {
    rb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        qb[b] = qb[a];
    });
});
function sb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || qb.hasOwnProperty(a) && qb[a] ? ("" + b).trim() : b + "px";
}
function tb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = sb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var ub = $8coUR({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function vb(a, b) {
    if (b) {
        if (ub[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(y(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(y(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(y(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(y(62));
    }
}
function wb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
function xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var yb = null, zb = null, Ab = null;
function Bb(a) {
    if (a = Cb(a)) {
        if ("function" !== typeof yb) throw Error(y(280));
        var b = a.stateNode;
        b && (b = Db(b), yb(a.stateNode, a.type, b));
    }
}
function Eb(a) {
    zb ? Ab ? Ab.push(a) : Ab = [
        a
    ] : zb = a;
}
function Fb() {
    if (zb) {
        var a = zb, b = Ab;
        Ab = zb = null;
        Bb(a);
        if (b) for(a = 0; a < b.length; a++)Bb(b[a]);
    }
}
function Gb(a, b) {
    return a(b);
}
function Hb(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ib() {}
var Jb = Gb, Kb = !1, Lb = !1;
function Mb() {
    if (null !== zb || null !== Ab) Ib(), Fb();
}
function Nb(a, b, c) {
    if (Lb) return a(b, c);
    Lb = !0;
    try {
        return Jb(a, b, c);
    } finally{
        Lb = !1, Mb();
    }
}
function Ob(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(y(231, b, typeof c));
    return c;
}
var Pb = !1;
if (fa) try {
    var Qb = {};
    Object.defineProperty(Qb, "passive", {
        get: function() {
            Pb = !0;
        }
    });
    window.addEventListener("test", Qb, Qb);
    window.removeEventListener("test", Qb, Qb);
} catch (a) {
    Pb = !1;
}
function Rb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var Sb = !1, Tb = null, Ub = !1, Vb = null, Wb = {
    onError: function(a) {
        Sb = !0;
        Tb = a;
    }
};
function Xb(a, b, c, d, e, f, g, h, k) {
    Sb = !1;
    Tb = null;
    Rb.apply(Wb, arguments);
}
function Yb(a, b, c, d, e, f, g, h, k) {
    Xb.apply(this, arguments);
    if (Sb) {
        if (Sb) {
            var l = Tb;
            Sb = !1;
            Tb = null;
        } else throw Error(y(198));
        Ub || (Ub = !0, Vb = l);
    }
}
function Zb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $b(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function ac(a) {
    if (Zb(a) !== a) throw Error(y(188));
}
function bc(a) {
    var b = a.alternate;
    if (!b) {
        b = Zb(a);
        if (null === b) throw Error(y(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return ac(e), a;
                if (f === d) return ac(e), b;
                f = f.sibling;
            }
            throw Error(y(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(y(189));
            }
        }
        if (c.alternate !== d) throw Error(y(190));
    }
    if (3 !== c.tag) throw Error(y(188));
    return c.stateNode.current === c ? a : b;
}
function cc(a) {
    a = bc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function dc(a, b) {
    for(var c = a.alternate; null !== b;){
        if (b === a || b === c) return !0;
        b = b.return;
    }
    return !1;
}
var ec, fc, gc, hc, ic = !1, jc = [], kc = null, lc = null, mc = null, nc = new Map, oc = new Map, pc = [], qc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a, b, c, d, e) {
    return {
        blockedOn: a,
        domEventName: b,
        eventSystemFlags: c | 16,
        nativeEvent: e,
        targetContainers: [
            d
        ]
    };
}
function sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            kc = null;
            break;
        case "dragenter":
        case "dragleave":
            lc = null;
            break;
        case "mouseover":
        case "mouseout":
            mc = null;
            break;
        case "pointerover":
        case "pointerout":
            nc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            oc.delete(b.pointerId);
    }
}
function tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = rc(b, c, d, e, f), null !== b && (b = Cb(b), null !== b && fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return kc = tc(kc, a, b, c, d, e), !0;
        case "dragenter":
            return lc = tc(lc, a, b, c, d, e), !0;
        case "mouseover":
            return mc = tc(mc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            nc.set(f, tc(nc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, oc.set(f, tc(oc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function vc(a) {
    var b = wc(a.target);
    if (null !== b) {
        var c = Zb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $b(c), null !== b) {
                    a.blockedOn = b;
                    hc(a.lanePriority, function() {
                        $fO90s.unstable_runWithPriority(a.priority, function() {
                            gc(c);
                        });
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null !== c) return b = Cb(c), null !== b && fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function zc(a, b, c) {
    xc(a) && c.delete(b);
}
function Ac() {
    for(ic = !1; 0 < jc.length;){
        var a = jc[0];
        if (null !== a.blockedOn) {
            a = Cb(a.blockedOn);
            null !== a && ec(a);
            break;
        }
        for(var b = a.targetContainers; 0 < b.length;){
            var c = yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
            if (null !== c) {
                a.blockedOn = c;
                break;
            }
            b.shift();
        }
        null === a.blockedOn && jc.shift();
    }
    null !== kc && xc(kc) && (kc = null);
    null !== lc && xc(lc) && (lc = null);
    null !== mc && xc(mc) && (mc = null);
    nc.forEach(zc);
    oc.forEach(zc);
}
function Bc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, ic || (ic = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, Ac)));
}
function Cc(a) {
    function b(b) {
        return Bc(b, a);
    }
    if (0 < jc.length) {
        Bc(jc[0], a);
        for(var c = 1; c < jc.length; c++){
            var d = jc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== kc && Bc(kc, a);
    null !== lc && Bc(lc, a);
    null !== mc && Bc(mc, a);
    nc.forEach(b);
    oc.forEach(b);
    for(c = 0; c < pc.length; c++)d = pc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < pc.length && (c = pc[0], null === c.blockedOn);)vc(c), null === c.blockedOn && pc.shift();
}
function Dc(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Ec = {
    animationend: Dc("Animation", "AnimationEnd"),
    animationiteration: Dc("Animation", "AnimationIteration"),
    animationstart: Dc("Animation", "AnimationStart"),
    transitionend: Dc("Transition", "TransitionEnd")
}, Fc = {}, Gc = {};
fa && (Gc = document.createElement("div").style, "AnimationEvent" in window || (delete Ec.animationend.animation, delete Ec.animationiteration.animation, delete Ec.animationstart.animation), "TransitionEvent" in window || delete Ec.transitionend.transition);
function Hc(a) {
    if (Fc[a]) return Fc[a];
    if (!Ec[a]) return a;
    var b = Ec[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Gc) return Fc[a] = b[c];
    return a;
}
var Ic = Hc("animationend"), Jc = Hc("animationiteration"), Kc = Hc("animationstart"), Lc = Hc("transitionend"), Mc = new Map, Nc = new Map, Oc = [
    "abort",
    "abort",
    Ic,
    "animationEnd",
    Jc,
    "animationIteration",
    Kc,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    Lc,
    "transitionEnd",
    "waiting",
    "waiting"
];
function Pc(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1];
        e = "on" + (e[0].toUpperCase() + e.slice(1));
        Nc.set(d, b);
        Mc.set(d, e);
        da(e, [
            d
        ]);
    }
}
var Qc = $fO90s.unstable_now;
Qc();
var F = 8;
function Rc(a) {
    if (0 !== (1 & a)) return F = 15, 1;
    if (0 !== (2 & a)) return F = 14, 2;
    if (0 !== (4 & a)) return F = 13, 4;
    var b = 24 & a;
    if (0 !== b) return F = 12, b;
    if (0 !== (a & 32)) return F = 11, 32;
    b = 192 & a;
    if (0 !== b) return F = 10, b;
    if (0 !== (a & 256)) return F = 9, 256;
    b = 3584 & a;
    if (0 !== b) return F = 8, b;
    if (0 !== (a & 4096)) return F = 7, 4096;
    b = 4186112 & a;
    if (0 !== b) return F = 6, b;
    b = 62914560 & a;
    if (0 !== b) return F = 5, b;
    if (a & 67108864) return F = 4, 67108864;
    if (0 !== (a & 134217728)) return F = 3, 134217728;
    b = 805306368 & a;
    if (0 !== b) return F = 2, b;
    if (0 !== (1073741824 & a)) return F = 1, 1073741824;
    F = 8;
    return a;
}
function Sc(a) {
    switch(a){
        case 99:
            return 15;
        case 98:
            return 10;
        case 97:
        case 96:
            return 8;
        case 95:
            return 2;
        default:
            return 0;
    }
}
function Tc(a) {
    switch(a){
        case 15:
        case 14:
            return 99;
        case 13:
        case 12:
        case 11:
        case 10:
            return 98;
        case 9:
        case 8:
        case 7:
        case 6:
        case 4:
        case 5:
            return 97;
        case 3:
        case 2:
        case 1:
            return 95;
        case 0:
            return 90;
        default:
            throw Error(y(358, a));
    }
}
function Uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return F = 0;
    var d = 0, e = 0, f = a.expiredLanes, g = a.suspendedLanes, h = a.pingedLanes;
    if (0 !== f) d = f, e = F = 15;
    else if (f = c & 134217727, 0 !== f) {
        var k = f & ~g;
        0 !== k ? (d = Rc(k), e = F) : (h &= f, 0 !== h && (d = Rc(h), e = F));
    } else f = c & ~g, 0 !== f ? (d = Rc(f), e = F) : 0 !== h && (d = Rc(h), e = F);
    if (0 === d) return 0;
    d = 31 - Vc(d);
    d = c & ((0 > d ? 0 : 1 << d) << 1) - 1;
    if (0 !== b && b !== d && 0 === (b & g)) {
        Rc(b);
        if (e <= F) return b;
        F = e;
    }
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - Vc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function Wc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function Xc(a, b) {
    switch(a){
        case 15:
            return 1;
        case 14:
            return 2;
        case 12:
            return a = Yc(24 & ~b), 0 === a ? Xc(10, b) : a;
        case 10:
            return a = Yc(192 & ~b), 0 === a ? Xc(8, b) : a;
        case 8:
            return a = Yc(3584 & ~b), 0 === a && (a = Yc(4186112 & ~b), 0 === a && (a = 512)), a;
        case 2:
            return b = Yc(805306368 & ~b), 0 === b && (b = 268435456), b;
    }
    throw Error(y(358, a));
}
function Yc(a) {
    return a & -a;
}
function Zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c(a, b, c) {
    a.pendingLanes |= b;
    var d = b - 1;
    a.suspendedLanes &= d;
    a.pingedLanes &= d;
    a = a.eventTimes;
    b = 31 - Vc(b);
    a[b] = c;
}
var Vc = Math.clz32 ? Math.clz32 : ad, bd = Math.log, cd = Math.LN2;
function ad(a) {
    return 0 === a ? 32 : 31 - (bd(a) / cd | 0) | 0;
}
var dd = $fO90s.unstable_UserBlockingPriority, ed = $fO90s.unstable_runWithPriority, fd = !0;
function gd(a, b, c, d) {
    Kb || Ib();
    var e = hd, f = Kb;
    Kb = !0;
    try {
        Hb(e, a, b, c, d);
    } finally{
        (Kb = f) || Mb();
    }
}
function id(a, b, c, d) {
    ed(dd, hd.bind(null, a, b, c, d));
}
function hd(a, b, c, d) {
    if (fd) {
        var e;
        if ((e = 0 === (b & 4)) && 0 < jc.length && -1 < qc.indexOf(a)) a = rc(null, a, b, c, d), jc.push(a);
        else {
            var f = yc(a, b, c, d);
            if (null === f) e && sc(a, d);
            else {
                if (e) {
                    if (-1 < qc.indexOf(a)) {
                        a = rc(f, a, b, c, d);
                        jc.push(a);
                        return;
                    }
                    if (uc(f, a, b, c, d)) return;
                    sc(a, d);
                }
                jd(a, b, d, null, c);
            }
        }
    }
}
function yc(a, b, c, d) {
    var e = xb(d);
    e = wc(e);
    if (null !== e) {
        var f = Zb(e);
        if (null === f) e = null;
        else {
            var g = f.tag;
            if (13 === g) {
                e = $b(f);
                if (null !== e) return e;
                e = null;
            } else if (3 === g) {
                if (f.stateNode.hydrate) return 3 === f.tag ? f.stateNode.containerInfo : null;
                e = null;
            } else f !== e && (e = null);
        }
    }
    jd(a, b, d, e, c);
    return null;
}
var kd = null, ld = null, md = null;
function nd() {
    if (md) return md;
    var a, b = ld, c = b.length, d, e = "value" in kd ? kd.value : kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function pd() {
    return !0;
}
function qd() {
    return !1;
}
function rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? pd : qd;
        this.isPropagationStopped = qd;
        return this;
    }
    $8coUR(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = pd);
        },
        persist: function() {},
        isPersistent: pd
    });
    return b;
}
var sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, td = rd(sd), ud = $8coUR({}, sd, {
    view: 0,
    detail: 0
}), vd = rd(ud), wd, xd, yd, Ad = $8coUR({}, ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== yd && (yd && "mousemove" === a.type ? (wd = a.screenX - yd.screenX, xd = a.screenY - yd.screenY) : xd = wd = 0, yd = a);
        return wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : xd;
    }
}), Bd = rd(Ad), Cd = $8coUR({}, Ad, {
    dataTransfer: 0
}), Dd = rd(Cd), Ed = $8coUR({}, ud, {
    relatedTarget: 0
}), Fd = rd(Ed), Gd = $8coUR({}, sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Hd = rd(Gd), Id = $8coUR({}, sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), Jd = rd(Id), Kd = $8coUR({}, sd, {
    data: 0
}), Ld = rd(Kd), Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Od[a]) ? !!b[a] : !1;
}
function zd() {
    return Pd;
}
var Qd = $8coUR({}, ud, {
    key: function(a) {
        if (a.key) {
            var b = Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zd,
    charCode: function(a) {
        return "keypress" === a.type ? od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), Rd = rd(Qd), Sd = $8coUR({}, Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), Td = rd(Sd), Ud = $8coUR({}, ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zd
}), Vd = rd(Ud), Wd = $8coUR({}, sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), Xd = rd(Wd), Yd = $8coUR({}, Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), Zd = rd(Yd), $d = [
    9,
    13,
    27,
    32
], ae = fa && "CompositionEvent" in window, be = null;
fa && "documentMode" in document && (be = document.documentMode);
var ce = fa && "TextEvent" in window && !be, de = fa && (!ae || be && 8 < be && 11 >= be), ee = String.fromCharCode(32), fe = !1;
function ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var ie = !1;
function je(a, b) {
    switch(a){
        case "compositionend":
            return he(b);
        case "keypress":
            if (32 !== b.which) return null;
            fe = !0;
            return ee;
        case "textInput":
            return a = b.data, a === ee && fe ? null : a;
        default:
            return null;
    }
}
function ke(a, b) {
    if (ie) return "compositionend" === a || !ae && ge(a, b) ? (a = nd(), md = ld = kd = null, ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!le[a.type] : "textarea" === b ? !0 : !1;
}
function ne(a, b, c, d) {
    Eb(d);
    b = oe(b, "onChange");
    0 < b.length && (c = new td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var pe = null, qe = null;
function re(a) {
    se(a, 0);
}
function te(a) {
    var b = ue(a);
    if (Wa(b)) return a;
}
function ve(a, b) {
    if ("change" === a) return b;
}
var we = !1;
if (fa) {
    var xe;
    if (fa) {
        var ye = "oninput" in document;
        if (!ye) {
            var ze = document.createElement("div");
            ze.setAttribute("oninput", "return;");
            ye = "function" === typeof ze.oninput;
        }
        xe = ye;
    } else xe = !1;
    we = xe && (!document.documentMode || 9 < document.documentMode);
}
function Ae() {
    pe && (pe.detachEvent("onpropertychange", Be), qe = pe = null);
}
function Be(a) {
    if ("value" === a.propertyName && te(qe)) {
        var b = [];
        ne(b, qe, a, xb(a));
        a = re;
        if (Kb) a(b);
        else {
            Kb = !0;
            try {
                Gb(a, b);
            } finally{
                Kb = !1, Mb();
            }
        }
    }
}
function Ce(a, b, c) {
    "focusin" === a ? (Ae(), pe = b, qe = c, pe.attachEvent("onpropertychange", Be)) : "focusout" === a && Ae();
}
function De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return te(qe);
}
function Ee(a, b) {
    if ("click" === a) return te(b);
}
function Fe(a, b) {
    if ("input" === a || "change" === a) return te(b);
}
function Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var He = "function" === typeof Object.is ? Object.is : Ge, Ie = Object.prototype.hasOwnProperty;
function Je(a, b) {
    if (He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!Ie.call(b, c[d]) || !He(a[c[d]], b[c[d]])) return !1;
    return !0;
}
function Ke(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function Le(a, b) {
    var c = Ke(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = Ke(c);
    }
}
function Me(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? Me(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function Ne() {
    for(var a = window, b = Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = Xa(a.document);
    }
    return b;
}
function Oe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var Pe = fa && "documentMode" in document && 11 >= document.documentMode, Qe = null, Re = null, Se = null, Te = !1;
function Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    Te || null == Qe || Qe !== Xa(d) || (d = Qe, "selectionStart" in d && Oe(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), Se && Je(Se, d) || (Se = d, d = oe(Re, "onSelect"), 0 < d.length && (b = new td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = Qe)));
}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
Pc(Oc, 2);
for(var Ve = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), We = 0; We < Ve.length; We++)Nc.set(Ve[We], 0);
ea("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
ea("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
ea("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
ea("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
da("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
da("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
da("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
da("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var Xe = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), Ye = new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    Yb(d, b, void 0, a);
    a.currentTarget = null;
}
function se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                Ze(e, h, l);
                f = k;
            }
        }
    }
    if (Ub) throw a = Vb, Ub = !1, Vb = null, a;
}
function G(a, b) {
    var c = $e(b), d = a + "__bubble";
    c.has(d) || (af(b, a, 2, !1), c.add(d));
}
var bf = "_reactListening" + Math.random().toString(36).slice(2);
function cf(a) {
    a[bf] || (a[bf] = !0, ba.forEach(function(b) {
        Ye.has(b) || df(b, !1, a, null);
        df(b, !0, a, null);
    }));
}
function df(a, b, c, d) {
    var e = 4 < arguments.length && void 0 !== arguments[4] ? arguments[4] : 0, f = c;
    "selectionchange" === a && 9 !== c.nodeType && (f = c.ownerDocument);
    if (null !== d && !b && Ye.has(a)) {
        if ("scroll" !== a) return;
        e |= 2;
        f = d;
    }
    var g = $e(f), h = a + "__" + (b ? "capture" : "bubble");
    g.has(h) || (b && (e |= 4), af(f, a, e, b), g.add(h));
}
function af(a, b, c, d) {
    var e = Nc.get(b);
    switch(void 0 === e ? 2 : e){
        case 0:
            e = gd;
            break;
        case 1:
            e = id;
            break;
        default:
            e = hd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !Pb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function jd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    Nb(function() {
        var d = f, e = xb(c), g = [];
        a: {
            var h = Mc.get(a);
            if (void 0 !== h) {
                var k = td, x = a;
                switch(a){
                    case "keypress":
                        if (0 === od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = Rd;
                        break;
                    case "focusin":
                        x = "focus";
                        k = Fd;
                        break;
                    case "focusout":
                        x = "blur";
                        k = Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = Vd;
                        break;
                    case Ic:
                    case Jc:
                    case Kc:
                        k = Hd;
                        break;
                    case Lc:
                        k = Xd;
                        break;
                    case "scroll":
                        k = vd;
                        break;
                    case "wheel":
                        k = Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = Td;
                }
                var w = 0 !== (b & 4), z = !w && "scroll" === a, u = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var t = d, q; null !== t;){
                    q = t;
                    var v = q.stateNode;
                    5 === q.tag && null !== v && (q = v, null !== u && (v = Ob(t, u), null != v && w.push(ef(t, v, q))));
                    if (z) break;
                    t = t.return;
                }
                0 < w.length && (h = new k(h, x, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && 0 === (b & 16) && (x = c.relatedTarget || c.fromElement) && (wc(x) || x[ff])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (x = c.relatedTarget || c.toElement, k = d, x = x ? wc(x) : null, null !== x && (z = Zb(x), x !== z || 5 !== x.tag && 6 !== x.tag)) x = null;
                    } else k = null, x = d;
                    if (k !== x) {
                        w = Bd;
                        v = "onMouseLeave";
                        u = "onMouseEnter";
                        t = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = Td, v = "onPointerLeave", u = "onPointerEnter", t = "pointer";
                        z = null == k ? h : ue(k);
                        q = null == x ? h : ue(x);
                        h = new w(v, t + "leave", k, c, e);
                        h.target = z;
                        h.relatedTarget = q;
                        v = null;
                        wc(e) === d && (w = new w(u, t + "enter", x, c, e), w.target = q, w.relatedTarget = z, v = w);
                        z = v;
                        if (k && x) b: {
                            w = k;
                            u = x;
                            t = 0;
                            for(q = w; q; q = gf(q))t++;
                            q = 0;
                            for(v = u; v; v = gf(v))q++;
                            for(; 0 < t - q;)w = gf(w), t--;
                            for(; 0 < q - t;)u = gf(u), q--;
                            for(; t--;){
                                if (w === u || null !== u && w === u.alternate) break b;
                                w = gf(w);
                                u = gf(u);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && hf(g, h, k, w, !1);
                        null !== x && null !== z && hf(g, z, x, w, !0);
                    }
                }
            }
            a: {
                h = d ? ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var J = ve;
                else if (me(h)) {
                    if (we) J = Fe;
                    else {
                        J = De;
                        var K = Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (J = Ee);
                if (J && (J = J(a, d))) {
                    ne(g, J, c, e);
                    break a;
                }
                K && K(a, h, d);
                "focusout" === a && (K = h._wrapperState) && K.controlled && "number" === h.type && bb(h, "number", h.value);
            }
            K = d ? ue(d) : window;
            switch(a){
                case "focusin":
                    if (me(K) || "true" === K.contentEditable) Qe = K, Re = d, Se = null;
                    break;
                case "focusout":
                    Se = Re = Qe = null;
                    break;
                case "mousedown":
                    Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    Te = !1;
                    Ue(g, c, e);
                    break;
                case "selectionchange":
                    if (Pe) break;
                case "keydown":
                case "keyup":
                    Ue(g, c, e);
            }
            var Q;
            if (ae) b: {
                switch(a){
                    case "compositionstart":
                        var L = "onCompositionStart";
                        break b;
                    case "compositionend":
                        L = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        L = "onCompositionUpdate";
                        break b;
                }
                L = void 0;
            }
            else ie ? ge(a, c) && (L = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (L = "onCompositionStart");
            L && (de && "ko" !== c.locale && (ie || "onCompositionStart" !== L ? "onCompositionEnd" === L && ie && (Q = nd()) : (kd = e, ld = "value" in kd ? kd.value : kd.textContent, ie = !0)), K = oe(d, L), 0 < K.length && (L = new Ld(L, a, null, c, e), g.push({
                event: L,
                listeners: K
            }), Q ? L.data = Q : (Q = he(c), null !== Q && (L.data = Q))));
            if (Q = ce ? je(a, c) : ke(a, c)) d = oe(d, "onBeforeInput"), 0 < d.length && (e = new Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = Q);
        }
        se(g, b);
    });
}
function ef(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = Ob(a, c), null != f && d.unshift(ef(a, f, e)), f = Ob(a, b), null != f && d.push(ef(a, f, e)));
        a = a.return;
    }
    return d;
}
function gf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function hf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = Ob(c, f), null != k && g.unshift(ef(c, k, h))) : e || (k = Ob(c, f), null != k && g.push(ef(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
function jf() {}
var kf = null, lf = null;
function mf(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function nf(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var of = "function" === typeof setTimeout ? setTimeout : void 0, pf = "function" === typeof clearTimeout ? clearTimeout : void 0;
function qf(a) {
    1 === a.nodeType ? a.textContent = "" : 9 === a.nodeType && (a = a.body, null != a && (a.textContent = ""));
}
function rf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function sf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var tf = 0;
function uf(a) {
    return {
        $$typeof: Ga,
        toString: a,
        valueOf: a
    };
}
var vf = Math.random().toString(36).slice(2), wf = "__reactFiber$" + vf, xf = "__reactProps$" + vf, ff = "__reactContainer$" + vf, yf = "__reactEvents$" + vf;
function wc(a) {
    var b = a[wf];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[ff] || c[wf]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = sf(a); null !== a;){
                if (c = a[wf]) return c;
                a = sf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Cb(a) {
    a = a[wf] || a[ff];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(y(33));
}
function Db(a) {
    return a[xf] || null;
}
function $e(a) {
    var b = a[yf];
    void 0 === b && (b = a[yf] = new Set);
    return b;
}
var zf = [], Af = -1;
function Bf(a) {
    return {
        current: a
    };
}
function H(a) {
    0 > Af || (a.current = zf[Af], zf[Af] = null, Af--);
}
function I(a, b) {
    Af++;
    zf[Af] = a.current;
    a.current = b;
}
var Cf = {}, M = Bf(Cf), N = Bf(!1), Df = Cf;
function Ef(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Cf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function Ff(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Gf() {
    H(N);
    H(M);
}
function Hf(a, b, c) {
    if (M.current !== Cf) throw Error(y(168));
    I(M, b);
    I(N, c);
}
function If(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(y(108, Ra(b) || "Unknown", e));
    return $8coUR({}, c, d);
}
function Jf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Cf;
    Df = M.current;
    I(M, a);
    I(N, N.current);
    return !0;
}
function Kf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(y(169));
    c ? (a = If(a, b, Df), d.__reactInternalMemoizedMergedChildContext = a, H(N), H(M), I(M, a)) : H(N);
    I(N, c);
}
var Lf = null, Mf = null, Nf = $fO90s.unstable_runWithPriority, Of = $fO90s.unstable_scheduleCallback, Pf = $fO90s.unstable_cancelCallback, Qf = $fO90s.unstable_shouldYield, Rf = $fO90s.unstable_requestPaint, Sf = $fO90s.unstable_now, Tf = $fO90s.unstable_getCurrentPriorityLevel, Uf = $fO90s.unstable_ImmediatePriority, Vf = $fO90s.unstable_UserBlockingPriority, Wf = $fO90s.unstable_NormalPriority, Xf = $fO90s.unstable_LowPriority, Yf = $fO90s.unstable_IdlePriority, Zf = {}, $f = void 0 !== Rf ? Rf : function() {}, ag = null, bg = null, cg = !1, dg = Sf(), O = 1E4 > dg ? Sf : function() {
    return Sf() - dg;
};
function eg() {
    switch(Tf()){
        case Uf:
            return 99;
        case Vf:
            return 98;
        case Wf:
            return 97;
        case Xf:
            return 96;
        case Yf:
            return 95;
        default:
            throw Error(y(332));
    }
}
function fg(a) {
    switch(a){
        case 99:
            return Uf;
        case 98:
            return Vf;
        case 97:
            return Wf;
        case 96:
            return Xf;
        case 95:
            return Yf;
        default:
            throw Error(y(332));
    }
}
function gg(a, b) {
    a = fg(a);
    return Nf(a, b);
}
function hg(a, b, c) {
    a = fg(a);
    return Of(a, b, c);
}
function ig() {
    if (null !== bg) {
        var a = bg;
        bg = null;
        Pf(a);
    }
    jg();
}
function jg() {
    if (!cg && null !== ag) {
        cg = !0;
        var a = 0;
        try {
            var b = ag;
            gg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            ag = null;
        } catch (c) {
            throw null !== ag && (ag = ag.slice(a + 1)), Of(Uf, ig), c;
        } finally{
            cg = !1;
        }
    }
}
var kg = ra.ReactCurrentBatchConfig;
function lg(a, b) {
    if (a && a.defaultProps) {
        b = $8coUR({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var mg = Bf(null), ng = null, og = null, pg = null;
function qg() {
    pg = og = ng = null;
}
function rg(a) {
    var b = mg.current;
    H(mg);
    a.type._context._currentValue = b;
}
function sg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if ((a.childLanes & b) === b) {
            if (null === c || (c.childLanes & b) === b) break;
            else c.childLanes |= b;
        } else a.childLanes |= b, null !== c && (c.childLanes |= b);
        a = a.return;
    }
}
function tg(a, b) {
    ng = a;
    pg = og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && (ug = !0), a.firstContext = null);
}
function vg(a, b) {
    if (pg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) pg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === og) {
            if (null === ng) throw Error(y(308));
            og = b;
            ng.dependencies = {
                lanes: 0,
                firstContext: b,
                responders: null
            };
        } else og = og.next = b;
    }
    return a._currentValue;
}
var wg = !1;
function xg(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function yg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function zg(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function Ag(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function Bg(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function Cg(a, b, c, d) {
    var e = a.updateQueue;
    wg = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        if (null !== n) {
            n = n.updateQueue;
            var A = n.lastBaseUpdate;
            A !== g && (null === A ? n.firstBaseUpdate = l : A.next = l, n.lastBaseUpdate = k);
        }
    }
    if (null !== f) {
        A = e.baseState;
        g = 0;
        n = l = k = null;
        do {
            h = f.lane;
            var p = f.eventTime;
            if ((d & h) === h) {
                null !== n && (n = n.next = {
                    eventTime: p,
                    lane: 0,
                    tag: f.tag,
                    payload: f.payload,
                    callback: f.callback,
                    next: null
                });
                a: {
                    var C = a, x = f;
                    h = b;
                    p = c;
                    switch(x.tag){
                        case 1:
                            C = x.payload;
                            if ("function" === typeof C) {
                                A = C.call(p, A, h);
                                break a;
                            }
                            A = C;
                            break a;
                        case 3:
                            C.flags = C.flags & -4097 | 64;
                        case 0:
                            C = x.payload;
                            h = "function" === typeof C ? C.call(p, A, h) : C;
                            if (null === h || void 0 === h) break a;
                            A = $8coUR({}, A, h);
                            break a;
                        case 2:
                            wg = !0;
                    }
                }
                null !== f.callback && (a.flags |= 32, h = e.effects, null === h ? e.effects = [
                    f
                ] : h.push(f));
            } else p = {
                eventTime: p,
                lane: h,
                tag: f.tag,
                payload: f.payload,
                callback: f.callback,
                next: null
            }, null === n ? (l = n = p, k = A) : n = n.next = p, g |= h;
            f = f.next;
            if (null === f) {
                if (h = e.shared.pending, null === h) break;
                else f = h.next, h.next = null, e.lastBaseUpdate = h, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = A);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        Dg |= g;
        a.lanes = g;
        a.memoizedState = A;
    }
}
function Eg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error(y(191, e));
            e.call(d);
        }
    }
}
var Fg = (new $acw62.Component).refs;
function Gg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $8coUR({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var Kg = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? Zb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = Hg(), e = Ig(a), f = zg(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        Ag(a, f);
        Jg(a, e, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = Hg(), d = Ig(a), e = zg(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        Ag(a, e);
        Jg(a, d, c);
    }
};
function Lg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !Je(c, d) || !Je(e, f) : !0;
}
function Mg(a, b, c) {
    var d = !1, e = Cf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = vg(f) : (e = Ff(b) ? Df : M.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Ef(a, e) : Cf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Kg;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Ng(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Kg.enqueueReplaceState(b, b.state, null);
}
function Og(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Fg;
    xg(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = vg(f) : (f = Ff(b) ? Df : M.current, e.context = Ef(a, f));
    Cg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Gg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Kg.enqueueReplaceState(e, e.state, null), Cg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4);
}
var Pg = Array.isArray;
function Qg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(y(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(y(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Fg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(y(284));
        if (!c._owner) throw Error(y(290, a));
    }
    return a;
}
function Rg(a, b) {
    if ("textarea" !== a.type) throw Error(y(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b));
}
function Sg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.flags = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Tg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags = 2, c) : d;
        b.flags = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Ug(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Qg(a, b, c), d.return = a, d;
        d = Vg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Qg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Wg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Xg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function A(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Ug("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case sa:
                    return c = Vg(b.type, b.key, b.props, null, a.mode, c), c.ref = Qg(a, null, b), c.return = a, c;
                case ta:
                    return b = Wg(b, a.mode, c), b.return = a, b;
            }
            if (Pg(b) || La(b)) return b = Xg(b, a.mode, c, null), b.return = a, b;
            Rg(a, b);
        }
        return null;
    }
    function p(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case sa:
                    return c.key === e ? c.type === ua ? n(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case ta:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Pg(c) || La(c)) return null !== e ? null : n(a, b, c, d, null);
            Rg(a, c);
        }
        return null;
    }
    function C(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case sa:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ua ? n(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case ta:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Pg(d) || La(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            Rg(b, d);
        }
        return null;
    }
    function x(e, g, h, k) {
        for(var l = null, t = null, u = g, z = g = 0, q = null; null !== u && z < h.length; z++){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var n = p(e, u, h[z], k);
            if (null === n) {
                null === u && (u = q);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, z);
            null === t ? l = n : t.sibling = n;
            t = n;
            u = q;
        }
        if (z === h.length) return c(e, u), l;
        if (null === u) {
            for(; z < h.length; z++)u = A(e, h[z], k), null !== u && (g = f(u, g, z), null === t ? l = u : t.sibling = u, t = u);
            return l;
        }
        for(u = d(e, u); z < h.length; z++)q = C(u, e, z, h[z], k), null !== q && (a && null !== q.alternate && u.delete(null === q.key ? z : q.key), g = f(q, g, z), null === t ? l = q : t.sibling = q, t = q);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function w(e, g, h, k) {
        var l = La(h);
        if ("function" !== typeof l) throw Error(y(150));
        h = l.call(h);
        if (null == h) throw Error(y(151));
        for(var t = l = null, u = g, z = g = 0, q = null, n = h.next(); null !== u && !n.done; z++, n = h.next()){
            u.index > z ? (q = u, u = null) : q = u.sibling;
            var w = p(e, u, n.value, k);
            if (null === w) {
                null === u && (u = q);
                break;
            }
            a && u && null === w.alternate && b(e, u);
            g = f(w, g, z);
            null === t ? l = w : t.sibling = w;
            t = w;
            u = q;
        }
        if (n.done) return c(e, u), l;
        if (null === u) {
            for(; !n.done; z++, n = h.next())n = A(e, n.value, k), null !== n && (g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
            return l;
        }
        for(u = d(e, u); !n.done; z++, n = h.next())n = C(u, e, z, n.value, k), null !== n && (a && null !== n.alternate && u.delete(null === n.key ? z : n.key), g = f(n, g, z), null === t ? l = n : t.sibling = n, t = n);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ua && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case sa:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ua) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Qg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ua ? (d = Xg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Vg(f.type, f.key, f.props, null, a.mode, h), h.ref = Qg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case ta:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Wg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Ug(f, a.mode, h), d.return = a, a = d), g(a);
        if (Pg(f)) return x(a, d, f, h);
        if (La(f)) return w(a, d, f, h);
        l && Rg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 22:
            case 0:
            case 11:
            case 15:
                throw Error(y(152, Ra(a.type) || "Component"));
        }
        return c(a, d);
    };
}
var Yg = Sg(!0), Zg = Sg(!1), $g = {}, ah = Bf($g), bh = Bf($g), ch = Bf($g);
function dh(a) {
    if (a === $g) throw Error(y(174));
    return a;
}
function eh(a, b) {
    I(ch, b);
    I(bh, a);
    I(ah, $g);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : mb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = mb(b, a);
    }
    H(ah);
    I(ah, b);
}
function fh() {
    H(ah);
    H(bh);
    H(ch);
}
function gh(a) {
    dh(ch.current);
    var b = dh(ah.current);
    var c = mb(b, a.type);
    b !== c && (I(bh, a), I(ah, c));
}
function hh(a) {
    bh.current === a && (H(ah), H(bh));
}
var P = Bf(0);
function ih(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var jh = null, kh = null, lh = !1;
function mh(a, b) {
    var c = nh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.flags = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function oh(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function ph(a) {
    if (lh) {
        var b = kh;
        if (b) {
            var c = b;
            if (!oh(a, b)) {
                b = rf(c.nextSibling);
                if (!b || !oh(a, b)) {
                    a.flags = a.flags & -1025 | 2;
                    lh = !1;
                    jh = a;
                    return;
                }
                mh(jh, c);
            }
            jh = a;
            kh = rf(b.firstChild);
        } else a.flags = a.flags & -1025 | 2, lh = !1, jh = a;
    }
}
function qh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    jh = a;
}
function rh(a) {
    if (a !== jh) return !1;
    if (!lh) return qh(a), lh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !nf(b, a.memoizedProps)) for(b = kh; b;)mh(a, b), b = rf(b.nextSibling);
    qh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(y(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            kh = rf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            kh = null;
        }
    } else kh = jh ? rf(a.stateNode.nextSibling) : null;
    return !0;
}
function sh() {
    kh = jh = null;
    lh = !1;
}
var th = [];
function uh() {
    for(var a = 0; a < th.length; a++)th[a]._workInProgressVersionPrimary = null;
    th.length = 0;
}
var vh = ra.ReactCurrentDispatcher, wh = ra.ReactCurrentBatchConfig, xh = 0, R = null, S = null, T = null, yh = !1, zh = !1;
function Ah() {
    throw Error(y(321));
}
function Bh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!He(a[c], b[c])) return !1;
    return !0;
}
function Ch(a, b, c, d, e, f) {
    xh = f;
    R = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    vh.current = null === a || null === a.memoizedState ? Dh : Eh;
    a = c(d, e);
    if (zh) {
        f = 0;
        do {
            zh = !1;
            if (!(25 > f)) throw Error(y(301));
            f += 1;
            T = S = null;
            b.updateQueue = null;
            vh.current = Fh;
            a = c(d, e);
        }while (zh);
    }
    vh.current = Gh;
    b = null !== S && null !== S.next;
    xh = 0;
    T = S = R = null;
    yh = !1;
    if (b) throw Error(y(300));
    return a;
}
function Hh() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === T ? R.memoizedState = T = a : T = T.next = a;
    return T;
}
function Ih() {
    if (null === S) {
        var a = R.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = S.next;
    var b = null === T ? R.memoizedState : T.next;
    if (null !== b) T = b, S = a;
    else {
        if (null === a) throw Error(y(310));
        S = a;
        a = {
            memoizedState: S.memoizedState,
            baseState: S.baseState,
            baseQueue: S.baseQueue,
            queue: S.queue,
            next: null
        };
        null === T ? R.memoizedState = T = a : T = T.next = a;
    }
    return T;
}
function Jh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function Kh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = S, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.lane;
            if ((xh & l) === l) null !== h && (h = h.next = {
                lane: 0,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            else {
                var n = {
                    lane: l,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = n, f = d) : h = h.next = n;
                R.lanes |= l;
                Dg |= l;
            }
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        He(d, b.memoizedState) || (ug = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function Lh(a) {
    var b = Ih(), c = b.queue;
    if (null === c) throw Error(y(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        He(f, b.memoizedState) || (ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function Mh(a, b, c) {
    var d = b._getVersion;
    d = d(b._source);
    var e = b._workInProgressVersionPrimary;
    if (null !== e) a = e === d;
    else if (a = a.mutableReadLanes, a = (xh & a) === a) b._workInProgressVersionPrimary = d, th.push(b);
    if (a) return c(b._source);
    th.push(b);
    throw Error(y(350));
}
function Nh(a, b, c, d) {
    var e = U;
    if (null === e) throw Error(y(349));
    var f = b._getVersion, g = f(b._source), h = vh.current, k = h.useState(function() {
        return Mh(e, b, c);
    }), l = k[1], n = k[0];
    k = T;
    var A = a.memoizedState, p = A.refs, C = p.getSnapshot, x = A.source;
    A = A.subscribe;
    var w = R;
    a.memoizedState = {
        refs: p,
        source: b,
        subscribe: d
    };
    h.useEffect(function() {
        p.getSnapshot = c;
        p.setSnapshot = l;
        var a = f(b._source);
        if (!He(g, a)) {
            a = c(b._source);
            He(n, a) || (l(a), a = Ig(w), e.mutableReadLanes |= a & e.pendingLanes);
            a = e.mutableReadLanes;
            e.entangledLanes |= a;
            for(var d = e.entanglements, h = a; 0 < h;){
                var k = 31 - Vc(h), v = 1 << k;
                d[k] |= a;
                h &= ~v;
            }
        }
    }, [
        c,
        b,
        d
    ]);
    h.useEffect(function() {
        return d(b._source, function() {
            var a = p.getSnapshot, c = p.setSnapshot;
            try {
                c(a(b._source));
                var d = Ig(w);
                e.mutableReadLanes |= d & e.pendingLanes;
            } catch (q) {
                c(function() {
                    throw q;
                });
            }
        });
    }, [
        b,
        d
    ]);
    He(C, c) && He(x, b) && He(A, d) || (a = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: n
    }, a.dispatch = l = Oh.bind(null, R, a), k.queue = a, k.baseQueue = null, n = Mh(e, b, c), k.memoizedState = k.baseState = n);
    return n;
}
function Ph(a, b, c) {
    var d = Ih();
    return Nh(d, a, b, c);
}
function Qh(a) {
    var b = Hh();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: Jh,
        lastRenderedState: a
    };
    a = a.dispatch = Oh.bind(null, R, a);
    return [
        b.memoizedState,
        a
    ];
}
function Rh(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = R.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, R.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Sh(a) {
    var b = Hh();
    a = {
        current: a
    };
    return b.memoizedState = a;
}
function Th() {
    return Ih().memoizedState;
}
function Uh(a, b, c, d) {
    var e = Hh();
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, void 0, void 0 === d ? null : d);
}
function Vh(a, b, c, d) {
    var e = Ih();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== S) {
        var g = S.memoizedState;
        f = g.destroy;
        if (null !== d && Bh(d, g.deps)) {
            Rh(b, c, f, d);
            return;
        }
    }
    R.flags |= a;
    e.memoizedState = Rh(1 | b, c, f, d);
}
function Wh(a, b) {
    return Uh(516, 4, a, b);
}
function Xh(a, b) {
    return Vh(516, 4, a, b);
}
function Yh(a, b) {
    return Vh(4, 2, a, b);
}
function Zh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $h(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Vh(4, 2, Zh.bind(null, b, a), c);
}
function ai() {}
function bi(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function ci(a, b) {
    var c = Ih();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && Bh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function di(a, b) {
    var c = eg();
    gg(98 > c ? 98 : c, function() {
        a(!0);
    });
    gg(97 < c ? 97 : c, function() {
        var c = wh.transition;
        wh.transition = 1;
        try {
            a(!1), b();
        } finally{
            wh.transition = c;
        }
    });
}
function Oh(a, b, c) {
    var d = Hg(), e = Ig(a), f = {
        lane: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    }, g = b.pending;
    null === g ? f.next = f : (f.next = g.next, g.next = f);
    b.pending = f;
    g = a.alternate;
    if (a === R || null !== g && g === R) zh = yh = !0;
    else {
        if (0 === a.lanes && (null === g || 0 === g.lanes) && (g = b.lastRenderedReducer, null !== g)) try {
            var h = b.lastRenderedState, k = g(h, c);
            f.eagerReducer = g;
            f.eagerState = k;
            if (He(k, h)) return;
        } catch (l) {} finally{}
        Jg(a, e, d);
    }
}
var Gh = {
    readContext: vg,
    useCallback: Ah,
    useContext: Ah,
    useEffect: Ah,
    useImperativeHandle: Ah,
    useLayoutEffect: Ah,
    useMemo: Ah,
    useReducer: Ah,
    useRef: Ah,
    useState: Ah,
    useDebugValue: Ah,
    useDeferredValue: Ah,
    useTransition: Ah,
    useMutableSource: Ah,
    useOpaqueIdentifier: Ah,
    unstable_isNewReconciler: !1
}, Dh = {
    readContext: vg,
    useCallback: function(a, b) {
        Hh().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: vg,
    useEffect: Wh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Uh(4, 2, Zh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Uh(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = Hh();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = Hh();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = Oh.bind(null, R, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: Sh,
    useState: Qh,
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Qh(a), c = b[0], d = b[1];
        Wh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Qh(!1), b = a[0];
        a = di.bind(null, a[1]);
        Sh(a);
        return [
            a,
            b
        ];
    },
    useMutableSource: function(a, b, c) {
        var d = Hh();
        d.memoizedState = {
            refs: {
                getSnapshot: b,
                setSnapshot: null
            },
            source: a,
            subscribe: c
        };
        return Nh(d, a, b, c);
    },
    useOpaqueIdentifier: function() {
        if (lh) {
            var a = !1, b = uf(function() {
                a || (a = !0, c("r:" + (tf++).toString(36)));
                throw Error(y(355));
            }), c = Qh(b)[1];
            0 === (R.mode & 2) && (R.flags |= 516, Rh(5, function() {
                c("r:" + (tf++).toString(36));
            }, void 0, null));
            return b;
        }
        b = "r:" + (tf++).toString(36);
        Qh(b);
        return b;
    },
    unstable_isNewReconciler: !1
}, Eh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Kh,
    useRef: Th,
    useState: function() {
        return Kh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Kh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Kh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Kh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, Fh = {
    readContext: vg,
    useCallback: bi,
    useContext: vg,
    useEffect: Xh,
    useImperativeHandle: $h,
    useLayoutEffect: Yh,
    useMemo: ci,
    useReducer: Lh,
    useRef: Th,
    useState: function() {
        return Lh(Jh);
    },
    useDebugValue: ai,
    useDeferredValue: function(a) {
        var b = Lh(Jh), c = b[0], d = b[1];
        Xh(function() {
            var b = wh.transition;
            wh.transition = 1;
            try {
                d(a);
            } finally{
                wh.transition = b;
            }
        }, [
            a
        ]);
        return c;
    },
    useTransition: function() {
        var a = Lh(Jh)[0];
        return [
            Th().current,
            a
        ];
    },
    useMutableSource: Ph,
    useOpaqueIdentifier: function() {
        return Lh(Jh)[0];
    },
    unstable_isNewReconciler: !1
}, ei = ra.ReactCurrentOwner, ug = !1;
function fi(a, b, c, d) {
    b.child = null === a ? Zg(b, null, c, d) : Yg(b, a.child, c, d);
}
function gi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    tg(b, e);
    d = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, d, e);
    return b.child;
}
function ii(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !ji(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ki(a, b, g, d, e, f);
        a = Vg(c.type, null, d, b, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (0 === (e & f) && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : Je, c(e, d) && a.ref === b.ref)) return hi(a, b, f);
    b.flags |= 1;
    a = Tg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ki(a, b, c, d, e, f) {
    if (null !== a && Je(a.memoizedProps, d) && a.ref === b.ref) {
        if (ug = !1, 0 !== (f & e)) 0 !== (a.flags & 16384) && (ug = !0);
        else return b.lanes = a.lanes, hi(a, b, f);
    }
    return li(a, b, c, d, f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode || "unstable-defer-without-hiding" === d.mode) {
        if (0 === (b.mode & 4)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, c);
        else if (0 !== (c & 1073741824)) b.memoizedState = {
            baseLanes: 0
        }, ni(b, null !== f ? f.baseLanes : c);
        else return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
            baseLanes: a
        }, ni(b, a), null;
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, ni(b, d);
    fi(a, b, e, c);
    return b.child;
}
function oi(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 128;
}
function li(a, b, c, d, e) {
    var f = Ff(c) ? Df : M.current;
    f = Ef(b, f);
    tg(b, e);
    c = Ch(a, b, c, d, f, e);
    if (null !== a && !ug) return b.updateQueue = a.updateQueue, b.flags &= -517, a.lanes &= ~e, hi(a, b, e);
    b.flags |= 1;
    fi(a, b, c, e);
    return b.child;
}
function pi(a, b, c, d, e) {
    if (Ff(c)) {
        var f = !0;
        Jf(b);
    } else f = !1;
    tg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), Mg(b, c, d), Og(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = vg(l) : (l = Ff(c) ? Df : M.current, l = Ef(b, l));
        var n = c.getDerivedStateFromProps, A = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        A || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Ng(b, g, d, l);
        wg = !1;
        var p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        k = b.memoizedState;
        h !== d || p !== k || N.current || wg ? ("function" === typeof n && (Gg(b, c, n, d), k = b.memoizedState), (h = wg || Lg(b, c, h, d, p, k, l)) ? (A || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4)) : ("function" === typeof g.componentDidMount && (b.flags |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4), d = !1);
    } else {
        g = b.stateNode;
        yg(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : lg(b.type, h);
        g.props = l;
        A = b.pendingProps;
        p = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = vg(k) : (k = Ff(c) ? Df : M.current, k = Ef(b, k));
        var C = c.getDerivedStateFromProps;
        (n = "function" === typeof C || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== A || p !== k) && Ng(b, g, d, k);
        wg = !1;
        p = b.memoizedState;
        g.state = p;
        Cg(b, d, g, e);
        var x = b.memoizedState;
        h !== A || p !== x || N.current || wg ? ("function" === typeof C && (Gg(b, c, C, d), x = b.memoizedState), (l = wg || Lg(b, c, l, d, p, x, k)) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && p === a.memoizedState || (b.flags |= 256), d = !1);
    }
    return qi(a, b, c, d, f, e);
}
function qi(a, b, c, d, e, f) {
    oi(a, b);
    var g = 0 !== (b.flags & 64);
    if (!d && !g) return e && Kf(b, c, !1), hi(a, b, f);
    d = b.stateNode;
    ei.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = Yg(b, a.child, null, f), b.child = Yg(b, null, h, f)) : fi(a, b, h, f);
    b.memoizedState = d.state;
    e && Kf(b, c, !0);
    return b.child;
}
function ri(a) {
    var b = a.stateNode;
    b.pendingContext ? Hf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Hf(a, b.context, !1);
    eh(a, b.containerInfo);
}
var si = {
    dehydrated: null,
    retryLane: 0
};
function ti(a, b, c) {
    var d = b.pendingProps, e = P.current, f = !1, g;
    (g = 0 !== (b.flags & 64)) || (g = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    g ? (f = !0, b.flags &= -65) : null !== a && null === a.memoizedState || void 0 === d.fallback || !0 === d.unstable_avoidThisFallback || (e |= 1);
    I(P, e & 1);
    if (null === a) {
        void 0 !== d.fallback && ph(b);
        a = d.children;
        e = d.fallback;
        if (f) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, a;
        if ("number" === typeof d.unstable_expectedLoadTime) return a = ui(b, a, e, c), b.child.memoizedState = {
            baseLanes: c
        }, b.memoizedState = si, b.lanes = 33554432, a;
        c = vi({
            mode: "visible",
            children: a
        }, b.mode, c, null);
        c.return = b;
        return b.child = c;
    }
    if (null !== a.memoizedState) {
        if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
            baseLanes: c
        } : {
            baseLanes: e.baseLanes | c
        }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
        c = xi(a, b, d.children, c);
        b.memoizedState = null;
        return c;
    }
    if (f) return d = wi(a, b, d.children, d.fallback, c), f = b.child, e = a.child.memoizedState, f.memoizedState = null === e ? {
        baseLanes: c
    } : {
        baseLanes: e.baseLanes | c
    }, f.childLanes = a.childLanes & ~c, b.memoizedState = si, d;
    c = xi(a, b, d.children, c);
    b.memoizedState = null;
    return c;
}
function ui(a, b, c, d) {
    var e = a.mode, f = a.child;
    b = {
        mode: "hidden",
        children: b
    };
    0 === (e & 2) && null !== f ? (f.childLanes = 0, f.pendingProps = b) : f = vi(b, e, 0, null);
    c = Xg(c, e, d, null);
    f.return = a;
    c.return = a;
    f.sibling = c;
    a.child = f;
    return c;
}
function xi(a, b, c, d) {
    var e = a.child;
    a = e.sibling;
    c = Tg(e, {
        mode: "visible",
        children: c
    });
    0 === (b.mode & 2) && (c.lanes = d);
    c.return = b;
    c.sibling = null;
    null !== a && (a.nextEffect = null, a.flags = 8, b.firstEffect = b.lastEffect = a);
    return b.child = c;
}
function wi(a, b, c, d, e) {
    var f = b.mode, g = a.child;
    a = g.sibling;
    var h = {
        mode: "hidden",
        children: c
    };
    0 === (f & 2) && b.child !== g ? (c = b.child, c.childLanes = 0, c.pendingProps = h, g = c.lastEffect, null !== g ? (b.firstEffect = c.firstEffect, b.lastEffect = g, g.nextEffect = null) : b.firstEffect = b.lastEffect = null) : c = Tg(g, h);
    null !== a ? d = Tg(a, d) : (d = Xg(d, f, e, null), d.flags |= 2);
    d.return = b;
    c.return = b;
    c.sibling = d;
    b.child = c;
    return d;
}
function yi(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    sg(a.return, b);
}
function zi(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailMode = e, g.lastEffect = f);
}
function Ai(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    fi(a, b, d.children, c);
    d = P.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 64;
    else {
        if (null !== a && 0 !== (a.flags & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && yi(a, c);
            else if (19 === a.tag) yi(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(P, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === ih(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            zi(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === ih(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            zi(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            zi(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function hi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    Dg |= b.lanes;
    if (0 !== (c & b.childLanes)) {
        if (null !== a && b.child !== a.child) throw Error(y(153));
        if (null !== b.child) {
            a = b.child;
            c = Tg(a, a.pendingProps);
            b.child = c;
            for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Tg(a, a.pendingProps), c.return = b;
            c.sibling = null;
        }
        return b.child;
    }
    return null;
}
var Bi, Ci, Di, Ei;
Bi = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
Ci = function() {};
Di = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        dh(ah.current);
        var f = null;
        switch(c){
            case "input":
                e = Ya(a, e);
                d = Ya(a, d);
                f = [];
                break;
            case "option":
                e = eb(a, e);
                d = eb(a, d);
                f = [];
                break;
            case "select":
                e = $8coUR({}, e, {
                    value: void 0
                });
                d = $8coUR({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = gb(a, e);
                d = gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = jf);
        }
        vb(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && (ca.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && (ca.hasOwnProperty(l) ? (null != k && "onScroll" === l && G("scroll", a), f || h === k || (f = [])) : "object" === typeof k && null !== k && k.$$typeof === Ga ? k.toString() : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
Ei = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function Fi(a, b) {
    if (!lh) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function Gi(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return Ff(b.type) && Gf(), null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            d = b.stateNode;
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) rh(b) ? b.flags |= 4 : d.hydrate || (b.flags |= 256);
            Ci(b);
            return null;
        case 5:
            hh(b);
            var e = dh(ch.current);
            c = b.type;
            if (null !== a && null != b.stateNode) Di(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(y(166));
                    return null;
                }
                a = dh(ah.current);
                if (rh(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[wf] = b;
                    d[xf] = f;
                    switch(c){
                        case "dialog":
                            G("cancel", d);
                            G("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < Xe.length; a++)G(Xe[a], d);
                            break;
                        case "source":
                            G("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", d);
                            G("load", d);
                            break;
                        case "details":
                            G("toggle", d);
                            break;
                        case "input":
                            Za(d, f);
                            G("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            G("invalid", d);
                            break;
                        case "textarea":
                            hb(d, f), G("invalid", d);
                    }
                    vb(c, f);
                    a = null;
                    for(var g in f)f.hasOwnProperty(g) && (e = f[g], "children" === g ? "string" === typeof e ? d.textContent !== e && (a = [
                        "children",
                        e
                    ]) : "number" === typeof e && d.textContent !== "" + e && (a = [
                        "children",
                        "" + e
                    ]) : ca.hasOwnProperty(g) && null != e && "onScroll" === g && G("scroll", d));
                    switch(c){
                        case "input":
                            Va(d);
                            cb(d, f, !0);
                            break;
                        case "textarea":
                            Va(d);
                            jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = jf);
                    }
                    d = a;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    a === kb.html && (a = lb(c));
                    a === kb.html ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[wf] = b;
                    a[xf] = d;
                    Bi(a, b, !1, !1);
                    b.stateNode = a;
                    g = wb(c, d);
                    switch(c){
                        case "dialog":
                            G("cancel", a);
                            G("close", a);
                            e = d;
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            G("load", a);
                            e = d;
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < Xe.length; e++)G(Xe[e], a);
                            e = d;
                            break;
                        case "source":
                            G("error", a);
                            e = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            G("error", a);
                            G("load", a);
                            e = d;
                            break;
                        case "details":
                            G("toggle", a);
                            e = d;
                            break;
                        case "input":
                            Za(a, d);
                            e = Ya(a, d);
                            G("invalid", a);
                            break;
                        case "option":
                            e = eb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            e = $8coUR({}, d, {
                                value: void 0
                            });
                            G("invalid", a);
                            break;
                        case "textarea":
                            hb(a, d);
                            e = gb(a, d);
                            G("invalid", a);
                            break;
                        default:
                            e = d;
                    }
                    vb(c, e);
                    var h = e;
                    for(f in h)if (h.hasOwnProperty(f)) {
                        var k = h[f];
                        "style" === f ? tb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && ob(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && pb(a, k) : "number" === typeof k && pb(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (ca.hasOwnProperty(f) ? null != k && "onScroll" === f && G("scroll", a) : null != k && qa(a, f, k, g));
                    }
                    switch(c){
                        case "input":
                            Va(a);
                            cb(a, d, !1);
                            break;
                        case "textarea":
                            Va(a);
                            jb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + Sa(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            f = d.value;
                            null != f ? fb(a, !!d.multiple, f, !1) : null != d.defaultValue && fb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof e.onClick && (a.onclick = jf);
                    }
                    mf(c, d) && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) Ei(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(y(166));
                c = dh(ch.current);
                dh(ah.current);
                rh(b) ? (d = b.stateNode, c = b.memoizedProps, d[wf] = b, d.nodeValue !== c && (b.flags |= 4)) : (d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[wf] = b, b.stateNode = d);
            }
            return null;
        case 13:
            H(P);
            d = b.memoizedState;
            if (0 !== (b.flags & 64)) return b.lanes = c, b;
            d = null !== d;
            c = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && rh(b) : c = null !== a.memoizedState;
            if (d && !c && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (P.current & 1)) 0 === V && (V = 3);
                else {
                    if (0 === V || 3 === V) V = 4;
                    null === U || 0 === (Dg & 134217727) && 0 === (Hi & 134217727) || Ii(U, W);
                }
            }
            if (d || c) b.flags |= 4;
            return null;
        case 4:
            return fh(), Ci(b), null === a && cf(b.stateNode.containerInfo), null;
        case 10:
            return rg(b), null;
        case 17:
            return Ff(b.type) && Gf(), null;
        case 19:
            H(P);
            d = b.memoizedState;
            if (null === d) return null;
            f = 0 !== (b.flags & 64);
            g = d.rendering;
            if (null === g) {
                if (f) Fi(d, !1);
                else {
                    if (0 !== V || null !== a && 0 !== (a.flags & 64)) for(a = b.child; null !== a;){
                        g = ih(a);
                        if (null !== g) {
                            b.flags |= 64;
                            Fi(d, !1);
                            f = g.updateQueue;
                            null !== f && (b.updateQueue = f, b.flags |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 2, f.nextEffect = null, f.firstEffect = null, f.lastEffect = null, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            I(P, P.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== d.tail && O() > Ji && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
            } else {
                if (!f) {
                    if (a = ih(g), null !== a) {
                        if (b.flags |= 64, f = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), Fi(d, !0), null === d.tail && "hidden" === d.tailMode && !g.alternate && !lh) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * O() - d.renderingStartTime > Ji && 1073741824 !== c && (b.flags |= 64, f = !0, Fi(d, !1), b.lanes = 33554432);
                }
                d.isBackwards ? (g.sibling = b.child, b.child = g) : (c = d.last, null !== c ? c.sibling = g : b.child = g, d.last = g);
            }
            return null !== d.tail ? (c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = O(), c.sibling = null, b = P.current, I(P, f ? b & 1 | 2 : b & 1), c) : null;
        case 23:
        case 24:
            return Ki(), null !== a && null !== a.memoizedState !== (null !== b.memoizedState) && "unstable-defer-without-hiding" !== d.mode && (b.flags |= 4), null;
    }
    throw Error(y(156, b.tag));
}
function Li(a) {
    switch(a.tag){
        case 1:
            Ff(a.type) && Gf();
            var b = a.flags;
            return b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 3:
            fh();
            H(N);
            H(M);
            uh();
            b = a.flags;
            if (0 !== (b & 64)) throw Error(y(285));
            a.flags = b & -4097 | 64;
            return a;
        case 5:
            return hh(a), null;
        case 13:
            return H(P), b = a.flags, b & 4096 ? (a.flags = b & -4097 | 64, a) : null;
        case 19:
            return H(P), null;
        case 4:
            return fh(), null;
        case 10:
            return rg(a), null;
        case 23:
        case 24:
            return Ki(), null;
        default:
            return null;
    }
}
function Mi(a, b) {
    try {
        var c = "", d = b;
        do c += Qa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e
    };
}
function Ni(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var Oi = "function" === typeof WeakMap ? WeakMap : Map;
function Pi(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Qi || (Qi = !0, Ri = d);
        Ni(a, b);
    };
    return c;
}
function Si(a, b, c) {
    c = zg(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ni(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === Ti ? Ti = new Set([
            this
        ]) : Ti.add(this), Ni(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var Ui = "function" === typeof WeakSet ? WeakSet : Set;
function Vi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Wi(a, c);
        }
        else b.current = null;
    }
}
function Xi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.flags & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : lg(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
            b.flags & 256 && qf(b.stateNode.containerInfo);
            return;
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(y(163));
}
function Yi(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    if (3 === (a.tag & 3)) {
                        var d = a.create;
                        a.destroy = d();
                    }
                    a = a.next;
                }while (a !== b);
            }
            b = c.updateQueue;
            b = null !== b ? b.lastEffect : null;
            if (null !== b) {
                a = b = b.next;
                do {
                    var e = a;
                    d = e.next;
                    e = e.tag;
                    0 !== (e & 4) && 0 !== (e & 1) && (Zi(c, a), $i(c, a));
                    a = d;
                }while (a !== b);
            }
            return;
        case 1:
            a = c.stateNode;
            c.flags & 4 && (null === b ? a.componentDidMount() : (d = c.elementType === c.type ? b.memoizedProps : lg(c.type, b.memoizedProps), a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate)));
            b = c.updateQueue;
            null !== b && Eg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Eg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.flags & 4 && mf(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Cc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
        case 23:
        case 24:
            return;
    }
    throw Error(y(163));
}
function aj(a, b) {
    for(var c = a;;){
        if (5 === c.tag) {
            var d = c.stateNode;
            if (b) d = d.style, "function" === typeof d.setProperty ? d.setProperty("display", "none", "important") : d.display = "none";
            else {
                d = c.stateNode;
                var e = c.memoizedProps.style;
                e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null;
                d.style.display = sb("display", e);
            }
        } else if (6 === c.tag) c.stateNode.nodeValue = b ? "" : c.memoizedProps;
        else if ((23 !== c.tag && 24 !== c.tag || null === c.memoizedState || c === a) && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === a) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === a) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function bj(a, b) {
    if (Mf && "function" === typeof Mf.onCommitFiberUnmount) try {
        Mf.onCommitFiberUnmount(Lf, b);
    } catch (f) {}
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var c = a = a.next;
                do {
                    var d = c, e = d.destroy;
                    d = d.tag;
                    if (void 0 !== e) {
                        if (0 !== (d & 4)) Zi(b, c);
                        else {
                            d = b;
                            try {
                                e();
                            } catch (f) {
                                Wi(d, f);
                            }
                        }
                    }
                    c = c.next;
                }while (c !== a);
            }
            break;
        case 1:
            Vi(b);
            a = b.stateNode;
            if ("function" === typeof a.componentWillUnmount) try {
                a.props = b.memoizedProps, a.state = b.memoizedState, a.componentWillUnmount();
            } catch (f) {
                Wi(b, f);
            }
            break;
        case 5:
            Vi(b);
            break;
        case 4:
            cj(a, b);
    }
}
function dj(a) {
    a.alternate = null;
    a.child = null;
    a.dependencies = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.return = null;
    a.updateQueue = null;
}
function ej(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function fj(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (ej(b)) break a;
            b = b.return;
        }
        throw Error(y(160));
    }
    var c = b;
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(y(161));
    }
    c.flags & 16 && (pb(b, ""), c.flags &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || ej(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.flags & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.flags & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? gj(a, c, b) : hj(a, c, b);
}
function gj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = jf));
    else if (4 !== d && (a = a.child, null !== a)) for(gj(a, b, c), a = a.sibling; null !== a;)gj(a, b, c), a = a.sibling;
}
function hj(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(hj(a, b, c), a = a.sibling; null !== a;)hj(a, b, c), a = a.sibling;
}
function cj(a, b) {
    for(var c = b, d = !1, e, f;;){
        if (!d) {
            d = c.return;
            a: for(;;){
                if (null === d) throw Error(y(160));
                e = d.stateNode;
                switch(d.tag){
                    case 5:
                        f = !1;
                        break a;
                    case 3:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                    case 4:
                        e = e.containerInfo;
                        f = !0;
                        break a;
                }
                d = d.return;
            }
            d = !0;
        }
        if (5 === c.tag || 6 === c.tag) {
            a: for(var g = a, h = c, k = h;;)if (bj(g, k), null !== k.child && 4 !== k.tag) k.child.return = k, k = k.child;
            else {
                if (k === h) break a;
                for(; null === k.sibling;){
                    if (null === k.return || k.return === h) break a;
                    k = k.return;
                }
                k.sibling.return = k.return;
                k = k.sibling;
            }
            f ? (g = e, h = c.stateNode, 8 === g.nodeType ? g.parentNode.removeChild(h) : g.removeChild(h)) : e.removeChild(c.stateNode);
        } else if (4 === c.tag) {
            if (null !== c.child) {
                e = c.stateNode.containerInfo;
                f = !0;
                c.child.return = c;
                c = c.child;
                continue;
            }
        } else if (bj(a, c), null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
            4 === c.tag && (d = !1);
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
}
function ij(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            var c = b.updateQueue;
            c = null !== c ? c.lastEffect : null;
            if (null !== c) {
                var d = c = c.next;
                do 3 === (d.tag & 3) && (a = d.destroy, d.destroy = void 0, void 0 !== a && a()), d = d.next;
                while (d !== c);
            }
            return;
        case 1:
            return;
        case 5:
            c = b.stateNode;
            if (null != c) {
                d = b.memoizedProps;
                var e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[xf] = d;
                    "input" === a && "radio" === d.type && null != d.name && $a(c, d);
                    wb(a, e);
                    b = wb(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? tb(c, h) : "dangerouslySetInnerHTML" === g ? ob(c, h) : "children" === g ? pb(c, h) : qa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            ab(c, d);
                            break;
                        case "textarea":
                            ib(c, d);
                            break;
                        case "select":
                            a = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, f = d.value, null != f ? fb(c, !!d.multiple, f, !1) : a !== !!d.multiple && (null != d.defaultValue ? fb(c, !!d.multiple, d.defaultValue, !0) : fb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(y(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            c = b.stateNode;
            c.hydrate && (c.hydrate = !1, Cc(c.containerInfo));
            return;
        case 12:
            return;
        case 13:
            null !== b.memoizedState && (jj = O(), aj(b.child, !0));
            kj(b);
            return;
        case 19:
            kj(b);
            return;
        case 17:
            return;
        case 23:
        case 24:
            aj(b, null !== b.memoizedState);
            return;
    }
    throw Error(y(163));
}
function kj(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Ui);
        b.forEach(function(b) {
            var d = lj.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function mj(a, b) {
    return null !== a && (a = a.memoizedState, null === a || null !== a.dehydrated) ? (b = b.memoizedState, null !== b && null === b.dehydrated) : !1;
}
var nj = Math.ceil, oj = ra.ReactCurrentDispatcher, pj = ra.ReactCurrentOwner, X = 0, U = null, Y = null, W = 0, qj = 0, rj = Bf(0), V = 0, sj = null, tj = 0, Dg = 0, Hi = 0, uj = 0, vj = null, jj = 0, Ji = Infinity;
function wj() {
    Ji = O() + 500;
}
var Z = null, Qi = !1, Ri = null, Ti = null, xj = !1, yj = null, zj = 90, Aj = [], Bj = [], Cj = null, Dj = 0, Ej = null, Fj = -1, Gj = 0, Hj = 0, Ij = null, Jj = !1;
function Hg() {
    return 0 !== (X & 48) ? O() : -1 !== Fj ? Fj : Fj = O();
}
function Ig(a) {
    a = a.mode;
    if (0 === (a & 2)) return 1;
    if (0 === (a & 4)) return 99 === eg() ? 1 : 2;
    0 === Gj && (Gj = tj);
    if (0 !== kg.transition) {
        0 !== Hj && (Hj = null !== vj ? vj.pendingLanes : 0);
        a = Gj;
        var b = 4186112 & ~Hj;
        b &= -b;
        0 === b && (a = 4186112 & ~a, b = a & -a, 0 === b && (b = 8192));
        return b;
    }
    a = eg();
    0 !== (X & 4) && 98 === a ? a = Xc(12, Gj) : (a = Sc(a), a = Xc(a, Gj));
    return a;
}
function Jg(a, b, c) {
    if (50 < Dj) throw Dj = 0, Ej = null, Error(y(185));
    a = Kj(a, b);
    if (null === a) return null;
    $c(a, b, c);
    a === U && (Hi |= b, 4 === V && Ii(a, W));
    var d = eg();
    1 === b ? 0 !== (X & 8) && 0 === (X & 48) ? Lj(a) : (Mj(a, c), 0 === X && (wj(), ig())) : (0 === (X & 4) || 98 !== d && 99 !== d || (null === Cj ? Cj = new Set([
        a
    ]) : Cj.add(a)), Mj(a, c));
    vj = a;
}
function Kj(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
function Mj(a, b) {
    for(var c = a.callbackNode, d = a.suspendedLanes, e = a.pingedLanes, f = a.expirationTimes, g = a.pendingLanes; 0 < g;){
        var h = 31 - Vc(g), k = 1 << h, l = f[h];
        if (-1 === l) {
            if (0 === (k & d) || 0 !== (k & e)) {
                l = b;
                Rc(k);
                var n = F;
                f[h] = 10 <= n ? l + 250 : 6 <= n ? l + 5E3 : -1;
            }
        } else l <= b && (a.expiredLanes |= k);
        g &= ~k;
    }
    d = Uc(a, a === U ? W : 0);
    b = F;
    if (0 === d) null !== c && (c !== Zf && Pf(c), a.callbackNode = null, a.callbackPriority = 0);
    else {
        if (null !== c) {
            if (a.callbackPriority === b) return;
            c !== Zf && Pf(c);
        }
        15 === b ? (c = Lj.bind(null, a), null === ag ? (ag = [
            c
        ], bg = Of(Uf, jg)) : ag.push(c), c = Zf) : 14 === b ? c = hg(99, Lj.bind(null, a)) : (c = Tc(b), c = hg(c, Nj.bind(null, a)));
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function Nj(a) {
    Fj = -1;
    Hj = Gj = 0;
    if (0 !== (X & 48)) throw Error(y(327));
    var b = a.callbackNode;
    if (Oj() && a.callbackNode !== b) return null;
    var c = Uc(a, a === U ? W : 0);
    if (0 === c) return null;
    var d = c;
    var e = X;
    X |= 16;
    var f = Pj();
    if (U !== a || W !== d) wj(), Qj(a, d);
    for(;;)try {
        Rj();
        break;
    } catch (h) {
        Sj(a, h);
    }
    qg();
    oj.current = f;
    X = e;
    null !== Y ? d = 0 : (U = null, W = 0, d = V);
    if (0 !== (tj & Hi)) Qj(a, 0);
    else if (0 !== d) {
        2 === d && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), c = Wc(a), 0 !== c && (d = Tj(a, c)));
        if (1 === d) throw b = sj, Qj(a, 0), Ii(a, c), Mj(a, O()), b;
        a.finishedWork = a.current.alternate;
        a.finishedLanes = c;
        switch(d){
            case 0:
            case 1:
                throw Error(y(345));
            case 2:
                Uj(a);
                break;
            case 3:
                Ii(a, c);
                if ((c & 62914560) === c && (d = jj + 500 - O(), 10 < d)) {
                    if (0 !== Uc(a, 0)) break;
                    e = a.suspendedLanes;
                    if ((e & c) !== c) {
                        Hg();
                        a.pingedLanes |= a.suspendedLanes & e;
                        break;
                    }
                    a.timeoutHandle = of(Uj.bind(null, a), d);
                    break;
                }
                Uj(a);
                break;
            case 4:
                Ii(a, c);
                if ((c & 4186112) === c) break;
                d = a.eventTimes;
                for(e = -1; 0 < c;){
                    var g = 31 - Vc(c);
                    f = 1 << g;
                    g = d[g];
                    g > e && (e = g);
                    c &= ~f;
                }
                c = e;
                c = O() - c;
                c = (120 > c ? 120 : 480 > c ? 480 : 1080 > c ? 1080 : 1920 > c ? 1920 : 3E3 > c ? 3E3 : 4320 > c ? 4320 : 1960 * nj(c / 1960)) - c;
                if (10 < c) {
                    a.timeoutHandle = of(Uj.bind(null, a), c);
                    break;
                }
                Uj(a);
                break;
            case 5:
                Uj(a);
                break;
            default:
                throw Error(y(329));
        }
    }
    Mj(a, O());
    return a.callbackNode === b ? Nj.bind(null, a) : null;
}
function Ii(a, b) {
    b &= ~uj;
    b &= ~Hi;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - Vc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function Lj(a) {
    if (0 !== (X & 48)) throw Error(y(327));
    Oj();
    if (a === U && 0 !== (a.expiredLanes & W)) {
        var b = W;
        var c = Tj(a, b);
        0 !== (tj & Hi) && (b = Uc(a, b), c = Tj(a, b));
    } else b = Uc(a, 0), c = Tj(a, b);
    0 !== a.tag && 2 === c && (X |= 64, a.hydrate && (a.hydrate = !1, qf(a.containerInfo)), b = Wc(a), 0 !== b && (c = Tj(a, b)));
    if (1 === c) throw c = sj, Qj(a, 0), Ii(a, b), Mj(a, O()), c;
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    Uj(a);
    Mj(a, O());
    return null;
}
function Vj() {
    if (null !== Cj) {
        var a = Cj;
        Cj = null;
        a.forEach(function(a) {
            a.expiredLanes |= 24 & a.pendingLanes;
            Mj(a, O());
        });
    }
    ig();
}
function Wj(a, b) {
    var c = X;
    X |= 1;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function Xj(a, b) {
    var c = X;
    X &= -2;
    X |= 8;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
}
function ni(a, b) {
    I(rj, qj);
    qj |= b;
    tj |= b;
}
function Ki() {
    qj = rj.current;
    H(rj);
}
function Qj(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, pf(c));
    if (null !== Y) for(c = Y.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Gf();
                break;
            case 3:
                fh();
                H(N);
                H(M);
                uh();
                break;
            case 5:
                hh(d);
                break;
            case 4:
                fh();
                break;
            case 13:
                H(P);
                break;
            case 19:
                H(P);
                break;
            case 10:
                rg(d);
                break;
            case 23:
            case 24:
                Ki();
        }
        c = c.return;
    }
    U = a;
    Y = Tg(a.current, null);
    W = qj = tj = b;
    V = 0;
    sj = null;
    uj = Hi = Dg = 0;
}
function Sj(a, b) {
    do {
        var c = Y;
        try {
            qg();
            vh.current = Gh;
            if (yh) {
                for(var d = R.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                yh = !1;
            }
            xh = 0;
            T = S = R = null;
            zh = !1;
            pj.current = null;
            if (null === c || null === c.return) {
                V = 1;
                sj = b;
                Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = W;
                h.flags |= 2048;
                h.firstEffect = h.lastEffect = null;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k;
                    if (0 === (h.mode & 2)) {
                        var n = h.alternate;
                        n ? (h.updateQueue = n.updateQueue, h.memoizedState = n.memoizedState, h.lanes = n.lanes) : (h.updateQueue = null, h.memoizedState = null);
                    }
                    var A = 0 !== (P.current & 1), p = g;
                    do {
                        var C;
                        if (C = 13 === p.tag) {
                            var x = p.memoizedState;
                            if (null !== x) C = null !== x.dehydrated ? !0 : !1;
                            else {
                                var w = p.memoizedProps;
                                C = void 0 === w.fallback ? !1 : !0 !== w.unstable_avoidThisFallback ? !0 : A ? !1 : !0;
                            }
                        }
                        if (C) {
                            var z = p.updateQueue;
                            if (null === z) {
                                var u = new Set;
                                u.add(l);
                                p.updateQueue = u;
                            } else z.add(l);
                            if (0 === (p.mode & 2)) {
                                p.flags |= 64;
                                h.flags |= 16384;
                                h.flags &= -2981;
                                if (1 === h.tag) {
                                    if (null === h.alternate) h.tag = 17;
                                    else {
                                        var t = zg(-1, 1);
                                        t.tag = 2;
                                        Ag(h, t);
                                    }
                                }
                                h.lanes |= 1;
                                break a;
                            }
                            k = void 0;
                            h = b;
                            var q = f.pingCache;
                            null === q ? (q = f.pingCache = new Oi, k = new Set, q.set(l, k)) : (k = q.get(l), void 0 === k && (k = new Set, q.set(l, k)));
                            if (!k.has(h)) {
                                k.add(h);
                                var v = Yj.bind(null, f, l, h);
                                l.then(v, v);
                            }
                            p.flags |= 4096;
                            p.lanes = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    k = Error((Ra(h.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");
                }
                5 !== V && (V = 2);
                k = Mi(k, h);
                p = g;
                do {
                    switch(p.tag){
                        case 3:
                            f = k;
                            p.flags |= 4096;
                            b &= -b;
                            p.lanes |= b;
                            var J = Pi(p, f, b);
                            Bg(p, J);
                            break a;
                        case 1:
                            f = k;
                            var K = p.type, Q = p.stateNode;
                            if (0 === (p.flags & 64) && ("function" === typeof K.getDerivedStateFromError || null !== Q && "function" === typeof Q.componentDidCatch && (null === Ti || !Ti.has(Q)))) {
                                p.flags |= 4096;
                                b &= -b;
                                p.lanes |= b;
                                var L = Si(p, f, b);
                                Bg(p, L);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            Zj(c);
        } catch (va) {
            b = va;
            Y === c && null !== c && (Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function Pj() {
    var a = oj.current;
    oj.current = Gh;
    return null === a ? Gh : a;
}
function Tj(a, b) {
    var c = X;
    X |= 16;
    var d = Pj();
    U === a && W === b || Qj(a, b);
    for(;;)try {
        ak();
        break;
    } catch (e) {
        Sj(a, e);
    }
    qg();
    X = c;
    oj.current = d;
    if (null !== Y) throw Error(y(261));
    U = null;
    W = 0;
    return V;
}
function ak() {
    for(; null !== Y;)bk(Y);
}
function Rj() {
    for(; null !== Y && !Qf();)bk(Y);
}
function bk(a) {
    var b = ck(a.alternate, a, qj);
    a.memoizedProps = a.pendingProps;
    null === b ? Zj(a) : Y = b;
    pj.current = null;
}
function Zj(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 2048)) {
            c = Gi(c, b, qj);
            if (null !== c) {
                Y = c;
                return;
            }
            c = b;
            if (24 !== c.tag && 23 !== c.tag || null === c.memoizedState || 0 !== (qj & 1073741824) || 0 === (c.mode & 4)) {
                for(var d = 0, e = c.child; null !== e;)d |= e.lanes | e.childLanes, e = e.sibling;
                c.childLanes = d;
            }
            null !== a && 0 === (a.flags & 2048) && (null === a.firstEffect && (a.firstEffect = b.firstEffect), null !== b.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = b.firstEffect), a.lastEffect = b.lastEffect), 1 < b.flags && (null !== a.lastEffect ? a.lastEffect.nextEffect = b : a.firstEffect = b, a.lastEffect = b));
        } else {
            c = Li(b);
            if (null !== c) {
                c.flags &= 2047;
                Y = c;
                return;
            }
            null !== a && (a.firstEffect = a.lastEffect = null, a.flags |= 2048);
        }
        b = b.sibling;
        if (null !== b) {
            Y = b;
            return;
        }
        Y = b = a;
    }while (null !== b);
    0 === V && (V = 5);
}
function Uj(a) {
    var b = eg();
    gg(99, dk.bind(null, a, b));
    return null;
}
function dk(a, b) {
    do Oj();
    while (null !== yj);
    if (0 !== (X & 48)) throw Error(y(327));
    var c = a.finishedWork;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error(y(177));
    a.callbackNode = null;
    var d = c.lanes | c.childLanes, e = d, f = a.pendingLanes & ~e;
    a.pendingLanes = e;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= e;
    a.mutableReadLanes &= e;
    a.entangledLanes &= e;
    e = a.entanglements;
    for(var g = a.eventTimes, h = a.expirationTimes; 0 < f;){
        var k = 31 - Vc(f), l = 1 << k;
        e[k] = 0;
        g[k] = -1;
        h[k] = -1;
        f &= ~l;
    }
    null !== Cj && 0 === (d & 24) && Cj.has(a) && Cj.delete(a);
    a === U && (Y = U = null, W = 0);
    1 < c.flags ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, d = c.firstEffect) : d = c : d = c.firstEffect;
    if (null !== d) {
        e = X;
        X |= 32;
        pj.current = null;
        kf = fd;
        g = Ne();
        if (Oe(g)) {
            if ("selectionStart" in g) h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: if (h = (h = g.ownerDocument) && h.defaultView || window, (l = h.getSelection && h.getSelection()) && 0 !== l.rangeCount) {
                h = l.anchorNode;
                f = l.anchorOffset;
                k = l.focusNode;
                l = l.focusOffset;
                try {
                    h.nodeType, k.nodeType;
                } catch (va) {
                    h = null;
                    break a;
                }
                var n = 0, A = -1, p = -1, C = 0, x = 0, w = g, z = null;
                b: for(;;){
                    for(var u;;){
                        w !== h || 0 !== f && 3 !== w.nodeType || (A = n + f);
                        w !== k || 0 !== l && 3 !== w.nodeType || (p = n + l);
                        3 === w.nodeType && (n += w.nodeValue.length);
                        if (null === (u = w.firstChild)) break;
                        z = w;
                        w = u;
                    }
                    for(;;){
                        if (w === g) break b;
                        z === h && ++C === f && (A = n);
                        z === k && ++x === l && (p = n);
                        if (null !== (u = w.nextSibling)) break;
                        w = z;
                        z = w.parentNode;
                    }
                    w = u;
                }
                h = -1 === A || -1 === p ? null : {
                    start: A,
                    end: p
                };
            } else h = null;
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        lf = {
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Ij = null;
        Jj = !1;
        Z = d;
        do try {
            ek();
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Ij = null;
        Z = d;
        do try {
            for(g = a; null !== Z;){
                var t = Z.flags;
                t & 16 && pb(Z.stateNode, "");
                if (t & 128) {
                    var q = Z.alternate;
                    if (null !== q) {
                        var v = q.ref;
                        null !== v && ("function" === typeof v ? v(null) : v.current = null);
                    }
                }
                switch(t & 1038){
                    case 2:
                        fj(Z);
                        Z.flags &= -3;
                        break;
                    case 6:
                        fj(Z);
                        Z.flags &= -3;
                        ij(Z.alternate, Z);
                        break;
                    case 1024:
                        Z.flags &= -1025;
                        break;
                    case 1028:
                        Z.flags &= -1025;
                        ij(Z.alternate, Z);
                        break;
                    case 4:
                        ij(Z.alternate, Z);
                        break;
                    case 8:
                        h = Z;
                        cj(g, h);
                        var J = h.alternate;
                        dj(h);
                        null !== J && dj(J);
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        v = lf;
        q = Ne();
        t = v.focusedElem;
        g = v.selectionRange;
        if (q !== t && t && t.ownerDocument && Me(t.ownerDocument.documentElement, t)) {
            null !== g && Oe(t) && (q = g.start, v = g.end, void 0 === v && (v = q), "selectionStart" in t ? (t.selectionStart = q, t.selectionEnd = Math.min(v, t.value.length)) : (v = (q = t.ownerDocument || document) && q.defaultView || window, v.getSelection && (v = v.getSelection(), h = t.textContent.length, J = Math.min(g.start, h), g = void 0 === g.end ? J : Math.min(g.end, h), !v.extend && J > g && (h = g, g = J, J = h), h = Le(t, J), f = Le(t, g), h && f && (1 !== v.rangeCount || v.anchorNode !== h.node || v.anchorOffset !== h.offset || v.focusNode !== f.node || v.focusOffset !== f.offset) && (q = q.createRange(), q.setStart(h.node, h.offset), v.removeAllRanges(), J > g ? (v.addRange(q), v.extend(f.node, f.offset)) : (q.setEnd(f.node, f.offset), v.addRange(q))))));
            q = [];
            for(v = t; v = v.parentNode;)1 === v.nodeType && q.push({
                element: v,
                left: v.scrollLeft,
                top: v.scrollTop
            });
            "function" === typeof t.focus && t.focus();
            for(t = 0; t < q.length; t++)v = q[t], v.element.scrollLeft = v.left, v.element.scrollTop = v.top;
        }
        fd = !!kf;
        lf = kf = null;
        a.current = c;
        Z = d;
        do try {
            for(t = a; null !== Z;){
                var K = Z.flags;
                K & 36 && Yi(t, Z.alternate, Z);
                if (K & 128) {
                    q = void 0;
                    var Q = Z.ref;
                    if (null !== Q) {
                        var L = Z.stateNode;
                        switch(Z.tag){
                            case 5:
                                q = L;
                                break;
                            default:
                                q = L;
                        }
                        "function" === typeof Q ? Q(q) : Q.current = q;
                    }
                }
                Z = Z.nextEffect;
            }
        } catch (va) {
            if (null === Z) throw Error(y(330));
            Wi(Z, va);
            Z = Z.nextEffect;
        }
        while (null !== Z);
        Z = null;
        $f();
        X = e;
    } else a.current = c;
    if (xj) xj = !1, yj = a, zj = b;
    else for(Z = d; null !== Z;)b = Z.nextEffect, Z.nextEffect = null, Z.flags & 8 && (K = Z, K.sibling = null, K.stateNode = null), Z = b;
    d = a.pendingLanes;
    0 === d && (Ti = null);
    1 === d ? a === Ej ? Dj++ : (Dj = 0, Ej = a) : Dj = 0;
    c = c.stateNode;
    if (Mf && "function" === typeof Mf.onCommitFiberRoot) try {
        Mf.onCommitFiberRoot(Lf, c, void 0, 64 === (c.current.flags & 64));
    } catch (va) {}
    Mj(a, O());
    if (Qi) throw Qi = !1, a = Ri, Ri = null, a;
    if (0 !== (X & 8)) return null;
    ig();
    return null;
}
function ek() {
    for(; null !== Z;){
        var a = Z.alternate;
        Jj || null === Ij || (0 !== (Z.flags & 8) ? dc(Z, Ij) && (Jj = !0) : 13 === Z.tag && mj(a, Z) && dc(Z, Ij) && (Jj = !0));
        var b = Z.flags;
        0 !== (b & 256) && Xi(a, Z);
        0 === (b & 512) || xj || (xj = !0, hg(97, function() {
            Oj();
            return null;
        }));
        Z = Z.nextEffect;
    }
}
function Oj() {
    if (90 !== zj) {
        var a = 97 < zj ? 97 : zj;
        zj = 90;
        return gg(a, fk);
    }
    return !1;
}
function $i(a, b) {
    Aj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function Zi(a, b) {
    Bj.push(b, a);
    xj || (xj = !0, hg(97, function() {
        Oj();
        return null;
    }));
}
function fk() {
    if (null === yj) return !1;
    var a = yj;
    yj = null;
    if (0 !== (X & 48)) throw Error(y(331));
    var b = X;
    X |= 32;
    var c = Bj;
    Bj = [];
    for(var d = 0; d < c.length; d += 2){
        var e = c[d], f = c[d + 1], g = e.destroy;
        e.destroy = void 0;
        if ("function" === typeof g) try {
            g();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    c = Aj;
    Aj = [];
    for(d = 0; d < c.length; d += 2){
        e = c[d];
        f = c[d + 1];
        try {
            var h = e.create;
            e.destroy = h();
        } catch (k) {
            if (null === f) throw Error(y(330));
            Wi(f, k);
        }
    }
    for(h = a.current.firstEffect; null !== h;)a = h.nextEffect, h.nextEffect = null, h.flags & 8 && (h.sibling = null, h.stateNode = null), h = a;
    X = b;
    ig();
    return !0;
}
function gk(a, b, c) {
    b = Mi(c, b);
    b = Pi(a, b, 1);
    Ag(a, b);
    b = Hg();
    a = Kj(a, 1);
    null !== a && ($c(a, 1, b), Mj(a, b));
}
function Wi(a, b) {
    if (3 === a.tag) gk(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            gk(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) {
                a = Mi(b, a);
                var e = Si(c, a, 1);
                Ag(c, e);
                e = Hg();
                c = Kj(c, 1);
                if (null !== c) $c(c, 1, e), Mj(c, e);
                else if ("function" === typeof d.componentDidCatch && (null === Ti || !Ti.has(d))) try {
                    d.componentDidCatch(b, a);
                } catch (f) {}
                break;
            }
        }
        c = c.return;
    }
}
function Yj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = Hg();
    a.pingedLanes |= a.suspendedLanes & c;
    U === a && (W & c) === c && (4 === V || 3 === V && (W & 62914560) === W && 500 > O() - jj ? Qj(a, 0) : uj |= c);
    Mj(a, b);
}
function lj(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = a.mode, 0 === (b & 2) ? b = 1 : 0 === (b & 4) ? b = 99 === eg() ? 1 : 2 : (0 === Gj && (Gj = tj), b = Yc(62914560 & ~Gj), 0 === b && (b = 4194304)));
    c = Hg();
    a = Kj(a, b);
    null !== a && ($c(a, b, c), Mj(a, c));
}
var ck;
ck = function(a, b, c) {
    var d = b.lanes;
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || N.current) ug = !0;
        else if (0 !== (c & d)) ug = 0 !== (a.flags & 16384) ? !0 : !1;
        else {
            ug = !1;
            switch(b.tag){
                case 3:
                    ri(b);
                    sh();
                    break;
                case 5:
                    gh(b);
                    break;
                case 1:
                    Ff(b.type) && Jf(b);
                    break;
                case 4:
                    eh(b, b.stateNode.containerInfo);
                    break;
                case 10:
                    d = b.memoizedProps.value;
                    var e = b.type._context;
                    I(mg, e._currentValue);
                    e._currentValue = d;
                    break;
                case 13:
                    if (null !== b.memoizedState) {
                        if (0 !== (c & b.child.childLanes)) return ti(a, b, c);
                        I(P, P.current & 1);
                        b = hi(a, b, c);
                        return null !== b ? b.sibling : null;
                    }
                    I(P, P.current & 1);
                    break;
                case 19:
                    d = 0 !== (c & b.childLanes);
                    if (0 !== (a.flags & 64)) {
                        if (d) return Ai(a, b, c);
                        b.flags |= 64;
                    }
                    e = b.memoizedState;
                    null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
                    I(P, P.current);
                    if (d) break;
                    else return null;
                case 23:
                case 24:
                    return b.lanes = 0, mi(a, b, c);
            }
            return hi(a, b, c);
        }
    } else ug = !1;
    b.lanes = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
            a = b.pendingProps;
            e = Ef(b, M.current);
            tg(b, c);
            e = Ch(null, b, d, a, e, c);
            b.flags |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (Ff(d)) {
                    var f = !0;
                    Jf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                xg(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Gg(b, d, g, a);
                e.updater = Kg;
                b.stateNode = e;
                e._reactInternals = b;
                Og(b, d, a, c);
                b = qi(null, b, d, !0, f, c);
            } else b.tag = 0, fi(null, b, e, c), b = b.child;
            return b;
        case 16:
            e = b.elementType;
            a: {
                null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
                a = b.pendingProps;
                f = e._init;
                e = f(e._payload);
                b.type = e;
                f = b.tag = hk(e);
                a = lg(e, a);
                switch(f){
                    case 0:
                        b = li(null, b, e, a, c);
                        break a;
                    case 1:
                        b = pi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = gi(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ii(null, b, e, lg(e.type, a), d, c);
                        break a;
                }
                throw Error(y(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), li(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), pi(a, b, d, e, c);
        case 3:
            ri(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(y(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            yg(a, b);
            Cg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) sh(), b = hi(a, b, c);
            else {
                e = b.stateNode;
                if (f = e.hydrate) kh = rf(b.stateNode.containerInfo.firstChild), jh = b, f = lh = !0;
                if (f) {
                    a = e.mutableSourceEagerHydrationData;
                    if (null != a) for(e = 0; e < a.length; e += 2)f = a[e], f._workInProgressVersionPrimary = a[e + 1], th.push(f);
                    c = Zg(b, null, d, c);
                    for(b.child = c; c;)c.flags = c.flags & -3 | 1024, c = c.sibling;
                } else fi(a, b, d, c), sh();
                b = b.child;
            }
            return b;
        case 5:
            return gh(b), null === a && ph(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, nf(d, e) ? g = null : null !== f && nf(d, f) && (b.flags |= 16), oi(a, b), fi(a, b, g, c), b.child;
        case 6:
            return null === a && ph(b), null;
        case 13:
            return ti(a, b, c);
        case 4:
            return eh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Yg(b, null, d, c) : fi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), gi(a, b, d, e, c);
        case 7:
            return fi(a, b, b.pendingProps, c), b.child;
        case 8:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return fi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(mg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = He(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !N.current) {
                            b = hi(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = zg(-1, c & -c), l.tag = 2, Ag(h, l));
                                    h.lanes |= c;
                                    l = h.alternate;
                                    null !== l && (l.lanes |= c);
                                    sg(h.return, c);
                                    k.lanes |= c;
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                fi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, tg(b, c), e = vg(e, f.unstable_observedBits), d = d(e), b.flags |= 1, fi(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = lg(e, b.pendingProps), f = lg(e.type, f), ii(a, b, e, f, d, c);
        case 15:
            return ki(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : lg(d, e), null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2), b.tag = 1, Ff(d) ? (a = !0, Jf(b)) : a = !1, tg(b, c), Mg(b, d, e), Og(b, d, e, c), qi(null, b, d, !0, a, c);
        case 19:
            return Ai(a, b, c);
        case 23:
            return mi(a, b, c);
        case 24:
            return mi(a, b, c);
    }
    throw Error(y(156, b.tag));
};
function ik(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.flags = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function nh(a, b, c, d) {
    return new ik(a, b, c, d);
}
function ji(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function hk(a) {
    if ("function" === typeof a) return ji(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === Aa) return 11;
        if (a === Da) return 14;
    }
    return 2;
}
function Tg(a, b) {
    var c = a.alternate;
    null === c ? (c = nh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Vg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) ji(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ua:
            return Xg(c.children, e, f, b);
        case Ha:
            g = 8;
            e |= 16;
            break;
        case wa:
            g = 8;
            e |= 1;
            break;
        case xa:
            return a = nh(12, c, b, e | 8), a.elementType = xa, a.type = xa, a.lanes = f, a;
        case Ba:
            return a = nh(13, c, b, e), a.type = Ba, a.elementType = Ba, a.lanes = f, a;
        case Ca:
            return a = nh(19, c, b, e), a.elementType = Ca, a.lanes = f, a;
        case Ia:
            return vi(c, e, f, b);
        case Ja:
            return a = nh(24, c, b, e), a.elementType = Ja, a.lanes = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case ya:
                    g = 10;
                    break a;
                case za:
                    g = 9;
                    break a;
                case Aa:
                    g = 11;
                    break a;
                case Da:
                    g = 14;
                    break a;
                case Ea:
                    g = 16;
                    d = null;
                    break a;
                case Fa:
                    g = 22;
                    break a;
            }
            throw Error(y(130, null == a ? a : typeof a, ""));
    }
    b = nh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function Xg(a, b, c, d) {
    a = nh(7, a, d, b);
    a.lanes = c;
    return a;
}
function vi(a, b, c, d) {
    a = nh(23, a, d, b);
    a.elementType = Ia;
    a.lanes = c;
    return a;
}
function Ug(a, b, c) {
    a = nh(6, a, null, b);
    a.lanes = c;
    return a;
}
function Wg(a, b, c) {
    b = nh(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function jk(a, b, c) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 0;
    this.eventTimes = Zc(0);
    this.expirationTimes = Zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = Zc(0);
    this.mutableSourceEagerHydrationData = null;
}
function kk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: ta,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function lk(a, b, c, d) {
    var e = b.current, f = Hg(), g = Ig(e);
    a: if (c) {
        c = c._reactInternals;
        b: {
            if (Zb(c) !== c || 1 !== c.tag) throw Error(y(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (Ff(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(y(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (Ff(k)) {
                c = If(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Cf;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = zg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    Ag(e, b);
    Jg(e, g, f);
    return g;
}
function mk(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function nk(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function ok(a, b) {
    nk(a, b);
    (a = a.alternate) && nk(a, b);
}
function pk() {
    return null;
}
function qk(a, b, c) {
    var d = null != c && null != c.hydrationOptions && c.hydrationOptions.mutableSources || null;
    c = new jk(a, b, null != c && !0 === c.hydrate);
    b = nh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    c.current = b;
    b.stateNode = c;
    xg(b);
    a[ff] = c.current;
    cf(8 === a.nodeType ? a.parentNode : a);
    if (d) for(a = 0; a < d.length; a++){
        b = d[a];
        var e = b._getVersion;
        e = e(b._source);
        null == c.mutableSourceEagerHydrationData ? c.mutableSourceEagerHydrationData = [
            b,
            e
        ] : c.mutableSourceEagerHydrationData.push(b, e);
    }
    this._internalRoot = c;
}
qk.prototype.render = function(a) {
    lk(a, this._internalRoot, null, null);
};
qk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    lk(null, a, null, function() {
        b[ff] = null;
    });
};
function rk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function sk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new qk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function tk(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = mk(g);
                h.call(a);
            };
        }
        lk(b, g, a, e);
    } else {
        f = c._reactRootContainer = sk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = mk(g);
                k.call(a);
            };
        }
        Xj(function() {
            lk(b, g, a, e);
        });
    }
    return mk(g);
}
ec = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 4, b);
        ok(a, 4);
    }
};
fc = function(a) {
    if (13 === a.tag) {
        var b = Hg();
        Jg(a, 67108864, b);
        ok(a, 67108864);
    }
};
gc = function(a) {
    if (13 === a.tag) {
        var b = Hg(), c = Ig(a);
        Jg(a, c, b);
        ok(a, c);
    }
};
hc = function(a, b) {
    return b();
};
yb = function(a, b, c) {
    switch(b){
        case "input":
            ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Db(d);
                        if (!e) throw Error(y(90));
                        Wa(d);
                        ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            ib(a, c);
            break;
        case "select":
            b = c.value, null != b && fb(a, !!c.multiple, b, !1);
    }
};
Gb = Wj;
Hb = function(a, b, c, d, e) {
    var f = X;
    X |= 4;
    try {
        return gg(98, a.bind(null, b, c, d, e));
    } finally{
        X = f, 0 === X && (wj(), ig());
    }
};
Ib = function() {
    0 === (X & 49) && (Vj(), Oj());
};
Jb = function(a, b) {
    var c = X;
    X |= 2;
    try {
        return a(b);
    } finally{
        X = c, 0 === X && (wj(), ig());
    }
};
function uk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!rk(b)) throw Error(y(200));
    return kk(a, b, null, c);
}
var vk = {
    Events: [
        Cb,
        ue,
        Db,
        Eb,
        Fb,
        Oj,
        {
            current: !1
        }
    ]
}, wk = {
    findFiberByHostInstance: wc,
    bundleType: 0,
    version: "17.0.2",
    rendererPackageName: "react-dom"
};
var xk = {
    bundleType: wk.bundleType,
    version: wk.version,
    rendererPackageName: wk.rendererPackageName,
    rendererConfig: wk.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: ra.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = cc(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: wk.findFiberByHostInstance || pk,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var yk = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!yk.isDisabled && yk.supportsFiber) try {
        Lf = yk.inject(xk), Mf = yk;
    } catch (a) {}
}
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = vk;
exports.createPortal = uk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(y(188));
        throw Error(y(268, Object.keys(a)));
    }
    a = cc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    var c = X;
    if (0 !== (c & 48)) return a(b);
    X |= 1;
    try {
        if (a) return gg(99, a.bind(null, b));
    } finally{
        X = c, ig();
    }
};
exports.hydrate = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!rk(b)) throw Error(y(200));
    return tk(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!rk(a)) throw Error(y(40));
    return a._reactRootContainer ? (Xj(function() {
        tk(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[ff] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Wj;
exports.unstable_createPortal = function(a, b) {
    return uk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!rk(c)) throw Error(y(200));
    if (null == a || void 0 === a._reactInternals) throw Error(y(38));
    return tk(a, b, c, !1, d);
};
exports.version = "17.0.2";

});
parcelRegister("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/** @license React v0.20.2
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$cf845f2c119da08a;
"use strict";
var $bcb017604639e9d7$var$f, $bcb017604639e9d7$var$g, $bcb017604639e9d7$var$h, $bcb017604639e9d7$var$k;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$t = null, $bcb017604639e9d7$var$u = null, $bcb017604639e9d7$var$w = function() {
        if (null !== $bcb017604639e9d7$var$t) try {
            var a = $bcb017604639e9d7$export$c4744153514ff05d();
            $bcb017604639e9d7$var$t(!0, a);
            $bcb017604639e9d7$var$t = null;
        } catch (b) {
            throw setTimeout($bcb017604639e9d7$var$w, 0), b;
        }
    };
    $bcb017604639e9d7$var$f = function(a) {
        null !== $bcb017604639e9d7$var$t ? setTimeout($bcb017604639e9d7$var$f, 0, a) : ($bcb017604639e9d7$var$t = a, setTimeout($bcb017604639e9d7$var$w, 0));
    };
    $bcb017604639e9d7$var$g = function(a, b) {
        $bcb017604639e9d7$var$u = setTimeout(a, b);
    };
    $bcb017604639e9d7$var$h = function() {
        clearTimeout($bcb017604639e9d7$var$u);
    };
    $bcb017604639e9d7$export$b5836b71941fa3ed = function() {
        return !1;
    };
    $bcb017604639e9d7$var$k = $bcb017604639e9d7$export$d66a1c1c77bd778b = function() {};
} else {
    var $bcb017604639e9d7$var$x = window.setTimeout, $bcb017604639e9d7$var$y = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $bcb017604639e9d7$var$z = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
        "function" !== typeof $bcb017604639e9d7$var$z && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");
    }
    var $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = null, $bcb017604639e9d7$var$C = -1, $bcb017604639e9d7$var$D = 5, $bcb017604639e9d7$var$E = 0;
    $bcb017604639e9d7$export$b5836b71941fa3ed = function() {
        return $bcb017604639e9d7$export$c4744153514ff05d() >= $bcb017604639e9d7$var$E;
    };
    $bcb017604639e9d7$var$k = function() {};
    $bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$D = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $bcb017604639e9d7$var$F = new MessageChannel, $bcb017604639e9d7$var$G = $bcb017604639e9d7$var$F.port2;
    $bcb017604639e9d7$var$F.port1.onmessage = function() {
        if (null !== $bcb017604639e9d7$var$B) {
            var a = $bcb017604639e9d7$export$c4744153514ff05d();
            $bcb017604639e9d7$var$E = a + $bcb017604639e9d7$var$D;
            try {
                $bcb017604639e9d7$var$B(!0, a) ? $bcb017604639e9d7$var$G.postMessage(null) : ($bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = null);
            } catch (b) {
                throw $bcb017604639e9d7$var$G.postMessage(null), b;
            }
        } else $bcb017604639e9d7$var$A = !1;
    };
    $bcb017604639e9d7$var$f = function(a) {
        $bcb017604639e9d7$var$B = a;
        $bcb017604639e9d7$var$A || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$G.postMessage(null));
    };
    $bcb017604639e9d7$var$g = function(a, b) {
        $bcb017604639e9d7$var$C = $bcb017604639e9d7$var$x(function() {
            a($bcb017604639e9d7$export$c4744153514ff05d());
        }, b);
    };
    $bcb017604639e9d7$var$h = function() {
        $bcb017604639e9d7$var$y($bcb017604639e9d7$var$C);
        $bcb017604639e9d7$var$C = -1;
    };
}
function $bcb017604639e9d7$var$H(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $bcb017604639e9d7$var$I(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$J(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $bcb017604639e9d7$var$K(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $bcb017604639e9d7$var$I(n, c)) void 0 !== r && 0 > $bcb017604639e9d7$var$I(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $bcb017604639e9d7$var$I(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $bcb017604639e9d7$var$I(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $bcb017604639e9d7$var$L = [], $bcb017604639e9d7$var$M = [], $bcb017604639e9d7$var$N = 1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$P = 3, $bcb017604639e9d7$var$Q = !1, $bcb017604639e9d7$var$R = !1, $bcb017604639e9d7$var$S = !1;
function $bcb017604639e9d7$var$T(a) {
    for(var b = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$K($bcb017604639e9d7$var$M);
        else if (b.startTime <= a) $bcb017604639e9d7$var$K($bcb017604639e9d7$var$M), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$H($bcb017604639e9d7$var$L, b);
        else break;
        b = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M);
    }
}
function $bcb017604639e9d7$var$U(a) {
    $bcb017604639e9d7$var$S = !1;
    $bcb017604639e9d7$var$T(a);
    if (!$bcb017604639e9d7$var$R) {
        if (null !== $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L)) $bcb017604639e9d7$var$R = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$V);
        else {
            var b = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M);
            null !== b && $bcb017604639e9d7$var$g($bcb017604639e9d7$var$U, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$V(a, b) {
    $bcb017604639e9d7$var$R = !1;
    $bcb017604639e9d7$var$S && ($bcb017604639e9d7$var$S = !1, $bcb017604639e9d7$var$h());
    $bcb017604639e9d7$var$Q = !0;
    var c = $bcb017604639e9d7$var$P;
    try {
        $bcb017604639e9d7$var$T(b);
        for($bcb017604639e9d7$var$O = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L); null !== $bcb017604639e9d7$var$O && (!($bcb017604639e9d7$var$O.expirationTime > b) || a && !$bcb017604639e9d7$export$b5836b71941fa3ed());){
            var d = $bcb017604639e9d7$var$O.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$O.callback = null;
                $bcb017604639e9d7$var$P = $bcb017604639e9d7$var$O.priorityLevel;
                var e = d($bcb017604639e9d7$var$O.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$O.callback = e : $bcb017604639e9d7$var$O === $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L) && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$L);
                $bcb017604639e9d7$var$T(b);
            } else $bcb017604639e9d7$var$K($bcb017604639e9d7$var$L);
            $bcb017604639e9d7$var$O = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L);
        }
        if (null !== $bcb017604639e9d7$var$O) var m = !0;
        else {
            var n = $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M);
            null !== n && $bcb017604639e9d7$var$g($bcb017604639e9d7$var$U, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$P = c, $bcb017604639e9d7$var$Q = !1;
    }
}
var $bcb017604639e9d7$var$W = $bcb017604639e9d7$var$k;
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$R || $bcb017604639e9d7$var$Q || ($bcb017604639e9d7$var$R = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$V));
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$P;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$P){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$P;
    }
    var c = $bcb017604639e9d7$var$P;
    $bcb017604639e9d7$var$P = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$P = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = $bcb017604639e9d7$var$W;
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$P;
    $bcb017604639e9d7$var$P = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$P = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$N++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$H($bcb017604639e9d7$var$M, a), null === $bcb017604639e9d7$var$J($bcb017604639e9d7$var$L) && a === $bcb017604639e9d7$var$J($bcb017604639e9d7$var$M) && ($bcb017604639e9d7$var$S ? $bcb017604639e9d7$var$h() : $bcb017604639e9d7$var$S = !0, $bcb017604639e9d7$var$g($bcb017604639e9d7$var$U, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$H($bcb017604639e9d7$var$L, a), $bcb017604639e9d7$var$R || $bcb017604639e9d7$var$Q || ($bcb017604639e9d7$var$R = !0, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$V)));
    return a;
};
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$P;
    return function() {
        var c = $bcb017604639e9d7$var$P;
        $bcb017604639e9d7$var$P = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$P = c;
        }
    };
};

});




parcelRegister("c9Z8w", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("hOzOt"))();

});
parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $f4905a8b274aa381$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});



parcelRegister("8nd05", function(module, exports) {

$parcel$export(module.exports, "default", () => $618a8e53233cd9fa$export$2e2bcd8739ae039);
function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}

});

parcelRegister("9RYKL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $72f8309e8b4c5d38$export$2e2bcd8739ae039);
var $72f8309e8b4c5d38$var$isProduction = true;
function $72f8309e8b4c5d38$var$warning(condition, message) {
    if (!$72f8309e8b4c5d38$var$isProduction) {
        if (condition) return;
        var text = "Warning: " + message;
        if (typeof console !== "undefined") console.warn(text);
        try {
            throw Error(text);
        } catch (x) {}
    }
}
var $72f8309e8b4c5d38$export$2e2bcd8739ae039 = $72f8309e8b4c5d38$var$warning;

});

parcelRegister("bv4qN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $85f606e562c81b96$export$2e2bcd8739ae039);
var $85f606e562c81b96$var$isProduction = true;
var $85f606e562c81b96$var$prefix = "Invariant failed";
function $85f606e562c81b96$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($85f606e562c81b96$var$isProduction) throw new Error($85f606e562c81b96$var$prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? $85f606e562c81b96$var$prefix + ": " + provided : $85f606e562c81b96$var$prefix;
    throw new Error(value);
}

});

parcelRegister("9cCWX", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $6b3372b60d35b33f$export$2b8d127b894957b9, (v) => $6b3372b60d35b33f$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $6b3372b60d35b33f$export$cea3a54a6425200c, (v) => $6b3372b60d35b33f$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $6b3372b60d35b33f$export$a7c73072b1a182ae, (v) => $6b3372b60d35b33f$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $6b3372b60d35b33f$export$9f27bc3417b4524d, (v) => $6b3372b60d35b33f$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $6b3372b60d35b33f$export$db77ccec0bb4ccac, (v) => $6b3372b60d35b33f$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $6b3372b60d35b33f$export$8392c0c9d3dcbd35, (v) => $6b3372b60d35b33f$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $6b3372b60d35b33f$export$ffb0004e005737fa, (v) => $6b3372b60d35b33f$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $6b3372b60d35b33f$export$b624eff549462981, (v) => $6b3372b60d35b33f$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $6b3372b60d35b33f$export$7897aa7841a5380c, (v) => $6b3372b60d35b33f$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $6b3372b60d35b33f$export$602eac185826482c, (v) => $6b3372b60d35b33f$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $6b3372b60d35b33f$export$e2c29f18771995cb, (v) => $6b3372b60d35b33f$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $6b3372b60d35b33f$export$5f8d39834fd61797, (v) => $6b3372b60d35b33f$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $6b3372b60d35b33f$export$74bf444e3cd11ea5, (v) => $6b3372b60d35b33f$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $6b3372b60d35b33f$export$92387174baf9b227, (v) => $6b3372b60d35b33f$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $6b3372b60d35b33f$export$ec112efeb987d9c6, (v) => $6b3372b60d35b33f$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $6b3372b60d35b33f$export$b706b080d889d2c9, (v) => $6b3372b60d35b33f$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $6b3372b60d35b33f$export$5be5a87408f70ddc, (v) => $6b3372b60d35b33f$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $6b3372b60d35b33f$export$45a5e7f76e0caa8d, (v) => $6b3372b60d35b33f$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $6b3372b60d35b33f$export$455c2e768291efa6, (v) => $6b3372b60d35b33f$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $6b3372b60d35b33f$export$9522e17588c12572, (v) => $6b3372b60d35b33f$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $6b3372b60d35b33f$export$2110ac352bb060b9, (v) => $6b3372b60d35b33f$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $6b3372b60d35b33f$export$56885ab8b9c456ab, (v) => $6b3372b60d35b33f$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $6b3372b60d35b33f$export$d927fcb6adf8f9de, (v) => $6b3372b60d35b33f$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $6b3372b60d35b33f$export$b82d16f27459e05a, (v) => $6b3372b60d35b33f$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $6b3372b60d35b33f$export$522c17b4f5e123e8, (v) => $6b3372b60d35b33f$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $6b3372b60d35b33f$export$1aabd8a0274ecfd6, (v) => $6b3372b60d35b33f$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $6b3372b60d35b33f$export$9b621391a187a31a, (v) => $6b3372b60d35b33f$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $6b3372b60d35b33f$export$f5bbd400c2f4426f, (v) => $6b3372b60d35b33f$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6b3372b60d35b33f$export$2b8d127b894957b9;
var $6b3372b60d35b33f$export$cea3a54a6425200c;
var $6b3372b60d35b33f$export$a7c73072b1a182ae;
var $6b3372b60d35b33f$export$9f27bc3417b4524d;
var $6b3372b60d35b33f$export$db77ccec0bb4ccac;
var $6b3372b60d35b33f$export$8392c0c9d3dcbd35;
var $6b3372b60d35b33f$export$ffb0004e005737fa;
var $6b3372b60d35b33f$export$b624eff549462981;
var $6b3372b60d35b33f$export$7897aa7841a5380c;
var $6b3372b60d35b33f$export$602eac185826482c;
var $6b3372b60d35b33f$export$e2c29f18771995cb;
var $6b3372b60d35b33f$export$5f8d39834fd61797;
var $6b3372b60d35b33f$export$74bf444e3cd11ea5;
var $6b3372b60d35b33f$export$92387174baf9b227;
var $6b3372b60d35b33f$export$ec112efeb987d9c6;
var $6b3372b60d35b33f$export$b706b080d889d2c9;
var $6b3372b60d35b33f$export$5be5a87408f70ddc;
var $6b3372b60d35b33f$export$45a5e7f76e0caa8d;
var $6b3372b60d35b33f$export$455c2e768291efa6;
var $6b3372b60d35b33f$export$9522e17588c12572;
var $6b3372b60d35b33f$export$2110ac352bb060b9;
var $6b3372b60d35b33f$export$56885ab8b9c456ab;
var $6b3372b60d35b33f$export$d927fcb6adf8f9de;
var $6b3372b60d35b33f$export$b82d16f27459e05a;
var $6b3372b60d35b33f$export$522c17b4f5e123e8;
var $6b3372b60d35b33f$export$1aabd8a0274ecfd6;
var $6b3372b60d35b33f$export$9b621391a187a31a;
var $6b3372b60d35b33f$export$f5bbd400c2f4426f;
"use strict";
var $6b3372b60d35b33f$var$b = "function" === typeof Symbol && Symbol.for, $6b3372b60d35b33f$var$c = $6b3372b60d35b33f$var$b ? Symbol.for("react.element") : 60103, $6b3372b60d35b33f$var$d = $6b3372b60d35b33f$var$b ? Symbol.for("react.portal") : 60106, $6b3372b60d35b33f$var$e = $6b3372b60d35b33f$var$b ? Symbol.for("react.fragment") : 60107, $6b3372b60d35b33f$var$f = $6b3372b60d35b33f$var$b ? Symbol.for("react.strict_mode") : 60108, $6b3372b60d35b33f$var$g = $6b3372b60d35b33f$var$b ? Symbol.for("react.profiler") : 60114, $6b3372b60d35b33f$var$h = $6b3372b60d35b33f$var$b ? Symbol.for("react.provider") : 60109, $6b3372b60d35b33f$var$k = $6b3372b60d35b33f$var$b ? Symbol.for("react.context") : 60110, $6b3372b60d35b33f$var$l = $6b3372b60d35b33f$var$b ? Symbol.for("react.async_mode") : 60111, $6b3372b60d35b33f$var$m = $6b3372b60d35b33f$var$b ? Symbol.for("react.concurrent_mode") : 60111, $6b3372b60d35b33f$var$n = $6b3372b60d35b33f$var$b ? Symbol.for("react.forward_ref") : 60112, $6b3372b60d35b33f$var$p = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense") : 60113, $6b3372b60d35b33f$var$q = $6b3372b60d35b33f$var$b ? Symbol.for("react.suspense_list") : 60120, $6b3372b60d35b33f$var$r = $6b3372b60d35b33f$var$b ? Symbol.for("react.memo") : 60115, $6b3372b60d35b33f$var$t = $6b3372b60d35b33f$var$b ? Symbol.for("react.lazy") : 60116, $6b3372b60d35b33f$var$v = $6b3372b60d35b33f$var$b ? Symbol.for("react.block") : 60121, $6b3372b60d35b33f$var$w = $6b3372b60d35b33f$var$b ? Symbol.for("react.fundamental") : 60117, $6b3372b60d35b33f$var$x = $6b3372b60d35b33f$var$b ? Symbol.for("react.responder") : 60118, $6b3372b60d35b33f$var$y = $6b3372b60d35b33f$var$b ? Symbol.for("react.scope") : 60119;
function $6b3372b60d35b33f$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $6b3372b60d35b33f$var$c:
                switch(a = a.type, a){
                    case $6b3372b60d35b33f$var$l:
                    case $6b3372b60d35b33f$var$m:
                    case $6b3372b60d35b33f$var$e:
                    case $6b3372b60d35b33f$var$g:
                    case $6b3372b60d35b33f$var$f:
                    case $6b3372b60d35b33f$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $6b3372b60d35b33f$var$k:
                            case $6b3372b60d35b33f$var$n:
                            case $6b3372b60d35b33f$var$t:
                            case $6b3372b60d35b33f$var$r:
                            case $6b3372b60d35b33f$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $6b3372b60d35b33f$var$d:
                return u;
        }
    }
}
function $6b3372b60d35b33f$var$A(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$m;
}
$6b3372b60d35b33f$export$2b8d127b894957b9 = $6b3372b60d35b33f$var$l;
$6b3372b60d35b33f$export$cea3a54a6425200c = $6b3372b60d35b33f$var$m;
$6b3372b60d35b33f$export$a7c73072b1a182ae = $6b3372b60d35b33f$var$k;
$6b3372b60d35b33f$export$9f27bc3417b4524d = $6b3372b60d35b33f$var$h;
$6b3372b60d35b33f$export$db77ccec0bb4ccac = $6b3372b60d35b33f$var$c;
$6b3372b60d35b33f$export$8392c0c9d3dcbd35 = $6b3372b60d35b33f$var$n;
$6b3372b60d35b33f$export$ffb0004e005737fa = $6b3372b60d35b33f$var$e;
$6b3372b60d35b33f$export$b624eff549462981 = $6b3372b60d35b33f$var$t;
$6b3372b60d35b33f$export$7897aa7841a5380c = $6b3372b60d35b33f$var$r;
$6b3372b60d35b33f$export$602eac185826482c = $6b3372b60d35b33f$var$d;
$6b3372b60d35b33f$export$e2c29f18771995cb = $6b3372b60d35b33f$var$g;
$6b3372b60d35b33f$export$5f8d39834fd61797 = $6b3372b60d35b33f$var$f;
$6b3372b60d35b33f$export$74bf444e3cd11ea5 = $6b3372b60d35b33f$var$p;
$6b3372b60d35b33f$export$92387174baf9b227 = function(a) {
    return $6b3372b60d35b33f$var$A(a) || $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$l;
};
$6b3372b60d35b33f$export$ec112efeb987d9c6 = $6b3372b60d35b33f$var$A;
$6b3372b60d35b33f$export$b706b080d889d2c9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$k;
};
$6b3372b60d35b33f$export$5be5a87408f70ddc = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$h;
};
$6b3372b60d35b33f$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $6b3372b60d35b33f$var$c;
};
$6b3372b60d35b33f$export$455c2e768291efa6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$n;
};
$6b3372b60d35b33f$export$9522e17588c12572 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$e;
};
$6b3372b60d35b33f$export$2110ac352bb060b9 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$t;
};
$6b3372b60d35b33f$export$56885ab8b9c456ab = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$r;
};
$6b3372b60d35b33f$export$d927fcb6adf8f9de = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$d;
};
$6b3372b60d35b33f$export$b82d16f27459e05a = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$g;
};
$6b3372b60d35b33f$export$522c17b4f5e123e8 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$f;
};
$6b3372b60d35b33f$export$1aabd8a0274ecfd6 = function(a) {
    return $6b3372b60d35b33f$var$z(a) === $6b3372b60d35b33f$var$p;
};
$6b3372b60d35b33f$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $6b3372b60d35b33f$var$e || a === $6b3372b60d35b33f$var$m || a === $6b3372b60d35b33f$var$g || a === $6b3372b60d35b33f$var$f || a === $6b3372b60d35b33f$var$p || a === $6b3372b60d35b33f$var$q || "object" === typeof a && null !== a && (a.$$typeof === $6b3372b60d35b33f$var$t || a.$$typeof === $6b3372b60d35b33f$var$r || a.$$typeof === $6b3372b60d35b33f$var$h || a.$$typeof === $6b3372b60d35b33f$var$k || a.$$typeof === $6b3372b60d35b33f$var$n || a.$$typeof === $6b3372b60d35b33f$var$w || a.$$typeof === $6b3372b60d35b33f$var$x || a.$$typeof === $6b3372b60d35b33f$var$y || a.$$typeof === $6b3372b60d35b33f$var$v);
};
$6b3372b60d35b33f$export$f5bbd400c2f4426f = $6b3372b60d35b33f$var$z;

});

parcelRegister("1En50", function(module, exports) {

$parcel$export(module.exports, "default", () => $133b6e059b2f6d5e$export$2e2bcd8739ae039);
function $133b6e059b2f6d5e$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}

});

parcelRegister("geReh", function(module, exports) {

$parcel$export(module.exports, "AdvancedFilterModule", () => $5b7ccabde48fae90$export$5f40a5e44930bd02);
$parcel$export(module.exports, "ClipboardModule", () => $5b7ccabde48fae90$export$3a36bd45ca02edda);
$parcel$export(module.exports, "ColumnsToolPanelModule", () => $5b7ccabde48fae90$export$8ff0dc87b3f8200e);
$parcel$export(module.exports, "EnterpriseCoreModule", () => $5b7ccabde48fae90$export$3a6d13add8617801);
$parcel$export(module.exports, "ExcelExportModule", () => $5b7ccabde48fae90$export$98f0c53ca0379def);
$parcel$export(module.exports, "FiltersToolPanelModule", () => $5b7ccabde48fae90$export$783953a68616c0a2);
$parcel$export(module.exports, "GridChartsModule", () => $5b7ccabde48fae90$export$6248c9e5743f8c49);
$parcel$export(module.exports, "LicenseManager", () => $5b7ccabde48fae90$export$91e2bbffdbb3852c);
$parcel$export(module.exports, "MasterDetailModule", () => $5b7ccabde48fae90$export$656cedc46227f6d2);
$parcel$export(module.exports, "MenuModule", () => $5b7ccabde48fae90$export$f1ab43fc4c3c5ce0);
$parcel$export(module.exports, "MultiFilter", () => $5b7ccabde48fae90$export$ab0841fc22e16fa3);
$parcel$export(module.exports, "MultiFilterModule", () => $5b7ccabde48fae90$export$8897e17f4dd9d13a);
$parcel$export(module.exports, "PivotDropZonePanel", () => $5b7ccabde48fae90$export$e3a33a41cac287e);
$parcel$export(module.exports, "PrimaryColsPanel", () => $5b7ccabde48fae90$export$2d9d69c2ece71d89);
$parcel$export(module.exports, "RangeSelectionModule", () => $5b7ccabde48fae90$export$5e5c8269d4d7ed2e);
$parcel$export(module.exports, "RichSelectModule", () => $5b7ccabde48fae90$export$9bd93207561bb9c);
$parcel$export(module.exports, "RowGroupDropZonePanel", () => $5b7ccabde48fae90$export$f3b209e86f7a7963);
$parcel$export(module.exports, "RowGroupingModule", () => $5b7ccabde48fae90$export$e67935bd41653107);
$parcel$export(module.exports, "ServerSideRowModelModule", () => $5b7ccabde48fae90$export$5c0e9f044c5e2dce);
$parcel$export(module.exports, "SetFilter", () => $5b7ccabde48fae90$export$7b7af8300a3a9e84);
$parcel$export(module.exports, "SetFilterModule", () => $5b7ccabde48fae90$export$4ab172eba3fdda9e);
$parcel$export(module.exports, "SideBarModule", () => $5b7ccabde48fae90$export$707a9bd30915b7fe);
$parcel$export(module.exports, "SparklinesModule", () => $5b7ccabde48fae90$export$4e5a2f3bfb2b8795);
$parcel$export(module.exports, "StatusBarModule", () => $5b7ccabde48fae90$export$76a316c8c2f3bc28);
$parcel$export(module.exports, "ToolPanelColDefService", () => $5b7ccabde48fae90$export$52f8319e10930bfa);
$parcel$export(module.exports, "ValuesDropZonePanel", () => $5b7ccabde48fae90$export$4c5515da8ced3ad7);
$parcel$export(module.exports, "ViewportRowModelModule", () => $5b7ccabde48fae90$export$5afa3276c0fcf76);
$parcel$export(module.exports, "__FORCE_MODULE_DETECTION_AG_GRID_CORE_EXT", () => $5b7ccabde48fae90$export$2d0cf3225e55a3e);
$parcel$export(module.exports, "agCharts", () => $5b7ccabde48fae90$export$8a8f7e9aca311bdd);
$parcel$export(module.exports, "exportMultipleSheetsAsExcel", () => $5b7ccabde48fae90$export$e871bbb2307806ee);
$parcel$export(module.exports, "getMultipleSheetsAsExcel", () => $5b7ccabde48fae90$export$cdca9ad0c864c7f0);
$parcel$export(module.exports, "ALWAYS_SYNC_GLOBAL_EVENTS", () => (parcelRequire("jIDNV")).ALWAYS_SYNC_GLOBAL_EVENTS);
$parcel$export(module.exports, "AbstractHeaderCellCtrl", () => (parcelRequire("jIDNV")).AbstractHeaderCellCtrl);
$parcel$export(module.exports, "AgAbstractField", () => (parcelRequire("jIDNV")).AgAbstractField);
$parcel$export(module.exports, "AgAbstractLabel", () => (parcelRequire("jIDNV")).AgAbstractLabel);
$parcel$export(module.exports, "AgAutocomplete", () => (parcelRequire("jIDNV")).AgAutocomplete);
$parcel$export(module.exports, "AgCheckbox", () => (parcelRequire("jIDNV")).AgCheckbox);
$parcel$export(module.exports, "AgDialog", () => (parcelRequire("jIDNV")).AgDialog);
$parcel$export(module.exports, "AgGroupComponent", () => (parcelRequire("jIDNV")).AgGroupComponent);
$parcel$export(module.exports, "AgInputDateField", () => (parcelRequire("jIDNV")).AgInputDateField);
$parcel$export(module.exports, "AgInputNumberField", () => (parcelRequire("jIDNV")).AgInputNumberField);
$parcel$export(module.exports, "AgInputRange", () => (parcelRequire("jIDNV")).AgInputRange);
$parcel$export(module.exports, "AgInputTextArea", () => (parcelRequire("jIDNV")).AgInputTextArea);
$parcel$export(module.exports, "AgInputTextField", () => (parcelRequire("jIDNV")).AgInputTextField);
$parcel$export(module.exports, "AgMenuItemComponent", () => (parcelRequire("jIDNV")).AgMenuItemComponent);
$parcel$export(module.exports, "AgMenuItemRenderer", () => (parcelRequire("jIDNV")).AgMenuItemRenderer);
$parcel$export(module.exports, "AgMenuList", () => (parcelRequire("jIDNV")).AgMenuList);
$parcel$export(module.exports, "AgMenuPanel", () => (parcelRequire("jIDNV")).AgMenuPanel);
$parcel$export(module.exports, "AgPanel", () => (parcelRequire("jIDNV")).AgPanel);
$parcel$export(module.exports, "AgPickerField", () => (parcelRequire("jIDNV")).AgPickerField);
$parcel$export(module.exports, "AgPromise", () => (parcelRequire("jIDNV")).AgPromise);
$parcel$export(module.exports, "AgPromiseStatus", () => (parcelRequire("jIDNV")).AgPromiseStatus);
$parcel$export(module.exports, "AgRadioButton", () => (parcelRequire("jIDNV")).AgRadioButton);
$parcel$export(module.exports, "AgRichSelect", () => (parcelRequire("jIDNV")).AgRichSelect);
$parcel$export(module.exports, "AgSelect", () => (parcelRequire("jIDNV")).AgSelect);
$parcel$export(module.exports, "AgSlider", () => (parcelRequire("jIDNV")).AgSlider);
$parcel$export(module.exports, "AgStackComponentsRegistry", () => (parcelRequire("jIDNV")).AgStackComponentsRegistry);
$parcel$export(module.exports, "AgToggleButton", () => (parcelRequire("jIDNV")).AgToggleButton);
$parcel$export(module.exports, "AlignedGridsService", () => (parcelRequire("jIDNV")).AlignedGridsService);
$parcel$export(module.exports, "AnimateShowChangeCellRenderer", () => (parcelRequire("jIDNV")).AnimateShowChangeCellRenderer);
$parcel$export(module.exports, "AnimateSlideCellRenderer", () => (parcelRequire("jIDNV")).AnimateSlideCellRenderer);
$parcel$export(module.exports, "AnimationFrameService", () => (parcelRequire("jIDNV")).AnimationFrameService);
$parcel$export(module.exports, "AutoScrollService", () => (parcelRequire("jIDNV")).AutoScrollService);
$parcel$export(module.exports, "AutoWidthCalculator", () => (parcelRequire("jIDNV")).AutoWidthCalculator);
$parcel$export(module.exports, "Autowired", () => (parcelRequire("jIDNV")).Autowired);
$parcel$export(module.exports, "BarColumnLabelPlacement", () => (parcelRequire("jIDNV")).BarColumnLabelPlacement);
$parcel$export(module.exports, "BaseComponentWrapper", () => (parcelRequire("jIDNV")).BaseComponentWrapper);
$parcel$export(module.exports, "Bean", () => (parcelRequire("jIDNV")).Bean);
$parcel$export(module.exports, "BeanStub", () => (parcelRequire("jIDNV")).BeanStub);
$parcel$export(module.exports, "Beans", () => (parcelRequire("jIDNV")).Beans);
$parcel$export(module.exports, "BodyDropPivotTarget", () => (parcelRequire("jIDNV")).BodyDropPivotTarget);
$parcel$export(module.exports, "BodyDropTarget", () => (parcelRequire("jIDNV")).BodyDropTarget);
$parcel$export(module.exports, "CellComp", () => (parcelRequire("jIDNV")).CellComp);
$parcel$export(module.exports, "CellCtrl", () => (parcelRequire("jIDNV")).CellCtrl);
$parcel$export(module.exports, "CellNavigationService", () => (parcelRequire("jIDNV")).CellNavigationService);
$parcel$export(module.exports, "CellPositionUtils", () => (parcelRequire("jIDNV")).CellPositionUtils);
$parcel$export(module.exports, "CellRangeType", () => (parcelRequire("jIDNV")).CellRangeType);
$parcel$export(module.exports, "ChangedPath", () => (parcelRequire("jIDNV")).ChangedPath);
$parcel$export(module.exports, "ChartMappings", () => (parcelRequire("jIDNV")).ChartMappings);
$parcel$export(module.exports, "CheckboxCellEditor", () => (parcelRequire("jIDNV")).CheckboxCellEditor);
$parcel$export(module.exports, "CheckboxCellRenderer", () => (parcelRequire("jIDNV")).CheckboxCellRenderer);
$parcel$export(module.exports, "CheckboxSelectionComponent", () => (parcelRequire("jIDNV")).CheckboxSelectionComponent);
$parcel$export(module.exports, "ClientSideRowModelSteps", () => (parcelRequire("jIDNV")).ClientSideRowModelSteps);
$parcel$export(module.exports, "Column", () => (parcelRequire("jIDNV")).Column);
$parcel$export(module.exports, "ColumnApi", () => (parcelRequire("jIDNV")).ColumnApi);
$parcel$export(module.exports, "ColumnFactory", () => (parcelRequire("jIDNV")).ColumnFactory);
$parcel$export(module.exports, "ColumnGroup", () => (parcelRequire("jIDNV")).ColumnGroup);
$parcel$export(module.exports, "ColumnKeyCreator", () => (parcelRequire("jIDNV")).ColumnKeyCreator);
$parcel$export(module.exports, "ColumnModel", () => (parcelRequire("jIDNV")).ColumnModel);
$parcel$export(module.exports, "Component", () => (parcelRequire("jIDNV")).Component);
$parcel$export(module.exports, "ComponentUtil", () => (parcelRequire("jIDNV")).ComponentUtil);
$parcel$export(module.exports, "Context", () => (parcelRequire("jIDNV")).Context);
$parcel$export(module.exports, "CssClassApplier", () => (parcelRequire("jIDNV")).CssClassApplier);
$parcel$export(module.exports, "CssClassManager", () => (parcelRequire("jIDNV")).CssClassManager);
$parcel$export(module.exports, "CtrlsService", () => (parcelRequire("jIDNV")).CtrlsService);
$parcel$export(module.exports, "DataTypeService", () => (parcelRequire("jIDNV")).DataTypeService);
$parcel$export(module.exports, "DateCellEditor", () => (parcelRequire("jIDNV")).DateCellEditor);
$parcel$export(module.exports, "DateFilter", () => (parcelRequire("jIDNV")).DateFilter);
$parcel$export(module.exports, "DateStringCellEditor", () => (parcelRequire("jIDNV")).DateStringCellEditor);
$parcel$export(module.exports, "DisplayedGroupCreator", () => (parcelRequire("jIDNV")).DisplayedGroupCreator);
$parcel$export(module.exports, "DragAndDropService", () => (parcelRequire("jIDNV")).DragAndDropService);
$parcel$export(module.exports, "DragService", () => (parcelRequire("jIDNV")).DragService);
$parcel$export(module.exports, "DragSourceType", () => (parcelRequire("jIDNV")).DragSourceType);
$parcel$export(module.exports, "Environment", () => (parcelRequire("jIDNV")).Environment);
$parcel$export(module.exports, "EventService", () => (parcelRequire("jIDNV")).EventService);
$parcel$export(module.exports, "Events", () => (parcelRequire("jIDNV")).Events);
$parcel$export(module.exports, "ExcelFactoryMode", () => (parcelRequire("jIDNV")).ExcelFactoryMode);
$parcel$export(module.exports, "ExpansionService", () => (parcelRequire("jIDNV")).ExpansionService);
$parcel$export(module.exports, "ExpressionService", () => (parcelRequire("jIDNV")).ExpressionService);
$parcel$export(module.exports, "FilterManager", () => (parcelRequire("jIDNV")).FilterManager);
$parcel$export(module.exports, "FilterWrapperComp", () => (parcelRequire("jIDNV")).FilterWrapperComp);
$parcel$export(module.exports, "FloatingFilterMapper", () => (parcelRequire("jIDNV")).FloatingFilterMapper);
$parcel$export(module.exports, "FocusService", () => (parcelRequire("jIDNV")).FocusService);
$parcel$export(module.exports, "GROUP_AUTO_COLUMN_ID", () => (parcelRequire("jIDNV")).GROUP_AUTO_COLUMN_ID);
$parcel$export(module.exports, "Grid", () => (parcelRequire("jIDNV")).Grid);
$parcel$export(module.exports, "GridApi", () => (parcelRequire("jIDNV")).GridApi);
$parcel$export(module.exports, "GridBodyComp", () => (parcelRequire("jIDNV")).GridBodyComp);
$parcel$export(module.exports, "GridBodyCtrl", () => (parcelRequire("jIDNV")).GridBodyCtrl);
$parcel$export(module.exports, "GridComp", () => (parcelRequire("jIDNV")).GridComp);
$parcel$export(module.exports, "GridCoreCreator", () => (parcelRequire("jIDNV")).GridCoreCreator);
$parcel$export(module.exports, "GridCtrl", () => (parcelRequire("jIDNV")).GridCtrl);
$parcel$export(module.exports, "GridHeaderComp", () => (parcelRequire("jIDNV")).GridHeaderComp);
$parcel$export(module.exports, "GridHeaderCtrl", () => (parcelRequire("jIDNV")).GridHeaderCtrl);
$parcel$export(module.exports, "GridOptionsService", () => (parcelRequire("jIDNV")).GridOptionsService);
$parcel$export(module.exports, "GroupCellRenderer", () => (parcelRequire("jIDNV")).GroupCellRenderer);
$parcel$export(module.exports, "GroupCellRendererCtrl", () => (parcelRequire("jIDNV")).GroupCellRendererCtrl);
$parcel$export(module.exports, "GroupInstanceIdCreator", () => (parcelRequire("jIDNV")).GroupInstanceIdCreator);
$parcel$export(module.exports, "HeaderCellCtrl", () => (parcelRequire("jIDNV")).HeaderCellCtrl);
$parcel$export(module.exports, "HeaderFilterCellComp", () => (parcelRequire("jIDNV")).HeaderFilterCellComp);
$parcel$export(module.exports, "HeaderFilterCellCtrl", () => (parcelRequire("jIDNV")).HeaderFilterCellCtrl);
$parcel$export(module.exports, "HeaderGroupCellCtrl", () => (parcelRequire("jIDNV")).HeaderGroupCellCtrl);
$parcel$export(module.exports, "HeaderNavigationDirection", () => (parcelRequire("jIDNV")).HeaderNavigationDirection);
$parcel$export(module.exports, "HeaderNavigationService", () => (parcelRequire("jIDNV")).HeaderNavigationService);
$parcel$export(module.exports, "HeaderPositionUtils", () => (parcelRequire("jIDNV")).HeaderPositionUtils);
$parcel$export(module.exports, "HeaderRowComp", () => (parcelRequire("jIDNV")).HeaderRowComp);
$parcel$export(module.exports, "HeaderRowContainerComp", () => (parcelRequire("jIDNV")).HeaderRowContainerComp);
$parcel$export(module.exports, "HeaderRowContainerCtrl", () => (parcelRequire("jIDNV")).HeaderRowContainerCtrl);
$parcel$export(module.exports, "HeaderRowCtrl", () => (parcelRequire("jIDNV")).HeaderRowCtrl);
$parcel$export(module.exports, "HeaderRowType", () => (parcelRequire("jIDNV")).HeaderRowType);
$parcel$export(module.exports, "HorizontalDirection", () => (parcelRequire("jIDNV")).HorizontalDirection);
$parcel$export(module.exports, "HorizontalResizeService", () => (parcelRequire("jIDNV")).HorizontalResizeService);
$parcel$export(module.exports, "KeyCode", () => (parcelRequire("jIDNV")).KeyCode);
$parcel$export(module.exports, "LargeTextCellEditor", () => (parcelRequire("jIDNV")).LargeTextCellEditor);
$parcel$export(module.exports, "LayoutCssClasses", () => (parcelRequire("jIDNV")).LayoutCssClasses);
$parcel$export(module.exports, "LocaleService", () => (parcelRequire("jIDNV")).LocaleService);
$parcel$export(module.exports, "Logger", () => (parcelRequire("jIDNV")).Logger);
$parcel$export(module.exports, "LoggerFactory", () => (parcelRequire("jIDNV")).LoggerFactory);
$parcel$export(module.exports, "ManagedFocusFeature", () => (parcelRequire("jIDNV")).ManagedFocusFeature);
$parcel$export(module.exports, "MenuService", () => (parcelRequire("jIDNV")).MenuService);
$parcel$export(module.exports, "ModuleNames", () => (parcelRequire("jIDNV")).ModuleNames);
$parcel$export(module.exports, "ModuleRegistry", () => (parcelRequire("jIDNV")).ModuleRegistry);
$parcel$export(module.exports, "MouseEventService", () => (parcelRequire("jIDNV")).MouseEventService);
$parcel$export(module.exports, "MoveColumnFeature", () => (parcelRequire("jIDNV")).MoveColumnFeature);
$parcel$export(module.exports, "NavigationService", () => (parcelRequire("jIDNV")).NavigationService);
$parcel$export(module.exports, "NumberCellEditor", () => (parcelRequire("jIDNV")).NumberCellEditor);
$parcel$export(module.exports, "NumberFilter", () => (parcelRequire("jIDNV")).NumberFilter);
$parcel$export(module.exports, "NumberSequence", () => (parcelRequire("jIDNV")).NumberSequence);
$parcel$export(module.exports, "Optional", () => (parcelRequire("jIDNV")).Optional);
$parcel$export(module.exports, "PaginationProxy", () => (parcelRequire("jIDNV")).PaginationProxy);
$parcel$export(module.exports, "PillDragComp", () => (parcelRequire("jIDNV")).PillDragComp);
$parcel$export(module.exports, "PillDropZonePanel", () => (parcelRequire("jIDNV")).PillDropZonePanel);
$parcel$export(module.exports, "PinnedRowModel", () => (parcelRequire("jIDNV")).PinnedRowModel);
$parcel$export(module.exports, "PopupComponent", () => (parcelRequire("jIDNV")).PopupComponent);
$parcel$export(module.exports, "PopupEditorWrapper", () => (parcelRequire("jIDNV")).PopupEditorWrapper);
$parcel$export(module.exports, "PopupService", () => (parcelRequire("jIDNV")).PopupService);
$parcel$export(module.exports, "PositionableFeature", () => (parcelRequire("jIDNV")).PositionableFeature);
$parcel$export(module.exports, "PostConstruct", () => (parcelRequire("jIDNV")).PostConstruct);
$parcel$export(module.exports, "PreConstruct", () => (parcelRequire("jIDNV")).PreConstruct);
$parcel$export(module.exports, "PreDestroy", () => (parcelRequire("jIDNV")).PreDestroy);
$parcel$export(module.exports, "PropertyKeys", () => (parcelRequire("jIDNV")).PropertyKeys);
$parcel$export(module.exports, "ProvidedColumnGroup", () => (parcelRequire("jIDNV")).ProvidedColumnGroup);
$parcel$export(module.exports, "ProvidedFilter", () => (parcelRequire("jIDNV")).ProvidedFilter);
$parcel$export(module.exports, "Qualifier", () => (parcelRequire("jIDNV")).Qualifier);
$parcel$export(module.exports, "QuerySelector", () => (parcelRequire("jIDNV")).QuerySelector);
$parcel$export(module.exports, "RefSelector", () => (parcelRequire("jIDNV")).RefSelector);
$parcel$export(module.exports, "ResizeObserverService", () => (parcelRequire("jIDNV")).ResizeObserverService);
$parcel$export(module.exports, "RowAnimationCssClasses", () => (parcelRequire("jIDNV")).RowAnimationCssClasses);
$parcel$export(module.exports, "RowContainerComp", () => (parcelRequire("jIDNV")).RowContainerComp);
$parcel$export(module.exports, "RowContainerCtrl", () => (parcelRequire("jIDNV")).RowContainerCtrl);
$parcel$export(module.exports, "RowContainerName", () => (parcelRequire("jIDNV")).RowContainerName);
$parcel$export(module.exports, "RowContainerType", () => (parcelRequire("jIDNV")).RowContainerType);
$parcel$export(module.exports, "RowCtrl", () => (parcelRequire("jIDNV")).RowCtrl);
$parcel$export(module.exports, "RowHighlightPosition", () => (parcelRequire("jIDNV")).RowHighlightPosition);
$parcel$export(module.exports, "RowNode", () => (parcelRequire("jIDNV")).RowNode);
$parcel$export(module.exports, "RowNodeBlock", () => (parcelRequire("jIDNV")).RowNodeBlock);
$parcel$export(module.exports, "RowNodeBlockLoader", () => (parcelRequire("jIDNV")).RowNodeBlockLoader);
$parcel$export(module.exports, "RowNodeSorter", () => (parcelRequire("jIDNV")).RowNodeSorter);
$parcel$export(module.exports, "RowPositionUtils", () => (parcelRequire("jIDNV")).RowPositionUtils);
$parcel$export(module.exports, "RowRenderer", () => (parcelRequire("jIDNV")).RowRenderer);
$parcel$export(module.exports, "ScalarFilter", () => (parcelRequire("jIDNV")).ScalarFilter);
$parcel$export(module.exports, "ScrollVisibleService", () => (parcelRequire("jIDNV")).ScrollVisibleService);
$parcel$export(module.exports, "SelectCellEditor", () => (parcelRequire("jIDNV")).SelectCellEditor);
$parcel$export(module.exports, "SelectableService", () => (parcelRequire("jIDNV")).SelectableService);
$parcel$export(module.exports, "SelectionHandleType", () => (parcelRequire("jIDNV")).SelectionHandleType);
$parcel$export(module.exports, "ServerSideTransactionResultStatus", () => (parcelRequire("jIDNV")).ServerSideTransactionResultStatus);
$parcel$export(module.exports, "SetLeftFeature", () => (parcelRequire("jIDNV")).SetLeftFeature);
$parcel$export(module.exports, "SimpleFilter", () => (parcelRequire("jIDNV")).SimpleFilter);
$parcel$export(module.exports, "SortController", () => (parcelRequire("jIDNV")).SortController);
$parcel$export(module.exports, "SortIndicatorComp", () => (parcelRequire("jIDNV")).SortIndicatorComp);
$parcel$export(module.exports, "StandardMenuFactory", () => (parcelRequire("jIDNV")).StandardMenuFactory);
$parcel$export(module.exports, "StylingService", () => (parcelRequire("jIDNV")).StylingService);
$parcel$export(module.exports, "TabGuardClassNames", () => (parcelRequire("jIDNV")).TabGuardClassNames);
$parcel$export(module.exports, "TabGuardComp", () => (parcelRequire("jIDNV")).TabGuardComp);
$parcel$export(module.exports, "TabGuardCtrl", () => (parcelRequire("jIDNV")).TabGuardCtrl);
$parcel$export(module.exports, "TabbedLayout", () => (parcelRequire("jIDNV")).TabbedLayout);
$parcel$export(module.exports, "TextCellEditor", () => (parcelRequire("jIDNV")).TextCellEditor);
$parcel$export(module.exports, "TextFilter", () => (parcelRequire("jIDNV")).TextFilter);
$parcel$export(module.exports, "TextFloatingFilter", () => (parcelRequire("jIDNV")).TextFloatingFilter);
$parcel$export(module.exports, "Timer", () => (parcelRequire("jIDNV")).Timer);
$parcel$export(module.exports, "TooltipFeature", () => (parcelRequire("jIDNV")).TooltipFeature);
$parcel$export(module.exports, "TooltipStateManager", () => (parcelRequire("jIDNV")).TooltipStateManager);
$parcel$export(module.exports, "TouchListener", () => (parcelRequire("jIDNV")).TouchListener);
$parcel$export(module.exports, "UserComponentFactory", () => (parcelRequire("jIDNV")).UserComponentFactory);
$parcel$export(module.exports, "UserComponentRegistry", () => (parcelRequire("jIDNV")).UserComponentRegistry);
$parcel$export(module.exports, "ValueCache", () => (parcelRequire("jIDNV")).ValueCache);
$parcel$export(module.exports, "ValueService", () => (parcelRequire("jIDNV")).ValueService);
$parcel$export(module.exports, "VanillaFrameworkOverrides", () => (parcelRequire("jIDNV")).VanillaFrameworkOverrides);
$parcel$export(module.exports, "VerticalDirection", () => (parcelRequire("jIDNV")).VerticalDirection);
$parcel$export(module.exports, "VirtualList", () => (parcelRequire("jIDNV")).VirtualList);
$parcel$export(module.exports, "VirtualListDragFeature", () => (parcelRequire("jIDNV")).VirtualListDragFeature);
$parcel$export(module.exports, "_", () => (parcelRequire("jIDNV"))._);
$parcel$export(module.exports, "createGrid", () => (parcelRequire("jIDNV")).createGrid);
$parcel$export(module.exports, "getRowContainerTypeForName", () => (parcelRequire("jIDNV")).getRowContainerTypeForName);
$parcel$export(module.exports, "provideGlobalGridOptions", () => (parcelRequire("jIDNV")).provideGlobalGridOptions);

var $jIDNV = parcelRequire("jIDNV");

var $iTJTu = parcelRequire("iTJTu");
var $5b7ccabde48fae90$var$__defProp = Object.defineProperty;
var $5b7ccabde48fae90$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $5b7ccabde48fae90$var$__getOwnPropNames = Object.getOwnPropertyNames;
var $5b7ccabde48fae90$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $5b7ccabde48fae90$var$__export = (target, all)=>{
    for(var name in all)$5b7ccabde48fae90$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $5b7ccabde48fae90$var$__copyProps = (to, from, except, desc)=>{
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of $5b7ccabde48fae90$var$__getOwnPropNames(from))if (!$5b7ccabde48fae90$var$__hasOwnProp.call(to, key) && key !== except) $5b7ccabde48fae90$var$__defProp(to, key, {
            get: ()=>from[key],
            enumerable: !(desc = $5b7ccabde48fae90$var$__getOwnPropDesc(from, key)) || desc.enumerable
        });
    }
    return to;
};
var $5b7ccabde48fae90$var$__reExport = (target, mod, secondTarget)=>($5b7ccabde48fae90$var$__copyProps(target, mod, "default"), secondTarget && $5b7ccabde48fae90$var$__copyProps(secondTarget, mod, "default"));
var $5b7ccabde48fae90$var$__decorateClass = (decorators, target, key, kind)=>{
    var result = kind > 1 ? void 0 : kind ? $5b7ccabde48fae90$var$__getOwnPropDesc(target, key) : target;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
    if (kind && result) $5b7ccabde48fae90$var$__defProp(target, key, result);
    return result;
};
// packages/ag-grid-enterprise/src/main.ts
var $5b7ccabde48fae90$var$main_exports = {};
$5b7ccabde48fae90$var$__export($5b7ccabde48fae90$var$main_exports, {
    ALWAYS_SYNC_GLOBAL_EVENTS: ()=>(0, $jIDNV.ALWAYS_SYNC_GLOBAL_EVENTS),
    AbstractHeaderCellCtrl: ()=>(0, $jIDNV.AbstractHeaderCellCtrl),
    AdvancedFilterModule: ()=>$5b7ccabde48fae90$export$5f40a5e44930bd02,
    AgAbstractField: ()=>(0, $jIDNV.AgAbstractField),
    AgAbstractLabel: ()=>(0, $jIDNV.AgAbstractLabel),
    AgAutocomplete: ()=>(0, $jIDNV.AgAutocomplete),
    AgCheckbox: ()=>(0, $jIDNV.AgCheckbox),
    AgDialog: ()=>(0, $jIDNV.AgDialog),
    AgGroupComponent: ()=>(0, $jIDNV.AgGroupComponent),
    AgInputDateField: ()=>(0, $jIDNV.AgInputDateField),
    AgInputNumberField: ()=>(0, $jIDNV.AgInputNumberField),
    AgInputRange: ()=>(0, $jIDNV.AgInputRange),
    AgInputTextArea: ()=>(0, $jIDNV.AgInputTextArea),
    AgInputTextField: ()=>(0, $jIDNV.AgInputTextField),
    AgMenuItemComponent: ()=>(0, $jIDNV.AgMenuItemComponent),
    AgMenuItemRenderer: ()=>(0, $jIDNV.AgMenuItemRenderer),
    AgMenuList: ()=>(0, $jIDNV.AgMenuList),
    AgMenuPanel: ()=>(0, $jIDNV.AgMenuPanel),
    AgPanel: ()=>(0, $jIDNV.AgPanel),
    AgPickerField: ()=>(0, $jIDNV.AgPickerField),
    AgPromise: ()=>(0, $jIDNV.AgPromise),
    AgPromiseStatus: ()=>(0, $jIDNV.AgPromiseStatus),
    AgRadioButton: ()=>(0, $jIDNV.AgRadioButton),
    AgRichSelect: ()=>(0, $jIDNV.AgRichSelect),
    AgSelect: ()=>(0, $jIDNV.AgSelect),
    AgSlider: ()=>(0, $jIDNV.AgSlider),
    AgStackComponentsRegistry: ()=>(0, $jIDNV.AgStackComponentsRegistry),
    AgToggleButton: ()=>(0, $jIDNV.AgToggleButton),
    AlignedGridsService: ()=>(0, $jIDNV.AlignedGridsService),
    AnimateShowChangeCellRenderer: ()=>(0, $jIDNV.AnimateShowChangeCellRenderer),
    AnimateSlideCellRenderer: ()=>(0, $jIDNV.AnimateSlideCellRenderer),
    AnimationFrameService: ()=>(0, $jIDNV.AnimationFrameService),
    AutoScrollService: ()=>(0, $jIDNV.AutoScrollService),
    AutoWidthCalculator: ()=>(0, $jIDNV.AutoWidthCalculator),
    Autowired: ()=>(0, $jIDNV.Autowired),
    BarColumnLabelPlacement: ()=>(0, $jIDNV.BarColumnLabelPlacement),
    BaseComponentWrapper: ()=>(0, $jIDNV.BaseComponentWrapper),
    Bean: ()=>(0, $jIDNV.Bean),
    BeanStub: ()=>(0, $jIDNV.BeanStub),
    Beans: ()=>(0, $jIDNV.Beans),
    BodyDropPivotTarget: ()=>(0, $jIDNV.BodyDropPivotTarget),
    BodyDropTarget: ()=>(0, $jIDNV.BodyDropTarget),
    CellComp: ()=>(0, $jIDNV.CellComp),
    CellCtrl: ()=>(0, $jIDNV.CellCtrl),
    CellNavigationService: ()=>(0, $jIDNV.CellNavigationService),
    CellPositionUtils: ()=>(0, $jIDNV.CellPositionUtils),
    CellRangeType: ()=>(0, $jIDNV.CellRangeType),
    ChangedPath: ()=>(0, $jIDNV.ChangedPath),
    ChartMappings: ()=>(0, $jIDNV.ChartMappings),
    CheckboxCellEditor: ()=>(0, $jIDNV.CheckboxCellEditor),
    CheckboxCellRenderer: ()=>(0, $jIDNV.CheckboxCellRenderer),
    CheckboxSelectionComponent: ()=>(0, $jIDNV.CheckboxSelectionComponent),
    ClientSideRowModelSteps: ()=>(0, $jIDNV.ClientSideRowModelSteps),
    ClipboardModule: ()=>$5b7ccabde48fae90$export$3a36bd45ca02edda,
    Column: ()=>(0, $jIDNV.Column),
    ColumnApi: ()=>(0, $jIDNV.ColumnApi),
    ColumnFactory: ()=>(0, $jIDNV.ColumnFactory),
    ColumnGroup: ()=>(0, $jIDNV.ColumnGroup),
    ColumnKeyCreator: ()=>(0, $jIDNV.ColumnKeyCreator),
    ColumnModel: ()=>(0, $jIDNV.ColumnModel),
    ColumnsToolPanelModule: ()=>$5b7ccabde48fae90$export$8ff0dc87b3f8200e,
    Component: ()=>(0, $jIDNV.Component),
    ComponentUtil: ()=>(0, $jIDNV.ComponentUtil),
    Context: ()=>(0, $jIDNV.Context),
    CssClassApplier: ()=>(0, $jIDNV.CssClassApplier),
    CssClassManager: ()=>(0, $jIDNV.CssClassManager),
    CtrlsService: ()=>(0, $jIDNV.CtrlsService),
    DataTypeService: ()=>(0, $jIDNV.DataTypeService),
    DateCellEditor: ()=>(0, $jIDNV.DateCellEditor),
    DateFilter: ()=>(0, $jIDNV.DateFilter),
    DateStringCellEditor: ()=>(0, $jIDNV.DateStringCellEditor),
    DisplayedGroupCreator: ()=>(0, $jIDNV.DisplayedGroupCreator),
    DragAndDropService: ()=>(0, $jIDNV.DragAndDropService),
    DragService: ()=>(0, $jIDNV.DragService),
    DragSourceType: ()=>(0, $jIDNV.DragSourceType),
    EnterpriseCoreModule: ()=>$5b7ccabde48fae90$export$3a6d13add8617801,
    Environment: ()=>(0, $jIDNV.Environment),
    EventService: ()=>(0, $jIDNV.EventService),
    Events: ()=>(0, $jIDNV.Events),
    ExcelExportModule: ()=>$5b7ccabde48fae90$export$98f0c53ca0379def,
    ExcelFactoryMode: ()=>(0, $jIDNV.ExcelFactoryMode),
    ExpansionService: ()=>(0, $jIDNV.ExpansionService),
    ExpressionService: ()=>(0, $jIDNV.ExpressionService),
    FilterManager: ()=>(0, $jIDNV.FilterManager),
    FilterWrapperComp: ()=>(0, $jIDNV.FilterWrapperComp),
    FiltersToolPanelModule: ()=>$5b7ccabde48fae90$export$783953a68616c0a2,
    FloatingFilterMapper: ()=>(0, $jIDNV.FloatingFilterMapper),
    FocusService: ()=>(0, $jIDNV.FocusService),
    GROUP_AUTO_COLUMN_ID: ()=>(0, $jIDNV.GROUP_AUTO_COLUMN_ID),
    Grid: ()=>(0, $jIDNV.Grid),
    GridApi: ()=>(0, $jIDNV.GridApi),
    GridBodyComp: ()=>(0, $jIDNV.GridBodyComp),
    GridBodyCtrl: ()=>(0, $jIDNV.GridBodyCtrl),
    GridChartsModule: ()=>$5b7ccabde48fae90$export$6248c9e5743f8c49,
    GridComp: ()=>(0, $jIDNV.GridComp),
    GridCoreCreator: ()=>(0, $jIDNV.GridCoreCreator),
    GridCtrl: ()=>(0, $jIDNV.GridCtrl),
    GridHeaderComp: ()=>(0, $jIDNV.GridHeaderComp),
    GridHeaderCtrl: ()=>(0, $jIDNV.GridHeaderCtrl),
    GridOptionsService: ()=>(0, $jIDNV.GridOptionsService),
    GroupCellRenderer: ()=>(0, $jIDNV.GroupCellRenderer),
    GroupCellRendererCtrl: ()=>(0, $jIDNV.GroupCellRendererCtrl),
    GroupInstanceIdCreator: ()=>(0, $jIDNV.GroupInstanceIdCreator),
    HeaderCellCtrl: ()=>(0, $jIDNV.HeaderCellCtrl),
    HeaderFilterCellComp: ()=>(0, $jIDNV.HeaderFilterCellComp),
    HeaderFilterCellCtrl: ()=>(0, $jIDNV.HeaderFilterCellCtrl),
    HeaderGroupCellCtrl: ()=>(0, $jIDNV.HeaderGroupCellCtrl),
    HeaderNavigationDirection: ()=>(0, $jIDNV.HeaderNavigationDirection),
    HeaderNavigationService: ()=>(0, $jIDNV.HeaderNavigationService),
    HeaderPositionUtils: ()=>(0, $jIDNV.HeaderPositionUtils),
    HeaderRowComp: ()=>(0, $jIDNV.HeaderRowComp),
    HeaderRowContainerComp: ()=>(0, $jIDNV.HeaderRowContainerComp),
    HeaderRowContainerCtrl: ()=>(0, $jIDNV.HeaderRowContainerCtrl),
    HeaderRowCtrl: ()=>(0, $jIDNV.HeaderRowCtrl),
    HeaderRowType: ()=>(0, $jIDNV.HeaderRowType),
    HorizontalDirection: ()=>(0, $jIDNV.HorizontalDirection),
    HorizontalResizeService: ()=>(0, $jIDNV.HorizontalResizeService),
    KeyCode: ()=>(0, $jIDNV.KeyCode),
    LargeTextCellEditor: ()=>(0, $jIDNV.LargeTextCellEditor),
    LayoutCssClasses: ()=>(0, $jIDNV.LayoutCssClasses),
    LicenseManager: ()=>$5b7ccabde48fae90$export$91e2bbffdbb3852c,
    LocaleService: ()=>(0, $jIDNV.LocaleService),
    Logger: ()=>(0, $jIDNV.Logger),
    LoggerFactory: ()=>(0, $jIDNV.LoggerFactory),
    ManagedFocusFeature: ()=>(0, $jIDNV.ManagedFocusFeature),
    MasterDetailModule: ()=>$5b7ccabde48fae90$export$656cedc46227f6d2,
    MenuModule: ()=>$5b7ccabde48fae90$export$f1ab43fc4c3c5ce0,
    MenuService: ()=>(0, $jIDNV.MenuService),
    ModuleNames: ()=>(0, $jIDNV.ModuleNames),
    ModuleRegistry: ()=>(0, $jIDNV.ModuleRegistry),
    MouseEventService: ()=>(0, $jIDNV.MouseEventService),
    MoveColumnFeature: ()=>(0, $jIDNV.MoveColumnFeature),
    MultiFilter: ()=>$5b7ccabde48fae90$export$ab0841fc22e16fa3,
    MultiFilterModule: ()=>$5b7ccabde48fae90$export$8897e17f4dd9d13a,
    NavigationService: ()=>(0, $jIDNV.NavigationService),
    NumberCellEditor: ()=>(0, $jIDNV.NumberCellEditor),
    NumberFilter: ()=>(0, $jIDNV.NumberFilter),
    NumberSequence: ()=>(0, $jIDNV.NumberSequence),
    Optional: ()=>(0, $jIDNV.Optional),
    PaginationProxy: ()=>(0, $jIDNV.PaginationProxy),
    PillDragComp: ()=>(0, $jIDNV.PillDragComp),
    PillDropZonePanel: ()=>(0, $jIDNV.PillDropZonePanel),
    PinnedRowModel: ()=>(0, $jIDNV.PinnedRowModel),
    PivotDropZonePanel: ()=>$5b7ccabde48fae90$export$e3a33a41cac287e,
    PopupComponent: ()=>(0, $jIDNV.PopupComponent),
    PopupEditorWrapper: ()=>(0, $jIDNV.PopupEditorWrapper),
    PopupService: ()=>(0, $jIDNV.PopupService),
    PositionableFeature: ()=>(0, $jIDNV.PositionableFeature),
    PostConstruct: ()=>(0, $jIDNV.PostConstruct),
    PreConstruct: ()=>(0, $jIDNV.PreConstruct),
    PreDestroy: ()=>(0, $jIDNV.PreDestroy),
    PrimaryColsPanel: ()=>$5b7ccabde48fae90$export$2d9d69c2ece71d89,
    PropertyKeys: ()=>(0, $jIDNV.PropertyKeys),
    ProvidedColumnGroup: ()=>(0, $jIDNV.ProvidedColumnGroup),
    ProvidedFilter: ()=>(0, $jIDNV.ProvidedFilter),
    Qualifier: ()=>(0, $jIDNV.Qualifier),
    QuerySelector: ()=>(0, $jIDNV.QuerySelector),
    RangeSelectionModule: ()=>$5b7ccabde48fae90$export$5e5c8269d4d7ed2e,
    RefSelector: ()=>(0, $jIDNV.RefSelector),
    ResizeObserverService: ()=>(0, $jIDNV.ResizeObserverService),
    RichSelectModule: ()=>$5b7ccabde48fae90$export$9bd93207561bb9c,
    RowAnimationCssClasses: ()=>(0, $jIDNV.RowAnimationCssClasses),
    RowContainerComp: ()=>(0, $jIDNV.RowContainerComp),
    RowContainerCtrl: ()=>(0, $jIDNV.RowContainerCtrl),
    RowContainerName: ()=>(0, $jIDNV.RowContainerName),
    RowContainerType: ()=>(0, $jIDNV.RowContainerType),
    RowCtrl: ()=>(0, $jIDNV.RowCtrl),
    RowGroupDropZonePanel: ()=>$5b7ccabde48fae90$export$f3b209e86f7a7963,
    RowGroupingModule: ()=>$5b7ccabde48fae90$export$e67935bd41653107,
    RowHighlightPosition: ()=>(0, $jIDNV.RowHighlightPosition),
    RowNode: ()=>(0, $jIDNV.RowNode),
    RowNodeBlock: ()=>(0, $jIDNV.RowNodeBlock),
    RowNodeBlockLoader: ()=>(0, $jIDNV.RowNodeBlockLoader),
    RowNodeSorter: ()=>(0, $jIDNV.RowNodeSorter),
    RowPositionUtils: ()=>(0, $jIDNV.RowPositionUtils),
    RowRenderer: ()=>(0, $jIDNV.RowRenderer),
    ScalarFilter: ()=>(0, $jIDNV.ScalarFilter),
    ScrollVisibleService: ()=>(0, $jIDNV.ScrollVisibleService),
    SelectCellEditor: ()=>(0, $jIDNV.SelectCellEditor),
    SelectableService: ()=>(0, $jIDNV.SelectableService),
    SelectionHandleType: ()=>(0, $jIDNV.SelectionHandleType),
    ServerSideRowModelModule: ()=>$5b7ccabde48fae90$export$5c0e9f044c5e2dce,
    ServerSideTransactionResultStatus: ()=>(0, $jIDNV.ServerSideTransactionResultStatus),
    SetFilter: ()=>$5b7ccabde48fae90$export$7b7af8300a3a9e84,
    SetFilterModule: ()=>$5b7ccabde48fae90$export$4ab172eba3fdda9e,
    SetLeftFeature: ()=>(0, $jIDNV.SetLeftFeature),
    SideBarModule: ()=>$5b7ccabde48fae90$export$707a9bd30915b7fe,
    SimpleFilter: ()=>(0, $jIDNV.SimpleFilter),
    SortController: ()=>(0, $jIDNV.SortController),
    SortIndicatorComp: ()=>(0, $jIDNV.SortIndicatorComp),
    SparklinesModule: ()=>$5b7ccabde48fae90$export$4e5a2f3bfb2b8795,
    StandardMenuFactory: ()=>(0, $jIDNV.StandardMenuFactory),
    StatusBarModule: ()=>$5b7ccabde48fae90$export$76a316c8c2f3bc28,
    StylingService: ()=>(0, $jIDNV.StylingService),
    TabGuardClassNames: ()=>(0, $jIDNV.TabGuardClassNames),
    TabGuardComp: ()=>(0, $jIDNV.TabGuardComp),
    TabGuardCtrl: ()=>(0, $jIDNV.TabGuardCtrl),
    TabbedLayout: ()=>(0, $jIDNV.TabbedLayout),
    TextCellEditor: ()=>(0, $jIDNV.TextCellEditor),
    TextFilter: ()=>(0, $jIDNV.TextFilter),
    TextFloatingFilter: ()=>(0, $jIDNV.TextFloatingFilter),
    Timer: ()=>(0, $jIDNV.Timer),
    ToolPanelColDefService: ()=>$5b7ccabde48fae90$export$52f8319e10930bfa,
    TooltipFeature: ()=>(0, $jIDNV.TooltipFeature),
    TooltipStateManager: ()=>(0, $jIDNV.TooltipStateManager),
    TouchListener: ()=>(0, $jIDNV.TouchListener),
    UserComponentFactory: ()=>(0, $jIDNV.UserComponentFactory),
    UserComponentRegistry: ()=>(0, $jIDNV.UserComponentRegistry),
    ValueCache: ()=>(0, $jIDNV.ValueCache),
    ValueService: ()=>(0, $jIDNV.ValueService),
    ValuesDropZonePanel: ()=>$5b7ccabde48fae90$export$4c5515da8ced3ad7,
    VanillaFrameworkOverrides: ()=>(0, $jIDNV.VanillaFrameworkOverrides),
    VerticalDirection: ()=>(0, $jIDNV.VerticalDirection),
    ViewportRowModelModule: ()=>$5b7ccabde48fae90$export$5afa3276c0fcf76,
    VirtualList: ()=>(0, $jIDNV.VirtualList),
    VirtualListDragFeature: ()=>(0, $jIDNV.VirtualListDragFeature),
    _: ()=>(0, $jIDNV._),
    __FORCE_MODULE_DETECTION_AG_GRID_CORE_EXT: ()=>$5b7ccabde48fae90$export$2d0cf3225e55a3e,
    agCharts: ()=>$5b7ccabde48fae90$export$8a8f7e9aca311bdd,
    createGrid: ()=>(0, $jIDNV.createGrid),
    exportMultipleSheetsAsExcel: ()=>$5b7ccabde48fae90$export$e871bbb2307806ee,
    getMultipleSheetsAsExcel: ()=>$5b7ccabde48fae90$export$cdca9ad0c864c7f0,
    getRowContainerTypeForName: ()=>(0, $jIDNV.getRowContainerTypeForName),
    provideGlobalGridOptions: ()=>(0, $jIDNV.provideGlobalGridOptions)
});
// enterprise-modules/core/src/license/shared/md5.ts
var $5b7ccabde48fae90$var$MD5 = class {
    constructor(){
        this.ieCompatibility = false;
    }
    init() {
        this.ieCompatibility = this.md5("hello") != "5d41402abc4b2a76b9719d911017c592";
    }
    md5cycle(x, k) {
        let a = x[0], b = x[1], c = x[2], d = x[3];
        a = this.ff(a, b, c, d, k[0], 7, -680876936);
        d = this.ff(d, a, b, c, k[1], 12, -389564586);
        c = this.ff(c, d, a, b, k[2], 17, 606105819);
        b = this.ff(b, c, d, a, k[3], 22, -1044525330);
        a = this.ff(a, b, c, d, k[4], 7, -176418897);
        d = this.ff(d, a, b, c, k[5], 12, 1200080426);
        c = this.ff(c, d, a, b, k[6], 17, -1473231341);
        b = this.ff(b, c, d, a, k[7], 22, -45705983);
        a = this.ff(a, b, c, d, k[8], 7, 1770035416);
        d = this.ff(d, a, b, c, k[9], 12, -1958414417);
        c = this.ff(c, d, a, b, k[10], 17, -42063);
        b = this.ff(b, c, d, a, k[11], 22, -1990404162);
        a = this.ff(a, b, c, d, k[12], 7, 1804603682);
        d = this.ff(d, a, b, c, k[13], 12, -40341101);
        c = this.ff(c, d, a, b, k[14], 17, -1502002290);
        b = this.ff(b, c, d, a, k[15], 22, 1236535329);
        a = this.gg(a, b, c, d, k[1], 5, -165796510);
        d = this.gg(d, a, b, c, k[6], 9, -1069501632);
        c = this.gg(c, d, a, b, k[11], 14, 643717713);
        b = this.gg(b, c, d, a, k[0], 20, -373897302);
        a = this.gg(a, b, c, d, k[5], 5, -701558691);
        d = this.gg(d, a, b, c, k[10], 9, 38016083);
        c = this.gg(c, d, a, b, k[15], 14, -660478335);
        b = this.gg(b, c, d, a, k[4], 20, -405537848);
        a = this.gg(a, b, c, d, k[9], 5, 568446438);
        d = this.gg(d, a, b, c, k[14], 9, -1019803690);
        c = this.gg(c, d, a, b, k[3], 14, -187363961);
        b = this.gg(b, c, d, a, k[8], 20, 1163531501);
        a = this.gg(a, b, c, d, k[13], 5, -1444681467);
        d = this.gg(d, a, b, c, k[2], 9, -51403784);
        c = this.gg(c, d, a, b, k[7], 14, 1735328473);
        b = this.gg(b, c, d, a, k[12], 20, -1926607734);
        a = this.hh(a, b, c, d, k[5], 4, -378558);
        d = this.hh(d, a, b, c, k[8], 11, -2022574463);
        c = this.hh(c, d, a, b, k[11], 16, 1839030562);
        b = this.hh(b, c, d, a, k[14], 23, -35309556);
        a = this.hh(a, b, c, d, k[1], 4, -1530992060);
        d = this.hh(d, a, b, c, k[4], 11, 1272893353);
        c = this.hh(c, d, a, b, k[7], 16, -155497632);
        b = this.hh(b, c, d, a, k[10], 23, -1094730640);
        a = this.hh(a, b, c, d, k[13], 4, 681279174);
        d = this.hh(d, a, b, c, k[0], 11, -358537222);
        c = this.hh(c, d, a, b, k[3], 16, -722521979);
        b = this.hh(b, c, d, a, k[6], 23, 76029189);
        a = this.hh(a, b, c, d, k[9], 4, -640364487);
        d = this.hh(d, a, b, c, k[12], 11, -421815835);
        c = this.hh(c, d, a, b, k[15], 16, 530742520);
        b = this.hh(b, c, d, a, k[2], 23, -995338651);
        a = this.ii(a, b, c, d, k[0], 6, -198630844);
        d = this.ii(d, a, b, c, k[7], 10, 1126891415);
        c = this.ii(c, d, a, b, k[14], 15, -1416354905);
        b = this.ii(b, c, d, a, k[5], 21, -57434055);
        a = this.ii(a, b, c, d, k[12], 6, 1700485571);
        d = this.ii(d, a, b, c, k[3], 10, -1894986606);
        c = this.ii(c, d, a, b, k[10], 15, -1051523);
        b = this.ii(b, c, d, a, k[1], 21, -2054922799);
        a = this.ii(a, b, c, d, k[8], 6, 1873313359);
        d = this.ii(d, a, b, c, k[15], 10, -30611744);
        c = this.ii(c, d, a, b, k[6], 15, -1560198380);
        b = this.ii(b, c, d, a, k[13], 21, 1309151649);
        a = this.ii(a, b, c, d, k[4], 6, -145523070);
        d = this.ii(d, a, b, c, k[11], 10, -1120210379);
        c = this.ii(c, d, a, b, k[2], 15, 718787259);
        b = this.ii(b, c, d, a, k[9], 21, -343485551);
        x[0] = this.add32(a, x[0]);
        x[1] = this.add32(b, x[1]);
        x[2] = this.add32(c, x[2]);
        x[3] = this.add32(d, x[3]);
    }
    cmn(q, a, b, x, s, t) {
        a = this.add32(this.add32(a, q), this.add32(x, t));
        return this.add32(a << s | a >>> 32 - s, b);
    }
    ff(a, b, c, d, x, s, t) {
        return this.cmn(b & c | ~b & d, a, b, x, s, t);
    }
    gg(a, b, c, d, x, s, t) {
        return this.cmn(b & d | c & ~d, a, b, x, s, t);
    }
    hh(a, b, c, d, x, s, t) {
        return this.cmn(b ^ c ^ d, a, b, x, s, t);
    }
    ii(a, b, c, d, x, s, t) {
        return this.cmn(c ^ (b | ~d), a, b, x, s, t);
    }
    md51(s) {
        const n = s.length;
        const state = [
            1732584193,
            -271733879,
            -1732584194,
            271733878
        ];
        let i;
        for(i = 64; i <= s.length; i += 64)this.md5cycle(state, this.md5blk(s.substring(i - 64, i)));
        s = s.substring(i - 64);
        const tail = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        for(i = 0; i < s.length; i++)tail[i >> 2] |= s.charCodeAt(i) << (i % 4 << 3);
        tail[i >> 2] |= 128 << (i % 4 << 3);
        if (i > 55) {
            this.md5cycle(state, tail);
            for(i = 0; i < 16; i++)tail[i] = 0;
        }
        tail[14] = n * 8;
        this.md5cycle(state, tail);
        return state;
    }
    /* there needs to be support for Unicode here, * unless we pretend that we can redefine the MD-5
   * algorithm for multi-byte characters (perhaps by adding every four 16-bit characters and
   * shortening the sum to 32 bits). Otherwise I suthis.ggest performing MD-5 as if every character
   * was two bytes--e.g., 0040 0025 = @%--but then how will an ordinary MD-5 sum be matched?
   * There is no way to standardize text to something like UTF-8 before transformation; speed cost is
   * utterly prohibitive. The JavaScript standard itself needs to look at this: it should start
   * providing access to strings as preformed UTF-8 8-bit unsigned value arrays.
   */ md5blk(s) {
        const md5blks = [];
        for(let i = 0; i < 64; i += 4)md5blks[i >> 2] = s.charCodeAt(i) + (s.charCodeAt(i + 1) << 8) + (s.charCodeAt(i + 2) << 16) + (s.charCodeAt(i + 3) << 24);
        return md5blks;
    }
    rhex(n) {
        const hex_chr = "0123456789abcdef".split("");
        let s = "", j = 0;
        for(; j < 4; j++)s += hex_chr[n >> j * 8 + 4 & 15] + hex_chr[n >> j * 8 & 15];
        return s;
    }
    hex(x) {
        for(let i = 0; i < x.length; i++)x[i] = this.rhex(x[i]);
        return x.join("");
    }
    md5(s) {
        return this.hex(this.md51(s));
    }
    add32(a, b) {
        return this.ieCompatibility ? this.add32Compat(a, b) : this.add32Std(a, b);
    }
    /* this function is much faster, so if possible we use it. Some IEs are the only ones I know of that
   need the idiotic second function, generated by an if clause.  */ add32Std(a, b) {
        return a + b & 4294967295;
    }
    add32Compat(x, y) {
        const lsw = (x & 65535) + (y & 65535), msw = (x >> 16) + (y >> 16) + (lsw >> 16);
        return msw << 16 | lsw & 65535;
    }
};
// enterprise-modules/core/src/license/shared/licenseManager.ts
function $5b7ccabde48fae90$var$missingOrEmpty(value) {
    return value == null || value.length === 0;
}
var $5b7ccabde48fae90$var$LICENSE_TYPES = {
    "01": "GRID",
    "02": "CHARTS",
    "0102": "BOTH"
};
var $5b7ccabde48fae90$var$_LicenseManager = class _LicenseManager {
    constructor(document2){
        this.watermarkMessage = void 0;
        this.totalMessageLength = 124;
        this.document = document2;
        this.md5 = new $5b7ccabde48fae90$var$MD5();
        this.md5.init();
    }
    validateLicense() {
        const licenseDetails = this.getLicenseDetails(_LicenseManager.licenseKey);
        const currentLicenseName = `AG Grid ${licenseDetails.currentLicenseType === "BOTH" ? "and AG Charts " : ""}Enterprise`;
        const suppliedLicenseName = licenseDetails.suppliedLicenseType === void 0 ? "" : `AG ${licenseDetails.suppliedLicenseType === "BOTH" ? "Grid and AG Charts" : licenseDetails.suppliedLicenseType === "GRID" ? "Grid" : "Charts"} Enterprise`;
        if (licenseDetails.missing) {
            if (!this.isWebsiteUrl() || this.isForceWatermark()) this.outputMissingLicenseKey(currentLicenseName);
        } else if (licenseDetails.expired) {
            const gridReleaseDate = _LicenseManager.getGridReleaseDate();
            const formattedReleaseDate = _LicenseManager.formatDate(gridReleaseDate);
            this.outputExpiredKey(licenseDetails.expiry, formattedReleaseDate, currentLicenseName, suppliedLicenseName);
        } else if (!licenseDetails.valid) this.outputInvalidLicenseKey(!!licenseDetails.incorrectLicenseType, currentLicenseName, suppliedLicenseName);
        else if (licenseDetails.isTrial && licenseDetails.trialExpired) this.outputExpiredTrialKey(licenseDetails.expiry, currentLicenseName, suppliedLicenseName);
    }
    static extractExpiry(license) {
        const restrictionHashed = license.substring(license.lastIndexOf("_") + 1, license.length);
        return new Date(parseInt(_LicenseManager.decode(restrictionHashed), 10));
    }
    static extractLicenseComponents(licenseKey) {
        let cleanedLicenseKey = licenseKey.replace(/[\u200B-\u200D\uFEFF]/g, "");
        cleanedLicenseKey = cleanedLicenseKey.replace(/\r?\n|\r/g, "");
        if (licenseKey.length <= 32) return {
            md5: null,
            license: licenseKey,
            version: null,
            isTrial: null
        };
        const hashStart = cleanedLicenseKey.length - 32;
        const md5 = cleanedLicenseKey.substring(hashStart);
        const license = cleanedLicenseKey.substring(0, hashStart);
        const [version, isTrial, type] = _LicenseManager.extractBracketedInformation(cleanedLicenseKey);
        return {
            md5: md5,
            license: license,
            version: version,
            isTrial: isTrial,
            type: type
        };
    }
    getLicenseDetails(licenseKey) {
        const currentLicenseType = _LicenseManager.chartsLicenseManager ? "BOTH" : "GRID";
        if ($5b7ccabde48fae90$var$missingOrEmpty(licenseKey)) return {
            licenseKey: licenseKey,
            valid: false,
            missing: true,
            currentLicenseType: currentLicenseType
        };
        const gridReleaseDate = _LicenseManager.getGridReleaseDate();
        const { md5: md5, license: license, version: version, isTrial: isTrial, type: type } = _LicenseManager.extractLicenseComponents(licenseKey);
        let valid = md5 === this.md5.md5(license) && licenseKey.indexOf("For_Trialing_ag-Grid_Only") === -1;
        let trialExpired = void 0;
        let expired = void 0;
        let expiry = null;
        let incorrectLicenseType = false;
        let suppliedLicenseType = void 0;
        function handleTrial() {
            const now = /* @__PURE__ */ new Date();
            trialExpired = expiry < now;
            expired = void 0;
        }
        if (valid) {
            expiry = _LicenseManager.extractExpiry(license);
            valid = !isNaN(expiry.getTime());
            if (valid) {
                expired = gridReleaseDate > expiry;
                switch(version){
                    case "legacy":
                    case "2":
                        if (isTrial) handleTrial();
                        break;
                    case "3":
                        if ($5b7ccabde48fae90$var$missingOrEmpty(type)) valid = false;
                        else {
                            suppliedLicenseType = type;
                            if (type !== $5b7ccabde48fae90$var$LICENSE_TYPES["01"] && type !== $5b7ccabde48fae90$var$LICENSE_TYPES["0102"] || currentLicenseType === "BOTH" && suppliedLicenseType !== "BOTH") {
                                valid = false;
                                incorrectLicenseType = true;
                            } else if (isTrial) handleTrial();
                        }
                }
            }
        }
        if (!valid) return {
            licenseKey: licenseKey,
            valid: valid,
            incorrectLicenseType: incorrectLicenseType,
            currentLicenseType: currentLicenseType,
            suppliedLicenseType: suppliedLicenseType
        };
        return {
            licenseKey: licenseKey,
            valid: valid,
            expiry: _LicenseManager.formatDate(expiry),
            expired: expired,
            version: version,
            isTrial: isTrial,
            trialExpired: trialExpired,
            incorrectLicenseType: incorrectLicenseType,
            currentLicenseType: currentLicenseType,
            suppliedLicenseType: suppliedLicenseType
        };
    }
    isDisplayWatermark() {
        return this.isForceWatermark() || !this.isLocalhost() && !this.isWebsiteUrl() && !$5b7ccabde48fae90$var$missingOrEmpty(this.watermarkMessage);
    }
    getWatermarkMessage() {
        return this.watermarkMessage || "";
    }
    getHostname() {
        const win = this.document.defaultView || window;
        const loc = win.location;
        const { hostname: hostname = "" } = loc;
        return hostname;
    }
    isForceWatermark() {
        const win = this.document.defaultView || window;
        const loc = win.location;
        const { pathname: pathname } = loc;
        return pathname ? pathname.indexOf("forceWatermark") !== -1 : false;
    }
    isWebsiteUrl() {
        const hostname = this.getHostname();
        return hostname.match(/^((?:[\w-]+\.)?ag-grid\.com)$/) !== null;
    }
    isLocalhost() {
        const hostname = this.getHostname();
        return hostname.match(/^(?:127\.0\.0\.1|localhost)$/) !== null;
    }
    static formatDate(date) {
        const monthNames = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ];
        const day = date.getDate();
        const monthIndex = date.getMonth();
        const year = date.getFullYear();
        return day + " " + monthNames[monthIndex] + " " + year;
    }
    static getGridReleaseDate() {
        return new Date(parseInt(_LicenseManager.decode(_LicenseManager.RELEASE_INFORMATION), 10));
    }
    static decode(input) {
        const keystr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
        let t = "";
        let n, r, i;
        let s, o, u, a;
        let f = 0;
        const e = input.replace(/[^A-Za-z0-9+/=]/g, "");
        while(f < e.length){
            s = keystr.indexOf(e.charAt(f++));
            o = keystr.indexOf(e.charAt(f++));
            u = keystr.indexOf(e.charAt(f++));
            a = keystr.indexOf(e.charAt(f++));
            n = s << 2 | o >> 4;
            r = (o & 15) << 4 | u >> 2;
            i = (u & 3) << 6 | a;
            t = t + String.fromCharCode(n);
            if (u != 64) t = t + String.fromCharCode(r);
            if (a != 64) t = t + String.fromCharCode(i);
        }
        t = _LicenseManager.utf8_decode(t);
        return t;
    }
    static utf8_decode(input) {
        input = input.replace(/rn/g, "n");
        let t = "";
        for(let n = 0; n < input.length; n++){
            const r = input.charCodeAt(n);
            if (r < 128) t += String.fromCharCode(r);
            else if (r > 127 && r < 2048) {
                t += String.fromCharCode(r >> 6 | 192);
                t += String.fromCharCode(r & 63 | 128);
            } else {
                t += String.fromCharCode(r >> 12 | 224);
                t += String.fromCharCode(r >> 6 & 63 | 128);
                t += String.fromCharCode(r & 63 | 128);
            }
        }
        return t;
    }
    static setChartsLicenseManager(dependantLicenseManager) {
        this.chartsLicenseManager = dependantLicenseManager;
    }
    static setLicenseKey(licenseKey) {
        this.licenseKey = licenseKey;
        if (this.chartsLicenseManager) this.chartsLicenseManager.setLicenseKey(licenseKey, true);
    }
    static extractBracketedInformation(licenseKey) {
        if (!licenseKey.includes("[")) return [
            "legacy",
            false,
            void 0
        ];
        const matches = licenseKey.match(/\[(.*?)\]/g).map((match)=>match.replace("[", "").replace("]", ""));
        if (!matches || matches.length === 0) return [
            "legacy",
            false,
            void 0
        ];
        const isTrial = matches.filter((match)=>match === "TRIAL").length === 1;
        const rawVersion = matches.filter((match)=>match.indexOf("v") === 0)[0];
        const version = rawVersion ? rawVersion.replace("v", "") : "legacy";
        const type = $5b7ccabde48fae90$var$LICENSE_TYPES[matches.filter((match)=>$5b7ccabde48fae90$var$LICENSE_TYPES[match])[0]];
        return [
            version,
            isTrial,
            type
        ];
    }
    centerPadAndOutput(input) {
        const paddingRequired = this.totalMessageLength - input.length;
        console.error(input.padStart(paddingRequired / 2 + input.length, "*").padEnd(this.totalMessageLength, "*"));
    }
    padAndOutput(input, padding = "*", terminateWithPadding = "") {
        console.error(input.padEnd(this.totalMessageLength - terminateWithPadding.length, padding) + terminateWithPadding);
    }
    outputInvalidLicenseKey(incorrectLicenseType, currentLicenseName, suppliedLicenseName) {
        if (incorrectLicenseType) {
            this.centerPadAndOutput("");
            this.centerPadAndOutput(` ${currentLicenseName} License `);
            this.centerPadAndOutput(" Incompatible License Key ");
            this.padAndOutput(`* Your license key is for ${suppliedLicenseName} only and does not cover you for ${currentLicenseName}.`, " ", "*");
            this.padAndOutput("* Please contact info@ag-grid.com to obtain a combined license key.", " ", "*");
            this.centerPadAndOutput("");
            this.centerPadAndOutput("");
        } else {
            this.centerPadAndOutput("");
            this.centerPadAndOutput(` ${currentLicenseName} License `);
            this.centerPadAndOutput(" Invalid License Key ");
            this.padAndOutput(`* Your license key is not valid - please contact info@ag-grid.com to obtain a valid license.`, " ", "*");
            this.centerPadAndOutput("");
            this.centerPadAndOutput("");
        }
        this.watermarkMessage = "Invalid License";
    }
    outputExpiredTrialKey(formattedExpiryDate, currentLicenseName, suppliedLicenseName) {
        this.centerPadAndOutput("");
        this.centerPadAndOutput(` ${currentLicenseName} License `);
        this.centerPadAndOutput(" Trial Period Expired. ");
        this.padAndOutput(`* Your trial only license for ${suppliedLicenseName} expired on ${formattedExpiryDate}.`, " ", "*");
        this.padAndOutput("* Please email info@ag-grid.com to purchase a license.", " ", "*");
        this.centerPadAndOutput("");
        this.centerPadAndOutput("");
        this.watermarkMessage = "Trial Period Expired";
    }
    outputMissingLicenseKey(currentLicenseName) {
        this.centerPadAndOutput("");
        this.centerPadAndOutput(` ${currentLicenseName} License `);
        this.centerPadAndOutput(" License Key Not Found ");
        this.padAndOutput(`* All ${currentLicenseName} features are unlocked for trial.`, " ", "*");
        this.padAndOutput("* If you want to hide the watermark please email info@ag-grid.com for a trial license key.", " ", "*");
        this.centerPadAndOutput("");
        this.centerPadAndOutput("");
        this.watermarkMessage = "For Trial Use Only";
    }
    outputExpiredKey(formattedExpiryDate, formattedReleaseDate, currentLicenseName, suppliedLicenseName) {
        this.centerPadAndOutput("");
        this.centerPadAndOutput(` ${currentLicenseName} License `);
        this.centerPadAndOutput(" Incompatible Software Version ");
        this.padAndOutput(`* Your license key works with versions of ${suppliedLicenseName} released before ${formattedExpiryDate}.`, " ", "*");
        this.padAndOutput(`* The version you are trying to use was released on ${formattedReleaseDate}.`, " ", "*");
        this.padAndOutput("* Please contact info@ag-grid.com to renew your license key.", " ", "*");
        this.centerPadAndOutput("");
        this.centerPadAndOutput("");
        this.watermarkMessage = "License Expired";
    }
};
$5b7ccabde48fae90$var$_LicenseManager.RELEASE_INFORMATION = "MTcxNTc3NTcyODYxNg==";
var $5b7ccabde48fae90$var$LicenseManager = $5b7ccabde48fae90$var$_LicenseManager;
// enterprise-modules/core/src/license/gridLicenseManager.ts
var $5b7ccabde48fae90$export$91e2bbffdbb3852c = class extends (0, $jIDNV.BeanStub) {
    validateLicense() {
        this.licenseManager = new $5b7ccabde48fae90$var$LicenseManager(this.gos.getDocument());
        this.licenseManager.validateLicense();
    }
    static getLicenseDetails(licenseKey) {
        return new $5b7ccabde48fae90$var$LicenseManager(null).getLicenseDetails(licenseKey);
    }
    isDisplayWatermark() {
        return this.licenseManager.isDisplayWatermark();
    }
    getWatermarkMessage() {
        return this.licenseManager.getWatermarkMessage();
    }
    static setLicenseKey(licenseKey) {
        $5b7ccabde48fae90$var$LicenseManager.setLicenseKey(licenseKey);
    }
    static setChartsLicenseManager(chartsLicenseManager) {
        $5b7ccabde48fae90$var$LicenseManager.setChartsLicenseManager(chartsLicenseManager);
    }
};
$5b7ccabde48fae90$var$__decorateClass([
    (0, $jIDNV.PreConstruct)
], $5b7ccabde48fae90$export$91e2bbffdbb3852c.prototype, "validateLicense", 1);
$5b7ccabde48fae90$export$91e2bbffdbb3852c = $5b7ccabde48fae90$var$__decorateClass([
    (0, $jIDNV.Bean)("licenseManager")
], $5b7ccabde48fae90$export$91e2bbffdbb3852c);
var $5b7ccabde48fae90$var$WatermarkComp = class extends (0, $jIDNV.Component) {
    constructor(){
        super(/* html*/ `<div class="ag-watermark">
                <div ref="eLicenseTextRef" class="ag-watermark-text"></div>
            </div>`);
    }
    postConstruct() {
        const show = this.shouldDisplayWatermark();
        this.setDisplayed(show);
        if (show) {
            this.eLicenseTextRef.innerText = this.licenseManager.getWatermarkMessage();
            window.setTimeout(()=>this.addCssClass("ag-opacity-zero"), 0);
            window.setTimeout(()=>this.setDisplayed(false), 5e3);
        }
    }
    shouldDisplayWatermark() {
        return this.licenseManager.isDisplayWatermark();
    }
};
$5b7ccabde48fae90$var$__decorateClass([
    (0, $jIDNV.Autowired)("licenseManager")
], $5b7ccabde48fae90$var$WatermarkComp.prototype, "licenseManager", 2);
$5b7ccabde48fae90$var$__decorateClass([
    (0, $jIDNV.RefSelector)("eLicenseTextRef")
], $5b7ccabde48fae90$var$WatermarkComp.prototype, "eLicenseTextRef", 2);
$5b7ccabde48fae90$var$__decorateClass([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$WatermarkComp.prototype, "postConstruct", 1);
// enterprise-modules/core/src/version.ts
var $5b7ccabde48fae90$var$VERSION = "31.3.4";
// enterprise-modules/core/src/agGridEnterpriseModule.ts
var $5b7ccabde48fae90$export$3a6d13add8617801 = {
    version: $5b7ccabde48fae90$var$VERSION,
    moduleName: (0, $jIDNV.ModuleNames).EnterpriseCoreModule,
    beans: [
        $5b7ccabde48fae90$export$91e2bbffdbb3852c
    ],
    agStackComponents: [
        {
            componentName: "AgWatermark",
            componentClass: $5b7ccabde48fae90$var$WatermarkComp
        }
    ]
};
var $5b7ccabde48fae90$var$__defProp2 = Object.defineProperty;
var $5b7ccabde48fae90$var$__defProps = Object.defineProperties;
var $5b7ccabde48fae90$var$__getOwnPropDesc2 = Object.getOwnPropertyDescriptor;
var $5b7ccabde48fae90$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $5b7ccabde48fae90$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $5b7ccabde48fae90$var$__hasOwnProp2 = Object.prototype.hasOwnProperty;
var $5b7ccabde48fae90$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $5b7ccabde48fae90$var$__defNormalProp = (obj, key, value)=>key in obj ? $5b7ccabde48fae90$var$__defProp2(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5b7ccabde48fae90$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($5b7ccabde48fae90$var$__hasOwnProp2.call(b, prop)) $5b7ccabde48fae90$var$__defNormalProp(a, prop, b[prop]);
    if ($5b7ccabde48fae90$var$__getOwnPropSymbols) {
        for (var prop of $5b7ccabde48fae90$var$__getOwnPropSymbols(b))if ($5b7ccabde48fae90$var$__propIsEnum.call(b, prop)) $5b7ccabde48fae90$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $5b7ccabde48fae90$var$__spreadProps = (a, b)=>$5b7ccabde48fae90$var$__defProps(a, $5b7ccabde48fae90$var$__getOwnPropDescs(b));
var $5b7ccabde48fae90$var$__decorateClass2 = (decorators, target, key, kind)=>{
    var result = kind > 1 ? void 0 : kind ? $5b7ccabde48fae90$var$__getOwnPropDesc2(target, key) : target;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
    if (kind && result) $5b7ccabde48fae90$var$__defProp2(target, key, result);
    return result;
};
var $5b7ccabde48fae90$var$AdvancedFilterHeaderComp = class extends (0, $jIDNV.Component) {
    constructor(enabled){
        super(/* html */ `
            <div class="ag-advanced-filter-header" role="row">
            </div>`);
        this.enabled = enabled;
    }
    postConstruct() {
        this.setupAdvancedFilter(this.enabled);
        this.addDestroyFunc(()=>this.destroyBean(this.eAdvancedFilter));
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_GRID_COLUMNS_CHANGED, ()=>this.onGridColumnsChanged());
        this.addGuiEventListener("keydown", (event)=>this.onKeyDown(event));
        this.addGuiEventListener("focusout", (event)=>{
            if (!this.getFocusableElement().contains(event.relatedTarget)) this.focusService.clearAdvancedFilterColumn();
        });
    }
    getFocusableElement() {
        var _a, _b;
        return (_b = (_a = this.eAdvancedFilter) == null ? void 0 : _a.getGui()) != null ? _b : this.getGui();
    }
    setEnabled(enabled) {
        if (enabled === this.enabled) return;
        this.setupAdvancedFilter(enabled);
    }
    refresh() {
        var _a;
        (_a = this.eAdvancedFilter) == null || _a.refresh();
    }
    getHeight() {
        return this.height;
    }
    setInputDisabled(disabled) {
        var _a;
        (_a = this.eAdvancedFilter) == null || _a.setInputDisabled(disabled);
    }
    setupAdvancedFilter(enabled) {
        const eGui = this.getGui();
        if (enabled) {
            this.eAdvancedFilter = this.createBean(new $5b7ccabde48fae90$var$AdvancedFilterComp());
            const eAdvancedFilterGui = this.eAdvancedFilter.getGui();
            this.eAdvancedFilter.addCssClass("ag-advanced-filter-header-cell");
            this.height = this.columnModel.getFloatingFiltersHeight();
            const height = `${this.height}px`;
            eGui.style.height = height;
            eGui.style.minHeight = height;
            this.setAriaRowIndex();
            (0, $jIDNV._).setAriaRole(eAdvancedFilterGui, "gridcell");
            (0, $jIDNV._).setAriaColIndex(eAdvancedFilterGui, 1);
            this.setAriaColumnCount(eAdvancedFilterGui);
            eGui.appendChild(eAdvancedFilterGui);
        } else {
            (0, $jIDNV._).clearElement(eGui);
            this.destroyBean(this.eAdvancedFilter);
            this.height = 0;
        }
        (0, $jIDNV._).setDisplayed(eGui, enabled);
        this.enabled = enabled;
    }
    setAriaColumnCount(eAdvancedFilterGui) {
        (0, $jIDNV._).setAriaColSpan(eAdvancedFilterGui, this.columnModel.getAllGridColumns().length);
    }
    setAriaRowIndex() {
        (0, $jIDNV._).setAriaRowIndex(this.getGui(), this.headerNavigationService.getHeaderRowCount());
    }
    onGridColumnsChanged() {
        if (!this.eAdvancedFilter) return;
        this.setAriaColumnCount(this.eAdvancedFilter.getGui());
        this.setAriaRowIndex();
    }
    onKeyDown(event) {
        switch(event.key){
            case (0, $jIDNV.KeyCode).ENTER:
                if (this.hasFocus()) {
                    if (this.focusService.focusInto(this.getFocusableElement())) event.preventDefault();
                }
                break;
            case (0, $jIDNV.KeyCode).ESCAPE:
                if (!this.hasFocus()) this.getFocusableElement().focus();
                break;
            case (0, $jIDNV.KeyCode).UP:
                this.navigateUpDown(true, event);
                break;
            case (0, $jIDNV.KeyCode).DOWN:
                this.navigateUpDown(false, event);
                break;
            case (0, $jIDNV.KeyCode).TAB:
                if (this.hasFocus()) this.navigateLeftRight(event);
                else {
                    const nextFocusableEl = this.focusService.findNextFocusableElement(this.getFocusableElement(), null, event.shiftKey);
                    if (nextFocusableEl) {
                        event.preventDefault();
                        nextFocusableEl.focus();
                    } else this.navigateLeftRight(event);
                }
                break;
        }
    }
    navigateUpDown(backwards, event) {
        if (this.hasFocus()) {
            if (this.focusService.focusNextFromAdvancedFilter(backwards)) event.preventDefault();
        }
    }
    navigateLeftRight(event) {
        if (event.shiftKey ? this.focusService.focusLastHeader() : this.focusService.focusNextFromAdvancedFilter(false, true)) event.preventDefault();
    }
    hasFocus() {
        return this.gos.getActiveDomElement() === this.getFocusableElement();
    }
};
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$AdvancedFilterHeaderComp.prototype, "columnModel", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.Autowired)("focusService")
], $5b7ccabde48fae90$var$AdvancedFilterHeaderComp.prototype, "focusService", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.Autowired)("headerNavigationService")
], $5b7ccabde48fae90$var$AdvancedFilterHeaderComp.prototype, "headerNavigationService", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$AdvancedFilterHeaderComp.prototype, "postConstruct", 1);
var $5b7ccabde48fae90$var$AddDropdownComp = class extends (0, $jIDNV.AgRichSelect) {
    constructor(params){
        super($5b7ccabde48fae90$var$__spreadProps($5b7ccabde48fae90$var$__spreadValues({}, params), {
            template: /* html */ `
                <div class="ag-picker-field" role="presentation">
                    <div ref="eLabel"></div>
                    <div ref="eWrapper" class="ag-wrapper ag-picker-collapsed">
                        <div ref="eDisplayField" class="ag-picker-field-display"></div>
                        <ag-input-text-field ref="eInput" class="ag-rich-select-field-input"></ag-input-text-field>
                        <div ref="eIcon" class="ag-picker-field-icon" aria-hidden="true"></div>
                    </div>
                </div>`
        }));
        this.params = params;
    }
    showPicker() {
        setTimeout(()=>super.showPicker());
    }
    hidePicker() {
        setTimeout(()=>super.hidePicker());
    }
    postConstruct() {
        super.postConstruct();
        const { wrapperClassName: wrapperClassName, ariaLabel: ariaLabel } = this.params;
        (0, $jIDNV._).setDisplayed(this.eDisplayField, false);
        if (wrapperClassName) this.eWrapper.classList.add(wrapperClassName);
        (0, $jIDNV._).setAriaLabelledBy(this.eWrapper, "");
        (0, $jIDNV._).setAriaLabel(this.eWrapper, ariaLabel);
    }
    onEnterKeyDown(event) {
        (0, $jIDNV._).stopPropagationForAgGrid(event);
        if (this.isPickerDisplayed) super.onEnterKeyDown(event);
        else {
            event.preventDefault();
            this.showPicker();
        }
    }
};
var $5b7ccabde48fae90$var$_AdvancedFilterBuilderDragFeature = class _AdvancedFilterBuilderDragFeature2 extends (0, $jIDNV.BeanStub) {
    constructor(comp, virtualList){
        super();
        this.comp = comp;
        this.virtualList = virtualList;
    }
    postConstruct() {
        this.createManagedBean(new (0, $jIDNV.VirtualListDragFeature)(this.comp, this.virtualList, {
            dragSourceType: (0, $jIDNV.DragSourceType).AdvancedFilterBuilder,
            listItemDragStartEvent: _AdvancedFilterBuilderDragFeature2.EVENT_DRAG_STARTED,
            listItemDragEndEvent: _AdvancedFilterBuilderDragFeature2.EVENT_DRAG_ENDED,
            eventSource: this,
            getCurrentDragValue: (listItemDragStartEvent)=>this.getCurrentDragValue(listItemDragStartEvent),
            isMoveBlocked: ()=>false,
            getNumRows: (comp)=>comp.getNumItems(),
            moveItem: (currentDragValue, lastHoveredListItem)=>this.moveItem(currentDragValue, lastHoveredListItem)
        }));
    }
    getCurrentDragValue(listItemDragStartEvent) {
        return listItemDragStartEvent.item;
    }
    moveItem(currentDragValue, lastHoveredListItem) {
        this.comp.moveItem(currentDragValue, lastHoveredListItem);
    }
};
$5b7ccabde48fae90$var$_AdvancedFilterBuilderDragFeature.EVENT_DRAG_STARTED = "advancedFilterBuilderDragStarted";
$5b7ccabde48fae90$var$_AdvancedFilterBuilderDragFeature.EVENT_DRAG_ENDED = "advancedFilterBuilderDragEnded";
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_AdvancedFilterBuilderDragFeature.prototype, "postConstruct", 1);
var $5b7ccabde48fae90$var$AdvancedFilterBuilderDragFeature = $5b7ccabde48fae90$var$_AdvancedFilterBuilderDragFeature;
var $5b7ccabde48fae90$var$AdvancedFilterBuilderItemNavigationFeature = class extends (0, $jIDNV.BeanStub) {
    constructor(eGui, focusWrapper, eFocusableComp){
        super();
        this.eGui = eGui;
        this.focusWrapper = focusWrapper;
        this.eFocusableComp = eFocusableComp;
    }
    postConstruct() {
        this.addManagedListener(this.eGui, "keydown", (event)=>{
            switch(event.key){
                case (0, $jIDNV.KeyCode).TAB:
                    if (!event.defaultPrevented) (0, $jIDNV._).stopPropagationForAgGrid(event);
                    break;
                case (0, $jIDNV.KeyCode).UP:
                case (0, $jIDNV.KeyCode).DOWN:
                    (0, $jIDNV._).stopPropagationForAgGrid(event);
                    break;
                case (0, $jIDNV.KeyCode).ESCAPE:
                    if ((0, $jIDNV._).isStopPropagationForAgGrid(event)) return;
                    if (this.eGui.contains(this.gos.getActiveDomElement())) {
                        event.preventDefault();
                        (0, $jIDNV._).stopPropagationForAgGrid(event);
                        this.focusWrapper.focus();
                    }
                    break;
            }
        });
        this.addManagedListener(this.focusWrapper, "keydown", (event)=>{
            switch(event.key){
                case (0, $jIDNV.KeyCode).ENTER:
                    if ((0, $jIDNV._).isStopPropagationForAgGrid(event)) return;
                    if (this.gos.getActiveDomElement() === this.focusWrapper) {
                        event.preventDefault();
                        (0, $jIDNV._).stopPropagationForAgGrid(event);
                        this.eFocusableComp.getFocusableElement().focus();
                    }
                    break;
            }
        });
        this.addManagedListener(this.focusWrapper, "focusin", ()=>{
            this.focusWrapper.classList.add("ag-advanced-filter-builder-virtual-list-item-highlight");
        });
        this.addManagedListener(this.focusWrapper, "focusout", (event)=>{
            if (!this.focusWrapper.contains(event.relatedTarget)) this.focusWrapper.classList.remove("ag-advanced-filter-builder-virtual-list-item-highlight");
        });
    }
};
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$AdvancedFilterBuilderItemNavigationFeature.prototype, "postConstruct", 1);
function $5b7ccabde48fae90$var$getAdvancedFilterBuilderAddButtonParams(translate, maxPickerWidth) {
    return {
        pickerAriaLabelKey: "ariaLabelAdvancedFilterBuilderAddField",
        pickerAriaLabelValue: "Advanced Filter Builder Add Field",
        pickerType: "ag-list",
        valueList: [
            {
                key: "condition",
                displayValue: translate("advancedFilterBuilderAddCondition")
            },
            {
                key: "join",
                displayValue: translate("advancedFilterBuilderAddJoin")
            }
        ],
        valueFormatter: (value)=>{
            var _a;
            return value == null ? null : (_a = value.displayValue) != null ? _a : value.key;
        },
        pickerIcon: "advancedFilterBuilderAdd",
        maxPickerWidth: `${maxPickerWidth != null ? maxPickerWidth : 120}px`,
        wrapperClassName: "ag-advanced-filter-builder-item-button",
        ariaLabel: translate("advancedFilterBuilderAddButtonTooltip")
    };
}
var $5b7ccabde48fae90$var$AdvancedFilterBuilderEvents = class {
};
$5b7ccabde48fae90$var$AdvancedFilterBuilderEvents.EVENT_ADDED = "advancedFilterBuilderAdded";
$5b7ccabde48fae90$var$AdvancedFilterBuilderEvents.EVENT_MOVED = "advancedFilterBuilderMoved";
$5b7ccabde48fae90$var$AdvancedFilterBuilderEvents.EVENT_REMOVED = "advancedFilterBuilderRemoved";
$5b7ccabde48fae90$var$AdvancedFilterBuilderEvents.EVENT_VALUE_CHANGED = "advancedFilterBuilderValueChanged";
$5b7ccabde48fae90$var$AdvancedFilterBuilderEvents.EVENT_VALID_CHANGED = "advancedFilterBuilderValidChanged";
var $5b7ccabde48fae90$var$ConditionPillWrapperComp = class extends (0, $jIDNV.Component) {
    constructor(){
        super(/* html */ `
            <div class="ag-advanced-filter-builder-item-condition" role="presentation"></div>
        `);
        this.validationMessage = null;
    }
    init(params) {
        const { item: item, createPill: createPill } = params;
        this.item = item;
        this.createPill = createPill;
        this.filterModel = item.filterModel;
        this.setupColumnCondition(this.filterModel);
        this.validate();
        this.addDestroyFunc(()=>this.destroyBeans([
                this.eColumnPill,
                this.eOperatorPill,
                this.eOperandPill
            ]));
    }
    getDragName() {
        return this.filterModel.colId ? this.advancedFilterExpressionService.parseColumnFilterModel(this.filterModel) : this.getDefaultColumnDisplayValue();
    }
    getAriaLabel() {
        return `${this.advancedFilterExpressionService.translate("ariaAdvancedFilterBuilderFilterItem")} ${this.getDragName()}`;
    }
    getValidationMessage() {
        return this.validationMessage;
    }
    getFocusableElement() {
        return this.eColumnPill.getFocusableElement();
    }
    setupColumnCondition(filterModel) {
        var _a;
        const columnDetails = this.advancedFilterExpressionService.getColumnDetails(filterModel.colId);
        this.baseCellDataType = columnDetails.baseCellDataType;
        this.column = columnDetails.column;
        this.numOperands = this.getNumOperands(this.getOperatorKey());
        this.eColumnPill = this.createPill({
            key: this.getColumnKey(),
            displayValue: (_a = this.getColumnDisplayValue()) != null ? _a : this.getDefaultColumnDisplayValue(),
            cssClass: "ag-advanced-filter-builder-column-pill",
            isSelect: true,
            getEditorParams: ()=>({
                    values: this.advancedFilterExpressionService.getColumnAutocompleteEntries()
                }),
            update: (key)=>this.setColumnKey(key),
            pickerAriaLabelKey: "ariaLabelAdvancedFilterBuilderColumnSelectField",
            pickerAriaLabelValue: "Advanced Filter Builder Column Select Field",
            ariaLabel: this.advancedFilterExpressionService.translate("ariaAdvancedFilterBuilderColumn")
        });
        this.getGui().appendChild(this.eColumnPill.getGui());
        if ((0, $jIDNV._).exists(this.getColumnKey())) {
            this.createOperatorPill();
            if (this.hasOperand()) this.createOperandPill();
        }
    }
    createOperatorPill() {
        var _a;
        this.eOperatorPill = this.createPill({
            key: this.getOperatorKey(),
            displayValue: (_a = this.getOperatorDisplayValue()) != null ? _a : this.getDefaultOptionSelectValue(),
            cssClass: "ag-advanced-filter-builder-option-pill",
            isSelect: true,
            getEditorParams: ()=>({
                    values: this.getOperatorAutocompleteEntries()
                }),
            update: (key)=>this.setOperatorKey(key),
            pickerAriaLabelKey: "ariaLabelAdvancedFilterBuilderOptionSelectField",
            pickerAriaLabelValue: "Advanced Filter Builder Option Select Field",
            ariaLabel: this.advancedFilterExpressionService.translate("ariaAdvancedFilterBuilderOption")
        });
        this.eColumnPill.getGui().insertAdjacentElement("afterend", this.eOperatorPill.getGui());
    }
    createOperandPill() {
        var _a;
        const key = (_a = this.getOperandDisplayValue()) != null ? _a : "";
        this.eOperandPill = this.createPill({
            key: key,
            displayValue: key,
            baseCellDataType: this.baseCellDataType,
            cssClass: "ag-advanced-filter-builder-value-pill",
            isSelect: false,
            update: (key2)=>this.setOperand(key2),
            ariaLabel: this.advancedFilterExpressionService.translate("ariaAdvancedFilterBuilderValue")
        });
        this.getGui().appendChild(this.eOperandPill.getGui());
    }
    getColumnKey() {
        return this.filterModel.colId;
    }
    getColumnDisplayValue() {
        return this.advancedFilterExpressionService.getColumnDisplayValue(this.filterModel);
    }
    getOperatorKey() {
        return this.filterModel.type;
    }
    getOperatorDisplayValue() {
        return this.advancedFilterExpressionService.getOperatorDisplayValue(this.filterModel);
    }
    getOperandDisplayValue() {
        return this.advancedFilterExpressionService.getOperandDisplayValue(this.filterModel, true);
    }
    hasOperand() {
        return this.numOperands > 0;
    }
    getOperatorAutocompleteEntries() {
        return this.column ? this.advancedFilterExpressionService.getOperatorAutocompleteEntries(this.column, this.baseCellDataType) : [];
    }
    setColumnKey(colId) {
        if (!this.eOperatorPill) this.createOperatorPill();
        const newColumnDetails = this.advancedFilterExpressionService.getColumnDetails(colId);
        this.column = newColumnDetails.column;
        const newBaseCellDataType = newColumnDetails.baseCellDataType;
        if (this.baseCellDataType !== newBaseCellDataType) {
            this.baseCellDataType = newBaseCellDataType;
            this.setOperatorKey(void 0);
            if (this.eOperatorPill) {
                (0, $jIDNV._).removeFromParent(this.eOperatorPill.getGui());
                this.destroyBean(this.eOperatorPill);
                this.createOperatorPill();
            }
            this.validate();
        }
        this.filterModel.colId = colId;
        this.filterModel.filterType = this.baseCellDataType;
    }
    setOperatorKey(operator) {
        const newNumOperands = this.getNumOperands(operator);
        if (newNumOperands !== this.numOperands) {
            this.numOperands = newNumOperands;
            if (newNumOperands === 0) this.destroyOperandPill();
            else {
                this.createOperandPill();
                if (this.baseCellDataType !== "number") this.setOperand("");
            }
        }
        this.filterModel.type = operator;
        this.validate();
    }
    setOperand(operand) {
        var _a;
        let parsedOperand = operand;
        if (this.column) parsedOperand = (_a = this.advancedFilterExpressionService.getOperandModelValue(operand, this.baseCellDataType, this.column)) != null ? _a : "";
        this.filterModel.filter = parsedOperand;
        this.validate();
    }
    getNumOperands(operator) {
        var _a, _b;
        return (_b = (_a = this.advancedFilterExpressionService.getExpressionOperator(this.baseCellDataType, operator)) == null ? void 0 : _a.numOperands) != null ? _b : 0;
    }
    destroyOperandPill() {
        delete this.filterModel.filter;
        this.getGui().removeChild(this.eOperandPill.getGui());
        this.destroyBean(this.eOperandPill);
        this.eOperandPill = void 0;
    }
    validate() {
        let validationMessage = null;
        if (!(0, $jIDNV._).exists(this.getColumnKey())) validationMessage = this.advancedFilterExpressionService.translate("advancedFilterBuilderValidationSelectColumn");
        else if (!(0, $jIDNV._).exists(this.getOperatorKey())) validationMessage = this.advancedFilterExpressionService.translate("advancedFilterBuilderValidationSelectOption");
        else if (this.numOperands > 0 && !(0, $jIDNV._).exists(this.getOperandDisplayValue())) validationMessage = this.advancedFilterExpressionService.translate("advancedFilterBuilderValidationEnterValue");
        this.item.valid = !validationMessage;
        if (validationMessage !== this.validationMessage) {
            this.validationMessage = validationMessage;
            this.dispatchEvent({
                type: $5b7ccabde48fae90$var$AdvancedFilterBuilderEvents.EVENT_VALID_CHANGED
            });
        }
    }
    getDefaultColumnDisplayValue() {
        return this.advancedFilterExpressionService.translate("advancedFilterBuilderSelectColumn");
    }
    getDefaultOptionSelectValue() {
        return this.advancedFilterExpressionService.translate("advancedFilterBuilderSelectOption");
    }
};
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.Autowired)("advancedFilterExpressionService")
], $5b7ccabde48fae90$var$ConditionPillWrapperComp.prototype, "advancedFilterExpressionService", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.Autowired)("valueService")
], $5b7ccabde48fae90$var$ConditionPillWrapperComp.prototype, "valueService", 2);
var $5b7ccabde48fae90$var$InputPillComp = class extends (0, $jIDNV.Component) {
    constructor(params){
        super(/* html */ `
            <div class="ag-advanced-filter-builder-pill-wrapper" role="presentation">
                <div ref="ePill" class="ag-advanced-filter-builder-pill" role="button">
                    <span ref="eLabel" class="ag-advanced-filter-builder-pill-display"></span>
                </div>
            </div>
        `);
        this.params = params;
        this.value = params.value;
    }
    postConstruct() {
        const { cssClass: cssClass, ariaLabel: ariaLabel } = this.params;
        this.ePill.classList.add(cssClass);
        this.activateTabIndex([
            this.ePill
        ]);
        this.eLabel.id = `${this.getCompId()}`;
        (0, $jIDNV._).setAriaDescribedBy(this.ePill, this.eLabel.id);
        (0, $jIDNV._).setAriaLabel(this.ePill, ariaLabel);
        this.renderValue();
        this.addManagedListener(this.ePill, "click", (event)=>{
            event.preventDefault();
            this.showEditor();
        });
        this.addManagedListener(this.ePill, "keydown", (event)=>{
            switch(event.key){
                case (0, $jIDNV.KeyCode).ENTER:
                    event.preventDefault();
                    (0, $jIDNV._).stopPropagationForAgGrid(event);
                    this.showEditor();
                    break;
            }
        });
        this.addDestroyFunc(()=>this.destroyBean(this.eEditor));
    }
    getFocusableElement() {
        return this.ePill;
    }
    showEditor() {
        if (this.eEditor) return;
        (0, $jIDNV._).setDisplayed(this.ePill, false);
        this.eEditor = this.createEditorComp(this.params.type);
        this.eEditor.setValue(this.value);
        const eEditorGui = this.eEditor.getGui();
        this.eEditor.addManagedListener(eEditorGui, "keydown", (event)=>{
            switch(event.key){
                case (0, $jIDNV.KeyCode).ENTER:
                    event.preventDefault();
                    (0, $jIDNV._).stopPropagationForAgGrid(event);
                    this.updateValue(true);
                    break;
                case (0, $jIDNV.KeyCode).ESCAPE:
                    event.preventDefault();
                    (0, $jIDNV._).stopPropagationForAgGrid(event);
                    this.hideEditor(true);
                    break;
            }
        });
        this.eEditor.addManagedListener(eEditorGui, "focusout", ()=>{
            this.updateValue(false);
        });
        this.getGui().appendChild(eEditorGui);
        this.eEditor.getFocusableElement().focus();
    }
    createEditorComp(type) {
        let comp;
        switch(type){
            case "text":
                comp = new (0, $jIDNV.AgInputTextField)();
                break;
            case "number":
                comp = new (0, $jIDNV.AgInputNumberField)();
                break;
            case "date":
                comp = new (0, $jIDNV.AgInputDateField)();
                break;
        }
        return this.createBean(comp);
    }
    hideEditor(keepFocus) {
        const { eEditor: eEditor } = this;
        if (!eEditor) return;
        this.eEditor = void 0;
        this.getGui().removeChild(eEditor.getGui());
        this.destroyBean(eEditor);
        (0, $jIDNV._).setDisplayed(this.ePill, true);
        if (keepFocus) this.ePill.focus();
    }
    renderValue() {
        let value;
        this.eLabel.classList.remove("ag-advanced-filter-builder-value-empty", "ag-advanced-filter-builder-value-number", "ag-advanced-filter-builder-value-text");
        if (!(0, $jIDNV._).exists(this.value)) {
            value = this.advancedFilterExpressionService.translate("advancedFilterBuilderEnterValue");
            this.eLabel.classList.add("ag-advanced-filter-builder-value-empty");
        } else if (this.params.type === "number") {
            value = this.value;
            this.eLabel.classList.add("ag-advanced-filter-builder-value-number");
        } else {
            value = `"${this.value}"`;
            this.eLabel.classList.add("ag-advanced-filter-builder-value-text");
        }
        this.eLabel.innerText = value;
    }
    updateValue(keepFocus) {
        var _a;
        if (!this.eEditor) return;
        const value = (_a = this.eEditor.getValue()) != null ? _a : "";
        this.dispatchEvent({
            type: (0, $jIDNV.Events).EVENT_FIELD_VALUE_CHANGED,
            value: value
        });
        this.value = value;
        this.renderValue();
        this.hideEditor(keepFocus);
    }
};
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.RefSelector)("ePill")
], $5b7ccabde48fae90$var$InputPillComp.prototype, "ePill", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.RefSelector)("eLabel")
], $5b7ccabde48fae90$var$InputPillComp.prototype, "eLabel", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.Autowired)("advancedFilterExpressionService")
], $5b7ccabde48fae90$var$InputPillComp.prototype, "advancedFilterExpressionService", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$InputPillComp.prototype, "postConstruct", 1);
var $5b7ccabde48fae90$var$JoinPillWrapperComp = class extends (0, $jIDNV.Component) {
    constructor(){
        super(/* html */ `
            <div class="ag-advanced-filter-builder-item-condition" role="presentation"></div>
        `);
    }
    init(params) {
        const { item: item, createPill: createPill } = params;
        const filterModel = item.filterModel;
        this.filterModel = filterModel;
        this.ePill = createPill({
            key: filterModel.type,
            displayValue: this.advancedFilterExpressionService.parseJoinOperator(filterModel),
            cssClass: "ag-advanced-filter-builder-join-pill",
            isSelect: true,
            getEditorParams: ()=>({
                    values: this.advancedFilterExpressionService.getJoinOperatorAutocompleteEntries()
                }),
            update: (key)=>filterModel.type = key,
            pickerAriaLabelKey: "ariaLabelAdvancedFilterBuilderJoinSelectField",
            pickerAriaLabelValue: "Advanced Filter Builder Join Operator Select Field",
            ariaLabel: this.advancedFilterExpressionService.translate("ariaAdvancedFilterBuilderJoinOperator")
        });
        this.getGui().appendChild(this.ePill.getGui());
        this.addDestroyFunc(()=>this.destroyBean(this.ePill));
    }
    getDragName() {
        return this.advancedFilterExpressionService.parseJoinOperator(this.filterModel);
    }
    getAriaLabel() {
        return `${this.advancedFilterExpressionService.translate("ariaAdvancedFilterBuilderGroupItem")} ${this.getDragName()}`;
    }
    getValidationMessage() {
        return null;
    }
    getFocusableElement() {
        return this.ePill.getFocusableElement();
    }
};
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.Autowired)("advancedFilterExpressionService")
], $5b7ccabde48fae90$var$JoinPillWrapperComp.prototype, "advancedFilterExpressionService", 2);
var $5b7ccabde48fae90$var$SelectPillComp = class extends (0, $jIDNV.AgRichSelect) {
    constructor(params){
        super($5b7ccabde48fae90$var$__spreadProps($5b7ccabde48fae90$var$__spreadValues({}, params), {
            template: /* html */ `
                <div class="ag-picker-field ag-advanced-filter-builder-pill-wrapper" role="presentation">
                    <div ref="eLabel"></div>
                    <div ref="eWrapper" class="ag-wrapper ag-advanced-filter-builder-pill ag-picker-collapsed">
                        <div ref="eDisplayField" class="ag-picker-field-display ag-advanced-filter-builder-pill-display"></div>
                        <ag-input-text-field ref="eInput" class="ag-rich-select-field-input"></ag-input-text-field>
                        <div ref="eIcon" class="ag-picker-field-icon" aria-hidden="true"></div>
                    </div>
                </div>`
        }));
        this.params = params;
    }
    getFocusableElement() {
        return this.eWrapper;
    }
    showPicker() {
        setTimeout(()=>super.showPicker());
    }
    hidePicker() {
        setTimeout(()=>super.hidePicker());
    }
    postConstruct() {
        super.postConstruct();
        const { wrapperClassName: wrapperClassName, ariaLabel: ariaLabel } = this.params;
        this.eWrapper.classList.add(wrapperClassName);
        (0, $jIDNV._).setAriaLabelledBy(this.eWrapper, "");
        (0, $jIDNV._).setAriaLabel(this.eWrapper, ariaLabel);
    }
    createPickerComponent() {
        var _a;
        if (!this.values) {
            const { values: values } = this.params.getEditorParams();
            this.values = values;
            const key = this.value.key;
            const value = (_a = values.find((value2)=>value2.key === key)) != null ? _a : {
                key: key,
                displayValue: this.value.displayValue
            };
            this.value = value;
        }
        return super.createPickerComponent();
    }
    onEnterKeyDown(event) {
        (0, $jIDNV._).stopPropagationForAgGrid(event);
        if (this.isPickerDisplayed) super.onEnterKeyDown(event);
        else {
            event.preventDefault();
            this.showPicker();
        }
    }
};
var $5b7ccabde48fae90$var$AdvancedFilterBuilderItemComp = class extends (0, $jIDNV.TabGuardComp) {
    constructor(item, dragFeature, focusWrapper){
        super(/* html */ `
            <div class="ag-advanced-filter-builder-item-wrapper" role="presentation">
                <div ref="eItem" class="ag-advanced-filter-builder-item" role="presentation">
                    <div ref="eTreeLines" class="ag-advanced-filter-builder-item-tree-lines" aria-hidden="true"></div>
                    <span ref="eDragHandle" class="ag-drag-handle" aria-hidden="true"></span>
                    <span ref="eValidation" class="ag-advanced-filter-builder-item-button ag-advanced-filter-builder-invalid" aria-hidden="true"></span>
                </div>
                <div ref="eButtons" class="ag-advanced-filter-builder-item-buttons">
                    <span ref="eMoveUpButton" class="ag-advanced-filter-builder-item-button" role="button"></span>
                    <span ref="eMoveDownButton" class="ag-advanced-filter-builder-item-button" role="button"></span>
                    <div ref="eAddButton" role="presentation"></div>
                    <span ref="eRemoveButton" class="ag-advanced-filter-builder-item-button" role="button"></span>
                </div>
            </div>
        `);
        this.item = item;
        this.dragFeature = dragFeature;
        this.focusWrapper = focusWrapper;
        this.moveUpDisabled = false;
        this.moveDownDisabled = false;
    }
    postConstruct() {
        const { filterModel: filterModel, level: level, showMove: showMove } = this.item;
        const isJoin = filterModel.filterType === "join";
        this.ePillWrapper = this.createManagedBean(isJoin ? new $5b7ccabde48fae90$var$JoinPillWrapperComp() : new $5b7ccabde48fae90$var$ConditionPillWrapperComp());
        this.ePillWrapper.init({
            item: this.item,
            createPill: (params)=>this.createPill(params)
        });
        this.eDragHandle.insertAdjacentElement("afterend", this.ePillWrapper.getGui());
        if (level === 0) {
            const eTreeLine = document.createElement("div");
            eTreeLine.classList.add("ag-advanced-filter-builder-item-tree-line-vertical-bottom");
            eTreeLine.classList.add("ag-advanced-filter-builder-item-tree-line-root");
            this.eTreeLines.appendChild(eTreeLine);
            (0, $jIDNV._).setDisplayed(this.eDragHandle, false);
            (0, $jIDNV._).setDisplayed(this.eButtons, false);
            (0, $jIDNV._).setAriaExpanded(this.focusWrapper, true);
        } else {
            this.setupTreeLines(level);
            this.eDragHandle.appendChild((0, $jIDNV._).createIconNoSpan("advancedFilterBuilderDrag", this.gos));
            this.setupValidation();
            this.setupMoveButtons(showMove);
            this.setupAddButton();
            this.setupRemoveButton();
            this.setupDragging();
            this.updateAriaExpanded();
        }
        (0, $jIDNV._).setAriaLevel(this.focusWrapper, level + 1);
        this.initialiseTabGuard({});
        this.createManagedBean(new $5b7ccabde48fae90$var$AdvancedFilterBuilderItemNavigationFeature(this.getGui(), this.focusWrapper, this.ePillWrapper));
        this.updateAriaLabel();
        this.addManagedListener(this.ePillWrapper, $5b7ccabde48fae90$var$AdvancedFilterBuilderEvents.EVENT_VALUE_CHANGED, ()=>this.dispatchEvent({
                type: $5b7ccabde48fae90$var$AdvancedFilterBuilderEvents.EVENT_VALUE_CHANGED
            }));
        this.addManagedListener(this.ePillWrapper, $5b7ccabde48fae90$var$AdvancedFilterBuilderEvents.EVENT_VALID_CHANGED, ()=>this.updateValidity());
    }
    setState(params) {
        const { level: level } = this.item;
        if (level === 0) return;
        const { showMove: showMove } = this.item;
        const { disableMoveUp: disableMoveUp, disableMoveDown: disableMoveDown, treeLines: treeLines, showStartTreeLine: showStartTreeLine } = params;
        this.updateTreeLines(treeLines, showStartTreeLine);
        this.updateAriaExpanded();
        if (showMove) {
            this.moveUpDisabled = !!disableMoveUp;
            this.moveDownDisabled = !!disableMoveDown;
            this.eMoveUpButton.classList.toggle("ag-advanced-filter-builder-item-button-disabled", disableMoveUp);
            this.eMoveDownButton.classList.toggle("ag-advanced-filter-builder-item-button-disabled", disableMoveDown);
            (0, $jIDNV._).setAriaDisabled(this.eMoveUpButton, !!disableMoveUp);
            (0, $jIDNV._).setAriaDisabled(this.eMoveDownButton, !!disableMoveDown);
            this.moveUpTooltipFeature.refreshToolTip();
            this.moveDownTooltipFeature.refreshToolTip();
        }
    }
    focusMoveButton(backwards) {
        (backwards ? this.eMoveUpButton : this.eMoveDownButton).focus();
    }
    afterAdd() {
        this.ePillWrapper.getFocusableElement().focus();
    }
    setupTreeLines(level) {
        for(let i = 0; i < level; i++){
            const eTreeLine = document.createElement("div");
            this.eTreeLines.appendChild(eTreeLine);
        }
    }
    updateTreeLines(treeLines, showStartTreeLine) {
        const lastTreeLineIndex = treeLines.length - 1;
        const { children: children } = this.eTreeLines;
        for(let i = 0; i < lastTreeLineIndex; i++){
            const eTreeLine2 = children.item(i);
            if (eTreeLine2) eTreeLine2.classList.toggle("ag-advanced-filter-builder-item-tree-line-vertical", !treeLines[i]);
        }
        const eTreeLine = children.item(lastTreeLineIndex);
        if (eTreeLine) {
            eTreeLine.classList.add("ag-advanced-filter-builder-item-tree-line-horizontal");
            const isLastChild = treeLines[lastTreeLineIndex];
            eTreeLine.classList.toggle("ag-advanced-filter-builder-item-tree-line-vertical-top", isLastChild);
            eTreeLine.classList.toggle("ag-advanced-filter-builder-item-tree-line-vertical", !isLastChild);
        }
        this.eDragHandle.classList.toggle("ag-advanced-filter-builder-item-tree-line-vertical-bottom", showStartTreeLine);
    }
    setupValidation() {
        this.eValidation.appendChild((0, $jIDNV._).createIconNoSpan("advancedFilterBuilderInvalid", this.gos));
        this.validationTooltipFeature = this.createManagedBean(new (0, $jIDNV.TooltipFeature)({
            getGui: ()=>this.eValidation,
            getLocation: ()=>"advancedFilter",
            getTooltipValue: ()=>this.ePillWrapper.getValidationMessage(),
            getTooltipShowDelayOverride: ()=>1e3
        }));
        this.updateValidity();
    }
    setupAddButton() {
        var _a;
        const addButtonParams = $5b7ccabde48fae90$var$getAdvancedFilterBuilderAddButtonParams((key)=>this.advancedFilterExpressionService.translate(key), (_a = this.gos.get("advancedFilterBuilderParams")) == null ? void 0 : _a.addSelectWidth);
        const eAddButton = this.createManagedBean(new $5b7ccabde48fae90$var$AddDropdownComp(addButtonParams));
        this.addManagedListener(eAddButton, (0, $jIDNV.Events).EVENT_FIELD_PICKER_VALUE_SELECTED, ({ value: value })=>this.dispatchEvent({
                type: $5b7ccabde48fae90$var$AdvancedFilterBuilderEvents.EVENT_ADDED,
                item: this.item,
                isJoin: value.key === "join"
            }));
        this.eAddButton.appendChild(eAddButton.getGui());
        this.createManagedBean(new (0, $jIDNV.TooltipFeature)({
            getGui: ()=>this.eAddButton,
            getLocation: ()=>"advancedFilter",
            getTooltipValue: ()=>this.advancedFilterExpressionService.translate("advancedFilterBuilderAddButtonTooltip")
        }));
    }
    setupRemoveButton() {
        this.eRemoveButton.appendChild((0, $jIDNV._).createIconNoSpan("advancedFilterBuilderRemove", this.gos));
        this.addManagedListener(this.eRemoveButton, "click", ()=>this.removeItem());
        this.addManagedListener(this.eRemoveButton, "keydown", (event)=>{
            switch(event.key){
                case (0, $jIDNV.KeyCode).ENTER:
                    event.preventDefault();
                    (0, $jIDNV._).stopPropagationForAgGrid(event);
                    this.removeItem();
                    break;
            }
        });
        this.createManagedBean(new (0, $jIDNV.TooltipFeature)({
            getGui: ()=>this.eRemoveButton,
            getLocation: ()=>"advancedFilter",
            getTooltipValue: ()=>this.advancedFilterExpressionService.translate("advancedFilterBuilderRemoveButtonTooltip")
        }));
        (0, $jIDNV._).setAriaLabel(this.eRemoveButton, this.advancedFilterExpressionService.translate("advancedFilterBuilderRemoveButtonTooltip"));
        this.activateTabIndex([
            this.eRemoveButton
        ]);
    }
    setupMoveButtons(showMove) {
        if (showMove) {
            this.eMoveUpButton.appendChild((0, $jIDNV._).createIconNoSpan("advancedFilterBuilderMoveUp", this.gos));
            this.addManagedListener(this.eMoveUpButton, "click", ()=>this.moveItem(true));
            this.addManagedListener(this.eMoveUpButton, "keydown", (event)=>{
                switch(event.key){
                    case (0, $jIDNV.KeyCode).ENTER:
                        event.preventDefault();
                        (0, $jIDNV._).stopPropagationForAgGrid(event);
                        this.moveItem(true);
                        break;
                }
            });
            this.moveUpTooltipFeature = this.createManagedBean(new (0, $jIDNV.TooltipFeature)({
                getGui: ()=>this.eMoveUpButton,
                getLocation: ()=>"advancedFilter",
                getTooltipValue: ()=>this.moveUpDisabled ? null : this.advancedFilterExpressionService.translate("advancedFilterBuilderMoveUpButtonTooltip")
            }));
            (0, $jIDNV._).setAriaLabel(this.eMoveUpButton, this.advancedFilterExpressionService.translate("advancedFilterBuilderMoveUpButtonTooltip"));
            this.eMoveDownButton.appendChild((0, $jIDNV._).createIconNoSpan("advancedFilterBuilderMoveDown", this.gos));
            this.addManagedListener(this.eMoveDownButton, "click", ()=>this.moveItem(false));
            this.addManagedListener(this.eMoveDownButton, "keydown", (event)=>{
                switch(event.key){
                    case (0, $jIDNV.KeyCode).ENTER:
                        event.preventDefault();
                        (0, $jIDNV._).stopPropagationForAgGrid(event);
                        this.moveItem(false);
                        break;
                }
            });
            this.moveDownTooltipFeature = this.createManagedBean(new (0, $jIDNV.TooltipFeature)({
                getGui: ()=>this.eMoveDownButton,
                getLocation: ()=>"advancedFilter",
                getTooltipValue: ()=>this.moveDownDisabled ? null : this.advancedFilterExpressionService.translate("advancedFilterBuilderMoveDownButtonTooltip")
            }));
            (0, $jIDNV._).setAriaLabel(this.eMoveDownButton, this.advancedFilterExpressionService.translate("advancedFilterBuilderMoveDownButtonTooltip"));
            this.activateTabIndex([
                this.eMoveUpButton,
                this.eMoveDownButton
            ]);
        } else {
            (0, $jIDNV._).setDisplayed(this.eMoveUpButton, false);
            (0, $jIDNV._).setDisplayed(this.eMoveDownButton, false);
        }
    }
    updateValidity() {
        (0, $jIDNV._).setVisible(this.eValidation, !this.item.valid);
        this.validationTooltipFeature.refreshToolTip();
        this.updateAriaLabel();
    }
    createPill(params) {
        var _a, _b;
        const { key: key, displayValue: displayValue, cssClass: cssClass, update: update, ariaLabel: ariaLabel } = params;
        const onUpdated = (key2)=>{
            if (key2 == null) return;
            update(key2);
            this.dispatchEvent({
                type: $5b7ccabde48fae90$var$AdvancedFilterBuilderEvents.EVENT_VALUE_CHANGED
            });
        };
        if (params.isSelect) {
            const { getEditorParams: getEditorParams, pickerAriaLabelKey: pickerAriaLabelKey, pickerAriaLabelValue: pickerAriaLabelValue } = params;
            const advancedFilterBuilderParams = this.gos.get("advancedFilterBuilderParams");
            const minPickerWidth = `${(_a = advancedFilterBuilderParams == null ? void 0 : advancedFilterBuilderParams.pillSelectMinWidth) != null ? _a : 140}px`;
            const maxPickerWidth = `${(_b = advancedFilterBuilderParams == null ? void 0 : advancedFilterBuilderParams.pillSelectMaxWidth) != null ? _b : 200}px`;
            const comp = this.createBean(new $5b7ccabde48fae90$var$SelectPillComp({
                pickerAriaLabelKey: pickerAriaLabelKey,
                pickerAriaLabelValue: pickerAriaLabelValue,
                pickerType: "ag-list",
                value: {
                    key: key,
                    displayValue: displayValue
                },
                valueFormatter: (value)=>{
                    var _a2;
                    return value == null ? null : (_a2 = value.displayValue) != null ? _a2 : value.key;
                },
                variableWidth: true,
                minPickerWidth: minPickerWidth,
                maxPickerWidth: maxPickerWidth,
                getEditorParams: getEditorParams,
                wrapperClassName: cssClass,
                ariaLabel: ariaLabel
            }));
            this.addManagedListener(comp, (0, $jIDNV.Events).EVENT_FIELD_PICKER_VALUE_SELECTED, ({ value: value })=>onUpdated(value == null ? void 0 : value.key));
            return comp;
        } else {
            const comp = this.createBean(new $5b7ccabde48fae90$var$InputPillComp({
                value: displayValue,
                cssClass: cssClass,
                type: this.getInputType(params.baseCellDataType),
                ariaLabel: ariaLabel
            }));
            this.addManagedListener(comp, (0, $jIDNV.Events).EVENT_FIELD_VALUE_CHANGED, ({ value: value })=>onUpdated(value));
            return comp;
        }
    }
    getInputType(baseCellDataType) {
        switch(baseCellDataType){
            case "text":
            case "object":
            case "boolean":
                return "text";
            case "number":
                return "number";
            case "date":
            case "dateString":
                return "date";
        }
    }
    setupDragging() {
        const dragSource = {
            type: (0, $jIDNV.DragSourceType).AdvancedFilterBuilder,
            eElement: this.eDragHandle,
            dragItemName: ()=>this.ePillWrapper.getDragName(),
            getDefaultIconName: ()=>(0, $jIDNV.DragAndDropService).ICON_NOT_ALLOWED,
            getDragItem: ()=>({}),
            onDragStarted: ()=>this.dragFeature.dispatchEvent({
                    type: $5b7ccabde48fae90$var$AdvancedFilterBuilderDragFeature.EVENT_DRAG_STARTED,
                    item: this.item
                }),
            onDragStopped: ()=>this.dragFeature.dispatchEvent({
                    type: $5b7ccabde48fae90$var$AdvancedFilterBuilderDragFeature.EVENT_DRAG_ENDED
                })
        };
        this.dragAndDropService.addDragSource(dragSource, true);
        this.addDestroyFunc(()=>this.dragAndDropService.removeDragSource(dragSource));
    }
    updateAriaLabel() {
        const wrapperLabel = this.ePillWrapper.getAriaLabel();
        const level = `${this.item.level + 1}`;
        const validationMessage = this.ePillWrapper.getValidationMessage();
        let ariaLabel;
        if (validationMessage) ariaLabel = this.advancedFilterExpressionService.translate("ariaAdvancedFilterBuilderItemValidation", [
            wrapperLabel,
            level,
            validationMessage
        ]);
        else ariaLabel = this.advancedFilterExpressionService.translate("ariaAdvancedFilterBuilderItem", [
            wrapperLabel,
            level
        ]);
        (0, $jIDNV._).setAriaLabel(this.focusWrapper, ariaLabel);
    }
    updateAriaExpanded() {
        (0, $jIDNV._).removeAriaExpanded(this.focusWrapper);
        const { filterModel: filterModel } = this.item;
        if ((filterModel == null ? void 0 : filterModel.filterType) === "join" && filterModel.conditions.length) (0, $jIDNV._).setAriaExpanded(this.focusWrapper, true);
    }
    removeItem() {
        this.dispatchEvent({
            type: $5b7ccabde48fae90$var$AdvancedFilterBuilderEvents.EVENT_REMOVED,
            item: this.item
        });
    }
    moveItem(backwards) {
        this.dispatchEvent({
            type: $5b7ccabde48fae90$var$AdvancedFilterBuilderEvents.EVENT_MOVED,
            item: this.item,
            backwards: backwards
        });
    }
};
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.RefSelector)("eTreeLines")
], $5b7ccabde48fae90$var$AdvancedFilterBuilderItemComp.prototype, "eTreeLines", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.RefSelector)("eDragHandle")
], $5b7ccabde48fae90$var$AdvancedFilterBuilderItemComp.prototype, "eDragHandle", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.RefSelector)("eItem")
], $5b7ccabde48fae90$var$AdvancedFilterBuilderItemComp.prototype, "eItem", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.RefSelector)("eButtons")
], $5b7ccabde48fae90$var$AdvancedFilterBuilderItemComp.prototype, "eButtons", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.RefSelector)("eValidation")
], $5b7ccabde48fae90$var$AdvancedFilterBuilderItemComp.prototype, "eValidation", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.RefSelector)("eMoveUpButton")
], $5b7ccabde48fae90$var$AdvancedFilterBuilderItemComp.prototype, "eMoveUpButton", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.RefSelector)("eMoveDownButton")
], $5b7ccabde48fae90$var$AdvancedFilterBuilderItemComp.prototype, "eMoveDownButton", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.RefSelector)("eAddButton")
], $5b7ccabde48fae90$var$AdvancedFilterBuilderItemComp.prototype, "eAddButton", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.RefSelector)("eRemoveButton")
], $5b7ccabde48fae90$var$AdvancedFilterBuilderItemComp.prototype, "eRemoveButton", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.Autowired)("beans")
], $5b7ccabde48fae90$var$AdvancedFilterBuilderItemComp.prototype, "beans", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.Autowired)("dragAndDropService")
], $5b7ccabde48fae90$var$AdvancedFilterBuilderItemComp.prototype, "dragAndDropService", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.Autowired)("advancedFilterExpressionService")
], $5b7ccabde48fae90$var$AdvancedFilterBuilderItemComp.prototype, "advancedFilterExpressionService", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$AdvancedFilterBuilderItemComp.prototype, "postConstruct", 1);
var $5b7ccabde48fae90$var$AdvancedFilterBuilderItemAddComp = class extends (0, $jIDNV.Component) {
    constructor(item, focusWrapper){
        super(/* html */ `
            <div class="ag-advanced-filter-builder-item-wrapper" role="presentation">
                <div ref="eItem" class="ag-advanced-filter-builder-item" role="presentation">
                    <div class="ag-advanced-filter-builder-item-tree-lines" aria-hidden="true">
                        <div class="ag-advanced-filter-builder-item-tree-line-vertical-top ag-advanced-filter-builder-item-tree-line-horizontal"></div>
                    </div>
                </div>
            </div>
        `);
        this.item = item;
        this.focusWrapper = focusWrapper;
    }
    postConstruct() {
        var _a;
        (0, $jIDNV._).setAriaLevel(this.focusWrapper, 2);
        const addButtonParams = $5b7ccabde48fae90$var$getAdvancedFilterBuilderAddButtonParams((key)=>this.advancedFilterExpressionService.translate(key), (_a = this.gos.get("advancedFilterBuilderParams")) == null ? void 0 : _a.addSelectWidth);
        const eAddButton = this.createManagedBean(new $5b7ccabde48fae90$var$AddDropdownComp(addButtonParams));
        this.addManagedListener(eAddButton, (0, $jIDNV.Events).EVENT_FIELD_PICKER_VALUE_SELECTED, ({ value: value })=>{
            this.dispatchEvent({
                type: $5b7ccabde48fae90$var$AdvancedFilterBuilderEvents.EVENT_ADDED,
                item: this.item,
                isJoin: value.key === "join"
            });
        });
        this.eItem.appendChild(eAddButton.getGui());
        this.createManagedBean(new (0, $jIDNV.TooltipFeature)({
            getGui: ()=>eAddButton.getGui(),
            getLocation: ()=>"advancedFilter",
            getTooltipValue: ()=>this.advancedFilterExpressionService.translate("advancedFilterBuilderAddButtonTooltip")
        }));
        this.createManagedBean(new $5b7ccabde48fae90$var$AdvancedFilterBuilderItemNavigationFeature(this.getGui(), this.focusWrapper, eAddButton));
        (0, $jIDNV._).setAriaLabel(this.focusWrapper, this.advancedFilterExpressionService.translate("ariaAdvancedFilterBuilderItem", [
            this.advancedFilterExpressionService.translate("advancedFilterBuilderAddButtonTooltip"),
            `${this.item.level + 1}`
        ]));
    }
    afterAdd() {}
};
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.Autowired)("beans")
], $5b7ccabde48fae90$var$AdvancedFilterBuilderItemAddComp.prototype, "beans", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.Autowired)("advancedFilterExpressionService")
], $5b7ccabde48fae90$var$AdvancedFilterBuilderItemAddComp.prototype, "advancedFilterExpressionService", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.RefSelector)("eItem")
], $5b7ccabde48fae90$var$AdvancedFilterBuilderItemAddComp.prototype, "eItem", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$AdvancedFilterBuilderItemAddComp.prototype, "postConstruct", 1);
var $5b7ccabde48fae90$var$AdvancedFilterBuilderComp = class extends (0, $jIDNV.Component) {
    constructor(){
        super(/* html */ `
            <div role="presentation" class="ag-advanced-filter-builder" tabindex="-1">
                <div role="presentation" class="ag-advanced-filter-builder-list" ref="eList"></div>
                <div role="presentation" class="ag-advanced-filter-builder-button-panel">
                    <button class="ag-button ag-standard-button ag-advanced-filter-builder-apply-button" ref="eApplyFilterButton"></button>
                    <button class="ag-button ag-standard-button ag-advanced-filter-builder-cancel-button" ref="eCancelFilterButton"></button>
                </div>
            </div>`);
        this.validationMessage = null;
    }
    postConstruct() {
        var _a;
        const { showMoveButtons: showMoveButtons } = (_a = this.gos.get("advancedFilterBuilderParams")) != null ? _a : {};
        this.showMove = !!showMoveButtons;
        this.addManagedPropertyListener("advancedFilterBuilderParams", ({ currentValue: currentValue })=>{
            this.showMove = !!(currentValue == null ? void 0 : currentValue.showMoveButtons);
            this.refreshList(false);
        });
        this.filterModel = this.setupFilterModel();
        this.setupVirtualList();
        this.dragFeature = this.createManagedBean(new $5b7ccabde48fae90$var$AdvancedFilterBuilderDragFeature(this, this.virtualList));
        this.setupButtons();
    }
    refresh() {
        let indexToFocus = this.virtualList.getLastFocusedRow();
        this.setupFilterModel();
        this.validateItems();
        this.refreshList(false);
        if (indexToFocus != null) {
            if (!this.virtualList.getComponentAt(indexToFocus)) indexToFocus = 0;
            this.virtualList.focusRow(indexToFocus);
        }
    }
    getNumItems() {
        return this.items.length;
    }
    moveItem(item, destination) {
        if (!destination || !item) return;
        this.moveItemToIndex(item, destination.rowIndex, destination.position);
    }
    afterGuiAttached() {
        this.virtualList.focusRow(0);
    }
    setupVirtualList() {
        this.virtualList = this.createManagedBean(new (0, $jIDNV.VirtualList)({
            cssIdentifier: "advanced-filter-builder",
            ariaRole: "tree",
            listName: this.advancedFilterExpressionService.translate("ariaAdvancedFilterBuilderList")
        }));
        this.virtualList.setComponentCreator(this.createItemComponent.bind(this));
        this.virtualList.setComponentUpdater(this.updateItemComponent.bind(this));
        this.virtualList.setRowHeight(40);
        this.eList.appendChild(this.virtualList.getGui());
        this.virtualList.setModel({
            getRowCount: ()=>this.items.length,
            getRow: (index)=>this.items[index],
            areRowsEqual: (oldRow, newRow)=>oldRow === newRow
        });
        this.buildList();
        this.virtualList.refresh();
    }
    setupButtons() {
        this.eApplyFilterButton.innerText = this.advancedFilterExpressionService.translate("advancedFilterBuilderApply");
        this.activateTabIndex([
            this.eApplyFilterButton
        ]);
        this.addManagedListener(this.eApplyFilterButton, "click", ()=>{
            this.advancedFilterService.setModel(this.filterModel);
            this.filterManager.onFilterChanged({
                source: "advancedFilter"
            });
            this.close();
        });
        this.validationTooltipFeature = this.createManagedBean(new (0, $jIDNV.TooltipFeature)({
            getGui: ()=>this.eApplyFilterButton,
            getLocation: ()=>"advancedFilter",
            getTooltipValue: ()=>this.validationMessage,
            getTooltipShowDelayOverride: ()=>1e3
        }));
        this.validate();
        this.addManagedListener(this.eApplyFilterButton, "mouseenter", ()=>this.addOrRemoveCssClass("ag-advanced-filter-builder-validation", true));
        this.addManagedListener(this.eApplyFilterButton, "mouseleave", ()=>this.addOrRemoveCssClass("ag-advanced-filter-builder-validation", false));
        this.eCancelFilterButton.innerText = this.advancedFilterExpressionService.translate("advancedFilterBuilderCancel");
        this.activateTabIndex([
            this.eCancelFilterButton
        ]);
        this.addManagedListener(this.eCancelFilterButton, "click", ()=>this.close());
    }
    removeItemFromParent(item) {
        const sourceParentIndex = item.parent.conditions.indexOf(item.filterModel);
        item.parent.conditions.splice(sourceParentIndex, 1);
        return sourceParentIndex;
    }
    moveItemToIndex(item, destinationRowIndex, destinationPosition) {
        var _a;
        const destinationItem = this.items[destinationRowIndex];
        const destinationIsParent = ((_a = destinationItem.filterModel) == null ? void 0 : _a.filterType) === "join" && destinationPosition === "bottom";
        const destinationParent = destinationIsParent ? destinationItem.filterModel : destinationItem.parent;
        if (!destinationParent) return;
        if (this.isChildOrSelf(destinationParent, item.filterModel) || destinationItem === item) return;
        this.removeItemFromParent(item);
        let destinationParentIndex;
        if (destinationIsParent) destinationParentIndex = 0;
        else {
            destinationParentIndex = destinationParent.conditions.indexOf(destinationItem.filterModel);
            if (destinationParentIndex === -1) destinationParentIndex = destinationParent.conditions.length;
            else if (destinationPosition === "bottom") destinationParentIndex += 1;
        }
        destinationParent.conditions.splice(destinationParentIndex, 0, item.filterModel);
        this.refreshList(false);
    }
    isChildOrSelf(modelToCheck, potentialParentModel) {
        return modelToCheck === potentialParentModel || potentialParentModel.filterType === "join" && potentialParentModel.conditions.some((condition)=>this.isChildOrSelf(modelToCheck, condition));
    }
    setupFilterModel() {
        const filterModel = this.formatFilterModel(this.advancedFilterService.getModel());
        this.stringifiedModel = JSON.stringify(filterModel);
        return filterModel;
    }
    formatFilterModel(filterModel) {
        filterModel = filterModel != null ? filterModel : {
            filterType: "join",
            type: "AND",
            conditions: []
        };
        if (filterModel.filterType !== "join") filterModel = {
            filterType: "join",
            type: "AND",
            conditions: [
                filterModel
            ]
        };
        return filterModel;
    }
    buildList() {
        const parseFilterModel = (filterModel, items, level, parent)=>{
            items.push({
                filterModel: filterModel,
                level: level,
                parent: parent,
                valid: true,
                showMove: this.showMove
            });
            if (filterModel.filterType === "join") {
                filterModel.conditions.forEach((childFilterModel)=>parseFilterModel(childFilterModel, items, level + 1, filterModel));
                if (level === 0) items.push({
                    filterModel: null,
                    level: level + 1,
                    parent: filterModel,
                    valid: true
                });
            }
        };
        this.items = [];
        parseFilterModel(this.filterModel, this.items, 0);
    }
    refreshList(softRefresh) {
        if (!softRefresh) {
            const invalidModels = [];
            this.items.forEach((item)=>{
                if (!item.valid) invalidModels.push(item.filterModel);
            });
            this.buildList();
            if (invalidModels.length) this.items.forEach((item)=>{
                if (item.filterModel && invalidModels.includes(item.filterModel)) item.valid = false;
            });
        }
        this.virtualList.refresh(softRefresh);
        this.validate();
    }
    updateItemComponent(item, comp) {
        const index = this.items.indexOf(item);
        const populateTreeLines = (filterModel2, treeLines2)=>{
            const parentItem = this.items.find((itemToCheck)=>itemToCheck.filterModel === filterModel2);
            const parentFilterModel = parentItem == null ? void 0 : parentItem.parent;
            if (parentFilterModel) {
                const { conditions: conditions } = parentFilterModel;
                populateTreeLines(parentFilterModel, treeLines2);
                treeLines2.push(conditions[conditions.length - 1] === filterModel2);
            }
        };
        const treeLines = [];
        const { filterModel: filterModel } = item;
        if (filterModel) {
            populateTreeLines(filterModel, treeLines);
            treeLines[0] = false;
        }
        const showStartTreeLine = (filterModel == null ? void 0 : filterModel.filterType) === "join" && !!filterModel.conditions.length;
        comp.setState({
            disableMoveUp: index === 1,
            disableMoveDown: !this.canMoveDown(item, index),
            treeLines: treeLines,
            showStartTreeLine: showStartTreeLine
        });
    }
    createItemComponent(item, focusWrapper) {
        const itemComp = this.createBean(item.filterModel ? new $5b7ccabde48fae90$var$AdvancedFilterBuilderItemComp(item, this.dragFeature, focusWrapper) : new $5b7ccabde48fae90$var$AdvancedFilterBuilderItemAddComp(item, focusWrapper));
        itemComp.addManagedListener(itemComp, $5b7ccabde48fae90$var$AdvancedFilterBuilderEvents.EVENT_REMOVED, ({ item: item2 })=>this.removeItem(item2));
        itemComp.addManagedListener(itemComp, $5b7ccabde48fae90$var$AdvancedFilterBuilderEvents.EVENT_VALUE_CHANGED, ()=>this.validate());
        itemComp.addManagedListener(itemComp, $5b7ccabde48fae90$var$AdvancedFilterBuilderEvents.EVENT_ADDED, ({ item: item2, isJoin: isJoin })=>this.addItem(item2, isJoin));
        itemComp.addManagedListener(itemComp, $5b7ccabde48fae90$var$AdvancedFilterBuilderEvents.EVENT_MOVED, ({ item: item2, backwards: backwards })=>this.moveItemUpDown(item2, backwards));
        if (itemComp instanceof $5b7ccabde48fae90$var$AdvancedFilterBuilderItemComp) this.updateItemComponent(item, itemComp);
        return itemComp;
    }
    addItem(item, isJoin) {
        var _a;
        const { parent: itemParent, level: level, filterModel: itemFilterModel } = item;
        const itemIsJoin = (itemFilterModel == null ? void 0 : itemFilterModel.filterType) === "join";
        const filterModel = isJoin ? {
            filterType: "join",
            type: "AND",
            conditions: []
        } : {};
        const parent = itemIsJoin ? itemFilterModel : itemParent;
        let insertIndex = itemIsJoin ? 0 : parent.conditions.indexOf(itemFilterModel);
        if (insertIndex >= 0) {
            if (!itemIsJoin) insertIndex += 1;
            parent.conditions.splice(insertIndex, 0, filterModel);
        } else parent.conditions.push(filterModel);
        let index = this.items.indexOf(item);
        const softRefresh = index >= 0;
        if (softRefresh) {
            if (item.filterModel) index++;
            const newItems = [
                {
                    filterModel: filterModel,
                    level: itemIsJoin ? level + 1 : level,
                    parent: parent,
                    valid: isJoin,
                    showMove: this.showMove
                }
            ];
            this.items.splice(index, 0, ...newItems);
        }
        this.refreshList(softRefresh);
        if (softRefresh) (_a = this.virtualList.getComponentAt(index)) == null || _a.afterAdd();
    }
    removeItem(item) {
        var _a;
        const parent = item.parent;
        const { filterModel: filterModel } = item;
        const parentIndex = parent.conditions.indexOf(filterModel);
        parent.conditions.splice(parentIndex, 1);
        const isJoin = ((_a = item.filterModel) == null ? void 0 : _a.filterType) === "join";
        const index = this.items.indexOf(item);
        const softRefresh = !isJoin && index >= 0;
        if (softRefresh) this.items.splice(index, 1);
        this.refreshList(softRefresh);
        if (index >= 0) this.virtualList.focusRow(index);
    }
    moveItemUpDown(item, backwards) {
        const itemIndex = this.items.indexOf(item);
        const destinationIndex = backwards ? itemIndex - 1 : itemIndex + 1;
        if (destinationIndex === 0 || !backwards && !this.canMoveDown(item, itemIndex)) return;
        const destinationItem = this.items[destinationIndex];
        const indexInParent = this.removeItemFromParent(item);
        const { level: level, filterModel: filterModel, parent: parent } = item;
        const { level: destinationLevel, filterModel: destinationFilterModel, parent: destinationParent } = destinationItem;
        if (backwards) {
            if (destinationLevel === level && destinationFilterModel.filterType === "join") destinationFilterModel.conditions.push(filterModel);
            else if (destinationLevel <= level) {
                const destinationIndex2 = destinationParent.conditions.indexOf(destinationFilterModel);
                destinationParent.conditions.splice(destinationIndex2, 0, filterModel);
            } else {
                const newParentItem = parent.conditions[indexInParent - 1];
                newParentItem.conditions.push(filterModel);
            }
        } else {
            if (destinationLevel === level) {
                if (destinationFilterModel.filterType === "join") destinationFilterModel.conditions.splice(0, 0, filterModel);
                else {
                    const destinationIndex2 = destinationParent.conditions.indexOf(destinationFilterModel);
                    destinationParent.conditions.splice(destinationIndex2 + 1, 0, filterModel);
                }
            } else if (indexInParent < parent.conditions.length) parent.conditions.splice(indexInParent + 1, 0, filterModel);
            else {
                const parentItem = this.items.find((itemToCheck)=>itemToCheck.filterModel === parent);
                const destinationIndex2 = parentItem.parent.conditions.indexOf(parentItem.filterModel) + 1;
                parentItem.parent.conditions.splice(destinationIndex2, 0, filterModel);
            }
        }
        this.refreshList(false);
        const newIndex = this.items.findIndex(({ filterModel: filterModelToCheck })=>filterModelToCheck === filterModel);
        if (newIndex >= 0) {
            const comp = this.virtualList.getComponentAt(newIndex);
            if (comp instanceof $5b7ccabde48fae90$var$AdvancedFilterBuilderItemComp) comp.focusMoveButton(backwards);
        }
    }
    canMoveDown(item, index) {
        return !(item.level === 1 && index === this.items.length - 2 || item.level === 1 && item.parent.conditions[item.parent.conditions.length - 1] === item.filterModel);
    }
    close() {
        this.advancedFilterService.getCtrl().toggleFilterBuilder("ui");
    }
    validate() {
        let disableApply = !this.items.every(({ valid: valid })=>valid);
        if (!disableApply) {
            disableApply = JSON.stringify(this.filterModel) === this.stringifiedModel;
            if (disableApply) this.validationMessage = this.advancedFilterExpressionService.translate("advancedFilterBuilderValidationAlreadyApplied");
            else this.validationMessage = null;
        } else this.validationMessage = this.advancedFilterExpressionService.translate("advancedFilterBuilderValidationIncomplete");
        (0, $jIDNV._).setDisabled(this.eApplyFilterButton, disableApply);
        this.validationTooltipFeature.refreshToolTip();
    }
    validateItems() {
        const clearOperator = (filterModel)=>{
            filterModel.type = void 0;
        };
        const clearOperand = (filterModel)=>{
            delete filterModel.filter;
        };
        this.items.forEach((item)=>{
            if (!item.valid || !item.filterModel || item.filterModel.filterType === "join") return;
            const { filterModel: filterModel } = item;
            const { colId: colId } = filterModel;
            const hasColumn = this.advancedFilterExpressionService.getColumnAutocompleteEntries().find(({ key: key })=>key === colId);
            const columnDetails = this.advancedFilterExpressionService.getColumnDetails(filterModel.colId);
            if (!hasColumn || !columnDetails.column) {
                item.valid = false;
                filterModel.colId = void 0;
                clearOperator(filterModel);
                clearOperand(filterModel);
                return;
            }
            const operatorForType = this.advancedFilterExpressionService.getDataTypeExpressionOperator(columnDetails.baseCellDataType);
            const operator = operatorForType.operators[filterModel.type];
            if (!operator) {
                item.valid = false;
                clearOperator(filterModel);
                clearOperand(filterModel);
                return;
            }
            if (operator.numOperands > 0 && !(0, $jIDNV._).exists(filterModel.filter)) {
                item.valid = false;
                return;
            }
        });
    }
};
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.RefSelector)("eList")
], $5b7ccabde48fae90$var$AdvancedFilterBuilderComp.prototype, "eList", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.RefSelector)("eApplyFilterButton")
], $5b7ccabde48fae90$var$AdvancedFilterBuilderComp.prototype, "eApplyFilterButton", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.RefSelector)("eCancelFilterButton")
], $5b7ccabde48fae90$var$AdvancedFilterBuilderComp.prototype, "eCancelFilterButton", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.Autowired)("filterManager")
], $5b7ccabde48fae90$var$AdvancedFilterBuilderComp.prototype, "filterManager", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.Autowired)("advancedFilterService")
], $5b7ccabde48fae90$var$AdvancedFilterBuilderComp.prototype, "advancedFilterService", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.Autowired)("advancedFilterExpressionService")
], $5b7ccabde48fae90$var$AdvancedFilterBuilderComp.prototype, "advancedFilterExpressionService", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.Autowired)("beans")
], $5b7ccabde48fae90$var$AdvancedFilterBuilderComp.prototype, "beans", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$AdvancedFilterBuilderComp.prototype, "postConstruct", 1);
var $5b7ccabde48fae90$var$_AdvancedFilterCtrl = class _AdvancedFilterCtrl2 extends (0, $jIDNV.BeanStub) {
    constructor(enabled){
        super();
        this.enabled = enabled;
    }
    postConstruct() {
        this.hasAdvancedFilterParent = !!this.gos.get("advancedFilterParent");
        this.ctrlsService.whenReady(()=>this.setAdvancedFilterComp());
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_ADVANCED_FILTER_ENABLED_CHANGED, ({ enabled: enabled })=>this.onEnabledChanged(enabled));
        this.addManagedPropertyListener("advancedFilterParent", ()=>this.updateComps());
        this.addDestroyFunc(()=>{
            this.destroyAdvancedFilterComp();
            this.destroyBean(this.eBuilderComp);
            if (this.eBuilderDialog && this.eBuilderDialog.isAlive()) this.destroyBean(this.eBuilderDialog);
        });
    }
    setupHeaderComp(eCompToInsertBefore) {
        this.eHeaderComp = this.createManagedBean(new $5b7ccabde48fae90$var$AdvancedFilterHeaderComp(this.enabled && !this.hasAdvancedFilterParent));
        eCompToInsertBefore.insertAdjacentElement("beforebegin", this.eHeaderComp.getGui());
    }
    focusHeaderComp() {
        if (this.eHeaderComp) {
            this.eHeaderComp.getFocusableElement().focus();
            return true;
        }
        return false;
    }
    refreshComp() {
        var _a, _b;
        (_a = this.eFilterComp) == null || _a.refresh();
        (_b = this.eHeaderComp) == null || _b.refresh();
    }
    refreshBuilderComp() {
        var _a;
        (_a = this.eBuilderComp) == null || _a.refresh();
    }
    getHeaderHeight() {
        var _a, _b;
        return (_b = (_a = this.eHeaderComp) == null ? void 0 : _a.getHeight()) != null ? _b : 0;
    }
    setInputDisabled(disabled) {
        var _a, _b;
        (_a = this.eFilterComp) == null || _a.setInputDisabled(disabled);
        (_b = this.eHeaderComp) == null || _b.setInputDisabled(disabled);
    }
    toggleFilterBuilder(source, force) {
        if (force && this.eBuilderDialog || force === false && !this.eBuilderDialog) return;
        if (this.eBuilderDialog) {
            this.builderDestroySource = source;
            this.destroyBean(this.eBuilderDialog);
            return;
        }
        this.setInputDisabled(true);
        const { width: width, height: height, minWidth: minWidth } = this.getBuilderDialogSize();
        this.eBuilderComp = this.createBean(new $5b7ccabde48fae90$var$AdvancedFilterBuilderComp());
        this.eBuilderDialog = this.createBean(new (0, $jIDNV.AgDialog)({
            title: this.advancedFilterExpressionService.translate("advancedFilterBuilderTitle"),
            component: this.eBuilderComp,
            width: width,
            height: height,
            resizable: true,
            movable: true,
            maximizable: true,
            centered: true,
            closable: true,
            minWidth: minWidth,
            afterGuiAttached: ()=>{
                var _a;
                return (_a = this.eBuilderComp) == null ? void 0 : _a.afterGuiAttached();
            }
        }));
        this.dispatchFilterBuilderVisibleChangedEvent(source, true);
        this.eBuilderDialog.addEventListener((0, $jIDNV.AgDialog).EVENT_DESTROYED, ()=>{
            var _a;
            this.destroyBean(this.eBuilderComp);
            this.eBuilderComp = void 0;
            this.eBuilderDialog = void 0;
            this.setInputDisabled(false);
            this.dispatchEvent({
                type: _AdvancedFilterCtrl2.EVENT_BUILDER_CLOSED
            });
            this.dispatchFilterBuilderVisibleChangedEvent((_a = this.builderDestroySource) != null ? _a : "ui", false);
            this.builderDestroySource = void 0;
        });
    }
    dispatchFilterBuilderVisibleChangedEvent(source, visible) {
        const event = {
            type: (0, $jIDNV.Events).EVENT_ADVANCED_FILTER_BUILDER_VISIBLE_CHANGED,
            source: source,
            visible: visible
        };
        this.eventService.dispatchEvent(event);
    }
    getBuilderDialogSize() {
        var _a, _b;
        const minWidth = (_b = (_a = this.gos.get("advancedFilterBuilderParams")) == null ? void 0 : _a.minWidth) != null ? _b : 500;
        const popupParent = this.popupService.getPopupParent();
        const maxWidth = Math.round((0, $jIDNV._).getAbsoluteWidth(popupParent)) - 2;
        const maxHeight = Math.round((0, $jIDNV._).getAbsoluteHeight(popupParent) * 0.75) - 2;
        const width = Math.min(Math.max(600, minWidth), maxWidth);
        const height = Math.min(600, maxHeight);
        return {
            width: width,
            height: height,
            minWidth: minWidth
        };
    }
    onEnabledChanged(enabled) {
        this.enabled = enabled;
        this.updateComps();
    }
    updateComps() {
        this.setAdvancedFilterComp();
        this.setHeaderCompEnabled();
        this.eventService.dispatchEvent({
            type: (0, $jIDNV.Events).EVENT_HEADER_HEIGHT_CHANGED
        });
    }
    setAdvancedFilterComp() {
        this.destroyAdvancedFilterComp();
        if (!this.enabled) return;
        const advancedFilterParent = this.gos.get("advancedFilterParent");
        this.hasAdvancedFilterParent = !!advancedFilterParent;
        if (advancedFilterParent) {
            const eAdvancedFilterComp = this.createBean(new $5b7ccabde48fae90$var$AdvancedFilterComp());
            const eAdvancedFilterCompGui = eAdvancedFilterComp.getGui();
            const { allThemes: allThemes } = this.environment.getTheme();
            if (allThemes.length) eAdvancedFilterCompGui.classList.add(...allThemes);
            eAdvancedFilterCompGui.classList.add(this.gos.get("enableRtl") ? "ag-rtl" : "ag-ltr");
            advancedFilterParent.appendChild(eAdvancedFilterCompGui);
            this.eFilterComp = eAdvancedFilterComp;
        }
    }
    setHeaderCompEnabled() {
        var _a;
        (_a = this.eHeaderComp) == null || _a.setEnabled(this.enabled && !this.hasAdvancedFilterParent);
    }
    destroyAdvancedFilterComp() {
        if (this.eFilterComp) {
            (0, $jIDNV._).removeFromParent(this.eFilterComp.getGui());
            this.destroyBean(this.eFilterComp);
        }
    }
};
$5b7ccabde48fae90$var$_AdvancedFilterCtrl.EVENT_BUILDER_CLOSED = "advancedFilterBuilderClosed";
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.Autowired)("focusService")
], $5b7ccabde48fae90$var$_AdvancedFilterCtrl.prototype, "focusService", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.Autowired)("ctrlsService")
], $5b7ccabde48fae90$var$_AdvancedFilterCtrl.prototype, "ctrlsService", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.Autowired)("popupService")
], $5b7ccabde48fae90$var$_AdvancedFilterCtrl.prototype, "popupService", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.Autowired)("advancedFilterExpressionService")
], $5b7ccabde48fae90$var$_AdvancedFilterCtrl.prototype, "advancedFilterExpressionService", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_AdvancedFilterCtrl.prototype, "postConstruct", 1);
var $5b7ccabde48fae90$var$AdvancedFilterCtrl = $5b7ccabde48fae90$var$_AdvancedFilterCtrl;
var $5b7ccabde48fae90$var$AdvancedFilterComp = class extends (0, $jIDNV.Component) {
    constructor(){
        super(/* html */ `
            <div class="ag-advanced-filter" role="presentation" tabindex="-1">
                <ag-autocomplete ref="eAutocomplete"></ag-autocomplete>
                <button class="ag-button ag-standard-button ag-advanced-filter-apply-button" ref="eApplyFilterButton"></button>
                <button class="ag-advanced-filter-builder-button" ref="eBuilderFilterButton">
                    <span ref="eBuilderFilterButtonIcon" aria-hidden="true"></span>
                    <span class="ag-advanced-filter-builder-button-label" ref="eBuilderFilterButtonLabel"></span>
                </button>
            </div>`);
        this.expressionParser = null;
        this.isApplyDisabled = true;
        this.builderOpen = false;
    }
    postConstruct() {
        this.eAutocomplete.setListGenerator((_value, position)=>this.generateAutocompleteListParams(position)).setValidator(()=>this.validateValue()).setForceLastSelection((lastSelection, searchString)=>this.forceLastSelection(lastSelection, searchString)).setInputAriaLabel(this.advancedFilterExpressionService.translate("ariaAdvancedFilterInput")).setListAriaLabel(this.advancedFilterExpressionService.translate("ariaLabelAdvancedFilterAutocomplete"));
        this.refresh();
        this.addManagedListener(this.eAutocomplete, (0, $jIDNV.AgAutocomplete).EVENT_VALUE_CHANGED, ({ value: value })=>this.onValueChanged(value));
        this.addManagedListener(this.eAutocomplete, (0, $jIDNV.AgAutocomplete).EVENT_VALUE_CONFIRMED, ({ isValid: isValid })=>this.onValueConfirmed(isValid));
        this.addManagedListener(this.eAutocomplete, (0, $jIDNV.AgAutocomplete).EVENT_OPTION_SELECTED, ({ position: position, updateEntry: updateEntry, autocompleteType: autocompleteType })=>this.onOptionSelected(position, updateEntry, autocompleteType));
        this.addManagedListener(this.eAutocomplete, (0, $jIDNV.AgAutocomplete).EVENT_VALID_CHANGED, ({ isValid: isValid, validationMessage: validationMessage })=>this.onValidChanged(isValid, validationMessage));
        this.setupApplyButton();
        this.setupBuilderButton();
    }
    refresh() {
        const expression = this.advancedFilterService.getExpressionDisplayValue();
        this.eAutocomplete.setValue({
            value: expression != null ? expression : "",
            position: expression == null ? void 0 : expression.length,
            updateListOnlyIfOpen: true
        });
    }
    setInputDisabled(disabled) {
        this.eAutocomplete.setInputDisabled(disabled);
        (0, $jIDNV._).setDisabled(this.eApplyFilterButton, disabled || this.isApplyDisabled);
    }
    getTooltipParams() {
        const res = super.getTooltipParams();
        res.location = "advancedFilter";
        return res;
    }
    setupApplyButton() {
        this.eApplyFilterButton.innerText = this.advancedFilterExpressionService.translate("advancedFilterApply");
        this.activateTabIndex([
            this.eApplyFilterButton
        ]);
        this.addManagedListener(this.eApplyFilterButton, "click", ()=>this.onValueConfirmed(this.eAutocomplete.isValid()));
        (0, $jIDNV._).setDisabled(this.eApplyFilterButton, this.isApplyDisabled);
    }
    setupBuilderButton() {
        this.eBuilderFilterButtonIcon.appendChild((0, $jIDNV._).createIconNoSpan("advancedFilterBuilder", this.gos));
        this.eBuilderFilterButtonLabel.innerText = this.advancedFilterExpressionService.translate("advancedFilterBuilder");
        this.activateTabIndex([
            this.eBuilderFilterButton
        ]);
        this.addManagedListener(this.eBuilderFilterButton, "click", ()=>this.openBuilder());
        this.addManagedListener(this.advancedFilterService.getCtrl(), $5b7ccabde48fae90$var$AdvancedFilterCtrl.EVENT_BUILDER_CLOSED, ()=>this.closeBuilder());
    }
    onValueChanged(value) {
        var _a;
        value = (0, $jIDNV._).makeNull(value);
        this.advancedFilterService.setExpressionDisplayValue(value);
        this.expressionParser = this.advancedFilterService.createExpressionParser(value);
        const updatedExpression = (_a = this.expressionParser) == null ? void 0 : _a.parseExpression();
        if (updatedExpression && updatedExpression !== value) this.eAutocomplete.setValue({
            value: updatedExpression,
            silent: true,
            restoreFocus: true
        });
    }
    onValueConfirmed(isValid) {
        if (!isValid || this.isApplyDisabled) return;
        (0, $jIDNV._).setDisabled(this.eApplyFilterButton, true);
        this.advancedFilterService.applyExpression();
        this.filterManager.onFilterChanged({
            source: "advancedFilter"
        });
    }
    onOptionSelected(position, updateEntry, type) {
        const { updatedValue: updatedValue, updatedPosition: updatedPosition, hideAutocomplete: hideAutocomplete } = this.updateExpression(position, updateEntry, type);
        this.eAutocomplete.setValue({
            value: updatedValue,
            position: updatedPosition,
            updateListOnlyIfOpen: hideAutocomplete,
            restoreFocus: true
        });
    }
    validateValue() {
        var _a, _b, _c;
        return ((_a = this.expressionParser) == null ? void 0 : _a.isValid()) ? null : (_c = (_b = this.expressionParser) == null ? void 0 : _b.getValidationMessage()) != null ? _c : null;
    }
    onValidChanged(isValid, validationMessage) {
        this.isApplyDisabled = !isValid || this.advancedFilterService.isCurrentExpressionApplied();
        (0, $jIDNV._).setDisabled(this.eApplyFilterButton, this.isApplyDisabled);
        this.setTooltip({
            newTooltipText: validationMessage,
            showDelayOverride: 1e3
        });
    }
    generateAutocompleteListParams(position) {
        return this.expressionParser ? this.expressionParser.getAutocompleteListParams(position) : this.advancedFilterExpressionService.getDefaultAutocompleteListParams("");
    }
    updateExpression(position, updateEntry, type) {
        var _a, _b;
        this.advancedFilterExpressionService.updateAutocompleteCache(updateEntry, type);
        return (_b = (_a = this.expressionParser) == null ? void 0 : _a.updateExpression(position, updateEntry, type)) != null ? _b : this.advancedFilterService.getDefaultExpression(updateEntry);
    }
    forceLastSelection({ key: key, displayValue: displayValue }, searchString) {
        return !!searchString.toLocaleLowerCase().match(`^${(displayValue != null ? displayValue : key).toLocaleLowerCase()}\\s*$`);
    }
    openBuilder() {
        if (this.builderOpen) return;
        this.builderOpen = true;
        (0, $jIDNV._).setDisabled(this.eBuilderFilterButton, true);
        this.advancedFilterService.getCtrl().toggleFilterBuilder("ui");
    }
    closeBuilder() {
        if (!this.builderOpen) return;
        this.builderOpen = false;
        (0, $jIDNV._).setDisabled(this.eBuilderFilterButton, false);
        this.eBuilderFilterButton.focus();
    }
};
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.RefSelector)("eAutocomplete")
], $5b7ccabde48fae90$var$AdvancedFilterComp.prototype, "eAutocomplete", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.RefSelector)("eApplyFilterButton")
], $5b7ccabde48fae90$var$AdvancedFilterComp.prototype, "eApplyFilterButton", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.RefSelector)("eBuilderFilterButton")
], $5b7ccabde48fae90$var$AdvancedFilterComp.prototype, "eBuilderFilterButton", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.RefSelector)("eBuilderFilterButtonIcon")
], $5b7ccabde48fae90$var$AdvancedFilterComp.prototype, "eBuilderFilterButtonIcon", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.RefSelector)("eBuilderFilterButtonLabel")
], $5b7ccabde48fae90$var$AdvancedFilterComp.prototype, "eBuilderFilterButtonLabel", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.Autowired)("advancedFilterService")
], $5b7ccabde48fae90$var$AdvancedFilterComp.prototype, "advancedFilterService", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.Autowired)("advancedFilterExpressionService")
], $5b7ccabde48fae90$var$AdvancedFilterComp.prototype, "advancedFilterExpressionService", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.Autowired)("filterManager")
], $5b7ccabde48fae90$var$AdvancedFilterComp.prototype, "filterManager", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$AdvancedFilterComp.prototype, "postConstruct", 1);
var $5b7ccabde48fae90$var$ADVANCED_FILTER_LOCALE_TEXT = {
    ariaAdvancedFilterBuilderItem: (variableValues)=>`${variableValues[0]}. Level ${variableValues[1]}. Press ENTER to edit.`,
    ariaAdvancedFilterBuilderItemValidation: (variableValues)=>`${variableValues[0]}. Level ${variableValues[1]}. ${variableValues[2]} Press ENTER to edit.`,
    ariaAdvancedFilterBuilderList: "Advanced Filter Builder List",
    ariaAdvancedFilterBuilderFilterItem: "Filter Condition",
    ariaAdvancedFilterBuilderGroupItem: "Filter Group",
    ariaAdvancedFilterBuilderColumn: "Column",
    ariaAdvancedFilterBuilderOption: "Option",
    ariaAdvancedFilterBuilderValue: "Value",
    ariaAdvancedFilterBuilderJoinOperator: "Join Operator",
    ariaAdvancedFilterInput: "Advanced Filter Input",
    ariaLabelAdvancedFilterAutocomplete: "Advanced Filter Autocomplete",
    advancedFilterContains: "contains",
    advancedFilterNotContains: "does not contain",
    advancedFilterTextEquals: "equals",
    advancedFilterTextNotEqual: "does not equal",
    advancedFilterStartsWith: "begins with",
    advancedFilterEndsWith: "ends with",
    advancedFilterBlank: "is blank",
    advancedFilterNotBlank: "is not blank",
    advancedFilterEquals: "=",
    advancedFilterNotEqual: "!=",
    advancedFilterGreaterThan: ">",
    advancedFilterGreaterThanOrEqual: ">=",
    advancedFilterLessThan: "<",
    advancedFilterLessThanOrEqual: "<=",
    advancedFilterTrue: "is true",
    advancedFilterFalse: "is false",
    advancedFilterAnd: "AND",
    advancedFilterOr: "OR",
    advancedFilterApply: "Apply",
    advancedFilterBuilder: "Builder",
    advancedFilterValidationMissingColumn: "Column is missing",
    advancedFilterValidationMissingOption: "Option is missing",
    advancedFilterValidationMissingValue: "Value is missing",
    advancedFilterValidationInvalidColumn: "Column not found",
    advancedFilterValidationInvalidOption: "Option not found",
    advancedFilterValidationMissingQuote: "Value is missing an end quote",
    advancedFilterValidationNotANumber: "Value is not a number",
    advancedFilterValidationInvalidDate: "Value is not a valid date",
    advancedFilterValidationMissingCondition: "Condition is missing",
    advancedFilterValidationJoinOperatorMismatch: "Join operators within a condition must be the same",
    advancedFilterValidationInvalidJoinOperator: "Join operator not found",
    advancedFilterValidationMissingEndBracket: "Missing end bracket",
    advancedFilterValidationExtraEndBracket: "Too many end brackets",
    advancedFilterValidationMessage: (variableValues)=>`Expression has an error. ${variableValues[0]} - ${variableValues[1]}.`,
    advancedFilterValidationMessageAtEnd: (variableValues)=>`Expression has an error. ${variableValues[0]} at end of expression.`,
    advancedFilterBuilderTitle: "Advanced Filter",
    advancedFilterBuilderApply: "Apply",
    advancedFilterBuilderCancel: "Cancel",
    advancedFilterBuilderAddButtonTooltip: "Add Filter or Group",
    advancedFilterBuilderRemoveButtonTooltip: "Remove",
    advancedFilterBuilderMoveUpButtonTooltip: "Move Up",
    advancedFilterBuilderMoveDownButtonTooltip: "Move Down",
    advancedFilterBuilderAddJoin: "Add Group",
    advancedFilterBuilderAddCondition: "Add Filter",
    advancedFilterBuilderSelectColumn: "Select a column",
    advancedFilterBuilderSelectOption: "Select an option",
    advancedFilterBuilderEnterValue: "Enter a value...",
    advancedFilterBuilderValidationAlreadyApplied: "Current filter already applied.",
    advancedFilterBuilderValidationIncomplete: "Not all conditions are complete.",
    advancedFilterBuilderValidationSelectColumn: "Must select a column.",
    advancedFilterBuilderValidationSelectOption: "Must select an option.",
    advancedFilterBuilderValidationEnterValue: "Must enter a value."
};
function $5b7ccabde48fae90$var$getSearchString(value, position, endPosition) {
    if (!value) return "";
    const numChars = endPosition - position;
    return numChars ? value.slice(0, value.length - numChars) : value;
}
function $5b7ccabde48fae90$var$updateExpression(expression, startPosition, endPosition, updatedValuePart, appendSpace, appendQuote, empty) {
    const secondPartStartPosition = endPosition + (!expression.length || empty ? 0 : 1);
    let positionOffset = 0;
    if (appendSpace) {
        if (expression[secondPartStartPosition] === " ") positionOffset = 1;
        else {
            updatedValuePart += " ";
            if (appendQuote) updatedValuePart += `"`;
        }
    }
    const updatedValue = expression.slice(0, startPosition) + updatedValuePart + expression.slice(secondPartStartPosition);
    return {
        updatedValue: updatedValue,
        updatedPosition: startPosition + updatedValuePart.length + positionOffset
    };
}
function $5b7ccabde48fae90$var$findStartPosition(expression, position, endPosition) {
    let startPosition = position;
    while(startPosition < endPosition){
        const char = expression[startPosition];
        if (char !== " ") break;
        startPosition++;
    }
    return startPosition;
}
function $5b7ccabde48fae90$var$findEndPosition(expression, position, includeCloseBracket, isStartPositionUnknown) {
    let endPosition = position;
    let isEmpty = false;
    while(endPosition < expression.length){
        const char = expression[endPosition];
        if (char === "(") {
            if (isStartPositionUnknown && expression[endPosition - 1] === " ") isEmpty = true;
            else endPosition = endPosition - 1;
            break;
        } else if (char === " " || includeCloseBracket && char === ")") {
            endPosition = endPosition - 1;
            break;
        }
        endPosition++;
    }
    return {
        endPosition: endPosition,
        isEmpty: isEmpty
    };
}
function $5b7ccabde48fae90$var$checkAndUpdateExpression(params, userValue, displayValue, endPosition) {
    if (displayValue !== userValue) params.expression = $5b7ccabde48fae90$var$updateExpression(params.expression, endPosition - userValue.length + 1, endPosition, displayValue).updatedValue;
}
function $5b7ccabde48fae90$var$escapeQuotes(value) {
    return value.replace(/(['"])/, "\\$1");
}
var $5b7ccabde48fae90$var$ColumnParser = class {
    constructor(params, startPosition){
        this.params = params;
        this.startPosition = startPosition;
        this.type = "column";
        this.valid = true;
        this.hasStartChar = false;
        this.hasEndChar = false;
        this.colName = "";
    }
    parse(char, position) {
        if (char === $5b7ccabde48fae90$var$ColFilterExpressionParser.COL_START_CHAR && !this.colName) this.hasStartChar = true;
        else if (char === $5b7ccabde48fae90$var$ColFilterExpressionParser.COL_END_CHAR && this.hasStartChar) {
            const isMatch = this.parseColumn(false, position);
            if (isMatch) {
                this.hasEndChar = true;
                return false;
            } else this.colName += char;
        } else this.colName += char;
        return void 0;
    }
    getDisplayValue() {
        return (this.hasStartChar ? $5b7ccabde48fae90$var$ColFilterExpressionParser.COL_START_CHAR : "") + this.colName + (this.hasEndChar ? $5b7ccabde48fae90$var$ColFilterExpressionParser.COL_END_CHAR : "");
    }
    getColId() {
        return this.colId;
    }
    complete(position) {
        this.parseColumn(true, position);
    }
    getValidationError() {
        var _a;
        return this.valid ? null : {
            message: this.params.advancedFilterExpressionService.translate("advancedFilterValidationInvalidColumn"),
            startPosition: this.startPosition,
            endPosition: (_a = this.endPosition) != null ? _a : this.params.expression.length - 1
        };
    }
    parseColumn(fromComplete, endPosition) {
        var _a;
        this.endPosition = endPosition;
        const colValue = this.params.advancedFilterExpressionService.getColId(this.colName);
        if (colValue && this.hasStartChar) {
            this.colId = colValue.colId;
            $5b7ccabde48fae90$var$checkAndUpdateExpression(this.params, this.colName, colValue.columnName, endPosition - 1);
            this.colName = colValue.columnName;
            this.column = this.params.columnModel.getPrimaryColumn(this.colId);
            if (this.column) {
                this.baseCellDataType = (_a = this.params.dataTypeService.getBaseDataType(this.column)) != null ? _a : "text";
                return true;
            }
        }
        if (fromComplete) this.valid = false;
        this.baseCellDataType = "text";
        return false;
    }
};
var $5b7ccabde48fae90$var$OperatorParser = class {
    constructor(params, startPosition, baseCellDataType){
        this.params = params;
        this.startPosition = startPosition;
        this.baseCellDataType = baseCellDataType;
        this.type = "operator";
        this.valid = true;
        this.expectedNumOperands = 0;
        this.operator = "";
    }
    parse(char, position) {
        if (char === " " || char === ")") {
            const isMatch = this.parseOperator(false, position - 1);
            if (isMatch) return true;
            else this.operator += char;
        } else this.operator += char;
        return void 0;
    }
    complete(position) {
        this.parseOperator(true, position);
    }
    getValidationError() {
        var _a;
        return this.valid ? null : {
            message: this.params.advancedFilterExpressionService.translate("advancedFilterValidationInvalidOption"),
            startPosition: this.startPosition,
            endPosition: (_a = this.endPosition) != null ? _a : this.params.expression.length - 1
        };
    }
    getDisplayValue() {
        return this.operator;
    }
    getOperatorKey() {
        return this.parsedOperator;
    }
    parseOperator(fromComplete, endPosition) {
        const operatorForType = this.params.advancedFilterExpressionService.getDataTypeExpressionOperator(this.baseCellDataType);
        const parsedOperator = operatorForType.findOperator(this.operator);
        this.endPosition = endPosition;
        if (parsedOperator) {
            this.parsedOperator = parsedOperator;
            const operator = operatorForType.operators[parsedOperator];
            this.expectedNumOperands = operator.numOperands;
            const operatorDisplayValue = operator.displayValue;
            $5b7ccabde48fae90$var$checkAndUpdateExpression(this.params, this.operator, operatorDisplayValue, endPosition);
            this.operator = operatorDisplayValue;
            return true;
        }
        const isPartialMatch = parsedOperator === null;
        if (fromComplete || !isPartialMatch) this.valid = false;
        return false;
    }
};
var $5b7ccabde48fae90$var$OperandParser = class {
    constructor(params, startPosition, baseCellDataType, column){
        this.params = params;
        this.startPosition = startPosition;
        this.baseCellDataType = baseCellDataType;
        this.column = column;
        this.type = "operand";
        this.valid = true;
        this.operand = "";
        this.validationMessage = null;
    }
    parse(char, position) {
        if (char === " ") {
            if (this.quotes) this.operand += char;
            else {
                this.parseOperand(false, position);
                return true;
            }
        } else if (char === ")") {
            if (this.baseCellDataType === "number" || !this.quotes) {
                this.parseOperand(false, position - 1);
                return true;
            } else this.operand += char;
        } else if (!this.operand && !this.quotes && (char === `'` || char === `"`)) this.quotes = char;
        else if (this.quotes && char === this.quotes) {
            this.parseOperand(false, position);
            return false;
        } else this.operand += char;
        return void 0;
    }
    complete(position) {
        this.parseOperand(true, position);
    }
    getValidationError() {
        var _a;
        return this.validationMessage ? {
            message: this.validationMessage,
            startPosition: this.startPosition,
            endPosition: (_a = this.endPosition) != null ? _a : this.params.expression.length - 1
        } : null;
    }
    getRawValue() {
        return this.operand;
    }
    getModelValue() {
        return this.modelValue;
    }
    parseOperand(fromComplete, position) {
        const { advancedFilterExpressionService: advancedFilterExpressionService } = this.params;
        this.endPosition = position;
        this.modelValue = this.operand;
        if (fromComplete && this.quotes) {
            this.valid = false;
            this.validationMessage = advancedFilterExpressionService.translate("advancedFilterValidationMissingQuote");
        } else if (this.modelValue === "") {
            this.valid = false;
            this.validationMessage = advancedFilterExpressionService.translate("advancedFilterValidationMissingValue");
        } else {
            const modelValue = advancedFilterExpressionService.getOperandModelValue(this.operand, this.baseCellDataType, this.column);
            if (modelValue != null) this.modelValue = modelValue;
            switch(this.baseCellDataType){
                case "number":
                    if (this.quotes || isNaN(this.modelValue)) {
                        this.valid = false;
                        this.validationMessage = advancedFilterExpressionService.translate("advancedFilterValidationNotANumber");
                    }
                    break;
                case "date":
                case "dateString":
                    if (modelValue == null) {
                        this.valid = false;
                        this.validationMessage = advancedFilterExpressionService.translate("advancedFilterValidationInvalidDate");
                    }
                    break;
            }
        }
    }
};
var $5b7ccabde48fae90$var$ColFilterExpressionParser = class {
    constructor(params, startPosition){
        this.params = params;
        this.startPosition = startPosition;
        this.isAwaiting = true;
    }
    parseExpression() {
        var _a, _b;
        let i = this.startPosition;
        const { expression: expression } = this.params;
        while(i < expression.length){
            const char = expression[i];
            if (char === " " && this.isAwaiting) ;
            else {
                this.isAwaiting = false;
                if (!this.parser) {
                    let parser;
                    if (!this.columnParser) {
                        this.columnParser = new $5b7ccabde48fae90$var$ColumnParser(this.params, i);
                        parser = this.columnParser;
                    } else if (!this.operatorParser) {
                        this.operatorParser = new $5b7ccabde48fae90$var$OperatorParser(this.params, i, this.columnParser.baseCellDataType);
                        parser = this.operatorParser;
                    } else {
                        this.operandParser = new $5b7ccabde48fae90$var$OperandParser(this.params, i, this.columnParser.baseCellDataType, this.columnParser.column);
                        parser = this.operandParser;
                    }
                    this.parser = parser;
                }
                const hasCompletedOnPrevChar = this.parser.parse(char, i);
                if (hasCompletedOnPrevChar != null) {
                    if (this.isComplete()) return this.returnEndPosition(hasCompletedOnPrevChar ? i - 1 : i, true);
                    this.parser = void 0;
                    this.isAwaiting = true;
                }
            }
            i++;
        }
        (_b = (_a = this.parser) == null ? void 0 : _a.complete) == null || _b.call(_a, i - 1);
        return this.returnEndPosition(i);
    }
    isValid() {
        return this.isComplete() && this.columnParser.valid && this.operatorParser.valid && (!this.operandParser || this.operandParser.valid);
    }
    getValidationError() {
        var _a, _b, _c, _d, _e;
        const validationError = (_e = (_c = (_a = this.columnParser) == null ? void 0 : _a.getValidationError()) != null ? _c : (_b = this.operatorParser) == null ? void 0 : _b.getValidationError()) != null ? _e : (_d = this.operandParser) == null ? void 0 : _d.getValidationError();
        if (validationError) return validationError;
        const endPosition = this.params.expression.length;
        let translateKey;
        if (!this.columnParser) translateKey = "advancedFilterValidationMissingColumn";
        else if (!this.operatorParser) translateKey = "advancedFilterValidationMissingOption";
        else if (this.operatorParser.expectedNumOperands && !this.operandParser) translateKey = "advancedFilterValidationMissingValue";
        if (translateKey) return {
            message: this.params.advancedFilterExpressionService.translate(translateKey),
            startPosition: endPosition,
            endPosition: endPosition
        };
        return null;
    }
    getFunctionString(params) {
        return this.getFunctionCommon(params, (operandIndex, operatorIndex, colId, evaluatorParamsIndex)=>{
            const escapedColId = $5b7ccabde48fae90$var$escapeQuotes(colId);
            const operand = operandIndex == null ? "" : `, params.operands[${operandIndex}]`;
            return `params.operators[${operatorIndex}].evaluator(expressionProxy.getValue('${escapedColId}', node), node, params.evaluatorParams[${evaluatorParamsIndex}]${operand})`;
        });
    }
    getFunctionParsed(params) {
        return this.getFunctionCommon(params, (operandIndex, operatorIndex, colId, evaluatorParamsIndex)=>{
            return (expressionProxy, node, p)=>p.operators[operatorIndex].evaluator(expressionProxy.getValue(colId, node), node, p.evaluatorParams[evaluatorParamsIndex], operandIndex == null ? void 0 : p.operands[operandIndex]);
        });
    }
    getAutocompleteListParams(position) {
        if (this.isColumnPosition(position)) return this.getColumnAutocompleteListParams(position);
        if (this.isOperatorPosition(position)) return this.getOperatorAutocompleteListParams(position);
        if (this.isBeyondEndPosition(position)) return void 0;
        return {
            enabled: false
        };
    }
    updateExpression(position, updateEntry, type) {
        var _a, _b, _c, _d, _e;
        const { expression: expression } = this.params;
        if (this.isColumnPosition(position)) return $5b7ccabde48fae90$var$updateExpression(this.params.expression, this.startPosition, ((_a = this.columnParser) == null ? void 0 : _a.getColId()) ? this.columnParser.endPosition : $5b7ccabde48fae90$var$findEndPosition(expression, position).endPosition, this.params.advancedFilterExpressionService.getColumnValue(updateEntry), true);
        else if (this.isOperatorPosition(position)) {
            const baseCellDataType = this.getBaseCellDataTypeFromOperatorAutocompleteType(type);
            const hasOperand = this.hasOperand(baseCellDataType, updateEntry.key);
            const doesOperandNeedQuotes = hasOperand && this.doesOperandNeedQuotes(baseCellDataType);
            let update;
            if (((_b = this.operatorParser) == null ? void 0 : _b.startPosition) != null && position < this.operatorParser.startPosition) update = $5b7ccabde48fae90$var$updateExpression(expression, position, position, (_c = updateEntry.displayValue) != null ? _c : updateEntry.key, hasOperand, doesOperandNeedQuotes);
            else {
                let endPosition;
                let empty = false;
                if ((_d = this.operatorParser) == null ? void 0 : _d.getOperatorKey()) endPosition = this.operatorParser.endPosition;
                else {
                    const { endPosition: calculatedEndPosition, isEmpty: isEmpty } = $5b7ccabde48fae90$var$findEndPosition(expression, position, true, true);
                    endPosition = calculatedEndPosition;
                    empty = isEmpty;
                }
                update = $5b7ccabde48fae90$var$updateExpression(expression, $5b7ccabde48fae90$var$findStartPosition(expression, this.columnParser.endPosition + 1, endPosition), endPosition, (_e = updateEntry.displayValue) != null ? _e : updateEntry.key, hasOperand, doesOperandNeedQuotes, empty);
            }
            return $5b7ccabde48fae90$var$__spreadProps($5b7ccabde48fae90$var$__spreadValues({}, update), {
                hideAutocomplete: !hasOperand
            });
        }
        return null;
    }
    getModel() {
        const colId = this.columnParser.getColId();
        const model = {
            filterType: this.columnParser.baseCellDataType,
            colId: colId,
            type: this.operatorParser.getOperatorKey()
        };
        if (this.operatorParser.expectedNumOperands) model.filter = this.operandParser.getModelValue();
        return model;
    }
    getFunctionCommon(params, processFunc) {
        var _a, _b;
        const colId = this.columnParser.getColId();
        const operator = (_a = this.operatorParser) == null ? void 0 : _a.getOperatorKey();
        const { operators: operators, evaluatorParams: evaluatorParams, operands: operands } = params;
        const operatorForColumn = this.params.advancedFilterExpressionService.getExpressionOperator(this.columnParser.baseCellDataType, operator);
        const operatorIndex = this.addToListAndGetIndex(operators, operatorForColumn);
        const evaluatorParamsForColumn = this.params.advancedFilterExpressionService.getExpressionEvaluatorParams(colId);
        const evaluatorParamsIndex = this.addToListAndGetIndex(evaluatorParams, evaluatorParamsForColumn);
        const operandIndex = ((_b = this.operatorParser) == null ? void 0 : _b.expectedNumOperands) === 0 ? void 0 : this.addToListAndGetIndex(operands, this.getOperandValue());
        return processFunc(operandIndex, operatorIndex, colId, evaluatorParamsIndex);
    }
    getOperandValue() {
        let operand = this.operandParser.getRawValue();
        const { baseCellDataType: baseCellDataType, column: column } = this.columnParser;
        switch(baseCellDataType){
            case "number":
                operand = Number(operand);
                break;
            case "date":
            case "dateString":
                operand = this.params.valueService.parseValue(column, null, operand, void 0);
                break;
        }
        if (baseCellDataType === "dateString") return this.params.dataTypeService.getDateParserFunction(column)(operand);
        return operand;
    }
    isComplete() {
        return !!(this.operatorParser && (!this.operatorParser.expectedNumOperands || this.operatorParser.expectedNumOperands && this.operandParser));
    }
    isColumnPosition(position) {
        return !this.columnParser || this.columnParser.endPosition == null || position <= this.columnParser.endPosition + 1;
    }
    isOperatorPosition(position) {
        return !this.operatorParser || this.operatorParser.endPosition == null || position <= this.operatorParser.endPosition + 1;
    }
    isBeyondEndPosition(position) {
        return this.isComplete() && this.endPosition != null && position > this.endPosition + 1 && this.endPosition + 1 < this.params.expression.length;
    }
    returnEndPosition(returnPosition, treatAsEnd) {
        this.endPosition = treatAsEnd ? returnPosition : returnPosition - 1;
        return returnPosition;
    }
    getColumnAutocompleteListParams(position) {
        return this.params.advancedFilterExpressionService.generateAutocompleteListParams(this.params.advancedFilterExpressionService.getColumnAutocompleteEntries(), "column", this.getColumnSearchString(position));
    }
    getColumnSearchString(position) {
        var _a, _b, _c, _d, _e;
        const columnName = (_b = (_a = this.columnParser) == null ? void 0 : _a.getDisplayValue()) != null ? _b : "";
        const searchString = $5b7ccabde48fae90$var$getSearchString(columnName, position, ((_c = this.columnParser) == null ? void 0 : _c.endPosition) == null ? this.params.expression.length : this.columnParser.endPosition + 1);
        const containsStartChar = ((_d = this.columnParser) == null ? void 0 : _d.hasStartChar) && searchString.length > 0;
        const containsEndChar = ((_e = this.columnParser) == null ? void 0 : _e.hasEndChar) && searchString.length === columnName.length + 2;
        if (containsStartChar) return searchString.slice(1, containsEndChar ? -1 : void 0);
        return searchString;
    }
    getOperatorAutocompleteListParams(position) {
        var _a, _b, _c, _d, _e;
        const column = (_a = this.columnParser) == null ? void 0 : _a.column;
        if (!column) return {
            enabled: false
        };
        const baseCellDataType = this.columnParser.baseCellDataType;
        const searchString = ((_b = this.operatorParser) == null ? void 0 : _b.startPosition) != null && position < this.operatorParser.startPosition ? "" : $5b7ccabde48fae90$var$getSearchString((_d = (_c = this.operatorParser) == null ? void 0 : _c.getDisplayValue()) != null ? _d : "", position, ((_e = this.operatorParser) == null ? void 0 : _e.endPosition) == null ? this.params.expression.length : this.operatorParser.endPosition + 1);
        return this.params.advancedFilterExpressionService.generateAutocompleteListParams(this.params.advancedFilterExpressionService.getOperatorAutocompleteEntries(column, baseCellDataType), `operator-${baseCellDataType}`, searchString);
    }
    getBaseCellDataTypeFromOperatorAutocompleteType(type) {
        return type == null ? void 0 : type.replace("operator-", "");
    }
    hasOperand(baseCellDataType, operator) {
        var _a, _b;
        return !baseCellDataType || !operator || ((_b = (_a = this.params.advancedFilterExpressionService.getExpressionOperator(baseCellDataType, operator)) == null ? void 0 : _a.numOperands) != null ? _b : 0) > 0;
    }
    doesOperandNeedQuotes(baseCellDataType) {
        return baseCellDataType !== "number";
    }
    addToListAndGetIndex(list, value) {
        const index = list.length;
        list.push(value);
        return index;
    }
};
$5b7ccabde48fae90$var$ColFilterExpressionParser.COL_START_CHAR = "[";
$5b7ccabde48fae90$var$ColFilterExpressionParser.COL_END_CHAR = "]";
function $5b7ccabde48fae90$var$findMatch(searchValue, values, getDisplayValue) {
    let partialMatch = false;
    const searchValueLowerCase = searchValue.toLocaleLowerCase();
    const partialSearchValue = searchValueLowerCase + " ";
    const parsedValue = Object.entries(values).find(([_key, value])=>{
        const displayValueLowerCase = getDisplayValue(value).toLocaleLowerCase();
        if (displayValueLowerCase.startsWith(partialSearchValue)) partialMatch = true;
        return displayValueLowerCase === searchValueLowerCase;
    });
    if (parsedValue) return parsedValue[0];
    else if (partialMatch) return null;
    else return void 0;
}
function $5b7ccabde48fae90$var$getEntries(operators, activeOperatorKeys) {
    const keys = activeOperatorKeys != null ? activeOperatorKeys : Object.keys(operators);
    return keys.map((key)=>({
            key: key,
            displayValue: operators[key].displayValue
        }));
}
var $5b7ccabde48fae90$var$TextFilterExpressionOperators = class {
    constructor(params){
        this.params = params;
        this.initOperators();
    }
    getEntries(activeOperators) {
        return $5b7ccabde48fae90$var$getEntries(this.operators, activeOperators);
    }
    findOperator(displayValue) {
        return $5b7ccabde48fae90$var$findMatch(displayValue, this.operators, ({ displayValue: displayValue2 })=>displayValue2);
    }
    initOperators() {
        const { translate: translate } = this.params;
        this.operators = {
            contains: {
                displayValue: translate("advancedFilterContains"),
                evaluator: (value, node, params, operand1)=>this.evaluateExpression(value, node, params, operand1, false, (v, o)=>v.includes(o)),
                numOperands: 1
            },
            notContains: {
                displayValue: translate("advancedFilterNotContains"),
                evaluator: (value, node, params, operand1)=>this.evaluateExpression(value, node, params, operand1, true, (v, o)=>!v.includes(o)),
                numOperands: 1
            },
            equals: {
                displayValue: translate("advancedFilterTextEquals"),
                evaluator: (value, node, params, operand1)=>this.evaluateExpression(value, node, params, operand1, false, (v, o)=>v === o),
                numOperands: 1
            },
            notEqual: {
                displayValue: translate("advancedFilterTextNotEqual"),
                evaluator: (value, node, params, operand1)=>this.evaluateExpression(value, node, params, operand1, true, (v, o)=>v != o),
                numOperands: 1
            },
            startsWith: {
                displayValue: translate("advancedFilterStartsWith"),
                evaluator: (value, node, params, operand1)=>this.evaluateExpression(value, node, params, operand1, false, (v, o)=>v.startsWith(o)),
                numOperands: 1
            },
            endsWith: {
                displayValue: translate("advancedFilterEndsWith"),
                evaluator: (value, node, params, operand1)=>this.evaluateExpression(value, node, params, operand1, false, (v, o)=>v.endsWith(o)),
                numOperands: 1
            },
            blank: {
                displayValue: translate("advancedFilterBlank"),
                evaluator: (value)=>value == null || typeof value === "string" && value.trim().length === 0,
                numOperands: 0
            },
            notBlank: {
                displayValue: translate("advancedFilterNotBlank"),
                evaluator: (value)=>value != null && (typeof value !== "string" || value.trim().length > 0),
                numOperands: 0
            }
        };
    }
    evaluateExpression(value, node, params, operand, nullsMatch, expression) {
        if (value == null) return nullsMatch;
        return params.caseSensitive ? expression(params.valueConverter(value, node), operand) : expression(params.valueConverter(value, node).toLocaleLowerCase(), operand.toLocaleLowerCase());
    }
};
var $5b7ccabde48fae90$var$ScalarFilterExpressionOperators = class {
    constructor(params){
        this.params = params;
        this.initOperators();
    }
    getEntries(activeOperators) {
        return $5b7ccabde48fae90$var$getEntries(this.operators, activeOperators);
    }
    findOperator(displayValue) {
        return $5b7ccabde48fae90$var$findMatch(displayValue, this.operators, ({ displayValue: displayValue2 })=>displayValue2);
    }
    initOperators() {
        const { translate: translate, equals: equals } = this.params;
        this.operators = {
            equals: {
                displayValue: translate("advancedFilterEquals"),
                evaluator: (value, node, params, operand1)=>this.evaluateSingleOperandExpression(value, node, params, operand1, !!params.includeBlanksInEquals, equals),
                numOperands: 1
            },
            notEqual: {
                displayValue: translate("advancedFilterNotEqual"),
                evaluator: (value, node, params, operand1)=>this.evaluateSingleOperandExpression(value, node, params, operand1, !!params.includeBlanksInEquals, (v, o)=>!equals(v, o)),
                numOperands: 1
            },
            greaterThan: {
                displayValue: translate("advancedFilterGreaterThan"),
                evaluator: (value, node, params, operand1)=>this.evaluateSingleOperandExpression(value, node, params, operand1, !!params.includeBlanksInGreaterThan, (v, o)=>v > o),
                numOperands: 1
            },
            greaterThanOrEqual: {
                displayValue: translate("advancedFilterGreaterThanOrEqual"),
                evaluator: (value, node, params, operand1)=>this.evaluateSingleOperandExpression(value, node, params, operand1, !!params.includeBlanksInGreaterThan, (v, o)=>v >= o),
                numOperands: 1
            },
            lessThan: {
                displayValue: translate("advancedFilterLessThan"),
                evaluator: (value, node, params, operand1)=>this.evaluateSingleOperandExpression(value, node, params, operand1, !!params.includeBlanksInLessThan, (v, o)=>v < o),
                numOperands: 1
            },
            lessThanOrEqual: {
                displayValue: translate("advancedFilterLessThanOrEqual"),
                evaluator: (value, node, params, operand1)=>this.evaluateSingleOperandExpression(value, node, params, operand1, !!params.includeBlanksInLessThan, (v, o)=>v <= o),
                numOperands: 1
            },
            blank: {
                displayValue: translate("advancedFilterBlank"),
                evaluator: (value)=>value == null,
                numOperands: 0
            },
            notBlank: {
                displayValue: translate("advancedFilterNotBlank"),
                evaluator: (value)=>value != null,
                numOperands: 0
            }
        };
    }
    evaluateSingleOperandExpression(value, node, params, operand, nullsMatch, expression) {
        if (value == null) return nullsMatch;
        return expression(params.valueConverter(value, node), operand);
    }
};
var $5b7ccabde48fae90$var$BooleanFilterExpressionOperators = class {
    constructor(params){
        this.params = params;
        this.initOperators();
    }
    getEntries(activeOperators) {
        return $5b7ccabde48fae90$var$getEntries(this.operators, activeOperators);
    }
    findOperator(displayValue) {
        return $5b7ccabde48fae90$var$findMatch(displayValue, this.operators, ({ displayValue: displayValue2 })=>displayValue2);
    }
    initOperators() {
        const { translate: translate } = this.params;
        this.operators = {
            true: {
                displayValue: translate("advancedFilterTrue"),
                evaluator: (value)=>!!value,
                numOperands: 0
            },
            false: {
                displayValue: translate("advancedFilterFalse"),
                evaluator: (value)=>value === false,
                numOperands: 0
            },
            blank: {
                displayValue: translate("advancedFilterBlank"),
                evaluator: (value)=>value == null,
                numOperands: 0
            },
            notBlank: {
                displayValue: translate("advancedFilterNotBlank"),
                evaluator: (value)=>value != null,
                numOperands: 0
            }
        };
    }
};
var $5b7ccabde48fae90$var$AdvancedFilterExpressionService = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.columnNameToIdMap = {};
        this.columnAutocompleteEntries = null;
        this.expressionEvaluatorParams = {};
    }
    postConstruct() {
        this.expressionJoinOperators = this.generateExpressionJoinOperators();
        this.expressionOperators = this.generateExpressionOperators();
    }
    parseJoinOperator(model) {
        var _a;
        const { type: type } = model;
        return (_a = this.expressionJoinOperators[type]) != null ? _a : type;
    }
    getColumnDisplayValue(model) {
        const { colId: colId } = model;
        const columnEntries = this.getColumnAutocompleteEntries();
        const columnEntry = columnEntries.find(({ key: key })=>key === colId);
        let columnName;
        if (columnEntry) {
            columnName = columnEntry.displayValue;
            this.columnNameToIdMap[columnName.toLocaleUpperCase()] = {
                colId: colId,
                columnName: columnName
            };
        } else columnName = colId;
        return columnName;
    }
    getOperatorDisplayValue(model) {
        var _a, _b;
        return (_b = (_a = this.getExpressionOperator(model.filterType, model.type)) == null ? void 0 : _a.displayValue) != null ? _b : model.type;
    }
    getOperandModelValue(operand, baseCellDataType, column) {
        var _a;
        switch(baseCellDataType){
            case "number":
                return (0, $jIDNV._).exists(operand) ? Number(operand) : null;
            case "date":
                return (0, $jIDNV._).serialiseDate(this.valueService.parseValue(column, null, operand, void 0), false);
            case "dateString":
                const parsedDateString = this.valueService.parseValue(column, null, operand, void 0);
                return (0, $jIDNV._).serialiseDate((_a = this.dataTypeService.getDateParserFunction(column)(parsedDateString)) != null ? _a : null, false);
        }
        return operand;
    }
    getOperandDisplayValue(model, skipFormatting) {
        var _a, _b;
        const { colId: colId, filter: filter } = model;
        const column = this.columnModel.getPrimaryColumn(colId);
        let operand = "";
        if (filter != null) {
            let operand1;
            switch(model.filterType){
                case "number":
                    operand1 = (_a = (0, $jIDNV._).toStringOrNull(filter)) != null ? _a : "";
                    break;
                case "date":
                    const dateValue = (0, $jIDNV._).parseDateTimeFromString(filter);
                    operand1 = column ? this.valueService.formatValue(column, null, dateValue) : null;
                    break;
                case "dateString":
                    const dateStringDateValue = (0, $jIDNV._).parseDateTimeFromString(filter);
                    const dateStringStringValue = column ? this.dataTypeService.getDateFormatterFunction(column)(dateStringDateValue != null ? dateStringDateValue : void 0) : null;
                    operand1 = column ? this.valueService.formatValue(column, null, dateStringStringValue) : null;
                    break;
            }
            if (model.filterType !== "number") {
                operand1 = (_b = operand1 != null ? operand1 : (0, $jIDNV._).toStringOrNull(filter)) != null ? _b : "";
                if (!skipFormatting) operand1 = `"${operand1}"`;
            }
            operand = skipFormatting ? operand1 : ` ${operand1}`;
        }
        return operand;
    }
    parseColumnFilterModel(model) {
        var _a, _b;
        const columnName = (_a = this.getColumnDisplayValue(model)) != null ? _a : "";
        const operator = (_b = this.getOperatorDisplayValue(model)) != null ? _b : "";
        const operands = this.getOperandDisplayValue(model);
        return `[${columnName}] ${operator}${operands}`;
    }
    updateAutocompleteCache(updateEntry, type) {
        if (type === "column") {
            const { key: colId, displayValue: displayValue } = updateEntry;
            this.columnNameToIdMap[updateEntry.displayValue.toLocaleUpperCase()] = {
                colId: colId,
                columnName: displayValue
            };
        }
    }
    translate(key, variableValues) {
        let defaultValue = $5b7ccabde48fae90$var$ADVANCED_FILTER_LOCALE_TEXT[key];
        if (typeof defaultValue === "function") defaultValue = defaultValue(variableValues);
        return this.localeService.getLocaleTextFunc()(key, defaultValue, variableValues);
    }
    generateAutocompleteListParams(entries, type, searchString) {
        return {
            enabled: true,
            type: type,
            searchString: searchString,
            entries: entries
        };
    }
    getColumnAutocompleteEntries() {
        var _a;
        if (this.columnAutocompleteEntries) return this.columnAutocompleteEntries;
        const columns = (_a = this.columnModel.getAllPrimaryColumns()) != null ? _a : [];
        const entries = [];
        const includeHiddenColumns = this.gos.get("includeHiddenColumnsInAdvancedFilter");
        columns.forEach((column)=>{
            if (column.getColDef().filter && (includeHiddenColumns || column.isVisible() || column.isRowGroupActive())) entries.push({
                key: column.getColId(),
                displayValue: this.columnModel.getDisplayNameForColumn(column, "advancedFilter")
            });
        });
        entries.sort((a, b)=>{
            var _a2, _b;
            const aValue = (_a2 = a.displayValue) != null ? _a2 : "";
            const bValue = (_b = b.displayValue) != null ? _b : "";
            if (aValue < bValue) return -1;
            else if (bValue > aValue) return 1;
            return 0;
        });
        return entries;
    }
    getOperatorAutocompleteEntries(column, baseCellDataType) {
        const activeOperators = this.getActiveOperators(column);
        return this.getDataTypeExpressionOperator(baseCellDataType).getEntries(activeOperators);
    }
    getJoinOperatorAutocompleteEntries() {
        return Object.entries(this.expressionJoinOperators).map(([key, displayValue])=>({
                key: key,
                displayValue: displayValue
            }));
    }
    getDefaultAutocompleteListParams(searchString) {
        return this.generateAutocompleteListParams(this.getColumnAutocompleteEntries(), "column", searchString);
    }
    getDataTypeExpressionOperator(baseCellDataType) {
        return this.expressionOperators[baseCellDataType];
    }
    getExpressionOperator(baseCellDataType, operator) {
        var _a, _b;
        return (_b = (_a = this.getDataTypeExpressionOperator(baseCellDataType)) == null ? void 0 : _a.operators) == null ? void 0 : _b[operator];
    }
    getExpressionJoinOperators() {
        return this.expressionJoinOperators;
    }
    getColId(columnName) {
        const upperCaseColumnName = columnName.toLocaleUpperCase();
        const cachedColId = this.columnNameToIdMap[upperCaseColumnName];
        if (cachedColId) return cachedColId;
        const columnAutocompleteEntries = this.getColumnAutocompleteEntries();
        const colEntry = columnAutocompleteEntries.find(({ displayValue: displayValue })=>displayValue.toLocaleUpperCase() === upperCaseColumnName);
        if (colEntry) {
            const { key: colId, displayValue: displayValue } = colEntry;
            const colValue = {
                colId: colId,
                columnName: displayValue
            };
            this.columnNameToIdMap[upperCaseColumnName] = colValue;
            return colValue;
        }
        return null;
    }
    getExpressionEvaluatorParams(colId) {
        let params = this.expressionEvaluatorParams[colId];
        if (params) return params;
        const column = this.columnModel.getPrimaryColumn(colId);
        if (!column) return {
            valueConverter: (v)=>v
        };
        const baseCellDataType = this.dataTypeService.getBaseDataType(column);
        switch(baseCellDataType){
            case "dateString":
                params = {
                    valueConverter: this.dataTypeService.getDateParserFunction(column)
                };
                break;
            case "object":
                if (column.getColDef().filterValueGetter) params = {
                    valueConverter: (v)=>v
                };
                else params = {
                    valueConverter: (value, node)=>{
                        var _a;
                        return (_a = this.valueService.formatValue(column, node, value)) != null ? _a : typeof value.toString === "function" ? value.toString() : "";
                    }
                };
                break;
            case "text":
            case void 0:
                params = {
                    valueConverter: (v)=>(0, $jIDNV._).toStringOrNull(v)
                };
                break;
            default:
                params = {
                    valueConverter: (v)=>v
                };
                break;
        }
        const { filterParams: filterParams } = column.getColDef();
        if (filterParams) [
            "caseSensitive",
            "includeBlanksInEquals",
            "includeBlanksInLessThan",
            "includeBlanksInGreaterThan"
        ].forEach((param)=>{
            const paramValue = filterParams[param];
            if (paramValue) params[param] = paramValue;
        });
        this.expressionEvaluatorParams[colId] = params;
        return params;
    }
    getColumnDetails(colId) {
        var _a, _b;
        const column = (_a = this.columnModel.getPrimaryColumn(colId)) != null ? _a : void 0;
        const baseCellDataType = (_b = column ? this.dataTypeService.getBaseDataType(column) : void 0) != null ? _b : "text";
        return {
            column: column,
            baseCellDataType: baseCellDataType
        };
    }
    generateExpressionOperators() {
        const translate = (key, variableValues)=>this.translate(key, variableValues);
        return {
            text: new $5b7ccabde48fae90$var$TextFilterExpressionOperators({
                translate: translate
            }),
            boolean: new $5b7ccabde48fae90$var$BooleanFilterExpressionOperators({
                translate: translate
            }),
            object: new $5b7ccabde48fae90$var$TextFilterExpressionOperators({
                translate: translate
            }),
            number: new $5b7ccabde48fae90$var$ScalarFilterExpressionOperators({
                translate: translate,
                equals: (v, o)=>v === o
            }),
            date: new $5b7ccabde48fae90$var$ScalarFilterExpressionOperators({
                translate: translate,
                equals: (v, o)=>v.getTime() === o.getTime()
            }),
            dateString: new $5b7ccabde48fae90$var$ScalarFilterExpressionOperators({
                translate: translate,
                equals: (v, o)=>v.getTime() === o.getTime()
            })
        };
    }
    getColumnValue({ displayValue: displayValue }) {
        return `${$5b7ccabde48fae90$var$ColFilterExpressionParser.COL_START_CHAR}${displayValue}${$5b7ccabde48fae90$var$ColFilterExpressionParser.COL_END_CHAR}`;
    }
    generateExpressionJoinOperators() {
        return {
            AND: this.translate("advancedFilterAnd"),
            OR: this.translate("advancedFilterOr")
        };
    }
    getActiveOperators(column) {
        var _a;
        const filterOptions = (_a = column.getColDef().filterParams) == null ? void 0 : _a.filterOptions;
        if (!filterOptions) return void 0;
        const isValid = filterOptions.every((filterOption)=>typeof filterOption === "string");
        return isValid ? filterOptions : void 0;
    }
    resetColumnCaches() {
        this.columnAutocompleteEntries = null;
        this.columnNameToIdMap = {};
        this.expressionEvaluatorParams = {};
    }
};
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.Autowired)("valueService")
], $5b7ccabde48fae90$var$AdvancedFilterExpressionService.prototype, "valueService", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$AdvancedFilterExpressionService.prototype, "columnModel", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.Autowired)("dataTypeService")
], $5b7ccabde48fae90$var$AdvancedFilterExpressionService.prototype, "dataTypeService", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$AdvancedFilterExpressionService.prototype, "postConstruct", 1);
$5b7ccabde48fae90$var$AdvancedFilterExpressionService = $5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.Bean)("advancedFilterExpressionService")
], $5b7ccabde48fae90$var$AdvancedFilterExpressionService);
var $5b7ccabde48fae90$var$OperatorParser2 = class {
    constructor(params){
        this.params = params;
        this.operators = [];
        this.operatorStartPositions = [];
        this.operatorEndPositions = [];
        this.activeOperator = 0;
        this.validationError = null;
    }
    parseExpression(i) {
        this.operators.push("");
        this.operatorStartPositions.push(i);
        this.operatorEndPositions.push(void 0);
        const { expression: expression } = this.params;
        while(i < expression.length){
            const char = expression[i];
            if (char === " ") {
                const isComplete = this.parseOperator(i - 1);
                if (isComplete) {
                    this.activeOperator++;
                    return i - 1;
                } else this.operators[this.activeOperator] += char;
            } else this.operators[this.activeOperator] += char;
            i++;
        }
        this.parseOperator(i - 1);
        return i;
    }
    isValid() {
        return !this.validationError && (!this.operators.length || !!this.parsedOperator);
    }
    getValidationError() {
        return this.validationError;
    }
    getFunction() {
        return this.parsedOperator === "OR" ? "||" : "&&";
    }
    getModel() {
        return this.parsedOperator === "OR" ? "OR" : "AND";
    }
    getAutocompleteListParams(position, operatorIndex) {
        let searchString;
        if (operatorIndex == null) searchString = "";
        else {
            const operator = this.operators[operatorIndex];
            const operatorEndPosition = this.operatorEndPositions[operatorIndex];
            searchString = $5b7ccabde48fae90$var$getSearchString(operator, position, operatorEndPosition == null ? this.params.expression.length : operatorEndPosition + 1);
        }
        let entries = this.params.advancedFilterExpressionService.getJoinOperatorAutocompleteEntries();
        if (operatorIndex || operatorIndex == null && this.activeOperator) entries = entries.filter(({ key: key })=>key === this.parsedOperator);
        return this.params.advancedFilterExpressionService.generateAutocompleteListParams(entries, "join", searchString);
    }
    updateExpression(position, updateEntry, operatorIndex) {
        var _a, _b;
        let { expression: expression } = this.params;
        const updatedValuePart = (_a = updateEntry.displayValue) != null ? _a : updateEntry.key;
        if (operatorIndex === 0) for(let i = this.operatorEndPositions.length - 1; i > 0; i--){
            const operatorEndPosition = this.operatorEndPositions[i];
            if (operatorEndPosition == null) continue;
            expression = $5b7ccabde48fae90$var$updateExpression(expression, this.operatorStartPositions[i], operatorEndPosition, updatedValuePart).updatedValue;
        }
        const startPosition = this.operatorStartPositions.length > operatorIndex ? this.operatorStartPositions[operatorIndex] : position;
        const endPosition = (_b = this.operatorEndPositions.length > operatorIndex ? this.operatorEndPositions[operatorIndex] : void 0) != null ? _b : $5b7ccabde48fae90$var$findEndPosition(expression, position, true).endPosition;
        return $5b7ccabde48fae90$var$updateExpression(expression, startPosition, endPosition, updatedValuePart, true);
    }
    getNumOperators() {
        return this.operators.length;
    }
    getLastOperatorEndPosition() {
        return this.operatorEndPositions[this.operatorEndPositions.length - 1];
    }
    parseOperator(endPosition) {
        const operator = this.operators.length > this.activeOperator ? this.operators[this.activeOperator] : "";
        const joinOperators = this.params.advancedFilterExpressionService.getExpressionJoinOperators();
        const parsedValue = $5b7ccabde48fae90$var$findMatch(operator, joinOperators, (v)=>v);
        if (parsedValue) {
            this.operatorEndPositions[this.activeOperator] = endPosition;
            const displayValue = joinOperators[parsedValue];
            if (this.activeOperator) {
                if (parsedValue !== this.parsedOperator) {
                    if (!this.validationError) this.validationError = {
                        message: this.params.advancedFilterExpressionService.translate("advancedFilterValidationJoinOperatorMismatch"),
                        startPosition: endPosition - operator.length + 1,
                        endPosition: endPosition
                    };
                    return false;
                }
            } else this.parsedOperator = parsedValue;
            if (operator !== displayValue) {
                $5b7ccabde48fae90$var$checkAndUpdateExpression(this.params, operator, displayValue, endPosition);
                this.operators[this.activeOperator] = displayValue;
            }
            return true;
        } else if (parsedValue === null) return false;
        else {
            if (!this.validationError) this.validationError = {
                message: this.params.advancedFilterExpressionService.translate("advancedFilterValidationInvalidJoinOperator"),
                startPosition: endPosition - operator.length + 1,
                endPosition: endPosition
            };
            return true;
        }
    }
};
var $5b7ccabde48fae90$var$JoinFilterExpressionParser = class _JoinFilterExpressionParser {
    constructor(params, startPosition){
        this.params = params;
        this.startPosition = startPosition;
        this.expectingExpression = true;
        this.expectingOperator = false;
        this.expressionParsers = [];
        this.operatorParser = new $5b7ccabde48fae90$var$OperatorParser2(this.params);
        this.missingEndBracket = false;
        this.extraEndBracket = false;
    }
    parseExpression() {
        let i = this.startPosition;
        const { expression: expression } = this.params;
        while(i < expression.length){
            const char = expression[i];
            if (char === "(" && !this.expectingOperator) {
                const nestedParser = new _JoinFilterExpressionParser(this.params, i + 1);
                i = nestedParser.parseExpression();
                this.expressionParsers.push(nestedParser);
                this.expectingExpression = false;
                this.expectingOperator = true;
            } else if (char === ")") {
                this.endPosition = i - 1;
                if (this.startPosition === 0) this.extraEndBracket = true;
                return i;
            } else if (char === " ") ;
            else if (this.expectingExpression) {
                const nestedParser = new $5b7ccabde48fae90$var$ColFilterExpressionParser(this.params, i);
                i = nestedParser.parseExpression();
                this.expressionParsers.push(nestedParser);
                this.expectingExpression = false;
                this.expectingOperator = true;
            } else if (this.expectingOperator) {
                i = this.operatorParser.parseExpression(i);
                this.expectingOperator = false;
                this.expectingExpression = true;
            }
            i++;
        }
        if (this.startPosition > 0) this.missingEndBracket = true;
        return i;
    }
    isValid() {
        return !this.missingEndBracket && !this.extraEndBracket && this.expressionParsers.length === this.operatorParser.getNumOperators() + 1 && this.operatorParser.isValid() && this.expressionParsers.every((expressionParser)=>expressionParser.isValid());
    }
    getValidationError() {
        const operatorError = this.operatorParser.getValidationError();
        for(let i = 0; i < this.expressionParsers.length; i++){
            const expressionError = this.expressionParsers[i].getValidationError();
            if (expressionError) return operatorError && operatorError.startPosition < expressionError.startPosition ? operatorError : expressionError;
        }
        if (operatorError) return operatorError;
        if (this.extraEndBracket) return {
            message: this.params.advancedFilterExpressionService.translate("advancedFilterValidationExtraEndBracket"),
            startPosition: this.endPosition + 1,
            endPosition: this.endPosition + 1
        };
        let translateKey;
        if (this.expressionParsers.length === this.operatorParser.getNumOperators()) translateKey = "advancedFilterValidationMissingCondition";
        else if (this.missingEndBracket) translateKey = "advancedFilterValidationMissingEndBracket";
        if (translateKey) return {
            message: this.params.advancedFilterExpressionService.translate(translateKey),
            startPosition: this.params.expression.length,
            endPosition: this.params.expression.length
        };
        return null;
    }
    getFunctionString(params) {
        const hasMultipleExpressions = this.expressionParsers.length > 1;
        const expression = this.expressionParsers.map((expressionParser)=>expressionParser.getFunctionString(params)).join(` ${this.operatorParser.getFunction()} `);
        return hasMultipleExpressions ? `(${expression})` : expression;
    }
    getFunctionParsed(params) {
        const operator = this.operatorParser.getFunction();
        const funcs = this.expressionParsers.map((expressionParser)=>expressionParser.getFunctionParsed(params));
        const arrayFunc = operator === "&&" ? "every" : "some";
        return (expressionProxy, node, p)=>funcs[arrayFunc]((func)=>func(expressionProxy, node, p));
    }
    getAutocompleteListParams(position) {
        if (this.endPosition != null && position > this.endPosition + 1) return void 0;
        if (!this.expressionParsers.length) return this.getColumnAutocompleteListParams();
        const expressionParserIndex = this.getExpressionParserIndex(position);
        if (expressionParserIndex == null) {
            if (this.params.expression[position] === "(") return {
                enabled: false
            };
            return this.getColumnAutocompleteListParams();
        }
        const expressionParser = this.expressionParsers[expressionParserIndex];
        const autocompleteType = expressionParser.getAutocompleteListParams(position);
        if (!autocompleteType) {
            if (expressionParserIndex < this.expressionParsers.length - 1) return this.operatorParser.getAutocompleteListParams(position, expressionParserIndex);
            if (this.expressionParsers.length === this.operatorParser.getNumOperators()) {
                const operatorEndPosition = this.operatorParser.getLastOperatorEndPosition();
                return operatorEndPosition == null || position <= operatorEndPosition + 1 ? this.operatorParser.getAutocompleteListParams(position, this.operatorParser.getNumOperators() - 1) : this.getColumnAutocompleteListParams();
            }
            if (this.params.expression[position - 1] === ")") return {
                enabled: false
            };
            return this.operatorParser.getAutocompleteListParams(position);
        }
        return autocompleteType;
    }
    updateExpression(position, updateEntry, type) {
        var _a;
        const expression = this.params.expression;
        const expressionParserIndex = this.getExpressionParserIndex(position);
        if (expressionParserIndex == null) {
            const updatedValuePart = type === "column" ? this.params.advancedFilterExpressionService.getColumnValue(updateEntry) : (_a = updateEntry.displayValue) != null ? _a : updateEntry.key;
            return $5b7ccabde48fae90$var$updateExpression(expression, this.startPosition, this.startPosition, updatedValuePart, true);
        }
        const expressionParser = this.expressionParsers[expressionParserIndex];
        const updatedExpression = expressionParser.updateExpression(position, updateEntry, type);
        if (updatedExpression == null) {
            if (type === "column") return $5b7ccabde48fae90$var$updateExpression(expression, position, expression.length - 1, this.params.advancedFilterExpressionService.getColumnValue(updateEntry), true);
            else if (this.endPosition != null && position > this.endPosition + 1) return null;
            else return this.operatorParser.updateExpression(position, updateEntry, expressionParserIndex);
        }
        return updatedExpression;
    }
    getModel() {
        if (this.expressionParsers.length > 1) return {
            filterType: "join",
            type: this.operatorParser.getModel(),
            conditions: this.expressionParsers.map((parser)=>parser.getModel())
        };
        else return this.expressionParsers[0].getModel();
    }
    getColumnAutocompleteListParams() {
        return this.params.advancedFilterExpressionService.generateAutocompleteListParams(this.params.advancedFilterExpressionService.getColumnAutocompleteEntries(), "column", "");
    }
    getExpressionParserIndex(position) {
        let expressionParserIndex;
        for(let i = 0; i < this.expressionParsers.length; i++){
            const expressionParserToCheck = this.expressionParsers[i];
            if (expressionParserToCheck.startPosition > position) break;
            expressionParserIndex = i;
        }
        return expressionParserIndex;
    }
};
var $5b7ccabde48fae90$var$FilterExpressionParser = class {
    constructor(params){
        this.params = params;
        this.valid = false;
    }
    parseExpression() {
        this.joinExpressionParser = new $5b7ccabde48fae90$var$JoinFilterExpressionParser(this.params, 0);
        const i = this.joinExpressionParser.parseExpression();
        this.valid = i >= this.params.expression.length - 1 && this.joinExpressionParser.isValid();
        return this.params.expression;
    }
    isValid() {
        return this.valid;
    }
    getValidationMessage() {
        const error = this.joinExpressionParser.getValidationError();
        if (!error) return null;
        const { message: message, startPosition: startPosition, endPosition: endPosition } = error;
        return startPosition < this.params.expression.length ? this.params.advancedFilterExpressionService.translate("advancedFilterValidationMessage", [
            message,
            this.params.expression.slice(startPosition, endPosition + 1).trim()
        ]) : this.params.advancedFilterExpressionService.translate("advancedFilterValidationMessageAtEnd", [
            message
        ]);
    }
    getFunctionString() {
        const params = this.createFunctionParams();
        return {
            functionString: `return ${this.joinExpressionParser.getFunctionString(params)};`,
            params: params
        };
    }
    getFunctionParsed() {
        const params = this.createFunctionParams();
        return {
            expressionFunction: this.joinExpressionParser.getFunctionParsed(params),
            params: params
        };
    }
    getAutocompleteListParams(position) {
        var _a;
        return (_a = this.joinExpressionParser.getAutocompleteListParams(position)) != null ? _a : {
            enabled: false
        };
    }
    updateExpression(position, updateEntry, type) {
        return this.joinExpressionParser.updateExpression(position, updateEntry, type);
    }
    getModel() {
        return this.isValid() ? this.joinExpressionParser.getModel() : null;
    }
    createFunctionParams() {
        return {
            operands: [],
            operators: [],
            evaluatorParams: []
        };
    }
};
var $5b7ccabde48fae90$var$AdvancedFilterService = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.appliedExpression = null;
        this.expression = null;
        this.isValid = true;
    }
    postConstruct() {
        this.setEnabled(this.gos.get("enableAdvancedFilter"), true);
        this.ctrl = this.createManagedBean(new $5b7ccabde48fae90$var$AdvancedFilterCtrl(this.enabled));
        this.expressionProxy = {
            getValue: (colId, node)=>{
                const column = this.columnModel.getPrimaryColumn(colId);
                return column ? this.valueService.getValue(column, node, true) : void 0;
            }
        };
        this.addManagedPropertyListener("enableAdvancedFilter", (event)=>this.setEnabled(!!event.currentValue));
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_NEW_COLUMNS_LOADED, (event)=>this.onNewColumnsLoaded(event));
        this.addManagedPropertyListener("includeHiddenColumnsInAdvancedFilter", ()=>this.updateValidity());
    }
    isEnabled() {
        return this.enabled;
    }
    isFilterPresent() {
        return !!this.expressionFunction;
    }
    doesFilterPass(node) {
        return this.expressionFunction(this.expressionProxy, node, this.expressionParams);
    }
    getModel() {
        var _a;
        const expressionParser = this.createExpressionParser(this.appliedExpression);
        expressionParser == null || expressionParser.parseExpression();
        return (_a = expressionParser == null ? void 0 : expressionParser.getModel()) != null ? _a : null;
    }
    setModel(model) {
        const parseModel = (model2, isFirstParent)=>{
            if (model2.filterType === "join") {
                const operator = this.advancedFilterExpressionService.parseJoinOperator(model2);
                const expression2 = model2.conditions.map((condition)=>parseModel(condition)).filter((condition)=>(0, $jIDNV._).exists(condition)).join(` ${operator} `);
                return isFirstParent || model2.conditions.length <= 1 ? expression2 : `(${expression2})`;
            } else return this.advancedFilterExpressionService.parseColumnFilterModel(model2);
        };
        const expression = model ? parseModel(model, true) : null;
        this.setExpressionDisplayValue(expression);
        this.applyExpression();
        this.ctrl.refreshComp();
        this.ctrl.refreshBuilderComp();
    }
    getExpressionDisplayValue() {
        return this.expression;
    }
    setExpressionDisplayValue(expression) {
        this.expression = expression;
    }
    isCurrentExpressionApplied() {
        return this.appliedExpression === this.expression;
    }
    createExpressionParser(expression) {
        if (!expression) return null;
        return new $5b7ccabde48fae90$var$FilterExpressionParser({
            expression: expression,
            columnModel: this.columnModel,
            dataTypeService: this.dataTypeService,
            valueService: this.valueService,
            advancedFilterExpressionService: this.advancedFilterExpressionService
        });
    }
    getDefaultExpression(updateEntry) {
        const updatedValue = this.advancedFilterExpressionService.getColumnValue(updateEntry) + " ";
        return {
            updatedValue: updatedValue,
            updatedPosition: updatedValue.length
        };
    }
    isHeaderActive() {
        return !this.gos.get("advancedFilterParent");
    }
    getCtrl() {
        return this.ctrl;
    }
    setEnabled(enabled, silent) {
        const previousValue = this.enabled;
        const rowModelType = this.rowModel.getType();
        const isValidRowModel = rowModelType === "clientSide" || rowModelType === "serverSide";
        if (enabled && !rowModelType) (0, $jIDNV._).warnOnce("Advanced Filter is only supported with the Client-Side Row Model or Server-Side Row Model.");
        this.enabled = enabled && isValidRowModel;
        if (!silent && this.enabled !== previousValue) {
            const event = {
                type: (0, $jIDNV.Events).EVENT_ADVANCED_FILTER_ENABLED_CHANGED,
                enabled: this.enabled
            };
            this.eventService.dispatchEvent(event);
        }
    }
    applyExpression() {
        const expressionParser = this.createExpressionParser(this.expression);
        expressionParser == null || expressionParser.parseExpression();
        this.applyExpressionFromParser(expressionParser);
    }
    applyExpressionFromParser(expressionParser) {
        this.isValid = !expressionParser || expressionParser.isValid();
        if (!expressionParser || !this.isValid) {
            this.expressionFunction = null;
            this.expressionParams = null;
            this.appliedExpression = null;
            return;
        }
        const { expressionFunction: expressionFunction, params: params } = this.getFunction(expressionParser);
        this.expressionFunction = expressionFunction;
        this.expressionParams = params;
        this.appliedExpression = this.expression;
    }
    getFunction(expressionParser) {
        if (this.gos.get("suppressAdvancedFilterEval")) return expressionParser.getFunctionParsed();
        else {
            const { functionString: functionString, params: params } = expressionParser.getFunctionString();
            return {
                expressionFunction: new Function("expressionProxy", "node", "params", functionString),
                params: params
            };
        }
    }
    updateValidity() {
        this.advancedFilterExpressionService.resetColumnCaches();
        const expressionParser = this.createExpressionParser(this.expression);
        expressionParser == null || expressionParser.parseExpression();
        const isValid = !expressionParser || expressionParser.isValid();
        const updatedValidity = isValid !== this.isValid;
        this.applyExpressionFromParser(expressionParser);
        this.ctrl.refreshComp();
        this.ctrl.refreshBuilderComp();
        return updatedValidity;
    }
    onNewColumnsLoaded(event) {
        if (event.source !== "gridInitializing" || !this.dataTypeService.isPendingInference()) return;
        this.ctrl.setInputDisabled(true);
        const destroyFunc = this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_DATA_TYPES_INFERRED, ()=>{
            destroyFunc == null || destroyFunc();
            this.ctrl.setInputDisabled(false);
        });
    }
};
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.Autowired)("valueService")
], $5b7ccabde48fae90$var$AdvancedFilterService.prototype, "valueService", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$AdvancedFilterService.prototype, "columnModel", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.Autowired)("dataTypeService")
], $5b7ccabde48fae90$var$AdvancedFilterService.prototype, "dataTypeService", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.Autowired)("rowModel")
], $5b7ccabde48fae90$var$AdvancedFilterService.prototype, "rowModel", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.Autowired)("advancedFilterExpressionService")
], $5b7ccabde48fae90$var$AdvancedFilterService.prototype, "advancedFilterExpressionService", 2);
$5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$AdvancedFilterService.prototype, "postConstruct", 1);
$5b7ccabde48fae90$var$AdvancedFilterService = $5b7ccabde48fae90$var$__decorateClass2([
    (0, $jIDNV.Bean)("advancedFilterService")
], $5b7ccabde48fae90$var$AdvancedFilterService);
var $5b7ccabde48fae90$var$VERSION2 = "31.3.4";
var $5b7ccabde48fae90$export$5f40a5e44930bd02 = {
    version: $5b7ccabde48fae90$var$VERSION2,
    moduleName: (0, $jIDNV.ModuleNames).AdvancedFilterModule,
    beans: [
        $5b7ccabde48fae90$var$AdvancedFilterService,
        $5b7ccabde48fae90$var$AdvancedFilterExpressionService
    ],
    agStackComponents: [
        {
            componentName: "agAdvancedFilter",
            componentClass: $5b7ccabde48fae90$var$AdvancedFilterComp
        }
    ],
    dependantModules: [
        $5b7ccabde48fae90$export$3a6d13add8617801
    ]
};
// enterprise-modules/charts/dist/package/main.esm.mjs
var $5b7ccabde48fae90$var$main_esm_exports = {};
$5b7ccabde48fae90$var$__export($5b7ccabde48fae90$var$main_esm_exports, {
    GridChartsModule: ()=>$5b7ccabde48fae90$export$6248c9e5743f8c49,
    __FORCE_MODULE_DETECTION_AG_GRID_CORE_EXT: ()=>$5b7ccabde48fae90$export$2d0cf3225e55a3e,
    agCharts: ()=>$5b7ccabde48fae90$export$8a8f7e9aca311bdd
});
var $5b7ccabde48fae90$var$__defProp3 = Object.defineProperty;
var $5b7ccabde48fae90$var$__defProps2 = Object.defineProperties;
var $5b7ccabde48fae90$var$__getOwnPropDesc3 = Object.getOwnPropertyDescriptor;
var $5b7ccabde48fae90$var$__getOwnPropDescs2 = Object.getOwnPropertyDescriptors;
var $5b7ccabde48fae90$var$__getOwnPropSymbols2 = Object.getOwnPropertySymbols;
var $5b7ccabde48fae90$var$__hasOwnProp3 = Object.prototype.hasOwnProperty;
var $5b7ccabde48fae90$var$__propIsEnum2 = Object.prototype.propertyIsEnumerable;
var $5b7ccabde48fae90$var$__defNormalProp2 = (obj, key, value)=>key in obj ? $5b7ccabde48fae90$var$__defProp3(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5b7ccabde48fae90$var$__spreadValues2 = (a, b)=>{
    for(var prop in b || (b = {}))if ($5b7ccabde48fae90$var$__hasOwnProp3.call(b, prop)) $5b7ccabde48fae90$var$__defNormalProp2(a, prop, b[prop]);
    if ($5b7ccabde48fae90$var$__getOwnPropSymbols2) {
        for (var prop of $5b7ccabde48fae90$var$__getOwnPropSymbols2(b))if ($5b7ccabde48fae90$var$__propIsEnum2.call(b, prop)) $5b7ccabde48fae90$var$__defNormalProp2(a, prop, b[prop]);
    }
    return a;
};
var $5b7ccabde48fae90$var$__spreadProps2 = (a, b)=>$5b7ccabde48fae90$var$__defProps2(a, $5b7ccabde48fae90$var$__getOwnPropDescs2(b));
var $5b7ccabde48fae90$var$__decorateClass3 = (decorators, target, key, kind)=>{
    var result = kind > 1 ? void 0 : kind ? $5b7ccabde48fae90$var$__getOwnPropDesc3(target, key) : target;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
    if (kind && result) $5b7ccabde48fae90$var$__defProp3(target, key, result);
    return result;
};
var $5b7ccabde48fae90$var$RangeService = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.cellRanges = [];
        this.bodyScrollListener = this.onBodyScroll.bind(this);
        this.dragging = false;
        this.intersectionRange = false;
    }
    init() {
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_NEW_COLUMNS_LOADED, ()=>this.onColumnsChanged());
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_COLUMN_VISIBLE, this.onColumnsChanged.bind(this));
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_COLUMN_VALUE_CHANGED, this.onColumnsChanged.bind(this));
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_COLUMN_PIVOT_MODE_CHANGED, ()=>this.removeAllCellRanges());
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_COLUMN_ROW_GROUP_CHANGED, ()=>this.removeAllCellRanges());
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_COLUMN_PIVOT_CHANGED, ()=>this.removeAllCellRanges());
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_COLUMN_GROUP_OPENED, this.refreshLastRangeStart.bind(this));
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_COLUMN_MOVED, this.refreshLastRangeStart.bind(this));
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_COLUMN_PINNED, this.refreshLastRangeStart.bind(this));
        this.ctrlsService.whenReady((p)=>{
            const gridBodyCtrl = p.gridBodyCtrl;
            this.autoScrollService = new (0, $jIDNV.AutoScrollService)({
                scrollContainer: gridBodyCtrl.getBodyViewportElement(),
                scrollAxis: "xy",
                getVerticalPosition: ()=>gridBodyCtrl.getScrollFeature().getVScrollPosition().top,
                setVerticalPosition: (position)=>gridBodyCtrl.getScrollFeature().setVerticalScrollPosition(position),
                getHorizontalPosition: ()=>gridBodyCtrl.getScrollFeature().getHScrollPosition().left,
                setHorizontalPosition: (position)=>gridBodyCtrl.getScrollFeature().setHorizontalScrollPosition(position),
                shouldSkipVerticalScroll: ()=>!this.gos.isDomLayout("normal"),
                shouldSkipHorizontalScroll: ()=>!gridBodyCtrl.getScrollFeature().isHorizontalScrollShowing()
            });
        });
    }
    // Called for both columns loaded & column visibility events
    onColumnsChanged() {
        this.refreshLastRangeStart();
        const allColumns = this.columnModel.getAllDisplayedColumns();
        this.cellRanges.forEach((cellRange)=>{
            const beforeCols = cellRange.columns;
            cellRange.columns = cellRange.columns.filter((col)=>col.isVisible() && allColumns.indexOf(col) !== -1);
            const colsInRangeChanged = !(0, $jIDNV._).areEqual(beforeCols, cellRange.columns);
            if (colsInRangeChanged) this.dispatchChangedEvent(false, true, cellRange.id);
        });
        const countBefore = this.cellRanges.length;
        this.cellRanges = this.cellRanges.filter((range)=>range.columns.length > 0);
        if (countBefore > this.cellRanges.length) this.dispatchChangedEvent(false, true);
    }
    refreshLastRangeStart() {
        const lastRange = (0, $jIDNV._).last(this.cellRanges);
        if (!lastRange) return;
        this.refreshRangeStart(lastRange);
    }
    isContiguousRange(cellRange) {
        const rangeColumns = cellRange.columns;
        if (!rangeColumns.length) return false;
        const allColumns = this.columnModel.getAllDisplayedColumns();
        const allPositions = rangeColumns.map((c)=>allColumns.indexOf(c)).sort((a, b)=>a - b);
        return (0, $jIDNV._).last(allPositions) - allPositions[0] + 1 === rangeColumns.length;
    }
    getRangeStartRow(cellRange) {
        if (cellRange.startRow && cellRange.endRow) return this.rowPositionUtils.before(cellRange.startRow, cellRange.endRow) ? cellRange.startRow : cellRange.endRow;
        const rowPinned = this.pinnedRowModel.getPinnedTopRowCount() > 0 ? "top" : null;
        return {
            rowIndex: 0,
            rowPinned: rowPinned
        };
    }
    getRangeEndRow(cellRange) {
        if (cellRange.startRow && cellRange.endRow) return this.rowPositionUtils.before(cellRange.startRow, cellRange.endRow) ? cellRange.endRow : cellRange.startRow;
        const pinnedBottomRowCount = this.pinnedRowModel.getPinnedBottomRowCount();
        const pinnedBottom = pinnedBottomRowCount > 0;
        if (pinnedBottom) return {
            rowIndex: pinnedBottomRowCount - 1,
            rowPinned: "bottom"
        };
        return {
            rowIndex: this.rowModel.getRowCount() - 1,
            rowPinned: null
        };
    }
    setRangeToCell(cell, appendRange = false) {
        if (!this.gos.get("enableRangeSelection")) return;
        const columns = this.calculateColumnsBetween(cell.column, cell.column);
        if (!columns) return;
        const suppressMultiRangeSelections = this.gos.get("suppressMultiRangeSelection");
        if (suppressMultiRangeSelections || !appendRange || (0, $jIDNV._).missing(this.cellRanges)) this.removeAllCellRanges(true);
        const rowForCell = {
            rowIndex: cell.rowIndex,
            rowPinned: cell.rowPinned
        };
        const cellRange = {
            startRow: rowForCell,
            endRow: rowForCell,
            columns: columns,
            startColumn: cell.column
        };
        this.cellRanges.push(cellRange);
        this.setNewestRangeStartCell(cell);
        this.onDragStop();
        this.dispatchChangedEvent(true, true);
    }
    extendLatestRangeToCell(cellPosition) {
        if (this.isEmpty() || !this.newestRangeStartCell) return;
        const cellRange = (0, $jIDNV._).last(this.cellRanges);
        this.updateRangeEnd(cellRange, cellPosition);
    }
    updateRangeEnd(cellRange, cellPosition, silent = false) {
        const endColumn = cellPosition.column;
        const colsToAdd = this.calculateColumnsBetween(cellRange.startColumn, endColumn);
        if (!colsToAdd || this.isLastCellOfRange(cellRange, cellPosition)) return;
        cellRange.columns = colsToAdd;
        cellRange.endRow = {
            rowIndex: cellPosition.rowIndex,
            rowPinned: cellPosition.rowPinned
        };
        if (!silent) this.dispatchChangedEvent(true, true, cellRange.id);
    }
    refreshRangeStart(cellRange) {
        const { startColumn: startColumn, columns: columns } = cellRange;
        const moveColInCellRange = (colToMove, moveToFront)=>{
            const otherCols = cellRange.columns.filter((col)=>col !== colToMove);
            if (colToMove) {
                cellRange.startColumn = colToMove;
                cellRange.columns = moveToFront ? [
                    colToMove,
                    ...otherCols
                ] : [
                    ...otherCols,
                    colToMove
                ];
            } else cellRange.columns = otherCols;
        };
        const { left: left, right: right } = this.getRangeEdgeColumns(cellRange);
        const shouldMoveLeftCol = startColumn === columns[0] && startColumn !== left;
        if (shouldMoveLeftCol) {
            moveColInCellRange(left, true);
            return;
        }
        const shouldMoveRightCol = startColumn === (0, $jIDNV._).last(columns) && startColumn === right;
        if (shouldMoveRightCol) {
            moveColInCellRange(right, false);
            return;
        }
    }
    getRangeEdgeColumns(cellRange) {
        const allColumns = this.columnModel.getAllDisplayedColumns();
        const allIndices = cellRange.columns.map((c)=>allColumns.indexOf(c)).filter((i)=>i > -1).sort((a, b)=>a - b);
        return {
            left: allColumns[allIndices[0]],
            right: allColumns[(0, $jIDNV._).last(allIndices)]
        };
    }
    // returns true if successful, false if not successful
    extendLatestRangeInDirection(event) {
        if (this.isEmpty() || !this.newestRangeStartCell) return;
        const key = event.key;
        const ctrlKey = event.ctrlKey || event.metaKey;
        const lastRange = (0, $jIDNV._).last(this.cellRanges);
        const startCell = this.newestRangeStartCell;
        const firstCol = lastRange.columns[0];
        const lastCol = (0, $jIDNV._).last(lastRange.columns);
        const endCellIndex = lastRange.endRow.rowIndex;
        const endCellFloating = lastRange.endRow.rowPinned;
        const endCellColumn = startCell.column === firstCol ? lastCol : firstCol;
        const endCell = {
            column: endCellColumn,
            rowIndex: endCellIndex,
            rowPinned: endCellFloating
        };
        const newEndCell = this.cellNavigationService.getNextCellToFocus(key, endCell, ctrlKey);
        if (!newEndCell) return;
        this.setCellRange({
            rowStartIndex: startCell.rowIndex,
            rowStartPinned: startCell.rowPinned,
            rowEndIndex: newEndCell.rowIndex,
            rowEndPinned: newEndCell.rowPinned,
            columnStart: startCell.column,
            columnEnd: newEndCell.column
        });
        return newEndCell;
    }
    setCellRange(params) {
        if (!this.gos.get("enableRangeSelection")) return;
        this.removeAllCellRanges(true);
        this.addCellRange(params);
    }
    setCellRanges(cellRanges) {
        if ((0, $jIDNV._).shallowCompare(this.cellRanges, cellRanges)) return;
        this.removeAllCellRanges(true);
        cellRanges.forEach((newRange)=>{
            if (newRange.columns && newRange.startRow) this.setNewestRangeStartCell({
                rowIndex: newRange.startRow.rowIndex,
                rowPinned: newRange.startRow.rowPinned,
                column: newRange.columns[0]
            });
            this.cellRanges.push(newRange);
        });
        this.dispatchChangedEvent(false, true);
    }
    setNewestRangeStartCell(position) {
        this.newestRangeStartCell = position;
    }
    clearCellRangeCellValues(params) {
        let { cellRanges: cellRanges } = params;
        const { cellEventSource: cellEventSource = "rangeService", dispatchWrapperEvents: dispatchWrapperEvents, wrapperEventSource: wrapperEventSource = "deleteKey" } = params;
        if (dispatchWrapperEvents) {
            const startEvent = {
                type: (0, $jIDNV.Events).EVENT_RANGE_DELETE_START,
                source: wrapperEventSource
            };
            this.eventService.dispatchEvent(startEvent);
        }
        if (!cellRanges) cellRanges = this.cellRanges;
        cellRanges.forEach((cellRange)=>{
            this.forEachRowInRange(cellRange, (rowPosition)=>{
                var _a;
                const rowNode = this.rowPositionUtils.getRowNode(rowPosition);
                if (!rowNode) return;
                for(let i = 0; i < cellRange.columns.length; i++){
                    const column = this.columnModel.getGridColumn(cellRange.columns[i]);
                    if (!column || !column.isCellEditable(rowNode)) continue;
                    const emptyValue = (_a = this.valueService.parseValue(column, rowNode, "", rowNode.getValueFromValueService(column))) != null ? _a : null;
                    rowNode.setDataValue(column, emptyValue, cellEventSource);
                }
            });
        });
        if (dispatchWrapperEvents) {
            const endEvent = {
                type: (0, $jIDNV.Events).EVENT_RANGE_DELETE_END,
                source: wrapperEventSource
            };
            this.eventService.dispatchEvent(endEvent);
        }
    }
    createCellRangeFromCellRangeParams(params) {
        return this.createPartialCellRangeFromRangeParams(params, false);
    }
    // Range service can't normally support a range without columns, but charts can
    createPartialCellRangeFromRangeParams(params, allowEmptyColumns) {
        let columns;
        let startsOnTheRight = false;
        if (params.columns) columns = params.columns.map((c)=>this.columnModel.getColumnWithValidation(c)).filter((c)=>c);
        else {
            const columnStart = this.columnModel.getColumnWithValidation(params.columnStart);
            const columnEnd = this.columnModel.getColumnWithValidation(params.columnEnd);
            if (!columnStart || !columnEnd) return;
            columns = this.calculateColumnsBetween(columnStart, columnEnd);
            if (columns && columns.length) startsOnTheRight = columns[0] !== columnStart;
        }
        if (!columns || !allowEmptyColumns && columns.length === 0) return;
        const startRow = params.rowStartIndex != null ? {
            rowIndex: params.rowStartIndex,
            rowPinned: params.rowStartPinned || null
        } : void 0;
        const endRow = params.rowEndIndex != null ? {
            rowIndex: params.rowEndIndex,
            rowPinned: params.rowEndPinned || null
        } : void 0;
        return {
            startRow: startRow,
            endRow: endRow,
            columns: columns,
            startColumn: startsOnTheRight ? (0, $jIDNV._).last(columns) : columns[0]
        };
    }
    addCellRange(params) {
        if (!this.gos.get("enableRangeSelection")) return;
        const newRange = this.createCellRangeFromCellRangeParams(params);
        if (newRange) {
            if (newRange.startRow) this.setNewestRangeStartCell({
                rowIndex: newRange.startRow.rowIndex,
                rowPinned: newRange.startRow.rowPinned,
                column: newRange.startColumn
            });
            this.cellRanges.push(newRange);
            this.dispatchChangedEvent(false, true, newRange.id);
        }
    }
    getCellRanges() {
        return this.cellRanges;
    }
    isEmpty() {
        return this.cellRanges.length === 0;
    }
    isMoreThanOneCell() {
        const len = this.cellRanges.length;
        if (len === 0) return false;
        if (len > 1) return true;
        const range = this.cellRanges[0];
        const startRow = this.getRangeStartRow(range);
        const endRow = this.getRangeEndRow(range);
        return startRow.rowPinned !== endRow.rowPinned || startRow.rowIndex !== endRow.rowIndex || range.columns.length !== 1;
    }
    areAllRangesAbleToMerge() {
        const rowToColumnMap = /* @__PURE__ */ new Map();
        const len = this.cellRanges.length;
        if (len <= 1) return true;
        this.cellRanges.forEach((range)=>{
            this.forEachRowInRange(range, (row)=>{
                const rowName = `${row.rowPinned || "normal"}_${row.rowIndex}`;
                const columns = rowToColumnMap.get(rowName);
                const currentRangeColIds = range.columns.map((col)=>col.getId());
                if (columns) {
                    const filteredColumns = currentRangeColIds.filter((col)=>columns.indexOf(col) === -1);
                    columns.push(...filteredColumns);
                } else rowToColumnMap.set(rowName, currentRangeColIds);
            });
        });
        let columnsString;
        for (const val of rowToColumnMap.values()){
            const currentValString = val.sort().join();
            if (columnsString === void 0) {
                columnsString = currentValString;
                continue;
            }
            if (columnsString !== currentValString) return false;
        }
        return true;
    }
    forEachRowInRange(cellRange, callback) {
        const topRow = this.getRangeStartRow(cellRange);
        const bottomRow = this.getRangeEndRow(cellRange);
        let currentRow = topRow;
        while(currentRow){
            callback(currentRow);
            if (this.rowPositionUtils.sameRow(currentRow, bottomRow)) break;
            currentRow = this.cellNavigationService.getRowBelow(currentRow);
        }
    }
    removeAllCellRanges(silent) {
        if (this.isEmpty()) return;
        this.onDragStop();
        this.cellRanges.length = 0;
        if (!silent) this.dispatchChangedEvent(false, true);
    }
    // as the user is dragging outside of the panel, the div starts to scroll, which in turn
    // means we are selection more (or less) cells, but the mouse isn't moving, so we recalculate
    // the selection my mimicking a new mouse event
    onBodyScroll() {
        if (this.dragging && this.lastMouseEvent) this.onDragging(this.lastMouseEvent);
    }
    isCellInAnyRange(cell) {
        return this.getCellRangeCount(cell) > 0;
    }
    isCellInSpecificRange(cell, range) {
        const columnInRange = range.columns !== null && (0, $jIDNV._).includes(range.columns, cell.column);
        const rowInRange = this.isRowInRange(cell.rowIndex, cell.rowPinned, range);
        return columnInRange && rowInRange;
    }
    isLastCellOfRange(cellRange, cell) {
        const { startRow: startRow, endRow: endRow } = cellRange;
        const lastRow = this.rowPositionUtils.before(startRow, endRow) ? endRow : startRow;
        const isLastRow = cell.rowIndex === lastRow.rowIndex && cell.rowPinned === lastRow.rowPinned;
        const rangeFirstIndexColumn = cellRange.columns[0];
        const rangeLastIndexColumn = (0, $jIDNV._).last(cellRange.columns);
        const lastRangeColumn = cellRange.startColumn === rangeFirstIndexColumn ? rangeLastIndexColumn : rangeFirstIndexColumn;
        const isLastColumn = cell.column === lastRangeColumn;
        return isLastColumn && isLastRow;
    }
    isBottomRightCell(cellRange, cell) {
        const allColumns = this.columnModel.getAllDisplayedColumns();
        const allPositions = cellRange.columns.map((c)=>allColumns.indexOf(c)).sort((a, b)=>a - b);
        const { startRow: startRow, endRow: endRow } = cellRange;
        const lastRow = this.rowPositionUtils.before(startRow, endRow) ? endRow : startRow;
        const isRightColumn = allColumns.indexOf(cell.column) === (0, $jIDNV._).last(allPositions);
        const isLastRow = cell.rowIndex === lastRow.rowIndex && (0, $jIDNV._).makeNull(cell.rowPinned) === (0, $jIDNV._).makeNull(lastRow.rowPinned);
        return isRightColumn && isLastRow;
    }
    // returns the number of ranges this cell is in
    getCellRangeCount(cell) {
        if (this.isEmpty()) return 0;
        return this.cellRanges.filter((cellRange)=>this.isCellInSpecificRange(cell, cellRange)).length;
    }
    isRowInRange(rowIndex, floating, cellRange) {
        const firstRow = this.getRangeStartRow(cellRange);
        const lastRow = this.getRangeEndRow(cellRange);
        const thisRow = {
            rowIndex: rowIndex,
            rowPinned: floating || null
        };
        const equalsFirstRow = thisRow.rowIndex === firstRow.rowIndex && thisRow.rowPinned == firstRow.rowPinned;
        const equalsLastRow = thisRow.rowIndex === lastRow.rowIndex && thisRow.rowPinned == lastRow.rowPinned;
        if (equalsFirstRow || equalsLastRow) return true;
        const afterFirstRow = !this.rowPositionUtils.before(thisRow, firstRow);
        const beforeLastRow = this.rowPositionUtils.before(thisRow, lastRow);
        return afterFirstRow && beforeLastRow;
    }
    getDraggingRange() {
        return this.draggingRange;
    }
    onDragStart(mouseEvent) {
        if (!this.gos.get("enableRangeSelection")) return;
        const { ctrlKey: ctrlKey, metaKey: metaKey, shiftKey: shiftKey } = mouseEvent;
        const isMultiKey = ctrlKey || metaKey;
        const allowMulti = !this.gos.get("suppressMultiRangeSelection");
        const isMultiSelect = allowMulti ? isMultiKey : false;
        const extendRange = shiftKey && (0, $jIDNV._).existsAndNotEmpty(this.cellRanges);
        if (!isMultiSelect && (!extendRange || (0, $jIDNV._).exists((0, $jIDNV._).last(this.cellRanges).type))) this.removeAllCellRanges(true);
        const startTarget = this.dragService.getStartTarget();
        if (startTarget) this.updateValuesOnMove(startTarget);
        if (!this.lastCellHovered) return;
        this.dragging = true;
        this.lastMouseEvent = mouseEvent;
        this.intersectionRange = isMultiSelect && this.getCellRangeCount(this.lastCellHovered) > 1;
        if (!extendRange) this.setNewestRangeStartCell(this.lastCellHovered);
        if (this.cellRanges.length > 0) this.draggingRange = (0, $jIDNV._).last(this.cellRanges);
        else {
            const mouseRowPosition = {
                rowIndex: this.lastCellHovered.rowIndex,
                rowPinned: this.lastCellHovered.rowPinned
            };
            this.draggingRange = {
                startRow: mouseRowPosition,
                endRow: mouseRowPosition,
                columns: [
                    this.lastCellHovered.column
                ],
                startColumn: this.newestRangeStartCell.column
            };
            this.cellRanges.push(this.draggingRange);
        }
        this.ctrlsService.getGridBodyCtrl().addScrollEventListener(this.bodyScrollListener);
        this.dispatchChangedEvent(true, false, this.draggingRange.id);
    }
    intersectLastRange(fromMouseClick) {
        if (fromMouseClick && this.dragging) return;
        if (this.gos.get("suppressMultiRangeSelection")) return;
        if (this.isEmpty()) return;
        const rowPosUtils = this.rowPositionUtils;
        const lastRange = (0, $jIDNV._).last(this.cellRanges);
        const intersectionStartRow = this.getRangeStartRow(lastRange);
        const intersectionEndRow = this.getRangeEndRow(lastRange);
        const newRanges = [];
        this.cellRanges.slice(0, -1).forEach((range)=>{
            const startRow = this.getRangeStartRow(range);
            const endRow = this.getRangeEndRow(range);
            const cols = range.columns;
            const intersectCols = cols.filter((col)=>lastRange.columns.indexOf(col) === -1);
            if (intersectCols.length === cols.length) {
                newRanges.push(range);
                return;
            }
            if (rowPosUtils.before(intersectionEndRow, startRow) || rowPosUtils.before(endRow, intersectionStartRow)) {
                newRanges.push(range);
                return;
            }
            const rangeCountBefore = newRanges.length;
            if (rowPosUtils.before(startRow, intersectionStartRow)) {
                const top = {
                    columns: [
                        ...cols
                    ],
                    startColumn: lastRange.startColumn,
                    startRow: $5b7ccabde48fae90$var$__spreadValues2({}, startRow),
                    endRow: this.cellNavigationService.getRowAbove(intersectionStartRow)
                };
                newRanges.push(top);
            }
            if (intersectCols.length > 0) {
                const middle = {
                    columns: intersectCols,
                    startColumn: (0, $jIDNV._).includes(intersectCols, lastRange.startColumn) ? lastRange.startColumn : intersectCols[0],
                    startRow: this.rowMax([
                        $5b7ccabde48fae90$var$__spreadValues2({}, intersectionStartRow),
                        $5b7ccabde48fae90$var$__spreadValues2({}, startRow)
                    ]),
                    endRow: this.rowMin([
                        $5b7ccabde48fae90$var$__spreadValues2({}, intersectionEndRow),
                        $5b7ccabde48fae90$var$__spreadValues2({}, endRow)
                    ])
                };
                newRanges.push(middle);
            }
            if (rowPosUtils.before(intersectionEndRow, endRow)) newRanges.push({
                columns: [
                    ...cols
                ],
                startColumn: lastRange.startColumn,
                startRow: this.cellNavigationService.getRowBelow(intersectionEndRow),
                endRow: $5b7ccabde48fae90$var$__spreadValues2({}, endRow)
            });
            if (newRanges.length - rangeCountBefore === 1) newRanges[newRanges.length - 1].id = range.id;
        });
        this.cellRanges = newRanges;
        if (fromMouseClick) this.dispatchChangedEvent(false, true);
    }
    rowMax(rows) {
        let max;
        rows.forEach((row)=>{
            if (max === void 0 || this.rowPositionUtils.before(max, row)) max = row;
        });
        return max;
    }
    rowMin(rows) {
        let min;
        rows.forEach((row)=>{
            if (min === void 0 || this.rowPositionUtils.before(row, min)) min = row;
        });
        return min;
    }
    updateValuesOnMove(eventTarget) {
        const cellCtrl = (0, $jIDNV._).getCtrlForEventTarget(this.gos, eventTarget, (0, $jIDNV.CellCtrl).DOM_DATA_KEY_CELL_CTRL);
        const cell = cellCtrl == null ? void 0 : cellCtrl.getCellPosition();
        this.cellHasChanged = false;
        if (!cell || this.lastCellHovered && this.cellPositionUtils.equals(cell, this.lastCellHovered)) return;
        if (this.lastCellHovered) this.cellHasChanged = true;
        this.lastCellHovered = cell;
    }
    onDragging(mouseEvent) {
        if (!this.dragging || !mouseEvent) return;
        this.updateValuesOnMove(mouseEvent.target);
        this.lastMouseEvent = mouseEvent;
        const cellPosition = this.lastCellHovered;
        const isMouseAndStartInPinned = (position)=>cellPosition && cellPosition.rowPinned === position && this.newestRangeStartCell.rowPinned === position;
        const skipVerticalScroll = isMouseAndStartInPinned("top") || isMouseAndStartInPinned("bottom");
        this.autoScrollService.check(mouseEvent, skipVerticalScroll);
        if (!this.cellHasChanged) return;
        const columns = this.calculateColumnsBetween(this.newestRangeStartCell.column, cellPosition.column);
        if (!columns) return;
        this.draggingRange.endRow = {
            rowIndex: cellPosition.rowIndex,
            rowPinned: cellPosition.rowPinned
        };
        this.draggingRange.columns = columns;
        this.dispatchChangedEvent(false, false, this.draggingRange.id);
    }
    onDragStop() {
        if (!this.dragging) return;
        const { id: id } = this.draggingRange;
        this.autoScrollService.ensureCleared();
        this.ctrlsService.getGridBodyCtrl().removeScrollEventListener(this.bodyScrollListener);
        this.lastMouseEvent = null;
        this.dragging = false;
        this.draggingRange = void 0;
        this.lastCellHovered = void 0;
        if (this.intersectionRange) {
            this.intersectionRange = false;
            this.intersectLastRange();
        }
        this.dispatchChangedEvent(false, true, id);
    }
    dispatchChangedEvent(started, finished, id) {
        const event = {
            type: (0, $jIDNV.Events).EVENT_RANGE_SELECTION_CHANGED,
            started: started,
            finished: finished,
            id: id
        };
        this.eventService.dispatchEvent(event);
    }
    calculateColumnsBetween(columnFrom, columnTo) {
        const allColumns = this.columnModel.getAllDisplayedColumns();
        const isSameColumn = columnFrom === columnTo;
        const fromIndex = allColumns.indexOf(columnFrom);
        if (fromIndex < 0) {
            console.warn(`AG Grid: column ${columnFrom.getId()} is not visible`);
            return;
        }
        const toIndex = isSameColumn ? fromIndex : allColumns.indexOf(columnTo);
        if (toIndex < 0) {
            console.warn(`AG Grid: column ${columnTo.getId()} is not visible`);
            return;
        }
        if (isSameColumn) return [
            columnFrom
        ];
        const firstIndex = Math.min(fromIndex, toIndex);
        const lastIndex = firstIndex === fromIndex ? toIndex : fromIndex;
        const columns = [];
        for(let i = firstIndex; i <= lastIndex; i++)columns.push(allColumns[i]);
        return columns;
    }
};
$5b7ccabde48fae90$var$__decorateClass3([
    (0, $jIDNV.Autowired)("rowModel")
], $5b7ccabde48fae90$var$RangeService.prototype, "rowModel", 2);
$5b7ccabde48fae90$var$__decorateClass3([
    (0, $jIDNV.Autowired)("dragService")
], $5b7ccabde48fae90$var$RangeService.prototype, "dragService", 2);
$5b7ccabde48fae90$var$__decorateClass3([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$RangeService.prototype, "columnModel", 2);
$5b7ccabde48fae90$var$__decorateClass3([
    (0, $jIDNV.Autowired)("cellNavigationService")
], $5b7ccabde48fae90$var$RangeService.prototype, "cellNavigationService", 2);
$5b7ccabde48fae90$var$__decorateClass3([
    (0, $jIDNV.Autowired)("pinnedRowModel")
], $5b7ccabde48fae90$var$RangeService.prototype, "pinnedRowModel", 2);
$5b7ccabde48fae90$var$__decorateClass3([
    (0, $jIDNV.Autowired)("rowPositionUtils")
], $5b7ccabde48fae90$var$RangeService.prototype, "rowPositionUtils", 2);
$5b7ccabde48fae90$var$__decorateClass3([
    (0, $jIDNV.Autowired)("cellPositionUtils")
], $5b7ccabde48fae90$var$RangeService.prototype, "cellPositionUtils", 2);
$5b7ccabde48fae90$var$__decorateClass3([
    (0, $jIDNV.Autowired)("ctrlsService")
], $5b7ccabde48fae90$var$RangeService.prototype, "ctrlsService", 2);
$5b7ccabde48fae90$var$__decorateClass3([
    (0, $jIDNV.Autowired)("valueService")
], $5b7ccabde48fae90$var$RangeService.prototype, "valueService", 2);
$5b7ccabde48fae90$var$__decorateClass3([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$RangeService.prototype, "init", 1);
$5b7ccabde48fae90$var$RangeService = $5b7ccabde48fae90$var$__decorateClass3([
    (0, $jIDNV.Bean)("rangeService")
], $5b7ccabde48fae90$var$RangeService);
var $5b7ccabde48fae90$var$AbstractSelectionHandle = class extends (0, $jIDNV.Component) {
    constructor(){
        super(...arguments);
        this.changedCalculatedValues = false;
        this.dragging = false;
        this.shouldDestroyOnEndDragging = false;
    }
    init() {
        this.dragService.addDragSource({
            dragStartPixels: 0,
            eElement: this.getGui(),
            onDragStart: this.onDragStart.bind(this),
            onDragging: (e)=>{
                this.dragging = true;
                this.rangeService.autoScrollService.check(e);
                if (this.changedCalculatedValues) {
                    this.onDrag(e);
                    this.changedCalculatedValues = false;
                }
            },
            onDragStop: (e)=>{
                this.dragging = false;
                this.onDragEnd(e);
                this.clearValues();
                this.rangeService.autoScrollService.ensureCleared();
                document.body.classList.remove(this.getDraggingCssClass());
                if (this.shouldDestroyOnEndDragging) this.destroy();
            }
        });
        this.addManagedListener(this.getGui(), "mousedown", this.preventRangeExtension.bind(this));
    }
    isDragging() {
        return this.dragging;
    }
    getCellCtrl() {
        return this.cellCtrl;
    }
    setCellCtrl(cellComp) {
        this.cellCtrl = cellComp;
    }
    getCellRange() {
        return this.cellRange;
    }
    setCellRange(range) {
        this.cellRange = range;
    }
    getRangeStartRow() {
        return this.rangeStartRow;
    }
    setRangeStartRow(row) {
        this.rangeStartRow = row;
    }
    getRangeEndRow() {
        return this.rangeEndRow;
    }
    setRangeEndRow(row) {
        this.rangeEndRow = row;
    }
    getLastCellHovered() {
        return this.lastCellHovered;
    }
    preventRangeExtension(e) {
        e.stopPropagation();
    }
    onDragStart(e) {
        this.cellHoverListener = this.addManagedListener(this.ctrlsService.get("gridCtrl").getGui(), "mousemove", this.updateValuesOnMove.bind(this));
        document.body.classList.add(this.getDraggingCssClass());
    }
    getDraggingCssClass() {
        return `ag-dragging-${this.type === (0, $jIDNV.SelectionHandleType).FILL ? "fill" : "range"}-handle`;
    }
    updateValuesOnMove(e) {
        const cell = this.mouseEventService.getCellPositionForEvent(e);
        if (!cell || this.lastCellHovered && this.cellPositionUtils.equals(cell, this.lastCellHovered)) return;
        this.lastCellHovered = cell;
        this.changedCalculatedValues = true;
    }
    getType() {
        return this.type;
    }
    refresh(cellCtrl) {
        const oldCellComp = this.getCellCtrl();
        const eGui = this.getGui();
        const cellRange = (0, $jIDNV._).last(this.rangeService.getCellRanges());
        const start = cellRange.startRow;
        const end = cellRange.endRow;
        if (start && end) {
            const isBefore = this.rowPositionUtils.before(end, start);
            if (isBefore) {
                this.setRangeStartRow(end);
                this.setRangeEndRow(start);
            } else {
                this.setRangeStartRow(start);
                this.setRangeEndRow(end);
            }
        }
        if (oldCellComp !== cellCtrl || !(0, $jIDNV._).isVisible(eGui)) {
            this.setCellCtrl(cellCtrl);
            const eParentOfValue = cellCtrl.getComp().getParentOfValue();
            if (eParentOfValue) eParentOfValue.appendChild(eGui);
        }
        this.setCellRange(cellRange);
    }
    clearValues() {
        this.lastCellHovered = void 0;
        this.removeListeners();
    }
    removeListeners() {
        if (this.cellHoverListener) {
            this.cellHoverListener();
            this.cellHoverListener = void 0;
        }
    }
    destroy() {
        if (!this.shouldDestroyOnEndDragging && this.isDragging()) {
            (0, $jIDNV._).setDisplayed(this.getGui(), false);
            this.shouldDestroyOnEndDragging = true;
            return;
        }
        this.shouldDestroyOnEndDragging = false;
        super.destroy();
        this.removeListeners();
        const eGui = this.getGui();
        if (eGui.parentElement) eGui.parentElement.removeChild(eGui);
    }
};
$5b7ccabde48fae90$var$__decorateClass3([
    (0, $jIDNV.Autowired)("rowRenderer")
], $5b7ccabde48fae90$var$AbstractSelectionHandle.prototype, "rowRenderer", 2);
$5b7ccabde48fae90$var$__decorateClass3([
    (0, $jIDNV.Autowired)("dragService")
], $5b7ccabde48fae90$var$AbstractSelectionHandle.prototype, "dragService", 2);
$5b7ccabde48fae90$var$__decorateClass3([
    (0, $jIDNV.Autowired)("rangeService")
], $5b7ccabde48fae90$var$AbstractSelectionHandle.prototype, "rangeService", 2);
$5b7ccabde48fae90$var$__decorateClass3([
    (0, $jIDNV.Autowired)("mouseEventService")
], $5b7ccabde48fae90$var$AbstractSelectionHandle.prototype, "mouseEventService", 2);
$5b7ccabde48fae90$var$__decorateClass3([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$AbstractSelectionHandle.prototype, "columnModel", 2);
$5b7ccabde48fae90$var$__decorateClass3([
    (0, $jIDNV.Autowired)("cellNavigationService")
], $5b7ccabde48fae90$var$AbstractSelectionHandle.prototype, "cellNavigationService", 2);
$5b7ccabde48fae90$var$__decorateClass3([
    (0, $jIDNV.Autowired)("navigationService")
], $5b7ccabde48fae90$var$AbstractSelectionHandle.prototype, "navigationService", 2);
$5b7ccabde48fae90$var$__decorateClass3([
    (0, $jIDNV.Autowired)("rowPositionUtils")
], $5b7ccabde48fae90$var$AbstractSelectionHandle.prototype, "rowPositionUtils", 2);
$5b7ccabde48fae90$var$__decorateClass3([
    (0, $jIDNV.Autowired)("cellPositionUtils")
], $5b7ccabde48fae90$var$AbstractSelectionHandle.prototype, "cellPositionUtils", 2);
$5b7ccabde48fae90$var$__decorateClass3([
    (0, $jIDNV.Autowired)("ctrlsService")
], $5b7ccabde48fae90$var$AbstractSelectionHandle.prototype, "ctrlsService", 2);
$5b7ccabde48fae90$var$__decorateClass3([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$AbstractSelectionHandle.prototype, "init", 1);
function $5b7ccabde48fae90$var$findLineByLeastSquares(values) {
    const len = values.length;
    let maxDecimals = 0;
    if (len <= 1) return values;
    for(let i = 0; i < values.length; i++){
        const value = values[i];
        const splitExponent = value.toString().split("e-");
        if (splitExponent.length > 1) {
            maxDecimals = Math.max(maxDecimals, parseInt(splitExponent[1], 10));
            continue;
        }
        if (Math.floor(value) === value) continue;
        maxDecimals = Math.max(maxDecimals, value.toString().split(".")[1].length);
    }
    let sum_x = 0;
    let sum_y = 0;
    let sum_xy = 0;
    let sum_xx = 0;
    let y = 0;
    for(let x = 0; x < len; x++){
        y = values[x];
        sum_x += x;
        sum_y += y;
        sum_xx += x * x;
        sum_xy += x * y;
    }
    const m = (len * sum_xy - sum_x * sum_y) / (len * sum_xx - sum_x * sum_x);
    const b = sum_y / len - m * sum_x / len;
    const result = [];
    for(let x = 0; x <= len; x++)result.push(parseFloat((x * m + b).toFixed(maxDecimals)));
    return result;
}
var $5b7ccabde48fae90$var$_FillHandle = class _FillHandle2 extends $5b7ccabde48fae90$var$AbstractSelectionHandle {
    constructor(){
        super(_FillHandle2.TEMPLATE);
        this.markedCells = [];
        this.cellValues = [];
        this.isUp = false;
        this.isLeft = false;
        this.isReduce = false;
        this.type = (0, $jIDNV.SelectionHandleType).FILL;
    }
    updateValuesOnMove(e) {
        super.updateValuesOnMove(e);
        if (!this.initialXY) this.initialXY = this.mouseEventService.getNormalisedPosition(e);
        const { x: x, y: y } = this.initialXY;
        const { x: newX, y: newY } = this.mouseEventService.getNormalisedPosition(e);
        const diffX = Math.abs(x - newX);
        const diffY = Math.abs(y - newY);
        const allowedDirection = this.getFillHandleDirection();
        let direction;
        if (allowedDirection === "xy") direction = diffX > diffY ? "x" : "y";
        else direction = allowedDirection;
        if (direction !== this.dragAxis) {
            this.dragAxis = direction;
            this.changedCalculatedValues = true;
        }
    }
    onDrag(e) {
        if (!this.initialPosition) {
            const cellCtrl = this.getCellCtrl();
            if (!cellCtrl) return;
            this.initialPosition = cellCtrl.getCellPosition();
        }
        const lastCellHovered = this.getLastCellHovered();
        if (lastCellHovered) this.markPathFrom(this.initialPosition, lastCellHovered);
    }
    onDragEnd(e) {
        this.initialXY = null;
        if (!this.markedCells.length) return;
        const isX = this.dragAxis === "x";
        const initialRange = this.getCellRange();
        const colLen = initialRange.columns.length;
        const rangeStartRow = this.getRangeStartRow();
        const rangeEndRow = this.getRangeEndRow();
        let finalRange;
        if (!this.isUp && !this.isLeft) finalRange = this.rangeService.createCellRangeFromCellRangeParams({
            rowStartIndex: rangeStartRow.rowIndex,
            rowStartPinned: rangeStartRow.rowPinned,
            columnStart: initialRange.columns[0],
            rowEndIndex: isX ? rangeEndRow.rowIndex : this.lastCellMarked.rowIndex,
            rowEndPinned: isX ? rangeEndRow.rowPinned : this.lastCellMarked.rowPinned,
            columnEnd: isX ? this.lastCellMarked.column : initialRange.columns[colLen - 1]
        });
        else {
            const startRow = isX ? rangeStartRow : this.lastCellMarked;
            finalRange = this.rangeService.createCellRangeFromCellRangeParams({
                rowStartIndex: startRow.rowIndex,
                rowStartPinned: startRow.rowPinned,
                columnStart: isX ? this.lastCellMarked.column : initialRange.columns[0],
                rowEndIndex: rangeEndRow.rowIndex,
                rowEndPinned: rangeEndRow.rowPinned,
                columnEnd: initialRange.columns[colLen - 1]
            });
        }
        if (finalRange) {
            this.raiseFillStartEvent();
            this.handleValueChanged(initialRange, finalRange, e);
            this.rangeService.setCellRanges([
                finalRange
            ]);
            this.raiseFillEndEvent(initialRange, finalRange);
        }
    }
    getFillHandleDirection() {
        const direction = this.gos.get("fillHandleDirection");
        if (!direction) return "xy";
        if (direction !== "x" && direction !== "y" && direction !== "xy") {
            (0, $jIDNV._).warnOnce(`valid values for fillHandleDirection are 'x', 'y' and 'xy'. Default to 'xy'.`);
            return "xy";
        }
        return direction;
    }
    raiseFillStartEvent() {
        const fillStartEvent = {
            type: (0, $jIDNV.Events).EVENT_FILL_START
        };
        this.eventService.dispatchEvent(fillStartEvent);
    }
    raiseFillEndEvent(initialRange, finalRange) {
        const fillEndEvent = {
            type: (0, $jIDNV.Events).EVENT_FILL_END,
            initialRange: initialRange,
            finalRange: finalRange
        };
        this.eventService.dispatchEvent(fillEndEvent);
    }
    handleValueChanged(initialRange, finalRange, e) {
        const initialRangeEndRow = this.rangeService.getRangeEndRow(initialRange);
        const initialRangeStartRow = this.rangeService.getRangeStartRow(initialRange);
        const finalRangeEndRow = this.rangeService.getRangeEndRow(finalRange);
        const finalRangeStartRow = this.rangeService.getRangeStartRow(finalRange);
        const isVertical = this.dragAxis === "y";
        if (this.isReduce && !this.gos.get("suppressClearOnFillReduction")) {
            const columns = isVertical ? initialRange.columns : initialRange.columns.filter((col)=>finalRange.columns.indexOf(col) < 0);
            const startRow = isVertical ? this.cellNavigationService.getRowBelow(finalRangeEndRow) : finalRangeStartRow;
            if (startRow) this.clearCellsInRange(startRow, initialRangeEndRow, columns);
            return;
        }
        const values = [];
        const initialValues = [];
        const initialNonAggregatedValues = [];
        const initialFormattedValues = [];
        let withinInitialRange = true;
        let idx = 0;
        const resetValues = ()=>{
            values.length = 0;
            initialValues.length = 0;
            initialNonAggregatedValues.length = 0;
            initialFormattedValues.length = 0;
            idx = 0;
        };
        const iterateAcrossCells = (column, columns)=>{
            let currentRow = this.isUp ? initialRangeEndRow : initialRangeStartRow;
            let finished = false;
            if (isVertical) {
                withinInitialRange = true;
                resetValues();
            }
            while(!finished && currentRow){
                const rowNode = this.rowPositionUtils.getRowNode(currentRow);
                if (!rowNode) break;
                if (isVertical && column) fillValues(values, column, rowNode, ()=>{
                    return !this.rowPositionUtils.sameRow(currentRow, this.isUp ? initialRangeStartRow : initialRangeEndRow);
                });
                else if (columns) {
                    withinInitialRange = true;
                    resetValues();
                    columns.forEach((col)=>fillValues(values, col, rowNode, ()=>col !== (this.isLeft ? initialRange.columns[0] : (0, $jIDNV._).last(initialRange.columns))));
                }
                finished = this.rowPositionUtils.sameRow(currentRow, this.isUp ? finalRangeStartRow : finalRangeEndRow);
                currentRow = this.isUp ? this.cellNavigationService.getRowAbove(currentRow) : this.cellNavigationService.getRowBelow(currentRow);
            }
        };
        const fillValues = (currentValues, col, rowNode, updateInitialSet)=>{
            var _a, _b;
            let currentValue;
            let skipValue = false;
            if (withinInitialRange) {
                currentValue = this.valueService.getValue(col, rowNode);
                initialValues.push(currentValue);
                initialNonAggregatedValues.push(this.valueService.getValue(col, rowNode, void 0, true));
                initialFormattedValues.push(this.valueService.formatValue(col, rowNode, currentValue));
                withinInitialRange = updateInitialSet();
            } else {
                const { value: value, fromUserFunction: fromUserFunction, sourceCol: sourceCol, sourceRowNode: sourceRowNode } = this.processValues({
                    event: e,
                    values: currentValues,
                    initialValues: initialValues,
                    initialNonAggregatedValues: initialNonAggregatedValues,
                    initialFormattedValues: initialFormattedValues,
                    col: col,
                    rowNode: rowNode,
                    idx: idx++
                });
                currentValue = value;
                if (col.isCellEditable(rowNode)) {
                    const cellValue = this.valueService.getValue(col, rowNode);
                    if (!fromUserFunction) {
                        if (sourceCol && ((_a = sourceCol.getColDef()) == null ? void 0 : _a.useValueFormatterForExport) !== false) currentValue = (_b = this.valueService.formatValue(sourceCol, sourceRowNode, currentValue)) != null ? _b : currentValue;
                        if (col.getColDef().useValueParserForImport !== false) currentValue = this.valueService.parseValue(col, rowNode, // if no sourceCol, then currentValue is a number
                        sourceCol ? currentValue : (0, $jIDNV._).toStringOrNull(currentValue), cellValue);
                    }
                    if (!fromUserFunction || cellValue !== currentValue) rowNode.setDataValue(col, currentValue, "rangeService");
                    else skipValue = true;
                }
            }
            if (!skipValue) currentValues.push({
                value: currentValue,
                column: col,
                rowNode: rowNode
            });
        };
        if (isVertical) initialRange.columns.forEach((col)=>{
            iterateAcrossCells(col);
        });
        else {
            const columns = this.isLeft ? [
                ...finalRange.columns
            ].reverse() : finalRange.columns;
            iterateAcrossCells(void 0, columns);
        }
    }
    clearCellsInRange(startRow, endRow, columns) {
        const cellRange = {
            startRow: startRow,
            endRow: endRow,
            columns: columns,
            startColumn: columns[0]
        };
        this.rangeService.clearCellRangeCellValues({
            cellRanges: [
                cellRange
            ]
        });
    }
    processValues(params) {
        const { event: event, values: values, initialValues: initialValues, initialNonAggregatedValues: initialNonAggregatedValues, initialFormattedValues: initialFormattedValues, col: col, rowNode: rowNode, idx: idx } = params;
        const userFillOperation = this.gos.getCallback("fillOperation");
        const isVertical = this.dragAxis === "y";
        let direction;
        if (isVertical) direction = this.isUp ? "up" : "down";
        else direction = this.isLeft ? "left" : "right";
        if (userFillOperation) {
            const params2 = {
                event: event,
                values: values.map(({ value: value })=>value),
                initialValues: initialValues,
                initialNonAggregatedValues: initialNonAggregatedValues,
                initialFormattedValues: initialFormattedValues,
                currentIndex: idx,
                currentCellValue: this.valueService.getValue(col, rowNode),
                direction: direction,
                column: col,
                rowNode: rowNode
            };
            const userResult = userFillOperation(params2);
            if (userResult !== false) return {
                value: userResult,
                fromUserFunction: true
            };
        }
        const allNumbers = !values.some(({ value: value })=>{
            const asFloat = parseFloat(value);
            return isNaN(asFloat) || asFloat.toString() !== value.toString();
        });
        if (event.altKey || !allNumbers) {
            if (allNumbers && initialValues.length === 1) {
                const multiplier = this.isUp || this.isLeft ? -1 : 1;
                return {
                    value: parseFloat((0, $jIDNV._).last(values).value) + 1 * multiplier,
                    fromUserFunction: false
                };
            }
            const { value: value, column: sourceCol, rowNode: sourceRowNode } = values[idx % values.length];
            return {
                value: value,
                fromUserFunction: false,
                sourceCol: sourceCol,
                sourceRowNode: sourceRowNode
            };
        }
        return {
            value: (0, $jIDNV._).last($5b7ccabde48fae90$var$findLineByLeastSquares(values.map(({ value: value })=>Number(value)))),
            fromUserFunction: false
        };
    }
    clearValues() {
        this.clearMarkedPath();
        this.clearCellValues();
        this.lastCellMarked = void 0;
        super.clearValues();
    }
    clearMarkedPath() {
        this.markedCells.forEach((cell)=>{
            if (!cell.isAlive()) return;
            const comp = cell.getComp();
            comp.addOrRemoveCssClass("ag-selection-fill-top", false);
            comp.addOrRemoveCssClass("ag-selection-fill-right", false);
            comp.addOrRemoveCssClass("ag-selection-fill-bottom", false);
            comp.addOrRemoveCssClass("ag-selection-fill-left", false);
        });
        this.markedCells.length = 0;
        this.isUp = false;
        this.isLeft = false;
        this.isReduce = false;
    }
    clearCellValues() {
        this.cellValues.length = 0;
    }
    markPathFrom(initialPosition, currentPosition) {
        this.clearMarkedPath();
        this.clearCellValues();
        if (this.dragAxis === "y") {
            if (this.rowPositionUtils.sameRow(currentPosition, initialPosition)) return;
            const isBefore = this.rowPositionUtils.before(currentPosition, initialPosition);
            const rangeStartRow = this.getRangeStartRow();
            const rangeEndRow = this.getRangeEndRow();
            if (isBefore && (currentPosition.rowPinned == rangeStartRow.rowPinned && currentPosition.rowIndex >= rangeStartRow.rowIndex || rangeStartRow.rowPinned != rangeEndRow.rowPinned && currentPosition.rowPinned == rangeEndRow.rowPinned && currentPosition.rowIndex <= rangeEndRow.rowIndex)) {
                this.reduceVertical(initialPosition, currentPosition);
                this.isReduce = true;
            } else {
                this.extendVertical(initialPosition, currentPosition, isBefore);
                this.isReduce = false;
            }
        } else {
            const initialColumn = initialPosition.column;
            const currentColumn = currentPosition.column;
            if (initialColumn === currentColumn) return;
            const displayedColumns = this.columnModel.getAllDisplayedColumns();
            const initialIndex = displayedColumns.indexOf(initialColumn);
            const currentIndex = displayedColumns.indexOf(currentColumn);
            if (currentIndex <= initialIndex && currentIndex >= displayedColumns.indexOf(this.getCellRange().columns[0])) {
                this.reduceHorizontal(initialPosition, currentPosition);
                this.isReduce = true;
            } else {
                this.extendHorizontal(initialPosition, currentPosition, currentIndex < initialIndex);
                this.isReduce = false;
            }
        }
        this.lastCellMarked = currentPosition;
    }
    extendVertical(initialPosition, endPosition, isMovingUp) {
        const { navigationService: navigationService, rangeService: rangeService } = this;
        let row = initialPosition;
        do {
            const cellRange = this.getCellRange();
            const colLen = cellRange.columns.length;
            for(let i = 0; i < colLen; i++){
                const column = cellRange.columns[i];
                const rowPos = {
                    rowIndex: row.rowIndex,
                    rowPinned: row.rowPinned
                };
                const cellPos = $5b7ccabde48fae90$var$__spreadProps2($5b7ccabde48fae90$var$__spreadValues2({}, rowPos), {
                    column: column
                });
                const cellInRange = rangeService.isCellInSpecificRange(cellPos, cellRange);
                const isInitialRow = this.rowPositionUtils.sameRow(row, initialPosition);
                if (isMovingUp) this.isUp = true;
                if (!isInitialRow) {
                    const cell = navigationService.getCellByPosition(cellPos);
                    if (cell) {
                        this.markedCells.push(cell);
                        const cellCtrl = cell.getComp();
                        if (!cellInRange) {
                            cellCtrl.addOrRemoveCssClass("ag-selection-fill-left", i === 0);
                            cellCtrl.addOrRemoveCssClass("ag-selection-fill-right", i === colLen - 1);
                        }
                        cellCtrl.addOrRemoveCssClass(isMovingUp ? "ag-selection-fill-top" : "ag-selection-fill-bottom", this.rowPositionUtils.sameRow(row, endPosition));
                    }
                }
            }
            if (this.rowPositionUtils.sameRow(row, endPosition)) break;
        }while (// tslint:disable-next-line
        row = isMovingUp ? this.cellNavigationService.getRowAbove(row) : this.cellNavigationService.getRowBelow(row));
    }
    reduceVertical(initialPosition, endPosition) {
        let row = initialPosition;
        do {
            const cellRange = this.getCellRange();
            const colLen = cellRange.columns.length;
            const isLastRow = this.rowPositionUtils.sameRow(row, endPosition);
            for(let i = 0; i < colLen; i++){
                const rowPos = {
                    rowIndex: row.rowIndex,
                    rowPinned: row.rowPinned
                };
                const celPos = $5b7ccabde48fae90$var$__spreadProps2($5b7ccabde48fae90$var$__spreadValues2({}, rowPos), {
                    column: cellRange.columns[i]
                });
                const cell = this.navigationService.getCellByPosition(celPos);
                if (cell) {
                    this.markedCells.push(cell);
                    const cellComp = cell.getComp();
                    cellComp.addOrRemoveCssClass("ag-selection-fill-bottom", this.rowPositionUtils.sameRow(row, endPosition));
                }
            }
            if (isLastRow) break;
        }while (row = this.cellNavigationService.getRowAbove(row));
    }
    extendHorizontal(initialPosition, endPosition, isMovingLeft) {
        const allCols = this.columnModel.getAllDisplayedColumns();
        const startCol = allCols.indexOf(isMovingLeft ? endPosition.column : initialPosition.column);
        const endCol = allCols.indexOf(isMovingLeft ? this.getCellRange().columns[0] : endPosition.column);
        const offset = isMovingLeft ? 0 : 1;
        const colsToMark = allCols.slice(startCol + offset, endCol + offset);
        const rangeStartRow = this.getRangeStartRow();
        const rangeEndRow = this.getRangeEndRow();
        colsToMark.forEach((column)=>{
            let row = rangeStartRow;
            let isLastRow = false;
            do {
                isLastRow = this.rowPositionUtils.sameRow(row, rangeEndRow);
                const cell = this.navigationService.getCellByPosition({
                    rowIndex: row.rowIndex,
                    rowPinned: row.rowPinned,
                    column: column
                });
                if (cell) {
                    this.markedCells.push(cell);
                    const cellComp = cell.getComp();
                    cellComp.addOrRemoveCssClass("ag-selection-fill-top", this.rowPositionUtils.sameRow(row, rangeStartRow));
                    cellComp.addOrRemoveCssClass("ag-selection-fill-bottom", this.rowPositionUtils.sameRow(row, rangeEndRow));
                    if (isMovingLeft) {
                        this.isLeft = true;
                        cellComp.addOrRemoveCssClass("ag-selection-fill-left", column === colsToMark[0]);
                    } else cellComp.addOrRemoveCssClass("ag-selection-fill-right", column === (0, $jIDNV._).last(colsToMark));
                }
                row = this.cellNavigationService.getRowBelow(row);
            }while (!isLastRow);
        });
    }
    reduceHorizontal(initialPosition, endPosition) {
        const allCols = this.columnModel.getAllDisplayedColumns();
        const startCol = allCols.indexOf(endPosition.column);
        const endCol = allCols.indexOf(initialPosition.column);
        const colsToMark = allCols.slice(startCol, endCol);
        const rangeStartRow = this.getRangeStartRow();
        const rangeEndRow = this.getRangeEndRow();
        colsToMark.forEach((column)=>{
            let row = rangeStartRow;
            let isLastRow = false;
            do {
                isLastRow = this.rowPositionUtils.sameRow(row, rangeEndRow);
                const cell = this.navigationService.getCellByPosition({
                    rowIndex: row.rowIndex,
                    rowPinned: row.rowPinned,
                    column: column
                });
                if (cell) {
                    this.markedCells.push(cell);
                    const cellComp = cell.getComp();
                    cellComp.addOrRemoveCssClass("ag-selection-fill-right", column === colsToMark[0]);
                }
                row = this.cellNavigationService.getRowBelow(row);
            }while (!isLastRow);
        });
    }
    refresh(cellCtrl) {
        const cellRange = this.rangeService.getCellRanges()[0];
        const isColumnRange = !cellRange.startRow || !cellRange.endRow;
        if (isColumnRange) {
            this.destroy();
            return;
        }
        super.refresh(cellCtrl);
    }
};
$5b7ccabde48fae90$var$_FillHandle.TEMPLATE = /* html */ `<div class="ag-fill-handle"></div>`;
$5b7ccabde48fae90$var$__decorateClass3([
    (0, $jIDNV.Autowired)("valueService")
], $5b7ccabde48fae90$var$_FillHandle.prototype, "valueService", 2);
var $5b7ccabde48fae90$var$FillHandle = $5b7ccabde48fae90$var$_FillHandle;
var $5b7ccabde48fae90$var$_RangeHandle = class _RangeHandle2 extends $5b7ccabde48fae90$var$AbstractSelectionHandle {
    constructor(){
        super(_RangeHandle2.TEMPLATE);
        this.type = (0, $jIDNV.SelectionHandleType).RANGE;
        this.rangeFixed = false;
    }
    onDrag(e) {
        const lastCellHovered = this.getLastCellHovered();
        if (!lastCellHovered) return;
        const cellRanges = this.rangeService.getCellRanges();
        const lastRange = (0, $jIDNV._).last(cellRanges);
        if (!this.rangeFixed) {
            this.fixRangeStartEnd(lastRange);
            this.rangeFixed = true;
        }
        this.endPosition = {
            rowIndex: lastCellHovered.rowIndex,
            rowPinned: lastCellHovered.rowPinned,
            column: lastCellHovered.column
        };
        if (cellRanges.length === 2 && cellRanges[0].type === (0, $jIDNV.CellRangeType).DIMENSION && lastRange.type === (0, $jIDNV.CellRangeType).VALUE) {
            const rowChanged = !this.rowPositionUtils.sameRow(this.endPosition, this.rangeService.getRangeEndRow(lastRange));
            if (rowChanged) this.rangeService.updateRangeEnd(cellRanges[0], $5b7ccabde48fae90$var$__spreadProps2($5b7ccabde48fae90$var$__spreadValues2({}, this.endPosition), {
                column: cellRanges[0].columns[0]
            }), true);
        }
        this.rangeService.extendLatestRangeToCell(this.endPosition);
    }
    onDragEnd(e) {
        const cellRange = (0, $jIDNV._).last(this.rangeService.getCellRanges());
        this.fixRangeStartEnd(cellRange);
        this.rangeFixed = false;
    }
    fixRangeStartEnd(cellRange) {
        const startRow = this.rangeService.getRangeStartRow(cellRange);
        const endRow = this.rangeService.getRangeEndRow(cellRange);
        const column = cellRange.columns[0];
        cellRange.startRow = startRow;
        cellRange.endRow = endRow;
        cellRange.startColumn = column;
    }
};
$5b7ccabde48fae90$var$_RangeHandle.TEMPLATE = /* html */ `<div class="ag-range-handle"></div>`;
var $5b7ccabde48fae90$var$RangeHandle = $5b7ccabde48fae90$var$_RangeHandle;
var $5b7ccabde48fae90$var$SelectionHandleFactory = class extends (0, $jIDNV.BeanStub) {
    createSelectionHandle(type) {
        return this.createBean(type === (0, $jIDNV.SelectionHandleType).RANGE ? new $5b7ccabde48fae90$var$RangeHandle() : new $5b7ccabde48fae90$var$FillHandle());
    }
};
$5b7ccabde48fae90$var$SelectionHandleFactory = $5b7ccabde48fae90$var$__decorateClass3([
    (0, $jIDNV.Bean)("selectionHandleFactory")
], $5b7ccabde48fae90$var$SelectionHandleFactory);
var $5b7ccabde48fae90$var$VERSION3 = "31.3.4";
var $5b7ccabde48fae90$export$5e5c8269d4d7ed2e = {
    version: $5b7ccabde48fae90$var$VERSION3,
    moduleName: (0, $jIDNV.ModuleNames).RangeSelectionModule,
    beans: [
        $5b7ccabde48fae90$var$RangeService,
        $5b7ccabde48fae90$var$SelectionHandleFactory
    ],
    agStackComponents: [
        {
            componentName: "AgFillHandle",
            componentClass: $5b7ccabde48fae90$var$FillHandle
        },
        {
            componentName: "AgRangeHandle",
            componentClass: $5b7ccabde48fae90$var$RangeHandle
        }
    ],
    dependantModules: [
        $5b7ccabde48fae90$export$3a6d13add8617801
    ]
};
// enterprise-modules/charts/dist/package/main.esm.mjs
$5b7ccabde48fae90$var$__reExport($5b7ccabde48fae90$var$main_esm_exports, $iTJTu);
var $5b7ccabde48fae90$var$__defProp4 = Object.defineProperty;
var $5b7ccabde48fae90$var$__defProps3 = Object.defineProperties;
var $5b7ccabde48fae90$var$__getOwnPropDesc4 = Object.getOwnPropertyDescriptor;
var $5b7ccabde48fae90$var$__getOwnPropDescs3 = Object.getOwnPropertyDescriptors;
var $5b7ccabde48fae90$var$__getOwnPropSymbols3 = Object.getOwnPropertySymbols;
var $5b7ccabde48fae90$var$__hasOwnProp4 = Object.prototype.hasOwnProperty;
var $5b7ccabde48fae90$var$__propIsEnum3 = Object.prototype.propertyIsEnumerable;
var $5b7ccabde48fae90$var$__defNormalProp3 = (obj, key, value)=>key in obj ? $5b7ccabde48fae90$var$__defProp4(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5b7ccabde48fae90$var$__spreadValues3 = (a, b)=>{
    for(var prop in b || (b = {}))if ($5b7ccabde48fae90$var$__hasOwnProp4.call(b, prop)) $5b7ccabde48fae90$var$__defNormalProp3(a, prop, b[prop]);
    if ($5b7ccabde48fae90$var$__getOwnPropSymbols3) {
        for (var prop of $5b7ccabde48fae90$var$__getOwnPropSymbols3(b))if ($5b7ccabde48fae90$var$__propIsEnum3.call(b, prop)) $5b7ccabde48fae90$var$__defNormalProp3(a, prop, b[prop]);
    }
    return a;
};
var $5b7ccabde48fae90$var$__spreadProps3 = (a, b)=>$5b7ccabde48fae90$var$__defProps3(a, $5b7ccabde48fae90$var$__getOwnPropDescs3(b));
var $5b7ccabde48fae90$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($5b7ccabde48fae90$var$__hasOwnProp4.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $5b7ccabde48fae90$var$__getOwnPropSymbols3) {
        for (var prop of $5b7ccabde48fae90$var$__getOwnPropSymbols3(source))if (exclude.indexOf(prop) < 0 && $5b7ccabde48fae90$var$__propIsEnum3.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $5b7ccabde48fae90$var$__decorateClass4 = (decorators, target, key, kind)=>{
    var result = kind > 1 ? void 0 : kind ? $5b7ccabde48fae90$var$__getOwnPropDesc4(target, key) : target;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
    if (kind && result) $5b7ccabde48fae90$var$__defProp4(target, key, result);
    return result;
};
var $5b7ccabde48fae90$var$_ChartDatasource = class _ChartDatasource2 extends (0, $jIDNV.BeanStub) {
    getData(params) {
        if (params.crossFiltering) {
            if (params.grouping) {
                console.warn("AG Grid: crossing filtering with row grouping is not supported.");
                return {
                    chartData: [],
                    columnNames: {}
                };
            }
            if (!this.gos.isRowModelType("clientSide")) {
                console.warn("AG Grid: crossing filtering is only supported in the client side row model.");
                return {
                    chartData: [],
                    columnNames: {}
                };
            }
        }
        const isServerSide = this.gos.isRowModelType("serverSide");
        if (isServerSide && params.pivoting) this.updatePivotKeysForSSRM();
        const result = this.extractRowsFromGridRowModel(params);
        result.chartData = this.aggregateRowsByDimension(params, result.chartData);
        return result;
    }
    extractRowsFromGridRowModel(params) {
        const { crossFiltering: crossFiltering, startRow: startRow, endRow: endRow, valueCols: valueCols, dimensionCols: dimensionCols, grouping: grouping } = params;
        let extractedRowData = [];
        const columnNames = {};
        const groupNodeIndexes = {};
        const groupsToRemove = {};
        let filteredNodes = {};
        let allRowNodes = [];
        let numRows;
        if (crossFiltering) {
            filteredNodes = this.getFilteredRowNodes();
            allRowNodes = this.getAllRowNodes();
            numRows = allRowNodes.length;
        } else {
            const modelLastRow = this.gridRowModel.getRowCount() - 1;
            const hasNoRange = startRow === endRow && startRow === 0 && dimensionCols.length === 0 && valueCols.length === 0;
            if (hasNoRange) numRows = 0;
            else {
                const rangeLastRow = endRow >= 0 ? Math.min(endRow, modelLastRow) : modelLastRow;
                numRows = rangeLastRow - startRow + 1;
            }
        }
        if (numRows > 0) valueCols.forEach((col)=>{
            let columnNamesArr = [];
            const pivotKeys = col.getColDef().pivotKeys;
            if (pivotKeys) columnNamesArr = pivotKeys.slice();
            const headerName = col.getColDef().headerName;
            if (headerName) columnNamesArr.push(headerName);
            if (columnNamesArr.length > 0) columnNames[col.getId()] = columnNamesArr;
        });
        let numRemovedNodes = 0;
        for(let i = 0; i < numRows; i++){
            const rowNode = crossFiltering ? allRowNodes[i] : this.gridRowModel.getRow(i + startRow);
            if (rowNode.footer) {
                numRemovedNodes++;
                continue;
            }
            const data = {};
            dimensionCols.forEach((col)=>{
                const colId = col.colId;
                const column = this.columnModel.getGridColumn(colId);
                if (column) {
                    const valueObject = this.valueService.getValue(column, rowNode);
                    if (grouping) {
                        const valueString = valueObject && valueObject.toString ? String(valueObject.toString()) : "";
                        const labels = _ChartDatasource2.getGroupLabels(rowNode, valueString);
                        data[colId] = {
                            labels: labels,
                            toString: function() {
                                return this.labels.filter((l)=>!!l).reverse().join(" - ");
                            }
                        };
                        if (rowNode.group) groupNodeIndexes[labels.toString()] = i - numRemovedNodes;
                        const groupKey = labels.slice(1, labels.length).toString();
                        if (groupKey) groupsToRemove[groupKey] = groupNodeIndexes[groupKey];
                    } else data[colId] = valueObject;
                } else data[$5b7ccabde48fae90$var$ChartDataModel.DEFAULT_CATEGORY] = i + 1;
            });
            valueCols.forEach((col)=>{
                const colId = col.getColId();
                if (crossFiltering) {
                    const filteredOutColId = colId + "-filtered-out";
                    const value = this.valueService.getValue(col, rowNode);
                    const actualValue = value != null && typeof value.toNumber === "function" ? value.toNumber() : value;
                    if (filteredNodes[rowNode.id]) {
                        data[colId] = actualValue;
                        data[filteredOutColId] = params.aggFunc || params.isScatter ? void 0 : 0;
                    } else {
                        data[colId] = params.aggFunc || params.isScatter ? void 0 : 0;
                        data[filteredOutColId] = actualValue;
                    }
                } else {
                    let value = this.valueService.getValue(col, rowNode);
                    if (value && value.hasOwnProperty("toString")) value = parseFloat(value.toString());
                    data[colId] = value != null && typeof value.toNumber === "function" ? value.toNumber() : value;
                }
            });
            extractedRowData.push(data);
        }
        let groupChartData;
        if (grouping) {
            const groupIndexesToRemove = (0, $jIDNV._).values(groupsToRemove);
            const allData = extractedRowData;
            extractedRowData = [];
            groupChartData = [];
            for(let i = 0; i < allData.length; i++)((0, $jIDNV._).includes(groupIndexesToRemove, i) ? groupChartData : extractedRowData).push(allData[i]);
        }
        return {
            chartData: extractedRowData,
            columnNames: columnNames,
            groupChartData: groupChartData
        };
    }
    aggregateRowsByDimension(params, dataFromGrid) {
        const dimensionCols = params.dimensionCols;
        if (!params.aggFunc || dimensionCols.length === 0) return dataFromGrid;
        const lastCol = (0, $jIDNV._).last(dimensionCols);
        const lastColId = lastCol && lastCol.colId;
        const map = {};
        const dataAggregated = [];
        dataFromGrid.forEach((data)=>{
            let currentMap = map;
            dimensionCols.forEach((col)=>{
                const colId = col.colId;
                const key = data[colId];
                if (colId === lastColId) {
                    let groupItem = currentMap[key];
                    if (!groupItem) {
                        groupItem = {
                            __children: []
                        };
                        dimensionCols.forEach((dimCol)=>{
                            const dimColId = dimCol.colId;
                            groupItem[dimColId] = data[dimColId];
                        });
                        currentMap[key] = groupItem;
                        dataAggregated.push(groupItem);
                    }
                    groupItem.__children.push(data);
                } else {
                    if (!currentMap[key]) currentMap[key] = {};
                    currentMap = currentMap[key];
                }
            });
        });
        if ((0, $jIDNV.ModuleRegistry).__assertRegistered((0, $jIDNV.ModuleNames).RowGroupingModule, "Charting Aggregation", this.context.getGridId())) {
            const aggStage = this.aggregationStage;
            dataAggregated.forEach((groupItem)=>params.valueCols.forEach((col)=>{
                    if (params.crossFiltering) params.valueCols.forEach((valueCol)=>{
                        const colId = valueCol.getColId();
                        const dataToAgg = groupItem.__children.filter((child)=>typeof child[colId] !== "undefined").map((child)=>child[colId]);
                        let aggResult = aggStage.aggregateValues(dataToAgg, params.aggFunc);
                        groupItem[valueCol.getId()] = aggResult && typeof aggResult.value !== "undefined" ? aggResult.value : aggResult;
                        const filteredOutColId = `${colId}-filtered-out`;
                        const dataToAggFiltered = groupItem.__children.filter((child)=>typeof child[filteredOutColId] !== "undefined").map((child)=>child[filteredOutColId]);
                        let aggResultFiltered = aggStage.aggregateValues(dataToAggFiltered, params.aggFunc);
                        groupItem[filteredOutColId] = aggResultFiltered && typeof aggResultFiltered.value !== "undefined" ? aggResultFiltered.value : aggResultFiltered;
                    });
                    else {
                        const dataToAgg = groupItem.__children.map((child)=>child[col.getId()]);
                        let aggResult = aggStage.aggregateValues(dataToAgg, params.aggFunc);
                        groupItem[col.getId()] = aggResult && typeof aggResult.value !== "undefined" ? aggResult.value : aggResult;
                    }
                }));
        }
        return dataAggregated;
    }
    updatePivotKeysForSSRM() {
        const secondaryColumns = this.columnModel.getSecondaryColumns();
        if (!secondaryColumns) return;
        const pivotKeySeparator = this.extractPivotKeySeparator(secondaryColumns);
        secondaryColumns.forEach((col)=>{
            if (pivotKeySeparator === "") col.getColDef().pivotKeys = [];
            else {
                const keys = col.getColId().split(pivotKeySeparator);
                col.getColDef().pivotKeys = keys.slice(0, keys.length - 1);
            }
        });
    }
    extractPivotKeySeparator(secondaryColumns) {
        if (secondaryColumns.length === 0) return "";
        const extractSeparator = (columnGroup, childId)=>{
            const groupId = columnGroup.getGroupId();
            if (!columnGroup.getParent()) return childId.split(groupId)[1][0];
            return extractSeparator(columnGroup.getParent(), groupId);
        };
        const firstSecondaryCol = secondaryColumns[0];
        if (firstSecondaryCol.getParent() == null) return "";
        return extractSeparator(firstSecondaryCol.getParent(), firstSecondaryCol.getColId());
    }
    static getGroupLabels(rowNode, initialLabel) {
        const labels = [
            initialLabel
        ];
        while(rowNode && rowNode.level !== 0){
            rowNode = rowNode.parent;
            if (rowNode) labels.push(rowNode.key);
        }
        return labels;
    }
    getFilteredRowNodes() {
        const filteredNodes = {};
        this.gridRowModel.forEachNodeAfterFilterAndSort((rowNode)=>{
            filteredNodes[rowNode.id] = rowNode;
        });
        return filteredNodes;
    }
    getAllRowNodes() {
        let allRowNodes = [];
        this.gridRowModel.forEachNode((rowNode)=>{
            allRowNodes.push(rowNode);
        });
        return this.sortRowNodes(allRowNodes);
    }
    sortRowNodes(rowNodes) {
        const sortOptions = this.sortController.getSortOptions();
        const noSort = !sortOptions || sortOptions.length == 0;
        if (noSort) return rowNodes;
        return this.rowNodeSorter.doFullSort(rowNodes, sortOptions);
    }
};
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("rowModel")
], $5b7ccabde48fae90$var$_ChartDatasource.prototype, "gridRowModel", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("valueService")
], $5b7ccabde48fae90$var$_ChartDatasource.prototype, "valueService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$_ChartDatasource.prototype, "columnModel", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("rowNodeSorter")
], $5b7ccabde48fae90$var$_ChartDatasource.prototype, "rowNodeSorter", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("sortController")
], $5b7ccabde48fae90$var$_ChartDatasource.prototype, "sortController", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Optional)("aggregationStage")
], $5b7ccabde48fae90$var$_ChartDatasource.prototype, "aggregationStage", 2);
var $5b7ccabde48fae90$var$ChartDatasource = $5b7ccabde48fae90$var$_ChartDatasource;
var $5b7ccabde48fae90$var$ChartColumnService = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.valueColsWithoutSeriesType = /* @__PURE__ */ new Set();
    }
    postConstruct() {
        const clearValueCols = ()=>this.valueColsWithoutSeriesType.clear();
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_NEW_COLUMNS_LOADED, clearValueCols);
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_ROW_DATA_UPDATED, clearValueCols);
    }
    getColumn(colId) {
        return this.columnModel.getPrimaryColumn(colId);
    }
    getAllDisplayedColumns() {
        return this.columnModel.getAllDisplayedColumns();
    }
    getColDisplayName(col) {
        return this.columnModel.getDisplayNameForColumn(col, "chart");
    }
    getRowGroupColumns() {
        return this.columnModel.getRowGroupColumns();
    }
    getGroupDisplayColumns() {
        return this.columnModel.getGroupDisplayColumns();
    }
    isPivotMode() {
        return this.columnModel.isPivotMode();
    }
    isPivotActive() {
        return this.columnModel.isPivotActive();
    }
    getChartColumns() {
        const gridCols = this.columnModel.getAllGridColumns();
        const dimensionCols = /* @__PURE__ */ new Set();
        const valueCols = /* @__PURE__ */ new Set();
        gridCols.forEach((col)=>{
            const colDef = col.getColDef();
            const chartDataType = colDef.chartDataType;
            if (chartDataType) switch(chartDataType){
                case "category":
                case "time":
                    dimensionCols.add(col);
                    return;
                case "series":
                    valueCols.add(col);
                    return;
                case "excluded":
                    return;
                default:
                    console.warn(`AG Grid: unexpected chartDataType value '${chartDataType}' supplied, instead use 'category', 'series' or 'excluded'`);
                    break;
            }
            if (colDef.colId === "ag-Grid-AutoColumn") {
                dimensionCols.add(col);
                return;
            }
            if (!col.isPrimary()) {
                valueCols.add(col);
                return;
            }
            (this.isInferredValueCol(col) ? valueCols : dimensionCols).add(col);
        });
        return {
            dimensionCols: dimensionCols,
            valueCols: valueCols
        };
    }
    isInferredValueCol(col) {
        const colId = col.getColId();
        if (colId === "ag-Grid-AutoColumn") return false;
        const row = this.rowPositionUtils.getRowNode({
            rowIndex: 0,
            rowPinned: null
        });
        if (!row) return this.valueColsWithoutSeriesType.has(colId);
        let cellValue = this.valueService.getValue(col, row);
        if (cellValue == null) cellValue = this.extractLeafData(row, col);
        if (cellValue != null && typeof cellValue.toNumber === "function") cellValue = cellValue.toNumber();
        const isNumber5 = typeof cellValue === "number";
        if (isNumber5) this.valueColsWithoutSeriesType.add(colId);
        return isNumber5;
    }
    extractLeafData(row, col) {
        if (!row.allLeafChildren) return null;
        for(let i = 0; i < row.allLeafChildren.length; i++){
            const childRow = row.allLeafChildren[i];
            const value = this.valueService.getValue(col, childRow);
            if (value != null) return value;
        }
        return null;
    }
    destroy() {
        this.valueColsWithoutSeriesType.clear();
        super.destroy();
    }
};
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$ChartColumnService.prototype, "columnModel", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("valueService")
], $5b7ccabde48fae90$var$ChartColumnService.prototype, "valueService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("rowPositionUtils")
], $5b7ccabde48fae90$var$ChartColumnService.prototype, "rowPositionUtils", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$ChartColumnService.prototype, "postConstruct", 1);
$5b7ccabde48fae90$var$ChartColumnService = $5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Bean)("chartColumnService")
], $5b7ccabde48fae90$var$ChartColumnService);
var $5b7ccabde48fae90$var$_ComboChartModel = class _ComboChartModel2 extends (0, $jIDNV.BeanStub) {
    constructor(chartDataModel){
        var _a;
        super();
        this.suppressComboChartWarnings = false;
        this.chartDataModel = chartDataModel;
        this.seriesChartTypes = (_a = chartDataModel.params.seriesChartTypes) != null ? _a : [];
    }
    init() {
        this.initComboCharts();
    }
    update(seriesChartTypes) {
        this.seriesChartTypes = seriesChartTypes != null ? seriesChartTypes : this.seriesChartTypes;
        this.initComboCharts();
        this.updateSeriesChartTypes();
    }
    initComboCharts() {
        const seriesChartTypesExist = this.seriesChartTypes && this.seriesChartTypes.length > 0;
        const customCombo = this.chartDataModel.chartType === "customCombo" || seriesChartTypesExist;
        if (customCombo) {
            this.chartDataModel.chartType = "customCombo";
            this.savedCustomSeriesChartTypes = this.seriesChartTypes || [];
        }
    }
    updateSeriesChartTypes() {
        if (!this.chartDataModel.isComboChart()) return;
        this.seriesChartTypes = this.seriesChartTypes.map((seriesChartType)=>{
            const primaryOnly = [
                "groupedColumn",
                "stackedColumn",
                "stackedArea"
            ].includes(seriesChartType.chartType);
            seriesChartType.secondaryAxis = primaryOnly ? false : seriesChartType.secondaryAxis;
            return seriesChartType;
        });
        if (this.chartDataModel.chartType === "customCombo") {
            this.updateSeriesChartTypesForCustomCombo();
            return;
        }
        this.updateChartSeriesTypesForBuiltInCombos();
    }
    updateSeriesChartTypesForCustomCombo() {
        const seriesChartTypesSupplied = this.seriesChartTypes && this.seriesChartTypes.length > 0;
        if (!seriesChartTypesSupplied && !this.suppressComboChartWarnings) console.warn(`AG Grid: 'seriesChartTypes' are required when the 'customCombo' chart type is specified.`);
        this.seriesChartTypes = this.seriesChartTypes.map((s)=>{
            if (!_ComboChartModel2.SUPPORTED_COMBO_CHART_TYPES.includes(s.chartType)) {
                console.warn(`AG Grid: invalid chartType '${s.chartType}' supplied in 'seriesChartTypes', converting to 'line' instead.`);
                s.chartType = "line";
            }
            return s;
        });
        const getSeriesChartType = (valueCol)=>{
            if (!this.savedCustomSeriesChartTypes || this.savedCustomSeriesChartTypes.length === 0) this.savedCustomSeriesChartTypes = this.seriesChartTypes;
            const providedSeriesChartType = this.savedCustomSeriesChartTypes.find((s)=>s.colId === valueCol.colId);
            if (!providedSeriesChartType) {
                if (valueCol.selected && !this.suppressComboChartWarnings) console.warn(`AG Grid: no 'seriesChartType' found for colId = '${valueCol.colId}', defaulting to 'line'.`);
                return {
                    colId: valueCol.colId,
                    chartType: "line",
                    secondaryAxis: false
                };
            }
            return providedSeriesChartType;
        };
        const updatedSeriesChartTypes = this.chartDataModel.valueColState.map(getSeriesChartType);
        this.seriesChartTypes = updatedSeriesChartTypes;
        this.savedCustomSeriesChartTypes = updatedSeriesChartTypes;
        this.suppressComboChartWarnings = true;
    }
    updateChartSeriesTypesForBuiltInCombos() {
        const { chartType: chartType, valueColState: valueColState } = this.chartDataModel;
        let primaryChartType = chartType === "columnLineCombo" ? "groupedColumn" : "stackedArea";
        let secondaryChartType = chartType === "columnLineCombo" ? "line" : "groupedColumn";
        const selectedCols = valueColState.filter((cs)=>cs.selected);
        const lineIndex = Math.ceil(selectedCols.length / 2);
        this.seriesChartTypes = selectedCols.map((valueCol, i)=>{
            const seriesType = i >= lineIndex ? secondaryChartType : primaryChartType;
            return {
                colId: valueCol.colId,
                chartType: seriesType,
                secondaryAxis: false
            };
        });
    }
};
$5b7ccabde48fae90$var$_ComboChartModel.SUPPORTED_COMBO_CHART_TYPES = [
    "line",
    "groupedColumn",
    "stackedColumn",
    "area",
    "stackedArea"
];
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_ComboChartModel.prototype, "init", 1);
var $5b7ccabde48fae90$var$ComboChartModel = $5b7ccabde48fae90$var$_ComboChartModel;
var $5b7ccabde48fae90$var$SERIES_TYPES = {
    "area": {
        isCartesian: true,
        canInvert: true
    },
    "bar": {
        isCartesian: true,
        canInvert: true
    },
    "histogram": {
        isCartesian: true
    },
    "line": {
        isCartesian: true,
        canInvert: true
    },
    "pie": {
        isPie: true
    },
    "donut": {
        isPie: true,
        canInvert: true
    },
    "scatter": {
        isCartesian: true
    },
    "bubble": {
        isCartesian: true
    },
    "radial-column": {
        isPolar: true,
        isEnterprise: true,
        isRadial: true,
        canInvert: true
    },
    "radial-bar": {
        isPolar: true,
        isEnterprise: true,
        isRadial: true,
        canInvert: true
    },
    "radar-line": {
        isPolar: true,
        isEnterprise: true,
        canInvert: true
    },
    "radar-area": {
        isPolar: true,
        isEnterprise: true,
        canInvert: true
    },
    "nightingale": {
        isPolar: true,
        isEnterprise: true,
        canInvert: true
    },
    "range-bar": {
        isCartesian: true,
        isEnterprise: true,
        canSwitchDirection: true
    },
    "range-area": {
        isCartesian: true,
        isEnterprise: true
    },
    "box-plot": {
        isCartesian: true,
        isEnterprise: true,
        canSwitchDirection: true
    },
    "treemap": {
        isEnterprise: true,
        isHierarchical: true
    },
    "sunburst": {
        isEnterprise: true,
        isHierarchical: true
    },
    "heatmap": {
        isCartesian: true,
        isEnterprise: true
    },
    "waterfall": {
        isCartesian: true,
        isEnterprise: true,
        canSwitchDirection: true
    }
};
function $5b7ccabde48fae90$var$isSeriesType(seriesType) {
    return !!$5b7ccabde48fae90$var$SERIES_TYPES[seriesType];
}
function $5b7ccabde48fae90$var$isComboChart(chartType) {
    return (0, $jIDNV.ChartMappings).COMBO_CHART_TYPES.includes(chartType);
}
function $5b7ccabde48fae90$var$doesSeriesHaveProperty(seriesType, prop) {
    var _a;
    return !!((_a = $5b7ccabde48fae90$var$SERIES_TYPES[seriesType]) == null ? void 0 : _a[prop]);
}
function $5b7ccabde48fae90$var$isEnterpriseChartType(chartType) {
    return $5b7ccabde48fae90$var$doesSeriesHaveProperty($5b7ccabde48fae90$var$getSeriesType(chartType), "isEnterprise");
}
var $5b7ccabde48fae90$var$stackedChartTypes = /* @__PURE__ */ new Set([
    "stackedColumn",
    "normalizedColumn",
    "stackedBar",
    "normalizedBar"
]);
function $5b7ccabde48fae90$var$isStacked(chartType) {
    return $5b7ccabde48fae90$var$stackedChartTypes.has(chartType);
}
function $5b7ccabde48fae90$var$isCartesian(seriesType) {
    return $5b7ccabde48fae90$var$doesSeriesHaveProperty(seriesType, "isCartesian");
}
function $5b7ccabde48fae90$var$isPolar(seriesType) {
    return $5b7ccabde48fae90$var$doesSeriesHaveProperty(seriesType, "isPolar");
}
function $5b7ccabde48fae90$var$isRadial(seriesType) {
    return $5b7ccabde48fae90$var$doesSeriesHaveProperty(seriesType, "isRadial");
}
function $5b7ccabde48fae90$var$isHierarchical(seriesType) {
    return $5b7ccabde48fae90$var$doesSeriesHaveProperty(seriesType, "isHierarchical");
}
function $5b7ccabde48fae90$var$getCanonicalChartType(chartType) {
    return chartType === "doughnut" ? "donut" : chartType;
}
function $5b7ccabde48fae90$var$getSeriesTypeIfExists(chartType) {
    return (0, $jIDNV.ChartMappings).CHART_TYPE_TO_SERIES_TYPE[chartType];
}
function $5b7ccabde48fae90$var$getSeriesType(chartType) {
    var _a;
    return (_a = $5b7ccabde48fae90$var$getSeriesTypeIfExists(chartType)) != null ? _a : "line";
}
function $5b7ccabde48fae90$var$isPieChartSeries(seriesType) {
    return $5b7ccabde48fae90$var$doesSeriesHaveProperty(seriesType, "isPie");
}
function $5b7ccabde48fae90$var$canOnlyHaveSingleSeries(chartType) {
    return chartType === "pie" || chartType === "waterfall" || chartType === "histogram";
}
function $5b7ccabde48fae90$var$getMaxNumCategories(chartType) {
    return $5b7ccabde48fae90$var$isHierarchical($5b7ccabde48fae90$var$getSeriesType(chartType)) ? void 0 : 1;
}
function $5b7ccabde48fae90$var$getMaxNumSeries(chartType) {
    if ($5b7ccabde48fae90$var$isHierarchical($5b7ccabde48fae90$var$getSeriesType(chartType))) return 2;
    else if ($5b7ccabde48fae90$var$canOnlyHaveSingleSeries(chartType)) return 1;
    else return void 0;
}
function $5b7ccabde48fae90$var$supportsInvertedCategorySeries(chartType) {
    return $5b7ccabde48fae90$var$doesSeriesHaveProperty($5b7ccabde48fae90$var$getSeriesType(chartType), "canInvert");
}
function $5b7ccabde48fae90$var$canSwitchDirection(chartType) {
    return $5b7ccabde48fae90$var$doesSeriesHaveProperty($5b7ccabde48fae90$var$getSeriesType(chartType), "canSwitchDirection");
}
var $5b7ccabde48fae90$var$_ChartDataModel = class _ChartDataModel2 extends (0, $jIDNV.BeanStub) {
    constructor(params){
        super();
        this.unlinked = false;
        this.chartData = [];
        this.valueColState = [];
        this.dimensionColState = [];
        this.columnNames = {};
        this.crossFiltering = false;
        this.grouping = false;
        this.params = params;
        this.chartId = params.chartId;
        this.setParams(params);
    }
    setParams(params) {
        const { chartType: chartType, pivotChart: pivotChart, chartThemeName: chartThemeName, switchCategorySeries: switchCategorySeries, aggFunc: aggFunc, cellRange: cellRange, suppressChartRanges: suppressChartRanges, unlinkChart: unlinkChart, crossFiltering: crossFiltering, seriesGroupType: seriesGroupType } = params;
        this.chartType = chartType;
        this.pivotChart = pivotChart != null ? pivotChart : false;
        this.chartThemeName = chartThemeName;
        this.switchCategorySeries = !!switchCategorySeries;
        this.aggFunc = aggFunc;
        this.referenceCellRange = cellRange;
        this.suppliedCellRange = cellRange;
        this.suppressChartRanges = suppressChartRanges != null ? suppressChartRanges : false;
        this.unlinked = !!unlinkChart;
        this.crossFiltering = !!crossFiltering;
        this.seriesGroupType = seriesGroupType;
    }
    init() {
        this.datasource = this.createManagedBean(new $5b7ccabde48fae90$var$ChartDatasource());
        this.chartColumnService = this.createManagedBean(new $5b7ccabde48fae90$var$ChartColumnService());
        this.comboChartModel = this.createManagedBean(new $5b7ccabde48fae90$var$ComboChartModel(this));
        this.updateCellRanges({
            setColsFromRange: true
        });
        this.updateData();
    }
    updateModel(params) {
        const { cellRange: cellRange, seriesChartTypes: seriesChartTypes } = params;
        if (cellRange !== this.suppliedCellRange) {
            this.dimensionCellRange = void 0;
            this.valueCellRange = void 0;
        }
        this.setParams(params);
        this.updateSelectedDimensions(cellRange == null ? void 0 : cellRange.columns);
        this.updateCellRanges({
            setColsFromRange: true
        });
        const shouldUpdateComboModel = this.isComboChart() || seriesChartTypes;
        if (shouldUpdateComboModel) this.comboChartModel.update(seriesChartTypes);
        if (!this.unlinked) this.updateData();
    }
    updateCellRanges(params) {
        const { updatedColState: updatedColState, resetOrder: resetOrder, maintainColState: maintainColState, setColsFromRange: setColsFromRange } = params != null ? params : {};
        if (this.valueCellRange) this.referenceCellRange = this.valueCellRange;
        const { dimensionCols: dimensionCols, valueCols: valueCols } = this.chartColumnService.getChartColumns();
        const allColsFromRanges = this.getAllColumnsFromRanges();
        if (updatedColState) this.updateColumnState(updatedColState, resetOrder);
        this.setDimensionCellRange(dimensionCols, allColsFromRanges, updatedColState);
        this.setValueCellRange(valueCols, allColsFromRanges, setColsFromRange);
        if (!updatedColState && !maintainColState) {
            this.resetColumnState();
            this.syncDimensionCellRange();
        }
        this.comboChartModel.updateSeriesChartTypes();
    }
    updateData() {
        const { startRow: startRow, endRow: endRow } = this.getRowIndexes();
        if (this.pivotChart) this.resetColumnState();
        this.grouping = this.isGrouping();
        const params = {
            aggFunc: this.aggFunc,
            dimensionCols: this.getSelectedDimensions(),
            grouping: this.grouping,
            pivoting: this.isPivotActive(),
            crossFiltering: this.crossFiltering,
            valueCols: this.getSelectedValueCols(),
            startRow: startRow,
            endRow: endRow,
            isScatter: (0, $jIDNV._).includes([
                "scatter",
                "bubble"
            ], this.chartType)
        };
        const { chartData: chartData, columnNames: columnNames, groupChartData: groupChartData } = this.datasource.getData(params);
        this.chartData = chartData;
        this.groupChartData = groupChartData;
        this.columnNames = columnNames;
        this.categoryAxisType = void 0;
    }
    isGrouping() {
        const usingTreeData = this.gos.get("treeData");
        const groupedCols = usingTreeData ? null : this.chartColumnService.getRowGroupColumns();
        const isGroupActive = usingTreeData || groupedCols && groupedCols.length > 0;
        const colIds = this.getSelectedDimensions().map(({ colId: colId })=>colId);
        const displayedGroupCols = this.chartColumnService.getGroupDisplayColumns();
        const groupDimensionSelected = displayedGroupCols.map((col)=>col.getColId()).some((id)=>colIds.includes(id));
        return !!isGroupActive && groupDimensionSelected;
    }
    getSelectedValueCols() {
        return this.valueColState.filter((cs)=>cs.selected).map((cs)=>cs.column);
    }
    getSelectedDimensions() {
        return this.dimensionColState.filter((cs)=>cs.selected);
    }
    getColDisplayName(col) {
        return this.chartColumnService.getColDisplayName(col);
    }
    isPivotMode() {
        return this.chartColumnService.isPivotMode();
    }
    getChartDataType(colId) {
        const column = this.chartColumnService.getColumn(colId);
        return column ? column.getColDef().chartDataType : void 0;
    }
    isPivotActive() {
        return this.chartColumnService.isPivotActive();
    }
    createCellRange(type, ...columns) {
        return {
            id: this.chartId,
            // set range ID to match chart ID so we can identify changes to the ranges for this chart
            startRow: this.referenceCellRange.startRow,
            endRow: this.referenceCellRange.endRow,
            columns: columns,
            startColumn: type === (0, $jIDNV.CellRangeType).DIMENSION || this.referenceCellRange.startColumn == null ? columns[0] : this.referenceCellRange.startColumn,
            type: type
        };
    }
    getAllColumnsFromRanges() {
        if (this.pivotChart) return (0, $jIDNV._).convertToSet(this.chartColumnService.getAllDisplayedColumns());
        const columns = this.dimensionCellRange || this.valueCellRange ? [] : this.referenceCellRange.columns;
        if (this.dimensionCellRange) columns.push(...this.dimensionCellRange.columns);
        if (this.valueCellRange) columns.push(...this.valueCellRange.columns);
        return (0, $jIDNV._).convertToSet(columns);
    }
    getRowIndexes() {
        let startRow = 0, endRow = 0;
        const { rangeService: rangeService, valueCellRange: valueCellRange, dimensionCellRange: dimensionCellRange } = this;
        const cellRange = valueCellRange || dimensionCellRange;
        if (rangeService && cellRange) {
            startRow = rangeService.getRangeStartRow(cellRange).rowIndex;
            const endRowPosition = rangeService.getRangeEndRow(cellRange);
            endRow = endRowPosition.rowPinned === "bottom" ? -1 : endRowPosition.rowIndex;
        }
        return {
            startRow: startRow,
            endRow: endRow
        };
    }
    resetColumnState() {
        const { dimensionCols: dimensionCols, valueCols: valueCols } = this.chartColumnService.getChartColumns();
        const allCols = this.getAllColumnsFromRanges();
        const isInitialising = this.valueColState.length < 1;
        this.dimensionColState = [];
        this.valueColState = [];
        const supportsMultipleDimensions = $5b7ccabde48fae90$var$isHierarchical($5b7ccabde48fae90$var$getSeriesType(this.chartType));
        let hasSelectedDimension = false;
        let order = 1;
        const aggFuncDimension = this.suppliedCellRange.columns[0];
        dimensionCols.forEach((column)=>{
            const isAutoGroupCol = column.getColId() === "ag-Grid-AutoColumn";
            let selected = false;
            if (this.crossFiltering && this.aggFunc) {
                if (aggFuncDimension.getColId() === column.getColId()) selected = true;
            } else selected = isAutoGroupCol ? true : (!hasSelectedDimension || supportsMultipleDimensions) && allCols.has(column);
            this.dimensionColState.push({
                column: column,
                colId: column.getColId(),
                displayName: this.getColDisplayName(column),
                selected: selected,
                order: order++
            });
            if (selected) hasSelectedDimension = true;
        });
        const defaultCategory = {
            colId: _ChartDataModel2.DEFAULT_CATEGORY,
            displayName: this.chartTranslationService.translate("defaultCategory"),
            selected: !hasSelectedDimension,
            // if no dimensions in range select the default
            order: 0
        };
        this.dimensionColState.unshift(defaultCategory);
        const valueColumnsFromReferenceRange = this.referenceCellRange.columns.filter((c)=>valueCols.has(c));
        valueCols.forEach((column)=>{
            if (isInitialising && (0, $jIDNV._).includes(this.referenceCellRange.columns, column)) column = valueColumnsFromReferenceRange.shift();
            this.valueColState.push({
                column: column,
                colId: column.getColId(),
                displayName: this.getColDisplayName(column),
                selected: allCols.has(column),
                order: order++
            });
        });
    }
    updateColumnState(updatedCol, resetOrder) {
        const idsMatch = (cs)=>cs.colId === updatedCol.colId;
        const { dimensionColState: dimensionColState, valueColState: valueColState } = this;
        const matchedDimensionColState = dimensionColState.find(idsMatch);
        const matchedValueColState = valueColState.find(idsMatch);
        if (matchedDimensionColState) {
            const supportsMultipleDimensions = $5b7ccabde48fae90$var$isHierarchical($5b7ccabde48fae90$var$getSeriesType(this.chartType));
            if (!supportsMultipleDimensions) {
                const selectedColumnState = updatedCol.selected ? matchedDimensionColState : dimensionColState.filter((cs)=>cs !== matchedDimensionColState).find(({ selected: selected })=>selected);
                dimensionColState.forEach((cs)=>cs.selected = cs === selectedColumnState);
            } else matchedDimensionColState.selected = updatedCol.selected;
        } else if (matchedValueColState) matchedValueColState.selected = updatedCol.selected;
        const allColumns = [
            ...dimensionColState,
            ...valueColState
        ];
        const orderedColIds = [];
        if (!resetOrder) {
            allColumns.forEach((col, i)=>{
                if (i === updatedCol.order) orderedColIds.push(updatedCol.colId);
                if (col.colId !== updatedCol.colId) orderedColIds.push(col.colId);
            });
            allColumns.forEach((col)=>{
                const order = orderedColIds.indexOf(col.colId);
                col.order = order >= 0 ? orderedColIds.indexOf(col.colId) : allColumns.length - 1;
            });
        }
        this.reorderColState();
    }
    reorderColState() {
        const ascColStateOrder = (a, b)=>a.order - b.order;
        this.dimensionColState.sort(ascColStateOrder);
        this.valueColState.sort(ascColStateOrder);
    }
    setDimensionCellRange(dimensionCols, colsInRange, updatedColState) {
        this.dimensionCellRange = void 0;
        const supportsMultipleDimensions = $5b7ccabde48fae90$var$isHierarchical($5b7ccabde48fae90$var$getSeriesType(this.chartType));
        if (!updatedColState && !this.dimensionColState.length) {
            const selectedCols = new Array();
            dimensionCols.forEach((col)=>{
                if (selectedCols.length > 0 && !supportsMultipleDimensions || !colsInRange.has(col)) return;
                selectedCols.push(col);
            });
            if (selectedCols.length > 0) this.dimensionCellRange = this.createCellRange((0, $jIDNV.CellRangeType).DIMENSION, ...selectedCols);
            return;
        }
        let selectedDimensionColStates = updatedColState ? [
            updatedColState
        ] : [];
        if (this.crossFiltering && this.aggFunc) {
            const aggFuncDimension = this.suppliedCellRange.columns[0];
            selectedDimensionColStates = this.dimensionColState.filter((cs)=>cs.colId === aggFuncDimension.getColId());
        } else if (supportsMultipleDimensions || selectedDimensionColStates.length === 0 || selectedDimensionColStates.some(({ column: column })=>!column || !dimensionCols.has(column))) selectedDimensionColStates = this.dimensionColState.filter((cs)=>cs.selected);
        const isDefaultCategory = selectedDimensionColStates.length === 1 ? selectedDimensionColStates[0].colId === _ChartDataModel2.DEFAULT_CATEGORY : false;
        const selectedColumns = selectedDimensionColStates.map(({ column: column })=>column).filter((value)=>value != null);
        if (selectedColumns.length > 0 && !isDefaultCategory) this.dimensionCellRange = this.createCellRange((0, $jIDNV.CellRangeType).DIMENSION, ...selectedColumns);
    }
    setValueCellRange(valueCols, colsInRange, setColsFromRange) {
        this.valueCellRange = void 0;
        const selectedValueCols = [];
        const maxSelection = $5b7ccabde48fae90$var$getMaxNumSeries(this.chartType);
        let numSelected = 0;
        valueCols.forEach((col)=>{
            if (setColsFromRange) {
                if ((maxSelection == null || numSelected < maxSelection) && colsInRange.has(col)) {
                    selectedValueCols.push(col);
                    numSelected++;
                }
            } else if (this.valueColState.some((colState)=>colState.selected && colState.colId === col.getColId())) selectedValueCols.push(col);
        });
        if (selectedValueCols.length > 0) {
            let orderedColIds = [];
            if (this.valueColState.length > 0) orderedColIds = this.valueColState.map((c)=>c.colId);
            else colsInRange.forEach((c)=>orderedColIds.push(c.getColId()));
            selectedValueCols.sort((a, b)=>orderedColIds.indexOf(a.getColId()) - orderedColIds.indexOf(b.getColId()));
            this.valueCellRange = this.createCellRange((0, $jIDNV.CellRangeType).VALUE, ...selectedValueCols);
        }
    }
    resetCellRanges(dimension, value) {
        if (!dimension && !value) return;
        const { dimensionCols: dimensionCols, valueCols: valueCols } = this.chartColumnService.getChartColumns();
        const allColsFromRanges = this.getAllColumnsFromRanges();
        if (dimension) this.setDimensionCellRange(dimensionCols, allColsFromRanges);
        if (value) this.setValueCellRange(valueCols, allColsFromRanges);
    }
    updateSelectedDimensions(columns) {
        const colIdSet = new Set(columns.map((column)=>column.getColId()));
        const supportsMultipleDimensions = $5b7ccabde48fae90$var$isHierarchical($5b7ccabde48fae90$var$getSeriesType(this.chartType));
        if (!supportsMultipleDimensions) {
            const foundColState = this.dimensionColState.find((colState)=>colIdSet.has(colState.colId)) || this.dimensionColState[0];
            const selectedColumnId = foundColState.colId;
            this.dimensionColState = this.dimensionColState.map((colState)=>$5b7ccabde48fae90$var$__spreadProps3($5b7ccabde48fae90$var$__spreadValues3({}, colState), {
                    selected: colState.colId === selectedColumnId
                }));
        } else {
            const foundColStates = this.dimensionColState.filter((colState)=>colIdSet.has(colState.colId));
            const selectedColumnIds = new Set(foundColStates.map((colState)=>colState.colId));
            this.dimensionColState = this.dimensionColState.map((colState)=>$5b7ccabde48fae90$var$__spreadProps3($5b7ccabde48fae90$var$__spreadValues3({}, colState), {
                    selected: selectedColumnIds.has(colState.colId)
                }));
        }
    }
    syncDimensionCellRange() {
        const selectedDimensions = this.getSelectedDimensions();
        if (selectedDimensions.length === 0) return;
        const selectedCols = selectedDimensions.map(({ column: column })=>column).filter((value)=>value != null);
        if (selectedCols.length > 0) this.dimensionCellRange = this.createCellRange((0, $jIDNV.CellRangeType).DIMENSION, ...selectedCols);
    }
    isComboChart(chartType) {
        return $5b7ccabde48fae90$var$isComboChart(chartType != null ? chartType : this.chartType);
    }
};
$5b7ccabde48fae90$var$_ChartDataModel.DEFAULT_CATEGORY = "AG-GRID-DEFAULT-CATEGORY";
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("rangeService")
], $5b7ccabde48fae90$var$_ChartDataModel.prototype, "rangeService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartTranslationService")
], $5b7ccabde48fae90$var$_ChartDataModel.prototype, "chartTranslationService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_ChartDataModel.prototype, "init", 1);
var $5b7ccabde48fae90$var$ChartDataModel = $5b7ccabde48fae90$var$_ChartDataModel;
var $5b7ccabde48fae90$var$ALL_AXIS_TYPES = [
    "number",
    "category",
    "grouped-category",
    "log",
    "time"
];
function $5b7ccabde48fae90$var$getLegacyAxisType(chartType) {
    switch(chartType){
        case "bar":
        case "stackedBar":
        case "normalizedBar":
            return [
                "number",
                "category"
            ];
        case "groupedBar":
            return [
                "number",
                "grouped-category"
            ];
        case "column":
        case "stackedColumn":
        case "normalizedColumn":
        case "line":
        case "area":
        case "stackedArea":
        case "normalizedArea":
        case "histogram":
            return [
                "category",
                "number"
            ];
        case "groupedColumn":
            return [
                "grouped-category",
                "number"
            ];
        case "scatter":
        case "bubble":
            return [
                "number",
                "number"
            ];
        default:
            return void 0;
    }
}
function $5b7ccabde48fae90$var$emptyTarget(value) {
    return Array.isArray(value) ? [] : {};
}
function $5b7ccabde48fae90$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $5b7ccabde48fae90$var$deepMerge($5b7ccabde48fae90$var$emptyTarget(value), value, options) : value;
}
function $5b7ccabde48fae90$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $5b7ccabde48fae90$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $5b7ccabde48fae90$var$getMergeFunction(key, options) {
    if (!options.customMerge) return $5b7ccabde48fae90$var$deepMerge;
    const customMerge = options.customMerge(key);
    return typeof customMerge === "function" ? customMerge : $5b7ccabde48fae90$var$deepMerge;
}
function $5b7ccabde48fae90$var$getEnumerableOwnPropertySymbols(target) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
        return target.propertyIsEnumerable(symbol);
    }) : [];
}
function $5b7ccabde48fae90$var$getKeys(target) {
    return Object.keys(target).concat($5b7ccabde48fae90$var$getEnumerableOwnPropertySymbols(target));
}
function $5b7ccabde48fae90$var$propertyIsOnObject(object, property) {
    try {
        return property in object;
    } catch (_382) {
        return false;
    }
}
function $5b7ccabde48fae90$var$propertyIsUnsafe(target, key) {
    return $5b7ccabde48fae90$var$propertyIsOnObject(target, key) && !(Object.hasOwnProperty.call(target, key) && Object.propertyIsEnumerable.call(target, key));
}
function $5b7ccabde48fae90$var$mergeObject(target = {}, source = {}, options) {
    const destination = {};
    if (options.isMergeableObject(target)) $5b7ccabde48fae90$var$getKeys(target).forEach(function(key) {
        destination[key] = $5b7ccabde48fae90$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    $5b7ccabde48fae90$var$getKeys(source).forEach(function(key) {
        if ($5b7ccabde48fae90$var$propertyIsUnsafe(target, key)) return;
        if ($5b7ccabde48fae90$var$propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) destination[key] = $5b7ccabde48fae90$var$getMergeFunction(key, options)(target[key], source[key], options);
        else destination[key] = $5b7ccabde48fae90$var$cloneUnlessOtherwiseSpecified(source[key], options);
    });
    return destination;
}
function $5b7ccabde48fae90$var$defaultIsMergeableObject(value) {
    return $5b7ccabde48fae90$var$isNonNullObject(value) && !$5b7ccabde48fae90$var$isSpecial(value);
}
function $5b7ccabde48fae90$var$isNonNullObject(value) {
    return !!value && typeof value === "object";
}
function $5b7ccabde48fae90$var$isSpecial(value) {
    const stringValue = Object.prototype.toString.call(value);
    return stringValue === "[object RegExp]" || stringValue === "[object Date]";
}
function $5b7ccabde48fae90$var$deepMerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $5b7ccabde48fae90$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $5b7ccabde48fae90$var$defaultIsMergeableObject;
    options.cloneUnlessOtherwiseSpecified = $5b7ccabde48fae90$var$cloneUnlessOtherwiseSpecified;
    const sourceIsArray = Array.isArray(source);
    const targetIsArray = Array.isArray(target);
    const sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $5b7ccabde48fae90$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $5b7ccabde48fae90$var$mergeObject(target, source, options);
}
function $5b7ccabde48fae90$var$get(source, expression, defaultValue) {
    if (source == null) return defaultValue;
    const keys = expression.split(".");
    let objectToRead = source;
    while(keys.length > 1){
        objectToRead = objectToRead[keys.shift()];
        if (objectToRead == null) return defaultValue;
    }
    const value = objectToRead[keys[0]];
    return value != null ? value : defaultValue;
}
function $5b7ccabde48fae90$var$set(target, expression, value) {
    if (target == null) return;
    const keys = expression.split(".");
    let objectToUpdate = target;
    keys.forEach((key, i)=>{
        if (!objectToUpdate[key]) objectToUpdate[key] = {};
        if (i < keys.length - 1) objectToUpdate = objectToUpdate[key];
    });
    objectToUpdate[keys[keys.length - 1]] = value;
}
function $5b7ccabde48fae90$var$createAgChartTheme(chartProxyParams, proxy, isEnterprise, chartThemeDefaults, updatedOverrides) {
    var _a;
    const { chartOptionsToRestore: chartOptionsToRestore, chartPaletteToRestore: chartPaletteToRestore, chartThemeToRestore: chartThemeToRestore } = chartProxyParams;
    const themeName = $5b7ccabde48fae90$var$getSelectedTheme(chartProxyParams);
    const stockTheme = $5b7ccabde48fae90$var$isStockTheme(themeName);
    const rootTheme = stockTheme ? {
        baseTheme: themeName
    } : (_a = $5b7ccabde48fae90$var$lookupCustomChartTheme(chartProxyParams, themeName)) != null ? _a : {};
    const gridOptionsThemeOverrides = chartProxyParams.getGridOptionsChartThemeOverrides();
    const apiThemeOverrides = chartProxyParams.apiChartThemeOverrides;
    const standaloneChartType = $5b7ccabde48fae90$var$getSeriesType(chartProxyParams.chartType);
    const crossFilteringOverrides = chartProxyParams.crossFiltering ? $5b7ccabde48fae90$var$createCrossFilterThemeOverrides(proxy, chartProxyParams, standaloneChartType) : void 0;
    const isTitleEnabled = ()=>{
        const isTitleEnabled2 = (obj)=>{
            if (!obj) return false;
            return Object.keys(obj).some((key)=>$5b7ccabde48fae90$var$get(obj[key], "title.enabled", false));
        };
        return isTitleEnabled2(gridOptionsThemeOverrides) || isTitleEnabled2(apiThemeOverrides);
    };
    const overrides = [
        stockTheme ? $5b7ccabde48fae90$var$inbuiltStockThemeOverrides(chartProxyParams, isEnterprise, isTitleEnabled()) : void 0,
        chartThemeDefaults,
        crossFilteringOverrides,
        gridOptionsThemeOverrides,
        apiThemeOverrides,
        $5b7ccabde48fae90$var$__spreadValues3({}, chartOptionsToRestore != null ? chartOptionsToRestore : {}),
        updatedOverrides
    ];
    const theme = overrides.filter((v)=>!!v).reduce((r, n)=>({
            baseTheme: r,
            overrides: n
        }), rootTheme);
    if (chartPaletteToRestore && themeName === chartThemeToRestore) {
        const rootThemePalette = (0, $iTJTu._Theme).getChartTheme(rootTheme).palette;
        if (!$5b7ccabde48fae90$var$isIdenticalPalette(chartPaletteToRestore, rootThemePalette)) theme.palette = chartPaletteToRestore;
    }
    return theme;
}
function $5b7ccabde48fae90$var$isIdenticalPalette(paletteA, paletteB) {
    const arrayCompare = (arrA, arrB)=>{
        if (arrA.length !== arrB.length) return false;
        return arrA.every((v, i)=>v === arrB[i]);
    };
    return arrayCompare(paletteA.fills, paletteB.fills) && arrayCompare(paletteA.strokes, paletteB.strokes);
}
function $5b7ccabde48fae90$var$isStockTheme(themeName) {
    return (0, $jIDNV._).includes(Object.keys((0, $iTJTu._Theme).themes), themeName);
}
function $5b7ccabde48fae90$var$createCrossFilterThemeOverrides(proxy, chartProxyParams, seriesType) {
    const legend = {
        listeners: {
            legendItemClick: (e)=>{
                const chart = proxy.getChart();
                chart.series.forEach((s)=>{
                    s.toggleSeriesItem(e.itemId, e.enabled);
                    s.toggleSeriesItem(`${e.itemId}-filtered-out`, e.enabled);
                });
            }
        }
    };
    return {
        [seriesType]: {
            tooltip: {
                delay: 500
            },
            legend: legend,
            listeners: {
                click: (e)=>chartProxyParams.crossFilterCallback(e, true)
            }
        }
    };
}
var $5b7ccabde48fae90$var$STATIC_INBUILT_STOCK_THEME_AXES_OVERRIDES = $5b7ccabde48fae90$var$ALL_AXIS_TYPES.reduce((r, n)=>$5b7ccabde48fae90$var$__spreadProps3($5b7ccabde48fae90$var$__spreadValues3({}, r), {
        [n]: {
            title: {
                _enabledFromTheme: true
            }
        }
    }), {});
function $5b7ccabde48fae90$var$inbuiltStockThemeOverrides(params, isEnterprise, titleEnabled) {
    const extraPadding = params.getExtraPaddingDirections();
    return {
        common: $5b7ccabde48fae90$var$__spreadProps3($5b7ccabde48fae90$var$__spreadValues3({}, isEnterprise ? {
            animation: {
                duration: 500
            }
        } : void 0), {
            axes: $5b7ccabde48fae90$var$STATIC_INBUILT_STOCK_THEME_AXES_OVERRIDES,
            padding: {
                // don't add extra padding when a title is present!
                top: !titleEnabled && extraPadding.includes("top") ? 40 : 20,
                right: extraPadding.includes("right") ? 30 : 20,
                bottom: extraPadding.includes("bottom") ? 40 : 20,
                left: extraPadding.includes("left") ? 30 : 20
            }
        }),
        pie: {
            series: {
                title: {
                    _enabledFromTheme: true
                },
                calloutLabel: {
                    _enabledFromTheme: true
                },
                sectorLabel: {
                    enabled: false,
                    _enabledFromTheme: true
                }
            }
        },
        donut: {
            series: {
                title: {
                    _enabledFromTheme: true
                },
                calloutLabel: {
                    _enabledFromTheme: true
                },
                sectorLabel: {
                    enabled: false,
                    _enabledFromTheme: true
                }
            }
        }
    };
}
function $5b7ccabde48fae90$var$getSelectedTheme(chartProxyParams) {
    let chartThemeName = chartProxyParams.getChartThemeName();
    const availableThemes = chartProxyParams.getChartThemes();
    if (!(0, $jIDNV._).includes(availableThemes, chartThemeName)) chartThemeName = availableThemes[0];
    return chartThemeName;
}
function $5b7ccabde48fae90$var$lookupCustomChartTheme(chartProxyParams, name) {
    const { customChartThemes: customChartThemes } = chartProxyParams;
    const customChartTheme = customChartThemes && customChartThemes[name];
    if (!customChartTheme) console.warn(`AG Grid: no stock theme exists with the name '${name}' and no custom chart theme with that name was supplied to 'customChartThemes'`);
    return customChartTheme;
}
var $5b7ccabde48fae90$var$validateIfDefined = (validationFn)=>{
    return (value)=>{
        if (value == void 0) return true;
        return validationFn(value);
    };
};
var $5b7ccabde48fae90$var$isString = (value)=>typeof value === "string";
var $5b7ccabde48fae90$var$isBoolean = (value)=>typeof value === "boolean";
var $5b7ccabde48fae90$var$isValidSeriesChartType = (value)=>typeof value === "object";
var $5b7ccabde48fae90$var$createWarnMessage = (property, expectedType)=>(value)=>`AG Grid - unable to update chart as invalid params supplied:  \`${property}: ${value}\`, expected ${expectedType}.`;
var $5b7ccabde48fae90$var$createEnterpriseMessage = (feature)=>{
    const url = "https://www.ag-grid.com/javascript-data-grid/integrated-charts-installation/";
    return `${feature} is not supported in AG Charts Community (either 'ag-grid-charts-enterprise' or '@ag-grid-enterprise/charts-enterprise' hasn't been loaded). See ${url} for more details.`;
};
var $5b7ccabde48fae90$var$_ChartParamsValidator = class _ChartParamsValidator2 {
    static isEnterprise() {
        return (0, $iTJTu._ModuleSupport).enterpriseModule.isEnterprise;
    }
    static isValidChartType(value) {
        return !!$5b7ccabde48fae90$var$getSeriesTypeIfExists(value) || $5b7ccabde48fae90$var$isComboChart(value);
    }
    static isLegacyChartType(value) {
        return _ChartParamsValidator2.legacyChartTypes.includes(value);
    }
    static validateUpdateParams(params) {
        let paramsToValidate = params;
        switch(paramsToValidate.type){
            case "rangeChartUpdate":
                return _ChartParamsValidator2.validateUpdateRangeChartParams(params);
            case "pivotChartUpdate":
                return _ChartParamsValidator2.validateUpdatePivotChartParams(params);
            case "crossFilterChartUpdate":
                return _ChartParamsValidator2.validateUpdateCrossFilterChartParams(params);
            default:
                console.warn(`AG Grid - Invalid value supplied for 'type': ${params.type}. It must be either 'rangeChartUpdate', 'pivotChartUpdate', or 'crossFilterChartUpdate'.`);
                return false;
        }
    }
    static validateCreateParams(params) {
        return _ChartParamsValidator2.validateProperties(params, [
            _ChartParamsValidator2.enterpriseChartTypeValidation,
            _ChartParamsValidator2.switchCategorySeriesValidation
        ]);
    }
    static validateUpdateRangeChartParams(params) {
        const validations = [
            ..._ChartParamsValidator2.commonUpdateValidations,
            _ChartParamsValidator2.enterpriseChartTypeValidation,
            ..._ChartParamsValidator2.cellRangeValidations,
            {
                property: "seriesChartTypes",
                validationFn: (value)=>value === void 0 || Array.isArray(value) && value.every($5b7ccabde48fae90$var$isValidSeriesChartType),
                warnMessage: $5b7ccabde48fae90$var$createWarnMessage("seriesChartTypes", "Array of SeriesChartType")
            }
        ];
        return _ChartParamsValidator2.validateProperties(params, validations, [
            ..._ChartParamsValidator2.baseUpdateChartParams,
            "cellRange",
            "suppressChartRanges",
            "switchCategorySeries",
            "aggFunc",
            "seriesChartTypes",
            "seriesGroupType"
        ], "UpdateRangeChartParams");
    }
    static validateUpdatePivotChartParams(params) {
        const validations = [
            ..._ChartParamsValidator2.commonUpdateValidations
        ];
        return _ChartParamsValidator2.validateProperties(params, validations, [
            ..._ChartParamsValidator2.baseUpdateChartParams
        ], "UpdatePivotChartParams");
    }
    static validateUpdateCrossFilterChartParams(params) {
        const validations = [
            ..._ChartParamsValidator2.commonUpdateValidations,
            ..._ChartParamsValidator2.cellRangeValidations
        ];
        return _ChartParamsValidator2.validateProperties(params, validations, [
            ..._ChartParamsValidator2.baseUpdateChartParams,
            "cellRange",
            "suppressChartRanges",
            "aggFunc"
        ], "UpdateCrossFilterChartParams");
    }
    static validateProperties(params, validations, validPropertyNames, paramsType) {
        let validatedProperties = void 0;
        for (const validation of validations){
            const { property: property, validationFn: validationFn, warnMessage: warnMessage, warnIfFixed: warnIfFixed } = validation;
            if (property in params) {
                const value = params[property];
                const validationResult = validationFn(value);
                if (validationResult === true) continue;
                if (validationResult === false) {
                    console.warn(warnMessage(value));
                    return false;
                }
                validatedProperties = validatedProperties || $5b7ccabde48fae90$var$__spreadValues3({}, params);
                validatedProperties[property] = validationResult;
                if (warnIfFixed) console.warn(warnMessage(value));
            }
        }
        if (validPropertyNames) {
            for(const property in params)if (!validPropertyNames.includes(property)) {
                console.warn(`AG Grid - Unexpected property supplied. ${paramsType} does not contain: \`${property}\`.`);
                return false;
            }
        }
        if (validatedProperties) return validatedProperties;
        return true;
    }
};
$5b7ccabde48fae90$var$_ChartParamsValidator.legacyChartTypes = [
    "doughnut"
];
$5b7ccabde48fae90$var$_ChartParamsValidator.baseUpdateChartParams = [
    "type",
    "chartId",
    "chartType",
    "chartThemeName",
    "chartThemeOverrides",
    "unlinkChart"
];
$5b7ccabde48fae90$var$_ChartParamsValidator.validateChartType = $5b7ccabde48fae90$var$validateIfDefined((chartType)=>{
    if ($5b7ccabde48fae90$var$_ChartParamsValidator.isValidChartType(chartType)) return true;
    if ($5b7ccabde48fae90$var$_ChartParamsValidator.isLegacyChartType(chartType)) {
        const renamedChartType = $5b7ccabde48fae90$var$getCanonicalChartType(chartType);
        (0, $jIDNV._).warnOnce(`The chart type '${chartType}' has been deprecated. Please use '${renamedChartType}' instead.`);
        return renamedChartType;
    }
    return false;
});
$5b7ccabde48fae90$var$_ChartParamsValidator.validateAgChartThemeOverrides = $5b7ccabde48fae90$var$validateIfDefined((themeOverrides)=>{
    return typeof themeOverrides === "object";
});
$5b7ccabde48fae90$var$_ChartParamsValidator.validateChartParamsCellRange = $5b7ccabde48fae90$var$validateIfDefined((cellRange)=>{
    return typeof cellRange === "object";
});
$5b7ccabde48fae90$var$_ChartParamsValidator.validateAggFunc = $5b7ccabde48fae90$var$validateIfDefined((aggFunc)=>{
    return typeof aggFunc === "string" || typeof aggFunc === "function";
});
$5b7ccabde48fae90$var$_ChartParamsValidator.enterpriseChartTypeValidation = {
    property: "chartType",
    validationFn: $5b7ccabde48fae90$var$validateIfDefined((chartType)=>$5b7ccabde48fae90$var$_ChartParamsValidator.isEnterprise() || !chartType || !$5b7ccabde48fae90$var$isEnterpriseChartType(chartType)),
    warnMessage: (chartType)=>$5b7ccabde48fae90$var$createEnterpriseMessage(`The '${chartType}' chart type`)
};
$5b7ccabde48fae90$var$_ChartParamsValidator.switchCategorySeriesValidation = {
    property: "switchCategorySeries",
    validationFn: $5b7ccabde48fae90$var$validateIfDefined((switchCategorySeries)=>{
        if (!switchCategorySeries || $5b7ccabde48fae90$var$_ChartParamsValidator.isEnterprise()) return true;
        return void 0;
    }),
    warnMessage: ()=>$5b7ccabde48fae90$var$createEnterpriseMessage(`'switchCategorySeries' has been ignored as it`),
    warnIfFixed: true
};
$5b7ccabde48fae90$var$_ChartParamsValidator.commonUpdateValidations = [
    {
        property: "chartId",
        validationFn: $5b7ccabde48fae90$var$isString,
        warnMessage: $5b7ccabde48fae90$var$createWarnMessage("chartId", "string")
    },
    {
        property: "chartType",
        validationFn: $5b7ccabde48fae90$var$_ChartParamsValidator.validateChartType,
        warnMessage: $5b7ccabde48fae90$var$createWarnMessage("chartType", "ChartType")
    },
    {
        property: "chartThemeName",
        validationFn: $5b7ccabde48fae90$var$isString,
        warnMessage: $5b7ccabde48fae90$var$createWarnMessage("chartThemeName", "string")
    },
    {
        property: "chartThemeOverrides",
        validationFn: $5b7ccabde48fae90$var$_ChartParamsValidator.validateAgChartThemeOverrides,
        warnMessage: $5b7ccabde48fae90$var$createWarnMessage("chartThemeOverrides", "AgChartThemeOverrides")
    },
    {
        property: "unlinkChart",
        validationFn: $5b7ccabde48fae90$var$isBoolean,
        warnMessage: $5b7ccabde48fae90$var$createWarnMessage("unlinkChart", "boolean")
    }
];
$5b7ccabde48fae90$var$_ChartParamsValidator.cellRangeValidations = [
    {
        property: "cellRange",
        validationFn: $5b7ccabde48fae90$var$_ChartParamsValidator.validateChartParamsCellRange,
        warnMessage: $5b7ccabde48fae90$var$createWarnMessage("cellRange", "ChartParamsCellRange")
    },
    {
        property: "suppressChartRanges",
        validationFn: $5b7ccabde48fae90$var$isBoolean,
        warnMessage: $5b7ccabde48fae90$var$createWarnMessage("suppressChartRanges", "boolean")
    },
    {
        property: "aggFunc",
        validationFn: $5b7ccabde48fae90$var$_ChartParamsValidator.validateAggFunc,
        warnMessage: $5b7ccabde48fae90$var$createWarnMessage("aggFunc", "string or IAggFunc")
    },
    $5b7ccabde48fae90$var$_ChartParamsValidator.switchCategorySeriesValidation
];
var $5b7ccabde48fae90$var$ChartParamsValidator = $5b7ccabde48fae90$var$_ChartParamsValidator;
var $5b7ccabde48fae90$var$DEFAULT_THEMES = [
    "ag-default",
    "ag-material",
    "ag-sheets",
    "ag-polychroma",
    "ag-vivid"
];
var $5b7ccabde48fae90$var$_ChartController = class _ChartController2 extends (0, $jIDNV.BeanStub) {
    constructor(model){
        super();
        this.model = model;
        this.isEnterprise = ()=>(0, $iTJTu._ModuleSupport).enterpriseModule.isEnterprise;
    }
    init() {
        this.setChartRange();
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_RANGE_SELECTION_CHANGED, (event)=>{
            if (event.id && event.id === this.model.chartId) this.updateForRangeChange();
        });
        if (this.model.unlinked) {
            if (this.rangeService) this.rangeService.setCellRanges([]);
        }
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_COLUMN_MOVED, this.updateForGridChange.bind(this));
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_COLUMN_PINNED, this.updateForGridChange.bind(this));
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_COLUMN_VISIBLE, this.updateForGridChange.bind(this));
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_COLUMN_ROW_GROUP_CHANGED, this.updateForGridChange.bind(this));
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_MODEL_UPDATED, this.updateForGridChange.bind(this));
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_CELL_VALUE_CHANGED, this.updateForDataChange.bind(this));
    }
    update(params) {
        if (!this.validUpdateType(params)) return false;
        const validationResult = $5b7ccabde48fae90$var$ChartParamsValidator.validateUpdateParams(params);
        if (!validationResult) return false;
        const validParams = validationResult === true ? params : validationResult;
        this.applyValidatedChartParams(validParams);
        return true;
    }
    applyValidatedChartParams(params) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i;
        const { chartId: chartId, chartType: chartType, chartThemeName: chartThemeName, unlinkChart: unlinkChart } = params;
        const common = {
            chartId: chartId,
            pivotChart: this.model.pivotChart,
            chartType: chartType != null ? chartType : this.model.chartType,
            chartThemeName: chartThemeName != null ? chartThemeName : this.model.chartThemeName,
            unlinkChart: unlinkChart != null ? unlinkChart : this.model.unlinked,
            cellRange: this.model.suppliedCellRange,
            switchCategorySeries: this.model.switchCategorySeries,
            aggFunc: this.model.aggFunc,
            seriesChartTypes: void 0,
            suppressChartRanges: false,
            crossFiltering: false
        };
        let chartModelParams = $5b7ccabde48fae90$var$__spreadValues3({}, common);
        switch(params.type){
            case "rangeChartUpdate":
                chartModelParams.cellRange = (_a = this.createCellRange(params)) != null ? _a : this.model.suppliedCellRange;
                chartModelParams.switchCategorySeries = (_b = params.switchCategorySeries) != null ? _b : this.model.switchCategorySeries;
                chartModelParams.aggFunc = (_c = params.aggFunc) != null ? _c : this.model.aggFunc;
                chartModelParams.seriesChartTypes = params.seriesChartTypes;
                chartModelParams.suppressChartRanges = (_d = params.suppressChartRanges) != null ? _d : this.model.suppressChartRanges;
                chartModelParams.seriesGroupType = (_e = params.seriesGroupType) != null ? _e : this.model.seriesGroupType;
                break;
            case "crossFilterChartUpdate":
                chartModelParams.cellRange = (_f = this.createCellRange(params)) != null ? _f : this.model.suppliedCellRange;
                chartModelParams.switchCategorySeries = false;
                chartModelParams.aggFunc = (_g = params.aggFunc) != null ? _g : this.model.aggFunc;
                chartModelParams.crossFiltering = true;
                chartModelParams.suppressChartRanges = (_h = params.suppressChartRanges) != null ? _h : this.model.suppressChartRanges;
                break;
            case "pivotChartUpdate":
                chartModelParams.switchCategorySeries = false;
                break;
        }
        this.model.updateModel(chartModelParams);
        const removeChartCellRanges = chartModelParams.unlinkChart || chartModelParams.suppressChartRanges;
        removeChartCellRanges ? (_i = this.rangeService) == null || _i.setCellRanges([]) : this.setChartRange();
    }
    updateForGridChange(params) {
        if (this.model.unlinked) return;
        const { maintainColState: maintainColState, setColsFromRange: setColsFromRange } = params != null ? params : {};
        this.model.updateCellRanges({
            maintainColState: maintainColState,
            setColsFromRange: setColsFromRange
        });
        this.model.updateData();
        this.setChartRange();
    }
    updateForDataChange() {
        if (this.model.unlinked) return;
        this.model.updateData();
        this.raiseChartModelUpdateEvent();
    }
    updateForRangeChange() {
        this.updateForGridChange({
            setColsFromRange: true
        });
        this.raiseChartRangeSelectionChangedEvent();
    }
    updateForPanelChange(params) {
        this.model.updateCellRanges(params);
        this.model.updateData();
        if (params.skipAnimation) this.getChartProxy().getChartRef().skipAnimations();
        this.setChartRange();
        this.raiseChartRangeSelectionChangedEvent();
    }
    updateThemeOverrides(updatedOverrides) {
        this.chartProxy.updateThemeOverrides(updatedOverrides);
    }
    getChartUpdateParams(updatedOverrides) {
        const selectedCols = this.getSelectedValueColState();
        const fields = selectedCols.map((c)=>({
                colId: c.colId,
                displayName: c.displayName
            }));
        const data = this.getChartData();
        const selectedDimensions = this.getSelectedDimensions();
        const params = {
            data: data,
            groupData: this.model.groupChartData,
            grouping: this.isGrouping(),
            categories: selectedDimensions.map((selectedDimension)=>{
                var _a;
                return {
                    id: selectedDimension.colId,
                    name: selectedDimension.displayName,
                    chartDataType: (_a = this.model.categoryAxisType) != null ? _a : this.model.getChartDataType(selectedDimension.colId)
                };
            }),
            fields: fields,
            chartId: this.getChartId(),
            getCrossFilteringContext: ()=>({
                    lastSelectedChartId: "xxx"
                }),
            //this.params.crossFilteringContext, //TODO
            seriesChartTypes: this.getSeriesChartTypes(),
            updatedOverrides: updatedOverrides,
            seriesGroupType: this.model.seriesGroupType
        };
        return this.isCategorySeriesSwitched() ? this.invertCategorySeriesParams(params) : params;
    }
    invertCategorySeriesParams(params) {
        const [category] = params.categories;
        const categories = [
            {
                id: $5b7ccabde48fae90$var$ChartDataModel.DEFAULT_CATEGORY,
                name: ""
            }
        ];
        const fields = params.data.map((value, index)=>{
            const categoryKey = `${category.id}:${index}`;
            const categoryValue = value[category.id];
            const seriesLabel = categoryValue == null ? "" : String(categoryValue);
            return {
                colId: categoryKey,
                displayName: seriesLabel
            };
        });
        const data = params.fields.map((field)=>{
            const row = {
                [$5b7ccabde48fae90$var$ChartDataModel.DEFAULT_CATEGORY]: field.displayName
            };
            for (const [index, value] of params.data.entries()){
                const categoryKey = `${category.id}:${index}`;
                const seriesLabelValue = value[field.colId];
                row[categoryKey] = seriesLabelValue;
            }
            return row;
        });
        return $5b7ccabde48fae90$var$__spreadProps3($5b7ccabde48fae90$var$__spreadValues3({}, params), {
            categories: categories,
            fields: fields,
            data: data
        });
    }
    getChartModel() {
        const modelType = this.model.pivotChart ? "pivot" : "range";
        const seriesChartTypes = this.isComboChart() ? this.model.comboChartModel.seriesChartTypes : void 0;
        return {
            modelType: modelType,
            chartId: this.model.chartId,
            chartType: this.model.chartType,
            chartThemeName: this.getChartThemeName(),
            chartOptions: this.chartProxy.getChartThemeOverrides(),
            chartPalette: this.chartProxy.getChartPalette(),
            cellRange: this.getCellRangeParams(),
            switchCategorySeries: this.model.switchCategorySeries,
            suppressChartRanges: this.model.suppressChartRanges,
            aggFunc: this.model.aggFunc,
            unlinkChart: this.model.unlinked,
            seriesChartTypes: seriesChartTypes,
            seriesGroupType: this.model.seriesGroupType
        };
    }
    getChartId() {
        return this.model.chartId;
    }
    getChartData() {
        return this.model.chartData;
    }
    getChartType() {
        return this.model.chartType;
    }
    setChartType(chartType) {
        this.updateMultiSeriesAndCategory(this.model.chartType, chartType);
        this.model.chartType = chartType;
        this.model.comboChartModel.updateSeriesChartTypes();
        this.model.switchCategorySeries = false;
        this.model.categoryAxisType = void 0;
        this.model.seriesGroupType = void 0;
        this.raiseChartModelUpdateEvent();
        this.raiseChartOptionsChangedEvent();
    }
    isCategorySeriesSwitched() {
        return this.model.switchCategorySeries && !this.model.isGrouping();
    }
    switchCategorySeries(inverted) {
        if (!$5b7ccabde48fae90$var$supportsInvertedCategorySeries(this.getChartType())) return;
        this.model.switchCategorySeries = inverted;
        this.raiseChartModelUpdateEvent();
    }
    getAggFunc() {
        return this.model.aggFunc;
    }
    setAggFunc(value, silent) {
        if (this.model.aggFunc === value) return;
        this.model.aggFunc = value;
        if (silent) return;
        this.model.updateData();
        this.raiseChartModelUpdateEvent();
    }
    updateMultiSeriesAndCategory(previousChartType, chartType) {
        var _a, _b;
        const updateForMax = (columns, maxNum)=>{
            let numSelected = 0;
            for (const colState of columns){
                if (!colState.selected) continue;
                if (numSelected >= maxNum) colState.selected = false;
                else numSelected++;
            }
            if (numSelected === 0) columns[0].selected = true;
        };
        const maxNumDimensions = $5b7ccabde48fae90$var$getMaxNumCategories(chartType);
        const maxNumSeries = $5b7ccabde48fae90$var$getMaxNumSeries(chartType);
        const updateDimensionColState = maxNumDimensions != null && ((_a = $5b7ccabde48fae90$var$getMaxNumCategories(previousChartType)) != null ? _a : 100) > (maxNumDimensions != null ? maxNumDimensions : 100);
        const updateValueColState = maxNumSeries != null && ((_b = $5b7ccabde48fae90$var$getMaxNumSeries(previousChartType)) != null ? _b : 100) > (maxNumSeries != null ? maxNumSeries : 100);
        if (updateDimensionColState) updateForMax(this.model.dimensionColState, maxNumDimensions);
        if (updateValueColState) updateForMax(this.model.valueColState, maxNumSeries);
        if (updateDimensionColState || updateValueColState) {
            this.model.resetCellRanges(updateDimensionColState, updateValueColState);
            this.setChartRange(true);
        }
    }
    setChartThemeName(chartThemeName, silent) {
        this.model.chartThemeName = chartThemeName;
        if (!silent) {
            this.raiseChartModelUpdateEvent();
            this.raiseChartOptionsChangedEvent();
        }
    }
    getChartThemeName() {
        return this.model.chartThemeName;
    }
    isPivotChart() {
        return this.model.pivotChart;
    }
    isPivotMode() {
        return this.model.isPivotMode();
    }
    isGrouping() {
        return this.model.isGrouping();
    }
    isCrossFilterChart() {
        return this.model.crossFiltering;
    }
    getThemeNames() {
        return this.gos.get("chartThemes") || $5b7ccabde48fae90$var$DEFAULT_THEMES;
    }
    getThemes() {
        const themeNames = this.getThemeNames();
        return themeNames.map((themeName)=>{
            const stockTheme = $5b7ccabde48fae90$var$isStockTheme(themeName);
            const theme = stockTheme ? themeName : this.chartProxy.lookupCustomChartTheme(themeName);
            return (0, $iTJTu._Theme).getChartTheme(theme);
        });
    }
    getPalettes() {
        const themes = this.getThemes();
        return themes.map((theme)=>{
            return theme.palette;
        });
    }
    getThemeTemplateParameters() {
        const themes = this.getThemes();
        return themes.map((theme)=>{
            return theme.getTemplateParameters();
        });
    }
    getValueColState() {
        return this.model.valueColState.map(this.displayNameMapper.bind(this));
    }
    getSelectedValueColState() {
        return this.getValueColState().filter((cs)=>cs.selected);
    }
    getSelectedDimensions() {
        return this.model.getSelectedDimensions();
    }
    displayNameMapper(col) {
        const columnNames = this.model.columnNames[col.colId];
        col.displayName = columnNames ? columnNames.join(" - ") : this.model.getColDisplayName(col.column);
        return col;
    }
    getColStateForMenu() {
        return {
            dimensionCols: this.model.dimensionColState,
            valueCols: this.getValueColState()
        };
    }
    setChartRange(silent = false) {
        if (this.rangeService && !this.model.suppressChartRanges && !this.model.unlinked) this.rangeService.setCellRanges(this.getCellRanges());
        if (!silent) this.raiseChartModelUpdateEvent();
    }
    detachChartRange() {
        this.model.unlinked = !this.model.unlinked;
        if (this.model.unlinked) {
            if (this.rangeService) this.rangeService.setCellRanges([]);
        } else this.updateForGridChange();
        this.dispatchEvent({
            type: _ChartController2.EVENT_CHART_LINKED_CHANGED
        });
    }
    setChartProxy(chartProxy) {
        this.chartProxy = chartProxy;
    }
    getChartProxy() {
        return this.chartProxy;
    }
    isActiveXYChart() {
        return (0, $jIDNV._).includes([
            "scatter",
            "bubble"
        ], this.getChartType());
    }
    isChartLinked() {
        return !this.model.unlinked;
    }
    customComboExists() {
        const savedCustomSeriesChartTypes = this.model.comboChartModel.savedCustomSeriesChartTypes;
        return savedCustomSeriesChartTypes && savedCustomSeriesChartTypes.length > 0;
    }
    getSeriesChartTypes() {
        return this.model.comboChartModel.seriesChartTypes;
    }
    isComboChart(chartType) {
        return this.model.isComboChart(chartType);
    }
    updateSeriesChartType(colId, chartType, secondaryAxis) {
        const seriesChartType = this.model.comboChartModel.seriesChartTypes.find((s)=>s.colId === colId);
        if (seriesChartType) {
            const updateChartType = this.model.chartType !== "customCombo";
            if (updateChartType) this.model.chartType = "customCombo";
            const prevSeriesChartType = seriesChartType.chartType;
            if (chartType != null) seriesChartType.chartType = chartType;
            if (secondaryAxis != null) seriesChartType.secondaryAxis = secondaryAxis;
            this.model.comboChartModel.savedCustomSeriesChartTypes = this.model.comboChartModel.seriesChartTypes;
            this.model.comboChartModel.updateSeriesChartTypes();
            this.updateForDataChange();
            if (updateChartType) this.dispatchEvent({
                type: _ChartController2.EVENT_CHART_TYPE_CHANGED
            });
            if (prevSeriesChartType !== chartType) this.dispatchEvent({
                type: _ChartController2.EVENT_CHART_SERIES_CHART_TYPE_CHANGED
            });
            this.raiseChartOptionsChangedEvent();
        }
    }
    getActiveSeriesChartTypes() {
        const selectedColIds = this.getSelectedValueColState().map((c)=>c.colId);
        return this.getSeriesChartTypes().filter((s)=>selectedColIds.includes(s.colId));
    }
    getChartSeriesTypes(chartType) {
        const targetChartType = chartType != null ? chartType : this.getChartType();
        return this.isComboChart(targetChartType) ? [
            "line",
            "bar",
            "area"
        ] : [
            $5b7ccabde48fae90$var$getSeriesType(targetChartType)
        ];
    }
    getChartSeriesType() {
        const seriesChartTypes = this.getSeriesChartTypes();
        if (seriesChartTypes.length === 0) return "bar";
        const ct = seriesChartTypes[0].chartType;
        if (ct === "columnLineCombo") return "bar";
        if (ct === "areaColumnCombo") return "area";
        return $5b7ccabde48fae90$var$getSeriesType(ct);
    }
    getCellRanges() {
        return [
            this.model.dimensionCellRange,
            this.model.valueCellRange
        ].filter((r)=>r);
    }
    createCellRange(params) {
        var _a;
        return params.cellRange && ((_a = this.rangeService) == null ? void 0 : _a.createPartialCellRangeFromRangeParams(params.cellRange, true));
    }
    validUpdateType(params) {
        var _a;
        if (!params.type) {
            console.warn(`AG Grid - Unable to update chart as the 'type' is missing. It must be either 'rangeChartUpdate', 'pivotChartUpdate', or 'crossFilterChartUpdate'.`);
            return false;
        }
        const chartTypeMap = {
            "Range Chart": ()=>!this.isPivotChart() && !this.isCrossFilterChart(),
            "Pivot Chart": ()=>this.isPivotChart(),
            "Cross Filter Chart": ()=>this.isCrossFilterChart()
        };
        const currentChartType = (_a = Object.keys(chartTypeMap).find((type)=>chartTypeMap[type]())) != null ? _a : "Range Chart";
        const valid = params.type === `${currentChartType[0].toLowerCase()}${currentChartType.slice(1).replace(/ /g, "")}Update`;
        if (!valid) console.warn(`AG Grid - Unable to update chart as a '${params.type}' update type is not permitted on a ${currentChartType}.`);
        return valid;
    }
    getCellRangeParams() {
        const cellRanges = this.getCellRanges();
        const firstCellRange = cellRanges[0];
        const startRow = firstCellRange && firstCellRange.startRow || null;
        const endRow = firstCellRange && firstCellRange.endRow || null;
        return {
            rowStartIndex: startRow && startRow.rowIndex,
            rowStartPinned: startRow && startRow.rowPinned,
            rowEndIndex: endRow && endRow.rowIndex,
            rowEndPinned: endRow && endRow.rowPinned,
            columns: cellRanges.reduce((columns, value)=>columns.concat(value.columns.map((c)=>c.getId())), [])
        };
    }
    setCategoryAxisType(categoryAxisType) {
        this.model.categoryAxisType = categoryAxisType;
        this.raiseChartModelUpdateEvent();
    }
    getSeriesGroupType() {
        var _a;
        return (_a = this.model.seriesGroupType) != null ? _a : this.chartProxy.getSeriesGroupType();
    }
    setSeriesGroupType(seriesGroupType) {
        this.model.seriesGroupType = seriesGroupType;
        this.raiseChartModelUpdateEvent();
    }
    raiseChartModelUpdateEvent() {
        const event = {
            type: _ChartController2.EVENT_CHART_MODEL_UPDATE
        };
        this.dispatchEvent(event);
    }
    raiseChartUpdatedEvent() {
        const event = {
            type: _ChartController2.EVENT_CHART_UPDATED
        };
        this.dispatchEvent(event);
    }
    raiseChartApiUpdateEvent() {
        const event = {
            type: _ChartController2.EVENT_CHART_API_UPDATE
        };
        this.dispatchEvent(event);
    }
    raiseChartOptionsChangedEvent() {
        const { chartId: chartId, chartType: chartType } = this.getChartModel();
        const event = {
            type: (0, $jIDNV.Events).EVENT_CHART_OPTIONS_CHANGED,
            chartId: chartId,
            chartType: chartType,
            chartThemeName: this.getChartThemeName(),
            chartOptions: this.chartProxy.getChartThemeOverrides()
        };
        this.eventService.dispatchEvent(event);
    }
    raiseChartRangeSelectionChangedEvent() {
        const event = {
            type: (0, $jIDNV.Events).EVENT_CHART_RANGE_SELECTION_CHANGED,
            id: this.model.chartId,
            chartId: this.model.chartId,
            cellRange: this.getCellRangeParams()
        };
        this.eventService.dispatchEvent(event);
    }
    destroy() {
        super.destroy();
        if (this.rangeService) this.rangeService.setCellRanges([]);
    }
};
$5b7ccabde48fae90$var$_ChartController.EVENT_CHART_UPDATED = "chartUpdated";
$5b7ccabde48fae90$var$_ChartController.EVENT_CHART_API_UPDATE = "chartApiUpdate";
$5b7ccabde48fae90$var$_ChartController.EVENT_CHART_MODEL_UPDATE = "chartModelUpdate";
$5b7ccabde48fae90$var$_ChartController.EVENT_CHART_TYPE_CHANGED = "chartTypeChanged";
$5b7ccabde48fae90$var$_ChartController.EVENT_CHART_SERIES_CHART_TYPE_CHANGED = "chartSeriesChartTypeChanged";
$5b7ccabde48fae90$var$_ChartController.EVENT_CHART_LINKED_CHANGED = "chartLinkedChanged";
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("rangeService")
], $5b7ccabde48fae90$var$_ChartController.prototype, "rangeService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_ChartController.prototype, "init", 1);
var $5b7ccabde48fae90$var$ChartController = $5b7ccabde48fae90$var$_ChartController;
var $5b7ccabde48fae90$var$_AgPillSelect = class _AgPillSelect2 extends (0, $jIDNV.Component) {
    constructor(config){
        super(_AgPillSelect2.TEMPLATE);
        this.config = config != null ? config : {};
        const { selectedValueList: selectedValueList, valueFormatter: valueFormatter, valueList: valueList } = this.config;
        this.selectedValues = selectedValueList != null ? selectedValueList : [];
        this.valueList = valueList != null ? valueList : [];
        this.valueFormatter = valueFormatter != null ? valueFormatter : (value)=>(0, $jIDNV._).escapeString(value);
    }
    init() {
        const { ariaLabel: ariaLabel, onValuesChange: onValuesChange, dragSourceId: dragSourceId } = this.config;
        this.dropZonePanel = this.createManagedBean(new $5b7ccabde48fae90$var$PillSelectDropZonePanel({
            getValues: ()=>this.selectedValues,
            setValues: (values)=>this.updateValues(values),
            isDraggable: ()=>this.selectedValues.length > 1
        }, (value)=>this.valueFormatter(value), ariaLabel, dragSourceId));
        const eGui = this.getGui();
        eGui.appendChild(this.dropZonePanel.getGui());
        this.initSelect();
        if (onValuesChange != null) this.onValuesChange = onValuesChange;
    }
    setValues(valueList, selectedValues) {
        const { added: added, removed: removed, updated: updated } = this.getChanges(this.valueList, valueList);
        let refreshSelect = false;
        if (added.length || removed.length || updated.length) refreshSelect = true;
        this.valueList = valueList;
        this.updateValues(selectedValues, refreshSelect, true);
        return this;
    }
    setValueFormatter(valueFormatter) {
        this.valueFormatter = valueFormatter;
        return this;
    }
    initSelect() {
        const options = this.createSelectOptions();
        if (!options.length) return false;
        const { selectPlaceholder: placeholder } = this.config;
        this.eSelect = this.createBean(new (0, $jIDNV.AgSelect)({
            options: options,
            placeholder: placeholder,
            onValueChange: (value)=>this.addValue(value),
            pickerIcon: "chartsMenuAdd"
        }));
        this.getGui().appendChild(this.eSelect.getGui());
        return true;
    }
    createSelectOptions() {
        let options = [];
        const { maxSelection: maxSelection } = this.config;
        if (maxSelection && this.selectedValues.length >= maxSelection) return options;
        this.valueList.forEach((value)=>{
            if (!this.selectedValues.includes(value)) options.push({
                value: value,
                text: this.valueFormatter(value)
            });
        });
        return options;
    }
    addValue(value) {
        this.dropZonePanel.addItem(value);
    }
    updateValues(values, forceRefreshSelect, silent) {
        var _a, _b, _c, _d, _e;
        const previousSelectedValues = this.selectedValues;
        this.selectedValues = values;
        const changes = this.getChanges(previousSelectedValues, values);
        const refreshSelect = forceRefreshSelect || changes.added.length || changes.removed.length;
        const activeElement = this.gos.getActiveDomElement();
        const selectHasFocus = (_a = this.eSelect) == null ? void 0 : _a.getGui().contains(activeElement);
        const dropZoneHasFocus = (_b = this.dropZonePanel) == null ? void 0 : _b.getGui().contains(activeElement);
        if (!silent) (_c = this.onValuesChange) == null || _c.call(this, changes);
        const emptyRefreshedSelect = refreshSelect ? !this.refreshSelect() : false;
        this.dropZonePanel.refreshGui();
        if (refreshSelect && selectHasFocus) {
            if (emptyRefreshedSelect) this.dropZonePanel.focusList(true);
            else (_d = this.eSelect) == null || _d.getFocusableElement().focus();
        }
        if (dropZoneHasFocus && !values.length) (_e = this.eSelect) == null || _e.getFocusableElement().focus();
    }
    getChanges(previousSelectedValues, newSelectedValues) {
        const added = newSelectedValues.filter((value)=>!previousSelectedValues.includes(value));
        const removed = previousSelectedValues.filter((value)=>!newSelectedValues.includes(value));
        const updated = newSelectedValues.filter((value, index)=>previousSelectedValues[index] !== value);
        return {
            added: added,
            removed: removed,
            updated: updated,
            selected: newSelectedValues
        };
    }
    refreshSelect() {
        if (!this.eSelect) return this.initSelect();
        const options = this.createSelectOptions();
        if (!options.length) {
            (0, $jIDNV._).removeFromParent(this.eSelect.getGui());
            this.eSelect = this.destroyBean(this.eSelect);
            return false;
        }
        this.eSelect.clearOptions().addOptions(options).setValue(void 0, true);
        return true;
    }
    destroy() {
        this.destroyBean(this.eSelect);
        super.destroy();
    }
};
$5b7ccabde48fae90$var$_AgPillSelect.TEMPLATE = /* html */ `<div class="ag-pill-select" role="presentation"></div>`;
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_AgPillSelect.prototype, "init", 1);
var $5b7ccabde48fae90$var$AgPillSelect = $5b7ccabde48fae90$var$_AgPillSelect;
var $5b7ccabde48fae90$var$PillSelectDragComp = class extends (0, $jIDNV.PillDragComp) {
    constructor(value, dragSourceDropTarget, ghost, valueFormatter, draggable, sourceId){
        super(dragSourceDropTarget, ghost, false);
        this.value = value;
        this.valueFormatter = valueFormatter;
        this.draggable = draggable;
        this.sourceId = sourceId;
    }
    getItem() {
        return this.value;
    }
    getDisplayName() {
        return this.valueFormatter(this.value);
    }
    getAriaDisplayName() {
        return this.getDisplayName();
    }
    getTooltip() {
        return void 0;
    }
    createGetDragItem() {
        return ()=>({
                value: this.value
            });
    }
    getDragSourceType() {
        return (0, $jIDNV.DragSourceType).ChartPanel;
    }
    getDragSourceId() {
        return this.sourceId;
    }
    isDraggable() {
        return this.draggable;
    }
};
var $5b7ccabde48fae90$var$PillSelectDropZonePanel = class extends (0, $jIDNV.PillDropZonePanel) {
    constructor(model, valueFormatter, ariaLabel, sourceId){
        super(false);
        this.model = model;
        this.valueFormatter = valueFormatter;
        this.ariaLabel = ariaLabel;
        this.sourceId = sourceId;
    }
    postConstruct() {
        super.init();
    }
    isItemDroppable(item, draggingEvent) {
        return this.isSourceEventFromTarget(draggingEvent) || this.sourceId != null && this.sourceId === draggingEvent.dragSource.sourceId;
    }
    updateItems(items) {
        this.model.setValues(items);
    }
    getExistingItems() {
        return this.model.getValues();
    }
    getIconName() {
        return this.isPotentialDndItems() ? (0, $jIDNV.DragAndDropService).ICON_MOVE : (0, $jIDNV.DragAndDropService).ICON_NOT_ALLOWED;
    }
    getAriaLabel() {
        return this.ariaLabel;
    }
    createPillComponent(item, dropTarget, ghost) {
        return new $5b7ccabde48fae90$var$PillSelectDragComp(item, dropTarget, ghost, this.valueFormatter, this.model.isDraggable(), this.sourceId);
    }
    getItems(dragItem) {
        return [
            dragItem.value
        ];
    }
    isInterestedIn(type) {
        return type === (0, $jIDNV.DragSourceType).ChartPanel;
    }
};
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$PillSelectDropZonePanel.prototype, "postConstruct", 1);
var $5b7ccabde48fae90$var$DragDataPanel = class extends (0, $jIDNV.Component) {
    constructor(chartController, autoScrollService, allowMultipleSelection, maxSelection, template){
        super(template);
        this.chartController = chartController;
        this.autoScrollService = autoScrollService;
        this.allowMultipleSelection = allowMultipleSelection;
        this.maxSelection = maxSelection;
        this.columnComps = /* @__PURE__ */ new Map();
    }
    refreshColumnComps(cols) {
        if (!(0, $jIDNV._).areEqual((0, $jIDNV._).keys(this.columnComps), cols.map(({ colId: colId })=>colId))) return false;
        cols.forEach((col)=>{
            this.columnComps.get(col.colId).setValue(col.selected, true);
        });
        return true;
    }
    createGroup(columns, valueFormatter, selectLabelKey, dragSourceId, skipAnimation) {
        if (this.allowMultipleSelection) {
            const selectedValueList = columns.filter((col)=>col.selected);
            this.valuePillSelect = this.groupComp.createManagedBean(new $5b7ccabde48fae90$var$AgPillSelect({
                valueList: columns,
                selectedValueList: selectedValueList,
                valueFormatter: valueFormatter,
                selectPlaceholder: this.chartTranslationService.translate(selectLabelKey),
                dragSourceId: dragSourceId,
                onValuesChange: (params)=>this.onValueChange(params),
                maxSelection: this.maxSelection
            }));
            this.groupComp.addItem(this.valuePillSelect);
        } else {
            const params = this.createValueSelectParams(columns);
            params.onValueChange = (updatedColState)=>{
                columns.forEach((col)=>{
                    col.selected = false;
                });
                updatedColState.selected = true;
                if (updatedColState.colId === $5b7ccabde48fae90$var$ChartDataModel.DEFAULT_CATEGORY) this.chartController.setAggFunc(void 0, true);
                this.chartController.updateForPanelChange({
                    updatedColState: updatedColState,
                    skipAnimation: skipAnimation == null ? void 0 : skipAnimation()
                });
            };
            this.valueSelect = this.groupComp.createManagedBean(new (0, $jIDNV.AgSelect)(params));
            this.groupComp.addItem(this.valueSelect);
        }
    }
    refreshValueSelect(columns) {
        if (!this.valueSelect) return;
        const { options: options, value: value } = this.createValueSelectParams(columns);
        this.valueSelect.clearOptions().addOptions(options).setValue(value, true);
    }
    createValueSelectParams(columns) {
        let selectedValue;
        const options = columns.map((value)=>{
            var _a;
            const text = (_a = value.displayName) != null ? _a : "";
            if (value.selected) selectedValue = value;
            return {
                value: value,
                text: text
            };
        });
        return {
            options: options,
            value: selectedValue
        };
    }
    onDragging(draggingEvent) {
        const itemHovered = this.checkHoveredItem(draggingEvent);
        if (!itemHovered) return;
        this.lastDraggedColumn = draggingEvent.dragItem.columns[0];
        const { comp: comp, position: position } = itemHovered;
        const { comp: lastHoveredComp, position: lastHoveredPosition } = this.lastHoveredItem || {};
        if (comp === lastHoveredComp && position === lastHoveredPosition) return;
        this.autoScrollService.check(draggingEvent.event);
        this.clearHoveredItems();
        this.lastHoveredItem = {
            comp: comp,
            position: position
        };
        const eGui = comp.getGui();
        eGui.classList.add("ag-list-item-hovered", `ag-item-highlight-${position}`);
    }
    checkHoveredItem(draggingEvent) {
        if ((0, $jIDNV._).missing(draggingEvent.vDirection)) return null;
        const mouseEvent = draggingEvent.event;
        for (const comp of this.columnComps.values()){
            const eGui = comp.getGui();
            if (!eGui.querySelector(".ag-chart-data-column-drag-handle")) continue;
            const rect = eGui.getBoundingClientRect();
            const isOverComp = mouseEvent.clientY >= rect.top && mouseEvent.clientY <= rect.bottom;
            if (isOverComp) {
                const height = eGui.clientHeight;
                const position = mouseEvent.clientY > rect.top + height / 2 ? "bottom" : "top";
                return {
                    comp: comp,
                    position: position
                };
            }
        }
        return null;
    }
    onDragLeave() {
        this.clearHoveredItems();
    }
    onDragStop() {
        if (this.lastHoveredItem) {
            const { dimensionCols: dimensionCols, valueCols: valueCols } = this.chartController.getColStateForMenu();
            const draggedColumnState = [
                ...dimensionCols,
                ...valueCols
            ].find((state)=>state.column === this.lastDraggedColumn);
            if (draggedColumnState) {
                let targetIndex = Array.from(this.columnComps.values()).indexOf(this.lastHoveredItem.comp);
                if (this.lastHoveredItem.position === "bottom") targetIndex++;
                draggedColumnState.order = targetIndex;
                this.chartController.updateForPanelChange({
                    updatedColState: draggedColumnState
                });
            }
        }
        this.clearHoveredItems();
        this.lastDraggedColumn = void 0;
        this.autoScrollService.ensureCleared();
    }
    clearHoveredItems() {
        this.columnComps.forEach((columnComp)=>{
            columnComp.getGui().classList.remove("ag-list-item-hovered", "ag-item-highlight-top", "ag-item-highlight-bottom");
        });
        this.lastHoveredItem = void 0;
    }
    addDragHandle(comp, col) {
        const eDragHandle = (0, $jIDNV._).createIconNoSpan("columnDrag", this.gos);
        eDragHandle.classList.add("ag-drag-handle", "ag-chart-data-column-drag-handle");
        comp.getGui().insertAdjacentElement("beforeend", eDragHandle);
        const dragSource = {
            type: (0, $jIDNV.DragSourceType).ChartPanel,
            eElement: eDragHandle,
            dragItemName: col.displayName,
            getDragItem: ()=>({
                    columns: [
                        col.column
                    ]
                }),
            onDragStopped: ()=>this.onDragStop()
        };
        this.dragAndDropService.addDragSource(dragSource, true);
        this.addDestroyFunc(()=>this.dragAndDropService.removeDragSource(dragSource));
    }
    addChangeListener(component, updatedColState) {
        this.addManagedListener(component, (0, $jIDNV.Events).EVENT_FIELD_VALUE_CHANGED, ()=>{
            updatedColState.selected = component.getValue();
            this.chartController.updateForPanelChange({
                updatedColState: updatedColState
            });
        });
    }
    isInterestedIn(type) {
        return type === (0, $jIDNV.DragSourceType).ChartPanel;
    }
    onValueChange({ added: added, updated: updated, removed: removed, selected: selected }) {
        let updatedColState;
        let resetOrder;
        const updateOrder = ()=>{
            selected.forEach((col, index)=>{
                col.order = index;
            });
            resetOrder = true;
        };
        if (added.length) {
            updatedColState = added[0];
            updatedColState.selected = true;
            updateOrder();
        } else if (removed.length) {
            updatedColState = removed[0];
            updatedColState.selected = false;
        } else if (updated.length) {
            updateOrder();
            updatedColState = updated[0];
        }
        if (updatedColState) this.chartController.updateForPanelChange({
            updatedColState: updatedColState,
            resetOrder: resetOrder
        });
    }
    destroy() {
        this.valuePillSelect = void 0;
        this.valueSelect = void 0;
        super.destroy();
    }
};
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("dragAndDropService")
], $5b7ccabde48fae90$var$DragDataPanel.prototype, "dragAndDropService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartTranslationService")
], $5b7ccabde48fae90$var$DragDataPanel.prototype, "chartTranslationService", 2);
var $5b7ccabde48fae90$var$DEFAULT_AGG_FUNC = "sum";
var $5b7ccabde48fae90$var$_CategoriesDataPanel = class _CategoriesDataPanel2 extends $5b7ccabde48fae90$var$DragDataPanel {
    constructor(chartController, autoScrollService, title, allowMultipleSelection, dimensionCols, isOpen){
        const maxSelection = void 0;
        super(chartController, autoScrollService, allowMultipleSelection, maxSelection, _CategoriesDataPanel2.TEMPLATE);
        this.title = title;
        this.dimensionCols = dimensionCols;
        this.isOpen = isOpen;
    }
    init() {
        this.groupComp = this.createBean(new (0, $jIDNV.AgGroupComponent)({
            title: this.title,
            enabled: true,
            suppressEnabledCheckbox: true,
            suppressOpenCloseIcons: false,
            cssIdentifier: "charts-data",
            expanded: this.isOpen
        }));
        if (this.chartMenuService.isLegacyFormat()) {
            this.createLegacyCategoriesGroup(this.dimensionCols);
            this.clearAggFuncControls();
        } else {
            this.createCategoriesGroup(this.dimensionCols);
            this.createAggFuncControls(this.dimensionCols);
        }
        this.getGui().appendChild(this.groupComp.getGui());
    }
    refresh(dimensionCols) {
        var _a;
        if (this.chartMenuService.isLegacyFormat()) {
            if (!this.refreshColumnComps(dimensionCols)) this.recreate(dimensionCols);
        } else {
            (_a = this.valuePillSelect) == null || _a.setValues(dimensionCols, dimensionCols.filter((col)=>col.selected));
            this.refreshValueSelect(dimensionCols);
            this.refreshAggFuncControls(dimensionCols, this.chartController.getAggFunc());
        }
    }
    recreate(dimensionCols) {
        this.isOpen = this.groupComp.isExpanded();
        (0, $jIDNV._).clearElement(this.getGui());
        this.destroyBean(this.groupComp);
        this.dimensionCols = dimensionCols;
        this.init();
    }
    createCategoriesGroup(columns) {
        this.createGroup(columns, (col)=>{
            var _a;
            return (_a = col.displayName) != null ? _a : "";
        }, "categoryAdd", "categorySelect", ()=>!this.chartController.getAggFunc());
    }
    createLegacyCategoriesGroup(columns) {
        const inputName = `chartDimension${this.groupComp.getCompId()}`;
        const supportsMultipleCategoryColumns = this.allowMultipleSelection;
        columns.forEach((col)=>{
            var _a;
            const params = {
                label: (_a = col.displayName) != null ? _a : "",
                value: col.selected,
                inputName: inputName
            };
            const comp = this.groupComp.createManagedBean(supportsMultipleCategoryColumns ? (()=>{
                const checkboxComp = new (0, $jIDNV.AgCheckbox)(params);
                checkboxComp.addCssClass("ag-data-select-checkbox");
                return checkboxComp;
            })() : new (0, $jIDNV.AgRadioButton)(params));
            this.addChangeListener(comp, col);
            this.groupComp.addItem(comp);
            this.columnComps.set(col.colId, comp);
            if (supportsMultipleCategoryColumns) this.addDragHandle(comp, col);
        });
        if (supportsMultipleCategoryColumns) {
            const categoriesGroupGui = this.groupComp.getGui();
            const dropTarget = {
                getIconName: ()=>(0, $jIDNV.DragAndDropService).ICON_MOVE,
                getContainer: ()=>categoriesGroupGui,
                onDragging: (params)=>this.onDragging(params),
                onDragLeave: ()=>this.onDragLeave(),
                isInterestedIn: this.isInterestedIn.bind(this),
                targetContainsSource: true
            };
            this.dragAndDropService.addDropTarget(dropTarget);
            this.addDestroyFunc(()=>this.dragAndDropService.removeDropTarget(dropTarget));
        }
    }
    createAggFuncControls(dimensionCols) {
        const aggFunc = this.chartController.getAggFunc();
        this.groupComp.addItem(this.aggFuncToggle = this.createBean(new (0, $jIDNV.AgToggleButton)({
            label: this.chartTranslationService.translate("aggregate"),
            labelAlignment: "left",
            labelWidth: "flex",
            inputWidth: "flex",
            value: aggFunc != void 0,
            onValueChange: (value)=>{
                var _a, _b;
                const aggFunc2 = value ? $5b7ccabde48fae90$var$DEFAULT_AGG_FUNC : void 0;
                this.chartController.setAggFunc(aggFunc2);
                (_a = this.aggFuncSelect) == null || _a.setValue(aggFunc2, true);
                (_b = this.aggFuncSelect) == null || _b.setDisplayed(aggFunc2 != void 0);
            }
        })));
        this.groupComp.addItem(this.aggFuncSelect = this.createBean(new (0, $jIDNV.AgSelect)({
            options: [
                {
                    value: "sum",
                    text: this.chartTranslationService.translate("sum")
                },
                {
                    value: "first",
                    text: this.chartTranslationService.translate("first")
                },
                {
                    value: "last",
                    text: this.chartTranslationService.translate("last")
                },
                {
                    value: "min",
                    text: this.chartTranslationService.translate("min")
                },
                {
                    value: "max",
                    text: this.chartTranslationService.translate("max")
                },
                {
                    value: "count",
                    text: this.chartTranslationService.translate("count")
                },
                {
                    value: "avg",
                    text: this.chartTranslationService.translate("avg")
                }
            ],
            value: typeof aggFunc === "string" ? aggFunc : void 0,
            onValueChange: (value)=>{
                this.chartController.setAggFunc(value);
            }
        })));
        this.refreshAggFuncControls(dimensionCols, aggFunc);
    }
    refreshAggFuncControls(dimensionCols, aggFunc) {
        var _a, _b, _c, _d;
        const selectedDimensions = dimensionCols.filter((col)=>col.selected);
        const supportsAggregation = selectedDimensions.some((col)=>col.colId !== $5b7ccabde48fae90$var$ChartDataModel.DEFAULT_CATEGORY);
        (_a = this.aggFuncToggle) == null || _a.setValue(aggFunc != void 0);
        (_b = this.aggFuncSelect) == null || _b.setValue(typeof aggFunc === "string" ? aggFunc : void 0, true);
        (_c = this.aggFuncToggle) == null || _c.setDisplayed(supportsAggregation);
        (_d = this.aggFuncSelect) == null || _d.setDisplayed(supportsAggregation && aggFunc != void 0);
    }
    clearAggFuncControls() {
        this.aggFuncToggle = this.aggFuncToggle && this.destroyBean(this.aggFuncToggle);
        this.aggFuncSelect = this.aggFuncSelect && this.destroyBean(this.aggFuncSelect);
    }
    destroy() {
        this.clearAggFuncControls();
        this.groupComp = this.destroyBean(this.groupComp);
        super.destroy();
    }
};
$5b7ccabde48fae90$var$_CategoriesDataPanel.TEMPLATE = /* html */ `<div id="categoriesGroup"></div>`;
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartMenuService")
], $5b7ccabde48fae90$var$_CategoriesDataPanel.prototype, "chartMenuService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_CategoriesDataPanel.prototype, "init", 1);
var $5b7ccabde48fae90$var$CategoriesDataPanel = $5b7ccabde48fae90$var$_CategoriesDataPanel;
var $5b7ccabde48fae90$var$_SeriesDataPanel = class _SeriesDataPanel2 extends $5b7ccabde48fae90$var$DragDataPanel {
    constructor(chartController, autoScrollService, chartOptionsService, title, allowMultipleSelect, maxSelection, valueCols, isOpen){
        super(chartController, autoScrollService, allowMultipleSelect, maxSelection, _SeriesDataPanel2.TEMPLATE);
        this.chartOptionsService = chartOptionsService;
        this.title = title;
        this.valueCols = valueCols;
        this.isOpen = isOpen;
    }
    init() {
        this.groupComp = this.createBean(new (0, $jIDNV.AgGroupComponent)({
            title: this.title,
            enabled: true,
            suppressEnabledCheckbox: true,
            suppressOpenCloseIcons: false,
            cssIdentifier: "charts-data",
            expanded: this.isOpen
        }));
        if (this.chartController.isActiveXYChart()) {
            const pairedModeToggle = this.groupComp.createManagedBean(new (0, $jIDNV.AgToggleButton)({
                label: this.chartTranslationService.translate("paired"),
                labelAlignment: "left",
                labelWidth: "flex",
                inputWidth: "flex",
                value: this.chartOptionsService.getPairedMode(),
                onValueChange: (newValue)=>{
                    this.chartOptionsService.setPairedMode(!!newValue);
                    this.chartController.updateForGridChange({
                        maintainColState: true
                    });
                }
            }));
            this.groupComp.addItem(pairedModeToggle);
        }
        if (this.chartMenuService.isLegacyFormat()) this.createLegacySeriesGroup(this.valueCols);
        else this.createSeriesGroup(this.valueCols);
        this.getGui().appendChild(this.groupComp.getGui());
    }
    refresh(valueCols) {
        var _a, _b;
        if (this.chartMenuService.isLegacyFormat()) {
            const canRefresh = this.refreshColumnComps(valueCols);
            if (canRefresh) {
                if (this.chartController.isActiveXYChart()) {
                    const getSeriesLabel = this.generateGetSeriesLabel(valueCols);
                    valueCols.forEach((col)=>{
                        this.columnComps.get(col.colId).setLabel(getSeriesLabel(col));
                    });
                }
            } else this.recreate(valueCols);
        } else {
            (_a = this.valuePillSelect) == null || _a.setValueFormatter(this.generateGetSeriesLabel(valueCols));
            (_b = this.valuePillSelect) == null || _b.setValues(valueCols, valueCols.filter((col)=>col.selected));
            this.refreshValueSelect(valueCols);
        }
    }
    recreate(valueCols) {
        this.isOpen = this.groupComp.isExpanded();
        (0, $jIDNV._).clearElement(this.getGui());
        this.destroyBean(this.groupComp);
        this.valueCols = valueCols;
        this.init();
    }
    createSeriesGroup(columns) {
        this.createGroup(columns, this.generateGetSeriesLabel(columns), "seriesAdd", "seriesSelect");
    }
    createLegacySeriesGroup(columns) {
        const getSeriesLabel = this.generateGetSeriesLabel(columns);
        columns.forEach((col)=>{
            const label = getSeriesLabel(col);
            const comp = this.groupComp.createManagedBean(new (0, $jIDNV.AgCheckbox)({
                label: label,
                value: col.selected
            }));
            comp.addCssClass("ag-data-select-checkbox");
            this.addChangeListener(comp, col);
            this.groupComp.addItem(comp);
            this.columnComps.set(col.colId, comp);
            this.addDragHandle(comp, col);
        });
        const seriesGroupGui = this.groupComp.getGui();
        const dropTarget = {
            getIconName: ()=>(0, $jIDNV.DragAndDropService).ICON_MOVE,
            getContainer: ()=>seriesGroupGui,
            onDragging: (params)=>this.onDragging(params),
            onDragLeave: ()=>this.onDragLeave(),
            isInterestedIn: this.isInterestedIn.bind(this),
            targetContainsSource: true
        };
        this.dragAndDropService.addDropTarget(dropTarget);
        this.addDestroyFunc(()=>this.dragAndDropService.removeDropTarget(dropTarget));
    }
    generateGetSeriesLabel(valueCols) {
        if (!this.chartController.isActiveXYChart()) return (col)=>{
            var _a;
            return (_a = col.displayName) != null ? _a : "";
        };
        const selectedCols = valueCols.filter((col)=>col.selected);
        const isBubble = this.chartController.getChartType() === "bubble";
        const isInPairedMode = this.chartOptionsService.getPairedMode();
        const indexToAxisLabel = /* @__PURE__ */ new Map();
        indexToAxisLabel.set(0, "X");
        indexToAxisLabel.set(1, "Y");
        indexToAxisLabel.set(2, "size");
        return (col)=>{
            var _a;
            const escapedLabel = (_a = col.displayName) != null ? _a : "";
            if (!col.selected) return escapedLabel;
            const index = selectedCols.indexOf(col);
            if (index === -1) return escapedLabel;
            let axisLabel;
            if (isInPairedMode) axisLabel = indexToAxisLabel.get(index % (isBubble ? 3 : 2));
            else if (index === 0) axisLabel = "X";
            else axisLabel = isBubble && index % 2 === 0 ? "size" : "Y";
            return `${escapedLabel} (${axisLabel})`;
        };
    }
    destroy() {
        this.groupComp = this.destroyBean(this.groupComp);
        super.destroy();
    }
};
$5b7ccabde48fae90$var$_SeriesDataPanel.TEMPLATE = /* html */ `<div id="seriesGroup"></div>`;
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartMenuService")
], $5b7ccabde48fae90$var$_SeriesDataPanel.prototype, "chartMenuService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_SeriesDataPanel.prototype, "init", 1);
var $5b7ccabde48fae90$var$SeriesDataPanel = $5b7ccabde48fae90$var$_SeriesDataPanel;
var $5b7ccabde48fae90$var$_SeriesChartTypePanel = class _SeriesChartTypePanel2 extends (0, $jIDNV.Component) {
    constructor(chartController, columns, isOpen){
        super(_SeriesChartTypePanel2.TEMPLATE);
        this.chartController = chartController;
        this.columns = columns;
        this.isOpen = isOpen;
        this.selectedColIds = [];
        this.chartTypeComps = /* @__PURE__ */ new Map();
        this.secondaryAxisComps = /* @__PURE__ */ new Map();
    }
    init() {
        this.createSeriesChartTypeGroup(this.columns);
    }
    refresh(columns) {
        if (!(0, $jIDNV._).areEqual(this.getValidColIds(columns), this.selectedColIds)) this.recreate(columns);
        else this.refreshComps();
    }
    recreate(columns) {
        this.isOpen = this.seriesChartTypeGroupComp.isExpanded();
        (0, $jIDNV._).clearElement(this.getGui());
        this.destroyBean(this.seriesChartTypeGroupComp);
        this.columns = columns;
        this.selectedColIds = [];
        this.clearComps();
        this.init();
    }
    getValidColIds(columns) {
        const seriesChartTypes = this.chartController.getSeriesChartTypes();
        return columns.filter((col)=>col.selected && !!seriesChartTypes.filter((s)=>s.colId === col.colId)[0]).map(({ colId: colId })=>colId);
    }
    createSeriesChartTypeGroup(columns) {
        this.seriesChartTypeGroupComp = this.createBean(new (0, $jIDNV.AgGroupComponent)({
            title: this.chartTranslationService.translate("seriesChartType"),
            enabled: true,
            suppressEnabledCheckbox: true,
            suppressOpenCloseIcons: false,
            cssIdentifier: "charts-data",
            expanded: this.isOpen
        }));
        const seriesChartTypes = this.chartController.getSeriesChartTypes();
        columns.forEach((col)=>{
            if (!col.selected) return;
            const seriesChartType = seriesChartTypes.filter((s)=>s.colId === col.colId)[0];
            if (!seriesChartType) return;
            this.selectedColIds.push(col.colId);
            const seriesItemGroup = this.seriesChartTypeGroupComp.createManagedBean(new (0, $jIDNV.AgGroupComponent)({
                title: col.displayName,
                enabled: true,
                suppressEnabledCheckbox: true,
                suppressOpenCloseIcons: true,
                cssIdentifier: "charts-format-sub-level"
            }));
            const isSecondaryAxisDisabled = (chartType)=>[
                    "groupedColumn",
                    "stackedColumn",
                    "stackedArea"
                ].includes(chartType);
            const secondaryAxisComp = this.seriesChartTypeGroupComp.createManagedBean(new (0, $jIDNV.AgCheckbox)({
                label: this.chartTranslationService.translate("secondaryAxis"),
                labelWidth: "flex",
                disabled: isSecondaryAxisDisabled(seriesChartType.chartType),
                value: !!seriesChartType.secondaryAxis,
                onValueChange: (enabled)=>this.chartController.updateSeriesChartType(col.colId, void 0, enabled)
            }));
            seriesItemGroup.addItem(secondaryAxisComp);
            const translate = (key)=>{
                return this.chartTranslationService.translate(key);
            };
            const availableChartTypes = [
                {
                    value: "line",
                    text: translate("line")
                },
                {
                    value: "area",
                    text: translate("area")
                },
                {
                    value: "stackedArea",
                    text: translate("stackedArea")
                },
                {
                    value: "groupedColumn",
                    text: translate("groupedColumn")
                },
                {
                    value: "stackedColumn",
                    text: translate("stackedColumn")
                }
            ];
            const chartTypeComp = seriesItemGroup.createManagedBean(new (0, $jIDNV.AgSelect)({
                labelAlignment: "left",
                labelWidth: "flex",
                options: availableChartTypes,
                value: seriesChartType.chartType,
                onValueChange: (chartType)=>this.chartController.updateSeriesChartType(col.colId, chartType)
            }));
            seriesItemGroup.addItem(chartTypeComp);
            this.seriesChartTypeGroupComp.addItem(seriesItemGroup);
            this.chartTypeComps.set(col.colId, chartTypeComp);
            this.secondaryAxisComps.set(col.colId, secondaryAxisComp);
        });
        this.getGui().appendChild(this.seriesChartTypeGroupComp.getGui());
    }
    refreshComps() {
        const seriesChartTypes = this.chartController.getSeriesChartTypes();
        this.selectedColIds.forEach((colId)=>{
            const seriesChartType = seriesChartTypes.find((chartType)=>chartType.colId === colId);
            if (!seriesChartType) return;
            const chartTypeComp = this.chartTypeComps.get(colId);
            const secondaryAxisComp = this.secondaryAxisComps.get(colId);
            chartTypeComp == null || chartTypeComp.setValue(seriesChartType.chartType);
            secondaryAxisComp == null || secondaryAxisComp.setValue(!!seriesChartType.secondaryAxis);
            secondaryAxisComp == null || secondaryAxisComp.setDisabled(this.isSecondaryAxisDisabled(seriesChartType.chartType));
        });
    }
    clearComps() {
        this.chartTypeComps.clear();
        this.secondaryAxisComps.clear();
    }
    isSecondaryAxisDisabled(chartType) {
        return [
            "groupedColumn",
            "stackedColumn",
            "stackedArea"
        ].includes(chartType);
    }
    destroy() {
        this.clearComps();
        this.seriesChartTypeGroupComp = this.destroyBean(this.seriesChartTypeGroupComp);
        super.destroy();
    }
};
$5b7ccabde48fae90$var$_SeriesChartTypePanel.TEMPLATE = /* html */ `<div id="seriesChartTypeGroup"></div>`;
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartTranslationService")
], $5b7ccabde48fae90$var$_SeriesChartTypePanel.prototype, "chartTranslationService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_SeriesChartTypePanel.prototype, "init", 1);
var $5b7ccabde48fae90$var$SeriesChartTypePanel = $5b7ccabde48fae90$var$_SeriesChartTypePanel;
var $5b7ccabde48fae90$var$_SwitchCategorySeriesDataPanel = class _SwitchCategorySeriesDataPanel2 extends (0, $jIDNV.Component) {
    constructor(getValue, setValue){
        super();
        this.getValue = getValue;
        this.setValue = setValue;
    }
    init() {
        this.switchCategorySeriesToggleButton = this.createManagedBean(new (0, $jIDNV.AgToggleButton)({
            label: this.chartTranslationService.translate("switchCategorySeries"),
            labelAlignment: "left",
            labelWidth: "flex",
            inputWidth: "flex",
            value: this.getValue(),
            onValueChange: (value)=>{
                this.setValue(value);
            }
        }));
        const switchCategorySeriesGroupParams = {
            title: void 0,
            suppressEnabledCheckbox: true,
            suppressOpenCloseIcons: true,
            cssIdentifier: "charts-data",
            expanded: true,
            items: [
                this.switchCategorySeriesToggleButton
            ]
        };
        this.setTemplate(_SwitchCategorySeriesDataPanel2.TEMPLATE, {
            switchCategorySeriesGroup: switchCategorySeriesGroupParams
        });
    }
    refresh() {
        var _a;
        (_a = this.switchCategorySeriesToggleButton) == null || _a.setValue(this.getValue(), true);
    }
};
$5b7ccabde48fae90$var$_SwitchCategorySeriesDataPanel.TEMPLATE = /* html */ `<div>
        <ag-group-component ref="switchCategorySeriesGroup"></ag-group-component>
    </div>`;
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartTranslationService")
], $5b7ccabde48fae90$var$_SwitchCategorySeriesDataPanel.prototype, "chartTranslationService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_SwitchCategorySeriesDataPanel.prototype, "init", 1);
var $5b7ccabde48fae90$var$SwitchCategorySeriesDataPanel = $5b7ccabde48fae90$var$_SwitchCategorySeriesDataPanel;
var $5b7ccabde48fae90$var$DefaultDataPanelDef = {
    groups: [
        {
            type: "categories",
            isOpen: true
        },
        {
            type: "series",
            isOpen: true
        },
        {
            type: "seriesChartType",
            isOpen: true
        }
    ]
};
var $5b7ccabde48fae90$var$_ChartDataPanel = class _ChartDataPanel2 extends (0, $jIDNV.Component) {
    constructor(chartController, chartOptionsService){
        super(_ChartDataPanel2.TEMPLATE);
        this.chartController = chartController;
        this.chartOptionsService = chartOptionsService;
        this.isSwitchCategorySeriesToggled = false;
    }
    init() {
        this.switchCategorySeriesPanel = this.addComponent(this.createManagedBean(new $5b7ccabde48fae90$var$SwitchCategorySeriesDataPanel(()=>this.chartController.isCategorySeriesSwitched(), (value)=>this.chartController.switchCategorySeries(value))));
        this.isSwitchCategorySeriesToggled = this.chartController.isCategorySeriesSwitched();
        this.createAutoScrollService();
        this.updatePanels();
        this.addManagedListener(this.chartController, $5b7ccabde48fae90$var$ChartController.EVENT_CHART_MODEL_UPDATE, this.updatePanels.bind(this));
        this.addManagedListener(this.chartController, $5b7ccabde48fae90$var$ChartController.EVENT_CHART_API_UPDATE, this.updatePanels.bind(this));
    }
    destroy() {
        this.clearPanelComponents();
        super.destroy();
    }
    updatePanels() {
        var _a, _b, _c, _d, _e;
        const currentChartType = this.chartType;
        const isSwitchCategorySeriesToggledCurrent = this.isSwitchCategorySeriesToggled;
        const { dimensionCols: dimensionCols, valueCols: valueCols } = this.chartController.getColStateForMenu();
        this.chartType = this.chartController.getChartType();
        this.isSwitchCategorySeriesToggled = this.chartController.isCategorySeriesSwitched();
        const hasChangedSwitchCategorySeries = this.isSwitchCategorySeriesToggled !== isSwitchCategorySeriesToggledCurrent;
        if (this.canRefresh(currentChartType, this.chartType) && !hasChangedSwitchCategorySeries) {
            (_a = this.categoriesDataPanel) == null || _a.refresh(dimensionCols);
            (_b = this.seriesDataPanel) == null || _b.refresh(valueCols);
            (_c = this.seriesChartTypePanel) == null || _c.refresh(valueCols);
        } else this.recreatePanels(dimensionCols, valueCols);
        (_d = this.switchCategorySeriesPanel) == null || _d.setDisplayed($5b7ccabde48fae90$var$supportsInvertedCategorySeries(this.chartType) && !this.chartMenuService.isLegacyFormat() && !this.chartController.isGrouping());
        if (hasChangedSwitchCategorySeries) (_e = this.switchCategorySeriesPanel) == null || _e.refresh();
    }
    canRefresh(oldChartType, newChartType) {
        if (oldChartType === void 0) return false;
        if (oldChartType === newChartType) return true;
        const isCombo = (chartType)=>[
                "columnLineCombo",
                "areaColumnCombo",
                "customCombo"
            ].includes(chartType);
        if (isCombo(oldChartType) && isCombo(newChartType)) return true;
        return false;
    }
    recreatePanels(dimensionCols, valueCols) {
        var _a;
        this.clearPanelComponents();
        const { chartType: chartType } = this;
        if (!chartType) return;
        const isCategorySeriesSwitched = this.chartController.isCategorySeriesSwitched();
        const panels = (_a = this.getDataPanelDef().groups) == null ? void 0 : _a.map(({ type: type, isOpen: isOpen })=>{
            if (type === (isCategorySeriesSwitched ? "series" : "categories")) return this.categoriesDataPanel = this.createBean(new $5b7ccabde48fae90$var$CategoriesDataPanel(this.chartController, this.autoScrollService, this.getCategoryGroupTitle(isCategorySeriesSwitched), this.getCategoryGroupMultipleSelect(chartType, isCategorySeriesSwitched), dimensionCols, isOpen));
            else if (type === (isCategorySeriesSwitched ? "categories" : "series")) return this.seriesDataPanel = this.createBean(new $5b7ccabde48fae90$var$SeriesDataPanel(this.chartController, this.autoScrollService, this.chartOptionsService, this.getSeriesGroupTitle(isCategorySeriesSwitched), this.getSeriesGroupMultipleSelect(chartType, isCategorySeriesSwitched), this.getSeriesGroupMaxSelection(chartType, isCategorySeriesSwitched), valueCols, isOpen));
            else if (type === "seriesChartType") {
                if (this.chartController.isComboChart()) return this.seriesChartTypePanel = this.createBean(new $5b7ccabde48fae90$var$SeriesChartTypePanel(this.chartController, valueCols, isOpen));
                return null;
            } else {
                (0, $jIDNV._).warnOnce(`Invalid charts data panel group name supplied: '${type}'`);
                return null;
            }
        }).filter((value)=>value != null);
        if (panels) this.addPanelComponents(panels);
    }
    addPanelComponents(panels) {
        var _a;
        const fragment = document.createDocumentFragment();
        for (const panel of panels){
            this.registerComponent(panel);
            fragment.appendChild(panel.getGui());
        }
        const afterPanelElement = (_a = this.switchCategorySeriesPanel) == null ? void 0 : _a.getGui();
        this.getGui().insertBefore(fragment, afterPanelElement != null ? afterPanelElement : null);
        return panels;
    }
    clearPanelComponents() {
        const eGui = this.getGui();
        if (this.categoriesDataPanel) eGui.removeChild(this.categoriesDataPanel.getGui());
        if (this.seriesDataPanel) eGui.removeChild(this.seriesDataPanel.getGui());
        if (this.seriesChartTypePanel) eGui.removeChild(this.seriesChartTypePanel.getGui());
        this.categoriesDataPanel = this.destroyBean(this.categoriesDataPanel);
        this.seriesDataPanel = this.destroyBean(this.seriesDataPanel);
        this.seriesChartTypePanel = this.destroyBean(this.seriesChartTypePanel);
    }
    createAutoScrollService() {
        const eGui = this.getGui();
        this.autoScrollService = new (0, $jIDNV.AutoScrollService)({
            scrollContainer: eGui,
            scrollAxis: "y",
            getVerticalPosition: ()=>eGui.scrollTop,
            setVerticalPosition: (position)=>eGui.scrollTop = position
        });
    }
    addComponent(component) {
        this.registerComponent(component);
        this.getGui().appendChild(component.getGui());
        return component;
    }
    registerComponent(component) {
        component.addCssClass("ag-chart-data-section");
    }
    getDataPanelDef() {
        var _a, _b;
        return (_b = (_a = this.gos.get("chartToolPanelsDef")) == null ? void 0 : _a.dataPanel) != null ? _b : $5b7ccabde48fae90$var$DefaultDataPanelDef;
    }
    getCategoryGroupTitle(isCategorySeriesSwitched) {
        if (isCategorySeriesSwitched) return this.chartTranslationService.translate("seriesLabels");
        return this.chartTranslationService.translate(this.chartController.isActiveXYChart() ? "labels" : "categories");
    }
    getCategoryGroupMultipleSelect(chartType, isCategorySeriesSwitched) {
        if (isCategorySeriesSwitched) return false;
        return $5b7ccabde48fae90$var$getMaxNumCategories(chartType) !== 1;
    }
    getSeriesGroupTitle(isCategorySeriesSwitched) {
        if (isCategorySeriesSwitched) return this.chartTranslationService.translate("categoryValues");
        return this.chartTranslationService.translate(this.chartController.isActiveXYChart() ? "xyValues" : "series");
    }
    getSeriesGroupMultipleSelect(chartType, isCategorySeriesSwitched) {
        return this.getSeriesGroupMaxSelection(chartType, isCategorySeriesSwitched) !== 1;
    }
    getSeriesGroupMaxSelection(chartType, isCategorySeriesSwitched) {
        if (isCategorySeriesSwitched) return void 0;
        return $5b7ccabde48fae90$var$getMaxNumSeries(chartType);
    }
};
$5b7ccabde48fae90$var$_ChartDataPanel.TEMPLATE = /* html */ `<div class="ag-chart-data-wrapper ag-scrollable-container"></div>`;
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartTranslationService")
], $5b7ccabde48fae90$var$_ChartDataPanel.prototype, "chartTranslationService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartMenuService")
], $5b7ccabde48fae90$var$_ChartDataPanel.prototype, "chartMenuService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_ChartDataPanel.prototype, "init", 1);
var $5b7ccabde48fae90$var$ChartDataPanel = $5b7ccabde48fae90$var$_ChartDataPanel;
var $5b7ccabde48fae90$var$_FontPanel = class _FontPanel2 extends (0, $jIDNV.Component) {
    constructor(params){
        super();
        this.activeComps = [];
        this.params = params;
        this.chartOptions = params.chartMenuUtils.getChartOptions();
    }
    init() {
        const fontGroupParams = {
            cssIdentifier: "charts-format-sub-level",
            direction: "vertical",
            suppressOpenCloseIcons: true,
            title: this.params.name || this.chartTranslationService.translate("font"),
            enabled: this.params.enabled,
            suppressEnabledCheckbox: !!this.params.suppressEnabledCheckbox,
            onEnableChange: (enabled)=>{
                if (this.params.onEnableChange) this.params.onEnableChange(enabled);
            }
        };
        this.setTemplate(_FontPanel2.TEMPLATE, {
            fontGroup: fontGroupParams,
            familySelect: this.getFamilySelectParams(),
            weightStyleSelect: this.getWeightStyleSelectParams(),
            sizeSelect: this.getSizeSelectParams(),
            colorPicker: this.params.chartMenuUtils.getDefaultColorPickerParams(this.params.keyMapper("color"))
        });
    }
    addCompToPanel(comp) {
        this.fontGroup.addItem(comp);
        this.activeComps.push(comp);
    }
    setEnabled(enabled) {
        this.fontGroup.setEnabled(enabled);
    }
    getFamilySelectParams() {
        const families = [
            "Arial, sans-serif",
            "Aria Black, sans-serif",
            "Book Antiqua,  serif",
            "Charcoal, sans-serif",
            "Comic Sans MS, cursive",
            "Courier, monospace",
            "Courier New, monospace",
            "Gadget, sans-serif",
            "Geneva, sans-serif",
            "Helvetica, sans-serif",
            "Impact, sans-serif",
            "Lucida Console, monospace",
            "Lucida Grande, sans-serif",
            "Lucida Sans Unicode,  sans-serif",
            "Monaco, monospace",
            "Palatino Linotype, serif",
            "Palatino, serif",
            "Times New Roman, serif",
            "Times, serif",
            "Verdana, sans-serif"
        ];
        const family = this.getInitialFontValue("fontFamily");
        let initialValue = families[0];
        if (family) {
            const lowerCaseValues = families.map((f)=>f.toLowerCase());
            const valueIndex = lowerCaseValues.indexOf(family.toLowerCase());
            if (valueIndex >= 0) initialValue = families[valueIndex];
            else {
                const capitalisedFontValue = (0, $jIDNV._).capitalise(family);
                families.push(capitalisedFontValue);
                initialValue = capitalisedFontValue;
            }
        }
        const options = families.sort().map((value)=>({
                value: value,
                text: value
            }));
        return {
            options: options,
            inputWidth: "flex",
            value: `${initialValue}`,
            onValueChange: (newValue)=>this.setFont({
                    fontFamily: newValue
                })
        };
    }
    getSizeSelectParams() {
        const sizes = [
            8,
            10,
            12,
            14,
            16,
            18,
            20,
            22,
            24,
            26,
            28,
            30,
            32,
            34,
            36
        ];
        const size = this.getInitialFontValue("fontSize");
        if (!(0, $jIDNV._).includes(sizes, size)) sizes.push(size);
        const options = sizes.sort((a, b)=>a - b).map((value)=>({
                value: `${value}`,
                text: `${value}`
            }));
        return {
            options: options,
            inputWidth: "flex",
            value: `${size}`,
            onValueChange: (newValue)=>this.setFont({
                    fontSize: parseInt(newValue, 10)
                }),
            label: this.chartTranslationService.translate("size")
        };
    }
    getWeightStyleSelectParams() {
        var _a, _b;
        const weight = (_a = this.getInitialFontValue("fontWeight")) != null ? _a : "normal";
        const style = (_b = this.getInitialFontValue("fontStyle")) != null ? _b : "normal";
        const weightStyles = [
            {
                name: "normal",
                weight: "normal",
                style: "normal"
            },
            {
                name: "bold",
                weight: "bold",
                style: "normal"
            },
            {
                name: "italic",
                weight: "normal",
                style: "italic"
            },
            {
                name: "boldItalic",
                weight: "bold",
                style: "italic"
            }
        ];
        let selectedOption = weightStyles.find((x)=>x.weight === weight && x.style === style);
        if (!selectedOption) {
            selectedOption = {
                name: "predefined",
                weight: weight,
                style: style
            };
            weightStyles.unshift(selectedOption);
        }
        const options = weightStyles.map((ws)=>({
                value: ws.name,
                text: this.chartTranslationService.translate(ws.name)
            }));
        return {
            options: options,
            inputWidth: "flex",
            value: selectedOption.name,
            onValueChange: (newValue)=>{
                const selectedWeightStyle = weightStyles.find((x)=>x.name === newValue);
                this.setFont({
                    fontWeight: selectedWeightStyle.weight,
                    fontStyle: selectedWeightStyle.style
                });
            }
        };
    }
    addItemToPanel(item) {
        this.fontGroup.addItem(item);
        this.activeComps.push(item);
    }
    destroyActiveComps() {
        this.activeComps.forEach((comp)=>{
            (0, $jIDNV._).removeFromParent(comp.getGui());
            this.destroyBean(comp);
        });
    }
    destroy() {
        this.destroyActiveComps();
        super.destroy();
    }
    setFont(font) {
        const { keyMapper: keyMapper } = this.params;
        Object.entries(font).forEach(([fontKey, value])=>{
            if (value) this.chartOptions.setValue(keyMapper(fontKey), value);
        });
    }
    getInitialFontValue(fontKey) {
        const { keyMapper: keyMapper } = this.params;
        return this.chartOptions.getValue(keyMapper(fontKey));
    }
};
$5b7ccabde48fae90$var$_FontPanel.TEMPLATE = /* html */ `<div class="ag-font-panel">
            <ag-group-component ref="fontGroup">
                <ag-select ref="familySelect"></ag-select>
                <ag-select ref="weightStyleSelect"></ag-select>
                <div class="ag-charts-font-size-color">
                    <ag-select ref="sizeSelect"></ag-select>
                    <ag-color-picker ref="colorPicker"></ag-color-picker>
                </div>
            </ag-group-component>
        </div>`;
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.RefSelector)("fontGroup")
], $5b7ccabde48fae90$var$_FontPanel.prototype, "fontGroup", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartTranslationService")
], $5b7ccabde48fae90$var$_FontPanel.prototype, "chartTranslationService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_FontPanel.prototype, "init", 1);
var $5b7ccabde48fae90$var$FontPanel = $5b7ccabde48fae90$var$_FontPanel;
var $5b7ccabde48fae90$var$_LegendPanel = class _LegendPanel2 extends (0, $jIDNV.Component) {
    constructor({ chartMenuParamsFactory: chartMenuUtils, isExpandedOnInit: isExpandedOnInit = false }){
        super();
        this.chartMenuUtils = chartMenuUtils;
        this.isExpandedOnInit = isExpandedOnInit;
    }
    init() {
        const legendGroupParams = this.chartMenuUtils.addEnableParams("legend.enabled", {
            cssIdentifier: "charts-format-top-level",
            direction: "vertical",
            title: this.chartTranslationService.translate("legend"),
            suppressEnabledCheckbox: false,
            suppressToggleExpandOnEnableChange: true,
            expanded: this.isExpandedOnInit,
            items: [
                this.createLabelPanel()
            ]
        });
        this.setTemplate(_LegendPanel2.TEMPLATE, {
            legendGroup: legendGroupParams,
            legendPositionSelect: this.chartMenuUtils.getDefaultLegendParams("legend.position"),
            legendPaddingSlider: this.getSliderParams("spacing", "spacing", 200),
            markerSizeSlider: this.getSliderParams("item.marker.size", "markerSize", 40),
            markerStrokeSlider: this.getSliderParams("item.marker.strokeWidth", "markerStroke", 10),
            markerPaddingSlider: this.getSliderParams("item.marker.padding", "itemSpacing", 20),
            itemPaddingXSlider: this.getSliderParams("item.paddingX", "layoutHorizontalSpacing", 50),
            itemPaddingYSlider: this.getSliderParams("item.paddingY", "layoutVerticalSpacing", 50)
        });
    }
    getSliderParams(expression, labelKey, defaultMaxValue) {
        return this.chartMenuUtils.getDefaultSliderParams(`legend.${expression}`, labelKey, defaultMaxValue);
    }
    createLabelPanel() {
        const params = {
            enabled: true,
            suppressEnabledCheckbox: true,
            chartMenuUtils: this.chartMenuUtils,
            keyMapper: (key)=>`legend.item.label.${key}`
        };
        return this.createManagedBean(new $5b7ccabde48fae90$var$FontPanel(params));
    }
};
$5b7ccabde48fae90$var$_LegendPanel.TEMPLATE = /* html */ `<div>
            <ag-group-component ref="legendGroup">
                <ag-select ref="legendPositionSelect"></ag-select>
                <ag-slider ref="legendPaddingSlider"></ag-slider>
                <ag-slider ref="markerSizeSlider"></ag-slider>
                <ag-slider ref="markerStrokeSlider"></ag-slider>
                <ag-slider ref="markerPaddingSlider"></ag-slider>
                <ag-slider ref="itemPaddingXSlider"></ag-slider>
                <ag-slider ref="itemPaddingYSlider"></ag-slider>
            </ag-group-component>
        </div>`;
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartTranslationService")
], $5b7ccabde48fae90$var$_LegendPanel.prototype, "chartTranslationService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_LegendPanel.prototype, "init", 1);
var $5b7ccabde48fae90$var$LegendPanel = $5b7ccabde48fae90$var$_LegendPanel;
var $5b7ccabde48fae90$var$_AxisTicksPanel = class _AxisTicksPanel2 extends (0, $jIDNV.Component) {
    constructor(chartMenuUtils){
        super();
        this.chartMenuUtils = chartMenuUtils;
    }
    init() {
        const axisTicksGroupParams = this.chartMenuUtils.addEnableParams("tick.enabled", {
            cssIdentifier: "charts-format-sub-level",
            direction: "vertical",
            suppressOpenCloseIcons: true,
            title: this.chartTranslationService.translate("ticks"),
            suppressEnabledCheckbox: false
        });
        const axisTicksColorPickerParams = this.chartMenuUtils.getDefaultColorPickerParams("tick.color");
        const axisTicksWidthSliderParams = this.chartMenuUtils.getDefaultSliderParams("tick.width", "width", 10);
        const axisTicksSizeSliderParams = this.chartMenuUtils.getDefaultSliderParams("tick.size", "length", 30);
        this.setTemplate(_AxisTicksPanel2.TEMPLATE, {
            axisTicksGroup: axisTicksGroupParams,
            axisTicksColorPicker: axisTicksColorPickerParams,
            axisTicksWidthSlider: axisTicksWidthSliderParams,
            axisTicksSizeSlider: axisTicksSizeSliderParams
        });
    }
};
$5b7ccabde48fae90$var$_AxisTicksPanel.TEMPLATE = /* html */ `<div>
            <ag-group-component ref="axisTicksGroup">
                <ag-color-picker ref="axisTicksColorPicker"></ag-color-picker>
                <ag-slider ref="axisTicksWidthSlider"></ag-slider>
                <ag-slider ref="axisTicksSizeSlider"></ag-slider>
            </ag-group-component>
        </div>`;
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartTranslationService")
], $5b7ccabde48fae90$var$_AxisTicksPanel.prototype, "chartTranslationService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_AxisTicksPanel.prototype, "init", 1);
var $5b7ccabde48fae90$var$AxisTicksPanel = $5b7ccabde48fae90$var$_AxisTicksPanel;
var $5b7ccabde48fae90$var$_GridLinePanel = class _GridLinePanel2 extends (0, $jIDNV.Component) {
    constructor(chartMenuUtils){
        super();
        this.chartMenuUtils = chartMenuUtils;
        this.chartOptions = chartMenuUtils.getChartOptions();
    }
    init() {
        const gridLineGroupParams = this.chartMenuUtils.addEnableParams("gridLine.enabled", {
            cssIdentifier: "charts-format-sub-level",
            direction: "vertical",
            suppressOpenCloseIcons: true,
            title: this.chartTranslationService.translate("gridLines"),
            suppressEnabledCheckbox: false
        });
        const gridLineColorPickerParams = this.getGridLineColorPickerParams("color");
        const gridLineWidthSliderParams = this.getGridLineWidthSliderParams("thickness");
        const gridLineLineDashSliderParams = this.getGridLineDashSliderParams("lineDash");
        this.setTemplate(_GridLinePanel2.TEMPLATE, {
            gridLineGroup: gridLineGroupParams,
            gridLineColorPicker: gridLineColorPickerParams,
            gridLineWidthSlider: gridLineWidthSliderParams,
            gridLineLineDashSlider: gridLineLineDashSliderParams
        });
    }
    getGridLineColorPickerParams(labelKey) {
        return this.chartMenuUtils.getDefaultColorPickerParams("gridLine.style", labelKey, {
            formatInputValue: (value)=>{
                var _a;
                return (_a = value == null ? void 0 : value[0]) == null ? void 0 : _a.stroke;
            },
            parseInputValue: (value)=>{
                var _a;
                const styles = (_a = this.chartOptions.getValue("gridLine.style")) != null ? _a : [];
                if (styles.length === 0) return [
                    {
                        stroke: value,
                        lineDash: []
                    }
                ];
                return [
                    $5b7ccabde48fae90$var$__spreadProps3($5b7ccabde48fae90$var$__spreadValues3({}, styles[0]), {
                        stroke: value
                    })
                ];
            }
        });
    }
    getGridLineWidthSliderParams(labelKey) {
        return this.chartMenuUtils.getDefaultSliderParams("gridLine.width", labelKey, 10);
    }
    getGridLineDashSliderParams(labelKey) {
        var _a, _b;
        const initialStyles = this.chartOptions.getValue("gridLine.style");
        const initialValue = (_b = (_a = initialStyles == null ? void 0 : initialStyles[0]) == null ? void 0 : _a.lineDash) == null ? void 0 : _b[0];
        const params = this.chartMenuUtils.getDefaultSliderParamsWithoutValueParams(initialValue != null ? initialValue : 0, labelKey, 30);
        params.onValueChange = (value)=>{
            const stroke = this.chartOptions.getValue("gridLine.style.0.stroke");
            this.chartOptions.setValue("gridLine.style", [
                {
                    lineDash: [
                        value
                    ],
                    stroke: stroke
                }
            ]);
        };
        return params;
    }
};
$5b7ccabde48fae90$var$_GridLinePanel.TEMPLATE = /* html */ `<div>
            <ag-group-component ref="gridLineGroup">
                <ag-color-picker ref="gridLineColorPicker"></ag-color-picker>
                <ag-slider ref="gridLineWidthSlider"></ag-slider>
                <ag-slider ref="gridLineLineDashSlider"></ag-slider>
            </ag-group-component>
        </div>`;
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartTranslationService")
], $5b7ccabde48fae90$var$_GridLinePanel.prototype, "chartTranslationService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_GridLinePanel.prototype, "init", 1);
var $5b7ccabde48fae90$var$GridLinePanel = $5b7ccabde48fae90$var$_GridLinePanel;
var $5b7ccabde48fae90$var$_AgAngleSelect = class _AgAngleSelect2 extends (0, $jIDNV.AgAbstractLabel) {
    constructor(config){
        super(config, _AgAngleSelect2.TEMPLATE);
        this.radius = 0;
        this.offsetX = 0;
        this.offsetY = 0;
    }
    postConstruct() {
        super.postConstruct();
        const { value: value, onValueChange: onValueChange } = this.config;
        if (value != null) this.setValue(value, void 0, true);
        if (onValueChange != null) this.onValueChange(onValueChange);
        this.dragListener = {
            eElement: this.eParentCircle,
            dragStartPixels: 0,
            onDragStart: (e)=>{
                this.parentCircleRect = this.eParentCircle.getBoundingClientRect();
            },
            onDragging: (e)=>this.calculateAngleDrag(e),
            onDragStop: ()=>{}
        };
        this.dragService.addDragSource(this.dragListener);
        this.eAngleValue.setLabel("").setLabelWidth(5).setInputWidth(45).setMin(0).setMax(360).setValue(`${this.degrees}`).onValueChange((value2)=>{
            if (value2 == null || value2 === "") value2 = "0";
            value2 = this.eAngleValue.normalizeValue(value2);
            let floatValue = parseFloat(value2);
            if (floatValue > 180) floatValue = floatValue - 360;
            this.setValue(floatValue);
        });
        this.updateNumberInput();
        if ((0, $jIDNV._).exists(this.getValue())) this.eAngleValue.setValue(this.normalizeNegativeValue(this.getValue()).toString());
        this.addManagedListener(this, (0, $jIDNV.Events).EVENT_FIELD_VALUE_CHANGED, ()=>{
            if (this.eAngleValue.getInputElement().contains(this.gos.getActiveDomElement())) return;
            this.updateNumberInput();
        });
    }
    updateNumberInput() {
        const normalizedValue = this.normalizeNegativeValue(this.getValue());
        this.eAngleValue.setValue(normalizedValue.toString());
    }
    positionChildCircle(radians) {
        const rect = this.parentCircleRect || {
            width: 24,
            height: 24
        };
        const eChildCircle = this.eChildCircle;
        const centerX = rect.width / 2;
        const centerY = rect.height / 2;
        eChildCircle.style.left = `${centerX + Math.cos(radians) * 8}px`;
        eChildCircle.style.top = `${centerY + Math.sin(radians) * 8}px`;
    }
    calculatePolar() {
        const x = this.offsetX;
        const y = this.offsetY;
        const radians = Math.atan2(y, x);
        this.degrees = this.toDegrees(radians);
        this.radius = Math.sqrt(x * x + y * y);
        this.positionChildCircle(radians);
    }
    calculateCartesian() {
        const radians = this.toRadians(this.getValue());
        const radius = this.getRadius();
        this.setOffsetX(Math.cos(radians) * radius).setOffsetY(Math.sin(radians) * radius);
    }
    setOffsetX(offset) {
        if (this.offsetX !== offset) {
            this.offsetX = offset;
            this.calculatePolar();
        }
        return this;
    }
    setOffsetY(offset) {
        if (this.offsetY !== offset) {
            this.offsetY = offset;
            this.calculatePolar();
        }
        return this;
    }
    calculateAngleDrag(e) {
        const rect = this.parentCircleRect;
        const centerX = rect.width / 2;
        const centerY = rect.height / 2;
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        const dx = x - centerX;
        const dy = y - centerY;
        const radians = Math.atan2(dy, dx);
        this.setValue(radians, true);
    }
    toDegrees(radians) {
        return radians / Math.PI * 180;
    }
    toRadians(degrees) {
        return degrees / 180 * Math.PI;
    }
    normalizeNegativeValue(degrees) {
        return degrees < 0 ? 360 + degrees : degrees;
    }
    normalizeAngle180(radians) {
        radians %= Math.PI * 2;
        if (radians < -Math.PI) radians += Math.PI * 2;
        else if (radians >= Math.PI) radians -= Math.PI * 2;
        return radians;
    }
    getRadius() {
        return this.radius;
    }
    setRadius(r) {
        if (this.radius === r) return this;
        this.radius = r;
        this.calculateCartesian();
        return this;
    }
    onValueChange(callbackFn) {
        this.addManagedListener(this, (0, $jIDNV.Events).EVENT_FIELD_VALUE_CHANGED, ()=>{
            callbackFn(this.degrees);
        });
        return this;
    }
    getValue(radians) {
        return radians ? this.toRadians(this.degrees) : this.degrees;
    }
    setValue(degrees, radians, silent) {
        let radiansValue;
        if (!radians) radiansValue = this.normalizeAngle180(this.toRadians(degrees));
        else radiansValue = degrees;
        degrees = this.toDegrees(radiansValue);
        if (this.degrees !== degrees) {
            this.degrees = Math.floor(degrees);
            this.calculateCartesian();
            this.positionChildCircle(radiansValue);
            if (!silent) this.dispatchEvent({
                type: (0, $jIDNV.Events).EVENT_FIELD_VALUE_CHANGED
            });
        }
        return this;
    }
    setWidth(width) {
        (0, $jIDNV._).setFixedWidth(this.getGui(), width);
        return this;
    }
    setDisabled(disabled) {
        super.setDisabled(disabled);
        this.eAngleValue.setDisabled(disabled);
        return this;
    }
    destroy() {
        this.dragService.removeDragSource(this.dragListener);
        super.destroy();
    }
};
$5b7ccabde48fae90$var$_AgAngleSelect.TEMPLATE = /* html */ `<div class="ag-angle-select">
            <div ref="eLabel"></div>
            <div class="ag-wrapper ag-angle-select-wrapper">
                <div ref="eAngleSelectField" class="ag-angle-select-field">
                    <div ref="eParentCircle" class="ag-angle-select-parent-circle">
                        <div ref="eChildCircle" class="ag-angle-select-child-circle"></div>
                    </div>
                </div>
                <ag-input-number-field ref="eAngleValue"></ag-input-number-field>
            </div>
        </div>`;
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.RefSelector)("eLabel")
], $5b7ccabde48fae90$var$_AgAngleSelect.prototype, "eLabel", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.RefSelector)("eParentCircle")
], $5b7ccabde48fae90$var$_AgAngleSelect.prototype, "eParentCircle", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.RefSelector)("eChildCircle")
], $5b7ccabde48fae90$var$_AgAngleSelect.prototype, "eChildCircle", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.RefSelector)("eAngleValue")
], $5b7ccabde48fae90$var$_AgAngleSelect.prototype, "eAngleValue", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("dragService")
], $5b7ccabde48fae90$var$_AgAngleSelect.prototype, "dragService", 2);
var $5b7ccabde48fae90$var$AgAngleSelect = $5b7ccabde48fae90$var$_AgAngleSelect;
var $5b7ccabde48fae90$var$ChartMenuParamsFactory = class extends (0, $jIDNV.BeanStub) {
    constructor(chartOptionsProxy){
        super();
        this.chartOptionsProxy = chartOptionsProxy;
    }
    getDefaultColorPickerParams(expression, labelKey, options) {
        return this.addValueParams(expression, {
            label: this.chartTranslationService.translate(labelKey != null ? labelKey : "color"),
            labelWidth: "flex",
            inputWidth: "flex"
        }, options);
    }
    getDefaultNumberInputParams(expression, labelKey, options) {
        return this.addValueParams(expression, {
            label: this.chartTranslationService.translate(labelKey),
            labelWidth: "flex",
            inputWidth: "flex",
            precision: options == null ? void 0 : options.precision,
            step: options == null ? void 0 : options.step,
            min: options == null ? void 0 : options.min,
            max: options == null ? void 0 : options.max
        }, {
            parseInputValue: (value)=>{
                const numberValue = Number(value);
                return isNaN(numberValue) ? void 0 : numberValue;
            },
            formatInputValue: (value)=>{
                return value == null ? "" : `${value}`;
            }
        });
    }
    getDefaultSliderParams(expression, labelKey, defaultMaxValue, isArray) {
        var _a;
        let value = (_a = this.chartOptionsProxy.getValue(expression)) != null ? _a : 0;
        if (isArray && Array.isArray(value)) value = value[0];
        const params = this.getDefaultSliderParamsWithoutValueParams(value, labelKey, defaultMaxValue);
        params.onValueChange = (value2)=>this.chartOptionsProxy.setValue(expression, isArray ? [
                value2
            ] : value2);
        return params;
    }
    getDefaultSliderParamsWithoutValueParams(value, labelKey, defaultMaxValue) {
        return {
            label: this.chartTranslationService.translate(labelKey),
            minValue: 0,
            maxValue: Math.max(value, defaultMaxValue),
            textFieldWidth: 45,
            value: `${value}`
        };
    }
    getDefaultCheckboxParams(expression, labelKey, options) {
        const value = this.chartOptionsProxy.getValue(expression);
        const params = {
            label: this.chartTranslationService.translate(labelKey),
            value: value,
            readOnly: options == null ? void 0 : options.readOnly,
            passive: options == null ? void 0 : options.passive
        };
        params.onValueChange = (value2)=>{
            this.chartOptionsProxy.setValue(expression, typeof value2 === "boolean" ? value2 : void 0);
        };
        return params;
    }
    getDefaultSelectParams(expression, labelKey, dropdownOptions, options) {
        const value = this.chartOptionsProxy.getValue(expression);
        const params = {
            label: this.chartTranslationService.translate(labelKey),
            value: value,
            options: dropdownOptions,
            pickerType: options == null ? void 0 : options.pickerType,
            pickerAriaLabelKey: options == null ? void 0 : options.pickerAriaLabelKey,
            pickerAriaLabelValue: options == null ? void 0 : options.pickerAriaLabelValue
        };
        params.onValueChange = (value2)=>{
            this.chartOptionsProxy.setValue(expression, value2);
        };
        return params;
    }
    getDefaultLegendParams(expression) {
        return this.addValueParams(expression, {
            label: this.chartTranslationService.translate("position"),
            labelWidth: "flex",
            inputWidth: "flex",
            options: [
                "top",
                "right",
                "bottom",
                "left"
            ].map((position)=>({
                    value: position,
                    text: this.chartTranslationService.translate(position)
                }))
        });
    }
    getDefaultFontPanelParams(expression, labelKey) {
        const keyMapper = (key)=>`${expression}.${key}`;
        return this.addEnableParams(keyMapper("enabled"), {
            name: this.chartTranslationService.translate(labelKey),
            suppressEnabledCheckbox: false,
            chartMenuUtils: this,
            keyMapper: keyMapper
        });
    }
    addValueParams(expression, params, options) {
        const optionsValue = this.chartOptionsProxy.getValue(expression);
        params.value = (options == null ? void 0 : options.formatInputValue) ? options.formatInputValue(optionsValue) : optionsValue;
        params.onValueChange = (value)=>{
            const optionsValue2 = (options == null ? void 0 : options.parseInputValue) ? options.parseInputValue(value) : value;
            this.chartOptionsProxy.setValue(expression, optionsValue2);
        };
        return params;
    }
    addEnableParams(expression, params) {
        var _a;
        params.enabled = (_a = this.chartOptionsProxy.getValue(expression)) != null ? _a : false;
        params.onEnableChange = (value)=>this.chartOptionsProxy.setValue(expression, value);
        return params;
    }
    getChartOptions() {
        return this.chartOptionsProxy;
    }
};
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartTranslationService")
], $5b7ccabde48fae90$var$ChartMenuParamsFactory.prototype, "chartTranslationService", 2);
var $5b7ccabde48fae90$var$DEFAULT_TIME_AXIS_FORMAT = "%d %B %Y";
var $5b7ccabde48fae90$var$_CartesianAxisPanel = class _CartesianAxisPanel2 extends (0, $jIDNV.Component) {
    constructor(axisType, { chartController: chartController, chartOptionsService: chartOptionsService, isExpandedOnInit: isExpandedOnInit = false, seriesType: seriesType }){
        super();
        this.activePanels = [];
        this.axisLabelUpdateFuncs = [];
        this.axisType = axisType;
        this.chartController = chartController;
        this.chartAxisOptionsProxy = chartOptionsService.getCartesianAxisOptionsProxy(axisType);
        this.chartAxisThemeOverridesProxy = chartOptionsService.getCartesianAxisThemeOverridesProxy(axisType);
        this.chartAxisAppliedThemeOverridesProxy = chartOptionsService.getCartesianAxisAppliedThemeOverridesProxy(axisType);
        this.chartOptionsSeriesProxy = chartOptionsService.getSeriesOptionsProxy(()=>seriesType != null ? seriesType : this.chartController.getChartSeriesType());
        this.chartOptionsService = chartOptionsService;
        this.isExpandedOnInit = isExpandedOnInit;
    }
    init() {
        var _a;
        const labelKey = this.axisType;
        const axisGroupParams = {
            cssIdentifier: "charts-format-top-level",
            direction: "vertical",
            title: this.translate(labelKey),
            expanded: this.isExpandedOnInit,
            suppressEnabledCheckbox: true
        };
        const chartAxisOptions = this.createManagedBean(new $5b7ccabde48fae90$var$ChartMenuParamsFactory(this.chartAxisOptionsProxy));
        const chartAxisThemeOverrides = this.createManagedBean(new $5b7ccabde48fae90$var$ChartMenuParamsFactory(this.chartAxisThemeOverridesProxy));
        const axisTypeSelectParams = this.getAxisTypeSelectParams(chartAxisOptions, this.chartAxisAppliedThemeOverridesProxy);
        const axisPositionSelectParams = this.getAxisPositionSelectParams(chartAxisOptions);
        const axisTimeFormatSelectParams = this.getAxisTimeFormatSelectParams(chartAxisOptions);
        const axisColorInputParams = this.getAxisColorInputParams(chartAxisThemeOverrides);
        const axisLineWidthSliderParams = this.getAxisLineWidthSliderParams(chartAxisThemeOverrides);
        this.setTemplate(_CartesianAxisPanel2.TEMPLATE, {
            axisGroup: axisGroupParams,
            axisTypeSelect: axisTypeSelectParams != null ? axisTypeSelectParams : void 0,
            axisPositionSelect: axisPositionSelectParams != null ? axisPositionSelectParams : void 0,
            axisTimeFormatSelect: axisTimeFormatSelectParams != null ? axisTimeFormatSelectParams : void 0,
            axisColorInput: axisColorInputParams,
            axisLineWidthSlider: axisLineWidthSliderParams
        });
        this.axisTypeSelect.setDisplayed(!!((_a = axisTypeSelectParams.options) == null ? void 0 : _a.length));
        if (!axisPositionSelectParams) this.removeTemplateComponent(this.axisPositionSelect);
        const updateTimeFormatVisibility = ()=>{
            const isTimeAxis = this.chartAxisOptionsProxy.getValue("type") === "time";
            (0, $jIDNV._).setDisplayed(this.axisTimeFormatSelect.getGui(), isTimeAxis);
        };
        if (!axisTimeFormatSelectParams) this.removeTemplateComponent(this.axisTimeFormatSelect);
        else {
            updateTimeFormatVisibility();
            this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_CHART_OPTIONS_CHANGED, (e)=>{
                updateTimeFormatVisibility();
            });
        }
        this.initGridLines(chartAxisThemeOverrides);
        this.initAxisTicks(chartAxisThemeOverrides);
        this.initAxisLabels(chartAxisThemeOverrides);
        const updateAxisLabelRotations = ()=>this.axisLabelUpdateFuncs.forEach((func)=>func());
        this.addManagedListener(this.chartController, $5b7ccabde48fae90$var$ChartController.EVENT_CHART_UPDATED, updateAxisLabelRotations);
        this.addManagedListener(this.chartController, $5b7ccabde48fae90$var$ChartController.EVENT_CHART_MODEL_UPDATE, ()=>setTimeout(()=>{
                this.refreshAxisTypeSelect(chartAxisOptions);
                updateTimeFormatVisibility();
            }));
    }
    getAxisTypeSelectParams(chartAxisOptions, chartAxisAppliedThemeOverrides) {
        const chartOptions = chartAxisOptions.getChartOptions();
        const axisTypeSelectOptions = this.getAxisTypeSelectOptions();
        const params = chartAxisOptions.getDefaultSelectParams("type", "axisType", axisTypeSelectOptions);
        params.onValueChange = (value)=>{
            var _a;
            const previousAxisType = chartOptions.getValue("type");
            if (value === previousAxisType) return;
            const previousAxisThemeOverrides = chartAxisAppliedThemeOverrides.getValue("*");
            const previousAxisIsTimeAxis = previousAxisType === "time";
            const updatedAxisIsTimeAxis = value === "time";
            const updatedLabelFormat = previousAxisIsTimeAxis !== updatedAxisIsTimeAxis ? updatedAxisIsTimeAxis ? $5b7ccabde48fae90$var$DEFAULT_TIME_AXIS_FORMAT : void 0 : null;
            this.chartOptionsService.setCartesianCategoryAxisType(this.axisType, value);
            if (updatedLabelFormat !== null) {
                const existingLabel = (_a = chartOptions.getValue("label")) != null ? _a : {};
                chartOptions.setValue("label", $5b7ccabde48fae90$var$__spreadProps3($5b7ccabde48fae90$var$__spreadValues3({}, existingLabel), {
                    format: updatedLabelFormat
                }));
            }
            chartAxisAppliedThemeOverrides.setValue("*", previousAxisThemeOverrides);
        };
        return params;
    }
    refreshAxisTypeSelect(chartAxisOptions) {
        const options = this.getAxisTypeSelectOptions();
        const hasOptions = !!options.length;
        this.axisTypeSelect.setDisplayed(hasOptions);
        if (!hasOptions) return;
        this.axisTypeSelect.clearOptions().addOptions(options).setValue(chartAxisOptions.getChartOptions().getValue("type"));
    }
    getAxisTypeSelectOptions() {
        const chartType = this.chartController.getChartType();
        const supportsNumericalAxis = ()=>{
            const testDatum = this.chartController.getChartData()[0];
            if (!testDatum) return false;
            return this.chartController.getSelectedDimensions().every((col)=>!isNaN(parseFloat(testDatum[col.colId])));
        };
        if ([
            "heatmap",
            "histogram",
            "boxPlot",
            "rangeBar",
            "scatter",
            "bubble"
        ].includes(chartType) || this.chartController.isGrouping() || !this.isCategoryAxis() || this.chartController.isCategorySeriesSwitched() || !supportsNumericalAxis()) return [];
        return [
            "category",
            "number",
            "time"
        ].map((value)=>({
                value: value,
                text: this.translate(value)
            }));
    }
    isCategoryAxis() {
        const isHorizontal = this.chartOptionsSeriesProxy.getValue("direction") === "horizontal";
        return isHorizontal && this.axisType === "yAxis" || !isHorizontal && this.axisType === "xAxis";
    }
    getAxisPositionSelectParams(chartAxisOptions) {
        const axisPositionSelectOptions = ((chartType, axisType)=>{
            switch(chartType){
                case "heatmap":
                    return null;
                default:
                    switch(axisType){
                        case "xAxis":
                            return [
                                {
                                    value: "top",
                                    text: this.translate("top")
                                },
                                {
                                    value: "bottom",
                                    text: this.translate("bottom")
                                }
                            ];
                        case "yAxis":
                            return [
                                {
                                    value: "left",
                                    text: this.translate("left")
                                },
                                {
                                    value: "right",
                                    text: this.translate("right")
                                }
                            ];
                    }
            }
        })(this.chartController.getChartType(), this.axisType);
        if (!axisPositionSelectOptions) return null;
        return chartAxisOptions.getDefaultSelectParams("position", "position", axisPositionSelectOptions);
    }
    getAxisTimeFormatSelectParams(chartAxisOptions) {
        if (!this.isCategoryAxis()) return null;
        const axisTimeFormatSelectOptions = [
            {
                value: "%d/%m/%Y",
                text: this.translate("timeFormatSlashesDDMMYYYY")
            },
            {
                value: "%m/%d/%Y",
                text: this.translate("timeFormatSlashesMMDDYYYY")
            },
            {
                value: "%d/%m/%y",
                text: this.translate("timeFormatSlashesDDMMYY")
            },
            {
                value: "%m/%d/%y",
                text: this.translate("timeFormatSlashesMMDDYY")
            },
            {
                value: "%d.%e.%y",
                text: this.translate("timeFormatDotsDDMYY")
            },
            {
                value: "%e.%d.%y",
                text: this.translate("timeFormatDotsMDDYY")
            },
            {
                value: "%Y-%m-%d",
                text: this.translate("timeFormatDashesYYYYMMDD")
            },
            {
                value: "%d %B %Y",
                text: this.translate("timeFormatSpacesDDMMMMYYYY")
            },
            {
                value: "%H:%M:%S",
                text: this.translate("timeFormatHHMMSS")
            },
            {
                value: "%I:%M:%S %p",
                text: this.translate("timeFormatHHMMSSAmPm")
            }
        ];
        return chartAxisOptions.getDefaultSelectParams("label.format", "timeFormat", axisTimeFormatSelectOptions);
    }
    getAxisColorInputParams(chartAxisThemeOverrides) {
        return chartAxisThemeOverrides.getDefaultColorPickerParams("line.color");
    }
    getAxisLineWidthSliderParams(chartAxisThemeOverrides) {
        var _a;
        const chartOptions = chartAxisThemeOverrides.getChartOptions();
        const getAxisLineWidth = ()=>{
            const isAxisLineEnabled = chartOptions.getValue("line.enabled");
            if (!isAxisLineEnabled) return null;
            return chartOptions.getValue("line.width");
        };
        const setAxisLineWidth = (value)=>{
            chartOptions.setValues([
                {
                    expression: "line.enabled",
                    value: value != null
                },
                {
                    expression: "line.width",
                    value: value != null ? value : 0
                }
            ]);
        };
        const axisLineWidthSliderParams = chartAxisThemeOverrides.getDefaultSliderParamsWithoutValueParams((_a = getAxisLineWidth()) != null ? _a : 0, "thickness", 10);
        axisLineWidthSliderParams.onValueChange = (newValue)=>{
            setAxisLineWidth(newValue === 0 ? null : newValue);
        };
        return axisLineWidthSliderParams;
    }
    initGridLines(chartAxisThemeOverrides) {
        const chartType = this.chartController.getChartType();
        switch(chartType){
            case "heatmap":
                return;
            default:
                const gridLineComp = this.createBean(new $5b7ccabde48fae90$var$GridLinePanel(chartAxisThemeOverrides));
                this.axisGroup.addItem(gridLineComp);
                this.activePanels.push(gridLineComp);
        }
    }
    initAxisTicks(chartAxisThemeOverrides) {
        if (!this.hasConfigurableAxisTicks()) return;
        const axisTicksComp = this.createBean(new $5b7ccabde48fae90$var$AxisTicksPanel(chartAxisThemeOverrides));
        this.axisGroup.addItem(axisTicksComp);
        this.activePanels.push(axisTicksComp);
    }
    hasConfigurableAxisTicks() {
        const chartType = this.chartController.getChartType();
        switch(chartType){
            case "radarLine":
            case "radarArea":
            case "rangeBar":
            case "boxPlot":
            case "waterfall":
                return false;
            default:
                return true;
        }
    }
    initAxisLabels(chartAxisThemeOverrides) {
        const params = {
            name: this.translate("labels"),
            enabled: true,
            suppressEnabledCheckbox: true,
            chartMenuUtils: chartAxisThemeOverrides,
            keyMapper: (key)=>`label.${key}`
        };
        const labelPanelComp = this.createBean(new $5b7ccabde48fae90$var$FontPanel(params));
        this.axisGroup.addItem(labelPanelComp);
        this.activePanels.push(labelPanelComp);
        this.addAdditionalLabelComps(labelPanelComp, chartAxisThemeOverrides);
    }
    addAdditionalLabelComps(labelPanelComp, chartAxisThemeOverrides) {
        this.addLabelPadding(labelPanelComp, chartAxisThemeOverrides);
        const rotationComp = this.createRotationWidget("labelRotation", chartAxisThemeOverrides);
        const autoRotateCb = this.initLabelRotation(rotationComp, chartAxisThemeOverrides);
        labelPanelComp.addCompToPanel(autoRotateCb);
        labelPanelComp.addCompToPanel(rotationComp);
    }
    initLabelRotation(rotationComp, chartAxisThemeOverrides) {
        const chartOptions = chartAxisThemeOverrides.getChartOptions();
        const getLabelRotationValue = ()=>{
            return chartOptions.getValue("label.rotation");
        };
        const getLabelAutoRotateValue = ()=>{
            return chartOptions.getValue("label.autoRotate");
        };
        const updateAutoRotate = (autoRotate2)=>{
            if (autoRotate2) this.prevRotation = getLabelRotationValue();
            chartOptions.setValues([
                {
                    expression: "label.autoRotate",
                    value: autoRotate2
                },
                // Clear the rotation option when activating auto-rotate, reinstate the previous value when deactivating
                {
                    expression: "label.rotation",
                    value: autoRotate2 ? void 0 : this.prevRotation
                }
            ]);
            rotationComp.setDisabled(autoRotate2);
        };
        const rotation = getLabelRotationValue();
        const autoRotate = typeof rotation === "number" ? false : getLabelAutoRotateValue();
        const autoRotateCheckbox = this.createBean(new (0, $jIDNV.AgCheckbox)({
            label: this.translate("autoRotate"),
            value: autoRotate,
            onValueChange: updateAutoRotate
        }));
        rotationComp.setDisabled(autoRotate);
        return autoRotateCheckbox;
    }
    createRotationWidget(labelKey, chartAxisThemeOverrides) {
        var _a;
        const chartOptions = chartAxisThemeOverrides.getChartOptions();
        const getLabelRotationValue = ()=>{
            return chartOptions.getValue("label.rotation");
        };
        const setLabelRotationValue = (value)=>{
            return chartOptions.setValue("label.rotation", value);
        };
        const degreesSymbol = String.fromCharCode(176);
        const label = `${this.chartTranslationService.translate(labelKey)} ${degreesSymbol}`;
        const angleSelect = new $5b7ccabde48fae90$var$AgAngleSelect({
            label: label,
            labelWidth: "flex",
            value: (_a = getLabelRotationValue()) != null ? _a : 0,
            onValueChange: setLabelRotationValue
        });
        this.axisLabelUpdateFuncs.push(()=>{
            var _a2;
            angleSelect.setValue((_a2 = getLabelRotationValue()) != null ? _a2 : 0);
        });
        return this.createBean(angleSelect);
    }
    addLabelPadding(labelPanelComp, chartAxisThemeOverrides) {
        const labelPaddingSlider = this.createBean(new (0, $jIDNV.AgSlider)(chartAxisThemeOverrides.getDefaultSliderParams("label.padding", "padding", 30)));
        labelPanelComp.addCompToPanel(labelPaddingSlider);
    }
    translate(key) {
        return this.chartTranslationService.translate(key);
    }
    removeTemplateComponent(component) {
        (0, $jIDNV._).removeFromParent(component.getGui());
        this.destroyBean(component);
    }
    destroyActivePanels() {
        this.activePanels.forEach((panel)=>{
            (0, $jIDNV._).removeFromParent(panel.getGui());
            this.destroyBean(panel);
        });
    }
    destroy() {
        this.destroyActivePanels();
        super.destroy();
    }
};
$5b7ccabde48fae90$var$_CartesianAxisPanel.TEMPLATE = /* html */ `<div>
            <ag-group-component ref="axisGroup">
                <ag-select ref="axisTypeSelect"></ag-select>
                <ag-select ref="axisTimeFormatSelect"></ag-select>
                <ag-select ref="axisPositionSelect"></ag-select>
                <ag-color-picker ref="axisColorInput"></ag-color-picker>
                <ag-slider ref="axisLineWidthSlider"></ag-slider>
            </ag-group-component>
        </div>`;
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.RefSelector)("axisGroup")
], $5b7ccabde48fae90$var$_CartesianAxisPanel.prototype, "axisGroup", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.RefSelector)("axisTypeSelect")
], $5b7ccabde48fae90$var$_CartesianAxisPanel.prototype, "axisTypeSelect", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.RefSelector)("axisPositionSelect")
], $5b7ccabde48fae90$var$_CartesianAxisPanel.prototype, "axisPositionSelect", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.RefSelector)("axisTimeFormatSelect")
], $5b7ccabde48fae90$var$_CartesianAxisPanel.prototype, "axisTimeFormatSelect", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartTranslationService")
], $5b7ccabde48fae90$var$_CartesianAxisPanel.prototype, "chartTranslationService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_CartesianAxisPanel.prototype, "init", 1);
var $5b7ccabde48fae90$var$CartesianAxisPanel = $5b7ccabde48fae90$var$_CartesianAxisPanel;
var $5b7ccabde48fae90$var$_PolarAxisPanel = class _PolarAxisPanel2 extends (0, $jIDNV.Component) {
    constructor({ chartController: chartController, chartAxisMenuParamsFactory: chartAxisMenuUtils, isExpandedOnInit: isExpandedOnInit = false }){
        super();
        this.chartController = chartController;
        this.chartMenuUtils = chartAxisMenuUtils;
        this.isExpandedOnInit = isExpandedOnInit;
    }
    init() {
        const axisGroupParams = {
            cssIdentifier: "charts-format-top-level",
            direction: "vertical",
            title: this.translate("polarAxis"),
            expanded: this.isExpandedOnInit,
            suppressEnabledCheckbox: true
        };
        const axisColorInputParams = this.chartMenuUtils.getDefaultColorPickerParams("line.color");
        const axisLineWidthSliderParams = this.chartMenuUtils.getDefaultSliderParams("line.width", "thickness", 10);
        this.setTemplate(_PolarAxisPanel2.TEMPLATE, {
            axisGroup: axisGroupParams,
            axisColorInput: axisColorInputParams,
            axisLineWidthSlider: axisLineWidthSliderParams
        });
        this.initAxis();
        this.initAxisLabels();
        this.initRadiusAxis();
    }
    initAxis() {
        const chartType = this.chartController.getChartType();
        const hasConfigurableAxisShape = [
            "radarLine",
            "radarArea"
        ].includes(chartType);
        if (hasConfigurableAxisShape) {
            const options = [
                {
                    value: "circle",
                    text: this.translate("circle")
                },
                {
                    value: "polygon",
                    text: this.translate("polygon")
                }
            ];
            this.axisGroup.addItem(this.createSelect({
                labelKey: "shape",
                options: options,
                property: "shape"
            }));
        }
        if (chartType !== "pie") this.axisGroup.addItem(this.createSlider({
            labelKey: "innerRadius",
            defaultMaxValue: 1,
            property: "innerRadiusRatio"
        }));
    }
    initAxisLabels() {
        const params = {
            name: this.translate("labels"),
            enabled: true,
            suppressEnabledCheckbox: true,
            chartMenuUtils: this.chartMenuUtils,
            keyMapper: (key)=>`label.${key}`
        };
        const labelPanelComp = this.createManagedBean(new $5b7ccabde48fae90$var$FontPanel(params));
        const labelOrientationComp = this.createOrientationWidget();
        labelPanelComp.addItemToPanel(labelOrientationComp);
        this.axisGroup.addItem(labelPanelComp);
    }
    createOrientationWidget() {
        const options = [
            {
                value: "fixed",
                text: this.translate("fixed")
            },
            {
                value: "parallel",
                text: this.translate("parallel")
            },
            {
                value: "perpendicular",
                text: this.translate("perpendicular")
            }
        ];
        return this.createSelect({
            labelKey: "orientation",
            options: options,
            property: "label.orientation"
        });
    }
    initRadiusAxis() {
        const chartSeriesType = $5b7ccabde48fae90$var$getSeriesType(this.chartController.getChartType());
        if (!$5b7ccabde48fae90$var$isRadial(chartSeriesType)) return;
        const items = [
            this.createSlider({
                labelKey: "groupPadding",
                defaultMaxValue: 1,
                property: "paddingInner"
            }),
            this.createSlider({
                labelKey: "seriesPadding",
                defaultMaxValue: 1,
                property: "groupPaddingInner"
            })
        ];
        const paddingPanelComp = this.createManagedBean(new (0, $jIDNV.AgGroupComponent)({
            cssIdentifier: "charts-format-sub-level",
            direction: "vertical",
            suppressOpenCloseIcons: true,
            enabled: true,
            suppressEnabledCheckbox: true,
            title: this.translate("padding"),
            items: items
        })).hideEnabledCheckbox(true).hideOpenCloseIcons(true);
        this.axisGroup.addItem(paddingPanelComp);
    }
    createSlider(config) {
        const { labelKey: labelKey, defaultMaxValue: defaultMaxValue, step: step = 0.05, property: property } = config;
        const params = this.chartMenuUtils.getDefaultSliderParams(property, labelKey, defaultMaxValue);
        params.step = step;
        return this.createManagedBean(new (0, $jIDNV.AgSlider)(params));
    }
    createSelect(config) {
        const { labelKey: label, options: options, property: property } = config;
        return this.createManagedBean(new (0, $jIDNV.AgSelect)(this.chartMenuUtils.addValueParams(property, {
            label: this.chartTranslationService.translate(label),
            labelAlignment: "left",
            labelWidth: "flex",
            inputWidth: "flex",
            options: options
        })));
    }
    translate(key) {
        return this.chartTranslationService.translate(key);
    }
};
$5b7ccabde48fae90$var$_PolarAxisPanel.TEMPLATE = /* html */ `<div>
            <ag-group-component ref="axisGroup">
                <ag-color-picker ref="axisColorInput"></ag-color-picker>
                <ag-slider ref="axisLineWidthSlider"></ag-slider>
            </ag-group-component>
        </div>`;
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.RefSelector)("axisGroup")
], $5b7ccabde48fae90$var$_PolarAxisPanel.prototype, "axisGroup", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartTranslationService")
], $5b7ccabde48fae90$var$_PolarAxisPanel.prototype, "chartTranslationService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_PolarAxisPanel.prototype, "init", 1);
var $5b7ccabde48fae90$var$PolarAxisPanel = $5b7ccabde48fae90$var$_PolarAxisPanel;
var $5b7ccabde48fae90$var$_PaddingPanel = class _PaddingPanel2 extends (0, $jIDNV.Component) {
    constructor(chartMenuUtils, chartController){
        super();
        this.chartMenuUtils = chartMenuUtils;
        this.chartController = chartController;
    }
    init() {
        const chartPaddingGroupParams = {
            cssIdentifier: "charts-format-sub-level",
            direction: "vertical",
            suppressOpenCloseIcons: true,
            title: this.chartTranslationService.translate("padding"),
            suppressEnabledCheckbox: true
        };
        const getSliderParams = (property)=>this.chartMenuUtils.getDefaultSliderParams("padding." + property, property, 200);
        this.setTemplate(_PaddingPanel2.TEMPLATE, {
            chartPaddingGroup: chartPaddingGroupParams,
            paddingTopSlider: getSliderParams("top"),
            paddingRightSlider: getSliderParams("right"),
            paddingBottomSlider: getSliderParams("bottom"),
            paddingLeftSlider: getSliderParams("left")
        });
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_CHART_OPTIONS_CHANGED, (e)=>{
            this.updateTopPadding(e.chartOptions);
        });
    }
    updateTopPadding(chartOptions) {
        const topPadding = [
            ...this.chartController.getChartSeriesTypes(),
            "common"
        ].map((seriesType)=>{
            var _a, _b;
            return (_b = (_a = chartOptions[seriesType]) == null ? void 0 : _a.padding) == null ? void 0 : _b.top;
        }).find((value)=>value != null);
        if (topPadding != null) this.paddingTopSlider.setValue(`${topPadding}`);
    }
};
$5b7ccabde48fae90$var$_PaddingPanel.TEMPLATE = /* html */ `<div>
            <ag-group-component ref="chartPaddingGroup">
                <ag-slider ref="paddingTopSlider"></ag-slider>
                <ag-slider ref="paddingRightSlider"></ag-slider>
                <ag-slider ref="paddingBottomSlider"></ag-slider>
                <ag-slider ref="paddingLeftSlider"></ag-slider>
            </ag-group-component>
        <div>`;
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.RefSelector)("paddingTopSlider")
], $5b7ccabde48fae90$var$_PaddingPanel.prototype, "paddingTopSlider", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartTranslationService")
], $5b7ccabde48fae90$var$_PaddingPanel.prototype, "chartTranslationService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_PaddingPanel.prototype, "init", 1);
var $5b7ccabde48fae90$var$PaddingPanel = $5b7ccabde48fae90$var$_PaddingPanel;
var $5b7ccabde48fae90$var$_BackgroundPanel = class _BackgroundPanel2 extends (0, $jIDNV.Component) {
    constructor(chartMenuUtils){
        super();
        this.chartMenuUtils = chartMenuUtils;
    }
    init() {
        const chartBackgroundGroupParams = this.chartMenuUtils.addEnableParams("background.visible", {
            cssIdentifier: "charts-format-sub-level",
            direction: "vertical",
            suppressOpenCloseIcons: true,
            title: this.chartTranslationService.translate("background"),
            suppressEnabledCheckbox: false
        });
        const colorPickerParams = this.chartMenuUtils.getDefaultColorPickerParams("background.fill");
        this.setTemplate(_BackgroundPanel2.TEMPLATE, {
            chartBackgroundGroup: chartBackgroundGroupParams,
            colorPicker: colorPickerParams
        });
    }
};
$5b7ccabde48fae90$var$_BackgroundPanel.TEMPLATE = /* html */ `<div>
            <ag-group-component ref="chartBackgroundGroup">
                <ag-color-picker ref="colorPicker"></ag-color-picker>
            </ag-group-component>
        <div>`;
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartTranslationService")
], $5b7ccabde48fae90$var$_BackgroundPanel.prototype, "chartTranslationService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_BackgroundPanel.prototype, "init", 1);
var $5b7ccabde48fae90$var$BackgroundPanel = $5b7ccabde48fae90$var$_BackgroundPanel;
var $5b7ccabde48fae90$var$_TitlePanel = class _TitlePanel2 extends (0, $jIDNV.Component) {
    constructor(chartMenuUtils, chartController){
        super(_TitlePanel2.TEMPLATE);
        this.chartMenuUtils = chartMenuUtils;
        this.chartController = chartController;
        this.activePanels = [];
        this.chartOptions = chartMenuUtils.getChartOptions();
    }
    init() {
        this.initFontPanel();
        this.titlePlaceholder = this.chartTranslationService.translate("titlePlaceholder");
    }
    hasTitle() {
        const title = this.chartOptions.getValue("title");
        return title && title.enabled && title.text && title.text.length > 0;
    }
    initFontPanel() {
        const hasTitle = this.hasTitle();
        const fontPanelParams = {
            name: this.chartTranslationService.translate("title"),
            enabled: hasTitle,
            suppressEnabledCheckbox: false,
            chartMenuUtils: this.chartMenuUtils,
            keyMapper: (key)=>`title.${key}`,
            onEnableChange: (enabled)=>{
                if (this.chartMenuService.doesChartToolbarExist(this.chartController)) {
                    const topPadding = this.chartOptions.getValue("padding.top");
                    this.chartOptions.setValue("padding.top", enabled ? topPadding - 20 : topPadding + 20);
                }
                this.chartOptions.setValue("title.enabled", enabled);
                const currentTitleText = this.chartOptions.getValue("title.text");
                const replaceableTitleText = currentTitleText === "Title" || (currentTitleText == null ? void 0 : currentTitleText.trim().length) === 0;
                if (enabled && replaceableTitleText) this.chartOptions.setValue("title.text", this.titlePlaceholder);
            }
        };
        const fontPanelComp = this.createBean(new $5b7ccabde48fae90$var$FontPanel(fontPanelParams));
        fontPanelComp.addItemToPanel(this.createSpacingSlicer());
        this.getGui().appendChild(fontPanelComp.getGui());
        this.activePanels.push(fontPanelComp);
        this.addManagedListener(this.eventService, "chartTitleEdit", ()=>{
            fontPanelComp.setEnabled(this.hasTitle());
        });
    }
    createSpacingSlicer() {
        const params = this.chartMenuUtils.getDefaultSliderParams("title.spacing", "spacing", 100);
        params.value = "10";
        return this.createBean(new (0, $jIDNV.AgSlider)(params));
    }
    destroyActivePanels() {
        this.activePanels.forEach((panel)=>{
            (0, $jIDNV._).removeFromParent(panel.getGui());
            this.destroyBean(panel);
        });
    }
    destroy() {
        this.destroyActivePanels();
        super.destroy();
    }
};
$5b7ccabde48fae90$var$_TitlePanel.TEMPLATE = /* html */ `<div></div>`;
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartTranslationService")
], $5b7ccabde48fae90$var$_TitlePanel.prototype, "chartTranslationService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartMenuService")
], $5b7ccabde48fae90$var$_TitlePanel.prototype, "chartMenuService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_TitlePanel.prototype, "init", 1);
var $5b7ccabde48fae90$var$TitlePanel = $5b7ccabde48fae90$var$_TitlePanel;
var $5b7ccabde48fae90$var$_ChartPanel = class _ChartPanel2 extends (0, $jIDNV.Component) {
    constructor({ chartController: chartController, chartMenuParamsFactory: chartMenuParamsFactory, isExpandedOnInit: isExpandedOnInit = false, chartOptionsService: chartOptionsService, seriesType: seriesType }){
        super();
        this.chartController = chartController;
        this.chartMenuParamsFactory = chartMenuParamsFactory;
        this.chartOptionsSeriesProxy = chartOptionsService.getSeriesOptionsProxy(()=>seriesType != null ? seriesType : this.chartController.getChartSeriesType());
        this.isExpandedOnInit = isExpandedOnInit;
    }
    init() {
        this.chartSeriesMenuParamsFactory = this.createManagedBean(new $5b7ccabde48fae90$var$ChartMenuParamsFactory(this.chartOptionsSeriesProxy));
        const chartGroupParams = {
            cssIdentifier: "charts-format-top-level",
            direction: "vertical",
            title: this.chartTranslationService.translate("chart"),
            expanded: this.isExpandedOnInit,
            suppressEnabledCheckbox: true,
            items: [
                this.createManagedBean(new $5b7ccabde48fae90$var$TitlePanel(this.chartMenuParamsFactory, this.chartController)),
                this.createManagedBean(new $5b7ccabde48fae90$var$PaddingPanel(this.chartMenuParamsFactory, this.chartController)),
                this.createManagedBean(new $5b7ccabde48fae90$var$BackgroundPanel(this.chartMenuParamsFactory)),
                ...this.createDirectionSelect()
            ]
        };
        this.setTemplate(_ChartPanel2.TEMPLATE, {
            chartGroup: chartGroupParams
        });
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_CHART_OPTIONS_CHANGED, ()=>this.refresh());
    }
    refresh() {
        this.updateDirectionSelect();
    }
    createDirectionSelect() {
        const enabled = !this.chartMenuService.isLegacyFormat();
        if (!enabled) return [];
        const options = [
            "horizontal",
            "vertical"
        ].map((value)=>({
                value: value,
                text: this.chartTranslationService.translate(value)
            }));
        const params = this.chartSeriesMenuParamsFactory.getDefaultSelectParams("direction", "direction", options);
        params.labelWidth = "flex";
        params.inputWidth = "flex";
        const onValueChange = params.onValueChange;
        params.onValueChange = (value)=>{
            onValueChange(value);
            this.chartController.raiseChartModelUpdateEvent();
        };
        this.directionSelect = this.createManagedBean(new (0, $jIDNV.AgSelect)(params));
        this.updateDirectionSelect();
        return [
            this.directionSelect
        ];
    }
    updateDirectionSelect() {
        var _a;
        (_a = this.directionSelect) == null || _a.setDisplayed($5b7ccabde48fae90$var$canSwitchDirection(this.chartController.getChartType()));
    }
};
$5b7ccabde48fae90$var$_ChartPanel.TEMPLATE = /* html */ `<div>
            <ag-group-component ref="chartGroup"></ag-group-component>
        </div>`;
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartTranslationService")
], $5b7ccabde48fae90$var$_ChartPanel.prototype, "chartTranslationService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartMenuService")
], $5b7ccabde48fae90$var$_ChartPanel.prototype, "chartMenuService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_ChartPanel.prototype, "init", 1);
var $5b7ccabde48fae90$var$ChartPanel = $5b7ccabde48fae90$var$_ChartPanel;
var $5b7ccabde48fae90$var$_ShadowPanel = class _ShadowPanel2 extends (0, $jIDNV.Component) {
    constructor(chartMenuUtils, propertyKey = "shadow"){
        super();
        this.chartMenuUtils = chartMenuUtils;
        this.propertyKey = propertyKey;
    }
    init() {
        const propertyNamespace = this.propertyKey;
        const shadowGroupParams = this.chartMenuUtils.addEnableParams(`${propertyNamespace}.enabled`, {
            cssIdentifier: "charts-format-sub-level",
            direction: "vertical",
            suppressOpenCloseIcons: true,
            title: this.chartTranslationService.translate("shadow"),
            suppressEnabledCheckbox: false
        });
        const shadowColorPickerParams = this.chartMenuUtils.getDefaultColorPickerParams(`${propertyNamespace}.color`);
        this.setTemplate(_ShadowPanel2.TEMPLATE, {
            shadowGroup: shadowGroupParams,
            shadowColorPicker: shadowColorPickerParams,
            shadowBlurSlider: this.getSliderParams("blur", 0, 20),
            shadowXOffsetSlider: this.getSliderParams("xOffset", -10, 10),
            shadowYOffsetSlider: this.getSliderParams("yOffset", -10, 10)
        });
    }
    getSliderParams(property, minValue, defaultMaxValue) {
        const expression = `${this.propertyKey}.${property}`;
        const params = this.chartMenuUtils.getDefaultSliderParams(expression, property, defaultMaxValue);
        params.minValue = minValue;
        return params;
    }
};
$5b7ccabde48fae90$var$_ShadowPanel.TEMPLATE = /* html */ `<div>
            <ag-group-component ref="shadowGroup">
                <ag-color-picker ref="shadowColorPicker"></ag-color-picker>
                <ag-slider ref="shadowBlurSlider"></ag-slider>
                <ag-slider ref="shadowXOffsetSlider"></ag-slider>
                <ag-slider ref="shadowYOffsetSlider"></ag-slider>
            </ag-group-component>
        </div>`;
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartTranslationService")
], $5b7ccabde48fae90$var$_ShadowPanel.prototype, "chartTranslationService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_ShadowPanel.prototype, "init", 1);
var $5b7ccabde48fae90$var$ShadowPanel = $5b7ccabde48fae90$var$_ShadowPanel;
var $5b7ccabde48fae90$var$_MarkersPanel = class _MarkersPanel2 extends (0, $jIDNV.Component) {
    constructor(chartOptionsService, chartMenuUtils){
        super();
        this.chartOptionsService = chartOptionsService;
        this.chartMenuUtils = chartMenuUtils;
    }
    init() {
        const chartType = this.chartOptionsService.getChartType();
        const shouldHideEnabledCheckbox = (0, $jIDNV._).includes([
            "scatter",
            "bubble"
        ], chartType);
        const seriesMarkersGroupParams = this.chartMenuUtils.addEnableParams("marker.enabled", {
            cssIdentifier: "charts-format-sub-level",
            direction: "vertical",
            title: this.chartTranslationService.translate("markers"),
            suppressEnabledCheckbox: shouldHideEnabledCheckbox,
            suppressOpenCloseIcons: true
        });
        const isBubble = chartType === "bubble";
        let seriesMarkerMinSizeSliderParams;
        let seriesMarkerSizeSliderParams;
        if (isBubble) {
            seriesMarkerMinSizeSliderParams = this.getSliderParams("marker.maxSize", "maxSize", 60);
            seriesMarkerSizeSliderParams = this.getSliderParams("marker.size", "minSize", 60);
        } else {
            seriesMarkerMinSizeSliderParams = {};
            seriesMarkerSizeSliderParams = this.getSliderParams("marker.size", "size", 60);
        }
        this.setTemplate(_MarkersPanel2.TEMPLATE, {
            seriesMarkersGroup: seriesMarkersGroupParams,
            seriesMarkerShapeSelect: this.getMarkerShapeSelectParams(),
            seriesMarkerMinSizeSlider: seriesMarkerMinSizeSliderParams,
            seriesMarkerSizeSlider: seriesMarkerSizeSliderParams,
            seriesMarkerStrokeWidthSlider: this.getSliderParams("marker.strokeWidth", "strokeWidth", 10)
        });
        if (!isBubble) this.seriesMarkerMinSizeSlider.setDisplayed(false);
    }
    getMarkerShapeSelectParams() {
        const options = [
            {
                value: "square",
                text: "Square"
            },
            {
                value: "circle",
                text: "Circle"
            },
            {
                value: "cross",
                text: "Cross"
            },
            {
                value: "diamond",
                text: "Diamond"
            },
            {
                value: "plus",
                text: "Plus"
            },
            {
                value: "triangle",
                text: "Triangle"
            },
            {
                value: "heart",
                text: "Heart"
            }
        ];
        return this.chartMenuUtils.addValueParams("marker.shape", {
            options: options,
            label: this.chartTranslationService.translate("shape")
        });
    }
    getSliderParams(expression, labelKey, defaultMaxValue) {
        return this.chartMenuUtils.getDefaultSliderParams(expression, labelKey, defaultMaxValue);
    }
};
$5b7ccabde48fae90$var$_MarkersPanel.TEMPLATE = /* html */ `<div>
            <ag-group-component ref="seriesMarkersGroup">
                <ag-select ref="seriesMarkerShapeSelect"></ag-select>
                <ag-slider ref="seriesMarkerMinSizeSlider"></ag-slider>
                <ag-slider ref="seriesMarkerSizeSlider"></ag-slider>
                <ag-slider ref="seriesMarkerStrokeWidthSlider"></ag-slider>
            </ag-group-component>
        </div>`;
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.RefSelector)("seriesMarkerMinSizeSlider")
], $5b7ccabde48fae90$var$_MarkersPanel.prototype, "seriesMarkerMinSizeSlider", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartTranslationService")
], $5b7ccabde48fae90$var$_MarkersPanel.prototype, "chartTranslationService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_MarkersPanel.prototype, "init", 1);
var $5b7ccabde48fae90$var$MarkersPanel = $5b7ccabde48fae90$var$_MarkersPanel;
var $5b7ccabde48fae90$var$_AgColorPanel = class _AgColorPanel2 extends (0, $jIDNV.Component) {
    constructor(config){
        super(_AgColorPanel2.TEMPLATE);
        this.H = 1;
        this.S = 1;
        this.B = 1;
        this.A = 1;
        this.isSpectrumDragging = false;
        this.isSpectrumHueDragging = false;
        this.isSpectrumAlphaDragging = false;
        this.colorChanged = false;
        this.picker = config.picker;
    }
    postConstruct() {
        this.initTabIndex();
        this.initRecentColors();
        this.addGuiEventListener("focus", ()=>this.spectrumColor.focus());
        this.addGuiEventListener("keydown", (e)=>{
            if (e.key === (0, $jIDNV.KeyCode).ENTER && !e.defaultPrevented) this.destroy();
        });
        this.addManagedListener(this.spectrumColor, "keydown", (e)=>this.moveDragger(e));
        this.addManagedListener(this.spectrumAlphaSlider, "keydown", (e)=>this.moveAlphaSlider(e));
        this.addManagedListener(this.spectrumHueSlider, "keydown", (e)=>this.moveHueSlider(e));
        this.addManagedListener(this.spectrumVal, "mousedown", this.onSpectrumDraggerDown.bind(this));
        this.addManagedListener(this.spectrumHue, "mousedown", this.onSpectrumHueDown.bind(this));
        this.addManagedListener(this.spectrumAlpha, "mousedown", this.onSpectrumAlphaDown.bind(this));
        this.addGuiEventListener("mousemove", (e)=>{
            this.onSpectrumDraggerMove(e);
            this.onSpectrumHueMove(e);
            this.onSpectrumAlphaMove(e);
        });
        this.addManagedListener(document, "mouseup", this.onMouseUp.bind(this));
        this.addManagedListener(this.recentColors, "click", this.onRecentColorClick.bind(this));
        this.addManagedListener(this.recentColors, "keydown", (e)=>{
            if (e.key === (0, $jIDNV.KeyCode).ENTER || e.key === (0, $jIDNV.KeyCode).SPACE) {
                e.preventDefault();
                this.onRecentColorClick(e);
            }
        });
    }
    initTabIndex() {
        const tabIndex = this.tabIndex = this.gos.get("tabIndex").toString();
        this.spectrumColor.setAttribute("tabindex", tabIndex);
        this.spectrumHueSlider.setAttribute("tabindex", tabIndex);
        this.spectrumAlphaSlider.setAttribute("tabindex", tabIndex);
    }
    refreshSpectrumRect() {
        return this.spectrumValRect = this.spectrumVal.getBoundingClientRect();
    }
    refreshHueRect() {
        return this.spectrumHueRect = this.spectrumHue.getBoundingClientRect();
    }
    refreshAlphaRect() {
        return this.spectrumAlphaRect = this.spectrumAlpha.getBoundingClientRect();
    }
    onSpectrumDraggerDown(e) {
        this.refreshSpectrumRect();
        this.isSpectrumDragging = true;
        this.moveDragger(e);
    }
    onSpectrumDraggerMove(e) {
        if (this.isSpectrumDragging) this.moveDragger(e);
    }
    onSpectrumHueDown(e) {
        this.refreshHueRect();
        this.isSpectrumHueDragging = true;
        this.moveHueSlider(e);
    }
    onSpectrumHueMove(e) {
        if (this.isSpectrumHueDragging) this.moveHueSlider(e);
    }
    onSpectrumAlphaDown(e) {
        this.refreshAlphaRect();
        this.isSpectrumAlphaDragging = true;
        this.moveAlphaSlider(e);
    }
    onSpectrumAlphaMove(e) {
        if (this.isSpectrumAlphaDragging) this.moveAlphaSlider(e);
    }
    onMouseUp() {
        this.isSpectrumDragging = false;
        this.isSpectrumHueDragging = false;
        this.isSpectrumAlphaDragging = false;
    }
    moveDragger(e) {
        const valRect = this.spectrumValRect;
        if (!valRect) return;
        let x;
        let y;
        if (e instanceof MouseEvent) {
            x = e.clientX - valRect.left;
            y = e.clientY - valRect.top;
        } else {
            const isLeft = e.key === (0, $jIDNV.KeyCode).LEFT;
            const isRight = e.key === (0, $jIDNV.KeyCode).RIGHT;
            const isUp = e.key === (0, $jIDNV.KeyCode).UP;
            const isDown = e.key === (0, $jIDNV.KeyCode).DOWN;
            const isVertical = isUp || isDown;
            const isHorizontal = isLeft || isRight;
            if (!isVertical && !isHorizontal) return;
            e.preventDefault();
            const { x: currentX, y: currentY } = this.getSpectrumValue();
            x = currentX + (isHorizontal ? isLeft ? -5 : 5 : 0);
            y = currentY + (isVertical ? isUp ? -5 : 5 : 0);
        }
        x = Math.max(x, 0);
        x = Math.min(x, valRect.width);
        y = Math.max(y, 0);
        y = Math.min(y, valRect.height);
        this.setSpectrumValue(x / valRect.width, 1 - y / valRect.height);
    }
    moveHueSlider(e) {
        const rect = this.spectrumHueRect;
        if (!rect) return;
        const x = this.moveSlider(this.spectrumHueSlider, e);
        if (x == null) return;
        this.H = 1 - x / rect.width;
        this.update();
    }
    moveAlphaSlider(e) {
        const rect = this.spectrumAlphaRect;
        if (!rect) return;
        const x = this.moveSlider(this.spectrumAlphaSlider, e);
        if (x == null) return;
        this.A = x / rect.width;
        this.update();
    }
    moveSlider(slider, e) {
        var _a;
        const sliderRect = slider.getBoundingClientRect();
        const parentRect = (_a = slider.parentElement) == null ? void 0 : _a.getBoundingClientRect();
        if (!slider || !parentRect) return null;
        let x;
        if (e instanceof MouseEvent) x = e.clientX - parentRect.left;
        else {
            const isLeft = e.key === (0, $jIDNV.KeyCode).LEFT;
            const isRight = e.key === (0, $jIDNV.KeyCode).RIGHT;
            if (!isLeft && !isRight) return null;
            e.preventDefault();
            const diff = isLeft ? -5 : 5;
            x = parseFloat(slider.style.left) - sliderRect.width / 2 + diff;
        }
        x = Math.max(x, 0);
        x = Math.min(x, parentRect.width);
        slider.style.left = x + sliderRect.width / 2 + "px";
        return x;
    }
    update() {
        const color = (0, $iTJTu._Util).Color.fromHSB(this.H * 360, this.S, this.B, this.A);
        const spectrumColor = (0, $iTJTu._Util).Color.fromHSB(this.H * 360, 1, 1);
        const rgbaColor = color.toRgbaString();
        const colorPicker = this.picker;
        const existingColor = (0, $iTJTu._Util).Color.fromString(colorPicker.getValue());
        if (existingColor.toRgbaString() !== rgbaColor) this.colorChanged = true;
        colorPicker.setValue(rgbaColor);
        this.spectrumColor.style.backgroundColor = spectrumColor.toRgbaString();
        this.spectrumDragger.style.backgroundColor = rgbaColor;
    }
    /**
   * @param saturation In the [0, 1] interval.
   * @param brightness In the [0, 1] interval.
   */ setSpectrumValue(saturation, brightness) {
        const valRect = this.spectrumValRect || this.refreshSpectrumRect();
        if (valRect == null) return;
        const dragger = this.spectrumDragger;
        const draggerRect = dragger.getBoundingClientRect();
        saturation = Math.max(0, saturation);
        saturation = Math.min(1, saturation);
        brightness = Math.max(0, brightness);
        brightness = Math.min(1, brightness);
        this.S = saturation;
        this.B = brightness;
        dragger.style.left = saturation * valRect.width - draggerRect.width / 2 + "px";
        dragger.style.top = (1 - brightness) * valRect.height - draggerRect.height / 2 + "px";
        this.update();
    }
    getSpectrumValue() {
        const dragger = this.spectrumDragger;
        const draggerRect = dragger.getBoundingClientRect();
        const x = parseFloat(dragger.style.left) + draggerRect.width / 2;
        const y = parseFloat(dragger.style.top) + draggerRect.height / 2;
        return {
            x: x,
            y: y
        };
    }
    initRecentColors() {
        const recentColors = _AgColorPanel2.recentColors;
        const innerHtml = recentColors.map((color, index)=>{
            return /* html */ `<div class="ag-recent-color" id=${index} style="background-color: ${color}; width: 15px; height: 15px;" recent-color="${color}" tabIndex="${this.tabIndex}"></div>`;
        });
        this.recentColors.innerHTML = innerHtml.join("");
    }
    setValue(val) {
        const color = (0, $iTJTu._Util).Color.fromString(val);
        const [h, s, b] = color.toHSB();
        this.H = (isNaN(h) ? 0 : h) / 360;
        this.A = color.a;
        const spectrumHueRect = this.spectrumHueRect || this.refreshHueRect();
        const spectrumAlphaRect = this.spectrumAlphaRect || this.refreshAlphaRect();
        this.spectrumHueSlider.style.left = `${(this.H - 1) * -spectrumHueRect.width}px`;
        this.spectrumAlphaSlider.style.left = `${this.A * spectrumAlphaRect.width}px`;
        this.setSpectrumValue(s, b);
    }
    onRecentColorClick(e) {
        const target = e.target;
        if (!(0, $jIDNV._).exists(target.id)) return;
        const id = parseInt(target.id, 10);
        this.setValue(_AgColorPanel2.recentColors[id]);
        this.destroy();
    }
    addRecentColor() {
        const color = (0, $iTJTu._Util).Color.fromHSB(this.H * 360, this.S, this.B, this.A);
        const rgbaColor = color.toRgbaString();
        let recentColors = _AgColorPanel2.recentColors;
        if (!this.colorChanged || recentColors[0] === rgbaColor) return;
        recentColors = recentColors.filter((currentColor)=>currentColor != rgbaColor);
        recentColors = [
            rgbaColor
        ].concat(recentColors);
        if (recentColors.length > _AgColorPanel2.maxRecentColors) recentColors = recentColors.slice(0, _AgColorPanel2.maxRecentColors);
        _AgColorPanel2.recentColors = recentColors;
    }
    destroy() {
        this.addRecentColor();
        super.destroy();
    }
};
$5b7ccabde48fae90$var$_AgColorPanel.maxRecentColors = 8;
$5b7ccabde48fae90$var$_AgColorPanel.recentColors = [];
$5b7ccabde48fae90$var$_AgColorPanel.TEMPLATE = /* html */ `<div class="ag-color-panel" tabindex="-1">
            <div ref="spectrumColor" class="ag-spectrum-color">
                <div class="ag-spectrum-sat ag-spectrum-fill">
                    <div ref="spectrumVal" class="ag-spectrum-val ag-spectrum-fill">
                        <div ref="spectrumDragger" class="ag-spectrum-dragger"></div>
                    </div>
                </div>
            </div>
            <div class="ag-spectrum-tools">
                <div ref="spectrumHue" class="ag-spectrum-hue ag-spectrum-tool">
                    <div class="ag-spectrum-hue-background"></div>
                    <div ref="spectrumHueSlider" class="ag-spectrum-slider"></div>
                </div>
                <div ref="spectrumAlpha" class="ag-spectrum-alpha ag-spectrum-tool">
                    <div class="ag-spectrum-alpha-background"></div>
                    <div ref="spectrumAlphaSlider" class="ag-spectrum-slider"></div>
                </div>
                <div ref="recentColors" class="ag-recent-colors"></div>
            </div>
        </div>`;
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.RefSelector)("spectrumColor")
], $5b7ccabde48fae90$var$_AgColorPanel.prototype, "spectrumColor", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.RefSelector)("spectrumVal")
], $5b7ccabde48fae90$var$_AgColorPanel.prototype, "spectrumVal", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.RefSelector)("spectrumDragger")
], $5b7ccabde48fae90$var$_AgColorPanel.prototype, "spectrumDragger", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.RefSelector)("spectrumHue")
], $5b7ccabde48fae90$var$_AgColorPanel.prototype, "spectrumHue", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.RefSelector)("spectrumHueSlider")
], $5b7ccabde48fae90$var$_AgColorPanel.prototype, "spectrumHueSlider", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.RefSelector)("spectrumAlpha")
], $5b7ccabde48fae90$var$_AgColorPanel.prototype, "spectrumAlpha", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.RefSelector)("spectrumAlphaSlider")
], $5b7ccabde48fae90$var$_AgColorPanel.prototype, "spectrumAlphaSlider", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.RefSelector)("recentColors")
], $5b7ccabde48fae90$var$_AgColorPanel.prototype, "recentColors", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_AgColorPanel.prototype, "postConstruct", 1);
var $5b7ccabde48fae90$var$AgColorPanel = $5b7ccabde48fae90$var$_AgColorPanel;
var $5b7ccabde48fae90$var$AgColorPicker = class extends (0, $jIDNV.AgPickerField) {
    constructor(config){
        super($5b7ccabde48fae90$var$__spreadValues3({
            pickerAriaLabelKey: "ariaLabelColorPicker",
            pickerAriaLabelValue: "Color Picker",
            pickerType: "ag-list",
            className: "ag-color-picker",
            pickerIcon: "colorPicker"
        }, config));
    }
    postConstruct() {
        super.postConstruct();
        if (this.value) this.setValue(this.value);
    }
    createPickerComponent() {
        const eGuiRect = this.getGui().getBoundingClientRect();
        const colorDialog = this.createBean(new (0, $jIDNV.AgDialog)({
            closable: false,
            modal: true,
            hideTitleBar: true,
            minWidth: 190,
            width: 190,
            height: 250,
            x: eGuiRect.right - 190,
            y: eGuiRect.top - 250
        }));
        return colorDialog;
    }
    renderAndPositionPicker() {
        const pickerComponent = this.pickerComponent;
        const colorPanel = this.createBean(new $5b7ccabde48fae90$var$AgColorPanel({
            picker: this
        }));
        pickerComponent.addCssClass("ag-color-dialog");
        colorPanel.addDestroyFunc(()=>{
            if (pickerComponent.isAlive()) this.destroyBean(pickerComponent);
        });
        pickerComponent.setParentComponent(this);
        pickerComponent.setBodyComponent(colorPanel);
        colorPanel.setValue(this.getValue());
        colorPanel.getGui().focus();
        pickerComponent.addDestroyFunc(()=>{
            if (!this.isDestroyingPicker) {
                this.beforeHidePicker();
                this.isDestroyingPicker = true;
                if (colorPanel.isAlive()) this.destroyBean(colorPanel);
                if (this.isAlive()) this.getFocusableElement().focus();
            } else this.isDestroyingPicker = false;
        });
        return ()=>{
            var _a;
            return (_a = this.pickerComponent) == null ? void 0 : _a.close();
        };
    }
    setValue(color) {
        if (this.value === color) return this;
        this.eDisplayField.style.backgroundColor = color;
        return super.setValue(color);
    }
    getValue() {
        return this.value;
    }
};
var $5b7ccabde48fae90$var$_CalloutPanel = class _CalloutPanel2 extends (0, $jIDNV.Component) {
    constructor(chartMenuUtils){
        super();
        this.chartMenuUtils = chartMenuUtils;
    }
    init() {
        const calloutGroupParams = {
            cssIdentifier: "charts-format-sub-level",
            direction: "vertical",
            title: this.chartTranslationService.translate("callout"),
            enabled: true,
            suppressOpenCloseIcons: true,
            suppressEnabledCheckbox: true
        };
        this.setTemplate(_CalloutPanel2.TEMPLATE, {
            calloutGroup: calloutGroupParams,
            calloutLengthSlider: this.chartMenuUtils.getDefaultSliderParams("calloutLine.length", "length", 40),
            calloutStrokeWidthSlider: this.chartMenuUtils.getDefaultSliderParams("calloutLine.strokeWidth", "strokeWidth", 10),
            labelOffsetSlider: this.chartMenuUtils.getDefaultSliderParams("calloutLabel.offset", "offset", 30)
        });
    }
};
$5b7ccabde48fae90$var$_CalloutPanel.TEMPLATE = /* html */ `<div>
            <ag-group-component ref="calloutGroup">
                <ag-slider ref="calloutLengthSlider"></ag-slider>
                <ag-slider ref="calloutStrokeWidthSlider"></ag-slider>
                <ag-slider ref="labelOffsetSlider"></ag-slider>
            </ag-group-component>
        </div>`;
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartTranslationService")
], $5b7ccabde48fae90$var$_CalloutPanel.prototype, "chartTranslationService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_CalloutPanel.prototype, "init", 1);
var $5b7ccabde48fae90$var$CalloutPanel = $5b7ccabde48fae90$var$_CalloutPanel;
var $5b7ccabde48fae90$var$_CapsPanel = class _CapsPanel2 extends (0, $jIDNV.Component) {
    constructor(chartMenuUtils){
        super();
        this.chartMenuUtils = chartMenuUtils;
    }
    init() {
        const capsGroupParams = {
            cssIdentifier: "charts-format-sub-level",
            direction: "vertical",
            title: this.chartTranslationService.translate("cap"),
            enabled: true,
            suppressOpenCloseIcons: true,
            suppressEnabledCheckbox: true
        };
        const capLengthRatioSliderParams = this.chartMenuUtils.getDefaultSliderParams("cap.lengthRatio", "capLengthRatio", 1);
        capLengthRatioSliderParams.step = 0.05;
        this.setTemplate(_CapsPanel2.TEMPLATE, {
            capsGroup: capsGroupParams,
            capLengthRatioSlider: capLengthRatioSliderParams
        });
    }
};
$5b7ccabde48fae90$var$_CapsPanel.TEMPLATE = /* html */ `<div>
            <ag-group-component ref="capsGroup">
                <ag-slider ref="capLengthRatioSlider"></ag-slider>
            </ag-group-component>
        </div>`;
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartTranslationService")
], $5b7ccabde48fae90$var$_CapsPanel.prototype, "chartTranslationService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_CapsPanel.prototype, "init", 1);
var $5b7ccabde48fae90$var$CapsPanel = $5b7ccabde48fae90$var$_CapsPanel;
var $5b7ccabde48fae90$var$_ConnectorLinePanel = class _ConnectorLinePanel2 extends (0, $jIDNV.Component) {
    constructor(chartMenuUtils){
        super();
        this.chartMenuUtils = chartMenuUtils;
    }
    init() {
        const lineGroupParams = {
            cssIdentifier: "charts-format-sub-level",
            direction: "vertical",
            title: this.chartTranslationService.translate("connectorLine"),
            enabled: true,
            suppressOpenCloseIcons: true,
            suppressEnabledCheckbox: true
        };
        this.setTemplate(_ConnectorLinePanel2.TEMPLATE, {
            lineGroup: lineGroupParams,
            lineColorPicker: this.chartMenuUtils.getDefaultColorPickerParams("line.stroke"),
            lineStrokeWidthSlider: this.getSliderParams("strokeWidth", 10, "line.strokeWidth"),
            lineDashSlider: this.getSliderParams("lineDash", 30, "line.lineDash", 1, true),
            lineOpacitySlider: this.getSliderParams("strokeOpacity", 1, "line.strokeOpacity", 0.05)
        });
    }
    getSliderParams(labelKey, maxValue, seriesOptionKey, step = 1, isArray = false) {
        const params = this.chartMenuUtils.getDefaultSliderParams(seriesOptionKey, labelKey, maxValue, isArray);
        params.step = step;
        return params;
    }
};
$5b7ccabde48fae90$var$_ConnectorLinePanel.TEMPLATE = /* html */ `<div>
            <ag-group-component ref="lineGroup">
                <ag-color-picker ref="lineColorPicker"></ag-color-picker>
                <ag-slider ref="lineStrokeWidthSlider"></ag-slider>
                <ag-slider ref="lineOpacitySlider"></ag-slider>
                <ag-slider ref="lineDashSlider"></ag-slider>                
            </ag-group-component>
        </div>`;
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartTranslationService")
], $5b7ccabde48fae90$var$_ConnectorLinePanel.prototype, "chartTranslationService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_ConnectorLinePanel.prototype, "init", 1);
var $5b7ccabde48fae90$var$ConnectorLinePanel = $5b7ccabde48fae90$var$_ConnectorLinePanel;
var $5b7ccabde48fae90$var$_WhiskersPanel = class _WhiskersPanel2 extends (0, $jIDNV.Component) {
    constructor(chartMenuUtils){
        super();
        this.chartMenuUtils = chartMenuUtils;
    }
    init() {
        const whiskersGroupParams = {
            cssIdentifier: "charts-format-sub-level",
            direction: "vertical",
            title: this.chartTranslationService.translate("whisker"),
            enabled: true,
            suppressOpenCloseIcons: true,
            suppressEnabledCheckbox: true
        };
        this.setTemplate(_WhiskersPanel2.TEMPLATE, {
            whiskersGroup: whiskersGroupParams,
            whiskerColorPicker: this.chartMenuUtils.getDefaultColorPickerParams("whisker.stroke"),
            whiskerThicknessSlider: this.chartMenuUtils.getDefaultSliderParams("whisker.strokeWidth", "strokeWidth", 10),
            whiskerOpacitySlider: this.chartMenuUtils.getDefaultSliderParams("whisker.strokeOpacity", "strokeOpacity", 1),
            whiskerLineDashSlider: this.chartMenuUtils.getDefaultSliderParams("whisker.lineDash", "lineDash", 30, true),
            whiskerLineDashOffsetSlider: this.chartMenuUtils.getDefaultSliderParams("whisker.lineDashOffset", "lineDashOffset", 30)
        });
    }
};
$5b7ccabde48fae90$var$_WhiskersPanel.TEMPLATE = /* html */ `<div>
            <ag-group-component ref="whiskersGroup">
                <ag-color-picker ref="whiskerColorPicker"></ag-color-picker>
                <ag-slider ref="whiskerThicknessSlider"></ag-slider>
                <ag-slider ref="whiskerOpacitySlider"></ag-slider>
                <ag-slider ref="whiskerLineDashSlider"></ag-slider>
                <ag-slider ref="whiskerLineDashOffsetSlider"></ag-slider>
            </ag-group-component>
        </div>`;
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartTranslationService")
], $5b7ccabde48fae90$var$_WhiskersPanel.prototype, "chartTranslationService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_WhiskersPanel.prototype, "init", 1);
var $5b7ccabde48fae90$var$WhiskersPanel = $5b7ccabde48fae90$var$_WhiskersPanel;
var $5b7ccabde48fae90$var$_SeriesItemsPanel = class _SeriesItemsPanel2 extends (0, $jIDNV.Component) {
    constructor(chartMenuUtils){
        super();
        this.chartMenuUtils = chartMenuUtils;
        this.activePanels = [];
    }
    init() {
        const seriesItemsGroupParams = {
            cssIdentifier: "charts-format-sub-level",
            direction: "vertical",
            title: this.chartTranslationService.translate("seriesItems"),
            enabled: true,
            suppressOpenCloseIcons: true,
            suppressEnabledCheckbox: true
        };
        this.setTemplate(_SeriesItemsPanel2.TEMPLATE, {
            seriesItemsGroup: seriesItemsGroupParams,
            seriesItemSelect: this.getSeriesItemsParams()
        });
        this.initSeriesControls();
    }
    getSeriesItemsParams() {
        const options = [
            {
                value: "positive",
                text: this.chartTranslationService.translate("seriesItemPositive")
            },
            {
                value: "negative",
                text: this.chartTranslationService.translate("seriesItemNegative")
            }
        ];
        const seriesItemChangedCallback = (newValue)=>{
            this.destroyActivePanels();
            this.initSeriesControls(newValue);
        };
        return {
            label: this.chartTranslationService.translate("seriesItemType"),
            labelAlignment: "left",
            labelWidth: "flex",
            inputWidth: "flex",
            options: options,
            value: "positive",
            onValueChange: seriesItemChangedCallback
        };
    }
    initSeriesControls(itemType = "positive") {
        this.initSlider("strokeWidth", 10, `item.${itemType}.strokeWidth`);
        this.initSlider("lineDash", 30, `item.${itemType}.lineDash`, 1, true);
        this.initSlider("strokeOpacity", 1, `item.${itemType}.strokeOpacity`, 0.05, false);
        this.initSlider("fillOpacity", 1, `item.${itemType}.fillOpacity`, 0.05, false);
        this.initItemLabels(itemType);
    }
    initSlider(labelKey, maxValue, seriesOptionKey, step = 1, isArray = false) {
        const params = this.chartMenuUtils.getDefaultSliderParams(seriesOptionKey, labelKey, maxValue, isArray);
        params.step = step;
        const itemSlider = this.seriesItemsGroup.createManagedBean(new (0, $jIDNV.AgSlider)(params));
        this.seriesItemsGroup.addItem(itemSlider);
        this.activePanels.push(itemSlider);
    }
    initItemLabels(itemType) {
        const sectorParams = this.chartMenuUtils.getDefaultFontPanelParams(`item.${itemType}.label`, "seriesItemLabels");
        const labelPanelComp = this.createBean(new $5b7ccabde48fae90$var$FontPanel(sectorParams));
        this.seriesItemsGroup.addItem(labelPanelComp);
        this.activePanels.push(labelPanelComp);
    }
    destroyActivePanels() {
        this.activePanels.forEach((panel)=>{
            (0, $jIDNV._).removeFromParent(panel.getGui());
            this.destroyBean(panel);
        });
    }
    destroy() {
        this.destroyActivePanels();
        super.destroy();
    }
};
$5b7ccabde48fae90$var$_SeriesItemsPanel.TEMPLATE = /* html */ `<div>
            <ag-group-component ref="seriesItemsGroup">
                <ag-select ref="seriesItemSelect"></ag-select>
            </ag-group-component>
        </div>`;
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.RefSelector)("seriesItemsGroup")
], $5b7ccabde48fae90$var$_SeriesItemsPanel.prototype, "seriesItemsGroup", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartTranslationService")
], $5b7ccabde48fae90$var$_SeriesItemsPanel.prototype, "chartTranslationService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_SeriesItemsPanel.prototype, "init", 1);
var $5b7ccabde48fae90$var$SeriesItemsPanel = $5b7ccabde48fae90$var$_SeriesItemsPanel;
var $5b7ccabde48fae90$var$_TileSpacingPanel = class _TileSpacingPanel2 extends (0, $jIDNV.Component) {
    constructor(chartMenuUtils){
        super();
        this.chartMenuUtils = chartMenuUtils;
    }
    init() {
        const groupParams = {
            cssIdentifier: "charts-format-sub-level",
            direction: "vertical",
            enabled: true,
            suppressOpenCloseIcons: true,
            suppressEnabledCheckbox: true
        };
        this.setTemplate(_TileSpacingPanel2.TEMPLATE, {
            groupSpacing: $5b7ccabde48fae90$var$__spreadProps3($5b7ccabde48fae90$var$__spreadValues3({}, groupParams), {
                title: this.chartTranslationService.translate("group")
            }),
            tileSpacing: $5b7ccabde48fae90$var$__spreadProps3($5b7ccabde48fae90$var$__spreadValues3({}, groupParams), {
                title: this.chartTranslationService.translate("tile")
            }),
            groupPaddingSlider: this.getSliderParams("padding", "group.padding"),
            groupSpacingSlider: this.getSliderParams("spacing", "group.gap"),
            tilePaddingSlider: this.getSliderParams("padding", "tile.padding"),
            tileSpacingSlider: this.getSliderParams("spacing", "tile.gap")
        });
    }
    getSliderParams(labelKey, key) {
        return this.chartMenuUtils.getDefaultSliderParams(key, labelKey, 10);
    }
};
$5b7ccabde48fae90$var$_TileSpacingPanel.TEMPLATE = /* html */ `<div>
            <ag-group-component ref="groupSpacing">
                <ag-slider ref="groupPaddingSlider"></ag-slider>
                <ag-slider ref="groupSpacingSlider"></ag-slider>
            </ag-group-component>
            <ag-group-component ref="tileSpacing">
                <ag-slider ref="tilePaddingSlider"></ag-slider>
                <ag-slider ref="tileSpacingSlider"></ag-slider>
            </ag-group-component>
        </div>`;
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartTranslationService")
], $5b7ccabde48fae90$var$_TileSpacingPanel.prototype, "chartTranslationService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_TileSpacingPanel.prototype, "init", 1);
var $5b7ccabde48fae90$var$TileSpacingPanel = $5b7ccabde48fae90$var$_TileSpacingPanel;
var $5b7ccabde48fae90$var$_SeriesPanel = class _SeriesPanel2 extends (0, $jIDNV.Component) {
    constructor({ chartController: chartController, chartOptionsService: chartOptionsService, seriesType: seriesType, isExpandedOnInit: isExpandedOnInit = false }){
        super();
        this.activePanels = [];
        this.widgetFuncs = {
            lineWidth: ()=>this.initStrokeWidth("lineWidth"),
            strokeWidth: ()=>this.initStrokeWidth("strokeWidth"),
            lineColor: ()=>this.initLineColor(),
            lineDash: ()=>this.initLineDash(),
            lineOpacity: ()=>this.initLineOpacity(),
            fillOpacity: ()=>this.initFillOpacity(),
            markers: ()=>this.initMarkers(),
            labels: ()=>this.initLabels(),
            shadow: ()=>this.initShadow(),
            tooltips: ()=>this.initTooltips(),
            bins: ()=>this.initBins(),
            whiskers: ()=>this.initWhiskers(),
            caps: ()=>this.initCaps(),
            connectorLine: ()=>this.initConnectorLine(),
            seriesItems: ()=>this.initSeriesItemsPanel(),
            tileSpacing: ()=>this.initTileSpacingPanel(),
            groupType: ()=>this.initGroupType()
        };
        this.seriesWidgetMappings = {
            bar: [
                "tooltips",
                "strokeWidth",
                "lineDash",
                "lineOpacity",
                "fillOpacity",
                "labels",
                "shadow"
            ],
            pie: [
                "tooltips",
                "strokeWidth",
                "lineOpacity",
                "fillOpacity",
                "labels",
                "shadow"
            ],
            donut: [
                "tooltips",
                "strokeWidth",
                "lineOpacity",
                "fillOpacity",
                "labels",
                "shadow"
            ],
            line: [
                "tooltips",
                "lineWidth",
                "lineDash",
                "lineOpacity",
                "markers",
                "labels"
            ],
            scatter: [
                "tooltips",
                "markers",
                "labels"
            ],
            bubble: [
                "tooltips",
                "markers",
                "labels"
            ],
            area: [
                "tooltips",
                "lineWidth",
                "lineDash",
                "lineOpacity",
                "fillOpacity",
                "markers",
                "labels",
                "shadow"
            ],
            histogram: [
                "tooltips",
                "bins",
                "strokeWidth",
                "lineDash",
                "lineOpacity",
                "fillOpacity",
                "labels",
                "shadow"
            ],
            "radial-column": [
                "tooltips",
                "strokeWidth",
                "lineDash",
                "lineOpacity",
                "fillOpacity",
                "labels",
                "groupType"
            ],
            "radial-bar": [
                "tooltips",
                "strokeWidth",
                "lineDash",
                "lineOpacity",
                "fillOpacity",
                "labels",
                "groupType"
            ],
            "radar-line": [
                "tooltips",
                "strokeWidth",
                "lineDash",
                "lineOpacity",
                "markers",
                "labels"
            ],
            "radar-area": [
                "tooltips",
                "strokeWidth",
                "lineDash",
                "lineOpacity",
                "fillOpacity",
                "markers",
                "labels"
            ],
            nightingale: [
                "tooltips",
                "strokeWidth",
                "lineDash",
                "lineOpacity",
                "fillOpacity",
                "labels",
                "groupType"
            ],
            "box-plot": [
                "tooltips",
                "strokeWidth",
                "lineDash",
                "lineOpacity",
                "fillOpacity",
                "whiskers",
                "caps"
            ],
            "range-bar": [
                "tooltips",
                "strokeWidth",
                "lineDash",
                "lineOpacity",
                "fillOpacity",
                "labels"
            ],
            "range-area": [
                "tooltips",
                "lineWidth",
                "lineDash",
                "lineOpacity",
                "fillOpacity",
                "markers",
                "labels",
                "shadow"
            ],
            treemap: [
                "tooltips",
                "tileSpacing"
            ],
            sunburst: [
                "tooltips"
            ],
            heatmap: [
                "tooltips",
                "labels",
                "lineColor",
                "lineWidth",
                "lineOpacity"
            ],
            waterfall: [
                "tooltips",
                "connectorLine",
                "seriesItems"
            ]
        };
        this.chartController = chartController;
        this.chartOptionsService = chartOptionsService;
        this.seriesType = seriesType || this.chartController.getChartSeriesType();
        this.isExpandedOnInit = isExpandedOnInit;
    }
    init() {
        const seriesGroupParams = {
            cssIdentifier: "charts-format-top-level",
            direction: "vertical",
            title: this.translate("series"),
            expanded: this.isExpandedOnInit,
            suppressEnabledCheckbox: true
        };
        this.setTemplate(_SeriesPanel2.TEMPLATE, {
            seriesGroup: seriesGroupParams
        });
        this.chartMenuUtils = this.createManagedBean(new $5b7ccabde48fae90$var$ChartMenuParamsFactory(this.chartOptionsService.getSeriesOptionsProxy(()=>this.seriesType)));
        this.chartOptions = this.chartMenuUtils.getChartOptions();
        this.addManagedListener(this.chartController, $5b7ccabde48fae90$var$ChartController.EVENT_CHART_SERIES_CHART_TYPE_CHANGED, this.refreshWidgets.bind(this));
        this.refreshWidgets();
    }
    refreshWidgets() {
        this.destroyActivePanels();
        const chart = this.chartController.getChartProxy().getChart();
        chart.waitForUpdate().then(()=>{
            var _a;
            const componentWasRemoved = !this.isAlive();
            if (componentWasRemoved) return;
            if (this.chartController.isComboChart()) {
                this.updateSeriesType();
                this.initSeriesSelect();
            }
            ((_a = this.seriesWidgetMappings[this.seriesType]) != null ? _a : []).forEach((w)=>this.widgetFuncs[w]());
        }).catch((e)=>console.error(`AG Grid - chart rendering failed`, e));
    }
    initSeriesSelect() {
        const seriesSelect = this.seriesGroup.createManagedBean(new (0, $jIDNV.AgSelect)({
            label: this.translate("seriesType"),
            labelAlignment: "left",
            labelWidth: "flex",
            inputWidth: "flex",
            options: this.getSeriesSelectOptions(),
            value: `${this.seriesType}`,
            onValueChange: (newValue)=>{
                this.seriesType = newValue;
                this.refreshWidgets();
            }
        }));
        this.seriesGroup.addItem(seriesSelect);
        this.activePanels.push(seriesSelect);
    }
    initTooltips() {
        const seriesTooltipsToggle = this.createBean(new (0, $jIDNV.AgToggleButton)(this.chartMenuUtils.addValueParams("tooltip.enabled", {
            label: this.translate("tooltips"),
            labelAlignment: "left",
            labelWidth: "flex",
            inputWidth: "flex"
        })));
        this.addWidget(seriesTooltipsToggle);
    }
    initLineColor() {
        const seriesLineColorPicker = this.createBean(new $5b7ccabde48fae90$var$AgColorPicker(this.chartMenuUtils.getDefaultColorPickerParams("stroke", "strokeColor")));
        this.addWidget(seriesLineColorPicker);
    }
    initStrokeWidth(labelKey) {
        const seriesStrokeWidthSlider = this.createBean(new (0, $jIDNV.AgSlider)(this.chartMenuUtils.getDefaultSliderParams("strokeWidth", labelKey, 10)));
        this.addWidget(seriesStrokeWidthSlider);
    }
    initLineDash() {
        const seriesLineDashSlider = this.createBean(new (0, $jIDNV.AgSlider)(this.chartMenuUtils.getDefaultSliderParams("lineDash", "lineDash", 30, true)));
        this.addWidget(seriesLineDashSlider);
    }
    initLineOpacity() {
        const params = this.chartMenuUtils.getDefaultSliderParams("strokeOpacity", "strokeOpacity", 1);
        params.step = 0.05;
        const seriesLineOpacitySlider = this.createBean(new (0, $jIDNV.AgSlider)(params));
        this.addWidget(seriesLineOpacitySlider);
    }
    initFillOpacity() {
        const params = this.chartMenuUtils.getDefaultSliderParams("fillOpacity", "fillOpacity", 1);
        params.step = 0.05;
        const seriesFillOpacitySlider = this.createBean(new (0, $jIDNV.AgSlider)(params));
        this.addWidget(seriesFillOpacitySlider);
    }
    initLabels() {
        const isPieChart = $5b7ccabde48fae90$var$isPieChartSeries(this.seriesType);
        const seriesOptionLabelProperty = isPieChart ? "calloutLabel" : "label";
        const labelKey = isPieChart ? "calloutLabels" : "labels";
        const labelParams = this.chartMenuUtils.getDefaultFontPanelParams(seriesOptionLabelProperty, labelKey);
        const labelPanelComp = this.createBean(new $5b7ccabde48fae90$var$FontPanel(labelParams));
        if (isPieChart) {
            const calloutPanelComp = this.createBean(new $5b7ccabde48fae90$var$CalloutPanel(this.chartMenuUtils));
            labelPanelComp.addCompToPanel(calloutPanelComp);
            this.activePanels.push(calloutPanelComp);
        }
        this.addWidget(labelPanelComp);
        if (isPieChart) {
            const sectorParams = this.chartMenuUtils.getDefaultFontPanelParams("sectorLabel", "sectorLabels");
            const sectorPanelComp = this.createBean(new $5b7ccabde48fae90$var$FontPanel(sectorParams));
            const positionRatioComp = this.getSectorLabelPositionRatio();
            sectorPanelComp.addCompToPanel(positionRatioComp);
            this.addWidget(sectorPanelComp);
        }
        if (this.seriesType === "range-bar") {
            const options = [
                {
                    value: "inside",
                    text: this.translate("inside")
                },
                {
                    value: "outside",
                    text: this.translate("outside")
                }
            ];
            const placementSelect = labelPanelComp.createManagedBean(new (0, $jIDNV.AgSelect)(this.chartMenuUtils.addValueParams("label.placement", {
                label: this.translate("labelPlacement"),
                labelAlignment: "left",
                labelWidth: "flex",
                inputWidth: "flex",
                options: options
            })));
            labelPanelComp.addCompToPanel(placementSelect);
            this.activePanels.push(placementSelect);
            const paddingSlider = labelPanelComp.createManagedBean(new (0, $jIDNV.AgSlider)(this.chartMenuUtils.getDefaultSliderParams("label.padding", "padding", 200)));
            labelPanelComp.addCompToPanel(paddingSlider);
            this.activePanels.push(paddingSlider);
        }
    }
    getSectorLabelPositionRatio() {
        const params = this.chartMenuUtils.getDefaultSliderParams("sectorLabel.positionRatio", "positionRatio", 1);
        params.step = 0.05;
        return this.createBean(new (0, $jIDNV.AgSlider)(params));
    }
    initShadow() {
        const shadowPanelComp = this.createBean(new $5b7ccabde48fae90$var$ShadowPanel(this.chartMenuUtils));
        this.addWidget(shadowPanelComp);
    }
    initMarkers() {
        const markersPanelComp = this.createBean(new $5b7ccabde48fae90$var$MarkersPanel(this.chartOptionsService, this.chartMenuUtils));
        this.addWidget(markersPanelComp);
    }
    initBins() {
        var _a;
        const params = this.chartMenuUtils.getDefaultSliderParams("binCount", "histogramBinCount", 20);
        const value = ((_a = this.chartOptions.getValue("bins")) != null ? _a : this.chartOptions.getValue("calculatedBins", true)).length;
        params.value = `${value}`;
        params.maxValue = Math.max(value, 20);
        const seriesBinCountSlider = this.createBean(new (0, $jIDNV.AgSlider)(params));
        this.addWidget(seriesBinCountSlider);
    }
    initWhiskers() {
        const whiskersPanelComp = this.createBean(new $5b7ccabde48fae90$var$WhiskersPanel(this.chartMenuUtils));
        this.addWidget(whiskersPanelComp);
    }
    initCaps() {
        const capsPanelComp = this.createBean(new $5b7ccabde48fae90$var$CapsPanel(this.chartMenuUtils));
        this.addWidget(capsPanelComp);
    }
    initConnectorLine() {
        const connectorLinePanelComp = this.createBean(new $5b7ccabde48fae90$var$ConnectorLinePanel(this.chartMenuUtils));
        this.addWidget(connectorLinePanelComp);
    }
    initSeriesItemsPanel() {
        const seriesItemsPanelComp = this.createBean(new $5b7ccabde48fae90$var$SeriesItemsPanel(this.chartMenuUtils));
        this.addWidget(seriesItemsPanelComp);
    }
    initTileSpacingPanel() {
        const tileSpacingPanelComp = this.createBean(new $5b7ccabde48fae90$var$TileSpacingPanel(this.chartMenuUtils));
        this.addWidget(tileSpacingPanelComp);
    }
    initGroupType() {
        const groupTypeSelect = this.createBean(new (0, $jIDNV.AgSelect)({
            label: this.chartTranslationService.translate("seriesGroupType"),
            options: (0, $jIDNV.ChartMappings).SERIES_GROUP_TYPES.map((value)=>({
                    value: value,
                    text: this.chartTranslationService.translate(`${value}SeriesGroupType`)
                })),
            value: this.chartController.getSeriesGroupType(),
            onValueChange: (value)=>this.chartController.setSeriesGroupType(value)
        }));
        this.addWidget(groupTypeSelect);
    }
    addWidget(widget) {
        this.seriesGroup.addItem(widget);
        this.activePanels.push(widget);
    }
    getSeriesSelectOptions() {
        const activeSeriesTypes = this.getActiveSeriesTypes();
        return [
            "area",
            "bar",
            "line"
        ].filter((seriesType)=>activeSeriesTypes.includes(seriesType)).map((value)=>({
                value: value,
                text: this.translate(value)
            }));
    }
    updateSeriesType() {
        const activeSeriesTypes = this.getActiveSeriesTypes();
        const invalidSeriesType = !activeSeriesTypes.includes(this.seriesType);
        if (invalidSeriesType && activeSeriesTypes.length > 0) this.seriesType = activeSeriesTypes[0];
    }
    getActiveSeriesTypes() {
        return this.chartController.getActiveSeriesChartTypes().map((s)=>$5b7ccabde48fae90$var$getSeriesType(s.chartType));
    }
    translate(key) {
        return this.chartTranslationService.translate(key);
    }
    destroyActivePanels() {
        this.activePanels.forEach((panel)=>{
            (0, $jIDNV._).removeFromParent(panel.getGui());
            this.destroyBean(panel);
        });
    }
    destroy() {
        this.destroyActivePanels();
        super.destroy();
    }
};
$5b7ccabde48fae90$var$_SeriesPanel.TEMPLATE = /* html */ `<div>
            <ag-group-component ref="seriesGroup">
            </ag-group-component>
        </div>`;
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.RefSelector)("seriesGroup")
], $5b7ccabde48fae90$var$_SeriesPanel.prototype, "seriesGroup", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartTranslationService")
], $5b7ccabde48fae90$var$_SeriesPanel.prototype, "chartTranslationService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_SeriesPanel.prototype, "init", 1);
var $5b7ccabde48fae90$var$SeriesPanel = $5b7ccabde48fae90$var$_SeriesPanel;
var $5b7ccabde48fae90$var$_GradientLegendPanel = class _GradientLegendPanel2 extends (0, $jIDNV.Component) {
    constructor({ chartMenuParamsFactory: chartMenuUtils, isExpandedOnInit: isExpandedOnInit = false }){
        super();
        this.chartMenuUtils = chartMenuUtils;
        this.isExpandedOnInit = isExpandedOnInit;
    }
    init() {
        const legendGroupParams = this.chartMenuUtils.addEnableParams("gradientLegend.enabled", {
            cssIdentifier: "charts-format-top-level",
            direction: "vertical",
            title: this.chartTranslationService.translate("legend"),
            suppressEnabledCheckbox: false,
            suppressToggleExpandOnEnableChange: true,
            expanded: this.isExpandedOnInit,
            items: [
                this.createLabelPanel()
            ]
        });
        this.setTemplate(_GradientLegendPanel2.TEMPLATE, {
            legendGroup: legendGroupParams,
            legendPositionSelect: this.chartMenuUtils.getDefaultLegendParams("gradientLegend.position"),
            gradientReverseCheckbox: this.getGradientReverseCheckboxParams(),
            gradientThicknessSlider: this.chartMenuUtils.getDefaultSliderParams("gradientLegend.gradient.thickness", "thickness", 40),
            gradientPreferredLengthSlider: this.chartMenuUtils.getDefaultSliderParams("gradientLegend.gradient.preferredLength", "preferredLength", 300),
            legendSpacingSlider: this.chartMenuUtils.getDefaultSliderParams("gradientLegend.spacing", "spacing", 200)
        });
    }
    getGradientReverseCheckboxParams() {
        return this.chartMenuUtils.addValueParams("gradientLegend.reverseOrder", {
            label: this.chartTranslationService.translate("reverseDirection"),
            labelWidth: "flex"
        });
    }
    createLabelPanel() {
        const params = {
            enabled: true,
            suppressEnabledCheckbox: true,
            chartMenuUtils: this.chartMenuUtils,
            keyMapper: (key)=>`gradientLegend.scale.label.${key}`
        };
        return this.createManagedBean(new $5b7ccabde48fae90$var$FontPanel(params));
    }
};
$5b7ccabde48fae90$var$_GradientLegendPanel.TEMPLATE = /* html */ `<div>
            <ag-group-component ref="legendGroup">
                <ag-select ref="legendPositionSelect"></ag-select>
                <ag-checkbox ref="gradientReverseCheckbox"></ag-checkbox>
                <ag-slider ref="gradientThicknessSlider"></ag-slider>
                <ag-slider ref="gradientPreferredLengthSlider"></ag-slider>
                <ag-slider ref="legendSpacingSlider"></ag-slider>
            </ag-group-component>
        </div>`;
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartTranslationService")
], $5b7ccabde48fae90$var$_GradientLegendPanel.prototype, "chartTranslationService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_GradientLegendPanel.prototype, "init", 1);
var $5b7ccabde48fae90$var$GradientLegendPanel = $5b7ccabde48fae90$var$_GradientLegendPanel;
var $5b7ccabde48fae90$var$ChartPanelFeature = class extends (0, $jIDNV.BeanStub) {
    constructor(chartController, eGui, cssClass, createPanels){
        super();
        this.chartController = chartController;
        this.eGui = eGui;
        this.cssClass = cssClass;
        this.createPanels = createPanels;
        this.panels = [];
    }
    postConstruct() {
        this.addManagedListener(this.chartController, $5b7ccabde48fae90$var$ChartController.EVENT_CHART_UPDATED, ()=>this.refreshPanels(true));
        this.addManagedListener(this.chartController, $5b7ccabde48fae90$var$ChartController.EVENT_CHART_API_UPDATE, ()=>this.refreshPanels(false));
    }
    addComponent(component) {
        this.createBean(component);
        this.panels.push(component);
        component.addCssClass(this.cssClass);
        this.eGui.appendChild(component.getGui());
    }
    refreshPanels(reuse) {
        const chartType = this.chartController.getChartType();
        const isGrouping = this.chartController.isGrouping();
        const seriesType = $5b7ccabde48fae90$var$getSeriesType(chartType);
        if (reuse && chartType === this.chartType && isGrouping === this.isGrouping) return;
        this.destroyPanels();
        this.createPanels(chartType, seriesType);
        this.chartType = chartType;
        this.isGrouping = isGrouping;
    }
    destroyPanels() {
        this.panels.forEach((panel)=>{
            (0, $jIDNV._).removeFromParent(panel.getGui());
            this.destroyBean(panel);
        });
        this.panels = [];
    }
    destroy() {
        this.destroyPanels();
        super.destroy();
    }
};
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$ChartPanelFeature.prototype, "postConstruct", 1);
var $5b7ccabde48fae90$var$DefaultFormatPanelDef = {
    groups: [
        {
            type: "chart"
        },
        {
            type: "legend"
        },
        {
            type: "series"
        },
        {
            type: "axis"
        }
    ]
};
var $5b7ccabde48fae90$var$_FormatPanel = class _FormatPanel2 extends (0, $jIDNV.Component) {
    constructor(chartMenuContext){
        super(_FormatPanel2.TEMPLATE);
        this.chartMenuContext = chartMenuContext;
    }
    init() {
        this.chartPanelFeature = this.createManagedBean(new $5b7ccabde48fae90$var$ChartPanelFeature(this.chartMenuContext.chartController, this.getGui(), "ag-chart-format-section", (chartType, seriesType)=>this.createPanels(chartType, seriesType)));
        this.chartPanelFeature.refreshPanels();
    }
    createPanels(chartType, seriesType) {
        var _a;
        (_a = this.getFormatPanelDef().groups) == null || _a.forEach((groupDef)=>{
            const group = groupDef.type;
            if (!this.isGroupPanelShownInSeries(group, seriesType)) return;
            const opts = $5b7ccabde48fae90$var$__spreadProps3($5b7ccabde48fae90$var$__spreadValues3({}, this.chartMenuContext), {
                isExpandedOnInit: groupDef.isOpen,
                seriesType: seriesType
            });
            switch(group){
                case "chart":
                    this.chartPanelFeature.addComponent(new $5b7ccabde48fae90$var$ChartPanel(opts));
                    break;
                case "legend":
                    const panel = [
                        "treemap",
                        "sunburst",
                        "heatmap"
                    ].includes(chartType) ? new $5b7ccabde48fae90$var$GradientLegendPanel(opts) : new $5b7ccabde48fae90$var$LegendPanel(opts);
                    this.chartPanelFeature.addComponent(panel);
                    break;
                case "axis":
                    if ($5b7ccabde48fae90$var$isPolar(seriesType)) this.chartPanelFeature.addComponent(new $5b7ccabde48fae90$var$PolarAxisPanel(opts));
                    else if ($5b7ccabde48fae90$var$isCartesian(seriesType)) {
                        this.chartPanelFeature.addComponent(new $5b7ccabde48fae90$var$CartesianAxisPanel("xAxis", opts));
                        this.chartPanelFeature.addComponent(new $5b7ccabde48fae90$var$CartesianAxisPanel("yAxis", opts));
                    }
                    break;
                case "horizontalAxis":
                    this.chartPanelFeature.addComponent(new $5b7ccabde48fae90$var$CartesianAxisPanel("xAxis", opts));
                    break;
                case "verticalAxis":
                    this.chartPanelFeature.addComponent(new $5b7ccabde48fae90$var$CartesianAxisPanel("yAxis", opts));
                    break;
                case "series":
                    this.chartPanelFeature.addComponent(new $5b7ccabde48fae90$var$SeriesPanel(opts));
                    break;
                case "navigator":
                    (0, $jIDNV._).warnOnce(`'navigator' is now displayed in the charts advanced settings instead of the format panel, and this setting will be ignored.`);
                default:
                    (0, $jIDNV._).warnOnce(`Invalid charts format panel group name supplied: '${groupDef.type}'`);
            }
        });
    }
    getFormatPanelDef() {
        var _a;
        const userProvidedFormatPanelDef = (_a = this.gos.get("chartToolPanelsDef")) == null ? void 0 : _a.formatPanel;
        return userProvidedFormatPanelDef ? userProvidedFormatPanelDef : $5b7ccabde48fae90$var$DefaultFormatPanelDef;
    }
    isGroupPanelShownInSeries(group, seriesType) {
        return [
            "chart",
            "legend",
            "series"
        ].includes(group) || $5b7ccabde48fae90$var$isCartesian(seriesType) && [
            "axis",
            "horizontalAxis",
            "verticalAxis"
        ].includes(group) || $5b7ccabde48fae90$var$isPolar(seriesType) && group === "axis";
    }
};
$5b7ccabde48fae90$var$_FormatPanel.TEMPLATE = /* html */ `<div class="ag-chart-format-wrapper"></div>`;
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_FormatPanel.prototype, "init", 1);
var $5b7ccabde48fae90$var$FormatPanel = $5b7ccabde48fae90$var$_FormatPanel;
var $5b7ccabde48fae90$var$CANVAS_CLASS = "ag-chart-mini-thumbnail-canvas";
var $5b7ccabde48fae90$var$ERROR_MESSAGE = "AG Grid - chart update failed";
var $5b7ccabde48fae90$var$MiniChart = class extends (0, $jIDNV.Component) {
    constructor(container, tooltipName){
        super();
        this.tooltipName = tooltipName;
        this.size = 58;
        this.padding = 5;
        this.root = new (0, $iTJTu._Scene).Group();
        const scene = new (0, $iTJTu._Scene).Scene({
            width: this.size,
            height: this.size
        });
        scene.canvas.element.classList.add($5b7ccabde48fae90$var$CANVAS_CLASS);
        scene.setRoot(this.root);
        scene.setContainer(container);
        this.scene = scene;
    }
    init() {
        this.scene.canvas.element.title = this.chartTranslationService.translate(this.tooltipName);
        this.scene.render().catch((e)=>{
            console.error(`${$5b7ccabde48fae90$var$ERROR_MESSAGE}`, e);
        });
    }
};
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartTranslationService")
], $5b7ccabde48fae90$var$MiniChart.prototype, "chartTranslationService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$MiniChart.prototype, "init", 1);
var $5b7ccabde48fae90$var$MiniChartWithAxes = class extends $5b7ccabde48fae90$var$MiniChart {
    constructor(container, tooltipName){
        super(container, tooltipName);
        this.stroke = "gray";
        this.axisOvershoot = 3;
    }
    addAxes() {
        const size = this.size;
        const padding = this.padding;
        const leftAxis = new (0, $iTJTu._Scene).Line();
        leftAxis.x1 = padding;
        leftAxis.y1 = padding;
        leftAxis.x2 = padding;
        leftAxis.y2 = size - padding + this.axisOvershoot;
        leftAxis.stroke = this.stroke;
        const bottomAxis = new (0, $iTJTu._Scene).Line();
        bottomAxis.x1 = padding - this.axisOvershoot + 1;
        bottomAxis.y1 = size - padding;
        bottomAxis.x2 = size - padding + 1;
        bottomAxis.y2 = size - padding;
        bottomAxis.stroke = this.stroke;
        const root = this.root;
        root.append(leftAxis);
        root.append(bottomAxis);
    }
};
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$MiniChartWithAxes.prototype, "addAxes", 1);
function $5b7ccabde48fae90$var$createColumnRects(params) {
    const { stacked: stacked, size: size, padding: padding, xScalePadding: xScalePadding, xScaleDomain: xScaleDomain, yScaleDomain: yScaleDomain } = params;
    const xScale = new (0, $iTJTu._Scene).BandScale();
    xScale.domain = xScaleDomain;
    xScale.range = [
        padding,
        size - padding
    ];
    xScale.paddingInner = xScalePadding;
    xScale.paddingOuter = xScalePadding;
    const yScale = new (0, $iTJTu._Scene).LinearScale();
    yScale.domain = yScaleDomain;
    yScale.range = [
        size - padding,
        padding
    ];
    const createBars = (series, xScale2, yScale2)=>{
        return series.map((datum, i)=>{
            const top = yScale2.convert(datum);
            const rect = new (0, $iTJTu._Scene).Rect();
            rect.x = xScale2.convert(i);
            rect.y = top;
            rect.width = xScale2.bandwidth;
            rect.height = yScale2.convert(0) - top;
            rect.strokeWidth = 0;
            rect.crisp = true;
            return rect;
        });
    };
    if (stacked) return params.data.map((d)=>createBars(d, xScale, yScale));
    return createBars(params.data, xScale, yScale);
}
function $5b7ccabde48fae90$var$createLinePaths(root, data, size, padding) {
    const xScale = new (0, $iTJTu._Scene).LinearScale();
    xScale.domain = [
        0,
        4
    ];
    xScale.range = [
        padding,
        size - padding
    ];
    const yScale = new (0, $iTJTu._Scene).LinearScale();
    yScale.domain = [
        0,
        10
    ];
    yScale.range = [
        size - padding,
        padding
    ];
    const lines = data.map((series)=>{
        const line = new (0, $iTJTu._Scene).Path();
        line.strokeWidth = 3;
        line.lineCap = "round";
        line.fill = void 0;
        series.forEach((datum, i)=>{
            line.path[i > 0 ? "lineTo" : "moveTo"](xScale.convert(i), yScale.convert(datum));
        });
        return line;
    });
    const linesGroup = new (0, $iTJTu._Scene).Group();
    linesGroup.setClipRectInGroupCoordinateSpace(new (0, $iTJTu._Scene).BBox(padding, padding, size - padding * 2, size - padding * 2));
    linesGroup.append(lines);
    root.append(linesGroup);
    return lines;
}
function $5b7ccabde48fae90$var$createPolarPaths(root, data, size, radius, innerRadius, markerSize = 0) {
    const angleScale = new (0, $iTJTu._Scene).LinearScale();
    angleScale.domain = [
        0,
        7
    ];
    angleScale.range = [
        -Math.PI,
        Math.PI
    ].map((angle)=>angle + Math.PI / 2);
    const radiusScale = new (0, $iTJTu._Scene).LinearScale();
    radiusScale.domain = [
        0,
        10
    ];
    radiusScale.range = [
        radius,
        innerRadius
    ];
    const markers = [];
    const paths = data.map((series)=>{
        const path = new (0, $iTJTu._Scene).Path();
        path.strokeWidth = 1;
        path.strokeOpacity = 0.5;
        path.lineCap = "round";
        path.fill = void 0;
        path.fillOpacity = 0.8;
        series.forEach((datum, i)=>{
            const angle = angleScale.convert(i);
            const r = radius + innerRadius - radiusScale.convert(datum);
            const x = r * Math.cos(angle);
            const y = r * Math.sin(angle);
            path.path[i > 0 ? "lineTo" : "moveTo"](x, y);
            if (markerSize > 0) {
                const marker = new (0, $iTJTu._Scene).Circle();
                marker.x = x;
                marker.y = y;
                marker.size = markerSize;
                markers.push(marker);
            }
        });
        path.path.closePath();
        return path;
    });
    const group = new (0, $iTJTu._Scene).Group();
    const center = size / 2;
    group.translationX = center;
    group.translationY = center;
    group.append([
        ...paths,
        ...markers
    ]);
    root.append(group);
    return {
        paths: paths,
        markers: markers
    };
}
function $5b7ccabde48fae90$var$accumulateData(data) {
    let [min, max] = [
        Infinity,
        -Infinity
    ];
    const processedData = data.reduce((acc, curr, currIndex)=>{
        var _a;
        const previous = currIndex > 0 ? acc[currIndex - 1] : void 0;
        (_a = acc[currIndex]) != null ? _a : acc[currIndex] = [];
        const current = acc[currIndex];
        curr.forEach((datum, datumIndex)=>{
            if (previous) datum += previous[datumIndex];
            current[datumIndex] = datum;
            if (current[datumIndex] < min) min = current[datumIndex];
            if (current[datumIndex] > max) max = current[datumIndex];
        });
        return acc;
    }, []);
    return {
        processedData: processedData,
        min: min,
        max: max
    };
}
var $5b7ccabde48fae90$var$MiniColumn = class extends $5b7ccabde48fae90$var$MiniChartWithAxes {
    constructor(container, fills, strokes){
        super(container, "groupedColumnTooltip");
        this.columnData = [
            2,
            3,
            4
        ];
        const { root: root, columnData: columnData, size: size, padding: padding } = this;
        this.columns = $5b7ccabde48fae90$var$createColumnRects({
            stacked: false,
            root: root,
            data: columnData,
            size: size,
            padding: padding,
            xScaleDomain: [
                0,
                1,
                2
            ],
            yScaleDomain: [
                0,
                4
            ],
            xScalePadding: 0.3
        });
        root.append(this.columns);
        this.updateColors(fills, strokes);
    }
    updateColors(fills, strokes) {
        this.columns.forEach((column, i)=>{
            column.fill = fills[i];
            column.stroke = strokes[i];
        });
    }
};
$5b7ccabde48fae90$var$MiniColumn.chartType = "groupedColumn";
var $5b7ccabde48fae90$var$_MiniStackedColumn = class _MiniStackedColumn2 extends $5b7ccabde48fae90$var$MiniChartWithAxes {
    constructor(container, fills, strokes, _themeTemplateParameters, _isCustomTheme, data = _MiniStackedColumn2.data, yScaleDomain = [
        0,
        16
    ], tooltipName = "stackedColumnTooltip"){
        super(container, tooltipName);
        const { root: root, size: size, padding: padding } = this;
        this.stackedColumns = $5b7ccabde48fae90$var$createColumnRects({
            stacked: true,
            root: root,
            data: data,
            size: size,
            padding: padding,
            xScaleDomain: [
                0,
                1,
                2
            ],
            yScaleDomain: yScaleDomain,
            xScalePadding: 0.3
        });
        root.append([].concat.apply([], this.stackedColumns));
        this.updateColors(fills, strokes);
    }
    updateColors(fills, strokes) {
        this.stackedColumns.forEach((series, i)=>series.forEach((column)=>{
                column.fill = fills[i];
                column.stroke = strokes[i];
            }));
    }
};
$5b7ccabde48fae90$var$_MiniStackedColumn.chartType = "stackedColumn";
$5b7ccabde48fae90$var$_MiniStackedColumn.data = [
    [
        8,
        12,
        16
    ],
    [
        6,
        9,
        12
    ],
    [
        2,
        3,
        4
    ]
];
var $5b7ccabde48fae90$var$MiniStackedColumn = $5b7ccabde48fae90$var$_MiniStackedColumn;
var $5b7ccabde48fae90$var$_MiniNormalizedColumn = class _MiniNormalizedColumn2 extends $5b7ccabde48fae90$var$MiniStackedColumn {
    constructor(container, fills, strokes, themeTemplateParameters, isCustomTheme){
        super(container, fills, strokes, themeTemplateParameters, isCustomTheme, _MiniNormalizedColumn2.data, [
            0,
            10
        ], "normalizedColumnTooltip");
    }
};
$5b7ccabde48fae90$var$_MiniNormalizedColumn.chartType = "normalizedColumn";
$5b7ccabde48fae90$var$_MiniNormalizedColumn.data = [
    [
        10,
        10,
        10
    ],
    [
        6,
        7,
        8
    ],
    [
        2,
        4,
        6
    ]
];
var $5b7ccabde48fae90$var$MiniNormalizedColumn = $5b7ccabde48fae90$var$_MiniNormalizedColumn;
var $5b7ccabde48fae90$var$MiniBar = class extends $5b7ccabde48fae90$var$MiniChartWithAxes {
    constructor(container, fills, strokes){
        super(container, "groupedBarTooltip");
        const padding = this.padding;
        const size = this.size;
        const data = [
            2,
            3,
            4
        ];
        const yScale = new (0, $iTJTu._Scene).BandScale();
        yScale.domain = [
            0,
            1,
            2
        ];
        yScale.range = [
            padding,
            size - padding
        ];
        yScale.paddingInner = 0.3;
        yScale.paddingOuter = 0.3;
        const xScale = new (0, $iTJTu._Scene).LinearScale();
        xScale.domain = [
            0,
            4
        ];
        xScale.range = [
            size - padding,
            padding
        ];
        const bottom = xScale.convert(0);
        const height = yScale.bandwidth;
        this.bars = data.map((datum, i)=>{
            const rect = new (0, $iTJTu._Scene).Rect();
            rect.x = padding;
            rect.y = yScale.convert(i);
            rect.width = bottom - xScale.convert(datum);
            rect.height = height;
            rect.strokeWidth = 0;
            rect.crisp = true;
            return rect;
        });
        this.updateColors(fills, strokes);
        this.root.append(this.bars);
    }
    updateColors(fills, strokes) {
        this.bars.forEach((bar, i)=>{
            bar.fill = fills[i];
            bar.stroke = strokes[i];
        });
    }
};
$5b7ccabde48fae90$var$MiniBar.chartType = "groupedBar";
var $5b7ccabde48fae90$var$_MiniStackedBar = class _MiniStackedBar2 extends $5b7ccabde48fae90$var$MiniChartWithAxes {
    constructor(container, fills, strokes, _themeTemplateParameters, _isCustomTheme, data = _MiniStackedBar2.data, xScaleDomain = [
        0,
        16
    ], tooltipName = "stackedBarTooltip"){
        super(container, tooltipName);
        const size = this.size;
        const padding = this.padding;
        const yScale = new (0, $iTJTu._Scene).BandScale();
        yScale.domain = [
            0,
            1,
            2
        ];
        yScale.range = [
            padding,
            size - padding
        ];
        yScale.paddingInner = 0.3;
        yScale.paddingOuter = 0.3;
        const xScale = new (0, $iTJTu._Scene).LinearScale();
        xScale.domain = xScaleDomain;
        xScale.range = [
            size - padding,
            padding
        ];
        const bottom = xScale.convert(0);
        const height = yScale.bandwidth;
        this.bars = data.map((series)=>series.map((datum, i)=>{
                const rect = new (0, $iTJTu._Scene).Rect();
                rect.x = padding;
                rect.y = yScale.convert(i);
                rect.width = bottom - xScale.convert(datum);
                rect.height = height;
                rect.strokeWidth = 0;
                rect.crisp = true;
                return rect;
            }));
        this.updateColors(fills, strokes);
        this.root.append([].concat.apply([], this.bars));
    }
    updateColors(fills, strokes) {
        this.bars.forEach((series, i)=>series.forEach((bar)=>{
                bar.fill = fills[i];
                bar.stroke = strokes[i];
            }));
    }
};
$5b7ccabde48fae90$var$_MiniStackedBar.chartType = "stackedBar";
$5b7ccabde48fae90$var$_MiniStackedBar.data = [
    [
        8,
        12,
        16
    ],
    [
        6,
        9,
        12
    ],
    [
        2,
        3,
        4
    ]
];
var $5b7ccabde48fae90$var$MiniStackedBar = $5b7ccabde48fae90$var$_MiniStackedBar;
var $5b7ccabde48fae90$var$_MiniNormalizedBar = class _MiniNormalizedBar2 extends $5b7ccabde48fae90$var$MiniStackedBar {
    constructor(container, fills, strokes, themeTemplateParameters, isCustomTheme){
        super(container, fills, strokes, themeTemplateParameters, isCustomTheme, _MiniNormalizedBar2.data, [
            0,
            10
        ], "normalizedBarTooltip");
    }
};
$5b7ccabde48fae90$var$_MiniNormalizedBar.chartType = "normalizedBar";
$5b7ccabde48fae90$var$_MiniNormalizedBar.data = [
    [
        10,
        10,
        10
    ],
    [
        6,
        7,
        8
    ],
    [
        2,
        4,
        6
    ]
];
var $5b7ccabde48fae90$var$MiniNormalizedBar = $5b7ccabde48fae90$var$_MiniNormalizedBar;
var $5b7ccabde48fae90$var$toRadians = (0, $iTJTu._Scene).toRadians;
var $5b7ccabde48fae90$var$MiniDonut = class extends $5b7ccabde48fae90$var$MiniChart {
    constructor(container, fills, strokes, _themeTemplateParameters, _isCustomTheme, centerRadiusScaler = 0.6, tooltipName = "donutTooltip"){
        super(container, tooltipName);
        const radius = (this.size - this.padding * 2) / 2;
        const center = radius + this.padding;
        const angles = [
            [
                $5b7ccabde48fae90$var$toRadians(-90),
                $5b7ccabde48fae90$var$toRadians(30)
            ],
            [
                $5b7ccabde48fae90$var$toRadians(30),
                $5b7ccabde48fae90$var$toRadians(120)
            ],
            [
                $5b7ccabde48fae90$var$toRadians(120),
                $5b7ccabde48fae90$var$toRadians(180)
            ],
            [
                $5b7ccabde48fae90$var$toRadians(180),
                $5b7ccabde48fae90$var$toRadians(210)
            ],
            [
                $5b7ccabde48fae90$var$toRadians(210),
                $5b7ccabde48fae90$var$toRadians(240)
            ],
            [
                $5b7ccabde48fae90$var$toRadians(240),
                $5b7ccabde48fae90$var$toRadians(270)
            ]
        ];
        this.sectors = angles.map(([startAngle, endAngle])=>{
            const sector = new (0, $iTJTu._Scene).Sector();
            sector.centerX = center;
            sector.centerY = center;
            sector.innerRadius = radius * centerRadiusScaler;
            sector.outerRadius = radius;
            sector.startAngle = startAngle;
            sector.endAngle = endAngle;
            sector.stroke = void 0;
            sector.strokeWidth = 0;
            sector.inset = 0.75;
            return sector;
        });
        this.updateColors(fills, strokes);
        this.root.append(this.sectors);
    }
    updateColors(fills, strokes) {
        this.sectors.forEach((sector, i)=>{
            sector.fill = fills[i % fills.length];
            sector.stroke = strokes[i % strokes.length];
        });
    }
};
$5b7ccabde48fae90$var$MiniDonut.chartType = "donut";
var $5b7ccabde48fae90$var$MiniPie = class extends $5b7ccabde48fae90$var$MiniDonut {
    constructor(container, fills, strokes, themeTemplateParameters, isCustomTheme){
        super(container, fills, strokes, themeTemplateParameters, isCustomTheme, 0, "pieTooltip");
    }
};
$5b7ccabde48fae90$var$MiniPie.chartType = "pie";
var $5b7ccabde48fae90$var$MiniLine = class extends $5b7ccabde48fae90$var$MiniChartWithAxes {
    constructor(container, fills, strokes){
        super(container, "lineTooltip");
        this.data = [
            [
                9,
                7,
                8,
                5,
                6
            ],
            [
                5,
                6,
                3,
                4,
                1
            ],
            [
                1,
                3,
                4,
                8,
                7
            ]
        ];
        this.lines = $5b7ccabde48fae90$var$createLinePaths(this.root, this.data, this.size, this.padding);
        this.updateColors(fills, strokes);
    }
    updateColors(fills, strokes) {
        this.lines.forEach((line, i)=>{
            line.stroke = fills[i];
        });
    }
};
$5b7ccabde48fae90$var$MiniLine.chartType = "line";
var $5b7ccabde48fae90$var$MiniScatter = class extends $5b7ccabde48fae90$var$MiniChartWithAxes {
    constructor(container, fills, strokes){
        super(container, "scatterTooltip");
        const size = this.size;
        const padding = this.padding;
        const data = [
            [
                [
                    0.3,
                    3
                ],
                [
                    1.1,
                    0.9
                ],
                [
                    2,
                    0.4
                ],
                [
                    3.4,
                    2.4
                ]
            ],
            [
                [
                    0,
                    0.3
                ],
                [
                    1,
                    2
                ],
                [
                    2.4,
                    1.4
                ],
                [
                    3,
                    0
                ]
            ]
        ];
        const xScale = new (0, $iTJTu._Scene).LinearScale();
        xScale.domain = [
            -0.5,
            4
        ];
        xScale.range = [
            padding * 2,
            size - padding
        ];
        const yScale = new (0, $iTJTu._Scene).LinearScale();
        yScale.domain = [
            -0.5,
            3.5
        ];
        yScale.range = [
            size - padding,
            padding
        ];
        const points = [];
        data.forEach((series)=>{
            series.forEach(([x, y])=>{
                const arc = new (0, $iTJTu._Scene).Arc();
                arc.strokeWidth = 0;
                arc.centerX = xScale.convert(x);
                arc.centerY = yScale.convert(y);
                arc.radius = 2.5;
                points.push(arc);
            });
        });
        this.points = points;
        this.updateColors(fills, strokes);
        const pointsGroup = new (0, $iTJTu._Scene).Group();
        pointsGroup.setClipRectInGroupCoordinateSpace(new (0, $iTJTu._Scene).BBox(padding, padding, size - padding * 2, size - padding * 2));
        pointsGroup.append(this.points);
        this.root.append(pointsGroup);
    }
    updateColors(fills, strokes) {
        this.points.forEach((line, i)=>{
            line.stroke = strokes[i % strokes.length];
            line.fill = fills[i % fills.length];
        });
    }
};
$5b7ccabde48fae90$var$MiniScatter.chartType = "scatter";
var $5b7ccabde48fae90$var$MiniBubble = class extends $5b7ccabde48fae90$var$MiniChartWithAxes {
    constructor(container, fills, strokes){
        super(container, "bubbleTooltip");
        const size = this.size;
        const padding = this.padding;
        const data = [
            [
                [
                    0.1,
                    0.3,
                    5
                ],
                [
                    0.5,
                    0.4,
                    7
                ],
                [
                    0.2,
                    0.8,
                    7
                ]
            ],
            [
                [
                    0.8,
                    0.7,
                    5
                ],
                [
                    0.7,
                    0.3,
                    9
                ]
            ]
        ];
        const xScale = new (0, $iTJTu._Scene).LinearScale();
        xScale.domain = [
            0,
            1
        ];
        xScale.range = [
            padding * 2,
            size - padding
        ];
        const yScale = new (0, $iTJTu._Scene).LinearScale();
        yScale.domain = [
            0,
            1
        ];
        yScale.range = [
            size - padding,
            padding
        ];
        const points = [];
        data.forEach((series)=>{
            series.forEach(([x, y, radius])=>{
                const arc = new (0, $iTJTu._Scene).Arc();
                arc.strokeWidth = 0;
                arc.centerX = xScale.convert(x);
                arc.centerY = yScale.convert(y);
                arc.radius = radius;
                arc.fillOpacity = 0.7;
                points.push(arc);
            });
        });
        this.points = points;
        this.updateColors(fills, strokes);
        const pointsGroup = new (0, $iTJTu._Scene).Group();
        pointsGroup.setClipRectInGroupCoordinateSpace(new (0, $iTJTu._Scene).BBox(padding, padding, size - padding * 2, size - padding * 2));
        pointsGroup.append(this.points);
        this.root.append(pointsGroup);
    }
    updateColors(fills, strokes) {
        this.points.forEach((line, i)=>{
            line.stroke = strokes[i % strokes.length];
            line.fill = fills[i % fills.length];
        });
    }
};
$5b7ccabde48fae90$var$MiniBubble.chartType = "bubble";
var $5b7ccabde48fae90$var$_MiniArea = class _MiniArea2 extends $5b7ccabde48fae90$var$MiniChartWithAxes {
    constructor(container, fills, strokes, _themeTemplateParameters, _isCustomTheme, data = _MiniArea2.data){
        super(container, "groupedAreaTooltip");
        const size = this.size;
        const padding = this.padding;
        const xScale = new (0, $iTJTu._Scene).BandScale();
        xScale.domain = [
            0,
            1,
            2
        ];
        xScale.paddingInner = 1;
        xScale.paddingOuter = 0;
        xScale.range = [
            padding + 0.5,
            size - padding - 0.5
        ];
        const yScale = new (0, $iTJTu._Scene).LinearScale();
        yScale.domain = [
            0,
            6
        ];
        yScale.range = [
            size - padding + 0.5,
            padding
        ];
        const xCount = data.length;
        const last = xCount * 2 - 1;
        const pathData = [];
        const bottomY = yScale.convert(0);
        data.forEach((datum, i)=>{
            const x = xScale.convert(i);
            datum.forEach((yDatum, j)=>{
                const y = yScale.convert(yDatum);
                const points = pathData[j] || (pathData[j] = []);
                points[i] = {
                    x: x,
                    y: y
                };
                points[last - i] = {
                    x: x,
                    y: bottomY
                };
            });
        });
        this.areas = pathData.reverse().map((points)=>{
            const area = new (0, $iTJTu._Scene).Path();
            area.strokeWidth = 1;
            area.strokeOpacity = 0.75;
            area.fillOpacity = 0.7;
            const path = area.path;
            path.clear();
            points.forEach((point, i)=>path[i > 0 ? "lineTo" : "moveTo"](point.x, point.y));
            path.closePath();
            return area;
        });
        this.updateColors(fills, strokes);
        this.root.append(this.areas);
    }
    updateColors(fills, strokes) {
        this.areas.forEach((area, i)=>{
            area.fill = fills[i];
            area.stroke = strokes[i];
        });
    }
};
$5b7ccabde48fae90$var$_MiniArea.chartType = "area";
$5b7ccabde48fae90$var$_MiniArea.data = [
    [
        1,
        3,
        5
    ],
    [
        2,
        6,
        4
    ],
    [
        5,
        3,
        1
    ]
];
var $5b7ccabde48fae90$var$MiniArea = $5b7ccabde48fae90$var$_MiniArea;
var $5b7ccabde48fae90$var$_MiniStackedArea = class _MiniStackedArea2 extends $5b7ccabde48fae90$var$MiniChartWithAxes {
    constructor(container, fills, strokes, _themeTemplateParameters, _isCustomTheme, data = _MiniStackedArea2.data, tooltipName = "stackedAreaTooltip"){
        super(container, tooltipName);
        const size = this.size;
        const padding = this.padding;
        const xScale = new (0, $iTJTu._Scene).BandScale();
        xScale.domain = [
            0,
            1,
            2
        ];
        xScale.paddingInner = 1;
        xScale.paddingOuter = 0;
        xScale.range = [
            padding + 0.5,
            size - padding - 0.5
        ];
        const yScale = new (0, $iTJTu._Scene).LinearScale();
        yScale.domain = [
            0,
            16
        ];
        yScale.range = [
            size - padding + 0.5,
            padding + 0.5
        ];
        const xCount = data.length;
        const last = xCount * 2 - 1;
        const pathData = [];
        data.forEach((datum, i)=>{
            const x = xScale.convert(i);
            let total = 0;
            datum.forEach((yDatum, j)=>{
                const y = yScale.convert(total + yDatum);
                const points = pathData[j] || (pathData[j] = []);
                points[i] = {
                    x: x,
                    y: y
                };
                points[last - i] = {
                    x: x,
                    y: yScale.convert(total)
                };
                total += yDatum;
            });
        });
        this.areas = pathData.map((points)=>{
            const area = new (0, $iTJTu._Scene).Path();
            area.strokeWidth = 0;
            const path = area.path;
            path.clear();
            points.forEach((point, i)=>path[i > 0 ? "lineTo" : "moveTo"](point.x, point.y));
            path.closePath();
            return area;
        });
        this.updateColors(fills, strokes);
        this.root.append(this.areas);
    }
    updateColors(fills, strokes) {
        this.areas.forEach((area, i)=>{
            area.fill = fills[i];
            area.stroke = strokes[i];
        });
    }
};
$5b7ccabde48fae90$var$_MiniStackedArea.chartType = "stackedArea";
$5b7ccabde48fae90$var$_MiniStackedArea.data = [
    [
        2,
        3,
        2
    ],
    [
        3,
        6,
        5
    ],
    [
        6,
        2,
        2
    ]
];
var $5b7ccabde48fae90$var$MiniStackedArea = $5b7ccabde48fae90$var$_MiniStackedArea;
var $5b7ccabde48fae90$var$_MiniNormalizedArea = class _MiniNormalizedArea2 extends $5b7ccabde48fae90$var$MiniStackedArea {
    constructor(container, fills, strokes, themeTemplateParameters, isCustomTheme, data = _MiniNormalizedArea2.data){
        super(container, fills, strokes, themeTemplateParameters, isCustomTheme, data, "normalizedAreaTooltip");
    }
};
$5b7ccabde48fae90$var$_MiniNormalizedArea.chartType = "normalizedArea";
$5b7ccabde48fae90$var$_MiniNormalizedArea.data = $5b7ccabde48fae90$var$MiniStackedArea.data.map((stack)=>{
    const sum = stack.reduce((p, c)=>p + c, 0);
    return stack.map((v)=>v / sum * 16);
});
var $5b7ccabde48fae90$var$MiniNormalizedArea = $5b7ccabde48fae90$var$_MiniNormalizedArea;
var $5b7ccabde48fae90$var$MiniHistogram = class extends $5b7ccabde48fae90$var$MiniChartWithAxes {
    constructor(container, fills, strokes){
        super(container, "histogramTooltip");
        const padding = this.padding;
        const size = this.size;
        const data = [
            2,
            5,
            11,
            13,
            10,
            6,
            1
        ];
        const xScale = new (0, $iTJTu._Scene).LinearScale();
        xScale.domain = [
            0,
            data.length
        ];
        xScale.range = [
            padding,
            size - padding
        ];
        const yScale = new (0, $iTJTu._Scene).LinearScale();
        yScale.domain = [
            0,
            data.reduce((a, b)=>Math.max(a, b), 0)
        ];
        yScale.range = [
            size - padding,
            padding
        ];
        const bottom = yScale.convert(0);
        this.bars = data.map((datum, i)=>{
            const top = yScale.convert(datum);
            const left = xScale.convert(i);
            const right = xScale.convert(i + 1);
            const rect = new (0, $iTJTu._Scene).Rect();
            rect.x = left;
            rect.y = top;
            rect.width = right - left;
            rect.height = bottom - top;
            rect.strokeWidth = 1;
            rect.strokeOpacity = 0.75;
            rect.crisp = true;
            return rect;
        });
        this.updateColors(fills, strokes);
        this.root.append(this.bars);
    }
    updateColors([fill], [stroke]) {
        this.bars.forEach((bar)=>{
            bar.fill = fill;
            bar.stroke = stroke;
        });
    }
};
$5b7ccabde48fae90$var$MiniHistogram.chartType = "histogram";
var $5b7ccabde48fae90$var$MiniChartWithPolarAxes = class extends $5b7ccabde48fae90$var$MiniChart {
    constructor(container, tooltipName){
        super(container, tooltipName);
        this.stroke = "gray";
        this.showRadiusAxisLine = true;
        this.showAngleAxisLines = true;
    }
    addAxes() {
        const size = this.size;
        const padding = this.padding;
        const combinedPadding = padding * 2;
        const axisLineRadius = (size - combinedPadding) / 2;
        const gridRadii = this.showAngleAxisLines ? [
            axisLineRadius,
            axisLineRadius * 0.8,
            axisLineRadius * 0.6,
            axisLineRadius * 0.4
        ] : [];
        const radiusAxisLine = new (0, $iTJTu._Scene).Line();
        radiusAxisLine.x1 = size / 2;
        radiusAxisLine.y1 = padding;
        radiusAxisLine.x2 = size / 2;
        radiusAxisLine.y2 = size - padding - axisLineRadius - gridRadii[gridRadii.length - 1];
        radiusAxisLine.stroke = this.stroke;
        radiusAxisLine.strokeOpacity = 0.5;
        radiusAxisLine.fill = void 0;
        radiusAxisLine.visible = this.showRadiusAxisLine;
        const x = padding + axisLineRadius;
        this.gridLines = gridRadii.map((radius, index)=>{
            const gridLine = new (0, $iTJTu._Scene).Path();
            gridLine.path.arc(x, x, radius, 0, 2 * Math.PI);
            gridLine.strokeWidth = 1;
            gridLine.stroke = this.stroke;
            gridLine.strokeOpacity = index === 0 ? 0.5 : 0.2;
            gridLine.fill = void 0;
            return gridLine;
        });
        const root = this.root;
        root.append(radiusAxisLine);
        if (this.gridLines.length > 0) root.append(this.gridLines);
    }
};
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$MiniChartWithPolarAxes.prototype, "addAxes", 1);
var $5b7ccabde48fae90$var$MiniRadialColumn = class extends $5b7ccabde48fae90$var$MiniChartWithPolarAxes {
    constructor(container, fills, strokes){
        super(container, "radialColumnTooltip");
        this.data = [
            [
                6,
                8,
                10,
                2,
                6,
                5
            ],
            [
                4,
                4,
                3,
                6,
                4,
                4
            ],
            [
                5,
                4,
                2,
                9,
                8,
                9
            ]
        ];
        this.showRadiusAxisLine = false;
        const { padding: padding, size: size, data: data } = this;
        const radius = (size - padding * 2) / 2;
        const innerRadiusRatio = 0.4;
        const axisInnerRadius = radius * innerRadiusRatio;
        const angleScale = new (0, $iTJTu._Scene).BandScale();
        angleScale.domain = data[0].map((_382, index)=>index);
        angleScale.range = [
            0,
            2 * Math.PI
        ];
        angleScale.paddingInner = 0;
        angleScale.paddingOuter = 0;
        const bandwidth = angleScale.bandwidth * 0.7;
        const { processedData: processedData, max: max } = $5b7ccabde48fae90$var$accumulateData(data);
        const radiusScale = new (0, $iTJTu._Scene).LinearScale();
        radiusScale.domain = [
            0,
            max
        ];
        radiusScale.range = [
            axisInnerRadius,
            radius
        ];
        const center = this.size / 2;
        this.series = processedData.map((series, seriesIndex)=>{
            const firstSeries = seriesIndex === 0;
            const previousSeries = firstSeries ? void 0 : processedData[seriesIndex - 1];
            const seriesGroup = new (0, $iTJTu._Scene).Group({
                zIndex: 1e6
            });
            const seriesColumns = series.map((datum, i)=>{
                const previousDatum = previousSeries == null ? void 0 : previousSeries[i];
                const outerRadius = radiusScale.convert(datum);
                const innerRadius = radiusScale.convert(previousDatum != null ? previousDatum : 0);
                const startAngle = angleScale.convert(i);
                const endAngle = startAngle + bandwidth;
                const columnWidth = (0, $iTJTu._Scene).getRadialColumnWidth(startAngle, endAngle, radius, 0.5, 0.5);
                const column = new (0, $iTJTu._Scene).RadialColumnShape();
                column.scalingCenterX = center;
                column.scalingCenterY = center;
                column.columnWidth = columnWidth;
                column.innerRadius = innerRadius;
                column.outerRadius = outerRadius;
                column.startAngle = startAngle;
                column.endAngle = endAngle;
                column.isBeveled = true;
                column.axisInnerRadius = axisInnerRadius;
                column.axisOuterRadius = radius;
                column.stroke = void 0;
                column.strokeWidth = 0;
                return column;
            });
            seriesGroup.append(seriesColumns);
            seriesGroup.translationX = center;
            seriesGroup.translationY = center;
            return seriesGroup;
        });
        this.root.append(this.series);
        this.updateColors(fills, strokes);
    }
    updateColors(fills, strokes) {
        this.series.forEach((group, i)=>{
            var _a;
            (_a = group.children) == null || _a.forEach((sector)=>{
                sector.fill = fills[i % fills.length];
                sector.stroke = strokes[i % strokes.length];
            });
        });
    }
};
$5b7ccabde48fae90$var$MiniRadialColumn.chartType = "radialColumn";
var $5b7ccabde48fae90$var$MiniRadialBar = class extends $5b7ccabde48fae90$var$MiniChartWithPolarAxes {
    constructor(container, fills, strokes){
        super(container, "radialBarTooltip");
        this.data = [
            [
                6,
                8,
                10
            ],
            [
                4,
                4,
                3
            ],
            [
                5,
                4,
                2
            ]
        ];
        this.showRadiusAxisLine = false;
        const radius = (this.size - this.padding) / 2;
        const innerRadiusRatio = 0.4;
        const innerRadius = radius * innerRadiusRatio;
        const totalRadius = radius + innerRadius;
        const radiusScale = new (0, $iTJTu._Scene).BandScale();
        radiusScale.domain = this.data[0].map((_382, index)=>index);
        radiusScale.range = [
            radius,
            innerRadius
        ];
        radiusScale.paddingInner = 0.5;
        radiusScale.paddingOuter = 0;
        const bandwidth = radiusScale.bandwidth;
        const { processedData: processedData, max: max } = $5b7ccabde48fae90$var$accumulateData(this.data);
        const angleScale = new (0, $iTJTu._Scene).LinearScale();
        angleScale.domain = [
            0,
            Math.ceil(max * 1.5)
        ];
        const start = 1.5 * Math.PI;
        const end = start + 2 * Math.PI;
        angleScale.range = [
            start,
            end
        ];
        const center = this.size / 2;
        this.series = processedData.map((series, index)=>{
            const previousSeries = index < 0 ? void 0 : processedData[index - 1];
            const seriesGroup = new (0, $iTJTu._Scene).Group({
                zIndex: 1e6
            });
            const seriesSectors = series.map((datum, i)=>{
                var _a;
                const previousDatum = (_a = previousSeries == null ? void 0 : previousSeries[i]) != null ? _a : 0;
                const innerRadius2 = totalRadius - radiusScale.convert(i);
                const outerRadius = innerRadius2 + bandwidth;
                const startAngle = angleScale.convert(previousDatum);
                const endAngle = angleScale.convert(datum);
                const sector = new (0, $iTJTu._Scene).Sector();
                sector.centerX = center;
                sector.centerY = center;
                sector.innerRadius = innerRadius2;
                sector.outerRadius = outerRadius;
                sector.startAngle = startAngle;
                sector.endAngle = endAngle;
                sector.stroke = void 0;
                sector.strokeWidth = 0;
                return sector;
            });
            seriesGroup.append(seriesSectors);
            return seriesGroup;
        });
        this.root.append(this.series);
        this.updateColors(fills, strokes);
    }
    updateColors(fills, strokes) {
        this.series.forEach((group, i)=>{
            var _a;
            (_a = group.children) == null || _a.forEach((sector)=>{
                sector.fill = fills[i % fills.length];
                sector.stroke = strokes[i % strokes.length];
            });
        });
    }
};
$5b7ccabde48fae90$var$MiniRadialBar.chartType = "radialBar";
var $5b7ccabde48fae90$var$MiniRadarLine = class extends $5b7ccabde48fae90$var$MiniChartWithPolarAxes {
    constructor(container, fills, strokes){
        super(container, "radarLineTooltip");
        this.markerSize = 4;
        this.data = [
            [
                8,
                7,
                8,
                7,
                8,
                8,
                7,
                8
            ],
            [
                6,
                8,
                5,
                10,
                6,
                7,
                4,
                6
            ],
            [
                0,
                3,
                3,
                5,
                4,
                4,
                2,
                0
            ]
        ];
        this.showRadiusAxisLine = false;
        const radius = (this.size - this.padding * 2) / 2;
        const innerRadius = 0;
        const { paths: paths, markers: markers } = $5b7ccabde48fae90$var$createPolarPaths(this.root, this.data, this.size, radius, innerRadius, this.markerSize);
        this.lines = paths;
        this.markers = markers;
        this.updateColors(fills, strokes);
    }
    updateColors(fills, strokes) {
        this.lines.forEach((line, i)=>{
            const n = this.data[i].length;
            line.stroke = fills[i];
            const startIdx = i * n;
            const endIdx = startIdx + n;
            const markers = this.markers.slice(startIdx, endIdx);
            markers.forEach((marker)=>{
                marker.stroke = strokes[i];
                marker.fill = fills[i];
            });
        });
    }
};
$5b7ccabde48fae90$var$MiniRadarLine.chartType = "radarLine";
var $5b7ccabde48fae90$var$MiniRadarArea = class extends $5b7ccabde48fae90$var$MiniChartWithPolarAxes {
    constructor(container, fills, strokes){
        super(container, "radarAreaTooltip");
        this.data = [
            [
                8,
                10,
                5,
                7,
                4,
                1,
                5,
                8
            ],
            [
                1,
                1,
                2,
                7,
                7,
                8,
                10,
                1
            ],
            [
                4,
                5,
                9,
                9,
                4,
                2,
                3,
                4
            ]
        ];
        this.showRadiusAxisLine = false;
        const radius = (this.size - this.padding * 2) / 2;
        const innerRadius = radius - this.size * 0.3;
        this.areas = $5b7ccabde48fae90$var$createPolarPaths(this.root, this.data, this.size, radius, innerRadius).paths;
        this.updateColors(fills, strokes);
    }
    updateColors(fills, strokes) {
        this.areas.forEach((area, i)=>{
            area.fill = fills[i];
            area.stroke = strokes[i];
        });
    }
};
$5b7ccabde48fae90$var$MiniRadarArea.chartType = "radarArea";
var $5b7ccabde48fae90$var$MiniNightingale = class extends $5b7ccabde48fae90$var$MiniChartWithPolarAxes {
    constructor(container, fills, strokes){
        super(container, "nightingaleTooltip");
        this.data = [
            [
                6,
                10,
                9,
                8,
                7,
                8
            ],
            [
                4,
                6,
                5,
                4,
                5,
                5
            ],
            [
                3,
                5,
                4,
                3,
                4,
                7
            ]
        ];
        this.showRadiusAxisLine = false;
        const radius = (this.size - this.padding * 2) / 2;
        const angleScale = new (0, $iTJTu._Scene).BandScale();
        angleScale.domain = this.data[0].map((_382, index)=>index);
        angleScale.range = [
            -Math.PI,
            Math.PI
        ];
        angleScale.paddingInner = 0;
        angleScale.paddingOuter = 0;
        const bandwidth = angleScale.bandwidth * 0.7;
        const { processedData: processedData, max: max } = $5b7ccabde48fae90$var$accumulateData(this.data);
        const radiusScale = new (0, $iTJTu._Scene).LinearScale();
        radiusScale.domain = [
            0,
            max
        ];
        radiusScale.range = [
            0,
            radius
        ];
        const center = this.size / 2;
        this.series = processedData.map((series, index)=>{
            const previousSeries = index < 0 ? void 0 : processedData[index - 1];
            const seriesGroup = new (0, $iTJTu._Scene).Group({
                zIndex: 1e6
            });
            const seriesSectors = series.map((datum, i)=>{
                const previousDatum = previousSeries == null ? void 0 : previousSeries[i];
                const outerRadius = radiusScale.convert(datum);
                const innerRadius = radiusScale.convert(previousDatum != null ? previousDatum : 0);
                const startAngle = angleScale.convert(i);
                const endAngle = startAngle + bandwidth;
                const sector = new (0, $iTJTu._Scene).Sector();
                sector.centerX = center;
                sector.centerY = center;
                sector.innerRadius = innerRadius;
                sector.outerRadius = outerRadius;
                sector.startAngle = startAngle;
                sector.endAngle = endAngle;
                sector.stroke = void 0;
                sector.strokeWidth = 0;
                return sector;
            });
            seriesGroup.append(seriesSectors);
            return seriesGroup;
        });
        this.root.append(this.series);
        this.updateColors(fills, strokes);
    }
    updateColors(fills, strokes) {
        this.series.forEach((group, i)=>{
            var _a;
            (_a = group.children) == null || _a.forEach((sector)=>{
                sector.fill = fills[i % fills.length];
                sector.stroke = strokes[i % strokes.length];
            });
        });
    }
};
$5b7ccabde48fae90$var$MiniNightingale.chartType = "nightingale";
var $5b7ccabde48fae90$var$MiniRangeBar = class extends $5b7ccabde48fae90$var$MiniChartWithAxes {
    constructor(container, fills, strokes){
        super(container, "rangeBarTooltip");
        const data = [
            3,
            3.5,
            3
        ];
        this.bars = this.createRangeBar(this.root, data, this.size, this.padding, "vertical");
        this.updateColors(fills, strokes);
    }
    updateColors(fills, strokes) {
        this.bars.forEach((bar, i)=>{
            bar.fill = fills[i];
            bar.stroke = strokes[i];
        });
    }
    createRangeBar(root, data, size, padding, direction) {
        const barAlongX = direction === "horizontal";
        const scalePadding = 2 * padding;
        const xScale = new (0, $iTJTu._Scene).BandScale();
        xScale.domain = data.map((_382, index)=>index);
        xScale.range = [
            padding,
            size - padding
        ];
        xScale.paddingInner = 0.3;
        xScale.paddingOuter = 0.3;
        const lowRatio = 0.7;
        const highRatio = 1.3;
        const yScale = new (0, $iTJTu._Scene).LinearScale();
        yScale.domain = [
            data.reduce((a, b)=>Math.min(a, b), Infinity) * lowRatio,
            data.reduce((a, b)=>Math.max(a, b), 0) * highRatio
        ];
        yScale.range = [
            scalePadding,
            size - scalePadding
        ];
        const width = xScale.bandwidth;
        const bars = data.map((datum, i)=>{
            const [low, high] = [
                datum * lowRatio,
                datum * highRatio
            ];
            const x = xScale.convert(i);
            const y = yScale.convert(low);
            const height = yScale.convert(high) - y;
            const rect = new (0, $iTJTu._Scene).Rect();
            rect.x = barAlongX ? y : x;
            rect.y = barAlongX ? x : y;
            rect.width = barAlongX ? height : width;
            rect.height = barAlongX ? width : height;
            rect.strokeWidth = 0;
            rect.crisp = true;
            return rect;
        });
        root.append(bars);
        return bars;
    }
};
$5b7ccabde48fae90$var$MiniRangeBar.chartType = "rangeBar";
var $5b7ccabde48fae90$var$MiniRangeArea = class extends $5b7ccabde48fae90$var$MiniChartWithAxes {
    constructor(container, fills, strokes){
        super(container, "rangeAreaTooltip");
        const period = 4;
        const dataSeriesMidpoints = [
            $5b7ccabde48fae90$var$zigzag({
                offset: 0.375 * period,
                length: period,
                pattern: {
                    low: 3,
                    high: 5,
                    period: period
                }
            }),
            $5b7ccabde48fae90$var$zigzag({
                offset: 0.375 * period,
                length: period,
                pattern: {
                    low: 2.25,
                    high: 4.25,
                    period: period
                }
            }),
            $5b7ccabde48fae90$var$zigzag({
                offset: 0.75 * period,
                length: period,
                pattern: {
                    low: 2.5,
                    high: 4.5,
                    period: period
                }
            })
        ];
        const dataSeriesWidth = 1.75;
        const data = dataSeriesMidpoints.map((series)=>series.map(([x, y])=>({
                    x: x,
                    low: y - 0.5 * dataSeriesWidth,
                    high: y + 0.5 * dataSeriesWidth
                })));
        const { lines: lines, areas: areas } = this.createRangeArea(this.root, data, this.size, this.padding);
        this.lines = lines;
        this.areas = areas;
        this.updateColors(fills, strokes);
    }
    updateColors(fills, strokes) {
        fills = $5b7ccabde48fae90$var$swapArrayItems(fills, 1, 2);
        strokes = $5b7ccabde48fae90$var$swapArrayItems(strokes, 1, 2);
        this.lines.forEach(([highLine, lowLine], i)=>{
            highLine.fill = void 0;
            highLine.stroke = strokes[i];
            lowLine.fill = void 0;
            lowLine.stroke = strokes[i];
        });
        this.areas.forEach((area, i)=>{
            area.fill = fills[i];
        });
    }
    createRangeArea(root, data, size, padding) {
        const xMin = data.reduce((acc, series)=>series.reduce((acc2, { x: x })=>Math.min(acc2, x), acc), Infinity);
        const xMax = data.reduce((acc, series)=>series.reduce((acc2, { x: x })=>Math.max(acc2, x), acc), -Infinity);
        const yMin = data.reduce((acc, series)=>series.reduce((acc2, { low: low })=>Math.min(acc2, low), acc), Infinity);
        const yMax = data.reduce((acc, series)=>series.reduce((acc2, { high: high })=>Math.max(acc2, high), acc), -Infinity);
        const xScale = new (0, $iTJTu._Scene).LinearScale();
        xScale.domain = [
            xMin,
            xMax
        ];
        xScale.range = [
            padding,
            size - padding
        ];
        const scalePadding = 2 * padding;
        const yScale = new (0, $iTJTu._Scene).LinearScale();
        yScale.domain = [
            yMin,
            yMax
        ];
        yScale.range = [
            size - scalePadding,
            scalePadding
        ];
        const lines = [];
        const areas = [];
        const lowPoints = data.map((series)=>{
            const highLine = new (0, $iTJTu._Scene).Path();
            const lowLine = new (0, $iTJTu._Scene).Path();
            const area = new (0, $iTJTu._Scene).Path();
            lines.push([
                highLine,
                lowLine
            ]);
            areas.push(area);
            highLine.strokeWidth = 0;
            lowLine.strokeWidth = 0;
            area.strokeWidth = 0;
            area.fillOpacity = 0.8;
            highLine.path.clear();
            lowLine.path.clear();
            area.path.clear();
            return series.map((datum, datumIndex)=>{
                const { x: x, low: low, high: high } = datum;
                const scaledX = xScale.convert(x);
                const yLow = yScale.convert(low);
                const yHigh = yScale.convert(high);
                const command = datumIndex > 0 ? "lineTo" : "moveTo";
                highLine.path[command](scaledX, yHigh);
                lowLine.path[command](scaledX, yLow);
                area.path[command](scaledX, yHigh);
                return [
                    scaledX,
                    yLow
                ];
            });
        });
        lowPoints.forEach((seriesLowPoints, seriesIndex)=>{
            const n = seriesLowPoints.length - 1;
            const area = areas[seriesIndex];
            for(let datumIndex = n; datumIndex >= 0; datumIndex--){
                const [x, y] = seriesLowPoints[datumIndex];
                area.path["lineTo"](x, y);
            }
        });
        root.append(areas.concat(...lines));
        return {
            lines: lines,
            areas: areas
        };
    }
};
$5b7ccabde48fae90$var$MiniRangeArea.chartType = "rangeArea";
function $5b7ccabde48fae90$var$zigzag(options) {
    const { offset: offset, length: length, pattern: pattern } = options;
    const points = getZigzagInflectionPoints(offset, length, pattern);
    const xMin = 0;
    const xMax = length;
    if (points.length === 0 || points[0][0] !== xMin) points.unshift(getZigzagPoint(xMin, offset, pattern));
    if (points[points.length - 1][0] !== xMax) points.push(getZigzagPoint(xMax, offset, pattern));
    return points;
    function getZigzagInflectionPoints(offset2, length2, pattern2) {
        const { period: period } = pattern2;
        const scaledOffset = offset2 / period;
        const patternInflectionPoints = [
            0,
            0.5
        ];
        const inflectionPoints = patternInflectionPoints.map((x)=>x - scaledOffset).map($5b7ccabde48fae90$var$getRemainderAbs).sort((a, b)=>a - b);
        const repeatedPoints = Array.from({
            length: Math.floor(inflectionPoints.length * (period / length2))
        }, (_382, i)=>inflectionPoints[i % inflectionPoints.length] + Math.floor(i / inflectionPoints.length));
        return repeatedPoints.map((x)=>x * period).map((x)=>getZigzagPoint(x, offset2, pattern2));
    }
    function getZigzagPoint(x, offset2, pattern2) {
        return [
            x,
            getZigzagValue(offset2 + x, pattern2)
        ];
    }
    function getZigzagValue(x, pattern2) {
        const { low: low, high: high, period: period } = pattern2;
        const scaledX = $5b7ccabde48fae90$var$getRemainderAbs(x / period);
        const y = scaledX > 0.5 ? 1 - 2 * (scaledX - 0.5) : 2 * scaledX;
        return low + (high - low) * y;
    }
}
function $5b7ccabde48fae90$var$getRemainderAbs(value) {
    const remainder = value % 1;
    return remainder < 0 ? remainder + 1 : remainder;
}
function $5b7ccabde48fae90$var$swapArrayItems(items, leftIndex, rightIndex) {
    const results = [
        ...items
    ];
    const temp = results[leftIndex];
    results[leftIndex] = results[rightIndex];
    results[rightIndex] = temp;
    return results;
}
var $5b7ccabde48fae90$var$MiniBoxPlot = class extends $5b7ccabde48fae90$var$MiniChartWithAxes {
    constructor(container, fills, strokes, themeTemplateParameters, isCustomTheme){
        super(container, "boxPlotTooltip");
        const padding = this.padding;
        const size = this.size;
        const data = [
            11,
            11.5,
            10.5
        ];
        const maxRatio = 1.2;
        const q3Ratio = 1.1;
        const q1Ratio = 0.9;
        const minRatio = 0.8;
        const yScale = new (0, $iTJTu._Scene).LinearScale();
        yScale.domain = [
            data.reduce((a, b)=>Math.min(a, b), Infinity) * minRatio,
            data.reduce((a, b)=>Math.max(a, b), 0) * maxRatio
        ];
        yScale.range = [
            size - 1.5 * padding,
            padding
        ];
        const xScale = new (0, $iTJTu._Scene).BandScale();
        xScale.domain = data.map((_382, index)=>index);
        xScale.range = [
            padding,
            size - padding
        ];
        xScale.paddingInner = 0.4;
        xScale.paddingOuter = 0.2;
        const bandwidth = Math.round(xScale.bandwidth);
        const halfBandWidth = Math.round(xScale.bandwidth / 2);
        this.boxPlotGroups = data.map((datum, i)=>{
            let [minValue, q1Value, q3Value, maxValue] = [
                datum * minRatio,
                datum * q1Ratio,
                datum * q3Ratio,
                datum * maxRatio
            ];
            const top = Math.round(yScale.convert(q3Value));
            const left = Math.round(xScale.convert(i));
            const right = Math.round(left + bandwidth);
            const bottom = Math.round(yScale.convert(q1Value));
            const min = Math.round(yScale.convert(minValue));
            const mid = Math.round(yScale.convert(datum));
            const max = Math.round(yScale.convert(maxValue));
            const whiskerX = left + halfBandWidth;
            const boxPlotGroup = new (0, $iTJTu._Scene).Group();
            const box = new (0, $iTJTu._Scene).Rect();
            const median = new (0, $iTJTu._Scene).Line();
            const topWhisker = new (0, $iTJTu._Scene).Line();
            const bottomWhisker = new (0, $iTJTu._Scene).Line();
            const topCap = new (0, $iTJTu._Scene).Line();
            const bottomCap = new (0, $iTJTu._Scene).Line();
            box.x = left;
            box.y = top;
            box.width = bandwidth;
            box.height = bottom - top;
            box.strokeWidth = 1;
            box.strokeOpacity = 0.75;
            box.crisp = true;
            this.setLineProperties(median, left, right, mid, mid);
            this.setLineProperties(topWhisker, whiskerX, whiskerX, max, top);
            this.setLineProperties(bottomWhisker, whiskerX, whiskerX, min, bottom);
            this.setLineProperties(topCap, left, right, max, max);
            this.setLineProperties(bottomCap, left, right, min, min);
            boxPlotGroup.append([
                box,
                median,
                topWhisker,
                bottomWhisker,
                topCap,
                bottomCap
            ]);
            return boxPlotGroup;
        });
        this.updateColors(fills, strokes, themeTemplateParameters, isCustomTheme);
        this.root.append(this.boxPlotGroups);
    }
    updateColors(fills, strokes, themeTemplateParameters, isCustomTheme) {
        var _a;
        const themeBackgroundColor = themeTemplateParameters == null ? void 0 : themeTemplateParameters.properties.get((0, $iTJTu._Theme).DEFAULT_BACKGROUND_COLOUR);
        const backgroundFill = (_a = Array.isArray(themeBackgroundColor) ? themeBackgroundColor[0] : themeBackgroundColor) != null ? _a : "white";
        this.boxPlotGroups.forEach((group, i)=>{
            var _a2;
            (_a2 = group.children) == null || _a2.forEach((node)=>{
                const fill = fills[i % fills.length];
                node.fill = isCustomTheme ? fill : (0, $iTJTu._Util).Color.interpolate(fill, backgroundFill)(0.7);
                node.stroke = strokes[i % strokes.length];
            });
        });
    }
    setLineProperties(line, x1, x2, y1, y2) {
        line.x1 = x1;
        line.x2 = x2;
        line.y1 = y1;
        line.y2 = y2;
        line.strokeOpacity = 0.75;
    }
};
$5b7ccabde48fae90$var$MiniBoxPlot.chartType = "boxPlot";
var $5b7ccabde48fae90$var$MiniTreemap = class extends $5b7ccabde48fae90$var$MiniChart {
    constructor(container, fills, strokes, themeTemplate, isCustomTheme){
        super(container, "treemapTooltip");
        const { size: size, padding: padding } = this;
        const data = [
            [
                1,
                1
            ],
            [
                3,
                2,
                1
            ]
        ];
        const treeSize = data.length;
        const treePadding = treeSize % 2 === 0 ? 0.3 : 0.2;
        const range = [
            padding,
            size - padding
        ];
        const columns = data.length;
        const columnParts = columns * (columns + 1) / 2;
        const columnPadding = treePadding / (columns - 1);
        const availableRange = range[1] - range[0];
        const availableWidth = availableRange - treePadding;
        let previousX = range[0];
        this.rects = data.reduce((rects, d, columnIndex)=>{
            rects != null ? rects : rects = [];
            const widthRatio = (columns - columnIndex) / columnParts;
            const width = availableWidth * widthRatio;
            const rows = d.length;
            const rowParts = d.reduce((parts, ratio)=>parts += ratio, 0);
            const rowPadding = treePadding / (rows - 1 || 1);
            const availableHeight = rows > 1 ? availableRange - treePadding : availableRange;
            let previousY = range[0];
            const xRects = d.map((ratio)=>{
                const rect = new (0, $iTJTu._Scene).Rect();
                const height = availableHeight * ratio / rowParts;
                rect.x = previousX;
                rect.y = previousY;
                rect.width = width;
                rect.height = height;
                rect.strokeWidth = 0.75;
                rect.crisp = true;
                previousY += height + rowPadding;
                return rect;
            });
            previousX += width + columnPadding;
            rects.push(...xRects);
            return rects;
        }, []);
        this.updateColors(fills, strokes, themeTemplate, isCustomTheme);
        const rectGroup = new (0, $iTJTu._Scene).Group();
        rectGroup.setClipRectInGroupCoordinateSpace(new (0, $iTJTu._Scene).BBox(padding, padding, size - padding, size - padding));
        rectGroup.append(this.rects);
        this.root.append(rectGroup);
    }
    updateColors(fills, strokes, themeTemplate, isCustomTheme) {
        var _a;
        const { properties: properties } = themeTemplate != null ? themeTemplate : {};
        const defaultBackgroundColor = properties == null ? void 0 : properties.get((0, $iTJTu._Theme).DEFAULT_BACKGROUND_COLOUR);
        const backgroundFill = (_a = Array.isArray(defaultBackgroundColor) ? defaultBackgroundColor[0] : defaultBackgroundColor) != null ? _a : "white";
        this.rects.forEach((rect, i)=>{
            rect.fill = fills[i % strokes.length];
            rect.stroke = isCustomTheme ? strokes[i % strokes.length] : backgroundFill;
        });
    }
};
$5b7ccabde48fae90$var$MiniTreemap.chartType = "treemap";
var $5b7ccabde48fae90$var$MiniSunburst = class extends $5b7ccabde48fae90$var$MiniChartWithPolarAxes {
    constructor(container, fills, strokes){
        super(container, "sunburstTooltip");
        this.data = [
            [
                [],
                []
            ],
            [
                [],
                []
            ],
            [
                [],
                []
            ]
        ];
        this.angleOffset = -Math.PI / 2;
        this.innerRadiusRatio = 0;
        this.showRadiusAxisLine = false;
        this.showAngleAxisLines = false;
        const { data: data, size: size, padding: padding, angleOffset: angleOffset, innerRadiusRatio: innerRadiusRatio } = this;
        const radius = (size - padding * 2) / 2;
        const angleRange = [
            angleOffset + 0,
            angleOffset + 2 * Math.PI
        ];
        const angleExtent = Math.abs(angleRange[1] - angleRange[0]);
        const radiusRange = [
            radius * innerRadiusRatio,
            radius
        ];
        const radiusExtent = Math.abs(radiusRange[1] - radiusRange[0]);
        let maxDepth = 0;
        const findMaxDepth = (data2, parentDepth)=>{
            data2.forEach((child)=>{
                const depth = parentDepth + 1;
                maxDepth = Math.max(maxDepth, depth);
                findMaxDepth(child, depth);
            });
        };
        findMaxDepth(data, 0);
        const radiusRatio = radiusExtent / maxDepth;
        const center = this.size / 2;
        const startAngle = angleRange[0];
        this.series = [];
        const createSectors = (data2, depth, startAngle2, availableAngle, group)=>{
            const isArray = Array.isArray(data2);
            if (!isArray) return;
            const childDepth = depth + 1;
            let previousAngle = startAngle2;
            data2.forEach((child, childIndex, children)=>{
                let childGroup = group;
                if (!childGroup) {
                    childGroup = new (0, $iTJTu._Scene).Group();
                    this.series.push(childGroup);
                }
                const innerRadius = radiusRange[0] + depth * radiusRatio;
                const outerRadius = radiusRange[0] + childDepth * radiusRatio;
                const angleRatio = 1 / children.length;
                const start = previousAngle;
                const end = start + availableAngle * angleRatio;
                const sector = new (0, $iTJTu._Scene).Sector();
                sector.centerX = center;
                sector.centerY = center;
                sector.innerRadius = innerRadius;
                sector.outerRadius = outerRadius;
                sector.startAngle = start;
                sector.endAngle = end;
                sector.stroke = void 0;
                sector.strokeWidth = 0;
                sector.inset = 0.75;
                previousAngle = end;
                childGroup.append(sector);
                createSectors(child, childDepth, start, Math.abs(end - start), childGroup);
            });
        };
        createSectors(data, 0, startAngle, angleExtent);
        this.root.append(this.series);
        this.updateColors(fills, strokes);
    }
    updateColors(fills, strokes) {
        this.series.forEach((group, i)=>{
            var _a;
            (_a = group.children) == null || _a.forEach((sector)=>{
                sector.fill = fills[i % fills.length];
                sector.stroke = strokes[i % strokes.length];
            });
        });
    }
};
$5b7ccabde48fae90$var$MiniSunburst.chartType = "sunburst";
var $5b7ccabde48fae90$var$MiniHeatmap = class extends $5b7ccabde48fae90$var$MiniChart {
    constructor(container, fills, strokes, themeTemplate, isCustomTheme){
        var _a, _b;
        super(container, "heatmapTooltip");
        const { size: size, padding: padding } = this;
        const heatmapSize = 3;
        const data = Array.from({
            length: heatmapSize
        }, (_382, __)=>Array.from({
                length: heatmapSize
            }, (_392, yIndex)=>yIndex));
        const domain = data.map((_382, index)=>index);
        const xScale = new (0, $iTJTu._Scene).BandScale();
        xScale.domain = domain;
        xScale.range = [
            padding,
            size - padding
        ];
        xScale.paddingInner = 0.01;
        xScale.paddingOuter = 0.1;
        const yScale = new (0, $iTJTu._Scene).BandScale();
        yScale.domain = domain;
        yScale.range = [
            padding,
            size - padding
        ];
        yScale.paddingInner = 0.01;
        yScale.paddingOuter = 0.1;
        const width = (_a = xScale.bandwidth) != null ? _a : 0;
        const height = (_b = yScale.bandwidth) != null ? _b : 0;
        this.rects = data.reduce((rects, d, index)=>{
            rects != null ? rects : rects = [];
            const xRects = d.map((_382, yIndex)=>{
                const rect = new (0, $iTJTu._Scene).Rect();
                rect.x = xScale.convert(index);
                rect.y = yScale.convert(yIndex);
                rect.width = width;
                rect.height = height;
                rect.strokeWidth = 0;
                rect.crisp = true;
                return rect;
            });
            rects.push(...xRects);
            return rects;
        }, []);
        this.updateColors(fills, strokes, themeTemplate, isCustomTheme);
        const rectGroup = new (0, $iTJTu._Scene).Group();
        rectGroup.setClipRectInGroupCoordinateSpace(new (0, $iTJTu._Scene).BBox(padding, padding, size - padding, size - padding));
        rectGroup.append(this.rects);
        this.root.append(rectGroup);
    }
    updateColors(fills, strokes, themeTemplate, isCustomTheme) {
        var _a;
        const { properties: properties } = themeTemplate != null ? themeTemplate : {};
        const defaultColorRange = properties == null ? void 0 : properties.get((0, $iTJTu._Theme).DEFAULT_DIVERGING_SERIES_COLOUR_RANGE);
        const defaultBackgroundColor = properties == null ? void 0 : properties.get((0, $iTJTu._Theme).DEFAULT_BACKGROUND_COLOUR);
        const backgroundFill = (_a = Array.isArray(defaultBackgroundColor) ? defaultBackgroundColor[0] : defaultBackgroundColor) != null ? _a : "white";
        const colorRange = isCustomTheme ? [
            fills[0],
            fills[1]
        ] : defaultColorRange;
        const stroke = isCustomTheme ? strokes[0] : backgroundFill;
        this.rects.forEach((rect, i)=>{
            rect.fill = (0, $iTJTu._Util).Color.interpolate(colorRange[0], colorRange[1])(i * 0.2);
            rect.stroke = stroke;
        });
    }
};
$5b7ccabde48fae90$var$MiniHeatmap.chartType = "heatmap";
var $5b7ccabde48fae90$var$MiniWaterfall = class extends $5b7ccabde48fae90$var$MiniChartWithAxes {
    constructor(container, fills, strokes, themeTemplate, isCustomTheme){
        super(container, "waterfallTooltip");
        this.data = [
            4,
            3,
            -3,
            6,
            -3
        ];
        this.bars = this.createWaterfall(this.root, this.data, this.size, this.padding, "vertical").bars;
        this.updateColors(fills, strokes, themeTemplate, isCustomTheme);
    }
    updateColors(fills, strokes, themeTemplate, isCustomTheme) {
        var _a, _b;
        const { data: data } = this;
        const { properties: properties } = themeTemplate != null ? themeTemplate : {};
        const palettePositive = {
            fill: fills[0],
            stroke: strokes[0]
        };
        const paletteNegative = {
            fill: fills[1],
            stroke: strokes[1]
        };
        const positive = isCustomTheme ? palettePositive : (_a = properties == null ? void 0 : properties.get((0, $iTJTu._Theme).DEFAULT_WATERFALL_SERIES_POSITIVE_COLOURS)) != null ? _a : palettePositive;
        const negative = isCustomTheme ? paletteNegative : (_b = properties == null ? void 0 : properties.get((0, $iTJTu._Theme).DEFAULT_WATERFALL_SERIES_NEGATIVE_COLOURS)) != null ? _b : paletteNegative;
        this.bars.forEach((bar, i)=>{
            const isPositive = data[i] >= 0;
            bar.fill = isPositive ? positive.fill : negative.fill;
            bar.stroke = isPositive ? positive.stroke : negative.stroke;
        });
    }
    createWaterfall(root, data, size, padding, direction) {
        const scalePadding = 2 * padding;
        const { processedData: processedData, min: min, max: max } = $5b7ccabde48fae90$var$accumulateData(data.map((d)=>[
                d
            ]));
        const flatData = processedData.reduce((flat, d)=>flat.concat(d), []);
        const yScale = new (0, $iTJTu._Scene).LinearScale();
        yScale.domain = [
            Math.min(min, 0),
            max
        ];
        yScale.range = [
            size - scalePadding,
            scalePadding
        ];
        const xScale = new (0, $iTJTu._Scene).BandScale();
        xScale.domain = data.map((_382, index)=>index);
        xScale.range = [
            padding,
            size - padding
        ];
        xScale.paddingInner = 0.2;
        xScale.paddingOuter = 0.3;
        const width = xScale.bandwidth;
        const connectorLine = new (0, $iTJTu._Scene).Path();
        connectorLine.stroke = "#575757";
        connectorLine.strokeWidth = 0;
        const pixelAlignmentOffset = Math.floor(connectorLine.strokeWidth) % 2 / 2;
        const connectorPath = connectorLine.path;
        connectorPath.clear();
        const barAlongX = direction === "horizontal";
        const bars = flatData.map((datum, i)=>{
            const previousDatum = i > 0 ? flatData[i - 1] : 0;
            const rawValue = data[i];
            const isPositive = rawValue > 0;
            const currY = Math.round(yScale.convert(datum));
            const trailY = Math.round(yScale.convert(previousDatum));
            const y = (isPositive ? currY : trailY) - pixelAlignmentOffset;
            const bottomY = (isPositive ? trailY : currY) + pixelAlignmentOffset;
            const height = Math.abs(bottomY - y);
            const x = xScale.convert(i);
            const rect = new (0, $iTJTu._Scene).Rect();
            rect.x = barAlongX ? y : x;
            rect.y = barAlongX ? x : y;
            rect.width = barAlongX ? height : width;
            rect.height = barAlongX ? width : height;
            rect.strokeWidth = 0;
            rect.crisp = true;
            const moveTo = currY + pixelAlignmentOffset;
            const lineTo = trailY + pixelAlignmentOffset;
            if (i > 0) {
                const lineToX = barAlongX ? lineTo : rect.x;
                const lineToY = barAlongX ? rect.y : lineTo;
                connectorPath.lineTo(lineToX, lineToY);
            }
            const moveToX = barAlongX ? moveTo : rect.x;
            const moveToY = barAlongX ? rect.y : moveTo;
            connectorPath.moveTo(moveToX, moveToY);
            return rect;
        });
        root.append([
            connectorLine,
            ...bars
        ]);
        return {
            bars: bars
        };
    }
};
$5b7ccabde48fae90$var$MiniWaterfall.chartType = "waterfall";
var $5b7ccabde48fae90$var$MiniColumnLineCombo = class extends $5b7ccabde48fae90$var$MiniChartWithAxes {
    constructor(container, fills, strokes){
        super(container, "columnLineComboTooltip");
        this.columnData = [
            3,
            4
        ];
        this.lineData = [
            [
                5,
                4,
                6,
                5,
                4
            ]
        ];
        const { root: root, columnData: columnData, lineData: lineData, size: size, padding: padding } = this;
        this.columns = $5b7ccabde48fae90$var$createColumnRects({
            stacked: false,
            root: root,
            data: columnData,
            size: size,
            padding: padding,
            xScaleDomain: [
                0,
                1
            ],
            yScaleDomain: [
                0,
                4
            ],
            xScalePadding: 0.5
        });
        root.append(this.columns);
        this.lines = $5b7ccabde48fae90$var$createLinePaths(root, lineData, size, padding);
        this.updateColors(fills, strokes);
    }
    updateColors(fills, strokes) {
        this.columns.forEach((bar, i)=>{
            bar.fill = fills[i];
            bar.stroke = strokes[i];
        });
        this.lines.forEach((line, i)=>{
            line.stroke = fills[i + 2];
        });
    }
};
$5b7ccabde48fae90$var$MiniColumnLineCombo.chartType = "columnLineCombo";
var $5b7ccabde48fae90$var$MiniAreaColumnCombo = class extends $5b7ccabde48fae90$var$MiniChartWithAxes {
    constructor(container, fills, strokes){
        super(container, "areaColumnComboTooltip");
        this.columnData = [
            3,
            4.5
        ];
        this.areaData = [
            [
                5,
                4,
                6,
                5,
                4
            ]
        ];
        const { root: root, columnData: columnData, areaData: areaData, size: size, padding: padding } = this;
        this.columns = $5b7ccabde48fae90$var$createColumnRects({
            stacked: false,
            root: root,
            data: columnData,
            size: size,
            padding: padding,
            xScaleDomain: [
                0,
                1
            ],
            yScaleDomain: [
                0,
                6
            ],
            xScalePadding: 0.5
        });
        const xScale = new (0, $iTJTu._Scene).BandScale();
        xScale.range = [
            padding,
            size - padding
        ];
        xScale.domain = [
            0,
            1,
            2,
            3,
            4
        ];
        xScale.paddingInner = 1;
        xScale.paddingOuter = 0;
        const yScale = new (0, $iTJTu._Scene).LinearScale();
        yScale.range = [
            size - padding,
            padding
        ];
        yScale.domain = [
            0,
            6
        ];
        const pathData = [];
        const yZero = yScale.convert(0);
        const firstX = xScale.convert(0);
        areaData.forEach((series, i)=>{
            const points = pathData[i] || (pathData[i] = []);
            series.forEach((data, j)=>{
                const yDatum = data;
                const xDatum = j;
                const x = xScale.convert(xDatum);
                const y = yScale.convert(yDatum);
                points[j] = {
                    x: x,
                    y: y
                };
            });
            const lastX = xScale.convert(series.length - 1);
            pathData[i].push({
                x: lastX,
                y: yZero
            }, {
                x: firstX,
                y: yZero
            });
        });
        this.areas = pathData.map((points)=>{
            const area = new (0, $iTJTu._Scene).Path();
            area.strokeWidth = 0;
            area.fillOpacity = 0.8;
            const path = area.path;
            points.forEach((point, i)=>path[i > 0 ? "lineTo" : "moveTo"](point.x, point.y));
            return area;
        });
        root.append(this.areas);
        root.append([].concat.apply([], this.columns));
        this.updateColors(fills, strokes);
    }
    updateColors(fills, strokes) {
        this.areas.forEach((area, i)=>{
            area.fill = fills[i];
            area.stroke = strokes[i];
        });
        this.columns.forEach((bar, i)=>{
            bar.fill = fills[i + 1];
            bar.stroke = strokes[i + 1];
        });
    }
};
$5b7ccabde48fae90$var$MiniAreaColumnCombo.chartType = "areaColumnCombo";
var $5b7ccabde48fae90$var$MiniCustomCombo = class extends $5b7ccabde48fae90$var$MiniChart {
    constructor(container, fills, strokes){
        super(container, "customComboTooltip");
        this.columnData = [
            3,
            4
        ];
        this.lineData = [
            [
                5,
                4,
                6,
                5,
                4
            ]
        ];
        const { root: root, columnData: columnData, lineData: lineData, size: size, padding: padding } = this;
        this.columns = $5b7ccabde48fae90$var$createColumnRects({
            stacked: false,
            root: root,
            data: columnData,
            size: size,
            padding: padding,
            xScaleDomain: [
                0,
                1
            ],
            yScaleDomain: [
                0,
                4
            ],
            xScalePadding: 0.5
        });
        root.append(this.columns);
        this.lines = $5b7ccabde48fae90$var$createLinePaths(root, lineData, size, padding);
        const axisStroke = "grey";
        const axisOvershoot = 3;
        const leftAxis = new (0, $iTJTu._Scene).Line();
        leftAxis.x1 = padding;
        leftAxis.y1 = padding;
        leftAxis.x2 = padding;
        leftAxis.y2 = size - padding + axisOvershoot;
        leftAxis.stroke = axisStroke;
        const bottomAxis = new (0, $iTJTu._Scene).Line();
        bottomAxis.x1 = padding - axisOvershoot + 1;
        bottomAxis.y1 = size - padding;
        bottomAxis.x2 = size - padding + 1;
        bottomAxis.y2 = size - padding;
        bottomAxis.stroke = axisStroke;
        const penIcon = new (0, $iTJTu._Scene).Path();
        this.buildPenIconPath(penIcon);
        penIcon.fill = "whitesmoke";
        penIcon.stroke = "darkslategrey";
        penIcon.strokeWidth = 1;
        root.append([
            bottomAxis,
            leftAxis,
            penIcon
        ]);
        this.updateColors(fills, strokes);
    }
    updateColors(fills, strokes) {
        this.columns.forEach((bar, i)=>{
            bar.fill = fills[i];
            bar.stroke = strokes[i];
        });
        this.lines.forEach((line, i)=>{
            line.stroke = fills[i + 2];
        });
    }
    buildPenIconPath(penIcon) {
        const { path: path } = penIcon;
        path.moveTo(25.76, 43.46);
        path.lineTo(31.27, 48.53);
        path.moveTo(49.86, 22);
        path.lineTo(49.86, 22);
        path.cubicCurveTo(49.01994659053345, 21.317514933510974, 47.89593834348529, 21.09645997825817, 46.86, 21.41);
        path.lineTo(46.86, 21.41);
        path.cubicCurveTo(45.55460035985361, 21.77260167850787, 44.38777081121966, 22.517979360321792, 43.51, 23.55);
        path.lineTo(25.51, 43.8);
        path.lineTo(25.43, 43.89);
        path.lineTo(23.01, 51.89);
        path.lineTo(22.83, 52.46);
        path.lineTo(31.02, 48.86);
        path.lineTo(49.02, 28.52);
        path.lineTo(49.02, 28.52);
        path.cubicCurveTo(49.940716461596224, 27.521914221246085, 50.54302631059587, 26.2720342455763, 50.75, 24.93);
        path.lineTo(50.75, 24.93);
        path.cubicCurveTo(50.95363374988308, 23.866379846512814, 50.62080640232334, 22.77066734274871, 49.86, 22);
        path.closePath();
        path.moveTo(41.76, 25.5);
        path.lineTo(47.34, 30.5);
        path.moveTo(40.74, 26.65);
        path.lineTo(46.25, 31.71);
    }
};
$5b7ccabde48fae90$var$MiniCustomCombo.chartType = "customCombo";
var $5b7ccabde48fae90$var$miniChartMapping = {
    columnGroup: {
        column: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniColumn
        },
        stackedColumn: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniStackedColumn
        },
        normalizedColumn: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniNormalizedColumn
        }
    },
    barGroup: {
        bar: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniBar
        },
        stackedBar: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniStackedBar
        },
        normalizedBar: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniNormalizedBar
        }
    },
    pieGroup: {
        pie: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniPie
        },
        donut: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniDonut
        },
        doughnut: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniDonut
        }
    },
    lineGroup: {
        line: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniLine
        }
    },
    scatterGroup: {
        scatter: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniScatter
        },
        bubble: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniBubble
        }
    },
    areaGroup: {
        area: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniArea
        },
        stackedArea: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniStackedArea
        },
        normalizedArea: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniNormalizedArea
        }
    },
    polarGroup: {
        radarLine: {
            range: true,
            pivot: false,
            enterprise: true,
            icon: $5b7ccabde48fae90$var$MiniRadarLine
        },
        radarArea: {
            range: true,
            pivot: false,
            enterprise: true,
            icon: $5b7ccabde48fae90$var$MiniRadarArea
        },
        nightingale: {
            range: true,
            pivot: false,
            enterprise: true,
            icon: $5b7ccabde48fae90$var$MiniNightingale
        },
        radialColumn: {
            range: true,
            pivot: false,
            enterprise: true,
            icon: $5b7ccabde48fae90$var$MiniRadialColumn
        },
        radialBar: {
            range: true,
            pivot: false,
            enterprise: true,
            icon: $5b7ccabde48fae90$var$MiniRadialBar
        }
    },
    statisticalGroup: {
        boxPlot: {
            range: true,
            pivot: false,
            enterprise: true,
            icon: $5b7ccabde48fae90$var$MiniBoxPlot
        },
        histogram: {
            range: true,
            pivot: false,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniHistogram
        },
        rangeBar: {
            range: true,
            pivot: false,
            enterprise: true,
            icon: $5b7ccabde48fae90$var$MiniRangeBar
        },
        rangeArea: {
            range: true,
            pivot: false,
            enterprise: true,
            icon: $5b7ccabde48fae90$var$MiniRangeArea
        }
    },
    hierarchicalGroup: {
        treemap: {
            range: true,
            pivot: true,
            enterprise: true,
            icon: $5b7ccabde48fae90$var$MiniTreemap
        },
        sunburst: {
            range: true,
            pivot: true,
            enterprise: true,
            icon: $5b7ccabde48fae90$var$MiniSunburst
        }
    },
    specializedGroup: {
        heatmap: {
            range: true,
            pivot: false,
            enterprise: true,
            icon: $5b7ccabde48fae90$var$MiniHeatmap
        },
        waterfall: {
            range: true,
            pivot: false,
            enterprise: true,
            icon: $5b7ccabde48fae90$var$MiniWaterfall
        }
    },
    combinationGroup: {
        columnLineCombo: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniColumnLineCombo
        },
        areaColumnCombo: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniAreaColumnCombo
        },
        customCombo: {
            range: true,
            pivot: true,
            enterprise: false,
            icon: $5b7ccabde48fae90$var$MiniCustomCombo
        }
    }
};
var $5b7ccabde48fae90$var$DEFAULT_CHART_GROUPS = {
    columnGroup: [
        "column",
        "stackedColumn",
        "normalizedColumn"
    ],
    barGroup: [
        "bar",
        "stackedBar",
        "normalizedBar"
    ],
    pieGroup: [
        "pie",
        "donut"
    ],
    lineGroup: [
        "line"
    ],
    scatterGroup: [
        "scatter",
        "bubble"
    ],
    areaGroup: [
        "area",
        "stackedArea",
        "normalizedArea"
    ],
    polarGroup: [
        "radarLine",
        "radarArea",
        "nightingale",
        "radialColumn",
        "radialBar"
    ],
    statisticalGroup: [
        "boxPlot",
        "histogram",
        "rangeBar",
        "rangeArea"
    ],
    hierarchicalGroup: [
        "treemap",
        "sunburst"
    ],
    specializedGroup: [
        "heatmap",
        "waterfall"
    ],
    combinationGroup: [
        "columnLineCombo",
        "areaColumnCombo",
        "customCombo"
    ]
};
var $5b7ccabde48fae90$var$_MiniChartsContainer = class _MiniChartsContainer2 extends (0, $jIDNV.Component) {
    constructor(chartController, fills, strokes, themeTemplateParameters, isCustomTheme, chartGroups = $5b7ccabde48fae90$var$DEFAULT_CHART_GROUPS){
        super(_MiniChartsContainer2.TEMPLATE);
        this.wrappers = {};
        this.chartController = chartController;
        this.fills = fills;
        this.strokes = strokes;
        this.themeTemplateParameters = themeTemplateParameters;
        this.isCustomTheme = isCustomTheme;
        this.chartGroups = $5b7ccabde48fae90$var$__spreadValues3({}, chartGroups);
    }
    init() {
        if (!this.chartController.customComboExists() && this.chartGroups.combinationGroup) this.chartGroups.combinationGroup = this.chartGroups.combinationGroup.filter((chartType)=>chartType !== "customCombo");
        const eGui = this.getGui();
        const isEnterprise = this.chartController.isEnterprise();
        const isPivotChart = this.chartController.isPivotChart();
        const isRangeChart = !isPivotChart;
        const displayedMenuGroups = Object.keys(this.chartGroups).map((group)=>{
            var _a;
            const menuGroup = group in $5b7ccabde48fae90$var$miniChartMapping ? $5b7ccabde48fae90$var$miniChartMapping[group] : void 0;
            if (!menuGroup) {
                (0, $jIDNV._).warnOnce(`invalid chartGroupsDef config '${group}'`);
                return null;
            }
            const chartGroupValues = (_a = this.chartGroups[group]) != null ? _a : [];
            const menuItems = chartGroupValues.map((chartType)=>{
                const menuItem = chartType in menuGroup ? menuGroup[chartType] : void 0;
                if (!menuItem) {
                    (0, $jIDNV._).warnOnce(`invalid chartGroupsDef config '${group}.${chartType}'`);
                    return null;
                }
                if (!isEnterprise && menuItem.enterprise) return null;
                if (isRangeChart && menuItem.range) return menuItem;
                if (isPivotChart && menuItem.pivot) return menuItem;
                return null;
            }).filter((menuItem)=>menuItem != null);
            if (menuItems.length === 0) return null;
            return {
                label: this.chartTranslationService.translate(group),
                items: menuItems
            };
        }).filter((menuGroup)=>menuGroup != null);
        for (const { label: label, items: items } of displayedMenuGroups){
            const groupComponent = this.createBean(new (0, $jIDNV.AgGroupComponent)({
                title: label,
                suppressEnabledCheckbox: true,
                enabled: true,
                suppressOpenCloseIcons: true,
                cssIdentifier: "charts-settings",
                direction: "horizontal"
            }));
            for (const menuItem of items){
                const MiniClass = menuItem.icon;
                const miniWrapper = document.createElement("div");
                miniWrapper.classList.add("ag-chart-mini-thumbnail");
                const miniClassChartType = MiniClass.chartType;
                this.addManagedListener(miniWrapper, "click", ()=>{
                    this.chartController.setChartType(miniClassChartType);
                    this.updateSelectedMiniChart();
                });
                this.wrappers[miniClassChartType] = miniWrapper;
                this.createBean(new MiniClass(miniWrapper, this.fills, this.strokes, this.themeTemplateParameters, this.isCustomTheme));
                groupComponent.addItem(miniWrapper);
            }
            eGui.appendChild(groupComponent.getGui());
        }
        this.updateSelectedMiniChart();
    }
    updateSelectedMiniChart() {
        const selectedChartType = this.chartController.getChartType();
        for(const miniChartType in this.wrappers){
            const miniChart = this.wrappers[miniChartType];
            const selected = miniChartType === selectedChartType;
            miniChart.classList.toggle("ag-selected", selected);
        }
    }
};
$5b7ccabde48fae90$var$_MiniChartsContainer.TEMPLATE = /* html */ `<div class="ag-chart-settings-mini-wrapper"></div>`;
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartTranslationService")
], $5b7ccabde48fae90$var$_MiniChartsContainer.prototype, "chartTranslationService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_MiniChartsContainer.prototype, "init", 1);
var $5b7ccabde48fae90$var$MiniChartsContainer = $5b7ccabde48fae90$var$_MiniChartsContainer;
var $5b7ccabde48fae90$var$_ChartSettingsPanel = class _ChartSettingsPanel2 extends (0, $jIDNV.Component) {
    constructor(chartController){
        super(_ChartSettingsPanel2.TEMPLATE);
        this.chartController = chartController;
        this.miniChartsContainers = [];
        this.cardItems = [];
        this.activePaletteIndex = 0;
        this.palettes = [];
        this.themes = [];
    }
    postConstruct() {
        this.resetPalettes();
        this.ePrevBtn.insertAdjacentElement("afterbegin", (0, $jIDNV._).createIconNoSpan("previous", this.gos));
        this.eNextBtn.insertAdjacentElement("afterbegin", (0, $jIDNV._).createIconNoSpan("next", this.gos));
        this.addManagedListener(this.ePrevBtn, "click", ()=>this.setActivePalette(this.getPrev(), "left"));
        this.addManagedListener(this.eNextBtn, "click", ()=>this.setActivePalette(this.getNext(), "right"));
        this.addManagedListener(this.chartController, $5b7ccabde48fae90$var$ChartController.EVENT_CHART_TYPE_CHANGED, ()=>this.resetPalettes(true));
        this.addManagedListener(this.chartController, $5b7ccabde48fae90$var$ChartController.EVENT_CHART_API_UPDATE, ()=>this.resetPalettes(true));
        this.scrollSelectedIntoView();
    }
    scrollSelectedIntoView() {
        setTimeout(()=>{
            const isMiniChartsContainerVisible = (miniChartsContainers)=>{
                return !miniChartsContainers.getGui().classList.contains("ag-hidden");
            };
            const currentMiniChartContainer = this.miniChartsContainers.find(isMiniChartsContainerVisible);
            const currentChart = currentMiniChartContainer.getGui().querySelector(".ag-selected");
            if (currentChart) {
                const parent = currentChart.offsetParent;
                if (parent) this.eMiniChartsContainer.scrollTo(0, parent.offsetTop);
            }
        }, 250);
    }
    resetPalettes(forceReset) {
        var _a, _b;
        const palettes = this.chartController.getPalettes();
        const themeTemplateParameters = this.chartController.getThemeTemplateParameters();
        const chartGroups = (_b = (_a = this.gos.get("chartToolPanelsDef")) == null ? void 0 : _a.settingsPanel) == null ? void 0 : _b.chartGroupsDef;
        if ((0, $jIDNV._).shallowCompare(palettes, this.palettes) && !forceReset || this.isAnimating) return;
        this.palettes = palettes;
        this.themes = this.chartController.getThemeNames();
        this.activePaletteIndex = this.themes.findIndex((name)=>name === this.chartController.getChartThemeName());
        this.cardItems = [];
        (0, $jIDNV._).clearElement(this.eCardSelector);
        this.destroyMiniCharts();
        const { themes: themes } = this;
        this.palettes.forEach((palette, index)=>{
            const isActivePalette = this.activePaletteIndex === index;
            const { fills: fills, strokes: strokes } = palette;
            const themeName = themes[index];
            const isCustomTheme = !$5b7ccabde48fae90$var$isStockTheme(themeName);
            const miniChartsContainer = this.createBean(new $5b7ccabde48fae90$var$MiniChartsContainer(this.chartController, fills, strokes, themeTemplateParameters[index], isCustomTheme, chartGroups));
            this.miniChartsContainers.push(miniChartsContainer);
            this.eMiniChartsContainer.appendChild(miniChartsContainer.getGui());
            this.addCardLink(index);
            if (isActivePalette) miniChartsContainer.updateSelectedMiniChart();
            else miniChartsContainer.setDisplayed(false);
        });
        (0, $jIDNV._).setDisplayed(this.eNavBar, this.palettes.length > 1);
        (0, $jIDNV._).radioCssClass(this.cardItems[this.activePaletteIndex], "ag-selected", "ag-not-selected");
    }
    addCardLink(index) {
        const link = document.createElement("div");
        link.classList.add("ag-chart-settings-card-item");
        this.addManagedListener(link, "click", ()=>{
            this.setActivePalette(index, index < this.activePaletteIndex ? "left" : "right");
        });
        this.eCardSelector.appendChild(link);
        this.cardItems.push(link);
    }
    getPrev() {
        let prev = this.activePaletteIndex - 1;
        if (prev < 0) prev = this.palettes.length - 1;
        return prev;
    }
    getNext() {
        let next = this.activePaletteIndex + 1;
        if (next >= this.palettes.length) next = 0;
        return next;
    }
    setActivePalette(index, animationDirection) {
        if (this.isAnimating || this.activePaletteIndex === index) return;
        (0, $jIDNV._).radioCssClass(this.cardItems[index], "ag-selected", "ag-not-selected");
        const currentPalette = this.miniChartsContainers[this.activePaletteIndex];
        const currentGui = currentPalette.getGui();
        const futurePalette = this.miniChartsContainers[index];
        const nextGui = futurePalette.getGui();
        currentPalette.updateSelectedMiniChart();
        futurePalette.updateSelectedMiniChart();
        const multiplier = animationDirection === "left" ? -1 : 1;
        const final = nextGui.style.left = `${(0, $jIDNV._).getAbsoluteWidth(this.getGui()) * multiplier}px`;
        this.activePaletteIndex = index;
        this.isAnimating = true;
        const animatingClass = "ag-animating";
        futurePalette.setDisplayed(true);
        currentPalette.addCssClass(animatingClass);
        futurePalette.addCssClass(animatingClass);
        this.chartController.setChartThemeName(this.themes[index]);
        window.setTimeout(()=>{
            currentGui.style.left = `${-parseFloat(final)}px`;
            nextGui.style.left = "0px";
        }, 0);
        window.setTimeout(()=>{
            this.isAnimating = false;
            currentPalette.removeCssClass(animatingClass);
            futurePalette.removeCssClass(animatingClass);
            currentPalette.setDisplayed(false);
        }, 300);
    }
    destroyMiniCharts() {
        (0, $jIDNV._).clearElement(this.eMiniChartsContainer);
        this.miniChartsContainers = this.destroyBeans(this.miniChartsContainers);
    }
    destroy() {
        this.destroyMiniCharts();
        super.destroy();
    }
};
$5b7ccabde48fae90$var$_ChartSettingsPanel.TEMPLATE = /* html */ `<div class="ag-chart-settings-wrapper">
            <div ref="eMiniChartsContainer" class="ag-chart-settings-mini-charts-container ag-scrollable-container"></div>
            <div ref="eNavBar" class="ag-chart-settings-nav-bar">
                <div ref="ePrevBtn" class="ag-chart-settings-prev">
                    <button type="button" class="ag-button ag-chart-settings-prev-button"></button>
                </div>
                <div ref="eCardSelector" class="ag-chart-settings-card-selector"></div>
                <div ref="eNextBtn" class="ag-chart-settings-next">
                    <button type="button" class="ag-button ag-chart-settings-next-button"></button>
                </div>
            </div>
        </div>`;
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.RefSelector)("eMiniChartsContainer")
], $5b7ccabde48fae90$var$_ChartSettingsPanel.prototype, "eMiniChartsContainer", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.RefSelector)("eNavBar")
], $5b7ccabde48fae90$var$_ChartSettingsPanel.prototype, "eNavBar", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.RefSelector)("eCardSelector")
], $5b7ccabde48fae90$var$_ChartSettingsPanel.prototype, "eCardSelector", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.RefSelector)("ePrevBtn")
], $5b7ccabde48fae90$var$_ChartSettingsPanel.prototype, "ePrevBtn", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.RefSelector)("eNextBtn")
], $5b7ccabde48fae90$var$_ChartSettingsPanel.prototype, "eNextBtn", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_ChartSettingsPanel.prototype, "postConstruct", 1);
var $5b7ccabde48fae90$var$ChartSettingsPanel = $5b7ccabde48fae90$var$_ChartSettingsPanel;
var $5b7ccabde48fae90$var$_TabbedChartMenu = class _TabbedChartMenu2 extends (0, $jIDNV.Component) {
    constructor(panels, chartMenuContext){
        super();
        this.panels = panels;
        this.chartMenuContext = chartMenuContext;
        this.tabs = [];
    }
    init() {
        this.panels.forEach((panel)=>{
            const panelType = panel.replace("chart", "").toLowerCase();
            const panelComp = this.createPanel(panelType);
            const tabItem = this.createTab(panel, panelType, panelComp);
            this.tabs.push(tabItem);
            this.addDestroyFunc(()=>this.destroyBean(panelComp));
        });
        this.tabbedLayout = new (0, $jIDNV.TabbedLayout)({
            items: this.tabs,
            cssClass: "ag-chart-tabbed-menu",
            keepScrollPosition: true,
            suppressFocusBodyOnOpen: true,
            suppressTrapFocus: true,
            enableCloseButton: !this.chartMenuService.isLegacyFormat(),
            closeButtonAriaLabel: this.chartTranslationService.translate("ariaChartMenuClose"),
            onCloseClicked: ()=>{
                var _a;
                (_a = this.eventSource) == null || _a.focus({
                    preventScroll: true
                });
                this.dispatchEvent({
                    type: _TabbedChartMenu2.EVENT_CLOSED
                });
            }
        });
        this.getContext().createBean(this.tabbedLayout);
    }
    createTab(name, title, panelComp) {
        const eWrapperDiv = document.createElement("div");
        eWrapperDiv.classList.add("ag-chart-tab", `ag-chart-${title}`);
        this.getContext().createBean(panelComp);
        eWrapperDiv.appendChild(panelComp.getGui());
        const titleEl = document.createElement("div");
        const translatedTitle = this.chartTranslationService.translate(title);
        titleEl.innerText = translatedTitle;
        return {
            title: titleEl,
            titleLabel: translatedTitle,
            bodyPromise: (0, $jIDNV.AgPromise).resolve(eWrapperDiv),
            getScrollableContainer: ()=>{
                const scrollableContainer = eWrapperDiv.querySelector(".ag-scrollable-container");
                return scrollableContainer || eWrapperDiv;
            },
            name: name
        };
    }
    showTab(tab) {
        const tabItem = this.tabs[tab];
        this.tabbedLayout.showItem(tabItem);
    }
    getGui() {
        return this.tabbedLayout && this.tabbedLayout.getGui();
    }
    showMenu(eventSource, suppressFocus) {
        var _a;
        this.eventSource = eventSource;
        if (!suppressFocus) (_a = this.tabbedLayout) == null || _a.focusHeader(true);
    }
    destroy() {
        if (this.parentComponent && this.parentComponent.isAlive()) this.destroyBean(this.parentComponent);
        super.destroy();
    }
    createPanel(panelType) {
        const { chartController: chartController, chartOptionsService: chartOptionsService } = this.chartMenuContext;
        switch(panelType){
            case _TabbedChartMenu2.TAB_DATA:
                return new $5b7ccabde48fae90$var$ChartDataPanel(chartController, chartOptionsService);
            case _TabbedChartMenu2.TAB_FORMAT:
                return new $5b7ccabde48fae90$var$FormatPanel(this.chartMenuContext);
            default:
                return new $5b7ccabde48fae90$var$ChartSettingsPanel(chartController);
        }
    }
};
$5b7ccabde48fae90$var$_TabbedChartMenu.EVENT_CLOSED = "closed";
$5b7ccabde48fae90$var$_TabbedChartMenu.TAB_DATA = "data";
$5b7ccabde48fae90$var$_TabbedChartMenu.TAB_FORMAT = "format";
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartTranslationService")
], $5b7ccabde48fae90$var$_TabbedChartMenu.prototype, "chartTranslationService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartMenuService")
], $5b7ccabde48fae90$var$_TabbedChartMenu.prototype, "chartMenuService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_TabbedChartMenu.prototype, "init", 1);
var $5b7ccabde48fae90$var$TabbedChartMenu = $5b7ccabde48fae90$var$_TabbedChartMenu;
var $5b7ccabde48fae90$var$ChartToolbar = class extends (0, $jIDNV.Component) {
    constructor(){
        super(/* html */ `<div class="ag-chart-menu" ref="eMenu"></div>`);
        this.buttonListenersDestroyFuncs = [];
    }
    updateParams(params) {
        const { buttons: buttons } = params;
        this.createButtons(buttons);
    }
    createButtons(buttons) {
        this.buttonListenersDestroyFuncs.forEach((func)=>func == null ? void 0 : func());
        this.buttonListenersDestroyFuncs = [];
        const menuEl = this.eMenu;
        (0, $jIDNV._).clearElement(menuEl);
        buttons.forEach((buttonConfig)=>{
            const { buttonName: buttonName, iconName: iconName, callback: callback } = buttonConfig;
            const buttonEl = this.createButton(iconName);
            const tooltipTitle = this.chartTranslationService.translate(buttonName + "ToolbarTooltip");
            if (tooltipTitle && buttonEl instanceof HTMLElement) buttonEl.title = tooltipTitle;
            this.buttonListenersDestroyFuncs.push(this.addManagedListener(buttonEl, "click", (event)=>callback(event.target)));
            menuEl.appendChild(buttonEl);
        });
    }
    createButton(iconName) {
        let buttonEl = (0, $jIDNV._).createIconNoSpan(iconName, this.gos, void 0, true);
        buttonEl.classList.add("ag-chart-menu-icon");
        if (!this.chartMenuService.isLegacyFormat()) buttonEl = this.wrapButton(buttonEl);
        return buttonEl;
    }
    wrapButton(buttonEl) {
        const wrapperEl = this.gos.getDocument().createElement("button");
        wrapperEl.appendChild(buttonEl);
        wrapperEl.classList.add("ag-chart-menu-toolbar-button");
        return wrapperEl;
    }
    destroy() {
        this.buttonListenersDestroyFuncs = [];
        super.destroy();
    }
};
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartTranslationService")
], $5b7ccabde48fae90$var$ChartToolbar.prototype, "chartTranslationService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartMenuService")
], $5b7ccabde48fae90$var$ChartToolbar.prototype, "chartMenuService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.RefSelector)("eMenu")
], $5b7ccabde48fae90$var$ChartToolbar.prototype, "eMenu", 2);
var $5b7ccabde48fae90$var$_ChartMenu = class _ChartMenu2 extends (0, $jIDNV.Component) {
    constructor(eChartContainer, eMenuPanelContainer, chartMenuContext){
        super(_ChartMenu2.TEMPLATE);
        this.eChartContainer = eChartContainer;
        this.eMenuPanelContainer = eMenuPanelContainer;
        this.chartMenuContext = chartMenuContext;
        this.buttons = {
            chartSettings: {
                iconName: "menu",
                callback: ()=>this.showMenu({
                        panel: this.defaultPanel
                    })
            },
            chartData: {
                iconName: "menu",
                callback: ()=>this.showMenu({
                        panel: "chartData"
                    })
            },
            chartFormat: {
                iconName: "menu",
                callback: ()=>this.showMenu({
                        panel: "chartFormat"
                    })
            },
            chartLink: {
                iconName: "linked",
                callback: ()=>this.chartMenuService.toggleLinked(this.chartMenuContext)
            },
            chartUnlink: {
                iconName: "unlinked",
                callback: ()=>this.chartMenuService.toggleLinked(this.chartMenuContext)
            },
            chartDownload: {
                iconName: "save",
                callback: ()=>this.chartMenuService.downloadChart(this.chartMenuContext)
            },
            chartMenu: {
                iconName: "menuAlt",
                callback: (eventSource)=>this.showMenuList(eventSource)
            }
        };
        this.panels = [];
        this.menuVisible = false;
        this.chartController = chartMenuContext.chartController;
    }
    postConstruct() {
        this.legacyFormat = this.chartMenuService.isLegacyFormat();
        this.chartToolbar = this.createManagedBean(new $5b7ccabde48fae90$var$ChartToolbar());
        this.getGui().appendChild(this.chartToolbar.getGui());
        if (this.legacyFormat) this.createLegacyToggleButton();
        this.refreshToolbarAndPanels();
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_CHART_CREATED, (e)=>{
            var _a;
            if (e.chartId === this.chartController.getChartId()) {
                const showDefaultToolPanel = Boolean((_a = this.gos.get("chartToolPanelsDef")) == null ? void 0 : _a.defaultToolPanel);
                if (showDefaultToolPanel) this.showMenu({
                    panel: this.defaultPanel,
                    animate: false,
                    suppressFocus: true
                });
            }
        });
        this.addManagedListener(this.chartController, $5b7ccabde48fae90$var$ChartController.EVENT_CHART_LINKED_CHANGED, this.refreshToolbarAndPanels.bind(this));
        this.refreshMenuClasses();
        if (this.legacyFormat && !this.gos.get("suppressChartToolPanelsButton") && this.panels.length > 0) {
            this.getGui().classList.add("ag-chart-tool-panel-button-enable");
            if (this.eHideButton) this.addManagedListener(this.eHideButton, "click", this.toggleMenu.bind(this));
        }
        if (!this.legacyFormat) this.getGui().classList.add("ag-chart-menu-wrapper");
        this.addManagedListener(this.chartController, $5b7ccabde48fae90$var$ChartController.EVENT_CHART_API_UPDATE, this.refreshToolbarAndPanels.bind(this));
    }
    isVisible() {
        return this.menuVisible;
    }
    getExtraPaddingDirections() {
        const topItems = [
            "chartMenu",
            "chartLink",
            "chartUnlink",
            "chartDownload"
        ];
        const rightItems = [
            "chartSettings",
            "chartData",
            "chartFormat"
        ];
        const result = [];
        if (topItems.some((v)=>this.chartToolbarOptions.includes(v))) result.push("top");
        if (rightItems.some((v)=>this.chartToolbarOptions.includes(v))) result.push(this.gos.get("enableRtl") ? "left" : "right");
        return result;
    }
    createLegacyToggleButton() {
        const eDocument = this.gos.getDocument();
        this.eHideButton = eDocument.createElement("button");
        this.eHideButton.classList.add("ag-button", "ag-chart-menu-close");
        this.eHideButtonIcon = eDocument.createElement("span");
        this.eHideButtonIcon.classList.add("ag-icon", "ag-icon-contracted");
        this.eHideButton.appendChild(this.eHideButtonIcon);
        this.getGui().appendChild(this.eHideButton);
    }
    refreshToolbarAndPanels() {
        this.initToolbarOptionsAndPanels();
        this.updateToolbar();
    }
    initToolbarOptionsAndPanels() {
        const { panels: panels, defaultPanel: defaultPanel, chartToolbarOptions: chartToolbarOptions } = this.chartMenuService.getToolbarOptionsAndPanels(this.chartController);
        this.panels = panels;
        this.defaultPanel = defaultPanel;
        this.chartToolbarOptions = chartToolbarOptions;
    }
    updateToolbar() {
        const buttons = this.chartToolbarOptions.map((buttonName)=>{
            const { iconName: iconName, callback: callback } = this.buttons[buttonName];
            return {
                buttonName: buttonName,
                iconName: iconName,
                callback: callback
            };
        });
        this.chartToolbar.updateParams({
            buttons: buttons
        });
    }
    createMenuPanel(defaultTab) {
        const width = this.environment.chartMenuPanelWidth();
        const menuPanel = this.menuPanel = this.createBean(new (0, $jIDNV.AgPanel)({
            minWidth: width,
            width: width,
            height: "100%",
            closable: true,
            hideTitleBar: true,
            cssIdentifier: "chart-menu"
        }));
        menuPanel.setParentComponent(this);
        this.eMenuPanelContainer.appendChild(menuPanel.getGui());
        this.tabbedMenu = this.createBean(new $5b7ccabde48fae90$var$TabbedChartMenu(this.panels, this.chartMenuContext));
        this.addManagedListener(this.tabbedMenu, $5b7ccabde48fae90$var$TabbedChartMenu.EVENT_CLOSED, ()=>{
            this.hideMenu(false);
        });
        this.addManagedListener(menuPanel, (0, $jIDNV.Component).EVENT_DESTROYED, ()=>this.destroyBean(this.tabbedMenu));
        return new (0, $jIDNV.AgPromise)((res)=>{
            window.setTimeout(()=>{
                menuPanel.setBodyComponent(this.tabbedMenu);
                this.tabbedMenu.showTab(defaultTab);
                res(menuPanel);
                if (this.legacyFormat) this.addManagedListener(this.eChartContainer, "click", (event)=>{
                    if (this.getGui().contains(event.target)) return;
                    if (this.menuVisible) this.hideMenu();
                });
            }, 100);
        });
    }
    showContainer(eventSource, suppressFocus) {
        if (!this.menuPanel) return;
        this.menuVisible = true;
        this.showParent(this.menuPanel.getWidth());
        this.refreshMenuClasses();
        this.tabbedMenu.showMenu(eventSource, suppressFocus);
    }
    toggleMenu() {
        this.menuVisible ? this.hideMenu(this.legacyFormat) : this.showMenu({
            animate: this.legacyFormat
        });
    }
    showMenu(params) {
        const { panel: panel, animate: animate = true, eventSource: eventSource, suppressFocus: suppressFocus } = params;
        if (!animate) this.eMenuPanelContainer.classList.add("ag-no-transition");
        if (this.menuPanel && !panel) this.showContainer(eventSource, suppressFocus);
        else {
            const menuPanel = panel || this.defaultPanel;
            let tab = this.panels.indexOf(menuPanel);
            if (tab < 0) {
                console.warn(`AG Grid: '${panel}' is not a valid Chart Tool Panel name`);
                tab = this.panels.indexOf(this.defaultPanel);
            }
            if (this.menuPanel) {
                this.tabbedMenu.showTab(tab);
                this.showContainer(eventSource, suppressFocus);
            } else this.createMenuPanel(tab).then(()=>this.showContainer(eventSource, suppressFocus));
        }
        if (!animate) setTimeout(()=>{
            if (!this.isAlive()) return;
            this.eMenuPanelContainer.classList.remove("ag-no-transition");
        }, 500);
    }
    hideMenu(animate = true) {
        if (!animate) this.eMenuPanelContainer.classList.add("ag-no-transition");
        this.hideParent();
        window.setTimeout(()=>{
            this.menuVisible = false;
            this.refreshMenuClasses();
            if (!animate) this.eMenuPanelContainer.classList.remove("ag-no-transition");
        }, 500);
    }
    refreshMenuClasses() {
        this.eChartContainer.classList.toggle("ag-chart-menu-visible", this.menuVisible);
        this.eChartContainer.classList.toggle("ag-chart-menu-hidden", !this.menuVisible);
        if (this.legacyFormat && !this.gos.get("suppressChartToolPanelsButton")) {
            this.eHideButtonIcon.classList.toggle("ag-icon-contracted", this.menuVisible);
            this.eHideButtonIcon.classList.toggle("ag-icon-expanded", !this.menuVisible);
        }
    }
    showParent(width) {
        this.eMenuPanelContainer.style.minWidth = `${width}px`;
    }
    hideParent() {
        this.eMenuPanelContainer.style.minWidth = "0";
    }
    showMenuList(eventSource) {
        this.chartMenuListFactory.showMenuList({
            eventSource: eventSource,
            showMenu: ()=>this.showMenu({
                    animate: false,
                    eventSource: eventSource
                }),
            chartMenuContext: this.chartMenuContext
        });
    }
    destroy() {
        super.destroy();
        if (this.menuPanel && this.menuPanel.isAlive()) this.destroyBean(this.menuPanel);
        if (this.tabbedMenu && this.tabbedMenu.isAlive()) this.destroyBean(this.tabbedMenu);
    }
};
$5b7ccabde48fae90$var$_ChartMenu.TEMPLATE = /* html */ `<div></div>`;
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartMenuService")
], $5b7ccabde48fae90$var$_ChartMenu.prototype, "chartMenuService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartMenuListFactory")
], $5b7ccabde48fae90$var$_ChartMenu.prototype, "chartMenuListFactory", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_ChartMenu.prototype, "postConstruct", 1);
var $5b7ccabde48fae90$var$ChartMenu = $5b7ccabde48fae90$var$_ChartMenu;
var $5b7ccabde48fae90$var$_TitleEdit = class _TitleEdit2 extends (0, $jIDNV.Component) {
    constructor(chartMenu){
        super(_TitleEdit2.TEMPLATE);
        this.chartMenu = chartMenu;
        this.destroyableChartListeners = [];
        this.editing = false;
    }
    init() {
        this.addManagedListener(this.getGui(), "keydown", (e)=>{
            if (this.editing && e.key === "Enter" && !e.shiftKey) {
                this.handleEndEditing();
                e.preventDefault();
            }
        });
        this.addManagedListener(this.getGui(), "input", ()=>{
            if (this.editing) this.updateHeight();
        });
        this.addManagedListener(this.getGui(), "blur", ()=>this.endEditing());
    }
    /* should be called when the containing component changes to a new chart proxy */ refreshTitle(chartMenuContext) {
        this.chartController = chartMenuContext.chartController;
        this.chartOptionsService = chartMenuContext.chartOptionsService;
        this.chartMenuUtils = chartMenuContext.chartMenuParamsFactory.getChartOptions();
        for (const destroyFn of this.destroyableChartListeners)destroyFn();
        this.destroyableChartListeners = [];
        const chartProxy = this.chartController.getChartProxy();
        const chart = chartProxy.getChart();
        const canvas = chart.canvasElement;
        const destroyDbleClickListener = this.addManagedListener(canvas, "dblclick", (event)=>{
            const { title: title } = chart;
            if (title && title.node.containsPoint(event.offsetX, event.offsetY)) {
                const bbox = title.node.computeBBox();
                const xy = title.node.inverseTransformPoint(bbox.x, bbox.y);
                this.startEditing($5b7ccabde48fae90$var$__spreadValues3($5b7ccabde48fae90$var$__spreadValues3({}, bbox), xy), canvas.width);
            }
        });
        let wasInTitle = false;
        const destroyMouseMoveListener = this.addManagedListener(canvas, "mousemove", (event)=>{
            const { title: title } = chart;
            const inTitle = !!(title && title.enabled && title.node.containsPoint(event.offsetX, event.offsetY));
            if (wasInTitle !== inTitle) canvas.style.cursor = inTitle ? "pointer" : "";
            wasInTitle = inTitle;
        });
        this.destroyableChartListeners = [
            destroyDbleClickListener,
            destroyMouseMoveListener
        ];
    }
    startEditing(titleBBox, canvasWidth) {
        if (this.chartMenuService.isLegacyFormat() && this.chartMenu && this.chartMenu.isVisible()) return;
        if (this.editing) return;
        this.editing = true;
        const minimumTargetInputWidth = 300;
        const inputWidth = Math.max(Math.min(titleBBox.width + 20, canvasWidth), minimumTargetInputWidth);
        const element = this.getGui();
        element.classList.add("currently-editing");
        const inputStyle = element.style;
        inputStyle.fontFamily = this.chartMenuUtils.getValue("title.fontFamily");
        inputStyle.fontWeight = this.chartMenuUtils.getValue("title.fontWeight");
        inputStyle.fontStyle = this.chartMenuUtils.getValue("title.fontStyle");
        inputStyle.fontSize = this.chartMenuUtils.getValue("title.fontSize") + "px";
        inputStyle.color = this.chartMenuUtils.getValue("title.color");
        const oldTitle = this.chartMenuUtils.getValue("title.text");
        const isTitlePlaceholder = oldTitle === this.chartTranslationService.translate("titlePlaceholder");
        element.value = isTitlePlaceholder ? "" : oldTitle;
        const oldTitleLines = oldTitle.split(/\r?\n/g).length;
        inputStyle.left = Math.round(titleBBox.x + titleBBox.width / 2 - inputWidth / 2 - 1) + "px";
        inputStyle.top = Math.round(titleBBox.y + titleBBox.height / 2 - oldTitleLines * this.getLineHeight() / 2 - 2) + "px";
        inputStyle.width = Math.round(inputWidth) + "px";
        inputStyle.lineHeight = this.getLineHeight() + "px";
        this.updateHeight();
        element.focus();
    }
    updateHeight() {
        const element = this.getGui();
        const oldTitleLines = this.chartMenuUtils.getValue("title.text").split(/\r?\n/g).length;
        const currentTitleLines = element.value.split(/\r?\n/g).length;
        element.style.height = Math.round(Math.max(oldTitleLines, currentTitleLines) * this.getLineHeight()) + 4 + "px";
    }
    getLineHeight() {
        const fixedLineHeight = this.chartMenuUtils.getValue("title.lineHeight");
        if (fixedLineHeight) return parseInt(fixedLineHeight);
        return Math.round(parseInt(this.chartMenuUtils.getValue("title.fontSize")) * 1.2);
    }
    handleEndEditing() {
        const titleColor = this.chartMenuUtils.getValue("title.color");
        const transparentColor = "rgba(0, 0, 0, 0)";
        this.chartMenuUtils.setValue("title.color", transparentColor);
        this.chartOptionsService.awaitChartOptionUpdate(()=>this.endEditing());
        this.chartOptionsService.awaitChartOptionUpdate(()=>{
            this.chartMenuUtils.setValue("title.color", titleColor);
        });
    }
    endEditing() {
        if (!this.editing) return;
        this.editing = false;
        const value = this.getGui().value;
        if (value && value.trim() !== "") {
            this.chartMenuUtils.setValue("title.text", value);
            this.chartMenuUtils.setValue("title.enabled", true);
        } else {
            this.chartMenuUtils.setValue("title.text", "");
            this.chartMenuUtils.setValue("title.enabled", false);
        }
        this.getGui().classList.remove("currently-editing");
        this.chartOptionsService.awaitChartOptionUpdate(()=>{
            this.eventService.dispatchEvent({
                type: "chartTitleEdit"
            });
        });
    }
};
$5b7ccabde48fae90$var$_TitleEdit.TEMPLATE = /* html */ `<textarea
             class="ag-chart-title-edit"
             style="padding:0; border:none; border-radius: 0; min-height: 0; text-align: center; resize: none;" />
        `;
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartTranslationService")
], $5b7ccabde48fae90$var$_TitleEdit.prototype, "chartTranslationService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartMenuService")
], $5b7ccabde48fae90$var$_TitleEdit.prototype, "chartMenuService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_TitleEdit.prototype, "init", 1);
var $5b7ccabde48fae90$var$TitleEdit = $5b7ccabde48fae90$var$_TitleEdit;
function $5b7ccabde48fae90$var$deproxy(chartOrProxy) {
    if (chartOrProxy.chart != null) return chartOrProxy.chart;
    return chartOrProxy;
}
var $5b7ccabde48fae90$var$ChartProxy = class {
    constructor(chartProxyParams){
        this.chartProxyParams = chartProxyParams;
        this.clearThemeOverrides = false;
        this.isEnterpriseCharts = (0, $iTJTu._ModuleSupport).enterpriseModule.isEnterprise;
        this.chart = chartProxyParams.chartInstance;
        this.chartType = chartProxyParams.chartType;
        this.crossFiltering = chartProxyParams.crossFiltering;
        this.crossFilterCallback = chartProxyParams.crossFilterCallback;
        this.standaloneChartType = $5b7ccabde48fae90$var$getSeriesType(this.chartType);
        if (this.chart == null) this.chart = (0, $iTJTu.AgCharts).create(this.getCommonChartOptions());
        else this.clearThemeOverrides = true;
    }
    crossFilteringReset() {}
    update(params) {
        (0, $iTJTu.AgCharts).update(this.getChartRef(), this.getUpdateOptions(params, this.getCommonChartOptions(params.updatedOverrides)));
    }
    updateThemeOverrides(themeOverrides) {
        (0, $iTJTu.AgCharts).updateDelta(this.getChartRef(), {
            theme: {
                overrides: themeOverrides
            }
        });
    }
    getChart() {
        return $5b7ccabde48fae90$var$deproxy(this.chart);
    }
    getChartRef() {
        return this.chart;
    }
    downloadChart(dimensions, fileName, fileFormat) {
        const { chart: chart } = this;
        const rawChart = $5b7ccabde48fae90$var$deproxy(chart);
        const imageFileName = fileName || (rawChart.title ? rawChart.title.text : "chart");
        const { width: width, height: height } = dimensions || {};
        (0, $iTJTu.AgCharts).download(chart, {
            width: width,
            height: height,
            fileName: imageFileName,
            fileFormat: fileFormat
        });
    }
    getChartImageDataURL(type) {
        return this.getChart().getCanvasDataURL(type);
    }
    getChartOptions() {
        return this.chart.getOptions();
    }
    getChartThemeOverrides() {
        var _a;
        const chartOptionsTheme = this.getChartOptions().theme;
        return (_a = chartOptionsTheme.overrides) != null ? _a : {};
    }
    getChartPalette() {
        return (0, $iTJTu._Theme).getChartTheme(this.getChartOptions().theme).palette;
    }
    setPaired(paired) {
        const seriesType = $5b7ccabde48fae90$var$getSeriesType(this.chartProxyParams.chartType);
        (0, $iTJTu.AgCharts).updateDelta(this.chart, {
            theme: {
                overrides: {
                    [seriesType]: {
                        paired: paired
                    }
                }
            }
        });
    }
    isPaired() {
        const seriesType = $5b7ccabde48fae90$var$getSeriesType(this.chartProxyParams.chartType);
        return $5b7ccabde48fae90$var$get(this.getChartThemeOverrides(), `${seriesType}.paired`, true);
    }
    lookupCustomChartTheme(themeName) {
        return $5b7ccabde48fae90$var$lookupCustomChartTheme(this.chartProxyParams, themeName);
    }
    getSeriesGroupType() {
        return void 0;
    }
    transformCategoryData(data, categoryKey) {
        return data.map((d, index)=>{
            const value = d[categoryKey];
            const valueString = value && value.toString ? value.toString() : "";
            const datum = $5b7ccabde48fae90$var$__spreadValues3({}, d);
            datum[categoryKey] = {
                id: index,
                value: value,
                toString: ()=>valueString
            };
            return datum;
        });
    }
    getCommonChartOptions(updatedOverrides) {
        var _a, _b;
        const existingOptions = this.clearThemeOverrides ? {} : (_b = (_a = this.chart) == null ? void 0 : _a.getOptions()) != null ? _b : {};
        const formattingPanelOverrides = this.chart != null ? this.getActiveFormattingPanelOverrides() : void 0;
        this.clearThemeOverrides = false;
        const theme = $5b7ccabde48fae90$var$createAgChartTheme(this.chartProxyParams, this, this.isEnterpriseCharts, this.getChartThemeDefaults(), updatedOverrides != null ? updatedOverrides : formattingPanelOverrides);
        const newOptions = $5b7ccabde48fae90$var$__spreadProps3($5b7ccabde48fae90$var$__spreadValues3({}, existingOptions), {
            mode: "integrated"
        });
        newOptions.theme = theme;
        newOptions.container = this.chartProxyParams.parentElement;
        return newOptions;
    }
    getChartThemeDefaults() {
        const seriesOverrides = this.getSeriesChartThemeDefaults();
        const seriesChartOptions = seriesOverrides ? {
            [this.standaloneChartType]: seriesOverrides
        } : {};
        const crosshair = {
            enabled: true,
            snap: true,
            label: {
                enabled: false
            }
        };
        return $5b7ccabde48fae90$var$__spreadValues3({
            common: {
                navigator: {
                    enabled: false
                },
                zoom: {
                    enabled: true
                },
                animation: {
                    enabled: true,
                    duration: 500
                },
                axes: {
                    number: {
                        crosshair: crosshair
                    },
                    category: {
                        crosshair: crosshair
                    },
                    log: {
                        crosshair: crosshair
                    },
                    time: {
                        crosshair: crosshair
                    }
                }
            }
        }, seriesChartOptions);
    }
    getSeriesChartThemeDefaults() {
        return void 0;
    }
    getActiveFormattingPanelOverrides() {
        var _a, _b;
        if (this.clearThemeOverrides) return {};
        const inUseTheme = (_a = this.chart) == null ? void 0 : _a.getOptions().theme;
        return (_b = inUseTheme == null ? void 0 : inUseTheme.overrides) != null ? _b : {};
    }
    destroy({ keepChartInstance: keepChartInstance = false } = {}) {
        if (keepChartInstance) {
            this.chart.resetAnimations();
            return this.chart;
        }
        this.destroyChart();
    }
    destroyChart() {
        if (this.chart) {
            this.chart.destroy();
            this.chart = void 0;
        }
    }
};
var $5b7ccabde48fae90$var$CartesianChartProxy = class extends $5b7ccabde48fae90$var$ChartProxy {
    constructor(params){
        super(params);
        this.crossFilteringAllPoints = /* @__PURE__ */ new Set();
        this.crossFilteringSelectedPoints = [];
    }
    getUpdateOptions(params, commonChartOptions) {
        const axes = this.getAxes(params, commonChartOptions);
        return $5b7ccabde48fae90$var$__spreadProps3($5b7ccabde48fae90$var$__spreadValues3({}, commonChartOptions), {
            data: this.getData(params, axes),
            axes: axes,
            series: this.getSeries(params)
        });
    }
    getData(params, axes) {
        const supportsCrossFiltering = [
            "area",
            "line"
        ].includes(this.standaloneChartType);
        return this.crossFiltering && supportsCrossFiltering ? this.getCrossFilterData(params) : this.getDataTransformedData(params, axes);
    }
    getDataTransformedData(params, axes) {
        const xAxisType = axes[0].type;
        const { categories: categories, data: data } = params;
        const [category] = categories;
        switch(xAxisType){
            case "category":
                return this.transformCategoryData(data, category.id);
            case "time":
                return this.transformTimeData(data, category.id);
            default:
                return data;
        }
    }
    getXAxisType(params) {
        if (params.grouping) return "grouped-category";
        else if (this.isXAxisOfType(params, "time", (value)=>value instanceof Date)) return "time";
        else if (this.isXAxisOfType(params, "number")) return "number";
        return "category";
    }
    isXAxisOfType(params, type, isInstance) {
        const [category] = params.categories;
        if (category == null ? void 0 : category.chartDataType) return category.chartDataType === type;
        if (!isInstance) return false;
        const testDatum = params.data[0];
        if (!testDatum) return false;
        return isInstance(testDatum[category.id]);
    }
    transformTimeData(data, categoryKey) {
        var _a;
        const firstValue = (_a = data[0]) == null ? void 0 : _a[categoryKey];
        if (firstValue instanceof Date) return data;
        return data.map((datum)=>{
            const value = datum[categoryKey];
            return typeof value === "string" ? $5b7ccabde48fae90$var$__spreadProps3($5b7ccabde48fae90$var$__spreadValues3({}, datum), {
                [categoryKey]: new Date(value)
            }) : datum;
        });
    }
    crossFilteringReset() {
        this.crossFilteringSelectedPoints = [];
        this.crossFilteringAllPoints.clear();
    }
    crossFilteringPointSelected(point) {
        return this.crossFilteringSelectedPoints.length == 0 || this.crossFilteringSelectedPoints.includes(point);
    }
    crossFilteringDeselectedPoints() {
        return this.crossFilteringSelectedPoints.length > 0 && this.crossFilteringAllPoints.size !== this.crossFilteringSelectedPoints.length;
    }
    extractLineAreaCrossFilterSeries(series, params) {
        const [category] = params.categories;
        const getYKey = (yKey)=>{
            if (this.standaloneChartType === "area") {
                const lastSelectedChartId = params.getCrossFilteringContext().lastSelectedChartId;
                return lastSelectedChartId === params.chartId ? yKey + "-total" : yKey;
            }
            return yKey + "-total";
        };
        return series.map((s)=>{
            s.yKey = getYKey(s.yKey);
            s.listeners = {
                nodeClick: (e)=>{
                    const value = e.datum[s.xKey];
                    const multiSelection = e.event.metaKey || e.event.ctrlKey;
                    this.crossFilteringAddSelectedPoint(multiSelection, value);
                    this.crossFilterCallback(e);
                }
            };
            s.marker = {
                formatter: (p)=>{
                    const value = p.datum[category.id];
                    return {
                        fill: p.highlighted ? "yellow" : p.fill,
                        size: p.highlighted ? 14 : this.crossFilteringPointSelected(value) ? 8 : 0
                    };
                }
            };
            if (this.standaloneChartType === "area") s.fillOpacity = this.crossFilteringDeselectedPoints() ? 0.3 : 1;
            if (this.standaloneChartType === "line") s.strokeOpacity = this.crossFilteringDeselectedPoints() ? 0.3 : 1;
            return s;
        });
    }
    getCrossFilterData(params) {
        this.crossFilteringAllPoints.clear();
        const [category] = params.categories;
        const colId = params.fields[0].colId;
        const filteredOutColId = `${colId}-filtered-out`;
        const lastSelectedChartId = params.getCrossFilteringContext().lastSelectedChartId;
        return params.data.map((d)=>{
            const value = d[category.id];
            this.crossFilteringAllPoints.add(value);
            const pointSelected = this.crossFilteringPointSelected(value);
            if (this.standaloneChartType === "area" && lastSelectedChartId === params.chartId) d[`${colId}-total`] = pointSelected ? d[colId] : d[colId] + d[filteredOutColId];
            if (this.standaloneChartType === "line") d[`${colId}-total`] = pointSelected ? d[colId] : d[colId] + d[filteredOutColId];
            return d;
        });
    }
    crossFilteringAddSelectedPoint(multiSelection, value) {
        multiSelection ? this.crossFilteringSelectedPoints.push(value) : this.crossFilteringSelectedPoints = [
            value
        ];
    }
    isHorizontal(commonChartOptions) {
        const seriesType = this.standaloneChartType;
        if (seriesType !== "waterfall" && seriesType !== "box-plot" && seriesType !== "range-bar") return false;
        const theme = commonChartOptions.theme;
        const isHorizontal = (theme2)=>{
            var _a, _b, _c;
            const direction = (_c = (_b = (_a = theme2 == null ? void 0 : theme2.overrides) == null ? void 0 : _a[seriesType]) == null ? void 0 : _b.series) == null ? void 0 : _c.direction;
            if (direction != null) return direction === "horizontal";
            if (typeof (theme2 == null ? void 0 : theme2.baseTheme) === "object") return isHorizontal(theme2.baseTheme);
            return false;
        };
        return isHorizontal(theme);
    }
};
function $5b7ccabde48fae90$var$hexToRGBA(hex, alpha) {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return alpha ? `rgba(${r}, ${g}, ${b}, ${alpha})` : `rgba(${r}, ${g}, ${b})`;
}
function $5b7ccabde48fae90$var$changeOpacity(fills, alpha) {
    return fills.map((fill)=>{
        const c = (0, $iTJTu._Util).Color.fromString(fill);
        return new (0, $iTJTu._Util).Color(c.r, c.g, c.b, alpha).toHexString();
    });
}
var $5b7ccabde48fae90$var$HORIZONTAL_CHART_TYPES = /* @__PURE__ */ new Set([
    "bar",
    "groupedBar",
    "stackedBar",
    "normalizedBar"
]);
var $5b7ccabde48fae90$var$BarChartProxy = class extends $5b7ccabde48fae90$var$CartesianChartProxy {
    constructor(params){
        super(params);
    }
    getAxes(params) {
        const axes = [
            {
                type: this.getXAxisType(params),
                position: this.isHorizontal() ? "left" : "bottom"
            },
            {
                type: "number",
                position: this.isHorizontal() ? "bottom" : "left"
            }
        ];
        if (this.isNormalised()) {
            const numberAxis = axes[1];
            numberAxis.label = $5b7ccabde48fae90$var$__spreadProps3($5b7ccabde48fae90$var$__spreadValues3({}, numberAxis.label), {
                formatter: (params2)=>Math.round(params2.value) + "%"
            });
        }
        return axes;
    }
    getSeries(params) {
        const [category] = params.categories;
        const series = params.fields.map((f)=>({
                type: this.standaloneChartType,
                direction: this.isHorizontal() ? "horizontal" : "vertical",
                stacked: this.crossFiltering || $5b7ccabde48fae90$var$isStacked(this.chartType),
                normalizedTo: this.isNormalised() ? 100 : void 0,
                xKey: category.id,
                xName: category.name,
                yKey: f.colId,
                yName: f.displayName
            }));
        return this.crossFiltering ? this.extractCrossFilterSeries(series) : series;
    }
    extractCrossFilterSeries(series) {
        const palette = this.getChartPalette();
        const updatePrimarySeries = (seriesOptions, index)=>{
            return $5b7ccabde48fae90$var$__spreadProps3($5b7ccabde48fae90$var$__spreadValues3({}, seriesOptions), {
                highlightStyle: {
                    item: {
                        fill: void 0
                    }
                },
                fill: palette == null ? void 0 : palette.fills[index],
                stroke: palette == null ? void 0 : palette.strokes[index],
                listeners: {
                    nodeClick: this.crossFilterCallback
                }
            });
        };
        const updateFilteredOutSeries = (seriesOptions)=>{
            const yKey = seriesOptions.yKey + "-filtered-out";
            return $5b7ccabde48fae90$var$__spreadProps3($5b7ccabde48fae90$var$__spreadValues3({}, $5b7ccabde48fae90$var$deepMerge({}, seriesOptions)), {
                yKey: yKey,
                fill: $5b7ccabde48fae90$var$hexToRGBA(seriesOptions.fill, "0.3"),
                stroke: $5b7ccabde48fae90$var$hexToRGBA(seriesOptions.stroke, "0.3"),
                showInLegend: false
            });
        };
        const allSeries = [];
        for(let i = 0; i < series.length; i++){
            const primarySeries = updatePrimarySeries(series[i], i);
            allSeries.push(primarySeries);
            allSeries.push(updateFilteredOutSeries(primarySeries));
        }
        return allSeries;
    }
    isNormalised() {
        const normalisedCharts = [
            "normalizedColumn",
            "normalizedBar"
        ];
        return !this.crossFiltering && (0, $jIDNV._).includes(normalisedCharts, this.chartType);
    }
    isHorizontal() {
        return $5b7ccabde48fae90$var$HORIZONTAL_CHART_TYPES.has(this.chartType);
    }
};
var $5b7ccabde48fae90$var$AreaChartProxy = class extends $5b7ccabde48fae90$var$CartesianChartProxy {
    constructor(params){
        super(params);
    }
    getAxes(params) {
        const axes = [
            {
                type: this.getXAxisType(params),
                position: "bottom"
            },
            {
                type: "number",
                position: "left"
            }
        ];
        if (this.isNormalised()) {
            const numberAxis = axes[1];
            numberAxis.label = $5b7ccabde48fae90$var$__spreadProps3($5b7ccabde48fae90$var$__spreadValues3({}, numberAxis.label), {
                formatter: (params2)=>Math.round(params2.value) + "%"
            });
        }
        return axes;
    }
    getSeries(params) {
        const [category] = params.categories;
        const series = params.fields.map((f)=>({
                type: this.standaloneChartType,
                xKey: category.id,
                xName: category.name,
                yKey: f.colId,
                yName: f.displayName,
                normalizedTo: this.chartType === "normalizedArea" ? 100 : void 0,
                stacked: [
                    "normalizedArea",
                    "stackedArea"
                ].includes(this.chartType)
            }));
        return this.crossFiltering ? this.extractLineAreaCrossFilterSeries(series, params) : series;
    }
    isNormalised() {
        return !this.crossFiltering && this.chartType === "normalizedArea";
    }
};
var $5b7ccabde48fae90$var$LineChartProxy = class extends $5b7ccabde48fae90$var$CartesianChartProxy {
    constructor(params){
        super(params);
    }
    getAxes(params) {
        return [
            {
                type: this.getXAxisType(params),
                position: "bottom"
            },
            {
                type: "number",
                position: "left"
            }
        ];
    }
    getSeries(params) {
        const [category] = params.categories;
        const series = params.fields.map((f)=>({
                type: this.standaloneChartType,
                xKey: category.id,
                xName: category.name,
                yKey: f.colId,
                yName: f.displayName
            }));
        return this.crossFiltering ? this.extractLineAreaCrossFilterSeries(series, params) : series;
    }
};
var $5b7ccabde48fae90$var$PolarChartProxy = class extends $5b7ccabde48fae90$var$ChartProxy {
    constructor(params){
        super(params);
    }
    getAxes(_382) {
        const radialBar = this.standaloneChartType === "radial-bar";
        return [
            {
                type: radialBar ? "angle-number" : "angle-category"
            },
            {
                type: radialBar ? "radius-category" : "radius-number"
            }
        ];
    }
    getSeries(params) {
        const { fields: fields, categories: categories, seriesGroupType: seriesGroupType } = params;
        const [category] = categories;
        const radialBar = this.standaloneChartType === "radial-bar";
        const seriesGroupTypeOptions = this.getSeriesGroupTypeOptions(seriesGroupType);
        return fields.map((f)=>{
            var _a, _b;
            return $5b7ccabde48fae90$var$__spreadValues3({
                type: this.standaloneChartType,
                angleKey: radialBar ? f.colId : category.id,
                angleName: radialBar ? (_a = f.displayName) != null ? _a : void 0 : category.name,
                radiusKey: radialBar ? category.id : f.colId,
                radiusName: radialBar ? category.name : (_b = f.displayName) != null ? _b : void 0
            }, seriesGroupTypeOptions);
        });
    }
    getSeriesGroupType() {
        var _a, _b;
        const standaloneChartType = this.standaloneChartType;
        if (![
            "nightingale",
            "radial-bar",
            "radial-column"
        ].includes(standaloneChartType)) return void 0;
        const firstSeriesProperties = (_b = (_a = this.getChart().series) == null ? void 0 : _a[0]) == null ? void 0 : _b.properties.toJson();
        const getStackedValue = ()=>firstSeriesProperties.normalizedTo ? "normalized" : "stacked";
        if (standaloneChartType === "nightingale") return firstSeriesProperties.grouped ? "grouped" : getStackedValue();
        else return firstSeriesProperties.stacked ? getStackedValue() : "grouped";
    }
    getUpdateOptions(params, commonChartOptions) {
        const axes = this.getAxes(params);
        return $5b7ccabde48fae90$var$__spreadProps3($5b7ccabde48fae90$var$__spreadValues3({}, commonChartOptions), {
            data: this.getData(params, axes),
            axes: axes,
            series: this.getSeries(params)
        });
    }
    getData(params, axes) {
        const isCategoryAxis = axes.some((axis)=>axis.type === "angle-category" || axis.type === "radius-category");
        if (isCategoryAxis) {
            const [category] = params.categories;
            return this.transformCategoryData(params.data, category.id);
        } else return params.data;
    }
    getSeriesGroupTypeOptions(seriesGroupType) {
        if (!seriesGroupType) return {};
        return {
            grouped: seriesGroupType === "grouped" || void 0,
            stacked: seriesGroupType !== "grouped" || void 0,
            normalizedTo: seriesGroupType === "normalized" ? 100 : void 0
        };
    }
};
var $5b7ccabde48fae90$var$PieChartProxy = class _PieChartProxy extends $5b7ccabde48fae90$var$ChartProxy {
    constructor(params){
        super(params);
    }
    getUpdateOptions(params, commonChartOptions) {
        return $5b7ccabde48fae90$var$__spreadProps3($5b7ccabde48fae90$var$__spreadValues3({}, commonChartOptions), {
            data: this.crossFiltering ? this.getCrossFilterData(params) : params.data,
            series: this.getSeries(params)
        });
    }
    getSeries(params) {
        const [category] = params.categories;
        const numFields = params.fields.length;
        const offset = {
            currentOffset: 0,
            offsetAmount: numFields > 1 ? 20 : 40
        };
        const series = this.getFields(params).map((f)=>{
            var _a;
            const options = {
                type: this.standaloneChartType,
                angleKey: f.colId,
                angleName: f.displayName,
                sectorLabelKey: f.colId,
                calloutLabelName: category.name,
                calloutLabelKey: category.id
            };
            if (this.chartType === "donut" || this.chartType === "doughnut") {
                const { outerRadiusOffset: outerRadiusOffset, innerRadiusOffset: innerRadiusOffset } = _PieChartProxy.calculateOffsets(offset);
                const title = f.displayName ? {
                    title: {
                        text: f.displayName,
                        showInLegend: numFields > 1
                    }
                } : void 0;
                return $5b7ccabde48fae90$var$__spreadProps3($5b7ccabde48fae90$var$__spreadValues3($5b7ccabde48fae90$var$__spreadProps3($5b7ccabde48fae90$var$__spreadValues3({}, options), {
                    type: "donut",
                    outerRadiusOffset: outerRadiusOffset,
                    innerRadiusOffset: innerRadiusOffset
                }), title), {
                    calloutLine: {
                        colors: (_a = this.getChartPalette()) == null ? void 0 : _a.strokes
                    }
                });
            }
            return options;
        });
        return this.crossFiltering ? this.extractCrossFilterSeries(series) : series;
    }
    getCrossFilterData(params) {
        const colId = params.fields[0].colId;
        const filteredOutColId = `${colId}-filtered-out`;
        return params.data.map((d)=>{
            const total = d[colId] + d[filteredOutColId];
            d[`${colId}-total`] = total;
            d[filteredOutColId] = 1;
            d[colId] = d[colId] / total;
            return d;
        });
    }
    extractCrossFilterSeries(series) {
        const palette = this.getChartPalette();
        const primaryOptions = (seriesOptions)=>{
            return $5b7ccabde48fae90$var$__spreadProps3($5b7ccabde48fae90$var$__spreadValues3({}, seriesOptions), {
                legendItemKey: seriesOptions.calloutLabelKey,
                calloutLabel: {
                    enabled: false
                },
                // hide labels on primary series
                highlightStyle: {
                    item: {
                        fill: void 0
                    }
                },
                radiusKey: seriesOptions.angleKey,
                angleKey: seriesOptions.angleKey + "-total",
                radiusMin: 0,
                radiusMax: 1,
                listeners: {
                    nodeClick: this.crossFilterCallback
                }
            });
        };
        const filteredOutOptions = (seriesOptions, angleKey2)=>{
            var _a, _b;
            return $5b7ccabde48fae90$var$__spreadProps3($5b7ccabde48fae90$var$__spreadValues3({}, $5b7ccabde48fae90$var$deepMerge({}, primaryOpts)), {
                radiusKey: angleKey2 + "-filtered-out",
                fills: $5b7ccabde48fae90$var$changeOpacity((_a = seriesOptions.fills) != null ? _a : palette.fills, 0.3),
                strokes: $5b7ccabde48fae90$var$changeOpacity((_b = seriesOptions.strokes) != null ? _b : palette.strokes, 0.3),
                showInLegend: false
            });
        };
        const primarySeries = series[0];
        const angleKey = primarySeries.angleKey;
        const primaryOpts = primaryOptions(primarySeries);
        return [
            filteredOutOptions(primarySeries, angleKey),
            primaryOpts
        ];
    }
    static calculateOffsets(offset) {
        const outerRadiusOffset = offset.currentOffset;
        offset.currentOffset -= offset.offsetAmount;
        const innerRadiusOffset = offset.currentOffset;
        offset.currentOffset -= offset.offsetAmount;
        return {
            outerRadiusOffset: outerRadiusOffset,
            innerRadiusOffset: innerRadiusOffset
        };
    }
    getFields(params) {
        return this.chartType === "pie" ? params.fields.slice(0, 1) : params.fields;
    }
};
var $5b7ccabde48fae90$var$ScatterChartProxy = class extends $5b7ccabde48fae90$var$CartesianChartProxy {
    constructor(params){
        super(params);
    }
    getAxes(_params) {
        return [
            {
                type: "number",
                position: "bottom"
            },
            {
                type: "number",
                position: "left"
            }
        ];
    }
    getSeries(params) {
        const [category] = params.categories;
        const paired = this.isPaired();
        const seriesDefinitions = this.getSeriesDefinitions(params.fields, paired);
        const labelFieldDefinition = category.id === $5b7ccabde48fae90$var$ChartDataModel.DEFAULT_CATEGORY ? void 0 : category;
        const series = seriesDefinitions.map((seriesDefinition)=>{
            var _a, _b, _c, _d, _e;
            if (seriesDefinition == null ? void 0 : seriesDefinition.sizeField) {
                const opts2 = {
                    type: "bubble",
                    xKey: seriesDefinition.xField.colId,
                    xName: (_a = seriesDefinition.xField.displayName) != null ? _a : void 0,
                    yKey: seriesDefinition.yField.colId,
                    yName: (_b = seriesDefinition.yField.displayName) != null ? _b : void 0,
                    title: `${seriesDefinition.yField.displayName} vs ${seriesDefinition.xField.displayName}`,
                    sizeKey: seriesDefinition.sizeField.colId,
                    sizeName: (_c = seriesDefinition.sizeField.displayName) != null ? _c : "",
                    labelKey: labelFieldDefinition ? labelFieldDefinition.id : seriesDefinition.yField.colId,
                    labelName: labelFieldDefinition ? labelFieldDefinition.name : void 0
                };
                return opts2;
            }
            const opts = {
                type: "scatter",
                xKey: seriesDefinition.xField.colId,
                xName: (_d = seriesDefinition.xField.displayName) != null ? _d : void 0,
                yKey: seriesDefinition.yField.colId,
                yName: (_e = seriesDefinition.yField.displayName) != null ? _e : void 0,
                title: `${seriesDefinition.yField.displayName} vs ${seriesDefinition.xField.displayName}`,
                labelKey: labelFieldDefinition ? labelFieldDefinition.id : seriesDefinition.yField.colId,
                labelName: labelFieldDefinition ? labelFieldDefinition.name : void 0
            };
            return opts;
        });
        return this.crossFiltering ? this.extractCrossFilterSeries(series, params) : series;
    }
    extractCrossFilterSeries(series, params) {
        const { data: data } = params;
        const palette = this.getChartPalette();
        const filteredOutKey = (key)=>`${key}-filtered-out`;
        const calcMarkerDomain = (data2, sizeKey)=>{
            var _a;
            const markerDomain = [
                Infinity,
                -Infinity
            ];
            if (sizeKey != null) for (const datum of data2){
                const value = (_a = datum[sizeKey]) != null ? _a : datum[filteredOutKey(sizeKey)];
                if (value < markerDomain[0]) markerDomain[0] = value;
                if (value > markerDomain[1]) markerDomain[1] = value;
            }
            if (markerDomain[0] <= markerDomain[1]) return markerDomain;
            return void 0;
        };
        const updatePrimarySeries = (series2, idx)=>{
            const fill = palette == null ? void 0 : palette.fills[idx];
            const stroke = palette == null ? void 0 : palette.strokes[idx];
            let markerDomain = void 0;
            if (series2.type === "bubble") {
                const { sizeKey: sizeKey } = series2;
                markerDomain = calcMarkerDomain(data, sizeKey);
            }
            const marker = $5b7ccabde48fae90$var$__spreadProps3($5b7ccabde48fae90$var$__spreadValues3({}, series2.marker), {
                fill: fill,
                stroke: stroke,
                domain: markerDomain
            });
            return $5b7ccabde48fae90$var$__spreadProps3($5b7ccabde48fae90$var$__spreadValues3({}, series2), {
                marker: marker,
                highlightStyle: {
                    item: {
                        fill: "yellow"
                    }
                },
                listeners: $5b7ccabde48fae90$var$__spreadProps3($5b7ccabde48fae90$var$__spreadValues3({}, series2.listeners), {
                    nodeClick: this.crossFilterCallback
                })
            });
        };
        const updateFilteredOutSeries = (series2)=>{
            let { yKey: yKey, xKey: xKey } = series2;
            let alteredSizeKey = {};
            if (series2.type === "bubble") alteredSizeKey = {
                sizeKey: filteredOutKey(series2.sizeKey)
            };
            return $5b7ccabde48fae90$var$__spreadProps3($5b7ccabde48fae90$var$__spreadValues3($5b7ccabde48fae90$var$__spreadValues3({}, series2), alteredSizeKey), {
                yKey: filteredOutKey(yKey),
                xKey: filteredOutKey(xKey),
                marker: $5b7ccabde48fae90$var$__spreadProps3($5b7ccabde48fae90$var$__spreadValues3({}, series2.marker), {
                    fillOpacity: 0.3,
                    strokeOpacity: 0.3
                }),
                showInLegend: false,
                listeners: $5b7ccabde48fae90$var$__spreadProps3($5b7ccabde48fae90$var$__spreadValues3({}, series2.listeners), {
                    nodeClick: (e)=>{
                        const value = e.datum[filteredOutKey(xKey)];
                        const filterableEvent = $5b7ccabde48fae90$var$__spreadProps3($5b7ccabde48fae90$var$__spreadValues3({}, e), {
                            xKey: xKey,
                            datum: $5b7ccabde48fae90$var$__spreadProps3($5b7ccabde48fae90$var$__spreadValues3({}, e.datum), {
                                [xKey]: value
                            })
                        });
                        this.crossFilterCallback(filterableEvent);
                    }
                })
            });
        };
        const updatedSeries = series.map(updatePrimarySeries);
        return [
            ...updatedSeries,
            ...updatedSeries.map(updateFilteredOutSeries)
        ];
    }
    getSeriesDefinitions(fields, paired) {
        if (fields.length < 2) return [];
        const isBubbleChart = this.chartType === "bubble";
        if (paired) {
            if (isBubbleChart) return fields.map((currentXField, i)=>i % 3 === 0 ? {
                    xField: currentXField,
                    yField: fields[i + 1],
                    sizeField: fields[i + 2]
                } : null).filter((x)=>x && x.yField && x.sizeField);
            return fields.map((currentXField, i)=>i % 2 === 0 ? {
                    xField: currentXField,
                    yField: fields[i + 1]
                } : null).filter((x)=>x && x.yField);
        }
        const xField = fields[0];
        if (isBubbleChart) return fields.map((yField, i)=>i % 2 === 1 ? {
                xField: xField,
                yField: yField,
                sizeField: fields[i + 1]
            } : null).filter((x)=>x && x.sizeField);
        return fields.filter((value, i)=>i > 0).map((yField)=>({
                xField: xField,
                yField: yField
            }));
    }
};
var $5b7ccabde48fae90$var$StatisticalChartProxy = class extends $5b7ccabde48fae90$var$CartesianChartProxy {
    constructor(params){
        super(params);
    }
    getAxes(params, commonChartOptions) {
        return [
            {
                type: this.getXAxisType(params),
                position: this.isHorizontal(commonChartOptions) ? "left" : "bottom"
            },
            {
                type: "number",
                position: this.isHorizontal(commonChartOptions) ? "bottom" : "left"
            }
        ];
    }
    computeSeriesStatistics(params, computeStatsFn) {
        const { data: data, fields: fields } = params;
        const [category] = params.categories;
        const categoryKey = category.id || $5b7ccabde48fae90$var$ChartDataModel.DEFAULT_CATEGORY;
        const groupedData = this.groupDataByCategory(categoryKey, data);
        return Array.from(groupedData).map(([categoryValue, categoryData])=>{
            const categoryResult = {
                [category.id]: categoryValue
            };
            fields.forEach((field, seriesIndex)=>{
                const seriesValues = categoryData.map((datum)=>datum[field.colId]).filter((value)=>typeof value === "number" && !isNaN(value));
                Object.entries(computeStatsFn(seriesValues)).forEach(([statKey, value])=>{
                    const propertyKey = `${statKey}:${seriesIndex}`;
                    categoryResult[propertyKey] = seriesValues.length > 0 ? value : null;
                });
            });
            return categoryResult;
        });
    }
    groupDataByCategory(categoryKey, data) {
        const getCategory = (datum)=>{
            if (categoryKey === $5b7ccabde48fae90$var$ChartDataModel.DEFAULT_CATEGORY) return 1;
            const categoryValue = datum[categoryKey];
            if (categoryValue === null || categoryValue === void 0) return "";
            return categoryValue instanceof Date ? categoryValue.getTime() : categoryValue;
        };
        return data.reduce((acc, datum)=>{
            let category = getCategory(datum);
            const existingCategoryData = acc.get(category);
            if (existingCategoryData) existingCategoryData.push(datum);
            else acc.set(category, [
                datum
            ]);
            return acc;
        }, /* @__PURE__ */ new Map());
    }
};
var $5b7ccabde48fae90$var$RangeChartProxy = class extends $5b7ccabde48fae90$var$StatisticalChartProxy {
    constructor(params){
        super(params);
    }
    getSeries(params) {
        const [category] = params.categories;
        return params.fields.map((field, seriesIndex)=>{
            var _a;
            return {
                type: this.standaloneChartType,
                // xKey/xName refer to category buckets
                xKey: category.id,
                xName: category.name,
                // yName is used to label the series
                yName: (_a = field.displayName) != null ? _a : void 0,
                // custom field labels shown in the tooltip
                yLowName: "Min",
                yHighName: "Max",
                // generated 'synthetic fields' from getData()
                yLowKey: `min:${seriesIndex}`,
                yHighKey: `max:${seriesIndex}`
            };
        });
    }
    getData(params) {
        return this.computeSeriesStatistics(params, (seriesValues)=>{
            return {
                min: Math.min(...seriesValues),
                max: Math.max(...seriesValues)
            };
        });
    }
};
var $5b7ccabde48fae90$var$HistogramChartProxy = class extends $5b7ccabde48fae90$var$CartesianChartProxy {
    constructor(params){
        super(params);
    }
    getSeries(params) {
        const firstField = params.fields[0];
        return [
            {
                type: this.standaloneChartType,
                xKey: firstField.colId,
                xName: firstField.displayName,
                yName: this.chartProxyParams.translate("histogramFrequency"),
                areaPlot: false
            }
        ];
    }
    getAxes(_params) {
        return [
            {
                type: "number",
                position: "bottom"
            },
            {
                type: "number",
                position: "left"
            }
        ];
    }
};
var $5b7ccabde48fae90$var$BoxPlotChartProxy = class extends $5b7ccabde48fae90$var$StatisticalChartProxy {
    constructor(params){
        super(params);
    }
    getSeries(params) {
        const [category] = params.categories;
        return params.fields.map((field, seriesIndex)=>{
            var _a;
            return {
                type: this.standaloneChartType,
                // xKey/xName refer to category buckets
                xKey: category.id,
                xName: category.name,
                // yName is used to label the series
                yName: (_a = field.displayName) != null ? _a : void 0,
                // custom field labels shown in the tooltip
                minName: "Min",
                q1Name: "Q1",
                medianName: "Median",
                q3Name: "Q3",
                maxName: "Max",
                // generated 'synthetic fields' from getData()
                minKey: `min:${seriesIndex}`,
                q1Key: `q1:${seriesIndex}`,
                medianKey: `median:${seriesIndex}`,
                q3Key: `q3:${seriesIndex}`,
                maxKey: `max:${seriesIndex}`
            };
        });
    }
    getData(params) {
        return this.computeSeriesStatistics(params, (seriesValues)=>{
            const sortedValues = seriesValues.sort((a, b)=>a - b);
            return {
                min: sortedValues[0],
                q1: this.quantile(sortedValues, 0.25),
                median: this.quantile(sortedValues, 0.5),
                q3: this.quantile(sortedValues, 0.75),
                max: sortedValues[sortedValues.length - 1]
            };
        });
    }
    quantile(sortedValues, q) {
        const position = (sortedValues.length - 1) * q;
        const indexBelow = Math.floor(position);
        const aboveValue = position - indexBelow;
        if (sortedValues[indexBelow + 1] !== void 0) return sortedValues[indexBelow] + aboveValue * (sortedValues[indexBelow + 1] - sortedValues[indexBelow]);
        return sortedValues[indexBelow];
    }
};
function $5b7ccabde48fae90$var$flatMap(items, iteratee) {
    return items.reduce((acc, item, index, array)=>acc.concat(iteratee(item, index, array)), new Array());
}
var $5b7ccabde48fae90$var$HEATMAP_CATEGORY_KEY = "AG-GRID-DEFAULT-HEATMAP-CATEGORY-KEY";
var $5b7ccabde48fae90$var$HEATMAP_SERIES_KEY = "AG-GRID-DEFAULT-HEATMAP-SERIES-KEY";
var $5b7ccabde48fae90$var$HEATMAP_VALUE_KEY = "AG-GRID-DEFAULT-HEATMAP-VALUE-KEY";
var $5b7ccabde48fae90$var$HeatmapChartProxy = class extends $5b7ccabde48fae90$var$ChartProxy {
    constructor(params){
        super(params);
    }
    getUpdateOptions(params, commonChartOptions) {
        const xSeriesKey = $5b7ccabde48fae90$var$HEATMAP_SERIES_KEY;
        const xValueKey = $5b7ccabde48fae90$var$HEATMAP_VALUE_KEY;
        const yKey = $5b7ccabde48fae90$var$HEATMAP_CATEGORY_KEY;
        return $5b7ccabde48fae90$var$__spreadProps3($5b7ccabde48fae90$var$__spreadValues3({}, commonChartOptions), {
            series: this.getSeries(params, xSeriesKey, xValueKey, yKey),
            data: this.getData(params, xSeriesKey, xValueKey, yKey)
        });
    }
    getSeries(params, xSeriesKey, xValueKey, yKey) {
        const [category] = params.categories;
        return [
            {
                type: this.standaloneChartType,
                yKey: // The axis keys reference synthetic fields based on the category values and series column names
                yKey,
                xKey: xSeriesKey,
                // The color key references a synthetic field based on the series column value for a specific cell
                colorKey: xValueKey,
                yName: category.name,
                // We don't know how to label the 'x' series, as it is a synthetic series created from the set of all input columns
                // In future releases we may want to consider inferring the series label from column groupings etc
                xName: void 0,
                colorName: void 0
            }
        ];
    }
    getData(params, xSeriesKey, xValueKey, yKey) {
        const [category] = params.categories;
        return $5b7ccabde48fae90$var$flatMap(params.data, (datum, index)=>{
            const value = datum[category.id];
            const valueString = value == null ? "" : String(value);
            const yValue = {
                id: index,
                value: value,
                toString: ()=>valueString
            };
            return params.fields.map(({ colId: colId, displayName: displayName })=>$5b7ccabde48fae90$var$__spreadProps3($5b7ccabde48fae90$var$__spreadValues3({}, datum), {
                    [xSeriesKey]: displayName,
                    [xValueKey]: datum[colId],
                    [yKey]: yValue
                }));
        });
    }
    getSeriesChartThemeDefaults() {
        return {
            gradientLegend: {
                gradient: {
                    preferredLength: 200
                }
            },
            series: {
                tooltip: {
                    renderer: $5b7ccabde48fae90$var$renderHeatmapTooltip
                }
            }
        };
    }
};
function $5b7ccabde48fae90$var$renderHeatmapTooltip(params) {
    const { xKey: xKey, yKey: yKey, colorKey: colorKey, yName: yName, datum: datum } = params;
    const table = [
        {
            label: yName,
            value: datum[yKey]
        },
        {
            label: datum[xKey],
            value: colorKey && datum[colorKey]
        }
    ];
    const html = table.map(({ label: label, value: value })=>`<b>${$5b7ccabde48fae90$var$sanitizeHtml(String(label))}:</b> ${$5b7ccabde48fae90$var$sanitizeHtml(String(value))}`).join("<br>");
    return {
        title: "",
        content: html
    };
}
function $5b7ccabde48fae90$var$sanitizeHtml(input) {
    const ESCAPED_CHARS = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;"
    };
    const characterClass = `[${Object.keys(ESCAPED_CHARS).join("")}]`;
    const pattern = new RegExp(characterClass, "g");
    return input.replace(pattern, (char)=>ESCAPED_CHARS[char]);
}
var $5b7ccabde48fae90$var$WaterfallChartProxy = class extends $5b7ccabde48fae90$var$CartesianChartProxy {
    constructor(params){
        super(params);
    }
    getAxes(params, commonChartOptions) {
        return [
            {
                type: this.getXAxisType(params),
                position: this.isHorizontal(commonChartOptions) ? "left" : "bottom"
            },
            {
                type: "number",
                position: this.isHorizontal(commonChartOptions) ? "bottom" : "left"
            }
        ];
    }
    getSeries(params) {
        var _a;
        const [category] = params.categories;
        const [firstField] = params.fields;
        const firstSeries = {
            type: this.standaloneChartType,
            xKey: category.id,
            xName: category.name,
            yKey: firstField.colId,
            yName: (_a = firstField.displayName) != null ? _a : void 0
        };
        return [
            firstSeries
        ];
    }
};
var $5b7ccabde48fae90$var$CARTESIAN_AXIS_TYPES = [
    "number",
    "category",
    "time",
    "grouped-category"
];
var $5b7ccabde48fae90$var$POLAR_AXIS_TYPES = [
    "angle-category",
    "angle-number",
    "radius-category",
    "radius-number"
];
var $5b7ccabde48fae90$var$VALID_AXIS_TYPES = [
    ...$5b7ccabde48fae90$var$CARTESIAN_AXIS_TYPES,
    ...$5b7ccabde48fae90$var$POLAR_AXIS_TYPES
];
var $5b7ccabde48fae90$var$ChartOptionsService = class _ChartOptionsService extends (0, $jIDNV.BeanStub) {
    constructor(chartController){
        super();
        this.chartController = chartController;
    }
    getChartThemeOverridesProxy() {
        return {
            getValue: (expression)=>this.getChartOption(expression),
            setValue: (expression, value)=>this.setChartThemeOverrides([
                    {
                        expression: expression,
                        value: value
                    }
                ]),
            setValues: (properties)=>this.setChartThemeOverrides(properties)
        };
    }
    getAxisThemeOverridesProxy() {
        return {
            getValue: (expression)=>this.getAxisProperty(expression),
            setValue: (expression, value)=>this.setAxisThemeOverrides([
                    {
                        expression: expression,
                        value: value
                    }
                ]),
            setValues: (properties)=>this.setAxisThemeOverrides(properties)
        };
    }
    getCartesianAxisOptionsProxy(axisType) {
        return {
            getValue: (expression)=>this.getCartesianAxisProperty(axisType, expression),
            setValue: (expression, value)=>this.setCartesianAxisOptions(axisType, [
                    {
                        expression: expression,
                        value: value
                    }
                ]),
            setValues: (properties)=>this.setCartesianAxisOptions(axisType, properties)
        };
    }
    getCartesianAxisThemeOverridesProxy(axisType) {
        return {
            getValue: (expression)=>this.getCartesianAxisProperty(axisType, expression),
            setValue: (expression, value)=>this.setCartesianAxisThemeOverrides(axisType, [
                    {
                        expression: expression,
                        value: value
                    }
                ]),
            setValues: (properties)=>this.setCartesianAxisThemeOverrides(axisType, properties)
        };
    }
    getCartesianAxisAppliedThemeOverridesProxy(axisType) {
        return {
            getValue: (expression)=>this.getCartesianAxisThemeOverride(axisType, // Allow the caller to specify a wildcard expression to retrieve the whole set of overrides
                expression === "*" ? null : expression),
            setValue: (expression, value)=>this.setCartesianAxisThemeOverrides(axisType, // Allow the caller to specify a wildcard expression to set the whole set of overrides
                [
                    {
                        expression: expression === "*" ? null : expression,
                        value: value
                    }
                ]),
            setValues: (properties)=>this.setCartesianAxisThemeOverrides(axisType, properties)
        };
    }
    getSeriesOptionsProxy(getSelectedSeries) {
        return {
            getValue: (expression, calculated)=>this.getSeriesOption(getSelectedSeries(), expression, calculated),
            setValue: (expression, value)=>this.setSeriesOptions(getSelectedSeries(), [
                    {
                        expression: expression,
                        value: value
                    }
                ]),
            setValues: (properties)=>this.setSeriesOptions(getSelectedSeries(), properties)
        };
    }
    /**
   * Determine the set of theme overrides that should be retained when transitioning from one chart type to another.
   */ getPersistedChartThemeOverrides(existingChartOptions, existingAxes, existingChartType, targetChartType) {
        const retainedThemeOverrideKeys = this.getRetainedChartThemeOverrideKeys(existingChartType, targetChartType);
        const retainedChartAxisThemeOverrideKeys = this.getRetainedChartAxisThemeOverrideKeys(null, existingChartType, targetChartType);
        const targetChartOptions = this.createChartOptions();
        for (const expression of retainedThemeOverrideKeys){
            const value = this.retrieveChartOptionsThemeOverride(existingChartOptions, existingChartType, expression);
            if (value !== void 0) this.assignChartOptionsThemeOverride(targetChartOptions, targetChartType, expression, value);
        }
        if (existingAxes) this.assignPersistedAxisOverrides({
            existingAxes: existingAxes,
            retainedChartAxisThemeOverrideKeys: retainedChartAxisThemeOverrideKeys,
            existingChartOptions: existingChartOptions,
            targetChartOptions: targetChartOptions,
            existingChartType: existingChartType,
            targetChartType: targetChartType
        });
        return targetChartOptions.theme.overrides;
    }
    assignPersistedAxisOverrides(params) {
        const { existingAxes: existingAxes, retainedChartAxisThemeOverrideKeys: retainedChartAxisThemeOverrideKeys, existingChartOptions: existingChartOptions, targetChartOptions: targetChartOptions, existingChartType: existingChartType, targetChartType: targetChartType } = params;
        for (const { expression: expression, targetAxisTypes: targetAxisTypes } of retainedChartAxisThemeOverrideKeys)for (const existingAxisType of existingAxes.map((axis)=>axis.type)){
            const value = this.retrieveChartOptionsThemeOverride(existingChartOptions, existingChartType, [
                "axes",
                existingAxisType,
                expression
            ].join("."));
            if (value !== void 0) for (const targetAxisType of targetAxisTypes)this.assignChartOptionsThemeOverride(targetChartOptions, targetChartType, [
                "axes",
                targetAxisType,
                expression
            ].join("."), value);
        }
    }
    getRetainedChartThemeOverrideKeys(existingChartType, targetChartType) {
        const UNIVERSAL_PERSISTED_THEME_OVERRIDES = [
            "animation"
        ];
        const PERSISTED_CARTESIAN_CHART_THEME_OVERRIDES = [
            "zoom",
            "navigator"
        ];
        const chartSpecificThemeOverrideKeys = ((previousChartType, updatedChartType)=>{
            const expressions = new Array();
            if ($5b7ccabde48fae90$var$isCartesian($5b7ccabde48fae90$var$getSeriesType(previousChartType)) && $5b7ccabde48fae90$var$isCartesian($5b7ccabde48fae90$var$getSeriesType(updatedChartType))) expressions.push(...PERSISTED_CARTESIAN_CHART_THEME_OVERRIDES);
            return expressions;
        })(existingChartType, targetChartType);
        return [
            ...UNIVERSAL_PERSISTED_THEME_OVERRIDES,
            ...chartSpecificThemeOverrideKeys
        ];
    }
    getRetainedChartAxisThemeOverrideKeys(axisType, existingChartType, targetChartType) {
        if ($5b7ccabde48fae90$var$isCartesian($5b7ccabde48fae90$var$getSeriesType(existingChartType)) && $5b7ccabde48fae90$var$isCartesian($5b7ccabde48fae90$var$getSeriesType(targetChartType))) {
            const retainedKeys = this.getRetainedCartesianAxisThemeOverrideKeys(axisType);
            return retainedKeys.map((expression)=>({
                    expression: expression,
                    targetAxisTypes: $5b7ccabde48fae90$var$CARTESIAN_AXIS_TYPES
                }));
        }
        return [];
    }
    getRetainedCartesianAxisThemeOverrideKeys(axisType) {
        const axisPositionSuffixes = axisType === "xAxis" ? [
            "",
            ".top",
            ".bottom"
        ] : axisType === "yAxis" ? [
            "",
            ".left",
            ".right"
        ] : [
            "",
            ".left",
            ".right",
            ".top",
            ".bottom"
        ];
        const PERSISTED_CARTESIAN_AXIS_THEME_OVERRIDES = [
            "crosshair"
        ];
        const expressions = new Array();
        for (const expression of PERSISTED_CARTESIAN_AXIS_THEME_OVERRIDES)for (const axisPositionSuffix of axisPositionSuffixes)expressions.push(`${expression}${axisPositionSuffix}`);
        return expressions;
    }
    getChartOption(expression) {
        return $5b7ccabde48fae90$var$get(this.getChart(), expression, void 0);
    }
    setChartThemeOverrides(properties) {
        const chartType = this.getChartType();
        const chartOptions = this.createChartOptions();
        for (const { expression: expression, value: value } of properties)this.assignChartOptionsThemeOverride(chartOptions, chartType, expression, value);
        this.applyChartOptions(chartOptions);
    }
    applyChartOptions(chartOptions, options) {
        if (Object.keys(chartOptions).length === 0) return;
        this.updateChart(chartOptions);
        const shouldRaiseEvent = !(options == null ? void 0 : options.silent);
        if (shouldRaiseEvent) this.raiseChartOptionsChangedEvent();
    }
    awaitChartOptionUpdate(func) {
        const chart = this.chartController.getChartProxy().getChart();
        chart.waitForUpdate().then(()=>func()).catch((e)=>console.error(`AG Grid - chart update failed`, e));
    }
    getAxisProperty(expression) {
        var _a;
        return $5b7ccabde48fae90$var$get((_a = this.getChart().axes) == null ? void 0 : _a[0], expression, void 0);
    }
    setAxisThemeOverrides(properties) {
        var _a;
        const chart = this.getChart();
        const chartType = this.getChartType();
        let chartOptions = this.createChartOptions();
        for (const { expression: expression, value: value } of properties){
            const relevantAxes = (_a = chart.axes) == null ? void 0 : _a.filter((axis)=>{
                const parts = expression.split(".");
                let current = axis;
                for (const part of parts){
                    if (!(part in current)) return false;
                    current = current[part];
                }
                return true;
            });
            if (!relevantAxes) continue;
            for (const axis of relevantAxes){
                if (!this.isValidAxisType(axis)) continue;
                this.assignChartAxisThemeOverride(chartOptions, chartType, axis.type, null, expression, value);
            }
        }
        this.applyChartOptions(chartOptions);
    }
    getCartesianAxisProperty(axisType, expression) {
        const axes = this.getChartAxes();
        const axis = this.getCartesianAxis(axes, axisType);
        return $5b7ccabde48fae90$var$get(axis, expression, void 0);
    }
    getCartesianAxisThemeOverride(axisType, expression) {
        const axes = this.getChartAxes();
        const chartAxis = this.getCartesianAxis(axes, axisType);
        if (!chartAxis || !this.isValidAxisType(chartAxis)) return void 0;
        const chartType = this.getChartType();
        const chartOptions = this.getChart().getOptions();
        return this.retrieveChartAxisThemeOverride(chartOptions, chartType, chartAxis.type, axisType === "yAxis" ? [
            "left",
            "right"
        ] : [
            "bottom",
            "top"
        ], expression);
    }
    setCartesianAxisThemeOverrides(axisType, properties) {
        const axes = this.getChartAxes();
        const chartAxis = this.getCartesianAxis(axes, axisType);
        if (!chartAxis || !this.isValidAxisType(chartAxis)) return;
        const chartType = this.getChartType();
        let chartOptions = this.createChartOptions();
        for (const { expression: expression, value: value } of properties)this.assignChartAxisThemeOverride(chartOptions, chartType, chartAxis.type, axisType === "yAxis" ? [
            "left",
            "right"
        ] : [
            "bottom",
            "top"
        ], expression, value);
        this.applyChartOptions(chartOptions);
    }
    setCartesianAxisOptions(axisType, properties) {
        this.updateCartesianAxisOptions(axisType, (chartOptions, axes, chartAxis)=>{
            const axisIndex = axes.indexOf(chartAxis);
            for (const { expression: expression, value: value } of properties)this.assignChartOption(chartOptions, `axes.${axisIndex}.${expression}`, value);
        });
    }
    updateCartesianAxisOptions(axisType, updateFunc) {
        const existingChartOptions = this.getChart().getOptions();
        const axisOptions = "axes" in existingChartOptions ? existingChartOptions.axes : void 0;
        if (!existingChartOptions || !axisOptions) return;
        const axes = this.getChartAxes();
        const chartAxis = this.getCartesianAxis(axes, axisType);
        if (!chartAxis) return;
        let chartOptions = this.createChartOptions();
        chartOptions.axes = axisOptions;
        updateFunc(chartOptions, axes, chartAxis, existingChartOptions);
        this.applyChartOptions(chartOptions);
    }
    setCartesianCategoryAxisType(axisType, value) {
        this.updateCartesianAxisOptions(axisType, (chartOptions, _axes, chartAxis, existingChartOptions)=>{
            const chartType = this.getChartType();
            this.assignPersistedAxisOverrides({
                existingAxes: [
                    chartAxis
                ],
                retainedChartAxisThemeOverrideKeys: this.getRetainedChartAxisThemeOverrideKeys(axisType, chartType, chartType),
                existingChartOptions: existingChartOptions,
                targetChartOptions: chartOptions,
                existingChartType: chartType,
                targetChartType: chartType
            });
            this.assignChartOption(chartOptions, `axes.0.type`, value);
            this.chartController.setCategoryAxisType(value);
        });
    }
    getCartesianAxis(axes, axisType) {
        if (axes.length < 2) return void 0;
        switch(axisType){
            case "xAxis":
                return axes[0].direction === "x" ? axes[0] : axes[1];
            case "yAxis":
                return axes[1].direction === "y" ? axes[1] : axes[0];
        }
    }
    getSeriesOption(seriesType, expression, calculated) {
        const series = this.getChart().series.find((s)=>_ChartOptionsService.isMatchingSeries(seriesType, s));
        return $5b7ccabde48fae90$var$get(calculated ? series : series == null ? void 0 : series.properties.toJson(), expression, void 0);
    }
    setSeriesOptions(seriesType, properties) {
        let chartOptions = this.createChartOptions();
        for (const { expression: expression, value: value } of properties)this.assignChartOptionsSeriesThemeOverride(chartOptions, seriesType, `series.${expression}`, value);
        this.applyChartOptions(chartOptions);
    }
    getPairedMode() {
        return this.chartController.getChartProxy().isPaired();
    }
    setPairedMode(paired) {
        this.chartController.getChartProxy().setPaired(paired);
    }
    getChartAxes() {
        var _a;
        const chart = this.getChart();
        return (_a = chart.axes) != null ? _a : [];
    }
    retrieveChartAxisThemeOverride(chartOptions, chartType, axisType, axisPositions, expression) {
        if (axisPositions) for (const axisPosition of axisPositions){
            const value = this.retrieveChartOptionsThemeOverride(chartOptions, chartType, [
                "axes",
                axisType,
                axisPosition,
                ...expression ? [
                    expression
                ] : []
            ].join("."));
            if (value === void 0) continue;
            return value;
        }
        else return this.retrieveChartOptionsThemeOverride(chartOptions, chartType, [
            "axes",
            axisType,
            ...expression ? [
                expression
            ] : []
        ].join("."));
    }
    assignChartAxisThemeOverride(chartOptions, chartType, axisType, axisPositions, expression, value) {
        if (axisPositions) for (const axisPosition of axisPositions)this.assignChartOptionsThemeOverride(chartOptions, chartType, [
            "axes",
            axisType,
            axisPosition,
            ...expression ? [
                expression
            ] : []
        ].join("."), value);
        else this.assignChartOptionsThemeOverride(chartOptions, chartType, [
            "axes",
            axisType,
            ...expression ? [
                expression
            ] : []
        ].join("."), value);
    }
    isValidAxisType(chartAxis) {
        return $5b7ccabde48fae90$var$VALID_AXIS_TYPES.includes(chartAxis.type);
    }
    getChartType() {
        return this.chartController.getChartType();
    }
    getChart() {
        return this.chartController.getChartProxy().getChart();
    }
    updateChart(chartOptions) {
        const chartRef = this.chartController.getChartProxy().getChartRef();
        chartRef.skipAnimations();
        (0, $iTJTu.AgCharts).updateDelta(chartRef, chartOptions);
    }
    createChartOptions() {
        const chartOptions = {
            theme: {
                overrides: {}
            }
        };
        return chartOptions;
    }
    retrieveChartOptionsThemeOverride(chartOptions, chartType, expression) {
        const chartSeriesTypes = this.getChartThemeOverridesSeriesTypeKeys(chartType);
        for (const seriesType of chartSeriesTypes){
            const value = this.retrieveChartOptionsSeriesThemeOverride(chartOptions, seriesType, expression);
            if (value === void 0) continue;
            return value;
        }
        return void 0;
    }
    assignChartOptionsThemeOverride(chartOptions, chartType, expression, value) {
        const chartSeriesTypes = this.getChartThemeOverridesSeriesTypeKeys(chartType);
        for (const seriesType of chartSeriesTypes)this.assignChartOptionsSeriesThemeOverride(chartOptions, seriesType, expression, value);
    }
    retrieveChartOptionsSeriesThemeOverride(chartOptions, seriesType, expression) {
        return this.retrieveChartOption(chartOptions, [
            "theme",
            "overrides",
            seriesType,
            ...expression ? [
                expression
            ] : []
        ].join("."));
    }
    assignChartOptionsSeriesThemeOverride(chartOptions, seriesType, expression, value) {
        this.assignChartOption(chartOptions, [
            "theme",
            "overrides",
            seriesType,
            ...expression ? [
                expression
            ] : []
        ].join("."), value);
    }
    getChartThemeOverridesSeriesTypeKeys(chartType) {
        const chartSeriesTypes = this.chartController.getChartSeriesTypes(chartType);
        if (this.chartController.isComboChart()) chartSeriesTypes.push("common");
        return chartSeriesTypes;
    }
    retrieveChartOption(chartOptions, expression) {
        return $5b7ccabde48fae90$var$get(chartOptions, expression, void 0);
    }
    assignChartOption(chartOptions, expression, value) {
        $5b7ccabde48fae90$var$set(chartOptions, expression, value);
    }
    raiseChartOptionsChangedEvent() {
        const chartModel = this.chartController.getChartModel();
        const event = {
            type: (0, $jIDNV.Events).EVENT_CHART_OPTIONS_CHANGED,
            chartId: chartModel.chartId,
            chartType: chartModel.chartType,
            chartThemeName: this.chartController.getChartThemeName(),
            chartOptions: chartModel.chartOptions
        };
        this.eventService.dispatchEvent(event);
    }
    static isMatchingSeries(seriesType, series) {
        return $5b7ccabde48fae90$var$isSeriesType(seriesType) && series.type === seriesType;
    }
    destroy() {
        super.destroy();
    }
};
var $5b7ccabde48fae90$var$ComboChartProxy = class extends $5b7ccabde48fae90$var$CartesianChartProxy {
    constructor(params){
        super(params);
    }
    getAxes(params) {
        const fields = params ? params.fields : [];
        const fieldsMap = new Map(fields.map((f)=>[
                f.colId,
                f
            ]));
        const { primaryYKeys: primaryYKeys, secondaryYKeys: secondaryYKeys } = this.getYKeys(fields, params.seriesChartTypes);
        const axes = [
            {
                type: this.getXAxisType(params),
                position: "bottom"
            }
        ];
        if (primaryYKeys.length > 0) axes.push({
            type: "number",
            keys: primaryYKeys,
            position: "left"
        });
        if (secondaryYKeys.length > 0) secondaryYKeys.forEach((secondaryYKey)=>{
            const field = fieldsMap.get(secondaryYKey);
            const secondaryAxisIsVisible = field && field.colId === secondaryYKey;
            if (!secondaryAxisIsVisible) return;
            const secondaryAxisOptions = {
                type: "number",
                keys: [
                    secondaryYKey
                ],
                position: "right"
            };
            axes.push(secondaryAxisOptions);
        });
        return axes;
    }
    getSeries(params) {
        const { fields: fields, seriesChartTypes: seriesChartTypes } = params;
        const [category] = params.categories;
        return fields.map((field)=>{
            const seriesChartType = seriesChartTypes.find((s)=>s.colId === field.colId);
            if (seriesChartType) {
                const chartType = seriesChartType.chartType;
                const grouped = [
                    "groupedColumn",
                    "groupedBar"
                ].includes(chartType);
                const groupedOpts = grouped ? {
                    grouped: true
                } : {};
                return $5b7ccabde48fae90$var$__spreadValues3({
                    type: $5b7ccabde48fae90$var$getSeriesType(chartType),
                    xKey: category.id,
                    yKey: field.colId,
                    yName: field.displayName,
                    stacked: [
                        "stackedArea",
                        "stackedColumn"
                    ].includes(chartType)
                }, groupedOpts);
            }
        });
    }
    getYKeys(fields, seriesChartTypes) {
        const primaryYKeys = [];
        const secondaryYKeys = [];
        fields.forEach((field)=>{
            const colId = field.colId;
            const seriesChartType = seriesChartTypes.find((s)=>s.colId === colId);
            if (seriesChartType) seriesChartType.secondaryAxis ? secondaryYKeys.push(colId) : primaryYKeys.push(colId);
        });
        return {
            primaryYKeys: primaryYKeys,
            secondaryYKeys: secondaryYKeys
        };
    }
};
var $5b7ccabde48fae90$var$CHART_TOOL_PANEL_ALLOW_LIST = [
    "chartSettings",
    "chartData",
    "chartFormat"
];
var $5b7ccabde48fae90$var$CHART_TOOLBAR_ALLOW_LIST = [
    "chartUnlink",
    "chartLink",
    "chartDownload"
];
var $5b7ccabde48fae90$var$CHART_TOOL_PANEL_MENU_OPTIONS = {
    settings: "chartSettings",
    data: "chartData",
    format: "chartFormat"
};
var $5b7ccabde48fae90$var$ChartMenuService = class extends (0, $jIDNV.BeanStub) {
    isLegacyFormat() {
        return !this.chartService.isEnterprise();
    }
    downloadChart(chartMenuContext, dimensions, fileName, fileFormat) {
        chartMenuContext.chartController.getChartProxy().downloadChart(dimensions, fileName, fileFormat);
    }
    toggleLinked(chartMenuContext) {
        chartMenuContext.chartController.detachChartRange();
    }
    openAdvancedSettings(chartMenuContext, eventSource) {
        this.advancedSettingsMenuFactory.showMenu(chartMenuContext, eventSource);
    }
    hideAdvancedSettings() {
        this.advancedSettingsMenuFactory.hideMenu();
    }
    getToolbarOptionsAndPanels(chartController) {
        var _a, _b, _c;
        const legacyFormat = this.isLegacyFormat();
        const useChartToolPanelCustomisation = Boolean(this.gos.get("chartToolPanelsDef")) || !legacyFormat;
        let panels;
        let defaultPanel;
        let chartToolbarOptions;
        if (useChartToolPanelCustomisation) {
            const defaultChartToolbarOptions = legacyFormat ? [
                chartController.isChartLinked() ? "chartLink" : "chartUnlink",
                "chartDownload"
            ] : [
                "chartMenu"
            ];
            const toolbarItemsFunc = this.gos.getCallback("getChartToolbarItems");
            const params = {
                defaultItems: defaultChartToolbarOptions
            };
            chartToolbarOptions = toolbarItemsFunc ? toolbarItemsFunc(params).filter((option)=>{
                if (!(legacyFormat ? $5b7ccabde48fae90$var$CHART_TOOLBAR_ALLOW_LIST : [
                    ...$5b7ccabde48fae90$var$CHART_TOOLBAR_ALLOW_LIST,
                    "chartMenu"
                ]).includes(option)) {
                    let msg;
                    if ($5b7ccabde48fae90$var$CHART_TOOL_PANEL_ALLOW_LIST.includes(option)) msg = `'${option}' is a Chart Tool Panel option and will be ignored since 'chartToolPanelsDef' is used. Please use 'chartToolPanelsDef.panels' grid option instead`;
                    else if (option === "chartMenu") msg = `'chartMenu' is only allowed as a Chart Toolbar Option when using AG Charts Enterprise`;
                    else msg = `'${option}' is not a valid Chart Toolbar Option`;
                    (0, $jIDNV._).warnOnce(msg);
                    return false;
                }
                return true;
            }) : defaultChartToolbarOptions;
            const panelsOverride = (_b = (_a = this.gos.get("chartToolPanelsDef")) == null ? void 0 : _a.panels) == null ? void 0 : _b.map((panel)=>{
                const menuOption = $5b7ccabde48fae90$var$CHART_TOOL_PANEL_MENU_OPTIONS[panel];
                if (!menuOption) (0, $jIDNV._).warnOnce(`Invalid panel in chartToolPanelsDef.panels: '${panel}'`);
                return menuOption;
            }).filter((panel)=>Boolean(panel));
            panels = panelsOverride ? panelsOverride : Object.values($5b7ccabde48fae90$var$CHART_TOOL_PANEL_MENU_OPTIONS);
            if (chartController.isPivotChart()) panels = panels.filter((panel)=>panel !== "chartData");
            const defaultToolPanel = (_c = this.gos.get("chartToolPanelsDef")) == null ? void 0 : _c.defaultToolPanel;
            defaultPanel = defaultToolPanel && $5b7ccabde48fae90$var$CHART_TOOL_PANEL_MENU_OPTIONS[defaultToolPanel] || panels[0];
            if (legacyFormat) chartToolbarOptions = panels.length > 0 ? [
                panels[0],
                ...chartToolbarOptions
            ] : chartToolbarOptions;
        } else {
            let tabOptions = [
                "chartSettings",
                "chartData",
                "chartFormat",
                chartController.isChartLinked() ? "chartLink" : "chartUnlink",
                "chartDownload"
            ];
            const toolbarItemsFunc = this.gos.getCallback("getChartToolbarItems");
            if (toolbarItemsFunc) {
                const isLegacyToolbar = this.gos.get("suppressChartToolPanelsButton");
                const params = {
                    defaultItems: isLegacyToolbar ? tabOptions : $5b7ccabde48fae90$var$CHART_TOOLBAR_ALLOW_LIST
                };
                tabOptions = toolbarItemsFunc(params).filter((option)=>{
                    if (!$5b7ccabde48fae90$var$CHART_TOOL_PANEL_ALLOW_LIST.includes(option) && !$5b7ccabde48fae90$var$CHART_TOOLBAR_ALLOW_LIST.includes(option)) {
                        (0, $jIDNV._).warnOnce(`'${option}' is not a valid Chart Toolbar Option`);
                        return false;
                    } else if (!isLegacyToolbar && $5b7ccabde48fae90$var$CHART_TOOL_PANEL_ALLOW_LIST.includes(option)) {
                        const msg = `'${option}' is a Chart Tool Panel option and will be ignored. Please use 'chartToolPanelsDef.panels' grid option instead`;
                        (0, $jIDNV._).warnOnce(msg);
                        return false;
                    }
                    return true;
                });
                if (!isLegacyToolbar) tabOptions = tabOptions.concat($5b7ccabde48fae90$var$CHART_TOOL_PANEL_ALLOW_LIST);
            }
            if (chartController.isPivotChart()) tabOptions = tabOptions.filter((option)=>option !== "chartData");
            const ignoreOptions = [
                "chartUnlink",
                "chartLink",
                "chartDownload"
            ];
            panels = tabOptions.filter((option)=>ignoreOptions.indexOf(option) === -1);
            defaultPanel = panels[0];
            chartToolbarOptions = tabOptions.filter((value)=>ignoreOptions.indexOf(value) !== -1 || panels.length && value === panels[0]);
        }
        return {
            panels: panels,
            defaultPanel: defaultPanel,
            chartToolbarOptions: chartToolbarOptions
        };
    }
    doesChartToolbarExist(chartController) {
        const { chartToolbarOptions: chartToolbarOptions } = this.getToolbarOptionsAndPanels(chartController);
        return [
            "chartMenu",
            ...$5b7ccabde48fae90$var$CHART_TOOLBAR_ALLOW_LIST
        ].some((option)=>chartToolbarOptions.includes(option));
    }
    doChartToolPanelsExist(chartController) {
        const { panels: panels } = this.getToolbarOptionsAndPanels(chartController);
        return panels.length > 0;
    }
};
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartService")
], $5b7ccabde48fae90$var$ChartMenuService.prototype, "chartService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("advancedSettingsMenuFactory")
], $5b7ccabde48fae90$var$ChartMenuService.prototype, "advancedSettingsMenuFactory", 2);
$5b7ccabde48fae90$var$ChartMenuService = $5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Bean)("chartMenuService")
], $5b7ccabde48fae90$var$ChartMenuService);
var $5b7ccabde48fae90$var$CATEGORY_LABEL_KEY = "AG-GRID-DEFAULT-LABEL-KEY";
function $5b7ccabde48fae90$var$createCategoryHierarchy(data, categoryKeys) {
    const hierarchy = $5b7ccabde48fae90$var$buildNestedHierarchy(data, getItemDepth, getItemCategoryLabel);
    return $5b7ccabde48fae90$var$formatCategoryHierarchy(hierarchy);
    function getItemDepth(item) {
        return categoryKeys.length;
    }
    function getItemCategoryLabel(item, categoryIndex) {
        const categoryKey = categoryKeys[categoryIndex];
        const categoryValue = item[categoryKey];
        return getCategoryLabel(categoryValue);
    }
    function getCategoryLabel(value) {
        if (value == null) return null;
        return String(value);
    }
}
function $5b7ccabde48fae90$var$createAutoGroupHierarchy(data, getItemLabels) {
    const hierarchy = $5b7ccabde48fae90$var$buildNestedHierarchy(data, getItemDepth, getItemGroupLabel);
    return $5b7ccabde48fae90$var$formatCategoryHierarchy(hierarchy);
    function getItemDepth(item) {
        var _a, _b;
        return (_b = (_a = getItemLabels(item)) == null ? void 0 : _a.length) != null ? _b : 0;
    }
    function getItemGroupLabel(item, groupIndex) {
        const labels = getItemLabels(item);
        if (!labels) return null;
        const labelIndex = labels.length - 1 - groupIndex;
        return labels[labelIndex];
    }
}
function $5b7ccabde48fae90$var$formatCategoryHierarchy(hierarchy, key = null, isChild) {
    const { depth: depth, rootValues: rootValues, value: value, children: inputChildren } = hierarchy;
    if (rootValues) return rootValues.map((item)=>$5b7ccabde48fae90$var$__spreadValues3({
            [$5b7ccabde48fae90$var$CATEGORY_LABEL_KEY]: key
        }, item));
    else if (depth === 0) return [
        $5b7ccabde48fae90$var$__spreadValues3({
            [$5b7ccabde48fae90$var$CATEGORY_LABEL_KEY]: key
        }, value)
    ];
    const children = [];
    for (const [childKey, childHierarchy] of inputChildren.entries())children.push(...$5b7ccabde48fae90$var$formatCategoryHierarchy(childHierarchy, childKey, true));
    return isChild ? [
        $5b7ccabde48fae90$var$__spreadValues3({
            [$5b7ccabde48fae90$var$CATEGORY_LABEL_KEY]: key,
            children: children
        }, value != null ? value : {})
    ] : children;
}
function $5b7ccabde48fae90$var$buildNestedHierarchy(data, getItemDepth, getItemGroupKey) {
    const hierarchy = {
        depth: 0,
        children: /* @__PURE__ */ new Map()
    };
    data.forEach((item)=>{
        const itemDepth = getItemDepth(item);
        createNestedItemHierarchy(item, itemDepth, getItemGroupKey, 0, hierarchy);
    });
    return hierarchy;
    function createNestedItemHierarchy(item, itemDepth, getItemGroupKey2, currentDepth, hierarchy2) {
        if (currentDepth === itemDepth) {
            if (currentDepth === 0) {
                if (!hierarchy2.rootValues) hierarchy2.rootValues = [];
                hierarchy2.rootValues.push(item);
            } else hierarchy2.value = item;
            return hierarchy2;
        } else {
            const key = getItemGroupKey2(item, currentDepth);
            const existingChildHierarchy = hierarchy2.children.get(key);
            const childHierarchy = createNestedItemHierarchy(item, itemDepth, getItemGroupKey2, currentDepth + 1, existingChildHierarchy || {
                depth: 0,
                children: /* @__PURE__ */ new Map()
            });
            hierarchy2.children.set(key, childHierarchy);
            hierarchy2.depth = Math.max(1 + childHierarchy.depth, hierarchy2.depth);
            return hierarchy2;
        }
    }
}
var $5b7ccabde48fae90$var$HierarchicalChartProxy = class extends $5b7ccabde48fae90$var$ChartProxy {
    constructor(chartProxyParams){
        super(chartProxyParams);
    }
    getUpdateOptions(params, commonChartOptions) {
        const { fields: fields } = params;
        const [sizeField, colorField] = fields;
        return $5b7ccabde48fae90$var$__spreadProps3($5b7ccabde48fae90$var$__spreadValues3({}, commonChartOptions), {
            series: this.getSeries(sizeField, colorField),
            data: this.getData(params, sizeField, colorField)
        });
    }
    getSeriesChartThemeDefaults() {
        return {
            gradientLegend: {
                gradient: {
                    preferredLength: 200
                }
            }
        };
    }
    getSeries(sizeField, colorField) {
        var _a, _b;
        return [
            {
                type: this.standaloneChartType,
                labelKey: $5b7ccabde48fae90$var$CATEGORY_LABEL_KEY,
                // Size and color fields are inferred from the range data
                sizeKey: sizeField == null ? void 0 : sizeField.colId,
                sizeName: (_a = sizeField == null ? void 0 : sizeField.displayName) != null ? _a : void 0,
                colorKey: colorField == null ? void 0 : colorField.colId,
                colorName: (_b = colorField == null ? void 0 : colorField.displayName) != null ? _b : void 0
            }
        ];
    }
    getData(params, sizeField, colorField) {
        var _a;
        const { categories: categories, data: data, groupData: groupData, grouping: isGrouped } = params;
        if (isGrouped) {
            const processedData = colorField ? data.concat((_a = groupData == null ? void 0 : groupData.map((groupDatum)=>{
                const newDatum = $5b7ccabde48fae90$var$__spreadValues3({}, groupDatum);
                delete newDatum[sizeField.colId];
                return newDatum;
            })) != null ? _a : []) : data;
            return $5b7ccabde48fae90$var$createAutoGroupHierarchy(processedData, (item)=>{
                var _a2, _b;
                return (_b = (_a2 = item[0, $jIDNV.GROUP_AUTO_COLUMN_ID]) == null ? void 0 : _a2.labels) != null ? _b : null;
            });
        } else {
            const categoryKeys = categories.map(({ id: id })=>id);
            return $5b7ccabde48fae90$var$createCategoryHierarchy(data, categoryKeys);
        }
    }
};
var $5b7ccabde48fae90$var$_GridChartComp = class _GridChartComp2 extends (0, $jIDNV.Component) {
    constructor(params){
        super(_GridChartComp2.TEMPLATE);
        this.params = params;
    }
    init() {
        const modelParams = $5b7ccabde48fae90$var$__spreadProps3($5b7ccabde48fae90$var$__spreadValues3({}, this.params), {
            chartType: $5b7ccabde48fae90$var$getCanonicalChartType(this.params.chartType),
            chartThemeName: this.getThemeName()
        });
        const isRtl = this.gos.get("enableRtl");
        this.addCssClass(isRtl ? "ag-rtl" : "ag-ltr");
        const model = this.createBean(new $5b7ccabde48fae90$var$ChartDataModel(modelParams));
        this.chartController = this.createManagedBean(new $5b7ccabde48fae90$var$ChartController(model));
        this.chartOptionsService = this.createManagedBean(new $5b7ccabde48fae90$var$ChartOptionsService(this.chartController));
        this.validateCustomThemes();
        this.createChart();
        if (this.params.insideDialog) this.addDialog();
        this.addMenu();
        this.addTitleEditComp();
        this.addManagedListener(this.getGui(), "focusin", this.setActiveChartCellRange.bind(this));
        this.addManagedListener(this.chartController, $5b7ccabde48fae90$var$ChartController.EVENT_CHART_MODEL_UPDATE, this.update.bind(this));
        this.addManagedPropertyListeners([
            "chartThemeOverrides",
            "chartThemes"
        ], this.reactivePropertyUpdate.bind(this));
        this.update();
        this.raiseChartCreatedEvent();
    }
    createChart() {
        var _a;
        let chartInstance = void 0;
        if (this.chartProxy) chartInstance = this.chartProxy.destroy({
            keepChartInstance: true
        });
        const crossFilterCallback = (event, reset)=>{
            const ctx = this.params.crossFilteringContext;
            ctx.lastSelectedChartId = reset ? "" : this.chartController.getChartId();
            if (reset) this.params.crossFilteringResetCallback();
            this.crossFilterService.filter(event, reset);
        };
        const chartType = this.chartController.getChartType();
        const chartProxyParams = {
            chartType: chartType,
            chartInstance: chartInstance,
            getChartThemeName: this.getChartThemeName.bind(this),
            getChartThemes: this.getChartThemes.bind(this),
            customChartThemes: this.gos.get("customChartThemes"),
            getGridOptionsChartThemeOverrides: ()=>this.getGridOptionsChartThemeOverrides(),
            getExtraPaddingDirections: ()=>{
                var _a2, _b;
                return (_b = (_a2 = this.chartMenu) == null ? void 0 : _a2.getExtraPaddingDirections()) != null ? _b : [];
            },
            apiChartThemeOverrides: this.params.chartThemeOverrides,
            crossFiltering: (_a = this.params.crossFiltering) != null ? _a : false,
            crossFilterCallback: crossFilterCallback,
            parentElement: this.eChart,
            grouping: this.chartController.isGrouping(),
            chartThemeToRestore: this.params.chartThemeName,
            chartOptionsToRestore: this.params.chartOptionsToRestore,
            chartPaletteToRestore: this.params.chartPaletteToRestore,
            seriesChartTypes: this.chartController.getSeriesChartTypes(),
            translate: (toTranslate)=>this.chartTranslationService.translate(toTranslate)
        };
        this.params.chartOptionsToRestore = void 0;
        this.chartType = chartType;
        this.chartProxy = _GridChartComp2.createChartProxy(chartProxyParams);
        if (!this.chartProxy) {
            console.warn("AG Grid: invalid chart type supplied: ", chartProxyParams.chartType);
            return;
        }
        const canvas = this.eChart.querySelector("canvas");
        if (canvas) canvas.classList.add("ag-charts-canvas");
        this.chartController.setChartProxy(this.chartProxy);
        this.createMenuContext();
        this.titleEdit && this.titleEdit.refreshTitle(this.chartMenuContext);
    }
    createMenuContext() {
        if (this.chartMenuContext) return;
        const chartMenuParamsFactory = this.createManagedBean(new $5b7ccabde48fae90$var$ChartMenuParamsFactory(this.chartOptionsService.getChartThemeOverridesProxy()));
        const chartAxisMenuParamsFactory = this.createManagedBean(new $5b7ccabde48fae90$var$ChartMenuParamsFactory(this.chartOptionsService.getAxisThemeOverridesProxy()));
        this.chartMenuContext = {
            chartController: this.chartController,
            chartOptionsService: this.chartOptionsService,
            chartMenuParamsFactory: chartMenuParamsFactory,
            chartAxisMenuParamsFactory: chartAxisMenuParamsFactory
        };
    }
    getChartThemeName() {
        return this.chartController.getChartThemeName();
    }
    getChartThemes() {
        return this.chartController.getThemeNames();
    }
    getGridOptionsChartThemeOverrides() {
        return this.gos.get("chartThemeOverrides");
    }
    static createChartProxy(chartProxyParams) {
        switch(chartProxyParams.chartType){
            case "column":
            case "bar":
            case "groupedColumn":
            case "stackedColumn":
            case "normalizedColumn":
            case "groupedBar":
            case "stackedBar":
            case "normalizedBar":
                return new $5b7ccabde48fae90$var$BarChartProxy(chartProxyParams);
            case "pie":
            case "donut":
            case "doughnut":
                return new $5b7ccabde48fae90$var$PieChartProxy(chartProxyParams);
            case "area":
            case "stackedArea":
            case "normalizedArea":
                return new $5b7ccabde48fae90$var$AreaChartProxy(chartProxyParams);
            case "line":
                return new $5b7ccabde48fae90$var$LineChartProxy(chartProxyParams);
            case "scatter":
            case "bubble":
                return new $5b7ccabde48fae90$var$ScatterChartProxy(chartProxyParams);
            case "histogram":
                return new $5b7ccabde48fae90$var$HistogramChartProxy(chartProxyParams);
            case "radarLine":
            case "radarArea":
            case "nightingale":
            case "radialColumn":
            case "radialBar":
                return new $5b7ccabde48fae90$var$PolarChartProxy(chartProxyParams);
            case "rangeBar":
            case "rangeArea":
                return new $5b7ccabde48fae90$var$RangeChartProxy(chartProxyParams);
            case "boxPlot":
                return new $5b7ccabde48fae90$var$BoxPlotChartProxy(chartProxyParams);
            case "treemap":
            case "sunburst":
                return new $5b7ccabde48fae90$var$HierarchicalChartProxy(chartProxyParams);
            case "heatmap":
                return new $5b7ccabde48fae90$var$HeatmapChartProxy(chartProxyParams);
            case "waterfall":
                return new $5b7ccabde48fae90$var$WaterfallChartProxy(chartProxyParams);
            case "columnLineCombo":
            case "areaColumnCombo":
            case "customCombo":
                return new $5b7ccabde48fae90$var$ComboChartProxy(chartProxyParams);
            default:
                throw `AG Grid: Unable to create chart as an invalid chartType = '${chartProxyParams.chartType}' was supplied.`;
        }
    }
    addDialog() {
        const title = this.chartTranslationService.translate(this.params.pivotChart ? "pivotChartTitle" : "rangeChartTitle");
        const { width: width, height: height } = this.getBestDialogSize();
        this.chartDialog = new (0, $jIDNV.AgDialog)({
            resizable: true,
            movable: true,
            maximizable: true,
            title: title,
            width: width,
            height: height,
            component: this,
            centered: true,
            closable: true
        });
        this.getContext().createBean(this.chartDialog);
        this.chartDialog.addEventListener((0, $jIDNV.AgDialog).EVENT_DESTROYED, ()=>{
            this.destroy();
            this.chartMenuService.hideAdvancedSettings();
        });
    }
    getBestDialogSize() {
        const popupParent = this.popupService.getPopupParent();
        const maxWidth = (0, $jIDNV._).getAbsoluteWidth(popupParent) * 0.75;
        const maxHeight = (0, $jIDNV._).getAbsoluteHeight(popupParent) * 0.75;
        const ratio = 0.553;
        const chart = this.chartProxy.getChart();
        let width = this.params.insideDialog ? 850 : chart.width;
        let height = this.params.insideDialog ? 470 : chart.height;
        if (width > maxWidth || height > maxHeight) {
            width = Math.min(width, maxWidth);
            height = Math.round(width * ratio);
            if (height > maxHeight) {
                height = maxHeight;
                width = Math.min(width, Math.round(height / ratio));
            }
        }
        return {
            width: width,
            height: height
        };
    }
    addMenu() {
        if (!this.params.crossFiltering) {
            this.chartMenu = this.createBean(new $5b7ccabde48fae90$var$ChartMenu(this.eChartContainer, this.eMenuContainer, this.chartMenuContext));
            this.eChartContainer.appendChild(this.chartMenu.getGui());
        }
    }
    addTitleEditComp() {
        this.titleEdit = this.createBean(new $5b7ccabde48fae90$var$TitleEdit(this.chartMenu));
        this.eTitleEditContainer.appendChild(this.titleEdit.getGui());
        if (this.chartProxy) this.titleEdit.refreshTitle(this.chartMenuContext);
    }
    update(params) {
        if (params == null ? void 0 : params.chartId) {
            const validUpdate = this.chartController.update(params);
            if (!validUpdate) return;
        }
        const updatedChartType = this.chartTypeChanged(params);
        const persistedThemeOverrides = updatedChartType || this.chartEmpty ? ((updatedChartType2)=>{
            const currentChartType = this.chartType;
            const targetChartType = updatedChartType2;
            const existingChartInstance = this.chartProxy.getChart();
            const existingChartOptions = existingChartInstance == null ? void 0 : existingChartInstance.getOptions();
            const existingAxes = existingChartInstance == null ? void 0 : existingChartInstance.axes;
            return this.chartOptionsService.getPersistedChartThemeOverrides(existingChartOptions, existingAxes, currentChartType, targetChartType != null ? targetChartType : currentChartType);
        })(updatedChartType) : void 0;
        if (updatedChartType) this.createChart();
        const updatedThemeOverrides = persistedThemeOverrides && (params == null ? void 0 : params.chartThemeOverrides) ? $5b7ccabde48fae90$var$deepMerge(persistedThemeOverrides, params.chartThemeOverrides) : persistedThemeOverrides || (params == null ? void 0 : params.chartThemeOverrides);
        this.updateChart(updatedThemeOverrides);
        if (params == null ? void 0 : params.chartId) this.chartProxy.getChart().waitForUpdate().then(()=>{
            this.chartController.raiseChartApiUpdateEvent();
        });
    }
    updateChart(updatedOverrides) {
        const { chartProxy: chartProxy } = this;
        const selectedCols = this.chartController.getSelectedValueColState();
        const data = this.chartController.getChartData();
        const chartEmpty = this.handleEmptyChart(data, selectedCols.length);
        this.chartEmpty = chartEmpty;
        if (chartEmpty) {
            if (updatedOverrides) this.chartController.updateThemeOverrides(updatedOverrides);
            return;
        }
        let chartUpdateParams = this.chartController.getChartUpdateParams(updatedOverrides);
        chartProxy.update(chartUpdateParams);
        this.chartProxy.getChart().waitForUpdate().then(()=>{
            this.chartController.raiseChartUpdatedEvent();
        });
        this.titleEdit.refreshTitle(this.chartMenuContext);
    }
    chartTypeChanged(updateParams) {
        const [currentType, updatedChartType] = [
            this.chartController.getChartType(),
            updateParams == null ? void 0 : updateParams.chartType
        ];
        const targetChartType = updatedChartType ? $5b7ccabde48fae90$var$getCanonicalChartType(updatedChartType) : void 0;
        if (this.chartType !== currentType) return targetChartType != null ? targetChartType : currentType;
        if (targetChartType && currentType !== targetChartType) return targetChartType;
        return null;
    }
    getChartModel() {
        return this.chartController.getChartModel();
    }
    getChartImageDataURL(fileFormat) {
        return this.chartProxy.getChartImageDataURL(fileFormat);
    }
    handleEmptyChart(data, numFields) {
        const pivotModeDisabled = this.chartController.isPivotChart() && !this.chartController.isPivotMode();
        const chartType = this.chartController.getChartType();
        let minFieldsRequired = 1;
        if (this.chartController.isActiveXYChart()) minFieldsRequired = chartType === "bubble" ? 3 : 2;
        else if ($5b7ccabde48fae90$var$isHierarchical($5b7ccabde48fae90$var$getSeriesType(chartType))) minFieldsRequired = 0;
        const isEmptyChart = numFields < minFieldsRequired || data.length === 0;
        if (this.eChart) {
            const isEmpty = pivotModeDisabled || isEmptyChart;
            (0, $jIDNV._).setDisplayed(this.eChart, !isEmpty);
            (0, $jIDNV._).setDisplayed(this.eEmpty, isEmpty);
        }
        if (pivotModeDisabled) {
            this.eEmpty.innerText = this.chartTranslationService.translate("pivotChartRequiresPivotMode");
            return true;
        }
        if (isEmptyChart) {
            this.eEmpty.innerText = this.chartTranslationService.translate("noDataToChart");
            return true;
        }
        return false;
    }
    downloadChart(dimensions, fileName, fileFormat) {
        this.chartProxy.downloadChart(dimensions, fileName, fileFormat);
    }
    openChartToolPanel(panel) {
        const menuPanel = panel ? $5b7ccabde48fae90$var$CHART_TOOL_PANEL_MENU_OPTIONS[panel] : panel;
        this.chartMenu.showMenu({
            panel: menuPanel
        });
    }
    closeChartToolPanel() {
        this.chartMenu.hideMenu();
    }
    getChartId() {
        return this.chartController.getChartId();
    }
    getUnderlyingChart() {
        return this.chartProxy.getChartRef();
    }
    crossFilteringReset() {
        this.chartProxy.crossFilteringReset();
    }
    setActiveChartCellRange(focusEvent) {
        if (this.getGui().contains(focusEvent.relatedTarget)) return;
        this.chartController.setChartRange(true);
        this.focusService.clearFocusedCell();
    }
    getThemeName() {
        const availableChartThemes = this.gos.get("chartThemes") || $5b7ccabde48fae90$var$DEFAULT_THEMES;
        if (availableChartThemes.length === 0) throw new Error("Cannot create chart: no chart themes available.");
        const { chartThemeName: chartThemeName } = this.params;
        return (0, $jIDNV._).includes(availableChartThemes, chartThemeName) ? chartThemeName : availableChartThemes[0];
    }
    getAllKeysInObjects(objects) {
        const allValues = {};
        objects.filter((obj)=>obj != null).forEach((obj)=>{
            Object.keys(obj).forEach((key)=>allValues[key] = null);
        });
        return Object.keys(allValues);
    }
    validateCustomThemes() {
        const suppliedThemes = this.getChartThemes();
        const customChartThemes = this.gos.get("customChartThemes");
        if (customChartThemes) this.getAllKeysInObjects([
            customChartThemes
        ]).forEach((customThemeName)=>{
            if (!(0, $jIDNV._).includes(suppliedThemes, customThemeName)) console.warn("AG Grid: a custom chart theme with the name '" + customThemeName + "' has been supplied but not added to the 'chartThemes' list");
        });
    }
    reactivePropertyUpdate() {
        this.chartController.setChartThemeName(this.getThemeName(), true);
        const chartId = this.getChartId();
        const modelType = this.chartController.isCrossFilterChart() ? "crossFilter" : this.getChartModel().modelType;
        const chartThemeOverrides = this.gos.get("chartThemeOverrides") || {};
        this.update({
            type: `${modelType}ChartUpdate`,
            chartId: chartId,
            chartThemeOverrides: chartThemeOverrides
        });
    }
    raiseChartCreatedEvent() {
        const event = {
            type: (0, $jIDNV.Events).EVENT_CHART_CREATED,
            chartId: this.chartController.getChartId()
        };
        this.chartProxy.getChart().waitForUpdate().then(()=>{
            this.eventService.dispatchEvent(event);
        });
    }
    raiseChartDestroyedEvent() {
        const event = {
            type: (0, $jIDNV.Events).EVENT_CHART_DESTROYED,
            chartId: this.chartController.getChartId()
        };
        this.eventService.dispatchEvent(event);
    }
    destroy() {
        var _a;
        super.destroy();
        if (this.chartProxy) this.chartProxy.destroy();
        this.destroyBean(this.chartMenu);
        this.destroyBean(this.titleEdit);
        if (this.chartDialog && this.chartDialog.isAlive()) this.destroyBean(this.chartDialog);
        (_a = this.onDestroyColorSchemeChangeListener) == null || _a.call(this);
        const eGui = this.getGui();
        (0, $jIDNV._).clearElement(eGui);
        (0, $jIDNV._).removeFromParent(eGui);
        this.raiseChartDestroyedEvent();
    }
};
$5b7ccabde48fae90$var$_GridChartComp.TEMPLATE = /* html */ `<div class="ag-chart" tabindex="-1">
            <div ref="eChartContainer" tabindex="-1" class="ag-chart-components-wrapper">
                <div ref="eChart" class="ag-chart-canvas-wrapper"></div>
                <div ref="eEmpty" class="ag-chart-empty-text ag-unselectable"></div>
            </div>
            <div ref="eTitleEditContainer"></div>
            <div ref="eMenuContainer" class="ag-chart-docked-container" style="min-width: 0px;"></div>
        </div>`;
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.RefSelector)("eChart")
], $5b7ccabde48fae90$var$_GridChartComp.prototype, "eChart", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.RefSelector)("eChartContainer")
], $5b7ccabde48fae90$var$_GridChartComp.prototype, "eChartContainer", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.RefSelector)("eMenuContainer")
], $5b7ccabde48fae90$var$_GridChartComp.prototype, "eMenuContainer", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.RefSelector)("eEmpty")
], $5b7ccabde48fae90$var$_GridChartComp.prototype, "eEmpty", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.RefSelector)("eTitleEditContainer")
], $5b7ccabde48fae90$var$_GridChartComp.prototype, "eTitleEditContainer", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartCrossFilterService")
], $5b7ccabde48fae90$var$_GridChartComp.prototype, "crossFilterService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartTranslationService")
], $5b7ccabde48fae90$var$_GridChartComp.prototype, "chartTranslationService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartMenuService")
], $5b7ccabde48fae90$var$_GridChartComp.prototype, "chartMenuService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("focusService")
], $5b7ccabde48fae90$var$_GridChartComp.prototype, "focusService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("popupService")
], $5b7ccabde48fae90$var$_GridChartComp.prototype, "popupService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_GridChartComp.prototype, "init", 1);
var $5b7ccabde48fae90$var$GridChartComp = $5b7ccabde48fae90$var$_GridChartComp;
var $5b7ccabde48fae90$var$VERSION4 = "31.3.4";
var $5b7ccabde48fae90$var$DEBUG = false;
function $5b7ccabde48fae90$var$upgradeChartModel(model) {
    const originalVersion = model.version;
    if (model.version == null) model.version = $5b7ccabde48fae90$var$heuristicVersionDetection(model);
    model = $5b7ccabde48fae90$var$migrateIfBefore("23.0.0", model, $5b7ccabde48fae90$var$migrateV23);
    model = $5b7ccabde48fae90$var$migrateIfBefore("24.0.0", model, $5b7ccabde48fae90$var$migrateV24);
    model = $5b7ccabde48fae90$var$migrateIfBefore("25.1.0", model, $5b7ccabde48fae90$var$migrateV25_1);
    model = $5b7ccabde48fae90$var$migrateIfBefore("26.0.0", model, $5b7ccabde48fae90$var$migrateV26);
    model = $5b7ccabde48fae90$var$migrateIfBefore("26.1.0", model, $5b7ccabde48fae90$var$migrateV26_1);
    model = $5b7ccabde48fae90$var$migrateIfBefore("26.2.0", model, $5b7ccabde48fae90$var$migrateV26_2);
    model = $5b7ccabde48fae90$var$migrateIfBefore("28.0.0", model, $5b7ccabde48fae90$var$migrateV28);
    model = $5b7ccabde48fae90$var$migrateIfBefore("28.2.0", model, $5b7ccabde48fae90$var$migrateV28_2);
    model = $5b7ccabde48fae90$var$migrateIfBefore("29.0.0", model, $5b7ccabde48fae90$var$migrateV29);
    model = $5b7ccabde48fae90$var$migrateIfBefore("29.1.0", model, $5b7ccabde48fae90$var$migrateV29_1);
    model = $5b7ccabde48fae90$var$migrateIfBefore("29.2.0", model, $5b7ccabde48fae90$var$migrateV29_2);
    model = $5b7ccabde48fae90$var$migrateIfBefore("30.0.0", model, $5b7ccabde48fae90$var$migrateV30);
    model = $5b7ccabde48fae90$var$migrateIfBefore("31.0.0", model, $5b7ccabde48fae90$var$migrateV31);
    model = $5b7ccabde48fae90$var$cleanup(model);
    model = $5b7ccabde48fae90$var$migrateIfBefore($5b7ccabde48fae90$var$VERSION4, model, (m)=>m);
    if ($5b7ccabde48fae90$var$DEBUG && originalVersion !== model.version) console.log("AG Grid: ChartModel migration complete", {
        model: model
    });
    return model;
}
function $5b7ccabde48fae90$var$migrateV23(model) {
    model = $5b7ccabde48fae90$var$jsonRename("chartOptions.legend.item.marker.type", "shape", model);
    model = $5b7ccabde48fae90$var$jsonRename("chartOptions.seriesDefaults.marker.type", "shape", model);
    model = $5b7ccabde48fae90$var$jsonRename("chartOptions.legend.padding", "spacing", model);
    return model;
}
function $5b7ccabde48fae90$var$migrateV24(model) {
    var _d;
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.seriesDefaults.marker.minSize", model);
    const _a = model, { chartType: chartType, chartPalette: chartPalette, chartOptions: _b } = _a, _c = _b, { xAxis: xAxis, yAxis: yAxis } = _c, chartOptions = $5b7ccabde48fae90$var$__objRest(_c, [
        "xAxis",
        "yAxis"
    ]), chartModel = $5b7ccabde48fae90$var$__objRest(_a, [
        "chartType",
        "chartPalette",
        // Migrate.
        "chartOptions"
    ]);
    const axesTypes = $5b7ccabde48fae90$var$getLegacyAxisType(chartType);
    const axes = axesTypes == null ? void 0 : axesTypes.map((type, i)=>$5b7ccabde48fae90$var$__spreadValues3({
            type: type
        }, i === 0 ? xAxis : yAxis));
    const LEGACY_PALETTES = {
        borneo: "ag-default",
        material: "ag-material",
        bright: "ag-vivid"
    };
    return $5b7ccabde48fae90$var$__spreadValues3({
        chartType: chartType,
        chartThemeName: (_d = LEGACY_PALETTES[chartPalette]) != null ? _d : "ag-default",
        chartOptions: $5b7ccabde48fae90$var$__spreadProps3($5b7ccabde48fae90$var$__spreadValues3({}, chartOptions), {
            axes: axes,
            xAxis: xAxis,
            yAxis: yAxis
        })
    }, chartModel);
}
function $5b7ccabde48fae90$var$migrateV25_1(model) {
    model = $5b7ccabde48fae90$var$jsonRename("chartOptions.seriesDefaults.label.minRequiredAngle", "minAngle", model);
    return model;
}
function $5b7ccabde48fae90$var$migrateV26(model) {
    const highlightOptUpdate = (_a)=>{
        var _b = _a, { dimOpacity: dimOpacity } = _b, opts = $5b7ccabde48fae90$var$__objRest(_b, [
            "dimOpacity"
        ]);
        return $5b7ccabde48fae90$var$__spreadValues3($5b7ccabde48fae90$var$__spreadValues3({}, opts), dimOpacity != null ? {
            series: {
                dimOpacity: dimOpacity
            }
        } : {});
    };
    model = $5b7ccabde48fae90$var$jsonMutate("chartOptions.seriesDefaults.highlightStyle", model, highlightOptUpdate);
    model = $5b7ccabde48fae90$var$jsonDelete("chart", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.seriesDefaults.tooltipClass", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.seriesDefaults.tooltipTracking", model);
    model = $5b7ccabde48fae90$var$jsonDeleteDefault("chartOptions.axes[].label.rotation", 0, model);
    model = $5b7ccabde48fae90$var$jsonDeleteDefault("chartOptions.axes[].label.rotation", 335, model);
    return model;
}
function $5b7ccabde48fae90$var$migrateV26_1(model) {
    const highlightOptUpdate = (_a)=>{
        var _b = _a, { item: item, series: series } = _b, opts = $5b7ccabde48fae90$var$__objRest(_b, [
            "item",
            "series"
        ]);
        return $5b7ccabde48fae90$var$__spreadValues3({
            item: $5b7ccabde48fae90$var$__spreadValues3($5b7ccabde48fae90$var$__spreadValues3({}, opts), item)
        }, series ? {
            series: series
        } : {});
    };
    model = $5b7ccabde48fae90$var$jsonMutate("chartOptions.seriesDefaults.highlightStyle", model, highlightOptUpdate);
    model = $5b7ccabde48fae90$var$jsonMutate("chartOptions.series[].highlightStyle", model, highlightOptUpdate);
    return model;
}
function $5b7ccabde48fae90$var$migrateV26_2(model) {
    model = $5b7ccabde48fae90$var$jsonMove("chartOptions.seriesDefaults.fill.opacity", "chartOptions.seriesDefaults.fillOpacity", model);
    model = $5b7ccabde48fae90$var$jsonMove("chartOptions.seriesDefaults.stroke.opacity", "chartOptions.seriesDefaults.strokeOpacity", model);
    model = $5b7ccabde48fae90$var$jsonMove("chartOptions.seriesDefaults.stroke.width", "chartOptions.seriesDefaults.strokeWidth", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.seriesDefaults.fill", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.seriesDefaults.stroke", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.seriesDefaults.callout.colors", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.xAxis", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.yAxis", model);
    const _a = model, { chartType: providedChartType, chartOptions: _b } = _a, _c = _b, { axes: axes, series: series, seriesDefaults: seriesDefaults } = _c, otherChartOptions = $5b7ccabde48fae90$var$__objRest(_c, [
        "axes",
        "series",
        "seriesDefaults"
    ]), otherModelProps = $5b7ccabde48fae90$var$__objRest(_a, [
        "chartType",
        "chartOptions"
    ]);
    const chartType = $5b7ccabde48fae90$var$getCanonicalChartType(providedChartType);
    const seriesType = $5b7ccabde48fae90$var$getSeriesType(chartType);
    const seriesTypes = [
        seriesType
    ];
    const chartTypeMixin = {};
    if (!$5b7ccabde48fae90$var$isPieChartSeries(seriesType)) {
        const minimalAxis = {
            top: {},
            bottom: {},
            left: {},
            right: {}
        };
        const updatedAxes = axes.map((_d)=>{
            var _e = _d, { type: type } = _e, axisProps = $5b7ccabde48fae90$var$__objRest(_e, [
                "type"
            ]);
            return {
                [type]: $5b7ccabde48fae90$var$__spreadValues3($5b7ccabde48fae90$var$__spreadValues3({}, minimalAxis), axisProps)
            };
        }).reduce($5b7ccabde48fae90$var$merge, {});
        $5b7ccabde48fae90$var$ALL_AXIS_TYPES.filter((v)=>updatedAxes[v] == null).forEach((v)=>{
            updatedAxes[v] = $5b7ccabde48fae90$var$__spreadValues3({}, minimalAxis);
        });
        chartTypeMixin.axes = updatedAxes;
    }
    const updatedChartOptions = seriesTypes.map((t)=>({
            [t]: $5b7ccabde48fae90$var$__spreadValues3($5b7ccabde48fae90$var$__spreadProps3($5b7ccabde48fae90$var$__spreadValues3({}, chartTypeMixin), {
                series: seriesDefaults
            }), otherChartOptions)
        })).reduce($5b7ccabde48fae90$var$merge, {});
    model = $5b7ccabde48fae90$var$__spreadProps3($5b7ccabde48fae90$var$__spreadValues3({}, otherModelProps), {
        chartType: chartType,
        chartOptions: updatedChartOptions
    });
    return model;
}
function $5b7ccabde48fae90$var$migrateV28(model) {
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.*.title.padding", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.*.subtitle.padding", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.*.axes.*.title.padding", model);
    model = $5b7ccabde48fae90$var$jsonBackfill("chartOptions.*.axes.*.title.enabled", false, model);
    return model;
}
function $5b7ccabde48fae90$var$migrateV28_2(model) {
    model = $5b7ccabde48fae90$var$jsonRename("chartOptions.pie.series.callout", "calloutLine", model);
    model = $5b7ccabde48fae90$var$jsonRename("chartOptions.pie.series.label", "calloutLabel", model);
    model = $5b7ccabde48fae90$var$jsonRename("chartOptions.pie.series.labelKey", "sectorLabelKey", model);
    model = $5b7ccabde48fae90$var$jsonRename("chartOptions.pie.series.labelName", "sectorLabelName", model);
    model = $5b7ccabde48fae90$var$jsonRename("chartOptions.donut.series.callout", "calloutLine", model);
    model = $5b7ccabde48fae90$var$jsonRename("chartOptions.donut.series.label", "calloutLabel", model);
    model = $5b7ccabde48fae90$var$jsonRename("chartOptions.donut.series.labelKey", "sectorLabelKey", model);
    model = $5b7ccabde48fae90$var$jsonRename("chartOptions.donut.series.labelName", "sectorLabelName", model);
    return model;
}
function $5b7ccabde48fae90$var$migrateV29(model) {
    model = $5b7ccabde48fae90$var$jsonMoveIfMissing("chartOptions.scatter.series.fill", "chartOptions.scatter.series.marker.fill", model);
    model = $5b7ccabde48fae90$var$jsonMoveIfMissing("chartOptions.scatter.series.fillOpacity", "chartOptions.scatter.series.marker.fillOpacity", model);
    model = $5b7ccabde48fae90$var$jsonMoveIfMissing("chartOptions.scatter.series.stroke", "chartOptions.scatter.series.marker.stroke", model);
    model = $5b7ccabde48fae90$var$jsonMoveIfMissing("chartOptions.scatter.series.strokeOpacity", "chartOptions.scatter.series.marker.strokeOpacity", model);
    model = $5b7ccabde48fae90$var$jsonMoveIfMissing("chartOptions.scatter.series.strokeWidth", "chartOptions.scatter.series.marker.strokeWidth", model);
    model = $5b7ccabde48fae90$var$jsonMove("chartOptions.scatter.series.paired", "chartOptions.scatter.paired", model);
    return model;
}
function $5b7ccabde48fae90$var$migrateV29_1(model) {
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.axes[].tick.count", model);
    return model;
}
function $5b7ccabde48fae90$var$migrateV29_2(model) {
    const tooltipOptUpdate = (_a)=>{
        var _b = _a, { tracking: tracking } = _b, opts = $5b7ccabde48fae90$var$__objRest(_b, [
            "tracking"
        ]);
        var _a2, _b2, _c, _d;
        const output = $5b7ccabde48fae90$var$__spreadValues3({}, opts);
        if (tracking === false) {
            (_a2 = output.position) != null ? _a2 : output.position = {
                type: "pointer"
            };
            (_b2 = output.range) != null ? _b2 : output.range = "nearest";
        } else if (tracking === true) {
            (_c = output.position) != null ? _c : output.position = {
                type: "node"
            };
            (_d = output.range) != null ? _d : output.range = "nearest";
        }
        return output;
    };
    model = $5b7ccabde48fae90$var$jsonMutate("chartOptions.*.tooltip", model, tooltipOptUpdate);
    return model;
}
function $5b7ccabde48fae90$var$migrateV30(model) {
    model = $5b7ccabde48fae90$var$jsonRename("chartOptions.pie.series.labelKey", "sectorLabelKey", model);
    model = $5b7ccabde48fae90$var$jsonRename("chartOptions.pie.series.labelName", "sectorLabelName", model);
    model = $5b7ccabde48fae90$var$migrateV29_1(model);
    model = $5b7ccabde48fae90$var$migrateV29_2(model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.*.series.flipXY", model);
    model = $5b7ccabde48fae90$var$jsonAdd("chartOptions.common.legend.enabled", true, model);
    model = $5b7ccabde48fae90$var$jsonBackfill("chartOptions.common.legend.position", "right", model);
    return model;
}
function $5b7ccabde48fae90$var$migrateV31(model) {
    const V30_LEGACY_PALETTES = {
        "ag-pastel": "ag-sheets",
        "ag-solar": "ag-polychroma"
    };
    const updatedModel = $5b7ccabde48fae90$var$jsonRename("chartOptions.column", "bar", model);
    const chartThemeName = V30_LEGACY_PALETTES[updatedModel.chartThemeName] || updatedModel.chartThemeName;
    return $5b7ccabde48fae90$var$__spreadProps3($5b7ccabde48fae90$var$__spreadValues3({}, updatedModel), {
        chartThemeName: chartThemeName
    });
}
function $5b7ccabde48fae90$var$cleanup(model) {
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.*.width", model);
    model = $5b7ccabde48fae90$var$jsonDelete("chartOptions.*.height", model);
    model = $5b7ccabde48fae90$var$jsonBackfill("chartOptions.*.axes.category.label.autoRotate", true, model);
    return model;
}
function $5b7ccabde48fae90$var$heuristicVersionDetection(model) {
    var _a, _b;
    const modelAny = model;
    if (model.version != null) return model.version;
    const hasKey = (obj, ...keys)=>{
        return Object.keys(obj || {}).some((k)=>keys.includes(k));
    };
    const chartOptions = modelAny.chartOptions;
    const seriesOptions = hasKey(chartOptions, "seriesDefaults") ? chartOptions == null ? void 0 : chartOptions.seriesDefaults : chartOptions == null ? void 0 : chartOptions[Object.keys(chartOptions)[0]];
    const hints = {
        "27.0.0": hasKey(modelAny, "seriesChartTypes"),
        "26.2.0": !hasKey(chartOptions, "seriesDefaults"),
        "26.1.0": hasKey(seriesOptions == null ? void 0 : seriesOptions.highlightStyle, "item"),
        "26.0.0": hasKey(seriesOptions == null ? void 0 : seriesOptions.highlightStyle, "series"),
        // '26.0.0': modelAny.chart === undefined,
        "25.1.0": hasKey(seriesOptions == null ? void 0 : seriesOptions.label, "minAngle"),
        "25.0.0": hasKey(modelAny, "modelType", "aggFunc", "unlinkChart", "suppressChartRanges") || hasKey(seriesOptions, "lineDash", "lineDashOffset"),
        "24.0.0": hasKey(modelAny, "chartThemeName", "chart") || hasKey(chartOptions, "series"),
        "23.2.0": hasKey(chartOptions, "navigator"),
        "23.0.0": hasKey((_b = (_a = chartOptions == null ? void 0 : chartOptions.legend) == null ? void 0 : _a.item) == null ? void 0 : _b.marker, "shape"),
        "22.1.0": hasKey(modelAny, "chartPalette", "chartType")
    };
    const defaultVersion = "27.1.0";
    const matchingHints = Object.entries(hints).filter(([_382, match])=>match);
    if ($5b7ccabde48fae90$var$DEBUG) console.log("AG Grid: ChartModel migration", {
        heuristicVersionCandidates: matchingHints
    });
    const [heuristicVersion = defaultVersion] = matchingHints[0];
    if ($5b7ccabde48fae90$var$DEBUG) console.log("AG Grid: ChartModel migration", {
        heuristicVersion: heuristicVersion
    });
    return heuristicVersion;
}
function $5b7ccabde48fae90$var$migrateIfBefore(maxVersion, model, migration) {
    if ($5b7ccabde48fae90$var$versionNumber(maxVersion) > $5b7ccabde48fae90$var$versionNumber(model.version)) {
        if ($5b7ccabde48fae90$var$DEBUG) console.log("AG Grid: ChartModel migration", {
            migratingTo: maxVersion
        });
        const result = migration(model);
        result.version = maxVersion;
        if ($5b7ccabde48fae90$var$DEBUG) console.log("AG Grid: ChartModel migration", {
            migratedTo: maxVersion,
            result: result
        });
        return result;
    }
    return model;
}
function $5b7ccabde48fae90$var$versionParts(version) {
    const split = typeof version === "string" ? version.split(".").map((v)=>Number(v)) : [];
    if (split.length !== 3 || split.some((v)=>isNaN(v))) throw new Error("AG Grid - Illegal version string: " + version);
    return {
        major: split[0],
        minor: split[1],
        patch: split[2]
    };
}
function $5b7ccabde48fae90$var$versionNumber(version) {
    const { major: major, minor: minor, patch: patch } = $5b7ccabde48fae90$var$versionParts(version);
    return major * 1e4 + minor * 100 + patch;
}
function $5b7ccabde48fae90$var$jsonDeleteDefault(path, defaultValue, json) {
    return $5b7ccabde48fae90$var$jsonMutateProperty(path, true, json, (parent, prop)=>{
        if (parent[prop] === defaultValue) delete parent[prop];
    });
}
function $5b7ccabde48fae90$var$jsonBackfill(path, defaultValue, json) {
    return $5b7ccabde48fae90$var$jsonMutateProperty(path, false, json, (parent, prop)=>{
        if (parent[prop] == null) parent[prop] = defaultValue;
    });
}
function $5b7ccabde48fae90$var$jsonAdd(path, value, json) {
    var _a;
    if (typeof path === "string") path = path.split(".");
    const nextPath = path[0];
    if (path.length > 1) json[nextPath] = $5b7ccabde48fae90$var$jsonAdd(path.slice(1), value, (_a = json[nextPath]) != null ? _a : {});
    const hasProperty = Object.keys(json).includes(nextPath);
    if (!hasProperty) json[nextPath] = value;
    return json;
}
function $5b7ccabde48fae90$var$jsonMove(from, to, json) {
    let valueToMove = void 0;
    let valueFound = false;
    json = $5b7ccabde48fae90$var$jsonMutateProperty(from, true, json, (parent, prop)=>{
        valueFound = true;
        valueToMove = parent[prop];
        delete parent[prop];
    });
    if (!valueFound) return json;
    return $5b7ccabde48fae90$var$jsonMutateProperty(to, false, json, (parent, prop)=>{
        parent[prop] = valueToMove;
    });
}
function $5b7ccabde48fae90$var$jsonMoveIfMissing(from, to, json) {
    let valueToMove = void 0;
    let valueFound = false;
    json = $5b7ccabde48fae90$var$jsonMutateProperty(from, true, json, (parent, prop)=>{
        valueFound = true;
        valueToMove = parent[prop];
        delete parent[prop];
    });
    if (!valueFound) return json;
    return $5b7ccabde48fae90$var$jsonMutateProperty(to, false, json, (parent, prop)=>{
        if (parent[prop] === void 0) parent[prop] = valueToMove;
    });
}
function $5b7ccabde48fae90$var$jsonRename(path, renameTo, json) {
    return $5b7ccabde48fae90$var$jsonMutateProperty(path, true, json, (parent, prop)=>{
        parent[renameTo] = parent[prop];
        delete parent[prop];
    });
}
function $5b7ccabde48fae90$var$jsonDelete(path, json) {
    return $5b7ccabde48fae90$var$jsonMutateProperty(path, true, json, (parent, prop)=>delete parent[prop]);
}
function $5b7ccabde48fae90$var$jsonMutateProperty(path, skipMissing, json, mutator) {
    const pathElements = path instanceof Array ? path : path.split(".");
    const parentPathElements = pathElements.slice(0, pathElements.length - 1);
    const targetName = pathElements[pathElements.length - 1];
    return $5b7ccabde48fae90$var$jsonMutate(parentPathElements, json, (parent)=>{
        const hasProperty = Object.keys(parent).includes(targetName);
        if (skipMissing && !hasProperty) return parent;
        const result = $5b7ccabde48fae90$var$__spreadValues3({}, parent);
        mutator(result, targetName);
        return result;
    });
}
function $5b7ccabde48fae90$var$jsonMutate(path, json, mutator) {
    const pathElements = path instanceof Array ? path : path.split(".");
    json = $5b7ccabde48fae90$var$__spreadValues3({}, json);
    if (pathElements.length === 0) return mutator(json);
    else if (pathElements[0].startsWith("{")) {
        const pathOptions = pathElements[0].substring(1, pathElements[0].lastIndexOf("}")).split(",");
        for (const pathOption of pathOptions)if (json[pathOption] != null) json[pathOption] = $5b7ccabde48fae90$var$jsonMutate(pathElements.slice(1), json[pathOption], mutator);
    } else if (pathElements[0].endsWith("[]")) {
        const arrayName = pathElements[0].substring(0, path[0].indexOf("["));
        if (json[arrayName] instanceof Array) json[arrayName] = json[arrayName].map((v)=>$5b7ccabde48fae90$var$jsonMutate(pathElements.slice(1), v, mutator));
    } else if (pathElements[0] === "*") for(const jsonProp in json)json[jsonProp] = $5b7ccabde48fae90$var$jsonMutate(pathElements.slice(1), json[jsonProp], mutator);
    else if (json[pathElements[0]] != null) json[pathElements[0]] = $5b7ccabde48fae90$var$jsonMutate(pathElements.slice(1), json[pathElements[0]], mutator);
    return json;
}
var $5b7ccabde48fae90$var$merge = (r, n)=>$5b7ccabde48fae90$var$__spreadValues3($5b7ccabde48fae90$var$__spreadValues3({}, r), n);
var $5b7ccabde48fae90$var$ChartService = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.activeCharts = /* @__PURE__ */ new Set();
        this.activeChartComps = /* @__PURE__ */ new Set();
        this.crossFilteringContext = {
            lastSelectedChartId: ""
        };
        this.isEnterprise = ()=>(0, $iTJTu._ModuleSupport).enterpriseModule.isEnterprise;
    }
    updateChart(params) {
        if (this.activeChartComps.size === 0) {
            console.warn(`AG Grid - No active charts to update.`);
            return;
        }
        const chartComp = [
            ...this.activeChartComps
        ].find((chartComp2)=>chartComp2.getChartId() === params.chartId);
        if (!chartComp) {
            console.warn(`AG Grid - Unable to update chart. No active chart found with ID: ${params.chartId}.`);
            return;
        }
        chartComp.update(params);
    }
    getChartModels() {
        const models = [];
        const versionedModel = (c)=>{
            return $5b7ccabde48fae90$var$__spreadProps3($5b7ccabde48fae90$var$__spreadValues3({}, c), {
                version: $5b7ccabde48fae90$var$VERSION4
            });
        };
        this.activeChartComps.forEach((c)=>models.push(versionedModel(c.getChartModel())));
        return models;
    }
    getChartRef(chartId) {
        let chartRef;
        this.activeCharts.forEach((cr)=>{
            if (cr.chartId === chartId) chartRef = cr;
        });
        return chartRef;
    }
    getChartComp(chartId) {
        let chartComp;
        this.activeChartComps.forEach((comp)=>{
            if (comp.getChartId() === chartId) chartComp = comp;
        });
        return chartComp;
    }
    getChartImageDataURL(params) {
        let url;
        this.activeChartComps.forEach((c)=>{
            if (c.getChartId() === params.chartId) url = c.getChartImageDataURL(params.fileFormat);
        });
        return url;
    }
    downloadChart(params) {
        const chartComp = Array.from(this.activeChartComps).find((c)=>c.getChartId() === params.chartId);
        chartComp == null || chartComp.downloadChart(params.dimensions, params.fileName, params.fileFormat);
    }
    openChartToolPanel(params) {
        const chartComp = Array.from(this.activeChartComps).find((c)=>c.getChartId() === params.chartId);
        chartComp == null || chartComp.openChartToolPanel(params.panel);
    }
    closeChartToolPanel(chartId) {
        const chartComp = Array.from(this.activeChartComps).find((c)=>c.getChartId() === chartId);
        chartComp == null || chartComp.closeChartToolPanel();
    }
    createChartFromCurrentRange(chartType = "groupedColumn") {
        const cellRange = this.getSelectedRange();
        return this.createChart({
            cellRange: cellRange,
            chartType: chartType
        });
    }
    restoreChart(model, chartContainer) {
        if (!model) {
            console.warn("AG Grid - unable to restore chart as no chart model is provided");
            return;
        }
        if (model.version !== $5b7ccabde48fae90$var$VERSION4) model = $5b7ccabde48fae90$var$upgradeChartModel(model);
        let cellRange;
        let pivotChart;
        let suppressChartRanges;
        let chartPaletteToRestore;
        if (model.modelType === "pivot") {
            this.gos.updateGridOptions({
                options: {
                    pivotMode: true
                },
                source: "pivotChart"
            });
            cellRange = this.createCellRange(void 0, true);
            pivotChart = true;
            suppressChartRanges = true;
        } else {
            cellRange = this.createCellRange(model.cellRange);
            chartPaletteToRestore = model.chartPalette;
        }
        if (!cellRange) return;
        return this.createChart($5b7ccabde48fae90$var$__spreadProps3($5b7ccabde48fae90$var$__spreadValues3({}, model), {
            cellRange: cellRange,
            pivotChart: pivotChart,
            suppressChartRanges: suppressChartRanges,
            chartContainer: chartContainer,
            chartOptionsToRestore: model.chartOptions,
            chartPaletteToRestore: chartPaletteToRestore
        }));
    }
    createRangeChart(params) {
        const cellRange = this.createCellRange(params.cellRange);
        if (!cellRange) return;
        return this.createChart($5b7ccabde48fae90$var$__spreadProps3($5b7ccabde48fae90$var$__spreadValues3({}, params), {
            cellRange: cellRange
        }));
    }
    createPivotChart(params) {
        this.gos.updateGridOptions({
            options: {
                pivotMode: true
            },
            source: "pivotChart"
        });
        const cellRange = this.createCellRange(void 0, true);
        if (!cellRange) return;
        return this.createChart($5b7ccabde48fae90$var$__spreadProps3($5b7ccabde48fae90$var$__spreadValues3({}, params), {
            cellRange: cellRange,
            pivotChart: true,
            suppressChartRanges: true
        }));
    }
    createCrossFilterChart(params) {
        const cellRange = this.createCellRange(params.cellRange);
        if (!cellRange) return;
        const suppressChartRangesSupplied = typeof params.suppressChartRanges !== "undefined" && params.suppressChartRanges !== null;
        const suppressChartRanges = suppressChartRangesSupplied ? params.suppressChartRanges : true;
        return this.createChart($5b7ccabde48fae90$var$__spreadProps3($5b7ccabde48fae90$var$__spreadValues3({}, params), {
            cellRange: cellRange,
            suppressChartRanges: suppressChartRanges,
            crossFiltering: true
        }));
    }
    createChart(params) {
        const validationResult = $5b7ccabde48fae90$var$ChartParamsValidator.validateCreateParams(params);
        if (!validationResult) return void 0;
        params = validationResult === true ? params : validationResult;
        const { chartType: chartType, chartContainer: chartContainer } = params;
        const createChartContainerFunc = this.gos.getCallback("createChartContainer");
        const gridChartParams = $5b7ccabde48fae90$var$__spreadProps3($5b7ccabde48fae90$var$__spreadValues3({}, params), {
            chartId: this.generateId(),
            chartType: $5b7ccabde48fae90$var$getCanonicalChartType(chartType),
            insideDialog: !(chartContainer || createChartContainerFunc),
            crossFilteringContext: this.crossFilteringContext,
            crossFilteringResetCallback: ()=>this.activeChartComps.forEach((c)=>c.crossFilteringReset())
        });
        const chartComp = new $5b7ccabde48fae90$var$GridChartComp(gridChartParams);
        this.context.createBean(chartComp);
        const chartRef = this.createChartRef(chartComp);
        if (chartContainer) {
            chartContainer.appendChild(chartComp.getGui());
            const theme = this.environment.getTheme();
            if (theme.el && !theme.el.contains(chartContainer)) chartContainer.classList.add(theme.theme);
        } else if (createChartContainerFunc) createChartContainerFunc(chartRef);
        else chartComp.addEventListener($5b7ccabde48fae90$var$GridChartComp.EVENT_DESTROYED, ()=>{
            this.activeChartComps.delete(chartComp);
            this.activeCharts.delete(chartRef);
        });
        return chartRef;
    }
    createChartRef(chartComp) {
        const chartRef = {
            destroyChart: ()=>{
                if (this.activeCharts.has(chartRef)) {
                    this.context.destroyBean(chartComp);
                    this.activeChartComps.delete(chartComp);
                    this.activeCharts.delete(chartRef);
                }
            },
            chartElement: chartComp.getGui(),
            chart: chartComp.getUnderlyingChart(),
            chartId: chartComp.getChartModel().chartId
        };
        this.activeCharts.add(chartRef);
        this.activeChartComps.add(chartComp);
        return chartRef;
    }
    getSelectedRange() {
        var _a, _b;
        const ranges = (_b = (_a = this.rangeService) == null ? void 0 : _a.getCellRanges()) != null ? _b : [];
        return ranges.length > 0 ? ranges[0] : {
            columns: []
        };
    }
    generateId() {
        return `id-${Math.random().toString(36).substring(2, 18)}`;
    }
    createCellRange(cellRangeParams, allRange) {
        var _a;
        const rangeParams = allRange ? {
            rowStartIndex: null,
            rowStartPinned: void 0,
            rowEndIndex: null,
            rowEndPinned: void 0,
            columns: this.columnModel.getAllDisplayedColumns().map((col)=>col.getColId())
        } : cellRangeParams;
        const cellRange = rangeParams && ((_a = this.rangeService) == null ? void 0 : _a.createPartialCellRangeFromRangeParams(rangeParams, true));
        if (!cellRange) console.warn(`AG Grid - unable to create chart as ${allRange ? "there are no columns in the grid" : "no range is selected"}.`);
        return cellRange;
    }
    destroyAllActiveCharts() {
        this.activeCharts.forEach((chart)=>chart.destroyChart());
    }
};
$5b7ccabde48fae90$var$ChartService.CHARTS_VERSION = (0, $iTJTu.VERSION);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$ChartService.prototype, "columnModel", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Optional)("rangeService")
], $5b7ccabde48fae90$var$ChartService.prototype, "rangeService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PreDestroy)
], $5b7ccabde48fae90$var$ChartService.prototype, "destroyAllActiveCharts", 1);
$5b7ccabde48fae90$var$ChartService = $5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Bean)("chartService")
], $5b7ccabde48fae90$var$ChartService);
var $5b7ccabde48fae90$var$ChartTranslationService = class extends (0, $jIDNV.BeanStub) {
    translate(toTranslate) {
        const translate = this.localeService.getLocaleTextFunc();
        const defaultTranslation = $5b7ccabde48fae90$var$ChartTranslationService.DEFAULT_TRANSLATIONS[toTranslate];
        return translate(toTranslate, defaultTranslation);
    }
};
$5b7ccabde48fae90$var$ChartTranslationService.DEFAULT_TRANSLATIONS = {
    pivotChartTitle: "Pivot Chart",
    rangeChartTitle: "Range Chart",
    settings: "Chart",
    data: "Data",
    format: "Format",
    categories: "Categories",
    defaultCategory: "(None)",
    series: "Series",
    switchCategorySeries: "Switch Category / Series",
    categoryValues: "Category Values",
    seriesLabels: "Series Labels",
    aggregate: "Aggregate",
    xyValues: "X Y Values",
    paired: "Paired Mode",
    axis: "Axis",
    xAxis: "Horizontal Axis",
    yAxis: "Vertical Axis",
    polarAxis: "Polar Axis",
    radiusAxis: "Radius Axis",
    navigator: "Navigator",
    zoom: "Zoom",
    animation: "Animation",
    crosshair: "Crosshair",
    color: "Color",
    thickness: "Thickness",
    preferredLength: "Preferred Length",
    xType: "X Type",
    axisType: "Axis Type",
    automatic: "Automatic",
    category: "Category",
    number: "Number",
    time: "Time",
    timeFormat: "Time Format",
    autoRotate: "Auto Rotate",
    labelRotation: "Rotation",
    circle: "Circle",
    orientation: "Orientation",
    polygon: "Polygon",
    fixed: "Fixed",
    parallel: "Parallel",
    perpendicular: "Perpendicular",
    radiusAxisPosition: "Position",
    ticks: "Ticks",
    gridLines: "Grid Lines",
    width: "Width",
    height: "Height",
    length: "Length",
    padding: "Padding",
    spacing: "Spacing",
    chart: "Chart",
    title: "Title",
    titlePlaceholder: "Chart title - double click to edit",
    background: "Background",
    font: "Font",
    top: "Top",
    right: "Right",
    bottom: "Bottom",
    left: "Left",
    labels: "Labels",
    calloutLabels: "Callout Labels",
    sectorLabels: "Sector Labels",
    positionRatio: "Position Ratio",
    size: "Size",
    shape: "Shape",
    minSize: "Minimum Size",
    maxSize: "Maximum Size",
    legend: "Legend",
    position: "Position",
    markerSize: "Marker Size",
    markerStroke: "Marker Stroke",
    markerPadding: "Marker Padding",
    itemSpacing: "Item Spacing",
    itemPaddingX: "Item Padding X",
    itemPaddingY: "Item Padding Y",
    layoutHorizontalSpacing: "Horizontal Spacing",
    layoutVerticalSpacing: "Vertical Spacing",
    strokeWidth: "Stroke Width",
    offset: "Offset",
    offsets: "Offsets",
    tooltips: "Tooltips",
    callout: "Callout",
    markers: "Markers",
    shadow: "Shadow",
    blur: "Blur",
    xOffset: "X Offset",
    yOffset: "Y Offset",
    lineWidth: "Line Width",
    lineDash: "Line Dash",
    lineDashOffset: "Dash Offset",
    scrollingZoom: "Scrolling",
    scrollingStep: "Scrolling Step",
    selectingZoom: "Selecting",
    durationMillis: "Duration (ms)",
    crosshairLabel: "Label",
    crosshairSnap: "Snap to Node",
    normal: "Normal",
    bold: "Bold",
    italic: "Italic",
    boldItalic: "Bold Italic",
    predefined: "Predefined",
    fillOpacity: "Fill Opacity",
    strokeColor: "Line Color",
    strokeOpacity: "Line Opacity",
    miniChart: "Mini-Chart",
    histogramBinCount: "Bin count",
    connectorLine: "Connector Line",
    seriesItems: "Series Items",
    seriesItemType: "Item Type",
    seriesItemPositive: "Positive",
    seriesItemNegative: "Negative",
    seriesItemLabels: "Item Labels",
    columnGroup: "Column",
    barGroup: "Bar",
    pieGroup: "Pie",
    lineGroup: "Line",
    scatterGroup: "X Y (Scatter)",
    areaGroup: "Area",
    polarGroup: "Polar",
    statisticalGroup: "Statistical",
    hierarchicalGroup: "Hierarchical",
    specializedGroup: "Specialized",
    combinationGroup: "Combination",
    groupedColumnTooltip: "Grouped",
    stackedColumnTooltip: "Stacked",
    normalizedColumnTooltip: "100% Stacked",
    groupedBarTooltip: "Grouped",
    stackedBarTooltip: "Stacked",
    normalizedBarTooltip: "100% Stacked",
    pieTooltip: "Pie",
    donutTooltip: "Donut",
    lineTooltip: "Line",
    groupedAreaTooltip: "Area",
    stackedAreaTooltip: "Stacked",
    normalizedAreaTooltip: "100% Stacked",
    scatterTooltip: "Scatter",
    bubbleTooltip: "Bubble",
    histogramTooltip: "Histogram",
    radialColumnTooltip: "Radial Column",
    radialBarTooltip: "Radial Bar",
    radarLineTooltip: "Radar Line",
    radarAreaTooltip: "Radar Area",
    nightingaleTooltip: "Nightingale",
    rangeBarTooltip: "Range Bar",
    rangeAreaTooltip: "Range Area",
    boxPlotTooltip: "Box Plot",
    treemapTooltip: "Treemap",
    sunburstTooltip: "Sunburst",
    heatmapTooltip: "Heatmap",
    waterfallTooltip: "Waterfall",
    columnLineComboTooltip: "Column & Line",
    areaColumnComboTooltip: "Area & Column",
    customComboTooltip: "Custom Combination",
    innerRadius: "Inner Radius",
    startAngle: "Start Angle",
    endAngle: "End Angle",
    reverseDirection: "Reverse Direction",
    groupPadding: "Group Padding",
    seriesPadding: "Series Padding",
    group: "Group",
    tile: "Tile",
    whisker: "Whisker",
    cap: "Cap",
    capLengthRatio: "Length Ratio",
    labelPlacement: "Placement",
    inside: "Inside",
    outside: "Outside",
    noDataToChart: "No data available to be charted.",
    pivotChartRequiresPivotMode: "Pivot Chart requires Pivot Mode enabled.",
    chartSettingsToolbarTooltip: "Menu",
    chartLinkToolbarTooltip: "Linked to Grid",
    chartUnlinkToolbarTooltip: "Unlinked from Grid",
    chartDownloadToolbarTooltip: "Download Chart",
    chartMenuToolbarTooltip: "Menu",
    chartEdit: "Edit Chart",
    chartAdvancedSettings: "Advanced Settings",
    chartLink: "Link to Grid",
    chartUnlink: "Unlink from Grid",
    chartDownload: "Download Chart",
    histogramFrequency: "Frequency",
    seriesChartType: "Series Chart Type",
    seriesType: "Series Type",
    secondaryAxis: "Secondary Axis",
    seriesAdd: "Add a series",
    categoryAdd: "Add a category",
    area: "Area",
    bar: "Bar",
    column: "Column",
    line: "Line",
    scatter: "Scatter",
    histogram: "Histogram",
    radialColumn: "Radial Column",
    radialBar: "Radial Bar",
    radarLine: "Radar Line",
    radarArea: "Radar Area",
    nightingale: "Nightingale",
    rangeBar: "Range Bar",
    rangeArea: "Range Area",
    treemap: "Treemap",
    sunburst: "Sunburst",
    waterfall: "Waterfall",
    boxPlot: "Box Plot",
    pie: "Pie",
    donut: "Donut",
    stackedArea: "StackedArea",
    groupedColumn: "Grouped Column",
    stackedColumn: "Stacked Column",
    advancedSettings: "Advanced Settings",
    ariaChartMenuClose: "Close Chart Edit Menu",
    timeFormatSlashesDDMMYYYY: "DD/MM/YYYY",
    timeFormatSlashesMMDDYYYY: "MM/DD/YYYY",
    timeFormatSlashesDDMMYY: "DD/MM/YY",
    timeFormatSlashesMMDDYY: "MM/DD/YY",
    timeFormatDotsDDMYY: "DD.M.YY",
    timeFormatDotsMDDYY: "M.DD.YY",
    timeFormatDashesYYYYMMDD: "YYYY-MM-DD",
    timeFormatSpacesDDMMMMYYYY: "DD MMMM YYYY",
    timeFormatHHMMSS: "HH:MM:SS",
    timeFormatHHMMSSAmPm: "HH:MM:SS AM/PM",
    sum: "Sum",
    first: "First",
    last: "Last",
    min: "Min",
    max: "Max",
    count: "Count",
    avg: "Average",
    direction: "Direction",
    horizontal: "Horizontal",
    vertical: "Vertical",
    seriesGroupType: "Group Type",
    groupedSeriesGroupType: "Grouped",
    stackedSeriesGroupType: "Stacked",
    normalizedSeriesGroupType: "100% Stacked"
};
$5b7ccabde48fae90$var$ChartTranslationService = $5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Bean)("chartTranslationService")
], $5b7ccabde48fae90$var$ChartTranslationService);
var $5b7ccabde48fae90$var$ChartCrossFilterService = class extends (0, $jIDNV.BeanStub) {
    filter(event, reset = false) {
        const filterModel = this.gridApi.getFilterModel();
        if (reset) {
            this.resetFilters(filterModel);
            return;
        }
        let colId = $5b7ccabde48fae90$var$ChartCrossFilterService.extractFilterColId(event);
        if (this.isValidColumnFilter(colId)) this.updateFilters(filterModel, event, colId);
        else console.warn("AG Grid: cross filtering requires a 'agSetColumnFilter' or 'agMultiColumnFilter' to be defined on the column with id: '" + colId + "'");
    }
    resetFilters(filterModel) {
        const filtersExist = Object.keys(filterModel).length > 0;
        if (filtersExist) {
            this.gridApi.setFilterModel(null);
            this.gridApi.onFilterChanged();
        }
    }
    updateFilters(filterModel, event, colId) {
        let dataKey = $5b7ccabde48fae90$var$ChartCrossFilterService.extractFilterColId(event);
        let rawValue = event.datum[dataKey];
        if (rawValue === void 0) return;
        let selectedValue = rawValue.toString();
        if (event.event.metaKey || event.event.ctrlKey) {
            const existingGridValues = this.getCurrentGridValuesForCategory(colId);
            const valueAlreadyExists = (0, $jIDNV._).includes(existingGridValues, selectedValue);
            let updatedValues;
            if (valueAlreadyExists) updatedValues = existingGridValues.filter((v)=>v !== selectedValue);
            else {
                updatedValues = existingGridValues;
                updatedValues.push(selectedValue);
            }
            filterModel[colId] = this.getUpdatedFilterModel(colId, updatedValues);
        } else {
            const updatedValues = [
                selectedValue
            ];
            filterModel = {
                [colId]: this.getUpdatedFilterModel(colId, updatedValues)
            };
        }
        this.gridApi.setFilterModel(filterModel);
    }
    getUpdatedFilterModel(colId, updatedValues) {
        let columnFilterType = this.getColumnFilterType(colId);
        if (columnFilterType === "agMultiColumnFilter") return {
            filterType: "multi",
            filterModels: [
                null,
                {
                    filterType: "set",
                    values: updatedValues
                }
            ]
        };
        return {
            filterType: "set",
            values: updatedValues
        };
    }
    getCurrentGridValuesForCategory(colId) {
        let filteredValues = [];
        const column = this.getColumnById(colId);
        this.gridApi.forEachNodeAfterFilter((rowNode)=>{
            if (column && !rowNode.group) {
                const value = this.valueService.getValue(column, rowNode) + "";
                if (!filteredValues.includes(value)) filteredValues.push(value);
            }
        });
        return filteredValues;
    }
    static extractFilterColId(event) {
        return event.xKey || event.calloutLabelKey;
    }
    isValidColumnFilter(colId) {
        if (colId.indexOf("-filtered-out")) colId = colId.replace("-filtered-out", "");
        let filterType = this.getColumnFilterType(colId);
        if (typeof filterType === "boolean") return filterType;
        return (0, $jIDNV._).includes([
            "agSetColumnFilter",
            "agMultiColumnFilter"
        ], filterType);
    }
    getColumnFilterType(colId) {
        let gridColumn = this.getColumnById(colId);
        if (gridColumn) {
            const colDef = gridColumn.getColDef();
            return colDef.filter;
        }
    }
    getColumnById(colId) {
        return this.columnModel.getGridColumn(colId);
    }
};
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("gridApi")
], $5b7ccabde48fae90$var$ChartCrossFilterService.prototype, "gridApi", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$ChartCrossFilterService.prototype, "columnModel", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("valueService")
], $5b7ccabde48fae90$var$ChartCrossFilterService.prototype, "valueService", 2);
$5b7ccabde48fae90$var$ChartCrossFilterService = $5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Bean)("chartCrossFilterService")
], $5b7ccabde48fae90$var$ChartCrossFilterService);
var $5b7ccabde48fae90$var$VERSION_CHECKING_FIRST_GRID_MAJOR_VERSION = 28;
var $5b7ccabde48fae90$var$VERSION_CHECKING_FIRST_CHARTS_MAJOR_VERSION = 6;
function $5b7ccabde48fae90$var$isValidVersion(version) {
    return version && version.match(/\d+\.\d+\.\d+/);
}
function $5b7ccabde48fae90$var$isValidMajorVersion({ gridMajorVersion: gridMajorVersion, chartsMajorVersion: chartsMajorVersion }) {
    const gridMajor = parseInt(gridMajorVersion, 10);
    const chartsMajor = parseInt(chartsMajorVersion, 10);
    const gridMajorDifference = gridMajor - $5b7ccabde48fae90$var$VERSION_CHECKING_FIRST_GRID_MAJOR_VERSION;
    const chartsMajorDifference = chartsMajor - $5b7ccabde48fae90$var$VERSION_CHECKING_FIRST_CHARTS_MAJOR_VERSION;
    const isFirstOrAfterVersion = gridMajorDifference >= 0;
    return gridMajorDifference === chartsMajorDifference && isFirstOrAfterVersion;
}
function $5b7ccabde48fae90$var$gridChartVersion(gridVersion) {
    if (!gridVersion || !$5b7ccabde48fae90$var$isValidVersion(gridVersion)) return void 0;
    const [gridMajor, gridMinor] = gridVersion.split(".") || [];
    const gridMajorMinor = `${gridMajor}.${gridMinor}.x`;
    const gridMajorNumber = parseInt(gridMajor, 10);
    const chartsMajor = gridMajorNumber - $5b7ccabde48fae90$var$VERSION_CHECKING_FIRST_GRID_MAJOR_VERSION + $5b7ccabde48fae90$var$VERSION_CHECKING_FIRST_CHARTS_MAJOR_VERSION;
    if (chartsMajor < 0) return void 0;
    const chartsMinor = gridMinor;
    const chartsMajorMinor = `${chartsMajor}.${chartsMinor}.x`;
    return {
        gridMajorMinor: gridMajorMinor,
        chartsMajorMinor: chartsMajorMinor
    };
}
function $5b7ccabde48fae90$var$validGridChartsVersionErrorMessage({ type: type, gridVersion: gridVersion, chartsVersion: chartsVersion }) {
    const invalidMessage = "AG Grid: AG Grid version is incompatible. Please see https://www.ag-grid.com/javascript-data-grid/modules/ for more information.";
    if (!gridVersion) return invalidMessage;
    const version = $5b7ccabde48fae90$var$gridChartVersion(gridVersion);
    if (!version) return invalidMessage;
    const { gridMajorMinor: gridMajorMinor, chartsMajorMinor: chartsMajorMinor } = version;
    if (type === "incompatible") return `AG Grid version ${gridVersion} and AG Charts version ${chartsVersion} is not supported. AG Grid version ${gridMajorMinor} should be used with AG Chart ${chartsMajorMinor}. Please see https://www.ag-grid.com/javascript-data-grid/modules/ for more information.`;
    else if (type === "invalidCharts") return `AG Grid version ${gridMajorMinor} should be used with AG Chart ${chartsMajorMinor}. Please see https://www.ag-grid.com/javascript-data-grid/modules/ for more information.`;
    return invalidMessage;
}
function $5b7ccabde48fae90$var$validGridChartsVersion({ gridVersion: gridVersion, chartsVersion: chartsVersion }) {
    if (!$5b7ccabde48fae90$var$isValidVersion(chartsVersion)) return {
        isValid: false,
        message: $5b7ccabde48fae90$var$validGridChartsVersionErrorMessage({
            type: "invalidCharts",
            gridVersion: gridVersion,
            chartsVersion: chartsVersion
        })
    };
    if (!$5b7ccabde48fae90$var$isValidVersion(gridVersion)) return {
        isValid: false,
        message: $5b7ccabde48fae90$var$validGridChartsVersionErrorMessage({
            type: "invalidGrid",
            gridVersion: gridVersion,
            chartsVersion: chartsVersion
        })
    };
    const [gridMajor, gridMinor] = gridVersion.split(".") || [];
    const [chartsMajor, chartsMinor, chartsPatch] = chartsVersion.split(".") || [];
    const isValidMajor = $5b7ccabde48fae90$var$isValidMajorVersion({
        gridMajorVersion: gridMajor,
        chartsMajorVersion: chartsMajor
    });
    if (isValidMajor && gridMinor === chartsMinor || chartsPatch.includes("beta")) return {
        isValid: true
    };
    else if (!isValidMajor || gridMinor !== chartsMinor) return {
        isValid: false,
        message: $5b7ccabde48fae90$var$validGridChartsVersionErrorMessage({
            type: "incompatible",
            gridVersion: gridVersion,
            chartsVersion: chartsVersion
        })
    };
    return {
        isValid: false,
        message: $5b7ccabde48fae90$var$validGridChartsVersionErrorMessage({
            type: "invalid",
            gridVersion: gridVersion,
            chartsVersion: chartsVersion
        })
    };
}
var $5b7ccabde48fae90$var$ChartMenuListFactory = class extends (0, $jIDNV.BeanStub) {
    showMenuList(params) {
        const { eventSource: eventSource, showMenu: showMenu, chartMenuContext: chartMenuContext } = params;
        const areChartToolPanelsEnabled = this.chartMenuService.doChartToolPanelsExist(chartMenuContext.chartController);
        const menuItems = this.mapWithStockItems(this.getMenuItems(chartMenuContext.chartController, areChartToolPanelsEnabled), chartMenuContext, showMenu, eventSource, areChartToolPanelsEnabled);
        if (!menuItems.length) return;
        const chartMenuList = this.createBean(new $5b7ccabde48fae90$var$ChartMenuList(menuItems));
        this.activeChartMenuList = chartMenuList;
        let multiplier = -1;
        let alignSide = "left";
        if (this.gos.get("enableRtl")) {
            multiplier = 1;
            alignSide = "right";
        }
        const eGui = chartMenuList.getGui();
        this.popupService.addPopup({
            modal: true,
            eChild: eGui,
            closeOnEsc: true,
            closedCallback: ()=>{
                this.destroyBean(chartMenuList);
                this.activeChartMenuList = void 0;
                const eDocument = this.gos.getDocument();
                const activeEl = this.gos.getActiveDomElement();
                if (!activeEl || activeEl === eDocument.body) eventSource.focus({
                    preventScroll: true
                });
            },
            afterGuiAttached: (params2)=>chartMenuList.afterGuiAttached(params2),
            positionCallback: ()=>{
                this.popupService.positionPopupByComponent({
                    type: "chartMenu",
                    eventSource: eventSource,
                    ePopup: eGui,
                    alignSide: alignSide,
                    nudgeX: 4 * multiplier,
                    nudgeY: 4,
                    position: "under",
                    keepWithinBounds: true
                });
            },
            ariaLabel: "Chart Menu"
        });
    }
    getMenuItems(chartController, areChartToolPanelsEnabled) {
        const defaultItems = [
            ...areChartToolPanelsEnabled ? [
                "chartEdit"
            ] : [],
            ...chartController.isEnterprise() ? [
                "chartAdvancedSettings"
            ] : [],
            chartController.isChartLinked() ? "chartUnlink" : "chartLink",
            "chartDownload"
        ];
        const chartMenuItems = this.gos.get("chartMenuItems");
        if (!chartMenuItems) return defaultItems;
        else if (Array.isArray(chartMenuItems)) return chartMenuItems;
        else return chartMenuItems(this.gos.addGridCommonParams({
            defaultItems: defaultItems
        }));
    }
    mapWithStockItems(originalList, chartMenuContext, showMenu, eventSource, areChartToolPanelsEnabled) {
        if (!originalList) return [];
        const resultList = [];
        originalList.forEach((menuItemOrString)=>{
            let result;
            if (typeof menuItemOrString === "string") result = this.getStockMenuItem(menuItemOrString, chartMenuContext, showMenu, eventSource, areChartToolPanelsEnabled);
            else result = $5b7ccabde48fae90$var$__spreadValues3({}, menuItemOrString);
            if (!result) return;
            const { subMenu: subMenu } = result;
            if (Array.isArray(subMenu)) result.subMenu = this.mapWithStockItems(subMenu, chartMenuContext, showMenu, eventSource, areChartToolPanelsEnabled);
            resultList.push(result);
        });
        return resultList;
    }
    getStockMenuItem(key, chartMenuContext, showMenu, eventSource, areChartToolPanelsEnabled) {
        switch(key){
            case "chartEdit":
                return areChartToolPanelsEnabled ? this.createMenuItem(this.chartTranslationService.translate("chartEdit"), "chartsMenuEdit", showMenu) : null;
            case "chartAdvancedSettings":
                return this.createMenuItem(this.chartTranslationService.translate("chartAdvancedSettings"), "chartsMenuAdvancedSettings", ()=>this.chartMenuService.openAdvancedSettings(chartMenuContext, eventSource));
            case "chartUnlink":
                return chartMenuContext.chartController.isChartLinked() ? this.createMenuItem(this.chartTranslationService.translate("chartUnlink"), "unlinked", ()=>this.chartMenuService.toggleLinked(chartMenuContext)) : null;
            case "chartLink":
                return !chartMenuContext.chartController.isChartLinked() ? this.createMenuItem(this.chartTranslationService.translate("chartLink"), "linked", ()=>this.chartMenuService.toggleLinked(chartMenuContext)) : null;
            case "chartDownload":
                return this.createMenuItem(this.chartTranslationService.translate("chartDownload"), "save", ()=>this.chartMenuService.downloadChart(chartMenuContext));
        }
        return null;
    }
    createMenuItem(name, iconName, action) {
        return {
            name: name,
            icon: (0, $jIDNV._).createIconNoSpan(iconName, this.gos, null),
            action: action
        };
    }
    destroy() {
        this.destroyBean(this.activeChartMenuList);
        super.destroy();
    }
};
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("popupService")
], $5b7ccabde48fae90$var$ChartMenuListFactory.prototype, "popupService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartMenuService")
], $5b7ccabde48fae90$var$ChartMenuListFactory.prototype, "chartMenuService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartTranslationService")
], $5b7ccabde48fae90$var$ChartMenuListFactory.prototype, "chartTranslationService", 2);
$5b7ccabde48fae90$var$ChartMenuListFactory = $5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Bean)("chartMenuListFactory")
], $5b7ccabde48fae90$var$ChartMenuListFactory);
var $5b7ccabde48fae90$var$ChartMenuList = class extends (0, $jIDNV.Component) {
    constructor(menuItems){
        super(/* html */ `
            <div ref="eChartsMenu" role="presentation" class="ag-menu ag-chart-menu-popup"></div>
        `);
        this.menuItems = menuItems;
    }
    init() {
        this.mainMenuList = this.createManagedBean(new (0, $jIDNV.AgMenuList)(0));
        this.mainMenuList.addMenuItems(this.menuItems);
        this.mainMenuList.addEventListener((0, $jIDNV.AgMenuItemComponent).EVENT_CLOSE_MENU, this.onHidePopup.bind(this));
        this.eChartsMenu.appendChild(this.mainMenuList.getGui());
    }
    onHidePopup() {
        var _a;
        (_a = this.hidePopupFunc) == null || _a.call(this);
    }
    afterGuiAttached({ hidePopup: hidePopup }) {
        if (hidePopup) {
            this.hidePopupFunc = hidePopup;
            this.addDestroyFunc(hidePopup);
        }
        this.focusService.focusInto(this.mainMenuList.getGui());
    }
};
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("focusService")
], $5b7ccabde48fae90$var$ChartMenuList.prototype, "focusService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.RefSelector)("eChartsMenu")
], $5b7ccabde48fae90$var$ChartMenuList.prototype, "eChartsMenu", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$ChartMenuList.prototype, "init", 1);
var $5b7ccabde48fae90$var$_AnimationPanel = class _AnimationPanel2 extends (0, $jIDNV.Component) {
    constructor(chartMenuParamsFactory){
        super();
        this.chartMenuParamsFactory = chartMenuParamsFactory;
    }
    init() {
        const animationGroupParams = this.chartMenuParamsFactory.addEnableParams("animation.enabled", {
            cssIdentifier: "charts-advanced-settings-top-level",
            direction: "vertical",
            suppressOpenCloseIcons: true,
            title: this.chartTranslationService.translate("animation"),
            suppressEnabledCheckbox: true,
            useToggle: true
        });
        const animationHeightInputParams = this.chartMenuParamsFactory.getDefaultNumberInputParams("animation.duration", "durationMillis", {
            min: 0
        });
        this.setTemplate(_AnimationPanel2.TEMPLATE, {
            animationGroup: animationGroupParams,
            animationHeightInput: animationHeightInputParams
        });
    }
};
$5b7ccabde48fae90$var$_AnimationPanel.TEMPLATE = /* html */ `<div>
            <ag-group-component ref="animationGroup">
                <ag-input-number-field ref="animationHeightInput"></ag-input>
            </ag-group-component>
        </div>`;
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartTranslationService")
], $5b7ccabde48fae90$var$_AnimationPanel.prototype, "chartTranslationService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_AnimationPanel.prototype, "init", 1);
var $5b7ccabde48fae90$var$AnimationPanel = $5b7ccabde48fae90$var$_AnimationPanel;
var $5b7ccabde48fae90$var$_CrosshairPanel = class _CrosshairPanel2 extends (0, $jIDNV.Component) {
    constructor(chartMenuParamsFactory){
        super();
        this.chartMenuParamsFactory = chartMenuParamsFactory;
    }
    init() {
        const crosshairGroupParams = this.chartMenuParamsFactory.addEnableParams("crosshair.enabled", {
            cssIdentifier: "charts-advanced-settings-top-level",
            direction: "vertical",
            suppressOpenCloseIcons: true,
            title: this.chartTranslationService.translate("crosshair"),
            suppressEnabledCheckbox: true,
            useToggle: true
        });
        const crosshairLabelCheckboxParams = this.chartMenuParamsFactory.getDefaultCheckboxParams("crosshair.label.enabled", "crosshairLabel");
        const crosshairSnapCheckboxParams = this.chartMenuParamsFactory.getDefaultCheckboxParams("crosshair.snap", "crosshairSnap");
        const crosshairStrokeColorPickerParams = this.chartMenuParamsFactory.getDefaultColorPickerParams("crosshair.stroke", "color");
        this.setTemplate(_CrosshairPanel2.TEMPLATE, {
            crosshairGroup: crosshairGroupParams,
            crosshairLabelCheckbox: crosshairLabelCheckboxParams,
            crosshairSnapCheckbox: crosshairSnapCheckboxParams,
            crosshairStrokeColorPicker: crosshairStrokeColorPickerParams
        });
    }
};
$5b7ccabde48fae90$var$_CrosshairPanel.TEMPLATE = /* html */ `<div>
            <ag-group-component ref="crosshairGroup">
                <ag-checkbox ref="crosshairLabelCheckbox"></ag-checkbox>
                <ag-checkbox ref="crosshairSnapCheckbox"></ag-checkbox>
                <ag-color-picker ref="crosshairStrokeColorPicker"></ag-color-picker>
            </ag-group-component>
        </div>`;
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartTranslationService")
], $5b7ccabde48fae90$var$_CrosshairPanel.prototype, "chartTranslationService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_CrosshairPanel.prototype, "init", 1);
var $5b7ccabde48fae90$var$CrosshairPanel = $5b7ccabde48fae90$var$_CrosshairPanel;
var $5b7ccabde48fae90$var$_NavigatorPanel = class _NavigatorPanel2 extends (0, $jIDNV.Component) {
    constructor(chartMenuParamsFactory){
        super();
        this.chartMenuParamsFactory = chartMenuParamsFactory;
    }
    init() {
        const navigatorGroupParams = this.chartMenuParamsFactory.addEnableParams("navigator.enabled", {
            cssIdentifier: "charts-advanced-settings-top-level",
            direction: "vertical",
            suppressOpenCloseIcons: true,
            title: this.chartTranslationService.translate("navigator"),
            suppressEnabledCheckbox: true,
            useToggle: true
        });
        const navigatorHeightSliderParams = this.chartMenuParamsFactory.getDefaultSliderParams("navigator.height", "height", 60);
        navigatorHeightSliderParams.minValue = 10;
        const navigatorMiniChartCheckboxParams = this.chartMenuParamsFactory.getDefaultCheckboxParams("navigator.miniChart.enabled", "miniChart");
        this.setTemplate(_NavigatorPanel2.TEMPLATE, {
            navigatorGroup: navigatorGroupParams,
            navigatorHeightSlider: navigatorHeightSliderParams,
            navigatorMiniChartCheckbox: navigatorMiniChartCheckboxParams
        });
    }
};
$5b7ccabde48fae90$var$_NavigatorPanel.TEMPLATE = /* html */ `<div>
            <ag-group-component ref="navigatorGroup">
                <ag-slider ref="navigatorHeightSlider"></ag-slider>
                <ag-checkbox ref="navigatorMiniChartCheckbox"></ag-checkbox>
            </ag-group-component>
        </div>`;
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartTranslationService")
], $5b7ccabde48fae90$var$_NavigatorPanel.prototype, "chartTranslationService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_NavigatorPanel.prototype, "init", 1);
var $5b7ccabde48fae90$var$NavigatorPanel = $5b7ccabde48fae90$var$_NavigatorPanel;
var $5b7ccabde48fae90$var$_ZoomPanel = class _ZoomPanel2 extends (0, $jIDNV.Component) {
    constructor(chartMenuParamsFactory){
        super();
        this.chartMenuParamsFactory = chartMenuParamsFactory;
    }
    init() {
        const zoomGroupParams = this.chartMenuParamsFactory.addEnableParams("zoom.enabled", {
            cssIdentifier: "charts-advanced-settings-top-level",
            direction: "vertical",
            suppressOpenCloseIcons: true,
            title: this.chartTranslationService.translate("zoom"),
            suppressEnabledCheckbox: true,
            useToggle: true
        });
        const zoomScrollingCheckboxParams = this.chartMenuParamsFactory.getDefaultCheckboxParams("zoom.enableScrolling", "scrollingZoom");
        const zoomScrollingStepSliderParams = this.chartMenuParamsFactory.getDefaultSliderParams("zoom.scrollingStep", "scrollingStep", 1);
        zoomScrollingStepSliderParams.step = 0.01;
        zoomScrollingStepSliderParams.minValue = zoomScrollingStepSliderParams.step;
        const zoomSelectingCheckboxParams = this.chartMenuParamsFactory.getDefaultCheckboxParams("zoom.enableSelecting", "selectingZoom");
        zoomScrollingCheckboxParams.onValueChange = /* @__PURE__ */ ((onValueChange)=>(value)=>{
                if (!onValueChange) return;
                onValueChange(value);
                this.zoomScrollingStepInput.setDisabled(!value);
            })(zoomScrollingCheckboxParams.onValueChange);
        this.setTemplate(_ZoomPanel2.TEMPLATE, {
            zoomGroup: zoomGroupParams,
            zoomScrollingCheckbox: zoomScrollingCheckboxParams,
            zoomScrollingStepInput: zoomScrollingStepSliderParams,
            zoomSelectingCheckbox: zoomSelectingCheckboxParams
        });
        this.zoomScrollingStepInput.setDisabled(!zoomScrollingCheckboxParams.value);
    }
};
$5b7ccabde48fae90$var$_ZoomPanel.TEMPLATE = /* html */ `<div>
            <ag-group-component ref="zoomGroup">
                <ag-checkbox ref="zoomSelectingCheckbox"></ag-checkbox>
                <ag-checkbox ref="zoomScrollingCheckbox"></ag-checkbox>
                <ag-slider ref="zoomScrollingStepInput"></ag-slider>
            </ag-group-component>
        </div>`;
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartTranslationService")
], $5b7ccabde48fae90$var$_ZoomPanel.prototype, "chartTranslationService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.RefSelector)("zoomScrollingStepInput")
], $5b7ccabde48fae90$var$_ZoomPanel.prototype, "zoomScrollingStepInput", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_ZoomPanel.prototype, "init", 1);
var $5b7ccabde48fae90$var$ZoomPanel = $5b7ccabde48fae90$var$_ZoomPanel;
var $5b7ccabde48fae90$var$INTERACTIVITY_GROUPS = [
    "navigator",
    "zoom",
    "animation",
    "crosshair"
];
var $5b7ccabde48fae90$var$_AdvancedSettingsPanel = class _AdvancedSettingsPanel2 extends (0, $jIDNV.Component) {
    constructor(chartMenuContext){
        super(_AdvancedSettingsPanel2.TEMPLATE);
        this.chartMenuContext = chartMenuContext;
    }
    postConstruct() {
        this.chartPanelFeature = this.createManagedBean(new $5b7ccabde48fae90$var$ChartPanelFeature(this.chartMenuContext.chartController, this.getGui(), "ag-chart-advanced-settings-section", (chartType, seriesType)=>this.createPanels(chartType, seriesType)));
        this.chartPanelFeature.refreshPanels();
    }
    createPanels(chartType, seriesType) {
        $5b7ccabde48fae90$var$INTERACTIVITY_GROUPS.forEach((group)=>{
            if (!this.isGroupPanelShownForSeries(group, seriesType)) return;
            const comp = this.createPanel(group);
            this.chartPanelFeature.addComponent(comp);
        });
    }
    isGroupPanelShownForSeries(group, seriesType) {
        return group === "animation" || $5b7ccabde48fae90$var$isCartesian(seriesType);
    }
    createPanel(group) {
        const { chartMenuParamsFactory: chartMenuParamsFactory, chartAxisMenuParamsFactory: chartAxisMenuParamsFactory } = this.chartMenuContext;
        switch(group){
            case "navigator":
                return new $5b7ccabde48fae90$var$NavigatorPanel(chartMenuParamsFactory);
            case "zoom":
                return new $5b7ccabde48fae90$var$ZoomPanel(chartMenuParamsFactory);
            case "animation":
                return new $5b7ccabde48fae90$var$AnimationPanel(chartMenuParamsFactory);
            case "crosshair":
                return new $5b7ccabde48fae90$var$CrosshairPanel(chartAxisMenuParamsFactory);
        }
    }
};
$5b7ccabde48fae90$var$_AdvancedSettingsPanel.TEMPLATE = /* html */ `<div class="ag-chart-advanced-settings-wrapper"></div>`;
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_AdvancedSettingsPanel.prototype, "postConstruct", 1);
var $5b7ccabde48fae90$var$AdvancedSettingsPanel = $5b7ccabde48fae90$var$_AdvancedSettingsPanel;
var $5b7ccabde48fae90$var$AdvancedSettingsMenuFactory = class extends (0, $jIDNV.BeanStub) {
    showMenu(chartMenuContext, eventSource) {
        this.hideMenu();
        const menu = this.createBean(new $5b7ccabde48fae90$var$AdvancedSettingsMenu(chartMenuContext));
        this.activeDialog = this.createBean(new (0, $jIDNV.AgDialog)({
            title: this.chartTranslationService.translate("advancedSettings"),
            component: menu,
            width: 300,
            height: 400,
            resizable: true,
            movable: true,
            centered: true,
            closable: true,
            afterGuiAttached: ()=>{
                var _a;
                (_a = this.focusService.findFocusableElements(menu.getGui())[0]) == null || _a.focus();
            },
            closedCallback: ()=>{
                this.activeMenu = this.destroyBean(this.activeMenu);
                this.activeDialog = void 0;
                eventSource == null || eventSource.focus({
                    preventScroll: true
                });
            }
        }));
        this.activeMenu = menu;
    }
    hideMenu() {
        if (this.activeDialog) this.destroyBean(this.activeDialog);
    }
    destroy() {
        this.activeMenu = this.destroyBean(this.activeMenu);
        this.activeDialog = this.destroyBean(this.activeDialog);
        super.destroy();
    }
};
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("focusService")
], $5b7ccabde48fae90$var$AdvancedSettingsMenuFactory.prototype, "focusService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("chartTranslationService")
], $5b7ccabde48fae90$var$AdvancedSettingsMenuFactory.prototype, "chartTranslationService", 2);
$5b7ccabde48fae90$var$AdvancedSettingsMenuFactory = $5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Bean)("advancedSettingsMenuFactory")
], $5b7ccabde48fae90$var$AdvancedSettingsMenuFactory);
var $5b7ccabde48fae90$var$_AdvancedSettingsMenu = class _AdvancedSettingsMenu2 extends (0, $jIDNV.TabGuardComp) {
    constructor(chartMenuContext){
        super(_AdvancedSettingsMenu2.TEMPLATE);
        this.chartMenuContext = chartMenuContext;
    }
    postConstruct() {
        this.advancedSettingsPanel = this.createManagedBean(new $5b7ccabde48fae90$var$AdvancedSettingsPanel(this.chartMenuContext));
        this.getGui().appendChild(this.advancedSettingsPanel.getGui());
        this.initialiseTabGuard({
            onTabKeyDown: this.onTabKeyDown.bind(this),
            focusTrapActive: true
        });
    }
    onTabKeyDown(e) {
        if (e.defaultPrevented) return;
        e.preventDefault();
        const backwards = e.shiftKey;
        const panelGui = this.advancedSettingsPanel.getGui();
        const nextEl = this.focusService.findNextFocusableElement(panelGui, false, backwards);
        if (nextEl) nextEl.focus();
        else {
            const focusableElements = this.focusService.findFocusableElements(panelGui);
            if (focusableElements.length) focusableElements[backwards ? focusableElements.length - 1 : 0].focus();
        }
    }
};
$5b7ccabde48fae90$var$_AdvancedSettingsMenu.TEMPLATE = /* html */ `<div class="ag-chart-advanced-settings"></div>`;
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.Autowired)("focusService")
], $5b7ccabde48fae90$var$_AdvancedSettingsMenu.prototype, "focusService", 2);
$5b7ccabde48fae90$var$__decorateClass4([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_AdvancedSettingsMenu.prototype, "postConstruct", 1);
var $5b7ccabde48fae90$var$AdvancedSettingsMenu = $5b7ccabde48fae90$var$_AdvancedSettingsMenu;
var $5b7ccabde48fae90$export$6248c9e5743f8c49 = {
    version: $5b7ccabde48fae90$var$VERSION4,
    validate: ()=>{
        return $5b7ccabde48fae90$var$validGridChartsVersion({
            gridVersion: $5b7ccabde48fae90$var$VERSION4,
            chartsVersion: $5b7ccabde48fae90$var$ChartService.CHARTS_VERSION
        });
    },
    moduleName: (0, $jIDNV.ModuleNames).GridChartsModule,
    beans: [
        $5b7ccabde48fae90$var$ChartService,
        $5b7ccabde48fae90$var$ChartTranslationService,
        $5b7ccabde48fae90$var$ChartCrossFilterService,
        $5b7ccabde48fae90$var$ChartMenuListFactory,
        $5b7ccabde48fae90$var$ChartMenuService,
        $5b7ccabde48fae90$var$AdvancedSettingsMenuFactory
    ],
    agStackComponents: [
        {
            componentName: "AgColorPicker",
            componentClass: $5b7ccabde48fae90$var$AgColorPicker
        },
        {
            componentName: "AgAngleSelect",
            componentClass: $5b7ccabde48fae90$var$AgAngleSelect
        },
        {
            componentName: "AgPillSelect",
            componentClass: $5b7ccabde48fae90$var$AgPillSelect
        }
    ],
    dependantModules: [
        $5b7ccabde48fae90$export$5e5c8269d4d7ed2e,
        $5b7ccabde48fae90$export$3a6d13add8617801
    ]
};
var $5b7ccabde48fae90$export$2d0cf3225e55a3e = 0;
var $5b7ccabde48fae90$export$8a8f7e9aca311bdd = {
    time: $iTJTu.time,
    AgChart: $iTJTu.AgChart
};
var $5b7ccabde48fae90$var$__defProp5 = Object.defineProperty;
var $5b7ccabde48fae90$var$__getOwnPropDesc5 = Object.getOwnPropertyDescriptor;
var $5b7ccabde48fae90$var$__decorateClass5 = (decorators, target, key, kind)=>{
    var result = kind > 1 ? void 0 : kind ? $5b7ccabde48fae90$var$__getOwnPropDesc5(target, key) : target;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
    if (kind && result) $5b7ccabde48fae90$var$__defProp5(target, key, result);
    return result;
};
var $5b7ccabde48fae90$var$SOURCE_PASTE = "paste";
var $5b7ccabde48fae90$var$EXPORT_TYPE_DRAG_COPY = "dragCopy";
var $5b7ccabde48fae90$var$EXPORT_TYPE_CLIPBOARD = "clipboard";
var $5b7ccabde48fae90$var$apiError = (method)=>`AG Grid: Unable to use the Clipboard API (navigator.clipboard.${method}()). The reason why it could not be used has been logged in the previous line. For this reason the grid has defaulted to using a workaround which doesn't perform as well. Either fix why Clipboard API is blocked, OR stop this message from appearing by setting grid property suppressClipboardApi=true (which will default the grid to using the workaround rather than the API.`;
var $5b7ccabde48fae90$var$ClipboardService = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.lastPasteOperationTime = 0;
        this.navigatorApiFailed = false;
    }
    init() {
        this.logger = this.loggerFactory.create("ClipboardService");
        if (this.rowModel.getType() === "clientSide") this.clientSideRowModel = this.rowModel;
        this.ctrlsService.whenReady((p)=>{
            this.gridCtrl = p.gridCtrl;
        });
    }
    pasteFromClipboard() {
        this.logger.log("pasteFromClipboard");
        const allowNavigator = !this.gos.get("suppressClipboardApi");
        if (allowNavigator && !this.navigatorApiFailed && navigator.clipboard && navigator.clipboard.readText) navigator.clipboard.readText().then(this.processClipboardData.bind(this)).catch((e)=>{
            (0, $jIDNV._).doOnce(()=>{
                console.warn(e);
                console.warn($5b7ccabde48fae90$var$apiError("readText"));
            }, "clipboardApiError");
            this.navigatorApiFailed = true;
            this.pasteFromClipboardLegacy();
        });
        else this.pasteFromClipboardLegacy();
    }
    pasteFromClipboardLegacy() {
        let defaultPrevented = false;
        const handlePasteEvent = (e)=>{
            const currentPastOperationTime = /* @__PURE__ */ new Date().getTime();
            if (currentPastOperationTime - this.lastPasteOperationTime < 50) {
                defaultPrevented = true;
                e.preventDefault();
            }
            this.lastPasteOperationTime = currentPastOperationTime;
        };
        this.executeOnTempElement((textArea)=>{
            textArea.addEventListener("paste", handlePasteEvent);
            textArea.focus({
                preventScroll: true
            });
        }, (element)=>{
            const data = element.value;
            if (!defaultPrevented) this.processClipboardData(data);
            else this.refocusLastFocusedCell();
            element.removeEventListener("paste", handlePasteEvent);
        });
    }
    refocusLastFocusedCell() {
        const focusedCell = this.focusService.getFocusedCell();
        if (focusedCell) this.focusService.setFocusedCell({
            rowIndex: focusedCell.rowIndex,
            column: focusedCell.column,
            rowPinned: focusedCell.rowPinned,
            forceBrowserFocus: true
        });
    }
    getClipboardDelimiter() {
        const delimiter = this.gos.get("clipboardDelimiter");
        return (0, $jIDNV._).exists(delimiter) ? delimiter : "	";
    }
    processClipboardData(data) {
        if (data == null) return;
        let parsedData = $5b7ccabde48fae90$var$ClipboardService.stringToArray(data, this.getClipboardDelimiter());
        const userFunc = this.gos.getCallback("processDataFromClipboard");
        if (userFunc) parsedData = userFunc({
            data: parsedData
        });
        if (parsedData == null) return;
        if (this.gos.get("suppressLastEmptyLineOnPaste")) this.removeLastLineIfBlank(parsedData);
        const pasteOperation = (cellsToFlash, updatedRowNodes, focusedCell, changedPath)=>{
            var _a;
            const rangeActive = (_a = this.rangeService) == null ? void 0 : _a.isMoreThanOneCell();
            const pasteIntoRange = rangeActive && !this.hasOnlyOneValueToPaste(parsedData);
            if (pasteIntoRange) this.pasteIntoActiveRange(this.rangeService, parsedData, cellsToFlash, updatedRowNodes, changedPath);
            else this.pasteStartingFromFocusedCell(parsedData, cellsToFlash, updatedRowNodes, focusedCell, changedPath);
        };
        this.doPasteOperation(pasteOperation);
    }
    // This will parse a delimited string into an array of arrays.
    static stringToArray(strData, delimiter = ",") {
        const data = [];
        const isNewline = (char)=>char === "\r" || char === "\n";
        let insideQuotedField = false;
        if (strData === "") return [
            [
                ""
            ]
        ];
        for(let row = 0, column = 0, position = 0; position < strData.length; position++){
            const previousChar = strData[position - 1];
            const currentChar = strData[position];
            const nextChar = strData[position + 1];
            const ensureDataExists = ()=>{
                if (!data[row]) data[row] = [];
                if (!data[row][column]) data[row][column] = "";
            };
            ensureDataExists();
            if (currentChar === '"') {
                if (insideQuotedField) {
                    if (nextChar === '"') {
                        data[row][column] += '"';
                        position++;
                    } else insideQuotedField = false;
                } else if (previousChar === void 0 || previousChar === delimiter || isNewline(previousChar)) insideQuotedField = true;
            }
            if (!insideQuotedField && currentChar !== '"') {
                if (currentChar === delimiter) {
                    column++;
                    ensureDataExists();
                    continue;
                } else if (isNewline(currentChar)) {
                    column = 0;
                    row++;
                    ensureDataExists();
                    if (currentChar === "\r" && nextChar === "\n") position++;
                    continue;
                }
            }
            data[row][column] += currentChar;
        }
        return data;
    }
    // common code to paste operations, e.g. paste to cell, paste to range, and copy range down
    doPasteOperation(pasteOperationFunc) {
        const source = "clipboard";
        this.eventService.dispatchEvent({
            type: (0, $jIDNV.Events).EVENT_PASTE_START,
            source: source
        });
        let changedPath;
        if (this.clientSideRowModel) {
            const onlyChangedColumns = this.gos.get("aggregateOnlyChangedColumns");
            changedPath = new (0, $jIDNV.ChangedPath)(onlyChangedColumns, this.clientSideRowModel.getRootNode());
        }
        const cellsToFlash = {};
        const updatedRowNodes = [];
        const focusedCell = this.focusService.getFocusedCell();
        pasteOperationFunc(cellsToFlash, updatedRowNodes, focusedCell, changedPath);
        const nodesToRefresh = [
            ...updatedRowNodes
        ];
        if (changedPath) {
            this.clientSideRowModel.doAggregate(changedPath);
            changedPath.forEachChangedNodeDepthFirst((rowNode)=>{
                nodesToRefresh.push(rowNode);
            });
        }
        this.rowRenderer.refreshCells({
            rowNodes: nodesToRefresh
        });
        this.dispatchFlashCells(cellsToFlash);
        this.fireRowChanged(updatedRowNodes);
        this.refocusLastFocusedCell();
        const event = {
            type: (0, $jIDNV.Events).EVENT_PASTE_END,
            source: source
        };
        this.eventService.dispatchEvent(event);
    }
    pasteIntoActiveRange(rangeService, clipboardData, cellsToFlash, updatedRowNodes, changedPath) {
        const abortRepeatingPasteIntoRows = this.getRangeSize(rangeService) % clipboardData.length != 0;
        let indexOffset = 0;
        let dataRowIndex = 0;
        const rowCallback = (currentRow, rowNode, columns, index)=>{
            const atEndOfClipboardData = index - indexOffset >= clipboardData.length;
            if (atEndOfClipboardData) {
                if (abortRepeatingPasteIntoRows) return;
                indexOffset += dataRowIndex;
                dataRowIndex = 0;
            }
            const currentRowData = clipboardData[index - indexOffset];
            updatedRowNodes.push(rowNode);
            const processCellFromClipboardFunc = this.gos.getCallback("processCellFromClipboard");
            columns.forEach((column, idx)=>{
                if (!column.isCellEditable(rowNode) || column.isSuppressPaste(rowNode)) return;
                if (idx >= currentRowData.length) idx = idx % currentRowData.length;
                const newValue = this.processCell(rowNode, column, currentRowData[idx], $5b7ccabde48fae90$var$EXPORT_TYPE_DRAG_COPY, processCellFromClipboardFunc, true);
                rowNode.setDataValue(column, newValue, $5b7ccabde48fae90$var$SOURCE_PASTE);
                if (changedPath) changedPath.addParentNode(rowNode.parent, [
                    column
                ]);
                const { rowIndex: rowIndex, rowPinned: rowPinned } = currentRow;
                const cellId = this.cellPositionUtils.createIdFromValues({
                    rowIndex: rowIndex,
                    column: column,
                    rowPinned: rowPinned
                });
                cellsToFlash[cellId] = true;
            });
            dataRowIndex++;
        };
        this.iterateActiveRanges(false, rowCallback);
    }
    getDisplayedColumnsStartingAt(column) {
        let currentColumn = column;
        const columns = [];
        while(currentColumn != null){
            columns.push(currentColumn);
            currentColumn = this.columnModel.getDisplayedColAfter(currentColumn);
        }
        return columns;
    }
    pasteStartingFromFocusedCell(parsedData, cellsToFlash, updatedRowNodes, focusedCell, changedPath) {
        if (!focusedCell) return;
        const currentRow = {
            rowIndex: focusedCell.rowIndex,
            rowPinned: focusedCell.rowPinned
        };
        const columnsToPasteInto = this.getDisplayedColumnsStartingAt(focusedCell.column);
        if (this.isPasteSingleValueIntoRange(parsedData)) this.pasteSingleValueIntoRange(parsedData, updatedRowNodes, cellsToFlash, changedPath);
        else this.pasteMultipleValues(parsedData, currentRow, updatedRowNodes, columnsToPasteInto, cellsToFlash, $5b7ccabde48fae90$var$EXPORT_TYPE_CLIPBOARD, changedPath);
    }
    // if range is active, and only one cell, then we paste this cell into all cells in the active range.
    isPasteSingleValueIntoRange(parsedData) {
        return this.hasOnlyOneValueToPaste(parsedData) && this.rangeService != null && !this.rangeService.isEmpty();
    }
    pasteSingleValueIntoRange(parsedData, updatedRowNodes, cellsToFlash, changedPath) {
        const value = parsedData[0][0];
        const rowCallback = (currentRow, rowNode, columns)=>{
            updatedRowNodes.push(rowNode);
            columns.forEach((column)=>this.updateCellValue(rowNode, column, value, cellsToFlash, $5b7ccabde48fae90$var$EXPORT_TYPE_CLIPBOARD, changedPath));
        };
        this.iterateActiveRanges(false, rowCallback);
    }
    hasOnlyOneValueToPaste(parsedData) {
        return parsedData.length === 1 && parsedData[0].length === 1;
    }
    copyRangeDown() {
        if (!this.rangeService || this.rangeService.isEmpty()) return;
        const firstRowValues = [];
        const pasteOperation = (cellsToFlash, updatedRowNodes, focusedCell, changedPath)=>{
            const processCellForClipboardFunc = this.gos.getCallback("processCellForClipboard");
            const processCellFromClipboardFunc = this.gos.getCallback("processCellFromClipboard");
            const rowCallback = (currentRow, rowNode, columns)=>{
                if (!firstRowValues.length) columns.forEach((column)=>{
                    const value = this.processCell(rowNode, column, this.valueService.getValue(column, rowNode), $5b7ccabde48fae90$var$EXPORT_TYPE_DRAG_COPY, processCellForClipboardFunc, false, true);
                    firstRowValues.push(value);
                });
                else {
                    updatedRowNodes.push(rowNode);
                    columns.forEach((column, index)=>{
                        if (!column.isCellEditable(rowNode) || column.isSuppressPaste(rowNode)) return;
                        const firstRowValue = this.processCell(rowNode, column, firstRowValues[index], $5b7ccabde48fae90$var$EXPORT_TYPE_DRAG_COPY, processCellFromClipboardFunc, true);
                        rowNode.setDataValue(column, firstRowValue, $5b7ccabde48fae90$var$SOURCE_PASTE);
                        if (changedPath) changedPath.addParentNode(rowNode.parent, [
                            column
                        ]);
                        const { rowIndex: rowIndex, rowPinned: rowPinned } = currentRow;
                        const cellId = this.cellPositionUtils.createIdFromValues({
                            rowIndex: rowIndex,
                            column: column,
                            rowPinned: rowPinned
                        });
                        cellsToFlash[cellId] = true;
                    });
                }
            };
            this.iterateActiveRanges(true, rowCallback);
        };
        this.doPasteOperation(pasteOperation);
    }
    removeLastLineIfBlank(parsedData) {
        const lastLine = (0, $jIDNV._).last(parsedData);
        const lastLineIsBlank = lastLine && lastLine.length === 1 && lastLine[0] === "";
        if (lastLineIsBlank) {
            if (parsedData.length === 1) return;
            (0, $jIDNV._).removeFromArray(parsedData, lastLine);
        }
    }
    fireRowChanged(rowNodes) {
        if (this.gos.get("editType") !== "fullRow") return;
        rowNodes.forEach((rowNode)=>{
            const event = {
                type: (0, $jIDNV.Events).EVENT_ROW_VALUE_CHANGED,
                node: rowNode,
                data: rowNode.data,
                rowIndex: rowNode.rowIndex,
                rowPinned: rowNode.rowPinned
            };
            this.eventService.dispatchEvent(event);
        });
    }
    pasteMultipleValues(clipboardGridData, currentRow, updatedRowNodes, columnsToPasteInto, cellsToFlash, type, changedPath) {
        let rowPointer = currentRow;
        const skipGroupRows = this.clientSideRowModel != null && !this.gos.get("enableGroupEdit") && !this.gos.get("treeData");
        const getNextGoodRowNode = ()=>{
            while(true){
                if (!rowPointer) return null;
                const res = this.rowPositionUtils.getRowNode(rowPointer);
                rowPointer = this.cellNavigationService.getRowBelow({
                    rowPinned: rowPointer.rowPinned,
                    rowIndex: rowPointer.rowIndex
                });
                if (res == null) return null;
                const skipRow = res.detail || res.footer || skipGroupRows && res.group;
                if (!skipRow) return res;
            }
        };
        clipboardGridData.forEach((clipboardRowData)=>{
            const rowNode = getNextGoodRowNode();
            if (!rowNode) return;
            clipboardRowData.forEach((value, index)=>this.updateCellValue(rowNode, columnsToPasteInto[index], value, cellsToFlash, type, changedPath));
            updatedRowNodes.push(rowNode);
        });
    }
    updateCellValue(rowNode, column, value, cellsToFlash, type, changedPath) {
        if (!rowNode || !column || !column.isCellEditable(rowNode) || column.isSuppressPaste(rowNode)) return;
        if (rowNode.group && column.isValueActive()) return;
        const processedValue = this.processCell(rowNode, column, value, type, this.gos.getCallback("processCellFromClipboard"), true);
        rowNode.setDataValue(column, processedValue, $5b7ccabde48fae90$var$SOURCE_PASTE);
        const { rowIndex: rowIndex, rowPinned: rowPinned } = rowNode;
        const cellId = this.cellPositionUtils.createIdFromValues({
            rowIndex: rowIndex,
            column: column,
            rowPinned: rowPinned
        });
        cellsToFlash[cellId] = true;
        if (changedPath) changedPath.addParentNode(rowNode.parent, [
            column
        ]);
    }
    copyToClipboard(params = {}) {
        this.copyOrCutToClipboard(params);
    }
    cutToClipboard(params = {}, source = "api") {
        if (this.gos.get("suppressCutToClipboard")) return;
        const startEvent = {
            type: (0, $jIDNV.Events).EVENT_CUT_START,
            source: source
        };
        this.eventService.dispatchEvent(startEvent);
        this.copyOrCutToClipboard(params, true);
        const endEvent = {
            type: (0, $jIDNV.Events).EVENT_CUT_END,
            source: source
        };
        this.eventService.dispatchEvent(endEvent);
    }
    copyOrCutToClipboard(params, cut) {
        let { includeHeaders: includeHeaders, includeGroupHeaders: includeGroupHeaders } = params;
        this.logger.log(`copyToClipboard: includeHeaders = ${includeHeaders}`);
        if (includeHeaders == null) includeHeaders = this.gos.get("copyHeadersToClipboard");
        if (includeGroupHeaders == null) includeGroupHeaders = this.gos.get("copyGroupHeadersToClipboard");
        const copyParams = {
            includeHeaders: includeHeaders,
            includeGroupHeaders: includeGroupHeaders
        };
        const shouldCopyRows = !this.gos.get("suppressCopyRowsToClipboard");
        let cellClearType = null;
        if (this.rangeService && !this.rangeService.isEmpty() && !this.shouldSkipSingleCellRange(this.rangeService)) {
            this.copySelectedRangeToClipboard(copyParams);
            cellClearType = 0;
        } else if (shouldCopyRows && !this.selectionService.isEmpty()) {
            this.copySelectedRowsToClipboard(copyParams);
            cellClearType = 1;
        } else if (this.focusService.isAnyCellFocused()) {
            this.copyFocusedCellToClipboard(copyParams);
            cellClearType = 2;
        }
        if (cut && cellClearType !== null) this.clearCellsAfterCopy(cellClearType);
    }
    clearCellsAfterCopy(type) {
        this.eventService.dispatchEvent({
            type: (0, $jIDNV.Events).EVENT_KEY_SHORTCUT_CHANGED_CELL_START
        });
        if (type === 0) this.rangeService.clearCellRangeCellValues({
            cellEventSource: "clipboardService"
        });
        else if (type === 1) this.clearSelectedRows();
        else {
            const focusedCell = this.focusService.getFocusedCell();
            if (focusedCell == null) return;
            const rowNode = this.rowPositionUtils.getRowNode(focusedCell);
            if (rowNode) this.clearCellValue(rowNode, focusedCell.column);
        }
        this.eventService.dispatchEvent({
            type: (0, $jIDNV.Events).EVENT_KEY_SHORTCUT_CHANGED_CELL_END
        });
    }
    clearSelectedRows() {
        const selected = this.selectionService.getSelectedNodes();
        const columns = this.columnModel.getAllDisplayedColumns();
        for (const row of selected)for (const col of columns)this.clearCellValue(row, col);
    }
    clearCellValue(rowNode, column) {
        var _a;
        if (!column.isCellEditable(rowNode)) return;
        const emptyValue = (_a = this.valueService.parseValue(column, rowNode, "", rowNode.getValueFromValueService(column))) != null ? _a : null;
        rowNode.setDataValue(column, emptyValue, "clipboardService");
    }
    shouldSkipSingleCellRange(rangeService) {
        return this.gos.get("suppressCopySingleCellRanges") && !rangeService.isMoreThanOneCell();
    }
    iterateActiveRanges(onlyFirst, rowCallback, columnCallback) {
        if (!this.rangeService || this.rangeService.isEmpty()) return;
        const cellRanges = this.rangeService.getCellRanges();
        if (onlyFirst) this.iterateActiveRange(cellRanges[0], rowCallback, columnCallback, true);
        else cellRanges.forEach((range, idx)=>this.iterateActiveRange(range, rowCallback, columnCallback, idx === cellRanges.length - 1));
    }
    iterateActiveRange(range, rowCallback, columnCallback, isLastRange) {
        if (!this.rangeService) return;
        let currentRow = this.rangeService.getRangeStartRow(range);
        const lastRow = this.rangeService.getRangeEndRow(range);
        if (columnCallback && range.columns) columnCallback(range.columns);
        let rangeIndex = 0;
        let isLastRow = false;
        while(!isLastRow && currentRow != null){
            const rowNode = this.rowPositionUtils.getRowNode(currentRow);
            isLastRow = this.rowPositionUtils.sameRow(currentRow, lastRow);
            rowCallback(currentRow, rowNode, range.columns, rangeIndex++, isLastRow && isLastRange);
            currentRow = this.cellNavigationService.getRowBelow(currentRow);
        }
    }
    copySelectedRangeToClipboard(params = {}) {
        if (!this.rangeService || this.rangeService.isEmpty()) return;
        const allRangesMerge = this.rangeService.areAllRangesAbleToMerge();
        const { data: data, cellsToFlash: cellsToFlash } = allRangesMerge ? this.buildDataFromMergedRanges(this.rangeService, params) : this.buildDataFromRanges(this.rangeService, params);
        this.copyDataToClipboard(data);
        this.dispatchFlashCells(cellsToFlash);
    }
    buildDataFromMergedRanges(rangeService, params) {
        const columnsSet = /* @__PURE__ */ new Set();
        const ranges = rangeService.getCellRanges();
        const rowPositionsMap = /* @__PURE__ */ new Map();
        const allRowPositions = [];
        const allCellsToFlash = {};
        ranges.forEach((range)=>{
            range.columns.forEach((col)=>columnsSet.add(col));
            const { rowPositions: rowPositions, cellsToFlash: cellsToFlash } = this.getRangeRowPositionsAndCellsToFlash(rangeService, range);
            rowPositions.forEach((rowPosition)=>{
                const rowPositionAsString = `${rowPosition.rowIndex}-${rowPosition.rowPinned || "null"}`;
                if (!rowPositionsMap.get(rowPositionAsString)) {
                    rowPositionsMap.set(rowPositionAsString, true);
                    allRowPositions.push(rowPosition);
                }
            });
            Object.assign(allCellsToFlash, cellsToFlash);
        });
        const allColumns = this.columnModel.getAllDisplayedColumns();
        const exportedColumns = Array.from(columnsSet);
        exportedColumns.sort((a, b)=>{
            const posA = allColumns.indexOf(a);
            const posB = allColumns.indexOf(b);
            return posA - posB;
        });
        const data = this.buildExportParams({
            columns: exportedColumns,
            rowPositions: allRowPositions,
            includeHeaders: params.includeHeaders,
            includeGroupHeaders: params.includeGroupHeaders
        });
        return {
            data: data,
            cellsToFlash: allCellsToFlash
        };
    }
    buildDataFromRanges(rangeService, params) {
        const ranges = rangeService.getCellRanges();
        const data = [];
        const allCellsToFlash = {};
        ranges.forEach((range)=>{
            const { rowPositions: rowPositions, cellsToFlash: cellsToFlash } = this.getRangeRowPositionsAndCellsToFlash(rangeService, range);
            Object.assign(allCellsToFlash, cellsToFlash);
            data.push(this.buildExportParams({
                columns: range.columns,
                rowPositions: rowPositions,
                includeHeaders: params.includeHeaders,
                includeGroupHeaders: params.includeGroupHeaders
            }));
        });
        return {
            data: data.join("\n"),
            cellsToFlash: allCellsToFlash
        };
    }
    getRangeRowPositionsAndCellsToFlash(rangeService, range) {
        const rowPositions = [];
        const cellsToFlash = {};
        const startRow = rangeService.getRangeStartRow(range);
        const lastRow = rangeService.getRangeEndRow(range);
        let node = startRow;
        while(node){
            rowPositions.push(node);
            range.columns.forEach((column)=>{
                const { rowIndex: rowIndex, rowPinned: rowPinned } = node;
                const cellId = this.cellPositionUtils.createIdFromValues({
                    rowIndex: rowIndex,
                    column: column,
                    rowPinned: rowPinned
                });
                cellsToFlash[cellId] = true;
            });
            if (this.rowPositionUtils.sameRow(node, lastRow)) break;
            node = this.cellNavigationService.getRowBelow(node);
        }
        return {
            rowPositions: rowPositions,
            cellsToFlash: cellsToFlash
        };
    }
    getCellsToFlashFromRowNodes(rowNodes) {
        const allDisplayedColumns = this.columnModel.getAllDisplayedColumns();
        const cellsToFlash = {};
        for(let i = 0; i < rowNodes.length; i++){
            const { rowIndex: rowIndex, rowPinned: rowPinned } = rowNodes[i];
            if (rowIndex == null) continue;
            for(let j = 0; j < allDisplayedColumns.length; j++){
                const column = allDisplayedColumns[j];
                const cellId = this.cellPositionUtils.createIdFromValues({
                    rowIndex: rowIndex,
                    column: column,
                    rowPinned: rowPinned
                });
                cellsToFlash[cellId] = true;
            }
        }
        return cellsToFlash;
    }
    copyFocusedCellToClipboard(params = {}) {
        const focusedCell = this.focusService.getFocusedCell();
        if (focusedCell == null) return;
        const cellId = this.cellPositionUtils.createId(focusedCell);
        const currentRow = {
            rowPinned: focusedCell.rowPinned,
            rowIndex: focusedCell.rowIndex
        };
        const column = focusedCell.column;
        const data = this.buildExportParams({
            columns: [
                column
            ],
            rowPositions: [
                currentRow
            ],
            includeHeaders: params.includeHeaders,
            includeGroupHeaders: params.includeGroupHeaders
        });
        this.copyDataToClipboard(data);
        this.dispatchFlashCells({
            [cellId]: true
        });
    }
    copySelectedRowsToClipboard(params = {}) {
        const { columnKeys: columnKeys, includeHeaders: includeHeaders, includeGroupHeaders: includeGroupHeaders } = params;
        const data = this.buildExportParams({
            columns: columnKeys,
            includeHeaders: includeHeaders,
            includeGroupHeaders: includeGroupHeaders
        });
        this.copyDataToClipboard(data);
        const rowNodes = this.selectionService.getSelectedNodes() || [];
        this.dispatchFlashCells(this.getCellsToFlashFromRowNodes(rowNodes));
    }
    buildExportParams(params) {
        const { columns: columns, rowPositions: rowPositions, includeHeaders: includeHeaders = false, includeGroupHeaders: includeGroupHeaders = false } = params;
        const exportParams = {
            columnKeys: columns,
            rowPositions: rowPositions,
            skipColumnHeaders: !includeHeaders,
            skipColumnGroupHeaders: !includeGroupHeaders,
            suppressQuotes: true,
            columnSeparator: this.getClipboardDelimiter(),
            onlySelected: !rowPositions,
            processCellCallback: this.gos.getCallback("processCellForClipboard"),
            processRowGroupCallback: (params2)=>this.processRowGroupCallback(params2),
            processHeaderCallback: this.gos.getCallback("processHeaderForClipboard"),
            processGroupHeaderCallback: this.gos.getCallback("processGroupHeaderForClipboard")
        };
        return this.csvCreator.getDataAsCsv(exportParams, true);
    }
    processRowGroupCallback(params) {
        const { node: node, column: column } = params;
        const isTreeData = this.gos.get("treeData");
        const isSuppressGroupMaintainValueType = this.gos.get("suppressGroupMaintainValueType");
        const getValueFromNode = ()=>{
            var _a, _b;
            if (isTreeData || isSuppressGroupMaintainValueType || !column) return node.key;
            const value2 = (_a = node.groupData) == null ? void 0 : _a[column.getId()];
            if (!value2 || !node.rowGroupColumn || node.rowGroupColumn.getColDef().useValueFormatterForExport === false) return value2;
            return (_b = this.valueService.formatValue(node.rowGroupColumn, node, value2)) != null ? _b : value2;
        };
        let value = getValueFromNode();
        if (params.node.footer) {
            let suffix = "";
            if (value && value.length) suffix = ` ${value}`;
            value = `Total${suffix}`;
        }
        const processCellForClipboard = this.gos.getCallback("processCellForClipboard");
        if (processCellForClipboard) {
            let column2 = node.rowGroupColumn;
            if (!column2 && node.footer && node.level === -1) column2 = this.columnModel.getRowGroupColumns()[0];
            return processCellForClipboard({
                value: value,
                node: node,
                column: column2,
                type: "clipboard",
                formatValue: (valueToFormat)=>{
                    var _a;
                    return (_a = this.valueService.formatValue(column2, node, valueToFormat)) != null ? _a : valueToFormat;
                },
                parseValue: (valueToParse)=>this.valueService.parseValue(column2, node, valueToParse, this.valueService.getValue(column2, node))
            });
        }
        return value;
    }
    dispatchFlashCells(cellsToFlash) {
        window.setTimeout(()=>{
            const event = {
                type: (0, $jIDNV.Events).EVENT_FLASH_CELLS,
                cells: cellsToFlash
            };
            this.eventService.dispatchEvent(event);
        }, 0);
    }
    processCell(rowNode, column, value, type, func, canParse, canFormat) {
        var _a;
        if (func) {
            const params = {
                column: column,
                node: rowNode,
                value: value,
                type: type,
                formatValue: (valueToFormat)=>{
                    var _a2;
                    return (_a2 = this.valueService.formatValue(column, rowNode != null ? rowNode : null, valueToFormat)) != null ? _a2 : valueToFormat;
                },
                parseValue: (valueToParse)=>this.valueService.parseValue(column, rowNode != null ? rowNode : null, valueToParse, this.valueService.getValue(column, rowNode))
            };
            return func(params);
        }
        if (canParse && column.getColDef().useValueParserForImport !== false) return this.valueService.parseValue(column, rowNode != null ? rowNode : null, value, this.valueService.getValue(column, rowNode));
        if (canFormat && column.getColDef().useValueFormatterForExport !== false) return (_a = this.valueService.formatValue(column, rowNode != null ? rowNode : null, value)) != null ? _a : value;
        return value;
    }
    copyDataToClipboard(data) {
        const userProvidedFunc = this.gos.getCallback("sendToClipboard");
        if (userProvidedFunc) {
            userProvidedFunc({
                data: data
            });
            return;
        }
        const allowNavigator = !this.gos.get("suppressClipboardApi");
        if (allowNavigator && navigator.clipboard) {
            navigator.clipboard.writeText(data).catch((e)=>{
                (0, $jIDNV._).doOnce(()=>{
                    console.warn(e);
                    console.warn($5b7ccabde48fae90$var$apiError("writeText"));
                }, "clipboardApiError");
                this.copyDataToClipboardLegacy(data);
            });
            return;
        }
        this.copyDataToClipboardLegacy(data);
    }
    copyDataToClipboardLegacy(data) {
        this.executeOnTempElement((element)=>{
            const eDocument = this.gos.getDocument();
            const focusedElementBefore = this.gos.getActiveDomElement();
            element.value = data || " ";
            element.select();
            element.focus({
                preventScroll: true
            });
            const result = eDocument.execCommand("copy");
            if (!result) console.warn("AG Grid: Browser did not allow document.execCommand('copy'). Ensure api.copySelectedRowsToClipboard() is invoked via a user event, i.e. button click, otherwise the browser will prevent it for security reasons.");
            if (focusedElementBefore != null && focusedElementBefore.focus != null) focusedElementBefore.focus({
                preventScroll: true
            });
        });
    }
    executeOnTempElement(callbackNow, callbackAfter) {
        const eDoc = this.gos.getDocument();
        const eTempInput = eDoc.createElement("textarea");
        eTempInput.style.width = "1px";
        eTempInput.style.height = "1px";
        eTempInput.style.top = eDoc.documentElement.scrollTop + "px";
        eTempInput.style.left = eDoc.documentElement.scrollLeft + "px";
        eTempInput.style.position = "absolute";
        eTempInput.style.opacity = "0";
        const guiRoot = this.gridCtrl.getGui();
        guiRoot.appendChild(eTempInput);
        try {
            callbackNow(eTempInput);
        } catch (err) {
            console.warn("AG Grid: Browser does not support document.execCommand('copy') for clipboard operations");
        }
        if (callbackAfter) window.setTimeout(()=>{
            callbackAfter(eTempInput);
            guiRoot.removeChild(eTempInput);
        }, 100);
        else guiRoot.removeChild(eTempInput);
    }
    getRangeSize(rangeService) {
        const ranges = rangeService.getCellRanges();
        let startRangeIndex = 0;
        let endRangeIndex = 0;
        if (ranges.length > 0) {
            startRangeIndex = rangeService.getRangeStartRow(ranges[0]).rowIndex;
            endRangeIndex = rangeService.getRangeEndRow(ranges[0]).rowIndex;
        }
        return startRangeIndex - endRangeIndex + 1;
    }
};
$5b7ccabde48fae90$var$__decorateClass5([
    (0, $jIDNV.Autowired)("csvCreator")
], $5b7ccabde48fae90$var$ClipboardService.prototype, "csvCreator", 2);
$5b7ccabde48fae90$var$__decorateClass5([
    (0, $jIDNV.Autowired)("loggerFactory")
], $5b7ccabde48fae90$var$ClipboardService.prototype, "loggerFactory", 2);
$5b7ccabde48fae90$var$__decorateClass5([
    (0, $jIDNV.Autowired)("selectionService")
], $5b7ccabde48fae90$var$ClipboardService.prototype, "selectionService", 2);
$5b7ccabde48fae90$var$__decorateClass5([
    (0, $jIDNV.Autowired)("rowModel")
], $5b7ccabde48fae90$var$ClipboardService.prototype, "rowModel", 2);
$5b7ccabde48fae90$var$__decorateClass5([
    (0, $jIDNV.Autowired)("ctrlsService")
], $5b7ccabde48fae90$var$ClipboardService.prototype, "ctrlsService", 2);
$5b7ccabde48fae90$var$__decorateClass5([
    (0, $jIDNV.Autowired)("valueService")
], $5b7ccabde48fae90$var$ClipboardService.prototype, "valueService", 2);
$5b7ccabde48fae90$var$__decorateClass5([
    (0, $jIDNV.Autowired)("focusService")
], $5b7ccabde48fae90$var$ClipboardService.prototype, "focusService", 2);
$5b7ccabde48fae90$var$__decorateClass5([
    (0, $jIDNV.Autowired)("rowRenderer")
], $5b7ccabde48fae90$var$ClipboardService.prototype, "rowRenderer", 2);
$5b7ccabde48fae90$var$__decorateClass5([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$ClipboardService.prototype, "columnModel", 2);
$5b7ccabde48fae90$var$__decorateClass5([
    (0, $jIDNV.Autowired)("cellNavigationService")
], $5b7ccabde48fae90$var$ClipboardService.prototype, "cellNavigationService", 2);
$5b7ccabde48fae90$var$__decorateClass5([
    (0, $jIDNV.Autowired)("cellPositionUtils")
], $5b7ccabde48fae90$var$ClipboardService.prototype, "cellPositionUtils", 2);
$5b7ccabde48fae90$var$__decorateClass5([
    (0, $jIDNV.Autowired)("rowPositionUtils")
], $5b7ccabde48fae90$var$ClipboardService.prototype, "rowPositionUtils", 2);
$5b7ccabde48fae90$var$__decorateClass5([
    (0, $jIDNV.Optional)("rangeService")
], $5b7ccabde48fae90$var$ClipboardService.prototype, "rangeService", 2);
$5b7ccabde48fae90$var$__decorateClass5([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$ClipboardService.prototype, "init", 1);
$5b7ccabde48fae90$var$ClipboardService = $5b7ccabde48fae90$var$__decorateClass5([
    (0, $jIDNV.Bean)("clipboardService")
], $5b7ccabde48fae90$var$ClipboardService);
var $5b7ccabde48fae90$var$VERSION5 = "31.3.4";
var $5b7ccabde48fae90$export$3a36bd45ca02edda = {
    version: $5b7ccabde48fae90$var$VERSION5,
    moduleName: (0, $jIDNV.ModuleNames).ClipboardModule,
    beans: [
        $5b7ccabde48fae90$var$ClipboardService
    ],
    dependantModules: [
        $5b7ccabde48fae90$export$3a6d13add8617801,
        (0, $jIDNV.CsvExportModule)
    ]
};
var $5b7ccabde48fae90$var$__defProp6 = Object.defineProperty;
var $5b7ccabde48fae90$var$__defProps4 = Object.defineProperties;
var $5b7ccabde48fae90$var$__getOwnPropDesc6 = Object.getOwnPropertyDescriptor;
var $5b7ccabde48fae90$var$__getOwnPropDescs4 = Object.getOwnPropertyDescriptors;
var $5b7ccabde48fae90$var$__getOwnPropSymbols4 = Object.getOwnPropertySymbols;
var $5b7ccabde48fae90$var$__hasOwnProp5 = Object.prototype.hasOwnProperty;
var $5b7ccabde48fae90$var$__propIsEnum4 = Object.prototype.propertyIsEnumerable;
var $5b7ccabde48fae90$var$__defNormalProp4 = (obj, key, value)=>key in obj ? $5b7ccabde48fae90$var$__defProp6(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5b7ccabde48fae90$var$__spreadValues4 = (a, b)=>{
    for(var prop in b || (b = {}))if ($5b7ccabde48fae90$var$__hasOwnProp5.call(b, prop)) $5b7ccabde48fae90$var$__defNormalProp4(a, prop, b[prop]);
    if ($5b7ccabde48fae90$var$__getOwnPropSymbols4) {
        for (var prop of $5b7ccabde48fae90$var$__getOwnPropSymbols4(b))if ($5b7ccabde48fae90$var$__propIsEnum4.call(b, prop)) $5b7ccabde48fae90$var$__defNormalProp4(a, prop, b[prop]);
    }
    return a;
};
var $5b7ccabde48fae90$var$__spreadProps4 = (a, b)=>$5b7ccabde48fae90$var$__defProps4(a, $5b7ccabde48fae90$var$__getOwnPropDescs4(b));
var $5b7ccabde48fae90$var$__decorateClass6 = (decorators, target, key, kind)=>{
    var result = kind > 1 ? void 0 : kind ? $5b7ccabde48fae90$var$__getOwnPropDesc6(target, key) : target;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
    if (kind && result) $5b7ccabde48fae90$var$__defProp6(target, key, result);
    return result;
};
var $5b7ccabde48fae90$var$AggregationStage = class extends (0, $jIDNV.BeanStub) {
    // it's possible to recompute the aggregate without doing the other parts
    // + api.refreshClientSideRowModel('aggregate')
    execute(params) {
        const noValueColumns = (0, $jIDNV._).missingOrEmpty(this.columnModel.getValueColumns());
        const noUserAgg = !this.gos.getCallback("getGroupRowAgg");
        const changedPathActive = params.changedPath && params.changedPath.isActive();
        if (noValueColumns && noUserAgg && changedPathActive) return;
        const aggDetails = this.createAggDetails(params);
        this.recursivelyCreateAggData(aggDetails);
    }
    createAggDetails(params) {
        const pivotActive = this.columnModel.isPivotActive();
        const measureColumns = this.columnModel.getValueColumns();
        const pivotColumns = pivotActive ? this.columnModel.getPivotColumns() : [];
        const aggDetails = {
            alwaysAggregateAtRootLevel: this.gos.get("alwaysAggregateAtRootLevel"),
            groupIncludeTotalFooter: !!this.gos.getGrandTotalRow(),
            changedPath: params.changedPath,
            valueColumns: measureColumns,
            pivotColumns: pivotColumns,
            filteredOnly: !this.isSuppressAggFilteredOnly(),
            userAggFunc: this.gos.getCallback("getGroupRowAgg")
        };
        return aggDetails;
    }
    isSuppressAggFilteredOnly() {
        const isGroupAggFiltering = this.gos.getGroupAggFiltering() !== void 0;
        return isGroupAggFiltering || this.gos.get("suppressAggFilteredOnly");
    }
    recursivelyCreateAggData(aggDetails) {
        const callback = (rowNode)=>{
            const hasNoChildren = !rowNode.hasChildren();
            if (hasNoChildren) {
                if (rowNode.aggData) rowNode.setAggData(null);
                return;
            }
            const isRootNode = rowNode.level === -1;
            if (isRootNode && !aggDetails.groupIncludeTotalFooter) {
                const notPivoting = !this.columnModel.isPivotMode();
                if (!aggDetails.alwaysAggregateAtRootLevel && notPivoting) {
                    rowNode.setAggData(null);
                    return;
                }
            }
            this.aggregateRowNode(rowNode, aggDetails);
        };
        aggDetails.changedPath.forEachChangedNodeDepthFirst(callback, true);
    }
    aggregateRowNode(rowNode, aggDetails) {
        const measureColumnsMissing = aggDetails.valueColumns.length === 0;
        const pivotColumnsMissing = aggDetails.pivotColumns.length === 0;
        let aggResult;
        if (aggDetails.userAggFunc) aggResult = aggDetails.userAggFunc({
            nodes: rowNode.childrenAfterFilter
        });
        else if (measureColumnsMissing) aggResult = null;
        else if (pivotColumnsMissing) aggResult = this.aggregateRowNodeUsingValuesOnly(rowNode, aggDetails);
        else aggResult = this.aggregateRowNodeUsingValuesAndPivot(rowNode);
        rowNode.setAggData(aggResult);
        if (rowNode.sibling) rowNode.sibling.setAggData(aggResult);
    }
    aggregateRowNodeUsingValuesAndPivot(rowNode) {
        var _a, _b;
        const result = {};
        const secondaryColumns = (_a = this.columnModel.getSecondaryColumns()) != null ? _a : [];
        let canSkipTotalColumns = true;
        for(let i = 0; i < secondaryColumns.length; i++){
            const secondaryCol = secondaryColumns[i];
            const colDef = secondaryCol.getColDef();
            if (colDef.pivotTotalColumnIds != null) {
                canSkipTotalColumns = false;
                continue;
            }
            const keys = (_b = colDef.pivotKeys) != null ? _b : [];
            let values;
            if (rowNode.leafGroup) values = this.getValuesFromMappedSet(rowNode.childrenMapped, keys, colDef.pivotValueColumn);
            else values = this.getValuesPivotNonLeaf(rowNode, colDef.colId);
            result[colDef.colId] = this.aggregateValues(values, colDef.pivotValueColumn.getAggFunc(), colDef.pivotValueColumn, rowNode, secondaryCol);
        }
        if (!canSkipTotalColumns) for(let i = 0; i < secondaryColumns.length; i++){
            const secondaryCol = secondaryColumns[i];
            const colDef = secondaryCol.getColDef();
            if (colDef.pivotTotalColumnIds == null || !colDef.pivotTotalColumnIds.length) continue;
            const aggResults = colDef.pivotTotalColumnIds.map((currentColId)=>result[currentColId]);
            result[colDef.colId] = this.aggregateValues(aggResults, colDef.pivotValueColumn.getAggFunc(), colDef.pivotValueColumn, rowNode, secondaryCol);
        }
        return result;
    }
    aggregateRowNodeUsingValuesOnly(rowNode, aggDetails) {
        const result = {};
        const changedValueColumns = aggDetails.changedPath.isActive() ? aggDetails.changedPath.getValueColumnsForNode(rowNode, aggDetails.valueColumns) : aggDetails.valueColumns;
        const notChangedValueColumns = aggDetails.changedPath.isActive() ? aggDetails.changedPath.getNotValueColumnsForNode(rowNode, aggDetails.valueColumns) : null;
        const values2d = this.getValuesNormal(rowNode, changedValueColumns, aggDetails.filteredOnly);
        const oldValues = rowNode.aggData;
        changedValueColumns.forEach((valueColumn, index)=>{
            result[valueColumn.getId()] = this.aggregateValues(values2d[index], valueColumn.getAggFunc(), valueColumn, rowNode);
        });
        if (notChangedValueColumns && oldValues) notChangedValueColumns.forEach((valueColumn)=>{
            result[valueColumn.getId()] = oldValues[valueColumn.getId()];
        });
        return result;
    }
    getValuesPivotNonLeaf(rowNode, colId) {
        return rowNode.childrenAfterFilter.map((childNode)=>childNode.aggData[colId]);
    }
    getValuesFromMappedSet(mappedSet, keys, valueColumn) {
        let mapPointer = mappedSet;
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            mapPointer = mapPointer ? mapPointer[key] : null;
        }
        if (!mapPointer) return [];
        return mapPointer.map((rowNode)=>this.valueService.getValue(valueColumn, rowNode));
    }
    getValuesNormal(rowNode, valueColumns, filteredOnly) {
        const values = [];
        valueColumns.forEach(()=>values.push([]));
        const valueColumnCount = valueColumns.length;
        const nodeList = filteredOnly ? rowNode.childrenAfterFilter : rowNode.childrenAfterGroup;
        const rowCount = nodeList.length;
        for(let i = 0; i < rowCount; i++){
            const childNode = nodeList[i];
            for(let j = 0; j < valueColumnCount; j++){
                const valueColumn = valueColumns[j];
                const value = this.valueService.getValue(valueColumn, childNode);
                values[j].push(value);
            }
        }
        return values;
    }
    aggregateValues(values, aggFuncOrString, column, rowNode, pivotResultColumn) {
        const aggFunc = typeof aggFuncOrString === "string" ? this.aggFuncService.getAggFunc(aggFuncOrString) : aggFuncOrString;
        if (typeof aggFunc !== "function") {
            console.error(`AG Grid: unrecognised aggregation function ${aggFuncOrString}`);
            return null;
        }
        const aggFuncAny = aggFunc;
        const params = this.gos.addGridCommonParams({
            values: values,
            column: column,
            colDef: column ? column.getColDef() : void 0,
            pivotResultColumn: pivotResultColumn,
            rowNode: rowNode,
            data: rowNode ? rowNode.data : void 0
        });
        return aggFuncAny(params);
    }
};
$5b7ccabde48fae90$var$__decorateClass6([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$AggregationStage.prototype, "columnModel", 2);
$5b7ccabde48fae90$var$__decorateClass6([
    (0, $jIDNV.Autowired)("valueService")
], $5b7ccabde48fae90$var$AggregationStage.prototype, "valueService", 2);
$5b7ccabde48fae90$var$__decorateClass6([
    (0, $jIDNV.Autowired)("aggFuncService")
], $5b7ccabde48fae90$var$AggregationStage.prototype, "aggFuncService", 2);
$5b7ccabde48fae90$var$AggregationStage = $5b7ccabde48fae90$var$__decorateClass6([
    (0, $jIDNV.Bean)("aggregationStage")
], $5b7ccabde48fae90$var$AggregationStage);
var $5b7ccabde48fae90$var$BatchRemover = class {
    constructor(){
        this.allSets = {};
        this.allParents = [];
    }
    removeFromChildrenAfterGroup(parent, child) {
        const set2 = this.getSet(parent);
        set2.removeFromChildrenAfterGroup[child.id] = true;
    }
    isRemoveFromAllLeafChildren(parent, child) {
        const set2 = this.getSet(parent);
        return !!set2.removeFromAllLeafChildren[child.id];
    }
    preventRemoveFromAllLeafChildren(parent, child) {
        const set2 = this.getSet(parent);
        delete set2.removeFromAllLeafChildren[child.id];
    }
    removeFromAllLeafChildren(parent, child) {
        const set2 = this.getSet(parent);
        set2.removeFromAllLeafChildren[child.id] = true;
    }
    getSet(parent) {
        if (!this.allSets[parent.id]) {
            this.allSets[parent.id] = {
                removeFromAllLeafChildren: {},
                removeFromChildrenAfterGroup: {}
            };
            this.allParents.push(parent);
        }
        return this.allSets[parent.id];
    }
    getAllParents() {
        return this.allParents;
    }
    flush() {
        this.allParents.forEach((parent)=>{
            const nodeDetails = this.allSets[parent.id];
            parent.childrenAfterGroup = parent.childrenAfterGroup.filter((child)=>!nodeDetails.removeFromChildrenAfterGroup[child.id]);
            parent.allLeafChildren = parent.allLeafChildren.filter((child)=>!nodeDetails.removeFromAllLeafChildren[child.id]);
            parent.updateHasChildren();
            if (parent.sibling) {
                parent.sibling.childrenAfterGroup = parent.childrenAfterGroup;
                parent.sibling.allLeafChildren = parent.allLeafChildren;
            }
        });
        this.allSets = {};
        this.allParents.length = 0;
    }
};
var $5b7ccabde48fae90$var$GroupStage = class extends (0, $jIDNV.BeanStub) {
    execute(params) {
        const details = this.createGroupingDetails(params);
        if (details.transactions) this.handleTransaction(details);
        else {
            const afterColsChanged = params.afterColumnsChanged === true;
            this.shotgunResetEverything(details, afterColsChanged);
        }
        if (!details.usingTreeData) {
            this.positionLeafsAndGroups(params.changedPath);
            this.orderGroups(details);
        }
        this.selectableService.updateSelectableAfterGrouping();
    }
    positionLeafsAndGroups(changedPath) {
        changedPath.forEachChangedNodeDepthFirst((group)=>{
            if (group.childrenAfterGroup) {
                const leafNodes = [];
                const groupNodes = [];
                let unbalancedNode;
                group.childrenAfterGroup.forEach((row)=>{
                    var _a;
                    if (!((_a = row.childrenAfterGroup) == null ? void 0 : _a.length)) leafNodes.push(row);
                    else if (row.key === "" && !unbalancedNode) unbalancedNode = row;
                    else groupNodes.push(row);
                });
                if (unbalancedNode) groupNodes.push(unbalancedNode);
                group.childrenAfterGroup = [
                    ...leafNodes,
                    ...groupNodes
                ];
            }
        }, false);
    }
    createGroupingDetails(params) {
        var _a;
        const { rowNode: rowNode, changedPath: changedPath, rowNodeTransactions: rowNodeTransactions, rowNodeOrder: rowNodeOrder } = params;
        const usingTreeData = this.gos.get("treeData");
        const groupedCols = usingTreeData ? null : this.columnModel.getRowGroupColumns();
        const details = {
            // someone complained that the parent attribute was causing some change detection
            // to break in an angular add-on.  Taking the parent out breaks a cyclic dependency, hence this flag got introduced.
            includeParents: !this.gos.get("suppressParentsInRowNodes"),
            expandByDefault: this.gos.get("groupDefaultExpanded"),
            groupedCols: groupedCols,
            rootNode: rowNode,
            pivotMode: this.columnModel.isPivotMode(),
            groupedColCount: usingTreeData || !groupedCols ? 0 : groupedCols.length,
            rowNodeOrder: rowNodeOrder,
            transactions: rowNodeTransactions,
            changedPath: // if no transaction, then it's shotgun, changed path would be 'not active' at this point anyway
            changedPath,
            groupAllowUnbalanced: this.gos.get("groupAllowUnbalanced"),
            isGroupOpenByDefault: this.gos.getCallback("isGroupOpenByDefault"),
            initialGroupOrderComparator: this.gos.getCallback("initialGroupOrderComparator"),
            usingTreeData: usingTreeData,
            suppressGroupMaintainValueType: this.gos.get("suppressGroupMaintainValueType"),
            getDataPath: usingTreeData ? this.gos.get("getDataPath") : void 0,
            keyCreators: (_a = groupedCols == null ? void 0 : groupedCols.map((column)=>column.getColDef().keyCreator)) != null ? _a : []
        };
        return details;
    }
    handleTransaction(details) {
        details.transactions.forEach((tran)=>{
            const batchRemover = !details.usingTreeData ? new $5b7ccabde48fae90$var$BatchRemover() : void 0;
            if ((0, $jIDNV._).existsAndNotEmpty(tran.remove)) this.removeNodes(tran.remove, details, batchRemover);
            if ((0, $jIDNV._).existsAndNotEmpty(tran.update)) this.moveNodesInWrongPath(tran.update, details, batchRemover);
            if ((0, $jIDNV._).existsAndNotEmpty(tran.add)) this.insertNodes(tran.add, details, false);
            if (batchRemover) {
                const parentsWithChildrenRemoved = batchRemover.getAllParents().slice();
                batchRemover.flush();
                this.removeEmptyGroups(parentsWithChildrenRemoved, details);
            }
        });
        if (details.rowNodeOrder) this.sortChildren(details);
    }
    // this is used when doing delta updates, eg Redux, keeps nodes in right order
    sortChildren(details) {
        details.changedPath.forEachChangedNodeDepthFirst((node)=>{
            if (!node.childrenAfterGroup) return;
            const didSort = (0, $jIDNV._).sortRowNodesByOrder(node.childrenAfterGroup, details.rowNodeOrder);
            if (didSort) details.changedPath.addParentNode(node);
        }, false, true);
    }
    orderGroups(details) {
        const comparator = details.initialGroupOrderComparator;
        if ((0, $jIDNV._).exists(comparator)) recursiveSort(details.rootNode);
        function recursiveSort(rowNode) {
            const doSort = (0, $jIDNV._).exists(rowNode.childrenAfterGroup) && // we only want to sort groups, so we do not sort leafs (a leaf group has leafs as children)
            !rowNode.leafGroup;
            if (doSort) {
                rowNode.childrenAfterGroup.sort((nodeA, nodeB)=>comparator({
                        nodeA: nodeA,
                        nodeB: nodeB
                    }));
                rowNode.childrenAfterGroup.forEach((childNode)=>recursiveSort(childNode));
            }
        }
    }
    getExistingPathForNode(node, details) {
        const res = [];
        let pointer = details.usingTreeData ? node : node.parent;
        while(pointer && pointer !== details.rootNode){
            res.push({
                key: pointer.key,
                rowGroupColumn: pointer.rowGroupColumn,
                field: pointer.field
            });
            pointer = pointer.parent;
        }
        res.reverse();
        return res;
    }
    moveNodesInWrongPath(childNodes, details, batchRemover) {
        childNodes.forEach((childNode)=>{
            if (details.changedPath.isActive()) details.changedPath.addParentNode(childNode.parent);
            const infoToKeyMapper = (item)=>item.key;
            const oldPath = this.getExistingPathForNode(childNode, details).map(infoToKeyMapper);
            const newPath = this.getGroupInfo(childNode, details).map(infoToKeyMapper);
            const nodeInCorrectPath = (0, $jIDNV._).areEqual(oldPath, newPath);
            if (!nodeInCorrectPath) this.moveNode(childNode, details, batchRemover);
        });
    }
    moveNode(childNode, details, batchRemover) {
        this.removeNodesInStages([
            childNode
        ], details, batchRemover);
        this.insertOneNode(childNode, details, true, batchRemover);
        childNode.setData(childNode.data);
        if (details.changedPath.isActive()) {
            const newParent = childNode.parent;
            details.changedPath.addParentNode(newParent);
        }
    }
    removeNodes(leafRowNodes, details, batchRemover) {
        this.removeNodesInStages(leafRowNodes, details, batchRemover);
        if (details.changedPath.isActive()) leafRowNodes.forEach((rowNode)=>details.changedPath.addParentNode(rowNode.parent));
    }
    removeNodesInStages(leafRowNodes, details, batchRemover) {
        this.removeNodesFromParents(leafRowNodes, details, batchRemover);
        if (details.usingTreeData) {
            this.postRemoveCreateFillerNodes(leafRowNodes, details);
            const nodeParents = leafRowNodes.map((n)=>n.parent);
            this.removeEmptyGroups(nodeParents, details);
        }
    }
    forEachParentGroup(details, group, callback) {
        let pointer = group;
        while(pointer && pointer !== details.rootNode){
            callback(pointer);
            pointer = pointer.parent;
        }
    }
    removeNodesFromParents(nodesToRemove, details, provided) {
        const batchRemoverIsLocal = provided == null;
        const batchRemoverToUse = provided ? provided : new $5b7ccabde48fae90$var$BatchRemover();
        nodesToRemove.forEach((nodeToRemove)=>{
            this.removeFromParent(nodeToRemove, batchRemoverToUse);
            this.forEachParentGroup(details, nodeToRemove.parent, (parentNode)=>{
                batchRemoverToUse.removeFromAllLeafChildren(parentNode, nodeToRemove);
            });
        });
        if (batchRemoverIsLocal) batchRemoverToUse.flush();
    }
    postRemoveCreateFillerNodes(nodesToRemove, details) {
        nodesToRemove.forEach((nodeToRemove)=>{
            const replaceWithGroup = nodeToRemove.hasChildren();
            if (replaceWithGroup) {
                const oldPath = this.getExistingPathForNode(nodeToRemove, details);
                const newGroupNode = this.findParentForNode(nodeToRemove, oldPath, details);
                newGroupNode.expanded = nodeToRemove.expanded;
                newGroupNode.allLeafChildren = nodeToRemove.allLeafChildren;
                newGroupNode.childrenAfterGroup = nodeToRemove.childrenAfterGroup;
                newGroupNode.childrenMapped = nodeToRemove.childrenMapped;
                newGroupNode.updateHasChildren();
                newGroupNode.childrenAfterGroup.forEach((rowNode)=>rowNode.parent = newGroupNode);
            }
        });
    }
    removeEmptyGroups(possibleEmptyGroups, details) {
        let checkAgain = true;
        const groupShouldBeRemoved = (rowNode)=>{
            const mapKey = this.getChildrenMappedKey(rowNode.key, rowNode.rowGroupColumn);
            const parentRowNode = rowNode.parent;
            const groupAlreadyRemoved = parentRowNode && parentRowNode.childrenMapped ? !parentRowNode.childrenMapped[mapKey] : true;
            if (groupAlreadyRemoved) return false;
            return !!rowNode.isEmptyRowGroupNode();
        };
        while(checkAgain){
            checkAgain = false;
            const batchRemover = new $5b7ccabde48fae90$var$BatchRemover();
            possibleEmptyGroups.forEach((possibleEmptyGroup)=>{
                this.forEachParentGroup(details, possibleEmptyGroup, (rowNode)=>{
                    if (groupShouldBeRemoved(rowNode)) {
                        checkAgain = true;
                        this.removeFromParent(rowNode, batchRemover);
                        rowNode.setSelectedParams({
                            newValue: false,
                            source: "rowGroupChanged"
                        });
                    }
                });
            });
            batchRemover.flush();
        }
    }
    // removes the node from the parent by:
    // a) removing from childrenAfterGroup (using batchRemover if present, otherwise immediately)
    // b) removing from childrenMapped (immediately)
    // c) setRowTop(null) - as the rowRenderer uses this to know the RowNode is no longer needed
    // d) setRowIndex(null) - as the rowNode will no longer be displayed.
    removeFromParent(child, batchRemover) {
        if (child.parent) {
            if (batchRemover) batchRemover.removeFromChildrenAfterGroup(child.parent, child);
            else {
                (0, $jIDNV._).removeFromArray(child.parent.childrenAfterGroup, child);
                child.parent.updateHasChildren();
            }
        }
        const mapKey = this.getChildrenMappedKey(child.key, child.rowGroupColumn);
        if (child.parent && child.parent.childrenMapped) child.parent.childrenMapped[mapKey] = void 0;
        child.setRowTop(null);
        child.setRowIndex(null);
    }
    addToParent(child, parent) {
        const mapKey = this.getChildrenMappedKey(child.key, child.rowGroupColumn);
        if (parent) {
            const children = parent.childrenMapped != null;
            if (children) parent.childrenMapped[mapKey] = child;
            parent.childrenAfterGroup.push(child);
            parent.updateHasChildren();
        }
    }
    areGroupColsEqual(d1, d2) {
        if (d1 == null || d2 == null || d1.pivotMode !== d2.pivotMode) return false;
        return (0, $jIDNV._).areEqual(d1.groupedCols, d2.groupedCols) && (0, $jIDNV._).areEqual(d1.keyCreators, d2.keyCreators);
    }
    checkAllGroupDataAfterColsChanged(details) {
        const recurse = (rowNodes)=>{
            if (!rowNodes) return;
            rowNodes.forEach((rowNode)=>{
                const isLeafNode = !details.usingTreeData && !rowNode.group;
                if (isLeafNode) return;
                const groupInfo = {
                    field: rowNode.field,
                    key: rowNode.key,
                    rowGroupColumn: rowNode.rowGroupColumn,
                    leafNode: rowNode.allLeafChildren[0]
                };
                this.setGroupData(rowNode, groupInfo, details);
                recurse(rowNode.childrenAfterGroup);
            });
        };
        recurse(details.rootNode.childrenAfterGroup);
    }
    shotgunResetEverything(details, afterColumnsChanged) {
        if (this.noChangeInGroupingColumns(details, afterColumnsChanged)) return;
        this.selectionService.filterFromSelection((node)=>node && !node.group);
        const { rootNode: rootNode, groupedCols: groupedCols } = details;
        rootNode.leafGroup = details.usingTreeData ? false : groupedCols.length === 0;
        rootNode.childrenAfterGroup = [];
        rootNode.childrenMapped = {};
        rootNode.updateHasChildren();
        const sibling = rootNode.sibling;
        if (sibling) {
            sibling.childrenAfterGroup = rootNode.childrenAfterGroup;
            sibling.childrenMapped = rootNode.childrenMapped;
        }
        this.insertNodes(rootNode.allLeafChildren, details, false);
    }
    noChangeInGroupingColumns(details, afterColumnsChanged) {
        let noFurtherProcessingNeeded = false;
        const groupDisplayColumns = this.columnModel.getGroupDisplayColumns();
        const newGroupDisplayColIds = groupDisplayColumns ? groupDisplayColumns.map((c)=>c.getId()).join("-") : "";
        if (afterColumnsChanged) {
            noFurtherProcessingNeeded = details.usingTreeData || this.areGroupColsEqual(details, this.oldGroupingDetails);
            if (this.oldGroupDisplayColIds !== newGroupDisplayColIds) this.checkAllGroupDataAfterColsChanged(details);
        }
        this.oldGroupingDetails = details;
        this.oldGroupDisplayColIds = newGroupDisplayColIds;
        return noFurtherProcessingNeeded;
    }
    insertNodes(newRowNodes, details, isMove) {
        newRowNodes.forEach((rowNode)=>{
            this.insertOneNode(rowNode, details, isMove);
            if (details.changedPath.isActive()) details.changedPath.addParentNode(rowNode.parent);
        });
    }
    insertOneNode(childNode, details, isMove, batchRemover) {
        const path = this.getGroupInfo(childNode, details);
        const parentGroup = this.findParentForNode(childNode, path, details, batchRemover);
        if (!parentGroup.group) console.warn(`AG Grid: duplicate group keys for row data, keys should be unique`, [
            parentGroup.data,
            childNode.data
        ]);
        if (details.usingTreeData) this.swapGroupWithUserNode(parentGroup, childNode, isMove);
        else {
            childNode.parent = parentGroup;
            childNode.level = path.length;
            parentGroup.childrenAfterGroup.push(childNode);
            parentGroup.updateHasChildren();
        }
    }
    findParentForNode(childNode, path, details, batchRemover) {
        let nextNode = details.rootNode;
        path.forEach((groupInfo, level)=>{
            nextNode = this.getOrCreateNextNode(nextNode, groupInfo, level, details);
            if (!(batchRemover == null ? void 0 : batchRemover.isRemoveFromAllLeafChildren(nextNode, childNode))) nextNode.allLeafChildren.push(childNode);
            else batchRemover == null || batchRemover.preventRemoveFromAllLeafChildren(nextNode, childNode);
        });
        return nextNode;
    }
    swapGroupWithUserNode(fillerGroup, userGroup, isMove) {
        userGroup.parent = fillerGroup.parent;
        userGroup.key = fillerGroup.key;
        userGroup.field = fillerGroup.field;
        userGroup.groupData = fillerGroup.groupData;
        userGroup.level = fillerGroup.level;
        if (!isMove) userGroup.expanded = fillerGroup.expanded;
        userGroup.leafGroup = fillerGroup.leafGroup;
        userGroup.rowGroupIndex = fillerGroup.rowGroupIndex;
        userGroup.allLeafChildren = fillerGroup.allLeafChildren;
        userGroup.childrenAfterGroup = fillerGroup.childrenAfterGroup;
        userGroup.childrenMapped = fillerGroup.childrenMapped;
        userGroup.sibling = fillerGroup.sibling;
        userGroup.updateHasChildren();
        this.removeFromParent(fillerGroup);
        userGroup.childrenAfterGroup.forEach((rowNode)=>rowNode.parent = userGroup);
        this.addToParent(userGroup, fillerGroup.parent);
    }
    getOrCreateNextNode(parentGroup, groupInfo, level, details) {
        const key = this.getChildrenMappedKey(groupInfo.key, groupInfo.rowGroupColumn);
        let nextNode = parentGroup.childrenMapped ? parentGroup.childrenMapped[key] : void 0;
        if (!nextNode) {
            nextNode = this.createGroup(groupInfo, parentGroup, level, details);
            this.addToParent(nextNode, parentGroup);
        }
        return nextNode;
    }
    createGroup(groupInfo, parent, level, details) {
        const groupNode = new (0, $jIDNV.RowNode)(this.beans);
        groupNode.group = true;
        groupNode.field = groupInfo.field;
        groupNode.rowGroupColumn = groupInfo.rowGroupColumn;
        this.setGroupData(groupNode, groupInfo, details);
        groupNode.key = groupInfo.key;
        groupNode.id = this.createGroupId(groupNode, parent, details.usingTreeData, level);
        groupNode.level = level;
        groupNode.leafGroup = details.usingTreeData ? false : level === details.groupedColCount - 1;
        groupNode.allLeafChildren = [];
        groupNode.setAllChildrenCount(0);
        groupNode.rowGroupIndex = details.usingTreeData ? null : level;
        groupNode.childrenAfterGroup = [];
        groupNode.childrenMapped = {};
        groupNode.updateHasChildren();
        groupNode.parent = details.includeParents ? parent : null;
        this.setExpandedInitialValue(details, groupNode);
        return groupNode;
    }
    createGroupId(node, parent, usingTreeData, level) {
        let createGroupId;
        if (usingTreeData) createGroupId = (node2, parent2, level2)=>{
            if (level2 < 0) return null;
            const parentId = parent2 ? createGroupId(parent2, parent2.parent, level2 - 1) : null;
            return `${parentId == null ? "" : parentId + "-"}${level2}-${node2.key}`;
        };
        else createGroupId = (node2, parent2)=>{
            if (!node2.rowGroupColumn) return null;
            const parentId = parent2 ? createGroupId(parent2, parent2.parent, 0) : null;
            return `${parentId == null ? "" : parentId + "-"}${node2.rowGroupColumn.getColId()}-${node2.key}`;
        };
        return (0, $jIDNV.RowNode).ID_PREFIX_ROW_GROUP + createGroupId(node, parent, level);
    }
    setGroupData(groupNode, groupInfo, details) {
        groupNode.groupData = {};
        const groupDisplayCols = this.columnModel.getGroupDisplayColumns();
        groupDisplayCols.forEach((col)=>{
            const isTreeData = details.usingTreeData;
            if (isTreeData) {
                groupNode.groupData[col.getColId()] = groupInfo.key;
                return;
            }
            const groupColumn = groupNode.rowGroupColumn;
            const isRowGroupDisplayed = groupColumn !== null && col.isRowGroupDisplayed(groupColumn.getId());
            if (isRowGroupDisplayed) {
                if (details.suppressGroupMaintainValueType) groupNode.groupData[col.getColId()] = groupInfo.key;
                else groupNode.groupData[col.getColId()] = this.valueService.getValue(groupColumn, groupInfo.leafNode);
            }
        });
    }
    getChildrenMappedKey(key, rowGroupColumn) {
        if (rowGroupColumn) return rowGroupColumn.getId() + "-" + key;
        return key;
    }
    setExpandedInitialValue(details, groupNode) {
        if (details.pivotMode && groupNode.leafGroup) {
            groupNode.expanded = false;
            return;
        }
        const userCallback = details.isGroupOpenByDefault;
        if (userCallback) {
            const params = {
                rowNode: groupNode,
                field: groupNode.field,
                key: groupNode.key,
                level: groupNode.level,
                rowGroupColumn: groupNode.rowGroupColumn
            };
            groupNode.expanded = userCallback(params) == true;
            return;
        }
        const { expandByDefault: expandByDefault } = details;
        if (details.expandByDefault === -1) {
            groupNode.expanded = true;
            return;
        }
        groupNode.expanded = groupNode.level < expandByDefault;
    }
    getGroupInfo(rowNode, details) {
        if (details.usingTreeData) return this.getGroupInfoFromCallback(rowNode, details);
        return this.getGroupInfoFromGroupColumns(rowNode, details);
    }
    getGroupInfoFromCallback(rowNode, details) {
        const keys = details.getDataPath ? details.getDataPath(rowNode.data) : null;
        if (keys === null || keys === void 0 || keys.length === 0) (0, $jIDNV._).warnOnce(`getDataPath() should not return an empty path for data ${rowNode.data}`);
        const groupInfoMapper = (key)=>({
                key: key,
                field: null,
                rowGroupColumn: null
            });
        return keys ? keys.map(groupInfoMapper) : [];
    }
    getGroupInfoFromGroupColumns(rowNode, details) {
        const res = [];
        details.groupedCols.forEach((groupCol)=>{
            let key = this.valueService.getKeyForNode(groupCol, rowNode);
            let keyExists = key !== null && key !== void 0 && key !== "";
            const createGroupForEmpty = details.pivotMode || !details.groupAllowUnbalanced;
            if (createGroupForEmpty && !keyExists) {
                key = "";
                keyExists = true;
            }
            if (keyExists) {
                const item = {
                    key: key,
                    field: groupCol.getColDef().field,
                    rowGroupColumn: groupCol,
                    leafNode: rowNode
                };
                res.push(item);
            }
        });
        return res;
    }
};
$5b7ccabde48fae90$var$__decorateClass6([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$GroupStage.prototype, "columnModel", 2);
$5b7ccabde48fae90$var$__decorateClass6([
    (0, $jIDNV.Autowired)("selectableService")
], $5b7ccabde48fae90$var$GroupStage.prototype, "selectableService", 2);
$5b7ccabde48fae90$var$__decorateClass6([
    (0, $jIDNV.Autowired)("valueService")
], $5b7ccabde48fae90$var$GroupStage.prototype, "valueService", 2);
$5b7ccabde48fae90$var$__decorateClass6([
    (0, $jIDNV.Autowired)("beans")
], $5b7ccabde48fae90$var$GroupStage.prototype, "beans", 2);
$5b7ccabde48fae90$var$__decorateClass6([
    (0, $jIDNV.Autowired)("selectionService")
], $5b7ccabde48fae90$var$GroupStage.prototype, "selectionService", 2);
$5b7ccabde48fae90$var$GroupStage = $5b7ccabde48fae90$var$__decorateClass6([
    (0, $jIDNV.Bean)("groupStage")
], $5b7ccabde48fae90$var$GroupStage);
var $5b7ccabde48fae90$var$PivotColDefService = class extends (0, $jIDNV.BeanStub) {
    init() {
        const getFieldSeparator = ()=>{
            var _a;
            return (_a = this.gos.get("serverSidePivotResultFieldSeparator")) != null ? _a : "_";
        };
        this.fieldSeparator = getFieldSeparator();
        this.addManagedPropertyListener("serverSidePivotResultFieldSeparator", ()=>{
            this.fieldSeparator = getFieldSeparator();
        });
        const getPivotDefaultExpanded = ()=>this.gos.get("pivotDefaultExpanded");
        this.pivotDefaultExpanded = getPivotDefaultExpanded();
        this.addManagedPropertyListener("pivotDefaultExpanded", ()=>{
            this.pivotDefaultExpanded = getPivotDefaultExpanded();
        });
    }
    createPivotColumnDefs(uniqueValues) {
        const pivotColumnGroupDefs = this.createPivotColumnsFromUniqueValues(uniqueValues);
        function extractColDefs(input, arr = []) {
            input.forEach((def)=>{
                if (def.children !== void 0) extractColDefs(def.children, arr);
                else arr.push(def);
            });
            return arr;
        }
        const pivotColumnDefs = extractColDefs(pivotColumnGroupDefs);
        this.addRowGroupTotals(pivotColumnGroupDefs, pivotColumnDefs);
        this.addExpandablePivotGroups(pivotColumnGroupDefs, pivotColumnDefs);
        this.addPivotTotalsToGroups(pivotColumnGroupDefs, pivotColumnDefs);
        const pivotColumnDefsClone = pivotColumnDefs.map((colDef)=>(0, $jIDNV._).cloneObject(colDef));
        return {
            pivotColumnGroupDefs: pivotColumnGroupDefs,
            pivotColumnDefs: pivotColumnDefsClone
        };
    }
    createPivotColumnsFromUniqueValues(uniqueValues) {
        const pivotColumns = this.columnModel.getPivotColumns();
        const maxDepth = pivotColumns.length;
        const pivotColumnGroupDefs = this.recursivelyBuildGroup(0, uniqueValues, [], maxDepth, pivotColumns);
        return pivotColumnGroupDefs;
    }
    recursivelyBuildGroup(index, uniqueValue, pivotKeys, maxDepth, primaryPivotColumns) {
        const measureColumns = this.columnModel.getValueColumns();
        if (index >= maxDepth) return this.buildMeasureCols(pivotKeys);
        const primaryPivotColumnDefs = primaryPivotColumns[index].getColDef();
        const comparator = this.headerNameComparator.bind(this, primaryPivotColumnDefs.pivotComparator);
        if (measureColumns.length === 1 && this.gos.get("removePivotHeaderRowWhenSingleValueColumn") && index === maxDepth - 1) {
            const leafCols = [];
            (0, $jIDNV._).iterateObject(uniqueValue, (key)=>{
                const newPivotKeys = [
                    ...pivotKeys,
                    key
                ];
                const colDef = this.createColDef(measureColumns[0], key, newPivotKeys);
                colDef.columnGroupShow = "open";
                leafCols.push(colDef);
            });
            leafCols.sort(comparator);
            return leafCols;
        }
        const groups = [];
        (0, $jIDNV._).iterateObject(uniqueValue, (key, value)=>{
            const openByDefault = this.pivotDefaultExpanded === -1 || index < this.pivotDefaultExpanded;
            const newPivotKeys = [
                ...pivotKeys,
                key
            ];
            groups.push({
                children: this.recursivelyBuildGroup(index + 1, value, newPivotKeys, maxDepth, primaryPivotColumns),
                headerName: key,
                pivotKeys: newPivotKeys,
                columnGroupShow: "open",
                openByDefault: openByDefault,
                groupId: this.generateColumnGroupId(newPivotKeys)
            });
        });
        groups.sort(comparator);
        return groups;
    }
    buildMeasureCols(pivotKeys) {
        const measureColumns = this.columnModel.getValueColumns();
        if (measureColumns.length === 0) return [
            this.createColDef(null, "-", pivotKeys)
        ];
        return measureColumns.map((measureCol)=>{
            const columnName = this.columnModel.getDisplayNameForColumn(measureCol, "header");
            return $5b7ccabde48fae90$var$__spreadProps4($5b7ccabde48fae90$var$__spreadValues4({}, this.createColDef(measureCol, columnName, pivotKeys)), {
                columnGroupShow: "open"
            });
        });
    }
    addExpandablePivotGroups(pivotColumnGroupDefs, pivotColumnDefs) {
        if (this.gos.get("suppressExpandablePivotGroups") || this.gos.get("pivotColumnGroupTotals")) return;
        const recursivelyAddSubTotals = (groupDef, currentPivotColumnDefs, acc)=>{
            const group = groupDef;
            if (group.children) {
                const childAcc = /* @__PURE__ */ new Map();
                group.children.forEach((grp)=>{
                    recursivelyAddSubTotals(grp, currentPivotColumnDefs, childAcc);
                });
                const firstGroup = !group.children.some((child)=>child.children);
                this.columnModel.getValueColumns().forEach((valueColumn)=>{
                    const columnName = this.columnModel.getDisplayNameForColumn(valueColumn, "header");
                    const totalColDef = this.createColDef(valueColumn, columnName, groupDef.pivotKeys);
                    totalColDef.pivotTotalColumnIds = childAcc.get(valueColumn.getColId());
                    totalColDef.columnGroupShow = "closed";
                    totalColDef.aggFunc = valueColumn.getAggFunc();
                    if (!firstGroup) {
                        const children = groupDef.children;
                        children.push(totalColDef);
                        currentPivotColumnDefs.push(totalColDef);
                    }
                });
                this.merge(acc, childAcc);
            } else {
                const def = groupDef;
                if (!def.pivotValueColumn) return;
                const pivotValueColId = def.pivotValueColumn.getColId();
                const arr = acc.has(pivotValueColId) ? acc.get(pivotValueColId) : [];
                arr.push(def.colId);
                acc.set(pivotValueColId, arr);
            }
        };
        pivotColumnGroupDefs.forEach((groupDef)=>{
            recursivelyAddSubTotals(groupDef, pivotColumnDefs, /* @__PURE__ */ new Map());
        });
    }
    addPivotTotalsToGroups(pivotColumnGroupDefs, pivotColumnDefs) {
        if (!this.gos.get("pivotColumnGroupTotals")) return;
        const insertAfter = this.gos.get("pivotColumnGroupTotals") === "after";
        const valueCols = this.columnModel.getValueColumns();
        const aggFuncs = valueCols.map((valueCol)=>valueCol.getAggFunc());
        if (!aggFuncs || aggFuncs.length < 1 || !this.sameAggFuncs(aggFuncs)) return;
        const valueColumn = valueCols[0];
        pivotColumnGroupDefs.forEach((groupDef)=>{
            this.recursivelyAddPivotTotal(groupDef, pivotColumnDefs, valueColumn, insertAfter);
        });
    }
    recursivelyAddPivotTotal(groupDef, pivotColumnDefs, valueColumn, insertAfter) {
        const group = groupDef;
        if (!group.children) {
            const def = groupDef;
            return def.colId ? [
                def.colId
            ] : null;
        }
        let colIds = [];
        group.children.forEach((grp)=>{
            const childColIds = this.recursivelyAddPivotTotal(grp, pivotColumnDefs, valueColumn, insertAfter);
            if (childColIds) colIds = colIds.concat(childColIds);
        });
        if (group.children.length > 1) {
            const localeTextFunc = this.localeService.getLocaleTextFunc();
            const headerName = localeTextFunc("pivotColumnGroupTotals", "Total");
            const totalColDef = this.createColDef(valueColumn, headerName, groupDef.pivotKeys, true);
            totalColDef.pivotTotalColumnIds = colIds;
            totalColDef.aggFunc = valueColumn.getAggFunc();
            const children = groupDef.children;
            insertAfter ? children.push(totalColDef) : children.unshift(totalColDef);
            pivotColumnDefs.push(totalColDef);
        }
        return colIds;
    }
    addRowGroupTotals(pivotColumnGroupDefs, pivotColumnDefs) {
        if (!this.gos.get("pivotRowTotals")) return;
        const insertAfter = this.gos.get("pivotRowTotals") === "after";
        const valueColumns = this.columnModel.getValueColumns();
        const valueCols = insertAfter ? valueColumns.slice() : valueColumns.slice().reverse();
        for(let i = 0; i < valueCols.length; i++){
            const valueCol = valueCols[i];
            let colIds = [];
            pivotColumnGroupDefs.forEach((groupDef)=>{
                colIds = colIds.concat(this.extractColIdsForValueColumn(groupDef, valueCol));
            });
            const withGroup = valueCols.length > 1 || !this.gos.get("removePivotHeaderRowWhenSingleValueColumn");
            this.createRowGroupTotal(pivotColumnGroupDefs, pivotColumnDefs, valueCol, colIds, insertAfter, withGroup);
        }
    }
    extractColIdsForValueColumn(groupDef, valueColumn) {
        const group = groupDef;
        if (!group.children) {
            const colDef = group;
            return colDef.pivotValueColumn === valueColumn && colDef.colId ? [
                colDef.colId
            ] : [];
        }
        let colIds = [];
        group.children.forEach((grp)=>{
            this.extractColIdsForValueColumn(grp, valueColumn);
            const childColIds = this.extractColIdsForValueColumn(grp, valueColumn);
            colIds = colIds.concat(childColIds);
        });
        return colIds;
    }
    createRowGroupTotal(parentChildren, pivotColumnDefs, valueColumn, colIds, insertAfter, addGroup) {
        const measureColumns = this.columnModel.getValueColumns();
        let colDef;
        if (measureColumns.length === 0) colDef = this.createColDef(null, "-", []);
        else {
            const columnName = this.columnModel.getDisplayNameForColumn(valueColumn, "header");
            colDef = this.createColDef(valueColumn, columnName, []);
            colDef.pivotTotalColumnIds = colIds;
        }
        colDef.colId = $5b7ccabde48fae90$var$PivotColDefService.PIVOT_ROW_TOTAL_PREFIX + colDef.colId;
        pivotColumnDefs.push(colDef);
        const valueGroup = addGroup ? {
            children: [
                colDef
            ],
            pivotKeys: [],
            groupId: `${$5b7ccabde48fae90$var$PivotColDefService.PIVOT_ROW_TOTAL_PREFIX}_pivotGroup_${valueColumn.getColId()}`
        } : colDef;
        insertAfter ? parentChildren.push(valueGroup) : parentChildren.unshift(valueGroup);
    }
    createColDef(valueColumn, headerName, pivotKeys, totalColumn = false) {
        const colDef = {};
        if (valueColumn) {
            const colDefToCopy = valueColumn.getColDef();
            Object.assign(colDef, colDefToCopy);
            colDef.hide = false;
        }
        colDef.headerName = headerName;
        colDef.colId = this.generateColumnId(pivotKeys || [], valueColumn && !totalColumn ? valueColumn.getColId() : "");
        colDef.field = colDef.colId;
        colDef.valueGetter = (params)=>{
            var _a;
            return (_a = params.data) == null ? void 0 : _a[params.colDef.field];
        };
        colDef.pivotKeys = pivotKeys;
        colDef.pivotValueColumn = valueColumn;
        if (colDef.filter === true) colDef.filter = "agNumberColumnFilter";
        return colDef;
    }
    sameAggFuncs(aggFuncs) {
        if (aggFuncs.length == 1) return true;
        for(let i = 1; i < aggFuncs.length; i++){
            if (aggFuncs[i] !== aggFuncs[0]) return false;
        }
        return true;
    }
    headerNameComparator(userComparator, a, b) {
        if (userComparator) return userComparator(a.headerName, b.headerName);
        else {
            if (a.headerName && !b.headerName) return 1;
            else if (!a.headerName && b.headerName) return -1;
            if (!a.headerName || !b.headerName) return 0;
            if (a.headerName < b.headerName) return -1;
            if (a.headerName > b.headerName) return 1;
            return 0;
        }
    }
    merge(m1, m2) {
        m2.forEach((value, key, map)=>{
            const existingList = m1.has(key) ? m1.get(key) : [];
            const updatedList = [
                ...existingList,
                ...value
            ];
            m1.set(key, updatedList);
        });
    }
    generateColumnGroupId(pivotKeys) {
        const pivotCols = this.columnModel.getPivotColumns().map((col)=>col.getColId());
        return `pivotGroup_${pivotCols.join("-")}_${pivotKeys.join("-")}`;
    }
    generateColumnId(pivotKeys, measureColumnId) {
        const pivotCols = this.columnModel.getPivotColumns().map((col)=>col.getColId());
        return `pivot_${pivotCols.join("-")}_${pivotKeys.join("-")}_${measureColumnId}`;
    }
    /**
   * Used by the SSRM to create secondary columns from provided fields
   * @param fields 
   */ createColDefsFromFields(fields) {
        const uniqueValues = {};
        for(let i = 0; i < fields.length; i++){
            const field = fields[i];
            const parts = field.split(this.fieldSeparator);
            let level = uniqueValues;
            for(let p = 0; p < parts.length; p++){
                const part = parts[p];
                if (level[part] == null) level[part] = {};
                level = level[part];
            }
        }
        const uniqueValuesToGroups = (id, key, uniqueValues2, depth)=>{
            var _a;
            const children = [];
            for(let key2 in uniqueValues2){
                const item = uniqueValues2[key2];
                const child = uniqueValuesToGroups(`${id}${this.fieldSeparator}${key2}`, key2, item, depth + 1);
                children.push(child);
            }
            if (children.length === 0) {
                const potentialAggCol = this.columnModel.getPrimaryColumn(key);
                if (potentialAggCol) {
                    const headerName = (_a = this.columnModel.getDisplayNameForColumn(potentialAggCol, "header")) != null ? _a : key;
                    const colDef = this.createColDef(potentialAggCol, headerName, void 0, false);
                    colDef.colId = id;
                    colDef.aggFunc = potentialAggCol.getAggFunc();
                    colDef.valueGetter = (params)=>{
                        var _a2;
                        return (_a2 = params.data) == null ? void 0 : _a2[id];
                    };
                    return colDef;
                }
                const col = {
                    colId: id,
                    headerName: key,
                    // this is to support using pinned rows, normally the data will be extracted from the aggData object using the colId
                    // however pinned rows still access the data object by field, this prevents values with dots from being treated as complex objects
                    valueGetter: (params)=>{
                        var _a2;
                        return (_a2 = params.data) == null ? void 0 : _a2[id];
                    }
                };
                return col;
            }
            const collapseSingleChildren = this.gos.get("removePivotHeaderRowWhenSingleValueColumn");
            if (collapseSingleChildren && children.length === 1 && "colId" in children[0]) {
                children[0].headerName = key;
                return children[0];
            }
            const group = {
                openByDefault: this.pivotDefaultExpanded === -1 || depth < this.pivotDefaultExpanded,
                groupId: id,
                headerName: key,
                children: children
            };
            return group;
        };
        const res = [];
        for(let key in uniqueValues){
            const item = uniqueValues[key];
            const col = uniqueValuesToGroups(key, key, item, 0);
            res.push(col);
        }
        return res;
    }
};
$5b7ccabde48fae90$var$PivotColDefService.PIVOT_ROW_TOTAL_PREFIX = "PivotRowTotal_";
$5b7ccabde48fae90$var$__decorateClass6([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$PivotColDefService.prototype, "columnModel", 2);
$5b7ccabde48fae90$var$__decorateClass6([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$PivotColDefService.prototype, "init", 1);
$5b7ccabde48fae90$var$PivotColDefService = $5b7ccabde48fae90$var$__decorateClass6([
    (0, $jIDNV.Bean)("pivotColDefService")
], $5b7ccabde48fae90$var$PivotColDefService);
var $5b7ccabde48fae90$var$PivotStage = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.uniqueValues = {};
        this.lastTimeFailed = false;
        this.maxUniqueValues = -1;
        this.currentUniqueCount = 0;
    }
    execute(params) {
        const changedPath = params.changedPath;
        if (this.columnModel.isPivotActive()) this.executePivotOn(changedPath);
        else this.executePivotOff(changedPath);
    }
    executePivotOff(changedPath) {
        this.aggregationColumnsHashLastTime = null;
        this.uniqueValues = {};
        if (this.columnModel.isSecondaryColumnsPresent()) {
            this.columnModel.setSecondaryColumns(null, "rowModelUpdated");
            if (changedPath) changedPath.setInactive();
        }
    }
    executePivotOn(changedPath) {
        var _a;
        const numberOfAggregationColumns = (_a = this.columnModel.getValueColumns().length) != null ? _a : 1;
        const configuredMaxCols = this.gos.get("pivotMaxGeneratedColumns");
        this.maxUniqueValues = configuredMaxCols === -1 ? -1 : configuredMaxCols / numberOfAggregationColumns;
        let uniqueValues;
        try {
            uniqueValues = this.bucketUpRowNodes(changedPath);
        } catch (e) {
            if (e.message === $5b7ccabde48fae90$var$PivotStage.EXCEEDED_MAX_UNIQUE_VALUES) {
                this.columnModel.setSecondaryColumns([], "rowModelUpdated");
                const event = {
                    type: (0, $jIDNV.Events).EVENT_PIVOT_MAX_COLUMNS_EXCEEDED,
                    message: e.message
                };
                this.eventService.dispatchEvent(event);
                this.lastTimeFailed = true;
                return;
            }
            throw e;
        }
        const uniqueValuesChanged = this.setUniqueValues(uniqueValues);
        const aggregationColumns = this.columnModel.getValueColumns();
        const aggregationColumnsHash = aggregationColumns.map((column)=>`${column.getId()}-${column.getColDef().headerName}`).join("#");
        const aggregationFuncsHash = aggregationColumns.map((column)=>column.getAggFunc().toString()).join("#");
        const aggregationColumnsChanged = this.aggregationColumnsHashLastTime !== aggregationColumnsHash;
        const aggregationFuncsChanged = this.aggregationFuncsHashLastTime !== aggregationFuncsHash;
        this.aggregationColumnsHashLastTime = aggregationColumnsHash;
        this.aggregationFuncsHashLastTime = aggregationFuncsHash;
        const groupColumnsHash = this.columnModel.getRowGroupColumns().map((column)=>column.getId()).join("#");
        const groupColumnsChanged = groupColumnsHash !== this.groupColumnsHashLastTime;
        this.groupColumnsHashLastTime = groupColumnsHash;
        const pivotRowTotals = this.gos.get("pivotRowTotals");
        const pivotColumnGroupTotals = this.gos.get("pivotColumnGroupTotals");
        const suppressExpandablePivotGroups = this.gos.get("suppressExpandablePivotGroups");
        const removePivotHeaderRowWhenSingleValueColumn = this.gos.get("removePivotHeaderRowWhenSingleValueColumn");
        const anyGridOptionsChanged = pivotRowTotals !== this.pivotRowTotalsLastTime || pivotColumnGroupTotals !== this.pivotColumnGroupTotalsLastTime || suppressExpandablePivotGroups !== this.suppressExpandablePivotGroupsLastTime || removePivotHeaderRowWhenSingleValueColumn !== this.removePivotHeaderRowWhenSingleValueColumnLastTime;
        this.pivotRowTotalsLastTime = pivotRowTotals;
        this.pivotColumnGroupTotalsLastTime = pivotColumnGroupTotals;
        this.suppressExpandablePivotGroupsLastTime = suppressExpandablePivotGroups;
        this.removePivotHeaderRowWhenSingleValueColumnLastTime = removePivotHeaderRowWhenSingleValueColumn;
        if (this.lastTimeFailed || uniqueValuesChanged || aggregationColumnsChanged || groupColumnsChanged || aggregationFuncsChanged || anyGridOptionsChanged) {
            const { pivotColumnGroupDefs: pivotColumnGroupDefs, pivotColumnDefs: pivotColumnDefs } = this.pivotColDefService.createPivotColumnDefs(this.uniqueValues);
            this.pivotColumnDefs = pivotColumnDefs;
            this.columnModel.setSecondaryColumns(pivotColumnGroupDefs, "rowModelUpdated");
            if (changedPath) changedPath.setInactive();
        }
        this.lastTimeFailed = false;
    }
    setUniqueValues(newValues) {
        const json1 = JSON.stringify(newValues);
        const json2 = JSON.stringify(this.uniqueValues);
        const uniqueValuesChanged = json1 !== json2;
        if (uniqueValuesChanged) {
            this.uniqueValues = newValues;
            return true;
        } else return false;
    }
    bucketUpRowNodes(changedPath) {
        this.currentUniqueCount = 0;
        const uniqueValues = {};
        changedPath.forEachChangedNodeDepthFirst((node)=>{
            if (node.leafGroup) node.childrenMapped = null;
        });
        const recursivelyBucketFilteredChildren = (node)=>{
            var _a;
            if (node.leafGroup) this.bucketRowNode(node, uniqueValues);
            else (_a = node.childrenAfterFilter) == null || _a.forEach(recursivelyBucketFilteredChildren);
        };
        changedPath.executeFromRootNode(recursivelyBucketFilteredChildren);
        return uniqueValues;
    }
    bucketRowNode(rowNode, uniqueValues) {
        const pivotColumns = this.columnModel.getPivotColumns();
        if (pivotColumns.length === 0) rowNode.childrenMapped = null;
        else rowNode.childrenMapped = this.bucketChildren(rowNode.childrenAfterFilter, pivotColumns, 0, uniqueValues);
        if (rowNode.sibling) rowNode.sibling.childrenMapped = rowNode.childrenMapped;
    }
    bucketChildren(children, pivotColumns, pivotIndex, uniqueValues) {
        const mappedChildren = {};
        const pivotColumn = pivotColumns[pivotIndex];
        children.forEach((child)=>{
            let key = this.valueService.getKeyForNode(pivotColumn, child);
            if ((0, $jIDNV._).missing(key)) key = "";
            if (!uniqueValues[key]) {
                this.currentUniqueCount += 1;
                uniqueValues[key] = {};
                const doesGeneratedColMaxExist = this.maxUniqueValues !== -1;
                const hasExceededColMax = this.currentUniqueCount > this.maxUniqueValues;
                if (doesGeneratedColMaxExist && hasExceededColMax) throw Error($5b7ccabde48fae90$var$PivotStage.EXCEEDED_MAX_UNIQUE_VALUES);
            }
            if (!mappedChildren[key]) mappedChildren[key] = [];
            mappedChildren[key].push(child);
        });
        if (pivotIndex === pivotColumns.length - 1) return mappedChildren;
        else {
            const result = {};
            (0, $jIDNV._).iterateObject(mappedChildren, (key, value)=>{
                result[key] = this.bucketChildren(value, pivotColumns, pivotIndex + 1, uniqueValues[key]);
            });
            return result;
        }
    }
    getPivotColumnDefs() {
        return this.pivotColumnDefs;
    }
};
$5b7ccabde48fae90$var$PivotStage.EXCEEDED_MAX_UNIQUE_VALUES = "Exceeded maximum allowed pivot column count.";
$5b7ccabde48fae90$var$__decorateClass6([
    (0, $jIDNV.Autowired)("valueService")
], $5b7ccabde48fae90$var$PivotStage.prototype, "valueService", 2);
$5b7ccabde48fae90$var$__decorateClass6([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$PivotStage.prototype, "columnModel", 2);
$5b7ccabde48fae90$var$__decorateClass6([
    (0, $jIDNV.Autowired)("pivotColDefService")
], $5b7ccabde48fae90$var$PivotStage.prototype, "pivotColDefService", 2);
$5b7ccabde48fae90$var$PivotStage = $5b7ccabde48fae90$var$__decorateClass6([
    (0, $jIDNV.Bean)("pivotStage")
], $5b7ccabde48fae90$var$PivotStage);
var $5b7ccabde48fae90$var$defaultAggFuncNames = {
    sum: "Sum",
    first: "First",
    last: "Last",
    min: "Min",
    max: "Max",
    count: "Count",
    avg: "Average"
};
var $5b7ccabde48fae90$var$AggFuncService = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.aggFuncsMap = {};
        this.initialised = false;
    }
    init() {
        if (this.initialised) return;
        this.initialiseWithDefaultAggregations();
        this.addAggFuncs(this.gos.get("aggFuncs"));
    }
    initialiseWithDefaultAggregations() {
        this.aggFuncsMap[$5b7ccabde48fae90$var$AggFuncService.AGG_SUM] = $5b7ccabde48fae90$var$aggSum;
        this.aggFuncsMap[$5b7ccabde48fae90$var$AggFuncService.AGG_FIRST] = $5b7ccabde48fae90$var$aggFirst;
        this.aggFuncsMap[$5b7ccabde48fae90$var$AggFuncService.AGG_LAST] = $5b7ccabde48fae90$var$aggLast;
        this.aggFuncsMap[$5b7ccabde48fae90$var$AggFuncService.AGG_MIN] = $5b7ccabde48fae90$var$aggMin;
        this.aggFuncsMap[$5b7ccabde48fae90$var$AggFuncService.AGG_MAX] = $5b7ccabde48fae90$var$aggMax;
        this.aggFuncsMap[$5b7ccabde48fae90$var$AggFuncService.AGG_COUNT] = $5b7ccabde48fae90$var$aggCount;
        this.aggFuncsMap[$5b7ccabde48fae90$var$AggFuncService.AGG_AVG] = $5b7ccabde48fae90$var$aggAvg;
        this.initialised = true;
    }
    isAggFuncPossible(column, func) {
        const allKeys = this.getFuncNames(column);
        const allowed = (0, $jIDNV._).includes(allKeys, func);
        const funcExists = (0, $jIDNV._).exists(this.aggFuncsMap[func]);
        return allowed && funcExists;
    }
    getDefaultFuncLabel(fctName) {
        var _a;
        return (_a = $5b7ccabde48fae90$var$defaultAggFuncNames[fctName]) != null ? _a : fctName;
    }
    getDefaultAggFunc(column) {
        const defaultAgg = column.getColDef().defaultAggFunc;
        if ((0, $jIDNV._).exists(defaultAgg) && this.isAggFuncPossible(column, defaultAgg)) return defaultAgg;
        if (this.isAggFuncPossible(column, $5b7ccabde48fae90$var$AggFuncService.AGG_SUM)) return $5b7ccabde48fae90$var$AggFuncService.AGG_SUM;
        const allKeys = this.getFuncNames(column);
        return (0, $jIDNV._).existsAndNotEmpty(allKeys) ? allKeys[0] : null;
    }
    addAggFuncs(aggFuncs) {
        this.init();
        (0, $jIDNV._).iterateObject(aggFuncs, (key, aggFunc)=>{
            this.aggFuncsMap[key] = aggFunc;
        });
    }
    getAggFunc(name) {
        this.init();
        return this.aggFuncsMap[name];
    }
    getFuncNames(column) {
        const userAllowedFuncs = column.getColDef().allowedAggFuncs;
        return userAllowedFuncs == null ? Object.keys(this.aggFuncsMap).sort() : userAllowedFuncs;
    }
    clear() {
        this.aggFuncsMap = {};
    }
};
$5b7ccabde48fae90$var$AggFuncService.AGG_SUM = "sum";
$5b7ccabde48fae90$var$AggFuncService.AGG_FIRST = "first";
$5b7ccabde48fae90$var$AggFuncService.AGG_LAST = "last";
$5b7ccabde48fae90$var$AggFuncService.AGG_MIN = "min";
$5b7ccabde48fae90$var$AggFuncService.AGG_MAX = "max";
$5b7ccabde48fae90$var$AggFuncService.AGG_COUNT = "count";
$5b7ccabde48fae90$var$AggFuncService.AGG_AVG = "avg";
$5b7ccabde48fae90$var$__decorateClass6([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$AggFuncService.prototype, "init", 1);
$5b7ccabde48fae90$var$AggFuncService = $5b7ccabde48fae90$var$__decorateClass6([
    (0, $jIDNV.Bean)("aggFuncService")
], $5b7ccabde48fae90$var$AggFuncService);
function $5b7ccabde48fae90$var$aggSum(params) {
    const { values: values } = params;
    let result = null;
    for(let i = 0; i < values.length; i++){
        const value = values[i];
        if (typeof value === "number") {
            if (result === null) result = value;
            else result += typeof result === "number" ? value : BigInt(value);
        } else if (typeof value === "bigint") {
            if (result === null) result = value;
            else result = (typeof result === "bigint" ? result : BigInt(result)) + value;
        }
    }
    return result;
}
function $5b7ccabde48fae90$var$aggFirst(params) {
    return params.values.length > 0 ? params.values[0] : null;
}
function $5b7ccabde48fae90$var$aggLast(params) {
    return params.values.length > 0 ? (0, $jIDNV._).last(params.values) : null;
}
function $5b7ccabde48fae90$var$aggMin(params) {
    const { values: values } = params;
    let result = null;
    for(let i = 0; i < values.length; i++){
        const value = values[i];
        if ((typeof value === "number" || typeof value === "bigint") && (result === null || result > value)) result = value;
    }
    return result;
}
function $5b7ccabde48fae90$var$aggMax(params) {
    const { values: values } = params;
    let result = null;
    for(let i = 0; i < values.length; i++){
        const value = values[i];
        if ((typeof value === "number" || typeof value === "bigint") && (result === null || result < value)) result = value;
    }
    return result;
}
function $5b7ccabde48fae90$var$aggCount(params) {
    var _a, _b;
    const { values: values } = params;
    let result = 0;
    for(let i = 0; i < values.length; i++){
        const value = values[i];
        result += value != null && typeof value.value === "number" ? value.value : 1;
    }
    const existingAggData = (_b = (_a = params.rowNode) == null ? void 0 : _a.aggData) == null ? void 0 : _b[params.column.getColId()];
    if (existingAggData && existingAggData.value === result) return existingAggData;
    return {
        value: result,
        toString: function() {
            return this.value.toString();
        },
        // used for sorting
        toNumber: function() {
            return this.value;
        }
    };
}
function $5b7ccabde48fae90$var$aggAvg(params) {
    var _a, _b, _c;
    const { values: values } = params;
    let sum = 0;
    let count = 0;
    for(let i = 0; i < values.length; i++){
        const currentValue = values[i];
        let valueToAdd = null;
        if (typeof currentValue === "number" || typeof currentValue === "bigint") {
            valueToAdd = currentValue;
            count++;
        } else if (currentValue != null && (typeof currentValue.value === "number" || typeof currentValue.value === "bigint") && typeof currentValue.count === "number") {
            valueToAdd = currentValue.value * (typeof currentValue.value === "number" ? currentValue.count : BigInt(currentValue.count));
            count += currentValue.count;
        }
        if (typeof valueToAdd === "number") sum += typeof sum === "number" ? valueToAdd : BigInt(valueToAdd);
        else if (typeof valueToAdd === "bigint") sum = (typeof sum === "bigint" ? sum : BigInt(sum)) + valueToAdd;
    }
    let value = null;
    if (count > 0) value = sum / (typeof sum === "number" ? count : BigInt(count));
    const existingAggData = (_c = (_a = params.rowNode) == null ? void 0 : _a.aggData) == null ? void 0 : _c[(_b = params.column) == null ? void 0 : _b.getColId()];
    if (existingAggData && existingAggData.count === count && existingAggData.value === value) return existingAggData;
    return {
        count: count,
        value: value,
        // the grid by default uses toString to render values for an object, so this
        // is a trick to get the default cellRenderer to display the avg value
        toString: function() {
            return typeof this.value === "number" || typeof this.value === "bigint" ? this.value.toString() : "";
        },
        // used for sorting
        toNumber: function() {
            return this.value;
        }
    };
}
var $5b7ccabde48fae90$var$DropZoneColumnComp = class extends (0, $jIDNV.PillDragComp) {
    constructor(column, dragSourceDropTarget, ghost, dropZonePurpose, horizontal){
        super(dragSourceDropTarget, ghost, horizontal, /* html */ `
                <span role="option">
                    <span ref="eDragHandle" class="ag-drag-handle ag-column-drop-cell-drag-handle" role="presentation"></span>
                    <span ref="eText" class="ag-column-drop-cell-text" aria-hidden="true"></span>
                    <ag-sort-indicator ref="eSortIndicator"></ag-sort-indicator>
                    <span ref="eButton" class="ag-column-drop-cell-button" role="presentation"></span>
                </span>
            `);
        this.column = column;
        this.dropZonePurpose = dropZonePurpose;
        this.popupShowing = false;
    }
    init() {
        this.displayName = this.columnModel.getDisplayNameForColumn(this.column, "columnDrop");
        super.init();
        this.setupSort();
        this.addManagedListener(this.eventService, (0, $jIDNV.Column).EVENT_SORT_CHANGED, ()=>{
            this.setupAria();
        });
        if (this.isGroupingZone()) this.addManagedPropertyListener("groupLockGroupColumns", ()=>{
            this.refreshRemove();
            this.refreshDraggable();
            this.setupAria();
        });
    }
    getItem() {
        return this.column;
    }
    getDisplayName() {
        return this.displayName;
    }
    getTooltip() {
        return this.column.getColDef().headerTooltip;
    }
    addAdditionalAriaInstructions(ariaInstructions, translate) {
        const isSortSuppressed = this.gos.get("rowGroupPanelSuppressSort");
        const isFunctionsReadOnly = this.gos.get("functionsReadOnly");
        if (this.isAggregationZone() && !isFunctionsReadOnly) {
            const aggregationMenuAria = translate("ariaDropZoneColumnValueItemDescription", "Press ENTER to change the aggregation type");
            ariaInstructions.push(aggregationMenuAria);
        }
        if (this.isGroupingZone() && this.column.isSortable() && !isSortSuppressed) {
            const sortProgressAria = translate("ariaDropZoneColumnGroupItemDescription", "Press ENTER to sort");
            ariaInstructions.push(sortProgressAria);
        }
        super.addAdditionalAriaInstructions(ariaInstructions, translate);
    }
    isDraggable() {
        return this.isReadOnly();
    }
    isRemovable() {
        return this.isReadOnly();
    }
    isReadOnly() {
        return !this.isGroupingAndLocked() && !this.gos.get("functionsReadOnly");
    }
    getAriaDisplayName() {
        const translate = this.localeService.getLocaleTextFunc();
        const { name: name, aggFuncName: aggFuncName } = this.getColumnAndAggFuncName();
        const aggSeparator = translate("ariaDropZoneColumnComponentAggFuncSeparator", " of ");
        const sortDirection = {
            asc: translate("ariaDropZoneColumnComponentSortAscending", "ascending"),
            desc: translate("ariaDropZoneColumnComponentSortDescending", "descending")
        };
        const columnSort = this.column.getSort();
        const isSortSuppressed = this.gos.get("rowGroupPanelSuppressSort");
        return [
            aggFuncName && `${aggFuncName}${aggSeparator}`,
            name,
            this.isGroupingZone() && !isSortSuppressed && columnSort && `, ${sortDirection[columnSort]}`
        ].filter((part)=>!!part).join("");
    }
    getColumnAndAggFuncName() {
        const name = this.displayName;
        let aggFuncName = "";
        if (this.isAggregationZone()) {
            const aggFunc = this.column.getAggFunc();
            const aggFuncString = typeof aggFunc === "string" ? aggFunc : "agg";
            const localeTextFunc = this.localeService.getLocaleTextFunc();
            aggFuncName = localeTextFunc(aggFuncString, aggFuncString);
        }
        return {
            name: name,
            aggFuncName: aggFuncName
        };
    }
    setupSort() {
        const canSort = this.column.isSortable();
        const isGroupingZone = this.isGroupingZone();
        if (!canSort || !isGroupingZone) return;
        if (!this.gos.get("rowGroupPanelSuppressSort")) {
            this.eSortIndicator.setupSort(this.column, true);
            const performSort = (event)=>{
                event.preventDefault();
                const sortUsingCtrl = this.gos.get("multiSortKey") === "ctrl";
                const multiSort = sortUsingCtrl ? event.ctrlKey || event.metaKey : event.shiftKey;
                this.sortController.progressSort(this.column, multiSort, "uiColumnSorted");
            };
            this.addGuiEventListener("click", performSort);
            this.addGuiEventListener("keydown", (e)=>{
                const isEnter = e.key === (0, $jIDNV.KeyCode).ENTER;
                if (isEnter && this.isGroupingZone()) performSort(e);
            });
        }
    }
    getDefaultIconName() {
        return (0, $jIDNV.DragAndDropService).ICON_HIDE;
    }
    createGetDragItem() {
        const { column: column } = this;
        return ()=>{
            const visibleState = {};
            visibleState[column.getId()] = column.isVisible();
            return {
                columns: [
                    column
                ],
                visibleState: visibleState
            };
        };
    }
    setupComponents() {
        super.setupComponents();
        if (this.isAggregationZone() && !this.gos.get("functionsReadOnly")) this.addGuiEventListener("click", this.onShowAggFuncSelection.bind(this));
    }
    onKeyDown(e) {
        super.onKeyDown(e);
        const isEnter = e.key === (0, $jIDNV.KeyCode).ENTER;
        if (isEnter && this.isAggregationZone() && !this.gos.get("functionsReadOnly")) {
            e.preventDefault();
            this.onShowAggFuncSelection();
        }
    }
    getDisplayValue() {
        const { name: name, aggFuncName: aggFuncName } = this.getColumnAndAggFuncName();
        return this.isAggregationZone() ? `${aggFuncName}(${name})` : name;
    }
    onShowAggFuncSelection() {
        if (this.popupShowing) return;
        this.popupShowing = true;
        const virtualList = new (0, $jIDNV.VirtualList)({
            cssIdentifier: "select-agg-func"
        });
        const rows = this.aggFuncService.getFuncNames(this.column);
        const eGui = this.getGui();
        const virtualListGui = virtualList.getGui();
        virtualList.setModel({
            getRow: function(index) {
                return rows[index];
            },
            getRowCount: function() {
                return rows.length;
            }
        });
        this.getContext().createBean(virtualList);
        const ePopup = (0, $jIDNV._).loadTemplate(/* html*/ `<div class="ag-select-agg-func-popup"></div>`);
        ePopup.style.top = "0px";
        ePopup.style.left = "0px";
        ePopup.appendChild(virtualListGui);
        ePopup.style.width = `${eGui.clientWidth}px`;
        const focusoutListener = this.addManagedListener(ePopup, "focusout", (e)=>{
            if (!ePopup.contains(e.relatedTarget) && addPopupRes) addPopupRes.hideFunc();
        });
        const popupHiddenFunc = (callbackEvent)=>{
            this.destroyBean(virtualList);
            this.popupShowing = false;
            if ((callbackEvent == null ? void 0 : callbackEvent.key) === "Escape") eGui.focus();
            if (focusoutListener) focusoutListener();
        };
        const translate = this.localeService.getLocaleTextFunc();
        const addPopupRes = this.popupService.addPopup({
            modal: true,
            eChild: ePopup,
            closeOnEsc: true,
            closedCallback: popupHiddenFunc,
            ariaLabel: translate("ariaLabelAggregationFunction", "Aggregation Function")
        });
        if (addPopupRes) virtualList.setComponentCreator(this.createAggSelect.bind(this, addPopupRes.hideFunc));
        virtualList.addGuiEventListener("keydown", (e)=>{
            if (e.key === (0, $jIDNV.KeyCode).ENTER || e.key === (0, $jIDNV.KeyCode).SPACE) {
                const row = virtualList.getLastFocusedRow();
                if (row == null) return;
                const comp = virtualList.getComponentAt(row);
                if (comp) comp.selectItem();
            }
        });
        this.popupService.positionPopupByComponent({
            type: "aggFuncSelect",
            eventSource: eGui,
            ePopup: ePopup,
            keepWithinBounds: true,
            column: this.column,
            position: "under"
        });
        virtualList.refresh();
        let rowToFocus = rows.findIndex((r)=>r === this.column.getAggFunc());
        if (rowToFocus === -1) rowToFocus = 0;
        virtualList.focusRow(rowToFocus);
    }
    createAggSelect(hidePopup, value) {
        const itemSelected = ()=>{
            hidePopup();
            if (this.gos.get("functionsPassive")) {
                const event = {
                    type: (0, $jIDNV.Events).EVENT_COLUMN_AGG_FUNC_CHANGE_REQUEST,
                    columns: [
                        this.column
                    ],
                    aggFunc: value
                };
                this.eventService.dispatchEvent(event);
            } else this.columnModel.setColumnAggFunc(this.column, value, "toolPanelDragAndDrop");
        };
        const localeTextFunc = this.localeService.getLocaleTextFunc();
        const aggFuncString = value.toString();
        const aggFuncStringTranslated = localeTextFunc(aggFuncString, aggFuncString);
        const comp = new $5b7ccabde48fae90$var$AggItemComp(itemSelected, aggFuncStringTranslated);
        return comp;
    }
    isGroupingAndLocked() {
        return this.isGroupingZone() && this.columnModel.isColumnGroupingLocked(this.column);
    }
    isAggregationZone() {
        return this.dropZonePurpose === "aggregation";
    }
    isGroupingZone() {
        return this.dropZonePurpose === "rowGroup";
    }
    getDragSourceType() {
        return (0, $jIDNV.DragSourceType).ToolPanel;
    }
    destroy() {
        super.destroy();
        this.column = null;
    }
};
$5b7ccabde48fae90$var$__decorateClass6([
    (0, $jIDNV.Autowired)("popupService")
], $5b7ccabde48fae90$var$DropZoneColumnComp.prototype, "popupService", 2);
$5b7ccabde48fae90$var$__decorateClass6([
    (0, $jIDNV.Autowired)("sortController")
], $5b7ccabde48fae90$var$DropZoneColumnComp.prototype, "sortController", 2);
$5b7ccabde48fae90$var$__decorateClass6([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$DropZoneColumnComp.prototype, "columnModel", 2);
$5b7ccabde48fae90$var$__decorateClass6([
    (0, $jIDNV.Optional)("aggFuncService")
], $5b7ccabde48fae90$var$DropZoneColumnComp.prototype, "aggFuncService", 2);
$5b7ccabde48fae90$var$__decorateClass6([
    (0, $jIDNV.RefSelector)("eSortIndicator")
], $5b7ccabde48fae90$var$DropZoneColumnComp.prototype, "eSortIndicator", 2);
var $5b7ccabde48fae90$var$AggItemComp = class extends (0, $jIDNV.Component) {
    constructor(itemSelected, value){
        super(/* html */ `<div class="ag-select-agg-func-item"/>`);
        this.selectItem = itemSelected;
        this.getGui().innerText = value;
        this.addGuiEventListener("click", this.selectItem);
    }
};
var $5b7ccabde48fae90$var$BaseDropZonePanel = class extends (0, $jIDNV.PillDropZonePanel) {
    constructor(horizontal, dropZonePurpose){
        super(horizontal);
        this.dropZonePurpose = dropZonePurpose;
    }
    init(params) {
        super.init(params);
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_NEW_COLUMNS_LOADED, this.refreshGui.bind(this));
        this.addManagedPropertyListeners([
            "functionsReadOnly",
            "rowGroupPanelSuppressSort",
            "groupLockGroupColumns"
        ], this.refreshGui.bind(this));
    }
    getItems(dragItem) {
        var _a;
        return (_a = dragItem.columns) != null ? _a : [];
    }
    isInterestedIn(type) {
        return type === (0, $jIDNV.DragSourceType).HeaderCell || type === (0, $jIDNV.DragSourceType).ToolPanel;
    }
    minimumAllowedNewInsertIndex() {
        const numberOfLockedCols = this.gos.get("groupLockGroupColumns");
        const numberOfGroupCols = this.columnModel.getRowGroupColumns().length;
        if (numberOfLockedCols === -1) return numberOfGroupCols;
        return Math.min(numberOfLockedCols, numberOfGroupCols);
    }
    showOrHideColumnOnExit(draggingEvent) {
        return this.isRowGroupPanel() && !this.gos.get("suppressRowGroupHidesColumns") && !draggingEvent.fromNudge;
    }
    handleDragEnterEnd(draggingEvent) {
        const hideColumnOnExit = this.showOrHideColumnOnExit(draggingEvent);
        if (hideColumnOnExit) {
            const dragItem = draggingEvent.dragSource.getDragItem();
            const columns = dragItem.columns;
            this.setColumnsVisible(columns, false, "uiColumnDragged");
        }
    }
    handleDragLeaveEnd(draggingEvent) {
        const showColumnOnExit = this.showOrHideColumnOnExit(draggingEvent);
        if (showColumnOnExit) {
            const dragItem = draggingEvent.dragSource.getDragItem();
            this.setColumnsVisible(dragItem.columns, true, "uiColumnDragged");
        }
    }
    setColumnsVisible(columns, visible, source) {
        if (columns) {
            const allowedCols = columns.filter((c)=>!c.getColDef().lockVisible);
            this.columnModel.setColumnsVisible(allowedCols, visible, source);
        }
    }
    isRowGroupPanel() {
        return this.dropZonePurpose === "rowGroup";
    }
    refreshOnDragStop() {
        return !this.gos.get("functionsPassive");
    }
    createPillComponent(column, dropTarget, ghost, horizontal) {
        return new $5b7ccabde48fae90$var$DropZoneColumnComp(column, dropTarget, ghost, this.dropZonePurpose, horizontal);
    }
};
$5b7ccabde48fae90$var$__decorateClass6([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$BaseDropZonePanel.prototype, "columnModel", 2);
var $5b7ccabde48fae90$export$f3b209e86f7a7963 = class extends $5b7ccabde48fae90$var$BaseDropZonePanel {
    constructor(horizontal){
        super(horizontal, "rowGroup");
    }
    passBeansUp() {
        const localeTextFunc = this.localeService.getLocaleTextFunc();
        const emptyMessage = localeTextFunc("rowGroupColumnsEmptyMessage", "Drag here to set row groups");
        const title = localeTextFunc("groups", "Row Groups");
        super.init({
            icon: (0, $jIDNV._).createIconNoSpan("rowGroupPanel", this.gos, null),
            emptyMessage: emptyMessage,
            title: title
        });
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_COLUMN_ROW_GROUP_CHANGED, this.refreshGui.bind(this));
    }
    getAriaLabel() {
        const translate = this.localeService.getLocaleTextFunc();
        const label = translate("ariaRowGroupDropZonePanelLabel", "Row Groups");
        return label;
    }
    getTooltipParams() {
        const res = super.getTooltipParams();
        res.location = "rowGroupColumnsList";
        return res;
    }
    isItemDroppable(column, draggingEvent) {
        if (this.gos.get("functionsReadOnly") || !column.isPrimary()) return false;
        return column.isAllowRowGroup() && (!column.isRowGroupActive() || this.isSourceEventFromTarget(draggingEvent));
    }
    updateItems(columns) {
        if (this.gos.get("functionsPassive")) {
            const event = {
                type: (0, $jIDNV.Events).EVENT_COLUMN_ROW_GROUP_CHANGE_REQUEST,
                columns: columns
            };
            this.eventService.dispatchEvent(event);
        } else this.columnModel.setRowGroupColumns(columns, "toolPanelUi");
    }
    getIconName() {
        return this.isPotentialDndItems() ? (0, $jIDNV.DragAndDropService).ICON_GROUP : (0, $jIDNV.DragAndDropService).ICON_NOT_ALLOWED;
    }
    getExistingItems() {
        return this.columnModel.getRowGroupColumns();
    }
};
$5b7ccabde48fae90$var$__decorateClass6([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$export$f3b209e86f7a7963.prototype, "passBeansUp", 1);
var $5b7ccabde48fae90$export$e3a33a41cac287e = class extends $5b7ccabde48fae90$var$BaseDropZonePanel {
    constructor(horizontal){
        super(horizontal, "pivot");
    }
    passBeansUp() {
        const localeTextFunc = this.localeService.getLocaleTextFunc();
        const emptyMessage = localeTextFunc("pivotColumnsEmptyMessage", "Drag here to set column labels");
        const title = localeTextFunc("pivots", "Column Labels");
        super.init({
            icon: (0, $jIDNV._).createIconNoSpan("pivotPanel", this.gos, null),
            emptyMessage: emptyMessage,
            title: title
        });
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_NEW_COLUMNS_LOADED, this.refresh.bind(this));
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_COLUMN_PIVOT_CHANGED, this.refresh.bind(this));
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_COLUMN_PIVOT_MODE_CHANGED, this.checkVisibility.bind(this));
        this.refresh();
    }
    getAriaLabel() {
        const translate = this.localeService.getLocaleTextFunc();
        const label = translate("ariaPivotDropZonePanelLabel", "Column Labels");
        return label;
    }
    getTooltipParams() {
        const res = super.getTooltipParams();
        res.location = "pivotColumnsList";
        return res;
    }
    refresh() {
        this.checkVisibility();
        this.refreshGui();
    }
    checkVisibility() {
        const pivotMode = this.columnModel.isPivotMode();
        if (this.isHorizontal()) switch(this.gos.get("pivotPanelShow")){
            case "always":
                this.setDisplayed(pivotMode);
                break;
            case "onlyWhenPivoting":
                const pivotActive = this.columnModel.isPivotActive();
                this.setDisplayed(pivotMode && pivotActive);
                break;
            default:
                this.setDisplayed(false);
                break;
        }
        else this.setDisplayed(pivotMode);
    }
    isItemDroppable(column, draggingEvent) {
        if (this.gos.get("functionsReadOnly") || !column.isPrimary()) return false;
        return column.isAllowPivot() && (!column.isPivotActive() || this.isSourceEventFromTarget(draggingEvent));
    }
    updateItems(columns) {
        if (this.gos.get("functionsPassive")) {
            const event = {
                type: (0, $jIDNV.Events).EVENT_COLUMN_PIVOT_CHANGE_REQUEST,
                columns: columns
            };
            this.eventService.dispatchEvent(event);
        } else this.columnModel.setPivotColumns(columns, "toolPanelUi");
    }
    getIconName() {
        return this.isPotentialDndItems() ? (0, $jIDNV.DragAndDropService).ICON_PIVOT : (0, $jIDNV.DragAndDropService).ICON_NOT_ALLOWED;
    }
    getExistingItems() {
        return this.columnModel.getPivotColumns();
    }
};
$5b7ccabde48fae90$var$__decorateClass6([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$export$e3a33a41cac287e.prototype, "passBeansUp", 1);
var $5b7ccabde48fae90$var$GridHeaderDropZones = class extends (0, $jIDNV.Component) {
    constructor(){
        super();
    }
    postConstruct() {
        this.setGui(this.createNorthPanel());
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_COLUMN_ROW_GROUP_CHANGED, ()=>this.onRowGroupChanged());
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_NEW_COLUMNS_LOADED, ()=>this.onRowGroupChanged());
        this.addManagedPropertyListener("rowGroupPanelShow", ()=>this.onRowGroupChanged());
        this.addManagedPropertyListener("pivotPanelShow", ()=>this.onPivotPanelShow());
        this.onRowGroupChanged();
    }
    createNorthPanel() {
        const topPanelGui = document.createElement("div");
        topPanelGui.classList.add("ag-column-drop-wrapper");
        (0, $jIDNV._).setAriaRole(topPanelGui, "presentation");
        this.rowGroupComp = new $5b7ccabde48fae90$export$f3b209e86f7a7963(true);
        this.createManagedBean(this.rowGroupComp);
        this.pivotComp = new $5b7ccabde48fae90$export$e3a33a41cac287e(true);
        this.createManagedBean(this.pivotComp);
        topPanelGui.appendChild(this.rowGroupComp.getGui());
        topPanelGui.appendChild(this.pivotComp.getGui());
        this.addManagedListener(this.rowGroupComp, (0, $jIDNV.Component).EVENT_DISPLAYED_CHANGED, ()=>this.onDropPanelVisible());
        this.addManagedListener(this.pivotComp, (0, $jIDNV.Component).EVENT_DISPLAYED_CHANGED, ()=>this.onDropPanelVisible());
        this.onDropPanelVisible();
        return topPanelGui;
    }
    onDropPanelVisible() {
        const bothDisplayed = this.rowGroupComp.isDisplayed() && this.pivotComp.isDisplayed();
        this.rowGroupComp.addOrRemoveCssClass("ag-column-drop-horizontal-half-width", bothDisplayed);
        this.pivotComp.addOrRemoveCssClass("ag-column-drop-horizontal-half-width", bothDisplayed);
    }
    onRowGroupChanged() {
        if (!this.rowGroupComp) return;
        const rowGroupPanelShow = this.gos.get("rowGroupPanelShow");
        if (rowGroupPanelShow === "always") this.rowGroupComp.setDisplayed(true);
        else if (rowGroupPanelShow === "onlyWhenGrouping") {
            const grouping = !this.columnModel.isRowGroupEmpty();
            this.rowGroupComp.setDisplayed(grouping);
        } else this.rowGroupComp.setDisplayed(false);
    }
    onPivotPanelShow() {
        if (!this.pivotComp) return;
        const pivotPanelShow = this.gos.get("pivotPanelShow");
        if (pivotPanelShow === "always") this.pivotComp.setDisplayed(true);
        else if (pivotPanelShow === "onlyWhenPivoting") {
            const pivoting = this.columnModel.isPivotActive();
            this.pivotComp.setDisplayed(pivoting);
        } else this.pivotComp.setDisplayed(false);
    }
};
$5b7ccabde48fae90$var$__decorateClass6([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$GridHeaderDropZones.prototype, "columnModel", 2);
$5b7ccabde48fae90$var$__decorateClass6([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$GridHeaderDropZones.prototype, "postConstruct", 1);
var $5b7ccabde48fae90$var$FilterAggregatesStage = class extends (0, $jIDNV.BeanStub) {
    execute(params) {
        const isPivotMode = this.columnModel.isPivotMode();
        const isAggFilterActive = this.filterManager.isAggregateFilterPresent() || this.filterManager.isAggregateQuickFilterPresent();
        const defaultPrimaryColumnPredicate = (params2)=>!params2.node.group;
        const defaultSecondaryColumnPredicate = (params2)=>params2.node.leafGroup;
        const applyFilterToNode = this.gos.getGroupAggFiltering() || (isPivotMode ? defaultSecondaryColumnPredicate : defaultPrimaryColumnPredicate);
        const { changedPath: changedPath } = params;
        const preserveChildren = (node, recursive = false)=>{
            if (node.childrenAfterFilter) {
                node.childrenAfterAggFilter = node.childrenAfterFilter;
                if (recursive) node.childrenAfterAggFilter.forEach((child)=>preserveChildren(child, recursive));
                this.setAllChildrenCount(node);
            }
            if (node.sibling) node.sibling.childrenAfterAggFilter = node.childrenAfterAggFilter;
        };
        const filterChildren = (node)=>{
            var _a;
            node.childrenAfterAggFilter = ((_a = node.childrenAfterFilter) == null ? void 0 : _a.filter((child)=>{
                var _a2;
                const shouldFilterRow = applyFilterToNode({
                    node: child
                });
                if (shouldFilterRow) {
                    const doesNodePassFilter = this.filterManager.doesRowPassAggregateFilters({
                        rowNode: child
                    });
                    if (doesNodePassFilter) {
                        preserveChildren(child, true);
                        return true;
                    }
                }
                const hasChildPassed = (_a2 = child.childrenAfterAggFilter) == null ? void 0 : _a2.length;
                return hasChildPassed;
            })) || null;
            this.setAllChildrenCount(node);
            if (node.sibling) node.sibling.childrenAfterAggFilter = node.childrenAfterAggFilter;
        };
        changedPath.forEachChangedNodeDepthFirst(isAggFilterActive ? filterChildren : preserveChildren, true);
    }
    setAllChildrenCountTreeData(rowNode) {
        let allChildrenCount = 0;
        rowNode.childrenAfterAggFilter.forEach((child)=>{
            allChildrenCount++;
            allChildrenCount += child.allChildrenCount;
        });
        rowNode.setAllChildrenCount(allChildrenCount);
    }
    setAllChildrenCountGridGrouping(rowNode) {
        let allChildrenCount = 0;
        rowNode.childrenAfterAggFilter.forEach((child)=>{
            if (child.group) allChildrenCount += child.allChildrenCount;
            else allChildrenCount++;
        });
        rowNode.setAllChildrenCount(allChildrenCount);
    }
    setAllChildrenCount(rowNode) {
        if (!rowNode.hasChildren()) {
            rowNode.setAllChildrenCount(null);
            return;
        }
        if (this.gos.get("treeData")) this.setAllChildrenCountTreeData(rowNode);
        else this.setAllChildrenCountGridGrouping(rowNode);
    }
};
$5b7ccabde48fae90$var$__decorateClass6([
    (0, $jIDNV.Autowired)("filterManager")
], $5b7ccabde48fae90$var$FilterAggregatesStage.prototype, "filterManager", 2);
$5b7ccabde48fae90$var$__decorateClass6([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$FilterAggregatesStage.prototype, "columnModel", 2);
$5b7ccabde48fae90$var$FilterAggregatesStage = $5b7ccabde48fae90$var$__decorateClass6([
    (0, $jIDNV.Bean)("filterAggregatesStage")
], $5b7ccabde48fae90$var$FilterAggregatesStage);
var $5b7ccabde48fae90$var$VERSION6 = "31.3.4";
var $5b7ccabde48fae90$var$_GroupFilter = class _GroupFilter2 extends (0, $jIDNV.TabGuardComp) {
    constructor(){
        super(/* html */ `
            <div class="ag-group-filter">
                <div ref="eGroupField"></div>
                <div ref="eUnderlyingFilter"></div>
            </div>
        `);
    }
    postConstruct() {
        this.initialiseTabGuard({});
    }
    init(params) {
        this.params = params;
        this.validateParams();
        return this.updateGroups().then(()=>{
            this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_COLUMN_ROW_GROUP_CHANGED, ()=>this.onColumnRowGroupChanged());
        });
    }
    validateParams() {
        const { colDef: colDef } = this.params;
        if (colDef.field) (0, $jIDNV._).warnOnce('Group Column Filter does not work with the colDef property "field". This property will be ignored.');
        if (colDef.filterValueGetter) (0, $jIDNV._).warnOnce('Group Column Filter does not work with the colDef property "filterValueGetter". This property will be ignored.');
        if (colDef.filterParams) (0, $jIDNV._).warnOnce('Group Column Filter does not work with the colDef property "filterParams". This property will be ignored.');
    }
    updateGroups() {
        const sourceColumns = this.updateGroupField();
        return this.getUnderlyingFilters(sourceColumns);
    }
    getSourceColumns() {
        this.groupColumn = this.params.column;
        if (this.gos.get("treeData")) {
            (0, $jIDNV._).warnOnce("Group Column Filter does not work with Tree Data enabled. Please disable Tree Data, or use a different filter.");
            return [];
        }
        const sourceColumns = this.columnModel.getSourceColumnsForGroupColumn(this.groupColumn);
        if (!sourceColumns) {
            (0, $jIDNV._).warnOnce("Group Column Filter only works on group columns. Please use a different filter.");
            return [];
        }
        return sourceColumns;
    }
    updateGroupField() {
        (0, $jIDNV._).clearElement(this.eGroupField);
        if (this.eGroupFieldSelect) this.destroyBean(this.eGroupFieldSelect);
        const allSourceColumns = this.getSourceColumns();
        const sourceColumns = allSourceColumns.filter((sourceColumn)=>sourceColumn.isFilterAllowed());
        if (!sourceColumns.length) {
            this.selectedColumn = void 0;
            (0, $jIDNV._).setDisplayed(this.eGroupField, false);
            return null;
        }
        if (allSourceColumns.length === 1) {
            this.selectedColumn = sourceColumns[0];
            (0, $jIDNV._).setDisplayed(this.eGroupField, false);
        } else {
            if (!this.selectedColumn || !sourceColumns.some((column)=>column.getId() === this.selectedColumn.getId())) this.selectedColumn = sourceColumns[0];
            this.createGroupFieldSelectElement(sourceColumns);
            this.eGroupField.appendChild(this.eGroupFieldSelect.getGui());
            this.eGroupField.appendChild((0, $jIDNV._).loadTemplate(/* html */ `<div class="ag-filter-separator"></div>`));
            (0, $jIDNV._).setDisplayed(this.eGroupField, true);
        }
        return sourceColumns;
    }
    createGroupFieldSelectElement(sourceColumns) {
        this.eGroupFieldSelect = this.createManagedBean(new (0, $jIDNV.AgSelect)());
        const localeTextFunc = this.localeService.getLocaleTextFunc();
        this.eGroupFieldSelect.setLabel(localeTextFunc("groupFilterSelect", "Select field:"));
        this.eGroupFieldSelect.setLabelAlignment("top");
        this.eGroupFieldSelect.addOptions(sourceColumns.map((sourceColumn)=>{
            var _a;
            return {
                value: sourceColumn.getId(),
                text: (_a = this.columnModel.getDisplayNameForColumn(sourceColumn, "groupFilter", false)) != null ? _a : void 0
            };
        }));
        this.eGroupFieldSelect.setValue(this.selectedColumn.getId());
        this.eGroupFieldSelect.onValueChange((newValue)=>this.updateSelectedColumn(newValue));
        this.eGroupFieldSelect.addCssClass("ag-group-filter-field-select-wrapper");
        if (sourceColumns.length === 1) this.eGroupFieldSelect.setDisabled(true);
    }
    getUnderlyingFilters(sourceColumns) {
        if (!sourceColumns) {
            this.filterColumnPairs = void 0;
            this.selectedFilter = void 0;
            this.groupColumn.setFilterActive(false, "columnRowGroupChanged");
            return (0, $jIDNV.AgPromise).resolve();
        }
        const filterPromises = [];
        const filterColumnPairs = [];
        sourceColumns.forEach((column)=>{
            const filterWrapper = this.filterManager.getOrCreateFilterWrapper(column, "COLUMN_MENU");
            if (filterWrapper == null ? void 0 : filterWrapper.filterPromise) filterPromises.push(filterWrapper.filterPromise.then((filter)=>{
                if (filter) filterColumnPairs.push({
                    filter: filter,
                    column: column
                });
                if (column.getId() === this.selectedColumn.getId()) this.selectedFilter = filter != null ? filter : void 0;
                return filter;
            }));
        });
        return (0, $jIDNV.AgPromise).all(filterPromises).then(()=>{
            this.filterColumnPairs = filterColumnPairs;
            this.groupColumn.setFilterActive(this.isFilterActive(), "columnRowGroupChanged");
        });
    }
    addUnderlyingFilterElement() {
        var _a, _b;
        (0, $jIDNV._).clearElement(this.eUnderlyingFilter);
        if (!this.selectedColumn) return (0, $jIDNV.AgPromise).resolve();
        const comp = this.createManagedBean(new (0, $jIDNV.FilterWrapperComp)(this.selectedColumn, "COLUMN_MENU"));
        this.filterWrapperComp = comp;
        if (!comp.hasFilter()) return (0, $jIDNV.AgPromise).resolve();
        this.eUnderlyingFilter.appendChild(comp.getGui());
        return (_b = (_a = comp.getFilter()) == null ? void 0 : _a.then(()=>{
            var _a2, _b2;
            (_a2 = comp.afterGuiAttached) == null || _a2.call(comp, this.afterGuiAttachedParams);
            if (!((_b2 = this.afterGuiAttachedParams) == null ? void 0 : _b2.suppressFocus) && this.eGroupFieldSelect && !this.eGroupFieldSelect.isDisabled()) this.eGroupFieldSelect.getFocusableElement().focus();
        })) != null ? _b : (0, $jIDNV.AgPromise).resolve();
    }
    updateSelectedColumn(columnId) {
        var _a;
        if (!columnId) return;
        (_a = this.filterWrapperComp) == null || _a.afterGuiDetached();
        this.destroyBean(this.filterWrapperComp);
        const selectedFilterColumnPair = this.getFilterColumnPair(columnId);
        this.selectedColumn = selectedFilterColumnPair == null ? void 0 : selectedFilterColumnPair.column;
        this.selectedFilter = selectedFilterColumnPair == null ? void 0 : selectedFilterColumnPair.filter;
        this.dispatchEvent({
            type: _GroupFilter2.EVENT_SELECTED_COLUMN_CHANGED
        });
        this.addUnderlyingFilterElement();
    }
    isFilterActive() {
        var _a;
        return !!((_a = this.filterColumnPairs) == null ? void 0 : _a.some(({ filter: filter })=>filter.isFilterActive()));
    }
    doesFilterPass() {
        return true;
    }
    getModel() {
        return null;
    }
    setModel() {
        return (0, $jIDNV.AgPromise).resolve();
    }
    afterGuiAttached(params) {
        this.afterGuiAttachedParams = params;
        this.addUnderlyingFilterElement();
    }
    afterGuiDetached() {
        var _a, _b;
        (0, $jIDNV._).clearElement(this.eUnderlyingFilter);
        (_b = (_a = this.selectedFilter) == null ? void 0 : _a.afterGuiDetached) == null || _b.call(_a);
    }
    onColumnRowGroupChanged() {
        this.updateGroups().then(()=>{
            this.dispatchEvent({
                type: _GroupFilter2.EVENT_COLUMN_ROW_GROUP_CHANGED
            });
            this.eventService.dispatchEvent({
                type: "filterAllowedUpdated"
            });
        });
    }
    getFilterColumnPair(columnId) {
        var _a;
        if (!columnId) return void 0;
        return (_a = this.filterColumnPairs) == null ? void 0 : _a.find(({ column: column })=>column.getId() === columnId);
    }
    getSelectedFilter() {
        return this.selectedFilter;
    }
    getSelectedColumn() {
        return this.selectedColumn;
    }
    isFilterAllowed() {
        return !!this.selectedColumn;
    }
    destroy() {
        super.destroy();
    }
};
$5b7ccabde48fae90$var$_GroupFilter.EVENT_COLUMN_ROW_GROUP_CHANGED = "columnRowGroupChanged";
$5b7ccabde48fae90$var$_GroupFilter.EVENT_SELECTED_COLUMN_CHANGED = "selectedColumnChanged";
$5b7ccabde48fae90$var$__decorateClass6([
    (0, $jIDNV.Autowired)("filterManager")
], $5b7ccabde48fae90$var$_GroupFilter.prototype, "filterManager", 2);
$5b7ccabde48fae90$var$__decorateClass6([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$_GroupFilter.prototype, "columnModel", 2);
$5b7ccabde48fae90$var$__decorateClass6([
    (0, $jIDNV.RefSelector)("eGroupField")
], $5b7ccabde48fae90$var$_GroupFilter.prototype, "eGroupField", 2);
$5b7ccabde48fae90$var$__decorateClass6([
    (0, $jIDNV.RefSelector)("eUnderlyingFilter")
], $5b7ccabde48fae90$var$_GroupFilter.prototype, "eUnderlyingFilter", 2);
$5b7ccabde48fae90$var$__decorateClass6([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_GroupFilter.prototype, "postConstruct", 1);
var $5b7ccabde48fae90$var$GroupFilter = $5b7ccabde48fae90$var$_GroupFilter;
var $5b7ccabde48fae90$var$GroupFloatingFilterComp = class extends (0, $jIDNV.Component) {
    constructor(){
        super(/* html */ `
            <div ref="eFloatingFilter" class="ag-group-floating-filter ag-floating-filter-input" role="presentation"></div>
        `);
        this.haveAddedColumnListeners = false;
    }
    init(params) {
        this.params = params;
        const canShowUnderlyingFloatingFilter = this.gos.get("groupDisplayType") === "multipleColumns";
        return new (0, $jIDNV.AgPromise)((resolve)=>{
            this.params.parentFilterInstance((parentFilterInstance)=>{
                this.parentFilterInstance = parentFilterInstance;
                if (canShowUnderlyingFloatingFilter) this.setupUnderlyingFloatingFilterElement().then(()=>resolve());
                else {
                    this.setupReadOnlyFloatingFilterElement();
                    resolve();
                }
            });
        }).then(()=>{
            this.addManagedListener(this.parentFilterInstance, $5b7ccabde48fae90$var$GroupFilter.EVENT_SELECTED_COLUMN_CHANGED, ()=>this.onSelectedColumnChanged());
            this.addManagedListener(this.parentFilterInstance, $5b7ccabde48fae90$var$GroupFilter.EVENT_COLUMN_ROW_GROUP_CHANGED, ()=>this.onColumnRowGroupChanged());
        });
    }
    onParamsUpdated(params) {
        this.refresh(params);
    }
    refresh(params) {
        this.params = params;
        this.setParams();
    }
    setParams() {
        var _a;
        const displayName = this.columnModel.getDisplayNameForColumn(this.params.column, "header", true);
        const translate = this.localeService.getLocaleTextFunc();
        (_a = this.eFloatingFilterText) == null || _a.setInputAriaLabel(`${displayName} ${translate("ariaFilterInput", "Filter Input")}`);
    }
    setupReadOnlyFloatingFilterElement() {
        if (!this.eFloatingFilterText) {
            this.eFloatingFilterText = this.createManagedBean(new (0, $jIDNV.AgInputTextField)());
            this.eFloatingFilterText.setDisabled(true).addGuiEventListener("click", ()=>this.params.showParentFilter());
            this.setParams();
        }
        this.updateDisplayedValue();
        this.eFloatingFilter.appendChild(this.eFloatingFilterText.getGui());
    }
    setupUnderlyingFloatingFilterElement() {
        this.showingUnderlyingFloatingFilter = false;
        this.underlyingFloatingFilter = void 0;
        (0, $jIDNV._).clearElement(this.eFloatingFilter);
        const column = this.parentFilterInstance.getSelectedColumn();
        if (column && !column.isVisible()) {
            const compDetails = this.filterManager.getFloatingFilterCompDetails(column, this.params.showParentFilter);
            if (compDetails) {
                this.compDetails = compDetails;
                if (!this.haveAddedColumnListeners) {
                    this.haveAddedColumnListeners = true;
                    this.addManagedListener(column, (0, $jIDNV.Column).EVENT_VISIBLE_CHANGED, this.onColumnVisibleChanged.bind(this));
                    this.addManagedListener(column, (0, $jIDNV.Column).EVENT_COL_DEF_CHANGED, this.onColDefChanged.bind(this));
                }
                return compDetails.newAgStackInstance().then((floatingFilter)=>{
                    var _a, _b;
                    this.underlyingFloatingFilter = floatingFilter;
                    (_b = this.underlyingFloatingFilter) == null || _b.onParentModelChanged((_a = this.parentFilterInstance.getSelectedFilter()) == null ? void 0 : _a.getModel());
                    this.appendChild(floatingFilter.getGui());
                    this.showingUnderlyingFloatingFilter = true;
                });
            }
        }
        this.setupReadOnlyFloatingFilterElement();
        return (0, $jIDNV.AgPromise).resolve();
    }
    onColumnVisibleChanged() {
        this.setupUnderlyingFloatingFilterElement();
    }
    onColDefChanged(event) {
        var _a, _b, _c;
        if (!event.column) return;
        const compDetails = this.filterManager.getFloatingFilterCompDetails(event.column, this.params.showParentFilter);
        if (compDetails) {
            if ((_a = this.underlyingFloatingFilter) == null ? void 0 : _a.refresh) this.underlyingFloatingFilter.refresh(compDetails.params);
            else (_c = (_b = this.underlyingFloatingFilter) == null ? void 0 : _b.onParamsUpdated) == null || _c.call(_b, compDetails.params);
        }
    }
    onParentModelChanged(_model, event) {
        var _a, _b;
        if (this.showingUnderlyingFloatingFilter) (_b = this.underlyingFloatingFilter) == null || _b.onParentModelChanged((_a = this.parentFilterInstance.getSelectedFilter()) == null ? void 0 : _a.getModel(), event);
        else this.updateDisplayedValue();
    }
    updateDisplayedValue() {
        if (!this.parentFilterInstance || !this.eFloatingFilterText) return;
        const selectedFilter = this.parentFilterInstance.getSelectedFilter();
        if (!selectedFilter) {
            this.eFloatingFilterText.setValue("");
            this.eFloatingFilterText.setDisplayed(false);
            return;
        }
        this.eFloatingFilterText.setDisplayed(true);
        if (selectedFilter.getModelAsString) {
            const filterModel = selectedFilter.getModel();
            this.eFloatingFilterText.setValue(filterModel == null ? "" : selectedFilter.getModelAsString(filterModel));
        } else this.eFloatingFilterText.setValue("");
    }
    onSelectedColumnChanged() {
        if (!this.showingUnderlyingFloatingFilter) this.updateDisplayedValue();
    }
    onColumnRowGroupChanged() {
        if (!this.showingUnderlyingFloatingFilter) this.updateDisplayedValue();
    }
    destroy() {
        super.destroy();
    }
};
$5b7ccabde48fae90$var$__decorateClass6([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$GroupFloatingFilterComp.prototype, "columnModel", 2);
$5b7ccabde48fae90$var$__decorateClass6([
    (0, $jIDNV.Autowired)("filterManager")
], $5b7ccabde48fae90$var$GroupFloatingFilterComp.prototype, "filterManager", 2);
$5b7ccabde48fae90$var$__decorateClass6([
    (0, $jIDNV.RefSelector)("eFloatingFilter")
], $5b7ccabde48fae90$var$GroupFloatingFilterComp.prototype, "eFloatingFilter", 2);
var $5b7ccabde48fae90$export$e67935bd41653107 = {
    version: $5b7ccabde48fae90$var$VERSION6,
    moduleName: (0, $jIDNV.ModuleNames).RowGroupingModule,
    beans: [
        $5b7ccabde48fae90$var$AggregationStage,
        $5b7ccabde48fae90$var$FilterAggregatesStage,
        $5b7ccabde48fae90$var$GroupStage,
        $5b7ccabde48fae90$var$PivotColDefService,
        $5b7ccabde48fae90$var$PivotStage,
        $5b7ccabde48fae90$var$AggFuncService
    ],
    agStackComponents: [
        {
            componentName: "AgGridHeaderDropZones",
            componentClass: $5b7ccabde48fae90$var$GridHeaderDropZones
        }
    ],
    userComponents: [
        {
            componentName: "agGroupColumnFilter",
            componentClass: $5b7ccabde48fae90$var$GroupFilter
        },
        {
            componentName: "agGroupColumnFloatingFilter",
            componentClass: $5b7ccabde48fae90$var$GroupFloatingFilterComp
        }
    ],
    dependantModules: [
        $5b7ccabde48fae90$export$3a6d13add8617801
    ]
};
var $5b7ccabde48fae90$export$4c5515da8ced3ad7 = class extends $5b7ccabde48fae90$var$BaseDropZonePanel {
    constructor(horizontal){
        super(horizontal, "aggregation");
    }
    passBeansUp() {
        const localeTextFunc = this.localeService.getLocaleTextFunc();
        const emptyMessage = localeTextFunc("valueColumnsEmptyMessage", "Drag here to aggregate");
        const title = localeTextFunc("values", "Values");
        super.init({
            icon: (0, $jIDNV._).createIconNoSpan("valuePanel", this.gos, null),
            emptyMessage: emptyMessage,
            title: title
        });
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_COLUMN_VALUE_CHANGED, this.refreshGui.bind(this));
    }
    getAriaLabel() {
        const translate = this.localeService.getLocaleTextFunc();
        const label = translate("ariaValuesDropZonePanelLabel", "Values");
        return label;
    }
    getTooltipParams() {
        const res = super.getTooltipParams();
        res.location = "valueColumnsList";
        return res;
    }
    getIconName() {
        return this.isPotentialDndItems() ? (0, $jIDNV.DragAndDropService).ICON_AGGREGATE : (0, $jIDNV.DragAndDropService).ICON_NOT_ALLOWED;
    }
    isItemDroppable(column, draggingEvent) {
        if (this.gos.get("functionsReadOnly") || !column.isPrimary()) return false;
        return column.isAllowValue() && (!column.isValueActive() || this.isSourceEventFromTarget(draggingEvent));
    }
    updateItems(columns) {
        if (this.gos.get("functionsPassive")) {
            const event = {
                type: (0, $jIDNV.Events).EVENT_COLUMN_VALUE_CHANGE_REQUEST,
                columns: columns
            };
            this.eventService.dispatchEvent(event);
        } else this.columnModel.setValueColumns(columns, "toolPanelUi");
    }
    getExistingItems() {
        return this.columnModel.getValueColumns();
    }
};
$5b7ccabde48fae90$var$__decorateClass6([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$export$4c5515da8ced3ad7.prototype, "passBeansUp", 1);
var $5b7ccabde48fae90$var$__defProp7 = Object.defineProperty;
var $5b7ccabde48fae90$var$__defProps5 = Object.defineProperties;
var $5b7ccabde48fae90$var$__getOwnPropDesc7 = Object.getOwnPropertyDescriptor;
var $5b7ccabde48fae90$var$__getOwnPropDescs5 = Object.getOwnPropertyDescriptors;
var $5b7ccabde48fae90$var$__getOwnPropSymbols5 = Object.getOwnPropertySymbols;
var $5b7ccabde48fae90$var$__hasOwnProp6 = Object.prototype.hasOwnProperty;
var $5b7ccabde48fae90$var$__propIsEnum5 = Object.prototype.propertyIsEnumerable;
var $5b7ccabde48fae90$var$__defNormalProp5 = (obj, key, value)=>key in obj ? $5b7ccabde48fae90$var$__defProp7(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5b7ccabde48fae90$var$__spreadValues5 = (a, b)=>{
    for(var prop in b || (b = {}))if ($5b7ccabde48fae90$var$__hasOwnProp6.call(b, prop)) $5b7ccabde48fae90$var$__defNormalProp5(a, prop, b[prop]);
    if ($5b7ccabde48fae90$var$__getOwnPropSymbols5) {
        for (var prop of $5b7ccabde48fae90$var$__getOwnPropSymbols5(b))if ($5b7ccabde48fae90$var$__propIsEnum5.call(b, prop)) $5b7ccabde48fae90$var$__defNormalProp5(a, prop, b[prop]);
    }
    return a;
};
var $5b7ccabde48fae90$var$__spreadProps5 = (a, b)=>$5b7ccabde48fae90$var$__defProps5(a, $5b7ccabde48fae90$var$__getOwnPropDescs5(b));
var $5b7ccabde48fae90$var$__decorateClass7 = (decorators, target, key, kind)=>{
    var result = kind > 1 ? void 0 : kind ? $5b7ccabde48fae90$var$__getOwnPropDesc7(target, key) : target;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
    if (kind && result) $5b7ccabde48fae90$var$__defProp7(target, key, result);
    return result;
};
var $5b7ccabde48fae90$var$HorizontalResizeComp = class extends (0, $jIDNV.Component) {
    constructor(){
        super(/* html */ `<div class="ag-tool-panel-horizontal-resize"></div>`);
        this.minWidth = 100;
        this.maxWidth = null;
    }
    setElementToResize(elementToResize) {
        this.elementToResize = elementToResize;
    }
    postConstruct() {
        const finishedWithResizeFunc = this.horizontalResizeService.addResizeBar({
            eResizeBar: this.getGui(),
            dragStartPixels: 1,
            onResizeStart: this.onResizeStart.bind(this),
            onResizing: this.onResizing.bind(this),
            onResizeEnd: this.onResizeEnd.bind(this)
        });
        this.addDestroyFunc(finishedWithResizeFunc);
        this.setInverted(this.gos.get("enableRtl"));
    }
    dispatchResizeEvent(start, end, width) {
        const event = {
            type: (0, $jIDNV.Events).EVENT_TOOL_PANEL_SIZE_CHANGED,
            width: width,
            started: start,
            ended: end
        };
        this.eventService.dispatchEvent(event);
    }
    onResizeStart() {
        this.startingWidth = this.elementToResize.offsetWidth;
        this.dispatchResizeEvent(true, false, this.startingWidth);
    }
    onResizeEnd(delta) {
        return this.onResizing(delta, true);
    }
    onResizing(delta, isEnd = false) {
        const direction = this.inverted ? -1 : 1;
        let newWidth = Math.max(this.minWidth, Math.floor(this.startingWidth - delta * direction));
        if (this.maxWidth != null) newWidth = Math.min(this.maxWidth, newWidth);
        this.elementToResize.style.width = `${newWidth}px`;
        this.dispatchResizeEvent(false, isEnd, newWidth);
    }
    setInverted(inverted) {
        this.inverted = inverted;
    }
    setMaxWidth(value) {
        this.maxWidth = value;
    }
    setMinWidth(value) {
        if (value != null) this.minWidth = value;
        else this.minWidth = 100;
    }
};
$5b7ccabde48fae90$var$__decorateClass7([
    (0, $jIDNV.Autowired)("horizontalResizeService")
], $5b7ccabde48fae90$var$HorizontalResizeComp.prototype, "horizontalResizeService", 2);
$5b7ccabde48fae90$var$__decorateClass7([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$HorizontalResizeComp.prototype, "postConstruct", 1);
var $5b7ccabde48fae90$var$_SideBarButtonComp = class _SideBarButtonComp2 extends (0, $jIDNV.Component) {
    constructor(toolPanelDef){
        super();
        this.toolPanelDef = toolPanelDef;
    }
    getToolPanelId() {
        return this.toolPanelDef.id;
    }
    postConstruct() {
        const template = this.createTemplate();
        this.setTemplate(template);
        this.setLabel();
        this.setIcon();
        this.addManagedListener(this.eToggleButton, "click", this.onButtonPressed.bind(this));
        this.eToggleButton.setAttribute("id", `ag-${this.getCompId()}-button`);
    }
    createTemplate() {
        const res = /* html */ `<div class="ag-side-button" role="presentation">
                <button type="button" ref="eToggleButton" tabindex="-1" role="tab" aria-expanded="false" class="ag-button ag-side-button-button">
                    <div ref="eIconWrapper" class="ag-side-button-icon-wrapper" aria-hidden="true"></div>
                    <span ref ="eLabel" class="ag-side-button-label"></span>
                </button>
            </div>`;
        return res;
    }
    setLabel() {
        const translate = this.localeService.getLocaleTextFunc();
        const def = this.toolPanelDef;
        const label = translate(def.labelKey, def.labelDefault);
        this.eLabel.innerText = label;
    }
    setIcon() {
        this.eIconWrapper.insertAdjacentElement("afterbegin", (0, $jIDNV._).createIconNoSpan(this.toolPanelDef.iconKey, this.gos));
    }
    onButtonPressed() {
        this.dispatchEvent({
            type: _SideBarButtonComp2.EVENT_TOGGLE_BUTTON_CLICKED
        });
    }
    setSelected(selected) {
        this.addOrRemoveCssClass("ag-selected", selected);
        (0, $jIDNV._).setAriaExpanded(this.eToggleButton, selected);
    }
    getButtonElement() {
        return this.eToggleButton;
    }
};
$5b7ccabde48fae90$var$_SideBarButtonComp.EVENT_TOGGLE_BUTTON_CLICKED = "toggleButtonClicked";
$5b7ccabde48fae90$var$__decorateClass7([
    (0, $jIDNV.RefSelector)("eToggleButton")
], $5b7ccabde48fae90$var$_SideBarButtonComp.prototype, "eToggleButton", 2);
$5b7ccabde48fae90$var$__decorateClass7([
    (0, $jIDNV.RefSelector)("eIconWrapper")
], $5b7ccabde48fae90$var$_SideBarButtonComp.prototype, "eIconWrapper", 2);
$5b7ccabde48fae90$var$__decorateClass7([
    (0, $jIDNV.RefSelector)("eLabel")
], $5b7ccabde48fae90$var$_SideBarButtonComp.prototype, "eLabel", 2);
$5b7ccabde48fae90$var$__decorateClass7([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_SideBarButtonComp.prototype, "postConstruct", 1);
var $5b7ccabde48fae90$var$SideBarButtonComp = $5b7ccabde48fae90$var$_SideBarButtonComp;
var $5b7ccabde48fae90$var$_SideBarButtonsComp = class _SideBarButtonsComp2 extends (0, $jIDNV.Component) {
    constructor(){
        super(_SideBarButtonsComp2.TEMPLATE);
        this.buttonComps = [];
    }
    postConstruct() {
        this.addManagedListener(this.getFocusableElement(), "keydown", this.handleKeyDown.bind(this));
    }
    handleKeyDown(e) {
        if (e.key !== (0, $jIDNV.KeyCode).TAB || !e.shiftKey) return;
        const lastColumn = (0, $jIDNV._).last(this.columnModel.getAllDisplayedColumns());
        if (this.focusService.focusGridView(lastColumn, true)) e.preventDefault();
    }
    setActiveButton(id) {
        this.buttonComps.forEach((comp)=>{
            comp.setSelected(id === comp.getToolPanelId());
        });
    }
    addButtonComp(def) {
        const buttonComp = this.createBean(new $5b7ccabde48fae90$var$SideBarButtonComp(def));
        this.buttonComps.push(buttonComp);
        this.appendChild(buttonComp);
        buttonComp.addEventListener($5b7ccabde48fae90$var$SideBarButtonComp.EVENT_TOGGLE_BUTTON_CLICKED, ()=>{
            this.dispatchEvent({
                type: _SideBarButtonsComp2.EVENT_SIDE_BAR_BUTTON_CLICKED,
                toolPanelId: def.id
            });
        });
        return buttonComp;
    }
    clearButtons() {
        this.buttonComps = this.destroyBeans(this.buttonComps);
        (0, $jIDNV._).clearElement(this.getGui());
    }
};
$5b7ccabde48fae90$var$_SideBarButtonsComp.EVENT_SIDE_BAR_BUTTON_CLICKED = "sideBarButtonClicked";
$5b7ccabde48fae90$var$_SideBarButtonsComp.TEMPLATE = /* html */ `<div class="ag-side-buttons" role="tablist"></div>`;
$5b7ccabde48fae90$var$__decorateClass7([
    (0, $jIDNV.Autowired)("focusService")
], $5b7ccabde48fae90$var$_SideBarButtonsComp.prototype, "focusService", 2);
$5b7ccabde48fae90$var$__decorateClass7([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$_SideBarButtonsComp.prototype, "columnModel", 2);
$5b7ccabde48fae90$var$__decorateClass7([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_SideBarButtonsComp.prototype, "postConstruct", 1);
$5b7ccabde48fae90$var$__decorateClass7([
    (0, $jIDNV.PreDestroy)
], $5b7ccabde48fae90$var$_SideBarButtonsComp.prototype, "clearButtons", 1);
var $5b7ccabde48fae90$var$SideBarButtonsComp = $5b7ccabde48fae90$var$_SideBarButtonsComp;
var $5b7ccabde48fae90$var$_SideBarDefParser = class _SideBarDefParser2 {
    static parse(toParse) {
        if (!toParse) return void 0;
        if (toParse === true) return {
            toolPanels: [
                _SideBarDefParser2.DEFAULT_COLUMN_COMP,
                _SideBarDefParser2.DEFAULT_FILTER_COMP
            ],
            defaultToolPanel: "columns"
        };
        if (typeof toParse === "string") return _SideBarDefParser2.parse([
            toParse
        ]);
        if (Array.isArray(toParse)) {
            const comps = [];
            toParse.forEach((key)=>{
                const lookupResult = _SideBarDefParser2.DEFAULT_BY_KEY[key];
                if (!lookupResult) {
                    console.warn(`AG Grid: the key ${key} is not a valid key for specifying a tool panel, valid keys are: ${Object.keys(_SideBarDefParser2.DEFAULT_BY_KEY).join(",")}`);
                    return;
                }
                comps.push(lookupResult);
            });
            if (comps.length === 0) return void 0;
            return {
                toolPanels: comps,
                defaultToolPanel: comps[0].id
            };
        }
        const result = {
            toolPanels: _SideBarDefParser2.parseComponents(toParse.toolPanels),
            defaultToolPanel: toParse.defaultToolPanel,
            hiddenByDefault: toParse.hiddenByDefault,
            position: toParse.position
        };
        return result;
    }
    static parseComponents(from) {
        const result = [];
        if (!from) return result;
        from.forEach((it)=>{
            let toAdd = null;
            if (typeof it === "string") {
                const lookupResult = _SideBarDefParser2.DEFAULT_BY_KEY[it];
                if (!lookupResult) {
                    console.warn(`AG Grid: the key ${it} is not a valid key for specifying a tool panel, valid keys are: ${Object.keys(_SideBarDefParser2.DEFAULT_BY_KEY).join(",")}`);
                    return;
                }
                toAdd = lookupResult;
            } else toAdd = it;
            result.push(toAdd);
        });
        return result;
    }
};
$5b7ccabde48fae90$var$_SideBarDefParser.DEFAULT_COLUMN_COMP = {
    id: "columns",
    labelDefault: "Columns",
    labelKey: "columns",
    iconKey: "columns",
    toolPanel: "agColumnsToolPanel"
};
$5b7ccabde48fae90$var$_SideBarDefParser.DEFAULT_FILTER_COMP = {
    id: "filters",
    labelDefault: "Filters",
    labelKey: "filters",
    iconKey: "filter",
    toolPanel: "agFiltersToolPanel"
};
$5b7ccabde48fae90$var$_SideBarDefParser.DEFAULT_BY_KEY = {
    columns: $5b7ccabde48fae90$var$_SideBarDefParser.DEFAULT_COLUMN_COMP,
    filters: $5b7ccabde48fae90$var$_SideBarDefParser.DEFAULT_FILTER_COMP
};
var $5b7ccabde48fae90$var$SideBarDefParser = $5b7ccabde48fae90$var$_SideBarDefParser;
var $5b7ccabde48fae90$var$_ToolPanelWrapper = class _ToolPanelWrapper2 extends (0, $jIDNV.Component) {
    constructor(){
        super(_ToolPanelWrapper2.TEMPLATE);
    }
    setupResize() {
        const eGui = this.getGui();
        const resizeBar = this.resizeBar = this.createManagedBean(new $5b7ccabde48fae90$var$HorizontalResizeComp());
        eGui.setAttribute("id", `ag-${this.getCompId()}`);
        resizeBar.setElementToResize(eGui);
        this.appendChild(resizeBar);
    }
    getToolPanelId() {
        return this.toolPanelId;
    }
    setToolPanelDef(toolPanelDef, params) {
        const { id: id, minWidth: minWidth, maxWidth: maxWidth, width: width } = toolPanelDef;
        this.toolPanelId = id;
        this.width = width;
        const compDetails = this.userComponentFactory.getToolPanelCompDetails(toolPanelDef, params);
        const componentPromise = compDetails.newAgStackInstance();
        this.params = compDetails.params;
        if (componentPromise == null) {
            console.warn(`AG Grid: error processing tool panel component ${id}. You need to specify 'toolPanel'`);
            return;
        }
        componentPromise.then(this.setToolPanelComponent.bind(this));
        if (minWidth != null) this.resizeBar.setMinWidth(minWidth);
        if (maxWidth != null) this.resizeBar.setMaxWidth(maxWidth);
    }
    setToolPanelComponent(compInstance) {
        this.toolPanelCompInstance = compInstance;
        this.appendChild(compInstance.getGui());
        this.addDestroyFunc(()=>{
            this.destroyBean(compInstance);
        });
        if (this.width) this.getGui().style.width = `${this.width}px`;
    }
    getToolPanelInstance() {
        return this.toolPanelCompInstance;
    }
    setResizerSizerSide(side) {
        const isRtl = this.gos.get("enableRtl");
        const isLeft = side === "left";
        const inverted = isRtl ? isLeft : !isLeft;
        this.resizeBar.setInverted(inverted);
    }
    refresh() {
        this.toolPanelCompInstance.refresh(this.params);
    }
};
$5b7ccabde48fae90$var$_ToolPanelWrapper.TEMPLATE = /* html */ `<div class="ag-tool-panel-wrapper" role="tabpanel"/>`;
$5b7ccabde48fae90$var$__decorateClass7([
    (0, $jIDNV.Autowired)("userComponentFactory")
], $5b7ccabde48fae90$var$_ToolPanelWrapper.prototype, "userComponentFactory", 2);
$5b7ccabde48fae90$var$__decorateClass7([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_ToolPanelWrapper.prototype, "setupResize", 1);
var $5b7ccabde48fae90$var$ToolPanelWrapper = $5b7ccabde48fae90$var$_ToolPanelWrapper;
var $5b7ccabde48fae90$var$_SideBarComp = class _SideBarComp2 extends (0, $jIDNV.Component) {
    constructor(){
        super(_SideBarComp2.TEMPLATE);
        this.toolPanelWrappers = [];
    }
    postConstruct() {
        var _a;
        this.sideBarButtonsComp.addEventListener($5b7ccabde48fae90$var$SideBarButtonsComp.EVENT_SIDE_BAR_BUTTON_CLICKED, this.onToolPanelButtonClicked.bind(this));
        const { sideBar: sideBarState } = (_a = this.gos.get("initialState")) != null ? _a : {};
        this.setSideBarDef({
            sideBarDef: $5b7ccabde48fae90$var$SideBarDefParser.parse(this.gos.get("sideBar")),
            sideBarState: sideBarState
        });
        this.addManagedPropertyListener("sideBar", this.onSideBarUpdated.bind(this));
        this.sideBarService.registerSideBarComp(this);
        this.createManagedBean(new (0, $jIDNV.ManagedFocusFeature)(this.getFocusableElement(), {
            onTabKeyDown: this.onTabKeyDown.bind(this),
            handleKeyDown: this.handleKeyDown.bind(this)
        }));
    }
    onTabKeyDown(e) {
        if (e.defaultPrevented) return;
        const { focusService: focusService, sideBarButtonsComp: sideBarButtonsComp } = this;
        const eGui = this.getGui();
        const sideBarGui = sideBarButtonsComp.getGui();
        const activeElement = this.gos.getActiveDomElement();
        const openPanel = eGui.querySelector(".ag-tool-panel-wrapper:not(.ag-hidden)");
        const target = e.target;
        if (!openPanel) return;
        if (sideBarGui.contains(activeElement)) {
            if (focusService.focusInto(openPanel, e.shiftKey)) e.preventDefault();
            return;
        }
        if (!e.shiftKey) return;
        let nextEl = null;
        if (openPanel.contains(activeElement)) nextEl = this.focusService.findNextFocusableElement(openPanel, void 0, true);
        else if (focusService.isTargetUnderManagedComponent(openPanel, target) && e.shiftKey) nextEl = this.focusService.findFocusableElementBeforeTabGuard(openPanel, target);
        if (!nextEl) nextEl = sideBarGui.querySelector(".ag-selected button");
        if (nextEl && nextEl !== e.target) {
            e.preventDefault();
            nextEl.focus();
        }
    }
    handleKeyDown(e) {
        const currentButton = this.gos.getActiveDomElement();
        if (!this.sideBarButtonsComp.getGui().contains(currentButton)) return;
        const sideBarGui = this.sideBarButtonsComp.getGui();
        const buttons = Array.prototype.slice.call(sideBarGui.querySelectorAll(".ag-side-button"));
        const currentPos = buttons.findIndex((button)=>button.contains(currentButton));
        let nextPos = null;
        switch(e.key){
            case (0, $jIDNV.KeyCode).LEFT:
            case (0, $jIDNV.KeyCode).UP:
                nextPos = Math.max(0, currentPos - 1);
                break;
            case (0, $jIDNV.KeyCode).RIGHT:
            case (0, $jIDNV.KeyCode).DOWN:
                nextPos = Math.min(currentPos + 1, buttons.length - 1);
                break;
        }
        if (nextPos === null) return;
        const innerButton = buttons[nextPos].querySelector("button");
        if (innerButton) {
            innerButton.focus();
            e.preventDefault();
        }
    }
    onToolPanelButtonClicked(event) {
        const id = event.toolPanelId;
        const openedItem = this.openedItem();
        if (openedItem === id) this.openToolPanel(void 0, "sideBarButtonClicked");
        else this.openToolPanel(id, "sideBarButtonClicked");
    }
    clearDownUi() {
        this.sideBarButtonsComp.clearButtons();
        this.destroyToolPanelWrappers();
    }
    setSideBarDef({ sideBarDef: sideBarDef, sideBarState: sideBarState, existingToolPanelWrappers: existingToolPanelWrappers }) {
        this.setDisplayed(false);
        this.sideBar = sideBarDef;
        if (!!this.sideBar && !!this.sideBar.toolPanels) {
            const toolPanelDefs = this.sideBar.toolPanels;
            this.createToolPanelsAndSideButtons(toolPanelDefs, sideBarState, existingToolPanelWrappers);
            if (!this.toolPanelWrappers.length) return;
            const shouldDisplaySideBar = sideBarState ? sideBarState.visible : !this.sideBar.hiddenByDefault;
            this.setDisplayed(shouldDisplaySideBar);
            this.setSideBarPosition(sideBarState ? sideBarState.position : this.sideBar.position);
            if (shouldDisplaySideBar) {
                if (sideBarState) {
                    const { openToolPanel: openToolPanel } = sideBarState;
                    if (openToolPanel) this.openToolPanel(openToolPanel, "sideBarInitializing");
                } else this.openToolPanel(this.sideBar.defaultToolPanel, "sideBarInitializing");
            }
        }
    }
    getDef() {
        return this.sideBar;
    }
    setSideBarPosition(position) {
        if (!position) position = "right";
        this.position = position;
        const isLeft = position === "left";
        const resizerSide = isLeft ? "right" : "left";
        this.addOrRemoveCssClass("ag-side-bar-left", isLeft);
        this.addOrRemoveCssClass("ag-side-bar-right", !isLeft);
        this.toolPanelWrappers.forEach((wrapper)=>{
            wrapper.setResizerSizerSide(resizerSide);
        });
        this.eventService.dispatchEvent({
            type: (0, $jIDNV.Events).EVENT_SIDE_BAR_UPDATED
        });
        return this;
    }
    setDisplayed(displayed, options) {
        super.setDisplayed(displayed, options);
        this.eventService.dispatchEvent({
            type: (0, $jIDNV.Events).EVENT_SIDE_BAR_UPDATED
        });
    }
    getState() {
        const toolPanels = {};
        this.toolPanelWrappers.forEach((wrapper)=>{
            var _a, _b;
            toolPanels[wrapper.getToolPanelId()] = (_b = (_a = wrapper.getToolPanelInstance()) == null ? void 0 : _a.getState) == null ? void 0 : _b.call(_a);
        });
        return {
            visible: this.isDisplayed(),
            position: this.position,
            openToolPanel: this.openedItem(),
            toolPanels: toolPanels
        };
    }
    createToolPanelsAndSideButtons(defs, sideBarState, existingToolPanelWrappers) {
        var _a;
        for (const def of defs)this.createToolPanelAndSideButton(def, (_a = sideBarState == null ? void 0 : sideBarState.toolPanels) == null ? void 0 : _a[def.id], existingToolPanelWrappers == null ? void 0 : existingToolPanelWrappers[def.id]);
    }
    validateDef(def) {
        if (def.id == null) {
            console.warn(`AG Grid: please review all your toolPanel components, it seems like at least one of them doesn't have an id`);
            return false;
        }
        if (def.toolPanel === "agColumnsToolPanel") {
            const moduleMissing = !(0, $jIDNV.ModuleRegistry).__assertRegistered((0, $jIDNV.ModuleNames).ColumnsToolPanelModule, "Column Tool Panel", this.context.getGridId());
            if (moduleMissing) return false;
        }
        if (def.toolPanel === "agFiltersToolPanel") {
            const moduleMissing = !(0, $jIDNV.ModuleRegistry).__assertRegistered((0, $jIDNV.ModuleNames).FiltersToolPanelModule, "Filters Tool Panel", this.context.getGridId());
            if (moduleMissing) return false;
            if (this.filterManager.isAdvancedFilterEnabled()) {
                (0, $jIDNV._).warnOnce("Advanced Filter does not work with Filters Tool Panel. Filters Tool Panel has been disabled.");
                return false;
            }
        }
        return true;
    }
    createToolPanelAndSideButton(def, initialState, existingToolPanelWrapper) {
        if (!this.validateDef(def)) return;
        const button = this.sideBarButtonsComp.addButtonComp(def);
        let wrapper;
        if (existingToolPanelWrapper) wrapper = existingToolPanelWrapper;
        else {
            wrapper = this.getContext().createBean(new $5b7ccabde48fae90$var$ToolPanelWrapper());
            wrapper.setToolPanelDef(def, {
                initialState: initialState,
                onStateUpdated: ()=>this.eventService.dispatchEvent({
                        type: (0, $jIDNV.Events).EVENT_SIDE_BAR_UPDATED
                    })
            });
        }
        wrapper.setDisplayed(false);
        const wrapperGui = wrapper.getGui();
        this.appendChild(wrapperGui);
        this.toolPanelWrappers.push(wrapper);
        (0, $jIDNV._).setAriaControls(button.getButtonElement(), wrapperGui);
    }
    refresh() {
        this.toolPanelWrappers.forEach((wrapper)=>wrapper.refresh());
    }
    openToolPanel(key, source = "api") {
        const currentlyOpenedKey = this.openedItem();
        if (currentlyOpenedKey === key) return;
        this.toolPanelWrappers.forEach((wrapper)=>{
            const show = key === wrapper.getToolPanelId();
            wrapper.setDisplayed(show);
        });
        const newlyOpenedKey = this.openedItem();
        const openToolPanelChanged = currentlyOpenedKey !== newlyOpenedKey;
        if (openToolPanelChanged) {
            this.sideBarButtonsComp.setActiveButton(key);
            this.raiseToolPanelVisibleEvent(key, currentlyOpenedKey != null ? currentlyOpenedKey : void 0, source);
        }
    }
    getToolPanelInstance(key) {
        const toolPanelWrapper = this.toolPanelWrappers.filter((toolPanel)=>toolPanel.getToolPanelId() === key)[0];
        if (!toolPanelWrapper) {
            console.warn(`AG Grid: unable to lookup Tool Panel as invalid key supplied: ${key}`);
            return;
        }
        return toolPanelWrapper.getToolPanelInstance();
    }
    raiseToolPanelVisibleEvent(key, previousKey, source) {
        const switchingToolPanel = !!key && !!previousKey;
        if (previousKey) {
            const event = {
                type: (0, $jIDNV.Events).EVENT_TOOL_PANEL_VISIBLE_CHANGED,
                source: source,
                key: previousKey,
                visible: false,
                switchingToolPanel: switchingToolPanel
            };
            this.eventService.dispatchEvent(event);
        }
        if (key) {
            const event = {
                type: (0, $jIDNV.Events).EVENT_TOOL_PANEL_VISIBLE_CHANGED,
                source: source,
                key: key,
                visible: true,
                switchingToolPanel: switchingToolPanel
            };
            this.eventService.dispatchEvent(event);
        }
    }
    close(source = "api") {
        this.openToolPanel(void 0, source);
    }
    isToolPanelShowing() {
        return !!this.openedItem();
    }
    openedItem() {
        let activeToolPanel = null;
        this.toolPanelWrappers.forEach((wrapper)=>{
            if (wrapper.isDisplayed()) activeToolPanel = wrapper.getToolPanelId();
        });
        return activeToolPanel;
    }
    onSideBarUpdated() {
        var _a;
        const sideBarDef = $5b7ccabde48fae90$var$SideBarDefParser.parse(this.gos.get("sideBar"));
        let existingToolPanelWrappers = {};
        if (sideBarDef && this.sideBar) (_a = sideBarDef.toolPanels) == null || _a.forEach((toolPanelDef)=>{
            var _a2, _b;
            const { id: id } = toolPanelDef;
            if (!id) return;
            const existingToolPanelDef = (_a2 = this.sideBar.toolPanels) == null ? void 0 : _a2.find((toolPanelDefToCheck)=>toolPanelDefToCheck.id === id);
            if (!existingToolPanelDef || toolPanelDef.toolPanel !== existingToolPanelDef.toolPanel) return;
            const toolPanelWrapper = this.toolPanelWrappers.find((toolPanel)=>toolPanel.getToolPanelId() === id);
            if (!toolPanelWrapper) return;
            const params = this.gos.addGridCommonParams($5b7ccabde48fae90$var$__spreadProps5($5b7ccabde48fae90$var$__spreadValues5({}, (_b = toolPanelDef.toolPanelParams) != null ? _b : {}), {
                onStateUpdated: ()=>this.eventService.dispatchEvent({
                        type: (0, $jIDNV.Events).EVENT_SIDE_BAR_UPDATED
                    })
            }));
            const hasRefreshed = toolPanelWrapper.getToolPanelInstance().refresh(params);
            if (hasRefreshed !== true) return;
            this.toolPanelWrappers = this.toolPanelWrappers.filter((toolPanel)=>toolPanel !== toolPanelWrapper);
            (0, $jIDNV._).removeFromParent(toolPanelWrapper.getGui());
            existingToolPanelWrappers[id] = toolPanelWrapper;
        });
        this.clearDownUi();
        this.setSideBarDef({
            sideBarDef: sideBarDef,
            existingToolPanelWrappers: existingToolPanelWrappers
        });
    }
    destroyToolPanelWrappers() {
        this.toolPanelWrappers.forEach((wrapper)=>{
            (0, $jIDNV._).removeFromParent(wrapper.getGui());
            this.destroyBean(wrapper);
        });
        this.toolPanelWrappers.length = 0;
    }
    destroy() {
        this.destroyToolPanelWrappers();
        super.destroy();
    }
};
$5b7ccabde48fae90$var$_SideBarComp.TEMPLATE = /* html */ `<div class="ag-side-bar ag-unselectable">
            <ag-side-bar-buttons ref="sideBarButtons"></ag-side-bar-buttons>
        </div>`;
$5b7ccabde48fae90$var$__decorateClass7([
    (0, $jIDNV.Autowired)("focusService")
], $5b7ccabde48fae90$var$_SideBarComp.prototype, "focusService", 2);
$5b7ccabde48fae90$var$__decorateClass7([
    (0, $jIDNV.Autowired)("filterManager")
], $5b7ccabde48fae90$var$_SideBarComp.prototype, "filterManager", 2);
$5b7ccabde48fae90$var$__decorateClass7([
    (0, $jIDNV.Autowired)("sideBarService")
], $5b7ccabde48fae90$var$_SideBarComp.prototype, "sideBarService", 2);
$5b7ccabde48fae90$var$__decorateClass7([
    (0, $jIDNV.RefSelector)("sideBarButtons")
], $5b7ccabde48fae90$var$_SideBarComp.prototype, "sideBarButtonsComp", 2);
$5b7ccabde48fae90$var$__decorateClass7([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_SideBarComp.prototype, "postConstruct", 1);
var $5b7ccabde48fae90$var$SideBarComp = $5b7ccabde48fae90$var$_SideBarComp;
var $5b7ccabde48fae90$export$52f8319e10930bfa = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.isColGroupDef = (colDef)=>colDef && typeof colDef.children !== "undefined";
        this.getId = (colDef)=>{
            return this.isColGroupDef(colDef) ? colDef.groupId : colDef.colId;
        };
    }
    createColumnTree(colDefs) {
        const invalidColIds = [];
        const createDummyColGroup = (abstractColDef, depth)=>{
            if (this.isColGroupDef(abstractColDef)) {
                const groupDef = abstractColDef;
                const groupId = typeof groupDef.groupId !== "undefined" ? groupDef.groupId : groupDef.headerName;
                const group = new (0, $jIDNV.ProvidedColumnGroup)(groupDef, groupId, false, depth);
                const children = [];
                groupDef.children.forEach((def)=>{
                    const child = createDummyColGroup(def, depth + 1);
                    if (child) children.push(child);
                });
                group.setChildren(children);
                return group;
            } else {
                const colDef = abstractColDef;
                const key = colDef.colId ? colDef.colId : colDef.field;
                const column = this.columnModel.getPrimaryColumn(key);
                if (!column) invalidColIds.push(colDef);
                return column;
            }
        };
        const mappedResults = [];
        colDefs.forEach((colDef)=>{
            const result = createDummyColGroup(colDef, 0);
            if (result) mappedResults.push(result);
        });
        if (invalidColIds.length > 0) console.warn("AG Grid: unable to find grid columns for the supplied colDef(s):", invalidColIds);
        return mappedResults;
    }
    syncLayoutWithGrid(syncLayoutCallback) {
        const leafPathTrees = this.getLeafPathTrees();
        const mergedColumnTrees = this.mergeLeafPathTrees(leafPathTrees);
        syncLayoutCallback(mergedColumnTrees);
    }
    getLeafPathTrees() {
        const getLeafPathTree = (node, childDef)=>{
            let leafPathTree;
            if (node instanceof (0, $jIDNV.ProvidedColumnGroup)) {
                if (node.isPadding()) leafPathTree = childDef;
                else {
                    const groupDef = Object.assign({}, node.getColGroupDef());
                    groupDef.groupId = node.getGroupId();
                    groupDef.children = [
                        childDef
                    ];
                    leafPathTree = groupDef;
                }
            } else {
                const colDef = Object.assign({}, node.getColDef());
                colDef.colId = node.getColId();
                leafPathTree = colDef;
            }
            const parent = node.getOriginalParent();
            if (parent) return getLeafPathTree(parent, leafPathTree);
            else return leafPathTree;
        };
        const allGridColumns = this.columnModel.getAllGridColumns();
        const allPrimaryGridColumns = allGridColumns.filter((column)=>{
            const colDef = column.getColDef();
            return column.isPrimary() && !colDef.showRowGroup;
        });
        return allPrimaryGridColumns.map((col)=>getLeafPathTree(col, col.getColDef()));
    }
    mergeLeafPathTrees(leafPathTrees) {
        const matchingRootGroupIds = (pathA, pathB)=>{
            const bothPathsAreGroups = this.isColGroupDef(pathA) && this.isColGroupDef(pathB);
            return bothPathsAreGroups && this.getId(pathA) === this.getId(pathB);
        };
        const mergeTrees = (treeA, treeB)=>{
            if (!this.isColGroupDef(treeB)) return treeA;
            const mergeResult = treeA;
            const groupToMerge = treeB;
            if (groupToMerge.children && groupToMerge.groupId) {
                const added = this.addChildrenToGroup(mergeResult, groupToMerge.groupId, groupToMerge.children[0]);
                if (added) return mergeResult;
            }
            groupToMerge.children.forEach((child)=>mergeTrees(mergeResult, child));
            return mergeResult;
        };
        const mergeColDefs = [];
        for(let i = 1; i <= leafPathTrees.length; i++){
            const first = leafPathTrees[i - 1];
            const second = leafPathTrees[i];
            if (matchingRootGroupIds(first, second)) leafPathTrees[i] = mergeTrees(first, second);
            else mergeColDefs.push(first);
        }
        return mergeColDefs;
    }
    addChildrenToGroup(tree, groupId, colDef) {
        const subGroupIsSplit = (currentSubGroup, currentSubGroupToAdd)=>{
            const existingChildIds = currentSubGroup.children.map(this.getId);
            const childGroupAlreadyExists = (0, $jIDNV._).includes(existingChildIds, this.getId(currentSubGroupToAdd));
            const lastChild = (0, $jIDNV._).last(currentSubGroup.children);
            const lastChildIsDifferent = lastChild && this.getId(lastChild) !== this.getId(currentSubGroupToAdd);
            return childGroupAlreadyExists && lastChildIsDifferent;
        };
        if (!this.isColGroupDef(tree)) return true;
        const currentGroup = tree;
        const groupToAdd = colDef;
        if (subGroupIsSplit(currentGroup, groupToAdd)) {
            currentGroup.children.push(groupToAdd);
            return true;
        }
        if (currentGroup.groupId === groupId) {
            const existingChildIds = currentGroup.children.map(this.getId);
            const colDefAlreadyPresent = (0, $jIDNV._).includes(existingChildIds, this.getId(groupToAdd));
            if (!colDefAlreadyPresent) {
                currentGroup.children.push(groupToAdd);
                return true;
            }
        }
        currentGroup.children.forEach((subGroup)=>this.addChildrenToGroup(subGroup, groupId, colDef));
        return false;
    }
};
$5b7ccabde48fae90$var$__decorateClass7([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$export$52f8319e10930bfa.prototype, "columnModel", 2);
$5b7ccabde48fae90$export$52f8319e10930bfa = $5b7ccabde48fae90$var$__decorateClass7([
    (0, $jIDNV.Bean)("toolPanelColDefService")
], $5b7ccabde48fae90$export$52f8319e10930bfa);
var $5b7ccabde48fae90$var$VERSION7 = "31.3.4";
var $5b7ccabde48fae90$var$SideBarService = class extends (0, $jIDNV.BeanStub) {
    registerSideBarComp(sideBarComp) {
        this.sideBarComp = sideBarComp;
    }
    getSideBarComp() {
        return this.sideBarComp;
    }
};
$5b7ccabde48fae90$var$SideBarService = $5b7ccabde48fae90$var$__decorateClass7([
    (0, $jIDNV.Bean)("sideBarService")
], $5b7ccabde48fae90$var$SideBarService);
var $5b7ccabde48fae90$export$707a9bd30915b7fe = {
    version: $5b7ccabde48fae90$var$VERSION7,
    moduleName: (0, $jIDNV.ModuleNames).SideBarModule,
    beans: [
        $5b7ccabde48fae90$export$52f8319e10930bfa,
        $5b7ccabde48fae90$var$SideBarService
    ],
    agStackComponents: [
        {
            componentName: "AgHorizontalResize",
            componentClass: $5b7ccabde48fae90$var$HorizontalResizeComp
        },
        {
            componentName: "AgSideBar",
            componentClass: $5b7ccabde48fae90$var$SideBarComp
        },
        {
            componentName: "AgSideBarButtons",
            componentClass: $5b7ccabde48fae90$var$SideBarButtonsComp
        }
    ],
    dependantModules: [
        $5b7ccabde48fae90$export$3a6d13add8617801
    ]
};
var $5b7ccabde48fae90$var$__defProp8 = Object.defineProperty;
var $5b7ccabde48fae90$var$__getOwnPropDesc8 = Object.getOwnPropertyDescriptor;
var $5b7ccabde48fae90$var$__getOwnPropSymbols6 = Object.getOwnPropertySymbols;
var $5b7ccabde48fae90$var$__hasOwnProp7 = Object.prototype.hasOwnProperty;
var $5b7ccabde48fae90$var$__propIsEnum6 = Object.prototype.propertyIsEnumerable;
var $5b7ccabde48fae90$var$__defNormalProp6 = (obj, key, value)=>key in obj ? $5b7ccabde48fae90$var$__defProp8(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5b7ccabde48fae90$var$__spreadValues6 = (a, b)=>{
    for(var prop in b || (b = {}))if ($5b7ccabde48fae90$var$__hasOwnProp7.call(b, prop)) $5b7ccabde48fae90$var$__defNormalProp6(a, prop, b[prop]);
    if ($5b7ccabde48fae90$var$__getOwnPropSymbols6) {
        for (var prop of $5b7ccabde48fae90$var$__getOwnPropSymbols6(b))if ($5b7ccabde48fae90$var$__propIsEnum6.call(b, prop)) $5b7ccabde48fae90$var$__defNormalProp6(a, prop, b[prop]);
    }
    return a;
};
var $5b7ccabde48fae90$var$__decorateClass8 = (decorators, target, key, kind)=>{
    var result = kind > 1 ? void 0 : kind ? $5b7ccabde48fae90$var$__getOwnPropDesc8(target, key) : target;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
    if (kind && result) $5b7ccabde48fae90$var$__defProp8(target, key, result);
    return result;
};
var $5b7ccabde48fae90$var$_PrimaryColsHeaderPanel = class _PrimaryColsHeaderPanel2 extends (0, $jIDNV.Component) {
    constructor(){
        super(_PrimaryColsHeaderPanel2.TEMPLATE);
    }
    postConstruct() {
        this.createExpandIcons();
        this.addManagedListener(this.eExpand, "click", this.onExpandClicked.bind(this));
        this.addManagedListener(this.eExpand, "keydown", (e)=>{
            if (e.key === (0, $jIDNV.KeyCode).SPACE) {
                e.preventDefault();
                this.onExpandClicked();
            }
        });
        this.addManagedListener(this.eSelect.getInputElement(), "click", this.onSelectClicked.bind(this));
        this.addManagedPropertyListener("functionsReadOnly", ()=>this.onFunctionsReadOnlyPropChanged());
        this.eFilterTextField.setAutoComplete(false).onValueChange(()=>this.onFilterTextChanged());
        this.addManagedListener(this.eFilterTextField.getInputElement(), "keydown", this.onMiniFilterKeyDown.bind(this));
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_NEW_COLUMNS_LOADED, this.showOrHideOptions.bind(this));
        const translate = this.localeService.getLocaleTextFunc();
        this.eSelect.setInputAriaLabel(translate("ariaColumnSelectAll", "Toggle Select All Columns"));
        this.eFilterTextField.setInputAriaLabel(translate("ariaFilterColumnsInput", "Filter Columns Input"));
        this.activateTabIndex([
            this.eExpand
        ]);
    }
    onFunctionsReadOnlyPropChanged() {
        const readOnly = this.gos.get("functionsReadOnly");
        this.eSelect.setReadOnly(readOnly);
        this.eSelect.addOrRemoveCssClass("ag-column-select-column-readonly", readOnly);
    }
    init(params) {
        this.params = params;
        const readOnly = this.gos.get("functionsReadOnly");
        this.eSelect.setReadOnly(readOnly);
        this.eSelect.addOrRemoveCssClass("ag-column-select-column-readonly", readOnly);
        if (this.columnModel.isReady()) this.showOrHideOptions();
    }
    createExpandIcons() {
        this.eExpand.appendChild(this.eExpandChecked = (0, $jIDNV._).createIconNoSpan("columnSelectOpen", this.gos));
        this.eExpand.appendChild(this.eExpandUnchecked = (0, $jIDNV._).createIconNoSpan("columnSelectClosed", this.gos));
        this.eExpand.appendChild(this.eExpandIndeterminate = (0, $jIDNV._).createIconNoSpan("columnSelectIndeterminate", this.gos));
        this.setExpandState(0);
    }
    // we only show expand / collapse if we are showing columns
    showOrHideOptions() {
        const showFilter = !this.params.suppressColumnFilter;
        const showSelect = !this.params.suppressColumnSelectAll;
        const showExpand = !this.params.suppressColumnExpandAll;
        const groupsPresent = this.columnModel.isPrimaryColumnGroupsPresent();
        const translate = this.localeService.getLocaleTextFunc();
        this.eFilterTextField.setInputPlaceholder(translate("searchOoo", "Search..."));
        (0, $jIDNV._).setDisplayed(this.eFilterTextField.getGui(), showFilter);
        (0, $jIDNV._).setDisplayed(this.eSelect.getGui(), showSelect);
        (0, $jIDNV._).setDisplayed(this.eExpand, showExpand && groupsPresent);
    }
    onFilterTextChanged() {
        if (!this.onFilterTextChangedDebounced) this.onFilterTextChangedDebounced = (0, $jIDNV._).debounce(()=>{
            const filterText = this.eFilterTextField.getValue();
            this.dispatchEvent({
                type: "filterChanged",
                filterText: filterText
            });
        }, _PrimaryColsHeaderPanel2.DEBOUNCE_DELAY);
        this.onFilterTextChangedDebounced();
    }
    onMiniFilterKeyDown(e) {
        if (e.key === (0, $jIDNV.KeyCode).ENTER) setTimeout(()=>this.onSelectClicked(), _PrimaryColsHeaderPanel2.DEBOUNCE_DELAY);
    }
    onSelectClicked() {
        this.dispatchEvent({
            type: this.selectState ? "unselectAll" : "selectAll"
        });
    }
    onExpandClicked() {
        this.dispatchEvent({
            type: this.expandState === 0 ? "collapseAll" : "expandAll"
        });
    }
    setExpandState(state) {
        this.expandState = state;
        (0, $jIDNV._).setDisplayed(this.eExpandChecked, this.expandState === 0);
        (0, $jIDNV._).setDisplayed(this.eExpandUnchecked, this.expandState === 1);
        (0, $jIDNV._).setDisplayed(this.eExpandIndeterminate, this.expandState === 2);
    }
    setSelectionState(state) {
        this.selectState = state;
        this.eSelect.setValue(this.selectState);
    }
};
$5b7ccabde48fae90$var$_PrimaryColsHeaderPanel.DEBOUNCE_DELAY = 300;
$5b7ccabde48fae90$var$_PrimaryColsHeaderPanel.TEMPLATE = /* html */ `<div class="ag-column-select-header" role="presentation">
            <div ref="eExpand" class="ag-column-select-header-icon"></div>
            <ag-checkbox ref="eSelect" class="ag-column-select-header-checkbox"></ag-checkbox>
            <ag-input-text-field class="ag-column-select-header-filter-wrapper" ref="eFilterTextField"></ag-input-text-field>
        </div>`;
$5b7ccabde48fae90$var$__decorateClass8([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$_PrimaryColsHeaderPanel.prototype, "columnModel", 2);
$5b7ccabde48fae90$var$__decorateClass8([
    (0, $jIDNV.RefSelector)("eExpand")
], $5b7ccabde48fae90$var$_PrimaryColsHeaderPanel.prototype, "eExpand", 2);
$5b7ccabde48fae90$var$__decorateClass8([
    (0, $jIDNV.RefSelector)("eSelect")
], $5b7ccabde48fae90$var$_PrimaryColsHeaderPanel.prototype, "eSelect", 2);
$5b7ccabde48fae90$var$__decorateClass8([
    (0, $jIDNV.RefSelector)("eFilterTextField")
], $5b7ccabde48fae90$var$_PrimaryColsHeaderPanel.prototype, "eFilterTextField", 2);
$5b7ccabde48fae90$var$__decorateClass8([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_PrimaryColsHeaderPanel.prototype, "postConstruct", 1);
var $5b7ccabde48fae90$var$PrimaryColsHeaderPanel = $5b7ccabde48fae90$var$_PrimaryColsHeaderPanel;
var $5b7ccabde48fae90$var$_ColumnModelItem = class _ColumnModelItem2 {
    constructor(displayName, columnOrGroup, dept, group = false, expanded){
        this.eventService = new (0, $jIDNV.EventService)();
        this.displayName = displayName;
        this.dept = dept;
        this.group = group;
        if (group) {
            this.columnGroup = columnOrGroup;
            this.expanded = expanded;
            this.children = [];
        } else this.column = columnOrGroup;
    }
    isGroup() {
        return this.group;
    }
    getDisplayName() {
        return this.displayName;
    }
    getColumnGroup() {
        return this.columnGroup;
    }
    getColumn() {
        return this.column;
    }
    getDept() {
        return this.dept;
    }
    isExpanded() {
        return !!this.expanded;
    }
    getChildren() {
        return this.children;
    }
    isPassesFilter() {
        return this.passesFilter;
    }
    setExpanded(expanded) {
        if (expanded === this.expanded) return;
        this.expanded = expanded;
        this.eventService.dispatchEvent({
            type: _ColumnModelItem2.EVENT_EXPANDED_CHANGED
        });
    }
    setPassesFilter(passesFilter) {
        this.passesFilter = passesFilter;
    }
    addEventListener(eventType, listener) {
        this.eventService.addEventListener(eventType, listener);
    }
    removeEventListener(eventType, listener) {
        this.eventService.removeEventListener(eventType, listener);
    }
};
$5b7ccabde48fae90$var$_ColumnModelItem.EVENT_EXPANDED_CHANGED = "expandedChanged";
var $5b7ccabde48fae90$var$ColumnModelItem = $5b7ccabde48fae90$var$_ColumnModelItem;
var $5b7ccabde48fae90$var$ToolPanelContextMenu = class extends (0, $jIDNV.Component) {
    constructor(column, mouseEvent, parentEl){
        super(/* html */ `<div class="ag-menu"></div>`);
        this.column = column;
        this.mouseEvent = mouseEvent;
        this.parentEl = parentEl;
        this.displayName = null;
    }
    postConstruct() {
        this.initializeProperties(this.column);
        this.buildMenuItemMap();
        if (this.column instanceof (0, $jIDNV.Column)) this.displayName = this.columnModel.getDisplayNameForColumn(this.column, "columnToolPanel");
        else this.displayName = this.columnModel.getDisplayNameForProvidedColumnGroup(null, this.column, "columnToolPanel");
        if (this.isActive()) {
            this.mouseEvent.preventDefault();
            const menuItemsMapped = this.getMappedMenuItems();
            if (menuItemsMapped.length === 0) return;
            this.displayContextMenu(menuItemsMapped);
        }
    }
    initializeProperties(column) {
        if (column instanceof (0, $jIDNV.ProvidedColumnGroup)) this.columns = column.getLeafColumns();
        else this.columns = [
            column
        ];
        this.allowGrouping = this.columns.some((col)=>col.isPrimary() && col.isAllowRowGroup());
        this.allowValues = this.columns.some((col)=>col.isPrimary() && col.isAllowValue());
        this.allowPivoting = this.columnModel.isPivotMode() && this.columns.some((col)=>col.isPrimary() && col.isAllowPivot());
    }
    buildMenuItemMap() {
        const localeTextFunc = this.localeService.getLocaleTextFunc();
        this.menuItemMap = /* @__PURE__ */ new Map();
        this.menuItemMap.set("rowGroup", {
            allowedFunction: (col)=>col.isPrimary() && col.isAllowRowGroup() && !this.columnModel.isColumnGroupingLocked(col),
            activeFunction: (col)=>col.isRowGroupActive(),
            activateLabel: ()=>`${localeTextFunc("groupBy", "Group by")} ${this.displayName}`,
            deactivateLabel: ()=>`${localeTextFunc("ungroupBy", "Un-Group by")} ${this.displayName}`,
            activateFunction: ()=>{
                const groupedColumns = this.columnModel.getRowGroupColumns();
                this.columnModel.setRowGroupColumns(this.addColumnsToList(groupedColumns), "toolPanelUi");
            },
            deActivateFunction: ()=>{
                const groupedColumns = this.columnModel.getRowGroupColumns();
                this.columnModel.setRowGroupColumns(this.removeColumnsFromList(groupedColumns), "toolPanelUi");
            },
            addIcon: "menuAddRowGroup",
            removeIcon: "menuRemoveRowGroup"
        });
        this.menuItemMap.set("value", {
            allowedFunction: (col)=>col.isPrimary() && col.isAllowValue(),
            activeFunction: (col)=>col.isValueActive(),
            activateLabel: ()=>localeTextFunc("addToValues", `Add ${this.displayName} to values`, [
                    this.displayName
                ]),
            deactivateLabel: ()=>localeTextFunc("removeFromValues", `Remove ${this.displayName} from values`, [
                    this.displayName
                ]),
            activateFunction: ()=>{
                const valueColumns = this.columnModel.getValueColumns();
                this.columnModel.setValueColumns(this.addColumnsToList(valueColumns), "toolPanelUi");
            },
            deActivateFunction: ()=>{
                const valueColumns = this.columnModel.getValueColumns();
                this.columnModel.setValueColumns(this.removeColumnsFromList(valueColumns), "toolPanelUi");
            },
            addIcon: "valuePanel",
            removeIcon: "valuePanel"
        });
        this.menuItemMap.set("pivot", {
            allowedFunction: (col)=>this.columnModel.isPivotMode() && col.isPrimary() && col.isAllowPivot(),
            activeFunction: (col)=>col.isPivotActive(),
            activateLabel: ()=>localeTextFunc("addToLabels", `Add ${this.displayName} to labels`, [
                    this.displayName
                ]),
            deactivateLabel: ()=>localeTextFunc("removeFromLabels", `Remove ${this.displayName} from labels`, [
                    this.displayName
                ]),
            activateFunction: ()=>{
                const pivotColumns = this.columnModel.getPivotColumns();
                this.columnModel.setPivotColumns(this.addColumnsToList(pivotColumns), "toolPanelUi");
            },
            deActivateFunction: ()=>{
                const pivotColumns = this.columnModel.getPivotColumns();
                this.columnModel.setPivotColumns(this.removeColumnsFromList(pivotColumns), "toolPanelUi");
            },
            addIcon: "pivotPanel",
            removeIcon: "pivotPanel"
        });
    }
    addColumnsToList(columnList) {
        return [
            ...columnList
        ].concat(this.columns.filter((col)=>columnList.indexOf(col) === -1));
    }
    removeColumnsFromList(columnList) {
        return columnList.filter((col)=>this.columns.indexOf(col) === -1);
    }
    displayContextMenu(menuItemsMapped) {
        const eGui = this.getGui();
        const menuList = this.createBean(new (0, $jIDNV.AgMenuList)());
        const localeTextFunc = this.localeService.getLocaleTextFunc();
        let hideFunc = ()=>{};
        eGui.appendChild(menuList.getGui());
        menuList.addMenuItems(menuItemsMapped);
        menuList.addManagedListener(menuList, (0, $jIDNV.AgMenuItemComponent).EVENT_CLOSE_MENU, ()=>{
            this.parentEl.focus();
            hideFunc();
        });
        const addPopupRes = this.popupService.addPopup({
            modal: true,
            eChild: eGui,
            closeOnEsc: true,
            afterGuiAttached: ()=>this.focusService.focusInto(menuList.getGui()),
            ariaLabel: localeTextFunc("ariaLabelContextMenu", "Context Menu"),
            closedCallback: (e)=>{
                if (e instanceof KeyboardEvent) this.parentEl.focus();
                this.destroyBean(menuList);
            }
        });
        if (addPopupRes) hideFunc = addPopupRes.hideFunc;
        this.popupService.positionPopupUnderMouseEvent({
            type: "columnContextMenu",
            mouseEvent: this.mouseEvent,
            ePopup: eGui
        });
    }
    isActive() {
        return this.allowGrouping || this.allowValues || this.allowPivoting;
    }
    getMappedMenuItems() {
        const ret = [];
        for (const val of this.menuItemMap.values()){
            const isInactive = this.columns.some((col)=>val.allowedFunction(col) && !val.activeFunction(col));
            const isActive = this.columns.some((col)=>val.allowedFunction(col) && val.activeFunction(col));
            if (isInactive) ret.push({
                name: val.activateLabel(this.displayName),
                icon: (0, $jIDNV._).createIconNoSpan(val.addIcon, this.gos, null),
                action: ()=>val.activateFunction()
            });
            if (isActive) ret.push({
                name: val.deactivateLabel(this.displayName),
                icon: (0, $jIDNV._).createIconNoSpan(val.removeIcon, this.gos, null),
                action: ()=>val.deActivateFunction()
            });
        }
        return ret;
    }
};
$5b7ccabde48fae90$var$__decorateClass8([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$ToolPanelContextMenu.prototype, "columnModel", 2);
$5b7ccabde48fae90$var$__decorateClass8([
    (0, $jIDNV.Autowired)("popupService")
], $5b7ccabde48fae90$var$ToolPanelContextMenu.prototype, "popupService", 2);
$5b7ccabde48fae90$var$__decorateClass8([
    (0, $jIDNV.Autowired)("focusService")
], $5b7ccabde48fae90$var$ToolPanelContextMenu.prototype, "focusService", 2);
$5b7ccabde48fae90$var$__decorateClass8([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$ToolPanelContextMenu.prototype, "postConstruct", 1);
var $5b7ccabde48fae90$var$_ToolPanelColumnGroupComp = class _ToolPanelColumnGroupComp2 extends (0, $jIDNV.Component) {
    constructor(modelItem, allowDragging, eventType, focusWrapper){
        super();
        this.modelItem = modelItem;
        this.allowDragging = allowDragging;
        this.eventType = eventType;
        this.focusWrapper = focusWrapper;
        this.processingColumnStateChange = false;
        this.modelItem = modelItem;
        this.columnGroup = modelItem.getColumnGroup();
        this.columnDept = modelItem.getDept();
        this.displayName = modelItem.getDisplayName();
        this.allowDragging = allowDragging;
    }
    init() {
        this.setTemplate(_ToolPanelColumnGroupComp2.TEMPLATE);
        this.eDragHandle = (0, $jIDNV._).createIconNoSpan("columnDrag", this.gos);
        this.eDragHandle.classList.add("ag-drag-handle", "ag-column-select-column-group-drag-handle");
        const checkboxGui = this.cbSelect.getGui();
        const checkboxInput = this.cbSelect.getInputElement();
        checkboxGui.insertAdjacentElement("afterend", this.eDragHandle);
        checkboxInput.setAttribute("tabindex", "-1");
        this.eLabel.innerHTML = this.displayName ? this.displayName : "";
        this.setupExpandContract();
        this.addCssClass("ag-column-select-indent-" + this.columnDept);
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_COLUMN_PIVOT_MODE_CHANGED, this.onColumnStateChanged.bind(this));
        this.addManagedListener(this.eLabel, "click", this.onLabelClicked.bind(this));
        this.addManagedListener(this.cbSelect, (0, $jIDNV.Events).EVENT_FIELD_VALUE_CHANGED, this.onCheckboxChanged.bind(this));
        this.addManagedListener(this.modelItem, $5b7ccabde48fae90$var$ColumnModelItem.EVENT_EXPANDED_CHANGED, this.onExpandChanged.bind(this));
        this.addManagedListener(this.focusWrapper, "keydown", this.handleKeyDown.bind(this));
        this.addManagedListener(this.focusWrapper, "contextmenu", this.onContextMenu.bind(this));
        this.setOpenClosedIcons();
        this.setupDragging();
        this.onColumnStateChanged();
        this.addVisibilityListenersToAllChildren();
        this.refreshAriaExpanded();
        this.refreshAriaLabel();
        this.setupTooltip();
        const classes = (0, $jIDNV.CssClassApplier).getToolPanelClassesFromColDef(this.columnGroup.getColGroupDef(), this.gos, null, this.columnGroup);
        classes.forEach((c)=>this.addOrRemoveCssClass(c, true));
    }
    getColumns() {
        return this.columnGroup.getLeafColumns();
    }
    setupTooltip() {
        const colGroupDef = this.columnGroup.getColGroupDef();
        if (!colGroupDef) return;
        const isTooltipWhenTruncated = this.gos.get("tooltipShowMode") === "whenTruncated";
        let shouldDisplayTooltip;
        if (isTooltipWhenTruncated) shouldDisplayTooltip = ()=>this.eLabel.scrollWidth > this.eLabel.clientWidth;
        const refresh = ()=>{
            const newTooltipText = colGroupDef.headerTooltip;
            this.setTooltip({
                newTooltipText: newTooltipText,
                location: "columnToolPanelColumnGroup",
                shouldDisplayTooltip: shouldDisplayTooltip
            });
        };
        refresh();
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_NEW_COLUMNS_LOADED, refresh);
    }
    getTooltipParams() {
        const res = super.getTooltipParams();
        res.location = "columnToolPanelColumnGroup";
        return res;
    }
    handleKeyDown(e) {
        switch(e.key){
            case (0, $jIDNV.KeyCode).LEFT:
                e.preventDefault();
                this.modelItem.setExpanded(false);
                break;
            case (0, $jIDNV.KeyCode).RIGHT:
                e.preventDefault();
                this.modelItem.setExpanded(true);
                break;
            case (0, $jIDNV.KeyCode).SPACE:
                e.preventDefault();
                if (this.isSelectable()) this.onSelectAllChanged(!this.isSelected());
                break;
        }
    }
    onContextMenu(e) {
        const { columnGroup: columnGroup, gos: gos } = this;
        if (gos.get("functionsReadOnly")) return;
        const contextMenu = this.createBean(new $5b7ccabde48fae90$var$ToolPanelContextMenu(columnGroup, e, this.focusWrapper));
        this.addDestroyFunc(()=>{
            if (contextMenu.isAlive()) this.destroyBean(contextMenu);
        });
    }
    addVisibilityListenersToAllChildren() {
        this.columnGroup.getLeafColumns().forEach((column)=>{
            this.addManagedListener(column, (0, $jIDNV.Column).EVENT_VISIBLE_CHANGED, this.onColumnStateChanged.bind(this));
            this.addManagedListener(column, (0, $jIDNV.Column).EVENT_VALUE_CHANGED, this.onColumnStateChanged.bind(this));
            this.addManagedListener(column, (0, $jIDNV.Column).EVENT_PIVOT_CHANGED, this.onColumnStateChanged.bind(this));
            this.addManagedListener(column, (0, $jIDNV.Column).EVENT_ROW_GROUP_CHANGED, this.onColumnStateChanged.bind(this));
        });
    }
    setupDragging() {
        if (!this.allowDragging) {
            (0, $jIDNV._).setDisplayed(this.eDragHandle, false);
            return;
        }
        let hideColumnOnExit = !this.gos.get("suppressDragLeaveHidesColumns");
        const dragSource = {
            type: (0, $jIDNV.DragSourceType).ToolPanel,
            eElement: this.eDragHandle,
            dragItemName: this.displayName,
            getDefaultIconName: ()=>hideColumnOnExit ? (0, $jIDNV.DragAndDropService).ICON_HIDE : (0, $jIDNV.DragAndDropService).ICON_NOT_ALLOWED,
            getDragItem: ()=>this.createDragItem(),
            onDragStarted: ()=>{
                hideColumnOnExit = !this.gos.get("suppressDragLeaveHidesColumns");
                const event = {
                    type: (0, $jIDNV.Events).EVENT_COLUMN_PANEL_ITEM_DRAG_START,
                    column: this.columnGroup
                };
                this.eventService.dispatchEvent(event);
            },
            onDragStopped: ()=>{
                const event = {
                    type: (0, $jIDNV.Events).EVENT_COLUMN_PANEL_ITEM_DRAG_END
                };
                this.eventService.dispatchEvent(event);
            },
            onGridEnter: (dragItem)=>{
                if (hideColumnOnExit) this.modelItemUtils.updateColumns({
                    columns: this.columnGroup.getLeafColumns(),
                    visibleState: dragItem == null ? void 0 : dragItem.visibleState,
                    pivotState: dragItem == null ? void 0 : dragItem.pivotState,
                    eventType: this.eventType
                });
            },
            onGridExit: ()=>{
                if (hideColumnOnExit) this.onChangeCommon(false);
            }
        };
        this.dragAndDropService.addDragSource(dragSource, true);
        this.addDestroyFunc(()=>this.dragAndDropService.removeDragSource(dragSource));
    }
    createDragItem() {
        const columns = this.columnGroup.getLeafColumns();
        const visibleState = {};
        const pivotState = {};
        columns.forEach((col)=>{
            const colId = col.getId();
            visibleState[colId] = col.isVisible();
            pivotState[colId] = this.modelItemUtils.createPivotState(col);
        });
        return {
            columns: columns,
            visibleState: visibleState,
            pivotState: pivotState
        };
    }
    setupExpandContract() {
        this.eGroupClosedIcon.appendChild((0, $jIDNV._).createIcon("columnSelectClosed", this.gos, null));
        this.eGroupOpenedIcon.appendChild((0, $jIDNV._).createIcon("columnSelectOpen", this.gos, null));
        this.addManagedListener(this.eGroupClosedIcon, "click", this.onExpandOrContractClicked.bind(this));
        this.addManagedListener(this.eGroupOpenedIcon, "click", this.onExpandOrContractClicked.bind(this));
        const touchListener = new (0, $jIDNV.TouchListener)(this.eColumnGroupIcons, true);
        this.addManagedListener(touchListener, (0, $jIDNV.TouchListener).EVENT_TAP, this.onExpandOrContractClicked.bind(this));
        this.addDestroyFunc(touchListener.destroy.bind(touchListener));
    }
    onLabelClicked() {
        const nextState = !this.cbSelect.getValue();
        this.onChangeCommon(nextState);
    }
    onCheckboxChanged(event) {
        this.onChangeCommon(event.selected);
    }
    getVisibleLeafColumns() {
        const childColumns = [];
        const extractCols = (children)=>{
            children.forEach((child)=>{
                if (!child.isPassesFilter()) return;
                if (child.isGroup()) extractCols(child.getChildren());
                else childColumns.push(child.getColumn());
            });
        };
        extractCols(this.modelItem.getChildren());
        return childColumns;
    }
    onChangeCommon(nextState) {
        this.refreshAriaLabel();
        if (this.processingColumnStateChange) return;
        this.modelItemUtils.selectAllChildren(this.modelItem.getChildren(), nextState, this.eventType);
    }
    refreshAriaLabel() {
        const translate = this.localeService.getLocaleTextFunc();
        const columnLabel = translate("ariaColumnGroup", "Column Group");
        const checkboxValue = this.cbSelect.getValue();
        const state = checkboxValue === void 0 ? translate("ariaIndeterminate", "indeterminate") : checkboxValue ? translate("ariaVisible", "visible") : translate("ariaHidden", "hidden");
        const visibilityLabel = translate("ariaToggleVisibility", "Press SPACE to toggle visibility");
        (0, $jIDNV._).setAriaLabel(this.focusWrapper, `${this.displayName} ${columnLabel}`);
        this.cbSelect.setInputAriaLabel(`${visibilityLabel} (${state})`);
        (0, $jIDNV._).setAriaDescribedBy(this.focusWrapper, this.cbSelect.getInputElement().id);
    }
    onColumnStateChanged() {
        const selectedValue = this.workOutSelectedValue();
        const readOnlyValue = this.workOutReadOnlyValue();
        this.processingColumnStateChange = true;
        this.cbSelect.setValue(selectedValue);
        this.cbSelect.setReadOnly(readOnlyValue);
        this.addOrRemoveCssClass("ag-column-select-column-group-readonly", readOnlyValue);
        this.processingColumnStateChange = false;
    }
    workOutSelectedValue() {
        const pivotMode = this.columnModel.isPivotMode();
        const visibleLeafColumns = this.getVisibleLeafColumns();
        let checkedCount = 0;
        let uncheckedCount = 0;
        visibleLeafColumns.forEach((column)=>{
            if (!pivotMode && column.getColDef().lockVisible) return;
            if (this.isColumnChecked(column, pivotMode)) checkedCount++;
            else uncheckedCount++;
        });
        if (checkedCount > 0 && uncheckedCount > 0) return void 0;
        return checkedCount > 0;
    }
    workOutReadOnlyValue() {
        const pivotMode = this.columnModel.isPivotMode();
        let colsThatCanAction = 0;
        this.columnGroup.getLeafColumns().forEach((col)=>{
            if (pivotMode) {
                if (col.isAnyFunctionAllowed()) colsThatCanAction++;
            } else if (!col.getColDef().lockVisible) colsThatCanAction++;
        });
        return colsThatCanAction === 0;
    }
    isColumnChecked(column, pivotMode) {
        if (pivotMode) {
            const pivoted = column.isPivotActive();
            const grouped = column.isRowGroupActive();
            const aggregated = column.isValueActive();
            return pivoted || grouped || aggregated;
        }
        return column.isVisible();
    }
    onExpandOrContractClicked() {
        const oldState = this.modelItem.isExpanded();
        this.modelItem.setExpanded(!oldState);
    }
    onExpandChanged() {
        this.setOpenClosedIcons();
        this.refreshAriaExpanded();
    }
    setOpenClosedIcons() {
        const folderOpen = this.modelItem.isExpanded();
        (0, $jIDNV._).setDisplayed(this.eGroupClosedIcon, !folderOpen);
        (0, $jIDNV._).setDisplayed(this.eGroupOpenedIcon, folderOpen);
    }
    refreshAriaExpanded() {
        (0, $jIDNV._).setAriaExpanded(this.focusWrapper, this.modelItem.isExpanded());
    }
    getDisplayName() {
        return this.displayName;
    }
    onSelectAllChanged(value) {
        const cbValue = this.cbSelect.getValue();
        const readOnly = this.cbSelect.isReadOnly();
        if (!readOnly && (value && !cbValue || !value && cbValue)) this.cbSelect.toggle();
    }
    isSelected() {
        return this.cbSelect.getValue();
    }
    isSelectable() {
        return !this.cbSelect.isReadOnly();
    }
    setSelected(selected) {
        this.cbSelect.setValue(selected, true);
    }
};
$5b7ccabde48fae90$var$_ToolPanelColumnGroupComp.TEMPLATE = /* html */ `<div class="ag-column-select-column-group" aria-hidden="true">
            <span class="ag-column-group-icons" ref="eColumnGroupIcons" >
                <span class="ag-column-group-closed-icon" ref="eGroupClosedIcon"></span>
                <span class="ag-column-group-opened-icon" ref="eGroupOpenedIcon"></span>
            </span>
            <ag-checkbox ref="cbSelect" class="ag-column-select-checkbox"></ag-checkbox>
            <span class="ag-column-select-column-label" ref="eLabel"></span>
        </div>`;
$5b7ccabde48fae90$var$__decorateClass8([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$_ToolPanelColumnGroupComp.prototype, "columnModel", 2);
$5b7ccabde48fae90$var$__decorateClass8([
    (0, $jIDNV.Autowired)("dragAndDropService")
], $5b7ccabde48fae90$var$_ToolPanelColumnGroupComp.prototype, "dragAndDropService", 2);
$5b7ccabde48fae90$var$__decorateClass8([
    (0, $jIDNV.Autowired)("modelItemUtils")
], $5b7ccabde48fae90$var$_ToolPanelColumnGroupComp.prototype, "modelItemUtils", 2);
$5b7ccabde48fae90$var$__decorateClass8([
    (0, $jIDNV.RefSelector)("cbSelect")
], $5b7ccabde48fae90$var$_ToolPanelColumnGroupComp.prototype, "cbSelect", 2);
$5b7ccabde48fae90$var$__decorateClass8([
    (0, $jIDNV.RefSelector)("eLabel")
], $5b7ccabde48fae90$var$_ToolPanelColumnGroupComp.prototype, "eLabel", 2);
$5b7ccabde48fae90$var$__decorateClass8([
    (0, $jIDNV.RefSelector)("eGroupOpenedIcon")
], $5b7ccabde48fae90$var$_ToolPanelColumnGroupComp.prototype, "eGroupOpenedIcon", 2);
$5b7ccabde48fae90$var$__decorateClass8([
    (0, $jIDNV.RefSelector)("eGroupClosedIcon")
], $5b7ccabde48fae90$var$_ToolPanelColumnGroupComp.prototype, "eGroupClosedIcon", 2);
$5b7ccabde48fae90$var$__decorateClass8([
    (0, $jIDNV.RefSelector)("eColumnGroupIcons")
], $5b7ccabde48fae90$var$_ToolPanelColumnGroupComp.prototype, "eColumnGroupIcons", 2);
$5b7ccabde48fae90$var$__decorateClass8([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_ToolPanelColumnGroupComp.prototype, "init", 1);
var $5b7ccabde48fae90$var$ToolPanelColumnGroupComp = $5b7ccabde48fae90$var$_ToolPanelColumnGroupComp;
var $5b7ccabde48fae90$var$PrimaryColsListPanelItemDragFeature = class extends (0, $jIDNV.BeanStub) {
    constructor(comp, virtualList){
        super();
        this.comp = comp;
        this.virtualList = virtualList;
    }
    postConstruct() {
        this.createManagedBean(new (0, $jIDNV.VirtualListDragFeature)(this.comp, this.virtualList, {
            dragSourceType: (0, $jIDNV.DragSourceType).ToolPanel,
            listItemDragStartEvent: (0, $jIDNV.Events).EVENT_COLUMN_PANEL_ITEM_DRAG_START,
            listItemDragEndEvent: (0, $jIDNV.Events).EVENT_COLUMN_PANEL_ITEM_DRAG_END,
            eventSource: this.eventService,
            getCurrentDragValue: (listItemDragStartEvent)=>this.getCurrentDragValue(listItemDragStartEvent),
            isMoveBlocked: (currentDragValue)=>this.isMoveBlocked(currentDragValue),
            getNumRows: (comp)=>comp.getDisplayedColsList().length,
            moveItem: (currentDragValue, lastHoveredListItem)=>this.moveItem(currentDragValue, lastHoveredListItem)
        }));
    }
    getCurrentDragValue(listItemDragStartEvent) {
        return listItemDragStartEvent.column;
    }
    isMoveBlocked(currentDragValue) {
        const preventMoving = this.gos.get("suppressMovableColumns");
        if (preventMoving) return true;
        const currentColumns = this.getCurrentColumns(currentDragValue);
        const hasNotMovable = currentColumns.find((col)=>{
            const colDef = col.getColDef();
            return !!colDef.suppressMovable || !!colDef.lockPosition;
        });
        return !!hasNotMovable;
    }
    moveItem(currentDragValue, lastHoveredListItem) {
        const targetIndex = this.getTargetIndex(currentDragValue, lastHoveredListItem);
        const columnsToMove = this.getCurrentColumns(currentDragValue);
        if (targetIndex != null) this.columnModel.moveColumns(columnsToMove, targetIndex, "toolPanelUi");
    }
    getMoveDiff(currentDragValue, end) {
        const allColumns = this.columnModel.getAllGridColumns();
        const currentColumns = this.getCurrentColumns(currentDragValue);
        const currentColumn = currentColumns[0];
        const span = currentColumns.length;
        const currentIndex = allColumns.indexOf(currentColumn);
        if (currentIndex < end) return span;
        return 0;
    }
    getCurrentColumns(currentDragValue) {
        if (currentDragValue instanceof (0, $jIDNV.ProvidedColumnGroup)) return currentDragValue.getLeafColumns();
        return [
            currentDragValue
        ];
    }
    getTargetIndex(currentDragValue, lastHoveredListItem) {
        if (!lastHoveredListItem) return null;
        const columnItemComponent = lastHoveredListItem.component;
        let isBefore = lastHoveredListItem.position === "top";
        let targetColumn;
        if (columnItemComponent instanceof $5b7ccabde48fae90$var$ToolPanelColumnGroupComp) {
            const columns = columnItemComponent.getColumns();
            targetColumn = columns[0];
            isBefore = true;
        } else targetColumn = columnItemComponent.getColumn();
        const movingCols = this.getCurrentColumns(currentDragValue);
        if (movingCols.indexOf(targetColumn) !== -1) return null;
        const targetColumnIndex = this.columnModel.getAllGridColumns().indexOf(targetColumn);
        const adjustedTarget = isBefore ? targetColumnIndex : targetColumnIndex + 1;
        const diff = this.getMoveDiff(currentDragValue, adjustedTarget);
        return adjustedTarget - diff;
    }
};
$5b7ccabde48fae90$var$__decorateClass8([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$PrimaryColsListPanelItemDragFeature.prototype, "columnModel", 2);
$5b7ccabde48fae90$var$__decorateClass8([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$PrimaryColsListPanelItemDragFeature.prototype, "postConstruct", 1);
var $5b7ccabde48fae90$var$_ToolPanelColumnComp = class _ToolPanelColumnComp2 extends (0, $jIDNV.Component) {
    constructor(modelItem, allowDragging, groupsExist, focusWrapper){
        super();
        this.allowDragging = allowDragging;
        this.groupsExist = groupsExist;
        this.focusWrapper = focusWrapper;
        this.processingColumnStateChange = false;
        this.column = modelItem.getColumn();
        this.columnDept = modelItem.getDept();
        this.displayName = modelItem.getDisplayName();
    }
    init() {
        this.setTemplate(_ToolPanelColumnComp2.TEMPLATE);
        this.eDragHandle = (0, $jIDNV._).createIconNoSpan("columnDrag", this.gos);
        this.eDragHandle.classList.add("ag-drag-handle", "ag-column-select-column-drag-handle");
        const checkboxGui = this.cbSelect.getGui();
        const checkboxInput = this.cbSelect.getInputElement();
        checkboxGui.insertAdjacentElement("afterend", this.eDragHandle);
        checkboxInput.setAttribute("tabindex", "-1");
        const displayNameSanitised = (0, $jIDNV._).escapeString(this.displayName);
        this.eLabel.innerHTML = displayNameSanitised;
        const indent = this.columnDept;
        if (this.groupsExist) this.addCssClass("ag-column-select-add-group-indent");
        this.addCssClass(`ag-column-select-indent-${indent}`);
        this.setupDragging();
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_COLUMN_PIVOT_MODE_CHANGED, this.onColumnStateChanged.bind(this));
        this.addManagedListener(this.column, (0, $jIDNV.Column).EVENT_VALUE_CHANGED, this.onColumnStateChanged.bind(this));
        this.addManagedListener(this.column, (0, $jIDNV.Column).EVENT_PIVOT_CHANGED, this.onColumnStateChanged.bind(this));
        this.addManagedListener(this.column, (0, $jIDNV.Column).EVENT_ROW_GROUP_CHANGED, this.onColumnStateChanged.bind(this));
        this.addManagedListener(this.column, (0, $jIDNV.Column).EVENT_VISIBLE_CHANGED, this.onColumnStateChanged.bind(this));
        this.addManagedListener(this.focusWrapper, "keydown", this.handleKeyDown.bind(this));
        this.addManagedListener(this.focusWrapper, "contextmenu", this.onContextMenu.bind(this));
        this.addManagedPropertyListener("functionsReadOnly", this.onColumnStateChanged.bind(this));
        this.addManagedListener(this.cbSelect, (0, $jIDNV.Events).EVENT_FIELD_VALUE_CHANGED, this.onCheckboxChanged.bind(this));
        this.addManagedListener(this.eLabel, "click", this.onLabelClicked.bind(this));
        this.onColumnStateChanged();
        this.refreshAriaLabel();
        this.setupTooltip();
        const classes = (0, $jIDNV.CssClassApplier).getToolPanelClassesFromColDef(this.column.getColDef(), this.gos, this.column, null);
        classes.forEach((c)=>this.addOrRemoveCssClass(c, true));
    }
    getColumn() {
        return this.column;
    }
    setupTooltip() {
        const isTooltipWhenTruncated = this.gos.get("tooltipShowMode") === "whenTruncated";
        let shouldDisplayTooltip;
        if (isTooltipWhenTruncated) shouldDisplayTooltip = ()=>this.eLabel.scrollWidth > this.eLabel.clientWidth;
        const refresh = ()=>{
            const newTooltipText = this.column.getColDef().headerTooltip;
            this.setTooltip({
                newTooltipText: newTooltipText,
                location: "columnToolPanelColumn",
                shouldDisplayTooltip: shouldDisplayTooltip
            });
        };
        refresh();
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_NEW_COLUMNS_LOADED, refresh);
    }
    getTooltipParams() {
        const res = super.getTooltipParams();
        res.location = "columnToolPanelColumn";
        res.colDef = this.column.getColDef();
        return res;
    }
    onContextMenu(e) {
        const { column: column, gos: gos } = this;
        if (gos.get("functionsReadOnly")) return;
        const contextMenu = this.createBean(new $5b7ccabde48fae90$var$ToolPanelContextMenu(column, e, this.focusWrapper));
        this.addDestroyFunc(()=>{
            if (contextMenu.isAlive()) this.destroyBean(contextMenu);
        });
    }
    handleKeyDown(e) {
        if (e.key === (0, $jIDNV.KeyCode).SPACE) {
            e.preventDefault();
            if (this.isSelectable()) this.onSelectAllChanged(!this.isSelected());
        }
    }
    onLabelClicked() {
        if (this.gos.get("functionsReadOnly")) return;
        const nextState = !this.cbSelect.getValue();
        this.onChangeCommon(nextState);
    }
    onCheckboxChanged(event) {
        this.onChangeCommon(event.selected);
    }
    onChangeCommon(nextState) {
        if (this.cbSelect.isReadOnly()) return;
        this.refreshAriaLabel();
        if (this.processingColumnStateChange) return;
        this.modelItemUtils.setColumn(this.column, nextState, "toolPanelUi");
    }
    refreshAriaLabel() {
        const translate = this.localeService.getLocaleTextFunc();
        const columnLabel = translate("ariaColumn", "Column");
        const state = this.cbSelect.getValue() ? translate("ariaVisible", "visible") : translate("ariaHidden", "hidden");
        const visibilityLabel = translate("ariaToggleVisibility", "Press SPACE to toggle visibility");
        (0, $jIDNV._).setAriaLabel(this.focusWrapper, `${this.displayName} ${columnLabel}`);
        this.cbSelect.setInputAriaLabel(`${visibilityLabel} (${state})`);
        (0, $jIDNV._).setAriaDescribedBy(this.focusWrapper, this.cbSelect.getInputElement().id);
    }
    setupDragging() {
        if (!this.allowDragging) {
            (0, $jIDNV._).setDisplayed(this.eDragHandle, false);
            return;
        }
        let hideColumnOnExit = !this.gos.get("suppressDragLeaveHidesColumns");
        const dragSource = {
            type: (0, $jIDNV.DragSourceType).ToolPanel,
            eElement: this.eDragHandle,
            dragItemName: this.displayName,
            getDefaultIconName: ()=>hideColumnOnExit ? (0, $jIDNV.DragAndDropService).ICON_HIDE : (0, $jIDNV.DragAndDropService).ICON_NOT_ALLOWED,
            getDragItem: ()=>this.createDragItem(),
            onDragStarted: ()=>{
                hideColumnOnExit = !this.gos.get("suppressDragLeaveHidesColumns");
                const event = {
                    type: (0, $jIDNV.Events).EVENT_COLUMN_PANEL_ITEM_DRAG_START,
                    column: this.column
                };
                this.eventService.dispatchEvent(event);
            },
            onDragStopped: ()=>{
                const event = {
                    type: (0, $jIDNV.Events).EVENT_COLUMN_PANEL_ITEM_DRAG_END
                };
                this.eventService.dispatchEvent(event);
            },
            onGridEnter: (dragItem)=>{
                if (hideColumnOnExit) this.modelItemUtils.updateColumns({
                    columns: [
                        this.column
                    ],
                    visibleState: dragItem == null ? void 0 : dragItem.visibleState,
                    pivotState: dragItem == null ? void 0 : dragItem.pivotState,
                    eventType: "toolPanelUi"
                });
            },
            onGridExit: ()=>{
                if (hideColumnOnExit) this.onChangeCommon(false);
            }
        };
        this.dragAndDropService.addDragSource(dragSource, true);
        this.addDestroyFunc(()=>this.dragAndDropService.removeDragSource(dragSource));
    }
    createDragItem() {
        const colId = this.column.getColId();
        const visibleState = {
            [colId]: this.column.isVisible()
        };
        const pivotState = {
            [colId]: this.modelItemUtils.createPivotState(this.column)
        };
        return {
            columns: [
                this.column
            ],
            visibleState: visibleState,
            pivotState: pivotState
        };
    }
    onColumnStateChanged() {
        this.processingColumnStateChange = true;
        const isPivotMode = this.columnModel.isPivotMode();
        if (isPivotMode) {
            const anyFunctionActive = this.column.isAnyFunctionActive();
            this.cbSelect.setValue(anyFunctionActive);
        } else this.cbSelect.setValue(this.column.isVisible());
        let canBeToggled = true;
        let canBeDragged = true;
        if (isPivotMode) {
            const functionsReadOnly = this.gos.get("functionsReadOnly");
            const noFunctionsAllowed = !this.column.isAnyFunctionAllowed();
            canBeToggled = !functionsReadOnly && !noFunctionsAllowed;
            canBeDragged = canBeToggled;
        } else {
            const { enableRowGroup: enableRowGroup, enableValue: enableValue, lockPosition: lockPosition, suppressMovable: suppressMovable, lockVisible: lockVisible } = this.column.getColDef();
            const forceDraggable = !!enableRowGroup || !!enableValue;
            const disableDraggable = !!lockPosition || !!suppressMovable;
            canBeToggled = !lockVisible;
            canBeDragged = forceDraggable || !disableDraggable;
        }
        this.cbSelect.setReadOnly(!canBeToggled);
        this.eDragHandle.classList.toggle("ag-column-select-column-readonly", !canBeDragged);
        this.addOrRemoveCssClass("ag-column-select-column-readonly", !canBeDragged && !canBeToggled);
        const checkboxPassive = isPivotMode && this.gos.get("functionsPassive");
        this.cbSelect.setPassive(checkboxPassive);
        this.processingColumnStateChange = false;
    }
    getDisplayName() {
        return this.displayName;
    }
    onSelectAllChanged(value) {
        if (value !== this.cbSelect.getValue()) {
            if (!this.cbSelect.isReadOnly()) this.cbSelect.toggle();
        }
    }
    isSelected() {
        return this.cbSelect.getValue();
    }
    isSelectable() {
        return !this.cbSelect.isReadOnly();
    }
    isExpandable() {
        return false;
    }
    setExpanded(value) {
        console.warn("AG Grid: can not expand a column item that does not represent a column group header");
    }
};
$5b7ccabde48fae90$var$_ToolPanelColumnComp.TEMPLATE = /* html */ `<div class="ag-column-select-column" aria-hidden="true">
            <ag-checkbox ref="cbSelect" class="ag-column-select-checkbox"></ag-checkbox>
            <span class="ag-column-select-column-label" ref="eLabel"></span>
        </div>`;
$5b7ccabde48fae90$var$__decorateClass8([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$_ToolPanelColumnComp.prototype, "columnModel", 2);
$5b7ccabde48fae90$var$__decorateClass8([
    (0, $jIDNV.Autowired)("dragAndDropService")
], $5b7ccabde48fae90$var$_ToolPanelColumnComp.prototype, "dragAndDropService", 2);
$5b7ccabde48fae90$var$__decorateClass8([
    (0, $jIDNV.Autowired)("modelItemUtils")
], $5b7ccabde48fae90$var$_ToolPanelColumnComp.prototype, "modelItemUtils", 2);
$5b7ccabde48fae90$var$__decorateClass8([
    (0, $jIDNV.RefSelector)("eLabel")
], $5b7ccabde48fae90$var$_ToolPanelColumnComp.prototype, "eLabel", 2);
$5b7ccabde48fae90$var$__decorateClass8([
    (0, $jIDNV.RefSelector)("cbSelect")
], $5b7ccabde48fae90$var$_ToolPanelColumnComp.prototype, "cbSelect", 2);
$5b7ccabde48fae90$var$__decorateClass8([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_ToolPanelColumnComp.prototype, "init", 1);
var $5b7ccabde48fae90$var$ToolPanelColumnComp = $5b7ccabde48fae90$var$_ToolPanelColumnComp;
var $5b7ccabde48fae90$var$UIColumnModel = class {
    constructor(items){
        this.items = items;
    }
    getRowCount() {
        return this.items.length;
    }
    getRow(index) {
        return this.items[index];
    }
};
var $5b7ccabde48fae90$var$PRIMARY_COLS_LIST_PANEL_CLASS = "ag-column-select-list";
var $5b7ccabde48fae90$var$_PrimaryColsListPanel = class _PrimaryColsListPanel2 extends (0, $jIDNV.Component) {
    constructor(){
        super(_PrimaryColsListPanel2.TEMPLATE);
        this.destroyColumnItemFuncs = [];
        this.hasLoadedInitialState = false;
        this.isInitialState = false;
    }
    destroyColumnTree() {
        this.allColsTree = [];
        this.destroyColumnItemFuncs.forEach((f)=>f());
        this.destroyColumnItemFuncs = [];
    }
    init(params, allowDragging, eventType) {
        this.params = params;
        this.allowDragging = allowDragging;
        this.eventType = eventType;
        if (!this.params.suppressSyncLayoutWithGrid) this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_COLUMN_MOVED, this.onColumnsChanged.bind(this));
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_NEW_COLUMNS_LOADED, this.onColumnsChanged.bind(this));
        const eventsImpactingCheckedState = [
            (0, $jIDNV.Events).EVENT_COLUMN_PIVOT_CHANGED,
            (0, $jIDNV.Events).EVENT_COLUMN_PIVOT_MODE_CHANGED,
            (0, $jIDNV.Events).EVENT_COLUMN_ROW_GROUP_CHANGED,
            (0, $jIDNV.Events).EVENT_COLUMN_VALUE_CHANGED,
            (0, $jIDNV.Events).EVENT_COLUMN_VISIBLE,
            (0, $jIDNV.Events).EVENT_NEW_COLUMNS_LOADED
        ];
        eventsImpactingCheckedState.forEach((event)=>{
            this.addManagedListener(this.eventService, event, this.fireSelectionChangedEvent.bind(this));
        });
        this.expandGroupsByDefault = !this.params.contractColumnSelection;
        this.virtualList = this.createManagedBean(new (0, $jIDNV.VirtualList)({
            cssIdentifier: "column-select",
            ariaRole: "tree"
        }));
        this.appendChild(this.virtualList.getGui());
        this.virtualList.setComponentCreator((item, listItemElement)=>{
            (0, $jIDNV._).setAriaLevel(listItemElement, item.getDept() + 1);
            return this.createComponentFromItem(item, listItemElement);
        });
        if (this.columnModel.isReady()) this.onColumnsChanged();
        if (this.params.suppressColumnMove) return;
        this.createManagedBean(new $5b7ccabde48fae90$var$PrimaryColsListPanelItemDragFeature(this, this.virtualList));
    }
    createComponentFromItem(item, listItemElement) {
        if (item.isGroup()) {
            const renderedGroup = new $5b7ccabde48fae90$var$ToolPanelColumnGroupComp(item, this.allowDragging, this.eventType, listItemElement);
            this.getContext().createBean(renderedGroup);
            return renderedGroup;
        }
        const columnComp = new $5b7ccabde48fae90$var$ToolPanelColumnComp(item, this.allowDragging, this.groupsExist, listItemElement);
        this.getContext().createBean(columnComp);
        return columnComp;
    }
    onColumnsChanged() {
        if (!this.hasLoadedInitialState) {
            this.hasLoadedInitialState = true;
            this.isInitialState = !!this.params.initialState;
        }
        const expandedStates = this.getExpandedStates();
        const pivotModeActive = this.columnModel.isPivotMode();
        const shouldSyncColumnLayoutWithGrid = !this.params.suppressSyncLayoutWithGrid && !pivotModeActive;
        if (shouldSyncColumnLayoutWithGrid) this.buildTreeFromWhatGridIsDisplaying();
        else this.buildTreeFromProvidedColumnDefs();
        this.setExpandedStates(expandedStates);
        this.markFilteredColumns();
        this.flattenAndFilterModel();
        this.isInitialState = false;
    }
    getDisplayedColsList() {
        return this.displayedColsList;
    }
    getExpandedStates() {
        const res = {};
        if (this.isInitialState) {
            const { expandedGroupIds: expandedGroupIds } = this.params.initialState;
            expandedGroupIds.forEach((id)=>{
                res[id] = true;
            });
            return res;
        }
        if (!this.allColsTree) return {};
        this.forEachItem((item)=>{
            if (!item.isGroup()) return;
            const colGroup = item.getColumnGroup();
            if (colGroup) res[colGroup.getId()] = item.isExpanded();
        });
        return res;
    }
    setExpandedStates(states) {
        if (!this.allColsTree) return;
        const { isInitialState: isInitialState } = this;
        this.forEachItem((item)=>{
            if (!item.isGroup()) return;
            const colGroup = item.getColumnGroup();
            if (colGroup) {
                const expanded = states[colGroup.getId()];
                const groupExistedLastTime = expanded != null;
                if (groupExistedLastTime || isInitialState) item.setExpanded(!!expanded);
            }
        });
    }
    buildTreeFromWhatGridIsDisplaying() {
        this.colDefService.syncLayoutWithGrid(this.setColumnLayout.bind(this));
    }
    setColumnLayout(colDefs) {
        const columnTree = this.colDefService.createColumnTree(colDefs);
        this.buildListModel(columnTree);
        this.groupsExist = colDefs.some((colDef)=>{
            return colDef && typeof colDef.children !== "undefined";
        });
        this.markFilteredColumns();
        this.flattenAndFilterModel();
    }
    buildTreeFromProvidedColumnDefs() {
        this.buildListModel(this.columnModel.getPrimaryColumnTree());
        this.groupsExist = this.columnModel.isPrimaryColumnGroupsPresent();
    }
    buildListModel(columnTree) {
        const columnExpandedListener = this.onColumnExpanded.bind(this);
        const addListeners = (item)=>{
            item.addEventListener($5b7ccabde48fae90$var$ColumnModelItem.EVENT_EXPANDED_CHANGED, columnExpandedListener);
            const removeFunc = item.removeEventListener.bind(item, $5b7ccabde48fae90$var$ColumnModelItem.EVENT_EXPANDED_CHANGED, columnExpandedListener);
            this.destroyColumnItemFuncs.push(removeFunc);
        };
        const recursivelyBuild = (tree, dept, parentList)=>{
            tree.forEach((child)=>{
                if (child instanceof (0, $jIDNV.ProvidedColumnGroup)) createGroupItem(child, dept, parentList);
                else createColumnItem(child, dept, parentList);
            });
        };
        const createGroupItem = (columnGroup, dept, parentList)=>{
            const columnGroupDef = columnGroup.getColGroupDef();
            const skipThisGroup = columnGroupDef && columnGroupDef.suppressColumnsToolPanel;
            if (skipThisGroup) return;
            if (columnGroup.isPadding()) {
                recursivelyBuild(columnGroup.getChildren(), dept, parentList);
                return;
            }
            const displayName = this.columnModel.getDisplayNameForProvidedColumnGroup(null, columnGroup, "columnToolPanel");
            const item = new $5b7ccabde48fae90$var$ColumnModelItem(displayName, columnGroup, dept, true, this.expandGroupsByDefault);
            parentList.push(item);
            addListeners(item);
            recursivelyBuild(columnGroup.getChildren(), dept + 1, item.getChildren());
        };
        const createColumnItem = (column, dept, parentList)=>{
            const skipThisColumn = column.getColDef() && column.getColDef().suppressColumnsToolPanel;
            if (skipThisColumn) return;
            const displayName = this.columnModel.getDisplayNameForColumn(column, "columnToolPanel");
            parentList.push(new $5b7ccabde48fae90$var$ColumnModelItem(displayName, column, dept));
        };
        this.destroyColumnTree();
        recursivelyBuild(columnTree, 0, this.allColsTree);
    }
    onColumnExpanded() {
        this.flattenAndFilterModel();
    }
    flattenAndFilterModel() {
        this.displayedColsList = [];
        const recursiveFunc = (item)=>{
            if (!item.isPassesFilter()) return;
            this.displayedColsList.push(item);
            if (item.isGroup() && item.isExpanded()) item.getChildren().forEach(recursiveFunc);
        };
        this.allColsTree.forEach(recursiveFunc);
        this.virtualList.setModel(new $5b7ccabde48fae90$var$UIColumnModel(this.displayedColsList));
        const focusedRow = this.virtualList.getLastFocusedRow();
        this.virtualList.refresh();
        if (focusedRow != null) this.focusRowIfAlive(focusedRow);
        this.notifyListeners();
        this.refreshAriaLabel();
    }
    refreshAriaLabel() {
        const translate = this.localeService.getLocaleTextFunc();
        const columnListName = translate("ariaColumnPanelList", "Column List");
        const localeColumns = translate("columns", "Columns");
        const items = this.displayedColsList.length;
        (0, $jIDNV._).setAriaLabel(this.virtualList.getAriaElement(), `${columnListName} ${items} ${localeColumns}`);
    }
    focusRowIfAlive(rowIndex) {
        window.setTimeout(()=>{
            if (this.isAlive()) this.virtualList.focusRow(rowIndex);
        }, 0);
    }
    forEachItem(callback) {
        const recursiveFunc = (items)=>{
            items.forEach((item)=>{
                callback(item);
                if (item.isGroup()) recursiveFunc(item.getChildren());
            });
        };
        if (!this.allColsTree) return;
        recursiveFunc(this.allColsTree);
    }
    doSetExpandedAll(value) {
        this.forEachItem((item)=>{
            if (item.isGroup()) item.setExpanded(value);
        });
    }
    setGroupsExpanded(expand, groupIds) {
        if (!groupIds) {
            this.doSetExpandedAll(expand);
            return;
        }
        const expandedGroupIds = [];
        this.forEachItem((item)=>{
            if (!item.isGroup()) return;
            const groupId = item.getColumnGroup().getId();
            if (groupIds.indexOf(groupId) >= 0) {
                item.setExpanded(expand);
                expandedGroupIds.push(groupId);
            }
        });
        const unrecognisedGroupIds = groupIds.filter((groupId)=>!(0, $jIDNV._).includes(expandedGroupIds, groupId));
        if (unrecognisedGroupIds.length > 0) console.warn("AG Grid: unable to find group(s) for supplied groupIds:", unrecognisedGroupIds);
    }
    getExpandState() {
        let expandedCount = 0;
        let notExpandedCount = 0;
        this.forEachItem((item)=>{
            if (!item.isGroup()) return;
            if (item.isExpanded()) expandedCount++;
            else notExpandedCount++;
        });
        if (expandedCount > 0 && notExpandedCount > 0) return 2;
        if (notExpandedCount > 0) return 1;
        return 0;
    }
    doSetSelectedAll(selectAllChecked) {
        this.modelItemUtils.selectAllChildren(this.allColsTree, selectAllChecked, this.eventType);
    }
    getSelectionState() {
        let checkedCount = 0;
        let uncheckedCount = 0;
        const pivotMode = this.columnModel.isPivotMode();
        this.forEachItem((item)=>{
            if (item.isGroup()) return;
            if (!item.isPassesFilter()) return;
            const column = item.getColumn();
            const colDef = column.getColDef();
            let checked;
            if (pivotMode) {
                const noPivotModeOptionsAllowed = !column.isAllowPivot() && !column.isAllowRowGroup() && !column.isAllowValue();
                if (noPivotModeOptionsAllowed) return;
                checked = column.isValueActive() || column.isPivotActive() || column.isRowGroupActive();
            } else {
                if (colDef.lockVisible) return;
                checked = column.isVisible();
            }
            checked ? checkedCount++ : uncheckedCount++;
        });
        if (checkedCount > 0 && uncheckedCount > 0) return void 0;
        return !(checkedCount === 0 || uncheckedCount > 0);
    }
    setFilterText(filterText) {
        this.filterText = (0, $jIDNV._).exists(filterText) ? filterText.toLowerCase() : null;
        this.markFilteredColumns();
        this.flattenAndFilterModel();
    }
    markFilteredColumns() {
        const passesFilter = (item)=>{
            if (!(0, $jIDNV._).exists(this.filterText)) return true;
            const displayName = item.getDisplayName();
            return displayName == null || displayName.toLowerCase().indexOf(this.filterText) !== -1;
        };
        const recursivelyCheckFilter = (item, parentPasses)=>{
            let atLeastOneChildPassed = false;
            if (item.isGroup()) {
                const groupPasses = passesFilter(item);
                item.getChildren().forEach((child)=>{
                    const childPasses = recursivelyCheckFilter(child, groupPasses || parentPasses);
                    if (childPasses) atLeastOneChildPassed = childPasses;
                });
            }
            const filterPasses = parentPasses || atLeastOneChildPassed ? true : passesFilter(item);
            item.setPassesFilter(filterPasses);
            return filterPasses;
        };
        this.allColsTree.forEach((item)=>recursivelyCheckFilter(item, false));
    }
    notifyListeners() {
        this.fireGroupExpandedEvent();
        this.fireSelectionChangedEvent();
    }
    fireGroupExpandedEvent() {
        const expandState = this.getExpandState();
        this.dispatchEvent({
            type: "groupExpanded",
            state: expandState
        });
    }
    fireSelectionChangedEvent() {
        if (!this.allColsTree) return;
        const selectionState = this.getSelectionState();
        this.dispatchEvent({
            type: "selectionChanged",
            state: selectionState
        });
    }
    getExpandedGroups() {
        const expandedGroupIds = [];
        if (!this.allColsTree) return expandedGroupIds;
        this.forEachItem((item)=>{
            if (item.isGroup() && item.isExpanded()) expandedGroupIds.push(item.getColumnGroup().getId());
        });
        return expandedGroupIds;
    }
};
$5b7ccabde48fae90$var$_PrimaryColsListPanel.TEMPLATE = /* html */ `<div class="${$5b7ccabde48fae90$var$PRIMARY_COLS_LIST_PANEL_CLASS}" role="presentation"></div>`;
$5b7ccabde48fae90$var$__decorateClass8([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$_PrimaryColsListPanel.prototype, "columnModel", 2);
$5b7ccabde48fae90$var$__decorateClass8([
    (0, $jIDNV.Autowired)("toolPanelColDefService")
], $5b7ccabde48fae90$var$_PrimaryColsListPanel.prototype, "colDefService", 2);
$5b7ccabde48fae90$var$__decorateClass8([
    (0, $jIDNV.Autowired)("modelItemUtils")
], $5b7ccabde48fae90$var$_PrimaryColsListPanel.prototype, "modelItemUtils", 2);
$5b7ccabde48fae90$var$__decorateClass8([
    (0, $jIDNV.PreDestroy)
], $5b7ccabde48fae90$var$_PrimaryColsListPanel.prototype, "destroyColumnTree", 1);
var $5b7ccabde48fae90$var$PrimaryColsListPanel = $5b7ccabde48fae90$var$_PrimaryColsListPanel;
var $5b7ccabde48fae90$var$PivotModePanel = class extends (0, $jIDNV.Component) {
    createTemplate() {
        return /* html */ `<div class="ag-pivot-mode-panel">
                <ag-toggle-button ref="cbPivotMode" class="ag-pivot-mode-select"></ag-toggle-button>
            </div>`;
    }
    init() {
        this.setTemplate(this.createTemplate());
        this.cbPivotMode.setValue(this.columnModel.isPivotMode());
        const localeTextFunc = this.localeService.getLocaleTextFunc();
        this.cbPivotMode.setLabel(localeTextFunc("pivotMode", "Pivot Mode"));
        this.addManagedListener(this.cbPivotMode, (0, $jIDNV.Events).EVENT_FIELD_VALUE_CHANGED, this.onBtPivotMode.bind(this));
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_NEW_COLUMNS_LOADED, this.onPivotModeChanged.bind(this));
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_COLUMN_PIVOT_MODE_CHANGED, this.onPivotModeChanged.bind(this));
    }
    onBtPivotMode() {
        const newValue = !!this.cbPivotMode.getValue();
        if (newValue !== this.columnModel.isPivotMode()) {
            this.gos.updateGridOptions({
                options: {
                    pivotMode: newValue
                },
                source: "toolPanelUi"
            });
            const { api: api } = this;
            if (api) api.refreshHeader();
        }
    }
    onPivotModeChanged() {
        const pivotModeActive = this.columnModel.isPivotMode();
        this.cbPivotMode.setValue(pivotModeActive);
    }
};
$5b7ccabde48fae90$var$__decorateClass8([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$PivotModePanel.prototype, "columnModel", 2);
$5b7ccabde48fae90$var$__decorateClass8([
    (0, $jIDNV.Autowired)("gridApi")
], $5b7ccabde48fae90$var$PivotModePanel.prototype, "api", 2);
$5b7ccabde48fae90$var$__decorateClass8([
    (0, $jIDNV.RefSelector)("cbPivotMode")
], $5b7ccabde48fae90$var$PivotModePanel.prototype, "cbPivotMode", 2);
$5b7ccabde48fae90$var$__decorateClass8([
    (0, $jIDNV.PreConstruct)
], $5b7ccabde48fae90$var$PivotModePanel.prototype, "init", 1);
var $5b7ccabde48fae90$var$_PrimaryColsPanel = class _PrimaryColsPanel2 extends (0, $jIDNV.Component) {
    constructor(){
        super(_PrimaryColsPanel2.TEMPLATE);
    }
    // we allow dragging in the toolPanel, but not when this component appears in the column menu
    init(allowDragging, params, eventType) {
        this.allowDragging = allowDragging;
        this.params = params;
        this.eventType = eventType;
        this.primaryColsHeaderPanel.init(this.params);
        const hideFilter = this.params.suppressColumnFilter;
        const hideSelect = this.params.suppressColumnSelectAll;
        const hideExpand = this.params.suppressColumnExpandAll;
        if (hideExpand && hideFilter && hideSelect) this.primaryColsHeaderPanel.setDisplayed(false);
        this.addManagedListener(this.primaryColsListPanel, "groupExpanded", this.onGroupExpanded.bind(this));
        this.addManagedListener(this.primaryColsListPanel, "selectionChanged", this.onSelectionChange.bind(this));
        this.primaryColsListPanel.init(this.params, this.allowDragging, this.eventType);
        this.addManagedListener(this.primaryColsHeaderPanel, "expandAll", this.onExpandAll.bind(this));
        this.addManagedListener(this.primaryColsHeaderPanel, "collapseAll", this.onCollapseAll.bind(this));
        this.addManagedListener(this.primaryColsHeaderPanel, "selectAll", this.onSelectAll.bind(this));
        this.addManagedListener(this.primaryColsHeaderPanel, "unselectAll", this.onUnselectAll.bind(this));
        this.addManagedListener(this.primaryColsHeaderPanel, "filterChanged", this.onFilterChanged.bind(this));
        this.positionableFeature = new (0, $jIDNV.PositionableFeature)(this.getGui(), {
            minHeight: 100
        });
        this.createManagedBean(this.positionableFeature);
    }
    toggleResizable(resizable) {
        this.positionableFeature.setResizable(resizable ? {
            bottom: true
        } : false);
    }
    onExpandAll() {
        this.primaryColsListPanel.doSetExpandedAll(true);
    }
    onCollapseAll() {
        this.primaryColsListPanel.doSetExpandedAll(false);
    }
    expandGroups(groupIds) {
        this.primaryColsListPanel.setGroupsExpanded(true, groupIds);
    }
    collapseGroups(groupIds) {
        this.primaryColsListPanel.setGroupsExpanded(false, groupIds);
    }
    setColumnLayout(colDefs) {
        this.primaryColsListPanel.setColumnLayout(colDefs);
    }
    onFilterChanged(event) {
        this.primaryColsListPanel.setFilterText(event.filterText);
    }
    syncLayoutWithGrid() {
        this.primaryColsListPanel.onColumnsChanged();
    }
    onSelectAll() {
        this.primaryColsListPanel.doSetSelectedAll(true);
    }
    onUnselectAll() {
        this.primaryColsListPanel.doSetSelectedAll(false);
    }
    onGroupExpanded(event) {
        this.primaryColsHeaderPanel.setExpandState(event.state);
        this.params.onStateUpdated();
    }
    onSelectionChange(event) {
        this.primaryColsHeaderPanel.setSelectionState(event.state);
    }
    getExpandedGroups() {
        return this.primaryColsListPanel.getExpandedGroups();
    }
};
$5b7ccabde48fae90$var$_PrimaryColsPanel.TEMPLATE = /* html */ `<div class="ag-column-select">
            <ag-primary-cols-header ref="primaryColsHeaderPanel"></ag-primary-cols-header>
            <ag-primary-cols-list ref="primaryColsListPanel"></ag-primary-cols-list>
        </div>`;
$5b7ccabde48fae90$var$__decorateClass8([
    (0, $jIDNV.RefSelector)("primaryColsHeaderPanel")
], $5b7ccabde48fae90$var$_PrimaryColsPanel.prototype, "primaryColsHeaderPanel", 2);
$5b7ccabde48fae90$var$__decorateClass8([
    (0, $jIDNV.RefSelector)("primaryColsListPanel")
], $5b7ccabde48fae90$var$_PrimaryColsPanel.prototype, "primaryColsListPanel", 2);
var $5b7ccabde48fae90$export$2d9d69c2ece71d89 = $5b7ccabde48fae90$var$_PrimaryColsPanel;
var $5b7ccabde48fae90$var$_ColumnToolPanel = class _ColumnToolPanel2 extends (0, $jIDNV.Component) {
    constructor(){
        super(_ColumnToolPanel2.TEMPLATE);
        this.initialised = false;
        this.childDestroyFuncs = [];
    }
    // lazy initialise the panel
    setVisible(visible) {
        super.setDisplayed(visible);
        if (visible && !this.initialised) this.init(this.params);
    }
    init(params) {
        const defaultParams = this.gos.addGridCommonParams({
            suppressColumnMove: false,
            suppressColumnSelectAll: false,
            suppressColumnFilter: false,
            suppressColumnExpandAll: false,
            contractColumnSelection: false,
            suppressPivotMode: false,
            suppressRowGroups: false,
            suppressValues: false,
            suppressPivots: false,
            suppressSyncLayoutWithGrid: false
        });
        this.params = $5b7ccabde48fae90$var$__spreadValues6($5b7ccabde48fae90$var$__spreadValues6({}, defaultParams), params);
        if (this.isRowGroupingModuleLoaded() && !this.params.suppressPivotMode) {
            this.pivotModePanel = this.createBean(new $5b7ccabde48fae90$var$PivotModePanel());
            this.childDestroyFuncs.push(()=>this.destroyBean(this.pivotModePanel));
            this.appendChild(this.pivotModePanel);
        }
        this.primaryColsPanel = this.createBean(new $5b7ccabde48fae90$export$2d9d69c2ece71d89());
        this.childDestroyFuncs.push(()=>this.destroyBean(this.primaryColsPanel));
        this.primaryColsPanel.init(true, this.params, "toolPanelUi");
        this.primaryColsPanel.addCssClass("ag-column-panel-column-select");
        this.appendChild(this.primaryColsPanel);
        if (this.isRowGroupingModuleLoaded()) {
            if (!this.params.suppressRowGroups) {
                this.rowGroupDropZonePanel = this.createBean(new $5b7ccabde48fae90$export$f3b209e86f7a7963(false));
                this.childDestroyFuncs.push(()=>this.destroyBean(this.rowGroupDropZonePanel));
                this.appendChild(this.rowGroupDropZonePanel);
            }
            if (!this.params.suppressValues) {
                this.valuesDropZonePanel = this.createBean(new $5b7ccabde48fae90$export$4c5515da8ced3ad7(false));
                this.childDestroyFuncs.push(()=>this.destroyBean(this.valuesDropZonePanel));
                this.appendChild(this.valuesDropZonePanel);
            }
            if (!this.params.suppressPivots) {
                this.pivotDropZonePanel = this.createBean(new $5b7ccabde48fae90$export$e3a33a41cac287e(false));
                this.childDestroyFuncs.push(()=>this.destroyBean(this.pivotDropZonePanel));
                this.appendChild(this.pivotDropZonePanel);
            }
            this.setLastVisible();
            const pivotModeListener = this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_COLUMN_PIVOT_MODE_CHANGED, ()=>{
                this.resetChildrenHeight();
                this.setLastVisible();
            });
            this.childDestroyFuncs.push(()=>pivotModeListener());
        }
        this.initialised = true;
    }
    setPivotModeSectionVisible(visible) {
        if (!this.isRowGroupingModuleLoaded()) return;
        if (this.pivotModePanel) this.pivotModePanel.setDisplayed(visible);
        else if (visible) {
            this.pivotModePanel = this.createBean(new $5b7ccabde48fae90$var$PivotModePanel());
            this.getGui().insertBefore(this.pivotModePanel.getGui(), this.getGui().firstChild);
            this.childDestroyFuncs.push(()=>this.destroyBean(this.pivotModePanel));
        }
        this.setLastVisible();
    }
    setRowGroupsSectionVisible(visible) {
        if (!this.isRowGroupingModuleLoaded()) return;
        if (this.rowGroupDropZonePanel) this.rowGroupDropZonePanel.setDisplayed(visible);
        else if (visible) {
            this.rowGroupDropZonePanel = this.createManagedBean(new $5b7ccabde48fae90$export$f3b209e86f7a7963(false));
            this.appendChild(this.rowGroupDropZonePanel);
        }
        this.setLastVisible();
    }
    setValuesSectionVisible(visible) {
        if (!this.isRowGroupingModuleLoaded()) return;
        if (this.valuesDropZonePanel) this.valuesDropZonePanel.setDisplayed(visible);
        else if (visible) {
            this.valuesDropZonePanel = this.createManagedBean(new $5b7ccabde48fae90$export$4c5515da8ced3ad7(false));
            this.appendChild(this.valuesDropZonePanel);
        }
        this.setLastVisible();
    }
    setPivotSectionVisible(visible) {
        if (!this.isRowGroupingModuleLoaded()) return;
        if (this.pivotDropZonePanel) this.pivotDropZonePanel.setDisplayed(visible);
        else if (visible) {
            this.pivotDropZonePanel = this.createManagedBean(new $5b7ccabde48fae90$export$e3a33a41cac287e(false));
            this.appendChild(this.pivotDropZonePanel);
            this.pivotDropZonePanel.setDisplayed(visible);
        }
        this.setLastVisible();
    }
    setResizers() {
        [
            this.primaryColsPanel,
            this.rowGroupDropZonePanel,
            this.valuesDropZonePanel,
            this.pivotDropZonePanel
        ].forEach((panel)=>{
            if (!panel) return;
            const eGui = panel.getGui();
            panel.toggleResizable(!eGui.classList.contains("ag-last-column-drop") && !eGui.classList.contains("ag-hidden"));
        });
    }
    setLastVisible() {
        const eGui = this.getGui();
        const columnDrops = Array.prototype.slice.call(eGui.querySelectorAll(".ag-column-drop"));
        columnDrops.forEach((columnDrop)=>columnDrop.classList.remove("ag-last-column-drop"));
        const columnDropEls = eGui.querySelectorAll(".ag-column-drop:not(.ag-hidden)");
        const lastVisible = (0, $jIDNV._).last(columnDropEls);
        if (lastVisible) lastVisible.classList.add("ag-last-column-drop");
        this.setResizers();
    }
    resetChildrenHeight() {
        const eGui = this.getGui();
        const children = eGui.children;
        for(let i = 0; i < children.length; i++){
            const child = children[i];
            child.style.removeProperty("height");
            child.style.removeProperty("flex");
        }
    }
    isRowGroupingModuleLoaded() {
        return (0, $jIDNV.ModuleRegistry).__assertRegistered((0, $jIDNV.ModuleNames).RowGroupingModule, "Row Grouping", this.context.getGridId());
    }
    expandColumnGroups(groupIds) {
        this.primaryColsPanel.expandGroups(groupIds);
    }
    collapseColumnGroups(groupIds) {
        this.primaryColsPanel.collapseGroups(groupIds);
    }
    setColumnLayout(colDefs) {
        this.primaryColsPanel.setColumnLayout(colDefs);
    }
    syncLayoutWithGrid() {
        this.primaryColsPanel.syncLayoutWithGrid();
    }
    destroyChildren() {
        this.childDestroyFuncs.forEach((func)=>func());
        this.childDestroyFuncs.length = 0;
        (0, $jIDNV._).clearElement(this.getGui());
    }
    refresh(params) {
        this.destroyChildren();
        this.init(params);
        return true;
    }
    getState() {
        return {
            expandedGroupIds: this.primaryColsPanel.getExpandedGroups()
        };
    }
    // this is a user component, and IComponent has "public destroy()" as part of the interface.
    // so this must be public.
    destroy() {
        this.destroyChildren();
        super.destroy();
    }
};
$5b7ccabde48fae90$var$_ColumnToolPanel.TEMPLATE = `<div class="ag-column-panel"></div>`;
var $5b7ccabde48fae90$var$ColumnToolPanel = $5b7ccabde48fae90$var$_ColumnToolPanel;
var $5b7ccabde48fae90$var$ModelItemUtils = class {
    selectAllChildren(colTree, selectAllChecked, eventType) {
        const cols = this.extractAllLeafColumns(colTree);
        this.setAllColumns(cols, selectAllChecked, eventType);
    }
    setColumn(col, selectAllChecked, eventType) {
        this.setAllColumns([
            col
        ], selectAllChecked, eventType);
    }
    setAllColumns(cols, selectAllChecked, eventType) {
        if (this.columnModel.isPivotMode()) this.setAllPivot(cols, selectAllChecked, eventType);
        else this.setAllVisible(cols, selectAllChecked, eventType);
    }
    extractAllLeafColumns(allItems) {
        const res = [];
        const recursiveFunc = (items)=>{
            items.forEach((item)=>{
                if (!item.isPassesFilter()) return;
                if (item.isGroup()) recursiveFunc(item.getChildren());
                else res.push(item.getColumn());
            });
        };
        recursiveFunc(allItems);
        return res;
    }
    setAllVisible(columns, visible, eventType) {
        const colStateItems = [];
        columns.forEach((col)=>{
            if (col.getColDef().lockVisible) return;
            if (col.isVisible() != visible) colStateItems.push({
                colId: col.getId(),
                hide: !visible
            });
        });
        if (colStateItems.length > 0) this.columnModel.applyColumnState({
            state: colStateItems
        }, eventType);
    }
    setAllPivot(columns, value, eventType) {
        if (this.gos.get("functionsPassive")) this.setAllPivotPassive(columns, value);
        else this.setAllPivotActive(columns, value, eventType);
    }
    setAllPivotPassive(columns, value) {
        const copyOfPivotColumns = this.columnModel.getPivotColumns().slice();
        const copyOfValueColumns = this.columnModel.getValueColumns().slice();
        const copyOfRowGroupColumns = this.columnModel.getRowGroupColumns().slice();
        let pivotChanged = false;
        let valueChanged = false;
        let rowGroupChanged = false;
        const turnOnAction = (col)=>{
            if (col.isAnyFunctionActive()) return;
            if (col.isAllowValue()) {
                copyOfValueColumns.push(col);
                valueChanged = true;
            } else if (col.isAllowRowGroup()) {
                copyOfRowGroupColumns.push(col);
                pivotChanged = true;
            } else if (col.isAllowPivot()) {
                copyOfPivotColumns.push(col);
                rowGroupChanged = true;
            }
        };
        const turnOffAction = (col)=>{
            if (!col.isAnyFunctionActive()) return;
            if (copyOfPivotColumns.indexOf(col) >= 0) {
                (0, $jIDNV._).removeFromArray(copyOfPivotColumns, col);
                pivotChanged = true;
            }
            if (copyOfValueColumns.indexOf(col) >= 0) {
                (0, $jIDNV._).removeFromArray(copyOfValueColumns, col);
                valueChanged = true;
            }
            if (copyOfRowGroupColumns.indexOf(col) >= 0) {
                (0, $jIDNV._).removeFromArray(copyOfRowGroupColumns, col);
                rowGroupChanged = true;
            }
        };
        const action = value ? turnOnAction : turnOffAction;
        columns.forEach(action);
        if (pivotChanged) {
            const event = {
                type: (0, $jIDNV.Events).EVENT_COLUMN_PIVOT_CHANGE_REQUEST,
                columns: copyOfPivotColumns
            };
            this.eventService.dispatchEvent(event);
        }
        if (rowGroupChanged) {
            const event = {
                type: (0, $jIDNV.Events).EVENT_COLUMN_ROW_GROUP_CHANGE_REQUEST,
                columns: copyOfRowGroupColumns
            };
            this.eventService.dispatchEvent(event);
        }
        if (valueChanged) {
            const event = {
                type: (0, $jIDNV.Events).EVENT_COLUMN_VALUE_CHANGE_REQUEST,
                columns: copyOfRowGroupColumns
            };
            this.eventService.dispatchEvent(event);
        }
    }
    setAllPivotActive(columns, value, eventType) {
        const colStateItems = [];
        const turnOnAction = (col)=>{
            if (col.isAnyFunctionActive()) return;
            if (col.isAllowValue()) {
                const aggFunc = typeof col.getAggFunc() === "string" ? col.getAggFunc() : this.aggFuncService.getDefaultAggFunc(col);
                colStateItems.push({
                    colId: col.getId(),
                    aggFunc: aggFunc
                });
            } else if (col.isAllowRowGroup()) colStateItems.push({
                colId: col.getId(),
                rowGroup: true
            });
            else if (col.isAllowPivot()) colStateItems.push({
                colId: col.getId(),
                pivot: true
            });
        };
        const turnOffAction = (col)=>{
            const isActive = col.isPivotActive() || col.isRowGroupActive() || col.isValueActive();
            if (isActive) colStateItems.push({
                colId: col.getId(),
                pivot: false,
                rowGroup: false,
                aggFunc: null
            });
        };
        const action = value ? turnOnAction : turnOffAction;
        columns.forEach(action);
        if (colStateItems.length > 0) this.columnModel.applyColumnState({
            state: colStateItems
        }, eventType);
    }
    updateColumns(params) {
        const { columns: columns, visibleState: visibleState, pivotState: pivotState, eventType: eventType } = params;
        const state = columns.map((column)=>{
            const colId = column.getColId();
            if (this.columnModel.isPivotMode()) {
                const pivotStateForColumn = pivotState == null ? void 0 : pivotState[colId];
                return {
                    colId: colId,
                    pivot: pivotStateForColumn == null ? void 0 : pivotStateForColumn.pivot,
                    rowGroup: pivotStateForColumn == null ? void 0 : pivotStateForColumn.rowGroup,
                    aggFunc: pivotStateForColumn == null ? void 0 : pivotStateForColumn.aggFunc
                };
            } else return {
                colId: colId,
                hide: !(visibleState == null ? void 0 : visibleState[colId])
            };
        });
        this.columnModel.applyColumnState({
            state: state
        }, eventType);
    }
    createPivotState(column) {
        return {
            pivot: column.isPivotActive(),
            rowGroup: column.isRowGroupActive(),
            aggFunc: column.isValueActive() ? column.getAggFunc() : void 0
        };
    }
};
$5b7ccabde48fae90$var$__decorateClass8([
    (0, $jIDNV.Autowired)("aggFuncService")
], $5b7ccabde48fae90$var$ModelItemUtils.prototype, "aggFuncService", 2);
$5b7ccabde48fae90$var$__decorateClass8([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$ModelItemUtils.prototype, "columnModel", 2);
$5b7ccabde48fae90$var$__decorateClass8([
    (0, $jIDNV.Autowired)("gridOptionsService")
], $5b7ccabde48fae90$var$ModelItemUtils.prototype, "gos", 2);
$5b7ccabde48fae90$var$__decorateClass8([
    (0, $jIDNV.Autowired)("eventService")
], $5b7ccabde48fae90$var$ModelItemUtils.prototype, "eventService", 2);
$5b7ccabde48fae90$var$ModelItemUtils = $5b7ccabde48fae90$var$__decorateClass8([
    (0, $jIDNV.Bean)("modelItemUtils")
], $5b7ccabde48fae90$var$ModelItemUtils);
var $5b7ccabde48fae90$var$VERSION8 = "31.3.4";
var $5b7ccabde48fae90$export$8ff0dc87b3f8200e = {
    version: $5b7ccabde48fae90$var$VERSION8,
    moduleName: (0, $jIDNV.ModuleNames).ColumnsToolPanelModule,
    beans: [
        $5b7ccabde48fae90$var$ModelItemUtils
    ],
    agStackComponents: [
        {
            componentName: "AgPrimaryColsHeader",
            componentClass: $5b7ccabde48fae90$var$PrimaryColsHeaderPanel
        },
        {
            componentName: "AgPrimaryColsList",
            componentClass: $5b7ccabde48fae90$var$PrimaryColsListPanel
        },
        {
            componentName: "AgPrimaryCols",
            componentClass: $5b7ccabde48fae90$export$2d9d69c2ece71d89
        }
    ],
    userComponents: [
        {
            componentName: "agColumnsToolPanel",
            componentClass: $5b7ccabde48fae90$var$ColumnToolPanel
        }
    ],
    dependantModules: [
        $5b7ccabde48fae90$export$3a6d13add8617801,
        $5b7ccabde48fae90$export$e67935bd41653107,
        $5b7ccabde48fae90$export$707a9bd30915b7fe
    ]
};
var $5b7ccabde48fae90$var$__defProp9 = Object.defineProperty;
var $5b7ccabde48fae90$var$__defProps6 = Object.defineProperties;
var $5b7ccabde48fae90$var$__getOwnPropDesc9 = Object.getOwnPropertyDescriptor;
var $5b7ccabde48fae90$var$__getOwnPropDescs6 = Object.getOwnPropertyDescriptors;
var $5b7ccabde48fae90$var$__getOwnPropSymbols7 = Object.getOwnPropertySymbols;
var $5b7ccabde48fae90$var$__hasOwnProp8 = Object.prototype.hasOwnProperty;
var $5b7ccabde48fae90$var$__propIsEnum7 = Object.prototype.propertyIsEnumerable;
var $5b7ccabde48fae90$var$__defNormalProp7 = (obj, key, value)=>key in obj ? $5b7ccabde48fae90$var$__defProp9(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5b7ccabde48fae90$var$__spreadValues7 = (a, b)=>{
    for(var prop in b || (b = {}))if ($5b7ccabde48fae90$var$__hasOwnProp8.call(b, prop)) $5b7ccabde48fae90$var$__defNormalProp7(a, prop, b[prop]);
    if ($5b7ccabde48fae90$var$__getOwnPropSymbols7) {
        for (var prop of $5b7ccabde48fae90$var$__getOwnPropSymbols7(b))if ($5b7ccabde48fae90$var$__propIsEnum7.call(b, prop)) $5b7ccabde48fae90$var$__defNormalProp7(a, prop, b[prop]);
    }
    return a;
};
var $5b7ccabde48fae90$var$__spreadProps6 = (a, b)=>$5b7ccabde48fae90$var$__defProps6(a, $5b7ccabde48fae90$var$__getOwnPropDescs6(b));
var $5b7ccabde48fae90$var$__decorateClass9 = (decorators, target, key, kind)=>{
    var result = kind > 1 ? void 0 : kind ? $5b7ccabde48fae90$var$__getOwnPropDesc9(target, key) : target;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
    if (kind && result) $5b7ccabde48fae90$var$__defProp9(target, key, result);
    return result;
};
var $5b7ccabde48fae90$var$coreFactory = {
    getTemplate (author) {
        const dt = /* @__PURE__ */ new Date();
        const jsonDate = dt.toJSON();
        return {
            name: "cp:coreProperties",
            properties: {
                prefixedAttributes: [
                    {
                        prefix: "xmlns:",
                        map: {
                            cp: "http://schemas.openxmlformats.org/package/2006/metadata/core-properties",
                            dc: "http://purl.org/dc/elements/1.1/",
                            dcterms: "http://purl.org/dc/terms/",
                            dcmitype: "http://purl.org/dc/dcmitype/",
                            xsi: "http://www.w3.org/2001/XMLSchema-instance"
                        }
                    }
                ]
            },
            children: [
                {
                    name: "dc:creator",
                    textNode: author
                },
                {
                    name: "dc:title",
                    textNode: "Workbook"
                },
                {
                    name: "dcterms:created",
                    properties: {
                        rawMap: {
                            "xsi:type": "dcterms:W3CDTF"
                        }
                    },
                    textNode: jsonDate
                },
                {
                    name: "dcterms:modified",
                    properties: {
                        rawMap: {
                            "xsi:type": "dcterms:W3CDTF"
                        }
                    },
                    textNode: jsonDate
                }
            ]
        };
    }
};
var $5b7ccabde48fae90$var$core_default = $5b7ccabde48fae90$var$coreFactory;
var $5b7ccabde48fae90$var$contentTypeFactory = {
    getTemplate (config) {
        const { name: name, ContentType: ContentType, Extension: Extension, PartName: PartName } = config;
        return {
            name: name,
            properties: {
                rawMap: {
                    Extension: Extension,
                    PartName: PartName,
                    ContentType: ContentType
                }
            }
        };
    }
};
var $5b7ccabde48fae90$var$contentType_default = $5b7ccabde48fae90$var$contentTypeFactory;
var $5b7ccabde48fae90$var$contentTypesFactory = {
    getTemplate (sheetLen) {
        const worksheets = new Array(sheetLen).fill(void 0).map((v, i)=>({
                name: "Override",
                ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",
                PartName: `/xl/worksheets/sheet${i + 1}.xml`
            }));
        const sheetsWithImages = $5b7ccabde48fae90$var$ExcelXlsxFactory.worksheetImages.size;
        const headerFooterImages = $5b7ccabde48fae90$var$ExcelXlsxFactory.worksheetHeaderFooterImages.size;
        const sheetsWithTables = $5b7ccabde48fae90$var$ExcelXlsxFactory.worksheetDataTables.size;
        const imageTypesObject = {};
        $5b7ccabde48fae90$var$ExcelXlsxFactory.workbookImageIds.forEach((v)=>{
            const type = v.type === "jpg" ? "jpeg" : v.type;
            imageTypesObject[type] = true;
        });
        const imageDocs = new Array(sheetsWithImages).fill(void 0).map((v, i)=>({
                name: "Override",
                ContentType: "application/vnd.openxmlformats-officedocument.drawing+xml",
                PartName: `/xl/drawings/drawing${i + 1}.xml`
            }));
        const tableDocs = new Array(sheetsWithTables).fill(void 0).map((v, i)=>({
                name: "Override",
                ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml",
                PartName: `/xl/tables/${$5b7ccabde48fae90$var$ExcelXlsxFactory.getTableNameFromIndex(i)}.xml`
            }));
        const imageTypes = Object.keys(imageTypesObject).map((ext)=>({
                name: "Default",
                ContentType: `image/${ext}`,
                Extension: ext
            }));
        if (headerFooterImages) imageTypes.push({
            name: "Default",
            Extension: "vml",
            ContentType: "application/vnd.openxmlformats-officedocument.vmlDrawing"
        });
        const children = [
            ...imageTypes,
            {
                name: "Default",
                Extension: "rels",
                ContentType: "application/vnd.openxmlformats-package.relationships+xml"
            },
            {
                name: "Default",
                ContentType: "application/xml",
                Extension: "xml"
            },
            {
                name: "Override",
                ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",
                PartName: "/xl/workbook.xml"
            },
            ...worksheets,
            {
                name: "Override",
                ContentType: "application/vnd.openxmlformats-officedocument.theme+xml",
                PartName: "/xl/theme/theme1.xml"
            },
            {
                name: "Override",
                ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",
                PartName: "/xl/styles.xml"
            },
            {
                name: "Override",
                ContentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",
                PartName: "/xl/sharedStrings.xml"
            },
            ...imageDocs,
            ...tableDocs,
            {
                name: "Override",
                ContentType: "application/vnd.openxmlformats-package.core-properties+xml",
                PartName: "/docProps/core.xml"
            }
        ].map((contentType)=>$5b7ccabde48fae90$var$contentType_default.getTemplate(contentType));
        return {
            name: "Types",
            properties: {
                rawMap: {
                    xmlns: "http://schemas.openxmlformats.org/package/2006/content-types"
                }
            },
            children: children
        };
    }
};
var $5b7ccabde48fae90$var$contentTypes_default = $5b7ccabde48fae90$var$contentTypesFactory;
var $5b7ccabde48fae90$var$INCH_TO_EMU = 9525;
var $5b7ccabde48fae90$var$numberFormatMap = {
    "0": 1,
    "0.00": 2,
    "#,##0": 3,
    "#,##0.00": 4,
    "0%": 9,
    "0.00%": 10,
    "0.00E+00": 11,
    "# ?/?": 12,
    "# ??/??": 13,
    "mm-dd-yy": 14,
    "d-mmm-yy": 15,
    "d-mmm": 16,
    "mmm-yy": 17,
    "h:mm AM/PM": 18,
    "h:mm:ss AM/PM": 19,
    "h:mm": 20,
    "h:mm:ss": 21,
    "m/d/yy h:mm": 22,
    "#,##0 ;(#,##0)": 37,
    "#,##0 ;[Red](#,##0)": 38,
    "#,##0.00;(#,##0.00)": 39,
    "#,##0.00;[Red](#,##0.00)": 40,
    "mm:ss": 45,
    "[h]:mm:ss": 46,
    "mmss.0": 47,
    "##0.0E+0": 48,
    "@": 49
};
var $5b7ccabde48fae90$var$pixelsToPoint = (pixels)=>{
    return Math.round(pixels * 72 / 96);
};
var $5b7ccabde48fae90$var$pointsToPixel = (points)=>{
    return Math.round(points * 96 / 72);
};
var $5b7ccabde48fae90$var$pixelsToEMU = (value)=>{
    return Math.ceil(value * $5b7ccabde48fae90$var$INCH_TO_EMU);
};
var $5b7ccabde48fae90$var$getFontFamilyId = (name)=>{
    if (name === void 0) return;
    const families = [
        "Automatic",
        "Roman",
        "Swiss",
        "Modern",
        "Script",
        "Decorative"
    ];
    const pos = families.indexOf(name || "Automatic");
    return Math.max(pos, 0);
};
var $5b7ccabde48fae90$var$getHeightFromProperty = (rowIndex, height)=>{
    if (!height) return;
    let finalHeight;
    if (typeof height === "number") finalHeight = height;
    else {
        const heightFunc = height;
        finalHeight = heightFunc({
            rowIndex: rowIndex
        });
    }
    return $5b7ccabde48fae90$var$pixelsToPoint(finalHeight);
};
var $5b7ccabde48fae90$var$setExcelImageTotalWidth = (image, columnsToExport)=>{
    const { colSpan: colSpan, column: column } = image.position;
    if (!image.width) return;
    if (colSpan) {
        const columnsInSpan = columnsToExport.slice(column - 1, column + colSpan - 1);
        let totalWidth = 0;
        for(let i = 0; i < columnsInSpan.length; i++){
            const colWidth = columnsInSpan[i].getActualWidth();
            if (image.width < totalWidth + colWidth) {
                image.position.colSpan = i + 1;
                image.totalWidth = image.width;
                image.width = image.totalWidth - totalWidth;
                break;
            }
            totalWidth += colWidth;
        }
    } else image.totalWidth = image.width;
};
var $5b7ccabde48fae90$var$setExcelImageTotalHeight = (image, rowHeight)=>{
    const { rowSpan: rowSpan, row: row } = image.position;
    if (!image.height) return;
    if (rowSpan) {
        let totalHeight = 0;
        let counter = 0;
        for(let i = row; i < row + rowSpan; i++){
            const nextRowHeight = $5b7ccabde48fae90$var$pointsToPixel($5b7ccabde48fae90$var$getHeightFromProperty(i, rowHeight) || 20);
            if (image.height < totalHeight + nextRowHeight) {
                image.position.rowSpan = counter + 1;
                image.totalHeight = image.height;
                image.height = image.totalHeight - totalHeight;
                break;
            }
            totalHeight += nextRowHeight;
            counter++;
        }
    } else image.totalHeight = image.height;
};
var $5b7ccabde48fae90$var$createXmlPart = (body, skipHeader)=>{
    const header = (0, $jIDNV.XmlFactory).createHeader({
        encoding: "UTF-8",
        standalone: "yes"
    });
    const xmlBody = (0, $jIDNV.XmlFactory).createXml(body);
    if (skipHeader) return xmlBody;
    return `${header}${xmlBody}`;
};
var $5b7ccabde48fae90$var$getExcelColumnName = (colIdx)=>{
    const startCode = 65;
    const tableWidth = 26;
    const fromCharCode = String.fromCharCode;
    const pos = Math.floor(colIdx / tableWidth);
    const tableIdx = colIdx % tableWidth;
    if (!pos || colIdx === tableWidth) return fromCharCode(startCode + colIdx - 1);
    if (!tableIdx) return $5b7ccabde48fae90$var$getExcelColumnName(pos - 1) + "Z";
    if (pos < tableWidth) return fromCharCode(startCode + pos - 1) + fromCharCode(startCode + tableIdx - 1);
    return $5b7ccabde48fae90$var$getExcelColumnName(pos) + fromCharCode(startCode + tableIdx - 1);
};
var $5b7ccabde48fae90$var$getAnchor = (name, imageAnchor)=>({
        name: `xdr:${name}`,
        children: [
            {
                name: "xdr:col",
                textNode: imageAnchor.col.toString()
            },
            {
                name: "xdr:colOff",
                textNode: imageAnchor.offsetX.toString()
            },
            {
                name: "xdr:row",
                textNode: imageAnchor.row.toString()
            },
            {
                name: "xdr:rowOff",
                textNode: imageAnchor.offsetY.toString()
            }
        ]
    });
var $5b7ccabde48fae90$var$getExt = (image)=>{
    const children = [
        {
            name: "a:ext",
            properties: {
                rawMap: {
                    uri: "{FF2B5EF4-FFF2-40B4-BE49-F238E27FC236}"
                }
            },
            children: [
                {
                    name: "a16:creationId",
                    properties: {
                        rawMap: {
                            "id": "{822E6D20-D7BC-2841-A643-D49A6EF008A2}",
                            "xmlns:a16": "http://schemas.microsoft.com/office/drawing/2014/main"
                        }
                    }
                }
            ]
        }
    ];
    const recolor = image.recolor && image.recolor.toLowerCase();
    switch(recolor){
        case "grayscale":
        case "sepia":
        case "washout":
            children.push({
                name: "a:ext",
                properties: {
                    rawMap: {
                        uri: "{C183D7F6-B498-43B3-948B-1728B52AA6E4}"
                    }
                },
                children: [
                    {
                        name: "adec:decorative",
                        properties: {
                            rawMap: {
                                "val": "0",
                                "xmlns:adec": "http://schemas.microsoft.com/office/drawing/2017/decorative"
                            }
                        }
                    }
                ]
            });
    }
    return {
        name: "a:extLst",
        children: children
    };
};
var $5b7ccabde48fae90$var$getNvPicPr = (image, index)=>({
        name: "xdr:nvPicPr",
        children: [
            {
                name: "xdr:cNvPr",
                properties: {
                    rawMap: {
                        id: index,
                        name: image.id,
                        descr: image.altText != null ? image.altText : void 0
                    }
                },
                children: [
                    $5b7ccabde48fae90$var$getExt(image)
                ]
            },
            {
                name: "xdr:cNvPicPr",
                properties: {
                    rawMap: {
                        preferRelativeResize: "0"
                    }
                },
                children: [
                    {
                        name: "a:picLocks"
                    }
                ]
            }
        ]
    });
var $5b7ccabde48fae90$var$getColorDetails = (color)=>{
    if (!color.saturation && !color.tint) return;
    const ret = [];
    if (color.saturation) ret.push({
        name: "a:satMod",
        properties: {
            rawMap: {
                val: color.saturation * 1e3
            }
        }
    });
    if (color.tint) ret.push({
        name: "a:tint",
        properties: {
            rawMap: {
                val: color.tint * 1e3
            }
        }
    });
    return ret;
};
var $5b7ccabde48fae90$var$getDuoTone = (primaryColor, secondaryColor)=>{
    return {
        name: "a:duotone",
        children: [
            {
                name: "a:prstClr",
                properties: {
                    rawMap: {
                        val: primaryColor.color
                    }
                },
                children: $5b7ccabde48fae90$var$getColorDetails(primaryColor)
            },
            {
                name: "a:srgbClr",
                properties: {
                    rawMap: {
                        val: secondaryColor.color
                    }
                },
                children: $5b7ccabde48fae90$var$getColorDetails(secondaryColor)
            }
        ]
    };
};
var $5b7ccabde48fae90$var$getBlipFill = (image, index)=>{
    let blipChildren;
    if (image.transparency) {
        const transparency = Math.min(Math.max(image.transparency, 0), 100);
        blipChildren = [
            {
                name: "a:alphaModFix",
                properties: {
                    rawMap: {
                        amt: 1e5 - Math.round(transparency * 1e3)
                    }
                }
            }
        ];
    }
    if (image.recolor) {
        if (!blipChildren) blipChildren = [];
        switch(image.recolor.toLocaleLowerCase()){
            case "grayscale":
                blipChildren.push({
                    name: "a:grayscl"
                });
                break;
            case "sepia":
                blipChildren.push($5b7ccabde48fae90$var$getDuoTone({
                    color: "black"
                }, {
                    color: "D9C3A5",
                    tint: 50,
                    saturation: 180
                }));
                break;
            case "washout":
                blipChildren.push({
                    name: "a:lum",
                    properties: {
                        rawMap: {
                            bright: "70000",
                            contrast: "-70000"
                        }
                    }
                });
                break;
            default:
        }
    }
    return {
        name: "xdr:blipFill",
        children: [
            {
                name: "a:blip",
                properties: {
                    rawMap: {
                        "cstate": "print",
                        "r:embed": `rId${index}`,
                        "xmlns:r": "http://schemas.openxmlformats.org/officeDocument/2006/relationships"
                    }
                },
                children: blipChildren
            },
            {
                name: "a:stretch",
                children: [
                    {
                        name: "a:fillRect"
                    }
                ]
            }
        ]
    };
};
var $5b7ccabde48fae90$var$getSpPr = (image, imageBoxSize)=>{
    const xfrm = {
        name: "a:xfrm",
        children: [
            {
                name: "a:off",
                properties: {
                    rawMap: {
                        x: 0,
                        y: 0
                    }
                }
            },
            {
                name: "a:ext",
                properties: {
                    rawMap: {
                        cx: imageBoxSize.width,
                        cy: imageBoxSize.height
                    }
                }
            }
        ]
    };
    if (image.rotation) {
        const rotation = image.rotation;
        xfrm.properties = {
            rawMap: {
                rot: Math.min(Math.max(rotation, 0), 360) * 6e4
            }
        };
    }
    const prstGeom = {
        name: "a:prstGeom",
        properties: {
            rawMap: {
                prst: "rect"
            }
        },
        children: [
            {
                name: "a:avLst"
            }
        ]
    };
    const ret = {
        name: "xdr:spPr",
        children: [
            xfrm,
            prstGeom
        ]
    };
    return ret;
};
var $5b7ccabde48fae90$var$getImageBoxSize = (image)=>{
    image.fitCell = !!image.fitCell || !image.width || !image.height;
    const { position: position = {}, fitCell: fitCell, width: width = 0, height: height = 0, totalHeight: totalHeight, totalWidth: totalWidth } = image;
    const { offsetX: offsetX = 0, offsetY: offsetY = 0, row: row = 1, rowSpan: rowSpan = 1, column: column = 1, colSpan: colSpan = 1 } = position;
    return {
        from: {
            row: row - 1,
            col: column - 1,
            offsetX: $5b7ccabde48fae90$var$pixelsToEMU(offsetX),
            offsetY: $5b7ccabde48fae90$var$pixelsToEMU(offsetY)
        },
        to: {
            row: row - 1 + (fitCell ? 1 : rowSpan - 1),
            col: column - 1 + (fitCell ? 1 : colSpan - 1),
            offsetX: $5b7ccabde48fae90$var$pixelsToEMU(width + offsetX),
            offsetY: $5b7ccabde48fae90$var$pixelsToEMU(height + offsetY)
        },
        height: $5b7ccabde48fae90$var$pixelsToEMU(totalHeight || height),
        width: $5b7ccabde48fae90$var$pixelsToEMU(totalWidth || width)
    };
};
var $5b7ccabde48fae90$var$getPicture = (image, currentIndex, worksheetImageIndex, imageBoxSize)=>{
    return {
        name: "xdr:pic",
        children: [
            $5b7ccabde48fae90$var$getNvPicPr(image, currentIndex + 1),
            $5b7ccabde48fae90$var$getBlipFill(image, worksheetImageIndex + 1),
            $5b7ccabde48fae90$var$getSpPr(image, imageBoxSize)
        ]
    };
};
var $5b7ccabde48fae90$var$drawingFactory = {
    getTemplate (config) {
        const { sheetIndex: sheetIndex } = config;
        const sheetImages = $5b7ccabde48fae90$var$ExcelXlsxFactory.worksheetImages.get(sheetIndex);
        const sheetImageIds = $5b7ccabde48fae90$var$ExcelXlsxFactory.worksheetImageIds.get(sheetIndex);
        const children = sheetImages.map((image, idx)=>{
            const boxSize = $5b7ccabde48fae90$var$getImageBoxSize(image);
            return {
                name: "xdr:twoCellAnchor",
                properties: {
                    rawMap: {
                        editAs: "absolute"
                    }
                },
                children: [
                    $5b7ccabde48fae90$var$getAnchor("from", boxSize.from),
                    $5b7ccabde48fae90$var$getAnchor("to", boxSize.to),
                    $5b7ccabde48fae90$var$getPicture(image, idx, sheetImageIds.get(image.id).index, boxSize),
                    {
                        name: "xdr:clientData"
                    }
                ]
            };
        });
        return {
            name: "xdr:wsDr",
            properties: {
                rawMap: {
                    "xmlns:a": "http://schemas.openxmlformats.org/drawingml/2006/main",
                    "xmlns:xdr": "http://schemas.openxmlformats.org/drawingml/2006/spreadsheetDrawing"
                }
            },
            children: children
        };
    }
};
var $5b7ccabde48fae90$var$drawing_default = $5b7ccabde48fae90$var$drawingFactory;
var $5b7ccabde48fae90$var$tableFactory = {
    getTemplate (dataTable, idx) {
        const { name: name, columns: columns, rowCount: rowCount, displayName: displayName, headerRowIndex: headerRowIndex, showRowStripes: showRowStripes, showColumnStripes: showColumnStripes, showFilterButtons: showFilterButtons, highlightFirstColumn: highlightFirstColumn, highlightLastColumn: highlightLastColumn } = dataTable || {};
        if (!dataTable || !name || !Array.isArray(columns) || !columns.length || !rowCount) return {
            name: "table"
        };
        const filterColumns = columns.map((col, idx2)=>({
                name: "filterColumn",
                properties: {
                    rawMap: {
                        colId: idx2.toString(),
                        // For filters, this should start with 0
                        hiddenButton: showFilterButtons[idx2] ? 0 : 1
                    }
                }
            }));
        const firstRow = headerRowIndex + 1;
        const id = (idx + 1).toString();
        const firstCell = `A${firstRow}`;
        const lastCell = `${String.fromCharCode(64 + columns.length)}${firstRow + rowCount}`;
        const ref = `${firstCell}:${lastCell}`;
        const displayNameToUse = idx ? `${displayName}_${idx + 1}` : displayName;
        return {
            name: "table",
            properties: {
                rawMap: {
                    "xmlns": "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
                    "xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
                    "mc:Ignorable": "xr xr3",
                    "xmlns:xr": "http://schemas.microsoft.com/office/spreadsheetml/2014/revision",
                    "xmlns:xr3": "http://schemas.microsoft.com/office/spreadsheetml/2016/revision3",
                    "name": name,
                    "displayName": displayNameToUse,
                    "ref": ref,
                    "totalsRowShown": 0,
                    "id": id
                }
            },
            children: [
                {
                    name: "autoFilter",
                    properties: {
                        rawMap: {
                            ref: ref
                        }
                    },
                    children: filterColumns
                },
                {
                    name: "tableColumns",
                    properties: {
                        rawMap: {
                            count: columns.length
                        }
                    },
                    children: columns.map((col, idx2)=>({
                            name: "tableColumn",
                            properties: {
                                rawMap: {
                                    id: (idx2 + 1).toString(),
                                    name: col,
                                    dataCellStyle: "Normal"
                                }
                            }
                        }))
                },
                {
                    name: "tableStyleInfo",
                    properties: {
                        rawMap: {
                            name: "TableStyleLight1",
                            showFirstColumn: highlightFirstColumn ? 1 : 0,
                            showLastColumn: highlightLastColumn ? 1 : 0,
                            showRowStripes: showRowStripes ? 1 : 0,
                            showColumnStripes: showColumnStripes ? 1 : 0
                        }
                    }
                }
            ]
        };
    }
};
var $5b7ccabde48fae90$var$table_default = $5b7ccabde48fae90$var$tableFactory;
var $5b7ccabde48fae90$var$getColorChildren = (props)=>{
    const [type, innerType, val, lastClr] = props;
    return {
        name: `a:${type}`,
        children: [
            {
                name: `a:${innerType}`,
                properties: {
                    rawMap: {
                        val: val,
                        lastClr: lastClr
                    }
                }
            }
        ]
    };
};
var $5b7ccabde48fae90$var$colorScheme = {
    getTemplate () {
        return {
            name: "a:clrScheme",
            properties: {
                rawMap: {
                    name: "Office"
                }
            },
            children: [
                $5b7ccabde48fae90$var$getColorChildren([
                    "dk1",
                    "sysClr",
                    "windowText",
                    "000000"
                ]),
                $5b7ccabde48fae90$var$getColorChildren([
                    "lt1",
                    "sysClr",
                    "window",
                    "FFFFFF"
                ]),
                $5b7ccabde48fae90$var$getColorChildren([
                    "dk2",
                    "srgbClr",
                    "44546A"
                ]),
                $5b7ccabde48fae90$var$getColorChildren([
                    "lt2",
                    "srgbClr",
                    "E7E6E6"
                ]),
                $5b7ccabde48fae90$var$getColorChildren([
                    "accent1",
                    "srgbClr",
                    "4472C4"
                ]),
                $5b7ccabde48fae90$var$getColorChildren([
                    "accent2",
                    "srgbClr",
                    "ED7D31"
                ]),
                $5b7ccabde48fae90$var$getColorChildren([
                    "accent3",
                    "srgbClr",
                    "A5A5A5"
                ]),
                $5b7ccabde48fae90$var$getColorChildren([
                    "accent4",
                    "srgbClr",
                    "FFC000"
                ]),
                $5b7ccabde48fae90$var$getColorChildren([
                    "accent5",
                    "srgbClr",
                    "5B9BD5"
                ]),
                $5b7ccabde48fae90$var$getColorChildren([
                    "accent6",
                    "srgbClr",
                    "70AD47"
                ]),
                $5b7ccabde48fae90$var$getColorChildren([
                    "hlink",
                    "srgbClr",
                    "0563C1"
                ]),
                $5b7ccabde48fae90$var$getColorChildren([
                    "folHlink",
                    "srgbClr",
                    "954F72"
                ])
            ]
        };
    }
};
var $5b7ccabde48fae90$var$colorScheme_default = $5b7ccabde48fae90$var$colorScheme;
var $5b7ccabde48fae90$var$getFont = (props)=>{
    const [type, typeface, script, panose] = props;
    return {
        name: `a:${type}`,
        properties: {
            rawMap: {
                script: script,
                typeface: typeface,
                panose: panose
            }
        }
    };
};
var $5b7ccabde48fae90$var$fontScheme = {
    getTemplate () {
        return {
            name: "a:fontScheme",
            properties: {
                rawMap: {
                    name: "Office"
                }
            },
            children: [
                {
                    name: "a:majorFont",
                    children: [
                        $5b7ccabde48fae90$var$getFont([
                            "latin",
                            "Calibri Light",
                            void 0,
                            "020F0302020204030204"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "ea",
                            ""
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "cs",
                            ""
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "\u6E38\u30B4\u30B7\u30C3\u30AF Light",
                            "Jpan"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "\uB9D1\uC740 \uACE0\uB515",
                            "Hang"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "\u7B49\u7EBF Light",
                            "Hans"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "\u65B0\u7D30\u660E\u9AD4",
                            "Hant"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Times New Roman",
                            "Arab"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Times New Roman",
                            "Hebr"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Tahoma",
                            "Thai"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Nyala",
                            "Ethi"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Vrinda",
                            "Beng"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Shruti",
                            "Gujr"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "MoolBoran",
                            "Khmr"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Tunga",
                            "Knda"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Raavi",
                            "Guru"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Euphemia",
                            "Cans"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Plantagenet Cherokee",
                            "Cher"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Microsoft Yi Baiti",
                            "Yiii"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Microsoft Himalaya",
                            "Tibt"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "MV Boli",
                            "Thaa"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Mangal",
                            "Deva"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Gautami",
                            "Telu"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Latha",
                            "Taml"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Estrangelo Edessa",
                            "Syrc"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Kalinga",
                            "Orya"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Kartika",
                            "Mlym"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "DokChampa",
                            "Laoo"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Iskoola Pota",
                            "Sinh"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Mongolian Baiti",
                            "Mong"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Times New Roman",
                            "Viet"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Microsoft Uighur",
                            "Uigh"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Sylfaen",
                            "Geor"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Arial",
                            "Armn"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Leelawadee UI",
                            "Bugi"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Microsoft JhengHei",
                            "Bopo"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Javanese Text",
                            "Java"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Segoe UI",
                            "Lisu"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Myanmar Text",
                            "Mymr"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Ebrima",
                            "Nkoo"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Nirmala UI",
                            "Olck"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Ebrima",
                            "Osma"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Phagspa",
                            "Phag"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Estrangelo Edessa",
                            "Syrn"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Estrangelo Edessa",
                            "Syrj"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Estrangelo Edessa",
                            "Syre"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Nirmala UI",
                            "Sora"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Microsoft Tai Le",
                            "Tale"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Microsoft New Tai Lue",
                            "Talu"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Ebrima",
                            "Tfng"
                        ])
                    ]
                },
                {
                    name: "a:minorFont",
                    children: [
                        $5b7ccabde48fae90$var$getFont([
                            "latin",
                            "Calibri",
                            void 0,
                            "020F0502020204030204"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "ea",
                            ""
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "cs",
                            ""
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "\u6E38\u30B4\u30B7\u30C3\u30AF",
                            "Jpan"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "\uB9D1\uC740 \uACE0\uB515",
                            "Hang"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "\u7B49\u7EBF",
                            "Hans"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "\u65B0\u7D30\u660E\u9AD4",
                            "Hant"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Arial",
                            "Arab"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Arial",
                            "Hebr"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Tahoma",
                            "Thai"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Nyala",
                            "Ethi"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Vrinda",
                            "Beng"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Shruti",
                            "Gujr"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "DaunPenh",
                            "Khmr"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Tunga",
                            "Knda"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Raavi",
                            "Guru"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Euphemia",
                            "Cans"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Plantagenet Cherokee",
                            "Cher"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Microsoft Yi Baiti",
                            "Yiii"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Microsoft Himalaya",
                            "Tibt"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "MV Boli",
                            "Thaa"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Mangal",
                            "Deva"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Gautami",
                            "Telu"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Latha",
                            "Taml"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Estrangelo Edessa",
                            "Syrc"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Kalinga",
                            "Orya"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Kartika",
                            "Mlym"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "DokChampa",
                            "Laoo"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Iskoola Pota",
                            "Sinh"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Mongolian Baiti",
                            "Mong"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Arial",
                            "Viet"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Microsoft Uighur",
                            "Uigh"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Sylfaen",
                            "Geor"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Arial",
                            "Armn"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Leelawadee UI",
                            "Bugi"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Microsoft JhengHei",
                            "Bopo"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Javanese Text",
                            "Java"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Segoe UI",
                            "Lisu"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Myanmar Text",
                            "Mymr"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Ebrima",
                            "Nkoo"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Nirmala UI",
                            "Olck"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Ebrima",
                            "Osma"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Phagspa",
                            "Phag"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Estrangelo Edessa",
                            "Syrn"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Estrangelo Edessa",
                            "Syrj"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Estrangelo Edessa",
                            "Syre"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Nirmala UI",
                            "Sora"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Microsoft Tai Le",
                            "Tale"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Microsoft New Tai Lue",
                            "Talu"
                        ]),
                        $5b7ccabde48fae90$var$getFont([
                            "font",
                            "Ebrima",
                            "Tfng"
                        ])
                    ]
                }
            ]
        };
    }
};
var $5b7ccabde48fae90$var$fontScheme_default = $5b7ccabde48fae90$var$fontScheme;
var $5b7ccabde48fae90$var$getPropertyVal = (name, val, children)=>({
        name: `a:${name}`,
        properties: {
            rawMap: {
                val: val
            }
        },
        children: children
    });
var $5b7ccabde48fae90$var$getGs = (props)=>{
    const [pos, schemeColor, satMod, lumMod, tint, shade] = props;
    const children = [];
    children.push($5b7ccabde48fae90$var$getPropertyVal("satMod", satMod));
    if (lumMod) children.push($5b7ccabde48fae90$var$getPropertyVal("lumMod", lumMod));
    if (tint) children.push($5b7ccabde48fae90$var$getPropertyVal("tint", tint));
    if (shade) children.push($5b7ccabde48fae90$var$getPropertyVal("shade", shade));
    return {
        name: "a:gs",
        properties: {
            rawMap: {
                pos: pos
            }
        },
        children: [
            {
                name: "a:schemeClr",
                properties: {
                    rawMap: {
                        val: schemeColor
                    }
                },
                children: children
            }
        ]
    };
};
var $5b7ccabde48fae90$var$getSolidFill = (val, children)=>({
        name: "a:solidFill",
        children: [
            $5b7ccabde48fae90$var$getPropertyVal("schemeClr", val, children)
        ]
    });
var $5b7ccabde48fae90$var$getGradFill = (props)=>{
    const [rotWithShape, gs1, gs2, gs3, lin] = props;
    const [ang, scaled] = lin;
    return {
        name: "a:gradFill",
        properties: {
            rawMap: {
                rotWithShape: rotWithShape
            }
        },
        children: [
            {
                name: "a:gsLst",
                children: [
                    $5b7ccabde48fae90$var$getGs(gs1),
                    $5b7ccabde48fae90$var$getGs(gs2),
                    $5b7ccabde48fae90$var$getGs(gs3)
                ]
            },
            {
                name: "a:lin",
                properties: {
                    rawMap: {
                        ang: ang,
                        scaled: scaled
                    }
                }
            }
        ]
    };
};
var $5b7ccabde48fae90$var$getLine = (props)=>{
    const [w, cap, cmpd, algn] = props;
    return {
        name: "a:ln",
        properties: {
            rawMap: {
                w: w,
                cap: cap,
                cmpd: cmpd,
                algn: algn
            }
        },
        children: [
            $5b7ccabde48fae90$var$getSolidFill("phClr"),
            $5b7ccabde48fae90$var$getPropertyVal("prstDash", "solid"),
            {
                name: "a:miter",
                properties: {
                    rawMap: {
                        lim: "800000"
                    }
                }
            }
        ]
    };
};
var $5b7ccabde48fae90$var$getEffectStyle = (shadow)=>{
    const children = [];
    if (shadow) {
        const [blurRad, dist, dir, algn, rotWithShape] = shadow;
        children.push({
            name: "a:outerShdw",
            properties: {
                rawMap: {
                    blurRad: blurRad,
                    dist: dist,
                    dir: dir,
                    algn: algn,
                    rotWithShape: rotWithShape
                }
            },
            children: [
                $5b7ccabde48fae90$var$getPropertyVal("srgbClr", "000000", [
                    $5b7ccabde48fae90$var$getPropertyVal("alpha", "63000")
                ])
            ]
        });
    }
    return {
        name: "a:effectStyle",
        children: [
            Object.assign({}, {
                name: "a:effectLst"
            }, children.length ? {
                children: children
            } : {})
        ]
    };
};
var $5b7ccabde48fae90$var$getFillStyleList = ()=>({
        name: "a:fillStyleLst",
        children: [
            $5b7ccabde48fae90$var$getSolidFill("phClr"),
            $5b7ccabde48fae90$var$getGradFill([
                "1",
                [
                    "0",
                    "phClr",
                    "105000",
                    "110000",
                    "67000"
                ],
                [
                    "50000",
                    "phClr",
                    "103000",
                    "105000",
                    "73000"
                ],
                [
                    "100000",
                    "phClr",
                    "109000",
                    "105000",
                    "81000"
                ],
                [
                    "5400000",
                    "0"
                ]
            ]),
            $5b7ccabde48fae90$var$getGradFill([
                "1",
                [
                    "0",
                    "phClr",
                    "103000",
                    "102000",
                    "94000"
                ],
                [
                    "50000",
                    "phClr",
                    "110000",
                    "100000",
                    void 0,
                    "100000"
                ],
                [
                    "100000",
                    "phClr",
                    "120000",
                    "99000",
                    void 0,
                    "78000"
                ],
                [
                    "5400000",
                    "0"
                ]
            ])
        ]
    });
var $5b7ccabde48fae90$var$getLineStyleList = ()=>({
        name: "a:lnStyleLst",
        children: [
            $5b7ccabde48fae90$var$getLine([
                "6350",
                "flat",
                "sng",
                "ctr"
            ]),
            $5b7ccabde48fae90$var$getLine([
                "12700",
                "flat",
                "sng",
                "ctr"
            ]),
            $5b7ccabde48fae90$var$getLine([
                "19050",
                "flat",
                "sng",
                "ctr"
            ])
        ]
    });
var $5b7ccabde48fae90$var$getEffectStyleList = ()=>({
        name: "a:effectStyleLst",
        children: [
            $5b7ccabde48fae90$var$getEffectStyle(),
            $5b7ccabde48fae90$var$getEffectStyle(),
            $5b7ccabde48fae90$var$getEffectStyle([
                "57150",
                "19050",
                "5400000",
                "ctr",
                "0"
            ])
        ]
    });
var $5b7ccabde48fae90$var$getBgFillStyleList = ()=>({
        name: "a:bgFillStyleLst",
        children: [
            $5b7ccabde48fae90$var$getSolidFill("phClr"),
            $5b7ccabde48fae90$var$getSolidFill("phClr", [
                $5b7ccabde48fae90$var$getPropertyVal("tint", "95000"),
                $5b7ccabde48fae90$var$getPropertyVal("satMod", "170000")
            ]),
            $5b7ccabde48fae90$var$getGradFill([
                "1",
                [
                    "0",
                    "phClr",
                    "150000",
                    "102000",
                    "93000",
                    "98000"
                ],
                [
                    "50000",
                    "phClr",
                    "130000",
                    "103000",
                    "98000",
                    "90000"
                ],
                [
                    "100000",
                    "phClr",
                    "120000",
                    void 0,
                    void 0,
                    "63000"
                ],
                [
                    "5400000",
                    "0"
                ]
            ])
        ]
    });
var $5b7ccabde48fae90$var$formatScheme = {
    getTemplate () {
        return {
            name: "a:fmtScheme",
            properties: {
                rawMap: {
                    name: "Office"
                }
            },
            children: [
                $5b7ccabde48fae90$var$getFillStyleList(),
                $5b7ccabde48fae90$var$getLineStyleList(),
                $5b7ccabde48fae90$var$getEffectStyleList(),
                $5b7ccabde48fae90$var$getBgFillStyleList()
            ]
        };
    }
};
var $5b7ccabde48fae90$var$formatScheme_default = $5b7ccabde48fae90$var$formatScheme;
var $5b7ccabde48fae90$var$themeElements = {
    getTemplate () {
        return {
            name: "a:themeElements",
            children: [
                $5b7ccabde48fae90$var$colorScheme_default.getTemplate(),
                $5b7ccabde48fae90$var$fontScheme_default.getTemplate(),
                $5b7ccabde48fae90$var$formatScheme_default.getTemplate()
            ]
        };
    }
};
var $5b7ccabde48fae90$var$themeElements_default = $5b7ccabde48fae90$var$themeElements;
var $5b7ccabde48fae90$var$officeTheme = {
    getTemplate () {
        return {
            name: "a:theme",
            properties: {
                prefixedAttributes: [
                    {
                        prefix: "xmlns:",
                        map: {
                            a: "http://schemas.openxmlformats.org/drawingml/2006/main"
                        }
                    }
                ],
                rawMap: {
                    name: "Office Theme"
                }
            },
            children: [
                $5b7ccabde48fae90$var$themeElements_default.getTemplate(),
                {
                    name: "a:objectDefaults"
                },
                {
                    name: "a:extraClrSchemeLst"
                }
            ]
        };
    }
};
var $5b7ccabde48fae90$var$office_default = $5b7ccabde48fae90$var$officeTheme;
var $5b7ccabde48fae90$var$buildSharedString = (strMap)=>{
    const ret = [];
    for (const key of strMap.keys()){
        const textNode = key.toString();
        const child = {
            name: "t",
            textNode: (0, $jIDNV._).escapeString(textNode)
        };
        const preserveSpaces = textNode.trim().length !== textNode.length;
        if (preserveSpaces) child.properties = {
            rawMap: {
                "xml:space": "preserve"
            }
        };
        ret.push({
            name: "si",
            children: [
                child
            ]
        });
    }
    return ret;
};
var $5b7ccabde48fae90$var$sharedStrings = {
    getTemplate (strings) {
        return {
            name: "sst",
            properties: {
                rawMap: {
                    xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
                    count: strings.size,
                    uniqueCount: strings.size
                }
            },
            children: $5b7ccabde48fae90$var$buildSharedString(strings)
        };
    }
};
var $5b7ccabde48fae90$var$sharedStrings_default = $5b7ccabde48fae90$var$sharedStrings;
function $5b7ccabde48fae90$var$prepareString(str) {
    const split = str.split(/(\[[^\]]*\])/);
    for(let i = 0; i < split.length; i++){
        let currentString = split[i];
        if (!currentString.length) continue;
        if (!currentString.startsWith("[")) currentString = currentString.replace(/\$/g, '"$"');
        split[i] = (0, $jIDNV._).escapeString(currentString);
    }
    return split.join("");
}
var $5b7ccabde48fae90$var$numberFormatFactory = {
    getTemplate (numberFormat) {
        let { formatCode: formatCode, numFmtId: numFmtId } = numberFormat;
        if (formatCode.length) formatCode = $5b7ccabde48fae90$var$prepareString(formatCode);
        return {
            name: "numFmt",
            properties: {
                rawMap: {
                    formatCode: formatCode,
                    numFmtId: numFmtId
                }
            }
        };
    }
};
var $5b7ccabde48fae90$var$numberFormat_default = $5b7ccabde48fae90$var$numberFormatFactory;
var $5b7ccabde48fae90$var$numberFormatsFactory = {
    getTemplate (numberFormats) {
        return {
            name: "numFmts",
            properties: {
                rawMap: {
                    count: numberFormats.length
                }
            },
            children: numberFormats.map((numberFormat)=>$5b7ccabde48fae90$var$numberFormat_default.getTemplate(numberFormat))
        };
    }
};
var $5b7ccabde48fae90$var$numberFormats_default = $5b7ccabde48fae90$var$numberFormatsFactory;
var $5b7ccabde48fae90$var$fontFactory = {
    getTemplate (font) {
        const { size: size, colorTheme: colorTheme, color: color = "FF000000", fontName: fontName = "Calibri", family: family, scheme: scheme, italic: italic, bold: bold, strikeThrough: strikeThrough, outline: outline, shadow: shadow, underline: underline, verticalAlign: verticalAlign } = font;
        const children = [
            {
                name: "sz",
                properties: {
                    rawMap: {
                        val: size
                    }
                }
            },
            {
                name: "color",
                properties: {
                    rawMap: {
                        theme: colorTheme,
                        rgb: color
                    }
                }
            },
            {
                name: "name",
                properties: {
                    rawMap: {
                        val: fontName
                    }
                }
            }
        ];
        if (family) children.push({
            name: "family",
            properties: {
                rawMap: {
                    val: family
                }
            }
        });
        if (scheme) children.push({
            name: "scheme",
            properties: {
                rawMap: {
                    val: scheme
                }
            }
        });
        if (italic) children.push({
            name: "i"
        });
        if (bold) children.push({
            name: "b"
        });
        if (strikeThrough) children.push({
            name: "strike"
        });
        if (outline) children.push({
            name: "outline"
        });
        if (shadow) children.push({
            name: "shadow"
        });
        if (underline) children.push({
            name: "u",
            properties: {
                rawMap: {
                    val: underline
                }
            }
        });
        if (verticalAlign) children.push({
            name: "vertAlign",
            properties: {
                rawMap: {
                    val: verticalAlign
                }
            }
        });
        return {
            name: "font",
            children: children
        };
    }
};
var $5b7ccabde48fae90$var$font_default = $5b7ccabde48fae90$var$fontFactory;
var $5b7ccabde48fae90$var$fontsFactory = {
    getTemplate (fonts) {
        return {
            name: "fonts",
            properties: {
                rawMap: {
                    count: fonts.length
                }
            },
            children: fonts.map((font)=>$5b7ccabde48fae90$var$font_default.getTemplate(font))
        };
    }
};
var $5b7ccabde48fae90$var$fonts_default = $5b7ccabde48fae90$var$fontsFactory;
var $5b7ccabde48fae90$var$fillFactory = {
    getTemplate (fill) {
        const { patternType: patternType, fgTheme: fgTheme, fgTint: fgTint, fgRgb: fgRgb, bgRgb: bgRgb, bgIndexed: bgIndexed } = fill;
        const pf = {
            name: "patternFill",
            properties: {
                rawMap: {
                    patternType: patternType
                }
            }
        };
        if (fgTheme || fgTint || fgRgb) pf.children = [
            {
                name: "fgColor",
                properties: {
                    rawMap: {
                        theme: fgTheme,
                        tint: fgTint,
                        rgb: fgRgb
                    }
                }
            }
        ];
        if (bgIndexed || bgRgb) {
            if (!pf.children) pf.children = [];
            pf.children.push({
                name: "bgColor",
                properties: {
                    rawMap: {
                        indexed: bgIndexed,
                        rgb: bgRgb
                    }
                }
            });
        }
        return {
            name: "fill",
            children: [
                pf
            ]
        };
    }
};
var $5b7ccabde48fae90$var$fill_default = $5b7ccabde48fae90$var$fillFactory;
var $5b7ccabde48fae90$var$fillsFactory = {
    getTemplate (fills) {
        return {
            name: "fills",
            properties: {
                rawMap: {
                    count: fills.length
                }
            },
            children: fills.map((fill)=>$5b7ccabde48fae90$var$fill_default.getTemplate(fill))
        };
    }
};
var $5b7ccabde48fae90$var$fills_default = $5b7ccabde48fae90$var$fillsFactory;
var $5b7ccabde48fae90$var$getWeightName = (value)=>{
    switch(value){
        case 1:
            return "thin";
        case 2:
            return "medium";
        case 3:
            return "thick";
        default:
            return "hair";
    }
};
var $5b7ccabde48fae90$var$mappedBorderNames = {
    None: "None",
    Dot: "Dotted",
    Dash: "Dashed",
    Double: "Double",
    DashDot: "DashDot",
    DashDotDot: "DashDotDot",
    SlantDashDot: "SlantDashDot"
};
var $5b7ccabde48fae90$var$mediumBorders = [
    "Dashed",
    "DashDot",
    "DashDotDot"
];
var $5b7ccabde48fae90$var$colorMap = {
    None: "none",
    Solid: "solid",
    Gray50: "mediumGray",
    Gray75: "darkGray",
    Gray25: "lightGray",
    HorzStripe: "darkHorizontal",
    VertStripe: "darkVertical",
    ReverseDiagStripe: "darkDown",
    DiagStripe: "darkUp",
    DiagCross: "darkGrid",
    ThickDiagCross: "darkTrellis",
    ThinHorzStripe: "lightHorizontal",
    ThinVertStripe: "lightVertical",
    ThinReverseDiagStripe: "lightDown",
    ThinDiagStripe: "lightUp",
    ThinHorzCross: "lightGrid",
    ThinDiagCross: "lightTrellis",
    Gray125: "gray125",
    Gray0625: "gray0625"
};
var $5b7ccabde48fae90$var$horizontalAlignmentMap = {
    Automatic: "general",
    Left: "left",
    Center: "center",
    Right: "right",
    Fill: "fill",
    Justify: "justify",
    CenterAcrossSelection: "centerContinuous",
    Distributed: "distributed",
    JustifyDistributed: "justify"
};
var $5b7ccabde48fae90$var$verticalAlignmentMap = {
    Automatic: void 0,
    Top: "top",
    Bottom: "bottom",
    Center: "center",
    Justify: "justify",
    Distributed: "distributed",
    JustifyDistributed: "justify"
};
var $5b7ccabde48fae90$var$convertLegacyPattern = (name)=>{
    if (!name) return "none";
    return $5b7ccabde48fae90$var$colorMap[name] || name;
};
var $5b7ccabde48fae90$var$convertLegacyColor = (color)=>{
    if (color == void 0) return color;
    if (color.charAt(0) === "#") color = color.substring(1);
    return color.length === 6 ? "FF" + color : color;
};
var $5b7ccabde48fae90$var$convertLegacyBorder = (type, weight)=>{
    if (!type) return "thin";
    const namedWeight = $5b7ccabde48fae90$var$getWeightName(weight);
    const mappedName = $5b7ccabde48fae90$var$mappedBorderNames[type];
    if (type === "Continuous") return namedWeight;
    if (namedWeight === "medium" && $5b7ccabde48fae90$var$mediumBorders.indexOf(mappedName) !== -1) return `medium${mappedName}`;
    return mappedName.charAt(0).toLowerCase() + mappedName.substring(1);
};
var $5b7ccabde48fae90$var$convertLegacyHorizontalAlignment = (alignment)=>{
    return $5b7ccabde48fae90$var$horizontalAlignmentMap[alignment] || "general";
};
var $5b7ccabde48fae90$var$convertLegacyVerticalAlignment = (alignment)=>{
    return $5b7ccabde48fae90$var$verticalAlignmentMap[alignment] || void 0;
};
var $5b7ccabde48fae90$var$getBorderColor = (color)=>{
    return {
        name: "color",
        properties: {
            rawMap: {
                rgb: $5b7ccabde48fae90$var$convertLegacyColor(color || "#000000")
            }
        }
    };
};
var $5b7ccabde48fae90$var$borderFactory = {
    getTemplate (border) {
        const { left: left, right: right, top: top, bottom: bottom, diagonal: diagonal } = border;
        const leftChildren = left ? [
            $5b7ccabde48fae90$var$getBorderColor(left.color)
        ] : void 0;
        const rightChildren = right ? [
            $5b7ccabde48fae90$var$getBorderColor(right.color)
        ] : void 0;
        const topChildren = top ? [
            $5b7ccabde48fae90$var$getBorderColor(top.color)
        ] : void 0;
        const bottomChildren = bottom ? [
            $5b7ccabde48fae90$var$getBorderColor(bottom.color)
        ] : void 0;
        const diagonalChildren = diagonal ? [
            $5b7ccabde48fae90$var$getBorderColor(diagonal.color)
        ] : void 0;
        return {
            name: "border",
            children: [
                {
                    name: "left",
                    properties: {
                        rawMap: {
                            style: left && left.style
                        }
                    },
                    children: leftChildren
                },
                {
                    name: "right",
                    properties: {
                        rawMap: {
                            style: right && right.style
                        }
                    },
                    children: rightChildren
                },
                {
                    name: "top",
                    properties: {
                        rawMap: {
                            style: top && top.style
                        }
                    },
                    children: topChildren
                },
                {
                    name: "bottom",
                    properties: {
                        rawMap: {
                            style: bottom && bottom.style
                        }
                    },
                    children: bottomChildren
                },
                {
                    name: "diagonal",
                    properties: {
                        rawMap: {
                            style: diagonal && diagonal.style
                        }
                    },
                    children: diagonalChildren
                }
            ]
        };
    }
};
var $5b7ccabde48fae90$var$border_default = $5b7ccabde48fae90$var$borderFactory;
var $5b7ccabde48fae90$var$bordersFactory = {
    getTemplate (borders) {
        return {
            name: "borders",
            properties: {
                rawMap: {
                    count: borders.length
                }
            },
            children: borders.map((border)=>$5b7ccabde48fae90$var$border_default.getTemplate(border))
        };
    }
};
var $5b7ccabde48fae90$var$borders_default = $5b7ccabde48fae90$var$bordersFactory;
var $5b7ccabde48fae90$var$getReadingOrderId = (readingOrder)=>{
    const order = [
        "Context",
        "LeftToRight",
        "RightToLeft"
    ];
    const pos = order.indexOf(readingOrder);
    return Math.max(pos, 0);
};
var $5b7ccabde48fae90$var$alignmentFactory = {
    getTemplate (alignment) {
        const { horizontal: horizontal, indent: indent, readingOrder: readingOrder, rotate: rotate, shrinkToFit: shrinkToFit, vertical: vertical, wrapText: wrapText } = alignment;
        return {
            name: "alignment",
            properties: {
                rawMap: {
                    horizontal: horizontal && $5b7ccabde48fae90$var$convertLegacyHorizontalAlignment(horizontal),
                    indent: indent,
                    readingOrder: readingOrder && $5b7ccabde48fae90$var$getReadingOrderId(readingOrder),
                    textRotation: rotate,
                    shrinkToFit: shrinkToFit,
                    vertical: vertical && $5b7ccabde48fae90$var$convertLegacyVerticalAlignment(vertical),
                    wrapText: wrapText
                }
            }
        };
    }
};
var $5b7ccabde48fae90$var$alignment_default = $5b7ccabde48fae90$var$alignmentFactory;
var $5b7ccabde48fae90$var$protectionFactory = {
    getTemplate (protection) {
        const locked = protection.protected === false ? 0 : 1;
        const hidden = protection.hideFormula === true ? 1 : 0;
        return {
            name: "protection",
            properties: {
                rawMap: {
                    hidden: hidden,
                    locked: locked
                }
            }
        };
    }
};
var $5b7ccabde48fae90$var$protection_default = $5b7ccabde48fae90$var$protectionFactory;
var $5b7ccabde48fae90$var$xfFactory = {
    getTemplate (xf) {
        const { alignment: alignment, borderId: borderId, fillId: fillId, fontId: fontId, numFmtId: numFmtId, protection: protection, quotePrefix: quotePrefix, xfId: xfId } = xf;
        const children = [];
        if (alignment) children.push($5b7ccabde48fae90$var$alignment_default.getTemplate(alignment));
        if (protection) children.push($5b7ccabde48fae90$var$protection_default.getTemplate(protection));
        return {
            name: "xf",
            properties: {
                rawMap: {
                    applyAlignment: alignment ? 1 : void 0,
                    applyProtection: protection ? 1 : void 0,
                    applyBorder: borderId ? 1 : void 0,
                    applyFill: fillId ? 1 : void 0,
                    borderId: borderId,
                    fillId: fillId,
                    applyFont: fontId ? 1 : void 0,
                    fontId: fontId,
                    applyNumberFormat: numFmtId ? 1 : void 0,
                    numFmtId: numFmtId,
                    quotePrefix: quotePrefix ? 1 : void 0,
                    xfId: xfId
                }
            },
            children: children.length ? children : void 0
        };
    }
};
var $5b7ccabde48fae90$var$xf_default = $5b7ccabde48fae90$var$xfFactory;
var $5b7ccabde48fae90$var$cellStylesXfsFactory = {
    getTemplate (xfs) {
        return {
            name: "cellStyleXfs",
            properties: {
                rawMap: {
                    count: xfs.length
                }
            },
            children: xfs.map((xf)=>$5b7ccabde48fae90$var$xf_default.getTemplate(xf))
        };
    }
};
var $5b7ccabde48fae90$var$cellStyleXfs_default = $5b7ccabde48fae90$var$cellStylesXfsFactory;
var $5b7ccabde48fae90$var$cellXfsFactory = {
    getTemplate (xfs) {
        return {
            name: "cellXfs",
            properties: {
                rawMap: {
                    count: xfs.length
                }
            },
            children: xfs.map((xf)=>$5b7ccabde48fae90$var$xf_default.getTemplate(xf))
        };
    }
};
var $5b7ccabde48fae90$var$cellXfs_default = $5b7ccabde48fae90$var$cellXfsFactory;
var $5b7ccabde48fae90$var$borderFactory2 = {
    getTemplate (cellStyle) {
        const { builtinId: builtinId, name: name, xfId: xfId } = cellStyle;
        return {
            name: "cellStyle",
            properties: {
                rawMap: {
                    builtinId: builtinId,
                    name: name,
                    xfId: xfId
                }
            }
        };
    }
};
var $5b7ccabde48fae90$var$cellStyle_default = $5b7ccabde48fae90$var$borderFactory2;
var $5b7ccabde48fae90$var$cellStylesFactory = {
    getTemplate (cellStyles) {
        return {
            name: "cellStyles",
            properties: {
                rawMap: {
                    count: cellStyles.length
                }
            },
            children: cellStyles.map((cellStyle)=>$5b7ccabde48fae90$var$cellStyle_default.getTemplate(cellStyle))
        };
    }
};
var $5b7ccabde48fae90$var$cellStyles_default = $5b7ccabde48fae90$var$cellStylesFactory;
var $5b7ccabde48fae90$var$stylesMap;
var $5b7ccabde48fae90$var$registeredNumberFmts;
var $5b7ccabde48fae90$var$registeredFonts;
var $5b7ccabde48fae90$var$registeredFills;
var $5b7ccabde48fae90$var$registeredBorders;
var $5b7ccabde48fae90$var$registeredCellStyleXfs;
var $5b7ccabde48fae90$var$registeredCellXfs;
var $5b7ccabde48fae90$var$registeredCellStyles;
var $5b7ccabde48fae90$var$currentSheet;
var $5b7ccabde48fae90$var$getStyleName = (name, currentSheet2)=>{
    if (name.indexOf("mixedStyle") !== -1 && currentSheet2 > 1) name += `_${currentSheet2}`;
    return name;
};
var $5b7ccabde48fae90$var$resetStylesheetValues = ()=>{
    $5b7ccabde48fae90$var$stylesMap = {
        base: 0
    };
    $5b7ccabde48fae90$var$registeredNumberFmts = [];
    $5b7ccabde48fae90$var$registeredFonts = [
        {
            fontName: "Calibri",
            colorTheme: "1",
            family: "2",
            scheme: "minor"
        }
    ];
    $5b7ccabde48fae90$var$registeredFills = [
        {
            patternType: "none"
        },
        {
            patternType: "gray125"
        }
    ];
    $5b7ccabde48fae90$var$registeredBorders = [
        {
            left: void 0,
            right: void 0,
            top: void 0,
            bottom: void 0,
            diagonal: void 0
        }
    ];
    $5b7ccabde48fae90$var$registeredCellStyleXfs = [
        {
            borderId: 0,
            fillId: 0,
            fontId: 0,
            numFmtId: 0
        }
    ];
    $5b7ccabde48fae90$var$registeredCellXfs = [
        {
            borderId: 0,
            fillId: 0,
            fontId: 0,
            numFmtId: 0,
            xfId: 0
        }
    ];
    $5b7ccabde48fae90$var$registeredCellStyles = [
        {
            builtinId: 0,
            name: "Normal",
            xfId: 0
        }
    ];
};
var $5b7ccabde48fae90$var$registerFill = (fill)=>{
    const convertedPattern = $5b7ccabde48fae90$var$convertLegacyPattern(fill.pattern);
    const convertedFillColor = $5b7ccabde48fae90$var$convertLegacyColor(fill.color);
    const convertedPatternColor = $5b7ccabde48fae90$var$convertLegacyColor(fill.patternColor);
    let pos = $5b7ccabde48fae90$var$registeredFills.findIndex((currentFill)=>{
        const { patternType: patternType, fgRgb: fgRgb, bgRgb: bgRgb } = currentFill;
        if (patternType != convertedPattern || fgRgb != convertedFillColor || bgRgb != convertedPatternColor) return false;
        return true;
    });
    if (pos === -1) {
        pos = $5b7ccabde48fae90$var$registeredFills.length;
        $5b7ccabde48fae90$var$registeredFills.push({
            patternType: convertedPattern,
            fgRgb: convertedFillColor,
            bgRgb: convertedPatternColor
        });
    }
    return pos;
};
var $5b7ccabde48fae90$var$registerNumberFmt = (format)=>{
    if ($5b7ccabde48fae90$var$numberFormatMap[format]) return $5b7ccabde48fae90$var$numberFormatMap[format];
    let pos = $5b7ccabde48fae90$var$registeredNumberFmts.findIndex((currentFormat)=>currentFormat.formatCode === format);
    if (pos === -1) {
        pos = $5b7ccabde48fae90$var$registeredNumberFmts.length + 164;
        $5b7ccabde48fae90$var$registeredNumberFmts.push({
            formatCode: format,
            numFmtId: pos
        });
    } else pos = $5b7ccabde48fae90$var$registeredNumberFmts[pos].numFmtId;
    return pos;
};
var $5b7ccabde48fae90$var$registerBorders = (borders)=>{
    const { borderBottom: borderBottom, borderTop: borderTop, borderLeft: borderLeft, borderRight: borderRight } = borders;
    let bottomStyle;
    let topStyle;
    let leftStyle;
    let rightStyle;
    let bottomColor;
    let topColor;
    let leftColor;
    let rightColor;
    if (borderLeft) {
        leftStyle = $5b7ccabde48fae90$var$convertLegacyBorder(borderLeft.lineStyle, borderLeft.weight);
        leftColor = $5b7ccabde48fae90$var$convertLegacyColor(borderLeft.color);
    }
    if (borderRight) {
        rightStyle = $5b7ccabde48fae90$var$convertLegacyBorder(borderRight.lineStyle, borderRight.weight);
        rightColor = $5b7ccabde48fae90$var$convertLegacyColor(borderRight.color);
    }
    if (borderBottom) {
        bottomStyle = $5b7ccabde48fae90$var$convertLegacyBorder(borderBottom.lineStyle, borderBottom.weight);
        bottomColor = $5b7ccabde48fae90$var$convertLegacyColor(borderBottom.color);
    }
    if (borderTop) {
        topStyle = $5b7ccabde48fae90$var$convertLegacyBorder(borderTop.lineStyle, borderTop.weight);
        topColor = $5b7ccabde48fae90$var$convertLegacyColor(borderTop.color);
    }
    let pos = $5b7ccabde48fae90$var$registeredBorders.findIndex((currentBorder)=>{
        const { left: left, right: right, top: top, bottom: bottom } = currentBorder;
        if (!left && (leftStyle || leftColor)) return false;
        if (!right && (rightStyle || rightColor)) return false;
        if (!top && (topStyle || topColor)) return false;
        if (!bottom && (bottomStyle || bottomColor)) return false;
        const { style: clS, color: clC } = left || {};
        const { style: crS, color: crC } = right || {};
        const { style: ctS, color: ctC } = top || {};
        const { style: cbS, color: cbC } = bottom || {};
        if (clS != leftStyle || clC != leftColor) return false;
        if (crS != rightStyle || crC != rightColor) return false;
        if (ctS != topStyle || ctC != topColor) return false;
        if (cbS != bottomStyle || cbC != bottomColor) return false;
        return true;
    });
    if (pos === -1) {
        pos = $5b7ccabde48fae90$var$registeredBorders.length;
        $5b7ccabde48fae90$var$registeredBorders.push({
            left: {
                style: leftStyle,
                color: leftColor
            },
            right: {
                style: rightStyle,
                color: rightColor
            },
            top: {
                style: topStyle,
                color: topColor
            },
            bottom: {
                style: bottomStyle,
                color: bottomColor
            },
            diagonal: {
                style: void 0,
                color: void 0
            }
        });
    }
    return pos;
};
var $5b7ccabde48fae90$var$registerFont = (font)=>{
    const { fontName: name = "Calibri", color: color, size: size, bold: bold, italic: italic, outline: outline, shadow: shadow, strikeThrough: strikeThrough, underline: underline, family: family, verticalAlign: verticalAlign } = font;
    const convertedColor = $5b7ccabde48fae90$var$convertLegacyColor(color);
    const familyId = $5b7ccabde48fae90$var$getFontFamilyId(family);
    const convertedUnderline = underline ? underline.toLocaleLowerCase() : void 0;
    const convertedVerticalAlign = verticalAlign ? verticalAlign.toLocaleLowerCase() : void 0;
    let pos = $5b7ccabde48fae90$var$registeredFonts.findIndex((currentFont)=>{
        if (currentFont.fontName != name || currentFont.color != convertedColor || currentFont.size != size || currentFont.bold != bold || currentFont.italic != italic || currentFont.outline != outline || currentFont.shadow != shadow || currentFont.strikeThrough != strikeThrough || currentFont.underline != convertedUnderline || currentFont.verticalAlign != convertedVerticalAlign || // @ts-ignore
        currentFont.family != familyId) return false;
        return true;
    });
    if (pos === -1) {
        pos = $5b7ccabde48fae90$var$registeredFonts.length;
        $5b7ccabde48fae90$var$registeredFonts.push({
            fontName: name,
            color: convertedColor,
            size: size,
            bold: bold,
            italic: italic,
            outline: outline,
            shadow: shadow,
            strikeThrough: strikeThrough,
            underline: convertedUnderline,
            verticalAlign: convertedVerticalAlign,
            family: familyId != null ? familyId.toString() : void 0
        });
    }
    return pos;
};
var $5b7ccabde48fae90$var$registerStyle = (config)=>{
    const { alignment: alignment, borders: borders, font: font, interior: interior, numberFormat: numberFormat, protection: protection, quotePrefix: quotePrefix } = config;
    let { id: id } = config;
    let currentFill = 0;
    let currentBorder = 0;
    let currentFont = 0;
    let currentNumberFmt = 0;
    if (!id) return;
    id = $5b7ccabde48fae90$var$getStyleName(id, $5b7ccabde48fae90$var$currentSheet);
    if ($5b7ccabde48fae90$var$stylesMap[id] != void 0) return;
    if (interior) currentFill = $5b7ccabde48fae90$var$registerFill(interior);
    if (borders) currentBorder = $5b7ccabde48fae90$var$registerBorders(borders);
    if (font) currentFont = $5b7ccabde48fae90$var$registerFont(font);
    if (numberFormat) currentNumberFmt = $5b7ccabde48fae90$var$registerNumberFmt(numberFormat.format);
    $5b7ccabde48fae90$var$stylesMap[id] = $5b7ccabde48fae90$var$registeredCellXfs.length;
    $5b7ccabde48fae90$var$registeredCellXfs.push({
        alignment: alignment,
        borderId: currentBorder || 0,
        fillId: currentFill || 0,
        fontId: currentFont || 0,
        numFmtId: currentNumberFmt || 0,
        protection: protection,
        quotePrefix: quotePrefix,
        xfId: 0
    });
};
var $5b7ccabde48fae90$var$stylesheetFactory = {
    getTemplate (defaultFontSize) {
        const numberFormats = $5b7ccabde48fae90$var$numberFormats_default.getTemplate($5b7ccabde48fae90$var$registeredNumberFmts);
        const fonts = $5b7ccabde48fae90$var$fonts_default.getTemplate($5b7ccabde48fae90$var$registeredFonts.map((font)=>$5b7ccabde48fae90$var$__spreadProps6($5b7ccabde48fae90$var$__spreadValues7({}, font), {
                size: font.size != null ? font.size : defaultFontSize
            })));
        const fills = $5b7ccabde48fae90$var$fills_default.getTemplate($5b7ccabde48fae90$var$registeredFills);
        const borders = $5b7ccabde48fae90$var$borders_default.getTemplate($5b7ccabde48fae90$var$registeredBorders);
        const cellStylesXfs = $5b7ccabde48fae90$var$cellStyleXfs_default.getTemplate($5b7ccabde48fae90$var$registeredCellStyleXfs);
        const cellXfs = $5b7ccabde48fae90$var$cellXfs_default.getTemplate($5b7ccabde48fae90$var$registeredCellXfs);
        const cellStyles = $5b7ccabde48fae90$var$cellStyles_default.getTemplate($5b7ccabde48fae90$var$registeredCellStyles);
        $5b7ccabde48fae90$var$resetStylesheetValues();
        return {
            name: "styleSheet",
            properties: {
                rawMap: {
                    "mc:Ignorable": "x14ac x16r2 xr",
                    "xmlns": "http://schemas.openxmlformats.org/spreadsheetml/2006/main",
                    "xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
                    "xmlns:x14ac": "http://schemas.microsoft.com/office/spreadsheetml/2009/9/ac",
                    "xmlns:x16r2": "http://schemas.microsoft.com/office/spreadsheetml/2015/02/main",
                    "xmlns:xr": "http://schemas.microsoft.com/office/spreadsheetml/2014/revision"
                }
            },
            children: [
                numberFormats,
                fonts,
                fills,
                borders,
                cellStylesXfs,
                cellXfs,
                cellStyles,
                {
                    name: "tableStyles",
                    properties: {
                        rawMap: {
                            count: 0,
                            defaultPivotStyle: "PivotStyleLight16",
                            defaultTableStyle: "TableStyleMedium2"
                        }
                    }
                }
            ]
        };
    }
};
var $5b7ccabde48fae90$var$getStyleId = (name, currentSheet2)=>{
    return $5b7ccabde48fae90$var$stylesMap[$5b7ccabde48fae90$var$getStyleName(name, currentSheet2)] || 0;
};
var $5b7ccabde48fae90$var$registerStyles = (styles, _currentSheet)=>{
    $5b7ccabde48fae90$var$currentSheet = _currentSheet;
    if ($5b7ccabde48fae90$var$currentSheet === 1) $5b7ccabde48fae90$var$resetStylesheetValues();
    styles.forEach($5b7ccabde48fae90$var$registerStyle);
};
var $5b7ccabde48fae90$var$stylesheet_default = $5b7ccabde48fae90$var$stylesheetFactory;
var $5b7ccabde48fae90$var$sheetFactory = {
    getTemplate (name, idx) {
        const sheetId = (idx + 1).toString();
        return {
            name: "sheet",
            properties: {
                rawMap: {
                    "name": name,
                    "sheetId": sheetId,
                    "r:id": `rId${sheetId}`
                }
            }
        };
    }
};
var $5b7ccabde48fae90$var$sheet_default = $5b7ccabde48fae90$var$sheetFactory;
var $5b7ccabde48fae90$var$sheetsFactory = {
    getTemplate (names) {
        return {
            name: "sheets",
            children: names.map((sheet, idx)=>$5b7ccabde48fae90$var$sheet_default.getTemplate(sheet, idx))
        };
    }
};
var $5b7ccabde48fae90$var$sheets_default = $5b7ccabde48fae90$var$sheetsFactory;
var $5b7ccabde48fae90$var$workbookFactory = {
    getTemplate (names) {
        return {
            name: "workbook",
            properties: {
                prefixedAttributes: [
                    {
                        prefix: "xmlns:",
                        map: {
                            r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships"
                        }
                    }
                ],
                rawMap: {
                    xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main"
                }
            },
            children: [
                $5b7ccabde48fae90$var$sheets_default.getTemplate(names)
            ]
        };
    }
};
var $5b7ccabde48fae90$var$workbook_default = $5b7ccabde48fae90$var$workbookFactory;
var $5b7ccabde48fae90$var$getExcelCellWidth = (width)=>Math.ceil((width - 12) / 7 + 1);
var $5b7ccabde48fae90$var$columnFactory = {
    getTemplate (config) {
        const { min: min, max: max, outlineLevel: outlineLevel, s: s, width: width, hidden: hidden, bestFit: bestFit } = config;
        let excelWidth = 1;
        let customWidth = "0";
        if (width > 1) {
            excelWidth = $5b7ccabde48fae90$var$getExcelCellWidth(width);
            customWidth = "1";
        }
        return {
            name: "col",
            properties: {
                rawMap: {
                    min: min,
                    max: max,
                    outlineLevel: outlineLevel != null ? outlineLevel : void 0,
                    width: excelWidth,
                    style: s,
                    hidden: hidden ? "1" : "0",
                    bestFit: bestFit ? "1" : "0",
                    customWidth: customWidth
                }
            }
        };
    }
};
var $5b7ccabde48fae90$var$column_default = $5b7ccabde48fae90$var$columnFactory;
var $5b7ccabde48fae90$var$convertLegacyType = (type)=>{
    const t = type.charAt(0).toLowerCase();
    return t === "s" ? "inlineStr" : t;
};
var $5b7ccabde48fae90$var$cellFactory = {
    getTemplate (config, idx, currentSheet2) {
        const { ref: ref, data: data, styleId: styleId } = config;
        const { type: type, value: value } = data || {
            type: "empty",
            value: null
        };
        let convertedType = type;
        if (type === "f") convertedType = "str";
        else if (type.charAt(0) === type.charAt(0).toUpperCase()) convertedType = $5b7ccabde48fae90$var$convertLegacyType(type);
        const obj = {
            name: "c",
            properties: {
                rawMap: {
                    r: ref,
                    t: convertedType === "empty" ? void 0 : convertedType,
                    s: styleId ? $5b7ccabde48fae90$var$getStyleId(styleId, currentSheet2) : void 0
                }
            }
        };
        if (convertedType === "empty") return obj;
        let children;
        if (convertedType === "str" && type === "f") children = [
            {
                name: "f",
                textNode: (0, $jIDNV._).escapeString(value)
            }
        ];
        else if (convertedType === "inlineStr") children = [
            {
                name: "is",
                children: [
                    {
                        name: "t",
                        textNode: (0, $jIDNV._).escapeString(value)
                    }
                ]
            }
        ];
        else children = [
            {
                name: "v",
                textNode: value
            }
        ];
        return Object.assign({}, obj, {
            children: children
        });
    }
};
var $5b7ccabde48fae90$var$cell_default = $5b7ccabde48fae90$var$cellFactory;
var $5b7ccabde48fae90$var$addEmptyCells = (cells, rowIdx)=>{
    const mergeMap = [];
    let posCounter = 0;
    for(let i = 0; i < cells.length; i++){
        const cell = cells[i];
        if (cell.mergeAcross) {
            mergeMap.push({
                pos: i,
                excelPos: posCounter
            });
            posCounter += cell.mergeAcross;
        }
        posCounter++;
    }
    if (mergeMap.length) for(let i = mergeMap.length - 1; i >= 0; i--){
        const mergedCells = [];
        const cell = cells[mergeMap[i].pos];
        for(let j = 1; j <= cell.mergeAcross; j++)mergedCells.push({
            ref: `${$5b7ccabde48fae90$var$getExcelColumnName(mergeMap[i].excelPos + 1 + j)}${rowIdx + 1}`,
            styleId: cell.styleId,
            data: {
                type: "empty",
                value: null
            }
        });
        if (mergedCells.length) cells.splice(mergeMap[i].pos + 1, 0, ...mergedCells);
    }
};
var $5b7ccabde48fae90$var$shouldDisplayCell = (cell)=>{
    var _a;
    return ((_a = cell.data) == null ? void 0 : _a.value) !== "" || cell.styleId !== void 0;
};
var $5b7ccabde48fae90$var$rowFactory = {
    getTemplate (config, idx, currentSheet2) {
        const { collapsed: collapsed, hidden: hidden, height: height, outlineLevel: outlineLevel, cells: cells = [] } = config;
        $5b7ccabde48fae90$var$addEmptyCells(cells, idx);
        const children = cells.filter($5b7ccabde48fae90$var$shouldDisplayCell).map((cell, idx2)=>$5b7ccabde48fae90$var$cell_default.getTemplate(cell, idx2, currentSheet2));
        return {
            name: "row",
            properties: {
                rawMap: {
                    r: idx + 1,
                    collapsed: collapsed ? "1" : "0",
                    hidden: hidden ? "1" : "0",
                    ht: height,
                    customHeight: height != null ? "1" : "0",
                    spans: "1:1",
                    outlineLevel: outlineLevel || void 0
                }
            },
            children: children
        };
    }
};
var $5b7ccabde48fae90$var$row_default = $5b7ccabde48fae90$var$rowFactory;
var $5b7ccabde48fae90$var$mergeCellFactory = {
    getTemplate (ref) {
        return {
            name: "mergeCell",
            properties: {
                rawMap: {
                    ref: ref
                }
            }
        };
    }
};
var $5b7ccabde48fae90$var$mergeCell_default = $5b7ccabde48fae90$var$mergeCellFactory;
var $5b7ccabde48fae90$var$getMergedCellsAndAddColumnGroups = (rows, cols, suppressColumnOutline)=>{
    const mergedCells = [];
    const cellsWithCollapsibleGroups = [];
    rows.forEach((currentRow, rowIdx)=>{
        const cells = currentRow.cells;
        let merges = 0;
        let lastCol;
        cells.forEach((currentCell, cellIdx)=>{
            const min = cellIdx + merges + 1;
            const start = $5b7ccabde48fae90$var$getExcelColumnName(min);
            const outputRow = rowIdx + 1;
            if (currentCell.mergeAcross) {
                merges += currentCell.mergeAcross;
                const end = $5b7ccabde48fae90$var$getExcelColumnName(cellIdx + merges + 1);
                mergedCells.push(`${start}${outputRow}:${end}${outputRow}`);
            }
            if (!cols[min - 1]) cols[min - 1] = {};
            const { collapsibleRanges: collapsibleRanges } = currentCell;
            if (collapsibleRanges) collapsibleRanges.forEach((range)=>{
                cellsWithCollapsibleGroups.push([
                    min + range[0],
                    min + range[1]
                ]);
            });
            lastCol = cols[min - 1];
            lastCol.min = min;
            lastCol.max = min;
            currentCell.ref = `${start}${outputRow}`;
        });
    });
    cellsWithCollapsibleGroups.sort((a, b)=>{
        if (a[0] !== b[0]) return a[0] - b[0];
        return b[1] - a[1];
    });
    const rangeMap = /* @__PURE__ */ new Map();
    const outlineLevel = /* @__PURE__ */ new Map();
    cellsWithCollapsibleGroups.filter((currentRange)=>{
        const rangeString = currentRange.toString();
        const inMap = rangeMap.get(rangeString);
        if (inMap) return false;
        rangeMap.set(rangeString, true);
        return true;
    }).forEach((range)=>{
        const refCol = cols.find((col)=>col.min == range[0] && col.max == range[1]);
        const currentOutlineLevel = outlineLevel.get(range[0]);
        cols.push({
            min: range[0],
            max: range[1],
            outlineLevel: suppressColumnOutline ? void 0 : currentOutlineLevel || 1,
            width: (refCol || {
                width: 100
            }).width
        });
        outlineLevel.set(range[0], (currentOutlineLevel || 0) + 1);
    });
    return mergedCells;
};
var $5b7ccabde48fae90$var$getPageOrientation = (orientation)=>{
    if (!orientation || orientation !== "Portrait" && orientation !== "Landscape") return "portrait";
    return orientation.toLocaleLowerCase();
};
var $5b7ccabde48fae90$var$getPageSize = (pageSize)=>{
    if (pageSize == null) return 1;
    const positions = [
        "Letter",
        "Letter Small",
        "Tabloid",
        "Ledger",
        "Legal",
        "Statement",
        "Executive",
        "A3",
        "A4",
        "A4 Small",
        "A5",
        "A6",
        "B4",
        "B5",
        "Folio",
        "Envelope",
        "Envelope DL",
        "Envelope C5",
        "Envelope B5",
        "Envelope C3",
        "Envelope C4",
        "Envelope C6",
        "Envelope Monarch",
        "Japanese Postcard",
        "Japanese Double Postcard"
    ];
    const pos = positions.indexOf(pageSize);
    return pos === -1 ? 1 : pos + 1;
};
var $5b7ccabde48fae90$var$addColumns = (columns)=>{
    return (params)=>{
        if (columns.length) params.children.push({
            name: "cols",
            children: columns.map((column)=>$5b7ccabde48fae90$var$column_default.getTemplate(column))
        });
        return params;
    };
};
var $5b7ccabde48fae90$var$addSheetData = (rows, sheetNumber)=>{
    return (params)=>{
        if (rows.length) params.children.push({
            name: "sheetData",
            children: rows.map((row, idx)=>$5b7ccabde48fae90$var$row_default.getTemplate(row, idx, sheetNumber))
        });
        return params;
    };
};
var $5b7ccabde48fae90$var$addMergeCells = (mergeCells)=>{
    return (params)=>{
        if (mergeCells.length) params.children.push({
            name: "mergeCells",
            properties: {
                rawMap: {
                    count: mergeCells.length
                }
            },
            children: mergeCells.map((mergedCell)=>$5b7ccabde48fae90$var$mergeCell_default.getTemplate(mergedCell))
        });
        return params;
    };
};
var $5b7ccabde48fae90$var$addPageMargins = (margins)=>{
    return (params)=>{
        const { top: top = 0.75, right: right = 0.7, bottom: bottom = 0.75, left: left = 0.7, header: header = 0.3, footer: footer = 0.3 } = margins;
        params.children.push({
            name: "pageMargins",
            properties: {
                rawMap: {
                    bottom: bottom,
                    footer: footer,
                    header: header,
                    left: left,
                    right: right,
                    top: top
                }
            }
        });
        return params;
    };
};
var $5b7ccabde48fae90$var$addPageSetup = (pageSetup)=>{
    return (params)=>{
        if (pageSetup) params.children.push({
            name: "pageSetup",
            properties: {
                rawMap: {
                    horizontalDpi: 0,
                    verticalDpi: 0,
                    orientation: $5b7ccabde48fae90$var$getPageOrientation(pageSetup.orientation),
                    paperSize: $5b7ccabde48fae90$var$getPageSize(pageSetup.pageSize)
                }
            }
        });
        return params;
    };
};
var $5b7ccabde48fae90$var$replaceHeaderFooterTokens = (value)=>{
    const map = {
        "&[Page]": "&P",
        "&[Pages]": "&N",
        "&[Date]": "&D",
        "&[Time]": "&T",
        "&[Tab]": "&A",
        "&[Path]": "&Z",
        "&[File]": "&F",
        "&[Picture]": "&G"
    };
    (0, $jIDNV._).iterateObject(map, (key, val)=>{
        value = value.replace(key, val);
    });
    return value;
};
var $5b7ccabde48fae90$var$getHeaderPosition = (position)=>{
    if (position === "Center") return "C";
    if (position === "Right") return "R";
    return "L";
};
var $5b7ccabde48fae90$var$applyHeaderFontStyle = (headerString, font)=>{
    if (!font) return headerString;
    headerString += "&amp;&quot;";
    headerString += font.fontName || "Calibri";
    if (font.bold !== font.italic) headerString += font.bold ? ",Bold" : ",Italic";
    else if (font.bold) headerString += ",Bold Italic";
    else headerString += ",Regular";
    headerString += "&quot;";
    if (font.size) headerString += `&amp;${font.size}`;
    if (font.strikeThrough) headerString += "&amp;S";
    if (font.underline) headerString += `&amp;${font.underline === "Double" ? "E" : "U"}`;
    if (font.color) headerString += `&amp;K${font.color.replace("#", "").toUpperCase()}`;
    return headerString;
};
var $5b7ccabde48fae90$var$processHeaderFooterContent = (content, location, rule)=>content.reduce((prev, curr, idx)=>{
        const pos = $5b7ccabde48fae90$var$getHeaderPosition(curr.position);
        const output = $5b7ccabde48fae90$var$applyHeaderFontStyle(`${prev}&amp;${pos}`, curr.font);
        const PositionMap = [
            "Left",
            "Center",
            "Right"
        ];
        if (!curr.position) curr.position = PositionMap[idx];
        const { image: image } = curr;
        if (curr.value === "&[Picture]" && image) {
            const imagePosition = `${pos}${location}${rule}`;
            $5b7ccabde48fae90$var$ExcelXlsxFactory.addHeaderFooterImageToMap(image, imagePosition);
        }
        return `${output}${(0, $jIDNV._).escapeString($5b7ccabde48fae90$var$replaceHeaderFooterTokens(curr.value))}`;
    }, "");
var $5b7ccabde48fae90$var$buildHeaderFooter = (headerFooterConfig)=>{
    const rules = [
        "all",
        "first",
        "even"
    ];
    const headersAndFooters = [];
    rules.forEach((rule)=>{
        const headerFooter = headerFooterConfig[rule];
        const namePrefix = rule === "all" ? "odd" : rule;
        if (!headerFooter) return;
        for (const [key, value] of Object.entries(headerFooter)){
            const nameSuffix = `${key.charAt(0).toUpperCase()}${key.slice(1)}`;
            const location = key[0].toUpperCase();
            if (value) {
                const normalizedRule = rule === "all" ? "" : rule.toUpperCase();
                headersAndFooters.push({
                    name: `${namePrefix}${nameSuffix}`,
                    properties: {
                        rawMap: {
                            "xml:space": "preserve"
                        }
                    },
                    textNode: $5b7ccabde48fae90$var$processHeaderFooterContent(value, location, normalizedRule)
                });
            }
        }
    });
    return headersAndFooters;
};
var $5b7ccabde48fae90$var$addHeaderFooter = (headerFooterConfig)=>{
    return (params)=>{
        if (!headerFooterConfig) return params;
        const differentFirst = headerFooterConfig.first != null ? 1 : 0;
        const differentOddEven = headerFooterConfig.even != null ? 1 : 0;
        params.children.push({
            name: "headerFooter",
            properties: {
                rawMap: {
                    differentFirst: differentFirst,
                    differentOddEven: differentOddEven
                }
            },
            children: $5b7ccabde48fae90$var$buildHeaderFooter(headerFooterConfig)
        });
        return params;
    };
};
var $5b7ccabde48fae90$var$addExcelTableRel = (excelTable)=>{
    return (params)=>{
        if (excelTable) params.children.push({
            name: "tableParts",
            properties: {
                rawMap: {
                    count: "1"
                }
            },
            children: [
                {
                    name: "tablePart",
                    properties: {
                        rawMap: {
                            "r:id": `rId${++params.rIdCounter}`
                        }
                    }
                }
            ]
        });
        return params;
    };
};
var $5b7ccabde48fae90$var$addDrawingRel = (currentSheet2)=>{
    return (params)=>{
        const worksheetImages = $5b7ccabde48fae90$var$ExcelXlsxFactory.worksheetImages.get(currentSheet2);
        if (worksheetImages == null ? void 0 : worksheetImages.length) params.children.push({
            name: "drawing",
            properties: {
                rawMap: {
                    "r:id": `rId${++params.rIdCounter}`
                }
            }
        });
        return params;
    };
};
var $5b7ccabde48fae90$var$addVmlDrawingRel = (currentSheet2)=>{
    return (params)=>{
        if ($5b7ccabde48fae90$var$ExcelXlsxFactory.worksheetHeaderFooterImages.get(currentSheet2)) params.children.push({
            name: "legacyDrawingHF",
            properties: {
                rawMap: {
                    "r:id": `rId${++params.rIdCounter}`
                }
            }
        });
        return params;
    };
};
var $5b7ccabde48fae90$var$addSheetPr = ()=>{
    return (params)=>{
        params.children.push({
            name: "sheetPr",
            children: [
                {
                    name: "outlinePr",
                    properties: {
                        rawMap: {
                            summaryBelow: 0
                        }
                    }
                }
            ]
        });
        return params;
    };
};
var $5b7ccabde48fae90$var$addSheetFormatPr = (rows)=>{
    return (params)=>{
        const maxOutline = rows.reduce((prev, row)=>{
            if (row.outlineLevel && row.outlineLevel > prev) return row.outlineLevel;
            return prev;
        }, 0);
        params.children.push({
            name: "sheetFormatPr",
            properties: {
                rawMap: {
                    baseColWidth: 10,
                    defaultRowHeight: 16,
                    outlineLevelRow: maxOutline ? maxOutline : void 0
                }
            }
        });
        return params;
    };
};
var $5b7ccabde48fae90$var$worksheetFactory = {
    getTemplate (params) {
        const { worksheet: worksheet, currentSheet: currentSheet2, config: config } = params;
        const { margins: margins = {}, pageSetup: pageSetup, headerFooterConfig: headerFooterConfig, suppressColumnOutline: suppressColumnOutline } = config;
        const { table: table } = worksheet;
        const { rows: rows, columns: columns } = table;
        const mergedCells = columns && columns.length ? $5b7ccabde48fae90$var$getMergedCellsAndAddColumnGroups(rows, columns, !!suppressColumnOutline) : [];
        const { worksheetDataTables: worksheetDataTables } = $5b7ccabde48fae90$var$ExcelXlsxFactory;
        const worksheetExcelTables = worksheetDataTables.get(currentSheet2);
        const createWorksheetChildren = (0, $jIDNV._).compose($5b7ccabde48fae90$var$addSheetPr(), $5b7ccabde48fae90$var$addSheetFormatPr(rows), $5b7ccabde48fae90$var$addColumns(columns), $5b7ccabde48fae90$var$addSheetData(rows, currentSheet2 + 1), $5b7ccabde48fae90$var$addMergeCells(mergedCells), $5b7ccabde48fae90$var$addPageMargins(margins), $5b7ccabde48fae90$var$addPageSetup(pageSetup), $5b7ccabde48fae90$var$addHeaderFooter(headerFooterConfig), $5b7ccabde48fae90$var$addDrawingRel(currentSheet2), $5b7ccabde48fae90$var$addVmlDrawingRel(currentSheet2), $5b7ccabde48fae90$var$addExcelTableRel(worksheetExcelTables));
        const { children: children } = createWorksheetChildren({
            children: [],
            rIdCounter: 0
        });
        return {
            name: "worksheet",
            properties: {
                prefixedAttributes: [
                    {
                        prefix: "xmlns:",
                        map: {
                            r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships"
                        }
                    }
                ],
                rawMap: {
                    xmlns: "http://schemas.openxmlformats.org/spreadsheetml/2006/main"
                }
            },
            children: children
        };
    }
};
var $5b7ccabde48fae90$var$worksheet_default = $5b7ccabde48fae90$var$worksheetFactory;
var $5b7ccabde48fae90$var$relationshipFactory = {
    getTemplate (config) {
        const { Id: Id, Type: Type, Target: Target } = config;
        return {
            name: "Relationship",
            properties: {
                rawMap: {
                    Id: Id,
                    Type: Type,
                    Target: Target
                }
            }
        };
    }
};
var $5b7ccabde48fae90$var$relationship_default = $5b7ccabde48fae90$var$relationshipFactory;
var $5b7ccabde48fae90$var$relationshipsFactory = {
    getTemplate (c) {
        const children = c.map((relationship)=>$5b7ccabde48fae90$var$relationship_default.getTemplate(relationship));
        return {
            name: "Relationships",
            properties: {
                rawMap: {
                    xmlns: "http://schemas.openxmlformats.org/package/2006/relationships"
                }
            },
            children: children
        };
    }
};
var $5b7ccabde48fae90$var$relationships_default = $5b7ccabde48fae90$var$relationshipsFactory;
var $5b7ccabde48fae90$var$getShapeLayout = ()=>({
        name: "o:shapelayout",
        properties: {
            prefixedAttributes: [
                {
                    prefix: "v:",
                    map: {
                        ext: "edit"
                    }
                }
            ]
        },
        children: [
            {
                name: "o:idmap",
                properties: {
                    prefixedAttributes: [
                        {
                            prefix: "v:",
                            map: {
                                ext: "edit"
                            }
                        }
                    ],
                    rawMap: {
                        data: "1"
                    }
                }
            }
        ]
    });
var $5b7ccabde48fae90$var$getStroke = ()=>({
        name: "v:stroke",
        properties: {
            rawMap: {
                joinstyle: "miter"
            }
        }
    });
var $5b7ccabde48fae90$var$getFormulas = (formulas)=>({
        name: "v:formulas",
        children: formulas.map((formula)=>({
                name: "v:f",
                properties: {
                    rawMap: {
                        eqn: formula
                    }
                }
            }))
    });
var $5b7ccabde48fae90$var$getPath = ()=>({
        name: "v:path",
        properties: {
            prefixedAttributes: [
                {
                    prefix: "o:",
                    map: {
                        connecttype: "rect",
                        extrusionok: "f"
                    }
                }
            ],
            rawMap: {
                gradientshapeok: "t"
            }
        }
    });
var $5b7ccabde48fae90$var$getLock = (params)=>{
    const { aspectratio: aspectratio, rotation: rotation } = params || {};
    const rawMap = {};
    if (aspectratio) rawMap.aspectratio = "t";
    if (rotation) rawMap.rotation = "t";
    return {
        name: "o:lock",
        properties: {
            prefixedAttributes: [
                {
                    prefix: "v:",
                    map: {
                        ext: "edit"
                    }
                }
            ],
            rawMap: rawMap
        }
    };
};
function $5b7ccabde48fae90$var$mapNumber(value, startSource, endSource, startTarget, endTarget) {
    return (value - startSource) / (endSource - startSource) * (endTarget - startTarget) + startTarget;
}
var $5b7ccabde48fae90$var$gainMap = {
    0: "0",
    5: "6554f",
    10: "13107f",
    15: "19661f",
    20: "26214f",
    25: ".5",
    30: "39322f",
    35: "45875f",
    40: "52429f",
    45: "58982f",
    50: "1",
    55: "72818f",
    60: "1.25",
    65: "93623f",
    70: "109227f",
    75: "2",
    80: "2.5",
    85: "3.4",
    90: "5",
    95: "10",
    96: "12.5",
    97: "1092267f",
    98: "25",
    99: "50",
    100: "2147483647f"
};
var $5b7ccabde48fae90$var$getImageData = (image, idx)=>{
    var _a;
    let rawMap;
    const { recolor: recolor, brightness: brightness, contrast: contrast, id: id } = image;
    if (recolor) {
        rawMap = {};
        if (recolor === "Washout" || recolor === "Grayscale") {
            rawMap.gain = "19661f";
            rawMap.blacklevel = "22938f";
        }
        if (recolor === "Black & White" || recolor === "Grayscale") {
            rawMap.grayscale = "t";
            if (recolor === "Black & White") rawMap.bilevel = "t";
        }
    }
    if (!recolor || recolor === "Grayscale") {
        if (!rawMap) rawMap = {};
        if (contrast != null && contrast !== 50) rawMap.gain = (_a = $5b7ccabde48fae90$var$gainMap[contrast]) != null ? _a : "1";
        if (brightness != null && brightness !== 50) rawMap.blacklevel = $5b7ccabde48fae90$var$mapNumber(brightness, 0, 100, -0.5, 0.5).toString();
    }
    return {
        name: "v:imagedata",
        properties: {
            prefixedAttributes: [
                {
                    prefix: "o:",
                    map: {
                        relid: `rId${idx}`,
                        title: id
                    }
                }
            ],
            rawMap: rawMap
        }
    };
};
var $5b7ccabde48fae90$var$getShapeType = ()=>{
    const formulas = [
        "if lineDrawn pixelLineWidth 0",
        "sum @0 1 0",
        "sum 0 0 @1",
        "prod @2 1 2",
        "prod @3 21600 pixelWidth",
        "prod @3 21600 pixelHeight",
        "sum @0 0 1",
        "prod @6 1 2",
        "prod @7 21600 pixelWidth",
        "sum @8 21600 0",
        "prod @7 21600 pixelHeight",
        "sum @10 21600 0"
    ];
    return {
        name: "v:shapetype",
        properties: {
            prefixedAttributes: [
                {
                    prefix: "o:",
                    map: {
                        spt: "75",
                        preferrelative: "t"
                    }
                }
            ],
            rawMap: {
                coordsize: "21600,21600",
                filled: "f",
                id: "_x0000_t75",
                path: "m@4@5l@4@11@9@11@9@5xe",
                stroked: "f"
            }
        },
        children: [
            $5b7ccabde48fae90$var$getStroke(),
            $5b7ccabde48fae90$var$getFormulas(formulas),
            $5b7ccabde48fae90$var$getPath(),
            $5b7ccabde48fae90$var$getLock({
                aspectratio: true
            })
        ]
    };
};
var $5b7ccabde48fae90$var$pixelToPoint = (value)=>Math.floor((value != null ? value : 0) * 0.74999943307122);
var $5b7ccabde48fae90$var$getShape = (image, idx)=>{
    const { width: width = 0, height: height = 0, altText: altText } = image;
    const imageWidth = $5b7ccabde48fae90$var$pixelToPoint(width);
    const imageHeight = $5b7ccabde48fae90$var$pixelToPoint(height);
    return {
        name: "v:shape",
        properties: {
            rawMap: {
                id: image.headerFooterPosition,
                "o:spid": "_x0000_s1025",
                style: `position: absolute; margin-left: 0; margin-top: 10in; margin-bottom: 0; margin-right: 0; width: ${imageWidth}pt; height: ${imageHeight}pt; z-index: ${idx + 1}`,
                type: "#_x0000_t75",
                alt: altText
            }
        },
        children: [
            $5b7ccabde48fae90$var$getImageData(image, idx + 1),
            $5b7ccabde48fae90$var$getLock({
                rotation: true
            })
        ]
    };
};
var $5b7ccabde48fae90$var$vmlDrawingFactory = {
    getTemplate (params) {
        const headerFooterImages = $5b7ccabde48fae90$var$ExcelXlsxFactory.worksheetHeaderFooterImages.get(params.sheetIndex) || [];
        const children = [
            $5b7ccabde48fae90$var$getShapeLayout(),
            $5b7ccabde48fae90$var$getShapeType(),
            ...headerFooterImages.map((img, idx)=>$5b7ccabde48fae90$var$getShape(img, idx))
        ];
        return {
            name: "xml",
            properties: {
                prefixedAttributes: [
                    {
                        prefix: "xmlns:",
                        map: {
                            v: "urn:schemas-microsoft-com:vml",
                            o: "urn:schemas-microsoft-com:office:office",
                            x: "urn:schemas-microsoft-com:office:excel"
                        }
                    }
                ]
            },
            children: children
        };
    }
};
var $5b7ccabde48fae90$var$vmlDrawing_default = $5b7ccabde48fae90$var$vmlDrawingFactory;
var $5b7ccabde48fae90$var$_ExcelXlsxFactory = class _ExcelXlsxFactory2 {
    static createExcel(styles, worksheet, config) {
        this.addSheetName(worksheet);
        $5b7ccabde48fae90$var$registerStyles(styles, this.sheetNames.length);
        let newConfig = Object.assign({}, config);
        if (config.exportAsExcelTable) {
            if (config.columnModel.isPivotActive()) {
                this.showExcelTableNonCompatibleFeaturesWarning("pivot mode");
                newConfig.exportAsExcelTable = false;
            }
            if (config.gos.get("masterDetail")) {
                this.showExcelTableNonCompatibleFeaturesWarning("master/detail");
                newConfig.exportAsExcelTable = false;
            }
        }
        this.processTableConfig(worksheet, newConfig);
        return this.createWorksheet(worksheet, newConfig);
    }
    static showExcelTableNonCompatibleFeaturesWarning(featureName) {
        console.warn(`AG Grid: Excel table export does not work with ${featureName}. The exported Excel file will not contain any Excel tables.
Please turn off ${featureName} to enable Excel table exports.`);
    }
    static getTableNameFromIndex(idx) {
        return `table${idx + 1}`;
    }
    static getSanitizedTableName(name) {
        return name.replace(/^[^a-zA-Z_]+/, "_").replace(/\s/g, "_").replace(/[^a-zA-Z0-9_]/g, "_");
    }
    static addTableToSheet(sheetIndex, table) {
        if (this.worksheetDataTables.has(sheetIndex)) {
            console.warn("Unable to add data table to Excel sheet: A table already exists.");
            return;
        }
        this.worksheetDataTables.set(sheetIndex, table);
    }
    static processTableConfig(worksheet, config) {
        var _a;
        if (!config.exportAsExcelTable) return;
        const tableConfig = typeof config.exportAsExcelTable === "boolean" ? {} : config.exportAsExcelTable;
        const { name: nameFromConfig, showColumnStripes: showColumnStripes, showRowStripes: showRowStripes, showFilterButton: showFilterButton, highlightFirstColumn: highlightFirstColumn, highlightLastColumn: highlightLastColumn } = tableConfig;
        const tableName = this.getSanitizedTableName(nameFromConfig || _ExcelXlsxFactory2.defaultTableDisplayName);
        const sheetIndex = this.sheetNames.length - 1;
        const { table: table } = worksheet;
        const { rows: rows, columns: columns } = table;
        const headerRowCount = config.columnModel.getHeaderRowCount();
        const tableHeaderRowIndex = headerRowCount - 1;
        const tableRowCount = rows.length;
        const tableColCount = columns.length;
        const tableColumns = [];
        const showFilterButtons = [];
        for(let i = 0; i < tableColCount; i++){
            const col = columns[i];
            tableColumns.push(col.displayName || "");
            showFilterButtons.push(showFilterButton === "match" || showFilterButton === void 0 ? (_a = col.filterAllowed) != null ? _a : false : showFilterButton);
        }
        if (!tableColumns || !tableColumns.length || !tableRowCount || !tableName) {
            console.warn("Unable to add data table to Excel sheet: Missing required parameters.");
            return;
        }
        this.addTableToSheet(sheetIndex, {
            name: this.getTableNameFromIndex(sheetIndex),
            displayName: tableName,
            columns: tableColumns,
            showFilterButtons: showFilterButtons,
            headerRowIndex: tableHeaderRowIndex,
            rowCount: tableRowCount - headerRowCount,
            showRowStripes: showRowStripes != null ? showRowStripes : true,
            showColumnStripes: showColumnStripes != null ? showColumnStripes : false,
            highlightFirstColumn: highlightFirstColumn != null ? highlightFirstColumn : false,
            highlightLastColumn: highlightLastColumn != null ? highlightLastColumn : false
        });
    }
    static addHeaderFooterImageToMap(image, position) {
        const sheetIndex = this.sheetNames.length - 1;
        const headerFooterImage = image;
        headerFooterImage.headerFooterPosition = position;
        this.buildImageMap({
            imageToAdd: headerFooterImage,
            idx: sheetIndex
        });
        let headerFooterImagesForSheet = this.worksheetHeaderFooterImages.get(sheetIndex);
        if (!headerFooterImagesForSheet) {
            headerFooterImagesForSheet = [];
            this.worksheetHeaderFooterImages.set(sheetIndex, headerFooterImagesForSheet);
        }
        if (!headerFooterImagesForSheet.find((img)=>img.id === image.id)) headerFooterImagesForSheet.push(image);
    }
    static addBodyImageToMap(image, rowIndex, col, columnsToExport, rowHeight) {
        let sheetIndex = this.sheetNames.length;
        const { row: row, column: column } = image.position || {};
        const calculatedImage = image;
        if (columnsToExport) {
            if (rowIndex != null && col != null && (!row || !column)) {
                if (!image.position) image.position = {};
                image.position = Object.assign({}, image.position, {
                    row: rowIndex,
                    column: columnsToExport.indexOf(col) + 1
                });
            }
            $5b7ccabde48fae90$var$setExcelImageTotalWidth(calculatedImage, columnsToExport);
            $5b7ccabde48fae90$var$setExcelImageTotalHeight(calculatedImage, rowHeight);
        }
        this.buildImageMap({
            imageToAdd: calculatedImage,
            idx: sheetIndex
        });
        let worksheetImageIdMap = this.worksheetImageIds.get(sheetIndex);
        if (!worksheetImageIdMap) {
            worksheetImageIdMap = /* @__PURE__ */ new Map();
            this.worksheetImageIds.set(sheetIndex, worksheetImageIdMap);
        }
        const sheetImages = this.worksheetImages.get(sheetIndex);
        if (!sheetImages) this.worksheetImages.set(sheetIndex, [
            calculatedImage
        ]);
        else sheetImages.push(calculatedImage);
        if (!worksheetImageIdMap.get(image.id)) worksheetImageIdMap.set(image.id, {
            index: worksheetImageIdMap.size,
            type: image.imageType
        });
    }
    static buildImageMap(params) {
        const { imageToAdd: imageToAdd, idx: idx } = params;
        const mappedImagesToSheet = this.images.get(imageToAdd.id);
        if (mappedImagesToSheet) {
            const currentSheetImages = mappedImagesToSheet.find((currentImage)=>currentImage.sheetId === idx);
            if (currentSheetImages) currentSheetImages.image.push(imageToAdd);
            else mappedImagesToSheet.push({
                sheetId: idx,
                image: [
                    imageToAdd
                ]
            });
        } else {
            this.images.set(imageToAdd.id, [
                {
                    sheetId: idx,
                    image: [
                        imageToAdd
                    ]
                }
            ]);
            this.workbookImageIds.set(imageToAdd.id, {
                type: imageToAdd.imageType,
                index: this.workbookImageIds.size
            });
        }
    }
    static addSheetName(worksheet) {
        const name = (0, $jIDNV._).escapeString(worksheet.name) || "";
        let append = "";
        while(this.sheetNames.indexOf(`${name}${append}`) !== -1)if (append === "") append = "_1";
        else {
            const curr = parseInt(append.slice(1), 10);
            append = `_${curr + 1}`;
        }
        worksheet.name = `${name}${append}`;
        this.sheetNames.push(worksheet.name);
    }
    static getStringPosition(str) {
        if (this.sharedStrings.has(str)) return this.sharedStrings.get(str);
        this.sharedStrings.set(str, this.sharedStrings.size);
        return this.sharedStrings.size - 1;
    }
    static resetFactory() {
        this.sharedStrings = /* @__PURE__ */ new Map();
        this.images = /* @__PURE__ */ new Map();
        this.worksheetImages = /* @__PURE__ */ new Map();
        this.worksheetHeaderFooterImages = /* @__PURE__ */ new Map();
        this.workbookImageIds = /* @__PURE__ */ new Map();
        this.worksheetImageIds = /* @__PURE__ */ new Map();
        this.worksheetDataTables = /* @__PURE__ */ new Map();
        this.sheetNames = [];
        this.factoryMode = (0, $jIDNV.ExcelFactoryMode).SINGLE_SHEET;
    }
    static createWorkbook() {
        return $5b7ccabde48fae90$var$createXmlPart($5b7ccabde48fae90$var$workbook_default.getTemplate(this.sheetNames));
    }
    static createStylesheet(defaultFontSize) {
        return $5b7ccabde48fae90$var$createXmlPart($5b7ccabde48fae90$var$stylesheet_default.getTemplate(defaultFontSize));
    }
    static createSharedStrings() {
        return $5b7ccabde48fae90$var$createXmlPart($5b7ccabde48fae90$var$sharedStrings_default.getTemplate(this.sharedStrings));
    }
    static createCore(author) {
        return $5b7ccabde48fae90$var$createXmlPart($5b7ccabde48fae90$var$core_default.getTemplate(author));
    }
    static createContentTypes(sheetLen) {
        return $5b7ccabde48fae90$var$createXmlPart($5b7ccabde48fae90$var$contentTypes_default.getTemplate(sheetLen));
    }
    static createRels() {
        const rs = $5b7ccabde48fae90$var$relationships_default.getTemplate([
            {
                Id: "rId1",
                Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
                Target: "xl/workbook.xml"
            },
            {
                Id: "rId2",
                Type: "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties",
                Target: "docProps/core.xml"
            }
        ]);
        return $5b7ccabde48fae90$var$createXmlPart(rs);
    }
    static createTheme() {
        return $5b7ccabde48fae90$var$createXmlPart($5b7ccabde48fae90$var$office_default.getTemplate());
    }
    static createTable(dataTable, index) {
        return $5b7ccabde48fae90$var$createXmlPart($5b7ccabde48fae90$var$table_default.getTemplate(dataTable, index));
    }
    static createWorkbookRels(sheetLen) {
        const worksheets = new Array(sheetLen).fill(void 0).map((v, i)=>({
                Id: `rId${i + 1}`,
                Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
                Target: `worksheets/sheet${i + 1}.xml`
            }));
        const rs = $5b7ccabde48fae90$var$relationships_default.getTemplate([
            ...worksheets,
            {
                Id: `rId${sheetLen + 1}`,
                Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme",
                Target: "theme/theme1.xml"
            },
            {
                Id: `rId${sheetLen + 2}`,
                Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",
                Target: "styles.xml"
            },
            {
                Id: `rId${sheetLen + 3}`,
                Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings",
                Target: "sharedStrings.xml"
            }
        ]);
        return $5b7ccabde48fae90$var$createXmlPart(rs);
    }
    static createDrawing(sheetIndex) {
        return $5b7ccabde48fae90$var$createXmlPart($5b7ccabde48fae90$var$drawing_default.getTemplate({
            sheetIndex: sheetIndex
        }));
    }
    static createDrawingRel(sheetIndex) {
        const worksheetImageIds = this.worksheetImageIds.get(sheetIndex) || [];
        const XMLArr = [];
        for (const [key, value] of worksheetImageIds)XMLArr.push({
            Id: `rId${value.index + 1}`,
            Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
            Target: `../media/image${this.workbookImageIds.get(key).index + 1}.${value.type}`
        });
        return $5b7ccabde48fae90$var$createXmlPart($5b7ccabde48fae90$var$relationships_default.getTemplate(XMLArr));
    }
    static createVmlDrawing(sheetIndex) {
        return $5b7ccabde48fae90$var$createXmlPart($5b7ccabde48fae90$var$vmlDrawing_default.getTemplate({
            sheetIndex: sheetIndex
        }), true);
    }
    static createVmlDrawingRel(sheetIndex) {
        const worksheetHeaderFooterImages = this.worksheetHeaderFooterImages.get(sheetIndex) || [];
        const XMLArr = [];
        for(let i = 0; i < worksheetHeaderFooterImages.length; i++){
            const headerFooterImage = worksheetHeaderFooterImages[i];
            const workbookImage = this.workbookImageIds.get(headerFooterImage.id);
            if (!workbookImage) continue;
            const { index: index, type: type } = workbookImage;
            const imageType = type === "jpg" ? "jpeg" : type;
            XMLArr.push({
                Id: `rId${i + 1}`,
                Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
                Target: `../media/image${index + 1}.${imageType}`
            });
        }
        return $5b7ccabde48fae90$var$createXmlPart($5b7ccabde48fae90$var$relationships_default.getTemplate(XMLArr));
    }
    static createRelationships({ drawingIndex: drawingIndex, vmlDrawingIndex: vmlDrawingIndex, tableIndex: tableIndex } = {}) {
        if (drawingIndex === void 0 && vmlDrawingIndex === void 0 && tableIndex === void 0) return "";
        const config = [];
        if (drawingIndex != null) config.push({
            Id: `rId${config.length + 1}`,
            Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing",
            Target: `../drawings/drawing${drawingIndex + 1}.xml`
        });
        if (vmlDrawingIndex != null) config.push({
            Id: `rId${config.length + 1}`,
            Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
            Target: `../drawings/vmlDrawing${vmlDrawingIndex + 1}.vml`
        });
        if (tableIndex != null) config.push({
            Id: `rId${config.length + 1}`,
            Type: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/table",
            Target: `../tables/${this.getTableNameFromIndex(tableIndex)}.xml`
        });
        const rs = $5b7ccabde48fae90$var$relationships_default.getTemplate(config);
        return $5b7ccabde48fae90$var$createXmlPart(rs);
    }
    static createWorksheet(worksheet, config) {
        return $5b7ccabde48fae90$var$createXmlPart($5b7ccabde48fae90$var$worksheet_default.getTemplate({
            worksheet: worksheet,
            currentSheet: this.sheetNames.length - 1,
            config: config
        }));
    }
};
$5b7ccabde48fae90$var$_ExcelXlsxFactory.sharedStrings = /* @__PURE__ */ new Map();
$5b7ccabde48fae90$var$_ExcelXlsxFactory.sheetNames = [];
$5b7ccabde48fae90$var$_ExcelXlsxFactory.images = /* @__PURE__ */ new Map();
$5b7ccabde48fae90$var$_ExcelXlsxFactory.worksheetImages = /* @__PURE__ */ new Map();
$5b7ccabde48fae90$var$_ExcelXlsxFactory.worksheetHeaderFooterImages = /* @__PURE__ */ new Map();
$5b7ccabde48fae90$var$_ExcelXlsxFactory.workbookImageIds = /* @__PURE__ */ new Map();
$5b7ccabde48fae90$var$_ExcelXlsxFactory.worksheetImageIds = /* @__PURE__ */ new Map();
$5b7ccabde48fae90$var$_ExcelXlsxFactory.worksheetDataTables = /* @__PURE__ */ new Map();
$5b7ccabde48fae90$var$_ExcelXlsxFactory.defaultTableDisplayName = "AG-GRID-TABLE";
$5b7ccabde48fae90$var$_ExcelXlsxFactory.factoryMode = (0, $jIDNV.ExcelFactoryMode).SINGLE_SHEET;
var $5b7ccabde48fae90$var$ExcelXlsxFactory = $5b7ccabde48fae90$var$_ExcelXlsxFactory;
var $5b7ccabde48fae90$var$ExcelSerializingSession = class extends (0, $jIDNV.BaseGridSerializingSession) {
    constructor(config){
        super(config);
        this.mixedStyles = {};
        this.mixedStyleCounter = 0;
        this.rows = [];
        this.config = Object.assign({}, config);
        this.stylesByIds = {};
        this.config.baseExcelStyles.forEach((style)=>{
            this.stylesByIds[style.id] = style;
        });
        this.excelStyles = [
            ...this.config.baseExcelStyles,
            {
                id: "_quotePrefix",
                quotePrefix: 1
            }
        ];
    }
    addCustomContent(customContent) {
        customContent.forEach((row)=>{
            const rowLen = this.rows.length + 1;
            let outlineLevel;
            if (!this.config.suppressRowOutline && row.outlineLevel != null) outlineLevel = row.outlineLevel;
            const rowObj = {
                height: $5b7ccabde48fae90$var$getHeightFromProperty(rowLen, row.height || this.config.rowHeight),
                cells: (row.cells || []).map((cell, idx)=>{
                    var _a, _b, _c;
                    const image = this.addImage(rowLen, this.columnsToExport[idx], (_a = cell.data) == null ? void 0 : _a.value);
                    let excelStyles = null;
                    if (cell.styleId) excelStyles = typeof cell.styleId === "string" ? [
                        cell.styleId
                    ] : cell.styleId;
                    const excelStyleId = this.getStyleId(excelStyles);
                    if (image) return this.createCell(excelStyleId, this.getDataTypeForValue(image.value), image.value == null ? "" : image.value);
                    const value = (_c = (_b = cell.data) == null ? void 0 : _b.value) != null ? _c : "";
                    const type = this.getDataTypeForValue(value);
                    if (cell.mergeAcross) return this.createMergedCell(excelStyleId, type, value, cell.mergeAcross);
                    return this.createCell(excelStyleId, type, value);
                }),
                outlineLevel: outlineLevel
            };
            if (row.collapsed != null) rowObj.collapsed = row.collapsed;
            if (row.hidden != null) rowObj.hidden = row.hidden;
            this.rows.push(rowObj);
        });
    }
    onNewHeaderGroupingRow() {
        const currentCells = [];
        this.rows.push({
            cells: currentCells,
            height: $5b7ccabde48fae90$var$getHeightFromProperty(this.rows.length + 1, this.config.headerRowHeight)
        });
        return {
            onColumn: (columnGroup, header, index, span, collapsibleRanges)=>{
                const styleIds = this.config.styleLinker({
                    rowType: (0, $jIDNV.RowType).HEADER_GROUPING,
                    rowIndex: 1,
                    value: `grouping-${header}`,
                    columnGroup: columnGroup
                });
                currentCells.push($5b7ccabde48fae90$var$__spreadProps6($5b7ccabde48fae90$var$__spreadValues7({}, this.createMergedCell(this.getStyleId(styleIds), this.getDataTypeForValue("string"), header, span)), {
                    collapsibleRanges: collapsibleRanges
                }));
            }
        };
    }
    onNewHeaderRow() {
        return this.onNewRow(this.onNewHeaderColumn, this.config.headerRowHeight);
    }
    onNewBodyRow(node) {
        const rowAccumulator = this.onNewRow(this.onNewBodyColumn, this.config.rowHeight);
        if (node) this.addRowOutlineIfNecessary(node);
        return rowAccumulator;
    }
    prepare(columnsToExport) {
        super.prepare(columnsToExport);
        this.columnsToExport = [
            ...columnsToExport
        ];
        this.cols = columnsToExport.map((col, i)=>this.convertColumnToExcel(col, i));
    }
    parse() {
        const longestRow = this.rows.reduce((a, b)=>Math.max(a, b.cells.length), 0);
        while(this.cols.length < longestRow)this.cols.push(this.convertColumnToExcel(null, this.cols.length + 1));
        const data = {
            name: this.config.sheetName,
            table: {
                columns: this.cols,
                rows: this.rows
            }
        };
        return this.createExcel(data);
    }
    addRowOutlineIfNecessary(node) {
        const { gos: gos, suppressRowOutline: suppressRowOutline, rowGroupExpandState: rowGroupExpandState = "expanded" } = this.config;
        const isGroupHideOpenParents = gos.get("groupHideOpenParents");
        if (isGroupHideOpenParents || suppressRowOutline || node.level == null) return;
        const padding = node.footer ? 1 : 0;
        const currentRow = (0, $jIDNV._).last(this.rows);
        currentRow.outlineLevel = node.level + padding;
        if (rowGroupExpandState === "expanded") return;
        const collapseAll = rowGroupExpandState === "collapsed";
        if (node.isExpandable()) {
            const isExpanded = !collapseAll && node.expanded;
            currentRow.collapsed = !isExpanded;
        }
        currentRow.hidden = !!node.parent && // or if it is a child of the root node
        node.parent.level !== -1 && (collapseAll || this.isAnyParentCollapsed(node.parent));
    }
    isAnyParentCollapsed(node) {
        while(node && node.level !== -1){
            if (!node.expanded) return true;
            node = node.parent;
        }
        return false;
    }
    convertColumnToExcel(column, index) {
        const columnWidth = this.config.columnWidth;
        const headerValue = column ? this.extractHeaderValue(column) : void 0;
        const displayName = headerValue != null ? headerValue : "";
        const filterAllowed = column ? column.isFilterAllowed() : false;
        if (columnWidth) {
            if (typeof columnWidth === "number") return {
                width: columnWidth,
                displayName: displayName,
                filterAllowed: filterAllowed
            };
            return {
                width: columnWidth({
                    column: column,
                    index: index
                }),
                displayName: displayName,
                filterAllowed: filterAllowed
            };
        }
        if (column) {
            const smallestUsefulWidth = 75;
            return {
                width: Math.max(column.getActualWidth(), smallestUsefulWidth),
                displayName: displayName,
                filterAllowed: filterAllowed
            };
        }
        return {
            displayName: displayName,
            filterAllowed: filterAllowed
        };
    }
    onNewHeaderColumn(rowIndex, currentCells) {
        return (column)=>{
            const nameForCol = this.extractHeaderValue(column);
            const styleIds = this.config.styleLinker({
                rowType: (0, $jIDNV.RowType).HEADER,
                rowIndex: rowIndex,
                value: nameForCol,
                column: column
            });
            currentCells.push(this.createCell(this.getStyleId(styleIds), this.getDataTypeForValue("string"), nameForCol));
        };
    }
    onNewBodyColumn(rowIndex, currentCells) {
        let skipCols = 0;
        return (column, index, node)=>{
            if (skipCols > 0) {
                skipCols -= 1;
                return;
            }
            const { value: valueForCell, valueFormatted: valueFormatted } = this.extractRowCellValue(column, index, rowIndex, "excel", node);
            const styleIds = this.config.styleLinker({
                rowType: (0, $jIDNV.RowType).BODY,
                rowIndex: rowIndex,
                value: valueForCell,
                column: column,
                node: node
            });
            const excelStyleId = this.getStyleId(styleIds);
            const colSpan = column.getColSpan(node);
            const addedImage = this.addImage(rowIndex, column, valueForCell);
            if (addedImage) currentCells.push(this.createCell(excelStyleId, this.getDataTypeForValue(addedImage.value), addedImage.value == null ? "" : addedImage.value));
            else if (colSpan > 1) {
                skipCols = colSpan - 1;
                currentCells.push(this.createMergedCell(excelStyleId, this.getDataTypeForValue(valueForCell), valueForCell, colSpan - 1));
            } else currentCells.push(this.createCell(excelStyleId, this.getDataTypeForValue(valueForCell), valueForCell, valueFormatted));
        };
    }
    onNewRow(onNewColumnAccumulator, height) {
        const currentCells = [];
        this.rows.push({
            cells: currentCells,
            height: $5b7ccabde48fae90$var$getHeightFromProperty(this.rows.length + 1, height)
        });
        return {
            onColumn: onNewColumnAccumulator.bind(this, this.rows.length, currentCells)()
        };
    }
    createExcel(data) {
        const { excelStyles: excelStyles, config: config } = this;
        return $5b7ccabde48fae90$var$ExcelXlsxFactory.createExcel(excelStyles, data, config);
    }
    getDataTypeForValue(valueForCell) {
        if (valueForCell === void 0) return "empty";
        return this.isNumerical(valueForCell) ? "n" : "s";
    }
    getTypeFromStyle(style, value) {
        if (this.isFormula(value)) return "f";
        if (style && style.dataType) switch(style.dataType.toLocaleLowerCase()){
            case "formula":
                return "f";
            case "string":
                return "s";
            case "number":
                return "n";
            case "datetime":
                return "d";
            case "error":
                return "e";
            case "boolean":
                return "b";
            default:
                console.warn(`AG Grid: Unrecognized data type for excel export [${style.id}.dataType=${style.dataType}]`);
        }
        return null;
    }
    addImage(rowIndex, column, value) {
        if (!this.config.addImageToCell) return;
        const addedImage = this.config.addImageToCell(rowIndex, column, value);
        if (!addedImage) return;
        $5b7ccabde48fae90$var$ExcelXlsxFactory.addBodyImageToMap(addedImage.image, rowIndex, column, this.columnsToExport, this.config.rowHeight);
        return addedImage;
    }
    createCell(styleId, type, value, valueFormatted) {
        const actualStyle = this.getStyleById(styleId);
        if (!(actualStyle == null ? void 0 : actualStyle.dataType) && type === "s" && valueFormatted) value = valueFormatted;
        const processedType = this.getTypeFromStyle(actualStyle, value) || type;
        const { value: processedValue, escaped: escaped } = this.getCellValue(processedType, value);
        const styles = [];
        if (actualStyle) styles.push(styleId);
        if (escaped) styles.push("_quotePrefix");
        styleId = this.getStyleId(styles) || void 0;
        return {
            styleId: styleId,
            data: {
                type: processedType,
                value: processedValue
            }
        };
    }
    createMergedCell(styleId, type, value, numOfCells) {
        const valueToUse = value == null ? "" : value;
        return {
            styleId: !!this.getStyleById(styleId) ? styleId : void 0,
            data: {
                type: type,
                value: type === "s" ? $5b7ccabde48fae90$var$ExcelXlsxFactory.getStringPosition(valueToUse).toString() : value
            },
            mergeAcross: numOfCells
        };
    }
    getCellValue(type, value) {
        let escaped = false;
        if (value == null) {
            type = "s";
            value = "";
        }
        if (type === "s") {
            if (value && value[0] === "'") {
                escaped = true;
                value = value.slice(1);
            }
            value = $5b7ccabde48fae90$var$ExcelXlsxFactory.getStringPosition(value).toString();
        } else if (type === "f") value = value.slice(1);
        else if (type === "n") {
            const numberValue = Number(value);
            if (isNaN(numberValue)) value = "";
            else if (value !== "") value = numberValue.toString();
        }
        return {
            value: value,
            escaped: escaped
        };
    }
    getStyleId(styleIds) {
        if (!styleIds || !styleIds.length) return null;
        if (styleIds.length === 1) return styleIds[0];
        const key = styleIds.join("-");
        if (!this.mixedStyles[key]) this.addNewMixedStyle(styleIds);
        return this.mixedStyles[key].excelID;
    }
    deepCloneObject(object) {
        return JSON.parse(JSON.stringify(object));
    }
    addNewMixedStyle(styleIds) {
        this.mixedStyleCounter += 1;
        const excelId = `mixedStyle${this.mixedStyleCounter}`;
        const resultantStyle = {};
        for (const styleId of styleIds){
            for (const excelStyle of this.excelStyles)if (excelStyle.id === styleId) (0, $jIDNV._).mergeDeep(resultantStyle, this.deepCloneObject(excelStyle));
        }
        resultantStyle.id = excelId;
        resultantStyle.name = excelId;
        const key = styleIds.join("-");
        this.mixedStyles[key] = {
            excelID: excelId,
            key: key,
            result: resultantStyle
        };
        this.excelStyles.push(resultantStyle);
        this.stylesByIds[excelId] = resultantStyle;
    }
    isFormula(value) {
        if (value == null) return false;
        return this.config.autoConvertFormulas && value.toString().startsWith("=");
    }
    isNumerical(value) {
        if (typeof value === "bigint") return true;
        return isFinite(value) && value !== "" && !isNaN(parseFloat(value));
    }
    getStyleById(styleId) {
        if (styleId == null) return null;
        return this.stylesByIds[styleId] || null;
    }
};
var $5b7ccabde48fae90$var$createExcelXMLCoreFolderStructure = ()=>{
    (0, $jIDNV.ZipContainer).addFolders([
        "_rels/",
        "docProps/",
        "xl/",
        "xl/theme/",
        "xl/_rels/",
        "xl/worksheets/"
    ]);
    const { images: images } = $5b7ccabde48fae90$var$ExcelXlsxFactory;
    if (!images.size) return;
    (0, $jIDNV.ZipContainer).addFolders([
        "xl/worksheets/_rels",
        "xl/drawings/",
        "xl/drawings/_rels",
        "xl/media/"
    ]);
    let imgCounter = 0;
    images.forEach((value)=>{
        const firstImage = value[0].image[0];
        const { base64: base64, imageType: imageType } = firstImage;
        const ext = imageType === "jpg" ? "jpeg" : imageType;
        (0, $jIDNV.ZipContainer).addFile(`xl/media/image${++imgCounter}.${ext}`, base64, true);
    });
};
var $5b7ccabde48fae90$var$createExcelXmlWorksheets = (data)=>{
    let imageRelationCounter = 0;
    let headerFooterImageCounter = 0;
    let tableRelationCounter = 0;
    const { images: images, worksheetDataTables: worksheetDataTables, worksheetImages: worksheetImages, worksheetHeaderFooterImages: worksheetHeaderFooterImages } = $5b7ccabde48fae90$var$ExcelXlsxFactory;
    for(let i = 0; i < data.length; i++){
        const value = data[i];
        (0, $jIDNV.ZipContainer).addFile(`xl/worksheets/sheet${i + 1}.xml`, value, false);
        const hasImages = images.size > 0 && worksheetImages.has(i);
        const hasTables = worksheetDataTables.size > 0 && worksheetDataTables.has(i);
        const hasHeaderFooterImages = images.size && worksheetHeaderFooterImages.has(i);
        if (!hasImages && !hasTables && !hasHeaderFooterImages) continue;
        let tableIndex;
        let drawingIndex;
        let vmlDrawingIndex;
        if (hasImages) {
            $5b7ccabde48fae90$var$createExcelXmlDrawings(i, imageRelationCounter);
            drawingIndex = imageRelationCounter;
            imageRelationCounter++;
        }
        if (hasHeaderFooterImages) {
            $5b7ccabde48fae90$var$createExcelVmlDrawings(i, headerFooterImageCounter);
            vmlDrawingIndex = headerFooterImageCounter;
            headerFooterImageCounter++;
        }
        if (hasTables) tableIndex = tableRelationCounter++;
        const worksheetRelFile = `xl/worksheets/_rels/sheet${i + 1}.xml.rels`;
        (0, $jIDNV.ZipContainer).addFile(worksheetRelFile, $5b7ccabde48fae90$var$ExcelXlsxFactory.createRelationships({
            tableIndex: tableIndex,
            drawingIndex: drawingIndex,
            vmlDrawingIndex: vmlDrawingIndex
        }));
    }
};
var $5b7ccabde48fae90$var$createExcelXmlDrawings = (sheetIndex, drawingIndex)=>{
    const drawingFolder = "xl/drawings";
    const drawingFileName = `${drawingFolder}/drawing${drawingIndex + 1}.xml`;
    const relFileName = `${drawingFolder}/_rels/drawing${drawingIndex + 1}.xml.rels`;
    (0, $jIDNV.ZipContainer).addFile(relFileName, $5b7ccabde48fae90$var$ExcelXlsxFactory.createDrawingRel(sheetIndex));
    (0, $jIDNV.ZipContainer).addFile(drawingFileName, $5b7ccabde48fae90$var$ExcelXlsxFactory.createDrawing(sheetIndex));
};
var $5b7ccabde48fae90$var$createExcelVmlDrawings = (sheetIndex, drawingIndex)=>{
    const drawingFolder = "xl/drawings";
    const drawingFileName = `${drawingFolder}/vmlDrawing${drawingIndex + 1}.vml`;
    const relFileName = `${drawingFolder}/_rels/vmlDrawing${drawingIndex + 1}.vml.rels`;
    (0, $jIDNV.ZipContainer).addFile(drawingFileName, $5b7ccabde48fae90$var$ExcelXlsxFactory.createVmlDrawing(sheetIndex));
    (0, $jIDNV.ZipContainer).addFile(relFileName, $5b7ccabde48fae90$var$ExcelXlsxFactory.createVmlDrawingRel(sheetIndex));
};
var $5b7ccabde48fae90$var$createExcelXmlTables = ()=>{
    const { worksheetDataTables: worksheetDataTables } = $5b7ccabde48fae90$var$ExcelXlsxFactory;
    const tablesDataByWorksheet = worksheetDataTables;
    const worksheetKeys = Array.from(tablesDataByWorksheet.keys());
    for(let i = 0; i < worksheetKeys.length; i++){
        const sheetIndex = worksheetKeys[i];
        const dataTable = tablesDataByWorksheet.get(sheetIndex);
        if (!dataTable) continue;
        (0, $jIDNV.ZipContainer).addFile(`xl/tables/${dataTable.name}.xml`, $5b7ccabde48fae90$var$ExcelXlsxFactory.createTable(dataTable, i));
    }
};
var $5b7ccabde48fae90$var$createExcelXmlCoreSheets = (fontSize, author, sheetLen)=>{
    (0, $jIDNV.ZipContainer).addFile("xl/workbook.xml", $5b7ccabde48fae90$var$ExcelXlsxFactory.createWorkbook());
    (0, $jIDNV.ZipContainer).addFile("xl/styles.xml", $5b7ccabde48fae90$var$ExcelXlsxFactory.createStylesheet(fontSize));
    (0, $jIDNV.ZipContainer).addFile("xl/sharedStrings.xml", $5b7ccabde48fae90$var$ExcelXlsxFactory.createSharedStrings());
    (0, $jIDNV.ZipContainer).addFile("xl/theme/theme1.xml", $5b7ccabde48fae90$var$ExcelXlsxFactory.createTheme());
    (0, $jIDNV.ZipContainer).addFile("xl/_rels/workbook.xml.rels", $5b7ccabde48fae90$var$ExcelXlsxFactory.createWorkbookRels(sheetLen));
    (0, $jIDNV.ZipContainer).addFile("docProps/core.xml", $5b7ccabde48fae90$var$ExcelXlsxFactory.createCore(author));
    (0, $jIDNV.ZipContainer).addFile("[Content_Types].xml", $5b7ccabde48fae90$var$ExcelXlsxFactory.createContentTypes(sheetLen));
    (0, $jIDNV.ZipContainer).addFile("_rels/.rels", $5b7ccabde48fae90$var$ExcelXlsxFactory.createRels());
};
var $5b7ccabde48fae90$var$createExcelFileForExcel = (data, options = {})=>{
    if (!data || data.length === 0) {
        console.warn("AG Grid: Invalid params supplied to createExcelFileForExcel() - `ExcelExportParams.data` is empty.");
        $5b7ccabde48fae90$var$ExcelXlsxFactory.resetFactory();
        return false;
    }
    const { fontSize: fontSize = 11, author: author = "AG Grid" } = options;
    $5b7ccabde48fae90$var$createExcelXMLCoreFolderStructure();
    $5b7ccabde48fae90$var$createExcelXmlTables();
    $5b7ccabde48fae90$var$createExcelXmlWorksheets(data);
    $5b7ccabde48fae90$var$createExcelXmlCoreSheets(fontSize, author, data.length);
    $5b7ccabde48fae90$var$ExcelXlsxFactory.resetFactory();
    return true;
};
var $5b7ccabde48fae90$var$getMultipleSheetsAsExcelCompressed = (params)=>{
    const { data: data, fontSize: fontSize, author: author } = params;
    const mimeType = params.mimeType || "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    if (!$5b7ccabde48fae90$var$createExcelFileForExcel(data, {
        author: author,
        fontSize: fontSize
    })) return Promise.resolve(void 0);
    return (0, $jIDNV.ZipContainer).getZipFile(mimeType);
};
var $5b7ccabde48fae90$export$cdca9ad0c864c7f0 = (params)=>{
    const { data: data, fontSize: fontSize, author: author } = params;
    const mimeType = params.mimeType || "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    if (!$5b7ccabde48fae90$var$createExcelFileForExcel(data, {
        author: author,
        fontSize: fontSize
    })) return;
    return (0, $jIDNV.ZipContainer).getUncompressedZipFile(mimeType);
};
var $5b7ccabde48fae90$export$e871bbb2307806ee = (params)=>{
    const { fileName: fileName = "export.xlsx" } = params;
    $5b7ccabde48fae90$var$getMultipleSheetsAsExcelCompressed(params).then((contents)=>{
        if (contents) {
            const downloadFileName = typeof fileName === "function" ? fileName() : fileName;
            (0, $jIDNV.Downloader).download(downloadFileName, contents);
        }
    });
};
var $5b7ccabde48fae90$var$ExcelCreator = class extends (0, $jIDNV.BaseCreator) {
    postConstruct() {
        this.setBeans({
            gridSerializer: this.gridSerializer,
            gos: this.gos
        });
    }
    getMergedParams(params) {
        const baseParams = this.gos.get("defaultExcelExportParams");
        return Object.assign({}, baseParams, params);
    }
    export(userParams) {
        if (this.isExportSuppressed()) {
            console.warn(`AG Grid: Export cancelled. Export is not allowed as per your configuration.`);
            return;
        }
        const mergedParams = this.getMergedParams(userParams);
        const data = this.getData(mergedParams);
        const exportParams = {
            data: [
                data
            ],
            fontSize: mergedParams.fontSize,
            author: mergedParams.author,
            mimeType: mergedParams.mimeType
        };
        this.packageCompressedFile(exportParams).then((packageFile)=>{
            if (packageFile) {
                const { fileName: fileName } = mergedParams;
                const providedFileName = typeof fileName === "function" ? fileName(this.gos.getGridCommonParams()) : fileName;
                (0, $jIDNV.Downloader).download(this.getFileName(providedFileName), packageFile);
            }
        });
    }
    exportDataAsExcel(params) {
        this.export(params);
    }
    getDataAsExcel(params) {
        const mergedParams = this.getMergedParams(params);
        const data = this.getData(mergedParams);
        const exportParams = {
            data: [
                data
            ],
            fontSize: mergedParams.fontSize,
            author: mergedParams.author,
            mimeType: mergedParams.mimeType
        };
        return this.packageFile(exportParams);
    }
    setFactoryMode(factoryMode) {
        $5b7ccabde48fae90$var$ExcelXlsxFactory.factoryMode = factoryMode;
    }
    getFactoryMode() {
        return $5b7ccabde48fae90$var$ExcelXlsxFactory.factoryMode;
    }
    getSheetDataForExcel(params) {
        const mergedParams = this.getMergedParams(params);
        return this.getData(mergedParams);
    }
    getMultipleSheetsAsExcel(params) {
        return $5b7ccabde48fae90$export$cdca9ad0c864c7f0(params);
    }
    exportMultipleSheetsAsExcel(params) {
        $5b7ccabde48fae90$export$e871bbb2307806ee(params);
    }
    getDefaultFileExtension() {
        return "xlsx";
    }
    createSerializingSession(params) {
        const { columnModel: columnModel, valueService: valueService, gos: gos } = this;
        let sheetName;
        if (params.sheetName != null) {
            const { sheetName: sheetNameParam } = params;
            const sheetNameValue = typeof sheetNameParam === "function" ? sheetNameParam(this.gos.getGridCommonParams()) : sheetNameParam;
            sheetName = String(sheetNameValue).substring(0, 31);
        } else sheetName = "ag-grid";
        const config = $5b7ccabde48fae90$var$__spreadProps6($5b7ccabde48fae90$var$__spreadValues7({}, params), {
            sheetName: sheetName,
            columnModel: columnModel,
            valueService: valueService,
            gos: gos,
            suppressRowOutline: params.suppressRowOutline || params.skipRowGroups,
            headerRowHeight: params.headerRowHeight || params.rowHeight,
            baseExcelStyles: this.gos.get("excelStyles") || [],
            styleLinker: this.styleLinker.bind(this)
        });
        return new $5b7ccabde48fae90$var$ExcelSerializingSession(config);
    }
    styleLinker(params) {
        const { rowType: rowType, rowIndex: rowIndex, value: value, column: column, columnGroup: columnGroup, node: node } = params;
        const isHeader = rowType === (0, $jIDNV.RowType).HEADER;
        const isGroupHeader = rowType === (0, $jIDNV.RowType).HEADER_GROUPING;
        const col = isHeader ? column : columnGroup;
        let headerClasses = [];
        if (isHeader || isGroupHeader) {
            headerClasses.push("header");
            if (isGroupHeader) headerClasses.push("headerGroup");
            if (col) headerClasses = headerClasses.concat((0, $jIDNV.CssClassApplier).getHeaderClassesFromColDef(col.getDefinition(), this.gos, column || null, columnGroup || null));
            return headerClasses;
        }
        const styles = this.gos.get("excelStyles");
        const applicableStyles = [
            "cell"
        ];
        if (!styles || !styles.length) return applicableStyles;
        const styleIds = styles.map((it)=>{
            return it.id;
        });
        this.stylingService.processAllCellClasses(column.getDefinition(), this.gos.addGridCommonParams({
            value: value,
            data: node.data,
            node: node,
            colDef: column.getDefinition(),
            column: column,
            rowIndex: rowIndex
        }), (className)=>{
            if (styleIds.indexOf(className) > -1) applicableStyles.push(className);
        });
        return applicableStyles.sort((left, right)=>{
            return styleIds.indexOf(left) < styleIds.indexOf(right) ? -1 : 1;
        });
    }
    isExportSuppressed() {
        return this.gos.get("suppressExcelExport");
    }
    packageCompressedFile(params) {
        return $5b7ccabde48fae90$var$getMultipleSheetsAsExcelCompressed(params);
    }
    packageFile(params) {
        return $5b7ccabde48fae90$export$cdca9ad0c864c7f0(params);
    }
};
$5b7ccabde48fae90$var$__decorateClass9([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$ExcelCreator.prototype, "columnModel", 2);
$5b7ccabde48fae90$var$__decorateClass9([
    (0, $jIDNV.Autowired)("valueService")
], $5b7ccabde48fae90$var$ExcelCreator.prototype, "valueService", 2);
$5b7ccabde48fae90$var$__decorateClass9([
    (0, $jIDNV.Autowired)("stylingService")
], $5b7ccabde48fae90$var$ExcelCreator.prototype, "stylingService", 2);
$5b7ccabde48fae90$var$__decorateClass9([
    (0, $jIDNV.Autowired)("gridSerializer")
], $5b7ccabde48fae90$var$ExcelCreator.prototype, "gridSerializer", 2);
$5b7ccabde48fae90$var$__decorateClass9([
    (0, $jIDNV.Autowired)("gridOptionsService")
], $5b7ccabde48fae90$var$ExcelCreator.prototype, "gos", 2);
$5b7ccabde48fae90$var$__decorateClass9([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$ExcelCreator.prototype, "postConstruct", 1);
$5b7ccabde48fae90$var$ExcelCreator = $5b7ccabde48fae90$var$__decorateClass9([
    (0, $jIDNV.Bean)("excelCreator")
], $5b7ccabde48fae90$var$ExcelCreator);
var $5b7ccabde48fae90$var$VERSION9 = "31.3.4";
var $5b7ccabde48fae90$export$98f0c53ca0379def = {
    version: $5b7ccabde48fae90$var$VERSION9,
    moduleName: (0, $jIDNV.ModuleNames).ExcelExportModule,
    beans: [
        // beans in this module
        $5b7ccabde48fae90$var$ExcelCreator,
        // these beans are part of CSV Export module
        (0, $jIDNV.GridSerializer),
        (0, $jIDNV.CsvCreator)
    ],
    dependantModules: [
        (0, $jIDNV.CsvExportModule),
        $5b7ccabde48fae90$export$3a6d13add8617801
    ]
};
var $5b7ccabde48fae90$var$__defProp10 = Object.defineProperty;
var $5b7ccabde48fae90$var$__getOwnPropDesc10 = Object.getOwnPropertyDescriptor;
var $5b7ccabde48fae90$var$__getOwnPropSymbols8 = Object.getOwnPropertySymbols;
var $5b7ccabde48fae90$var$__hasOwnProp9 = Object.prototype.hasOwnProperty;
var $5b7ccabde48fae90$var$__propIsEnum8 = Object.prototype.propertyIsEnumerable;
var $5b7ccabde48fae90$var$__defNormalProp8 = (obj, key, value)=>key in obj ? $5b7ccabde48fae90$var$__defProp10(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5b7ccabde48fae90$var$__spreadValues8 = (a, b)=>{
    for(var prop in b || (b = {}))if ($5b7ccabde48fae90$var$__hasOwnProp9.call(b, prop)) $5b7ccabde48fae90$var$__defNormalProp8(a, prop, b[prop]);
    if ($5b7ccabde48fae90$var$__getOwnPropSymbols8) {
        for (var prop of $5b7ccabde48fae90$var$__getOwnPropSymbols8(b))if ($5b7ccabde48fae90$var$__propIsEnum8.call(b, prop)) $5b7ccabde48fae90$var$__defNormalProp8(a, prop, b[prop]);
    }
    return a;
};
var $5b7ccabde48fae90$var$__decorateClass10 = (decorators, target, key, kind)=>{
    var result = kind > 1 ? void 0 : kind ? $5b7ccabde48fae90$var$__getOwnPropDesc10(target, key) : target;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
    if (kind && result) $5b7ccabde48fae90$var$__defProp10(target, key, result);
    return result;
};
var $5b7ccabde48fae90$var$FiltersToolPanelHeaderPanel = class extends (0, $jIDNV.Component) {
    preConstruct() {
        this.setTemplate(/* html */ `<div class="ag-filter-toolpanel-search" role="presentation">
                <div ref="eExpand" class="ag-filter-toolpanel-expand"></div>
                <ag-input-text-field ref="eFilterTextField" class="ag-filter-toolpanel-search-input"></ag-input-text-field>
            </div>`);
    }
    postConstruct() {
        const translate = this.localeService.getLocaleTextFunc();
        this.eFilterTextField.setAutoComplete(false).setInputAriaLabel(translate("ariaFilterColumnsInput", "Filter Columns Input")).onValueChange(this.onSearchTextChanged.bind(this));
        this.createExpandIcons();
        this.setExpandState(0);
        this.addManagedListener(this.eExpand, "click", this.onExpandClicked.bind(this));
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_NEW_COLUMNS_LOADED, this.showOrHideOptions.bind(this));
    }
    init(params) {
        this.params = params;
        if (this.columnModel.isReady()) this.showOrHideOptions();
    }
    createExpandIcons() {
        this.eExpand.appendChild(this.eExpandChecked = (0, $jIDNV._).createIconNoSpan("columnSelectOpen", this.gos));
        this.eExpand.appendChild(this.eExpandUnchecked = (0, $jIDNV._).createIconNoSpan("columnSelectClosed", this.gos));
        this.eExpand.appendChild(this.eExpandIndeterminate = (0, $jIDNV._).createIconNoSpan("columnSelectIndeterminate", this.gos));
    }
    // we only show expand / collapse if we are showing filters
    showOrHideOptions() {
        const showFilterSearch = !this.params.suppressFilterSearch;
        const showExpand = !this.params.suppressExpandAll;
        const translate = this.localeService.getLocaleTextFunc();
        this.eFilterTextField.setInputPlaceholder(translate("searchOoo", "Search..."));
        const isFilterGroupPresent = (col)=>col.getOriginalParent() && col.isFilterAllowed();
        const filterGroupsPresent = this.columnModel.getAllGridColumns().some(isFilterGroupPresent);
        (0, $jIDNV._).setDisplayed(this.eFilterTextField.getGui(), showFilterSearch);
        (0, $jIDNV._).setDisplayed(this.eExpand, showExpand && filterGroupsPresent);
    }
    onSearchTextChanged() {
        if (!this.onSearchTextChangedDebounced) this.onSearchTextChangedDebounced = (0, $jIDNV._).debounce(()=>{
            this.dispatchEvent({
                type: "searchChanged",
                searchText: this.eFilterTextField.getValue()
            });
        }, 300);
        this.onSearchTextChangedDebounced();
    }
    onExpandClicked() {
        const event = this.currentExpandState === 0 ? {
            type: "collapseAll"
        } : {
            type: "expandAll"
        };
        this.dispatchEvent(event);
    }
    setExpandState(state) {
        this.currentExpandState = state;
        (0, $jIDNV._).setDisplayed(this.eExpandChecked, this.currentExpandState === 0);
        (0, $jIDNV._).setDisplayed(this.eExpandUnchecked, this.currentExpandState === 1);
        (0, $jIDNV._).setDisplayed(this.eExpandIndeterminate, this.currentExpandState === 2);
    }
};
$5b7ccabde48fae90$var$__decorateClass10([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$FiltersToolPanelHeaderPanel.prototype, "columnModel", 2);
$5b7ccabde48fae90$var$__decorateClass10([
    (0, $jIDNV.RefSelector)("eExpand")
], $5b7ccabde48fae90$var$FiltersToolPanelHeaderPanel.prototype, "eExpand", 2);
$5b7ccabde48fae90$var$__decorateClass10([
    (0, $jIDNV.RefSelector)("eFilterTextField")
], $5b7ccabde48fae90$var$FiltersToolPanelHeaderPanel.prototype, "eFilterTextField", 2);
$5b7ccabde48fae90$var$__decorateClass10([
    (0, $jIDNV.PreConstruct)
], $5b7ccabde48fae90$var$FiltersToolPanelHeaderPanel.prototype, "preConstruct", 1);
$5b7ccabde48fae90$var$__decorateClass10([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$FiltersToolPanelHeaderPanel.prototype, "postConstruct", 1);
var $5b7ccabde48fae90$var$_ToolPanelFilterComp = class _ToolPanelFilterComp2 extends (0, $jIDNV.Component) {
    constructor(hideHeader, expandedCallback){
        super(_ToolPanelFilterComp2.TEMPLATE);
        this.expandedCallback = expandedCallback;
        this.expanded = false;
        this.hideHeader = hideHeader;
    }
    postConstruct() {
        this.eExpandChecked = (0, $jIDNV._).createIconNoSpan("columnSelectOpen", this.gos);
        this.eExpandUnchecked = (0, $jIDNV._).createIconNoSpan("columnSelectClosed", this.gos);
        this.eExpand.appendChild(this.eExpandChecked);
        this.eExpand.appendChild(this.eExpandUnchecked);
    }
    setColumn(column) {
        this.column = column;
        this.eFilterName.innerText = this.columnModel.getDisplayNameForColumn(this.column, "filterToolPanel", false) || "";
        this.addManagedListener(this.eFilterToolPanelHeader, "click", this.toggleExpanded.bind(this));
        this.addManagedListener(this.eFilterToolPanelHeader, "keydown", this.onKeyDown.bind(this));
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_FILTER_OPENED, this.onFilterOpened.bind(this));
        this.addInIcon("filter", this.eFilterIcon, this.column);
        (0, $jIDNV._).setDisplayed(this.eFilterIcon, this.isFilterActive(), {
            skipAriaHidden: true
        });
        (0, $jIDNV._).setDisplayed(this.eExpandChecked, false);
        if (this.hideHeader) {
            (0, $jIDNV._).setDisplayed(this.eFilterToolPanelHeader, false);
            this.eFilterToolPanelHeader.removeAttribute("tabindex");
        } else this.eFilterToolPanelHeader.setAttribute("tabindex", "0");
        this.addManagedListener(this.column, (0, $jIDNV.Column).EVENT_FILTER_CHANGED, this.onFilterChanged.bind(this));
    }
    onKeyDown(e) {
        const { key: key } = e;
        const { ENTER: ENTER, SPACE: SPACE, LEFT: LEFT, RIGHT: RIGHT } = (0, $jIDNV.KeyCode);
        if (key !== ENTER && key !== SPACE && key !== LEFT && key !== RIGHT) return;
        e.preventDefault();
        if (key === ENTER || key === SPACE) this.toggleExpanded();
        else if (key === (0, $jIDNV.KeyCode).LEFT) this.collapse();
        else this.expand();
    }
    getColumn() {
        return this.column;
    }
    getColumnFilterName() {
        return this.columnModel.getDisplayNameForColumn(this.column, "filterToolPanel", false);
    }
    addCssClassToTitleBar(cssClass) {
        this.eFilterToolPanelHeader.classList.add(cssClass);
    }
    addInIcon(iconName, eParent, column) {
        if (eParent == null) return;
        const eIcon = (0, $jIDNV._).createIconNoSpan(iconName, this.gos, column);
        eParent.appendChild(eIcon);
    }
    isFilterActive() {
        return this.filterManager.isFilterActive(this.column);
    }
    onFilterChanged() {
        (0, $jIDNV._).setDisplayed(this.eFilterIcon, this.isFilterActive(), {
            skipAriaHidden: true
        });
        this.dispatchEvent({
            type: (0, $jIDNV.Column).EVENT_FILTER_CHANGED
        });
    }
    toggleExpanded() {
        this.expanded ? this.collapse() : this.expand();
    }
    expand() {
        if (this.expanded) return;
        this.expanded = true;
        (0, $jIDNV._).setAriaExpanded(this.eFilterToolPanelHeader, true);
        (0, $jIDNV._).setDisplayed(this.eExpandChecked, true);
        (0, $jIDNV._).setDisplayed(this.eExpandUnchecked, false);
        this.addFilterElement();
        this.expandedCallback();
    }
    addFilterElement(suppressFocus) {
        var _a;
        const filterPanelWrapper = (0, $jIDNV._).loadTemplate(/* html */ `<div class="ag-filter-toolpanel-instance-filter"></div>`);
        const comp = this.createManagedBean(new (0, $jIDNV.FilterWrapperComp)(this.column, "TOOLBAR"));
        this.filterWrapperComp = comp;
        if (!comp.hasFilter()) return;
        (_a = comp.getFilter()) == null || _a.then((filter)=>{
            this.underlyingFilter = filter;
            if (!filter) return;
            filterPanelWrapper.appendChild(comp.getGui());
            this.agFilterToolPanelBody.appendChild(filterPanelWrapper);
            comp.afterGuiAttached({
                container: "toolPanel",
                suppressFocus: suppressFocus
            });
        });
    }
    collapse() {
        var _a;
        if (!this.expanded) return;
        this.expanded = false;
        (0, $jIDNV._).setAriaExpanded(this.eFilterToolPanelHeader, false);
        this.removeFilterElement();
        (0, $jIDNV._).setDisplayed(this.eExpandChecked, false);
        (0, $jIDNV._).setDisplayed(this.eExpandUnchecked, true);
        (_a = this.filterWrapperComp) == null || _a.afterGuiDetached();
        this.destroyBean(this.filterWrapperComp);
        this.expandedCallback();
    }
    removeFilterElement() {
        (0, $jIDNV._).clearElement(this.agFilterToolPanelBody);
    }
    isExpanded() {
        return this.expanded;
    }
    refreshFilter(isDisplayed) {
        var _a;
        if (!this.expanded) return;
        const filter = this.underlyingFilter;
        if (!filter) return;
        if (isDisplayed) {
            if (typeof filter.refreshVirtualList === "function") filter.refreshVirtualList();
        } else (_a = filter.afterGuiDetached) == null || _a.call(filter);
    }
    onFilterOpened(event) {
        if (event.source !== "COLUMN_MENU") return;
        if (event.column !== this.column) return;
        if (!this.expanded) return;
        this.collapse();
    }
};
$5b7ccabde48fae90$var$_ToolPanelFilterComp.TEMPLATE = /* html */ `
        <div class="ag-filter-toolpanel-instance">
            <div class="ag-filter-toolpanel-header ag-filter-toolpanel-instance-header" ref="eFilterToolPanelHeader" role="button" aria-expanded="false">
                <div ref="eExpand" class="ag-filter-toolpanel-expand"></div>
                <span ref="eFilterName" class="ag-header-cell-text"></span>
                <span ref="eFilterIcon" class="ag-header-icon ag-filter-icon ag-filter-toolpanel-instance-header-icon" aria-hidden="true"></span>
            </div>
            <div class="ag-filter-toolpanel-instance-body ag-filter" ref="agFilterToolPanelBody"></div>
        </div>`;
$5b7ccabde48fae90$var$__decorateClass10([
    (0, $jIDNV.RefSelector)("eFilterToolPanelHeader")
], $5b7ccabde48fae90$var$_ToolPanelFilterComp.prototype, "eFilterToolPanelHeader", 2);
$5b7ccabde48fae90$var$__decorateClass10([
    (0, $jIDNV.RefSelector)("eFilterName")
], $5b7ccabde48fae90$var$_ToolPanelFilterComp.prototype, "eFilterName", 2);
$5b7ccabde48fae90$var$__decorateClass10([
    (0, $jIDNV.RefSelector)("agFilterToolPanelBody")
], $5b7ccabde48fae90$var$_ToolPanelFilterComp.prototype, "agFilterToolPanelBody", 2);
$5b7ccabde48fae90$var$__decorateClass10([
    (0, $jIDNV.RefSelector)("eFilterIcon")
], $5b7ccabde48fae90$var$_ToolPanelFilterComp.prototype, "eFilterIcon", 2);
$5b7ccabde48fae90$var$__decorateClass10([
    (0, $jIDNV.RefSelector)("eExpand")
], $5b7ccabde48fae90$var$_ToolPanelFilterComp.prototype, "eExpand", 2);
$5b7ccabde48fae90$var$__decorateClass10([
    (0, $jIDNV.Autowired)("filterManager")
], $5b7ccabde48fae90$var$_ToolPanelFilterComp.prototype, "filterManager", 2);
$5b7ccabde48fae90$var$__decorateClass10([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$_ToolPanelFilterComp.prototype, "columnModel", 2);
$5b7ccabde48fae90$var$__decorateClass10([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_ToolPanelFilterComp.prototype, "postConstruct", 1);
var $5b7ccabde48fae90$var$ToolPanelFilterComp = $5b7ccabde48fae90$var$_ToolPanelFilterComp;
var $5b7ccabde48fae90$var$_ToolPanelFilterGroupComp = class _ToolPanelFilterGroupComp2 extends (0, $jIDNV.Component) {
    constructor(columnGroup, childFilterComps, expandedCallback, depth, showingColumn){
        super();
        this.columnGroup = columnGroup;
        this.childFilterComps = childFilterComps;
        this.depth = depth;
        this.expandedCallback = expandedCallback;
        this.showingColumn = showingColumn;
    }
    preConstruct() {
        const groupParams = {
            cssIdentifier: "filter-toolpanel",
            direction: "vertical"
        };
        this.setTemplate(_ToolPanelFilterGroupComp2.TEMPLATE, {
            filterGroupComp: groupParams
        });
    }
    init() {
        this.setGroupTitle();
        this.filterGroupComp.setAlignItems("stretch");
        this.filterGroupComp.addCssClass(`ag-filter-toolpanel-group-level-${this.depth}`);
        this.filterGroupComp.addCssClassToTitleBar(`ag-filter-toolpanel-group-level-${this.depth}-header`);
        this.childFilterComps.forEach((filterComp)=>{
            this.filterGroupComp.addItem(filterComp);
            filterComp.addCssClassToTitleBar(`ag-filter-toolpanel-group-level-${this.depth + 1}-header`);
        });
        this.refreshFilterClass();
        this.addExpandCollapseListeners();
        this.addFilterChangedListeners();
        this.setupTooltip();
        this.addInIcon("filter");
    }
    setupTooltip() {
        if (!this.showingColumn) return;
        const isTooltipWhenTruncated = this.gos.get("tooltipShowMode") === "whenTruncated";
        let shouldDisplayTooltip;
        if (isTooltipWhenTruncated) shouldDisplayTooltip = ()=>{
            const eGui = this.filterGroupComp.getGui();
            const eTitle = eGui.querySelector(".ag-group-title");
            if (!eTitle) return true;
            return eTitle.scrollWidth > eTitle.clientWidth;
        };
        const refresh = ()=>{
            const newTooltipText = this.columnGroup.getColDef().headerTooltip;
            this.setTooltip({
                newTooltipText: newTooltipText,
                location: "filterToolPanelColumnGroup",
                shouldDisplayTooltip: shouldDisplayTooltip
            });
        };
        refresh();
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_NEW_COLUMNS_LOADED, refresh);
    }
    getTooltipParams() {
        const res = super.getTooltipParams();
        res.location = "filterToolPanelColumnGroup";
        return res;
    }
    addCssClassToTitleBar(cssClass) {
        this.filterGroupComp.addCssClassToTitleBar(cssClass);
    }
    refreshFilters(isDisplayed) {
        this.childFilterComps.forEach((filterComp)=>{
            if (filterComp instanceof _ToolPanelFilterGroupComp2) filterComp.refreshFilters(isDisplayed);
            else filterComp.refreshFilter(isDisplayed);
        });
    }
    isColumnGroup() {
        return this.columnGroup instanceof (0, $jIDNV.ProvidedColumnGroup);
    }
    isExpanded() {
        return this.filterGroupComp.isExpanded();
    }
    getChildren() {
        return this.childFilterComps;
    }
    getFilterGroupName() {
        return this.filterGroupName ? this.filterGroupName : "";
    }
    getFilterGroupId() {
        return this.columnGroup.getId();
    }
    hideGroupItem(hide, index) {
        this.filterGroupComp.hideItem(hide, index);
    }
    hideGroup(hide) {
        this.setDisplayed(!hide);
    }
    addInIcon(iconName) {
        const eIcon = (0, $jIDNV._).createIconNoSpan(iconName, this.gos);
        if (eIcon) eIcon.classList.add("ag-filter-toolpanel-group-instance-header-icon");
        this.filterGroupComp.addTitleBarWidget(eIcon);
    }
    forEachToolPanelFilterChild(action) {
        this.childFilterComps.forEach((filterComp)=>{
            if (filterComp instanceof $5b7ccabde48fae90$var$ToolPanelFilterComp) action(filterComp);
        });
    }
    addExpandCollapseListeners() {
        const expandListener = this.isColumnGroup() ? ()=>this.expandedCallback() : ()=>this.forEachToolPanelFilterChild((filterComp)=>filterComp.expand());
        const collapseListener = this.isColumnGroup() ? ()=>this.expandedCallback() : ()=>this.forEachToolPanelFilterChild((filterComp)=>filterComp.collapse());
        this.addManagedListener(this.filterGroupComp, (0, $jIDNV.AgGroupComponent).EVENT_EXPANDED, expandListener);
        this.addManagedListener(this.filterGroupComp, (0, $jIDNV.AgGroupComponent).EVENT_COLLAPSED, collapseListener);
    }
    getColumns() {
        if (this.columnGroup instanceof (0, $jIDNV.ProvidedColumnGroup)) return this.columnGroup.getLeafColumns();
        return [
            this.columnGroup
        ];
    }
    addFilterChangedListeners() {
        this.getColumns().forEach((column)=>{
            this.addManagedListener(column, (0, $jIDNV.Column).EVENT_FILTER_CHANGED, ()=>this.refreshFilterClass());
        });
        if (!(this.columnGroup instanceof (0, $jIDNV.ProvidedColumnGroup))) this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_FILTER_OPENED, this.onFilterOpened.bind(this));
    }
    refreshFilterClass() {
        const columns = this.getColumns();
        const anyChildFiltersActive = ()=>columns.some((col)=>col.isFilterActive());
        this.filterGroupComp.addOrRemoveCssClass("ag-has-filter", anyChildFiltersActive());
    }
    onFilterOpened(event) {
        if (event.source !== "COLUMN_MENU") return;
        if (event.column !== this.columnGroup) return;
        if (!this.isExpanded()) return;
        this.collapse();
    }
    expand() {
        this.filterGroupComp.toggleGroupExpand(true);
    }
    collapse() {
        this.filterGroupComp.toggleGroupExpand(false);
    }
    setGroupTitle() {
        this.filterGroupName = this.columnGroup instanceof (0, $jIDNV.ProvidedColumnGroup) ? this.getColumnGroupName(this.columnGroup) : this.getColumnName(this.columnGroup);
        this.filterGroupComp.setTitle(this.filterGroupName || "");
    }
    getColumnGroupName(columnGroup) {
        return this.columnModel.getDisplayNameForProvidedColumnGroup(null, columnGroup, "filterToolPanel");
    }
    getColumnName(column) {
        return this.columnModel.getDisplayNameForColumn(column, "filterToolPanel", false);
    }
    destroyFilters() {
        this.childFilterComps = this.destroyBeans(this.childFilterComps);
        (0, $jIDNV._).clearElement(this.getGui());
    }
    destroy() {
        this.destroyFilters();
        super.destroy();
    }
};
$5b7ccabde48fae90$var$_ToolPanelFilterGroupComp.TEMPLATE = /* html */ `<div class="ag-filter-toolpanel-group-wrapper">
            <ag-group-component ref="filterGroupComp"></ag-group-component>
        </div>`;
$5b7ccabde48fae90$var$__decorateClass10([
    (0, $jIDNV.RefSelector)("filterGroupComp")
], $5b7ccabde48fae90$var$_ToolPanelFilterGroupComp.prototype, "filterGroupComp", 2);
$5b7ccabde48fae90$var$__decorateClass10([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$_ToolPanelFilterGroupComp.prototype, "columnModel", 2);
$5b7ccabde48fae90$var$__decorateClass10([
    (0, $jIDNV.PreConstruct)
], $5b7ccabde48fae90$var$_ToolPanelFilterGroupComp.prototype, "preConstruct", 1);
$5b7ccabde48fae90$var$__decorateClass10([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_ToolPanelFilterGroupComp.prototype, "init", 1);
var $5b7ccabde48fae90$var$ToolPanelFilterGroupComp = $5b7ccabde48fae90$var$_ToolPanelFilterGroupComp;
var $5b7ccabde48fae90$var$_FiltersToolPanelListPanel = class _FiltersToolPanelListPanel2 extends (0, $jIDNV.Component) {
    constructor(){
        super(_FiltersToolPanelListPanel2.TEMPLATE);
        this.initialised = false;
        this.hasLoadedInitialState = false;
        this.isInitialState = false;
        this.filterGroupComps = [];
        this.suppressOnColumnsChanged = false;
        this.onColumnsChangedPending = false;
    }
    init(params) {
        this.initialised = true;
        const defaultParams = this.gos.addGridCommonParams({
            suppressExpandAll: false,
            suppressFilterSearch: false,
            suppressSyncLayoutWithGrid: false
        });
        (0, $jIDNV._).mergeDeep(defaultParams, params);
        this.params = defaultParams;
        if (!this.params.suppressSyncLayoutWithGrid) this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_COLUMN_MOVED, ()=>this.onColumnsChanged());
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_NEW_COLUMNS_LOADED, ()=>this.onColumnsChanged());
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_TOOL_PANEL_VISIBLE_CHANGED, (event)=>{
            if (event.key === "filters") this.refreshFilters(event.visible);
        });
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_DRAG_STARTED, ()=>{
            this.suppressOnColumnsChanged = true;
        });
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_DRAG_STOPPED, ()=>{
            this.suppressOnColumnsChanged = false;
            if (this.onColumnsChangedPending) {
                this.onColumnsChangedPending = false;
                this.onColumnsChanged();
            }
        });
        if (this.columnModel.isReady()) this.onColumnsChanged();
    }
    onColumnsChanged() {
        if (this.suppressOnColumnsChanged) {
            this.onColumnsChangedPending = true;
            return;
        }
        const pivotModeActive = this.columnModel.isPivotMode();
        const shouldSyncColumnLayoutWithGrid = !this.params.suppressSyncLayoutWithGrid && !pivotModeActive;
        shouldSyncColumnLayoutWithGrid ? this.syncFilterLayout() : this.buildTreeFromProvidedColumnDefs();
        this.refreshAriaLabel();
    }
    syncFilterLayout() {
        this.toolPanelColDefService.syncLayoutWithGrid(this.setFiltersLayout.bind(this));
        this.refreshAriaLabel();
    }
    buildTreeFromProvidedColumnDefs() {
        const columnTree = this.columnModel.getPrimaryColumnTree();
        this.recreateFilters(columnTree);
    }
    setFiltersLayout(colDefs) {
        const columnTree = this.toolPanelColDefService.createColumnTree(colDefs);
        this.recreateFilters(columnTree);
    }
    recreateFilters(columnTree) {
        const activeElement = this.gos.getActiveDomElement();
        if (!this.hasLoadedInitialState) {
            this.hasLoadedInitialState = true;
            this.isInitialState = !!this.params.initialState;
        }
        const expansionState = this.getExpansionState();
        this.destroyFilters();
        this.filterGroupComps = this.recursivelyAddComps(columnTree, 0, expansionState);
        const len = this.filterGroupComps.length;
        if (len) {
            this.filterGroupComps.forEach((comp)=>this.appendChild(comp));
            this.setFirstAndLastVisible(0, len - 1);
        }
        if ((0, $jIDNV._).exists(this.searchFilterText)) this.searchFilters(this.searchFilterText);
        this.fireExpandedEvent();
        if (this.getGui().contains(activeElement)) activeElement.focus();
        this.isInitialState = false;
        this.refreshAriaLabel();
    }
    recursivelyAddComps(tree, depth, expansionState) {
        return (0, $jIDNV._).flatten(tree.map((child)=>{
            if (child instanceof (0, $jIDNV.ProvidedColumnGroup)) return (0, $jIDNV._).flatten(this.recursivelyAddFilterGroupComps(child, depth, expansionState));
            const column = child;
            if (!this.shouldDisplayFilter(column)) return [];
            const hideFilterCompHeader = depth === 0;
            const filterComp = new $5b7ccabde48fae90$var$ToolPanelFilterComp(hideFilterCompHeader, ()=>this.onFilterExpanded());
            this.createBean(filterComp);
            filterComp.setColumn(column);
            if (expansionState.get(column.getId())) filterComp.expand();
            if (depth > 0) return filterComp;
            const filterGroupComp = this.createBean(new $5b7ccabde48fae90$var$ToolPanelFilterGroupComp(column, [
                filterComp
            ], this.onGroupExpanded.bind(this), depth, true));
            filterGroupComp.addCssClassToTitleBar("ag-filter-toolpanel-header");
            if (!expansionState.get(filterGroupComp.getFilterGroupId())) filterGroupComp.collapse();
            return filterGroupComp;
        }));
    }
    refreshAriaLabel() {
        const translate = this.localeService.getLocaleTextFunc();
        const filterListName = translate("ariaFilterPanelList", "Filter List");
        const localeFilters = translate("filters", "Filters");
        const eGui = this.getGui();
        const groupSelector = ".ag-filter-toolpanel-group-wrapper";
        const itemSelector = ".ag-filter-toolpanel-group-item";
        const hiddenSelector = ".ag-hidden";
        const visibleItems = eGui.querySelectorAll(`${itemSelector}:not(${groupSelector}, ${hiddenSelector})`);
        const totalVisibleItems = visibleItems.length;
        (0, $jIDNV._).setAriaLabel(this.getAriaElement(), `${filterListName} ${totalVisibleItems} ${localeFilters}`);
    }
    recursivelyAddFilterGroupComps(columnGroup, depth, expansionState) {
        if (!this.filtersExistInChildren(columnGroup.getChildren())) return;
        const colGroupDef = columnGroup.getColGroupDef();
        if (colGroupDef && colGroupDef.suppressFiltersToolPanel) return [];
        const newDepth = columnGroup.isPadding() ? depth : depth + 1;
        const childFilterComps = (0, $jIDNV._).flatten(this.recursivelyAddComps(columnGroup.getChildren(), newDepth, expansionState));
        if (columnGroup.isPadding()) return childFilterComps;
        const filterGroupComp = new $5b7ccabde48fae90$var$ToolPanelFilterGroupComp(columnGroup, childFilterComps, this.onGroupExpanded.bind(this), depth, false);
        this.createBean(filterGroupComp);
        filterGroupComp.addCssClassToTitleBar("ag-filter-toolpanel-header");
        const expansionStateValue = expansionState.get(filterGroupComp.getFilterGroupId());
        if (this.isInitialState && !expansionStateValue || expansionStateValue === false) filterGroupComp.collapse();
        return [
            filterGroupComp
        ];
    }
    filtersExistInChildren(tree) {
        return tree.some((child)=>{
            if (child instanceof (0, $jIDNV.ProvidedColumnGroup)) return this.filtersExistInChildren(child.getChildren());
            return this.shouldDisplayFilter(child);
        });
    }
    shouldDisplayFilter(column) {
        const suppressFiltersToolPanel = column.getColDef() && column.getColDef().suppressFiltersToolPanel;
        return column.isFilterAllowed() && !suppressFiltersToolPanel;
    }
    getExpansionState() {
        const expansionState = /* @__PURE__ */ new Map();
        if (this.isInitialState) {
            const { expandedColIds: expandedColIds, expandedGroupIds: expandedGroupIds } = this.params.initialState;
            expandedColIds.forEach((id)=>expansionState.set(id, true));
            expandedGroupIds.forEach((id)=>expansionState.set(id, true));
            return expansionState;
        }
        const recursiveGetExpansionState = (filterGroupComp)=>{
            expansionState.set(filterGroupComp.getFilterGroupId(), filterGroupComp.isExpanded());
            filterGroupComp.getChildren().forEach((child)=>{
                if (child instanceof $5b7ccabde48fae90$var$ToolPanelFilterGroupComp) recursiveGetExpansionState(child);
                else expansionState.set(child.getColumn().getId(), child.isExpanded());
            });
        };
        this.filterGroupComps.forEach(recursiveGetExpansionState);
        return expansionState;
    }
    // we don't support refreshing, but must implement because it's on the tool panel interface
    refresh() {}
    // lazy initialise the panel
    setVisible(visible) {
        super.setDisplayed(visible);
        if (visible && !this.initialised) this.init(this.params);
    }
    expandFilterGroups(expand, groupIds) {
        const updatedGroupIds = [];
        const updateGroupExpandState = (filterGroup)=>{
            const groupId = filterGroup.getFilterGroupId();
            const shouldExpandOrCollapse = !groupIds || (0, $jIDNV._).includes(groupIds, groupId);
            if (shouldExpandOrCollapse) {
                if (expand && filterGroup.isColumnGroup()) filterGroup.expand();
                else filterGroup.collapse();
                updatedGroupIds.push(groupId);
            }
            filterGroup.getChildren().forEach((child)=>{
                if (child instanceof $5b7ccabde48fae90$var$ToolPanelFilterGroupComp) updateGroupExpandState(child);
            });
        };
        this.filterGroupComps.forEach(updateGroupExpandState);
        this.onGroupExpanded();
        if (groupIds) {
            const unrecognisedGroupIds = groupIds.filter((groupId)=>updatedGroupIds.indexOf(groupId) < 0);
            if (unrecognisedGroupIds.length > 0) console.warn("AG Grid: unable to find groups for these supplied groupIds:", unrecognisedGroupIds);
        }
    }
    expandFilters(expand, colIds) {
        const updatedColIds = [];
        const updateGroupExpandState = (filterComp)=>{
            if (filterComp instanceof $5b7ccabde48fae90$var$ToolPanelFilterGroupComp) {
                let anyChildrenChanged = false;
                filterComp.getChildren().forEach((child)=>{
                    const childUpdated = updateGroupExpandState(child);
                    if (childUpdated) {
                        if (expand) {
                            filterComp.expand();
                            anyChildrenChanged = true;
                        } else if (!filterComp.isColumnGroup()) filterComp.collapse();
                    }
                });
                return anyChildrenChanged;
            }
            const colId = filterComp.getColumn().getColId();
            const updateFilterExpandState = !colIds || (0, $jIDNV._).includes(colIds, colId);
            if (updateFilterExpandState) {
                expand ? filterComp.expand() : filterComp.collapse();
                updatedColIds.push(colId);
            }
            return updateFilterExpandState;
        };
        this.filterGroupComps.forEach(updateGroupExpandState);
        this.onGroupExpanded();
        if (colIds) {
            const unrecognisedColIds = colIds.filter((colId)=>updatedColIds.indexOf(colId) < 0);
            if (unrecognisedColIds.length > 0) console.warn("AG Grid: unable to find columns for these supplied colIds:", unrecognisedColIds);
        }
    }
    onGroupExpanded() {
        this.fireExpandedEvent();
    }
    onFilterExpanded() {
        this.dispatchEvent({
            type: "filterExpanded"
        });
    }
    fireExpandedEvent() {
        let expandedCount = 0;
        let notExpandedCount = 0;
        const updateExpandCounts = (filterGroup)=>{
            if (!filterGroup.isColumnGroup()) return;
            filterGroup.isExpanded() ? expandedCount++ : notExpandedCount++;
            filterGroup.getChildren().forEach((child)=>{
                if (child instanceof $5b7ccabde48fae90$var$ToolPanelFilterGroupComp) updateExpandCounts(child);
            });
        };
        this.filterGroupComps.forEach(updateExpandCounts);
        let state;
        if (expandedCount > 0 && notExpandedCount > 0) state = 2;
        else if (notExpandedCount > 0) state = 1;
        else state = 0;
        this.dispatchEvent({
            type: "groupExpanded",
            state: state
        });
    }
    performFilterSearch(searchText) {
        this.searchFilterText = (0, $jIDNV._).exists(searchText) ? searchText.toLowerCase() : null;
        this.searchFilters(this.searchFilterText);
    }
    searchFilters(searchFilter) {
        const passesFilter = (groupName)=>{
            return !(0, $jIDNV._).exists(searchFilter) || groupName.toLowerCase().indexOf(searchFilter) !== -1;
        };
        const recursivelySearch = (filterItem, parentPasses)=>{
            if (!(filterItem instanceof $5b7ccabde48fae90$var$ToolPanelFilterGroupComp)) return passesFilter(filterItem.getColumnFilterName() || "");
            const children = filterItem.getChildren();
            const groupNamePasses = passesFilter(filterItem.getFilterGroupName());
            const alreadyPassed = parentPasses || groupNamePasses;
            if (alreadyPassed) {
                filterItem.hideGroup(false);
                for(let i = 0; i < children.length; i++){
                    recursivelySearch(children[i], alreadyPassed);
                    filterItem.hideGroupItem(false, i);
                }
                return true;
            }
            let anyChildPasses = false;
            children.forEach((child, index)=>{
                const childPasses = recursivelySearch(child, parentPasses);
                filterItem.hideGroupItem(!childPasses, index);
                if (childPasses) anyChildPasses = true;
            });
            filterItem.hideGroup(!anyChildPasses);
            return anyChildPasses;
        };
        let firstVisible;
        let lastVisible;
        this.filterGroupComps.forEach((filterGroup, idx)=>{
            recursivelySearch(filterGroup, false);
            if (firstVisible === void 0) {
                if (!filterGroup.containsCssClass("ag-hidden")) {
                    firstVisible = idx;
                    lastVisible = idx;
                }
            } else if (!filterGroup.containsCssClass("ag-hidden") && lastVisible !== idx) lastVisible = idx;
        });
        this.setFirstAndLastVisible(firstVisible, lastVisible);
        this.refreshAriaLabel();
    }
    setFirstAndLastVisible(firstIdx, lastIdx) {
        this.filterGroupComps.forEach((filterGroup, idx)=>{
            filterGroup.removeCssClass("ag-first-group-visible");
            filterGroup.removeCssClass("ag-last-group-visible");
            if (idx === firstIdx) filterGroup.addCssClass("ag-first-group-visible");
            if (idx === lastIdx) filterGroup.addCssClass("ag-last-group-visible");
        });
    }
    refreshFilters(isDisplayed) {
        this.filterGroupComps.forEach((filterGroupComp)=>filterGroupComp.refreshFilters(isDisplayed));
    }
    getExpandedFiltersAndGroups() {
        const expandedGroupIds = [];
        const expandedColIds = /* @__PURE__ */ new Set();
        const getExpandedFiltersAndGroups = (filterComp)=>{
            if (filterComp instanceof $5b7ccabde48fae90$var$ToolPanelFilterGroupComp) {
                filterComp.getChildren().forEach((child)=>getExpandedFiltersAndGroups(child));
                const groupId = filterComp.getFilterGroupId();
                if (filterComp.isExpanded() && !expandedColIds.has(groupId)) expandedGroupIds.push(groupId);
            } else if (filterComp.isExpanded()) expandedColIds.add(filterComp.getColumn().getColId());
        };
        this.filterGroupComps.forEach(getExpandedFiltersAndGroups);
        return {
            expandedGroupIds: expandedGroupIds,
            expandedColIds: Array.from(expandedColIds)
        };
    }
    destroyFilters() {
        this.filterGroupComps = this.destroyBeans(this.filterGroupComps);
        (0, $jIDNV._).clearElement(this.getGui());
    }
    destroy() {
        this.destroyFilters();
        super.destroy();
    }
};
$5b7ccabde48fae90$var$_FiltersToolPanelListPanel.TEMPLATE = /* html */ `<div class="ag-filter-list-panel"></div>`;
$5b7ccabde48fae90$var$__decorateClass10([
    (0, $jIDNV.Autowired)("toolPanelColDefService")
], $5b7ccabde48fae90$var$_FiltersToolPanelListPanel.prototype, "toolPanelColDefService", 2);
$5b7ccabde48fae90$var$__decorateClass10([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$_FiltersToolPanelListPanel.prototype, "columnModel", 2);
var $5b7ccabde48fae90$var$FiltersToolPanelListPanel = $5b7ccabde48fae90$var$_FiltersToolPanelListPanel;
var $5b7ccabde48fae90$var$_FiltersToolPanel = class _FiltersToolPanel2 extends (0, $jIDNV.Component) {
    constructor(){
        super(_FiltersToolPanel2.TEMPLATE);
        this.initialised = false;
        this.listenerDestroyFuncs = [];
    }
    init(params) {
        if (this.initialised) {
            this.listenerDestroyFuncs.forEach((func)=>func());
            this.listenerDestroyFuncs = [];
        }
        this.initialised = true;
        const defaultParams = this.gos.addGridCommonParams({
            suppressExpandAll: false,
            suppressFilterSearch: false,
            suppressSyncLayoutWithGrid: false
        });
        this.params = $5b7ccabde48fae90$var$__spreadValues8($5b7ccabde48fae90$var$__spreadValues8({}, defaultParams), params);
        this.filtersToolPanelHeaderPanel.init(this.params);
        this.filtersToolPanelListPanel.init(this.params);
        const hideExpand = this.params.suppressExpandAll;
        const hideSearch = this.params.suppressFilterSearch;
        if (hideExpand && hideSearch) this.filtersToolPanelHeaderPanel.setDisplayed(false);
        this.listenerDestroyFuncs.push(this.addManagedListener(this.filtersToolPanelHeaderPanel, "expandAll", this.onExpandAll.bind(this)), this.addManagedListener(this.filtersToolPanelHeaderPanel, "collapseAll", this.onCollapseAll.bind(this)), this.addManagedListener(this.filtersToolPanelHeaderPanel, "searchChanged", this.onSearchChanged.bind(this)), this.addManagedListener(this.filtersToolPanelListPanel, "filterExpanded", this.onFilterExpanded.bind(this)), this.addManagedListener(this.filtersToolPanelListPanel, "groupExpanded", this.onGroupExpanded.bind(this)));
    }
    // lazy initialise the panel
    setVisible(visible) {
        super.setDisplayed(visible);
        if (visible && !this.initialised) this.init(this.params);
    }
    onExpandAll() {
        this.filtersToolPanelListPanel.expandFilterGroups(true);
    }
    onCollapseAll() {
        this.filtersToolPanelListPanel.expandFilterGroups(false);
    }
    onSearchChanged(event) {
        this.filtersToolPanelListPanel.performFilterSearch(event.searchText);
    }
    setFilterLayout(colDefs) {
        this.filtersToolPanelListPanel.setFiltersLayout(colDefs);
    }
    onFilterExpanded() {
        this.params.onStateUpdated();
    }
    onGroupExpanded(event) {
        this.filtersToolPanelHeaderPanel.setExpandState(event.state);
        this.params.onStateUpdated();
    }
    expandFilterGroups(groupIds) {
        this.filtersToolPanelListPanel.expandFilterGroups(true, groupIds);
    }
    collapseFilterGroups(groupIds) {
        this.filtersToolPanelListPanel.expandFilterGroups(false, groupIds);
    }
    expandFilters(colIds) {
        this.filtersToolPanelListPanel.expandFilters(true, colIds);
    }
    collapseFilters(colIds) {
        this.filtersToolPanelListPanel.expandFilters(false, colIds);
    }
    syncLayoutWithGrid() {
        this.filtersToolPanelListPanel.syncFilterLayout();
    }
    refresh(params) {
        this.init(params);
        return true;
    }
    getState() {
        return this.filtersToolPanelListPanel.getExpandedFiltersAndGroups();
    }
    // this is a user component, and IComponent has "public destroy()" as part of the interface.
    // so we need to override destroy() just to make the method public.
    destroy() {
        super.destroy();
    }
};
$5b7ccabde48fae90$var$_FiltersToolPanel.TEMPLATE = /* html */ `<div class="ag-filter-toolpanel">
            <ag-filters-tool-panel-header ref="filtersToolPanelHeaderPanel"></ag-filters-tool-panel-header>
            <ag-filters-tool-panel-list ref="filtersToolPanelListPanel"></ag-filters-tool-panel-list>
         </div>`;
$5b7ccabde48fae90$var$__decorateClass10([
    (0, $jIDNV.RefSelector)("filtersToolPanelHeaderPanel")
], $5b7ccabde48fae90$var$_FiltersToolPanel.prototype, "filtersToolPanelHeaderPanel", 2);
$5b7ccabde48fae90$var$__decorateClass10([
    (0, $jIDNV.RefSelector)("filtersToolPanelListPanel")
], $5b7ccabde48fae90$var$_FiltersToolPanel.prototype, "filtersToolPanelListPanel", 2);
var $5b7ccabde48fae90$var$FiltersToolPanel = $5b7ccabde48fae90$var$_FiltersToolPanel;
var $5b7ccabde48fae90$var$VERSION10 = "31.3.4";
var $5b7ccabde48fae90$export$783953a68616c0a2 = {
    version: $5b7ccabde48fae90$var$VERSION10,
    moduleName: (0, $jIDNV.ModuleNames).FiltersToolPanelModule,
    beans: [],
    agStackComponents: [
        {
            componentName: "AgFiltersToolPanelHeader",
            componentClass: $5b7ccabde48fae90$var$FiltersToolPanelHeaderPanel
        },
        {
            componentName: "AgFiltersToolPanelList",
            componentClass: $5b7ccabde48fae90$var$FiltersToolPanelListPanel
        }
    ],
    userComponents: [
        {
            componentName: "agFiltersToolPanel",
            componentClass: $5b7ccabde48fae90$var$FiltersToolPanel
        }
    ],
    dependantModules: [
        $5b7ccabde48fae90$export$707a9bd30915b7fe,
        $5b7ccabde48fae90$export$3a6d13add8617801
    ]
};
var $5b7ccabde48fae90$var$__defProp11 = Object.defineProperty;
var $5b7ccabde48fae90$var$__getOwnPropDesc11 = Object.getOwnPropertyDescriptor;
var $5b7ccabde48fae90$var$__getOwnPropSymbols9 = Object.getOwnPropertySymbols;
var $5b7ccabde48fae90$var$__hasOwnProp10 = Object.prototype.hasOwnProperty;
var $5b7ccabde48fae90$var$__propIsEnum9 = Object.prototype.propertyIsEnumerable;
var $5b7ccabde48fae90$var$__defNormalProp9 = (obj, key, value)=>key in obj ? $5b7ccabde48fae90$var$__defProp11(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5b7ccabde48fae90$var$__spreadValues9 = (a, b)=>{
    for(var prop in b || (b = {}))if ($5b7ccabde48fae90$var$__hasOwnProp10.call(b, prop)) $5b7ccabde48fae90$var$__defNormalProp9(a, prop, b[prop]);
    if ($5b7ccabde48fae90$var$__getOwnPropSymbols9) {
        for (var prop of $5b7ccabde48fae90$var$__getOwnPropSymbols9(b))if ($5b7ccabde48fae90$var$__propIsEnum9.call(b, prop)) $5b7ccabde48fae90$var$__defNormalProp9(a, prop, b[prop]);
    }
    return a;
};
var $5b7ccabde48fae90$var$__decorateClass11 = (decorators, target, key, kind)=>{
    var result = kind > 1 ? void 0 : kind ? $5b7ccabde48fae90$var$__getOwnPropDesc11(target, key) : target;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
    if (kind && result) $5b7ccabde48fae90$var$__defProp11(target, key, result);
    return result;
};
var $5b7ccabde48fae90$var$DetailCellRendererCtrl = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.loadRowDataVersion = 0;
    }
    init(comp, params) {
        this.params = params;
        this.comp = comp;
        const doNothingBecauseInsidePinnedSection = params.pinned != null;
        if (doNothingBecauseInsidePinnedSection) return;
        this.setAutoHeightClasses();
        this.setupRefreshStrategy();
        this.addThemeToDetailGrid();
        this.createDetailGrid();
        this.loadRowData();
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_FULL_WIDTH_ROW_FOCUSED, this.onFullWidthRowFocused.bind(this));
    }
    onFullWidthRowFocused(e) {
        const params = this.params;
        const row = {
            rowIndex: params.node.rowIndex,
            rowPinned: params.node.rowPinned
        };
        const eventRow = {
            rowIndex: e.rowIndex,
            rowPinned: e.rowPinned
        };
        const isSameRow = this.rowPositionUtils.sameRow(row, eventRow);
        if (!isSameRow) return;
        this.focusService.focusInto(this.comp.getGui(), e.fromBelow);
    }
    setAutoHeightClasses() {
        const autoHeight = this.gos.get("detailRowAutoHeight");
        const parentClass = autoHeight ? "ag-details-row-auto-height" : "ag-details-row-fixed-height";
        const detailClass = autoHeight ? "ag-details-grid-auto-height" : "ag-details-grid-fixed-height";
        this.comp.addOrRemoveCssClass(parentClass, true);
        this.comp.addOrRemoveDetailGridCssClass(detailClass, true);
    }
    setupRefreshStrategy() {
        const providedStrategy = this.params.refreshStrategy;
        const validSelection = providedStrategy == "everything" || providedStrategy == "nothing" || providedStrategy == "rows";
        if (validSelection) {
            this.refreshStrategy = providedStrategy;
            return;
        }
        if (providedStrategy != null) console.warn("AG Grid: invalid cellRendererParams.refreshStrategy = '" + providedStrategy + "' supplied, defaulting to refreshStrategy = 'rows'.");
        this.refreshStrategy = "rows";
    }
    addThemeToDetailGrid() {
        const { theme: theme } = this.environment.getTheme();
        if (theme) this.comp.addOrRemoveDetailGridCssClass(theme, true);
    }
    createDetailGrid() {
        if ((0, $jIDNV._).missing(this.params.detailGridOptions)) {
            console.warn("AG Grid: could not find detail grid options for master detail, please set gridOptions.detailCellRendererParams.detailGridOptions");
            return;
        }
        const autoHeight = this.gos.get("detailRowAutoHeight");
        const gridOptions = $5b7ccabde48fae90$var$__spreadValues9({}, this.params.detailGridOptions);
        if (autoHeight) gridOptions.domLayout = "autoHeight";
        this.comp.setDetailGrid(gridOptions);
    }
    registerDetailWithMaster(api, columnApi) {
        const rowId = this.params.node.id;
        const masterGridApi = this.params.api;
        const gridInfo = {
            id: rowId,
            api: api,
            columnApi: columnApi
        };
        const rowNode = this.params.node;
        if (masterGridApi.isDestroyed()) return;
        masterGridApi.addDetailGridInfo(rowId, gridInfo);
        rowNode.detailGridInfo = gridInfo;
        this.addDestroyFunc(()=>{
            if (rowNode.detailGridInfo !== gridInfo) return;
            if (!masterGridApi.isDestroyed()) masterGridApi.removeDetailGridInfo(rowId);
            rowNode.detailGridInfo = null;
        });
    }
    loadRowData() {
        var _a, _b, _c;
        this.loadRowDataVersion++;
        const versionThisCall = this.loadRowDataVersion;
        if (((_a = this.params.detailGridOptions) == null ? void 0 : _a.rowModelType) === "serverSide") {
            const node = this.params.node;
            (_c = (_b = node.detailGridInfo) == null ? void 0 : _b.api) == null || _c.refreshServerSide({
                purge: true
            });
            return;
        }
        const userFunc = this.params.getDetailRowData;
        if (!userFunc) {
            console.warn("AG Grid: could not find getDetailRowData for master / detail, please set gridOptions.detailCellRendererParams.getDetailRowData");
            return;
        }
        const successCallback = (rowData)=>{
            const mostRecentCall = this.loadRowDataVersion === versionThisCall;
            if (mostRecentCall) this.comp.setRowData(rowData);
        };
        const funcParams = {
            node: this.params.node,
            // we take data from node, rather than params.data
            // as the data could have been updated with new instance
            data: this.params.node.data,
            successCallback: successCallback,
            context: this.gos.getGridCommonParams().context
        };
        userFunc(funcParams);
    }
    refresh() {
        const GET_GRID_TO_REFRESH = false;
        const GET_GRID_TO_DO_NOTHING = true;
        switch(this.refreshStrategy){
            case "nothing":
                return GET_GRID_TO_DO_NOTHING;
            case "everything":
                return GET_GRID_TO_REFRESH;
        }
        this.loadRowData();
        return GET_GRID_TO_DO_NOTHING;
    }
};
$5b7ccabde48fae90$var$__decorateClass11([
    (0, $jIDNV.Autowired)("rowPositionUtils")
], $5b7ccabde48fae90$var$DetailCellRendererCtrl.prototype, "rowPositionUtils", 2);
$5b7ccabde48fae90$var$__decorateClass11([
    (0, $jIDNV.Autowired)("focusService")
], $5b7ccabde48fae90$var$DetailCellRendererCtrl.prototype, "focusService", 2);
var $5b7ccabde48fae90$var$_DetailCellRenderer = class _DetailCellRenderer2 extends (0, $jIDNV.Component) {
    init(params) {
        this.params = params;
        this.selectAndSetTemplate();
        const compProxy = {
            addOrRemoveCssClass: (cssClassName, on)=>this.addOrRemoveCssClass(cssClassName, on),
            addOrRemoveDetailGridCssClass: (cssClassName, on)=>this.eDetailGrid.classList.toggle(cssClassName, on),
            setDetailGrid: (gridOptions)=>this.setDetailGrid(gridOptions),
            setRowData: (rowData)=>this.setRowData(rowData),
            getGui: ()=>this.eDetailGrid
        };
        this.ctrl = this.createManagedBean(new $5b7ccabde48fae90$var$DetailCellRendererCtrl());
        this.ctrl.init(compProxy, params);
    }
    refresh() {
        return this.ctrl && this.ctrl.refresh();
    }
    // this is a user component, and IComponent has "public destroy()" as part of the interface.
    // so we need to override destroy() just to make the method public.
    destroy() {
        super.destroy();
    }
    selectAndSetTemplate() {
        if (this.params.pinned) {
            this.setTemplate('<div class="ag-details-row"></div>');
            return;
        }
        const setDefaultTemplate = ()=>{
            this.setTemplate(_DetailCellRenderer2.TEMPLATE);
        };
        if ((0, $jIDNV._).missing(this.params.template)) setDefaultTemplate();
        else {
            if (typeof this.params.template === "string") this.setTemplate(this.params.template);
            else if (typeof this.params.template === "function") {
                const templateFunc = this.params.template;
                const template = templateFunc(this.params);
                this.setTemplate(template);
            } else {
                console.warn("AG Grid: detailCellRendererParams.template should be function or string");
                setDefaultTemplate();
            }
        }
        if (this.eDetailGrid == null) console.warn('AG Grid: reference to eDetailGrid was missing from the details template. Please add ref="eDetailGrid" to the template.');
    }
    setDetailGrid(gridOptions) {
        if (!this.eDetailGrid) return;
        const agGridReact = this.context.getBean("agGridReact");
        const agGridReactCloned = agGridReact ? (0, $jIDNV._).cloneObject(agGridReact) : void 0;
        const frameworkComponentWrapper = this.context.getBean("frameworkComponentWrapper");
        const frameworkOverrides = this.getFrameworkOverrides();
        const api = (0, $jIDNV.createGrid)(this.eDetailGrid, gridOptions, {
            frameworkOverrides: frameworkOverrides,
            providedBeanInstances: {
                agGridReact: agGridReactCloned,
                frameworkComponentWrapper: frameworkComponentWrapper
            },
            modules: (0, $jIDNV.ModuleRegistry).__getGridRegisteredModules(this.params.api.getGridId())
        });
        this.detailApi = api;
        this.ctrl.registerDetailWithMaster(api, new (0, $jIDNV.ColumnApi)(api));
        this.addDestroyFunc(()=>{
            api == null || api.destroy();
        });
    }
    setRowData(rowData) {
        this.detailApi && this.detailApi.setGridOption("rowData", rowData);
    }
};
$5b7ccabde48fae90$var$_DetailCellRenderer.TEMPLATE = /* html */ `<div class="ag-details-row" role="gridcell">
            <div ref="eDetailGrid" class="ag-details-grid" role="presentation"></div>
        </div>`;
$5b7ccabde48fae90$var$__decorateClass11([
    (0, $jIDNV.RefSelector)("eDetailGrid")
], $5b7ccabde48fae90$var$_DetailCellRenderer.prototype, "eDetailGrid", 2);
var $5b7ccabde48fae90$var$DetailCellRenderer = $5b7ccabde48fae90$var$_DetailCellRenderer;
var $5b7ccabde48fae90$var$VERSION11 = "31.3.4";
var $5b7ccabde48fae90$export$656cedc46227f6d2 = {
    version: $5b7ccabde48fae90$var$VERSION11,
    moduleName: (0, $jIDNV.ModuleNames).MasterDetailModule,
    beans: [],
    userComponents: [
        {
            componentName: "agDetailCellRenderer",
            componentClass: $5b7ccabde48fae90$var$DetailCellRenderer
        }
    ],
    controllers: [
        {
            controllerName: "detailCellRenderer",
            controllerClass: $5b7ccabde48fae90$var$DetailCellRendererCtrl
        }
    ],
    dependantModules: [
        $5b7ccabde48fae90$export$3a6d13add8617801
    ]
};
var $5b7ccabde48fae90$var$__defProp12 = Object.defineProperty;
var $5b7ccabde48fae90$var$__defProps7 = Object.defineProperties;
var $5b7ccabde48fae90$var$__getOwnPropDesc12 = Object.getOwnPropertyDescriptor;
var $5b7ccabde48fae90$var$__getOwnPropDescs7 = Object.getOwnPropertyDescriptors;
var $5b7ccabde48fae90$var$__getOwnPropSymbols10 = Object.getOwnPropertySymbols;
var $5b7ccabde48fae90$var$__hasOwnProp11 = Object.prototype.hasOwnProperty;
var $5b7ccabde48fae90$var$__propIsEnum10 = Object.prototype.propertyIsEnumerable;
var $5b7ccabde48fae90$var$__defNormalProp10 = (obj, key, value)=>key in obj ? $5b7ccabde48fae90$var$__defProp12(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5b7ccabde48fae90$var$__spreadValues10 = (a, b)=>{
    for(var prop in b || (b = {}))if ($5b7ccabde48fae90$var$__hasOwnProp11.call(b, prop)) $5b7ccabde48fae90$var$__defNormalProp10(a, prop, b[prop]);
    if ($5b7ccabde48fae90$var$__getOwnPropSymbols10) {
        for (var prop of $5b7ccabde48fae90$var$__getOwnPropSymbols10(b))if ($5b7ccabde48fae90$var$__propIsEnum10.call(b, prop)) $5b7ccabde48fae90$var$__defNormalProp10(a, prop, b[prop]);
    }
    return a;
};
var $5b7ccabde48fae90$var$__spreadProps7 = (a, b)=>$5b7ccabde48fae90$var$__defProps7(a, $5b7ccabde48fae90$var$__getOwnPropDescs7(b));
var $5b7ccabde48fae90$var$__decorateClass12 = (decorators, target, key, kind)=>{
    var result = kind > 1 ? void 0 : kind ? $5b7ccabde48fae90$var$__getOwnPropDesc12(target, key) : target;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
    if (kind && result) $5b7ccabde48fae90$var$__defProp12(target, key, result);
    return result;
};
var $5b7ccabde48fae90$var$EnterpriseMenuFactory = class extends (0, $jIDNV.BeanStub) {
    hideActiveMenu() {
        this.destroyBean(this.activeMenu);
    }
    showMenuAfterMouseEvent(column, mouseEvent, containerType, filtersOnly) {
        const defaultTab = filtersOnly ? "filterMenuTab" : void 0;
        this.showMenu(column, (menu)=>{
            var _a;
            const ePopup = menu.getGui();
            this.popupService.positionPopupUnderMouseEvent({
                type: containerType,
                column: column,
                mouseEvent: mouseEvent,
                ePopup: ePopup
            });
            if (defaultTab) (_a = menu.showTab) == null || _a.call(menu, defaultTab);
            this.dispatchVisibleChangedEvent(true, false, column, defaultTab);
        }, containerType, defaultTab, void 0, mouseEvent.target);
    }
    showMenuAfterButtonClick(column, eventSource, containerType, filtersOnly) {
        let multiplier = -1;
        let alignSide = "left";
        if (this.gos.get("enableRtl")) {
            multiplier = 1;
            alignSide = "right";
        }
        const defaultTab = filtersOnly ? "filterMenuTab" : void 0;
        const restrictToTabs = defaultTab ? [
            defaultTab
        ] : void 0;
        const isLegacyMenuEnabled = this.menuService.isLegacyMenuEnabled();
        let nudgeX = (isLegacyMenuEnabled ? 9 : 4) * multiplier;
        let nudgeY = isLegacyMenuEnabled ? -23 : 4;
        this.showMenu(column, (menu)=>{
            var _a;
            const ePopup = menu.getGui();
            this.popupService.positionPopupByComponent({
                type: containerType,
                column: column,
                eventSource: eventSource,
                ePopup: ePopup,
                alignSide: alignSide,
                nudgeX: nudgeX,
                nudgeY: nudgeY,
                position: "under",
                keepWithinBounds: true
            });
            if (defaultTab) (_a = menu.showTab) == null || _a.call(menu, defaultTab);
            this.dispatchVisibleChangedEvent(true, false, column, defaultTab);
        }, containerType, defaultTab, restrictToTabs, eventSource);
    }
    showMenu(column, positionCallback, containerType, defaultTab, restrictToTabs, eventSource) {
        var _a;
        const { menu: menu, eMenuGui: eMenuGui, anchorToElement: anchorToElement, restoreFocusParams: restoreFocusParams } = this.getMenuParams(column, restrictToTabs, eventSource);
        const closedFuncs = [];
        closedFuncs.push((e)=>{
            const eComp = menu.getGui();
            this.destroyBean(menu);
            if (column) {
                column.setMenuVisible(false, "contextMenu");
                this.menuUtils.restoreFocusOnClose(restoreFocusParams, eComp, e);
            }
        });
        const translate = this.localeService.getLocaleTextFunc();
        this.popupService.addPopup({
            modal: true,
            eChild: eMenuGui,
            closeOnEsc: true,
            closedCallback: (e)=>{
                closedFuncs.forEach((f)=>f(e));
                this.dispatchVisibleChangedEvent(false, false, column, defaultTab);
            },
            afterGuiAttached: (params)=>menu.afterGuiAttached(Object.assign({}, {
                    container: containerType
                }, params)),
            // if defaultTab is not present, positionCallback will be called
            // after `showTabBasedOnPreviousSelection` is called.
            positionCallback: !!defaultTab ? ()=>positionCallback(menu) : void 0,
            ariaLabel: translate("ariaLabelColumnMenu", "Column Menu")
        });
        if (!defaultTab) {
            (_a = menu.showTabBasedOnPreviousSelection) == null || _a.call(menu);
            positionCallback(menu);
        }
        if (this.menuService.isColumnMenuAnchoringEnabled()) {
            const stopAnchoringPromise = this.popupService.setPopupPositionRelatedToElement(eMenuGui, anchorToElement);
            if (stopAnchoringPromise && column) this.addStopAnchoring(stopAnchoringPromise, column, closedFuncs);
        }
        menu.addEventListener($5b7ccabde48fae90$var$TabbedColumnMenu.EVENT_TAB_SELECTED, (event)=>{
            this.dispatchVisibleChangedEvent(false, true, column);
            this.lastSelectedTab = event.key;
            this.dispatchVisibleChangedEvent(true, true, column);
        });
        column == null || column.setMenuVisible(true, "contextMenu");
        this.activeMenu = menu;
        menu.addEventListener((0, $jIDNV.BeanStub).EVENT_DESTROYED, ()=>{
            if (this.activeMenu === menu) this.activeMenu = null;
        });
    }
    addStopAnchoring(stopAnchoringPromise, column, closedFuncsArr) {
        stopAnchoringPromise.then((stopAnchoringFunc)=>{
            column.addEventListener("leftChanged", stopAnchoringFunc);
            column.addEventListener("visibleChanged", stopAnchoringFunc);
            closedFuncsArr.push(()=>{
                column.removeEventListener("leftChanged", stopAnchoringFunc);
                column.removeEventListener("visibleChanged", stopAnchoringFunc);
            });
        });
    }
    getMenuParams(column, restrictToTabs, eventSource) {
        const restoreFocusParams = {
            column: column,
            headerPosition: this.focusService.getFocusedHeader(),
            columnIndex: this.columnModel.getAllDisplayedColumns().indexOf(column),
            eventSource: eventSource
        };
        const menu = this.createMenu(column, restoreFocusParams, restrictToTabs, eventSource);
        return {
            menu: menu,
            eMenuGui: menu.getGui(),
            anchorToElement: eventSource || this.ctrlsService.getGridBodyCtrl().getGui(),
            restoreFocusParams: restoreFocusParams
        };
    }
    createMenu(column, restoreFocusParams, restrictToTabs, eventSource) {
        if (this.menuService.isLegacyMenuEnabled()) return this.createBean(new $5b7ccabde48fae90$var$TabbedColumnMenu(column, restoreFocusParams, this.lastSelectedTab, restrictToTabs, eventSource));
        else return this.createBean(new $5b7ccabde48fae90$var$ColumnContextMenu(column, restoreFocusParams, eventSource));
    }
    dispatchVisibleChangedEvent(visible, switchingTab, column, defaultTab) {
        var _a, _b;
        const event = {
            type: (0, $jIDNV.Events).EVENT_COLUMN_MENU_VISIBLE_CHANGED,
            visible: visible,
            switchingTab: switchingTab,
            key: (_b = (_a = this.lastSelectedTab) != null ? _a : defaultTab) != null ? _b : this.menuService.isLegacyMenuEnabled() ? $5b7ccabde48fae90$var$TabbedColumnMenu.TAB_GENERAL : "columnMenu",
            column: column != null ? column : null
        };
        this.eventService.dispatchEvent(event);
    }
    isMenuEnabled(column) {
        var _a;
        if (!this.menuService.isLegacyMenuEnabled()) return true;
        const isFilterDisabled = !this.filterManager.isFilterAllowed(column);
        const tabs = (_a = column.getColDef().menuTabs) != null ? _a : $5b7ccabde48fae90$var$TabbedColumnMenu.TABS_DEFAULT;
        const numActiveTabs = isFilterDisabled && tabs.includes($5b7ccabde48fae90$var$TabbedColumnMenu.TAB_FILTER) ? tabs.length - 1 : tabs.length;
        return numActiveTabs > 0;
    }
    showMenuAfterContextMenuEvent(column, mouseEvent, touchEvent) {
        this.menuUtils.onContextMenu(mouseEvent, touchEvent, (eventOrTouch)=>{
            this.showMenuAfterMouseEvent(column, eventOrTouch, "columnMenu");
            return true;
        });
    }
};
$5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Autowired)("popupService")
], $5b7ccabde48fae90$var$EnterpriseMenuFactory.prototype, "popupService", 2);
$5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Autowired)("focusService")
], $5b7ccabde48fae90$var$EnterpriseMenuFactory.prototype, "focusService", 2);
$5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Autowired)("ctrlsService")
], $5b7ccabde48fae90$var$EnterpriseMenuFactory.prototype, "ctrlsService", 2);
$5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$EnterpriseMenuFactory.prototype, "columnModel", 2);
$5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Autowired)("filterManager")
], $5b7ccabde48fae90$var$EnterpriseMenuFactory.prototype, "filterManager", 2);
$5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Autowired)("menuUtils")
], $5b7ccabde48fae90$var$EnterpriseMenuFactory.prototype, "menuUtils", 2);
$5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Autowired)("menuService")
], $5b7ccabde48fae90$var$EnterpriseMenuFactory.prototype, "menuService", 2);
$5b7ccabde48fae90$var$EnterpriseMenuFactory = $5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Bean)("enterpriseMenuFactory")
], $5b7ccabde48fae90$var$EnterpriseMenuFactory);
var $5b7ccabde48fae90$var$_TabbedColumnMenu = class _TabbedColumnMenu2 extends (0, $jIDNV.BeanStub) {
    constructor(column, restoreFocusParams, initialSelection, restrictTo, sourceElement){
        super();
        this.column = column;
        this.restoreFocusParams = restoreFocusParams;
        this.initialSelection = initialSelection;
        this.restrictTo = restrictTo;
        this.sourceElement = sourceElement;
        this.tabFactories = {};
        this.includeChecks = {};
        this.tabFactories[_TabbedColumnMenu2.TAB_GENERAL] = this.createMainPanel.bind(this);
        this.tabFactories[_TabbedColumnMenu2.TAB_FILTER] = this.createFilterPanel.bind(this);
        this.tabFactories[_TabbedColumnMenu2.TAB_COLUMNS] = this.createColumnsPanel.bind(this);
        this.includeChecks[_TabbedColumnMenu2.TAB_GENERAL] = ()=>true;
        this.includeChecks[_TabbedColumnMenu2.TAB_FILTER] = ()=>column ? this.filterManager.isFilterAllowed(column) : false;
        this.includeChecks[_TabbedColumnMenu2.TAB_COLUMNS] = ()=>true;
    }
    init() {
        const tabs = this.getTabsToCreate().map((name)=>this.createTab(name));
        this.tabbedLayout = new (0, $jIDNV.TabbedLayout)({
            items: tabs,
            cssClass: "ag-menu",
            onActiveItemClicked: this.onHidePopup.bind(this),
            onItemClicked: this.onTabItemClicked.bind(this)
        });
        this.createBean(this.tabbedLayout);
        if (this.mainMenuList) this.mainMenuList.setParentComponent(this.tabbedLayout);
        this.addDestroyFunc(()=>this.destroyBean(this.tabbedLayout));
    }
    getTabsToCreate() {
        var _a, _b;
        if (this.restrictTo) return this.restrictTo;
        return ((_b = (_a = this.column) == null ? void 0 : _a.getColDef().menuTabs) != null ? _b : _TabbedColumnMenu2.TABS_DEFAULT).filter((tabName)=>this.isValidMenuTabItem(tabName)).filter((tabName)=>this.isNotSuppressed(tabName)).filter((tabName)=>this.isModuleLoaded(tabName));
    }
    isModuleLoaded(menuTabName) {
        if (menuTabName === _TabbedColumnMenu2.TAB_COLUMNS) return (0, $jIDNV.ModuleRegistry).__isRegistered((0, $jIDNV.ModuleNames).ColumnsToolPanelModule, this.context.getGridId());
        return true;
    }
    isValidMenuTabItem(menuTabName) {
        let isValid = true;
        let itemsToConsider = _TabbedColumnMenu2.TABS_DEFAULT;
        if (this.restrictTo != null) {
            isValid = this.restrictTo.indexOf(menuTabName) > -1;
            itemsToConsider = this.restrictTo;
        }
        isValid = isValid && _TabbedColumnMenu2.TABS_DEFAULT.indexOf(menuTabName) > -1;
        if (!isValid) console.warn(`AG Grid: Trying to render an invalid menu item '${menuTabName}'. Check that your 'menuTabs' contains one of [${itemsToConsider}]`);
        return isValid;
    }
    isNotSuppressed(menuTabName) {
        return this.includeChecks[menuTabName]();
    }
    createTab(name) {
        return this.tabFactories[name]();
    }
    showTabBasedOnPreviousSelection() {
        this.showTab(this.initialSelection);
    }
    showTab(toShow) {
        if (this.tabItemColumns && toShow === _TabbedColumnMenu2.TAB_COLUMNS) this.tabbedLayout.showItem(this.tabItemColumns);
        else if (this.tabItemFilter && toShow === _TabbedColumnMenu2.TAB_FILTER) this.tabbedLayout.showItem(this.tabItemFilter);
        else if (this.tabItemGeneral && toShow === _TabbedColumnMenu2.TAB_GENERAL) this.tabbedLayout.showItem(this.tabItemGeneral);
        else this.tabbedLayout.showFirstItem();
    }
    onTabItemClicked(event) {
        let key = null;
        switch(event.item){
            case this.tabItemColumns:
                key = _TabbedColumnMenu2.TAB_COLUMNS;
                break;
            case this.tabItemFilter:
                key = _TabbedColumnMenu2.TAB_FILTER;
                break;
            case this.tabItemGeneral:
                key = _TabbedColumnMenu2.TAB_GENERAL;
                break;
        }
        if (key) this.activateTab(key);
    }
    activateTab(tab) {
        const ev = {
            type: _TabbedColumnMenu2.EVENT_TAB_SELECTED,
            key: tab
        };
        this.dispatchEvent(ev);
    }
    createMainPanel() {
        this.mainMenuList = this.columnMenuFactory.createMenu(this, this.column, ()=>{
            var _a;
            return (_a = this.sourceElement) != null ? _a : this.getGui();
        });
        this.mainMenuList.addEventListener((0, $jIDNV.AgMenuItemComponent).EVENT_CLOSE_MENU, this.onHidePopup.bind(this));
        this.tabItemGeneral = {
            title: (0, $jIDNV._).createIconNoSpan("menu", this.gos, this.column),
            titleLabel: _TabbedColumnMenu2.TAB_GENERAL.replace("MenuTab", ""),
            bodyPromise: (0, $jIDNV.AgPromise).resolve(this.mainMenuList.getGui()),
            name: _TabbedColumnMenu2.TAB_GENERAL
        };
        return this.tabItemGeneral;
    }
    onHidePopup(event) {
        this.menuUtils.closePopupAndRestoreFocusOnSelect(this.hidePopupFunc, this.restoreFocusParams, event);
    }
    createFilterPanel() {
        const comp = this.column ? this.createManagedBean(new (0, $jIDNV.FilterWrapperComp)(this.column, "COLUMN_MENU")) : null;
        if (!(comp == null ? void 0 : comp.hasFilter())) throw new Error("AG Grid - Unable to instantiate filter");
        const afterAttachedCallback = (params)=>comp.afterGuiAttached(params);
        const afterDetachedCallback = ()=>comp.afterGuiDetached();
        this.tabItemFilter = {
            title: (0, $jIDNV._).createIconNoSpan("filter", this.gos, this.column),
            titleLabel: _TabbedColumnMenu2.TAB_FILTER.replace("MenuTab", ""),
            bodyPromise: (0, $jIDNV.AgPromise).resolve(comp == null ? void 0 : comp.getGui()),
            afterAttachedCallback: afterAttachedCallback,
            afterDetachedCallback: afterDetachedCallback,
            name: _TabbedColumnMenu2.TAB_FILTER
        };
        return this.tabItemFilter;
    }
    createColumnsPanel() {
        const eWrapperDiv = document.createElement("div");
        eWrapperDiv.classList.add("ag-menu-column-select-wrapper");
        const columnSelectPanel = this.columnChooserFactory.createColumnSelectPanel(this, this.column);
        const columnSelectPanelGui = columnSelectPanel.getGui();
        columnSelectPanelGui.classList.add("ag-menu-column-select");
        eWrapperDiv.appendChild(columnSelectPanelGui);
        this.tabItemColumns = {
            title: (0, $jIDNV._).createIconNoSpan("columns", this.gos, this.column),
            //createColumnsIcon(),
            titleLabel: _TabbedColumnMenu2.TAB_COLUMNS.replace("MenuTab", ""),
            bodyPromise: (0, $jIDNV.AgPromise).resolve(eWrapperDiv),
            name: _TabbedColumnMenu2.TAB_COLUMNS
        };
        return this.tabItemColumns;
    }
    afterGuiAttached(params) {
        const { container: container, hidePopup: hidePopup } = params;
        this.tabbedLayout.setAfterAttachedParams({
            container: container,
            hidePopup: hidePopup
        });
        if (hidePopup) {
            this.hidePopupFunc = hidePopup;
            this.addDestroyFunc(hidePopup);
        }
    }
    getGui() {
        return this.tabbedLayout.getGui();
    }
};
$5b7ccabde48fae90$var$_TabbedColumnMenu.EVENT_TAB_SELECTED = "tabSelected";
$5b7ccabde48fae90$var$_TabbedColumnMenu.TAB_FILTER = "filterMenuTab";
$5b7ccabde48fae90$var$_TabbedColumnMenu.TAB_GENERAL = "generalMenuTab";
$5b7ccabde48fae90$var$_TabbedColumnMenu.TAB_COLUMNS = "columnsMenuTab";
$5b7ccabde48fae90$var$_TabbedColumnMenu.TABS_DEFAULT = [
    $5b7ccabde48fae90$var$_TabbedColumnMenu.TAB_GENERAL,
    $5b7ccabde48fae90$var$_TabbedColumnMenu.TAB_FILTER,
    $5b7ccabde48fae90$var$_TabbedColumnMenu.TAB_COLUMNS
];
$5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Autowired)("filterManager")
], $5b7ccabde48fae90$var$_TabbedColumnMenu.prototype, "filterManager", 2);
$5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Autowired)("columnChooserFactory")
], $5b7ccabde48fae90$var$_TabbedColumnMenu.prototype, "columnChooserFactory", 2);
$5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Autowired)("columnMenuFactory")
], $5b7ccabde48fae90$var$_TabbedColumnMenu.prototype, "columnMenuFactory", 2);
$5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Autowired)("menuUtils")
], $5b7ccabde48fae90$var$_TabbedColumnMenu.prototype, "menuUtils", 2);
$5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_TabbedColumnMenu.prototype, "init", 1);
var $5b7ccabde48fae90$var$TabbedColumnMenu = $5b7ccabde48fae90$var$_TabbedColumnMenu;
var $5b7ccabde48fae90$var$ColumnContextMenu = class extends (0, $jIDNV.Component) {
    constructor(column, restoreFocusParams, sourceElement){
        super(/* html */ `
            <div ref="eColumnMenu" role="presentation" class="ag-menu ag-column-menu"></div>
        `);
        this.column = column;
        this.restoreFocusParams = restoreFocusParams;
        this.sourceElement = sourceElement;
    }
    init() {
        this.mainMenuList = this.columnMenuFactory.createMenu(this, this.column, ()=>{
            var _a;
            return (_a = this.sourceElement) != null ? _a : this.getGui();
        });
        this.mainMenuList.addEventListener((0, $jIDNV.AgMenuItemComponent).EVENT_CLOSE_MENU, this.onHidePopup.bind(this));
        this.eColumnMenu.appendChild(this.mainMenuList.getGui());
    }
    onHidePopup(event) {
        this.menuUtils.closePopupAndRestoreFocusOnSelect(this.hidePopupFunc, this.restoreFocusParams, event);
    }
    afterGuiAttached({ hidePopup: hidePopup }) {
        if (hidePopup) {
            this.hidePopupFunc = hidePopup;
            this.addDestroyFunc(hidePopup);
        }
        this.focusService.focusInto(this.mainMenuList.getGui());
    }
};
$5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Autowired)("columnMenuFactory")
], $5b7ccabde48fae90$var$ColumnContextMenu.prototype, "columnMenuFactory", 2);
$5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Autowired)("menuUtils")
], $5b7ccabde48fae90$var$ColumnContextMenu.prototype, "menuUtils", 2);
$5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Autowired)("focusService")
], $5b7ccabde48fae90$var$ColumnContextMenu.prototype, "focusService", 2);
$5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.RefSelector)("eColumnMenu")
], $5b7ccabde48fae90$var$ColumnContextMenu.prototype, "eColumnMenu", 2);
$5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$ColumnContextMenu.prototype, "init", 1);
var $5b7ccabde48fae90$var$CSS_MENU = "ag-menu";
var $5b7ccabde48fae90$var$CSS_CONTEXT_MENU_OPEN = "ag-context-menu-open";
var $5b7ccabde48fae90$var$ContextMenuFactory = class extends (0, $jIDNV.BeanStub) {
    hideActiveMenu() {
        this.destroyBean(this.activeMenu);
    }
    getMenuItems(node, column, value) {
        const defaultMenuOptions = [];
        if ((0, $jIDNV._).exists(node) && (0, $jIDNV.ModuleRegistry).__isRegistered((0, $jIDNV.ModuleNames).ClipboardModule, this.context.getGridId())) {
            if (column) {
                if (!this.gos.get("suppressCutToClipboard")) defaultMenuOptions.push("cut");
                defaultMenuOptions.push("copy", "copyWithHeaders", "copyWithGroupHeaders", "paste", "separator");
            }
        }
        if (this.gos.get("enableCharts") && (0, $jIDNV.ModuleRegistry).__isRegistered((0, $jIDNV.ModuleNames).GridChartsModule, this.context.getGridId())) {
            if (this.columnModel.isPivotMode()) defaultMenuOptions.push("pivotChart");
            if (this.rangeService && !this.rangeService.isEmpty()) defaultMenuOptions.push("chartRange");
        }
        if ((0, $jIDNV._).exists(node)) {
            const csvModuleMissing = !(0, $jIDNV.ModuleRegistry).__isRegistered((0, $jIDNV.ModuleNames).CsvExportModule, this.context.getGridId());
            const excelModuleMissing = !(0, $jIDNV.ModuleRegistry).__isRegistered((0, $jIDNV.ModuleNames).ExcelExportModule, this.context.getGridId());
            const suppressExcel = this.gos.get("suppressExcelExport") || excelModuleMissing;
            const suppressCsv = this.gos.get("suppressCsvExport") || csvModuleMissing;
            const onIPad = (0, $jIDNV._).isIOSUserAgent();
            const anyExport = !onIPad && (!suppressExcel || !suppressCsv);
            if (anyExport) defaultMenuOptions.push("export");
        }
        const defaultItems = defaultMenuOptions.length ? defaultMenuOptions : void 0;
        const columnContextMenuItems = column == null ? void 0 : column.getColDef().contextMenuItems;
        if (Array.isArray(columnContextMenuItems)) return columnContextMenuItems;
        if (typeof columnContextMenuItems === "function") return columnContextMenuItems(this.gos.addGridCommonParams({
            column: column,
            node: node,
            value: value,
            defaultItems: defaultItems
        }));
        const userFunc = this.gos.getCallback("getContextMenuItems");
        if (userFunc) return userFunc({
            column: column,
            node: node,
            value: value,
            defaultItems: defaultItems
        });
        return defaultMenuOptions;
    }
    onContextMenu(mouseEvent, touchEvent, rowNode, column, value, anchorToElement) {
        this.menuUtils.onContextMenu(mouseEvent, touchEvent, (eventOrTouch)=>this.showMenu(rowNode, column, value, eventOrTouch, anchorToElement));
    }
    showMenu(node, column, value, mouseEvent, anchorToElement) {
        const menuItems = this.getMenuItems(node, column, value);
        const eGridBodyGui = this.ctrlsService.getGridBodyCtrl().getGui();
        if (menuItems === void 0 || (0, $jIDNV._).missingOrEmpty(menuItems)) return false;
        const menu = new $5b7ccabde48fae90$var$ContextMenu(menuItems, column, node, value);
        this.createBean(menu);
        const eMenuGui = menu.getGui();
        const positionParams = {
            column: column,
            rowNode: node,
            type: "contextMenu",
            mouseEvent: mouseEvent,
            ePopup: eMenuGui,
            // move one pixel away so that accidentally double clicking
            // won't show the browser's contextmenu
            nudgeY: 1
        };
        const translate = this.localeService.getLocaleTextFunc();
        const addPopupRes = this.popupService.addPopup({
            modal: true,
            eChild: eMenuGui,
            closeOnEsc: true,
            closedCallback: (e)=>{
                eGridBodyGui.classList.remove($5b7ccabde48fae90$var$CSS_CONTEXT_MENU_OPEN);
                this.destroyBean(menu);
                this.dispatchVisibleChangedEvent(false, e === void 0 ? "api" : "ui");
            },
            click: mouseEvent,
            positionCallback: ()=>{
                const isRtl = this.gos.get("enableRtl");
                this.popupService.positionPopupUnderMouseEvent($5b7ccabde48fae90$var$__spreadProps7($5b7ccabde48fae90$var$__spreadValues10({}, positionParams), {
                    nudgeX: isRtl ? (eMenuGui.offsetWidth + 1) * -1 : 1
                }));
            },
            anchorToElement: // so when browser is scrolled down, or grid is scrolled, context menu stays with cell
            anchorToElement,
            ariaLabel: translate("ariaLabelContextMenu", "Context Menu")
        });
        if (addPopupRes) {
            eGridBodyGui.classList.add($5b7ccabde48fae90$var$CSS_CONTEXT_MENU_OPEN);
            menu.afterGuiAttached({
                container: "contextMenu",
                hidePopup: addPopupRes.hideFunc
            });
        }
        if (this.activeMenu) this.hideActiveMenu();
        this.activeMenu = menu;
        menu.addEventListener((0, $jIDNV.BeanStub).EVENT_DESTROYED, ()=>{
            if (this.activeMenu === menu) this.activeMenu = null;
        });
        if (addPopupRes) menu.addEventListener((0, $jIDNV.AgMenuItemComponent).EVENT_CLOSE_MENU, (e)=>{
            var _a, _b;
            return addPopupRes.hideFunc({
                mouseEvent: (_a = e.mouseEvent) != null ? _a : void 0,
                keyboardEvent: (_b = e.keyboardEvent) != null ? _b : void 0,
                forceHide: true
            });
        });
        const isApi = mouseEvent && mouseEvent instanceof MouseEvent && mouseEvent.type === "mousedown";
        this.dispatchVisibleChangedEvent(true, isApi ? "api" : "ui");
        return true;
    }
    dispatchVisibleChangedEvent(visible, source = "ui") {
        const displayedEvent = {
            type: (0, $jIDNV.Events).EVENT_CONTEXT_MENU_VISIBLE_CHANGED,
            visible: visible,
            source: source
        };
        this.eventService.dispatchEvent(displayedEvent);
    }
};
$5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Autowired)("popupService")
], $5b7ccabde48fae90$var$ContextMenuFactory.prototype, "popupService", 2);
$5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Autowired)("ctrlsService")
], $5b7ccabde48fae90$var$ContextMenuFactory.prototype, "ctrlsService", 2);
$5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$ContextMenuFactory.prototype, "columnModel", 2);
$5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Autowired)("menuUtils")
], $5b7ccabde48fae90$var$ContextMenuFactory.prototype, "menuUtils", 2);
$5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Optional)("rangeService")
], $5b7ccabde48fae90$var$ContextMenuFactory.prototype, "rangeService", 2);
$5b7ccabde48fae90$var$ContextMenuFactory = $5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Bean)("contextMenuFactory")
], $5b7ccabde48fae90$var$ContextMenuFactory);
var $5b7ccabde48fae90$var$ContextMenu = class extends (0, $jIDNV.Component) {
    constructor(menuItems, column, node, value){
        super(/* html */ `<div class="${$5b7ccabde48fae90$var$CSS_MENU}" role="presentation"></div>`);
        this.menuItems = menuItems;
        this.column = column;
        this.node = node;
        this.value = value;
        this.menuList = null;
        this.focusedCell = null;
    }
    addMenuItems() {
        const menuList = this.createManagedBean(new (0, $jIDNV.AgMenuList)(0, {
            column: this.column,
            node: this.node,
            value: this.value
        }));
        const menuItemsMapped = this.menuItemMapper.mapWithStockItems(this.menuItems, null, ()=>this.getGui());
        menuList.addMenuItems(menuItemsMapped);
        this.appendChild(menuList);
        this.menuList = menuList;
        menuList.addEventListener((0, $jIDNV.AgMenuItemComponent).EVENT_CLOSE_MENU, (e)=>this.dispatchEvent(e));
    }
    afterGuiAttached(params) {
        if (params.hidePopup) this.addDestroyFunc(params.hidePopup);
        this.focusedCell = this.focusService.getFocusedCell();
        if (this.menuList) this.focusService.focusInto(this.menuList.getGui());
    }
    restoreFocusedCell() {
        const currentFocusedCell = this.focusService.getFocusedCell();
        if (currentFocusedCell && this.focusedCell && this.cellPositionUtils.equals(currentFocusedCell, this.focusedCell)) {
            const { rowIndex: rowIndex, rowPinned: rowPinned, column: column } = this.focusedCell;
            const doc = this.gos.getDocument();
            const activeEl = this.gos.getActiveDomElement();
            if (!activeEl || activeEl === doc.body) this.focusService.setFocusedCell({
                rowIndex: rowIndex,
                column: column,
                rowPinned: rowPinned,
                forceBrowserFocus: true,
                preventScrollOnBrowserFocus: !this.focusService.isKeyboardMode()
            });
        }
    }
    destroy() {
        this.restoreFocusedCell();
        super.destroy();
    }
};
$5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Autowired)("menuItemMapper")
], $5b7ccabde48fae90$var$ContextMenu.prototype, "menuItemMapper", 2);
$5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Autowired)("focusService")
], $5b7ccabde48fae90$var$ContextMenu.prototype, "focusService", 2);
$5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Autowired)("cellPositionUtils")
], $5b7ccabde48fae90$var$ContextMenu.prototype, "cellPositionUtils", 2);
$5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$ContextMenu.prototype, "addMenuItems", 1);
var $5b7ccabde48fae90$var$MenuItemMapper = class extends (0, $jIDNV.BeanStub) {
    mapWithStockItems(originalList, column, sourceElement) {
        if (!originalList) return [];
        const resultList = [];
        originalList.forEach((menuItemOrString)=>{
            let result;
            if (typeof menuItemOrString === "string") result = this.getStockMenuItem(menuItemOrString, column, sourceElement);
            else result = $5b7ccabde48fae90$var$__spreadValues10({}, menuItemOrString);
            if (!result) return;
            const resultDef = result;
            const { subMenu: subMenu } = resultDef;
            if (subMenu && subMenu instanceof Array) resultDef.subMenu = this.mapWithStockItems(subMenu, column, sourceElement);
            if (result != null) resultList.push(result);
        });
        return resultList;
    }
    getStockMenuItem(key, column, sourceElement) {
        var _a;
        const localeTextFunc = this.localeService.getLocaleTextFunc();
        const skipHeaderOnAutoSize = this.gos.get("skipHeaderOnAutoSize");
        switch(key){
            case "pinSubMenu":
                return {
                    name: localeTextFunc("pinColumn", "Pin Column"),
                    icon: (0, $jIDNV._).createIconNoSpan("menuPin", this.gos, null),
                    subMenu: [
                        "clearPinned",
                        "pinLeft",
                        "pinRight"
                    ]
                };
            case "pinLeft":
                return {
                    name: localeTextFunc("pinLeft", "Pin Left"),
                    action: ()=>this.columnModel.setColumnsPinned([
                            column
                        ], "left", "contextMenu"),
                    checked: !!column && column.isPinnedLeft()
                };
            case "pinRight":
                return {
                    name: localeTextFunc("pinRight", "Pin Right"),
                    action: ()=>this.columnModel.setColumnsPinned([
                            column
                        ], "right", "contextMenu"),
                    checked: !!column && column.isPinnedRight()
                };
            case "clearPinned":
                return {
                    name: localeTextFunc("noPin", "No Pin"),
                    action: ()=>this.columnModel.setColumnsPinned([
                            column
                        ], null, "contextMenu"),
                    checked: !!column && !column.isPinned()
                };
            case "valueAggSubMenu":
                if ((0, $jIDNV.ModuleRegistry).__assertRegistered((0, $jIDNV.ModuleNames).RowGroupingModule, "Aggregation from Menu", this.context.getGridId())) {
                    if (!(column == null ? void 0 : column.isPrimary()) && !(column == null ? void 0 : column.getColDef().pivotValueColumn)) return null;
                    return {
                        name: localeTextFunc("valueAggregation", "Value Aggregation"),
                        icon: (0, $jIDNV._).createIconNoSpan("menuValue", this.gos, null),
                        subMenu: this.createAggregationSubMenu(column, this.aggFuncService)
                    };
                } else return null;
            case "autoSizeThis":
                return {
                    name: localeTextFunc("autosizeThiscolumn", "Autosize This Column"),
                    action: ()=>this.columnModel.autoSizeColumn(column, "contextMenu", skipHeaderOnAutoSize)
                };
            case "autoSizeAll":
                return {
                    name: localeTextFunc("autosizeAllColumns", "Autosize All Columns"),
                    action: ()=>this.columnModel.autoSizeAllColumns("contextMenu", skipHeaderOnAutoSize)
                };
            case "rowGroup":
                return {
                    name: localeTextFunc("groupBy", "Group by") + " " + (0, $jIDNV._).escapeString(this.columnModel.getDisplayNameForColumn(column, "header")),
                    disabled: (column == null ? void 0 : column.isRowGroupActive()) || !(column == null ? void 0 : column.getColDef().enableRowGroup),
                    action: ()=>this.columnModel.addRowGroupColumns([
                            column
                        ], "contextMenu"),
                    icon: (0, $jIDNV._).createIconNoSpan("menuAddRowGroup", this.gos, null)
                };
            case "rowUnGroup":
                const icon = (0, $jIDNV._).createIconNoSpan("menuRemoveRowGroup", this.gos, null);
                const showRowGroup = column == null ? void 0 : column.getColDef().showRowGroup;
                const lockedGroups = this.gos.get("groupLockGroupColumns");
                if (showRowGroup === true) return {
                    name: localeTextFunc("ungroupAll", "Un-Group All"),
                    disabled: lockedGroups === -1 || lockedGroups >= this.columnModel.getRowGroupColumns().length,
                    action: ()=>this.columnModel.setRowGroupColumns(this.columnModel.getRowGroupColumns().slice(0, lockedGroups), "contextMenu"),
                    icon: icon
                };
                if (typeof showRowGroup === "string") {
                    const underlyingColumn = this.columnModel.getPrimaryColumn(showRowGroup);
                    const ungroupByName = underlyingColumn != null ? (0, $jIDNV._).escapeString(this.columnModel.getDisplayNameForColumn(underlyingColumn, "header")) : showRowGroup;
                    return {
                        name: localeTextFunc("ungroupBy", "Un-Group by") + " " + ungroupByName,
                        disabled: underlyingColumn != null && this.columnModel.isColumnGroupingLocked(underlyingColumn),
                        action: ()=>this.columnModel.removeRowGroupColumns([
                                showRowGroup
                            ], "contextMenu"),
                        icon: icon
                    };
                }
                return {
                    name: localeTextFunc("ungroupBy", "Un-Group by") + " " + (0, $jIDNV._).escapeString(this.columnModel.getDisplayNameForColumn(column, "header")),
                    disabled: !(column == null ? void 0 : column.isRowGroupActive()) || !(column == null ? void 0 : column.getColDef().enableRowGroup) || this.columnModel.isColumnGroupingLocked(column),
                    action: ()=>this.columnModel.removeRowGroupColumns([
                            column
                        ], "contextMenu"),
                    icon: icon
                };
            case "resetColumns":
                return {
                    name: localeTextFunc("resetColumns", "Reset Columns"),
                    action: ()=>this.columnModel.resetColumnState("contextMenu")
                };
            case "expandAll":
                return {
                    name: localeTextFunc("expandAll", "Expand All Row Groups"),
                    action: ()=>this.gridApi.expandAll()
                };
            case "contractAll":
                return {
                    name: localeTextFunc("collapseAll", "Collapse All Row Groups"),
                    action: ()=>this.gridApi.collapseAll()
                };
            case "copy":
                if ((0, $jIDNV.ModuleRegistry).__assertRegistered((0, $jIDNV.ModuleNames).ClipboardModule, "Copy from Menu", this.context.getGridId())) return {
                    name: localeTextFunc("copy", "Copy"),
                    shortcut: localeTextFunc("ctrlC", "Ctrl+C"),
                    icon: (0, $jIDNV._).createIconNoSpan("clipboardCopy", this.gos, null),
                    action: ()=>this.clipboardService.copyToClipboard()
                };
                else return null;
            case "copyWithHeaders":
                if ((0, $jIDNV.ModuleRegistry).__assertRegistered((0, $jIDNV.ModuleNames).ClipboardModule, "Copy with Headers from Menu", this.context.getGridId())) return {
                    name: localeTextFunc("copyWithHeaders", "Copy with Headers"),
                    // shortcut: localeTextFunc('ctrlC','Ctrl+C'),
                    icon: (0, $jIDNV._).createIconNoSpan("clipboardCopy", this.gos, null),
                    action: ()=>this.clipboardService.copyToClipboard({
                            includeHeaders: true
                        })
                };
                else return null;
            case "copyWithGroupHeaders":
                if ((0, $jIDNV.ModuleRegistry).__assertRegistered((0, $jIDNV.ModuleNames).ClipboardModule, "Copy with Group Headers from Menu", this.context.getGridId())) return {
                    name: localeTextFunc("copyWithGroupHeaders", "Copy with Group Headers"),
                    // shortcut: localeTextFunc('ctrlC','Ctrl+C'),
                    icon: (0, $jIDNV._).createIconNoSpan("clipboardCopy", this.gos, null),
                    action: ()=>this.clipboardService.copyToClipboard({
                            includeHeaders: true,
                            includeGroupHeaders: true
                        })
                };
                else return null;
            case "cut":
                if ((0, $jIDNV.ModuleRegistry).__assertRegistered((0, $jIDNV.ModuleNames).ClipboardModule, "Cut from Menu", this.context.getGridId())) {
                    const focusedCell = this.focusService.getFocusedCell();
                    const rowNode = focusedCell ? this.rowPositionUtils.getRowNode(focusedCell) : null;
                    const isEditable = rowNode ? focusedCell == null ? void 0 : focusedCell.column.isCellEditable(rowNode) : false;
                    return {
                        name: localeTextFunc("cut", "Cut"),
                        shortcut: localeTextFunc("ctrlX", "Ctrl+X"),
                        icon: (0, $jIDNV._).createIconNoSpan("clipboardCut", this.gos, null),
                        disabled: !isEditable || this.gos.get("suppressCutToClipboard"),
                        action: ()=>this.clipboardService.cutToClipboard(void 0, "contextMenu")
                    };
                } else return null;
            case "paste":
                if ((0, $jIDNV.ModuleRegistry).__assertRegistered((0, $jIDNV.ModuleNames).ClipboardModule, "Paste from Clipboard", this.context.getGridId())) return {
                    name: localeTextFunc("paste", "Paste"),
                    shortcut: localeTextFunc("ctrlV", "Ctrl+V"),
                    disabled: true,
                    icon: (0, $jIDNV._).createIconNoSpan("clipboardPaste", this.gos, null),
                    action: ()=>this.clipboardService.pasteFromClipboard()
                };
                else return null;
            case "export":
                const exportSubMenuItems = [];
                const csvModuleLoaded = (0, $jIDNV.ModuleRegistry).__isRegistered((0, $jIDNV.ModuleNames).CsvExportModule, this.context.getGridId());
                const excelModuleLoaded = (0, $jIDNV.ModuleRegistry).__isRegistered((0, $jIDNV.ModuleNames).ExcelExportModule, this.context.getGridId());
                if (!this.gos.get("suppressCsvExport") && csvModuleLoaded) exportSubMenuItems.push("csvExport");
                if (!this.gos.get("suppressExcelExport") && excelModuleLoaded) exportSubMenuItems.push("excelExport");
                return {
                    name: localeTextFunc("export", "Export"),
                    subMenu: exportSubMenuItems,
                    icon: (0, $jIDNV._).createIconNoSpan("save", this.gos, null)
                };
            case "csvExport":
                return {
                    name: localeTextFunc("csvExport", "CSV Export"),
                    icon: (0, $jIDNV._).createIconNoSpan("csvExport", this.gos, null),
                    action: ()=>this.gridApi.exportDataAsCsv({})
                };
            case "excelExport":
                return {
                    name: localeTextFunc("excelExport", "Excel Export"),
                    icon: (0, $jIDNV._).createIconNoSpan("excelExport", this.gos, null),
                    action: ()=>this.gridApi.exportDataAsExcel()
                };
            case "separator":
                return "separator";
            case "pivotChart":
            case "chartRange":
                return (_a = this.chartMenuItemMapper.getChartItems(key)) != null ? _a : null;
            case "columnFilter":
                if (column) return {
                    name: localeTextFunc("columnFilter", "Column Filter"),
                    icon: (0, $jIDNV._).createIconNoSpan("filter", this.gos, null),
                    action: ()=>this.menuService.showFilterMenu({
                            column: column,
                            buttonElement: sourceElement(),
                            containerType: "columnFilter",
                            positionBy: "button"
                        })
                };
                else return null;
            case "columnChooser":
                if ((0, $jIDNV.ModuleRegistry).__isRegistered((0, $jIDNV.ModuleNames).ColumnsToolPanelModule, this.context.getGridId())) return {
                    name: localeTextFunc("columnChooser", "Choose Columns"),
                    icon: (0, $jIDNV._).createIconNoSpan("columns", this.gos, null),
                    action: ()=>this.menuService.showColumnChooser({
                            column: column,
                            eventSource: sourceElement()
                        })
                };
                else return null;
            case "sortAscending":
                return {
                    name: localeTextFunc("sortAscending", "Sort Ascending"),
                    icon: (0, $jIDNV._).createIconNoSpan("sortAscending", this.gos, null),
                    action: ()=>this.sortController.setSortForColumn(column, "asc", false, "columnMenu")
                };
            case "sortDescending":
                return {
                    name: localeTextFunc("sortDescending", "Sort Descending"),
                    icon: (0, $jIDNV._).createIconNoSpan("sortDescending", this.gos, null),
                    action: ()=>this.sortController.setSortForColumn(column, "desc", false, "columnMenu")
                };
            case "sortUnSort":
                return {
                    name: localeTextFunc("sortUnSort", "Clear Sort"),
                    icon: (0, $jIDNV._).createIconNoSpan("sortUnSort", this.gos, null),
                    action: ()=>this.sortController.setSortForColumn(column, null, false, "columnMenu")
                };
            default:
                console.warn(`AG Grid: unknown menu item type ${key}`);
                return null;
        }
    }
    createAggregationSubMenu(column, aggFuncService) {
        const localeTextFunc = this.localeService.getLocaleTextFunc();
        let columnToUse;
        if (column.isPrimary()) columnToUse = column;
        else {
            const pivotValueColumn = column.getColDef().pivotValueColumn;
            columnToUse = (0, $jIDNV._).exists(pivotValueColumn) ? pivotValueColumn : void 0;
        }
        const result = [];
        if (columnToUse) {
            const columnIsAlreadyAggValue = columnToUse.isValueActive();
            const funcNames = aggFuncService.getFuncNames(columnToUse);
            result.push({
                name: localeTextFunc("noAggregation", "None"),
                action: ()=>{
                    this.columnModel.removeValueColumns([
                        columnToUse
                    ], "contextMenu");
                    this.columnModel.setColumnAggFunc(columnToUse, void 0, "contextMenu");
                },
                checked: !columnIsAlreadyAggValue
            });
            funcNames.forEach((funcName)=>{
                result.push({
                    name: localeTextFunc(funcName, aggFuncService.getDefaultFuncLabel(funcName)),
                    action: ()=>{
                        this.columnModel.setColumnAggFunc(columnToUse, funcName, "contextMenu");
                        this.columnModel.addValueColumns([
                            columnToUse
                        ], "contextMenu");
                    },
                    checked: columnIsAlreadyAggValue && columnToUse.getAggFunc() === funcName
                });
            });
        }
        return result;
    }
};
$5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$MenuItemMapper.prototype, "columnModel", 2);
$5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Autowired)("gridApi")
], $5b7ccabde48fae90$var$MenuItemMapper.prototype, "gridApi", 2);
$5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Autowired)("focusService")
], $5b7ccabde48fae90$var$MenuItemMapper.prototype, "focusService", 2);
$5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Autowired)("rowPositionUtils")
], $5b7ccabde48fae90$var$MenuItemMapper.prototype, "rowPositionUtils", 2);
$5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Autowired)("chartMenuItemMapper")
], $5b7ccabde48fae90$var$MenuItemMapper.prototype, "chartMenuItemMapper", 2);
$5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Autowired)("menuService")
], $5b7ccabde48fae90$var$MenuItemMapper.prototype, "menuService", 2);
$5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Autowired)("sortController")
], $5b7ccabde48fae90$var$MenuItemMapper.prototype, "sortController", 2);
$5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Optional)("clipboardService")
], $5b7ccabde48fae90$var$MenuItemMapper.prototype, "clipboardService", 2);
$5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Optional)("aggFuncService")
], $5b7ccabde48fae90$var$MenuItemMapper.prototype, "aggFuncService", 2);
$5b7ccabde48fae90$var$MenuItemMapper = $5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Bean)("menuItemMapper")
], $5b7ccabde48fae90$var$MenuItemMapper);
var $5b7ccabde48fae90$var$VERSION12 = "31.3.4";
var $5b7ccabde48fae90$var$ChartMenuItemMapper = class extends (0, $jIDNV.BeanStub) {
    getChartItems(key) {
        var _a, _b;
        if (!this.chartService) {
            (0, $jIDNV.ModuleRegistry).__assertRegistered((0, $jIDNV.ModuleNames).GridChartsModule, `the Context Menu key "${key}"`, this.context.getGridId());
            return void 0;
        }
        const builder = key === "pivotChart" ? new $5b7ccabde48fae90$var$PivotMenuItemMapper(this.gos, this.chartService, this.localeService) : new $5b7ccabde48fae90$var$RangeMenuItemMapper(this.gos, this.chartService, this.localeService);
        const isEnterprise = this.chartService.isEnterprise();
        let topLevelMenuItem = builder.getMenuItem();
        if (topLevelMenuItem && topLevelMenuItem.subMenu && !isEnterprise) {
            const filterEnterpriseItems = (m)=>{
                var _a2;
                return $5b7ccabde48fae90$var$__spreadProps7($5b7ccabde48fae90$var$__spreadValues10({}, m), {
                    subMenu: (_a2 = m.subMenu) == null ? void 0 : _a2.filter((menu)=>!menu._enterprise).map((menu)=>filterEnterpriseItems(menu))
                });
            };
            topLevelMenuItem = filterEnterpriseItems(topLevelMenuItem);
        }
        const chartGroupsDef = (_b = (_a = this.gos.get("chartToolPanelsDef")) == null ? void 0 : _a.settingsPanel) == null ? void 0 : _b.chartGroupsDef;
        if (chartGroupsDef) topLevelMenuItem = $5b7ccabde48fae90$var$ChartMenuItemMapper.filterAndOrderChartMenu(topLevelMenuItem, chartGroupsDef, builder.getConfigLookup());
        return this.cleanInternals(topLevelMenuItem);
    }
    // Remove our internal _key and _enterprise properties so this does not leak out of the class on the menu items.
    cleanInternals(menuItem) {
        if (!menuItem) return menuItem;
        const removeKeys = (m)=>{
            var _a;
            m == null || delete m._key;
            m == null || delete m._enterprise;
            (_a = m == null ? void 0 : m.subMenu) == null || _a.forEach((s)=>removeKeys(s));
            return m;
        };
        return removeKeys(menuItem);
    }
    static buildLookup(menuItem) {
        let itemLookup = {};
        const addItem = (item)=>{
            itemLookup[item._key] = item;
            if (item.subMenu) item.subMenu.forEach((s)=>addItem(s));
        };
        addItem(menuItem);
        return itemLookup;
    }
    /**
   * Make the MenuItem match the charts provided and their ordering on the ChartGroupsDef config object as provided by the user.
   */ static filterAndOrderChartMenu(topLevelMenuItem, chartGroupsDef, configLookup) {
        var _a;
        const menuItemLookup = this.buildLookup(topLevelMenuItem);
        let orderedAndFiltered = $5b7ccabde48fae90$var$__spreadProps7($5b7ccabde48fae90$var$__spreadValues10({}, topLevelMenuItem), {
            subMenu: []
        });
        Object.entries(chartGroupsDef).forEach(([group, chartTypes])=>{
            var _a2, _b;
            const chartConfigGroup = configLookup[group];
            if (chartConfigGroup === null) return;
            if (chartConfigGroup == void 0) {
                (0, $jIDNV._).warnOnce(`invalid chartGroupsDef config '${group}'`);
                return void 0;
            }
            const menuItem = menuItemLookup[chartConfigGroup._key];
            if (menuItem) {
                if (menuItem.subMenu) {
                    const subMenus = chartTypes.map((chartType)=>{
                        const itemKey = chartConfigGroup[chartType];
                        if (itemKey == void 0) {
                            (0, $jIDNV._).warnOnce(`invalid chartGroupsDef config '${group}.${chartType}'`);
                            return void 0;
                        }
                        return menuItemLookup[itemKey];
                    }).filter((s)=>s !== void 0);
                    if (subMenus.length > 0) {
                        menuItem.subMenu = subMenus;
                        (_a2 = orderedAndFiltered.subMenu) == null || _a2.push(menuItem);
                    }
                } else (_b = orderedAndFiltered.subMenu) == null || _b.push(menuItem);
            }
        });
        if (((_a = orderedAndFiltered.subMenu) == null ? void 0 : _a.length) == 0) return void 0;
        return orderedAndFiltered;
    }
};
$5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Optional)("chartService")
], $5b7ccabde48fae90$var$ChartMenuItemMapper.prototype, "chartService", 2);
$5b7ccabde48fae90$var$ChartMenuItemMapper = $5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Bean)("chartMenuItemMapper")
], $5b7ccabde48fae90$var$ChartMenuItemMapper);
var $5b7ccabde48fae90$var$PivotMenuItemMapper = class {
    constructor(gos, chartService, localeService){
        this.gos = gos;
        this.chartService = chartService;
        this.localeService = localeService;
    }
    getMenuItem() {
        const localeTextFunc = this.localeService.getLocaleTextFunc();
        const getMenuItem = (localeKey, defaultText, chartType, key, enterprise = false)=>{
            return {
                name: localeTextFunc(localeKey, defaultText),
                action: ()=>this.chartService.createPivotChart({
                        chartType: chartType
                    }),
                _key: key,
                _enterprise: enterprise
            };
        };
        return {
            name: localeTextFunc("pivotChart", "Pivot Chart"),
            _key: "pivotChart",
            subMenu: [
                {
                    _key: "pivotColumnChart",
                    name: localeTextFunc("columnChart", "Column"),
                    subMenu: [
                        getMenuItem("groupedColumn", "Grouped&lrm;", "groupedColumn", "pivotGroupedColumn"),
                        getMenuItem("stackedColumn", "Stacked&lrm;", "stackedColumn", "pivotStackedColumn"),
                        getMenuItem("normalizedColumn", "100% Stacked&lrm;", "normalizedColumn", "pivotNormalizedColumn")
                    ]
                },
                {
                    _key: "pivotBarChart",
                    name: localeTextFunc("barChart", "Bar"),
                    subMenu: [
                        getMenuItem("groupedBar", "Grouped&lrm;", "groupedBar", "pivotGroupedBar"),
                        getMenuItem("stackedBar", "Stacked&lrm;", "stackedBar", "pivotStackedBar"),
                        getMenuItem("normalizedBar", "100% Stacked&lrm;", "normalizedBar", "pivotNormalizedBar")
                    ]
                },
                {
                    _key: "pivotPieChart",
                    name: localeTextFunc("pieChart", "Pie"),
                    subMenu: [
                        getMenuItem("pie", "Pie&lrm;", "pie", "pivotPie"),
                        getMenuItem("donut", "Donut&lrm;", "donut", "pivotDonut")
                    ]
                },
                getMenuItem("line", "Line&lrm;", "line", "pivotLineChart"),
                {
                    _key: "pivotXYChart",
                    name: localeTextFunc("xyChart", "X Y (Scatter)"),
                    subMenu: [
                        getMenuItem("scatter", "Scatter&lrm;", "scatter", "pivotScatter"),
                        getMenuItem("bubble", "Bubble&lrm;", "bubble", "pivotBubble")
                    ]
                },
                {
                    _key: "pivotAreaChart",
                    name: localeTextFunc("areaChart", "Area"),
                    subMenu: [
                        getMenuItem("area", "Area&lrm;", "area", "pivotArea"),
                        getMenuItem("stackedArea", "Stacked&lrm;", "stackedArea", "pivotStackedArea"),
                        getMenuItem("normalizedArea", "100% Stacked&lrm;", "normalizedArea", "pivotNormalizedArea")
                    ]
                },
                {
                    _key: "pivotStatisticalChart",
                    _enterprise: false,
                    // histogram chart is available in both community and enterprise distributions
                    name: localeTextFunc("statisticalChart", "Statistical"),
                    subMenu: [
                        getMenuItem("histogramChart", "Histogram&lrm;", "histogram", "pivotHistogram", false)
                    ]
                },
                {
                    _key: "pivotHierarchicalChart",
                    _enterprise: true,
                    name: localeTextFunc("hierarchicalChart", "Hierarchical"),
                    subMenu: [
                        getMenuItem("treemapChart", "Treemap&lrm;", "treemap", "pivotTreemap", true),
                        getMenuItem("sunburstChart", "Sunburst&lrm;", "sunburst", "pivotSunburst", true)
                    ]
                },
                {
                    _key: "pivotCombinationChart",
                    name: localeTextFunc("combinationChart", "Combination"),
                    subMenu: [
                        getMenuItem("columnLineCombo", "Column & Line&lrm;", "columnLineCombo", "pivotColumnLineCombo"),
                        getMenuItem("AreaColumnCombo", "Area & Column&lrm;", "areaColumnCombo", "pivotAreaColumnCombo")
                    ]
                }
            ],
            icon: (0, $jIDNV._).createIconNoSpan("chart", this.gos, void 0)
        };
    }
    getConfigLookup() {
        return {
            columnGroup: {
                _key: "pivotColumnChart",
                column: "pivotGroupedColumn",
                stackedColumn: "pivotStackedColumn",
                normalizedColumn: "pivotNormalizedColumn"
            },
            barGroup: {
                _key: "pivotBarChart",
                bar: "pivotGroupedBar",
                stackedBar: "pivotStackedBar",
                normalizedBar: "pivotNormalizedBar"
            },
            pieGroup: {
                _key: "pivotPieChart",
                pie: "pivotPie",
                donut: "pivotDonut",
                doughnut: "pivotDonut"
            },
            lineGroup: {
                _key: "pivotLineChart",
                line: "pivotLineChart"
            },
            scatterGroup: {
                _key: "pivotXYChart",
                bubble: "pivotBubble",
                scatter: "pivotScatter"
            },
            areaGroup: {
                _key: "pivotAreaChart",
                area: "pivotArea",
                stackedArea: "pivotStackedArea",
                normalizedArea: "pivotNormalizedArea"
            },
            combinationGroup: {
                _key: "pivotCombinationChart",
                columnLineCombo: "pivotColumnLineCombo",
                areaColumnCombo: "pivotAreaColumnCombo",
                customCombo: null
            },
            hierarchicalGroup: {
                _key: "pivotHierarchicalChart",
                treemap: "pivotTreemap",
                sunburst: "pivotSunburst"
            },
            statisticalGroup: {
                _key: "pivotStatisticalChart",
                histogram: "pivotHistogram",
                // Some statistical charts do not currently support pivot mode
                rangeBar: null,
                rangeArea: null,
                boxPlot: null
            },
            // Polar charts do not support pivot mode
            polarGroup: null,
            // Specialized charts do not currently support pivot mode
            specializedGroup: null
        };
    }
};
var $5b7ccabde48fae90$var$RangeMenuItemMapper = class {
    constructor(gos, chartService, localeService){
        this.gos = gos;
        this.chartService = chartService;
        this.localeService = localeService;
    }
    getMenuItem() {
        const localeTextFunc = this.localeService.getLocaleTextFunc();
        const getMenuItem = (localeKey, defaultText, chartType, key, enterprise = false)=>{
            return {
                name: localeTextFunc(localeKey, defaultText),
                action: ()=>this.chartService.createChartFromCurrentRange(chartType),
                _key: key,
                _enterprise: enterprise
            };
        };
        return {
            name: localeTextFunc("chartRange", "Chart Range"),
            _key: "chartRange",
            subMenu: [
                {
                    name: localeTextFunc("columnChart", "Column"),
                    subMenu: [
                        getMenuItem("groupedColumn", "Grouped&lrm;", "groupedColumn", "rangeGroupedColumn"),
                        getMenuItem("stackedColumn", "Stacked&lrm;", "stackedColumn", "rangeStackedColumn"),
                        getMenuItem("normalizedColumn", "100% Stacked&lrm;", "normalizedColumn", "rangeNormalizedColumn")
                    ],
                    _key: "rangeColumnChart"
                },
                {
                    name: localeTextFunc("barChart", "Bar"),
                    subMenu: [
                        getMenuItem("groupedBar", "Grouped&lrm;", "groupedBar", "rangeGroupedBar"),
                        getMenuItem("stackedBar", "Stacked&lrm;", "stackedBar", "rangeStackedBar"),
                        getMenuItem("normalizedBar", "100% Stacked&lrm;", "normalizedBar", "rangeNormalizedBar")
                    ],
                    _key: "rangeBarChart"
                },
                {
                    name: localeTextFunc("pieChart", "Pie"),
                    subMenu: [
                        getMenuItem("pie", "Pie&lrm;", "pie", "rangePie"),
                        getMenuItem("donut", "Donut&lrm;", "donut", "rangeDonut")
                    ],
                    _key: "rangePieChart"
                },
                getMenuItem("line", "Line&lrm;", "line", "rangeLineChart"),
                {
                    name: localeTextFunc("xyChart", "X Y (Scatter)"),
                    subMenu: [
                        getMenuItem("scatter", "Scatter&lrm;", "scatter", "rangeScatter"),
                        getMenuItem("bubble", "Bubble&lrm;", "bubble", "rangeBubble")
                    ],
                    _key: "rangeXYChart"
                },
                {
                    name: localeTextFunc("areaChart", "Area"),
                    subMenu: [
                        getMenuItem("area", "Area&lrm;", "area", "rangeArea"),
                        getMenuItem("stackedArea", "Stacked&lrm;", "stackedArea", "rangeStackedArea"),
                        getMenuItem("normalizedArea", "100% Stacked&lrm;", "normalizedArea", "rangeNormalizedArea")
                    ],
                    _key: "rangeAreaChart"
                },
                {
                    name: localeTextFunc("polarChart", "Polar"),
                    subMenu: [
                        getMenuItem("radarLine", "Radar Line&lrm;", "radarLine", "rangeRadarLine"),
                        getMenuItem("radarArea", "Radar Area&lrm;", "radarArea", "rangeRadarArea"),
                        getMenuItem("nightingale", "Nightingale&lrm;", "nightingale", "rangeNightingale"),
                        getMenuItem("radialColumn", "Radial Column&lrm;", "radialColumn", "rangeRadialColumn"),
                        getMenuItem("radialBar", "Radial Bar&lrm;", "radialBar", "rangeRadialBar")
                    ],
                    _key: "rangePolarChart",
                    _enterprise: true
                },
                {
                    name: localeTextFunc("statisticalChart", "Statistical"),
                    subMenu: [
                        getMenuItem("boxPlot", "Box Plot&lrm;", "boxPlot", "rangeBoxPlot", true),
                        getMenuItem("histogramChart", "Histogram&lrm;", "histogram", "rangeHistogram", false),
                        getMenuItem("rangeBar", "Range Bar&lrm;", "rangeBar", "rangeRangeBar", true),
                        getMenuItem("rangeArea", "Range Area&lrm;", "rangeArea", "rangeRangeArea", true)
                    ],
                    _key: "rangeStatisticalChart",
                    _enterprise: false
                },
                {
                    name: localeTextFunc("hierarchicalChart", "Hierarchical"),
                    subMenu: [
                        getMenuItem("treemap", "Treemap&lrm;", "treemap", "rangeTreemap"),
                        getMenuItem("sunburst", "Sunburst&lrm;", "sunburst", "rangeSunburst")
                    ],
                    _key: "rangeHierarchicalChart",
                    _enterprise: true
                },
                {
                    name: localeTextFunc("specializedChart", "Specialized"),
                    subMenu: [
                        getMenuItem("heatmap", "Heatmap&lrm;", "heatmap", "rangeHeatmap"),
                        getMenuItem("waterfall", "Waterfall&lrm;", "waterfall", "rangeWaterfall")
                    ],
                    _key: "rangeSpecializedChart",
                    _enterprise: true
                },
                {
                    name: localeTextFunc("combinationChart", "Combination"),
                    subMenu: [
                        getMenuItem("columnLineCombo", "Column & Line&lrm;", "columnLineCombo", "rangeColumnLineCombo"),
                        getMenuItem("AreaColumnCombo", "Area & Column&lrm;", "areaColumnCombo", "rangeAreaColumnCombo")
                    ],
                    _key: "rangeCombinationChart"
                }
            ],
            icon: (0, $jIDNV._).createIconNoSpan("chart", this.gos, void 0)
        };
    }
    getConfigLookup() {
        return {
            columnGroup: {
                _key: "rangeColumnChart",
                column: "rangeGroupedColumn",
                stackedColumn: "rangeStackedColumn",
                normalizedColumn: "rangeNormalizedColumn"
            },
            barGroup: {
                _key: "rangeBarChart",
                bar: "rangeGroupedBar",
                stackedBar: "rangeStackedBar",
                normalizedBar: "rangeNormalizedBar"
            },
            pieGroup: {
                _key: "rangePieChart",
                pie: "rangePie",
                donut: "rangeDonut",
                doughnut: "rangeDonut"
            },
            lineGroup: {
                _key: "rangeLineChart",
                line: "rangeLineChart"
            },
            scatterGroup: {
                _key: "rangeXYChart",
                bubble: "rangeBubble",
                scatter: "rangeScatter"
            },
            areaGroup: {
                _key: "rangeAreaChart",
                area: "rangeArea",
                stackedArea: "rangeStackedArea",
                normalizedArea: "rangeNormalizedArea"
            },
            polarGroup: {
                _key: "rangePolarChart",
                radarLine: "rangeRadarLine",
                radarArea: "rangeRadarArea",
                nightingale: "rangeNightingale",
                radialColumn: "rangeRadialColumn",
                radialBar: "rangeRadialBar"
            },
            statisticalGroup: {
                _key: "rangeStatisticalChart",
                boxPlot: "rangeBoxPlot",
                histogram: "rangeHistogram",
                rangeBar: "rangeRangeBar",
                rangeArea: "rangeRangeArea"
            },
            hierarchicalGroup: {
                _key: "rangeHierarchicalChart",
                treemap: "rangeTreemap",
                sunburst: "rangeSunburst"
            },
            specializedGroup: {
                _key: "rangeSpecializedChart",
                heatmap: "rangeHeatmap",
                waterfall: "rangeWaterfall"
            },
            combinationGroup: {
                _key: "rangeCombinationChart",
                columnLineCombo: "rangeColumnLineCombo",
                areaColumnCombo: "rangeAreaColumnCombo",
                customCombo: null
            }
        };
    }
};
var $5b7ccabde48fae90$var$ColumnChooserFactory = class extends (0, $jIDNV.BeanStub) {
    createColumnSelectPanel(parent, column, draggable, params) {
        var _a, _b;
        const columnSelectPanel = parent.createManagedBean(new $5b7ccabde48fae90$export$2d9d69c2ece71d89());
        const columnChooserParams = (_b = (_a = params != null ? params : column == null ? void 0 : column.getColDef().columnChooserParams) != null ? _a : column == null ? void 0 : column.getColDef().columnsMenuParams) != null ? _b : {};
        const { contractColumnSelection: contractColumnSelection, suppressColumnExpandAll: suppressColumnExpandAll, suppressColumnFilter: suppressColumnFilter, suppressColumnSelectAll: suppressColumnSelectAll, suppressSyncLayoutWithGrid: suppressSyncLayoutWithGrid, columnLayout: columnLayout } = columnChooserParams;
        columnSelectPanel.init(!!draggable, this.gos.addGridCommonParams({
            suppressColumnMove: false,
            suppressValues: false,
            suppressPivots: false,
            suppressRowGroups: false,
            suppressPivotMode: false,
            contractColumnSelection: !!contractColumnSelection,
            suppressColumnExpandAll: !!suppressColumnExpandAll,
            suppressColumnFilter: !!suppressColumnFilter,
            suppressColumnSelectAll: !!suppressColumnSelectAll,
            suppressSyncLayoutWithGrid: !!columnLayout || !!suppressSyncLayoutWithGrid,
            onStateUpdated: ()=>{}
        }), "columnMenu");
        if (columnLayout) columnSelectPanel.setColumnLayout(columnLayout);
        return columnSelectPanel;
    }
    showColumnChooser({ column: column, chooserParams: chooserParams, eventSource: eventSource }) {
        this.hideActiveColumnChooser();
        const columnSelectPanel = this.createColumnSelectPanel(this, column, true, chooserParams);
        const translate = this.localeService.getLocaleTextFunc();
        const columnIndex = this.columnModel.getAllDisplayedColumns().indexOf(column);
        const headerPosition = column ? this.focusService.getFocusedHeader() : null;
        this.activeColumnChooserDialog = this.createBean(new (0, $jIDNV.AgDialog)({
            title: translate("chooseColumns", "Choose Columns"),
            component: columnSelectPanel,
            width: 300,
            height: 300,
            resizable: true,
            movable: true,
            centered: true,
            closable: true,
            afterGuiAttached: ()=>{
                var _a;
                (_a = this.focusService.findNextFocusableElement(columnSelectPanel.getGui())) == null || _a.focus();
                this.dispatchVisibleChangedEvent(true, column);
            },
            closedCallback: (event)=>{
                const eComp = this.activeColumnChooser.getGui();
                this.destroyBean(this.activeColumnChooser);
                this.activeColumnChooser = void 0;
                this.activeColumnChooserDialog = void 0;
                this.dispatchVisibleChangedEvent(false, column);
                if (column) this.menuUtils.restoreFocusOnClose({
                    column: column,
                    headerPosition: headerPosition,
                    columnIndex: columnIndex,
                    eventSource: eventSource
                }, eComp, event, true);
            }
        }));
        this.activeColumnChooser = columnSelectPanel;
    }
    hideActiveColumnChooser() {
        if (this.activeColumnChooserDialog) this.destroyBean(this.activeColumnChooserDialog);
    }
    dispatchVisibleChangedEvent(visible, column) {
        const event = {
            type: (0, $jIDNV.Events).EVENT_COLUMN_MENU_VISIBLE_CHANGED,
            visible: visible,
            switchingTab: false,
            key: "columnChooser",
            column: column != null ? column : null
        };
        this.eventService.dispatchEvent(event);
    }
};
$5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Autowired)("focusService")
], $5b7ccabde48fae90$var$ColumnChooserFactory.prototype, "focusService", 2);
$5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Autowired)("menuUtils")
], $5b7ccabde48fae90$var$ColumnChooserFactory.prototype, "menuUtils", 2);
$5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$ColumnChooserFactory.prototype, "columnModel", 2);
$5b7ccabde48fae90$var$ColumnChooserFactory = $5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Bean)("columnChooserFactory")
], $5b7ccabde48fae90$var$ColumnChooserFactory);
var $5b7ccabde48fae90$var$ColumnMenuFactory = class extends (0, $jIDNV.BeanStub) {
    createMenu(parent, column, sourceElement) {
        const menuList = parent.createManagedBean(new (0, $jIDNV.AgMenuList)(0, {
            column: column != null ? column : null,
            node: null,
            value: null
        }));
        const menuItems = this.getMenuItems(column);
        const menuItemsMapped = this.menuItemMapper.mapWithStockItems(menuItems, column != null ? column : null, sourceElement);
        menuList.addMenuItems(menuItemsMapped);
        return menuList;
    }
    getMenuItems(column) {
        const defaultItems = this.getDefaultMenuOptions(column);
        let result;
        const columnMainMenuItems = column == null ? void 0 : column.getColDef().mainMenuItems;
        if (Array.isArray(columnMainMenuItems)) result = columnMainMenuItems;
        else if (typeof columnMainMenuItems === "function") result = columnMainMenuItems(this.gos.addGridCommonParams({
            column: column,
            defaultItems: defaultItems
        }));
        else {
            const userFunc = this.gos.getCallback("getMainMenuItems");
            if (userFunc && column) result = userFunc({
                column: column,
                defaultItems: defaultItems
            });
            else result = defaultItems;
        }
        (0, $jIDNV._).removeRepeatsFromArray(result, $5b7ccabde48fae90$var$ColumnMenuFactory.MENU_ITEM_SEPARATOR);
        return result;
    }
    getDefaultMenuOptions(column) {
        const result = [];
        const isLegacyMenuEnabled = this.menuService.isLegacyMenuEnabled();
        if (!column) {
            if (!isLegacyMenuEnabled) result.push("columnChooser");
            result.push("resetColumns");
            return result;
        }
        const allowPinning = !column.getColDef().lockPinned;
        const rowGroupCount = this.columnModel.getRowGroupColumns().length;
        const doingGrouping = rowGroupCount > 0;
        const allowValue = column.isAllowValue();
        const allowRowGroup = column.isAllowRowGroup();
        const isPrimary = column.isPrimary();
        const pivotModeOn = this.columnModel.isPivotMode();
        const isInMemoryRowModel = this.rowModel.getType() === "clientSide";
        const usingTreeData = this.gos.get("treeData");
        const allowValueAgg = // if primary, then only allow aggValue if grouping and it's a value columns
        isPrimary && doingGrouping && allowValue || !isPrimary;
        if (!isLegacyMenuEnabled && column.isSortable()) {
            const sort = column.getSort();
            if (sort !== "asc") result.push("sortAscending");
            if (sort !== "desc") result.push("sortDescending");
            if (sort) result.push("sortUnSort");
            result.push($5b7ccabde48fae90$var$ColumnMenuFactory.MENU_ITEM_SEPARATOR);
        }
        if (this.menuService.isFilterMenuItemEnabled(column)) {
            result.push("columnFilter");
            result.push($5b7ccabde48fae90$var$ColumnMenuFactory.MENU_ITEM_SEPARATOR);
        }
        if (allowPinning) result.push("pinSubMenu");
        if (allowValueAgg) result.push("valueAggSubMenu");
        if (allowPinning || allowValueAgg) result.push($5b7ccabde48fae90$var$ColumnMenuFactory.MENU_ITEM_SEPARATOR);
        result.push("autoSizeThis");
        result.push("autoSizeAll");
        result.push($5b7ccabde48fae90$var$ColumnMenuFactory.MENU_ITEM_SEPARATOR);
        const showRowGroup = column.getColDef().showRowGroup;
        if (showRowGroup) result.push("rowUnGroup");
        else if (allowRowGroup && column.isPrimary()) {
            if (column.isRowGroupActive()) {
                const groupLocked = this.columnModel.isColumnGroupingLocked(column);
                if (!groupLocked) result.push("rowUnGroup");
            } else result.push("rowGroup");
        }
        result.push($5b7ccabde48fae90$var$ColumnMenuFactory.MENU_ITEM_SEPARATOR);
        if (!isLegacyMenuEnabled) result.push("columnChooser");
        result.push("resetColumns");
        const allowExpandAndContract = isInMemoryRowModel && (usingTreeData || rowGroupCount > (pivotModeOn ? 1 : 0));
        if (allowExpandAndContract) {
            result.push("expandAll");
            result.push("contractAll");
        }
        return result;
    }
};
$5b7ccabde48fae90$var$ColumnMenuFactory.MENU_ITEM_SEPARATOR = "separator";
$5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Autowired)("menuItemMapper")
], $5b7ccabde48fae90$var$ColumnMenuFactory.prototype, "menuItemMapper", 2);
$5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$ColumnMenuFactory.prototype, "columnModel", 2);
$5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Autowired)("rowModel")
], $5b7ccabde48fae90$var$ColumnMenuFactory.prototype, "rowModel", 2);
$5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Autowired)("filterManager")
], $5b7ccabde48fae90$var$ColumnMenuFactory.prototype, "filterManager", 2);
$5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Autowired)("menuService")
], $5b7ccabde48fae90$var$ColumnMenuFactory.prototype, "menuService", 2);
$5b7ccabde48fae90$var$ColumnMenuFactory = $5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Bean)("columnMenuFactory")
], $5b7ccabde48fae90$var$ColumnMenuFactory);
var $5b7ccabde48fae90$var$MenuUtils = class extends (0, $jIDNV.BeanStub) {
    restoreFocusOnClose(restoreFocusParams, eComp, e, restoreIfMouseEvent) {
        const { eventSource: eventSource } = restoreFocusParams;
        const isKeyboardEvent = e instanceof KeyboardEvent;
        if (!restoreIfMouseEvent && !isKeyboardEvent || !eventSource) return;
        const eDocument = this.gos.getDocument();
        const activeEl = this.gos.getActiveDomElement();
        if (!eComp.contains(activeEl) && activeEl !== eDocument.body) return;
        this.focusHeaderCell(restoreFocusParams);
    }
    closePopupAndRestoreFocusOnSelect(hidePopupFunc, restoreFocusParams, event) {
        let keyboardEvent;
        if (event && event.keyboardEvent) keyboardEvent = event.keyboardEvent;
        hidePopupFunc(keyboardEvent && {
            keyboardEvent: keyboardEvent
        });
        const focusedCell = this.focusService.getFocusedCell();
        const eDocument = this.gos.getDocument();
        const activeEl = this.gos.getActiveDomElement();
        if (!activeEl || activeEl === eDocument.body) {
            if (focusedCell) {
                const { rowIndex: rowIndex, rowPinned: rowPinned, column: column } = focusedCell;
                this.focusService.setFocusedCell({
                    rowIndex: rowIndex,
                    column: column,
                    rowPinned: rowPinned,
                    forceBrowserFocus: true,
                    preventScrollOnBrowserFocus: true
                });
            } else this.focusHeaderCell(restoreFocusParams);
        }
    }
    onContextMenu(mouseEvent, touchEvent, showMenuCallback) {
        if (!this.gos.get("allowContextMenuWithControlKey")) {
            if (mouseEvent && (mouseEvent.ctrlKey || mouseEvent.metaKey)) return;
        }
        if (mouseEvent) this.blockMiddleClickScrollsIfNeeded(mouseEvent);
        if (this.gos.get("suppressContextMenu")) return;
        const eventOrTouch = mouseEvent != null ? mouseEvent : touchEvent.touches[0];
        if (showMenuCallback(eventOrTouch)) {
            const event = mouseEvent != null ? mouseEvent : touchEvent;
            if (event && event.cancelable) event.preventDefault();
        }
    }
    focusHeaderCell(restoreFocusParams) {
        const { column: column, columnIndex: columnIndex, headerPosition: headerPosition, eventSource: eventSource } = restoreFocusParams;
        const isColumnStillVisible = this.columnModel.getAllDisplayedColumns().some((col)=>col === column);
        if (isColumnStillVisible && eventSource && (0, $jIDNV._).isVisible(eventSource)) {
            const focusableEl = this.focusService.findTabbableParent(eventSource);
            if (focusableEl) {
                if (column) this.headerNavigationService.scrollToColumn(column);
                focusableEl.focus();
            }
        } else if (headerPosition && columnIndex !== -1) {
            const allColumns = this.columnModel.getAllDisplayedColumns();
            const columnToFocus = allColumns[columnIndex] || (0, $jIDNV._).last(allColumns);
            if (columnToFocus) this.focusService.focusHeaderPosition({
                headerPosition: {
                    headerRowIndex: headerPosition.headerRowIndex,
                    column: columnToFocus
                }
            });
        }
    }
    blockMiddleClickScrollsIfNeeded(mouseEvent) {
        if (this.gos.get("suppressMiddleClickScrolls") && mouseEvent.which === 2) mouseEvent.preventDefault();
    }
};
$5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Autowired)("focusService")
], $5b7ccabde48fae90$var$MenuUtils.prototype, "focusService", 2);
$5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Autowired)("headerNavigationService")
], $5b7ccabde48fae90$var$MenuUtils.prototype, "headerNavigationService", 2);
$5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$MenuUtils.prototype, "columnModel", 2);
$5b7ccabde48fae90$var$MenuUtils = $5b7ccabde48fae90$var$__decorateClass12([
    (0, $jIDNV.Bean)("menuUtils")
], $5b7ccabde48fae90$var$MenuUtils);
var $5b7ccabde48fae90$export$f1ab43fc4c3c5ce0 = {
    version: $5b7ccabde48fae90$var$VERSION12,
    moduleName: (0, $jIDNV.ModuleNames).MenuModule,
    beans: [
        $5b7ccabde48fae90$var$EnterpriseMenuFactory,
        $5b7ccabde48fae90$var$ContextMenuFactory,
        $5b7ccabde48fae90$var$MenuItemMapper,
        $5b7ccabde48fae90$var$ChartMenuItemMapper,
        $5b7ccabde48fae90$var$ColumnChooserFactory,
        $5b7ccabde48fae90$var$ColumnMenuFactory,
        $5b7ccabde48fae90$var$MenuUtils
    ],
    dependantModules: [
        $5b7ccabde48fae90$export$3a6d13add8617801
    ]
};
var $5b7ccabde48fae90$var$__defProp13 = Object.defineProperty;
var $5b7ccabde48fae90$var$__defProps8 = Object.defineProperties;
var $5b7ccabde48fae90$var$__getOwnPropDesc13 = Object.getOwnPropertyDescriptor;
var $5b7ccabde48fae90$var$__getOwnPropDescs8 = Object.getOwnPropertyDescriptors;
var $5b7ccabde48fae90$var$__getOwnPropSymbols11 = Object.getOwnPropertySymbols;
var $5b7ccabde48fae90$var$__hasOwnProp12 = Object.prototype.hasOwnProperty;
var $5b7ccabde48fae90$var$__propIsEnum11 = Object.prototype.propertyIsEnumerable;
var $5b7ccabde48fae90$var$__defNormalProp11 = (obj, key, value)=>key in obj ? $5b7ccabde48fae90$var$__defProp13(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5b7ccabde48fae90$var$__spreadValues11 = (a, b)=>{
    for(var prop in b || (b = {}))if ($5b7ccabde48fae90$var$__hasOwnProp12.call(b, prop)) $5b7ccabde48fae90$var$__defNormalProp11(a, prop, b[prop]);
    if ($5b7ccabde48fae90$var$__getOwnPropSymbols11) {
        for (var prop of $5b7ccabde48fae90$var$__getOwnPropSymbols11(b))if ($5b7ccabde48fae90$var$__propIsEnum11.call(b, prop)) $5b7ccabde48fae90$var$__defNormalProp11(a, prop, b[prop]);
    }
    return a;
};
var $5b7ccabde48fae90$var$__spreadProps8 = (a, b)=>$5b7ccabde48fae90$var$__defProps8(a, $5b7ccabde48fae90$var$__getOwnPropDescs8(b));
var $5b7ccabde48fae90$var$__decorateClass13 = (decorators, target, key, kind)=>{
    var result = kind > 1 ? void 0 : kind ? $5b7ccabde48fae90$var$__getOwnPropDesc13(target, key) : target;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
    if (kind && result) $5b7ccabde48fae90$var$__defProp13(target, key, result);
    return result;
};
var $5b7ccabde48fae90$var$_MultiFilter = class _MultiFilter2 extends (0, $jIDNV.TabGuardComp) {
    constructor(){
        super(/* html */ `<div class="ag-multi-filter ag-menu-list-compact"></div>`);
        this.filterDefs = [];
        this.filters = [];
        this.guiDestroyFuncs = [];
        this.filterGuis = [];
        this.activeFilterIndices = [];
        this.lastActivatedMenuItem = null;
        this.afterFiltersReadyFuncs = [];
    }
    postConstruct() {
        this.initialiseTabGuard({
            onFocusIn: (e)=>this.onFocusIn(e)
        });
    }
    static getFilterDefs(params) {
        const { filters: filters } = params;
        return filters && filters.length > 0 ? filters : [
            {
                filter: "agTextColumnFilter"
            },
            {
                filter: "agSetColumnFilter"
            }
        ];
    }
    init(params) {
        this.params = params;
        this.filterDefs = _MultiFilter2.getFilterDefs(params);
        const { column: column, filterChangedCallback: filterChangedCallback } = params;
        this.column = column;
        this.filterChangedCallback = filterChangedCallback;
        const filterPromises = [];
        this.filterDefs.forEach((filterDef, index)=>{
            const filterPromise = this.createFilter(filterDef, index);
            if (filterPromise != null) filterPromises.push(filterPromise);
        });
        return new (0, $jIDNV.AgPromise)((resolve)=>{
            (0, $jIDNV.AgPromise).all(filterPromises).then((filters)=>{
                this.filters = filters;
                this.refreshGui("columnMenu").then(()=>{
                    resolve();
                });
            });
        }).then(()=>{
            this.afterFiltersReadyFuncs.forEach((f)=>f());
            this.afterFiltersReadyFuncs.length = 0;
        });
    }
    refreshGui(container) {
        if (container === this.lastOpenedInContainer) return (0, $jIDNV.AgPromise).resolve();
        this.removeAllChildrenExceptTabGuards();
        this.destroyChildren();
        return (0, $jIDNV.AgPromise).all(this.filters.map((filter, index)=>{
            const filterDef = this.filterDefs[index];
            const filterTitle = this.getFilterTitle(filter, filterDef);
            let filterGuiPromise;
            if (filterDef.display === "subMenu" && container !== "toolPanel") filterGuiPromise = this.insertFilterMenu(filter, filterTitle).then((menuItem)=>menuItem.getGui());
            else if (filterDef.display === "subMenu" || filterDef.display === "accordion") {
                const group = this.insertFilterGroup(filter, filterTitle);
                filterGuiPromise = (0, $jIDNV.AgPromise).resolve(group.getGui());
            } else filterGuiPromise = (0, $jIDNV.AgPromise).resolve(filter.getGui());
            return filterGuiPromise;
        })).then((filterGuis)=>{
            filterGuis.forEach((filterGui, index)=>{
                if (index > 0) this.appendChild((0, $jIDNV._).loadTemplate(/* html */ `<div class="ag-filter-separator"></div>`));
                this.appendChild(filterGui);
            });
            this.filterGuis = filterGuis;
            this.lastOpenedInContainer = container;
        });
    }
    getFilterTitle(filter, filterDef) {
        if (filterDef.title != null) return filterDef.title;
        return filter instanceof (0, $jIDNV.ProvidedFilter) ? filter.getFilterTitle() : "Filter";
    }
    destroyChildren() {
        this.guiDestroyFuncs.forEach((func)=>func());
        this.guiDestroyFuncs.length = 0;
        this.filterGuis.length = 0;
    }
    insertFilterMenu(filter, name) {
        const menuItem = this.createBean(new (0, $jIDNV.AgMenuItemComponent)());
        return menuItem.init({
            menuItemDef: {
                name: name,
                subMenu: [],
                cssClasses: [
                    "ag-multi-filter-menu-item"
                ],
                menuItem: (0, $jIDNV.AgMenuItemRenderer),
                menuItemParams: {
                    cssClassPrefix: "ag-compact-menu-option",
                    isCompact: true
                }
            },
            level: 0,
            isAnotherSubMenuOpen: ()=>false,
            childComponent: filter,
            contextParams: {
                column: null,
                node: null,
                value: null
            }
        }).then(()=>{
            menuItem.setParentComponent(this);
            this.guiDestroyFuncs.push(()=>this.destroyBean(menuItem));
            this.addManagedListener(menuItem, (0, $jIDNV.AgMenuItemComponent).EVENT_MENU_ITEM_ACTIVATED, (event)=>{
                if (this.lastActivatedMenuItem && this.lastActivatedMenuItem !== event.menuItem) this.lastActivatedMenuItem.deactivate();
                this.lastActivatedMenuItem = event.menuItem;
            });
            const menuItemGui = menuItem.getGui();
            menuItem.addManagedListener(menuItemGui, "keydown", (e)=>{
                const { key: key } = e;
                switch(key){
                    case (0, $jIDNV.KeyCode).UP:
                    case (0, $jIDNV.KeyCode).RIGHT:
                    case (0, $jIDNV.KeyCode).DOWN:
                    case (0, $jIDNV.KeyCode).LEFT:
                        e.preventDefault();
                        if (key === (0, $jIDNV.KeyCode).RIGHT) menuItem.openSubMenu(true);
                        break;
                }
            });
            menuItem.addManagedListener(menuItemGui, "focusin", ()=>menuItem.activate());
            menuItem.addManagedListener(menuItemGui, "focusout", ()=>{
                if (!menuItem.isSubMenuOpen() && !menuItem.isSubMenuOpening()) menuItem.deactivate();
            });
            return menuItem;
        });
    }
    insertFilterGroup(filter, title) {
        const group = this.createBean(new (0, $jIDNV.AgGroupComponent)({
            title: title,
            cssIdentifier: "multi-filter"
        }));
        this.guiDestroyFuncs.push(()=>this.destroyBean(group));
        group.addItem(filter.getGui());
        group.toggleGroupExpand(false);
        if (filter.afterGuiAttached) group.addManagedListener(group, (0, $jIDNV.AgGroupComponent).EVENT_EXPANDED, ()=>filter.afterGuiAttached({
                container: this.lastOpenedInContainer,
                suppressFocus: true,
                hidePopup: this.hidePopup
            }));
        return group;
    }
    isFilterActive() {
        return this.filters.some((filter)=>filter.isFilterActive());
    }
    getLastActiveFilterIndex() {
        return this.activeFilterIndices.length > 0 ? this.activeFilterIndices[this.activeFilterIndices.length - 1] : null;
    }
    doesFilterPass(params, filterToSkip) {
        let rowPasses = true;
        this.filters.forEach((filter)=>{
            if (!rowPasses || filter === filterToSkip || !filter.isFilterActive()) return;
            rowPasses = filter.doesFilterPass(params);
        });
        return rowPasses;
    }
    getFilterType() {
        return "multi";
    }
    getModelFromUi() {
        const model = {
            filterType: this.getFilterType(),
            filterModels: this.filters.map((filter)=>{
                const providedFilter = filter;
                if (typeof providedFilter.getModelFromUi === "function") return providedFilter.getModelFromUi();
                return null;
            })
        };
        return model;
    }
    getModel() {
        if (!this.isFilterActive()) return null;
        const model = {
            filterType: this.getFilterType(),
            filterModels: this.filters.map((filter)=>{
                if (filter.isFilterActive()) return filter.getModel();
                return null;
            })
        };
        return model;
    }
    setModel(model) {
        const setFilterModel = (filter, filterModel)=>{
            return new (0, $jIDNV.AgPromise)((resolve)=>{
                const promise = filter.setModel(filterModel);
                promise ? promise.then(()=>resolve()) : resolve();
            });
        };
        let promises = [];
        if (model == null) promises = this.filters.map((filter, index)=>{
            const res = setFilterModel(filter, null).then(()=>{
                this.updateActiveList(index);
            });
            return res;
        });
        else this.filters.forEach((filter, index)=>{
            const filterModel = model.filterModels.length > index ? model.filterModels[index] : null;
            const res = setFilterModel(filter, filterModel).then(()=>{
                this.updateActiveList(index);
            });
            promises.push(res);
        });
        return (0, $jIDNV.AgPromise).all(promises).then(()=>{});
    }
    applyModel(source = "api") {
        let result = false;
        this.filters.forEach((filter)=>{
            if (filter instanceof (0, $jIDNV.ProvidedFilter)) result = filter.applyModel(source) || result;
        });
        return result;
    }
    getChildFilterInstance(index) {
        return this.filters[index];
    }
    afterGuiAttached(params) {
        let refreshPromise;
        if (params) {
            this.hidePopup = params.hidePopup;
            refreshPromise = this.refreshGui(params.container);
        } else {
            this.hidePopup = void 0;
            refreshPromise = (0, $jIDNV.AgPromise).resolve();
        }
        refreshPromise.then(()=>{
            const { filterDefs: filterDefs } = this;
            let hasFocused = false;
            if (filterDefs) (0, $jIDNV._).forEachReverse(filterDefs, (filterDef, index)=>{
                var _a;
                const isFirst = index === 0;
                const suppressFocus = !isFirst || filterDef.display !== "inline";
                const afterGuiAttachedParams = $5b7ccabde48fae90$var$__spreadProps8($5b7ccabde48fae90$var$__spreadValues11({}, params != null ? params : {}), {
                    suppressFocus: suppressFocus
                });
                const filter = (_a = this.filters) == null ? void 0 : _a[index];
                if (filter) {
                    this.executeFunctionIfExistsOnFilter(filter, "afterGuiAttached", afterGuiAttachedParams);
                    if (isFirst) hasFocused = true;
                }
                if (isFirst && suppressFocus) {
                    const filterGui = this.filterGuis[index];
                    if (filterGui) {
                        filterGui.focus();
                        hasFocused = true;
                    }
                }
            });
            const eDocument = this.gos.getDocument();
            const activeEl = this.gos.getActiveDomElement();
            if (!hasFocused && (!activeEl || activeEl === eDocument.body || this.getGui().contains(activeEl))) this.forceFocusOutOfContainer(true);
        });
    }
    afterGuiDetached() {
        this.executeFunctionIfExists("afterGuiDetached");
    }
    onAnyFilterChanged() {
        this.executeFunctionIfExists("onAnyFilterChanged");
    }
    onNewRowsLoaded() {
        this.executeFunctionIfExists("onNewRowsLoaded");
    }
    destroy() {
        this.filters.forEach((filter)=>this.destroyBean(filter));
        this.filters.length = 0;
        this.destroyChildren();
        this.hidePopup = void 0;
        super.destroy();
    }
    executeFunctionIfExists(name, ...params) {
        (0, $jIDNV._).forEachReverse(this.filters, (filter)=>{
            this.executeFunctionIfExistsOnFilter(filter, name, params);
        });
    }
    executeFunctionIfExistsOnFilter(filter, name, ...params) {
        const func = filter[name];
        if (typeof func === "function") func.apply(filter, params);
    }
    createFilter(filterDef, index) {
        const { filterModifiedCallback: filterModifiedCallback, doesRowPassOtherFilter: doesRowPassOtherFilter } = this.params;
        let filterInstance;
        const filterParams = $5b7ccabde48fae90$var$__spreadProps8($5b7ccabde48fae90$var$__spreadValues11({}, this.filterManager.createFilterParams(this.column, this.column.getColDef())), {
            filterModifiedCallback: filterModifiedCallback,
            filterChangedCallback: (additionalEventAttributes)=>{
                this.executeWhenAllFiltersReady(()=>this.filterChanged(index, additionalEventAttributes));
            },
            doesRowPassOtherFilter: (node)=>doesRowPassOtherFilter(node) && this.doesFilterPass({
                    node: node,
                    data: node.data
                }, filterInstance)
        });
        const compDetails = this.userComponentFactory.getFilterDetails(filterDef, filterParams, "agTextColumnFilter");
        if (!compDetails) return null;
        const filterPromise = compDetails.newAgStackInstance();
        if (filterPromise) filterPromise.then((filter)=>filterInstance = filter);
        return filterPromise;
    }
    executeWhenAllFiltersReady(action) {
        if (this.filters && this.filters.length > 0) action();
        else this.afterFiltersReadyFuncs.push(action);
    }
    updateActiveList(index) {
        const changedFilter = this.filters[index];
        (0, $jIDNV._).removeFromArray(this.activeFilterIndices, index);
        if (changedFilter.isFilterActive()) this.activeFilterIndices.push(index);
    }
    filterChanged(index, additionalEventAttributes) {
        this.updateActiveList(index);
        this.filterChangedCallback(additionalEventAttributes);
        const changedFilter = this.filters[index];
        this.filters.forEach((filter)=>{
            if (filter === changedFilter) return;
            if (typeof filter.onAnyFilterChanged === "function") filter.onAnyFilterChanged();
        });
    }
    onFocusIn(e) {
        if (this.lastActivatedMenuItem != null && !this.lastActivatedMenuItem.getGui().contains(e.target)) {
            this.lastActivatedMenuItem.deactivate();
            this.lastActivatedMenuItem = null;
        }
    }
    getModelAsString(model) {
        var _a, _b, _c, _d;
        if (!this.filters || !((_a = model == null ? void 0 : model.filterModels) == null ? void 0 : _a.length)) return "";
        const lastActiveIndex = (_b = this.getLastActiveFilterIndex()) != null ? _b : 0;
        const activeFilter = this.filters[lastActiveIndex];
        return (_d = (_c = activeFilter.getModelAsString) == null ? void 0 : _c.call(activeFilter, model.filterModels[lastActiveIndex])) != null ? _d : "";
    }
};
$5b7ccabde48fae90$var$__decorateClass13([
    (0, $jIDNV.Autowired)("filterManager")
], $5b7ccabde48fae90$var$_MultiFilter.prototype, "filterManager", 2);
$5b7ccabde48fae90$var$__decorateClass13([
    (0, $jIDNV.Autowired)("userComponentFactory")
], $5b7ccabde48fae90$var$_MultiFilter.prototype, "userComponentFactory", 2);
$5b7ccabde48fae90$var$__decorateClass13([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_MultiFilter.prototype, "postConstruct", 1);
var $5b7ccabde48fae90$export$ab0841fc22e16fa3 = $5b7ccabde48fae90$var$_MultiFilter;
var $5b7ccabde48fae90$var$MultiFloatingFilterComp = class extends (0, $jIDNV.Component) {
    constructor(){
        super(/* html */ `<div class="ag-multi-floating-filter ag-floating-filter-input"></div>`);
        this.floatingFilters = [];
        this.compDetailsList = [];
    }
    init(params) {
        this.params = params;
        const { compDetailsList: compDetailsList } = this.getCompDetailsList(params);
        return this.setParams(compDetailsList);
    }
    setParams(compDetailsList) {
        const floatingFilterPromises = [];
        compDetailsList.forEach((compDetails)=>{
            const floatingFilterPromise = compDetails == null ? void 0 : compDetails.newAgStackInstance();
            if (floatingFilterPromise != null) {
                this.compDetailsList.push(compDetails);
                floatingFilterPromises.push(floatingFilterPromise);
            }
        });
        return (0, $jIDNV.AgPromise).all(floatingFilterPromises).then((floatingFilters)=>{
            floatingFilters.forEach((floatingFilter, index)=>{
                this.floatingFilters.push(floatingFilter);
                const gui = floatingFilter.getGui();
                this.appendChild(gui);
                if (index > 0) (0, $jIDNV._).setDisplayed(gui, false);
            });
        });
    }
    onParamsUpdated(params) {
        this.refresh(params);
    }
    refresh(params) {
        this.params = params;
        const { compDetailsList: newCompDetailsList, floatingFilterParamsList: floatingFilterParamsList } = this.getCompDetailsList(params);
        const allFloatingFilterCompsUnchanged = newCompDetailsList.length === this.compDetailsList.length && newCompDetailsList.every((newCompDetails, index)=>!this.filterManager.areFilterCompsDifferent(this.compDetailsList[index], newCompDetails));
        if (allFloatingFilterCompsUnchanged) floatingFilterParamsList.forEach((floatingFilterParams, index)=>{
            var _a;
            const floatingFilter = this.floatingFilters[index];
            let hasRefreshed = false;
            if (floatingFilter.refresh) {
                const result = floatingFilter.refresh(floatingFilterParams);
                if (result !== null) hasRefreshed = true;
            }
            if (!hasRefreshed) (_a = floatingFilter.onParamsUpdated) == null || _a.call(floatingFilter, floatingFilterParams);
        });
        else {
            (0, $jIDNV._).clearElement(this.getGui());
            this.destroyBeans(this.floatingFilters);
            this.floatingFilters = [];
            this.compDetailsList = [];
            this.setParams(newCompDetailsList);
        }
    }
    getCompDetailsList(params) {
        const compDetailsList = [];
        const floatingFilterParamsList = [];
        const filterParams = params.filterParams;
        $5b7ccabde48fae90$export$ab0841fc22e16fa3.getFilterDefs(filterParams).forEach((filterDef, index)=>{
            const floatingFilterParams = $5b7ccabde48fae90$var$__spreadProps8($5b7ccabde48fae90$var$__spreadValues11({}, params), {
                // set the parent filter instance for each floating filter to the relevant child filter instance
                parentFilterInstance: (callback)=>{
                    this.parentMultiFilterInstance((parent)=>{
                        const child = parent.getChildFilterInstance(index);
                        if (child == null) return;
                        callback(child);
                    });
                }
            });
            (0, $jIDNV._).mergeDeep(floatingFilterParams.filterParams, filterDef.filterParams);
            const compDetails = this.getCompDetails(filterDef, floatingFilterParams);
            if (compDetails) {
                compDetailsList.push(compDetails);
                floatingFilterParamsList.push(floatingFilterParams);
            }
        });
        return {
            compDetailsList: compDetailsList,
            floatingFilterParamsList: floatingFilterParamsList
        };
    }
    onParentModelChanged(model, event) {
        if (event && event.afterFloatingFilter) return;
        this.parentMultiFilterInstance((parent)=>{
            if (model == null) this.floatingFilters.forEach((filter, i)=>{
                filter.onParentModelChanged(null, event);
                (0, $jIDNV._).setDisplayed(filter.getGui(), i === 0);
            });
            else {
                const lastActiveFloatingFilterIndex = parent.getLastActiveFilterIndex();
                this.floatingFilters.forEach((filter, i)=>{
                    const filterModel = model.filterModels.length > i ? model.filterModels[i] : null;
                    filter.onParentModelChanged(filterModel, event);
                    const shouldShow = lastActiveFloatingFilterIndex == null ? i === 0 : i === lastActiveFloatingFilterIndex;
                    (0, $jIDNV._).setDisplayed(filter.getGui(), shouldShow);
                });
            }
        });
    }
    destroy() {
        this.destroyBeans(this.floatingFilters);
        this.floatingFilters.length = 0;
        super.destroy();
    }
    getCompDetails(filterDef, params) {
        var _a;
        let defaultComponentName = (_a = this.userComponentFactory.getDefaultFloatingFilterType(filterDef, ()=>this.filterManager.getDefaultFloatingFilter(this.params.column))) != null ? _a : "agReadOnlyFloatingFilter";
        return this.userComponentFactory.getFloatingFilterCompDetails(filterDef, params, defaultComponentName);
    }
    parentMultiFilterInstance(cb) {
        this.params.parentFilterInstance((parent)=>{
            if (!(parent instanceof $5b7ccabde48fae90$export$ab0841fc22e16fa3)) throw new Error("AG Grid - MultiFloatingFilterComp expects MultiFilter as its parent");
            cb(parent);
        });
    }
};
$5b7ccabde48fae90$var$__decorateClass13([
    (0, $jIDNV.Autowired)("userComponentFactory")
], $5b7ccabde48fae90$var$MultiFloatingFilterComp.prototype, "userComponentFactory", 2);
$5b7ccabde48fae90$var$__decorateClass13([
    (0, $jIDNV.Autowired)("filterManager")
], $5b7ccabde48fae90$var$MultiFloatingFilterComp.prototype, "filterManager", 2);
var $5b7ccabde48fae90$var$VERSION13 = "31.3.4";
var $5b7ccabde48fae90$export$8897e17f4dd9d13a = {
    version: $5b7ccabde48fae90$var$VERSION13,
    moduleName: (0, $jIDNV.ModuleNames).MultiFilterModule,
    beans: [],
    userComponents: [
        {
            componentName: "agMultiColumnFilter",
            componentClass: $5b7ccabde48fae90$export$ab0841fc22e16fa3
        },
        {
            componentName: "agMultiColumnFloatingFilter",
            componentClass: $5b7ccabde48fae90$var$MultiFloatingFilterComp
        }
    ],
    dependantModules: [
        $5b7ccabde48fae90$export$3a6d13add8617801
    ]
};
var $5b7ccabde48fae90$var$RichSelectCellEditor = class extends (0, $jIDNV.PopupComponent) {
    constructor(){
        super(/* html */ `<div class="ag-cell-edit-wrapper"></div>`);
    }
    init(params) {
        this.params = params;
        const { cellStartedEdit: cellStartedEdit, cellHeight: cellHeight, values: values } = params;
        if ((0, $jIDNV._).missing(values)) console.warn("AG Grid: agRichSelectCellEditor requires cellEditorParams.values to be set");
        const { params: richSelectParams, valuesPromise: valuesPromise } = this.buildRichSelectParams();
        this.richSelect = this.createManagedBean(new (0, $jIDNV.AgRichSelect)(richSelectParams));
        this.richSelect.addCssClass("ag-cell-editor");
        this.appendChild(this.richSelect);
        if (valuesPromise) valuesPromise.then((values2)=>{
            this.richSelect.setValueList({
                valueList: values2,
                refresh: true
            });
            const searchStringCallback = this.getSearchStringCallback(values2);
            if (searchStringCallback) this.richSelect.setSearchStringCreator(searchStringCallback);
        });
        this.addManagedListener(this.richSelect, (0, $jIDNV.Events).EVENT_FIELD_PICKER_VALUE_SELECTED, this.onEditorPickerValueSelected.bind(this));
        this.addManagedListener(this.richSelect.getGui(), "focusout", this.onEditorFocusOut.bind(this));
        this.focusAfterAttached = cellStartedEdit;
        if ((0, $jIDNV._).exists(cellHeight)) this.richSelect.setRowHeight(cellHeight);
    }
    onEditorPickerValueSelected(e) {
        this.params.stopEditing(!e.fromEnterKey);
    }
    onEditorFocusOut(e) {
        if (this.richSelect.getGui().contains(e.relatedTarget)) return;
        this.params.stopEditing(true);
    }
    buildRichSelectParams() {
        const { cellRenderer: cellRenderer, value: value, values: values, formatValue: formatValue, searchDebounceDelay: searchDebounceDelay, valueListGap: valueListGap, valueListMaxHeight: valueListMaxHeight, valueListMaxWidth: valueListMaxWidth, allowTyping: allowTyping, filterList: filterList, searchType: searchType, highlightMatch: highlightMatch, valuePlaceholder: valuePlaceholder, eventKey: eventKey } = this.params;
        const ret = {
            value: value,
            cellRenderer: cellRenderer,
            searchDebounceDelay: searchDebounceDelay,
            valueFormatter: formatValue,
            pickerAriaLabelKey: "ariaLabelRichSelectField",
            pickerAriaLabelValue: "Rich Select Field",
            pickerType: "virtual-list",
            pickerGap: valueListGap,
            allowTyping: allowTyping,
            filterList: filterList,
            searchType: searchType,
            highlightMatch: highlightMatch,
            maxPickerHeight: valueListMaxHeight,
            maxPickerWidth: valueListMaxWidth,
            placeholder: valuePlaceholder,
            initialInputValue: (eventKey == null ? void 0 : eventKey.length) === 1 ? eventKey : void 0
        };
        let valuesResult;
        let valuesPromise;
        if (typeof values === "function") valuesResult = values(this.params);
        else valuesResult = values != null ? values : [];
        if (Array.isArray(valuesResult)) {
            ret.valueList = valuesResult;
            ret.searchStringCreator = this.getSearchStringCallback(valuesResult);
        } else valuesPromise = valuesResult;
        return {
            params: ret,
            valuesPromise: valuesPromise
        };
    }
    getSearchStringCallback(values) {
        const { colDef: colDef } = this.params;
        if (typeof values[0] !== "object" || !colDef.keyCreator) return;
        return (values2)=>values2.map((value)=>{
                const keyParams = this.gos.addGridCommonParams({
                    value: value,
                    colDef: this.params.colDef,
                    column: this.params.column,
                    node: this.params.node,
                    data: this.params.data
                });
                return colDef.keyCreator(keyParams);
            });
    }
    // we need to have the gui attached before we can draw the virtual rows, as the
    // virtual row logic needs info about the gui state
    afterGuiAttached() {
        const { focusAfterAttached: focusAfterAttached, params: params } = this;
        setTimeout(()=>{
            if (!this.isAlive()) return;
            if (focusAfterAttached) {
                const focusableEl = this.richSelect.getFocusableElement();
                focusableEl.focus();
                const { allowTyping: allowTyping, eventKey: eventKey2 } = this.params;
                if (allowTyping && (!eventKey2 || eventKey2.length !== 1)) focusableEl.select();
            }
            this.richSelect.showPicker();
            const { eventKey: eventKey } = params;
            if (eventKey) {
                if ((eventKey == null ? void 0 : eventKey.length) === 1) this.richSelect.searchTextFromString(eventKey);
            }
        });
    }
    getValue() {
        return this.richSelect.getValue();
    }
    isPopup() {
        return false;
    }
};
var $5b7ccabde48fae90$var$VERSION14 = "31.3.4";
var $5b7ccabde48fae90$export$9bd93207561bb9c = {
    version: $5b7ccabde48fae90$var$VERSION14,
    moduleName: (0, $jIDNV.ModuleNames).RichSelectModule,
    beans: [],
    userComponents: [
        {
            componentName: "agRichSelect",
            componentClass: $5b7ccabde48fae90$var$RichSelectCellEditor
        },
        {
            componentName: "agRichSelectCellEditor",
            componentClass: $5b7ccabde48fae90$var$RichSelectCellEditor
        }
    ],
    dependantModules: [
        $5b7ccabde48fae90$export$3a6d13add8617801
    ]
};
var $5b7ccabde48fae90$var$__defProp14 = Object.defineProperty;
var $5b7ccabde48fae90$var$__defProps9 = Object.defineProperties;
var $5b7ccabde48fae90$var$__getOwnPropDesc14 = Object.getOwnPropertyDescriptor;
var $5b7ccabde48fae90$var$__getOwnPropDescs9 = Object.getOwnPropertyDescriptors;
var $5b7ccabde48fae90$var$__getOwnPropSymbols12 = Object.getOwnPropertySymbols;
var $5b7ccabde48fae90$var$__hasOwnProp13 = Object.prototype.hasOwnProperty;
var $5b7ccabde48fae90$var$__propIsEnum12 = Object.prototype.propertyIsEnumerable;
var $5b7ccabde48fae90$var$__defNormalProp12 = (obj, key, value)=>key in obj ? $5b7ccabde48fae90$var$__defProp14(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5b7ccabde48fae90$var$__spreadValues12 = (a, b)=>{
    for(var prop in b || (b = {}))if ($5b7ccabde48fae90$var$__hasOwnProp13.call(b, prop)) $5b7ccabde48fae90$var$__defNormalProp12(a, prop, b[prop]);
    if ($5b7ccabde48fae90$var$__getOwnPropSymbols12) {
        for (var prop of $5b7ccabde48fae90$var$__getOwnPropSymbols12(b))if ($5b7ccabde48fae90$var$__propIsEnum12.call(b, prop)) $5b7ccabde48fae90$var$__defNormalProp12(a, prop, b[prop]);
    }
    return a;
};
var $5b7ccabde48fae90$var$__spreadProps9 = (a, b)=>$5b7ccabde48fae90$var$__defProps9(a, $5b7ccabde48fae90$var$__getOwnPropDescs9(b));
var $5b7ccabde48fae90$var$__objRest2 = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($5b7ccabde48fae90$var$__hasOwnProp13.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $5b7ccabde48fae90$var$__getOwnPropSymbols12) {
        for (var prop of $5b7ccabde48fae90$var$__getOwnPropSymbols12(source))if (exclude.indexOf(prop) < 0 && $5b7ccabde48fae90$var$__propIsEnum12.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $5b7ccabde48fae90$var$__decorateClass14 = (decorators, target, key, kind)=>{
    var result = kind > 1 ? void 0 : kind ? $5b7ccabde48fae90$var$__getOwnPropDesc14(target, key) : target;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
    if (kind && result) $5b7ccabde48fae90$var$__defProp14(target, key, result);
    return result;
};
var $5b7ccabde48fae90$var$FullStore = class extends (0, $jIDNV.RowNodeBlock) {
    constructor(ssrmParams, storeParams, parentRowNode){
        super(0);
        this.nodeIdSequence = new (0, $jIDNV.NumberSequence)();
        this.info = {};
        this.ssrmParams = ssrmParams;
        this.parentRowNode = parentRowNode;
        this.level = parentRowNode.level + 1;
        this.groupLevel = ssrmParams.rowGroupCols ? this.level < ssrmParams.rowGroupCols.length : void 0;
        this.leafGroup = ssrmParams.rowGroupCols ? this.level === ssrmParams.rowGroupCols.length - 1 : false;
    }
    postConstruct() {
        this.usingTreeData = this.gos.get("treeData");
        this.nodeIdPrefix = this.blockUtils.createNodeIdPrefix(this.parentRowNode);
        if (!this.usingTreeData && this.groupLevel) {
            const groupColVo = this.ssrmParams.rowGroupCols[this.level];
            this.groupField = groupColVo.field;
            this.rowGroupColumn = this.columnModel.getRowGroupColumns()[this.level];
        }
        let initialRowCount = 1;
        const isRootStore = this.parentRowNode.level === -1;
        const userInitialRowCount = this.storeUtils.getServerSideInitialRowCount();
        if (isRootStore && userInitialRowCount != null) initialRowCount = userInitialRowCount;
        this.initialiseRowNodes(initialRowCount);
        this.rowNodeBlockLoader.addBlock(this);
        this.addDestroyFunc(()=>this.rowNodeBlockLoader.removeBlock(this));
        this.postSortFunc = this.gos.getCallback("postSortRows");
        if (userInitialRowCount != null) this.eventService.dispatchEventOnce({
            type: (0, $jIDNV.Events).EVENT_ROW_COUNT_READY
        });
    }
    destroyRowNodes() {
        this.blockUtils.destroyRowNodes(this.allRowNodes);
        this.allRowNodes = [];
        this.nodesAfterSort = [];
        this.nodesAfterFilter = [];
        this.allNodesMap = {};
    }
    initialiseRowNodes(loadingRowsCount, failedLoad = false) {
        this.destroyRowNodes();
        for(let i = 0; i < loadingRowsCount; i++){
            const loadingRowNode = this.blockUtils.createRowNode({
                field: this.groupField,
                group: this.groupLevel,
                leafGroup: this.leafGroup,
                level: this.level,
                parent: this.parentRowNode,
                rowGroupColumn: this.rowGroupColumn
            });
            if (failedLoad) loadingRowNode.failedLoad = true;
            this.allRowNodes.push(loadingRowNode);
            this.nodesAfterFilter.push(loadingRowNode);
            this.nodesAfterSort.push(loadingRowNode);
        }
    }
    getBlockStateJson() {
        return {
            id: this.nodeIdPrefix ? this.nodeIdPrefix : "",
            state: this.getState()
        };
    }
    loadFromDatasource() {
        this.storeUtils.loadFromDatasource({
            startRow: void 0,
            endRow: void 0,
            parentBlock: this,
            parentNode: this.parentRowNode,
            storeParams: this.ssrmParams,
            success: this.success.bind(this, this.getVersion()),
            fail: this.pageLoadFailed.bind(this, this.getVersion())
        });
    }
    getStartRow() {
        return 0;
    }
    getEndRow() {
        return this.nodesAfterSort.length;
    }
    createDataNode(data, index) {
        const rowNode = this.blockUtils.createRowNode({
            field: this.groupField,
            group: this.groupLevel,
            leafGroup: this.leafGroup,
            level: this.level,
            parent: this.parentRowNode,
            rowGroupColumn: this.rowGroupColumn
        });
        if (index != null) (0, $jIDNV._).insertIntoArray(this.allRowNodes, rowNode, index);
        else this.allRowNodes.push(rowNode);
        const defaultId = this.prefixId(this.nodeIdSequence.next());
        this.blockUtils.setDataIntoRowNode(rowNode, data, defaultId, void 0);
        this.nodeManager.addRowNode(rowNode);
        this.blockUtils.checkOpenByDefault(rowNode);
        this.allNodesMap[rowNode.id] = rowNode;
        return rowNode;
    }
    prefixId(id) {
        if (this.nodeIdPrefix) return this.nodeIdPrefix + "-" + id;
        else return id.toString();
    }
    processServerFail() {
        this.initialiseRowNodes(1, true);
        this.fireStoreUpdatedEvent();
        this.flushAsyncTransactions();
    }
    processServerResult(params) {
        if (!this.isAlive()) return;
        const info = params.groupLevelInfo;
        if (info) Object.assign(this.info, info);
        if (params.pivotResultFields) this.serverSideRowModel.generateSecondaryColumns(params.pivotResultFields);
        const nodesToRecycle = this.allRowNodes.length > 0 ? this.allNodesMap : void 0;
        this.allRowNodes = [];
        this.nodesAfterSort = [];
        this.nodesAfterFilter = [];
        this.allNodesMap = {};
        if (!params.rowData) (0, $jIDNV._).warnOnce('"params.data" is missing from Server-Side Row Model success() callback. Please use the "data" attribute. If no data is returned, set an empty list.');
        this.createOrRecycleNodes(nodesToRecycle, params.rowData);
        if (nodesToRecycle) this.blockUtils.destroyRowNodes((0, $jIDNV._).getAllValuesInObject(nodesToRecycle));
        if (this.level === 0) this.eventService.dispatchEventOnce({
            type: (0, $jIDNV.Events).EVENT_ROW_COUNT_READY
        });
        this.filterAndSortNodes();
        this.fireStoreUpdatedEvent();
        this.flushAsyncTransactions();
    }
    createOrRecycleNodes(nodesToRecycle, rowData) {
        if (!rowData) return;
        const lookupNodeToRecycle = (data)=>{
            if (!nodesToRecycle) return void 0;
            const getRowIdFunc = this.gos.getCallback("getRowId");
            if (!getRowIdFunc) return void 0;
            const parentKeys = this.parentRowNode.getGroupKeys();
            const level = this.level;
            const id = getRowIdFunc({
                data: data,
                parentKeys: parentKeys.length > 0 ? parentKeys : void 0,
                level: level
            });
            const foundNode = nodesToRecycle[id];
            if (!foundNode) return void 0;
            delete nodesToRecycle[id];
            return foundNode;
        };
        const recycleNode = (rowNode, dataItem)=>{
            this.allNodesMap[rowNode.id] = rowNode;
            this.blockUtils.updateDataIntoRowNode(rowNode, dataItem);
            this.allRowNodes.push(rowNode);
        };
        rowData.forEach((dataItem)=>{
            const nodeToRecycle = lookupNodeToRecycle(dataItem);
            if (nodeToRecycle) recycleNode(nodeToRecycle, dataItem);
            else this.createDataNode(dataItem);
        });
    }
    flushAsyncTransactions() {
        window.setTimeout(()=>this.transactionManager.flushAsyncTransactions(), 0);
    }
    filterAndSortNodes() {
        this.filterRowNodes();
        this.sortRowNodes();
    }
    sortRowNodes() {
        const serverIsSorting = this.storeUtils.isServerSideSortAllLevels() || this.storeUtils.isServerSideSortOnServer();
        const sortOptions = this.sortController.getSortOptions();
        const noSortApplied = !sortOptions || sortOptions.length == 0;
        if (serverIsSorting || noSortApplied) {
            this.nodesAfterSort = this.nodesAfterFilter;
            return;
        }
        this.nodesAfterSort = this.rowNodeSorter.doFullSort(this.nodesAfterFilter, sortOptions);
        if (this.postSortFunc) {
            const params = {
                nodes: this.nodesAfterSort
            };
            this.postSortFunc(params);
        }
    }
    filterRowNodes() {
        const serverIsFiltering = !this.storeUtils.isServerSideOnlyRefreshFilteredGroups() || this.storeUtils.isServerSideFilterOnServer();
        const groupLevel = this.groupLevel;
        if (serverIsFiltering || groupLevel) {
            this.nodesAfterFilter = this.allRowNodes;
            return;
        }
        this.nodesAfterFilter = this.allRowNodes.filter((rowNode)=>this.filterManager.doesRowPassFilter({
                rowNode: rowNode
            }));
    }
    clearDisplayIndexes() {
        this.displayIndexStart = void 0;
        this.displayIndexEnd = void 0;
        this.allRowNodes.forEach((rowNode)=>this.blockUtils.clearDisplayIndex(rowNode));
    }
    getDisplayIndexEnd() {
        return this.displayIndexEnd;
    }
    isDisplayIndexInStore(displayIndex) {
        if (this.getRowCount() === 0) return false;
        return displayIndex >= this.displayIndexStart && displayIndex < this.displayIndexEnd;
    }
    setDisplayIndexes(displayIndexSeq, nextRowTop) {
        this.displayIndexStart = displayIndexSeq.peek();
        this.topPx = nextRowTop.value;
        const visibleNodeIds = {};
        this.nodesAfterSort.forEach((rowNode)=>{
            this.blockUtils.setDisplayIndex(rowNode, displayIndexSeq, nextRowTop);
            visibleNodeIds[rowNode.id] = true;
        });
        this.allRowNodes.forEach((rowNode)=>{
            if (!visibleNodeIds[rowNode.id]) this.blockUtils.clearDisplayIndex(rowNode);
        });
        this.displayIndexEnd = displayIndexSeq.peek();
        this.heightPx = nextRowTop.value - this.topPx;
    }
    forEachStoreDeep(callback, sequence = new (0, $jIDNV.NumberSequence)()) {
        callback(this, sequence.next());
        this.allRowNodes.forEach((rowNode)=>{
            const childCache = rowNode.childStore;
            if (childCache) childCache.forEachStoreDeep(callback, sequence);
        });
    }
    forEachNodeDeep(callback, sequence = new (0, $jIDNV.NumberSequence)()) {
        this.allRowNodes.forEach((rowNode)=>{
            callback(rowNode, sequence.next());
            const childCache = rowNode.childStore;
            if (childCache) childCache.forEachNodeDeep(callback, sequence);
        });
    }
    forEachNodeDeepAfterFilterAndSort(callback, sequence = new (0, $jIDNV.NumberSequence)(), includeFooterNodes = false) {
        this.nodesAfterSort.forEach((rowNode)=>{
            callback(rowNode, sequence.next());
            const childCache = rowNode.childStore;
            if (childCache) childCache.forEachNodeDeepAfterFilterAndSort(callback, sequence, includeFooterNodes);
        });
        if (includeFooterNodes && this.parentRowNode.sibling) callback(this.parentRowNode.sibling, sequence.next());
    }
    getRowUsingDisplayIndex(displayRowIndex) {
        if (!this.isDisplayIndexInStore(displayRowIndex)) return void 0;
        const res = this.blockUtils.binarySearchForDisplayIndex(displayRowIndex, this.nodesAfterSort);
        return res;
    }
    getRowBounds(index) {
        for(let i = 0; i < this.nodesAfterSort.length; i++){
            const rowNode = this.nodesAfterSort[i];
            const res = this.blockUtils.extractRowBounds(rowNode, index);
            if (res) return res;
        }
        return null;
    }
    isPixelInRange(pixel) {
        return pixel >= this.topPx && pixel < this.topPx + this.heightPx;
    }
    getRowIndexAtPixel(pixel) {
        const pixelBeforeThisStore = pixel <= this.topPx;
        if (pixelBeforeThisStore) {
            const firstNode = this.nodesAfterSort[0];
            return firstNode.rowIndex;
        }
        const pixelAfterThisStore = pixel >= this.topPx + this.heightPx;
        if (pixelAfterThisStore) {
            const lastRowNode = this.nodesAfterSort[this.nodesAfterSort.length - 1];
            const lastRowNodeBottomPx = lastRowNode.rowTop + lastRowNode.rowHeight;
            if (pixel >= lastRowNodeBottomPx && lastRowNode.expanded) {
                if (lastRowNode.childStore && lastRowNode.childStore.getRowCount() > 0) return lastRowNode.childStore.getRowIndexAtPixel(pixel);
                if (lastRowNode.detailNode) return lastRowNode.detailNode.rowIndex;
            }
            return lastRowNode.rowIndex;
        }
        let res = null;
        this.nodesAfterSort.forEach((rowNode)=>{
            const res2 = this.blockUtils.getIndexAtPixel(rowNode, pixel);
            if (res2 != null) res = res2;
        });
        const pixelIsPastLastRow = res == null;
        if (pixelIsPastLastRow) return this.displayIndexEnd - 1;
        return res;
    }
    getChildStore(keys) {
        return this.storeUtils.getChildStore(keys, this, (key)=>{
            const rowNode = this.allRowNodes.find((currentRowNode)=>{
                return currentRowNode.key == key;
            });
            return rowNode;
        });
    }
    forEachChildStoreShallow(callback) {
        this.allRowNodes.forEach((rowNode)=>{
            const childStore = rowNode.childStore;
            if (childStore) callback(childStore);
        });
    }
    refreshAfterFilter(params) {
        const serverIsFiltering = this.storeUtils.isServerSideFilterOnServer();
        const storeIsImpacted = this.storeUtils.isServerRefreshNeeded(this.parentRowNode, this.ssrmParams.rowGroupCols, params);
        const serverIsFilteringAllLevels = !this.storeUtils.isServerSideOnlyRefreshFilteredGroups();
        if (serverIsFilteringAllLevels || serverIsFiltering && storeIsImpacted) {
            this.refreshStore(true);
            this.sortRowNodes();
            return;
        }
        this.filterRowNodes();
        this.sortRowNodes();
        this.forEachChildStoreShallow((store)=>store.refreshAfterFilter(params));
    }
    refreshAfterSort(params) {
        const serverIsSorting = this.storeUtils.isServerSideSortOnServer();
        const storeIsImpacted = this.storeUtils.isServerRefreshNeeded(this.parentRowNode, this.ssrmParams.rowGroupCols, params);
        const serverIsSortingAllLevels = this.storeUtils.isServerSideSortAllLevels();
        if (serverIsSortingAllLevels || serverIsSorting && storeIsImpacted) {
            this.refreshStore(true);
            this.filterRowNodes();
            return;
        }
        this.filterRowNodes();
        this.sortRowNodes();
        this.forEachChildStoreShallow((store)=>store.refreshAfterSort(params));
    }
    applyTransaction(transaction) {
        switch(this.getState()){
            case (0, $jIDNV.RowNodeBlock).STATE_FAILED:
                return {
                    status: (0, $jIDNV.ServerSideTransactionResultStatus).StoreLoadingFailed
                };
            case (0, $jIDNV.RowNodeBlock).STATE_LOADING:
                return {
                    status: (0, $jIDNV.ServerSideTransactionResultStatus).StoreLoading
                };
            case (0, $jIDNV.RowNodeBlock).STATE_WAITING_TO_LOAD:
                return {
                    status: (0, $jIDNV.ServerSideTransactionResultStatus).StoreWaitingToLoad
                };
        }
        const applyCallback = this.gos.getCallback("isApplyServerSideTransaction");
        if (applyCallback) {
            const params = {
                transaction: transaction,
                parentNode: this.parentRowNode,
                groupLevelInfo: this.info
            };
            const apply = applyCallback(params);
            if (!apply) return {
                status: (0, $jIDNV.ServerSideTransactionResultStatus).Cancelled
            };
        }
        const res = {
            status: (0, $jIDNV.ServerSideTransactionResultStatus).Applied,
            remove: [],
            update: [],
            add: []
        };
        const nodesToUnselect = [];
        this.executeAdd(transaction, res);
        this.executeRemove(transaction, res, nodesToUnselect);
        this.executeUpdate(transaction, res, nodesToUnselect);
        this.filterAndSortNodes();
        this.updateSelection(nodesToUnselect);
        return res;
    }
    updateSelection(nodesToUnselect) {
        const selectionChanged = nodesToUnselect.length > 0;
        if (selectionChanged) {
            this.selectionService.setNodesSelected({
                newValue: false,
                nodes: nodesToUnselect,
                suppressFinishActions: true,
                clearSelection: false,
                source: "rowDataChanged"
            });
            const event = {
                type: (0, $jIDNV.Events).EVENT_SELECTION_CHANGED,
                source: "rowDataChanged"
            };
            this.eventService.dispatchEvent(event);
        }
    }
    executeAdd(rowDataTran, rowNodeTransaction) {
        const { add: add, addIndex: addIndex } = rowDataTran;
        if ((0, $jIDNV._).missingOrEmpty(add)) return;
        const useIndex = typeof addIndex === "number" && addIndex >= 0;
        if (useIndex) add.reverse().forEach((item)=>{
            const newRowNode = this.createDataNode(item, addIndex);
            rowNodeTransaction.add.push(newRowNode);
        });
        else add.forEach((item)=>{
            const newRowNode = this.createDataNode(item);
            rowNodeTransaction.add.push(newRowNode);
        });
    }
    executeRemove(rowDataTran, rowNodeTransaction, nodesToUnselect) {
        const { remove: remove } = rowDataTran;
        if (remove == null) return;
        const rowIdsRemoved = {};
        remove.forEach((item)=>{
            const rowNode = this.lookupRowNode(item);
            if (!rowNode) return;
            if (rowNode.isSelected()) nodesToUnselect.push(rowNode);
            rowNode.clearRowTopAndRowIndex();
            rowIdsRemoved[rowNode.id] = true;
            delete this.allNodesMap[rowNode.id];
            rowNodeTransaction.remove.push(rowNode);
            this.nodeManager.removeNode(rowNode);
        });
        this.allRowNodes = this.allRowNodes.filter((rowNode)=>!rowIdsRemoved[rowNode.id]);
    }
    executeUpdate(rowDataTran, rowNodeTransaction, nodesToUnselect) {
        const { update: update } = rowDataTran;
        if (update == null) return;
        update.forEach((item)=>{
            const rowNode = this.lookupRowNode(item);
            if (!rowNode) return;
            this.blockUtils.updateDataIntoRowNode(rowNode, item);
            if (!rowNode.selectable && rowNode.isSelected()) nodesToUnselect.push(rowNode);
            rowNodeTransaction.update.push(rowNode);
        });
    }
    lookupRowNode(data) {
        const getRowIdFunc = this.gos.getCallback("getRowId");
        let rowNode;
        if (getRowIdFunc != null) {
            const level = this.level;
            const parentKeys = this.parentRowNode.getGroupKeys();
            const id = getRowIdFunc({
                data: data,
                parentKeys: parentKeys.length > 0 ? parentKeys : void 0,
                level: level
            });
            rowNode = this.allNodesMap[id];
            if (!rowNode) {
                console.error(`AG Grid: could not find row id=${id}, data item was not found for this id`);
                return null;
            }
        } else {
            rowNode = this.allRowNodes.find((currentRowNode)=>currentRowNode.data === data);
            if (!rowNode) {
                console.error(`AG Grid: could not find data item as object was not found`, data);
                return null;
            }
        }
        return rowNode;
    }
    addStoreStates(result) {
        result.push({
            suppressInfiniteScroll: true,
            route: this.parentRowNode.getGroupKeys(),
            rowCount: this.allRowNodes.length,
            info: this.info
        });
        this.forEachChildStoreShallow((childStore)=>childStore.addStoreStates(result));
    }
    refreshStore(purge) {
        if (purge) {
            const loadingRowsToShow = this.nodesAfterSort ? this.nodesAfterSort.length : 1;
            this.initialiseRowNodes(loadingRowsToShow);
        }
        this.scheduleLoad();
        this.fireStoreUpdatedEvent();
    }
    retryLoads() {
        if (this.getState() === (0, $jIDNV.RowNodeBlock).STATE_FAILED) {
            this.initialiseRowNodes(1);
            this.scheduleLoad();
        }
        this.forEachChildStoreShallow((store)=>store.retryLoads());
    }
    scheduleLoad() {
        this.setStateWaitingToLoad();
        this.rowNodeBlockLoader.checkBlockToLoad();
    }
    // gets called 1) row count changed 2) cache purged 3) items inserted
    fireStoreUpdatedEvent() {
        const event = {
            type: (0, $jIDNV.Events).EVENT_STORE_UPDATED
        };
        this.eventService.dispatchEvent(event);
    }
    getRowCount() {
        return this.nodesAfterSort.length;
    }
    getTopLevelRowDisplayedIndex(topLevelIndex) {
        const rowNode = this.nodesAfterSort[topLevelIndex];
        return rowNode.rowIndex;
    }
    isLastRowIndexKnown() {
        return this.getState() == (0, $jIDNV.RowNodeBlock).STATE_LOADED;
    }
    getRowNodesInRange(firstInRange, lastInRange) {
        const result = [];
        let inActiveRange = false;
        if ((0, $jIDNV._).missing(firstInRange)) inActiveRange = true;
        this.nodesAfterSort.forEach((rowNode)=>{
            const hitFirstOrLast = rowNode === firstInRange || rowNode === lastInRange;
            if (inActiveRange || hitFirstOrLast) result.push(rowNode);
            if (hitFirstOrLast) inActiveRange = !inActiveRange;
        });
        const invalidRange = inActiveRange;
        return invalidRange ? [] : result;
    }
    getStoreBounds() {
        return {
            topPx: this.topPx,
            heightPx: this.heightPx
        };
    }
};
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("ssrmStoreUtils")
], $5b7ccabde48fae90$var$FullStore.prototype, "storeUtils", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("ssrmBlockUtils")
], $5b7ccabde48fae90$var$FullStore.prototype, "blockUtils", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$FullStore.prototype, "columnModel", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("rowNodeBlockLoader")
], $5b7ccabde48fae90$var$FullStore.prototype, "rowNodeBlockLoader", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("rowNodeSorter")
], $5b7ccabde48fae90$var$FullStore.prototype, "rowNodeSorter", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("sortController")
], $5b7ccabde48fae90$var$FullStore.prototype, "sortController", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("selectionService")
], $5b7ccabde48fae90$var$FullStore.prototype, "selectionService", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("ssrmNodeManager")
], $5b7ccabde48fae90$var$FullStore.prototype, "nodeManager", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("filterManager")
], $5b7ccabde48fae90$var$FullStore.prototype, "filterManager", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("ssrmTransactionManager")
], $5b7ccabde48fae90$var$FullStore.prototype, "transactionManager", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("rowModel")
], $5b7ccabde48fae90$var$FullStore.prototype, "serverSideRowModel", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$FullStore.prototype, "postConstruct", 1);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.PreDestroy)
], $5b7ccabde48fae90$var$FullStore.prototype, "destroyRowNodes", 1);
var $5b7ccabde48fae90$var$MultiIndexMap = class {
    constructor(...indexes){
        if (indexes.length < 1) throw new Error("AG Grid: At least one index must be provided.");
        this.indexes = indexes;
        this.maps = new Map(this.indexes.map((index)=>[
                index,
                /* @__PURE__ */ new Map()
            ]));
    }
    getSize() {
        return this.maps.get(this.indexes[0]).size;
    }
    getBy(index, key) {
        const map = this.maps.get(index);
        if (!map) throw new Error(`AG Grid: ${String(index)} not found`);
        return map.get(key);
    }
    set(item) {
        this.indexes.forEach((index)=>{
            const map = this.maps.get(index);
            if (!map) throw new Error(`AG Grid: ${String(index)} not found`);
            map.set(item[index], item);
        });
    }
    delete(item) {
        this.indexes.forEach((index)=>{
            const map = this.maps.get(index);
            if (!map) throw new Error(`AG Grid: ${String(index)} not found`);
            map.delete(item[index]);
        });
    }
    clear() {
        this.maps.forEach((map)=>map.clear());
    }
    getIterator(index) {
        const map = this.maps.get(index);
        if (!map) throw new Error(`AG Grid: ${String(index)} not found`);
        return map.values();
    }
    forEach(callback) {
        const iterator = this.getIterator(this.indexes[0]);
        let pointer;
        while(pointer = iterator.next()){
            if (pointer.done) break;
            callback(pointer.value);
        }
    }
    find(callback) {
        const iterator = this.getIterator(this.indexes[0]);
        let pointer;
        while(pointer = iterator.next()){
            if (pointer.done) break;
            if (callback(pointer.value)) return pointer.value;
        }
    }
    filter(predicate) {
        const iterator = this.getIterator(this.indexes[0]);
        let pointer;
        const result = [];
        while(pointer = iterator.next()){
            if (pointer.done) break;
            if (predicate(pointer.value)) result.push(pointer.value);
        }
        return result;
    }
};
var $5b7ccabde48fae90$var$LazyBlockLoadingService = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.cacheLoadingNodesMap = /* @__PURE__ */ new Map();
        this.isCheckQueued = false;
        this.nextBlockToLoad = void 0;
    }
    init() {
        this.addManagedListener(this.rowNodeBlockLoader, (0, $jIDNV.RowNodeBlockLoader).BLOCK_LOADED_EVENT, ()=>this.queueLoadCheck());
    }
    subscribe(cache) {
        this.cacheLoadingNodesMap.set(cache, /* @__PURE__ */ new Set());
    }
    unsubscribe(cache) {
        this.cacheLoadingNodesMap.delete(cache);
    }
    /**
   * Queues a microtask to check if any blocks need to be loaded.
   */ queueLoadCheck() {
        if (this.isCheckQueued) return;
        this.isCheckQueued = true;
        window.queueMicrotask(()=>{
            this.queueLoadAction();
            this.isCheckQueued = false;
        });
    }
    queueLoadAction() {
        const nextBlockToLoad = this.getBlockToLoad();
        if (!nextBlockToLoad) return;
        const isSameBlock = this.nextBlockToLoad && this.nextBlockToLoad.cache === nextBlockToLoad.cache && this.nextBlockToLoad.index === nextBlockToLoad.index;
        if (isSameBlock) return;
        if (!this.nextBlockToLoad || !isSameBlock) {
            this.nextBlockToLoad = nextBlockToLoad;
            window.clearTimeout(this.loaderTimeout);
            const startRow = Number(this.nextBlockToLoad.index);
            const cache = this.nextBlockToLoad.cache;
            const endRow = nextBlockToLoad.index + nextBlockToLoad.cache.getBlockSize();
            this.loaderTimeout = window.setTimeout(()=>{
                if (!cache.isAlive()) return;
                this.loaderTimeout = void 0;
                this.attemptLoad(cache, startRow, endRow);
                this.nextBlockToLoad = void 0;
            }, this.gos.get("blockLoadDebounceMillis"));
        }
    }
    attemptLoad(cache, start, end) {
        const availableLoadingCount = this.rowNodeBlockLoader.getAvailableLoadingCount();
        if (availableLoadingCount != null && availableLoadingCount === 0) return;
        this.rowNodeBlockLoader.registerLoads(1);
        this.executeLoad(cache, start, end);
        this.queueLoadCheck();
    }
    executeLoad(cache, startRow, endRow) {
        var _a;
        const ssrmParams = cache.getSsrmParams();
        const request = {
            startRow: startRow,
            endRow: endRow,
            rowGroupCols: ssrmParams.rowGroupCols,
            valueCols: ssrmParams.valueCols,
            pivotCols: ssrmParams.pivotCols,
            pivotMode: ssrmParams.pivotMode,
            groupKeys: cache.store.getParentNode().getGroupKeys(),
            filterModel: ssrmParams.filterModel,
            sortModel: ssrmParams.sortModel
        };
        const loadingNodes = this.cacheLoadingNodesMap.get(cache);
        const removeNodesFromLoadingMap = ()=>{
            for(let i = 0; i < endRow - startRow; i++)loadingNodes.delete(startRow + i);
        };
        const addNodesToLoadingMap = ()=>{
            for(let i = 0; i < endRow - startRow; i++)loadingNodes.add(startRow + i);
        };
        const success = (params2)=>{
            this.rowNodeBlockLoader.loadComplete();
            cache.onLoadSuccess(startRow, endRow - startRow, params2);
            removeNodesFromLoadingMap();
        };
        const fail = ()=>{
            this.rowNodeBlockLoader.loadComplete();
            cache.onLoadFailed(startRow, endRow - startRow);
            removeNodesFromLoadingMap();
        };
        const params = this.gos.addGridCommonParams({
            request: request,
            success: success,
            fail: fail,
            parentNode: cache.store.getParentNode()
        });
        addNodesToLoadingMap();
        (_a = cache.getSsrmParams().datasource) == null || _a.getRows(params);
    }
    getBlockToLoad() {
        var _a;
        const firstRowInViewport = this.rowRenderer.getFirstVirtualRenderedRow();
        const lastRowInViewport = this.rowRenderer.getLastVirtualRenderedRow();
        for(let i = firstRowInViewport; i <= lastRowInViewport; i++){
            const row = this.rowModel.getRow(i);
            if (!row) continue;
            const store = row.parent && row.parent.childStore;
            if (!store || !(store instanceof $5b7ccabde48fae90$var$LazyStore)) continue;
            const cache = store.getCache();
            const lazyNode = cache.getNodes().getBy("node", row);
            if (!lazyNode) continue;
            const loadingNodes = this.cacheLoadingNodesMap.get(cache);
            if (loadingNodes == null ? void 0 : loadingNodes.has(lazyNode.index)) continue;
            if (row.__needsRefreshWhenVisible || row.stub && !row.failedLoad) return {
                cache: cache,
                index: cache.getBlockStartIndex(lazyNode.index)
            };
        }
        let cacheToRefresh = null;
        let nodeToRefresh = null;
        let nodeToRefreshDist = Number.MAX_SAFE_INTEGER;
        for (const cache of this.cacheLoadingNodesMap.keys()){
            const nodesToRefresh = cache.getNodesToRefresh();
            nodesToRefresh.forEach((node)=>{
                if (node.rowIndex == null) {
                    nodeToRefresh = node;
                    cacheToRefresh = cache;
                    return;
                }
                const lazyNode = cache.getNodes().getBy("node", node);
                if (!lazyNode) return;
                const loadingNodes = this.cacheLoadingNodesMap.get(cache);
                if (loadingNodes == null ? void 0 : loadingNodes.has(lazyNode.index)) return;
                const distToViewportTop = Math.abs(firstRowInViewport - node.rowIndex);
                const distToViewportBottom = Math.abs(node.rowIndex - lastRowInViewport);
                if (distToViewportTop < nodeToRefreshDist) {
                    nodeToRefresh = node;
                    nodeToRefreshDist = distToViewportTop;
                    cacheToRefresh = cache;
                }
                if (distToViewportBottom < nodeToRefreshDist) {
                    nodeToRefresh = node;
                    nodeToRefreshDist = distToViewportBottom;
                    cacheToRefresh = cache;
                }
            });
        }
        if (!cacheToRefresh) return void 0;
        const lazyCache = cacheToRefresh;
        const lazyIndex = (_a = lazyCache.getNodes().getBy("node", nodeToRefresh)) == null ? void 0 : _a.index;
        return lazyIndex == null ? void 0 : {
            cache: lazyCache,
            index: lazyCache.getBlockStartIndex(lazyIndex)
        };
    }
    isRowLoading(cache, index) {
        var _a, _b;
        return (_b = (_a = this.cacheLoadingNodesMap.get(cache)) == null ? void 0 : _a.has(index)) != null ? _b : false;
    }
};
$5b7ccabde48fae90$var$LazyBlockLoadingService.DEFAULT_BLOCK_SIZE = 100;
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("rowNodeBlockLoader")
], $5b7ccabde48fae90$var$LazyBlockLoadingService.prototype, "rowNodeBlockLoader", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("rowRenderer")
], $5b7ccabde48fae90$var$LazyBlockLoadingService.prototype, "rowRenderer", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("rowModel")
], $5b7ccabde48fae90$var$LazyBlockLoadingService.prototype, "rowModel", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$LazyBlockLoadingService.prototype, "init", 1);
$5b7ccabde48fae90$var$LazyBlockLoadingService = $5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Bean)("lazyBlockLoadingService")
], $5b7ccabde48fae90$var$LazyBlockLoadingService);
var $5b7ccabde48fae90$var$LazyCache = class extends (0, $jIDNV.BeanStub) {
    constructor(store, numberOfRows, storeParams){
        super();
        this.live = true;
        this.removedNodeCache = /* @__PURE__ */ new Map();
        this.store = store;
        this.numberOfRows = numberOfRows;
        this.isLastRowKnown = false;
        this.storeParams = storeParams;
    }
    init() {
        this.lazyBlockLoadingService.subscribe(this);
        this.nodeMap = new $5b7ccabde48fae90$var$MultiIndexMap("index", "id", "node");
        this.nodeDisplayIndexMap = /* @__PURE__ */ new Map();
        this.nodesToRefresh = /* @__PURE__ */ new Set();
        this.defaultNodeIdPrefix = this.blockUtils.createNodeIdPrefix(this.store.getParentNode());
        this.getRowIdFunc = this.gos.getCallback("getRowId");
        this.isMasterDetail = this.gos.get("masterDetail");
    }
    destroyRowNodes() {
        this.lazyBlockLoadingService.unsubscribe(this);
        this.numberOfRows = 0;
        this.nodeMap.forEach((node)=>this.blockUtils.destroyRowNode(node.node));
        this.nodeMap.clear();
        this.nodeDisplayIndexMap.clear();
        this.nodesToRefresh.clear();
        this.live = false;
    }
    /**
   * Get the row node for a specific display index from this store
   * @param displayIndex the display index of the node to find
   * @returns undefined if the node is not in the store bounds, otherwise will always return a node
   */ getRowByDisplayIndex(displayIndex) {
        var _a, _b, _c, _d;
        if (!this.store.isDisplayIndexInStore(displayIndex)) return void 0;
        const node = this.nodeDisplayIndexMap.get(displayIndex);
        if (node) {
            if (node.stub || node.__needsRefreshWhenVisible) this.lazyBlockLoadingService.queueLoadCheck();
            return node;
        }
        if (displayIndex === this.store.getDisplayIndexStart()) return this.createStubNode(0, displayIndex);
        const contiguouslyPreviousNode = this.nodeDisplayIndexMap.get(displayIndex - 1);
        if (contiguouslyPreviousNode) {
            if (this.isMasterDetail && contiguouslyPreviousNode.master && contiguouslyPreviousNode.expanded) return contiguouslyPreviousNode.detailNode;
            if (contiguouslyPreviousNode.expanded && ((_a = contiguouslyPreviousNode.childStore) == null ? void 0 : _a.isDisplayIndexInStore(displayIndex))) return (_b = contiguouslyPreviousNode.childStore) == null ? void 0 : _b.getRowUsingDisplayIndex(displayIndex);
            const lazyCacheNode = this.nodeMap.getBy("node", contiguouslyPreviousNode);
            return this.createStubNode(lazyCacheNode.index + 1, displayIndex);
        }
        const adjacentNodes = this.getSurroundingNodesByDisplayIndex(displayIndex);
        if (adjacentNodes == null) {
            const storeIndexFromEndIndex2 = this.store.getRowCount() - (this.store.getDisplayIndexEnd() - displayIndex);
            return this.createStubNode(storeIndexFromEndIndex2, displayIndex);
        }
        const { previousNode: previousNode, nextNode: nextNode } = adjacentNodes;
        if (previousNode && previousNode.node.expanded && ((_c = previousNode.node.childStore) == null ? void 0 : _c.isDisplayIndexInStore(displayIndex))) return (_d = previousNode.node.childStore) == null ? void 0 : _d.getRowUsingDisplayIndex(displayIndex);
        if (nextNode) {
            const displayIndexDiff = nextNode.node.rowIndex - displayIndex;
            const newStoreIndex = nextNode.index - displayIndexDiff;
            return this.createStubNode(newStoreIndex, displayIndex);
        }
        const storeIndexFromEndIndex = this.store.getRowCount() - (this.store.getDisplayIndexEnd() - displayIndex);
        return this.createStubNode(storeIndexFromEndIndex, displayIndex);
    }
    /**
   * Used for creating and positioning a stub node without firing a store updated event
   */ createStubNode(storeIndex, displayIndex) {
        const rowBounds = this.store.getRowBounds(displayIndex);
        const newNode = this.createRowAtIndex(storeIndex, null, (node)=>{
            node.setRowIndex(displayIndex);
            node.setRowTop(rowBounds.rowTop);
            this.nodeDisplayIndexMap.set(displayIndex, node);
        });
        this.lazyBlockLoadingService.queueLoadCheck();
        return newNode;
    }
    /**
   * @param index The row index relative to this store
   * @returns A rowNode at the given store index
   */ getRowByStoreIndex(index) {
        var _a;
        return (_a = this.nodeMap.getBy("index", index)) == null ? void 0 : _a.node;
    }
    /**
   * Given a number of rows, skips through the given sequence & row top reference (using default row height)
   * @param numberOfRowsToSkip number of rows to skip over in the given sequence
   * @param displayIndexSeq the sequence in which to skip
   * @param nextRowTop the row top reference in which to skip
   */ skipDisplayIndexes(numberOfRowsToSkip, displayIndexSeq, nextRowTop) {
        if (numberOfRowsToSkip === 0) return;
        const defaultRowHeight = this.gos.getRowHeightAsNumber();
        displayIndexSeq.skip(numberOfRowsToSkip);
        nextRowTop.value += numberOfRowsToSkip * defaultRowHeight;
    }
    /**
   * @param displayIndexSeq the number sequence for generating the display index of each row
   * @param nextRowTop an object containing the next row top value intended to be modified by ref per row
   */ setDisplayIndexes(displayIndexSeq, nextRowTop) {
        this.nodeDisplayIndexMap.clear();
        const orderedMap = {};
        this.nodeMap.forEach((lazyNode)=>{
            orderedMap[lazyNode.index] = lazyNode.node;
        });
        let lastIndex = -1;
        for(const stringIndex in orderedMap){
            const node = orderedMap[stringIndex];
            const numericIndex = Number(stringIndex);
            const numberOfRowsToSkip2 = numericIndex - 1 - lastIndex;
            this.skipDisplayIndexes(numberOfRowsToSkip2, displayIndexSeq, nextRowTop);
            this.blockUtils.setDisplayIndex(node, displayIndexSeq, nextRowTop);
            this.nodeDisplayIndexMap.set(node.rowIndex, node);
            lastIndex = numericIndex;
        }
        const numberOfRowsToSkip = this.numberOfRows - 1 - lastIndex;
        this.skipDisplayIndexes(numberOfRowsToSkip, displayIndexSeq, nextRowTop);
        this.purgeExcessRows();
    }
    getRowCount() {
        return this.numberOfRows;
    }
    setRowCount(rowCount, isLastRowIndexKnown) {
        if (rowCount < 0) throw new Error("AG Grid: setRowCount can only accept a positive row count.");
        this.numberOfRows = rowCount;
        if (isLastRowIndexKnown != null) {
            this.isLastRowKnown = isLastRowIndexKnown;
            if (isLastRowIndexKnown === false) this.numberOfRows += 1;
        }
        this.fireStoreUpdatedEvent();
    }
    getNodes() {
        return this.nodeMap;
    }
    getNodeCachedByDisplayIndex(displayIndex) {
        var _a;
        return (_a = this.nodeDisplayIndexMap.get(displayIndex)) != null ? _a : null;
    }
    getNodesToRefresh() {
        return this.nodesToRefresh;
    }
    /**
   * @returns the previous and next loaded row nodes surrounding the given display index
   */ getSurroundingNodesByDisplayIndex(displayIndex) {
        let nextNode;
        let previousNode;
        this.nodeMap.forEach((lazyNode)=>{
            if (displayIndex > lazyNode.node.rowIndex) {
                if (previousNode == null || previousNode.node.rowIndex < lazyNode.node.rowIndex) previousNode = lazyNode;
                return;
            }
            if (nextNode == null || nextNode.node.rowIndex > lazyNode.node.rowIndex) {
                nextNode = lazyNode;
                return;
            }
        });
        if (!previousNode && !nextNode) return null;
        return {
            previousNode: previousNode,
            nextNode: nextNode
        };
    }
    /**
   * Get or calculate the display index for a given store index
   * @param storeIndex the rows index within this store
   * @returns the rows visible display index relative to the grid
   */ getDisplayIndexFromStoreIndex(storeIndex) {
        var _a, _b;
        const nodeAtIndex = this.nodeMap.getBy("index", storeIndex);
        if (nodeAtIndex) return nodeAtIndex.node.rowIndex;
        let nextNode;
        let previousNode;
        this.nodeMap.forEach((lazyNode)=>{
            if (storeIndex > lazyNode.index) {
                if (previousNode == null || previousNode.index < lazyNode.index) previousNode = lazyNode;
                return;
            }
            if (nextNode == null || nextNode.index > lazyNode.index) {
                nextNode = lazyNode;
                return;
            }
        });
        if (!nextNode) return this.store.getDisplayIndexEnd() - (this.numberOfRows - storeIndex);
        if (!previousNode) return this.store.getDisplayIndexStart() + storeIndex;
        const storeIndexDiff = storeIndex - previousNode.index;
        const previousDisplayIndex = (_b = (_a = previousNode.node.childStore) == null ? void 0 : _a.getDisplayIndexEnd()) != null ? _b : previousNode.node.rowIndex;
        return previousDisplayIndex + storeIndexDiff;
    }
    /**
   * Creates a new row and inserts it at the given index
   * @param atStoreIndex the node index relative to this store
   * @param data the data object to populate the node with 
   * @returns the new row node
   */ createRowAtIndex(atStoreIndex, data, createNodeCallback) {
        var _a, _b;
        const lazyNode = this.nodeMap.getBy("index", atStoreIndex);
        if (lazyNode) {
            const { node: node } = lazyNode;
            node.__needsRefreshWhenVisible = false;
            if (this.doesNodeMatch(data, node)) {
                this.blockUtils.updateDataIntoRowNode(node, data);
                this.nodesToRefresh.delete(node);
                return node;
            }
            if (this.getRowIdFunc == null && node.hasChildren() && node.expanded) {
                this.nodesToRefresh.delete(node);
                return node;
            }
            this.destroyRowAtIndex(atStoreIndex);
        }
        if (data && this.getRowIdFunc != null) {
            const id = this.getRowId(data);
            const deletedNode = id && ((_a = this.removedNodeCache) == null ? void 0 : _a.get(id));
            if (deletedNode) {
                (_b = this.removedNodeCache) == null || _b.delete(id);
                this.blockUtils.updateDataIntoRowNode(deletedNode, data);
                this.nodeMap.set({
                    id: deletedNode.id,
                    node: deletedNode,
                    index: atStoreIndex
                });
                return deletedNode;
            }
            const lazyNode2 = this.nodeMap.getBy("id", id);
            if (lazyNode2) {
                this.nodeMap.delete(lazyNode2);
                const { node: node, index: index } = lazyNode2;
                this.blockUtils.updateDataIntoRowNode(node, data);
                this.nodeMap.set({
                    id: node.id,
                    node: node,
                    index: atStoreIndex
                });
                this.nodesToRefresh.delete(node);
                if (this.getBlockStartIndex(index) === this.getBlockStartIndex(atStoreIndex)) return node;
                this.markBlockForVerify(index);
                return node;
            }
        }
        const newNode = this.blockUtils.createRowNode(this.store.getRowDetails());
        if (data != null) {
            const defaultId = this.getPrefixedId(this.store.getIdSequence().next());
            this.blockUtils.setDataIntoRowNode(newNode, data, defaultId, void 0);
            this.serverSideRowModel.setPaused(true);
            this.blockUtils.checkOpenByDefault(newNode);
            this.serverSideRowModel.setPaused(false);
            this.nodeManager.addRowNode(newNode);
        }
        this.nodeMap.set({
            id: newNode.id,
            node: newNode,
            index: atStoreIndex
        });
        if (createNodeCallback) createNodeCallback(newNode);
        return newNode;
    }
    getBlockStates() {
        const blockCounts = {};
        const blockStates = {};
        this.nodeMap.forEach(({ node: node, index: index })=>{
            var _a;
            const blockStart = this.getBlockStartIndex(index);
            if (!node.stub && !node.failedLoad) blockCounts[blockStart] = ((_a = blockCounts[blockStart]) != null ? _a : 0) + 1;
            let rowState = "loaded";
            if (node.failedLoad) rowState = "failed";
            else if (this.lazyBlockLoadingService.isRowLoading(this, blockStart)) rowState = "loading";
            else if (this.nodesToRefresh.has(node) || node.stub) rowState = "needsLoading";
            if (!blockStates[blockStart]) blockStates[blockStart] = /* @__PURE__ */ new Set();
            blockStates[blockStart].add(rowState);
        });
        const statePriorityMap = {
            loading: 4,
            failed: 3,
            needsLoading: 2,
            loaded: 1
        };
        const blockPrefix = this.blockUtils.createNodeIdPrefix(this.store.getParentNode());
        const results = {};
        Object.entries(blockStates).forEach(([blockStart, uniqueStates])=>{
            var _a;
            const sortedStates = [
                ...uniqueStates
            ].sort((a, b)=>{
                var _a2, _b;
                return ((_a2 = statePriorityMap[a]) != null ? _a2 : 0) - ((_b = statePriorityMap[b]) != null ? _b : 0);
            });
            const priorityState = sortedStates[0];
            const blockNumber = Number(blockStart) / this.getBlockSize();
            const blockId = blockPrefix ? `${blockPrefix}-${blockNumber}` : String(blockNumber);
            results[blockId] = {
                blockNumber: blockNumber,
                startRow: Number(blockStart),
                endRow: Number(blockStart) + this.getBlockSize(),
                pageStatus: priorityState,
                loadedRowCount: (_a = blockCounts[blockStart]) != null ? _a : 0
            };
        });
        return results;
    }
    destroyRowAtIndex(atStoreIndex) {
        const lazyNode = this.nodeMap.getBy("index", atStoreIndex);
        if (!lazyNode) return;
        this.nodeMap.delete(lazyNode);
        this.nodeDisplayIndexMap.delete(lazyNode.node.rowIndex);
        if (this.nodesToRefresh.size > 0) this.removedNodeCache.set(lazyNode.node.id, lazyNode.node);
        else this.blockUtils.destroyRowNode(lazyNode.node);
        this.nodesToRefresh.delete(lazyNode.node);
    }
    getSsrmParams() {
        return this.store.getSsrmParams();
    }
    /**
   * @param id the base id to be prefixed
   * @returns a node id with prefix if required
   */ getPrefixedId(id) {
        if (this.defaultNodeIdPrefix) return this.defaultNodeIdPrefix + "-" + id;
        else return id.toString();
    }
    markBlockForVerify(rowIndex) {
        const [start, end] = this.getBlockBounds(rowIndex);
        const lazyNodesInRange = this.nodeMap.filter((lazyNode)=>lazyNode.index >= start && lazyNode.index < end);
        lazyNodesInRange.forEach(({ node: node })=>{
            node.__needsRefreshWhenVisible = true;
        });
    }
    doesNodeMatch(data, node) {
        if (node.stub) return false;
        if (this.getRowIdFunc != null) {
            const id = this.getRowId(data);
            return node.id === id;
        }
        return node.data === data;
    }
    /**
   * Deletes any stub nodes not within the given range
   */ purgeStubsOutsideOfViewport() {
        const firstRow = this.api.getFirstDisplayedRowIndex();
        const lastRow = this.api.getLastDisplayedRowIndex();
        const firstRowBlockStart = this.getBlockStartIndex(firstRow);
        const [_94, lastRowBlockEnd] = this.getBlockBounds(lastRow);
        this.nodeMap.forEach((lazyNode)=>{
            if (this.lazyBlockLoadingService.isRowLoading(this, lazyNode.index) || lazyNode.node.failedLoad) return;
            if (lazyNode.node.stub && (lazyNode.index < firstRowBlockStart || lazyNode.index > lastRowBlockEnd)) this.destroyRowAtIndex(lazyNode.index);
        });
    }
    getBlocksDistanceFromRow(nodes, otherDisplayIndex) {
        const blockDistanceToMiddle = {};
        nodes.forEach(({ node: node, index: index })=>{
            const [blockStart, blockEnd] = this.getBlockBounds(index);
            if (blockStart in blockDistanceToMiddle) return;
            const distStart = Math.abs(node.rowIndex - otherDisplayIndex);
            let distEnd;
            const lastLazyNode = this.nodeMap.getBy("index", [
                blockEnd - 1
            ]);
            if (lastLazyNode) distEnd = Math.abs(lastLazyNode.node.rowIndex - otherDisplayIndex);
            const farthest = distEnd == null || distStart < distEnd ? distStart : distEnd;
            blockDistanceToMiddle[blockStart] = farthest;
        });
        return Object.entries(blockDistanceToMiddle);
    }
    purgeExcessRows() {
        var _a;
        this.purgeStubsOutsideOfViewport();
        if (this.store.getDisplayIndexEnd() == null || this.storeParams.maxBlocksInCache == null) return;
        const firstRowInViewport = this.api.getFirstDisplayedRowIndex();
        const lastRowInViewport = this.api.getLastDisplayedRowIndex();
        const allLoadedBlocks = /* @__PURE__ */ new Set();
        const blocksInViewport = /* @__PURE__ */ new Set();
        this.nodeMap.forEach(({ index: index, node: node })=>{
            const blockStart = this.getBlockStartIndex(index);
            allLoadedBlocks.add(blockStart);
            const isInViewport = node.rowIndex >= firstRowInViewport && node.rowIndex <= lastRowInViewport;
            if (isInViewport) blocksInViewport.add(blockStart);
        });
        const numberOfBlocksToRetain = Math.max(blocksInViewport.size, (_a = this.storeParams.maxBlocksInCache) != null ? _a : 0);
        const loadedBlockCount = allLoadedBlocks.size;
        const blocksToRemove = loadedBlockCount - numberOfBlocksToRetain;
        if (blocksToRemove <= 0) return;
        let firstRowBlockStart = Number.MAX_SAFE_INTEGER;
        let lastRowBlockStart = Number.MIN_SAFE_INTEGER;
        blocksInViewport.forEach((blockStart)=>{
            if (firstRowBlockStart > blockStart) firstRowBlockStart = blockStart;
            if (lastRowBlockStart < blockStart) lastRowBlockStart = blockStart;
        });
        const disposableNodes = this.nodeMap.filter(({ node: node, index: index })=>{
            const rowBlockStart = this.getBlockStartIndex(index);
            const rowBlockInViewport = rowBlockStart >= firstRowBlockStart && rowBlockStart <= lastRowBlockStart;
            return !rowBlockInViewport && !this.isNodeCached(node);
        });
        if (disposableNodes.length === 0) return;
        const midViewportRow = firstRowInViewport + (lastRowInViewport - firstRowInViewport) / 2;
        const blockDistanceArray = this.getBlocksDistanceFromRow(disposableNodes, midViewportRow);
        const blockSize = this.getBlockSize();
        blockDistanceArray.sort((a, b)=>Math.sign(b[1] - a[1]));
        for(let i = 0; i < Math.min(blocksToRemove, blockDistanceArray.length); i++){
            const blockStart = Number(blockDistanceArray[i][0]);
            for(let x = blockStart; x < blockStart + blockSize; x++){
                const lazyNode = this.nodeMap.getBy("index", x);
                if (!lazyNode || this.isNodeCached(lazyNode.node)) continue;
                this.destroyRowAtIndex(x);
            }
        }
    }
    isNodeFocused(node) {
        const focusedCell = this.focusService.getFocusCellToUseAfterRefresh();
        if (!focusedCell) return false;
        if (focusedCell.rowPinned != null) return false;
        const hasFocus = focusedCell.rowIndex === node.rowIndex;
        return hasFocus;
    }
    isNodeCached(node) {
        return node.isExpandable() && node.expanded || this.isNodeFocused(node);
    }
    extractDuplicateIds(rows) {
        if (this.getRowIdFunc == null) return [];
        const newIds = /* @__PURE__ */ new Set();
        const duplicates = /* @__PURE__ */ new Set();
        rows.forEach((data)=>{
            const id = this.getRowId(data);
            if (newIds.has(id)) {
                duplicates.add(id);
                return;
            }
            newIds.add(id);
        });
        return [
            ...duplicates
        ];
    }
    onLoadSuccess(firstRowIndex, numberOfRowsExpected, response) {
        if (!this.live) return;
        const info = response.groupLevelInfo;
        this.store.setStoreInfo(info);
        if (this.getRowIdFunc != null) {
            const duplicates = this.extractDuplicateIds(response.rowData);
            if (duplicates.length > 0) {
                const duplicateIdText = duplicates.join(", ");
                console.warn(`AG Grid: Unable to display rows as duplicate row ids (${duplicateIdText}) were returned by the getRowId callback. Please modify the getRowId callback to provide unique ids.`);
                this.onLoadFailed(firstRowIndex, numberOfRowsExpected);
                return;
            }
        }
        if (response.pivotResultFields) this.serverSideRowModel.generateSecondaryColumns(response.pivotResultFields);
        const wasRefreshing = this.nodesToRefresh.size > 0;
        response.rowData.forEach((data, responseRowIndex)=>{
            var _a;
            const rowIndex = firstRowIndex + responseRowIndex;
            const nodeFromCache = this.nodeMap.getBy("index", rowIndex);
            if ((_a = nodeFromCache == null ? void 0 : nodeFromCache.node) == null ? void 0 : _a.stub) {
                this.createRowAtIndex(rowIndex, data);
                return;
            }
            if (nodeFromCache && this.doesNodeMatch(data, nodeFromCache.node)) {
                this.blockUtils.updateDataIntoRowNode(nodeFromCache.node, data);
                this.nodesToRefresh.delete(nodeFromCache.node);
                nodeFromCache.node.__needsRefreshWhenVisible = false;
                return;
            }
            this.createRowAtIndex(rowIndex, data);
        });
        if (response.rowCount != void 0 && response.rowCount !== -1) {
            this.numberOfRows = response.rowCount;
            this.isLastRowKnown = true;
        } else if (numberOfRowsExpected > response.rowData.length) {
            this.numberOfRows = firstRowIndex + response.rowData.length;
            this.isLastRowKnown = true;
        } else if (!this.isLastRowKnown) {
            const lastInferredRow = firstRowIndex + response.rowData.length + 1;
            if (lastInferredRow > this.numberOfRows) this.numberOfRows = lastInferredRow;
        }
        if (this.isLastRowKnown) {
            const lazyNodesAfterStoreEnd = this.nodeMap.filter((lazyNode)=>lazyNode.index >= this.numberOfRows);
            lazyNodesAfterStoreEnd.forEach((lazyNode)=>this.destroyRowAtIndex(lazyNode.index));
        }
        this.fireStoreUpdatedEvent();
        const finishedRefreshing = this.nodesToRefresh.size === 0;
        if (wasRefreshing && finishedRefreshing) this.fireRefreshFinishedEvent();
    }
    fireRefreshFinishedEvent() {
        const finishedRefreshing = this.nodesToRefresh.size === 0;
        if (!finishedRefreshing) return;
        this.removedNodeCache.forEach((node)=>{
            this.blockUtils.destroyRowNode(node);
        });
        this.removedNodeCache = /* @__PURE__ */ new Map();
        this.store.fireRefreshFinishedEvent();
    }
    /**
   * @returns true if all rows are loaded
   */ isStoreFullyLoaded() {
        const knowsSize = this.isLastRowKnown;
        const hasCorrectRowCount = this.nodeMap.getSize() === this.numberOfRows;
        if (!knowsSize || !hasCorrectRowCount) return;
        if (this.nodesToRefresh.size > 0) return;
        let index = -1;
        const firstOutOfPlaceNode = this.nodeMap.find((lazyNode)=>{
            index += 1;
            if (lazyNode.index !== index) return true;
            if (lazyNode.node.__needsRefreshWhenVisible) return true;
            if (lazyNode.node.stub) return true;
            return false;
        });
        return firstOutOfPlaceNode == null;
    }
    isLastRowIndexKnown() {
        return this.isLastRowKnown;
    }
    onLoadFailed(firstRowIndex, numberOfRowsExpected) {
        var _a;
        if (!this.live) return;
        const wasRefreshing = this.nodesToRefresh.size > 0;
        for(let i = firstRowIndex; i < firstRowIndex + numberOfRowsExpected && i < this.getRowCount(); i++){
            let { node: node } = (_a = this.nodeMap.getBy("index", i)) != null ? _a : {};
            if (node) this.nodesToRefresh.delete(node);
            if (!node || !node.stub) {
                if (node && !node.stub) this.destroyRowAtIndex(i);
                node = this.createRowAtIndex(i);
            }
            node.__needsRefreshWhenVisible = false;
            node.failedLoad = true;
        }
        const finishedRefreshing = this.nodesToRefresh.size === 0;
        if (wasRefreshing && finishedRefreshing) this.fireRefreshFinishedEvent();
        this.fireStoreUpdatedEvent();
    }
    markNodesForRefresh() {
        this.nodeMap.forEach((lazyNode)=>{
            if (lazyNode.node.stub && !lazyNode.node.failedLoad) return;
            this.nodesToRefresh.add(lazyNode.node);
        });
        this.lazyBlockLoadingService.queueLoadCheck();
        if (this.isLastRowKnown && this.numberOfRows === 0) {
            this.numberOfRows = 1;
            this.isLastRowKnown = false;
            this.fireStoreUpdatedEvent();
        }
    }
    isNodeInCache(id) {
        return !!this.nodeMap.getBy("id", id);
    }
    // gets called 1) row count changed 2) cache purged 3) items inserted
    fireStoreUpdatedEvent() {
        if (!this.live) return;
        this.store.fireStoreUpdatedEvent();
    }
    getRowId(data) {
        if (this.getRowIdFunc == null) return null;
        const { level: level } = this.store.getRowDetails();
        const parentKeys = this.store.getParentNode().getGroupKeys();
        const id = this.getRowIdFunc({
            data: data,
            parentKeys: parentKeys.length > 0 ? parentKeys : void 0,
            level: level
        });
        return String(id);
    }
    getOrderedNodeMap() {
        const obj = {};
        this.nodeMap.forEach((node)=>obj[node.index] = node);
        return obj;
    }
    clearDisplayIndexes() {
        this.nodeDisplayIndexMap.clear();
    }
    /**
   * Client side sorting
   */ clientSideSortRows() {
        const sortOptions = this.sortController.getSortOptions();
        const isAnySort = sortOptions.some((opt)=>opt.sort != null);
        if (!isAnySort) return;
        const allNodes = new Array(this.nodeMap.getSize());
        this.nodeMap.forEach((lazyNode)=>allNodes[lazyNode.index] = lazyNode.node);
        this.nodeMap.clear();
        const sortedNodes = this.rowNodeSorter.doFullSort(allNodes, sortOptions);
        sortedNodes.forEach((node, index)=>{
            this.nodeMap.set({
                id: node.id,
                node: node,
                index: index
            });
        });
    }
    /**
   * Transaction Support here
   */ updateRowNodes(updates) {
        if (this.getRowIdFunc == null) throw new Error("AG Grid: Transactions can only be applied when row ids are supplied.");
        const updatedNodes = [];
        updates.forEach((data)=>{
            const id = this.getRowId(data);
            const lazyNode = this.nodeMap.getBy("id", id);
            if (lazyNode) {
                this.blockUtils.updateDataIntoRowNode(lazyNode.node, data);
                updatedNodes.push(lazyNode.node);
            }
        });
        return updatedNodes;
    }
    insertRowNodes(inserts, indexToAdd) {
        const realRowCount = this.store.getRowCount() - (this.store.getParentNode().sibling ? 1 : 0);
        const addIndex = indexToAdd == null && this.isLastRowKnown ? realRowCount : indexToAdd;
        if (addIndex == null || realRowCount < addIndex) return [];
        if (this.getRowIdFunc == null) throw new Error("AG Grid: Transactions can only be applied when row ids are supplied.");
        const uniqueInsertsMap = {};
        inserts.forEach((data)=>{
            const dataId = this.getRowId(data);
            if (dataId && this.isNodeInCache(dataId)) return;
            uniqueInsertsMap[dataId] = data;
        });
        const uniqueInserts = Object.values(uniqueInsertsMap);
        let numberOfInserts = uniqueInserts.length;
        if (numberOfInserts === 0) return [];
        const nodesToMove = this.nodeMap.filter((node)=>node.index >= addIndex);
        nodesToMove.forEach((lazyNode)=>this.nodeMap.delete(lazyNode));
        nodesToMove.forEach((lazyNode)=>{
            this.nodeMap.set({
                node: lazyNode.node,
                index: lazyNode.index + numberOfInserts,
                id: lazyNode.id
            });
        });
        this.numberOfRows += numberOfInserts;
        return uniqueInserts.map((data, uniqueInsertOffset)=>this.createRowAtIndex(addIndex + uniqueInsertOffset, data));
    }
    removeRowNodes(idsToRemove) {
        if (this.getRowIdFunc == null) throw new Error("AG Grid: Transactions can only be applied when row ids are supplied.");
        const removedNodes = [];
        const nodesToVerify = [];
        let deletedNodeCount = 0;
        const remainingIdsToRemove = [
            ...idsToRemove
        ];
        const allNodes = this.getOrderedNodeMap();
        let contiguousIndex = -1;
        for(let stringIndex in allNodes){
            contiguousIndex += 1;
            const node = allNodes[stringIndex];
            const matchIndex = remainingIdsToRemove.findIndex((idToRemove)=>idToRemove === node.id);
            if (matchIndex !== -1) {
                remainingIdsToRemove.splice(matchIndex, 1);
                this.destroyRowAtIndex(Number(stringIndex));
                removedNodes.push(node.node);
                deletedNodeCount += 1;
                continue;
            }
            if (deletedNodeCount === 0) continue;
            const numericStoreIndex = Number(stringIndex);
            if (contiguousIndex !== numericStoreIndex) nodesToVerify.push(node.node);
            this.nodeMap.delete(allNodes[stringIndex]);
            this.nodeMap.set({
                id: node.id,
                node: node.node,
                index: numericStoreIndex - deletedNodeCount
            });
        }
        this.numberOfRows -= this.isLastRowIndexKnown() ? idsToRemove.length : deletedNodeCount;
        if (remainingIdsToRemove.length > 0 && nodesToVerify.length > 0) {
            nodesToVerify.forEach((node)=>node.__needsRefreshWhenVisible = true);
            this.lazyBlockLoadingService.queueLoadCheck();
        }
        return removedNodes;
    }
    /**
   * Return the block size configured for this cache
   */ getBlockSize() {
        return this.storeParams.cacheBlockSize || $5b7ccabde48fae90$var$LazyBlockLoadingService.DEFAULT_BLOCK_SIZE;
    }
    /**
   * Get the start index of the loading block for a given index
   */ getBlockStartIndex(storeIndex) {
        const blockSize = this.getBlockSize();
        return storeIndex - storeIndex % blockSize;
    }
    /**
   * Get the start and end index of a block, given a row store index
   */ getBlockBounds(storeIndex) {
        const startOfBlock = this.getBlockStartIndex(storeIndex);
        const blockSize = this.getBlockSize();
        return [
            startOfBlock,
            startOfBlock + blockSize
        ];
    }
};
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("gridApi")
], $5b7ccabde48fae90$var$LazyCache.prototype, "api", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("ssrmBlockUtils")
], $5b7ccabde48fae90$var$LazyCache.prototype, "blockUtils", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("focusService")
], $5b7ccabde48fae90$var$LazyCache.prototype, "focusService", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("ssrmNodeManager")
], $5b7ccabde48fae90$var$LazyCache.prototype, "nodeManager", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("rowModel")
], $5b7ccabde48fae90$var$LazyCache.prototype, "serverSideRowModel", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("rowNodeSorter")
], $5b7ccabde48fae90$var$LazyCache.prototype, "rowNodeSorter", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("sortController")
], $5b7ccabde48fae90$var$LazyCache.prototype, "sortController", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("lazyBlockLoadingService")
], $5b7ccabde48fae90$var$LazyCache.prototype, "lazyBlockLoadingService", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$LazyCache.prototype, "init", 1);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.PreDestroy)
], $5b7ccabde48fae90$var$LazyCache.prototype, "destroyRowNodes", 1);
var $5b7ccabde48fae90$var$LazyStore = class extends (0, $jIDNV.BeanStub) {
    constructor(ssrmParams, storeParams, parentRowNode){
        super();
        this.idSequence = new (0, $jIDNV.NumberSequence)();
        this.ssrmParams = ssrmParams;
        this.parentRowNode = parentRowNode;
        this.storeParams = storeParams;
        this.level = parentRowNode.level + 1;
        this.group = ssrmParams.rowGroupCols ? this.level < ssrmParams.rowGroupCols.length : false;
        this.leafGroup = ssrmParams.rowGroupCols ? this.level === ssrmParams.rowGroupCols.length - 1 : false;
        this.info = {};
    }
    init() {
        var _a;
        let numberOfRows = 1;
        if (this.level === 0) {
            numberOfRows = (_a = this.storeUtils.getServerSideInitialRowCount()) != null ? _a : 1;
            this.eventService.dispatchEventOnce({
                type: (0, $jIDNV.Events).EVENT_ROW_COUNT_READY
            });
        }
        this.cache = this.createManagedBean(new $5b7ccabde48fae90$var$LazyCache(this, numberOfRows, this.storeParams));
        const usingTreeData = this.gos.get("treeData");
        if (!usingTreeData && this.group) {
            const groupColVo = this.ssrmParams.rowGroupCols[this.level];
            this.groupField = groupColVo.field;
            this.rowGroupColumn = this.columnModel.getRowGroupColumns()[this.level];
        }
    }
    destroyRowNodes() {
        this.displayIndexStart = void 0;
        this.displayIndexEnd = void 0;
        this.destroyBean(this.cache);
    }
    /**
   * Given a server response, ingest the rows outside of the data source lifecycle.
   * 
   * @param rowDataParams the server response containing the rows to ingest
   * @param startRow the index to start ingesting rows
   * @param expectedRows the expected number of rows in the response (used to determine if the last row index is known)
   */ applyRowData(rowDataParams, startRow, expectedRows) {
        this.cache.onLoadSuccess(startRow, expectedRows, rowDataParams);
    }
    /**
   * Applies a given transaction to the data set within this store
   * 
   * @param transaction an object containing delta instructions determining the changes to apply to this store
   * @returns an object determining the status of this transaction and effected nodes
   */ applyTransaction(transaction) {
        var _a, _b, _c;
        const idFunc = this.gos.getCallback("getRowId");
        if (!idFunc) {
            console.warn("AG Grid: getRowId callback must be implemented for transactions to work. Transaction was ignored.");
            return {
                status: (0, $jIDNV.ServerSideTransactionResultStatus).Cancelled
            };
        }
        const applyCallback = this.gos.getCallback("isApplyServerSideTransaction");
        if (applyCallback) {
            const params = {
                transaction: transaction,
                parentNode: this.parentRowNode,
                groupLevelInfo: this.info
            };
            const apply = applyCallback(params);
            if (!apply) return {
                status: (0, $jIDNV.ServerSideTransactionResultStatus).Cancelled
            };
        }
        const allRowsLoaded = this.cache.isStoreFullyLoaded();
        let updatedNodes = void 0;
        if ((_a = transaction.update) == null ? void 0 : _a.length) updatedNodes = this.cache.updateRowNodes(transaction.update);
        let insertedNodes = void 0;
        if ((_b = transaction.add) == null ? void 0 : _b.length) {
            let addIndex = transaction.addIndex;
            if (addIndex != null && addIndex < 0) addIndex = void 0;
            insertedNodes = this.cache.insertRowNodes(transaction.add, addIndex);
        }
        let removedNodes = void 0;
        if ((_c = transaction.remove) == null ? void 0 : _c.length) {
            const allIdsToRemove = transaction.remove.map((data)=>idFunc({
                    level: this.level,
                    parentKeys: this.parentRowNode.getGroupKeys(),
                    data: data
                }));
            const allUniqueIdsToRemove = [
                ...new Set(allIdsToRemove)
            ];
            removedNodes = this.cache.removeRowNodes(allUniqueIdsToRemove);
        }
        const isClientSideSortingEnabled = this.gos.get("serverSideEnableClientSideSort");
        const isUpdateOrAdd = (updatedNodes == null ? void 0 : updatedNodes.length) || (insertedNodes == null ? void 0 : insertedNodes.length);
        const isClientSideSort = allRowsLoaded && isClientSideSortingEnabled;
        if (isClientSideSort && isUpdateOrAdd) this.cache.clientSideSortRows();
        this.updateSelectionAfterTransaction(updatedNodes, removedNodes);
        return {
            status: (0, $jIDNV.ServerSideTransactionResultStatus).Applied,
            update: updatedNodes,
            add: insertedNodes,
            remove: removedNodes
        };
    }
    updateSelectionAfterTransaction(updatedNodes, removedNodes) {
        const nodesToDeselect = [];
        updatedNodes == null || updatedNodes.forEach((node)=>{
            if (node.isSelected() && !node.selectable) nodesToDeselect.push(node);
        });
        removedNodes == null || removedNodes.forEach((node)=>{
            if (node.isSelected()) nodesToDeselect.push(node);
        });
        if (nodesToDeselect.length) this.selectionService.setNodesSelected({
            newValue: false,
            clearSelection: false,
            nodes: nodesToDeselect,
            source: "rowDataChanged"
        });
    }
    /**
   * Clear the display indexes, used for fading rows out when stores are not being destroyed
   */ clearDisplayIndexes() {
        this.displayIndexStart = void 0;
        this.displayIndexEnd = void 0;
        this.cache.getNodes().forEach((lazyNode)=>this.blockUtils.clearDisplayIndex(lazyNode.node));
        if (this.parentRowNode.sibling) this.blockUtils.clearDisplayIndex(this.parentRowNode.sibling);
        this.cache.clearDisplayIndexes();
    }
    /**
   * @returns an index representing the last sequentially displayed row in the grid for this store
   */ getDisplayIndexStart() {
        return this.displayIndexStart;
    }
    /**
   * @returns the index representing one after the last sequentially displayed row in the grid for this store
   */ getDisplayIndexEnd() {
        return this.displayIndexEnd;
    }
    /** 
   * @returns the virtual size of this store
   */ getRowCount() {
        if (this.parentRowNode.sibling) return this.cache.getRowCount() + 1;
        return this.cache.getRowCount();
    }
    /** 
   * Sets the current row count of the store, and whether the last row index is known
   */ setRowCount(rowCount, isLastRowIndexKnown) {
        this.cache.setRowCount(rowCount, isLastRowIndexKnown);
    }
    /**
   * Given a display index, returns whether that row is within this store or a child store of this store
   * 
   * @param displayIndex the visible index of a row
   * @returns whether or not the row exists within this store
   */ isDisplayIndexInStore(displayIndex) {
        if (this.cache.getRowCount() === 0) return false;
        return this.displayIndexStart <= displayIndex && displayIndex < this.getDisplayIndexEnd();
    }
    /**
   * Recursively sets up the display indexes and top position of every node belonging to this store.
   * 
   * Called after a row height changes, or a store updated event.
   * 
   * @param displayIndexSeq the number sequence for generating the display index of each row
   * @param nextRowTop an object containing the next row top value intended to be modified by ref per row
   */ setDisplayIndexes(displayIndexSeq, nextRowTop) {
        this.displayIndexStart = displayIndexSeq.peek();
        this.topPx = nextRowTop.value;
        const footerNode = this.parentRowNode.level > -1 && this.gos.getGroupTotalRowCallback()({
            node: this.parentRowNode
        });
        if (!footerNode) this.parentRowNode.destroyFooter();
        if (footerNode === "top") {
            this.parentRowNode.createFooter();
            this.blockUtils.setDisplayIndex(this.parentRowNode.sibling, displayIndexSeq, nextRowTop);
        }
        this.cache.setDisplayIndexes(displayIndexSeq, nextRowTop);
        if (footerNode === "bottom") {
            this.parentRowNode.createFooter();
            this.blockUtils.setDisplayIndex(this.parentRowNode.sibling, displayIndexSeq, nextRowTop);
        }
        this.displayIndexEnd = displayIndexSeq.peek();
        this.heightPx = nextRowTop.value - this.topPx;
    }
    /**
   * Recursively applies a provided function to every node
   * 
   * For the purpose of exclusively server side filtered stores, this is the same as getNodes().forEachDeepAfterFilterAndSort
   */ forEachStoreDeep(callback, sequence = new (0, $jIDNV.NumberSequence)()) {
        callback(this, sequence.next());
        this.cache.getNodes().forEach((lazyNode)=>{
            const childCache = lazyNode.node.childStore;
            if (childCache) childCache.forEachStoreDeep(callback, sequence);
        });
    }
    /**
   * Recursively applies a provided function to every node
   * 
   * For the purpose of exclusively server side filtered stores, this is the same as getNodes().forEachDeepAfterFilterAndSort
   */ forEachNodeDeep(callback, sequence = new (0, $jIDNV.NumberSequence)()) {
        this.cache.getNodes().forEach((lazyNode)=>{
            callback(lazyNode.node, sequence.next());
            const childCache = lazyNode.node.childStore;
            if (childCache) childCache.forEachNodeDeep(callback, sequence);
        });
    }
    /**
   * Recursively applies a provided function to every node
   * 
   * For the purpose of exclusively server side filtered stores, this is the same as getNodes().forEachDeep
   */ forEachNodeDeepAfterFilterAndSort(callback, sequence = new (0, $jIDNV.NumberSequence)(), includeFooterNodes = false) {
        const footerNode = this.parentRowNode.level > -1 && this.gos.getGroupTotalRowCallback()({
            node: this.parentRowNode
        });
        if (footerNode === "top") callback(this.parentRowNode.sibling, sequence.next());
        const orderedNodes = this.cache.getOrderedNodeMap();
        for(let key in orderedNodes){
            const lazyNode = orderedNodes[key];
            callback(lazyNode.node, sequence.next());
            const childCache = lazyNode.node.childStore;
            if (childCache) childCache.forEachNodeDeepAfterFilterAndSort(callback, sequence, includeFooterNodes);
        }
        if (footerNode === "bottom") callback(this.parentRowNode.sibling, sequence.next());
    }
    /**
   * Removes the failed status from all nodes, and marks them as stub to encourage reloading
   */ retryLoads() {
        this.cache.getNodes().forEach(({ node: node })=>{
            if (node.failedLoad) {
                node.failedLoad = false;
                node.__needsRefreshWhenVisible = true;
                node.stub = true;
            }
        });
        this.forEachChildStoreShallow((store)=>store.retryLoads());
        this.fireStoreUpdatedEvent();
    }
    /**
   * Given a display index, returns the row at that location.
   * 
   * @param displayRowIndex the displayed index within the grid to search for
   * @returns the row node if the display index falls within the store, if it didn't exist this will create a new stub to return
   */ getRowUsingDisplayIndex(displayRowIndex) {
        if (this.parentRowNode.sibling && displayRowIndex === this.parentRowNode.sibling.rowIndex) return this.parentRowNode.sibling;
        return this.cache.getRowByDisplayIndex(displayRowIndex);
    }
    /**
   * Given a display index, returns the row top and height for the row at that index.
   * 
   * @param displayIndex the display index of the node
   * @returns an object containing the rowTop and rowHeight of the node at the given displayIndex
   */ getRowBounds(displayIndex) {
        var _a;
        if (!this.isDisplayIndexInStore(displayIndex)) return null;
        const thisNode = this.cache.getNodeCachedByDisplayIndex(displayIndex);
        if (thisNode) {
            const boundsFromRow = this.blockUtils.extractRowBounds(thisNode, displayIndex);
            if (boundsFromRow) return boundsFromRow;
        }
        const { previousNode: previousNode, nextNode: nextNode } = (_a = this.cache.getSurroundingNodesByDisplayIndex(displayIndex)) != null ? _a : {};
        if (previousNode) {
            const boundsFromRow = this.blockUtils.extractRowBounds(previousNode.node, displayIndex);
            if (boundsFromRow != null) return boundsFromRow;
        }
        const defaultRowHeight = this.gos.getRowHeightAsNumber();
        if (nextNode) {
            const numberOfRowDiff2 = (nextNode.node.rowIndex - displayIndex) * defaultRowHeight;
            return {
                rowTop: nextNode.node.rowTop - numberOfRowDiff2,
                rowHeight: defaultRowHeight
            };
        }
        const lastTop = this.topPx + this.heightPx;
        const numberOfRowDiff = (this.getDisplayIndexEnd() - displayIndex) * defaultRowHeight;
        return {
            rowTop: lastTop - numberOfRowDiff,
            rowHeight: defaultRowHeight
        };
    }
    /**
   * Given a vertical pixel, determines whether this store contains a row at that pixel
   * 
   * @param pixel a vertical pixel position from the grid
   * @returns whether that pixel points to a virtual space belonging to this store
   */ isPixelInRange(pixel) {
        return pixel >= this.topPx && pixel < this.topPx + this.heightPx;
    }
    /**
   * Given a vertical pixel, returns the row existing at that pixel location
   * 
   * @param pixel a vertical pixel position from the grid
   * @returns the display index at the given pixel location
   */ getRowIndexAtPixel(pixel) {
        if (pixel < this.topPx) return this.getDisplayIndexStart();
        if (pixel >= this.topPx + this.heightPx) return this.getDisplayIndexEnd() - 1;
        if (this.parentRowNode.sibling && pixel > this.parentRowNode.sibling.rowTop && pixel < this.parentRowNode.sibling.rowTop + this.parentRowNode.sibling.rowHeight) return this.parentRowNode.sibling.rowIndex;
        let distToPreviousNodeTop = Number.MAX_SAFE_INTEGER;
        let previousNode = null;
        let distToNextNodeTop = Number.MAX_SAFE_INTEGER;
        let nextNode = null;
        this.cache.getNodes().forEach(({ node: node })=>{
            const distBetween = Math.abs(pixel - node.rowTop);
            if (node.rowTop < pixel) {
                if (distBetween < distToPreviousNodeTop) {
                    distToPreviousNodeTop = distBetween;
                    previousNode = node;
                }
                return;
            }
            if (distBetween < distToNextNodeTop) {
                distToNextNodeTop = distBetween;
                nextNode = node;
            }
        });
        previousNode;
        nextNode;
        if (previousNode) {
            const indexOfRow = this.blockUtils.getIndexAtPixel(previousNode, pixel);
            if (indexOfRow != null) return indexOfRow;
        }
        const defaultRowHeight = this.gos.getRowHeightAsNumber();
        if (nextNode) {
            const nextTop2 = nextNode.rowTop;
            const numberOfRowDiff2 = Math.ceil((nextTop2 - pixel) / defaultRowHeight);
            return nextNode.rowIndex - numberOfRowDiff2;
        }
        const nextTop = this.topPx + this.heightPx;
        const numberOfRowDiff = Math.floor((nextTop - pixel) / defaultRowHeight);
        return this.getDisplayIndexEnd() - numberOfRowDiff;
    }
    /**
   * Given a path of group keys, returns the child store for that group.
   * 
   * @param keys the grouping path to the desired store
   * @returns the child store for the given keys, or null if not found
   */ getChildStore(keys) {
        return this.storeUtils.getChildStore(keys, this, (key)=>{
            const lazyNode = this.cache.getNodes().find((lazyNode2)=>lazyNode2.node.key == key);
            if (!lazyNode) return null;
            return lazyNode.node;
        });
    }
    /**
   * Executes a provided callback on each child store belonging to this store
   * 
   * @param cb the callback to execute
   */ forEachChildStoreShallow(cb) {
        this.cache.getNodes().forEach(({ node: node })=>{
            if (node.childStore) cb(node.childStore);
        });
    }
    /**
   * Executes after a change to sorting, determines recursively whether this store or a child requires refreshed.
   * 
   * If a purge refresh occurs, the row count is preserved.
   * 
   * @param params a set of properties pertaining to the sort changes
   */ refreshAfterSort(params) {
        const serverSortsAllLevels = this.storeUtils.isServerSideSortAllLevels();
        if (serverSortsAllLevels || this.storeUtils.isServerRefreshNeeded(this.parentRowNode, this.ssrmParams.rowGroupCols, params)) {
            const allRowsLoaded = this.cache.isStoreFullyLoaded();
            const isClientSideSortingEnabled = this.gos.get("serverSideEnableClientSideSort");
            const isClientSideSort = allRowsLoaded && isClientSideSortingEnabled;
            if (!isClientSideSort) {
                const oldCount = this.cache.getRowCount();
                this.destroyBean(this.cache);
                this.cache = this.createManagedBean(new $5b7ccabde48fae90$var$LazyCache(this, oldCount, this.storeParams));
                return;
            }
            this.cache.clientSideSortRows();
        }
        this.forEachChildStoreShallow((store)=>store.refreshAfterSort(params));
    }
    /**
   * Executes after a change to filtering, determines recursively whether this store or a child requires refreshed.
   * 
   * If a refresh occurs, the row count is reset.
   * 
   * @param params a set of properties pertaining to the filter changes
   */ refreshAfterFilter(params) {
        const serverFiltersAllLevels = !this.storeUtils.isServerSideOnlyRefreshFilteredGroups();
        if (serverFiltersAllLevels || this.storeUtils.isServerRefreshNeeded(this.parentRowNode, this.ssrmParams.rowGroupCols, params)) {
            this.refreshStore(true);
            return;
        }
        this.forEachChildStoreShallow((store)=>store.refreshAfterFilter(params));
    }
    /**
   * Marks all existing nodes as requiring reloaded, and triggers a load check
   *
   * @param purge whether to remove all nodes and data in favour of stub nodes
   */ refreshStore(purge) {
        if (purge) {
            this.destroyBean(this.cache);
            this.cache = this.createManagedBean(new $5b7ccabde48fae90$var$LazyCache(this, 1, this.storeParams));
            this.fireStoreUpdatedEvent();
            return;
        }
        this.cache.markNodesForRefresh();
    }
    /**
   * Used for pagination, given a local/store index, returns the display index of that row
   * 
   * @param topLevelIndex the store index of a row
   * @returns the display index for the given store index
   */ getTopLevelRowDisplayedIndex(topLevelIndex) {
        const displayIndex = this.cache.getDisplayIndexFromStoreIndex(topLevelIndex);
        return displayIndex != null ? displayIndex : topLevelIndex;
    }
    /**
   * Used for pagination to determine if the last page is known, and for aria to determine if the last grid row is known
   * 
   * @returns whether the last index of this store is known, or if lazy loading still required
   */ isLastRowIndexKnown() {
        return this.cache.isLastRowIndexKnown();
    }
    /**
   * Used by the selection service to select a range of nodes
   * 
   * @param firstInRange the first node in the range to find
   * @param lastInRange the last node in the range to find
   * @returns a range of nodes between firstInRange and lastInRange inclusive
   */ getRowNodesInRange(firstInRange, lastInRange) {
        const result = [];
        let inActiveRange = false;
        if ((0, $jIDNV._).missing(firstInRange)) inActiveRange = true;
        return this.cache.getNodes().filter(({ node: node })=>{
            return node.rowIndex >= firstInRange.rowIndex && node.rowIndex <= lastInRange.rowIndex;
        }).map(({ node: node })=>node);
    }
    /**
   * Mutates a given array to add this stores state, and recursively add all the children store states.
   * 
   * @param result a mutable results array
   */ addStoreStates(result) {
        result.push({
            suppressInfiniteScroll: false,
            route: this.parentRowNode.getGroupKeys(),
            rowCount: this.getRowCount(),
            lastRowIndexKnown: this.isLastRowIndexKnown(),
            info: this.info,
            maxBlocksInCache: this.storeParams.maxBlocksInCache,
            cacheBlockSize: this.storeParams.cacheBlockSize
        });
        this.forEachChildStoreShallow((childStore)=>childStore.addStoreStates(result));
    }
    getIdSequence() {
        return this.idSequence;
    }
    getParentNode() {
        return this.parentRowNode;
    }
    getRowDetails() {
        return {
            field: this.groupField,
            group: this.group,
            leafGroup: this.leafGroup,
            level: this.level,
            parent: this.parentRowNode,
            rowGroupColumn: this.rowGroupColumn
        };
    }
    getSsrmParams() {
        return this.ssrmParams;
    }
    setStoreInfo(info) {
        if (info) Object.assign(this.info, info);
    }
    // gets called 1) row count changed 2) cache purged
    fireStoreUpdatedEvent() {
        const event = {
            type: (0, $jIDNV.Events).EVENT_STORE_UPDATED
        };
        this.eventService.dispatchEvent(event);
    }
    // gets called when row data updated, and no more refreshing needed
    fireRefreshFinishedEvent() {
        const event = {
            type: (0, $jIDNV.Events).EVENT_STORE_REFRESHED,
            route: this.parentRowNode.getRoute()
        };
        this.eventService.dispatchEvent(event);
    }
    getBlockStates() {
        return this.cache.getBlockStates();
    }
    getStoreBounds() {
        return {
            topPx: this.topPx,
            heightPx: this.heightPx
        };
    }
    getCache() {
        return this.cache;
    }
};
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("ssrmBlockUtils")
], $5b7ccabde48fae90$var$LazyStore.prototype, "blockUtils", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("ssrmStoreUtils")
], $5b7ccabde48fae90$var$LazyStore.prototype, "storeUtils", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$LazyStore.prototype, "columnModel", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("selectionService")
], $5b7ccabde48fae90$var$LazyStore.prototype, "selectionService", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$LazyStore.prototype, "init", 1);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.PreDestroy)
], $5b7ccabde48fae90$var$LazyStore.prototype, "destroyRowNodes", 1);
var $5b7ccabde48fae90$var$ServerSideRowModel = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.onRowHeightChanged_debounced = (0, $jIDNV._).debounce(this.onRowHeightChanged.bind(this), 100);
        this.pauseStoreUpdateListening = false;
        this.started = false;
        this.managingPivotResultColumns = false;
    }
    // we don't implement as lazy row heights is not supported in this row model
    ensureRowHeightsValid() {
        return false;
    }
    start() {
        this.started = true;
        this.updateDatasource();
    }
    destroyDatasource() {
        if (!this.datasource) return;
        if (this.datasource.destroy) this.datasource.destroy();
        this.rowRenderer.datasourceChanged();
        this.datasource = void 0;
    }
    addEventListeners() {
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_NEW_COLUMNS_LOADED, this.onColumnEverything.bind(this));
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_STORE_UPDATED, this.onStoreUpdated.bind(this));
        const resetListener = this.resetRootStore.bind(this);
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_COLUMN_VALUE_CHANGED, resetListener);
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_COLUMN_PIVOT_CHANGED, resetListener);
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_COLUMN_ROW_GROUP_CHANGED, resetListener);
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_COLUMN_PIVOT_MODE_CHANGED, resetListener);
        this.addManagedPropertyListeners([
            /**
       * Following properties omitted as they are likely to come with undesired  side effects.
       * 'getRowId', 'isRowMaster', 'getRowHeight', 'isServerSideGroup', 'getServerSideGroupKey',
       * */ "masterDetail",
            "treeData",
            "removePivotHeaderRowWhenSingleValueColumn",
            "suppressServerSideInfiniteScroll",
            "cacheBlockSize"
        ], resetListener);
        this.addManagedPropertyListener("rowHeight", ()=>this.resetRowHeights());
        this.verifyProps();
        this.addManagedPropertyListener("serverSideDatasource", ()=>this.updateDatasource());
    }
    updateDatasource() {
        const datasource = this.gos.get("serverSideDatasource");
        if (datasource) this.setDatasource(datasource);
    }
    verifyProps() {
        if (this.gos.exists("initialGroupOrderComparator")) (0, $jIDNV._).warnOnce(`initialGroupOrderComparator cannot be used with Server Side Row Model.`);
        if (this.gos.isRowSelection() && !this.gos.exists("getRowId")) (0, $jIDNV._).warnOnce(`getRowId callback must be provided for Server Side Row Model selection to work correctly.`);
    }
    setDatasource(datasource) {
        if (!this.started) return;
        this.destroyDatasource();
        this.datasource = datasource;
        this.resetRootStore();
    }
    applyRowData(rowDataParams, startRow, route) {
        const rootStore = this.getRootStore();
        if (!rootStore) return;
        const storeToExecuteOn = rootStore.getChildStore(route);
        if (!storeToExecuteOn) return;
        if (storeToExecuteOn instanceof $5b7ccabde48fae90$var$LazyStore) storeToExecuteOn.applyRowData(rowDataParams, startRow, rowDataParams.rowData.length);
        else if (storeToExecuteOn instanceof $5b7ccabde48fae90$var$FullStore) storeToExecuteOn.processServerResult(rowDataParams);
    }
    isLastRowIndexKnown() {
        const cache = this.getRootStore();
        if (!cache) return false;
        return cache.isLastRowIndexKnown();
    }
    onColumnEverything() {
        if (!this.storeParams) {
            this.resetRootStore();
            return;
        }
        const rowGroupColumnVos = this.columnsToValueObjects(this.columnModel.getRowGroupColumns());
        const valueColumnVos = this.columnsToValueObjects(this.columnModel.getValueColumns());
        const pivotColumnVos = this.columnsToValueObjects(this.columnModel.getPivotColumns());
        const areColsSame = (params)=>{
            const oldColsMap = {};
            params.oldCols.forEach((col)=>oldColsMap[col.id] = col);
            const allColsUnchanged = params.newCols.every((col)=>{
                const equivalentCol = oldColsMap[col.id];
                if (equivalentCol) delete oldColsMap[col.id];
                return equivalentCol && equivalentCol.field === col.field && equivalentCol.aggFunc === col.aggFunc;
            });
            const missingCols = !params.allowRemovedColumns && !!Object.values(oldColsMap).length;
            return allColsUnchanged && !missingCols;
        };
        const sortModelDifferent = !(0, $jIDNV._).jsonEquals(this.storeParams.sortModel, this.sortController.getSortModel());
        const rowGroupDifferent = !areColsSame({
            oldCols: this.storeParams.rowGroupCols,
            newCols: rowGroupColumnVos
        });
        const pivotDifferent = !areColsSame({
            oldCols: this.storeParams.pivotCols,
            newCols: pivotColumnVos
        });
        const valuesDifferent = !!(rowGroupColumnVos == null ? void 0 : rowGroupColumnVos.length) && !areColsSame({
            oldCols: this.storeParams.valueCols,
            newCols: valueColumnVos,
            allowRemovedColumns: true
        });
        const resetRequired = sortModelDifferent || rowGroupDifferent || pivotDifferent || valuesDifferent;
        if (resetRequired) this.resetRootStore();
        else {
            const newParams = this.createStoreParams();
            this.storeParams.rowGroupCols = newParams.rowGroupCols;
            this.storeParams.pivotCols = newParams.pivotCols;
            this.storeParams.valueCols = newParams.valueCols;
        }
    }
    destroyRootStore() {
        if (!this.rootNode || !this.rootNode.childStore) return;
        this.rootNode.childStore = this.destroyBean(this.rootNode.childStore);
        this.nodeManager.clear();
    }
    refreshAfterSort(newSortModel, params) {
        if (this.storeParams) this.storeParams.sortModel = newSortModel;
        const rootStore = this.getRootStore();
        if (!rootStore) return;
        rootStore.refreshAfterSort(params);
        this.onStoreUpdated();
    }
    generateSecondaryColumns(pivotFields) {
        if (!this.pivotColDefService) {
            (0, $jIDNV.ModuleRegistry).__assertRegistered((0, $jIDNV.ModuleNames).RowGroupingModule, "pivotResultFields", this.context.getGridId());
            return;
        }
        const pivotColumnGroupDefs = this.pivotColDefService.createColDefsFromFields(pivotFields);
        this.managingPivotResultColumns = true;
        this.columnModel.setSecondaryColumns(pivotColumnGroupDefs, "rowModelUpdated");
    }
    resetRowHeights() {
        const atLeastOne = this.resetRowHeightsForAllRowNodes();
        const rootNodeHeight = this.gos.getRowHeightForNode(this.rootNode);
        this.rootNode.setRowHeight(rootNodeHeight.height, rootNodeHeight.estimated);
        if (this.rootNode.sibling) {
            const rootNodeSibling = this.gos.getRowHeightForNode(this.rootNode.sibling);
            this.rootNode.sibling.setRowHeight(rootNodeSibling.height, rootNodeSibling.estimated);
        }
        if (atLeastOne) this.onRowHeightChanged();
    }
    resetRowHeightsForAllRowNodes() {
        let atLeastOne = false;
        this.forEachNode((rowNode)=>{
            const rowHeightForNode = this.gos.getRowHeightForNode(rowNode);
            rowNode.setRowHeight(rowHeightForNode.height, rowHeightForNode.estimated);
            const detailNode = rowNode.detailNode;
            if (detailNode) {
                const detailRowHeight = this.gos.getRowHeightForNode(detailNode);
                detailNode.setRowHeight(detailRowHeight.height, detailRowHeight.estimated);
            }
            if (rowNode.sibling) {
                const siblingRowHeight = this.gos.getRowHeightForNode(rowNode.sibling);
                detailNode.setRowHeight(siblingRowHeight.height, siblingRowHeight.estimated);
            }
            atLeastOne = true;
        });
        return atLeastOne;
    }
    resetRootStore() {
        this.destroyRootStore();
        this.rootNode = new (0, $jIDNV.RowNode)(this.beans);
        this.rootNode.group = true;
        this.rootNode.level = -1;
        if (this.datasource) {
            this.storeParams = this.createStoreParams();
            this.rootNode.childStore = this.createBean(this.storeFactory.createStore(this.storeParams, this.rootNode));
            this.updateRowIndexesAndBounds();
        }
        if (this.managingPivotResultColumns) {
            this.columnModel.setSecondaryColumns(null, "api");
            this.managingPivotResultColumns = false;
        }
        this.dispatchModelUpdated(true);
    }
    columnsToValueObjects(columns) {
        return columns.map((col)=>({
                id: col.getId(),
                aggFunc: col.getAggFunc(),
                displayName: this.columnModel.getDisplayNameForColumn(col, "model"),
                field: col.getColDef().field
            }));
    }
    createStoreParams() {
        const rowGroupColumnVos = this.columnsToValueObjects(this.columnModel.getRowGroupColumns());
        const valueColumnVos = this.columnsToValueObjects(this.columnModel.getValueColumns());
        const pivotColumnVos = this.columnsToValueObjects(this.columnModel.getPivotColumns());
        const dynamicRowHeight = this.gos.isGetRowHeightFunction();
        const params = {
            // the columns the user has grouped and aggregated by
            valueCols: valueColumnVos,
            rowGroupCols: rowGroupColumnVos,
            pivotCols: pivotColumnVos,
            pivotMode: this.columnModel.isPivotMode(),
            // sort and filter model
            filterModel: this.filterManager.isAdvancedFilterEnabled() ? this.filterManager.getAdvancedFilterModel() : this.filterManager.getFilterModel(),
            sortModel: this.sortController.getSortModel(),
            datasource: this.datasource,
            lastAccessedSequence: new (0, $jIDNV.NumberSequence)(),
            dynamicRowHeight: // blockSize: blockSize == null ? 100 : blockSize,
            dynamicRowHeight
        };
        return params;
    }
    getParams() {
        return this.storeParams;
    }
    dispatchModelUpdated(reset = false) {
        const modelUpdatedEvent = {
            type: (0, $jIDNV.Events).EVENT_MODEL_UPDATED,
            animate: !reset,
            keepRenderedRows: !reset,
            newPage: false,
            newData: false
        };
        this.eventService.dispatchEvent(modelUpdatedEvent);
    }
    onStoreUpdated() {
        if (this.pauseStoreUpdateListening) return;
        this.updateRowIndexesAndBounds();
        this.dispatchModelUpdated();
    }
    /** This method is debounced. It is used for row auto-height. If we don't debounce,
   * then the Row Models will end up recalculating each row position
   * for each row height change and result in the Row Renderer laying out rows.
   * This is particularly bad if using print layout, and showing eg 1,000 rows,
   * each row will change it's height, causing Row Model to update 1,000 times.
   */ onRowHeightChangedDebounced() {
        this.onRowHeightChanged_debounced();
    }
    onRowHeightChanged() {
        this.updateRowIndexesAndBounds();
        this.dispatchModelUpdated();
    }
    updateRowIndexesAndBounds() {
        const rootStore = this.getRootStore();
        if (!rootStore) return;
        rootStore.setDisplayIndexes(new (0, $jIDNV.NumberSequence)(), {
            value: 0
        });
    }
    retryLoads() {
        const rootStore = this.getRootStore();
        if (!rootStore) return;
        rootStore.retryLoads();
        this.onStoreUpdated();
    }
    getRow(index) {
        const rootStore = this.getRootStore();
        if (!rootStore) return void 0;
        return rootStore.getRowUsingDisplayIndex(index);
    }
    /**
   * Pauses the store, to prevent it updating the UI. This is used when doing batch updates to the store.
   */ setPaused(paused) {
        this.pauseStoreUpdateListening = paused;
    }
    expandAll(value) {
        this.pauseStoreUpdateListening = true;
        this.forEachNode((node)=>{
            if (node.stub) return;
            if (node.hasChildren()) node.setExpanded(value);
        });
        this.pauseStoreUpdateListening = false;
        this.onStoreUpdated();
    }
    refreshAfterFilter(newFilterModel, params) {
        if (this.storeParams) this.storeParams.filterModel = newFilterModel;
        const rootStore = this.getRootStore();
        if (!rootStore) return;
        rootStore.refreshAfterFilter(params);
        this.onStoreUpdated();
    }
    getRootStore() {
        if (this.rootNode && this.rootNode.childStore) return this.rootNode.childStore;
    }
    getRowCount() {
        const rootStore = this.getRootStore();
        if (!rootStore) return 0;
        return rootStore.getDisplayIndexEnd();
    }
    getTopLevelRowCount() {
        const rootStore = this.getRootStore();
        if (!rootStore) return 1;
        return rootStore.getRowCount();
    }
    getTopLevelRowDisplayedIndex(topLevelIndex) {
        const rootStore = this.getRootStore();
        if (!rootStore) return topLevelIndex;
        return rootStore.getTopLevelRowDisplayedIndex(topLevelIndex);
    }
    getRowBounds(index) {
        const rootStore = this.getRootStore();
        if (!rootStore) {
            const rowHeight = this.gos.getRowHeightAsNumber();
            return {
                rowTop: 0,
                rowHeight: rowHeight
            };
        }
        return rootStore.getRowBounds(index);
    }
    getBlockStates() {
        const root = this.getRootStore();
        if (!root) return void 0;
        const states = {};
        root.forEachStoreDeep((store)=>{
            if (store instanceof $5b7ccabde48fae90$var$FullStore) {
                const { id: id, state: state } = store.getBlockStateJson();
                states[id] = state;
            } else if (store instanceof $5b7ccabde48fae90$var$LazyStore) Object.entries(store.getBlockStates()).forEach(([block, state])=>{
                states[block] = state;
            });
            else throw new Error("AG Grid: Unsupported store type");
        });
        return states;
    }
    getRowIndexAtPixel(pixel) {
        const rootStore = this.getRootStore();
        if (pixel <= 0 || !rootStore) return 0;
        return rootStore.getRowIndexAtPixel(pixel);
    }
    isEmpty() {
        return false;
    }
    isRowsToRender() {
        return this.getRootStore() != null && this.getRowCount() > 0;
    }
    getType() {
        return "serverSide";
    }
    forEachNode(callback) {
        const rootStore = this.getRootStore();
        if (!rootStore) return;
        rootStore.forEachNodeDeep(callback);
    }
    forEachNodeAfterFilterAndSort(callback, includeFooterNodes = false) {
        const rootStore = this.getRootStore();
        if (!rootStore) return;
        rootStore.forEachNodeDeepAfterFilterAndSort(callback, void 0, includeFooterNodes);
    }
    /** @return false if store hasn't started */ executeOnStore(route, callback) {
        if (!this.started) return false;
        const rootStore = this.getRootStore();
        if (!rootStore) return true;
        const storeToExecuteOn = rootStore.getChildStore(route);
        if (storeToExecuteOn) callback(storeToExecuteOn);
        return true;
    }
    refreshStore(params = {}) {
        const route = params.route ? params.route : [];
        this.executeOnStore(route, (store)=>store.refreshStore(params.purge == true));
    }
    getStoreState() {
        const res = [];
        const rootStore = this.getRootStore();
        if (rootStore) rootStore.addStoreStates(res);
        return res;
    }
    getNodesInRangeForSelection(firstInRange, lastInRange) {
        if (!(0, $jIDNV._).exists(firstInRange)) return [];
        if (!lastInRange) return [
            firstInRange
        ];
        const startIndex = firstInRange.rowIndex;
        const endIndex = lastInRange.rowIndex;
        if (startIndex === null || endIndex === null) return [
            firstInRange
        ];
        const nodeRange = [];
        const [firstIndex, lastIndex] = [
            startIndex,
            endIndex
        ].sort((a, b)=>a - b);
        this.forEachNode((node)=>{
            const thisRowIndex = node.rowIndex;
            if (thisRowIndex == null || node.stub) return;
            if (thisRowIndex >= firstIndex && thisRowIndex <= lastIndex) nodeRange.push(node);
        });
        if (nodeRange.length !== lastIndex - firstIndex + 1) return [
            firstInRange
        ];
        return nodeRange;
    }
    getRowNode(id) {
        let result;
        this.forEachNode((rowNode)=>{
            if (rowNode.id === id) result = rowNode;
            if (rowNode.detailNode && rowNode.detailNode.id === id) result = rowNode.detailNode;
        });
        return result;
    }
    isRowPresent(rowNode) {
        const foundRowNode = this.getRowNode(rowNode.id);
        return !!foundRowNode;
    }
    setRowCount(rowCount, lastRowIndexKnown) {
        const rootStore = this.getRootStore();
        if (rootStore) {
            if (rootStore instanceof $5b7ccabde48fae90$var$LazyStore) {
                rootStore.setRowCount(rowCount, lastRowIndexKnown);
                return;
            }
            console.error("AG Grid: Infinite scrolling must be enabled in order to set the row count.");
        }
    }
};
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$ServerSideRowModel.prototype, "columnModel", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("filterManager")
], $5b7ccabde48fae90$var$ServerSideRowModel.prototype, "filterManager", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("sortController")
], $5b7ccabde48fae90$var$ServerSideRowModel.prototype, "sortController", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("rowRenderer")
], $5b7ccabde48fae90$var$ServerSideRowModel.prototype, "rowRenderer", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("ssrmNodeManager")
], $5b7ccabde48fae90$var$ServerSideRowModel.prototype, "nodeManager", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("ssrmStoreFactory")
], $5b7ccabde48fae90$var$ServerSideRowModel.prototype, "storeFactory", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("beans")
], $5b7ccabde48fae90$var$ServerSideRowModel.prototype, "beans", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Optional)("pivotColDefService")
], $5b7ccabde48fae90$var$ServerSideRowModel.prototype, "pivotColDefService", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.PreDestroy)
], $5b7ccabde48fae90$var$ServerSideRowModel.prototype, "destroyDatasource", 1);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$ServerSideRowModel.prototype, "addEventListeners", 1);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.PreDestroy)
], $5b7ccabde48fae90$var$ServerSideRowModel.prototype, "destroyRootStore", 1);
$5b7ccabde48fae90$var$ServerSideRowModel = $5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Bean)("rowModel")
], $5b7ccabde48fae90$var$ServerSideRowModel);
var $5b7ccabde48fae90$var$StoreUtils = class extends (0, $jIDNV.BeanStub) {
    loadFromDatasource(p) {
        const { storeParams: storeParams, parentBlock: parentBlock, parentNode: parentNode } = p;
        const groupKeys = parentNode.getGroupKeys();
        if (!storeParams.datasource) return;
        const request = {
            startRow: p.startRow,
            endRow: p.endRow,
            rowGroupCols: storeParams.rowGroupCols,
            valueCols: storeParams.valueCols,
            pivotCols: storeParams.pivotCols,
            pivotMode: storeParams.pivotMode,
            groupKeys: groupKeys,
            filterModel: storeParams.filterModel,
            sortModel: storeParams.sortModel
        };
        const getRowsParams = this.gos.addGridCommonParams({
            success: p.success,
            fail: p.fail,
            request: request,
            parentNode: p.parentNode
        });
        window.setTimeout(()=>{
            if (!storeParams.datasource || !parentBlock.isAlive()) {
                p.fail();
                return;
            }
            storeParams.datasource.getRows(getRowsParams);
        }, 0);
    }
    getChildStore(keys, currentCache, findNodeFunc) {
        if ((0, $jIDNV._).missingOrEmpty(keys)) return currentCache;
        const nextKey = keys[0];
        const nextNode = findNodeFunc(nextKey);
        if (nextNode) {
            if (keys.length === 1 && !nextNode.childStore) {
                const storeParams = this.serverSideRowModel.getParams();
                nextNode.childStore = this.createBean(this.storeFactory.createStore(storeParams, nextNode));
            }
            const keyListForNextLevel = keys.slice(1, keys.length);
            const nextStore = nextNode.childStore;
            return nextStore ? nextStore.getChildStore(keyListForNextLevel) : null;
        }
        return null;
    }
    isServerRefreshNeeded(parentRowNode, rowGroupCols, params) {
        if (params.valueColChanged || params.secondaryColChanged) return true;
        const level = parentRowNode.level + 1;
        const grouping = level < rowGroupCols.length;
        const leafNodes = !grouping;
        if (leafNodes) return true;
        const colIdThisGroup = rowGroupCols[level].id;
        const actionOnThisGroup = params.changedColumns.indexOf(colIdThisGroup) > -1;
        if (actionOnThisGroup) return true;
        const allCols = this.columnModel.getAllGridColumns();
        const affectedGroupCols = allCols.filter((col)=>col.getColDef().showRowGroup && params.changedColumns.includes(col.getId())).map((col)=>col.getColDef().showRowGroup).some((group)=>group === true || group === colIdThisGroup);
        return affectedGroupCols;
    }
    getServerSideInitialRowCount() {
        return this.gos.get("serverSideInitialRowCount");
    }
    assertRowModelIsServerSide(key) {
        if (!this.gos.isRowModelType("serverSide")) {
            (0, $jIDNV._).warnOnce(`The '${key}' property can only be used with the Server Side Row Model.`);
            return false;
        }
        return true;
    }
    assertNotTreeData(key) {
        if (this.gos.get("treeData")) {
            (0, $jIDNV._).warnOnce(`The '${key}' property cannot be used while using tree data.`);
            return false;
        }
        return true;
    }
    isServerSideSortAllLevels() {
        return this.gos.get("serverSideSortAllLevels") && this.assertRowModelIsServerSide("serverSideSortAllLevels");
    }
    isServerSideOnlyRefreshFilteredGroups() {
        return this.gos.get("serverSideOnlyRefreshFilteredGroups") && this.assertRowModelIsServerSide("serverSideOnlyRefreshFilteredGroups");
    }
    isServerSideSortOnServer() {
        return this.gos.get("serverSideSortOnServer") && this.assertRowModelIsServerSide("serverSideSortOnServer") && this.assertNotTreeData("serverSideSortOnServer");
    }
    isServerSideFilterOnServer() {
        return this.gos.get("serverSideFilterOnServer") && this.assertRowModelIsServerSide("serverSideFilterOnServer") && this.assertNotTreeData("serverSideFilterOnServer");
    }
};
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$StoreUtils.prototype, "columnModel", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("rowModel")
], $5b7ccabde48fae90$var$StoreUtils.prototype, "serverSideRowModel", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("ssrmStoreFactory")
], $5b7ccabde48fae90$var$StoreUtils.prototype, "storeFactory", 2);
$5b7ccabde48fae90$var$StoreUtils = $5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Bean)("ssrmStoreUtils")
], $5b7ccabde48fae90$var$StoreUtils);
var $5b7ccabde48fae90$var$GROUP_MISSING_KEY_ID = "ag-Grid-MissingKey";
var $5b7ccabde48fae90$var$BlockUtils = class extends (0, $jIDNV.BeanStub) {
    createRowNode(params) {
        const rowNode = new (0, $jIDNV.RowNode)(this.beans);
        const rowHeight = params.rowHeight != null ? params.rowHeight : this.gos.getRowHeightAsNumber();
        rowNode.setRowHeight(rowHeight);
        rowNode.group = params.group;
        rowNode.leafGroup = params.leafGroup;
        rowNode.level = params.level;
        rowNode.uiLevel = params.level;
        rowNode.parent = params.parent;
        rowNode.stub = true;
        rowNode.__needsRefreshWhenVisible = false;
        if (rowNode.group) {
            rowNode.expanded = false;
            rowNode.field = params.field;
            rowNode.rowGroupColumn = params.rowGroupColumn;
        }
        return rowNode;
    }
    destroyRowNodes(rowNodes) {
        if (rowNodes) rowNodes.forEach((row)=>this.destroyRowNode(row));
    }
    destroyRowNode(rowNode, preserveStore = false) {
        if (rowNode.childStore && !preserveStore) {
            this.destroyBean(rowNode.childStore);
            rowNode.childStore = null;
        }
        if (rowNode.sibling && !rowNode.footer) this.destroyRowNode(rowNode.sibling, false);
        rowNode.clearRowTopAndRowIndex();
        if (rowNode.id != null) this.nodeManager.removeNode(rowNode);
    }
    setTreeGroupInfo(rowNode) {
        rowNode.updateHasChildren();
        const getKeyFunc = this.gos.get("getServerSideGroupKey");
        if (rowNode.hasChildren() && getKeyFunc != null) rowNode.key = getKeyFunc(rowNode.data);
        if (!rowNode.hasChildren() && rowNode.childStore != null) {
            this.destroyBean(rowNode.childStore);
            rowNode.childStore = null;
            rowNode.expanded = false;
        }
    }
    setRowGroupInfo(rowNode) {
        rowNode.key = this.valueService.getValue(rowNode.rowGroupColumn, rowNode);
        if (rowNode.key === null || rowNode.key === void 0) (0, $jIDNV._).doOnce(()=>{
            console.warn(`AG Grid: null and undefined values are not allowed for server side row model keys`);
            if (rowNode.rowGroupColumn) console.warn(`column = ${rowNode.rowGroupColumn.getId()}`);
            console.warn(`data is `, rowNode.data);
        }, "ServerSideBlock-CannotHaveNullOrUndefinedForKey");
        const getGroupIncludeFooter = this.beans.gos.getGroupTotalRowCallback();
        const doesRowShowFooter = getGroupIncludeFooter({
            node: rowNode
        });
        if (doesRowShowFooter) {
            rowNode.createFooter();
            if (rowNode.sibling) rowNode.sibling.uiLevel = rowNode.uiLevel + 1;
        }
    }
    setMasterDetailInfo(rowNode) {
        const isMasterFunc = this.gos.get("isRowMaster");
        if (isMasterFunc != null) rowNode.master = isMasterFunc(rowNode.data);
        else rowNode.master = true;
    }
    updateDataIntoRowNode(rowNode, data) {
        rowNode.updateData(data);
        if (this.gos.get("treeData")) {
            this.setTreeGroupInfo(rowNode);
            this.setChildCountIntoRowNode(rowNode);
        } else if (rowNode.group) {
            this.setChildCountIntoRowNode(rowNode);
            if (!rowNode.footer) {
                const getGroupIncludeFooter = this.beans.gos.getGroupTotalRowCallback();
                const doesRowShowFooter = getGroupIncludeFooter({
                    node: rowNode
                });
                if (doesRowShowFooter) {
                    if (rowNode.sibling) rowNode.sibling.updateData(data);
                    else rowNode.createFooter();
                } else if (rowNode.sibling) rowNode.destroyFooter();
            }
        } else this.gos.get("masterDetail");
    }
    setDataIntoRowNode(rowNode, data, defaultId, cachedRowHeight) {
        var _a;
        rowNode.stub = false;
        const treeData = this.gos.get("treeData");
        if ((0, $jIDNV._).exists(data)) {
            rowNode.setDataAndId(data, defaultId);
            if (treeData) this.setTreeGroupInfo(rowNode);
            else if (rowNode.group) this.setRowGroupInfo(rowNode);
            else if (this.gos.get("masterDetail")) this.setMasterDetailInfo(rowNode);
        } else {
            rowNode.setDataAndId(void 0, void 0);
            rowNode.key = null;
        }
        if (treeData || rowNode.group) {
            this.setGroupDataIntoRowNode(rowNode);
            this.setChildCountIntoRowNode(rowNode);
        }
        if ((0, $jIDNV._).exists(data)) {
            rowNode.setRowHeight(this.gos.getRowHeightForNode(rowNode, false, cachedRowHeight).height);
            (_a = rowNode.sibling) == null || _a.setRowHeight(this.gos.getRowHeightForNode(rowNode.sibling, false, cachedRowHeight).height);
        }
    }
    setChildCountIntoRowNode(rowNode) {
        const getChildCount = this.gos.get("getChildCount");
        if (getChildCount) rowNode.setAllChildrenCount(getChildCount(rowNode.data));
    }
    setGroupDataIntoRowNode(rowNode) {
        const groupDisplayCols = this.columnModel.getGroupDisplayColumns();
        const usingTreeData = this.gos.get("treeData");
        groupDisplayCols.forEach((col)=>{
            if (rowNode.groupData == null) rowNode.groupData = {};
            if (usingTreeData) rowNode.groupData[col.getColId()] = rowNode.key;
            else if (col.isRowGroupDisplayed(rowNode.rowGroupColumn.getId())) {
                const groupValue = this.valueService.getValue(rowNode.rowGroupColumn, rowNode);
                rowNode.groupData[col.getColId()] = groupValue;
            }
        });
    }
    clearDisplayIndex(rowNode) {
        rowNode.clearRowTopAndRowIndex();
        const hasChildStore = rowNode.hasChildren() && (0, $jIDNV._).exists(rowNode.childStore);
        if (hasChildStore) {
            const childStore = rowNode.childStore;
            childStore.clearDisplayIndexes();
        }
        const hasDetailNode = rowNode.master && rowNode.detailNode;
        if (hasDetailNode) rowNode.detailNode.clearRowTopAndRowIndex();
    }
    setDisplayIndex(rowNode, displayIndexSeq, nextRowTop) {
        rowNode.setRowIndex(displayIndexSeq.next());
        rowNode.setRowTop(nextRowTop.value);
        nextRowTop.value += rowNode.rowHeight;
        if (rowNode.footer) return;
        const hasDetailRow = rowNode.master;
        if (hasDetailRow) {
            if (rowNode.expanded && rowNode.detailNode) {
                rowNode.detailNode.setRowIndex(displayIndexSeq.next());
                rowNode.detailNode.setRowTop(nextRowTop.value);
                nextRowTop.value += rowNode.detailNode.rowHeight;
            } else if (rowNode.detailNode) rowNode.detailNode.clearRowTopAndRowIndex();
        }
        const hasChildStore = rowNode.hasChildren() && (0, $jIDNV._).exists(rowNode.childStore);
        if (hasChildStore) {
            const childStore = rowNode.childStore;
            if (rowNode.expanded) childStore.setDisplayIndexes(displayIndexSeq, nextRowTop);
            else childStore.clearDisplayIndexes();
        }
    }
    binarySearchForDisplayIndex(displayRowIndex, rowNodes) {
        let bottomPointer = 0;
        let topPointer = rowNodes.length - 1;
        if ((0, $jIDNV._).missing(topPointer) || (0, $jIDNV._).missing(bottomPointer)) {
            console.warn(`AG Grid: error: topPointer = ${topPointer}, bottomPointer = ${bottomPointer}`);
            return void 0;
        }
        while(true){
            const midPointer = Math.floor((bottomPointer + topPointer) / 2);
            const currentRowNode = rowNodes[midPointer];
            if (currentRowNode.rowIndex === displayRowIndex) return currentRowNode;
            const expandedMasterRow = currentRowNode.master && currentRowNode.expanded;
            const detailNode = currentRowNode.detailNode;
            if (expandedMasterRow && detailNode && detailNode.rowIndex === displayRowIndex) return currentRowNode.detailNode;
            const childStore = currentRowNode.childStore;
            if (currentRowNode.expanded && childStore && childStore.isDisplayIndexInStore(displayRowIndex)) return childStore.getRowUsingDisplayIndex(displayRowIndex);
            if (currentRowNode.rowIndex < displayRowIndex) bottomPointer = midPointer + 1;
            else if (currentRowNode.rowIndex > displayRowIndex) topPointer = midPointer - 1;
            else {
                console.warn(`AG Grid: error: unable to locate rowIndex = ${displayRowIndex} in cache`);
                return void 0;
            }
        }
    }
    extractRowBounds(rowNode, index) {
        const extractRowBounds = (currentRowNode)=>({
                rowHeight: currentRowNode.rowHeight,
                rowTop: currentRowNode.rowTop
            });
        if (rowNode.rowIndex === index) return extractRowBounds(rowNode);
        if (rowNode.hasChildren() && rowNode.expanded && (0, $jIDNV._).exists(rowNode.childStore)) {
            const childStore = rowNode.childStore;
            if (childStore.isDisplayIndexInStore(index)) return childStore.getRowBounds(index);
        } else if (rowNode.master && rowNode.expanded && (0, $jIDNV._).exists(rowNode.detailNode)) {
            if (rowNode.detailNode.rowIndex === index) return extractRowBounds(rowNode.detailNode);
        }
    }
    getIndexAtPixel(rowNode, pixel) {
        if (rowNode.isPixelInRange(pixel)) return rowNode.rowIndex;
        const expandedMasterRow = rowNode.master && rowNode.expanded;
        const detailNode = rowNode.detailNode;
        if (expandedMasterRow && detailNode && detailNode.isPixelInRange(pixel)) return rowNode.detailNode.rowIndex;
        if (rowNode.hasChildren() && rowNode.expanded && (0, $jIDNV._).exists(rowNode.childStore)) {
            const childStore = rowNode.childStore;
            if (childStore.isPixelInRange(pixel)) return childStore.getRowIndexAtPixel(pixel);
        }
        return null;
    }
    createNodeIdPrefix(parentRowNode) {
        const parts = [];
        let rowNode = parentRowNode;
        while(rowNode && rowNode.level >= 0){
            if (rowNode.key === "") parts.push($5b7ccabde48fae90$var$GROUP_MISSING_KEY_ID);
            else parts.push(rowNode.key);
            rowNode = rowNode.parent;
        }
        if (parts.length > 0) return parts.reverse().join("-");
        return void 0;
    }
    checkOpenByDefault(rowNode) {
        return this.expansionService.checkOpenByDefault(rowNode);
    }
};
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("valueService")
], $5b7ccabde48fae90$var$BlockUtils.prototype, "valueService", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$BlockUtils.prototype, "columnModel", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("ssrmNodeManager")
], $5b7ccabde48fae90$var$BlockUtils.prototype, "nodeManager", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("beans")
], $5b7ccabde48fae90$var$BlockUtils.prototype, "beans", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("expansionService")
], $5b7ccabde48fae90$var$BlockUtils.prototype, "expansionService", 2);
$5b7ccabde48fae90$var$BlockUtils = $5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Bean)("ssrmBlockUtils")
], $5b7ccabde48fae90$var$BlockUtils);
var $5b7ccabde48fae90$var$NodeManager = class {
    constructor(){
        this.rowNodes = {};
    }
    addRowNode(rowNode) {
        const id = rowNode.id;
        if (this.rowNodes[id]) {
            console.warn(`AG Grid: Duplicate node id ${rowNode.id}. Row ID's are provided via the getRowId() callback. Please modify the getRowId() callback code to provide unique row id values.`);
            console.warn("first instance", this.rowNodes[id].data);
            console.warn("second instance", rowNode.data);
        }
        this.rowNodes[id] = rowNode;
    }
    removeNode(rowNode) {
        const id = rowNode.id;
        if (this.rowNodes[id]) this.rowNodes[id] = void 0;
    }
    clear() {
        this.rowNodes = {};
    }
};
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.PreDestroy)
], $5b7ccabde48fae90$var$NodeManager.prototype, "clear", 1);
$5b7ccabde48fae90$var$NodeManager = $5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Bean)("ssrmNodeManager")
], $5b7ccabde48fae90$var$NodeManager);
var $5b7ccabde48fae90$var$TransactionManager = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.asyncTransactions = [];
    }
    postConstruct() {
        if (!this.gos.isRowModelType("serverSide")) return;
    }
    applyTransactionAsync(transaction, callback) {
        if (this.asyncTransactionsTimeout == null) this.scheduleExecuteAsync();
        this.asyncTransactions.push({
            transaction: transaction,
            callback: callback
        });
    }
    scheduleExecuteAsync() {
        const waitMillis = this.gos.getAsyncTransactionWaitMillis();
        this.asyncTransactionsTimeout = window.setTimeout(()=>{
            this.executeAsyncTransactions();
        }, waitMillis);
    }
    executeAsyncTransactions() {
        if (!this.asyncTransactions) return;
        const resultFuncs = [];
        const resultsForEvent = [];
        const transactionsToRetry = [];
        let atLeastOneTransactionApplied = false;
        this.asyncTransactions.forEach((txWrapper)=>{
            let result;
            const hasStarted = this.serverSideRowModel.executeOnStore(txWrapper.transaction.route, (cache)=>{
                result = cache.applyTransaction(txWrapper.transaction);
            });
            if (!hasStarted) result = {
                status: (0, $jIDNV.ServerSideTransactionResultStatus).StoreNotStarted
            };
            else if (result == void 0) result = {
                status: (0, $jIDNV.ServerSideTransactionResultStatus).StoreNotFound
            };
            resultsForEvent.push(result);
            const retryTransaction = result.status == (0, $jIDNV.ServerSideTransactionResultStatus).StoreLoading;
            if (retryTransaction) {
                transactionsToRetry.push(txWrapper);
                return;
            }
            if (txWrapper.callback) resultFuncs.push(()=>txWrapper.callback(result));
            if (result.status === (0, $jIDNV.ServerSideTransactionResultStatus).Applied) atLeastOneTransactionApplied = true;
        });
        if (resultFuncs.length > 0) window.setTimeout(()=>{
            resultFuncs.forEach((func)=>func());
        }, 0);
        this.asyncTransactionsTimeout = void 0;
        this.asyncTransactions = transactionsToRetry;
        if (atLeastOneTransactionApplied) {
            this.valueCache.onDataChanged();
            this.eventService.dispatchEvent({
                type: (0, $jIDNV.Events).EVENT_STORE_UPDATED
            });
        }
        if (resultsForEvent.length > 0) {
            const event = {
                type: (0, $jIDNV.Events).EVENT_ASYNC_TRANSACTIONS_FLUSHED,
                results: resultsForEvent
            };
            this.eventService.dispatchEvent(event);
        }
    }
    flushAsyncTransactions() {
        if (this.asyncTransactionsTimeout != null) clearTimeout(this.asyncTransactionsTimeout);
        this.executeAsyncTransactions();
    }
    applyTransaction(transaction) {
        let res;
        const hasStarted = this.serverSideRowModel.executeOnStore(transaction.route, (store)=>{
            res = store.applyTransaction(transaction);
        });
        if (!hasStarted) return {
            status: (0, $jIDNV.ServerSideTransactionResultStatus).StoreNotStarted
        };
        else if (res) {
            this.valueCache.onDataChanged();
            if (res.remove) {
                const removedRowIds = res.remove.map((row)=>row.id);
                this.selectionService.deleteSelectionStateFromParent(transaction.route || [], removedRowIds);
            }
            this.eventService.dispatchEvent({
                type: (0, $jIDNV.Events).EVENT_STORE_UPDATED
            });
            return res;
        } else return {
            status: (0, $jIDNV.ServerSideTransactionResultStatus).StoreNotFound
        };
    }
};
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("rowNodeBlockLoader")
], $5b7ccabde48fae90$var$TransactionManager.prototype, "rowNodeBlockLoader", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("valueCache")
], $5b7ccabde48fae90$var$TransactionManager.prototype, "valueCache", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("rowModel")
], $5b7ccabde48fae90$var$TransactionManager.prototype, "serverSideRowModel", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("rowRenderer")
], $5b7ccabde48fae90$var$TransactionManager.prototype, "rowRenderer", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("selectionService")
], $5b7ccabde48fae90$var$TransactionManager.prototype, "selectionService", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$TransactionManager.prototype, "postConstruct", 1);
$5b7ccabde48fae90$var$TransactionManager = $5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Bean)("ssrmTransactionManager")
], $5b7ccabde48fae90$var$TransactionManager);
var $5b7ccabde48fae90$var$ExpandListener = class extends (0, $jIDNV.BeanStub) {
    postConstruct() {
        if (!this.gos.isRowModelType("serverSide")) return;
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_ROW_GROUP_OPENED, this.onRowGroupOpened.bind(this));
    }
    onRowGroupOpened(event) {
        const rowNode = event.node;
        if (rowNode.expanded) {
            if (rowNode.master) this.createDetailNode(rowNode);
            else if ((0, $jIDNV._).missing(rowNode.childStore)) {
                const storeParams = this.serverSideRowModel.getParams();
                rowNode.childStore = this.createBean(this.storeFactory.createStore(storeParams, rowNode));
            }
        } else if (this.gos.get("purgeClosedRowNodes") && (0, $jIDNV._).exists(rowNode.childStore)) rowNode.childStore = this.destroyBean(rowNode.childStore);
        const storeUpdatedEvent = {
            type: (0, $jIDNV.Events).EVENT_STORE_UPDATED
        };
        this.eventService.dispatchEvent(storeUpdatedEvent);
    }
    createDetailNode(masterNode) {
        if ((0, $jIDNV._).exists(masterNode.detailNode)) return masterNode.detailNode;
        const detailNode = new (0, $jIDNV.RowNode)(this.beans);
        detailNode.detail = true;
        detailNode.selectable = false;
        detailNode.parent = masterNode;
        if ((0, $jIDNV._).exists(masterNode.id)) detailNode.id = "detail_" + masterNode.id;
        detailNode.data = masterNode.data;
        detailNode.level = masterNode.level + 1;
        const defaultDetailRowHeight = 200;
        const rowHeight = this.gos.getRowHeightForNode(detailNode).height;
        detailNode.rowHeight = rowHeight ? rowHeight : defaultDetailRowHeight;
        masterNode.detailNode = detailNode;
        return detailNode;
    }
};
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("rowModel")
], $5b7ccabde48fae90$var$ExpandListener.prototype, "serverSideRowModel", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("ssrmStoreFactory")
], $5b7ccabde48fae90$var$ExpandListener.prototype, "storeFactory", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("beans")
], $5b7ccabde48fae90$var$ExpandListener.prototype, "beans", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$ExpandListener.prototype, "postConstruct", 1);
$5b7ccabde48fae90$var$ExpandListener = $5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Bean)("ssrmExpandListener")
], $5b7ccabde48fae90$var$ExpandListener);
var $5b7ccabde48fae90$var$SortListener = class extends (0, $jIDNV.BeanStub) {
    postConstruct() {
        if (!this.gos.isRowModelType("serverSide")) return;
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_SORT_CHANGED, this.onSortChanged.bind(this));
    }
    onSortChanged() {
        const storeParams = this.serverSideRowModel.getParams();
        if (!storeParams) return;
        const newSortModel = this.sortController.getSortModel();
        const oldSortModel = storeParams.sortModel;
        const changedColumns = this.findChangedColumnsInSort(newSortModel, oldSortModel);
        const valueColChanged = this.listenerUtils.isSortingWithValueColumn(changedColumns);
        const secondaryColChanged = this.listenerUtils.isSortingWithSecondaryColumn(changedColumns);
        const params = {
            valueColChanged: valueColChanged,
            secondaryColChanged: secondaryColChanged,
            changedColumns: changedColumns
        };
        this.serverSideRowModel.refreshAfterSort(newSortModel, params);
    }
    // returns back all the cols that were effected by the sorting. eg if we were sorting by col A,
    // and now we are sorting by col B, the list of impacted cols should be A and B. so if a cache
    // is impacted by sorting on A or B then it needs to be refreshed. this includes where the cache
    // was previously sorted by A and then the A sort now needs to be cleared.
    findChangedColumnsInSort(newSortModel, oldSortModel) {
        let allColsInBothSorts = [];
        [
            newSortModel,
            oldSortModel
        ].forEach((sortModel)=>{
            if (sortModel) {
                const ids = sortModel.map((sm)=>sm.colId);
                allColsInBothSorts = allColsInBothSorts.concat(ids);
            }
        });
        const differentSorts = (oldSortItem, newSortItem)=>{
            const oldSort = oldSortItem ? oldSortItem.sort : null;
            const newSort = newSortItem ? newSortItem.sort : null;
            return oldSort !== newSort;
        };
        const differentIndexes = (oldSortItem, newSortItem)=>{
            const oldIndex = oldSortItem ? oldSortModel.indexOf(oldSortItem) : -1;
            const newIndex = newSortItem ? newSortModel.indexOf(newSortItem) : -1;
            return oldIndex !== newIndex;
        };
        return allColsInBothSorts.filter((colId)=>{
            const oldSortItem = oldSortModel.find((sm)=>sm.colId === colId);
            const newSortItem = newSortModel.find((sm)=>sm.colId === colId);
            return differentSorts(oldSortItem, newSortItem) || differentIndexes(oldSortItem, newSortItem);
        });
    }
};
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("sortController")
], $5b7ccabde48fae90$var$SortListener.prototype, "sortController", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("rowModel")
], $5b7ccabde48fae90$var$SortListener.prototype, "serverSideRowModel", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("ssrmListenerUtils")
], $5b7ccabde48fae90$var$SortListener.prototype, "listenerUtils", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$SortListener.prototype, "postConstruct", 1);
$5b7ccabde48fae90$var$SortListener = $5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Bean)("ssrmSortService")
], $5b7ccabde48fae90$var$SortListener);
var $5b7ccabde48fae90$var$FilterListener = class extends (0, $jIDNV.BeanStub) {
    postConstruct() {
        if (!this.gos.isRowModelType("serverSide")) return;
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_ADVANCED_FILTER_ENABLED_CHANGED, ()=>this.onFilterChanged(true));
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_FILTER_CHANGED, ()=>this.onFilterChanged());
    }
    onFilterChanged(advancedFilterEnabledChanged) {
        const storeParams = this.serverSideRowModel.getParams();
        if (!storeParams) return;
        const oldModel = storeParams.filterModel;
        let newModel;
        let changedColumns;
        if (this.filterManager.isAdvancedFilterEnabled()) {
            newModel = this.filterManager.getAdvancedFilterModel();
            const oldColumns = advancedFilterEnabledChanged ? Object.keys(oldModel != null ? oldModel : {}) : this.getAdvancedFilterColumns(oldModel);
            const newColumns = this.getAdvancedFilterColumns(newModel);
            oldColumns.forEach((column)=>newColumns.add(column));
            changedColumns = Array.from(newColumns);
        } else {
            newModel = this.filterManager.getFilterModel();
            if (advancedFilterEnabledChanged) {
                const oldColumns = this.getAdvancedFilterColumns(oldModel);
                Object.keys(newModel).forEach((column)=>oldColumns.add(column));
                changedColumns = Array.from(oldColumns);
            } else changedColumns = this.findChangedColumns(oldModel, newModel);
        }
        const valueColChanged = this.listenerUtils.isSortingWithValueColumn(changedColumns);
        const secondaryColChanged = this.listenerUtils.isSortingWithSecondaryColumn(changedColumns);
        const params = {
            valueColChanged: valueColChanged,
            secondaryColChanged: secondaryColChanged,
            changedColumns: changedColumns
        };
        this.serverSideRowModel.refreshAfterFilter(newModel, params);
    }
    findChangedColumns(oldModel, newModel) {
        const allColKeysMap = {};
        Object.keys(oldModel).forEach((key)=>allColKeysMap[key] = true);
        Object.keys(newModel).forEach((key)=>allColKeysMap[key] = true);
        const res = [];
        Object.keys(allColKeysMap).forEach((key)=>{
            const oldJson = JSON.stringify(oldModel[key]);
            const newJson = JSON.stringify(newModel[key]);
            const filterChanged = oldJson != newJson;
            if (filterChanged) res.push(key);
        });
        return res;
    }
    getAdvancedFilterColumns(model) {
        const columns = /* @__PURE__ */ new Set();
        if (!model) return columns;
        const processAdvancedFilterModel = (filterModel)=>{
            if (filterModel.filterType === "join") filterModel.conditions.forEach((condition)=>processAdvancedFilterModel(condition));
            else columns.add(filterModel.colId);
        };
        processAdvancedFilterModel(model);
        return columns;
    }
};
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("rowModel")
], $5b7ccabde48fae90$var$FilterListener.prototype, "serverSideRowModel", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("filterManager")
], $5b7ccabde48fae90$var$FilterListener.prototype, "filterManager", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("ssrmListenerUtils")
], $5b7ccabde48fae90$var$FilterListener.prototype, "listenerUtils", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$FilterListener.prototype, "postConstruct", 1);
$5b7ccabde48fae90$var$FilterListener = $5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Bean)("ssrmFilterListener")
], $5b7ccabde48fae90$var$FilterListener);
var $5b7ccabde48fae90$var$StoreFactory = class {
    createStore(ssrmParams, parentNode) {
        const storeParams = this.getStoreParams(ssrmParams, parentNode);
        const CacheClass = storeParams.suppressInfiniteScroll ? $5b7ccabde48fae90$var$FullStore : $5b7ccabde48fae90$var$LazyStore;
        return new CacheClass(ssrmParams, storeParams, parentNode);
    }
    getStoreParams(ssrmParams, parentNode) {
        const userStoreParams = this.getLevelSpecificParams(parentNode);
        const infiniteScroll = this.isInfiniteScroll(userStoreParams);
        const cacheBlockSize = this.getBlockSize(infiniteScroll, userStoreParams);
        const maxBlocksInCache = this.getMaxBlocksInCache(infiniteScroll, ssrmParams, userStoreParams);
        const storeParams = {
            suppressInfiniteScroll: !infiniteScroll,
            cacheBlockSize: cacheBlockSize,
            maxBlocksInCache: maxBlocksInCache
        };
        return storeParams;
    }
    getMaxBlocksInCache(infiniteScroll, ssrmParams, userStoreParams) {
        if (!infiniteScroll) return void 0;
        const maxBlocksInCache = userStoreParams && userStoreParams.maxBlocksInCache != null ? userStoreParams.maxBlocksInCache : this.gos.get("maxBlocksInCache");
        const maxBlocksActive = maxBlocksInCache != null && maxBlocksInCache >= 0;
        if (!maxBlocksActive) return void 0;
        if (ssrmParams.dynamicRowHeight) {
            const message = "Server Side Row Model does not support Dynamic Row Height and Cache Purging. Either a) remove getRowHeight() callback or b) remove maxBlocksInCache property. Purging has been disabled.";
            (0, $jIDNV._).warnOnce(message);
            return void 0;
        }
        if (this.columnModel.isAutoRowHeightActive()) {
            const message = "Server Side Row Model does not support Auto Row Height and Cache Purging. Either a) remove colDef.autoHeight or b) remove maxBlocksInCache property. Purging has been disabled.";
            (0, $jIDNV._).warnOnce(message);
            return void 0;
        }
        return maxBlocksInCache;
    }
    getBlockSize(infiniteScroll, userStoreParams) {
        if (!infiniteScroll) return void 0;
        const blockSize = userStoreParams && userStoreParams.cacheBlockSize != null ? userStoreParams.cacheBlockSize : this.gos.get("cacheBlockSize");
        if (blockSize != null && blockSize > 0) return blockSize;
        else return 100;
    }
    getLevelSpecificParams(parentNode) {
        const callback = this.gos.getCallback("getServerSideGroupLevelParams");
        if (!callback) return void 0;
        const params = {
            level: parentNode.level + 1,
            parentRowNode: parentNode.level >= 0 ? parentNode : void 0,
            rowGroupColumns: this.columnModel.getRowGroupColumns(),
            pivotColumns: this.columnModel.getPivotColumns(),
            pivotMode: this.columnModel.isPivotMode()
        };
        const res = callback(params);
        return res;
    }
    isInfiniteScroll(storeParams) {
        const res = storeParams && storeParams.suppressInfiniteScroll != null ? storeParams.suppressInfiniteScroll : this.isSuppressServerSideInfiniteScroll();
        return !res;
    }
    isSuppressServerSideInfiniteScroll() {
        return this.gos.get("suppressServerSideInfiniteScroll");
    }
};
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("gridOptionsService")
], $5b7ccabde48fae90$var$StoreFactory.prototype, "gos", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$StoreFactory.prototype, "columnModel", 2);
$5b7ccabde48fae90$var$StoreFactory = $5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Bean)("ssrmStoreFactory")
], $5b7ccabde48fae90$var$StoreFactory);
var $5b7ccabde48fae90$var$ListenerUtils = class {
    isSortingWithValueColumn(changedColumnsInSort) {
        const valueColIds = this.columnModel.getValueColumns().map((col)=>col.getColId());
        for(let i = 0; i < changedColumnsInSort.length; i++){
            if (valueColIds.indexOf(changedColumnsInSort[i]) > -1) return true;
        }
        return false;
    }
    isSortingWithSecondaryColumn(changedColumnsInSort) {
        if (!this.columnModel.getSecondaryColumns()) return false;
        const secondaryColIds = this.columnModel.getSecondaryColumns().map((col)=>col.getColId());
        for(let i = 0; i < changedColumnsInSort.length; i++){
            if (secondaryColIds.indexOf(changedColumnsInSort[i]) > -1) return true;
        }
        return false;
    }
};
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$ListenerUtils.prototype, "columnModel", 2);
$5b7ccabde48fae90$var$ListenerUtils = $5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Bean)("ssrmListenerUtils")
], $5b7ccabde48fae90$var$ListenerUtils);
var $5b7ccabde48fae90$var$DefaultStrategy = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.selectedState = {
            selectAll: false,
            toggledNodes: /* @__PURE__ */ new Set()
        };
        this.lastSelected = null;
        this.selectAllUsed = false;
        this.selectedNodes = {};
    }
    init() {
        this.rowSelection = this.gos.get("rowSelection");
        this.addManagedPropertyListener("rowSelection", (propChange)=>{
            this.rowSelection = propChange.currentValue;
        });
    }
    getSelectedState() {
        return {
            selectAll: this.selectedState.selectAll,
            toggledNodes: [
                ...this.selectedState.toggledNodes
            ]
        };
    }
    setSelectedState(state) {
        const newState = {
            selectAll: false,
            toggledNodes: /* @__PURE__ */ new Set()
        };
        if (typeof state !== "object") {
            console.error("AG Grid: The provided selection state should be an object.");
            return;
        }
        if ("selectAll" in state && typeof state.selectAll === "boolean") newState.selectAll = state.selectAll;
        else {
            console.error("AG Grid: Select all status should be of boolean type.");
            return;
        }
        if ("toggledNodes" in state && Array.isArray(state.toggledNodes)) state.toggledNodes.forEach((key)=>{
            if (typeof key === "string") newState.toggledNodes.add(key);
            else console.warn(`AG Grid: Provided ids must be of string type. Invalid id provided: ${key}`);
        });
        else {
            console.error("AG Grid: `toggledNodes` must be an array of string ids.");
            return;
        }
        this.selectedState = newState;
    }
    deleteSelectionStateFromParent(parentPath, removedNodeIds) {
        if (this.selectedState.toggledNodes.size === 0) return false;
        let anyNodesToggled = false;
        removedNodeIds.forEach((id)=>{
            if (this.selectedState.toggledNodes.delete(id)) anyNodesToggled = true;
        });
        return anyNodesToggled;
    }
    setNodesSelected(params) {
        if (params.nodes.length === 0) return 0;
        const onlyThisNode = params.clearSelection && params.newValue && !params.rangeSelect;
        if (this.rowSelection !== "multiple" || onlyThisNode) {
            if (params.nodes.length > 1) throw new Error("AG Grid: cannot select multiple rows when rowSelection is set to 'single'");
            const node = params.nodes[0];
            if (params.newValue) {
                this.selectedNodes = {
                    [node.id]: node
                };
                this.selectedState = {
                    selectAll: false,
                    toggledNodes: /* @__PURE__ */ new Set([
                        node.id
                    ])
                };
            } else {
                this.selectedNodes = {};
                this.selectedState = {
                    selectAll: false,
                    toggledNodes: /* @__PURE__ */ new Set()
                };
            }
            this.lastSelected = node.id;
            return 1;
        }
        const updateNodeState = (node)=>{
            if (params.newValue) this.selectedNodes[node.id] = node;
            else delete this.selectedNodes[node.id];
            const isNodeSelectable = node.selectable;
            const doesNodeConform = params.newValue === this.selectedState.selectAll;
            if (doesNodeConform || !isNodeSelectable) {
                this.selectedState.toggledNodes.delete(node.id);
                return;
            }
            this.selectedState.toggledNodes.add(node.id);
        };
        if (params.rangeSelect && this.lastSelected) {
            if (params.nodes.length > 1) throw new Error("AG Grid: cannot select multiple rows when using rangeSelect");
            const node = params.nodes[0];
            const lastSelectedNode = this.rowModel.getRowNode(this.lastSelected);
            this.rowModel.getNodesInRangeForSelection(node, lastSelectedNode != null ? lastSelectedNode : null).forEach(updateNodeState);
            this.lastSelected = node.id;
            return 1;
        }
        params.nodes.forEach(updateNodeState);
        this.lastSelected = params.nodes[params.nodes.length - 1].id;
        return 1;
    }
    processNewRow(node) {
        if (this.selectedNodes[node.id]) this.selectedNodes[node.id] = node;
    }
    isNodeSelected(node) {
        const isToggled = this.selectedState.toggledNodes.has(node.id);
        return this.selectedState.selectAll ? !isToggled : isToggled;
    }
    getSelectedNodes() {
        if (this.selectAllUsed) console.warn(`AG Grid: getSelectedNodes and getSelectedRows functions cannot be used with select all functionality with the server-side row model.
                Use \`api.getServerSideSelectionState()\` instead.`);
        return Object.values(this.selectedNodes);
    }
    getSelectedRows() {
        return this.getSelectedNodes().map((node)=>node.data);
    }
    getSelectionCount() {
        if (this.selectedState.selectAll) return -1;
        return this.selectedState.toggledNodes.size;
    }
    clearOtherNodes(rowNodeToKeepSelected, source) {
        const clearedRows = this.selectedState.selectAll ? 1 : this.selectedState.toggledNodes.size - 1;
        this.selectedState = {
            selectAll: false,
            toggledNodes: /* @__PURE__ */ new Set([
                rowNodeToKeepSelected.id
            ])
        };
        this.rowModel.forEachNode((node)=>{
            if (node !== rowNodeToKeepSelected) node.selectThisNode(false, void 0, source);
        });
        const event = {
            type: (0, $jIDNV.Events).EVENT_SELECTION_CHANGED,
            source: source
        };
        this.eventService.dispatchEvent(event);
        return clearedRows;
    }
    isEmpty() {
        var _a;
        return !this.selectedState.selectAll && !((_a = this.selectedState.toggledNodes) == null ? void 0 : _a.size);
    }
    selectAllRowNodes(params) {
        this.selectedState = {
            selectAll: true,
            toggledNodes: /* @__PURE__ */ new Set()
        };
        this.selectedNodes = {};
        this.selectAllUsed = true;
    }
    deselectAllRowNodes(params) {
        this.selectedState = {
            selectAll: false,
            toggledNodes: /* @__PURE__ */ new Set()
        };
        this.selectedNodes = {};
    }
    getSelectAllState(justFiltered, justCurrentPage) {
        if (this.selectedState.selectAll) {
            if (this.selectedState.toggledNodes.size > 0) return null;
            return true;
        }
        if (this.selectedState.toggledNodes.size > 0) return null;
        return false;
    }
};
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("rowModel")
], $5b7ccabde48fae90$var$DefaultStrategy.prototype, "rowModel", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$DefaultStrategy.prototype, "init", 1);
var $5b7ccabde48fae90$var$GroupSelectsChildrenStrategy = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.selectedState = {
            selectAllChildren: false,
            toggledNodes: /* @__PURE__ */ new Map()
        };
        this.lastSelected = null;
    }
    init() {
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_MODEL_UPDATED, ()=>this.removeRedundantState());
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_COLUMN_ROW_GROUP_CHANGED, ()=>this.selectionService.reset("rowGroupChanged"));
    }
    getSelectedState() {
        const treeData = this.gos.get("treeData");
        const recursivelySerializeState = (state, level, nodeId)=>{
            const normalisedState = {
                nodeId: nodeId
            };
            if (treeData || level <= this.columnModel.getRowGroupColumns().length) normalisedState.selectAllChildren = state.selectAllChildren;
            if (state.toggledNodes.size) {
                const toggledNodes = [];
                state.toggledNodes.forEach((value, key)=>{
                    const newState = recursivelySerializeState(value, level + 1, key);
                    toggledNodes.push(newState);
                });
                normalisedState.toggledNodes = toggledNodes;
            }
            return normalisedState;
        };
        return recursivelySerializeState(this.selectedState, 0);
    }
    setSelectedState(state) {
        const recursivelyDeserializeState = (normalisedState, parentSelected)=>{
            var _a, _b;
            if (typeof normalisedState !== "object") throw new Error("AG Grid: Each provided state object must be an object.");
            if ("selectAllChildren" in normalisedState && typeof normalisedState.selectAllChildren !== "boolean") throw new Error("AG Grid: `selectAllChildren` must be a boolean value or undefined.");
            if ("toggledNodes" in normalisedState) {
                if (!Array.isArray(normalisedState.toggledNodes)) throw new Error("AG Grid: `toggledNodes` must be an array.");
                const allHaveIds = normalisedState.toggledNodes.every((innerState)=>typeof innerState === "object" && "nodeId" in innerState && typeof innerState.nodeId === "string");
                if (!allHaveIds) throw new Error("AG Grid: Every `toggledNode` requires an associated string id.");
            }
            const isThisNodeSelected = (_a = normalisedState.selectAllChildren) != null ? _a : !parentSelected;
            const convertedChildren = (_b = normalisedState.toggledNodes) == null ? void 0 : _b.map((innerState)=>[
                    innerState.nodeId,
                    recursivelyDeserializeState(innerState, isThisNodeSelected)
                ]);
            const doesRedundantStateExist = convertedChildren == null ? void 0 : convertedChildren.some(([_94, innerState])=>isThisNodeSelected === innerState.selectAllChildren && innerState.toggledNodes.size === 0);
            if (doesRedundantStateExist) throw new Error(`
                    AG Grid: AG Grid: Row selection state could not be parsed due to invalid data. Ensure all child state has toggledNodes or does not conform with the parent rule.
                    Please rebuild the selection state and reapply it.
                `);
            return {
                selectAllChildren: isThisNodeSelected,
                toggledNodes: new Map(convertedChildren)
            };
        };
        try {
            this.selectedState = recursivelyDeserializeState(state, !!state.selectAllChildren);
        } catch (e) {
            console.error(e.message);
        }
    }
    deleteSelectionStateFromParent(parentRoute, removedNodeIds) {
        let parentState = this.selectedState;
        const remainingRoute = [
            ...parentRoute
        ];
        while(parentState && remainingRoute.length)parentState = parentState.toggledNodes.get(remainingRoute.pop());
        if (!parentState) return false;
        let anyStateChanged = false;
        removedNodeIds.forEach((id)=>{
            if (parentState == null ? void 0 : parentState.toggledNodes.delete(id)) anyStateChanged = true;
        });
        if (anyStateChanged) this.removeRedundantState();
        return anyStateChanged;
    }
    setNodesSelected(params) {
        const _a = params, { nodes: nodes } = _a, other = $5b7ccabde48fae90$var$__objRest2(_a, [
            "nodes"
        ]);
        if (nodes.length === 0) return 0;
        if (params.rangeSelect) {
            if (nodes.length > 1) throw new Error("AG Grid: cannot select multiple rows when using rangeSelect");
            const node = nodes[0];
            const rangeOfNodes = this.rowModel.getNodesInRangeForSelection(node, this.lastSelected);
            const routes = rangeOfNodes.map(this.getRouteToNode).sort((a, b)=>b.length - a.length);
            const completedRoutes = /* @__PURE__ */ new Set();
            routes.forEach((route)=>{
                if (completedRoutes.has(route[route.length - 1])) return;
                route.forEach((part)=>completedRoutes.add(part));
                this.recursivelySelectNode(route, this.selectedState, $5b7ccabde48fae90$var$__spreadValues12({
                    node: node
                }, other));
            });
            this.removeRedundantState();
            this.lastSelected = node;
            return 1;
        }
        params.nodes.forEach((node)=>{
            const idPathToNode = this.getRouteToNode(node);
            this.recursivelySelectNode(idPathToNode, this.selectedState, $5b7ccabde48fae90$var$__spreadProps9($5b7ccabde48fae90$var$__spreadValues12({}, other), {
                node: node
            }));
        });
        this.removeRedundantState();
        this.lastSelected = params.nodes[params.nodes.length - 1];
        return 1;
    }
    isNodeSelected(node) {
        const path = this.getRouteToNode(node);
        return this.isNodePathSelected(path, this.selectedState);
    }
    isNodePathSelected([nextNode, ...nodes], state) {
        if (nodes.length === 0) {
            const isToggled = state.toggledNodes.has(nextNode.id);
            if (nextNode.hasChildren()) {
                const groupState = state.toggledNodes.get(nextNode.id);
                if (groupState && groupState.toggledNodes.size) return void 0;
            }
            return state.selectAllChildren ? !isToggled : isToggled;
        }
        if (state.toggledNodes.has(nextNode.id)) {
            const nextState = state.toggledNodes.get(nextNode.id);
            if (nextState) return this.isNodePathSelected(nodes, nextState);
        }
        return !!state.selectAllChildren;
    }
    getRouteToNode(node) {
        const pathToNode = [];
        let tempNode = node;
        while(tempNode.parent){
            pathToNode.push(tempNode);
            tempNode = tempNode.parent;
        }
        return pathToNode.reverse();
    }
    removeRedundantState() {
        if (this.filterManager.isAnyFilterPresent()) return;
        const forEachNodeStateDepthFirst = (state = this.selectedState, thisKey, parentState)=>{
            state.toggledNodes.forEach((value, key)=>{
                forEachNodeStateDepthFirst(value, key, state);
            });
            if (thisKey) {
                const thisRow = this.rowModel.getRowNode(thisKey);
                const thisRowStore = thisRow == null ? void 0 : thisRow.childStore;
                const isStoreSizeKnown = thisRowStore == null ? void 0 : thisRowStore.isLastRowIndexKnown();
                if (isStoreSizeKnown) {
                    const possibleAllNodesToggled = state.toggledNodes.size >= thisRowStore.getRowCount();
                    if (possibleAllNodesToggled) {
                        for (const childState of state.toggledNodes.entries()){
                            const [key, value] = childState;
                            if (value.toggledNodes.size > 0) return;
                            const rowDoesNotExist = !this.rowModel.getRowNode(key);
                            if (rowDoesNotExist) return;
                        }
                        state.selectAllChildren = !state.selectAllChildren;
                        state.toggledNodes.clear();
                    }
                }
            }
            const hasNoToggledRows = state.toggledNodes.size === 0;
            const isIdenticalToParent = (parentState == null ? void 0 : parentState.selectAllChildren) === state.selectAllChildren;
            if (hasNoToggledRows && isIdenticalToParent) parentState == null || parentState.toggledNodes.delete(thisKey);
        };
        forEachNodeStateDepthFirst();
    }
    recursivelySelectNode([nextNode, ...nodes], selectedState, params) {
        if (!nextNode) return;
        const isLastNode = !nodes.length;
        if (isLastNode) {
            const isNodeSelectable = nextNode.selectable;
            const doesNodeConform = selectedState.selectAllChildren === params.newValue;
            if (doesNodeConform || !isNodeSelectable) {
                selectedState.toggledNodes.delete(nextNode.id);
                return;
            }
            const newState = {
                selectAllChildren: params.newValue,
                toggledNodes: /* @__PURE__ */ new Map()
            };
            selectedState.toggledNodes.set(nextNode.id, newState);
            return;
        }
        const doesStateAlreadyExist = selectedState.toggledNodes.has(nextNode.id);
        const childState = doesStateAlreadyExist ? selectedState.toggledNodes.get(nextNode.id) : {
            selectAllChildren: selectedState.selectAllChildren,
            toggledNodes: /* @__PURE__ */ new Map()
        };
        if (!doesStateAlreadyExist) selectedState.toggledNodes.set(nextNode.id, childState);
        this.recursivelySelectNode(nodes, childState, params);
        if (selectedState.selectAllChildren === childState.selectAllChildren && childState.toggledNodes.size === 0) selectedState.toggledNodes.delete(nextNode.id);
    }
    getSelectedNodes() {
        console.warn(`AG Grid: \`getSelectedNodes\` and \`getSelectedRows\` functions cannot be used with \`groupSelectsChildren\` and the server-side row model.
            Use \`api.getServerSideSelectionState()\` instead.`);
        const selectedNodes = [];
        this.rowModel.forEachNode((node)=>{
            if (node.isSelected()) selectedNodes.push(node);
        });
        return selectedNodes;
    }
    processNewRow(node) {}
    getSelectedRows() {
        return this.getSelectedNodes().map((node)=>node.data);
    }
    getSelectionCount() {
        return -1;
    }
    isEmpty() {
        var _a;
        return !this.selectedState.selectAllChildren && !((_a = this.selectedState.toggledNodes) == null ? void 0 : _a.size);
    }
    selectAllRowNodes(params) {
        this.selectedState = {
            selectAllChildren: true,
            toggledNodes: /* @__PURE__ */ new Map()
        };
    }
    deselectAllRowNodes(params) {
        this.selectedState = {
            selectAllChildren: false,
            toggledNodes: /* @__PURE__ */ new Map()
        };
    }
    getSelectAllState(justFiltered, justCurrentPage) {
        if (this.selectedState.selectAllChildren) {
            if (this.selectedState.toggledNodes.size > 0) return null;
            return true;
        }
        if (this.selectedState.toggledNodes.size > 0) return null;
        return false;
    }
};
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("rowModel")
], $5b7ccabde48fae90$var$GroupSelectsChildrenStrategy.prototype, "rowModel", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$GroupSelectsChildrenStrategy.prototype, "columnModel", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("filterManager")
], $5b7ccabde48fae90$var$GroupSelectsChildrenStrategy.prototype, "filterManager", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("rowModel")
], $5b7ccabde48fae90$var$GroupSelectsChildrenStrategy.prototype, "serverSideRowModel", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("selectionService")
], $5b7ccabde48fae90$var$GroupSelectsChildrenStrategy.prototype, "selectionService", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$GroupSelectsChildrenStrategy.prototype, "init", 1);
var $5b7ccabde48fae90$var$ServerSideSelectionService = class extends (0, $jIDNV.BeanStub) {
    init() {
        const groupSelectsChildren = this.gos.get("groupSelectsChildren");
        this.addManagedPropertyListener("groupSelectsChildren", (propChange)=>{
            this.destroyBean(this.selectionStrategy);
            const StrategyClazz2 = !propChange.currentValue ? $5b7ccabde48fae90$var$DefaultStrategy : $5b7ccabde48fae90$var$GroupSelectsChildrenStrategy;
            this.selectionStrategy = this.createManagedBean(new StrategyClazz2());
            this.shotgunResetNodeSelectionState();
            const event = {
                type: (0, $jIDNV.Events).EVENT_SELECTION_CHANGED,
                source: "api"
            };
            this.eventService.dispatchEvent(event);
        });
        this.addManagedPropertyListener("rowSelection", ()=>this.deselectAllRowNodes({
                source: "api"
            }));
        const StrategyClazz = !groupSelectsChildren ? $5b7ccabde48fae90$var$DefaultStrategy : $5b7ccabde48fae90$var$GroupSelectsChildrenStrategy;
        this.selectionStrategy = this.createManagedBean(new StrategyClazz());
    }
    getSelectionState() {
        return this.selectionStrategy.getSelectedState();
    }
    setSelectionState(state, source) {
        if (Array.isArray(state)) return;
        this.selectionStrategy.setSelectedState(state);
        this.shotgunResetNodeSelectionState();
        const event = {
            type: (0, $jIDNV.Events).EVENT_SELECTION_CHANGED,
            source: source
        };
        this.eventService.dispatchEvent(event);
    }
    setNodesSelected(params) {
        const _a = params, { nodes: nodes } = _a, otherParams = $5b7ccabde48fae90$var$__objRest2(_a, [
            "nodes"
        ]);
        const rowSelection = this.gos.get("rowSelection");
        if (nodes.length > 1 && rowSelection !== "multiple") {
            console.warn(`AG Grid: cannot multi select while rowSelection='single'`);
            return 0;
        }
        if (nodes.length > 1 && params.rangeSelect) {
            console.warn(`AG Grid: cannot use range selection when multi selecting rows`);
            return 0;
        }
        const adjustedParams = $5b7ccabde48fae90$var$__spreadValues12({
            nodes: nodes.filter((node)=>node.selectable)
        }, otherParams);
        if (!adjustedParams.nodes.length) return 0;
        const changedNodes = this.selectionStrategy.setNodesSelected(adjustedParams);
        this.shotgunResetNodeSelectionState(adjustedParams.source);
        const event = {
            type: (0, $jIDNV.Events).EVENT_SELECTION_CHANGED,
            source: adjustedParams.source
        };
        this.eventService.dispatchEvent(event);
        return changedNodes;
    }
    /**
   * Deletes the selection state for a set of nodes, for use after deleting nodes via
   * transaction. As this is designed for transactions, all nodes should belong to the same group.
   */ deleteSelectionStateFromParent(storeRoute, removedNodeIds) {
        const stateChanged = this.selectionStrategy.deleteSelectionStateFromParent(storeRoute, removedNodeIds);
        if (!stateChanged) return;
        this.shotgunResetNodeSelectionState();
        const event = {
            type: (0, $jIDNV.Events).EVENT_SELECTION_CHANGED,
            source: "api"
        };
        this.eventService.dispatchEvent(event);
    }
    shotgunResetNodeSelectionState(source) {
        this.rowModel.forEachNode((node)=>{
            if (node.stub) return;
            const isNodeSelected = this.selectionStrategy.isNodeSelected(node);
            if (isNodeSelected !== node.isSelected()) node.selectThisNode(isNodeSelected, void 0, source);
        });
    }
    getSelectedNodes() {
        return this.selectionStrategy.getSelectedNodes();
    }
    getSelectedRows() {
        return this.selectionStrategy.getSelectedRows();
    }
    getSelectionCount() {
        return this.selectionStrategy.getSelectionCount();
    }
    syncInRowNode(rowNode, oldNode) {
        this.selectionStrategy.processNewRow(rowNode);
        const isNodeSelected = this.selectionStrategy.isNodeSelected(rowNode);
        if (isNodeSelected != false && !rowNode.selectable) {
            this.selectionStrategy.setNodesSelected({
                nodes: [
                    rowNode
                ],
                newValue: false,
                source: "api"
            });
            this.shotgunResetNodeSelectionState();
            const event = {
                type: (0, $jIDNV.Events).EVENT_SELECTION_CHANGED,
                source: "api"
            };
            this.eventService.dispatchEvent(event);
            return;
        }
        rowNode.setSelectedInitialValue(isNodeSelected);
    }
    reset() {
        this.selectionStrategy.deselectAllRowNodes({
            source: "api"
        });
    }
    isEmpty() {
        return this.selectionStrategy.isEmpty();
    }
    hasNodesToSelect(justFiltered = false, justCurrentPage = false) {
        return true;
    }
    selectAllRowNodes(params) {
        if (params.justCurrentPage || params.justFiltered) console.warn("AG Grid: selecting just filtered only works when gridOptions.rowModelType='clientSide'");
        this.selectionStrategy.selectAllRowNodes(params);
        this.rowModel.forEachNode((node)=>{
            if (node.stub) return;
            node.selectThisNode(true, void 0, params.source);
        });
        const event = {
            type: (0, $jIDNV.Events).EVENT_SELECTION_CHANGED,
            source: params.source
        };
        this.eventService.dispatchEvent(event);
    }
    deselectAllRowNodes(params) {
        if (params.justCurrentPage || params.justFiltered) console.warn("AG Grid: selecting just filtered only works when gridOptions.rowModelType='clientSide'");
        this.selectionStrategy.deselectAllRowNodes(params);
        this.rowModel.forEachNode((node)=>{
            if (node.stub) return;
            node.selectThisNode(false, void 0, params.source);
        });
        const event = {
            type: (0, $jIDNV.Events).EVENT_SELECTION_CHANGED,
            source: params.source
        };
        this.eventService.dispatchEvent(event);
    }
    getSelectAllState(justFiltered, justCurrentPage) {
        return this.selectionStrategy.getSelectAllState(justFiltered, justCurrentPage);
    }
    // used by CSRM
    updateGroupsFromChildrenSelections(source, changedPath) {
        return false;
    }
    // used by CSRM
    getBestCostNodeSelection() {
        console.warn("AG Grid: calling gridApi.getBestCostNodeSelection() is only possible when using rowModelType=`clientSide`.");
        return void 0;
    }
    // used by CSRM
    filterFromSelection() {
        return;
    }
};
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("rowModel")
], $5b7ccabde48fae90$var$ServerSideSelectionService.prototype, "rowModel", 2);
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$ServerSideSelectionService.prototype, "init", 1);
$5b7ccabde48fae90$var$ServerSideSelectionService = $5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Bean)("selectionService")
], $5b7ccabde48fae90$var$ServerSideSelectionService);
var $5b7ccabde48fae90$var$VERSION15 = "31.3.4";
var $5b7ccabde48fae90$var$ServerSideExpansionService = class extends (0, $jIDNV.ExpansionService) {
    constructor(){
        super(...arguments);
        this.queuedRowIds = /* @__PURE__ */ new Set();
    }
    postConstruct() {
        super.postConstruct();
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_COLUMN_ROW_GROUP_CHANGED, ()=>{
            this.queuedRowIds.clear();
        });
    }
    checkOpenByDefault(rowNode) {
        if (!rowNode.isExpandable()) return;
        if (this.queuedRowIds.has(rowNode.id)) {
            this.queuedRowIds.delete(rowNode.id);
            rowNode.setExpanded(true);
            return;
        }
        const userFunc = this.gos.getCallback("isServerSideGroupOpenByDefault");
        if (!userFunc) return;
        const params = {
            data: rowNode.data,
            rowNode: rowNode
        };
        const userFuncRes = userFunc(params);
        if (userFuncRes) rowNode.setExpanded(true);
    }
    expandRows(rowIds) {
        rowIds.forEach((rowId)=>{
            const rowNode = this.serverSideRowModel.getRowNode(rowId);
            if (rowNode) rowNode.setExpanded(true);
            else this.queuedRowIds.add(rowId);
        });
    }
    expandAll(value) {
        this.serverSideRowModel.expandAll(value);
    }
    onGroupExpandedOrCollapsed() {}
};
$5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Autowired)("rowModel")
], $5b7ccabde48fae90$var$ServerSideExpansionService.prototype, "serverSideRowModel", 2);
$5b7ccabde48fae90$var$ServerSideExpansionService = $5b7ccabde48fae90$var$__decorateClass14([
    (0, $jIDNV.Bean)("expansionService")
], $5b7ccabde48fae90$var$ServerSideExpansionService);
var $5b7ccabde48fae90$export$5c0e9f044c5e2dce = {
    version: $5b7ccabde48fae90$var$VERSION15,
    moduleName: (0, $jIDNV.ModuleNames).ServerSideRowModelModule,
    rowModel: "serverSide",
    beans: [
        $5b7ccabde48fae90$var$ServerSideRowModel,
        $5b7ccabde48fae90$var$ExpandListener,
        $5b7ccabde48fae90$var$SortListener,
        $5b7ccabde48fae90$var$StoreUtils,
        $5b7ccabde48fae90$var$BlockUtils,
        $5b7ccabde48fae90$var$NodeManager,
        $5b7ccabde48fae90$var$TransactionManager,
        $5b7ccabde48fae90$var$FilterListener,
        $5b7ccabde48fae90$var$StoreFactory,
        $5b7ccabde48fae90$var$ListenerUtils,
        $5b7ccabde48fae90$var$ServerSideSelectionService,
        $5b7ccabde48fae90$var$ServerSideExpansionService,
        $5b7ccabde48fae90$var$LazyBlockLoadingService
    ],
    dependantModules: [
        $5b7ccabde48fae90$export$3a6d13add8617801
    ]
};
var $5b7ccabde48fae90$var$__defProp15 = Object.defineProperty;
var $5b7ccabde48fae90$var$__getOwnPropDesc15 = Object.getOwnPropertyDescriptor;
var $5b7ccabde48fae90$var$__decorateClass15 = (decorators, target, key, kind)=>{
    var result = kind > 1 ? void 0 : kind ? $5b7ccabde48fae90$var$__getOwnPropDesc15(target, key) : target;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
    if (kind && result) $5b7ccabde48fae90$var$__defProp15(target, key, result);
    return result;
};
var $5b7ccabde48fae90$var$ClientSideValuesExtractor = class {
    constructor(rowModel, filterParams, createKey, caseFormat, columnModel, valueService, treeDataOrGrouping, treeData, getDataPath, groupAllowUnbalanced, addManagedListener){
        this.rowModel = rowModel;
        this.filterParams = filterParams;
        this.createKey = createKey;
        this.caseFormat = caseFormat;
        this.columnModel = columnModel;
        this.valueService = valueService;
        this.treeDataOrGrouping = treeDataOrGrouping;
        this.treeData = treeData;
        this.getDataPath = getDataPath;
        this.groupAllowUnbalanced = groupAllowUnbalanced;
        this.addManagedListener = addManagedListener;
    }
    extractUniqueValuesAsync(predicate, existingValues) {
        return new (0, $jIDNV.AgPromise)((resolve)=>{
            if (this.rowModel.isRowDataLoaded()) resolve(this.extractUniqueValues(predicate, existingValues));
            else {
                const destroyFunc = this.addManagedListener((0, $jIDNV.Events).EVENT_ROW_COUNT_READY, ()=>{
                    destroyFunc == null || destroyFunc();
                    resolve(this.extractUniqueValues(predicate, existingValues));
                });
            }
        });
    }
    extractUniqueValues(predicate, existingValues) {
        const values = /* @__PURE__ */ new Map();
        const existingFormattedKeys = this.extractExistingFormattedKeys(existingValues);
        const formattedKeys = /* @__PURE__ */ new Set();
        const treeData = this.treeData && !!this.getDataPath;
        const groupedCols = this.columnModel.getRowGroupColumns();
        const addValue = (unformattedKey, value)=>{
            const formattedKey = this.caseFormat(unformattedKey);
            if (!formattedKeys.has(formattedKey)) {
                formattedKeys.add(formattedKey);
                let keyToAdd = unformattedKey;
                let valueToAdd = (0, $jIDNV._).makeNull(value);
                const existingUnformattedKey = existingFormattedKeys == null ? void 0 : existingFormattedKeys.get(formattedKey);
                if (existingUnformattedKey != null) {
                    keyToAdd = existingUnformattedKey;
                    valueToAdd = existingValues.get(existingUnformattedKey);
                }
                values.set(keyToAdd, valueToAdd);
            }
        };
        this.rowModel.forEachLeafNode((node)=>{
            if (!node.data || !predicate(node)) return;
            if (this.treeDataOrGrouping) {
                this.addValueForTreeDataOrGrouping(node, treeData, groupedCols, addValue);
                return;
            }
            let value = this.getValue(node);
            if (this.filterParams.convertValuesToStrings) {
                this.addValueForConvertValuesToString(node, value, addValue);
                return;
            }
            if (value != null && Array.isArray(value)) {
                value.forEach((x)=>{
                    addValue(this.createKey(x, node), x);
                });
                if (value.length === 0) addValue(null, null);
            } else addValue(this.createKey(value, node), value);
        });
        return values;
    }
    addValueForConvertValuesToString(node, value, addValue) {
        const key = this.createKey(value, node);
        if (key != null && Array.isArray(key)) {
            key.forEach((part)=>{
                const processedPart = (0, $jIDNV._).toStringOrNull((0, $jIDNV._).makeNull(part));
                addValue(processedPart, processedPart);
            });
            if (key.length === 0) addValue(null, null);
        } else addValue(key, key);
    }
    addValueForTreeDataOrGrouping(node, treeData, groupedCols, addValue) {
        var _a;
        let dataPath;
        if (treeData) {
            if ((_a = node.childrenAfterGroup) == null ? void 0 : _a.length) return;
            dataPath = this.getDataPath(node.data);
        } else {
            dataPath = groupedCols.map((groupCol)=>this.valueService.getKeyForNode(groupCol, node));
            dataPath.push(this.getValue(node));
        }
        if (dataPath) dataPath = dataPath.map((treeKey)=>(0, $jIDNV._).toStringOrNull((0, $jIDNV._).makeNull(treeKey)));
        if (!treeData && this.groupAllowUnbalanced && (dataPath == null ? void 0 : dataPath.some((treeKey)=>treeKey == null))) dataPath = dataPath.filter((treeKey)=>treeKey != null);
        addValue(this.createKey(dataPath), dataPath);
    }
    getValue(node) {
        return this.filterParams.getValue(node);
    }
    extractExistingFormattedKeys(existingValues) {
        if (!existingValues) return null;
        const existingFormattedKeys = /* @__PURE__ */ new Map();
        existingValues.forEach((_value, key)=>{
            existingFormattedKeys.set(this.caseFormat(key), key);
        });
        return existingFormattedKeys;
    }
};
var $5b7ccabde48fae90$var$SetFilterDisplayValue = class {
};
$5b7ccabde48fae90$var$SetFilterDisplayValue.SELECT_ALL = "__AG_SELECT_ALL__";
$5b7ccabde48fae90$var$SetFilterDisplayValue.ADD_SELECTION_TO_FILTER = "__AG_ADD_SELECTION_TO_FILTER__";
var $5b7ccabde48fae90$var$FlatSetDisplayValueModel = class {
    constructor(valueService, valueFormatter, formatter, column){
        this.valueService = valueService;
        this.valueFormatter = valueFormatter;
        this.formatter = formatter;
        this.column = column;
        this.displayedKeys = [];
    }
    updateDisplayedValuesToAllAvailable(_getValue, _allKeys, availableKeys) {
        this.displayedKeys = Array.from(availableKeys);
    }
    updateDisplayedValuesToMatchMiniFilter(getValue, _allKeys, availableKeys, matchesFilter, nullMatchesFilter) {
        this.displayedKeys = [];
        for (let key of availableKeys){
            if (key == null) {
                if (nullMatchesFilter) this.displayedKeys.push(key);
            } else {
                const value = getValue(key);
                const valueFormatterValue = this.valueService.formatValue(this.column, null, value, this.valueFormatter, false);
                const textFormatterValue = this.formatter(valueFormatterValue);
                if (matchesFilter(textFormatterValue)) this.displayedKeys.push(key);
            }
        }
    }
    getDisplayedValueCount() {
        return this.displayedKeys.length;
    }
    getDisplayedItem(index) {
        return this.displayedKeys[index];
    }
    getSelectAllItem() {
        return $5b7ccabde48fae90$var$SetFilterDisplayValue.SELECT_ALL;
    }
    getAddSelectionToFilterItem() {
        return $5b7ccabde48fae90$var$SetFilterDisplayValue.ADD_SELECTION_TO_FILTER;
    }
    getDisplayedKeys() {
        return this.displayedKeys;
    }
    forEachDisplayedKey(func) {
        this.displayedKeys.forEach(func);
    }
    someDisplayedKey(func) {
        return this.displayedKeys.some(func);
    }
    hasGroups() {
        return false;
    }
    refresh() {}
};
var $5b7ccabde48fae90$var$_TreeSetDisplayValueModel = class _TreeSetDisplayValueModel2 {
    constructor(formatter, treeListPathGetter, treeListFormatter, treeDataOrGrouping){
        this.formatter = formatter;
        this.treeListPathGetter = treeListPathGetter;
        this.treeListFormatter = treeListFormatter;
        this.treeDataOrGrouping = treeDataOrGrouping;
        this.allDisplayedItemsTree = [];
        this.activeDisplayedItemsFlat = [];
        this.selectAllItem = {
            depth: 0,
            filterPasses: true,
            available: true,
            treeKey: $5b7ccabde48fae90$var$SetFilterDisplayValue.SELECT_ALL,
            children: this.allDisplayedItemsTree,
            expanded: true,
            key: $5b7ccabde48fae90$var$SetFilterDisplayValue.SELECT_ALL,
            parentTreeKeys: []
        };
        this.addSelectionToFilterItem = {
            depth: 0,
            filterPasses: true,
            available: true,
            treeKey: $5b7ccabde48fae90$var$SetFilterDisplayValue.ADD_SELECTION_TO_FILTER,
            expanded: true,
            key: $5b7ccabde48fae90$var$SetFilterDisplayValue.ADD_SELECTION_TO_FILTER,
            parentTreeKeys: []
        };
    }
    updateDisplayedValuesToAllAvailable(getValue, allKeys, availableKeys, source) {
        if (source === "reload") this.generateItemTree(getValue, allKeys, availableKeys);
        else if (source === "otherFilter") {
            this.updateAvailable(availableKeys);
            this.updateExpandAll();
        } else if (source === "miniFilter") {
            this.resetFilter();
            this.updateExpandAll();
        }
        this.flattenItems();
    }
    updateDisplayedValuesToMatchMiniFilter(getValue, allKeys, availableKeys, matchesFilter, nullMatchesFilter, source) {
        if (source === "reload") this.generateItemTree(getValue, allKeys, availableKeys);
        else if (source === "otherFilter") this.updateAvailable(availableKeys);
        this.updateFilter(matchesFilter, nullMatchesFilter);
        this.updateExpandAll();
        this.flattenItems();
    }
    generateItemTree(getValue, allKeys, availableKeys) {
        var _a;
        this.allDisplayedItemsTree = [];
        this.groupsExist = false;
        const treeListPathGetter = this.getTreeListPathGetter(getValue, availableKeys);
        for (let key of allKeys){
            const value = getValue(key);
            const dataPath = (_a = treeListPathGetter(value)) != null ? _a : [
                null
            ];
            if (dataPath.length > 1) this.groupsExist = true;
            const available = availableKeys.has(key);
            let children = this.allDisplayedItemsTree;
            let item;
            let parentTreeKeys = [];
            dataPath.forEach((treeKey, depth)=>{
                if (!children) {
                    children = [];
                    item.children = children;
                }
                item = children.find((child)=>{
                    var _a2;
                    return ((_a2 = child.treeKey) == null ? void 0 : _a2.toUpperCase()) === (treeKey == null ? void 0 : treeKey.toUpperCase());
                });
                if (!item) {
                    item = {
                        treeKey: treeKey,
                        depth: depth,
                        filterPasses: true,
                        expanded: false,
                        available: available,
                        parentTreeKeys: parentTreeKeys
                    };
                    if (depth === dataPath.length - 1) item.key = key;
                    children.push(item);
                }
                children = item.children;
                parentTreeKeys = [
                    ...parentTreeKeys,
                    treeKey
                ];
            });
        }
        this.updateAvailable(availableKeys);
        this.selectAllItem.children = this.allDisplayedItemsTree;
        this.selectAllItem.expanded = false;
    }
    getTreeListPathGetter(getValue, availableKeys) {
        if (this.treeListPathGetter) return this.treeListPathGetter;
        if (this.treeDataOrGrouping) return (value)=>value;
        let isDate2 = false;
        for (const availableKey of availableKeys){
            const value = getValue(availableKey);
            if (value instanceof Date) {
                isDate2 = true;
                break;
            } else if (value != null) break;
        }
        if (isDate2) return _TreeSetDisplayValueModel2.DATE_TREE_LIST_PATH_GETTER;
        (0, $jIDNV._).warnOnce("property treeList=true for Set Filter params, but you did not provide a treeListPathGetter or values of type Date.");
        return (value)=>[
                String(value)
            ];
    }
    flattenItems() {
        this.activeDisplayedItemsFlat = [];
        const recursivelyFlattenDisplayedItems = (items)=>{
            items.forEach((item)=>{
                if (!item.filterPasses || !item.available) return;
                this.activeDisplayedItemsFlat.push(item);
                if (item.children && item.expanded) recursivelyFlattenDisplayedItems(item.children);
            });
        };
        recursivelyFlattenDisplayedItems(this.allDisplayedItemsTree);
    }
    resetFilter() {
        const recursiveFilterReset = (item)=>{
            if (item.children) item.children.forEach((child)=>{
                recursiveFilterReset(child);
            });
            item.filterPasses = true;
        };
        this.allDisplayedItemsTree.forEach((item)=>recursiveFilterReset(item));
    }
    updateFilter(matchesFilter, nullMatchesFilter) {
        const passesFilter = (item)=>{
            if (!item.available) return false;
            if (item.treeKey == null) return nullMatchesFilter;
            return matchesFilter(this.formatter(this.treeListFormatter ? this.treeListFormatter(item.treeKey, item.depth, item.parentTreeKeys) : item.treeKey));
        };
        this.allDisplayedItemsTree.forEach((item)=>this.recursiveItemCheck(item, false, passesFilter, "filterPasses"));
    }
    getDisplayedValueCount() {
        return this.activeDisplayedItemsFlat.length;
    }
    getDisplayedItem(index) {
        return this.activeDisplayedItemsFlat[index];
    }
    getSelectAllItem() {
        return this.selectAllItem;
    }
    getAddSelectionToFilterItem() {
        return this.addSelectionToFilterItem;
    }
    getDisplayedKeys() {
        const displayedKeys = [];
        this.forEachDisplayedKey((key)=>displayedKeys.push(key));
        return displayedKeys;
    }
    forEachDisplayedKey(func) {
        const recursiveForEachItem = (item, topParentExpanded)=>{
            if (item.children) {
                if (!item.expanded || !topParentExpanded) item.children.forEach((child)=>{
                    if (child.filterPasses) recursiveForEachItem(child, false);
                });
            } else func(item.key);
        };
        this.activeDisplayedItemsFlat.forEach((item)=>recursiveForEachItem(item, true));
    }
    someDisplayedKey(func) {
        const recursiveSomeItem = (item, topParentExpanded)=>{
            if (item.children) {
                if (!item.expanded || !topParentExpanded) return item.children.some((child)=>{
                    if (child.filterPasses) return recursiveSomeItem(child, false);
                    return false;
                });
            } else return func(item.key);
            return false;
        };
        return this.activeDisplayedItemsFlat.some((item)=>recursiveSomeItem(item, true));
    }
    hasGroups() {
        return this.groupsExist;
    }
    refresh() {
        this.updateExpandAll();
        this.flattenItems();
    }
    updateExpandAll() {
        const recursiveExpansionCheck = (items, someTrue, someFalse)=>{
            for (const item2 of items){
                if (!item2.filterPasses || !item2.available || !item2.children) continue;
                someTrue = someTrue || !!item2.expanded;
                someFalse = someFalse || !item2.expanded;
                if (someTrue && someFalse) return void 0;
                const childExpanded = recursiveExpansionCheck(item2.children, someTrue, someFalse);
                if (childExpanded === void 0) return void 0;
                else if (childExpanded) someTrue = true;
                else someFalse = true;
            }
            return someTrue && someFalse ? void 0 : someTrue;
        };
        const item = this.getSelectAllItem();
        item.expanded = recursiveExpansionCheck(item.children, false, false);
    }
    recursiveItemCheck(item, parentPasses, checkFunction, itemProp) {
        let atLeastOneChildPassed = false;
        if (item.children) item.children.forEach((child)=>{
            const childPasses = this.recursiveItemCheck(child, parentPasses || checkFunction(item), checkFunction, itemProp);
            atLeastOneChildPassed = atLeastOneChildPassed || childPasses;
        });
        const itemPasses = parentPasses || atLeastOneChildPassed || checkFunction(item);
        item[itemProp] = itemPasses;
        return itemPasses;
    }
    updateAvailable(availableKeys) {
        const isAvailable = (item)=>availableKeys.has(item.key);
        this.allDisplayedItemsTree.forEach((item)=>this.recursiveItemCheck(item, false, isAvailable, "available"));
    }
};
$5b7ccabde48fae90$var$_TreeSetDisplayValueModel.DATE_TREE_LIST_PATH_GETTER = (date)=>date ? [
        String(date.getFullYear()),
        String(date.getMonth() + 1),
        String(date.getDate())
    ] : null;
var $5b7ccabde48fae90$var$TreeSetDisplayValueModel = $5b7ccabde48fae90$var$_TreeSetDisplayValueModel;
var $5b7ccabde48fae90$var$SetValueModelFilteringKeys = class {
    constructor({ caseFormat: caseFormat }){
        this.filteringKeys = null;
        this.filteringKeysCaseFormatted = null;
        this.hasNoAppliedFilteringKeys = false;
        this.caseFormat = caseFormat;
    }
    allFilteringKeys() {
        return this.filteringKeys;
    }
    allFilteringKeysCaseFormatted() {
        return this.filteringKeysCaseFormatted;
    }
    noAppliedFilteringKeys() {
        return this.hasNoAppliedFilteringKeys;
    }
    setFilteringKeys(filteringKeys) {
        this.filteringKeys = new Set(filteringKeys);
        this.hasNoAppliedFilteringKeys = !this.filteringKeys || this.filteringKeys.size === 0;
        this.filteringKeysCaseFormatted = /* @__PURE__ */ new Set();
        this.filteringKeys.forEach((key)=>this.filteringKeysCaseFormatted.add(this.caseFormat(key)));
    }
    addFilteringKey(key) {
        if (this.filteringKeys == null) {
            this.filteringKeys = /* @__PURE__ */ new Set();
            this.filteringKeysCaseFormatted = /* @__PURE__ */ new Set();
        }
        this.filteringKeys.add(key);
        this.filteringKeysCaseFormatted.add(this.caseFormat(key));
        if (this.hasNoAppliedFilteringKeys) this.hasNoAppliedFilteringKeys = false;
    }
    hasCaseFormattedFilteringKey(key) {
        return this.filteringKeysCaseFormatted.has(this.caseFormat(key));
    }
    hasFilteringKey(key) {
        return this.filteringKeys.has(key);
    }
    reset() {
        this.filteringKeys = null;
        this.filteringKeysCaseFormatted = null;
        this.hasNoAppliedFilteringKeys = false;
    }
};
var $5b7ccabde48fae90$var$_SetValueModel = class _SetValueModel2 {
    constructor(params){
        this.localEventService = new (0, $jIDNV.EventService)();
        this.miniFilterText = null;
        this.addCurrentSelectionToFilter = false;
        this.providedValues = null;
        this.allValues = /* @__PURE__ */ new Map();
        this.availableKeys = /* @__PURE__ */ new Set();
        this.selectedKeys = /* @__PURE__ */ new Set();
        this.initialised = false;
        const { usingComplexObjects: usingComplexObjects, columnModel: columnModel, valueService: valueService, treeDataTreeList: treeDataTreeList, groupingTreeList: groupingTreeList, filterParams: filterParams, gos: gos, valueFormatter: valueFormatter, addManagedListener: addManagedListener } = params;
        const { column: column, colDef: colDef, textFormatter: textFormatter, doesRowPassOtherFilter: doesRowPassOtherFilter, suppressSorting: suppressSorting, comparator: comparator, rowModel: rowModel, values: values, caseSensitive: caseSensitive, convertValuesToStrings: convertValuesToStrings, treeList: treeList, treeListPathGetter: treeListPathGetter, treeListFormatter: treeListFormatter } = filterParams;
        this.filterParams = filterParams;
        this.gos = gos;
        this.setIsLoading = params.setIsLoading;
        this.translate = params.translate;
        this.caseFormat = params.caseFormat;
        this.createKey = params.createKey;
        this.usingComplexObjects = !!params.usingComplexObjects;
        this.formatter = textFormatter || (0, $jIDNV.TextFilter).DEFAULT_FORMATTER;
        this.doesRowPassOtherFilters = doesRowPassOtherFilter;
        this.suppressSorting = suppressSorting || false;
        this.convertValuesToStrings = !!convertValuesToStrings;
        this.filteringKeys = new $5b7ccabde48fae90$var$SetValueModelFilteringKeys({
            caseFormat: this.caseFormat
        });
        const keyComparator = comparator != null ? comparator : colDef.comparator;
        const treeDataOrGrouping = !!treeDataTreeList || !!groupingTreeList;
        this.compareByValue = !!(usingComplexObjects && keyComparator || treeDataOrGrouping || treeList && !treeListPathGetter);
        if (treeDataOrGrouping && !keyComparator) this.entryComparator = this.createTreeDataOrGroupingComparator();
        else if (treeList && !treeListPathGetter && !keyComparator) this.entryComparator = ([_aKey, aValue], [_bKey, bValue])=>(0, $jIDNV._).defaultComparator(aValue, bValue);
        else this.entryComparator = ([_aKey, aValue], [_bKey, bValue])=>keyComparator(aValue, bValue);
        this.keyComparator = keyComparator != null ? keyComparator : (0, $jIDNV._).defaultComparator;
        this.caseSensitive = !!caseSensitive;
        const getDataPath = gos.get("getDataPath");
        const groupAllowUnbalanced = gos.get("groupAllowUnbalanced");
        if (rowModel.getType() === "clientSide") this.clientSideValuesExtractor = new $5b7ccabde48fae90$var$ClientSideValuesExtractor(rowModel, this.filterParams, this.createKey, this.caseFormat, columnModel, valueService, treeDataOrGrouping, !!treeDataTreeList, getDataPath, groupAllowUnbalanced, addManagedListener);
        if (values == null) this.valuesType = 2;
        else {
            this.valuesType = Array.isArray(values) ? 0 : 1;
            this.providedValues = values;
        }
        this.displayValueModel = treeList ? new $5b7ccabde48fae90$var$TreeSetDisplayValueModel(this.formatter, treeListPathGetter, treeListFormatter, treeDataTreeList || groupingTreeList) : new $5b7ccabde48fae90$var$FlatSetDisplayValueModel(valueService, valueFormatter, this.formatter, column);
        this.updateAllValues().then((updatedKeys)=>this.resetSelectionState(updatedKeys || []));
    }
    addEventListener(eventType, listener, async) {
        this.localEventService.addEventListener(eventType, listener, async);
    }
    removeEventListener(eventType, listener, async) {
        this.localEventService.removeEventListener(eventType, listener, async);
    }
    updateOnParamsChange(filterParams) {
        return new (0, $jIDNV.AgPromise)((resolve)=>{
            const { values: values, textFormatter: textFormatter, suppressSorting: suppressSorting } = filterParams;
            const currentProvidedValues = this.providedValues;
            const currentSuppressSorting = this.suppressSorting;
            this.filterParams = filterParams;
            this.formatter = textFormatter || (0, $jIDNV.TextFilter).DEFAULT_FORMATTER;
            this.suppressSorting = suppressSorting || false;
            this.providedValues = values != null ? values : null;
            if (this.providedValues !== currentProvidedValues || this.suppressSorting !== currentSuppressSorting) {
                if (!values || values.length === 0) {
                    this.valuesType = 2;
                    this.providedValues = null;
                } else this.valuesType = Array.isArray(values) ? 0 : 1;
                const currentModel = this.getModel();
                this.updateAllValues().then((updatedKeys)=>{
                    this.setModel(currentModel).then(()=>resolve());
                });
            } else resolve();
        });
    }
    /**
   * Re-fetches the values used in the filter from the value source.
   * If keepSelection is false, the filter selection will be reset to everything selected,
   * otherwise the current selection will be preserved.
   */ refreshValues() {
        return new (0, $jIDNV.AgPromise)((resolve)=>{
            this.allValuesPromise.then(()=>{
                const currentModel = this.getModel();
                this.updateAllValues();
                this.setModel(currentModel).then(()=>resolve());
            });
        });
    }
    /**
   * Overrides the current values being used for the set filter.
   * If keepSelection is false, the filter selection will be reset to everything selected,
   * otherwise the current selection will be preserved.
   */ overrideValues(valuesToUse) {
        return new (0, $jIDNV.AgPromise)((resolve)=>{
            this.allValuesPromise.then(()=>{
                this.valuesType = 0;
                this.providedValues = valuesToUse;
                this.refreshValues().then(()=>resolve());
            });
        });
    }
    /** @return has anything been updated */ refreshAfterAnyFilterChanged() {
        if (this.showAvailableOnly()) return this.allValuesPromise.then((keys)=>{
            this.updateAvailableKeys(keys != null ? keys : [], "otherFilter");
            return true;
        });
        return (0, $jIDNV.AgPromise).resolve(false);
    }
    isInitialised() {
        return this.initialised;
    }
    updateAllValues() {
        this.allValuesPromise = new (0, $jIDNV.AgPromise)((resolve)=>{
            switch(this.valuesType){
                case 2:
                    this.getValuesFromRowsAsync(false).then((values)=>resolve(this.processAllValues(values)));
                    break;
                case 0:
                    resolve(this.processAllValues(this.uniqueValues(this.validateProvidedValues(this.providedValues))));
                    break;
                case 1:
                    {
                        this.setIsLoading(true);
                        const callback = this.providedValues;
                        const { column: column, colDef: colDef } = this.filterParams;
                        const params = this.gos.addGridCommonParams({
                            success: (values)=>{
                                this.setIsLoading(false);
                                resolve(this.processAllValues(this.uniqueValues(this.validateProvidedValues(values))));
                            },
                            colDef: colDef,
                            column: column
                        });
                        window.setTimeout(()=>callback(params), 0);
                        break;
                    }
                default:
                    throw new Error("Unrecognised valuesType");
            }
        });
        this.allValuesPromise.then((values)=>this.updateAvailableKeys(values || [], "reload")).then(()=>this.initialised = true);
        return this.allValuesPromise;
    }
    processAllValues(values) {
        const sortedKeys = this.sortKeys(values);
        this.allValues = values != null ? values : /* @__PURE__ */ new Map();
        return sortedKeys;
    }
    validateProvidedValues(values) {
        if (this.usingComplexObjects && (values == null ? void 0 : values.length)) {
            const firstValue = values[0];
            if (firstValue && typeof firstValue !== "object" && typeof firstValue !== "function") {
                const firstKey = this.createKey(firstValue);
                if (firstKey == null) (0, $jIDNV._).warnOnce("Set Filter Key Creator is returning null for provided values and provided values are primitives. Please provide complex objects or set convertValuesToStrings=true in the filterParams. See https://www.ag-grid.com/javascript-data-grid/filter-set-filter-list/#filter-value-types");
                else (0, $jIDNV._).warnOnce("Set Filter has a Key Creator, but provided values are primitives. Did you mean to provide complex objects or enable convertValuesToStrings?");
            }
        }
        return values;
    }
    setValuesType(value) {
        this.valuesType = value;
    }
    getValuesType() {
        return this.valuesType;
    }
    isKeyAvailable(key) {
        return this.availableKeys.has(key);
    }
    showAvailableOnly() {
        return this.valuesType === 2;
    }
    updateAvailableKeys(allKeys, source) {
        const availableKeys = this.showAvailableOnly() ? this.sortKeys(this.getValuesFromRows(true)) : allKeys;
        this.availableKeys = new Set(availableKeys);
        this.localEventService.dispatchEvent({
            type: _SetValueModel2.EVENT_AVAILABLE_VALUES_CHANGED
        });
        this.updateDisplayedValues(source, allKeys);
    }
    sortKeys(nullableValues) {
        const values = nullableValues != null ? nullableValues : /* @__PURE__ */ new Map();
        if (this.suppressSorting) return Array.from(values.keys());
        let sortedKeys;
        if (this.compareByValue) sortedKeys = Array.from(values.entries()).sort(this.entryComparator).map(([key])=>key);
        else sortedKeys = Array.from(values.keys()).sort(this.keyComparator);
        if (this.filterParams.excelMode && values.has(null)) {
            sortedKeys = sortedKeys.filter((v)=>v != null);
            sortedKeys.push(null);
        }
        return sortedKeys;
    }
    getParamsForValuesFromRows(removeUnavailableValues = false) {
        if (!this.clientSideValuesExtractor) {
            (0, $jIDNV._).doOnce(()=>{
                console.error("AG Grid: Set Filter cannot initialise because you are using a row model that does not contain all rows in the browser. Either use a different filter type, or configure Set Filter such that you provide it with values");
            }, "setFilterValueNotCSRM");
            return null;
        }
        const predicate = (node)=>!removeUnavailableValues || this.doesRowPassOtherFilters(node);
        const existingValues = removeUnavailableValues && !this.caseSensitive ? this.allValues : void 0;
        return {
            predicate: predicate,
            existingValues: existingValues
        };
    }
    getValuesFromRows(removeUnavailableValues = false) {
        const params = this.getParamsForValuesFromRows(removeUnavailableValues);
        if (!params) return null;
        return this.clientSideValuesExtractor.extractUniqueValues(params.predicate, params.existingValues);
    }
    getValuesFromRowsAsync(removeUnavailableValues = false) {
        const params = this.getParamsForValuesFromRows(removeUnavailableValues);
        if (!params) return (0, $jIDNV.AgPromise).resolve(null);
        return this.clientSideValuesExtractor.extractUniqueValuesAsync(params.predicate, params.existingValues);
    }
    /** Sets mini filter value. Returns true if it changed from last value, otherwise false. */ setMiniFilter(value) {
        value = (0, $jIDNV._).makeNull(value);
        if (this.miniFilterText === value) return false;
        if (value === null) this.setAddCurrentSelectionToFilter(false);
        this.miniFilterText = value;
        this.updateDisplayedValues("miniFilter");
        return true;
    }
    getMiniFilter() {
        return this.miniFilterText;
    }
    updateDisplayedValues(source, allKeys) {
        if (source === "expansion") {
            this.displayValueModel.refresh();
            return;
        }
        if (this.miniFilterText == null) {
            this.displayValueModel.updateDisplayedValuesToAllAvailable((key)=>this.getValue(key), allKeys, this.availableKeys, source);
            return;
        }
        const formattedFilterText = this.caseFormat(this.formatter(this.miniFilterText) || "");
        const matchesFilter = (valueToCheck)=>valueToCheck != null && this.caseFormat(valueToCheck).indexOf(formattedFilterText) >= 0;
        const nullMatchesFilter = !!this.filterParams.excelMode && matchesFilter(this.translate("blanks"));
        this.displayValueModel.updateDisplayedValuesToMatchMiniFilter((key)=>this.getValue(key), allKeys, this.availableKeys, matchesFilter, nullMatchesFilter, source);
    }
    getDisplayedValueCount() {
        return this.displayValueModel.getDisplayedValueCount();
    }
    getDisplayedItem(index) {
        return this.displayValueModel.getDisplayedItem(index);
    }
    getSelectAllItem() {
        return this.displayValueModel.getSelectAllItem();
    }
    getAddSelectionToFilterItem() {
        return this.displayValueModel.getAddSelectionToFilterItem();
    }
    hasSelections() {
        return this.filterParams.defaultToNothingSelected ? this.selectedKeys.size > 0 : this.allValues.size !== this.selectedKeys.size;
    }
    getKeys() {
        return Array.from(this.allValues.keys());
    }
    getValues() {
        return Array.from(this.allValues.values());
    }
    getValue(key) {
        return this.allValues.get(key);
    }
    setAddCurrentSelectionToFilter(value) {
        this.addCurrentSelectionToFilter = value;
    }
    isInWindowsExcelMode() {
        return this.filterParams.excelMode === "windows";
    }
    isAddCurrentSelectionToFilterChecked() {
        return this.isInWindowsExcelMode() && this.addCurrentSelectionToFilter;
    }
    showAddCurrentSelectionToFilter() {
        return this.isInWindowsExcelMode() && (0, $jIDNV._).exists(this.miniFilterText) && this.miniFilterText.length > 0;
    }
    selectAllMatchingMiniFilter(clearExistingSelection = false) {
        if (this.miniFilterText == null) this.selectedKeys = new Set(this.allValues.keys());
        else {
            if (clearExistingSelection) this.selectedKeys.clear();
            this.displayValueModel.forEachDisplayedKey((key)=>this.selectedKeys.add(key));
        }
    }
    deselectAllMatchingMiniFilter() {
        if (this.miniFilterText == null) this.selectedKeys.clear();
        else this.displayValueModel.forEachDisplayedKey((key)=>this.selectedKeys.delete(key));
    }
    selectKey(key) {
        this.selectedKeys.add(key);
    }
    deselectKey(key) {
        if (this.filterParams.excelMode && this.isEverythingVisibleSelected()) this.resetSelectionState(this.displayValueModel.getDisplayedKeys());
        this.selectedKeys.delete(key);
    }
    isKeySelected(key) {
        return this.selectedKeys.has(key);
    }
    isEverythingVisibleSelected() {
        return !this.displayValueModel.someDisplayedKey((it)=>!this.isKeySelected(it));
    }
    isNothingVisibleSelected() {
        return !this.displayValueModel.someDisplayedKey((it)=>this.isKeySelected(it));
    }
    getModel() {
        if (!this.hasSelections()) return null;
        const filteringKeys = this.isAddCurrentSelectionToFilterChecked() ? this.filteringKeys.allFilteringKeys() : null;
        if (filteringKeys && filteringKeys.size > 0) {
            if (this.selectedKeys) {
                const modelKeys = /* @__PURE__ */ new Set([
                    ...Array.from(filteringKeys),
                    ...Array.from(this.selectedKeys).filter((key)=>!filteringKeys.has(key))
                ]);
                return Array.from(modelKeys);
            }
            return Array.from(filteringKeys);
        }
        return Array.from(this.selectedKeys);
    }
    setModel(model) {
        return this.allValuesPromise.then((keys)=>{
            if (model == null) this.resetSelectionState(keys != null ? keys : []);
            else {
                this.selectedKeys.clear();
                const existingFormattedKeys = /* @__PURE__ */ new Map();
                this.allValues.forEach((_value, key)=>{
                    existingFormattedKeys.set(this.caseFormat(key), key);
                });
                model.forEach((unformattedKey)=>{
                    const formattedKey = this.caseFormat((0, $jIDNV._).makeNull(unformattedKey));
                    const existingUnformattedKey = existingFormattedKeys.get(formattedKey);
                    if (existingUnformattedKey !== void 0) this.selectKey(existingUnformattedKey);
                });
            }
        });
    }
    uniqueValues(values) {
        const uniqueValues = /* @__PURE__ */ new Map();
        const formattedKeys = /* @__PURE__ */ new Set();
        (values != null ? values : []).forEach((value)=>{
            const valueToUse = (0, $jIDNV._).makeNull(value);
            const unformattedKey = this.convertAndGetKey(valueToUse);
            const formattedKey = this.caseFormat(unformattedKey);
            if (!formattedKeys.has(formattedKey)) {
                formattedKeys.add(formattedKey);
                uniqueValues.set(unformattedKey, valueToUse);
            }
        });
        return uniqueValues;
    }
    convertAndGetKey(value) {
        return this.convertValuesToStrings ? value : this.createKey(value);
    }
    resetSelectionState(keys) {
        if (this.filterParams.defaultToNothingSelected) this.selectedKeys.clear();
        else this.selectedKeys = new Set(keys);
    }
    hasGroups() {
        return this.displayValueModel.hasGroups();
    }
    createTreeDataOrGroupingComparator() {
        return ([_aKey, aValue], [_bKey, bValue])=>{
            if (aValue == null) return bValue == null ? 0 : -1;
            else if (bValue == null) return 1;
            for(let i = 0; i < aValue.length; i++){
                if (i >= bValue.length) return 1;
                const diff = (0, $jIDNV._).defaultComparator(aValue[i], bValue[i]);
                if (diff !== 0) return diff;
            }
            return 0;
        };
    }
    setAppliedModelKeys(appliedModelKeys) {
        this.filteringKeys.setFilteringKeys(appliedModelKeys);
    }
    addToAppliedModelKeys(appliedModelKey) {
        this.filteringKeys.addFilteringKey(appliedModelKey);
    }
    getAppliedModelKeys() {
        return this.filteringKeys.allFilteringKeys();
    }
    getCaseFormattedAppliedModelKeys() {
        return this.filteringKeys.allFilteringKeysCaseFormatted();
    }
    hasAppliedModelKey(appliedModelKey) {
        return this.filteringKeys.hasCaseFormattedFilteringKey(appliedModelKey);
    }
    hasAnyAppliedModelKey() {
        return !this.filteringKeys.noAppliedFilteringKeys();
    }
};
$5b7ccabde48fae90$var$_SetValueModel.EVENT_AVAILABLE_VALUES_CHANGED = "availableValuesChanged";
var $5b7ccabde48fae90$var$SetValueModel = $5b7ccabde48fae90$var$_SetValueModel;
var $5b7ccabde48fae90$var$_SetFilterListItem = class _SetFilterListItem2 extends (0, $jIDNV.Component) {
    constructor(params){
        var _a;
        super(params.isGroup ? _SetFilterListItem2.GROUP_TEMPLATE : _SetFilterListItem2.TEMPLATE);
        this.focusWrapper = params.focusWrapper;
        this.value = params.value;
        this.params = params.params;
        this.translate = params.translate;
        this.valueFormatter = params.valueFormatter;
        this.item = params.item;
        this.isSelected = params.isSelected;
        this.isTree = params.isTree;
        this.depth = (_a = params.depth) != null ? _a : 0;
        this.isGroup = params.isGroup;
        this.groupsExist = params.groupsExist;
        this.isExpanded = params.isExpanded;
        this.hasIndeterminateExpandState = params.hasIndeterminateExpandState;
    }
    init() {
        this.addDestroyFunc(()=>{
            var _a;
            return (_a = this.destroyCellRendererComponent) == null ? void 0 : _a.call(this);
        });
        this.render();
        this.eCheckbox.setLabelEllipsis(true).setValue(this.isSelected, true).setDisabled(!!this.params.readOnly).getInputElement().setAttribute("tabindex", "-1");
        this.refreshVariableAriaLabels();
        if (this.isTree) {
            if (this.depth > 0) this.addCssClass("ag-set-filter-indent-" + this.depth);
            if (this.isGroup) this.setupExpansion();
            else if (this.groupsExist) this.addCssClass("ag-set-filter-add-group-indent");
            (0, $jIDNV._).setAriaLevel(this.getAriaElement(), this.depth + 1);
        }
        this.refreshAriaChecked();
        if (!!this.params.readOnly) return;
        this.eCheckbox.onValueChange((value)=>this.onCheckboxChanged(!!value));
    }
    getFocusableElement() {
        return this.focusWrapper;
    }
    setupExpansion() {
        this.eGroupClosedIcon.appendChild((0, $jIDNV._).createIcon("setFilterGroupClosed", this.gos, null));
        this.eGroupOpenedIcon.appendChild((0, $jIDNV._).createIcon("setFilterGroupOpen", this.gos, null));
        this.addManagedListener(this.eGroupClosedIcon, "click", this.onExpandOrContractClicked.bind(this));
        this.addManagedListener(this.eGroupOpenedIcon, "click", this.onExpandOrContractClicked.bind(this));
        if (this.hasIndeterminateExpandState) {
            this.eGroupIndeterminateIcon.appendChild((0, $jIDNV._).createIcon("setFilterGroupIndeterminate", this.gos, null));
            this.addManagedListener(this.eGroupIndeterminateIcon, "click", this.onExpandOrContractClicked.bind(this));
        }
        this.setExpandedIcons();
        this.refreshAriaExpanded();
    }
    onExpandOrContractClicked() {
        this.setExpanded(!this.isExpanded);
    }
    setExpanded(isExpanded, silent) {
        if (this.isGroup && isExpanded !== this.isExpanded) {
            this.isExpanded = isExpanded;
            const event = {
                type: _SetFilterListItem2.EVENT_EXPANDED_CHANGED,
                isExpanded: !!isExpanded,
                item: this.item
            };
            if (!silent) this.dispatchEvent(event);
            this.setExpandedIcons();
            this.refreshAriaExpanded();
        }
    }
    setExpandedIcons() {
        (0, $jIDNV._).setDisplayed(this.eGroupClosedIcon, this.hasIndeterminateExpandState ? this.isExpanded === false : !this.isExpanded);
        (0, $jIDNV._).setDisplayed(this.eGroupOpenedIcon, this.isExpanded === true);
        if (this.hasIndeterminateExpandState) (0, $jIDNV._).setDisplayed(this.eGroupIndeterminateIcon, this.isExpanded === void 0);
    }
    onCheckboxChanged(isSelected) {
        this.isSelected = isSelected;
        const event = {
            type: _SetFilterListItem2.EVENT_SELECTION_CHANGED,
            isSelected: isSelected,
            item: this.item
        };
        this.dispatchEvent(event);
        this.refreshVariableAriaLabels();
        this.refreshAriaChecked();
    }
    toggleSelected() {
        if (!!this.params.readOnly) return;
        this.setSelected(!this.isSelected);
    }
    setSelected(isSelected, silent) {
        this.isSelected = isSelected;
        this.eCheckbox.setValue(isSelected, silent);
        this.refreshAriaChecked();
    }
    refreshVariableAriaLabels() {
        if (!this.isTree) return;
        const translate = this.localeService.getLocaleTextFunc();
        const checkboxValue = this.eCheckbox.getValue();
        const state = checkboxValue === void 0 ? translate("ariaIndeterminate", "indeterminate") : checkboxValue ? translate("ariaVisible", "visible") : translate("ariaHidden", "hidden");
        const visibilityLabel = translate("ariaToggleVisibility", "Press SPACE to toggle visibility");
        (0, $jIDNV._).setAriaLabelledBy(this.eCheckbox.getInputElement(), void 0);
        this.eCheckbox.setInputAriaLabel(`${visibilityLabel} (${state})`);
    }
    setupFixedAriaLabels(value) {
        if (!this.isTree) return;
        const translate = this.localeService.getLocaleTextFunc();
        const itemLabel = translate("ariaFilterValue", "Filter Value");
        const ariaEl = this.getAriaElement();
        (0, $jIDNV._).setAriaLabel(ariaEl, `${value} ${itemLabel}`);
        (0, $jIDNV._).setAriaDescribedBy(ariaEl, this.eCheckbox.getInputElement().id);
    }
    refreshAriaChecked() {
        const ariaEl = this.getAriaElement();
        (0, $jIDNV._).setAriaChecked(ariaEl, this.eCheckbox.getValue());
    }
    refreshAriaExpanded() {
        (0, $jIDNV._).setAriaExpanded(this.getAriaElement(), !!this.isExpanded);
    }
    refresh(item, isSelected, isExpanded) {
        var _a, _b;
        this.item = item;
        if (isSelected !== this.isSelected) this.setSelected(isSelected, true);
        this.setExpanded(isExpanded, true);
        if (this.valueFunction) {
            const value = this.valueFunction();
            this.setTooltipAndCellRendererParams(value, value);
            if (!this.cellRendererComponent) this.renderCellWithoutCellRenderer();
        }
        if (this.cellRendererComponent) {
            const success = (_b = (_a = this.cellRendererComponent).refresh) == null ? void 0 : _b.call(_a, this.cellRendererParams);
            if (!success) {
                const oldComponent = this.cellRendererComponent;
                this.renderCell();
                this.destroyBean(oldComponent);
            }
        }
    }
    render() {
        const { params: { column: column } } = this;
        let { value: value } = this;
        let formattedValue = null;
        if (typeof value === "function") {
            this.valueFunction = value;
            formattedValue = this.valueFunction();
            value = formattedValue;
        } else if (this.isTree) formattedValue = (0, $jIDNV._).toStringOrNull(value);
        else formattedValue = this.getFormattedValue(column, value);
        this.setTooltipAndCellRendererParams(value, formattedValue);
        this.renderCell();
    }
    setTooltipAndCellRendererParams(value, formattedValue) {
        const isTooltipWhenTruncated = this.gos.get("tooltipShowMode") === "whenTruncated";
        if (this.params.showTooltips && (!isTooltipWhenTruncated || !this.params.cellRenderer)) {
            const newTooltipText = formattedValue != null ? formattedValue : (0, $jIDNV._).toStringOrNull(value);
            let shouldDisplayTooltip;
            if (isTooltipWhenTruncated) shouldDisplayTooltip = ()=>{
                const el = this.eCheckbox.getGui().querySelector(".ag-label");
                if (!el) return true;
                return el.scrollWidth > el.clientWidth;
            };
            this.setTooltip({
                newTooltipText: newTooltipText,
                location: "setFilterValue",
                getColDef: ()=>this.params.colDef,
                getColumn: ()=>this.params.column,
                shouldDisplayTooltip: shouldDisplayTooltip
            });
        }
        this.cellRendererParams = this.gos.addGridCommonParams({
            value: value,
            valueFormatted: formattedValue,
            colDef: this.params.colDef,
            column: this.params.column,
            setTooltip: (value2, shouldDisplayTooltip)=>{
                this.setTooltip({
                    newTooltipText: value2,
                    getColDef: ()=>this.params.colDef,
                    getColumn: ()=>this.params.column,
                    location: "setFilterValue",
                    shouldDisplayTooltip: shouldDisplayTooltip
                });
            }
        });
    }
    getTooltipParams() {
        const res = super.getTooltipParams();
        res.location = "setFilterValue";
        res.colDef = this.getComponentHolder();
        if (this.isTree) res.level = this.depth;
        return res;
    }
    getFormattedValue(column, value) {
        return this.valueService.formatValue(column, null, value, this.valueFormatter, false);
    }
    renderCell() {
        const compDetails = this.userComponentFactory.getSetFilterCellRendererDetails(this.params, this.cellRendererParams);
        const cellRendererPromise = compDetails ? compDetails.newAgStackInstance() : void 0;
        if (cellRendererPromise == null) {
            this.renderCellWithoutCellRenderer();
            return;
        }
        cellRendererPromise.then((component)=>{
            if (component) {
                this.cellRendererComponent = component;
                this.eCheckbox.setLabel(component.getGui());
                this.destroyCellRendererComponent = ()=>this.destroyBean(component);
            }
        });
    }
    renderCellWithoutCellRenderer() {
        var _a;
        let valueToRender = (_a = this.cellRendererParams.valueFormatted == null ? this.cellRendererParams.value : this.cellRendererParams.valueFormatted) != null ? _a : this.translate("blanks");
        if (typeof valueToRender !== "string") {
            (0, $jIDNV._).warnOnce(`Set Filter Value Formatter must return string values. Please ensure the Set Filter Value Formatter returns string values for complex objects, or set convertValuesToStrings=true in the filterParams. See ${this.getFrameworkOverrides().getDocLink("filter-set-filter-list/#filter-value-types")}`);
            valueToRender = "";
        }
        this.eCheckbox.setLabel(valueToRender);
        this.setupFixedAriaLabels(valueToRender);
    }
    getComponentHolder() {
        return this.params.column.getColDef();
    }
};
$5b7ccabde48fae90$var$_SetFilterListItem.EVENT_SELECTION_CHANGED = "selectionChanged";
$5b7ccabde48fae90$var$_SetFilterListItem.EVENT_EXPANDED_CHANGED = "expandedChanged";
$5b7ccabde48fae90$var$_SetFilterListItem.GROUP_TEMPLATE = /* html */ `
        <div class="ag-set-filter-item" aria-hidden="true">
            <span class="ag-set-filter-group-icons">
                <span class="ag-set-filter-group-closed-icon" ref="eGroupClosedIcon"></span>
                <span class="ag-set-filter-group-opened-icon" ref="eGroupOpenedIcon"></span>
                <span class="ag-set-filter-group-indeterminate-icon" ref="eGroupIndeterminateIcon"></span>
            </span>
            <ag-checkbox ref="eCheckbox" class="ag-set-filter-item-checkbox"></ag-checkbox>
        </div>`;
$5b7ccabde48fae90$var$_SetFilterListItem.TEMPLATE = /* html */ `
        <div class="ag-set-filter-item">
            <ag-checkbox ref="eCheckbox" class="ag-set-filter-item-checkbox"></ag-checkbox>
        </div>`;
$5b7ccabde48fae90$var$__decorateClass15([
    (0, $jIDNV.Autowired)("valueService")
], $5b7ccabde48fae90$var$_SetFilterListItem.prototype, "valueService", 2);
$5b7ccabde48fae90$var$__decorateClass15([
    (0, $jIDNV.Autowired)("userComponentFactory")
], $5b7ccabde48fae90$var$_SetFilterListItem.prototype, "userComponentFactory", 2);
$5b7ccabde48fae90$var$__decorateClass15([
    (0, $jIDNV.RefSelector)("eCheckbox")
], $5b7ccabde48fae90$var$_SetFilterListItem.prototype, "eCheckbox", 2);
$5b7ccabde48fae90$var$__decorateClass15([
    (0, $jIDNV.RefSelector)("eGroupOpenedIcon")
], $5b7ccabde48fae90$var$_SetFilterListItem.prototype, "eGroupOpenedIcon", 2);
$5b7ccabde48fae90$var$__decorateClass15([
    (0, $jIDNV.RefSelector)("eGroupClosedIcon")
], $5b7ccabde48fae90$var$_SetFilterListItem.prototype, "eGroupClosedIcon", 2);
$5b7ccabde48fae90$var$__decorateClass15([
    (0, $jIDNV.RefSelector)("eGroupIndeterminateIcon")
], $5b7ccabde48fae90$var$_SetFilterListItem.prototype, "eGroupIndeterminateIcon", 2);
$5b7ccabde48fae90$var$__decorateClass15([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_SetFilterListItem.prototype, "init", 1);
var $5b7ccabde48fae90$var$SetFilterListItem = $5b7ccabde48fae90$var$_SetFilterListItem;
var $5b7ccabde48fae90$var$DEFAULT_LOCALE_TEXT = {
    loadingOoo: "Loading...",
    blanks: "(Blanks)",
    searchOoo: "Search...",
    selectAll: "(Select All)",
    selectAllSearchResults: "(Select All Search Results)",
    addCurrentSelectionToFilter: "Add current selection to filter",
    noMatches: "No matches."
};
var $5b7ccabde48fae90$var$SetFilterModelFormatter = class {
    getModelAsString(model, setFilter) {
        const { values: values } = model || setFilter.getModel() || {};
        const valueModel = setFilter.getValueModel();
        if (values == null || valueModel == null) return "";
        const availableKeys = values.filter((v)=>valueModel.isKeyAvailable(v));
        const numValues = availableKeys.length;
        const formattedValues = availableKeys.slice(0, 10).map((key)=>setFilter.getFormattedValue(key));
        return `(${numValues}) ${formattedValues.join(",")}${numValues > 10 ? ",..." : ""}`;
    }
};
var $5b7ccabde48fae90$export$7b7af8300a3a9e84 = class extends (0, $jIDNV.ProvidedFilter) {
    constructor(){
        super("setFilter");
        this.valueModel = null;
        this.setFilterParams = null;
        this.virtualList = null;
        this.caseSensitive = false;
        this.convertValuesToStrings = false;
        this.treeDataTreeList = false;
        this.groupingTreeList = false;
        this.hardRefreshVirtualList = false;
        this.noValueFormatterSupplied = false;
        this.filterModelFormatter = new $5b7ccabde48fae90$var$SetFilterModelFormatter();
        this.updateSetFilterOnParamsChange = (newParams)=>{
            var _a;
            this.setFilterParams = newParams;
            this.convertValuesToStrings = !!newParams.convertValuesToStrings;
            this.caseSensitive = !!newParams.caseSensitive;
            const keyCreator = (_a = newParams.keyCreator) != null ? _a : newParams.colDef.keyCreator;
            this.setValueFormatter(newParams.valueFormatter, keyCreator, this.convertValuesToStrings, !!newParams.treeList, !!newParams.colDef.refData);
            const isGroupCol = newParams.column.getId().startsWith((0, $jIDNV.GROUP_AUTO_COLUMN_ID));
            this.treeDataTreeList = this.gos.get("treeData") && !!newParams.treeList && isGroupCol;
            this.getDataPath = this.gos.get("getDataPath");
            this.groupingTreeList = !!this.columnModel.getRowGroupColumns().length && !!newParams.treeList && isGroupCol;
            this.createKey = this.generateCreateKey(keyCreator, this.convertValuesToStrings, this.treeDataTreeList || this.groupingTreeList);
        };
    }
    postConstruct() {
        super.postConstruct();
    }
    // unlike the simple filters, nothing in the set filter UI shows/hides.
    // maybe this method belongs in abstractSimpleFilter???
    updateUiVisibility() {}
    createBodyTemplate() {
        return /* html */ `
            <div class="ag-set-filter">
                <div ref="eFilterLoading" class="ag-filter-loading ag-hidden">${this.translateForSetFilter("loadingOoo")}</div>
                <ag-input-text-field class="ag-mini-filter" ref="eMiniFilter"></ag-input-text-field>
                <div ref="eFilterNoMatches" class="ag-filter-no-matches ag-hidden">${this.translateForSetFilter("noMatches")}</div>
                <div ref="eSetFilterList" class="ag-set-filter-list" role="presentation"></div>
            </div>`;
    }
    handleKeyDown(e) {
        super.handleKeyDown(e);
        if (e.defaultPrevented) return;
        switch(e.key){
            case (0, $jIDNV.KeyCode).SPACE:
                this.handleKeySpace(e);
                break;
            case (0, $jIDNV.KeyCode).ENTER:
                this.handleKeyEnter(e);
                break;
            case (0, $jIDNV.KeyCode).LEFT:
                this.handleKeyLeft(e);
                break;
            case (0, $jIDNV.KeyCode).RIGHT:
                this.handleKeyRight(e);
                break;
        }
    }
    handleKeySpace(e) {
        var _a;
        (_a = this.getComponentForKeyEvent(e)) == null || _a.toggleSelected();
    }
    handleKeyEnter(e) {
        if (!this.setFilterParams) return;
        const { excelMode: excelMode, readOnly: readOnly } = this.setFilterParams || {};
        if (!excelMode || !!readOnly) return;
        e.preventDefault();
        this.onBtApply(false, false, e);
        if (this.setFilterParams.excelMode === "mac") this.eMiniFilter.getInputElement().select();
    }
    handleKeyLeft(e) {
        var _a;
        (_a = this.getComponentForKeyEvent(e)) == null || _a.setExpanded(false);
    }
    handleKeyRight(e) {
        var _a;
        (_a = this.getComponentForKeyEvent(e)) == null || _a.setExpanded(true);
    }
    getComponentForKeyEvent(e) {
        var _a;
        if (!this.eSetFilterList.contains(this.gos.getActiveDomElement()) || !this.virtualList) return;
        const currentItem = this.virtualList.getLastFocusedRow();
        if (currentItem == null) return;
        const component = this.virtualList.getComponentAt(currentItem);
        if (component == null) return;
        e.preventDefault();
        const { readOnly: readOnly } = (_a = this.setFilterParams) != null ? _a : {};
        if (!!readOnly) return;
        return component;
    }
    getCssIdentifier() {
        return "set-filter";
    }
    setModel(model) {
        var _a;
        if (model == null && ((_a = this.valueModel) == null ? void 0 : _a.getModel()) == null) {
            this.setMiniFilter(null);
            return (0, $jIDNV.AgPromise).resolve();
        }
        return super.setModel(model);
    }
    refresh(params) {
        var _a, _b, _c;
        if (!super.refresh(params)) return false;
        const paramsThatForceReload = [
            "treeList",
            "treeListFormatter",
            "treeListPathGetter",
            "keyCreator",
            "convertValuesToStrings",
            "caseSensitive",
            "comparator",
            "suppressSelectAll",
            "excelMode"
        ];
        if (paramsThatForceReload.some((param)=>{
            var _a2;
            return params[param] !== ((_a2 = this.setFilterParams) == null ? void 0 : _a2[param]);
        })) return false;
        if (this.haveColDefParamsChanged(params.colDef)) return false;
        super.updateParams(params);
        this.updateSetFilterOnParamsChange(params);
        this.updateMiniFilter();
        if (params.cellRenderer !== ((_a = this.setFilterParams) == null ? void 0 : _a.cellRenderer) || params.valueFormatter !== ((_b = this.setFilterParams) == null ? void 0 : _b.valueFormatter)) this.checkAndRefreshVirtualList();
        (_c = this.valueModel) == null || _c.updateOnParamsChange(params).then(()=>{
            var _a2;
            if ((_a2 = this.valueModel) == null ? void 0 : _a2.hasSelections()) this.refreshFilterValues();
        });
        return true;
    }
    haveColDefParamsChanged(colDef) {
        var _a;
        const paramsThatForceReload = [
            "keyCreator",
            "filterValueGetter"
        ];
        const existingColDef = (_a = this.setFilterParams) == null ? void 0 : _a.colDef;
        return paramsThatForceReload.some((param)=>colDef[param] !== (existingColDef == null ? void 0 : existingColDef[param]));
    }
    setModelAndRefresh(values) {
        return this.valueModel ? this.valueModel.setModel(values).then(()=>this.checkAndRefreshVirtualList()) : (0, $jIDNV.AgPromise).resolve();
    }
    resetUiToDefaults() {
        this.setMiniFilter(null);
        return this.setModelAndRefresh(null);
    }
    setModelIntoUi(model) {
        this.setMiniFilter(null);
        const values = model == null ? null : model.values;
        return this.setModelAndRefresh(values);
    }
    getModelFromUi() {
        if (!this.valueModel) throw new Error("Value model has not been created.");
        const values = this.valueModel.getModel();
        if (!values) return null;
        return {
            values: values,
            filterType: this.getFilterType()
        };
    }
    getFilterType() {
        return "set";
    }
    getValueModel() {
        return this.valueModel;
    }
    areModelsEqual(a, b) {
        if (a == null && b == null) return true;
        return a != null && b != null && (0, $jIDNV._).areEqual(a.values, b.values);
    }
    setParams(params) {
        var _a;
        this.applyExcelModeOptions(params);
        super.setParams(params);
        this.updateSetFilterOnParamsChange(params);
        const keyCreator = (_a = params.keyCreator) != null ? _a : params.colDef.keyCreator;
        this.valueModel = new $5b7ccabde48fae90$var$SetValueModel({
            filterParams: params,
            setIsLoading: (loading)=>this.setIsLoading(loading),
            translate: (key)=>this.translateForSetFilter(key),
            caseFormat: (v)=>this.caseFormat(v),
            createKey: this.createKey,
            valueFormatter: this.valueFormatter,
            usingComplexObjects: !!keyCreator,
            gos: this.gos,
            columnModel: this.columnModel,
            valueService: this.valueService,
            treeDataTreeList: this.treeDataTreeList,
            groupingTreeList: this.groupingTreeList,
            addManagedListener: (event, listener)=>this.addManagedListener(this.eventService, event, listener)
        });
        this.initialiseFilterBodyUi();
        this.addEventListenersForDataChanges();
    }
    onAddCurrentSelectionToFilterChange(newValue) {
        if (!this.valueModel) throw new Error("Value model has not been created.");
        this.valueModel.setAddCurrentSelectionToFilter(newValue);
    }
    setValueFormatter(providedValueFormatter, keyCreator, convertValuesToStrings, treeList, isRefData) {
        let valueFormatter = providedValueFormatter;
        if (!valueFormatter) {
            if (keyCreator && !convertValuesToStrings && !treeList) throw new Error("AG Grid: Must supply a Value Formatter in Set Filter params when using a Key Creator unless convertValuesToStrings is enabled");
            this.noValueFormatterSupplied = true;
            if (!isRefData) valueFormatter = (params)=>(0, $jIDNV._).toStringOrNull(params.value);
        }
        this.valueFormatter = valueFormatter;
    }
    generateCreateKey(keyCreator, convertValuesToStrings, treeDataOrGrouping) {
        if (treeDataOrGrouping && !keyCreator) throw new Error("AG Grid: Must supply a Key Creator in Set Filter params when `treeList = true` on a group column, and Tree Data or Row Grouping is enabled.");
        if (keyCreator) return (value, node = null)=>{
            const params = this.getKeyCreatorParams(value, node);
            return (0, $jIDNV._).makeNull(keyCreator(params));
        };
        if (convertValuesToStrings) return (value)=>Array.isArray(value) ? value : (0, $jIDNV._).makeNull((0, $jIDNV._).toStringOrNull(value));
        else return (value)=>(0, $jIDNV._).makeNull((0, $jIDNV._).toStringOrNull(value));
    }
    getFormattedValue(key) {
        var _a;
        let value = this.valueModel.getValue(key);
        if (this.noValueFormatterSupplied && (this.treeDataTreeList || this.groupingTreeList) && Array.isArray(value)) value = (0, $jIDNV._).last(value);
        const formattedValue = this.valueService.formatValue(this.setFilterParams.column, null, value, this.valueFormatter, false);
        return (_a = formattedValue == null ? (0, $jIDNV._).toStringOrNull(value) : formattedValue) != null ? _a : this.translateForSetFilter("blanks");
    }
    applyExcelModeOptions(params) {
        if (params.excelMode === "windows") {
            if (!params.buttons) params.buttons = [
                "apply",
                "cancel"
            ];
            if (params.closeOnApply == null) params.closeOnApply = true;
        } else if (params.excelMode === "mac") {
            if (!params.buttons) params.buttons = [
                "reset"
            ];
            if (params.applyMiniFilterWhileTyping == null) params.applyMiniFilterWhileTyping = true;
            if (params.debounceMs == null) params.debounceMs = 500;
        }
        if (params.excelMode && params.defaultToNothingSelected) {
            params.defaultToNothingSelected = false;
            (0, $jIDNV._).warnOnce('The Set Filter Parameter "defaultToNothingSelected" value was ignored because it does not work when "excelMode" is used.');
        }
    }
    addEventListenersForDataChanges() {
        if (!this.isValuesTakenFromGrid()) return;
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_CELL_VALUE_CHANGED, (event)=>{
            if (this.setFilterParams && event.column === this.setFilterParams.column) this.syncAfterDataChange();
        });
        this.addManagedPropertyListeners([
            "treeData",
            "getDataPath",
            "groupAllowUnbalanced"
        ], ()=>{
            this.syncAfterDataChange();
        });
    }
    syncAfterDataChange() {
        if (!this.valueModel) throw new Error("Value model has not been created.");
        let promise = this.valueModel.refreshValues();
        return promise.then(()=>{
            this.checkAndRefreshVirtualList();
            this.onBtApply(false, true);
        });
    }
    setIsLoading(isLoading) {
        (0, $jIDNV._).setDisplayed(this.eFilterLoading, isLoading);
        if (!isLoading) this.hardRefreshVirtualList = true;
    }
    initialiseFilterBodyUi() {
        this.initVirtualList();
        this.initMiniFilter();
    }
    initVirtualList() {
        if (!this.setFilterParams) throw new Error("Set filter params have not been provided.");
        if (!this.valueModel) throw new Error("Value model has not been created.");
        const translate = this.localeService.getLocaleTextFunc();
        const filterListName = translate("ariaFilterList", "Filter List");
        const isTree = !!this.setFilterParams.treeList;
        const virtualList = this.virtualList = this.createBean(new (0, $jIDNV.VirtualList)({
            cssIdentifier: "filter",
            ariaRole: isTree ? "tree" : "listbox",
            listName: filterListName
        }));
        const eSetFilterList = this.getRefElement("eSetFilterList");
        if (isTree) eSetFilterList.classList.add("ag-set-filter-tree-list");
        if (eSetFilterList) eSetFilterList.appendChild(virtualList.getGui());
        const { cellHeight: cellHeight } = this.setFilterParams;
        if (cellHeight != null) virtualList.setRowHeight(cellHeight);
        const componentCreator = (item, listItemElement)=>this.createSetListItem(item, isTree, listItemElement);
        virtualList.setComponentCreator(componentCreator);
        const componentUpdater = (item, component)=>this.updateSetListItem(item, component);
        virtualList.setComponentUpdater(componentUpdater);
        let model;
        if (this.setFilterParams.suppressSelectAll) model = new $5b7ccabde48fae90$var$ModelWrapper(this.valueModel);
        else model = new $5b7ccabde48fae90$var$ModelWrapperWithSelectAll(this.valueModel, ()=>this.isSelectAllSelected());
        if (isTree) model = new $5b7ccabde48fae90$var$TreeModelWrapper(model);
        virtualList.setModel(model);
    }
    getSelectAllLabel() {
        if (!this.setFilterParams) throw new Error("Set filter params have not been provided.");
        if (!this.valueModel) throw new Error("Value model has not been created.");
        const key = this.valueModel.getMiniFilter() == null || !this.setFilterParams.excelMode ? "selectAll" : "selectAllSearchResults";
        return this.translateForSetFilter(key);
    }
    getAddSelectionToFilterLabel() {
        if (!this.setFilterParams) throw new Error("Set filter params have not been provided.");
        if (!this.valueModel) throw new Error("Value model has not been created.");
        return this.translateForSetFilter("addCurrentSelectionToFilter");
    }
    createSetListItem(item, isTree, focusWrapper) {
        if (!this.setFilterParams) throw new Error("Set filter params have not been provided.");
        if (!this.valueModel) throw new Error("Value model has not been created.");
        const groupsExist = this.valueModel.hasGroups();
        const { isSelected: isSelected, isExpanded: isExpanded } = this.isSelectedExpanded(item);
        const { value: value, depth: depth, isGroup: isGroup, hasIndeterminateExpandState: hasIndeterminateExpandState, selectedListener: selectedListener, expandedListener: expandedListener } = this.newSetListItemAttributes(item, isTree);
        const itemParams = {
            focusWrapper: focusWrapper,
            value: value,
            params: this.setFilterParams,
            translate: (translateKey)=>this.translateForSetFilter(translateKey),
            valueFormatter: this.valueFormatter,
            item: item,
            isSelected: isSelected,
            isTree: isTree,
            depth: depth,
            groupsExist: groupsExist,
            isGroup: isGroup,
            isExpanded: isExpanded,
            hasIndeterminateExpandState: hasIndeterminateExpandState
        };
        const listItem = this.createBean(new $5b7ccabde48fae90$var$SetFilterListItem(itemParams));
        listItem.addEventListener($5b7ccabde48fae90$var$SetFilterListItem.EVENT_SELECTION_CHANGED, selectedListener);
        if (expandedListener) listItem.addEventListener($5b7ccabde48fae90$var$SetFilterListItem.EVENT_EXPANDED_CHANGED, expandedListener);
        return listItem;
    }
    newSetTreeItemAttributes(item, isTree) {
        var _a, _b, _c, _d, _e, _f;
        if (!this.setFilterParams) throw new Error("Set filter params have not been provided.");
        if (!this.valueModel) throw new Error("Value model has not been created.");
        const groupsExist = this.valueModel.hasGroups();
        if (item.key === $5b7ccabde48fae90$var$SetFilterDisplayValue.SELECT_ALL) return {
            value: ()=>this.getSelectAllLabel(),
            isGroup: groupsExist,
            depth: item.depth,
            hasIndeterminateExpandState: true,
            selectedListener: (e)=>this.onSelectAll(e.isSelected),
            expandedListener: (e)=>this.onExpandAll(e.item, e.isExpanded)
        };
        if (item.key === $5b7ccabde48fae90$var$SetFilterDisplayValue.ADD_SELECTION_TO_FILTER) return {
            value: ()=>this.getAddSelectionToFilterLabel(),
            depth: item.depth,
            isGroup: false,
            hasIndeterminateExpandState: false,
            selectedListener: (e)=>{
                this.onAddCurrentSelectionToFilterChange(e.isSelected);
            }
        };
        if (item.children) return {
            value: (_c = (_b = (_a = this.setFilterParams).treeListFormatter) == null ? void 0 : _b.call(_a, item.treeKey, item.depth, item.parentTreeKeys)) != null ? _c : item.treeKey,
            depth: item.depth,
            isGroup: true,
            selectedListener: (e)=>this.onGroupItemSelected(e.item, e.isSelected),
            expandedListener: (e)=>this.onExpandedChanged(e.item, e.isExpanded)
        };
        return {
            value: (_f = (_e = (_d = this.setFilterParams).treeListFormatter) == null ? void 0 : _e.call(_d, item.treeKey, item.depth, item.parentTreeKeys)) != null ? _f : item.treeKey,
            depth: item.depth,
            selectedListener: (e)=>this.onItemSelected(e.item.key, e.isSelected)
        };
    }
    newSetListItemAttributes(item, isTree) {
        if (!this.setFilterParams) throw new Error("Set filter params have not been provided.");
        if (!this.valueModel) throw new Error("Value model has not been created.");
        if (this.isSetFilterModelTreeItem(item)) return this.newSetTreeItemAttributes(item, isTree);
        if (item === $5b7ccabde48fae90$var$SetFilterDisplayValue.SELECT_ALL) return {
            value: ()=>this.getSelectAllLabel(),
            selectedListener: (e)=>this.onSelectAll(e.isSelected)
        };
        if (item === $5b7ccabde48fae90$var$SetFilterDisplayValue.ADD_SELECTION_TO_FILTER) return {
            value: ()=>this.getAddSelectionToFilterLabel(),
            selectedListener: (e)=>{
                this.onAddCurrentSelectionToFilterChange(e.isSelected);
            }
        };
        return {
            value: this.valueModel.getValue(item),
            selectedListener: (e)=>this.onItemSelected(e.item, e.isSelected)
        };
    }
    updateSetListItem(item, component) {
        const { isSelected: isSelected, isExpanded: isExpanded } = this.isSelectedExpanded(item);
        component.refresh(item, isSelected, isExpanded);
    }
    isSelectedExpanded(item) {
        let isSelected;
        let isExpanded;
        if (this.isSetFilterModelTreeItem(item)) {
            isExpanded = item.expanded;
            if (item.key === $5b7ccabde48fae90$var$SetFilterDisplayValue.SELECT_ALL) isSelected = this.isSelectAllSelected();
            else if (item.key === $5b7ccabde48fae90$var$SetFilterDisplayValue.ADD_SELECTION_TO_FILTER) isSelected = this.valueModel.isAddCurrentSelectionToFilterChecked();
            else if (item.children) isSelected = this.areAllChildrenSelected(item);
            else isSelected = this.valueModel.isKeySelected(item.key);
        } else {
            if (item === $5b7ccabde48fae90$var$SetFilterDisplayValue.SELECT_ALL) isSelected = this.isSelectAllSelected();
            else if (item === $5b7ccabde48fae90$var$SetFilterDisplayValue.ADD_SELECTION_TO_FILTER) isSelected = this.valueModel.isAddCurrentSelectionToFilterChecked();
            else isSelected = this.valueModel.isKeySelected(item);
        }
        return {
            isSelected: isSelected,
            isExpanded: isExpanded
        };
    }
    isSetFilterModelTreeItem(item) {
        return (item == null ? void 0 : item.treeKey) !== void 0;
    }
    initMiniFilter() {
        if (!this.setFilterParams) throw new Error("Set filter params have not been provided.");
        if (!this.valueModel) throw new Error("Value model has not been created.");
        const { eMiniFilter: eMiniFilter, localeService: localeService } = this;
        const translate = localeService.getLocaleTextFunc();
        eMiniFilter.setDisplayed(!this.setFilterParams.suppressMiniFilter);
        eMiniFilter.setValue(this.valueModel.getMiniFilter());
        eMiniFilter.onValueChange(()=>this.onMiniFilterInput());
        eMiniFilter.setInputAriaLabel(translate("ariaSearchFilterValues", "Search filter values"));
        this.addManagedListener(eMiniFilter.getInputElement(), "keydown", (e)=>this.onMiniFilterKeyDown(e));
    }
    updateMiniFilter() {
        if (!this.setFilterParams) throw new Error("Set filter params have not been provided.");
        if (!this.valueModel) throw new Error("Value model has not been created.");
        const { eMiniFilter: eMiniFilter } = this;
        if (eMiniFilter.isDisplayed() !== !this.setFilterParams.suppressMiniFilter) eMiniFilter.setDisplayed(!this.setFilterParams.suppressMiniFilter);
        const miniFilterValue = this.valueModel.getMiniFilter();
        if (eMiniFilter.getValue() !== miniFilterValue) eMiniFilter.setValue(miniFilterValue);
    }
    // we need to have the GUI attached before we can draw the virtual rows, as the
    // virtual row logic needs info about the GUI state
    afterGuiAttached(params) {
        if (!this.setFilterParams) throw new Error("Set filter params have not been provided.");
        super.afterGuiAttached(params);
        this.resetExpansion();
        this.refreshVirtualList();
        const { eMiniFilter: eMiniFilter } = this;
        eMiniFilter.setInputPlaceholder(this.translateForSetFilter("searchOoo"));
        if (!params || !params.suppressFocus) eMiniFilter.getFocusableElement().focus();
    }
    afterGuiDetached() {
        var _a, _b;
        super.afterGuiDetached();
        if ((_a = this.setFilterParams) == null ? void 0 : _a.excelMode) this.resetMiniFilter();
        const appliedModel = this.getModel();
        if (((_b = this.setFilterParams) == null ? void 0 : _b.excelMode) || !this.areModelsEqual(appliedModel, this.getModelFromUi())) {
            this.resetUiToActiveModel(appliedModel);
            this.showOrHideResults();
        }
    }
    applyModel(source = "api") {
        if (!this.setFilterParams) throw new Error("Set filter params have not been provided.");
        if (!this.valueModel) throw new Error("Value model has not been created.");
        if (this.setFilterParams.excelMode && source !== "rowDataUpdated" && this.valueModel.isEverythingVisibleSelected()) this.valueModel.selectAllMatchingMiniFilter();
        const shouldKeepCurrentSelection = this.valueModel.showAddCurrentSelectionToFilter() && this.valueModel.isAddCurrentSelectionToFilterChecked();
        if (shouldKeepCurrentSelection && !this.getModel()) return false;
        const result = super.applyModel(source);
        const appliedModel = this.getModel();
        if (appliedModel) {
            if (!shouldKeepCurrentSelection) this.valueModel.setAppliedModelKeys(/* @__PURE__ */ new Set());
            appliedModel.values.forEach((key)=>{
                this.valueModel.addToAppliedModelKeys(key);
            });
        } else if (!shouldKeepCurrentSelection) this.valueModel.setAppliedModelKeys(null);
        return result;
    }
    isModelValid(model) {
        return this.setFilterParams && this.setFilterParams.excelMode ? model == null || model.values.length > 0 : true;
    }
    doesFilterPass(params) {
        if (!this.setFilterParams || !this.valueModel || !this.valueModel.getCaseFormattedAppliedModelKeys()) return true;
        if (!this.valueModel.hasAnyAppliedModelKey()) return false;
        const { node: node, data: data } = params;
        if (this.treeDataTreeList) return this.doesFilterPassForTreeData(node, data);
        if (this.groupingTreeList) return this.doesFilterPassForGrouping(node);
        let value = this.getValueFromNode(node);
        if (this.convertValuesToStrings) return this.doesFilterPassForConvertValuesToString(node, value);
        if (value != null && Array.isArray(value)) {
            if (value.length === 0) return this.valueModel.hasAppliedModelKey(null);
            return value.some((v)=>this.isInAppliedModel(this.createKey(v, node)));
        }
        return this.isInAppliedModel(this.createKey(value, node));
    }
    doesFilterPassForConvertValuesToString(node, value) {
        const key = this.createKey(value, node);
        if (key != null && Array.isArray(key)) {
            if (key.length === 0) return this.valueModel.hasAppliedModelKey(null);
            return key.some((v)=>this.isInAppliedModel(v));
        }
        return this.isInAppliedModel(key);
    }
    doesFilterPassForTreeData(node, data) {
        var _a;
        if ((_a = node.childrenAfterGroup) == null ? void 0 : _a.length) return false;
        return this.isInAppliedModel(this.createKey(this.checkMakeNullDataPath(this.getDataPath(data))));
    }
    doesFilterPassForGrouping(node) {
        const dataPath = this.columnModel.getRowGroupColumns().map((groupCol)=>this.valueService.getKeyForNode(groupCol, node));
        dataPath.push(this.getValueFromNode(node));
        return this.isInAppliedModel(this.createKey(this.checkMakeNullDataPath(dataPath)));
    }
    checkMakeNullDataPath(dataPath) {
        if (dataPath) dataPath = dataPath.map((treeKey)=>(0, $jIDNV._).toStringOrNull((0, $jIDNV._).makeNull(treeKey)));
        if (dataPath == null ? void 0 : dataPath.some((treeKey)=>treeKey == null)) return null;
        return dataPath;
    }
    isInAppliedModel(key) {
        return this.valueModel.hasAppliedModelKey(key);
    }
    getValueFromNode(node) {
        return this.setFilterParams.getValue(node);
    }
    getKeyCreatorParams(value, node = null) {
        return {
            value: value,
            colDef: this.setFilterParams.colDef,
            column: this.setFilterParams.column,
            node: node,
            data: node == null ? void 0 : node.data,
            api: this.setFilterParams.api,
            columnApi: this.setFilterParams.columnApi,
            context: this.setFilterParams.context
        };
    }
    onNewRowsLoaded() {
        if (!this.isValuesTakenFromGrid()) return;
        this.syncAfterDataChange();
    }
    isValuesTakenFromGrid() {
        if (!this.valueModel) return false;
        const valuesType = this.valueModel.getValuesType();
        return valuesType === 2;
    }
    //noinspection JSUnusedGlobalSymbols
    /**
   * Public method provided so the user can change the value of the filter once
   * the filter has been already started
   * @param values The values to use.
   */ setFilterValues(values) {
        if (!this.valueModel) throw new Error("Value model has not been created.");
        this.valueModel.overrideValues(values).then(()=>{
            this.checkAndRefreshVirtualList();
            this.onUiChanged();
        });
    }
    //noinspection JSUnusedGlobalSymbols
    /**
   * Public method provided so the user can reset the values of the filter once that it has started.
   */ resetFilterValues() {
        if (!this.valueModel) throw new Error("Value model has not been created.");
        this.valueModel.setValuesType(2);
        this.syncAfterDataChange();
    }
    refreshFilterValues() {
        if (!this.valueModel) throw new Error("Value model has not been created.");
        if (!this.valueModel.isInitialised()) return;
        this.valueModel.refreshValues().then(()=>{
            this.checkAndRefreshVirtualList();
            this.onUiChanged();
        });
    }
    onAnyFilterChanged() {
        setTimeout(()=>{
            if (!this.isAlive()) return;
            if (!this.valueModel) throw new Error("Value model has not been created.");
            this.valueModel.refreshAfterAnyFilterChanged().then((refresh)=>{
                if (refresh) {
                    this.checkAndRefreshVirtualList();
                    this.showOrHideResults();
                }
            });
        }, 0);
    }
    onMiniFilterInput() {
        if (!this.setFilterParams) throw new Error("Set filter params have not been provided.");
        if (!this.valueModel) throw new Error("Value model has not been created.");
        if (!this.valueModel.setMiniFilter(this.eMiniFilter.getValue())) return;
        const { applyMiniFilterWhileTyping: applyMiniFilterWhileTyping, readOnly: readOnly } = this.setFilterParams || {};
        if (!readOnly && applyMiniFilterWhileTyping) this.filterOnAllVisibleValues(false);
        else this.updateUiAfterMiniFilterChange();
    }
    updateUiAfterMiniFilterChange() {
        if (!this.setFilterParams) throw new Error("Set filter params have not been provided.");
        if (!this.valueModel) throw new Error("Value model has not been created.");
        const { excelMode: excelMode, readOnly: readOnly } = this.setFilterParams || {};
        if (excelMode == null || !!readOnly) this.checkAndRefreshVirtualList();
        else if (this.valueModel.getMiniFilter() == null) this.resetUiToActiveModel(this.getModel());
        else {
            this.valueModel.selectAllMatchingMiniFilter(true);
            this.checkAndRefreshVirtualList();
            this.onUiChanged();
        }
        this.showOrHideResults();
    }
    showOrHideResults() {
        if (!this.valueModel) throw new Error("Value model has not been created.");
        const hideResults = this.valueModel.getMiniFilter() != null && this.valueModel.getDisplayedValueCount() < 1;
        (0, $jIDNV._).setDisplayed(this.eNoMatches, hideResults);
        (0, $jIDNV._).setDisplayed(this.eSetFilterList, !hideResults);
    }
    resetMiniFilter() {
        var _a;
        this.eMiniFilter.setValue(null, true);
        (_a = this.valueModel) == null || _a.setMiniFilter(null);
    }
    resetUiToActiveModel(currentModel, afterUiUpdatedFunc) {
        this.setModelAndRefresh(currentModel == null ? null : currentModel.values).then(()=>{
            this.onUiChanged(false, "prevent");
            afterUiUpdatedFunc == null || afterUiUpdatedFunc();
        });
    }
    handleCancelEnd(e) {
        this.setMiniFilter(null);
        super.handleCancelEnd(e);
    }
    onMiniFilterKeyDown(e) {
        const { excelMode: excelMode, readOnly: readOnly } = this.setFilterParams || {};
        if (e.key === (0, $jIDNV.KeyCode).ENTER && !excelMode && !readOnly) this.filterOnAllVisibleValues();
    }
    filterOnAllVisibleValues(applyImmediately = true) {
        const { readOnly: readOnly } = this.setFilterParams || {};
        if (!this.valueModel) throw new Error("Value model has not been created.");
        if (!!readOnly) throw new Error("Unable to filter in readOnly mode.");
        this.valueModel.selectAllMatchingMiniFilter(true);
        this.checkAndRefreshVirtualList();
        this.onUiChanged(false, applyImmediately ? "immediately" : "debounce");
        this.showOrHideResults();
    }
    focusRowIfAlive(rowIndex) {
        if (rowIndex == null) return;
        window.setTimeout(()=>{
            if (!this.virtualList) throw new Error("Virtual list has not been created.");
            if (this.isAlive()) this.virtualList.focusRow(rowIndex);
        }, 0);
    }
    onSelectAll(isSelected) {
        if (!this.valueModel) throw new Error("Value model has not been created.");
        if (!this.virtualList) throw new Error("Virtual list has not been created.");
        if (isSelected) this.valueModel.selectAllMatchingMiniFilter();
        else this.valueModel.deselectAllMatchingMiniFilter();
        this.refreshAfterSelection();
    }
    onGroupItemSelected(item, isSelected) {
        const recursiveGroupSelection = (i)=>{
            if (i.children) i.children.forEach((childItem)=>recursiveGroupSelection(childItem));
            else this.selectItem(i.key, isSelected);
        };
        recursiveGroupSelection(item);
        this.refreshAfterSelection();
    }
    onItemSelected(key, isSelected) {
        if (!this.valueModel) throw new Error("Value model has not been created.");
        if (!this.virtualList) throw new Error("Virtual list has not been created.");
        this.selectItem(key, isSelected);
        this.refreshAfterSelection();
    }
    selectItem(key, isSelected) {
        if (isSelected) this.valueModel.selectKey(key);
        else this.valueModel.deselectKey(key);
    }
    onExpandAll(item, isExpanded) {
        const recursiveExpansion = (i)=>{
            if (i.filterPasses && i.available && i.children) {
                i.children.forEach((childItem)=>recursiveExpansion(childItem));
                i.expanded = isExpanded;
            }
        };
        recursiveExpansion(item);
        this.refreshAfterExpansion();
    }
    onExpandedChanged(item, isExpanded) {
        item.expanded = isExpanded;
        this.refreshAfterExpansion();
    }
    refreshAfterExpansion() {
        const focusedRow = this.virtualList.getLastFocusedRow();
        this.valueModel.updateDisplayedValues("expansion");
        this.checkAndRefreshVirtualList();
        this.focusRowIfAlive(focusedRow);
    }
    refreshAfterSelection() {
        const focusedRow = this.virtualList.getLastFocusedRow();
        this.checkAndRefreshVirtualList();
        this.onUiChanged();
        this.focusRowIfAlive(focusedRow);
    }
    setMiniFilter(newMiniFilter) {
        this.eMiniFilter.setValue(newMiniFilter);
        this.onMiniFilterInput();
    }
    getMiniFilter() {
        return this.valueModel ? this.valueModel.getMiniFilter() : null;
    }
    checkAndRefreshVirtualList() {
        if (!this.virtualList) throw new Error("Virtual list has not been created.");
        this.virtualList.refresh(!this.hardRefreshVirtualList);
        if (this.hardRefreshVirtualList) this.hardRefreshVirtualList = false;
    }
    getFilterKeys() {
        return this.valueModel ? this.valueModel.getKeys() : [];
    }
    getFilterValues() {
        return this.valueModel ? this.valueModel.getValues() : [];
    }
    getValues() {
        return this.getFilterKeys();
    }
    refreshVirtualList() {
        if (this.setFilterParams && this.setFilterParams.refreshValuesOnOpen) this.refreshFilterValues();
        else this.checkAndRefreshVirtualList();
    }
    translateForSetFilter(key) {
        const translate = this.localeService.getLocaleTextFunc();
        return translate(key, $5b7ccabde48fae90$var$DEFAULT_LOCALE_TEXT[key]);
    }
    isSelectAllSelected() {
        if (!this.setFilterParams || !this.valueModel) return false;
        if (!this.setFilterParams.defaultToNothingSelected) {
            if (this.valueModel.hasSelections() && this.valueModel.isNothingVisibleSelected()) return false;
            if (this.valueModel.isEverythingVisibleSelected()) return true;
        } else {
            if (this.valueModel.hasSelections() && this.valueModel.isEverythingVisibleSelected()) return true;
            if (this.valueModel.isNothingVisibleSelected()) return false;
        }
        return void 0;
    }
    areAllChildrenSelected(item) {
        const recursiveChildSelectionCheck = (i)=>{
            if (i.children) {
                let someTrue = false;
                let someFalse = false;
                const mixed = i.children.some((child)=>{
                    if (!child.filterPasses || !child.available) return false;
                    const childSelected = recursiveChildSelectionCheck(child);
                    if (childSelected === void 0) return true;
                    if (childSelected) someTrue = true;
                    else someFalse = true;
                    return someTrue && someFalse;
                });
                return mixed ? void 0 : someTrue;
            } else return this.valueModel.isKeySelected(i.key);
        };
        if (!this.setFilterParams.defaultToNothingSelected) return recursiveChildSelectionCheck(item);
        else return this.valueModel.hasSelections() && recursiveChildSelectionCheck(item);
    }
    destroy() {
        if (this.virtualList != null) {
            this.virtualList.destroy();
            this.virtualList = null;
        }
        super.destroy();
    }
    caseFormat(valueToFormat) {
        if (valueToFormat == null || typeof valueToFormat !== "string") return valueToFormat;
        return this.caseSensitive ? valueToFormat : valueToFormat.toUpperCase();
    }
    resetExpansion() {
        var _a, _b;
        if (!((_a = this.setFilterParams) == null ? void 0 : _a.treeList)) return;
        const selectAllItem = (_b = this.valueModel) == null ? void 0 : _b.getSelectAllItem();
        if (this.isSetFilterModelTreeItem(selectAllItem)) {
            const recursiveCollapse = (i)=>{
                if (i.children) {
                    i.children.forEach((childItem)=>recursiveCollapse(childItem));
                    i.expanded = false;
                }
            };
            recursiveCollapse(selectAllItem);
            this.valueModel.updateDisplayedValues("expansion");
        }
    }
    getModelAsString(model) {
        return this.filterModelFormatter.getModelAsString(model, this);
    }
    getPositionableElement() {
        return this.eSetFilterList;
    }
};
$5b7ccabde48fae90$var$__decorateClass15([
    (0, $jIDNV.RefSelector)("eMiniFilter")
], $5b7ccabde48fae90$export$7b7af8300a3a9e84.prototype, "eMiniFilter", 2);
$5b7ccabde48fae90$var$__decorateClass15([
    (0, $jIDNV.RefSelector)("eFilterLoading")
], $5b7ccabde48fae90$export$7b7af8300a3a9e84.prototype, "eFilterLoading", 2);
$5b7ccabde48fae90$var$__decorateClass15([
    (0, $jIDNV.RefSelector)("eSetFilterList")
], $5b7ccabde48fae90$export$7b7af8300a3a9e84.prototype, "eSetFilterList", 2);
$5b7ccabde48fae90$var$__decorateClass15([
    (0, $jIDNV.RefSelector)("eFilterNoMatches")
], $5b7ccabde48fae90$export$7b7af8300a3a9e84.prototype, "eNoMatches", 2);
$5b7ccabde48fae90$var$__decorateClass15([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$export$7b7af8300a3a9e84.prototype, "columnModel", 2);
$5b7ccabde48fae90$var$__decorateClass15([
    (0, $jIDNV.Autowired)("valueService")
], $5b7ccabde48fae90$export$7b7af8300a3a9e84.prototype, "valueService", 2);
var $5b7ccabde48fae90$var$ModelWrapper = class {
    constructor(model){
        this.model = model;
    }
    getRowCount() {
        return this.model.getDisplayedValueCount();
    }
    getRow(index) {
        return this.model.getDisplayedItem(index);
    }
    areRowsEqual(oldRow, newRow) {
        return oldRow === newRow;
    }
};
var $5b7ccabde48fae90$var$ModelWrapperWithSelectAll = class {
    constructor(model, isSelectAllSelected){
        this.model = model;
        this.isSelectAllSelected = isSelectAllSelected;
    }
    getRowCount() {
        const showAddCurrentSelectionToFilter = this.model.showAddCurrentSelectionToFilter();
        const outboundItems = showAddCurrentSelectionToFilter ? 2 : 1;
        return this.model.getDisplayedValueCount() + outboundItems;
    }
    getRow(index) {
        if (index === 0) return this.model.getSelectAllItem();
        const showAddCurrentSelectionToFilter = this.model.showAddCurrentSelectionToFilter();
        const outboundItems = showAddCurrentSelectionToFilter ? 2 : 1;
        if (index === 1 && showAddCurrentSelectionToFilter) return this.model.getAddSelectionToFilterItem();
        return this.model.getDisplayedItem(index - outboundItems);
    }
    areRowsEqual(oldRow, newRow) {
        return oldRow === newRow;
    }
};
var $5b7ccabde48fae90$var$TreeModelWrapper = class {
    constructor(model){
        this.model = model;
    }
    getRowCount() {
        return this.model.getRowCount();
    }
    getRow(index) {
        return this.model.getRow(index);
    }
    areRowsEqual(oldRow, newRow) {
        if (oldRow == null && newRow == null) return true;
        return oldRow != null && newRow != null && oldRow.treeKey === newRow.treeKey && oldRow.depth === newRow.depth;
    }
};
var $5b7ccabde48fae90$var$SetFloatingFilterComp = class extends (0, $jIDNV.Component) {
    constructor(){
        super(/* html */ `
            <div class="ag-floating-filter-input ag-set-floating-filter-input" role="presentation">
                <ag-input-text-field ref="eFloatingFilterText"></ag-input-text-field>
            </div>`);
        this.availableValuesListenerAdded = false;
        this.filterModelFormatter = new $5b7ccabde48fae90$var$SetFilterModelFormatter();
    }
    // this is a user component, and IComponent has "public destroy()" as part of the interface.
    // so we need to override destroy() just to make the method public.
    destroy() {
        super.destroy();
    }
    init(params) {
        this.params = params;
        this.eFloatingFilterText.setDisabled(true).addGuiEventListener("click", ()=>this.params.showParentFilter());
        this.setParams(params);
    }
    setParams(params) {
        const displayName = this.columnModel.getDisplayNameForColumn(params.column, "header", true);
        const translate = this.localeService.getLocaleTextFunc();
        this.eFloatingFilterText.setInputAriaLabel(`${displayName} ${translate("ariaFilterInput", "Filter Input")}`);
    }
    onParamsUpdated(params) {
        this.refresh(params);
    }
    refresh(params) {
        this.params = params;
        this.setParams(params);
    }
    onParentModelChanged(parentModel) {
        this.updateFloatingFilterText(parentModel);
    }
    parentSetFilterInstance(cb) {
        this.params.parentFilterInstance((filter)=>{
            if (!(filter instanceof $5b7ccabde48fae90$export$7b7af8300a3a9e84)) throw new Error("AG Grid - SetFloatingFilter expects SetFilter as its parent");
            cb(filter);
        });
    }
    addAvailableValuesListener() {
        this.parentSetFilterInstance((setFilter)=>{
            const setValueModel = setFilter.getValueModel();
            if (!setValueModel) return;
            this.addManagedListener(setValueModel, $5b7ccabde48fae90$var$SetValueModel.EVENT_AVAILABLE_VALUES_CHANGED, ()=>this.updateFloatingFilterText());
        });
        this.availableValuesListenerAdded = true;
    }
    updateFloatingFilterText(parentModel) {
        if (!this.availableValuesListenerAdded) this.addAvailableValuesListener();
        this.parentSetFilterInstance((setFilter)=>{
            this.eFloatingFilterText.setValue(this.filterModelFormatter.getModelAsString(parentModel, setFilter));
        });
    }
};
$5b7ccabde48fae90$var$__decorateClass15([
    (0, $jIDNV.RefSelector)("eFloatingFilterText")
], $5b7ccabde48fae90$var$SetFloatingFilterComp.prototype, "eFloatingFilterText", 2);
$5b7ccabde48fae90$var$__decorateClass15([
    (0, $jIDNV.Autowired)("columnModel")
], $5b7ccabde48fae90$var$SetFloatingFilterComp.prototype, "columnModel", 2);
var $5b7ccabde48fae90$var$VERSION16 = "31.3.4";
var $5b7ccabde48fae90$export$4ab172eba3fdda9e = {
    version: $5b7ccabde48fae90$var$VERSION16,
    moduleName: (0, $jIDNV.ModuleNames).SetFilterModule,
    beans: [],
    userComponents: [
        {
            componentName: "agSetColumnFilter",
            componentClass: $5b7ccabde48fae90$export$7b7af8300a3a9e84
        },
        {
            componentName: "agSetColumnFloatingFilter",
            componentClass: $5b7ccabde48fae90$var$SetFloatingFilterComp
        }
    ],
    dependantModules: [
        $5b7ccabde48fae90$export$3a6d13add8617801
    ]
};
var $5b7ccabde48fae90$var$__defProp16 = Object.defineProperty;
var $5b7ccabde48fae90$var$__getOwnPropDesc16 = Object.getOwnPropertyDescriptor;
var $5b7ccabde48fae90$var$__getOwnPropSymbols13 = Object.getOwnPropertySymbols;
var $5b7ccabde48fae90$var$__hasOwnProp14 = Object.prototype.hasOwnProperty;
var $5b7ccabde48fae90$var$__propIsEnum13 = Object.prototype.propertyIsEnumerable;
var $5b7ccabde48fae90$var$__defNormalProp13 = (obj, key, value)=>key in obj ? $5b7ccabde48fae90$var$__defProp16(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5b7ccabde48fae90$var$__spreadValues13 = (a, b)=>{
    for(var prop in b || (b = {}))if ($5b7ccabde48fae90$var$__hasOwnProp14.call(b, prop)) $5b7ccabde48fae90$var$__defNormalProp13(a, prop, b[prop]);
    if ($5b7ccabde48fae90$var$__getOwnPropSymbols13) {
        for (var prop of $5b7ccabde48fae90$var$__getOwnPropSymbols13(b))if ($5b7ccabde48fae90$var$__propIsEnum13.call(b, prop)) $5b7ccabde48fae90$var$__defNormalProp13(a, prop, b[prop]);
    }
    return a;
};
var $5b7ccabde48fae90$var$__decorateClass16 = (decorators, target, key, kind)=>{
    var result = kind > 1 ? void 0 : kind ? $5b7ccabde48fae90$var$__getOwnPropDesc16(target, key) : target;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
    if (kind && result) $5b7ccabde48fae90$var$__defProp16(target, key, result);
    return result;
};
var $5b7ccabde48fae90$var$defaultTooltipCss = `
.ag-sparkline-tooltip-wrapper {
    position: absolute;
    user-select: none;
    pointer-events: none;
}

.ag-sparkline-tooltip {
    position: relative;
    font: 12px arial,sans-serif;
    border-radius: 2px;
    box-shadow: 0 1px 3px rgb(0 0 0 / 20%), 0 1px 1px rgb(0 0 0 / 14%);
    line-height: 1.7em;
    overflow: hidden;
    white-space: nowrap;
    z-index: 99999;
    background-color: rgb(255, 255, 255);
    color: rgba(0,0,0, 0.67);
}

.ag-sparkline-tooltip-content {
    padding: 0 7px;
    opacity: 1;
}

.ag-sparkline-tooltip-title {
    padding-left: 7px;
    opacity: 1;
}

.ag-sparkline-tooltip-wrapper-hidden {
    top: -10000px !important;
}

.ag-sparkline-wrapper {
    box-sizing: border-box;
    overflow: hidden;
}
`;
var { extent: $5b7ccabde48fae90$var$extent, isNumber: $5b7ccabde48fae90$var$isNumber, isString: $5b7ccabde48fae90$var$isString2, isStringObject: $5b7ccabde48fae90$var$isStringObject, isDate: $5b7ccabde48fae90$var$isDate, createId: $5b7ccabde48fae90$var$createId, Padding: $5b7ccabde48fae90$var$Padding } = (0, $iTJTu._Util);
var { LinearScale: $5b7ccabde48fae90$var$LinearScale, BandScale: $5b7ccabde48fae90$var$BandScale, TimeScale: $5b7ccabde48fae90$var$TimeScale } = (0, $iTJTu._Scale);
var $5b7ccabde48fae90$var$SparklineAxis = class {
    constructor(){
        this.type = "category";
        this.stroke = "rgb(204, 214, 235)";
        this.strokeWidth = 1;
    }
};
var $5b7ccabde48fae90$var$_Sparkline = class _Sparkline2 {
    constructor(){
        this.id = $5b7ccabde48fae90$var$createId(this);
        this.seriesRect = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
        this._context = void 0;
        this._container = void 0;
        this._data = void 0;
        this.padding = new $5b7ccabde48fae90$var$Padding(3);
        this.xKey = "x";
        this.yKey = "y";
        this.dataType = void 0;
        this.xData = [];
        this.yData = [];
        this.min = void 0;
        this.max = void 0;
        this.yScale = new $5b7ccabde48fae90$var$LinearScale();
        this.axis = new $5b7ccabde48fae90$var$SparklineAxis();
        this.highlightStyle = {
            size: 6,
            fill: "yellow",
            stroke: "silver",
            strokeWidth: 1
        };
        this._width = 100;
        this._height = 100;
        this.smallestInterval = void 0;
        this.layoutId = 0;
        this.defaultDateFormatter = new Intl.DateTimeFormat("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: false
        });
        this._onMouseMove = this.onMouseMove.bind(this);
        this._onMouseOut = this.onMouseOut.bind(this);
        const root = new (0, $iTJTu._Scene).Group();
        this.rootGroup = root;
        const element = document.createElement("div");
        element.setAttribute("class", "ag-sparkline-wrapper");
        const scene = new (0, $iTJTu._Scene).Scene({});
        this.scene = scene;
        this.canvasElement = scene.canvas.element;
        scene.setRoot(root);
        scene.setContainer(element);
        this.resizeAndSetDimensions(this.width, this.height);
        if (!_Sparkline2.tooltipDocuments.includes(document)) this.initialiseTooltipStyles();
        this.setupDomEventListeners(this.canvasElement);
    }
    set context(value) {
        if (this._context !== value) this._context = value;
    }
    get context() {
        return this._context;
    }
    set container(value) {
        if (this._container !== value) {
            const { parentNode: parentNode } = this.canvasElement;
            if (parentNode != null) parentNode.removeChild(this.canvasElement);
            if (value) value.appendChild(this.canvasElement);
            this._container = value;
        }
    }
    get container() {
        return this._container;
    }
    set data(value) {
        if (this._data !== value) {
            this._data = value;
            this.processData();
            if (this.mouseMoveEvent && this.highlightedDatum) this.updateHitPoint(this.mouseMoveEvent);
        }
    }
    get data() {
        return this._data;
    }
    resizeAndSetDimensions(width, height) {
        this.scene.resize(width, height);
        this.seriesRect.width = width;
        this.seriesRect.height = height;
    }
    initialiseTooltipStyles() {
        const styleElement = document.createElement("style");
        styleElement.innerHTML = $5b7ccabde48fae90$var$defaultTooltipCss;
        document.head.insertBefore(styleElement, document.head.querySelector("style"));
        _Sparkline2.tooltipDocuments.push(document);
    }
    set width(value) {
        if (this._width !== value) {
            this._width = value;
            this.scene.resize(value, this.height);
            this.scheduleLayout();
        }
    }
    get width() {
        return this._width;
    }
    set height(value) {
        if (this._height !== value) {
            this._height = value;
            this.scene.resize(this.width, value);
            this.scheduleLayout();
        }
    }
    get height() {
        return this._height;
    }
    /**
   * Generate node data from processed data.
   * Produce data joins.
   * Update selection's nodes using node data.
   */ update() {}
    // Update y scale based on processed data.
    updateYScale() {
        this.updateYScaleRange();
        this.updateYScaleDomain();
    }
    // Update y scale domain based on processed data.
    updateYScaleDomain() {}
    // Update y scale range based on height and padding (seriesRect).
    updateYScaleRange() {
        const { yScale: yScale, seriesRect: seriesRect } = this;
        yScale.range = [
            seriesRect.height,
            0
        ];
    }
    // Update x scale based on processed data.
    updateXScale() {
        const { type: type } = this.axis;
        this.xScale = this.getXScale(type);
        this.updateXScaleRange();
        this.updateXScaleDomain();
    }
    // Update x scale range based on width and padding (seriesRect).
    updateXScaleRange() {
        this.xScale.range = [
            0,
            this.seriesRect.width
        ];
    }
    // Update x scale domain based on processed data and type of scale.
    updateXScaleDomain() {
        const { xData: xData, xScale: xScale } = this;
        let xMinMax;
        if (xScale instanceof $5b7ccabde48fae90$var$LinearScale || xScale instanceof $5b7ccabde48fae90$var$TimeScale) xMinMax = $5b7ccabde48fae90$var$extent(xData);
        this.xScale.domain = xMinMax ? xMinMax.slice() : xData;
    }
    /**
   * Return xScale instance based on the provided type or return a `BandScale` by default.
   * The default type is `category`.
   * @param type
   */ getXScale(type = "category") {
        switch(type){
            case "number":
                return new $5b7ccabde48fae90$var$LinearScale();
            case "time":
                return new $5b7ccabde48fae90$var$TimeScale();
            case "category":
            default:
                return new $5b7ccabde48fae90$var$BandScale();
        }
    }
    // Update axis line.
    updateAxisLine() {}
    // Update X and Y scales and the axis line.
    updateAxes() {
        this.updateYScale();
        this.updateXScale();
        this.updateAxisLine();
    }
    // Update horizontal and vertical crosshair lines.
    updateCrosshairs() {
        this.updateXCrosshairLine();
        this.updateYCrosshairLine();
    }
    // Using processed data, generate data that backs visible nodes.
    generateNodeData() {
        return [];
    }
    // Returns persisted node data associated with the sparkline's data.
    getNodeData() {
        return [];
    }
    // Update the selection's nodes.
    updateNodes() {}
    // Update the vertical crosshair line.
    updateXCrosshairLine() {}
    // Update the horizontal crosshair line.
    updateYCrosshairLine() {}
    highlightDatum(closestDatum) {
        this.updateNodes();
    }
    dehighlightDatum() {
        this.highlightedDatum = void 0;
        this.updateNodes();
        this.updateCrosshairs();
    }
    /**
   * Highlight closest datum and display tooltip if enabled.
   * Only update if necessary, i.e. only update if the highlighted datum is different from previously highlighted datum,
   * or if there is no previously highlighted datum.
   * @param event
   */ onMouseMove(event) {
        this.mouseMoveEvent = event;
        this.updateHitPoint(event);
    }
    updateHitPoint(event) {
        var _a, _b, _c;
        const closestDatum = this.pickClosestSeriesNodeDatum(event.offsetX, event.offsetY);
        if (!closestDatum) return;
        const oldHighlightedDatum = this.highlightedDatum;
        this.highlightedDatum = closestDatum;
        if (this.highlightedDatum && !oldHighlightedDatum || this.highlightedDatum && oldHighlightedDatum && this.highlightedDatum !== oldHighlightedDatum) {
            this.highlightDatum(closestDatum);
            this.updateCrosshairs();
            this.scene.render().catch((e)=>console.error(`AG Grid - chart rendering failed`, e));
        }
        const tooltipEnabled = (_c = (_b = (_a = this.processedOptions) == null ? void 0 : _a.tooltip) == null ? void 0 : _b.enabled) != null ? _c : true;
        if (tooltipEnabled) this.handleTooltip(event, closestDatum);
    }
    /**
   * Dehighlight all nodes and remove tooltip.
   * @param event
   */ onMouseOut(event) {
        this.dehighlightDatum();
        this.tooltip.toggle(false);
        this.scene.render().catch((e)=>console.error(`AG Grid - chart rendering failed`, e));
    }
    // Fetch required values from the data object and process them.
    processData() {
        const { data: data, yData: yData, xData: xData } = this;
        if (!data || this.invalidData(this.data)) return;
        yData.length = 0;
        xData.length = 0;
        const n = data.length;
        const dataType = this.getDataType(data);
        this.dataType = dataType;
        const { type: xValueType } = this.axis;
        const xType = xValueType !== "number" && xValueType !== "time" ? "category" : xValueType;
        const isContinuousX = xType === "number" || xType === "time";
        const setSmallestXInterval = (curr, prev)=>{
            if (this.smallestInterval == void 0) this.smallestInterval = {
                x: Infinity,
                y: Infinity
            };
            const { x: x } = this.smallestInterval;
            const interval = Math.abs(curr - prev);
            if (interval > 0 && interval < x) this.smallestInterval.x = interval;
        };
        let prevX;
        if (dataType === "number") for(let i = 0; i < n; i++){
            const xDatum = i;
            const yDatum = data[i];
            const x = this.getDatum(xDatum, xType);
            const y = this.getDatum(yDatum, "number");
            if (isContinuousX) setSmallestXInterval(x, prevX);
            xData.push(x);
            yData.push(y);
            prevX = x;
        }
        else if (dataType === "array") for(let i = 0; i < n; i++){
            const datum = data[i];
            if (Array.isArray(datum)) {
                const xDatum = datum[0];
                const yDatum = datum[1];
                const x = this.getDatum(xDatum, xType);
                const y = this.getDatum(yDatum, "number");
                if (x == void 0) continue;
                if (isContinuousX) setSmallestXInterval(x, prevX);
                xData.push(x);
                yData.push(y);
                prevX = x;
            }
        }
        else if (dataType === "object") {
            const { yKey: yKey, xKey: xKey } = this;
            for(let i = 0; i < n; i++){
                const datum = data[i];
                if (typeof datum === "object" && !Array.isArray(datum)) {
                    const xDatum = datum[xKey];
                    const yDatum = datum[yKey];
                    const x = this.getDatum(xDatum, xType);
                    const y = this.getDatum(yDatum, "number");
                    if (x == void 0) continue;
                    if (isContinuousX) setSmallestXInterval(x, prevX);
                    xData.push(x);
                    yData.push(y);
                    prevX = x;
                }
            }
        }
        this.updateAxes();
        this.immediateLayout();
    }
    /**
   * Return the type of data provided to the sparkline based on the first truthy value in the data array.
   * If the value is not a number, array or object, return `undefined`.
   * @param data
   */ getDataType(data) {
        for (const datum of data)if (datum != void 0) {
            if ($5b7ccabde48fae90$var$isNumber(datum)) return "number";
            else if (Array.isArray(datum)) return "array";
            else if (typeof datum === "object") return "object";
        }
    }
    /**
   * Return the given value depending on the type of axis.
   * Return `undefined` if the value is invalid for the given axis type.
   * @param value
   */ getDatum(value, type) {
        if (type === "number" && $5b7ccabde48fae90$var$isNumber(value) || type === "time" && ($5b7ccabde48fae90$var$isNumber(value) || $5b7ccabde48fae90$var$isDate(value))) return value;
        else if (type === "category") {
            if ($5b7ccabde48fae90$var$isString2(value) || $5b7ccabde48fae90$var$isDate(value) || $5b7ccabde48fae90$var$isNumber(value)) return {
                toString: ()=>String(value)
            };
            else if ($5b7ccabde48fae90$var$isStringObject(value)) return value;
        }
    }
    /**
   * Only `true` while we are waiting for the layout to start.
   * This will be `false` if the layout has already started and is ongoing.
   */ get layoutScheduled() {
        return !!this.layoutId;
    }
    /**
   * Execute update method on the next available screen repaint to make changes to the canvas.
   * If we are waiting for a layout to start and a new layout is requested,
   * cancel the previous layout using the non 0 integer (this.layoutId) returned from requestAnimationFrame.
   */ scheduleLayout() {
        if (this.layoutId) cancelAnimationFrame(this.layoutId);
        this.layoutId = requestAnimationFrame(()=>{
            this.immediateLayout();
            this.layoutId = 0;
        });
    }
    immediateLayout() {
        this.setSparklineDimensions();
        if (this.invalidData(this.data)) return;
        this.updateXScaleRange();
        this.updateYScaleRange();
        this.updateAxisLine();
        this.update();
        this.scene.render().catch((e)=>console.error(`AG Grid - chart rendering failed`, e));
    }
    setSparklineDimensions() {
        const { width: width, height: height, padding: padding, seriesRect: seriesRect, rootGroup: rootGroup } = this;
        const shrunkWidth = width - padding.left - padding.right;
        const shrunkHeight = height - padding.top - padding.bottom;
        seriesRect.width = shrunkWidth;
        seriesRect.height = shrunkHeight;
        seriesRect.x = padding.left;
        seriesRect.y = padding.top;
        rootGroup.translationX = seriesRect.x;
        rootGroup.translationY = seriesRect.y;
    }
    /**
   * Return the closest data point to x/y canvas coordinates.
   * @param x
   * @param y
   */ pickClosestSeriesNodeDatum(x, y) {
        let minDistance = Infinity;
        let closestDatum;
        const hitPoint = this.rootGroup.transformPoint(x, y);
        const nodeData = this.getNodeData();
        for(let i = 0; i < nodeData.length; i++){
            const datum = nodeData[i];
            if (!datum.point) return;
            const distance = this.getDistance(hitPoint, datum.point);
            if (distance <= minDistance) {
                minDistance = distance;
                closestDatum = datum;
            }
        }
        return closestDatum;
    }
    /**
   * Return the relevant distance between two points.
   * The distance will be calculated based on the x value of the points for all sparklines except bar sparkline, where the distance is based on the y values.
   * @param x
   * @param y
   */ getDistance(p1, p2) {
        return Math.abs(p1.x - p2.x);
    }
    /**
   * calculate x/y coordinates for tooltip based on coordinates of highlighted datum, position of canvas and page offset.
   * @param datum
   */ handleTooltip(event, datum) {
        var _a, _b;
        const { seriesDatum: seriesDatum } = datum;
        const { canvasElement: canvasElement } = this;
        const { clientX: clientX, clientY: clientY } = event;
        const tooltipOptions = (_a = this.processedOptions) == null ? void 0 : _a.tooltip;
        const meta = {
            pageX: clientX,
            pageY: clientY,
            position: {
                xOffset: tooltipOptions == null ? void 0 : tooltipOptions.xOffset,
                yOffset: tooltipOptions == null ? void 0 : tooltipOptions.yOffset
            },
            container: tooltipOptions == null ? void 0 : tooltipOptions.container
        };
        if (meta.container == void 0) meta.container = canvasElement;
        const yValue = seriesDatum.y;
        const xValue = seriesDatum.x;
        let enabled = (_b = tooltipOptions == null ? void 0 : tooltipOptions.enabled) != null ? _b : true;
        const tooltipRenderer = tooltipOptions == null ? void 0 : tooltipOptions.renderer;
        if (tooltipRenderer) {
            const tooltipRendererResult = tooltipRenderer({
                context: this.context,
                datum: seriesDatum,
                yValue: yValue,
                xValue: xValue
            });
            enabled = typeof tooltipRendererResult !== "string" && tooltipRendererResult.enabled !== void 0 ? tooltipRendererResult.enabled : enabled;
        }
        const html = enabled && seriesDatum.y !== void 0 && this.getTooltipHtml(datum);
        if (html) this.tooltip.show(meta, html);
    }
    formatNumericDatum(datum) {
        return String(Math.round(datum * 10) / 10);
    }
    // locale.format('%m/%d/%y, %H:%M:%S');
    formatDatum(datum) {
        const type = this.axis.type || "category";
        if (type === "number" && typeof datum === "number") return this.formatNumericDatum(datum);
        else if (type === "time" && (datum instanceof Date || $5b7ccabde48fae90$var$isNumber(datum))) return this.defaultDateFormatter.format(datum);
        else return String(datum);
    }
    setupDomEventListeners(chartElement) {
        chartElement.addEventListener("mousemove", this._onMouseMove);
        chartElement.addEventListener("mouseout", this._onMouseOut);
    }
    cleanupDomEventListeners(chartElement) {
        chartElement.removeEventListener("mousemove", this._onMouseMove);
        chartElement.removeEventListener("mouseout", this._onMouseOut);
    }
    invalidData(data) {
        return !data || !Array.isArray(data);
    }
    /**
   * Cleanup and remove canvas element from the DOM.
   */ destroy() {
        this.cleanupDomEventListeners(this.canvasElement);
        this.scene.destroy();
        this.container = void 0;
    }
};
$5b7ccabde48fae90$var$_Sparkline.tooltipDocuments = [];
var $5b7ccabde48fae90$var$Sparkline = $5b7ccabde48fae90$var$_Sparkline;
function $5b7ccabde48fae90$var$toTooltipHtml(input, defaults) {
    var _a, _b, _c;
    if (typeof input === "string") return input;
    defaults = defaults != null ? defaults : {};
    const { content: content = (_a = defaults.content) != null ? _a : "", title: title = (_b = defaults.title) != null ? _b : void 0, color: color = defaults.color, backgroundColor: backgroundColor = defaults.backgroundColor, opacity: opacity = (_c = defaults.opacity) != null ? _c : 1 } = input;
    let titleHtml;
    let contentHtml;
    if (color) {
        titleHtml = title ? `<span class="${$5b7ccabde48fae90$var$SparklineTooltip.class}-title"; style="color: ${color}">${title}</span>` : "";
        contentHtml = `<span class="${$5b7ccabde48fae90$var$SparklineTooltip.class}-content" style="color: ${color}">${content}</span>`;
    } else {
        titleHtml = title ? `<span class="${$5b7ccabde48fae90$var$SparklineTooltip.class}-title">${title}</span>` : "";
        contentHtml = `<span class="${$5b7ccabde48fae90$var$SparklineTooltip.class}-content">${content}</span>`;
    }
    let style = `opacity: ${opacity}`;
    if (backgroundColor) style += `; background-color: ${backgroundColor.toLowerCase()}`;
    return `<div class="${$5b7ccabde48fae90$var$SparklineTooltip.class}" style="${style}">
                ${titleHtml}
                ${contentHtml}
            </div>`;
}
var $5b7ccabde48fae90$var$_SparklineTooltip = class _SparklineTooltip2 {
    constructor(){
        this.element = document.createElement("div");
        const tooltipRoot = document.body;
        tooltipRoot.appendChild(this.element);
    }
    isVisible() {
        const { element: element } = this;
        if (element.classList) return !element.classList.contains(`${_SparklineTooltip2.class}-wrapper-hidden`);
        const classes = element.getAttribute("class");
        if (classes) return classes.split(" ").indexOf(`${_SparklineTooltip2.class}-wrapper-hidden`) < 0;
        return false;
    }
    updateClass(visible) {
        const classList = [
            `${_SparklineTooltip2.class}-wrapper`
        ];
        if (visible !== true) classList.push(`${_SparklineTooltip2.class}-wrapper-hidden`);
        this.element.setAttribute("class", classList.join(" "));
    }
    show(meta, html) {
        var _a, _b, _c, _d;
        this.toggle(false);
        const { element: element } = this;
        if (html !== void 0) element.innerHTML = html;
        else if (!element.innerHTML) return;
        const xOffset = (_b = (_a = meta.position) == null ? void 0 : _a.xOffset) != null ? _b : 10;
        const yOffset = (_d = (_c = meta.position) == null ? void 0 : _c.yOffset) != null ? _d : 0;
        let left = meta.pageX + xOffset;
        let top = meta.pageY + yOffset;
        const tooltipRect = element.getBoundingClientRect();
        let maxLeft = window.innerWidth - tooltipRect.width;
        if (meta.container) {
            const containerRect = meta.container.getBoundingClientRect();
            maxLeft = containerRect.left + (containerRect.width - tooltipRect.width);
        }
        if (left > maxLeft) left = meta.pageX - element.clientWidth - xOffset;
        if (typeof scrollX !== "undefined") left += scrollX;
        if (typeof scrollY !== "undefined") top += scrollY;
        element.style.left = `${Math.round(left)}px`;
        element.style.top = `${Math.round(top)}px`;
        this.toggle(true);
    }
    toggle(visible) {
        this.updateClass(visible);
    }
    destroy() {
        const { parentNode: parentNode } = this.element;
        if (parentNode) parentNode.removeChild(this.element);
    }
};
$5b7ccabde48fae90$var$_SparklineTooltip.class = "ag-sparkline-tooltip";
var $5b7ccabde48fae90$var$SparklineTooltip = $5b7ccabde48fae90$var$_SparklineTooltip;
function $5b7ccabde48fae90$var$getMarker(shape) {
    switch(shape){
        case "circle":
            return (0, $iTJTu._Scene).Circle;
        case "square":
            return (0, $iTJTu._Scene).Square;
        case "diamond":
            return (0, $iTJTu._Scene).Diamond;
        default:
            return (0, $iTJTu._Scene).Circle;
    }
}
function $5b7ccabde48fae90$var$getLineDash(lineCap, lineDash = "solid") {
    const buttOrNull = {
        solid: [],
        dash: [
            4,
            3
        ],
        dot: [
            1,
            3
        ],
        dashDot: [
            4,
            3,
            1,
            3
        ],
        dashDotDot: [
            4,
            3,
            1,
            3,
            1,
            3
        ],
        shortDot: [
            1,
            1
        ],
        shortDash: [
            3,
            1
        ],
        shortDashDot: [
            3,
            1,
            1,
            1
        ],
        shortDashDotDot: [
            3,
            1,
            1,
            1,
            1,
            1
        ],
        longDash: [
            8,
            3
        ],
        longDashDot: [
            8,
            3,
            1,
            3
        ],
        longDashDotDot: [
            8,
            3,
            1,
            3,
            1,
            3
        ]
    };
    const roundOrSquare = {
        solid: [],
        dash: [
            3,
            3
        ],
        dot: [
            0,
            3
        ],
        dashDot: [
            3,
            3,
            0,
            3
        ],
        dashDotDot: [
            3,
            3,
            0,
            3,
            0,
            3
        ],
        shortDot: [
            0,
            2
        ],
        shortDash: [
            2,
            2
        ],
        shortDashDot: [
            2,
            2,
            0,
            2
        ],
        shortDashDotDot: [
            2,
            2,
            0,
            2,
            0,
            2
        ],
        longDash: [
            7,
            3
        ],
        longDashDot: [
            7,
            3,
            0,
            3
        ],
        longDashDotDot: [
            7,
            3,
            0,
            3,
            0,
            3
        ]
    };
    if (lineCap === "round" || lineCap === "square") {
        if (roundOrSquare[lineDash] == void 0) {
            console.warn(`'${lineDash}' is not a valid 'lineDash' option.`);
            return roundOrSquare.solid;
        }
        return roundOrSquare[lineDash];
    }
    if (buttOrNull[lineDash] == void 0) {
        console.warn(`'${lineDash}' is not a valid 'lineDash' option.`);
        return buttOrNull.solid;
    }
    return buttOrNull[lineDash];
}
var { extent: $5b7ccabde48fae90$var$extent2 } = (0, $iTJTu._Util);
var { BandScale: $5b7ccabde48fae90$var$BandScale2 } = (0, $iTJTu._Scale);
var $5b7ccabde48fae90$var$SparklineMarker = class {
    constructor(){
        this.enabled = true;
        this.shape = "circle";
        this.size = 0;
        this.fill = "rgb(124, 181, 236)";
        this.stroke = "rgb(124, 181, 236)";
        this.strokeWidth = 1;
        this.formatter = void 0;
    }
};
var $5b7ccabde48fae90$var$SparklineLine = class {
    constructor(){
        this.stroke = "rgb(124, 181, 236)";
        this.strokeWidth = 1;
    }
};
var $5b7ccabde48fae90$var$SparklineCrosshairs = class {
    constructor(){
        this.xLine = {
            enabled: true,
            stroke: "rgba(0,0,0, 0.54)",
            strokeWidth: 1,
            lineDash: "solid",
            lineCap: void 0
        };
        this.yLine = {
            enabled: false,
            stroke: "rgba(0,0,0, 0.54)",
            strokeWidth: 1,
            lineDash: "solid",
            lineCap: void 0
        };
    }
};
var $5b7ccabde48fae90$var$AreaSparkline = class extends $5b7ccabde48fae90$var$Sparkline {
    constructor(){
        super();
        this.fill = "rgba(124, 181, 236, 0.25)";
        this.strokePath = new (0, $iTJTu._Scene).Path();
        this.fillPath = new (0, $iTJTu._Scene).Path();
        this.xCrosshairLine = new (0, $iTJTu._Scene).Line();
        this.yCrosshairLine = new (0, $iTJTu._Scene).Line();
        this.areaSparklineGroup = new (0, $iTJTu._Scene).Group();
        this.xAxisLine = new (0, $iTJTu._Scene).Line();
        this.markers = new (0, $iTJTu._Scene).Group();
        this.markerSelection = (0, $iTJTu._Scene).Selection.select(this.markers, ()=>this.markerFactory());
        this.markerSelectionData = [];
        this.marker = new $5b7ccabde48fae90$var$SparklineMarker();
        this.line = new $5b7ccabde48fae90$var$SparklineLine();
        this.crosshairs = new $5b7ccabde48fae90$var$SparklineCrosshairs();
        this.rootGroup.append(this.areaSparklineGroup);
        this.xAxisLine.zIndex = 500;
        this.fillPath.zIndex = 50;
        this.strokePath.zIndex = 1e3;
        this.xCrosshairLine.zIndex = 2e3;
        this.yCrosshairLine.zIndex = 2e3;
        this.markers.zIndex = 2500;
        this.areaSparklineGroup.append([
            this.fillPath,
            this.xAxisLine,
            this.strokePath,
            this.xCrosshairLine,
            this.yCrosshairLine,
            this.markers
        ]);
    }
    markerFactory() {
        const { shape: shape } = this.marker;
        const MarkerShape = $5b7ccabde48fae90$var$getMarker(shape);
        return new MarkerShape();
    }
    getNodeData() {
        return this.markerSelectionData;
    }
    update() {
        const data = this.generateNodeData();
        if (!data) return;
        const { nodeData: nodeData, fillData: fillData, strokeData: strokeData } = data;
        this.markerSelectionData = nodeData;
        this.updateSelection(nodeData);
        this.updateNodes();
        this.updateStroke(strokeData);
        this.updateFill(fillData);
    }
    updateYScaleDomain() {
        const { yData: yData, yScale: yScale } = this;
        const yMinMax = $5b7ccabde48fae90$var$extent2(yData);
        let yMin = 0;
        let yMax = 1;
        if (yMinMax !== void 0) {
            yMin = this.min = yMinMax[0];
            yMax = this.max = yMinMax[1];
        }
        yMin = yMin < 0 ? yMin : 0;
        yMax = yMax < 0 ? 0 : yMax;
        yScale.domain = [
            yMin,
            yMax
        ];
    }
    generateNodeData() {
        const { data: data, yData: yData, xData: xData, xScale: xScale, yScale: yScale } = this;
        if (!data) return;
        const continuous = !(xScale instanceof $5b7ccabde48fae90$var$BandScale2);
        const offsetX = !continuous ? xScale.bandwidth / 2 : 0;
        const n = yData.length;
        const nodeData = [];
        const fillData = [];
        const strokeData = [];
        let firstValidX;
        let lastValidX;
        let previousX;
        let nextX;
        const yZero = yScale.convert(0);
        for(let i = 0; i < n; i++){
            const yDatum = yData[i];
            const xDatum = xData[i];
            const x = xScale.convert(continuous ? xScale.toDomain(xDatum) : xDatum) + offsetX;
            const y = yDatum === void 0 ? NaN : yScale.convert(yDatum);
            if (i + 1 < n) nextX = xScale.convert(continuous ? xScale.toDomain(xData[i + 1]) : xData[i + 1]) + offsetX;
            strokeData.push({
                seriesDatum: {
                    x: xDatum,
                    y: yDatum
                },
                point: {
                    x: x,
                    y: y
                }
            });
            if (yDatum === void 0 && previousX !== void 0) {
                fillData.push({
                    seriesDatum: void 0,
                    point: {
                        x: previousX,
                        y: yZero
                    }
                });
                if (nextX !== void 0) fillData.push({
                    seriesDatum: void 0,
                    point: {
                        x: nextX,
                        y: yZero
                    }
                });
            } else if (yDatum !== void 0) {
                fillData.push({
                    seriesDatum: {
                        x: xDatum,
                        y: yDatum
                    },
                    point: {
                        x: x,
                        y: y
                    }
                });
                nodeData.push({
                    seriesDatum: {
                        x: xDatum,
                        y: yDatum
                    },
                    point: {
                        x: x,
                        y: y
                    }
                });
                firstValidX = firstValidX !== void 0 ? firstValidX : x;
                lastValidX = x;
            }
            previousX = x;
        }
        fillData.push({
            seriesDatum: void 0,
            point: {
                x: lastValidX,
                y: yZero
            }
        }, {
            seriesDatum: void 0,
            point: {
                x: firstValidX,
                y: yZero
            }
        });
        return {
            nodeData: nodeData,
            fillData: fillData,
            strokeData: strokeData
        };
    }
    updateAxisLine() {
        const { xScale: xScale, yScale: yScale, axis: axis, xAxisLine: xAxisLine } = this;
        xAxisLine.x1 = xScale.range[0];
        xAxisLine.x2 = xScale.range[1];
        xAxisLine.y1 = xAxisLine.y2 = 0;
        xAxisLine.stroke = axis.stroke;
        xAxisLine.strokeWidth = axis.strokeWidth;
        const yZero = yScale.convert(0);
        xAxisLine.translationY = yZero;
    }
    updateSelection(selectionData) {
        this.markerSelection.update(selectionData);
    }
    updateNodes() {
        const { highlightedDatum: highlightedDatum, highlightStyle: highlightStyle, marker: marker } = this;
        const { size: highlightSize, fill: highlightFill, stroke: highlightStroke, strokeWidth: highlightStrokeWidth } = highlightStyle;
        const markerFormatter = marker.formatter;
        this.markerSelection.each((node, datum, index)=>{
            const { point: point, seriesDatum: seriesDatum } = datum;
            if (!point) return;
            const highlighted = datum === highlightedDatum;
            const markerFill = highlighted && highlightFill !== void 0 ? highlightFill : marker.fill;
            const markerStroke = highlighted && highlightStroke !== void 0 ? highlightStroke : marker.stroke;
            const markerStrokeWidth = highlighted && highlightStrokeWidth !== void 0 ? highlightStrokeWidth : marker.strokeWidth;
            const markerSize = highlighted && highlightSize !== void 0 ? highlightSize : marker.size;
            let markerFormat;
            if (markerFormatter) {
                const first = index === 0;
                const last = index === this.markerSelectionData.length - 1;
                const min = seriesDatum.y === this.min;
                const max = seriesDatum.y === this.max;
                markerFormat = markerFormatter({
                    datum: datum,
                    xValue: seriesDatum.x,
                    yValue: seriesDatum.y,
                    min: min,
                    max: max,
                    first: first,
                    last: last,
                    fill: markerFill,
                    stroke: markerStroke,
                    strokeWidth: markerStrokeWidth,
                    size: markerSize,
                    highlighted: highlighted
                });
            }
            node.size = markerFormat && markerFormat.size != void 0 ? markerFormat.size : markerSize;
            node.fill = markerFormat && markerFormat.fill != void 0 ? markerFormat.fill : markerFill;
            node.stroke = markerFormat && markerFormat.stroke != void 0 ? markerFormat.stroke : markerStroke;
            node.strokeWidth = markerFormat && markerFormat.strokeWidth != void 0 ? markerFormat.strokeWidth : markerStrokeWidth;
            node.translationX = point.x;
            node.translationY = point.y;
            node.visible = markerFormat && markerFormat.enabled != void 0 ? markerFormat.enabled : marker.enabled && node.size > 0;
        });
    }
    updateStroke(strokeData) {
        const { strokePath: strokePath, yData: yData, line: line } = this;
        const path = strokePath.path;
        path.clear();
        if (yData.length < 2) return;
        const n = strokeData.length;
        let moveTo = true;
        for(let i = 0; i < n; i++){
            const { point: point, seriesDatum: seriesDatum } = strokeData[i];
            const x = point.x;
            const y = point.y;
            if (seriesDatum.y == void 0) moveTo = true;
            else if (moveTo) {
                path.moveTo(x, y);
                moveTo = false;
            } else path.lineTo(x, y);
        }
        strokePath.lineJoin = strokePath.lineCap = "round";
        strokePath.fill = void 0;
        strokePath.stroke = line.stroke;
        strokePath.strokeWidth = line.strokeWidth;
    }
    updateFill(areaData) {
        const { fillPath: fillPath, yData: yData, fill: fill } = this;
        const path = fillPath.path;
        const n = areaData.length;
        path.clear();
        if (yData.length < 2) return;
        for(let i = 0; i < n; i++){
            const { point: point } = areaData[i];
            const x = point.x;
            const y = point.y;
            if (i > 0) path.lineTo(x, y);
            else path.moveTo(x, y);
        }
        path.closePath();
        fillPath.lineJoin = "round";
        fillPath.stroke = void 0;
        fillPath.fill = fill;
    }
    updateXCrosshairLine() {
        var _a;
        const { yScale: yScale, xCrosshairLine: xCrosshairLine, highlightedDatum: highlightedDatum, crosshairs: { xLine: xLine } } = this;
        if (!xLine.enabled || highlightedDatum == void 0) {
            xCrosshairLine.strokeWidth = 0;
            return;
        }
        xCrosshairLine.y1 = yScale.range[0];
        xCrosshairLine.y2 = yScale.range[1];
        xCrosshairLine.x1 = xCrosshairLine.x2 = 0;
        xCrosshairLine.stroke = xLine.stroke;
        xCrosshairLine.strokeWidth = (_a = xLine.strokeWidth) != null ? _a : 1;
        xCrosshairLine.lineCap = xLine.lineCap === "round" || xLine.lineCap === "square" ? xLine.lineCap : void 0;
        const { lineDash: lineDash } = xLine;
        xCrosshairLine.lineDash = Array.isArray(lineDash) ? lineDash : $5b7ccabde48fae90$var$getLineDash(xCrosshairLine.lineCap, xLine.lineDash);
        xCrosshairLine.translationX = highlightedDatum.point.x;
    }
    updateYCrosshairLine() {
        var _a;
        const { xScale: xScale, yCrosshairLine: yCrosshairLine, highlightedDatum: highlightedDatum, crosshairs: { yLine: yLine } } = this;
        if (!yLine.enabled || highlightedDatum == void 0) {
            yCrosshairLine.strokeWidth = 0;
            return;
        }
        yCrosshairLine.x1 = xScale.range[0];
        yCrosshairLine.x2 = xScale.range[1];
        yCrosshairLine.y1 = yCrosshairLine.y2 = 0;
        yCrosshairLine.stroke = yLine.stroke;
        yCrosshairLine.strokeWidth = (_a = yLine.strokeWidth) != null ? _a : 1;
        yCrosshairLine.lineCap = yLine.lineCap === "round" || yLine.lineCap === "square" ? yLine.lineCap : void 0;
        const { lineDash: lineDash } = yLine;
        yCrosshairLine.lineDash = Array.isArray(lineDash) ? lineDash : $5b7ccabde48fae90$var$getLineDash(yCrosshairLine.lineCap, yLine.lineDash);
        yCrosshairLine.translationY = highlightedDatum.point.y;
    }
    getTooltipHtml(datum) {
        var _a, _b;
        const { dataType: dataType } = this;
        const { seriesDatum: seriesDatum } = datum;
        const yValue = seriesDatum.y;
        const xValue = seriesDatum.x;
        const content = this.formatNumericDatum(yValue);
        const title = dataType === "array" || dataType === "object" ? this.formatDatum(xValue) : void 0;
        const defaults = {
            content: content,
            title: title
        };
        const tooltipRenderer = (_b = (_a = this.processedOptions) == null ? void 0 : _a.tooltip) == null ? void 0 : _b.renderer;
        if (tooltipRenderer) return $5b7ccabde48fae90$var$toTooltipHtml(tooltipRenderer({
            context: this.context,
            datum: seriesDatum,
            yValue: yValue,
            xValue: xValue
        }), defaults);
        return $5b7ccabde48fae90$var$toTooltipHtml(defaults);
    }
};
$5b7ccabde48fae90$var$AreaSparkline.className = "AreaSparkline";
var { extent: $5b7ccabde48fae90$var$extent3 } = (0, $iTJTu._Util);
var { BandScale: $5b7ccabde48fae90$var$BandScale3 } = (0, $iTJTu._Scale);
var $5b7ccabde48fae90$var$SparklineMarker2 = class {
    constructor(){
        this.enabled = true;
        this.shape = "circle";
        this.size = 0;
        this.fill = "rgb(124, 181, 236)";
        this.stroke = "rgb(124, 181, 236)";
        this.strokeWidth = 1;
        this.formatter = void 0;
    }
};
var $5b7ccabde48fae90$var$SparklineLine2 = class {
    constructor(){
        this.stroke = "rgb(124, 181, 236)";
        this.strokeWidth = 1;
    }
};
var $5b7ccabde48fae90$var$SparklineCrosshairs2 = class {
    constructor(){
        this.xLine = {
            enabled: true,
            stroke: "rgba(0,0,0, 0.54)",
            strokeWidth: 1,
            lineDash: "solid",
            lineCap: void 0
        };
        this.yLine = {
            enabled: false,
            stroke: "rgba(0,0,0, 0.54)",
            strokeWidth: 1,
            lineDash: "solid",
            lineCap: void 0
        };
    }
};
var $5b7ccabde48fae90$var$LineSparkline = class extends $5b7ccabde48fae90$var$Sparkline {
    constructor(){
        super();
        this.linePath = new (0, $iTJTu._Scene).Path();
        this.xCrosshairLine = new (0, $iTJTu._Scene).Line();
        this.yCrosshairLine = new (0, $iTJTu._Scene).Line();
        this.lineSparklineGroup = new (0, $iTJTu._Scene).Group();
        this.markers = new (0, $iTJTu._Scene).Group();
        this.markerSelection = (0, $iTJTu._Scene).Selection.select(this.markers, ()=>this.markerFactory());
        this.markerSelectionData = [];
        this.marker = new $5b7ccabde48fae90$var$SparklineMarker2();
        this.line = new $5b7ccabde48fae90$var$SparklineLine2();
        this.crosshairs = new $5b7ccabde48fae90$var$SparklineCrosshairs2();
        this.rootGroup.append(this.lineSparklineGroup);
        this.linePath.zIndex = 1e3;
        this.xCrosshairLine.zIndex = 2e3;
        this.yCrosshairLine.zIndex = 2e3;
        this.markers.zIndex = 2500;
        this.lineSparklineGroup.append([
            this.linePath,
            this.xCrosshairLine,
            this.yCrosshairLine,
            this.markers
        ]);
    }
    getNodeData() {
        return this.markerSelectionData;
    }
    markerFactory() {
        const { shape: shape } = this.marker;
        const MarkerShape = $5b7ccabde48fae90$var$getMarker(shape);
        return new MarkerShape();
    }
    /**
   * If marker shape is changed, this method should be called to remove the previous marker nodes selection.
   */ onMarkerShapeChange() {
        this.markerSelection = this.markerSelection.clear();
        this.scheduleLayout();
    }
    update() {
        const nodeData = this.generateNodeData();
        if (!nodeData) return;
        this.markerSelectionData = nodeData;
        this.updateSelection(nodeData);
        this.updateNodes();
        this.updateLine();
    }
    updateYScaleDomain() {
        const { yData: yData, yScale: yScale } = this;
        const yMinMax = $5b7ccabde48fae90$var$extent3(yData);
        let yMin = 0;
        let yMax = 1;
        if (yMinMax !== void 0) {
            yMin = this.min = yMinMax[0];
            yMax = this.max = yMinMax[1];
        }
        if (yMin === yMax) {
            const padding = Math.abs(yMin * 0.01);
            yMin -= padding;
            yMax += padding;
        }
        yScale.domain = [
            yMin,
            yMax
        ];
    }
    generateNodeData() {
        const { data: data, yData: yData, xData: xData, xScale: xScale, yScale: yScale } = this;
        if (!data) return;
        const continuous = !(xScale instanceof $5b7ccabde48fae90$var$BandScale3);
        const offsetX = !continuous ? xScale.bandwidth / 2 : 0;
        const nodeData = [];
        for(let i = 0; i < yData.length; i++){
            const yDatum = yData[i];
            const xDatum = xData[i];
            if (yDatum == void 0) continue;
            const x = xScale.convert(continuous ? xScale.toDomain(xDatum) : xDatum) + offsetX;
            const y = yDatum === void 0 ? NaN : yScale.convert(yDatum);
            nodeData.push({
                seriesDatum: {
                    x: xDatum,
                    y: yDatum
                },
                point: {
                    x: x,
                    y: y
                }
            });
        }
        return nodeData;
    }
    updateSelection(selectionData) {
        this.markerSelection.update(selectionData);
    }
    updateNodes() {
        const { highlightedDatum: highlightedDatum, highlightStyle: highlightStyle, marker: marker } = this;
        const { size: highlightSize, fill: highlightFill, stroke: highlightStroke, strokeWidth: highlightStrokeWidth } = highlightStyle;
        const markerFormatter = marker.formatter;
        this.markerSelection.each((node, datum, index)=>{
            const highlighted = datum === highlightedDatum;
            const markerFill = highlighted && highlightFill !== void 0 ? highlightFill : marker.fill;
            const markerStroke = highlighted && highlightStroke !== void 0 ? highlightStroke : marker.stroke;
            const markerStrokeWidth = highlighted && highlightStrokeWidth !== void 0 ? highlightStrokeWidth : marker.strokeWidth;
            const markerSize = highlighted && highlightSize !== void 0 ? highlightSize : marker.size;
            let markerFormat;
            const { seriesDatum: seriesDatum, point: point } = datum;
            if (markerFormatter) {
                const first = index === 0;
                const last = index === this.markerSelectionData.length - 1;
                const min = seriesDatum.y === this.min;
                const max = seriesDatum.y === this.max;
                markerFormat = markerFormatter({
                    datum: datum,
                    xValue: seriesDatum.x,
                    yValue: seriesDatum.y,
                    min: min,
                    max: max,
                    first: first,
                    last: last,
                    fill: markerFill,
                    stroke: markerStroke,
                    strokeWidth: markerStrokeWidth,
                    size: markerSize,
                    highlighted: highlighted
                });
            }
            node.size = markerFormat && markerFormat.size != void 0 ? markerFormat.size : markerSize;
            node.fill = markerFormat && markerFormat.fill != void 0 ? markerFormat.fill : markerFill;
            node.stroke = markerFormat && markerFormat.stroke != void 0 ? markerFormat.stroke : markerStroke;
            node.strokeWidth = markerFormat && markerFormat.strokeWidth != void 0 ? markerFormat.strokeWidth : markerStrokeWidth;
            node.translationX = point.x;
            node.translationY = point.y;
            node.visible = markerFormat && markerFormat.enabled != void 0 ? markerFormat.enabled : marker.enabled && node.size > 0;
        });
    }
    updateLine() {
        const { linePath: linePath, yData: yData, xData: xData, xScale: xScale, yScale: yScale, line: line } = this;
        const path = linePath.path;
        path.clear();
        if (yData.length < 2) return;
        const continuous = !(xScale instanceof $5b7ccabde48fae90$var$BandScale3);
        const n = yData.length;
        const offsetX = !continuous ? xScale.bandwidth / 2 : 0;
        let moveTo = true;
        for(let i = 0; i < n; i++){
            const xDatum = xData[i];
            const yDatum = yData[i];
            const x = xScale.convert(continuous ? xScale.toDomain(xDatum) : xDatum) + offsetX;
            const y = yDatum === void 0 ? NaN : yScale.convert(yDatum);
            if (yDatum == void 0) moveTo = true;
            else if (moveTo) {
                path.moveTo(x, y);
                moveTo = false;
            } else path.lineTo(x, y);
        }
        linePath.fill = void 0;
        linePath.stroke = line.stroke;
        linePath.strokeWidth = line.strokeWidth;
    }
    updateXCrosshairLine() {
        var _a;
        const { yScale: yScale, xCrosshairLine: xCrosshairLine, highlightedDatum: highlightedDatum, crosshairs: { xLine: xLine } } = this;
        if (!xLine.enabled || highlightedDatum == void 0) {
            xCrosshairLine.strokeWidth = 0;
            return;
        }
        xCrosshairLine.y1 = yScale.range[0];
        xCrosshairLine.y2 = yScale.range[1];
        xCrosshairLine.x1 = xCrosshairLine.x2 = 0;
        xCrosshairLine.stroke = xLine.stroke;
        xCrosshairLine.strokeWidth = (_a = xLine.strokeWidth) != null ? _a : 1;
        xCrosshairLine.lineCap = xLine.lineCap === "round" || xLine.lineCap === "square" ? xLine.lineCap : void 0;
        const { lineDash: lineDash } = xLine;
        xCrosshairLine.lineDash = Array.isArray(lineDash) ? lineDash : $5b7ccabde48fae90$var$getLineDash(xCrosshairLine.lineCap, xLine.lineDash);
        xCrosshairLine.translationX = highlightedDatum.point.x;
    }
    updateYCrosshairLine() {
        var _a;
        const { xScale: xScale, yCrosshairLine: yCrosshairLine, highlightedDatum: highlightedDatum, crosshairs: { yLine: yLine } } = this;
        if (!yLine.enabled || highlightedDatum == void 0) {
            yCrosshairLine.strokeWidth = 0;
            return;
        }
        yCrosshairLine.x1 = xScale.range[0];
        yCrosshairLine.x2 = xScale.range[1];
        yCrosshairLine.y1 = yCrosshairLine.y2 = 0;
        yCrosshairLine.stroke = yLine.stroke;
        yCrosshairLine.strokeWidth = (_a = yLine.strokeWidth) != null ? _a : 1;
        yCrosshairLine.lineCap = yLine.lineCap === "round" || yLine.lineCap === "square" ? yLine.lineCap : void 0;
        const { lineDash: lineDash } = yLine;
        yCrosshairLine.lineDash = Array.isArray(lineDash) ? lineDash : $5b7ccabde48fae90$var$getLineDash(yCrosshairLine.lineCap, yLine.lineDash);
        yCrosshairLine.translationY = highlightedDatum.point.y;
    }
    getTooltipHtml(datum) {
        var _a, _b;
        const { dataType: dataType } = this;
        const { seriesDatum: seriesDatum } = datum;
        const yValue = seriesDatum.y;
        const xValue = seriesDatum.x;
        const content = this.formatNumericDatum(yValue);
        const title = dataType === "array" || dataType === "object" ? this.formatDatum(xValue) : void 0;
        const defaults = {
            content: content,
            title: title
        };
        const tooltipRenderer = (_b = (_a = this.processedOptions) == null ? void 0 : _a.tooltip) == null ? void 0 : _b.renderer;
        if (tooltipRenderer) return $5b7ccabde48fae90$var$toTooltipHtml(tooltipRenderer({
            context: this.context,
            datum: seriesDatum,
            yValue: yValue,
            xValue: xValue
        }), defaults);
        return $5b7ccabde48fae90$var$toTooltipHtml(defaults);
    }
};
$5b7ccabde48fae90$var$LineSparkline.className = "LineSparkline";
var $5b7ccabde48fae90$var$Label = class {
    constructor(){
        this.enabled = true;
        this.fontSize = 8;
        this.fontFamily = "Verdana, sans-serif";
        this.fontStyle = void 0;
        this.fontWeight = void 0;
        this.color = "rgba(70, 70, 70, 1)";
    }
};
var { extent: $5b7ccabde48fae90$var$extent4 } = (0, $iTJTu._Util);
var $5b7ccabde48fae90$var$BarColumnLabel = class extends $5b7ccabde48fae90$var$Label {
    constructor(){
        super(...arguments);
        this.formatter = void 0;
        this.placement = "insideEnd";
    }
};
var $5b7ccabde48fae90$var$BarColumnSparkline = class extends $5b7ccabde48fae90$var$Sparkline {
    constructor(){
        super();
        this.fill = "rgb(124, 181, 236)";
        this.stroke = "silver";
        this.strokeWidth = 0;
        this.paddingInner = 0.1;
        this.paddingOuter = 0.2;
        this.valueAxisDomain = void 0;
        this.formatter = void 0;
        this.axisLine = new (0, $iTJTu._Scene).Line();
        this.bandWidth = 0;
        this.sparklineGroup = new (0, $iTJTu._Scene).Group();
        this.rectGroup = new (0, $iTJTu._Scene).Group();
        this.labelGroup = new (0, $iTJTu._Scene).Group();
        this.rectSelection = (0, $iTJTu._Scene).Selection.select(this.rectGroup, (0, $iTJTu._Scene).Rect);
        this.labelSelection = (0, $iTJTu._Scene).Selection.select(this.labelGroup, (0, $iTJTu._Scene).Text);
        this.nodeSelectionData = [];
        this.label = new $5b7ccabde48fae90$var$BarColumnLabel();
        this.rootGroup.append(this.sparklineGroup);
        this.rectGroup.zIndex = 50;
        this.axisLine.zIndex = 500;
        this.labelGroup.zIndex = 1500;
        this.sparklineGroup.append([
            this.rectGroup,
            this.axisLine,
            this.labelGroup
        ]);
        this.axisLine.lineCap = "round";
        this.label.enabled = false;
    }
    getNodeData() {
        return this.nodeSelectionData;
    }
    update() {
        this.updateSelections();
        this.updateNodes();
    }
    updateSelections() {
        const nodeData = this.generateNodeData();
        if (!nodeData) return;
        this.nodeSelectionData = nodeData;
        this.updateRectSelection(nodeData);
        this.updateLabelSelection(nodeData);
    }
    updateNodes() {
        this.updateRectNodes();
        this.updateLabelNodes();
    }
    calculateStep(range) {
        var _a;
        const { xScale: xScale, paddingInner: paddingInner, paddingOuter: paddingOuter, smallestInterval: smallestInterval } = this;
        let domainLength = xScale.domain[1] - xScale.domain[0];
        let intervals = domainLength / ((_a = smallestInterval == null ? void 0 : smallestInterval.x) != null ? _a : 1) + 1;
        const maxBands = 50;
        const bands = Math.min(intervals, maxBands);
        const gaps = bands - 1;
        const step = range / Math.max(1, 2 * paddingOuter + gaps * paddingInner + bands);
        return step;
    }
    updateYScaleDomain() {
        const { yScale: yScale, yData: yData, valueAxisDomain: valueAxisDomain } = this;
        const yMinMax = $5b7ccabde48fae90$var$extent4(yData);
        let yMin = 0;
        let yMax = 1;
        if (yMinMax !== void 0) {
            yMin = this.min = yMinMax[0];
            yMax = this.max = yMinMax[1];
        }
        yMin = yMin < 0 ? yMin : 0;
        yMax = yMax < 0 ? 0 : yMax;
        if (valueAxisDomain) {
            if (valueAxisDomain[1] < yMax) valueAxisDomain[1] = yMax;
            if (valueAxisDomain[0] > yMin) valueAxisDomain[0] = yMin;
        }
        yScale.domain = valueAxisDomain ? valueAxisDomain : [
            yMin,
            yMax
        ];
    }
    updateRectSelection(selectionData) {
        this.rectSelection.update(selectionData);
    }
    updateRectNodes() {
        const { highlightedDatum: highlightedDatum, formatter: nodeFormatter, fill: fill, stroke: stroke, strokeWidth: strokeWidth } = this;
        const { fill: highlightFill, stroke: highlightStroke, strokeWidth: highlightStrokeWidth } = this.highlightStyle;
        this.rectSelection.each((node, datum, index)=>{
            const highlighted = datum === highlightedDatum;
            const nodeFill = highlighted && highlightFill !== void 0 ? highlightFill : fill;
            const nodeStroke = highlighted && highlightStroke !== void 0 ? highlightStroke : stroke;
            const nodeStrokeWidth = highlighted && highlightStrokeWidth !== void 0 ? highlightStrokeWidth : strokeWidth;
            let nodeFormat;
            const { x: x, y: y, width: width, height: height, seriesDatum: seriesDatum } = datum;
            if (nodeFormatter) {
                const first = index === 0;
                const last = index === this.nodeSelectionData.length - 1;
                const min = seriesDatum.y === this.min;
                const max = seriesDatum.y === this.max;
                nodeFormat = nodeFormatter({
                    datum: datum,
                    xValue: seriesDatum.x,
                    yValue: seriesDatum.y,
                    width: width,
                    height: height,
                    min: min,
                    max: max,
                    first: first,
                    last: last,
                    fill: nodeFill,
                    stroke: nodeStroke,
                    strokeWidth: nodeStrokeWidth,
                    highlighted: highlighted
                });
            }
            node.fill = nodeFormat && nodeFormat.fill || nodeFill;
            node.stroke = nodeFormat && nodeFormat.stroke || nodeStroke;
            node.strokeWidth = nodeFormat && nodeFormat.strokeWidth || nodeStrokeWidth;
            node.x = node.y = 0;
            node.width = width;
            node.height = height;
            node.visible = node.height > 0;
            node.translationX = x;
            node.translationY = y;
        });
    }
    updateLabelSelection(selectionData) {
        this.labelSelection.update(selectionData, (text)=>{
            text.tag = 1;
            text.pointerEvents = (0, $iTJTu._Scene).PointerEvents.None;
        });
    }
    updateLabelNodes() {
        const { label: { enabled: labelEnabled, fontStyle: fontStyle, fontWeight: fontWeight, fontSize: fontSize, fontFamily: fontFamily, color: color } } = this;
        this.labelSelection.each((text, datum)=>{
            const label = datum.label;
            if (label && labelEnabled) {
                text.fontStyle = fontStyle;
                text.fontWeight = fontWeight;
                text.fontSize = fontSize;
                text.fontFamily = fontFamily;
                text.textAlign = label.textAlign;
                text.textBaseline = label.textBaseline;
                text.text = label.text;
                text.x = label.x;
                text.y = label.y;
                text.fill = color;
                text.visible = true;
            } else text.visible = false;
        });
    }
    getTooltipHtml(datum) {
        var _a, _b;
        const { dataType: dataType } = this;
        const { seriesDatum: seriesDatum } = datum;
        const yValue = seriesDatum.y;
        const xValue = seriesDatum.x;
        const content = this.formatNumericDatum(yValue);
        const title = dataType === "array" || dataType === "object" ? this.formatDatum(xValue) : void 0;
        const defaults = {
            content: content,
            title: title
        };
        const tooltipRenderer = (_b = (_a = this.processedOptions) == null ? void 0 : _a.tooltip) == null ? void 0 : _b.renderer;
        if (tooltipRenderer) return $5b7ccabde48fae90$var$toTooltipHtml(tooltipRenderer({
            context: this.context,
            datum: seriesDatum,
            yValue: yValue,
            xValue: xValue
        }), defaults);
        return $5b7ccabde48fae90$var$toTooltipHtml(defaults);
    }
    formatLabelValue(value) {
        return value % 1 !== 0 ? value.toFixed(1) : value.toFixed(0);
    }
};
var { isNumber: $5b7ccabde48fae90$var$isNumber2 } = (0, $iTJTu._Util);
var { BandScale: $5b7ccabde48fae90$var$BandScale4 } = (0, $iTJTu._Scale);
var $5b7ccabde48fae90$var$BarSparkline = class extends $5b7ccabde48fae90$var$BarColumnSparkline {
    updateYScaleRange() {
        const { seriesRect: seriesRect, yScale: yScale } = this;
        yScale.range = [
            0,
            seriesRect.width
        ];
    }
    updateXScaleRange() {
        const { xScale: xScale, seriesRect: seriesRect, paddingOuter: paddingOuter, paddingInner: paddingInner } = this;
        if (xScale instanceof $5b7ccabde48fae90$var$BandScale4) {
            xScale.range = [
                0,
                seriesRect.height
            ];
            xScale.paddingInner = paddingInner;
            xScale.paddingOuter = paddingOuter;
        } else {
            const step = this.calculateStep(seriesRect.height);
            const padding = step * paddingOuter;
            this.bandWidth = step * (1 - paddingInner);
            xScale.range = [
                padding,
                seriesRect.height - padding - this.bandWidth
            ];
        }
    }
    updateAxisLine() {
        const { yScale: yScale, axis: axis, axisLine: axisLine, seriesRect: seriesRect } = this;
        const { strokeWidth: strokeWidth } = axis;
        axisLine.x1 = 0;
        axisLine.x2 = 0;
        axisLine.y1 = 0;
        axisLine.y2 = seriesRect.height;
        axisLine.stroke = axis.stroke;
        axisLine.strokeWidth = strokeWidth + (strokeWidth % 2 === 1 ? 1 : 0);
        const yZero = yScale.convert(0);
        axisLine.translationX = yZero;
    }
    generateNodeData() {
        const { data: data, yData: yData, xData: xData, xScale: xScale, yScale: yScale, fill: fill, stroke: stroke, strokeWidth: strokeWidth, label: label } = this;
        if (!data) return;
        const { fontStyle: labelFontStyle, fontWeight: labelFontWeight, fontSize: labelFontSize, fontFamily: labelFontFamily, color: labelColor, formatter: labelFormatter, placement: labelPlacement } = label;
        const nodeData = [];
        const yZero = yScale.convert(0);
        const continuous = !(xScale instanceof $5b7ccabde48fae90$var$BandScale4);
        for(let i = 0, n = yData.length; i < n; i++){
            let yDatum = yData[i];
            const xDatum = xData[i];
            const invalidDatum = yDatum === void 0;
            if (invalidDatum) yDatum = 0;
            const y = xScale.convert(continuous ? xScale.toDomain(xDatum) : xDatum);
            const x = Math.min(yDatum === void 0 ? NaN : yScale.convert(yDatum), yZero);
            const bottom = Math.max(yDatum === void 0 ? NaN : yScale.convert(yDatum), yZero);
            const height = !continuous ? xScale.bandwidth : this.bandWidth;
            const width = bottom - x;
            const midPoint = {
                x: yZero,
                y: y
            };
            let labelText;
            if (labelFormatter) labelText = labelFormatter({
                value: yDatum
            });
            else labelText = yDatum !== void 0 && $5b7ccabde48fae90$var$isNumber2(yDatum) ? this.formatLabelValue(yDatum) : "";
            const labelY = y + height / 2;
            let labelX;
            const labelTextBaseline = "middle";
            let labelTextAlign;
            const isPositiveY = yDatum !== void 0 && yDatum >= 0;
            const labelPadding = 4;
            if (labelPlacement === "center") {
                labelX = x + width / 2;
                labelTextAlign = "center";
            } else if (labelPlacement === "outsideEnd") {
                labelX = x + (isPositiveY ? width + labelPadding : -labelPadding);
                labelTextAlign = isPositiveY ? "start" : "end";
            } else if (labelPlacement === "insideEnd") {
                labelX = x + (isPositiveY ? width - labelPadding : labelPadding);
                labelTextAlign = isPositiveY ? "end" : "start";
                const textSize = (0, $iTJTu._Scene).Text.getTextSize(labelText, labelFontFamily);
                const textWidth = textSize.width || 20;
                const positiveBoundary = yZero + textWidth;
                const negativeBoundary = yZero - textWidth;
                const exceedsBoundaries = isPositiveY && labelX < positiveBoundary || !isPositiveY && labelX > negativeBoundary;
                if (exceedsBoundaries) {
                    labelX = yZero + labelPadding * (isPositiveY ? 1 : -1);
                    labelTextAlign = isPositiveY ? "start" : "end";
                }
            } else {
                labelX = yZero + labelPadding * (isPositiveY ? 1 : -1);
                labelTextAlign = isPositiveY ? "start" : "end";
            }
            nodeData.push({
                x: x,
                y: y,
                width: width,
                height: height,
                fill: fill,
                stroke: stroke,
                strokeWidth: strokeWidth,
                seriesDatum: {
                    x: xDatum,
                    y: invalidDatum ? void 0 : yDatum
                },
                point: midPoint,
                label: {
                    x: labelX,
                    y: labelY,
                    text: labelText,
                    fontStyle: labelFontStyle,
                    fontWeight: labelFontWeight,
                    fontSize: labelFontSize,
                    fontFamily: labelFontFamily,
                    textAlign: labelTextAlign,
                    textBaseline: labelTextBaseline,
                    fill: labelColor
                }
            });
        }
        return nodeData;
    }
    getDistance(p1, p2) {
        return Math.abs(p1.y - p2.y);
    }
};
$5b7ccabde48fae90$var$BarSparkline.className = "BarSparkline";
var { isNumber: $5b7ccabde48fae90$var$isNumber3 } = (0, $iTJTu._Util);
var { BandScale: $5b7ccabde48fae90$var$BandScale5 } = (0, $iTJTu._Scale);
var $5b7ccabde48fae90$var$ColumnSparkline = class extends $5b7ccabde48fae90$var$BarColumnSparkline {
    updateYScaleRange() {
        const { seriesRect: seriesRect, yScale: yScale } = this;
        yScale.range = [
            seriesRect.height,
            0
        ];
    }
    updateXScaleRange() {
        const { xScale: xScale, seriesRect: seriesRect, paddingOuter: paddingOuter, paddingInner: paddingInner } = this;
        if (xScale instanceof $5b7ccabde48fae90$var$BandScale5) {
            xScale.range = [
                0,
                seriesRect.width
            ];
            xScale.paddingInner = paddingInner;
            xScale.paddingOuter = paddingOuter;
        } else {
            const step = this.calculateStep(seriesRect.width);
            const padding = step * paddingOuter;
            this.bandWidth = step * (1 - paddingInner);
            xScale.range = [
                padding,
                seriesRect.width - padding - this.bandWidth
            ];
        }
    }
    updateAxisLine() {
        const { yScale: yScale, axis: axis, axisLine: axisLine, seriesRect: seriesRect } = this;
        const { strokeWidth: strokeWidth } = axis;
        axisLine.x1 = 0;
        axisLine.x2 = seriesRect.width;
        axisLine.y1 = 0;
        axisLine.y2 = 0;
        axisLine.stroke = axis.stroke;
        axisLine.strokeWidth = strokeWidth + (strokeWidth % 2 === 1 ? 1 : 0);
        const yZero = yScale.convert(0);
        axisLine.translationY = yZero;
    }
    generateNodeData() {
        const { data: data, yData: yData, xData: xData, xScale: xScale, yScale: yScale, fill: fill, stroke: stroke, strokeWidth: strokeWidth, label: label } = this;
        if (!data) return;
        const { fontStyle: labelFontStyle, fontWeight: labelFontWeight, fontSize: labelFontSize, fontFamily: labelFontFamily, color: labelColor, formatter: labelFormatter, placement: labelPlacement } = label;
        const nodeData = [];
        const yZero = yScale.convert(0);
        const continuous = !(xScale instanceof $5b7ccabde48fae90$var$BandScale5);
        for(let i = 0, n = yData.length; i < n; i++){
            let yDatum = yData[i];
            const xDatum = xData[i];
            const invalidDatum = yDatum === void 0;
            if (invalidDatum) yDatum = 0;
            const y = Math.min(yDatum === void 0 ? NaN : yScale.convert(yDatum), yZero);
            const x = xScale.convert(continuous ? xScale.toDomain(xDatum) : xDatum);
            const bottom = Math.max(yDatum === void 0 ? NaN : yScale.convert(yDatum), yZero);
            const width = !continuous ? xScale.bandwidth : this.bandWidth;
            const height = bottom - y;
            const midPoint = {
                x: x + width / 2,
                y: yZero
            };
            let labelText;
            if (labelFormatter) labelText = labelFormatter({
                value: yDatum
            });
            else labelText = yDatum !== void 0 && $5b7ccabde48fae90$var$isNumber3(yDatum) ? this.formatLabelValue(yDatum) : "";
            const labelX = x + width / 2;
            let labelY;
            const labelTextAlign = "center";
            let labelTextBaseline;
            const isPositiveY = yDatum !== void 0 && yDatum >= 0;
            const labelPadding = 2;
            if (labelPlacement === "center") {
                labelY = y + height / 2;
                labelTextBaseline = "middle";
            } else if (labelPlacement === "outsideEnd") {
                labelY = y + (isPositiveY ? -labelPadding : height + labelPadding);
                labelTextBaseline = isPositiveY ? "bottom" : "top";
            } else if (labelPlacement === "insideEnd") {
                labelY = y + (isPositiveY ? labelPadding : height - labelPadding);
                labelTextBaseline = isPositiveY ? "top" : "bottom";
                const textSize = (0, $iTJTu._Scene).Text.getTextSize(labelText, labelFontFamily);
                const textHeight = textSize.height || 10;
                const positiveBoundary = yZero - textHeight;
                const negativeBoundary = yZero + textHeight;
                const exceedsBoundaries = isPositiveY && labelY > positiveBoundary || !isPositiveY && labelY < negativeBoundary;
                if (exceedsBoundaries) {
                    labelY = yZero + labelPadding * (isPositiveY ? -1 : 1);
                    labelTextBaseline = isPositiveY ? "bottom" : "top";
                }
            } else {
                labelY = yZero + labelPadding * (isPositiveY ? -1 : 1);
                labelTextBaseline = isPositiveY ? "bottom" : "top";
            }
            nodeData.push({
                x: x,
                y: y,
                width: width,
                height: height,
                fill: fill,
                stroke: stroke,
                strokeWidth: strokeWidth,
                seriesDatum: {
                    x: xDatum,
                    y: invalidDatum ? void 0 : yDatum
                },
                point: midPoint,
                label: {
                    x: labelX,
                    y: labelY,
                    text: labelText,
                    fontStyle: labelFontStyle,
                    fontWeight: labelFontWeight,
                    fontSize: labelFontSize,
                    fontFamily: labelFontFamily,
                    textAlign: labelTextAlign,
                    textBaseline: labelTextBaseline,
                    fill: labelColor
                }
            });
        }
        return nodeData;
    }
};
$5b7ccabde48fae90$var$ColumnSparkline.className = "ColumnSparkline";
var { isNumber: $5b7ccabde48fae90$var$isNumber4 } = (0, $iTJTu._Util);
var $5b7ccabde48fae90$var$AgSparkline = class {
    static create(options, tooltip) {
        options = (0, $iTJTu._Util).deepClone(options);
        const sparkline = $5b7ccabde48fae90$var$getSparklineInstance(options.type);
        if (tooltip) sparkline.tooltip = tooltip;
        $5b7ccabde48fae90$var$initSparkline(sparkline, options);
        $5b7ccabde48fae90$var$initSparklineByType(sparkline, options);
        if (options.data) sparkline.data = options.data;
        sparkline.processedOptions = options;
        return sparkline;
    }
};
function $5b7ccabde48fae90$var$getSparklineInstance(type = "line") {
    switch(type){
        case "column":
            return new $5b7ccabde48fae90$var$ColumnSparkline();
        case "bar":
            return new $5b7ccabde48fae90$var$BarSparkline();
        case "area":
            return new $5b7ccabde48fae90$var$AreaSparkline();
        case "line":
        default:
            return new $5b7ccabde48fae90$var$LineSparkline();
    }
}
function $5b7ccabde48fae90$var$initSparklineByType(sparkline, options) {
    switch(options.type){
        case "bar":
            $5b7ccabde48fae90$var$initBarColumnSparkline(sparkline, options);
            break;
        case "column":
            $5b7ccabde48fae90$var$initBarColumnSparkline(sparkline, options);
            break;
        case "area":
            $5b7ccabde48fae90$var$initAreaSparkline(sparkline, options);
            break;
        case "line":
        default:
            $5b7ccabde48fae90$var$initLineSparkline(sparkline, options);
            break;
    }
}
function $5b7ccabde48fae90$var$initSparkline(sparkline, options) {
    $5b7ccabde48fae90$var$setValueIfPropertyExists(sparkline, "context", options.context, options);
    $5b7ccabde48fae90$var$setValueIfPropertyExists(sparkline, "width", options.width, options);
    $5b7ccabde48fae90$var$setValueIfPropertyExists(sparkline, "height", options.height, options);
    $5b7ccabde48fae90$var$setValueIfPropertyExists(sparkline, "container", options.container, options);
    $5b7ccabde48fae90$var$setValueIfPropertyExists(sparkline, "xKey", options.xKey, options);
    $5b7ccabde48fae90$var$setValueIfPropertyExists(sparkline, "yKey", options.yKey, options);
    if (options.padding) $5b7ccabde48fae90$var$initPaddingOptions(sparkline.padding, options.padding);
    if (options.axis) $5b7ccabde48fae90$var$initAxisOptions(sparkline.axis, options.axis);
    if (options.highlightStyle) $5b7ccabde48fae90$var$initHighlightStyleOptions(sparkline.highlightStyle, options.highlightStyle);
}
function $5b7ccabde48fae90$var$initLineSparkline(sparkline, options) {
    if (options.marker) $5b7ccabde48fae90$var$initMarkerOptions(sparkline.marker, options.marker);
    if (options.line) $5b7ccabde48fae90$var$initLineOptions(sparkline.line, options.line);
    if (options.crosshairs) $5b7ccabde48fae90$var$initCrosshairsOptions(sparkline.crosshairs, options.crosshairs);
}
function $5b7ccabde48fae90$var$initAreaSparkline(sparkline, options) {
    $5b7ccabde48fae90$var$setValueIfPropertyExists(sparkline, "fill", options.fill, options);
    if (options.marker) $5b7ccabde48fae90$var$initMarkerOptions(sparkline.marker, options.marker);
    if (options.line) $5b7ccabde48fae90$var$initLineOptions(sparkline.line, options.line);
    if (options.crosshairs) $5b7ccabde48fae90$var$initCrosshairsOptions(sparkline.crosshairs, options.crosshairs);
}
function $5b7ccabde48fae90$var$initBarColumnSparkline(sparkline, options) {
    $5b7ccabde48fae90$var$setValueIfPropertyExists(sparkline, "valueAxisDomain", options.valueAxisDomain, options);
    $5b7ccabde48fae90$var$setValueIfPropertyExists(sparkline, "fill", options.fill, options);
    $5b7ccabde48fae90$var$setValueIfPropertyExists(sparkline, "stroke", options.stroke, options);
    $5b7ccabde48fae90$var$setValueIfPropertyExists(sparkline, "strokeWidth", options.strokeWidth, options);
    $5b7ccabde48fae90$var$setValueIfPropertyExists(sparkline, "paddingInner", options.paddingInner, options);
    $5b7ccabde48fae90$var$setValueIfPropertyExists(sparkline, "paddingOuter", options.paddingOuter, options);
    $5b7ccabde48fae90$var$setValueIfPropertyExists(sparkline, "formatter", options.formatter, options);
    if (options.label) $5b7ccabde48fae90$var$initLabelOptions(sparkline.label, options.label);
}
function $5b7ccabde48fae90$var$initPaddingOptions(target, options) {
    $5b7ccabde48fae90$var$setValueIfPropertyExists(target, "top", options.top, options);
    $5b7ccabde48fae90$var$setValueIfPropertyExists(target, "right", options.right, options);
    $5b7ccabde48fae90$var$setValueIfPropertyExists(target, "bottom", options.bottom, options);
    $5b7ccabde48fae90$var$setValueIfPropertyExists(target, "left", options.left, options);
}
function $5b7ccabde48fae90$var$initMarkerOptions(target, options) {
    $5b7ccabde48fae90$var$setValueIfPropertyExists(target, "enabled", options.enabled, options);
    $5b7ccabde48fae90$var$setValueIfPropertyExists(target, "size", options.size, options);
    $5b7ccabde48fae90$var$setValueIfPropertyExists(target, "shape", options.shape, options);
    $5b7ccabde48fae90$var$setValueIfPropertyExists(target, "fill", options.fill, options);
    $5b7ccabde48fae90$var$setValueIfPropertyExists(target, "stroke", options.stroke, options);
    $5b7ccabde48fae90$var$setValueIfPropertyExists(target, "strokeWidth", options.strokeWidth, options);
    $5b7ccabde48fae90$var$setValueIfPropertyExists(target, "formatter", options.formatter, options);
}
function $5b7ccabde48fae90$var$initLabelOptions(target, options) {
    $5b7ccabde48fae90$var$setValueIfPropertyExists(target, "enabled", options.enabled, options);
    $5b7ccabde48fae90$var$setValueIfPropertyExists(target, "fontStyle", options.fontStyle, options);
    $5b7ccabde48fae90$var$setValueIfPropertyExists(target, "fontWeight", options.fontWeight, options);
    $5b7ccabde48fae90$var$setValueIfPropertyExists(target, "fontSize", options.fontSize, options);
    $5b7ccabde48fae90$var$setValueIfPropertyExists(target, "fontFamily", options.fontFamily, options);
    $5b7ccabde48fae90$var$setValueIfPropertyExists(target, "textAlign", options.textAlign, options);
    $5b7ccabde48fae90$var$setValueIfPropertyExists(target, "textBaseline", options.textBaseline, options);
    $5b7ccabde48fae90$var$setValueIfPropertyExists(target, "color", options.color, options);
    $5b7ccabde48fae90$var$setValueIfPropertyExists(target, "formatter", options.formatter, options);
    $5b7ccabde48fae90$var$setValueIfPropertyExists(target, "placement", options.placement, options);
}
function $5b7ccabde48fae90$var$initLineOptions(target, options) {
    $5b7ccabde48fae90$var$setValueIfPropertyExists(target, "stroke", options.stroke, options);
    $5b7ccabde48fae90$var$setValueIfPropertyExists(target, "strokeWidth", options.strokeWidth, options);
}
function $5b7ccabde48fae90$var$initAxisOptions(target, options) {
    $5b7ccabde48fae90$var$setValueIfPropertyExists(target, "type", options.type, options);
    $5b7ccabde48fae90$var$setValueIfPropertyExists(target, "stroke", options.stroke, options);
    $5b7ccabde48fae90$var$setValueIfPropertyExists(target, "strokeWidth", options.strokeWidth, options);
}
function $5b7ccabde48fae90$var$initHighlightStyleOptions(target, options) {
    $5b7ccabde48fae90$var$setValueIfPropertyExists(target, "fill", options.fill, options);
    $5b7ccabde48fae90$var$setValueIfPropertyExists(target, "size", options.size, options);
    $5b7ccabde48fae90$var$setValueIfPropertyExists(target, "stroke", options.stroke, options);
    $5b7ccabde48fae90$var$setValueIfPropertyExists(target, "strokeWidth", options.strokeWidth, options);
}
function $5b7ccabde48fae90$var$initCrosshairsOptions(target, options) {
    if (target.xLine && options.xLine) $5b7ccabde48fae90$var$initCrosshairLineOptions(target.xLine, options.xLine);
    if (target.yLine && options.yLine) $5b7ccabde48fae90$var$initCrosshairLineOptions(target.yLine, options.yLine);
}
function $5b7ccabde48fae90$var$initCrosshairLineOptions(target, options) {
    $5b7ccabde48fae90$var$setValueIfPropertyExists(target, "enabled", options.enabled, options);
    $5b7ccabde48fae90$var$setValueIfPropertyExists(target, "stroke", options.stroke, options);
    $5b7ccabde48fae90$var$setValueIfPropertyExists(target, "strokeWidth", options.strokeWidth, options);
    $5b7ccabde48fae90$var$setValueIfPropertyExists(target, "lineDash", options.lineDash, options);
    $5b7ccabde48fae90$var$setValueIfPropertyExists(target, "lineCap", options.lineCap, options);
}
var $5b7ccabde48fae90$var$doOnceFlags = {};
function $5b7ccabde48fae90$var$doOnce(func, key) {
    if ($5b7ccabde48fae90$var$doOnceFlags[key]) return;
    func();
    $5b7ccabde48fae90$var$doOnceFlags[key] = true;
}
var $5b7ccabde48fae90$var$offsetValidator = (property, value, defaultOffset)=>{
    if ($5b7ccabde48fae90$var$isNumber4(value)) return true;
    const message = `AG Charts: ${property} must be a number, the value you provided is not a valid number. Using the default of ${defaultOffset}px.`;
    $5b7ccabde48fae90$var$doOnce(()=>console.warn(message), `${property} not a number`);
    return false;
};
var $5b7ccabde48fae90$var$validators = {
    xOffset: $5b7ccabde48fae90$var$offsetValidator,
    yOffset: $5b7ccabde48fae90$var$offsetValidator
};
function $5b7ccabde48fae90$var$setValueIfPropertyExists(target, property, value, options) {
    if (property in options) {
        if (property in target) {
            const validator = $5b7ccabde48fae90$var$validators[property];
            const isValid = validator ? validator(property, value, target[property]) : true;
            if (isValid && target[property] !== value) target[property] = value;
        } else console.warn(`Property ${property} does not exist on the target object.`);
    }
}
var $5b7ccabde48fae90$var$_SparklineCellRenderer = class _SparklineCellRenderer2 extends (0, $jIDNV.Component) {
    constructor(){
        super(_SparklineCellRenderer2.TEMPLATE);
    }
    init(params) {
        let firstTimeIn = true;
        const updateSparkline = ()=>{
            const { clientWidth: clientWidth, clientHeight: clientHeight } = this.getGui();
            if (clientWidth === 0 || clientHeight === 0) return;
            if (firstTimeIn) {
                const options = $5b7ccabde48fae90$var$__spreadValues13({
                    data: params.value,
                    width: clientWidth,
                    height: clientHeight,
                    context: {
                        data: params.data
                    }
                }, params.sparklineOptions);
                this.sparkline = $5b7ccabde48fae90$var$AgSparkline.create(options, this.sparklineTooltipSingleton.getSparklineTooltip());
                this.eSparkline.appendChild(this.sparkline.canvasElement);
                firstTimeIn = false;
            } else {
                this.sparkline.width = clientWidth;
                this.sparkline.height = clientHeight;
            }
        };
        const unsubscribeFromResize = this.resizeObserverService.observeResize(this.getGui(), updateSparkline);
        this.addDestroyFunc(()=>unsubscribeFromResize());
    }
    refresh(params) {
        if (this.sparkline) {
            this.sparkline.data = params.value;
            return true;
        }
        return false;
    }
    destroy() {
        if (this.sparkline) this.sparkline.destroy();
        super.destroy();
    }
};
$5b7ccabde48fae90$var$_SparklineCellRenderer.TEMPLATE = `<div class="ag-sparkline-wrapper">
            <span ref="eSparkline"></span>
        </div>`;
$5b7ccabde48fae90$var$__decorateClass16([
    (0, $jIDNV.RefSelector)("eSparkline")
], $5b7ccabde48fae90$var$_SparklineCellRenderer.prototype, "eSparkline", 2);
$5b7ccabde48fae90$var$__decorateClass16([
    (0, $jIDNV.Autowired)("resizeObserverService")
], $5b7ccabde48fae90$var$_SparklineCellRenderer.prototype, "resizeObserverService", 2);
$5b7ccabde48fae90$var$__decorateClass16([
    (0, $jIDNV.Autowired)("sparklineTooltipSingleton")
], $5b7ccabde48fae90$var$_SparklineCellRenderer.prototype, "sparklineTooltipSingleton", 2);
var $5b7ccabde48fae90$var$SparklineCellRenderer = $5b7ccabde48fae90$var$_SparklineCellRenderer;
var $5b7ccabde48fae90$var$SparklineTooltipSingleton = class extends (0, $jIDNV.BeanStub) {
    postConstruct() {
        this.tooltip = new $5b7ccabde48fae90$var$SparklineTooltip();
    }
    getSparklineTooltip() {
        return this.tooltip;
    }
    destroyTooltip() {
        if (this.tooltip) this.tooltip.destroy();
    }
};
$5b7ccabde48fae90$var$__decorateClass16([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$SparklineTooltipSingleton.prototype, "postConstruct", 1);
$5b7ccabde48fae90$var$__decorateClass16([
    (0, $jIDNV.PreDestroy)
], $5b7ccabde48fae90$var$SparklineTooltipSingleton.prototype, "destroyTooltip", 1);
$5b7ccabde48fae90$var$SparklineTooltipSingleton = $5b7ccabde48fae90$var$__decorateClass16([
    (0, $jIDNV.Bean)("sparklineTooltipSingleton")
], $5b7ccabde48fae90$var$SparklineTooltipSingleton);
var $5b7ccabde48fae90$var$VERSION17 = "31.3.4";
var $5b7ccabde48fae90$export$4e5a2f3bfb2b8795 = {
    version: $5b7ccabde48fae90$var$VERSION17,
    moduleName: (0, $jIDNV.ModuleNames).SparklinesModule,
    beans: [
        $5b7ccabde48fae90$var$SparklineTooltipSingleton
    ],
    userComponents: [
        {
            componentName: "agSparklineCellRenderer",
            componentClass: $5b7ccabde48fae90$var$SparklineCellRenderer
        }
    ],
    dependantModules: [
        $5b7ccabde48fae90$export$3a6d13add8617801
    ]
};
var $5b7ccabde48fae90$var$StatusBarService = class extends (0, $jIDNV.BeanStub) {
    // tslint:disable-next-line
    constructor(){
        super();
        this.allComponents = /* @__PURE__ */ new Map();
    }
    registerStatusPanel(key, component) {
        this.allComponents.set(key, component);
    }
    unregisterStatusPanel(key) {
        this.allComponents.delete(key);
    }
    unregisterAllComponents() {
        this.allComponents.clear();
    }
    getStatusPanel(key) {
        return this.allComponents.get(key);
    }
    destroy() {
        this.unregisterAllComponents();
        super.destroy();
    }
};
$5b7ccabde48fae90$var$StatusBarService = $5b7ccabde48fae90$var$__decorateClass([
    (0, $jIDNV.Bean)("statusBarService")
], $5b7ccabde48fae90$var$StatusBarService);
var $5b7ccabde48fae90$var$_StatusBar = class _StatusBar extends (0, $jIDNV.Component) {
    constructor(){
        super(_StatusBar.TEMPLATE);
        this.compDestroyFunctions = {};
    }
    postConstruct() {
        this.processStatusPanels(/* @__PURE__ */ new Map());
        this.addManagedPropertyListeners([
            "statusBar"
        ], this.handleStatusBarChanged.bind(this));
    }
    processStatusPanels(existingStatusPanelsToReuse) {
        var _a;
        const statusPanels = (_a = this.gos.get("statusBar")) == null ? void 0 : _a.statusPanels;
        if (statusPanels) {
            const leftStatusPanelComponents = statusPanels.filter((componentConfig)=>componentConfig.align === "left");
            this.createAndRenderComponents(leftStatusPanelComponents, this.eStatusBarLeft, existingStatusPanelsToReuse);
            const centerStatusPanelComponents = statusPanels.filter((componentConfig)=>componentConfig.align === "center");
            this.createAndRenderComponents(centerStatusPanelComponents, this.eStatusBarCenter, existingStatusPanelsToReuse);
            const rightStatusPanelComponents = statusPanels.filter((componentConfig)=>!componentConfig.align || componentConfig.align === "right");
            this.createAndRenderComponents(rightStatusPanelComponents, this.eStatusBarRight, existingStatusPanelsToReuse);
        } else this.setDisplayed(false);
    }
    handleStatusBarChanged() {
        var _a;
        const statusPanels = (_a = this.gos.get("statusBar")) == null ? void 0 : _a.statusPanels;
        const validStatusBarPanelsProvided = Array.isArray(statusPanels) && statusPanels.length > 0;
        this.setDisplayed(validStatusBarPanelsProvided);
        const existingStatusPanelsToReuse = /* @__PURE__ */ new Map();
        if (validStatusBarPanelsProvided) statusPanels.forEach((statusPanelConfig)=>{
            var _a2, _b;
            const key = (_a2 = statusPanelConfig.key) != null ? _a2 : statusPanelConfig.statusPanel;
            const existingStatusPanel = this.statusBarService.getStatusPanel(key);
            if (existingStatusPanel == null ? void 0 : existingStatusPanel.refresh) {
                const newParams = this.gos.addGridCommonParams((_b = statusPanelConfig.statusPanelParams) != null ? _b : {});
                const hasRefreshed = existingStatusPanel.refresh(newParams);
                if (hasRefreshed) {
                    existingStatusPanelsToReuse.set(key, existingStatusPanel);
                    delete this.compDestroyFunctions[key];
                    (0, $jIDNV._).removeFromParent(existingStatusPanel.getGui());
                }
            }
        });
        this.resetStatusBar();
        if (validStatusBarPanelsProvided) this.processStatusPanels(existingStatusPanelsToReuse);
    }
    resetStatusBar() {
        this.eStatusBarLeft.innerHTML = "";
        this.eStatusBarCenter.innerHTML = "";
        this.eStatusBarRight.innerHTML = "";
        this.destroyComponents();
        this.statusBarService.unregisterAllComponents();
    }
    destroyComponents() {
        Object.values(this.compDestroyFunctions).forEach((func)=>func());
        this.compDestroyFunctions = {};
    }
    createAndRenderComponents(statusBarComponents, ePanelComponent, existingStatusPanelsToReuse) {
        const componentDetails = [];
        statusBarComponents.forEach((componentConfig)=>{
            const key = componentConfig.key || componentConfig.statusPanel;
            const existingStatusPanel = existingStatusPanelsToReuse.get(key);
            let promise;
            if (existingStatusPanel) promise = (0, $jIDNV.AgPromise).resolve(existingStatusPanel);
            else {
                const params = {};
                const compDetails = this.userComponentFactory.getStatusPanelCompDetails(componentConfig, params);
                promise = compDetails.newAgStackInstance();
                if (!promise) return;
            }
            componentDetails.push({
                key: key,
                promise: promise
            });
        });
        (0, $jIDNV.AgPromise).all(componentDetails.map((details)=>details.promise)).then(()=>{
            componentDetails.forEach((componentDetail)=>{
                componentDetail.promise.then((component)=>{
                    const destroyFunc = ()=>{
                        this.getContext().destroyBean(component);
                    };
                    if (this.isAlive()) {
                        this.statusBarService.registerStatusPanel(componentDetail.key, component);
                        ePanelComponent.appendChild(component.getGui());
                        this.compDestroyFunctions[componentDetail.key] = destroyFunc;
                    } else destroyFunc();
                });
            });
        });
    }
};
$5b7ccabde48fae90$var$_StatusBar.TEMPLATE = /* html */ `<div class="ag-status-bar">
            <div ref="eStatusBarLeft" class="ag-status-bar-left" role="status"></div>
            <div ref="eStatusBarCenter" class="ag-status-bar-center" role="status"></div>
            <div ref="eStatusBarRight" class="ag-status-bar-right" role="status"></div>
        </div>`;
$5b7ccabde48fae90$var$__decorateClass([
    (0, $jIDNV.Autowired)("userComponentFactory")
], $5b7ccabde48fae90$var$_StatusBar.prototype, "userComponentFactory", 2);
$5b7ccabde48fae90$var$__decorateClass([
    (0, $jIDNV.Autowired)("statusBarService")
], $5b7ccabde48fae90$var$_StatusBar.prototype, "statusBarService", 2);
$5b7ccabde48fae90$var$__decorateClass([
    (0, $jIDNV.RefSelector)("eStatusBarLeft")
], $5b7ccabde48fae90$var$_StatusBar.prototype, "eStatusBarLeft", 2);
$5b7ccabde48fae90$var$__decorateClass([
    (0, $jIDNV.RefSelector)("eStatusBarCenter")
], $5b7ccabde48fae90$var$_StatusBar.prototype, "eStatusBarCenter", 2);
$5b7ccabde48fae90$var$__decorateClass([
    (0, $jIDNV.RefSelector)("eStatusBarRight")
], $5b7ccabde48fae90$var$_StatusBar.prototype, "eStatusBarRight", 2);
$5b7ccabde48fae90$var$__decorateClass([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_StatusBar.prototype, "postConstruct", 1);
$5b7ccabde48fae90$var$__decorateClass([
    (0, $jIDNV.PreDestroy)
], $5b7ccabde48fae90$var$_StatusBar.prototype, "destroyComponents", 1);
var $5b7ccabde48fae90$var$StatusBar = $5b7ccabde48fae90$var$_StatusBar;
var $5b7ccabde48fae90$var$_NameValueComp = class _NameValueComp extends (0, $jIDNV.Component) {
    constructor(){
        super(_NameValueComp.TEMPLATE);
    }
    setLabel(key, defaultValue) {
        this.setDisplayed(false);
        const localeTextFunc = this.localeService.getLocaleTextFunc();
        this.eLabel.innerHTML = localeTextFunc(key, defaultValue);
    }
    setValue(value) {
        this.eValue.innerHTML = value;
    }
};
$5b7ccabde48fae90$var$_NameValueComp.TEMPLATE = /* html */ `<div class="ag-status-name-value">
            <span ref="eLabel"></span>:&nbsp;
            <span ref="eValue" class="ag-status-name-value-value"></span>
        </div>`;
$5b7ccabde48fae90$var$__decorateClass([
    (0, $jIDNV.RefSelector)("eLabel")
], $5b7ccabde48fae90$var$_NameValueComp.prototype, "eLabel", 2);
$5b7ccabde48fae90$var$__decorateClass([
    (0, $jIDNV.RefSelector)("eValue")
], $5b7ccabde48fae90$var$_NameValueComp.prototype, "eValue", 2);
var $5b7ccabde48fae90$var$NameValueComp = $5b7ccabde48fae90$var$_NameValueComp;
var $5b7ccabde48fae90$var$TotalAndFilteredRowsComp = class extends $5b7ccabde48fae90$var$NameValueComp {
    postConstruct() {
        if (this.rowModel.getType() !== "clientSide") {
            (0, $jIDNV._).warnOnce(`agTotalAndFilteredRowCountComponent should only be used with the client side row model.`);
            return;
        }
        this.setLabel("totalAndFilteredRows", "Rows");
        this.addCssClass("ag-status-panel");
        this.addCssClass("ag-status-panel-total-and-filtered-row-count");
        this.setDisplayed(true);
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_MODEL_UPDATED, this.onDataChanged.bind(this));
        this.onDataChanged();
    }
    onDataChanged() {
        const localeTextFunc = this.localeService.getLocaleTextFunc();
        const thousandSeparator = localeTextFunc("thousandSeparator", ",");
        const decimalSeparator = localeTextFunc("decimalSeparator", ".");
        const rowCount = (0, $jIDNV._).formatNumberCommas(this.getFilteredRowCountValue(), thousandSeparator, decimalSeparator);
        const totalRowCount = (0, $jIDNV._).formatNumberCommas(this.getTotalRowCount(), thousandSeparator, decimalSeparator);
        if (rowCount === totalRowCount) this.setValue(rowCount);
        else {
            const localeTextFunc2 = this.localeService.getLocaleTextFunc();
            this.setValue(`${rowCount} ${localeTextFunc2("of", "of")} ${totalRowCount}`);
        }
    }
    getFilteredRowCountValue() {
        let filteredRowCount = 0;
        this.rowModel.forEachNodeAfterFilter((node)=>{
            if (!node.group) filteredRowCount++;
        });
        return filteredRowCount;
    }
    getTotalRowCount() {
        let totalRowCount = 0;
        this.rowModel.forEachNode((node)=>{
            if (!node.group) totalRowCount++;
        });
        return totalRowCount;
    }
    init() {}
    refresh() {
        return true;
    }
    // this is a user component, and IComponent has "public destroy()" as part of the interface.
    // so we need to override destroy() just to make the method public.
    destroy() {
        super.destroy();
    }
};
$5b7ccabde48fae90$var$__decorateClass([
    (0, $jIDNV.Autowired)("rowModel")
], $5b7ccabde48fae90$var$TotalAndFilteredRowsComp.prototype, "rowModel", 2);
$5b7ccabde48fae90$var$__decorateClass([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$TotalAndFilteredRowsComp.prototype, "postConstruct", 1);
var $5b7ccabde48fae90$var$FilteredRowsComp = class extends $5b7ccabde48fae90$var$NameValueComp {
    postConstruct() {
        this.setLabel("filteredRows", "Filtered");
        if (this.rowModel.getType() !== "clientSide") {
            (0, $jIDNV._).warnOnce(`agFilteredRowCountComponent should only be used with the client side row model.`);
            return;
        }
        this.addCssClass("ag-status-panel");
        this.addCssClass("ag-status-panel-filtered-row-count");
        this.setDisplayed(true);
        const listener = this.onDataChanged.bind(this);
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_MODEL_UPDATED, listener);
        listener();
    }
    onDataChanged() {
        const totalRowCountValue = this.getTotalRowCountValue();
        const filteredRowCountValue = this.getFilteredRowCountValue();
        const localeTextFunc = this.localeService.getLocaleTextFunc();
        const thousandSeparator = localeTextFunc("thousandSeparator", ",");
        const decimalSeparator = localeTextFunc("decimalSeparator", ".");
        this.setValue((0, $jIDNV._).formatNumberCommas(filteredRowCountValue, thousandSeparator, decimalSeparator));
        this.setDisplayed(totalRowCountValue !== filteredRowCountValue);
    }
    getTotalRowCountValue() {
        let totalRowCount = 0;
        this.rowModel.forEachNode((node)=>totalRowCount += 1);
        return totalRowCount;
    }
    getFilteredRowCountValue() {
        let filteredRowCount = 0;
        this.rowModel.forEachNodeAfterFilter((node)=>{
            if (!node.group) filteredRowCount += 1;
        });
        return filteredRowCount;
    }
    init() {}
    refresh() {
        return true;
    }
    // this is a user component, and IComponent has "public destroy()" as part of the interface.
    // so we need to override destroy() just to make the method public.
    destroy() {
        super.destroy();
    }
};
$5b7ccabde48fae90$var$__decorateClass([
    (0, $jIDNV.Autowired)("rowModel")
], $5b7ccabde48fae90$var$FilteredRowsComp.prototype, "rowModel", 2);
$5b7ccabde48fae90$var$__decorateClass([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$FilteredRowsComp.prototype, "postConstruct", 1);
var $5b7ccabde48fae90$var$TotalRowsComp = class extends $5b7ccabde48fae90$var$NameValueComp {
    postConstruct() {
        this.setLabel("totalRows", "Total Rows");
        if (this.rowModel.getType() !== "clientSide") {
            (0, $jIDNV._).warnOnce("agTotalRowCountComponent should only be used with the client side row model.");
            return;
        }
        this.addCssClass("ag-status-panel");
        this.addCssClass("ag-status-panel-total-row-count");
        this.setDisplayed(true);
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_MODEL_UPDATED, this.onDataChanged.bind(this));
        this.onDataChanged();
    }
    onDataChanged() {
        const localeTextFunc = this.localeService.getLocaleTextFunc();
        const thousandSeparator = localeTextFunc("thousandSeparator", ",");
        const decimalSeparator = localeTextFunc("decimalSeparator", ".");
        this.setValue((0, $jIDNV._).formatNumberCommas(this.getRowCountValue(), thousandSeparator, decimalSeparator));
    }
    getRowCountValue() {
        let totalRowCount = 0;
        this.rowModel.forEachLeafNode((node)=>totalRowCount += 1);
        return totalRowCount;
    }
    init() {}
    refresh() {
        return true;
    }
    // this is a user component, and IComponent has "public destroy()" as part of the interface.
    // so we need to override destroy() just to make the method public.
    destroy() {
        super.destroy();
    }
};
$5b7ccabde48fae90$var$__decorateClass([
    (0, $jIDNV.Autowired)("rowModel")
], $5b7ccabde48fae90$var$TotalRowsComp.prototype, "rowModel", 2);
$5b7ccabde48fae90$var$__decorateClass([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$TotalRowsComp.prototype, "postConstruct", 1);
var $5b7ccabde48fae90$var$SelectedRowsComp = class extends $5b7ccabde48fae90$var$NameValueComp {
    postConstruct() {
        if (!this.isValidRowModel()) {
            console.warn(`AG Grid: agSelectedRowCountComponent should only be used with the client and server side row model.`);
            return;
        }
        this.setLabel("selectedRows", "Selected");
        this.addCssClass("ag-status-panel");
        this.addCssClass("ag-status-panel-selected-row-count");
        this.onRowSelectionChanged();
        const eventListener = this.onRowSelectionChanged.bind(this);
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_MODEL_UPDATED, eventListener);
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_SELECTION_CHANGED, eventListener);
    }
    isValidRowModel() {
        const rowModelType = this.rowModel.getType();
        return rowModelType === "clientSide" || rowModelType === "serverSide";
    }
    onRowSelectionChanged() {
        const selectedRowCount = this.selectionService.getSelectionCount();
        if (selectedRowCount < 0) {
            this.setValue("?");
            this.setDisplayed(true);
            return;
        }
        const localeTextFunc = this.localeService.getLocaleTextFunc();
        const thousandSeparator = localeTextFunc("thousandSeparator", ",");
        const decimalSeparator = localeTextFunc("decimalSeparator", ".");
        this.setValue((0, $jIDNV._).formatNumberCommas(selectedRowCount, thousandSeparator, decimalSeparator));
        this.setDisplayed(selectedRowCount > 0);
    }
    init() {}
    refresh() {
        return true;
    }
    // this is a user component, and IComponent has "public destroy()" as part of the interface.
    // so we need to override destroy() just to make the method public.
    destroy() {
        super.destroy();
    }
};
$5b7ccabde48fae90$var$__decorateClass([
    (0, $jIDNV.Autowired)("rowModel")
], $5b7ccabde48fae90$var$SelectedRowsComp.prototype, "rowModel", 2);
$5b7ccabde48fae90$var$__decorateClass([
    (0, $jIDNV.Autowired)("selectionService")
], $5b7ccabde48fae90$var$SelectedRowsComp.prototype, "selectionService", 2);
$5b7ccabde48fae90$var$__decorateClass([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$SelectedRowsComp.prototype, "postConstruct", 1);
var $5b7ccabde48fae90$var$_AggregationComp = class _AggregationComp extends (0, $jIDNV.Component) {
    constructor(){
        super(_AggregationComp.TEMPLATE);
    }
    // this is a user component, and IComponent has "public destroy()" as part of the interface.
    // so we need to override destroy() just to make the method public.
    destroy() {
        super.destroy();
    }
    postConstruct() {
        if (!this.isValidRowModel()) {
            console.warn(`AG Grid: agAggregationComponent should only be used with the client and server side row model.`);
            return;
        }
        this.avgAggregationComp.setLabel("avg", "Average");
        this.countAggregationComp.setLabel("count", "Count");
        this.minAggregationComp.setLabel("min", "Min");
        this.maxAggregationComp.setLabel("max", "Max");
        this.sumAggregationComp.setLabel("sum", "Sum");
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_RANGE_SELECTION_CHANGED, this.onRangeSelectionChanged.bind(this));
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_MODEL_UPDATED, this.onRangeSelectionChanged.bind(this));
    }
    isValidRowModel() {
        const rowModelType = this.rowModel.getType();
        return rowModelType === "clientSide" || rowModelType === "serverSide";
    }
    init(params) {
        this.params = params;
    }
    refresh(params) {
        this.params = params;
        this.onRangeSelectionChanged();
        return true;
    }
    setAggregationComponentValue(aggFuncName, value, visible) {
        var _a;
        const statusBarValueComponent = this.getAllowedAggregationValueComponent(aggFuncName);
        if ((0, $jIDNV._).exists(statusBarValueComponent) && statusBarValueComponent) {
            const localeTextFunc = this.localeService.getLocaleTextFunc();
            const thousandSeparator = localeTextFunc("thousandSeparator", ",");
            const decimalSeparator = localeTextFunc("decimalSeparator", ".");
            statusBarValueComponent.setValue((0, $jIDNV._).formatNumberTwoDecimalPlacesAndCommas(value, thousandSeparator, decimalSeparator));
            statusBarValueComponent.setDisplayed(visible);
        } else (_a = this.getAggregationValueComponent(aggFuncName)) == null || _a.setDisplayed(false);
    }
    getAllowedAggregationValueComponent(aggFuncName) {
        const { aggFuncs: aggFuncs } = this.params;
        if (!aggFuncs || aggFuncs.includes(aggFuncName)) return this.getAggregationValueComponent(aggFuncName);
        return null;
    }
    getAggregationValueComponent(aggFuncName) {
        const refComponentName = `${aggFuncName}AggregationComp`;
        return this[refComponentName];
    }
    onRangeSelectionChanged() {
        var _a;
        const cellRanges = (_a = this.rangeService) == null ? void 0 : _a.getCellRanges();
        let sum = 0;
        let count = 0;
        let numberCount = 0;
        let min = null;
        let max = null;
        const cellsSoFar = {};
        if (cellRanges && !(0, $jIDNV._).missingOrEmpty(cellRanges) && this.rangeService) for(let i = 0; i < cellRanges.length; i++){
            const cellRange = cellRanges[i];
            let currentRow = this.rangeService.getRangeStartRow(cellRange);
            const lastRow = this.rangeService.getRangeEndRow(cellRange);
            while(true){
                const finishedAllRows = (0, $jIDNV._).missing(currentRow) || !currentRow || this.rowPositionUtils.before(lastRow, currentRow);
                if (finishedAllRows || !currentRow || !cellRange.columns) break;
                cellRange.columns.forEach((col)=>{
                    if (currentRow === null) return;
                    const cellId = this.cellPositionUtils.createId({
                        rowPinned: currentRow.rowPinned,
                        column: col,
                        rowIndex: currentRow.rowIndex
                    });
                    if (cellsSoFar[cellId]) return;
                    cellsSoFar[cellId] = true;
                    const rowNode = this.rowPositionUtils.getRowNode(currentRow);
                    if ((0, $jIDNV._).missing(rowNode)) return;
                    let value = this.valueService.getValue(col, rowNode);
                    if ((0, $jIDNV._).missing(value) || value === "") return;
                    count++;
                    if (typeof value === "object" && "value" in value) {
                        value = value.value;
                        if (value === "") return;
                    }
                    if (typeof value === "string") value = Number(value);
                    if (typeof value === "number" && !isNaN(value)) {
                        sum += value;
                        if (max === null || value > max) max = value;
                        if (min === null || value < min) min = value;
                        numberCount++;
                    }
                });
                currentRow = this.cellNavigationService.getRowBelow(currentRow);
            }
        }
        const gotResult = count > 1;
        const gotNumberResult = numberCount > 1;
        this.setAggregationComponentValue("count", count, gotResult);
        this.setAggregationComponentValue("sum", sum, gotNumberResult);
        this.setAggregationComponentValue("min", min, gotNumberResult);
        this.setAggregationComponentValue("max", max, gotNumberResult);
        this.setAggregationComponentValue("avg", sum / numberCount, gotNumberResult);
    }
};
$5b7ccabde48fae90$var$_AggregationComp.TEMPLATE = /* html */ `<div class="ag-status-panel ag-status-panel-aggregations">
            <ag-name-value ref="avgAggregationComp"></ag-name-value>
            <ag-name-value ref="countAggregationComp"></ag-name-value>
            <ag-name-value ref="minAggregationComp"></ag-name-value>
            <ag-name-value ref="maxAggregationComp"></ag-name-value>
            <ag-name-value ref="sumAggregationComp"></ag-name-value>
        </div>`;
$5b7ccabde48fae90$var$__decorateClass([
    (0, $jIDNV.Optional)("rangeService")
], $5b7ccabde48fae90$var$_AggregationComp.prototype, "rangeService", 2);
$5b7ccabde48fae90$var$__decorateClass([
    (0, $jIDNV.Autowired)("valueService")
], $5b7ccabde48fae90$var$_AggregationComp.prototype, "valueService", 2);
$5b7ccabde48fae90$var$__decorateClass([
    (0, $jIDNV.Autowired)("cellNavigationService")
], $5b7ccabde48fae90$var$_AggregationComp.prototype, "cellNavigationService", 2);
$5b7ccabde48fae90$var$__decorateClass([
    (0, $jIDNV.Autowired)("rowModel")
], $5b7ccabde48fae90$var$_AggregationComp.prototype, "rowModel", 2);
$5b7ccabde48fae90$var$__decorateClass([
    (0, $jIDNV.Autowired)("cellPositionUtils")
], $5b7ccabde48fae90$var$_AggregationComp.prototype, "cellPositionUtils", 2);
$5b7ccabde48fae90$var$__decorateClass([
    (0, $jIDNV.Autowired)("rowPositionUtils")
], $5b7ccabde48fae90$var$_AggregationComp.prototype, "rowPositionUtils", 2);
$5b7ccabde48fae90$var$__decorateClass([
    (0, $jIDNV.RefSelector)("sumAggregationComp")
], $5b7ccabde48fae90$var$_AggregationComp.prototype, "sumAggregationComp", 2);
$5b7ccabde48fae90$var$__decorateClass([
    (0, $jIDNV.RefSelector)("countAggregationComp")
], $5b7ccabde48fae90$var$_AggregationComp.prototype, "countAggregationComp", 2);
$5b7ccabde48fae90$var$__decorateClass([
    (0, $jIDNV.RefSelector)("minAggregationComp")
], $5b7ccabde48fae90$var$_AggregationComp.prototype, "minAggregationComp", 2);
$5b7ccabde48fae90$var$__decorateClass([
    (0, $jIDNV.RefSelector)("maxAggregationComp")
], $5b7ccabde48fae90$var$_AggregationComp.prototype, "maxAggregationComp", 2);
$5b7ccabde48fae90$var$__decorateClass([
    (0, $jIDNV.RefSelector)("avgAggregationComp")
], $5b7ccabde48fae90$var$_AggregationComp.prototype, "avgAggregationComp", 2);
$5b7ccabde48fae90$var$__decorateClass([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$_AggregationComp.prototype, "postConstruct", 1);
var $5b7ccabde48fae90$var$AggregationComp = $5b7ccabde48fae90$var$_AggregationComp;
// enterprise-modules/status-bar/src/version.ts
var $5b7ccabde48fae90$var$VERSION18 = "31.3.4";
// enterprise-modules/status-bar/src/statusBarModule.ts
var $5b7ccabde48fae90$export$76a316c8c2f3bc28 = {
    version: $5b7ccabde48fae90$var$VERSION18,
    moduleName: (0, $jIDNV.ModuleNames).StatusBarModule,
    beans: [
        $5b7ccabde48fae90$var$StatusBarService
    ],
    agStackComponents: [
        {
            componentName: "AgStatusBar",
            componentClass: $5b7ccabde48fae90$var$StatusBar
        },
        {
            componentName: "AgNameValue",
            componentClass: $5b7ccabde48fae90$var$NameValueComp
        }
    ],
    userComponents: [
        {
            componentName: "agAggregationComponent",
            componentClass: $5b7ccabde48fae90$var$AggregationComp
        },
        {
            componentName: "agSelectedRowCountComponent",
            componentClass: $5b7ccabde48fae90$var$SelectedRowsComp
        },
        {
            componentName: "agTotalRowCountComponent",
            componentClass: $5b7ccabde48fae90$var$TotalRowsComp
        },
        {
            componentName: "agFilteredRowCountComponent",
            componentClass: $5b7ccabde48fae90$var$FilteredRowsComp
        },
        {
            componentName: "agTotalAndFilteredRowCountComponent",
            componentClass: $5b7ccabde48fae90$var$TotalAndFilteredRowsComp
        }
    ],
    dependantModules: [
        $5b7ccabde48fae90$export$3a6d13add8617801
    ]
};
var $5b7ccabde48fae90$var$__defProp17 = Object.defineProperty;
var $5b7ccabde48fae90$var$__getOwnPropDesc17 = Object.getOwnPropertyDescriptor;
var $5b7ccabde48fae90$var$__decorateClass17 = (decorators, target, key, kind)=>{
    var result = kind > 1 ? void 0 : kind ? $5b7ccabde48fae90$var$__getOwnPropDesc17(target, key) : target;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
    if (kind && result) $5b7ccabde48fae90$var$__defProp17(target, key, result);
    return result;
};
var $5b7ccabde48fae90$var$VERSION19 = "31.3.4";
var $5b7ccabde48fae90$var$ViewportRowModel = class extends (0, $jIDNV.BeanStub) {
    constructor(){
        super(...arguments);
        this.firstRow = -1;
        this.lastRow = -1;
        this.rowCount = -1;
        this.rowNodesByIndex = {};
    }
    // we don't implement as lazy row heights is not supported in this row model
    ensureRowHeightsValid(startPixel, endPixel, startLimitIndex, endLimitIndex) {
        return false;
    }
    init() {
        this.rowHeight = this.gos.getRowHeightAsNumber();
        this.addManagedListener(this.eventService, (0, $jIDNV.Events).EVENT_VIEWPORT_CHANGED, this.onViewportChanged.bind(this));
        this.addManagedPropertyListener("viewportDatasource", ()=>this.updateDatasource());
        this.addManagedPropertyListener("rowHeight", ()=>{
            this.rowHeight = this.gos.getRowHeightAsNumber();
            this.updateRowHeights();
        });
    }
    start() {
        this.updateDatasource();
    }
    isLastRowIndexKnown() {
        return true;
    }
    destroyDatasource() {
        if (!this.viewportDatasource) return;
        if (this.viewportDatasource.destroy) this.viewportDatasource.destroy();
        this.rowRenderer.datasourceChanged();
        this.firstRow = -1;
        this.lastRow = -1;
    }
    updateDatasource() {
        const datasource = this.gos.get("viewportDatasource");
        if (datasource) this.setViewportDatasource(datasource);
    }
    getViewportRowModelPageSize() {
        return this.gos.get("viewportRowModelPageSize");
    }
    getViewportRowModelBufferSize() {
        return this.gos.get("viewportRowModelBufferSize");
    }
    calculateFirstRow(firstRenderedRow) {
        const bufferSize = this.getViewportRowModelBufferSize();
        const pageSize = this.getViewportRowModelPageSize();
        const afterBuffer = firstRenderedRow - bufferSize;
        if (afterBuffer < 0) return 0;
        return Math.floor(afterBuffer / pageSize) * pageSize;
    }
    calculateLastRow(lastRenderedRow) {
        if (lastRenderedRow === -1) return lastRenderedRow;
        const bufferSize = this.getViewportRowModelBufferSize();
        const pageSize = this.getViewportRowModelPageSize();
        const afterBuffer = lastRenderedRow + bufferSize;
        const result = Math.ceil(afterBuffer / pageSize) * pageSize;
        const lastRowIndex = this.rowCount - 1;
        return Math.min(result, lastRowIndex);
    }
    onViewportChanged(event) {
        const newFirst = this.calculateFirstRow(event.firstRow);
        const newLast = this.calculateLastRow(event.lastRow);
        if (this.firstRow !== newFirst || this.lastRow !== newLast) {
            this.firstRow = newFirst;
            this.lastRow = newLast;
            this.purgeRowsNotInViewport();
            if (this.viewportDatasource) this.viewportDatasource.setViewportRange(this.firstRow, this.lastRow);
        }
    }
    purgeRowsNotInViewport() {
        Object.keys(this.rowNodesByIndex).forEach((indexStr)=>{
            const index = parseInt(indexStr, 10);
            if (index < this.firstRow || index > this.lastRow) {
                if (this.isRowFocused(index)) return;
                delete this.rowNodesByIndex[index];
            }
        });
    }
    isRowFocused(rowIndex) {
        const focusedCell = this.focusService.getFocusCellToUseAfterRefresh();
        if (!focusedCell) return false;
        if (focusedCell.rowPinned != null) return false;
        const hasFocus = focusedCell.rowIndex === rowIndex;
        return hasFocus;
    }
    setViewportDatasource(viewportDatasource) {
        this.destroyDatasource();
        this.viewportDatasource = viewportDatasource;
        this.rowCount = -1;
        if (!viewportDatasource.init) console.warn("AG Grid: viewport is missing init method.");
        else viewportDatasource.init({
            setRowCount: this.setRowCount.bind(this),
            setRowData: this.setRowData.bind(this),
            getRow: this.getRow.bind(this)
        });
    }
    getType() {
        return "viewport";
    }
    getRow(rowIndex) {
        if (!this.rowNodesByIndex[rowIndex]) this.rowNodesByIndex[rowIndex] = this.createBlankRowNode(rowIndex);
        return this.rowNodesByIndex[rowIndex];
    }
    getRowNode(id) {
        let result;
        this.forEachNode((rowNode)=>{
            if (rowNode.id === id) result = rowNode;
        });
        return result;
    }
    getRowCount() {
        return this.rowCount === -1 ? 0 : this.rowCount;
    }
    getRowIndexAtPixel(pixel) {
        if (this.rowHeight !== 0) return Math.floor(pixel / this.rowHeight);
        return 0;
    }
    getRowBounds(index) {
        return {
            rowHeight: this.rowHeight,
            rowTop: this.rowHeight * index
        };
    }
    updateRowHeights() {
        this.forEachNode((node)=>{
            node.setRowHeight(this.rowHeight);
            node.setRowTop(this.rowHeight * node.rowIndex);
        });
        const event = {
            type: (0, $jIDNV.Events).EVENT_MODEL_UPDATED,
            newData: false,
            newPage: false,
            keepRenderedRows: true,
            animate: false
        };
        this.eventService.dispatchEvent(event);
    }
    getTopLevelRowCount() {
        return this.getRowCount();
    }
    getTopLevelRowDisplayedIndex(topLevelIndex) {
        return topLevelIndex;
    }
    isEmpty() {
        return this.rowCount > 0;
    }
    isRowsToRender() {
        return this.rowCount > 0;
    }
    getNodesInRangeForSelection(firstInRange, lastInRange) {
        const firstIndex = (0, $jIDNV._).missing(firstInRange) ? 0 : firstInRange.rowIndex;
        const lastIndex = lastInRange.rowIndex;
        const firstNodeOutOfRange = firstIndex < this.firstRow || firstIndex > this.lastRow;
        const lastNodeOutOfRange = lastIndex < this.firstRow || lastIndex > this.lastRow;
        if (firstNodeOutOfRange || lastNodeOutOfRange) return [];
        const result = [];
        const startIndex = firstIndex <= lastIndex ? firstIndex : lastIndex;
        const endIndex = firstIndex <= lastIndex ? lastIndex : firstIndex;
        for(let i = startIndex; i <= endIndex; i++)result.push(this.rowNodesByIndex[i]);
        return result;
    }
    forEachNode(callback) {
        let callbackCount = 0;
        Object.keys(this.rowNodesByIndex).forEach((indexStr)=>{
            const index = parseInt(indexStr, 10);
            const rowNode = this.rowNodesByIndex[index];
            callback(rowNode, callbackCount);
            callbackCount++;
        });
    }
    setRowData(rowData) {
        (0, $jIDNV._).iterateObject(rowData, (indexStr, dataItem)=>{
            const index = parseInt(indexStr, 10);
            if (index >= this.firstRow && index <= this.lastRow) {
                let rowNode = this.rowNodesByIndex[index];
                if ((0, $jIDNV._).missing(rowNode)) {
                    rowNode = this.createBlankRowNode(index);
                    this.rowNodesByIndex[index] = rowNode;
                }
                rowNode.setDataAndId(dataItem, index.toString());
            }
        });
    }
    createBlankRowNode(rowIndex) {
        const rowNode = new (0, $jIDNV.RowNode)(this.beans);
        rowNode.setRowHeight(this.rowHeight);
        rowNode.setRowTop(this.rowHeight * rowIndex);
        rowNode.setRowIndex(rowIndex);
        return rowNode;
    }
    setRowCount(rowCount, keepRenderedRows = false) {
        if (rowCount === this.rowCount) return;
        this.rowCount = rowCount;
        this.eventService.dispatchEventOnce({
            type: (0, $jIDNV.Events).EVENT_ROW_COUNT_READY
        });
        const event = {
            type: (0, $jIDNV.Events).EVENT_MODEL_UPDATED,
            newData: false,
            newPage: false,
            keepRenderedRows: keepRenderedRows,
            animate: false
        };
        this.eventService.dispatchEvent(event);
    }
    isRowPresent(rowNode) {
        const foundRowNode = this.getRowNode(rowNode.id);
        return !!foundRowNode;
    }
};
$5b7ccabde48fae90$var$__decorateClass17([
    (0, $jIDNV.Autowired)("rowRenderer")
], $5b7ccabde48fae90$var$ViewportRowModel.prototype, "rowRenderer", 2);
$5b7ccabde48fae90$var$__decorateClass17([
    (0, $jIDNV.Autowired)("focusService")
], $5b7ccabde48fae90$var$ViewportRowModel.prototype, "focusService", 2);
$5b7ccabde48fae90$var$__decorateClass17([
    (0, $jIDNV.Autowired)("beans")
], $5b7ccabde48fae90$var$ViewportRowModel.prototype, "beans", 2);
$5b7ccabde48fae90$var$__decorateClass17([
    (0, $jIDNV.PostConstruct)
], $5b7ccabde48fae90$var$ViewportRowModel.prototype, "init", 1);
$5b7ccabde48fae90$var$__decorateClass17([
    (0, $jIDNV.PreDestroy)
], $5b7ccabde48fae90$var$ViewportRowModel.prototype, "destroyDatasource", 1);
$5b7ccabde48fae90$var$ViewportRowModel = $5b7ccabde48fae90$var$__decorateClass17([
    (0, $jIDNV.Bean)("rowModel")
], $5b7ccabde48fae90$var$ViewportRowModel);
var $5b7ccabde48fae90$export$5afa3276c0fcf76 = {
    version: $5b7ccabde48fae90$var$VERSION19,
    moduleName: (0, $jIDNV.ModuleNames).ViewportRowModelModule,
    rowModel: "viewport",
    beans: [
        $5b7ccabde48fae90$var$ViewportRowModel
    ],
    dependantModules: [
        $5b7ccabde48fae90$export$3a6d13add8617801
    ]
};
// packages/ag-grid-enterprise/src/main.ts
$5b7ccabde48fae90$var$__reExport($5b7ccabde48fae90$var$main_exports, $5b7ccabde48fae90$var$main_esm_exports);
(0, $jIDNV.ModuleRegistry).__registerModules([
    (0, $jIDNV.ClientSideRowModelModule),
    (0, $jIDNV.InfiniteRowModelModule),
    (0, $jIDNV.CsvExportModule),
    $5b7ccabde48fae90$export$5f40a5e44930bd02,
    $5b7ccabde48fae90$export$6248c9e5743f8c49,
    $5b7ccabde48fae90$export$3a36bd45ca02edda,
    $5b7ccabde48fae90$export$8ff0dc87b3f8200e,
    $5b7ccabde48fae90$export$98f0c53ca0379def,
    $5b7ccabde48fae90$export$783953a68616c0a2,
    $5b7ccabde48fae90$export$656cedc46227f6d2,
    $5b7ccabde48fae90$export$f1ab43fc4c3c5ce0,
    $5b7ccabde48fae90$export$8897e17f4dd9d13a,
    $5b7ccabde48fae90$export$5e5c8269d4d7ed2e,
    $5b7ccabde48fae90$export$9bd93207561bb9c,
    $5b7ccabde48fae90$export$e67935bd41653107,
    $5b7ccabde48fae90$export$5c0e9f044c5e2dce,
    $5b7ccabde48fae90$export$4ab172eba3fdda9e,
    $5b7ccabde48fae90$export$707a9bd30915b7fe,
    $5b7ccabde48fae90$export$4e5a2f3bfb2b8795,
    $5b7ccabde48fae90$export$76a316c8c2f3bc28,
    $5b7ccabde48fae90$export$5afa3276c0fcf76
], false, void 0);

});
parcelRegister("jIDNV", function(module, exports) {

$parcel$export(module.exports, "ColumnKeyCreator", () => $437b23f6a393c3bf$export$f67d1427302c96a3);
$parcel$export(module.exports, "ModuleNames", () => $437b23f6a393c3bf$export$7014c4aa9a91d0eb);
$parcel$export(module.exports, "ModuleRegistry", () => $437b23f6a393c3bf$export$dc053975cc7f6c11);
$parcel$export(module.exports, "Context", () => $437b23f6a393c3bf$export$841858b892ce1f4c);
$parcel$export(module.exports, "PreConstruct", () => $437b23f6a393c3bf$export$e99736521cbcf94e);
$parcel$export(module.exports, "PostConstruct", () => $437b23f6a393c3bf$export$e7d0339d3610248e);
$parcel$export(module.exports, "PreDestroy", () => $437b23f6a393c3bf$export$cc3f3d4529c57d95);
$parcel$export(module.exports, "Bean", () => $437b23f6a393c3bf$export$24f477b6454bfaa9);
$parcel$export(module.exports, "Autowired", () => $437b23f6a393c3bf$export$4bf29303185cb747);
$parcel$export(module.exports, "Optional", () => $437b23f6a393c3bf$export$7acb7b24c478f9c6);
$parcel$export(module.exports, "Qualifier", () => $437b23f6a393c3bf$export$c3215dfb7fd4803b);
$parcel$export(module.exports, "EventService", () => $437b23f6a393c3bf$export$895d7dc49f082ca1);
$parcel$export(module.exports, "Column", () => $437b23f6a393c3bf$export$816b5d811295e6bc);
$parcel$export(module.exports, "ProvidedColumnGroup", () => $437b23f6a393c3bf$export$89dd394cd2c9e921);
$parcel$export(module.exports, "BeanStub", () => $437b23f6a393c3bf$export$2032c8ef3788dfbd);
$parcel$export(module.exports, "ColumnFactory", () => $437b23f6a393c3bf$export$a988f568cf9d5725);
$parcel$export(module.exports, "ColumnGroup", () => $437b23f6a393c3bf$export$8a8fbc71323f074);
$parcel$export(module.exports, "Events", () => $437b23f6a393c3bf$export$ada873a34909da65);
$parcel$export(module.exports, "ALWAYS_SYNC_GLOBAL_EVENTS", () => $437b23f6a393c3bf$export$12e4e9a3cbd0ec07);
$parcel$export(module.exports, "GroupInstanceIdCreator", () => $437b23f6a393c3bf$export$b3b24737a74261fb);
$parcel$export(module.exports, "GROUP_AUTO_COLUMN_ID", () => $437b23f6a393c3bf$export$a7016588c430dba6);
$parcel$export(module.exports, "ColumnModel", () => $437b23f6a393c3bf$export$c9dec256e4c9f340);
$parcel$export(module.exports, "DisplayedGroupCreator", () => $437b23f6a393c3bf$export$de11801d74224ab);
$parcel$export(module.exports, "PropertyKeys", () => $437b23f6a393c3bf$export$4d1a0127671c9c1f);
$parcel$export(module.exports, "ComponentUtil", () => $437b23f6a393c3bf$export$1f1b72b628161f7c);
$parcel$export(module.exports, "AgStackComponentsRegistry", () => $437b23f6a393c3bf$export$7d237966671a050f);
$parcel$export(module.exports, "KeyCode", () => $437b23f6a393c3bf$export$e9e0d96f49f57c33);
$parcel$export(module.exports, "_", () => $437b23f6a393c3bf$export$71511d61b312f219);
$parcel$export(module.exports, "NumberSequence", () => $437b23f6a393c3bf$export$9bbf3cc62ef6fcad);
$parcel$export(module.exports, "AgPromiseStatus", () => $437b23f6a393c3bf$export$2245a02c19383694);
$parcel$export(module.exports, "AgPromise", () => $437b23f6a393c3bf$export$30ec7836a4847721);
$parcel$export(module.exports, "Timer", () => $437b23f6a393c3bf$export$c57e9b2d8b9e4de);
$parcel$export(module.exports, "CssClassManager", () => $437b23f6a393c3bf$export$a7053cb7eb605bd2);
$parcel$export(module.exports, "TooltipStateManager", () => $437b23f6a393c3bf$export$e3d1279ac5e83a0);
$parcel$export(module.exports, "TooltipFeature", () => $437b23f6a393c3bf$export$e5073a590d24815c);
$parcel$export(module.exports, "Component", () => $437b23f6a393c3bf$export$16fa2f45be04daa8);
$parcel$export(module.exports, "QuerySelector", () => $437b23f6a393c3bf$export$fe9de06a57e74a75);
$parcel$export(module.exports, "RefSelector", () => $437b23f6a393c3bf$export$8a4e90ba380c343c);
$parcel$export(module.exports, "ManagedFocusFeature", () => $437b23f6a393c3bf$export$5510e53ed3962582);
$parcel$export(module.exports, "PositionableFeature", () => $437b23f6a393c3bf$export$c53a5d9f1fb0f7f6);
$parcel$export(module.exports, "ProvidedFilter", () => $437b23f6a393c3bf$export$a927a1327c2cc7f0);
$parcel$export(module.exports, "AgAbstractLabel", () => $437b23f6a393c3bf$export$d72ea6e1c340e03b);
$parcel$export(module.exports, "AgAbstractField", () => $437b23f6a393c3bf$export$8889445e1e1d2c89);
$parcel$export(module.exports, "AgPickerField", () => $437b23f6a393c3bf$export$1f14489b6fdeb99b);
$parcel$export(module.exports, "AgSelect", () => $437b23f6a393c3bf$export$6f9c460854d56032);
$parcel$export(module.exports, "AgCheckbox", () => $437b23f6a393c3bf$export$b00c508c1ae18d07);
$parcel$export(module.exports, "AgRadioButton", () => $437b23f6a393c3bf$export$5caa9ea96bbb722);
$parcel$export(module.exports, "SimpleFilter", () => $437b23f6a393c3bf$export$f5377e6e4a0f88ed);
$parcel$export(module.exports, "ScalarFilter", () => $437b23f6a393c3bf$export$804d9bd153e864e6);
$parcel$export(module.exports, "DateFilter", () => $437b23f6a393c3bf$export$45c1765a9388d778);
$parcel$export(module.exports, "AgInputTextField", () => $437b23f6a393c3bf$export$8c027679838afd47);
$parcel$export(module.exports, "AgInputNumberField", () => $437b23f6a393c3bf$export$c8aa0be99738aee);
$parcel$export(module.exports, "NumberFilter", () => $437b23f6a393c3bf$export$db99a591a1ce9821);
$parcel$export(module.exports, "TextFilter", () => $437b23f6a393c3bf$export$bf4978b2dd458630);
$parcel$export(module.exports, "TextFloatingFilter", () => $437b23f6a393c3bf$export$f856d88991b6b7f9);
$parcel$export(module.exports, "TouchListener", () => $437b23f6a393c3bf$export$7b2e93987414b382);
$parcel$export(module.exports, "SortIndicatorComp", () => $437b23f6a393c3bf$export$220e9505c6bd76f6);
$parcel$export(module.exports, "PopupComponent", () => $437b23f6a393c3bf$export$9fac2d040f3ed438);
$parcel$export(module.exports, "LargeTextCellEditor", () => $437b23f6a393c3bf$export$98890d6e078b4910);
$parcel$export(module.exports, "SelectCellEditor", () => $437b23f6a393c3bf$export$638f87cb94a2e5dc);
$parcel$export(module.exports, "TextCellEditor", () => $437b23f6a393c3bf$export$6e94bf0a822a6a81);
$parcel$export(module.exports, "AnimateShowChangeCellRenderer", () => $437b23f6a393c3bf$export$6f4a45bae925df69);
$parcel$export(module.exports, "AnimateSlideCellRenderer", () => $437b23f6a393c3bf$export$3915b8b8c907c2a);
$parcel$export(module.exports, "RowNode", () => $437b23f6a393c3bf$export$6af91cd58ec2edf9);
$parcel$export(module.exports, "CheckboxSelectionComponent", () => $437b23f6a393c3bf$export$b54c7a6db4674fde);
$parcel$export(module.exports, "VerticalDirection", () => $437b23f6a393c3bf$export$b40429d5c2dfb329);
$parcel$export(module.exports, "HorizontalDirection", () => $437b23f6a393c3bf$export$2e679088785045c);
$parcel$export(module.exports, "DragSourceType", () => $437b23f6a393c3bf$export$46ba5a92125911d9);
$parcel$export(module.exports, "DragAndDropService", () => $437b23f6a393c3bf$export$3529111922becfa6);
$parcel$export(module.exports, "GroupCellRendererCtrl", () => $437b23f6a393c3bf$export$629e29df0ab4c80);
$parcel$export(module.exports, "GroupCellRenderer", () => $437b23f6a393c3bf$export$ad98892c9ca039a2);
$parcel$export(module.exports, "NumberCellEditor", () => $437b23f6a393c3bf$export$b0b5b22313882d92);
$parcel$export(module.exports, "DateCellEditor", () => $437b23f6a393c3bf$export$e458dd9c8f847882);
$parcel$export(module.exports, "DateStringCellEditor", () => $437b23f6a393c3bf$export$54060a84075c35d1);
$parcel$export(module.exports, "CheckboxCellRenderer", () => $437b23f6a393c3bf$export$c3622544a1decc94);
$parcel$export(module.exports, "CheckboxCellEditor", () => $437b23f6a393c3bf$export$64a4d9c7e8236d55);
$parcel$export(module.exports, "AgMenuItemRenderer", () => $437b23f6a393c3bf$export$66550b837708f888);
$parcel$export(module.exports, "UserComponentRegistry", () => $437b23f6a393c3bf$export$84607ca0a5de10d3);
$parcel$export(module.exports, "FloatingFilterMapper", () => $437b23f6a393c3bf$export$9ff31c116240592);
$parcel$export(module.exports, "UserComponentFactory", () => $437b23f6a393c3bf$export$b32ef18681c5348a);
$parcel$export(module.exports, "ExcelFactoryMode", () => $437b23f6a393c3bf$export$1b4f0b0d179ae7d9);
$parcel$export(module.exports, "RowHighlightPosition", () => $437b23f6a393c3bf$export$e879772ad3c0a0e);
$parcel$export(module.exports, "AutoScrollService", () => $437b23f6a393c3bf$export$c66bdc3d55a4f95);
$parcel$export(module.exports, "DragService", () => $437b23f6a393c3bf$export$590729638d17528a);
$parcel$export(module.exports, "VirtualListDragFeature", () => $437b23f6a393c3bf$export$dde02d2f19b2bc46);
$parcel$export(module.exports, "GridApi", () => $437b23f6a393c3bf$export$8f1681b1712fcf78);
$parcel$export(module.exports, "FilterManager", () => $437b23f6a393c3bf$export$4c85e4ca0d95642f);
$parcel$export(module.exports, "FilterWrapperComp", () => $437b23f6a393c3bf$export$70acaf0e0e30e7d);
$parcel$export(module.exports, "HeaderFilterCellComp", () => $437b23f6a393c3bf$export$aee3d2f667fe76c1);
$parcel$export(module.exports, "LayoutCssClasses", () => $437b23f6a393c3bf$export$f22675e2b4e3ac28);
$parcel$export(module.exports, "RowAnimationCssClasses", () => $437b23f6a393c3bf$export$4ffc042a393c407b);
$parcel$export(module.exports, "GridBodyCtrl", () => $437b23f6a393c3bf$export$8bebc3145b40d221);
$parcel$export(module.exports, "SelectionHandleType", () => $437b23f6a393c3bf$export$dc43114153b7f047);
$parcel$export(module.exports, "CellRangeType", () => $437b23f6a393c3bf$export$162bc75b85f28397);
$parcel$export(module.exports, "Beans", () => $437b23f6a393c3bf$export$e1272dadeadaca63);
$parcel$export(module.exports, "CssClassApplier", () => $437b23f6a393c3bf$export$f90acfa36b600d3d);
$parcel$export(module.exports, "CellCtrl", () => $437b23f6a393c3bf$export$4fd76abbfd48a7b6);
$parcel$export(module.exports, "RowCtrl", () => $437b23f6a393c3bf$export$e449e57ac30326ed);
$parcel$export(module.exports, "RowContainerName", () => $437b23f6a393c3bf$export$6ecab00f7b310c71);
$parcel$export(module.exports, "RowContainerType", () => $437b23f6a393c3bf$export$ef20fcc15b4eafb6);
$parcel$export(module.exports, "getRowContainerTypeForName", () => $437b23f6a393c3bf$export$c62f516a68da5a74);
$parcel$export(module.exports, "RowContainerCtrl", () => $437b23f6a393c3bf$export$2d4385f6f566fe5e);
$parcel$export(module.exports, "GridBodyComp", () => $437b23f6a393c3bf$export$fb561602f10e2162);
$parcel$export(module.exports, "ScrollVisibleService", () => $437b23f6a393c3bf$export$eca0fad328f0291c);
$parcel$export(module.exports, "MouseEventService", () => $437b23f6a393c3bf$export$2e403e146bc377e1);
$parcel$export(module.exports, "NavigationService", () => $437b23f6a393c3bf$export$2a4aa3d46d9c7613);
$parcel$export(module.exports, "PopupEditorWrapper", () => $437b23f6a393c3bf$export$fdd61bfa9577e25);
$parcel$export(module.exports, "CellComp", () => $437b23f6a393c3bf$export$e59215a9594b9f01);
$parcel$export(module.exports, "RowContainerComp", () => $437b23f6a393c3bf$export$a301f7d71bb9bd77);
$parcel$export(module.exports, "BodyDropPivotTarget", () => $437b23f6a393c3bf$export$2828fedc973b5610);
$parcel$export(module.exports, "MoveColumnFeature", () => $437b23f6a393c3bf$export$a5c24618571fc64c);
$parcel$export(module.exports, "BodyDropTarget", () => $437b23f6a393c3bf$export$2350838bf1877b9e);
$parcel$export(module.exports, "HeaderRowType", () => $437b23f6a393c3bf$export$e37505288cf627d);
$parcel$export(module.exports, "HeaderRowComp", () => $437b23f6a393c3bf$export$e63c63fafc55a465);
$parcel$export(module.exports, "AbstractHeaderCellCtrl", () => $437b23f6a393c3bf$export$879ff627d5a4d5c);
$parcel$export(module.exports, "SetLeftFeature", () => $437b23f6a393c3bf$export$84c1fb51ab89c7b5);
$parcel$export(module.exports, "HeaderFilterCellCtrl", () => $437b23f6a393c3bf$export$65579fe86751e033);
$parcel$export(module.exports, "HeaderCellCtrl", () => $437b23f6a393c3bf$export$8a024062e840d3f5);
$parcel$export(module.exports, "HeaderGroupCellCtrl", () => $437b23f6a393c3bf$export$6ab7b303345e4c8);
$parcel$export(module.exports, "HeaderRowCtrl", () => $437b23f6a393c3bf$export$d184e9bef4f8ca43);
$parcel$export(module.exports, "HeaderRowContainerCtrl", () => $437b23f6a393c3bf$export$1e864ee88f54e7b);
$parcel$export(module.exports, "HeaderRowContainerComp", () => $437b23f6a393c3bf$export$f44f3572151186aa);
$parcel$export(module.exports, "HeaderNavigationDirection", () => $437b23f6a393c3bf$export$17290b528485e8bd);
$parcel$export(module.exports, "HeaderNavigationService", () => $437b23f6a393c3bf$export$ee63d8b4f36fee20);
$parcel$export(module.exports, "GridHeaderCtrl", () => $437b23f6a393c3bf$export$20b300eb69ca4d09);
$parcel$export(module.exports, "GridHeaderComp", () => $437b23f6a393c3bf$export$a83f8d9da6e79f4);
$parcel$export(module.exports, "HorizontalResizeService", () => $437b23f6a393c3bf$export$8c88ee8741066b8b);
$parcel$export(module.exports, "StandardMenuFactory", () => $437b23f6a393c3bf$export$ddca88023f936464);
$parcel$export(module.exports, "TabGuardClassNames", () => $437b23f6a393c3bf$export$3be5727576441c72);
$parcel$export(module.exports, "TabGuardCtrl", () => $437b23f6a393c3bf$export$3074753638c3772c);
$parcel$export(module.exports, "TabGuardComp", () => $437b23f6a393c3bf$export$5a26e3abd1c845b6);
$parcel$export(module.exports, "TabbedLayout", () => $437b23f6a393c3bf$export$e71fa82861e8f8);
$parcel$export(module.exports, "ResizeObserverService", () => $437b23f6a393c3bf$export$c3ae9ac02599b50f);
$parcel$export(module.exports, "AnimationFrameService", () => $437b23f6a393c3bf$export$2963e6121f7c3146);
$parcel$export(module.exports, "ClientSideRowModelSteps", () => $437b23f6a393c3bf$export$42ac378faabadc9d);
$parcel$export(module.exports, "ExpansionService", () => $437b23f6a393c3bf$export$609b78da5e2f116c);
$parcel$export(module.exports, "MenuService", () => $437b23f6a393c3bf$export$ec78627b94a587e2);
$parcel$export(module.exports, "AutoWidthCalculator", () => $437b23f6a393c3bf$export$cc129c761c9af6b5);
$parcel$export(module.exports, "RowRenderer", () => $437b23f6a393c3bf$export$a41edaea3b7c09c8);
$parcel$export(module.exports, "PinnedRowModel", () => $437b23f6a393c3bf$export$d44126a5f53c99d9);
$parcel$export(module.exports, "ServerSideTransactionResultStatus", () => $437b23f6a393c3bf$export$58e95be8934cbc38);
$parcel$export(module.exports, "ChangedPath", () => $437b23f6a393c3bf$export$cb4d9114a9732e85);
$parcel$export(module.exports, "RowNodeBlock", () => $437b23f6a393c3bf$export$eb7378abb0bca09e);
$parcel$export(module.exports, "RowNodeBlockLoader", () => $437b23f6a393c3bf$export$6bcc4682a6134db1);
$parcel$export(module.exports, "PaginationProxy", () => $437b23f6a393c3bf$export$beda096b980d328);
$parcel$export(module.exports, "StylingService", () => $437b23f6a393c3bf$export$cf53ce5e31dacc9f);
$parcel$export(module.exports, "AgToggleButton", () => $437b23f6a393c3bf$export$167b21bf245ce0bf);
$parcel$export(module.exports, "AgInputTextArea", () => $437b23f6a393c3bf$export$fd677433260ffbc8);
$parcel$export(module.exports, "AgInputDateField", () => $437b23f6a393c3bf$export$9e01ec8ba43de612);
$parcel$export(module.exports, "AgInputRange", () => $437b23f6a393c3bf$export$59243fd7dabffb56);
$parcel$export(module.exports, "VirtualList", () => $437b23f6a393c3bf$export$8aa850fa810c1c21);
$parcel$export(module.exports, "AgRichSelect", () => $437b23f6a393c3bf$export$16d6ce2fe866e420);
$parcel$export(module.exports, "AgSlider", () => $437b23f6a393c3bf$export$393c85b733ccd61d);
$parcel$export(module.exports, "AgGroupComponent", () => $437b23f6a393c3bf$export$ad535c478b02d5b4);
$parcel$export(module.exports, "AgMenuList", () => $437b23f6a393c3bf$export$b113b1dd8295ef83);
$parcel$export(module.exports, "AgMenuItemComponent", () => $437b23f6a393c3bf$export$908d4fd0a47034b5);
$parcel$export(module.exports, "AgMenuPanel", () => $437b23f6a393c3bf$export$afc64d33b32952ba);
$parcel$export(module.exports, "AgPanel", () => $437b23f6a393c3bf$export$36e6d4f6293bbc52);
$parcel$export(module.exports, "AgDialog", () => $437b23f6a393c3bf$export$c9fd1c3b091fd3ea);
$parcel$export(module.exports, "PopupService", () => $437b23f6a393c3bf$export$27497a369f7303c1);
$parcel$export(module.exports, "AgAutocomplete", () => $437b23f6a393c3bf$export$b26fb295f8aa6b61);
$parcel$export(module.exports, "PillDragComp", () => $437b23f6a393c3bf$export$35edd0e9295b87d1);
$parcel$export(module.exports, "PillDropZonePanel", () => $437b23f6a393c3bf$export$50f4ce491a627136);
$parcel$export(module.exports, "VanillaFrameworkOverrides", () => $437b23f6a393c3bf$export$8174ad74937c6482);
$parcel$export(module.exports, "CellNavigationService", () => $437b23f6a393c3bf$export$672e779a12850b13);
$parcel$export(module.exports, "AlignedGridsService", () => $437b23f6a393c3bf$export$64acd562943cc6b9);
$parcel$export(module.exports, "ColumnApi", () => $437b23f6a393c3bf$export$77ba9896796af9bf);
$parcel$export(module.exports, "ValueService", () => $437b23f6a393c3bf$export$c52638093d9fc6a3);
$parcel$export(module.exports, "ExpressionService", () => $437b23f6a393c3bf$export$4ce5344b7d88a0e2);
$parcel$export(module.exports, "LoggerFactory", () => $437b23f6a393c3bf$export$e0f5ef03cd95415a);
$parcel$export(module.exports, "Logger", () => $437b23f6a393c3bf$export$efa9a398d6368992);
$parcel$export(module.exports, "GridCtrl", () => $437b23f6a393c3bf$export$f3c741dac0be9745);
$parcel$export(module.exports, "GridComp", () => $437b23f6a393c3bf$export$f29859a2c0c53119);
$parcel$export(module.exports, "SortController", () => $437b23f6a393c3bf$export$765594e5be71a851);
$parcel$export(module.exports, "FocusService", () => $437b23f6a393c3bf$export$a48e931b7fcc2862);
$parcel$export(module.exports, "ValueCache", () => $437b23f6a393c3bf$export$8bb85f19590498f6);
$parcel$export(module.exports, "Environment", () => $437b23f6a393c3bf$export$7dc6752a22ab011a);
$parcel$export(module.exports, "SelectableService", () => $437b23f6a393c3bf$export$75ae26c229338c6b);
$parcel$export(module.exports, "RowPositionUtils", () => $437b23f6a393c3bf$export$27e6ff2feb462d0f);
$parcel$export(module.exports, "CellPositionUtils", () => $437b23f6a393c3bf$export$d4b97c43369f9635);
$parcel$export(module.exports, "HeaderPositionUtils", () => $437b23f6a393c3bf$export$4dfb519ecc588412);
$parcel$export(module.exports, "RowNodeSorter", () => $437b23f6a393c3bf$export$5cc6416c85df0cc5);
$parcel$export(module.exports, "CtrlsService", () => $437b23f6a393c3bf$export$1ec35376f0ed6145);
$parcel$export(module.exports, "GridOptionsService", () => $437b23f6a393c3bf$export$4e35ad424d98ee6);
$parcel$export(module.exports, "LocaleService", () => $437b23f6a393c3bf$export$f325e19d05d9c36d);
$parcel$export(module.exports, "DataTypeService", () => $437b23f6a393c3bf$export$167d98081c349dc);
$parcel$export(module.exports, "provideGlobalGridOptions", () => $437b23f6a393c3bf$export$9def8154c643bfd1);
$parcel$export(module.exports, "createGrid", () => $437b23f6a393c3bf$export$fce123c48a7b4eae);
$parcel$export(module.exports, "GridCoreCreator", () => $437b23f6a393c3bf$export$7759b93c6200a2f9);
$parcel$export(module.exports, "Grid", () => $437b23f6a393c3bf$export$ef2184bd89960b14);
$parcel$export(module.exports, "BaseComponentWrapper", () => $437b23f6a393c3bf$export$157f014d661b6f19);
$parcel$export(module.exports, "ChartMappings", () => $437b23f6a393c3bf$export$95ec81232b2e8791);
$parcel$export(module.exports, "BarColumnLabelPlacement", () => $437b23f6a393c3bf$export$c8e24a0d0ec865d3);
$parcel$export(module.exports, "ClientSideRowModelModule", () => $437b23f6a393c3bf$export$4c74201d5a94c8e5);
$parcel$export(module.exports, "InfiniteRowModelModule", () => $437b23f6a393c3bf$export$ca8341149bdd39bc);
$parcel$export(module.exports, "BaseCreator", () => $437b23f6a393c3bf$export$b335f23c5aead909);
$parcel$export(module.exports, "BaseGridSerializingSession", () => $437b23f6a393c3bf$export$5018ab277b833b61);
$parcel$export(module.exports, "Downloader", () => $437b23f6a393c3bf$export$ef06e7620d37c296);
$parcel$export(module.exports, "CsvCreator", () => $437b23f6a393c3bf$export$8ff7d5e0eafc769c);
$parcel$export(module.exports, "RowType", () => $437b23f6a393c3bf$export$6c09164be112ad33);
$parcel$export(module.exports, "GridSerializer", () => $437b23f6a393c3bf$export$6ec40cbcb0344850);
$parcel$export(module.exports, "CsvExportModule", () => $437b23f6a393c3bf$export$f744275d8b795fc2);
$parcel$export(module.exports, "XmlFactory", () => $437b23f6a393c3bf$export$1abb521838b54ff);
$parcel$export(module.exports, "ZipContainer", () => $437b23f6a393c3bf$export$35dc58f6886fc963);
var $437b23f6a393c3bf$var$__defProp = Object.defineProperty;
var $437b23f6a393c3bf$var$__defProps = Object.defineProperties;
var $437b23f6a393c3bf$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $437b23f6a393c3bf$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $437b23f6a393c3bf$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $437b23f6a393c3bf$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $437b23f6a393c3bf$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $437b23f6a393c3bf$var$__defNormalProp = (obj, key, value)=>key in obj ? $437b23f6a393c3bf$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $437b23f6a393c3bf$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($437b23f6a393c3bf$var$__hasOwnProp.call(b, prop)) $437b23f6a393c3bf$var$__defNormalProp(a, prop, b[prop]);
    if ($437b23f6a393c3bf$var$__getOwnPropSymbols) {
        for (var prop of $437b23f6a393c3bf$var$__getOwnPropSymbols(b))if ($437b23f6a393c3bf$var$__propIsEnum.call(b, prop)) $437b23f6a393c3bf$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $437b23f6a393c3bf$var$__spreadProps = (a, b)=>$437b23f6a393c3bf$var$__defProps(a, $437b23f6a393c3bf$var$__getOwnPropDescs(b));
var $437b23f6a393c3bf$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($437b23f6a393c3bf$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $437b23f6a393c3bf$var$__getOwnPropSymbols) {
        for (var prop of $437b23f6a393c3bf$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $437b23f6a393c3bf$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $437b23f6a393c3bf$var$__export = (target, all)=>{
    for(var name in all)$437b23f6a393c3bf$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $437b23f6a393c3bf$var$__decorateClass = (decorators, target, key, kind)=>{
    var result = kind > 1 ? void 0 : kind ? $437b23f6a393c3bf$var$__getOwnPropDesc(target, key) : target;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
    if (kind && result) $437b23f6a393c3bf$var$__defProp(target, key, result);
    return result;
};
var $437b23f6a393c3bf$var$__decorateParam = (index, decorator)=>(target, key)=>decorator(target, key, index);
// community-modules/core/src/utils/generic.ts
var $437b23f6a393c3bf$var$generic_exports = {};
$437b23f6a393c3bf$var$__export($437b23f6a393c3bf$var$generic_exports, {
    attrToBoolean: ()=>$437b23f6a393c3bf$var$attrToBoolean,
    attrToNumber: ()=>$437b23f6a393c3bf$var$attrToNumber,
    attrToString: ()=>$437b23f6a393c3bf$var$attrToString,
    defaultComparator: ()=>$437b23f6a393c3bf$var$defaultComparator,
    exists: ()=>$437b23f6a393c3bf$var$exists,
    jsonEquals: ()=>$437b23f6a393c3bf$var$jsonEquals,
    makeNull: ()=>$437b23f6a393c3bf$var$makeNull,
    missing: ()=>$437b23f6a393c3bf$var$missing,
    missingOrEmpty: ()=>$437b23f6a393c3bf$var$missingOrEmpty,
    toStringOrNull: ()=>$437b23f6a393c3bf$var$toStringOrNull,
    values: ()=>$437b23f6a393c3bf$var$values
});
function $437b23f6a393c3bf$var$makeNull(value) {
    if (value == null || value === "") return null;
    return value;
}
function $437b23f6a393c3bf$var$exists(value, allowEmptyString = false) {
    return value != null && (value !== "" || allowEmptyString);
}
function $437b23f6a393c3bf$var$missing(value) {
    return !$437b23f6a393c3bf$var$exists(value);
}
function $437b23f6a393c3bf$var$missingOrEmpty(value) {
    return value == null || value.length === 0;
}
function $437b23f6a393c3bf$var$toStringOrNull(value) {
    return value != null && typeof value.toString === "function" ? value.toString() : null;
}
function $437b23f6a393c3bf$var$attrToNumber(value) {
    if (value === void 0) return;
    if (value === null || value === "") return null;
    if (typeof value === "number") return isNaN(value) ? void 0 : value;
    const valueParsed = parseInt(value, 10);
    return isNaN(valueParsed) ? void 0 : valueParsed;
}
function $437b23f6a393c3bf$var$attrToBoolean(value) {
    if (value === void 0) return;
    if (value === null || value === "") return false;
    if (typeof value === "boolean") return value;
    return /true/i.test(value);
}
function $437b23f6a393c3bf$var$attrToString(value) {
    if (value == null || value === "") return;
    return value;
}
function $437b23f6a393c3bf$var$jsonEquals(val1, val2) {
    const val1Json = val1 ? JSON.stringify(val1) : null;
    const val2Json = val2 ? JSON.stringify(val2) : null;
    return val1Json === val2Json;
}
function $437b23f6a393c3bf$var$defaultComparator(valueA, valueB, accentedCompare = false) {
    const valueAMissing = valueA == null;
    const valueBMissing = valueB == null;
    if (valueA && valueA.toNumber) valueA = valueA.toNumber();
    if (valueB && valueB.toNumber) valueB = valueB.toNumber();
    if (valueAMissing && valueBMissing) return 0;
    if (valueAMissing) return -1;
    if (valueBMissing) return 1;
    function doQuickCompare(a, b) {
        return a > b ? 1 : a < b ? -1 : 0;
    }
    if (typeof valueA !== "string") return doQuickCompare(valueA, valueB);
    if (!accentedCompare) return doQuickCompare(valueA, valueB);
    try {
        return valueA.localeCompare(valueB);
    } catch (e) {
        return doQuickCompare(valueA, valueB);
    }
}
function $437b23f6a393c3bf$var$values(object) {
    if (object instanceof Set || object instanceof Map) {
        const arr = [];
        object.forEach((value)=>arr.push(value));
        return arr;
    }
    return Object.values(object);
}
// community-modules/core/src/columns/columnKeyCreator.ts
var $437b23f6a393c3bf$export$f67d1427302c96a3 = class {
    constructor(){
        this.existingKeys = {};
    }
    addExistingKeys(keys2) {
        for(let i = 0; i < keys2.length; i++)this.existingKeys[keys2[i]] = true;
    }
    getUniqueKey(colId, colField) {
        colId = $437b23f6a393c3bf$var$toStringOrNull(colId);
        let count = 0;
        while(true){
            let idToTry;
            if (colId) {
                idToTry = colId;
                if (count !== 0) idToTry += "_" + count;
            } else if (colField) {
                idToTry = colField;
                if (count !== 0) idToTry += "_" + count;
            } else idToTry = count;
            if (!this.existingKeys[idToTry]) {
                this.existingKeys[idToTry] = true;
                return String(idToTry);
            }
            count++;
        }
    }
};
// community-modules/core/src/utils/object.ts
var $437b23f6a393c3bf$var$object_exports = {};
$437b23f6a393c3bf$var$__export($437b23f6a393c3bf$var$object_exports, {
    SKIP_JS_BUILTINS: ()=>$437b23f6a393c3bf$var$SKIP_JS_BUILTINS,
    cloneObject: ()=>$437b23f6a393c3bf$var$cloneObject,
    deepCloneDefinition: ()=>$437b23f6a393c3bf$var$deepCloneDefinition,
    getAllValuesInObject: ()=>$437b23f6a393c3bf$var$getAllValuesInObject,
    getValueUsingField: ()=>$437b23f6a393c3bf$var$getValueUsingField,
    isNonNullObject: ()=>$437b23f6a393c3bf$var$isNonNullObject,
    iterateObject: ()=>$437b23f6a393c3bf$var$iterateObject,
    mergeDeep: ()=>$437b23f6a393c3bf$var$mergeDeep,
    removeAllReferences: ()=>$437b23f6a393c3bf$var$removeAllReferences
});
var $437b23f6a393c3bf$var$SKIP_JS_BUILTINS = /* @__PURE__ */ new Set([
    "__proto__",
    "constructor",
    "prototype"
]);
function $437b23f6a393c3bf$var$iterateObject(object, callback) {
    if (object == null) return;
    if (Array.isArray(object)) {
        for(let i = 0; i < object.length; i++)callback(i.toString(), object[i]);
        return;
    }
    for (const [key, value] of Object.entries(object))callback(key, value);
}
function $437b23f6a393c3bf$var$cloneObject(object) {
    const copy = {};
    const keys2 = Object.keys(object);
    for(let i = 0; i < keys2.length; i++){
        if ($437b23f6a393c3bf$var$SKIP_JS_BUILTINS.has(keys2[i])) continue;
        const key = keys2[i];
        const value = object[key];
        copy[key] = value;
    }
    return copy;
}
function $437b23f6a393c3bf$var$deepCloneDefinition(object, keysToSkip) {
    if (!object) return;
    const obj = object;
    const res = {};
    Object.keys(obj).forEach((key)=>{
        if (keysToSkip && keysToSkip.indexOf(key) >= 0 || $437b23f6a393c3bf$var$SKIP_JS_BUILTINS.has(key)) return;
        const value = obj[key];
        const sourceIsSimpleObject = $437b23f6a393c3bf$var$isNonNullObject(value) && value.constructor === Object;
        if (sourceIsSimpleObject) res[key] = $437b23f6a393c3bf$var$deepCloneDefinition(value);
        else res[key] = value;
    });
    return res;
}
function $437b23f6a393c3bf$var$getAllValuesInObject(obj) {
    if (!obj) return [];
    const anyObject = Object;
    if (typeof anyObject.values === "function") return anyObject.values(obj);
    const ret = [];
    for(const key in obj)if (obj.hasOwnProperty(key) && obj.propertyIsEnumerable(key)) ret.push(obj[key]);
    return ret;
}
function $437b23f6a393c3bf$var$mergeDeep(dest, source, copyUndefined = true, makeCopyOfSimpleObjects = false) {
    if (!$437b23f6a393c3bf$var$exists(source)) return;
    $437b23f6a393c3bf$var$iterateObject(source, (key, sourceValue)=>{
        if ($437b23f6a393c3bf$var$SKIP_JS_BUILTINS.has(key)) return;
        let destValue = dest[key];
        if (destValue === sourceValue) return;
        if (makeCopyOfSimpleObjects) {
            const objectIsDueToBeCopied = destValue == null && sourceValue != null;
            if (objectIsDueToBeCopied) {
                const sourceIsSimpleObject = typeof sourceValue === "object" && sourceValue.constructor === Object;
                const dontCopy = sourceIsSimpleObject;
                if (dontCopy) {
                    destValue = {};
                    dest[key] = destValue;
                }
            }
        }
        if ($437b23f6a393c3bf$var$isNonNullObject(sourceValue) && $437b23f6a393c3bf$var$isNonNullObject(destValue) && !Array.isArray(destValue)) $437b23f6a393c3bf$var$mergeDeep(destValue, sourceValue, copyUndefined, makeCopyOfSimpleObjects);
        else if (copyUndefined || sourceValue !== void 0) dest[key] = sourceValue;
    });
}
function $437b23f6a393c3bf$var$getValueUsingField(data, field, fieldContainsDots) {
    if (!field || !data) return;
    if (!fieldContainsDots) return data[field];
    const fields = field.split(".");
    let currentObject = data;
    for(let i = 0; i < fields.length; i++){
        if (currentObject == null) return void 0;
        currentObject = currentObject[fields[i]];
    }
    return currentObject;
}
function $437b23f6a393c3bf$var$removeAllReferences(obj, preserveKeys = [], preDestroyLink) {
    Object.keys(obj).forEach((key)=>{
        const value = obj[key];
        if (typeof value === "object" && !preserveKeys.includes(key)) obj[key] = void 0;
    });
    const proto = Object.getPrototypeOf(obj);
    const properties = {};
    const msgFunc = (key)=>`AG Grid: Grid API function ${key}() cannot be called as the grid has been destroyed.
    It is recommended to remove local references to the grid api. Alternatively, check gridApi.isDestroyed() to avoid calling methods against a destroyed grid.
    To run logic when the grid is about to be destroyed use the gridPreDestroy event. See: ${preDestroyLink}`;
    Object.getOwnPropertyNames(proto).forEach((key)=>{
        const value = proto[key];
        if (typeof value === "function" && !preserveKeys.includes(key)) {
            const func = ()=>{
                console.warn(msgFunc(key));
            };
            properties[key] = {
                value: func,
                writable: true
            };
        }
    });
    Object.defineProperties(obj, properties);
}
function $437b23f6a393c3bf$var$isNonNullObject(value) {
    return typeof value === "object" && value !== null;
}
// community-modules/core/src/utils/function.ts
var $437b23f6a393c3bf$var$function_exports = {};
$437b23f6a393c3bf$var$__export($437b23f6a393c3bf$var$function_exports, {
    compose: ()=>$437b23f6a393c3bf$var$compose,
    debounce: ()=>$437b23f6a393c3bf$var$debounce,
    doOnce: ()=>$437b23f6a393c3bf$var$doOnce,
    errorOnce: ()=>$437b23f6a393c3bf$var$errorOnce,
    executeAfter: ()=>$437b23f6a393c3bf$var$executeAfter,
    executeInAWhile: ()=>$437b23f6a393c3bf$var$executeInAWhile,
    executeNextVMTurn: ()=>$437b23f6a393c3bf$var$executeNextVMTurn,
    getFunctionName: ()=>$437b23f6a393c3bf$var$getFunctionName,
    isFunction: ()=>$437b23f6a393c3bf$var$isFunction,
    noop: ()=>$437b23f6a393c3bf$var$noop,
    throttle: ()=>$437b23f6a393c3bf$var$throttle,
    waitUntil: ()=>$437b23f6a393c3bf$var$waitUntil,
    warnOnce: ()=>$437b23f6a393c3bf$var$warnOnce
});
var $437b23f6a393c3bf$var$doOnceFlags = {};
function $437b23f6a393c3bf$var$doOnce(func, key) {
    if ($437b23f6a393c3bf$var$doOnceFlags[key]) return;
    func();
    $437b23f6a393c3bf$var$doOnceFlags[key] = true;
}
function $437b23f6a393c3bf$var$warnOnce(msg) {
    $437b23f6a393c3bf$var$doOnce(()=>console.warn("AG Grid: " + msg), msg);
}
function $437b23f6a393c3bf$var$errorOnce(msg) {
    $437b23f6a393c3bf$var$doOnce(()=>console.error("AG Grid: " + msg), msg);
}
function $437b23f6a393c3bf$var$getFunctionName(funcConstructor) {
    if (funcConstructor.name) return funcConstructor.name;
    const matches = /function\s+([^\(]+)/.exec(funcConstructor.toString());
    return matches && matches.length === 2 ? matches[1].trim() : null;
}
function $437b23f6a393c3bf$var$isFunction(val) {
    return !!(val && val.constructor && val.call && val.apply);
}
function $437b23f6a393c3bf$var$executeInAWhile(funcs) {
    $437b23f6a393c3bf$var$executeAfter(funcs, 400);
}
var $437b23f6a393c3bf$var$executeNextVMTurnFuncs = [];
var $437b23f6a393c3bf$var$executeNextVMTurnPending = false;
function $437b23f6a393c3bf$var$executeNextVMTurn(func) {
    $437b23f6a393c3bf$var$executeNextVMTurnFuncs.push(func);
    if ($437b23f6a393c3bf$var$executeNextVMTurnPending) return;
    $437b23f6a393c3bf$var$executeNextVMTurnPending = true;
    window.setTimeout(()=>{
        const funcsCopy = $437b23f6a393c3bf$var$executeNextVMTurnFuncs.slice();
        $437b23f6a393c3bf$var$executeNextVMTurnFuncs.length = 0;
        $437b23f6a393c3bf$var$executeNextVMTurnPending = false;
        funcsCopy.forEach((func2)=>func2());
    }, 0);
}
function $437b23f6a393c3bf$var$executeAfter(funcs, milliseconds = 0) {
    if (funcs.length > 0) window.setTimeout(()=>funcs.forEach((func)=>func()), milliseconds);
}
function $437b23f6a393c3bf$var$debounce(func, delay) {
    let timeout;
    return function(...args) {
        const context = this;
        window.clearTimeout(timeout);
        timeout = window.setTimeout(function() {
            func.apply(context, args);
        }, delay);
    };
}
function $437b23f6a393c3bf$var$throttle(func, wait) {
    let previousCall = 0;
    return function(...args) {
        const context = this;
        const currentCall = /* @__PURE__ */ new Date().getTime();
        if (currentCall - previousCall < wait) return;
        previousCall = currentCall;
        func.apply(context, args);
    };
}
function $437b23f6a393c3bf$var$waitUntil(condition, callback, timeout = 100, timeoutMessage) {
    const timeStamp = /* @__PURE__ */ new Date().getTime();
    let interval = null;
    let executed = false;
    const internalCallback = ()=>{
        const reachedTimeout = /* @__PURE__ */ new Date().getTime() - timeStamp > timeout;
        if (condition() || reachedTimeout) {
            callback();
            executed = true;
            if (interval != null) {
                window.clearInterval(interval);
                interval = null;
            }
            if (reachedTimeout && timeoutMessage) console.warn(timeoutMessage);
        }
    };
    internalCallback();
    if (!executed) interval = window.setInterval(internalCallback, 10);
}
function $437b23f6a393c3bf$var$compose(...fns) {
    return (arg)=>fns.reduce((composed, f)=>f(composed), arg);
}
var $437b23f6a393c3bf$var$noop = ()=>{
    return;
};
// community-modules/core/src/modules/moduleNames.ts
var $437b23f6a393c3bf$export$7014c4aa9a91d0eb = /* @__PURE__ */ ((ModuleNames2)=>{
    ModuleNames2["CommunityCoreModule"] = "@ag-grid-community/core";
    ModuleNames2["InfiniteRowModelModule"] = "@ag-grid-community/infinite-row-model";
    ModuleNames2["ClientSideRowModelModule"] = "@ag-grid-community/client-side-row-model";
    ModuleNames2["CsvExportModule"] = "@ag-grid-community/csv-export";
    ModuleNames2["EnterpriseCoreModule"] = "@ag-grid-enterprise/core";
    ModuleNames2["RowGroupingModule"] = "@ag-grid-enterprise/row-grouping";
    ModuleNames2["ColumnsToolPanelModule"] = "@ag-grid-enterprise/column-tool-panel";
    ModuleNames2["FiltersToolPanelModule"] = "@ag-grid-enterprise/filter-tool-panel";
    ModuleNames2["MenuModule"] = "@ag-grid-enterprise/menu";
    ModuleNames2["SetFilterModule"] = "@ag-grid-enterprise/set-filter";
    ModuleNames2["MultiFilterModule"] = "@ag-grid-enterprise/multi-filter";
    ModuleNames2["StatusBarModule"] = "@ag-grid-enterprise/status-bar";
    ModuleNames2["SideBarModule"] = "@ag-grid-enterprise/side-bar";
    ModuleNames2["RangeSelectionModule"] = "@ag-grid-enterprise/range-selection";
    ModuleNames2["MasterDetailModule"] = "@ag-grid-enterprise/master-detail";
    ModuleNames2["RichSelectModule"] = "@ag-grid-enterprise/rich-select";
    ModuleNames2["GridChartsModule"] = "@ag-grid-enterprise/charts";
    ModuleNames2["ViewportRowModelModule"] = "@ag-grid-enterprise/viewport-row-model";
    ModuleNames2["ServerSideRowModelModule"] = "@ag-grid-enterprise/server-side-row-model";
    ModuleNames2["ExcelExportModule"] = "@ag-grid-enterprise/excel-export";
    ModuleNames2["ClipboardModule"] = "@ag-grid-enterprise/clipboard";
    ModuleNames2["SparklinesModule"] = "@ag-grid-enterprise/sparklines";
    ModuleNames2["AdvancedFilterModule"] = "@ag-grid-enterprise/advanced-filter";
    ModuleNames2["AngularModule"] = "@ag-grid-community/angular";
    ModuleNames2["ReactModule"] = "@ag-grid-community/react";
    ModuleNames2["VueModule"] = "@ag-grid-community/vue";
    return ModuleNames2;
})($437b23f6a393c3bf$export$7014c4aa9a91d0eb || {});
// community-modules/core/src/modules/moduleRegistry.ts
var $437b23f6a393c3bf$var$_ModuleRegistry = class _ModuleRegistry {
    /**
   * Globally register the given module for all grids.
   * @param module - module to register
   */ static register(module) {
        _ModuleRegistry.__register(module, true, void 0);
    }
    /**
   * Globally register the given modules for all grids.
   * @param modules - modules to register
   */ static registerModules(modules) {
        _ModuleRegistry.__registerModules(modules, true, void 0);
    }
    /** AG GRID INTERNAL - Module registration helper. */ static __register(module, moduleBased, gridId) {
        _ModuleRegistry.runVersionChecks(module);
        if (gridId !== void 0) {
            _ModuleRegistry.areGridScopedModules = true;
            if (_ModuleRegistry.gridModulesMap[gridId] === void 0) _ModuleRegistry.gridModulesMap[gridId] = {};
            _ModuleRegistry.gridModulesMap[gridId][module.moduleName] = module;
        } else _ModuleRegistry.globalModulesMap[module.moduleName] = module;
        _ModuleRegistry.setModuleBased(moduleBased);
    }
    /** AG GRID INTERNAL - Unregister grid scoped module. */ static __unRegisterGridModules(gridId) {
        delete _ModuleRegistry.gridModulesMap[gridId];
    }
    /** AG GRID INTERNAL - Module registration helper. */ static __registerModules(modules, moduleBased, gridId) {
        _ModuleRegistry.setModuleBased(moduleBased);
        if (!modules) return;
        modules.forEach((module)=>_ModuleRegistry.__register(module, moduleBased, gridId));
    }
    static isValidModuleVersion(module) {
        const [moduleMajor, moduleMinor] = module.version.split(".") || [];
        const [currentModuleMajor, currentModuleMinor] = _ModuleRegistry.currentModuleVersion.split(".") || [];
        return moduleMajor === currentModuleMajor && moduleMinor === currentModuleMinor;
    }
    static runVersionChecks(module) {
        if (!_ModuleRegistry.currentModuleVersion) _ModuleRegistry.currentModuleVersion = module.version;
        if (!module.version) console.error(`AG Grid: You are using incompatible versions of AG Grid modules. Major and minor versions should always match across modules. '${module.moduleName}' is incompatible. Please update all modules to the same version.`);
        else if (!_ModuleRegistry.isValidModuleVersion(module)) console.error(`AG Grid: You are using incompatible versions of AG Grid modules. Major and minor versions should always match across modules. '${module.moduleName}' is version ${module.version} but the other modules are version ${this.currentModuleVersion}. Please update all modules to the same version.`);
        if (module.validate) {
            const result = module.validate();
            if (!result.isValid) {
                const errorResult = result;
                console.error(`AG Grid: ${errorResult.message}`);
            }
        }
    }
    static setModuleBased(moduleBased) {
        if (_ModuleRegistry.moduleBased === void 0) _ModuleRegistry.moduleBased = moduleBased;
        else if (_ModuleRegistry.moduleBased !== moduleBased) $437b23f6a393c3bf$var$doOnce(()=>{
            console.warn(`AG Grid: You are mixing modules (i.e. @ag-grid-community/core) and packages (ag-grid-community) - you can only use one or the other of these mechanisms.`);
            console.warn("Please see https://www.ag-grid.com/javascript-grid/modules/ for more information.");
        }, "ModulePackageCheck");
    }
    /**
   * AG GRID INTERNAL - Set if files are being served from a single UMD bundle to provide accurate enterprise upgrade steps.
   */ static __setIsBundled() {
        _ModuleRegistry.isBundled = true;
    }
    /** AG GRID INTERNAL - Assert a given module has been register, globally or individually with this grid. */ static __assertRegistered(moduleName, reason, gridId) {
        var _a;
        if (this.__isRegistered(moduleName, gridId)) return true;
        const warningKey = reason + moduleName;
        let warningMessage;
        if (_ModuleRegistry.isBundled) warningMessage = `AG Grid: unable to use ${reason} as 'ag-grid-enterprise' has not been loaded. Check you are using the Enterprise bundle:
        
        <script src="https://cdn.jsdelivr.net/npm/ag-grid-enterprise@AG_GRID_VERSION/dist/ag-grid-enterprise.min.js"><\/script>
        
For more info see: https://ag-grid.com/javascript-data-grid/getting-started/#getting-started-with-ag-grid-enterprise`;
        else if (_ModuleRegistry.moduleBased || _ModuleRegistry.moduleBased === void 0) {
            let modName = (_a = Object.entries($437b23f6a393c3bf$export$7014c4aa9a91d0eb).find(([k, v])=>v === moduleName)) == null ? void 0 : _a[0];
            warningMessage = `AG Grid: unable to use ${reason} as the ${modName} is not registered${_ModuleRegistry.areGridScopedModules ? ` for gridId: ${gridId}` : ""}. Check if you have registered the module:
           
    import { ModuleRegistry } from '@ag-grid-community/core';
    import { ${modName} } from '${moduleName}';
    
    ModuleRegistry.registerModules([ ${modName} ]);

For more info see: https://www.ag-grid.com/javascript-grid/modules/`;
        } else warningMessage = `AG Grid: unable to use ${reason} as package 'ag-grid-enterprise' has not been imported. Check that you have imported the package:
            
    import 'ag-grid-enterprise';`;
        $437b23f6a393c3bf$var$doOnce(()=>{
            console.warn(warningMessage);
        }, warningKey);
        return false;
    }
    /** AG GRID INTERNAL - Is the given module registered, globally or individually with this grid. */ static __isRegistered(moduleName, gridId) {
        var _a;
        return !!_ModuleRegistry.globalModulesMap[moduleName] || !!((_a = _ModuleRegistry.gridModulesMap[gridId]) == null ? void 0 : _a[moduleName]);
    }
    /** AG GRID INTERNAL - Get all registered modules globally / individually for this grid. */ static __getRegisteredModules(gridId) {
        return [
            ...$437b23f6a393c3bf$var$values(_ModuleRegistry.globalModulesMap),
            ...$437b23f6a393c3bf$var$values(_ModuleRegistry.gridModulesMap[gridId] || {})
        ];
    }
    /** AG GRID INTERNAL - Get the list of modules registered individually for this grid. */ static __getGridRegisteredModules(gridId) {
        var _a;
        return $437b23f6a393c3bf$var$values((_a = _ModuleRegistry.gridModulesMap[gridId]) != null ? _a : {}) || [];
    }
    /** INTERNAL */ static __isPackageBased() {
        return !_ModuleRegistry.moduleBased;
    }
};
// having in a map a) removes duplicates and b) allows fast lookup
$437b23f6a393c3bf$var$_ModuleRegistry.globalModulesMap = {};
$437b23f6a393c3bf$var$_ModuleRegistry.gridModulesMap = {};
$437b23f6a393c3bf$var$_ModuleRegistry.areGridScopedModules = false;
var $437b23f6a393c3bf$export$dc053975cc7f6c11 = $437b23f6a393c3bf$var$_ModuleRegistry;
// community-modules/core/src/context/context.ts
var $437b23f6a393c3bf$export$841858b892ce1f4c = class {
    constructor(params, logger){
        this.beanWrappers = {};
        this.destroyed = false;
        if (!params || !params.beanClasses) return;
        this.contextParams = params;
        this.logger = logger;
        this.logger.log(">> creating ag-Application Context");
        this.createBeans();
        const beanInstances = this.getBeanInstances();
        this.wireBeans(beanInstances);
        this.logger.log(">> ag-Application Context ready - component is alive");
    }
    getBeanInstances() {
        return $437b23f6a393c3bf$var$values(this.beanWrappers).map((beanEntry)=>beanEntry.beanInstance);
    }
    createBean(bean, afterPreCreateCallback) {
        if (!bean) throw Error(`Can't wire to bean since it is null`);
        this.wireBeans([
            bean
        ], afterPreCreateCallback);
        return bean;
    }
    wireBeans(beanInstances, afterPreCreateCallback) {
        this.autoWireBeans(beanInstances);
        this.methodWireBeans(beanInstances);
        this.callLifeCycleMethods(beanInstances, "preConstructMethods");
        if ($437b23f6a393c3bf$var$exists(afterPreCreateCallback)) beanInstances.forEach(afterPreCreateCallback);
        this.callLifeCycleMethods(beanInstances, "postConstructMethods");
    }
    createBeans() {
        this.contextParams.beanClasses.forEach(this.createBeanWrapper.bind(this));
        $437b23f6a393c3bf$var$iterateObject(this.beanWrappers, (key, beanEntry)=>{
            let constructorParamsMeta;
            if (beanEntry.bean.__agBeanMetaData && beanEntry.bean.__agBeanMetaData.autowireMethods && beanEntry.bean.__agBeanMetaData.autowireMethods.agConstructor) constructorParamsMeta = beanEntry.bean.__agBeanMetaData.autowireMethods.agConstructor;
            const constructorParams = this.getBeansForParameters(constructorParamsMeta, beanEntry.bean.name);
            const newInstance = new (beanEntry.bean.bind.apply(beanEntry.bean, [
                null,
                ...constructorParams
            ]))();
            beanEntry.beanInstance = newInstance;
        });
        const createdBeanNames = Object.keys(this.beanWrappers).join(", ");
        this.logger.log(`created beans: ${createdBeanNames}`);
    }
    // tslint:disable-next-line
    createBeanWrapper(BeanClass) {
        const metaData = BeanClass.__agBeanMetaData;
        if (!metaData) {
            let beanName;
            if (BeanClass.prototype.constructor) beanName = $437b23f6a393c3bf$var$getFunctionName(BeanClass.prototype.constructor);
            else beanName = "" + BeanClass;
            console.error(`Context item ${beanName} is not a bean`);
            return;
        }
        const beanEntry = {
            bean: BeanClass,
            beanInstance: null,
            beanName: metaData.beanName
        };
        this.beanWrappers[metaData.beanName] = beanEntry;
    }
    autoWireBeans(beanInstances) {
        beanInstances.forEach((beanInstance)=>{
            this.forEachMetaDataInHierarchy(beanInstance, (metaData, beanName)=>{
                const attributes = metaData.agClassAttributes;
                if (!attributes) return;
                attributes.forEach((attribute)=>{
                    const otherBean = this.lookupBeanInstance(beanName, attribute.beanName, attribute.optional);
                    beanInstance[attribute.attributeName] = otherBean;
                });
            });
        });
    }
    methodWireBeans(beanInstances) {
        beanInstances.forEach((beanInstance)=>{
            this.forEachMetaDataInHierarchy(beanInstance, (metaData, beanName)=>{
                $437b23f6a393c3bf$var$iterateObject(metaData.autowireMethods, (methodName, wireParams)=>{
                    if (methodName === "agConstructor") return;
                    const initParams = this.getBeansForParameters(wireParams, beanName);
                    beanInstance[methodName].apply(beanInstance, initParams);
                });
            });
        });
    }
    forEachMetaDataInHierarchy(beanInstance, callback) {
        let prototype = Object.getPrototypeOf(beanInstance);
        while(prototype != null){
            const constructor = prototype.constructor;
            if (constructor.hasOwnProperty("__agBeanMetaData")) {
                const metaData = constructor.__agBeanMetaData;
                const beanName = this.getBeanName(constructor);
                callback(metaData, beanName);
            }
            prototype = Object.getPrototypeOf(prototype);
        }
    }
    getBeanName(constructor) {
        if (constructor.__agBeanMetaData && constructor.__agBeanMetaData.beanName) return constructor.__agBeanMetaData.beanName;
        const constructorString = constructor.toString();
        const beanName = constructorString.substring(9, constructorString.indexOf("("));
        return beanName;
    }
    getBeansForParameters(parameters, beanName) {
        const beansList = [];
        if (parameters) $437b23f6a393c3bf$var$iterateObject(parameters, (paramIndex, otherBeanName)=>{
            const otherBean = this.lookupBeanInstance(beanName, otherBeanName);
            beansList[Number(paramIndex)] = otherBean;
        });
        return beansList;
    }
    lookupBeanInstance(wiringBean, beanName, optional = false) {
        if (this.destroyed) {
            this.logger.log(`AG Grid: bean reference ${beanName} is used after the grid is destroyed!`);
            return null;
        }
        if (beanName === "context") return this;
        if (this.contextParams.providedBeanInstances && this.contextParams.providedBeanInstances.hasOwnProperty(beanName)) return this.contextParams.providedBeanInstances[beanName];
        const beanEntry = this.beanWrappers[beanName];
        if (beanEntry) return beanEntry.beanInstance;
        if (!optional) console.error(`AG Grid: unable to find bean reference ${beanName} while initialising ${wiringBean}`);
        return null;
    }
    callLifeCycleMethods(beanInstances, lifeCycleMethod) {
        beanInstances.forEach((beanInstance)=>this.callLifeCycleMethodsOnBean(beanInstance, lifeCycleMethod));
    }
    callLifeCycleMethodsOnBean(beanInstance, lifeCycleMethod, methodToIgnore) {
        const allMethods = {};
        this.forEachMetaDataInHierarchy(beanInstance, (metaData)=>{
            const methods = metaData[lifeCycleMethod];
            if (methods) methods.forEach((methodName)=>{
                if (methodName != methodToIgnore) allMethods[methodName] = true;
            });
        });
        const allMethodsList = Object.keys(allMethods);
        allMethodsList.forEach((methodName)=>beanInstance[methodName]());
    }
    getBean(name) {
        return this.lookupBeanInstance("getBean", name, true);
    }
    destroy() {
        if (this.destroyed) return;
        this.destroyed = true;
        this.logger.log(">> Shutting down ag-Application Context");
        const beanInstances = this.getBeanInstances();
        this.destroyBeans(beanInstances);
        this.contextParams.providedBeanInstances = null;
        $437b23f6a393c3bf$export$dc053975cc7f6c11.__unRegisterGridModules(this.contextParams.gridId);
        this.logger.log(">> ag-Application Context shut down - component is dead");
    }
    destroyBean(bean) {
        if (!bean) return;
        this.destroyBeans([
            bean
        ]);
    }
    destroyBeans(beans) {
        if (!beans) return [];
        beans.forEach((bean)=>{
            this.callLifeCycleMethodsOnBean(bean, "preDestroyMethods", "destroy");
            const beanAny = bean;
            if (typeof beanAny.destroy === "function") beanAny.destroy();
        });
        return [];
    }
    isDestroyed() {
        return this.destroyed;
    }
    getGridId() {
        return this.contextParams.gridId;
    }
};
function $437b23f6a393c3bf$export$e99736521cbcf94e(target, methodName, descriptor) {
    const props = $437b23f6a393c3bf$var$getOrCreateProps(target.constructor);
    if (!props.preConstructMethods) props.preConstructMethods = [];
    props.preConstructMethods.push(methodName);
}
function $437b23f6a393c3bf$export$e7d0339d3610248e(target, methodName, descriptor) {
    const props = $437b23f6a393c3bf$var$getOrCreateProps(target.constructor);
    if (!props.postConstructMethods) props.postConstructMethods = [];
    props.postConstructMethods.push(methodName);
}
function $437b23f6a393c3bf$export$cc3f3d4529c57d95(target, methodName, descriptor) {
    const props = $437b23f6a393c3bf$var$getOrCreateProps(target.constructor);
    if (!props.preDestroyMethods) props.preDestroyMethods = [];
    props.preDestroyMethods.push(methodName);
}
function $437b23f6a393c3bf$export$24f477b6454bfaa9(beanName) {
    return (classConstructor)=>{
        const props = $437b23f6a393c3bf$var$getOrCreateProps(classConstructor);
        props.beanName = beanName;
    };
}
function $437b23f6a393c3bf$export$4bf29303185cb747(name) {
    return (target, propertyKey, descriptor)=>{
        $437b23f6a393c3bf$var$autowiredFunc(target, name, false, target, propertyKey, null);
    };
}
function $437b23f6a393c3bf$export$7acb7b24c478f9c6(name) {
    return (target, propertyKey, descriptor)=>{
        $437b23f6a393c3bf$var$autowiredFunc(target, name, true, target, propertyKey, null);
    };
}
function $437b23f6a393c3bf$var$autowiredFunc(target, name, optional, classPrototype, methodOrAttributeName, index) {
    if (name === null) {
        console.error("AG Grid: Autowired name should not be null");
        return;
    }
    if (typeof index === "number") {
        console.error("AG Grid: Autowired should be on an attribute");
        return;
    }
    const props = $437b23f6a393c3bf$var$getOrCreateProps(target.constructor);
    if (!props.agClassAttributes) props.agClassAttributes = [];
    props.agClassAttributes.push({
        attributeName: methodOrAttributeName,
        beanName: name,
        optional: optional
    });
}
function $437b23f6a393c3bf$export$c3215dfb7fd4803b(name) {
    return (classPrototype, methodOrAttributeName, index)=>{
        const constructor = typeof classPrototype == "function" ? classPrototype : classPrototype.constructor;
        let props;
        if (typeof index === "number") {
            let methodName;
            if (methodOrAttributeName) {
                props = $437b23f6a393c3bf$var$getOrCreateProps(constructor);
                methodName = methodOrAttributeName;
            } else {
                props = $437b23f6a393c3bf$var$getOrCreateProps(constructor);
                methodName = "agConstructor";
            }
            if (!props.autowireMethods) props.autowireMethods = {};
            if (!props.autowireMethods[methodName]) props.autowireMethods[methodName] = {};
            props.autowireMethods[methodName][index] = name;
        }
    };
}
function $437b23f6a393c3bf$var$getOrCreateProps(target) {
    if (!target.hasOwnProperty("__agBeanMetaData")) target.__agBeanMetaData = {};
    return target.__agBeanMetaData;
}
// community-modules/core/src/eventService.ts
var $437b23f6a393c3bf$export$895d7dc49f082ca1 = class {
    constructor(){
        this.allSyncListeners = /* @__PURE__ */ new Map();
        this.allAsyncListeners = /* @__PURE__ */ new Map();
        this.globalSyncListeners = /* @__PURE__ */ new Set();
        this.globalAsyncListeners = /* @__PURE__ */ new Set();
        this.asyncFunctionsQueue = [];
        this.scheduled = false;
        // using an object performs better than a Set for the number of different events we have
        this.firedEvents = {};
    }
    // because this class is used both inside the context and outside the context, we do not
    // use autowired attributes, as that would be confusing, as sometimes the attributes
    // would be wired, and sometimes not.
    //
    // the global event servers used by AG Grid is autowired by the context once, and this
    // setBeans method gets called once.
    //
    // the times when this class is used outside of the context (eg RowNode has an instance of this
    // class) then it is not a bean, and this setBeans method is not called.
    setBeans(gos, frameworkOverrides, globalEventListener = null, globalSyncEventListener = null) {
        this.frameworkOverrides = frameworkOverrides;
        this.gos = gos;
        if (globalEventListener) {
            const async = gos.useAsyncEvents();
            this.addGlobalListener(globalEventListener, async);
        }
        if (globalSyncEventListener) this.addGlobalListener(globalSyncEventListener, false);
    }
    setFrameworkOverrides(frameworkOverrides) {
        this.frameworkOverrides = frameworkOverrides;
    }
    getListeners(eventType, async, autoCreateListenerCollection) {
        const listenerMap = async ? this.allAsyncListeners : this.allSyncListeners;
        let listeners = listenerMap.get(eventType);
        if (!listeners && autoCreateListenerCollection) {
            listeners = /* @__PURE__ */ new Set();
            listenerMap.set(eventType, listeners);
        }
        return listeners;
    }
    noRegisteredListenersExist() {
        return this.allSyncListeners.size === 0 && this.allAsyncListeners.size === 0 && this.globalSyncListeners.size === 0 && this.globalAsyncListeners.size === 0;
    }
    addEventListener(eventType, listener, async = false) {
        this.getListeners(eventType, async, true).add(listener);
    }
    removeEventListener(eventType, listener, async = false) {
        const listeners = this.getListeners(eventType, async, false);
        if (!listeners) return;
        listeners.delete(listener);
        if (listeners.size === 0) {
            const listenerMap = async ? this.allAsyncListeners : this.allSyncListeners;
            listenerMap.delete(eventType);
        }
    }
    addGlobalListener(listener, async = false) {
        (async ? this.globalAsyncListeners : this.globalSyncListeners).add(listener);
    }
    removeGlobalListener(listener, async = false) {
        (async ? this.globalAsyncListeners : this.globalSyncListeners).delete(listener);
    }
    dispatchEvent(event) {
        let agEvent = event;
        if (this.gos) this.gos.addGridCommonParams(agEvent);
        this.dispatchToListeners(agEvent, true);
        this.dispatchToListeners(agEvent, false);
        this.firedEvents[agEvent.type] = true;
    }
    dispatchEventOnce(event) {
        if (!this.firedEvents[event.type]) this.dispatchEvent(event);
    }
    dispatchToListeners(event, async) {
        var _a;
        const eventType = event.type;
        if (async && "event" in event) {
            const browserEvent = event.event;
            if (browserEvent instanceof Event) event.eventPath = browserEvent.composedPath();
        }
        const processEventListeners = (listeners2, originalListeners2)=>listeners2.forEach((listener)=>{
                if (!originalListeners2.has(listener)) return;
                const callback = this.frameworkOverrides ? ()=>this.frameworkOverrides.wrapIncoming(()=>listener(event)) : ()=>listener(event);
                if (async) this.dispatchAsync(callback);
                else callback();
            });
        const originalListeners = (_a = this.getListeners(eventType, async, false)) != null ? _a : /* @__PURE__ */ new Set();
        const listeners = new Set(originalListeners);
        if (listeners.size > 0) processEventListeners(listeners, originalListeners);
        const globalListeners = new Set(async ? this.globalAsyncListeners : this.globalSyncListeners);
        globalListeners.forEach((listener)=>{
            const callback = this.frameworkOverrides ? ()=>this.frameworkOverrides.wrapIncoming(()=>listener(eventType, event)) : ()=>listener(eventType, event);
            if (async) this.dispatchAsync(callback);
            else callback();
        });
    }
    // this gets called inside the grid's thread, for each event that it
    // wants to set async. the grid then batches the events into one setTimeout()
    // because setTimeout() is an expensive operation. ideally we would have
    // each event in it's own setTimeout(), but we batch for performance.
    dispatchAsync(func) {
        this.asyncFunctionsQueue.push(func);
        if (!this.scheduled) {
            this.frameworkOverrides.wrapIncoming(()=>{
                window.setTimeout(this.flushAsyncQueue.bind(this), 0);
            });
            this.scheduled = true;
        }
    }
    // this happens in the next VM turn only, and empties the queue of events
    flushAsyncQueue() {
        this.scheduled = false;
        const queueCopy = this.asyncFunctionsQueue.slice();
        this.asyncFunctionsQueue = [];
        queueCopy.forEach((func)=>func());
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$var$__decorateParam(0, $437b23f6a393c3bf$export$c3215dfb7fd4803b("gridOptionsService")),
    $437b23f6a393c3bf$var$__decorateParam(1, $437b23f6a393c3bf$export$c3215dfb7fd4803b("frameworkOverrides")),
    $437b23f6a393c3bf$var$__decorateParam(2, $437b23f6a393c3bf$export$c3215dfb7fd4803b("globalEventListener")),
    $437b23f6a393c3bf$var$__decorateParam(3, $437b23f6a393c3bf$export$c3215dfb7fd4803b("globalSyncEventListener"))
], $437b23f6a393c3bf$export$895d7dc49f082ca1.prototype, "setBeans", 1);
$437b23f6a393c3bf$export$895d7dc49f082ca1 = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("eventService")
], $437b23f6a393c3bf$export$895d7dc49f082ca1);
// community-modules/core/src/misc/frameworkEventListenerService.ts
var $437b23f6a393c3bf$var$FrameworkEventListenerService = class {
    constructor(frameworkOverrides){
        this.frameworkOverrides = frameworkOverrides;
        // Map from user listener to wrapped listener so we can remove listener provided by user
        this.wrappedListeners = /* @__PURE__ */ new Map();
        this.wrappedGlobalListeners = /* @__PURE__ */ new Map();
    }
    wrap(userListener) {
        let listener = userListener;
        if (this.frameworkOverrides.shouldWrapOutgoing) {
            listener = (event)=>{
                this.frameworkOverrides.wrapOutgoing(()=>userListener(event));
            };
            this.wrappedListeners.set(userListener, listener);
        }
        return listener;
    }
    wrapGlobal(userListener) {
        let listener = userListener;
        if (this.frameworkOverrides.shouldWrapOutgoing) {
            listener = (eventType, event)=>{
                this.frameworkOverrides.wrapOutgoing(()=>userListener(eventType, event));
            };
            this.wrappedGlobalListeners.set(userListener, listener);
        }
        return listener;
    }
    unwrap(userListener) {
        var _a;
        return (_a = this.wrappedListeners.get(userListener)) != null ? _a : userListener;
    }
    unwrapGlobal(userListener) {
        var _a;
        return (_a = this.wrappedGlobalListeners.get(userListener)) != null ? _a : userListener;
    }
};
// community-modules/core/src/entities/column.ts
var $437b23f6a393c3bf$var$COL_DEF_DEFAULTS = {
    resizable: true,
    sortable: true
};
var $437b23f6a393c3bf$var$instanceIdSequence = 0;
function $437b23f6a393c3bf$var$getNextColInstanceId() {
    return $437b23f6a393c3bf$var$instanceIdSequence++;
}
var $437b23f6a393c3bf$var$_Column = class _Column {
    constructor(colDef, userProvidedColDef, colId, primary){
        // used by React (and possibly other frameworks) as key for rendering. also used to
        // identify old vs new columns for destroying cols when no longer used.
        this.instanceId = $437b23f6a393c3bf$var$getNextColInstanceId();
        // The measured height of this column's header when autoHeaderHeight is enabled
        this.autoHeaderHeight = null;
        this.moving = false;
        this.menuVisible = false;
        this.lastLeftPinned = false;
        this.firstRightPinned = false;
        this.filterActive = false;
        this.eventService = new $437b23f6a393c3bf$export$895d7dc49f082ca1();
        this.tooltipEnabled = false;
        this.rowGroupActive = false;
        this.pivotActive = false;
        this.aggregationActive = false;
        this.colDef = colDef;
        this.userProvidedColDef = userProvidedColDef;
        this.colId = colId;
        this.primary = primary;
        this.setState(colDef);
    }
    getInstanceId() {
        return this.instanceId;
    }
    setState(colDef) {
        if (colDef.sort !== void 0) {
            if (colDef.sort === "asc" || colDef.sort === "desc") this.sort = colDef.sort;
        } else if (colDef.initialSort === "asc" || colDef.initialSort === "desc") this.sort = colDef.initialSort;
        const sortIndex = colDef.sortIndex;
        const initialSortIndex = colDef.initialSortIndex;
        if (sortIndex !== void 0) {
            if (sortIndex !== null) this.sortIndex = sortIndex;
        } else if (initialSortIndex !== null) this.sortIndex = initialSortIndex;
        const hide = colDef.hide;
        const initialHide = colDef.initialHide;
        if (hide !== void 0) this.visible = !hide;
        else this.visible = !initialHide;
        if (colDef.pinned !== void 0) this.setPinned(colDef.pinned);
        else this.setPinned(colDef.initialPinned);
        const flex = colDef.flex;
        const initialFlex = colDef.initialFlex;
        if (flex !== void 0) this.flex = flex;
        else if (initialFlex !== void 0) this.flex = initialFlex;
    }
    // gets called when user provides an alternative colDef, eg
    setColDef(colDef, userProvidedColDef, source) {
        this.colDef = colDef;
        this.userProvidedColDef = userProvidedColDef;
        this.initMinAndMaxWidths();
        this.initDotNotation();
        this.initTooltip();
        this.eventService.dispatchEvent(this.createColumnEvent("colDefChanged", source));
    }
    /**
   * Returns the column definition provided by the application.
   * This may not be correct, as items can be superseded by default column options.
   * However it's useful for comparison, eg to know which application column definition matches that column.
   */ getUserProvidedColDef() {
        return this.userProvidedColDef;
    }
    setParent(parent) {
        this.parent = parent;
    }
    /** Returns the parent column group, if column grouping is active. */ getParent() {
        return this.parent;
    }
    setOriginalParent(originalParent) {
        this.originalParent = originalParent;
    }
    /**
   * Used for marryChildren, helps with comparing when duplicate groups have been created to manage split groups.
   * 
   * Parent may contain a duplicate but not identical group when the group is split.
   */ getOriginalParent() {
        return this.originalParent;
    }
    initialise() {
        this.initMinAndMaxWidths();
        this.resetActualWidth("gridInitializing");
        this.initDotNotation();
        this.initTooltip();
    }
    initDotNotation() {
        const suppressDotNotation = this.gos.get("suppressFieldDotNotation");
        this.fieldContainsDots = $437b23f6a393c3bf$var$exists(this.colDef.field) && this.colDef.field.indexOf(".") >= 0 && !suppressDotNotation;
        this.tooltipFieldContainsDots = $437b23f6a393c3bf$var$exists(this.colDef.tooltipField) && this.colDef.tooltipField.indexOf(".") >= 0 && !suppressDotNotation;
    }
    initMinAndMaxWidths() {
        var _a, _b;
        const colDef = this.colDef;
        this.minWidth = (_a = colDef.minWidth) != null ? _a : this.environment.getMinColWidth();
        this.maxWidth = (_b = colDef.maxWidth) != null ? _b : Number.MAX_SAFE_INTEGER;
    }
    initTooltip() {
        this.tooltipEnabled = $437b23f6a393c3bf$var$exists(this.colDef.tooltipField) || $437b23f6a393c3bf$var$exists(this.colDef.tooltipValueGetter) || $437b23f6a393c3bf$var$exists(this.colDef.tooltipComponent);
    }
    resetActualWidth(source) {
        const initialWidth = this.calculateColInitialWidth(this.colDef);
        this.setActualWidth(initialWidth, source, true);
    }
    calculateColInitialWidth(colDef) {
        var _a, _b;
        const minColWidth = (_a = colDef.minWidth) != null ? _a : this.environment.getMinColWidth();
        const maxColWidth = (_b = colDef.maxWidth) != null ? _b : Number.MAX_SAFE_INTEGER;
        let width;
        const colDefWidth = $437b23f6a393c3bf$var$attrToNumber(colDef.width);
        const colDefInitialWidth = $437b23f6a393c3bf$var$attrToNumber(colDef.initialWidth);
        if (colDefWidth != null) width = colDefWidth;
        else if (colDefInitialWidth != null) width = colDefInitialWidth;
        else width = 200;
        return Math.max(Math.min(width, maxColWidth), minColWidth);
    }
    isEmptyGroup() {
        return false;
    }
    isRowGroupDisplayed(colId) {
        if ($437b23f6a393c3bf$var$missing(this.colDef) || $437b23f6a393c3bf$var$missing(this.colDef.showRowGroup)) return false;
        const showingAllGroups = this.colDef.showRowGroup === true;
        const showingThisGroup = this.colDef.showRowGroup === colId;
        return showingAllGroups || showingThisGroup;
    }
    /** Returns `true` if column is a primary column, `false` if secondary. Secondary columns are used for pivoting. */ isPrimary() {
        return this.primary;
    }
    /** Returns `true` if column filtering is allowed. */ isFilterAllowed() {
        const filterDefined = !!this.colDef.filter;
        return filterDefined;
    }
    isFieldContainsDots() {
        return this.fieldContainsDots;
    }
    isTooltipEnabled() {
        return this.tooltipEnabled;
    }
    isTooltipFieldContainsDots() {
        return this.tooltipFieldContainsDots;
    }
    /** Add an event listener to the column. */ addEventListener(eventType, userListener) {
        var _a, _b;
        if (this.frameworkOverrides.shouldWrapOutgoing && !this.frameworkEventListenerService) {
            this.eventService.setFrameworkOverrides(this.frameworkOverrides);
            this.frameworkEventListenerService = new $437b23f6a393c3bf$var$FrameworkEventListenerService(this.frameworkOverrides);
        }
        const listener = (_b = (_a = this.frameworkEventListenerService) == null ? void 0 : _a.wrap(userListener)) != null ? _b : userListener;
        this.eventService.addEventListener(eventType, listener);
    }
    /** Remove event listener from the column. */ removeEventListener(eventType, userListener) {
        var _a, _b;
        const listener = (_b = (_a = this.frameworkEventListenerService) == null ? void 0 : _a.unwrap(userListener)) != null ? _b : userListener;
        this.eventService.removeEventListener(eventType, listener);
    }
    createColumnFunctionCallbackParams(rowNode) {
        return this.gos.addGridCommonParams({
            node: rowNode,
            data: rowNode.data,
            column: this,
            colDef: this.colDef
        });
    }
    isSuppressNavigable(rowNode) {
        if (typeof this.colDef.suppressNavigable === "boolean") return this.colDef.suppressNavigable;
        if (typeof this.colDef.suppressNavigable === "function") {
            const params = this.createColumnFunctionCallbackParams(rowNode);
            const userFunc = this.colDef.suppressNavigable;
            return userFunc(params);
        }
        return false;
    }
    /**
   * Returns `true` if the cell for this column is editable for the given `rowNode`, otherwise `false`.
   */ isCellEditable(rowNode) {
        if (rowNode.group && !this.gos.get("enableGroupEdit")) return false;
        return this.isColumnFunc(rowNode, this.colDef.editable);
    }
    isSuppressFillHandle() {
        return !!this.colDef.suppressFillHandle;
    }
    isAutoHeight() {
        return !!this.colDef.autoHeight;
    }
    isAutoHeaderHeight() {
        return !!this.colDef.autoHeaderHeight;
    }
    isRowDrag(rowNode) {
        return this.isColumnFunc(rowNode, this.colDef.rowDrag);
    }
    isDndSource(rowNode) {
        return this.isColumnFunc(rowNode, this.colDef.dndSource);
    }
    isCellCheckboxSelection(rowNode) {
        return this.isColumnFunc(rowNode, this.colDef.checkboxSelection);
    }
    isSuppressPaste(rowNode) {
        return this.isColumnFunc(rowNode, this.colDef ? this.colDef.suppressPaste : null);
    }
    isResizable() {
        return !!this.getColDefValue("resizable");
    }
    /** Get value from ColDef or default if it exists. */ getColDefValue(key) {
        var _a;
        return (_a = this.colDef[key]) != null ? _a : $437b23f6a393c3bf$var$COL_DEF_DEFAULTS[key];
    }
    isColumnFunc(rowNode, value) {
        if (typeof value === "boolean") return value;
        if (typeof value === "function") {
            const params = this.createColumnFunctionCallbackParams(rowNode);
            const editableFunc = value;
            return editableFunc(params);
        }
        return false;
    }
    setMoving(moving, source) {
        this.moving = moving;
        this.eventService.dispatchEvent(this.createColumnEvent("movingChanged", source));
    }
    createColumnEvent(type, source) {
        return this.gos.addGridCommonParams({
            type: type,
            column: this,
            columns: [
                this
            ],
            source: source
        });
    }
    isMoving() {
        return this.moving;
    }
    /** If sorting is active, returns the sort direction e.g. `'asc'` or `'desc'`. */ getSort() {
        return this.sort;
    }
    setSort(sort, source) {
        if (this.sort !== sort) {
            this.sort = sort;
            this.eventService.dispatchEvent(this.createColumnEvent("sortChanged", source));
        }
        this.dispatchStateUpdatedEvent("sort");
    }
    setMenuVisible(visible, source) {
        if (this.menuVisible !== visible) {
            this.menuVisible = visible;
            this.eventService.dispatchEvent(this.createColumnEvent("menuVisibleChanged", source));
        }
    }
    isMenuVisible() {
        return this.menuVisible;
    }
    isSortable() {
        return !!this.getColDefValue("sortable");
    }
    isSortAscending() {
        return this.sort === "asc";
    }
    isSortDescending() {
        return this.sort === "desc";
    }
    isSortNone() {
        return $437b23f6a393c3bf$var$missing(this.sort);
    }
    isSorting() {
        return $437b23f6a393c3bf$var$exists(this.sort);
    }
    getSortIndex() {
        return this.sortIndex;
    }
    setSortIndex(sortOrder) {
        this.sortIndex = sortOrder;
        this.dispatchStateUpdatedEvent("sortIndex");
    }
    setAggFunc(aggFunc) {
        this.aggFunc = aggFunc;
        this.dispatchStateUpdatedEvent("aggFunc");
    }
    /** If aggregation is set for the column, returns the aggregation function. */ getAggFunc() {
        return this.aggFunc;
    }
    getLeft() {
        return this.left;
    }
    getOldLeft() {
        return this.oldLeft;
    }
    getRight() {
        return this.left + this.actualWidth;
    }
    setLeft(left, source) {
        this.oldLeft = this.left;
        if (this.left !== left) {
            this.left = left;
            this.eventService.dispatchEvent(this.createColumnEvent("leftChanged", source));
        }
    }
    /** Returns `true` if filter is active on the column. */ isFilterActive() {
        return this.filterActive;
    }
    // additionalEventAttributes is used by provided simple floating filter, so it can add 'floatingFilter=true' to the event
    setFilterActive(active, source, additionalEventAttributes) {
        if (this.filterActive !== active) {
            this.filterActive = active;
            this.eventService.dispatchEvent(this.createColumnEvent("filterActiveChanged", source));
        }
        const filterChangedEvent = this.createColumnEvent("filterChanged", source);
        if (additionalEventAttributes) $437b23f6a393c3bf$var$mergeDeep(filterChangedEvent, additionalEventAttributes);
        this.eventService.dispatchEvent(filterChangedEvent);
    }
    /** Returns `true` when this `Column` is hovered, otherwise `false` */ isHovered() {
        return this.columnHoverService.isHovered(this);
    }
    setPinned(pinned) {
        if (pinned === true || pinned === "left") this.pinned = "left";
        else if (pinned === "right") this.pinned = "right";
        else this.pinned = null;
        this.dispatchStateUpdatedEvent("pinned");
    }
    setFirstRightPinned(firstRightPinned, source) {
        if (this.firstRightPinned !== firstRightPinned) {
            this.firstRightPinned = firstRightPinned;
            this.eventService.dispatchEvent(this.createColumnEvent("firstRightPinnedChanged", source));
        }
    }
    setLastLeftPinned(lastLeftPinned, source) {
        if (this.lastLeftPinned !== lastLeftPinned) {
            this.lastLeftPinned = lastLeftPinned;
            this.eventService.dispatchEvent(this.createColumnEvent("lastLeftPinnedChanged", source));
        }
    }
    isFirstRightPinned() {
        return this.firstRightPinned;
    }
    isLastLeftPinned() {
        return this.lastLeftPinned;
    }
    isPinned() {
        return this.pinned === "left" || this.pinned === "right";
    }
    isPinnedLeft() {
        return this.pinned === "left";
    }
    isPinnedRight() {
        return this.pinned === "right";
    }
    getPinned() {
        return this.pinned;
    }
    setVisible(visible, source) {
        const newValue = visible === true;
        if (this.visible !== newValue) {
            this.visible = newValue;
            this.eventService.dispatchEvent(this.createColumnEvent("visibleChanged", source));
        }
        this.dispatchStateUpdatedEvent("hide");
    }
    isVisible() {
        return this.visible;
    }
    isSpanHeaderHeight() {
        const colDef = this.getColDef();
        return !colDef.suppressSpanHeaderHeight && !colDef.autoHeaderHeight;
    }
    getColumnGroupPaddingInfo() {
        let parent = this.getParent();
        if (!parent || !parent.isPadding()) return {
            numberOfParents: 0,
            isSpanningTotal: false
        };
        const numberOfParents = parent.getPaddingLevel() + 1;
        let isSpanningTotal = true;
        while(parent){
            if (!parent.isPadding()) {
                isSpanningTotal = false;
                break;
            }
            parent = parent.getParent();
        }
        return {
            numberOfParents: numberOfParents,
            isSpanningTotal: isSpanningTotal
        };
    }
    /** Returns the column definition for this column.
   * The column definition will be the result of merging the application provided column definition with any provided defaults
   * (e.g. `defaultColDef` grid option, or column types.
   *
   * Equivalent: `getDefinition` */ getColDef() {
        return this.colDef;
    }
    getColumnGroupShow() {
        return this.colDef.columnGroupShow;
    }
    /**
   * Returns the unique ID for the column.
   *
   * Equivalent: `getId`, `getUniqueId` */ getColId() {
        return this.colId;
    }
    /**
   * Returns the unique ID for the column.
   *
   * Equivalent: `getColId`, `getUniqueId` */ getId() {
        return this.colId;
    }
    /**
   * Returns the unique ID for the column.
   *
   * Equivalent: `getColId`, `getId` */ getUniqueId() {
        return this.colId;
    }
    getDefinition() {
        return this.colDef;
    }
    /** Returns the current width of the column. If the column is resized, the actual width is the new size. */ getActualWidth() {
        return this.actualWidth;
    }
    getAutoHeaderHeight() {
        return this.autoHeaderHeight;
    }
    /** Returns true if the header height has changed */ setAutoHeaderHeight(height) {
        const changed = height !== this.autoHeaderHeight;
        this.autoHeaderHeight = height;
        return changed;
    }
    createBaseColDefParams(rowNode) {
        const params = this.gos.addGridCommonParams({
            node: rowNode,
            data: rowNode.data,
            colDef: this.colDef,
            column: this
        });
        return params;
    }
    getColSpan(rowNode) {
        if ($437b23f6a393c3bf$var$missing(this.colDef.colSpan)) return 1;
        const params = this.createBaseColDefParams(rowNode);
        const colSpan = this.colDef.colSpan(params);
        return Math.max(colSpan, 1);
    }
    getRowSpan(rowNode) {
        if ($437b23f6a393c3bf$var$missing(this.colDef.rowSpan)) return 1;
        const params = this.createBaseColDefParams(rowNode);
        const rowSpan = this.colDef.rowSpan(params);
        return Math.max(rowSpan, 1);
    }
    setActualWidth(actualWidth, source, silent = false) {
        if (this.minWidth != null) actualWidth = Math.max(actualWidth, this.minWidth);
        if (this.maxWidth != null) actualWidth = Math.min(actualWidth, this.maxWidth);
        if (this.actualWidth !== actualWidth) {
            this.actualWidth = actualWidth;
            if (this.flex && source !== "flex" && source !== "gridInitializing") this.flex = null;
            if (!silent) this.fireColumnWidthChangedEvent(source);
        }
        this.dispatchStateUpdatedEvent("width");
    }
    fireColumnWidthChangedEvent(source) {
        this.eventService.dispatchEvent(this.createColumnEvent("widthChanged", source));
    }
    isGreaterThanMax(width) {
        if (this.maxWidth != null) return width > this.maxWidth;
        return false;
    }
    getMinWidth() {
        return this.minWidth;
    }
    getMaxWidth() {
        return this.maxWidth;
    }
    getFlex() {
        return this.flex || 0;
    }
    // this method should only be used by the columnModel to
    // change flex when required by the applyColumnState method.
    setFlex(flex) {
        if (this.flex !== flex) this.flex = flex;
        this.dispatchStateUpdatedEvent("flex");
    }
    setMinimum(source) {
        if ($437b23f6a393c3bf$var$exists(this.minWidth)) this.setActualWidth(this.minWidth, source);
    }
    setRowGroupActive(rowGroup, source) {
        if (this.rowGroupActive !== rowGroup) {
            this.rowGroupActive = rowGroup;
            this.eventService.dispatchEvent(this.createColumnEvent("columnRowGroupChanged", source));
        }
        this.dispatchStateUpdatedEvent("rowGroup");
    }
    /** Returns `true` if row group is currently active for this column. */ isRowGroupActive() {
        return this.rowGroupActive;
    }
    setPivotActive(pivot, source) {
        if (this.pivotActive !== pivot) {
            this.pivotActive = pivot;
            this.eventService.dispatchEvent(this.createColumnEvent("columnPivotChanged", source));
        }
        this.dispatchStateUpdatedEvent("pivot");
    }
    /** Returns `true` if pivot is currently active for this column. */ isPivotActive() {
        return this.pivotActive;
    }
    isAnyFunctionActive() {
        return this.isPivotActive() || this.isRowGroupActive() || this.isValueActive();
    }
    isAnyFunctionAllowed() {
        return this.isAllowPivot() || this.isAllowRowGroup() || this.isAllowValue();
    }
    setValueActive(value, source) {
        if (this.aggregationActive !== value) {
            this.aggregationActive = value;
            this.eventService.dispatchEvent(this.createColumnEvent("columnValueChanged", source));
        }
    }
    /** Returns `true` if value (aggregation) is currently active for this column. */ isValueActive() {
        return this.aggregationActive;
    }
    isAllowPivot() {
        return this.colDef.enablePivot === true;
    }
    isAllowValue() {
        return this.colDef.enableValue === true;
    }
    isAllowRowGroup() {
        return this.colDef.enableRowGroup === true;
    }
    /**
   * @deprecated v31.1 Use `getColDef().menuTabs ?? defaultValues` instead.
   */ getMenuTabs(defaultValues) {
        $437b23f6a393c3bf$var$warnOnce(`As of v31.1, 'getMenuTabs' is deprecated. Use 'getColDef().menuTabs ?? defaultValues' instead.`);
        let menuTabs = this.getColDef().menuTabs;
        if (menuTabs == null) menuTabs = defaultValues;
        return menuTabs;
    }
    dispatchStateUpdatedEvent(key) {
        this.eventService.dispatchEvent({
            type: _Column.EVENT_STATE_UPDATED,
            key: key
        });
    }
};
// + renderedHeaderCell - for making header cell transparent when moving
$437b23f6a393c3bf$var$_Column.EVENT_MOVING_CHANGED = "movingChanged";
// + renderedCell - changing left position
$437b23f6a393c3bf$var$_Column.EVENT_LEFT_CHANGED = "leftChanged";
// + renderedCell - changing width
$437b23f6a393c3bf$var$_Column.EVENT_WIDTH_CHANGED = "widthChanged";
// + renderedCell - for changing pinned classes
$437b23f6a393c3bf$var$_Column.EVENT_LAST_LEFT_PINNED_CHANGED = "lastLeftPinnedChanged";
$437b23f6a393c3bf$var$_Column.EVENT_FIRST_RIGHT_PINNED_CHANGED = "firstRightPinnedChanged";
// + renderedColumn - for changing visibility icon
$437b23f6a393c3bf$var$_Column.EVENT_VISIBLE_CHANGED = "visibleChanged";
// + every time the filter changes, used in the floating filters
$437b23f6a393c3bf$var$_Column.EVENT_FILTER_CHANGED = "filterChanged";
// + renderedHeaderCell - marks the header with filter icon
$437b23f6a393c3bf$var$_Column.EVENT_FILTER_ACTIVE_CHANGED = "filterActiveChanged";
// + renderedHeaderCell - marks the header with sort icon
$437b23f6a393c3bf$var$_Column.EVENT_SORT_CHANGED = "sortChanged";
// + renderedHeaderCell - marks the header with sort icon
$437b23f6a393c3bf$var$_Column.EVENT_COL_DEF_CHANGED = "colDefChanged";
$437b23f6a393c3bf$var$_Column.EVENT_MENU_VISIBLE_CHANGED = "menuVisibleChanged";
// + toolpanel, for gui updates
$437b23f6a393c3bf$var$_Column.EVENT_ROW_GROUP_CHANGED = "columnRowGroupChanged";
// + toolpanel, for gui updates
$437b23f6a393c3bf$var$_Column.EVENT_PIVOT_CHANGED = "columnPivotChanged";
// + toolpanel, for gui updates
$437b23f6a393c3bf$var$_Column.EVENT_VALUE_CHANGED = "columnValueChanged";
// + dataTypeService - when waiting to infer cell data types
$437b23f6a393c3bf$var$_Column.EVENT_STATE_UPDATED = "columnStateUpdated";
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("gridOptionsService")
], $437b23f6a393c3bf$var$_Column.prototype, "gos", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("environment")
], $437b23f6a393c3bf$var$_Column.prototype, "environment", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnHoverService")
], $437b23f6a393c3bf$var$_Column.prototype, "columnHoverService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("frameworkOverrides")
], $437b23f6a393c3bf$var$_Column.prototype, "frameworkOverrides", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$_Column.prototype, "initialise", 1);
var $437b23f6a393c3bf$export$816b5d811295e6bc = $437b23f6a393c3bf$var$_Column;
// community-modules/core/src/entities/providedColumnGroup.ts
var $437b23f6a393c3bf$var$_ProvidedColumnGroup = class _ProvidedColumnGroup {
    constructor(colGroupDef, groupId, padding, level){
        this.localEventService = new $437b23f6a393c3bf$export$895d7dc49f082ca1();
        this.expandable = false;
        // used by React (and possibly other frameworks) as key for rendering. also used to
        // identify old vs new columns for destroying cols when no longer used.
        this.instanceId = $437b23f6a393c3bf$var$getNextColInstanceId();
        this.expandableListenerRemoveCallback = null;
        this.colGroupDef = colGroupDef;
        this.groupId = groupId;
        this.expanded = !!colGroupDef && !!colGroupDef.openByDefault;
        this.padding = padding;
        this.level = level;
    }
    destroy() {
        if (this.expandableListenerRemoveCallback) this.reset(null, void 0);
    }
    reset(colGroupDef, level) {
        this.colGroupDef = colGroupDef;
        this.level = level;
        this.originalParent = null;
        if (this.expandableListenerRemoveCallback) this.expandableListenerRemoveCallback();
        this.children = void 0;
        this.expandable = void 0;
    }
    getInstanceId() {
        return this.instanceId;
    }
    setOriginalParent(originalParent) {
        this.originalParent = originalParent;
    }
    getOriginalParent() {
        return this.originalParent;
    }
    getLevel() {
        return this.level;
    }
    isVisible() {
        if (this.children) return this.children.some((child)=>child.isVisible());
        return false;
    }
    isPadding() {
        return this.padding;
    }
    setExpanded(expanded) {
        this.expanded = expanded === void 0 ? false : expanded;
        const event = {
            type: _ProvidedColumnGroup.EVENT_EXPANDED_CHANGED
        };
        this.localEventService.dispatchEvent(event);
    }
    isExpandable() {
        return this.expandable;
    }
    isExpanded() {
        return this.expanded;
    }
    getGroupId() {
        return this.groupId;
    }
    getId() {
        return this.getGroupId();
    }
    setChildren(children) {
        this.children = children;
    }
    getChildren() {
        return this.children;
    }
    getColGroupDef() {
        return this.colGroupDef;
    }
    getLeafColumns() {
        const result = [];
        this.addLeafColumns(result);
        return result;
    }
    addLeafColumns(leafColumns) {
        if (!this.children) return;
        this.children.forEach((child)=>{
            if (child instanceof $437b23f6a393c3bf$export$816b5d811295e6bc) leafColumns.push(child);
            else if (child instanceof _ProvidedColumnGroup) child.addLeafColumns(leafColumns);
        });
    }
    getColumnGroupShow() {
        const colGroupDef = this.colGroupDef;
        if (!colGroupDef) return;
        return colGroupDef.columnGroupShow;
    }
    // need to check that this group has at least one col showing when both expanded and contracted.
    // if not, then we don't allow expanding and contracting on this group
    setupExpandable() {
        this.setExpandable();
        if (this.expandableListenerRemoveCallback) this.expandableListenerRemoveCallback();
        const listener = this.onColumnVisibilityChanged.bind(this);
        this.getLeafColumns().forEach((col)=>col.addEventListener("visibleChanged", listener));
        this.expandableListenerRemoveCallback = ()=>{
            this.getLeafColumns().forEach((col)=>col.removeEventListener("visibleChanged", listener));
            this.expandableListenerRemoveCallback = null;
        };
    }
    setExpandable() {
        if (this.isPadding()) return;
        let atLeastOneShowingWhenOpen = false;
        let atLeastOneShowingWhenClosed = false;
        let atLeastOneChangeable = false;
        const children = this.findChildrenRemovingPadding();
        for(let i = 0, j = children.length; i < j; i++){
            const abstractColumn = children[i];
            if (!abstractColumn.isVisible()) continue;
            const headerGroupShow = abstractColumn.getColumnGroupShow();
            if (headerGroupShow === "open") {
                atLeastOneShowingWhenOpen = true;
                atLeastOneChangeable = true;
            } else if (headerGroupShow === "closed") {
                atLeastOneShowingWhenClosed = true;
                atLeastOneChangeable = true;
            } else {
                atLeastOneShowingWhenOpen = true;
                atLeastOneShowingWhenClosed = true;
            }
        }
        const expandable = atLeastOneShowingWhenOpen && atLeastOneShowingWhenClosed && atLeastOneChangeable;
        if (this.expandable !== expandable) {
            this.expandable = expandable;
            const event = {
                type: _ProvidedColumnGroup.EVENT_EXPANDABLE_CHANGED
            };
            this.localEventService.dispatchEvent(event);
        }
    }
    findChildrenRemovingPadding() {
        const res = [];
        const process = (items)=>{
            items.forEach((item)=>{
                const skipBecausePadding = item instanceof _ProvidedColumnGroup && item.isPadding();
                if (skipBecausePadding) process(item.children);
                else res.push(item);
            });
        };
        process(this.children);
        return res;
    }
    onColumnVisibilityChanged() {
        this.setExpandable();
    }
    addEventListener(eventType, listener) {
        this.localEventService.addEventListener(eventType, listener);
    }
    removeEventListener(eventType, listener) {
        this.localEventService.removeEventListener(eventType, listener);
    }
};
$437b23f6a393c3bf$var$_ProvidedColumnGroup.EVENT_EXPANDED_CHANGED = "expandedChanged";
$437b23f6a393c3bf$var$_ProvidedColumnGroup.EVENT_EXPANDABLE_CHANGED = "expandableChanged";
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$cc3f3d4529c57d95
], $437b23f6a393c3bf$var$_ProvidedColumnGroup.prototype, "destroy", 1);
var $437b23f6a393c3bf$export$89dd394cd2c9e921 = $437b23f6a393c3bf$var$_ProvidedColumnGroup;
// community-modules/core/src/entities/defaultColumnTypes.ts
var $437b23f6a393c3bf$var$DefaultColumnTypes = {
    numericColumn: {
        headerClass: "ag-right-aligned-header",
        cellClass: "ag-right-aligned-cell"
    },
    rightAligned: {
        headerClass: "ag-right-aligned-header",
        cellClass: "ag-right-aligned-cell"
    }
};
// community-modules/core/src/utils/event.ts
var $437b23f6a393c3bf$var$event_exports = {};
$437b23f6a393c3bf$var$__export($437b23f6a393c3bf$var$event_exports, {
    addSafePassiveEventListener: ()=>$437b23f6a393c3bf$var$addSafePassiveEventListener,
    createEventPath: ()=>$437b23f6a393c3bf$var$createEventPath,
    getCtrlForEventTarget: ()=>$437b23f6a393c3bf$var$getCtrlForEventTarget,
    getEventPath: ()=>$437b23f6a393c3bf$var$getEventPath,
    isElementInEventPath: ()=>$437b23f6a393c3bf$var$isElementInEventPath,
    isEventSupported: ()=>$437b23f6a393c3bf$var$isEventSupported,
    isStopPropagationForAgGrid: ()=>$437b23f6a393c3bf$var$isStopPropagationForAgGrid,
    stopPropagationForAgGrid: ()=>$437b23f6a393c3bf$var$stopPropagationForAgGrid
});
// community-modules/core/src/utils/array.ts
var $437b23f6a393c3bf$var$array_exports = {};
$437b23f6a393c3bf$var$__export($437b23f6a393c3bf$var$array_exports, {
    areEqual: ()=>$437b23f6a393c3bf$var$areEqual,
    existsAndNotEmpty: ()=>$437b23f6a393c3bf$var$existsAndNotEmpty,
    flatten: ()=>$437b23f6a393c3bf$var$flatten,
    forEachReverse: ()=>$437b23f6a393c3bf$var$forEachReverse,
    includes: ()=>$437b23f6a393c3bf$var$includes,
    insertArrayIntoArray: ()=>$437b23f6a393c3bf$var$insertArrayIntoArray,
    insertIntoArray: ()=>$437b23f6a393c3bf$var$insertIntoArray,
    last: ()=>$437b23f6a393c3bf$var$last,
    moveInArray: ()=>$437b23f6a393c3bf$var$moveInArray,
    pushAll: ()=>$437b23f6a393c3bf$var$pushAll,
    removeAllFromArray: ()=>$437b23f6a393c3bf$var$removeAllFromArray,
    removeAllFromUnorderedArray: ()=>$437b23f6a393c3bf$var$removeAllFromUnorderedArray,
    removeFromArray: ()=>$437b23f6a393c3bf$var$removeFromArray,
    removeFromUnorderedArray: ()=>$437b23f6a393c3bf$var$removeFromUnorderedArray,
    removeRepeatsFromArray: ()=>$437b23f6a393c3bf$var$removeRepeatsFromArray,
    shallowCompare: ()=>$437b23f6a393c3bf$var$shallowCompare,
    sortNumerically: ()=>$437b23f6a393c3bf$var$sortNumerically,
    toStrings: ()=>$437b23f6a393c3bf$var$toStrings
});
function $437b23f6a393c3bf$var$existsAndNotEmpty(value) {
    return value != null && value.length > 0;
}
function $437b23f6a393c3bf$var$last(arr) {
    if (!arr || !arr.length) return;
    return arr[arr.length - 1];
}
function $437b23f6a393c3bf$var$areEqual(a, b, comparator) {
    if (a == null && b == null) return true;
    return a != null && b != null && a.length === b.length && a.every((value, index)=>comparator ? comparator(value, b[index]) : b[index] === value);
}
function $437b23f6a393c3bf$var$shallowCompare(arr1, arr2) {
    return $437b23f6a393c3bf$var$areEqual(arr1, arr2);
}
function $437b23f6a393c3bf$var$sortNumerically(array) {
    return array.sort((a, b)=>a - b);
}
function $437b23f6a393c3bf$var$removeRepeatsFromArray(array, object) {
    if (!array) return;
    for(let index = array.length - 2; index >= 0; index--){
        const thisOneMatches = array[index] === object;
        const nextOneMatches = array[index + 1] === object;
        if (thisOneMatches && nextOneMatches) array.splice(index + 1, 1);
    }
}
function $437b23f6a393c3bf$var$removeFromUnorderedArray(array, object) {
    const index = array.indexOf(object);
    if (index >= 0) {
        array[index] = array[array.length - 1];
        array.pop();
    }
}
function $437b23f6a393c3bf$var$removeFromArray(array, object) {
    const index = array.indexOf(object);
    if (index >= 0) array.splice(index, 1);
}
function $437b23f6a393c3bf$var$removeAllFromUnorderedArray(array, toRemove) {
    for(let i = 0; i < toRemove.length; i++)$437b23f6a393c3bf$var$removeFromUnorderedArray(array, toRemove[i]);
}
function $437b23f6a393c3bf$var$removeAllFromArray(array, toRemove) {
    for(let i = 0; i < toRemove.length; i++)$437b23f6a393c3bf$var$removeFromArray(array, toRemove[i]);
}
function $437b23f6a393c3bf$var$insertIntoArray(array, object, toIndex) {
    array.splice(toIndex, 0, object);
}
function $437b23f6a393c3bf$var$insertArrayIntoArray(dest, src, toIndex) {
    if (dest == null || src == null) return;
    for(let i = src.length - 1; i >= 0; i--){
        const item = src[i];
        $437b23f6a393c3bf$var$insertIntoArray(dest, item, toIndex);
    }
}
function $437b23f6a393c3bf$var$moveInArray(array, objectsToMove, toIndex) {
    $437b23f6a393c3bf$var$removeAllFromArray(array, objectsToMove);
    objectsToMove.slice().reverse().forEach((obj)=>$437b23f6a393c3bf$var$insertIntoArray(array, obj, toIndex));
}
function $437b23f6a393c3bf$var$includes(array, value) {
    return array.indexOf(value) > -1;
}
function $437b23f6a393c3bf$var$flatten(arrayOfArrays) {
    return [].concat.apply([], arrayOfArrays);
}
function $437b23f6a393c3bf$var$pushAll(target, source) {
    if (source == null || target == null) return;
    source.forEach((value)=>target.push(value));
}
function $437b23f6a393c3bf$var$toStrings(array) {
    return array.map($437b23f6a393c3bf$var$toStringOrNull);
}
function $437b23f6a393c3bf$var$forEachReverse(list, action) {
    if (list == null) return;
    for(let i = list.length - 1; i >= 0; i--)action(list[i], i);
}
// community-modules/core/src/utils/event.ts
var $437b23f6a393c3bf$var$AG_GRID_STOP_PROPAGATION = "__ag_Grid_Stop_Propagation";
var $437b23f6a393c3bf$var$PASSIVE_EVENTS = [
    "touchstart",
    "touchend",
    "touchmove",
    "touchcancel",
    "scroll"
];
var $437b23f6a393c3bf$var$supports = {};
function $437b23f6a393c3bf$var$stopPropagationForAgGrid(event) {
    event[$437b23f6a393c3bf$var$AG_GRID_STOP_PROPAGATION] = true;
}
function $437b23f6a393c3bf$var$isStopPropagationForAgGrid(event) {
    return event[$437b23f6a393c3bf$var$AG_GRID_STOP_PROPAGATION] === true;
}
var $437b23f6a393c3bf$var$isEventSupported = /* @__PURE__ */ (()=>{
    const tags = {
        select: "input",
        change: "input",
        submit: "form",
        reset: "form",
        error: "img",
        load: "img",
        abort: "img"
    };
    const eventChecker = (eventName)=>{
        if (typeof $437b23f6a393c3bf$var$supports[eventName] === "boolean") return $437b23f6a393c3bf$var$supports[eventName];
        const el = document.createElement(tags[eventName] || "div");
        eventName = "on" + eventName;
        return $437b23f6a393c3bf$var$supports[eventName] = eventName in el;
    };
    return eventChecker;
})();
function $437b23f6a393c3bf$var$getCtrlForEventTarget(gos, eventTarget, type) {
    let sourceElement = eventTarget;
    while(sourceElement){
        const renderedComp = gos.getDomData(sourceElement, type);
        if (renderedComp) return renderedComp;
        sourceElement = sourceElement.parentElement;
    }
    return null;
}
function $437b23f6a393c3bf$var$isElementInEventPath(element, event) {
    if (!event || !element) return false;
    return $437b23f6a393c3bf$var$getEventPath(event).indexOf(element) >= 0;
}
function $437b23f6a393c3bf$var$createEventPath(event) {
    const res = [];
    let pointer = event.target;
    while(pointer){
        res.push(pointer);
        pointer = pointer.parentElement;
    }
    return res;
}
function $437b23f6a393c3bf$var$getEventPath(event) {
    const eventNoType = event;
    if (eventNoType.path) return eventNoType.path;
    if (eventNoType.composedPath) return eventNoType.composedPath();
    return $437b23f6a393c3bf$var$createEventPath(eventNoType);
}
function $437b23f6a393c3bf$var$addSafePassiveEventListener(frameworkOverrides, eElement, event, listener) {
    const isPassive = $437b23f6a393c3bf$var$includes($437b23f6a393c3bf$var$PASSIVE_EVENTS, event);
    const options = isPassive ? {
        passive: true
    } : void 0;
    if (frameworkOverrides && frameworkOverrides.addEventListener) frameworkOverrides.addEventListener(eElement, event, listener, options);
}
// community-modules/core/src/context/beanStub.ts
var $437b23f6a393c3bf$var$_BeanStub = class _BeanStub {
    constructor(){
        this.destroyFunctions = [];
        this.destroyed = false;
        // for vue 3 - prevents Vue from trying to make this (and obviously any sub classes) from being reactive
        // prevents vue from creating proxies for created objects and prevents identity related issues
        this.__v_skip = true;
        // this was a test constructor niall built, when active, it prints after 5 seconds all beans/components that are
        // not destroyed. to use, create a new grid, then api.destroy() before 5 seconds. then anything that gets printed
        // points to a bean or component that was not properly disposed of.
        // constructor() {
        //     setTimeout(()=> {
        //         if (this.isAlive()) {
        //             let prototype: any = Object.getPrototypeOf(this);
        //             const constructor: any = prototype.constructor;
        //             const constructorString = constructor.toString();
        //             const beanName = constructorString.substring(9, constructorString.indexOf("("));
        //             console.log('is alive ' + beanName);
        //         }
        //     }, 5000);
        // }
        // Enable multiple grid properties to be updated together by the user but only trigger shared logic once.
        // Closely related to logic in ComponentUtil.ts
        this.lastChangeSetIdLookup = {};
        this.propertyListenerId = 0;
        this.isAlive = ()=>!this.destroyed;
    }
    // CellComp and GridComp and override this because they get the FrameworkOverrides from the Beans bean
    getFrameworkOverrides() {
        return this.frameworkOverrides;
    }
    getContext() {
        return this.context;
    }
    destroy() {
        for(let i = 0; i < this.destroyFunctions.length; i++)this.destroyFunctions[i]();
        this.destroyFunctions.length = 0;
        this.destroyed = true;
        this.dispatchEvent({
            type: _BeanStub.EVENT_DESTROYED
        });
    }
    addEventListener(eventType, listener) {
        if (!this.localEventService) this.localEventService = new $437b23f6a393c3bf$export$895d7dc49f082ca1();
        this.localEventService.addEventListener(eventType, listener);
    }
    removeEventListener(eventType, listener) {
        if (this.localEventService) this.localEventService.removeEventListener(eventType, listener);
    }
    dispatchEvent(event) {
        if (this.localEventService) this.localEventService.dispatchEvent(event);
    }
    addManagedListener(object, event, listener) {
        if (this.destroyed) return;
        if (object instanceof HTMLElement) $437b23f6a393c3bf$var$addSafePassiveEventListener(this.getFrameworkOverrides(), object, event, listener);
        else object.addEventListener(event, listener);
        const destroyFunc = ()=>{
            object.removeEventListener(event, listener);
            return null;
        };
        this.destroyFunctions.push(destroyFunc);
        return ()=>{
            destroyFunc();
            this.destroyFunctions = this.destroyFunctions.filter((fn)=>fn !== destroyFunc);
            return null;
        };
    }
    setupGridOptionListener(event, listener) {
        this.gos.addEventListener(event, listener);
        const destroyFunc = ()=>{
            this.gos.removeEventListener(event, listener);
            return null;
        };
        this.destroyFunctions.push(destroyFunc);
        return ()=>{
            destroyFunc();
            this.destroyFunctions = this.destroyFunctions.filter((fn)=>fn !== destroyFunc);
            return null;
        };
    }
    /**
   * Setup a managed property listener for the given GridOption property.
   * @param event GridOption property to listen to changes for.
   * @param listener Listener to run when property value changes
   */ addManagedPropertyListener(event, listener) {
        if (this.destroyed) return ()=>null;
        return this.setupGridOptionListener(event, listener);
    }
    /**
   * Setup managed property listeners for the given set of GridOption properties.
   * The listener will be run if any of the property changes but will only run once if
   * multiple of the properties change within the same framework lifecycle event.
   * Works on the basis that GridOptionsService updates all properties *before* any property change events are fired.
   * @param events Array of GridOption properties to listen for changes too.
   * @param listener Shared listener to run if any of the properties change
   */ addManagedPropertyListeners(events, listener) {
        if (this.destroyed) return;
        const eventsKey = events.join("-") + this.propertyListenerId++;
        const wrappedListener = (event)=>{
            if (event.changeSet) {
                if (event.changeSet && event.changeSet.id === this.lastChangeSetIdLookup[eventsKey]) return;
                this.lastChangeSetIdLookup[eventsKey] = event.changeSet.id;
            }
            const propertiesChangeEvent = {
                type: "gridPropertyChanged",
                changeSet: event.changeSet,
                source: event.source
            };
            listener(propertiesChangeEvent);
        };
        events.forEach((event)=>this.setupGridOptionListener(event, wrappedListener));
    }
    addDestroyFunc(func) {
        if (this.isAlive()) this.destroyFunctions.push(func);
        else func();
    }
    createManagedBean(bean, context) {
        const res = this.createBean(bean, context);
        this.addDestroyFunc(this.destroyBean.bind(this, bean, context));
        return res;
    }
    createBean(bean, context, afterPreCreateCallback) {
        return (context || this.getContext()).createBean(bean, afterPreCreateCallback);
    }
    destroyBean(bean, context) {
        return (context || this.getContext()).destroyBean(bean);
    }
    destroyBeans(beans, context) {
        if (beans) for(let i = 0; i < beans.length; i++)this.destroyBean(beans[i], context);
        return [];
    }
};
$437b23f6a393c3bf$var$_BeanStub.EVENT_DESTROYED = "destroyed";
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("frameworkOverrides")
], $437b23f6a393c3bf$var$_BeanStub.prototype, "frameworkOverrides", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("context")
], $437b23f6a393c3bf$var$_BeanStub.prototype, "context", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("eventService")
], $437b23f6a393c3bf$var$_BeanStub.prototype, "eventService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("gridOptionsService")
], $437b23f6a393c3bf$var$_BeanStub.prototype, "gos", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("localeService")
], $437b23f6a393c3bf$var$_BeanStub.prototype, "localeService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("environment")
], $437b23f6a393c3bf$var$_BeanStub.prototype, "environment", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$cc3f3d4529c57d95
], $437b23f6a393c3bf$var$_BeanStub.prototype, "destroy", 1);
var $437b23f6a393c3bf$export$2032c8ef3788dfbd = $437b23f6a393c3bf$var$_BeanStub;
// community-modules/core/src/columns/columnFactory.ts
var $437b23f6a393c3bf$export$a988f568cf9d5725 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    setBeans(loggerFactory) {
        this.logger = loggerFactory.create("ColumnFactory");
    }
    createColumnTree(defs, primaryColumns, existingTree, source) {
        const columnKeyCreator = new $437b23f6a393c3bf$export$f67d1427302c96a3();
        const { existingCols: existingCols, existingGroups: existingGroups, existingColKeys: existingColKeys } = this.extractExistingTreeData(existingTree);
        columnKeyCreator.addExistingKeys(existingColKeys);
        const unbalancedTree = this.recursivelyCreateColumns(defs, 0, primaryColumns, existingCols, columnKeyCreator, existingGroups, source);
        const treeDept = this.findMaxDept(unbalancedTree, 0);
        this.logger.log("Number of levels for grouped columns is " + treeDept);
        const columnTree = this.balanceColumnTree(unbalancedTree, 0, treeDept, columnKeyCreator);
        const deptFirstCallback = (child, parent)=>{
            if (child instanceof $437b23f6a393c3bf$export$89dd394cd2c9e921) child.setupExpandable();
            child.setOriginalParent(parent);
        };
        $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(null, columnTree, deptFirstCallback);
        return {
            columnTree: columnTree,
            treeDept: treeDept
        };
    }
    extractExistingTreeData(existingTree) {
        const existingCols = [];
        const existingGroups = [];
        const existingColKeys = [];
        if (existingTree) $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(null, existingTree, (item)=>{
            if (item instanceof $437b23f6a393c3bf$export$89dd394cd2c9e921) {
                const group = item;
                existingGroups.push(group);
            } else {
                const col = item;
                existingColKeys.push(col.getId());
                existingCols.push(col);
            }
        });
        return {
            existingCols: existingCols,
            existingGroups: existingGroups,
            existingColKeys: existingColKeys
        };
    }
    createForAutoGroups(autoGroupCols, gridBalancedTree) {
        return autoGroupCols.map((col)=>this.createAutoGroupTreeItem(gridBalancedTree, col));
    }
    createAutoGroupTreeItem(balancedColumnTree, column) {
        const dept = this.findDepth(balancedColumnTree);
        let nextChild = column;
        for(let i = dept - 1; i >= 0; i--){
            const autoGroup = new $437b23f6a393c3bf$export$89dd394cd2c9e921(null, `FAKE_PATH_${column.getId()}}_${i}`, true, i);
            this.createBean(autoGroup);
            autoGroup.setChildren([
                nextChild
            ]);
            nextChild.setOriginalParent(autoGroup);
            nextChild = autoGroup;
        }
        if (dept === 0) column.setOriginalParent(null);
        return nextChild;
    }
    findDepth(balancedColumnTree) {
        let dept = 0;
        let pointer = balancedColumnTree;
        while(pointer && pointer[0] && pointer[0] instanceof $437b23f6a393c3bf$export$89dd394cd2c9e921){
            dept++;
            pointer = pointer[0].getChildren();
        }
        return dept;
    }
    balanceColumnTree(unbalancedTree, currentDept, columnDept, columnKeyCreator) {
        const result = [];
        for(let i = 0; i < unbalancedTree.length; i++){
            const child = unbalancedTree[i];
            if (child instanceof $437b23f6a393c3bf$export$89dd394cd2c9e921) {
                const originalGroup = child;
                const newChildren = this.balanceColumnTree(originalGroup.getChildren(), currentDept + 1, columnDept, columnKeyCreator);
                originalGroup.setChildren(newChildren);
                result.push(originalGroup);
            } else {
                let firstPaddedGroup;
                let currentPaddedGroup;
                for(let j = columnDept - 1; j >= currentDept; j--){
                    const newColId = columnKeyCreator.getUniqueKey(null, null);
                    const colGroupDefMerged = this.createMergedColGroupDef(null);
                    const paddedGroup = new $437b23f6a393c3bf$export$89dd394cd2c9e921(colGroupDefMerged, newColId, true, currentDept);
                    this.createBean(paddedGroup);
                    if (currentPaddedGroup) currentPaddedGroup.setChildren([
                        paddedGroup
                    ]);
                    currentPaddedGroup = paddedGroup;
                    if (!firstPaddedGroup) firstPaddedGroup = currentPaddedGroup;
                }
                if (firstPaddedGroup && currentPaddedGroup) {
                    result.push(firstPaddedGroup);
                    const hasGroups = unbalancedTree.some((leaf)=>leaf instanceof $437b23f6a393c3bf$export$89dd394cd2c9e921);
                    if (hasGroups) {
                        currentPaddedGroup.setChildren([
                            child
                        ]);
                        continue;
                    } else {
                        currentPaddedGroup.setChildren(unbalancedTree);
                        break;
                    }
                }
                result.push(child);
            }
        }
        return result;
    }
    findMaxDept(treeChildren, dept) {
        let maxDeptThisLevel = dept;
        for(let i = 0; i < treeChildren.length; i++){
            const abstractColumn = treeChildren[i];
            if (abstractColumn instanceof $437b23f6a393c3bf$export$89dd394cd2c9e921) {
                const originalGroup = abstractColumn;
                const newDept = this.findMaxDept(originalGroup.getChildren(), dept + 1);
                if (maxDeptThisLevel < newDept) maxDeptThisLevel = newDept;
            }
        }
        return maxDeptThisLevel;
    }
    recursivelyCreateColumns(defs, level, primaryColumns, existingColsCopy, columnKeyCreator, existingGroups, source) {
        if (!defs) return [];
        const result = new Array(defs.length);
        for(let i = 0; i < result.length; i++){
            const def = defs[i];
            if (this.isColumnGroup(def)) result[i] = this.createColumnGroup(primaryColumns, def, level, existingColsCopy, columnKeyCreator, existingGroups, source);
            else result[i] = this.createColumn(primaryColumns, def, existingColsCopy, columnKeyCreator, source);
        }
        return result;
    }
    createColumnGroup(primaryColumns, colGroupDef, level, existingColumns, columnKeyCreator, existingGroups, source) {
        const colGroupDefMerged = this.createMergedColGroupDef(colGroupDef);
        const groupId = columnKeyCreator.getUniqueKey(colGroupDefMerged.groupId || null, null);
        const providedGroup = new $437b23f6a393c3bf$export$89dd394cd2c9e921(colGroupDefMerged, groupId, false, level);
        this.createBean(providedGroup);
        const existingGroupAndIndex = this.findExistingGroup(colGroupDef, existingGroups);
        if (existingGroupAndIndex) existingGroups.splice(existingGroupAndIndex.idx, 1);
        let existingGroup = existingGroupAndIndex == null ? void 0 : existingGroupAndIndex.group;
        if (existingGroup) providedGroup.setExpanded(existingGroup.isExpanded());
        const children = this.recursivelyCreateColumns(colGroupDefMerged.children, level + 1, primaryColumns, existingColumns, columnKeyCreator, existingGroups, source);
        providedGroup.setChildren(children);
        return providedGroup;
    }
    createMergedColGroupDef(colGroupDef) {
        const colGroupDefMerged = {};
        Object.assign(colGroupDefMerged, this.gos.get("defaultColGroupDef"));
        Object.assign(colGroupDefMerged, colGroupDef);
        return colGroupDefMerged;
    }
    createColumn(primaryColumns, colDef, existingColsCopy, columnKeyCreator, source) {
        const existingColAndIndex = this.findExistingColumn(colDef, existingColsCopy);
        if (existingColAndIndex) existingColsCopy == null || existingColsCopy.splice(existingColAndIndex.idx, 1);
        let column = existingColAndIndex == null ? void 0 : existingColAndIndex.column;
        if (!column) {
            const colId = columnKeyCreator.getUniqueKey(colDef.colId, colDef.field);
            const colDefMerged = this.addColumnDefaultAndTypes(colDef, colId);
            column = new $437b23f6a393c3bf$export$816b5d811295e6bc(colDefMerged, colDef, colId, primaryColumns);
            this.context.createBean(column);
        } else {
            const colDefMerged = this.addColumnDefaultAndTypes(colDef, column.getColId());
            column.setColDef(colDefMerged, colDef, source);
            this.applyColumnState(column, colDefMerged, source);
        }
        this.dataTypeService.addColumnListeners(column);
        return column;
    }
    applyColumnState(column, colDef, source) {
        const flex = $437b23f6a393c3bf$var$attrToNumber(colDef.flex);
        if (flex !== void 0) column.setFlex(flex);
        const noFlexThisCol = column.getFlex() <= 0;
        if (noFlexThisCol) {
            const width = $437b23f6a393c3bf$var$attrToNumber(colDef.width);
            if (width != null) column.setActualWidth(width, source);
            else {
                const widthBeforeUpdate = column.getActualWidth();
                column.setActualWidth(widthBeforeUpdate, source);
            }
        }
        if (colDef.sort !== void 0) {
            if (colDef.sort == "asc" || colDef.sort == "desc") column.setSort(colDef.sort, source);
            else column.setSort(void 0, source);
        }
        const sortIndex = $437b23f6a393c3bf$var$attrToNumber(colDef.sortIndex);
        if (sortIndex !== void 0) column.setSortIndex(sortIndex);
        const hide = $437b23f6a393c3bf$var$attrToBoolean(colDef.hide);
        if (hide !== void 0) column.setVisible(!hide, source);
        if (colDef.pinned !== void 0) column.setPinned(colDef.pinned);
    }
    findExistingColumn(newColDef, existingColsCopy) {
        if (!existingColsCopy) return void 0;
        for(let i = 0; i < existingColsCopy.length; i++){
            const def = existingColsCopy[i].getUserProvidedColDef();
            if (!def) continue;
            const newHasId = newColDef.colId != null;
            if (newHasId) {
                if (existingColsCopy[i].getId() === newColDef.colId) return {
                    idx: i,
                    column: existingColsCopy[i]
                };
                continue;
            }
            const newHasField = newColDef.field != null;
            if (newHasField) {
                if (def.field === newColDef.field) return {
                    idx: i,
                    column: existingColsCopy[i]
                };
                continue;
            }
            if (def === newColDef) return {
                idx: i,
                column: existingColsCopy[i]
            };
        }
        return void 0;
    }
    findExistingGroup(newGroupDef, existingGroups) {
        const newHasId = newGroupDef.groupId != null;
        if (!newHasId) return void 0;
        for(let i = 0; i < existingGroups.length; i++){
            const existingGroup = existingGroups[i];
            const existingDef = existingGroup.getColGroupDef();
            if (!existingDef) continue;
            if (existingGroup.getId() === newGroupDef.groupId) return {
                idx: i,
                group: existingGroup
            };
        }
        return void 0;
    }
    addColumnDefaultAndTypes(colDef, colId) {
        const res = {};
        const defaultColDef = this.gos.get("defaultColDef");
        $437b23f6a393c3bf$var$mergeDeep(res, defaultColDef, false, true);
        const columnType = this.dataTypeService.updateColDefAndGetColumnType(res, colDef, colId);
        if (columnType) this.assignColumnTypes(columnType, res);
        $437b23f6a393c3bf$var$mergeDeep(res, colDef, false, true);
        const autoGroupColDef = this.gos.get("autoGroupColumnDef");
        const isSortingCoupled = this.gos.isColumnsSortingCoupledToGroup();
        if (colDef.rowGroup && autoGroupColDef && isSortingCoupled) $437b23f6a393c3bf$var$mergeDeep(res, {
            sort: autoGroupColDef.sort,
            initialSort: autoGroupColDef.initialSort
        }, false, true);
        this.dataTypeService.validateColDef(res);
        return res;
    }
    assignColumnTypes(typeKeys, colDefMerged) {
        if (!typeKeys.length) return;
        const allColumnTypes = Object.assign({}, $437b23f6a393c3bf$var$DefaultColumnTypes);
        const userTypes = this.gos.get("columnTypes") || {};
        $437b23f6a393c3bf$var$iterateObject(userTypes, (key, value)=>{
            if (key in allColumnTypes) console.warn(`AG Grid: the column type '${key}' is a default column type and cannot be overridden.`);
            else {
                const colType = value;
                if (colType.type) $437b23f6a393c3bf$var$warnOnce(`Column type definitions 'columnTypes' with a 'type' attribute are not supported because a column type cannot refer to another column type. Only column definitions 'columnDefs' can use the 'type' attribute to refer to a column type.`);
                allColumnTypes[key] = value;
            }
        });
        typeKeys.forEach((t)=>{
            const typeColDef = allColumnTypes[t.trim()];
            if (typeColDef) $437b23f6a393c3bf$var$mergeDeep(colDefMerged, typeColDef, false, true);
            else console.warn("AG Grid: colDef.type '" + t + "' does not correspond to defined gridOptions.columnTypes");
        });
    }
    // if object has children, we assume it's a group
    isColumnGroup(abstractColDef) {
        return abstractColDef.children !== void 0;
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("dataTypeService")
], $437b23f6a393c3bf$export$a988f568cf9d5725.prototype, "dataTypeService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$var$__decorateParam(0, $437b23f6a393c3bf$export$c3215dfb7fd4803b("loggerFactory"))
], $437b23f6a393c3bf$export$a988f568cf9d5725.prototype, "setBeans", 1);
$437b23f6a393c3bf$export$a988f568cf9d5725 = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("columnFactory")
], $437b23f6a393c3bf$export$a988f568cf9d5725);
function $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(parent, tree, callback) {
    if (!tree) return;
    for(let i = 0; i < tree.length; i++){
        const child = tree[i];
        if (child instanceof $437b23f6a393c3bf$export$89dd394cd2c9e921) $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(child, child.getChildren(), callback);
        callback(child, parent);
    }
}
// community-modules/core/src/entities/columnGroup.ts
var $437b23f6a393c3bf$var$_ColumnGroup = class _ColumnGroup {
    constructor(providedColumnGroup, groupId, partId, pinned){
        // depends on the open/closed state of the group, only displaying columns are stored here
        this.displayedChildren = [];
        this.localEventService = new $437b23f6a393c3bf$export$895d7dc49f082ca1();
        this.groupId = groupId;
        this.partId = partId;
        this.providedColumnGroup = providedColumnGroup;
        this.pinned = pinned;
    }
    // this is static, a it is used outside of this class
    static createUniqueId(groupId, instanceId) {
        return groupId + "_" + instanceId;
    }
    // as the user is adding and removing columns, the groups are recalculated.
    // this reset clears out all children, ready for children to be added again
    reset() {
        this.parent = null;
        this.children = null;
        this.displayedChildren = null;
    }
    getParent() {
        return this.parent;
    }
    setParent(parent) {
        this.parent = parent;
    }
    getUniqueId() {
        return _ColumnGroup.createUniqueId(this.groupId, this.partId);
    }
    isEmptyGroup() {
        return this.displayedChildren.length === 0;
    }
    isMoving() {
        const allLeafColumns = this.getProvidedColumnGroup().getLeafColumns();
        if (!allLeafColumns || allLeafColumns.length === 0) return false;
        return allLeafColumns.every((col)=>col.isMoving());
    }
    checkLeft() {
        this.displayedChildren.forEach((child)=>{
            if (child instanceof _ColumnGroup) child.checkLeft();
        });
        if (this.displayedChildren.length > 0) {
            if (this.gos.get("enableRtl")) {
                const lastChild = $437b23f6a393c3bf$var$last(this.displayedChildren);
                const lastChildLeft = lastChild.getLeft();
                this.setLeft(lastChildLeft);
            } else {
                const firstChildLeft = this.displayedChildren[0].getLeft();
                this.setLeft(firstChildLeft);
            }
        } else this.setLeft(null);
    }
    getLeft() {
        return this.left;
    }
    getOldLeft() {
        return this.oldLeft;
    }
    setLeft(left) {
        this.oldLeft = this.left;
        if (this.left !== left) {
            this.left = left;
            this.localEventService.dispatchEvent(this.createAgEvent(_ColumnGroup.EVENT_LEFT_CHANGED));
        }
    }
    getPinned() {
        return this.pinned;
    }
    createAgEvent(type) {
        return {
            type: type
        };
    }
    addEventListener(eventType, listener) {
        this.localEventService.addEventListener(eventType, listener);
    }
    removeEventListener(eventType, listener) {
        this.localEventService.removeEventListener(eventType, listener);
    }
    getGroupId() {
        return this.groupId;
    }
    getPartId() {
        return this.partId;
    }
    isChildInThisGroupDeepSearch(wantedChild) {
        let result = false;
        this.children.forEach((foundChild)=>{
            if (wantedChild === foundChild) result = true;
            if (foundChild instanceof _ColumnGroup) {
                if (foundChild.isChildInThisGroupDeepSearch(wantedChild)) result = true;
            }
        });
        return result;
    }
    getActualWidth() {
        let groupActualWidth = 0;
        if (this.displayedChildren) this.displayedChildren.forEach((child)=>{
            groupActualWidth += child.getActualWidth();
        });
        return groupActualWidth;
    }
    isResizable() {
        if (!this.displayedChildren) return false;
        let result = false;
        this.displayedChildren.forEach((child)=>{
            if (child.isResizable()) result = true;
        });
        return result;
    }
    getMinWidth() {
        let result = 0;
        this.displayedChildren.forEach((groupChild)=>{
            result += groupChild.getMinWidth() || 0;
        });
        return result;
    }
    addChild(child) {
        if (!this.children) this.children = [];
        this.children.push(child);
    }
    getDisplayedChildren() {
        return this.displayedChildren;
    }
    getLeafColumns() {
        const result = [];
        this.addLeafColumns(result);
        return result;
    }
    getDisplayedLeafColumns() {
        const result = [];
        this.addDisplayedLeafColumns(result);
        return result;
    }
    getDefinition() {
        return this.providedColumnGroup.getColGroupDef();
    }
    getColGroupDef() {
        return this.providedColumnGroup.getColGroupDef();
    }
    isPadding() {
        return this.providedColumnGroup.isPadding();
    }
    isExpandable() {
        return this.providedColumnGroup.isExpandable();
    }
    isExpanded() {
        return this.providedColumnGroup.isExpanded();
    }
    setExpanded(expanded) {
        this.providedColumnGroup.setExpanded(expanded);
    }
    addDisplayedLeafColumns(leafColumns) {
        this.displayedChildren.forEach((child)=>{
            if (child instanceof $437b23f6a393c3bf$export$816b5d811295e6bc) leafColumns.push(child);
            else if (child instanceof _ColumnGroup) child.addDisplayedLeafColumns(leafColumns);
        });
    }
    addLeafColumns(leafColumns) {
        this.children.forEach((child)=>{
            if (child instanceof $437b23f6a393c3bf$export$816b5d811295e6bc) leafColumns.push(child);
            else if (child instanceof _ColumnGroup) child.addLeafColumns(leafColumns);
        });
    }
    getChildren() {
        return this.children;
    }
    getColumnGroupShow() {
        return this.providedColumnGroup.getColumnGroupShow();
    }
    getProvidedColumnGroup() {
        return this.providedColumnGroup;
    }
    getPaddingLevel() {
        const parent = this.getParent();
        if (!this.isPadding() || !parent || !parent.isPadding()) return 0;
        return 1 + parent.getPaddingLevel();
    }
    calculateDisplayedColumns() {
        this.displayedChildren = [];
        let parentWithExpansion = this;
        while(parentWithExpansion != null && parentWithExpansion.isPadding())parentWithExpansion = parentWithExpansion.getParent();
        const isExpandable = parentWithExpansion ? parentWithExpansion.providedColumnGroup.isExpandable() : false;
        if (!isExpandable) {
            this.displayedChildren = this.children;
            this.localEventService.dispatchEvent(this.createAgEvent(_ColumnGroup.EVENT_DISPLAYED_CHILDREN_CHANGED));
            return;
        }
        this.children.forEach((child)=>{
            const emptyGroup = child instanceof _ColumnGroup && (!child.displayedChildren || !child.displayedChildren.length);
            if (emptyGroup) return;
            const headerGroupShow = child.getColumnGroupShow();
            switch(headerGroupShow){
                case "open":
                    if (parentWithExpansion.providedColumnGroup.isExpanded()) this.displayedChildren.push(child);
                    break;
                case "closed":
                    if (!parentWithExpansion.providedColumnGroup.isExpanded()) this.displayedChildren.push(child);
                    break;
                default:
                    this.displayedChildren.push(child);
                    break;
            }
        });
        this.localEventService.dispatchEvent(this.createAgEvent(_ColumnGroup.EVENT_DISPLAYED_CHILDREN_CHANGED));
    }
};
$437b23f6a393c3bf$var$_ColumnGroup.EVENT_LEFT_CHANGED = "leftChanged";
$437b23f6a393c3bf$var$_ColumnGroup.EVENT_DISPLAYED_CHILDREN_CHANGED = "displayedChildrenChanged";
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("gridOptionsService")
], $437b23f6a393c3bf$var$_ColumnGroup.prototype, "gos", 2);
var $437b23f6a393c3bf$export$8a8fbc71323f074 = $437b23f6a393c3bf$var$_ColumnGroup;
// community-modules/core/src/eventKeys.ts
var $437b23f6a393c3bf$export$ada873a34909da65 = class {
};
/** Everything has changed with the columns. Either complete new set of columns set, or user called applyColumnState() */ /** @deprecated - grid no longer uses this, and setSate() also fires individual events */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_EVERYTHING_CHANGED = "columnEverythingChanged";
/** User has set in new columns. */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_NEW_COLUMNS_LOADED = "newColumnsLoaded";
/** The pivot mode flag was changed */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_PIVOT_MODE_CHANGED = "columnPivotModeChanged";
/** Exceeded the pivot limit when generating columns */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_PIVOT_MAX_COLUMNS_EXCEEDED = "pivotMaxColumnsExceeded";
/** A row group column was added, removed or order changed. */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_ROW_GROUP_CHANGED = "columnRowGroupChanged";
/** expandAll / collapseAll was called from the api. */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_EXPAND_COLLAPSE_ALL = "expandOrCollapseAll";
/** A pivot column was added, removed or order changed. */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_PIVOT_CHANGED = "columnPivotChanged";
/** The list of grid columns has changed. */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_GRID_COLUMNS_CHANGED = "gridColumnsChanged";
/** A value column was added, removed or agg function was changed. */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_VALUE_CHANGED = "columnValueChanged";
/** A column was moved */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_MOVED = "columnMoved";
/** One or more columns was shown / hidden */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_VISIBLE = "columnVisible";
/** One or more columns was pinned / unpinned*/ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_PINNED = "columnPinned";
/** A column group was opened / closed */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_GROUP_OPENED = "columnGroupOpened";
/** One or more columns was resized. If just one, the column in the event is set. */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_RESIZED = "columnResized";
/** The list of displayed columns has changed, can result from columns open / close, column move, pivot, group, etc */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_DISPLAYED_COLUMNS_CHANGED = "displayedColumnsChanged";
/** The grid option related to suppressing movable columns has changed */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_SUPPRESS_COLUMN_MOVE_CHANGED = "suppressMovableColumns";
/** The grid option related to suppressing column group selection has changed */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_SUPPRESS_MENU_HIDE_CHANGED = "suppressMenuHide";
/** The grid option related to suppressing movable columns has changed */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_SUPPRESS_FIELD_DOT_NOTATION = "suppressFieldDotNotation";
/** The list of virtual columns has changed, results from viewport changing */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_VIRTUAL_COLUMNS_CHANGED = "virtualColumnsChanged";
/** Column header mouse over */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_HEADER_MOUSE_OVER = "columnHeaderMouseOver";
/** Column header mouse leave */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_HEADER_MOUSE_LEAVE = "columnHeaderMouseLeave";
/** Column header clicked */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_HEADER_CLICKED = "columnHeaderClicked";
/** Column header context menu event, such as right-click or context menu key press */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_HEADER_CONTEXT_MENU = "columnHeaderContextMenu";
/** Async Transactions Executed */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_ASYNC_TRANSACTIONS_FLUSHED = "asyncTransactionsFlushed";
/** A row group was opened / closed */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_GROUP_OPENED = "rowGroupOpened";
/** Client-Side Row Model only. The client has updated data for the grid */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_DATA_UPDATED = "rowDataUpdated";
/** The client has set new floating data into the grid */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_PINNED_ROW_DATA_CHANGED = "pinnedRowDataChanged";
/** Range selection has changed */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_RANGE_SELECTION_CHANGED = "rangeSelectionChanged";
/** Chart was created */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_CHART_CREATED = "chartCreated";
/** Chart Range selection has changed */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_CHART_RANGE_SELECTION_CHANGED = "chartRangeSelectionChanged";
/** Chart Options have changed */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_CHART_OPTIONS_CHANGED = "chartOptionsChanged";
/** Chart was destroyed */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_CHART_DESTROYED = "chartDestroyed";
/** For when the tool panel is shown / hidden */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_TOOL_PANEL_VISIBLE_CHANGED = "toolPanelVisibleChanged";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_TOOL_PANEL_SIZE_CHANGED = "toolPanelSizeChanged";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_PANEL_ITEM_DRAG_START = "columnPanelItemDragStart";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_PANEL_ITEM_DRAG_END = "columnPanelItemDragEnd";
/** Model was updated - grid updates the drawn rows when this happens */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_MODEL_UPDATED = "modelUpdated";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_CUT_START = "cutStart";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_CUT_END = "cutEnd";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_PASTE_START = "pasteStart";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_PASTE_END = "pasteEnd";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_FILL_START = "fillStart";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_FILL_END = "fillEnd";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_RANGE_DELETE_START = "rangeDeleteStart";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_RANGE_DELETE_END = "rangeDeleteEnd";
/** Undo operation has started. */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_UNDO_STARTED = "undoStarted";
/** Undo operation has ended. */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_UNDO_ENDED = "undoEnded";
/** Redo operation has started. */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_REDO_STARTED = "redoStarted";
/** Redo operation has ended. */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_REDO_ENDED = "redoEnded";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_KEY_SHORTCUT_CHANGED_CELL_START = "keyShortcutChangedCellStart";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_KEY_SHORTCUT_CHANGED_CELL_END = "keyShortcutChangedCellEnd";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_CELL_CLICKED = "cellClicked";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_CELL_DOUBLE_CLICKED = "cellDoubleClicked";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_CELL_MOUSE_DOWN = "cellMouseDown";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_CELL_CONTEXT_MENU = "cellContextMenu";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_CELL_VALUE_CHANGED = "cellValueChanged";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_CELL_EDIT_REQUEST = "cellEditRequest";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_VALUE_CHANGED = "rowValueChanged";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_CELL_FOCUSED = "cellFocused";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_CELL_FOCUS_CLEARED = "cellFocusCleared";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_FULL_WIDTH_ROW_FOCUSED = "fullWidthRowFocused";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_SELECTED = "rowSelected";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_SELECTION_CHANGED = "selectionChanged";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_TOOLTIP_SHOW = "tooltipShow";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_TOOLTIP_HIDE = "tooltipHide";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_CELL_KEY_DOWN = "cellKeyDown";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_CELL_MOUSE_OVER = "cellMouseOver";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_CELL_MOUSE_OUT = "cellMouseOut";
/** 2 events for filtering. The grid LISTENS for filterChanged and afterFilterChanged */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_FILTER_CHANGED = "filterChanged";
/** Filter was change but not applied. Only useful if apply buttons are used in filters. */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_FILTER_MODIFIED = "filterModified";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_FILTER_OPENED = "filterOpened";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_ADVANCED_FILTER_BUILDER_VISIBLE_CHANGED = "advancedFilterBuilderVisibleChanged";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_SORT_CHANGED = "sortChanged";
/** A row was removed from the dom, for any reason. Use to clean up resources (if any) used by the row. */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_VIRTUAL_ROW_REMOVED = "virtualRowRemoved";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_CLICKED = "rowClicked";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_DOUBLE_CLICKED = "rowDoubleClicked";
/** Gets called once after the grid has finished initialising. */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_GRID_READY = "gridReady";
/** Called once when the grid is about to get destroyed. */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_GRID_PRE_DESTROYED = "gridPreDestroyed";
/** Width of height of the main grid div has changed. Grid listens for this and does layout of grid if it's
 * changed, so always filling the space it was given. */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_GRID_SIZE_CHANGED = "gridSizeChanged";
/** The indexes of the rows rendered has changed, eg user has scrolled to a new vertical position. */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_VIEWPORT_CHANGED = "viewportChanged";
/* The width of the scrollbar has been calculated */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_SCROLLBAR_WIDTH_CHANGED = "scrollbarWidthChanged";
/** Rows were rendered for the first time (ie on async data load). */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_FIRST_DATA_RENDERED = "firstDataRendered";
/** A column drag has started, either resizing a column or moving a column. */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_DRAG_STARTED = "dragStarted";
/** A column drag has stopped */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_DRAG_STOPPED = "dragStopped";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_CHECKBOX_CHANGED = "checkboxChanged";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_EDITING_STARTED = "rowEditingStarted";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_EDITING_STOPPED = "rowEditingStopped";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_CELL_EDITING_STARTED = "cellEditingStarted";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_CELL_EDITING_STOPPED = "cellEditingStopped";
/** Main body of grid has scrolled, either horizontally or vertically */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_BODY_SCROLL = "bodyScroll";
/** Main body of the grid has stopped scrolling, either horizontally or vertically */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_BODY_SCROLL_END = "bodyScrollEnd";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_HEIGHT_SCALE_CHANGED = "heightScaleChanged";
/** The displayed page for pagination has changed. For example the data was filtered or sorted,
 * or the user has moved to a different page. */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_PAGINATION_CHANGED = "paginationChanged";
/** Only used by React, Angular, Web Components and VueJS AG Grid components
 * (not used if doing plain JavaScript). If the grid receives changes due
 * to bound properties, this event fires after the grid has finished processing the change. */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COMPONENT_STATE_CHANGED = "componentStateChanged";
/** Only used by the SSRM, called when the grid has no more rows to refresh */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_STORE_REFRESHED = "storeRefreshed";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_STATE_UPDATED = "stateUpdated";
/** The visibility of the column menu has changed. */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_MENU_VISIBLE_CHANGED = "columnMenuVisibleChanged";
/** The visibility of the context menu has changed. */ $437b23f6a393c3bf$export$ada873a34909da65.EVENT_CONTEXT_MENU_VISIBLE_CHANGED = "contextMenuVisibleChanged";
/*****************************  INTERNAL EVENTS: START ******************************************* */ /** Please remember to add to ComponentUtil.EXCLUDED_INTERNAL_EVENTS to not have these events exposed to framework components. */ /** All items from here down are used internally by the grid, not intended for external use. */ // not documented, either experimental, or we just don't want users using an depending on them
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_BODY_HEIGHT_CHANGED = "bodyHeightChanged";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_CONTAINER_WIDTH_CHANGED = "columnContainerWidthChanged";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED = "displayedColumnsWidthChanged";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_SCROLL_VISIBILITY_CHANGED = "scrollVisibilityChanged";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_HOVER_CHANGED = "columnHoverChanged";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_FLASH_CELLS = "flashCells";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_PAGINATION_PIXEL_OFFSET_CHANGED = "paginationPixelOffsetChanged";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_DISPLAYED_ROWS_CHANGED = "displayedRowsChanged";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_LEFT_PINNED_WIDTH_CHANGED = "leftPinnedWidthChanged";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_RIGHT_PINNED_WIDTH_CHANGED = "rightPinnedWidthChanged";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_CONTAINER_HEIGHT_CHANGED = "rowContainerHeightChanged";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_HEADER_HEIGHT_CHANGED = "headerHeightChanged";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_HEADER_HEIGHT_CHANGED = "columnHeaderHeightChanged";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_DRAG_ENTER = "rowDragEnter";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_DRAG_MOVE = "rowDragMove";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_DRAG_LEAVE = "rowDragLeave";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_DRAG_END = "rowDragEnd";
// environment
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_GRID_STYLES_CHANGED = "gridStylesChanged";
// these are used for server side group and agg - only used by CS with Viewport Row Model - intention is
// to design these better around server side functions and then release to general public when fully working with
// all the row models.
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_ROW_GROUP_CHANGE_REQUEST = "columnRowGroupChangeRequest";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_PIVOT_CHANGE_REQUEST = "columnPivotChangeRequest";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_VALUE_CHANGE_REQUEST = "columnValueChangeRequest";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_AGG_FUNC_CHANGE_REQUEST = "columnAggFuncChangeRequest";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_STORE_UPDATED = "storeUpdated";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_FILTER_DESTROYED = "filterDestroyed";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_DATA_UPDATE_STARTED = "rowDataUpdateStarted";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_COUNT_READY = "rowCountReady";
// Advanced Filters
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_ADVANCED_FILTER_ENABLED_CHANGED = "advancedFilterEnabledChanged";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_DATA_TYPES_INFERRED = "dataTypesInferred";
// Widgets
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_FIELD_VALUE_CHANGED = "fieldValueChanged";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_FIELD_PICKER_VALUE_SELECTED = "fieldPickerValueSelected";
$437b23f6a393c3bf$export$ada873a34909da65.EVENT_SIDE_BAR_UPDATED = "sideBarUpdated";
// community-modules/core/src/events.ts
var $437b23f6a393c3bf$export$12e4e9a3cbd0ec07 = /* @__PURE__ */ new Set([
    $437b23f6a393c3bf$export$ada873a34909da65.EVENT_GRID_PRE_DESTROYED,
    $437b23f6a393c3bf$export$ada873a34909da65.EVENT_FILL_START
]);
// community-modules/core/src/columns/groupInstanceIdCreator.ts
var $437b23f6a393c3bf$export$b3b24737a74261fb = class {
    constructor(){
        // this map contains keys to numbers, so we remember what the last call was
        this.existingIds = {};
    }
    getInstanceIdForKey(key) {
        const lastResult = this.existingIds[key];
        let result;
        if (typeof lastResult !== "number") result = 0;
        else result = lastResult + 1;
        this.existingIds[key] = result;
        return result;
    }
};
// community-modules/core/src/columns/autoGroupColService.ts
var $437b23f6a393c3bf$export$a7016588c430dba6 = "ag-Grid-AutoColumn";
var $437b23f6a393c3bf$var$AutoGroupColService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    createAutoGroupColumns(rowGroupColumns) {
        const groupAutoColumns = [];
        const doingTreeData = this.gos.get("treeData");
        let doingMultiAutoColumn = this.gos.isGroupMultiAutoColumn();
        if (doingTreeData && doingMultiAutoColumn) {
            console.warn('AG Grid: you cannot mix groupDisplayType = "multipleColumns" with treeData, only one column can be used to display groups when doing tree data');
            doingMultiAutoColumn = false;
        }
        if (doingMultiAutoColumn) rowGroupColumns.forEach((rowGroupCol, index)=>{
            groupAutoColumns.push(this.createOneAutoGroupColumn(rowGroupCol, index));
        });
        else groupAutoColumns.push(this.createOneAutoGroupColumn());
        return groupAutoColumns;
    }
    updateAutoGroupColumns(autoGroupColumns, source) {
        autoGroupColumns.forEach((column, index)=>this.updateOneAutoGroupColumn(column, index, source));
    }
    // rowGroupCol and index are missing if groupDisplayType != "multipleColumns"
    createOneAutoGroupColumn(rowGroupCol, index) {
        let colId;
        if (rowGroupCol) colId = `${$437b23f6a393c3bf$export$a7016588c430dba6}-${rowGroupCol.getId()}`;
        else colId = $437b23f6a393c3bf$export$a7016588c430dba6;
        const colDef = this.createAutoGroupColDef(colId, rowGroupCol, index);
        colDef.colId = colId;
        const newCol = new $437b23f6a393c3bf$export$816b5d811295e6bc(colDef, null, colId, true);
        this.context.createBean(newCol);
        return newCol;
    }
    /**
   * Refreshes an auto group col to load changes from defaultColDef or autoGroupColDef
   */ updateOneAutoGroupColumn(colToUpdate, index, source) {
        const oldColDef = colToUpdate.getColDef();
        const underlyingColId = typeof oldColDef.showRowGroup == "string" ? oldColDef.showRowGroup : void 0;
        const underlyingColumn = underlyingColId != null ? this.columnModel.getPrimaryColumn(underlyingColId) : void 0;
        const colDef = this.createAutoGroupColDef(colToUpdate.getId(), underlyingColumn != null ? underlyingColumn : void 0, index);
        colToUpdate.setColDef(colDef, null, source);
        this.columnFactory.applyColumnState(colToUpdate, colDef, source);
    }
    createAutoGroupColDef(colId, underlyingColumn, index) {
        let res = this.createBaseColDef(underlyingColumn);
        const autoGroupColumnDef = this.gos.get("autoGroupColumnDef");
        $437b23f6a393c3bf$var$mergeDeep(res, autoGroupColumnDef);
        res = this.columnFactory.addColumnDefaultAndTypes(res, colId);
        if (!this.gos.get("treeData")) {
            const noFieldOrValueGetter = $437b23f6a393c3bf$var$missing(res.field) && $437b23f6a393c3bf$var$missing(res.valueGetter) && $437b23f6a393c3bf$var$missing(res.filterValueGetter) && res.filter !== "agGroupColumnFilter";
            if (noFieldOrValueGetter) res.filter = false;
        }
        if (index && index > 0) res.headerCheckboxSelection = false;
        const isSortingCoupled = this.gos.isColumnsSortingCoupledToGroup();
        const hasOwnData = res.valueGetter || res.field != null;
        if (isSortingCoupled && !hasOwnData) {
            res.sortIndex = void 0;
            res.initialSort = void 0;
        }
        return res;
    }
    createBaseColDef(rowGroupCol) {
        const userDef = this.gos.get("autoGroupColumnDef");
        const localeTextFunc = this.localeService.getLocaleTextFunc();
        const res = {
            headerName: localeTextFunc("group", "Group")
        };
        const userHasProvidedGroupCellRenderer = userDef && (userDef.cellRenderer || userDef.cellRendererSelector);
        if (!userHasProvidedGroupCellRenderer) res.cellRenderer = "agGroupCellRenderer";
        if (rowGroupCol) {
            const colDef = rowGroupCol.getColDef();
            Object.assign(res, {
                // cellRendererParams.groupKey: colDefToCopy.field;
                headerName: this.columnModel.getDisplayNameForColumn(rowGroupCol, "header"),
                headerValueGetter: colDef.headerValueGetter
            });
            if (colDef.cellRenderer) Object.assign(res, {
                cellRendererParams: {
                    innerRenderer: colDef.cellRenderer,
                    innerRendererParams: colDef.cellRendererParams
                }
            });
            res.showRowGroup = rowGroupCol.getColId();
        } else res.showRowGroup = true;
        return res;
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnModel")
], $437b23f6a393c3bf$var$AutoGroupColService.prototype, "columnModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnFactory")
], $437b23f6a393c3bf$var$AutoGroupColService.prototype, "columnFactory", 2);
$437b23f6a393c3bf$var$AutoGroupColService = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("autoGroupColService")
], $437b23f6a393c3bf$var$AutoGroupColService);
// community-modules/core/src/utils/string.ts
var $437b23f6a393c3bf$var$string_exports = {};
$437b23f6a393c3bf$var$__export($437b23f6a393c3bf$var$string_exports, {
    camelCaseToHumanText: ()=>$437b23f6a393c3bf$var$camelCaseToHumanText,
    camelCaseToHyphenated: ()=>$437b23f6a393c3bf$var$camelCaseToHyphenated,
    capitalise: ()=>$437b23f6a393c3bf$var$capitalise,
    escapeString: ()=>$437b23f6a393c3bf$var$escapeString,
    utf8_encode: ()=>$437b23f6a393c3bf$var$utf8_encode
});
var $437b23f6a393c3bf$var$reUnescapedHtml = /[&<>"']/g;
var $437b23f6a393c3bf$var$HTML_ESCAPES = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
};
function $437b23f6a393c3bf$var$utf8_encode(s) {
    const stringFromCharCode = String.fromCharCode;
    function ucs2decode(string) {
        const output = [];
        if (!string) return [];
        const len = string.length;
        let counter = 0;
        let value;
        let extra;
        while(counter < len){
            value = string.charCodeAt(counter++);
            if (value >= 55296 && value <= 56319 && counter < len) {
                extra = string.charCodeAt(counter++);
                if ((extra & 64512) == 56320) output.push(((value & 1023) << 10) + (extra & 1023) + 65536);
                else {
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    function checkScalarValue(point) {
        if (point >= 55296 && point <= 57343) throw Error("Lone surrogate U+" + point.toString(16).toUpperCase() + " is not a scalar value");
    }
    function createByte(point, shift) {
        return stringFromCharCode(point >> shift & 63 | 128);
    }
    function encodeCodePoint(point) {
        if (point >= 0 && point <= 31 && point !== 10) {
            const convertedCode = point.toString(16).toUpperCase();
            const paddedCode = convertedCode.padStart(4, "0");
            return `_x${paddedCode}_`;
        }
        if ((point & 4294967168) == 0) return stringFromCharCode(point);
        let symbol = "";
        if ((point & 4294965248) == 0) symbol = stringFromCharCode(point >> 6 & 31 | 192);
        else if ((point & 4294901760) == 0) {
            checkScalarValue(point);
            symbol = stringFromCharCode(point >> 12 & 15 | 224);
            symbol += createByte(point, 6);
        } else if ((point & 4292870144) == 0) {
            symbol = stringFromCharCode(point >> 18 & 7 | 240);
            symbol += createByte(point, 12);
            symbol += createByte(point, 6);
        }
        symbol += stringFromCharCode(point & 63 | 128);
        return symbol;
    }
    const codePoints = ucs2decode(s);
    const length = codePoints.length;
    let index = -1;
    let codePoint;
    let byteString = "";
    while(++index < length){
        codePoint = codePoints[index];
        byteString += encodeCodePoint(codePoint);
    }
    return byteString;
}
function $437b23f6a393c3bf$var$capitalise(str) {
    return str[0].toUpperCase() + str.substring(1).toLowerCase();
}
function $437b23f6a393c3bf$var$escapeString(toEscape, skipEscapingHtmlChars) {
    if (toEscape == null) return null;
    const stringResult = toEscape.toString().toString();
    if (skipEscapingHtmlChars) return stringResult;
    return stringResult.replace($437b23f6a393c3bf$var$reUnescapedHtml, (chr)=>$437b23f6a393c3bf$var$HTML_ESCAPES[chr]);
}
function $437b23f6a393c3bf$var$camelCaseToHumanText(camelCase) {
    if (!camelCase || camelCase == null) return null;
    const rex = /([a-z])([A-Z])/g;
    const rexCaps = /([A-Z]+)([A-Z])([a-z])/g;
    const words = camelCase.replace(rex, "$1 $2").replace(rexCaps, "$1 $2$3").replace(/\./g, " ").split(" ");
    return words.map((word)=>word.substring(0, 1).toUpperCase() + (word.length > 1 ? word.substring(1, word.length) : "")).join(" ");
}
function $437b23f6a393c3bf$var$camelCaseToHyphenated(camelCase) {
    return camelCase.replace(/[A-Z]/g, (s)=>`-${s.toLocaleLowerCase()}`);
}
// community-modules/core/src/utils/map.ts
var $437b23f6a393c3bf$var$map_exports = {};
$437b23f6a393c3bf$var$__export($437b23f6a393c3bf$var$map_exports, {
    convertToMap: ()=>$437b23f6a393c3bf$var$convertToMap,
    keys: ()=>$437b23f6a393c3bf$var$keys,
    mapById: ()=>$437b23f6a393c3bf$var$mapById
});
function $437b23f6a393c3bf$var$convertToMap(arr) {
    const map = /* @__PURE__ */ new Map();
    arr.forEach((pair)=>map.set(pair[0], pair[1]));
    return map;
}
function $437b23f6a393c3bf$var$mapById(arr, callback) {
    const map = /* @__PURE__ */ new Map();
    arr.forEach((item)=>map.set(callback(item), item));
    return map;
}
function $437b23f6a393c3bf$var$keys(map) {
    const arr = [];
    map.forEach((_2, key)=>arr.push(key));
    return arr;
}
// community-modules/core/src/columns/columnModel.ts
var $437b23f6a393c3bf$export$c9dec256e4c9f340 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        // header row count, based on user provided columns
        this.primaryHeaderRowCount = 0;
        this.secondaryHeaderRowCount = 0;
        // header row count, either above, or based on pivoting if we are pivoting
        this.gridHeaderRowCount = 0;
        // leave level columns of the displayed trees
        this.displayedColumnsLeft = [];
        this.displayedColumnsRight = [];
        this.displayedColumnsCenter = [];
        // all three lists above combined
        this.displayedColumns = [];
        // for fast lookup, to see if a column or group is still displayed
        this.displayedColumnsAndGroupsMap = {};
        // all columns to be rendered
        this.viewportColumns = [];
        // A hash key to keep track of changes in viewport columns
        this.viewportColumnsHash = "";
        // same as viewportColumns, except we always include columns with headerAutoHeight
        this.headerViewportColumns = [];
        // all columns to be rendered in the centre
        this.viewportColumnsCenter = [];
        // same as viewportColumnsCenter, except we always include columns with headerAutoHeight
        this.headerViewportColumnsCenter = [];
        // all columns & groups to be rendered, index by row. used by header rows to get all items
        // to render for that row.
        this.viewportRowLeft = {};
        this.viewportRowRight = {};
        this.viewportRowCenter = {};
        this.autoHeightActiveAtLeastOnce = false;
        this.rowGroupColumns = [];
        this.valueColumns = [];
        this.pivotColumns = [];
        this.ready = false;
        this.changeEventsDispatching = false;
        this.autoGroupsNeedBuilding = false;
        this.forceRecreateAutoGroups = false;
        this.pivotMode = false;
        this.bodyWidth = 0;
        this.leftWidth = 0;
        this.rightWidth = 0;
        this.bodyWidthDirty = true;
        // when we're waiting for cell data types to be inferred, we need to defer column resizing
        this.shouldQueueResizeOperations = false;
        this.resizeOperationQueue = [];
    }
    init() {
        this.suppressColumnVirtualisation = this.gos.get("suppressColumnVirtualisation");
        const pivotMode = this.gos.get("pivotMode");
        if (this.isPivotSettingAllowed(pivotMode)) this.pivotMode = pivotMode;
        this.addManagedPropertyListeners([
            "groupDisplayType",
            "treeData",
            "treeDataDisplayType",
            "groupHideOpenParents"
        ], (event)=>this.buildAutoGroupColumns($437b23f6a393c3bf$var$convertSourceType(event.source)));
        this.addManagedPropertyListener("autoGroupColumnDef", (event)=>this.onAutoGroupColumnDefChanged($437b23f6a393c3bf$var$convertSourceType(event.source)));
        this.addManagedPropertyListeners([
            "defaultColDef",
            "columnTypes",
            "suppressFieldDotNotation"
        ], (event)=>this.onSharedColDefChanged($437b23f6a393c3bf$var$convertSourceType(event.source)));
        this.addManagedPropertyListener("pivotMode", (event)=>this.setPivotMode(this.gos.get("pivotMode"), $437b23f6a393c3bf$var$convertSourceType(event.source)));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_FIRST_DATA_RENDERED, ()=>this.onFirstDataRendered());
    }
    buildAutoGroupColumns(source) {
        if (!this.columnDefs) return;
        this.autoGroupsNeedBuilding = true;
        this.forceRecreateAutoGroups = true;
        this.updateGridColumns();
        this.updateDisplayedColumns(source);
    }
    onAutoGroupColumnDefChanged(source) {
        if (this.groupAutoColumns) this.autoGroupColService.updateAutoGroupColumns(this.groupAutoColumns, source);
    }
    onSharedColDefChanged(source) {
        if (!this.gridColumns) return;
        if (this.groupAutoColumns) this.autoGroupColService.updateAutoGroupColumns(this.groupAutoColumns, source);
        this.createColumnsFromColumnDefs(true, source);
    }
    setColumnDefs(columnDefs, source) {
        const colsPreviouslyExisted = !!this.columnDefs;
        this.columnDefs = columnDefs;
        this.createColumnsFromColumnDefs(colsPreviouslyExisted, source);
    }
    recreateColumnDefs(source) {
        this.onSharedColDefChanged(source);
    }
    destroyOldColumns(oldTree, newTree) {
        const oldObjectsById = {};
        if (!oldTree) return;
        $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(null, oldTree, (child)=>{
            oldObjectsById[child.getInstanceId()] = child;
        });
        if (newTree) $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(null, newTree, (child)=>{
            oldObjectsById[child.getInstanceId()] = null;
        });
        const colsToDestroy = Object.values(oldObjectsById).filter((item)=>item != null);
        this.destroyBeans(colsToDestroy);
    }
    destroyColumns() {
        this.destroyOldColumns(this.primaryColumnTree);
        this.destroyOldColumns(this.secondaryBalancedTree);
        this.destroyOldColumns(this.groupAutoColsBalancedTree);
    }
    createColumnsFromColumnDefs(colsPreviouslyExisted, source) {
        const dispatchEventsFunc = colsPreviouslyExisted ? this.compareColumnStatesAndDispatchEvents(source) : void 0;
        this.valueCache.expire();
        this.autoGroupsNeedBuilding = true;
        const oldPrimaryColumns = this.primaryColumns;
        const oldPrimaryTree = this.primaryColumnTree;
        const balancedTreeResult = this.columnFactory.createColumnTree(this.columnDefs, true, oldPrimaryTree, source);
        this.destroyOldColumns(this.primaryColumnTree, balancedTreeResult.columnTree);
        this.primaryColumnTree = balancedTreeResult.columnTree;
        this.primaryHeaderRowCount = balancedTreeResult.treeDept + 1;
        this.primaryColumns = this.getColumnsFromTree(this.primaryColumnTree);
        this.primaryColumnsMap = {};
        this.primaryColumns.forEach((col)=>this.primaryColumnsMap[col.getId()] = col);
        this.extractRowGroupColumns(source, oldPrimaryColumns);
        this.extractPivotColumns(source, oldPrimaryColumns);
        this.extractValueColumns(source, oldPrimaryColumns);
        this.ready = true;
        const gridColsNotProcessed = this.gridColsArePrimary === void 0;
        const processGridCols = this.gridColsArePrimary || gridColsNotProcessed || this.autoGroupsNeedBuilding;
        if (processGridCols) {
            this.updateGridColumns();
            if (colsPreviouslyExisted && this.gridColsArePrimary && !this.gos.get("maintainColumnOrder")) this.orderGridColumnsLikePrimary();
            this.updateDisplayedColumns(source);
            this.checkViewportColumns();
        }
        this.dispatchEverythingChanged(source);
        this.changeEventsDispatching = true;
        if (dispatchEventsFunc) dispatchEventsFunc();
        this.changeEventsDispatching = false;
        this.dispatchNewColumnsLoaded(source);
    }
    shouldRowModelIgnoreRefresh() {
        return this.changeEventsDispatching;
    }
    dispatchNewColumnsLoaded(source) {
        const newColumnsLoadedEvent = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_NEW_COLUMNS_LOADED,
            source: source
        };
        this.eventService.dispatchEvent(newColumnsLoadedEvent);
        if (source === "gridInitializing") this.onColumnsReady();
    }
    // this event is legacy, no grid code listens to it. instead the grid listens to New Columns Loaded
    dispatchEverythingChanged(source) {
        const eventEverythingChanged = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_EVERYTHING_CHANGED,
            source: source
        };
        this.eventService.dispatchEvent(eventEverythingChanged);
    }
    orderGridColumnsLikePrimary() {
        const primaryColumns = this.primaryColumns;
        if (!primaryColumns) return;
        const primaryColsOrdered = primaryColumns.filter((col)=>this.gridColumns.indexOf(col) >= 0);
        const otherCols = this.gridColumns.filter((col)=>primaryColsOrdered.indexOf(col) < 0);
        this.gridColumns = [
            ...otherCols,
            ...primaryColsOrdered
        ];
        this.gridColumns = this.placeLockedColumns(this.gridColumns);
    }
    getAllDisplayedAutoHeightCols() {
        return this.displayedAutoHeightCols;
    }
    setViewport() {
        if (this.gos.get("enableRtl")) {
            this.viewportLeft = this.bodyWidth - this.scrollPosition - this.scrollWidth;
            this.viewportRight = this.bodyWidth - this.scrollPosition;
        } else {
            this.viewportLeft = this.scrollPosition;
            this.viewportRight = this.scrollWidth + this.scrollPosition;
        }
    }
    // checks what columns are currently displayed due to column virtualisation. dispatches an event
    // if the list of columns has changed.
    // + setColumnWidth(), setViewportPosition(), setColumnDefs(), sizeColumnsToFit()
    checkViewportColumns(afterScroll = false) {
        if (this.displayedColumnsCenter == null) return;
        const viewportColumnsChanged = this.extractViewport();
        if (!viewportColumnsChanged) return;
        const event = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_VIRTUAL_COLUMNS_CHANGED,
            afterScroll: afterScroll
        };
        this.eventService.dispatchEvent(event);
    }
    setViewportPosition(scrollWidth, scrollPosition, afterScroll = false) {
        if (scrollWidth !== this.scrollWidth || scrollPosition !== this.scrollPosition || this.bodyWidthDirty) {
            this.scrollWidth = scrollWidth;
            this.scrollPosition = scrollPosition;
            this.bodyWidthDirty = true;
            this.setViewport();
            if (this.ready) this.checkViewportColumns(afterScroll);
        }
    }
    isPivotMode() {
        return this.pivotMode;
    }
    isPivotSettingAllowed(pivot) {
        if (pivot && this.gos.get("treeData")) {
            $437b23f6a393c3bf$var$warnOnce("Pivot mode not available with treeData.");
            return false;
        }
        return true;
    }
    setPivotMode(pivotMode, source) {
        if (pivotMode === this.pivotMode || !this.isPivotSettingAllowed(this.pivotMode)) return;
        this.pivotMode = pivotMode;
        if (!this.gridColumns) return;
        this.autoGroupsNeedBuilding = true;
        this.updateGridColumns();
        this.updateDisplayedColumns(source);
        const event = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_PIVOT_MODE_CHANGED
        };
        this.eventService.dispatchEvent(event);
    }
    getSecondaryPivotColumn(pivotKeys, valueColKey) {
        if ($437b23f6a393c3bf$var$missing(this.secondaryColumns)) return null;
        const valueColumnToFind = this.getPrimaryColumn(valueColKey);
        let foundColumn = null;
        this.secondaryColumns.forEach((column)=>{
            const thisPivotKeys = column.getColDef().pivotKeys;
            const pivotValueColumn = column.getColDef().pivotValueColumn;
            const pivotKeyMatches = $437b23f6a393c3bf$var$areEqual(thisPivotKeys, pivotKeys);
            const pivotValueMatches = pivotValueColumn === valueColumnToFind;
            if (pivotKeyMatches && pivotValueMatches) foundColumn = column;
        });
        return foundColumn;
    }
    setBeans(loggerFactory) {
        this.logger = loggerFactory.create("columnModel");
    }
    setFirstRightAndLastLeftPinned(source) {
        let lastLeft;
        let firstRight;
        if (this.gos.get("enableRtl")) {
            lastLeft = this.displayedColumnsLeft ? this.displayedColumnsLeft[0] : null;
            firstRight = this.displayedColumnsRight ? $437b23f6a393c3bf$var$last(this.displayedColumnsRight) : null;
        } else {
            lastLeft = this.displayedColumnsLeft ? $437b23f6a393c3bf$var$last(this.displayedColumnsLeft) : null;
            firstRight = this.displayedColumnsRight ? this.displayedColumnsRight[0] : null;
        }
        this.gridColumns.forEach((column)=>{
            column.setLastLeftPinned(column === lastLeft, source);
            column.setFirstRightPinned(column === firstRight, source);
        });
    }
    autoSizeColumns(params) {
        if (this.shouldQueueResizeOperations) {
            this.resizeOperationQueue.push(()=>this.autoSizeColumns(params));
            return;
        }
        const { columns: columns, skipHeader: skipHeader, skipHeaderGroups: skipHeaderGroups, stopAtGroup: stopAtGroup, source: source = "api" } = params;
        this.animationFrameService.flushAllFrames();
        const columnsAutosized = [];
        let changesThisTimeAround = -1;
        const shouldSkipHeader = skipHeader != null ? skipHeader : this.gos.get("skipHeaderOnAutoSize");
        const shouldSkipHeaderGroups = skipHeaderGroups != null ? skipHeaderGroups : shouldSkipHeader;
        while(changesThisTimeAround !== 0){
            changesThisTimeAround = 0;
            this.actionOnGridColumns(columns, (column)=>{
                if (columnsAutosized.indexOf(column) >= 0) return false;
                const preferredWidth = this.autoWidthCalculator.getPreferredWidthForColumn(column, shouldSkipHeader);
                if (preferredWidth > 0) {
                    const newWidth = this.normaliseColumnWidth(column, preferredWidth);
                    column.setActualWidth(newWidth, source);
                    columnsAutosized.push(column);
                    changesThisTimeAround++;
                }
                return true;
            }, source);
        }
        if (!shouldSkipHeaderGroups) this.autoSizeColumnGroupsByColumns(columns, source, stopAtGroup);
        this.dispatchColumnResizedEvent(columnsAutosized, true, "autosizeColumns");
    }
    dispatchColumnResizedEvent(columns, finished, source, flexColumns = null) {
        if (columns && columns.length) {
            const event = {
                type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_RESIZED,
                columns: columns,
                column: columns.length === 1 ? columns[0] : null,
                flexColumns: flexColumns,
                finished: finished,
                source: source
            };
            this.eventService.dispatchEvent(event);
        }
    }
    dispatchColumnChangedEvent(type, columns, source) {
        const event = {
            type: type,
            columns: columns,
            column: columns && columns.length == 1 ? columns[0] : null,
            source: source
        };
        this.eventService.dispatchEvent(event);
    }
    dispatchColumnMovedEvent(params) {
        const { movedColumns: movedColumns, source: source, toIndex: toIndex, finished: finished } = params;
        const event = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_MOVED,
            columns: movedColumns,
            column: movedColumns && movedColumns.length === 1 ? movedColumns[0] : null,
            toIndex: toIndex,
            finished: finished,
            source: source
        };
        this.eventService.dispatchEvent(event);
    }
    dispatchColumnPinnedEvent(changedColumns, source) {
        if (!changedColumns.length) return;
        const column = changedColumns.length === 1 ? changedColumns[0] : null;
        const pinned = this.getCommonValue(changedColumns, (col)=>col.getPinned());
        const event = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_PINNED,
            // mistake in typing, 'undefined' should be allowed, as 'null' means 'not pinned'
            pinned: pinned != null ? pinned : null,
            columns: changedColumns,
            column: column,
            source: source
        };
        this.eventService.dispatchEvent(event);
    }
    dispatchColumnVisibleEvent(changedColumns, source) {
        if (!changedColumns.length) return;
        const column = changedColumns.length === 1 ? changedColumns[0] : null;
        const visible = this.getCommonValue(changedColumns, (col)=>col.isVisible());
        const event = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_VISIBLE,
            visible: visible,
            columns: changedColumns,
            column: column,
            source: source
        };
        this.eventService.dispatchEvent(event);
    }
    autoSizeColumn(key, source, skipHeader) {
        if (key) this.autoSizeColumns({
            columns: [
                key
            ],
            skipHeader: skipHeader,
            skipHeaderGroups: true,
            source: source
        });
    }
    autoSizeColumnGroupsByColumns(keys2, source, stopAtGroup) {
        const columnGroups = /* @__PURE__ */ new Set();
        const columns = this.getGridColumns(keys2);
        columns.forEach((col)=>{
            let parent = col.getParent();
            while(parent && parent != stopAtGroup){
                if (!parent.isPadding()) columnGroups.add(parent);
                parent = parent.getParent();
            }
        });
        let headerGroupCtrl;
        const resizedColumns = [];
        for (const columnGroup of columnGroups){
            for (const headerContainerCtrl of this.ctrlsService.getHeaderRowContainerCtrls()){
                headerGroupCtrl = headerContainerCtrl.getHeaderCtrlForColumn(columnGroup);
                if (headerGroupCtrl) break;
            }
            if (headerGroupCtrl) headerGroupCtrl.resizeLeafColumnsToFit(source);
        }
        return resizedColumns;
    }
    autoSizeAllColumns(source, skipHeader) {
        if (this.shouldQueueResizeOperations) {
            this.resizeOperationQueue.push(()=>this.autoSizeAllColumns(source, skipHeader));
            return;
        }
        const allDisplayedColumns = this.getAllDisplayedColumns();
        this.autoSizeColumns({
            columns: allDisplayedColumns,
            skipHeader: skipHeader,
            source: source
        });
    }
    // Possible candidate for reuse (alot of recursive traversal duplication)
    getColumnsFromTree(rootColumns) {
        const result = [];
        const recursiveFindColumns = (childColumns)=>{
            for(let i = 0; i < childColumns.length; i++){
                const child = childColumns[i];
                if (child instanceof $437b23f6a393c3bf$export$816b5d811295e6bc) result.push(child);
                else if (child instanceof $437b23f6a393c3bf$export$89dd394cd2c9e921) recursiveFindColumns(child.getChildren());
            }
        };
        recursiveFindColumns(rootColumns);
        return result;
    }
    getAllDisplayedTrees() {
        if (this.displayedTreeLeft && this.displayedTreeRight && this.displayedTreeCentre) return this.displayedTreeLeft.concat(this.displayedTreeCentre).concat(this.displayedTreeRight);
        return null;
    }
    // + columnSelectPanel
    getPrimaryColumnTree() {
        return this.primaryColumnTree;
    }
    // + gridPanel -> for resizing the body and setting top margin
    getHeaderRowCount() {
        return this.gridHeaderRowCount;
    }
    // + headerRenderer -> setting pinned body width
    getDisplayedTreeLeft() {
        return this.displayedTreeLeft;
    }
    // + headerRenderer -> setting pinned body width
    getDisplayedTreeRight() {
        return this.displayedTreeRight;
    }
    // + headerRenderer -> setting pinned body width
    getDisplayedTreeCentre() {
        return this.displayedTreeCentre;
    }
    // gridPanel -> ensureColumnVisible
    isColumnDisplayed(column) {
        return this.getAllDisplayedColumns().indexOf(column) >= 0;
    }
    // + csvCreator
    getAllDisplayedColumns() {
        return this.displayedColumns;
    }
    getViewportColumns() {
        return this.viewportColumns;
    }
    getDisplayedLeftColumnsForRow(rowNode) {
        if (!this.colSpanActive) return this.displayedColumnsLeft;
        return this.getDisplayedColumnsForRow(rowNode, this.displayedColumnsLeft);
    }
    getDisplayedRightColumnsForRow(rowNode) {
        if (!this.colSpanActive) return this.displayedColumnsRight;
        return this.getDisplayedColumnsForRow(rowNode, this.displayedColumnsRight);
    }
    isColSpanActive() {
        return this.colSpanActive;
    }
    getDisplayedColumnsForRow(rowNode, displayedColumns, filterCallback, emptySpaceBeforeColumn) {
        const result = [];
        let lastConsideredCol = null;
        for(let i = 0; i < displayedColumns.length; i++){
            const col = displayedColumns[i];
            const maxAllowedColSpan = displayedColumns.length - i;
            const colSpan = Math.min(col.getColSpan(rowNode), maxAllowedColSpan);
            const columnsToCheckFilter = [
                col
            ];
            if (colSpan > 1) {
                const colsToRemove = colSpan - 1;
                for(let j = 1; j <= colsToRemove; j++)columnsToCheckFilter.push(displayedColumns[i + j]);
                i += colsToRemove;
            }
            let filterPasses;
            if (filterCallback) {
                filterPasses = false;
                columnsToCheckFilter.forEach((colForFilter)=>{
                    if (filterCallback(colForFilter)) filterPasses = true;
                });
            } else filterPasses = true;
            if (filterPasses) {
                if (result.length === 0 && lastConsideredCol) {
                    const gapBeforeColumn = emptySpaceBeforeColumn ? emptySpaceBeforeColumn(col) : false;
                    if (gapBeforeColumn) result.push(lastConsideredCol);
                }
                result.push(col);
            }
            lastConsideredCol = col;
        }
        return result;
    }
    // + rowRenderer
    // if we are not column spanning, this just returns back the virtual centre columns,
    // however if we are column spanning, then different rows can have different virtual
    // columns, so we have to work out the list for each individual row.
    getViewportCenterColumnsForRow(rowNode) {
        if (!this.colSpanActive) return this.viewportColumnsCenter;
        const emptySpaceBeforeColumn = (col)=>{
            const left = col.getLeft();
            return $437b23f6a393c3bf$var$exists(left) && left > this.viewportLeft;
        };
        const filterCallback = this.isColumnVirtualisationSuppressed() ? null : this.isColumnInRowViewport.bind(this);
        return this.getDisplayedColumnsForRow(rowNode, this.displayedColumnsCenter, filterCallback, emptySpaceBeforeColumn);
    }
    isColumnAtEdge(col, edge) {
        const allColumns = this.getAllDisplayedColumns();
        if (!allColumns.length) return false;
        const isFirst = edge === "first";
        let columnToCompare;
        if (col instanceof $437b23f6a393c3bf$export$8a8fbc71323f074) {
            const leafColumns = col.getDisplayedLeafColumns();
            if (!leafColumns.length) return false;
            columnToCompare = isFirst ? leafColumns[0] : $437b23f6a393c3bf$var$last(leafColumns);
        } else columnToCompare = col;
        return (isFirst ? allColumns[0] : $437b23f6a393c3bf$var$last(allColumns)) === columnToCompare;
    }
    getAriaColumnIndex(col) {
        let targetColumn;
        if (col instanceof $437b23f6a393c3bf$export$8a8fbc71323f074) targetColumn = col.getLeafColumns()[0];
        else targetColumn = col;
        return this.ariaOrderColumns.indexOf(targetColumn) + 1;
    }
    isColumnInHeaderViewport(col) {
        if (col.isAutoHeaderHeight()) return true;
        return this.isColumnInRowViewport(col);
    }
    isColumnInRowViewport(col) {
        if (col.isAutoHeight()) return true;
        const columnLeft = col.getLeft() || 0;
        const columnRight = columnLeft + col.getActualWidth();
        const leftBounds = this.viewportLeft - 200;
        const rightBounds = this.viewportRight + 200;
        const columnToMuchLeft = columnLeft < leftBounds && columnRight < leftBounds;
        const columnToMuchRight = columnLeft > rightBounds && columnRight > rightBounds;
        return !columnToMuchLeft && !columnToMuchRight;
    }
    // used by:
    // + angularGrid -> setting pinned body width
    // note: this should be cached
    getDisplayedColumnsLeftWidth() {
        return this.getWidthOfColsInList(this.displayedColumnsLeft);
    }
    // note: this should be cached
    getDisplayedColumnsRightWidth() {
        return this.getWidthOfColsInList(this.displayedColumnsRight);
    }
    updatePrimaryColumnList(keys2, masterList, actionIsAdd, columnCallback, eventType, source) {
        if (!keys2 || $437b23f6a393c3bf$var$missingOrEmpty(keys2)) return;
        let atLeastOne = false;
        keys2.forEach((key)=>{
            if (!key) return;
            const columnToAdd = this.getPrimaryColumn(key);
            if (!columnToAdd) return;
            if (actionIsAdd) {
                if (masterList.indexOf(columnToAdd) >= 0) return;
                masterList.push(columnToAdd);
            } else {
                if (masterList.indexOf(columnToAdd) < 0) return;
                $437b23f6a393c3bf$var$removeFromArray(masterList, columnToAdd);
            }
            columnCallback(columnToAdd);
            atLeastOne = true;
        });
        if (!atLeastOne) return;
        if (this.autoGroupsNeedBuilding) this.updateGridColumns();
        this.updateDisplayedColumns(source);
        const event = {
            type: eventType,
            columns: masterList,
            column: masterList.length === 1 ? masterList[0] : null,
            source: source
        };
        this.eventService.dispatchEvent(event);
    }
    setRowGroupColumns(colKeys, source) {
        this.autoGroupsNeedBuilding = true;
        this.setPrimaryColumnList(colKeys, this.rowGroupColumns, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_ROW_GROUP_CHANGED, true, this.setRowGroupActive.bind(this), source);
    }
    setRowGroupActive(active, column, source) {
        if (active === column.isRowGroupActive()) return;
        column.setRowGroupActive(active, source);
        if (active && !this.gos.get("suppressRowGroupHidesColumns")) this.setColumnsVisible([
            column
        ], false, source);
        if (!active && !this.gos.get("suppressMakeColumnVisibleAfterUnGroup")) this.setColumnsVisible([
            column
        ], true, source);
    }
    addRowGroupColumns(keys2, source) {
        this.autoGroupsNeedBuilding = true;
        this.updatePrimaryColumnList(keys2, this.rowGroupColumns, true, this.setRowGroupActive.bind(this, true), $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_ROW_GROUP_CHANGED, source);
    }
    removeRowGroupColumns(keys2, source) {
        this.autoGroupsNeedBuilding = true;
        this.updatePrimaryColumnList(keys2, this.rowGroupColumns, false, this.setRowGroupActive.bind(this, false), $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_ROW_GROUP_CHANGED, source);
    }
    addPivotColumns(keys2, source) {
        this.updatePrimaryColumnList(keys2, this.pivotColumns, true, (column)=>column.setPivotActive(true, source), $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_PIVOT_CHANGED, source);
    }
    setPivotColumns(colKeys, source) {
        this.setPrimaryColumnList(colKeys, this.pivotColumns, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_PIVOT_CHANGED, true, (added, column)=>{
            column.setPivotActive(added, source);
        }, source);
    }
    removePivotColumns(keys2, source) {
        this.updatePrimaryColumnList(keys2, this.pivotColumns, false, (column)=>column.setPivotActive(false, source), $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_PIVOT_CHANGED, source);
    }
    setPrimaryColumnList(colKeys, masterList, eventName, detectOrderChange, columnCallback, source) {
        if (!this.gridColumns) return;
        const changes = /* @__PURE__ */ new Map();
        masterList.forEach((col, idx)=>changes.set(col, idx));
        masterList.length = 0;
        if ($437b23f6a393c3bf$var$exists(colKeys)) colKeys.forEach((key)=>{
            const column = this.getPrimaryColumn(key);
            if (column) masterList.push(column);
        });
        masterList.forEach((col, idx)=>{
            const oldIndex = changes.get(col);
            if (oldIndex === void 0) {
                changes.set(col, 0);
                return;
            }
            if (detectOrderChange && oldIndex !== idx) return;
            changes.delete(col);
        });
        (this.primaryColumns || []).forEach((column)=>{
            const added = masterList.indexOf(column) >= 0;
            columnCallback(added, column);
        });
        if (this.autoGroupsNeedBuilding) this.updateGridColumns();
        this.updateDisplayedColumns(source);
        this.dispatchColumnChangedEvent(eventName, [
            ...changes.keys()
        ], source);
    }
    setValueColumns(colKeys, source) {
        this.setPrimaryColumnList(colKeys, this.valueColumns, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_VALUE_CHANGED, false, this.setValueActive.bind(this), source);
    }
    setValueActive(active, column, source) {
        if (active === column.isValueActive()) return;
        column.setValueActive(active, source);
        if (active && !column.getAggFunc() && this.aggFuncService) {
            const initialAggFunc = this.aggFuncService.getDefaultAggFunc(column);
            column.setAggFunc(initialAggFunc);
        }
    }
    addValueColumns(keys2, source) {
        this.updatePrimaryColumnList(keys2, this.valueColumns, true, this.setValueActive.bind(this, true), $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_VALUE_CHANGED, source);
    }
    removeValueColumns(keys2, source) {
        this.updatePrimaryColumnList(keys2, this.valueColumns, false, this.setValueActive.bind(this, false), $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_VALUE_CHANGED, source);
    }
    // returns the width we can set to this col, taking into consideration min and max widths
    normaliseColumnWidth(column, newWidth) {
        const minWidth = column.getMinWidth();
        if ($437b23f6a393c3bf$var$exists(minWidth) && newWidth < minWidth) newWidth = minWidth;
        const maxWidth = column.getMaxWidth();
        if ($437b23f6a393c3bf$var$exists(maxWidth) && column.isGreaterThanMax(newWidth)) newWidth = maxWidth;
        return newWidth;
    }
    getPrimaryOrGridColumn(key) {
        const column = this.getPrimaryColumn(key);
        return column || this.getGridColumn(key);
    }
    setColumnWidths(columnWidths, shiftKey, finished, source) {
        const sets = [];
        columnWidths.forEach((columnWidth)=>{
            const col = this.getPrimaryOrGridColumn(columnWidth.key);
            if (!col) return;
            sets.push({
                width: columnWidth.newWidth,
                ratios: [
                    1
                ],
                columns: [
                    col
                ]
            });
            const defaultIsShift = this.gos.get("colResizeDefault") === "shift";
            if (defaultIsShift) shiftKey = !shiftKey;
            if (shiftKey) {
                const otherCol = this.getDisplayedColAfter(col);
                if (!otherCol) return;
                const widthDiff = col.getActualWidth() - columnWidth.newWidth;
                const otherColWidth = otherCol.getActualWidth() + widthDiff;
                sets.push({
                    width: otherColWidth,
                    ratios: [
                        1
                    ],
                    columns: [
                        otherCol
                    ]
                });
            }
        });
        if (sets.length === 0) return;
        this.resizeColumnSets({
            resizeSets: sets,
            finished: finished,
            source: source
        });
    }
    checkMinAndMaxWidthsForSet(columnResizeSet) {
        const { columns: columns, width: width } = columnResizeSet;
        let minWidthAccumulated = 0;
        let maxWidthAccumulated = 0;
        let maxWidthActive = true;
        columns.forEach((col)=>{
            const minWidth = col.getMinWidth();
            minWidthAccumulated += minWidth || 0;
            const maxWidth = col.getMaxWidth();
            if ($437b23f6a393c3bf$var$exists(maxWidth) && maxWidth > 0) maxWidthAccumulated += maxWidth;
            else maxWidthActive = false;
        });
        const minWidthPasses = width >= minWidthAccumulated;
        const maxWidthPasses = !maxWidthActive || width <= maxWidthAccumulated;
        return minWidthPasses && maxWidthPasses;
    }
    // method takes sets of columns and resizes them. either all sets will be resized, or nothing
    // be resized. this is used for example when user tries to resize a group and holds shift key,
    // then both the current group (grows), and the adjacent group (shrinks), will get resized,
    // so that's two sets for this method.
    resizeColumnSets(params) {
        const { resizeSets: resizeSets, finished: finished, source: source } = params;
        const passMinMaxCheck = !resizeSets || resizeSets.every((columnResizeSet)=>this.checkMinAndMaxWidthsForSet(columnResizeSet));
        if (!passMinMaxCheck) {
            if (finished) {
                const columns = resizeSets && resizeSets.length > 0 ? resizeSets[0].columns : null;
                this.dispatchColumnResizedEvent(columns, finished, source);
            }
            return;
        }
        const changedCols = [];
        const allResizedCols = [];
        resizeSets.forEach((set)=>{
            const { width: width, columns: columns, ratios: ratios } = set;
            const newWidths = {};
            const finishedCols = {};
            columns.forEach((col)=>allResizedCols.push(col));
            let finishedColsGrew = true;
            let loopCount = 0;
            while(finishedColsGrew){
                loopCount++;
                if (loopCount > 1e3) {
                    console.error("AG Grid: infinite loop in resizeColumnSets");
                    break;
                }
                finishedColsGrew = false;
                const subsetCols = [];
                let subsetRatioTotal = 0;
                let pixelsToDistribute = width;
                columns.forEach((col, index)=>{
                    const thisColFinished = finishedCols[col.getId()];
                    if (thisColFinished) pixelsToDistribute -= newWidths[col.getId()];
                    else {
                        subsetCols.push(col);
                        const ratioThisCol = ratios[index];
                        subsetRatioTotal += ratioThisCol;
                    }
                });
                const ratioScale = 1 / subsetRatioTotal;
                subsetCols.forEach((col, index)=>{
                    const lastCol = index === subsetCols.length - 1;
                    let colNewWidth;
                    if (lastCol) colNewWidth = pixelsToDistribute;
                    else {
                        colNewWidth = Math.round(ratios[index] * width * ratioScale);
                        pixelsToDistribute -= colNewWidth;
                    }
                    const minWidth = col.getMinWidth();
                    const maxWidth = col.getMaxWidth();
                    if ($437b23f6a393c3bf$var$exists(minWidth) && colNewWidth < minWidth) {
                        colNewWidth = minWidth;
                        finishedCols[col.getId()] = true;
                        finishedColsGrew = true;
                    } else if ($437b23f6a393c3bf$var$exists(maxWidth) && maxWidth > 0 && colNewWidth > maxWidth) {
                        colNewWidth = maxWidth;
                        finishedCols[col.getId()] = true;
                        finishedColsGrew = true;
                    }
                    newWidths[col.getId()] = colNewWidth;
                });
            }
            columns.forEach((col)=>{
                const newWidth = newWidths[col.getId()];
                const actualWidth = col.getActualWidth();
                if (actualWidth !== newWidth) {
                    col.setActualWidth(newWidth, source);
                    changedCols.push(col);
                }
            });
        });
        const atLeastOneColChanged = changedCols.length > 0;
        let flexedCols = [];
        if (atLeastOneColChanged) {
            flexedCols = this.refreshFlexedColumns({
                resizingCols: allResizedCols,
                skipSetLeft: true
            });
            this.setLeftValues(source);
            this.updateBodyWidths();
            this.checkViewportColumns();
        }
        const colsForEvent = allResizedCols.concat(flexedCols);
        if (atLeastOneColChanged || finished) this.dispatchColumnResizedEvent(colsForEvent, finished, source, flexedCols);
    }
    setColumnAggFunc(key, aggFunc, source) {
        if (!key) return;
        const column = this.getPrimaryColumn(key);
        if (!column) return;
        column.setAggFunc(aggFunc);
        this.dispatchColumnChangedEvent($437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_VALUE_CHANGED, [
            column
        ], source);
    }
    moveRowGroupColumn(fromIndex, toIndex, source) {
        if (this.isRowGroupEmpty()) return;
        const column = this.rowGroupColumns[fromIndex];
        const impactedColumns = this.rowGroupColumns.slice(fromIndex, toIndex);
        this.rowGroupColumns.splice(fromIndex, 1);
        this.rowGroupColumns.splice(toIndex, 0, column);
        const event = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_ROW_GROUP_CHANGED,
            columns: impactedColumns,
            column: impactedColumns.length === 1 ? impactedColumns[0] : null,
            source: source
        };
        this.eventService.dispatchEvent(event);
    }
    moveColumns(columnsToMoveKeys, toIndex, source, finished = true) {
        if (!this.gridColumns) return;
        this.columnAnimationService.start();
        if (toIndex > this.gridColumns.length - columnsToMoveKeys.length) {
            console.warn("AG Grid: tried to insert columns in invalid location, toIndex = " + toIndex);
            console.warn("AG Grid: remember that you should not count the moving columns when calculating the new index");
            return;
        }
        const movedColumns = this.getGridColumns(columnsToMoveKeys);
        const failedRules = !this.doesMovePassRules(movedColumns, toIndex);
        if (failedRules) return;
        $437b23f6a393c3bf$var$moveInArray(this.gridColumns, movedColumns, toIndex);
        this.updateDisplayedColumns(source);
        this.dispatchColumnMovedEvent({
            movedColumns: movedColumns,
            source: source,
            toIndex: toIndex,
            finished: finished
        });
        this.columnAnimationService.finish();
    }
    doesMovePassRules(columnsToMove, toIndex) {
        const proposedColumnOrder = this.getProposedColumnOrder(columnsToMove, toIndex);
        return this.doesOrderPassRules(proposedColumnOrder);
    }
    doesOrderPassRules(gridOrder) {
        if (!this.doesMovePassMarryChildren(gridOrder)) return false;
        if (!this.doesMovePassLockedPositions(gridOrder)) return false;
        return true;
    }
    getProposedColumnOrder(columnsToMove, toIndex) {
        const proposedColumnOrder = this.gridColumns.slice();
        $437b23f6a393c3bf$var$moveInArray(proposedColumnOrder, columnsToMove, toIndex);
        return proposedColumnOrder;
    }
    // returns the provided cols sorted in same order as they appear in grid columns. eg if grid columns
    // contains [a,b,c,d,e] and col passed is [e,a] then the passed cols are sorted into [a,e]
    sortColumnsLikeGridColumns(cols) {
        if (!cols || cols.length <= 1) return;
        const notAllColsInGridColumns = cols.filter((c)=>this.gridColumns.indexOf(c) < 0).length > 0;
        if (notAllColsInGridColumns) return;
        cols.sort((a, b)=>{
            const indexA = this.gridColumns.indexOf(a);
            const indexB = this.gridColumns.indexOf(b);
            return indexA - indexB;
        });
    }
    doesMovePassLockedPositions(proposedColumnOrder) {
        let lastPlacement = 0;
        let rulePassed = true;
        const lockPositionToPlacement = (position)=>{
            if (!position) return 1;
            if (position === true) return 0;
            return position === "left" ? 0 : 2;
        };
        proposedColumnOrder.forEach((col)=>{
            const placement = lockPositionToPlacement(col.getColDef().lockPosition);
            if (placement < lastPlacement) rulePassed = false;
            lastPlacement = placement;
        });
        return rulePassed;
    }
    doesMovePassMarryChildren(allColumnsCopy) {
        let rulePassed = true;
        $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(null, this.gridBalancedTree, (child)=>{
            if (!(child instanceof $437b23f6a393c3bf$export$89dd394cd2c9e921)) return;
            const columnGroup = child;
            const colGroupDef = columnGroup.getColGroupDef();
            const marryChildren = colGroupDef && colGroupDef.marryChildren;
            if (!marryChildren) return;
            const newIndexes = [];
            columnGroup.getLeafColumns().forEach((col)=>{
                const newColIndex = allColumnsCopy.indexOf(col);
                newIndexes.push(newColIndex);
            });
            const maxIndex = Math.max.apply(Math, newIndexes);
            const minIndex = Math.min.apply(Math, newIndexes);
            const spread = maxIndex - minIndex;
            const maxSpread = columnGroup.getLeafColumns().length - 1;
            if (spread > maxSpread) rulePassed = false;
        });
        return rulePassed;
    }
    moveColumnByIndex(fromIndex, toIndex, source) {
        if (!this.gridColumns) return;
        const column = this.gridColumns[fromIndex];
        this.moveColumns([
            column
        ], toIndex, source);
    }
    getColumnDefs() {
        if (!this.primaryColumns) return;
        const cols = this.primaryColumns.slice();
        if (this.gridColsArePrimary) cols.sort((a, b)=>this.gridColumns.indexOf(a) - this.gridColumns.indexOf(b));
        else if (this.lastPrimaryOrder) cols.sort((a, b)=>this.lastPrimaryOrder.indexOf(a) - this.lastPrimaryOrder.indexOf(b));
        return this.columnDefFactory.buildColumnDefs(cols, this.rowGroupColumns, this.pivotColumns);
    }
    // used by:
    // + angularGrid -> for setting body width
    // + rowController -> setting main row widths (when inserting and resizing)
    // need to cache this
    getBodyContainerWidth() {
        return this.bodyWidth;
    }
    getContainerWidth(pinned) {
        switch(pinned){
            case "left":
                return this.leftWidth;
            case "right":
                return this.rightWidth;
            default:
                return this.bodyWidth;
        }
    }
    // after setColumnWidth or updateGroupsAndDisplayedColumns
    updateBodyWidths() {
        const newBodyWidth = this.getWidthOfColsInList(this.displayedColumnsCenter);
        const newLeftWidth = this.getWidthOfColsInList(this.displayedColumnsLeft);
        const newRightWidth = this.getWidthOfColsInList(this.displayedColumnsRight);
        this.bodyWidthDirty = this.bodyWidth !== newBodyWidth;
        const atLeastOneChanged = this.bodyWidth !== newBodyWidth || this.leftWidth !== newLeftWidth || this.rightWidth !== newRightWidth;
        if (atLeastOneChanged) {
            this.bodyWidth = newBodyWidth;
            this.leftWidth = newLeftWidth;
            this.rightWidth = newRightWidth;
            const evt = {
                type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_CONTAINER_WIDTH_CHANGED
            };
            this.eventService.dispatchEvent(evt);
            const event = {
                type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED
            };
            this.eventService.dispatchEvent(event);
        }
    }
    // + rowController
    getValueColumns() {
        return this.valueColumns ? this.valueColumns : [];
    }
    // + rowController
    getPivotColumns() {
        return this.pivotColumns ? this.pivotColumns : [];
    }
    // + clientSideRowModel
    isPivotActive() {
        return this.pivotColumns && this.pivotColumns.length > 0 && this.pivotMode;
    }
    // + toolPanel
    getRowGroupColumns() {
        return this.rowGroupColumns ? this.rowGroupColumns : [];
    }
    // + rowController -> while inserting rows
    getDisplayedCenterColumns() {
        return this.displayedColumnsCenter;
    }
    // + rowController -> while inserting rows
    getDisplayedLeftColumns() {
        return this.displayedColumnsLeft;
    }
    getDisplayedRightColumns() {
        return this.displayedColumnsRight;
    }
    // used by:
    // + clientSideRowController -> sorting, building quick filter text
    // + headerRenderer -> sorting (clearing icon)
    getAllPrimaryColumns() {
        return this.primaryColumns ? this.primaryColumns : null;
    }
    getSecondaryColumns() {
        return this.secondaryColumns ? this.secondaryColumns : null;
    }
    getAllColumnsForQuickFilter() {
        return this.columnsForQuickFilter;
    }
    // + moveColumnController
    getAllGridColumns() {
        var _a;
        return (_a = this.gridColumns) != null ? _a : [];
    }
    isRowGroupEmpty() {
        return $437b23f6a393c3bf$var$missingOrEmpty(this.rowGroupColumns);
    }
    setColumnsVisible(keys2, visible = false, source) {
        this.applyColumnState({
            state: keys2.map((key)=>({
                    colId: typeof key === "string" ? key : key.getColId(),
                    hide: !visible
                }))
        }, source);
    }
    setColumnsPinned(keys2, pinned, source) {
        if (!this.gridColumns) return;
        if (this.gos.isDomLayout("print")) {
            console.warn(`AG Grid: Changing the column pinning status is not allowed with domLayout='print'`);
            return;
        }
        this.columnAnimationService.start();
        let actualPinned;
        if (pinned === true || pinned === "left") actualPinned = "left";
        else if (pinned === "right") actualPinned = "right";
        else actualPinned = null;
        this.actionOnGridColumns(keys2, (col)=>{
            if (col.getPinned() !== actualPinned) {
                col.setPinned(actualPinned);
                return true;
            }
            return false;
        }, source, ()=>{
            const event = {
                type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_PINNED,
                pinned: actualPinned,
                column: null,
                columns: null,
                source: source
            };
            return event;
        });
        this.columnAnimationService.finish();
    }
    // does an action on a set of columns. provides common functionality for looking up the
    // columns based on key, getting a list of effected columns, and then updated the event
    // with either one column (if it was just one col) or a list of columns
    // used by: autoResize, setVisible, setPinned
    actionOnGridColumns(keys2, action, source, createEvent) {
        if ($437b23f6a393c3bf$var$missingOrEmpty(keys2)) return;
        const updatedColumns = [];
        keys2.forEach((key)=>{
            if (!key) return;
            const column = this.getGridColumn(key);
            if (!column) return;
            const resultOfAction = action(column);
            if (resultOfAction !== false) updatedColumns.push(column);
        });
        if (!updatedColumns.length) return;
        this.updateDisplayedColumns(source);
        if ($437b23f6a393c3bf$var$exists(createEvent) && createEvent) {
            const event = createEvent();
            event.columns = updatedColumns;
            event.column = updatedColumns.length === 1 ? updatedColumns[0] : null;
            this.eventService.dispatchEvent(event);
        }
    }
    getDisplayedColBefore(col) {
        const allDisplayedColumns = this.getAllDisplayedColumns();
        const oldIndex = allDisplayedColumns.indexOf(col);
        if (oldIndex > 0) return allDisplayedColumns[oldIndex - 1];
        return null;
    }
    // used by:
    // + rowRenderer -> for navigation
    getDisplayedColAfter(col) {
        const allDisplayedColumns = this.getAllDisplayedColumns();
        const oldIndex = allDisplayedColumns.indexOf(col);
        if (oldIndex < allDisplayedColumns.length - 1) return allDisplayedColumns[oldIndex + 1];
        return null;
    }
    getDisplayedGroupAtDirection(columnGroup, direction) {
        const requiredLevel = columnGroup.getProvidedColumnGroup().getLevel() + columnGroup.getPaddingLevel();
        const colGroupLeafColumns = columnGroup.getDisplayedLeafColumns();
        const col = direction === "After" ? $437b23f6a393c3bf$var$last(colGroupLeafColumns) : colGroupLeafColumns[0];
        const getDisplayColMethod = `getDisplayedCol${direction}`;
        while(true){
            const column = this[getDisplayColMethod](col);
            if (!column) return null;
            const groupPointer = this.getColumnGroupAtLevel(column, requiredLevel);
            if (groupPointer !== columnGroup) return groupPointer;
        }
    }
    getColumnGroupAtLevel(column, level) {
        let groupPointer = column.getParent();
        let originalGroupLevel;
        let groupPointerLevel;
        while(true){
            const groupPointerProvidedColumnGroup = groupPointer.getProvidedColumnGroup();
            originalGroupLevel = groupPointerProvidedColumnGroup.getLevel();
            groupPointerLevel = groupPointer.getPaddingLevel();
            if (originalGroupLevel + groupPointerLevel <= level) break;
            groupPointer = groupPointer.getParent();
        }
        return groupPointer;
    }
    isPinningLeft() {
        return this.displayedColumnsLeft.length > 0;
    }
    isPinningRight() {
        return this.displayedColumnsRight.length > 0;
    }
    getPrimaryAndSecondaryAndAutoColumns() {
        return [].concat(...[
            this.primaryColumns || [],
            this.groupAutoColumns || [],
            this.secondaryColumns || []
        ]);
    }
    createStateItemFromColumn(column) {
        const rowGroupIndex = column.isRowGroupActive() ? this.rowGroupColumns.indexOf(column) : null;
        const pivotIndex = column.isPivotActive() ? this.pivotColumns.indexOf(column) : null;
        const aggFunc = column.isValueActive() ? column.getAggFunc() : null;
        const sort = column.getSort() != null ? column.getSort() : null;
        const sortIndex = column.getSortIndex() != null ? column.getSortIndex() : null;
        const flex = column.getFlex() != null && column.getFlex() > 0 ? column.getFlex() : null;
        const res = {
            colId: column.getColId(),
            width: column.getActualWidth(),
            hide: !column.isVisible(),
            pinned: column.getPinned(),
            sort: sort,
            sortIndex: sortIndex,
            aggFunc: aggFunc,
            rowGroup: column.isRowGroupActive(),
            rowGroupIndex: rowGroupIndex,
            pivot: column.isPivotActive(),
            pivotIndex: pivotIndex,
            flex: flex
        };
        return res;
    }
    getColumnState() {
        if ($437b23f6a393c3bf$var$missing(this.primaryColumns) || !this.isAlive()) return [];
        const colsForState = this.getPrimaryAndSecondaryAndAutoColumns();
        const res = colsForState.map(this.createStateItemFromColumn.bind(this));
        this.orderColumnStateList(res);
        return res;
    }
    orderColumnStateList(columnStateList) {
        const colIdToGridIndexMap = $437b23f6a393c3bf$var$convertToMap(this.gridColumns.map((col, index)=>[
                col.getColId(),
                index
            ]));
        columnStateList.sort((itemA, itemB)=>{
            const posA = colIdToGridIndexMap.has(itemA.colId) ? colIdToGridIndexMap.get(itemA.colId) : -1;
            const posB = colIdToGridIndexMap.has(itemB.colId) ? colIdToGridIndexMap.get(itemB.colId) : -1;
            return posA - posB;
        });
    }
    resetColumnState(source) {
        if ($437b23f6a393c3bf$var$missingOrEmpty(this.primaryColumns)) return;
        const primaryColumns = this.getColumnsFromTree(this.primaryColumnTree);
        const columnStates = [];
        let letRowGroupIndex = 1e3;
        let letPivotIndex = 1e3;
        let colsToProcess = [];
        if (this.groupAutoColumns) colsToProcess = colsToProcess.concat(this.groupAutoColumns);
        if (primaryColumns) colsToProcess = colsToProcess.concat(primaryColumns);
        colsToProcess.forEach((column)=>{
            const stateItem = this.getColumnStateFromColDef(column);
            if ($437b23f6a393c3bf$var$missing(stateItem.rowGroupIndex) && stateItem.rowGroup) stateItem.rowGroupIndex = letRowGroupIndex++;
            if ($437b23f6a393c3bf$var$missing(stateItem.pivotIndex) && stateItem.pivot) stateItem.pivotIndex = letPivotIndex++;
            columnStates.push(stateItem);
        });
        this.applyColumnState({
            state: columnStates,
            applyOrder: true
        }, source);
    }
    getColumnStateFromColDef(column) {
        const getValueOrNull = (a, b)=>a != null ? a : b != null ? b : null;
        const colDef = column.getColDef();
        const sort = getValueOrNull(colDef.sort, colDef.initialSort);
        const sortIndex = getValueOrNull(colDef.sortIndex, colDef.initialSortIndex);
        const hide = getValueOrNull(colDef.hide, colDef.initialHide);
        const pinned = getValueOrNull(colDef.pinned, colDef.initialPinned);
        const width = getValueOrNull(colDef.width, colDef.initialWidth);
        const flex = getValueOrNull(colDef.flex, colDef.initialFlex);
        let rowGroupIndex = getValueOrNull(colDef.rowGroupIndex, colDef.initialRowGroupIndex);
        let rowGroup = getValueOrNull(colDef.rowGroup, colDef.initialRowGroup);
        if (rowGroupIndex == null && (rowGroup == null || rowGroup == false)) {
            rowGroupIndex = null;
            rowGroup = null;
        }
        let pivotIndex = getValueOrNull(colDef.pivotIndex, colDef.initialPivotIndex);
        let pivot = getValueOrNull(colDef.pivot, colDef.initialPivot);
        if (pivotIndex == null && (pivot == null || pivot == false)) {
            pivotIndex = null;
            pivot = null;
        }
        const aggFunc = getValueOrNull(colDef.aggFunc, colDef.initialAggFunc);
        return {
            colId: column.getColId(),
            sort: sort,
            sortIndex: sortIndex,
            hide: hide,
            pinned: pinned,
            width: width,
            flex: flex,
            rowGroup: rowGroup,
            rowGroupIndex: rowGroupIndex,
            pivot: pivot,
            pivotIndex: pivotIndex,
            aggFunc: aggFunc
        };
    }
    applyColumnState(params, source) {
        if ($437b23f6a393c3bf$var$missingOrEmpty(this.primaryColumns)) return false;
        if (params && params.state && !params.state.forEach) {
            console.warn("AG Grid: applyColumnState() - the state attribute should be an array, however an array was not found. Please provide an array of items (one for each col you want to change) for state.");
            return false;
        }
        const applyStates = (states, existingColumns, getById)=>{
            const dispatchEventsFunc = this.compareColumnStatesAndDispatchEvents(source);
            this.autoGroupsNeedBuilding = true;
            const columnsWithNoState = existingColumns.slice();
            const rowGroupIndexes = {};
            const pivotIndexes = {};
            const autoGroupColumnStates = [];
            const unmatchedAndAutoStates2 = [];
            let unmatchedCount2 = 0;
            const previousRowGroupCols = this.rowGroupColumns.slice();
            const previousPivotCols = this.pivotColumns.slice();
            states.forEach((state)=>{
                const colId = state.colId || "";
                const isAutoGroupColumn = colId.startsWith($437b23f6a393c3bf$export$a7016588c430dba6);
                if (isAutoGroupColumn) {
                    autoGroupColumnStates.push(state);
                    unmatchedAndAutoStates2.push(state);
                    return;
                }
                const column = getById(colId);
                if (!column) {
                    unmatchedAndAutoStates2.push(state);
                    unmatchedCount2 += 1;
                } else {
                    this.syncColumnWithStateItem(column, state, params.defaultState, rowGroupIndexes, pivotIndexes, false, source);
                    $437b23f6a393c3bf$var$removeFromArray(columnsWithNoState, column);
                }
            });
            const applyDefaultsFunc = (col)=>this.syncColumnWithStateItem(col, null, params.defaultState, rowGroupIndexes, pivotIndexes, false, source);
            columnsWithNoState.forEach(applyDefaultsFunc);
            const comparator = (indexes, oldList, colA, colB)=>{
                const indexA = indexes[colA.getId()];
                const indexB = indexes[colB.getId()];
                const aHasIndex = indexA != null;
                const bHasIndex = indexB != null;
                if (aHasIndex && bHasIndex) return indexA - indexB;
                if (aHasIndex) return -1;
                if (bHasIndex) return 1;
                const oldIndexA = oldList.indexOf(colA);
                const oldIndexB = oldList.indexOf(colB);
                const aHasOldIndex = oldIndexA >= 0;
                const bHasOldIndex = oldIndexB >= 0;
                if (aHasOldIndex && bHasOldIndex) return oldIndexA - oldIndexB;
                if (aHasOldIndex) return -1;
                return 1;
            };
            this.rowGroupColumns.sort(comparator.bind(this, rowGroupIndexes, previousRowGroupCols));
            this.pivotColumns.sort(comparator.bind(this, pivotIndexes, previousPivotCols));
            this.updateGridColumns();
            const autoGroupColsCopy = this.groupAutoColumns ? this.groupAutoColumns.slice() : [];
            autoGroupColumnStates.forEach((stateItem)=>{
                const autoCol = this.getAutoColumn(stateItem.colId);
                $437b23f6a393c3bf$var$removeFromArray(autoGroupColsCopy, autoCol);
                this.syncColumnWithStateItem(autoCol, stateItem, params.defaultState, null, null, true, source);
            });
            autoGroupColsCopy.forEach(applyDefaultsFunc);
            this.applyOrderAfterApplyState(params);
            this.updateDisplayedColumns(source);
            this.dispatchEverythingChanged(source);
            dispatchEventsFunc();
            return {
                unmatchedAndAutoStates: unmatchedAndAutoStates2,
                unmatchedCount: unmatchedCount2
            };
        };
        this.columnAnimationService.start();
        let { unmatchedAndAutoStates: unmatchedAndAutoStates, unmatchedCount: unmatchedCount } = applyStates(params.state || [], this.primaryColumns || [], (id)=>this.getPrimaryColumn(id));
        if (unmatchedAndAutoStates.length > 0 || $437b23f6a393c3bf$var$exists(params.defaultState)) unmatchedCount = applyStates(unmatchedAndAutoStates, this.secondaryColumns || [], (id)=>this.getSecondaryColumn(id)).unmatchedCount;
        this.columnAnimationService.finish();
        return unmatchedCount === 0;
    }
    applyOrderAfterApplyState(params) {
        if (!params.applyOrder || !params.state) return;
        let newOrder = [];
        const processedColIds = {};
        params.state.forEach((item)=>{
            if (!item.colId || processedColIds[item.colId]) return;
            const col = this.gridColumnsMap[item.colId];
            if (col) {
                newOrder.push(col);
                processedColIds[item.colId] = true;
            }
        });
        let autoGroupInsertIndex = 0;
        this.gridColumns.forEach((col)=>{
            const colId = col.getColId();
            const alreadyProcessed = processedColIds[colId] != null;
            if (alreadyProcessed) return;
            const isAutoGroupCol = colId.startsWith($437b23f6a393c3bf$export$a7016588c430dba6);
            if (isAutoGroupCol) $437b23f6a393c3bf$var$insertIntoArray(newOrder, col, autoGroupInsertIndex++);
            else newOrder.push(col);
        });
        newOrder = this.placeLockedColumns(newOrder);
        if (!this.doesMovePassMarryChildren(newOrder)) {
            console.warn("AG Grid: Applying column order broke a group where columns should be married together. Applying new order has been discarded.");
            return;
        }
        this.gridColumns = newOrder;
    }
    compareColumnStatesAndDispatchEvents(source) {
        const startState = {
            rowGroupColumns: this.rowGroupColumns.slice(),
            pivotColumns: this.pivotColumns.slice(),
            valueColumns: this.valueColumns.slice()
        };
        const columnStateBefore = this.getColumnState();
        const columnStateBeforeMap = {};
        columnStateBefore.forEach((col)=>{
            columnStateBeforeMap[col.colId] = col;
        });
        return ()=>{
            const colsForState = this.getPrimaryAndSecondaryAndAutoColumns();
            const dispatchWhenListsDifferent = (eventType, colsBefore, colsAfter, idMapper)=>{
                const beforeList = colsBefore.map(idMapper);
                const afterList = colsAfter.map(idMapper);
                const unchanged = $437b23f6a393c3bf$var$areEqual(beforeList, afterList);
                if (unchanged) return;
                const changes = new Set(colsBefore);
                colsAfter.forEach((id)=>{
                    if (!changes.delete(id)) changes.add(id);
                });
                const changesArr = [
                    ...changes
                ];
                const event = {
                    type: eventType,
                    columns: changesArr,
                    column: changesArr.length === 1 ? changesArr[0] : null,
                    source: source
                };
                this.eventService.dispatchEvent(event);
            };
            const getChangedColumns = (changedPredicate)=>{
                const changedColumns2 = [];
                colsForState.forEach((column)=>{
                    const colStateBefore = columnStateBeforeMap[column.getColId()];
                    if (colStateBefore && changedPredicate(colStateBefore, column)) changedColumns2.push(column);
                });
                return changedColumns2;
            };
            const columnIdMapper = (c)=>c.getColId();
            dispatchWhenListsDifferent($437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_ROW_GROUP_CHANGED, startState.rowGroupColumns, this.rowGroupColumns, columnIdMapper);
            dispatchWhenListsDifferent($437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_PIVOT_CHANGED, startState.pivotColumns, this.pivotColumns, columnIdMapper);
            const valueChangePredicate = (cs, c)=>{
                const oldActive = cs.aggFunc != null;
                const activeChanged = oldActive != c.isValueActive();
                const aggFuncChanged = oldActive && cs.aggFunc != c.getAggFunc();
                return activeChanged || aggFuncChanged;
            };
            const changedValues = getChangedColumns(valueChangePredicate);
            if (changedValues.length > 0) this.dispatchColumnChangedEvent($437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_VALUE_CHANGED, changedValues, source);
            const resizeChangePredicate = (cs, c)=>cs.width != c.getActualWidth();
            this.dispatchColumnResizedEvent(getChangedColumns(resizeChangePredicate), true, source);
            const pinnedChangePredicate = (cs, c)=>cs.pinned != c.getPinned();
            this.dispatchColumnPinnedEvent(getChangedColumns(pinnedChangePredicate), source);
            const visibilityChangePredicate = (cs, c)=>cs.hide == c.isVisible();
            this.dispatchColumnVisibleEvent(getChangedColumns(visibilityChangePredicate), source);
            const sortChangePredicate = (cs, c)=>cs.sort != c.getSort() || cs.sortIndex != c.getSortIndex();
            const changedColumns = getChangedColumns(sortChangePredicate);
            if (changedColumns.length > 0) this.sortController.dispatchSortChangedEvents(source, changedColumns);
            this.normaliseColumnMovedEventForColumnState(columnStateBefore, source);
        };
    }
    getCommonValue(cols, valueGetter) {
        if (!cols || cols.length == 0) return void 0;
        const firstValue = valueGetter(cols[0]);
        for(let i = 1; i < cols.length; i++){
            if (firstValue !== valueGetter(cols[i])) return void 0;
        }
        return firstValue;
    }
    normaliseColumnMovedEventForColumnState(colStateBefore, source) {
        const colStateAfter = this.getColumnState();
        const colStateAfterMapped = {};
        colStateAfter.forEach((s)=>colStateAfterMapped[s.colId] = s);
        const colsIntersectIds = {};
        colStateBefore.forEach((s)=>{
            if (colStateAfterMapped[s.colId]) colsIntersectIds[s.colId] = true;
        });
        const beforeFiltered = colStateBefore.filter((c)=>colsIntersectIds[c.colId]);
        const afterFiltered = colStateAfter.filter((c)=>colsIntersectIds[c.colId]);
        const movedColumns = [];
        afterFiltered.forEach((csAfter, index)=>{
            const csBefore = beforeFiltered && beforeFiltered[index];
            if (csBefore && csBefore.colId !== csAfter.colId) {
                const gridCol = this.getGridColumn(csBefore.colId);
                if (gridCol) movedColumns.push(gridCol);
            }
        });
        if (!movedColumns.length) return;
        this.dispatchColumnMovedEvent({
            movedColumns: movedColumns,
            source: source,
            finished: true
        });
    }
    syncColumnWithStateItem(column, stateItem, defaultState, rowGroupIndexes, pivotIndexes, autoCol, source) {
        var _a;
        if (!column) return;
        const getValue = (key1, key2)=>{
            const obj = {
                value1: void 0,
                value2: void 0
            };
            let calculated = false;
            if (stateItem) {
                if (stateItem[key1] !== void 0) {
                    obj.value1 = stateItem[key1];
                    calculated = true;
                }
                if ($437b23f6a393c3bf$var$exists(key2) && stateItem[key2] !== void 0) {
                    obj.value2 = stateItem[key2];
                    calculated = true;
                }
            }
            if (!calculated && defaultState) {
                if (defaultState[key1] !== void 0) obj.value1 = defaultState[key1];
                if ($437b23f6a393c3bf$var$exists(key2) && defaultState[key2] !== void 0) obj.value2 = defaultState[key2];
            }
            return obj;
        };
        const hide = getValue("hide").value1;
        if (hide !== void 0) column.setVisible(!hide, source);
        const pinned = getValue("pinned").value1;
        if (pinned !== void 0) column.setPinned(pinned);
        const minColWidth = (_a = column.getColDef().minWidth) != null ? _a : this.environment.getMinColWidth();
        const flex = getValue("flex").value1;
        if (flex !== void 0) column.setFlex(flex);
        if (flex == null) {
            const width = getValue("width").value1;
            if (width != null) {
                if (minColWidth != null && width >= minColWidth) column.setActualWidth(width, source);
            }
        }
        const sort = getValue("sort").value1;
        if (sort !== void 0) {
            if (sort === "desc" || sort === "asc") column.setSort(sort, source);
            else column.setSort(void 0, source);
        }
        const sortIndex = getValue("sortIndex").value1;
        if (sortIndex !== void 0) column.setSortIndex(sortIndex);
        if (autoCol || !column.isPrimary()) return;
        const aggFunc = getValue("aggFunc").value1;
        if (aggFunc !== void 0) {
            if (typeof aggFunc === "string") {
                column.setAggFunc(aggFunc);
                if (!column.isValueActive()) {
                    column.setValueActive(true, source);
                    this.valueColumns.push(column);
                }
            } else {
                if ($437b23f6a393c3bf$var$exists(aggFunc)) console.warn("AG Grid: stateItem.aggFunc must be a string. if using your own aggregation functions, register the functions first before using them in get/set state. This is because it is intended for the column state to be stored and retrieved as simple JSON.");
                if (column.isValueActive()) {
                    column.setValueActive(false, source);
                    $437b23f6a393c3bf$var$removeFromArray(this.valueColumns, column);
                }
            }
        }
        const { value1: rowGroup, value2: rowGroupIndex } = getValue("rowGroup", "rowGroupIndex");
        if (rowGroup !== void 0 || rowGroupIndex !== void 0) {
            if (typeof rowGroupIndex === "number" || rowGroup) {
                if (!column.isRowGroupActive()) {
                    column.setRowGroupActive(true, source);
                    this.rowGroupColumns.push(column);
                }
                if (rowGroupIndexes && typeof rowGroupIndex === "number") rowGroupIndexes[column.getId()] = rowGroupIndex;
            } else if (column.isRowGroupActive()) {
                column.setRowGroupActive(false, source);
                $437b23f6a393c3bf$var$removeFromArray(this.rowGroupColumns, column);
            }
        }
        const { value1: pivot, value2: pivotIndex } = getValue("pivot", "pivotIndex");
        if (pivot !== void 0 || pivotIndex !== void 0) {
            if (typeof pivotIndex === "number" || pivot) {
                if (!column.isPivotActive()) {
                    column.setPivotActive(true, source);
                    this.pivotColumns.push(column);
                }
                if (pivotIndexes && typeof pivotIndex === "number") pivotIndexes[column.getId()] = pivotIndex;
            } else if (column.isPivotActive()) {
                column.setPivotActive(false, source);
                $437b23f6a393c3bf$var$removeFromArray(this.pivotColumns, column);
            }
        }
    }
    getGridColumns(keys2) {
        return this.getColumns(keys2, this.getGridColumn.bind(this));
    }
    getColumns(keys2, columnLookupCallback) {
        const foundColumns = [];
        if (keys2) keys2.forEach((key)=>{
            const column = columnLookupCallback(key);
            if (column) foundColumns.push(column);
        });
        return foundColumns;
    }
    // used by growGroupPanel
    getColumnWithValidation(key) {
        if (key == null) return null;
        const column = this.getGridColumn(key);
        if (!column) console.warn("AG Grid: could not find column " + key);
        return column;
    }
    getPrimaryColumn(key) {
        if (!this.primaryColumns) return null;
        return this.getColumn(key, this.primaryColumns, this.primaryColumnsMap);
    }
    getGridColumn(key) {
        return this.getColumn(key, this.gridColumns, this.gridColumnsMap);
    }
    lookupGridColumn(key) {
        return this.gridColumnsMap[key];
    }
    getSecondaryColumn(key) {
        if (!this.secondaryColumns) return null;
        return this.getColumn(key, this.secondaryColumns, this.secondaryColumnsMap);
    }
    getColumn(key, columnList, columnMap) {
        if (!key || !columnMap) return null;
        if (typeof key == "string" && columnMap[key]) return columnMap[key];
        for(let i = 0; i < columnList.length; i++){
            if (this.columnsMatch(columnList[i], key)) return columnList[i];
        }
        return this.getAutoColumn(key);
    }
    getSourceColumnsForGroupColumn(groupCol) {
        const sourceColumnId = groupCol.getColDef().showRowGroup;
        if (!sourceColumnId) return null;
        if (sourceColumnId === true) return this.rowGroupColumns.slice(0);
        const column = this.getPrimaryColumn(sourceColumnId);
        return column ? [
            column
        ] : null;
    }
    getAutoColumn(key) {
        if (!this.groupAutoColumns || !$437b23f6a393c3bf$var$exists(this.groupAutoColumns) || $437b23f6a393c3bf$var$missing(this.groupAutoColumns)) return null;
        return this.groupAutoColumns.find((groupCol)=>this.columnsMatch(groupCol, key)) || null;
    }
    columnsMatch(column, key) {
        const columnMatches = column === key;
        const colDefMatches = column.getColDef() === key;
        const idMatches = column.getColId() == key;
        return columnMatches || colDefMatches || idMatches;
    }
    getDisplayNameForColumn(column, location, includeAggFunc = false) {
        if (!column) return null;
        const headerName = this.getHeaderName(column.getColDef(), column, null, null, location);
        if (includeAggFunc) return this.wrapHeaderNameWithAggFunc(column, headerName);
        return headerName;
    }
    getDisplayNameForProvidedColumnGroup(columnGroup, providedColumnGroup, location) {
        const colGroupDef = providedColumnGroup ? providedColumnGroup.getColGroupDef() : null;
        if (colGroupDef) return this.getHeaderName(colGroupDef, null, columnGroup, providedColumnGroup, location);
        return null;
    }
    getDisplayNameForColumnGroup(columnGroup, location) {
        return this.getDisplayNameForProvidedColumnGroup(columnGroup, columnGroup.getProvidedColumnGroup(), location);
    }
    // location is where the column is going to appear, ie who is calling us
    getHeaderName(colDef, column, columnGroup, providedColumnGroup, location) {
        const headerValueGetter = colDef.headerValueGetter;
        if (headerValueGetter) {
            const params = this.gos.addGridCommonParams({
                colDef: colDef,
                column: column,
                columnGroup: columnGroup,
                providedColumnGroup: providedColumnGroup,
                location: location
            });
            if (typeof headerValueGetter === "function") return headerValueGetter(params);
            else if (typeof headerValueGetter === "string") return this.expressionService.evaluate(headerValueGetter, params);
            console.warn("AG Grid: headerValueGetter must be a function or a string");
            return "";
        } else if (colDef.headerName != null) return colDef.headerName;
        else if (colDef.field) return $437b23f6a393c3bf$var$camelCaseToHumanText(colDef.field);
        return "";
    }
    wrapHeaderNameWithAggFunc(column, headerName) {
        if (this.gos.get("suppressAggFuncInHeader")) return headerName;
        const pivotValueColumn = column.getColDef().pivotValueColumn;
        const pivotActiveOnThisColumn = $437b23f6a393c3bf$var$exists(pivotValueColumn);
        let aggFunc = null;
        let aggFuncFound;
        if (pivotActiveOnThisColumn) {
            const isCollapsedHeaderEnabled = this.gos.get("removePivotHeaderRowWhenSingleValueColumn") && this.valueColumns.length === 1;
            const isTotalColumn = column.getColDef().pivotTotalColumnIds !== void 0;
            if (isCollapsedHeaderEnabled && !isTotalColumn) return headerName;
            aggFunc = pivotValueColumn ? pivotValueColumn.getAggFunc() : null;
            aggFuncFound = true;
        } else {
            const measureActive = column.isValueActive();
            const aggregationPresent = this.pivotMode || !this.isRowGroupEmpty();
            if (measureActive && aggregationPresent) {
                aggFunc = column.getAggFunc();
                aggFuncFound = true;
            } else aggFuncFound = false;
        }
        if (aggFuncFound) {
            const aggFuncString = typeof aggFunc === "string" ? aggFunc : "func";
            const localeTextFunc = this.localeService.getLocaleTextFunc();
            const aggFuncStringTranslated = localeTextFunc(aggFuncString, aggFuncString);
            return `${aggFuncStringTranslated}(${headerName})`;
        }
        return headerName;
    }
    // returns the group with matching colId and instanceId. If instanceId is missing,
    // matches only on the colId.
    getColumnGroup(colId, partId) {
        if (!colId) return null;
        if (colId instanceof $437b23f6a393c3bf$export$8a8fbc71323f074) return colId;
        const allColumnGroups = this.getAllDisplayedTrees();
        const checkPartId = typeof partId === "number";
        let result = null;
        $437b23f6a393c3bf$var$depthFirstAllColumnTreeSearch(allColumnGroups, false, (child)=>{
            if (child instanceof $437b23f6a393c3bf$export$8a8fbc71323f074) {
                const columnGroup = child;
                let matched;
                if (checkPartId) matched = colId === columnGroup.getGroupId() && partId === columnGroup.getPartId();
                else matched = colId === columnGroup.getGroupId();
                if (matched) result = columnGroup;
            }
        });
        return result;
    }
    isReady() {
        return this.ready;
    }
    extractValueColumns(source, oldPrimaryColumns) {
        this.valueColumns = this.extractColumns(oldPrimaryColumns, this.valueColumns, (col, flag)=>col.setValueActive(flag, source), // aggFunc doesn't have index variant, cos order of value cols doesn't matter, so always return null
        ()=>void 0, ()=>void 0, // aggFunc is a string, so return it's existence
        (colDef)=>{
            const aggFunc = colDef.aggFunc;
            if (aggFunc === null || aggFunc === "") return null;
            if (aggFunc === void 0) return;
            return !!aggFunc;
        }, (colDef)=>{
            return colDef.initialAggFunc != null && colDef.initialAggFunc != "";
        });
        this.valueColumns.forEach((col)=>{
            const colDef = col.getColDef();
            if (colDef.aggFunc != null && colDef.aggFunc != "") col.setAggFunc(colDef.aggFunc);
            else if (!col.getAggFunc()) col.setAggFunc(colDef.initialAggFunc);
        });
    }
    extractRowGroupColumns(source, oldPrimaryColumns) {
        this.rowGroupColumns = this.extractColumns(oldPrimaryColumns, this.rowGroupColumns, (col, flag)=>col.setRowGroupActive(flag, source), (colDef)=>colDef.rowGroupIndex, (colDef)=>colDef.initialRowGroupIndex, (colDef)=>colDef.rowGroup, (colDef)=>colDef.initialRowGroup);
    }
    extractColumns(oldPrimaryColumns = [], previousCols = [], setFlagFunc, getIndexFunc, getInitialIndexFunc, getValueFunc, getInitialValueFunc) {
        const colsWithIndex = [];
        const colsWithValue = [];
        (this.primaryColumns || []).forEach((col)=>{
            const colIsNew = oldPrimaryColumns.indexOf(col) < 0;
            const colDef = col.getColDef();
            const value = $437b23f6a393c3bf$var$attrToBoolean(getValueFunc(colDef));
            const initialValue = $437b23f6a393c3bf$var$attrToBoolean(getInitialValueFunc(colDef));
            const index = $437b23f6a393c3bf$var$attrToNumber(getIndexFunc(colDef));
            const initialIndex = $437b23f6a393c3bf$var$attrToNumber(getInitialIndexFunc(colDef));
            let include;
            const valuePresent = value !== void 0;
            const indexPresent = index !== void 0;
            const initialValuePresent = initialValue !== void 0;
            const initialIndexPresent = initialIndex !== void 0;
            if (valuePresent) include = value;
            else if (indexPresent) {
                if (index === null) include = false;
                else include = index >= 0;
            } else if (colIsNew) {
                if (initialValuePresent) include = initialValue;
                else if (initialIndexPresent) include = initialIndex != null && initialIndex >= 0;
                else include = false;
            } else include = previousCols.indexOf(col) >= 0;
            if (include) {
                const useIndex = colIsNew ? index != null || initialIndex != null : index != null;
                useIndex ? colsWithIndex.push(col) : colsWithValue.push(col);
            }
        });
        const getIndexForCol = (col)=>{
            const index = getIndexFunc(col.getColDef());
            const defaultIndex = getInitialIndexFunc(col.getColDef());
            return index != null ? index : defaultIndex;
        };
        colsWithIndex.sort((colA, colB)=>{
            const indexA = getIndexForCol(colA);
            const indexB = getIndexForCol(colB);
            if (indexA === indexB) return 0;
            if (indexA < indexB) return -1;
            return 1;
        });
        const res = [].concat(colsWithIndex);
        previousCols.forEach((col)=>{
            if (colsWithValue.indexOf(col) >= 0) res.push(col);
        });
        colsWithValue.forEach((col)=>{
            if (res.indexOf(col) < 0) res.push(col);
        });
        previousCols.forEach((col)=>{
            if (res.indexOf(col) < 0) setFlagFunc(col, false);
        });
        res.forEach((col)=>{
            if (previousCols.indexOf(col) < 0) setFlagFunc(col, true);
        });
        return res;
    }
    extractPivotColumns(source, oldPrimaryColumns) {
        this.pivotColumns = this.extractColumns(oldPrimaryColumns, this.pivotColumns, (col, flag)=>col.setPivotActive(flag, source), (colDef)=>colDef.pivotIndex, (colDef)=>colDef.initialPivotIndex, (colDef)=>colDef.pivot, (colDef)=>colDef.initialPivot);
    }
    resetColumnGroupState(source) {
        if (!this.primaryColumnTree) return;
        const stateItems = [];
        $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(null, this.primaryColumnTree, (child)=>{
            if (child instanceof $437b23f6a393c3bf$export$89dd394cd2c9e921) {
                const colGroupDef = child.getColGroupDef();
                const groupState = {
                    groupId: child.getGroupId(),
                    open: !colGroupDef ? void 0 : colGroupDef.openByDefault
                };
                stateItems.push(groupState);
            }
        });
        this.setColumnGroupState(stateItems, source);
    }
    getColumnGroupState() {
        const columnGroupState = [];
        $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(null, this.gridBalancedTree, (node)=>{
            if (node instanceof $437b23f6a393c3bf$export$89dd394cd2c9e921) columnGroupState.push({
                groupId: node.getGroupId(),
                open: node.isExpanded()
            });
        });
        return columnGroupState;
    }
    setColumnGroupState(stateItems, source) {
        if (!this.gridBalancedTree) return;
        this.columnAnimationService.start();
        const impactedGroups = [];
        stateItems.forEach((stateItem)=>{
            const groupKey = stateItem.groupId;
            const newValue = stateItem.open;
            const providedColumnGroup = this.getProvidedColumnGroup(groupKey);
            if (!providedColumnGroup) return;
            if (providedColumnGroup.isExpanded() === newValue) return;
            this.logger.log("columnGroupOpened(" + providedColumnGroup.getGroupId() + "," + newValue + ")");
            providedColumnGroup.setExpanded(newValue);
            impactedGroups.push(providedColumnGroup);
        });
        this.updateGroupsAndDisplayedColumns(source);
        this.setFirstRightAndLastLeftPinned(source);
        if (impactedGroups.length) {
            const event = {
                type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_GROUP_OPENED,
                columnGroup: $437b23f6a393c3bf$export$89dd394cd2c9e921.length === 1 ? impactedGroups[0] : void 0,
                columnGroups: impactedGroups
            };
            this.eventService.dispatchEvent(event);
        }
        this.columnAnimationService.finish();
    }
    // called by headerRenderer - when a header is opened or closed
    setColumnGroupOpened(key, newValue, source) {
        let keyAsString;
        if (key instanceof $437b23f6a393c3bf$export$89dd394cd2c9e921) keyAsString = key.getId();
        else keyAsString = key || "";
        this.setColumnGroupState([
            {
                groupId: keyAsString,
                open: newValue
            }
        ], source);
    }
    getProvidedColumnGroup(key) {
        if (typeof key !== "string") console.error("AG Grid: group key must be a string");
        let res = null;
        $437b23f6a393c3bf$var$depthFirstOriginalTreeSearch(null, this.gridBalancedTree, (node)=>{
            if (node instanceof $437b23f6a393c3bf$export$89dd394cd2c9e921) {
                if (node.getId() === key) res = node;
            }
        });
        return res;
    }
    calculateColumnsForDisplay() {
        let columnsForDisplay;
        if (this.pivotMode && $437b23f6a393c3bf$var$missing(this.secondaryColumns)) columnsForDisplay = this.gridColumns.filter((column)=>{
            const isAutoGroupCol = this.groupAutoColumns && $437b23f6a393c3bf$var$includes(this.groupAutoColumns, column);
            const isValueCol = this.valueColumns && $437b23f6a393c3bf$var$includes(this.valueColumns, column);
            return isAutoGroupCol || isValueCol;
        });
        else columnsForDisplay = this.gridColumns.filter((column)=>{
            const isAutoGroupCol = this.groupAutoColumns && $437b23f6a393c3bf$var$includes(this.groupAutoColumns, column);
            return isAutoGroupCol || column.isVisible();
        });
        return columnsForDisplay;
    }
    checkColSpanActiveInCols(columns) {
        let result = false;
        columns.forEach((col)=>{
            if ($437b23f6a393c3bf$var$exists(col.getColDef().colSpan)) result = true;
        });
        return result;
    }
    calculateColumnsForGroupDisplay() {
        this.groupDisplayColumns = [];
        this.groupDisplayColumnsMap = {};
        const checkFunc = (col)=>{
            const colDef = col.getColDef();
            const underlyingColumn = colDef.showRowGroup;
            if (colDef && $437b23f6a393c3bf$var$exists(underlyingColumn)) {
                this.groupDisplayColumns.push(col);
                if (typeof underlyingColumn === "string") this.groupDisplayColumnsMap[underlyingColumn] = col;
                else if (underlyingColumn === true) this.getRowGroupColumns().forEach((rowGroupCol)=>{
                    this.groupDisplayColumnsMap[rowGroupCol.getId()] = col;
                });
            }
        };
        this.gridColumns.forEach(checkFunc);
    }
    getGroupDisplayColumns() {
        return this.groupDisplayColumns;
    }
    getGroupDisplayColumnForGroup(rowGroupColumnId) {
        return this.groupDisplayColumnsMap[rowGroupColumnId];
    }
    updateDisplayedColumns(source) {
        const columnsForDisplay = this.calculateColumnsForDisplay();
        this.buildDisplayedTrees(columnsForDisplay);
        this.updateGroupsAndDisplayedColumns(source);
        this.setFirstRightAndLastLeftPinned(source);
    }
    isSecondaryColumnsPresent() {
        return $437b23f6a393c3bf$var$exists(this.secondaryColumns);
    }
    setSecondaryColumns(colDefs, source) {
        if (!this.gridColumns) return;
        const newColsPresent = colDefs;
        if (!newColsPresent && $437b23f6a393c3bf$var$missing(this.secondaryColumns)) return;
        if (newColsPresent) {
            this.processSecondaryColumnDefinitions(colDefs);
            const balancedTreeResult = this.columnFactory.createColumnTree(colDefs, false, this.secondaryBalancedTree || this.previousSecondaryColumns || void 0, source);
            this.destroyOldColumns(this.secondaryBalancedTree, balancedTreeResult.columnTree);
            this.secondaryBalancedTree = balancedTreeResult.columnTree;
            this.secondaryHeaderRowCount = balancedTreeResult.treeDept + 1;
            this.secondaryColumns = this.getColumnsFromTree(this.secondaryBalancedTree);
            this.secondaryColumnsMap = {};
            this.secondaryColumns.forEach((col)=>this.secondaryColumnsMap[col.getId()] = col);
            this.previousSecondaryColumns = null;
        } else {
            this.previousSecondaryColumns = this.secondaryBalancedTree;
            this.secondaryBalancedTree = null;
            this.secondaryHeaderRowCount = -1;
            this.secondaryColumns = null;
            this.secondaryColumnsMap = {};
        }
        this.updateGridColumns();
        this.updateDisplayedColumns(source);
    }
    processSecondaryColumnDefinitions(colDefs) {
        const columnCallback = this.gos.get("processPivotResultColDef");
        const groupCallback = this.gos.get("processPivotResultColGroupDef");
        if (!columnCallback && !groupCallback) return void 0;
        const searchForColDefs = (colDefs2)=>{
            colDefs2.forEach((abstractColDef)=>{
                const isGroup = $437b23f6a393c3bf$var$exists(abstractColDef.children);
                if (isGroup) {
                    const colGroupDef = abstractColDef;
                    if (groupCallback) groupCallback(colGroupDef);
                    searchForColDefs(colGroupDef.children);
                } else {
                    const colDef = abstractColDef;
                    if (columnCallback) columnCallback(colDef);
                }
            });
        };
        if (colDefs) searchForColDefs(colDefs);
    }
    // called from: applyColumnState, setColumnDefs, setSecondaryColumns
    updateGridColumns() {
        const prevGridCols = this.gridBalancedTree;
        if (this.gridColsArePrimary) this.lastPrimaryOrder = this.gridColumns;
        else this.lastSecondaryOrder = this.gridColumns;
        const areAutoColsChanged = this.createGroupAutoColumnsIfNeeded();
        if (areAutoColsChanged) {
            const groupAutoColsMap = $437b23f6a393c3bf$var$convertToMap(this.groupAutoColumns.map((col)=>[
                    col,
                    true
                ]));
            if (this.lastPrimaryOrder) {
                this.lastPrimaryOrder = this.lastPrimaryOrder.filter((col)=>!groupAutoColsMap.has(col));
                this.lastPrimaryOrder = [
                    ...this.groupAutoColumns,
                    ...this.lastPrimaryOrder
                ];
            }
            if (this.lastSecondaryOrder) {
                this.lastSecondaryOrder = this.lastSecondaryOrder.filter((col)=>!groupAutoColsMap.has(col));
                this.lastSecondaryOrder = [
                    ...this.groupAutoColumns,
                    ...this.lastSecondaryOrder
                ];
            }
        }
        let sortOrderToRecover;
        if (this.secondaryColumns && this.secondaryBalancedTree) {
            const hasSameColumns = this.secondaryColumns.some((col)=>{
                return this.gridColumnsMap[col.getColId()] !== void 0;
            });
            this.gridBalancedTree = this.secondaryBalancedTree.slice();
            this.gridHeaderRowCount = this.secondaryHeaderRowCount;
            this.gridColumns = this.secondaryColumns.slice();
            this.gridColsArePrimary = false;
            if (hasSameColumns) sortOrderToRecover = this.lastSecondaryOrder;
        } else if (this.primaryColumns) {
            this.gridBalancedTree = this.primaryColumnTree.slice();
            this.gridHeaderRowCount = this.primaryHeaderRowCount;
            this.gridColumns = this.primaryColumns.slice();
            this.gridColsArePrimary = true;
            sortOrderToRecover = this.lastPrimaryOrder;
        }
        this.addAutoGroupToGridColumns();
        this.orderGridColsLike(sortOrderToRecover);
        this.gridColumns = this.placeLockedColumns(this.gridColumns);
        this.calculateColumnsForGroupDisplay();
        this.refreshQuickFilterColumns();
        this.clearDisplayedAndViewportColumns();
        this.colSpanActive = this.checkColSpanActiveInCols(this.gridColumns);
        this.gridColumnsMap = {};
        this.gridColumns.forEach((col)=>this.gridColumnsMap[col.getId()] = col);
        this.setAutoHeightActive();
        if (!$437b23f6a393c3bf$var$areEqual(prevGridCols, this.gridBalancedTree)) {
            const event = {
                type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_GRID_COLUMNS_CHANGED
            };
            this.eventService.dispatchEvent(event);
        }
    }
    setAutoHeightActive() {
        this.autoHeightActive = this.gridColumns.filter((col)=>col.isAutoHeight()).length > 0;
        if (this.autoHeightActive) {
            this.autoHeightActiveAtLeastOnce = true;
            const supportedRowModel = this.gos.isRowModelType("clientSide") || this.gos.isRowModelType("serverSide");
            if (!supportedRowModel) $437b23f6a393c3bf$var$warnOnce("autoHeight columns only work with Client Side Row Model and Server Side Row Model.");
        }
    }
    orderGridColsLike(colsOrder) {
        if ($437b23f6a393c3bf$var$missing(colsOrder)) return;
        const lastOrderMapped = $437b23f6a393c3bf$var$convertToMap(colsOrder.map((col, index)=>[
                col,
                index
            ]));
        let noColsFound = true;
        this.gridColumns.forEach((col)=>{
            if (lastOrderMapped.has(col)) noColsFound = false;
        });
        if (noColsFound) return;
        const gridColsMap = $437b23f6a393c3bf$var$convertToMap(this.gridColumns.map((col)=>[
                col,
                true
            ]));
        const oldColsOrdered = colsOrder.filter((col)=>gridColsMap.has(col));
        const oldColsMap = $437b23f6a393c3bf$var$convertToMap(oldColsOrdered.map((col)=>[
                col,
                true
            ]));
        const newColsOrdered = this.gridColumns.filter((col)=>!oldColsMap.has(col));
        const newGridColumns = oldColsOrdered.slice();
        newColsOrdered.forEach((newCol)=>{
            let parent = newCol.getOriginalParent();
            if (!parent) {
                newGridColumns.push(newCol);
                return;
            }
            const siblings = [];
            while(!siblings.length && parent){
                const leafCols = parent.getLeafColumns();
                leafCols.forEach((leafCol)=>{
                    const presentInNewGriColumns = newGridColumns.indexOf(leafCol) >= 0;
                    const noYetInSiblings = siblings.indexOf(leafCol) < 0;
                    if (presentInNewGriColumns && noYetInSiblings) siblings.push(leafCol);
                });
                parent = parent.getOriginalParent();
            }
            if (!siblings.length) {
                newGridColumns.push(newCol);
                return;
            }
            const indexes = siblings.map((col)=>newGridColumns.indexOf(col));
            const lastIndex = Math.max(...indexes);
            $437b23f6a393c3bf$var$insertIntoArray(newGridColumns, newCol, lastIndex + 1);
        });
        this.gridColumns = newGridColumns;
    }
    isPrimaryColumnGroupsPresent() {
        return this.primaryHeaderRowCount > 1;
    }
    // if we are using autoGroupCols, then they should be included for quick filter. this covers the
    // following scenarios:
    // a) user provides 'field' into autoGroupCol of normal grid, so now because a valid col to filter leafs on
    // b) using tree data and user depends on autoGroupCol for first col, and we also want to filter on this
    //    (tree data is a bit different, as parent rows can be filtered on, unlike row grouping)
    refreshQuickFilterColumns() {
        var _a;
        let columnsForQuickFilter = (_a = this.isPivotMode() && !this.gos.get("applyQuickFilterBeforePivotOrAgg") ? this.secondaryColumns : this.primaryColumns) != null ? _a : [];
        if (this.groupAutoColumns) columnsForQuickFilter = columnsForQuickFilter.concat(this.groupAutoColumns);
        this.columnsForQuickFilter = this.gos.get("includeHiddenColumnsInQuickFilter") ? columnsForQuickFilter : columnsForQuickFilter.filter((col)=>col.isVisible() || col.isRowGroupActive());
    }
    placeLockedColumns(cols) {
        const left = [];
        const normal = [];
        const right = [];
        cols.forEach((col)=>{
            const position = col.getColDef().lockPosition;
            if (position === "right") right.push(col);
            else if (position === "left" || position === true) left.push(col);
            else normal.push(col);
        });
        return [
            ...left,
            ...normal,
            ...right
        ];
    }
    addAutoGroupToGridColumns() {
        if ($437b23f6a393c3bf$var$missing(this.groupAutoColumns)) {
            this.destroyOldColumns(this.groupAutoColsBalancedTree);
            this.groupAutoColsBalancedTree = null;
            return;
        }
        this.gridColumns = this.groupAutoColumns ? this.groupAutoColumns.concat(this.gridColumns) : this.gridColumns;
        const newAutoColsTree = this.columnFactory.createForAutoGroups(this.groupAutoColumns, this.gridBalancedTree);
        this.destroyOldColumns(this.groupAutoColsBalancedTree, newAutoColsTree);
        this.groupAutoColsBalancedTree = newAutoColsTree;
        this.gridBalancedTree = newAutoColsTree.concat(this.gridBalancedTree);
    }
    // gets called after we copy down grid columns, to make sure any part of the gui
    // that tries to draw, eg the header, it will get empty lists of columns rather
    // than stale columns. for example, the header will received gridColumnsChanged
    // event, so will try and draw, but it will draw successfully when it acts on the
    // virtualColumnsChanged event
    clearDisplayedAndViewportColumns() {
        this.viewportRowLeft = {};
        this.viewportRowRight = {};
        this.viewportRowCenter = {};
        this.displayedColumnsLeft = [];
        this.displayedColumnsRight = [];
        this.displayedColumnsCenter = [];
        this.displayedColumns = [];
        this.ariaOrderColumns = [];
        this.viewportColumns = [];
        this.headerViewportColumns = [];
        this.viewportColumnsHash = "";
    }
    updateGroupsAndDisplayedColumns(source) {
        this.updateOpenClosedVisibilityInColumnGroups();
        this.deriveDisplayedColumns(source);
        this.refreshFlexedColumns();
        this.extractViewport();
        this.updateBodyWidths();
        const event = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_DISPLAYED_COLUMNS_CHANGED
        };
        this.eventService.dispatchEvent(event);
    }
    deriveDisplayedColumns(source) {
        this.derivedDisplayedColumnsFromDisplayedTree(this.displayedTreeLeft, this.displayedColumnsLeft);
        this.derivedDisplayedColumnsFromDisplayedTree(this.displayedTreeCentre, this.displayedColumnsCenter);
        this.derivedDisplayedColumnsFromDisplayedTree(this.displayedTreeRight, this.displayedColumnsRight);
        this.joinColumnsAriaOrder();
        this.joinDisplayedColumns();
        this.setLeftValues(source);
        this.displayedAutoHeightCols = this.displayedColumns.filter((col)=>col.isAutoHeight());
    }
    isAutoRowHeightActive() {
        return this.autoHeightActive;
    }
    wasAutoRowHeightEverActive() {
        return this.autoHeightActiveAtLeastOnce;
    }
    joinColumnsAriaOrder() {
        const allColumns = this.getAllGridColumns();
        const pinnedLeft = [];
        const center = [];
        const pinnedRight = [];
        for (const col of allColumns){
            const pinned = col.getPinned();
            if (!pinned) center.push(col);
            else if (pinned === true || pinned === "left") pinnedLeft.push(col);
            else pinnedRight.push(col);
        }
        this.ariaOrderColumns = pinnedLeft.concat(center).concat(pinnedRight);
    }
    joinDisplayedColumns() {
        if (this.gos.get("enableRtl")) this.displayedColumns = this.displayedColumnsRight.concat(this.displayedColumnsCenter).concat(this.displayedColumnsLeft);
        else this.displayedColumns = this.displayedColumnsLeft.concat(this.displayedColumnsCenter).concat(this.displayedColumnsRight);
    }
    // sets the left pixel position of each column
    setLeftValues(source) {
        this.setLeftValuesOfColumns(source);
        this.setLeftValuesOfGroups();
    }
    setLeftValuesOfColumns(source) {
        if (!this.primaryColumns) return;
        const allColumns = this.getPrimaryAndSecondaryAndAutoColumns().slice(0);
        const doingRtl = this.gos.get("enableRtl");
        [
            this.displayedColumnsLeft,
            this.displayedColumnsRight,
            this.displayedColumnsCenter
        ].forEach((columns)=>{
            if (doingRtl) {
                let left = this.getWidthOfColsInList(columns);
                columns.forEach((column)=>{
                    left -= column.getActualWidth();
                    column.setLeft(left, source);
                });
            } else {
                let left = 0;
                columns.forEach((column)=>{
                    column.setLeft(left, source);
                    left += column.getActualWidth();
                });
            }
            $437b23f6a393c3bf$var$removeAllFromUnorderedArray(allColumns, columns);
        });
        allColumns.forEach((column)=>{
            column.setLeft(null, source);
        });
    }
    setLeftValuesOfGroups() {
        [
            this.displayedTreeLeft,
            this.displayedTreeRight,
            this.displayedTreeCentre
        ].forEach((columns)=>{
            columns.forEach((column)=>{
                if (column instanceof $437b23f6a393c3bf$export$8a8fbc71323f074) {
                    const columnGroup = column;
                    columnGroup.checkLeft();
                }
            });
        });
    }
    derivedDisplayedColumnsFromDisplayedTree(tree, columns) {
        columns.length = 0;
        $437b23f6a393c3bf$var$depthFirstAllColumnTreeSearch(tree, true, (child)=>{
            if (child instanceof $437b23f6a393c3bf$export$816b5d811295e6bc) columns.push(child);
        });
    }
    isColumnVirtualisationSuppressed() {
        return this.suppressColumnVirtualisation || this.viewportRight === 0;
    }
    extractViewportColumns() {
        if (this.isColumnVirtualisationSuppressed()) {
            this.viewportColumnsCenter = this.displayedColumnsCenter;
            this.headerViewportColumnsCenter = this.displayedColumnsCenter;
        } else {
            this.viewportColumnsCenter = this.displayedColumnsCenter.filter(this.isColumnInRowViewport.bind(this));
            this.headerViewportColumnsCenter = this.displayedColumnsCenter.filter(this.isColumnInHeaderViewport.bind(this));
        }
        this.viewportColumns = this.viewportColumnsCenter.concat(this.displayedColumnsLeft).concat(this.displayedColumnsRight);
        this.headerViewportColumns = this.headerViewportColumnsCenter.concat(this.displayedColumnsLeft).concat(this.displayedColumnsRight);
    }
    getVirtualHeaderGroupRow(type, dept) {
        let result;
        switch(type){
            case "left":
                result = this.viewportRowLeft[dept];
                break;
            case "right":
                result = this.viewportRowRight[dept];
                break;
            default:
                result = this.viewportRowCenter[dept];
                break;
        }
        if ($437b23f6a393c3bf$var$missing(result)) result = [];
        return result;
    }
    calculateHeaderRows() {
        this.viewportRowLeft = {};
        this.viewportRowRight = {};
        this.viewportRowCenter = {};
        const virtualColIds = {};
        this.headerViewportColumns.forEach((col)=>virtualColIds[col.getId()] = true);
        const testGroup = (children, result, dept)=>{
            let returnValue = false;
            for(let i = 0; i < children.length; i++){
                const child = children[i];
                let addThisItem = false;
                if (child instanceof $437b23f6a393c3bf$export$816b5d811295e6bc) addThisItem = virtualColIds[child.getId()] === true;
                else {
                    const columnGroup = child;
                    const displayedChildren = columnGroup.getDisplayedChildren();
                    if (displayedChildren) addThisItem = testGroup(displayedChildren, result, dept + 1);
                }
                if (addThisItem) {
                    returnValue = true;
                    if (!result[dept]) result[dept] = [];
                    result[dept].push(child);
                }
            }
            return returnValue;
        };
        testGroup(this.displayedTreeLeft, this.viewportRowLeft, 0);
        testGroup(this.displayedTreeRight, this.viewportRowRight, 0);
        testGroup(this.displayedTreeCentre, this.viewportRowCenter, 0);
    }
    extractViewport() {
        const hashColumn = (c)=>`${c.getId()}-${c.getPinned() || "normal"}`;
        this.extractViewportColumns();
        const newHash = this.viewportColumns.map(hashColumn).join("#");
        const changed = this.viewportColumnsHash !== newHash;
        if (changed) {
            this.viewportColumnsHash = newHash;
            this.calculateHeaderRows();
        }
        return changed;
    }
    refreshFlexedColumns(params = {}) {
        var _a;
        const source = params.source ? params.source : "flex";
        if (params.viewportWidth != null) this.flexViewportWidth = params.viewportWidth;
        if (!this.flexViewportWidth) return [];
        let flexAfterDisplayIndex = -1;
        if (params.resizingCols) {
            const allResizingCols = new Set(params.resizingCols);
            let displayedCols = this.displayedColumnsCenter;
            for(let i = displayedCols.length - 1; i >= 0; i--)if (allResizingCols.has(displayedCols[i])) {
                flexAfterDisplayIndex = i;
                break;
            }
        }
        let knownColumnsWidth = 0;
        let flexingColumns = [];
        let minimumFlexedWidth = 0;
        let totalFlex = 0;
        for(let i = 0; i < this.displayedColumnsCenter.length; i++){
            const isFlex = this.displayedColumnsCenter[i].getFlex() && i > flexAfterDisplayIndex;
            if (isFlex) {
                flexingColumns.push(this.displayedColumnsCenter[i]);
                totalFlex += this.displayedColumnsCenter[i].getFlex();
                minimumFlexedWidth += (_a = this.displayedColumnsCenter[i].getMinWidth()) != null ? _a : 0;
            } else knownColumnsWidth += this.displayedColumnsCenter[i].getActualWidth();
        }
        if (!flexingColumns.length) return [];
        let changedColumns = [];
        if (knownColumnsWidth + minimumFlexedWidth > this.flexViewportWidth) {
            flexingColumns.forEach((col)=>{
                var _a2;
                return col.setActualWidth((_a2 = col.getMinWidth()) != null ? _a2 : 0, source);
            });
            changedColumns = flexingColumns;
            flexingColumns = [];
        }
        const flexingColumnSizes = [];
        let spaceForFlexingColumns;
        outer: while(true){
            spaceForFlexingColumns = this.flexViewportWidth - knownColumnsWidth;
            const spacePerFlex = spaceForFlexingColumns / totalFlex;
            for(let i = 0; i < flexingColumns.length; i++){
                const col = flexingColumns[i];
                const widthByFlexRule = spacePerFlex * col.getFlex();
                let constrainedWidth = 0;
                const minWidth = col.getMinWidth();
                const maxWidth = col.getMaxWidth();
                if ($437b23f6a393c3bf$var$exists(minWidth) && widthByFlexRule < minWidth) constrainedWidth = minWidth;
                else if ($437b23f6a393c3bf$var$exists(maxWidth) && widthByFlexRule > maxWidth) constrainedWidth = maxWidth;
                if (constrainedWidth) {
                    col.setActualWidth(constrainedWidth, source);
                    $437b23f6a393c3bf$var$removeFromUnorderedArray(flexingColumns, col);
                    totalFlex -= col.getFlex();
                    changedColumns.push(col);
                    knownColumnsWidth += col.getActualWidth();
                    continue outer;
                }
                flexingColumnSizes[i] = Math.round(widthByFlexRule);
            }
            break;
        }
        let remainingSpace = spaceForFlexingColumns;
        flexingColumns.forEach((col, i)=>{
            col.setActualWidth(Math.min(flexingColumnSizes[i], remainingSpace), source);
            changedColumns.push(col);
            remainingSpace -= flexingColumnSizes[i];
        });
        if (!params.skipSetLeft) this.setLeftValues(source);
        if (params.updateBodyWidths) this.updateBodyWidths();
        if (params.fireResizedEvent) this.dispatchColumnResizedEvent(changedColumns, true, source, flexingColumns);
        return flexingColumns;
    }
    // called from api
    sizeColumnsToFit(gridWidth, source = "sizeColumnsToFit", silent, params) {
        var _c, _d, _e, _f, _g;
        if (this.shouldQueueResizeOperations) {
            this.resizeOperationQueue.push(()=>this.sizeColumnsToFit(gridWidth, source, silent, params));
            return;
        }
        const limitsMap = {};
        if (params) (_c = params == null ? void 0 : params.columnLimits) == null || _c.forEach((_a)=>{
            var _b = _a, { key: key } = _b, dimensions = $437b23f6a393c3bf$var$__objRest(_b, [
                "key"
            ]);
            limitsMap[typeof key === "string" ? key : key.getColId()] = dimensions;
        });
        const allDisplayedColumns = this.getAllDisplayedColumns();
        const doColumnsAlreadyFit = gridWidth === this.getWidthOfColsInList(allDisplayedColumns);
        if (gridWidth <= 0 || !allDisplayedColumns.length || doColumnsAlreadyFit) return;
        const colsToSpread = [];
        const colsToNotSpread = [];
        allDisplayedColumns.forEach((column)=>{
            if (column.getColDef().suppressSizeToFit === true) colsToNotSpread.push(column);
            else colsToSpread.push(column);
        });
        const colsToDispatchEventFor = colsToSpread.slice(0);
        let finishedResizing = false;
        const moveToNotSpread = (column)=>{
            $437b23f6a393c3bf$var$removeFromArray(colsToSpread, column);
            colsToNotSpread.push(column);
        };
        colsToSpread.forEach((column)=>{
            var _a, _b;
            column.resetActualWidth(source);
            const widthOverride = limitsMap == null ? void 0 : limitsMap[column.getId()];
            const minOverride = (_a = widthOverride == null ? void 0 : widthOverride.minWidth) != null ? _a : params == null ? void 0 : params.defaultMinWidth;
            const maxOverride = (_b = widthOverride == null ? void 0 : widthOverride.maxWidth) != null ? _b : params == null ? void 0 : params.defaultMaxWidth;
            const colWidth = column.getActualWidth();
            if (typeof minOverride === "number" && colWidth < minOverride) column.setActualWidth(minOverride, source, true);
            else if (typeof maxOverride === "number" && colWidth > maxOverride) column.setActualWidth(maxOverride, source, true);
        });
        while(!finishedResizing){
            finishedResizing = true;
            const availablePixels = gridWidth - this.getWidthOfColsInList(colsToNotSpread);
            if (availablePixels <= 0) colsToSpread.forEach((column)=>{
                var _a, _b;
                const widthOverride = (_b = (_a = limitsMap == null ? void 0 : limitsMap[column.getId()]) == null ? void 0 : _a.minWidth) != null ? _b : params == null ? void 0 : params.defaultMinWidth;
                if (typeof widthOverride === "number") {
                    column.setActualWidth(widthOverride, source, true);
                    return;
                }
                column.setMinimum(source);
            });
            else {
                const scale = availablePixels / this.getWidthOfColsInList(colsToSpread);
                let pixelsForLastCol = availablePixels;
                for(let i = colsToSpread.length - 1; i >= 0; i--){
                    const column = colsToSpread[i];
                    const widthOverride = limitsMap == null ? void 0 : limitsMap[column.getId()];
                    const minOverride = (_d = widthOverride == null ? void 0 : widthOverride.minWidth) != null ? _d : params == null ? void 0 : params.defaultMinWidth;
                    const maxOverride = (_e = widthOverride == null ? void 0 : widthOverride.maxWidth) != null ? _e : params == null ? void 0 : params.defaultMaxWidth;
                    const colMinWidth = (_f = column.getMinWidth()) != null ? _f : 0;
                    const colMaxWidth = (_g = column.getMaxWidth()) != null ? _g : Number.MAX_VALUE;
                    const minWidth = typeof minOverride === "number" && minOverride > colMinWidth ? minOverride : column.getMinWidth();
                    const maxWidth = typeof maxOverride === "number" && maxOverride < colMaxWidth ? maxOverride : column.getMaxWidth();
                    let newWidth = Math.round(column.getActualWidth() * scale);
                    if ($437b23f6a393c3bf$var$exists(minWidth) && newWidth < minWidth) {
                        newWidth = minWidth;
                        moveToNotSpread(column);
                        finishedResizing = false;
                    } else if ($437b23f6a393c3bf$var$exists(maxWidth) && newWidth > maxWidth) {
                        newWidth = maxWidth;
                        moveToNotSpread(column);
                        finishedResizing = false;
                    } else if (i === 0) newWidth = pixelsForLastCol;
                    column.setActualWidth(newWidth, source, true);
                    pixelsForLastCol -= newWidth;
                }
            }
        }
        colsToDispatchEventFor.forEach((col)=>{
            col.fireColumnWidthChangedEvent(source);
        });
        this.setLeftValues(source);
        this.updateBodyWidths();
        if (silent) return;
        this.dispatchColumnResizedEvent(colsToDispatchEventFor, true, source);
    }
    buildDisplayedTrees(visibleColumns) {
        const leftVisibleColumns = [];
        const rightVisibleColumns = [];
        const centerVisibleColumns = [];
        visibleColumns.forEach((column)=>{
            switch(column.getPinned()){
                case "left":
                    leftVisibleColumns.push(column);
                    break;
                case "right":
                    rightVisibleColumns.push(column);
                    break;
                default:
                    centerVisibleColumns.push(column);
                    break;
            }
        });
        const groupInstanceIdCreator = new $437b23f6a393c3bf$export$b3b24737a74261fb();
        this.displayedTreeLeft = this.displayedGroupCreator.createDisplayedGroups(leftVisibleColumns, groupInstanceIdCreator, "left", this.displayedTreeLeft);
        this.displayedTreeRight = this.displayedGroupCreator.createDisplayedGroups(rightVisibleColumns, groupInstanceIdCreator, "right", this.displayedTreeRight);
        this.displayedTreeCentre = this.displayedGroupCreator.createDisplayedGroups(centerVisibleColumns, groupInstanceIdCreator, null, this.displayedTreeCentre);
        this.updateDisplayedMap();
    }
    updateDisplayedMap() {
        this.displayedColumnsAndGroupsMap = {};
        const func = (child)=>{
            this.displayedColumnsAndGroupsMap[child.getUniqueId()] = child;
        };
        $437b23f6a393c3bf$var$depthFirstAllColumnTreeSearch(this.displayedTreeCentre, false, func);
        $437b23f6a393c3bf$var$depthFirstAllColumnTreeSearch(this.displayedTreeLeft, false, func);
        $437b23f6a393c3bf$var$depthFirstAllColumnTreeSearch(this.displayedTreeRight, false, func);
    }
    isDisplayed(item) {
        const fromMap = this.displayedColumnsAndGroupsMap[item.getUniqueId()];
        return fromMap === item;
    }
    updateOpenClosedVisibilityInColumnGroups() {
        const allColumnGroups = this.getAllDisplayedTrees();
        $437b23f6a393c3bf$var$depthFirstAllColumnTreeSearch(allColumnGroups, false, (child)=>{
            if (child instanceof $437b23f6a393c3bf$export$8a8fbc71323f074) child.calculateDisplayedColumns();
        });
    }
    getGroupAutoColumns() {
        return this.groupAutoColumns;
    }
    /**
   * Creates new auto group columns if required
   * @returns whether auto cols have changed
   */ createGroupAutoColumnsIfNeeded() {
        const forceRecreateAutoGroups = this.forceRecreateAutoGroups;
        this.forceRecreateAutoGroups = false;
        if (!this.autoGroupsNeedBuilding) return false;
        this.autoGroupsNeedBuilding = false;
        const groupFullWidthRow = this.gos.isGroupUseEntireRow(this.pivotMode);
        const suppressAutoColumn = this.pivotMode ? this.gos.get("pivotSuppressAutoColumn") : this.isGroupSuppressAutoColumn();
        const groupingActive = this.rowGroupColumns.length > 0 || this.gos.get("treeData");
        const needAutoColumns = groupingActive && !suppressAutoColumn && !groupFullWidthRow;
        if (needAutoColumns) {
            const newAutoGroupCols = this.autoGroupColService.createAutoGroupColumns(this.rowGroupColumns);
            const autoColsDifferent = !this.autoColsEqual(newAutoGroupCols, this.groupAutoColumns);
            if (autoColsDifferent || forceRecreateAutoGroups) {
                this.groupAutoColumns = newAutoGroupCols;
                return true;
            }
        } else this.groupAutoColumns = null;
        return false;
    }
    isGroupSuppressAutoColumn() {
        const groupDisplayType = this.gos.get("groupDisplayType");
        const isCustomRowGroups = groupDisplayType === "custom";
        if (isCustomRowGroups) return true;
        const treeDataDisplayType = this.gos.get("treeDataDisplayType");
        return treeDataDisplayType === "custom";
    }
    autoColsEqual(colsA, colsB) {
        return $437b23f6a393c3bf$var$areEqual(colsA, colsB, (a, b)=>a.getColId() === b.getColId());
    }
    getWidthOfColsInList(columnList) {
        return columnList.reduce((width, col)=>width + col.getActualWidth(), 0);
    }
    getFirstDisplayedColumn() {
        const isRtl = this.gos.get("enableRtl");
        const queryOrder = [
            "getDisplayedLeftColumns",
            "getDisplayedCenterColumns",
            "getDisplayedRightColumns"
        ];
        if (isRtl) queryOrder.reverse();
        for(let i = 0; i < queryOrder.length; i++){
            const container = this[queryOrder[i]]();
            if (container.length) return isRtl ? $437b23f6a393c3bf$var$last(container) : container[0];
        }
        return null;
    }
    setColumnHeaderHeight(col, height) {
        const changed = col.setAutoHeaderHeight(height);
        if (changed) {
            const event = {
                type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_HEADER_HEIGHT_CHANGED,
                column: col,
                columns: [
                    col
                ],
                source: "autosizeColumnHeaderHeight"
            };
            this.eventService.dispatchEvent(event);
        }
    }
    getColumnGroupHeaderRowHeight() {
        if (this.isPivotMode()) return this.getPivotGroupHeaderHeight();
        return this.getGroupHeaderHeight();
    }
    getColumnHeaderRowHeight() {
        const defaultHeight = this.isPivotMode() ? this.getPivotHeaderHeight() : this.getHeaderHeight();
        const displayedHeights = this.getAllDisplayedColumns().filter((col)=>col.isAutoHeaderHeight()).map((col)=>col.getAutoHeaderHeight() || 0);
        return Math.max(defaultHeight, ...displayedHeights);
    }
    getHeaderHeight() {
        var _a;
        return (_a = this.gos.get("headerHeight")) != null ? _a : this.environment.getFromTheme(25, "headerHeight");
    }
    getFloatingFiltersHeight() {
        var _a;
        return (_a = this.gos.get("floatingFiltersHeight")) != null ? _a : this.getHeaderHeight();
    }
    getGroupHeaderHeight() {
        var _a;
        return (_a = this.gos.get("groupHeaderHeight")) != null ? _a : this.getHeaderHeight();
    }
    getPivotHeaderHeight() {
        var _a;
        return (_a = this.gos.get("pivotHeaderHeight")) != null ? _a : this.getHeaderHeight();
    }
    getPivotGroupHeaderHeight() {
        var _a;
        return (_a = this.gos.get("pivotGroupHeaderHeight")) != null ? _a : this.getGroupHeaderHeight();
    }
    queueResizeOperations() {
        this.shouldQueueResizeOperations = true;
    }
    processResizeOperations() {
        this.shouldQueueResizeOperations = false;
        this.resizeOperationQueue.forEach((resizeOperation)=>resizeOperation());
        this.resizeOperationQueue = [];
    }
    resetColumnDefIntoColumn(column, source) {
        const userColDef = column.getUserProvidedColDef();
        if (!userColDef) return false;
        const newColDef = this.columnFactory.addColumnDefaultAndTypes(userColDef, column.getColId());
        column.setColDef(newColDef, userColDef, source);
        return true;
    }
    isColumnGroupingLocked(column) {
        const groupLockGroupColumns = this.gos.get("groupLockGroupColumns");
        if (!column.isRowGroupActive() || groupLockGroupColumns === 0) return false;
        if (groupLockGroupColumns === -1) return true;
        const colIndex = this.rowGroupColumns.findIndex((groupCol)=>groupCol.getColId() === column.getColId());
        return groupLockGroupColumns > colIndex;
    }
    generateColumnStateForRowGroupAndPivotIndexes(updatedRowGroupColumnState, updatedPivotColumnState) {
        let existingColumnStateUpdates = {};
        const orderColumns = (updatedColumnState, colList, enableProp, initialEnableProp, indexProp, initialIndexProp)=>{
            if (!colList.length || !this.primaryColumns) return [];
            const updatedColIdArray = Object.keys(updatedColumnState);
            const updatedColIds = new Set(updatedColIdArray);
            const newColIds = new Set(updatedColIdArray);
            const allColIds = new Set(colList.map((column)=>{
                const colId = column.getColId();
                newColIds.delete(colId);
                return colId;
            }).concat(updatedColIdArray));
            const colIdsInOriginalOrder = [];
            const originalOrderMap = {};
            let orderIndex = 0;
            for(let i = 0; i < this.primaryColumns.length; i++){
                const colId = this.primaryColumns[i].getColId();
                if (allColIds.has(colId)) {
                    colIdsInOriginalOrder.push(colId);
                    originalOrderMap[colId] = orderIndex++;
                }
            }
            let index = 1e3;
            let hasAddedNewCols = false;
            let lastIndex = 0;
            const processPrecedingNewCols = (colId)=>{
                const originalOrderIndex = originalOrderMap[colId];
                for(let i = lastIndex; i < originalOrderIndex; i++){
                    const newColId = colIdsInOriginalOrder[i];
                    if (newColIds.has(newColId)) {
                        updatedColumnState[newColId][indexProp] = index++;
                        newColIds.delete(newColId);
                    }
                }
                lastIndex = originalOrderIndex;
            };
            colList.forEach((column)=>{
                const colId = column.getColId();
                if (updatedColIds.has(colId)) {
                    processPrecedingNewCols(colId);
                    updatedColumnState[colId][indexProp] = index++;
                } else {
                    const colDef = column.getColDef();
                    const missingIndex = colDef[indexProp] === null || colDef[indexProp] === void 0 && colDef[initialIndexProp] == null;
                    if (missingIndex) {
                        if (!hasAddedNewCols) {
                            const propEnabled = colDef[enableProp] || colDef[enableProp] === void 0 && colDef[initialEnableProp];
                            if (propEnabled) processPrecedingNewCols(colId);
                            else {
                                newColIds.forEach((newColId)=>{
                                    updatedColumnState[newColId][indexProp] = index + originalOrderMap[newColId];
                                });
                                index += colIdsInOriginalOrder.length;
                                hasAddedNewCols = true;
                            }
                        }
                        if (!existingColumnStateUpdates[colId]) existingColumnStateUpdates[colId] = {
                            colId: colId
                        };
                        existingColumnStateUpdates[colId][indexProp] = index++;
                    }
                }
            });
        };
        orderColumns(updatedRowGroupColumnState, this.rowGroupColumns, "rowGroup", "initialRowGroup", "rowGroupIndex", "initialRowGroupIndex");
        orderColumns(updatedPivotColumnState, this.pivotColumns, "pivot", "initialPivot", "pivotIndex", "initialPivotIndex");
        return Object.values(existingColumnStateUpdates);
    }
    onColumnsReady() {
        const autoSizeStrategy = this.gos.get("autoSizeStrategy");
        if (!autoSizeStrategy) return;
        const { type: type } = autoSizeStrategy;
        setTimeout(()=>{
            if (type === "fitGridWidth") {
                const { columnLimits: propColumnLimits, defaultMinWidth: defaultMinWidth, defaultMaxWidth: defaultMaxWidth } = autoSizeStrategy;
                const columnLimits = propColumnLimits == null ? void 0 : propColumnLimits.map(({ colId: key, minWidth: minWidth, maxWidth: maxWidth })=>({
                        key: key,
                        minWidth: minWidth,
                        maxWidth: maxWidth
                    }));
                this.ctrlsService.getGridBodyCtrl().sizeColumnsToFit({
                    defaultMinWidth: defaultMinWidth,
                    defaultMaxWidth: defaultMaxWidth,
                    columnLimits: columnLimits
                });
            } else if (type === "fitProvidedWidth") this.sizeColumnsToFit(autoSizeStrategy.width, "sizeColumnsToFit");
        });
    }
    onFirstDataRendered() {
        const autoSizeStrategy = this.gos.get("autoSizeStrategy");
        if ((autoSizeStrategy == null ? void 0 : autoSizeStrategy.type) !== "fitCellContents") return;
        const { colIds: columns, skipHeader: skipHeader } = autoSizeStrategy;
        setTimeout(()=>{
            if (columns) this.autoSizeColumns({
                columns: columns,
                skipHeader: skipHeader,
                source: "autosizeColumns"
            });
            else this.autoSizeAllColumns("autosizeColumns", skipHeader);
        });
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("expressionService")
], $437b23f6a393c3bf$export$c9dec256e4c9f340.prototype, "expressionService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnFactory")
], $437b23f6a393c3bf$export$c9dec256e4c9f340.prototype, "columnFactory", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("displayedGroupCreator")
], $437b23f6a393c3bf$export$c9dec256e4c9f340.prototype, "displayedGroupCreator", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("ctrlsService")
], $437b23f6a393c3bf$export$c9dec256e4c9f340.prototype, "ctrlsService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("autoWidthCalculator")
], $437b23f6a393c3bf$export$c9dec256e4c9f340.prototype, "autoWidthCalculator", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnAnimationService")
], $437b23f6a393c3bf$export$c9dec256e4c9f340.prototype, "columnAnimationService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("autoGroupColService")
], $437b23f6a393c3bf$export$c9dec256e4c9f340.prototype, "autoGroupColService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("valueCache")
], $437b23f6a393c3bf$export$c9dec256e4c9f340.prototype, "valueCache", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("animationFrameService")
], $437b23f6a393c3bf$export$c9dec256e4c9f340.prototype, "animationFrameService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("sortController")
], $437b23f6a393c3bf$export$c9dec256e4c9f340.prototype, "sortController", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnDefFactory")
], $437b23f6a393c3bf$export$c9dec256e4c9f340.prototype, "columnDefFactory", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$7acb7b24c478f9c6("aggFuncService")
], $437b23f6a393c3bf$export$c9dec256e4c9f340.prototype, "aggFuncService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$export$c9dec256e4c9f340.prototype, "init", 1);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$cc3f3d4529c57d95
], $437b23f6a393c3bf$export$c9dec256e4c9f340.prototype, "destroyColumns", 1);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$var$__decorateParam(0, $437b23f6a393c3bf$export$c3215dfb7fd4803b("loggerFactory"))
], $437b23f6a393c3bf$export$c9dec256e4c9f340.prototype, "setBeans", 1);
$437b23f6a393c3bf$export$c9dec256e4c9f340 = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("columnModel")
], $437b23f6a393c3bf$export$c9dec256e4c9f340);
function $437b23f6a393c3bf$var$convertSourceType(source) {
    return source === "gridOptionsUpdated" ? "gridOptionsChanged" : source;
}
function $437b23f6a393c3bf$var$depthFirstAllColumnTreeSearch(tree, useDisplayedChildren, callback) {
    if (!tree) return;
    for(let i = 0; i < tree.length; i++){
        const child = tree[i];
        if (child instanceof $437b23f6a393c3bf$export$8a8fbc71323f074) {
            const childTree = useDisplayedChildren ? child.getDisplayedChildren() : child.getChildren();
            $437b23f6a393c3bf$var$depthFirstAllColumnTreeSearch(childTree, useDisplayedChildren, callback);
        }
        callback(child);
    }
}
// community-modules/core/src/columns/displayedGroupCreator.ts
var $437b23f6a393c3bf$export$de11801d74224ab = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    createDisplayedGroups(sortedVisibleColumns, groupInstanceIdCreator, pinned, oldDisplayedGroups) {
        const oldColumnsMapped = this.mapOldGroupsById(oldDisplayedGroups);
        const topLevelResultCols = [];
        let groupsOrColsAtCurrentLevel = sortedVisibleColumns;
        while(groupsOrColsAtCurrentLevel.length){
            const currentlyIterating = groupsOrColsAtCurrentLevel;
            groupsOrColsAtCurrentLevel = [];
            let lastGroupedColIdx = 0;
            const createGroupToIndex = (to)=>{
                const from = lastGroupedColIdx;
                lastGroupedColIdx = to;
                const previousNode = currentlyIterating[from];
                const previousNodeProvided = previousNode instanceof $437b23f6a393c3bf$export$8a8fbc71323f074 ? previousNode.getProvidedColumnGroup() : previousNode;
                const previousNodeParent = previousNodeProvided.getOriginalParent();
                if (previousNodeParent == null) {
                    for(let i = from; i < to; i++)topLevelResultCols.push(currentlyIterating[i]);
                    return;
                }
                const newGroup = this.createColumnGroup(previousNodeParent, groupInstanceIdCreator, oldColumnsMapped, pinned);
                for(let i = from; i < to; i++)newGroup.addChild(currentlyIterating[i]);
                groupsOrColsAtCurrentLevel.push(newGroup);
            };
            for(let i = 1; i < currentlyIterating.length; i++){
                const thisNode = currentlyIterating[i];
                const thisNodeProvided = thisNode instanceof $437b23f6a393c3bf$export$8a8fbc71323f074 ? thisNode.getProvidedColumnGroup() : thisNode;
                const thisNodeParent = thisNodeProvided.getOriginalParent();
                const previousNode = currentlyIterating[lastGroupedColIdx];
                const previousNodeProvided = previousNode instanceof $437b23f6a393c3bf$export$8a8fbc71323f074 ? previousNode.getProvidedColumnGroup() : previousNode;
                const previousNodeParent = previousNodeProvided.getOriginalParent();
                if (thisNodeParent !== previousNodeParent) createGroupToIndex(i);
            }
            if (lastGroupedColIdx < currentlyIterating.length) createGroupToIndex(currentlyIterating.length);
        }
        this.setupParentsIntoColumns(topLevelResultCols, null);
        return topLevelResultCols;
    }
    createColumnGroup(providedGroup, groupInstanceIdCreator, oldColumnsMapped, pinned) {
        const groupId = providedGroup.getGroupId();
        const instanceId = groupInstanceIdCreator.getInstanceIdForKey(groupId);
        const uniqueId = $437b23f6a393c3bf$export$8a8fbc71323f074.createUniqueId(groupId, instanceId);
        let columnGroup = oldColumnsMapped[uniqueId];
        if (columnGroup && columnGroup.getProvidedColumnGroup() !== providedGroup) columnGroup = null;
        if ($437b23f6a393c3bf$var$exists(columnGroup)) columnGroup.reset();
        else {
            columnGroup = new $437b23f6a393c3bf$export$8a8fbc71323f074(providedGroup, groupId, instanceId, pinned);
            this.context.createBean(columnGroup);
        }
        return columnGroup;
    }
    // returns back a 2d map of ColumnGroup as follows: groupId -> instanceId -> ColumnGroup
    mapOldGroupsById(displayedGroups) {
        const result = {};
        const recursive = (columnsOrGroups)=>{
            columnsOrGroups.forEach((columnOrGroup)=>{
                if (columnOrGroup instanceof $437b23f6a393c3bf$export$8a8fbc71323f074) {
                    const columnGroup = columnOrGroup;
                    result[columnOrGroup.getUniqueId()] = columnGroup;
                    recursive(columnGroup.getChildren());
                }
            });
        };
        if (displayedGroups) recursive(displayedGroups);
        return result;
    }
    setupParentsIntoColumns(columnsOrGroups, parent) {
        columnsOrGroups.forEach((columnsOrGroup)=>{
            columnsOrGroup.setParent(parent);
            if (columnsOrGroup instanceof $437b23f6a393c3bf$export$8a8fbc71323f074) {
                const columnGroup = columnsOrGroup;
                this.setupParentsIntoColumns(columnGroup.getChildren(), columnGroup);
            }
        });
    }
};
$437b23f6a393c3bf$export$de11801d74224ab = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("displayedGroupCreator")
], $437b23f6a393c3bf$export$de11801d74224ab);
// community-modules/core/src/propertyKeys.ts
var $437b23f6a393c3bf$var$INITIAL_GRID_OPTION_KEYS = {
    enableBrowserTooltips: true,
    tooltipTrigger: true,
    tooltipMouseTrack: true,
    tooltipShowMode: true,
    tooltipInteraction: true,
    defaultColGroupDef: true,
    suppressAutoSize: true,
    skipHeaderOnAutoSize: true,
    autoSizeStrategy: true,
    components: true,
    stopEditingWhenCellsLoseFocus: true,
    undoRedoCellEditing: true,
    undoRedoCellEditingLimit: true,
    excelStyles: true,
    cacheQuickFilter: true,
    excludeHiddenColumnsFromQuickFilter: true,
    advancedFilterModel: true,
    customChartThemes: true,
    chartThemeOverrides: true,
    enableChartToolPanelsButton: true,
    suppressChartToolPanelsButton: true,
    chartToolPanelsDef: true,
    loadingCellRendererSelector: true,
    localeText: true,
    keepDetailRows: true,
    keepDetailRowsCount: true,
    detailRowHeight: true,
    detailRowAutoHeight: true,
    tabIndex: true,
    valueCache: true,
    valueCacheNeverExpires: true,
    enableCellExpressions: true,
    suppressParentsInRowNodes: true,
    suppressTouch: true,
    suppressAsyncEvents: true,
    suppressBrowserResizeObserver: true,
    suppressPropertyNamesCheck: true,
    debug: true,
    loadingOverlayComponent: true,
    suppressLoadingOverlay: true,
    noRowsOverlayComponent: true,
    paginationPageSizeSelector: true,
    paginateChildRows: true,
    pivotPanelShow: true,
    pivotSuppressAutoColumn: true,
    suppressExpandablePivotGroups: true,
    aggFuncs: true,
    suppressAggFuncInHeader: true,
    suppressAggAtRootLevel: true,
    removePivotHeaderRowWhenSingleValueColumn: true,
    allowShowChangeAfterFilter: true,
    ensureDomOrder: true,
    enableRtl: true,
    suppressColumnVirtualisation: true,
    suppressMaxRenderedRowRestriction: true,
    suppressRowVirtualisation: true,
    rowDragText: true,
    suppressGroupMaintainValueType: true,
    groupLockGroupColumns: true,
    rowGroupPanelSuppressSort: true,
    suppressGroupRowsSticky: true,
    rowModelType: true,
    cacheOverflowSize: true,
    infiniteInitialRowCount: true,
    serverSideInitialRowCount: true,
    suppressServerSideInfiniteScroll: true,
    maxBlocksInCache: true,
    maxConcurrentDatasourceRequests: true,
    blockLoadDebounceMillis: true,
    serverSideOnlyRefreshFilteredGroups: true,
    serverSidePivotResultFieldSeparator: true,
    viewportRowModelPageSize: true,
    viewportRowModelBufferSize: true,
    debounceVerticalScrollbar: true,
    suppressAnimationFrame: true,
    suppressPreventDefaultOnMouseWheel: true,
    scrollbarWidth: true,
    icons: true,
    suppressRowTransform: true,
    gridId: true,
    functionsPassive: true,
    enableGroupEdit: true,
    initialState: true,
    processUnpinnedColumns: true,
    createChartContainer: true,
    getLocaleText: true,
    getRowId: true,
    reactiveCustomComponents: true,
    columnMenu: true
};
var $437b23f6a393c3bf$var$_PropertyKeys = class _PropertyKeys {
};
$437b23f6a393c3bf$var$_PropertyKeys.STRING_PROPERTIES = [
    "rowSelection",
    "overlayLoadingTemplate",
    "overlayNoRowsTemplate",
    "gridId",
    "quickFilterText",
    "rowModelType",
    "editType",
    "domLayout",
    "clipboardDelimiter",
    "rowGroupPanelShow",
    "multiSortKey",
    "pivotColumnGroupTotals",
    "pivotRowTotals",
    "pivotPanelShow",
    "fillHandleDirection",
    "groupDisplayType",
    "treeDataDisplayType",
    "colResizeDefault",
    "tooltipTrigger",
    "serverSidePivotResultFieldSeparator",
    "columnMenu",
    "tooltipShowMode",
    "grandTotalRow"
];
$437b23f6a393c3bf$var$_PropertyKeys.OBJECT_PROPERTIES = [
    "components",
    "rowStyle",
    "context",
    "autoGroupColumnDef",
    "localeText",
    "icons",
    "datasource",
    "serverSideDatasource",
    "viewportDatasource",
    "groupRowRendererParams",
    "aggFuncs",
    "fullWidthCellRendererParams",
    "defaultColGroupDef",
    "defaultColDef",
    "defaultCsvExportParams",
    "defaultExcelExportParams",
    "columnTypes",
    "rowClassRules",
    "detailCellRendererParams",
    "loadingCellRendererParams",
    "loadingOverlayComponentParams",
    "noRowsOverlayComponentParams",
    "popupParent",
    "statusBar",
    "sideBar",
    "chartThemeOverrides",
    "customChartThemes",
    "chartToolPanelsDef",
    "dataTypeDefinitions",
    "advancedFilterModel",
    "advancedFilterParent",
    "advancedFilterBuilderParams",
    "initialState",
    "autoSizeStrategy"
];
$437b23f6a393c3bf$var$_PropertyKeys.ARRAY_PROPERTIES = [
    "sortingOrder",
    "alignedGrids",
    "rowData",
    "columnDefs",
    "excelStyles",
    "pinnedTopRowData",
    "pinnedBottomRowData",
    "chartThemes",
    "rowClass",
    "paginationPageSizeSelector"
];
// These properties are coerced at runtime, do not do union types
$437b23f6a393c3bf$var$_PropertyKeys.NUMBER_PROPERTIES = [
    "rowHeight",
    "detailRowHeight",
    "rowBuffer",
    "headerHeight",
    "groupHeaderHeight",
    "groupLockGroupColumns",
    "floatingFiltersHeight",
    "pivotHeaderHeight",
    "pivotGroupHeaderHeight",
    "groupDefaultExpanded",
    "pivotDefaultExpanded",
    "viewportRowModelPageSize",
    "viewportRowModelBufferSize",
    "autoSizePadding",
    "maxBlocksInCache",
    "maxConcurrentDatasourceRequests",
    "tooltipShowDelay",
    "tooltipHideDelay",
    "cacheOverflowSize",
    "paginationPageSize",
    "cacheBlockSize",
    "infiniteInitialRowCount",
    "serverSideInitialRowCount",
    "scrollbarWidth",
    "asyncTransactionWaitMillis",
    "blockLoadDebounceMillis",
    "keepDetailRowsCount",
    "undoRedoCellEditingLimit",
    "cellFlashDelay",
    "cellFadeDelay",
    "cellFlashDuration",
    "cellFadeDuration",
    "tabIndex",
    "pivotMaxGeneratedColumns"
];
// These properties are coerced at runtime, do not do union types
$437b23f6a393c3bf$var$_PropertyKeys.BOOLEAN_PROPERTIES = [
    "suppressMakeColumnVisibleAfterUnGroup",
    "suppressRowClickSelection",
    "suppressCellFocus",
    "suppressHeaderFocus",
    "suppressHorizontalScroll",
    "groupSelectsChildren",
    "alwaysShowHorizontalScroll",
    "alwaysShowVerticalScroll",
    "debug",
    "enableBrowserTooltips",
    "enableCellExpressions",
    "groupIncludeTotalFooter",
    "groupSuppressBlankHeader",
    "suppressMenuHide",
    "suppressRowDeselection",
    "unSortIcon",
    "suppressMultiSort",
    "alwaysMultiSort",
    "singleClickEdit",
    "suppressLoadingOverlay",
    "suppressNoRowsOverlay",
    "suppressAutoSize",
    "skipHeaderOnAutoSize",
    "suppressParentsInRowNodes",
    "suppressColumnMoveAnimation",
    "suppressMovableColumns",
    "suppressFieldDotNotation",
    "enableRangeSelection",
    "enableRangeHandle",
    "enableFillHandle",
    "suppressClearOnFillReduction",
    "deltaSort",
    "suppressTouch",
    "suppressAsyncEvents",
    "allowContextMenuWithControlKey",
    "suppressContextMenu",
    "enableCellChangeFlash",
    "suppressDragLeaveHidesColumns",
    "suppressRowGroupHidesColumns",
    "suppressMiddleClickScrolls",
    "suppressPreventDefaultOnMouseWheel",
    "suppressCopyRowsToClipboard",
    "copyHeadersToClipboard",
    "copyGroupHeadersToClipboard",
    "pivotMode",
    "suppressAggFuncInHeader",
    "suppressColumnVirtualisation",
    "alwaysAggregateAtRootLevel",
    "suppressAggAtRootLevel",
    "suppressFocusAfterRefresh",
    "functionsPassive",
    "functionsReadOnly",
    "animateRows",
    "groupSelectsFiltered",
    "groupRemoveSingleChildren",
    "groupRemoveLowestSingleChildren",
    "enableRtl",
    "suppressClickEdit",
    "rowDragEntireRow",
    "rowDragManaged",
    "suppressRowDrag",
    "suppressMoveWhenRowDragging",
    "rowDragMultiRow",
    "enableGroupEdit",
    "embedFullWidthRows",
    "suppressPaginationPanel",
    "groupHideOpenParents",
    "groupAllowUnbalanced",
    "pagination",
    "paginationAutoPageSize",
    "suppressScrollOnNewData",
    "suppressScrollWhenPopupsAreOpen",
    "purgeClosedRowNodes",
    "cacheQuickFilter",
    "includeHiddenColumnsInQuickFilter",
    "excludeHiddenColumnsFromQuickFilter",
    "ensureDomOrder",
    "accentedSort",
    "suppressChangeDetection",
    "valueCache",
    "valueCacheNeverExpires",
    "aggregateOnlyChangedColumns",
    "suppressAnimationFrame",
    "suppressExcelExport",
    "suppressCsvExport",
    "includeHiddenColumnsInAdvancedFilter",
    "suppressMultiRangeSelection",
    "enterMovesDown",
    "enterMovesDownAfterEdit",
    "enterNavigatesVerticallyAfterEdit",
    "enterNavigatesVertically",
    "suppressPropertyNamesCheck",
    "rowMultiSelectWithClick",
    "suppressRowHoverHighlight",
    "suppressRowTransform",
    "suppressClipboardPaste",
    "suppressLastEmptyLineOnPaste",
    "enableCharts",
    "enableChartToolPanelsButton",
    "suppressChartToolPanelsButton",
    "suppressMaintainUnsortedOrder",
    "enableCellTextSelection",
    "suppressBrowserResizeObserver",
    "suppressMaxRenderedRowRestriction",
    "excludeChildrenWhenTreeDataFiltering",
    "tooltipMouseTrack",
    "tooltipInteraction",
    "keepDetailRows",
    "paginateChildRows",
    "preventDefaultOnContextMenu",
    "undoRedoCellEditing",
    "allowDragFromColumnsToolPanel",
    "pivotSuppressAutoColumn",
    "suppressExpandablePivotGroups",
    "debounceVerticalScrollbar",
    "detailRowAutoHeight",
    "serverSideFilterAllLevels",
    "serverSideSortAllLevels",
    "serverSideEnableClientSideSort",
    "serverSideOnlyRefreshFilteredGroups",
    "serverSideSortOnServer",
    "serverSideFilterOnServer",
    "suppressAggFilteredOnly",
    "showOpenedGroup",
    "suppressClipboardApi",
    "suppressModelUpdateAfterUpdateTransaction",
    "stopEditingWhenCellsLoseFocus",
    "maintainColumnOrder",
    "groupMaintainOrder",
    "columnHoverHighlight",
    "readOnlyEdit",
    "suppressRowVirtualisation",
    "enableCellEditingOnBackspace",
    "resetRowDataOnUpdate",
    "removePivotHeaderRowWhenSingleValueColumn",
    "suppressCopySingleCellRanges",
    "suppressGroupRowsSticky",
    "suppressCutToClipboard",
    "suppressServerSideInfiniteScroll",
    "rowGroupPanelSuppressSort",
    "allowShowChangeAfterFilter",
    "enableAdvancedFilter",
    "masterDetail",
    "treeData",
    "suppressGroupMaintainValueType",
    "reactiveCustomComponents",
    "applyQuickFilterBeforePivotOrAgg",
    "suppressServerSideFullWidthLoadingRow",
    "suppressAdvancedFilterEval"
];
// If property does not fit above, i.e union that should not be coerced.
$437b23f6a393c3bf$var$_PropertyKeys.OTHER_PROPERTIES = [
    "suppressStickyTotalRow"
];
/** You do not need to include event callbacks in this list, as they are generated automatically. */ $437b23f6a393c3bf$var$_PropertyKeys.FUNCTIONAL_PROPERTIES = [
    "doesExternalFilterPass",
    "processPivotResultColDef",
    "processPivotResultColGroupDef",
    "getBusinessKeyForNode",
    "isRowSelectable",
    "rowDragText",
    "groupRowRenderer",
    "fullWidthCellRenderer",
    "loadingCellRenderer",
    "loadingOverlayComponent",
    "noRowsOverlayComponent",
    "detailCellRenderer",
    "quickFilterParser",
    "quickFilterMatcher"
];
/** These callbacks extend AgGridCommon interface */ $437b23f6a393c3bf$var$_PropertyKeys.CALLBACK_PROPERTIES = [
    "getLocaleText",
    "isExternalFilterPresent",
    "getRowHeight",
    "getRowClass",
    "getRowStyle",
    "getContextMenuItems",
    "getMainMenuItems",
    "processRowPostCreate",
    "processCellForClipboard",
    "getGroupRowAgg",
    "isFullWidthRow",
    "sendToClipboard",
    "navigateToNextHeader",
    "tabToNextHeader",
    "navigateToNextCell",
    "tabToNextCell",
    "processCellFromClipboard",
    "getDocument",
    "postProcessPopup",
    "getChildCount",
    "getDataPath",
    "isRowMaster",
    "postSortRows",
    "processHeaderForClipboard",
    "processUnpinnedColumns",
    "processGroupHeaderForClipboard",
    "paginationNumberFormatter",
    "processDataFromClipboard",
    "getServerSideGroupKey",
    "isServerSideGroup",
    "createChartContainer",
    "getChartToolbarItems",
    "fillOperation",
    "isApplyServerSideTransaction",
    "getServerSideGroupLevelParams",
    "isServerSideGroupOpenByDefault",
    "isGroupOpenByDefault",
    "initialGroupOrderComparator",
    "groupIncludeFooter",
    "loadingCellRendererSelector",
    "getRowId",
    "groupAggFiltering",
    "chartMenuItems",
    "groupTotalRow"
];
$437b23f6a393c3bf$var$_PropertyKeys.FUNCTION_PROPERTIES = [
    ...$437b23f6a393c3bf$var$_PropertyKeys.FUNCTIONAL_PROPERTIES,
    ...$437b23f6a393c3bf$var$_PropertyKeys.CALLBACK_PROPERTIES
];
$437b23f6a393c3bf$var$_PropertyKeys.ALL_PROPERTIES = [
    ...$437b23f6a393c3bf$var$_PropertyKeys.ARRAY_PROPERTIES,
    ...$437b23f6a393c3bf$var$_PropertyKeys.OBJECT_PROPERTIES,
    ...$437b23f6a393c3bf$var$_PropertyKeys.STRING_PROPERTIES,
    ...$437b23f6a393c3bf$var$_PropertyKeys.NUMBER_PROPERTIES,
    ...$437b23f6a393c3bf$var$_PropertyKeys.FUNCTION_PROPERTIES,
    ...$437b23f6a393c3bf$var$_PropertyKeys.BOOLEAN_PROPERTIES,
    ...$437b23f6a393c3bf$var$_PropertyKeys.OTHER_PROPERTIES
];
var $437b23f6a393c3bf$export$4d1a0127671c9c1f = $437b23f6a393c3bf$var$_PropertyKeys;
// community-modules/core/src/components/componentUtil.ts
var $437b23f6a393c3bf$var$_ComponentUtil = class _ComponentUtil {
    static getCallbackForEvent(eventName) {
        if (!eventName || eventName.length < 2) return eventName;
        return "on" + eventName[0].toUpperCase() + eventName.substring(1);
    }
    static getGridOptionKeys() {
        return this.ALL_PROPERTIES_AND_CALLBACKS;
    }
    /** Combines component props / attributes with the provided gridOptions returning a new combined gridOptions object */ static combineAttributesAndGridOptions(gridOptions, component) {
        if (typeof gridOptions !== "object") gridOptions = {};
        const mergedOptions = $437b23f6a393c3bf$var$__spreadValues({}, gridOptions);
        const keys2 = _ComponentUtil.getGridOptionKeys();
        keys2.forEach((key)=>{
            const value = component[key];
            if (typeof value !== "undefined" && value !== _ComponentUtil.VUE_OMITTED_PROPERTY) mergedOptions[key] = value;
        });
        return mergedOptions;
    }
    static processOnChange(changes, api, isVue) {
        if (!changes) return;
        const gridChanges = {};
        let hasChanges = false;
        Object.keys(changes).filter((key)=>_ComponentUtil.ALL_PROPERTIES_AND_CALLBACKS_SET.has(key)).forEach((key)=>{
            gridChanges[key] = changes[key];
            hasChanges = true;
        });
        if (!hasChanges) return;
        api.__internalUpdateGridOptions(gridChanges, true);
        const event = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COMPONENT_STATE_CHANGED
        };
        $437b23f6a393c3bf$var$iterateObject(gridChanges, (key, value)=>{
            event[key] = value;
        });
        api.dispatchEvent(event);
    }
};
// all events
$437b23f6a393c3bf$var$_ComponentUtil.EVENTS = $437b23f6a393c3bf$var$values($437b23f6a393c3bf$export$ada873a34909da65);
$437b23f6a393c3bf$var$_ComponentUtil.VUE_OMITTED_PROPERTY = "AG-VUE-OMITTED-PROPERTY";
// events that are internal to AG Grid and should not be exposed to users via documentation or generated framework components
/** Exclude the following internal events from code generation to prevent exposing these events via framework components */ $437b23f6a393c3bf$var$_ComponentUtil.EXCLUDED_INTERNAL_EVENTS = [
    $437b23f6a393c3bf$export$ada873a34909da65.EVENT_SCROLLBAR_WIDTH_CHANGED,
    $437b23f6a393c3bf$export$ada873a34909da65.EVENT_CHECKBOX_CHANGED,
    $437b23f6a393c3bf$export$ada873a34909da65.EVENT_HEIGHT_SCALE_CHANGED,
    $437b23f6a393c3bf$export$ada873a34909da65.EVENT_BODY_HEIGHT_CHANGED,
    $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_CONTAINER_WIDTH_CHANGED,
    $437b23f6a393c3bf$export$ada873a34909da65.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED,
    $437b23f6a393c3bf$export$ada873a34909da65.EVENT_SCROLL_VISIBILITY_CHANGED,
    $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_HOVER_CHANGED,
    $437b23f6a393c3bf$export$ada873a34909da65.EVENT_FLASH_CELLS,
    $437b23f6a393c3bf$export$ada873a34909da65.EVENT_PAGINATION_PIXEL_OFFSET_CHANGED,
    $437b23f6a393c3bf$export$ada873a34909da65.EVENT_DISPLAYED_ROWS_CHANGED,
    $437b23f6a393c3bf$export$ada873a34909da65.EVENT_LEFT_PINNED_WIDTH_CHANGED,
    $437b23f6a393c3bf$export$ada873a34909da65.EVENT_RIGHT_PINNED_WIDTH_CHANGED,
    $437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_CONTAINER_HEIGHT_CHANGED,
    $437b23f6a393c3bf$export$ada873a34909da65.EVENT_STORE_UPDATED,
    $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_PANEL_ITEM_DRAG_START,
    $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_PANEL_ITEM_DRAG_END,
    $437b23f6a393c3bf$export$ada873a34909da65.EVENT_KEY_SHORTCUT_CHANGED_CELL_START,
    $437b23f6a393c3bf$export$ada873a34909da65.EVENT_KEY_SHORTCUT_CHANGED_CELL_END,
    $437b23f6a393c3bf$export$ada873a34909da65.EVENT_FULL_WIDTH_ROW_FOCUSED,
    $437b23f6a393c3bf$export$ada873a34909da65.EVENT_HEADER_HEIGHT_CHANGED,
    $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_HEADER_HEIGHT_CHANGED,
    $437b23f6a393c3bf$export$ada873a34909da65.EVENT_CELL_FOCUS_CLEARED,
    $437b23f6a393c3bf$export$ada873a34909da65.EVENT_GRID_STYLES_CHANGED,
    $437b23f6a393c3bf$export$ada873a34909da65.EVENT_FILTER_DESTROYED,
    $437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_DATA_UPDATE_STARTED,
    $437b23f6a393c3bf$export$ada873a34909da65.EVENT_ADVANCED_FILTER_ENABLED_CHANGED,
    $437b23f6a393c3bf$export$ada873a34909da65.EVENT_DATA_TYPES_INFERRED,
    $437b23f6a393c3bf$export$ada873a34909da65.EVENT_FIELD_VALUE_CHANGED,
    $437b23f6a393c3bf$export$ada873a34909da65.EVENT_FIELD_PICKER_VALUE_SELECTED,
    $437b23f6a393c3bf$export$ada873a34909da65.EVENT_SUPPRESS_COLUMN_MOVE_CHANGED,
    $437b23f6a393c3bf$export$ada873a34909da65.EVENT_SUPPRESS_MENU_HIDE_CHANGED,
    $437b23f6a393c3bf$export$ada873a34909da65.EVENT_SUPPRESS_FIELD_DOT_NOTATION,
    $437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_COUNT_READY,
    $437b23f6a393c3bf$export$ada873a34909da65.EVENT_SIDE_BAR_UPDATED
];
// events that are available for use by users of AG Grid and so should be documented
/** EVENTS that should be exposed via code generation for the framework components.  */ $437b23f6a393c3bf$var$_ComponentUtil.PUBLIC_EVENTS = $437b23f6a393c3bf$var$_ComponentUtil.EVENTS.filter((e)=>!$437b23f6a393c3bf$var$includes($437b23f6a393c3bf$var$_ComponentUtil.EXCLUDED_INTERNAL_EVENTS, e));
// onXXX methods, based on the above events
$437b23f6a393c3bf$var$_ComponentUtil.EVENT_CALLBACKS = $437b23f6a393c3bf$var$_ComponentUtil.EVENTS.map((event)=>$437b23f6a393c3bf$var$_ComponentUtil.getCallbackForEvent(event));
$437b23f6a393c3bf$var$_ComponentUtil.BOOLEAN_PROPERTIES = $437b23f6a393c3bf$export$4d1a0127671c9c1f.BOOLEAN_PROPERTIES;
$437b23f6a393c3bf$var$_ComponentUtil.ALL_PROPERTIES = $437b23f6a393c3bf$export$4d1a0127671c9c1f.ALL_PROPERTIES;
$437b23f6a393c3bf$var$_ComponentUtil.ALL_PROPERTIES_AND_CALLBACKS = [
    ...$437b23f6a393c3bf$var$_ComponentUtil.ALL_PROPERTIES,
    ...$437b23f6a393c3bf$var$_ComponentUtil.EVENT_CALLBACKS
];
$437b23f6a393c3bf$var$_ComponentUtil.ALL_PROPERTIES_AND_CALLBACKS_SET = new Set($437b23f6a393c3bf$var$_ComponentUtil.ALL_PROPERTIES_AND_CALLBACKS);
var $437b23f6a393c3bf$export$1f1b72b628161f7c = $437b23f6a393c3bf$var$_ComponentUtil;
// community-modules/core/src/components/agStackComponentsRegistry.ts
var $437b23f6a393c3bf$export$7d237966671a050f = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.componentsMappedByName = {};
    }
    setupComponents(components) {
        if (components) components.forEach((componentMeta)=>this.addComponent(componentMeta));
    }
    addComponent(componentMeta) {
        const classEscaped = componentMeta.componentName.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
        const classUpperCase = classEscaped.toUpperCase();
        this.componentsMappedByName[classUpperCase] = componentMeta.componentClass;
    }
    getComponentClass(htmlTag) {
        return this.componentsMappedByName[htmlTag];
    }
};
$437b23f6a393c3bf$export$7d237966671a050f = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("agStackComponentsRegistry")
], $437b23f6a393c3bf$export$7d237966671a050f);
// community-modules/core/src/utils/aria.ts
var $437b23f6a393c3bf$var$aria_exports = {};
$437b23f6a393c3bf$var$__export($437b23f6a393c3bf$var$aria_exports, {
    getAriaCheckboxStateName: ()=>$437b23f6a393c3bf$var$getAriaCheckboxStateName,
    getAriaLabel: ()=>$437b23f6a393c3bf$var$getAriaLabel,
    getAriaLevel: ()=>$437b23f6a393c3bf$var$getAriaLevel,
    getAriaPosInSet: ()=>$437b23f6a393c3bf$var$getAriaPosInSet,
    getAriaSortState: ()=>$437b23f6a393c3bf$var$getAriaSortState,
    removeAriaExpanded: ()=>$437b23f6a393c3bf$var$removeAriaExpanded,
    removeAriaSort: ()=>$437b23f6a393c3bf$var$removeAriaSort,
    setAriaActiveDescendant: ()=>$437b23f6a393c3bf$var$setAriaActiveDescendant,
    setAriaAtomic: ()=>$437b23f6a393c3bf$var$setAriaAtomic,
    setAriaChecked: ()=>$437b23f6a393c3bf$var$setAriaChecked,
    setAriaColCount: ()=>$437b23f6a393c3bf$var$setAriaColCount,
    setAriaColIndex: ()=>$437b23f6a393c3bf$var$setAriaColIndex,
    setAriaColSpan: ()=>$437b23f6a393c3bf$var$setAriaColSpan,
    setAriaControls: ()=>$437b23f6a393c3bf$var$setAriaControls,
    setAriaDescribedBy: ()=>$437b23f6a393c3bf$var$setAriaDescribedBy,
    setAriaDisabled: ()=>$437b23f6a393c3bf$var$setAriaDisabled,
    setAriaExpanded: ()=>$437b23f6a393c3bf$var$setAriaExpanded,
    setAriaHidden: ()=>$437b23f6a393c3bf$var$setAriaHidden,
    setAriaLabel: ()=>$437b23f6a393c3bf$var$setAriaLabel,
    setAriaLabelledBy: ()=>$437b23f6a393c3bf$var$setAriaLabelledBy,
    setAriaLevel: ()=>$437b23f6a393c3bf$var$setAriaLevel,
    setAriaLive: ()=>$437b23f6a393c3bf$var$setAriaLive,
    setAriaMultiSelectable: ()=>$437b23f6a393c3bf$var$setAriaMultiSelectable,
    setAriaPosInSet: ()=>$437b23f6a393c3bf$var$setAriaPosInSet,
    setAriaRelevant: ()=>$437b23f6a393c3bf$var$setAriaRelevant,
    setAriaRole: ()=>$437b23f6a393c3bf$var$setAriaRole,
    setAriaRowCount: ()=>$437b23f6a393c3bf$var$setAriaRowCount,
    setAriaRowIndex: ()=>$437b23f6a393c3bf$var$setAriaRowIndex,
    setAriaSelected: ()=>$437b23f6a393c3bf$var$setAriaSelected,
    setAriaSetSize: ()=>$437b23f6a393c3bf$var$setAriaSetSize,
    setAriaSort: ()=>$437b23f6a393c3bf$var$setAriaSort
});
function $437b23f6a393c3bf$var$toggleAriaAttribute(element, attribute, value) {
    if (value == null || typeof value === "string" && value == "") $437b23f6a393c3bf$var$removeAriaAttribute(element, attribute);
    else $437b23f6a393c3bf$var$setAriaAttribute(element, attribute, value);
}
function $437b23f6a393c3bf$var$setAriaAttribute(element, attribute, value) {
    element.setAttribute($437b23f6a393c3bf$var$ariaAttributeName(attribute), value.toString());
}
function $437b23f6a393c3bf$var$removeAriaAttribute(element, attribute) {
    element.removeAttribute($437b23f6a393c3bf$var$ariaAttributeName(attribute));
}
function $437b23f6a393c3bf$var$ariaAttributeName(attribute) {
    return `aria-${attribute}`;
}
function $437b23f6a393c3bf$var$setAriaRole(element, role) {
    if (role) element.setAttribute("role", role);
    else element.removeAttribute("role");
}
function $437b23f6a393c3bf$var$getAriaSortState(sortDirection) {
    let sort;
    if (sortDirection === "asc") sort = "ascending";
    else if (sortDirection === "desc") sort = "descending";
    else if (sortDirection === "mixed") sort = "other";
    else sort = "none";
    return sort;
}
function $437b23f6a393c3bf$var$getAriaLevel(element) {
    return parseInt(element.getAttribute("aria-level"), 10);
}
function $437b23f6a393c3bf$var$getAriaPosInSet(element) {
    return parseInt(element.getAttribute("aria-posinset"), 10);
}
function $437b23f6a393c3bf$var$getAriaLabel(element) {
    return element.getAttribute("aria-label");
}
function $437b23f6a393c3bf$var$setAriaLabel(element, label) {
    $437b23f6a393c3bf$var$toggleAriaAttribute(element, "label", label);
}
function $437b23f6a393c3bf$var$setAriaLabelledBy(element, labelledBy) {
    $437b23f6a393c3bf$var$toggleAriaAttribute(element, "labelledby", labelledBy);
}
function $437b23f6a393c3bf$var$setAriaDescribedBy(element, describedby) {
    $437b23f6a393c3bf$var$toggleAriaAttribute(element, "describedby", describedby);
}
function $437b23f6a393c3bf$var$setAriaLive(element, live) {
    $437b23f6a393c3bf$var$toggleAriaAttribute(element, "live", live);
}
function $437b23f6a393c3bf$var$setAriaAtomic(element, atomic) {
    $437b23f6a393c3bf$var$toggleAriaAttribute(element, "atomic", atomic);
}
function $437b23f6a393c3bf$var$setAriaRelevant(element, relevant) {
    $437b23f6a393c3bf$var$toggleAriaAttribute(element, "relevant", relevant);
}
function $437b23f6a393c3bf$var$setAriaLevel(element, level) {
    $437b23f6a393c3bf$var$toggleAriaAttribute(element, "level", level);
}
function $437b23f6a393c3bf$var$setAriaDisabled(element, disabled) {
    $437b23f6a393c3bf$var$toggleAriaAttribute(element, "disabled", disabled);
}
function $437b23f6a393c3bf$var$setAriaHidden(element, hidden) {
    $437b23f6a393c3bf$var$toggleAriaAttribute(element, "hidden", hidden);
}
function $437b23f6a393c3bf$var$setAriaActiveDescendant(element, descendantId) {
    $437b23f6a393c3bf$var$toggleAriaAttribute(element, "activedescendant", descendantId);
}
function $437b23f6a393c3bf$var$setAriaExpanded(element, expanded) {
    $437b23f6a393c3bf$var$setAriaAttribute(element, "expanded", expanded);
}
function $437b23f6a393c3bf$var$removeAriaExpanded(element) {
    $437b23f6a393c3bf$var$removeAriaAttribute(element, "expanded");
}
function $437b23f6a393c3bf$var$setAriaSetSize(element, setsize) {
    $437b23f6a393c3bf$var$setAriaAttribute(element, "setsize", setsize);
}
function $437b23f6a393c3bf$var$setAriaPosInSet(element, position) {
    $437b23f6a393c3bf$var$setAriaAttribute(element, "posinset", position);
}
function $437b23f6a393c3bf$var$setAriaMultiSelectable(element, multiSelectable) {
    $437b23f6a393c3bf$var$setAriaAttribute(element, "multiselectable", multiSelectable);
}
function $437b23f6a393c3bf$var$setAriaRowCount(element, rowCount) {
    $437b23f6a393c3bf$var$setAriaAttribute(element, "rowcount", rowCount);
}
function $437b23f6a393c3bf$var$setAriaRowIndex(element, rowIndex) {
    $437b23f6a393c3bf$var$setAriaAttribute(element, "rowindex", rowIndex);
}
function $437b23f6a393c3bf$var$setAriaColCount(element, colCount) {
    $437b23f6a393c3bf$var$setAriaAttribute(element, "colcount", colCount);
}
function $437b23f6a393c3bf$var$setAriaColIndex(element, colIndex) {
    $437b23f6a393c3bf$var$setAriaAttribute(element, "colindex", colIndex);
}
function $437b23f6a393c3bf$var$setAriaColSpan(element, colSpan) {
    $437b23f6a393c3bf$var$setAriaAttribute(element, "colspan", colSpan);
}
function $437b23f6a393c3bf$var$setAriaSort(element, sort) {
    $437b23f6a393c3bf$var$setAriaAttribute(element, "sort", sort);
}
function $437b23f6a393c3bf$var$removeAriaSort(element) {
    $437b23f6a393c3bf$var$removeAriaAttribute(element, "sort");
}
function $437b23f6a393c3bf$var$setAriaSelected(element, selected) {
    $437b23f6a393c3bf$var$toggleAriaAttribute(element, "selected", selected);
}
function $437b23f6a393c3bf$var$setAriaChecked(element, checked) {
    $437b23f6a393c3bf$var$setAriaAttribute(element, "checked", checked === void 0 ? "mixed" : checked);
}
function $437b23f6a393c3bf$var$setAriaControls(controllerElement, controlledElement) {
    $437b23f6a393c3bf$var$toggleAriaAttribute(controllerElement, "controls", controlledElement.id);
    $437b23f6a393c3bf$var$setAriaLabelledBy(controlledElement, controllerElement.id);
}
function $437b23f6a393c3bf$var$getAriaCheckboxStateName(translate, state) {
    return state === void 0 ? translate("ariaIndeterminate", "indeterminate") : state === true ? translate("ariaChecked", "checked") : translate("ariaUnchecked", "unchecked");
}
// community-modules/core/src/utils/browser.ts
var $437b23f6a393c3bf$var$browser_exports = {};
$437b23f6a393c3bf$var$__export($437b23f6a393c3bf$var$browser_exports, {
    browserSupportsPreventScroll: ()=>$437b23f6a393c3bf$var$browserSupportsPreventScroll,
    getBodyHeight: ()=>$437b23f6a393c3bf$var$getBodyHeight,
    getBodyWidth: ()=>$437b23f6a393c3bf$var$getBodyWidth,
    getMaxDivHeight: ()=>$437b23f6a393c3bf$var$getMaxDivHeight,
    getSafariVersion: ()=>$437b23f6a393c3bf$var$getSafariVersion,
    getScrollbarWidth: ()=>$437b23f6a393c3bf$var$getScrollbarWidth,
    getTabIndex: ()=>$437b23f6a393c3bf$var$getTabIndex,
    isBrowserChrome: ()=>$437b23f6a393c3bf$var$isBrowserChrome,
    isBrowserFirefox: ()=>$437b23f6a393c3bf$var$isBrowserFirefox,
    isBrowserSafari: ()=>$437b23f6a393c3bf$var$isBrowserSafari,
    isIOSUserAgent: ()=>$437b23f6a393c3bf$var$isIOSUserAgent,
    isInvisibleScrollbar: ()=>$437b23f6a393c3bf$var$isInvisibleScrollbar,
    isMacOsUserAgent: ()=>$437b23f6a393c3bf$var$isMacOsUserAgent
});
var $437b23f6a393c3bf$var$isSafari;
var $437b23f6a393c3bf$var$safariVersion;
var $437b23f6a393c3bf$var$isChrome;
var $437b23f6a393c3bf$var$isFirefox;
var $437b23f6a393c3bf$var$isMacOs;
var $437b23f6a393c3bf$var$isIOS;
var $437b23f6a393c3bf$var$invisibleScrollbar;
var $437b23f6a393c3bf$var$browserScrollbarWidth;
function $437b23f6a393c3bf$var$isBrowserSafari() {
    if ($437b23f6a393c3bf$var$isSafari === void 0) $437b23f6a393c3bf$var$isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    return $437b23f6a393c3bf$var$isSafari;
}
function $437b23f6a393c3bf$var$getSafariVersion() {
    if ($437b23f6a393c3bf$var$safariVersion === void 0) {
        if ($437b23f6a393c3bf$var$isBrowserSafari()) {
            const versionMatch = navigator.userAgent.match(/version\/(\d+)/i);
            if (versionMatch) $437b23f6a393c3bf$var$safariVersion = versionMatch[1] != null ? parseFloat(versionMatch[1]) : 0;
        } else $437b23f6a393c3bf$var$safariVersion = 0;
    }
    return $437b23f6a393c3bf$var$safariVersion;
}
function $437b23f6a393c3bf$var$isBrowserChrome() {
    if ($437b23f6a393c3bf$var$isChrome === void 0) {
        const win = window;
        $437b23f6a393c3bf$var$isChrome = !!win.chrome && (!!win.chrome.webstore || !!win.chrome.runtime) || /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    }
    return $437b23f6a393c3bf$var$isChrome;
}
function $437b23f6a393c3bf$var$isBrowserFirefox() {
    if ($437b23f6a393c3bf$var$isFirefox === void 0) $437b23f6a393c3bf$var$isFirefox = /(firefox)/i.test(navigator.userAgent);
    return $437b23f6a393c3bf$var$isFirefox;
}
function $437b23f6a393c3bf$var$isMacOsUserAgent() {
    if ($437b23f6a393c3bf$var$isMacOs === void 0) $437b23f6a393c3bf$var$isMacOs = /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
    return $437b23f6a393c3bf$var$isMacOs;
}
function $437b23f6a393c3bf$var$isIOSUserAgent() {
    if ($437b23f6a393c3bf$var$isIOS === void 0) $437b23f6a393c3bf$var$isIOS = /iPad|iPhone|iPod/.test(navigator.platform) || // eslint-disable-next-line
    navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
    return $437b23f6a393c3bf$var$isIOS;
}
function $437b23f6a393c3bf$var$browserSupportsPreventScroll() {
    return !$437b23f6a393c3bf$var$isBrowserSafari() || $437b23f6a393c3bf$var$getSafariVersion() >= 15;
}
function $437b23f6a393c3bf$var$getTabIndex(el) {
    if (!el) return null;
    const numberTabIndex = el.tabIndex;
    const tabIndex = el.getAttribute("tabIndex");
    if (numberTabIndex === -1 && (tabIndex === null || tabIndex === "" && !$437b23f6a393c3bf$var$isBrowserFirefox())) return null;
    return numberTabIndex.toString();
}
function $437b23f6a393c3bf$var$getMaxDivHeight() {
    if (!document.body) return -1;
    let res = 1e6;
    const testUpTo = navigator.userAgent.toLowerCase().match(/firefox/) ? 6e6 : 1e9;
    const div = document.createElement("div");
    document.body.appendChild(div);
    while(true){
        const test = res * 2;
        div.style.height = test + "px";
        if (test > testUpTo || div.clientHeight !== test) break;
        else res = test;
    }
    document.body.removeChild(div);
    return res;
}
function $437b23f6a393c3bf$var$getBodyWidth() {
    var _a, _b, _c;
    return (_c = (_a = document.body) == null ? void 0 : _a.clientWidth) != null ? _c : window.innerHeight || ((_b = document.documentElement) == null ? void 0 : _b.clientWidth) || -1;
}
function $437b23f6a393c3bf$var$getBodyHeight() {
    var _a, _b, _c;
    return (_c = (_a = document.body) == null ? void 0 : _a.clientHeight) != null ? _c : window.innerHeight || ((_b = document.documentElement) == null ? void 0 : _b.clientHeight) || -1;
}
function $437b23f6a393c3bf$var$getScrollbarWidth() {
    if ($437b23f6a393c3bf$var$browserScrollbarWidth == null) $437b23f6a393c3bf$var$initScrollbarWidthAndVisibility();
    return $437b23f6a393c3bf$var$browserScrollbarWidth;
}
function $437b23f6a393c3bf$var$initScrollbarWidthAndVisibility() {
    const body = document.body;
    const div = document.createElement("div");
    div.style.width = div.style.height = "100px";
    div.style.opacity = "0";
    div.style.overflow = "scroll";
    div.style.msOverflowStyle = "scrollbar";
    div.style.position = "absolute";
    body.appendChild(div);
    let width = div.offsetWidth - div.clientWidth;
    if (width === 0 && div.clientWidth === 0) width = null;
    if (div.parentNode) div.parentNode.removeChild(div);
    if (width != null) {
        $437b23f6a393c3bf$var$browserScrollbarWidth = width;
        $437b23f6a393c3bf$var$invisibleScrollbar = width === 0;
    }
}
function $437b23f6a393c3bf$var$isInvisibleScrollbar() {
    if ($437b23f6a393c3bf$var$invisibleScrollbar == null) $437b23f6a393c3bf$var$initScrollbarWidthAndVisibility();
    return $437b23f6a393c3bf$var$invisibleScrollbar;
}
// community-modules/core/src/utils/date.ts
var $437b23f6a393c3bf$var$date_exports = {};
$437b23f6a393c3bf$var$__export($437b23f6a393c3bf$var$date_exports, {
    dateToFormattedString: ()=>$437b23f6a393c3bf$var$dateToFormattedString,
    parseDateTimeFromString: ()=>$437b23f6a393c3bf$var$parseDateTimeFromString,
    serialiseDate: ()=>$437b23f6a393c3bf$var$serialiseDate
});
// community-modules/core/src/utils/number.ts
var $437b23f6a393c3bf$var$number_exports = {};
$437b23f6a393c3bf$var$__export($437b23f6a393c3bf$var$number_exports, {
    cleanNumber: ()=>$437b23f6a393c3bf$var$cleanNumber,
    createArrayOfNumbers: ()=>$437b23f6a393c3bf$var$createArrayOfNumbers,
    decToHex: ()=>$437b23f6a393c3bf$var$decToHex,
    formatNumberCommas: ()=>$437b23f6a393c3bf$var$formatNumberCommas,
    formatNumberTwoDecimalPlacesAndCommas: ()=>$437b23f6a393c3bf$var$formatNumberTwoDecimalPlacesAndCommas,
    padStartWidthZeros: ()=>$437b23f6a393c3bf$var$padStartWidthZeros,
    sum: ()=>$437b23f6a393c3bf$var$sum
});
function $437b23f6a393c3bf$var$padStartWidthZeros(value, totalStringSize) {
    return value.toString().padStart(totalStringSize, "0");
}
function $437b23f6a393c3bf$var$createArrayOfNumbers(first, last2) {
    const result = [];
    for(let i = first; i <= last2; i++)result.push(i);
    return result;
}
function $437b23f6a393c3bf$var$cleanNumber(value) {
    if (typeof value === "string") value = parseInt(value, 10);
    if (typeof value === "number") return Math.floor(value);
    return null;
}
function $437b23f6a393c3bf$var$decToHex(number, bytes) {
    let hex = "";
    for(let i = 0; i < bytes; i++){
        hex += String.fromCharCode(number & 255);
        number >>>= 8;
    }
    return hex;
}
function $437b23f6a393c3bf$var$formatNumberTwoDecimalPlacesAndCommas(value, thousandSeparator, decimalSeparator) {
    if (typeof value !== "number") return "";
    return $437b23f6a393c3bf$var$formatNumberCommas(Math.round(value * 100) / 100, thousandSeparator, decimalSeparator);
}
function $437b23f6a393c3bf$var$formatNumberCommas(value, thousandSeparator, decimalSeparator) {
    if (typeof value !== "number") return "";
    return value.toString().replace(".", decimalSeparator).replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousandSeparator}`);
}
function $437b23f6a393c3bf$var$sum(values2) {
    return values2 == null ? null : values2.reduce((total, value)=>total + value, 0);
}
// community-modules/core/src/utils/date.ts
function $437b23f6a393c3bf$var$serialiseDate(date, includeTime = true, separator = "-") {
    if (!date) return null;
    let serialised = [
        date.getFullYear(),
        date.getMonth() + 1,
        date.getDate()
    ].map((part)=>$437b23f6a393c3bf$var$padStartWidthZeros(part, 2)).join(separator);
    if (includeTime) serialised += " " + [
        date.getHours(),
        date.getMinutes(),
        date.getSeconds()
    ].map((part)=>$437b23f6a393c3bf$var$padStartWidthZeros(part, 2)).join(":");
    return serialised;
}
var $437b23f6a393c3bf$var$calculateOrdinal = (value)=>{
    if (value > 3 && value < 21) return "th";
    const remainder = value % 10;
    switch(remainder){
        case 1:
            return "st";
        case 2:
            return "nd";
        case 3:
            return "rd";
    }
    return "th";
};
function $437b23f6a393c3bf$var$dateToFormattedString(date, format = "YYYY-MM-DD") {
    const fullYear = $437b23f6a393c3bf$var$padStartWidthZeros(date.getFullYear(), 4);
    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ];
    const days = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ];
    const replace = {
        YYYY: ()=>fullYear.slice(fullYear.length - 4, fullYear.length),
        YY: ()=>fullYear.slice(fullYear.length - 2, fullYear.length),
        Y: ()=>`${date.getFullYear()}`,
        MMMM: ()=>months[date.getMonth()],
        MMM: ()=>months[date.getMonth()].slice(0, 3),
        MM: ()=>$437b23f6a393c3bf$var$padStartWidthZeros(date.getMonth() + 1, 2),
        Mo: ()=>`${date.getMonth() + 1}${$437b23f6a393c3bf$var$calculateOrdinal(date.getMonth() + 1)}`,
        M: ()=>`${date.getMonth() + 1}`,
        Do: ()=>`${date.getDate()}${$437b23f6a393c3bf$var$calculateOrdinal(date.getDate())}`,
        DD: ()=>$437b23f6a393c3bf$var$padStartWidthZeros(date.getDate(), 2),
        D: ()=>`${date.getDate()}`,
        dddd: ()=>days[date.getDay()],
        ddd: ()=>days[date.getDay()].slice(0, 3),
        dd: ()=>days[date.getDay()].slice(0, 2),
        do: ()=>`${date.getDay()}${$437b23f6a393c3bf$var$calculateOrdinal(date.getDay())}`,
        d: ()=>`${date.getDay()}`
    };
    const regexp = new RegExp(Object.keys(replace).join("|"), "g");
    return format.replace(regexp, (match)=>{
        if (match in replace) return replace[match]();
        return match;
    });
}
function $437b23f6a393c3bf$var$parseDateTimeFromString(value) {
    if (!value) return null;
    const [dateStr, timeStr] = value.split(" ");
    if (!dateStr) return null;
    const fields = dateStr.split("-").map((f)=>parseInt(f, 10));
    if (fields.filter((f)=>!isNaN(f)).length !== 3) return null;
    const [year, month, day] = fields;
    const date = new Date(year, month - 1, day);
    if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day) return null;
    if (!timeStr || timeStr === "00:00:00") return date;
    const [hours, minutes, seconds] = timeStr.split(":").map((part)=>parseInt(part, 10));
    if (hours >= 0 && hours < 24) date.setHours(hours);
    if (minutes >= 0 && minutes < 60) date.setMinutes(minutes);
    if (seconds >= 0 && seconds < 60) date.setSeconds(seconds);
    return date;
}
// community-modules/core/src/utils/dom.ts
var $437b23f6a393c3bf$var$dom_exports = {};
$437b23f6a393c3bf$var$__export($437b23f6a393c3bf$var$dom_exports, {
    FOCUSABLE_EXCLUDE: ()=>$437b23f6a393c3bf$var$FOCUSABLE_EXCLUDE,
    FOCUSABLE_SELECTOR: ()=>$437b23f6a393c3bf$var$FOCUSABLE_SELECTOR,
    addOrRemoveAttribute: ()=>$437b23f6a393c3bf$var$addOrRemoveAttribute,
    addStylesToElement: ()=>$437b23f6a393c3bf$var$addStylesToElement,
    bindCellRendererToHtmlElement: ()=>$437b23f6a393c3bf$var$bindCellRendererToHtmlElement,
    clearElement: ()=>$437b23f6a393c3bf$var$clearElement,
    copyNodeList: ()=>$437b23f6a393c3bf$var$copyNodeList,
    ensureDomOrder: ()=>$437b23f6a393c3bf$var$ensureDomOrder,
    formatSize: ()=>$437b23f6a393c3bf$var$formatSize,
    getAbsoluteHeight: ()=>$437b23f6a393c3bf$var$getAbsoluteHeight,
    getAbsoluteWidth: ()=>$437b23f6a393c3bf$var$getAbsoluteWidth,
    getElementRectWithOffset: ()=>$437b23f6a393c3bf$var$getElementRectWithOffset,
    getElementSize: ()=>$437b23f6a393c3bf$var$getElementSize,
    getInnerHeight: ()=>$437b23f6a393c3bf$var$getInnerHeight,
    getInnerWidth: ()=>$437b23f6a393c3bf$var$getInnerWidth,
    getScrollLeft: ()=>$437b23f6a393c3bf$var$getScrollLeft,
    insertWithDomOrder: ()=>$437b23f6a393c3bf$var$insertWithDomOrder,
    isElementChildOfClass: ()=>$437b23f6a393c3bf$var$isElementChildOfClass,
    isFocusableFormField: ()=>$437b23f6a393c3bf$var$isFocusableFormField,
    isHorizontalScrollShowing: ()=>$437b23f6a393c3bf$var$isHorizontalScrollShowing,
    isInDOM: ()=>$437b23f6a393c3bf$var$isInDOM,
    isNodeOrElement: ()=>$437b23f6a393c3bf$var$isNodeOrElement,
    isRtlNegativeScroll: ()=>$437b23f6a393c3bf$var$isRtlNegativeScroll,
    isVerticalScrollShowing: ()=>$437b23f6a393c3bf$var$isVerticalScrollShowing,
    isVisible: ()=>$437b23f6a393c3bf$var$isVisible,
    iterateNamedNodeMap: ()=>$437b23f6a393c3bf$var$iterateNamedNodeMap,
    loadTemplate: ()=>$437b23f6a393c3bf$var$loadTemplate,
    nodeListForEach: ()=>$437b23f6a393c3bf$var$nodeListForEach,
    radioCssClass: ()=>$437b23f6a393c3bf$var$radioCssClass,
    removeFromParent: ()=>$437b23f6a393c3bf$var$removeFromParent,
    setDisabled: ()=>$437b23f6a393c3bf$var$setDisabled,
    setDisplayed: ()=>$437b23f6a393c3bf$var$setDisplayed,
    setDomChildOrder: ()=>$437b23f6a393c3bf$var$setDomChildOrder,
    setElementHeight: ()=>$437b23f6a393c3bf$var$setElementHeight,
    setElementWidth: ()=>$437b23f6a393c3bf$var$setElementWidth,
    setFixedHeight: ()=>$437b23f6a393c3bf$var$setFixedHeight,
    setFixedWidth: ()=>$437b23f6a393c3bf$var$setFixedWidth,
    setScrollLeft: ()=>$437b23f6a393c3bf$var$setScrollLeft,
    setVisible: ()=>$437b23f6a393c3bf$var$setVisible
});
var $437b23f6a393c3bf$var$rtlNegativeScroll;
function $437b23f6a393c3bf$var$radioCssClass(element, elementClass, otherElementClass) {
    const parent = element.parentElement;
    let sibling = parent && parent.firstChild;
    while(sibling){
        if (elementClass) sibling.classList.toggle(elementClass, sibling === element);
        if (otherElementClass) sibling.classList.toggle(otherElementClass, sibling !== element);
        sibling = sibling.nextSibling;
    }
}
var $437b23f6a393c3bf$var$FOCUSABLE_SELECTOR = "[tabindex], input, select, button, textarea, [href]";
var $437b23f6a393c3bf$var$FOCUSABLE_EXCLUDE = "[disabled], .ag-disabled:not(.ag-button), .ag-disabled *";
function $437b23f6a393c3bf$var$isFocusableFormField(element) {
    const matches = Element.prototype.matches || Element.prototype.msMatchesSelector;
    const inputSelector = "input, select, button, textarea";
    const isFocusable = matches.call(element, inputSelector);
    const isNotFocusable = matches.call(element, $437b23f6a393c3bf$var$FOCUSABLE_EXCLUDE);
    const isElementVisible = $437b23f6a393c3bf$var$isVisible(element);
    const focusable = isFocusable && !isNotFocusable && isElementVisible;
    return focusable;
}
function $437b23f6a393c3bf$var$setDisplayed(element, displayed, options = {}) {
    const { skipAriaHidden: skipAriaHidden } = options;
    element.classList.toggle("ag-hidden", !displayed);
    if (!skipAriaHidden) $437b23f6a393c3bf$var$setAriaHidden(element, !displayed);
}
function $437b23f6a393c3bf$var$setVisible(element, visible, options = {}) {
    const { skipAriaHidden: skipAriaHidden } = options;
    element.classList.toggle("ag-invisible", !visible);
    if (!skipAriaHidden) $437b23f6a393c3bf$var$setAriaHidden(element, !visible);
}
function $437b23f6a393c3bf$var$setDisabled(element, disabled) {
    const attributeName = "disabled";
    const addOrRemoveDisabledAttribute = disabled ? (e)=>e.setAttribute(attributeName, "") : (e)=>e.removeAttribute(attributeName);
    addOrRemoveDisabledAttribute(element);
    $437b23f6a393c3bf$var$nodeListForEach(element.querySelectorAll("input"), (input)=>addOrRemoveDisabledAttribute(input));
}
function $437b23f6a393c3bf$var$isElementChildOfClass(element, cls, maxNest) {
    let counter = 0;
    while(element){
        if (element.classList.contains(cls)) return true;
        element = element.parentElement;
        if (typeof maxNest == "number") {
            if (++counter > maxNest) break;
        } else if (element === maxNest) break;
    }
    return false;
}
function $437b23f6a393c3bf$var$getElementSize(el) {
    const { height: height, width: width, borderTopWidth: borderTopWidth, borderRightWidth: borderRightWidth, borderBottomWidth: borderBottomWidth, borderLeftWidth: borderLeftWidth, paddingTop: paddingTop, paddingRight: paddingRight, paddingBottom: paddingBottom, paddingLeft: paddingLeft, marginTop: marginTop, marginRight: marginRight, marginBottom: marginBottom, marginLeft: marginLeft, boxSizing: boxSizing } = window.getComputedStyle(el);
    return {
        height: parseFloat(height || "0"),
        width: parseFloat(width || "0"),
        borderTopWidth: parseFloat(borderTopWidth || "0"),
        borderRightWidth: parseFloat(borderRightWidth || "0"),
        borderBottomWidth: parseFloat(borderBottomWidth || "0"),
        borderLeftWidth: parseFloat(borderLeftWidth || "0"),
        paddingTop: parseFloat(paddingTop || "0"),
        paddingRight: parseFloat(paddingRight || "0"),
        paddingBottom: parseFloat(paddingBottom || "0"),
        paddingLeft: parseFloat(paddingLeft || "0"),
        marginTop: parseFloat(marginTop || "0"),
        marginRight: parseFloat(marginRight || "0"),
        marginBottom: parseFloat(marginBottom || "0"),
        marginLeft: parseFloat(marginLeft || "0"),
        boxSizing: boxSizing
    };
}
function $437b23f6a393c3bf$var$getInnerHeight(el) {
    const size = $437b23f6a393c3bf$var$getElementSize(el);
    if (size.boxSizing === "border-box") return size.height - size.paddingTop - size.paddingBottom;
    return size.height;
}
function $437b23f6a393c3bf$var$getInnerWidth(el) {
    const size = $437b23f6a393c3bf$var$getElementSize(el);
    if (size.boxSizing === "border-box") return size.width - size.paddingLeft - size.paddingRight;
    return size.width;
}
function $437b23f6a393c3bf$var$getAbsoluteHeight(el) {
    const size = $437b23f6a393c3bf$var$getElementSize(el);
    const marginRight = size.marginBottom + size.marginTop;
    return Math.ceil(el.offsetHeight + marginRight);
}
function $437b23f6a393c3bf$var$getAbsoluteWidth(el) {
    const size = $437b23f6a393c3bf$var$getElementSize(el);
    const marginWidth = size.marginLeft + size.marginRight;
    return Math.ceil(el.offsetWidth + marginWidth);
}
function $437b23f6a393c3bf$var$getElementRectWithOffset(el) {
    const offsetElementRect = el.getBoundingClientRect();
    const { borderTopWidth: borderTopWidth, borderLeftWidth: borderLeftWidth, borderRightWidth: borderRightWidth, borderBottomWidth: borderBottomWidth } = $437b23f6a393c3bf$var$getElementSize(el);
    return {
        top: offsetElementRect.top + (borderTopWidth || 0),
        left: offsetElementRect.left + (borderLeftWidth || 0),
        right: offsetElementRect.right + (borderRightWidth || 0),
        bottom: offsetElementRect.bottom + (borderBottomWidth || 0)
    };
}
function $437b23f6a393c3bf$var$isRtlNegativeScroll() {
    if (typeof $437b23f6a393c3bf$var$rtlNegativeScroll === "boolean") return $437b23f6a393c3bf$var$rtlNegativeScroll;
    const template = document.createElement("div");
    template.style.direction = "rtl";
    template.style.width = "1px";
    template.style.height = "1px";
    template.style.position = "fixed";
    template.style.top = "0px";
    template.style.overflow = "hidden";
    template.dir = "rtl";
    template.innerHTML = /* html */ `<div style="width: 2px">
            <span style="display: inline-block; width: 1px"></span>
            <span style="display: inline-block; width: 1px"></span>
        </div>`;
    document.body.appendChild(template);
    template.scrollLeft = 1;
    $437b23f6a393c3bf$var$rtlNegativeScroll = Math.floor(template.scrollLeft) === 0;
    document.body.removeChild(template);
    return $437b23f6a393c3bf$var$rtlNegativeScroll;
}
function $437b23f6a393c3bf$var$getScrollLeft(element, rtl) {
    let scrollLeft = element.scrollLeft;
    if (rtl) {
        scrollLeft = Math.abs(scrollLeft);
        if ($437b23f6a393c3bf$var$isBrowserChrome() && !$437b23f6a393c3bf$var$isRtlNegativeScroll()) scrollLeft = element.scrollWidth - element.clientWidth - scrollLeft;
    }
    return scrollLeft;
}
function $437b23f6a393c3bf$var$setScrollLeft(element, value, rtl) {
    if (rtl) {
        if ($437b23f6a393c3bf$var$isRtlNegativeScroll()) value *= -1;
        else if ($437b23f6a393c3bf$var$isBrowserSafari() || $437b23f6a393c3bf$var$isBrowserChrome()) value = element.scrollWidth - element.clientWidth - value;
    }
    element.scrollLeft = value;
}
function $437b23f6a393c3bf$var$clearElement(el) {
    while(el && el.firstChild)el.removeChild(el.firstChild);
}
function $437b23f6a393c3bf$var$removeFromParent(node) {
    if (node && node.parentNode) node.parentNode.removeChild(node);
}
function $437b23f6a393c3bf$var$isInDOM(element) {
    return !!element.offsetParent;
}
function $437b23f6a393c3bf$var$isVisible(element) {
    const el = element;
    if (el.checkVisibility) return el.checkVisibility({
        checkVisibilityCSS: true
    });
    const isHidden = !$437b23f6a393c3bf$var$isInDOM(element) || window.getComputedStyle(element).visibility !== "visible";
    return !isHidden;
}
function $437b23f6a393c3bf$var$loadTemplate(template) {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = (template || "").trim();
    return tempDiv.firstChild;
}
function $437b23f6a393c3bf$var$ensureDomOrder(eContainer, eChild, eChildBefore) {
    if (eChildBefore && eChildBefore.nextSibling === eChild) return;
    if (eChildBefore) {
        if (eChildBefore.nextSibling) eContainer.insertBefore(eChild, eChildBefore.nextSibling);
        else eContainer.appendChild(eChild);
    } else if (eContainer.firstChild && eContainer.firstChild !== eChild) eContainer.insertAdjacentElement("afterbegin", eChild);
}
function $437b23f6a393c3bf$var$setDomChildOrder(eContainer, orderedChildren) {
    for(let i = 0; i < orderedChildren.length; i++){
        const correctCellAtIndex = orderedChildren[i];
        const actualCellAtIndex = eContainer.children[i];
        if (actualCellAtIndex !== correctCellAtIndex) eContainer.insertBefore(correctCellAtIndex, actualCellAtIndex);
    }
}
function $437b23f6a393c3bf$var$insertWithDomOrder(eContainer, eToInsert, eChildBefore) {
    if (eChildBefore) eChildBefore.insertAdjacentElement("afterend", eToInsert);
    else if (eContainer.firstChild) eContainer.insertAdjacentElement("afterbegin", eToInsert);
    else eContainer.appendChild(eToInsert);
}
function $437b23f6a393c3bf$var$addStylesToElement(eElement, styles) {
    if (!styles) return;
    for (const [key, value] of Object.entries(styles)){
        if (!key || !key.length || value == null) continue;
        const parsedKey = $437b23f6a393c3bf$var$camelCaseToHyphenated(key);
        const valueAsString = value.toString();
        const parsedValue = valueAsString.replace(/\s*!important/g, "");
        const priority = parsedValue.length != valueAsString.length ? "important" : void 0;
        eElement.style.setProperty(parsedKey, parsedValue, priority);
    }
}
function $437b23f6a393c3bf$var$isHorizontalScrollShowing(element) {
    return element.clientWidth < element.scrollWidth;
}
function $437b23f6a393c3bf$var$isVerticalScrollShowing(element) {
    return element.clientHeight < element.scrollHeight;
}
function $437b23f6a393c3bf$var$setElementWidth(element, width) {
    if (width === "flex") {
        element.style.removeProperty("width");
        element.style.removeProperty("minWidth");
        element.style.removeProperty("maxWidth");
        element.style.flex = "1 1 auto";
    } else $437b23f6a393c3bf$var$setFixedWidth(element, width);
}
function $437b23f6a393c3bf$var$setFixedWidth(element, width) {
    width = $437b23f6a393c3bf$var$formatSize(width);
    element.style.width = width.toString();
    element.style.maxWidth = width.toString();
    element.style.minWidth = width.toString();
}
function $437b23f6a393c3bf$var$setElementHeight(element, height) {
    if (height === "flex") {
        element.style.removeProperty("height");
        element.style.removeProperty("minHeight");
        element.style.removeProperty("maxHeight");
        element.style.flex = "1 1 auto";
    } else $437b23f6a393c3bf$var$setFixedHeight(element, height);
}
function $437b23f6a393c3bf$var$setFixedHeight(element, height) {
    height = $437b23f6a393c3bf$var$formatSize(height);
    element.style.height = height.toString();
    element.style.maxHeight = height.toString();
    element.style.minHeight = height.toString();
}
function $437b23f6a393c3bf$var$formatSize(size) {
    if (typeof size === "number") return `${size}px`;
    return size;
}
function $437b23f6a393c3bf$var$isNodeOrElement(o) {
    return o instanceof Node || o instanceof HTMLElement;
}
function $437b23f6a393c3bf$var$copyNodeList(nodeList) {
    if (nodeList == null) return [];
    const result = [];
    $437b23f6a393c3bf$var$nodeListForEach(nodeList, (node)=>result.push(node));
    return result;
}
function $437b23f6a393c3bf$var$iterateNamedNodeMap(map, callback) {
    if (!map) return;
    for(let i = 0; i < map.length; i++){
        const attr = map[i];
        callback(attr.name, attr.value);
    }
}
function $437b23f6a393c3bf$var$addOrRemoveAttribute(element, name, value) {
    if (value == null) element.removeAttribute(name);
    else element.setAttribute(name, value.toString());
}
function $437b23f6a393c3bf$var$nodeListForEach(nodeList, action) {
    if (nodeList == null) return;
    for(let i = 0; i < nodeList.length; i++)action(nodeList[i]);
}
function $437b23f6a393c3bf$var$bindCellRendererToHtmlElement(cellRendererPromise, eTarget) {
    cellRendererPromise.then((cellRenderer)=>{
        const gui = cellRenderer.getGui();
        if (gui != null) {
            if (typeof gui === "object") eTarget.appendChild(gui);
            else eTarget.innerHTML = gui;
        }
    });
}
// community-modules/core/src/utils/fuzzyMatch.ts
var $437b23f6a393c3bf$var$fuzzyMatch_exports = {};
$437b23f6a393c3bf$var$__export($437b23f6a393c3bf$var$fuzzyMatch_exports, {
    fuzzyCheckStrings: ()=>$437b23f6a393c3bf$var$fuzzyCheckStrings,
    fuzzySuggestions: ()=>$437b23f6a393c3bf$var$fuzzySuggestions
});
function $437b23f6a393c3bf$var$fuzzyCheckStrings(inputValues, validValues, allSuggestions) {
    const fuzzyMatches = {};
    const invalidInputs = inputValues.filter((inputValue)=>!validValues.some((validValue)=>validValue === inputValue));
    if (invalidInputs.length > 0) invalidInputs.forEach((invalidInput)=>fuzzyMatches[invalidInput] = $437b23f6a393c3bf$var$fuzzySuggestions(invalidInput, allSuggestions).values);
    return fuzzyMatches;
}
function $437b23f6a393c3bf$var$fuzzySuggestions(inputValue, allSuggestions, hideIrrelevant, filterByPercentageOfBestMatch) {
    let thisSuggestions = allSuggestions.map((text, idx)=>({
            value: text,
            relevance: $437b23f6a393c3bf$var$stringWeightedDistances(inputValue.toLowerCase(), text.toLocaleLowerCase()),
            idx: idx
        }));
    thisSuggestions.sort((a, b)=>b.relevance - a.relevance);
    if (hideIrrelevant) thisSuggestions = thisSuggestions.filter((suggestion)=>suggestion.relevance !== 0);
    if (thisSuggestions.length > 0 && filterByPercentageOfBestMatch && filterByPercentageOfBestMatch > 0) {
        const bestMatch = thisSuggestions[0].relevance;
        const limit = bestMatch * filterByPercentageOfBestMatch;
        thisSuggestions = thisSuggestions.filter((suggestion)=>limit - suggestion.relevance < 0);
    }
    const values2 = [];
    const indices = [];
    for (const suggestion of thisSuggestions){
        values2.push(suggestion.value);
        indices.push(suggestion.idx);
    }
    return {
        values: values2,
        indices: indices
    };
}
function $437b23f6a393c3bf$var$stringWeightedDistances(str1, str2) {
    const a = str1.replace(/\s/g, "");
    const b = str2.replace(/\s/g, "");
    let weight = 0;
    let lastIndex = -1;
    for(let i = 0; i < a.length; i++){
        const idx = b.indexOf(a[i], lastIndex + 1);
        if (idx === -1) continue;
        lastIndex = idx;
        weight += 100 - lastIndex * 100 / 1e4 * 100;
    }
    return weight;
}
// community-modules/core/src/utils/icon.ts
var $437b23f6a393c3bf$var$icon_exports = {};
$437b23f6a393c3bf$var$__export($437b23f6a393c3bf$var$icon_exports, {
    createIcon: ()=>$437b23f6a393c3bf$var$createIcon,
    createIconNoSpan: ()=>$437b23f6a393c3bf$var$createIconNoSpan,
    iconNameClassMap: ()=>$437b23f6a393c3bf$var$iconNameClassMap
});
var $437b23f6a393c3bf$var$iconNameClassMap = {
    // header column group shown when expanded (click to contract)
    columnGroupOpened: "expanded",
    // header column group shown when contracted (click to expand)
    columnGroupClosed: "contracted",
    // tool panel column group contracted (click to expand)
    columnSelectClosed: "tree-closed",
    // tool panel column group expanded (click to contract)
    columnSelectOpen: "tree-open",
    // column tool panel header expand/collapse all button, shown when some children are expanded and
    //     others are collapsed
    columnSelectIndeterminate: "tree-indeterminate",
    // shown on ghost icon while dragging column to the side of the grid to pin
    columnMovePin: "pin",
    // shown on ghost icon while dragging over part of the page that is not a drop zone
    columnMoveHide: "eye-slash",
    // shown on ghost icon while dragging columns to reorder
    columnMoveMove: "arrows",
    // animating icon shown when dragging a column to the right of the grid causes horizontal scrolling
    columnMoveLeft: "left",
    // animating icon shown when dragging a column to the left of the grid causes horizontal scrolling
    columnMoveRight: "right",
    // shown on ghost icon while dragging over Row Groups drop zone
    columnMoveGroup: "group",
    // shown on ghost icon while dragging over Values drop zone
    columnMoveValue: "aggregation",
    // shown on ghost icon while dragging over pivot drop zone
    columnMovePivot: "pivot",
    // shown on ghost icon while dragging over drop zone that doesn't support it, e.g.
    //     string column over aggregation drop zone
    dropNotAllowed: "not-allowed",
    // shown on row group when contracted (click to expand)
    groupContracted: "tree-closed",
    // shown on row group when expanded (click to contract)
    groupExpanded: "tree-open",
    // set filter tree list group contracted (click to expand)
    setFilterGroupClosed: "tree-closed",
    // set filter tree list group expanded (click to contract)
    setFilterGroupOpen: "tree-open",
    // set filter tree list expand/collapse all button, shown when some children are expanded and
    //     others are collapsed
    setFilterGroupIndeterminate: "tree-indeterminate",
    // context menu chart item
    chart: "chart",
    // chart window title bar
    close: "cross",
    // X (remove) on column 'pill' after adding it to a drop zone list
    cancel: "cancel",
    // indicates the currently active pin state in the "Pin column" sub-menu of the column menu
    check: "tick",
    // "go to first" button in pagination controls
    first: "first",
    // "go to previous" button in pagination controls
    previous: "previous",
    // "go to next" button in pagination controls
    next: "next",
    // "go to last" button in pagination controls
    last: "last",
    // shown on top right of chart when chart is linked to range data (click to unlink)
    linked: "linked",
    // shown on top right of chart when chart is not linked to range data (click to link)
    unlinked: "unlinked",
    // "Choose colour" button on chart settings tab
    colorPicker: "color-picker",
    // rotating spinner shown by the loading cell renderer
    groupLoading: "loading",
    // button to launch enterprise column menu
    menu: "menu",
    menuAlt: "menu-alt",
    // filter tool panel tab
    filter: "filter",
    // column tool panel tab
    columns: "columns",
    // button in chart regular size window title bar (click to maximise)
    maximize: "maximize",
    // button in chart maximised window title bar (click to make regular size)
    minimize: "minimize",
    // "Pin column" item in column header menu
    menuPin: "pin",
    // "Value aggregation" column menu item (shown on numeric columns when grouping is active)"
    menuValue: "aggregation",
    // "Group by {column-name}" item in column header menu
    menuAddRowGroup: "group",
    // "Un-Group by {column-name}" item in column header menu
    menuRemoveRowGroup: "group",
    // context menu copy item
    clipboardCopy: "copy",
    // context menu cut item
    clipboardCut: "cut",
    // context menu paste item
    clipboardPaste: "paste",
    // identifies the pivot drop zone
    pivotPanel: "pivot",
    // "Row groups" drop zone in column tool panel
    rowGroupPanel: "group",
    // columns tool panel Values drop zone
    valuePanel: "aggregation",
    // drag handle used to pick up draggable columns
    columnDrag: "grip",
    // drag handle used to pick up draggable rows
    rowDrag: "grip",
    // context menu export item
    save: "save",
    // csv export
    csvExport: "csv",
    // excel export,
    excelExport: "excel",
    // icon on dropdown editors
    smallDown: "small-down",
    // version of small-right used in RTL mode
    smallLeft: "small-left",
    // separater between column 'pills' when you add multiple columns to the header drop zone
    smallRight: "small-right",
    smallUp: "small-up",
    // show on column header when column is sorted ascending
    sortAscending: "asc",
    // show on column header when column is sorted descending
    sortDescending: "desc",
    // show on column header when column has no sort, only when enabled with gridOptions.unSortIcon=true
    sortUnSort: "none",
    // Builder button in Advanced Filter
    advancedFilterBuilder: "group",
    // drag handle used to pick up Advanced Filter Builder rows
    advancedFilterBuilderDrag: "grip",
    // Advanced Filter Builder row validation error
    advancedFilterBuilderInvalid: "not-allowed",
    // shown on Advanced Filter Builder rows to move them up
    advancedFilterBuilderMoveUp: "up",
    // shown on Advanced Filter Builder rows to move them down
    advancedFilterBuilderMoveDown: "down",
    // shown on Advanced Filter Builder rows to add new rows
    advancedFilterBuilderAdd: "plus",
    // shown on Advanced Filter Builder rows to remove row
    advancedFilterBuilderRemove: "minus",
    // Edit Chart menu item shown in Integrated Charts menu
    chartsMenuEdit: "chart",
    // Advanced Settings menu item shown in Integrated Charts menu
    chartsMenuAdvancedSettings: "settings",
    // shown in Integrated Charts menu add fields
    chartsMenuAdd: "plus"
};
function $437b23f6a393c3bf$var$createIcon(iconName, gos, column) {
    const iconContents = $437b23f6a393c3bf$var$createIconNoSpan(iconName, gos, column);
    if (iconContents) {
        const { className: className } = iconContents;
        if (typeof className === "string" && className.indexOf("ag-icon") > -1 || typeof className === "object" && className["ag-icon"]) return iconContents;
    }
    const eResult = document.createElement("span");
    eResult.appendChild(iconContents);
    return eResult;
}
function $437b23f6a393c3bf$var$createIconNoSpan(iconName, gos, column, forceCreate) {
    let userProvidedIcon = null;
    const icons = column && column.getColDef().icons;
    if (icons) userProvidedIcon = icons[iconName];
    if (gos && !userProvidedIcon) {
        const optionsIcons = gos.get("icons");
        if (optionsIcons) userProvidedIcon = optionsIcons[iconName];
    }
    if (userProvidedIcon) {
        let rendererResult;
        if (typeof userProvidedIcon === "function") rendererResult = userProvidedIcon();
        else if (typeof userProvidedIcon === "string") rendererResult = userProvidedIcon;
        else throw new Error("icon from grid options needs to be a string or a function");
        if (typeof rendererResult === "string") return $437b23f6a393c3bf$var$loadTemplate(rendererResult);
        if ($437b23f6a393c3bf$var$isNodeOrElement(rendererResult)) return rendererResult;
        console.warn("AG Grid: iconRenderer should return back a string or a dom object");
    } else {
        const span = document.createElement("span");
        let cssClass = $437b23f6a393c3bf$var$iconNameClassMap[iconName];
        if (!cssClass) {
            if (!forceCreate) {
                console.warn(`AG Grid: Did not find icon ${iconName}`);
                cssClass = "";
            } else cssClass = iconName;
        }
        span.setAttribute("class", `ag-icon ag-icon-${cssClass}`);
        span.setAttribute("unselectable", "on");
        $437b23f6a393c3bf$var$setAriaRole(span, "presentation");
        return span;
    }
}
// community-modules/core/src/utils/keyboard.ts
var $437b23f6a393c3bf$var$keyboard_exports = {};
$437b23f6a393c3bf$var$__export($437b23f6a393c3bf$var$keyboard_exports, {
    isDeleteKey: ()=>$437b23f6a393c3bf$var$isDeleteKey,
    isEventFromPrintableCharacter: ()=>$437b23f6a393c3bf$var$isEventFromPrintableCharacter,
    isUserSuppressingHeaderKeyboardEvent: ()=>$437b23f6a393c3bf$var$isUserSuppressingHeaderKeyboardEvent,
    isUserSuppressingKeyboardEvent: ()=>$437b23f6a393c3bf$var$isUserSuppressingKeyboardEvent,
    normaliseQwertyAzerty: ()=>$437b23f6a393c3bf$var$normaliseQwertyAzerty
});
// community-modules/core/src/constants/keyCode.ts
var $437b23f6a393c3bf$export$e9e0d96f49f57c33 = class {
};
$437b23f6a393c3bf$export$e9e0d96f49f57c33.BACKSPACE = "Backspace";
$437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB = "Tab";
$437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER = "Enter";
$437b23f6a393c3bf$export$e9e0d96f49f57c33.ESCAPE = "Escape";
$437b23f6a393c3bf$export$e9e0d96f49f57c33.SPACE = " ";
$437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT = "ArrowLeft";
$437b23f6a393c3bf$export$e9e0d96f49f57c33.UP = "ArrowUp";
$437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT = "ArrowRight";
$437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN = "ArrowDown";
$437b23f6a393c3bf$export$e9e0d96f49f57c33.DELETE = "Delete";
$437b23f6a393c3bf$export$e9e0d96f49f57c33.F2 = "F2";
$437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_UP = "PageUp";
$437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_DOWN = "PageDown";
$437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_HOME = "Home";
$437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_END = "End";
// these should be used with `event.code` instead of `event.key`
// as `event.key` changes when non-latin keyboards are used
$437b23f6a393c3bf$export$e9e0d96f49f57c33.A = "KeyA";
$437b23f6a393c3bf$export$e9e0d96f49f57c33.C = "KeyC";
$437b23f6a393c3bf$export$e9e0d96f49f57c33.D = "KeyD";
$437b23f6a393c3bf$export$e9e0d96f49f57c33.V = "KeyV";
$437b23f6a393c3bf$export$e9e0d96f49f57c33.X = "KeyX";
$437b23f6a393c3bf$export$e9e0d96f49f57c33.Y = "KeyY";
$437b23f6a393c3bf$export$e9e0d96f49f57c33.Z = "KeyZ";
// community-modules/core/src/utils/keyboard.ts
var $437b23f6a393c3bf$var$A_KEYCODE = 65;
var $437b23f6a393c3bf$var$C_KEYCODE = 67;
var $437b23f6a393c3bf$var$V_KEYCODE = 86;
var $437b23f6a393c3bf$var$D_KEYCODE = 68;
var $437b23f6a393c3bf$var$Z_KEYCODE = 90;
var $437b23f6a393c3bf$var$Y_KEYCODE = 89;
function $437b23f6a393c3bf$var$isEventFromPrintableCharacter(event) {
    if (event.altKey || event.ctrlKey || event.metaKey) return false;
    const printableCharacter = event.key.length === 1;
    return printableCharacter;
}
function $437b23f6a393c3bf$var$isUserSuppressingKeyboardEvent(gos, keyboardEvent, rowNode, column, editing) {
    const colDefFunc = column ? column.getColDef().suppressKeyboardEvent : void 0;
    if (!colDefFunc) return false;
    const params = gos.addGridCommonParams({
        event: keyboardEvent,
        editing: editing,
        column: column,
        node: rowNode,
        data: rowNode.data,
        colDef: column.getColDef()
    });
    if (colDefFunc) {
        const colDefFuncResult = colDefFunc(params);
        if (colDefFuncResult) return true;
    }
    return false;
}
function $437b23f6a393c3bf$var$isUserSuppressingHeaderKeyboardEvent(gos, keyboardEvent, headerRowIndex, column) {
    const colDef = column.getDefinition();
    const colDefFunc = colDef && colDef.suppressHeaderKeyboardEvent;
    if (!$437b23f6a393c3bf$var$exists(colDefFunc)) return false;
    const params = gos.addGridCommonParams({
        colDef: colDef,
        column: column,
        headerRowIndex: headerRowIndex,
        event: keyboardEvent
    });
    return !!colDefFunc(params);
}
function $437b23f6a393c3bf$var$normaliseQwertyAzerty(keyboardEvent) {
    const { keyCode: keyCode } = keyboardEvent;
    let code;
    switch(keyCode){
        case $437b23f6a393c3bf$var$A_KEYCODE:
            code = $437b23f6a393c3bf$export$e9e0d96f49f57c33.A;
            break;
        case $437b23f6a393c3bf$var$C_KEYCODE:
            code = $437b23f6a393c3bf$export$e9e0d96f49f57c33.C;
            break;
        case $437b23f6a393c3bf$var$V_KEYCODE:
            code = $437b23f6a393c3bf$export$e9e0d96f49f57c33.V;
            break;
        case $437b23f6a393c3bf$var$D_KEYCODE:
            code = $437b23f6a393c3bf$export$e9e0d96f49f57c33.D;
            break;
        case $437b23f6a393c3bf$var$Z_KEYCODE:
            code = $437b23f6a393c3bf$export$e9e0d96f49f57c33.Z;
            break;
        case $437b23f6a393c3bf$var$Y_KEYCODE:
            code = $437b23f6a393c3bf$export$e9e0d96f49f57c33.Y;
            break;
        default:
            code = keyboardEvent.code;
    }
    return code;
}
function $437b23f6a393c3bf$var$isDeleteKey(key, alwaysReturnFalseOnBackspace = false) {
    if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.DELETE) return true;
    if (!alwaysReturnFalseOnBackspace && key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.BACKSPACE) return $437b23f6a393c3bf$var$isMacOsUserAgent();
    return false;
}
// community-modules/core/src/utils/mouse.ts
var $437b23f6a393c3bf$var$mouse_exports = {};
$437b23f6a393c3bf$var$__export($437b23f6a393c3bf$var$mouse_exports, {
    areEventsNear: ()=>$437b23f6a393c3bf$var$areEventsNear
});
function $437b23f6a393c3bf$var$areEventsNear(e1, e2, pixelCount) {
    if (pixelCount === 0) return false;
    const diffX = Math.abs(e1.clientX - e2.clientX);
    const diffY = Math.abs(e1.clientY - e2.clientY);
    return Math.max(diffX, diffY) <= pixelCount;
}
// community-modules/core/src/utils/rowNode.ts
var $437b23f6a393c3bf$var$rowNode_exports = {};
$437b23f6a393c3bf$var$__export($437b23f6a393c3bf$var$rowNode_exports, {
    sortRowNodesByOrder: ()=>$437b23f6a393c3bf$var$sortRowNodesByOrder
});
function $437b23f6a393c3bf$var$sortRowNodesByOrder(rowNodes, rowNodeOrder) {
    if (!rowNodes) return false;
    const comparator = (nodeA, nodeB)=>{
        const positionA = rowNodeOrder[nodeA.id];
        const positionB = rowNodeOrder[nodeB.id];
        const aHasIndex = positionA !== void 0;
        const bHasIndex = positionB !== void 0;
        const bothNodesAreUserNodes = aHasIndex && bHasIndex;
        const bothNodesAreFillerNodes = !aHasIndex && !bHasIndex;
        if (bothNodesAreUserNodes) return positionA - positionB;
        if (bothNodesAreFillerNodes) return nodeA.__objectId - nodeB.__objectId;
        if (aHasIndex) return 1;
        return -1;
    };
    let rowNodeA;
    let rowNodeB;
    let atLeastOneOutOfOrder = false;
    for(let i = 0; i < rowNodes.length - 1; i++){
        rowNodeA = rowNodes[i];
        rowNodeB = rowNodes[i + 1];
        if (comparator(rowNodeA, rowNodeB) > 0) {
            atLeastOneOutOfOrder = true;
            break;
        }
    }
    if (atLeastOneOutOfOrder) {
        rowNodes.sort(comparator);
        return true;
    }
    return false;
}
// community-modules/core/src/utils/set.ts
var $437b23f6a393c3bf$var$set_exports = {};
$437b23f6a393c3bf$var$__export($437b23f6a393c3bf$var$set_exports, {
    convertToSet: ()=>$437b23f6a393c3bf$var$convertToSet
});
function $437b23f6a393c3bf$var$convertToSet(list) {
    const set = /* @__PURE__ */ new Set();
    list.forEach((x)=>set.add(x));
    return set;
}
// community-modules/core/src/utils/utils.ts
var $437b23f6a393c3bf$var$utils = $437b23f6a393c3bf$var$__spreadValues($437b23f6a393c3bf$var$__spreadValues($437b23f6a393c3bf$var$__spreadValues($437b23f6a393c3bf$var$__spreadValues($437b23f6a393c3bf$var$__spreadValues($437b23f6a393c3bf$var$__spreadValues($437b23f6a393c3bf$var$__spreadValues($437b23f6a393c3bf$var$__spreadValues($437b23f6a393c3bf$var$__spreadValues($437b23f6a393c3bf$var$__spreadValues($437b23f6a393c3bf$var$__spreadValues($437b23f6a393c3bf$var$__spreadValues($437b23f6a393c3bf$var$__spreadValues($437b23f6a393c3bf$var$__spreadValues($437b23f6a393c3bf$var$__spreadValues($437b23f6a393c3bf$var$__spreadValues($437b23f6a393c3bf$var$__spreadValues($437b23f6a393c3bf$var$__spreadValues({}, $437b23f6a393c3bf$var$aria_exports), $437b23f6a393c3bf$var$array_exports), $437b23f6a393c3bf$var$browser_exports), $437b23f6a393c3bf$var$date_exports), $437b23f6a393c3bf$var$dom_exports), $437b23f6a393c3bf$var$event_exports), $437b23f6a393c3bf$var$function_exports), $437b23f6a393c3bf$var$fuzzyMatch_exports), $437b23f6a393c3bf$var$generic_exports), $437b23f6a393c3bf$var$icon_exports), $437b23f6a393c3bf$var$keyboard_exports), $437b23f6a393c3bf$var$map_exports), $437b23f6a393c3bf$var$mouse_exports), $437b23f6a393c3bf$var$number_exports), $437b23f6a393c3bf$var$object_exports), $437b23f6a393c3bf$var$rowNode_exports), $437b23f6a393c3bf$var$set_exports), $437b23f6a393c3bf$var$string_exports);
var $437b23f6a393c3bf$export$71511d61b312f219 = $437b23f6a393c3bf$var$utils;
// community-modules/core/src/utils/numberSequence.ts
var $437b23f6a393c3bf$export$9bbf3cc62ef6fcad = class {
    constructor(initValue = 0, step = 1){
        this.nextValue = initValue;
        this.step = step;
    }
    next() {
        const valToReturn = this.nextValue;
        this.nextValue += this.step;
        return valToReturn;
    }
    peek() {
        return this.nextValue;
    }
    skip(count) {
        this.nextValue += count;
    }
};
// community-modules/core/src/utils/promise.ts
var $437b23f6a393c3bf$export$2245a02c19383694 = /* @__PURE__ */ ((AgPromiseStatus2)=>{
    AgPromiseStatus2[AgPromiseStatus2["IN_PROGRESS"] = 0] = "IN_PROGRESS";
    AgPromiseStatus2[AgPromiseStatus2["RESOLVED"] = 1] = "RESOLVED";
    return AgPromiseStatus2;
})($437b23f6a393c3bf$export$2245a02c19383694 || {});
var $437b23f6a393c3bf$export$30ec7836a4847721 = class _AgPromise {
    constructor(callback){
        this.status = 0 /* IN_PROGRESS */ ;
        this.resolution = null;
        this.waiters = [];
        callback((value)=>this.onDone(value), (params)=>this.onReject(params));
    }
    static all(promises) {
        return new _AgPromise((resolve)=>{
            let remainingToResolve = promises.length;
            const combinedValues = new Array(remainingToResolve);
            promises.forEach((promise, index)=>{
                promise.then((value)=>{
                    combinedValues[index] = value;
                    remainingToResolve--;
                    if (remainingToResolve === 0) resolve(combinedValues);
                });
            });
        });
    }
    static resolve(value = null) {
        return new _AgPromise((resolve)=>resolve(value));
    }
    then(func) {
        return new _AgPromise((resolve)=>{
            if (this.status === 1 /* RESOLVED */ ) resolve(func(this.resolution));
            else this.waiters.push((value)=>resolve(func(value)));
        });
    }
    resolveNow(ifNotResolvedValue, ifResolved) {
        return this.status === 1 /* RESOLVED */  ? ifResolved(this.resolution) : ifNotResolvedValue;
    }
    onDone(value) {
        this.status = 1 /* RESOLVED */ ;
        this.resolution = value;
        this.waiters.forEach((waiter)=>waiter(value));
    }
    onReject(params) {
        console.warn("TBI");
    }
};
// community-modules/core/src/utils/timer.ts
var $437b23f6a393c3bf$export$c57e9b2d8b9e4de = class {
    constructor(){
        this.timestamp = /* @__PURE__ */ new Date().getTime();
    }
    print(msg) {
        const duration = /* @__PURE__ */ new Date().getTime() - this.timestamp;
        console.info(`${msg} = ${duration}`);
        this.timestamp = /* @__PURE__ */ new Date().getTime();
    }
};
// community-modules/core/src/rendering/cssClassManager.ts
var $437b23f6a393c3bf$export$a7053cb7eb605bd2 = class {
    constructor(getGui){
        // to minimise DOM hits, we only apply CSS classes if they have changed. as adding a CSS class that is already
        // there, or removing one that wasn't present, all takes CPU.
        this.cssClassStates = {};
        this.getGui = getGui;
    }
    addCssClass(className) {
        const list = (className || "").split(" ");
        if (list.length > 1) {
            list.forEach((cls)=>this.addCssClass(cls));
            return;
        }
        const updateNeeded = this.cssClassStates[className] !== true;
        if (updateNeeded && className.length) {
            const eGui = this.getGui();
            if (eGui) eGui.classList.add(className);
            this.cssClassStates[className] = true;
        }
    }
    removeCssClass(className) {
        const list = (className || "").split(" ");
        if (list.length > 1) {
            list.forEach((cls)=>this.removeCssClass(cls));
            return;
        }
        const updateNeeded = this.cssClassStates[className] !== false;
        if (updateNeeded && className.length) {
            const eGui = this.getGui();
            if (eGui) eGui.classList.remove(className);
            this.cssClassStates[className] = false;
        }
    }
    containsCssClass(className) {
        const eGui = this.getGui();
        if (!eGui) return false;
        return eGui.classList.contains(className);
    }
    addOrRemoveCssClass(className, addOrRemove) {
        if (!className) return;
        if (className.indexOf(" ") >= 0) {
            const list = (className || "").split(" ");
            if (list.length > 1) {
                list.forEach((cls)=>this.addOrRemoveCssClass(cls, addOrRemove));
                return;
            }
        }
        const updateNeeded = this.cssClassStates[className] !== addOrRemove;
        if (updateNeeded && className.length) {
            const eGui = this.getGui();
            if (eGui) eGui.classList.toggle(className, addOrRemove);
            this.cssClassStates[className] = addOrRemove;
        }
    }
};
// community-modules/core/src/widgets/tooltipStateManager.ts
var $437b23f6a393c3bf$var$_TooltipStateManager = class _TooltipStateManager extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(parentComp, tooltipShowDelayOverride, tooltipHideDelayOverride, shouldDisplayTooltip){
        super();
        this.parentComp = parentComp;
        this.tooltipShowDelayOverride = tooltipShowDelayOverride;
        this.tooltipHideDelayOverride = tooltipHideDelayOverride;
        this.shouldDisplayTooltip = shouldDisplayTooltip;
        this.SHOW_QUICK_TOOLTIP_DIFF = 1e3;
        this.FADE_OUT_TOOLTIP_TIMEOUT = 1e3;
        this.INTERACTIVE_HIDE_DELAY = 100;
        this.interactionEnabled = false;
        this.isInteractingWithTooltip = false;
        this.state = 0 /* NOTHING */ ;
        // when showing the tooltip, we need to make sure it's the most recent instance we request, as due to
        // async we could request two tooltips before the first instance returns, in which case we should
        // disregard the second instance.
        this.tooltipInstanceCount = 0;
        this.tooltipMouseTrack = false;
    }
    postConstruct() {
        if (this.gos.get("tooltipInteraction")) this.interactionEnabled = true;
        this.tooltipTrigger = this.getTooltipTrigger();
        this.tooltipMouseTrack = this.gos.get("tooltipMouseTrack");
        const el = this.parentComp.getGui();
        if (this.tooltipTrigger === 0 /* HOVER */ ) {
            this.addManagedListener(el, "mouseenter", this.onMouseEnter.bind(this));
            this.addManagedListener(el, "mouseleave", this.onMouseLeave.bind(this));
        }
        if (this.tooltipTrigger === 1 /* FOCUS */ ) {
            this.addManagedListener(el, "focusin", this.onFocusIn.bind(this));
            this.addManagedListener(el, "focusout", this.onFocusOut.bind(this));
        }
        this.addManagedListener(el, "mousemove", this.onMouseMove.bind(this));
        if (!this.interactionEnabled) {
            this.addManagedListener(el, "mousedown", this.onMouseDown.bind(this));
            this.addManagedListener(el, "keydown", this.onKeyDown.bind(this));
        }
    }
    getGridOptionsTooltipDelay(delayOption) {
        const delay = this.gos.get(delayOption);
        if (delay < 0) $437b23f6a393c3bf$var$warnOnce(`${delayOption} should not be lower than 0`);
        return Math.max(200, delay);
    }
    getTooltipDelay(type) {
        var _a, _b;
        if (type === "show") return (_a = this.tooltipShowDelayOverride) != null ? _a : this.getGridOptionsTooltipDelay("tooltipShowDelay");
        return (_b = this.tooltipHideDelayOverride) != null ? _b : this.getGridOptionsTooltipDelay("tooltipHideDelay");
    }
    destroy() {
        this.setToDoNothing();
        super.destroy();
    }
    getTooltipTrigger() {
        const trigger = this.gos.get("tooltipTrigger");
        if (!trigger || trigger === "hover") return 0 /* HOVER */ ;
        return 1 /* FOCUS */ ;
    }
    onMouseEnter(e) {
        if (this.interactionEnabled && this.interactiveTooltipTimeoutId) {
            this.unlockService();
            this.startHideTimeout();
        }
        if ($437b23f6a393c3bf$var$isIOSUserAgent()) return;
        if (_TooltipStateManager.isLocked) this.showTooltipTimeoutId = window.setTimeout(()=>{
            this.prepareToShowTooltip(e);
        }, this.INTERACTIVE_HIDE_DELAY);
        else this.prepareToShowTooltip(e);
    }
    onMouseMove(e) {
        if (this.lastMouseEvent) this.lastMouseEvent = e;
        if (this.tooltipMouseTrack && this.state === 2 /* SHOWING */  && this.tooltipComp) this.positionTooltip();
    }
    onMouseDown() {
        this.setToDoNothing();
    }
    onMouseLeave() {
        if (this.interactionEnabled) this.lockService();
        else this.setToDoNothing();
    }
    onFocusIn() {
        this.prepareToShowTooltip();
    }
    onFocusOut(e) {
        var _a;
        const relatedTarget = e.relatedTarget;
        const parentCompGui = this.parentComp.getGui();
        const tooltipGui = (_a = this.tooltipComp) == null ? void 0 : _a.getGui();
        if (this.isInteractingWithTooltip || parentCompGui.contains(relatedTarget) || this.interactionEnabled && (tooltipGui == null ? void 0 : tooltipGui.contains(relatedTarget))) return;
        this.setToDoNothing();
    }
    onKeyDown() {
        this.setToDoNothing();
    }
    prepareToShowTooltip(mouseEvent) {
        if (this.state != 0 /* NOTHING */  || _TooltipStateManager.isLocked) return;
        let delay = 0;
        if (mouseEvent) delay = this.isLastTooltipHiddenRecently() ? 200 : this.getTooltipDelay("show");
        this.lastMouseEvent = mouseEvent || null;
        this.showTooltipTimeoutId = window.setTimeout(this.showTooltip.bind(this), delay);
        this.state = 1 /* WAITING_TO_SHOW */ ;
    }
    isLastTooltipHiddenRecently() {
        const now = /* @__PURE__ */ new Date().getTime();
        const then = _TooltipStateManager.lastTooltipHideTime;
        return now - then < this.SHOW_QUICK_TOOLTIP_DIFF;
    }
    setToDoNothing() {
        if (this.state === 2 /* SHOWING */ ) this.hideTooltip();
        if (this.onBodyScrollEventCallback) {
            this.onBodyScrollEventCallback();
            this.onBodyScrollEventCallback = void 0;
        }
        if (this.onColumnMovedEventCallback) {
            this.onColumnMovedEventCallback();
            this.onColumnMovedEventCallback = void 0;
        }
        this.clearTimeouts();
        this.state = 0 /* NOTHING */ ;
        this.lastMouseEvent = null;
    }
    showTooltip() {
        const params = $437b23f6a393c3bf$var$__spreadValues({}, this.parentComp.getTooltipParams());
        if (!$437b23f6a393c3bf$var$exists(params.value) || this.shouldDisplayTooltip && !this.shouldDisplayTooltip()) {
            this.setToDoNothing();
            return;
        }
        this.state = 2 /* SHOWING */ ;
        this.tooltipInstanceCount++;
        const callback = this.newTooltipComponentCallback.bind(this, this.tooltipInstanceCount);
        const userDetails = this.userComponentFactory.getTooltipCompDetails(params);
        userDetails.newAgStackInstance().then(callback);
    }
    hideTooltip(forceHide) {
        if (!forceHide && this.isInteractingWithTooltip) return;
        if (this.tooltipComp) {
            this.destroyTooltipComp();
            _TooltipStateManager.lastTooltipHideTime = /* @__PURE__ */ new Date().getTime();
        }
        const event = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_TOOLTIP_HIDE,
            parentGui: this.parentComp.getGui()
        };
        this.eventService.dispatchEvent(event);
        this.state = 0 /* NOTHING */ ;
    }
    newTooltipComponentCallback(tooltipInstanceCopy, tooltipComp) {
        const compNoLongerNeeded = this.state !== 2 /* SHOWING */  || this.tooltipInstanceCount !== tooltipInstanceCopy;
        if (compNoLongerNeeded) {
            this.getContext().destroyBean(tooltipComp);
            return;
        }
        const eGui = tooltipComp.getGui();
        this.tooltipComp = tooltipComp;
        if (!eGui.classList.contains("ag-tooltip")) eGui.classList.add("ag-tooltip-custom");
        if (this.tooltipTrigger === 0 /* HOVER */ ) eGui.classList.add("ag-tooltip-animate");
        if (this.interactionEnabled) eGui.classList.add("ag-tooltip-interactive");
        const translate = this.localeService.getLocaleTextFunc();
        const addPopupRes = this.popupService.addPopup({
            eChild: eGui,
            ariaLabel: translate("ariaLabelTooltip", "Tooltip")
        });
        if (addPopupRes) this.tooltipPopupDestroyFunc = addPopupRes.hideFunc;
        this.positionTooltip();
        if (this.tooltipTrigger === 1 /* FOCUS */ ) {
            this.onBodyScrollEventCallback = this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_BODY_SCROLL, this.setToDoNothing.bind(this));
            this.onColumnMovedEventCallback = this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_MOVED, this.setToDoNothing.bind(this));
        }
        if (this.interactionEnabled) {
            if (this.tooltipTrigger === 0 /* HOVER */ ) {
                this.tooltipMouseEnterListener = this.addManagedListener(eGui, "mouseenter", this.onTooltipMouseEnter.bind(this)) || null;
                this.tooltipMouseLeaveListener = this.addManagedListener(eGui, "mouseleave", this.onTooltipMouseLeave.bind(this)) || null;
            } else {
                this.tooltipFocusInListener = this.addManagedListener(eGui, "focusin", this.onTooltipFocusIn.bind(this)) || null;
                this.tooltipFocusOutListener = this.addManagedListener(eGui, "focusout", this.onTooltipFocusOut.bind(this)) || null;
            }
        }
        const event = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_TOOLTIP_SHOW,
            tooltipGui: eGui,
            parentGui: this.parentComp.getGui()
        };
        this.eventService.dispatchEvent(event);
        this.startHideTimeout();
    }
    onTooltipMouseEnter() {
        this.isInteractingWithTooltip = true;
        this.unlockService();
    }
    onTooltipMouseLeave() {
        this.isInteractingWithTooltip = false;
        this.lockService();
    }
    onTooltipFocusIn() {
        this.isInteractingWithTooltip = true;
    }
    onTooltipFocusOut(e) {
        var _a;
        const parentGui = this.parentComp.getGui();
        const tooltipGui = (_a = this.tooltipComp) == null ? void 0 : _a.getGui();
        const relatedTarget = e.relatedTarget;
        if (tooltipGui == null ? void 0 : tooltipGui.contains(relatedTarget)) return;
        this.isInteractingWithTooltip = false;
        if (parentGui.contains(relatedTarget)) this.startHideTimeout();
        else this.hideTooltip();
    }
    positionTooltip() {
        const params = {
            type: "tooltip",
            ePopup: this.tooltipComp.getGui(),
            nudgeY: 18,
            skipObserver: this.tooltipMouseTrack
        };
        if (this.lastMouseEvent) this.popupService.positionPopupUnderMouseEvent($437b23f6a393c3bf$var$__spreadProps($437b23f6a393c3bf$var$__spreadValues({}, params), {
            mouseEvent: this.lastMouseEvent
        }));
        else this.popupService.positionPopupByComponent($437b23f6a393c3bf$var$__spreadProps($437b23f6a393c3bf$var$__spreadValues({}, params), {
            eventSource: this.parentComp.getGui(),
            position: "under",
            keepWithinBounds: true,
            nudgeY: 5
        }));
    }
    destroyTooltipComp() {
        this.tooltipComp.getGui().classList.add("ag-tooltip-hiding");
        const tooltipPopupDestroyFunc = this.tooltipPopupDestroyFunc;
        const tooltipComp = this.tooltipComp;
        const delay = this.tooltipTrigger === 0 /* HOVER */  ? this.FADE_OUT_TOOLTIP_TIMEOUT : 0;
        window.setTimeout(()=>{
            tooltipPopupDestroyFunc();
            this.getContext().destroyBean(tooltipComp);
        }, delay);
        this.clearTooltipListeners();
        this.tooltipPopupDestroyFunc = void 0;
        this.tooltipComp = void 0;
    }
    clearTooltipListeners() {
        [
            this.tooltipMouseEnterListener,
            this.tooltipMouseLeaveListener,
            this.tooltipFocusInListener,
            this.tooltipFocusOutListener
        ].forEach((listener)=>{
            if (listener) listener();
        });
        this.tooltipMouseEnterListener = this.tooltipMouseLeaveListener = this.tooltipFocusInListener = this.tooltipFocusOutListener = null;
    }
    lockService() {
        _TooltipStateManager.isLocked = true;
        this.interactiveTooltipTimeoutId = window.setTimeout(()=>{
            this.unlockService();
            this.setToDoNothing();
        }, this.INTERACTIVE_HIDE_DELAY);
    }
    unlockService() {
        _TooltipStateManager.isLocked = false;
        this.clearInteractiveTimeout();
    }
    startHideTimeout() {
        this.clearHideTimeout();
        this.hideTooltipTimeoutId = window.setTimeout(this.hideTooltip.bind(this), this.getTooltipDelay("hide"));
    }
    clearShowTimeout() {
        if (!this.showTooltipTimeoutId) return;
        window.clearTimeout(this.showTooltipTimeoutId);
        this.showTooltipTimeoutId = void 0;
    }
    clearHideTimeout() {
        if (!this.hideTooltipTimeoutId) return;
        window.clearTimeout(this.hideTooltipTimeoutId);
        this.hideTooltipTimeoutId = void 0;
    }
    clearInteractiveTimeout() {
        if (!this.interactiveTooltipTimeoutId) return;
        window.clearTimeout(this.interactiveTooltipTimeoutId);
        this.interactiveTooltipTimeoutId = void 0;
    }
    clearTimeouts() {
        this.clearShowTimeout();
        this.clearHideTimeout();
        this.clearInteractiveTimeout();
    }
};
$437b23f6a393c3bf$var$_TooltipStateManager.isLocked = false;
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("popupService")
], $437b23f6a393c3bf$var$_TooltipStateManager.prototype, "popupService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("userComponentFactory")
], $437b23f6a393c3bf$var$_TooltipStateManager.prototype, "userComponentFactory", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$_TooltipStateManager.prototype, "postConstruct", 1);
var $437b23f6a393c3bf$export$e3d1279ac5e83a0 = $437b23f6a393c3bf$var$_TooltipStateManager;
// community-modules/core/src/widgets/tooltipFeature.ts
var $437b23f6a393c3bf$export$e5073a590d24815c = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(ctrl, beans){
        super();
        this.ctrl = ctrl;
        if (beans) this.beans = beans;
    }
    postConstruct() {
        this.refreshToolTip();
    }
    setBrowserTooltip(tooltip) {
        const name = "title";
        const eGui = this.ctrl.getGui();
        if (!eGui) return;
        if (tooltip != null && tooltip != "") eGui.setAttribute(name, tooltip);
        else eGui.removeAttribute(name);
    }
    updateTooltipText() {
        this.tooltip = this.ctrl.getTooltipValue();
    }
    createTooltipFeatureIfNeeded() {
        var _a, _b, _c, _d;
        if (this.tooltipManager != null) return;
        const parent = {
            getTooltipParams: ()=>this.getTooltipParams(),
            getGui: ()=>this.ctrl.getGui()
        };
        this.tooltipManager = this.createBean(new $437b23f6a393c3bf$export$e3d1279ac5e83a0(parent, (_b = (_a = this.ctrl).getTooltipShowDelayOverride) == null ? void 0 : _b.call(_a), (_d = (_c = this.ctrl).getTooltipHideDelayOverride) == null ? void 0 : _d.call(_c), this.ctrl.shouldDisplayTooltip), this.beans.context);
    }
    refreshToolTip() {
        this.browserTooltips = this.beans.gos.get("enableBrowserTooltips");
        this.updateTooltipText();
        if (this.browserTooltips) {
            this.setBrowserTooltip(this.tooltip);
            if (this.tooltipManager) this.tooltipManager = this.destroyBean(this.tooltipManager, this.beans.context);
        } else {
            this.setBrowserTooltip(null);
            this.createTooltipFeatureIfNeeded();
        }
    }
    getTooltipParams() {
        const ctrl = this.ctrl;
        const column = ctrl.getColumn ? ctrl.getColumn() : void 0;
        const colDef = ctrl.getColDef ? ctrl.getColDef() : void 0;
        const rowNode = ctrl.getRowNode ? ctrl.getRowNode() : void 0;
        return {
            location: ctrl.getLocation(),
            colDef: //'cell',
            colDef,
            column: column,
            rowIndex: ctrl.getRowIndex ? ctrl.getRowIndex() : void 0,
            node: rowNode,
            data: rowNode ? rowNode.data : void 0,
            value: this.getTooltipText(),
            valueFormatted: ctrl.getValueFormatted ? ctrl.getValueFormatted() : void 0,
            hideTooltipCallback: ()=>{
                var _a;
                return (_a = this.tooltipManager) == null ? void 0 : _a.hideTooltip(true);
            }
        };
    }
    getTooltipText() {
        return this.tooltip;
    }
    // overriding to make public, as we don't dispose this bean via context
    destroy() {
        if (this.tooltipManager) this.tooltipManager = this.destroyBean(this.tooltipManager, this.beans.context);
        super.destroy();
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("beans")
], $437b23f6a393c3bf$export$e5073a590d24815c.prototype, "beans", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$export$e5073a590d24815c.prototype, "postConstruct", 1);
// community-modules/core/src/widgets/component.ts
var $437b23f6a393c3bf$var$compIdSequence = new $437b23f6a393c3bf$export$9bbf3cc62ef6fcad();
var $437b23f6a393c3bf$var$_Component = class _Component extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(template){
        super();
        // if false, then CSS class "ag-hidden" is applied, which sets "display: none"
        this.displayed = true;
        // if false, then CSS class "ag-invisible" is applied, which sets "visibility: hidden"
        this.visible = true;
        // unique id for this row component. this is used for getting a reference to the HTML dom.
        // we cannot use the RowNode id as this is not unique (due to animation, old rows can be lying
        // around as we create a new rowComp instance for the same row node).
        this.compId = $437b23f6a393c3bf$var$compIdSequence.next();
        this.cssClassManager = new $437b23f6a393c3bf$export$a7053cb7eb605bd2(()=>this.eGui);
        if (template) this.setTemplate(template);
    }
    preConstructOnComponent() {
        this.usingBrowserTooltips = this.gos.get("enableBrowserTooltips");
    }
    getCompId() {
        return this.compId;
    }
    getTooltipParams() {
        return {
            value: this.tooltipText,
            location: "UNKNOWN"
        };
    }
    setTooltip(params) {
        const { newTooltipText: newTooltipText, showDelayOverride: showDelayOverride, hideDelayOverride: hideDelayOverride, location: location, shouldDisplayTooltip: shouldDisplayTooltip } = params || {};
        if (this.tooltipFeature) this.tooltipFeature = this.destroyBean(this.tooltipFeature);
        if (this.tooltipText !== newTooltipText) this.tooltipText = newTooltipText;
        const getTooltipValue = ()=>this.tooltipText;
        if (newTooltipText != null) this.tooltipFeature = this.createBean(new $437b23f6a393c3bf$export$e5073a590d24815c({
            getTooltipValue: getTooltipValue,
            getGui: ()=>this.getGui(),
            getLocation: ()=>location != null ? location : "UNKNOWN",
            getColDef: params == null ? void 0 : params.getColDef,
            getColumn: params == null ? void 0 : params.getColumn,
            getTooltipShowDelayOverride: showDelayOverride != null ? ()=>showDelayOverride : void 0,
            getTooltipHideDelayOverride: hideDelayOverride != null ? ()=>hideDelayOverride : void 0,
            shouldDisplayTooltip: shouldDisplayTooltip
        }));
    }
    // for registered components only, eg creates AgCheckbox instance from ag-checkbox HTML tag
    createChildComponentsFromTags(parentNode, paramsMap) {
        const childNodeList = $437b23f6a393c3bf$var$copyNodeList(parentNode.childNodes);
        childNodeList.forEach((childNode)=>{
            if (!(childNode instanceof HTMLElement)) return;
            const childComp = this.createComponentFromElement(childNode, (childComp2)=>{
                const childGui = childComp2.getGui();
                if (childGui) this.copyAttributesFromNode(childNode, childComp2.getGui());
            }, paramsMap);
            if (childComp) {
                if (childComp.addItems && childNode.children.length) {
                    this.createChildComponentsFromTags(childNode, paramsMap);
                    const items = Array.prototype.slice.call(childNode.children);
                    childComp.addItems(items);
                }
                this.swapComponentForNode(childComp, parentNode, childNode);
            } else if (childNode.childNodes) this.createChildComponentsFromTags(childNode, paramsMap);
        });
    }
    createComponentFromElement(element, afterPreCreateCallback, paramsMap) {
        const key = element.nodeName;
        const componentParams = paramsMap ? paramsMap[element.getAttribute("ref")] : void 0;
        const ComponentClass = this.agStackComponentsRegistry.getComponentClass(key);
        if (ComponentClass) {
            _Component.elementGettingCreated = element;
            const newComponent = new ComponentClass(componentParams);
            newComponent.setParentComponent(this);
            this.createBean(newComponent, null, afterPreCreateCallback);
            return newComponent;
        }
        return null;
    }
    copyAttributesFromNode(source, dest) {
        $437b23f6a393c3bf$var$iterateNamedNodeMap(source.attributes, (name, value)=>dest.setAttribute(name, value));
    }
    swapComponentForNode(newComponent, parentNode, childNode) {
        const eComponent = newComponent.getGui();
        parentNode.replaceChild(eComponent, childNode);
        parentNode.insertBefore(document.createComment(childNode.nodeName), eComponent);
        this.addDestroyFunc(this.destroyBean.bind(this, newComponent));
        this.swapInComponentForQuerySelectors(newComponent, childNode);
    }
    swapInComponentForQuerySelectors(newComponent, childNode) {
        const thisNoType = this;
        this.iterateOverQuerySelectors((querySelector)=>{
            if (thisNoType[querySelector.attributeName] === childNode) thisNoType[querySelector.attributeName] = newComponent;
        });
    }
    iterateOverQuerySelectors(action) {
        let thisPrototype = Object.getPrototypeOf(this);
        while(thisPrototype != null){
            const metaData = thisPrototype.__agComponentMetaData;
            const currentProtoName = $437b23f6a393c3bf$var$getFunctionName(thisPrototype.constructor);
            if (metaData && metaData[currentProtoName] && metaData[currentProtoName].querySelectors) metaData[currentProtoName].querySelectors.forEach((querySelector)=>action(querySelector));
            thisPrototype = Object.getPrototypeOf(thisPrototype);
        }
    }
    activateTabIndex(elements) {
        const tabIndex = this.gos.get("tabIndex");
        if (!elements) elements = [];
        if (!elements.length) elements.push(this.getGui());
        elements.forEach((el)=>el.setAttribute("tabindex", tabIndex.toString()));
    }
    setTemplate(template, paramsMap) {
        const eGui = $437b23f6a393c3bf$var$loadTemplate(template);
        this.setTemplateFromElement(eGui, paramsMap);
    }
    setTemplateFromElement(element, paramsMap) {
        this.eGui = element;
        this.eGui.__agComponent = this;
        this.wireQuerySelectors();
        if (!!this.getContext()) this.createChildComponentsFromTags(this.getGui(), paramsMap);
    }
    createChildComponentsPreConstruct() {
        if (!!this.getGui()) this.createChildComponentsFromTags(this.getGui());
    }
    wireQuerySelectors() {
        if (!this.eGui) return;
        const thisNoType = this;
        this.iterateOverQuerySelectors((querySelector)=>{
            const setResult = (result)=>thisNoType[querySelector.attributeName] = result;
            const topLevelRefMatch = querySelector.refSelector && this.getAttribute("ref") === querySelector.refSelector;
            if (topLevelRefMatch) setResult(this.eGui);
            else {
                const resultOfQuery = this.eGui.querySelector(querySelector.querySelector);
                if (resultOfQuery) setResult(resultOfQuery.__agComponent || resultOfQuery);
            }
        });
    }
    getGui() {
        return this.eGui;
    }
    getFocusableElement() {
        return this.eGui;
    }
    getAriaElement() {
        return this.getFocusableElement();
    }
    setParentComponent(component) {
        this.parentComponent = component;
    }
    getParentComponent() {
        return this.parentComponent;
    }
    // this method is for older code, that wants to provide the gui element,
    // it is not intended for this to be in ag-Stack
    setGui(eGui) {
        this.eGui = eGui;
    }
    queryForHtmlElement(cssSelector) {
        return this.eGui.querySelector(cssSelector);
    }
    queryForHtmlInputElement(cssSelector) {
        return this.eGui.querySelector(cssSelector);
    }
    appendChild(newChild, container) {
        if (newChild == null) return;
        if (!container) container = this.eGui;
        if ($437b23f6a393c3bf$var$isNodeOrElement(newChild)) container.appendChild(newChild);
        else {
            const childComponent = newChild;
            container.appendChild(childComponent.getGui());
        }
    }
    isDisplayed() {
        return this.displayed;
    }
    setVisible(visible, options = {}) {
        if (visible !== this.visible) {
            this.visible = visible;
            const { skipAriaHidden: skipAriaHidden } = options;
            $437b23f6a393c3bf$var$setVisible(this.eGui, visible, {
                skipAriaHidden: skipAriaHidden
            });
        }
    }
    setDisplayed(displayed, options = {}) {
        if (displayed !== this.displayed) {
            this.displayed = displayed;
            const { skipAriaHidden: skipAriaHidden } = options;
            $437b23f6a393c3bf$var$setDisplayed(this.eGui, displayed, {
                skipAriaHidden: skipAriaHidden
            });
            const event = {
                type: _Component.EVENT_DISPLAYED_CHANGED,
                visible: this.displayed
            };
            this.dispatchEvent(event);
        }
    }
    destroy() {
        if (this.parentComponent) this.parentComponent = void 0;
        if (this.tooltipFeature) this.tooltipFeature = this.destroyBean(this.tooltipFeature);
        const eGui = this.eGui;
        if (eGui && eGui.__agComponent) eGui.__agComponent = void 0;
        super.destroy();
    }
    addGuiEventListener(event, listener, options) {
        this.eGui.addEventListener(event, listener, options);
        this.addDestroyFunc(()=>this.eGui.removeEventListener(event, listener));
    }
    addCssClass(className) {
        this.cssClassManager.addCssClass(className);
    }
    removeCssClass(className) {
        this.cssClassManager.removeCssClass(className);
    }
    containsCssClass(className) {
        return this.cssClassManager.containsCssClass(className);
    }
    addOrRemoveCssClass(className, addOrRemove) {
        this.cssClassManager.addOrRemoveCssClass(className, addOrRemove);
    }
    getAttribute(key) {
        const { eGui: eGui } = this;
        return eGui ? eGui.getAttribute(key) : null;
    }
    getRefElement(refName) {
        return this.queryForHtmlElement(`[ref="${refName}"]`);
    }
};
$437b23f6a393c3bf$var$_Component.EVENT_DISPLAYED_CHANGED = "displayedChanged";
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("agStackComponentsRegistry")
], $437b23f6a393c3bf$var$_Component.prototype, "agStackComponentsRegistry", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e99736521cbcf94e
], $437b23f6a393c3bf$var$_Component.prototype, "preConstructOnComponent", 1);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e99736521cbcf94e
], $437b23f6a393c3bf$var$_Component.prototype, "createChildComponentsPreConstruct", 1);
var $437b23f6a393c3bf$export$16fa2f45be04daa8 = $437b23f6a393c3bf$var$_Component;
// community-modules/core/src/widgets/componentAnnotations.ts
function $437b23f6a393c3bf$export$fe9de06a57e74a75(selector) {
    return $437b23f6a393c3bf$var$querySelectorFunc.bind(this, selector, void 0);
}
function $437b23f6a393c3bf$export$8a4e90ba380c343c(ref) {
    return $437b23f6a393c3bf$var$querySelectorFunc.bind(this, `[ref=${ref}]`, ref);
}
function $437b23f6a393c3bf$var$querySelectorFunc(selector, refSelector, classPrototype, methodOrAttributeName, index) {
    if (selector === null) {
        console.error("AG Grid: QuerySelector selector should not be null");
        return;
    }
    if (typeof index === "number") {
        console.error("AG Grid: QuerySelector should be on an attribute");
        return;
    }
    $437b23f6a393c3bf$var$addToObjectProps(classPrototype, "querySelectors", {
        attributeName: methodOrAttributeName,
        querySelector: selector,
        refSelector: refSelector
    });
}
function $437b23f6a393c3bf$var$addToObjectProps(target, key, value) {
    const props = $437b23f6a393c3bf$var$getOrCreateProps2(target, $437b23f6a393c3bf$var$getFunctionName(target.constructor));
    if (!props[key]) props[key] = [];
    props[key].push(value);
}
function $437b23f6a393c3bf$var$getOrCreateProps2(target, instanceName) {
    if (!target.__agComponentMetaData) target.__agComponentMetaData = {};
    if (!target.__agComponentMetaData[instanceName]) target.__agComponentMetaData[instanceName] = {};
    return target.__agComponentMetaData[instanceName];
}
// community-modules/core/src/filter/floating/provided/readOnlyFloatingFilter.ts
var $437b23f6a393c3bf$var$ReadOnlyFloatingFilter = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super(/* html */ `
            <div class="ag-floating-filter-input" role="presentation">
                <ag-input-text-field ref="eFloatingFilterText"></ag-input-text-field>
            </div>`);
    }
    // this is a user component, and IComponent has "public destroy()" as part of the interface.
    // so we need to override destroy() just to make the method public.
    destroy() {
        super.destroy();
    }
    init(params) {
        this.params = params;
        const displayName = this.columnModel.getDisplayNameForColumn(params.column, "header", true);
        const translate = this.localeService.getLocaleTextFunc();
        this.eFloatingFilterText.setDisabled(true).setInputAriaLabel(`${displayName} ${translate("ariaFilterInput", "Filter Input")}`);
    }
    onParentModelChanged(parentModel) {
        if (parentModel == null) {
            this.eFloatingFilterText.setValue("");
            return;
        }
        this.params.parentFilterInstance((filterInstance)=>{
            if (filterInstance.getModelAsString) {
                const modelAsString = filterInstance.getModelAsString(parentModel);
                this.eFloatingFilterText.setValue(modelAsString);
            }
        });
    }
    onParamsUpdated(params) {
        this.refresh(params);
    }
    refresh(params) {
        this.init(params);
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eFloatingFilterText")
], $437b23f6a393c3bf$var$ReadOnlyFloatingFilter.prototype, "eFloatingFilterText", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnModel")
], $437b23f6a393c3bf$var$ReadOnlyFloatingFilter.prototype, "columnModel", 2);
// community-modules/core/src/filter/provided/date/dateCompWrapper.ts
var $437b23f6a393c3bf$var$DateCompWrapper = class {
    constructor(context, userComponentFactory, dateComponentParams, eParent, onReady){
        this.alive = true;
        this.context = context;
        this.eParent = eParent;
        const compDetails = userComponentFactory.getDateCompDetails(dateComponentParams);
        const promise = compDetails.newAgStackInstance();
        promise.then((dateComp)=>{
            if (!this.alive) {
                context.destroyBean(dateComp);
                return;
            }
            this.dateComp = dateComp;
            if (!dateComp) return;
            eParent.appendChild(dateComp.getGui());
            if (dateComp.afterGuiAttached) dateComp.afterGuiAttached();
            if (this.tempValue) dateComp.setDate(this.tempValue);
            if (this.disabled != null) this.setDateCompDisabled(this.disabled);
            onReady == null || onReady(this);
        });
    }
    destroy() {
        this.alive = false;
        this.dateComp = this.context.destroyBean(this.dateComp);
    }
    getDate() {
        return this.dateComp ? this.dateComp.getDate() : this.tempValue;
    }
    setDate(value) {
        if (this.dateComp) this.dateComp.setDate(value);
        else this.tempValue = value;
    }
    setDisabled(disabled) {
        if (this.dateComp) this.setDateCompDisabled(disabled);
        else this.disabled = disabled;
    }
    setDisplayed(displayed) {
        $437b23f6a393c3bf$var$setDisplayed(this.eParent, displayed);
    }
    setInputPlaceholder(placeholder) {
        if (this.dateComp && this.dateComp.setInputPlaceholder) this.dateComp.setInputPlaceholder(placeholder);
    }
    setInputAriaLabel(label) {
        if (this.dateComp && this.dateComp.setInputAriaLabel) this.dateComp.setInputAriaLabel(label);
    }
    afterGuiAttached(params) {
        if (this.dateComp && typeof this.dateComp.afterGuiAttached === "function") this.dateComp.afterGuiAttached(params);
    }
    updateParams(params) {
        var _a, _b;
        let hasRefreshed = false;
        if (((_a = this.dateComp) == null ? void 0 : _a.refresh) && typeof this.dateComp.refresh === "function") {
            const result = this.dateComp.refresh(params);
            if (result !== null) hasRefreshed = true;
        }
        if (!hasRefreshed && ((_b = this.dateComp) == null ? void 0 : _b.onParamsUpdated) && typeof this.dateComp.onParamsUpdated === "function") {
            const result = this.dateComp.onParamsUpdated(params);
            if (result !== null) $437b23f6a393c3bf$var$warnOnce(`Custom date component method 'onParamsUpdated' is deprecated. Use 'refresh' instead.`);
        }
    }
    setDateCompDisabled(disabled) {
        if (this.dateComp == null) return;
        if (this.dateComp.setDisabled == null) return;
        this.dateComp.setDisabled(disabled);
    }
};
// community-modules/core/src/filter/provided/optionsFactory.ts
var $437b23f6a393c3bf$var$OptionsFactory = class {
    constructor(){
        this.customFilterOptions = {};
    }
    init(params, defaultOptions) {
        this.filterOptions = params.filterOptions || defaultOptions;
        this.mapCustomOptions();
        this.selectDefaultItem(params);
    }
    getFilterOptions() {
        return this.filterOptions;
    }
    mapCustomOptions() {
        if (!this.filterOptions) return;
        this.filterOptions.forEach((filterOption)=>{
            if (typeof filterOption === "string") return;
            const requiredProperties = [
                [
                    "displayKey"
                ],
                [
                    "displayName"
                ],
                [
                    "predicate",
                    "test"
                ]
            ];
            const propertyCheck = (keys2)=>{
                if (!keys2.some((key)=>filterOption[key] != null)) {
                    console.warn(`AG Grid: ignoring FilterOptionDef as it doesn't contain one of '${keys2}'`);
                    return false;
                }
                return true;
            };
            if (!requiredProperties.every(propertyCheck)) {
                this.filterOptions = this.filterOptions.filter((v)=>v === filterOption) || [];
                return;
            }
            this.customFilterOptions[filterOption.displayKey] = filterOption;
        });
    }
    selectDefaultItem(params) {
        if (params.defaultOption) this.defaultOption = params.defaultOption;
        else if (this.filterOptions.length >= 1) {
            const firstFilterOption = this.filterOptions[0];
            if (typeof firstFilterOption === "string") this.defaultOption = firstFilterOption;
            else if (firstFilterOption.displayKey) this.defaultOption = firstFilterOption.displayKey;
            else console.warn(`AG Grid: invalid FilterOptionDef supplied as it doesn't contain a 'displayKey'`);
        } else console.warn("AG Grid: no filter options for filter");
    }
    getDefaultOption() {
        return this.defaultOption;
    }
    getCustomOption(name) {
        return this.customFilterOptions[name];
    }
};
// community-modules/core/src/filter/filterLocaleText.ts
var $437b23f6a393c3bf$var$FILTER_LOCALE_TEXT = {
    applyFilter: "Apply",
    clearFilter: "Clear",
    resetFilter: "Reset",
    cancelFilter: "Cancel",
    textFilter: "Text Filter",
    numberFilter: "Number Filter",
    dateFilter: "Date Filter",
    setFilter: "Set Filter",
    filterOoo: "Filter...",
    empty: "Choose one",
    equals: "Equals",
    notEqual: "Does not equal",
    lessThan: "Less than",
    greaterThan: "Greater than",
    inRange: "Between",
    inRangeStart: "From",
    inRangeEnd: "To",
    lessThanOrEqual: "Less than or equal to",
    greaterThanOrEqual: "Greater than or equal to",
    contains: "Contains",
    notContains: "Does not contain",
    startsWith: "Begins with",
    endsWith: "Ends with",
    blank: "Blank",
    notBlank: "Not blank",
    before: "Before",
    after: "After",
    andCondition: "AND",
    orCondition: "OR",
    dateFormatOoo: "yyyy-mm-dd"
};
// community-modules/core/src/widgets/managedFocusFeature.ts
var $437b23f6a393c3bf$var$_ManagedFocusFeature = class _ManagedFocusFeature extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(eFocusableElement, callbacks = {}){
        super();
        this.eFocusableElement = eFocusableElement;
        this.callbacks = callbacks;
        this.callbacks = $437b23f6a393c3bf$var$__spreadValues({
            shouldStopEventPropagation: ()=>false,
            onTabKeyDown: (e)=>{
                if (e.defaultPrevented) return;
                const nextRoot = this.focusService.findNextFocusableElement(this.eFocusableElement, false, e.shiftKey);
                if (!nextRoot) return;
                nextRoot.focus();
                e.preventDefault();
            }
        }, callbacks);
    }
    postConstruct() {
        this.eFocusableElement.classList.add(_ManagedFocusFeature.FOCUS_MANAGED_CLASS);
        this.addKeyDownListeners(this.eFocusableElement);
        if (this.callbacks.onFocusIn) this.addManagedListener(this.eFocusableElement, "focusin", this.callbacks.onFocusIn);
        if (this.callbacks.onFocusOut) this.addManagedListener(this.eFocusableElement, "focusout", this.callbacks.onFocusOut);
    }
    addKeyDownListeners(eGui) {
        this.addManagedListener(eGui, "keydown", (e)=>{
            if (e.defaultPrevented || $437b23f6a393c3bf$var$isStopPropagationForAgGrid(e)) return;
            if (this.callbacks.shouldStopEventPropagation(e)) {
                $437b23f6a393c3bf$var$stopPropagationForAgGrid(e);
                return;
            }
            if (e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB) this.callbacks.onTabKeyDown(e);
            else if (this.callbacks.handleKeyDown) this.callbacks.handleKeyDown(e);
        });
    }
};
$437b23f6a393c3bf$var$_ManagedFocusFeature.FOCUS_MANAGED_CLASS = "ag-focus-managed";
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("focusService")
], $437b23f6a393c3bf$var$_ManagedFocusFeature.prototype, "focusService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$_ManagedFocusFeature.prototype, "postConstruct", 1);
var $437b23f6a393c3bf$export$5510e53ed3962582 = $437b23f6a393c3bf$var$_ManagedFocusFeature;
// community-modules/core/src/rendering/features/positionableFeature.ts
var $437b23f6a393c3bf$var$RESIZE_CONTAINER_STYLE = "ag-resizer-wrapper";
var $437b23f6a393c3bf$var$RESIZE_TEMPLATE = /* html */ `<div class="${$437b23f6a393c3bf$var$RESIZE_CONTAINER_STYLE}">
        <div ref="eTopLeftResizer" class="ag-resizer ag-resizer-topLeft"></div>
        <div ref="eTopResizer" class="ag-resizer ag-resizer-top"></div>
        <div ref="eTopRightResizer" class="ag-resizer ag-resizer-topRight"></div>
        <div ref="eRightResizer" class="ag-resizer ag-resizer-right"></div>
        <div ref="eBottomRightResizer" class="ag-resizer ag-resizer-bottomRight"></div>
        <div ref="eBottomResizer" class="ag-resizer ag-resizer-bottom"></div>
        <div ref="eBottomLeftResizer" class="ag-resizer ag-resizer-bottomLeft"></div>
        <div ref="eLeftResizer" class="ag-resizer ag-resizer-left"></div>
    </div>`;
var $437b23f6a393c3bf$export$c53a5d9f1fb0f7f6 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(element, config){
        super();
        this.element = element;
        this.dragStartPosition = {
            x: 0,
            y: 0
        };
        this.position = {
            x: 0,
            y: 0
        };
        this.lastSize = {
            width: -1,
            height: -1
        };
        this.positioned = false;
        this.resizersAdded = false;
        this.resizeListeners = [];
        this.boundaryEl = null;
        this.isResizing = false;
        this.isMoving = false;
        this.resizable = {};
        this.movable = false;
        this.currentResizer = null;
        this.config = Object.assign({}, {
            popup: false
        }, config);
    }
    center() {
        const { clientHeight: clientHeight, clientWidth: clientWidth } = this.offsetParent;
        const x = clientWidth / 2 - this.getWidth() / 2;
        const y = clientHeight / 2 - this.getHeight() / 2;
        this.offsetElement(x, y);
    }
    initialisePosition() {
        if (this.positioned) return;
        const { centered: centered, forcePopupParentAsOffsetParent: forcePopupParentAsOffsetParent, minWidth: minWidth, width: width, minHeight: minHeight, height: height, x: x, y: y } = this.config;
        if (!this.offsetParent) this.setOffsetParent();
        let computedMinHeight = 0;
        let computedMinWidth = 0;
        const isElementVisible = $437b23f6a393c3bf$var$isVisible(this.element);
        if (isElementVisible) {
            const boundaryEl = this.findBoundaryElement();
            const offsetParentComputedStyles = window.getComputedStyle(boundaryEl);
            if (offsetParentComputedStyles.minWidth != null) {
                const paddingWidth = boundaryEl.offsetWidth - this.element.offsetWidth;
                computedMinWidth = parseInt(offsetParentComputedStyles.minWidth, 10) - paddingWidth;
            }
            if (offsetParentComputedStyles.minHeight != null) {
                const paddingHeight = boundaryEl.offsetHeight - this.element.offsetHeight;
                computedMinHeight = parseInt(offsetParentComputedStyles.minHeight, 10) - paddingHeight;
            }
        }
        this.minHeight = minHeight || computedMinHeight;
        this.minWidth = minWidth || computedMinWidth;
        if (width) this.setWidth(width);
        if (height) this.setHeight(height);
        if (!width || !height) this.refreshSize();
        if (centered) this.center();
        else if (x || y) this.offsetElement(x, y);
        else if (isElementVisible && forcePopupParentAsOffsetParent) {
            let boundaryEl = this.boundaryEl;
            let initialisedDuringPositioning = true;
            if (!boundaryEl) {
                boundaryEl = this.findBoundaryElement();
                initialisedDuringPositioning = false;
            }
            if (boundaryEl) {
                const top = parseFloat(boundaryEl.style.top);
                const left = parseFloat(boundaryEl.style.left);
                if (initialisedDuringPositioning) this.offsetElement(isNaN(left) ? 0 : left, isNaN(top) ? 0 : top);
                else this.setPosition(left, top);
            }
        }
        this.positioned = !!this.offsetParent;
    }
    isPositioned() {
        return this.positioned;
    }
    getPosition() {
        return this.position;
    }
    setMovable(movable, moveElement) {
        if (!this.config.popup || movable === this.movable) return;
        this.movable = movable;
        const params = this.moveElementDragListener || {
            eElement: moveElement,
            onDragStart: this.onMoveStart.bind(this),
            onDragging: this.onMove.bind(this),
            onDragStop: this.onMoveEnd.bind(this)
        };
        if (movable) {
            this.dragService.addDragSource(params);
            this.moveElementDragListener = params;
        } else {
            this.dragService.removeDragSource(params);
            this.moveElementDragListener = void 0;
        }
    }
    setResizable(resizable) {
        this.clearResizeListeners();
        if (resizable) this.addResizers();
        else this.removeResizers();
        if (typeof resizable === "boolean") {
            if (resizable === false) return;
            resizable = {
                topLeft: resizable,
                top: resizable,
                topRight: resizable,
                right: resizable,
                bottomRight: resizable,
                bottom: resizable,
                bottomLeft: resizable,
                left: resizable
            };
        }
        Object.keys(resizable).forEach((side)=>{
            const resizableStructure = resizable;
            const isSideResizable = !!resizableStructure[side];
            const resizerEl = this.getResizerElement(side);
            const params = {
                dragStartPixels: 0,
                eElement: resizerEl,
                onDragStart: (e)=>this.onResizeStart(e, side),
                onDragging: this.onResize.bind(this),
                onDragStop: (e)=>this.onResizeEnd(e, side)
            };
            if (isSideResizable || !this.isAlive() && !isSideResizable) {
                if (isSideResizable) {
                    this.dragService.addDragSource(params);
                    this.resizeListeners.push(params);
                    resizerEl.style.pointerEvents = "all";
                } else resizerEl.style.pointerEvents = "none";
                this.resizable[side] = isSideResizable;
            }
        });
    }
    removeSizeFromEl() {
        this.element.style.removeProperty("height");
        this.element.style.removeProperty("width");
        this.element.style.removeProperty("flex");
    }
    restoreLastSize() {
        this.element.style.flex = "0 0 auto";
        const { height: height, width: width } = this.lastSize;
        if (width !== -1) this.element.style.width = `${width}px`;
        if (height !== -1) this.element.style.height = `${height}px`;
    }
    getHeight() {
        return this.element.offsetHeight;
    }
    setHeight(height) {
        const { popup: popup } = this.config;
        const eGui = this.element;
        let isPercent = false;
        if (typeof height === "string" && height.indexOf("%") !== -1) {
            $437b23f6a393c3bf$var$setFixedHeight(eGui, height);
            height = $437b23f6a393c3bf$var$getAbsoluteHeight(eGui);
            isPercent = true;
        } else {
            height = Math.max(this.minHeight, height);
            if (this.positioned) {
                const availableHeight = this.getAvailableHeight();
                if (availableHeight && height > availableHeight) height = availableHeight;
            }
        }
        if (this.getHeight() === height) return;
        if (!isPercent) {
            if (popup) $437b23f6a393c3bf$var$setFixedHeight(eGui, height);
            else {
                eGui.style.height = `${height}px`;
                eGui.style.flex = "0 0 auto";
                this.lastSize.height = typeof height === "number" ? height : parseFloat(height);
            }
        } else {
            eGui.style.maxHeight = "unset";
            eGui.style.minHeight = "unset";
        }
    }
    getAvailableHeight() {
        const { popup: popup, forcePopupParentAsOffsetParent: forcePopupParentAsOffsetParent } = this.config;
        if (!this.positioned) this.initialisePosition();
        const { clientHeight: clientHeight } = this.offsetParent;
        if (!clientHeight) return null;
        const elRect = this.element.getBoundingClientRect();
        const offsetParentRect = this.offsetParent.getBoundingClientRect();
        const yPosition = popup ? this.position.y : elRect.top;
        const parentTop = popup ? 0 : offsetParentRect.top;
        let additionalHeight = 0;
        if (forcePopupParentAsOffsetParent) {
            const parentEl = this.element.parentElement;
            if (parentEl) {
                const { bottom: bottom } = parentEl.getBoundingClientRect();
                additionalHeight = bottom - elRect.bottom;
            }
        }
        const availableHeight = clientHeight + parentTop - yPosition - additionalHeight;
        return availableHeight;
    }
    getWidth() {
        return this.element.offsetWidth;
    }
    setWidth(width) {
        const eGui = this.element;
        const { popup: popup } = this.config;
        let isPercent = false;
        if (typeof width === "string" && width.indexOf("%") !== -1) {
            $437b23f6a393c3bf$var$setFixedWidth(eGui, width);
            width = $437b23f6a393c3bf$var$getAbsoluteWidth(eGui);
            isPercent = true;
        } else if (this.positioned) {
            width = Math.max(this.minWidth, width);
            const { clientWidth: clientWidth } = this.offsetParent;
            const xPosition = popup ? this.position.x : this.element.getBoundingClientRect().left;
            if (clientWidth && width + xPosition > clientWidth) width = clientWidth - xPosition;
        }
        if (this.getWidth() === width) return;
        if (!isPercent) {
            if (this.config.popup) $437b23f6a393c3bf$var$setFixedWidth(eGui, width);
            else {
                eGui.style.width = `${width}px`;
                eGui.style.flex = " unset";
                this.lastSize.width = typeof width === "number" ? width : parseFloat(width);
            }
        } else {
            eGui.style.maxWidth = "unset";
            eGui.style.minWidth = "unset";
        }
    }
    offsetElement(x = 0, y = 0) {
        const { forcePopupParentAsOffsetParent: forcePopupParentAsOffsetParent } = this.config;
        const ePopup = forcePopupParentAsOffsetParent ? this.boundaryEl : this.element;
        if (!ePopup) return;
        this.popupService.positionPopup({
            ePopup: ePopup,
            keepWithinBounds: true,
            skipObserver: this.movable || this.isResizable(),
            updatePosition: ()=>({
                    x: x,
                    y: y
                })
        });
        this.setPosition(parseFloat(ePopup.style.left), parseFloat(ePopup.style.top));
    }
    constrainSizeToAvailableHeight(constrain) {
        if (!this.config.forcePopupParentAsOffsetParent) return;
        const applyMaxHeightToElement = ()=>{
            const availableHeight = this.getAvailableHeight();
            this.element.style.setProperty("max-height", `${availableHeight}px`);
        };
        if (constrain) this.resizeObserverSubscriber = this.resizeObserverService.observeResize(this.popupService.getPopupParent(), applyMaxHeightToElement);
        else {
            this.element.style.removeProperty("max-height");
            if (this.resizeObserverSubscriber) {
                this.resizeObserverSubscriber();
                this.resizeObserverSubscriber = void 0;
            }
        }
    }
    setPosition(x, y) {
        this.position.x = x;
        this.position.y = y;
    }
    updateDragStartPosition(x, y) {
        this.dragStartPosition = {
            x: x,
            y: y
        };
    }
    calculateMouseMovement(params) {
        const { e: e, isLeft: isLeft, isTop: isTop, anywhereWithin: anywhereWithin, topBuffer: topBuffer } = params;
        const xDiff = e.clientX - this.dragStartPosition.x;
        const yDiff = e.clientY - this.dragStartPosition.y;
        const movementX = this.shouldSkipX(e, !!isLeft, !!anywhereWithin, xDiff) ? 0 : xDiff;
        const movementY = this.shouldSkipY(e, !!isTop, topBuffer, yDiff) ? 0 : yDiff;
        return {
            movementX: movementX,
            movementY: movementY
        };
    }
    shouldSkipX(e, isLeft, anywhereWithin, diff) {
        const elRect = this.element.getBoundingClientRect();
        const parentRect = this.offsetParent.getBoundingClientRect();
        const boundaryElRect = this.boundaryEl.getBoundingClientRect();
        const xPosition = this.config.popup ? this.position.x : elRect.left;
        let skipX = xPosition <= 0 && parentRect.left >= e.clientX || parentRect.right <= e.clientX && parentRect.right <= boundaryElRect.right;
        if (skipX) return true;
        if (isLeft) skipX = // is positioned to the right of the left side anchor
        diff < 0 && e.clientX > xPosition + parentRect.left || // skip if we are moving to the right and the cursor
        // is positioned to the left of the dialog
        diff > 0 && e.clientX < xPosition + parentRect.left;
        else if (anywhereWithin) skipX = diff < 0 && e.clientX > boundaryElRect.right || diff > 0 && e.clientX < xPosition + parentRect.left;
        else skipX = // we skip if we are moving to the left and the cursor
        // is to the right of the dialog
        diff < 0 && e.clientX > boundaryElRect.right || // or skip if we are moving to the right and the cursor
        // is to the left of the right side anchor
        diff > 0 && e.clientX < boundaryElRect.right;
        return skipX;
    }
    shouldSkipY(e, isTop, topBuffer = 0, diff) {
        const elRect = this.element.getBoundingClientRect();
        const parentRect = this.offsetParent.getBoundingClientRect();
        const boundaryElRect = this.boundaryEl.getBoundingClientRect();
        const yPosition = this.config.popup ? this.position.y : elRect.top;
        let skipY = yPosition <= 0 && parentRect.top >= e.clientY || parentRect.bottom <= e.clientY && parentRect.bottom <= boundaryElRect.bottom;
        if (skipY) return true;
        if (isTop) skipY = // below the top anchor + topBuffer
        // note: topBuffer is used when moving the dialog using the title bar
        diff < 0 && e.clientY > yPosition + parentRect.top + topBuffer || // skip if we are moving to the bottom and the cursor is
        // above the top anchor
        diff > 0 && e.clientY < yPosition + parentRect.top;
        else skipY = // is below the bottom anchor
        diff < 0 && e.clientY > boundaryElRect.bottom || // skip if we are moving towards the bottom and the cursor
        // is above the bottom anchor
        diff > 0 && e.clientY < boundaryElRect.bottom;
        return skipY;
    }
    createResizeMap() {
        const eGui = this.element;
        this.resizerMap = {
            topLeft: {
                element: eGui.querySelector("[ref=eTopLeftResizer]")
            },
            top: {
                element: eGui.querySelector("[ref=eTopResizer]")
            },
            topRight: {
                element: eGui.querySelector("[ref=eTopRightResizer]")
            },
            right: {
                element: eGui.querySelector("[ref=eRightResizer]")
            },
            bottomRight: {
                element: eGui.querySelector("[ref=eBottomRightResizer]")
            },
            bottom: {
                element: eGui.querySelector("[ref=eBottomResizer]")
            },
            bottomLeft: {
                element: eGui.querySelector("[ref=eBottomLeftResizer]")
            },
            left: {
                element: eGui.querySelector("[ref=eLeftResizer]")
            }
        };
    }
    addResizers() {
        if (this.resizersAdded) return;
        const eGui = this.element;
        if (!eGui) return;
        const parser = new DOMParser();
        const resizers = parser.parseFromString($437b23f6a393c3bf$var$RESIZE_TEMPLATE, "text/html").body;
        eGui.appendChild(resizers.firstChild);
        this.createResizeMap();
        this.resizersAdded = true;
    }
    removeResizers() {
        this.resizerMap = void 0;
        const resizerEl = this.element.querySelector(`.${$437b23f6a393c3bf$var$RESIZE_CONTAINER_STYLE}`);
        if (resizerEl) this.element.removeChild(resizerEl);
        this.resizersAdded = false;
    }
    getResizerElement(side) {
        return this.resizerMap[side].element;
    }
    onResizeStart(e, side) {
        this.boundaryEl = this.findBoundaryElement();
        if (!this.positioned) this.initialisePosition();
        this.currentResizer = {
            isTop: !!side.match(/top/i),
            isRight: !!side.match(/right/i),
            isBottom: !!side.match(/bottom/i),
            isLeft: !!side.match(/left/i)
        };
        this.element.classList.add("ag-resizing");
        this.resizerMap[side].element.classList.add("ag-active");
        const { popup: popup, forcePopupParentAsOffsetParent: forcePopupParentAsOffsetParent } = this.config;
        if (!popup && !forcePopupParentAsOffsetParent) this.applySizeToSiblings(this.currentResizer.isBottom || this.currentResizer.isTop);
        this.isResizing = true;
        this.updateDragStartPosition(e.clientX, e.clientY);
    }
    getSiblings() {
        const element = this.element;
        const parent = element.parentElement;
        if (!parent) return null;
        return Array.prototype.slice.call(parent.children).filter((el)=>!el.classList.contains("ag-hidden"));
    }
    getMinSizeOfSiblings() {
        const siblings = this.getSiblings() || [];
        let height = 0;
        let width = 0;
        for(let i = 0; i < siblings.length; i++){
            const currentEl = siblings[i];
            const isFlex = !!currentEl.style.flex && currentEl.style.flex !== "0 0 auto";
            if (currentEl === this.element) continue;
            let nextHeight = this.minHeight || 0;
            let nextWidth = this.minWidth || 0;
            if (isFlex) {
                const computedStyle = window.getComputedStyle(currentEl);
                if (computedStyle.minHeight) nextHeight = parseInt(computedStyle.minHeight, 10);
                if (computedStyle.minWidth) nextWidth = parseInt(computedStyle.minWidth, 10);
            } else {
                nextHeight = currentEl.offsetHeight;
                nextWidth = currentEl.offsetWidth;
            }
            height += nextHeight;
            width += nextWidth;
        }
        return {
            height: height,
            width: width
        };
    }
    applySizeToSiblings(vertical) {
        let containerToFlex = null;
        const siblings = this.getSiblings();
        if (!siblings) return;
        for(let i = 0; i < siblings.length; i++){
            const el = siblings[i];
            if (el === containerToFlex) continue;
            if (vertical) el.style.height = `${el.offsetHeight}px`;
            else el.style.width = `${el.offsetWidth}px`;
            el.style.flex = "0 0 auto";
            if (el === this.element) containerToFlex = siblings[i + 1];
        }
        if (containerToFlex) {
            containerToFlex.style.removeProperty("height");
            containerToFlex.style.removeProperty("min-height");
            containerToFlex.style.removeProperty("max-height");
            containerToFlex.style.flex = "1 1 auto";
        }
    }
    isResizable() {
        return Object.values(this.resizable).some((value)=>value);
    }
    onResize(e) {
        if (!this.isResizing || !this.currentResizer) return;
        const { popup: popup, forcePopupParentAsOffsetParent: forcePopupParentAsOffsetParent } = this.config;
        const { isTop: isTop, isRight: isRight, isBottom: isBottom, isLeft: isLeft } = this.currentResizer;
        const isHorizontal = isRight || isLeft;
        const isVertical = isBottom || isTop;
        const { movementX: movementX, movementY: movementY } = this.calculateMouseMovement({
            e: e,
            isLeft: isLeft,
            isTop: isTop
        });
        const xPosition = this.position.x;
        const yPosition = this.position.y;
        let offsetLeft = 0;
        let offsetTop = 0;
        if (isHorizontal && movementX) {
            const direction = isLeft ? -1 : 1;
            const oldWidth = this.getWidth();
            const newWidth = oldWidth + movementX * direction;
            let skipWidth = false;
            if (isLeft) {
                offsetLeft = oldWidth - newWidth;
                if (xPosition + offsetLeft <= 0 || newWidth <= this.minWidth) {
                    skipWidth = true;
                    offsetLeft = 0;
                }
            }
            if (!skipWidth) this.setWidth(newWidth);
        }
        if (isVertical && movementY) {
            const direction = isTop ? -1 : 1;
            const oldHeight = this.getHeight();
            const newHeight = oldHeight + movementY * direction;
            let skipHeight = false;
            if (isTop) {
                offsetTop = oldHeight - newHeight;
                if (yPosition + offsetTop <= 0 || newHeight <= this.minHeight) {
                    skipHeight = true;
                    offsetTop = 0;
                }
            } else if (!this.config.popup && !this.config.forcePopupParentAsOffsetParent && oldHeight < newHeight && this.getMinSizeOfSiblings().height + newHeight > this.element.parentElement.offsetHeight) skipHeight = true;
            if (!skipHeight) this.setHeight(newHeight);
        }
        this.updateDragStartPosition(e.clientX, e.clientY);
        if ((popup || forcePopupParentAsOffsetParent) && offsetLeft || offsetTop) this.offsetElement(xPosition + offsetLeft, yPosition + offsetTop);
    }
    onResizeEnd(e, side) {
        this.isResizing = false;
        this.currentResizer = null;
        this.boundaryEl = null;
        const params = {
            type: "resize"
        };
        this.element.classList.remove("ag-resizing");
        this.resizerMap[side].element.classList.remove("ag-active");
        this.dispatchEvent(params);
    }
    refreshSize() {
        const eGui = this.element;
        if (this.config.popup) {
            if (!this.config.width) this.setWidth(eGui.offsetWidth);
            if (!this.config.height) this.setHeight(eGui.offsetHeight);
        }
    }
    onMoveStart(e) {
        this.boundaryEl = this.findBoundaryElement();
        if (!this.positioned) this.initialisePosition();
        this.isMoving = true;
        this.element.classList.add("ag-moving");
        this.updateDragStartPosition(e.clientX, e.clientY);
    }
    onMove(e) {
        if (!this.isMoving) return;
        const { x: x, y: y } = this.position;
        let topBuffer;
        if (this.config.calculateTopBuffer) topBuffer = this.config.calculateTopBuffer();
        const { movementX: movementX, movementY: movementY } = this.calculateMouseMovement({
            e: e,
            isTop: true,
            anywhereWithin: true,
            topBuffer: topBuffer
        });
        this.offsetElement(x + movementX, y + movementY);
        this.updateDragStartPosition(e.clientX, e.clientY);
    }
    onMoveEnd() {
        this.isMoving = false;
        this.boundaryEl = null;
        this.element.classList.remove("ag-moving");
    }
    setOffsetParent() {
        if (this.config.forcePopupParentAsOffsetParent) this.offsetParent = this.popupService.getPopupParent();
        else this.offsetParent = this.element.offsetParent;
    }
    findBoundaryElement() {
        let el = this.element;
        while(el){
            if (window.getComputedStyle(el).position !== "static") return el;
            el = el.parentElement;
        }
        return this.element;
    }
    clearResizeListeners() {
        while(this.resizeListeners.length){
            const params = this.resizeListeners.pop();
            this.dragService.removeDragSource(params);
        }
    }
    destroy() {
        super.destroy();
        if (this.moveElementDragListener) this.dragService.removeDragSource(this.moveElementDragListener);
        this.constrainSizeToAvailableHeight(false);
        this.clearResizeListeners();
        this.removeResizers();
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("popupService")
], $437b23f6a393c3bf$export$c53a5d9f1fb0f7f6.prototype, "popupService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("resizeObserverService")
], $437b23f6a393c3bf$export$c53a5d9f1fb0f7f6.prototype, "resizeObserverService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("dragService")
], $437b23f6a393c3bf$export$c53a5d9f1fb0f7f6.prototype, "dragService", 2);
// community-modules/core/src/filter/provided/providedFilter.ts
var $437b23f6a393c3bf$var$_ProvidedFilter = class _ProvidedFilter extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(filterNameKey){
        super();
        this.filterNameKey = filterNameKey;
        this.applyActive = false;
        this.hidePopup = null;
        this.debouncePending = false;
        // after the user hits 'apply' the model gets copied to here. this is then the model that we use for
        // all filtering. so if user changes UI but doesn't hit apply, then the UI will be out of sync with this model.
        // this is what we want, as the UI should only become the 'active' filter once it's applied. when apply is
        // inactive, this model will be in sync (following the debounce ms). if the UI is not a valid filter
        // (eg the value is missing so nothing to filter on, or for set filter all checkboxes are checked so filter
        // not active) then this appliedModel will be null/undefined.
        this.appliedModel = null;
        this.buttonListeners = [];
    }
    postConstruct() {
        this.resetTemplate();
        this.createManagedBean(new $437b23f6a393c3bf$export$5510e53ed3962582(this.getFocusableElement(), {
            handleKeyDown: this.handleKeyDown.bind(this)
        }));
        this.positionableFeature = new $437b23f6a393c3bf$export$c53a5d9f1fb0f7f6(this.getPositionableElement(), {
            forcePopupParentAsOffsetParent: true
        });
        this.createBean(this.positionableFeature);
    }
    // override
    handleKeyDown(e) {}
    getFilterTitle() {
        return this.translate(this.filterNameKey);
    }
    isFilterActive() {
        return !!this.appliedModel;
    }
    resetTemplate(paramsMap) {
        let eGui = this.getGui();
        if (eGui) eGui.removeEventListener("submit", this.onFormSubmit);
        const templateString = /* html */ `
            <form class="ag-filter-wrapper">
                <div class="ag-filter-body-wrapper ag-${this.getCssIdentifier()}-body-wrapper" ref="eFilterBody">
                    ${this.createBodyTemplate()}
                </div>
            </form>`;
        this.setTemplate(templateString, paramsMap);
        eGui = this.getGui();
        if (eGui) eGui.addEventListener("submit", this.onFormSubmit);
    }
    isReadOnly() {
        return !!this.providedFilterParams.readOnly;
    }
    init(params) {
        this.setParams(params);
        this.resetUiToDefaults(true).then(()=>{
            this.updateUiVisibility();
            this.setupOnBtApplyDebounce();
        });
    }
    setParams(params) {
        this.providedFilterParams = params;
        this.applyActive = _ProvidedFilter.isUseApplyButton(params);
        this.resetButtonsPanel();
    }
    updateParams(params) {
        this.providedFilterParams = params;
        this.applyActive = _ProvidedFilter.isUseApplyButton(params);
        this.resetUiToActiveModel(this.getModel(), ()=>{
            this.updateUiVisibility();
            this.setupOnBtApplyDebounce();
        });
    }
    resetButtonsPanel() {
        const { buttons: buttons } = this.providedFilterParams;
        const hasButtons = buttons && buttons.length > 0 && !this.isReadOnly();
        if (!this.eButtonsPanel) {
            if (hasButtons) {
                this.eButtonsPanel = document.createElement("div");
                this.eButtonsPanel.classList.add("ag-filter-apply-panel");
            }
        } else {
            $437b23f6a393c3bf$var$clearElement(this.eButtonsPanel);
            this.buttonListeners.forEach((destroyFunc)=>destroyFunc == null ? void 0 : destroyFunc());
            this.buttonListeners = [];
        }
        if (!hasButtons) {
            if (this.eButtonsPanel) $437b23f6a393c3bf$var$removeFromParent(this.eButtonsPanel);
            return;
        }
        const fragment = document.createDocumentFragment();
        const addButton = (type)=>{
            let text;
            let clickListener;
            switch(type){
                case "apply":
                    text = this.translate("applyFilter");
                    clickListener = (e)=>this.onBtApply(false, false, e);
                    break;
                case "clear":
                    text = this.translate("clearFilter");
                    clickListener = ()=>this.onBtClear();
                    break;
                case "reset":
                    text = this.translate("resetFilter");
                    clickListener = ()=>this.onBtReset();
                    break;
                case "cancel":
                    text = this.translate("cancelFilter");
                    clickListener = (e)=>{
                        this.onBtCancel(e);
                    };
                    break;
                default:
                    console.warn("AG Grid: Unknown button type specified");
                    return;
            }
            const buttonType = type === "apply" ? "submit" : "button";
            const button = $437b23f6a393c3bf$var$loadTemplate(/* html */ `<button
                    type="${buttonType}"
                    ref="${type}FilterButton"
                    class="ag-button ag-standard-button ag-filter-apply-panel-button"
                >${text}
                </button>`);
            this.buttonListeners.push(this.addManagedListener(button, "click", clickListener));
            fragment.append(button);
        };
        $437b23f6a393c3bf$var$convertToSet(buttons).forEach((type)=>addButton(type));
        this.eButtonsPanel.append(fragment);
        this.getGui().appendChild(this.eButtonsPanel);
    }
    // subclasses can override this to provide alternative debounce defaults
    getDefaultDebounceMs() {
        return 0;
    }
    setupOnBtApplyDebounce() {
        const debounceMs = _ProvidedFilter.getDebounceMs(this.providedFilterParams, this.getDefaultDebounceMs());
        const debounceFunc = $437b23f6a393c3bf$var$debounce(this.checkApplyDebounce.bind(this), debounceMs);
        this.onBtApplyDebounce = ()=>{
            this.debouncePending = true;
            debounceFunc();
        };
    }
    checkApplyDebounce() {
        if (this.debouncePending) {
            this.debouncePending = false;
            this.onBtApply();
        }
    }
    getModel() {
        return this.appliedModel ? this.appliedModel : null;
    }
    setModel(model) {
        const promise = model != null ? this.setModelIntoUi(model) : this.resetUiToDefaults();
        return promise.then(()=>{
            this.updateUiVisibility();
            this.applyModel("api");
        });
    }
    onBtCancel(e) {
        this.resetUiToActiveModel(this.getModel(), ()=>{
            this.handleCancelEnd(e);
        });
    }
    handleCancelEnd(e) {
        if (this.providedFilterParams.closeOnApply) this.close(e);
    }
    resetUiToActiveModel(currentModel, afterUiUpdatedFunc) {
        const afterAppliedFunc = ()=>{
            this.onUiChanged(false, "prevent");
            afterUiUpdatedFunc == null || afterUiUpdatedFunc();
        };
        if (currentModel != null) this.setModelIntoUi(currentModel).then(afterAppliedFunc);
        else this.resetUiToDefaults().then(afterAppliedFunc);
    }
    onBtClear() {
        this.resetUiToDefaults().then(()=>this.onUiChanged());
    }
    onBtReset() {
        this.onBtClear();
        this.onBtApply();
    }
    /**
   * Applies changes made in the UI to the filter, and returns true if the model has changed.
   */ applyModel(source = "api") {
        const newModel = this.getModelFromUi();
        if (!this.isModelValid(newModel)) return false;
        const previousModel = this.appliedModel;
        this.appliedModel = newModel;
        return !this.areModelsEqual(previousModel, newModel);
    }
    isModelValid(model) {
        return true;
    }
    onFormSubmit(e) {
        e.preventDefault();
    }
    onBtApply(afterFloatingFilter = false, afterDataChange = false, e) {
        if (e) e.preventDefault();
        if (this.applyModel(afterDataChange ? "rowDataUpdated" : "ui")) {
            const source = "columnFilter";
            this.providedFilterParams.filterChangedCallback({
                afterFloatingFilter: afterFloatingFilter,
                afterDataChange: afterDataChange,
                source: source
            });
        }
        const { closeOnApply: closeOnApply } = this.providedFilterParams;
        if (closeOnApply && this.applyActive && !afterFloatingFilter && !afterDataChange) this.close(e);
    }
    onNewRowsLoaded() {}
    close(e) {
        if (!this.hidePopup) return;
        const keyboardEvent = e;
        const key = keyboardEvent && keyboardEvent.key;
        let params;
        if (key === "Enter" || key === "Space") params = {
            keyboardEvent: keyboardEvent
        };
        this.hidePopup(params);
        this.hidePopup = null;
    }
    /**
   * By default, if the change came from a floating filter it will be applied immediately, otherwise if there is no
   * apply button it will be applied after a debounce, otherwise it will not be applied at all. This behaviour can
   * be adjusted by using the apply parameter.
   */ onUiChanged(fromFloatingFilter = false, apply) {
        this.updateUiVisibility();
        this.providedFilterParams.filterModifiedCallback();
        if (this.applyActive && !this.isReadOnly()) {
            const isValid = this.isModelValid(this.getModelFromUi());
            const applyFilterButton = this.getRefElement("applyFilterButton");
            if (applyFilterButton) $437b23f6a393c3bf$var$setDisabled(applyFilterButton, !isValid);
        }
        if (fromFloatingFilter && !apply || apply === "immediately") this.onBtApply(fromFloatingFilter);
        else if (!this.applyActive && !apply || apply === "debounce") this.onBtApplyDebounce();
    }
    afterGuiAttached(params) {
        if (params) this.hidePopup = params.hidePopup;
        this.refreshFilterResizer(params == null ? void 0 : params.container);
    }
    refreshFilterResizer(containerType) {
        if (!this.positionableFeature || containerType === "toolPanel") return;
        const isResizable = containerType === "floatingFilter" || containerType === "columnFilter";
        const { positionableFeature: positionableFeature, gos: gos } = this;
        if (isResizable) {
            positionableFeature.restoreLastSize();
            positionableFeature.setResizable(gos.get("enableRtl") ? {
                bottom: true,
                bottomLeft: true,
                left: true
            } : {
                bottom: true,
                bottomRight: true,
                right: true
            });
        } else {
            this.positionableFeature.removeSizeFromEl();
            this.positionableFeature.setResizable(false);
        }
        this.positionableFeature.constrainSizeToAvailableHeight(true);
    }
    afterGuiDetached() {
        this.checkApplyDebounce();
        if (this.positionableFeature) this.positionableFeature.constrainSizeToAvailableHeight(false);
    }
    // static, as used by floating filter also
    static getDebounceMs(params, debounceDefault) {
        if (_ProvidedFilter.isUseApplyButton(params)) {
            if (params.debounceMs != null) console.warn("AG Grid: debounceMs is ignored when apply button is present");
            return 0;
        }
        return params.debounceMs != null ? params.debounceMs : debounceDefault;
    }
    // static, as used by floating filter also
    static isUseApplyButton(params) {
        return !!params.buttons && params.buttons.indexOf("apply") >= 0;
    }
    refresh(newParams) {
        this.providedFilterParams = newParams;
        return true;
    }
    destroy() {
        const eGui = this.getGui();
        if (eGui) eGui.removeEventListener("submit", this.onFormSubmit);
        this.hidePopup = null;
        if (this.positionableFeature) this.positionableFeature = this.destroyBean(this.positionableFeature);
        this.appliedModel = null;
        super.destroy();
    }
    translate(key) {
        const translate = this.localeService.getLocaleTextFunc();
        return translate(key, $437b23f6a393c3bf$var$FILTER_LOCALE_TEXT[key]);
    }
    getCellValue(rowNode) {
        return this.providedFilterParams.getValue(rowNode);
    }
    // override to control positionable feature
    getPositionableElement() {
        return this.eFilterBody;
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowModel")
], $437b23f6a393c3bf$var$_ProvidedFilter.prototype, "rowModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eFilterBody")
], $437b23f6a393c3bf$var$_ProvidedFilter.prototype, "eFilterBody", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$_ProvidedFilter.prototype, "postConstruct", 1);
var $437b23f6a393c3bf$export$a927a1327c2cc7f0 = $437b23f6a393c3bf$var$_ProvidedFilter;
// community-modules/core/src/widgets/agAbstractLabel.ts
var $437b23f6a393c3bf$export$d72ea6e1c340e03b = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(config, template){
        super(template);
        this.labelSeparator = "";
        this.labelAlignment = "left";
        this.disabled = false;
        this.label = "";
        this.config = config || {};
    }
    postConstruct() {
        this.addCssClass("ag-labeled");
        this.eLabel.classList.add("ag-label");
        const { labelSeparator: labelSeparator, label: label, labelWidth: labelWidth, labelAlignment: labelAlignment, disabled: disabled } = this.config;
        if (disabled != null) this.setDisabled(disabled);
        if (labelSeparator != null) this.setLabelSeparator(labelSeparator);
        if (label != null) this.setLabel(label);
        if (labelWidth != null) this.setLabelWidth(labelWidth);
        this.setLabelAlignment(labelAlignment || this.labelAlignment);
        this.refreshLabel();
    }
    refreshLabel() {
        $437b23f6a393c3bf$var$clearElement(this.eLabel);
        if (typeof this.label === "string") this.eLabel.innerText = this.label + this.labelSeparator;
        else if (this.label) this.eLabel.appendChild(this.label);
        if (this.label === "") {
            $437b23f6a393c3bf$var$setDisplayed(this.eLabel, false);
            $437b23f6a393c3bf$var$setAriaRole(this.eLabel, "presentation");
        } else {
            $437b23f6a393c3bf$var$setDisplayed(this.eLabel, true);
            $437b23f6a393c3bf$var$setAriaRole(this.eLabel, null);
        }
    }
    setLabelSeparator(labelSeparator) {
        if (this.labelSeparator === labelSeparator) return this;
        this.labelSeparator = labelSeparator;
        if (this.label != null) this.refreshLabel();
        return this;
    }
    getLabelId() {
        this.eLabel.id = this.eLabel.id || `ag-${this.getCompId()}-label`;
        return this.eLabel.id;
    }
    getLabel() {
        return this.label;
    }
    setLabel(label) {
        if (this.label === label) return this;
        this.label = label;
        this.refreshLabel();
        return this;
    }
    setLabelAlignment(alignment) {
        const eGui = this.getGui();
        const eGuiClassList = eGui.classList;
        eGuiClassList.toggle("ag-label-align-left", alignment === "left");
        eGuiClassList.toggle("ag-label-align-right", alignment === "right");
        eGuiClassList.toggle("ag-label-align-top", alignment === "top");
        return this;
    }
    setLabelEllipsis(hasEllipsis) {
        this.eLabel.classList.toggle("ag-label-ellipsis", hasEllipsis);
        return this;
    }
    setLabelWidth(width) {
        if (this.label == null) return this;
        $437b23f6a393c3bf$var$setElementWidth(this.eLabel, width);
        return this;
    }
    setDisabled(disabled) {
        disabled = !!disabled;
        const element = this.getGui();
        $437b23f6a393c3bf$var$setDisabled(element, disabled);
        element.classList.toggle("ag-disabled", disabled);
        this.disabled = disabled;
        return this;
    }
    isDisabled() {
        return !!this.disabled;
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$export$d72ea6e1c340e03b.prototype, "postConstruct", 1);
// community-modules/core/src/widgets/agAbstractField.ts
var $437b23f6a393c3bf$export$8889445e1e1d2c89 = class extends $437b23f6a393c3bf$export$d72ea6e1c340e03b {
    constructor(config, template, className){
        super(config, template);
        this.className = className;
    }
    postConstruct() {
        super.postConstruct();
        const { width: width, value: value, onValueChange: onValueChange } = this.config;
        if (width != null) this.setWidth(width);
        if (value != null) this.setValue(value);
        if (onValueChange != null) this.onValueChange(onValueChange);
        if (this.className) this.addCssClass(this.className);
        this.refreshAriaLabelledBy();
    }
    refreshAriaLabelledBy() {
        const ariaEl = this.getAriaElement();
        const labelId = this.getLabelId();
        if ($437b23f6a393c3bf$var$getAriaLabel(ariaEl) !== null) $437b23f6a393c3bf$var$setAriaLabelledBy(ariaEl, "");
        else $437b23f6a393c3bf$var$setAriaLabelledBy(ariaEl, labelId != null ? labelId : "");
    }
    setAriaLabel(label) {
        $437b23f6a393c3bf$var$setAriaLabel(this.getAriaElement(), label);
        this.refreshAriaLabelledBy();
        return this;
    }
    onValueChange(callbackFn) {
        this.addManagedListener(this, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_FIELD_VALUE_CHANGED, ()=>callbackFn(this.getValue()));
        return this;
    }
    getWidth() {
        return this.getGui().clientWidth;
    }
    setWidth(width) {
        $437b23f6a393c3bf$var$setFixedWidth(this.getGui(), width);
        return this;
    }
    getPreviousValue() {
        return this.previousValue;
    }
    getValue() {
        return this.value;
    }
    setValue(value, silent) {
        if (this.value === value) return this;
        this.previousValue = this.value;
        this.value = value;
        if (!silent) this.dispatchEvent({
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_FIELD_VALUE_CHANGED
        });
        return this;
    }
};
// community-modules/core/src/widgets/agPickerField.ts
var $437b23f6a393c3bf$var$TEMPLATE = /* html */ `
    <div class="ag-picker-field" role="presentation">
        <div ref="eLabel"></div>
            <div ref="eWrapper" class="ag-wrapper ag-picker-field-wrapper ag-picker-collapsed">
            <div ref="eDisplayField" class="ag-picker-field-display"></div>
            <div ref="eIcon" class="ag-picker-field-icon" aria-hidden="true"></div>
        </div>
    </div>`;
var $437b23f6a393c3bf$export$1f14489b6fdeb99b = class extends $437b23f6a393c3bf$export$8889445e1e1d2c89 {
    constructor(config){
        super(config, (config == null ? void 0 : config.template) || $437b23f6a393c3bf$var$TEMPLATE, config == null ? void 0 : config.className);
        this.isPickerDisplayed = false;
        this.skipClick = false;
        this.pickerGap = 4;
        this.hideCurrentPicker = null;
        this.ariaRole = config == null ? void 0 : config.ariaRole;
        this.onPickerFocusIn = this.onPickerFocusIn.bind(this);
        this.onPickerFocusOut = this.onPickerFocusOut.bind(this);
        if (!config) return;
        const { pickerGap: pickerGap, maxPickerHeight: maxPickerHeight, variableWidth: variableWidth, minPickerWidth: minPickerWidth, maxPickerWidth: maxPickerWidth } = config;
        if (pickerGap != null) this.pickerGap = pickerGap;
        this.variableWidth = !!variableWidth;
        if (maxPickerHeight != null) this.setPickerMaxHeight(maxPickerHeight);
        if (minPickerWidth != null) this.setPickerMinWidth(minPickerWidth);
        if (maxPickerWidth != null) this.setPickerMaxWidth(maxPickerWidth);
    }
    postConstruct() {
        super.postConstruct();
        this.setupAria();
        const displayId = `ag-${this.getCompId()}-display`;
        this.eDisplayField.setAttribute("id", displayId);
        const ariaEl = this.getAriaElement();
        this.addManagedListener(ariaEl, "keydown", this.onKeyDown.bind(this));
        this.addManagedListener(this.eLabel, "mousedown", this.onLabelOrWrapperMouseDown.bind(this));
        this.addManagedListener(this.eWrapper, "mousedown", this.onLabelOrWrapperMouseDown.bind(this));
        const { pickerIcon: pickerIcon, inputWidth: inputWidth } = this.config;
        if (pickerIcon) {
            const icon = $437b23f6a393c3bf$var$createIconNoSpan(pickerIcon, this.gos);
            if (icon) this.eIcon.appendChild(icon);
        }
        if (inputWidth != null) this.setInputWidth(inputWidth);
    }
    setupAria() {
        const ariaEl = this.getAriaElement();
        ariaEl.setAttribute("tabindex", this.gos.get("tabIndex").toString());
        $437b23f6a393c3bf$var$setAriaExpanded(ariaEl, false);
        if (this.ariaRole) $437b23f6a393c3bf$var$setAriaRole(ariaEl, this.ariaRole);
    }
    onLabelOrWrapperMouseDown(e) {
        if (e) {
            const focusableEl = this.getFocusableElement();
            if (focusableEl !== this.eWrapper && (e == null ? void 0 : e.target) === focusableEl) return;
            e.preventDefault();
            this.getFocusableElement().focus();
        }
        if (this.skipClick) {
            this.skipClick = false;
            return;
        }
        if (this.isDisabled()) return;
        if (this.isPickerDisplayed) this.hidePicker();
        else this.showPicker();
    }
    onKeyDown(e) {
        switch(e.key){
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.SPACE:
                e.preventDefault();
                this.onLabelOrWrapperMouseDown();
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ESCAPE:
                if (this.isPickerDisplayed) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (this.hideCurrentPicker) this.hideCurrentPicker();
                }
                break;
        }
    }
    showPicker() {
        this.isPickerDisplayed = true;
        if (!this.pickerComponent) this.pickerComponent = this.createPickerComponent();
        const pickerGui = this.pickerComponent.getGui();
        pickerGui.addEventListener("focusin", this.onPickerFocusIn);
        pickerGui.addEventListener("focusout", this.onPickerFocusOut);
        this.hideCurrentPicker = this.renderAndPositionPicker();
        this.toggleExpandedStyles(true);
    }
    renderAndPositionPicker() {
        const eDocument = this.gos.getDocument();
        const ePicker = this.pickerComponent.getGui();
        if (!this.gos.get("suppressScrollWhenPopupsAreOpen")) this.destroyMouseWheelFunc = this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_BODY_SCROLL, ()=>{
            this.hidePicker();
        });
        const translate = this.localeService.getLocaleTextFunc();
        const { pickerAriaLabelKey: pickerAriaLabelKey, pickerAriaLabelValue: pickerAriaLabelValue, modalPicker: modalPicker = true } = this.config;
        const popupParams = {
            modal: modalPicker,
            eChild: ePicker,
            closeOnEsc: true,
            closedCallback: ()=>{
                const activeEl = this.gos.getActiveDomElement();
                const shouldRestoreFocus = !activeEl || activeEl === eDocument.body;
                this.beforeHidePicker();
                if (shouldRestoreFocus && this.isAlive()) this.getFocusableElement().focus();
            },
            ariaLabel: translate(pickerAriaLabelKey, pickerAriaLabelValue)
        };
        const addPopupRes = this.popupService.addPopup(popupParams);
        const { maxPickerHeight: maxPickerHeight, minPickerWidth: minPickerWidth, maxPickerWidth: maxPickerWidth, variableWidth: variableWidth } = this;
        if (variableWidth) {
            if (minPickerWidth) ePicker.style.minWidth = minPickerWidth;
            ePicker.style.width = $437b23f6a393c3bf$var$formatSize($437b23f6a393c3bf$var$getAbsoluteWidth(this.eWrapper));
            if (maxPickerWidth) ePicker.style.maxWidth = maxPickerWidth;
        } else $437b23f6a393c3bf$var$setElementWidth(ePicker, maxPickerWidth != null ? maxPickerWidth : $437b23f6a393c3bf$var$getAbsoluteWidth(this.eWrapper));
        const maxHeight = maxPickerHeight != null ? maxPickerHeight : `${$437b23f6a393c3bf$var$getInnerHeight(this.popupService.getPopupParent())}px`;
        ePicker.style.setProperty("max-height", maxHeight);
        ePicker.style.position = "absolute";
        this.alignPickerToComponent();
        return addPopupRes.hideFunc;
    }
    alignPickerToComponent() {
        if (!this.pickerComponent) return;
        const { pickerType: pickerType } = this.config;
        const { pickerGap: pickerGap } = this;
        const alignSide = this.gos.get("enableRtl") ? "right" : "left";
        this.popupService.positionPopupByComponent({
            type: pickerType,
            eventSource: this.eWrapper,
            ePopup: this.pickerComponent.getGui(),
            position: "under",
            alignSide: alignSide,
            keepWithinBounds: true,
            nudgeY: pickerGap
        });
    }
    beforeHidePicker() {
        if (this.destroyMouseWheelFunc) {
            this.destroyMouseWheelFunc();
            this.destroyMouseWheelFunc = void 0;
        }
        this.toggleExpandedStyles(false);
        const pickerGui = this.pickerComponent.getGui();
        pickerGui.removeEventListener("focusin", this.onPickerFocusIn);
        pickerGui.removeEventListener("focusout", this.onPickerFocusOut);
        this.isPickerDisplayed = false;
        this.pickerComponent = void 0;
        this.hideCurrentPicker = null;
    }
    toggleExpandedStyles(expanded) {
        if (!this.isAlive()) return;
        const ariaEl = this.getAriaElement();
        $437b23f6a393c3bf$var$setAriaExpanded(ariaEl, expanded);
        this.eWrapper.classList.toggle("ag-picker-expanded", expanded);
        this.eWrapper.classList.toggle("ag-picker-collapsed", !expanded);
    }
    onPickerFocusIn() {
        this.togglePickerHasFocus(true);
    }
    onPickerFocusOut(e) {
        var _a;
        if (!((_a = this.pickerComponent) == null ? void 0 : _a.getGui().contains(e.relatedTarget))) this.togglePickerHasFocus(false);
    }
    togglePickerHasFocus(focused) {
        if (!this.pickerComponent) return;
        this.eWrapper.classList.toggle("ag-picker-has-focus", focused);
    }
    hidePicker() {
        if (this.hideCurrentPicker) this.hideCurrentPicker();
    }
    setInputWidth(width) {
        $437b23f6a393c3bf$var$setElementWidth(this.eWrapper, width);
        return this;
    }
    getFocusableElement() {
        return this.eWrapper;
    }
    setPickerGap(gap) {
        this.pickerGap = gap;
        return this;
    }
    setPickerMinWidth(width) {
        if (typeof width === "number") width = `${width}px`;
        this.minPickerWidth = width == null ? void 0 : width;
        return this;
    }
    setPickerMaxWidth(width) {
        if (typeof width === "number") width = `${width}px`;
        this.maxPickerWidth = width == null ? void 0 : width;
        return this;
    }
    setPickerMaxHeight(height) {
        if (typeof height === "number") height = `${height}px`;
        this.maxPickerHeight = height == null ? void 0 : height;
        return this;
    }
    destroy() {
        this.hidePicker();
        super.destroy();
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("popupService")
], $437b23f6a393c3bf$export$1f14489b6fdeb99b.prototype, "popupService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eLabel")
], $437b23f6a393c3bf$export$1f14489b6fdeb99b.prototype, "eLabel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eWrapper")
], $437b23f6a393c3bf$export$1f14489b6fdeb99b.prototype, "eWrapper", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eDisplayField")
], $437b23f6a393c3bf$export$1f14489b6fdeb99b.prototype, "eDisplayField", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eIcon")
], $437b23f6a393c3bf$export$1f14489b6fdeb99b.prototype, "eIcon", 2);
// community-modules/core/src/widgets/agList.ts
var $437b23f6a393c3bf$var$_AgList = class _AgList extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(cssIdentifier = "default", unFocusable = false){
        super(/* html */ `<div class="ag-list ag-${cssIdentifier}-list" role="listbox"></div>`);
        this.cssIdentifier = cssIdentifier;
        this.unFocusable = unFocusable;
        this.options = [];
        this.itemEls = [];
    }
    init() {
        const eGui = this.getGui();
        this.addManagedListener(eGui, "mouseleave", ()=>this.clearHighlighted());
        if (this.unFocusable) return;
        this.addManagedListener(eGui, "keydown", this.handleKeyDown.bind(this));
    }
    handleKeyDown(e) {
        const key = e.key;
        switch(key){
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER:
                if (!this.highlightedEl) this.setValue(this.getValue());
                else {
                    const pos = this.itemEls.indexOf(this.highlightedEl);
                    this.setValueByIndex(pos);
                }
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
                e.preventDefault();
                this.navigate(key);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_DOWN:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_UP:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_HOME:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_END:
                e.preventDefault();
                this.navigateToPage(key);
                break;
        }
    }
    navigate(key) {
        const isDown = key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN;
        let itemToHighlight;
        if (!this.highlightedEl) itemToHighlight = this.itemEls[isDown ? 0 : this.itemEls.length - 1];
        else {
            const currentIdx = this.itemEls.indexOf(this.highlightedEl);
            let nextPos = currentIdx + (isDown ? 1 : -1);
            nextPos = Math.min(Math.max(nextPos, 0), this.itemEls.length - 1);
            itemToHighlight = this.itemEls[nextPos];
        }
        this.highlightItem(itemToHighlight);
    }
    navigateToPage(key) {
        if (!this.highlightedEl || this.itemEls.length === 0) return;
        const currentIdx = this.itemEls.indexOf(this.highlightedEl);
        const rowCount = this.options.length - 1;
        const itemHeight = this.itemEls[0].clientHeight;
        const pageSize = Math.floor(this.getGui().clientHeight / itemHeight);
        let newIndex = -1;
        if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_HOME) newIndex = 0;
        else if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_END) newIndex = rowCount;
        else if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_DOWN) newIndex = Math.min(currentIdx + pageSize, rowCount);
        else if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_UP) newIndex = Math.max(currentIdx - pageSize, 0);
        if (newIndex === -1) return;
        this.highlightItem(this.itemEls[newIndex]);
    }
    addOptions(listOptions) {
        listOptions.forEach((listOption)=>this.addOption(listOption));
        return this;
    }
    addOption(listOption) {
        const { value: value, text: text } = listOption;
        const valueToRender = text || value;
        this.options.push({
            value: value,
            text: valueToRender
        });
        this.renderOption(value, valueToRender);
        this.updateIndices();
        return this;
    }
    clearOptions() {
        this.options = [];
        this.reset(true);
        this.itemEls.forEach((itemEl)=>{
            $437b23f6a393c3bf$var$removeFromParent(itemEl);
        });
        this.itemEls = [];
    }
    updateIndices() {
        const options = this.getGui().querySelectorAll(".ag-list-item");
        options.forEach((option, idx)=>{
            $437b23f6a393c3bf$var$setAriaPosInSet(option, idx + 1);
            $437b23f6a393c3bf$var$setAriaSetSize(option, options.length);
        });
    }
    renderOption(value, text) {
        const eDocument = this.gos.getDocument();
        const itemEl = eDocument.createElement("div");
        $437b23f6a393c3bf$var$setAriaRole(itemEl, "option");
        itemEl.classList.add("ag-list-item", `ag-${this.cssIdentifier}-list-item`);
        const span = eDocument.createElement("span");
        itemEl.appendChild(span);
        span.textContent = text;
        if (!this.unFocusable) itemEl.tabIndex = -1;
        this.itemEls.push(itemEl);
        this.addManagedListener(itemEl, "mousemove", ()=>this.highlightItem(itemEl));
        this.addManagedListener(itemEl, "mousedown", (e)=>{
            e.preventDefault();
            this.setValue(value);
        });
        this.createManagedBean(new $437b23f6a393c3bf$export$e5073a590d24815c({
            getTooltipValue: ()=>text,
            getGui: ()=>itemEl,
            getLocation: ()=>"UNKNOWN",
            // only show tooltips for items where the text cannot be fully displayed
            shouldDisplayTooltip: ()=>span.scrollWidth > span.clientWidth
        }));
        this.getGui().appendChild(itemEl);
    }
    setValue(value, silent) {
        if (this.value === value) {
            this.fireItemSelected();
            return this;
        }
        if (value == null) {
            this.reset(silent);
            return this;
        }
        const idx = this.options.findIndex((option)=>option.value === value);
        if (idx !== -1) {
            const option = this.options[idx];
            this.value = option.value;
            this.displayValue = option.text;
            this.highlightItem(this.itemEls[idx]);
            if (!silent) this.fireChangeEvent();
        }
        return this;
    }
    setValueByIndex(idx) {
        return this.setValue(this.options[idx].value);
    }
    getValue() {
        return this.value;
    }
    getDisplayValue() {
        return this.displayValue;
    }
    refreshHighlighted() {
        this.clearHighlighted();
        const idx = this.options.findIndex((option)=>option.value === this.value);
        if (idx !== -1) this.highlightItem(this.itemEls[idx]);
    }
    reset(silent) {
        this.value = null;
        this.displayValue = null;
        this.clearHighlighted();
        if (!silent) this.fireChangeEvent();
    }
    highlightItem(el) {
        if (!$437b23f6a393c3bf$var$isVisible(el)) return;
        this.clearHighlighted();
        this.highlightedEl = el;
        this.highlightedEl.classList.add(_AgList.ACTIVE_CLASS);
        $437b23f6a393c3bf$var$setAriaSelected(this.highlightedEl, true);
        const eGui = this.getGui();
        const { scrollTop: scrollTop, clientHeight: clientHeight } = eGui;
        const { offsetTop: offsetTop, offsetHeight: offsetHeight } = el;
        if (offsetTop + offsetHeight > scrollTop + clientHeight || offsetTop < scrollTop) this.highlightedEl.scrollIntoView({
            block: "nearest"
        });
        if (!this.unFocusable) this.highlightedEl.focus();
    }
    clearHighlighted() {
        if (!this.highlightedEl || !$437b23f6a393c3bf$var$isVisible(this.highlightedEl)) return;
        this.highlightedEl.classList.remove(_AgList.ACTIVE_CLASS);
        $437b23f6a393c3bf$var$setAriaSelected(this.highlightedEl, false);
        this.highlightedEl = null;
    }
    fireChangeEvent() {
        this.dispatchEvent({
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_FIELD_VALUE_CHANGED
        });
        this.fireItemSelected();
    }
    fireItemSelected() {
        this.dispatchEvent({
            type: _AgList.EVENT_ITEM_SELECTED
        });
    }
};
$437b23f6a393c3bf$var$_AgList.EVENT_ITEM_SELECTED = "selectedItem";
$437b23f6a393c3bf$var$_AgList.ACTIVE_CLASS = "ag-active-item";
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$_AgList.prototype, "init", 1);
var $437b23f6a393c3bf$var$AgList = $437b23f6a393c3bf$var$_AgList;
// community-modules/core/src/widgets/agSelect.ts
var $437b23f6a393c3bf$var$_AgSelect = class _AgSelect extends $437b23f6a393c3bf$export$1f14489b6fdeb99b {
    constructor(config){
        super($437b23f6a393c3bf$var$__spreadValues({
            pickerAriaLabelKey: "ariaLabelSelectField",
            pickerAriaLabelValue: "Select Field",
            pickerType: "ag-list",
            className: "ag-select",
            pickerIcon: "smallDown",
            ariaRole: "combobox"
        }, config));
    }
    postConstruct() {
        super.postConstruct();
        this.createListComponent();
        this.eWrapper.tabIndex = this.gos.get("tabIndex");
        const { options: options, value: value, placeholder: placeholder } = this.config;
        if (options != null) this.addOptions(options);
        if (value != null) this.setValue(value, true);
        if (placeholder && value == null) this.eDisplayField.textContent = placeholder;
        this.addManagedListener(this.eWrapper, "focusout", this.onWrapperFocusOut.bind(this));
    }
    onWrapperFocusOut(e) {
        if (!this.eWrapper.contains(e.relatedTarget)) this.hidePicker();
    }
    createListComponent() {
        this.listComponent = this.createBean(new $437b23f6a393c3bf$var$AgList("select", true));
        this.listComponent.setParentComponent(this);
        const eListAriaEl = this.listComponent.getAriaElement();
        const listId = `ag-select-list-${this.listComponent.getCompId()}`;
        eListAriaEl.setAttribute("id", listId);
        $437b23f6a393c3bf$var$setAriaControls(this.getAriaElement(), eListAriaEl);
        this.listComponent.addManagedListener(this.listComponent, $437b23f6a393c3bf$var$AgList.EVENT_ITEM_SELECTED, ()=>{
            this.hidePicker();
            this.dispatchEvent({
                type: _AgSelect.EVENT_ITEM_SELECTED
            });
        });
        this.listComponent.addManagedListener(this.listComponent, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_FIELD_VALUE_CHANGED, ()=>{
            if (!this.listComponent) return;
            this.setValue(this.listComponent.getValue(), false, true);
            this.hidePicker();
        });
    }
    createPickerComponent() {
        return this.listComponent;
    }
    onKeyDown(e) {
        var _a;
        const { key: key } = e;
        if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB) this.hidePicker();
        switch(key){
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_UP:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_DOWN:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_HOME:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_END:
                e.preventDefault();
                if (this.isPickerDisplayed) (_a = this.listComponent) == null || _a.handleKeyDown(e);
                else super.onKeyDown(e);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ESCAPE:
                super.onKeyDown(e);
                break;
        }
    }
    showPicker() {
        if (!this.listComponent) return;
        super.showPicker();
        this.listComponent.refreshHighlighted();
    }
    addOptions(options) {
        options.forEach((option)=>this.addOption(option));
        return this;
    }
    addOption(option) {
        this.listComponent.addOption(option);
        return this;
    }
    clearOptions() {
        var _a;
        (_a = this.listComponent) == null || _a.clearOptions();
        return this;
    }
    setValue(value, silent, fromPicker) {
        if (this.value === value || !this.listComponent) return this;
        if (!fromPicker) this.listComponent.setValue(value, true);
        const newValue = this.listComponent.getValue();
        if (newValue === this.getValue()) return this;
        let displayValue = this.listComponent.getDisplayValue();
        if (displayValue == null && this.config.placeholder) displayValue = this.config.placeholder;
        this.eDisplayField.textContent = displayValue;
        this.setTooltip({
            newTooltipText: displayValue != null ? displayValue : null,
            shouldDisplayTooltip: ()=>this.eDisplayField.scrollWidth > this.eDisplayField.clientWidth
        });
        return super.setValue(value, silent);
    }
    destroy() {
        if (this.listComponent) {
            this.destroyBean(this.listComponent);
            this.listComponent = void 0;
        }
        super.destroy();
    }
};
$437b23f6a393c3bf$var$_AgSelect.EVENT_ITEM_SELECTED = "selectedItem";
var $437b23f6a393c3bf$export$6f9c460854d56032 = $437b23f6a393c3bf$var$_AgSelect;
// community-modules/core/src/widgets/agAbstractInputField.ts
var $437b23f6a393c3bf$var$AgAbstractInputField = class extends $437b23f6a393c3bf$export$8889445e1e1d2c89 {
    constructor(config, className, inputType = "text", displayFieldTag = "input"){
        super(config, /* html */ `
            <div role="presentation">
                <div ref="eLabel" class="ag-input-field-label"></div>
                <div ref="eWrapper" class="ag-wrapper ag-input-wrapper" role="presentation">
                    <${displayFieldTag} ref="eInput" class="ag-input-field-input"></${displayFieldTag}>
                </div>
            </div>`, className);
        this.inputType = inputType;
        this.displayFieldTag = displayFieldTag;
    }
    postConstruct() {
        super.postConstruct();
        this.setInputType();
        this.eLabel.classList.add(`${this.className}-label`);
        this.eWrapper.classList.add(`${this.className}-input-wrapper`);
        this.eInput.classList.add(`${this.className}-input`);
        this.addCssClass("ag-input-field");
        this.eInput.id = this.eInput.id || `ag-${this.getCompId()}-input`;
        const { inputName: inputName, inputWidth: inputWidth } = this.config;
        if (inputName != null) this.setInputName(inputName);
        if (inputWidth != null) this.setInputWidth(inputWidth);
        this.addInputListeners();
        this.activateTabIndex([
            this.eInput
        ]);
    }
    addInputListeners() {
        this.addManagedListener(this.eInput, "input", (e)=>this.setValue(e.target.value));
    }
    setInputType() {
        if (this.displayFieldTag === "input") this.eInput.setAttribute("type", this.inputType);
    }
    getInputElement() {
        return this.eInput;
    }
    setInputWidth(width) {
        $437b23f6a393c3bf$var$setElementWidth(this.eWrapper, width);
        return this;
    }
    setInputName(name) {
        this.getInputElement().setAttribute("name", name);
        return this;
    }
    getFocusableElement() {
        return this.eInput;
    }
    setMaxLength(length) {
        const eInput = this.eInput;
        eInput.maxLength = length;
        return this;
    }
    setInputPlaceholder(placeholder) {
        $437b23f6a393c3bf$var$addOrRemoveAttribute(this.eInput, "placeholder", placeholder);
        return this;
    }
    setInputAriaLabel(label) {
        $437b23f6a393c3bf$var$setAriaLabel(this.eInput, label);
        this.refreshAriaLabelledBy();
        return this;
    }
    setDisabled(disabled) {
        $437b23f6a393c3bf$var$setDisabled(this.eInput, disabled);
        return super.setDisabled(disabled);
    }
    setAutoComplete(value) {
        if (value === true) $437b23f6a393c3bf$var$addOrRemoveAttribute(this.eInput, "autocomplete", null);
        else {
            const autoCompleteValue = typeof value === "string" ? value : "off";
            $437b23f6a393c3bf$var$addOrRemoveAttribute(this.eInput, "autocomplete", autoCompleteValue);
        }
        return this;
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eLabel")
], $437b23f6a393c3bf$var$AgAbstractInputField.prototype, "eLabel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eWrapper")
], $437b23f6a393c3bf$var$AgAbstractInputField.prototype, "eWrapper", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eInput")
], $437b23f6a393c3bf$var$AgAbstractInputField.prototype, "eInput", 2);
// community-modules/core/src/widgets/agCheckbox.ts
var $437b23f6a393c3bf$export$b00c508c1ae18d07 = class extends $437b23f6a393c3bf$var$AgAbstractInputField {
    constructor(config, className = "ag-checkbox", inputType = "checkbox"){
        super(config, className, inputType);
        this.labelAlignment = "right";
        this.selected = false;
        this.readOnly = false;
        this.passive = false;
    }
    postConstruct() {
        super.postConstruct();
        const { readOnly: readOnly, passive: passive } = this.config;
        if (typeof readOnly === "boolean") this.setReadOnly(readOnly);
        if (typeof passive === "boolean") this.setPassive(passive);
    }
    addInputListeners() {
        this.addManagedListener(this.eInput, "click", this.onCheckboxClick.bind(this));
        this.addManagedListener(this.eLabel, "click", this.toggle.bind(this));
    }
    getNextValue() {
        return this.selected === void 0 ? true : !this.selected;
    }
    setPassive(passive) {
        this.passive = passive;
    }
    isReadOnly() {
        return this.readOnly;
    }
    setReadOnly(readOnly) {
        this.eWrapper.classList.toggle("ag-disabled", readOnly);
        this.eInput.disabled = readOnly;
        this.readOnly = readOnly;
    }
    setDisabled(disabled) {
        this.eWrapper.classList.toggle("ag-disabled", disabled);
        return super.setDisabled(disabled);
    }
    toggle() {
        if (this.eInput.disabled) return;
        const previousValue = this.isSelected();
        const nextValue = this.getNextValue();
        if (this.passive) this.dispatchChange(nextValue, previousValue);
        else this.setValue(nextValue);
    }
    getValue() {
        return this.isSelected();
    }
    setValue(value, silent) {
        this.refreshSelectedClass(value);
        this.setSelected(value, silent);
        return this;
    }
    setName(name) {
        const input = this.getInputElement();
        input.name = name;
        return this;
    }
    isSelected() {
        return this.selected;
    }
    setSelected(selected, silent) {
        if (this.isSelected() === selected) return;
        this.previousValue = this.isSelected();
        selected = this.selected = typeof selected === "boolean" ? selected : void 0;
        this.eInput.checked = selected;
        this.eInput.indeterminate = selected === void 0;
        if (!silent) this.dispatchChange(this.selected, this.previousValue);
    }
    dispatchChange(selected, previousValue, event) {
        this.dispatchEvent({
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_FIELD_VALUE_CHANGED,
            selected: selected,
            previousValue: previousValue,
            event: event
        });
        const input = this.getInputElement();
        const checkboxChangedEvent = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_CHECKBOX_CHANGED,
            id: input.id,
            name: input.name,
            selected: selected,
            previousValue: previousValue
        };
        this.eventService.dispatchEvent(checkboxChangedEvent);
    }
    onCheckboxClick(e) {
        if (this.passive || this.eInput.disabled) return;
        const previousValue = this.isSelected();
        const selected = this.selected = e.target.checked;
        this.refreshSelectedClass(selected);
        this.dispatchChange(selected, previousValue, e);
    }
    refreshSelectedClass(value) {
        this.eWrapper.classList.toggle("ag-checked", value === true);
        this.eWrapper.classList.toggle("ag-indeterminate", value == null);
    }
};
// community-modules/core/src/widgets/agRadioButton.ts
var $437b23f6a393c3bf$export$5caa9ea96bbb722 = class extends $437b23f6a393c3bf$export$b00c508c1ae18d07 {
    constructor(config){
        super(config, "ag-radio-button", "radio");
    }
    isSelected() {
        return this.eInput.checked;
    }
    toggle() {
        if (this.eInput.disabled) return;
        if (!this.isSelected()) this.setValue(true);
    }
    addInputListeners() {
        super.addInputListeners();
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_CHECKBOX_CHANGED, this.onChange.bind(this));
    }
    /**
   * This ensures that if another radio button in the same named group is selected, we deselect this radio button.
   * By default the browser does this for you, but we are managing classes ourselves in order to ensure input
   * elements are styled correctly in IE11, and the DOM 'changed' event is only fired when a button is selected,
   * not deselected, so we need to use our own event.
   */ onChange(event) {
        if (event.selected && event.name && this.eInput.name && this.eInput.name === event.name && event.id && this.eInput.id !== event.id) this.setValue(false, true);
    }
};
// community-modules/core/src/filter/provided/simpleFilter.ts
var $437b23f6a393c3bf$var$SimpleFilterModelFormatter = class {
    constructor(localeService, optionsFactory, valueFormatter){
        this.localeService = localeService;
        this.optionsFactory = optionsFactory;
        this.valueFormatter = valueFormatter;
    }
    // used by:
    // 1) NumberFloatingFilter & TextFloatingFilter: Always, for both when editable and read only.
    // 2) DateFloatingFilter: Only when read only (as we show text rather than a date picker when read only)
    getModelAsString(model) {
        if (!model) return null;
        const isCombined = model.operator != null;
        const translate = this.localeService.getLocaleTextFunc();
        if (isCombined) {
            const combinedModel = model;
            let { conditions: conditions } = combinedModel;
            if (!conditions) {
                const { condition1: condition1, condition2: condition2 } = combinedModel;
                conditions = [
                    condition1,
                    condition2
                ];
            }
            const customOptions = conditions.map((condition)=>this.getModelAsString(condition));
            const joinOperatorTranslateKey = combinedModel.operator === "AND" ? "andCondition" : "orCondition";
            return customOptions.join(` ${translate(joinOperatorTranslateKey, $437b23f6a393c3bf$var$FILTER_LOCALE_TEXT[joinOperatorTranslateKey])} `);
        } else if (model.type === $437b23f6a393c3bf$export$f5377e6e4a0f88ed.BLANK || model.type === $437b23f6a393c3bf$export$f5377e6e4a0f88ed.NOT_BLANK) return translate(model.type, model.type);
        else {
            const condition = model;
            const customOption = this.optionsFactory.getCustomOption(condition.type);
            const { displayKey: displayKey, displayName: displayName, numberOfInputs: numberOfInputs } = customOption || {};
            if (displayKey && displayName && numberOfInputs === 0) {
                translate(displayKey, displayName);
                return displayName;
            }
            return this.conditionToString(condition, customOption);
        }
    }
    updateParams(params) {
        this.optionsFactory = params.optionsFactory;
    }
    formatValue(value) {
        var _a;
        return this.valueFormatter ? (_a = this.valueFormatter(value != null ? value : null)) != null ? _a : "" : String(value);
    }
};
var $437b23f6a393c3bf$var$_SimpleFilter = class _SimpleFilter extends $437b23f6a393c3bf$export$a927a1327c2cc7f0 {
    constructor(){
        super(...arguments);
        this.eTypes = [];
        this.eJoinOperatorPanels = [];
        this.eJoinOperatorsAnd = [];
        this.eJoinOperatorsOr = [];
        this.eConditionBodies = [];
        this.listener = ()=>this.onUiChanged();
        this.lastUiCompletePosition = null;
        this.joinOperatorId = 0;
    }
    getNumberOfInputs(type) {
        const customOpts = this.optionsFactory.getCustomOption(type);
        if (customOpts) {
            const { numberOfInputs: numberOfInputs } = customOpts;
            return numberOfInputs != null ? numberOfInputs : 1;
        }
        const zeroInputTypes = [
            _SimpleFilter.EMPTY,
            _SimpleFilter.NOT_BLANK,
            _SimpleFilter.BLANK
        ];
        if (type && zeroInputTypes.indexOf(type) >= 0) return 0;
        else if (type === _SimpleFilter.IN_RANGE) return 2;
        return 1;
    }
    // floating filter calls this when user applies filter from floating filter
    onFloatingFilterChanged(type, value) {
        this.setTypeFromFloatingFilter(type);
        this.setValueFromFloatingFilter(value);
        this.onUiChanged(true);
    }
    setTypeFromFloatingFilter(type) {
        this.eTypes.forEach((eType, position)=>{
            if (position === 0) eType.setValue(type, true);
            else eType.setValue(this.optionsFactory.getDefaultOption(), true);
        });
    }
    getModelFromUi() {
        const conditions = this.getUiCompleteConditions();
        if (conditions.length === 0) return null;
        if (this.maxNumConditions > 1 && conditions.length > 1) return {
            filterType: this.getFilterType(),
            operator: this.getJoinOperator(),
            condition1: conditions[0],
            condition2: conditions[1],
            conditions: conditions
        };
        return conditions[0];
    }
    getConditionTypes() {
        return this.eTypes.map((eType)=>eType.getValue());
    }
    getConditionType(position) {
        return this.eTypes[position].getValue();
    }
    getJoinOperator() {
        if (this.eJoinOperatorsOr.length === 0) return this.defaultJoinOperator;
        return this.eJoinOperatorsOr[0].getValue() === true ? "OR" : "AND";
    }
    areModelsEqual(a, b) {
        if (!a && !b) return true;
        if (!a && b || a && !b) return false;
        const aIsSimple = !a.operator;
        const bIsSimple = !b.operator;
        const oneSimpleOneCombined = !aIsSimple && bIsSimple || aIsSimple && !bIsSimple;
        if (oneSimpleOneCombined) return false;
        let res;
        if (aIsSimple) {
            const aSimple = a;
            const bSimple = b;
            res = this.areSimpleModelsEqual(aSimple, bSimple);
        } else {
            const aCombined = a;
            const bCombined = b;
            res = aCombined.operator === bCombined.operator && $437b23f6a393c3bf$var$areEqual(aCombined.conditions, bCombined.conditions, (aModel, bModel)=>this.areSimpleModelsEqual(aModel, bModel));
        }
        return res;
    }
    shouldRefresh(newParams) {
        var _a, _b, _c;
        const model = this.getModel();
        const conditions = model ? (_a = model.conditions) != null ? _a : [
            model
        ] : null;
        const newOptionsList = (_c = (_b = newParams.filterOptions) == null ? void 0 : _b.map((option)=>typeof option === "string" ? option : option.displayKey)) != null ? _c : this.getDefaultFilterOptions();
        const allConditionsExistInNewOptionsList = !conditions || conditions.every((condition)=>newOptionsList.find((option)=>option === condition.type) !== void 0);
        if (!allConditionsExistInNewOptionsList) return false;
        if (typeof newParams.maxNumConditions === "number" && conditions && conditions.length > newParams.maxNumConditions) return false;
        return true;
    }
    refresh(newParams) {
        if (!this.shouldRefresh(newParams)) return false;
        const parentRefreshed = super.refresh(newParams);
        if (!parentRefreshed) return false;
        this.setParams(newParams);
        this.removeConditionsAndOperators(0);
        this.createOption();
        this.setModel(this.getModel());
        return true;
    }
    setModelIntoUi(model) {
        const isCombined = model.operator;
        if (isCombined) {
            let combinedModel = model;
            if (!combinedModel.conditions) combinedModel.conditions = [
                combinedModel.condition1,
                combinedModel.condition2
            ];
            const numConditions = this.validateAndUpdateConditions(combinedModel.conditions);
            const numPrevConditions = this.getNumConditions();
            if (numConditions < numPrevConditions) this.removeConditionsAndOperators(numConditions);
            else if (numConditions > numPrevConditions) for(let i = numPrevConditions; i < numConditions; i++){
                this.createJoinOperatorPanel();
                this.createOption();
            }
            const orChecked = combinedModel.operator === "OR";
            this.eJoinOperatorsAnd.forEach((eJoinOperatorAnd)=>eJoinOperatorAnd.setValue(!orChecked, true));
            this.eJoinOperatorsOr.forEach((eJoinOperatorOr)=>eJoinOperatorOr.setValue(orChecked, true));
            combinedModel.conditions.forEach((condition, position)=>{
                this.eTypes[position].setValue(condition.type, true);
                this.setConditionIntoUi(condition, position);
            });
        } else {
            const simpleModel = model;
            if (this.getNumConditions() > 1) this.removeConditionsAndOperators(1);
            this.eTypes[0].setValue(simpleModel.type, true);
            this.setConditionIntoUi(simpleModel, 0);
        }
        this.lastUiCompletePosition = this.getNumConditions() - 1;
        this.createMissingConditionsAndOperators();
        this.onUiChanged();
        return $437b23f6a393c3bf$export$30ec7836a4847721.resolve();
    }
    validateAndUpdateConditions(conditions) {
        let numConditions = conditions.length;
        if (numConditions > this.maxNumConditions) {
            conditions.splice(this.maxNumConditions);
            $437b23f6a393c3bf$var$warnOnce('Filter Model contains more conditions than "filterParams.maxNumConditions". Additional conditions have been ignored.');
            numConditions = this.maxNumConditions;
        }
        return numConditions;
    }
    doesFilterPass(params) {
        var _a;
        const model = this.getModel();
        if (model == null) return true;
        const { operator: operator } = model;
        const models = [];
        if (operator) {
            const combinedModel = model;
            models.push(...(_a = combinedModel.conditions) != null ? _a : []);
        } else models.push(model);
        const combineFunction = operator && operator === "OR" ? "some" : "every";
        return models[combineFunction]((m)=>this.individualConditionPasses(params, m));
    }
    setParams(params) {
        super.setParams(params);
        this.setNumConditions(params);
        this.defaultJoinOperator = this.getDefaultJoinOperator(params.defaultJoinOperator);
        this.filterPlaceholder = params.filterPlaceholder;
        this.optionsFactory = new $437b23f6a393c3bf$var$OptionsFactory();
        this.optionsFactory.init(params, this.getDefaultFilterOptions());
        this.createFilterListOptions();
        this.createOption();
        this.createMissingConditionsAndOperators();
        if (this.isReadOnly()) this.eFilterBody.setAttribute("tabindex", "-1");
    }
    setNumConditions(params) {
        var _a, _b;
        if (params.suppressAndOrCondition != null) $437b23f6a393c3bf$var$warnOnce('Since v29.2 "filterParams.suppressAndOrCondition" is deprecated. Use "filterParams.maxNumConditions = 1" instead.');
        if (params.alwaysShowBothConditions != null) $437b23f6a393c3bf$var$warnOnce('Since v29.2 "filterParams.alwaysShowBothConditions" is deprecated. Use "filterParams.numAlwaysVisibleConditions = 2" instead.');
        this.maxNumConditions = (_a = params.maxNumConditions) != null ? _a : params.suppressAndOrCondition ? 1 : 2;
        if (this.maxNumConditions < 1) {
            $437b23f6a393c3bf$var$warnOnce('"filterParams.maxNumConditions" must be greater than or equal to zero.');
            this.maxNumConditions = 1;
        }
        this.numAlwaysVisibleConditions = (_b = params.numAlwaysVisibleConditions) != null ? _b : params.alwaysShowBothConditions ? 2 : 1;
        if (this.numAlwaysVisibleConditions < 1) {
            $437b23f6a393c3bf$var$warnOnce('"filterParams.numAlwaysVisibleConditions" must be greater than or equal to zero.');
            this.numAlwaysVisibleConditions = 1;
        }
        if (this.numAlwaysVisibleConditions > this.maxNumConditions) {
            $437b23f6a393c3bf$var$warnOnce('"filterParams.numAlwaysVisibleConditions" cannot be greater than "filterParams.maxNumConditions".');
            this.numAlwaysVisibleConditions = this.maxNumConditions;
        }
    }
    createOption() {
        const eType = this.createManagedBean(new $437b23f6a393c3bf$export$6f9c460854d56032());
        this.eTypes.push(eType);
        eType.addCssClass("ag-filter-select");
        this.eFilterBody.appendChild(eType.getGui());
        const eConditionBody = this.createValueElement();
        this.eConditionBodies.push(eConditionBody);
        this.eFilterBody.appendChild(eConditionBody);
        this.putOptionsIntoDropdown(eType);
        this.resetType(eType);
        const position = this.getNumConditions() - 1;
        this.forEachPositionInput(position, (element)=>this.resetInput(element));
        this.addChangedListeners(eType, position);
    }
    createJoinOperatorPanel() {
        const eJoinOperatorPanel = document.createElement("div");
        this.eJoinOperatorPanels.push(eJoinOperatorPanel);
        eJoinOperatorPanel.classList.add("ag-filter-condition");
        const eJoinOperatorAnd = this.createJoinOperator(this.eJoinOperatorsAnd, eJoinOperatorPanel, "and");
        const eJoinOperatorOr = this.createJoinOperator(this.eJoinOperatorsOr, eJoinOperatorPanel, "or");
        this.eFilterBody.appendChild(eJoinOperatorPanel);
        const index = this.eJoinOperatorPanels.length - 1;
        const uniqueGroupId = this.joinOperatorId++;
        this.resetJoinOperatorAnd(eJoinOperatorAnd, index, uniqueGroupId);
        this.resetJoinOperatorOr(eJoinOperatorOr, index, uniqueGroupId);
        if (!this.isReadOnly()) {
            eJoinOperatorAnd.onValueChange(this.listener);
            eJoinOperatorOr.onValueChange(this.listener);
        }
    }
    createJoinOperator(eJoinOperators, eJoinOperatorPanel, andOr) {
        const eJoinOperator = this.createManagedBean(new $437b23f6a393c3bf$export$5caa9ea96bbb722());
        eJoinOperators.push(eJoinOperator);
        eJoinOperator.addCssClass("ag-filter-condition-operator");
        eJoinOperator.addCssClass(`ag-filter-condition-operator-${andOr}`);
        eJoinOperatorPanel.appendChild(eJoinOperator.getGui());
        return eJoinOperator;
    }
    getDefaultJoinOperator(defaultJoinOperator) {
        return defaultJoinOperator === "AND" || defaultJoinOperator === "OR" ? defaultJoinOperator : "AND";
    }
    createFilterListOptions() {
        const filterOptions = this.optionsFactory.getFilterOptions();
        this.filterListOptions = filterOptions.map((option)=>typeof option === "string" ? this.createBoilerplateListOption(option) : this.createCustomListOption(option));
    }
    putOptionsIntoDropdown(eType) {
        this.filterListOptions.forEach((listOption)=>{
            eType.addOption(listOption);
        });
        eType.setDisabled(this.filterListOptions.length <= 1);
    }
    createBoilerplateListOption(option) {
        return {
            value: option,
            text: this.translate(option)
        };
    }
    createCustomListOption(option) {
        const { displayKey: displayKey } = option;
        const customOption = this.optionsFactory.getCustomOption(option.displayKey);
        return {
            value: displayKey,
            text: customOption ? this.localeService.getLocaleTextFunc()(customOption.displayKey, customOption.displayName) : this.translate(displayKey)
        };
    }
    /**
   * @deprecated As of v29.2 filters can have more than two conditions. Check `colDef.filterParams.maxNumConditions` instead.
   */ isAllowTwoConditions() {
        return this.maxNumConditions >= 2;
    }
    createBodyTemplate() {
        return "";
    }
    getCssIdentifier() {
        return "simple-filter";
    }
    updateUiVisibility() {
        const joinOperator = this.getJoinOperator();
        this.updateNumConditions();
        this.updateConditionStatusesAndValues(this.lastUiCompletePosition, joinOperator);
    }
    updateNumConditions() {
        var _a;
        let lastUiCompletePosition = -1;
        let areAllConditionsUiComplete = true;
        for(let position = 0; position < this.getNumConditions(); position++)if (this.isConditionUiComplete(position)) lastUiCompletePosition = position;
        else areAllConditionsUiComplete = false;
        if (this.shouldAddNewConditionAtEnd(areAllConditionsUiComplete)) {
            this.createJoinOperatorPanel();
            this.createOption();
        } else {
            const activePosition = (_a = this.lastUiCompletePosition) != null ? _a : this.getNumConditions() - 2;
            if (lastUiCompletePosition < activePosition) {
                this.removeConditionsAndOperators(activePosition + 1);
                const removeStartPosition = lastUiCompletePosition + 1;
                const numConditionsToRemove = activePosition - removeStartPosition;
                if (numConditionsToRemove > 0) this.removeConditionsAndOperators(removeStartPosition, numConditionsToRemove);
                this.createMissingConditionsAndOperators();
            }
        }
        this.lastUiCompletePosition = lastUiCompletePosition;
    }
    updateConditionStatusesAndValues(lastUiCompletePosition, joinOperator) {
        this.eTypes.forEach((eType, position)=>{
            const disabled = this.isConditionDisabled(position, lastUiCompletePosition);
            eType.setDisabled(disabled || this.filterListOptions.length <= 1);
            if (position === 1) {
                $437b23f6a393c3bf$var$setDisabled(this.eJoinOperatorPanels[0], disabled);
                this.eJoinOperatorsAnd[0].setDisabled(disabled);
                this.eJoinOperatorsOr[0].setDisabled(disabled);
            }
        });
        this.eConditionBodies.forEach((element, index)=>{
            $437b23f6a393c3bf$var$setDisplayed(element, this.isConditionBodyVisible(index));
        });
        const orChecked = (joinOperator != null ? joinOperator : this.getJoinOperator()) === "OR";
        this.eJoinOperatorsAnd.forEach((eJoinOperatorAnd, index)=>{
            eJoinOperatorAnd.setValue(!orChecked, true);
        });
        this.eJoinOperatorsOr.forEach((eJoinOperatorOr, index)=>{
            eJoinOperatorOr.setValue(orChecked, true);
        });
        this.forEachInput((element, index, position, numberOfInputs)=>{
            this.setElementDisplayed(element, index < numberOfInputs);
            this.setElementDisabled(element, this.isConditionDisabled(position, lastUiCompletePosition));
        });
        this.resetPlaceholder();
    }
    shouldAddNewConditionAtEnd(areAllConditionsUiComplete) {
        return areAllConditionsUiComplete && this.getNumConditions() < this.maxNumConditions && !this.isReadOnly();
    }
    removeConditionsAndOperators(startPosition, deleteCount) {
        if (startPosition >= this.getNumConditions()) return;
        this.removeComponents(this.eTypes, startPosition, deleteCount);
        this.removeElements(this.eConditionBodies, startPosition, deleteCount);
        this.removeValueElements(startPosition, deleteCount);
        const joinOperatorIndex = Math.max(startPosition - 1, 0);
        this.removeElements(this.eJoinOperatorPanels, joinOperatorIndex, deleteCount);
        this.removeComponents(this.eJoinOperatorsAnd, joinOperatorIndex, deleteCount);
        this.removeComponents(this.eJoinOperatorsOr, joinOperatorIndex, deleteCount);
    }
    removeElements(elements, startPosition, deleteCount) {
        const removedElements = this.removeItems(elements, startPosition, deleteCount);
        removedElements.forEach((element)=>$437b23f6a393c3bf$var$removeFromParent(element));
    }
    removeComponents(components, startPosition, deleteCount) {
        const removedComponents = this.removeItems(components, startPosition, deleteCount);
        removedComponents.forEach((comp)=>{
            $437b23f6a393c3bf$var$removeFromParent(comp.getGui());
            this.destroyBean(comp);
        });
    }
    removeItems(items, startPosition, deleteCount) {
        return deleteCount == null ? items.splice(startPosition) : items.splice(startPosition, deleteCount);
    }
    afterGuiAttached(params) {
        super.afterGuiAttached(params);
        this.resetPlaceholder();
        if (!(params == null ? void 0 : params.suppressFocus)) {
            if (this.isReadOnly()) this.eFilterBody.focus();
            else {
                const firstInput = this.getInputs(0)[0];
                if (!firstInput) return;
                if (firstInput instanceof $437b23f6a393c3bf$var$AgAbstractInputField) firstInput.getInputElement().focus();
            }
        }
    }
    afterGuiDetached() {
        super.afterGuiDetached();
        const appliedModel = this.getModel();
        this.resetUiToActiveModel(appliedModel);
        let lastUiCompletePosition = -1;
        let updatedLastUiCompletePosition = -1;
        let conditionsRemoved = false;
        const joinOperator = this.getJoinOperator();
        for(let position = this.getNumConditions() - 1; position >= 0; position--){
            if (this.isConditionUiComplete(position)) {
                if (lastUiCompletePosition === -1) {
                    lastUiCompletePosition = position;
                    updatedLastUiCompletePosition = position;
                }
            } else {
                const shouldRemovePositionAtEnd = position >= this.numAlwaysVisibleConditions && !this.isConditionUiComplete(position - 1);
                const positionBeforeLastUiCompletePosition = position < lastUiCompletePosition;
                if (shouldRemovePositionAtEnd || positionBeforeLastUiCompletePosition) {
                    this.removeConditionsAndOperators(position, 1);
                    conditionsRemoved = true;
                    if (positionBeforeLastUiCompletePosition) updatedLastUiCompletePosition--;
                }
            }
        }
        let shouldUpdateConditionStatusesAndValues = false;
        if (this.getNumConditions() < this.numAlwaysVisibleConditions) {
            this.createMissingConditionsAndOperators();
            shouldUpdateConditionStatusesAndValues = true;
        }
        if (this.shouldAddNewConditionAtEnd(updatedLastUiCompletePosition === this.getNumConditions() - 1)) {
            this.createJoinOperatorPanel();
            this.createOption();
            shouldUpdateConditionStatusesAndValues = true;
        }
        if (shouldUpdateConditionStatusesAndValues) this.updateConditionStatusesAndValues(updatedLastUiCompletePosition, joinOperator);
        if (conditionsRemoved) this.updateJoinOperatorsDisabled();
        this.lastUiCompletePosition = updatedLastUiCompletePosition;
    }
    getPlaceholderText(defaultPlaceholder, position) {
        let placeholder = this.translate(defaultPlaceholder);
        if ($437b23f6a393c3bf$var$isFunction(this.filterPlaceholder)) {
            const filterPlaceholderFn = this.filterPlaceholder;
            const filterOptionKey = this.eTypes[position].getValue();
            const filterOption = this.translate(filterOptionKey);
            placeholder = filterPlaceholderFn({
                filterOptionKey: filterOptionKey,
                filterOption: filterOption,
                placeholder: placeholder
            });
        } else if (typeof this.filterPlaceholder === "string") placeholder = this.filterPlaceholder;
        return placeholder;
    }
    // allow sub-classes to reset HTML placeholders after UI update.
    resetPlaceholder() {
        const globalTranslate = this.localeService.getLocaleTextFunc();
        this.forEachInput((element, index, position, numberOfInputs)=>{
            if (!(element instanceof $437b23f6a393c3bf$var$AgAbstractInputField)) return;
            const placeholder = index === 0 && numberOfInputs > 1 ? "inRangeStart" : index === 0 ? "filterOoo" : "inRangeEnd";
            const ariaLabel = index === 0 && numberOfInputs > 1 ? globalTranslate("ariaFilterFromValue", "Filter from value") : index === 0 ? globalTranslate("ariaFilterValue", "Filter Value") : globalTranslate("ariaFilterToValue", "Filter to Value");
            element.setInputPlaceholder(this.getPlaceholderText(placeholder, position));
            element.setInputAriaLabel(ariaLabel);
        });
    }
    setElementValue(element, value, fromFloatingFilter) {
        if (element instanceof $437b23f6a393c3bf$var$AgAbstractInputField) element.setValue(value != null ? String(value) : null, true);
    }
    setElementDisplayed(element, displayed) {
        if (element instanceof $437b23f6a393c3bf$export$16fa2f45be04daa8) $437b23f6a393c3bf$var$setDisplayed(element.getGui(), displayed);
    }
    setElementDisabled(element, disabled) {
        if (element instanceof $437b23f6a393c3bf$export$16fa2f45be04daa8) $437b23f6a393c3bf$var$setDisabled(element.getGui(), disabled);
    }
    attachElementOnChange(element, listener) {
        if (element instanceof $437b23f6a393c3bf$var$AgAbstractInputField) element.onValueChange(listener);
    }
    forEachInput(cb) {
        this.getConditionTypes().forEach((type, position)=>{
            this.forEachPositionTypeInput(position, type, cb);
        });
    }
    forEachPositionInput(position, cb) {
        const type = this.getConditionType(position);
        this.forEachPositionTypeInput(position, type, cb);
    }
    forEachPositionTypeInput(position, type, cb) {
        const numberOfInputs = this.getNumberOfInputs(type);
        const inputs = this.getInputs(position);
        for(let index = 0; index < inputs.length; index++){
            const input = inputs[index];
            if (input != null) cb(input, index, position, numberOfInputs);
        }
    }
    isConditionDisabled(position, lastUiCompletePosition) {
        if (this.isReadOnly()) return true;
        if (position === 0) return false;
        return position > lastUiCompletePosition + 1;
    }
    isConditionBodyVisible(position) {
        const type = this.getConditionType(position);
        const numberOfInputs = this.getNumberOfInputs(type);
        return numberOfInputs > 0;
    }
    // returns true if the UI represents a working filter, eg all parts are filled out.
    // eg if text filter and textfield blank then returns false.
    isConditionUiComplete(position) {
        if (position >= this.getNumConditions()) return false;
        const type = this.getConditionType(position);
        if (type === _SimpleFilter.EMPTY) return false;
        if (this.getValues(position).some((v)=>v == null)) return false;
        return true;
    }
    getNumConditions() {
        return this.eTypes.length;
    }
    getUiCompleteConditions() {
        const conditions = [];
        for(let position = 0; position < this.getNumConditions(); position++)if (this.isConditionUiComplete(position)) conditions.push(this.createCondition(position));
        return conditions;
    }
    createMissingConditionsAndOperators() {
        if (this.isReadOnly()) return;
        for(let i = this.getNumConditions(); i < this.numAlwaysVisibleConditions; i++){
            this.createJoinOperatorPanel();
            this.createOption();
        }
    }
    resetUiToDefaults(silent) {
        this.removeConditionsAndOperators(this.isReadOnly() ? 1 : this.numAlwaysVisibleConditions);
        this.eTypes.forEach((eType)=>this.resetType(eType));
        this.eJoinOperatorsAnd.forEach((eJoinOperatorAnd, index)=>this.resetJoinOperatorAnd(eJoinOperatorAnd, index, this.joinOperatorId + index));
        this.eJoinOperatorsOr.forEach((eJoinOperatorOr, index)=>this.resetJoinOperatorOr(eJoinOperatorOr, index, this.joinOperatorId + index));
        this.joinOperatorId++;
        this.forEachInput((element)=>this.resetInput(element));
        this.resetPlaceholder();
        this.createMissingConditionsAndOperators();
        this.lastUiCompletePosition = null;
        if (!silent) this.onUiChanged();
        return $437b23f6a393c3bf$export$30ec7836a4847721.resolve();
    }
    resetType(eType) {
        const translate = this.localeService.getLocaleTextFunc();
        const filteringLabel = translate("ariaFilteringOperator", "Filtering operator");
        eType.setValue(this.optionsFactory.getDefaultOption(), true).setAriaLabel(filteringLabel).setDisabled(this.isReadOnly() || this.filterListOptions.length <= 1);
    }
    resetJoinOperatorAnd(eJoinOperatorAnd, index, uniqueGroupId) {
        this.resetJoinOperator(eJoinOperatorAnd, index, this.isDefaultOperator("AND"), this.translate("andCondition"), uniqueGroupId);
    }
    resetJoinOperatorOr(eJoinOperatorOr, index, uniqueGroupId) {
        this.resetJoinOperator(eJoinOperatorOr, index, this.isDefaultOperator("OR"), this.translate("orCondition"), uniqueGroupId);
    }
    resetJoinOperator(eJoinOperator, index, value, label, uniqueGroupId) {
        this.updateJoinOperatorDisabled(eJoinOperator.setValue(value, true).setName(`ag-simple-filter-and-or-${this.getCompId()}-${uniqueGroupId}`).setLabel(label), index);
    }
    updateJoinOperatorsDisabled() {
        this.eJoinOperatorsAnd.forEach((eJoinOperator, index)=>this.updateJoinOperatorDisabled(eJoinOperator, index));
        this.eJoinOperatorsOr.forEach((eJoinOperator, index)=>this.updateJoinOperatorDisabled(eJoinOperator, index));
    }
    updateJoinOperatorDisabled(eJoinOperator, index) {
        eJoinOperator.setDisabled(this.isReadOnly() || index > 0);
    }
    resetInput(element) {
        this.setElementValue(element, null);
        this.setElementDisabled(element, this.isReadOnly());
    }
    // puts model values into the UI
    setConditionIntoUi(model, position) {
        const values2 = this.mapValuesFromModel(model);
        this.forEachInput((element, index, elPosition, _2)=>{
            if (elPosition !== position) return;
            this.setElementValue(element, values2[index] != null ? values2[index] : null);
        });
    }
    // after floating filter changes, this sets the 'value' section. this is implemented by the base class
    // (as that's where value is controlled), the 'type' part from the floating filter is dealt with in this class.
    setValueFromFloatingFilter(value) {
        this.forEachInput((element, index, position, _2)=>{
            this.setElementValue(element, index === 0 && position === 0 ? value : null, true);
        });
    }
    isDefaultOperator(operator) {
        return operator === this.defaultJoinOperator;
    }
    addChangedListeners(eType, position) {
        if (this.isReadOnly()) return;
        eType.onValueChange(this.listener);
        this.forEachPositionInput(position, (element)=>{
            this.attachElementOnChange(element, this.listener);
        });
    }
    /** returns true if the row passes the said condition */ individualConditionPasses(params, filterModel) {
        const cellValue = this.getCellValue(params.node);
        const values2 = this.mapValuesFromModel(filterModel);
        const customFilterOption = this.optionsFactory.getCustomOption(filterModel.type);
        const customFilterResult = this.evaluateCustomFilter(customFilterOption, values2, cellValue);
        if (customFilterResult != null) return customFilterResult;
        if (cellValue == null) return this.evaluateNullValue(filterModel.type);
        return this.evaluateNonNullValue(values2, cellValue, filterModel, params);
    }
    evaluateCustomFilter(customFilterOption, values2, cellValue) {
        if (customFilterOption == null) return;
        const { predicate: predicate } = customFilterOption;
        if (predicate != null && !values2.some((v)=>v == null)) return predicate(values2, cellValue);
        return;
    }
    isBlank(cellValue) {
        return cellValue == null || typeof cellValue === "string" && cellValue.trim().length === 0;
    }
    hasInvalidInputs() {
        return false;
    }
};
$437b23f6a393c3bf$var$_SimpleFilter.EMPTY = "empty";
$437b23f6a393c3bf$var$_SimpleFilter.BLANK = "blank";
$437b23f6a393c3bf$var$_SimpleFilter.NOT_BLANK = "notBlank";
$437b23f6a393c3bf$var$_SimpleFilter.EQUALS = "equals";
$437b23f6a393c3bf$var$_SimpleFilter.NOT_EQUAL = "notEqual";
$437b23f6a393c3bf$var$_SimpleFilter.LESS_THAN = "lessThan";
$437b23f6a393c3bf$var$_SimpleFilter.LESS_THAN_OR_EQUAL = "lessThanOrEqual";
$437b23f6a393c3bf$var$_SimpleFilter.GREATER_THAN = "greaterThan";
$437b23f6a393c3bf$var$_SimpleFilter.GREATER_THAN_OR_EQUAL = "greaterThanOrEqual";
$437b23f6a393c3bf$var$_SimpleFilter.IN_RANGE = "inRange";
$437b23f6a393c3bf$var$_SimpleFilter.CONTAINS = "contains";
$437b23f6a393c3bf$var$_SimpleFilter.NOT_CONTAINS = "notContains";
$437b23f6a393c3bf$var$_SimpleFilter.STARTS_WITH = "startsWith";
$437b23f6a393c3bf$var$_SimpleFilter.ENDS_WITH = "endsWith";
var $437b23f6a393c3bf$export$f5377e6e4a0f88ed = $437b23f6a393c3bf$var$_SimpleFilter;
// community-modules/core/src/filter/provided/scalarFilter.ts
var $437b23f6a393c3bf$export$804d9bd153e864e6 = class _ScalarFilter extends $437b23f6a393c3bf$export$f5377e6e4a0f88ed {
    setParams(params) {
        super.setParams(params);
        this.scalarFilterParams = params;
    }
    evaluateNullValue(filterType) {
        switch(filterType){
            case _ScalarFilter.EQUALS:
            case _ScalarFilter.NOT_EQUAL:
                if (this.scalarFilterParams.includeBlanksInEquals) return true;
                break;
            case _ScalarFilter.GREATER_THAN:
            case _ScalarFilter.GREATER_THAN_OR_EQUAL:
                if (this.scalarFilterParams.includeBlanksInGreaterThan) return true;
                break;
            case _ScalarFilter.LESS_THAN:
            case _ScalarFilter.LESS_THAN_OR_EQUAL:
                if (this.scalarFilterParams.includeBlanksInLessThan) return true;
                break;
            case _ScalarFilter.IN_RANGE:
                if (this.scalarFilterParams.includeBlanksInRange) return true;
                break;
            case _ScalarFilter.BLANK:
                return true;
            case _ScalarFilter.NOT_BLANK:
                return false;
        }
        return false;
    }
    evaluateNonNullValue(values2, cellValue, filterModel) {
        const comparator = this.comparator();
        const compareResult = values2[0] != null ? comparator(values2[0], cellValue) : 0;
        switch(filterModel.type){
            case _ScalarFilter.EQUALS:
                return compareResult === 0;
            case _ScalarFilter.NOT_EQUAL:
                return compareResult !== 0;
            case _ScalarFilter.GREATER_THAN:
                return compareResult > 0;
            case _ScalarFilter.GREATER_THAN_OR_EQUAL:
                return compareResult >= 0;
            case _ScalarFilter.LESS_THAN:
                return compareResult < 0;
            case _ScalarFilter.LESS_THAN_OR_EQUAL:
                return compareResult <= 0;
            case _ScalarFilter.IN_RANGE:
                {
                    const compareToResult = comparator(values2[1], cellValue);
                    return this.scalarFilterParams.inRangeInclusive ? compareResult >= 0 && compareToResult <= 0 : compareResult > 0 && compareToResult < 0;
                }
            case _ScalarFilter.BLANK:
                return this.isBlank(cellValue);
            case _ScalarFilter.NOT_BLANK:
                return !this.isBlank(cellValue);
            default:
                console.warn('AG Grid: Unexpected type of filter "' + filterModel.type + '", it looks like the filter was configured with incorrect Filter Options');
                return true;
        }
    }
};
// community-modules/core/src/filter/provided/date/dateFilter.ts
var $437b23f6a393c3bf$var$DEFAULT_MIN_YEAR = 1e3;
var $437b23f6a393c3bf$var$DEFAULT_MAX_YEAR = Infinity;
var $437b23f6a393c3bf$var$DateFilterModelFormatter = class extends $437b23f6a393c3bf$var$SimpleFilterModelFormatter {
    constructor(dateFilterParams, localeService, optionsFactory){
        super(localeService, optionsFactory);
        this.dateFilterParams = dateFilterParams;
    }
    conditionToString(condition, options) {
        const { type: type } = condition;
        const { numberOfInputs: numberOfInputs } = options || {};
        const isRange = type == $437b23f6a393c3bf$export$f5377e6e4a0f88ed.IN_RANGE || numberOfInputs === 2;
        const dateFrom = $437b23f6a393c3bf$var$parseDateTimeFromString(condition.dateFrom);
        const dateTo = $437b23f6a393c3bf$var$parseDateTimeFromString(condition.dateTo);
        const format = this.dateFilterParams.inRangeFloatingFilterDateFormat;
        if (isRange) {
            const formattedFrom = dateFrom !== null ? $437b23f6a393c3bf$var$dateToFormattedString(dateFrom, format) : "null";
            const formattedTo = dateTo !== null ? $437b23f6a393c3bf$var$dateToFormattedString(dateTo, format) : "null";
            return `${formattedFrom}-${formattedTo}`;
        }
        if (dateFrom != null) return $437b23f6a393c3bf$var$dateToFormattedString(dateFrom, format);
        return `${type}`;
    }
    updateParams(params) {
        super.updateParams(params);
        this.dateFilterParams = params.dateFilterParams;
    }
};
var $437b23f6a393c3bf$var$_DateFilter = class _DateFilter extends $437b23f6a393c3bf$export$804d9bd153e864e6 {
    constructor(){
        super("dateFilter");
        this.eConditionPanelsFrom = [];
        this.eConditionPanelsTo = [];
        this.dateConditionFromComps = [];
        this.dateConditionToComps = [];
        this.minValidYear = $437b23f6a393c3bf$var$DEFAULT_MIN_YEAR;
        this.maxValidYear = $437b23f6a393c3bf$var$DEFAULT_MAX_YEAR;
        this.minValidDate = null;
        this.maxValidDate = null;
    }
    afterGuiAttached(params) {
        super.afterGuiAttached(params);
        this.dateConditionFromComps[0].afterGuiAttached(params);
    }
    mapValuesFromModel(filterModel) {
        const { dateFrom: dateFrom, dateTo: dateTo, type: type } = filterModel || {};
        return [
            dateFrom && $437b23f6a393c3bf$var$parseDateTimeFromString(dateFrom) || null,
            dateTo && $437b23f6a393c3bf$var$parseDateTimeFromString(dateTo) || null
        ].slice(0, this.getNumberOfInputs(type));
    }
    comparator() {
        return this.dateFilterParams.comparator ? this.dateFilterParams.comparator : this.defaultComparator.bind(this);
    }
    defaultComparator(filterDate, cellValue) {
        const cellAsDate = cellValue;
        if (cellValue == null || cellAsDate < filterDate) return -1;
        if (cellAsDate > filterDate) return 1;
        return 0;
    }
    setParams(params) {
        this.dateFilterParams = params;
        super.setParams(params);
        const yearParser = (param, fallback)=>{
            if (params[param] != null) {
                if (!isNaN(params[param])) return params[param] == null ? fallback : Number(params[param]);
                else console.warn(`AG Grid: DateFilter ${param} is not a number`);
            }
            return fallback;
        };
        this.minValidYear = yearParser("minValidYear", $437b23f6a393c3bf$var$DEFAULT_MIN_YEAR);
        this.maxValidYear = yearParser("maxValidYear", $437b23f6a393c3bf$var$DEFAULT_MAX_YEAR);
        if (this.minValidYear > this.maxValidYear) console.warn(`AG Grid: DateFilter minValidYear should be <= maxValidYear`);
        if (params.minValidDate) this.minValidDate = params.minValidDate instanceof Date ? params.minValidDate : $437b23f6a393c3bf$var$parseDateTimeFromString(params.minValidDate);
        else this.minValidDate = null;
        if (params.maxValidDate) this.maxValidDate = params.maxValidDate instanceof Date ? params.maxValidDate : $437b23f6a393c3bf$var$parseDateTimeFromString(params.maxValidDate);
        else this.maxValidDate = null;
        if (this.minValidDate && this.maxValidDate && this.minValidDate > this.maxValidDate) console.warn(`AG Grid: DateFilter minValidDate should be <= maxValidDate`);
        this.filterModelFormatter = new $437b23f6a393c3bf$var$DateFilterModelFormatter(this.dateFilterParams, this.localeService, this.optionsFactory);
    }
    createDateCompWrapper(element) {
        const dateCompWrapper = new $437b23f6a393c3bf$var$DateCompWrapper(this.getContext(), this.userComponentFactory, {
            onDateChanged: ()=>this.onUiChanged(),
            filterParams: this.dateFilterParams
        }, element);
        this.addDestroyFunc(()=>dateCompWrapper.destroy());
        return dateCompWrapper;
    }
    setElementValue(element, value) {
        element.setDate(value);
    }
    setElementDisplayed(element, displayed) {
        element.setDisplayed(displayed);
    }
    setElementDisabled(element, disabled) {
        element.setDisabled(disabled);
    }
    getDefaultFilterOptions() {
        return _DateFilter.DEFAULT_FILTER_OPTIONS;
    }
    createValueElement() {
        const eDocument = this.gos.getDocument();
        const eCondition = eDocument.createElement("div");
        eCondition.classList.add("ag-filter-body");
        this.createFromToElement(eCondition, this.eConditionPanelsFrom, this.dateConditionFromComps, "from");
        this.createFromToElement(eCondition, this.eConditionPanelsTo, this.dateConditionToComps, "to");
        return eCondition;
    }
    createFromToElement(eCondition, eConditionPanels, dateConditionComps, fromTo) {
        const eDocument = this.gos.getDocument();
        const eConditionPanel = eDocument.createElement("div");
        eConditionPanel.classList.add(`ag-filter-${fromTo}`);
        eConditionPanel.classList.add(`ag-filter-date-${fromTo}`);
        eConditionPanels.push(eConditionPanel);
        eCondition.appendChild(eConditionPanel);
        dateConditionComps.push(this.createDateCompWrapper(eConditionPanel));
    }
    removeValueElements(startPosition, deleteCount) {
        this.removeDateComps(this.dateConditionFromComps, startPosition, deleteCount);
        this.removeDateComps(this.dateConditionToComps, startPosition, deleteCount);
        this.removeItems(this.eConditionPanelsFrom, startPosition, deleteCount);
        this.removeItems(this.eConditionPanelsTo, startPosition, deleteCount);
    }
    removeDateComps(components, startPosition, deleteCount) {
        const removedComponents = this.removeItems(components, startPosition, deleteCount);
        removedComponents.forEach((comp)=>comp.destroy());
    }
    isValidDateValue(value) {
        if (value === null) return false;
        if (this.minValidDate) {
            if (value < this.minValidDate) return false;
        } else {
            if (value.getUTCFullYear() < this.minValidYear) return false;
        }
        if (this.maxValidDate) {
            if (value > this.maxValidDate) return false;
        } else {
            if (value.getUTCFullYear() > this.maxValidYear) return false;
        }
        return true;
    }
    isConditionUiComplete(position) {
        if (!super.isConditionUiComplete(position)) return false;
        let valid = true;
        this.forEachInput((element, index, elPosition, numberOfInputs)=>{
            if (elPosition !== position || !valid || index >= numberOfInputs) return;
            valid = valid && this.isValidDateValue(element.getDate());
        });
        return valid;
    }
    areSimpleModelsEqual(aSimple, bSimple) {
        return aSimple.dateFrom === bSimple.dateFrom && aSimple.dateTo === bSimple.dateTo && aSimple.type === bSimple.type;
    }
    getFilterType() {
        return "date";
    }
    createCondition(position) {
        const type = this.getConditionType(position);
        const model = {};
        const values2 = this.getValues(position);
        if (values2.length > 0) model.dateFrom = $437b23f6a393c3bf$var$serialiseDate(values2[0]);
        if (values2.length > 1) model.dateTo = $437b23f6a393c3bf$var$serialiseDate(values2[1]);
        return $437b23f6a393c3bf$var$__spreadValues({
            dateFrom: null,
            dateTo: null,
            filterType: this.getFilterType(),
            type: type
        }, model);
    }
    resetPlaceholder() {
        const globalTranslate = this.localeService.getLocaleTextFunc();
        const placeholder = this.translate("dateFormatOoo");
        const ariaLabel = globalTranslate("ariaFilterValue", "Filter Value");
        this.forEachInput((element)=>{
            element.setInputPlaceholder(placeholder);
            element.setInputAriaLabel(ariaLabel);
        });
    }
    getInputs(position) {
        if (position >= this.dateConditionFromComps.length) return [
            null,
            null
        ];
        return [
            this.dateConditionFromComps[position],
            this.dateConditionToComps[position]
        ];
    }
    getValues(position) {
        const result = [];
        this.forEachPositionInput(position, (element, index, _elPosition, numberOfInputs)=>{
            if (index < numberOfInputs) result.push(element.getDate());
        });
        return result;
    }
    translate(key) {
        if (key === $437b23f6a393c3bf$export$804d9bd153e864e6.LESS_THAN) return super.translate("before");
        if (key === $437b23f6a393c3bf$export$804d9bd153e864e6.GREATER_THAN) return super.translate("after");
        return super.translate(key);
    }
    getModelAsString(model) {
        var _a;
        return (_a = this.filterModelFormatter.getModelAsString(model)) != null ? _a : "";
    }
};
$437b23f6a393c3bf$var$_DateFilter.DEFAULT_FILTER_OPTIONS = [
    $437b23f6a393c3bf$export$804d9bd153e864e6.EQUALS,
    $437b23f6a393c3bf$export$804d9bd153e864e6.NOT_EQUAL,
    $437b23f6a393c3bf$export$804d9bd153e864e6.LESS_THAN,
    $437b23f6a393c3bf$export$804d9bd153e864e6.GREATER_THAN,
    $437b23f6a393c3bf$export$804d9bd153e864e6.IN_RANGE,
    $437b23f6a393c3bf$export$804d9bd153e864e6.BLANK,
    $437b23f6a393c3bf$export$804d9bd153e864e6.NOT_BLANK
];
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("userComponentFactory")
], $437b23f6a393c3bf$var$_DateFilter.prototype, "userComponentFactory", 2);
var $437b23f6a393c3bf$export$45c1765a9388d778 = $437b23f6a393c3bf$var$_DateFilter;
// community-modules/core/src/filter/floating/provided/simpleFloatingFilter.ts
var $437b23f6a393c3bf$var$SimpleFloatingFilter = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    getDefaultDebounceMs() {
        return 0;
    }
    // this is a user component, and IComponent has "public destroy()" as part of the interface.
    // so we need to override destroy() just to make the method public.
    destroy() {
        super.destroy();
    }
    isEventFromFloatingFilter(event) {
        return event && event.afterFloatingFilter;
    }
    isEventFromDataChange(event) {
        return event == null ? void 0 : event.afterDataChange;
    }
    getLastType() {
        return this.lastType;
    }
    isReadOnly() {
        return this.readOnly;
    }
    setLastTypeFromModel(model) {
        if (!model) {
            this.lastType = this.optionsFactory.getDefaultOption();
            return;
        }
        const isCombined = model.operator;
        let condition;
        if (isCombined) {
            const combinedModel = model;
            condition = combinedModel.conditions[0];
        } else condition = model;
        this.lastType = condition.type;
    }
    canWeEditAfterModelFromParentFilter(model) {
        if (!model) return this.isTypeEditable(this.lastType);
        const isCombined = model.operator;
        if (isCombined) return false;
        const simpleModel = model;
        return this.isTypeEditable(simpleModel.type);
    }
    init(params) {
        this.setSimpleParams(params, false);
    }
    setSimpleParams(params, update = true) {
        this.optionsFactory = new $437b23f6a393c3bf$var$OptionsFactory();
        this.optionsFactory.init(params.filterParams, this.getDefaultFilterOptions());
        if (!update) this.lastType = this.optionsFactory.getDefaultOption();
        this.readOnly = !!params.filterParams.readOnly;
        const editable = this.isTypeEditable(this.optionsFactory.getDefaultOption());
        this.setEditable(editable);
    }
    onParamsUpdated(params) {
        this.refresh(params);
    }
    refresh(params) {
        this.setSimpleParams(params);
    }
    doesFilterHaveSingleInput(filterType) {
        const customFilterOption = this.optionsFactory.getCustomOption(filterType);
        const { numberOfInputs: numberOfInputs } = customFilterOption || {};
        return numberOfInputs == null || numberOfInputs == 1;
    }
    isTypeEditable(type) {
        const uneditableTypes = [
            $437b23f6a393c3bf$export$f5377e6e4a0f88ed.IN_RANGE,
            $437b23f6a393c3bf$export$f5377e6e4a0f88ed.EMPTY,
            $437b23f6a393c3bf$export$f5377e6e4a0f88ed.BLANK,
            $437b23f6a393c3bf$export$f5377e6e4a0f88ed.NOT_BLANK
        ];
        return !!type && !this.isReadOnly() && this.doesFilterHaveSingleInput(type) && uneditableTypes.indexOf(type) < 0;
    }
    getAriaLabel(params) {
        const displayName = this.columnModel.getDisplayNameForColumn(params.column, "header", true);
        const translate = this.localeService.getLocaleTextFunc();
        return `${displayName} ${translate("ariaFilterInput", "Filter Input")}`;
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnModel")
], $437b23f6a393c3bf$var$SimpleFloatingFilter.prototype, "columnModel", 2);
// community-modules/core/src/filter/provided/date/dateFloatingFilter.ts
var $437b23f6a393c3bf$var$DateFloatingFilter = class extends $437b23f6a393c3bf$var$SimpleFloatingFilter {
    constructor(){
        super(/* html */ `
            <div class="ag-floating-filter-input" role="presentation">
                <ag-input-text-field ref="eReadOnlyText"></ag-input-text-field>
                <div ref="eDateWrapper" style="display: flex;"></div>
            </div>`);
    }
    getDefaultFilterOptions() {
        return $437b23f6a393c3bf$export$45c1765a9388d778.DEFAULT_FILTER_OPTIONS;
    }
    init(params) {
        super.init(params);
        this.params = params;
        this.filterParams = params.filterParams;
        this.createDateComponent();
        this.filterModelFormatter = new $437b23f6a393c3bf$var$DateFilterModelFormatter(this.filterParams, this.localeService, this.optionsFactory);
        const translate = this.localeService.getLocaleTextFunc();
        this.eReadOnlyText.setDisabled(true).setInputAriaLabel(translate("ariaDateFilterInput", "Date Filter Input"));
    }
    onParamsUpdated(params) {
        this.refresh(params);
    }
    refresh(params) {
        super.refresh(params);
        this.params = params;
        this.filterParams = params.filterParams;
        this.updateDateComponent();
        this.filterModelFormatter.updateParams({
            optionsFactory: this.optionsFactory,
            dateFilterParams: this.filterParams
        });
        this.updateCompOnModelChange(params.currentParentModel());
    }
    updateCompOnModelChange(model) {
        const allowEditing = !this.isReadOnly() && this.canWeEditAfterModelFromParentFilter(model);
        this.setEditable(allowEditing);
        if (allowEditing) {
            if (model) {
                const dateModel = model;
                this.dateComp.setDate($437b23f6a393c3bf$var$parseDateTimeFromString(dateModel.dateFrom));
            } else this.dateComp.setDate(null);
            this.eReadOnlyText.setValue("");
        } else {
            this.eReadOnlyText.setValue(this.filterModelFormatter.getModelAsString(model));
            this.dateComp.setDate(null);
        }
    }
    setEditable(editable) {
        $437b23f6a393c3bf$var$setDisplayed(this.eDateWrapper, editable);
        $437b23f6a393c3bf$var$setDisplayed(this.eReadOnlyText.getGui(), !editable);
    }
    onParentModelChanged(model, event) {
        if (this.isEventFromFloatingFilter(event) || this.isEventFromDataChange(event)) return;
        super.setLastTypeFromModel(model);
        this.updateCompOnModelChange(model);
    }
    onDateChanged() {
        const filterValueDate = this.dateComp.getDate();
        const filterValueText = $437b23f6a393c3bf$var$serialiseDate(filterValueDate);
        this.params.parentFilterInstance((filterInstance)=>{
            if (filterInstance) {
                const date = $437b23f6a393c3bf$var$parseDateTimeFromString(filterValueText);
                filterInstance.onFloatingFilterChanged(this.getLastType() || null, date);
            }
        });
    }
    getDateComponentParams() {
        const debounceMs = $437b23f6a393c3bf$export$a927a1327c2cc7f0.getDebounceMs(this.params.filterParams, this.getDefaultDebounceMs());
        return {
            onDateChanged: $437b23f6a393c3bf$var$debounce(this.onDateChanged.bind(this), debounceMs),
            filterParams: this.params.column.getColDef().filterParams
        };
    }
    createDateComponent() {
        this.dateComp = new $437b23f6a393c3bf$var$DateCompWrapper(this.getContext(), this.userComponentFactory, this.getDateComponentParams(), this.eDateWrapper, (dateComp)=>{
            dateComp.setInputAriaLabel(this.getAriaLabel(this.params));
        });
        this.addDestroyFunc(()=>this.dateComp.destroy());
    }
    updateDateComponent() {
        const params = this.gos.addGridCommonParams(this.getDateComponentParams());
        this.dateComp.updateParams(params);
    }
    getFilterModelFormatter() {
        return this.filterModelFormatter;
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("userComponentFactory")
], $437b23f6a393c3bf$var$DateFloatingFilter.prototype, "userComponentFactory", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eReadOnlyText")
], $437b23f6a393c3bf$var$DateFloatingFilter.prototype, "eReadOnlyText", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eDateWrapper")
], $437b23f6a393c3bf$var$DateFloatingFilter.prototype, "eDateWrapper", 2);
// community-modules/core/src/filter/provided/date/defaultDateComponent.ts
var $437b23f6a393c3bf$var$DefaultDateComponent = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super(/* html */ `
            <div class="ag-filter-filter">
                <ag-input-text-field class="ag-date-filter" ref="eDateInput"></ag-input-text-field>
            </div>`);
    }
    // this is a user component, and IComponent has "public destroy()" as part of the interface.
    // so we need to override destroy() just to make the method public.
    destroy() {
        super.destroy();
    }
    init(params) {
        this.params = params;
        this.setParams(params);
        const inputElement = this.eDateInput.getInputElement();
        this.addManagedListener(inputElement, "mousedown", ()=>{
            if (this.eDateInput.isDisabled() || this.usingSafariDatePicker) return;
            inputElement.focus();
        });
        this.addManagedListener(inputElement, "input", (e)=>{
            if (e.target !== this.gos.getActiveDomElement()) return;
            if (this.eDateInput.isDisabled()) return;
            this.params.onDateChanged();
        });
    }
    setParams(params) {
        const inputElement = this.eDateInput.getInputElement();
        const shouldUseBrowserDatePicker = this.shouldUseBrowserDatePicker(params);
        this.usingSafariDatePicker = shouldUseBrowserDatePicker && $437b23f6a393c3bf$var$isBrowserSafari();
        inputElement.type = shouldUseBrowserDatePicker ? "date" : "text";
        const { minValidYear: minValidYear, maxValidYear: maxValidYear, minValidDate: minValidDate, maxValidDate: maxValidDate } = params.filterParams || {};
        if (minValidDate && minValidYear) $437b23f6a393c3bf$var$warnOnce("DateFilter should not have both minValidDate and minValidYear parameters set at the same time! minValidYear will be ignored.");
        if (maxValidDate && maxValidYear) $437b23f6a393c3bf$var$warnOnce("DateFilter should not have both maxValidDate and maxValidYear parameters set at the same time! maxValidYear will be ignored.");
        if (minValidDate && maxValidDate) {
            const [parsedMinValidDate, parsedMaxValidDate] = [
                minValidDate,
                maxValidDate
            ].map((v)=>v instanceof Date ? v : $437b23f6a393c3bf$var$parseDateTimeFromString(v));
            if (parsedMinValidDate && parsedMaxValidDate && parsedMinValidDate.getTime() > parsedMaxValidDate.getTime()) $437b23f6a393c3bf$var$warnOnce("DateFilter parameter minValidDate should always be lower than or equal to parameter maxValidDate.");
        }
        if (minValidDate) {
            if (minValidDate instanceof Date) inputElement.min = $437b23f6a393c3bf$var$dateToFormattedString(minValidDate);
            else inputElement.min = minValidDate;
        } else if (minValidYear) inputElement.min = `${minValidYear}-01-01`;
        if (maxValidDate) {
            if (maxValidDate instanceof Date) inputElement.max = $437b23f6a393c3bf$var$dateToFormattedString(maxValidDate);
            else inputElement.max = maxValidDate;
        } else if (maxValidYear) inputElement.max = `${maxValidYear}-12-31`;
    }
    onParamsUpdated(params) {
        this.refresh(params);
    }
    refresh(params) {
        this.params = params;
        this.setParams(params);
    }
    getDate() {
        return $437b23f6a393c3bf$var$parseDateTimeFromString(this.eDateInput.getValue());
    }
    setDate(date) {
        this.eDateInput.setValue($437b23f6a393c3bf$var$serialiseDate(date, false));
    }
    setInputPlaceholder(placeholder) {
        this.eDateInput.setInputPlaceholder(placeholder);
    }
    setInputAriaLabel(ariaLabel) {
        this.eDateInput.setAriaLabel(ariaLabel);
    }
    setDisabled(disabled) {
        this.eDateInput.setDisabled(disabled);
    }
    afterGuiAttached(params) {
        if (!params || !params.suppressFocus) this.eDateInput.getInputElement().focus();
    }
    shouldUseBrowserDatePicker(params) {
        if (params.filterParams && params.filterParams.browserDatePicker != null) return params.filterParams.browserDatePicker;
        return $437b23f6a393c3bf$var$isBrowserChrome() || $437b23f6a393c3bf$var$isBrowserFirefox() || $437b23f6a393c3bf$var$isBrowserSafari() && $437b23f6a393c3bf$var$getSafariVersion() >= 14.1;
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eDateInput")
], $437b23f6a393c3bf$var$DefaultDateComponent.prototype, "eDateInput", 2);
// community-modules/core/src/widgets/agInputTextField.ts
var $437b23f6a393c3bf$export$8c027679838afd47 = class extends $437b23f6a393c3bf$var$AgAbstractInputField {
    constructor(config, className = "ag-text-field", inputType = "text"){
        super(config, className, inputType);
    }
    postConstruct() {
        super.postConstruct();
        if (this.config.allowedCharPattern) this.preventDisallowedCharacters();
    }
    setValue(value, silent) {
        if (this.eInput.value !== value) this.eInput.value = $437b23f6a393c3bf$var$exists(value) ? value : "";
        return super.setValue(value, silent);
    }
    /** Used to set an initial value into the input without necessarily setting `this.value` or triggering events (e.g. to set an invalid value) */ setStartValue(value) {
        this.setValue(value, true);
    }
    preventDisallowedCharacters() {
        const pattern = new RegExp(`[${this.config.allowedCharPattern}]`);
        const preventCharacters = (event)=>{
            if (!$437b23f6a393c3bf$var$isEventFromPrintableCharacter(event)) return;
            if (event.key && !pattern.test(event.key)) event.preventDefault();
        };
        this.addManagedListener(this.eInput, "keydown", preventCharacters);
        this.addManagedListener(this.eInput, "paste", (e)=>{
            var _a;
            const text = (_a = e.clipboardData) == null ? void 0 : _a.getData("text");
            if (text && text.split("").some((c)=>!pattern.test(c))) e.preventDefault();
        });
    }
};
// community-modules/core/src/widgets/agInputNumberField.ts
var $437b23f6a393c3bf$export$c8aa0be99738aee = class extends $437b23f6a393c3bf$export$8c027679838afd47 {
    constructor(config){
        super(config, "ag-number-field", "number");
    }
    postConstruct() {
        super.postConstruct();
        this.addManagedListener(this.eInput, "blur", ()=>{
            const floatedValue = parseFloat(this.eInput.value);
            const value = isNaN(floatedValue) ? "" : this.normalizeValue(floatedValue.toString());
            if (this.value !== value) this.setValue(value);
        });
        this.addManagedListener(this.eInput, "wheel", this.onWheel.bind(this));
        this.eInput.step = "any";
        const { precision: precision, min: min, max: max, step: step } = this.config;
        if (typeof precision === "number") this.setPrecision(precision);
        if (typeof min === "number") this.setMin(min);
        if (typeof max === "number") this.setMax(max);
        if (typeof step === "number") this.setStep(step);
    }
    onWheel(e) {
        if (this.gos.getActiveDomElement() === this.eInput) e.preventDefault();
    }
    normalizeValue(value) {
        if (value === "") return "";
        if (this.precision != null) value = this.adjustPrecision(value);
        const val = parseFloat(value);
        if (this.min != null && val < this.min) value = this.min.toString();
        else if (this.max != null && val > this.max) value = this.max.toString();
        return value;
    }
    adjustPrecision(value, isScientificNotation) {
        if (this.precision == null) return value;
        if (isScientificNotation) {
            const floatString = parseFloat(value).toFixed(this.precision);
            return parseFloat(floatString).toString();
        }
        const parts = String(value).split(".");
        if (parts.length > 1) {
            if (parts[1].length <= this.precision) return value;
            else if (this.precision > 0) return `${parts[0]}.${parts[1].slice(0, this.precision)}`;
        }
        return parts[0];
    }
    setMin(min) {
        if (this.min === min) return this;
        this.min = min;
        $437b23f6a393c3bf$var$addOrRemoveAttribute(this.eInput, "min", min);
        return this;
    }
    setMax(max) {
        if (this.max === max) return this;
        this.max = max;
        $437b23f6a393c3bf$var$addOrRemoveAttribute(this.eInput, "max", max);
        return this;
    }
    setPrecision(precision) {
        this.precision = precision;
        return this;
    }
    setStep(step) {
        if (this.step === step) return this;
        this.step = step;
        $437b23f6a393c3bf$var$addOrRemoveAttribute(this.eInput, "step", step);
        return this;
    }
    setValue(value, silent) {
        return this.setValueOrInputValue((v)=>super.setValue(v, silent), ()=>this, value);
    }
    setStartValue(value) {
        return this.setValueOrInputValue((v)=>super.setValue(v, true), (v)=>{
            this.eInput.value = v;
        }, value);
    }
    setValueOrInputValue(setValueFunc, setInputValueOnlyFunc, value) {
        if ($437b23f6a393c3bf$var$exists(value)) {
            let setInputValueOnly = this.isScientificNotation(value);
            if (setInputValueOnly && this.eInput.validity.valid) return setValueFunc(value);
            if (!setInputValueOnly) {
                value = this.adjustPrecision(value);
                const normalizedValue = this.normalizeValue(value);
                setInputValueOnly = value != normalizedValue;
            }
            if (setInputValueOnly) return setInputValueOnlyFunc(value);
        }
        return setValueFunc(value);
    }
    getValue() {
        if (!this.eInput.validity.valid) return void 0;
        const inputValue = this.eInput.value;
        if (this.isScientificNotation(inputValue)) return this.adjustPrecision(inputValue, true);
        return super.getValue();
    }
    isScientificNotation(value) {
        return typeof value === "string" && value.includes("e");
    }
};
// community-modules/core/src/filter/provided/number/numberFilter.ts
var $437b23f6a393c3bf$var$NumberFilterModelFormatter = class extends $437b23f6a393c3bf$var$SimpleFilterModelFormatter {
    conditionToString(condition, options) {
        const { numberOfInputs: numberOfInputs } = options || {};
        const isRange = condition.type == $437b23f6a393c3bf$export$f5377e6e4a0f88ed.IN_RANGE || numberOfInputs === 2;
        if (isRange) return `${this.formatValue(condition.filter)}-${this.formatValue(condition.filterTo)}`;
        if (condition.filter != null) return this.formatValue(condition.filter);
        return `${condition.type}`;
    }
};
function $437b23f6a393c3bf$var$getAllowedCharPattern(filterParams) {
    const { allowedCharPattern: allowedCharPattern } = filterParams != null ? filterParams : {};
    return allowedCharPattern != null ? allowedCharPattern : null;
}
var $437b23f6a393c3bf$var$_NumberFilter = class _NumberFilter extends $437b23f6a393c3bf$export$804d9bd153e864e6 {
    constructor(){
        super("numberFilter");
        this.eValuesFrom = [];
        this.eValuesTo = [];
    }
    refresh(params) {
        if (this.numberFilterParams.allowedCharPattern !== params.allowedCharPattern) return false;
        return super.refresh(params);
    }
    mapValuesFromModel(filterModel) {
        const { filter: filter, filterTo: filterTo, type: type } = filterModel || {};
        return [
            this.processValue(filter),
            this.processValue(filterTo)
        ].slice(0, this.getNumberOfInputs(type));
    }
    getDefaultDebounceMs() {
        return 500;
    }
    comparator() {
        return (left, right)=>{
            if (left === right) return 0;
            return left < right ? 1 : -1;
        };
    }
    setParams(params) {
        this.numberFilterParams = params;
        super.setParams(params);
        this.filterModelFormatter = new $437b23f6a393c3bf$var$NumberFilterModelFormatter(this.localeService, this.optionsFactory, this.numberFilterParams.numberFormatter);
    }
    getDefaultFilterOptions() {
        return _NumberFilter.DEFAULT_FILTER_OPTIONS;
    }
    setElementValue(element, value, fromFloatingFilter) {
        const valueToSet = !fromFloatingFilter && this.numberFilterParams.numberFormatter ? this.numberFilterParams.numberFormatter(value != null ? value : null) : value;
        super.setElementValue(element, valueToSet);
    }
    createValueElement() {
        const allowedCharPattern = $437b23f6a393c3bf$var$getAllowedCharPattern(this.numberFilterParams);
        const eCondition = document.createElement("div");
        eCondition.classList.add("ag-filter-body");
        $437b23f6a393c3bf$var$setAriaRole(eCondition, "presentation");
        this.createFromToElement(eCondition, this.eValuesFrom, "from", allowedCharPattern);
        this.createFromToElement(eCondition, this.eValuesTo, "to", allowedCharPattern);
        return eCondition;
    }
    createFromToElement(eCondition, eValues, fromTo, allowedCharPattern) {
        const eValue = this.createManagedBean(allowedCharPattern ? new $437b23f6a393c3bf$export$8c027679838afd47({
            allowedCharPattern: allowedCharPattern
        }) : new $437b23f6a393c3bf$export$c8aa0be99738aee());
        eValue.addCssClass(`ag-filter-${fromTo}`);
        eValue.addCssClass("ag-filter-filter");
        eValues.push(eValue);
        eCondition.appendChild(eValue.getGui());
    }
    removeValueElements(startPosition, deleteCount) {
        this.removeComponents(this.eValuesFrom, startPosition, deleteCount);
        this.removeComponents(this.eValuesTo, startPosition, deleteCount);
    }
    getValues(position) {
        const result = [];
        this.forEachPositionInput(position, (element, index, _elPosition, numberOfInputs)=>{
            if (index < numberOfInputs) result.push(this.processValue(this.stringToFloat(element.getValue())));
        });
        return result;
    }
    areSimpleModelsEqual(aSimple, bSimple) {
        return aSimple.filter === bSimple.filter && aSimple.filterTo === bSimple.filterTo && aSimple.type === bSimple.type;
    }
    getFilterType() {
        return "number";
    }
    processValue(value) {
        if (value == null) return null;
        return isNaN(value) ? null : value;
    }
    stringToFloat(value) {
        if (typeof value === "number") return value;
        let filterText = $437b23f6a393c3bf$var$makeNull(value);
        if (filterText != null && filterText.trim() === "") filterText = null;
        if (this.numberFilterParams.numberParser) return this.numberFilterParams.numberParser(filterText);
        return filterText == null || filterText.trim() === "-" ? null : parseFloat(filterText);
    }
    createCondition(position) {
        const type = this.getConditionType(position);
        const model = {
            filterType: this.getFilterType(),
            type: type
        };
        const values2 = this.getValues(position);
        if (values2.length > 0) model.filter = values2[0];
        if (values2.length > 1) model.filterTo = values2[1];
        return model;
    }
    getInputs(position) {
        if (position >= this.eValuesFrom.length) return [
            null,
            null
        ];
        return [
            this.eValuesFrom[position],
            this.eValuesTo[position]
        ];
    }
    getModelAsString(model) {
        var _a;
        return (_a = this.filterModelFormatter.getModelAsString(model)) != null ? _a : "";
    }
    hasInvalidInputs() {
        let invalidInputs = false;
        this.forEachInput((element)=>{
            if (!element.getInputElement().validity.valid) {
                invalidInputs = true;
                return;
            }
        });
        return invalidInputs;
    }
};
$437b23f6a393c3bf$var$_NumberFilter.DEFAULT_FILTER_OPTIONS = [
    $437b23f6a393c3bf$export$804d9bd153e864e6.EQUALS,
    $437b23f6a393c3bf$export$804d9bd153e864e6.NOT_EQUAL,
    $437b23f6a393c3bf$export$804d9bd153e864e6.GREATER_THAN,
    $437b23f6a393c3bf$export$804d9bd153e864e6.GREATER_THAN_OR_EQUAL,
    $437b23f6a393c3bf$export$804d9bd153e864e6.LESS_THAN,
    $437b23f6a393c3bf$export$804d9bd153e864e6.LESS_THAN_OR_EQUAL,
    $437b23f6a393c3bf$export$804d9bd153e864e6.IN_RANGE,
    $437b23f6a393c3bf$export$804d9bd153e864e6.BLANK,
    $437b23f6a393c3bf$export$804d9bd153e864e6.NOT_BLANK
];
var $437b23f6a393c3bf$export$db99a591a1ce9821 = $437b23f6a393c3bf$var$_NumberFilter;
// community-modules/core/src/filter/provided/text/textFilter.ts
var $437b23f6a393c3bf$var$TextFilterModelFormatter = class extends $437b23f6a393c3bf$var$SimpleFilterModelFormatter {
    conditionToString(condition, options) {
        const { numberOfInputs: numberOfInputs } = options || {};
        const isRange = condition.type == $437b23f6a393c3bf$export$f5377e6e4a0f88ed.IN_RANGE || numberOfInputs === 2;
        if (isRange) return `${condition.filter}-${condition.filterTo}`;
        if (condition.filter != null) return `${condition.filter}`;
        return `${condition.type}`;
    }
};
var $437b23f6a393c3bf$var$_TextFilter = class _TextFilter extends $437b23f6a393c3bf$export$f5377e6e4a0f88ed {
    constructor(){
        super("textFilter");
        this.eValuesFrom = [];
        this.eValuesTo = [];
    }
    static trimInput(value) {
        const trimmedInput = value && value.trim();
        return trimmedInput === "" ? value : trimmedInput;
    }
    getDefaultDebounceMs() {
        return 500;
    }
    setParams(params) {
        this.textFilterParams = params;
        super.setParams(params);
        this.matcher = this.getTextMatcher();
        this.formatter = this.textFilterParams.textFormatter || (this.textFilterParams.caseSensitive ? _TextFilter.DEFAULT_FORMATTER : _TextFilter.DEFAULT_LOWERCASE_FORMATTER);
        this.filterModelFormatter = new $437b23f6a393c3bf$var$TextFilterModelFormatter(this.localeService, this.optionsFactory);
    }
    getTextMatcher() {
        const legacyComparator = this.textFilterParams.textCustomComparator;
        if (legacyComparator) {
            $437b23f6a393c3bf$export$71511d61b312f219.warnOnce("textCustomComparator is deprecated, use textMatcher instead.");
            return ({ filterOption: filterOption, value: value, filterText: filterText })=>legacyComparator(filterOption, value, filterText);
        }
        return this.textFilterParams.textMatcher || _TextFilter.DEFAULT_MATCHER;
    }
    createCondition(position) {
        const type = this.getConditionType(position);
        const model = {
            filterType: this.getFilterType(),
            type: type
        };
        const values2 = this.getValuesWithSideEffects(position, true);
        if (values2.length > 0) model.filter = values2[0];
        if (values2.length > 1) model.filterTo = values2[1];
        return model;
    }
    getFilterType() {
        return "text";
    }
    areSimpleModelsEqual(aSimple, bSimple) {
        return aSimple.filter === bSimple.filter && aSimple.filterTo === bSimple.filterTo && aSimple.type === bSimple.type;
    }
    getInputs(position) {
        if (position >= this.eValuesFrom.length) return [
            null,
            null
        ];
        return [
            this.eValuesFrom[position],
            this.eValuesTo[position]
        ];
    }
    getValues(position) {
        return this.getValuesWithSideEffects(position, false);
    }
    getValuesWithSideEffects(position, applySideEffects) {
        const result = [];
        this.forEachPositionInput(position, (element, index, _elPosition, numberOfInputs)=>{
            var _a;
            if (index < numberOfInputs) {
                let value = $437b23f6a393c3bf$var$makeNull(element.getValue());
                if (applySideEffects && this.textFilterParams.trimInput) {
                    value = (_a = _TextFilter.trimInput(value)) != null ? _a : null;
                    element.setValue(value, true);
                }
                result.push(value);
            }
        });
        return result;
    }
    getDefaultFilterOptions() {
        return _TextFilter.DEFAULT_FILTER_OPTIONS;
    }
    createValueElement() {
        const eCondition = document.createElement("div");
        eCondition.classList.add("ag-filter-body");
        $437b23f6a393c3bf$var$setAriaRole(eCondition, "presentation");
        this.createFromToElement(eCondition, this.eValuesFrom, "from");
        this.createFromToElement(eCondition, this.eValuesTo, "to");
        return eCondition;
    }
    createFromToElement(eCondition, eValues, fromTo) {
        const eValue = this.createManagedBean(new $437b23f6a393c3bf$export$8c027679838afd47());
        eValue.addCssClass(`ag-filter-${fromTo}`);
        eValue.addCssClass("ag-filter-filter");
        eValues.push(eValue);
        eCondition.appendChild(eValue.getGui());
    }
    removeValueElements(startPosition, deleteCount) {
        this.removeComponents(this.eValuesFrom, startPosition, deleteCount);
        this.removeComponents(this.eValuesTo, startPosition, deleteCount);
    }
    mapValuesFromModel(filterModel) {
        const { filter: filter, filterTo: filterTo, type: type } = filterModel || {};
        return [
            filter || null,
            filterTo || null
        ].slice(0, this.getNumberOfInputs(type));
    }
    evaluateNullValue(filterType) {
        const filterTypesAllowNulls = [
            $437b23f6a393c3bf$export$f5377e6e4a0f88ed.NOT_EQUAL,
            $437b23f6a393c3bf$export$f5377e6e4a0f88ed.NOT_CONTAINS,
            $437b23f6a393c3bf$export$f5377e6e4a0f88ed.BLANK
        ];
        return filterType ? filterTypesAllowNulls.indexOf(filterType) >= 0 : false;
    }
    evaluateNonNullValue(values2, cellValue, filterModel, params) {
        const formattedValues = values2.map((v)=>this.formatter(v)) || [];
        const cellValueFormatted = this.formatter(cellValue);
        const { api: api, colDef: colDef, column: column, columnApi: columnApi, context: context, textFormatter: textFormatter } = this.textFilterParams;
        if (filterModel.type === $437b23f6a393c3bf$export$f5377e6e4a0f88ed.BLANK) return this.isBlank(cellValue);
        else if (filterModel.type === $437b23f6a393c3bf$export$f5377e6e4a0f88ed.NOT_BLANK) return !this.isBlank(cellValue);
        const matcherParams = {
            api: api,
            colDef: colDef,
            column: column,
            columnApi: columnApi,
            context: context,
            node: params.node,
            data: params.data,
            filterOption: filterModel.type,
            value: cellValueFormatted,
            textFormatter: textFormatter
        };
        return formattedValues.some((v)=>this.matcher($437b23f6a393c3bf$var$__spreadProps($437b23f6a393c3bf$var$__spreadValues({}, matcherParams), {
                filterText: v
            })));
    }
    getModelAsString(model) {
        var _a;
        return (_a = this.filterModelFormatter.getModelAsString(model)) != null ? _a : "";
    }
};
$437b23f6a393c3bf$var$_TextFilter.DEFAULT_FILTER_OPTIONS = [
    $437b23f6a393c3bf$export$f5377e6e4a0f88ed.CONTAINS,
    $437b23f6a393c3bf$export$f5377e6e4a0f88ed.NOT_CONTAINS,
    $437b23f6a393c3bf$export$f5377e6e4a0f88ed.EQUALS,
    $437b23f6a393c3bf$export$f5377e6e4a0f88ed.NOT_EQUAL,
    $437b23f6a393c3bf$export$f5377e6e4a0f88ed.STARTS_WITH,
    $437b23f6a393c3bf$export$f5377e6e4a0f88ed.ENDS_WITH,
    $437b23f6a393c3bf$export$f5377e6e4a0f88ed.BLANK,
    $437b23f6a393c3bf$export$f5377e6e4a0f88ed.NOT_BLANK
];
$437b23f6a393c3bf$var$_TextFilter.DEFAULT_FORMATTER = (from)=>from;
$437b23f6a393c3bf$var$_TextFilter.DEFAULT_LOWERCASE_FORMATTER = (from)=>from == null ? null : from.toString().toLowerCase();
$437b23f6a393c3bf$var$_TextFilter.DEFAULT_MATCHER = ({ filterOption: filterOption, value: value, filterText: filterText })=>{
    if (filterText == null) return false;
    switch(filterOption){
        case $437b23f6a393c3bf$var$_TextFilter.CONTAINS:
            return value.indexOf(filterText) >= 0;
        case $437b23f6a393c3bf$var$_TextFilter.NOT_CONTAINS:
            return value.indexOf(filterText) < 0;
        case $437b23f6a393c3bf$var$_TextFilter.EQUALS:
            return value === filterText;
        case $437b23f6a393c3bf$var$_TextFilter.NOT_EQUAL:
            return value != filterText;
        case $437b23f6a393c3bf$var$_TextFilter.STARTS_WITH:
            return value.indexOf(filterText) === 0;
        case $437b23f6a393c3bf$var$_TextFilter.ENDS_WITH:
            const index = value.lastIndexOf(filterText);
            return index >= 0 && index === value.length - filterText.length;
        default:
            return false;
    }
};
var $437b23f6a393c3bf$export$bf4978b2dd458630 = $437b23f6a393c3bf$var$_TextFilter;
// community-modules/core/src/filter/floating/provided/textInputFloatingFilter.ts
var $437b23f6a393c3bf$var$FloatingFilterTextInputService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(params){
        super();
        this.params = params;
        this.valueChangedListener = ()=>{};
    }
    setupGui(parentElement) {
        var _a;
        this.eFloatingFilterTextInput = this.createManagedBean(new $437b23f6a393c3bf$export$8c027679838afd47((_a = this.params) == null ? void 0 : _a.config));
        const eInput = this.eFloatingFilterTextInput.getGui();
        parentElement.appendChild(eInput);
        this.addManagedListener(eInput, "input", (e)=>this.valueChangedListener(e));
        this.addManagedListener(eInput, "keydown", (e)=>this.valueChangedListener(e));
    }
    setEditable(editable) {
        this.eFloatingFilterTextInput.setDisabled(!editable);
    }
    setAutoComplete(autoComplete) {
        this.eFloatingFilterTextInput.setAutoComplete(autoComplete);
    }
    getValue() {
        return this.eFloatingFilterTextInput.getValue();
    }
    setValue(value, silent) {
        this.eFloatingFilterTextInput.setValue(value, silent);
    }
    setValueChangedListener(listener) {
        this.valueChangedListener = listener;
    }
    setParams(params) {
        this.setAriaLabel(params.ariaLabel);
        if (params.autoComplete !== void 0) this.setAutoComplete(params.autoComplete);
    }
    setAriaLabel(ariaLabel) {
        this.eFloatingFilterTextInput.setInputAriaLabel(ariaLabel);
    }
};
var $437b23f6a393c3bf$var$TextInputFloatingFilter = class extends $437b23f6a393c3bf$var$SimpleFloatingFilter {
    postConstruct() {
        this.setTemplate(/* html */ `
            <div class="ag-floating-filter-input" role="presentation" ref="eFloatingFilterInputContainer"></div>
        `);
    }
    getDefaultDebounceMs() {
        return 500;
    }
    onParentModelChanged(model, event) {
        if (this.isEventFromFloatingFilter(event) || this.isEventFromDataChange(event)) return;
        this.setLastTypeFromModel(model);
        this.setEditable(this.canWeEditAfterModelFromParentFilter(model));
        this.floatingFilterInputService.setValue(this.getFilterModelFormatter().getModelAsString(model));
    }
    init(params) {
        this.setupFloatingFilterInputService(params);
        super.init(params);
        this.setTextInputParams(params);
    }
    setupFloatingFilterInputService(params) {
        this.floatingFilterInputService = this.createFloatingFilterInputService(params);
        this.floatingFilterInputService.setupGui(this.eFloatingFilterInputContainer);
    }
    setTextInputParams(params) {
        var _a;
        this.params = params;
        const autoComplete = (_a = params.browserAutoComplete) != null ? _a : false;
        this.floatingFilterInputService.setParams({
            ariaLabel: this.getAriaLabel(params),
            autoComplete: autoComplete
        });
        this.applyActive = $437b23f6a393c3bf$export$a927a1327c2cc7f0.isUseApplyButton(this.params.filterParams);
        if (!this.isReadOnly()) {
            const debounceMs = $437b23f6a393c3bf$export$a927a1327c2cc7f0.getDebounceMs(this.params.filterParams, this.getDefaultDebounceMs());
            const toDebounce = $437b23f6a393c3bf$var$debounce(this.syncUpWithParentFilter.bind(this), debounceMs);
            this.floatingFilterInputService.setValueChangedListener(toDebounce);
        }
    }
    onParamsUpdated(params) {
        this.refresh(params);
    }
    refresh(params) {
        super.refresh(params);
        this.setTextInputParams(params);
    }
    recreateFloatingFilterInputService(params) {
        const value = this.floatingFilterInputService.getValue();
        $437b23f6a393c3bf$var$clearElement(this.eFloatingFilterInputContainer);
        this.destroyBean(this.floatingFilterInputService);
        this.setupFloatingFilterInputService(params);
        this.floatingFilterInputService.setValue(value, true);
    }
    syncUpWithParentFilter(e) {
        const isEnterKey = e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER;
        if (this.applyActive && !isEnterKey) return;
        let value = this.floatingFilterInputService.getValue();
        if (this.params.filterParams.trimInput) {
            value = $437b23f6a393c3bf$export$bf4978b2dd458630.trimInput(value);
            this.floatingFilterInputService.setValue(value, true);
        }
        this.params.parentFilterInstance((filterInstance)=>{
            if (filterInstance) filterInstance.onFloatingFilterChanged(this.getLastType() || null, value || null);
        });
    }
    setEditable(editable) {
        this.floatingFilterInputService.setEditable(editable);
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eFloatingFilterInputContainer")
], $437b23f6a393c3bf$var$TextInputFloatingFilter.prototype, "eFloatingFilterInputContainer", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$TextInputFloatingFilter.prototype, "postConstruct", 1);
// community-modules/core/src/filter/provided/number/numberFloatingFilter.ts
var $437b23f6a393c3bf$var$FloatingFilterNumberInputService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.valueChangedListener = ()=>{};
        this.numberInputActive = true;
    }
    setupGui(parentElement) {
        this.eFloatingFilterNumberInput = this.createManagedBean(new $437b23f6a393c3bf$export$c8aa0be99738aee());
        this.eFloatingFilterTextInput = this.createManagedBean(new $437b23f6a393c3bf$export$8c027679838afd47());
        this.eFloatingFilterTextInput.setDisabled(true);
        const eNumberInput = this.eFloatingFilterNumberInput.getGui();
        const eTextInput = this.eFloatingFilterTextInput.getGui();
        parentElement.appendChild(eNumberInput);
        parentElement.appendChild(eTextInput);
        this.setupListeners(eNumberInput, (e)=>this.valueChangedListener(e));
        this.setupListeners(eTextInput, (e)=>this.valueChangedListener(e));
    }
    setEditable(editable) {
        this.numberInputActive = editable;
        this.eFloatingFilterNumberInput.setDisplayed(this.numberInputActive);
        this.eFloatingFilterTextInput.setDisplayed(!this.numberInputActive);
    }
    setAutoComplete(autoComplete) {
        this.eFloatingFilterNumberInput.setAutoComplete(autoComplete);
        this.eFloatingFilterTextInput.setAutoComplete(autoComplete);
    }
    getValue() {
        return this.getActiveInputElement().getValue();
    }
    setValue(value, silent) {
        this.getActiveInputElement().setValue(value, silent);
    }
    getActiveInputElement() {
        return this.numberInputActive ? this.eFloatingFilterNumberInput : this.eFloatingFilterTextInput;
    }
    setValueChangedListener(listener) {
        this.valueChangedListener = listener;
    }
    setupListeners(element, listener) {
        this.addManagedListener(element, "input", listener);
        this.addManagedListener(element, "keydown", listener);
    }
    setParams(params) {
        this.setAriaLabel(params.ariaLabel);
        if (params.autoComplete !== void 0) this.setAutoComplete(params.autoComplete);
    }
    setAriaLabel(ariaLabel) {
        this.eFloatingFilterNumberInput.setInputAriaLabel(ariaLabel);
        this.eFloatingFilterTextInput.setInputAriaLabel(ariaLabel);
    }
};
var $437b23f6a393c3bf$var$NumberFloatingFilter = class extends $437b23f6a393c3bf$var$TextInputFloatingFilter {
    init(params) {
        var _a;
        super.init(params);
        this.filterModelFormatter = new $437b23f6a393c3bf$var$NumberFilterModelFormatter(this.localeService, this.optionsFactory, (_a = params.filterParams) == null ? void 0 : _a.numberFormatter);
    }
    onParamsUpdated(params) {
        this.refresh(params);
    }
    refresh(params) {
        const allowedCharPattern = $437b23f6a393c3bf$var$getAllowedCharPattern(params.filterParams);
        if (allowedCharPattern !== this.allowedCharPattern) this.recreateFloatingFilterInputService(params);
        super.refresh(params);
        this.filterModelFormatter.updateParams({
            optionsFactory: this.optionsFactory
        });
    }
    getDefaultFilterOptions() {
        return $437b23f6a393c3bf$export$db99a591a1ce9821.DEFAULT_FILTER_OPTIONS;
    }
    getFilterModelFormatter() {
        return this.filterModelFormatter;
    }
    createFloatingFilterInputService(params) {
        this.allowedCharPattern = $437b23f6a393c3bf$var$getAllowedCharPattern(params.filterParams);
        if (this.allowedCharPattern) return this.createManagedBean(new $437b23f6a393c3bf$var$FloatingFilterTextInputService({
            config: {
                allowedCharPattern: this.allowedCharPattern
            }
        }));
        return this.createManagedBean(new $437b23f6a393c3bf$var$FloatingFilterNumberInputService());
    }
};
// community-modules/core/src/filter/provided/text/textFloatingFilter.ts
var $437b23f6a393c3bf$export$f856d88991b6b7f9 = class extends $437b23f6a393c3bf$var$TextInputFloatingFilter {
    init(params) {
        super.init(params);
        this.filterModelFormatter = new $437b23f6a393c3bf$var$TextFilterModelFormatter(this.localeService, this.optionsFactory);
    }
    onParamsUpdated(params) {
        this.refresh(params);
    }
    refresh(params) {
        super.refresh(params);
        this.filterModelFormatter.updateParams({
            optionsFactory: this.optionsFactory
        });
    }
    getDefaultFilterOptions() {
        return $437b23f6a393c3bf$export$bf4978b2dd458630.DEFAULT_FILTER_OPTIONS;
    }
    getFilterModelFormatter() {
        return this.filterModelFormatter;
    }
    createFloatingFilterInputService() {
        return this.createManagedBean(new $437b23f6a393c3bf$var$FloatingFilterTextInputService());
    }
};
// community-modules/core/src/widgets/touchListener.ts
var $437b23f6a393c3bf$var$_TouchListener = class _TouchListener {
    constructor(eElement, preventMouseClick = false){
        this.destroyFuncs = [];
        this.touching = false;
        this.eventService = new $437b23f6a393c3bf$export$895d7dc49f082ca1();
        this.eElement = eElement;
        this.preventMouseClick = preventMouseClick;
        const startListener = this.onTouchStart.bind(this);
        const moveListener = this.onTouchMove.bind(this);
        const endListener = this.onTouchEnd.bind(this);
        this.eElement.addEventListener("touchstart", startListener, {
            passive: true
        });
        this.eElement.addEventListener("touchmove", moveListener, {
            passive: true
        });
        this.eElement.addEventListener("touchend", endListener, {
            passive: false
        });
        this.destroyFuncs.push(()=>{
            this.eElement.removeEventListener("touchstart", startListener, {
                passive: true
            });
            this.eElement.removeEventListener("touchmove", moveListener, {
                passive: true
            });
            this.eElement.removeEventListener("touchend", endListener, {
                passive: false
            });
        });
    }
    getActiveTouch(touchList) {
        for(let i = 0; i < touchList.length; i++){
            const matches = touchList[i].identifier === this.touchStart.identifier;
            if (matches) return touchList[i];
        }
        return null;
    }
    addEventListener(eventType, listener) {
        this.eventService.addEventListener(eventType, listener);
    }
    removeEventListener(eventType, listener) {
        this.eventService.removeEventListener(eventType, listener);
    }
    onTouchStart(touchEvent) {
        if (this.touching) return;
        this.touchStart = touchEvent.touches[0];
        this.touching = true;
        this.moved = false;
        const touchStartCopy = this.touchStart;
        window.setTimeout(()=>{
            const touchesMatch = this.touchStart === touchStartCopy;
            if (this.touching && touchesMatch && !this.moved) {
                this.moved = true;
                const event = {
                    type: _TouchListener.EVENT_LONG_TAP,
                    touchStart: this.touchStart,
                    touchEvent: touchEvent
                };
                this.eventService.dispatchEvent(event);
            }
        }, 500);
    }
    onTouchMove(touchEvent) {
        if (!this.touching) return;
        const touch = this.getActiveTouch(touchEvent.touches);
        if (!touch) return;
        const eventIsFarAway = !$437b23f6a393c3bf$var$areEventsNear(touch, this.touchStart, 4);
        if (eventIsFarAway) this.moved = true;
    }
    onTouchEnd(touchEvent) {
        if (!this.touching) return;
        if (!this.moved) {
            const event = {
                type: _TouchListener.EVENT_TAP,
                touchStart: this.touchStart
            };
            this.eventService.dispatchEvent(event);
            this.checkForDoubleTap();
        }
        if (this.preventMouseClick && touchEvent.cancelable) touchEvent.preventDefault();
        this.touching = false;
    }
    checkForDoubleTap() {
        const now = /* @__PURE__ */ new Date().getTime();
        if (this.lastTapTime && this.lastTapTime > 0) {
            const interval = now - this.lastTapTime;
            if (interval > _TouchListener.DOUBLE_TAP_MILLIS) {
                const event = {
                    type: _TouchListener.EVENT_DOUBLE_TAP,
                    touchStart: this.touchStart
                };
                this.eventService.dispatchEvent(event);
                this.lastTapTime = null;
            } else this.lastTapTime = now;
        } else this.lastTapTime = now;
    }
    destroy() {
        this.destroyFuncs.forEach((func)=>func());
    }
};
$437b23f6a393c3bf$var$_TouchListener.EVENT_TAP = "tap";
$437b23f6a393c3bf$var$_TouchListener.EVENT_DOUBLE_TAP = "doubleTap";
$437b23f6a393c3bf$var$_TouchListener.EVENT_LONG_TAP = "longTap";
$437b23f6a393c3bf$var$_TouchListener.DOUBLE_TAP_MILLIS = 500;
var $437b23f6a393c3bf$export$7b2e93987414b382 = $437b23f6a393c3bf$var$_TouchListener;
// community-modules/core/src/headerRendering/cells/column/sortIndicatorComp.ts
var $437b23f6a393c3bf$var$_SortIndicatorComp = class _SortIndicatorComp extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(skipTemplate){
        super();
        if (!skipTemplate) this.setTemplate(_SortIndicatorComp.TEMPLATE);
    }
    attachCustomElements(eSortOrder, eSortAsc, eSortDesc, eSortMixed, eSortNone) {
        this.eSortOrder = eSortOrder;
        this.eSortAsc = eSortAsc;
        this.eSortDesc = eSortDesc;
        this.eSortMixed = eSortMixed;
        this.eSortNone = eSortNone;
    }
    setupSort(column, suppressOrder = false) {
        this.column = column;
        this.suppressOrder = suppressOrder;
        this.setupMultiSortIndicator();
        if (!this.column.isSortable() && !this.column.getColDef().showRowGroup) return;
        this.addInIcon("sortAscending", this.eSortAsc, column);
        this.addInIcon("sortDescending", this.eSortDesc, column);
        this.addInIcon("sortUnSort", this.eSortNone, column);
        this.addManagedPropertyListener("unSortIcon", ()=>this.updateIcons());
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_NEW_COLUMNS_LOADED, ()=>this.updateIcons());
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_SORT_CHANGED, ()=>this.onSortChanged());
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_ROW_GROUP_CHANGED, ()=>this.onSortChanged());
        this.onSortChanged();
    }
    addInIcon(iconName, eParent, column) {
        if (eParent == null) return;
        const eIcon = $437b23f6a393c3bf$var$createIconNoSpan(iconName, this.gos, column);
        if (eIcon) eParent.appendChild(eIcon);
    }
    onSortChanged() {
        this.updateIcons();
        if (!this.suppressOrder) this.updateSortOrder();
    }
    updateIcons() {
        const sortDirection = this.sortController.getDisplaySortForColumn(this.column);
        if (this.eSortAsc) {
            const isAscending = sortDirection === "asc";
            $437b23f6a393c3bf$var$setDisplayed(this.eSortAsc, isAscending, {
                skipAriaHidden: true
            });
        }
        if (this.eSortDesc) {
            const isDescending = sortDirection === "desc";
            $437b23f6a393c3bf$var$setDisplayed(this.eSortDesc, isDescending, {
                skipAriaHidden: true
            });
        }
        if (this.eSortNone) {
            const alwaysHideNoSort = !this.column.getColDef().unSortIcon && !this.gos.get("unSortIcon");
            const isNone = sortDirection === null || sortDirection === void 0;
            $437b23f6a393c3bf$var$setDisplayed(this.eSortNone, !alwaysHideNoSort && isNone, {
                skipAriaHidden: true
            });
        }
    }
    setupMultiSortIndicator() {
        this.addInIcon("sortUnSort", this.eSortMixed, this.column);
        const isColumnShowingRowGroup = this.column.getColDef().showRowGroup;
        const areGroupsCoupled = this.gos.isColumnsSortingCoupledToGroup();
        if (areGroupsCoupled && isColumnShowingRowGroup) {
            this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_SORT_CHANGED, ()=>this.updateMultiSortIndicator());
            this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_ROW_GROUP_CHANGED, ()=>this.updateMultiSortIndicator());
            this.updateMultiSortIndicator();
        }
    }
    updateMultiSortIndicator() {
        if (this.eSortMixed) {
            const isMixedSort = this.sortController.getDisplaySortForColumn(this.column) === "mixed";
            $437b23f6a393c3bf$var$setDisplayed(this.eSortMixed, isMixedSort, {
                skipAriaHidden: true
            });
        }
    }
    // we listen here for global sort events, NOT column sort events, as we want to do this
    // when sorting has been set on all column (if we listened just for our col (where we
    // set the asc / desc icons) then it's possible other cols are yet to get their sorting state.
    updateSortOrder() {
        var _a;
        if (!this.eSortOrder) return;
        const allColumnsWithSorting = this.sortController.getColumnsWithSortingOrdered();
        const indexThisCol = (_a = this.sortController.getDisplaySortIndexForColumn(this.column)) != null ? _a : -1;
        const moreThanOneColSorting = allColumnsWithSorting.some((col)=>{
            var _a2;
            return (_a2 = this.sortController.getDisplaySortIndexForColumn(col)) != null ? _a2 : false;
        });
        const showIndex = indexThisCol >= 0 && moreThanOneColSorting;
        $437b23f6a393c3bf$var$setDisplayed(this.eSortOrder, showIndex, {
            skipAriaHidden: true
        });
        if (indexThisCol >= 0) this.eSortOrder.textContent = (indexThisCol + 1).toString();
        else $437b23f6a393c3bf$var$clearElement(this.eSortOrder);
    }
};
$437b23f6a393c3bf$var$_SortIndicatorComp.TEMPLATE = /* html */ `<span class="ag-sort-indicator-container">
            <span ref="eSortOrder" class="ag-sort-indicator-icon ag-sort-order ag-hidden" aria-hidden="true"></span>
            <span ref="eSortAsc" class="ag-sort-indicator-icon ag-sort-ascending-icon ag-hidden" aria-hidden="true"></span>
            <span ref="eSortDesc" class="ag-sort-indicator-icon ag-sort-descending-icon ag-hidden" aria-hidden="true"></span>
            <span ref="eSortMixed" class="ag-sort-indicator-icon ag-sort-mixed-icon ag-hidden" aria-hidden="true"></span>
            <span ref="eSortNone" class="ag-sort-indicator-icon ag-sort-none-icon ag-hidden" aria-hidden="true"></span>
        </span>`;
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eSortOrder")
], $437b23f6a393c3bf$var$_SortIndicatorComp.prototype, "eSortOrder", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eSortAsc")
], $437b23f6a393c3bf$var$_SortIndicatorComp.prototype, "eSortAsc", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eSortDesc")
], $437b23f6a393c3bf$var$_SortIndicatorComp.prototype, "eSortDesc", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eSortMixed")
], $437b23f6a393c3bf$var$_SortIndicatorComp.prototype, "eSortMixed", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eSortNone")
], $437b23f6a393c3bf$var$_SortIndicatorComp.prototype, "eSortNone", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnModel")
], $437b23f6a393c3bf$var$_SortIndicatorComp.prototype, "columnModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("sortController")
], $437b23f6a393c3bf$var$_SortIndicatorComp.prototype, "sortController", 2);
var $437b23f6a393c3bf$export$220e9505c6bd76f6 = $437b23f6a393c3bf$var$_SortIndicatorComp;
// community-modules/core/src/headerRendering/cells/column/headerComp.ts
var $437b23f6a393c3bf$var$_HeaderComp = class _HeaderComp extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super(...arguments);
        this.lastMovingChanged = 0;
    }
    // this is a user component, and IComponent has "public destroy()" as part of the interface.
    // so we need to override destroy() just to make the method public.
    destroy() {
        super.destroy();
    }
    refresh(params) {
        const oldParams = this.params;
        this.params = params;
        if (this.workOutTemplate() != this.currentTemplate || this.workOutShowMenu() != this.currentShowMenu || this.workOutSort() != this.currentSort || this.shouldSuppressMenuHide() != this.currentSuppressMenuHide || oldParams.enableFilterButton != params.enableFilterButton || oldParams.enableFilterIcon != params.enableFilterIcon) return false;
        this.setDisplayName(params);
        return true;
    }
    workOutTemplate() {
        var _a;
        let template = (_a = this.params.template) != null ? _a : _HeaderComp.TEMPLATE;
        template = template && template.trim ? template.trim() : template;
        return template;
    }
    init(params) {
        this.params = params;
        this.currentTemplate = this.workOutTemplate();
        this.setTemplate(this.currentTemplate);
        this.setupTap();
        this.setMenu();
        this.setupSort();
        this.setupFilterIcon();
        this.setupFilterButton();
        this.setDisplayName(params);
    }
    setDisplayName(params) {
        if (this.currentDisplayName != params.displayName) {
            this.currentDisplayName = params.displayName;
            const displayNameSanitised = $437b23f6a393c3bf$var$escapeString(this.currentDisplayName, true);
            if (this.eText) this.eText.textContent = displayNameSanitised;
        }
    }
    addInIcon(iconName, eParent, column) {
        if (eParent == null) return;
        const eIcon = $437b23f6a393c3bf$var$createIconNoSpan(iconName, this.gos, column);
        if (eIcon) eParent.appendChild(eIcon);
    }
    setupTap() {
        const { gos: gos } = this;
        if (gos.get("suppressTouch")) return;
        const touchListener = new $437b23f6a393c3bf$export$7b2e93987414b382(this.getGui(), true);
        const suppressMenuHide = this.shouldSuppressMenuHide();
        const tapMenuButton = suppressMenuHide && $437b23f6a393c3bf$var$exists(this.eMenu);
        const menuTouchListener = tapMenuButton ? new $437b23f6a393c3bf$export$7b2e93987414b382(this.eMenu, true) : touchListener;
        if (this.params.enableMenu) {
            const eventType = tapMenuButton ? "EVENT_TAP" : "EVENT_LONG_TAP";
            const showMenuFn = (event)=>this.params.showColumnMenuAfterMouseClick(event.touchStart);
            this.addManagedListener(menuTouchListener, $437b23f6a393c3bf$export$7b2e93987414b382[eventType], showMenuFn);
        }
        if (this.params.enableSorting) {
            const tapListener = (event)=>{
                var _a, _b;
                const target = event.touchStart.target;
                if (suppressMenuHide && (((_a = this.eMenu) == null ? void 0 : _a.contains(target)) || ((_b = this.eFilterButton) == null ? void 0 : _b.contains(target)))) return;
                this.sortController.progressSort(this.params.column, false, "uiColumnSorted");
            };
            this.addManagedListener(touchListener, $437b23f6a393c3bf$export$7b2e93987414b382.EVENT_TAP, tapListener);
        }
        if (this.params.enableFilterButton) {
            const filterButtonTouchListener = new $437b23f6a393c3bf$export$7b2e93987414b382(this.eFilterButton, true);
            this.addManagedListener(filterButtonTouchListener, "tap", ()=>this.params.showFilter(this.eFilterButton));
            this.addDestroyFunc(()=>filterButtonTouchListener.destroy());
        }
        this.addDestroyFunc(()=>touchListener.destroy());
        if (tapMenuButton) this.addDestroyFunc(()=>menuTouchListener.destroy());
    }
    workOutShowMenu() {
        return this.params.enableMenu && this.menuService.isHeaderMenuButtonEnabled();
    }
    shouldSuppressMenuHide() {
        return this.menuService.isHeaderMenuButtonAlwaysShowEnabled();
    }
    setMenu() {
        if (!this.eMenu) return;
        this.currentShowMenu = this.workOutShowMenu();
        if (!this.currentShowMenu) {
            $437b23f6a393c3bf$var$removeFromParent(this.eMenu);
            this.eMenu = void 0;
            return;
        }
        const isLegacyMenu = this.menuService.isLegacyMenuEnabled();
        this.addInIcon(isLegacyMenu ? "menu" : "menuAlt", this.eMenu, this.params.column);
        this.eMenu.classList.toggle("ag-header-menu-icon", !isLegacyMenu);
        this.currentSuppressMenuHide = this.shouldSuppressMenuHide();
        this.addManagedListener(this.eMenu, "click", ()=>this.params.showColumnMenu(this.eMenu));
        this.eMenu.classList.toggle("ag-header-menu-always-show", this.currentSuppressMenuHide);
    }
    onMenuKeyboardShortcut(isFilterShortcut) {
        var _a, _b, _c, _d;
        const { column: column } = this.params;
        const isLegacyMenuEnabled = this.menuService.isLegacyMenuEnabled();
        if (isFilterShortcut && !isLegacyMenuEnabled) {
            if (this.menuService.isFilterMenuInHeaderEnabled(column)) {
                this.params.showFilter((_b = (_a = this.eFilterButton) != null ? _a : this.eMenu) != null ? _b : this.getGui());
                return true;
            }
        } else if (this.params.enableMenu) {
            this.params.showColumnMenu((_d = (_c = this.eMenu) != null ? _c : this.eFilterButton) != null ? _d : this.getGui());
            return true;
        }
        return false;
    }
    workOutSort() {
        return this.params.enableSorting;
    }
    setupSort() {
        this.currentSort = this.params.enableSorting;
        if (!this.eSortIndicator) {
            this.eSortIndicator = this.context.createBean(new $437b23f6a393c3bf$export$220e9505c6bd76f6(true));
            this.eSortIndicator.attachCustomElements(this.eSortOrder, this.eSortAsc, this.eSortDesc, this.eSortMixed, this.eSortNone);
        }
        this.eSortIndicator.setupSort(this.params.column);
        if (!this.currentSort) return;
        this.addManagedListener(this.params.column, $437b23f6a393c3bf$export$816b5d811295e6bc.EVENT_MOVING_CHANGED, ()=>{
            this.lastMovingChanged = /* @__PURE__ */ new Date().getTime();
        });
        if (this.eLabel) this.addManagedListener(this.eLabel, "click", (event)=>{
            const moving = this.params.column.isMoving();
            const nowTime = /* @__PURE__ */ new Date().getTime();
            const movedRecently = nowTime - this.lastMovingChanged < 50;
            const columnMoving = moving || movedRecently;
            if (!columnMoving) {
                const sortUsingCtrl = this.gos.get("multiSortKey") === "ctrl";
                const multiSort = sortUsingCtrl ? event.ctrlKey || event.metaKey : event.shiftKey;
                this.params.progressSort(multiSort);
            }
        });
        const onSortingChanged = ()=>{
            this.addOrRemoveCssClass("ag-header-cell-sorted-asc", this.params.column.isSortAscending());
            this.addOrRemoveCssClass("ag-header-cell-sorted-desc", this.params.column.isSortDescending());
            this.addOrRemoveCssClass("ag-header-cell-sorted-none", this.params.column.isSortNone());
            if (this.params.column.getColDef().showRowGroup) {
                const sourceColumns = this.columnModel.getSourceColumnsForGroupColumn(this.params.column);
                const sortDirectionsMatch = sourceColumns == null ? void 0 : sourceColumns.every((sourceCol)=>this.params.column.getSort() == sourceCol.getSort());
                const isMultiSorting = !sortDirectionsMatch;
                this.addOrRemoveCssClass("ag-header-cell-sorted-mixed", isMultiSorting);
            }
        };
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_SORT_CHANGED, onSortingChanged);
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_ROW_GROUP_CHANGED, onSortingChanged);
    }
    setupFilterIcon() {
        if (!this.eFilter) return;
        this.configureFilter(this.params.enableFilterIcon, this.eFilter, this.onFilterChangedIcon.bind(this));
    }
    setupFilterButton() {
        if (!this.eFilterButton) return;
        const configured = this.configureFilter(this.params.enableFilterButton, this.eFilterButton, this.onFilterChangedButton.bind(this));
        if (configured) this.addManagedListener(this.eFilterButton, "click", ()=>this.params.showFilter(this.eFilterButton));
        else this.eFilterButton = void 0;
    }
    configureFilter(enabled, element, filterChangedCallback) {
        if (!enabled) {
            $437b23f6a393c3bf$var$removeFromParent(element);
            return false;
        }
        const { column: column } = this.params;
        this.addInIcon("filter", element, column);
        this.addManagedListener(column, $437b23f6a393c3bf$export$816b5d811295e6bc.EVENT_FILTER_CHANGED, filterChangedCallback);
        filterChangedCallback();
        return true;
    }
    onFilterChangedIcon() {
        const filterPresent = this.params.column.isFilterActive();
        $437b23f6a393c3bf$var$setDisplayed(this.eFilter, filterPresent, {
            skipAriaHidden: true
        });
    }
    onFilterChangedButton() {
        const filterPresent = this.params.column.isFilterActive();
        this.eFilterButton.classList.toggle("ag-filter-active", filterPresent);
    }
    getAnchorElementForMenu(isFilter) {
        var _a, _b, _c, _d;
        if (isFilter) return (_b = (_a = this.eFilterButton) != null ? _a : this.eMenu) != null ? _b : this.getGui();
        return (_d = (_c = this.eMenu) != null ? _c : this.eFilterButton) != null ? _d : this.getGui();
    }
};
$437b23f6a393c3bf$var$_HeaderComp.TEMPLATE = /* html */ `<div class="ag-cell-label-container" role="presentation">
            <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button" aria-hidden="true"></span>
            <span ref="eFilterButton" class="ag-header-icon ag-header-cell-filter-button" aria-hidden="true"></span>
            <div ref="eLabel" class="ag-header-cell-label" role="presentation">
                <span ref="eText" class="ag-header-cell-text"></span>
                <span ref="eFilter" class="ag-header-icon ag-header-label-icon ag-filter-icon" aria-hidden="true"></span>
                <ag-sort-indicator ref="eSortIndicator"></ag-sort-indicator>
            </div>
        </div>`;
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("sortController")
], $437b23f6a393c3bf$var$_HeaderComp.prototype, "sortController", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("menuService")
], $437b23f6a393c3bf$var$_HeaderComp.prototype, "menuService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnModel")
], $437b23f6a393c3bf$var$_HeaderComp.prototype, "columnModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eFilter")
], $437b23f6a393c3bf$var$_HeaderComp.prototype, "eFilter", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eFilterButton")
], $437b23f6a393c3bf$var$_HeaderComp.prototype, "eFilterButton", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eSortIndicator")
], $437b23f6a393c3bf$var$_HeaderComp.prototype, "eSortIndicator", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eMenu")
], $437b23f6a393c3bf$var$_HeaderComp.prototype, "eMenu", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eLabel")
], $437b23f6a393c3bf$var$_HeaderComp.prototype, "eLabel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eText")
], $437b23f6a393c3bf$var$_HeaderComp.prototype, "eText", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eSortOrder")
], $437b23f6a393c3bf$var$_HeaderComp.prototype, "eSortOrder", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eSortAsc")
], $437b23f6a393c3bf$var$_HeaderComp.prototype, "eSortAsc", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eSortDesc")
], $437b23f6a393c3bf$var$_HeaderComp.prototype, "eSortDesc", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eSortMixed")
], $437b23f6a393c3bf$var$_HeaderComp.prototype, "eSortMixed", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eSortNone")
], $437b23f6a393c3bf$var$_HeaderComp.prototype, "eSortNone", 2);
var $437b23f6a393c3bf$var$HeaderComp = $437b23f6a393c3bf$var$_HeaderComp;
// community-modules/core/src/headerRendering/cells/columnGroup/headerGroupComp.ts
var $437b23f6a393c3bf$var$_HeaderGroupComp = class _HeaderGroupComp extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super(_HeaderGroupComp.TEMPLATE);
    }
    // this is a user component, and IComponent has "public destroy()" as part of the interface.
    // so we need to override destroy() just to make the method public.
    destroy() {
        super.destroy();
    }
    init(params) {
        this.params = params;
        this.checkWarnings();
        this.setupLabel();
        this.addGroupExpandIcon();
        this.setupExpandIcons();
    }
    checkWarnings() {
        const paramsAny = this.params;
        if (paramsAny.template) $437b23f6a393c3bf$var$warnOnce(`A template was provided for Header Group Comp - templates are only supported for Header Comps (not groups)`);
    }
    setupExpandIcons() {
        this.addInIcon("columnGroupOpened", "agOpened");
        this.addInIcon("columnGroupClosed", "agClosed");
        const expandAction = (event)=>{
            if ($437b23f6a393c3bf$var$isStopPropagationForAgGrid(event)) return;
            const newExpandedValue = !this.params.columnGroup.isExpanded();
            this.columnModel.setColumnGroupOpened(this.params.columnGroup.getProvidedColumnGroup(), newExpandedValue, "uiColumnExpanded");
        };
        this.addTouchAndClickListeners(this.eCloseIcon, expandAction);
        this.addTouchAndClickListeners(this.eOpenIcon, expandAction);
        const stopPropagationAction = (event)=>{
            $437b23f6a393c3bf$var$stopPropagationForAgGrid(event);
        };
        this.addManagedListener(this.eCloseIcon, "dblclick", stopPropagationAction);
        this.addManagedListener(this.eOpenIcon, "dblclick", stopPropagationAction);
        this.addManagedListener(this.getGui(), "dblclick", expandAction);
        this.updateIconVisibility();
        const providedColumnGroup = this.params.columnGroup.getProvidedColumnGroup();
        this.addManagedListener(providedColumnGroup, $437b23f6a393c3bf$export$89dd394cd2c9e921.EVENT_EXPANDED_CHANGED, this.updateIconVisibility.bind(this));
        this.addManagedListener(providedColumnGroup, $437b23f6a393c3bf$export$89dd394cd2c9e921.EVENT_EXPANDABLE_CHANGED, this.updateIconVisibility.bind(this));
    }
    addTouchAndClickListeners(eElement, action) {
        const touchListener = new $437b23f6a393c3bf$export$7b2e93987414b382(eElement, true);
        this.addManagedListener(touchListener, $437b23f6a393c3bf$export$7b2e93987414b382.EVENT_TAP, action);
        this.addDestroyFunc(()=>touchListener.destroy());
        this.addManagedListener(eElement, "click", action);
    }
    updateIconVisibility() {
        const columnGroup = this.params.columnGroup;
        if (columnGroup.isExpandable()) {
            const expanded = this.params.columnGroup.isExpanded();
            $437b23f6a393c3bf$var$setDisplayed(this.eOpenIcon, expanded);
            $437b23f6a393c3bf$var$setDisplayed(this.eCloseIcon, !expanded);
        } else {
            $437b23f6a393c3bf$var$setDisplayed(this.eOpenIcon, false);
            $437b23f6a393c3bf$var$setDisplayed(this.eCloseIcon, false);
        }
    }
    addInIcon(iconName, refName) {
        const eIcon = $437b23f6a393c3bf$var$createIconNoSpan(iconName, this.gos, null);
        if (eIcon) this.getRefElement(refName).appendChild(eIcon);
    }
    addGroupExpandIcon() {
        if (!this.params.columnGroup.isExpandable()) {
            $437b23f6a393c3bf$var$setDisplayed(this.eOpenIcon, false);
            $437b23f6a393c3bf$var$setDisplayed(this.eCloseIcon, false);
            return;
        }
    }
    setupLabel() {
        var _a;
        const { displayName: displayName, columnGroup: columnGroup } = this.params;
        if ($437b23f6a393c3bf$var$exists(displayName)) {
            const displayNameSanitised = $437b23f6a393c3bf$var$escapeString(displayName, true);
            this.getRefElement("agLabel").textContent = displayNameSanitised;
        }
        this.addOrRemoveCssClass("ag-sticky-label", !((_a = columnGroup.getColGroupDef()) == null ? void 0 : _a.suppressStickyLabel));
    }
};
$437b23f6a393c3bf$var$_HeaderGroupComp.TEMPLATE = /* html */ `<div class="ag-header-group-cell-label" ref="agContainer" role="presentation">
            <span ref="agLabel" class="ag-header-group-text" role="presentation"></span>
            <span ref="agOpened" class="ag-header-icon ag-header-expand-icon ag-header-expand-icon-expanded"></span>
            <span ref="agClosed" class="ag-header-icon ag-header-expand-icon ag-header-expand-icon-collapsed"></span>
        </div>`;
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnModel")
], $437b23f6a393c3bf$var$_HeaderGroupComp.prototype, "columnModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("agOpened")
], $437b23f6a393c3bf$var$_HeaderGroupComp.prototype, "eOpenIcon", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("agClosed")
], $437b23f6a393c3bf$var$_HeaderGroupComp.prototype, "eCloseIcon", 2);
var $437b23f6a393c3bf$var$HeaderGroupComp = $437b23f6a393c3bf$var$_HeaderGroupComp;
// community-modules/core/src/widgets/popupComponent.ts
var $437b23f6a393c3bf$export$9fac2d040f3ed438 = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    isPopup() {
        return true;
    }
    setParentComponent(container) {
        container.addCssClass("ag-has-popup");
        super.setParentComponent(container);
    }
    destroy() {
        const parentComp = this.parentComponent;
        const hasParent = parentComp && parentComp.isAlive();
        if (hasParent) parentComp.getGui().classList.remove("ag-has-popup");
        super.destroy();
    }
};
// community-modules/core/src/rendering/cellEditors/largeTextCellEditor.ts
var $437b23f6a393c3bf$var$_LargeTextCellEditor = class _LargeTextCellEditor extends $437b23f6a393c3bf$export$9fac2d040f3ed438 {
    constructor(){
        super(_LargeTextCellEditor.TEMPLATE);
    }
    init(params) {
        this.params = params;
        this.focusAfterAttached = params.cellStartedEdit;
        this.eTextArea.setMaxLength(params.maxLength || 200).setCols(params.cols || 60).setRows(params.rows || 10);
        if ($437b23f6a393c3bf$var$exists(params.value, true)) this.eTextArea.setValue(params.value.toString(), true);
        this.addGuiEventListener("keydown", this.onKeyDown.bind(this));
        this.activateTabIndex();
    }
    onKeyDown(event) {
        const key = event.key;
        if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT || key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP || key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT || key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN || event.shiftKey && key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER) event.stopPropagation();
    }
    afterGuiAttached() {
        const translate = this.localeService.getLocaleTextFunc();
        this.eTextArea.setInputAriaLabel(translate("ariaInputEditor", "Input Editor"));
        if (this.focusAfterAttached) this.eTextArea.getFocusableElement().focus();
    }
    getValue() {
        const value = this.eTextArea.getValue();
        if (!$437b23f6a393c3bf$var$exists(value) && !$437b23f6a393c3bf$var$exists(this.params.value)) return this.params.value;
        return this.params.parseValue(value);
    }
};
$437b23f6a393c3bf$var$_LargeTextCellEditor.TEMPLATE = /* html */ `<div class="ag-large-text">
            <ag-input-text-area ref="eTextArea" class="ag-large-text-input"></ag-input-text-area>
        </div>`;
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eTextArea")
], $437b23f6a393c3bf$var$_LargeTextCellEditor.prototype, "eTextArea", 2);
var $437b23f6a393c3bf$export$98890d6e078b4910 = $437b23f6a393c3bf$var$_LargeTextCellEditor;
// community-modules/core/src/rendering/cellEditors/selectCellEditor.ts
var $437b23f6a393c3bf$export$638f87cb94a2e5dc = class extends $437b23f6a393c3bf$export$9fac2d040f3ed438 {
    constructor(){
        super(/* html */ `<div class="ag-cell-edit-wrapper">
                <ag-select class="ag-cell-editor" ref="eSelect"></ag-select>
            </div>`);
        this.startedByEnter = false;
    }
    init(params) {
        this.focusAfterAttached = params.cellStartedEdit;
        const { eSelect: eSelect, valueService: valueService, gos: gos } = this;
        const { values: values2, value: value, eventKey: eventKey } = params;
        if ($437b23f6a393c3bf$var$missing(values2)) {
            console.warn("AG Grid: no values found for select cellEditor");
            return;
        }
        this.startedByEnter = eventKey != null ? eventKey === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER : false;
        let hasValue = false;
        values2.forEach((currentValue)=>{
            const option = {
                value: currentValue
            };
            const valueFormatted = valueService.formatValue(params.column, null, currentValue);
            const valueFormattedExits = valueFormatted !== null && valueFormatted !== void 0;
            option.text = valueFormattedExits ? valueFormatted : currentValue;
            eSelect.addOption(option);
            hasValue = hasValue || value === currentValue;
        });
        if (hasValue) eSelect.setValue(params.value, true);
        else if (params.values.length) eSelect.setValue(params.values[0], true);
        const { valueListGap: valueListGap, valueListMaxWidth: valueListMaxWidth, valueListMaxHeight: valueListMaxHeight } = params;
        if (valueListGap != null) eSelect.setPickerGap(valueListGap);
        if (valueListMaxHeight != null) eSelect.setPickerMaxHeight(valueListMaxHeight);
        if (valueListMaxWidth != null) eSelect.setPickerMaxWidth(valueListMaxWidth);
        if (gos.get("editType") !== "fullRow") this.addManagedListener(this.eSelect, $437b23f6a393c3bf$export$6f9c460854d56032.EVENT_ITEM_SELECTED, ()=>params.stopEditing());
    }
    afterGuiAttached() {
        if (this.focusAfterAttached) this.eSelect.getFocusableElement().focus();
        if (this.startedByEnter) setTimeout(()=>{
            if (this.isAlive()) this.eSelect.showPicker();
        });
    }
    focusIn() {
        this.eSelect.getFocusableElement().focus();
    }
    getValue() {
        return this.eSelect.getValue();
    }
    isPopup() {
        return false;
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("valueService")
], $437b23f6a393c3bf$export$638f87cb94a2e5dc.prototype, "valueService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eSelect")
], $437b23f6a393c3bf$export$638f87cb94a2e5dc.prototype, "eSelect", 2);
// community-modules/core/src/rendering/cellEditors/simpleCellEditor.ts
var $437b23f6a393c3bf$var$SimpleCellEditor = class extends $437b23f6a393c3bf$export$9fac2d040f3ed438 {
    constructor(cellEditorInput){
        super(/* html */ `
            <div class="ag-cell-edit-wrapper">
                ${cellEditorInput.getTemplate()}
            </div>`);
        this.cellEditorInput = cellEditorInput;
    }
    init(params) {
        this.params = params;
        const eInput = this.eInput;
        this.cellEditorInput.init(eInput, params);
        let startValue;
        if (params.cellStartedEdit) {
            this.focusAfterAttached = true;
            const eventKey = params.eventKey;
            if (eventKey === $437b23f6a393c3bf$export$e9e0d96f49f57c33.BACKSPACE || params.eventKey === $437b23f6a393c3bf$export$e9e0d96f49f57c33.DELETE) startValue = "";
            else if (eventKey && eventKey.length === 1) startValue = eventKey;
            else {
                startValue = this.cellEditorInput.getStartValue();
                if (eventKey !== $437b23f6a393c3bf$export$e9e0d96f49f57c33.F2) this.highlightAllOnFocus = true;
            }
        } else {
            this.focusAfterAttached = false;
            startValue = this.cellEditorInput.getStartValue();
        }
        if (startValue != null) eInput.setStartValue(startValue);
        this.addManagedListener(eInput.getGui(), "keydown", (event)=>{
            const { key: key } = event;
            if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_UP || key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_DOWN) event.preventDefault();
        });
    }
    afterGuiAttached() {
        var _a, _b;
        const translate = this.localeService.getLocaleTextFunc();
        const eInput = this.eInput;
        eInput.setInputAriaLabel(translate("ariaInputEditor", "Input Editor"));
        if (!this.focusAfterAttached) return;
        if (!$437b23f6a393c3bf$var$isBrowserSafari()) eInput.getFocusableElement().focus();
        const inputEl = eInput.getInputElement();
        if (this.highlightAllOnFocus) inputEl.select();
        else (_b = (_a = this.cellEditorInput).setCaret) == null || _b.call(_a);
    }
    // gets called when tabbing through cells and in full row edit mode
    focusIn() {
        const eInput = this.eInput;
        const focusEl = eInput.getFocusableElement();
        const inputEl = eInput.getInputElement();
        focusEl.focus();
        inputEl.select();
    }
    getValue() {
        return this.cellEditorInput.getValue();
    }
    isPopup() {
        return false;
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eInput")
], $437b23f6a393c3bf$var$SimpleCellEditor.prototype, "eInput", 2);
// community-modules/core/src/rendering/cellEditors/textCellEditor.ts
var $437b23f6a393c3bf$var$TextCellEditorInput = class {
    getTemplate() {
        return /* html */ `<ag-input-text-field class="ag-cell-editor" ref="eInput"></ag-input-text-field>`;
    }
    init(eInput, params) {
        this.eInput = eInput;
        this.params = params;
        if (params.maxLength != null) eInput.setMaxLength(params.maxLength);
    }
    getValue() {
        const value = this.eInput.getValue();
        if (!$437b23f6a393c3bf$var$exists(value) && !$437b23f6a393c3bf$var$exists(this.params.value)) return this.params.value;
        return this.params.parseValue(value);
    }
    getStartValue() {
        const formatValue = this.params.useFormatter || this.params.column.getColDef().refData;
        return formatValue ? this.params.formatValue(this.params.value) : this.params.value;
    }
    setCaret() {
        const value = this.eInput.getValue();
        const len = $437b23f6a393c3bf$var$exists(value) && value.length || 0;
        if (len) this.eInput.getInputElement().setSelectionRange(len, len);
    }
};
var $437b23f6a393c3bf$export$6e94bf0a822a6a81 = class extends $437b23f6a393c3bf$var$SimpleCellEditor {
    constructor(){
        super(new $437b23f6a393c3bf$var$TextCellEditorInput());
    }
};
// community-modules/core/src/rendering/cellRenderers/animateShowChangeCellRenderer.ts
var $437b23f6a393c3bf$var$ARROW_UP = "\u2191";
var $437b23f6a393c3bf$var$ARROW_DOWN = "\u2193";
var $437b23f6a393c3bf$export$6f4a45bae925df69 = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super();
        this.refreshCount = 0;
        const template = document.createElement("span");
        const delta = document.createElement("span");
        delta.setAttribute("class", "ag-value-change-delta");
        const value = document.createElement("span");
        value.setAttribute("class", "ag-value-change-value");
        template.appendChild(delta);
        template.appendChild(value);
        this.setTemplateFromElement(template);
    }
    init(params) {
        this.eValue = this.queryForHtmlElement(".ag-value-change-value");
        this.eDelta = this.queryForHtmlElement(".ag-value-change-delta");
        this.refresh(params, true);
    }
    showDelta(params, delta) {
        const absDelta = Math.abs(delta);
        const valueFormatted = params.formatValue(absDelta);
        const valueToUse = $437b23f6a393c3bf$var$exists(valueFormatted) ? valueFormatted : absDelta;
        const deltaUp = delta >= 0;
        if (deltaUp) this.eDelta.textContent = $437b23f6a393c3bf$var$ARROW_UP + valueToUse;
        else this.eDelta.textContent = $437b23f6a393c3bf$var$ARROW_DOWN + valueToUse;
        this.eDelta.classList.toggle("ag-value-change-delta-up", deltaUp);
        this.eDelta.classList.toggle("ag-value-change-delta-down", !deltaUp);
    }
    setTimerToRemoveDelta() {
        this.refreshCount++;
        const refreshCountCopy = this.refreshCount;
        this.getFrameworkOverrides().wrapIncoming(()=>{
            window.setTimeout(()=>{
                if (refreshCountCopy === this.refreshCount) this.hideDeltaValue();
            }, 2e3);
        });
    }
    hideDeltaValue() {
        this.eValue.classList.remove("ag-value-change-value-highlight");
        $437b23f6a393c3bf$var$clearElement(this.eDelta);
    }
    refresh(params, isInitialRender = false) {
        const value = params.value;
        if (value === this.lastValue) return false;
        if ($437b23f6a393c3bf$var$exists(params.valueFormatted)) this.eValue.textContent = params.valueFormatted;
        else if ($437b23f6a393c3bf$var$exists(params.value)) this.eValue.textContent = value;
        else $437b23f6a393c3bf$var$clearElement(this.eValue);
        if (this.filterManager.isSuppressFlashingCellsBecauseFiltering()) return false;
        if (typeof value === "number" && typeof this.lastValue === "number") {
            const delta = value - this.lastValue;
            this.showDelta(params, delta);
        }
        if (this.lastValue) this.eValue.classList.add("ag-value-change-value-highlight");
        if (!isInitialRender) this.setTimerToRemoveDelta();
        this.lastValue = value;
        return true;
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("filterManager")
], $437b23f6a393c3bf$export$6f4a45bae925df69.prototype, "filterManager", 2);
// community-modules/core/src/rendering/cellRenderers/animateSlideCellRenderer.ts
var $437b23f6a393c3bf$export$3915b8b8c907c2a = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super();
        this.refreshCount = 0;
        const template = document.createElement("span");
        const slide = document.createElement("span");
        slide.setAttribute("class", "ag-value-slide-current");
        template.appendChild(slide);
        this.setTemplateFromElement(template);
        this.eCurrent = this.queryForHtmlElement(".ag-value-slide-current");
    }
    init(params) {
        this.refresh(params, true);
    }
    addSlideAnimation() {
        this.refreshCount++;
        const refreshCountCopy = this.refreshCount;
        if (this.ePrevious) this.getGui().removeChild(this.ePrevious);
        const prevElement = document.createElement("span");
        prevElement.setAttribute("class", "ag-value-slide-previous ag-value-slide-out");
        this.ePrevious = prevElement;
        this.ePrevious.textContent = this.eCurrent.textContent;
        this.getGui().insertBefore(this.ePrevious, this.eCurrent);
        this.getFrameworkOverrides().wrapIncoming(()=>{
            window.setTimeout(()=>{
                if (refreshCountCopy !== this.refreshCount) return;
                this.ePrevious.classList.add("ag-value-slide-out-end");
            }, 50);
            window.setTimeout(()=>{
                if (refreshCountCopy !== this.refreshCount) return;
                this.getGui().removeChild(this.ePrevious);
                this.ePrevious = null;
            }, 3e3);
        });
    }
    refresh(params, isInitialRender = false) {
        let value = params.value;
        if ($437b23f6a393c3bf$var$missing(value)) value = "";
        if (value === this.lastValue) return false;
        if (this.filterManager.isSuppressFlashingCellsBecauseFiltering()) return false;
        if (!isInitialRender) this.addSlideAnimation();
        this.lastValue = value;
        if ($437b23f6a393c3bf$var$exists(params.valueFormatted)) this.eCurrent.textContent = params.valueFormatted;
        else if ($437b23f6a393c3bf$var$exists(params.value)) this.eCurrent.textContent = value;
        else $437b23f6a393c3bf$var$clearElement(this.eCurrent);
        return true;
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("filterManager")
], $437b23f6a393c3bf$export$3915b8b8c907c2a.prototype, "filterManager", 2);
// community-modules/core/src/entities/rowNode.ts
var $437b23f6a393c3bf$var$_RowNode = class _RowNode {
    constructor(beans){
        /** The current row index. If the row is filtered out or in a collapsed group, this value will be `null`. */ this.rowIndex = null;
        /** The key for the group eg Ireland, UK, USA */ this.key = null;
        /** Children mapped by the pivot columns. */ this.childrenMapped = {};
        /**
     * This will be `true` if it has a rowIndex assigned, otherwise `false`.
     */ this.displayed = false;
        /** The row top position in pixels. */ this.rowTop = null;
        /** The top pixel for this row last time, makes sense if data set was ordered or filtered,
     * it is used so new rows can animate in from their old position. */ this.oldRowTop = null;
        /** `true` by default - can be overridden via gridOptions.isRowSelectable(rowNode) */ this.selectable = true;
        /** Used by sorting service - to give deterministic sort to groups. Previously we
     * just id for this, however id is a string and had slower sorting compared to numbers. */ this.__objectId = _RowNode.OBJECT_ID_SEQUENCE++;
        /** When one or more Columns are using autoHeight, this keeps track of height of each autoHeight Cell,
     * indexed by the Column ID. */ this.__autoHeights = {};
        /** `true` when nodes with the same id are being removed and added as part of the same batch transaction */ this.alreadyRendered = false;
        this.highlighted = null;
        this.hovered = false;
        this.selected = false;
        this.beans = beans;
    }
    /**
   * Replaces the data on the `rowNode`. When this method is called, the grid will refresh the entire rendered row if it is displayed.
   */ setData(data) {
        this.setDataCommon(data, false);
    }
    // similar to setRowData, however it is expected that the data is the same data item. this
    // is intended to be used with Redux type stores, where the whole data can be changed. we are
    // guaranteed that the data is the same entity (so grid doesn't need to worry about the id of the
    // underlying data changing, hence doesn't need to worry about selection). the grid, upon receiving
    // dataChanged event, will refresh the cells rather than rip them all out (so user can show transitions).
    /**
   * Updates the data on the `rowNode`. When this method is called, the grid will refresh the entire rendered row if it is displayed.
   */ updateData(data) {
        this.setDataCommon(data, true);
    }
    setDataCommon(data, update) {
        const oldData = this.data;
        this.data = data;
        this.beans.valueCache.onDataChanged();
        this.updateDataOnDetailNode();
        this.checkRowSelectable();
        this.resetQuickFilterAggregateText();
        const event = this.createDataChangedEvent(data, oldData, update);
        this.dispatchLocalEvent(event);
    }
    // when we are doing master / detail, the detail node is lazy created, but then kept around.
    // so if we show / hide the detail, the same detail rowNode is used. so we need to keep the data
    // in sync, otherwise expand/collapse of the detail would still show the old values.
    updateDataOnDetailNode() {
        if (this.detailNode) this.detailNode.data = this.data;
    }
    createDataChangedEvent(newData, oldData, update) {
        return {
            type: _RowNode.EVENT_DATA_CHANGED,
            node: this,
            oldData: oldData,
            newData: newData,
            update: update
        };
    }
    createLocalRowEvent(type) {
        return {
            type: type,
            node: this
        };
    }
    getRowIndexString() {
        if (this.rowPinned === "top") return "t-" + this.rowIndex;
        if (this.rowPinned === "bottom") return "b-" + this.rowIndex;
        return this.rowIndex.toString();
    }
    createDaemonNode() {
        const oldNode = new _RowNode(this.beans);
        oldNode.id = this.id;
        oldNode.data = this.data;
        oldNode.__daemon = true;
        oldNode.selected = this.selected;
        oldNode.level = this.level;
        return oldNode;
    }
    setDataAndId(data, id) {
        const oldNode = $437b23f6a393c3bf$var$exists(this.id) ? this.createDaemonNode() : null;
        const oldData = this.data;
        this.data = data;
        this.updateDataOnDetailNode();
        this.setId(id);
        this.checkRowSelectable();
        this.beans.selectionService.syncInRowNode(this, oldNode);
        const event = this.createDataChangedEvent(data, oldData, false);
        this.dispatchLocalEvent(event);
    }
    checkRowSelectable() {
        const isRowSelectableFunc = this.beans.gos.get("isRowSelectable");
        this.setRowSelectable(isRowSelectableFunc ? isRowSelectableFunc(this) : true);
    }
    setRowSelectable(newVal, suppressSelectionUpdate) {
        if (this.selectable !== newVal) {
            this.selectable = newVal;
            if (this.eventService) this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_SELECTABLE_CHANGED));
            if (suppressSelectionUpdate) return;
            const isGroupSelectsChildren = this.beans.gos.get("groupSelectsChildren");
            if (isGroupSelectsChildren) {
                const selected = this.calculateSelectedFromChildren();
                this.setSelectedParams({
                    newValue: selected != null ? selected : false,
                    source: "selectableChanged"
                });
                return;
            }
            if (this.isSelected() && !this.selectable) this.setSelectedParams({
                newValue: false,
                source: "selectableChanged"
            });
        }
    }
    setId(id) {
        const getRowIdFunc = this.beans.gos.getCallback("getRowId");
        if (getRowIdFunc) {
            if (this.data) {
                const parentKeys = this.getGroupKeys(true);
                this.id = getRowIdFunc({
                    data: this.data,
                    parentKeys: parentKeys.length > 0 ? parentKeys : void 0,
                    level: this.level
                });
                if (this.id !== null && typeof this.id === "string" && this.id.startsWith(_RowNode.ID_PREFIX_ROW_GROUP)) console.error(`AG Grid: Row IDs cannot start with ${_RowNode.ID_PREFIX_ROW_GROUP}, this is a reserved prefix for AG Grid's row grouping feature.`);
                if (this.id !== null && typeof this.id !== "string") this.id = "" + this.id;
            } else this.id = void 0;
        } else this.id = id;
    }
    getGroupKeys(excludeSelf = false) {
        const keys2 = [];
        let pointer = this;
        if (excludeSelf) pointer = pointer.parent;
        while(pointer && pointer.level >= 0){
            keys2.push(pointer.key);
            pointer = pointer.parent;
        }
        keys2.reverse();
        return keys2;
    }
    isPixelInRange(pixel) {
        if (!$437b23f6a393c3bf$var$exists(this.rowTop) || !$437b23f6a393c3bf$var$exists(this.rowHeight)) return false;
        return pixel >= this.rowTop && pixel < this.rowTop + this.rowHeight;
    }
    setFirstChild(firstChild) {
        if (this.firstChild === firstChild) return;
        this.firstChild = firstChild;
        if (this.eventService) this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_FIRST_CHILD_CHANGED));
    }
    setLastChild(lastChild) {
        if (this.lastChild === lastChild) return;
        this.lastChild = lastChild;
        if (this.eventService) this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_LAST_CHILD_CHANGED));
    }
    setChildIndex(childIndex) {
        if (this.childIndex === childIndex) return;
        this.childIndex = childIndex;
        if (this.eventService) this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_CHILD_INDEX_CHANGED));
    }
    setRowTop(rowTop) {
        this.oldRowTop = this.rowTop;
        if (this.rowTop === rowTop) return;
        this.rowTop = rowTop;
        if (this.eventService) this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_TOP_CHANGED));
        this.setDisplayed(rowTop !== null);
    }
    clearRowTopAndRowIndex() {
        this.oldRowTop = null;
        this.setRowTop(null);
        this.setRowIndex(null);
    }
    setDisplayed(displayed) {
        if (this.displayed === displayed) return;
        this.displayed = displayed;
        if (this.eventService) this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_DISPLAYED_CHANGED));
    }
    setDragging(dragging) {
        if (this.dragging === dragging) return;
        this.dragging = dragging;
        if (this.eventService) this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_DRAGGING_CHANGED));
    }
    setHighlighted(highlighted) {
        if (highlighted === this.highlighted) return;
        this.highlighted = highlighted;
        if (this.eventService) this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_HIGHLIGHT_CHANGED));
    }
    setHovered(hovered) {
        if (this.hovered === hovered) return;
        this.hovered = hovered;
    }
    isHovered() {
        return this.hovered;
    }
    setAllChildrenCount(allChildrenCount) {
        if (this.allChildrenCount === allChildrenCount) return;
        this.allChildrenCount = allChildrenCount;
        if (this.eventService) this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_ALL_CHILDREN_COUNT_CHANGED));
    }
    setMaster(master) {
        if (this.master === master) return;
        if (this.master && !master) this.expanded = false;
        this.master = master;
        if (this.eventService) this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_MASTER_CHANGED));
    }
    setGroup(group) {
        if (this.group === group) return;
        if (this.group && !group) this.expanded = false;
        this.group = group;
        this.updateHasChildren();
        if (this.eventService) this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_GROUP_CHANGED));
    }
    /**
   * Sets the row height.
   * Call if you want to change the height initially assigned to the row.
   * After calling, you must call `api.onRowHeightChanged()` so the grid knows it needs to work out the placement of the rows. */ setRowHeight(rowHeight, estimated = false) {
        this.rowHeight = rowHeight;
        this.rowHeightEstimated = estimated;
        if (this.eventService) this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_HEIGHT_CHANGED));
    }
    setRowAutoHeight(cellHeight, column) {
        if (!this.__autoHeights) this.__autoHeights = {};
        this.__autoHeights[column.getId()] = cellHeight;
        if (cellHeight != null) {
            if (this.checkAutoHeightsDebounced == null) this.checkAutoHeightsDebounced = $437b23f6a393c3bf$var$debounce(this.checkAutoHeights.bind(this), 1);
            this.checkAutoHeightsDebounced();
        }
    }
    checkAutoHeights() {
        let notAllPresent = false;
        let nonePresent = true;
        let newRowHeight = 0;
        const autoHeights = this.__autoHeights;
        if (autoHeights == null) return;
        const displayedAutoHeightCols = this.beans.columnModel.getAllDisplayedAutoHeightCols();
        displayedAutoHeightCols.forEach((col)=>{
            let cellHeight = autoHeights[col.getId()];
            if (cellHeight == null) {
                if (this.beans.columnModel.isColSpanActive()) {
                    let activeColsForRow = [];
                    switch(col.getPinned()){
                        case "left":
                            activeColsForRow = this.beans.columnModel.getDisplayedLeftColumnsForRow(this);
                            break;
                        case "right":
                            activeColsForRow = this.beans.columnModel.getDisplayedRightColumnsForRow(this);
                            break;
                        case null:
                            activeColsForRow = this.beans.columnModel.getViewportCenterColumnsForRow(this);
                            break;
                    }
                    if (activeColsForRow.includes(col)) {
                        notAllPresent = true;
                        return;
                    }
                    cellHeight = -1;
                } else {
                    notAllPresent = true;
                    return;
                }
            } else nonePresent = false;
            if (cellHeight > newRowHeight) newRowHeight = cellHeight;
        });
        if (notAllPresent) return;
        if (nonePresent || newRowHeight < 10) newRowHeight = this.beans.gos.getRowHeightForNode(this).height;
        if (newRowHeight == this.rowHeight) return;
        this.setRowHeight(newRowHeight);
        const rowModel = this.beans.rowModel;
        if (rowModel.onRowHeightChangedDebounced) rowModel.onRowHeightChangedDebounced();
    }
    setRowIndex(rowIndex) {
        if (this.rowIndex === rowIndex) return;
        this.rowIndex = rowIndex;
        if (this.eventService) this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_ROW_INDEX_CHANGED));
    }
    setUiLevel(uiLevel) {
        if (this.uiLevel === uiLevel) return;
        this.uiLevel = uiLevel;
        if (this.eventService) this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_UI_LEVEL_CHANGED));
    }
    /**
   * Set the expanded state of this rowNode. Pass `true` to expand and `false` to collapse.
   */ setExpanded(expanded, e, forceSync) {
        if (this.expanded === expanded) return;
        this.expanded = expanded;
        if (this.eventService) this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_EXPANDED_CHANGED));
        const event = Object.assign({}, this.createGlobalRowEvent($437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_GROUP_OPENED), {
            expanded: expanded,
            event: e || null
        });
        this.beans.rowNodeEventThrottle.dispatchExpanded(event, forceSync);
        this.beans.rowRenderer.refreshCells({
            rowNodes: [
                this
            ]
        });
    }
    createGlobalRowEvent(type) {
        return this.beans.gos.addGridCommonParams({
            type: type,
            node: this,
            data: this.data,
            rowIndex: this.rowIndex,
            rowPinned: this.rowPinned
        });
    }
    dispatchLocalEvent(event) {
        if (this.eventService) this.eventService.dispatchEvent(event);
    }
    /**
   * Replaces the value on the `rowNode` for the specified column. When complete,
   * the grid will refresh the rendered cell on the required row only.
   * **Note**: This method only fires `onCellEditRequest` when the Grid is in **Read Only** mode.
   *
   * @param colKey The column where the value should be updated
   * @param newValue The new value
   * @param eventSource The source of the event
   * @returns `true` if the value was changed, otherwise `false`.
   */ setDataValue(colKey, newValue, eventSource) {
        const getColumnFromKey = ()=>{
            var _a;
            if (typeof colKey !== "string") return colKey;
            return (_a = this.beans.columnModel.getGridColumn(colKey)) != null ? _a : this.beans.columnModel.getPrimaryColumn(colKey);
        };
        const column = getColumnFromKey();
        const oldValue = this.getValueFromValueService(column);
        if (this.beans.gos.get("readOnlyEdit")) {
            this.dispatchEventForSaveValueReadOnly(column, oldValue, newValue, eventSource);
            return false;
        }
        const valueChanged = this.beans.valueService.setValue(this, column, newValue, eventSource);
        this.dispatchCellChangedEvent(column, newValue, oldValue);
        this.checkRowSelectable();
        return valueChanged;
    }
    getValueFromValueService(column) {
        var _a, _b;
        const lockedClosedGroup = this.leafGroup && this.beans.columnModel.isPivotMode();
        const isOpenGroup = this.group && this.expanded && !this.footer && !lockedClosedGroup;
        let includeFooter = false;
        const groupIncludeFooterOpt = (_a = this.beans.gos.get("groupTotalRow")) != null ? _a : this.beans.gos.get("groupIncludeFooter");
        if (typeof groupIncludeFooterOpt !== "function") includeFooter = !!groupIncludeFooterOpt;
        else {
            const groupIncludeFooterCb = (_b = this.beans.gos.getCallback("groupTotalRow")) != null ? _b : this.beans.gos.getCallback("groupIncludeFooter");
            includeFooter = !!groupIncludeFooterCb({
                node: this
            });
        }
        const groupAlwaysShowAggData = this.beans.gos.get("groupSuppressBlankHeader");
        const ignoreAggData = isOpenGroup && includeFooter && !groupAlwaysShowAggData;
        const value = this.beans.valueService.getValue(column, this, false, ignoreAggData);
        return value;
    }
    dispatchEventForSaveValueReadOnly(column, oldValue, newValue, eventSource) {
        const event = this.beans.gos.addGridCommonParams({
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_CELL_EDIT_REQUEST,
            event: null,
            rowIndex: this.rowIndex,
            rowPinned: this.rowPinned,
            column: column,
            colDef: column.getColDef(),
            data: this.data,
            node: this,
            oldValue: oldValue,
            newValue: newValue,
            value: newValue,
            source: eventSource
        });
        this.beans.eventService.dispatchEvent(event);
    }
    setGroupValue(colKey, newValue) {
        const column = this.beans.columnModel.getGridColumn(colKey);
        if ($437b23f6a393c3bf$var$missing(this.groupData)) this.groupData = {};
        const columnId = column.getColId();
        const oldValue = this.groupData[columnId];
        if (oldValue === newValue) return;
        this.groupData[columnId] = newValue;
        this.dispatchCellChangedEvent(column, newValue, oldValue);
    }
    // sets the data for an aggregation
    setAggData(newAggData) {
        const oldAggData = this.aggData;
        this.aggData = newAggData;
        if (this.eventService) {
            const eventFunc = (colId)=>{
                const value = this.aggData ? this.aggData[colId] : void 0;
                const oldValue = oldAggData ? oldAggData[colId] : void 0;
                if (value === oldValue) return;
                const column = this.beans.columnModel.lookupGridColumn(colId);
                if (!column) return;
                this.dispatchCellChangedEvent(column, value, oldValue);
            };
            for(const key in this.aggData)eventFunc(key);
            for(const key in newAggData){
                if (key in this.aggData) continue;
                eventFunc(key);
            }
        }
    }
    updateHasChildren() {
        let newValue = this.group && !this.footer || this.childrenAfterGroup && this.childrenAfterGroup.length > 0;
        const isSsrm = this.beans.gos.isRowModelType("serverSide");
        if (isSsrm) {
            const isTreeData = this.beans.gos.get("treeData");
            const isGroupFunc = this.beans.gos.get("isServerSideGroup");
            newValue = !this.stub && !this.footer && (isTreeData ? !!isGroupFunc && isGroupFunc(this.data) : !!this.group);
        }
        if (newValue !== this.__hasChildren) {
            this.__hasChildren = !!newValue;
            if (this.eventService) this.eventService.dispatchEvent(this.createLocalRowEvent(_RowNode.EVENT_HAS_CHILDREN_CHANGED));
        }
    }
    hasChildren() {
        if (this.__hasChildren == null) this.updateHasChildren();
        return this.__hasChildren;
    }
    isEmptyRowGroupNode() {
        return this.group && $437b23f6a393c3bf$var$missingOrEmpty(this.childrenAfterGroup);
    }
    dispatchCellChangedEvent(column, newValue, oldValue) {
        const cellChangedEvent = {
            type: _RowNode.EVENT_CELL_CHANGED,
            node: this,
            column: column,
            newValue: newValue,
            oldValue: oldValue
        };
        this.dispatchLocalEvent(cellChangedEvent);
    }
    /**
   * The first time `quickFilter` runs, the grid creates a one-off string representation of the row.
   * This string is then used for the quick filter instead of hitting each column separately.
   * When you edit, using grid editing, this string gets cleared down.
   * However if you edit without using grid editing, you will need to clear this string down for the row to be updated with the new values.
   * Otherwise new values will not work with the `quickFilter`. */ resetQuickFilterAggregateText() {
        this.quickFilterAggregateText = null;
    }
    /** Returns:
  * - `true` if the node can be expanded, i.e it is a group or master row.
  * - `false` if the node cannot be expanded
  */ isExpandable() {
        if (this.footer) return false;
        if (this.beans.columnModel.isPivotMode()) return this.hasChildren() && !this.leafGroup;
        return this.hasChildren() || !!this.master;
    }
    /** Returns:
   * - `true` if node is selected,
   * - `false` if the node isn't selected
   * - `undefined` if it's partially selected (group where not all children are selected). */ isSelected() {
        if (this.footer) return this.sibling.isSelected();
        return this.selected;
    }
    /** Perform a depth-first search of this node and its children. */ depthFirstSearch(callback) {
        if (this.childrenAfterGroup) this.childrenAfterGroup.forEach((child)=>child.depthFirstSearch(callback));
        callback(this);
    }
    // + selectionController.calculatedSelectedForAllGroupNodes()
    calculateSelectedFromChildren() {
        var _a;
        let atLeastOneSelected = false;
        let atLeastOneDeSelected = false;
        let atLeastOneMixed = false;
        if (!((_a = this.childrenAfterGroup) == null ? void 0 : _a.length)) return this.selectable ? this.selected : null;
        for(let i = 0; i < this.childrenAfterGroup.length; i++){
            const child = this.childrenAfterGroup[i];
            let childState = child.isSelected();
            if (!child.selectable) {
                const selectable = child.calculateSelectedFromChildren();
                if (selectable === null) continue;
                childState = selectable;
            }
            switch(childState){
                case true:
                    atLeastOneSelected = true;
                    break;
                case false:
                    atLeastOneDeSelected = true;
                    break;
                default:
                    atLeastOneMixed = true;
                    break;
            }
        }
        if (atLeastOneMixed || atLeastOneSelected && atLeastOneDeSelected) return void 0;
        if (atLeastOneSelected) return true;
        if (atLeastOneDeSelected) return false;
        if (!this.selectable) return null;
        return this.selected;
    }
    setSelectedInitialValue(selected) {
        this.selected = selected;
    }
    selectThisNode(newValue, e, source = "api") {
        const selectionNotAllowed = !this.selectable && newValue;
        const selectionNotChanged = this.selected === newValue;
        if (selectionNotAllowed || selectionNotChanged) return false;
        this.selected = newValue;
        if (this.eventService) this.dispatchLocalEvent(this.createLocalRowEvent(_RowNode.EVENT_ROW_SELECTED));
        const sibling = this.sibling;
        if (sibling && sibling.footer && sibling.eventService) sibling.dispatchLocalEvent(sibling.createLocalRowEvent(_RowNode.EVENT_ROW_SELECTED));
        const event = $437b23f6a393c3bf$var$__spreadProps($437b23f6a393c3bf$var$__spreadValues({}, this.createGlobalRowEvent($437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_SELECTED)), {
            event: e || null,
            source: source
        });
        this.beans.eventService.dispatchEvent(event);
        return true;
    }
    /**
   * Select (or deselect) the node.
   * @param newValue -`true` for selection, `false` for deselection.
   * @param clearSelection - If selecting, then passing `true` will select the node exclusively (i.e. NOT do multi select). If doing deselection, `clearSelection` has no impact.
   * @param source - Source property that will appear in the `selectionChanged` event.
   */ setSelected(newValue, clearSelection = false, source = "api") {
        if (typeof source === "boolean") {
            console.warn("AG Grid: since version v30, rowNode.setSelected() property `suppressFinishActions` has been removed, please use `gridApi.setNodesSelected()` for bulk actions, and the event `source` property for ignoring events instead.");
            return;
        }
        this.setSelectedParams({
            newValue: newValue,
            clearSelection: clearSelection,
            rangeSelect: false,
            source: source
        });
    }
    // this is for internal use only. To make calling code more readable, this is the same method as setSelected except it takes names parameters
    setSelectedParams(params) {
        if (this.rowPinned) {
            console.warn("AG Grid: cannot select pinned rows");
            return 0;
        }
        if (this.id === void 0) {
            console.warn("AG Grid: cannot select node until id for node is known");
            return 0;
        }
        return this.beans.selectionService.setNodesSelected($437b23f6a393c3bf$var$__spreadProps($437b23f6a393c3bf$var$__spreadValues({}, params), {
            nodes: [
                this.footer ? this.sibling : this
            ]
        }));
    }
    /**
   * Returns:
   * - `true` if node is either pinned to the `top` or `bottom`
   * - `false` if the node isn't pinned
   */ isRowPinned() {
        return this.rowPinned === "top" || this.rowPinned === "bottom";
    }
    isParentOfNode(potentialParent) {
        let parentNode = this.parent;
        while(parentNode){
            if (parentNode === potentialParent) return true;
            parentNode = parentNode.parent;
        }
        return false;
    }
    /** Add an event listener. */ addEventListener(eventType, userListener) {
        var _a, _b;
        if (!this.eventService) this.eventService = new $437b23f6a393c3bf$export$895d7dc49f082ca1();
        if (this.beans.frameworkOverrides.shouldWrapOutgoing && !this.frameworkEventListenerService) {
            this.eventService.setFrameworkOverrides(this.beans.frameworkOverrides);
            this.frameworkEventListenerService = new $437b23f6a393c3bf$var$FrameworkEventListenerService(this.beans.frameworkOverrides);
        }
        const listener = (_b = (_a = this.frameworkEventListenerService) == null ? void 0 : _a.wrap(userListener)) != null ? _b : userListener;
        this.eventService.addEventListener(eventType, listener);
    }
    /** Remove event listener. */ removeEventListener(eventType, userListener) {
        var _a, _b;
        if (!this.eventService) return;
        const listener = (_b = (_a = this.frameworkEventListenerService) == null ? void 0 : _a.unwrap(userListener)) != null ? _b : userListener;
        this.eventService.removeEventListener(eventType, listener);
        if (this.eventService.noRegisteredListenersExist()) this.eventService = null;
    }
    onMouseEnter() {
        this.dispatchLocalEvent(this.createLocalRowEvent(_RowNode.EVENT_MOUSE_ENTER));
    }
    onMouseLeave() {
        this.dispatchLocalEvent(this.createLocalRowEvent(_RowNode.EVENT_MOUSE_LEAVE));
    }
    getFirstChildOfFirstChild(rowGroupColumn) {
        let currentRowNode = this;
        let isCandidate = true;
        let foundFirstChildPath = false;
        let nodeToSwapIn = null;
        while(isCandidate && !foundFirstChildPath){
            const parentRowNode = currentRowNode.parent;
            const firstChild = $437b23f6a393c3bf$var$exists(parentRowNode) && currentRowNode.firstChild;
            if (firstChild) {
                if (parentRowNode.rowGroupColumn === rowGroupColumn) {
                    foundFirstChildPath = true;
                    nodeToSwapIn = parentRowNode;
                }
            } else isCandidate = false;
            currentRowNode = parentRowNode;
        }
        return foundFirstChildPath ? nodeToSwapIn : null;
    }
    /**
   * Returns:
   * - `true` if the node is a full width cell
   * - `false` if the node is not a full width cell
   */ isFullWidthCell() {
        if (this.detail) return true;
        const isFullWidthCellFunc = this.beans.gos.getCallback("isFullWidthRow");
        return isFullWidthCellFunc ? isFullWidthCellFunc({
            rowNode: this
        }) : false;
    }
    /**
   * Returns the route of the row node. If the Row Node is a group, it returns the route to that Row Node.
   * If the Row Node is not a group, it returns `undefined`.
   */ getRoute() {
        if (this.key == null) return;
        const res = [];
        let pointer = this;
        while(pointer.key != null){
            res.push(pointer.key);
            pointer = pointer.parent;
        }
        return res.reverse();
    }
    createFooter() {
        if (this.sibling) return;
        const ignoredProperties = /* @__PURE__ */ new Set([
            "eventService",
            "__objectId",
            "sticky"
        ]);
        const footerNode = new _RowNode(this.beans);
        Object.keys(this).forEach((key)=>{
            if (ignoredProperties.has(key)) return;
            footerNode[key] = this[key];
        });
        footerNode.footer = true;
        footerNode.setRowTop(null);
        footerNode.setRowIndex(null);
        footerNode.oldRowTop = null;
        footerNode.id = "rowGroupFooter_" + this.id;
        footerNode.sibling = this;
        this.sibling = footerNode;
    }
    // Only used by SSRM. In CSRM this is never used as footers should always be present for
    // the purpose of exporting collapsed groups. In SSRM it is not possible to export collapsed
    // groups anyway, so can destroy footers.
    destroyFooter() {
        if (!this.sibling) return;
        this.sibling.setRowTop(null);
        this.sibling.setRowIndex(null);
        this.sibling = void 0;
    }
};
$437b23f6a393c3bf$var$_RowNode.ID_PREFIX_ROW_GROUP = "row-group-";
$437b23f6a393c3bf$var$_RowNode.ID_PREFIX_TOP_PINNED = "t-";
$437b23f6a393c3bf$var$_RowNode.ID_PREFIX_BOTTOM_PINNED = "b-";
$437b23f6a393c3bf$var$_RowNode.OBJECT_ID_SEQUENCE = 0;
$437b23f6a393c3bf$var$_RowNode.EVENT_ROW_SELECTED = "rowSelected";
$437b23f6a393c3bf$var$_RowNode.EVENT_DATA_CHANGED = "dataChanged";
$437b23f6a393c3bf$var$_RowNode.EVENT_CELL_CHANGED = "cellChanged";
$437b23f6a393c3bf$var$_RowNode.EVENT_ALL_CHILDREN_COUNT_CHANGED = "allChildrenCountChanged";
$437b23f6a393c3bf$var$_RowNode.EVENT_MASTER_CHANGED = "masterChanged";
$437b23f6a393c3bf$var$_RowNode.EVENT_GROUP_CHANGED = "groupChanged";
$437b23f6a393c3bf$var$_RowNode.EVENT_MOUSE_ENTER = "mouseEnter";
$437b23f6a393c3bf$var$_RowNode.EVENT_MOUSE_LEAVE = "mouseLeave";
$437b23f6a393c3bf$var$_RowNode.EVENT_HEIGHT_CHANGED = "heightChanged";
$437b23f6a393c3bf$var$_RowNode.EVENT_TOP_CHANGED = "topChanged";
$437b23f6a393c3bf$var$_RowNode.EVENT_DISPLAYED_CHANGED = "displayedChanged";
$437b23f6a393c3bf$var$_RowNode.EVENT_FIRST_CHILD_CHANGED = "firstChildChanged";
$437b23f6a393c3bf$var$_RowNode.EVENT_LAST_CHILD_CHANGED = "lastChildChanged";
$437b23f6a393c3bf$var$_RowNode.EVENT_CHILD_INDEX_CHANGED = "childIndexChanged";
$437b23f6a393c3bf$var$_RowNode.EVENT_ROW_INDEX_CHANGED = "rowIndexChanged";
$437b23f6a393c3bf$var$_RowNode.EVENT_EXPANDED_CHANGED = "expandedChanged";
$437b23f6a393c3bf$var$_RowNode.EVENT_HAS_CHILDREN_CHANGED = "hasChildrenChanged";
$437b23f6a393c3bf$var$_RowNode.EVENT_SELECTABLE_CHANGED = "selectableChanged";
$437b23f6a393c3bf$var$_RowNode.EVENT_UI_LEVEL_CHANGED = "uiLevelChanged";
$437b23f6a393c3bf$var$_RowNode.EVENT_HIGHLIGHT_CHANGED = "rowHighlightChanged";
$437b23f6a393c3bf$var$_RowNode.EVENT_DRAGGING_CHANGED = "draggingChanged";
var $437b23f6a393c3bf$export$6af91cd58ec2edf9 = $437b23f6a393c3bf$var$_RowNode;
// community-modules/core/src/rendering/checkboxSelectionComponent.ts
var $437b23f6a393c3bf$export$b54c7a6db4674fde = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super(/* html*/ `
            <div class="ag-selection-checkbox" role="presentation">
                <ag-checkbox role="presentation" ref="eCheckbox"></ag-checkbox>
            </div>`);
    }
    postConstruct() {
        this.eCheckbox.setPassive(true);
    }
    getCheckboxId() {
        return this.eCheckbox.getInputElement().id;
    }
    onDataChanged() {
        this.onSelectionChanged();
    }
    onSelectableChanged() {
        this.showOrHideSelect();
    }
    onSelectionChanged() {
        const translate = this.localeService.getLocaleTextFunc();
        const state = this.rowNode.isSelected();
        const stateName = $437b23f6a393c3bf$var$getAriaCheckboxStateName(translate, state);
        const [ariaKey, ariaLabel] = this.rowNode.selectable ? [
            "ariaRowToggleSelection",
            "Press Space to toggle row selection"
        ] : [
            "ariaRowSelectionDisabled",
            "Row Selection is disabled for this row"
        ];
        const translatedLabel = translate(ariaKey, ariaLabel);
        this.eCheckbox.setValue(state, true);
        this.eCheckbox.setInputAriaLabel(`${translatedLabel} (${stateName})`);
    }
    onClicked(newValue, groupSelectsFiltered, event) {
        return this.rowNode.setSelectedParams({
            newValue: newValue,
            rangeSelect: event.shiftKey,
            groupSelectsFiltered: groupSelectsFiltered,
            event: event,
            source: "checkboxSelected"
        });
    }
    init(params) {
        this.rowNode = params.rowNode;
        this.column = params.column;
        this.overrides = params.overrides;
        this.onSelectionChanged();
        this.addManagedListener(this.eCheckbox.getInputElement(), "dblclick", (event)=>{
            $437b23f6a393c3bf$var$stopPropagationForAgGrid(event);
        });
        this.addManagedListener(this.eCheckbox.getInputElement(), "click", (event)=>{
            $437b23f6a393c3bf$var$stopPropagationForAgGrid(event);
            const groupSelectsFiltered = this.gos.get("groupSelectsFiltered");
            const isSelected = this.eCheckbox.getValue();
            if (this.shouldHandleIndeterminateState(isSelected, groupSelectsFiltered)) {
                const result = this.onClicked(true, groupSelectsFiltered, event || {});
                if (result === 0) this.onClicked(false, groupSelectsFiltered, event);
            } else if (isSelected) this.onClicked(false, groupSelectsFiltered, event);
            else this.onClicked(true, groupSelectsFiltered, event || {});
        });
        this.addManagedListener(this.rowNode, $437b23f6a393c3bf$export$6af91cd58ec2edf9.EVENT_ROW_SELECTED, this.onSelectionChanged.bind(this));
        this.addManagedListener(this.rowNode, $437b23f6a393c3bf$export$6af91cd58ec2edf9.EVENT_DATA_CHANGED, this.onDataChanged.bind(this));
        this.addManagedListener(this.rowNode, $437b23f6a393c3bf$export$6af91cd58ec2edf9.EVENT_SELECTABLE_CHANGED, this.onSelectableChanged.bind(this));
        const isRowSelectableFunc = this.gos.get("isRowSelectable");
        const checkboxVisibleIsDynamic = isRowSelectableFunc || typeof this.getIsVisible() === "function";
        if (checkboxVisibleIsDynamic) {
            const showOrHideSelectListener = this.showOrHideSelect.bind(this);
            this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_DISPLAYED_COLUMNS_CHANGED, showOrHideSelectListener);
            this.addManagedListener(this.rowNode, $437b23f6a393c3bf$export$6af91cd58ec2edf9.EVENT_DATA_CHANGED, showOrHideSelectListener);
            this.addManagedListener(this.rowNode, $437b23f6a393c3bf$export$6af91cd58ec2edf9.EVENT_CELL_CHANGED, showOrHideSelectListener);
            this.showOrHideSelect();
        }
        this.eCheckbox.getInputElement().setAttribute("tabindex", "-1");
    }
    shouldHandleIndeterminateState(isSelected, groupSelectsFiltered) {
        return groupSelectsFiltered && (this.eCheckbox.getPreviousValue() === void 0 || isSelected === void 0) && this.gos.isRowModelType("clientSide");
    }
    showOrHideSelect() {
        var _a, _b, _c;
        let selectable = this.rowNode.selectable;
        const isVisible2 = this.getIsVisible();
        if (selectable) {
            if (typeof isVisible2 === "function") {
                const extraParams = (_a = this.overrides) == null ? void 0 : _a.callbackParams;
                if (!this.column) selectable = isVisible2($437b23f6a393c3bf$var$__spreadProps($437b23f6a393c3bf$var$__spreadValues({}, extraParams), {
                    node: this.rowNode,
                    data: this.rowNode.data
                }));
                else {
                    const params = this.column.createColumnFunctionCallbackParams(this.rowNode);
                    selectable = isVisible2($437b23f6a393c3bf$var$__spreadValues($437b23f6a393c3bf$var$__spreadValues({}, extraParams), params));
                }
            } else selectable = isVisible2 != null ? isVisible2 : false;
        }
        const disableInsteadOfHide = (_b = this.column) == null ? void 0 : _b.getColDef().showDisabledCheckboxes;
        if (disableInsteadOfHide) {
            this.eCheckbox.setDisabled(!selectable);
            this.setVisible(true);
            this.setDisplayed(true);
            return;
        }
        if ((_c = this.overrides) == null ? void 0 : _c.removeHidden) {
            this.setDisplayed(selectable);
            return;
        }
        this.setVisible(selectable);
    }
    getIsVisible() {
        var _a, _b;
        if (this.overrides) return this.overrides.isVisible;
        return (_b = (_a = this.column) == null ? void 0 : _a.getColDef()) == null ? void 0 : _b.checkboxSelection;
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eCheckbox")
], $437b23f6a393c3bf$export$b54c7a6db4674fde.prototype, "eCheckbox", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$export$b54c7a6db4674fde.prototype, "postConstruct", 1);
// community-modules/core/src/constants/direction.ts
var $437b23f6a393c3bf$export$b40429d5c2dfb329 = /* @__PURE__ */ ((VerticalDirection2)=>{
    VerticalDirection2[VerticalDirection2["Up"] = 0] = "Up";
    VerticalDirection2[VerticalDirection2["Down"] = 1] = "Down";
    return VerticalDirection2;
})($437b23f6a393c3bf$export$b40429d5c2dfb329 || {});
var $437b23f6a393c3bf$export$2e679088785045c = /* @__PURE__ */ ((HorizontalDirection2)=>{
    HorizontalDirection2[HorizontalDirection2["Left"] = 0] = "Left";
    HorizontalDirection2[HorizontalDirection2["Right"] = 1] = "Right";
    return HorizontalDirection2;
})($437b23f6a393c3bf$export$2e679088785045c || {});
// community-modules/core/src/dragAndDrop/dragAndDropService.ts
var $437b23f6a393c3bf$export$46ba5a92125911d9 = /* @__PURE__ */ ((DragSourceType4)=>{
    DragSourceType4[DragSourceType4["ToolPanel"] = 0] = "ToolPanel";
    DragSourceType4[DragSourceType4["HeaderCell"] = 1] = "HeaderCell";
    DragSourceType4[DragSourceType4["RowDrag"] = 2] = "RowDrag";
    DragSourceType4[DragSourceType4["ChartPanel"] = 3] = "ChartPanel";
    DragSourceType4[DragSourceType4["AdvancedFilterBuilder"] = 4] = "AdvancedFilterBuilder";
    return DragSourceType4;
})($437b23f6a393c3bf$export$46ba5a92125911d9 || {});
var $437b23f6a393c3bf$export$3529111922becfa6 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.dragSourceAndParamsList = [];
        this.dropTargets = [];
    }
    init() {
        this.ePinnedIcon = $437b23f6a393c3bf$var$createIcon("columnMovePin", this.gos, null);
        this.eHideIcon = $437b23f6a393c3bf$var$createIcon("columnMoveHide", this.gos, null);
        this.eMoveIcon = $437b23f6a393c3bf$var$createIcon("columnMoveMove", this.gos, null);
        this.eLeftIcon = $437b23f6a393c3bf$var$createIcon("columnMoveLeft", this.gos, null);
        this.eRightIcon = $437b23f6a393c3bf$var$createIcon("columnMoveRight", this.gos, null);
        this.eGroupIcon = $437b23f6a393c3bf$var$createIcon("columnMoveGroup", this.gos, null);
        this.eAggregateIcon = $437b23f6a393c3bf$var$createIcon("columnMoveValue", this.gos, null);
        this.ePivotIcon = $437b23f6a393c3bf$var$createIcon("columnMovePivot", this.gos, null);
        this.eDropNotAllowedIcon = $437b23f6a393c3bf$var$createIcon("dropNotAllowed", this.gos, null);
    }
    addDragSource(dragSource, allowTouch = false) {
        const params = {
            eElement: dragSource.eElement,
            dragStartPixels: dragSource.dragStartPixels,
            onDragStart: this.onDragStart.bind(this, dragSource),
            onDragStop: this.onDragStop.bind(this),
            onDragging: this.onDragging.bind(this),
            includeTouch: allowTouch
        };
        this.dragSourceAndParamsList.push({
            params: params,
            dragSource: dragSource
        });
        this.dragService.addDragSource(params);
    }
    removeDragSource(dragSource) {
        const sourceAndParams = this.dragSourceAndParamsList.find((item)=>item.dragSource === dragSource);
        if (sourceAndParams) {
            this.dragService.removeDragSource(sourceAndParams.params);
            $437b23f6a393c3bf$var$removeFromArray(this.dragSourceAndParamsList, sourceAndParams);
        }
    }
    clearDragSourceParamsList() {
        this.dragSourceAndParamsList.forEach((sourceAndParams)=>this.dragService.removeDragSource(sourceAndParams.params));
        this.dragSourceAndParamsList.length = 0;
        this.dropTargets.length = 0;
    }
    nudge() {
        if (this.dragging) this.onDragging(this.eventLastTime, true);
    }
    onDragStart(dragSource, mouseEvent) {
        this.dragging = true;
        this.dragSource = dragSource;
        this.eventLastTime = mouseEvent;
        this.dragItem = this.dragSource.getDragItem();
        this.lastDropTarget = void 0;
        if (this.dragSource.onDragStarted) this.dragSource.onDragStarted();
        this.createGhost();
    }
    onDragStop(mouseEvent) {
        this.eventLastTime = null;
        this.dragging = false;
        if (this.dragSource.onDragStopped) this.dragSource.onDragStopped();
        if (this.lastDropTarget && this.lastDropTarget.onDragStop) {
            const draggingEvent = this.createDropTargetEvent(this.lastDropTarget, mouseEvent, null, null, false);
            this.lastDropTarget.onDragStop(draggingEvent);
        }
        this.lastDropTarget = null;
        this.dragItem = null;
        this.removeGhost();
    }
    onDragging(mouseEvent, fromNudge) {
        var _a, _b, _c, _d;
        const hDirection = this.getHorizontalDirection(mouseEvent);
        const vDirection = this.getVerticalDirection(mouseEvent);
        this.eventLastTime = mouseEvent;
        this.positionGhost(mouseEvent);
        const validDropTargets = this.dropTargets.filter((target)=>this.isMouseOnDropTarget(mouseEvent, target));
        const dropTarget = this.findCurrentDropTarget(mouseEvent, validDropTargets);
        if (dropTarget !== this.lastDropTarget) {
            this.leaveLastTargetIfExists(mouseEvent, hDirection, vDirection, fromNudge);
            if (this.lastDropTarget !== null && dropTarget === null) (_b = (_a = this.dragSource).onGridExit) == null || _b.call(_a, this.dragItem);
            if (this.lastDropTarget === null && dropTarget !== null) (_d = (_c = this.dragSource).onGridEnter) == null || _d.call(_c, this.dragItem);
            this.enterDragTargetIfExists(dropTarget, mouseEvent, hDirection, vDirection, fromNudge);
            this.lastDropTarget = dropTarget;
        } else if (dropTarget && dropTarget.onDragging) {
            const draggingEvent = this.createDropTargetEvent(dropTarget, mouseEvent, hDirection, vDirection, fromNudge);
            dropTarget.onDragging(draggingEvent);
        }
    }
    getAllContainersFromDropTarget(dropTarget) {
        const secondaryContainers = dropTarget.getSecondaryContainers ? dropTarget.getSecondaryContainers() : null;
        const containers = [
            [
                dropTarget.getContainer()
            ]
        ];
        return secondaryContainers ? containers.concat(secondaryContainers) : containers;
    }
    allContainersIntersect(mouseEvent, containers) {
        for (const container of containers){
            const rect = container.getBoundingClientRect();
            if (rect.width === 0 || rect.height === 0) return false;
            const horizontalFit = mouseEvent.clientX >= rect.left && mouseEvent.clientX < rect.right;
            const verticalFit = mouseEvent.clientY >= rect.top && mouseEvent.clientY < rect.bottom;
            if (!horizontalFit || !verticalFit) return false;
        }
        return true;
    }
    // checks if the mouse is on the drop target. it checks eContainer and eSecondaryContainers
    isMouseOnDropTarget(mouseEvent, dropTarget) {
        const allContainersFromDropTarget = this.getAllContainersFromDropTarget(dropTarget);
        let mouseOverTarget = false;
        for (const currentContainers of allContainersFromDropTarget)if (this.allContainersIntersect(mouseEvent, currentContainers)) {
            mouseOverTarget = true;
            break;
        }
        if (dropTarget.targetContainsSource && !dropTarget.getContainer().contains(this.dragSource.eElement)) return false;
        return mouseOverTarget && dropTarget.isInterestedIn(this.dragSource.type, this.dragSource.eElement);
    }
    findCurrentDropTarget(mouseEvent, validDropTargets) {
        const len = validDropTargets.length;
        if (len === 0) return null;
        if (len === 1) return validDropTargets[0];
        const rootNode = this.gos.getRootNode();
        const elementStack = rootNode.elementsFromPoint(mouseEvent.clientX, mouseEvent.clientY);
        for (const el of elementStack)for (const dropTarget of validDropTargets){
            const containers = $437b23f6a393c3bf$var$flatten(this.getAllContainersFromDropTarget(dropTarget));
            if (containers.indexOf(el) !== -1) return dropTarget;
        }
        return null;
    }
    enterDragTargetIfExists(dropTarget, mouseEvent, hDirection, vDirection, fromNudge) {
        if (!dropTarget) return;
        if (dropTarget.onDragEnter) {
            const dragEnterEvent = this.createDropTargetEvent(dropTarget, mouseEvent, hDirection, vDirection, fromNudge);
            dropTarget.onDragEnter(dragEnterEvent);
        }
        this.setGhostIcon(dropTarget.getIconName ? dropTarget.getIconName() : null);
    }
    leaveLastTargetIfExists(mouseEvent, hDirection, vDirection, fromNudge) {
        if (!this.lastDropTarget) return;
        if (this.lastDropTarget.onDragLeave) {
            const dragLeaveEvent = this.createDropTargetEvent(this.lastDropTarget, mouseEvent, hDirection, vDirection, fromNudge);
            this.lastDropTarget.onDragLeave(dragLeaveEvent);
        }
        this.setGhostIcon(null);
    }
    addDropTarget(dropTarget) {
        this.dropTargets.push(dropTarget);
    }
    removeDropTarget(dropTarget) {
        this.dropTargets = this.dropTargets.filter((target)=>target.getContainer() !== dropTarget.getContainer());
    }
    hasExternalDropZones() {
        return this.dropTargets.some((zones)=>zones.external);
    }
    findExternalZone(params) {
        const externalTargets = this.dropTargets.filter((target)=>target.external);
        return externalTargets.find((zone)=>zone.getContainer() === params.getContainer()) || null;
    }
    getHorizontalDirection(event) {
        const clientX = this.eventLastTime && this.eventLastTime.clientX;
        const eClientX = event.clientX;
        if (clientX === eClientX) return null;
        return clientX > eClientX ? 0 /* Left */  : 1 /* Right */ ;
    }
    getVerticalDirection(event) {
        const clientY = this.eventLastTime && this.eventLastTime.clientY;
        const eClientY = event.clientY;
        if (clientY === eClientY) return null;
        return clientY > eClientY ? 0 /* Up */  : 1 /* Down */ ;
    }
    createDropTargetEvent(dropTarget, event, hDirection, vDirection, fromNudge) {
        const dropZoneTarget = dropTarget.getContainer();
        const rect = dropZoneTarget.getBoundingClientRect();
        const { gridApi: api, columnApi: columnApi, dragItem: dragItem, dragSource: dragSource } = this;
        const x = event.clientX - rect.left;
        const y = event.clientY - rect.top;
        return {
            event: event,
            x: x,
            y: y,
            vDirection: vDirection,
            hDirection: hDirection,
            dragSource: dragSource,
            fromNudge: fromNudge,
            dragItem: dragItem,
            api: api,
            columnApi: columnApi,
            dropZoneTarget: dropZoneTarget
        };
    }
    positionGhost(event) {
        const ghost = this.eGhost;
        if (!ghost) return;
        const ghostRect = ghost.getBoundingClientRect();
        const ghostHeight = ghostRect.height;
        const browserWidth = $437b23f6a393c3bf$var$getBodyWidth() - 2;
        const browserHeight = $437b23f6a393c3bf$var$getBodyHeight() - 2;
        const offsetParentSize = $437b23f6a393c3bf$var$getElementRectWithOffset(ghost.offsetParent);
        const { clientY: clientY, clientX: clientX } = event;
        let top = clientY - offsetParentSize.top - ghostHeight / 2;
        let left = clientX - offsetParentSize.left - 10;
        const eDocument = this.gos.getDocument();
        const win = eDocument.defaultView || window;
        const windowScrollY = win.pageYOffset || eDocument.documentElement.scrollTop;
        const windowScrollX = win.pageXOffset || eDocument.documentElement.scrollLeft;
        if (browserWidth > 0 && left + ghost.clientWidth > browserWidth + windowScrollX) left = browserWidth + windowScrollX - ghost.clientWidth;
        if (left < 0) left = 0;
        if (browserHeight > 0 && top + ghost.clientHeight > browserHeight + windowScrollY) top = browserHeight + windowScrollY - ghost.clientHeight;
        if (top < 0) top = 0;
        ghost.style.left = `${left}px`;
        ghost.style.top = `${top}px`;
    }
    removeGhost() {
        if (this.eGhost && this.eGhostParent) this.eGhostParent.removeChild(this.eGhost);
        this.eGhost = null;
    }
    createGhost() {
        this.eGhost = $437b23f6a393c3bf$var$loadTemplate($437b23f6a393c3bf$export$3529111922becfa6.GHOST_TEMPLATE);
        this.mouseEventService.stampTopLevelGridCompWithGridInstance(this.eGhost);
        const { theme: theme } = this.environment.getTheme();
        if (theme) this.eGhost.classList.add(theme);
        this.eGhostIcon = this.eGhost.querySelector(".ag-dnd-ghost-icon");
        this.setGhostIcon(null);
        const eText = this.eGhost.querySelector(".ag-dnd-ghost-label");
        let dragItemName = this.dragSource.dragItemName;
        if ($437b23f6a393c3bf$var$isFunction(dragItemName)) dragItemName = dragItemName();
        eText.innerHTML = $437b23f6a393c3bf$var$escapeString(dragItemName) || "";
        this.eGhost.style.height = "25px";
        this.eGhost.style.top = "20px";
        this.eGhost.style.left = "20px";
        const eDocument = this.gos.getDocument();
        let rootNode = null;
        let targetEl = null;
        try {
            rootNode = eDocument.fullscreenElement;
        } catch (e) {} finally{
            if (!rootNode) rootNode = this.gos.getRootNode();
            const body = rootNode.querySelector("body");
            if (body) targetEl = body;
            else if (rootNode instanceof ShadowRoot) targetEl = rootNode;
            else if (rootNode instanceof Document) targetEl = rootNode == null ? void 0 : rootNode.documentElement;
            else targetEl = rootNode;
        }
        this.eGhostParent = targetEl;
        if (!this.eGhostParent) console.warn("AG Grid: could not find document body, it is needed for dragging columns");
        else this.eGhostParent.appendChild(this.eGhost);
    }
    setGhostIcon(iconName, shake = false) {
        $437b23f6a393c3bf$var$clearElement(this.eGhostIcon);
        let eIcon = null;
        if (!iconName) iconName = this.dragSource.getDefaultIconName ? this.dragSource.getDefaultIconName() : $437b23f6a393c3bf$export$3529111922becfa6.ICON_NOT_ALLOWED;
        switch(iconName){
            case $437b23f6a393c3bf$export$3529111922becfa6.ICON_PINNED:
                eIcon = this.ePinnedIcon;
                break;
            case $437b23f6a393c3bf$export$3529111922becfa6.ICON_MOVE:
                eIcon = this.eMoveIcon;
                break;
            case $437b23f6a393c3bf$export$3529111922becfa6.ICON_LEFT:
                eIcon = this.eLeftIcon;
                break;
            case $437b23f6a393c3bf$export$3529111922becfa6.ICON_RIGHT:
                eIcon = this.eRightIcon;
                break;
            case $437b23f6a393c3bf$export$3529111922becfa6.ICON_GROUP:
                eIcon = this.eGroupIcon;
                break;
            case $437b23f6a393c3bf$export$3529111922becfa6.ICON_AGGREGATE:
                eIcon = this.eAggregateIcon;
                break;
            case $437b23f6a393c3bf$export$3529111922becfa6.ICON_PIVOT:
                eIcon = this.ePivotIcon;
                break;
            case $437b23f6a393c3bf$export$3529111922becfa6.ICON_NOT_ALLOWED:
                eIcon = this.eDropNotAllowedIcon;
                break;
            case $437b23f6a393c3bf$export$3529111922becfa6.ICON_HIDE:
                eIcon = this.eHideIcon;
                break;
        }
        this.eGhostIcon.classList.toggle("ag-shake-left-to-right", shake);
        if (eIcon === this.eHideIcon && this.gos.get("suppressDragLeaveHidesColumns")) return;
        if (eIcon) this.eGhostIcon.appendChild(eIcon);
    }
};
$437b23f6a393c3bf$export$3529111922becfa6.ICON_PINNED = "pinned";
$437b23f6a393c3bf$export$3529111922becfa6.ICON_MOVE = "move";
$437b23f6a393c3bf$export$3529111922becfa6.ICON_LEFT = "left";
$437b23f6a393c3bf$export$3529111922becfa6.ICON_RIGHT = "right";
$437b23f6a393c3bf$export$3529111922becfa6.ICON_GROUP = "group";
$437b23f6a393c3bf$export$3529111922becfa6.ICON_AGGREGATE = "aggregate";
$437b23f6a393c3bf$export$3529111922becfa6.ICON_PIVOT = "pivot";
$437b23f6a393c3bf$export$3529111922becfa6.ICON_NOT_ALLOWED = "notAllowed";
$437b23f6a393c3bf$export$3529111922becfa6.ICON_HIDE = "hide";
$437b23f6a393c3bf$export$3529111922becfa6.GHOST_TEMPLATE = /* html */ `<div class="ag-dnd-ghost ag-unselectable">
            <span class="ag-dnd-ghost-icon ag-shake-left-to-right"></span>
            <div class="ag-dnd-ghost-label"></div>
        </div>`;
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("dragService")
], $437b23f6a393c3bf$export$3529111922becfa6.prototype, "dragService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("mouseEventService")
], $437b23f6a393c3bf$export$3529111922becfa6.prototype, "mouseEventService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnApi")
], $437b23f6a393c3bf$export$3529111922becfa6.prototype, "columnApi", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("gridApi")
], $437b23f6a393c3bf$export$3529111922becfa6.prototype, "gridApi", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$export$3529111922becfa6.prototype, "init", 1);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$cc3f3d4529c57d95
], $437b23f6a393c3bf$export$3529111922becfa6.prototype, "clearDragSourceParamsList", 1);
$437b23f6a393c3bf$export$3529111922becfa6 = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("dragAndDropService")
], $437b23f6a393c3bf$export$3529111922becfa6);
// community-modules/core/src/rendering/row/rowDragComp.ts
var $437b23f6a393c3bf$var$RowDragComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(cellValueFn, rowNode, column, customGui, dragStartPixels, suppressVisibilityChange){
        super();
        this.cellValueFn = cellValueFn;
        this.rowNode = rowNode;
        this.column = column;
        this.customGui = customGui;
        this.dragStartPixels = dragStartPixels;
        this.suppressVisibilityChange = suppressVisibilityChange;
        this.dragSource = null;
    }
    isCustomGui() {
        return this.customGui != null;
    }
    postConstruct() {
        if (!this.customGui) {
            this.setTemplate(/* html */ `<div class="ag-drag-handle ag-row-drag" aria-hidden="true"></div>`);
            this.getGui().appendChild($437b23f6a393c3bf$var$createIconNoSpan("rowDrag", this.gos, null));
            this.addDragSource();
        } else this.setDragElement(this.customGui, this.dragStartPixels);
        this.checkCompatibility();
        if (!this.suppressVisibilityChange) {
            const strategy = this.gos.get("rowDragManaged") ? new $437b23f6a393c3bf$var$ManagedVisibilityStrategy(this, this.beans, this.rowNode, this.column) : new $437b23f6a393c3bf$var$NonManagedVisibilityStrategy(this, this.beans, this.rowNode, this.column);
            this.createManagedBean(strategy, this.beans.context);
        }
    }
    setDragElement(dragElement, dragStartPixels) {
        this.setTemplateFromElement(dragElement);
        this.addDragSource(dragStartPixels);
    }
    getSelectedNodes() {
        const isRowDragMultiRow = this.gos.get("rowDragMultiRow");
        if (!isRowDragMultiRow) return [
            this.rowNode
        ];
        const selection = this.beans.selectionService.getSelectedNodes();
        return selection.indexOf(this.rowNode) !== -1 ? selection : [
            this.rowNode
        ];
    }
    // returns true if all compatibility items work out
    checkCompatibility() {
        const managed = this.gos.get("rowDragManaged");
        const treeData = this.gos.get("treeData");
        if (treeData && managed) $437b23f6a393c3bf$var$warnOnce("If using row drag with tree data, you cannot have rowDragManaged=true");
    }
    getDragItem() {
        return {
            rowNode: this.rowNode,
            rowNodes: this.getSelectedNodes(),
            columns: this.column ? [
                this.column
            ] : void 0,
            defaultTextValue: this.cellValueFn()
        };
    }
    getRowDragText(column) {
        if (column) {
            const colDef = column.getColDef();
            if (colDef.rowDragText) return colDef.rowDragText;
        }
        return this.gos.get("rowDragText");
    }
    addDragSource(dragStartPixels = 4) {
        if (this.dragSource) this.removeDragSource();
        const translate = this.localeService.getLocaleTextFunc();
        this.dragSource = {
            type: 2 /* RowDrag */ ,
            eElement: this.getGui(),
            dragItemName: ()=>{
                var _a;
                const dragItem = this.getDragItem();
                const dragItemCount = ((_a = dragItem.rowNodes) == null ? void 0 : _a.length) || 1;
                const rowDragText = this.getRowDragText(this.column);
                if (rowDragText) return rowDragText(dragItem, dragItemCount);
                return dragItemCount === 1 ? this.cellValueFn() : `${dragItemCount} ${translate("rowDragRows", "rows")}`;
            },
            getDragItem: ()=>this.getDragItem(),
            dragStartPixels: dragStartPixels,
            dragSourceDomDataKey: this.gos.getDomDataKey()
        };
        this.beans.dragAndDropService.addDragSource(this.dragSource, true);
    }
    removeDragSource() {
        if (this.dragSource) this.beans.dragAndDropService.removeDragSource(this.dragSource);
        this.dragSource = null;
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("beans")
], $437b23f6a393c3bf$var$RowDragComp.prototype, "beans", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$RowDragComp.prototype, "postConstruct", 1);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$cc3f3d4529c57d95
], $437b23f6a393c3bf$var$RowDragComp.prototype, "removeDragSource", 1);
var $437b23f6a393c3bf$var$VisibilityStrategy = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(parent, rowNode, column){
        super();
        this.parent = parent;
        this.rowNode = rowNode;
        this.column = column;
    }
    setDisplayedOrVisible(neverDisplayed) {
        const displayedOptions = {
            skipAriaHidden: true
        };
        if (neverDisplayed) this.parent.setDisplayed(false, displayedOptions);
        else {
            let shown = true;
            let isShownSometimes = false;
            if (this.column) {
                shown = this.column.isRowDrag(this.rowNode) || this.parent.isCustomGui();
                isShownSometimes = $437b23f6a393c3bf$var$isFunction(this.column.getColDef().rowDrag);
            }
            if (isShownSometimes) {
                this.parent.setDisplayed(true, displayedOptions);
                this.parent.setVisible(shown, displayedOptions);
            } else {
                this.parent.setDisplayed(shown, displayedOptions);
                this.parent.setVisible(true, displayedOptions);
            }
        }
    }
};
var $437b23f6a393c3bf$var$NonManagedVisibilityStrategy = class extends $437b23f6a393c3bf$var$VisibilityStrategy {
    constructor(parent, beans, rowNode, column){
        super(parent, rowNode, column);
        this.beans = beans;
    }
    postConstruct() {
        this.addManagedPropertyListener("suppressRowDrag", this.onSuppressRowDrag.bind(this));
        this.addManagedListener(this.rowNode, $437b23f6a393c3bf$export$6af91cd58ec2edf9.EVENT_DATA_CHANGED, this.workOutVisibility.bind(this));
        this.addManagedListener(this.rowNode, $437b23f6a393c3bf$export$6af91cd58ec2edf9.EVENT_CELL_CHANGED, this.workOutVisibility.bind(this));
        this.addManagedListener(this.rowNode, $437b23f6a393c3bf$export$6af91cd58ec2edf9.EVENT_CELL_CHANGED, this.workOutVisibility.bind(this));
        this.addManagedListener(this.beans.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_NEW_COLUMNS_LOADED, this.workOutVisibility.bind(this));
        this.workOutVisibility();
    }
    onSuppressRowDrag() {
        this.workOutVisibility();
    }
    workOutVisibility() {
        const neverDisplayed = this.gos.get("suppressRowDrag");
        this.setDisplayedOrVisible(neverDisplayed);
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$NonManagedVisibilityStrategy.prototype, "postConstruct", 1);
var $437b23f6a393c3bf$var$ManagedVisibilityStrategy = class extends $437b23f6a393c3bf$var$VisibilityStrategy {
    constructor(parent, beans, rowNode, column){
        super(parent, rowNode, column);
        this.beans = beans;
    }
    postConstruct() {
        this.addManagedListener(this.beans.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_SORT_CHANGED, this.workOutVisibility.bind(this));
        this.addManagedListener(this.beans.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_FILTER_CHANGED, this.workOutVisibility.bind(this));
        this.addManagedListener(this.beans.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_ROW_GROUP_CHANGED, this.workOutVisibility.bind(this));
        this.addManagedListener(this.beans.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_NEW_COLUMNS_LOADED, this.workOutVisibility.bind(this));
        this.addManagedListener(this.rowNode, $437b23f6a393c3bf$export$6af91cd58ec2edf9.EVENT_DATA_CHANGED, this.workOutVisibility.bind(this));
        this.addManagedListener(this.rowNode, $437b23f6a393c3bf$export$6af91cd58ec2edf9.EVENT_CELL_CHANGED, this.workOutVisibility.bind(this));
        this.addManagedPropertyListener("suppressRowDrag", this.onSuppressRowDrag.bind(this));
        this.workOutVisibility();
    }
    onSuppressRowDrag() {
        this.workOutVisibility();
    }
    workOutVisibility() {
        const gridBodyCon = this.beans.ctrlsService.getGridBodyCtrl();
        const rowDragFeature = gridBodyCon.getRowDragFeature();
        const shouldPreventRowMove = rowDragFeature && rowDragFeature.shouldPreventRowMove();
        const suppressRowDrag = this.gos.get("suppressRowDrag");
        const hasExternalDropZones = this.beans.dragAndDropService.hasExternalDropZones();
        const neverDisplayed = shouldPreventRowMove && !hasExternalDropZones || suppressRowDrag;
        this.setDisplayedOrVisible(neverDisplayed);
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$ManagedVisibilityStrategy.prototype, "postConstruct", 1);
// community-modules/core/src/rendering/cellRenderers/groupCellRendererCtrl.ts
var $437b23f6a393c3bf$export$629e29df0ab4c80 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    init(comp, eGui, eCheckbox, eExpanded, eContracted, compClass, params) {
        var _a, _b, _c, _d;
        this.params = params;
        this.eGui = eGui;
        this.eCheckbox = eCheckbox;
        this.eExpanded = eExpanded;
        this.eContracted = eContracted;
        this.comp = comp;
        this.compClass = compClass;
        const { node: node, value: value, colDef: colDef } = params;
        const topLevelFooter = this.isTopLevelFooter();
        if (!topLevelFooter) {
            const embeddedRowMismatch = this.isEmbeddedRowMismatch();
            if (embeddedRowMismatch) return;
            if (node.footer && this.gos.get("groupHideOpenParents")) {
                const showRowGroup = colDef && colDef.showRowGroup;
                const rowGroupColumnId = node.rowGroupColumn && node.rowGroupColumn.getColId();
                if (showRowGroup !== rowGroupColumnId) return;
            }
        }
        this.setupShowingValueForOpenedParent();
        this.findDisplayedGroupNode();
        if (!topLevelFooter) {
            const showingFooterTotal = params.node.footer && params.node.rowGroupIndex === this.columnModel.getRowGroupColumns().findIndex((c)=>{
                var _a2;
                return c.getColId() === ((_a2 = params.colDef) == null ? void 0 : _a2.showRowGroup);
            });
            const isAlwaysShowing = this.gos.get("groupDisplayType") != "multipleColumns" || this.gos.get("treeData");
            const showOpenGroupValue = isAlwaysShowing || this.gos.get("showOpenedGroup") && !params.node.footer && (!params.node.group || params.node.rowGroupIndex != null && params.node.rowGroupIndex > this.columnModel.getRowGroupColumns().findIndex((c)=>{
                var _a2;
                return c.getColId() === ((_a2 = params.colDef) == null ? void 0 : _a2.showRowGroup);
            }));
            const leafWithValues = !node.group && (((_a = this.params.colDef) == null ? void 0 : _a.field) || ((_b = this.params.colDef) == null ? void 0 : _b.valueGetter));
            const isExpandable = this.isExpandable();
            const showPivotModeLeafValue = this.columnModel.isPivotMode() && node.leafGroup && ((_c = node.rowGroupColumn) == null ? void 0 : _c.getColId()) === ((_d = params.column) == null ? void 0 : _d.getColDef().showRowGroup);
            const canSkipRenderingCell = !this.showingValueForOpenedParent && !isExpandable && !leafWithValues && !showOpenGroupValue && !showingFooterTotal && !showPivotModeLeafValue;
            if (canSkipRenderingCell) return;
        }
        this.addExpandAndContract();
        this.addFullWidthRowDraggerIfNeeded();
        this.addCheckboxIfNeeded();
        this.addValueElement();
        this.setupIndent();
        this.refreshAriaExpanded();
    }
    getCellAriaRole() {
        var _a, _b;
        const colDefAriaRole = (_a = this.params.colDef) == null ? void 0 : _a.cellAriaRole;
        const columnColDefAriaRole = (_b = this.params.column) == null ? void 0 : _b.getColDef().cellAriaRole;
        return colDefAriaRole || columnColDefAriaRole || "gridcell";
    }
    destroy() {
        super.destroy();
        this.expandListener = null;
    }
    refreshAriaExpanded() {
        const { node: node, eGridCell: eGridCell } = this.params;
        if (this.expandListener) this.expandListener = this.expandListener();
        if (!this.isExpandable()) {
            $437b23f6a393c3bf$var$removeAriaExpanded(eGridCell);
            return;
        }
        const listener = ()=>{
            $437b23f6a393c3bf$var$setAriaExpanded(eGridCell, !!node.expanded);
        };
        this.expandListener = this.addManagedListener(node, $437b23f6a393c3bf$export$6af91cd58ec2edf9.EVENT_EXPANDED_CHANGED, listener) || null;
        listener();
    }
    isTopLevelFooter() {
        const totalRow = this.gos.getGrandTotalRow();
        if (!totalRow) return false;
        if (this.params.value != null || this.params.node.level != -1) return false;
        const colDef = this.params.colDef;
        const doingFullWidth = colDef == null;
        if (doingFullWidth) return true;
        if (colDef.showRowGroup === true) return true;
        const rowGroupCols = this.columnModel.getRowGroupColumns();
        if (!rowGroupCols || rowGroupCols.length === 0) return true;
        const firstRowGroupCol = rowGroupCols[0];
        return firstRowGroupCol.getId() === colDef.showRowGroup;
    }
    // if we are doing embedded full width rows, we only show the renderer when
    // in the body, or if pinning in the pinned section, or if pinning and RTL,
    // in the right section. otherwise we would have the cell repeated in each section.
    isEmbeddedRowMismatch() {
        if (!this.params.fullWidth || !this.gos.get("embedFullWidthRows")) return false;
        const pinnedLeftCell = this.params.pinned === "left";
        const pinnedRightCell = this.params.pinned === "right";
        const bodyCell = !pinnedLeftCell && !pinnedRightCell;
        if (this.gos.get("enableRtl")) {
            if (this.columnModel.isPinningLeft()) return !pinnedRightCell;
            return !bodyCell;
        }
        if (this.columnModel.isPinningLeft()) return !pinnedLeftCell;
        return !bodyCell;
    }
    findDisplayedGroupNode() {
        const column = this.params.column;
        const rowNode = this.params.node;
        if (this.showingValueForOpenedParent) {
            let pointer = rowNode.parent;
            while(pointer != null){
                if (pointer.rowGroupColumn && column.isRowGroupDisplayed(pointer.rowGroupColumn.getId())) {
                    this.displayedGroupNode = pointer;
                    break;
                }
                pointer = pointer.parent;
            }
        }
        if ($437b23f6a393c3bf$var$missing(this.displayedGroupNode)) this.displayedGroupNode = rowNode;
    }
    setupShowingValueForOpenedParent() {
        const rowNode = this.params.node;
        const column = this.params.column;
        if (!this.gos.get("groupHideOpenParents")) {
            this.showingValueForOpenedParent = false;
            return;
        }
        if (!rowNode.groupData) {
            this.showingValueForOpenedParent = false;
            return;
        }
        const showingGroupNode = rowNode.rowGroupColumn != null;
        if (showingGroupNode) {
            const keyOfGroupingColumn = rowNode.rowGroupColumn.getId();
            const configuredToShowThisGroupLevel = column.isRowGroupDisplayed(keyOfGroupingColumn);
            if (configuredToShowThisGroupLevel) {
                this.showingValueForOpenedParent = false;
                return;
            }
        }
        const valPresent = rowNode.groupData[column.getId()] != null;
        this.showingValueForOpenedParent = valPresent;
    }
    addValueElement() {
        if (this.displayedGroupNode.footer) this.addFooterValue();
        else {
            this.addGroupValue();
            this.addChildCount();
        }
    }
    addGroupValue() {
        var _a;
        const paramsAdjusted = this.adjustParamsWithDetailsFromRelatedColumn();
        const innerCompDetails = this.getInnerCompDetails(paramsAdjusted);
        const { valueFormatted: valueFormatted, value: value } = paramsAdjusted;
        let valueWhenNoRenderer = valueFormatted;
        if (valueWhenNoRenderer == null) {
            const isGroupColForNode = this.displayedGroupNode.rowGroupColumn && ((_a = this.params.column) == null ? void 0 : _a.isRowGroupDisplayed(this.displayedGroupNode.rowGroupColumn.getId()));
            if (this.displayedGroupNode.key === "" && this.displayedGroupNode.group && isGroupColForNode) {
                const localeTextFunc = this.localeService.getLocaleTextFunc();
                valueWhenNoRenderer = localeTextFunc("blanks", "(Blanks)");
            } else valueWhenNoRenderer = value != null ? value : null;
        }
        this.comp.setInnerRenderer(innerCompDetails, valueWhenNoRenderer);
    }
    adjustParamsWithDetailsFromRelatedColumn() {
        const relatedColumn = this.displayedGroupNode.rowGroupColumn;
        const column = this.params.column;
        if (!relatedColumn) return this.params;
        const notFullWidth = column != null;
        if (notFullWidth) {
            const showingThisRowGroup = column.isRowGroupDisplayed(relatedColumn.getId());
            if (!showingThisRowGroup) return this.params;
        }
        const params = this.params;
        const { value: value, node: node } = this.params;
        const valueFormatted = this.valueService.formatValue(relatedColumn, node, value);
        const paramsAdjusted = $437b23f6a393c3bf$var$__spreadProps($437b23f6a393c3bf$var$__spreadValues({}, params), {
            valueFormatted: valueFormatted
        });
        return paramsAdjusted;
    }
    addFooterValue() {
        let footerValueGetter = this.params.totalValueGetter;
        if (!footerValueGetter) {
            const legacyGetter = this.params.footerValueGetter;
            if (legacyGetter) {
                footerValueGetter = legacyGetter;
                $437b23f6a393c3bf$var$warnOnce("As of v31.3, footerValueGetter is deprecated. Use `totalValueGetter` instead.");
            }
        }
        let footerValue = "";
        if (footerValueGetter) {
            const paramsClone = $437b23f6a393c3bf$var$cloneObject(this.params);
            paramsClone.value = this.params.value;
            if (typeof footerValueGetter === "function") footerValue = footerValueGetter(paramsClone);
            else if (typeof footerValueGetter === "string") footerValue = this.expressionService.evaluate(footerValueGetter, paramsClone);
            else console.warn("AG Grid: footerValueGetter should be either a function or a string (expression)");
        } else {
            const localeTextFunc = this.localeService.getLocaleTextFunc();
            const footerTotalPrefix = localeTextFunc("footerTotal", "Total");
            footerValue = footerTotalPrefix + " " + (this.params.value != null ? this.params.value : "");
        }
        const innerCompDetails = this.getInnerCompDetails(this.params);
        this.comp.setInnerRenderer(innerCompDetails, footerValue);
    }
    getInnerCompDetails(params) {
        if (params.fullWidth) return this.userComponentFactory.getFullWidthGroupRowInnerCellRenderer(this.gos.get("groupRowRendererParams"), params);
        const innerCompDetails = this.userComponentFactory.getInnerRendererDetails(params, params);
        const isGroupRowRenderer = (details)=>details && details.componentClass == this.compClass;
        if (innerCompDetails && !isGroupRowRenderer(innerCompDetails)) return innerCompDetails;
        const relatedColumn = this.displayedGroupNode.rowGroupColumn;
        const relatedColDef = relatedColumn ? relatedColumn.getColDef() : void 0;
        if (!relatedColDef) return;
        const relatedCompDetails = this.userComponentFactory.getCellRendererDetails(relatedColDef, params);
        if (relatedCompDetails && !isGroupRowRenderer(relatedCompDetails)) return relatedCompDetails;
        if (isGroupRowRenderer(relatedCompDetails) && relatedColDef.cellRendererParams && relatedColDef.cellRendererParams.innerRenderer) {
            const res = this.userComponentFactory.getInnerRendererDetails(relatedColDef.cellRendererParams, params);
            return res;
        }
    }
    addChildCount() {
        if (this.params.suppressCount) return;
        this.addManagedListener(this.displayedGroupNode, $437b23f6a393c3bf$export$6af91cd58ec2edf9.EVENT_ALL_CHILDREN_COUNT_CHANGED, this.updateChildCount.bind(this));
        this.updateChildCount();
    }
    updateChildCount() {
        const allChildrenCount = this.displayedGroupNode.allChildrenCount;
        const showingGroupForThisNode = this.isShowRowGroupForThisRow();
        const showCount = showingGroupForThisNode && allChildrenCount != null && allChildrenCount >= 0;
        const countString = showCount ? `(${allChildrenCount})` : ``;
        this.comp.setChildCount(countString);
    }
    isShowRowGroupForThisRow() {
        if (this.gos.get("treeData")) return true;
        const rowGroupColumn = this.displayedGroupNode.rowGroupColumn;
        if (!rowGroupColumn) return false;
        const column = this.params.column;
        const thisColumnIsInterested = column == null || column.isRowGroupDisplayed(rowGroupColumn.getId());
        return thisColumnIsInterested;
    }
    addExpandAndContract() {
        var _a;
        const params = this.params;
        const eExpandedIcon = $437b23f6a393c3bf$var$createIconNoSpan("groupExpanded", this.gos, null);
        const eContractedIcon = $437b23f6a393c3bf$var$createIconNoSpan("groupContracted", this.gos, null);
        if (eExpandedIcon) this.eExpanded.appendChild(eExpandedIcon);
        if (eContractedIcon) this.eContracted.appendChild(eContractedIcon);
        const eGroupCell = params.eGridCell;
        const isDoubleClickEdit = ((_a = this.params.column) == null ? void 0 : _a.isCellEditable(params.node)) && this.gos.get("enableGroupEdit");
        if (!isDoubleClickEdit && this.isExpandable() && !params.suppressDoubleClickExpand) this.addManagedListener(eGroupCell, "dblclick", this.onCellDblClicked.bind(this));
        this.addManagedListener(this.eExpanded, "click", this.onExpandClicked.bind(this));
        this.addManagedListener(this.eContracted, "click", this.onExpandClicked.bind(this));
        this.addManagedListener(eGroupCell, "keydown", this.onKeyDown.bind(this));
        this.addManagedListener(params.node, $437b23f6a393c3bf$export$6af91cd58ec2edf9.EVENT_EXPANDED_CHANGED, this.showExpandAndContractIcons.bind(this));
        this.showExpandAndContractIcons();
        const expandableChangedListener = this.onRowNodeIsExpandableChanged.bind(this);
        this.addManagedListener(this.displayedGroupNode, $437b23f6a393c3bf$export$6af91cd58ec2edf9.EVENT_ALL_CHILDREN_COUNT_CHANGED, expandableChangedListener);
        this.addManagedListener(this.displayedGroupNode, $437b23f6a393c3bf$export$6af91cd58ec2edf9.EVENT_MASTER_CHANGED, expandableChangedListener);
        this.addManagedListener(this.displayedGroupNode, $437b23f6a393c3bf$export$6af91cd58ec2edf9.EVENT_GROUP_CHANGED, expandableChangedListener);
        this.addManagedListener(this.displayedGroupNode, $437b23f6a393c3bf$export$6af91cd58ec2edf9.EVENT_HAS_CHILDREN_CHANGED, expandableChangedListener);
    }
    onExpandClicked(mouseEvent) {
        if ($437b23f6a393c3bf$var$isStopPropagationForAgGrid(mouseEvent)) return;
        $437b23f6a393c3bf$var$stopPropagationForAgGrid(mouseEvent);
        this.onExpandOrContract(mouseEvent);
    }
    onExpandOrContract(e) {
        const rowNode = this.displayedGroupNode;
        const nextExpandState = !rowNode.expanded;
        if (!nextExpandState && rowNode.sticky) this.scrollToStickyNode(rowNode);
        rowNode.setExpanded(nextExpandState, e);
    }
    scrollToStickyNode(rowNode) {
        const gridBodyCtrl = this.ctrlsService.getGridBodyCtrl();
        const scrollFeature = gridBodyCtrl.getScrollFeature();
        scrollFeature.setVerticalScrollPosition(rowNode.rowTop - rowNode.stickyRowTop);
    }
    isExpandable() {
        if (this.showingValueForOpenedParent) return true;
        const rowNode = this.displayedGroupNode;
        const reducedLeafNode = this.columnModel.isPivotMode() && rowNode.leafGroup;
        const expandableGroup = rowNode.isExpandable() && !rowNode.footer && !reducedLeafNode;
        if (!expandableGroup) return false;
        const column = this.params.column;
        const displayingForOneColumnOnly = column != null && typeof column.getColDef().showRowGroup === "string";
        if (displayingForOneColumnOnly) {
            const showing = this.isShowRowGroupForThisRow();
            return showing;
        }
        return true;
    }
    showExpandAndContractIcons() {
        const { params: params, displayedGroupNode: displayedGroup, columnModel: columnModel } = this;
        const { node: node } = params;
        const isExpandable = this.isExpandable();
        if (isExpandable) {
            const expanded = this.showingValueForOpenedParent ? true : node.expanded;
            this.comp.setExpandedDisplayed(expanded);
            this.comp.setContractedDisplayed(!expanded);
        } else {
            this.comp.setExpandedDisplayed(false);
            this.comp.setContractedDisplayed(false);
        }
        const pivotMode = columnModel.isPivotMode();
        const pivotModeAndLeafGroup = pivotMode && displayedGroup.leafGroup;
        const addExpandableCss = isExpandable && !pivotModeAndLeafGroup;
        const isTotalFooterNode = node.footer && node.level === -1;
        this.comp.addOrRemoveCssClass("ag-cell-expandable", addExpandableCss);
        this.comp.addOrRemoveCssClass("ag-row-group", addExpandableCss);
        if (pivotMode) this.comp.addOrRemoveCssClass("ag-pivot-leaf-group", pivotModeAndLeafGroup);
        else if (!isTotalFooterNode) this.comp.addOrRemoveCssClass("ag-row-group-leaf-indent", !addExpandableCss);
    }
    onRowNodeIsExpandableChanged() {
        this.showExpandAndContractIcons();
        this.setIndent();
        this.refreshAriaExpanded();
    }
    setupIndent() {
        const node = this.params.node;
        const suppressPadding = this.params.suppressPadding;
        if (!suppressPadding) {
            this.addManagedListener(node, $437b23f6a393c3bf$export$6af91cd58ec2edf9.EVENT_UI_LEVEL_CHANGED, this.setIndent.bind(this));
            this.setIndent();
        }
    }
    setIndent() {
        if (this.gos.get("groupHideOpenParents")) return;
        const params = this.params;
        const rowNode = params.node;
        const fullWithRow = !!params.colDef;
        const treeData = this.gos.get("treeData");
        const manyDimensionThisColumn = !fullWithRow || treeData || params.colDef.showRowGroup === true;
        const paddingCount = manyDimensionThisColumn ? rowNode.uiLevel : 0;
        if (this.indentClass) this.comp.addOrRemoveCssClass(this.indentClass, false);
        this.indentClass = "ag-row-group-indent-" + paddingCount;
        this.comp.addOrRemoveCssClass(this.indentClass, true);
    }
    addFullWidthRowDraggerIfNeeded() {
        if (!this.params.fullWidth || !this.params.rowDrag) return;
        const rowDragComp = new $437b23f6a393c3bf$var$RowDragComp(()=>this.params.value, this.params.node);
        this.createManagedBean(rowDragComp, this.context);
        this.eGui.insertAdjacentElement("afterbegin", rowDragComp.getGui());
    }
    isUserWantsSelected() {
        const paramsCheckbox = this.params.checkbox;
        return typeof paramsCheckbox === "function" || paramsCheckbox === true;
    }
    addCheckboxIfNeeded() {
        const rowNode = this.displayedGroupNode;
        const checkboxNeeded = this.isUserWantsSelected() && // footers cannot be selected
        !rowNode.footer && // pinned rows cannot be selected
        !rowNode.rowPinned && // details cannot be selected
        !rowNode.detail;
        if (checkboxNeeded) {
            const cbSelectionComponent = new $437b23f6a393c3bf$export$b54c7a6db4674fde();
            this.getContext().createBean(cbSelectionComponent);
            cbSelectionComponent.init({
                rowNode: this.params.node,
                // when groupHideOpenParents = true and group expanded, we want the checkbox to refer to leaf node state (not group node state)
                column: this.params.column,
                overrides: {
                    isVisible: this.params.checkbox,
                    callbackParams: this.params,
                    removeHidden: true
                }
            });
            this.eCheckbox.appendChild(cbSelectionComponent.getGui());
            this.addDestroyFunc(()=>this.getContext().destroyBean(cbSelectionComponent));
        }
        this.comp.setCheckboxVisible(checkboxNeeded);
    }
    onKeyDown(event) {
        const isEnterKey = event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER;
        if (!isEnterKey || this.params.suppressEnterExpand) return;
        const cellEditable = this.params.column && this.params.column.isCellEditable(this.params.node);
        if (cellEditable) return;
        this.onExpandOrContract(event);
    }
    onCellDblClicked(mouseEvent) {
        if ($437b23f6a393c3bf$var$isStopPropagationForAgGrid(mouseEvent)) return;
        const targetIsExpandIcon = $437b23f6a393c3bf$var$isElementInEventPath(this.eExpanded, mouseEvent) || $437b23f6a393c3bf$var$isElementInEventPath(this.eContracted, mouseEvent);
        if (!targetIsExpandIcon) this.onExpandOrContract(mouseEvent);
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("expressionService")
], $437b23f6a393c3bf$export$629e29df0ab4c80.prototype, "expressionService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("valueService")
], $437b23f6a393c3bf$export$629e29df0ab4c80.prototype, "valueService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnModel")
], $437b23f6a393c3bf$export$629e29df0ab4c80.prototype, "columnModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("userComponentFactory")
], $437b23f6a393c3bf$export$629e29df0ab4c80.prototype, "userComponentFactory", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("ctrlsService")
], $437b23f6a393c3bf$export$629e29df0ab4c80.prototype, "ctrlsService", 2);
// community-modules/core/src/rendering/cellRenderers/groupCellRenderer.ts
var $437b23f6a393c3bf$var$_GroupCellRenderer = class _GroupCellRenderer extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super(_GroupCellRenderer.TEMPLATE);
    }
    init(params) {
        const compProxy = {
            setInnerRenderer: (compDetails, valueToDisplay)=>this.setRenderDetails(compDetails, valueToDisplay),
            setChildCount: (count)=>this.eChildCount.textContent = count,
            addOrRemoveCssClass: (cssClass, value)=>this.addOrRemoveCssClass(cssClass, value),
            setContractedDisplayed: (expanded)=>$437b23f6a393c3bf$var$setDisplayed(this.eContracted, expanded),
            setExpandedDisplayed: (expanded)=>$437b23f6a393c3bf$var$setDisplayed(this.eExpanded, expanded),
            setCheckboxVisible: (visible)=>this.eCheckbox.classList.toggle("ag-invisible", !visible)
        };
        const ctrl = this.createManagedBean(new $437b23f6a393c3bf$export$629e29df0ab4c80());
        const fullWidth = !params.colDef;
        const eGui = this.getGui();
        ctrl.init(compProxy, eGui, this.eCheckbox, this.eExpanded, this.eContracted, this.constructor, params);
        if (fullWidth) $437b23f6a393c3bf$var$setAriaRole(eGui, ctrl.getCellAriaRole());
    }
    setRenderDetails(compDetails, valueToDisplay) {
        if (compDetails) {
            const componentPromise = compDetails.newAgStackInstance();
            if (!componentPromise) return;
            componentPromise.then((comp)=>{
                if (!comp) return;
                const destroyComp = ()=>this.context.destroyBean(comp);
                if (this.isAlive()) {
                    this.eValue.appendChild(comp.getGui());
                    this.addDestroyFunc(destroyComp);
                } else destroyComp();
            });
        } else this.eValue.innerText = valueToDisplay;
    }
    // this is a user component, and IComponent has "public destroy()" as part of the interface.
    // so we need to have public here instead of private or protected
    destroy() {
        this.getContext().destroyBean(this.innerCellRenderer);
        super.destroy();
    }
    refresh() {
        return false;
    }
};
$437b23f6a393c3bf$var$_GroupCellRenderer.TEMPLATE = /* html */ `<span class="ag-cell-wrapper">
            <span class="ag-group-expanded" ref="eExpanded"></span>
            <span class="ag-group-contracted" ref="eContracted"></span>
            <span class="ag-group-checkbox ag-invisible" ref="eCheckbox"></span>
            <span class="ag-group-value" ref="eValue"></span>
            <span class="ag-group-child-count" ref="eChildCount"></span>
        </span>`;
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eExpanded")
], $437b23f6a393c3bf$var$_GroupCellRenderer.prototype, "eExpanded", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eContracted")
], $437b23f6a393c3bf$var$_GroupCellRenderer.prototype, "eContracted", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eCheckbox")
], $437b23f6a393c3bf$var$_GroupCellRenderer.prototype, "eCheckbox", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eValue")
], $437b23f6a393c3bf$var$_GroupCellRenderer.prototype, "eValue", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eChildCount")
], $437b23f6a393c3bf$var$_GroupCellRenderer.prototype, "eChildCount", 2);
var $437b23f6a393c3bf$export$ad98892c9ca039a2 = $437b23f6a393c3bf$var$_GroupCellRenderer;
// community-modules/core/src/rendering/cellRenderers/loadingCellRenderer.ts
var $437b23f6a393c3bf$var$_LoadingCellRenderer = class _LoadingCellRenderer extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super(_LoadingCellRenderer.TEMPLATE);
    }
    init(params) {
        params.node.failedLoad ? this.setupFailed() : this.setupLoading();
    }
    setupFailed() {
        const localeTextFunc = this.localeService.getLocaleTextFunc();
        this.eLoadingText.innerText = localeTextFunc("loadingError", "ERR");
    }
    setupLoading() {
        const eLoadingIcon = $437b23f6a393c3bf$var$createIconNoSpan("groupLoading", this.gos, null);
        if (eLoadingIcon) this.eLoadingIcon.appendChild(eLoadingIcon);
        const localeTextFunc = this.localeService.getLocaleTextFunc();
        this.eLoadingText.innerText = localeTextFunc("loadingOoo", "Loading");
    }
    refresh(params) {
        return false;
    }
    // this is a user component, and IComponent has "public destroy()" as part of the interface.
    // so we need to override destroy() just to make the method public.
    destroy() {
        super.destroy();
    }
};
$437b23f6a393c3bf$var$_LoadingCellRenderer.TEMPLATE = `<div class="ag-loading">
            <span class="ag-loading-icon" ref="eLoadingIcon"></span>
            <span class="ag-loading-text" ref="eLoadingText"></span>
        </div>`;
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eLoadingIcon")
], $437b23f6a393c3bf$var$_LoadingCellRenderer.prototype, "eLoadingIcon", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eLoadingText")
], $437b23f6a393c3bf$var$_LoadingCellRenderer.prototype, "eLoadingText", 2);
var $437b23f6a393c3bf$var$LoadingCellRenderer = $437b23f6a393c3bf$var$_LoadingCellRenderer;
// community-modules/core/src/rendering/cellRenderers/skeletonCellRenderer.ts
var $437b23f6a393c3bf$var$_SkeletonCellRenderer = class _SkeletonCellRenderer extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super(_SkeletonCellRenderer.TEMPLATE);
    }
    init(params) {
        const id = `ag-cell-skeleton-renderer-${this.getCompId()}`;
        this.getGui().setAttribute("id", id);
        this.addDestroyFunc(()=>$437b23f6a393c3bf$var$setAriaLabelledBy(params.eParentOfValue));
        $437b23f6a393c3bf$var$setAriaLabelledBy(params.eParentOfValue, id);
        params.node.failedLoad ? this.setupFailed() : this.setupLoading();
    }
    setupFailed() {
        const localeTextFunc = this.localeService.getLocaleTextFunc();
        this.getGui().innerText = localeTextFunc("loadingError", "ERR");
        const ariaFailed = localeTextFunc("ariaSkeletonCellLoadingFailed", "Row failed to load");
        $437b23f6a393c3bf$var$setAriaLabel(this.getGui(), ariaFailed);
    }
    setupLoading() {
        const eDocument = this.gos.getDocument();
        const skeletonEffect = eDocument.createElement("div");
        skeletonEffect.classList.add("ag-skeleton-effect");
        this.getGui().appendChild(skeletonEffect);
        const localeTextFunc = this.localeService.getLocaleTextFunc();
        const ariaLoading = localeTextFunc("ariaSkeletonCellLoading", "Row data is loading");
        $437b23f6a393c3bf$var$setAriaLabel(this.getGui(), ariaLoading);
    }
    refresh(params) {
        return false;
    }
    // this is a user component, and IComponent has "public destroy()" as part of the interface.
    // so we need to override destroy() just to make the method public.
    destroy() {
        super.destroy();
    }
};
$437b23f6a393c3bf$var$_SkeletonCellRenderer.TEMPLATE = `<div class="ag-skeleton-container"></div>`;
var $437b23f6a393c3bf$var$SkeletonCellRenderer = $437b23f6a393c3bf$var$_SkeletonCellRenderer;
// community-modules/core/src/rendering/overlays/loadingOverlayComponent.ts
var $437b23f6a393c3bf$var$_LoadingOverlayComponent = class _LoadingOverlayComponent extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super();
    }
    // this is a user component, and IComponent has "public destroy()" as part of the interface.
    // so we need to override destroy() just to make the method public.
    destroy() {
        super.destroy();
    }
    init(params) {
        const customTemplate = this.gos.get("overlayLoadingTemplate");
        this.setTemplate(customTemplate != null ? customTemplate : _LoadingOverlayComponent.DEFAULT_LOADING_OVERLAY_TEMPLATE);
        if (!customTemplate) {
            const localeTextFunc = this.localeService.getLocaleTextFunc();
            setTimeout(()=>{
                this.getGui().textContent = localeTextFunc("loadingOoo", "Loading...");
            });
        }
    }
};
$437b23f6a393c3bf$var$_LoadingOverlayComponent.DEFAULT_LOADING_OVERLAY_TEMPLATE = /* html */ `<span aria-live="polite" aria-atomic="true" class="ag-overlay-loading-center"></span>`;
var $437b23f6a393c3bf$var$LoadingOverlayComponent = $437b23f6a393c3bf$var$_LoadingOverlayComponent;
// community-modules/core/src/rendering/overlays/noRowsOverlayComponent.ts
var $437b23f6a393c3bf$var$_NoRowsOverlayComponent = class _NoRowsOverlayComponent extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super();
    }
    // this is a user component, and IComponent has "public destroy()" as part of the interface.
    // so we need to override destroy() just to make the method public.
    destroy() {
        super.destroy();
    }
    init(params) {
        const customTemplate = this.gos.get("overlayNoRowsTemplate");
        this.setTemplate(customTemplate != null ? customTemplate : _NoRowsOverlayComponent.DEFAULT_NO_ROWS_TEMPLATE);
        if (!customTemplate) {
            const localeTextFunc = this.localeService.getLocaleTextFunc();
            setTimeout(()=>{
                this.getGui().textContent = localeTextFunc("noRowsToShow", "No Rows To Show");
            });
        }
    }
};
$437b23f6a393c3bf$var$_NoRowsOverlayComponent.DEFAULT_NO_ROWS_TEMPLATE = /* html */ `<span class="ag-overlay-no-rows-center"></span>`;
var $437b23f6a393c3bf$var$NoRowsOverlayComponent = $437b23f6a393c3bf$var$_NoRowsOverlayComponent;
// community-modules/core/src/rendering/tooltipComponent.ts
var $437b23f6a393c3bf$var$TooltipComponent = class extends $437b23f6a393c3bf$export$9fac2d040f3ed438 {
    constructor(){
        super(/* html */ `<div class="ag-tooltip"></div>`);
    }
    // will need to type params
    init(params) {
        const { value: value } = params;
        this.getGui().textContent = $437b23f6a393c3bf$var$escapeString(value, true);
    }
};
// community-modules/core/src/rendering/cellEditors/numberCellEditor.ts
var $437b23f6a393c3bf$var$NumberCellEditorInput = class {
    getTemplate() {
        return /* html */ `<ag-input-number-field class="ag-cell-editor" ref="eInput"></ag-input-number-field>`;
    }
    init(eInput, params) {
        this.eInput = eInput;
        this.params = params;
        if (params.max != null) eInput.setMax(params.max);
        if (params.min != null) eInput.setMin(params.min);
        if (params.precision != null) eInput.setPrecision(params.precision);
        if (params.step != null) eInput.setStep(params.step);
        const inputEl = eInput.getInputElement();
        if (params.preventStepping) eInput.addManagedListener(inputEl, "keydown", this.preventStepping);
        else if (params.showStepperButtons) inputEl.classList.add("ag-number-field-input-stepper");
    }
    preventStepping(e) {
        if (e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP || e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN) e.preventDefault();
    }
    getValue() {
        const value = this.eInput.getValue();
        if (!$437b23f6a393c3bf$var$exists(value) && !$437b23f6a393c3bf$var$exists(this.params.value)) return this.params.value;
        let parsedValue = this.params.parseValue(value);
        if (parsedValue == null) return parsedValue;
        if (typeof parsedValue === "string") {
            if (parsedValue === "") return null;
            parsedValue = Number(parsedValue);
        }
        return isNaN(parsedValue) ? null : parsedValue;
    }
    getStartValue() {
        return this.params.value;
    }
};
var $437b23f6a393c3bf$export$b0b5b22313882d92 = class extends $437b23f6a393c3bf$var$SimpleCellEditor {
    constructor(){
        super(new $437b23f6a393c3bf$var$NumberCellEditorInput());
    }
};
// community-modules/core/src/rendering/cellEditors/dateCellEditor.ts
var $437b23f6a393c3bf$var$DateCellEditorInput = class {
    getTemplate() {
        return /* html */ `<ag-input-date-field class="ag-cell-editor" ref="eInput"></ag-input-date-field>`;
    }
    init(eInput, params) {
        this.eInput = eInput;
        this.params = params;
        if (params.min != null) eInput.setMin(params.min);
        if (params.max != null) eInput.setMax(params.max);
        if (params.step != null) eInput.setStep(params.step);
    }
    getValue() {
        const value = this.eInput.getDate();
        if (!$437b23f6a393c3bf$var$exists(value) && !$437b23f6a393c3bf$var$exists(this.params.value)) return this.params.value;
        return value != null ? value : null;
    }
    getStartValue() {
        const { value: value } = this.params;
        if (!(value instanceof Date)) return void 0;
        return $437b23f6a393c3bf$var$serialiseDate(value, false);
    }
};
var $437b23f6a393c3bf$export$e458dd9c8f847882 = class extends $437b23f6a393c3bf$var$SimpleCellEditor {
    constructor(){
        super(new $437b23f6a393c3bf$var$DateCellEditorInput());
    }
};
// community-modules/core/src/rendering/cellEditors/dateStringCellEditor.ts
var $437b23f6a393c3bf$var$DateStringCellEditorInput = class {
    constructor(getDataTypeService){
        this.getDataTypeService = getDataTypeService;
    }
    getTemplate() {
        return /* html */ `<ag-input-date-field class="ag-cell-editor" ref="eInput"></ag-input-date-field>`;
    }
    init(eInput, params) {
        this.eInput = eInput;
        this.params = params;
        if (params.min != null) eInput.setMin(params.min);
        if (params.max != null) eInput.setMax(params.max);
        if (params.step != null) eInput.setStep(params.step);
    }
    getValue() {
        const value = this.formatDate(this.eInput.getDate());
        if (!$437b23f6a393c3bf$var$exists(value) && !$437b23f6a393c3bf$var$exists(this.params.value)) return this.params.value;
        return this.params.parseValue(value != null ? value : "");
    }
    getStartValue() {
        var _a, _b;
        return $437b23f6a393c3bf$var$serialiseDate((_b = this.parseDate((_a = this.params.value) != null ? _a : void 0)) != null ? _b : null, false);
    }
    parseDate(value) {
        return this.getDataTypeService().getDateParserFunction(this.params.column)(value);
    }
    formatDate(value) {
        return this.getDataTypeService().getDateFormatterFunction(this.params.column)(value);
    }
};
var $437b23f6a393c3bf$export$54060a84075c35d1 = class extends $437b23f6a393c3bf$var$SimpleCellEditor {
    constructor(){
        super(new $437b23f6a393c3bf$var$DateStringCellEditorInput(()=>this.dataTypeService));
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("dataTypeService")
], $437b23f6a393c3bf$export$54060a84075c35d1.prototype, "dataTypeService", 2);
// community-modules/core/src/rendering/cellRenderers/checkboxCellRenderer.ts
var $437b23f6a393c3bf$var$_CheckboxCellRenderer = class _CheckboxCellRenderer extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super(_CheckboxCellRenderer.TEMPLATE);
    }
    init(params) {
        this.params = params;
        this.updateCheckbox(params);
        const inputEl = this.eCheckbox.getInputElement();
        inputEl.setAttribute("tabindex", "-1");
        $437b23f6a393c3bf$var$setAriaLive(inputEl, "polite");
        this.addManagedListener(inputEl, "click", (event)=>{
            $437b23f6a393c3bf$var$stopPropagationForAgGrid(event);
            if (this.eCheckbox.isDisabled()) return;
            const isSelected = this.eCheckbox.getValue();
            this.onCheckboxChanged(isSelected);
        });
        this.addManagedListener(inputEl, "dblclick", (event)=>{
            $437b23f6a393c3bf$var$stopPropagationForAgGrid(event);
        });
        this.addManagedListener(this.params.eGridCell, "keydown", (event)=>{
            if (event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.SPACE && !this.eCheckbox.isDisabled()) {
                if (this.params.eGridCell === this.gos.getActiveDomElement()) this.eCheckbox.toggle();
                const isSelected = this.eCheckbox.getValue();
                this.onCheckboxChanged(isSelected);
                event.preventDefault();
            }
        });
    }
    refresh(params) {
        this.params = params;
        this.updateCheckbox(params);
        return true;
    }
    updateCheckbox(params) {
        var _a, _b, _c;
        let isSelected;
        let displayed = true;
        if (params.node.group && params.column) {
            const colId = params.column.getColId();
            if (colId.startsWith($437b23f6a393c3bf$export$a7016588c430dba6)) isSelected = params.value == null || params.value === "" ? void 0 : params.value === "true";
            else if (params.node.aggData && params.node.aggData[colId] !== void 0) isSelected = (_a = params.value) != null ? _a : void 0;
            else displayed = false;
        } else isSelected = (_b = params.value) != null ? _b : void 0;
        if (!displayed) {
            this.eCheckbox.setDisplayed(false);
            return;
        }
        this.eCheckbox.setValue(isSelected);
        const disabled = params.disabled != null ? params.disabled : !((_c = params.column) == null ? void 0 : _c.isCellEditable(params.node));
        this.eCheckbox.setDisabled(disabled);
        const translate = this.localeService.getLocaleTextFunc();
        const stateName = $437b23f6a393c3bf$var$getAriaCheckboxStateName(translate, isSelected);
        const ariaLabel = disabled ? stateName : `${translate("ariaToggleCellValue", "Press SPACE to toggle cell value")} (${stateName})`;
        this.eCheckbox.setInputAriaLabel(ariaLabel);
    }
    onCheckboxChanged(isSelected) {
        const { column: column, node: node, rowIndex: rowIndex, value: value } = this.params;
        const eventStarted = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_CELL_EDITING_STARTED,
            column: column,
            colDef: column == null ? void 0 : column.getColDef(),
            data: node.data,
            node: node,
            rowIndex: rowIndex,
            rowPinned: node.rowPinned,
            value: value
        };
        this.eventService.dispatchEvent(eventStarted);
        const valueChanged = this.params.node.setDataValue(this.params.column, isSelected, "edit");
        const eventStopped = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_CELL_EDITING_STOPPED,
            column: column,
            colDef: column == null ? void 0 : column.getColDef(),
            data: node.data,
            node: node,
            rowIndex: rowIndex,
            rowPinned: node.rowPinned,
            value: value,
            oldValue: value,
            newValue: isSelected,
            valueChanged: valueChanged
        };
        this.eventService.dispatchEvent(eventStopped);
    }
};
$437b23f6a393c3bf$var$_CheckboxCellRenderer.TEMPLATE = /* html*/ `
        <div class="ag-cell-wrapper ag-checkbox-cell" role="presentation">
            <ag-checkbox role="presentation" ref="eCheckbox"></ag-checkbox>
        </div>`;
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eCheckbox")
], $437b23f6a393c3bf$var$_CheckboxCellRenderer.prototype, "eCheckbox", 2);
var $437b23f6a393c3bf$export$c3622544a1decc94 = $437b23f6a393c3bf$var$_CheckboxCellRenderer;
// community-modules/core/src/rendering/cellEditors/checkboxCellEditor.ts
var $437b23f6a393c3bf$export$64a4d9c7e8236d55 = class extends $437b23f6a393c3bf$export$9fac2d040f3ed438 {
    constructor(){
        super(/* html */ `
            <div class="ag-cell-wrapper ag-cell-edit-wrapper ag-checkbox-edit">
                <ag-checkbox role="presentation" ref="eCheckbox"></ag-checkbox>
            </div>`);
    }
    init(params) {
        var _a;
        this.params = params;
        const isSelected = (_a = params.value) != null ? _a : void 0;
        this.eCheckbox.setValue(isSelected);
        const inputEl = this.eCheckbox.getInputElement();
        inputEl.setAttribute("tabindex", "-1");
        this.setAriaLabel(isSelected);
        this.addManagedListener(this.eCheckbox, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_FIELD_VALUE_CHANGED, (event)=>this.setAriaLabel(event.selected));
    }
    getValue() {
        return this.eCheckbox.getValue();
    }
    focusIn() {
        this.eCheckbox.getFocusableElement().focus();
    }
    afterGuiAttached() {
        if (this.params.cellStartedEdit) this.focusIn();
    }
    isPopup() {
        return false;
    }
    setAriaLabel(isSelected) {
        const translate = this.localeService.getLocaleTextFunc();
        const stateName = $437b23f6a393c3bf$var$getAriaCheckboxStateName(translate, isSelected);
        const ariaLabel = translate("ariaToggleCellValue", "Press SPACE to toggle cell value");
        this.eCheckbox.setInputAriaLabel(`${ariaLabel} (${stateName})`);
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eCheckbox")
], $437b23f6a393c3bf$export$64a4d9c7e8236d55.prototype, "eCheckbox", 2);
// community-modules/core/src/widgets/agMenuItemRenderer.ts
var $437b23f6a393c3bf$export$66550b837708f888 = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super();
        this.setTemplate(/* html */ `<div></div>`);
    }
    init(params) {
        var _a;
        this.params = params;
        this.cssClassPrefix = (_a = this.params.cssClassPrefix) != null ? _a : "ag-menu-option";
        this.addIcon();
        this.addName();
        this.addShortcut();
        this.addSubMenu();
    }
    configureDefaults() {
        return true;
    }
    addIcon() {
        if (this.params.isCompact) return;
        const icon = $437b23f6a393c3bf$var$loadTemplate(/* html */ `<span ref="eIcon" class="${this.getClassName("part")} ${this.getClassName("icon")}" role="presentation"></span>`);
        if (this.params.checked) icon.appendChild($437b23f6a393c3bf$var$createIconNoSpan("check", this.gos));
        else if (this.params.icon) {
            if ($437b23f6a393c3bf$var$isNodeOrElement(this.params.icon)) icon.appendChild(this.params.icon);
            else if (typeof this.params.icon === "string") icon.innerHTML = this.params.icon;
            else console.warn("AG Grid: menu item icon must be DOM node or string");
        }
        this.getGui().appendChild(icon);
    }
    addName() {
        const name = $437b23f6a393c3bf$var$loadTemplate(/* html */ `<span ref="eName" class="${this.getClassName("part")} ${this.getClassName("text")}">${this.params.name || ""}</span>`);
        this.getGui().appendChild(name);
    }
    addShortcut() {
        if (this.params.isCompact) return;
        const shortcut = $437b23f6a393c3bf$var$loadTemplate(/* html */ `<span ref="eShortcut" class="${this.getClassName("part")} ${this.getClassName("shortcut")}">${this.params.shortcut || ""}</span>`);
        this.getGui().appendChild(shortcut);
    }
    addSubMenu() {
        const pointer = $437b23f6a393c3bf$var$loadTemplate(/* html */ `<span ref="ePopupPointer" class="${this.getClassName("part")} ${this.getClassName("popup-pointer")}"></span>`);
        const eGui = this.getGui();
        if (this.params.subMenu) {
            const iconName = this.gos.get("enableRtl") ? "smallLeft" : "smallRight";
            $437b23f6a393c3bf$var$setAriaExpanded(eGui, false);
            pointer.appendChild($437b23f6a393c3bf$var$createIconNoSpan(iconName, this.gos));
        }
        eGui.appendChild(pointer);
    }
    getClassName(suffix) {
        return `${this.cssClassPrefix}-${suffix}`;
    }
    destroy() {
        super.destroy();
    }
};
// community-modules/core/src/components/framework/userComponentRegistry.ts
var $437b23f6a393c3bf$export$84607ca0a5de10d3 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.agGridDefaults = {
            //date
            agDateInput: $437b23f6a393c3bf$var$DefaultDateComponent,
            //header
            agColumnHeader: $437b23f6a393c3bf$var$HeaderComp,
            agColumnGroupHeader: $437b23f6a393c3bf$var$HeaderGroupComp,
            agSortIndicator: $437b23f6a393c3bf$export$220e9505c6bd76f6,
            //floating filters
            agTextColumnFloatingFilter: $437b23f6a393c3bf$export$f856d88991b6b7f9,
            agNumberColumnFloatingFilter: $437b23f6a393c3bf$var$NumberFloatingFilter,
            agDateColumnFloatingFilter: $437b23f6a393c3bf$var$DateFloatingFilter,
            agReadOnlyFloatingFilter: $437b23f6a393c3bf$var$ReadOnlyFloatingFilter,
            // renderers
            agAnimateShowChangeCellRenderer: $437b23f6a393c3bf$export$6f4a45bae925df69,
            agAnimateSlideCellRenderer: $437b23f6a393c3bf$export$3915b8b8c907c2a,
            agGroupCellRenderer: $437b23f6a393c3bf$export$ad98892c9ca039a2,
            agGroupRowRenderer: $437b23f6a393c3bf$export$ad98892c9ca039a2,
            agLoadingCellRenderer: $437b23f6a393c3bf$var$LoadingCellRenderer,
            agSkeletonCellRenderer: $437b23f6a393c3bf$var$SkeletonCellRenderer,
            agCheckboxCellRenderer: $437b23f6a393c3bf$export$c3622544a1decc94,
            //editors
            agCellEditor: $437b23f6a393c3bf$export$6e94bf0a822a6a81,
            agTextCellEditor: $437b23f6a393c3bf$export$6e94bf0a822a6a81,
            agNumberCellEditor: $437b23f6a393c3bf$export$b0b5b22313882d92,
            agDateCellEditor: $437b23f6a393c3bf$export$e458dd9c8f847882,
            agDateStringCellEditor: $437b23f6a393c3bf$export$54060a84075c35d1,
            agSelectCellEditor: $437b23f6a393c3bf$export$638f87cb94a2e5dc,
            agLargeTextCellEditor: $437b23f6a393c3bf$export$98890d6e078b4910,
            agCheckboxCellEditor: $437b23f6a393c3bf$export$64a4d9c7e8236d55,
            //filter
            agTextColumnFilter: $437b23f6a393c3bf$export$bf4978b2dd458630,
            agNumberColumnFilter: $437b23f6a393c3bf$export$db99a591a1ce9821,
            agDateColumnFilter: $437b23f6a393c3bf$export$45c1765a9388d778,
            //overlays
            agLoadingOverlay: $437b23f6a393c3bf$var$LoadingOverlayComponent,
            agNoRowsOverlay: $437b23f6a393c3bf$var$NoRowsOverlayComponent,
            // tooltips
            agTooltipComponent: $437b23f6a393c3bf$var$TooltipComponent,
            // menu item
            agMenuItem: $437b23f6a393c3bf$export$66550b837708f888
        };
        /** Used to provide useful error messages if a user is trying to use an enterprise component without loading the module. */ this.enterpriseAgDefaultCompsModule = {
            agSetColumnFilter: "@ag-grid-enterprise/set-filter" /* SetFilterModule */ ,
            agSetColumnFloatingFilter: "@ag-grid-enterprise/set-filter" /* SetFilterModule */ ,
            agMultiColumnFilter: "@ag-grid-enterprise/multi-filter" /* MultiFilterModule */ ,
            agMultiColumnFloatingFilter: "@ag-grid-enterprise/multi-filter" /* MultiFilterModule */ ,
            agGroupColumnFilter: "@ag-grid-enterprise/row-grouping" /* RowGroupingModule */ ,
            agGroupColumnFloatingFilter: "@ag-grid-enterprise/row-grouping" /* RowGroupingModule */ ,
            agRichSelect: "@ag-grid-enterprise/rich-select" /* RichSelectModule */ ,
            agRichSelectCellEditor: "@ag-grid-enterprise/rich-select" /* RichSelectModule */ ,
            agDetailCellRenderer: "@ag-grid-enterprise/master-detail" /* MasterDetailModule */ ,
            agSparklineCellRenderer: "@ag-grid-enterprise/sparklines" /* SparklinesModule */ 
        };
        this.jsComps = {};
    }
    init() {
        const comps = this.gos.get("components");
        if (comps != null) $437b23f6a393c3bf$var$iterateObject(comps, (key, component)=>this.registerJsComponent(key, component));
    }
    registerDefaultComponent(name, component) {
        if (this.agGridDefaults[name]) {
            console.error(`Trying to overwrite a default component. You should call registerComponent`);
            return;
        }
        this.agGridDefaults[name] = component;
    }
    registerJsComponent(name, component) {
        this.jsComps[name] = component;
    }
    retrieve(propertyName, name) {
        const createResult = (component, componentFromFramework)=>({
                componentFromFramework: componentFromFramework,
                component: component
            });
        const registeredViaFrameworkComp = this.getFrameworkOverrides().frameworkComponent(name, this.gos.get("components"));
        if (registeredViaFrameworkComp != null) return createResult(registeredViaFrameworkComp, true);
        const jsComponent = this.jsComps[name];
        if (jsComponent) {
            const isFwkComp = this.getFrameworkOverrides().isFrameworkComponent(jsComponent);
            return createResult(jsComponent, isFwkComp);
        }
        const defaultComponent = this.agGridDefaults[name];
        if (defaultComponent) return createResult(defaultComponent, false);
        const moduleForComponent = this.enterpriseAgDefaultCompsModule[name];
        if (moduleForComponent) $437b23f6a393c3bf$export$dc053975cc7f6c11.__assertRegistered(moduleForComponent, `AG Grid '${propertyName}' component: ${name}`, this.context.getGridId());
        else $437b23f6a393c3bf$var$doOnce(()=>{
            this.warnAboutMissingComponent(propertyName, name);
        }, "MissingComp" + name);
        return null;
    }
    warnAboutMissingComponent(propertyName, componentName) {
        const validComponents = [
            // Don't include the old names / internals in potential suggestions
            ...Object.keys(this.agGridDefaults).filter((k)=>![
                    "agCellEditor",
                    "agGroupRowRenderer",
                    "agSortIndicator"
                ].includes(k)),
            ...Object.keys(this.jsComps)
        ];
        const suggestions = $437b23f6a393c3bf$var$fuzzySuggestions(componentName, validComponents, true, 0.8).values;
        console.warn(`AG Grid: Could not find '${componentName}' component. It was configured as "${propertyName}: '${componentName}'" but it wasn't found in the list of registered components.`);
        if (suggestions.length > 0) console.warn(`         Did you mean: [${suggestions.slice(0, 3)}]?`);
        console.warn(`If using a custom component check it has been registered as described in: ${this.getFrameworkOverrides().getDocLink("components/")}`);
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$export$84607ca0a5de10d3.prototype, "init", 1);
$437b23f6a393c3bf$export$84607ca0a5de10d3 = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("userComponentRegistry")
], $437b23f6a393c3bf$export$84607ca0a5de10d3);
// community-modules/core/src/components/framework/componentTypes.ts
var $437b23f6a393c3bf$var$DateComponent = {
    propertyName: "dateComponent",
    cellRenderer: false
};
var $437b23f6a393c3bf$var$HeaderComponent = {
    propertyName: "headerComponent",
    cellRenderer: false
};
var $437b23f6a393c3bf$var$HeaderGroupComponent = {
    propertyName: "headerGroupComponent",
    cellRenderer: false
};
var $437b23f6a393c3bf$var$CellRendererComponent = {
    propertyName: "cellRenderer",
    cellRenderer: true
};
var $437b23f6a393c3bf$var$LoadingCellRendererComponent = {
    propertyName: "loadingCellRenderer",
    cellRenderer: true
};
var $437b23f6a393c3bf$var$CellEditorComponent = {
    propertyName: "cellEditor",
    cellRenderer: false
};
var $437b23f6a393c3bf$var$InnerRendererComponent = {
    propertyName: "innerRenderer",
    cellRenderer: true
};
var $437b23f6a393c3bf$var$LoadingOverlayComponent2 = {
    propertyName: "loadingOverlayComponent",
    cellRenderer: false
};
var $437b23f6a393c3bf$var$NoRowsOverlayComponent2 = {
    propertyName: "noRowsOverlayComponent",
    cellRenderer: false
};
var $437b23f6a393c3bf$var$TooltipComponent2 = {
    propertyName: "tooltipComponent",
    cellRenderer: false
};
var $437b23f6a393c3bf$var$FilterComponent = {
    propertyName: "filter",
    cellRenderer: false
};
var $437b23f6a393c3bf$var$FloatingFilterComponent = {
    propertyName: "floatingFilterComponent",
    cellRenderer: false
};
var $437b23f6a393c3bf$var$ToolPanelComponent = {
    propertyName: "toolPanel",
    cellRenderer: false
};
var $437b23f6a393c3bf$var$StatusPanelComponent = {
    propertyName: "statusPanel",
    cellRenderer: false
};
var $437b23f6a393c3bf$var$FullWidth = {
    propertyName: "fullWidthCellRenderer",
    cellRenderer: true
};
var $437b23f6a393c3bf$var$FullWidthLoading = {
    propertyName: "loadingCellRenderer",
    cellRenderer: true
};
var $437b23f6a393c3bf$var$FullWidthGroup = {
    propertyName: "groupRowRenderer",
    cellRenderer: true
};
var $437b23f6a393c3bf$var$FullWidthDetail = {
    propertyName: "detailCellRenderer",
    cellRenderer: true
};
var $437b23f6a393c3bf$var$MenuItemComponent = {
    propertyName: "menuItem",
    cellRenderer: false
};
// community-modules/core/src/filter/floating/floatingFilterMapper.ts
var $437b23f6a393c3bf$export$9ff31c116240592 = class {
    static getFloatingFilterType(filterType) {
        return this.filterToFloatingFilterMapping[filterType];
    }
};
$437b23f6a393c3bf$export$9ff31c116240592.filterToFloatingFilterMapping = {
    set: "agSetColumnFloatingFilter",
    agSetColumnFilter: "agSetColumnFloatingFilter",
    multi: "agMultiColumnFloatingFilter",
    agMultiColumnFilter: "agMultiColumnFloatingFilter",
    group: "agGroupColumnFloatingFilter",
    agGroupColumnFilter: "agGroupColumnFloatingFilter",
    number: "agNumberColumnFloatingFilter",
    agNumberColumnFilter: "agNumberColumnFloatingFilter",
    date: "agDateColumnFloatingFilter",
    agDateColumnFilter: "agDateColumnFloatingFilter",
    text: "agTextColumnFloatingFilter",
    agTextColumnFilter: "agTextColumnFloatingFilter"
};
// community-modules/core/src/components/framework/userComponentFactory.ts
var $437b23f6a393c3bf$export$b32ef18681c5348a = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    getHeaderCompDetails(colDef, params) {
        return this.getCompDetails(colDef, $437b23f6a393c3bf$var$HeaderComponent, "agColumnHeader", params);
    }
    getHeaderGroupCompDetails(params) {
        const colGroupDef = params.columnGroup.getColGroupDef();
        return this.getCompDetails(colGroupDef, $437b23f6a393c3bf$var$HeaderGroupComponent, "agColumnGroupHeader", params);
    }
    // this one is unusual, as it can be LoadingCellRenderer, DetailCellRenderer, FullWidthCellRenderer or GroupRowRenderer.
    // so we have to pass the type in.
    getFullWidthCellRendererDetails(params) {
        return this.getCompDetails(this.gridOptions, $437b23f6a393c3bf$var$FullWidth, null, params, true);
    }
    getFullWidthLoadingCellRendererDetails(params) {
        return this.getCompDetails(this.gridOptions, $437b23f6a393c3bf$var$FullWidthLoading, "agLoadingCellRenderer", params, true);
    }
    getFullWidthGroupCellRendererDetails(params) {
        return this.getCompDetails(this.gridOptions, $437b23f6a393c3bf$var$FullWidthGroup, "agGroupRowRenderer", params, true);
    }
    getFullWidthDetailCellRendererDetails(params) {
        return this.getCompDetails(this.gridOptions, $437b23f6a393c3bf$var$FullWidthDetail, "agDetailCellRenderer", params, true);
    }
    // CELL RENDERER
    getInnerRendererDetails(def, params) {
        return this.getCompDetails(def, $437b23f6a393c3bf$var$InnerRendererComponent, null, params);
    }
    getFullWidthGroupRowInnerCellRenderer(def, params) {
        return this.getCompDetails(def, $437b23f6a393c3bf$var$InnerRendererComponent, null, params);
    }
    getCellRendererDetails(def, params) {
        return this.getCompDetails(def, $437b23f6a393c3bf$var$CellRendererComponent, null, params);
    }
    getLoadingCellRendererDetails(def, params) {
        return this.getCompDetails(def, $437b23f6a393c3bf$var$LoadingCellRendererComponent, "agSkeletonCellRenderer", params, true);
    }
    // CELL EDITOR
    getCellEditorDetails(def, params) {
        return this.getCompDetails(def, $437b23f6a393c3bf$var$CellEditorComponent, "agCellEditor", params, true);
    }
    // FILTER
    getFilterDetails(def, params, defaultFilter) {
        return this.getCompDetails(def, $437b23f6a393c3bf$var$FilterComponent, defaultFilter, params, true);
    }
    getDateCompDetails(params) {
        return this.getCompDetails(this.gridOptions, $437b23f6a393c3bf$var$DateComponent, "agDateInput", params, true);
    }
    getLoadingOverlayCompDetails(params) {
        return this.getCompDetails(this.gridOptions, $437b23f6a393c3bf$var$LoadingOverlayComponent2, "agLoadingOverlay", params, true);
    }
    getNoRowsOverlayCompDetails(params) {
        return this.getCompDetails(this.gridOptions, $437b23f6a393c3bf$var$NoRowsOverlayComponent2, "agNoRowsOverlay", params, true);
    }
    getTooltipCompDetails(params) {
        return this.getCompDetails(params.colDef, $437b23f6a393c3bf$var$TooltipComponent2, "agTooltipComponent", params, true);
    }
    getSetFilterCellRendererDetails(def, params) {
        return this.getCompDetails(def, $437b23f6a393c3bf$var$CellRendererComponent, null, params);
    }
    getFloatingFilterCompDetails(def, params, defaultFloatingFilter) {
        return this.getCompDetails(def, $437b23f6a393c3bf$var$FloatingFilterComponent, defaultFloatingFilter, params);
    }
    getToolPanelCompDetails(toolPanelDef, params) {
        return this.getCompDetails(toolPanelDef, $437b23f6a393c3bf$var$ToolPanelComponent, null, params, true);
    }
    getStatusPanelCompDetails(def, params) {
        return this.getCompDetails(def, $437b23f6a393c3bf$var$StatusPanelComponent, null, params, true);
    }
    getMenuItemCompDetails(def, params) {
        return this.getCompDetails(def, $437b23f6a393c3bf$var$MenuItemComponent, "agMenuItem", params, true);
    }
    getCompDetails(defObject, type, defaultName, params, mandatory = false) {
        const { propertyName: propertyName, cellRenderer: cellRenderer } = type;
        let { compName: compName, jsComp: jsComp, fwComp: fwComp, paramsFromSelector: paramsFromSelector, popupFromSelector: popupFromSelector, popupPositionFromSelector: popupPositionFromSelector } = this.getCompKeys(defObject, type, params);
        const lookupFromRegistry = (key)=>{
            const item = this.userComponentRegistry.retrieve(propertyName, key);
            if (item) {
                jsComp = !item.componentFromFramework ? item.component : void 0;
                fwComp = item.componentFromFramework ? item.component : void 0;
            }
        };
        if (compName != null) lookupFromRegistry(compName);
        if (jsComp == null && fwComp == null && defaultName != null) lookupFromRegistry(defaultName);
        if (jsComp && cellRenderer && !this.agComponentUtils.doesImplementIComponent(jsComp)) jsComp = this.agComponentUtils.adaptFunction(propertyName, jsComp);
        if (!jsComp && !fwComp) {
            if (mandatory) console.error(`AG Grid: Could not find component ${compName}, did you forget to configure this component?`);
            return;
        }
        const paramsMerged = this.mergeParamsWithApplicationProvidedParams(defObject, type, params, paramsFromSelector);
        const componentFromFramework = jsComp == null;
        const componentClass = jsComp ? jsComp : fwComp;
        return {
            componentFromFramework: componentFromFramework,
            componentClass: componentClass,
            params: paramsMerged,
            type: type,
            popupFromSelector: popupFromSelector,
            popupPositionFromSelector: popupPositionFromSelector,
            newAgStackInstance: ()=>this.newAgStackInstance(componentClass, componentFromFramework, paramsMerged, type)
        };
    }
    getCompKeys(defObject, type, params) {
        const { propertyName: propertyName } = type;
        let compName;
        let jsComp;
        let fwComp;
        let paramsFromSelector;
        let popupFromSelector;
        let popupPositionFromSelector;
        if (defObject) {
            const defObjectAny = defObject;
            const selectorFunc = defObjectAny[propertyName + "Selector"];
            const selectorRes = selectorFunc ? selectorFunc(params) : null;
            const assignComp = (providedJsComp)=>{
                if (typeof providedJsComp === "string") compName = providedJsComp;
                else if (providedJsComp != null && providedJsComp !== true) {
                    const isFwkComp = this.getFrameworkOverrides().isFrameworkComponent(providedJsComp);
                    if (isFwkComp) fwComp = providedJsComp;
                    else jsComp = providedJsComp;
                }
            };
            if (selectorRes) {
                assignComp(selectorRes.component);
                paramsFromSelector = selectorRes.params;
                popupFromSelector = selectorRes.popup;
                popupPositionFromSelector = selectorRes.popupPosition;
            } else assignComp(defObjectAny[propertyName]);
        }
        return {
            compName: compName,
            jsComp: jsComp,
            fwComp: fwComp,
            paramsFromSelector: paramsFromSelector,
            popupFromSelector: popupFromSelector,
            popupPositionFromSelector: popupPositionFromSelector
        };
    }
    newAgStackInstance(ComponentClass, componentFromFramework, params, type) {
        const propertyName = type.propertyName;
        const jsComponent = !componentFromFramework;
        let instance;
        if (jsComponent) instance = new ComponentClass();
        else {
            const thisComponentConfig = this.componentMetadataProvider.retrieve(propertyName);
            instance = this.frameworkComponentWrapper.wrap(ComponentClass, thisComponentConfig.mandatoryMethodList, thisComponentConfig.optionalMethodList, type);
        }
        const deferredInit = this.initComponent(instance, params);
        if (deferredInit == null) return $437b23f6a393c3bf$export$30ec7836a4847721.resolve(instance);
        return deferredInit.then(()=>instance);
    }
    // used by Floating Filter
    mergeParamsWithApplicationProvidedParams(defObject, type, paramsFromGrid, paramsFromSelector = null) {
        const params = this.gos.getGridCommonParams();
        $437b23f6a393c3bf$var$mergeDeep(params, paramsFromGrid);
        const defObjectAny = defObject;
        const userParams = defObjectAny && defObjectAny[type.propertyName + "Params"];
        if (typeof userParams === "function") {
            const userParamsFromFunc = userParams(paramsFromGrid);
            $437b23f6a393c3bf$var$mergeDeep(params, userParamsFromFunc);
        } else if (typeof userParams === "object") $437b23f6a393c3bf$var$mergeDeep(params, userParams);
        $437b23f6a393c3bf$var$mergeDeep(params, paramsFromSelector);
        return params;
    }
    initComponent(component, params) {
        this.context.createBean(component);
        if (component.init == null) return;
        return component.init(params);
    }
    getDefaultFloatingFilterType(def, getFromDefault) {
        if (def == null) return null;
        let defaultFloatingFilterType = null;
        let { compName: compName, jsComp: jsComp, fwComp: fwComp } = this.getCompKeys(def, $437b23f6a393c3bf$var$FilterComponent);
        if (compName) defaultFloatingFilterType = $437b23f6a393c3bf$export$9ff31c116240592.getFloatingFilterType(compName);
        else {
            const usingDefaultFilter = jsComp == null && fwComp == null && def.filter === true;
            if (usingDefaultFilter) defaultFloatingFilterType = getFromDefault();
        }
        return defaultFloatingFilterType;
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("gridOptions")
], $437b23f6a393c3bf$export$b32ef18681c5348a.prototype, "gridOptions", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("agComponentUtils")
], $437b23f6a393c3bf$export$b32ef18681c5348a.prototype, "agComponentUtils", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("componentMetadataProvider")
], $437b23f6a393c3bf$export$b32ef18681c5348a.prototype, "componentMetadataProvider", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("userComponentRegistry")
], $437b23f6a393c3bf$export$b32ef18681c5348a.prototype, "userComponentRegistry", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$7acb7b24c478f9c6("frameworkComponentWrapper")
], $437b23f6a393c3bf$export$b32ef18681c5348a.prototype, "frameworkComponentWrapper", 2);
$437b23f6a393c3bf$export$b32ef18681c5348a = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("userComponentFactory")
], $437b23f6a393c3bf$export$b32ef18681c5348a);
// community-modules/core/src/interfaces/iExcelCreator.ts
var $437b23f6a393c3bf$export$1b4f0b0d179ae7d9 = /* @__PURE__ */ ((ExcelFactoryMode2)=>{
    ExcelFactoryMode2[ExcelFactoryMode2["SINGLE_SHEET"] = 0] = "SINGLE_SHEET";
    ExcelFactoryMode2[ExcelFactoryMode2["MULTI_SHEET"] = 1] = "MULTI_SHEET";
    return ExcelFactoryMode2;
})($437b23f6a393c3bf$export$1b4f0b0d179ae7d9 || {});
// community-modules/core/src/interfaces/iRowNode.ts
var $437b23f6a393c3bf$export$e879772ad3c0a0e = /* @__PURE__ */ ((RowHighlightPosition2)=>{
    RowHighlightPosition2[RowHighlightPosition2["Above"] = 0] = "Above";
    RowHighlightPosition2[RowHighlightPosition2["Below"] = 1] = "Below";
    return RowHighlightPosition2;
})($437b23f6a393c3bf$export$e879772ad3c0a0e || {});
// community-modules/core/src/autoScrollService.ts
var $437b23f6a393c3bf$export$c66bdc3d55a4f95 = class {
    constructor(params){
        this.tickingInterval = null;
        this.onScrollCallback = null;
        this.scrollContainer = params.scrollContainer;
        this.scrollHorizontally = params.scrollAxis.indexOf("x") !== -1;
        this.scrollVertically = params.scrollAxis.indexOf("y") !== -1;
        this.scrollByTick = params.scrollByTick != null ? params.scrollByTick : 20;
        if (params.onScrollCallback) this.onScrollCallback = params.onScrollCallback;
        if (this.scrollVertically) {
            this.getVerticalPosition = params.getVerticalPosition;
            this.setVerticalPosition = params.setVerticalPosition;
        }
        if (this.scrollHorizontally) {
            this.getHorizontalPosition = params.getHorizontalPosition;
            this.setHorizontalPosition = params.setHorizontalPosition;
        }
        this.shouldSkipVerticalScroll = params.shouldSkipVerticalScroll || (()=>false);
        this.shouldSkipHorizontalScroll = params.shouldSkipHorizontalScroll || (()=>false);
    }
    check(mouseEvent, forceSkipVerticalScroll = false) {
        const skipVerticalScroll = forceSkipVerticalScroll || this.shouldSkipVerticalScroll();
        if (skipVerticalScroll && this.shouldSkipHorizontalScroll()) return;
        const rect = this.scrollContainer.getBoundingClientRect();
        const scrollTick = this.scrollByTick;
        this.tickLeft = mouseEvent.clientX < rect.left + scrollTick;
        this.tickRight = mouseEvent.clientX > rect.right - scrollTick;
        this.tickUp = mouseEvent.clientY < rect.top + scrollTick && !skipVerticalScroll;
        this.tickDown = mouseEvent.clientY > rect.bottom - scrollTick && !skipVerticalScroll;
        if (this.tickLeft || this.tickRight || this.tickUp || this.tickDown) this.ensureTickingStarted();
        else this.ensureCleared();
    }
    ensureTickingStarted() {
        if (this.tickingInterval === null) {
            this.tickingInterval = window.setInterval(this.doTick.bind(this), 100);
            this.tickCount = 0;
        }
    }
    doTick() {
        this.tickCount++;
        let tickAmount;
        tickAmount = this.tickCount > 20 ? 200 : this.tickCount > 10 ? 80 : 40;
        if (this.scrollVertically) {
            const vScrollPosition = this.getVerticalPosition();
            if (this.tickUp) this.setVerticalPosition(vScrollPosition - tickAmount);
            if (this.tickDown) this.setVerticalPosition(vScrollPosition + tickAmount);
        }
        if (this.scrollHorizontally) {
            const hScrollPosition = this.getHorizontalPosition();
            if (this.tickLeft) this.setHorizontalPosition(hScrollPosition - tickAmount);
            if (this.tickRight) this.setHorizontalPosition(hScrollPosition + tickAmount);
        }
        if (this.onScrollCallback) this.onScrollCallback();
    }
    ensureCleared() {
        if (this.tickingInterval) {
            window.clearInterval(this.tickingInterval);
            this.tickingInterval = null;
        }
    }
};
// community-modules/core/src/gridBodyComp/rowDragFeature.ts
var $437b23f6a393c3bf$var$RowDragFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(eContainer){
        super();
        this.eContainer = eContainer;
    }
    postConstruct() {
        if (this.gos.isRowModelType("clientSide")) this.clientSideRowModel = this.rowModel;
        this.ctrlsService.whenReady((p)=>{
            const gridBodyCon = p.gridBodyCtrl;
            this.autoScrollService = new $437b23f6a393c3bf$export$c66bdc3d55a4f95({
                scrollContainer: gridBodyCon.getBodyViewportElement(),
                scrollAxis: "y",
                getVerticalPosition: ()=>gridBodyCon.getScrollFeature().getVScrollPosition().top,
                setVerticalPosition: (position)=>gridBodyCon.getScrollFeature().setVerticalScrollPosition(position),
                onScrollCallback: ()=>{
                    this.onDragging(this.lastDraggingEvent);
                }
            });
        });
    }
    getContainer() {
        return this.eContainer;
    }
    isInterestedIn(type) {
        return type === 2 /* RowDrag */ ;
    }
    getIconName() {
        const managedDrag = this.gos.get("rowDragManaged");
        if (managedDrag && this.shouldPreventRowMove()) return $437b23f6a393c3bf$export$3529111922becfa6.ICON_NOT_ALLOWED;
        return $437b23f6a393c3bf$export$3529111922becfa6.ICON_MOVE;
    }
    shouldPreventRowMove() {
        const rowGroupCols = this.columnModel.getRowGroupColumns();
        if (rowGroupCols.length) return true;
        const isFilterPresent = this.filterManager.isAnyFilterPresent();
        if (isFilterPresent) return true;
        const isSortActive = this.sortController.isSortActive();
        if (isSortActive) return true;
        return false;
    }
    getRowNodes(draggingEvent) {
        if (!this.isFromThisGrid(draggingEvent)) return draggingEvent.dragItem.rowNodes || [];
        const currentNode = draggingEvent.dragItem.rowNode;
        const isRowDragMultiRow = this.gos.get("rowDragMultiRow");
        if (isRowDragMultiRow) {
            const selectedNodes = [
                ...this.selectionService.getSelectedNodes()
            ].sort((a, b)=>{
                if (a.rowIndex == null || b.rowIndex == null) return 0;
                return this.getRowIndexNumber(a) - this.getRowIndexNumber(b);
            });
            if (selectedNodes.indexOf(currentNode) !== -1) return selectedNodes;
        }
        return [
            currentNode
        ];
    }
    onDragEnter(draggingEvent) {
        draggingEvent.dragItem.rowNodes = this.getRowNodes(draggingEvent);
        this.dispatchGridEvent($437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_DRAG_ENTER, draggingEvent);
        this.getRowNodes(draggingEvent).forEach((rowNode)=>{
            rowNode.setDragging(true);
        });
        this.onEnterOrDragging(draggingEvent);
    }
    onDragging(draggingEvent) {
        this.onEnterOrDragging(draggingEvent);
    }
    isFromThisGrid(draggingEvent) {
        const { dragSourceDomDataKey: dragSourceDomDataKey } = draggingEvent.dragSource;
        return dragSourceDomDataKey === this.gos.getDomDataKey();
    }
    isDropZoneWithinThisGrid(draggingEvent) {
        const gridBodyCon = this.ctrlsService.getGridBodyCtrl();
        const gridGui = gridBodyCon.getGui();
        const { dropZoneTarget: dropZoneTarget } = draggingEvent;
        return !gridGui.contains(dropZoneTarget);
    }
    onEnterOrDragging(draggingEvent) {
        this.dispatchGridEvent($437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_DRAG_MOVE, draggingEvent);
        this.lastDraggingEvent = draggingEvent;
        const pixel = this.mouseEventService.getNormalisedPosition(draggingEvent).y;
        const managedDrag = this.gos.get("rowDragManaged");
        if (managedDrag) this.doManagedDrag(draggingEvent, pixel);
        this.autoScrollService.check(draggingEvent.event);
    }
    doManagedDrag(draggingEvent, pixel) {
        const isFromThisGrid = this.isFromThisGrid(draggingEvent);
        const managedDrag = this.gos.get("rowDragManaged");
        const rowNodes = draggingEvent.dragItem.rowNodes;
        if (managedDrag && this.shouldPreventRowMove()) return;
        if (this.gos.get("suppressMoveWhenRowDragging") || !isFromThisGrid) {
            if (!this.isDropZoneWithinThisGrid(draggingEvent)) this.clientSideRowModel.highlightRowAtPixel(rowNodes[0], pixel);
        } else this.moveRows(rowNodes, pixel);
    }
    getRowIndexNumber(rowNode) {
        return parseInt($437b23f6a393c3bf$var$last(rowNode.getRowIndexString().split("-")), 10);
    }
    moveRowAndClearHighlight(draggingEvent) {
        const lastHighlightedRowNode = this.clientSideRowModel.getLastHighlightedRowNode();
        const isBelow = lastHighlightedRowNode && lastHighlightedRowNode.highlighted === 1 /* Below */ ;
        const pixel = this.mouseEventService.getNormalisedPosition(draggingEvent).y;
        const rowNodes = draggingEvent.dragItem.rowNodes;
        let increment = isBelow ? 1 : 0;
        if (this.isFromThisGrid(draggingEvent)) {
            rowNodes.forEach((rowNode)=>{
                if (rowNode.rowTop < pixel) increment -= 1;
            });
            this.moveRows(rowNodes, pixel, increment);
        } else {
            const getRowIdFunc = this.gos.getCallback("getRowId");
            let addIndex = this.clientSideRowModel.getRowIndexAtPixel(pixel) + 1;
            if (this.clientSideRowModel.getHighlightPosition(pixel) === 0 /* Above */ ) addIndex--;
            this.clientSideRowModel.updateRowData({
                add: rowNodes.map((node)=>node.data).filter((data)=>!this.clientSideRowModel.getRowNode(getRowIdFunc ? getRowIdFunc({
                        data: data,
                        level: 0
                    }) : data.id)),
                addIndex: addIndex
            });
        }
        this.clearRowHighlight();
    }
    clearRowHighlight() {
        this.clientSideRowModel.highlightRowAtPixel(null);
    }
    moveRows(rowNodes, pixel, increment = 0) {
        var _a;
        const rowWasMoved = this.clientSideRowModel.ensureRowsAtPixel(rowNodes, pixel, increment);
        if (rowWasMoved) {
            this.focusService.clearFocusedCell();
            (_a = this.rangeService) == null || _a.removeAllCellRanges();
        }
    }
    addRowDropZone(params) {
        if (!params.getContainer()) {
            $437b23f6a393c3bf$var$warnOnce("addRowDropZone - A container target needs to be provided");
            return;
        }
        if (this.dragAndDropService.findExternalZone(params)) {
            console.warn("AG Grid: addRowDropZone - target already exists in the list of DropZones. Use `removeRowDropZone` before adding it again.");
            return;
        }
        let processedParams = {
            getContainer: params.getContainer
        };
        if (params.fromGrid) processedParams = params;
        else {
            if (params.onDragEnter) processedParams.onDragEnter = (e)=>{
                params.onDragEnter(this.draggingToRowDragEvent($437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_DRAG_ENTER, e));
            };
            if (params.onDragLeave) processedParams.onDragLeave = (e)=>{
                params.onDragLeave(this.draggingToRowDragEvent($437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_DRAG_LEAVE, e));
            };
            if (params.onDragging) processedParams.onDragging = (e)=>{
                params.onDragging(this.draggingToRowDragEvent($437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_DRAG_MOVE, e));
            };
            if (params.onDragStop) processedParams.onDragStop = (e)=>{
                params.onDragStop(this.draggingToRowDragEvent($437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_DRAG_END, e));
            };
        }
        this.dragAndDropService.addDropTarget($437b23f6a393c3bf$var$__spreadValues({
            isInterestedIn: (type)=>type === 2 /* RowDrag */ ,
            getIconName: ()=>$437b23f6a393c3bf$export$3529111922becfa6.ICON_MOVE,
            external: true
        }, processedParams));
    }
    getRowDropZone(events) {
        const getContainer = this.getContainer.bind(this);
        const onDragEnter = this.onDragEnter.bind(this);
        const onDragLeave = this.onDragLeave.bind(this);
        const onDragging = this.onDragging.bind(this);
        const onDragStop = this.onDragStop.bind(this);
        if (!events) return {
            getContainer: getContainer,
            onDragEnter: onDragEnter,
            onDragLeave: onDragLeave,
            onDragging: onDragging,
            onDragStop: onDragStop,
            /* @private */ fromGrid: true
        };
        return {
            getContainer: getContainer,
            onDragEnter: events.onDragEnter ? (e)=>{
                onDragEnter(e);
                events.onDragEnter(this.draggingToRowDragEvent($437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_DRAG_ENTER, e));
            } : onDragEnter,
            onDragLeave: events.onDragLeave ? (e)=>{
                onDragLeave(e);
                events.onDragLeave(this.draggingToRowDragEvent($437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_DRAG_LEAVE, e));
            } : onDragLeave,
            onDragging: events.onDragging ? (e)=>{
                onDragging(e);
                events.onDragging(this.draggingToRowDragEvent($437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_DRAG_MOVE, e));
            } : onDragging,
            onDragStop: events.onDragStop ? (e)=>{
                onDragStop(e);
                events.onDragStop(this.draggingToRowDragEvent($437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_DRAG_END, e));
            } : onDragStop,
            fromGrid: true
        };
    }
    draggingToRowDragEvent(type, draggingEvent) {
        const yNormalised = this.mouseEventService.getNormalisedPosition(draggingEvent).y;
        const mouseIsPastLastRow = yNormalised > this.paginationProxy.getCurrentPageHeight();
        let overIndex = -1;
        let overNode;
        if (!mouseIsPastLastRow) {
            overIndex = this.rowModel.getRowIndexAtPixel(yNormalised);
            overNode = this.rowModel.getRow(overIndex);
        }
        let vDirectionString;
        switch(draggingEvent.vDirection){
            case 1 /* Down */ :
                vDirectionString = "down";
                break;
            case 0 /* Up */ :
                vDirectionString = "up";
                break;
            default:
                vDirectionString = null;
                break;
        }
        const event = this.gos.addGridCommonParams({
            type: type,
            event: draggingEvent.event,
            node: draggingEvent.dragItem.rowNode,
            nodes: draggingEvent.dragItem.rowNodes,
            overIndex: overIndex,
            overNode: overNode,
            y: yNormalised,
            vDirection: vDirectionString
        });
        return event;
    }
    dispatchGridEvent(type, draggingEvent) {
        const event = this.draggingToRowDragEvent(type, draggingEvent);
        this.eventService.dispatchEvent(event);
    }
    onDragLeave(draggingEvent) {
        this.dispatchGridEvent($437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_DRAG_LEAVE, draggingEvent);
        this.stopDragging(draggingEvent);
        if (this.gos.get("rowDragManaged")) this.clearRowHighlight();
    }
    onDragStop(draggingEvent) {
        this.dispatchGridEvent($437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_DRAG_END, draggingEvent);
        this.stopDragging(draggingEvent);
        if (this.gos.get("rowDragManaged") && (this.gos.get("suppressMoveWhenRowDragging") || !this.isFromThisGrid(draggingEvent)) && !this.isDropZoneWithinThisGrid(draggingEvent)) this.moveRowAndClearHighlight(draggingEvent);
    }
    stopDragging(draggingEvent) {
        this.autoScrollService.ensureCleared();
        this.getRowNodes(draggingEvent).forEach((rowNode)=>{
            rowNode.setDragging(false);
        });
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("dragAndDropService")
], $437b23f6a393c3bf$var$RowDragFeature.prototype, "dragAndDropService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowModel")
], $437b23f6a393c3bf$var$RowDragFeature.prototype, "rowModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("paginationProxy")
], $437b23f6a393c3bf$var$RowDragFeature.prototype, "paginationProxy", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnModel")
], $437b23f6a393c3bf$var$RowDragFeature.prototype, "columnModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("focusService")
], $437b23f6a393c3bf$var$RowDragFeature.prototype, "focusService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("sortController")
], $437b23f6a393c3bf$var$RowDragFeature.prototype, "sortController", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("filterManager")
], $437b23f6a393c3bf$var$RowDragFeature.prototype, "filterManager", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("selectionService")
], $437b23f6a393c3bf$var$RowDragFeature.prototype, "selectionService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("mouseEventService")
], $437b23f6a393c3bf$var$RowDragFeature.prototype, "mouseEventService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("ctrlsService")
], $437b23f6a393c3bf$var$RowDragFeature.prototype, "ctrlsService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$7acb7b24c478f9c6("rangeService")
], $437b23f6a393c3bf$var$RowDragFeature.prototype, "rangeService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$RowDragFeature.prototype, "postConstruct", 1);
// community-modules/core/src/dragAndDrop/dragService.ts
var $437b23f6a393c3bf$export$590729638d17528a = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.dragEndFunctions = [];
        this.dragSources = [];
    }
    removeAllListeners() {
        this.dragSources.forEach(this.removeListener.bind(this));
        this.dragSources.length = 0;
    }
    removeListener(dragSourceAndListener) {
        const element = dragSourceAndListener.dragSource.eElement;
        const mouseDownListener = dragSourceAndListener.mouseDownListener;
        element.removeEventListener("mousedown", mouseDownListener);
        if (dragSourceAndListener.touchEnabled) {
            const touchStartListener = dragSourceAndListener.touchStartListener;
            element.removeEventListener("touchstart", touchStartListener, {
                passive: true
            });
        }
    }
    removeDragSource(params) {
        const dragSourceAndListener = this.dragSources.find((item)=>item.dragSource === params);
        if (!dragSourceAndListener) return;
        this.removeListener(dragSourceAndListener);
        $437b23f6a393c3bf$var$removeFromArray(this.dragSources, dragSourceAndListener);
    }
    isDragging() {
        return this.dragging;
    }
    addDragSource(params) {
        const mouseListener = this.onMouseDown.bind(this, params);
        const { eElement: eElement, includeTouch: includeTouch, stopPropagationForTouch: stopPropagationForTouch } = params;
        eElement.addEventListener("mousedown", mouseListener);
        let touchListener = null;
        const suppressTouch = this.gos.get("suppressTouch");
        if (includeTouch && !suppressTouch) {
            touchListener = (touchEvent)=>{
                if ($437b23f6a393c3bf$var$isFocusableFormField(touchEvent.target)) return;
                if (touchEvent.cancelable) {
                    touchEvent.preventDefault();
                    if (stopPropagationForTouch) touchEvent.stopPropagation();
                }
                this.onTouchStart(params, touchEvent);
            };
            eElement.addEventListener("touchstart", touchListener, {
                passive: false
            });
        }
        this.dragSources.push({
            dragSource: params,
            mouseDownListener: mouseListener,
            touchStartListener: touchListener,
            touchEnabled: !!includeTouch
        });
    }
    getStartTarget() {
        return this.startTarget;
    }
    // gets called whenever mouse down on any drag source
    onTouchStart(params, touchEvent) {
        this.currentDragParams = params;
        this.dragging = false;
        const touch = touchEvent.touches[0];
        this.touchLastTime = touch;
        this.touchStart = touch;
        const touchMoveEvent = (e)=>this.onTouchMove(e, params.eElement);
        const touchEndEvent = (e)=>this.onTouchUp(e, params.eElement);
        const documentTouchMove = (e)=>{
            if (e.cancelable) e.preventDefault();
        };
        const target = touchEvent.target;
        const events = [
            // Prevents the page document from moving while we are dragging items around.
            // preventDefault needs to be called in the touchmove listener and never inside the
            // touchstart, because using touchstart causes the click event to be cancelled on touch devices.
            {
                target: this.gos.getRootNode(),
                type: "touchmove",
                listener: documentTouchMove,
                options: {
                    passive: false
                }
            },
            {
                target: target,
                type: "touchmove",
                listener: touchMoveEvent,
                options: {
                    passive: true
                }
            },
            {
                target: target,
                type: "touchend",
                listener: touchEndEvent,
                options: {
                    passive: true
                }
            },
            {
                target: target,
                type: "touchcancel",
                listener: touchEndEvent,
                options: {
                    passive: true
                }
            }
        ];
        this.addTemporaryEvents(events);
        if (params.dragStartPixels === 0) this.onCommonMove(touch, this.touchStart, params.eElement);
    }
    // gets called whenever mouse down on any drag source
    onMouseDown(params, mouseEvent) {
        const e = mouseEvent;
        if (params.skipMouseEvent && params.skipMouseEvent(mouseEvent)) return;
        if (e._alreadyProcessedByDragService) return;
        e._alreadyProcessedByDragService = true;
        if (mouseEvent.button !== 0) return;
        if (this.shouldPreventMouseEvent(mouseEvent)) mouseEvent.preventDefault();
        this.currentDragParams = params;
        this.dragging = false;
        this.mouseStartEvent = mouseEvent;
        this.startTarget = mouseEvent.target;
        const mouseMoveEvent = (event)=>this.onMouseMove(event, params.eElement);
        const mouseUpEvent = (event)=>this.onMouseUp(event, params.eElement);
        const contextEvent = (event)=>event.preventDefault();
        const target = this.gos.getRootNode();
        const events = [
            {
                target: target,
                type: "mousemove",
                listener: mouseMoveEvent
            },
            {
                target: target,
                type: "mouseup",
                listener: mouseUpEvent
            },
            {
                target: target,
                type: "contextmenu",
                listener: contextEvent
            }
        ];
        this.addTemporaryEvents(events);
        if (params.dragStartPixels === 0) this.onMouseMove(mouseEvent, params.eElement);
    }
    addTemporaryEvents(events) {
        events.forEach((currentEvent)=>{
            const { target: target, type: type, listener: listener, options: options } = currentEvent;
            target.addEventListener(type, listener, options);
        });
        this.dragEndFunctions.push(()=>{
            events.forEach((currentEvent)=>{
                const { target: target, type: type, listener: listener, options: options } = currentEvent;
                target.removeEventListener(type, listener, options);
            });
        });
    }
    // returns true if the event is close to the original event by X pixels either vertically or horizontally.
    // we only start dragging after X pixels so this allows us to know if we should start dragging yet.
    isEventNearStartEvent(currentEvent, startEvent) {
        const { dragStartPixels: dragStartPixels } = this.currentDragParams;
        const requiredPixelDiff = $437b23f6a393c3bf$var$exists(dragStartPixels) ? dragStartPixels : 4;
        return $437b23f6a393c3bf$var$areEventsNear(currentEvent, startEvent, requiredPixelDiff);
    }
    getFirstActiveTouch(touchList) {
        for(let i = 0; i < touchList.length; i++){
            if (touchList[i].identifier === this.touchStart.identifier) return touchList[i];
        }
        return null;
    }
    onCommonMove(currentEvent, startEvent, el) {
        if (!this.dragging) {
            if (!this.dragging && this.isEventNearStartEvent(currentEvent, startEvent)) return;
            this.dragging = true;
            const event = {
                type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_DRAG_STARTED,
                target: el
            };
            this.eventService.dispatchEvent(event);
            this.currentDragParams.onDragStart(startEvent);
            this.currentDragParams.onDragging(startEvent);
        }
        this.currentDragParams.onDragging(currentEvent);
    }
    onTouchMove(touchEvent, el) {
        const touch = this.getFirstActiveTouch(touchEvent.touches);
        if (!touch) return;
        this.onCommonMove(touch, this.touchStart, el);
    }
    // only gets called after a mouse down - as this is only added after mouseDown
    // and is removed when mouseUp happens
    onMouseMove(mouseEvent, el) {
        var _a;
        if ($437b23f6a393c3bf$var$isBrowserSafari()) {
            const eDocument = this.gos.getDocument();
            (_a = eDocument.getSelection()) == null || _a.removeAllRanges();
        }
        if (this.shouldPreventMouseEvent(mouseEvent)) mouseEvent.preventDefault();
        this.onCommonMove(mouseEvent, this.mouseStartEvent, el);
    }
    shouldPreventMouseEvent(mouseEvent) {
        const isEnableCellTextSelect = this.gos.get("enableCellTextSelection");
        const isMouseMove = mouseEvent.type === "mousemove";
        return(// when `isEnableCellTextSelect` is `true`, we need to preventDefault on mouseMove
        // to avoid the grid text being selected while dragging components.
        isEnableCellTextSelect && isMouseMove && mouseEvent.cancelable && this.mouseEventService.isEventFromThisGrid(mouseEvent) && !this.isOverFormFieldElement(mouseEvent));
    }
    isOverFormFieldElement(mouseEvent) {
        const el = mouseEvent.target;
        const tagName = el == null ? void 0 : el.tagName.toLocaleLowerCase();
        return !!(tagName == null ? void 0 : tagName.match("^a$|textarea|input|select|button"));
    }
    onTouchUp(touchEvent, el) {
        let touch = this.getFirstActiveTouch(touchEvent.changedTouches);
        if (!touch) touch = this.touchLastTime;
        this.onUpCommon(touch, el);
    }
    onMouseUp(mouseEvent, el) {
        this.onUpCommon(mouseEvent, el);
    }
    onUpCommon(eventOrTouch, el) {
        if (this.dragging) {
            this.dragging = false;
            this.currentDragParams.onDragStop(eventOrTouch);
            const event = {
                type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_DRAG_STOPPED,
                target: el
            };
            this.eventService.dispatchEvent(event);
        }
        this.mouseStartEvent = null;
        this.startTarget = null;
        this.touchStart = null;
        this.touchLastTime = null;
        this.currentDragParams = null;
        this.dragEndFunctions.forEach((func)=>func());
        this.dragEndFunctions.length = 0;
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("mouseEventService")
], $437b23f6a393c3bf$export$590729638d17528a.prototype, "mouseEventService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$cc3f3d4529c57d95
], $437b23f6a393c3bf$export$590729638d17528a.prototype, "removeAllListeners", 1);
$437b23f6a393c3bf$export$590729638d17528a = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("dragService")
], $437b23f6a393c3bf$export$590729638d17528a);
// community-modules/core/src/dragAndDrop/virtualListDragFeature.ts
var $437b23f6a393c3bf$var$LIST_ITEM_HOVERED = "ag-list-item-hovered";
var $437b23f6a393c3bf$export$dde02d2f19b2bc46 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(comp, virtualList, params){
        super();
        this.comp = comp;
        this.virtualList = virtualList;
        this.params = params;
        this.currentDragValue = null;
        this.lastHoveredListItem = null;
    }
    postConstruct() {
        this.addManagedListener(this.params.eventSource, this.params.listItemDragStartEvent, this.listItemDragStart.bind(this));
        this.addManagedListener(this.params.eventSource, this.params.listItemDragEndEvent, this.listItemDragEnd.bind(this));
        this.createDropTarget();
        this.createAutoScrollService();
    }
    listItemDragStart(event) {
        this.currentDragValue = this.params.getCurrentDragValue(event);
        this.moveBlocked = this.params.isMoveBlocked(this.currentDragValue);
    }
    listItemDragEnd() {
        window.setTimeout(()=>{
            this.currentDragValue = null;
            this.moveBlocked = false;
        }, 10);
    }
    createDropTarget() {
        const dropTarget = {
            isInterestedIn: (type)=>type === this.params.dragSourceType,
            getIconName: ()=>this.moveBlocked ? $437b23f6a393c3bf$export$3529111922becfa6.ICON_PINNED : $437b23f6a393c3bf$export$3529111922becfa6.ICON_MOVE,
            getContainer: ()=>this.comp.getGui(),
            onDragging: (e)=>this.onDragging(e),
            onDragStop: ()=>this.onDragStop(),
            onDragLeave: ()=>this.onDragLeave()
        };
        this.dragAndDropService.addDropTarget(dropTarget);
    }
    createAutoScrollService() {
        const virtualListGui = this.virtualList.getGui();
        this.autoScrollService = new $437b23f6a393c3bf$export$c66bdc3d55a4f95({
            scrollContainer: virtualListGui,
            scrollAxis: "y",
            getVerticalPosition: ()=>virtualListGui.scrollTop,
            setVerticalPosition: (position)=>virtualListGui.scrollTop = position
        });
    }
    onDragging(e) {
        if (!this.currentDragValue || this.moveBlocked) return;
        const hoveredListItem = this.getListDragItem(e);
        const comp = this.virtualList.getComponentAt(hoveredListItem.rowIndex);
        if (!comp) return;
        const el = comp.getGui().parentElement;
        if (this.lastHoveredListItem && this.lastHoveredListItem.rowIndex === hoveredListItem.rowIndex && this.lastHoveredListItem.position === hoveredListItem.position) return;
        this.autoScrollService.check(e.event);
        this.clearHoveredItems();
        this.lastHoveredListItem = hoveredListItem;
        $437b23f6a393c3bf$var$radioCssClass(el, $437b23f6a393c3bf$var$LIST_ITEM_HOVERED);
        $437b23f6a393c3bf$var$radioCssClass(el, `ag-item-highlight-${hoveredListItem.position}`);
    }
    getListDragItem(e) {
        const virtualListGui = this.virtualList.getGui();
        const paddingTop = parseFloat(window.getComputedStyle(virtualListGui).paddingTop);
        const rowHeight = this.virtualList.getRowHeight();
        const scrollTop = this.virtualList.getScrollTop();
        const rowIndex = Math.max(0, (e.y - paddingTop + scrollTop) / rowHeight);
        const maxLen = this.params.getNumRows(this.comp) - 1;
        const normalizedRowIndex = Math.min(maxLen, rowIndex) | 0;
        return {
            rowIndex: normalizedRowIndex,
            position: Math.round(rowIndex) > rowIndex || rowIndex > maxLen ? "bottom" : "top",
            component: this.virtualList.getComponentAt(normalizedRowIndex)
        };
    }
    onDragStop() {
        if (this.moveBlocked) return;
        this.params.moveItem(this.currentDragValue, this.lastHoveredListItem);
        this.clearHoveredItems();
        this.autoScrollService.ensureCleared();
    }
    onDragLeave() {
        this.clearHoveredItems();
        this.autoScrollService.ensureCleared();
    }
    clearHoveredItems() {
        const virtualListGui = this.virtualList.getGui();
        virtualListGui.querySelectorAll(`.${$437b23f6a393c3bf$var$LIST_ITEM_HOVERED}`).forEach((el)=>{
            [
                $437b23f6a393c3bf$var$LIST_ITEM_HOVERED,
                "ag-item-highlight-top",
                "ag-item-highlight-bottom"
            ].forEach((cls)=>{
                el.classList.remove(cls);
            });
        });
        this.lastHoveredListItem = null;
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("dragAndDropService")
], $437b23f6a393c3bf$export$dde02d2f19b2bc46.prototype, "dragAndDropService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$export$dde02d2f19b2bc46.prototype, "postConstruct", 1);
// community-modules/core/src/gridApi.ts
function $437b23f6a393c3bf$var$unwrapUserComp(comp) {
    const compAsAny = comp;
    const isProxy = compAsAny != null && compAsAny.getFrameworkComponentInstance != null;
    return isProxy ? compAsAny.getFrameworkComponentInstance() : comp;
}
var $437b23f6a393c3bf$export$8f1681b1712fcf78 = class {
    constructor(){
        this.detailGridInfoMap = {};
        this.destroyCalled = false;
    }
    init() {
        switch(this.rowModel.getType()){
            case "clientSide":
                this.clientSideRowModel = this.rowModel;
                break;
            case "infinite":
                this.infiniteRowModel = this.rowModel;
                break;
            case "serverSide":
                this.serverSideRowModel = this.rowModel;
                break;
        }
        this.ctrlsService.whenReady((p)=>{
            this.gridBodyCtrl = p.gridBodyCtrl;
        });
    }
    /** Used internally by grid. Not intended to be used by the client. Interface may change between releases. */ __getAlignedGridService() {
        return this.alignedGridsService;
    }
    /** Returns the `gridId` for the current grid as specified via the gridOptions property `gridId` or the auto assigned grid id if none was provided. */ getGridId() {
        return this.context.getGridId();
    }
    /** Register a detail grid with the master grid when it is created. */ addDetailGridInfo(id, gridInfo) {
        this.detailGridInfoMap[id] = gridInfo;
    }
    /** Unregister a detail grid from the master grid when it is destroyed. */ removeDetailGridInfo(id) {
        delete this.detailGridInfoMap[id];
    }
    /** Returns the `DetailGridInfo` corresponding to the supplied `detailGridId`. */ getDetailGridInfo(id) {
        return this.detailGridInfoMap[id];
    }
    /** Iterates through each `DetailGridInfo` in the grid and calls the supplied callback on each. */ forEachDetailGridInfo(callback) {
        let index = 0;
        $437b23f6a393c3bf$var$iterateObject(this.detailGridInfoMap, (id, gridInfo)=>{
            if ($437b23f6a393c3bf$var$exists(gridInfo)) {
                callback(gridInfo, index);
                index++;
            }
        });
    }
    /** Similar to `exportDataAsCsv`, except returns the result as a string rather than download it. */ getDataAsCsv(params) {
        if ($437b23f6a393c3bf$export$dc053975cc7f6c11.__assertRegistered("@ag-grid-community/csv-export" /* CsvExportModule */ , "api.getDataAsCsv", this.context.getGridId())) return this.csvCreator.getDataAsCsv(params);
    }
    /** Downloads a CSV export of the grid's data. */ exportDataAsCsv(params) {
        if ($437b23f6a393c3bf$export$dc053975cc7f6c11.__assertRegistered("@ag-grid-community/csv-export" /* CsvExportModule */ , "api.exportDataAsCsv", this.context.getGridId())) this.csvCreator.exportDataAsCsv(params);
    }
    assertNotExcelMultiSheet(method, params) {
        if (!$437b23f6a393c3bf$export$dc053975cc7f6c11.__assertRegistered("@ag-grid-enterprise/excel-export" /* ExcelExportModule */ , "api." + method, this.context.getGridId())) return false;
        if (this.excelCreator.getFactoryMode() === 1 /* MULTI_SHEET */ ) {
            console.warn("AG Grid: The Excel Exporter is currently on Multi Sheet mode. End that operation by calling 'api.getMultipleSheetAsExcel()' or 'api.exportMultipleSheetsAsExcel()'");
            return false;
        }
        return true;
    }
    /** Similar to `exportDataAsExcel`, except instead of downloading a file, it will return a [Blob](https://developer.mozilla.org/en-US/docs/Web/API/Blob) to be processed by the user. */ getDataAsExcel(params) {
        if (this.assertNotExcelMultiSheet("getDataAsExcel", params)) return this.excelCreator.getDataAsExcel(params);
    }
    /** Downloads an Excel export of the grid's data. */ exportDataAsExcel(params) {
        if (this.assertNotExcelMultiSheet("exportDataAsExcel", params)) this.excelCreator.exportDataAsExcel(params);
    }
    /** This is method to be used to get the grid's data as a sheet, that will later be exported either by `getMultipleSheetsAsExcel()` or `exportMultipleSheetsAsExcel()`. */ getSheetDataForExcel(params) {
        if (!$437b23f6a393c3bf$export$dc053975cc7f6c11.__assertRegistered("@ag-grid-enterprise/excel-export" /* ExcelExportModule */ , "api.getSheetDataForExcel", this.context.getGridId())) return;
        this.excelCreator.setFactoryMode(1 /* MULTI_SHEET */ );
        return this.excelCreator.getSheetDataForExcel(params);
    }
    /** Similar to `exportMultipleSheetsAsExcel`, except instead of downloading a file, it will return a [Blob](https://developer.mozilla.org/en-US/docs/Web/API/Blob) to be processed by the user. */ getMultipleSheetsAsExcel(params) {
        if ($437b23f6a393c3bf$export$dc053975cc7f6c11.__assertRegistered("@ag-grid-enterprise/excel-export" /* ExcelExportModule */ , "api.getMultipleSheetsAsExcel", this.context.getGridId())) return this.excelCreator.getMultipleSheetsAsExcel(params);
    }
    /** Downloads an Excel export of multiple sheets in one file. */ exportMultipleSheetsAsExcel(params) {
        if ($437b23f6a393c3bf$export$dc053975cc7f6c11.__assertRegistered("@ag-grid-enterprise/excel-export" /* ExcelExportModule */ , "api.exportMultipleSheetsAsExcel", this.context.getGridId())) this.excelCreator.exportMultipleSheetsAsExcel(params);
    }
    /**
   * Sets an ARIA property in the grid panel (element with `role=\"grid\"`), and removes an ARIA property when the value is null.
   *
   * Example: `api.setGridAriaProperty('label', 'my grid')` will set `aria-label=\"my grid\"`.
   *
   * `api.setGridAriaProperty('label', null)` will remove the `aria-label` attribute from the grid element.
   */ setGridAriaProperty(property, value) {
        if (!property) return;
        const eGrid = this.ctrlsService.getGridBodyCtrl().getGui();
        const ariaProperty = `aria-${property}`;
        if (value === null) eGrid.removeAttribute(ariaProperty);
        else eGrid.setAttribute(ariaProperty, value);
    }
    logMissingRowModel(apiMethod, ...requiredRowModels) {
        console.error(`AG Grid: api.${apiMethod} can only be called when gridOptions.rowModelType is ${requiredRowModels.join(" or ")}`);
    }
    logDeprecation(version, apiMethod, replacement, message) {
        $437b23f6a393c3bf$var$warnOnce(`Since ${version} api.${apiMethod} is deprecated. Please use ${replacement} instead. ${message != null ? message : ""}`);
    }
    /** Gets the number of top pinned rows. */ getPinnedTopRowCount() {
        return this.pinnedRowModel.getPinnedTopRowCount();
    }
    /** Gets the number of bottom pinned rows. */ getPinnedBottomRowCount() {
        return this.pinnedRowModel.getPinnedBottomRowCount();
    }
    /** Gets the top pinned row with the specified index. */ getPinnedTopRow(index) {
        return this.pinnedRowModel.getPinnedTopRow(index);
    }
    /** Gets the bottom pinned row with the specified index. */ getPinnedBottomRow(index) {
        return this.pinnedRowModel.getPinnedBottomRow(index);
    }
    expireValueCache() {
        this.valueCache.expire();
    }
    /**
   * Returns an object with two properties:
   *  - `top`: The top pixel position of the current scroll in the grid
   *  - `bottom`: The bottom pixel position of the current scroll in the grid
   */ getVerticalPixelRange() {
        return this.gridBodyCtrl.getScrollFeature().getVScrollPosition();
    }
    /**
   * Returns an object with two properties:
   * - `left`: The left pixel position of the current scroll in the grid
   * - `right`: The right pixel position of the current scroll in the grid
   */ getHorizontalPixelRange() {
        return this.gridBodyCtrl.getScrollFeature().getHScrollPosition();
    }
    /** Performs change detection on all cells, refreshing cells where required. */ refreshCells(params = {}) {
        this.frameworkOverrides.wrapIncoming(()=>this.rowRenderer.refreshCells(params));
    }
    /** Flash rows, columns or individual cells. */ flashCells(params = {}) {
        const warning = (prop)=>$437b23f6a393c3bf$var$warnOnce(`Since v31.1 api.flashCells parameter '${prop}Delay' is deprecated. Please use '${prop}Duration' instead.`);
        if ($437b23f6a393c3bf$var$exists(params.fadeDelay)) warning("fade");
        if ($437b23f6a393c3bf$var$exists(params.flashDelay)) warning("flash");
        this.frameworkOverrides.wrapIncoming(()=>this.rowRenderer.flashCells(params));
    }
    /** Remove row(s) from the DOM and recreate them again from scratch. */ redrawRows(params = {}) {
        const rowNodes = params ? params.rowNodes : void 0;
        this.frameworkOverrides.wrapIncoming(()=>this.rowRenderer.redrawRows(rowNodes));
    }
    /** Redraws the header. Useful if a column name changes, or something else that changes how the column header is displayed. */ refreshHeader() {
        this.frameworkOverrides.wrapIncoming(()=>this.ctrlsService.getHeaderRowContainerCtrls().forEach((c)=>c.refresh()));
    }
    /** Returns `true` if any filter is set. This includes quick filter, column filter, external filter or advanced filter. */ isAnyFilterPresent() {
        return this.filterManager.isAnyFilterPresent();
    }
    /** Returns `true` if any column filter is set, otherwise `false`. */ isColumnFilterPresent() {
        return this.filterManager.isColumnFilterPresent() || this.filterManager.isAggregateFilterPresent();
    }
    /** Returns `true` if the Quick Filter is set, otherwise `false`. */ isQuickFilterPresent() {
        return this.filterManager.isQuickFilterPresent();
    }
    /**
   * Returns the row model inside the table.
   * From here you can see the original rows, rows after filter has been applied,
   * rows after aggregation has been applied, and the final set of 'to be displayed' rows.
   *
   * @deprecated As of v31.1, getModel() is deprecated and will not be available in future versions.
   * Please use the appropriate grid API methods instead
   */ getModel() {
        $437b23f6a393c3bf$var$warnOnce("Since v31.1 getModel() is deprecated. Please use the appropriate grid API methods instead.");
        return this.rowModel;
    }
    /** 
   * Expand or collapse a specific row node, optionally expanding/collapsing all of its parent nodes.
   * By default rows are expanded asynchronously for best performance. Set forceSync: `true` if you need to interact with the expanded row immediately after this function.
   */ setRowNodeExpanded(rowNode, expanded, expandParents, forceSync) {
        this.expansionService.setRowNodeExpanded(rowNode, expanded, expandParents, forceSync);
    }
    /**
   * Informs the grid that row group expanded state has changed and it needs to rerender the group nodes.
   * Typically called after updating the row node expanded state explicitly, i.e `rowNode.expanded = false`,
   * across multiple groups and you want to update the grid view in a single rerender instead of on every group change.
   */ onGroupExpandedOrCollapsed() {
        if ($437b23f6a393c3bf$var$missing(this.clientSideRowModel)) {
            this.logMissingRowModel("onGroupExpandedOrCollapsed", "clientSide");
            return;
        }
        this.expansionService.onGroupExpandedOrCollapsed();
    }
    /**
   * Refresh the Client-Side Row Model, executing the grouping, filtering and sorting again.
   * Optionally provide the step you wish the refresh to apply from. Defaults to `everything`.
   */ refreshClientSideRowModel(step) {
        if ($437b23f6a393c3bf$var$missing(this.clientSideRowModel)) {
            this.logMissingRowModel("refreshClientSideRowModel", "clientSide");
            return;
        }
        this.clientSideRowModel.refreshModel(step);
    }
    /** Returns `true` when there are no more animation frames left to process. */ isAnimationFrameQueueEmpty() {
        return this.animationFrameService.isQueueEmpty();
    }
    flushAllAnimationFrames() {
        this.animationFrameService.flushAllFrames();
    }
    /**
   * Returns the row node with the given ID.
   * The row node ID is the one you provide from the callback `getRowId(params)`,
   * otherwise the ID is a number (cast as string) auto-generated by the grid when
   * the row data is set.
   */ getRowNode(id) {
        return this.rowModel.getRowNode(id);
    }
    /**
   * Gets the sizes that various UI elements will be rendered at with the current theme.
   * If you override the row or header height using `gridOptions`, the override value you provided will be returned.
   */ getSizesForCurrentTheme() {
        return {
            rowHeight: this.gos.getRowHeightAsNumber(),
            headerHeight: this.columnModel.getHeaderHeight()
        };
    }
    /** Expand all groups. */ expandAll() {
        if (this.clientSideRowModel || this.serverSideRowModel) this.expansionService.expandAll(true);
        else this.logMissingRowModel("expandAll", "clientSide", "serverSide");
    }
    /** Collapse all groups. */ collapseAll() {
        if (this.clientSideRowModel || this.serverSideRowModel) this.expansionService.expandAll(false);
        else this.logMissingRowModel("collapseAll", "clientSide", "serverSide");
    }
    /**
   * Registers a callback to a virtual row.
   * A virtual row is a row that is visually rendered on the screen (rows that are not visible because of the scroll position are not rendered).
   * Unlike normal events, you do not need to unregister rendered row listeners.
   * When the rendered row is removed from the grid, all associated rendered row listeners will also be removed.
   * listen for this event if your `cellRenderer` needs to do cleanup when the row no longer exists.
   */ addRenderedRowListener(eventName, rowIndex, callback) {
        this.rowRenderer.addRenderedRowListener(eventName, rowIndex, callback);
    }
    /** Get the current Quick Filter text from the grid, or `undefined` if none is set. */ getQuickFilter() {
        return this.gos.get("quickFilterText");
    }
    /** Get the state of the Advanced Filter. Used for saving Advanced Filter state */ getAdvancedFilterModel() {
        if ($437b23f6a393c3bf$export$dc053975cc7f6c11.__assertRegistered("@ag-grid-enterprise/advanced-filter" /* AdvancedFilterModule */ , "api.getAdvancedFilterModel", this.context.getGridId())) return this.filterManager.getAdvancedFilterModel();
        return null;
    }
    /** Set the state of the Advanced Filter. Used for restoring Advanced Filter state */ setAdvancedFilterModel(advancedFilterModel) {
        this.filterManager.setAdvancedFilterModel(advancedFilterModel);
    }
    /** Open the Advanced Filter Builder dialog (if enabled). */ showAdvancedFilterBuilder() {
        if ($437b23f6a393c3bf$export$dc053975cc7f6c11.__assertRegistered("@ag-grid-enterprise/advanced-filter" /* AdvancedFilterModule */ , "api.setAdvancedFilterModel", this.context.getGridId())) this.filterManager.showAdvancedFilterBuilder("api");
    }
    /**
   * Set all of the provided nodes selection state to the provided value.
   */ setNodesSelected(params) {
        const allNodesValid = params.nodes.every((node)=>{
            if (node.rowPinned) {
                console.warn("AG Grid: cannot select pinned rows");
                return false;
            }
            if (node.id === void 0) {
                console.warn("AG Grid: cannot select node until id for node is known");
                return false;
            }
            return true;
        });
        if (!allNodesValid) return;
        const { nodes: nodes, source: source, newValue: newValue } = params;
        const nodesAsRowNode = nodes;
        this.selectionService.setNodesSelected({
            nodes: nodesAsRowNode,
            source: source != null ? source : "api",
            newValue: newValue
        });
    }
    /**
   * Select all rows, regardless of filtering and rows that are not visible due to grouping being enabled and their groups not expanded.
   * @param source Source property that will appear in the `selectionChanged` event, defaults to `'apiSelectAll'`
   */ selectAll(source = "apiSelectAll") {
        this.selectionService.selectAllRowNodes({
            source: source
        });
    }
    /**
   * Clear all row selections, regardless of filtering.
   * @param source Source property that will appear in the `selectionChanged` event, defaults to `'apiSelectAll'`
   */ deselectAll(source = "apiSelectAll") {
        this.selectionService.deselectAllRowNodes({
            source: source
        });
    }
    /**
   * Select all filtered rows.
   * @param source Source property that will appear in the `selectionChanged` event, defaults to `'apiSelectAllFiltered'`
   */ selectAllFiltered(source = "apiSelectAllFiltered") {
        this.selectionService.selectAllRowNodes({
            source: source,
            justFiltered: true
        });
    }
    /**
   * Clear all filtered selections.
   * @param source Source property that will appear in the `selectionChanged` event, defaults to `'apiSelectAllFiltered'`
   */ deselectAllFiltered(source = "apiSelectAllFiltered") {
        this.selectionService.deselectAllRowNodes({
            source: source,
            justFiltered: true
        });
    }
    /**
   * Returns an object containing rules matching the selected rows in the SSRM.
   * 
   * If `groupSelectsChildren=false` the returned object will be flat, and will conform to IServerSideSelectionState.
   * If `groupSelectsChildren=true` the returned object will be hierarchical, and will conform to IServerSideGroupSelectionState.
   */ getServerSideSelectionState() {
        if ($437b23f6a393c3bf$var$missing(this.serverSideRowModel)) {
            this.logMissingRowModel("getServerSideSelectionState", "serverSide");
            return null;
        }
        return this.selectionService.getSelectionState();
    }
    /**
   * Set the rules matching the selected rows in the SSRM.
   * 
   * If `groupSelectsChildren=false` the param will be flat, and should conform to IServerSideSelectionState.
   * If `groupSelectsChildren=true` the param will be hierarchical, and should conform to IServerSideGroupSelectionState.
   */ setServerSideSelectionState(state) {
        if ($437b23f6a393c3bf$var$missing(this.serverSideRowModel)) {
            this.logMissingRowModel("setServerSideSelectionState", "serverSide");
            return;
        }
        this.selectionService.setSelectionState(state, "api");
    }
    /**
   * Select all rows on the current page.
   * @param source Source property that will appear in the `selectionChanged` event, defaults to `'apiSelectAllCurrentPage'`
   */ selectAllOnCurrentPage(source = "apiSelectAllCurrentPage") {
        this.selectionService.selectAllRowNodes({
            source: source,
            justCurrentPage: true
        });
    }
    /**
   * Clear all filtered on the current page.
   * @param source Source property that will appear in the `selectionChanged` event, defaults to `'apiSelectAllCurrentPage'`
   */ deselectAllOnCurrentPage(source = "apiSelectAllCurrentPage") {
        this.selectionService.deselectAllRowNodes({
            source: source,
            justCurrentPage: true
        });
    }
    /** Show the 'loading' overlay. */ showLoadingOverlay() {
        this.overlayService.showLoadingOverlay();
    }
    /** Show the 'no rows' overlay. */ showNoRowsOverlay() {
        this.overlayService.showNoRowsOverlay();
    }
    /** Hides the overlay if showing. */ hideOverlay() {
        this.overlayService.hideOverlay();
    }
    /**
   * Returns an unsorted list of selected nodes.
   * Getting the underlying node (rather than the data) is useful when working with tree / aggregated data,
   * as the node can be traversed.
   */ getSelectedNodes() {
        return this.selectionService.getSelectedNodes();
    }
    /** Returns an unsorted list of selected rows (i.e. row data that you provided). */ getSelectedRows() {
        return this.selectionService.getSelectedRows();
    }
    /**
   * Returns a list of all selected nodes at 'best cost', a feature to be used with groups / trees.
   * If a group has all its children selected, then the group appears in the result, but not the children.
   * Designed for use with `'children'` as the group selection type, where groups don't actually appear in the selection normally.
   */ getBestCostNodeSelection() {
        if ($437b23f6a393c3bf$var$missing(this.clientSideRowModel)) {
            this.logMissingRowModel("getBestCostNodeSelection", "clientSide");
            return;
        }
        return this.selectionService.getBestCostNodeSelection();
    }
    /** Retrieve rendered nodes. Due to virtualisation this will contain only the current visible rows and those in the buffer. */ getRenderedNodes() {
        return this.rowRenderer.getRenderedNodes();
    }
    /**
   *  Ensures the column is visible by scrolling the table if needed.
   *
   * This will have no effect before the firstDataRendered event has fired.
   *
   * @param key - The column to ensure visible
   * @param position - Where the column will be positioned.
   * - `auto` - Scrolls the minimum amount to make sure the column is visible.
   * - `start` - Scrolls the column to the start of the viewport.
   * - `middle` - Scrolls the column to the middle of the viewport.
   * - `end` - Scrolls the column to the end of the viewport.
  */ ensureColumnVisible(key, position = "auto") {
        this.frameworkOverrides.wrapIncoming(()=>this.gridBodyCtrl.getScrollFeature().ensureColumnVisible(key, position), "ensureVisible");
    }
    /**
   * Vertically scrolls the grid until the provided row index is inside the visible viewport.
   * If a position is provided, the grid will attempt to scroll until the row is at the given position within the viewport.
   * This will have no effect before the firstDataRendered event has fired.
   */ ensureIndexVisible(index, position) {
        this.frameworkOverrides.wrapIncoming(()=>this.gridBodyCtrl.getScrollFeature().ensureIndexVisible(index, position), "ensureVisible");
    }
    /**
   * Vertically scrolls the grid until the provided row (or a row matching the provided comparator) is inside the visible viewport.
   * If a position is provided, the grid will attempt to scroll until the row is at the given position within the viewport.
   * This will have no effect before the firstDataRendered event has fired.
   */ ensureNodeVisible(nodeSelector, position = null) {
        this.frameworkOverrides.wrapIncoming(()=>this.gridBodyCtrl.getScrollFeature().ensureNodeVisible(nodeSelector, position), "ensureVisible");
    }
    /**
   * Similar to `forEachNode`, except lists all the leaf nodes.
   * This effectively goes through all the data that you provided to the grid before the grid performed any grouping.
   * If using tree data, goes through all the nodes for the data you provided, including nodes that have children,
   * but excluding groups the grid created where gaps were missing in the hierarchy.
   */ forEachLeafNode(callback) {
        if ($437b23f6a393c3bf$var$missing(this.clientSideRowModel)) {
            this.logMissingRowModel("forEachLeafNode", "clientSide");
            return;
        }
        this.clientSideRowModel.forEachLeafNode(callback);
    }
    /**
   * Iterates through each node (row) in the grid and calls the callback for each node.
   * This works similar to the `forEach` method on a JavaScript array.
   * This is called for every node, ignoring any filtering or sorting applied within the grid.
   * If using the Infinite Row Model, then this gets called for each page loaded in the page cache.
   */ forEachNode(callback, includeFooterNodes) {
        this.rowModel.forEachNode(callback, includeFooterNodes);
    }
    /** Similar to `forEachNode`, except skips any filtered out data. */ forEachNodeAfterFilter(callback) {
        if ($437b23f6a393c3bf$var$missing(this.clientSideRowModel)) {
            this.logMissingRowModel("forEachNodeAfterFilter", "clientSide");
            return;
        }
        this.clientSideRowModel.forEachNodeAfterFilter(callback);
    }
    /** Similar to `forEachNodeAfterFilter`, except the callbacks are called in the order the rows are displayed in the grid. */ forEachNodeAfterFilterAndSort(callback) {
        if ($437b23f6a393c3bf$var$missing(this.clientSideRowModel)) {
            this.logMissingRowModel("forEachNodeAfterFilterAndSort", "clientSide");
            return;
        }
        this.clientSideRowModel.forEachNodeAfterFilterAndSort(callback);
    }
    /**
   * @deprecated v31.1 To get/set individual filter models, use `getColumnFilterModel` or `setColumnFilterModel` instead.
   * To get hold of the filter instance, use `getColumnFilterInstance` which returns the instance asynchronously.
   */ getFilterInstance(key, callback) {
        $437b23f6a393c3bf$var$warnOnce(`'getFilterInstance' is deprecated. To get/set individual filter models, use 'getColumnFilterModel' or 'setColumnFilterModel' instead. To get hold of the filter instance, use 'getColumnFilterInstance' which returns the instance asynchronously.`);
        return this.filterManager.getFilterInstance(key, callback);
    }
    /**
   * Returns the filter component instance for a column.
   * For getting/setting models for individual column filters, use `getColumnFilterModel` and `setColumnFilterModel` instead of this.
   * `key` can be a column ID or a `Column` object.
   */ getColumnFilterInstance(key) {
        return this.filterManager.getColumnFilterInstance(key);
    }
    /** Destroys a filter. Useful to force a particular filter to be created from scratch again. */ destroyFilter(key) {
        const column = this.columnModel.getPrimaryColumn(key);
        if (column) return this.filterManager.destroyFilter(column, "api");
    }
    /** Gets the status panel instance corresponding to the supplied `id`. */ getStatusPanel(key) {
        if (!$437b23f6a393c3bf$export$dc053975cc7f6c11.__assertRegistered("@ag-grid-enterprise/status-bar" /* StatusBarModule */ , "api.getStatusPanel", this.context.getGridId())) return;
        const comp = this.statusBarService.getStatusPanel(key);
        return $437b23f6a393c3bf$var$unwrapUserComp(comp);
    }
    getColumnDef(key) {
        const column = this.columnModel.getPrimaryColumn(key);
        if (column) return column.getColDef();
        return null;
    }
    /**
   * Returns the current column definitions.
  */ getColumnDefs() {
        return this.columnModel.getColumnDefs();
    }
    /**
   * Informs the grid that a filter has changed. This is typically called after a filter change through one of the filter APIs.
   * @param source The source of the filter change event. If not specified defaults to `'api'`.
   */ onFilterChanged(source = "api") {
        this.filterManager.onFilterChanged({
            source: source
        });
    }
    /**
   * Gets the grid to act as if the sort was changed.
   * Useful if you update some values and want to get the grid to reorder them according to the new values.
   */ onSortChanged() {
        this.sortController.onSortChanged("api");
    }
    /**
   * Sets the state of all the column filters. Provide it with what you get from `getFilterModel()` to restore filter state.
   * If inferring cell data types, and row data is provided asynchronously and is yet to be set,
   * the filter model will be applied asynchronously after row data is added.
   * To always perform this synchronously, set `cellDataType = false` on the default column definition,
   * or provide cell data types for every column.
   */ setFilterModel(model) {
        this.frameworkOverrides.wrapIncoming(()=>this.filterManager.setFilterModel(model));
    }
    /** Gets the current state of all the column filters. Used for saving filter state. */ getFilterModel() {
        return this.filterManager.getFilterModel();
    }
    /**
   * Gets the current filter model for the specified column.
   * Will return `null` if no active filter.
   */ getColumnFilterModel(column) {
        return this.filterManager.getColumnFilterModel(column);
    }
    /**
   * Sets the filter model for the specified column.
   * Setting a `model` of `null` will reset the filter (make inactive).
   * Must wait on the response before calling `api.onFilterChanged()`.
   */ setColumnFilterModel(column, model) {
        return this.filterManager.setColumnFilterModel(column, model);
    }
    /** Returns the focused cell (or the last focused cell if the grid lost focus). */ getFocusedCell() {
        return this.focusService.getFocusedCell();
    }
    /** Clears the focused cell. */ clearFocusedCell() {
        return this.focusService.clearFocusedCell();
    }
    /** Sets the focus to the specified cell. `rowPinned` can be either 'top', 'bottom' or null (for not pinned). */ setFocusedCell(rowIndex, colKey, rowPinned) {
        this.focusService.setFocusedCell({
            rowIndex: rowIndex,
            column: colKey,
            rowPinned: rowPinned,
            forceBrowserFocus: true
        });
    }
    /** Adds a drop zone outside of the grid where rows can be dropped. */ addRowDropZone(params) {
        this.gridBodyCtrl.getRowDragFeature().addRowDropZone(params);
    }
    /** Removes an external drop zone added by `addRowDropZone`. */ removeRowDropZone(params) {
        const activeDropTarget = this.dragAndDropService.findExternalZone(params);
        if (activeDropTarget) this.dragAndDropService.removeDropTarget(activeDropTarget);
    }
    /** Returns the `RowDropZoneParams` to be used by another grid's `addRowDropZone` method. */ getRowDropZoneParams(events) {
        return this.gridBodyCtrl.getRowDragFeature().getRowDropZone(events);
    }
    assertSideBarLoaded(apiMethod) {
        return $437b23f6a393c3bf$export$dc053975cc7f6c11.__assertRegistered("@ag-grid-enterprise/side-bar" /* SideBarModule */ , "api." + apiMethod, this.context.getGridId());
    }
    /** Returns `true` if the side bar is visible. */ isSideBarVisible() {
        return this.assertSideBarLoaded("isSideBarVisible") && this.sideBarService.getSideBarComp().isDisplayed();
    }
    /** Show/hide the entire side bar, including any visible panel and the tab buttons. */ setSideBarVisible(show) {
        if (this.assertSideBarLoaded("setSideBarVisible")) this.sideBarService.getSideBarComp().setDisplayed(show);
    }
    /** Sets the side bar position relative to the grid. Possible values are `'left'` or `'right'`. */ setSideBarPosition(position) {
        if (this.assertSideBarLoaded("setSideBarPosition")) this.sideBarService.getSideBarComp().setSideBarPosition(position);
    }
    /** Opens a particular tool panel. Provide the ID of the tool panel to open. */ openToolPanel(key) {
        if (this.assertSideBarLoaded("openToolPanel")) this.sideBarService.getSideBarComp().openToolPanel(key, "api");
    }
    /** Closes the currently open tool panel (if any). */ closeToolPanel() {
        if (this.assertSideBarLoaded("closeToolPanel")) this.sideBarService.getSideBarComp().close("api");
    }
    /** Returns the ID of the currently shown tool panel if any, otherwise `null`. */ getOpenedToolPanel() {
        if (this.assertSideBarLoaded("getOpenedToolPanel")) return this.sideBarService.getSideBarComp().openedItem();
        return null;
    }
    /** Force refresh all tool panels by calling their `refresh` method. */ refreshToolPanel() {
        if (this.assertSideBarLoaded("refreshToolPanel")) this.sideBarService.getSideBarComp().refresh();
    }
    /** Returns `true` if the tool panel is showing, otherwise `false`. */ isToolPanelShowing() {
        return this.assertSideBarLoaded("isToolPanelShowing") && this.sideBarService.getSideBarComp().isToolPanelShowing();
    }
    /** Gets the tool panel instance corresponding to the supplied `id`. */ getToolPanelInstance(id) {
        if (this.assertSideBarLoaded("getToolPanelInstance")) {
            const comp = this.sideBarService.getSideBarComp().getToolPanelInstance(id);
            return $437b23f6a393c3bf$var$unwrapUserComp(comp);
        }
    }
    /** Returns the current side bar configuration. If a shortcut was used, returns the detailed long form. */ getSideBar() {
        if (this.assertSideBarLoaded("getSideBar")) return this.sideBarService.getSideBarComp().getDef();
        return void 0;
    }
    /** Tells the grid to recalculate the row heights. */ resetRowHeights() {
        if ($437b23f6a393c3bf$var$exists(this.clientSideRowModel)) {
            if (this.columnModel.isAutoRowHeightActive()) {
                console.warn("AG Grid: calling gridApi.resetRowHeights() makes no sense when using Auto Row Height.");
                return;
            }
            this.clientSideRowModel.resetRowHeights();
        }
    }
    /**
   * Sets the `rowCount` and `maxRowFound` properties.
   * The second parameter, `maxRowFound`, is optional and if left out, only `rowCount` is set.
   * Set `rowCount` to adjust the height of the vertical scroll.
   * Set `maxRowFound` to enable / disable searching for more rows.
   * Use this method if you add or remove rows into the dataset and need to reset the number of rows or instruct the grid that the entire row count is no longer known.
   */ setRowCount(rowCount, maxRowFound) {
        if (this.serverSideRowModel) {
            if (this.columnModel.isRowGroupEmpty()) {
                this.serverSideRowModel.setRowCount(rowCount, maxRowFound);
                return;
            }
            console.error("AG Grid: setRowCount cannot be used while using row grouping.");
            return;
        }
        if (this.infiniteRowModel) {
            this.infiniteRowModel.setRowCount(rowCount, maxRowFound);
            return;
        }
        this.logMissingRowModel("setRowCount", "infinite", "serverSide");
    }
    /** Tells the grid a row height has changed. To be used after calling `rowNode.setRowHeight(newHeight)`. */ onRowHeightChanged() {
        if (this.clientSideRowModel) this.clientSideRowModel.onRowHeightChanged();
        else if (this.serverSideRowModel) this.serverSideRowModel.onRowHeightChanged();
    }
    /**
   * @deprecated v31.3 Use `getCellValue` instead.
   */ getValue(colKey, rowNode) {
        this.logDeprecation("31.3", "getValue", "getCellValue");
        return this.getCellValue({
            colKey: colKey,
            rowNode: rowNode
        });
    }
    getCellValue(params) {
        var _a;
        const { colKey: colKey, rowNode: rowNode, useFormatter: useFormatter } = params;
        let column = (_a = this.columnModel.getPrimaryColumn(colKey)) != null ? _a : this.columnModel.getGridColumn(colKey);
        if ($437b23f6a393c3bf$var$missing(column)) return null;
        const value = this.valueService.getValue(column, rowNode);
        if (useFormatter) {
            const formattedValue = this.valueService.formatValue(column, rowNode, value);
            return formattedValue != null ? formattedValue : $437b23f6a393c3bf$var$escapeString(value, true);
        }
        return value;
    }
    /**
   * Add an event listener for the specified `eventType`.
   * Works similar to `addEventListener` for a browser DOM element.
   * Listeners will be automatically removed when the grid is destroyed.
   */ addEventListener(eventType, listener) {
        this.apiEventService.addEventListener(eventType, listener);
    }
    /**
   * Add an event listener for all event types coming from the grid.
   * Listeners will be automatically removed when the grid is destroyed.
   */ addGlobalListener(listener) {
        this.apiEventService.addGlobalListener(listener);
    }
    /** Remove an event listener. */ removeEventListener(eventType, listener) {
        this.apiEventService.removeEventListener(eventType, listener);
    }
    /** Remove a global event listener. */ removeGlobalListener(listener) {
        this.apiEventService.removeGlobalListener(listener);
    }
    dispatchEvent(event) {
        this.eventService.dispatchEvent(event);
    }
    /** Will destroy the grid and release resources. If you are using a framework you do not need to call this, as the grid links in with the framework lifecycle. However if you are using Web Components or native JavaScript, you do need to call this, to avoid a memory leak in your application. */ destroy() {
        var _a;
        const preDestroyLink = `See ${this.frameworkOverrides.getDocLink("grid-lifecycle/#grid-pre-destroyed")}`;
        if (this.destroyCalled) return;
        const event = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_GRID_PRE_DESTROYED,
            state: this.getState()
        };
        this.dispatchEvent(event);
        this.destroyCalled = true;
        (_a = this.ctrlsService.get("gridCtrl")) == null || _a.destroyGridUi();
        this.context.destroy();
        this.detailGridInfoMap = {};
        $437b23f6a393c3bf$var$removeAllReferences(this, [
            "isDestroyed"
        ], preDestroyLink);
    }
    /** Returns `true` if the grid has been destroyed. */ isDestroyed() {
        return this.destroyCalled;
    }
    /** Reset the Quick Filter cache text on every rowNode. */ resetQuickFilter() {
        this.filterManager.resetQuickFilterCache();
    }
    /** Returns the list of selected cell ranges. */ getCellRanges() {
        if (this.rangeService) return this.rangeService.getCellRanges();
        $437b23f6a393c3bf$export$dc053975cc7f6c11.__assertRegistered("@ag-grid-enterprise/range-selection" /* RangeSelectionModule */ , "api.getCellRanges", this.context.getGridId());
        return null;
    }
    /** Adds the provided cell range to the selected ranges. */ addCellRange(params) {
        if (this.rangeService) {
            this.rangeService.addCellRange(params);
            return;
        }
        $437b23f6a393c3bf$export$dc053975cc7f6c11.__assertRegistered("@ag-grid-enterprise/range-selection" /* RangeSelectionModule */ , "api.addCellRange", this.context.getGridId());
    }
    /** Clears the selected ranges. */ clearRangeSelection() {
        if (this.rangeService) this.rangeService.removeAllCellRanges();
        $437b23f6a393c3bf$export$dc053975cc7f6c11.__assertRegistered("@ag-grid-enterprise/range-selection" /* RangeSelectionModule */ , "gridApi.clearRangeSelection", this.context.getGridId());
    }
    /** Reverts the last cell edit. */ undoCellEditing() {
        this.undoRedoService.undo("api");
    }
    /** Re-applies the most recently undone cell edit. */ redoCellEditing() {
        this.undoRedoService.redo("api");
    }
    /** Returns current number of available cell edit undo operations. */ getCurrentUndoSize() {
        return this.undoRedoService.getCurrentUndoStackSize();
    }
    /** Returns current number of available cell edit redo operations. */ getCurrentRedoSize() {
        return this.undoRedoService.getCurrentRedoStackSize();
    }
    assertChart(methodName, func) {
        if ($437b23f6a393c3bf$export$dc053975cc7f6c11.__assertRegistered("@ag-grid-enterprise/charts" /* GridChartsModule */ , "api." + methodName, this.context.getGridId())) return this.frameworkOverrides.wrapIncoming(()=>func());
    }
    /** Returns a list of models with information about the charts that are currently rendered from the grid. */ getChartModels() {
        return this.assertChart("getChartModels", ()=>this.chartService.getChartModels());
    }
    /** Returns the `ChartRef` using the supplied `chartId`. */ getChartRef(chartId) {
        return this.assertChart("getChartRef", ()=>this.chartService.getChartRef(chartId));
    }
    /** Returns a base64-encoded image data URL for the referenced chartId. */ getChartImageDataURL(params) {
        return this.assertChart("getChartImageDataURL", ()=>this.chartService.getChartImageDataURL(params));
    }
    /** Starts a browser-based image download for the referenced chartId. */ downloadChart(params) {
        return this.assertChart("downloadChart", ()=>this.chartService.downloadChart(params));
    }
    /** Open the Chart Tool Panel. */ openChartToolPanel(params) {
        return this.assertChart("openChartToolPanel", ()=>this.chartService.openChartToolPanel(params));
    }
    /** Close the Chart Tool Panel. */ closeChartToolPanel(params) {
        return this.assertChart("closeChartToolPanel", ()=>this.chartService.closeChartToolPanel(params.chartId));
    }
    /** Used to programmatically create charts from a range. */ createRangeChart(params) {
        return this.assertChart("createRangeChart", ()=>this.chartService.createRangeChart(params));
    }
    /** Used to programmatically create pivot charts from a grid. */ createPivotChart(params) {
        return this.assertChart("createPivotChart", ()=>this.chartService.createPivotChart(params));
    }
    /** Used to programmatically create cross filter charts from a range. */ createCrossFilterChart(params) {
        return this.assertChart("createCrossFilterChart", ()=>this.chartService.createCrossFilterChart(params));
    }
    /** Used to programmatically update a chart. */ updateChart(params) {
        return this.assertChart("updateChart", ()=>this.chartService.updateChart(params));
    }
    /** Restores a chart using the `ChartModel` that was previously obtained from `getChartModels()`. */ restoreChart(chartModel, chartContainer) {
        return this.assertChart("restoreChart", ()=>this.chartService.restoreChart(chartModel, chartContainer));
    }
    assertClipboard(methodName, func) {
        if ($437b23f6a393c3bf$export$dc053975cc7f6c11.__assertRegistered("@ag-grid-enterprise/clipboard" /* ClipboardModule */ , "api" + methodName, this.context.getGridId())) func();
    }
    /** Copies data to clipboard by following the same rules as pressing Ctrl+C. */ copyToClipboard(params) {
        this.assertClipboard("copyToClipboard", ()=>this.clipboardService.copyToClipboard(params));
    }
    /** Cuts data to clipboard by following the same rules as pressing Ctrl+X. */ cutToClipboard(params) {
        this.assertClipboard("cutToClipboard", ()=>this.clipboardService.cutToClipboard(params));
    }
    /** Copies the selected rows to the clipboard. */ copySelectedRowsToClipboard(params) {
        this.assertClipboard("copySelectedRowsToClipboard", ()=>this.clipboardService.copySelectedRowsToClipboard(params));
    }
    /** Copies the selected ranges to the clipboard. */ copySelectedRangeToClipboard(params) {
        this.assertClipboard("copySelectedRangeToClipboard", ()=>this.clipboardService.copySelectedRangeToClipboard(params));
    }
    /** Copies the selected range down, similar to `Ctrl + D` in Excel. */ copySelectedRangeDown() {
        this.assertClipboard("copySelectedRangeDown", ()=>this.clipboardService.copyRangeDown());
    }
    /** Pastes the data from the Clipboard into the focused cell of the grid. If no grid cell is focused, calling this method has no effect. */ pasteFromClipboard() {
        this.assertClipboard("pasteFromClipboard", ()=>this.clipboardService.pasteFromClipboard());
    }
    /** @deprecated v31.1 Use `IHeaderParams.showColumnMenu` within a header component, or `api.showColumnMenu` elsewhere. */ showColumnMenuAfterButtonClick(colKey, buttonElement) {
        $437b23f6a393c3bf$var$warnOnce(`'showColumnMenuAfterButtonClick' is deprecated. Use 'IHeaderParams.showColumnMenu' within a header component, or 'api.showColumnMenu' elsewhere.`);
        const column = this.columnModel.getGridColumn(colKey);
        this.menuService.showColumnMenu({
            column: column,
            buttonElement: buttonElement,
            positionBy: "button"
        });
    }
    /** @deprecated v31.1 Use `IHeaderParams.showColumnMenuAfterMouseClick` within a header component, or `api.showColumnMenu` elsewhere. */ showColumnMenuAfterMouseClick(colKey, mouseEvent) {
        $437b23f6a393c3bf$var$warnOnce(`'showColumnMenuAfterMouseClick' is deprecated. Use 'IHeaderParams.showColumnMenuAfterMouseClick' within a header component, or 'api.showColumnMenu' elsewhere.`);
        let column = this.columnModel.getGridColumn(colKey);
        if (!column) column = this.columnModel.getPrimaryColumn(colKey);
        if (!column) {
            console.error(`AG Grid: column '${colKey}' not found`);
            return;
        }
        this.menuService.showColumnMenu({
            column: column,
            mouseEvent: mouseEvent,
            positionBy: "mouse"
        });
    }
    /**
   * Displays the AG Grid context menu
   */ showContextMenu(params) {
        const { rowNode: rowNode, column: column, value: value, x: x, y: y } = params || {};
        let { x: clientX, y: clientY } = this.menuService.getContextMenuPosition(rowNode, column);
        if (x != null) clientX = x;
        if (y != null) clientY = y;
        this.menuService.showContextMenu({
            mouseEvent: new MouseEvent("mousedown", {
                clientX: clientX,
                clientY: clientY
            }),
            rowNode: rowNode,
            column: column,
            value: value
        });
    }
    /** Show the column chooser. */ showColumnChooser(params) {
        this.menuService.showColumnChooser({
            chooserParams: params
        });
    }
    /** Show the filter for the provided column. */ showColumnFilter(colKey) {
        const column = this.columnModel.getGridColumn(colKey);
        if (!column) {
            console.error(`AG Grid: column '${colKey}' not found`);
            return;
        }
        this.menuService.showFilterMenu({
            column: column,
            containerType: "columnFilter",
            positionBy: "auto"
        });
    }
    /** Show the column menu for the provided column. */ showColumnMenu(colKey) {
        const column = this.columnModel.getGridColumn(colKey);
        if (!column) {
            console.error(`AG Grid: column '${colKey}' not found`);
            return;
        }
        this.menuService.showColumnMenu({
            column: column,
            positionBy: "auto"
        });
    }
    /** Hides any visible context menu or column menu. */ hidePopupMenu() {
        this.menuService.hidePopupMenu();
    }
    /** Hide the column chooser if visible. */ hideColumnChooser() {
        this.menuService.hideColumnChooser();
    }
    /** Navigates the grid focus to the next cell, as if tabbing. */ tabToNextCell(event) {
        return this.navigationService.tabToNextCell(false, event);
    }
    /** Navigates the grid focus to the previous cell, as if shift-tabbing. */ tabToPreviousCell(event) {
        return this.navigationService.tabToNextCell(true, event);
    }
    /** Returns the list of active cell renderer instances. */ getCellRendererInstances(params = {}) {
        const res = this.rowRenderer.getCellRendererInstances(params);
        const unwrapped = res.map($437b23f6a393c3bf$var$unwrapUserComp);
        return unwrapped;
    }
    /** Returns the list of active cell editor instances. Optionally provide parameters to restrict to certain columns / row nodes. */ getCellEditorInstances(params = {}) {
        const res = this.rowRenderer.getCellEditorInstances(params);
        const unwrapped = res.map($437b23f6a393c3bf$var$unwrapUserComp);
        return unwrapped;
    }
    /** If the grid is editing, returns back details of the editing cell(s). */ getEditingCells() {
        return this.rowRenderer.getEditingCells();
    }
    /** If a cell is editing, it stops the editing. Pass `true` if you want to cancel the editing (i.e. don't accept changes). */ stopEditing(cancel = false) {
        this.rowRenderer.stopEditing(cancel);
    }
    /** Start editing the provided cell. If another cell is editing, the editing will be stopped in that other cell. */ startEditingCell(params) {
        const column = this.columnModel.getGridColumn(params.colKey);
        if (!column) {
            console.warn(`AG Grid: no column found for ${params.colKey}`);
            return;
        }
        const cellPosition = {
            rowIndex: params.rowIndex,
            rowPinned: params.rowPinned || null,
            column: column
        };
        const notPinned = params.rowPinned == null;
        if (notPinned) this.ensureIndexVisible(params.rowIndex);
        this.ensureColumnVisible(params.colKey);
        const cell = this.navigationService.getCellByPosition(cellPosition);
        if (!cell) return;
        if (!this.focusService.isCellFocused(cellPosition)) this.focusService.setFocusedCell(cellPosition);
        cell.startRowOrCellEdit(params.key);
    }
    /** @deprecated v31.1 addAggFunc(key, func) is  deprecated, please use addAggFuncs({ key: func }) instead. */ addAggFunc(key, aggFunc) {
        this.logDeprecation("v31.1", "addAggFunc(key, func)", "addAggFuncs({ key: func })");
        if (this.aggFuncService) this.aggFuncService.addAggFuncs({
            key: aggFunc
        });
    }
    /** Add aggregations function with the specified keys. */ addAggFuncs(aggFuncs) {
        if (this.aggFuncService) this.aggFuncService.addAggFuncs(aggFuncs);
    }
    /** Clears all aggregation functions (including those provided by the grid). */ clearAggFuncs() {
        if (this.aggFuncService) this.aggFuncService.clear();
    }
    /** Apply transactions to the server side row model. */ applyServerSideTransaction(transaction) {
        if (!this.serverSideTransactionManager) {
            this.logMissingRowModel("applyServerSideTransaction", "serverSide");
            return;
        }
        return this.serverSideTransactionManager.applyTransaction(transaction);
    }
    /** Batch apply transactions to the server side row model. */ applyServerSideTransactionAsync(transaction, callback) {
        if (!this.serverSideTransactionManager) {
            this.logMissingRowModel("applyServerSideTransactionAsync", "serverSide");
            return;
        }
        return this.serverSideTransactionManager.applyTransactionAsync(transaction, callback);
    }
    /**
   * Applies row data to a server side store.
   * New rows will overwrite rows at the same index in the same way as if provided by a datasource success callback.
  */ applyServerSideRowData(params) {
        var _a, _b;
        const startRow = (_a = params.startRow) != null ? _a : 0;
        const route = (_b = params.route) != null ? _b : [];
        if (startRow < 0) {
            console.warn(`AG Grid: invalid value ${params.startRow} for startRow, the value should be >= 0`);
            return;
        }
        if (this.serverSideRowModel) this.serverSideRowModel.applyRowData(params.successParams, startRow, route);
        else this.logMissingRowModel("setServerSideDatasource", "serverSide");
    }
    /** Gets all failed server side loads to retry. */ retryServerSideLoads() {
        if (!this.serverSideRowModel) {
            this.logMissingRowModel("retryServerSideLoads", "serverSide");
            return;
        }
        this.serverSideRowModel.retryLoads();
    }
    flushServerSideAsyncTransactions() {
        if (!this.serverSideTransactionManager) {
            this.logMissingRowModel("flushServerSideAsyncTransactions", "serverSide");
            return;
        }
        return this.serverSideTransactionManager.flushAsyncTransactions();
    }
    /** Update row data. Pass a transaction object with lists for `add`, `remove` and `update`. */ applyTransaction(rowDataTransaction) {
        if (!this.clientSideRowModel) {
            this.logMissingRowModel("applyTransaction", "clientSide");
            return;
        }
        return this.frameworkOverrides.wrapIncoming(()=>this.clientSideRowModel.updateRowData(rowDataTransaction));
    }
    /** Same as `applyTransaction` except executes asynchronously for efficiency. */ applyTransactionAsync(rowDataTransaction, callback) {
        if (!this.clientSideRowModel) {
            this.logMissingRowModel("applyTransactionAsync", "clientSide");
            return;
        }
        this.frameworkOverrides.wrapIncoming(()=>this.clientSideRowModel.batchUpdateRowData(rowDataTransaction, callback));
    }
    /** Executes any remaining asynchronous grid transactions, if any are waiting to be executed. */ flushAsyncTransactions() {
        if (!this.clientSideRowModel) {
            this.logMissingRowModel("flushAsyncTransactions", "clientSide");
            return;
        }
        this.frameworkOverrides.wrapIncoming(()=>this.clientSideRowModel.flushAsyncTransactions());
    }
    /**
   * Marks all the currently loaded blocks in the cache for reload.
   * If you have 10 blocks in the cache, all 10 will be marked for reload.
   * The old data will continue to be displayed until the new data is loaded.
   */ refreshInfiniteCache() {
        if (this.infiniteRowModel) this.infiniteRowModel.refreshCache();
        else this.logMissingRowModel("refreshInfiniteCache", "infinite");
    }
    /**
   * Purges the cache.
   * The grid is then told to refresh. Only the blocks required to display the current data on screen are fetched (typically no more than 2).
   * The grid will display nothing while the new blocks are loaded.
   * Use this to immediately remove the old data from the user.
   */ purgeInfiniteCache() {
        if (this.infiniteRowModel) this.infiniteRowModel.purgeCache();
        else this.logMissingRowModel("purgeInfiniteCache", "infinite");
    }
    /**
   * Refresh a server-side store level.
   * If you pass no parameters, then the top level store is refreshed.
   * To refresh a child level, pass in the string of keys to get to the desired level.
   * Once the store refresh is complete, the storeRefreshed event is fired.
   */ refreshServerSide(params) {
        if (!this.serverSideRowModel) {
            this.logMissingRowModel("refreshServerSide", "serverSide");
            return;
        }
        this.serverSideRowModel.refreshStore(params);
    }
    /** Returns info on all server side group levels. */ getServerSideGroupLevelState() {
        if (!this.serverSideRowModel) {
            this.logMissingRowModel("getServerSideGroupLevelState", "serverSide");
            return [];
        }
        return this.serverSideRowModel.getStoreState();
    }
    /** The row count defines how many rows the grid allows scrolling to. */ getInfiniteRowCount() {
        if (this.infiniteRowModel) return this.infiniteRowModel.getRowCount();
        else this.logMissingRowModel("getInfiniteRowCount", "infinite");
    }
    /** Returns `true` if grid allows for scrolling past the last row to load more rows, thus providing infinite scroll. */ isLastRowIndexKnown() {
        if (this.infiniteRowModel) return this.infiniteRowModel.isLastRowIndexKnown();
        else this.logMissingRowModel("isLastRowIndexKnown", "infinite");
    }
    /**
   * Returns an object representing the state of the cache. This is useful for debugging and understanding how the cache is working.
   */ getCacheBlockState() {
        return this.rowNodeBlockLoader.getBlockState();
    }
    /** @deprecated v31.1 `getFirstDisplayedRow` is deprecated. Please use `getFirstDisplayedRowIndex` instead. */ getFirstDisplayedRow() {
        this.logDeprecation("v31.1", "getFirstDisplayedRow", "getFirstDisplayedRowIndex");
        return this.getFirstDisplayedRowIndex();
    }
    /** Get the index of the first displayed row due to scrolling (includes invisible rendered rows in the buffer). */ getFirstDisplayedRowIndex() {
        return this.rowRenderer.getFirstVirtualRenderedRow();
    }
    /** @deprecated v31.1 `getLastDisplayedRow` is deprecated. Please use `getLastDisplayedRowIndex` instead. */ getLastDisplayedRow() {
        this.logDeprecation("v31.1", "getLastDisplayedRow", "getLastDisplayedRowIndex");
        return this.getLastDisplayedRowIndex();
    }
    /** Get the index of the last displayed row due to scrolling (includes invisible rendered rows in the buffer). */ getLastDisplayedRowIndex() {
        return this.rowRenderer.getLastVirtualRenderedRow();
    }
    /** Returns the displayed `RowNode` at the given `index`. */ getDisplayedRowAtIndex(index) {
        return this.rowModel.getRow(index);
    }
    /** Returns the total number of displayed rows. */ getDisplayedRowCount() {
        return this.rowModel.getRowCount();
    }
    /**
   * Returns `true` when the last page is known.
   * This will always be `true` if you are using the Client-Side Row Model for pagination.
   * Returns `false` when the last page is not known; this only happens when using Infinite Row Model.
   */ paginationIsLastPageFound() {
        return this.paginationProxy.isLastPageFound();
    }
    /** Returns how many rows are being shown per page. */ paginationGetPageSize() {
        return this.paginationProxy.getPageSize();
    }
    /** Returns the 0-based index of the page which is showing. */ paginationGetCurrentPage() {
        return this.paginationProxy.getCurrentPage();
    }
    /** Returns the total number of pages. Returns `null` if `paginationIsLastPageFound() === false`. */ paginationGetTotalPages() {
        return this.paginationProxy.getTotalPages();
    }
    /** The total number of rows. Returns `null` if `paginationIsLastPageFound() === false`. */ paginationGetRowCount() {
        return this.paginationProxy.getMasterRowCount();
    }
    /** Navigates to the next page. */ paginationGoToNextPage() {
        this.paginationProxy.goToNextPage();
    }
    /** Navigates to the previous page. */ paginationGoToPreviousPage() {
        this.paginationProxy.goToPreviousPage();
    }
    /** Navigates to the first page. */ paginationGoToFirstPage() {
        this.paginationProxy.goToFirstPage();
    }
    /** Navigates to the last page. */ paginationGoToLastPage() {
        this.paginationProxy.goToLastPage();
    }
    /** Goes to the specified page. If the page requested doesn't exist, it will go to the last page. */ paginationGoToPage(page) {
        this.paginationProxy.goToPage(page);
    }
    // Methods migrated from old ColumnApi
    /**
   * Adjusts the size of columns to fit the available horizontal space.
   *
   * Note: it is not recommended to call this method rapidly e.g. in response
   * to window resize events or as the container size is animated. This can
   * cause the scrollbar to flicker. Use column flex for smoother results.
   * 
   * If inferring cell data types with custom column types
   * and row data is provided asynchronously, the column sizing will happen asynchronously when row data is added.
   * To always perform this synchronously, set `cellDataType = false` on the default column definition.
   **/ sizeColumnsToFit(paramsOrGridWidth) {
        if (typeof paramsOrGridWidth === "number") this.columnModel.sizeColumnsToFit(paramsOrGridWidth, "api");
        else this.gridBodyCtrl.sizeColumnsToFit(paramsOrGridWidth);
    }
    /** Call this if you want to open or close a column group. */ setColumnGroupOpened(group, newValue) {
        this.columnModel.setColumnGroupOpened(group, newValue, "api");
    }
    /** Returns the column group with the given name. */ getColumnGroup(name, instanceId) {
        return this.columnModel.getColumnGroup(name, instanceId);
    }
    /** Returns the provided column group with the given name. */ getProvidedColumnGroup(name) {
        return this.columnModel.getProvidedColumnGroup(name);
    }
    /** Returns the display name for a column. Useful if you are doing your own header rendering and want the grid to work out if `headerValueGetter` is used, or if you are doing your own column management GUI, to know what to show as the column name. */ getDisplayNameForColumn(column, location) {
        return this.columnModel.getDisplayNameForColumn(column, location) || "";
    }
    /** Returns the display name for a column group (when grouping columns). */ getDisplayNameForColumnGroup(columnGroup, location) {
        return this.columnModel.getDisplayNameForColumnGroup(columnGroup, location) || "";
    }
    /** Returns the column with the given `colKey`, which can either be the `colId` (a string) or the `colDef` (an object). */ getColumn(key) {
        return this.columnModel.getPrimaryColumn(key);
    }
    /** Returns all the columns, regardless of visible or not. */ getColumns() {
        return this.columnModel.getAllPrimaryColumns();
    }
    /** Applies the state of the columns from a previous state. Returns `false` if one or more columns could not be found. */ applyColumnState(params) {
        return this.columnModel.applyColumnState(params, "api");
    }
    /** Gets the state of the columns. Typically used when saving column state. */ getColumnState() {
        return this.columnModel.getColumnState();
    }
    /** Sets the state back to match the originally provided column definitions. */ resetColumnState() {
        this.columnModel.resetColumnState("api");
    }
    /** Gets the state of the column groups. Typically used when saving column group state. */ getColumnGroupState() {
        return this.columnModel.getColumnGroupState();
    }
    /** Sets the state of the column group state from a previous state. */ setColumnGroupState(stateItems) {
        this.columnModel.setColumnGroupState(stateItems, "api");
    }
    /** Sets the state back to match the originally provided column definitions. */ resetColumnGroupState() {
        this.columnModel.resetColumnGroupState("api");
    }
    /** Returns `true` if pinning left or right, otherwise `false`. */ isPinning() {
        return this.columnModel.isPinningLeft() || this.columnModel.isPinningRight();
    }
    /** Returns `true` if pinning left, otherwise `false`. */ isPinningLeft() {
        return this.columnModel.isPinningLeft();
    }
    /** Returns `true` if pinning right, otherwise `false`. */ isPinningRight() {
        return this.columnModel.isPinningRight();
    }
    /** Returns the column to the right of the provided column, taking into consideration open / closed column groups and visible columns. This is useful if you need to know what column is beside yours e.g. if implementing your own cell navigation. */ getDisplayedColAfter(col) {
        return this.columnModel.getDisplayedColAfter(col);
    }
    /** Same as `getVisibleColAfter` except gives column to the left. */ getDisplayedColBefore(col) {
        return this.columnModel.getDisplayedColBefore(col);
    }
    /** @deprecated v31.1 setColumnVisible(key, visible) deprecated, please use setColumnsVisible([key], visible) instead. */ setColumnVisible(key, visible) {
        this.logDeprecation("v31.1", "setColumnVisible(key,visible)", "setColumnsVisible([key],visible)");
        this.columnModel.setColumnsVisible([
            key
        ], visible, "api");
    }
    /** Sets the visibility of columns. Key can be the column ID or `Column` object. */ setColumnsVisible(keys2, visible) {
        this.columnModel.setColumnsVisible(keys2, visible, "api");
    }
    /** @deprecated v31.1 setColumnPinned(key, pinned) deprecated, please use setColumnsPinned([key], pinned) instead. */ setColumnPinned(key, pinned) {
        this.logDeprecation("v31.1", "setColumnPinned(key,pinned)", "setColumnsPinned([key],pinned)");
        this.columnModel.setColumnsPinned([
            key
        ], pinned, "api");
    }
    /** Set a column's pinned / unpinned state. Key can be the column ID, field, `ColDef` object or `Column` object. */ setColumnsPinned(keys2, pinned) {
        this.columnModel.setColumnsPinned(keys2, pinned, "api");
    }
    /**
   * Returns all the grid columns, same as `getColumns()`, except
   *
   *  a) it has the order of the columns that are presented in the grid
   *
   *  b) it's after the 'pivot' step, so if pivoting, has the value columns for the pivot.
   */ getAllGridColumns() {
        return this.columnModel.getAllGridColumns();
    }
    /** Same as `getAllDisplayedColumns` but just for the pinned left portion of the grid. */ getDisplayedLeftColumns() {
        return this.columnModel.getDisplayedLeftColumns();
    }
    /** Same as `getAllDisplayedColumns` but just for the center portion of the grid. */ getDisplayedCenterColumns() {
        return this.columnModel.getDisplayedCenterColumns();
    }
    /** Same as `getAllDisplayedColumns` but just for the pinned right portion of the grid. */ getDisplayedRightColumns() {
        return this.columnModel.getDisplayedRightColumns();
    }
    /** Returns all columns currently displayed (e.g. are visible and if in a group, the group is showing the columns) for the pinned left, centre and pinned right portions of the grid. */ getAllDisplayedColumns() {
        return this.columnModel.getAllDisplayedColumns();
    }
    /** Same as `getAllGridColumns()`, except only returns rendered columns, i.e. columns that are not within the viewport and therefore not rendered, due to column virtualisation, are not displayed. */ getAllDisplayedVirtualColumns() {
        return this.columnModel.getViewportColumns();
    }
    /** @deprecated v31.1 moveColumn(key, toIndex) deprecated, please use moveColumns([key], toIndex) instead. */ moveColumn(key, toIndex) {
        this.logDeprecation("v31.1", "moveColumn(key, toIndex)", "moveColumns([key], toIndex)");
        this.columnModel.moveColumns([
            key
        ], toIndex, "api");
    }
    /** Moves the column at `fromIdex` to `toIndex`. The column is first removed, then added at the `toIndex` location, thus index locations will change to the right of the column after the removal. */ moveColumnByIndex(fromIndex, toIndex) {
        this.columnModel.moveColumnByIndex(fromIndex, toIndex, "api");
    }
    /** Moves columns to `toIndex`. The columns are first removed, then added at the `toIndex` location, thus index locations will change to the right of the column after the removal. */ moveColumns(columnsToMoveKeys, toIndex) {
        this.columnModel.moveColumns(columnsToMoveKeys, toIndex, "api");
    }
    /** Move the column to a new position in the row grouping order. */ moveRowGroupColumn(fromIndex, toIndex) {
        this.columnModel.moveRowGroupColumn(fromIndex, toIndex, "api");
    }
    /** Sets the agg function for a column. `aggFunc` can be one of the built-in aggregations or a custom aggregation by name or direct function. */ setColumnAggFunc(key, aggFunc) {
        this.columnModel.setColumnAggFunc(key, aggFunc, "api");
    }
    /** @deprecated v31.1 setColumnWidths(key, newWidth) deprecated, please use setColumnWidths( [{key: newWidth}] ) instead. */ setColumnWidth(key, newWidth, finished = true, source = "api") {
        this.logDeprecation("v31.1", "setColumnWidth(col, width)", "setColumnWidths([{key: col, newWidth: width}])");
        this.columnModel.setColumnWidths([
            {
                key: key,
                newWidth: newWidth
            }
        ], false, finished, source);
    }
    /** Sets the column widths of the columns provided. The finished flag gets included in the resulting event and not used internally by the grid. The finished flag is intended for dragging, where a dragging action will produce many `columnWidth` events, so the consumer of events knows when it receives the last event in a stream. The finished parameter is optional, and defaults to `true`. */ setColumnWidths(columnWidths, finished = true, source = "api") {
        this.columnModel.setColumnWidths(columnWidths, false, finished, source);
    }
    /** Get the pivot mode. */ isPivotMode() {
        return this.columnModel.isPivotMode();
    }
    /** Returns the pivot result column for the given `pivotKeys` and `valueColId`. Useful to then call operations on the pivot column. */ getPivotResultColumn(pivotKeys, valueColKey) {
        return this.columnModel.getSecondaryPivotColumn(pivotKeys, valueColKey);
    }
    /** Set the value columns to the provided list of columns. */ setValueColumns(colKeys) {
        this.columnModel.setValueColumns(colKeys, "api");
    }
    /** Get a list of the existing value columns. */ getValueColumns() {
        return this.columnModel.getValueColumns();
    }
    /** @deprecated v31.1 removeValueColumn(colKey) deprecated, please use removeValueColumns([colKey]) instead. */ removeValueColumn(colKey) {
        this.logDeprecation("v31.1", "removeValueColumn(colKey)", "removeValueColumns([colKey])");
        this.columnModel.removeValueColumns([
            colKey
        ], "api");
    }
    /** Remove the given list of columns from the existing set of value columns. */ removeValueColumns(colKeys) {
        this.columnModel.removeValueColumns(colKeys, "api");
    }
    /** @deprecated v31.1 addValueColumn(colKey) deprecated, please use addValueColumns([colKey]) instead. */ addValueColumn(colKey) {
        this.logDeprecation("v31.1", "addValueColumn(colKey)", "addValueColumns([colKey])");
        this.columnModel.addValueColumns([
            colKey
        ], "api");
    }
    /** Add the given list of columns to the existing set of value columns. */ addValueColumns(colKeys) {
        this.columnModel.addValueColumns(colKeys, "api");
    }
    /** Set the row group columns. */ setRowGroupColumns(colKeys) {
        this.columnModel.setRowGroupColumns(colKeys, "api");
    }
    /** @deprecated v31.1 removeRowGroupColumn(colKey) deprecated, please use removeRowGroupColumns([colKey]) instead. */ removeRowGroupColumn(colKey) {
        this.logDeprecation("v31.1", "removeRowGroupColumn(colKey)", "removeRowGroupColumns([colKey])");
        this.columnModel.removeRowGroupColumns([
            colKey
        ], "api");
    }
    /** Remove columns from the row groups. */ removeRowGroupColumns(colKeys) {
        this.columnModel.removeRowGroupColumns(colKeys, "api");
    }
    /** @deprecated v31.1 addRowGroupColumn(colKey) deprecated, please use addRowGroupColumns([colKey]) instead. */ addRowGroupColumn(colKey) {
        this.logDeprecation("v31.1", "addRowGroupColumn(colKey)", "addRowGroupColumns([colKey])");
        this.columnModel.addRowGroupColumns([
            colKey
        ], "api");
    }
    /** Add columns to the row groups. */ addRowGroupColumns(colKeys) {
        this.columnModel.addRowGroupColumns(colKeys, "api");
    }
    /** Get row group columns. */ getRowGroupColumns() {
        return this.columnModel.getRowGroupColumns();
    }
    /** Set the pivot columns. */ setPivotColumns(colKeys) {
        this.columnModel.setPivotColumns(colKeys, "api");
    }
    /** @deprecated v31.1 removePivotColumn(colKey) deprecated, please use removePivotColumns([colKey]) instead. */ removePivotColumn(colKey) {
        this.logDeprecation("v31.1", "removePivotColumn(colKey)", "removePivotColumns([colKey])");
        this.columnModel.removePivotColumns([
            colKey
        ], "api");
    }
    /** Remove pivot columns. */ removePivotColumns(colKeys) {
        this.columnModel.removePivotColumns(colKeys, "api");
    }
    /** @deprecated v31.1 addPivotColumn(colKey) deprecated, please use addPivotColumns([colKey]) instead. */ addPivotColumn(colKey) {
        this.logDeprecation("v31.1", "addPivotColumn(colKey)", "addPivotColumns([colKey])");
        this.columnModel.addPivotColumns([
            colKey
        ], "api");
    }
    /** Add pivot columns. */ addPivotColumns(colKeys) {
        this.columnModel.addPivotColumns(colKeys, "api");
    }
    /** Get the pivot columns. */ getPivotColumns() {
        return this.columnModel.getPivotColumns();
    }
    /** Same as `getAllDisplayedColumnGroups` but just for the pinned left portion of the grid. */ getLeftDisplayedColumnGroups() {
        return this.columnModel.getDisplayedTreeLeft();
    }
    /** Same as `getAllDisplayedColumnGroups` but just for the center portion of the grid. */ getCenterDisplayedColumnGroups() {
        return this.columnModel.getDisplayedTreeCentre();
    }
    /** Same as `getAllDisplayedColumnGroups` but just for the pinned right portion of the grid. */ getRightDisplayedColumnGroups() {
        return this.columnModel.getDisplayedTreeRight();
    }
    /** Returns all 'root' column headers. If you are not grouping columns, these return the columns. If you are grouping, these return the top level groups - you can navigate down through each one to get the other lower level headers and finally the columns at the bottom. */ getAllDisplayedColumnGroups() {
        return this.columnModel.getAllDisplayedTrees();
    }
    /** @deprecated v31.1 autoSizeColumn(key) deprecated, please use autoSizeColumns([colKey]) instead. */ autoSizeColumn(key, skipHeader) {
        this.logDeprecation("v31.1", "autoSizeColumn(key, skipHeader)", "autoSizeColumns([key], skipHeader)");
        return this.columnModel.autoSizeColumns({
            columns: [
                key
            ],
            skipHeader: skipHeader,
            source: "api"
        });
    }
    /**
   * Auto-sizes columns based on their contents. If inferring cell data types with custom column types
   * and row data is provided asynchronously, the column sizing will happen asynchronously when row data is added.
   * To always perform this synchronously, set `cellDataType = false` on the default column definition.
   */ autoSizeColumns(keys2, skipHeader) {
        this.columnModel.autoSizeColumns({
            columns: keys2,
            skipHeader: skipHeader,
            source: "api"
        });
    }
    /**
   * Calls `autoSizeColumns` on all displayed columns. If inferring cell data types with custom column types
   * and row data is provided asynchronously, the column sizing will happen asynchronously when row data is added.
   * To always perform this synchronously, set `cellDataType = false` on the default column definition.
   */ autoSizeAllColumns(skipHeader) {
        this.columnModel.autoSizeAllColumns("api", skipHeader);
    }
    /** Set the pivot result columns. */ setPivotResultColumns(colDefs) {
        this.columnModel.setSecondaryColumns(colDefs, "api");
    }
    /** Returns the grid's pivot result columns. */ getPivotResultColumns() {
        return this.columnModel.getSecondaryColumns();
    }
    /** Get the current state of the grid. Can be used in conjunction with the `initialState` grid option to save and restore grid state. */ getState() {
        return this.stateService.getState();
    }
    /**
   * Returns the grid option value for a provided key.
   */ getGridOption(key) {
        return this.gos.get(key);
    }
    /**
   * Updates a single gridOption to the new value provided. (Cannot be used on `Initial` properties.)
   * If updating multiple options, it is recommended to instead use `api.updateGridOptions()` which batches update logic.
   */ setGridOption(key, value) {
        this.updateGridOptions({
            [key]: value
        });
    }
    /**
   * Updates the provided subset of gridOptions with the provided values. (Cannot be used on `Initial` properties.)
   */ updateGridOptions(options) {
        this.gos.updateGridOptions({
            options: options
        });
    }
    /** Used internally by grid. Not intended to be used by the client. Interface may change between releases. */ __internalUpdateGridOptions(options, force) {
        this.gos.updateGridOptions({
            options: options,
            force: force,
            source: "gridOptionsUpdated"
        });
    }
    deprecatedUpdateGridOption(key, value) {
        $437b23f6a393c3bf$var$warnOnce(`set${key.charAt(0).toUpperCase()}${key.slice(1, key.length)} is deprecated. Please use 'api.setGridOption('${key}', newValue)' or 'api.updateGridOptions({ ${key}: newValue })' instead.`);
        this.setGridOption(key, value);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Set the top pinned rows. Call with no rows / undefined to clear top pinned rows. 
   **/ setPivotMode(pivotMode) {
        this.deprecatedUpdateGridOption("pivotMode", pivotMode);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Set the top pinned rows. Call with no rows / undefined to clear top pinned rows. 
   **/ setPinnedTopRowData(rows) {
        this.deprecatedUpdateGridOption("pinnedTopRowData", rows);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Set the bottom pinned rows. Call with no rows / undefined to clear bottom pinned rows.
   * */ setPinnedBottomRowData(rows) {
        this.deprecatedUpdateGridOption("pinnedBottomRowData", rows);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * DOM element to use as the popup parent for grid popups (context menu, column menu etc).
   * */ setPopupParent(ePopupParent) {
        this.deprecatedUpdateGridOption("popupParent", ePopupParent);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   */ setSuppressModelUpdateAfterUpdateTransaction(value) {
        this.deprecatedUpdateGridOption("suppressModelUpdateAfterUpdateTransaction", value);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Resets the data type definitions. This will update the columns in the grid.
   * */ setDataTypeDefinitions(dataTypeDefinitions) {
        this.deprecatedUpdateGridOption("dataTypeDefinitions", dataTypeDefinitions);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Set whether the grid paginates the data or not.
   *  - `true` to enable pagination
   *  - `false` to disable pagination
   */ setPagination(value) {
        this.deprecatedUpdateGridOption("pagination", value);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Sets the `paginationPageSize`, then re-paginates the grid so the changes are applied immediately.
   * */ paginationSetPageSize(size) {
        this.deprecatedUpdateGridOption("paginationPageSize", size);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Resets the side bar to the provided configuration. The parameter is the same as the sideBar grid property. The side bar is re-created from scratch with the new config.
   * */ setSideBar(def) {
        this.deprecatedUpdateGridOption("sideBar", def);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   */ setSuppressClipboardPaste(value) {
        this.deprecatedUpdateGridOption("suppressClipboardPaste", value);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   */ setGroupRemoveSingleChildren(value) {
        this.deprecatedUpdateGridOption("groupRemoveSingleChildren", value);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   */ setGroupRemoveLowestSingleChildren(value) {
        this.deprecatedUpdateGridOption("groupRemoveLowestSingleChildren", value);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   */ setGroupDisplayType(value) {
        this.deprecatedUpdateGridOption("groupDisplayType", value);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Sets the `groupIncludeFooter` property
   */ setGroupIncludeFooter(value) {
        this.deprecatedUpdateGridOption("groupIncludeFooter", value);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Sets the `groupIncludeTotalFooter` property
   */ setGroupIncludeTotalFooter(value) {
        this.deprecatedUpdateGridOption("groupIncludeTotalFooter", value);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   */ setRowClass(className) {
        this.deprecatedUpdateGridOption("rowClass", className);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Sets the `deltaSort` property
   * */ setDeltaSort(enable) {
        this.deprecatedUpdateGridOption("deltaSort", enable);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Sets the `suppressRowDrag` property.
   * */ setSuppressRowDrag(value) {
        this.deprecatedUpdateGridOption("suppressRowDrag", value);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Sets the `suppressMoveWhenRowDragging` property.
   * */ setSuppressMoveWhenRowDragging(value) {
        this.deprecatedUpdateGridOption("suppressMoveWhenRowDragging", value);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Sets the `suppressRowClickSelection` property.
   * */ setSuppressRowClickSelection(value) {
        this.deprecatedUpdateGridOption("suppressRowClickSelection", value);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Enable/disable the Advanced Filter
   * */ setEnableAdvancedFilter(enabled) {
        this.deprecatedUpdateGridOption("enableAdvancedFilter", enabled);
    }
    /** 
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Updates the `includeHiddenColumnsInAdvancedFilter` grid option.
   * By default hidden columns are excluded from the Advanced Filter.
   * Set to `true` to include them.
   */ setIncludeHiddenColumnsInAdvancedFilter(value) {
        this.deprecatedUpdateGridOption("includeHiddenColumnsInAdvancedFilter", value);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * DOM element to use as the parent for the Advanced Filter, to allow it to appear outside of the grid.
   * Set to `null` to appear inside the grid.
   */ setAdvancedFilterParent(advancedFilterParent) {
        this.deprecatedUpdateGridOption("advancedFilterParent", advancedFilterParent);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Updates the Advanced Filter Builder parameters.
   * */ setAdvancedFilterBuilderParams(params) {
        this.deprecatedUpdateGridOption("advancedFilterBuilderParams", params);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Pass a Quick Filter text into the grid for filtering.
   * */ setQuickFilter(newFilter) {
        $437b23f6a393c3bf$var$warnOnce(`setQuickFilter is deprecated. Please use 'api.setGridOption('quickFilterText', newValue)' or 'api.updateGridOptions({ quickFilterText: newValue })' instead.`);
        this.gos.updateGridOptions({
            options: {
                quickFilterText: newFilter
            }
        });
    }
    /** 
   * @deprecated As of v30, hidden columns are excluded from the Quick Filter by default. To include hidden columns, use `setIncludeHiddenColumnsInQuickFilter` instead.
   */ setExcludeHiddenColumnsFromQuickFilter(value) {
        this.deprecatedUpdateGridOption("includeHiddenColumnsInQuickFilter", !value);
    }
    /** 
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Updates the `includeHiddenColumnsInQuickFilter` grid option.
   * By default hidden columns are excluded from the Quick Filter.
   * Set to `true` to include them.
   */ setIncludeHiddenColumnsInQuickFilter(value) {
        this.deprecatedUpdateGridOption("includeHiddenColumnsInQuickFilter", value);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Updates the `quickFilterParser` grid option,
   * which changes how the Quick Filter splits the Quick Filter text into search terms.
   */ setQuickFilterParser(quickFilterParser) {
        this.deprecatedUpdateGridOption("quickFilterParser", quickFilterParser);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Updates the `quickFilterMatcher` grid option,
   * which changes the matching logic for whether a row passes the Quick Filter.
   */ setQuickFilterMatcher(quickFilterMatcher) {
        this.deprecatedUpdateGridOption("quickFilterMatcher", quickFilterMatcher);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * If `true`, the horizontal scrollbar will always be present, even if not required. Otherwise, it will only be displayed when necessary.
   * */ setAlwaysShowHorizontalScroll(show) {
        this.deprecatedUpdateGridOption("alwaysShowHorizontalScroll", show);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * If `true`, the vertical scrollbar will always be present, even if not required. Otherwise it will only be displayed when necessary.
   * */ setAlwaysShowVerticalScroll(show) {
        this.deprecatedUpdateGridOption("alwaysShowVerticalScroll", show);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   */ setFunctionsReadOnly(readOnly) {
        this.deprecatedUpdateGridOption("functionsReadOnly", readOnly);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Call to set new column definitions. The grid will redraw all the column headers, and then redraw all of the rows.
   */ setColumnDefs(colDefs, source = "api") {
        $437b23f6a393c3bf$var$warnOnce(`setColumnDefs is deprecated. Please use 'api.setGridOption('columnDefs', newValue)' or 'api.updateGridOptions({ columnDefs: newValue })' instead.`);
        this.gos.updateGridOptions({
            options: {
                columnDefs: colDefs
            },
            source: source
        });
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Call to set new auto group column definition. The grid will recreate any auto-group columns if present.
   * */ setAutoGroupColumnDef(colDef, source = "api") {
        $437b23f6a393c3bf$var$warnOnce(`setAutoGroupColumnDef is deprecated. Please use 'api.setGridOption('autoGroupColumnDef', newValue)' or 'api.updateGridOptions({ autoGroupColumnDef: newValue })' instead.`);
        this.gos.updateGridOptions({
            options: {
                autoGroupColumnDef: colDef
            },
            source: source
        });
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Call to set new Default Column Definition.
   * */ setDefaultColDef(colDef, source = "api") {
        $437b23f6a393c3bf$var$warnOnce(`setDefaultColDef is deprecated. Please use 'api.setGridOption('defaultColDef', newValue)' or 'api.updateGridOptions({ defaultColDef: newValue })' instead.`);
        this.gos.updateGridOptions({
            options: {
                defaultColDef: colDef
            },
            source: source
        });
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Call to set new Column Types.
   * */ setColumnTypes(columnTypes, source = "api") {
        $437b23f6a393c3bf$var$warnOnce(`setColumnTypes is deprecated. Please use 'api.setGridOption('columnTypes', newValue)' or 'api.updateGridOptions({ columnTypes: newValue })' instead.`);
        this.gos.updateGridOptions({
            options: {
                columnTypes: columnTypes
            },
            source: source
        });
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Sets the `treeData` property.
   * */ setTreeData(newTreeData) {
        this.deprecatedUpdateGridOption("treeData", newTreeData);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Set new datasource for Server-Side Row Model.
   * */ setServerSideDatasource(datasource) {
        this.deprecatedUpdateGridOption("serverSideDatasource", datasource);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * 
   * Note this purges all the cached data and reloads all the rows of the grid.
   * */ setCacheBlockSize(blockSize) {
        this.deprecatedUpdateGridOption("cacheBlockSize", blockSize);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Set new datasource for Infinite Row Model.
   * */ setDatasource(datasource) {
        this.deprecatedUpdateGridOption("datasource", datasource);
    }
    /** 
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Set new datasource for Viewport Row Model.
   * */ setViewportDatasource(viewportDatasource) {
        this.deprecatedUpdateGridOption("viewportDatasource", viewportDatasource);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Set the row data.
   * */ setRowData(rowData) {
        this.deprecatedUpdateGridOption("rowData", rowData);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Sets the `enableCellTextSelection` property.
   * */ setEnableCellTextSelection(selectable) {
        this.deprecatedUpdateGridOption("enableCellTextSelection", selectable);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Sets the height in pixels for the row containing the column label header.
   * */ setHeaderHeight(headerHeight) {
        this.deprecatedUpdateGridOption("headerHeight", headerHeight);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Switch between layout options: `normal`, `autoHeight`, `print`.
   * Defaults to `normal` if no domLayout provided.
   */ setDomLayout(domLayout) {
        this.deprecatedUpdateGridOption("domLayout", domLayout);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Sets the preferred direction for the selection fill handle.
   * */ setFillHandleDirection(direction) {
        this.deprecatedUpdateGridOption("fillHandleDirection", direction);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Sets the height in pixels for the rows containing header column groups.
   * */ setGroupHeaderHeight(headerHeight) {
        this.deprecatedUpdateGridOption("groupHeaderHeight", headerHeight);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Sets the height in pixels for the row containing the floating filters.
   * */ setFloatingFiltersHeight(headerHeight) {
        this.deprecatedUpdateGridOption("floatingFiltersHeight", headerHeight);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Sets the height in pixels for the row containing the columns when in pivot mode.
   * */ setPivotHeaderHeight(headerHeight) {
        this.deprecatedUpdateGridOption("pivotHeaderHeight", headerHeight);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   * Sets the height in pixels for the row containing header column groups when in pivot mode.
   * */ setPivotGroupHeaderHeight(headerHeight) {
        this.deprecatedUpdateGridOption("pivotGroupHeaderHeight", headerHeight);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setAnimateRows(animateRows) {
        this.deprecatedUpdateGridOption("animateRows", animateRows);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setIsExternalFilterPresent(isExternalFilterPresentFunc) {
        this.deprecatedUpdateGridOption("isExternalFilterPresent", isExternalFilterPresentFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setDoesExternalFilterPass(doesExternalFilterPassFunc) {
        this.deprecatedUpdateGridOption("doesExternalFilterPass", doesExternalFilterPassFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setNavigateToNextCell(navigateToNextCellFunc) {
        this.deprecatedUpdateGridOption("navigateToNextCell", navigateToNextCellFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setTabToNextCell(tabToNextCellFunc) {
        this.deprecatedUpdateGridOption("tabToNextCell", tabToNextCellFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setTabToNextHeader(tabToNextHeaderFunc) {
        this.deprecatedUpdateGridOption("tabToNextHeader", tabToNextHeaderFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setNavigateToNextHeader(navigateToNextHeaderFunc) {
        this.deprecatedUpdateGridOption("navigateToNextHeader", navigateToNextHeaderFunc);
    }
    setRowGroupPanelShow(rowGroupPanelShow) {
        this.deprecatedUpdateGridOption("rowGroupPanelShow", rowGroupPanelShow);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setGetGroupRowAgg(getGroupRowAggFunc) {
        this.deprecatedUpdateGridOption("getGroupRowAgg", getGroupRowAggFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setGetBusinessKeyForNode(getBusinessKeyForNodeFunc) {
        this.deprecatedUpdateGridOption("getBusinessKeyForNode", getBusinessKeyForNodeFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setGetChildCount(getChildCountFunc) {
        this.deprecatedUpdateGridOption("getChildCount", getChildCountFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setProcessRowPostCreate(processRowPostCreateFunc) {
        this.deprecatedUpdateGridOption("processRowPostCreate", processRowPostCreateFunc);
    }
    /**
   * @deprecated v31 `getRowId` is a static property and cannot be updated.
   *  */ setGetRowId(getRowIdFunc) {
        $437b23f6a393c3bf$var$warnOnce(`getRowId is a static property and can no longer be updated.`);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setGetRowClass(rowClassFunc) {
        this.deprecatedUpdateGridOption("getRowClass", rowClassFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setIsFullWidthRow(isFullWidthRowFunc) {
        this.deprecatedUpdateGridOption("isFullWidthRow", isFullWidthRowFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setIsRowSelectable(isRowSelectableFunc) {
        this.deprecatedUpdateGridOption("isRowSelectable", isRowSelectableFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setIsRowMaster(isRowMasterFunc) {
        this.deprecatedUpdateGridOption("isRowMaster", isRowMasterFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setPostSortRows(postSortRowsFunc) {
        this.deprecatedUpdateGridOption("postSortRows", postSortRowsFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setGetDocument(getDocumentFunc) {
        this.deprecatedUpdateGridOption("getDocument", getDocumentFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setGetContextMenuItems(getContextMenuItemsFunc) {
        this.deprecatedUpdateGridOption("getContextMenuItems", getContextMenuItemsFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setGetMainMenuItems(getMainMenuItemsFunc) {
        this.deprecatedUpdateGridOption("getMainMenuItems", getMainMenuItemsFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setProcessCellForClipboard(processCellForClipboardFunc) {
        this.deprecatedUpdateGridOption("processCellForClipboard", processCellForClipboardFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setSendToClipboard(sendToClipboardFunc) {
        this.deprecatedUpdateGridOption("sendToClipboard", sendToClipboardFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setProcessCellFromClipboard(processCellFromClipboardFunc) {
        this.deprecatedUpdateGridOption("processCellFromClipboard", processCellFromClipboardFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setProcessPivotResultColDef(processPivotResultColDefFunc) {
        this.deprecatedUpdateGridOption("processPivotResultColDef", processPivotResultColDefFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setProcessPivotResultColGroupDef(processPivotResultColGroupDefFunc) {
        this.deprecatedUpdateGridOption("processPivotResultColGroupDef", processPivotResultColGroupDefFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setPostProcessPopup(postProcessPopupFunc) {
        this.deprecatedUpdateGridOption("postProcessPopup", postProcessPopupFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setInitialGroupOrderComparator(initialGroupOrderComparatorFunc) {
        this.deprecatedUpdateGridOption("initialGroupOrderComparator", initialGroupOrderComparatorFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setGetChartToolbarItems(getChartToolbarItemsFunc) {
        this.deprecatedUpdateGridOption("getChartToolbarItems", getChartToolbarItemsFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setPaginationNumberFormatter(paginationNumberFormatterFunc) {
        this.deprecatedUpdateGridOption("paginationNumberFormatter", paginationNumberFormatterFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setGetServerSideGroupLevelParams(getServerSideGroupLevelParamsFunc) {
        this.deprecatedUpdateGridOption("getServerSideGroupLevelParams", getServerSideGroupLevelParamsFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setIsServerSideGroupOpenByDefault(isServerSideGroupOpenByDefaultFunc) {
        this.deprecatedUpdateGridOption("isServerSideGroupOpenByDefault", isServerSideGroupOpenByDefaultFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setIsApplyServerSideTransaction(isApplyServerSideTransactionFunc) {
        this.deprecatedUpdateGridOption("isApplyServerSideTransaction", isApplyServerSideTransactionFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setIsServerSideGroup(isServerSideGroupFunc) {
        this.deprecatedUpdateGridOption("isServerSideGroup", isServerSideGroupFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setGetServerSideGroupKey(getServerSideGroupKeyFunc) {
        this.deprecatedUpdateGridOption("getServerSideGroupKey", getServerSideGroupKeyFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setGetRowStyle(rowStyleFunc) {
        this.deprecatedUpdateGridOption("getRowStyle", rowStyleFunc);
    }
    /**
   * @deprecated v31 Use `api.setGridOption` or `api.updateGridOptions` instead.
   *  */ setGetRowHeight(rowHeightFunc) {
        this.deprecatedUpdateGridOption("getRowHeight", rowHeightFunc);
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowRenderer")
], $437b23f6a393c3bf$export$8f1681b1712fcf78.prototype, "rowRenderer", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("navigationService")
], $437b23f6a393c3bf$export$8f1681b1712fcf78.prototype, "navigationService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("filterManager")
], $437b23f6a393c3bf$export$8f1681b1712fcf78.prototype, "filterManager", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnModel")
], $437b23f6a393c3bf$export$8f1681b1712fcf78.prototype, "columnModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("selectionService")
], $437b23f6a393c3bf$export$8f1681b1712fcf78.prototype, "selectionService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("gridOptionsService")
], $437b23f6a393c3bf$export$8f1681b1712fcf78.prototype, "gos", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("valueService")
], $437b23f6a393c3bf$export$8f1681b1712fcf78.prototype, "valueService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("alignedGridsService")
], $437b23f6a393c3bf$export$8f1681b1712fcf78.prototype, "alignedGridsService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("eventService")
], $437b23f6a393c3bf$export$8f1681b1712fcf78.prototype, "eventService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("pinnedRowModel")
], $437b23f6a393c3bf$export$8f1681b1712fcf78.prototype, "pinnedRowModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("context")
], $437b23f6a393c3bf$export$8f1681b1712fcf78.prototype, "context", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowModel")
], $437b23f6a393c3bf$export$8f1681b1712fcf78.prototype, "rowModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("sortController")
], $437b23f6a393c3bf$export$8f1681b1712fcf78.prototype, "sortController", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("paginationProxy")
], $437b23f6a393c3bf$export$8f1681b1712fcf78.prototype, "paginationProxy", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("focusService")
], $437b23f6a393c3bf$export$8f1681b1712fcf78.prototype, "focusService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("dragAndDropService")
], $437b23f6a393c3bf$export$8f1681b1712fcf78.prototype, "dragAndDropService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("menuService")
], $437b23f6a393c3bf$export$8f1681b1712fcf78.prototype, "menuService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("valueCache")
], $437b23f6a393c3bf$export$8f1681b1712fcf78.prototype, "valueCache", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("animationFrameService")
], $437b23f6a393c3bf$export$8f1681b1712fcf78.prototype, "animationFrameService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("ctrlsService")
], $437b23f6a393c3bf$export$8f1681b1712fcf78.prototype, "ctrlsService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("overlayService")
], $437b23f6a393c3bf$export$8f1681b1712fcf78.prototype, "overlayService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("stateService")
], $437b23f6a393c3bf$export$8f1681b1712fcf78.prototype, "stateService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("expansionService")
], $437b23f6a393c3bf$export$8f1681b1712fcf78.prototype, "expansionService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("apiEventService")
], $437b23f6a393c3bf$export$8f1681b1712fcf78.prototype, "apiEventService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("frameworkOverrides")
], $437b23f6a393c3bf$export$8f1681b1712fcf78.prototype, "frameworkOverrides", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("undoRedoService")
], $437b23f6a393c3bf$export$8f1681b1712fcf78.prototype, "undoRedoService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowNodeBlockLoader")
], $437b23f6a393c3bf$export$8f1681b1712fcf78.prototype, "rowNodeBlockLoader", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$7acb7b24c478f9c6("csvCreator")
], $437b23f6a393c3bf$export$8f1681b1712fcf78.prototype, "csvCreator", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$7acb7b24c478f9c6("excelCreator")
], $437b23f6a393c3bf$export$8f1681b1712fcf78.prototype, "excelCreator", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$7acb7b24c478f9c6("rangeService")
], $437b23f6a393c3bf$export$8f1681b1712fcf78.prototype, "rangeService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$7acb7b24c478f9c6("clipboardService")
], $437b23f6a393c3bf$export$8f1681b1712fcf78.prototype, "clipboardService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$7acb7b24c478f9c6("aggFuncService")
], $437b23f6a393c3bf$export$8f1681b1712fcf78.prototype, "aggFuncService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$7acb7b24c478f9c6("statusBarService")
], $437b23f6a393c3bf$export$8f1681b1712fcf78.prototype, "statusBarService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$7acb7b24c478f9c6("chartService")
], $437b23f6a393c3bf$export$8f1681b1712fcf78.prototype, "chartService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$7acb7b24c478f9c6("ssrmTransactionManager")
], $437b23f6a393c3bf$export$8f1681b1712fcf78.prototype, "serverSideTransactionManager", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$7acb7b24c478f9c6("sideBarService")
], $437b23f6a393c3bf$export$8f1681b1712fcf78.prototype, "sideBarService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$export$8f1681b1712fcf78.prototype, "init", 1);
$437b23f6a393c3bf$export$8f1681b1712fcf78 = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("gridApi")
], $437b23f6a393c3bf$export$8f1681b1712fcf78);
// community-modules/core/src/filter/quickFilterService.ts
var $437b23f6a393c3bf$var$QuickFilterService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.quickFilter = null;
        this.quickFilterParts = null;
    }
    postConstruct() {
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_PIVOT_MODE_CHANGED, ()=>this.resetQuickFilterCache());
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_NEW_COLUMNS_LOADED, ()=>this.resetQuickFilterCache());
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_ROW_GROUP_CHANGED, ()=>this.resetQuickFilterCache());
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_VISIBLE, ()=>{
            if (!this.gos.get("includeHiddenColumnsInQuickFilter")) this.resetQuickFilterCache();
        });
        this.addManagedPropertyListener("quickFilterText", (e)=>this.setQuickFilter(e.currentValue));
        this.addManagedPropertyListeners([
            "includeHiddenColumnsInQuickFilter",
            "applyQuickFilterBeforePivotOrAgg"
        ], ()=>this.onQuickFilterColumnConfigChanged());
        this.quickFilter = this.parseQuickFilter(this.gos.get("quickFilterText"));
        this.parser = this.gos.get("quickFilterParser");
        this.matcher = this.gos.get("quickFilterMatcher");
        this.setQuickFilterParts();
        this.addManagedPropertyListeners([
            "quickFilterMatcher",
            "quickFilterParser"
        ], ()=>this.setQuickFilterParserAndMatcher());
    }
    isQuickFilterPresent() {
        return this.quickFilter !== null;
    }
    doesRowPassQuickFilter(node) {
        const usingCache = this.gos.get("cacheQuickFilter");
        if (this.matcher) return this.doesRowPassQuickFilterMatcher(usingCache, node);
        return this.quickFilterParts.every((part)=>usingCache ? this.doesRowPassQuickFilterCache(node, part) : this.doesRowPassQuickFilterNoCache(node, part));
    }
    resetQuickFilterCache() {
        this.rowModel.forEachNode((node)=>node.quickFilterAggregateText = null);
    }
    setQuickFilterParts() {
        const { quickFilter: quickFilter, parser: parser } = this;
        if (quickFilter) this.quickFilterParts = parser ? parser(quickFilter) : quickFilter.split(" ");
        else this.quickFilterParts = null;
    }
    parseQuickFilter(newFilter) {
        if (!$437b23f6a393c3bf$var$exists(newFilter)) return null;
        if (!this.gos.isRowModelType("clientSide")) {
            console.warn("AG Grid - Quick filtering only works with the Client-Side Row Model");
            return null;
        }
        return newFilter.toUpperCase();
    }
    setQuickFilter(newFilter) {
        if (newFilter != null && typeof newFilter !== "string") {
            console.warn(`AG Grid - Grid option quickFilterText only supports string inputs, received: ${typeof newFilter}`);
            return;
        }
        const parsedFilter = this.parseQuickFilter(newFilter);
        if (this.quickFilter !== parsedFilter) {
            this.quickFilter = parsedFilter;
            this.setQuickFilterParts();
            this.dispatchEvent({
                type: $437b23f6a393c3bf$var$QuickFilterService.EVENT_QUICK_FILTER_CHANGED
            });
        }
    }
    setQuickFilterParserAndMatcher() {
        const parser = this.gos.get("quickFilterParser");
        const matcher = this.gos.get("quickFilterMatcher");
        const hasChanged = parser !== this.parser || matcher !== this.matcher;
        this.parser = parser;
        this.matcher = matcher;
        if (hasChanged) {
            this.setQuickFilterParts();
            this.dispatchEvent({
                type: $437b23f6a393c3bf$var$QuickFilterService.EVENT_QUICK_FILTER_CHANGED
            });
        }
    }
    onQuickFilterColumnConfigChanged() {
        this.columnModel.refreshQuickFilterColumns();
        this.resetQuickFilterCache();
        if (this.isQuickFilterPresent()) this.dispatchEvent({
            type: $437b23f6a393c3bf$var$QuickFilterService.EVENT_QUICK_FILTER_CHANGED
        });
    }
    doesRowPassQuickFilterNoCache(node, filterPart) {
        const columns = this.columnModel.getAllColumnsForQuickFilter();
        return columns.some((column)=>{
            const part = this.getQuickFilterTextForColumn(column, node);
            return $437b23f6a393c3bf$var$exists(part) && part.indexOf(filterPart) >= 0;
        });
    }
    doesRowPassQuickFilterCache(node, filterPart) {
        this.checkGenerateQuickFilterAggregateText(node);
        return node.quickFilterAggregateText.indexOf(filterPart) >= 0;
    }
    doesRowPassQuickFilterMatcher(usingCache, node) {
        let quickFilterAggregateText;
        if (usingCache) {
            this.checkGenerateQuickFilterAggregateText(node);
            quickFilterAggregateText = node.quickFilterAggregateText;
        } else quickFilterAggregateText = this.getQuickFilterAggregateText(node);
        const { quickFilterParts: quickFilterParts, matcher: matcher } = this;
        return matcher(quickFilterParts, quickFilterAggregateText);
    }
    checkGenerateQuickFilterAggregateText(node) {
        if (!node.quickFilterAggregateText) node.quickFilterAggregateText = this.getQuickFilterAggregateText(node);
    }
    getQuickFilterTextForColumn(column, node) {
        let value = this.valueService.getValue(column, node, true);
        const colDef = column.getColDef();
        if (colDef.getQuickFilterText) {
            const params = this.gos.addGridCommonParams({
                value: value,
                node: node,
                data: node.data,
                column: column,
                colDef: colDef
            });
            value = colDef.getQuickFilterText(params);
        }
        return $437b23f6a393c3bf$var$exists(value) ? value.toString().toUpperCase() : null;
    }
    getQuickFilterAggregateText(node) {
        const stringParts = [];
        const columns = this.columnModel.getAllColumnsForQuickFilter();
        columns.forEach((column)=>{
            const part = this.getQuickFilterTextForColumn(column, node);
            if ($437b23f6a393c3bf$var$exists(part)) stringParts.push(part);
        });
        return stringParts.join($437b23f6a393c3bf$var$QuickFilterService.QUICK_FILTER_SEPARATOR);
    }
};
$437b23f6a393c3bf$var$QuickFilterService.EVENT_QUICK_FILTER_CHANGED = "quickFilterChanged";
$437b23f6a393c3bf$var$QuickFilterService.QUICK_FILTER_SEPARATOR = "\n";
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("valueService")
], $437b23f6a393c3bf$var$QuickFilterService.prototype, "valueService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnModel")
], $437b23f6a393c3bf$var$QuickFilterService.prototype, "columnModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowModel")
], $437b23f6a393c3bf$var$QuickFilterService.prototype, "rowModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$QuickFilterService.prototype, "postConstruct", 1);
$437b23f6a393c3bf$var$QuickFilterService = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("quickFilterService")
], $437b23f6a393c3bf$var$QuickFilterService);
// community-modules/core/src/filter/filterManager.ts
var $437b23f6a393c3bf$export$4c85e4ca0d95642f = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.allColumnFilters = /* @__PURE__ */ new Map();
        this.allColumnListeners = /* @__PURE__ */ new Map();
        this.activeAggregateFilters = [];
        this.activeColumnFilters = [];
        // this is true when the grid is processing the filter change. this is used by the cell comps, so that they
        // don't flash when data changes due to filter changes. there is no need to flash when filter changes as the
        // user is in control, so doesn't make sense to show flashing changes. for example, go to main demo where
        // this feature is turned off (hack code to always return false for isSuppressFlashingCellsBecauseFiltering(), put in)
        // 100,000 rows and group by country. then do some filtering. all the cells flash, which is silly.
        this.processingFilterChange = false;
        // when we're waiting for cell data types to be inferred, we need to defer filter model updates
        this.filterModelUpdateQueue = [];
        this.columnFilterModelUpdateQueue = [];
        this.advancedFilterModelUpdateQueue = [];
    }
    init() {
        var _a, _b, _c;
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_GRID_COLUMNS_CHANGED, ()=>this.onColumnsChanged());
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_VALUE_CHANGED, ()=>this.refreshFiltersForAggregations());
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_PIVOT_CHANGED, ()=>this.refreshFiltersForAggregations());
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_PIVOT_MODE_CHANGED, ()=>this.refreshFiltersForAggregations());
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_NEW_COLUMNS_LOADED, ()=>this.updateAdvancedFilterColumns());
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_VISIBLE, ()=>this.updateAdvancedFilterColumns());
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_DATA_UPDATED, ()=>this.onNewRowsLoaded("rowDataUpdated"));
        this.externalFilterPresent = this.isExternalFilterPresentCallback();
        this.addManagedPropertyListeners([
            "isExternalFilterPresent",
            "doesExternalFilterPass"
        ], ()=>{
            this.onFilterChanged({
                source: "api"
            });
        });
        this.updateAggFiltering();
        this.addManagedPropertyListener("groupAggFiltering", ()=>{
            this.updateAggFiltering();
            this.onFilterChanged();
        });
        this.addManagedPropertyListener("advancedFilterModel", (event)=>this.setAdvancedFilterModel(event.currentValue));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_ADVANCED_FILTER_ENABLED_CHANGED, ({ enabled: enabled })=>this.onAdvancedFilterEnabledChanged(enabled));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_DATA_TYPES_INFERRED, ()=>this.processFilterModelUpdateQueue());
        this.addManagedListener(this.quickFilterService, $437b23f6a393c3bf$var$QuickFilterService.EVENT_QUICK_FILTER_CHANGED, ()=>this.onFilterChanged({
                source: "quickFilter"
            }));
        this.initialFilterModel = $437b23f6a393c3bf$var$__spreadValues({}, (_c = (_b = (_a = this.gos.get("initialState")) == null ? void 0 : _a.filter) == null ? void 0 : _b.filterModel) != null ? _c : {});
    }
    isExternalFilterPresentCallback() {
        const isFilterPresent = this.gos.getCallback("isExternalFilterPresent");
        if (typeof isFilterPresent === "function") return isFilterPresent({});
        return false;
    }
    doesExternalFilterPass(node) {
        const doesFilterPass = this.gos.get("doesExternalFilterPass");
        if (typeof doesFilterPass === "function") return doesFilterPass(node);
        return false;
    }
    setFilterModel(model, source = "api") {
        if (this.isAdvancedFilterEnabled()) {
            this.warnAdvancedFilters();
            return;
        }
        if (this.dataTypeService.isPendingInference()) {
            this.filterModelUpdateQueue.push({
                model: model,
                source: source
            });
            return;
        }
        const allPromises = [];
        const previousModel = this.getFilterModel();
        if (model) {
            const modelKeys = $437b23f6a393c3bf$var$convertToSet(Object.keys(model));
            this.allColumnFilters.forEach((filterWrapper, colId)=>{
                const newModel = model[colId];
                allPromises.push(this.setModelOnFilterWrapper(filterWrapper.filterPromise, newModel));
                modelKeys.delete(colId);
            });
            modelKeys.forEach((colId)=>{
                const column = this.columnModel.getPrimaryColumn(colId) || this.columnModel.getGridColumn(colId);
                if (!column) {
                    console.warn("AG Grid: setFilterModel() - no column found for colId: " + colId);
                    return;
                }
                if (!column.isFilterAllowed()) {
                    console.warn("AG Grid: setFilterModel() - unable to fully apply model, filtering disabled for colId: " + colId);
                    return;
                }
                const filterWrapper = this.getOrCreateFilterWrapper(column, "NO_UI");
                if (!filterWrapper) {
                    console.warn("AG-Grid: setFilterModel() - unable to fully apply model, unable to create filter for colId: " + colId);
                    return;
                }
                allPromises.push(this.setModelOnFilterWrapper(filterWrapper.filterPromise, model[colId]));
            });
        } else this.allColumnFilters.forEach((filterWrapper)=>{
            allPromises.push(this.setModelOnFilterWrapper(filterWrapper.filterPromise, null));
        });
        $437b23f6a393c3bf$export$30ec7836a4847721.all(allPromises).then(()=>{
            const currentModel = this.getFilterModel();
            const columns = [];
            this.allColumnFilters.forEach((filterWrapper, colId)=>{
                const before = previousModel ? previousModel[colId] : null;
                const after = currentModel ? currentModel[colId] : null;
                if (!$437b23f6a393c3bf$export$71511d61b312f219.jsonEquals(before, after)) columns.push(filterWrapper.column);
            });
            if (columns.length > 0) this.onFilterChanged({
                columns: columns,
                source: source
            });
        });
    }
    setModelOnFilterWrapper(filterPromise, newModel) {
        return new $437b23f6a393c3bf$export$30ec7836a4847721((resolve)=>{
            filterPromise.then((filter)=>{
                if (typeof filter.setModel !== "function") {
                    console.warn("AG Grid: filter missing setModel method, which is needed for setFilterModel");
                    resolve();
                }
                (filter.setModel(newModel) || $437b23f6a393c3bf$export$30ec7836a4847721.resolve()).then(()=>resolve());
            });
        });
    }
    getFilterModel() {
        const result = {};
        this.allColumnFilters.forEach((filterWrapper, key)=>{
            const model = this.getModelFromFilterWrapper(filterWrapper);
            if ($437b23f6a393c3bf$var$exists(model)) result[key] = model;
        });
        return result;
    }
    getModelFromFilterWrapper(filterWrapper) {
        var _a;
        const filterPromise = filterWrapper.filterPromise;
        const filter = filterPromise.resolveNow(null, (promiseFilter)=>promiseFilter);
        if (filter == null) return (_a = this.initialFilterModel[filterWrapper.column.getColId()]) != null ? _a : null;
        if (typeof filter.getModel !== "function") {
            console.warn("AG Grid: filter API missing getModel method, which is needed for getFilterModel");
            return null;
        }
        return filter.getModel();
    }
    isColumnFilterPresent() {
        return this.activeColumnFilters.length > 0;
    }
    isAggregateFilterPresent() {
        return !!this.activeAggregateFilters.length;
    }
    isExternalFilterPresent() {
        return this.externalFilterPresent;
    }
    isChildFilterPresent() {
        return this.isColumnFilterPresent() || this.isQuickFilterPresent() || this.isExternalFilterPresent() || this.isAdvancedFilterPresent();
    }
    isAdvancedFilterPresent() {
        return this.isAdvancedFilterEnabled() && this.advancedFilterService.isFilterPresent();
    }
    onAdvancedFilterEnabledChanged(enabled) {
        var _a;
        if (enabled) {
            if (this.allColumnFilters.size) {
                this.allColumnFilters.forEach((filterWrapper)=>this.disposeFilterWrapper(filterWrapper, "advancedFilterEnabled"));
                this.onFilterChanged({
                    source: "advancedFilter"
                });
            }
        } else if ((_a = this.advancedFilterService) == null ? void 0 : _a.isFilterPresent()) {
            this.advancedFilterService.setModel(null);
            this.onFilterChanged({
                source: "advancedFilter"
            });
        }
    }
    isAdvancedFilterEnabled() {
        var _a;
        return !!((_a = this.advancedFilterService) == null ? void 0 : _a.isEnabled());
    }
    isAdvancedFilterHeaderActive() {
        return this.isAdvancedFilterEnabled() && this.advancedFilterService.isHeaderActive();
    }
    doAggregateFiltersPass(node, filterToSkip) {
        return this.doColumnFiltersPass(node, filterToSkip, true);
    }
    // called by:
    // 1) onFilterChanged()
    // 2) onNewRowsLoaded()
    updateActiveFilters() {
        this.activeColumnFilters.length = 0;
        this.activeAggregateFilters.length = 0;
        const isFilterActive = (filter)=>{
            if (!filter) return false;
            if (!filter.isFilterActive) {
                console.warn("AG Grid: Filter is missing isFilterActive() method");
                return false;
            }
            return filter.isFilterActive();
        };
        const groupFilterEnabled = !!this.gos.getGroupAggFiltering();
        const isAggFilter = (column)=>{
            const isSecondary = !column.isPrimary();
            if (isSecondary) return true;
            const isShowingPrimaryColumns = !this.columnModel.isPivotActive();
            const isValueActive = column.isValueActive();
            if (!isValueActive || !isShowingPrimaryColumns) return false;
            if (this.columnModel.isPivotMode()) return true;
            return groupFilterEnabled;
        };
        this.allColumnFilters.forEach((filterWrapper)=>{
            if (filterWrapper.filterPromise.resolveNow(false, isFilterActive)) {
                const filterComp = filterWrapper.filterPromise.resolveNow(null, (filter)=>filter);
                if (isAggFilter(filterWrapper.column)) this.activeAggregateFilters.push(filterComp);
                else this.activeColumnFilters.push(filterComp);
            }
        });
    }
    updateFilterFlagInColumns(source, additionalEventAttributes) {
        this.allColumnFilters.forEach((filterWrapper)=>{
            const isFilterActive = filterWrapper.filterPromise.resolveNow(false, (filter)=>filter.isFilterActive());
            filterWrapper.column.setFilterActive(isFilterActive, source, additionalEventAttributes);
        });
    }
    isAnyFilterPresent() {
        return this.isQuickFilterPresent() || this.isColumnFilterPresent() || this.isAggregateFilterPresent() || this.isExternalFilterPresent() || this.isAdvancedFilterPresent();
    }
    doColumnFiltersPass(node, filterToSkip, targetAggregates) {
        const { data: data, aggData: aggData } = node;
        const targetedFilters = targetAggregates ? this.activeAggregateFilters : this.activeColumnFilters;
        const targetedData = targetAggregates ? aggData : data;
        for(let i = 0; i < targetedFilters.length; i++){
            const filter = targetedFilters[i];
            if (filter == null || filter === filterToSkip) continue;
            if (typeof filter.doesFilterPass !== "function") throw new Error("Filter is missing method doesFilterPass");
            if (!filter.doesFilterPass({
                node: node,
                data: targetedData
            })) return false;
        }
        return true;
    }
    resetQuickFilterCache() {
        this.quickFilterService.resetQuickFilterCache();
    }
    refreshFiltersForAggregations() {
        const isAggFiltering = this.gos.getGroupAggFiltering();
        if (isAggFiltering) this.onFilterChanged();
    }
    // sometimes (especially in React) the filter can call onFilterChanged when we are in the middle
    // of a render cycle. this would be bad, so we wait for render cycle to complete when this happens.
    // this happens in react when we change React State in the grid (eg setting RowCtrl's in RowContainer)
    // which results in React State getting applied in the main application, triggering a useEffect() to
    // be kicked off adn then the application calling the grid's API. in AG-6554, the custom filter was
    // getting it's useEffect() triggered in this way.
    callOnFilterChangedOutsideRenderCycle(params) {
        const action = ()=>this.onFilterChanged(params);
        if (this.rowRenderer.isRefreshInProgress()) setTimeout(action, 0);
        else action();
    }
    onFilterChanged(params = {}) {
        const { source: source, filterInstance: filterInstance, additionalEventAttributes: additionalEventAttributes, columns: columns } = params;
        this.updateDependantFilters();
        this.updateActiveFilters();
        this.updateFilterFlagInColumns("filterChanged", additionalEventAttributes);
        this.externalFilterPresent = this.isExternalFilterPresentCallback();
        this.allColumnFilters.forEach((filterWrapper)=>{
            if (!filterWrapper.filterPromise) return;
            filterWrapper.filterPromise.then((filter)=>{
                if (filter && filter !== filterInstance && filter.onAnyFilterChanged) filter.onAnyFilterChanged();
            });
        });
        const filterChangedEvent = {
            source: source,
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_FILTER_CHANGED,
            columns: columns || []
        };
        if (additionalEventAttributes) $437b23f6a393c3bf$var$mergeDeep(filterChangedEvent, additionalEventAttributes);
        this.processingFilterChange = true;
        this.eventService.dispatchEvent(filterChangedEvent);
        this.processingFilterChange = false;
    }
    isSuppressFlashingCellsBecauseFiltering() {
        var _a;
        const allowShowChangeAfterFilter = (_a = this.gos.get("allowShowChangeAfterFilter")) != null ? _a : false;
        return !allowShowChangeAfterFilter && this.processingFilterChange;
    }
    isQuickFilterPresent() {
        return this.quickFilterService.isQuickFilterPresent();
    }
    updateAggFiltering() {
        this.aggFiltering = !!this.gos.getGroupAggFiltering();
    }
    isAggregateQuickFilterPresent() {
        return this.isQuickFilterPresent() && this.shouldApplyQuickFilterAfterAgg();
    }
    isNonAggregateQuickFilterPresent() {
        return this.isQuickFilterPresent() && !this.shouldApplyQuickFilterAfterAgg();
    }
    shouldApplyQuickFilterAfterAgg() {
        return (this.aggFiltering || this.columnModel.isPivotMode()) && !this.gos.get("applyQuickFilterBeforePivotOrAgg");
    }
    doesRowPassOtherFilters(filterToSkip, node) {
        return this.doesRowPassFilter({
            rowNode: node,
            filterInstanceToSkip: filterToSkip
        });
    }
    doesRowPassAggregateFilters(params) {
        if (this.isAggregateQuickFilterPresent() && !this.quickFilterService.doesRowPassQuickFilter(params.rowNode)) return false;
        if (this.isAggregateFilterPresent() && !this.doAggregateFiltersPass(params.rowNode, params.filterInstanceToSkip)) return false;
        return true;
    }
    doesRowPassFilter(params) {
        if (this.isNonAggregateQuickFilterPresent() && !this.quickFilterService.doesRowPassQuickFilter(params.rowNode)) return false;
        if (this.isExternalFilterPresent() && !this.doesExternalFilterPass(params.rowNode)) return false;
        if (this.isColumnFilterPresent() && !this.doColumnFiltersPass(params.rowNode, params.filterInstanceToSkip)) return false;
        if (this.isAdvancedFilterPresent() && !this.advancedFilterService.doesFilterPass(params.rowNode)) return false;
        return true;
    }
    onNewRowsLoaded(source) {
        this.allColumnFilters.forEach((filterWrapper)=>{
            filterWrapper.filterPromise.then((filter)=>{
                if (filter.onNewRowsLoaded) filter.onNewRowsLoaded();
            });
        });
        this.updateFilterFlagInColumns(source, {
            afterDataChange: true
        });
        this.updateActiveFilters();
    }
    createValueGetter(column) {
        return ({ node: node })=>this.valueService.getValue(column, node, true);
    }
    createGetValue(filterColumn) {
        return (rowNode, column)=>{
            const columnToUse = column ? this.columnModel.getGridColumn(column) : filterColumn;
            return columnToUse ? this.valueService.getValue(columnToUse, rowNode, true) : void 0;
        };
    }
    getFilterComponent(column, source, createIfDoesNotExist = true) {
        var _a;
        if (createIfDoesNotExist) return ((_a = this.getOrCreateFilterWrapper(column, source)) == null ? void 0 : _a.filterPromise) || null;
        const filterWrapper = this.cachedFilter(column);
        return filterWrapper ? filterWrapper.filterPromise : null;
    }
    isFilterActive(column) {
        const filterWrapper = this.cachedFilter(column);
        return !!filterWrapper && filterWrapper.filterPromise.resolveNow(false, (filter)=>filter.isFilterActive());
    }
    getOrCreateFilterWrapper(column, source) {
        if (!column.isFilterAllowed()) return null;
        let filterWrapper = this.cachedFilter(column);
        if (!filterWrapper) {
            filterWrapper = this.createFilterWrapper(column, source);
            this.setColumnFilterWrapper(column, filterWrapper);
        }
        return filterWrapper;
    }
    cachedFilter(column) {
        return this.allColumnFilters.get(column.getColId());
    }
    getDefaultFilter(column) {
        let defaultFilter;
        if ($437b23f6a393c3bf$export$dc053975cc7f6c11.__isRegistered("@ag-grid-enterprise/set-filter" /* SetFilterModule */ , this.context.getGridId())) defaultFilter = "agSetColumnFilter";
        else {
            const cellDataType = this.dataTypeService.getBaseDataType(column);
            if (cellDataType === "number") defaultFilter = "agNumberColumnFilter";
            else if (cellDataType === "date" || cellDataType === "dateString") defaultFilter = "agDateColumnFilter";
            else defaultFilter = "agTextColumnFilter";
        }
        return defaultFilter;
    }
    getDefaultFloatingFilter(column) {
        let defaultFloatingFilterType;
        if ($437b23f6a393c3bf$export$dc053975cc7f6c11.__isRegistered("@ag-grid-enterprise/set-filter" /* SetFilterModule */ , this.context.getGridId())) defaultFloatingFilterType = "agSetColumnFloatingFilter";
        else {
            const cellDataType = this.dataTypeService.getBaseDataType(column);
            if (cellDataType === "number") defaultFloatingFilterType = "agNumberColumnFloatingFilter";
            else if (cellDataType === "date" || cellDataType === "dateString") defaultFloatingFilterType = "agDateColumnFloatingFilter";
            else defaultFloatingFilterType = "agTextColumnFloatingFilter";
        }
        return defaultFloatingFilterType;
    }
    createFilterInstance(column) {
        const defaultFilter = this.getDefaultFilter(column);
        const colDef = column.getColDef();
        let filterInstance;
        const params = $437b23f6a393c3bf$var$__spreadProps($437b23f6a393c3bf$var$__spreadValues({}, this.createFilterParams(column, colDef)), {
            filterModifiedCallback: ()=>this.filterModifiedCallbackFactory(filterInstance, column)(),
            filterChangedCallback: (additionalEventAttributes)=>this.filterChangedCallbackFactory(filterInstance, column)(additionalEventAttributes),
            doesRowPassOtherFilter: (node)=>this.doesRowPassOtherFilters(filterInstance, node)
        });
        const compDetails = this.userComponentFactory.getFilterDetails(colDef, params, defaultFilter);
        if (!compDetails) return {
            filterPromise: null,
            compDetails: null
        };
        return {
            filterPromise: ()=>{
                const filterPromise = compDetails.newAgStackInstance();
                if (filterPromise) filterPromise.then((r)=>filterInstance = r);
                return filterPromise;
            },
            compDetails: compDetails
        };
    }
    createFilterParams(column, colDef) {
        const params = this.gos.addGridCommonParams({
            column: column,
            colDef: $437b23f6a393c3bf$var$cloneObject(colDef),
            rowModel: this.rowModel,
            filterChangedCallback: ()=>{},
            filterModifiedCallback: ()=>{},
            valueGetter: this.createValueGetter(column),
            getValue: this.createGetValue(column),
            doesRowPassOtherFilter: ()=>true
        });
        return params;
    }
    createFilterWrapper(column, source) {
        var _a;
        const filterWrapper = {
            column: column,
            filterPromise: null,
            compiledElement: null,
            compDetails: null
        };
        const { filterPromise: filterPromise, compDetails: compDetails } = this.createFilterInstance(column);
        filterWrapper.filterPromise = (_a = filterPromise == null ? void 0 : filterPromise()) != null ? _a : null;
        filterWrapper.compDetails = compDetails;
        return filterWrapper;
    }
    onColumnsChanged() {
        const columns = [];
        this.allColumnFilters.forEach((wrapper, colId)=>{
            let currentColumn;
            if (wrapper.column.isPrimary()) currentColumn = this.columnModel.getPrimaryColumn(colId);
            else currentColumn = this.columnModel.getGridColumn(colId);
            if (currentColumn && currentColumn === wrapper.column) return;
            columns.push(wrapper.column);
            this.disposeFilterWrapper(wrapper, "columnChanged");
            this.disposeColumnListener(colId);
        });
        if (columns.length > 0) this.onFilterChanged({
            columns: columns,
            source: "api"
        });
        else this.updateDependantFilters();
    }
    updateDependantFilters() {
        const groupColumns = this.columnModel.getGroupAutoColumns();
        groupColumns == null || groupColumns.forEach((groupColumn)=>{
            if (groupColumn.getColDef().filter === "agGroupColumnFilter") this.getOrCreateFilterWrapper(groupColumn, "NO_UI");
        });
    }
    // for group filters, can change dynamically whether they are allowed or not
    isFilterAllowed(column) {
        var _a, _b;
        if (this.isAdvancedFilterEnabled()) return false;
        const isFilterAllowed = column.isFilterAllowed();
        if (!isFilterAllowed) return false;
        const filterWrapper = this.allColumnFilters.get(column.getColId());
        return (_b = (_a = filterWrapper == null ? void 0 : filterWrapper.filterPromise) == null ? void 0 : _a.resolveNow(true, // defer to filter component isFilterAllowed if it exists
        (filter)=>typeof (filter == null ? void 0 : filter.isFilterAllowed) === "function" ? filter == null ? void 0 : filter.isFilterAllowed() : true)) != null ? _b : true;
    }
    getFloatingFilterCompDetails(column, showParentFilter) {
        const parentFilterInstance = (callback)=>{
            const filterComponent = this.getFilterComponent(column, "NO_UI");
            if (filterComponent == null) return;
            filterComponent.then((instance)=>{
                callback($437b23f6a393c3bf$var$unwrapUserComp(instance));
            });
        };
        const colDef = column.getColDef();
        const filterParams = $437b23f6a393c3bf$var$__spreadProps($437b23f6a393c3bf$var$__spreadValues({}, this.createFilterParams(column, colDef)), {
            filterChangedCallback: ()=>parentFilterInstance((filterInstance)=>this.filterChangedCallbackFactory(filterInstance, column)())
        });
        const finalFilterParams = this.userComponentFactory.mergeParamsWithApplicationProvidedParams(colDef, $437b23f6a393c3bf$var$FilterComponent, filterParams);
        let defaultFloatingFilterType = this.userComponentFactory.getDefaultFloatingFilterType(colDef, ()=>this.getDefaultFloatingFilter(column));
        if (defaultFloatingFilterType == null) defaultFloatingFilterType = "agReadOnlyFloatingFilter";
        const params = {
            column: column,
            filterParams: finalFilterParams,
            currentParentModel: ()=>this.getCurrentFloatingFilterParentModel(column),
            parentFilterInstance: parentFilterInstance,
            showParentFilter: showParentFilter,
            suppressFilterButton: false
        };
        return this.userComponentFactory.getFloatingFilterCompDetails(colDef, params, defaultFloatingFilterType);
    }
    getCurrentFloatingFilterParentModel(column) {
        const filterComponent = this.getFilterComponent(column, "NO_UI", false);
        return filterComponent ? filterComponent.resolveNow(null, (filter)=>filter && filter.getModel()) : null;
    }
    // destroys the filter, so it no longer takes part
    destroyFilter(column, source = "api") {
        const colId = column.getColId();
        const filterWrapper = this.allColumnFilters.get(colId);
        this.disposeColumnListener(colId);
        delete this.initialFilterModel[colId];
        if (filterWrapper) {
            this.disposeFilterWrapper(filterWrapper, source);
            this.onFilterChanged({
                columns: [
                    column
                ],
                source: "api"
            });
        }
    }
    disposeColumnListener(colId) {
        const columnListener = this.allColumnListeners.get(colId);
        if (columnListener) {
            this.allColumnListeners.delete(colId);
            columnListener();
        }
    }
    disposeFilterWrapper(filterWrapper, source) {
        filterWrapper.filterPromise.then((filter)=>{
            this.getContext().destroyBean(filter);
            filterWrapper.column.setFilterActive(false, "filterDestroyed");
            this.allColumnFilters.delete(filterWrapper.column.getColId());
            const event = {
                type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_FILTER_DESTROYED,
                source: source,
                column: filterWrapper.column
            };
            this.eventService.dispatchEvent(event);
        });
    }
    filterModifiedCallbackFactory(filter, column) {
        return ()=>{
            const event = {
                type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_FILTER_MODIFIED,
                column: column,
                filterInstance: filter
            };
            this.eventService.dispatchEvent(event);
        };
    }
    filterChangedCallbackFactory(filter, column) {
        return (additionalEventAttributes)=>{
            var _a;
            const source = (_a = additionalEventAttributes == null ? void 0 : additionalEventAttributes.source) != null ? _a : "api";
            const params = {
                filter: filter,
                additionalEventAttributes: additionalEventAttributes,
                columns: [
                    column
                ],
                source: source
            };
            this.callOnFilterChangedOutsideRenderCycle(params);
        };
    }
    checkDestroyFilter(colId) {
        const filterWrapper = this.allColumnFilters.get(colId);
        if (!filterWrapper) return;
        const column = filterWrapper.column;
        const { compDetails: compDetails } = column.isFilterAllowed() ? this.createFilterInstance(column) : {
            compDetails: null
        };
        if (this.areFilterCompsDifferent(filterWrapper.compDetails, compDetails)) {
            this.destroyFilter(column, "paramsUpdated");
            return;
        }
        const newFilterParams = column.getColDef().filterParams;
        if (!filterWrapper.filterPromise) {
            this.destroyFilter(column, "paramsUpdated");
            return;
        }
        filterWrapper.filterPromise.then((filter)=>{
            const shouldRefreshFilter = (filter == null ? void 0 : filter.refresh) ? filter.refresh($437b23f6a393c3bf$var$__spreadValues($437b23f6a393c3bf$var$__spreadProps($437b23f6a393c3bf$var$__spreadValues({}, this.createFilterParams(column, column.getColDef())), {
                filterModifiedCallback: this.filterModifiedCallbackFactory(filter, column),
                filterChangedCallback: this.filterChangedCallbackFactory(filter, column),
                doesRowPassOtherFilter: (node)=>this.doesRowPassOtherFilters(filter, node)
            }), newFilterParams)) : true;
            if (shouldRefreshFilter === false) this.destroyFilter(column, "paramsUpdated");
        });
    }
    setColumnFilterWrapper(column, filterWrapper) {
        const colId = column.getColId();
        this.allColumnFilters.set(colId, filterWrapper);
        this.allColumnListeners.set(colId, this.addManagedListener(column, $437b23f6a393c3bf$export$816b5d811295e6bc.EVENT_COL_DEF_CHANGED, ()=>this.checkDestroyFilter(colId)));
    }
    areFilterCompsDifferent(oldCompDetails, newCompDetails) {
        if (!newCompDetails || !oldCompDetails) return true;
        const { componentClass: oldComponentClass } = oldCompDetails;
        const { componentClass: newComponentClass } = newCompDetails;
        const isSameComponentClass = oldComponentClass === newComponentClass || // react hooks returns new wrappers, so check nested render method
        (oldComponentClass == null ? void 0 : oldComponentClass.render) && (newComponentClass == null ? void 0 : newComponentClass.render) && oldComponentClass.render === newComponentClass.render;
        return !isSameComponentClass;
    }
    getAdvancedFilterModel() {
        return this.isAdvancedFilterEnabled() ? this.advancedFilterService.getModel() : null;
    }
    setAdvancedFilterModel(expression) {
        if (!this.isAdvancedFilterEnabled()) return;
        if (this.dataTypeService.isPendingInference()) {
            this.advancedFilterModelUpdateQueue.push(expression);
            return;
        }
        this.advancedFilterService.setModel(expression != null ? expression : null);
        this.onFilterChanged({
            source: "advancedFilter"
        });
    }
    showAdvancedFilterBuilder(source) {
        if (!this.isAdvancedFilterEnabled()) return;
        this.advancedFilterService.getCtrl().toggleFilterBuilder(source, true);
    }
    updateAdvancedFilterColumns() {
        if (!this.isAdvancedFilterEnabled()) return;
        if (this.advancedFilterService.updateValidity()) this.onFilterChanged({
            source: "advancedFilter"
        });
    }
    hasFloatingFilters() {
        if (this.isAdvancedFilterEnabled()) return false;
        const gridColumns = this.columnModel.getAllGridColumns();
        return gridColumns.some((col)=>col.getColDef().floatingFilter);
    }
    getFilterInstance(key, callback) {
        if (this.isAdvancedFilterEnabled()) {
            this.warnAdvancedFilters();
            return void 0;
        }
        const res = this.getFilterInstanceImpl(key, (instance)=>{
            if (!callback) return;
            const unwrapped2 = $437b23f6a393c3bf$var$unwrapUserComp(instance);
            callback(unwrapped2);
        });
        const unwrapped = $437b23f6a393c3bf$var$unwrapUserComp(res);
        return unwrapped;
    }
    getColumnFilterInstance(key) {
        return new Promise((resolve)=>{
            this.getFilterInstance(key, (filter)=>{
                resolve(filter);
            });
        });
    }
    getFilterInstanceImpl(key, callback) {
        const column = this.columnModel.getPrimaryColumn(key);
        if (!column) return void 0;
        const filterPromise = this.getFilterComponent(column, "NO_UI");
        const currentValue = filterPromise && filterPromise.resolveNow(null, (filterComp)=>filterComp);
        if (currentValue) setTimeout(callback, 0, currentValue);
        else if (filterPromise) filterPromise.then((comp)=>{
            callback(comp);
        });
        return currentValue;
    }
    warnAdvancedFilters() {
        $437b23f6a393c3bf$var$warnOnce("Column Filter API methods have been disabled as Advanced Filters are enabled.");
    }
    setupAdvancedFilterHeaderComp(eCompToInsertBefore) {
        var _a;
        (_a = this.advancedFilterService) == null || _a.getCtrl().setupHeaderComp(eCompToInsertBefore);
    }
    getHeaderRowCount() {
        return this.isAdvancedFilterHeaderActive() ? 1 : 0;
    }
    getHeaderHeight() {
        return this.isAdvancedFilterHeaderActive() ? this.advancedFilterService.getCtrl().getHeaderHeight() : 0;
    }
    processFilterModelUpdateQueue() {
        this.filterModelUpdateQueue.forEach(({ model: model, source: source })=>this.setFilterModel(model, source));
        this.filterModelUpdateQueue = [];
        this.columnFilterModelUpdateQueue.forEach(({ key: key, model: model, resolve: resolve })=>{
            this.setColumnFilterModel(key, model).then(()=>resolve());
        });
        this.columnFilterModelUpdateQueue = [];
        this.advancedFilterModelUpdateQueue.forEach((model)=>this.setAdvancedFilterModel(model));
        this.advancedFilterModelUpdateQueue = [];
    }
    getColumnFilterModel(key) {
        const filterWrapper = this.getFilterWrapper(key);
        return filterWrapper ? this.getModelFromFilterWrapper(filterWrapper) : null;
    }
    setColumnFilterModel(key, model) {
        if (this.isAdvancedFilterEnabled()) {
            this.warnAdvancedFilters();
            return Promise.resolve();
        }
        if (this.dataTypeService.isPendingInference()) {
            let resolve = ()=>{};
            const promise = new Promise((res)=>{
                resolve = res;
            });
            this.columnFilterModelUpdateQueue.push({
                key: key,
                model: model,
                resolve: resolve
            });
            return promise;
        }
        const column = this.columnModel.getPrimaryColumn(key);
        const filterWrapper = column ? this.getOrCreateFilterWrapper(column, "NO_UI") : null;
        const convertPromise = (promise)=>{
            return new Promise((resolve)=>{
                promise.then((result)=>resolve(result));
            });
        };
        return filterWrapper ? convertPromise(this.setModelOnFilterWrapper(filterWrapper.filterPromise, model)) : Promise.resolve();
    }
    getFilterWrapper(key) {
        var _a;
        const column = this.columnModel.getPrimaryColumn(key);
        return column ? (_a = this.cachedFilter(column)) != null ? _a : null : null;
    }
    destroy() {
        super.destroy();
        this.allColumnFilters.forEach((filterWrapper)=>this.disposeFilterWrapper(filterWrapper, "gridDestroyed"));
        this.allColumnListeners.clear();
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("valueService")
], $437b23f6a393c3bf$export$4c85e4ca0d95642f.prototype, "valueService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnModel")
], $437b23f6a393c3bf$export$4c85e4ca0d95642f.prototype, "columnModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowModel")
], $437b23f6a393c3bf$export$4c85e4ca0d95642f.prototype, "rowModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("userComponentFactory")
], $437b23f6a393c3bf$export$4c85e4ca0d95642f.prototype, "userComponentFactory", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowRenderer")
], $437b23f6a393c3bf$export$4c85e4ca0d95642f.prototype, "rowRenderer", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("dataTypeService")
], $437b23f6a393c3bf$export$4c85e4ca0d95642f.prototype, "dataTypeService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("quickFilterService")
], $437b23f6a393c3bf$export$4c85e4ca0d95642f.prototype, "quickFilterService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$7acb7b24c478f9c6("advancedFilterService")
], $437b23f6a393c3bf$export$4c85e4ca0d95642f.prototype, "advancedFilterService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$export$4c85e4ca0d95642f.prototype, "init", 1);
$437b23f6a393c3bf$export$4c85e4ca0d95642f = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("filterManager")
], $437b23f6a393c3bf$export$4c85e4ca0d95642f);
// community-modules/core/src/filter/filterWrapperComp.ts
var $437b23f6a393c3bf$export$70acaf0e0e30e7d = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(column, source){
        super(/* html */ `<div class="ag-filter"></div>`);
        this.column = column;
        this.source = source;
        this.filterWrapper = null;
    }
    postConstruct() {
        this.createFilter(true);
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_FILTER_DESTROYED, this.onFilterDestroyed.bind(this));
    }
    hasFilter() {
        return !!this.filterWrapper;
    }
    getFilter() {
        var _a, _b;
        return (_b = (_a = this.filterWrapper) == null ? void 0 : _a.filterPromise) != null ? _b : null;
    }
    afterInit() {
        var _a, _b, _c;
        return (_c = (_b = (_a = this.filterWrapper) == null ? void 0 : _a.filterPromise) == null ? void 0 : _b.then(()=>{})) != null ? _c : $437b23f6a393c3bf$export$30ec7836a4847721.resolve();
    }
    afterGuiAttached(params) {
        var _a, _b;
        (_b = (_a = this.filterWrapper) == null ? void 0 : _a.filterPromise) == null || _b.then((filter)=>{
            var _a2;
            (_a2 = filter == null ? void 0 : filter.afterGuiAttached) == null || _a2.call(filter, params);
        });
    }
    afterGuiDetached() {
        var _a, _b;
        (_b = (_a = this.filterWrapper) == null ? void 0 : _a.filterPromise) == null || _b.then((filter)=>{
            var _a2;
            (_a2 = filter == null ? void 0 : filter.afterGuiDetached) == null || _a2.call(filter);
        });
    }
    createFilter(init) {
        var _a;
        const { column: column, source: source } = this;
        this.filterWrapper = this.filterManager.getOrCreateFilterWrapper(column, source);
        if (!((_a = this.filterWrapper) == null ? void 0 : _a.filterPromise)) return;
        this.filterWrapper.filterPromise.then((filter)=>{
            let guiFromFilter = filter.getGui();
            if (!$437b23f6a393c3bf$var$exists(guiFromFilter)) console.warn(`AG Grid: getGui method from filter returned ${guiFromFilter}, it should be a DOM element or an HTML template string.`);
            if (typeof guiFromFilter === "string") guiFromFilter = $437b23f6a393c3bf$var$loadTemplate(guiFromFilter);
            this.appendChild(guiFromFilter);
            if (init) {
                const event = {
                    type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_FILTER_OPENED,
                    column: column,
                    source: source,
                    eGui: this.getGui()
                };
                this.eventService.dispatchEvent(event);
            }
        });
    }
    onFilterDestroyed(event) {
        if ((event.source === "api" || event.source === "paramsUpdated") && event.column.getId() === this.column.getId() && this.columnModel.getPrimaryColumn(this.column)) {
            $437b23f6a393c3bf$var$clearElement(this.getGui());
            this.createFilter();
        }
    }
    destroy() {
        this.filterWrapper = null;
        super.destroy();
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("filterManager")
], $437b23f6a393c3bf$export$70acaf0e0e30e7d.prototype, "filterManager", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnModel")
], $437b23f6a393c3bf$export$70acaf0e0e30e7d.prototype, "columnModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$export$70acaf0e0e30e7d.prototype, "postConstruct", 1);
// community-modules/core/src/headerRendering/cells/abstractCell/abstractHeaderCellComp.ts
var $437b23f6a393c3bf$var$AbstractHeaderCellComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(template, ctrl){
        super(template);
        this.ctrl = ctrl;
    }
    getCtrl() {
        return this.ctrl;
    }
};
// community-modules/core/src/headerRendering/cells/floatingFilter/headerFilterCellComp.ts
var $437b23f6a393c3bf$var$_HeaderFilterCellComp = class _HeaderFilterCellComp extends $437b23f6a393c3bf$var$AbstractHeaderCellComp {
    constructor(ctrl){
        super(_HeaderFilterCellComp.TEMPLATE, ctrl);
    }
    postConstruct() {
        const eGui = this.getGui();
        const compProxy = {
            addOrRemoveCssClass: (cssClassName, on)=>this.addOrRemoveCssClass(cssClassName, on),
            addOrRemoveBodyCssClass: (cssClassName, on)=>this.eFloatingFilterBody.classList.toggle(cssClassName, on),
            setButtonWrapperDisplayed: (displayed)=>$437b23f6a393c3bf$var$setDisplayed(this.eButtonWrapper, displayed),
            setCompDetails: (compDetails)=>this.setCompDetails(compDetails),
            getFloatingFilterComp: ()=>this.compPromise,
            setWidth: (width)=>eGui.style.width = width,
            setMenuIcon: (eIcon)=>this.eButtonShowMainFilter.appendChild(eIcon)
        };
        this.ctrl.setComp(compProxy, eGui, this.eButtonShowMainFilter, this.eFloatingFilterBody);
    }
    setCompDetails(compDetails) {
        if (!compDetails) {
            this.destroyFloatingFilterComp();
            this.compPromise = null;
            return;
        }
        this.compPromise = compDetails.newAgStackInstance();
        this.compPromise.then((comp)=>this.afterCompCreated(comp));
    }
    destroyFloatingFilterComp() {
        if (this.floatingFilterComp) {
            this.eFloatingFilterBody.removeChild(this.floatingFilterComp.getGui());
            this.floatingFilterComp = this.destroyBean(this.floatingFilterComp);
        }
    }
    afterCompCreated(comp) {
        if (!comp) return;
        if (!this.isAlive()) {
            this.destroyBean(comp);
            return;
        }
        this.destroyFloatingFilterComp();
        this.floatingFilterComp = comp;
        this.eFloatingFilterBody.appendChild(comp.getGui());
        if (comp.afterGuiAttached) comp.afterGuiAttached();
    }
};
$437b23f6a393c3bf$var$_HeaderFilterCellComp.TEMPLATE = /* html */ `<div class="ag-header-cell ag-floating-filter" role="gridcell">
            <div ref="eFloatingFilterBody" role="presentation"></div>
            <div class="ag-floating-filter-button ag-hidden" ref="eButtonWrapper" role="presentation">
                <button type="button" class="ag-button ag-floating-filter-button-button" ref="eButtonShowMainFilter" tabindex="-1"></button>
            </div>
        </div>`;
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eFloatingFilterBody")
], $437b23f6a393c3bf$var$_HeaderFilterCellComp.prototype, "eFloatingFilterBody", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eButtonWrapper")
], $437b23f6a393c3bf$var$_HeaderFilterCellComp.prototype, "eButtonWrapper", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eButtonShowMainFilter")
], $437b23f6a393c3bf$var$_HeaderFilterCellComp.prototype, "eButtonShowMainFilter", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$_HeaderFilterCellComp.prototype, "postConstruct", 1);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$cc3f3d4529c57d95
], $437b23f6a393c3bf$var$_HeaderFilterCellComp.prototype, "destroyFloatingFilterComp", 1);
var $437b23f6a393c3bf$export$aee3d2f667fe76c1 = $437b23f6a393c3bf$var$_HeaderFilterCellComp;
// community-modules/core/src/styling/layoutFeature.ts
var $437b23f6a393c3bf$export$f22675e2b4e3ac28 = /* @__PURE__ */ ((LayoutCssClasses2)=>{
    LayoutCssClasses2["AUTO_HEIGHT"] = "ag-layout-auto-height";
    LayoutCssClasses2["NORMAL"] = "ag-layout-normal";
    LayoutCssClasses2["PRINT"] = "ag-layout-print";
    return LayoutCssClasses2;
})($437b23f6a393c3bf$export$f22675e2b4e3ac28 || {});
var $437b23f6a393c3bf$var$LayoutFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(view){
        super();
        this.view = view;
    }
    postConstruct() {
        this.addManagedPropertyListener("domLayout", this.updateLayoutClasses.bind(this));
        this.updateLayoutClasses();
    }
    updateLayoutClasses() {
        const domLayout = this.getDomLayout();
        const params = {
            autoHeight: domLayout === "autoHeight",
            normal: domLayout === "normal",
            print: domLayout === "print"
        };
        const cssClass = params.autoHeight ? "ag-layout-auto-height" /* AUTO_HEIGHT */  : params.print ? "ag-layout-print" /* PRINT */  : "ag-layout-normal" /* NORMAL */ ;
        this.view.updateLayoutClasses(cssClass, params);
    }
    // returns either 'print', 'autoHeight' or 'normal' (normal is the default)
    getDomLayout() {
        var _a;
        const domLayout = (_a = this.gos.get("domLayout")) != null ? _a : "normal";
        const validLayouts = [
            "normal",
            "print",
            "autoHeight"
        ];
        if (validLayouts.indexOf(domLayout) === -1) {
            $437b23f6a393c3bf$var$warnOnce(`${domLayout} is not valid for DOM Layout, valid values are 'normal', 'autoHeight', 'print'.`);
            return "normal";
        }
        return domLayout;
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$LayoutFeature.prototype, "postConstruct", 1);
// community-modules/core/src/gridBodyComp/gridBodyScrollFeature.ts
var $437b23f6a393c3bf$var$GridBodyScrollFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(eBodyViewport){
        super();
        this.lastScrollSource = [
            null,
            null
        ];
        this.scrollLeft = -1;
        this.nextScrollTop = -1;
        this.scrollTop = -1;
        // Used to provide approximate values of scrollTop and offsetHeight
        // without forcing the browser to recalculate styles.
        this.lastOffsetHeight = -1;
        this.lastScrollTop = -1;
        this.eBodyViewport = eBodyViewport;
        this.resetLastHScrollDebounced = $437b23f6a393c3bf$var$debounce(()=>this.lastScrollSource[1 /* Horizontal */ ] = null, 500);
        this.resetLastVScrollDebounced = $437b23f6a393c3bf$var$debounce(()=>this.lastScrollSource[0 /* Vertical */ ] = null, 500);
    }
    postConstruct() {
        this.enableRtl = this.gos.get("enableRtl");
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, this.onDisplayedColumnsWidthChanged.bind(this));
        this.ctrlsService.whenReady((p)=>{
            this.centerRowsCtrl = p.center;
            this.onDisplayedColumnsWidthChanged();
            this.addScrollListener();
        });
    }
    addScrollListener() {
        const { fakeHScrollComp: fakeHScrollComp, fakeVScrollComp: fakeVScrollComp } = this.ctrlsService.getParams();
        this.addManagedListener(this.centerRowsCtrl.getViewportElement(), "scroll", this.onHScroll.bind(this));
        fakeHScrollComp.onScrollCallback(this.onFakeHScroll.bind(this));
        const isDebounce = this.gos.get("debounceVerticalScrollbar");
        const onVScroll = isDebounce ? $437b23f6a393c3bf$var$debounce(this.onVScroll.bind(this), 100) : this.onVScroll.bind(this);
        const onFakeVScroll = isDebounce ? $437b23f6a393c3bf$var$debounce(this.onFakeVScroll.bind(this), 100) : this.onFakeVScroll.bind(this);
        this.addManagedListener(this.eBodyViewport, "scroll", onVScroll);
        fakeVScrollComp.onScrollCallback(onFakeVScroll);
    }
    onDisplayedColumnsWidthChanged() {
        if (this.enableRtl) this.horizontallyScrollHeaderCenterAndFloatingCenter();
    }
    horizontallyScrollHeaderCenterAndFloatingCenter(scrollLeft) {
        const notYetInitialised = this.centerRowsCtrl == null;
        if (notYetInitialised) return;
        if (scrollLeft === void 0) scrollLeft = this.centerRowsCtrl.getCenterViewportScrollLeft();
        const offset = this.enableRtl ? scrollLeft : -scrollLeft;
        const { topCenter: topCenter, stickyTopCenter: stickyTopCenter, stickyBottomCenter: stickyBottomCenter, centerHeader: centerHeader, bottomCenter: bottomCenter, fakeHScrollComp: fakeHScrollComp } = this.ctrlsService.getParams();
        centerHeader.setHorizontalScroll(-offset);
        bottomCenter.setContainerTranslateX(offset);
        topCenter.setContainerTranslateX(offset);
        stickyTopCenter.setContainerTranslateX(offset);
        stickyBottomCenter.setContainerTranslateX(offset);
        const centerViewport = this.centerRowsCtrl.getViewportElement();
        const isCenterViewportLastHorizontal = this.lastScrollSource[1 /* Horizontal */ ] === 0 /* Container */ ;
        scrollLeft = Math.abs(scrollLeft);
        if (isCenterViewportLastHorizontal) fakeHScrollComp.setScrollPosition(scrollLeft);
        else $437b23f6a393c3bf$var$setScrollLeft(centerViewport, scrollLeft, this.enableRtl);
    }
    isControllingScroll(source, direction) {
        if (this.lastScrollSource[direction] == null) {
            this.lastScrollSource[direction] = source;
            return true;
        }
        return this.lastScrollSource[direction] === source;
    }
    onFakeHScroll() {
        if (!this.isControllingScroll(1 /* FakeContainer */ , 1 /* Horizontal */ )) return;
        this.onHScrollCommon(1 /* FakeContainer */ );
    }
    onHScroll() {
        if (!this.isControllingScroll(0 /* Container */ , 1 /* Horizontal */ )) return;
        this.onHScrollCommon(0 /* Container */ );
    }
    onHScrollCommon(source) {
        const centerContainerViewport = this.centerRowsCtrl.getViewportElement();
        const { scrollLeft: scrollLeft } = centerContainerViewport;
        if (this.shouldBlockScrollUpdate(1 /* Horizontal */ , scrollLeft, true)) return;
        let newScrollLeft;
        if (source === 0 /* Container */ ) newScrollLeft = $437b23f6a393c3bf$var$getScrollLeft(centerContainerViewport, this.enableRtl);
        else newScrollLeft = this.ctrlsService.get("fakeHScrollComp").getScrollPosition();
        this.doHorizontalScroll(Math.round(newScrollLeft));
        this.resetLastHScrollDebounced();
    }
    onFakeVScroll() {
        if (!this.isControllingScroll(1 /* FakeContainer */ , 0 /* Vertical */ )) return;
        this.onVScrollCommon(1 /* FakeContainer */ );
    }
    onVScroll() {
        if (!this.isControllingScroll(0 /* Container */ , 0 /* Vertical */ )) return;
        this.onVScrollCommon(0 /* Container */ );
    }
    onVScrollCommon(source) {
        let scrollTop;
        if (source === 0 /* Container */ ) scrollTop = this.eBodyViewport.scrollTop;
        else scrollTop = this.ctrlsService.get("fakeVScrollComp").getScrollPosition();
        if (this.shouldBlockScrollUpdate(0 /* Vertical */ , scrollTop, true)) return;
        this.animationFrameService.setScrollTop(scrollTop);
        this.nextScrollTop = scrollTop;
        if (source === 0 /* Container */ ) this.ctrlsService.get("fakeVScrollComp").setScrollPosition(scrollTop);
        else this.eBodyViewport.scrollTop = scrollTop;
        if (this.gos.get("suppressAnimationFrame")) this.scrollGridIfNeeded();
        else this.animationFrameService.schedule();
        this.resetLastVScrollDebounced();
    }
    doHorizontalScroll(scrollLeft) {
        const fakeScrollLeft = this.ctrlsService.get("fakeHScrollComp").getScrollPosition();
        if (this.scrollLeft === scrollLeft && scrollLeft === fakeScrollLeft) return;
        this.scrollLeft = scrollLeft;
        this.fireScrollEvent(1 /* Horizontal */ );
        this.horizontallyScrollHeaderCenterAndFloatingCenter(scrollLeft);
        this.centerRowsCtrl.onHorizontalViewportChanged(true);
    }
    fireScrollEvent(direction) {
        const bodyScrollEvent = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_BODY_SCROLL,
            direction: direction === 1 /* Horizontal */  ? "horizontal" : "vertical",
            left: this.scrollLeft,
            top: this.scrollTop
        };
        this.eventService.dispatchEvent(bodyScrollEvent);
        window.clearTimeout(this.scrollTimer);
        this.scrollTimer = void 0;
        this.scrollTimer = window.setTimeout(()=>{
            const bodyScrollEndEvent = $437b23f6a393c3bf$var$__spreadProps($437b23f6a393c3bf$var$__spreadValues({}, bodyScrollEvent), {
                type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_BODY_SCROLL_END
            });
            this.eventService.dispatchEvent(bodyScrollEndEvent);
        }, 100);
    }
    shouldBlockScrollUpdate(direction, scrollTo, touchOnly = false) {
        if (touchOnly && !$437b23f6a393c3bf$var$isIOSUserAgent()) return false;
        if (direction === 0 /* Vertical */ ) return this.shouldBlockVerticalScroll(scrollTo);
        return this.shouldBlockHorizontalScroll(scrollTo);
    }
    shouldBlockVerticalScroll(scrollTo) {
        const clientHeight = $437b23f6a393c3bf$var$getInnerHeight(this.eBodyViewport);
        const { scrollHeight: scrollHeight } = this.eBodyViewport;
        if (scrollTo < 0 || scrollTo + clientHeight > scrollHeight) return true;
        return false;
    }
    shouldBlockHorizontalScroll(scrollTo) {
        const clientWidth = this.centerRowsCtrl.getCenterWidth();
        const { scrollWidth: scrollWidth } = this.centerRowsCtrl.getViewportElement();
        if (this.enableRtl && $437b23f6a393c3bf$var$isRtlNegativeScroll()) {
            if (scrollTo > 0) return true;
        } else if (scrollTo < 0) return true;
        if (Math.abs(scrollTo) + clientWidth > scrollWidth) return true;
        return false;
    }
    redrawRowsAfterScroll() {
        this.fireScrollEvent(0 /* Vertical */ );
    }
    // this is to cater for AG-3274, where grid is removed from the dom and then inserted back in again.
    // (which happens with some implementations of tabbing). this can result in horizontal scroll getting
    // reset back to the left, however no scroll event is fired. so we need to get header to also scroll
    // back to the left to be kept in sync.
    // adding and removing the grid from the DOM both resets the scroll position and
    // triggers a resize event, so notify listeners if the scroll position has changed
    checkScrollLeft() {
        if (this.scrollLeft !== this.centerRowsCtrl.getCenterViewportScrollLeft()) this.onHScrollCommon(0 /* Container */ );
    }
    scrollGridIfNeeded() {
        const frameNeeded = this.scrollTop != this.nextScrollTop;
        if (frameNeeded) {
            this.scrollTop = this.nextScrollTop;
            this.redrawRowsAfterScroll();
        }
        return frameNeeded;
    }
    // called by scrollHorizontally method and alignedGridsService
    setHorizontalScrollPosition(hScrollPosition, fromAlignedGridsService = false) {
        const minScrollLeft = 0;
        const maxScrollLeft = this.centerRowsCtrl.getViewportElement().scrollWidth - this.centerRowsCtrl.getCenterWidth();
        if (!fromAlignedGridsService && this.shouldBlockScrollUpdate(1 /* Horizontal */ , hScrollPosition)) {
            if (this.enableRtl && $437b23f6a393c3bf$var$isRtlNegativeScroll()) hScrollPosition = hScrollPosition > 0 ? 0 : maxScrollLeft;
            else hScrollPosition = Math.min(Math.max(hScrollPosition, minScrollLeft), maxScrollLeft);
        }
        $437b23f6a393c3bf$var$setScrollLeft(this.centerRowsCtrl.getViewportElement(), Math.abs(hScrollPosition), this.enableRtl);
        this.doHorizontalScroll(hScrollPosition);
    }
    setVerticalScrollPosition(vScrollPosition) {
        this.eBodyViewport.scrollTop = vScrollPosition;
    }
    getVScrollPosition() {
        this.lastScrollTop = this.eBodyViewport.scrollTop;
        this.lastOffsetHeight = this.eBodyViewport.offsetHeight;
        const result = {
            top: this.lastScrollTop,
            bottom: this.lastScrollTop + this.lastOffsetHeight
        };
        return result;
    }
    /** Get an approximate scroll position that returns the last real value read.
   * This is useful for avoiding repeated DOM reads that force the browser to recalculate styles.
   * This can have big performance improvements but may not be 100% accurate so only use if this is acceptable.
   */ getApproximateVScollPosition() {
        if (this.lastScrollTop >= 0 && this.lastOffsetHeight >= 0) return {
            top: this.scrollTop,
            bottom: this.scrollTop + this.lastOffsetHeight
        };
        return this.getVScrollPosition();
    }
    getHScrollPosition() {
        return this.centerRowsCtrl.getHScrollPosition();
    }
    isHorizontalScrollShowing() {
        return this.centerRowsCtrl.isHorizontalScrollShowing();
    }
    // called by the headerRootComp and moveColumnController
    scrollHorizontally(pixels) {
        const oldScrollPosition = this.centerRowsCtrl.getViewportElement().scrollLeft;
        this.setHorizontalScrollPosition(oldScrollPosition + pixels);
        return this.centerRowsCtrl.getViewportElement().scrollLeft - oldScrollPosition;
    }
    // gets called by rowRenderer when new data loaded, as it will want to scroll to the top
    scrollToTop() {
        this.eBodyViewport.scrollTop = 0;
    }
    // Valid values for position are bottom, middle and top
    ensureNodeVisible(comparator, position = null) {
        const rowCount = this.rowModel.getRowCount();
        let indexToSelect = -1;
        for(let i = 0; i < rowCount; i++){
            const node = this.rowModel.getRow(i);
            if (typeof comparator === "function") {
                const predicate = comparator;
                if (node && predicate(node)) {
                    indexToSelect = i;
                    break;
                }
            } else if (comparator === node || comparator === node.data) {
                indexToSelect = i;
                break;
            }
        }
        if (indexToSelect >= 0) this.ensureIndexVisible(indexToSelect, position);
    }
    // Valid values for position are bottom, middle and top
    // position should be {'top','middle','bottom', or undefined/null}.
    // if undefined/null, then the grid will to the minimal amount of scrolling,
    // eg if grid needs to scroll up, it scrolls until row is on top,
    //    if grid needs to scroll down, it scrolls until row is on bottom,
    //    if row is already in view, grid does not scroll
    ensureIndexVisible(index, position) {
        if (this.gos.isDomLayout("print")) return;
        const rowCount = this.paginationProxy.getRowCount();
        if (typeof index !== "number" || index < 0 || index >= rowCount) {
            console.warn("AG Grid: Invalid row index for ensureIndexVisible: " + index);
            return;
        }
        const isPaging = this.gos.get("pagination");
        const paginationPanelEnabled = isPaging && !this.gos.get("suppressPaginationPanel");
        this.getFrameworkOverrides().wrapIncoming(()=>{
            if (!paginationPanelEnabled) this.paginationProxy.goToPageWithIndex(index);
            const gridBodyCtrl = this.ctrlsService.getGridBodyCtrl();
            const stickyTopHeight = gridBodyCtrl.getStickyTopHeight();
            const stickyBottomHeight = gridBodyCtrl.getStickyBottomHeight();
            const rowNode = this.paginationProxy.getRow(index);
            let rowGotShiftedDuringOperation;
            do {
                const startingRowTop = rowNode.rowTop;
                const startingRowHeight = rowNode.rowHeight;
                const paginationOffset = this.paginationProxy.getPixelOffset();
                const rowTopPixel = rowNode.rowTop - paginationOffset;
                const rowBottomPixel = rowTopPixel + rowNode.rowHeight;
                const scrollPosition = this.getVScrollPosition();
                const heightOffset = this.heightScaler.getDivStretchOffset();
                const vScrollTop = scrollPosition.top + heightOffset;
                const vScrollBottom = scrollPosition.bottom + heightOffset;
                const viewportHeight = vScrollBottom - vScrollTop;
                const pxTop = this.heightScaler.getScrollPositionForPixel(rowTopPixel);
                const pxBottom = this.heightScaler.getScrollPositionForPixel(rowBottomPixel - viewportHeight);
                const pxMiddle = Math.min((pxTop + pxBottom) / 2, rowTopPixel);
                const rowAboveViewport = vScrollTop + stickyTopHeight > rowTopPixel;
                const rowBelowViewport = vScrollBottom - stickyBottomHeight < rowBottomPixel;
                let newScrollPosition = null;
                if (position === "top") newScrollPosition = pxTop;
                else if (position === "bottom") newScrollPosition = pxBottom;
                else if (position === "middle") newScrollPosition = pxMiddle;
                else if (rowAboveViewport) newScrollPosition = pxTop - stickyTopHeight;
                else if (rowBelowViewport) newScrollPosition = pxBottom + stickyBottomHeight;
                if (newScrollPosition !== null) {
                    this.setVerticalScrollPosition(newScrollPosition);
                    this.rowRenderer.redraw({
                        afterScroll: true
                    });
                }
                rowGotShiftedDuringOperation = startingRowTop !== rowNode.rowTop || startingRowHeight !== rowNode.rowHeight;
            }while (rowGotShiftedDuringOperation);
            this.animationFrameService.flushAllFrames();
        });
    }
    ensureColumnVisible(key, position = "auto") {
        const column = this.columnModel.getGridColumn(key);
        if (!column) return;
        if (column.isPinned()) return;
        if (!this.columnModel.isColumnDisplayed(column)) return;
        const newHorizontalScroll = this.getPositionedHorizontalScroll(column, position);
        this.getFrameworkOverrides().wrapIncoming(()=>{
            if (newHorizontalScroll !== null) this.centerRowsCtrl.setCenterViewportScrollLeft(newHorizontalScroll);
            this.centerRowsCtrl.onHorizontalViewportChanged();
            this.animationFrameService.flushAllFrames();
        });
    }
    setScrollPosition(top, left) {
        this.getFrameworkOverrides().wrapIncoming(()=>{
            this.centerRowsCtrl.setCenterViewportScrollLeft(left);
            this.setVerticalScrollPosition(top);
            this.rowRenderer.redraw({
                afterScroll: true
            });
            this.animationFrameService.flushAllFrames();
        });
    }
    getPositionedHorizontalScroll(column, position) {
        const { columnBeforeStart: columnBeforeStart, columnAfterEnd: columnAfterEnd } = this.isColumnOutsideViewport(column);
        const viewportTooSmallForColumn = this.centerRowsCtrl.getCenterWidth() < column.getActualWidth();
        const viewportWidth = this.centerRowsCtrl.getCenterWidth();
        const isRtl = this.enableRtl;
        let alignColToStart = (isRtl ? columnBeforeStart : columnAfterEnd) || viewportTooSmallForColumn;
        let alignColToEnd = isRtl ? columnAfterEnd : columnBeforeStart;
        if (position !== "auto") {
            alignColToStart = position === "start";
            alignColToEnd = position === "end";
        }
        const isMiddle = position === "middle";
        if (alignColToStart || alignColToEnd || isMiddle) {
            const { colLeft: colLeft, colMiddle: colMiddle, colRight: colRight } = this.getColumnBounds(column);
            if (isMiddle) return colMiddle - viewportWidth / 2;
            if (alignColToStart) return isRtl ? colRight : colLeft;
            return isRtl ? colLeft - viewportWidth : colRight - viewportWidth;
        }
        return null;
    }
    isColumnOutsideViewport(column) {
        const { start: viewportStart, end: viewportEnd } = this.getViewportBounds();
        const { colLeft: colLeft, colRight: colRight } = this.getColumnBounds(column);
        const isRtl = this.enableRtl;
        const columnBeforeStart = isRtl ? viewportStart > colRight : viewportEnd < colRight;
        const columnAfterEnd = isRtl ? viewportEnd < colLeft : viewportStart > colLeft;
        return {
            columnBeforeStart: columnBeforeStart,
            columnAfterEnd: columnAfterEnd
        };
    }
    getColumnBounds(column) {
        const isRtl = this.enableRtl;
        const bodyWidth = this.columnModel.getBodyContainerWidth();
        const colWidth = column.getActualWidth();
        const colLeft = column.getLeft();
        const multiplier = isRtl ? -1 : 1;
        const colLeftPixel = isRtl ? bodyWidth - colLeft : colLeft;
        const colRightPixel = colLeftPixel + colWidth * multiplier;
        const colMidPixel = colLeftPixel + colWidth / 2 * multiplier;
        return {
            colLeft: colLeftPixel,
            colMiddle: colMidPixel,
            colRight: colRightPixel
        };
    }
    getViewportBounds() {
        const viewportWidth = this.centerRowsCtrl.getCenterWidth();
        const scrollPosition = this.centerRowsCtrl.getCenterViewportScrollLeft();
        const viewportStartPixel = scrollPosition;
        const viewportEndPixel = viewportWidth + scrollPosition;
        return {
            start: viewportStartPixel,
            end: viewportEndPixel,
            width: viewportWidth
        };
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("ctrlsService")
], $437b23f6a393c3bf$var$GridBodyScrollFeature.prototype, "ctrlsService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("animationFrameService")
], $437b23f6a393c3bf$var$GridBodyScrollFeature.prototype, "animationFrameService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("paginationProxy")
], $437b23f6a393c3bf$var$GridBodyScrollFeature.prototype, "paginationProxy", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowModel")
], $437b23f6a393c3bf$var$GridBodyScrollFeature.prototype, "rowModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowContainerHeightService")
], $437b23f6a393c3bf$var$GridBodyScrollFeature.prototype, "heightScaler", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowRenderer")
], $437b23f6a393c3bf$var$GridBodyScrollFeature.prototype, "rowRenderer", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnModel")
], $437b23f6a393c3bf$var$GridBodyScrollFeature.prototype, "columnModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$GridBodyScrollFeature.prototype, "postConstruct", 1);
// community-modules/core/src/gridBodyComp/gridBodyCtrl.ts
var $437b23f6a393c3bf$export$4ffc042a393c407b = /* @__PURE__ */ ((RowAnimationCssClasses2)=>{
    RowAnimationCssClasses2["ANIMATION_ON"] = "ag-row-animation";
    RowAnimationCssClasses2["ANIMATION_OFF"] = "ag-row-no-animation";
    return RowAnimationCssClasses2;
})($437b23f6a393c3bf$export$4ffc042a393c407b || {});
var $437b23f6a393c3bf$var$CSS_CLASS_FORCE_VERTICAL_SCROLL = "ag-force-vertical-scroll";
var $437b23f6a393c3bf$var$CSS_CLASS_CELL_SELECTABLE = "ag-selectable";
var $437b23f6a393c3bf$var$CSS_CLASS_COLUMN_MOVING = "ag-column-moving";
var $437b23f6a393c3bf$export$8bebc3145b40d221 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.stickyTopHeight = 0;
        this.stickyBottomHeight = 0;
    }
    getScrollFeature() {
        return this.bodyScrollFeature;
    }
    getBodyViewportElement() {
        return this.eBodyViewport;
    }
    setComp(comp, eGridBody, eBodyViewport, eTop, eBottom, eStickyTop, eStickyBottom) {
        this.comp = comp;
        this.eGridBody = eGridBody;
        this.eBodyViewport = eBodyViewport;
        this.eTop = eTop;
        this.eBottom = eBottom;
        this.eStickyTop = eStickyTop;
        this.eStickyBottom = eStickyBottom;
        this.setCellTextSelection(this.gos.get("enableCellTextSelection"));
        this.addManagedPropertyListener("enableCellTextSelection", (props)=>this.setCellTextSelection(props.currentValue));
        this.createManagedBean(new $437b23f6a393c3bf$var$LayoutFeature(this.comp));
        this.bodyScrollFeature = this.createManagedBean(new $437b23f6a393c3bf$var$GridBodyScrollFeature(this.eBodyViewport));
        this.addRowDragListener();
        this.setupRowAnimationCssClass();
        this.addEventListeners();
        this.addFocusListeners([
            eTop,
            eBodyViewport,
            eBottom,
            eStickyTop,
            eStickyBottom
        ]);
        this.onGridColumnsChanged();
        this.addBodyViewportListener();
        this.setFloatingHeights();
        this.disableBrowserDragging();
        this.addStopEditingWhenGridLosesFocus();
        this.filterManager.setupAdvancedFilterHeaderComp(eTop);
        this.ctrlsService.register("gridBodyCtrl", this);
    }
    getComp() {
        return this.comp;
    }
    addEventListeners() {
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_GRID_COLUMNS_CHANGED, this.onGridColumnsChanged.bind(this));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_SCROLL_VISIBILITY_CHANGED, this.onScrollVisibilityChanged.bind(this));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_PINNED_ROW_DATA_CHANGED, this.onPinnedRowDataChanged.bind(this));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_HEADER_HEIGHT_CHANGED, this.onHeaderHeightChanged.bind(this));
    }
    addFocusListeners(elements) {
        elements.forEach((element)=>{
            this.addManagedListener(element, "focusin", (e)=>{
                const { target: target } = e;
                const isFocusedElementNested = $437b23f6a393c3bf$var$isElementChildOfClass(target, "ag-root", element);
                element.classList.toggle("ag-has-focus", !isFocusedElementNested);
            });
            this.addManagedListener(element, "focusout", (e)=>{
                const { target: target, relatedTarget: relatedTarget } = e;
                const gridContainRelatedTarget = element.contains(relatedTarget);
                const isNestedRelatedTarget = $437b23f6a393c3bf$var$isElementChildOfClass(relatedTarget, "ag-root", element);
                const isNestedTarget = $437b23f6a393c3bf$var$isElementChildOfClass(target, "ag-root", element);
                if (isNestedTarget) return;
                if (!gridContainRelatedTarget || isNestedRelatedTarget) element.classList.remove("ag-has-focus");
            });
        });
    }
    // used by ColumnAnimationService
    setColumnMovingCss(moving) {
        this.comp.setColumnMovingCss($437b23f6a393c3bf$var$CSS_CLASS_COLUMN_MOVING, moving);
    }
    setCellTextSelection(selectable = false) {
        this.comp.setCellSelectableCss($437b23f6a393c3bf$var$CSS_CLASS_CELL_SELECTABLE, selectable);
    }
    onScrollVisibilityChanged() {
        const visible = this.scrollVisibleService.isVerticalScrollShowing();
        this.setVerticalScrollPaddingVisible(visible);
        this.setStickyWidth(visible);
        this.setStickyBottomOffsetBottom();
        const scrollbarWidth = visible ? this.gos.getScrollbarWidth() || 0 : 0;
        const pad = $437b23f6a393c3bf$var$isInvisibleScrollbar() ? 16 : 0;
        const width = `calc(100% + ${scrollbarWidth + pad}px)`;
        this.animationFrameService.requestAnimationFrame(()=>this.comp.setBodyViewportWidth(width));
    }
    onGridColumnsChanged() {
        const columns = this.columnModel.getAllGridColumns();
        this.comp.setColumnCount(columns.length);
    }
    // if we do not do this, then the user can select a pic in the grid (eg an image in a custom cell renderer)
    // and then that will start the browser native drag n' drop, which messes up with our own drag and drop.
    disableBrowserDragging() {
        this.addManagedListener(this.eGridBody, "dragstart", (event)=>{
            if (event.target instanceof HTMLImageElement) {
                event.preventDefault();
                return false;
            }
        });
    }
    addStopEditingWhenGridLosesFocus() {
        if (!this.gos.get("stopEditingWhenCellsLoseFocus")) return;
        const focusOutListener = (event)=>{
            const elementWithFocus = event.relatedTarget;
            if ($437b23f6a393c3bf$var$getTabIndex(elementWithFocus) === null) {
                this.rowRenderer.stopEditing();
                return;
            }
            let clickInsideGrid = // see if click came from inside the viewports
            viewports.some((viewport)=>viewport.contains(elementWithFocus)) && this.mouseEventService.isElementInThisGrid(elementWithFocus);
            if (!clickInsideGrid) {
                const popupService = this.popupService;
                clickInsideGrid = popupService.getActivePopups().some((popup)=>popup.contains(elementWithFocus)) || popupService.isElementWithinCustomPopup(elementWithFocus);
            }
            if (!clickInsideGrid) this.rowRenderer.stopEditing();
        };
        const viewports = [
            this.eBodyViewport,
            this.eBottom,
            this.eTop,
            this.eStickyTop,
            this.eStickyBottom
        ];
        viewports.forEach((viewport)=>this.addManagedListener(viewport, "focusout", focusOutListener));
    }
    updateRowCount() {
        const headerCount = this.headerNavigationService.getHeaderRowCount() + this.filterManager.getHeaderRowCount();
        const rowCount = this.rowModel.isLastRowIndexKnown() ? this.rowModel.getRowCount() : -1;
        const total = rowCount === -1 ? -1 : headerCount + rowCount;
        this.comp.setRowCount(total);
    }
    registerBodyViewportResizeListener(listener) {
        this.comp.registerBodyViewportResizeListener(listener);
    }
    setVerticalScrollPaddingVisible(visible) {
        const overflowY = visible ? "scroll" : "hidden";
        this.comp.setPinnedTopBottomOverflowY(overflowY);
    }
    isVerticalScrollShowing() {
        const show = this.gos.get("alwaysShowVerticalScroll");
        const cssClass = show ? $437b23f6a393c3bf$var$CSS_CLASS_FORCE_VERTICAL_SCROLL : null;
        const allowVerticalScroll = this.gos.isDomLayout("normal");
        this.comp.setAlwaysVerticalScrollClass(cssClass, show);
        return show || allowVerticalScroll && $437b23f6a393c3bf$var$isVerticalScrollShowing(this.eBodyViewport);
    }
    setupRowAnimationCssClass() {
        const listener = ()=>{
            const animateRows = this.gos.isAnimateRows() && !this.rowContainerHeightService.isStretching();
            const animateRowsCssClass = animateRows ? "ag-row-animation" /* ANIMATION_ON */  : "ag-row-no-animation" /* ANIMATION_OFF */ ;
            this.comp.setRowAnimationCssOnBodyViewport(animateRowsCssClass, animateRows);
        };
        listener();
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_HEIGHT_SCALE_CHANGED, listener);
        this.addManagedPropertyListener("animateRows", listener);
    }
    getGridBodyElement() {
        return this.eGridBody;
    }
    addBodyViewportListener() {
        const listener = this.onBodyViewportContextMenu.bind(this);
        this.addManagedListener(this.eBodyViewport, "contextmenu", listener);
        this.mockContextMenuForIPad(listener);
        this.addManagedListener(this.eBodyViewport, "wheel", this.onBodyViewportWheel.bind(this));
        this.addManagedListener(this.eStickyTop, "wheel", this.onStickyWheel.bind(this));
        this.addManagedListener(this.eStickyBottom, "wheel", this.onStickyWheel.bind(this));
        this.addFullWidthContainerWheelListener();
    }
    addFullWidthContainerWheelListener() {
        const fullWidthContainer = this.eBodyViewport.querySelector(".ag-full-width-container");
        const eCenterColsViewport = this.eBodyViewport.querySelector(".ag-center-cols-viewport");
        if (fullWidthContainer && eCenterColsViewport) this.addManagedListener(fullWidthContainer, "wheel", (e)=>this.onFullWidthContainerWheel(e, eCenterColsViewport));
    }
    onFullWidthContainerWheel(e, eCenterColsViewport) {
        if (!e.deltaX || Math.abs(e.deltaY) > Math.abs(e.deltaX) || !this.mouseEventService.isEventFromThisGrid(e)) return;
        e.preventDefault();
        eCenterColsViewport.scrollBy({
            left: e.deltaX
        });
    }
    onBodyViewportContextMenu(mouseEvent, touch, touchEvent) {
        if (!mouseEvent && !touchEvent) return;
        if (this.gos.get("preventDefaultOnContextMenu")) {
            const event = mouseEvent || touchEvent;
            event.preventDefault();
        }
        const { target: target } = mouseEvent || touch;
        if (target === this.eBodyViewport || target === this.ctrlsService.get("center").getViewportElement()) this.menuService.showContextMenu({
            mouseEvent: mouseEvent,
            touchEvent: touchEvent,
            value: null,
            anchorToElement: this.eGridBody
        });
    }
    mockContextMenuForIPad(listener) {
        if (!$437b23f6a393c3bf$var$isIOSUserAgent()) return;
        const touchListener = new $437b23f6a393c3bf$export$7b2e93987414b382(this.eBodyViewport);
        const longTapListener = (event)=>{
            listener(void 0, event.touchStart, event.touchEvent);
        };
        this.addManagedListener(touchListener, $437b23f6a393c3bf$export$7b2e93987414b382.EVENT_LONG_TAP, longTapListener);
        this.addDestroyFunc(()=>touchListener.destroy());
    }
    onBodyViewportWheel(e) {
        if (!this.gos.get("suppressScrollWhenPopupsAreOpen")) return;
        if (this.popupService.hasAnchoredPopup()) e.preventDefault();
    }
    onStickyWheel(e) {
        e.preventDefault();
        if (e.offsetY) this.scrollVertically(e.deltaY);
    }
    getGui() {
        return this.eGridBody;
    }
    // called by rowDragFeature
    scrollVertically(pixels) {
        const oldScrollPosition = this.eBodyViewport.scrollTop;
        this.bodyScrollFeature.setVerticalScrollPosition(oldScrollPosition + pixels);
        return this.eBodyViewport.scrollTop - oldScrollPosition;
    }
    addRowDragListener() {
        this.rowDragFeature = this.createManagedBean(new $437b23f6a393c3bf$var$RowDragFeature(this.eBodyViewport));
        this.dragAndDropService.addDropTarget(this.rowDragFeature);
    }
    getRowDragFeature() {
        return this.rowDragFeature;
    }
    onPinnedRowDataChanged() {
        this.setFloatingHeights();
    }
    setFloatingHeights() {
        const { pinnedRowModel: pinnedRowModel } = this;
        let floatingTopHeight = pinnedRowModel.getPinnedTopTotalHeight();
        let floatingBottomHeight = pinnedRowModel.getPinnedBottomTotalHeight();
        this.comp.setTopHeight(floatingTopHeight);
        this.comp.setBottomHeight(floatingBottomHeight);
        this.comp.setTopDisplay(floatingTopHeight ? "inherit" : "none");
        this.comp.setBottomDisplay(floatingBottomHeight ? "inherit" : "none");
        this.setStickyTopOffsetTop();
        this.setStickyBottomOffsetBottom();
    }
    setStickyTopHeight(height = 0) {
        this.comp.setStickyTopHeight(`${height}px`);
        this.stickyTopHeight = height;
    }
    getStickyTopHeight() {
        return this.stickyTopHeight;
    }
    setStickyBottomHeight(height = 0) {
        this.comp.setStickyBottomHeight(`${height}px`);
        this.stickyBottomHeight = height;
    }
    getStickyBottomHeight() {
        return this.stickyBottomHeight;
    }
    setStickyWidth(vScrollVisible) {
        if (!vScrollVisible) {
            this.comp.setStickyTopWidth("100%");
            this.comp.setStickyBottomWidth("100%");
        } else {
            const scrollbarWidth = this.gos.getScrollbarWidth();
            this.comp.setStickyTopWidth(`calc(100% - ${scrollbarWidth}px)`);
            this.comp.setStickyBottomWidth(`calc(100% - ${scrollbarWidth}px)`);
        }
    }
    onHeaderHeightChanged() {
        this.setStickyTopOffsetTop();
    }
    setStickyTopOffsetTop() {
        const headerCtrl = this.ctrlsService.get("gridHeaderCtrl");
        const headerHeight = headerCtrl.getHeaderHeight() + this.filterManager.getHeaderHeight();
        const pinnedTopHeight = this.pinnedRowModel.getPinnedTopTotalHeight();
        let height = 0;
        if (headerHeight > 0) height += headerHeight;
        if (pinnedTopHeight > 0) height += pinnedTopHeight;
        if (height > 0) height += 1;
        this.comp.setStickyTopTop(`${height}px`);
    }
    setStickyBottomOffsetBottom() {
        const pinnedBottomHeight = this.pinnedRowModel.getPinnedBottomTotalHeight();
        const hScrollShowing = this.scrollVisibleService.isHorizontalScrollShowing();
        const scrollbarWidth = hScrollShowing ? this.gos.getScrollbarWidth() || 0 : 0;
        const height = pinnedBottomHeight + scrollbarWidth;
        this.comp.setStickyBottomBottom(`${height}px`);
    }
    // method will call itself if no available width. this covers if the grid
    // isn't visible, but is just about to be visible.
    sizeColumnsToFit(params, nextTimeout) {
        const removeScrollWidth = this.isVerticalScrollShowing();
        const scrollWidthToRemove = removeScrollWidth ? this.gos.getScrollbarWidth() : 0;
        const bodyViewportWidth = $437b23f6a393c3bf$var$getInnerWidth(this.eGridBody);
        const availableWidth = bodyViewportWidth - scrollWidthToRemove;
        if (availableWidth > 0) {
            this.columnModel.sizeColumnsToFit(availableWidth, "sizeColumnsToFit", false, params);
            return;
        }
        if (nextTimeout === void 0) window.setTimeout(()=>{
            this.sizeColumnsToFit(params, 100);
        }, 0);
        else if (nextTimeout === 100) window.setTimeout(()=>{
            this.sizeColumnsToFit(params, 500);
        }, 100);
        else if (nextTimeout === 500) window.setTimeout(()=>{
            this.sizeColumnsToFit(params, -1);
        }, 500);
        else console.warn("AG Grid: tried to call sizeColumnsToFit() but the grid is coming back with zero width, maybe the grid is not visible yet on the screen?");
    }
    // + rangeService
    addScrollEventListener(listener) {
        this.eBodyViewport.addEventListener("scroll", listener, {
            passive: true
        });
    }
    // + focusService
    removeScrollEventListener(listener) {
        this.eBodyViewport.removeEventListener("scroll", listener);
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("animationFrameService")
], $437b23f6a393c3bf$export$8bebc3145b40d221.prototype, "animationFrameService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowContainerHeightService")
], $437b23f6a393c3bf$export$8bebc3145b40d221.prototype, "rowContainerHeightService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("ctrlsService")
], $437b23f6a393c3bf$export$8bebc3145b40d221.prototype, "ctrlsService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnModel")
], $437b23f6a393c3bf$export$8bebc3145b40d221.prototype, "columnModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("scrollVisibleService")
], $437b23f6a393c3bf$export$8bebc3145b40d221.prototype, "scrollVisibleService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("menuService")
], $437b23f6a393c3bf$export$8bebc3145b40d221.prototype, "menuService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("headerNavigationService")
], $437b23f6a393c3bf$export$8bebc3145b40d221.prototype, "headerNavigationService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("dragAndDropService")
], $437b23f6a393c3bf$export$8bebc3145b40d221.prototype, "dragAndDropService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("pinnedRowModel")
], $437b23f6a393c3bf$export$8bebc3145b40d221.prototype, "pinnedRowModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowRenderer")
], $437b23f6a393c3bf$export$8bebc3145b40d221.prototype, "rowRenderer", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("popupService")
], $437b23f6a393c3bf$export$8bebc3145b40d221.prototype, "popupService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("mouseEventService")
], $437b23f6a393c3bf$export$8bebc3145b40d221.prototype, "mouseEventService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowModel")
], $437b23f6a393c3bf$export$8bebc3145b40d221.prototype, "rowModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("filterManager")
], $437b23f6a393c3bf$export$8bebc3145b40d221.prototype, "filterManager", 2);
// community-modules/core/src/interfaces/IRangeService.ts
var $437b23f6a393c3bf$export$dc43114153b7f047 = /* @__PURE__ */ ((SelectionHandleType2)=>{
    SelectionHandleType2[SelectionHandleType2["FILL"] = 0] = "FILL";
    SelectionHandleType2[SelectionHandleType2["RANGE"] = 1] = "RANGE";
    return SelectionHandleType2;
})($437b23f6a393c3bf$export$dc43114153b7f047 || {});
var $437b23f6a393c3bf$export$162bc75b85f28397 = /* @__PURE__ */ ((CellRangeType2)=>{
    CellRangeType2[CellRangeType2["VALUE"] = 0] = "VALUE";
    CellRangeType2[CellRangeType2["DIMENSION"] = 1] = "DIMENSION";
    return CellRangeType2;
})($437b23f6a393c3bf$export$162bc75b85f28397 || {});
// community-modules/core/src/rendering/cell/cellRangeFeature.ts
var $437b23f6a393c3bf$var$CSS_CELL_RANGE_SELECTED = "ag-cell-range-selected";
var $437b23f6a393c3bf$var$CSS_CELL_RANGE_CHART = "ag-cell-range-chart";
var $437b23f6a393c3bf$var$CSS_CELL_RANGE_SINGLE_CELL = "ag-cell-range-single-cell";
var $437b23f6a393c3bf$var$CSS_CELL_RANGE_CHART_CATEGORY = "ag-cell-range-chart-category";
var $437b23f6a393c3bf$var$CSS_CELL_RANGE_HANDLE = "ag-cell-range-handle";
var $437b23f6a393c3bf$var$CSS_CELL_RANGE_TOP = "ag-cell-range-top";
var $437b23f6a393c3bf$var$CSS_CELL_RANGE_RIGHT = "ag-cell-range-right";
var $437b23f6a393c3bf$var$CSS_CELL_RANGE_BOTTOM = "ag-cell-range-bottom";
var $437b23f6a393c3bf$var$CSS_CELL_RANGE_LEFT = "ag-cell-range-left";
var $437b23f6a393c3bf$var$CellRangeFeature = class {
    constructor(beans, ctrl){
        this.beans = beans;
        this.rangeService = beans.rangeService;
        this.selectionHandleFactory = beans.selectionHandleFactory;
        this.cellCtrl = ctrl;
    }
    setComp(cellComp, eGui) {
        this.cellComp = cellComp;
        this.eGui = eGui;
        this.onRangeSelectionChanged();
    }
    onRangeSelectionChanged() {
        if (!this.cellComp) return;
        this.rangeCount = this.rangeService.getCellRangeCount(this.cellCtrl.getCellPosition());
        this.hasChartRange = this.getHasChartRange();
        this.cellComp.addOrRemoveCssClass($437b23f6a393c3bf$var$CSS_CELL_RANGE_SELECTED, this.rangeCount !== 0);
        this.cellComp.addOrRemoveCssClass(`${$437b23f6a393c3bf$var$CSS_CELL_RANGE_SELECTED}-1`, this.rangeCount === 1);
        this.cellComp.addOrRemoveCssClass(`${$437b23f6a393c3bf$var$CSS_CELL_RANGE_SELECTED}-2`, this.rangeCount === 2);
        this.cellComp.addOrRemoveCssClass(`${$437b23f6a393c3bf$var$CSS_CELL_RANGE_SELECTED}-3`, this.rangeCount === 3);
        this.cellComp.addOrRemoveCssClass(`${$437b23f6a393c3bf$var$CSS_CELL_RANGE_SELECTED}-4`, this.rangeCount >= 4);
        this.cellComp.addOrRemoveCssClass($437b23f6a393c3bf$var$CSS_CELL_RANGE_CHART, this.hasChartRange);
        $437b23f6a393c3bf$var$setAriaSelected(this.eGui, this.rangeCount > 0 ? true : void 0);
        this.cellComp.addOrRemoveCssClass($437b23f6a393c3bf$var$CSS_CELL_RANGE_SINGLE_CELL, this.isSingleCell());
        this.updateRangeBorders();
        this.refreshHandle();
    }
    updateRangeBorders() {
        const rangeBorders = this.getRangeBorders();
        const isSingleCell = this.isSingleCell();
        const isTop = !isSingleCell && rangeBorders.top;
        const isRight = !isSingleCell && rangeBorders.right;
        const isBottom = !isSingleCell && rangeBorders.bottom;
        const isLeft = !isSingleCell && rangeBorders.left;
        this.cellComp.addOrRemoveCssClass($437b23f6a393c3bf$var$CSS_CELL_RANGE_TOP, isTop);
        this.cellComp.addOrRemoveCssClass($437b23f6a393c3bf$var$CSS_CELL_RANGE_RIGHT, isRight);
        this.cellComp.addOrRemoveCssClass($437b23f6a393c3bf$var$CSS_CELL_RANGE_BOTTOM, isBottom);
        this.cellComp.addOrRemoveCssClass($437b23f6a393c3bf$var$CSS_CELL_RANGE_LEFT, isLeft);
    }
    isSingleCell() {
        const { rangeService: rangeService } = this.beans;
        return this.rangeCount === 1 && !!rangeService && !rangeService.isMoreThanOneCell();
    }
    getHasChartRange() {
        const { rangeService: rangeService } = this.beans;
        if (!this.rangeCount || !rangeService) return false;
        const cellRanges = rangeService.getCellRanges();
        return cellRanges.length > 0 && cellRanges.every((range)=>$437b23f6a393c3bf$var$includes([
                1 /* DIMENSION */ ,
                0 /* VALUE */ 
            ], range.type));
    }
    updateRangeBordersIfRangeCount() {
        if (this.rangeCount > 0) {
            this.updateRangeBorders();
            this.refreshHandle();
        }
    }
    getRangeBorders() {
        const isRtl = this.beans.gos.get("enableRtl");
        let top = false;
        let right = false;
        let bottom = false;
        let left = false;
        const thisCol = this.cellCtrl.getCellPosition().column;
        const columnModel = this.beans.columnModel;
        let leftCol;
        let rightCol;
        if (isRtl) {
            leftCol = columnModel.getDisplayedColAfter(thisCol);
            rightCol = columnModel.getDisplayedColBefore(thisCol);
        } else {
            leftCol = columnModel.getDisplayedColBefore(thisCol);
            rightCol = columnModel.getDisplayedColAfter(thisCol);
        }
        const ranges = this.rangeService.getCellRanges().filter((range)=>this.rangeService.isCellInSpecificRange(this.cellCtrl.getCellPosition(), range));
        if (!leftCol) left = true;
        if (!rightCol) right = true;
        for(let i = 0; i < ranges.length; i++){
            if (top && right && bottom && left) break;
            const range = ranges[i];
            const startRow = this.rangeService.getRangeStartRow(range);
            const endRow = this.rangeService.getRangeEndRow(range);
            if (!top && this.beans.rowPositionUtils.sameRow(startRow, this.cellCtrl.getCellPosition())) top = true;
            if (!bottom && this.beans.rowPositionUtils.sameRow(endRow, this.cellCtrl.getCellPosition())) bottom = true;
            if (!left && leftCol && range.columns.indexOf(leftCol) < 0) left = true;
            if (!right && rightCol && range.columns.indexOf(rightCol) < 0) right = true;
        }
        return {
            top: top,
            right: right,
            bottom: bottom,
            left: left
        };
    }
    refreshHandle() {
        if (this.beans.context.isDestroyed()) return;
        const shouldHaveSelectionHandle = this.shouldHaveSelectionHandle();
        if (this.selectionHandle && !shouldHaveSelectionHandle) this.selectionHandle = this.beans.context.destroyBean(this.selectionHandle);
        if (shouldHaveSelectionHandle) this.addSelectionHandle();
        this.cellComp.addOrRemoveCssClass($437b23f6a393c3bf$var$CSS_CELL_RANGE_HANDLE, !!this.selectionHandle);
    }
    shouldHaveSelectionHandle() {
        const gos = this.beans.gos;
        const cellRanges = this.rangeService.getCellRanges();
        const rangesLen = cellRanges.length;
        if (this.rangeCount < 1 || rangesLen < 1) return false;
        const cellRange = $437b23f6a393c3bf$var$last(cellRanges);
        const cellPosition = this.cellCtrl.getCellPosition();
        const isFillHandleAvailable = gos.get("enableFillHandle") && !this.cellCtrl.isSuppressFillHandle();
        const isRangeHandleAvailable = gos.get("enableRangeHandle");
        let handleIsAvailable = rangesLen === 1 && !this.cellCtrl.isEditing() && (isFillHandleAvailable || isRangeHandleAvailable);
        if (this.hasChartRange) {
            const hasCategoryRange = cellRanges[0].type === 1 /* DIMENSION */ ;
            const isCategoryCell = hasCategoryRange && this.rangeService.isCellInSpecificRange(cellPosition, cellRanges[0]);
            this.cellComp.addOrRemoveCssClass($437b23f6a393c3bf$var$CSS_CELL_RANGE_CHART_CATEGORY, isCategoryCell);
            handleIsAvailable = cellRange.type === 0 /* VALUE */ ;
        }
        return handleIsAvailable && cellRange.endRow != null && this.rangeService.isContiguousRange(cellRange) && this.rangeService.isBottomRightCell(cellRange, cellPosition);
    }
    addSelectionHandle() {
        const gos = this.beans.gos;
        const cellRangeType = $437b23f6a393c3bf$var$last(this.rangeService.getCellRanges()).type;
        const selectionHandleFill = gos.get("enableFillHandle") && $437b23f6a393c3bf$var$missing(cellRangeType);
        const type = selectionHandleFill ? 0 /* FILL */  : 1 /* RANGE */ ;
        if (this.selectionHandle && this.selectionHandle.getType() !== type) this.selectionHandle = this.beans.context.destroyBean(this.selectionHandle);
        if (!this.selectionHandle) this.selectionHandle = this.selectionHandleFactory.createSelectionHandle(type);
        this.selectionHandle.refresh(this.cellCtrl);
    }
    destroy() {
        this.beans.context.destroyBean(this.selectionHandle);
    }
};
// community-modules/core/src/rendering/cell/cellPositionFeature.ts
var $437b23f6a393c3bf$var$CellPositionFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(ctrl, beans){
        super();
        this.cellCtrl = ctrl;
        this.beans = beans;
        this.column = ctrl.getColumn();
        this.rowNode = ctrl.getRowNode();
    }
    setupRowSpan() {
        this.rowSpan = this.column.getRowSpan(this.rowNode);
        this.addManagedListener(this.beans.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_NEW_COLUMNS_LOADED, ()=>this.onNewColumnsLoaded());
    }
    setComp(eGui) {
        this.eGui = eGui;
        this.setupColSpan();
        this.setupRowSpan();
        this.onLeftChanged();
        this.onWidthChanged();
        this.applyRowSpan();
    }
    onNewColumnsLoaded() {
        const rowSpan = this.column.getRowSpan(this.rowNode);
        if (this.rowSpan === rowSpan) return;
        this.rowSpan = rowSpan;
        this.applyRowSpan(true);
    }
    onDisplayColumnsChanged() {
        const colsSpanning = this.getColSpanningList();
        if (!$437b23f6a393c3bf$var$areEqual(this.colsSpanning, colsSpanning)) {
            this.colsSpanning = colsSpanning;
            this.onWidthChanged();
            this.onLeftChanged();
        }
    }
    setupColSpan() {
        if (this.column.getColDef().colSpan == null) return;
        this.colsSpanning = this.getColSpanningList();
        this.addManagedListener(this.beans.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayColumnsChanged.bind(this));
        this.addManagedListener(this.beans.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, this.onWidthChanged.bind(this));
    }
    onWidthChanged() {
        if (!this.eGui) return;
        const width = this.getCellWidth();
        this.eGui.style.width = `${width}px`;
    }
    getCellWidth() {
        if (!this.colsSpanning) return this.column.getActualWidth();
        return this.colsSpanning.reduce((width, col)=>width + col.getActualWidth(), 0);
    }
    getColSpanningList() {
        const colSpan = this.column.getColSpan(this.rowNode);
        const colsSpanning = [];
        if (colSpan === 1) colsSpanning.push(this.column);
        else {
            let pointer = this.column;
            const pinned = this.column.getPinned();
            for(let i = 0; pointer && i < colSpan; i++){
                colsSpanning.push(pointer);
                pointer = this.beans.columnModel.getDisplayedColAfter(pointer);
                if (!pointer || $437b23f6a393c3bf$var$missing(pointer)) break;
                if (pinned !== pointer.getPinned()) break;
            }
        }
        return colsSpanning;
    }
    onLeftChanged() {
        if (!this.eGui) return;
        const left = this.modifyLeftForPrintLayout(this.getCellLeft());
        this.eGui.style.left = left + "px";
    }
    getCellLeft() {
        let mostLeftCol;
        if (this.beans.gos.get("enableRtl") && this.colsSpanning) mostLeftCol = $437b23f6a393c3bf$var$last(this.colsSpanning);
        else mostLeftCol = this.column;
        return mostLeftCol.getLeft();
    }
    modifyLeftForPrintLayout(leftPosition) {
        if (!this.cellCtrl.isPrintLayout() || this.column.getPinned() === "left") return leftPosition;
        const leftWidth = this.beans.columnModel.getDisplayedColumnsLeftWidth();
        if (this.column.getPinned() === "right") {
            const bodyWidth = this.beans.columnModel.getBodyContainerWidth();
            return leftWidth + bodyWidth + (leftPosition || 0);
        }
        return leftWidth + (leftPosition || 0);
    }
    applyRowSpan(force) {
        if (this.rowSpan === 1 && !force) return;
        const singleRowHeight = this.beans.gos.getRowHeightAsNumber();
        const totalRowHeight = singleRowHeight * this.rowSpan;
        this.eGui.style.height = `${totalRowHeight}px`;
        this.eGui.style.zIndex = "1";
    }
    // overriding to make public, as we don't dispose this bean via context
    destroy() {
        super.destroy();
    }
};
// community-modules/core/src/rendering/cell/cellCustomStyleFeature.ts
var $437b23f6a393c3bf$var$CellCustomStyleFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(ctrl, beans){
        super();
        this.staticClasses = [];
        this.cellCtrl = ctrl;
        this.beans = beans;
        this.column = ctrl.getColumn();
        this.rowNode = ctrl.getRowNode();
    }
    setComp(comp) {
        this.cellComp = comp;
        this.applyUserStyles();
        this.applyCellClassRules();
        this.applyClassesFromColDef();
    }
    applyCellClassRules() {
        const colDef = this.column.getColDef();
        const { cellClassRules: cellClassRules } = colDef;
        const cellClassParams = this.beans.gos.addGridCommonParams({
            value: this.cellCtrl.getValue(),
            data: this.rowNode.data,
            node: this.rowNode,
            colDef: colDef,
            column: this.column,
            rowIndex: this.rowNode.rowIndex
        });
        this.beans.stylingService.processClassRules(// if current was previous, skip
        cellClassRules === this.cellClassRules ? void 0 : this.cellClassRules, cellClassRules, cellClassParams, (className)=>this.cellComp.addOrRemoveCssClass(className, true), (className)=>this.cellComp.addOrRemoveCssClass(className, false));
        this.cellClassRules = cellClassRules;
    }
    applyUserStyles() {
        const colDef = this.column.getColDef();
        if (!colDef.cellStyle) return;
        let styles;
        if (typeof colDef.cellStyle === "function") {
            const cellStyleParams = this.beans.gos.addGridCommonParams({
                column: this.column,
                value: this.cellCtrl.getValue(),
                colDef: colDef,
                data: this.rowNode.data,
                node: this.rowNode,
                rowIndex: this.rowNode.rowIndex
            });
            const cellStyleFunc = colDef.cellStyle;
            styles = cellStyleFunc(cellStyleParams);
        } else styles = colDef.cellStyle;
        if (styles) this.cellComp.setUserStyles(styles);
    }
    applyClassesFromColDef() {
        const colDef = this.column.getColDef();
        const cellClassParams = this.beans.gos.addGridCommonParams({
            value: this.cellCtrl.getValue(),
            data: this.rowNode.data,
            node: this.rowNode,
            column: this.column,
            colDef: colDef,
            rowIndex: this.rowNode.rowIndex
        });
        if (this.staticClasses.length) this.staticClasses.forEach((className)=>this.cellComp.addOrRemoveCssClass(className, false));
        this.staticClasses = this.beans.stylingService.getStaticCellClasses(colDef, cellClassParams);
        if (this.staticClasses.length) this.staticClasses.forEach((className)=>this.cellComp.addOrRemoveCssClass(className, true));
    }
    // overriding to make public, as we don't dispose this bean via context
    destroy() {
        super.destroy();
    }
};
// community-modules/core/src/rendering/beans.ts
var $437b23f6a393c3bf$export$e1272dadeadaca63 = class {
    postConstruct() {
        if (this.gos.isRowModelType("clientSide")) this.clientSideRowModel = this.rowModel;
        if (this.gos.isRowModelType("serverSide")) this.serverSideRowModel = this.rowModel;
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("resizeObserverService")
], $437b23f6a393c3bf$export$e1272dadeadaca63.prototype, "resizeObserverService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("paginationProxy")
], $437b23f6a393c3bf$export$e1272dadeadaca63.prototype, "paginationProxy", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("context")
], $437b23f6a393c3bf$export$e1272dadeadaca63.prototype, "context", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("gridOptionsService")
], $437b23f6a393c3bf$export$e1272dadeadaca63.prototype, "gos", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("environment")
], $437b23f6a393c3bf$export$e1272dadeadaca63.prototype, "environment", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowRenderer")
], $437b23f6a393c3bf$export$e1272dadeadaca63.prototype, "rowRenderer", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("valueService")
], $437b23f6a393c3bf$export$e1272dadeadaca63.prototype, "valueService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("eventService")
], $437b23f6a393c3bf$export$e1272dadeadaca63.prototype, "eventService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnModel")
], $437b23f6a393c3bf$export$e1272dadeadaca63.prototype, "columnModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("headerNavigationService")
], $437b23f6a393c3bf$export$e1272dadeadaca63.prototype, "headerNavigationService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("navigationService")
], $437b23f6a393c3bf$export$e1272dadeadaca63.prototype, "navigationService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnAnimationService")
], $437b23f6a393c3bf$export$e1272dadeadaca63.prototype, "columnAnimationService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("focusService")
], $437b23f6a393c3bf$export$e1272dadeadaca63.prototype, "focusService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("popupService")
], $437b23f6a393c3bf$export$e1272dadeadaca63.prototype, "popupService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("stylingService")
], $437b23f6a393c3bf$export$e1272dadeadaca63.prototype, "stylingService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnHoverService")
], $437b23f6a393c3bf$export$e1272dadeadaca63.prototype, "columnHoverService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("userComponentFactory")
], $437b23f6a393c3bf$export$e1272dadeadaca63.prototype, "userComponentFactory", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("userComponentRegistry")
], $437b23f6a393c3bf$export$e1272dadeadaca63.prototype, "userComponentRegistry", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("animationFrameService")
], $437b23f6a393c3bf$export$e1272dadeadaca63.prototype, "animationFrameService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("dragService")
], $437b23f6a393c3bf$export$e1272dadeadaca63.prototype, "dragService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("dragAndDropService")
], $437b23f6a393c3bf$export$e1272dadeadaca63.prototype, "dragAndDropService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("sortController")
], $437b23f6a393c3bf$export$e1272dadeadaca63.prototype, "sortController", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("filterManager")
], $437b23f6a393c3bf$export$e1272dadeadaca63.prototype, "filterManager", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowContainerHeightService")
], $437b23f6a393c3bf$export$e1272dadeadaca63.prototype, "rowContainerHeightService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("frameworkOverrides")
], $437b23f6a393c3bf$export$e1272dadeadaca63.prototype, "frameworkOverrides", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("cellPositionUtils")
], $437b23f6a393c3bf$export$e1272dadeadaca63.prototype, "cellPositionUtils", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowPositionUtils")
], $437b23f6a393c3bf$export$e1272dadeadaca63.prototype, "rowPositionUtils", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("selectionService")
], $437b23f6a393c3bf$export$e1272dadeadaca63.prototype, "selectionService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowCssClassCalculator")
], $437b23f6a393c3bf$export$e1272dadeadaca63.prototype, "rowCssClassCalculator", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowModel")
], $437b23f6a393c3bf$export$e1272dadeadaca63.prototype, "rowModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("ctrlsService")
], $437b23f6a393c3bf$export$e1272dadeadaca63.prototype, "ctrlsService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("ctrlsFactory")
], $437b23f6a393c3bf$export$e1272dadeadaca63.prototype, "ctrlsFactory", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("agStackComponentsRegistry")
], $437b23f6a393c3bf$export$e1272dadeadaca63.prototype, "agStackComponentsRegistry", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("valueCache")
], $437b23f6a393c3bf$export$e1272dadeadaca63.prototype, "valueCache", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowNodeEventThrottle")
], $437b23f6a393c3bf$export$e1272dadeadaca63.prototype, "rowNodeEventThrottle", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("localeService")
], $437b23f6a393c3bf$export$e1272dadeadaca63.prototype, "localeService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("syncService")
], $437b23f6a393c3bf$export$e1272dadeadaca63.prototype, "syncService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("ariaAnnouncementService")
], $437b23f6a393c3bf$export$e1272dadeadaca63.prototype, "ariaAnnouncementService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$7acb7b24c478f9c6("rangeService")
], $437b23f6a393c3bf$export$e1272dadeadaca63.prototype, "rangeService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$7acb7b24c478f9c6("selectionHandleFactory")
], $437b23f6a393c3bf$export$e1272dadeadaca63.prototype, "selectionHandleFactory", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$export$e1272dadeadaca63.prototype, "postConstruct", 1);
$437b23f6a393c3bf$export$e1272dadeadaca63 = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("beans")
], $437b23f6a393c3bf$export$e1272dadeadaca63);
// community-modules/core/src/rendering/cell/cellMouseListenerFeature.ts
var $437b23f6a393c3bf$var$CellMouseListenerFeature = class extends $437b23f6a393c3bf$export$e1272dadeadaca63 {
    constructor(ctrl, beans, column){
        super();
        this.cellCtrl = ctrl;
        this.beans = beans;
        this.column = column;
    }
    onMouseEvent(eventName, mouseEvent) {
        if ($437b23f6a393c3bf$var$isStopPropagationForAgGrid(mouseEvent)) return;
        switch(eventName){
            case "click":
                this.onCellClicked(mouseEvent);
                break;
            case "mousedown":
            case "touchstart":
                this.onMouseDown(mouseEvent);
                break;
            case "dblclick":
                this.onCellDoubleClicked(mouseEvent);
                break;
            case "mouseout":
                this.onMouseOut(mouseEvent);
                break;
            case "mouseover":
                this.onMouseOver(mouseEvent);
                break;
        }
    }
    onCellClicked(mouseEvent) {
        if (this.isDoubleClickOnIPad()) {
            this.onCellDoubleClicked(mouseEvent);
            mouseEvent.preventDefault();
            return;
        }
        const { eventService: eventService, rangeService: rangeService, gos: gos } = this.beans;
        const isMultiKey = mouseEvent.ctrlKey || mouseEvent.metaKey;
        if (rangeService && isMultiKey) {
            if (rangeService.getCellRangeCount(this.cellCtrl.getCellPosition()) > 1) rangeService.intersectLastRange(true);
        }
        const cellClickedEvent = this.cellCtrl.createEvent(mouseEvent, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_CELL_CLICKED);
        eventService.dispatchEvent(cellClickedEvent);
        const colDef = this.column.getColDef();
        if (colDef.onCellClicked) window.setTimeout(()=>{
            this.beans.frameworkOverrides.wrapOutgoing(()=>{
                colDef.onCellClicked(cellClickedEvent);
            });
        }, 0);
        const editOnSingleClick = (gos.get("singleClickEdit") || colDef.singleClickEdit) && !gos.get("suppressClickEdit");
        if (editOnSingleClick && !(mouseEvent.shiftKey && (rangeService == null ? void 0 : rangeService.getCellRanges().length) != 0)) this.cellCtrl.startRowOrCellEdit();
    }
    // returns true if on iPad and this is second 'click' event in 200ms
    isDoubleClickOnIPad() {
        if (!$437b23f6a393c3bf$var$isIOSUserAgent() || $437b23f6a393c3bf$var$isEventSupported("dblclick")) return false;
        const nowMillis = /* @__PURE__ */ new Date().getTime();
        const res = nowMillis - this.lastIPadMouseClickEvent < 200;
        this.lastIPadMouseClickEvent = nowMillis;
        return res;
    }
    onCellDoubleClicked(mouseEvent) {
        const colDef = this.column.getColDef();
        const cellDoubleClickedEvent = this.cellCtrl.createEvent(mouseEvent, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_CELL_DOUBLE_CLICKED);
        this.beans.eventService.dispatchEvent(cellDoubleClickedEvent);
        if (typeof colDef.onCellDoubleClicked === "function") window.setTimeout(()=>{
            this.beans.frameworkOverrides.wrapOutgoing(()=>{
                colDef.onCellDoubleClicked(cellDoubleClickedEvent);
            });
        }, 0);
        const editOnDoubleClick = !this.beans.gos.get("singleClickEdit") && !this.beans.gos.get("suppressClickEdit");
        if (editOnDoubleClick) this.cellCtrl.startRowOrCellEdit(null, mouseEvent);
    }
    onMouseDown(mouseEvent) {
        const { ctrlKey: ctrlKey, metaKey: metaKey, shiftKey: shiftKey } = mouseEvent;
        const target = mouseEvent.target;
        const { cellCtrl: cellCtrl, beans: beans } = this;
        const { eventService: eventService, rangeService: rangeService, focusService: focusService } = beans;
        if (this.isRightClickInExistingRange(mouseEvent)) return;
        const ranges = rangeService && rangeService.getCellRanges().length != 0;
        if (!shiftKey || !ranges) {
            const forceBrowserFocus = $437b23f6a393c3bf$var$isBrowserSafari() && !cellCtrl.isEditing() && !$437b23f6a393c3bf$var$isFocusableFormField(target);
            cellCtrl.focusCell(forceBrowserFocus);
        }
        if (shiftKey && ranges && !focusService.isCellFocused(cellCtrl.getCellPosition())) {
            mouseEvent.preventDefault();
            const focusedCellPosition = focusService.getFocusedCell();
            if (focusedCellPosition) {
                const { column: column, rowIndex: rowIndex, rowPinned: rowPinned } = focusedCellPosition;
                const focusedRowCtrl = beans.rowRenderer.getRowByPosition({
                    rowIndex: rowIndex,
                    rowPinned: rowPinned
                });
                const focusedCellCtrl = focusedRowCtrl == null ? void 0 : focusedRowCtrl.getCellCtrl(column);
                if (focusedCellCtrl == null ? void 0 : focusedCellCtrl.isEditing()) focusedCellCtrl.stopEditing();
                focusService.setFocusedCell({
                    column: column,
                    rowIndex: rowIndex,
                    rowPinned: rowPinned,
                    forceBrowserFocus: true,
                    preventScrollOnBrowserFocus: true
                });
            }
        }
        if (this.containsWidget(target)) return;
        if (rangeService) {
            const thisCell = this.cellCtrl.getCellPosition();
            if (shiftKey) rangeService.extendLatestRangeToCell(thisCell);
            else {
                const isMultiKey = ctrlKey || metaKey;
                rangeService.setRangeToCell(thisCell, isMultiKey);
            }
        }
        eventService.dispatchEvent(this.cellCtrl.createEvent(mouseEvent, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_CELL_MOUSE_DOWN));
    }
    isRightClickInExistingRange(mouseEvent) {
        const { rangeService: rangeService } = this.beans;
        if (rangeService) {
            const cellInRange = rangeService.isCellInAnyRange(this.cellCtrl.getCellPosition());
            const isRightClick = mouseEvent.button === 2 || mouseEvent.ctrlKey && this.beans.gos.get("allowContextMenuWithControlKey");
            if (cellInRange && isRightClick) return true;
        }
        return false;
    }
    containsWidget(target) {
        return $437b23f6a393c3bf$var$isElementChildOfClass(target, "ag-selection-checkbox", 3);
    }
    onMouseOut(mouseEvent) {
        if (this.mouseStayingInsideCell(mouseEvent)) return;
        const cellMouseOutEvent = this.cellCtrl.createEvent(mouseEvent, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_CELL_MOUSE_OUT);
        this.beans.eventService.dispatchEvent(cellMouseOutEvent);
        this.beans.columnHoverService.clearMouseOver();
    }
    onMouseOver(mouseEvent) {
        if (this.mouseStayingInsideCell(mouseEvent)) return;
        const cellMouseOverEvent = this.cellCtrl.createEvent(mouseEvent, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_CELL_MOUSE_OVER);
        this.beans.eventService.dispatchEvent(cellMouseOverEvent);
        this.beans.columnHoverService.setMouseOver([
            this.column
        ]);
    }
    mouseStayingInsideCell(e) {
        if (!e.target || !e.relatedTarget) return false;
        const eGui = this.cellCtrl.getGui();
        const cellContainsTarget = eGui.contains(e.target);
        const cellContainsRelatedTarget = eGui.contains(e.relatedTarget);
        return cellContainsTarget && cellContainsRelatedTarget;
    }
    destroy() {}
};
// community-modules/core/src/rendering/cell/cellKeyboardListenerFeature.ts
var $437b23f6a393c3bf$var$CellKeyboardListenerFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(ctrl, beans, column, rowNode, rowCtrl){
        super();
        this.cellCtrl = ctrl;
        this.beans = beans;
        this.rowNode = rowNode;
        this.rowCtrl = rowCtrl;
    }
    setComp(eGui) {
        this.eGui = eGui;
    }
    onKeyDown(event) {
        const key = event.key;
        switch(key){
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER:
                this.onEnterKeyDown(event);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.F2:
                this.onF2KeyDown(event);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ESCAPE:
                this.onEscapeKeyDown(event);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB:
                this.onTabKeyDown(event);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.BACKSPACE:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DELETE:
                this.onBackspaceOrDeleteKeyDown(key, event);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT:
                this.onNavigationKeyDown(event, key);
                break;
        }
    }
    onNavigationKeyDown(event, key) {
        if (this.cellCtrl.isEditing()) return;
        if (event.shiftKey && this.cellCtrl.isRangeSelectionEnabled()) this.onShiftRangeSelect(event);
        else this.beans.navigationService.navigateToNextCell(event, key, this.cellCtrl.getCellPosition(), true);
        event.preventDefault();
    }
    onShiftRangeSelect(event) {
        if (!this.beans.rangeService) return;
        const endCell = this.beans.rangeService.extendLatestRangeInDirection(event);
        if (endCell) this.beans.navigationService.ensureCellVisible(endCell);
    }
    onTabKeyDown(event) {
        this.beans.navigationService.onTabKeyDown(this.cellCtrl, event);
    }
    onBackspaceOrDeleteKeyDown(key, event) {
        var _a;
        const { cellCtrl: cellCtrl, beans: beans, rowNode: rowNode } = this;
        const { gos: gos, rangeService: rangeService, eventService: eventService } = beans;
        if (cellCtrl.isEditing()) return;
        eventService.dispatchEvent({
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_KEY_SHORTCUT_CHANGED_CELL_START
        });
        if ($437b23f6a393c3bf$var$isDeleteKey(key, gos.get("enableCellEditingOnBackspace"))) {
            if (rangeService && gos.get("enableRangeSelection")) rangeService.clearCellRangeCellValues({
                dispatchWrapperEvents: true,
                wrapperEventSource: "deleteKey"
            });
            else if (cellCtrl.isCellEditable()) {
                const column = cellCtrl.getColumn();
                const emptyValue = (_a = this.beans.valueService.parseValue(column, rowNode, "", rowNode.getValueFromValueService(column))) != null ? _a : null;
                rowNode.setDataValue(column, emptyValue, "cellClear");
            }
        } else cellCtrl.startRowOrCellEdit(key, event);
        eventService.dispatchEvent({
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_KEY_SHORTCUT_CHANGED_CELL_END
        });
    }
    onEnterKeyDown(e) {
        if (this.cellCtrl.isEditing() || this.rowCtrl.isEditing()) this.cellCtrl.stopEditingAndFocus(false, e.shiftKey);
        else if (this.beans.gos.get("enterNavigatesVertically")) {
            const key = e.shiftKey ? $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP : $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN;
            this.beans.navigationService.navigateToNextCell(null, key, this.cellCtrl.getCellPosition(), false);
        } else {
            this.cellCtrl.startRowOrCellEdit($437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER, e);
            if (this.cellCtrl.isEditing()) e.preventDefault();
        }
    }
    onF2KeyDown(event) {
        if (!this.cellCtrl.isEditing()) this.cellCtrl.startRowOrCellEdit($437b23f6a393c3bf$export$e9e0d96f49f57c33.F2, event);
    }
    onEscapeKeyDown(event) {
        if (this.cellCtrl.isEditing()) {
            this.cellCtrl.stopRowOrCellEdit(true);
            this.cellCtrl.focusCell(true);
        }
    }
    processCharacter(event) {
        const eventTarget = event.target;
        const eventOnChildComponent = eventTarget !== this.eGui;
        if (eventOnChildComponent || this.cellCtrl.isEditing()) return;
        const key = event.key;
        if (key === " ") this.onSpaceKeyDown(event);
        else {
            this.cellCtrl.startRowOrCellEdit(key, event);
            event.preventDefault();
        }
    }
    onSpaceKeyDown(event) {
        const { gos: gos } = this.beans;
        if (!this.cellCtrl.isEditing() && gos.isRowSelection()) {
            const currentSelection = this.rowNode.isSelected();
            const newSelection = !currentSelection;
            if (newSelection || !gos.get("suppressRowDeselection")) {
                const groupSelectsFiltered = this.beans.gos.get("groupSelectsFiltered");
                const updatedCount = this.rowNode.setSelectedParams({
                    newValue: newSelection,
                    rangeSelect: event.shiftKey,
                    groupSelectsFiltered: groupSelectsFiltered,
                    event: event,
                    source: "spaceKey"
                });
                if (currentSelection === void 0 && updatedCount === 0) this.rowNode.setSelectedParams({
                    newValue: false,
                    rangeSelect: event.shiftKey,
                    groupSelectsFiltered: groupSelectsFiltered,
                    event: event,
                    source: "spaceKey"
                });
            }
        }
        event.preventDefault();
    }
    destroy() {
        super.destroy();
    }
};
// community-modules/core/src/rendering/dndSourceComp.ts
var $437b23f6a393c3bf$var$DndSourceComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(rowNode, column, eCell){
        super(/* html */ `<div class="ag-drag-handle ag-row-drag" draggable="true"></div>`);
        this.rowNode = rowNode;
        this.column = column;
        this.eCell = eCell;
    }
    postConstruct() {
        const eGui = this.getGui();
        eGui.appendChild($437b23f6a393c3bf$var$createIconNoSpan("rowDrag", this.gos, null));
        this.addGuiEventListener("mousedown", (e)=>{
            e.stopPropagation();
        });
        this.addDragSource();
        this.checkVisibility();
    }
    addDragSource() {
        this.addGuiEventListener("dragstart", this.onDragStart.bind(this));
    }
    onDragStart(dragEvent) {
        const providedOnRowDrag = this.column.getColDef().dndSourceOnRowDrag;
        dragEvent.dataTransfer.setDragImage(this.eCell, 0, 0);
        const defaultOnRowDrag = ()=>{
            try {
                const jsonData = JSON.stringify(this.rowNode.data);
                dragEvent.dataTransfer.setData("application/json", jsonData);
                dragEvent.dataTransfer.setData("text/plain", jsonData);
            } catch (e) {}
        };
        if (providedOnRowDrag) {
            const params = this.gos.addGridCommonParams({
                rowNode: this.rowNode,
                dragEvent: dragEvent
            });
            providedOnRowDrag(params);
        } else defaultOnRowDrag();
    }
    checkVisibility() {
        const visible = this.column.isDndSource(this.rowNode);
        this.setDisplayed(visible);
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$DndSourceComp.prototype, "postConstruct", 1);
// community-modules/core/src/headerRendering/cells/cssClassApplier.ts
var $437b23f6a393c3bf$var$CSS_FIRST_COLUMN = "ag-column-first";
var $437b23f6a393c3bf$var$CSS_LAST_COLUMN = "ag-column-last";
var $437b23f6a393c3bf$export$f90acfa36b600d3d = class {
    static getHeaderClassesFromColDef(abstractColDef, gos, column, columnGroup) {
        if ($437b23f6a393c3bf$var$missing(abstractColDef)) return [];
        return this.getColumnClassesFromCollDef(abstractColDef.headerClass, abstractColDef, gos, column, columnGroup);
    }
    static getToolPanelClassesFromColDef(abstractColDef, gos, column, columnGroup) {
        if ($437b23f6a393c3bf$var$missing(abstractColDef)) return [];
        return this.getColumnClassesFromCollDef(abstractColDef.toolPanelClass, abstractColDef, gos, column, columnGroup);
    }
    static refreshFirstAndLastStyles(comp, column, columnModel) {
        comp.addOrRemoveCssClass($437b23f6a393c3bf$var$CSS_FIRST_COLUMN, columnModel.isColumnAtEdge(column, "first"));
        comp.addOrRemoveCssClass($437b23f6a393c3bf$var$CSS_LAST_COLUMN, columnModel.isColumnAtEdge(column, "last"));
    }
    static getClassParams(abstractColDef, gos, column, columnGroup) {
        return gos.addGridCommonParams({
            // bad naming, as colDef here can be a group or a column,
            // however most people won't appreciate the difference,
            // so keeping it as colDef to avoid confusion.
            colDef: abstractColDef,
            column: column,
            columnGroup: columnGroup
        });
    }
    static getColumnClassesFromCollDef(classesOrFunc, abstractColDef, gos, column, columnGroup) {
        if ($437b23f6a393c3bf$var$missing(classesOrFunc)) return [];
        let classToUse;
        if (typeof classesOrFunc === "function") {
            const params = this.getClassParams(abstractColDef, gos, column, columnGroup);
            classToUse = classesOrFunc(params);
        } else classToUse = classesOrFunc;
        if (typeof classToUse === "string") return [
            classToUse
        ];
        if (Array.isArray(classToUse)) return [
            ...classToUse
        ];
        return [];
    }
};
// community-modules/core/src/rendering/cell/cellCtrl.ts
var $437b23f6a393c3bf$var$CSS_CELL = "ag-cell";
var $437b23f6a393c3bf$var$CSS_AUTO_HEIGHT = "ag-cell-auto-height";
var $437b23f6a393c3bf$var$CSS_NORMAL_HEIGHT = "ag-cell-normal-height";
var $437b23f6a393c3bf$var$CSS_CELL_FOCUS = "ag-cell-focus";
var $437b23f6a393c3bf$var$CSS_CELL_FIRST_RIGHT_PINNED = "ag-cell-first-right-pinned";
var $437b23f6a393c3bf$var$CSS_CELL_LAST_LEFT_PINNED = "ag-cell-last-left-pinned";
var $437b23f6a393c3bf$var$CSS_CELL_NOT_INLINE_EDITING = "ag-cell-not-inline-editing";
var $437b23f6a393c3bf$var$CSS_COLUMN_HOVER = "ag-column-hover";
var $437b23f6a393c3bf$var$CSS_CELL_WRAP_TEXT = "ag-cell-wrap-text";
var $437b23f6a393c3bf$var$instanceIdSequence2 = 0;
var $437b23f6a393c3bf$var$_CellCtrl = class _CellCtrl extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(column, rowNode, beans, rowCtrl){
        super();
        this.cellRangeFeature = null;
        this.cellPositionFeature = null;
        this.cellCustomStyleFeature = null;
        this.tooltipFeature = null;
        this.cellMouseListenerFeature = null;
        this.cellKeyboardListenerFeature = null;
        this.suppressRefreshCell = false;
        this.onCellCompAttachedFuncs = [];
        this.column = column;
        this.rowNode = rowNode;
        this.beans = beans;
        this.rowCtrl = rowCtrl;
        this.instanceId = column.getId() + "-" + $437b23f6a393c3bf$var$instanceIdSequence2++;
        this.colIdSanitised = $437b23f6a393c3bf$var$escapeString(this.column.getId());
        if (!beans.gos.get("suppressCellFocus")) this.tabIndex = -1;
        this.createCellPosition();
        this.addFeatures();
        this.updateAndFormatValue(false);
    }
    shouldRestoreFocus() {
        return this.beans.focusService.shouldRestoreFocus(this.cellPosition);
    }
    addFeatures() {
        this.cellPositionFeature = new $437b23f6a393c3bf$var$CellPositionFeature(this, this.beans);
        this.addDestroyFunc(()=>{
            var _a;
            (_a = this.cellPositionFeature) == null || _a.destroy();
            this.cellPositionFeature = null;
        });
        this.cellCustomStyleFeature = new $437b23f6a393c3bf$var$CellCustomStyleFeature(this, this.beans);
        this.addDestroyFunc(()=>{
            var _a;
            (_a = this.cellCustomStyleFeature) == null || _a.destroy();
            this.cellCustomStyleFeature = null;
        });
        this.cellMouseListenerFeature = new $437b23f6a393c3bf$var$CellMouseListenerFeature(this, this.beans, this.column);
        this.addDestroyFunc(()=>{
            var _a;
            (_a = this.cellMouseListenerFeature) == null || _a.destroy();
            this.cellMouseListenerFeature = null;
        });
        this.cellKeyboardListenerFeature = new $437b23f6a393c3bf$var$CellKeyboardListenerFeature(this, this.beans, this.column, this.rowNode, this.rowCtrl);
        this.addDestroyFunc(()=>{
            var _a;
            (_a = this.cellKeyboardListenerFeature) == null || _a.destroy();
            this.cellKeyboardListenerFeature = null;
        });
        if (this.column.isTooltipEnabled()) {
            this.enableTooltipFeature();
            this.addDestroyFunc(()=>{
                this.disableTooltipFeature();
            });
        }
        const rangeSelectionEnabled = this.beans.rangeService && this.beans.gos.get("enableRangeSelection");
        if (rangeSelectionEnabled) {
            this.cellRangeFeature = new $437b23f6a393c3bf$var$CellRangeFeature(this.beans, this);
            this.addDestroyFunc(()=>{
                var _a;
                (_a = this.cellRangeFeature) == null || _a.destroy();
                this.cellRangeFeature = null;
            });
        }
    }
    enableTooltipFeature(value, shouldDisplayTooltip) {
        const getTooltipValue = ()=>{
            const colDef = this.column.getColDef();
            const data = this.rowNode.data;
            if (colDef.tooltipField && $437b23f6a393c3bf$var$exists(data)) return $437b23f6a393c3bf$var$getValueUsingField(data, colDef.tooltipField, this.column.isTooltipFieldContainsDots());
            const valueGetter = colDef.tooltipValueGetter;
            if (valueGetter) return valueGetter(this.beans.gos.addGridCommonParams({
                location: "cell",
                colDef: this.column.getColDef(),
                column: this.column,
                rowIndex: this.cellPosition.rowIndex,
                node: this.rowNode,
                data: this.rowNode.data,
                value: this.value,
                valueFormatted: this.valueFormatted
            }));
            return null;
        };
        const isTooltipWhenTruncated = this.beans.gos.get("tooltipShowMode") === "whenTruncated";
        if (!shouldDisplayTooltip && isTooltipWhenTruncated && !this.isCellRenderer()) shouldDisplayTooltip = ()=>{
            const eGui = this.getGui();
            const textEl = eGui.children.length === 0 ? eGui : eGui.querySelector(".ag-cell-value");
            if (!textEl) return true;
            return textEl.scrollWidth > textEl.clientWidth;
        };
        const tooltipCtrl = {
            getColumn: ()=>this.column,
            getColDef: ()=>this.column.getColDef(),
            getRowIndex: ()=>this.cellPosition.rowIndex,
            getRowNode: ()=>this.rowNode,
            getGui: ()=>this.getGui(),
            getLocation: ()=>"cell",
            getTooltipValue: value != null ? ()=>value : getTooltipValue,
            // this makes no sense, why is the cell formatted value passed to the tooltip???
            getValueFormatted: ()=>this.valueFormatted,
            shouldDisplayTooltip: shouldDisplayTooltip
        };
        this.tooltipFeature = new $437b23f6a393c3bf$export$e5073a590d24815c(tooltipCtrl, this.beans);
    }
    disableTooltipFeature() {
        if (!this.tooltipFeature) return;
        this.tooltipFeature.destroy();
        this.tooltipFeature = null;
    }
    setComp(comp, eGui, eCellWrapper, printLayout, startEditing) {
        var _a, _b, _c, _d;
        this.cellComp = comp;
        this.eGui = eGui;
        this.printLayout = printLayout;
        this.addDomData();
        this.onCellFocused(this.focusEventToRestore);
        this.applyStaticCssClasses();
        this.setWrapText();
        this.onFirstRightPinnedChanged();
        this.onLastLeftPinnedChanged();
        this.onColumnHover();
        this.setupControlComps();
        this.setupAutoHeight(eCellWrapper);
        this.refreshFirstAndLastStyles();
        this.refreshAriaColIndex();
        (_a = this.cellPositionFeature) == null || _a.setComp(eGui);
        (_b = this.cellCustomStyleFeature) == null || _b.setComp(comp);
        (_c = this.tooltipFeature) == null || _c.refreshToolTip();
        (_d = this.cellKeyboardListenerFeature) == null || _d.setComp(this.eGui);
        if (this.cellRangeFeature) this.cellRangeFeature.setComp(comp, eGui);
        if (startEditing && this.isCellEditable()) this.startEditing();
        else this.showValue();
        if (this.onCellCompAttachedFuncs.length) {
            this.onCellCompAttachedFuncs.forEach((func)=>func());
            this.onCellCompAttachedFuncs = [];
        }
    }
    setupAutoHeight(eCellWrapper) {
        this.isAutoHeight = this.column.isAutoHeight();
        if (!this.isAutoHeight || !eCellWrapper) return;
        const eParentCell = eCellWrapper.parentElement;
        const minRowHeight = this.beans.gos.getRowHeightForNode(this.rowNode).height;
        const measureHeight = (timesCalled)=>{
            if (this.editing) return;
            if (!this.isAlive()) return;
            const { paddingTop: paddingTop, paddingBottom: paddingBottom, borderBottomWidth: borderBottomWidth, borderTopWidth: borderTopWidth } = $437b23f6a393c3bf$var$getElementSize(eParentCell);
            const extraHeight = paddingTop + paddingBottom + borderBottomWidth + borderTopWidth;
            const wrapperHeight = eCellWrapper.offsetHeight;
            const autoHeight = wrapperHeight + extraHeight;
            if (timesCalled < 5) {
                const doc = this.beans.gos.getDocument();
                const notYetInDom = !doc || !doc.contains(eCellWrapper);
                const possiblyNoContentYet = autoHeight == 0;
                if (notYetInDom || possiblyNoContentYet) {
                    window.setTimeout(()=>measureHeight(timesCalled + 1), 0);
                    return;
                }
            }
            const newHeight = Math.max(autoHeight, minRowHeight);
            this.rowNode.setRowAutoHeight(newHeight, this.column);
        };
        const listener = ()=>measureHeight(0);
        listener();
        const destroyResizeObserver = this.beans.resizeObserverService.observeResize(eCellWrapper, listener);
        this.addDestroyFunc(()=>{
            destroyResizeObserver();
            this.rowNode.setRowAutoHeight(void 0, this.column);
        });
    }
    getCellAriaRole() {
        var _a;
        return (_a = this.column.getColDef().cellAriaRole) != null ? _a : "gridcell";
    }
    getInstanceId() {
        return this.instanceId;
    }
    getColumnIdSanitised() {
        return this.colIdSanitised;
    }
    getTabIndex() {
        return this.tabIndex;
    }
    isCellRenderer() {
        const colDef = this.column.getColDef();
        return colDef.cellRenderer != null || colDef.cellRendererSelector != null;
    }
    getValueToDisplay() {
        var _a;
        return (_a = this.valueFormatted) != null ? _a : this.value;
    }
    showValue(forceNewCellRendererInstance = false) {
        var _a;
        const valueToDisplay = this.getValueToDisplay();
        let compDetails;
        if (this.rowNode.stub) {
            const params = this.createCellRendererParams();
            compDetails = this.beans.userComponentFactory.getLoadingCellRendererDetails(this.column.getColDef(), params);
        } else if (this.isCellRenderer()) {
            const params = this.createCellRendererParams();
            compDetails = this.beans.userComponentFactory.getCellRendererDetails(this.column.getColDef(), params);
        }
        this.cellComp.setRenderDetails(compDetails, valueToDisplay, forceNewCellRendererInstance);
        (_a = this.cellRangeFeature) == null || _a.refreshHandle();
    }
    setupControlComps() {
        const colDef = this.column.getColDef();
        this.includeSelection = this.isIncludeControl(colDef.checkboxSelection);
        this.includeRowDrag = this.isIncludeControl(colDef.rowDrag);
        this.includeDndSource = this.isIncludeControl(colDef.dndSource);
        this.cellComp.setIncludeSelection(this.includeSelection);
        this.cellComp.setIncludeDndSource(this.includeDndSource);
        this.cellComp.setIncludeRowDrag(this.includeRowDrag);
    }
    isForceWrapper() {
        const forceWrapper = this.beans.gos.get("enableCellTextSelection") || this.column.isAutoHeight();
        return forceWrapper;
    }
    isIncludeControl(value) {
        const rowNodePinned = this.rowNode.rowPinned != null;
        const isFunc = typeof value === "function";
        const res = rowNodePinned ? false : isFunc || value === true;
        return res;
    }
    refreshShouldDestroy() {
        const colDef = this.column.getColDef();
        const selectionChanged = this.includeSelection != this.isIncludeControl(colDef.checkboxSelection);
        const rowDragChanged = this.includeRowDrag != this.isIncludeControl(colDef.rowDrag);
        const dndSourceChanged = this.includeDndSource != this.isIncludeControl(colDef.dndSource);
        const autoHeightChanged = this.isAutoHeight != this.column.isAutoHeight();
        return selectionChanged || rowDragChanged || dndSourceChanged || autoHeightChanged;
    }
    // either called internally if single cell editing, or called by rowRenderer if row editing
    startEditing(key = null, cellStartedEdit = false, event = null) {
        if (!this.isCellEditable() || this.editing) return;
        if (!this.cellComp) {
            this.onCellCompAttachedFuncs.push(()=>{
                this.startEditing(key, cellStartedEdit, event);
            });
            return;
        }
        const editorParams = this.createCellEditorParams(key, cellStartedEdit);
        const colDef = this.column.getColDef();
        const compDetails = this.beans.userComponentFactory.getCellEditorDetails(colDef, editorParams);
        this.editCompDetails = compDetails;
        const popup = (compDetails == null ? void 0 : compDetails.popupFromSelector) != null ? compDetails.popupFromSelector : !!colDef.cellEditorPopup;
        const position = (compDetails == null ? void 0 : compDetails.popupPositionFromSelector) != null ? compDetails.popupPositionFromSelector : colDef.cellEditorPopupPosition;
        this.setEditing(true);
        this.cellComp.setEditDetails(compDetails, popup, position, this.beans.gos.get("reactiveCustomComponents"));
        const e = this.createEvent(event, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_CELL_EDITING_STARTED);
        this.beans.eventService.dispatchEvent(e);
    }
    setEditing(editing) {
        var _a;
        if (this.editing === editing) return;
        this.editing = editing;
        (_a = this.cellRangeFeature) == null || _a.refreshHandle();
    }
    // pass in 'true' to cancel the editing.
    stopRowOrCellEdit(cancel = false) {
        if (this.beans.gos.get("editType") === "fullRow") this.rowCtrl.stopEditing(cancel);
        else this.stopEditing(cancel);
    }
    onPopupEditorClosed() {
        if (!this.isEditing()) return;
        this.stopEditingAndFocus();
    }
    takeValueFromCellEditor(cancel) {
        const noValueResult = {
            newValueExists: false
        };
        if (cancel) return noValueResult;
        const cellEditor = this.cellComp.getCellEditor();
        if (!cellEditor) return noValueResult;
        const userWantsToCancel = cellEditor.isCancelAfterEnd && cellEditor.isCancelAfterEnd();
        if (userWantsToCancel) return noValueResult;
        const newValue = cellEditor.getValue();
        return {
            newValue: newValue,
            newValueExists: true
        };
    }
    /**
   * @returns `True` if the value changes, otherwise `False`.
   */ saveNewValue(oldValue, newValue) {
        if (newValue === oldValue) return false;
        this.suppressRefreshCell = true;
        const valueChanged = this.rowNode.setDataValue(this.column, newValue, "edit");
        this.suppressRefreshCell = false;
        return valueChanged;
    }
    /**
   * Ends the Cell Editing
   * @param cancel `True` if the edit process is being canceled.
   * @returns `True` if the value of the `GridCell` has been updated, otherwise `False`.
   */ stopEditing(cancel = false) {
        if (!this.editing) return false;
        const { newValue: newValue, newValueExists: newValueExists } = this.takeValueFromCellEditor(cancel);
        const oldValue = this.rowNode.getValueFromValueService(this.column);
        let valueChanged = false;
        if (newValueExists) valueChanged = this.saveNewValue(oldValue, newValue);
        this.setEditing(false);
        this.cellComp.setEditDetails();
        this.editCompDetails = void 0;
        this.updateAndFormatValue(false);
        this.refreshCell({
            forceRefresh: true,
            suppressFlash: true
        });
        this.dispatchEditingStoppedEvent(oldValue, newValue, !cancel && !!valueChanged);
        return valueChanged;
    }
    dispatchEditingStoppedEvent(oldValue, newValue, valueChanged) {
        const editingStoppedEvent = $437b23f6a393c3bf$var$__spreadProps($437b23f6a393c3bf$var$__spreadValues({}, this.createEvent(null, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_CELL_EDITING_STOPPED)), {
            oldValue: oldValue,
            newValue: newValue,
            valueChanged: valueChanged
        });
        this.beans.eventService.dispatchEvent(editingStoppedEvent);
    }
    createCellEditorParams(key, cellStartedEdit) {
        return this.beans.gos.addGridCommonParams({
            value: this.rowNode.getValueFromValueService(this.column),
            eventKey: key,
            column: this.column,
            colDef: this.column.getColDef(),
            rowIndex: this.getCellPosition().rowIndex,
            node: this.rowNode,
            data: this.rowNode.data,
            cellStartedEdit: cellStartedEdit,
            onKeyDown: this.onKeyDown.bind(this),
            stopEditing: this.stopEditingAndFocus.bind(this),
            eGridCell: this.getGui(),
            parseValue: this.parseValue.bind(this),
            formatValue: this.formatValue.bind(this)
        });
    }
    createCellRendererParams() {
        const res = this.beans.gos.addGridCommonParams({
            value: this.value,
            valueFormatted: this.valueFormatted,
            getValue: ()=>this.rowNode.getValueFromValueService(this.column),
            setValue: (value)=>this.beans.valueService.setValue(this.rowNode, this.column, value),
            formatValue: this.formatValue.bind(this),
            data: this.rowNode.data,
            node: this.rowNode,
            pinned: this.column.getPinned(),
            colDef: this.column.getColDef(),
            column: this.column,
            rowIndex: this.getCellPosition().rowIndex,
            refreshCell: this.refreshCell.bind(this),
            eGridCell: this.getGui(),
            eParentOfValue: this.cellComp.getParentOfValue(),
            registerRowDragger: (rowDraggerElement, dragStartPixels, value, suppressVisibilityChange)=>this.registerRowDragger(rowDraggerElement, dragStartPixels, suppressVisibilityChange),
            setTooltip: (value, shouldDisplayTooltip)=>{
                var _a;
                if (this.tooltipFeature) this.disableTooltipFeature();
                this.enableTooltipFeature(value, shouldDisplayTooltip);
                (_a = this.tooltipFeature) == null || _a.refreshToolTip();
            }
        });
        return res;
    }
    parseValue(newValue) {
        return this.beans.valueService.parseValue(this.column, this.rowNode, newValue, this.getValue());
    }
    setFocusOutOnEditor() {
        if (!this.editing) return;
        const cellEditor = this.cellComp.getCellEditor();
        if (cellEditor && cellEditor.focusOut) cellEditor.focusOut();
    }
    setFocusInOnEditor() {
        if (!this.editing) return;
        const cellEditor = this.cellComp.getCellEditor();
        if (cellEditor && cellEditor.focusIn) cellEditor.focusIn();
        else this.focusCell(true);
    }
    onCellChanged(event) {
        const eventImpactsThisCell = event.column === this.column;
        if (eventImpactsThisCell) this.refreshCell({});
    }
    refreshOrDestroyCell(params) {
        var _a;
        if (this.refreshShouldDestroy()) (_a = this.rowCtrl) == null || _a.recreateCell(this);
        else this.refreshCell(params);
    }
    // + stop editing {forceRefresh: true, suppressFlash: true}
    // + event cellChanged {}
    // + cellRenderer.params.refresh() {} -> method passes 'as is' to the cellRenderer, so params could be anything
    // + rowCtrl: event dataChanged {suppressFlash: !update, newData: !update}
    // + rowCtrl: api refreshCells() {animate: true/false}
    // + rowRenderer: api softRefreshView() {}
    refreshCell(params) {
        var _a, _b, _c, _d;
        if (this.suppressRefreshCell || this.editing) return;
        const colDef = this.column.getColDef();
        const newData = params != null && !!params.newData;
        const suppressFlash = params != null && !!params.suppressFlash || !!colDef.suppressCellFlash;
        const noValueProvided = colDef.field == null && colDef.valueGetter == null && colDef.showRowGroup == null;
        const forceRefresh = params && params.forceRefresh || noValueProvided || newData;
        const isCellCompReady = !!this.cellComp;
        const valuesDifferent = this.updateAndFormatValue(isCellCompReady);
        const dataNeedsUpdating = forceRefresh || valuesDifferent;
        if (!isCellCompReady) return;
        if (dataNeedsUpdating) {
            this.showValue(newData);
            const processingFilterChange = this.beans.filterManager.isSuppressFlashingCellsBecauseFiltering();
            const flashCell = !suppressFlash && !processingFilterChange && (this.beans.gos.get("enableCellChangeFlash") || colDef.enableCellChangeFlash);
            if (flashCell) this.flashCell();
            (_a = this.cellCustomStyleFeature) == null || _a.applyUserStyles();
            (_b = this.cellCustomStyleFeature) == null || _b.applyClassesFromColDef();
        }
        (_c = this.tooltipFeature) == null || _c.refreshToolTip();
        (_d = this.cellCustomStyleFeature) == null || _d.applyCellClassRules();
    }
    // cell editors call this, when they want to stop for reasons other
    // than what we pick up on. eg selecting from a dropdown ends editing.
    stopEditingAndFocus(suppressNavigateAfterEdit = false, shiftKey = false) {
        this.stopRowOrCellEdit();
        this.focusCell(true);
        if (!suppressNavigateAfterEdit) this.navigateAfterEdit(shiftKey);
    }
    navigateAfterEdit(shiftKey) {
        const enterNavigatesVerticallyAfterEdit = this.beans.gos.get("enterNavigatesVerticallyAfterEdit");
        if (enterNavigatesVerticallyAfterEdit) {
            const key = shiftKey ? $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP : $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN;
            this.beans.navigationService.navigateToNextCell(null, key, this.getCellPosition(), false);
        }
    }
    // user can also call this via API
    flashCell(delays) {
        var _a, _b;
        const flashDuration = (_a = delays == null ? void 0 : delays.flashDuration) != null ? _a : delays == null ? void 0 : delays.flashDelay;
        const fadeDuration = (_b = delays == null ? void 0 : delays.fadeDuration) != null ? _b : delays == null ? void 0 : delays.fadeDelay;
        this.animateCell("data-changed", flashDuration, fadeDuration);
    }
    animateCell(cssName, flashDuration, fadeDuration) {
        if (!this.cellComp) return;
        const fullName = `ag-cell-${cssName}`;
        const animationFullName = `ag-cell-${cssName}-animation`;
        const { gos: gos } = this.beans;
        if (!flashDuration) flashDuration = gos.get("cellFlashDuration");
        if (!$437b23f6a393c3bf$var$exists(fadeDuration)) fadeDuration = gos.get("cellFadeDuration");
        this.cellComp.addOrRemoveCssClass(fullName, true);
        this.cellComp.addOrRemoveCssClass(animationFullName, false);
        this.beans.frameworkOverrides.wrapIncoming(()=>{
            window.setTimeout(()=>{
                if (!this.isAlive()) return;
                this.cellComp.addOrRemoveCssClass(fullName, false);
                this.cellComp.addOrRemoveCssClass(animationFullName, true);
                this.eGui.style.transition = `background-color ${fadeDuration}ms`;
                window.setTimeout(()=>{
                    if (!this.isAlive()) return;
                    this.cellComp.addOrRemoveCssClass(animationFullName, false);
                    this.eGui.style.transition = "";
                }, fadeDuration);
            }, flashDuration);
        });
    }
    onFlashCells(event) {
        if (!this.cellComp) return;
        const cellId = this.beans.cellPositionUtils.createId(this.getCellPosition());
        const shouldFlash = event.cells[cellId];
        if (shouldFlash) this.animateCell("highlight");
    }
    isCellEditable() {
        return this.column.isCellEditable(this.rowNode);
    }
    isSuppressFillHandle() {
        return this.column.isSuppressFillHandle();
    }
    formatValue(value) {
        var _a;
        return (_a = this.callValueFormatter(value)) != null ? _a : value;
    }
    callValueFormatter(value) {
        return this.beans.valueService.formatValue(this.column, this.rowNode, value);
    }
    updateAndFormatValue(compareValues) {
        const oldValue = this.value;
        const oldValueFormatted = this.valueFormatted;
        this.value = this.rowNode.getValueFromValueService(this.column);
        this.valueFormatted = this.callValueFormatter(this.value);
        if (compareValues) return !this.valuesAreEqual(oldValue, this.value) || this.valueFormatted != oldValueFormatted;
        return true;
    }
    valuesAreEqual(val1, val2) {
        const colDef = this.column.getColDef();
        return colDef.equals ? colDef.equals(val1, val2) : val1 === val2;
    }
    getComp() {
        return this.cellComp;
    }
    getValue() {
        return this.value;
    }
    addDomData() {
        const element = this.getGui();
        this.beans.gos.setDomData(element, _CellCtrl.DOM_DATA_KEY_CELL_CTRL, this);
        this.addDestroyFunc(()=>this.beans.gos.setDomData(element, _CellCtrl.DOM_DATA_KEY_CELL_CTRL, null));
    }
    createEvent(domEvent, eventType) {
        const event = this.beans.gos.addGridCommonParams({
            type: eventType,
            node: this.rowNode,
            data: this.rowNode.data,
            value: this.value,
            column: this.column,
            colDef: this.column.getColDef(),
            rowPinned: this.rowNode.rowPinned,
            event: domEvent,
            rowIndex: this.rowNode.rowIndex
        });
        return event;
    }
    processCharacter(event) {
        var _a;
        (_a = this.cellKeyboardListenerFeature) == null || _a.processCharacter(event);
    }
    onKeyDown(event) {
        var _a;
        (_a = this.cellKeyboardListenerFeature) == null || _a.onKeyDown(event);
    }
    onMouseEvent(eventName, mouseEvent) {
        var _a;
        (_a = this.cellMouseListenerFeature) == null || _a.onMouseEvent(eventName, mouseEvent);
    }
    getGui() {
        return this.eGui;
    }
    getColSpanningList() {
        return this.cellPositionFeature.getColSpanningList();
    }
    onLeftChanged() {
        var _a;
        if (!this.cellComp) return;
        (_a = this.cellPositionFeature) == null || _a.onLeftChanged();
    }
    onDisplayedColumnsChanged() {
        if (!this.eGui) return;
        this.refreshAriaColIndex();
        this.refreshFirstAndLastStyles();
    }
    refreshFirstAndLastStyles() {
        const { cellComp: cellComp, column: column, beans: beans } = this;
        $437b23f6a393c3bf$export$f90acfa36b600d3d.refreshFirstAndLastStyles(cellComp, column, beans.columnModel);
    }
    refreshAriaColIndex() {
        const colIdx = this.beans.columnModel.getAriaColumnIndex(this.column);
        $437b23f6a393c3bf$var$setAriaColIndex(this.getGui(), colIdx);
    }
    isSuppressNavigable() {
        return this.column.isSuppressNavigable(this.rowNode);
    }
    onWidthChanged() {
        var _a;
        return (_a = this.cellPositionFeature) == null ? void 0 : _a.onWidthChanged();
    }
    getColumn() {
        return this.column;
    }
    getRowNode() {
        return this.rowNode;
    }
    isPrintLayout() {
        return this.printLayout;
    }
    getCellPosition() {
        return this.cellPosition;
    }
    isEditing() {
        return this.editing;
    }
    // called by rowRenderer when user navigates via tab key
    startRowOrCellEdit(key, event = null) {
        if (!this.cellComp) {
            this.onCellCompAttachedFuncs.push(()=>{
                this.startRowOrCellEdit(key, event);
            });
            return;
        }
        if (this.beans.gos.get("editType") === "fullRow") this.rowCtrl.startRowEditing(key, this);
        else this.startEditing(key, true, event);
    }
    getRowCtrl() {
        return this.rowCtrl;
    }
    getRowPosition() {
        return {
            rowIndex: this.cellPosition.rowIndex,
            rowPinned: this.cellPosition.rowPinned
        };
    }
    updateRangeBordersIfRangeCount() {
        if (!this.cellComp) return;
        if (this.cellRangeFeature) this.cellRangeFeature.updateRangeBordersIfRangeCount();
    }
    onRangeSelectionChanged() {
        if (!this.cellComp) return;
        if (this.cellRangeFeature) this.cellRangeFeature.onRangeSelectionChanged();
    }
    isRangeSelectionEnabled() {
        return this.cellRangeFeature != null;
    }
    focusCell(forceBrowserFocus = false) {
        this.beans.focusService.setFocusedCell({
            rowIndex: this.getCellPosition().rowIndex,
            column: this.column,
            rowPinned: this.rowNode.rowPinned,
            forceBrowserFocus: forceBrowserFocus
        });
    }
    onRowIndexChanged() {
        this.createCellPosition();
        this.onCellFocused();
        if (this.cellRangeFeature) this.cellRangeFeature.onRangeSelectionChanged();
    }
    onFirstRightPinnedChanged() {
        if (!this.cellComp) return;
        const firstRightPinned = this.column.isFirstRightPinned();
        this.cellComp.addOrRemoveCssClass($437b23f6a393c3bf$var$CSS_CELL_FIRST_RIGHT_PINNED, firstRightPinned);
    }
    onLastLeftPinnedChanged() {
        if (!this.cellComp) return;
        const lastLeftPinned = this.column.isLastLeftPinned();
        this.cellComp.addOrRemoveCssClass($437b23f6a393c3bf$var$CSS_CELL_LAST_LEFT_PINNED, lastLeftPinned);
    }
    onCellFocused(event) {
        if (this.beans.gos.get("suppressCellFocus")) return;
        const cellFocused = this.beans.focusService.isCellFocused(this.cellPosition);
        if (!this.cellComp) {
            if (cellFocused && (event == null ? void 0 : event.forceBrowserFocus)) this.focusEventToRestore = event;
            return;
        }
        this.focusEventToRestore = void 0;
        this.cellComp.addOrRemoveCssClass($437b23f6a393c3bf$var$CSS_CELL_FOCUS, cellFocused);
        if (cellFocused && event && event.forceBrowserFocus) {
            const focusEl = this.cellComp.getFocusableElement();
            focusEl.focus({
                preventScroll: !!event.preventScrollOnBrowserFocus
            });
        }
        const fullRowEdit = this.beans.gos.get("editType") === "fullRow";
        if (!cellFocused && !fullRowEdit && this.editing) this.stopRowOrCellEdit();
        if (cellFocused) this.rowCtrl.announceDescription();
    }
    createCellPosition() {
        this.cellPosition = {
            rowIndex: this.rowNode.rowIndex,
            rowPinned: $437b23f6a393c3bf$var$makeNull(this.rowNode.rowPinned),
            column: this.column
        };
    }
    // CSS Classes that only get applied once, they never change
    applyStaticCssClasses() {
        this.cellComp.addOrRemoveCssClass($437b23f6a393c3bf$var$CSS_CELL, true);
        this.cellComp.addOrRemoveCssClass($437b23f6a393c3bf$var$CSS_CELL_NOT_INLINE_EDITING, true);
        const autoHeight = this.column.isAutoHeight() == true;
        this.cellComp.addOrRemoveCssClass($437b23f6a393c3bf$var$CSS_AUTO_HEIGHT, autoHeight);
        this.cellComp.addOrRemoveCssClass($437b23f6a393c3bf$var$CSS_NORMAL_HEIGHT, !autoHeight);
    }
    onColumnHover() {
        if (!this.cellComp) return;
        if (!this.beans.gos.get("columnHoverHighlight")) return;
        const isHovered = this.beans.columnHoverService.isHovered(this.column);
        this.cellComp.addOrRemoveCssClass($437b23f6a393c3bf$var$CSS_COLUMN_HOVER, isHovered);
    }
    onColDefChanged() {
        if (!this.cellComp) return;
        const isTooltipEnabled = this.column.isTooltipEnabled();
        if (isTooltipEnabled) {
            this.disableTooltipFeature();
            this.enableTooltipFeature();
        } else this.disableTooltipFeature();
        this.setWrapText();
        if (!this.editing) this.refreshOrDestroyCell({
            forceRefresh: true,
            suppressFlash: true
        });
        else {
            const cellEditor = this.getCellEditor();
            if (cellEditor == null ? void 0 : cellEditor.refresh) {
                const { eventKey: eventKey, cellStartedEdit: cellStartedEdit } = this.editCompDetails.params;
                const editorParams = this.createCellEditorParams(eventKey, cellStartedEdit);
                const colDef = this.column.getColDef();
                const compDetails = this.beans.userComponentFactory.getCellEditorDetails(colDef, editorParams);
                cellEditor.refresh(compDetails.params);
            }
        }
    }
    setWrapText() {
        const value = this.column.getColDef().wrapText == true;
        this.cellComp.addOrRemoveCssClass($437b23f6a393c3bf$var$CSS_CELL_WRAP_TEXT, value);
    }
    dispatchCellContextMenuEvent(event) {
        const colDef = this.column.getColDef();
        const cellContextMenuEvent = this.createEvent(event, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_CELL_CONTEXT_MENU);
        this.beans.eventService.dispatchEvent(cellContextMenuEvent);
        if (colDef.onCellContextMenu) window.setTimeout(()=>{
            this.beans.frameworkOverrides.wrapOutgoing(()=>{
                colDef.onCellContextMenu(cellContextMenuEvent);
            });
        }, 0);
    }
    getCellRenderer() {
        return this.cellComp ? this.cellComp.getCellRenderer() : null;
    }
    getCellEditor() {
        return this.cellComp ? this.cellComp.getCellEditor() : null;
    }
    destroy() {
        this.onCellCompAttachedFuncs = [];
        super.destroy();
    }
    createSelectionCheckbox() {
        const cbSelectionComponent = new $437b23f6a393c3bf$export$b54c7a6db4674fde();
        this.beans.context.createBean(cbSelectionComponent);
        cbSelectionComponent.init({
            rowNode: this.rowNode,
            column: this.column
        });
        return cbSelectionComponent;
    }
    createDndSource() {
        const dndSourceComp = new $437b23f6a393c3bf$var$DndSourceComp(this.rowNode, this.column, this.eGui);
        this.beans.context.createBean(dndSourceComp);
        return dndSourceComp;
    }
    registerRowDragger(customElement, dragStartPixels, suppressVisibilityChange) {
        if (this.customRowDragComp) {
            this.customRowDragComp.setDragElement(customElement, dragStartPixels);
            return;
        }
        const newComp = this.createRowDragComp(customElement, dragStartPixels, suppressVisibilityChange);
        if (newComp) {
            this.customRowDragComp = newComp;
            this.addDestroyFunc(()=>{
                this.beans.context.destroyBean(newComp);
                this.customRowDragComp = null;
            });
        }
    }
    createRowDragComp(customElement, dragStartPixels, suppressVisibilityChange) {
        const pagination = this.beans.gos.get("pagination");
        const rowDragManaged = this.beans.gos.get("rowDragManaged");
        const clientSideRowModelActive = this.beans.gos.isRowModelType("clientSide");
        if (rowDragManaged) {
            if (!clientSideRowModelActive) {
                $437b23f6a393c3bf$var$warnOnce("managed row dragging is only allowed in the Client Side Row Model");
                return;
            }
            if (pagination) {
                $437b23f6a393c3bf$var$warnOnce("managed row dragging is not possible when doing pagination");
                return;
            }
        }
        const rowDragComp = new $437b23f6a393c3bf$var$RowDragComp(()=>this.value, this.rowNode, this.column, customElement, dragStartPixels, suppressVisibilityChange);
        this.beans.context.createBean(rowDragComp);
        return rowDragComp;
    }
};
$437b23f6a393c3bf$var$_CellCtrl.DOM_DATA_KEY_CELL_CTRL = "cellCtrl";
var $437b23f6a393c3bf$export$4fd76abbfd48a7b6 = $437b23f6a393c3bf$var$_CellCtrl;
// community-modules/core/src/rendering/row/rowCtrl.ts
var $437b23f6a393c3bf$var$instanceIdSequence3 = 0;
var $437b23f6a393c3bf$var$_RowCtrl = class _RowCtrl extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(rowNode, beans, animateIn, useAnimationFrameForCreate, printLayout){
        super();
        this.allRowGuis = [];
        this.active = true;
        this.centerCellCtrls = {
            list: [],
            map: {}
        };
        this.leftCellCtrls = {
            list: [],
            map: {}
        };
        this.rightCellCtrls = {
            list: [],
            map: {}
        };
        this.slideInAnimation = {
            left: false,
            center: false,
            right: false,
            fullWidth: false
        };
        this.fadeInAnimation = {
            left: false,
            center: false,
            right: false,
            fullWidth: false
        };
        this.rowDragComps = [];
        this.lastMouseDownOnDragger = false;
        this.emptyStyle = {};
        this.updateColumnListsPending = false;
        this.rowId = null;
        this.businessKeySanitised = null;
        this.beans = beans;
        this.gos = beans.gos;
        this.rowNode = rowNode;
        this.paginationPage = beans.paginationProxy.getCurrentPage();
        this.useAnimationFrameForCreate = useAnimationFrameForCreate;
        this.printLayout = printLayout;
        this.suppressRowTransform = this.gos.get("suppressRowTransform");
        this.instanceId = rowNode.id + "-" + $437b23f6a393c3bf$var$instanceIdSequence3++;
        this.rowId = $437b23f6a393c3bf$var$escapeString(rowNode.id);
        this.initRowBusinessKey();
        this.rowFocused = beans.focusService.isRowFocused(this.rowNode.rowIndex, this.rowNode.rowPinned);
        this.rowLevel = beans.rowCssClassCalculator.calculateRowLevel(this.rowNode);
        this.setRowType();
        this.setAnimateFlags(animateIn);
        this.rowStyles = this.processStylesFromGridOptions();
        if (this.isFullWidth() && !this.gos.get("suppressCellFocus")) this.tabIndex = -1;
        this.addListeners();
    }
    initRowBusinessKey() {
        this.businessKeyForNodeFunc = this.gos.get("getBusinessKeyForNode");
        this.updateRowBusinessKey();
    }
    updateRowBusinessKey() {
        if (typeof this.businessKeyForNodeFunc !== "function") return;
        const businessKey = this.businessKeyForNodeFunc(this.rowNode);
        this.businessKeySanitised = $437b23f6a393c3bf$var$escapeString(businessKey);
    }
    getRowId() {
        return this.rowId;
    }
    getRowStyles() {
        return this.rowStyles;
    }
    getTabIndex() {
        return this.tabIndex;
    }
    isSticky() {
        return this.rowNode.sticky;
    }
    getInstanceId() {
        return this.instanceId;
    }
    setComp(rowComp, element, containerType) {
        const gui = {
            rowComp: rowComp,
            element: element,
            containerType: containerType
        };
        this.allRowGuis.push(gui);
        if (containerType === "left" /* LEFT */ ) this.leftGui = gui;
        else if (containerType === "right" /* RIGHT */ ) this.rightGui = gui;
        else if (containerType === "fullWidth" /* FULL_WIDTH */ ) this.fullWidthGui = gui;
        else this.centerGui = gui;
        this.initialiseRowComp(gui);
        if (this.rowType !== "FullWidthLoading" && !this.rowNode.rowPinned) this.beans.rowRenderer.dispatchFirstDataRenderedEvent();
    }
    unsetComp(containerType) {
        this.allRowGuis = this.allRowGuis.filter((rowGui)=>rowGui.containerType !== containerType);
        switch(containerType){
            case "left" /* LEFT */ :
                this.leftGui = void 0;
                break;
            case "right" /* RIGHT */ :
                this.rightGui = void 0;
                break;
            case "fullWidth" /* FULL_WIDTH */ :
                this.fullWidthGui = void 0;
                break;
            case "center" /* CENTER */ :
                this.centerGui = void 0;
                break;
            default:
        }
    }
    isCacheable() {
        return this.rowType === "FullWidthDetail" /* FullWidthDetail */  && this.gos.get("keepDetailRows");
    }
    setCached(cached) {
        const displayValue = cached ? "none" : "";
        this.allRowGuis.forEach((rg)=>rg.element.style.display = displayValue);
    }
    initialiseRowComp(gui) {
        const gos = this.gos;
        this.listenOnDomOrder(gui);
        if (this.beans.columnModel.wasAutoRowHeightEverActive()) this.rowNode.checkAutoHeights();
        this.onRowHeightChanged(gui);
        this.updateRowIndexes(gui);
        this.setFocusedClasses(gui);
        this.setStylesFromGridOptions(false, gui);
        if (gos.isRowSelection() && this.rowNode.selectable) this.onRowSelected(gui);
        this.updateColumnLists(!this.useAnimationFrameForCreate);
        const comp = gui.rowComp;
        const initialRowClasses = this.getInitialRowClasses(gui.containerType);
        initialRowClasses.forEach((name)=>comp.addOrRemoveCssClass(name, true));
        this.executeSlideAndFadeAnimations(gui);
        if (this.rowNode.group) $437b23f6a393c3bf$var$setAriaExpanded(gui.element, this.rowNode.expanded == true);
        this.setRowCompRowId(comp);
        this.setRowCompRowBusinessKey(comp);
        gos.setDomData(gui.element, _RowCtrl.DOM_DATA_KEY_ROW_CTRL, this);
        this.addDestroyFunc(()=>gos.setDomData(gui.element, _RowCtrl.DOM_DATA_KEY_ROW_CTRL, null));
        if (this.useAnimationFrameForCreate) this.beans.animationFrameService.createTask(this.addHoverFunctionality.bind(this, gui.element), this.rowNode.rowIndex, "createTasksP2");
        else this.addHoverFunctionality(gui.element);
        if (this.isFullWidth()) this.setupFullWidth(gui);
        if (gos.get("rowDragEntireRow")) this.addRowDraggerToRow(gui);
        if (this.useAnimationFrameForCreate) this.beans.animationFrameService.addDestroyTask(()=>{
            if (!this.isAlive()) return;
            gui.rowComp.addOrRemoveCssClass("ag-after-created", true);
        });
        this.executeProcessRowPostCreateFunc();
    }
    setRowCompRowBusinessKey(comp) {
        if (this.businessKeySanitised == null) return;
        comp.setRowBusinessKey(this.businessKeySanitised);
    }
    getBusinessKey() {
        return this.businessKeySanitised;
    }
    setRowCompRowId(comp) {
        this.rowId = $437b23f6a393c3bf$var$escapeString(this.rowNode.id);
        if (this.rowId == null) return;
        comp.setRowId(this.rowId);
    }
    executeSlideAndFadeAnimations(gui) {
        const { containerType: containerType } = gui;
        const shouldSlide = this.slideInAnimation[containerType];
        if (shouldSlide) {
            $437b23f6a393c3bf$var$executeNextVMTurn(()=>{
                this.onTopChanged();
            });
            this.slideInAnimation[containerType] = false;
        }
        const shouldFade = this.fadeInAnimation[containerType];
        if (shouldFade) {
            $437b23f6a393c3bf$var$executeNextVMTurn(()=>{
                gui.rowComp.addOrRemoveCssClass("ag-opacity-zero", false);
            });
            this.fadeInAnimation[containerType] = false;
        }
    }
    addRowDraggerToRow(gui) {
        if (this.gos.get("enableRangeSelection")) {
            $437b23f6a393c3bf$var$warnOnce("Setting `rowDragEntireRow: true` in the gridOptions doesn't work with `enableRangeSelection: true`");
            return;
        }
        const translate = this.beans.localeService.getLocaleTextFunc();
        const rowDragComp = new $437b23f6a393c3bf$var$RowDragComp(()=>`1 ${translate("rowDragRow", "row")}`, this.rowNode, void 0, gui.element, void 0, true);
        const rowDragBean = this.createBean(rowDragComp, this.beans.context);
        this.rowDragComps.push(rowDragBean);
    }
    setupFullWidth(gui) {
        const pinned = this.getPinnedForContainer(gui.containerType);
        if (this.rowType == "FullWidthDetail" /* FullWidthDetail */ ) {
            if (!$437b23f6a393c3bf$export$dc053975cc7f6c11.__assertRegistered("@ag-grid-enterprise/master-detail" /* MasterDetailModule */ , "cell renderer 'agDetailCellRenderer' (for master detail)", this.beans.context.getGridId())) return;
        }
        const compDetails = this.createFullWidthCompDetails(gui.element, pinned);
        gui.rowComp.showFullWidth(compDetails);
    }
    isPrintLayout() {
        return this.printLayout;
    }
    getFullWidthCellRenderers() {
        var _a, _b;
        if (this.gos.get("embedFullWidthRows")) return this.allRowGuis.map((gui)=>{
            var _a2;
            return (_a2 = gui == null ? void 0 : gui.rowComp) == null ? void 0 : _a2.getFullWidthCellRenderer();
        });
        return [
            (_b = (_a = this.fullWidthGui) == null ? void 0 : _a.rowComp) == null ? void 0 : _b.getFullWidthCellRenderer()
        ];
    }
    // use by autoWidthCalculator, as it clones the elements
    getCellElement(column) {
        const cellCtrl = this.getCellCtrl(column);
        return cellCtrl ? cellCtrl.getGui() : null;
    }
    executeProcessRowPostCreateFunc() {
        const func = this.gos.getCallback("processRowPostCreate");
        if (!func || !this.areAllContainersReady()) return;
        const params = {
            // areAllContainersReady asserts that centerGui is not null
            eRow: this.centerGui.element,
            ePinnedLeftRow: this.leftGui ? this.leftGui.element : void 0,
            ePinnedRightRow: this.rightGui ? this.rightGui.element : void 0,
            node: this.rowNode,
            rowIndex: this.rowNode.rowIndex,
            addRenderedRowListener: this.addEventListener.bind(this)
        };
        func(params);
    }
    areAllContainersReady() {
        const isLeftReady = !!this.leftGui || !this.beans.columnModel.isPinningLeft();
        const isCenterReady = !!this.centerGui;
        const isRightReady = !!this.rightGui || !this.beans.columnModel.isPinningRight();
        return isLeftReady && isCenterReady && isRightReady;
    }
    setRowType() {
        const isStub = this.rowNode.stub && !this.gos.get("suppressServerSideFullWidthLoadingRow");
        const isFullWidthCell = this.rowNode.isFullWidthCell();
        const isDetailCell = this.gos.get("masterDetail") && this.rowNode.detail;
        const pivotMode = this.beans.columnModel.isPivotMode();
        const isGroupRow = !!this.rowNode.group && !this.rowNode.footer;
        const isFullWidthGroup = isGroupRow && this.gos.isGroupUseEntireRow(pivotMode);
        if (isStub) this.rowType = "FullWidthLoading" /* FullWidthLoading */ ;
        else if (isDetailCell) this.rowType = "FullWidthDetail" /* FullWidthDetail */ ;
        else if (isFullWidthCell) this.rowType = "FullWidth" /* FullWidth */ ;
        else if (isFullWidthGroup) this.rowType = "FullWidthGroup" /* FullWidthGroup */ ;
        else this.rowType = "Normal" /* Normal */ ;
    }
    updateColumnLists(suppressAnimationFrame = false, useFlushSync = false) {
        if (this.isFullWidth()) return;
        const noAnimation = suppressAnimationFrame || this.gos.get("suppressAnimationFrame") || this.printLayout;
        if (noAnimation) {
            this.updateColumnListsImpl(useFlushSync);
            return;
        }
        if (this.updateColumnListsPending) return;
        this.beans.animationFrameService.createTask(()=>{
            if (!this.active) return;
            this.updateColumnListsImpl(true);
        }, this.rowNode.rowIndex, "createTasksP1");
        this.updateColumnListsPending = true;
    }
    createCellCtrls(prev, cols, pinned = null) {
        const res = {
            list: [],
            map: {}
        };
        const addCell = (colInstanceId, cellCtrl)=>{
            res.list.push(cellCtrl);
            res.map[colInstanceId] = cellCtrl;
        };
        cols.forEach((col)=>{
            const colInstanceId = col.getInstanceId();
            let cellCtrl = prev.map[colInstanceId];
            if (!cellCtrl) cellCtrl = new $437b23f6a393c3bf$export$4fd76abbfd48a7b6(col, this.rowNode, this.beans, this);
            addCell(colInstanceId, cellCtrl);
        });
        prev.list.forEach((prevCellCtrl)=>{
            const cellInResult = res.map[prevCellCtrl.getColumn().getInstanceId()] != null;
            if (cellInResult) return;
            const keepCell = !this.isCellEligibleToBeRemoved(prevCellCtrl, pinned);
            if (keepCell) {
                addCell(prevCellCtrl.getColumn().getInstanceId(), prevCellCtrl);
                return;
            }
            prevCellCtrl.destroy();
        });
        return res;
    }
    updateColumnListsImpl(useFlushSync) {
        this.updateColumnListsPending = false;
        this.createAllCellCtrls();
        this.setCellCtrls(useFlushSync);
    }
    setCellCtrls(useFlushSync) {
        this.allRowGuis.forEach((item)=>{
            const cellControls = this.getCellCtrlsForContainer(item.containerType);
            item.rowComp.setCellCtrls(cellControls, useFlushSync);
        });
    }
    getCellCtrlsForContainer(containerType) {
        switch(containerType){
            case "left" /* LEFT */ :
                return this.leftCellCtrls.list;
            case "right" /* RIGHT */ :
                return this.rightCellCtrls.list;
            case "fullWidth" /* FULL_WIDTH */ :
                return [];
            case "center" /* CENTER */ :
                return this.centerCellCtrls.list;
            default:
                const exhaustiveCheck = containerType;
                throw new Error(`Unhandled case: ${exhaustiveCheck}`);
        }
    }
    createAllCellCtrls() {
        const columnModel = this.beans.columnModel;
        if (this.printLayout) {
            this.centerCellCtrls = this.createCellCtrls(this.centerCellCtrls, columnModel.getAllDisplayedColumns());
            this.leftCellCtrls = {
                list: [],
                map: {}
            };
            this.rightCellCtrls = {
                list: [],
                map: {}
            };
        } else {
            const centerCols = columnModel.getViewportCenterColumnsForRow(this.rowNode);
            this.centerCellCtrls = this.createCellCtrls(this.centerCellCtrls, centerCols);
            const leftCols = columnModel.getDisplayedLeftColumnsForRow(this.rowNode);
            this.leftCellCtrls = this.createCellCtrls(this.leftCellCtrls, leftCols, "left");
            const rightCols = columnModel.getDisplayedRightColumnsForRow(this.rowNode);
            this.rightCellCtrls = this.createCellCtrls(this.rightCellCtrls, rightCols, "right");
        }
    }
    isCellEligibleToBeRemoved(cellCtrl, nextContainerPinned) {
        const REMOVE_CELL = true;
        const KEEP_CELL = false;
        const column = cellCtrl.getColumn();
        if (column.getPinned() != nextContainerPinned) return REMOVE_CELL;
        const editing = cellCtrl.isEditing();
        const focused = this.beans.focusService.isCellFocused(cellCtrl.getCellPosition());
        const mightWantToKeepCell = editing || focused;
        if (mightWantToKeepCell) {
            const column2 = cellCtrl.getColumn();
            const displayedColumns = this.beans.columnModel.getAllDisplayedColumns();
            const cellStillDisplayed = displayedColumns.indexOf(column2) >= 0;
            return cellStillDisplayed ? KEEP_CELL : REMOVE_CELL;
        }
        return REMOVE_CELL;
    }
    getDomOrder() {
        const isEnsureDomOrder = this.gos.get("ensureDomOrder");
        return isEnsureDomOrder || this.gos.isDomLayout("print");
    }
    listenOnDomOrder(gui) {
        const listener = ()=>{
            gui.rowComp.setDomOrder(this.getDomOrder());
        };
        this.addManagedPropertyListener("domLayout", listener);
        this.addManagedPropertyListener("ensureDomOrder", listener);
    }
    setAnimateFlags(animateIn) {
        if (this.isSticky() || !animateIn) return;
        const oldRowTopExists = $437b23f6a393c3bf$var$exists(this.rowNode.oldRowTop);
        const pinningLeft = this.beans.columnModel.isPinningLeft();
        const pinningRight = this.beans.columnModel.isPinningRight();
        if (oldRowTopExists) {
            if (this.isFullWidth() && !this.gos.get("embedFullWidthRows")) {
                this.slideInAnimation.fullWidth = true;
                return;
            }
            this.slideInAnimation.center = true;
            this.slideInAnimation.left = pinningLeft;
            this.slideInAnimation.right = pinningRight;
        } else {
            if (this.isFullWidth() && !this.gos.get("embedFullWidthRows")) {
                this.fadeInAnimation.fullWidth = true;
                return;
            }
            this.fadeInAnimation.center = true;
            this.fadeInAnimation.left = pinningLeft;
            this.fadeInAnimation.right = pinningRight;
        }
    }
    isEditing() {
        return this.editingRow;
    }
    isFullWidth() {
        return this.rowType !== "Normal" /* Normal */ ;
    }
    refreshFullWidth() {
        const tryRefresh = (gui, pinned)=>{
            if (!gui) return true;
            return gui.rowComp.refreshFullWidth(()=>{
                const compDetails = this.createFullWidthCompDetails(gui.element, pinned);
                return compDetails.params;
            });
        };
        const fullWidthSuccess = tryRefresh(this.fullWidthGui, null);
        const centerSuccess = tryRefresh(this.centerGui, null);
        const leftSuccess = tryRefresh(this.leftGui, "left");
        const rightSuccess = tryRefresh(this.rightGui, "right");
        const allFullWidthRowsRefreshed = fullWidthSuccess && centerSuccess && leftSuccess && rightSuccess;
        return allFullWidthRowsRefreshed;
    }
    addListeners() {
        this.addManagedListener(this.rowNode, $437b23f6a393c3bf$export$6af91cd58ec2edf9.EVENT_HEIGHT_CHANGED, ()=>this.onRowHeightChanged());
        this.addManagedListener(this.rowNode, $437b23f6a393c3bf$export$6af91cd58ec2edf9.EVENT_ROW_SELECTED, ()=>this.onRowSelected());
        this.addManagedListener(this.rowNode, $437b23f6a393c3bf$export$6af91cd58ec2edf9.EVENT_ROW_INDEX_CHANGED, this.onRowIndexChanged.bind(this));
        this.addManagedListener(this.rowNode, $437b23f6a393c3bf$export$6af91cd58ec2edf9.EVENT_TOP_CHANGED, this.onTopChanged.bind(this));
        this.addManagedListener(this.rowNode, $437b23f6a393c3bf$export$6af91cd58ec2edf9.EVENT_EXPANDED_CHANGED, this.updateExpandedCss.bind(this));
        this.addManagedListener(this.rowNode, $437b23f6a393c3bf$export$6af91cd58ec2edf9.EVENT_HAS_CHILDREN_CHANGED, this.updateExpandedCss.bind(this));
        if (this.rowNode.detail) this.addManagedListener(this.rowNode.parent, $437b23f6a393c3bf$export$6af91cd58ec2edf9.EVENT_DATA_CHANGED, this.onRowNodeDataChanged.bind(this));
        this.addManagedListener(this.rowNode, $437b23f6a393c3bf$export$6af91cd58ec2edf9.EVENT_DATA_CHANGED, this.onRowNodeDataChanged.bind(this));
        this.addManagedListener(this.rowNode, $437b23f6a393c3bf$export$6af91cd58ec2edf9.EVENT_CELL_CHANGED, this.postProcessCss.bind(this));
        this.addManagedListener(this.rowNode, $437b23f6a393c3bf$export$6af91cd58ec2edf9.EVENT_HIGHLIGHT_CHANGED, this.onRowNodeHighlightChanged.bind(this));
        this.addManagedListener(this.rowNode, $437b23f6a393c3bf$export$6af91cd58ec2edf9.EVENT_DRAGGING_CHANGED, this.postProcessRowDragging.bind(this));
        this.addManagedListener(this.rowNode, $437b23f6a393c3bf$export$6af91cd58ec2edf9.EVENT_UI_LEVEL_CHANGED, this.onUiLevelChanged.bind(this));
        const eventService = this.beans.eventService;
        this.addManagedListener(eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_PAGINATION_PIXEL_OFFSET_CHANGED, this.onPaginationPixelOffsetChanged.bind(this));
        this.addManagedListener(eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_HEIGHT_SCALE_CHANGED, this.onTopChanged.bind(this));
        this.addManagedListener(eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
        this.addManagedListener(eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_VIRTUAL_COLUMNS_CHANGED, this.onVirtualColumnsChanged.bind(this));
        this.addManagedListener(eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_CELL_FOCUSED, this.onCellFocusChanged.bind(this));
        this.addManagedListener(eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_CELL_FOCUS_CLEARED, this.onCellFocusChanged.bind(this));
        this.addManagedListener(eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_PAGINATION_CHANGED, this.onPaginationChanged.bind(this));
        this.addManagedListener(eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_MODEL_UPDATED, this.refreshFirstAndLastRowStyles.bind(this));
        this.addManagedListener(eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_MOVED, this.updateColumnLists.bind(this));
        this.addDestroyFunc(()=>{
            this.destroyBeans(this.rowDragComps, this.beans.context);
            if (this.tooltipFeature) this.tooltipFeature = this.destroyBean(this.tooltipFeature, this.beans.context);
        });
        this.addManagedPropertyListeners([
            "rowDragEntireRow"
        ], ()=>{
            const useRowDragEntireRow = this.gos.get("rowDragEntireRow");
            if (useRowDragEntireRow) {
                this.allRowGuis.forEach((gui)=>{
                    this.addRowDraggerToRow(gui);
                });
                return;
            }
            this.destroyBeans(this.rowDragComps, this.beans.context);
            this.rowDragComps = [];
        });
        this.addListenersForCellComps();
    }
    addListenersForCellComps() {
        this.addManagedListener(this.rowNode, $437b23f6a393c3bf$export$6af91cd58ec2edf9.EVENT_ROW_INDEX_CHANGED, ()=>{
            this.getAllCellCtrls().forEach((cellCtrl)=>cellCtrl.onRowIndexChanged());
        });
        this.addManagedListener(this.rowNode, $437b23f6a393c3bf$export$6af91cd58ec2edf9.EVENT_CELL_CHANGED, (event)=>{
            this.getAllCellCtrls().forEach((cellCtrl)=>cellCtrl.onCellChanged(event));
        });
    }
    onRowNodeDataChanged(event) {
        const fullWidthChanged = this.isFullWidth() !== !!this.rowNode.isFullWidthCell();
        if (fullWidthChanged) {
            this.beans.rowRenderer.redrawRow(this.rowNode);
            return;
        }
        if (this.isFullWidth()) {
            const refresh = this.refreshFullWidth();
            if (!refresh) this.beans.rowRenderer.redrawRow(this.rowNode);
            return;
        }
        this.getAllCellCtrls().forEach((cellCtrl)=>cellCtrl.refreshCell({
                suppressFlash: !event.update,
                newData: !event.update
            }));
        this.allRowGuis.forEach((gui)=>{
            this.setRowCompRowId(gui.rowComp);
            this.updateRowBusinessKey();
            this.setRowCompRowBusinessKey(gui.rowComp);
        });
        this.onRowSelected();
        this.postProcessCss();
    }
    postProcessCss() {
        this.setStylesFromGridOptions(true);
        this.postProcessClassesFromGridOptions();
        this.postProcessRowClassRules();
        this.postProcessRowDragging();
    }
    onRowNodeHighlightChanged() {
        const highlighted = this.rowNode.highlighted;
        this.allRowGuis.forEach((gui)=>{
            const aboveOn = highlighted === 0 /* Above */ ;
            const belowOn = highlighted === 1 /* Below */ ;
            gui.rowComp.addOrRemoveCssClass("ag-row-highlight-above", aboveOn);
            gui.rowComp.addOrRemoveCssClass("ag-row-highlight-below", belowOn);
        });
    }
    postProcessRowDragging() {
        const dragging = this.rowNode.dragging;
        this.allRowGuis.forEach((gui)=>gui.rowComp.addOrRemoveCssClass("ag-row-dragging", dragging));
    }
    updateExpandedCss() {
        const expandable = this.rowNode.isExpandable();
        const expanded = this.rowNode.expanded == true;
        this.allRowGuis.forEach((gui)=>{
            gui.rowComp.addOrRemoveCssClass("ag-row-group", expandable);
            gui.rowComp.addOrRemoveCssClass("ag-row-group-expanded", expandable && expanded);
            gui.rowComp.addOrRemoveCssClass("ag-row-group-contracted", expandable && !expanded);
            $437b23f6a393c3bf$var$setAriaExpanded(gui.element, expandable && expanded);
        });
    }
    onDisplayedColumnsChanged() {
        this.updateColumnLists(true);
        if (this.beans.columnModel.wasAutoRowHeightEverActive()) this.rowNode.checkAutoHeights();
    }
    onVirtualColumnsChanged() {
        this.updateColumnLists(false, true);
    }
    getRowPosition() {
        return {
            rowPinned: $437b23f6a393c3bf$var$makeNull(this.rowNode.rowPinned),
            rowIndex: this.rowNode.rowIndex
        };
    }
    onKeyboardNavigate(keyboardEvent) {
        const currentFullWidthComp = this.allRowGuis.find((c)=>c.element.contains(keyboardEvent.target));
        const currentFullWidthContainer = currentFullWidthComp ? currentFullWidthComp.element : null;
        const isFullWidthContainerFocused = currentFullWidthContainer === keyboardEvent.target;
        if (!isFullWidthContainerFocused) return;
        const node = this.rowNode;
        const lastFocusedCell = this.beans.focusService.getFocusedCell();
        const cellPosition = {
            rowIndex: node.rowIndex,
            rowPinned: node.rowPinned,
            column: lastFocusedCell && lastFocusedCell.column
        };
        this.beans.navigationService.navigateToNextCell(keyboardEvent, keyboardEvent.key, cellPosition, true);
        keyboardEvent.preventDefault();
    }
    onTabKeyDown(keyboardEvent) {
        if (keyboardEvent.defaultPrevented || $437b23f6a393c3bf$var$isStopPropagationForAgGrid(keyboardEvent)) return;
        const currentFullWidthComp = this.allRowGuis.find((c)=>c.element.contains(keyboardEvent.target));
        const currentFullWidthContainer = currentFullWidthComp ? currentFullWidthComp.element : null;
        const isFullWidthContainerFocused = currentFullWidthContainer === keyboardEvent.target;
        let nextEl = null;
        if (!isFullWidthContainerFocused) nextEl = this.beans.focusService.findNextFocusableElement(currentFullWidthContainer, false, keyboardEvent.shiftKey);
        if (this.isFullWidth() && isFullWidthContainerFocused || !nextEl) this.beans.navigationService.onTabKeyDown(this, keyboardEvent);
    }
    getFullWidthElement() {
        if (this.fullWidthGui) return this.fullWidthGui.element;
        return null;
    }
    getRowYPosition() {
        var _a;
        const displayedEl = (_a = this.allRowGuis.find((el)=>$437b23f6a393c3bf$var$isVisible(el.element))) == null ? void 0 : _a.element;
        if (displayedEl) return displayedEl.getBoundingClientRect().top;
        return 0;
    }
    onFullWidthRowFocused(event) {
        var _a;
        const node = this.rowNode;
        const isFocused = !event ? false : this.isFullWidth() && event.rowIndex === node.rowIndex && event.rowPinned == node.rowPinned;
        const element = this.fullWidthGui ? this.fullWidthGui.element : (_a = this.centerGui) == null ? void 0 : _a.element;
        if (!element) return;
        element.classList.toggle("ag-full-width-focus", isFocused);
        if (isFocused) element.focus({
            preventScroll: true
        });
    }
    recreateCell(cellCtrl) {
        this.centerCellCtrls = this.removeCellCtrl(this.centerCellCtrls, cellCtrl);
        this.leftCellCtrls = this.removeCellCtrl(this.leftCellCtrls, cellCtrl);
        this.rightCellCtrls = this.removeCellCtrl(this.rightCellCtrls, cellCtrl);
        cellCtrl.destroy();
        this.updateColumnLists();
    }
    removeCellCtrl(prev, cellCtrlToRemove) {
        const res = {
            list: [],
            map: {}
        };
        prev.list.forEach((cellCtrl)=>{
            if (cellCtrl === cellCtrlToRemove) return;
            res.list.push(cellCtrl);
            res.map[cellCtrl.getColumn().getInstanceId()] = cellCtrl;
        });
        return res;
    }
    onMouseEvent(eventName, mouseEvent) {
        switch(eventName){
            case "dblclick":
                this.onRowDblClick(mouseEvent);
                break;
            case "click":
                this.onRowClick(mouseEvent);
                break;
            case "touchstart":
            case "mousedown":
                this.onRowMouseDown(mouseEvent);
                break;
        }
    }
    createRowEvent(type, domEvent) {
        return this.gos.addGridCommonParams({
            type: type,
            node: this.rowNode,
            data: this.rowNode.data,
            rowIndex: this.rowNode.rowIndex,
            rowPinned: this.rowNode.rowPinned,
            event: domEvent
        });
    }
    createRowEventWithSource(type, domEvent) {
        const event = this.createRowEvent(type, domEvent);
        event.source = this;
        return event;
    }
    onRowDblClick(mouseEvent) {
        if ($437b23f6a393c3bf$var$isStopPropagationForAgGrid(mouseEvent)) return;
        const agEvent = this.createRowEventWithSource($437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_DOUBLE_CLICKED, mouseEvent);
        this.beans.eventService.dispatchEvent(agEvent);
    }
    onRowMouseDown(mouseEvent) {
        this.lastMouseDownOnDragger = $437b23f6a393c3bf$var$isElementChildOfClass(mouseEvent.target, "ag-row-drag", 3);
        if (!this.isFullWidth()) return;
        const node = this.rowNode;
        const columnModel = this.beans.columnModel;
        if (this.beans.rangeService) this.beans.rangeService.removeAllCellRanges();
        this.beans.focusService.setFocusedCell({
            rowIndex: node.rowIndex,
            column: columnModel.getAllDisplayedColumns()[0],
            rowPinned: node.rowPinned,
            forceBrowserFocus: true
        });
    }
    onRowClick(mouseEvent) {
        const stop = $437b23f6a393c3bf$var$isStopPropagationForAgGrid(mouseEvent) || this.lastMouseDownOnDragger;
        if (stop) return;
        const agEvent = this.createRowEventWithSource($437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_CLICKED, mouseEvent);
        this.beans.eventService.dispatchEvent(agEvent);
        const isMultiKey = mouseEvent.ctrlKey || mouseEvent.metaKey;
        const isShiftKey = mouseEvent.shiftKey;
        const groupSelectsChildren = this.gos.get("groupSelectsChildren");
        if (// we do not allow selecting groups by clicking (as the click here expands the group), or if it's a detail row,
        // so return if it's a group row
        groupSelectsChildren && this.rowNode.group || this.isRowSelectionBlocked() || // if click selection suppressed, do nothing
        this.gos.get("suppressRowClickSelection")) return;
        const multiSelectOnClick = this.gos.get("rowMultiSelectWithClick");
        const rowDeselectionWithCtrl = !this.gos.get("suppressRowDeselection");
        const source = "rowClicked";
        if (this.rowNode.isSelected()) {
            if (multiSelectOnClick) this.rowNode.setSelectedParams({
                newValue: false,
                event: mouseEvent,
                source: source
            });
            else if (isMultiKey) {
                if (rowDeselectionWithCtrl) this.rowNode.setSelectedParams({
                    newValue: false,
                    event: mouseEvent,
                    source: source
                });
            } else this.rowNode.setSelectedParams({
                newValue: true,
                clearSelection: !isShiftKey,
                rangeSelect: isShiftKey,
                event: mouseEvent,
                source: source
            });
        } else {
            const clearSelection = multiSelectOnClick ? false : !isMultiKey;
            this.rowNode.setSelectedParams({
                newValue: true,
                clearSelection: clearSelection,
                rangeSelect: isShiftKey,
                event: mouseEvent,
                source: source
            });
        }
    }
    isRowSelectionBlocked() {
        return !this.rowNode.selectable || !!this.rowNode.rowPinned || !this.gos.isRowSelection();
    }
    setupDetailRowAutoHeight(eDetailGui) {
        if (this.rowType !== "FullWidthDetail" /* FullWidthDetail */ ) return;
        if (!this.gos.get("detailRowAutoHeight")) return;
        const checkRowSizeFunc = ()=>{
            const clientHeight = eDetailGui.clientHeight;
            if (clientHeight != null && clientHeight > 0) {
                const updateRowHeightFunc = ()=>{
                    this.rowNode.setRowHeight(clientHeight);
                    if (this.beans.clientSideRowModel) this.beans.clientSideRowModel.onRowHeightChanged();
                    else if (this.beans.serverSideRowModel) this.beans.serverSideRowModel.onRowHeightChanged();
                };
                window.setTimeout(updateRowHeightFunc, 0);
            }
        };
        const resizeObserverDestroyFunc = this.beans.resizeObserverService.observeResize(eDetailGui, checkRowSizeFunc);
        this.addDestroyFunc(resizeObserverDestroyFunc);
        checkRowSizeFunc();
    }
    createFullWidthCompDetails(eRow, pinned) {
        const params = this.gos.addGridCommonParams({
            fullWidth: true,
            data: this.rowNode.data,
            node: this.rowNode,
            value: this.rowNode.key,
            valueFormatted: this.rowNode.key,
            rowIndex: this.rowNode.rowIndex,
            // these need to be taken out, as part of 'afterAttached' now
            eGridCell: eRow,
            eParentOfValue: eRow,
            pinned: pinned,
            addRenderedRowListener: this.addEventListener.bind(this),
            registerRowDragger: (rowDraggerElement, dragStartPixels, value, suppressVisibilityChange)=>this.addFullWidthRowDragging(rowDraggerElement, dragStartPixels, value, suppressVisibilityChange),
            setTooltip: (value, shouldDisplayTooltip)=>this.refreshRowTooltip(value, shouldDisplayTooltip)
        });
        switch(this.rowType){
            case "FullWidthDetail" /* FullWidthDetail */ :
                return this.beans.userComponentFactory.getFullWidthDetailCellRendererDetails(params);
            case "FullWidthGroup" /* FullWidthGroup */ :
                return this.beans.userComponentFactory.getFullWidthGroupCellRendererDetails(params);
            case "FullWidthLoading" /* FullWidthLoading */ :
                return this.beans.userComponentFactory.getFullWidthLoadingCellRendererDetails(params);
            default:
                return this.beans.userComponentFactory.getFullWidthCellRendererDetails(params);
        }
    }
    refreshRowTooltip(value, shouldDisplayTooltip) {
        if (!this.fullWidthGui) return;
        const tooltipParams = {
            getGui: ()=>this.fullWidthGui.element,
            getTooltipValue: ()=>value,
            getLocation: ()=>"fullWidthRow",
            shouldDisplayTooltip: shouldDisplayTooltip
        };
        if (this.tooltipFeature) this.destroyBean(this.tooltipFeature, this.beans.context);
        this.tooltipFeature = this.createBean(new $437b23f6a393c3bf$export$e5073a590d24815c(tooltipParams, this.beans));
    }
    addFullWidthRowDragging(rowDraggerElement, dragStartPixels, value = "", suppressVisibilityChange) {
        if (!this.isFullWidth()) return;
        const rowDragComp = new $437b23f6a393c3bf$var$RowDragComp(()=>value, this.rowNode, void 0, rowDraggerElement, dragStartPixels, suppressVisibilityChange);
        this.createBean(rowDragComp, this.beans.context);
        this.addDestroyFunc(()=>{
            this.destroyBean(rowDragComp, this.beans.context);
        });
    }
    onUiLevelChanged() {
        const newLevel = this.beans.rowCssClassCalculator.calculateRowLevel(this.rowNode);
        if (this.rowLevel != newLevel) {
            const classToAdd = "ag-row-level-" + newLevel;
            const classToRemove = "ag-row-level-" + this.rowLevel;
            this.allRowGuis.forEach((gui)=>{
                gui.rowComp.addOrRemoveCssClass(classToAdd, true);
                gui.rowComp.addOrRemoveCssClass(classToRemove, false);
            });
        }
        this.rowLevel = newLevel;
    }
    isFirstRowOnPage() {
        return this.rowNode.rowIndex === this.beans.paginationProxy.getPageFirstRow();
    }
    isLastRowOnPage() {
        return this.rowNode.rowIndex === this.beans.paginationProxy.getPageLastRow();
    }
    refreshFirstAndLastRowStyles() {
        const newFirst = this.isFirstRowOnPage();
        const newLast = this.isLastRowOnPage();
        if (this.firstRowOnPage !== newFirst) {
            this.firstRowOnPage = newFirst;
            this.allRowGuis.forEach((gui)=>gui.rowComp.addOrRemoveCssClass("ag-row-first", newFirst));
        }
        if (this.lastRowOnPage !== newLast) {
            this.lastRowOnPage = newLast;
            this.allRowGuis.forEach((gui)=>gui.rowComp.addOrRemoveCssClass("ag-row-last", newLast));
        }
    }
    stopEditing(cancel = false) {
        if (this.stoppingRowEdit) return;
        const cellControls = this.getAllCellCtrls();
        const isRowEdit = this.editingRow;
        this.stoppingRowEdit = true;
        let fireRowEditEvent = false;
        for (const ctrl of cellControls){
            const valueChanged = ctrl.stopEditing(cancel);
            if (isRowEdit && !cancel && !fireRowEditEvent && valueChanged) fireRowEditEvent = true;
        }
        if (fireRowEditEvent) {
            const event = this.createRowEvent($437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_VALUE_CHANGED);
            this.beans.eventService.dispatchEvent(event);
        }
        if (isRowEdit) this.setEditingRow(false);
        this.stoppingRowEdit = false;
    }
    setInlineEditingCss(editing) {
        this.allRowGuis.forEach((gui)=>{
            gui.rowComp.addOrRemoveCssClass("ag-row-inline-editing", editing);
            gui.rowComp.addOrRemoveCssClass("ag-row-not-inline-editing", !editing);
        });
    }
    setEditingRow(value) {
        this.editingRow = value;
        this.allRowGuis.forEach((gui)=>gui.rowComp.addOrRemoveCssClass("ag-row-editing", value));
        const event = value ? this.createRowEvent($437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_EDITING_STARTED) : this.createRowEvent($437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_EDITING_STOPPED);
        this.beans.eventService.dispatchEvent(event);
    }
    startRowEditing(key = null, sourceRenderedCell = null, event = null) {
        if (this.editingRow) return;
        const atLeastOneEditing = this.getAllCellCtrls().reduce((prev, cellCtrl)=>{
            const cellStartedEdit = cellCtrl === sourceRenderedCell;
            if (cellStartedEdit) cellCtrl.startEditing(key, cellStartedEdit, event);
            else cellCtrl.startEditing(null, cellStartedEdit, event);
            if (prev) return true;
            return cellCtrl.isEditing();
        }, false);
        if (atLeastOneEditing) this.setEditingRow(true);
    }
    getAllCellCtrls() {
        if (this.leftCellCtrls.list.length === 0 && this.rightCellCtrls.list.length === 0) return this.centerCellCtrls.list;
        const res = [
            ...this.centerCellCtrls.list,
            ...this.leftCellCtrls.list,
            ...this.rightCellCtrls.list
        ];
        return res;
    }
    postProcessClassesFromGridOptions() {
        const cssClasses = this.beans.rowCssClassCalculator.processClassesFromGridOptions(this.rowNode);
        if (!cssClasses || !cssClasses.length) return;
        cssClasses.forEach((classStr)=>{
            this.allRowGuis.forEach((c)=>c.rowComp.addOrRemoveCssClass(classStr, true));
        });
    }
    postProcessRowClassRules() {
        this.beans.rowCssClassCalculator.processRowClassRules(this.rowNode, (className)=>{
            this.allRowGuis.forEach((gui)=>gui.rowComp.addOrRemoveCssClass(className, true));
        }, (className)=>{
            this.allRowGuis.forEach((gui)=>gui.rowComp.addOrRemoveCssClass(className, false));
        });
    }
    setStylesFromGridOptions(updateStyles, gui) {
        if (updateStyles) this.rowStyles = this.processStylesFromGridOptions();
        this.forEachGui(gui, (gui2)=>gui2.rowComp.setUserStyles(this.rowStyles));
    }
    getPinnedForContainer(rowContainerType) {
        const pinned = rowContainerType === "left" /* LEFT */  ? "left" : rowContainerType === "right" /* RIGHT */  ? "right" : null;
        return pinned;
    }
    getInitialRowClasses(rowContainerType) {
        const pinned = this.getPinnedForContainer(rowContainerType);
        const params = {
            rowNode: this.rowNode,
            rowFocused: this.rowFocused,
            fadeRowIn: this.fadeInAnimation[rowContainerType],
            rowIsEven: this.rowNode.rowIndex % 2 === 0,
            rowLevel: this.rowLevel,
            fullWidthRow: this.isFullWidth(),
            firstRowOnPage: this.isFirstRowOnPage(),
            lastRowOnPage: this.isLastRowOnPage(),
            printLayout: this.printLayout,
            expandable: this.rowNode.isExpandable(),
            pinned: pinned
        };
        return this.beans.rowCssClassCalculator.getInitialRowClasses(params);
    }
    processStylesFromGridOptions() {
        const rowStyle = this.gos.get("rowStyle");
        if (rowStyle && typeof rowStyle === "function") {
            console.warn("AG Grid: rowStyle should be an object of key/value styles, not be a function, use getRowStyle() instead");
            return;
        }
        const rowStyleFunc = this.gos.getCallback("getRowStyle");
        let rowStyleFuncResult;
        if (rowStyleFunc) {
            const params = {
                data: this.rowNode.data,
                node: this.rowNode,
                rowIndex: this.rowNode.rowIndex
            };
            rowStyleFuncResult = rowStyleFunc(params);
        }
        if (rowStyleFuncResult || rowStyle) return Object.assign({}, rowStyle, rowStyleFuncResult);
        return this.emptyStyle;
    }
    onRowSelected(gui) {
        const selected = !!this.rowNode.isSelected();
        this.forEachGui(gui, (gui2)=>{
            gui2.rowComp.addOrRemoveCssClass("ag-row-selected", selected);
            $437b23f6a393c3bf$var$setAriaSelected(gui2.element, selected);
            const hasFocus = gui2.element.contains(this.beans.gos.getActiveDomElement());
            if (hasFocus && (gui2 === this.centerGui || gui2 === this.fullWidthGui)) this.announceDescription();
        });
    }
    announceDescription() {
        if (this.isRowSelectionBlocked()) return;
        const selected = this.rowNode.isSelected();
        if (selected && this.beans.gos.get("suppressRowDeselection")) return;
        const translate = this.beans.localeService.getLocaleTextFunc();
        const label = translate(selected ? "ariaRowDeselect" : "ariaRowSelect", `Press SPACE to ${selected ? "deselect" : "select"} this row.`);
        this.beans.ariaAnnouncementService.announceValue(label);
    }
    addHoverFunctionality(eRow) {
        if (!this.active) return;
        this.addManagedListener(eRow, "mouseenter", ()=>this.rowNode.onMouseEnter());
        this.addManagedListener(eRow, "mouseleave", ()=>this.rowNode.onMouseLeave());
        this.addManagedListener(this.rowNode, $437b23f6a393c3bf$export$6af91cd58ec2edf9.EVENT_MOUSE_ENTER, ()=>{
            if (!this.beans.dragService.isDragging() && !this.gos.get("suppressRowHoverHighlight")) {
                eRow.classList.add("ag-row-hover");
                this.rowNode.setHovered(true);
            }
        });
        this.addManagedListener(this.rowNode, $437b23f6a393c3bf$export$6af91cd58ec2edf9.EVENT_MOUSE_LEAVE, ()=>{
            eRow.classList.remove("ag-row-hover");
            this.rowNode.setHovered(false);
        });
    }
    // for animation, we don't want to animate entry or exit to a very far away pixel,
    // otherwise the row would move so fast, it would appear to disappear. so this method
    // moves the row closer to the viewport if it is far away, so the row slide in / out
    // at a speed the user can see.
    roundRowTopToBounds(rowTop) {
        const range = this.beans.ctrlsService.getGridBodyCtrl().getScrollFeature().getApproximateVScollPosition();
        const minPixel = this.applyPaginationOffset(range.top, true) - 100;
        const maxPixel = this.applyPaginationOffset(range.bottom, true) + 100;
        return Math.min(Math.max(minPixel, rowTop), maxPixel);
    }
    getFrameworkOverrides() {
        return this.beans.frameworkOverrides;
    }
    forEachGui(gui, callback) {
        if (gui) callback(gui);
        else this.allRowGuis.forEach(callback);
    }
    onRowHeightChanged(gui) {
        if (this.rowNode.rowHeight == null) return;
        const rowHeight = this.rowNode.rowHeight;
        const defaultRowHeight = this.beans.environment.getDefaultRowHeight();
        const isHeightFromFunc = this.gos.isGetRowHeightFunction();
        const heightFromFunc = isHeightFromFunc ? this.gos.getRowHeightForNode(this.rowNode).height : void 0;
        const lineHeight = heightFromFunc ? `${Math.min(defaultRowHeight, heightFromFunc) - 2}px` : void 0;
        this.forEachGui(gui, (gui2)=>{
            gui2.element.style.height = `${rowHeight}px`;
            if (lineHeight) gui2.element.style.setProperty("--ag-line-height", lineHeight);
        });
    }
    addEventListener(eventType, listener) {
        super.addEventListener(eventType, listener);
    }
    removeEventListener(eventType, listener) {
        super.removeEventListener(eventType, listener);
    }
    // note - this is NOT called by context, as we don't wire / unwire the CellComp for performance reasons.
    destroyFirstPass(suppressAnimation = false) {
        this.active = false;
        if (!suppressAnimation && this.gos.isAnimateRows() && !this.isSticky()) {
            const rowStillVisibleJustNotInViewport = this.rowNode.rowTop != null;
            if (rowStillVisibleJustNotInViewport) {
                const rowTop = this.roundRowTopToBounds(this.rowNode.rowTop);
                this.setRowTop(rowTop);
            } else this.allRowGuis.forEach((gui)=>gui.rowComp.addOrRemoveCssClass("ag-opacity-zero", true));
        }
        this.rowNode.setHovered(false);
        const event = this.createRowEvent($437b23f6a393c3bf$export$ada873a34909da65.EVENT_VIRTUAL_ROW_REMOVED);
        this.dispatchEvent(event);
        this.beans.eventService.dispatchEvent(event);
        super.destroy();
    }
    destroySecondPass() {
        this.allRowGuis.length = 0;
        this.stopEditing();
        const destroyCellCtrls = (ctrls)=>{
            ctrls.list.forEach((c)=>c.destroy());
            return {
                list: [],
                map: {}
            };
        };
        this.centerCellCtrls = destroyCellCtrls(this.centerCellCtrls);
        this.leftCellCtrls = destroyCellCtrls(this.leftCellCtrls);
        this.rightCellCtrls = destroyCellCtrls(this.rightCellCtrls);
    }
    setFocusedClasses(gui) {
        this.forEachGui(gui, (gui2)=>{
            gui2.rowComp.addOrRemoveCssClass("ag-row-focus", this.rowFocused);
            gui2.rowComp.addOrRemoveCssClass("ag-row-no-focus", !this.rowFocused);
        });
    }
    onCellFocusChanged() {
        const rowFocused = this.beans.focusService.isRowFocused(this.rowNode.rowIndex, this.rowNode.rowPinned);
        if (rowFocused !== this.rowFocused) {
            this.rowFocused = rowFocused;
            this.setFocusedClasses();
        }
        if (!rowFocused && this.editingRow) this.stopEditing(false);
    }
    onPaginationChanged() {
        const currentPage = this.beans.paginationProxy.getCurrentPage();
        if (this.paginationPage !== currentPage) {
            this.paginationPage = currentPage;
            this.onTopChanged();
        }
        this.refreshFirstAndLastRowStyles();
    }
    onTopChanged() {
        this.setRowTop(this.rowNode.rowTop);
    }
    onPaginationPixelOffsetChanged() {
        this.onTopChanged();
    }
    // applies pagination offset, eg if on second page, and page height is 500px, then removes
    // 500px from the top position, so a row with rowTop 600px is displayed at location 100px.
    // reverse will take the offset away rather than add.
    applyPaginationOffset(topPx, reverse = false) {
        if (this.rowNode.isRowPinned() || this.rowNode.sticky) return topPx;
        const pixelOffset = this.beans.paginationProxy.getPixelOffset();
        const multiplier = reverse ? 1 : -1;
        return topPx + pixelOffset * multiplier;
    }
    setRowTop(pixels) {
        if (this.printLayout) return;
        if ($437b23f6a393c3bf$var$exists(pixels)) {
            const afterPaginationPixels = this.applyPaginationOffset(pixels);
            const skipScaling = this.rowNode.isRowPinned() || this.rowNode.sticky;
            const afterScalingPixels = skipScaling ? afterPaginationPixels : this.beans.rowContainerHeightService.getRealPixelPosition(afterPaginationPixels);
            const topPx = `${afterScalingPixels}px`;
            this.setRowTopStyle(topPx);
        }
    }
    // the top needs to be set into the DOM element when the element is created, not updated afterwards.
    // otherwise the transition would not work, as it would be transitioning from zero (the unset value).
    // for example, suppose a row that is outside the viewport, then user does a filter to remove other rows
    // and this row now appears in the viewport, and the row moves up (ie it was under the viewport and not rendered,
    // but now is in the viewport) then a new RowComp is created, however it should have it's position initialised
    // to below the viewport, so the row will appear to animate up. if we didn't set the initial position at creation
    // time, the row would animate down (ie from position zero).
    getInitialRowTop(rowContainerType) {
        return this.suppressRowTransform ? this.getInitialRowTopShared(rowContainerType) : void 0;
    }
    getInitialTransform(rowContainerType) {
        return this.suppressRowTransform ? void 0 : `translateY(${this.getInitialRowTopShared(rowContainerType)})`;
    }
    getInitialRowTopShared(rowContainerType) {
        if (this.printLayout) return "";
        let rowTop;
        if (this.isSticky()) rowTop = this.rowNode.stickyRowTop;
        else {
            const pixels = this.slideInAnimation[rowContainerType] ? this.roundRowTopToBounds(this.rowNode.oldRowTop) : this.rowNode.rowTop;
            const afterPaginationPixels = this.applyPaginationOffset(pixels);
            rowTop = this.rowNode.isRowPinned() ? afterPaginationPixels : this.beans.rowContainerHeightService.getRealPixelPosition(afterPaginationPixels);
        }
        return rowTop + "px";
    }
    setRowTopStyle(topPx) {
        this.allRowGuis.forEach((gui)=>this.suppressRowTransform ? gui.rowComp.setTop(topPx) : gui.rowComp.setTransform(`translateY(${topPx})`));
    }
    getRowNode() {
        return this.rowNode;
    }
    getCellCtrl(column) {
        let res = null;
        this.getAllCellCtrls().forEach((cellCtrl)=>{
            if (cellCtrl.getColumn() == column) res = cellCtrl;
        });
        if (res != null) return res;
        this.getAllCellCtrls().forEach((cellCtrl)=>{
            if (cellCtrl.getColSpanningList().indexOf(column) >= 0) res = cellCtrl;
        });
        return res;
    }
    onRowIndexChanged() {
        if (this.rowNode.rowIndex != null) {
            this.onCellFocusChanged();
            this.updateRowIndexes();
            this.postProcessCss();
        }
    }
    getRowIndex() {
        return this.rowNode.getRowIndexString();
    }
    updateRowIndexes(gui) {
        const rowIndexStr = this.rowNode.getRowIndexString();
        const headerRowCount = this.beans.headerNavigationService.getHeaderRowCount() + this.beans.filterManager.getHeaderRowCount();
        const rowIsEven = this.rowNode.rowIndex % 2 === 0;
        const ariaRowIndex = headerRowCount + this.rowNode.rowIndex + 1;
        this.forEachGui(gui, (c)=>{
            c.rowComp.setRowIndex(rowIndexStr);
            c.rowComp.addOrRemoveCssClass("ag-row-even", rowIsEven);
            c.rowComp.addOrRemoveCssClass("ag-row-odd", !rowIsEven);
            $437b23f6a393c3bf$var$setAriaRowIndex(c.element, ariaRowIndex);
        });
    }
};
$437b23f6a393c3bf$var$_RowCtrl.DOM_DATA_KEY_ROW_CTRL = "renderedRow";
var $437b23f6a393c3bf$export$e449e57ac30326ed = $437b23f6a393c3bf$var$_RowCtrl;
// community-modules/core/src/gridBodyComp/rowContainer/rowContainerEventsFeature.ts
var $437b23f6a393c3bf$var$RowContainerEventsFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(element){
        super();
        this.element = element;
    }
    postConstruct() {
        this.addKeyboardListeners();
        this.addMouseListeners();
        this.mockContextMenuForIPad();
    }
    addKeyboardListeners() {
        const eventName = "keydown";
        const listener = this.processKeyboardEvent.bind(this, eventName);
        this.addManagedListener(this.element, eventName, listener);
    }
    addMouseListeners() {
        const mouseDownEvent = $437b23f6a393c3bf$var$isEventSupported("touchstart") ? "touchstart" : "mousedown";
        const eventNames = [
            "dblclick",
            "contextmenu",
            "mouseover",
            "mouseout",
            "click",
            mouseDownEvent
        ];
        eventNames.forEach((eventName)=>{
            const listener = this.processMouseEvent.bind(this, eventName);
            this.addManagedListener(this.element, eventName, listener);
        });
    }
    processMouseEvent(eventName, mouseEvent) {
        if (!this.mouseEventService.isEventFromThisGrid(mouseEvent) || $437b23f6a393c3bf$var$isStopPropagationForAgGrid(mouseEvent)) return;
        const rowComp = this.getRowForEvent(mouseEvent);
        const cellCtrl = this.mouseEventService.getRenderedCellForEvent(mouseEvent);
        if (eventName === "contextmenu") this.handleContextMenuMouseEvent(mouseEvent, void 0, rowComp, cellCtrl);
        else {
            if (cellCtrl) cellCtrl.onMouseEvent(eventName, mouseEvent);
            if (rowComp) rowComp.onMouseEvent(eventName, mouseEvent);
        }
    }
    mockContextMenuForIPad() {
        if (!$437b23f6a393c3bf$var$isIOSUserAgent()) return;
        const touchListener = new $437b23f6a393c3bf$export$7b2e93987414b382(this.element);
        const longTapListener = (event)=>{
            const rowComp = this.getRowForEvent(event.touchEvent);
            const cellComp = this.mouseEventService.getRenderedCellForEvent(event.touchEvent);
            this.handleContextMenuMouseEvent(void 0, event.touchEvent, rowComp, cellComp);
        };
        this.addManagedListener(touchListener, $437b23f6a393c3bf$export$7b2e93987414b382.EVENT_LONG_TAP, longTapListener);
        this.addDestroyFunc(()=>touchListener.destroy());
    }
    getRowForEvent(event) {
        let sourceElement = event.target;
        while(sourceElement){
            const rowCon = this.gos.getDomData(sourceElement, $437b23f6a393c3bf$export$e449e57ac30326ed.DOM_DATA_KEY_ROW_CTRL);
            if (rowCon) return rowCon;
            sourceElement = sourceElement.parentElement;
        }
        return null;
    }
    handleContextMenuMouseEvent(mouseEvent, touchEvent, rowComp, cellCtrl) {
        const rowNode = rowComp ? rowComp.getRowNode() : null;
        const column = cellCtrl ? cellCtrl.getColumn() : null;
        let value = null;
        if (column) {
            const event = mouseEvent ? mouseEvent : touchEvent;
            cellCtrl.dispatchCellContextMenuEvent(event != null ? event : null);
            value = this.valueService.getValue(column, rowNode);
        }
        const gridBodyCon = this.ctrlsService.getGridBodyCtrl();
        const anchorToElement = cellCtrl ? cellCtrl.getGui() : gridBodyCon.getGridBodyElement();
        this.menuService.showContextMenu({
            mouseEvent: mouseEvent,
            touchEvent: touchEvent,
            rowNode: rowNode,
            column: column,
            value: value,
            anchorToElement: anchorToElement
        });
    }
    getControlsForEventTarget(target) {
        return {
            cellCtrl: $437b23f6a393c3bf$var$getCtrlForEventTarget(this.gos, target, $437b23f6a393c3bf$export$4fd76abbfd48a7b6.DOM_DATA_KEY_CELL_CTRL),
            rowCtrl: $437b23f6a393c3bf$var$getCtrlForEventTarget(this.gos, target, $437b23f6a393c3bf$export$e449e57ac30326ed.DOM_DATA_KEY_ROW_CTRL)
        };
    }
    processKeyboardEvent(eventName, keyboardEvent) {
        const { cellCtrl: cellCtrl, rowCtrl: rowCtrl } = this.getControlsForEventTarget(keyboardEvent.target);
        if (keyboardEvent.defaultPrevented) return;
        if (cellCtrl) this.processCellKeyboardEvent(cellCtrl, eventName, keyboardEvent);
        else if (rowCtrl && rowCtrl.isFullWidth()) this.processFullWidthRowKeyboardEvent(rowCtrl, eventName, keyboardEvent);
    }
    processCellKeyboardEvent(cellCtrl, eventName, keyboardEvent) {
        const rowNode = cellCtrl.getRowNode();
        const column = cellCtrl.getColumn();
        const editing = cellCtrl.isEditing();
        const gridProcessingAllowed = !$437b23f6a393c3bf$var$isUserSuppressingKeyboardEvent(this.gos, keyboardEvent, rowNode, column, editing);
        if (gridProcessingAllowed) {
            if (eventName === "keydown") {
                const wasScrollKey = !editing && this.navigationService.handlePageScrollingKey(keyboardEvent);
                if (!wasScrollKey) cellCtrl.onKeyDown(keyboardEvent);
                this.doGridOperations(keyboardEvent, cellCtrl.isEditing());
                if ($437b23f6a393c3bf$var$isEventFromPrintableCharacter(keyboardEvent)) cellCtrl.processCharacter(keyboardEvent);
            }
        }
        if (eventName === "keydown") {
            const cellKeyDownEvent = cellCtrl.createEvent(keyboardEvent, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_CELL_KEY_DOWN);
            this.eventService.dispatchEvent(cellKeyDownEvent);
        }
    }
    processFullWidthRowKeyboardEvent(rowComp, eventName, keyboardEvent) {
        const rowNode = rowComp.getRowNode();
        const focusedCell = this.focusService.getFocusedCell();
        const column = focusedCell && focusedCell.column;
        const gridProcessingAllowed = !$437b23f6a393c3bf$var$isUserSuppressingKeyboardEvent(this.gos, keyboardEvent, rowNode, column, false);
        if (gridProcessingAllowed) {
            const key = keyboardEvent.key;
            if (eventName === "keydown") switch(key){
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_HOME:
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_END:
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_UP:
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_DOWN:
                    this.navigationService.handlePageScrollingKey(keyboardEvent, true);
                    break;
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
                    rowComp.onKeyboardNavigate(keyboardEvent);
                    break;
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB:
                    rowComp.onTabKeyDown(keyboardEvent);
                    break;
                default:
            }
        }
        if (eventName === "keydown") {
            const cellKeyDownEvent = rowComp.createRowEvent($437b23f6a393c3bf$export$ada873a34909da65.EVENT_CELL_KEY_DOWN, keyboardEvent);
            this.eventService.dispatchEvent(cellKeyDownEvent);
        }
    }
    doGridOperations(keyboardEvent, editing) {
        if (!keyboardEvent.ctrlKey && !keyboardEvent.metaKey) return;
        if (editing) return;
        if (!this.mouseEventService.isEventFromThisGrid(keyboardEvent)) return;
        const keyCode = $437b23f6a393c3bf$var$normaliseQwertyAzerty(keyboardEvent);
        if (keyCode === $437b23f6a393c3bf$export$e9e0d96f49f57c33.A) return this.onCtrlAndA(keyboardEvent);
        if (keyCode === $437b23f6a393c3bf$export$e9e0d96f49f57c33.C) return this.onCtrlAndC(keyboardEvent);
        if (keyCode === $437b23f6a393c3bf$export$e9e0d96f49f57c33.D) return this.onCtrlAndD(keyboardEvent);
        if (keyCode === $437b23f6a393c3bf$export$e9e0d96f49f57c33.V) return this.onCtrlAndV(keyboardEvent);
        if (keyCode === $437b23f6a393c3bf$export$e9e0d96f49f57c33.X) return this.onCtrlAndX(keyboardEvent);
        if (keyCode === $437b23f6a393c3bf$export$e9e0d96f49f57c33.Y) return this.onCtrlAndY();
        if (keyCode === $437b23f6a393c3bf$export$e9e0d96f49f57c33.Z) return this.onCtrlAndZ(keyboardEvent);
    }
    onCtrlAndA(event) {
        const { pinnedRowModel: pinnedRowModel, paginationProxy: paginationProxy, rangeService: rangeService } = this;
        if (rangeService && paginationProxy.isRowsToRender()) {
            const [isEmptyPinnedTop, isEmptyPinnedBottom] = [
                pinnedRowModel.isEmpty("top"),
                pinnedRowModel.isEmpty("bottom")
            ];
            const floatingStart = isEmptyPinnedTop ? null : "top";
            let floatingEnd;
            let rowEnd;
            if (isEmptyPinnedBottom) {
                floatingEnd = null;
                rowEnd = this.paginationProxy.getRowCount() - 1;
            } else {
                floatingEnd = "bottom";
                rowEnd = pinnedRowModel.getPinnedBottomRowData().length - 1;
            }
            const allDisplayedColumns = this.columnModel.getAllDisplayedColumns();
            if ($437b23f6a393c3bf$var$missingOrEmpty(allDisplayedColumns)) return;
            rangeService.setCellRange({
                rowStartIndex: 0,
                rowStartPinned: floatingStart,
                rowEndIndex: rowEnd,
                rowEndPinned: floatingEnd,
                columnStart: allDisplayedColumns[0],
                columnEnd: $437b23f6a393c3bf$var$last(allDisplayedColumns)
            });
        }
        event.preventDefault();
    }
    onCtrlAndC(event) {
        if (!this.clipboardService || this.gos.get("enableCellTextSelection")) return;
        const { cellCtrl: cellCtrl, rowCtrl: rowCtrl } = this.getControlsForEventTarget(event.target);
        if ((cellCtrl == null ? void 0 : cellCtrl.isEditing()) || (rowCtrl == null ? void 0 : rowCtrl.isEditing())) return;
        event.preventDefault();
        this.clipboardService.copyToClipboard();
    }
    onCtrlAndX(event) {
        if (!this.clipboardService || this.gos.get("enableCellTextSelection") || this.gos.get("suppressCutToClipboard")) return;
        const { cellCtrl: cellCtrl, rowCtrl: rowCtrl } = this.getControlsForEventTarget(event.target);
        if ((cellCtrl == null ? void 0 : cellCtrl.isEditing()) || (rowCtrl == null ? void 0 : rowCtrl.isEditing())) return;
        event.preventDefault();
        this.clipboardService.cutToClipboard(void 0, "ui");
    }
    onCtrlAndV(event) {
        const { cellCtrl: cellCtrl, rowCtrl: rowCtrl } = this.getControlsForEventTarget(event.target);
        if ((cellCtrl == null ? void 0 : cellCtrl.isEditing()) || (rowCtrl == null ? void 0 : rowCtrl.isEditing())) return;
        if (this.clipboardService && !this.gos.get("suppressClipboardPaste")) this.clipboardService.pasteFromClipboard();
    }
    onCtrlAndD(event) {
        if (this.clipboardService && !this.gos.get("suppressClipboardPaste")) this.clipboardService.copyRangeDown();
        event.preventDefault();
    }
    onCtrlAndZ(event) {
        if (!this.gos.get("undoRedoCellEditing")) return;
        event.preventDefault();
        if (event.shiftKey) this.undoRedoService.redo("ui");
        else this.undoRedoService.undo("ui");
    }
    onCtrlAndY() {
        this.undoRedoService.redo("ui");
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("mouseEventService")
], $437b23f6a393c3bf$var$RowContainerEventsFeature.prototype, "mouseEventService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("valueService")
], $437b23f6a393c3bf$var$RowContainerEventsFeature.prototype, "valueService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("menuService")
], $437b23f6a393c3bf$var$RowContainerEventsFeature.prototype, "menuService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("ctrlsService")
], $437b23f6a393c3bf$var$RowContainerEventsFeature.prototype, "ctrlsService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("navigationService")
], $437b23f6a393c3bf$var$RowContainerEventsFeature.prototype, "navigationService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("focusService")
], $437b23f6a393c3bf$var$RowContainerEventsFeature.prototype, "focusService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("undoRedoService")
], $437b23f6a393c3bf$var$RowContainerEventsFeature.prototype, "undoRedoService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnModel")
], $437b23f6a393c3bf$var$RowContainerEventsFeature.prototype, "columnModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("paginationProxy")
], $437b23f6a393c3bf$var$RowContainerEventsFeature.prototype, "paginationProxy", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("pinnedRowModel")
], $437b23f6a393c3bf$var$RowContainerEventsFeature.prototype, "pinnedRowModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$7acb7b24c478f9c6("rangeService")
], $437b23f6a393c3bf$var$RowContainerEventsFeature.prototype, "rangeService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$7acb7b24c478f9c6("clipboardService")
], $437b23f6a393c3bf$var$RowContainerEventsFeature.prototype, "clipboardService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$RowContainerEventsFeature.prototype, "postConstruct", 1);
// community-modules/core/src/gridBodyComp/viewportSizeFeature.ts
var $437b23f6a393c3bf$var$ViewportSizeFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(centerContainerCtrl){
        super();
        this.centerContainerCtrl = centerContainerCtrl;
    }
    postConstruct() {
        this.ctrlsService.whenReady((p)=>{
            this.gridBodyCtrl = p.gridBodyCtrl;
            this.listenForResize();
        });
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_SCROLLBAR_WIDTH_CHANGED, this.onScrollbarWidthChanged.bind(this));
        this.addManagedPropertyListeners([
            "alwaysShowHorizontalScroll",
            "alwaysShowVerticalScroll"
        ], ()=>{
            this.checkViewportAndScrolls();
        });
    }
    listenForResize() {
        const listener = ()=>this.onCenterViewportResized();
        this.centerContainerCtrl.registerViewportResizeListener(listener);
        this.gridBodyCtrl.registerBodyViewportResizeListener(listener);
    }
    onScrollbarWidthChanged() {
        this.checkViewportAndScrolls();
    }
    onCenterViewportResized() {
        if (this.centerContainerCtrl.isViewportInTheDOMTree()) {
            this.keepPinnedColumnsNarrowerThanViewport();
            this.checkViewportAndScrolls();
            const newWidth = this.centerContainerCtrl.getCenterWidth();
            if (newWidth !== this.centerWidth) {
                this.centerWidth = newWidth;
                this.columnModel.refreshFlexedColumns({
                    viewportWidth: this.centerWidth,
                    updateBodyWidths: true,
                    fireResizedEvent: true
                });
            }
        } else this.bodyHeight = 0;
    }
    keepPinnedColumnsNarrowerThanViewport() {
        const eBodyViewport = this.gridBodyCtrl.getBodyViewportElement();
        const bodyWidth = $437b23f6a393c3bf$var$getInnerWidth(eBodyViewport);
        if (bodyWidth <= 50) return;
        let columnsToRemove = this.getPinnedColumnsOverflowingViewport(bodyWidth - 50);
        const processUnpinnedColumns = this.gos.getCallback("processUnpinnedColumns");
        if (!columnsToRemove.length) return;
        if (processUnpinnedColumns) {
            const params = {
                columns: columnsToRemove,
                viewportWidth: bodyWidth
            };
            columnsToRemove = processUnpinnedColumns(params);
        }
        this.columnModel.setColumnsPinned(columnsToRemove, null, "viewportSizeFeature");
    }
    getPinnedColumnsOverflowingViewport(viewportWidth) {
        const pinnedRightWidth = this.pinnedWidthService.getPinnedRightWidth();
        const pinnedLeftWidth = this.pinnedWidthService.getPinnedLeftWidth();
        const totalPinnedWidth = pinnedRightWidth + pinnedLeftWidth;
        if (totalPinnedWidth < viewportWidth) return [];
        const pinnedLeftColumns = [
            ...this.columnModel.getDisplayedLeftColumns()
        ];
        const pinnedRightColumns = [
            ...this.columnModel.getDisplayedRightColumns()
        ];
        let indexRight = 0;
        let indexLeft = 0;
        let totalWidthRemoved = 0;
        const columnsToRemove = [];
        let spaceNecessary = totalPinnedWidth - totalWidthRemoved - viewportWidth;
        while((indexLeft < pinnedLeftColumns.length || indexRight < pinnedRightColumns.length) && spaceNecessary > 0){
            if (indexRight < pinnedRightColumns.length) {
                const currentColumn = pinnedRightColumns[indexRight++];
                spaceNecessary -= currentColumn.getActualWidth();
                columnsToRemove.push(currentColumn);
            }
            if (indexLeft < pinnedLeftColumns.length && spaceNecessary > 0) {
                const currentColumn = pinnedLeftColumns[indexLeft++];
                spaceNecessary -= currentColumn.getActualWidth();
                columnsToRemove.push(currentColumn);
            }
        }
        return columnsToRemove;
    }
    // gets called every time the viewport size changes. we use this to check visibility of scrollbars
    // in the grid panel, and also to check size and position of viewport for row and column virtualisation.
    checkViewportAndScrolls() {
        this.updateScrollVisibleService();
        this.checkBodyHeight();
        this.onHorizontalViewportChanged();
        this.gridBodyCtrl.getScrollFeature().checkScrollLeft();
    }
    getBodyHeight() {
        return this.bodyHeight;
    }
    checkBodyHeight() {
        const eBodyViewport = this.gridBodyCtrl.getBodyViewportElement();
        const bodyHeight = $437b23f6a393c3bf$var$getInnerHeight(eBodyViewport);
        if (this.bodyHeight !== bodyHeight) {
            this.bodyHeight = bodyHeight;
            const event = {
                type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_BODY_HEIGHT_CHANGED
            };
            this.eventService.dispatchEvent(event);
        }
    }
    updateScrollVisibleService() {
        this.updateScrollVisibleServiceImpl();
        setTimeout(this.updateScrollVisibleServiceImpl.bind(this), 500);
    }
    updateScrollVisibleServiceImpl() {
        const params = {
            horizontalScrollShowing: this.isHorizontalScrollShowing(),
            verticalScrollShowing: this.gridBodyCtrl.isVerticalScrollShowing()
        };
        this.scrollVisibleService.setScrollsVisible(params);
    }
    isHorizontalScrollShowing() {
        return this.centerContainerCtrl.isHorizontalScrollShowing();
    }
    // this gets called whenever a change in the viewport, so we can inform column controller it has to work
    // out the virtual columns again. gets called from following locations:
    // + ensureColVisible, scroll, init, layoutChanged, displayedColumnsChanged
    onHorizontalViewportChanged() {
        const scrollWidth = this.centerContainerCtrl.getCenterWidth();
        const scrollPosition = this.centerContainerCtrl.getViewportScrollLeft();
        this.columnModel.setViewportPosition(scrollWidth, scrollPosition);
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("ctrlsService")
], $437b23f6a393c3bf$var$ViewportSizeFeature.prototype, "ctrlsService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("pinnedWidthService")
], $437b23f6a393c3bf$var$ViewportSizeFeature.prototype, "pinnedWidthService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnModel")
], $437b23f6a393c3bf$var$ViewportSizeFeature.prototype, "columnModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("scrollVisibleService")
], $437b23f6a393c3bf$var$ViewportSizeFeature.prototype, "scrollVisibleService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$ViewportSizeFeature.prototype, "postConstruct", 1);
// community-modules/core/src/gridBodyComp/rowContainer/setPinnedLeftWidthFeature.ts
var $437b23f6a393c3bf$var$SetPinnedLeftWidthFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(element){
        super();
        this.element = element;
    }
    postConstruct() {
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_LEFT_PINNED_WIDTH_CHANGED, this.onPinnedLeftWidthChanged.bind(this));
    }
    onPinnedLeftWidthChanged() {
        const leftWidth = this.pinnedWidthService.getPinnedLeftWidth();
        const displayed = leftWidth > 0;
        $437b23f6a393c3bf$var$setDisplayed(this.element, displayed);
        $437b23f6a393c3bf$var$setFixedWidth(this.element, leftWidth);
    }
    getWidth() {
        return this.pinnedWidthService.getPinnedLeftWidth();
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("pinnedWidthService")
], $437b23f6a393c3bf$var$SetPinnedLeftWidthFeature.prototype, "pinnedWidthService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$SetPinnedLeftWidthFeature.prototype, "postConstruct", 1);
// community-modules/core/src/gridBodyComp/rowContainer/setPinnedRightWidthFeature.ts
var $437b23f6a393c3bf$var$SetPinnedRightWidthFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(element){
        super();
        this.element = element;
    }
    postConstruct() {
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_RIGHT_PINNED_WIDTH_CHANGED, this.onPinnedRightWidthChanged.bind(this));
    }
    onPinnedRightWidthChanged() {
        const rightWidth = this.pinnedWidthService.getPinnedRightWidth();
        const displayed = rightWidth > 0;
        $437b23f6a393c3bf$var$setDisplayed(this.element, displayed);
        $437b23f6a393c3bf$var$setFixedWidth(this.element, rightWidth);
    }
    getWidth() {
        return this.pinnedWidthService.getPinnedRightWidth();
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("pinnedWidthService")
], $437b23f6a393c3bf$var$SetPinnedRightWidthFeature.prototype, "pinnedWidthService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$SetPinnedRightWidthFeature.prototype, "postConstruct", 1);
// community-modules/core/src/gridBodyComp/rowContainer/setHeightFeature.ts
var $437b23f6a393c3bf$var$SetHeightFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(eContainer, eViewport){
        super();
        this.eContainer = eContainer;
        this.eViewport = eViewport;
    }
    postConstruct() {
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_CONTAINER_HEIGHT_CHANGED, this.onHeightChanged.bind(this));
    }
    onHeightChanged() {
        const height = this.maxDivHeightScaler.getUiContainerHeight();
        const heightString = height != null ? `${height}px` : ``;
        this.eContainer.style.height = heightString;
        if (this.eViewport) this.eViewport.style.height = heightString;
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowContainerHeightService")
], $437b23f6a393c3bf$var$SetHeightFeature.prototype, "maxDivHeightScaler", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$SetHeightFeature.prototype, "postConstruct", 1);
// community-modules/core/src/gridBodyComp/rowContainer/dragListenerFeature.ts
var $437b23f6a393c3bf$var$DragListenerFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(eContainer){
        super();
        this.eContainer = eContainer;
    }
    postConstruct() {
        if (!this.rangeService) return;
        this.params = {
            eElement: this.eContainer,
            onDragStart: this.rangeService.onDragStart.bind(this.rangeService),
            onDragStop: this.rangeService.onDragStop.bind(this.rangeService),
            onDragging: this.rangeService.onDragging.bind(this.rangeService)
        };
        this.addManagedPropertyListener("enableRangeSelection", (props)=>{
            const isEnabled = props.currentValue;
            if (isEnabled) {
                this.enableFeature();
                return;
            }
            this.disableFeature();
        });
        this.addDestroyFunc(()=>this.disableFeature());
        const isRangeSelection = this.gos.get("enableRangeSelection");
        if (isRangeSelection) this.enableFeature();
    }
    enableFeature() {
        this.dragService.addDragSource(this.params);
    }
    disableFeature() {
        this.dragService.removeDragSource(this.params);
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("dragService")
], $437b23f6a393c3bf$var$DragListenerFeature.prototype, "dragService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$7acb7b24c478f9c6("rangeService")
], $437b23f6a393c3bf$var$DragListenerFeature.prototype, "rangeService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$DragListenerFeature.prototype, "postConstruct", 1);
// community-modules/core/src/gridBodyComp/centerWidthFeature.ts
var $437b23f6a393c3bf$var$CenterWidthFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(callback, addSpacer = false){
        super();
        this.callback = callback;
        this.addSpacer = addSpacer;
    }
    postConstruct() {
        const listener = this.setWidth.bind(this);
        this.addManagedPropertyListener("domLayout", listener);
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_CONTAINER_WIDTH_CHANGED, listener);
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_DISPLAYED_COLUMNS_CHANGED, listener);
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_LEFT_PINNED_WIDTH_CHANGED, listener);
        if (this.addSpacer) {
            this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_RIGHT_PINNED_WIDTH_CHANGED, listener);
            this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_SCROLL_VISIBILITY_CHANGED, listener);
            this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_SCROLLBAR_WIDTH_CHANGED, listener);
        }
        this.setWidth();
    }
    setWidth() {
        const { columnModel: columnModel } = this;
        const printLayout = this.gos.isDomLayout("print");
        const centerWidth = columnModel.getBodyContainerWidth();
        const leftWidth = columnModel.getDisplayedColumnsLeftWidth();
        const rightWidth = columnModel.getDisplayedColumnsRightWidth();
        let totalWidth;
        if (printLayout) totalWidth = centerWidth + leftWidth + rightWidth;
        else {
            totalWidth = centerWidth;
            if (this.addSpacer) {
                const relevantWidth = this.gos.get("enableRtl") ? leftWidth : rightWidth;
                if (relevantWidth === 0 && this.scrollVisibleService.isVerticalScrollShowing()) totalWidth += this.gos.getScrollbarWidth();
            }
        }
        this.callback(totalWidth);
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnModel")
], $437b23f6a393c3bf$var$CenterWidthFeature.prototype, "columnModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("scrollVisibleService")
], $437b23f6a393c3bf$var$CenterWidthFeature.prototype, "scrollVisibleService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$CenterWidthFeature.prototype, "postConstruct", 1);
// community-modules/core/src/gridBodyComp/rowContainer/rowContainerCtrl.ts
var $437b23f6a393c3bf$export$6ecab00f7b310c71 = /* @__PURE__ */ ((RowContainerName2)=>{
    RowContainerName2["LEFT"] = "left";
    RowContainerName2["RIGHT"] = "right";
    RowContainerName2["CENTER"] = "center";
    RowContainerName2["FULL_WIDTH"] = "fullWidth";
    RowContainerName2["TOP_LEFT"] = "topLeft";
    RowContainerName2["TOP_RIGHT"] = "topRight";
    RowContainerName2["TOP_CENTER"] = "topCenter";
    RowContainerName2["TOP_FULL_WIDTH"] = "topFullWidth";
    RowContainerName2["STICKY_TOP_LEFT"] = "stickyTopLeft";
    RowContainerName2["STICKY_TOP_RIGHT"] = "stickyTopRight";
    RowContainerName2["STICKY_TOP_CENTER"] = "stickyTopCenter";
    RowContainerName2["STICKY_TOP_FULL_WIDTH"] = "stickyTopFullWidth";
    RowContainerName2["STICKY_BOTTOM_LEFT"] = "stickyBottomLeft";
    RowContainerName2["STICKY_BOTTOM_RIGHT"] = "stickyBottomRight";
    RowContainerName2["STICKY_BOTTOM_CENTER"] = "stickyBottomCenter";
    RowContainerName2["STICKY_BOTTOM_FULL_WIDTH"] = "stickyBottomFullWidth";
    RowContainerName2["BOTTOM_LEFT"] = "bottomLeft";
    RowContainerName2["BOTTOM_RIGHT"] = "bottomRight";
    RowContainerName2["BOTTOM_CENTER"] = "bottomCenter";
    RowContainerName2["BOTTOM_FULL_WIDTH"] = "bottomFullWidth";
    return RowContainerName2;
})($437b23f6a393c3bf$export$6ecab00f7b310c71 || {});
var $437b23f6a393c3bf$export$ef20fcc15b4eafb6 = /* @__PURE__ */ ((RowContainerType3)=>{
    RowContainerType3["LEFT"] = "left";
    RowContainerType3["RIGHT"] = "right";
    RowContainerType3["CENTER"] = "center";
    RowContainerType3["FULL_WIDTH"] = "fullWidth";
    return RowContainerType3;
})($437b23f6a393c3bf$export$ef20fcc15b4eafb6 || {});
function $437b23f6a393c3bf$export$c62f516a68da5a74(name) {
    switch(name){
        case "center" /* CENTER */ :
        case "topCenter" /* TOP_CENTER */ :
        case "stickyTopCenter" /* STICKY_TOP_CENTER */ :
        case "bottomCenter" /* BOTTOM_CENTER */ :
        case "stickyBottomCenter" /* STICKY_BOTTOM_CENTER */ :
            return "center" /* CENTER */ ;
        case "left" /* LEFT */ :
        case "topLeft" /* TOP_LEFT */ :
        case "stickyTopLeft" /* STICKY_TOP_LEFT */ :
        case "bottomLeft" /* BOTTOM_LEFT */ :
        case "stickyBottomLeft" /* STICKY_BOTTOM_LEFT */ :
            return "left" /* LEFT */ ;
        case "right" /* RIGHT */ :
        case "topRight" /* TOP_RIGHT */ :
        case "stickyTopRight" /* STICKY_TOP_RIGHT */ :
        case "bottomRight" /* BOTTOM_RIGHT */ :
        case "stickyBottomRight" /* STICKY_BOTTOM_RIGHT */ :
            return "right" /* RIGHT */ ;
        case "fullWidth" /* FULL_WIDTH */ :
        case "topFullWidth" /* TOP_FULL_WIDTH */ :
        case "stickyTopFullWidth" /* STICKY_TOP_FULL_WIDTH */ :
        case "bottomFullWidth" /* BOTTOM_FULL_WIDTH */ :
        case "stickyBottomFullWidth" /* STICKY_BOTTOM_FULL_WIDTH */ :
            return "fullWidth" /* FULL_WIDTH */ ;
        default:
            throw Error("Invalid Row Container Type");
    }
}
var $437b23f6a393c3bf$var$ContainerCssClasses = $437b23f6a393c3bf$var$convertToMap([
    [
        "center" /* CENTER */ ,
        "ag-center-cols-container"
    ],
    [
        "left" /* LEFT */ ,
        "ag-pinned-left-cols-container"
    ],
    [
        "right" /* RIGHT */ ,
        "ag-pinned-right-cols-container"
    ],
    [
        "fullWidth" /* FULL_WIDTH */ ,
        "ag-full-width-container"
    ],
    [
        "topCenter" /* TOP_CENTER */ ,
        "ag-floating-top-container"
    ],
    [
        "topLeft" /* TOP_LEFT */ ,
        "ag-pinned-left-floating-top"
    ],
    [
        "topRight" /* TOP_RIGHT */ ,
        "ag-pinned-right-floating-top"
    ],
    [
        "topFullWidth" /* TOP_FULL_WIDTH */ ,
        "ag-floating-top-full-width-container"
    ],
    [
        "stickyTopCenter" /* STICKY_TOP_CENTER */ ,
        "ag-sticky-top-container"
    ],
    [
        "stickyTopLeft" /* STICKY_TOP_LEFT */ ,
        "ag-pinned-left-sticky-top"
    ],
    [
        "stickyTopRight" /* STICKY_TOP_RIGHT */ ,
        "ag-pinned-right-sticky-top"
    ],
    [
        "stickyTopFullWidth" /* STICKY_TOP_FULL_WIDTH */ ,
        "ag-sticky-top-full-width-container"
    ],
    [
        "stickyBottomCenter" /* STICKY_BOTTOM_CENTER */ ,
        "ag-sticky-bottom-container"
    ],
    [
        "stickyBottomLeft" /* STICKY_BOTTOM_LEFT */ ,
        "ag-pinned-left-sticky-bottom"
    ],
    [
        "stickyBottomRight" /* STICKY_BOTTOM_RIGHT */ ,
        "ag-pinned-right-sticky-bottom"
    ],
    [
        "stickyBottomFullWidth" /* STICKY_BOTTOM_FULL_WIDTH */ ,
        "ag-sticky-bottom-full-width-container"
    ],
    [
        "bottomCenter" /* BOTTOM_CENTER */ ,
        "ag-floating-bottom-container"
    ],
    [
        "bottomLeft" /* BOTTOM_LEFT */ ,
        "ag-pinned-left-floating-bottom"
    ],
    [
        "bottomRight" /* BOTTOM_RIGHT */ ,
        "ag-pinned-right-floating-bottom"
    ],
    [
        "bottomFullWidth" /* BOTTOM_FULL_WIDTH */ ,
        "ag-floating-bottom-full-width-container"
    ]
]);
var $437b23f6a393c3bf$var$ViewportCssClasses = $437b23f6a393c3bf$var$convertToMap([
    [
        "center" /* CENTER */ ,
        "ag-center-cols-viewport"
    ],
    [
        "topCenter" /* TOP_CENTER */ ,
        "ag-floating-top-viewport"
    ],
    [
        "stickyTopCenter" /* STICKY_TOP_CENTER */ ,
        "ag-sticky-top-viewport"
    ],
    [
        "bottomCenter" /* BOTTOM_CENTER */ ,
        "ag-floating-bottom-viewport"
    ],
    [
        "stickyBottomCenter" /* STICKY_BOTTOM_CENTER */ ,
        "ag-sticky-bottom-viewport"
    ]
]);
var $437b23f6a393c3bf$var$_RowContainerCtrl = class _RowContainerCtrl extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(name){
        super();
        this.visible = true;
        // Maintaining a constant reference enables optimization in React.
        this.EMPTY_CTRLS = [];
        this.name = name;
        this.isFullWithContainer = this.name === "topFullWidth" /* TOP_FULL_WIDTH */  || this.name === "stickyTopFullWidth" /* STICKY_TOP_FULL_WIDTH */  || this.name === "stickyBottomFullWidth" /* STICKY_BOTTOM_FULL_WIDTH */  || this.name === "bottomFullWidth" /* BOTTOM_FULL_WIDTH */  || this.name === "fullWidth" /* FULL_WIDTH */ ;
    }
    static getRowContainerCssClasses(name) {
        const containerClass = $437b23f6a393c3bf$var$ContainerCssClasses.get(name);
        const viewportClass = $437b23f6a393c3bf$var$ViewportCssClasses.get(name);
        return {
            container: containerClass,
            viewport: viewportClass
        };
    }
    static getPinned(name) {
        switch(name){
            case "bottomLeft" /* BOTTOM_LEFT */ :
            case "topLeft" /* TOP_LEFT */ :
            case "stickyTopLeft" /* STICKY_TOP_LEFT */ :
            case "stickyBottomLeft" /* STICKY_BOTTOM_LEFT */ :
            case "left" /* LEFT */ :
                return "left";
            case "bottomRight" /* BOTTOM_RIGHT */ :
            case "topRight" /* TOP_RIGHT */ :
            case "stickyTopRight" /* STICKY_TOP_RIGHT */ :
            case "stickyBottomRight" /* STICKY_BOTTOM_RIGHT */ :
            case "right" /* RIGHT */ :
                return "right";
            default:
                return null;
        }
    }
    postConstruct() {
        this.enableRtl = this.gos.get("enableRtl");
        this.forContainers([
            "center" /* CENTER */ 
        ], ()=>this.viewportSizeFeature = this.createManagedBean(new $437b23f6a393c3bf$var$ViewportSizeFeature(this)));
    }
    registerWithCtrlsService() {
        switch(this.name){
            case "fullWidth" /* FULL_WIDTH */ :
            case "topFullWidth" /* TOP_FULL_WIDTH */ :
            case "stickyTopFullWidth" /* STICKY_TOP_FULL_WIDTH */ :
            case "bottomFullWidth" /* BOTTOM_FULL_WIDTH */ :
            case "stickyBottomFullWidth" /* STICKY_BOTTOM_FULL_WIDTH */ :
                return;
            default:
                this.ctrlsService.register(this.name, this);
        }
    }
    forContainers(names, callback) {
        if (names.indexOf(this.name) >= 0) callback();
    }
    getContainerElement() {
        return this.eContainer;
    }
    getViewportSizeFeature() {
        return this.viewportSizeFeature;
    }
    setComp(view, eContainer, eViewport) {
        this.comp = view;
        this.eContainer = eContainer;
        this.eViewport = eViewport;
        this.createManagedBean(new $437b23f6a393c3bf$var$RowContainerEventsFeature(this.eContainer));
        this.addPreventScrollWhileDragging();
        this.listenOnDomOrder();
        this.stopHScrollOnPinnedRows();
        const allTopNoFW = [
            "topCenter" /* TOP_CENTER */ ,
            "topLeft" /* TOP_LEFT */ ,
            "topRight" /* TOP_RIGHT */ 
        ];
        const allStickyTopNoFW = [
            "stickyTopCenter" /* STICKY_TOP_CENTER */ ,
            "stickyTopLeft" /* STICKY_TOP_LEFT */ ,
            "stickyTopRight" /* STICKY_TOP_RIGHT */ 
        ];
        const allStickyBottomNoFW = [
            "stickyBottomCenter" /* STICKY_BOTTOM_CENTER */ ,
            "stickyBottomLeft" /* STICKY_BOTTOM_LEFT */ ,
            "stickyBottomRight" /* STICKY_BOTTOM_RIGHT */ 
        ];
        const allBottomNoFW = [
            "bottomCenter" /* BOTTOM_CENTER */ ,
            "bottomLeft" /* BOTTOM_LEFT */ ,
            "bottomRight" /* BOTTOM_RIGHT */ 
        ];
        const allMiddleNoFW = [
            "center" /* CENTER */ ,
            "left" /* LEFT */ ,
            "right" /* RIGHT */ 
        ];
        const allNoFW = [
            ...allTopNoFW,
            ...allBottomNoFW,
            ...allMiddleNoFW,
            ...allStickyTopNoFW,
            ...allStickyBottomNoFW
        ];
        const allMiddle = [
            "center" /* CENTER */ ,
            "left" /* LEFT */ ,
            "right" /* RIGHT */ ,
            "fullWidth" /* FULL_WIDTH */ 
        ];
        const allCenter = [
            "center" /* CENTER */ ,
            "topCenter" /* TOP_CENTER */ ,
            "stickyTopCenter" /* STICKY_TOP_CENTER */ ,
            "bottomCenter" /* BOTTOM_CENTER */ ,
            "stickyBottomCenter" /* STICKY_BOTTOM_CENTER */ 
        ];
        const allLeft = [
            "left" /* LEFT */ ,
            "bottomLeft" /* BOTTOM_LEFT */ ,
            "topLeft" /* TOP_LEFT */ ,
            "stickyTopLeft" /* STICKY_TOP_LEFT */ ,
            "stickyBottomLeft" /* STICKY_BOTTOM_LEFT */ 
        ];
        const allRight = [
            "right" /* RIGHT */ ,
            "bottomRight" /* BOTTOM_RIGHT */ ,
            "topRight" /* TOP_RIGHT */ ,
            "stickyTopRight" /* STICKY_TOP_RIGHT */ ,
            "stickyBottomRight" /* STICKY_BOTTOM_RIGHT */ 
        ];
        this.forContainers(allLeft, ()=>{
            this.pinnedWidthFeature = this.createManagedBean(new $437b23f6a393c3bf$var$SetPinnedLeftWidthFeature(this.eContainer));
            this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_LEFT_PINNED_WIDTH_CHANGED, ()=>this.onPinnedWidthChanged());
        });
        this.forContainers(allRight, ()=>{
            this.pinnedWidthFeature = this.createManagedBean(new $437b23f6a393c3bf$var$SetPinnedRightWidthFeature(this.eContainer));
            this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_RIGHT_PINNED_WIDTH_CHANGED, ()=>this.onPinnedWidthChanged());
        });
        this.forContainers(allMiddle, ()=>this.createManagedBean(new $437b23f6a393c3bf$var$SetHeightFeature(this.eContainer, this.name === "center" /* CENTER */  ? eViewport : void 0)));
        this.forContainers(allNoFW, ()=>this.createManagedBean(new $437b23f6a393c3bf$var$DragListenerFeature(this.eContainer)));
        this.forContainers(allCenter, ()=>this.createManagedBean(new $437b23f6a393c3bf$var$CenterWidthFeature((width)=>this.comp.setContainerWidth(`${width}px`))));
        this.addListeners();
        this.registerWithCtrlsService();
    }
    addListeners() {
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_DISPLAYED_COLUMNS_CHANGED, ()=>this.onDisplayedColumnsChanged());
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, ()=>this.onDisplayedColumnsWidthChanged());
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_DISPLAYED_ROWS_CHANGED, (params)=>this.onDisplayedRowsChanged(params.afterScroll));
        this.onDisplayedColumnsChanged();
        this.onDisplayedColumnsWidthChanged();
        this.onDisplayedRowsChanged();
    }
    listenOnDomOrder() {
        const allStickyContainers = [
            "stickyTopCenter" /* STICKY_TOP_CENTER */ ,
            "stickyTopLeft" /* STICKY_TOP_LEFT */ ,
            "stickyTopRight" /* STICKY_TOP_RIGHT */ ,
            "stickyTopFullWidth" /* STICKY_TOP_FULL_WIDTH */ ,
            "stickyBottomCenter" /* STICKY_BOTTOM_CENTER */ ,
            "stickyBottomLeft" /* STICKY_BOTTOM_LEFT */ ,
            "stickyBottomRight" /* STICKY_BOTTOM_RIGHT */ ,
            "stickyBottomFullWidth" /* STICKY_BOTTOM_FULL_WIDTH */ 
        ];
        const isStickContainer = allStickyContainers.indexOf(this.name) >= 0;
        if (isStickContainer) {
            this.comp.setDomOrder(true);
            return;
        }
        const listener = ()=>{
            const isEnsureDomOrder = this.gos.get("ensureDomOrder");
            const isPrintLayout = this.gos.isDomLayout("print");
            this.comp.setDomOrder(isEnsureDomOrder || isPrintLayout);
        };
        this.addManagedPropertyListener("domLayout", listener);
        listener();
    }
    // when editing a pinned row, if the cell is half outside the scrollable area, the browser can
    // scroll the column into view. we do not want this, the pinned sections should never scroll.
    // so we listen to scrolls on these containers and reset the scroll if we find one.
    stopHScrollOnPinnedRows() {
        this.forContainers([
            "topCenter" /* TOP_CENTER */ ,
            "stickyTopCenter" /* STICKY_TOP_CENTER */ ,
            "bottomCenter" /* BOTTOM_CENTER */ ,
            "stickyBottomCenter" /* STICKY_BOTTOM_CENTER */ 
        ], ()=>{
            const resetScrollLeft = ()=>this.eViewport.scrollLeft = 0;
            this.addManagedListener(this.eViewport, "scroll", resetScrollLeft);
        });
    }
    onDisplayedColumnsChanged() {
        this.forContainers([
            "center" /* CENTER */ 
        ], ()=>this.onHorizontalViewportChanged());
    }
    onDisplayedColumnsWidthChanged() {
        this.forContainers([
            "center" /* CENTER */ 
        ], ()=>this.onHorizontalViewportChanged());
    }
    // this methods prevents the grid views from being scrolled while the dragService is being used
    // eg. the view should not scroll up and down while dragging rows using the rowDragComp.
    addPreventScrollWhileDragging() {
        const preventScroll = (e)=>{
            if (this.dragService.isDragging()) {
                if (e.cancelable) e.preventDefault();
            }
        };
        this.eContainer.addEventListener("touchmove", preventScroll, {
            passive: false
        });
        this.addDestroyFunc(()=>this.eContainer.removeEventListener("touchmove", preventScroll));
    }
    // this gets called whenever a change in the viewport, so we can inform column controller it has to work
    // out the virtual columns again. gets called from following locations:
    // + ensureColVisible, scroll, init, layoutChanged, displayedColumnsChanged
    onHorizontalViewportChanged(afterScroll = false) {
        const scrollWidth = this.getCenterWidth();
        const scrollPosition = this.getCenterViewportScrollLeft();
        this.columnModel.setViewportPosition(scrollWidth, scrollPosition, afterScroll);
    }
    getCenterWidth() {
        return $437b23f6a393c3bf$var$getInnerWidth(this.eViewport);
    }
    getCenterViewportScrollLeft() {
        return $437b23f6a393c3bf$var$getScrollLeft(this.eViewport, this.enableRtl);
    }
    registerViewportResizeListener(listener) {
        const unsubscribeFromResize = this.resizeObserverService.observeResize(this.eViewport, listener);
        this.addDestroyFunc(()=>unsubscribeFromResize());
    }
    isViewportInTheDOMTree() {
        return $437b23f6a393c3bf$var$isInDOM(this.eViewport);
    }
    getViewportScrollLeft() {
        return $437b23f6a393c3bf$var$getScrollLeft(this.eViewport, this.enableRtl);
    }
    isHorizontalScrollShowing() {
        const isAlwaysShowHorizontalScroll = this.gos.get("alwaysShowHorizontalScroll");
        return isAlwaysShowHorizontalScroll || $437b23f6a393c3bf$var$isHorizontalScrollShowing(this.eViewport);
    }
    getViewportElement() {
        return this.eViewport;
    }
    setContainerTranslateX(amount) {
        this.eContainer.style.transform = `translateX(${amount}px)`;
    }
    getHScrollPosition() {
        const res = {
            left: this.eViewport.scrollLeft,
            right: this.eViewport.scrollLeft + this.eViewport.offsetWidth
        };
        return res;
    }
    setCenterViewportScrollLeft(value) {
        $437b23f6a393c3bf$var$setScrollLeft(this.eViewport, value, this.enableRtl);
    }
    isContainerVisible() {
        const pinned = _RowContainerCtrl.getPinned(this.name);
        return !pinned || !!this.pinnedWidthFeature && this.pinnedWidthFeature.getWidth() > 0;
    }
    onPinnedWidthChanged() {
        const visible = this.isContainerVisible();
        if (this.visible != visible) {
            this.visible = visible;
            this.onDisplayedRowsChanged();
        }
    }
    onDisplayedRowsChanged(afterScroll = false) {
        const rows = this.getRowCtrls();
        if (!this.visible || rows.length === 0) {
            this.comp.setRowCtrls({
                rowCtrls: this.EMPTY_CTRLS
            });
            return;
        }
        const printLayout = this.gos.isDomLayout("print");
        const embedFullWidthRows = this.gos.get("embedFullWidthRows");
        const embedFW = embedFullWidthRows || printLayout;
        const rowsThisContainer = rows.filter((rowCtrl)=>{
            const fullWidthRow = rowCtrl.isFullWidth();
            const match = this.isFullWithContainer ? !embedFW && fullWidthRow : embedFW || !fullWidthRow;
            return match;
        });
        this.comp.setRowCtrls({
            rowCtrls: rowsThisContainer,
            useFlushSync: afterScroll
        });
    }
    getRowCtrls() {
        switch(this.name){
            case "topCenter" /* TOP_CENTER */ :
            case "topLeft" /* TOP_LEFT */ :
            case "topRight" /* TOP_RIGHT */ :
            case "topFullWidth" /* TOP_FULL_WIDTH */ :
                return this.rowRenderer.getTopRowCtrls();
            case "stickyTopCenter" /* STICKY_TOP_CENTER */ :
            case "stickyTopLeft" /* STICKY_TOP_LEFT */ :
            case "stickyTopRight" /* STICKY_TOP_RIGHT */ :
            case "stickyTopFullWidth" /* STICKY_TOP_FULL_WIDTH */ :
                return this.rowRenderer.getStickyTopRowCtrls();
            case "stickyBottomCenter" /* STICKY_BOTTOM_CENTER */ :
            case "stickyBottomLeft" /* STICKY_BOTTOM_LEFT */ :
            case "stickyBottomRight" /* STICKY_BOTTOM_RIGHT */ :
            case "stickyBottomFullWidth" /* STICKY_BOTTOM_FULL_WIDTH */ :
                return this.rowRenderer.getStickyBottomRowCtrls();
            case "bottomCenter" /* BOTTOM_CENTER */ :
            case "bottomLeft" /* BOTTOM_LEFT */ :
            case "bottomRight" /* BOTTOM_RIGHT */ :
            case "bottomFullWidth" /* BOTTOM_FULL_WIDTH */ :
                return this.rowRenderer.getBottomRowCtrls();
            default:
                return this.rowRenderer.getCentreRowCtrls();
        }
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("dragService")
], $437b23f6a393c3bf$var$_RowContainerCtrl.prototype, "dragService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("ctrlsService")
], $437b23f6a393c3bf$var$_RowContainerCtrl.prototype, "ctrlsService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnModel")
], $437b23f6a393c3bf$var$_RowContainerCtrl.prototype, "columnModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("resizeObserverService")
], $437b23f6a393c3bf$var$_RowContainerCtrl.prototype, "resizeObserverService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowRenderer")
], $437b23f6a393c3bf$var$_RowContainerCtrl.prototype, "rowRenderer", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$_RowContainerCtrl.prototype, "postConstruct", 1);
var $437b23f6a393c3bf$export$2d4385f6f566fe5e = $437b23f6a393c3bf$var$_RowContainerCtrl;
// community-modules/core/src/gridBodyComp/gridBodyComp.ts
var $437b23f6a393c3bf$var$GRID_BODY_TEMPLATE = /* html */ `<div class="ag-root ag-unselectable" role="treegrid">
        <ag-header-root ref="gridHeader"></ag-header-root>
        <div class="ag-floating-top" ref="eTop" role="presentation">
            <ag-row-container ref="topLeftContainer" name="${"topLeft" /* TOP_LEFT */ }"></ag-row-container>
            <ag-row-container ref="topCenterContainer" name="${"topCenter" /* TOP_CENTER */ }"></ag-row-container>
            <ag-row-container ref="topRightContainer" name="${"topRight" /* TOP_RIGHT */ }"></ag-row-container>
            <ag-row-container ref="topFullWidthContainer" name="${"topFullWidth" /* TOP_FULL_WIDTH */ }"></ag-row-container>
        </div>
        <div class="ag-body" ref="eBody" role="presentation">
            <div class="ag-body-viewport" ref="eBodyViewport" role="presentation">
                <ag-row-container ref="leftContainer" name="${"left" /* LEFT */ }"></ag-row-container>
                <ag-row-container ref="centerContainer" name="${"center" /* CENTER */ }"></ag-row-container>
                <ag-row-container ref="rightContainer" name="${"right" /* RIGHT */ }"></ag-row-container>
                <ag-row-container ref="fullWidthContainer" name="${"fullWidth" /* FULL_WIDTH */ }"></ag-row-container>
            </div>
            <ag-fake-vertical-scroll></ag-fake-vertical-scroll>
        </div>
        <div class="ag-sticky-top" ref="eStickyTop" role="presentation">
            <ag-row-container ref="stickyTopLeftContainer" name="${"stickyTopLeft" /* STICKY_TOP_LEFT */ }"></ag-row-container>
            <ag-row-container ref="stickyTopCenterContainer" name="${"stickyTopCenter" /* STICKY_TOP_CENTER */ }"></ag-row-container>
            <ag-row-container ref="stickyTopRightContainer" name="${"stickyTopRight" /* STICKY_TOP_RIGHT */ }"></ag-row-container>
            <ag-row-container ref="stickyTopFullWidthContainer" name="${"stickyTopFullWidth" /* STICKY_TOP_FULL_WIDTH */ }"></ag-row-container>
        </div>
        <div class="ag-sticky-bottom" ref="eStickyBottom" role="presentation">
            <ag-row-container ref="stickyBottomLeftContainer" name="${"stickyBottomLeft" /* STICKY_BOTTOM_LEFT */ }"></ag-row-container>
            <ag-row-container ref="stickyBottomCenterContainer" name="${"stickyBottomCenter" /* STICKY_BOTTOM_CENTER */ }"></ag-row-container>
            <ag-row-container ref="stickyBottomRightContainer" name="${"stickyBottomRight" /* STICKY_BOTTOM_RIGHT */ }"></ag-row-container>
            <ag-row-container ref="stickyBottomFullWidthContainer" name="${"stickyBottomFullWidth" /* STICKY_BOTTOM_FULL_WIDTH */ }"></ag-row-container>
        </div>
        <div class="ag-floating-bottom" ref="eBottom" role="presentation">
            <ag-row-container ref="bottomLeftContainer" name="${"bottomLeft" /* BOTTOM_LEFT */ }"></ag-row-container>
            <ag-row-container ref="bottomCenterContainer" name="${"bottomCenter" /* BOTTOM_CENTER */ }"></ag-row-container>
            <ag-row-container ref="bottomRightContainer" name="${"bottomRight" /* BOTTOM_RIGHT */ }"></ag-row-container>
            <ag-row-container ref="bottomFullWidthContainer" name="${"bottomFullWidth" /* BOTTOM_FULL_WIDTH */ }"></ag-row-container>
        </div>
        <ag-fake-horizontal-scroll></ag-fake-horizontal-scroll>
        <ag-overlay-wrapper></ag-overlay-wrapper>
    </div>`;
var $437b23f6a393c3bf$export$fb561602f10e2162 = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super($437b23f6a393c3bf$var$GRID_BODY_TEMPLATE);
    }
    init() {
        const setHeight = (height, element)=>{
            const heightString = `${height}px`;
            element.style.minHeight = heightString;
            element.style.height = heightString;
        };
        const compProxy = {
            setRowAnimationCssOnBodyViewport: (cssClass, animate)=>this.setRowAnimationCssOnBodyViewport(cssClass, animate),
            setColumnCount: (count)=>$437b23f6a393c3bf$var$setAriaColCount(this.getGui(), count),
            setRowCount: (count)=>$437b23f6a393c3bf$var$setAriaRowCount(this.getGui(), count),
            setTopHeight: (height)=>setHeight(height, this.eTop),
            setBottomHeight: (height)=>setHeight(height, this.eBottom),
            setTopDisplay: (display)=>this.eTop.style.display = display,
            setBottomDisplay: (display)=>this.eBottom.style.display = display,
            setStickyTopHeight: (height)=>this.eStickyTop.style.height = height,
            setStickyTopTop: (top)=>this.eStickyTop.style.top = top,
            setStickyTopWidth: (width)=>this.eStickyTop.style.width = width,
            setStickyBottomHeight: (height)=>this.eStickyBottom.style.height = height,
            setStickyBottomBottom: (bottom)=>this.eStickyBottom.style.bottom = bottom,
            setStickyBottomWidth: (width)=>this.eStickyBottom.style.width = width,
            setColumnMovingCss: (cssClass, flag)=>this.addOrRemoveCssClass(cssClass, flag),
            updateLayoutClasses: (cssClass, params)=>{
                const classLists = [
                    this.eBodyViewport.classList,
                    this.eBody.classList
                ];
                classLists.forEach((classList)=>{
                    classList.toggle("ag-layout-auto-height" /* AUTO_HEIGHT */ , params.autoHeight);
                    classList.toggle("ag-layout-normal" /* NORMAL */ , params.normal);
                    classList.toggle("ag-layout-print" /* PRINT */ , params.print);
                });
                this.addOrRemoveCssClass("ag-layout-auto-height" /* AUTO_HEIGHT */ , params.autoHeight);
                this.addOrRemoveCssClass("ag-layout-normal" /* NORMAL */ , params.normal);
                this.addOrRemoveCssClass("ag-layout-print" /* PRINT */ , params.print);
            },
            setAlwaysVerticalScrollClass: (cssClass, on)=>this.eBodyViewport.classList.toggle($437b23f6a393c3bf$var$CSS_CLASS_FORCE_VERTICAL_SCROLL, on),
            registerBodyViewportResizeListener: (listener)=>{
                const unsubscribeFromResize = this.resizeObserverService.observeResize(this.eBodyViewport, listener);
                this.addDestroyFunc(()=>unsubscribeFromResize());
            },
            setPinnedTopBottomOverflowY: (overflow)=>this.eTop.style.overflowY = this.eBottom.style.overflowY = overflow,
            setCellSelectableCss: (cssClass, selectable)=>{
                [
                    this.eTop,
                    this.eBodyViewport,
                    this.eBottom
                ].forEach((ct)=>ct.classList.toggle(cssClass, selectable));
            },
            setBodyViewportWidth: (width)=>this.eBodyViewport.style.width = width
        };
        this.ctrl = this.createManagedBean(new $437b23f6a393c3bf$export$8bebc3145b40d221());
        this.ctrl.setComp(compProxy, this.getGui(), this.eBodyViewport, this.eTop, this.eBottom, this.eStickyTop, this.eStickyBottom);
        if (this.rangeService && this.gos.get("enableRangeSelection") || this.gos.get("rowSelection") === "multiple") $437b23f6a393c3bf$var$setAriaMultiSelectable(this.getGui(), true);
    }
    setRowAnimationCssOnBodyViewport(cssClass, animateRows) {
        const bodyViewportClassList = this.eBodyViewport.classList;
        bodyViewportClassList.toggle("ag-row-animation" /* ANIMATION_ON */ , animateRows);
        bodyViewportClassList.toggle("ag-row-no-animation" /* ANIMATION_OFF */ , !animateRows);
    }
    getFloatingTopBottom() {
        return [
            this.eTop,
            this.eBottom
        ];
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("resizeObserverService")
], $437b23f6a393c3bf$export$fb561602f10e2162.prototype, "resizeObserverService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$7acb7b24c478f9c6("rangeService")
], $437b23f6a393c3bf$export$fb561602f10e2162.prototype, "rangeService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eBodyViewport")
], $437b23f6a393c3bf$export$fb561602f10e2162.prototype, "eBodyViewport", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eStickyTop")
], $437b23f6a393c3bf$export$fb561602f10e2162.prototype, "eStickyTop", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eStickyBottom")
], $437b23f6a393c3bf$export$fb561602f10e2162.prototype, "eStickyBottom", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eTop")
], $437b23f6a393c3bf$export$fb561602f10e2162.prototype, "eTop", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eBottom")
], $437b23f6a393c3bf$export$fb561602f10e2162.prototype, "eBottom", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("gridHeader")
], $437b23f6a393c3bf$export$fb561602f10e2162.prototype, "headerRootComp", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eBody")
], $437b23f6a393c3bf$export$fb561602f10e2162.prototype, "eBody", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$export$fb561602f10e2162.prototype, "init", 1);
// community-modules/core/src/gridBodyComp/scrollVisibleService.ts
var $437b23f6a393c3bf$export$eca0fad328f0291c = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    postConstruct() {
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, this.onDisplayedColumnsWidthChanged.bind(this));
    }
    onDisplayedColumnsChanged() {
        this.update();
    }
    onDisplayedColumnsWidthChanged() {
        this.update();
    }
    update() {
        if (this.columnAnimationService.isActive()) this.columnAnimationService.executeLaterVMTurn(()=>{
            this.columnAnimationService.executeLaterVMTurn(()=>this.updateImpl());
        });
        else this.updateImpl();
    }
    updateImpl() {
        const centerRowCtrl = this.ctrlsService.get("center");
        if (!centerRowCtrl || this.columnAnimationService.isActive()) return;
        const params = {
            horizontalScrollShowing: centerRowCtrl.isHorizontalScrollShowing(),
            verticalScrollShowing: this.isVerticalScrollShowing()
        };
        this.setScrollsVisible(params);
    }
    setScrollsVisible(params) {
        const atLeastOneDifferent = this.horizontalScrollShowing !== params.horizontalScrollShowing || this.verticalScrollShowing !== params.verticalScrollShowing;
        if (atLeastOneDifferent) {
            this.horizontalScrollShowing = params.horizontalScrollShowing;
            this.verticalScrollShowing = params.verticalScrollShowing;
            const event = {
                type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_SCROLL_VISIBILITY_CHANGED
            };
            this.eventService.dispatchEvent(event);
        }
    }
    // used by pagination service - to know page height
    isHorizontalScrollShowing() {
        return this.horizontalScrollShowing;
    }
    // used by header container
    isVerticalScrollShowing() {
        return this.verticalScrollShowing;
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("ctrlsService")
], $437b23f6a393c3bf$export$eca0fad328f0291c.prototype, "ctrlsService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnAnimationService")
], $437b23f6a393c3bf$export$eca0fad328f0291c.prototype, "columnAnimationService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$export$eca0fad328f0291c.prototype, "postConstruct", 1);
$437b23f6a393c3bf$export$eca0fad328f0291c = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("scrollVisibleService")
], $437b23f6a393c3bf$export$eca0fad328f0291c);
// community-modules/core/src/gridBodyComp/mouseEventService.ts
var $437b23f6a393c3bf$export$2e403e146bc377e1 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.gridInstanceId = $437b23f6a393c3bf$export$2e403e146bc377e1.gridInstanceSequence.next();
    }
    // we put the instance id onto the main DOM element. this is used for events, when grids are inside grids,
    // so the grid can work out if the even came from this grid or a grid inside this one. see the ctrl+v logic
    // for where this is used.
    stampTopLevelGridCompWithGridInstance(eGridDiv) {
        eGridDiv[$437b23f6a393c3bf$export$2e403e146bc377e1.GRID_DOM_KEY] = this.gridInstanceId;
    }
    getRenderedCellForEvent(event) {
        return $437b23f6a393c3bf$var$getCtrlForEventTarget(this.gos, event.target, $437b23f6a393c3bf$export$4fd76abbfd48a7b6.DOM_DATA_KEY_CELL_CTRL);
    }
    // walks the path of the event, and returns true if this grid is the first one that it finds. if doing
    // master / detail grids, and a child grid is found, then it returns false. this stops things like copy/paste
    // getting executed on many grids at the same time.
    isEventFromThisGrid(event) {
        const res = this.isElementInThisGrid(event.target);
        return res;
    }
    isElementInThisGrid(element) {
        let pointer = element;
        while(pointer){
            const instanceId = pointer[$437b23f6a393c3bf$export$2e403e146bc377e1.GRID_DOM_KEY];
            if ($437b23f6a393c3bf$var$exists(instanceId)) {
                const eventFromThisGrid = instanceId === this.gridInstanceId;
                return eventFromThisGrid;
            }
            pointer = pointer.parentElement;
        }
        return false;
    }
    getCellPositionForEvent(event) {
        const cellComp = this.getRenderedCellForEvent(event);
        return cellComp ? cellComp.getCellPosition() : null;
    }
    getNormalisedPosition(event) {
        const gridPanelHasScrolls = this.gos.isDomLayout("normal");
        const e = event;
        let x;
        let y;
        if (e.clientX != null || e.clientY != null) {
            x = e.clientX;
            y = e.clientY;
        } else {
            x = e.x;
            y = e.y;
        }
        if (gridPanelHasScrolls) {
            const gridBodyCon = this.ctrlsService.getGridBodyCtrl();
            const vRange = gridBodyCon.getScrollFeature().getVScrollPosition();
            const hRange = gridBodyCon.getScrollFeature().getHScrollPosition();
            x += hRange.left;
            y += vRange.top;
        }
        return {
            x: x,
            y: y
        };
    }
};
$437b23f6a393c3bf$export$2e403e146bc377e1.gridInstanceSequence = new $437b23f6a393c3bf$export$9bbf3cc62ef6fcad();
$437b23f6a393c3bf$export$2e403e146bc377e1.GRID_DOM_KEY = "__ag_grid_instance";
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("ctrlsService")
], $437b23f6a393c3bf$export$2e403e146bc377e1.prototype, "ctrlsService", 2);
$437b23f6a393c3bf$export$2e403e146bc377e1 = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("mouseEventService")
], $437b23f6a393c3bf$export$2e403e146bc377e1);
// community-modules/core/src/gridBodyComp/navigationService.ts
var $437b23f6a393c3bf$export$2a4aa3d46d9c7613 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super();
        this.onPageDown = $437b23f6a393c3bf$var$throttle(this.onPageDown, 100);
        this.onPageUp = $437b23f6a393c3bf$var$throttle(this.onPageUp, 100);
    }
    postConstruct() {
        this.ctrlsService.whenReady((p)=>{
            this.gridBodyCon = p.gridBodyCtrl;
        });
    }
    handlePageScrollingKey(event, fromFullWidth = false) {
        const key = event.key;
        const alt = event.altKey;
        const ctrl = event.ctrlKey || event.metaKey;
        const rangeServiceShouldHandleShift = !!this.rangeService && event.shiftKey;
        const currentCell = this.mouseEventService.getCellPositionForEvent(event);
        let processed = false;
        switch(key){
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_HOME:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_END:
                if (!ctrl && !alt) {
                    this.onHomeOrEndKey(key);
                    processed = true;
                }
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
                if (!currentCell) return false;
                if (ctrl && !alt && !rangeServiceShouldHandleShift) {
                    this.onCtrlUpDownLeftRight(key, currentCell);
                    processed = true;
                }
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_DOWN:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_UP:
                if (!ctrl && !alt) processed = this.handlePageUpDown(key, currentCell, fromFullWidth);
                break;
        }
        if (processed) event.preventDefault();
        return processed;
    }
    handlePageUpDown(key, currentCell, fromFullWidth) {
        if (fromFullWidth) currentCell = this.focusService.getFocusedCell();
        if (!currentCell) return false;
        if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_UP) this.onPageUp(currentCell);
        else this.onPageDown(currentCell);
        return true;
    }
    navigateTo(navigateParams) {
        var _a;
        const { scrollIndex: scrollIndex, scrollType: scrollType, scrollColumn: scrollColumn, focusIndex: focusIndex, focusColumn: focusColumn } = navigateParams;
        if ($437b23f6a393c3bf$var$exists(scrollColumn) && !scrollColumn.isPinned()) this.gridBodyCon.getScrollFeature().ensureColumnVisible(scrollColumn);
        if ($437b23f6a393c3bf$var$exists(scrollIndex)) this.gridBodyCon.getScrollFeature().ensureIndexVisible(scrollIndex, scrollType);
        if (!navigateParams.isAsync) this.gridBodyCon.getScrollFeature().ensureIndexVisible(focusIndex);
        this.focusService.setFocusedCell({
            rowIndex: focusIndex,
            column: focusColumn,
            rowPinned: null,
            forceBrowserFocus: true
        });
        (_a = this.rangeService) == null || _a.setRangeToCell({
            rowIndex: focusIndex,
            rowPinned: null,
            column: focusColumn
        });
    }
    // this method is throttled, see the `constructor`
    onPageDown(gridCell) {
        const gridBodyCon = this.ctrlsService.getGridBodyCtrl();
        const scrollPosition = gridBodyCon.getScrollFeature().getVScrollPosition();
        const pixelsInOnePage = this.getViewportHeight();
        const pagingPixelOffset = this.paginationProxy.getPixelOffset();
        const currentPageBottomPixel = scrollPosition.top + pixelsInOnePage;
        const currentPageBottomRow = this.paginationProxy.getRowIndexAtPixel(currentPageBottomPixel + pagingPixelOffset);
        if (this.columnModel.isAutoRowHeightActive()) this.navigateToNextPageWithAutoHeight(gridCell, currentPageBottomRow);
        else this.navigateToNextPage(gridCell, currentPageBottomRow);
    }
    // this method is throttled, see the `constructor`
    onPageUp(gridCell) {
        const gridBodyCon = this.ctrlsService.getGridBodyCtrl();
        const scrollPosition = gridBodyCon.getScrollFeature().getVScrollPosition();
        const pagingPixelOffset = this.paginationProxy.getPixelOffset();
        const currentPageTopPixel = scrollPosition.top;
        const currentPageTopRow = this.paginationProxy.getRowIndexAtPixel(currentPageTopPixel + pagingPixelOffset);
        if (this.columnModel.isAutoRowHeightActive()) this.navigateToNextPageWithAutoHeight(gridCell, currentPageTopRow, true);
        else this.navigateToNextPage(gridCell, currentPageTopRow, true);
    }
    navigateToNextPage(gridCell, scrollIndex, up = false) {
        const pixelsInOnePage = this.getViewportHeight();
        const firstRow = this.paginationProxy.getPageFirstRow();
        const lastRow = this.paginationProxy.getPageLastRow();
        const pagingPixelOffset = this.paginationProxy.getPixelOffset();
        const currentRowNode = this.paginationProxy.getRow(gridCell.rowIndex);
        const rowPixelDiff = up ? (currentRowNode == null ? void 0 : currentRowNode.rowHeight) - pixelsInOnePage - pagingPixelOffset : pixelsInOnePage - pagingPixelOffset;
        const nextCellPixel = (currentRowNode == null ? void 0 : currentRowNode.rowTop) + rowPixelDiff;
        let focusIndex = this.paginationProxy.getRowIndexAtPixel(nextCellPixel + pagingPixelOffset);
        if (focusIndex === gridCell.rowIndex) {
            const diff = up ? -1 : 1;
            scrollIndex = focusIndex = gridCell.rowIndex + diff;
        }
        let scrollType;
        if (up) {
            scrollType = "bottom";
            if (focusIndex < firstRow) focusIndex = firstRow;
            if (scrollIndex < firstRow) scrollIndex = firstRow;
        } else {
            scrollType = "top";
            if (focusIndex > lastRow) focusIndex = lastRow;
            if (scrollIndex > lastRow) scrollIndex = lastRow;
        }
        if (this.isRowTallerThanView(focusIndex)) {
            scrollIndex = focusIndex;
            scrollType = "top";
        }
        this.navigateTo({
            scrollIndex: scrollIndex,
            scrollType: scrollType,
            scrollColumn: null,
            focusIndex: focusIndex,
            focusColumn: gridCell.column
        });
    }
    navigateToNextPageWithAutoHeight(gridCell, scrollIndex, up = false) {
        this.navigateTo({
            scrollIndex: scrollIndex,
            scrollType: up ? "bottom" : "top",
            scrollColumn: null,
            focusIndex: scrollIndex,
            focusColumn: gridCell.column
        });
        setTimeout(()=>{
            const focusIndex = this.getNextFocusIndexForAutoHeight(gridCell, up);
            this.navigateTo({
                scrollIndex: scrollIndex,
                scrollType: up ? "bottom" : "top",
                scrollColumn: null,
                focusIndex: focusIndex,
                focusColumn: gridCell.column,
                isAsync: true
            });
        }, 50);
    }
    getNextFocusIndexForAutoHeight(gridCell, up = false) {
        var _a;
        const step = up ? -1 : 1;
        const pixelsInOnePage = this.getViewportHeight();
        const lastRowIndex = this.paginationProxy.getPageLastRow();
        let pixelSum = 0;
        let currentIndex = gridCell.rowIndex;
        while(currentIndex >= 0 && currentIndex <= lastRowIndex){
            const currentCell = this.paginationProxy.getRow(currentIndex);
            if (currentCell) {
                const currentCellHeight = (_a = currentCell.rowHeight) != null ? _a : 0;
                if (pixelSum + currentCellHeight > pixelsInOnePage) break;
                pixelSum += currentCellHeight;
            }
            currentIndex += step;
        }
        return Math.max(0, Math.min(currentIndex, lastRowIndex));
    }
    getViewportHeight() {
        const { gridBodyCtrl: gridBodyCtrl, center: center } = this.ctrlsService.getParams();
        const scrollPosition = gridBodyCtrl.getScrollFeature().getVScrollPosition();
        const scrollbarWidth = this.gos.getScrollbarWidth();
        let pixelsInOnePage = scrollPosition.bottom - scrollPosition.top;
        if (center.isHorizontalScrollShowing()) pixelsInOnePage -= scrollbarWidth;
        return pixelsInOnePage;
    }
    isRowTallerThanView(rowIndex) {
        const rowNode = this.paginationProxy.getRow(rowIndex);
        if (!rowNode) return false;
        const rowHeight = rowNode.rowHeight;
        if (typeof rowHeight !== "number") return false;
        return rowHeight > this.getViewportHeight();
    }
    onCtrlUpDownLeftRight(key, gridCell) {
        const cellToFocus = this.cellNavigationService.getNextCellToFocus(key, gridCell, true);
        const { rowIndex: rowIndex, column: column } = cellToFocus;
        this.navigateTo({
            scrollIndex: rowIndex,
            scrollType: null,
            scrollColumn: column,
            focusIndex: rowIndex,
            focusColumn: column
        });
    }
    // home brings focus to top left cell, end brings focus to bottom right, grid scrolled to bring
    // same cell into view (which means either scroll all the way up, or all the way down).
    onHomeOrEndKey(key) {
        const homeKey = key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_HOME;
        const allColumns = this.columnModel.getAllDisplayedColumns();
        const columnToSelect = homeKey ? allColumns[0] : $437b23f6a393c3bf$var$last(allColumns);
        const scrollIndex = homeKey ? this.paginationProxy.getPageFirstRow() : this.paginationProxy.getPageLastRow();
        this.navigateTo({
            scrollIndex: scrollIndex,
            scrollType: null,
            scrollColumn: columnToSelect,
            focusIndex: scrollIndex,
            focusColumn: columnToSelect
        });
    }
    // result of keyboard event
    onTabKeyDown(previous, keyboardEvent) {
        const backwards = keyboardEvent.shiftKey;
        const movedToNextCell = this.tabToNextCellCommon(previous, backwards, keyboardEvent);
        if (movedToNextCell !== false) {
            if (movedToNextCell) keyboardEvent.preventDefault();
            return;
        }
        if (backwards) {
            const { rowIndex: rowIndex, rowPinned: rowPinned } = previous.getRowPosition();
            const firstRow = rowPinned ? rowIndex === 0 : rowIndex === this.paginationProxy.getPageFirstRow();
            if (firstRow) {
                if (this.gos.get("headerHeight") === 0 || this.gos.get("suppressHeaderFocus")) this.focusService.focusNextGridCoreContainer(true, true);
                else {
                    keyboardEvent.preventDefault();
                    this.focusService.focusPreviousFromFirstCell(keyboardEvent);
                }
            }
        } else {
            if (previous instanceof $437b23f6a393c3bf$export$4fd76abbfd48a7b6) previous.focusCell(true);
            if (this.focusService.focusNextGridCoreContainer(backwards)) keyboardEvent.preventDefault();
        }
    }
    // comes from API
    tabToNextCell(backwards, event) {
        const focusedCell = this.focusService.getFocusedCell();
        if (!focusedCell) return false;
        let cellOrRow = this.getCellByPosition(focusedCell);
        if (!cellOrRow) {
            cellOrRow = this.rowRenderer.getRowByPosition(focusedCell);
            if (!cellOrRow || !cellOrRow.isFullWidth()) return false;
        }
        return !!this.tabToNextCellCommon(cellOrRow, backwards, event);
    }
    tabToNextCellCommon(previous, backwards, event) {
        let editing = previous.isEditing();
        if (!editing && previous instanceof $437b23f6a393c3bf$export$4fd76abbfd48a7b6) {
            const cell = previous;
            const row = cell.getRowCtrl();
            if (row) editing = row.isEditing();
        }
        let res;
        if (editing) {
            if (this.gos.get("editType") === "fullRow") res = this.moveToNextEditingRow(previous, backwards, event);
            else res = this.moveToNextEditingCell(previous, backwards, event);
        } else res = this.moveToNextCellNotEditing(previous, backwards);
        if (res === null) return res;
        return res || !!this.focusService.getFocusedHeader();
    }
    // returns null if no navigation should be performed
    moveToNextEditingCell(previousCell, backwards, event = null) {
        const previousPos = previousCell.getCellPosition();
        previousCell.getGui().focus();
        previousCell.stopEditing();
        const nextCell = this.findNextCellToFocusOn(previousPos, backwards, true);
        if (nextCell === false) return null;
        if (nextCell == null) return false;
        nextCell.startEditing(null, true, event);
        nextCell.focusCell(false);
        return true;
    }
    // returns null if no navigation should be performed
    moveToNextEditingRow(previousCell, backwards, event = null) {
        const previousPos = previousCell.getCellPosition();
        const nextCell = this.findNextCellToFocusOn(previousPos, backwards, true);
        if (nextCell === false) return null;
        if (nextCell == null) return false;
        const nextPos = nextCell.getCellPosition();
        const previousEditable = this.isCellEditable(previousPos);
        const nextEditable = this.isCellEditable(nextPos);
        const rowsMatch = nextPos && previousPos.rowIndex === nextPos.rowIndex && previousPos.rowPinned === nextPos.rowPinned;
        if (previousEditable) previousCell.setFocusOutOnEditor();
        if (!rowsMatch) {
            const pRow = previousCell.getRowCtrl();
            pRow.stopEditing();
            const nRow = nextCell.getRowCtrl();
            nRow.startRowEditing(void 0, void 0, event);
        }
        if (nextEditable) {
            nextCell.setFocusInOnEditor();
            nextCell.focusCell();
        } else nextCell.focusCell(true);
        return true;
    }
    // returns null if no navigation should be performed
    moveToNextCellNotEditing(previousCell, backwards) {
        const displayedColumns = this.columnModel.getAllDisplayedColumns();
        let cellPos;
        if (previousCell instanceof $437b23f6a393c3bf$export$e449e57ac30326ed) cellPos = $437b23f6a393c3bf$var$__spreadProps($437b23f6a393c3bf$var$__spreadValues({}, previousCell.getRowPosition()), {
            column: backwards ? displayedColumns[0] : $437b23f6a393c3bf$var$last(displayedColumns)
        });
        else cellPos = previousCell.getCellPosition();
        const nextCell = this.findNextCellToFocusOn(cellPos, backwards, false);
        if (nextCell === false) return null;
        if (nextCell instanceof $437b23f6a393c3bf$export$4fd76abbfd48a7b6) nextCell.focusCell(true);
        else if (nextCell) return this.tryToFocusFullWidthRow(nextCell.getRowPosition(), backwards);
        return $437b23f6a393c3bf$var$exists(nextCell);
    }
    /**
   * called by the cell, when tab is pressed while editing.
   * @return: RenderedCell when navigation successful, false if navigation should not be performed, otherwise null
   */ findNextCellToFocusOn(previousPosition, backwards, startEditing) {
        var _a;
        let nextPosition = previousPosition;
        while(true){
            if (previousPosition !== nextPosition) previousPosition = nextPosition;
            if (!backwards) nextPosition = this.getLastCellOfColSpan(nextPosition);
            nextPosition = this.cellNavigationService.getNextTabbedCell(nextPosition, backwards);
            const userFunc = this.gos.getCallback("tabToNextCell");
            if ($437b23f6a393c3bf$var$exists(userFunc)) {
                const params = {
                    backwards: backwards,
                    editing: startEditing,
                    previousCellPosition: previousPosition,
                    nextCellPosition: nextPosition ? nextPosition : null
                };
                const userResult = userFunc(params);
                if (userResult === true || userResult === null) {
                    if (userResult === null) $437b23f6a393c3bf$var$warnOnce("Returning `null` from tabToNextCell is deprecated. Return `true` to stay on the current cell, or `false` to let the browser handle the tab behaviour.");
                    nextPosition = previousPosition;
                } else if (userResult === false) return false;
                else {
                    if (userResult.floating) {
                        $437b23f6a393c3bf$var$warnOnce(`tabToNextCellFunc return type should have attributes: rowIndex, rowPinned, column. However you had 'floating', maybe you meant 'rowPinned'?`);
                        userResult.rowPinned = userResult.floating;
                    }
                    nextPosition = {
                        rowIndex: userResult.rowIndex,
                        column: userResult.column,
                        rowPinned: userResult.rowPinned
                    };
                }
            }
            if (!nextPosition) return null;
            if (nextPosition.rowIndex < 0) {
                const headerLen = this.headerNavigationService.getHeaderRowCount();
                this.focusService.focusHeaderPosition({
                    headerPosition: {
                        headerRowIndex: headerLen + nextPosition.rowIndex,
                        column: nextPosition.column
                    },
                    fromCell: true
                });
                return null;
            }
            const fullRowEdit = this.gos.get("editType") === "fullRow";
            if (startEditing && !fullRowEdit) {
                const cellIsEditable = this.isCellEditable(nextPosition);
                if (!cellIsEditable) continue;
            }
            this.ensureCellVisible(nextPosition);
            const nextCell = this.getCellByPosition(nextPosition);
            if (!nextCell) {
                const row = this.rowRenderer.getRowByPosition(nextPosition);
                if (!row || !row.isFullWidth() || startEditing) continue;
                return row;
            }
            if (nextCell.isSuppressNavigable()) continue;
            (_a = this.rangeService) == null || _a.setRangeToCell(nextPosition);
            return nextCell;
        }
    }
    isCellEditable(cell) {
        const rowNode = this.lookupRowNodeForCell(cell);
        if (rowNode) return cell.column.isCellEditable(rowNode);
        return false;
    }
    getCellByPosition(cellPosition) {
        const rowCtrl = this.rowRenderer.getRowByPosition(cellPosition);
        if (!rowCtrl) return null;
        return rowCtrl.getCellCtrl(cellPosition.column);
    }
    lookupRowNodeForCell(cell) {
        if (cell.rowPinned === "top") return this.pinnedRowModel.getPinnedTopRow(cell.rowIndex);
        if (cell.rowPinned === "bottom") return this.pinnedRowModel.getPinnedBottomRow(cell.rowIndex);
        return this.paginationProxy.getRow(cell.rowIndex);
    }
    // we use index for rows, but column object for columns, as the next column (by index) might not
    // be visible (header grouping) so it's not reliable, so using the column object instead.
    navigateToNextCell(event, key, currentCell, allowUserOverride) {
        let nextCell = currentCell;
        let hitEdgeOfGrid = false;
        while(nextCell && (nextCell === currentCell || !this.isValidNavigateCell(nextCell))){
            if (this.gos.get("enableRtl")) {
                if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT) nextCell = this.getLastCellOfColSpan(nextCell);
            } else if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT) nextCell = this.getLastCellOfColSpan(nextCell);
            nextCell = this.cellNavigationService.getNextCellToFocus(key, nextCell);
            hitEdgeOfGrid = $437b23f6a393c3bf$var$missing(nextCell);
        }
        if (hitEdgeOfGrid && event && event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP) nextCell = {
            rowIndex: -1,
            rowPinned: null,
            column: currentCell.column
        };
        if (allowUserOverride) {
            const userFunc = this.gos.getCallback("navigateToNextCell");
            if ($437b23f6a393c3bf$var$exists(userFunc)) {
                const params = {
                    key: key,
                    previousCellPosition: currentCell,
                    nextCellPosition: nextCell ? nextCell : null,
                    event: event
                };
                const userCell = userFunc(params);
                if ($437b23f6a393c3bf$var$exists(userCell)) {
                    if (userCell.floating) {
                        $437b23f6a393c3bf$var$warnOnce(`tabToNextCellFunc return type should have attributes: rowIndex, rowPinned, column. However you had 'floating', maybe you meant 'rowPinned'?`);
                        userCell.rowPinned = userCell.floating;
                    }
                    nextCell = {
                        rowPinned: userCell.rowPinned,
                        rowIndex: userCell.rowIndex,
                        column: userCell.column
                    };
                } else nextCell = null;
            }
        }
        if (!nextCell) return;
        if (nextCell.rowIndex < 0) {
            const headerLen = this.headerNavigationService.getHeaderRowCount();
            this.focusService.focusHeaderPosition({
                headerPosition: {
                    headerRowIndex: headerLen + nextCell.rowIndex,
                    column: currentCell.column
                },
                event: event || void 0,
                fromCell: true
            });
            return;
        }
        const normalisedPosition = this.getNormalisedPosition(nextCell);
        if (normalisedPosition) this.focusPosition(normalisedPosition);
        else this.tryToFocusFullWidthRow(nextCell);
    }
    getNormalisedPosition(cellPosition) {
        this.ensureCellVisible(cellPosition);
        const cellCtrl = this.getCellByPosition(cellPosition);
        if (!cellCtrl) return null;
        cellPosition = cellCtrl.getCellPosition();
        this.ensureCellVisible(cellPosition);
        return cellPosition;
    }
    tryToFocusFullWidthRow(position, backwards = false) {
        const displayedColumns = this.columnModel.getAllDisplayedColumns();
        const rowComp = this.rowRenderer.getRowByPosition(position);
        if (!rowComp || !rowComp.isFullWidth()) return false;
        const currentCellFocused = this.focusService.getFocusedCell();
        const cellPosition = {
            rowIndex: position.rowIndex,
            rowPinned: position.rowPinned,
            column: position.column || (backwards ? $437b23f6a393c3bf$var$last(displayedColumns) : displayedColumns[0])
        };
        this.focusPosition(cellPosition);
        const fromBelow = currentCellFocused != null ? this.rowPositionUtils.before(cellPosition, currentCellFocused) : false;
        const focusEvent = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_FULL_WIDTH_ROW_FOCUSED,
            rowIndex: cellPosition.rowIndex,
            rowPinned: cellPosition.rowPinned,
            column: cellPosition.column,
            isFullWidthCell: true,
            floating: cellPosition.rowPinned,
            fromBelow: fromBelow
        };
        this.eventService.dispatchEvent(focusEvent);
        return true;
    }
    focusPosition(cellPosition) {
        var _a;
        this.focusService.setFocusedCell({
            rowIndex: cellPosition.rowIndex,
            column: cellPosition.column,
            rowPinned: cellPosition.rowPinned,
            forceBrowserFocus: true
        });
        (_a = this.rangeService) == null || _a.setRangeToCell(cellPosition);
    }
    isValidNavigateCell(cell) {
        const rowNode = this.rowPositionUtils.getRowNode(cell);
        return !!rowNode;
    }
    getLastCellOfColSpan(cell) {
        const cellCtrl = this.getCellByPosition(cell);
        if (!cellCtrl) return cell;
        const colSpanningList = cellCtrl.getColSpanningList();
        if (colSpanningList.length === 1) return cell;
        return {
            rowIndex: cell.rowIndex,
            column: $437b23f6a393c3bf$var$last(colSpanningList),
            rowPinned: cell.rowPinned
        };
    }
    ensureCellVisible(gridCell) {
        const isGroupStickyEnabled = this.gos.isGroupRowsSticky();
        const rowNode = this.rowModel.getRow(gridCell.rowIndex);
        const skipScrollToRow = isGroupStickyEnabled && (rowNode == null ? void 0 : rowNode.sticky);
        if (!skipScrollToRow && $437b23f6a393c3bf$var$missing(gridCell.rowPinned)) this.gridBodyCon.getScrollFeature().ensureIndexVisible(gridCell.rowIndex);
        if (!gridCell.column.isPinned()) this.gridBodyCon.getScrollFeature().ensureColumnVisible(gridCell.column);
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("mouseEventService")
], $437b23f6a393c3bf$export$2a4aa3d46d9c7613.prototype, "mouseEventService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("paginationProxy")
], $437b23f6a393c3bf$export$2a4aa3d46d9c7613.prototype, "paginationProxy", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("focusService")
], $437b23f6a393c3bf$export$2a4aa3d46d9c7613.prototype, "focusService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnModel")
], $437b23f6a393c3bf$export$2a4aa3d46d9c7613.prototype, "columnModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowModel")
], $437b23f6a393c3bf$export$2a4aa3d46d9c7613.prototype, "rowModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("ctrlsService")
], $437b23f6a393c3bf$export$2a4aa3d46d9c7613.prototype, "ctrlsService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowRenderer")
], $437b23f6a393c3bf$export$2a4aa3d46d9c7613.prototype, "rowRenderer", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("headerNavigationService")
], $437b23f6a393c3bf$export$2a4aa3d46d9c7613.prototype, "headerNavigationService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowPositionUtils")
], $437b23f6a393c3bf$export$2a4aa3d46d9c7613.prototype, "rowPositionUtils", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("cellNavigationService")
], $437b23f6a393c3bf$export$2a4aa3d46d9c7613.prototype, "cellNavigationService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("pinnedRowModel")
], $437b23f6a393c3bf$export$2a4aa3d46d9c7613.prototype, "pinnedRowModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$7acb7b24c478f9c6("rangeService")
], $437b23f6a393c3bf$export$2a4aa3d46d9c7613.prototype, "rangeService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$export$2a4aa3d46d9c7613.prototype, "postConstruct", 1);
$437b23f6a393c3bf$export$2a4aa3d46d9c7613 = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("navigationService")
], $437b23f6a393c3bf$export$2a4aa3d46d9c7613);
// community-modules/core/src/rendering/cellEditors/popupEditorWrapper.ts
var $437b23f6a393c3bf$var$_PopupEditorWrapper = class _PopupEditorWrapper extends $437b23f6a393c3bf$export$9fac2d040f3ed438 {
    constructor(params){
        super(/* html */ `<div class="ag-popup-editor" tabindex="-1"/>`);
        this.params = params;
    }
    postConstruct() {
        this.gos.setDomData(this.getGui(), _PopupEditorWrapper.DOM_KEY_POPUP_EDITOR_WRAPPER, true);
        this.addKeyDownListener();
    }
    addKeyDownListener() {
        const eGui = this.getGui();
        const params = this.params;
        const listener = (event)=>{
            if (!$437b23f6a393c3bf$var$isUserSuppressingKeyboardEvent(this.gos, event, params.node, params.column, true)) params.onKeyDown(event);
        };
        this.addManagedListener(eGui, "keydown", listener);
    }
};
$437b23f6a393c3bf$var$_PopupEditorWrapper.DOM_KEY_POPUP_EDITOR_WRAPPER = "popupEditorWrapper";
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$_PopupEditorWrapper.prototype, "postConstruct", 1);
var $437b23f6a393c3bf$export$fdd61bfa9577e25 = $437b23f6a393c3bf$var$_PopupEditorWrapper;
// community-modules/core/src/rendering/cell/cellComp.ts
var $437b23f6a393c3bf$export$e59215a9594b9f01 = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(beans, cellCtrl, printLayout, eRow, editingRow){
        super();
        // every time we go into edit mode, or back again, this gets incremented.
        // it's the components way of dealing with the async nature of framework components,
        // so if a framework component takes a while to be created, we know if the object
        // is still relevant when creating is finished. eg we could click edit / un-edit 20
        // times before the first React edit component comes back - we should discard
        // the first 19.
        this.rendererVersion = 0;
        this.editorVersion = 0;
        this.beans = beans;
        this.column = cellCtrl.getColumn();
        this.rowNode = cellCtrl.getRowNode();
        this.rowCtrl = cellCtrl.getRowCtrl();
        this.eRow = eRow;
        this.cellCtrl = cellCtrl;
        const cellDiv = document.createElement("div");
        cellDiv.setAttribute("comp-id", `${this.getCompId()}`);
        this.setTemplateFromElement(cellDiv);
        const eGui = this.getGui();
        this.forceWrapper = cellCtrl.isForceWrapper();
        this.refreshWrapper(false);
        const setAttribute = (name, value)=>{
            if (value != null && value != "") eGui.setAttribute(name, value);
            else eGui.removeAttribute(name);
        };
        $437b23f6a393c3bf$var$setAriaRole(eGui, cellCtrl.getCellAriaRole());
        setAttribute("col-id", cellCtrl.getColumnIdSanitised());
        const tabIndex = cellCtrl.getTabIndex();
        if (tabIndex !== void 0) setAttribute("tabindex", tabIndex.toString());
        const compProxy = {
            addOrRemoveCssClass: (cssClassName, on)=>this.addOrRemoveCssClass(cssClassName, on),
            setUserStyles: (styles)=>$437b23f6a393c3bf$var$addStylesToElement(eGui, styles),
            getFocusableElement: ()=>this.getFocusableElement(),
            setIncludeSelection: (include)=>this.includeSelection = include,
            setIncludeRowDrag: (include)=>this.includeRowDrag = include,
            setIncludeDndSource: (include)=>this.includeDndSource = include,
            setRenderDetails: (compDetails, valueToDisplay, force)=>this.setRenderDetails(compDetails, valueToDisplay, force),
            setEditDetails: (compDetails, popup, position)=>this.setEditDetails(compDetails, popup, position),
            getCellEditor: ()=>this.cellEditor || null,
            getCellRenderer: ()=>this.cellRenderer || null,
            getParentOfValue: ()=>this.getParentOfValue()
        };
        cellCtrl.setComp(compProxy, this.getGui(), this.eCellWrapper, printLayout, editingRow);
    }
    getParentOfValue() {
        if (this.eCellValue) return this.eCellValue;
        if (this.eCellWrapper) return this.eCellWrapper;
        return this.getGui();
    }
    setRenderDetails(compDetails, valueToDisplay, forceNewCellRendererInstance) {
        const isInlineEditing = this.cellEditor && !this.cellEditorPopupWrapper;
        if (isInlineEditing) return;
        this.firstRender = this.firstRender == null;
        const controlWrapperChanged = this.refreshWrapper(false);
        this.refreshEditStyles(false);
        if (compDetails) {
            const neverRefresh = forceNewCellRendererInstance || controlWrapperChanged;
            const cellRendererRefreshSuccessful = neverRefresh ? false : this.refreshCellRenderer(compDetails);
            if (!cellRendererRefreshSuccessful) {
                this.destroyRenderer();
                this.createCellRendererInstance(compDetails);
            }
        } else {
            this.destroyRenderer();
            this.insertValueWithoutCellRenderer(valueToDisplay);
        }
    }
    setEditDetails(compDetails, popup, position) {
        if (compDetails) this.createCellEditorInstance(compDetails, popup, position);
        else this.destroyEditor();
    }
    removeControls() {
        this.checkboxSelectionComp = this.beans.context.destroyBean(this.checkboxSelectionComp);
        this.dndSourceComp = this.beans.context.destroyBean(this.dndSourceComp);
        this.rowDraggingComp = this.beans.context.destroyBean(this.rowDraggingComp);
    }
    // returns true if wrapper was changed
    refreshWrapper(editing) {
        const providingControls = this.includeRowDrag || this.includeDndSource || this.includeSelection;
        const usingWrapper = providingControls || this.forceWrapper;
        const putWrapperIn = usingWrapper && this.eCellWrapper == null;
        if (putWrapperIn) {
            const wrapperDiv = document.createElement("div");
            wrapperDiv.setAttribute("role", "presentation");
            wrapperDiv.setAttribute("class", "ag-cell-wrapper");
            this.eCellWrapper = wrapperDiv;
            this.getGui().appendChild(this.eCellWrapper);
        }
        const takeWrapperOut = !usingWrapper && this.eCellWrapper != null;
        if (takeWrapperOut) {
            $437b23f6a393c3bf$var$removeFromParent(this.eCellWrapper);
            this.eCellWrapper = void 0;
        }
        this.addOrRemoveCssClass("ag-cell-value", !usingWrapper);
        const usingCellValue = !editing && usingWrapper;
        const putCellValueIn = usingCellValue && this.eCellValue == null;
        if (putCellValueIn) {
            const cellSpan = document.createElement("span");
            cellSpan.setAttribute("role", "presentation");
            cellSpan.setAttribute("class", "ag-cell-value");
            this.eCellValue = cellSpan;
            this.eCellWrapper.appendChild(this.eCellValue);
        }
        const takeCellValueOut = !usingCellValue && this.eCellValue != null;
        if (takeCellValueOut) {
            $437b23f6a393c3bf$var$removeFromParent(this.eCellValue);
            this.eCellValue = void 0;
        }
        const templateChanged = putWrapperIn || takeWrapperOut || putCellValueIn || takeCellValueOut;
        if (templateChanged) this.removeControls();
        if (!editing) {
            if (providingControls) this.addControls();
        }
        return templateChanged;
    }
    addControls() {
        if (this.includeRowDrag) {
            if (this.rowDraggingComp == null) {
                this.rowDraggingComp = this.cellCtrl.createRowDragComp();
                if (this.rowDraggingComp) this.eCellWrapper.insertBefore(this.rowDraggingComp.getGui(), this.eCellValue);
            }
        }
        if (this.includeDndSource) {
            if (this.dndSourceComp == null) {
                this.dndSourceComp = this.cellCtrl.createDndSource();
                this.eCellWrapper.insertBefore(this.dndSourceComp.getGui(), this.eCellValue);
            }
        }
        if (this.includeSelection) {
            if (this.checkboxSelectionComp == null) {
                this.checkboxSelectionComp = this.cellCtrl.createSelectionCheckbox();
                this.eCellWrapper.insertBefore(this.checkboxSelectionComp.getGui(), this.eCellValue);
            }
        }
    }
    createCellEditorInstance(compDetails, popup, position) {
        const versionCopy = this.editorVersion;
        const cellEditorPromise = compDetails.newAgStackInstance();
        if (!cellEditorPromise) return;
        const { params: params } = compDetails;
        cellEditorPromise.then((c)=>this.afterCellEditorCreated(versionCopy, c, params, popup, position));
        const cellEditorAsync = $437b23f6a393c3bf$var$missing(this.cellEditor);
        if (cellEditorAsync && params.cellStartedEdit) this.cellCtrl.focusCell(true);
    }
    insertValueWithoutCellRenderer(valueToDisplay) {
        const eParent = this.getParentOfValue();
        $437b23f6a393c3bf$var$clearElement(eParent);
        const escapedValue = valueToDisplay != null ? $437b23f6a393c3bf$var$escapeString(valueToDisplay, true) : null;
        if (escapedValue != null) eParent.textContent = escapedValue;
    }
    destroyEditorAndRenderer() {
        this.destroyRenderer();
        this.destroyEditor();
    }
    destroyRenderer() {
        const { context: context } = this.beans;
        this.cellRenderer = context.destroyBean(this.cellRenderer);
        $437b23f6a393c3bf$var$removeFromParent(this.cellRendererGui);
        this.cellRendererGui = null;
        this.rendererVersion++;
    }
    destroyEditor() {
        const { context: context } = this.beans;
        if (this.hideEditorPopup) this.hideEditorPopup();
        this.hideEditorPopup = void 0;
        this.cellEditor = context.destroyBean(this.cellEditor);
        this.cellEditorPopupWrapper = context.destroyBean(this.cellEditorPopupWrapper);
        $437b23f6a393c3bf$var$removeFromParent(this.cellEditorGui);
        this.cellEditorGui = null;
        this.editorVersion++;
    }
    refreshCellRenderer(compClassAndParams) {
        if (this.cellRenderer == null || this.cellRenderer.refresh == null) return false;
        if (this.cellRendererClass !== compClassAndParams.componentClass) return false;
        const result = this.cellRenderer.refresh(compClassAndParams.params);
        return result === true || result === void 0;
    }
    createCellRendererInstance(compDetails) {
        const suppressAnimationFrame = this.beans.gos.get("suppressAnimationFrame");
        const useTaskService = !suppressAnimationFrame;
        const displayComponentVersionCopy = this.rendererVersion;
        const { componentClass: componentClass } = compDetails;
        const createCellRendererFunc = ()=>{
            const staleTask = this.rendererVersion !== displayComponentVersionCopy || !this.isAlive();
            if (staleTask) return;
            const componentPromise = compDetails.newAgStackInstance();
            const callback = this.afterCellRendererCreated.bind(this, displayComponentVersionCopy, componentClass);
            if (componentPromise) componentPromise.then(callback);
        };
        if (useTaskService && this.firstRender) this.beans.animationFrameService.createTask(createCellRendererFunc, this.rowNode.rowIndex, "createTasksP2");
        else createCellRendererFunc();
    }
    getCtrl() {
        return this.cellCtrl;
    }
    getRowCtrl() {
        return this.rowCtrl;
    }
    getCellRenderer() {
        return this.cellRenderer;
    }
    getCellEditor() {
        return this.cellEditor;
    }
    afterCellRendererCreated(cellRendererVersion, cellRendererClass, cellRenderer) {
        const staleTask = !this.isAlive() || cellRendererVersion !== this.rendererVersion;
        if (staleTask) {
            this.beans.context.destroyBean(cellRenderer);
            return;
        }
        this.cellRenderer = cellRenderer;
        this.cellRendererClass = cellRendererClass;
        this.cellRendererGui = this.cellRenderer.getGui();
        if (this.cellRendererGui != null) {
            const eParent = this.getParentOfValue();
            $437b23f6a393c3bf$var$clearElement(eParent);
            eParent.appendChild(this.cellRendererGui);
        }
    }
    afterCellEditorCreated(requestVersion, cellEditor, params, popup, position) {
        const staleComp = requestVersion !== this.editorVersion;
        if (staleComp) {
            this.beans.context.destroyBean(cellEditor);
            return;
        }
        const editingCancelledByUserComp = cellEditor.isCancelBeforeStart && cellEditor.isCancelBeforeStart();
        if (editingCancelledByUserComp) {
            this.beans.context.destroyBean(cellEditor);
            this.cellCtrl.stopEditing(true);
            return;
        }
        if (!cellEditor.getGui) {
            console.warn(`AG Grid: cellEditor for column ${this.column.getId()} is missing getGui() method`);
            this.beans.context.destroyBean(cellEditor);
            return;
        }
        this.cellEditor = cellEditor;
        this.cellEditorGui = cellEditor.getGui();
        const cellEditorInPopup = popup || cellEditor.isPopup !== void 0 && cellEditor.isPopup();
        if (cellEditorInPopup) this.addPopupCellEditor(params, position);
        else this.addInCellEditor();
        this.refreshEditStyles(true, cellEditorInPopup);
        if (cellEditor.afterGuiAttached) cellEditor.afterGuiAttached();
    }
    refreshEditStyles(editing, isPopup) {
        var _a;
        this.addOrRemoveCssClass("ag-cell-inline-editing", editing && !isPopup);
        this.addOrRemoveCssClass("ag-cell-popup-editing", editing && !!isPopup);
        this.addOrRemoveCssClass("ag-cell-not-inline-editing", !editing || !!isPopup);
        (_a = this.rowCtrl) == null || _a.setInlineEditingCss(editing);
    }
    addInCellEditor() {
        const eGui = this.getGui();
        if (eGui.contains(this.beans.gos.getActiveDomElement())) eGui.focus();
        this.destroyRenderer();
        this.refreshWrapper(true);
        this.clearParentOfValue();
        if (this.cellEditorGui) {
            const eParent = this.getParentOfValue();
            eParent.appendChild(this.cellEditorGui);
        }
    }
    addPopupCellEditor(params, position) {
        if (this.beans.gos.get("editType") === "fullRow") console.warn("AG Grid: popup cellEditor does not work with fullRowEdit - you cannot use them both - either turn off fullRowEdit, or stop using popup editors.");
        const cellEditor = this.cellEditor;
        this.cellEditorPopupWrapper = this.beans.context.createBean(new $437b23f6a393c3bf$export$fdd61bfa9577e25(params));
        const ePopupGui = this.cellEditorPopupWrapper.getGui();
        if (this.cellEditorGui) ePopupGui.appendChild(this.cellEditorGui);
        const popupService = this.beans.popupService;
        const useModelPopup = this.beans.gos.get("stopEditingWhenCellsLoseFocus");
        const positionToUse = position != null ? position : cellEditor.getPopupPosition ? cellEditor.getPopupPosition() : "over";
        const isRtl = this.beans.gos.get("enableRtl");
        const positionParams = {
            ePopup: ePopupGui,
            column: this.column,
            rowNode: this.rowNode,
            type: "popupCellEditor",
            eventSource: this.getGui(),
            position: positionToUse,
            alignSide: isRtl ? "right" : "left",
            keepWithinBounds: true
        };
        const positionCallback = popupService.positionPopupByComponent.bind(popupService, positionParams);
        const translate = this.beans.localeService.getLocaleTextFunc();
        const addPopupRes = popupService.addPopup({
            modal: useModelPopup,
            eChild: ePopupGui,
            closeOnEsc: true,
            closedCallback: ()=>{
                this.cellCtrl.onPopupEditorClosed();
            },
            anchorToElement: this.getGui(),
            positionCallback: positionCallback,
            ariaLabel: translate("ariaLabelCellEditor", "Cell Editor")
        });
        if (addPopupRes) this.hideEditorPopup = addPopupRes.hideFunc;
    }
    detach() {
        this.eRow.removeChild(this.getGui());
    }
    // if the row is also getting destroyed, then we don't need to remove from dom,
    // as the row will also get removed, so no need to take out the cells from the row
    // if the row is going (removing is an expensive operation, so only need to remove
    // the top part)
    //
    // note - this is NOT called by context, as we don't wire / unwire the CellComp for performance reasons.
    destroy() {
        this.cellCtrl.stopEditing();
        this.destroyEditorAndRenderer();
        this.removeControls();
        super.destroy();
    }
    clearParentOfValue() {
        const eGui = this.getGui();
        if (eGui.contains(this.beans.gos.getActiveDomElement()) && $437b23f6a393c3bf$var$browserSupportsPreventScroll()) eGui.focus({
            preventScroll: true
        });
        $437b23f6a393c3bf$var$clearElement(this.getParentOfValue());
    }
};
// community-modules/core/src/rendering/row/rowComp.ts
var $437b23f6a393c3bf$var$RowComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(ctrl, beans, containerType){
        super();
        this.cellComps = {};
        this.beans = beans;
        this.rowCtrl = ctrl;
        const rowDiv = document.createElement("div");
        rowDiv.setAttribute("comp-id", `${this.getCompId()}`);
        rowDiv.setAttribute("style", this.getInitialStyle(containerType));
        this.setTemplateFromElement(rowDiv);
        const eGui = this.getGui();
        const style = eGui.style;
        this.domOrder = this.rowCtrl.getDomOrder();
        $437b23f6a393c3bf$var$setAriaRole(eGui, "row");
        const tabIndex = this.rowCtrl.getTabIndex();
        if (tabIndex != null) eGui.setAttribute("tabindex", tabIndex.toString());
        const compProxy = {
            setDomOrder: (domOrder)=>this.domOrder = domOrder,
            setCellCtrls: (cellCtrls)=>this.setCellCtrls(cellCtrls),
            showFullWidth: (compDetails)=>this.showFullWidth(compDetails),
            getFullWidthCellRenderer: ()=>this.getFullWidthCellRenderer(),
            addOrRemoveCssClass: (name, on)=>this.addOrRemoveCssClass(name, on),
            setUserStyles: (styles)=>$437b23f6a393c3bf$var$addStylesToElement(eGui, styles),
            setTop: (top)=>style.top = top,
            setTransform: (transform)=>style.transform = transform,
            setRowIndex: (rowIndex)=>eGui.setAttribute("row-index", rowIndex),
            setRowId: (rowId)=>eGui.setAttribute("row-id", rowId),
            setRowBusinessKey: (businessKey)=>eGui.setAttribute("row-business-key", businessKey),
            refreshFullWidth: (getUpdatedParams)=>this.refreshFullWidth(getUpdatedParams)
        };
        ctrl.setComp(compProxy, this.getGui(), containerType);
        this.addDestroyFunc(()=>{
            ctrl.unsetComp(containerType);
        });
    }
    getInitialStyle(containerType) {
        const transform = this.rowCtrl.getInitialTransform(containerType);
        return transform ? `transform: ${transform}` : `top: ${this.rowCtrl.getInitialRowTop(containerType)}`;
    }
    showFullWidth(compDetails) {
        const callback = (cellRenderer)=>{
            if (this.isAlive()) {
                const eGui = cellRenderer.getGui();
                this.getGui().appendChild(eGui);
                this.rowCtrl.setupDetailRowAutoHeight(eGui);
                this.setFullWidthRowComp(cellRenderer);
            } else this.beans.context.destroyBean(cellRenderer);
        };
        const res = compDetails.newAgStackInstance();
        if (!res) return;
        res.then(callback);
    }
    setCellCtrls(cellCtrls) {
        const cellsToRemove = Object.assign({}, this.cellComps);
        cellCtrls.forEach((cellCtrl)=>{
            const key = cellCtrl.getInstanceId();
            const existingCellComp = this.cellComps[key];
            if (existingCellComp == null) this.newCellComp(cellCtrl);
            else cellsToRemove[key] = null;
        });
        const cellCompsToRemove = $437b23f6a393c3bf$var$getAllValuesInObject(cellsToRemove).filter((cellComp)=>cellComp != null);
        this.destroyCells(cellCompsToRemove);
        this.ensureDomOrder(cellCtrls);
    }
    ensureDomOrder(cellCtrls) {
        if (!this.domOrder) return;
        const elementsInOrder = [];
        cellCtrls.forEach((cellCtrl)=>{
            const cellComp = this.cellComps[cellCtrl.getInstanceId()];
            if (cellComp) elementsInOrder.push(cellComp.getGui());
        });
        $437b23f6a393c3bf$var$setDomChildOrder(this.getGui(), elementsInOrder);
    }
    newCellComp(cellCtrl) {
        const cellComp = new $437b23f6a393c3bf$export$e59215a9594b9f01(this.beans, cellCtrl, this.rowCtrl.isPrintLayout(), this.getGui(), this.rowCtrl.isEditing());
        this.cellComps[cellCtrl.getInstanceId()] = cellComp;
        this.getGui().appendChild(cellComp.getGui());
    }
    destroy() {
        super.destroy();
        this.destroyAllCells();
    }
    destroyAllCells() {
        const cellsToDestroy = $437b23f6a393c3bf$var$getAllValuesInObject(this.cellComps).filter((cp)=>cp != null);
        this.destroyCells(cellsToDestroy);
    }
    setFullWidthRowComp(fullWidthRowComponent) {
        if (this.fullWidthCellRenderer) console.error("AG Grid - should not be setting fullWidthRowComponent twice");
        this.fullWidthCellRenderer = fullWidthRowComponent;
        this.addDestroyFunc(()=>{
            this.fullWidthCellRenderer = this.beans.context.destroyBean(this.fullWidthCellRenderer);
        });
    }
    getFullWidthCellRenderer() {
        return this.fullWidthCellRenderer;
    }
    destroyCells(cellComps) {
        cellComps.forEach((cellComp)=>{
            if (!cellComp) return;
            const instanceId = cellComp.getCtrl().getInstanceId();
            if (this.cellComps[instanceId] !== cellComp) return;
            cellComp.detach();
            cellComp.destroy();
            this.cellComps[instanceId] = null;
        });
    }
    refreshFullWidth(getUpdatedParams) {
        const { fullWidthCellRenderer: fullWidthCellRenderer } = this;
        if (!fullWidthCellRenderer || !fullWidthCellRenderer.refresh) return false;
        const params = getUpdatedParams();
        return fullWidthCellRenderer.refresh(params);
    }
};
// community-modules/core/src/gridBodyComp/rowContainer/rowContainerComp.ts
function $437b23f6a393c3bf$var$templateFactory() {
    const name = $437b23f6a393c3bf$export$16fa2f45be04daa8.elementGettingCreated.getAttribute("name");
    const cssClasses = $437b23f6a393c3bf$export$2d4385f6f566fe5e.getRowContainerCssClasses(name);
    let res;
    const centerTemplate = name === "center" /* CENTER */  || name === "topCenter" /* TOP_CENTER */  || name === "stickyTopCenter" /* STICKY_TOP_CENTER */  || name === "bottomCenter" /* BOTTOM_CENTER */  || name === "stickyBottomCenter" /* STICKY_BOTTOM_CENTER */ ;
    if (centerTemplate) res = /* html */ `<div class="${cssClasses.viewport}" ref="eViewport" role="presentation">
                <div class="${cssClasses.container}" ref="eContainer"></div>
            </div>`;
    else res = /* html */ `<div class="${cssClasses.container}" ref="eContainer"></div>`;
    return res;
}
var $437b23f6a393c3bf$export$a301f7d71bb9bd77 = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super($437b23f6a393c3bf$var$templateFactory());
        this.rowComps = {};
        this.name = $437b23f6a393c3bf$export$16fa2f45be04daa8.elementGettingCreated.getAttribute("name");
        this.type = $437b23f6a393c3bf$export$c62f516a68da5a74(this.name);
    }
    postConstruct() {
        const compProxy = {
            setViewportHeight: (height)=>this.eViewport.style.height = height,
            setRowCtrls: ({ rowCtrls: rowCtrls })=>this.setRowCtrls(rowCtrls),
            setDomOrder: (domOrder)=>{
                this.domOrder = domOrder;
            },
            setContainerWidth: (width)=>this.eContainer.style.width = width
        };
        const ctrl = this.createManagedBean(new $437b23f6a393c3bf$export$2d4385f6f566fe5e(this.name));
        ctrl.setComp(compProxy, this.eContainer, this.eViewport);
    }
    preDestroy() {
        this.setRowCtrls([]);
    }
    setRowCtrls(rowCtrls) {
        const oldRows = $437b23f6a393c3bf$var$__spreadValues({}, this.rowComps);
        this.rowComps = {};
        this.lastPlacedElement = null;
        const processRow = (rowCon)=>{
            const instanceId = rowCon.getInstanceId();
            const existingRowComp = oldRows[instanceId];
            if (existingRowComp) {
                this.rowComps[instanceId] = existingRowComp;
                delete oldRows[instanceId];
                this.ensureDomOrder(existingRowComp.getGui());
            } else {
                if (!rowCon.getRowNode().displayed) return;
                const rowComp = new $437b23f6a393c3bf$var$RowComp(rowCon, this.beans, this.type);
                this.rowComps[instanceId] = rowComp;
                this.appendRow(rowComp.getGui());
            }
        };
        rowCtrls.forEach(processRow);
        $437b23f6a393c3bf$var$getAllValuesInObject(oldRows).forEach((oldRowComp)=>{
            this.eContainer.removeChild(oldRowComp.getGui());
            oldRowComp.destroy();
        });
        $437b23f6a393c3bf$var$setAriaRole(this.eContainer, "rowgroup");
    }
    appendRow(element) {
        if (this.domOrder) $437b23f6a393c3bf$var$insertWithDomOrder(this.eContainer, element, this.lastPlacedElement);
        else this.eContainer.appendChild(element);
        this.lastPlacedElement = element;
    }
    ensureDomOrder(eRow) {
        if (this.domOrder) {
            $437b23f6a393c3bf$var$ensureDomOrder(this.eContainer, eRow, this.lastPlacedElement);
            this.lastPlacedElement = eRow;
        }
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("beans")
], $437b23f6a393c3bf$export$a301f7d71bb9bd77.prototype, "beans", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eViewport")
], $437b23f6a393c3bf$export$a301f7d71bb9bd77.prototype, "eViewport", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eContainer")
], $437b23f6a393c3bf$export$a301f7d71bb9bd77.prototype, "eContainer", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$export$a301f7d71bb9bd77.prototype, "postConstruct", 1);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$cc3f3d4529c57d95
], $437b23f6a393c3bf$export$a301f7d71bb9bd77.prototype, "preDestroy", 1);
// community-modules/core/src/headerRendering/columnDrag/bodyDropPivotTarget.ts
var $437b23f6a393c3bf$export$2828fedc973b5610 = class {
    constructor(pinned){
        this.columnsToAggregate = [];
        this.columnsToGroup = [];
        this.columnsToPivot = [];
        this.pinned = pinned;
    }
    /** Callback for when drag enters */ onDragEnter(draggingEvent) {
        this.clearColumnsList();
        if (this.gos.get("functionsReadOnly")) return;
        const dragColumns = draggingEvent.dragItem.columns;
        if (!dragColumns) return;
        dragColumns.forEach((column)=>{
            if (!column.isPrimary()) return;
            if (column.isAnyFunctionActive()) return;
            if (column.isAllowValue()) this.columnsToAggregate.push(column);
            else if (column.isAllowRowGroup()) this.columnsToGroup.push(column);
            else if (column.isAllowPivot()) this.columnsToPivot.push(column);
        });
    }
    getIconName() {
        const totalColumns = this.columnsToAggregate.length + this.columnsToGroup.length + this.columnsToPivot.length;
        if (totalColumns > 0) return this.pinned ? $437b23f6a393c3bf$export$3529111922becfa6.ICON_PINNED : $437b23f6a393c3bf$export$3529111922becfa6.ICON_MOVE;
        return null;
    }
    /** Callback for when drag leaves */ onDragLeave(draggingEvent) {
        this.clearColumnsList();
    }
    clearColumnsList() {
        this.columnsToAggregate.length = 0;
        this.columnsToGroup.length = 0;
        this.columnsToPivot.length = 0;
    }
    /** Callback for when dragging */ onDragging(draggingEvent) {}
    /** Callback for when drag stops */ onDragStop(draggingEvent) {
        if (this.columnsToAggregate.length > 0) this.columnModel.addValueColumns(this.columnsToAggregate, "toolPanelDragAndDrop");
        if (this.columnsToGroup.length > 0) this.columnModel.addRowGroupColumns(this.columnsToGroup, "toolPanelDragAndDrop");
        if (this.columnsToPivot.length > 0) this.columnModel.addPivotColumns(this.columnsToPivot, "toolPanelDragAndDrop");
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnModel")
], $437b23f6a393c3bf$export$2828fedc973b5610.prototype, "columnModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("gridOptionsService")
], $437b23f6a393c3bf$export$2828fedc973b5610.prototype, "gos", 2);
// community-modules/core/src/headerRendering/columnMoveHelper.ts
var $437b23f6a393c3bf$var$ColumnMoveHelper = class {
    static attemptMoveColumns(params) {
        const { isFromHeader: isFromHeader, hDirection: hDirection, xPosition: xPosition, fromEnter: fromEnter, fakeEvent: fakeEvent, pinned: pinned, gos: gos, columnModel: columnModel } = params;
        const draggingLeft = hDirection === 0 /* Left */ ;
        const draggingRight = hDirection === 1 /* Right */ ;
        let { allMovingColumns: allMovingColumns } = params;
        if (isFromHeader) {
            let newCols = [];
            allMovingColumns.forEach((col)=>{
                var _a;
                let movingGroup = null;
                let parent = col.getParent();
                while(parent != null && parent.getDisplayedLeafColumns().length === 1){
                    movingGroup = parent;
                    parent = parent.getParent();
                }
                if (movingGroup != null) {
                    const isMarryChildren = !!((_a = movingGroup.getColGroupDef()) == null ? void 0 : _a.marryChildren);
                    const columnsToMove = isMarryChildren ? movingGroup.getProvidedColumnGroup().getLeafColumns() : movingGroup.getLeafColumns();
                    columnsToMove.forEach((newCol)=>{
                        if (!newCols.includes(newCol)) newCols.push(newCol);
                    });
                } else if (!newCols.includes(col)) newCols.push(col);
            });
            allMovingColumns = newCols;
        }
        const allMovingColumnsOrdered = allMovingColumns.slice();
        columnModel.sortColumnsLikeGridColumns(allMovingColumnsOrdered);
        const validMoves = this.calculateValidMoves({
            movingCols: allMovingColumnsOrdered,
            draggingRight: draggingRight,
            xPosition: xPosition,
            pinned: pinned,
            gos: gos,
            columnModel: columnModel
        });
        const oldIndex = this.calculateOldIndex(allMovingColumnsOrdered, columnModel);
        if (validMoves.length === 0) return;
        const firstValidMove = validMoves[0];
        let constrainDirection = oldIndex !== null && !fromEnter;
        if (isFromHeader) constrainDirection = oldIndex !== null;
        if (constrainDirection && !fakeEvent) {
            if (draggingLeft && firstValidMove >= oldIndex) return;
            if (draggingRight && firstValidMove <= oldIndex) return;
        }
        const displayedCols = columnModel.getAllDisplayedColumns();
        let potentialMoves = [];
        let targetOrder = null;
        for(let i = 0; i < validMoves.length; i++){
            const move = validMoves[i];
            const order = columnModel.getProposedColumnOrder(allMovingColumnsOrdered, move);
            if (!columnModel.doesOrderPassRules(order)) continue;
            const displayedOrder = order.filter((col)=>displayedCols.includes(col));
            if (targetOrder === null) targetOrder = displayedOrder;
            else if (!$437b23f6a393c3bf$var$areEqual(displayedOrder, targetOrder)) break;
            const fragCount = this.groupFragCount(order);
            potentialMoves.push({
                move: move,
                fragCount: fragCount
            });
        }
        if (potentialMoves.length === 0) return;
        potentialMoves.sort((a, b)=>a.fragCount - b.fragCount);
        return this.moveColumns(allMovingColumns, potentialMoves[0].move, "uiColumnMoved", false, columnModel);
    }
    static moveColumns(columns, toIndex, source, finished, columnModel) {
        columnModel.moveColumns(columns, toIndex, source, finished);
        return finished ? null : {
            columns: columns,
            toIndex: toIndex
        };
    }
    // returns the index of the first column in the list ONLY if the cols are all beside
    // each other. if the cols are not beside each other, then returns null
    static calculateOldIndex(movingCols, columnModel) {
        const gridCols = columnModel.getAllGridColumns();
        const indexes = $437b23f6a393c3bf$var$sortNumerically(movingCols.map((col)=>gridCols.indexOf(col)));
        const firstIndex = indexes[0];
        const lastIndex = $437b23f6a393c3bf$var$last(indexes);
        const spread = lastIndex - firstIndex;
        const gapsExist = spread !== indexes.length - 1;
        return gapsExist ? null : firstIndex;
    }
    // A measure of how fragmented in terms of groups an order of columns is
    static groupFragCount(columns) {
        function parents(col) {
            let result = [];
            let parent = col.getOriginalParent();
            while(parent != null){
                result.push(parent);
                parent = parent.getOriginalParent();
            }
            return result;
        }
        let count = 0;
        for(let i = 0; i < columns.length - 1; i++){
            let a = parents(columns[i]);
            let b = parents(columns[i + 1]);
            [a, b] = a.length > b.length ? [
                a,
                b
            ] : [
                b,
                a
            ];
            a.forEach((parent)=>{
                if (b.indexOf(parent) === -1) count++;
            });
        }
        return count;
    }
    static getDisplayedColumns(columnModel, type) {
        switch(type){
            case "left":
                return columnModel.getDisplayedLeftColumns();
            case "right":
                return columnModel.getDisplayedRightColumns();
            default:
                return columnModel.getDisplayedCenterColumns();
        }
    }
    static calculateValidMoves(params) {
        const { movingCols: movingCols, draggingRight: draggingRight, xPosition: xPosition, pinned: pinned, gos: gos, columnModel: columnModel } = params;
        const isMoveBlocked = gos.get("suppressMovableColumns") || movingCols.some((col)=>col.getColDef().suppressMovable);
        if (isMoveBlocked) return [];
        const allDisplayedCols = this.getDisplayedColumns(columnModel, pinned);
        const allGridCols = columnModel.getAllGridColumns();
        const movingDisplayedCols = allDisplayedCols.filter((col)=>$437b23f6a393c3bf$var$includes(movingCols, col));
        const otherDisplayedCols = allDisplayedCols.filter((col)=>!$437b23f6a393c3bf$var$includes(movingCols, col));
        const otherGridCols = allGridCols.filter((col)=>!$437b23f6a393c3bf$var$includes(movingCols, col));
        let displayIndex = 0;
        let availableWidth = xPosition;
        if (draggingRight) {
            let widthOfMovingDisplayedCols = 0;
            movingDisplayedCols.forEach((col)=>widthOfMovingDisplayedCols += col.getActualWidth());
            availableWidth -= widthOfMovingDisplayedCols;
        }
        if (availableWidth > 0) {
            for(let i = 0; i < otherDisplayedCols.length; i++){
                const col = otherDisplayedCols[i];
                availableWidth -= col.getActualWidth();
                if (availableWidth < 0) break;
                displayIndex++;
            }
            if (draggingRight) displayIndex++;
        }
        let firstValidMove;
        if (displayIndex > 0) {
            const leftColumn = otherDisplayedCols[displayIndex - 1];
            firstValidMove = otherGridCols.indexOf(leftColumn) + 1;
        } else {
            firstValidMove = otherGridCols.indexOf(otherDisplayedCols[0]);
            if (firstValidMove === -1) firstValidMove = 0;
        }
        const validMoves = [
            firstValidMove
        ];
        const numberComparator = (a, b)=>a - b;
        if (draggingRight) {
            let pointer = firstValidMove + 1;
            const lastIndex = allGridCols.length - 1;
            while(pointer <= lastIndex){
                validMoves.push(pointer);
                pointer++;
            }
            validMoves.sort(numberComparator);
        } else {
            let pointer = firstValidMove;
            const lastIndex = allGridCols.length - 1;
            let displacedCol = allGridCols[pointer];
            while(pointer <= lastIndex && allDisplayedCols.indexOf(displacedCol) < 0){
                pointer++;
                validMoves.push(pointer);
                displacedCol = allGridCols[pointer];
            }
            pointer = firstValidMove - 1;
            const firstDisplayIndex = 0;
            while(pointer >= firstDisplayIndex){
                validMoves.push(pointer);
                pointer--;
            }
            validMoves.sort(numberComparator).reverse();
        }
        return validMoves;
    }
    static normaliseX(x, pinned, fromKeyboard, gos, ctrlsService) {
        const eViewport = ctrlsService.getHeaderRowContainerCtrl(pinned).getViewport();
        if (fromKeyboard) x -= eViewport.getBoundingClientRect().left;
        if (gos.get("enableRtl")) {
            const clientWidth = eViewport.clientWidth;
            x = clientWidth - x;
        }
        if (pinned == null) x += ctrlsService.get("center").getCenterViewportScrollLeft();
        return x;
    }
};
// community-modules/core/src/headerRendering/columnDrag/moveColumnFeature.ts
var $437b23f6a393c3bf$export$a5c24618571fc64c = class {
    constructor(pinned){
        this.needToMoveLeft = false;
        this.needToMoveRight = false;
        this.lastMovedInfo = null;
        this.pinned = pinned;
        this.isCenterContainer = !$437b23f6a393c3bf$var$exists(pinned);
    }
    init() {
        this.ctrlsService.whenReady((p)=>{
            this.gridBodyCon = p.gridBodyCtrl;
        });
    }
    getIconName() {
        return this.pinned ? $437b23f6a393c3bf$export$3529111922becfa6.ICON_PINNED : $437b23f6a393c3bf$export$3529111922becfa6.ICON_MOVE;
    }
    onDragEnter(draggingEvent) {
        const columns = draggingEvent.dragItem.columns;
        const dragCameFromToolPanel = draggingEvent.dragSource.type === 0 /* ToolPanel */ ;
        if (dragCameFromToolPanel) this.setColumnsVisible(columns, true, "uiColumnDragged");
        else {
            const visibleState = draggingEvent.dragItem.visibleState;
            const visibleColumns = (columns || []).filter((column)=>visibleState[column.getId()]);
            this.setColumnsVisible(visibleColumns, true, "uiColumnDragged");
        }
        this.setColumnsPinned(columns, this.pinned, "uiColumnDragged");
        this.onDragging(draggingEvent, true, true);
    }
    onDragLeave() {
        this.ensureIntervalCleared();
        this.lastMovedInfo = null;
    }
    setColumnsVisible(columns, visible, source) {
        if (columns) {
            const allowedCols = columns.filter((c)=>!c.getColDef().lockVisible);
            this.columnModel.setColumnsVisible(allowedCols, visible, source);
        }
    }
    setColumnsPinned(columns, pinned, source) {
        if (columns) {
            const allowedCols = columns.filter((c)=>!c.getColDef().lockPinned);
            this.columnModel.setColumnsPinned(allowedCols, pinned, source);
        }
    }
    onDragStop() {
        this.onDragging(this.lastDraggingEvent, false, true, true);
        this.ensureIntervalCleared();
        this.lastMovedInfo = null;
    }
    checkCenterForScrolling(xAdjustedForScroll) {
        if (this.isCenterContainer) {
            const centerCtrl = this.ctrlsService.get("center");
            const firstVisiblePixel = centerCtrl.getCenterViewportScrollLeft();
            const lastVisiblePixel = firstVisiblePixel + centerCtrl.getCenterWidth();
            if (this.gos.get("enableRtl")) {
                this.needToMoveRight = xAdjustedForScroll < firstVisiblePixel + 50;
                this.needToMoveLeft = xAdjustedForScroll > lastVisiblePixel - 50;
            } else {
                this.needToMoveLeft = xAdjustedForScroll < firstVisiblePixel + 50;
                this.needToMoveRight = xAdjustedForScroll > lastVisiblePixel - 50;
            }
            if (this.needToMoveLeft || this.needToMoveRight) this.ensureIntervalStarted();
            else this.ensureIntervalCleared();
        }
    }
    onDragging(draggingEvent = this.lastDraggingEvent, fromEnter = false, fakeEvent = false, finished = false) {
        var _a;
        if (finished) {
            if (this.lastMovedInfo) {
                const { columns: columns, toIndex: toIndex } = this.lastMovedInfo;
                $437b23f6a393c3bf$var$ColumnMoveHelper.moveColumns(columns, toIndex, "uiColumnMoved", true, this.columnModel);
            }
            return;
        }
        this.lastDraggingEvent = draggingEvent;
        if ($437b23f6a393c3bf$var$missing(draggingEvent.hDirection)) return;
        const mouseX = $437b23f6a393c3bf$var$ColumnMoveHelper.normaliseX(draggingEvent.x, this.pinned, false, this.gos, this.ctrlsService);
        if (!fromEnter) this.checkCenterForScrolling(mouseX);
        const hDirection = this.normaliseDirection(draggingEvent.hDirection);
        const dragSourceType = draggingEvent.dragSource.type;
        const allMovingColumns = ((_a = draggingEvent.dragSource.getDragItem().columns) == null ? void 0 : _a.filter((col)=>{
            if (col.getColDef().lockPinned) return col.getPinned() == this.pinned;
            return true;
        })) || [];
        const lastMovedInfo = $437b23f6a393c3bf$var$ColumnMoveHelper.attemptMoveColumns({
            allMovingColumns: allMovingColumns,
            isFromHeader: dragSourceType === 1 /* HeaderCell */ ,
            hDirection: hDirection,
            xPosition: mouseX,
            pinned: this.pinned,
            fromEnter: fromEnter,
            fakeEvent: fakeEvent,
            gos: this.gos,
            columnModel: this.columnModel
        });
        if (lastMovedInfo) this.lastMovedInfo = lastMovedInfo;
    }
    normaliseDirection(hDirection) {
        if (this.gos.get("enableRtl")) switch(hDirection){
            case 0 /* Left */ :
                return 1 /* Right */ ;
            case 1 /* Right */ :
                return 0 /* Left */ ;
            default:
                console.error(`AG Grid: Unknown direction ${hDirection}`);
        }
        else return hDirection;
    }
    ensureIntervalStarted() {
        if (!this.movingIntervalId) {
            this.intervalCount = 0;
            this.failedMoveAttempts = 0;
            this.movingIntervalId = window.setInterval(this.moveInterval.bind(this), 100);
            if (this.needToMoveLeft) this.dragAndDropService.setGhostIcon($437b23f6a393c3bf$export$3529111922becfa6.ICON_LEFT, true);
            else this.dragAndDropService.setGhostIcon($437b23f6a393c3bf$export$3529111922becfa6.ICON_RIGHT, true);
        }
    }
    ensureIntervalCleared() {
        if (this.movingIntervalId) {
            window.clearInterval(this.movingIntervalId);
            this.movingIntervalId = null;
            this.dragAndDropService.setGhostIcon($437b23f6a393c3bf$export$3529111922becfa6.ICON_MOVE);
        }
    }
    moveInterval() {
        let pixelsToMove;
        this.intervalCount++;
        pixelsToMove = 10 + this.intervalCount * 5;
        if (pixelsToMove > 100) pixelsToMove = 100;
        let pixelsMoved = null;
        const scrollFeature = this.gridBodyCon.getScrollFeature();
        if (this.needToMoveLeft) pixelsMoved = scrollFeature.scrollHorizontally(-pixelsToMove);
        else if (this.needToMoveRight) pixelsMoved = scrollFeature.scrollHorizontally(pixelsToMove);
        if (pixelsMoved !== 0) {
            this.onDragging(this.lastDraggingEvent);
            this.failedMoveAttempts = 0;
        } else {
            this.failedMoveAttempts++;
            const columns = this.lastDraggingEvent.dragItem.columns;
            const columnsThatCanPin = columns.filter((c)=>!c.getColDef().lockPinned);
            if (columnsThatCanPin.length > 0) {
                this.dragAndDropService.setGhostIcon($437b23f6a393c3bf$export$3529111922becfa6.ICON_PINNED);
                if (this.failedMoveAttempts > 7) {
                    const pinType = this.needToMoveLeft ? "left" : "right";
                    this.setColumnsPinned(columnsThatCanPin, pinType, "uiColumnDragged");
                    this.dragAndDropService.nudge();
                }
            }
        }
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnModel")
], $437b23f6a393c3bf$export$a5c24618571fc64c.prototype, "columnModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("dragAndDropService")
], $437b23f6a393c3bf$export$a5c24618571fc64c.prototype, "dragAndDropService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("gridOptionsService")
], $437b23f6a393c3bf$export$a5c24618571fc64c.prototype, "gos", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("ctrlsService")
], $437b23f6a393c3bf$export$a5c24618571fc64c.prototype, "ctrlsService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$export$a5c24618571fc64c.prototype, "init", 1);
// community-modules/core/src/headerRendering/columnDrag/bodyDropTarget.ts
var $437b23f6a393c3bf$export$2350838bf1877b9e = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(pinned, eContainer){
        super();
        this.pinned = pinned;
        this.eContainer = eContainer;
    }
    postConstruct() {
        this.ctrlsService.whenReady((p)=>{
            switch(this.pinned){
                case "left":
                    this.eSecondaryContainers = [
                        [
                            p.gridBodyCtrl.getBodyViewportElement(),
                            p.left.getContainerElement()
                        ],
                        [
                            p.bottomLeft.getContainerElement()
                        ],
                        [
                            p.topLeft.getContainerElement()
                        ]
                    ];
                    break;
                case "right":
                    this.eSecondaryContainers = [
                        [
                            p.gridBodyCtrl.getBodyViewportElement(),
                            p.right.getContainerElement()
                        ],
                        [
                            p.bottomRight.getContainerElement()
                        ],
                        [
                            p.topRight.getContainerElement()
                        ]
                    ];
                    break;
                default:
                    this.eSecondaryContainers = [
                        [
                            p.gridBodyCtrl.getBodyViewportElement(),
                            p.center.getViewportElement()
                        ],
                        [
                            p.bottomCenter.getViewportElement()
                        ],
                        [
                            p.topCenter.getViewportElement()
                        ]
                    ];
                    break;
            }
        });
    }
    isInterestedIn(type) {
        return type === 1 /* HeaderCell */  || type === 0 /* ToolPanel */  && this.gos.get("allowDragFromColumnsToolPanel");
    }
    getSecondaryContainers() {
        return this.eSecondaryContainers;
    }
    getContainer() {
        return this.eContainer;
    }
    init() {
        this.moveColumnFeature = this.createManagedBean(new $437b23f6a393c3bf$export$a5c24618571fc64c(this.pinned));
        this.bodyDropPivotTarget = this.createManagedBean(new $437b23f6a393c3bf$export$2828fedc973b5610(this.pinned));
        this.dragAndDropService.addDropTarget(this);
    }
    getIconName() {
        return this.currentDropListener.getIconName();
    }
    // we want to use the bodyPivotTarget if the user is dragging columns in from the toolPanel
    // and we are in pivot mode, as it has to logic to set pivot/value/group on the columns when
    // dropped into the grid's body.
    isDropColumnInPivotMode(draggingEvent) {
        return this.columnModel.isPivotMode() && draggingEvent.dragSource.type === 0 /* ToolPanel */ ;
    }
    onDragEnter(draggingEvent) {
        this.currentDropListener = this.isDropColumnInPivotMode(draggingEvent) ? this.bodyDropPivotTarget : this.moveColumnFeature;
        this.currentDropListener.onDragEnter(draggingEvent);
    }
    onDragLeave(params) {
        this.currentDropListener.onDragLeave(params);
    }
    onDragging(params) {
        this.currentDropListener.onDragging(params);
    }
    onDragStop(params) {
        this.currentDropListener.onDragStop(params);
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("dragAndDropService")
], $437b23f6a393c3bf$export$2350838bf1877b9e.prototype, "dragAndDropService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnModel")
], $437b23f6a393c3bf$export$2350838bf1877b9e.prototype, "columnModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("ctrlsService")
], $437b23f6a393c3bf$export$2350838bf1877b9e.prototype, "ctrlsService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$export$2350838bf1877b9e.prototype, "postConstruct", 1);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$export$2350838bf1877b9e.prototype, "init", 1);
// community-modules/core/src/headerRendering/cells/column/headerCellComp.ts
var $437b23f6a393c3bf$var$_HeaderCellComp = class _HeaderCellComp extends $437b23f6a393c3bf$var$AbstractHeaderCellComp {
    constructor(ctrl){
        super(_HeaderCellComp.TEMPLATE, ctrl);
        this.headerCompVersion = 0;
        this.column = ctrl.getColumnGroupChild();
        this.pinned = ctrl.getPinned();
    }
    postConstruct() {
        const eGui = this.getGui();
        const setAttribute = (name, value)=>{
            if (value != null && value != "") eGui.setAttribute(name, value);
            else eGui.removeAttribute(name);
        };
        setAttribute("col-id", this.column.getColId());
        const compProxy = {
            setWidth: (width)=>eGui.style.width = width,
            addOrRemoveCssClass: (cssClassName, on)=>this.addOrRemoveCssClass(cssClassName, on),
            setAriaSort: (sort)=>sort ? $437b23f6a393c3bf$var$setAriaSort(eGui, sort) : $437b23f6a393c3bf$var$removeAriaSort(eGui),
            setUserCompDetails: (compDetails)=>this.setUserCompDetails(compDetails),
            getUserCompInstance: ()=>this.headerComp
        };
        this.ctrl.setComp(compProxy, this.getGui(), this.eResize, this.eHeaderCompWrapper);
        const selectAllGui = this.ctrl.getSelectAllGui();
        this.eResize.insertAdjacentElement("afterend", selectAllGui);
    }
    destroyHeaderComp() {
        if (this.headerComp) {
            this.eHeaderCompWrapper.removeChild(this.headerCompGui);
            this.headerComp = this.destroyBean(this.headerComp);
            this.headerCompGui = void 0;
        }
    }
    setUserCompDetails(compDetails) {
        this.headerCompVersion++;
        const versionCopy = this.headerCompVersion;
        compDetails.newAgStackInstance().then((comp)=>this.afterCompCreated(versionCopy, comp));
    }
    afterCompCreated(version, headerComp) {
        if (version != this.headerCompVersion || !this.isAlive()) {
            this.destroyBean(headerComp);
            return;
        }
        this.destroyHeaderComp();
        this.headerComp = headerComp;
        this.headerCompGui = headerComp.getGui();
        this.eHeaderCompWrapper.appendChild(this.headerCompGui);
        this.ctrl.setDragSource(this.getGui());
    }
};
$437b23f6a393c3bf$var$_HeaderCellComp.TEMPLATE = /* html */ `<div class="ag-header-cell" role="columnheader">
            <div ref="eResize" class="ag-header-cell-resize" role="presentation"></div>
            <div ref="eHeaderCompWrapper" class="ag-header-cell-comp-wrapper" role="presentation"></div>
        </div>`;
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eResize")
], $437b23f6a393c3bf$var$_HeaderCellComp.prototype, "eResize", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eHeaderCompWrapper")
], $437b23f6a393c3bf$var$_HeaderCellComp.prototype, "eHeaderCompWrapper", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$_HeaderCellComp.prototype, "postConstruct", 1);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$cc3f3d4529c57d95
], $437b23f6a393c3bf$var$_HeaderCellComp.prototype, "destroyHeaderComp", 1);
var $437b23f6a393c3bf$var$HeaderCellComp = $437b23f6a393c3bf$var$_HeaderCellComp;
// community-modules/core/src/headerRendering/cells/columnGroup/headerGroupCellComp.ts
var $437b23f6a393c3bf$var$_HeaderGroupCellComp = class _HeaderGroupCellComp extends $437b23f6a393c3bf$var$AbstractHeaderCellComp {
    constructor(ctrl){
        super(_HeaderGroupCellComp.TEMPLATE, ctrl);
    }
    postConstruct() {
        const eGui = this.getGui();
        const setAttribute = (key, value)=>value != void 0 ? eGui.setAttribute(key, value) : eGui.removeAttribute(key);
        eGui.setAttribute("col-id", this.ctrl.getColId());
        const compProxy = {
            addOrRemoveCssClass: (cssClassName, on)=>this.addOrRemoveCssClass(cssClassName, on),
            setResizableDisplayed: (displayed)=>$437b23f6a393c3bf$var$setDisplayed(this.eResize, displayed),
            setWidth: (width)=>eGui.style.width = width,
            setAriaExpanded: (expanded)=>setAttribute("aria-expanded", expanded),
            setUserCompDetails: (details)=>this.setUserCompDetails(details),
            getUserCompInstance: ()=>this.headerGroupComp
        };
        this.ctrl.setComp(compProxy, eGui, this.eResize);
    }
    setUserCompDetails(details) {
        details.newAgStackInstance().then((comp)=>this.afterHeaderCompCreated(comp));
    }
    afterHeaderCompCreated(headerGroupComp) {
        const destroyFunc = ()=>this.destroyBean(headerGroupComp);
        if (!this.isAlive()) {
            destroyFunc();
            return;
        }
        const eGui = this.getGui();
        const eHeaderGroupGui = headerGroupComp.getGui();
        eGui.appendChild(eHeaderGroupGui);
        this.addDestroyFunc(destroyFunc);
        this.headerGroupComp = headerGroupComp;
        this.ctrl.setDragSource(eGui);
    }
};
$437b23f6a393c3bf$var$_HeaderGroupCellComp.TEMPLATE = /* html */ `<div class="ag-header-group-cell" role="columnheader">
            <div ref="eResize" class="ag-header-cell-resize" role="presentation"></div>
        </div>`;
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eResize")
], $437b23f6a393c3bf$var$_HeaderGroupCellComp.prototype, "eResize", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$_HeaderGroupCellComp.prototype, "postConstruct", 1);
var $437b23f6a393c3bf$var$HeaderGroupCellComp = $437b23f6a393c3bf$var$_HeaderGroupCellComp;
// community-modules/core/src/headerRendering/row/headerRowComp.ts
var $437b23f6a393c3bf$export$e37505288cf627d = /* @__PURE__ */ ((HeaderRowType2)=>{
    HeaderRowType2["COLUMN_GROUP"] = "group";
    HeaderRowType2["COLUMN"] = "column";
    HeaderRowType2["FLOATING_FILTER"] = "filter";
    return HeaderRowType2;
})($437b23f6a393c3bf$export$e37505288cf627d || {});
var $437b23f6a393c3bf$export$e63c63fafc55a465 = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(ctrl){
        super();
        this.headerComps = {};
        this.ctrl = ctrl;
        this.setTemplate(/* html */ `<div class="${this.ctrl.getHeaderRowClass()}" role="row"></div>`);
    }
    init() {
        $437b23f6a393c3bf$var$setAriaRowIndex(this.getGui(), this.ctrl.getAriaRowIndex());
        const compProxy = {
            setHeight: (height)=>this.getGui().style.height = height,
            setTop: (top)=>this.getGui().style.top = top,
            setHeaderCtrls: (ctrls, forceOrder)=>this.setHeaderCtrls(ctrls, forceOrder),
            setWidth: (width)=>this.getGui().style.width = width
        };
        this.ctrl.setComp(compProxy);
    }
    destroyHeaderCtrls() {
        this.setHeaderCtrls([], false);
    }
    setHeaderCtrls(ctrls, forceOrder) {
        if (!this.isAlive()) return;
        const oldComps = this.headerComps;
        this.headerComps = {};
        ctrls.forEach((ctrl)=>{
            const id = ctrl.getInstanceId();
            let comp = oldComps[id];
            delete oldComps[id];
            if (comp == null) {
                comp = this.createHeaderComp(ctrl);
                this.getGui().appendChild(comp.getGui());
            }
            this.headerComps[id] = comp;
        });
        $437b23f6a393c3bf$var$iterateObject(oldComps, (id, comp)=>{
            this.getGui().removeChild(comp.getGui());
            this.destroyBean(comp);
        });
        if (forceOrder) {
            const comps = $437b23f6a393c3bf$var$getAllValuesInObject(this.headerComps);
            comps.sort((a, b)=>{
                const leftA = a.getCtrl().getColumnGroupChild().getLeft();
                const leftB = b.getCtrl().getColumnGroupChild().getLeft();
                return leftA - leftB;
            });
            const elementsInOrder = comps.map((c)=>c.getGui());
            $437b23f6a393c3bf$var$setDomChildOrder(this.getGui(), elementsInOrder);
        }
    }
    createHeaderComp(headerCtrl) {
        let result;
        switch(this.ctrl.getType()){
            case "group" /* COLUMN_GROUP */ :
                result = new $437b23f6a393c3bf$var$HeaderGroupCellComp(headerCtrl);
                break;
            case "filter" /* FLOATING_FILTER */ :
                result = new $437b23f6a393c3bf$export$aee3d2f667fe76c1(headerCtrl);
                break;
            default:
                result = new $437b23f6a393c3bf$var$HeaderCellComp(headerCtrl);
                break;
        }
        this.createBean(result);
        result.setParentComponent(this);
        return result;
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$export$e63c63fafc55a465.prototype, "init", 1);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$cc3f3d4529c57d95
], $437b23f6a393c3bf$export$e63c63fafc55a465.prototype, "destroyHeaderCtrls", 1);
// community-modules/core/src/headerRendering/cells/abstractCell/abstractHeaderCellCtrl.ts
var $437b23f6a393c3bf$var$instanceIdSequence4 = 0;
var $437b23f6a393c3bf$var$_AbstractHeaderCellCtrl = class _AbstractHeaderCellCtrl extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(columnGroupChild, beans, parentRowCtrl){
        super();
        this.resizeToggleTimeout = 0;
        this.resizeMultiplier = 1;
        this.resizeFeature = null;
        this.lastFocusEvent = null;
        this.dragSource = null;
        this.columnGroupChild = columnGroupChild;
        this.parentRowCtrl = parentRowCtrl;
        this.beans = beans;
        this.instanceId = columnGroupChild.getUniqueId() + "-" + $437b23f6a393c3bf$var$instanceIdSequence4++;
    }
    postConstruct() {
        this.addManagedPropertyListeners([
            "suppressHeaderFocus"
        ], ()=>this.refreshTabIndex());
    }
    shouldStopEventPropagation(e) {
        const { headerRowIndex: headerRowIndex, column: column } = this.focusService.getFocusedHeader();
        return $437b23f6a393c3bf$var$isUserSuppressingHeaderKeyboardEvent(this.gos, e, headerRowIndex, column);
    }
    getWrapperHasFocus() {
        const activeEl = this.gos.getActiveDomElement();
        return activeEl === this.eGui;
    }
    setGui(eGui) {
        this.eGui = eGui;
        this.addDomData();
        this.addManagedListener(this.beans.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
        this.onDisplayedColumnsChanged();
        this.refreshTabIndex();
    }
    onDisplayedColumnsChanged() {
        if (!this.comp || !this.column) return;
        this.refreshFirstAndLastStyles();
        this.refreshAriaColIndex();
    }
    refreshFirstAndLastStyles() {
        const { comp: comp, column: column, beans: beans } = this;
        $437b23f6a393c3bf$export$f90acfa36b600d3d.refreshFirstAndLastStyles(comp, column, beans.columnModel);
    }
    refreshAriaColIndex() {
        const { beans: beans, column: column } = this;
        const colIdx = beans.columnModel.getAriaColumnIndex(column);
        $437b23f6a393c3bf$var$setAriaColIndex(this.eGui, colIdx);
    }
    addResizeAndMoveKeyboardListeners() {
        if (!this.resizeFeature) return;
        this.addManagedListener(this.eGui, "keydown", this.onGuiKeyDown.bind(this));
        this.addManagedListener(this.eGui, "keyup", this.onGuiKeyUp.bind(this));
    }
    refreshTabIndex() {
        const suppressHeaderFocus = this.gos.get("suppressHeaderFocus");
        if (suppressHeaderFocus) this.eGui.removeAttribute("tabindex");
        else this.eGui.setAttribute("tabindex", "-1");
    }
    onGuiKeyDown(e) {
        var _a;
        const activeEl = this.gos.getActiveDomElement();
        const isLeftOrRight = e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT || e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT;
        if (this.isResizing) {
            e.preventDefault();
            e.stopImmediatePropagation();
        }
        if (// if elements within the header are focused, we don't process the event
        activeEl !== this.eGui || // if shiftKey and altKey are not pressed, it's cell navigation so we don't process the event
        !e.shiftKey && !e.altKey) return;
        if (this.isResizing || isLeftOrRight) {
            e.preventDefault();
            e.stopImmediatePropagation();
        }
        if (!isLeftOrRight) return;
        const isLeft = e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT !== this.gos.get("enableRtl");
        const direction = $437b23f6a393c3bf$export$2e679088785045c[isLeft ? "Left" : "Right"];
        if (e.altKey) {
            this.isResizing = true;
            this.resizeMultiplier += 1;
            const diff = this.getViewportAdjustedResizeDiff(e);
            this.resizeHeader(diff, e.shiftKey);
            (_a = this.resizeFeature) == null || _a.toggleColumnResizing(true);
        } else this.moveHeader(direction);
    }
    getViewportAdjustedResizeDiff(e) {
        let diff = this.getResizeDiff(e);
        const pinned = this.column.getPinned();
        if (pinned) {
            const leftWidth = this.pinnedWidthService.getPinnedLeftWidth();
            const rightWidth = this.pinnedWidthService.getPinnedRightWidth();
            const bodyWidth = $437b23f6a393c3bf$var$getInnerWidth(this.ctrlsService.getGridBodyCtrl().getBodyViewportElement()) - 50;
            if (leftWidth + rightWidth + diff > bodyWidth) {
                if (bodyWidth > leftWidth + rightWidth) diff = bodyWidth - leftWidth - rightWidth;
                else return 0;
            }
        }
        return diff;
    }
    getResizeDiff(e) {
        let isLeft = e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT !== this.gos.get("enableRtl");
        const pinned = this.column.getPinned();
        const isRtl = this.gos.get("enableRtl");
        if (pinned) {
            if (isRtl !== (pinned === "right")) isLeft = !isLeft;
        }
        return (isLeft ? -1 : 1) * this.resizeMultiplier;
    }
    onGuiKeyUp() {
        if (!this.isResizing) return;
        if (this.resizeToggleTimeout) {
            window.clearTimeout(this.resizeToggleTimeout);
            this.resizeToggleTimeout = 0;
        }
        this.isResizing = false;
        this.resizeMultiplier = 1;
        this.resizeToggleTimeout = setTimeout(()=>{
            var _a;
            (_a = this.resizeFeature) == null || _a.toggleColumnResizing(false);
        }, 150);
    }
    handleKeyDown(e) {
        const wrapperHasFocus = this.getWrapperHasFocus();
        switch(e.key){
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_DOWN:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_UP:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_HOME:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_END:
                if (wrapperHasFocus) e.preventDefault();
        }
    }
    addDomData() {
        const key = _AbstractHeaderCellCtrl.DOM_DATA_KEY_HEADER_CTRL;
        this.gos.setDomData(this.eGui, key, this);
        this.addDestroyFunc(()=>this.gos.setDomData(this.eGui, key, null));
    }
    getGui() {
        return this.eGui;
    }
    focus(event) {
        if (!this.eGui) return false;
        this.lastFocusEvent = event || null;
        this.eGui.focus();
        return true;
    }
    getRowIndex() {
        return this.parentRowCtrl.getRowIndex();
    }
    getParentRowCtrl() {
        return this.parentRowCtrl;
    }
    getPinned() {
        return this.parentRowCtrl.getPinned();
    }
    getInstanceId() {
        return this.instanceId;
    }
    getColumnGroupChild() {
        return this.columnGroupChild;
    }
    removeDragSource() {
        if (this.dragSource) {
            this.dragAndDropService.removeDragSource(this.dragSource);
            this.dragSource = null;
        }
    }
    handleContextMenuMouseEvent(mouseEvent, touchEvent, column) {
        const event = mouseEvent != null ? mouseEvent : touchEvent;
        if (this.gos.get("preventDefaultOnContextMenu")) event.preventDefault();
        const columnToUse = column instanceof $437b23f6a393c3bf$export$816b5d811295e6bc ? column : void 0;
        if (this.menuService.isHeaderContextMenuEnabled(columnToUse)) this.menuService.showHeaderContextMenu(columnToUse, mouseEvent, touchEvent);
        this.dispatchColumnMouseEvent($437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_HEADER_CONTEXT_MENU, column);
    }
    dispatchColumnMouseEvent(eventType, column) {
        const event = {
            type: eventType,
            column: column
        };
        this.eventService.dispatchEvent(event);
    }
    destroy() {
        super.destroy();
        this.removeDragSource();
        this.comp = null;
        this.column = null;
        this.resizeFeature = null;
        this.lastFocusEvent = null;
        this.columnGroupChild = null;
        this.parentRowCtrl = null;
        this.eGui = null;
    }
};
$437b23f6a393c3bf$var$_AbstractHeaderCellCtrl.DOM_DATA_KEY_HEADER_CTRL = "headerCtrl";
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("pinnedWidthService")
], $437b23f6a393c3bf$var$_AbstractHeaderCellCtrl.prototype, "pinnedWidthService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("focusService")
], $437b23f6a393c3bf$var$_AbstractHeaderCellCtrl.prototype, "focusService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("userComponentFactory")
], $437b23f6a393c3bf$var$_AbstractHeaderCellCtrl.prototype, "userComponentFactory", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("ctrlsService")
], $437b23f6a393c3bf$var$_AbstractHeaderCellCtrl.prototype, "ctrlsService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("dragAndDropService")
], $437b23f6a393c3bf$var$_AbstractHeaderCellCtrl.prototype, "dragAndDropService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("menuService")
], $437b23f6a393c3bf$var$_AbstractHeaderCellCtrl.prototype, "menuService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$_AbstractHeaderCellCtrl.prototype, "postConstruct", 1);
var $437b23f6a393c3bf$export$879ff627d5a4d5c = $437b23f6a393c3bf$var$_AbstractHeaderCellCtrl;
// community-modules/core/src/rendering/features/setLeftFeature.ts
var $437b23f6a393c3bf$export$84c1fb51ab89c7b5 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(columnOrGroup, eCell, beans, colsSpanning){
        super();
        this.columnOrGroup = columnOrGroup;
        this.eCell = eCell;
        this.ariaEl = this.eCell.querySelector("[role=columnheader]") || this.eCell;
        this.colsSpanning = colsSpanning;
        this.beans = beans;
    }
    setColsSpanning(colsSpanning) {
        this.colsSpanning = colsSpanning;
        this.onLeftChanged();
    }
    getColumnOrGroup() {
        if (this.beans.gos.get("enableRtl") && this.colsSpanning) return $437b23f6a393c3bf$var$last(this.colsSpanning);
        return this.columnOrGroup;
    }
    postConstruct() {
        this.addManagedListener(this.columnOrGroup, $437b23f6a393c3bf$export$816b5d811295e6bc.EVENT_LEFT_CHANGED, this.onLeftChanged.bind(this));
        this.setLeftFirstTime();
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, this.onLeftChanged.bind(this));
        this.addManagedPropertyListener("domLayout", this.onLeftChanged.bind(this));
    }
    setLeftFirstTime() {
        const suppressMoveAnimation = this.beans.gos.get("suppressColumnMoveAnimation");
        const oldLeftExists = $437b23f6a393c3bf$var$exists(this.columnOrGroup.getOldLeft());
        const animateColumnMove = this.beans.columnAnimationService.isActive() && oldLeftExists && !suppressMoveAnimation;
        if (animateColumnMove) this.animateInLeft();
        else this.onLeftChanged();
    }
    animateInLeft() {
        const colOrGroup = this.getColumnOrGroup();
        const left = colOrGroup.getLeft();
        const oldLeft = colOrGroup.getOldLeft();
        const oldActualLeft = this.modifyLeftForPrintLayout(colOrGroup, oldLeft);
        const actualLeft = this.modifyLeftForPrintLayout(colOrGroup, left);
        this.setLeft(oldActualLeft);
        this.actualLeft = actualLeft;
        this.beans.columnAnimationService.executeNextVMTurn(()=>{
            if (this.actualLeft === actualLeft) this.setLeft(actualLeft);
        });
    }
    onLeftChanged() {
        const colOrGroup = this.getColumnOrGroup();
        const left = colOrGroup.getLeft();
        this.actualLeft = this.modifyLeftForPrintLayout(colOrGroup, left);
        this.setLeft(this.actualLeft);
    }
    modifyLeftForPrintLayout(colOrGroup, leftPosition) {
        const printLayout = this.beans.gos.isDomLayout("print");
        if (!printLayout) return leftPosition;
        if (colOrGroup.getPinned() === "left") return leftPosition;
        const leftWidth = this.beans.columnModel.getDisplayedColumnsLeftWidth();
        if (colOrGroup.getPinned() === "right") {
            const bodyWidth = this.beans.columnModel.getBodyContainerWidth();
            return leftWidth + bodyWidth + leftPosition;
        }
        return leftWidth + leftPosition;
    }
    setLeft(value) {
        if ($437b23f6a393c3bf$var$exists(value)) this.eCell.style.left = `${value}px`;
        let indexColumn;
        if (this.columnOrGroup instanceof $437b23f6a393c3bf$export$816b5d811295e6bc) indexColumn = this.columnOrGroup;
        else {
            const columnGroup = this.columnOrGroup;
            const children = columnGroup.getLeafColumns();
            if (!children.length) return;
            if (children.length > 1) $437b23f6a393c3bf$var$setAriaColSpan(this.ariaEl, children.length);
            indexColumn = children[0];
        }
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$export$84c1fb51ab89c7b5.prototype, "postConstruct", 1);
// community-modules/core/src/headerRendering/cells/hoverFeature.ts
var $437b23f6a393c3bf$var$HoverFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(columns, element){
        super();
        this.columns = columns;
        this.element = element;
    }
    postConstruct() {
        if (this.gos.get("columnHoverHighlight")) this.addMouseHoverListeners();
    }
    addMouseHoverListeners() {
        this.addManagedListener(this.element, "mouseout", this.onMouseOut.bind(this));
        this.addManagedListener(this.element, "mouseover", this.onMouseOver.bind(this));
    }
    onMouseOut() {
        this.columnHoverService.clearMouseOver();
    }
    onMouseOver() {
        this.columnHoverService.setMouseOver(this.columns);
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnHoverService")
], $437b23f6a393c3bf$var$HoverFeature.prototype, "columnHoverService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$HoverFeature.prototype, "postConstruct", 1);
// community-modules/core/src/headerRendering/cells/floatingFilter/headerFilterCellCtrl.ts
var $437b23f6a393c3bf$export$65579fe86751e033 = class extends $437b23f6a393c3bf$export$879ff627d5a4d5c {
    constructor(column, beans, parentRowCtrl){
        super(column, beans, parentRowCtrl);
        this.iconCreated = false;
        this.column = column;
    }
    setComp(comp, eGui, eButtonShowMainFilter, eFloatingFilterBody) {
        this.comp = comp;
        this.eButtonShowMainFilter = eButtonShowMainFilter;
        this.eFloatingFilterBody = eFloatingFilterBody;
        this.setGui(eGui);
        this.setupActive();
        this.setupWidth();
        this.setupLeft();
        this.setupHover();
        this.setupFocus();
        this.setupAria();
        this.setupFilterButton();
        this.setupUserComp();
        this.setupSyncWithFilter();
        this.setupUi();
        this.addManagedListener(this.eButtonShowMainFilter, "click", this.showParentFilter.bind(this));
        this.setupFilterChangedListener();
        this.addManagedListener(this.column, $437b23f6a393c3bf$export$816b5d811295e6bc.EVENT_COL_DEF_CHANGED, this.onColDefChanged.bind(this));
    }
    // empty abstract method
    resizeHeader() {}
    // empty abstract method
    moveHeader() {}
    setupActive() {
        const colDef = this.column.getColDef();
        const filterExists = !!colDef.filter;
        const floatingFilterExists = !!colDef.floatingFilter;
        this.active = filterExists && floatingFilterExists;
    }
    setupUi() {
        this.comp.setButtonWrapperDisplayed(!this.suppressFilterButton && this.active);
        this.comp.addOrRemoveBodyCssClass("ag-floating-filter-full-body", this.suppressFilterButton);
        this.comp.addOrRemoveBodyCssClass("ag-floating-filter-body", !this.suppressFilterButton);
        if (!this.active || this.iconCreated) return;
        const eMenuIcon = $437b23f6a393c3bf$var$createIconNoSpan("filter", this.gos, this.column);
        if (eMenuIcon) {
            this.iconCreated = true;
            this.eButtonShowMainFilter.appendChild(eMenuIcon);
        }
    }
    setupFocus() {
        this.createManagedBean(new $437b23f6a393c3bf$export$5510e53ed3962582(this.eGui, {
            shouldStopEventPropagation: this.shouldStopEventPropagation.bind(this),
            onTabKeyDown: this.onTabKeyDown.bind(this),
            handleKeyDown: this.handleKeyDown.bind(this),
            onFocusIn: this.onFocusIn.bind(this)
        }));
    }
    setupAria() {
        const localeTextFunc = this.localeService.getLocaleTextFunc();
        $437b23f6a393c3bf$var$setAriaLabel(this.eButtonShowMainFilter, localeTextFunc("ariaFilterMenuOpen", "Open Filter Menu"));
    }
    onTabKeyDown(e) {
        const activeEl = this.gos.getActiveDomElement();
        const wrapperHasFocus = activeEl === this.eGui;
        if (wrapperHasFocus) return;
        const nextFocusableEl = this.focusService.findNextFocusableElement(this.eGui, null, e.shiftKey);
        if (nextFocusableEl) {
            this.beans.headerNavigationService.scrollToColumn(this.column);
            e.preventDefault();
            nextFocusableEl.focus();
            return;
        }
        const nextFocusableColumn = this.findNextColumnWithFloatingFilter(e.shiftKey);
        if (!nextFocusableColumn) return;
        if (this.focusService.focusHeaderPosition({
            headerPosition: {
                headerRowIndex: this.getParentRowCtrl().getRowIndex(),
                column: nextFocusableColumn
            },
            event: e
        })) e.preventDefault();
    }
    findNextColumnWithFloatingFilter(backwards) {
        const columnModel = this.beans.columnModel;
        let nextCol = this.column;
        do {
            nextCol = backwards ? columnModel.getDisplayedColBefore(nextCol) : columnModel.getDisplayedColAfter(nextCol);
            if (!nextCol) break;
        }while (!nextCol.getColDef().filter || !nextCol.getColDef().floatingFilter);
        return nextCol;
    }
    handleKeyDown(e) {
        super.handleKeyDown(e);
        const wrapperHasFocus = this.getWrapperHasFocus();
        switch(e.key){
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
                if (!wrapperHasFocus) e.preventDefault();
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT:
                if (wrapperHasFocus) return;
                e.stopPropagation();
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER:
                if (wrapperHasFocus) {
                    if (this.focusService.focusInto(this.eGui)) e.preventDefault();
                }
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ESCAPE:
                if (!wrapperHasFocus) this.eGui.focus();
        }
    }
    onFocusIn(e) {
        const isRelatedWithin = this.eGui.contains(e.relatedTarget);
        if (isRelatedWithin) return;
        const notFromHeaderWrapper = !!e.relatedTarget && !e.relatedTarget.classList.contains("ag-floating-filter");
        const fromWithinHeader = !!e.relatedTarget && $437b23f6a393c3bf$var$isElementChildOfClass(e.relatedTarget, "ag-floating-filter");
        if (notFromHeaderWrapper && fromWithinHeader && e.target === this.eGui) {
            const lastFocusEvent = this.lastFocusEvent;
            const fromTab = !!(lastFocusEvent && lastFocusEvent.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB);
            if (lastFocusEvent && fromTab) {
                const shouldFocusLast = lastFocusEvent.shiftKey;
                this.focusService.focusInto(this.eGui, shouldFocusLast);
            }
        }
        const rowIndex = this.getRowIndex();
        this.beans.focusService.setFocusedHeader(rowIndex, this.column);
    }
    setupHover() {
        this.createManagedBean(new $437b23f6a393c3bf$var$HoverFeature([
            this.column
        ], this.eGui));
        const listener = ()=>{
            if (!this.gos.get("columnHoverHighlight")) return;
            const hovered = this.beans.columnHoverService.isHovered(this.column);
            this.comp.addOrRemoveCssClass("ag-column-hover", hovered);
        };
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_HOVER_CHANGED, listener);
        listener();
    }
    setupLeft() {
        const setLeftFeature = new $437b23f6a393c3bf$export$84c1fb51ab89c7b5(this.column, this.eGui, this.beans);
        this.createManagedBean(setLeftFeature);
    }
    setupFilterButton() {
        this.suppressFilterButton = !this.menuService.isFloatingFilterButtonEnabled(this.column);
        this.highlightFilterButtonWhenActive = !this.menuService.isLegacyMenuEnabled();
    }
    setupUserComp() {
        if (!this.active) return;
        const compDetails = this.beans.filterManager.getFloatingFilterCompDetails(this.column, ()=>this.showParentFilter());
        if (compDetails) this.setCompDetails(compDetails);
    }
    setCompDetails(compDetails) {
        this.userCompDetails = compDetails;
        this.comp.setCompDetails(compDetails);
    }
    showParentFilter() {
        const eventSource = this.suppressFilterButton ? this.eFloatingFilterBody : this.eButtonShowMainFilter;
        this.menuService.showFilterMenu({
            column: this.column,
            buttonElement: eventSource,
            containerType: "floatingFilter",
            positionBy: "button"
        });
    }
    setupSyncWithFilter() {
        if (!this.active) return;
        const { filterManager: filterManager } = this.beans;
        const syncWithFilter = (event)=>{
            if ((event == null ? void 0 : event.source) === "filterDestroyed" && this.context.isDestroyed()) return;
            const compPromise = this.comp.getFloatingFilterComp();
            if (!compPromise) return;
            compPromise.then((comp)=>{
                var _a;
                if (comp) {
                    const parentModel = filterManager.getCurrentFloatingFilterParentModel(this.column);
                    comp.onParentModelChanged(parentModel, event ? this.gos.addGridCommonParams({
                        columns: (_a = event.columns) != null ? _a : [],
                        type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_FILTER_CHANGED,
                        source: event.source === "api" ? "api" : "columnFilter"
                    }) : null);
                }
            });
        };
        this.destroySyncListener = this.addManagedListener(this.column, $437b23f6a393c3bf$export$816b5d811295e6bc.EVENT_FILTER_CHANGED, syncWithFilter);
        if (filterManager.isFilterActive(this.column)) syncWithFilter(null);
    }
    setupWidth() {
        const listener = ()=>{
            const width = `${this.column.getActualWidth()}px`;
            this.comp.setWidth(width);
        };
        this.addManagedListener(this.column, $437b23f6a393c3bf$export$816b5d811295e6bc.EVENT_WIDTH_CHANGED, listener);
        listener();
    }
    setupFilterChangedListener() {
        if (this.active) {
            this.destroyFilterChangedListener = this.addManagedListener(this.column, $437b23f6a393c3bf$export$816b5d811295e6bc.EVENT_FILTER_CHANGED, this.updateFilterButton.bind(this));
            this.updateFilterButton();
        }
    }
    updateFilterButton() {
        if (!this.suppressFilterButton && this.comp) {
            const isFilterAllowed = this.beans.filterManager.isFilterAllowed(this.column);
            this.comp.setButtonWrapperDisplayed(isFilterAllowed);
            if (this.highlightFilterButtonWhenActive && isFilterAllowed) this.eButtonShowMainFilter.classList.toggle("ag-filter-active", this.column.isFilterActive());
        }
    }
    onColDefChanged() {
        var _a, _b;
        const wasActive = this.active;
        this.setupActive();
        const becomeActive = !wasActive && this.active;
        if (wasActive && !this.active) {
            (_a = this.destroySyncListener) == null || _a.call(this);
            (_b = this.destroyFilterChangedListener) == null || _b.call(this);
        }
        const newCompDetails = this.active ? this.beans.filterManager.getFloatingFilterCompDetails(this.column, ()=>this.showParentFilter()) : null;
        const compPromise = this.comp.getFloatingFilterComp();
        if (!compPromise || !newCompDetails) this.updateCompDetails(newCompDetails, becomeActive);
        else compPromise.then((compInstance)=>{
            var _a2;
            if (!compInstance || this.beans.filterManager.areFilterCompsDifferent((_a2 = this.userCompDetails) != null ? _a2 : null, newCompDetails)) this.updateCompDetails(newCompDetails, becomeActive);
            else this.updateFloatingFilterParams(newCompDetails);
        });
    }
    updateCompDetails(compDetails, becomeActive) {
        if (!this.isAlive()) return;
        this.setCompDetails(compDetails);
        this.setupFilterButton();
        this.setupUi();
        if (becomeActive) {
            this.setupSyncWithFilter();
            this.setupFilterChangedListener();
        }
    }
    updateFloatingFilterParams(userCompDetails) {
        var _a;
        if (!userCompDetails) return;
        const params = userCompDetails.params;
        (_a = this.comp.getFloatingFilterComp()) == null || _a.then((floatingFilter)=>{
            let hasRefreshed = false;
            if ((floatingFilter == null ? void 0 : floatingFilter.refresh) && typeof floatingFilter.refresh === "function") {
                const result = floatingFilter.refresh(params);
                if (result !== null) hasRefreshed = true;
            }
            if (!hasRefreshed && (floatingFilter == null ? void 0 : floatingFilter.onParamsUpdated) && typeof floatingFilter.onParamsUpdated === "function") {
                const result = floatingFilter.onParamsUpdated(params);
                if (result !== null) $437b23f6a393c3bf$var$warnOnce(`Custom floating filter method 'onParamsUpdated' is deprecated. Use 'refresh' instead.`);
            }
        });
    }
    destroy() {
        super.destroy();
        this.eButtonShowMainFilter = null;
        this.eFloatingFilterBody = null;
        this.userCompDetails = null;
        this.destroySyncListener = null;
        this.destroyFilterChangedListener = null;
    }
};
// community-modules/core/src/headerRendering/cells/column/resizeFeature.ts
var $437b23f6a393c3bf$var$ResizeFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(pinned, column, eResize, comp, ctrl){
        super();
        this.pinned = pinned;
        this.column = column;
        this.eResize = eResize;
        this.comp = comp;
        this.ctrl = ctrl;
    }
    postConstruct() {
        const destroyResizeFuncs = [];
        let canResize;
        let canAutosize;
        const addResize = ()=>{
            $437b23f6a393c3bf$var$setDisplayed(this.eResize, canResize);
            if (!canResize) return;
            const finishedWithResizeFunc = this.horizontalResizeService.addResizeBar({
                eResizeBar: this.eResize,
                onResizeStart: this.onResizeStart.bind(this),
                onResizing: this.onResizing.bind(this, false),
                onResizeEnd: this.onResizing.bind(this, true)
            });
            destroyResizeFuncs.push(finishedWithResizeFunc);
            if (canAutosize) {
                const skipHeaderOnAutoSize = this.gos.get("skipHeaderOnAutoSize");
                const autoSizeColListener = ()=>{
                    this.columnModel.autoSizeColumn(this.column, "uiColumnResized", skipHeaderOnAutoSize);
                };
                this.eResize.addEventListener("dblclick", autoSizeColListener);
                const touchListener = new $437b23f6a393c3bf$export$7b2e93987414b382(this.eResize);
                touchListener.addEventListener($437b23f6a393c3bf$export$7b2e93987414b382.EVENT_DOUBLE_TAP, autoSizeColListener);
                destroyResizeFuncs.push(()=>{
                    this.eResize.removeEventListener("dblclick", autoSizeColListener);
                    touchListener.removeEventListener($437b23f6a393c3bf$export$7b2e93987414b382.EVENT_DOUBLE_TAP, autoSizeColListener);
                    touchListener.destroy();
                });
            }
        };
        const removeResize = ()=>{
            destroyResizeFuncs.forEach((f)=>f());
            destroyResizeFuncs.length = 0;
        };
        const refresh = ()=>{
            const resize = this.column.isResizable();
            const autoSize = !this.gos.get("suppressAutoSize") && !this.column.getColDef().suppressAutoSize;
            const propertyChange = resize !== canResize || autoSize !== canAutosize;
            if (propertyChange) {
                canResize = resize;
                canAutosize = autoSize;
                removeResize();
                addResize();
            }
        };
        refresh();
        this.addDestroyFunc(removeResize);
        this.ctrl.addRefreshFunction(refresh);
    }
    onResizing(finished, resizeAmount) {
        const { column: key, lastResizeAmount: lastResizeAmount, resizeStartWidth: resizeStartWidth } = this;
        const resizeAmountNormalised = this.normaliseResizeAmount(resizeAmount);
        const newWidth = resizeStartWidth + resizeAmountNormalised;
        const columnWidths = [
            {
                key: key,
                newWidth: newWidth
            }
        ];
        if (this.column.getPinned()) {
            const leftWidth = this.pinnedWidthService.getPinnedLeftWidth();
            const rightWidth = this.pinnedWidthService.getPinnedRightWidth();
            const bodyWidth = $437b23f6a393c3bf$var$getInnerWidth(this.ctrlsService.getGridBodyCtrl().getBodyViewportElement()) - 50;
            if (leftWidth + rightWidth + (resizeAmountNormalised - lastResizeAmount) > bodyWidth) return;
        }
        this.lastResizeAmount = resizeAmountNormalised;
        this.columnModel.setColumnWidths(columnWidths, this.resizeWithShiftKey, finished, "uiColumnResized");
        if (finished) this.toggleColumnResizing(false);
    }
    onResizeStart(shiftKey) {
        this.resizeStartWidth = this.column.getActualWidth();
        this.lastResizeAmount = 0;
        this.resizeWithShiftKey = shiftKey;
        this.toggleColumnResizing(true);
    }
    toggleColumnResizing(resizing) {
        this.comp.addOrRemoveCssClass("ag-column-resizing", resizing);
    }
    // optionally inverts the drag, depending on pinned and RTL
    // note - this method is duplicated in RenderedHeaderGroupCell - should refactor out?
    normaliseResizeAmount(dragChange) {
        let result = dragChange;
        const notPinningLeft = this.pinned !== "left";
        const pinningRight = this.pinned === "right";
        if (this.gos.get("enableRtl")) {
            if (notPinningLeft) result *= -1;
        } else if (pinningRight) result *= -1;
        return result;
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("horizontalResizeService")
], $437b23f6a393c3bf$var$ResizeFeature.prototype, "horizontalResizeService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("pinnedWidthService")
], $437b23f6a393c3bf$var$ResizeFeature.prototype, "pinnedWidthService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("ctrlsService")
], $437b23f6a393c3bf$var$ResizeFeature.prototype, "ctrlsService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnModel")
], $437b23f6a393c3bf$var$ResizeFeature.prototype, "columnModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$ResizeFeature.prototype, "postConstruct", 1);
// community-modules/core/src/headerRendering/cells/column/selectAllFeature.ts
var $437b23f6a393c3bf$var$SelectAllFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(column){
        super();
        this.cbSelectAllVisible = false;
        this.processingEventFromCheckbox = false;
        this.column = column;
    }
    onSpaceKeyDown(e) {
        const checkbox = this.cbSelectAll;
        if (checkbox.isDisplayed() && !checkbox.getGui().contains(this.gos.getActiveDomElement())) {
            e.preventDefault();
            checkbox.setValue(!checkbox.getValue());
        }
    }
    getCheckboxGui() {
        return this.cbSelectAll.getGui();
    }
    setComp(ctrl) {
        this.headerCellCtrl = ctrl;
        this.cbSelectAll = this.createManagedBean(new $437b23f6a393c3bf$export$b00c508c1ae18d07());
        this.cbSelectAll.addCssClass("ag-header-select-all");
        $437b23f6a393c3bf$var$setAriaRole(this.cbSelectAll.getGui(), "presentation");
        this.showOrHideSelectAll();
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_NEW_COLUMNS_LOADED, this.onNewColumnsLoaded.bind(this));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_SELECTION_CHANGED, this.onSelectionChanged.bind(this));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_PAGINATION_CHANGED, this.onSelectionChanged.bind(this));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_MODEL_UPDATED, this.onModelChanged.bind(this));
        this.addManagedListener(this.cbSelectAll, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_FIELD_VALUE_CHANGED, this.onCbSelectAll.bind(this));
        $437b23f6a393c3bf$var$setAriaHidden(this.cbSelectAll.getGui(), true);
        this.cbSelectAll.getInputElement().setAttribute("tabindex", "-1");
        this.refreshSelectAllLabel();
    }
    onNewColumnsLoaded() {
        this.showOrHideSelectAll();
    }
    onDisplayedColumnsChanged() {
        if (!this.isAlive()) return;
        this.showOrHideSelectAll();
    }
    showOrHideSelectAll() {
        this.cbSelectAllVisible = this.isCheckboxSelection();
        this.cbSelectAll.setDisplayed(this.cbSelectAllVisible, {
            skipAriaHidden: true
        });
        if (this.cbSelectAllVisible) {
            this.checkRightRowModelType("selectAllCheckbox");
            this.checkSelectionType("selectAllCheckbox");
            this.updateStateOfCheckbox();
        }
        this.refreshSelectAllLabel();
    }
    onModelChanged() {
        if (!this.cbSelectAllVisible) return;
        this.updateStateOfCheckbox();
    }
    onSelectionChanged() {
        if (!this.cbSelectAllVisible) return;
        this.updateStateOfCheckbox();
    }
    updateStateOfCheckbox() {
        if (this.processingEventFromCheckbox) return;
        this.processingEventFromCheckbox = true;
        const allSelected = this.selectionService.getSelectAllState(this.isFilteredOnly(), this.isCurrentPageOnly());
        this.cbSelectAll.setValue(allSelected);
        const hasNodesToSelect = this.selectionService.hasNodesToSelect(this.isFilteredOnly(), this.isCurrentPageOnly());
        this.cbSelectAll.setDisabled(!hasNodesToSelect);
        this.refreshSelectAllLabel();
        this.processingEventFromCheckbox = false;
    }
    refreshSelectAllLabel() {
        const translate = this.localeService.getLocaleTextFunc();
        const checked = this.cbSelectAll.getValue();
        const ariaStatus = checked ? translate("ariaChecked", "checked") : translate("ariaUnchecked", "unchecked");
        const ariaLabel = translate("ariaRowSelectAll", "Press Space to toggle all rows selection");
        if (!this.cbSelectAllVisible) this.headerCellCtrl.setAriaDescriptionProperty("selectAll", null);
        else this.headerCellCtrl.setAriaDescriptionProperty("selectAll", `${ariaLabel} (${ariaStatus})`);
        this.cbSelectAll.setInputAriaLabel(`${ariaLabel} (${ariaStatus})`);
        this.headerCellCtrl.announceAriaDescription();
    }
    checkSelectionType(feature) {
        const isMultiSelect = this.gos.get("rowSelection") === "multiple";
        if (!isMultiSelect) {
            console.warn(`AG Grid: ${feature} is only available if using 'multiple' rowSelection.`);
            return false;
        }
        return true;
    }
    checkRightRowModelType(feature) {
        const rowModelType = this.rowModel.getType();
        const rowModelMatches = rowModelType === "clientSide" || rowModelType === "serverSide";
        if (!rowModelMatches) {
            console.warn(`AG Grid: ${feature} is only available if using 'clientSide' or 'serverSide' rowModelType, you are using ${rowModelType}.`);
            return false;
        }
        return true;
    }
    onCbSelectAll() {
        if (this.processingEventFromCheckbox) return;
        if (!this.cbSelectAllVisible) return;
        const value = this.cbSelectAll.getValue();
        const justFiltered = this.isFilteredOnly();
        const justCurrentPage = this.isCurrentPageOnly();
        let source = "uiSelectAll";
        if (justCurrentPage) source = "uiSelectAllCurrentPage";
        else if (justFiltered) source = "uiSelectAllFiltered";
        const params = {
            source: source,
            justFiltered: justFiltered,
            justCurrentPage: justCurrentPage
        };
        if (value) this.selectionService.selectAllRowNodes(params);
        else this.selectionService.deselectAllRowNodes(params);
    }
    isCheckboxSelection() {
        let result = this.column.getColDef().headerCheckboxSelection;
        if (typeof result === "function") {
            const func = result;
            const params = this.gos.addGridCommonParams({
                column: this.column,
                colDef: this.column.getColDef()
            });
            result = func(params);
        }
        if (result) return this.checkRightRowModelType("headerCheckboxSelection") && this.checkSelectionType("headerCheckboxSelection");
        return false;
    }
    isFilteredOnly() {
        return !!this.column.getColDef().headerCheckboxSelectionFilteredOnly;
    }
    isCurrentPageOnly() {
        return !!this.column.getColDef().headerCheckboxSelectionCurrentPageOnly;
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowModel")
], $437b23f6a393c3bf$var$SelectAllFeature.prototype, "rowModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("selectionService")
], $437b23f6a393c3bf$var$SelectAllFeature.prototype, "selectionService", 2);
// community-modules/core/src/headerRendering/cells/column/headerCellCtrl.ts
var $437b23f6a393c3bf$export$8a024062e840d3f5 = class extends $437b23f6a393c3bf$export$879ff627d5a4d5c {
    constructor(column, beans, parentRowCtrl){
        super(column, beans, parentRowCtrl);
        this.refreshFunctions = [];
        this.userHeaderClasses = /* @__PURE__ */ new Set();
        this.ariaDescriptionProperties = /* @__PURE__ */ new Map();
        this.column = column;
    }
    setComp(comp, eGui, eResize, eHeaderCompWrapper) {
        this.comp = comp;
        this.setGui(eGui);
        this.updateState();
        this.setupWidth();
        this.setupMovingCss();
        this.setupMenuClass();
        this.setupSortableClass();
        this.setupWrapTextClass();
        this.refreshSpanHeaderHeight();
        this.setupAutoHeight(eHeaderCompWrapper);
        this.addColumnHoverListener();
        this.setupFilterClass();
        this.setupClassesFromColDef();
        this.setupTooltip();
        this.addActiveHeaderMouseListeners();
        this.setupSelectAll();
        this.setupUserComp();
        this.refreshAria();
        this.resizeFeature = this.createManagedBean(new $437b23f6a393c3bf$var$ResizeFeature(this.getPinned(), this.column, eResize, comp, this));
        this.createManagedBean(new $437b23f6a393c3bf$var$HoverFeature([
            this.column
        ], eGui));
        this.createManagedBean(new $437b23f6a393c3bf$export$84c1fb51ab89c7b5(this.column, eGui, this.beans));
        this.createManagedBean(new $437b23f6a393c3bf$export$5510e53ed3962582(eGui, {
            shouldStopEventPropagation: (e)=>this.shouldStopEventPropagation(e),
            onTabKeyDown: ()=>null,
            handleKeyDown: this.handleKeyDown.bind(this),
            onFocusIn: this.onFocusIn.bind(this),
            onFocusOut: this.onFocusOut.bind(this)
        }));
        this.addResizeAndMoveKeyboardListeners();
        this.addManagedPropertyListeners([
            "suppressMovableColumns",
            "suppressMenuHide",
            "suppressAggFuncInHeader"
        ], this.refresh.bind(this));
        this.addManagedListener(this.column, $437b23f6a393c3bf$export$816b5d811295e6bc.EVENT_COL_DEF_CHANGED, this.refresh.bind(this));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_VALUE_CHANGED, this.onColumnValueChanged.bind(this));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_ROW_GROUP_CHANGED, this.onColumnRowGroupChanged.bind(this));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_PIVOT_CHANGED, this.onColumnPivotChanged.bind(this));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_HEADER_HEIGHT_CHANGED, this.onHeaderHeightChanged.bind(this));
    }
    resizeHeader(delta, shiftKey) {
        var _a, _b;
        if (!this.column.isResizable()) return;
        const actualWidth = this.column.getActualWidth();
        const minWidth = (_a = this.column.getMinWidth()) != null ? _a : 0;
        const maxWidth = (_b = this.column.getMaxWidth()) != null ? _b : Number.MAX_SAFE_INTEGER;
        const newWidth = Math.min(Math.max(actualWidth + delta, minWidth), maxWidth);
        this.beans.columnModel.setColumnWidths([
            {
                key: this.column,
                newWidth: newWidth
            }
        ], shiftKey, true, "uiColumnResized");
    }
    moveHeader(hDirection) {
        const { eGui: eGui, column: column, gos: gos, ctrlsService: ctrlsService } = this;
        const pinned = this.getPinned();
        const left = eGui.getBoundingClientRect().left;
        const width = column.getActualWidth();
        const isRtl = gos.get("enableRtl");
        const isLeft = hDirection === 0 /* Left */  !== isRtl;
        const xPosition = $437b23f6a393c3bf$var$ColumnMoveHelper.normaliseX(isLeft ? left - 20 : left + width + 20, pinned, true, gos, ctrlsService);
        $437b23f6a393c3bf$var$ColumnMoveHelper.attemptMoveColumns({
            allMovingColumns: [
                column
            ],
            isFromHeader: true,
            hDirection: hDirection,
            xPosition: xPosition,
            pinned: pinned,
            fromEnter: false,
            fakeEvent: false,
            gos: gos,
            columnModel: this.beans.columnModel
        });
        ctrlsService.getGridBodyCtrl().getScrollFeature().ensureColumnVisible(column, "auto");
    }
    setupUserComp() {
        const compDetails = this.lookupUserCompDetails();
        this.setCompDetails(compDetails);
    }
    setCompDetails(compDetails) {
        this.userCompDetails = compDetails;
        this.comp.setUserCompDetails(compDetails);
    }
    lookupUserCompDetails() {
        const params = this.createParams();
        const colDef = this.column.getColDef();
        return this.userComponentFactory.getHeaderCompDetails(colDef, params);
    }
    createParams() {
        const params = this.gos.addGridCommonParams({
            column: this.column,
            displayName: this.displayName,
            enableSorting: this.column.isSortable(),
            enableMenu: this.menuEnabled,
            enableFilterButton: this.openFilterEnabled && this.menuService.isHeaderFilterButtonEnabled(this.column),
            enableFilterIcon: !this.openFilterEnabled || this.menuService.isLegacyMenuEnabled(),
            showColumnMenu: (buttonElement)=>{
                this.menuService.showColumnMenu({
                    column: this.column,
                    buttonElement: buttonElement,
                    positionBy: "button"
                });
            },
            showColumnMenuAfterMouseClick: (mouseEvent)=>{
                this.menuService.showColumnMenu({
                    column: this.column,
                    mouseEvent: mouseEvent,
                    positionBy: "mouse"
                });
            },
            showFilter: (buttonElement)=>{
                this.menuService.showFilterMenu({
                    column: this.column,
                    buttonElement: buttonElement,
                    containerType: "columnFilter",
                    positionBy: "button"
                });
            },
            progressSort: (multiSort)=>{
                this.beans.sortController.progressSort(this.column, !!multiSort, "uiColumnSorted");
            },
            setSort: (sort, multiSort)=>{
                this.beans.sortController.setSortForColumn(this.column, sort, !!multiSort, "uiColumnSorted");
            },
            eGridHeader: this.getGui(),
            setTooltip: (value, shouldDisplayTooltip)=>{
                this.setupTooltip(value, shouldDisplayTooltip);
            }
        });
        return params;
    }
    setupSelectAll() {
        this.selectAllFeature = this.createManagedBean(new $437b23f6a393c3bf$var$SelectAllFeature(this.column));
        this.selectAllFeature.setComp(this);
    }
    getSelectAllGui() {
        return this.selectAllFeature.getCheckboxGui();
    }
    handleKeyDown(e) {
        super.handleKeyDown(e);
        if (e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.SPACE) this.selectAllFeature.onSpaceKeyDown(e);
        if (e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER) this.onEnterKeyDown(e);
        if (e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN && e.altKey) this.showMenuOnKeyPress(e, false);
    }
    onEnterKeyDown(e) {
        if (e.ctrlKey || e.metaKey) this.showMenuOnKeyPress(e, true);
        else if (this.sortable) {
            const multiSort = e.shiftKey;
            this.beans.sortController.progressSort(this.column, multiSort, "uiColumnSorted");
        }
    }
    showMenuOnKeyPress(e, isFilterShortcut) {
        const headerComp = this.comp.getUserCompInstance();
        if (!headerComp || !(headerComp instanceof $437b23f6a393c3bf$var$HeaderComp)) return;
        if (headerComp.onMenuKeyboardShortcut(isFilterShortcut)) e.preventDefault();
    }
    onFocusIn(e) {
        if (!this.getGui().contains(e.relatedTarget)) {
            const rowIndex = this.getRowIndex();
            this.focusService.setFocusedHeader(rowIndex, this.column);
            this.announceAriaDescription();
        }
        if (this.focusService.isKeyboardMode()) this.setActiveHeader(true);
    }
    onFocusOut(e) {
        if (this.getGui().contains(e.relatedTarget)) return;
        this.setActiveHeader(false);
    }
    setupTooltip(value, shouldDisplayTooltip) {
        if (this.tooltipFeature) this.tooltipFeature = this.destroyBean(this.tooltipFeature);
        const isTooltipWhenTruncated = this.gos.get("tooltipShowMode") === "whenTruncated";
        const eGui = this.eGui;
        const colDef = this.column.getColDef();
        if (!shouldDisplayTooltip && isTooltipWhenTruncated && !colDef.headerComponent) shouldDisplayTooltip = ()=>{
            const textEl = eGui.querySelector(".ag-header-cell-text");
            if (!textEl) return true;
            return textEl.scrollWidth > textEl.clientWidth;
        };
        const tooltipCtrl = {
            getColumn: ()=>this.column,
            getColDef: ()=>this.column.getColDef(),
            getGui: ()=>eGui,
            getLocation: ()=>"header",
            getTooltipValue: ()=>{
                if (value != null) return value;
                const res = this.column.getColDef().headerTooltip;
                return res;
            },
            shouldDisplayTooltip: shouldDisplayTooltip
        };
        const tooltipFeature = this.createManagedBean(new $437b23f6a393c3bf$export$e5073a590d24815c(tooltipCtrl));
        this.refreshFunctions.push(()=>tooltipFeature.refreshToolTip());
    }
    setupClassesFromColDef() {
        const refreshHeaderClasses = ()=>{
            const colDef = this.column.getColDef();
            const classes = $437b23f6a393c3bf$export$f90acfa36b600d3d.getHeaderClassesFromColDef(colDef, this.gos, this.column, null);
            const oldClasses = this.userHeaderClasses;
            this.userHeaderClasses = new Set(classes);
            classes.forEach((c)=>{
                if (oldClasses.has(c)) oldClasses.delete(c);
                else this.comp.addOrRemoveCssClass(c, true);
            });
            oldClasses.forEach((c)=>this.comp.addOrRemoveCssClass(c, false));
        };
        this.refreshFunctions.push(refreshHeaderClasses);
        refreshHeaderClasses();
    }
    setDragSource(eSource) {
        this.dragSourceElement = eSource;
        this.removeDragSource();
        if (!eSource || !this.draggable) return;
        const { column: column, beans: beans, displayName: displayName, dragAndDropService: dragAndDropService, gos: gos } = this;
        const { columnModel: columnModel } = beans;
        let hideColumnOnExit = !this.gos.get("suppressDragLeaveHidesColumns");
        const dragSource = this.dragSource = {
            type: 1 /* HeaderCell */ ,
            eElement: eSource,
            getDefaultIconName: ()=>hideColumnOnExit ? $437b23f6a393c3bf$export$3529111922becfa6.ICON_HIDE : $437b23f6a393c3bf$export$3529111922becfa6.ICON_NOT_ALLOWED,
            getDragItem: ()=>this.createDragItem(column),
            dragItemName: displayName,
            onDragStarted: ()=>{
                hideColumnOnExit = !gos.get("suppressDragLeaveHidesColumns");
                column.setMoving(true, "uiColumnMoved");
            },
            onDragStopped: ()=>column.setMoving(false, "uiColumnMoved"),
            onGridEnter: (dragItem)=>{
                var _a;
                if (hideColumnOnExit) {
                    const unlockedColumns = ((_a = dragItem == null ? void 0 : dragItem.columns) == null ? void 0 : _a.filter((col)=>!col.getColDef().lockVisible)) || [];
                    columnModel.setColumnsVisible(unlockedColumns, true, "uiColumnMoved");
                }
            },
            onGridExit: (dragItem)=>{
                var _a;
                if (hideColumnOnExit) {
                    const unlockedColumns = ((_a = dragItem == null ? void 0 : dragItem.columns) == null ? void 0 : _a.filter((col)=>!col.getColDef().lockVisible)) || [];
                    columnModel.setColumnsVisible(unlockedColumns, false, "uiColumnMoved");
                }
            }
        };
        dragAndDropService.addDragSource(dragSource, true);
    }
    createDragItem(column) {
        const visibleState = {};
        visibleState[column.getId()] = column.isVisible();
        return {
            columns: [
                column
            ],
            visibleState: visibleState
        };
    }
    updateState() {
        this.menuEnabled = this.menuService.isColumnMenuInHeaderEnabled(this.column);
        this.openFilterEnabled = this.menuService.isFilterMenuInHeaderEnabled(this.column);
        this.sortable = this.column.isSortable();
        this.displayName = this.calculateDisplayName();
        this.draggable = this.workOutDraggable();
    }
    addRefreshFunction(func) {
        this.refreshFunctions.push(func);
    }
    refresh() {
        this.updateState();
        this.refreshHeaderComp();
        this.refreshAria();
        this.refreshFunctions.forEach((f)=>f());
    }
    refreshHeaderComp() {
        const newCompDetails = this.lookupUserCompDetails();
        const compInstance = this.comp.getUserCompInstance();
        const attemptRefresh = compInstance != null && this.userCompDetails.componentClass == newCompDetails.componentClass;
        const headerCompRefreshed = attemptRefresh ? this.attemptHeaderCompRefresh(newCompDetails.params) : false;
        if (headerCompRefreshed) this.setDragSource(this.dragSourceElement);
        else this.setCompDetails(newCompDetails);
    }
    attemptHeaderCompRefresh(params) {
        const headerComp = this.comp.getUserCompInstance();
        if (!headerComp) return false;
        if (!headerComp.refresh) return false;
        const res = headerComp.refresh(params);
        return res;
    }
    calculateDisplayName() {
        return this.beans.columnModel.getDisplayNameForColumn(this.column, "header", true);
    }
    checkDisplayName() {
        if (this.displayName !== this.calculateDisplayName()) this.refresh();
    }
    workOutDraggable() {
        const colDef = this.column.getColDef();
        const isSuppressMovableColumns = this.gos.get("suppressMovableColumns");
        const colCanMove = !isSuppressMovableColumns && !colDef.suppressMovable && !colDef.lockPosition;
        return !!colCanMove || !!colDef.enableRowGroup || !!colDef.enablePivot;
    }
    onColumnRowGroupChanged() {
        this.checkDisplayName();
    }
    onColumnPivotChanged() {
        this.checkDisplayName();
    }
    onColumnValueChanged() {
        this.checkDisplayName();
    }
    setupWidth() {
        const listener = ()=>{
            const columnWidth = this.column.getActualWidth();
            this.comp.setWidth(`${columnWidth}px`);
        };
        this.addManagedListener(this.column, $437b23f6a393c3bf$export$816b5d811295e6bc.EVENT_WIDTH_CHANGED, listener);
        listener();
    }
    setupMovingCss() {
        const listener = ()=>{
            this.comp.addOrRemoveCssClass("ag-header-cell-moving", this.column.isMoving());
        };
        this.addManagedListener(this.column, $437b23f6a393c3bf$export$816b5d811295e6bc.EVENT_MOVING_CHANGED, listener);
        listener();
    }
    setupMenuClass() {
        const listener = ()=>{
            this.comp.addOrRemoveCssClass("ag-column-menu-visible", this.column.isMenuVisible());
        };
        this.addManagedListener(this.column, $437b23f6a393c3bf$export$816b5d811295e6bc.EVENT_MENU_VISIBLE_CHANGED, listener);
        listener();
    }
    setupSortableClass() {
        const updateSortableCssClass = ()=>{
            this.comp.addOrRemoveCssClass("ag-header-cell-sortable", !!this.sortable);
        };
        updateSortableCssClass();
        this.addRefreshFunction(updateSortableCssClass);
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$816b5d811295e6bc.EVENT_SORT_CHANGED, this.refreshAriaSort.bind(this));
    }
    setupFilterClass() {
        const listener = ()=>{
            const isFilterActive = this.column.isFilterActive();
            this.comp.addOrRemoveCssClass("ag-header-cell-filtered", isFilterActive);
            this.refreshAria();
        };
        this.addManagedListener(this.column, $437b23f6a393c3bf$export$816b5d811295e6bc.EVENT_FILTER_ACTIVE_CHANGED, listener);
        listener();
    }
    setupWrapTextClass() {
        const listener = ()=>{
            const wrapText = !!this.column.getColDef().wrapHeaderText;
            this.comp.addOrRemoveCssClass("ag-header-cell-wrap-text", wrapText);
        };
        listener();
        this.addRefreshFunction(listener);
    }
    onDisplayedColumnsChanged() {
        super.onDisplayedColumnsChanged();
        if (!this.isAlive()) return;
        this.onHeaderHeightChanged();
    }
    onHeaderHeightChanged() {
        this.refreshSpanHeaderHeight();
    }
    refreshSpanHeaderHeight() {
        const { eGui: eGui, column: column, comp: comp, beans: beans } = this;
        if (!column.isSpanHeaderHeight()) {
            eGui.style.removeProperty("top");
            eGui.style.removeProperty("height");
            comp.addOrRemoveCssClass("ag-header-span-height", false);
            comp.addOrRemoveCssClass("ag-header-span-total", false);
            return;
        }
        const { numberOfParents: numberOfParents, isSpanningTotal: isSpanningTotal } = this.column.getColumnGroupPaddingInfo();
        comp.addOrRemoveCssClass("ag-header-span-height", numberOfParents > 0);
        const { columnModel: columnModel } = beans;
        const headerHeight = columnModel.getColumnHeaderRowHeight();
        if (numberOfParents === 0) {
            comp.addOrRemoveCssClass("ag-header-span-total", false);
            eGui.style.setProperty("top", `0px`);
            eGui.style.setProperty("height", `${headerHeight}px`);
            return;
        }
        comp.addOrRemoveCssClass("ag-header-span-total", isSpanningTotal);
        const pivotMode = columnModel.isPivotMode();
        const groupHeaderHeight = pivotMode ? columnModel.getPivotGroupHeaderHeight() : columnModel.getGroupHeaderHeight();
        const extraHeight = numberOfParents * groupHeaderHeight;
        eGui.style.setProperty("top", `${-extraHeight}px`);
        eGui.style.setProperty("height", `${headerHeight + extraHeight}px`);
    }
    setupAutoHeight(wrapperElement) {
        const { columnModel: columnModel, resizeObserverService: resizeObserverService } = this.beans;
        const measureHeight = (timesCalled)=>{
            if (!this.isAlive()) return;
            const { paddingTop: paddingTop, paddingBottom: paddingBottom, borderBottomWidth: borderBottomWidth, borderTopWidth: borderTopWidth } = $437b23f6a393c3bf$var$getElementSize(this.getGui());
            const extraHeight = paddingTop + paddingBottom + borderBottomWidth + borderTopWidth;
            const wrapperHeight = wrapperElement.offsetHeight;
            const autoHeight = wrapperHeight + extraHeight;
            if (timesCalled < 5) {
                const doc = this.beans.gos.getDocument();
                const notYetInDom = !doc || !doc.contains(wrapperElement);
                const possiblyNoContentYet = autoHeight == 0;
                if (notYetInDom || possiblyNoContentYet) {
                    window.setTimeout(()=>measureHeight(timesCalled + 1), 0);
                    return;
                }
            }
            columnModel.setColumnHeaderHeight(this.column, autoHeight);
        };
        let isMeasuring = false;
        let stopResizeObserver;
        const checkMeasuring = ()=>{
            const newValue = this.column.isAutoHeaderHeight();
            if (newValue && !isMeasuring) startMeasuring();
            if (!newValue && isMeasuring) stopMeasuring();
        };
        const startMeasuring = ()=>{
            isMeasuring = true;
            measureHeight(0);
            this.comp.addOrRemoveCssClass("ag-header-cell-auto-height", true);
            stopResizeObserver = resizeObserverService.observeResize(wrapperElement, ()=>measureHeight(0));
        };
        const stopMeasuring = ()=>{
            isMeasuring = false;
            if (stopResizeObserver) stopResizeObserver();
            this.comp.addOrRemoveCssClass("ag-header-cell-auto-height", false);
            stopResizeObserver = void 0;
        };
        checkMeasuring();
        this.addDestroyFunc(()=>stopMeasuring());
        this.addManagedListener(this.column, $437b23f6a393c3bf$export$816b5d811295e6bc.EVENT_WIDTH_CHANGED, ()=>isMeasuring && measureHeight(0));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$816b5d811295e6bc.EVENT_SORT_CHANGED, ()=>{
            if (isMeasuring) window.setTimeout(()=>measureHeight(0));
        });
        this.addRefreshFunction(checkMeasuring);
    }
    refreshAriaSort() {
        if (this.sortable) {
            const translate = this.localeService.getLocaleTextFunc();
            const sort = this.beans.sortController.getDisplaySortForColumn(this.column) || null;
            this.comp.setAriaSort($437b23f6a393c3bf$var$getAriaSortState(sort));
            this.setAriaDescriptionProperty("sort", translate("ariaSortableColumn", "Press ENTER to sort"));
        } else {
            this.comp.setAriaSort();
            this.setAriaDescriptionProperty("sort", null);
        }
    }
    refreshAriaMenu() {
        if (this.menuEnabled) {
            const translate = this.localeService.getLocaleTextFunc();
            this.setAriaDescriptionProperty("menu", translate("ariaMenuColumn", "Press ALT DOWN to open column menu"));
        } else this.setAriaDescriptionProperty("menu", null);
    }
    refreshAriaFilterButton() {
        if (this.openFilterEnabled && !this.menuService.isLegacyMenuEnabled()) {
            const translate = this.localeService.getLocaleTextFunc();
            this.setAriaDescriptionProperty("filterButton", translate("ariaFilterColumn", "Press CTRL ENTER to open filter"));
        } else this.setAriaDescriptionProperty("filterButton", null);
    }
    refreshAriaFiltered() {
        const translate = this.localeService.getLocaleTextFunc();
        const isFilterActive = this.column.isFilterActive();
        if (isFilterActive) this.setAriaDescriptionProperty("filter", translate("ariaColumnFiltered", "Column Filtered"));
        else this.setAriaDescriptionProperty("filter", null);
    }
    setAriaDescriptionProperty(property, value) {
        if (value != null) this.ariaDescriptionProperties.set(property, value);
        else this.ariaDescriptionProperties.delete(property);
    }
    announceAriaDescription() {
        if (!this.eGui.contains(this.beans.gos.getActiveDomElement())) return;
        const ariaDescription = Array.from(this.ariaDescriptionProperties.keys()).sort((a, b)=>a === "filter" ? -1 : b.charCodeAt(0) - a.charCodeAt(0)).map((key)=>this.ariaDescriptionProperties.get(key)).join(". ");
        this.beans.ariaAnnouncementService.announceValue(ariaDescription);
    }
    refreshAria() {
        this.refreshAriaSort();
        this.refreshAriaMenu();
        this.refreshAriaFilterButton();
        this.refreshAriaFiltered();
    }
    addColumnHoverListener() {
        const listener = ()=>{
            if (!this.gos.get("columnHoverHighlight")) return;
            const isHovered = this.beans.columnHoverService.isHovered(this.column);
            this.comp.addOrRemoveCssClass("ag-column-hover", isHovered);
        };
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_HOVER_CHANGED, listener);
        listener();
    }
    getColId() {
        return this.column.getColId();
    }
    addActiveHeaderMouseListeners() {
        const listener = (e)=>this.handleMouseOverChange(e.type === "mouseenter");
        const clickListener = ()=>this.dispatchColumnMouseEvent($437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_HEADER_CLICKED, this.column);
        const contextMenuListener = (event)=>this.handleContextMenuMouseEvent(event, void 0, this.column);
        this.addManagedListener(this.getGui(), "mouseenter", listener);
        this.addManagedListener(this.getGui(), "mouseleave", listener);
        this.addManagedListener(this.getGui(), "click", clickListener);
        this.addManagedListener(this.getGui(), "contextmenu", contextMenuListener);
    }
    handleMouseOverChange(isMouseOver) {
        this.setActiveHeader(isMouseOver);
        const eventType = isMouseOver ? $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_HEADER_MOUSE_OVER : $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_HEADER_MOUSE_LEAVE;
        const event = {
            type: eventType,
            column: this.column
        };
        this.eventService.dispatchEvent(event);
    }
    setActiveHeader(active) {
        this.comp.addOrRemoveCssClass("ag-header-active", active);
    }
    getAnchorElementForMenu(isFilter) {
        const headerComp = this.comp.getUserCompInstance();
        if (headerComp instanceof $437b23f6a393c3bf$var$HeaderComp) return headerComp.getAnchorElementForMenu(isFilter);
        return this.getGui();
    }
    destroy() {
        super.destroy();
        this.refreshFunctions = null;
        this.selectAllFeature = null;
        this.dragSourceElement = null;
        this.userCompDetails = null;
        this.userHeaderClasses = null;
        this.ariaDescriptionProperties = null;
    }
};
// community-modules/core/src/headerRendering/cells/columnGroup/groupResizeFeature.ts
var $437b23f6a393c3bf$var$GroupResizeFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(comp, eResize, pinned, columnGroup){
        super();
        this.eResize = eResize;
        this.comp = comp;
        this.pinned = pinned;
        this.columnGroup = columnGroup;
    }
    postConstruct() {
        if (!this.columnGroup.isResizable()) {
            this.comp.setResizableDisplayed(false);
            return;
        }
        const finishedWithResizeFunc = this.horizontalResizeService.addResizeBar({
            eResizeBar: this.eResize,
            onResizeStart: this.onResizeStart.bind(this),
            onResizing: this.onResizing.bind(this, false),
            onResizeEnd: this.onResizing.bind(this, true)
        });
        this.addDestroyFunc(finishedWithResizeFunc);
        if (!this.gos.get("suppressAutoSize")) {
            const skipHeaderOnAutoSize = this.gos.get("skipHeaderOnAutoSize");
            this.eResize.addEventListener("dblclick", ()=>{
                const keys2 = [];
                const leafCols = this.columnGroup.getDisplayedLeafColumns();
                leafCols.forEach((column)=>{
                    if (!column.getColDef().suppressAutoSize) keys2.push(column.getColId());
                });
                if (keys2.length > 0) this.columnModel.autoSizeColumns({
                    columns: keys2,
                    skipHeader: skipHeaderOnAutoSize,
                    stopAtGroup: this.columnGroup,
                    source: "uiColumnResized"
                });
                this.resizeLeafColumnsToFit("uiColumnResized");
            });
        }
    }
    onResizeStart(shiftKey) {
        const initialValues = this.getInitialValues(shiftKey);
        this.storeLocalValues(initialValues);
        this.toggleColumnResizing(true);
    }
    onResizing(finished, resizeAmount, source = "uiColumnResized") {
        const resizeAmountNormalised = this.normaliseDragChange(resizeAmount);
        const width = this.resizeStartWidth + resizeAmountNormalised;
        this.resizeColumnsFromLocalValues(width, source, finished);
    }
    getInitialValues(shiftKey) {
        const columnsToResize = this.getColumnsToResize();
        const resizeStartWidth = this.getInitialSizeOfColumns(columnsToResize);
        const resizeRatios = this.getSizeRatiosOfColumns(columnsToResize, resizeStartWidth);
        const columnSizeAndRatios = {
            columnsToResize: columnsToResize,
            resizeStartWidth: resizeStartWidth,
            resizeRatios: resizeRatios
        };
        let groupAfter = null;
        if (shiftKey) groupAfter = this.columnModel.getDisplayedGroupAtDirection(this.columnGroup, "After");
        if (groupAfter) {
            const takeFromLeafCols = groupAfter.getDisplayedLeafColumns();
            const groupAfterColumns = columnSizeAndRatios.groupAfterColumns = takeFromLeafCols.filter((col)=>col.isResizable());
            const groupAfterStartWidth = columnSizeAndRatios.groupAfterStartWidth = this.getInitialSizeOfColumns(groupAfterColumns);
            columnSizeAndRatios.groupAfterRatios = this.getSizeRatiosOfColumns(groupAfterColumns, groupAfterStartWidth);
        } else {
            columnSizeAndRatios.groupAfterColumns = void 0;
            columnSizeAndRatios.groupAfterStartWidth = void 0;
            columnSizeAndRatios.groupAfterRatios = void 0;
        }
        return columnSizeAndRatios;
    }
    storeLocalValues(initialValues) {
        const { columnsToResize: columnsToResize, resizeStartWidth: resizeStartWidth, resizeRatios: resizeRatios, groupAfterColumns: groupAfterColumns, groupAfterStartWidth: groupAfterStartWidth, groupAfterRatios: groupAfterRatios } = initialValues;
        this.resizeCols = columnsToResize;
        this.resizeStartWidth = resizeStartWidth;
        this.resizeRatios = resizeRatios;
        this.resizeTakeFromCols = groupAfterColumns;
        this.resizeTakeFromStartWidth = groupAfterStartWidth;
        this.resizeTakeFromRatios = groupAfterRatios;
    }
    clearLocalValues() {
        this.resizeCols = void 0;
        this.resizeRatios = void 0;
        this.resizeTakeFromCols = void 0;
        this.resizeTakeFromRatios = void 0;
    }
    resizeLeafColumnsToFit(source) {
        const preferredSize = this.autoWidthCalculator.getPreferredWidthForColumnGroup(this.columnGroup);
        const initialValues = this.getInitialValues();
        if (preferredSize > initialValues.resizeStartWidth) this.resizeColumns(initialValues, preferredSize, source, true);
    }
    resizeColumnsFromLocalValues(totalWidth, source, finished = true) {
        var _a, _b, _c;
        if (!this.resizeCols || !this.resizeRatios) return;
        const initialValues = {
            columnsToResize: this.resizeCols,
            resizeStartWidth: this.resizeStartWidth,
            resizeRatios: this.resizeRatios,
            groupAfterColumns: (_a = this.resizeTakeFromCols) != null ? _a : void 0,
            groupAfterStartWidth: (_b = this.resizeTakeFromStartWidth) != null ? _b : void 0,
            groupAfterRatios: (_c = this.resizeTakeFromRatios) != null ? _c : void 0
        };
        this.resizeColumns(initialValues, totalWidth, source, finished);
    }
    resizeColumns(initialValues, totalWidth, source, finished = true) {
        const { columnsToResize: columnsToResize, resizeStartWidth: resizeStartWidth, resizeRatios: resizeRatios, groupAfterColumns: groupAfterColumns, groupAfterStartWidth: groupAfterStartWidth, groupAfterRatios: groupAfterRatios } = initialValues;
        const resizeSets = [];
        resizeSets.push({
            columns: columnsToResize,
            ratios: resizeRatios,
            width: totalWidth
        });
        if (groupAfterColumns) {
            const diff = totalWidth - resizeStartWidth;
            resizeSets.push({
                columns: groupAfterColumns,
                ratios: groupAfterRatios,
                width: groupAfterStartWidth - diff
            });
        }
        this.columnModel.resizeColumnSets({
            resizeSets: resizeSets,
            finished: finished,
            source: source
        });
        if (finished) this.toggleColumnResizing(false);
    }
    toggleColumnResizing(resizing) {
        this.comp.addOrRemoveCssClass("ag-column-resizing", resizing);
    }
    getColumnsToResize() {
        const leafCols = this.columnGroup.getDisplayedLeafColumns();
        return leafCols.filter((col)=>col.isResizable());
    }
    getInitialSizeOfColumns(columns) {
        return columns.reduce((totalWidth, column)=>totalWidth + column.getActualWidth(), 0);
    }
    getSizeRatiosOfColumns(columns, initialSizeOfColumns) {
        return columns.map((column)=>column.getActualWidth() / initialSizeOfColumns);
    }
    // optionally inverts the drag, depending on pinned and RTL
    // note - this method is duplicated in RenderedHeaderCell - should refactor out?
    normaliseDragChange(dragChange) {
        let result = dragChange;
        if (this.gos.get("enableRtl")) {
            if (this.pinned !== "left") result *= -1;
        } else if (this.pinned === "right") result *= -1;
        return result;
    }
    destroy() {
        super.destroy();
        this.clearLocalValues();
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("horizontalResizeService")
], $437b23f6a393c3bf$var$GroupResizeFeature.prototype, "horizontalResizeService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("autoWidthCalculator")
], $437b23f6a393c3bf$var$GroupResizeFeature.prototype, "autoWidthCalculator", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnModel")
], $437b23f6a393c3bf$var$GroupResizeFeature.prototype, "columnModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$GroupResizeFeature.prototype, "postConstruct", 1);
// community-modules/core/src/headerRendering/cells/columnGroup/groupWidthFeature.ts
var $437b23f6a393c3bf$var$GroupWidthFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(comp, columnGroup){
        super();
        // the children can change, we keep destroy functions related to listening to the children here
        this.removeChildListenersFuncs = [];
        this.columnGroup = columnGroup;
        this.comp = comp;
    }
    postConstruct() {
        this.addListenersToChildrenColumns();
        this.addManagedListener(this.columnGroup, $437b23f6a393c3bf$export$8a8fbc71323f074.EVENT_DISPLAYED_CHILDREN_CHANGED, this.onDisplayedChildrenChanged.bind(this));
        this.onWidthChanged();
        this.addDestroyFunc(this.removeListenersOnChildrenColumns.bind(this));
    }
    addListenersToChildrenColumns() {
        this.removeListenersOnChildrenColumns();
        const widthChangedListener = this.onWidthChanged.bind(this);
        this.columnGroup.getLeafColumns().forEach((column)=>{
            column.addEventListener("widthChanged", widthChangedListener);
            column.addEventListener("visibleChanged", widthChangedListener);
            this.removeChildListenersFuncs.push(()=>{
                column.removeEventListener("widthChanged", widthChangedListener);
                column.removeEventListener("visibleChanged", widthChangedListener);
            });
        });
    }
    removeListenersOnChildrenColumns() {
        this.removeChildListenersFuncs.forEach((func)=>func());
        this.removeChildListenersFuncs = [];
    }
    onDisplayedChildrenChanged() {
        this.addListenersToChildrenColumns();
        this.onWidthChanged();
    }
    onWidthChanged() {
        const columnWidth = this.columnGroup.getActualWidth();
        this.comp.setWidth(`${columnWidth}px`);
        this.comp.addOrRemoveCssClass("ag-hidden", columnWidth === 0);
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$GroupWidthFeature.prototype, "postConstruct", 1);
// community-modules/core/src/headerRendering/cells/columnGroup/headerGroupCellCtrl.ts
var $437b23f6a393c3bf$export$6ab7b303345e4c8 = class extends $437b23f6a393c3bf$export$879ff627d5a4d5c {
    constructor(columnGroup, beans, parentRowCtrl){
        super(columnGroup, beans, parentRowCtrl);
        this.onSuppressColMoveChange = ()=>{
            if (!this.isAlive() || this.isSuppressMoving()) this.removeDragSource();
            else if (!this.dragSource) {
                const eGui = this.getGui();
                this.setDragSource(eGui);
            }
        };
        this.column = columnGroup;
    }
    setComp(comp, eGui, eResize) {
        this.comp = comp;
        this.setGui(eGui);
        this.displayName = this.beans.columnModel.getDisplayNameForColumnGroup(this.column, "header");
        this.addClasses();
        this.setupMovingCss();
        this.setupExpandable();
        this.setupTooltip();
        this.addDestroyFunc(()=>{
            if (this.tooltipFeature) this.tooltipFeature = this.destroyBean(this.tooltipFeature);
        });
        this.setupUserComp();
        this.addHeaderMouseListeners();
        const pinned = this.getParentRowCtrl().getPinned();
        const leafCols = this.column.getProvidedColumnGroup().getLeafColumns();
        this.createManagedBean(new $437b23f6a393c3bf$var$HoverFeature(leafCols, eGui));
        this.createManagedBean(new $437b23f6a393c3bf$export$84c1fb51ab89c7b5(this.column, eGui, this.beans));
        this.createManagedBean(new $437b23f6a393c3bf$var$GroupWidthFeature(comp, this.column));
        this.resizeFeature = this.createManagedBean(new $437b23f6a393c3bf$var$GroupResizeFeature(comp, eResize, pinned, this.column));
        this.createManagedBean(new $437b23f6a393c3bf$export$5510e53ed3962582(eGui, {
            shouldStopEventPropagation: this.shouldStopEventPropagation.bind(this),
            onTabKeyDown: ()=>void 0,
            handleKeyDown: this.handleKeyDown.bind(this),
            onFocusIn: this.onFocusIn.bind(this)
        }));
        this.addManagedPropertyListener($437b23f6a393c3bf$export$ada873a34909da65.EVENT_SUPPRESS_COLUMN_MOVE_CHANGED, this.onSuppressColMoveChange);
        this.addResizeAndMoveKeyboardListeners();
    }
    resizeHeader(delta, shiftKey) {
        if (!this.resizeFeature) return;
        const initialValues = this.resizeFeature.getInitialValues(shiftKey);
        this.resizeFeature.resizeColumns(initialValues, initialValues.resizeStartWidth + delta, "uiColumnResized", true);
    }
    moveHeader(hDirection) {
        const { beans: beans, eGui: eGui, column: column, gos: gos, ctrlsService: ctrlsService } = this;
        const isRtl = gos.get("enableRtl");
        const isLeft = hDirection === 0 /* Left */ ;
        const pinned = this.getPinned();
        const rect = eGui.getBoundingClientRect();
        const left = rect.left;
        const width = rect.width;
        const xPosition = $437b23f6a393c3bf$var$ColumnMoveHelper.normaliseX(isLeft !== isRtl ? left - 20 : left + width + 20, pinned, true, gos, ctrlsService);
        const id = column.getGroupId();
        const headerPosition = this.focusService.getFocusedHeader();
        $437b23f6a393c3bf$var$ColumnMoveHelper.attemptMoveColumns({
            allMovingColumns: this.column.getLeafColumns(),
            isFromHeader: true,
            hDirection: hDirection,
            xPosition: xPosition,
            pinned: pinned,
            fromEnter: false,
            fakeEvent: false,
            gos: gos,
            columnModel: beans.columnModel
        });
        const displayedLeafColumns = column.getDisplayedLeafColumns();
        const targetColumn = isLeft ? displayedLeafColumns[0] : $437b23f6a393c3bf$var$last(displayedLeafColumns);
        this.ctrlsService.getGridBodyCtrl().getScrollFeature().ensureColumnVisible(targetColumn, "auto");
        if (!this.isAlive() && headerPosition) this.restoreFocus(id, column, headerPosition);
    }
    restoreFocus(groupId, previousColumnGroup, previousPosition) {
        const leafCols = previousColumnGroup.getLeafColumns();
        if (!leafCols.length) return;
        const parent = leafCols[0].getParent();
        if (!parent) return;
        const newColumnGroup = this.findGroupWidthId(parent, groupId);
        if (newColumnGroup) this.focusService.focusHeaderPosition({
            headerPosition: $437b23f6a393c3bf$var$__spreadProps($437b23f6a393c3bf$var$__spreadValues({}, previousPosition), {
                column: newColumnGroup
            })
        });
    }
    findGroupWidthId(columnGroup, id) {
        while(columnGroup){
            if (columnGroup.getGroupId() === id) return columnGroup;
            columnGroup = columnGroup.getParent();
        }
        return null;
    }
    resizeLeafColumnsToFit(source) {
        if (!this.resizeFeature) return;
        this.resizeFeature.resizeLeafColumnsToFit(source);
    }
    setupUserComp() {
        const params = this.gos.addGridCommonParams({
            displayName: this.displayName,
            columnGroup: this.column,
            setExpanded: (expanded)=>{
                this.beans.columnModel.setColumnGroupOpened(this.column.getProvidedColumnGroup(), expanded, "gridInitializing");
            },
            setTooltip: (value, shouldDisplayTooltip)=>{
                this.setupTooltip(value, shouldDisplayTooltip);
            }
        });
        const compDetails = this.userComponentFactory.getHeaderGroupCompDetails(params);
        this.comp.setUserCompDetails(compDetails);
    }
    addHeaderMouseListeners() {
        const listener = (e)=>this.handleMouseOverChange(e.type === "mouseenter");
        const clickListener = ()=>this.dispatchColumnMouseEvent($437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_HEADER_CLICKED, this.column.getProvidedColumnGroup());
        const contextMenuListener = (event)=>this.handleContextMenuMouseEvent(event, void 0, this.column.getProvidedColumnGroup());
        this.addManagedListener(this.getGui(), "mouseenter", listener);
        this.addManagedListener(this.getGui(), "mouseleave", listener);
        this.addManagedListener(this.getGui(), "click", clickListener);
        this.addManagedListener(this.getGui(), "contextmenu", contextMenuListener);
    }
    handleMouseOverChange(isMouseOver) {
        const eventType = isMouseOver ? $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_HEADER_MOUSE_OVER : $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_HEADER_MOUSE_LEAVE;
        const event = {
            type: eventType,
            column: this.column.getProvidedColumnGroup()
        };
        this.eventService.dispatchEvent(event);
    }
    setupTooltip(value, shouldDisplayTooltip) {
        if (this.tooltipFeature) this.tooltipFeature = this.destroyBean(this.tooltipFeature);
        const colGroupDef = this.column.getColGroupDef();
        const isTooltipWhenTruncated = this.gos.get("tooltipShowMode") === "whenTruncated";
        const eGui = this.eGui;
        if (!shouldDisplayTooltip && isTooltipWhenTruncated && !(colGroupDef == null ? void 0 : colGroupDef.headerGroupComponent)) shouldDisplayTooltip = ()=>{
            const textEl = eGui.querySelector(".ag-header-group-text");
            if (!textEl) return true;
            return textEl.scrollWidth > textEl.clientWidth;
        };
        const tooltipCtrl = {
            getColumn: ()=>this.column,
            getGui: ()=>eGui,
            getLocation: ()=>"headerGroup",
            getTooltipValue: ()=>value != null ? value : colGroupDef && colGroupDef.headerTooltip,
            shouldDisplayTooltip: shouldDisplayTooltip
        };
        if (colGroupDef) tooltipCtrl.getColDef = ()=>colGroupDef;
        this.createBean(new $437b23f6a393c3bf$export$e5073a590d24815c(tooltipCtrl));
    }
    setupExpandable() {
        const providedColGroup = this.column.getProvidedColumnGroup();
        this.refreshExpanded();
        this.addManagedListener(providedColGroup, $437b23f6a393c3bf$export$89dd394cd2c9e921.EVENT_EXPANDABLE_CHANGED, this.refreshExpanded.bind(this));
        this.addManagedListener(providedColGroup, $437b23f6a393c3bf$export$89dd394cd2c9e921.EVENT_EXPANDED_CHANGED, this.refreshExpanded.bind(this));
    }
    refreshExpanded() {
        const column = this.column;
        this.expandable = column.isExpandable();
        const expanded = column.isExpanded();
        if (this.expandable) this.comp.setAriaExpanded(expanded ? "true" : "false");
        else this.comp.setAriaExpanded(void 0);
    }
    getColId() {
        return this.column.getUniqueId();
    }
    addClasses() {
        const colGroupDef = this.column.getColGroupDef();
        const classes = $437b23f6a393c3bf$export$f90acfa36b600d3d.getHeaderClassesFromColDef(colGroupDef, this.gos, null, this.column);
        if (this.column.isPadding()) {
            classes.push("ag-header-group-cell-no-group");
            const leafCols = this.column.getLeafColumns();
            if (leafCols.every((col)=>col.isSpanHeaderHeight())) classes.push("ag-header-span-height");
        } else classes.push("ag-header-group-cell-with-group");
        classes.forEach((c)=>this.comp.addOrRemoveCssClass(c, true));
    }
    setupMovingCss() {
        const providedColumnGroup = this.column.getProvidedColumnGroup();
        const leafColumns = providedColumnGroup.getLeafColumns();
        const listener = ()=>this.comp.addOrRemoveCssClass("ag-header-cell-moving", this.column.isMoving());
        leafColumns.forEach((col)=>{
            this.addManagedListener(col, $437b23f6a393c3bf$export$816b5d811295e6bc.EVENT_MOVING_CHANGED, listener);
        });
        listener();
    }
    onFocusIn(e) {
        if (!this.eGui.contains(e.relatedTarget)) {
            const rowIndex = this.getRowIndex();
            this.beans.focusService.setFocusedHeader(rowIndex, this.column);
        }
    }
    handleKeyDown(e) {
        super.handleKeyDown(e);
        const wrapperHasFocus = this.getWrapperHasFocus();
        if (!this.expandable || !wrapperHasFocus) return;
        if (e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER) {
            const column = this.column;
            const newExpandedValue = !column.isExpanded();
            this.beans.columnModel.setColumnGroupOpened(column.getProvidedColumnGroup(), newExpandedValue, "uiColumnExpanded");
        }
    }
    // unlike columns, this will only get called once, as we don't react on props on column groups
    // (we will always destroy and recreate this comp if something changes)
    setDragSource(eHeaderGroup) {
        if (!this.isAlive() || this.isSuppressMoving()) return;
        this.removeDragSource();
        if (!eHeaderGroup) return;
        const { beans: beans, column: column, displayName: displayName, gos: gos, dragAndDropService: dragAndDropService } = this;
        const { columnModel: columnModel } = beans;
        const allLeafColumns = column.getProvidedColumnGroup().getLeafColumns();
        let hideColumnOnExit = !gos.get("suppressDragLeaveHidesColumns");
        const dragSource = this.dragSource = {
            type: 1 /* HeaderCell */ ,
            eElement: eHeaderGroup,
            getDefaultIconName: ()=>hideColumnOnExit ? $437b23f6a393c3bf$export$3529111922becfa6.ICON_HIDE : $437b23f6a393c3bf$export$3529111922becfa6.ICON_NOT_ALLOWED,
            dragItemName: displayName,
            // we add in the original group leaf columns, so we move both visible and non-visible items
            getDragItem: ()=>this.getDragItemForGroup(column),
            onDragStarted: ()=>{
                hideColumnOnExit = !gos.get("suppressDragLeaveHidesColumns");
                allLeafColumns.forEach((col)=>col.setMoving(true, "uiColumnDragged"));
            },
            onDragStopped: ()=>allLeafColumns.forEach((col)=>col.setMoving(false, "uiColumnDragged")),
            onGridEnter: (dragItem)=>{
                var _a;
                if (hideColumnOnExit) {
                    const unlockedColumns = ((_a = dragItem == null ? void 0 : dragItem.columns) == null ? void 0 : _a.filter((col)=>!col.getColDef().lockVisible)) || [];
                    columnModel.setColumnsVisible(unlockedColumns, true, "uiColumnMoved");
                }
            },
            onGridExit: (dragItem)=>{
                var _a;
                if (hideColumnOnExit) {
                    const unlockedColumns = ((_a = dragItem == null ? void 0 : dragItem.columns) == null ? void 0 : _a.filter((col)=>!col.getColDef().lockVisible)) || [];
                    columnModel.setColumnsVisible(unlockedColumns, false, "uiColumnMoved");
                }
            }
        };
        dragAndDropService.addDragSource(dragSource, true);
    }
    // when moving the columns, we want to move all the columns (contained within the DragItem) in this group in one go,
    // and in the order they are currently in the screen.
    getDragItemForGroup(columnGroup) {
        const allColumnsOriginalOrder = columnGroup.getProvidedColumnGroup().getLeafColumns();
        const visibleState = {};
        allColumnsOriginalOrder.forEach((column)=>visibleState[column.getId()] = column.isVisible());
        const allColumnsCurrentOrder = [];
        this.beans.columnModel.getAllDisplayedColumns().forEach((column)=>{
            if (allColumnsOriginalOrder.indexOf(column) >= 0) {
                allColumnsCurrentOrder.push(column);
                $437b23f6a393c3bf$var$removeFromArray(allColumnsOriginalOrder, column);
            }
        });
        allColumnsOriginalOrder.forEach((column)=>allColumnsCurrentOrder.push(column));
        return {
            columns: allColumnsCurrentOrder,
            visibleState: visibleState
        };
    }
    isSuppressMoving() {
        let childSuppressesMoving = false;
        this.column.getLeafColumns().forEach((column)=>{
            if (column.getColDef().suppressMovable || column.getColDef().lockPosition) childSuppressesMoving = true;
        });
        const result = childSuppressesMoving || this.gos.get("suppressMovableColumns");
        return result;
    }
};
// community-modules/core/src/headerRendering/row/headerRowCtrl.ts
var $437b23f6a393c3bf$var$instanceIdSequence5 = 0;
var $437b23f6a393c3bf$export$d184e9bef4f8ca43 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(rowIndex, pinned, type){
        super();
        this.instanceId = $437b23f6a393c3bf$var$instanceIdSequence5++;
        this.rowIndex = rowIndex;
        this.pinned = pinned;
        this.type = type;
        const typeClass = type == "group" /* COLUMN_GROUP */  ? `ag-header-row-column-group` : type == "filter" /* FLOATING_FILTER */  ? `ag-header-row-column-filter` : `ag-header-row-column`;
        this.headerRowClass = `ag-header-row ${typeClass}`;
    }
    postConstruct() {
        this.isPrintLayout = this.gos.isDomLayout("print");
        this.isEnsureDomOrder = this.gos.get("ensureDomOrder");
    }
    getInstanceId() {
        return this.instanceId;
    }
    /**
   * 
   * @param comp Proxy to the actual component
   * @param initCompState Should the component be initialised with the current state of the controller. Default: true
   */ setComp(comp, initCompState = true) {
        this.comp = comp;
        if (initCompState) {
            this.onRowHeightChanged();
            this.onVirtualColumnsChanged();
        }
        this.setWidth();
        this.addEventListeners();
    }
    getHeaderRowClass() {
        return this.headerRowClass;
    }
    getAriaRowIndex() {
        return this.rowIndex + 1;
    }
    addEventListeners() {
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_RESIZED, this.onColumnResized.bind(this));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_VIRTUAL_COLUMNS_CHANGED, (params)=>this.onVirtualColumnsChanged(params.afterScroll));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_HEADER_HEIGHT_CHANGED, this.onRowHeightChanged.bind(this));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_GRID_STYLES_CHANGED, this.onRowHeightChanged.bind(this));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_ADVANCED_FILTER_ENABLED_CHANGED, this.onRowHeightChanged.bind(this));
        this.addManagedPropertyListener("domLayout", this.onDisplayedColumnsChanged.bind(this));
        this.addManagedPropertyListener("ensureDomOrder", (e)=>this.isEnsureDomOrder = e.currentValue);
        this.addManagedPropertyListener("headerHeight", this.onRowHeightChanged.bind(this));
        this.addManagedPropertyListener("pivotHeaderHeight", this.onRowHeightChanged.bind(this));
        this.addManagedPropertyListener("groupHeaderHeight", this.onRowHeightChanged.bind(this));
        this.addManagedPropertyListener("pivotGroupHeaderHeight", this.onRowHeightChanged.bind(this));
        this.addManagedPropertyListener("floatingFiltersHeight", this.onRowHeightChanged.bind(this));
    }
    getHeaderCellCtrl(column) {
        if (!this.headerCellCtrls) return;
        return $437b23f6a393c3bf$var$values(this.headerCellCtrls).find((cellCtrl)=>cellCtrl.getColumnGroupChild() === column);
    }
    onDisplayedColumnsChanged() {
        this.isPrintLayout = this.gos.isDomLayout("print");
        this.onVirtualColumnsChanged();
        this.setWidth();
        this.onRowHeightChanged();
    }
    getType() {
        return this.type;
    }
    onColumnResized() {
        this.setWidth();
    }
    setWidth() {
        const width = this.getWidthForRow();
        this.comp.setWidth(`${width}px`);
    }
    getWidthForRow() {
        const { columnModel: columnModel } = this.beans;
        if (this.isPrintLayout) {
            const pinned = this.pinned != null;
            if (pinned) return 0;
            return columnModel.getContainerWidth("right") + columnModel.getContainerWidth("left") + columnModel.getContainerWidth(null);
        }
        return columnModel.getContainerWidth(this.pinned);
    }
    onRowHeightChanged() {
        var { topOffset: topOffset, rowHeight: rowHeight } = this.getTopAndHeight();
        this.comp.setTop(topOffset + "px");
        this.comp.setHeight(rowHeight + "px");
    }
    getTopAndHeight() {
        const { columnModel: columnModel, filterManager: filterManager } = this.beans;
        let headerRowCount = columnModel.getHeaderRowCount();
        const sizes = [];
        let numberOfFloating = 0;
        if (filterManager.hasFloatingFilters()) {
            headerRowCount++;
            numberOfFloating = 1;
        }
        const groupHeight = columnModel.getColumnGroupHeaderRowHeight();
        const headerHeight = columnModel.getColumnHeaderRowHeight();
        const numberOfNonGroups = 1 + numberOfFloating;
        const numberOfGroups = headerRowCount - numberOfNonGroups;
        for(let i = 0; i < numberOfGroups; i++)sizes.push(groupHeight);
        sizes.push(headerHeight);
        for(let i = 0; i < numberOfFloating; i++)sizes.push(columnModel.getFloatingFiltersHeight());
        let topOffset = 0;
        for(let i = 0; i < this.rowIndex; i++)topOffset += sizes[i];
        const rowHeight = sizes[this.rowIndex];
        return {
            topOffset: topOffset,
            rowHeight: rowHeight
        };
    }
    getPinned() {
        return this.pinned;
    }
    getRowIndex() {
        return this.rowIndex;
    }
    onVirtualColumnsChanged(afterScroll = false) {
        const ctrlsToDisplay = this.getHeaderCtrls();
        const forceOrder = this.isEnsureDomOrder || this.isPrintLayout;
        this.comp.setHeaderCtrls(ctrlsToDisplay, forceOrder, afterScroll);
    }
    getHeaderCtrls() {
        const oldCtrls = this.headerCellCtrls;
        this.headerCellCtrls = /* @__PURE__ */ new Map();
        const columns = this.getColumnsInViewport();
        for (const child of columns)this.recycleAndCreateHeaderCtrls(child, oldCtrls);
        const isFocusedAndDisplayed = (ctrl)=>{
            const { focusService: focusService, columnModel: columnModel } = this.beans;
            const isFocused = focusService.isHeaderWrapperFocused(ctrl);
            if (!isFocused) return false;
            const isDisplayed = columnModel.isDisplayed(ctrl.getColumnGroupChild());
            return isDisplayed;
        };
        if (oldCtrls) for (const [id, oldCtrl] of oldCtrls){
            const keepCtrl = isFocusedAndDisplayed(oldCtrl);
            if (keepCtrl) this.headerCellCtrls.set(id, oldCtrl);
            else this.destroyBean(oldCtrl);
        }
        const ctrlsToDisplay = Array.from(this.headerCellCtrls.values());
        return ctrlsToDisplay;
    }
    recycleAndCreateHeaderCtrls(headerColumn, oldCtrls) {
        if (!this.headerCellCtrls) return;
        if (headerColumn.isEmptyGroup()) return;
        const idOfChild = headerColumn.getUniqueId();
        let headerCtrl;
        if (oldCtrls) {
            headerCtrl = oldCtrls.get(idOfChild);
            oldCtrls.delete(idOfChild);
        }
        const forOldColumn = headerCtrl && headerCtrl.getColumnGroupChild() != headerColumn;
        if (forOldColumn) {
            this.destroyBean(headerCtrl);
            headerCtrl = void 0;
        }
        if (headerCtrl == null) switch(this.type){
            case "filter" /* FLOATING_FILTER */ :
                headerCtrl = this.createBean(new $437b23f6a393c3bf$export$65579fe86751e033(headerColumn, this.beans, this));
                break;
            case "group" /* COLUMN_GROUP */ :
                headerCtrl = this.createBean(new $437b23f6a393c3bf$export$6ab7b303345e4c8(headerColumn, this.beans, this));
                break;
            default:
                headerCtrl = this.createBean(new $437b23f6a393c3bf$export$8a024062e840d3f5(headerColumn, this.beans, this));
                break;
        }
        this.headerCellCtrls.set(idOfChild, headerCtrl);
    }
    getColumnsInViewport() {
        return this.isPrintLayout ? this.getColumnsInViewportPrintLayout() : this.getColumnsInViewportNormalLayout();
    }
    getColumnsInViewportPrintLayout() {
        if (this.pinned != null) return [];
        let viewportColumns = [];
        const actualDepth = this.getActualDepth();
        const { columnModel: columnModel } = this.beans;
        [
            "left",
            null,
            "right"
        ].forEach((pinned)=>{
            const items = columnModel.getVirtualHeaderGroupRow(pinned, actualDepth);
            viewportColumns = viewportColumns.concat(items);
        });
        return viewportColumns;
    }
    getActualDepth() {
        return this.type == "filter" /* FLOATING_FILTER */  ? this.rowIndex - 1 : this.rowIndex;
    }
    getColumnsInViewportNormalLayout() {
        return this.beans.columnModel.getVirtualHeaderGroupRow(this.pinned, this.getActualDepth());
    }
    focusHeader(column, event) {
        if (!this.headerCellCtrls) return false;
        const allCtrls = Array.from(this.headerCellCtrls.values());
        const ctrl = allCtrls.find((ctrl2)=>ctrl2.getColumnGroupChild() == column);
        if (!ctrl) return false;
        return ctrl.focus(event);
    }
    destroy() {
        if (this.headerCellCtrls) this.headerCellCtrls.forEach((ctrl)=>{
            this.destroyBean(ctrl);
        });
        this.headerCellCtrls = void 0;
        super.destroy();
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("beans")
], $437b23f6a393c3bf$export$d184e9bef4f8ca43.prototype, "beans", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$export$d184e9bef4f8ca43.prototype, "postConstruct", 1);
// community-modules/core/src/headerRendering/rowContainer/headerRowContainerCtrl.ts
var $437b23f6a393c3bf$export$1e864ee88f54e7b = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(pinned){
        super();
        this.hidden = false;
        this.includeFloatingFilter = false;
        this.groupsRowCtrls = [];
        this.pinned = pinned;
    }
    setComp(comp, eGui) {
        this.comp = comp;
        this.eViewport = eGui;
        this.setupCenterWidth();
        this.setupPinnedWidth();
        this.setupDragAndDrop(this.eViewport);
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_GRID_COLUMNS_CHANGED, this.onGridColumnsChanged.bind(this));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_ADVANCED_FILTER_ENABLED_CHANGED, this.onDisplayedColumnsChanged.bind(this));
        this.ctrlsService.registerHeaderContainer(this, this.pinned);
        if (this.columnModel.isReady()) this.refresh();
    }
    setupDragAndDrop(dropContainer) {
        const bodyDropTarget = new $437b23f6a393c3bf$export$2350838bf1877b9e(this.pinned, dropContainer);
        this.createManagedBean(bodyDropTarget);
    }
    refresh(keepColumns = false) {
        const sequence = new $437b23f6a393c3bf$export$9bbf3cc62ef6fcad();
        const focusedHeaderPosition = this.focusService.getFocusHeaderToUseAfterRefresh();
        const refreshColumnGroups = ()=>{
            const groupRowCount = this.columnModel.getHeaderRowCount() - 1;
            this.groupsRowCtrls = this.destroyBeans(this.groupsRowCtrls);
            for(let i = 0; i < groupRowCount; i++){
                const ctrl = this.createBean(new $437b23f6a393c3bf$export$d184e9bef4f8ca43(sequence.next(), this.pinned, "group" /* COLUMN_GROUP */ ));
                this.groupsRowCtrls.push(ctrl);
            }
        };
        const refreshColumns = ()=>{
            const rowIndex = sequence.next();
            const needNewInstance = !this.hidden && (this.columnsRowCtrl == null || !keepColumns || this.columnsRowCtrl.getRowIndex() !== rowIndex);
            const shouldDestroyInstance = needNewInstance || this.hidden;
            if (shouldDestroyInstance) this.columnsRowCtrl = this.destroyBean(this.columnsRowCtrl);
            if (needNewInstance) this.columnsRowCtrl = this.createBean(new $437b23f6a393c3bf$export$d184e9bef4f8ca43(rowIndex, this.pinned, "column" /* COLUMN */ ));
        };
        const refreshFilters = ()=>{
            this.includeFloatingFilter = this.filterManager.hasFloatingFilters() && !this.hidden;
            const destroyPreviousComp = ()=>{
                this.filtersRowCtrl = this.destroyBean(this.filtersRowCtrl);
            };
            if (!this.includeFloatingFilter) {
                destroyPreviousComp();
                return;
            }
            const rowIndex = sequence.next();
            if (this.filtersRowCtrl) {
                const rowIndexMismatch = this.filtersRowCtrl.getRowIndex() !== rowIndex;
                if (!keepColumns || rowIndexMismatch) destroyPreviousComp();
            }
            if (!this.filtersRowCtrl) this.filtersRowCtrl = this.createBean(new $437b23f6a393c3bf$export$d184e9bef4f8ca43(rowIndex, this.pinned, "filter" /* FLOATING_FILTER */ ));
        };
        refreshColumnGroups();
        refreshColumns();
        refreshFilters();
        const allCtrls = this.getAllCtrls();
        this.comp.setCtrls(allCtrls);
        this.restoreFocusOnHeader(focusedHeaderPosition);
    }
    restoreFocusOnHeader(position) {
        if (position == null || position.column.getPinned() != this.pinned) return;
        this.focusService.focusHeaderPosition({
            headerPosition: position
        });
    }
    getAllCtrls() {
        const res = [
            ...this.groupsRowCtrls
        ];
        if (this.columnsRowCtrl) res.push(this.columnsRowCtrl);
        if (this.filtersRowCtrl) res.push(this.filtersRowCtrl);
        return res;
    }
    // grid cols have changed - this also means the number of rows in the header can have
    // changed. so we remove all the old rows and insert new ones for a complete refresh
    onGridColumnsChanged() {
        this.refresh(true);
    }
    onDisplayedColumnsChanged() {
        const includeFloatingFilter = this.filterManager.hasFloatingFilters() && !this.hidden;
        if (this.includeFloatingFilter !== includeFloatingFilter) this.refresh(true);
    }
    setupCenterWidth() {
        if (this.pinned != null) return;
        this.createManagedBean(new $437b23f6a393c3bf$var$CenterWidthFeature((width)=>this.comp.setCenterWidth(`${width}px`), true));
    }
    setHorizontalScroll(offset) {
        this.comp.setViewportScrollLeft(offset);
    }
    setupPinnedWidth() {
        if (this.pinned == null) return;
        const pinningLeft = this.pinned === "left";
        const pinningRight = this.pinned === "right";
        this.hidden = true;
        const listener = ()=>{
            const width = pinningLeft ? this.pinnedWidthService.getPinnedLeftWidth() : this.pinnedWidthService.getPinnedRightWidth();
            if (width == null) return;
            const hidden = width == 0;
            const hiddenChanged = this.hidden !== hidden;
            const isRtl = this.gos.get("enableRtl");
            const scrollbarWidth = this.gos.getScrollbarWidth();
            const addPaddingForScrollbar = this.scrollVisibleService.isVerticalScrollShowing() && (isRtl && pinningLeft || !isRtl && pinningRight);
            const widthWithPadding = addPaddingForScrollbar ? width + scrollbarWidth : width;
            this.comp.setPinnedContainerWidth(`${widthWithPadding}px`);
            this.comp.setDisplayed(!hidden);
            if (hiddenChanged) {
                this.hidden = hidden;
                this.refresh();
            }
        };
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_LEFT_PINNED_WIDTH_CHANGED, listener);
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_RIGHT_PINNED_WIDTH_CHANGED, listener);
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_SCROLL_VISIBILITY_CHANGED, listener);
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_SCROLLBAR_WIDTH_CHANGED, listener);
    }
    getHeaderCtrlForColumn(column) {
        if (column instanceof $437b23f6a393c3bf$export$816b5d811295e6bc) {
            if (!this.columnsRowCtrl) return;
            return this.columnsRowCtrl.getHeaderCellCtrl(column);
        }
        if (this.groupsRowCtrls.length === 0) return;
        for(let i = 0; i < this.groupsRowCtrls.length; i++){
            const ctrl = this.groupsRowCtrls[i].getHeaderCellCtrl(column);
            if (ctrl) return ctrl;
        }
    }
    getHtmlElementForColumnHeader(column) {
        const cellCtrl = this.getHeaderCtrlForColumn(column);
        if (!cellCtrl) return null;
        return cellCtrl.getGui();
    }
    getRowType(rowIndex) {
        const allCtrls = this.getAllCtrls();
        const ctrl = allCtrls[rowIndex];
        return ctrl ? ctrl.getType() : void 0;
    }
    focusHeader(rowIndex, column, event) {
        const allCtrls = this.getAllCtrls();
        const ctrl = allCtrls[rowIndex];
        if (!ctrl) return false;
        return ctrl.focusHeader(column, event);
    }
    getViewport() {
        return this.eViewport;
    }
    getRowCount() {
        return this.groupsRowCtrls.length + (this.columnsRowCtrl ? 1 : 0) + (this.filtersRowCtrl ? 1 : 0);
    }
    destroy() {
        if (this.filtersRowCtrl) this.filtersRowCtrl = this.destroyBean(this.filtersRowCtrl);
        if (this.columnsRowCtrl) this.columnsRowCtrl = this.destroyBean(this.columnsRowCtrl);
        if (this.groupsRowCtrls && this.groupsRowCtrls.length) this.groupsRowCtrls = this.destroyBeans(this.groupsRowCtrls);
        super.destroy();
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("ctrlsService")
], $437b23f6a393c3bf$export$1e864ee88f54e7b.prototype, "ctrlsService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("scrollVisibleService")
], $437b23f6a393c3bf$export$1e864ee88f54e7b.prototype, "scrollVisibleService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("pinnedWidthService")
], $437b23f6a393c3bf$export$1e864ee88f54e7b.prototype, "pinnedWidthService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnModel")
], $437b23f6a393c3bf$export$1e864ee88f54e7b.prototype, "columnModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("focusService")
], $437b23f6a393c3bf$export$1e864ee88f54e7b.prototype, "focusService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("filterManager")
], $437b23f6a393c3bf$export$1e864ee88f54e7b.prototype, "filterManager", 2);
// community-modules/core/src/headerRendering/rowContainer/headerRowContainerComp.ts
var $437b23f6a393c3bf$var$_HeaderRowContainerComp = class _HeaderRowContainerComp extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(pinned){
        super();
        this.headerRowComps = {};
        this.rowCompsList = [];
        this.pinned = pinned;
    }
    init() {
        this.selectAndSetTemplate();
        const compProxy = {
            setDisplayed: (displayed)=>this.setDisplayed(displayed),
            setCtrls: (ctrls)=>this.setCtrls(ctrls),
            // only gets called for center section
            setCenterWidth: (width)=>this.eCenterContainer.style.width = width,
            setViewportScrollLeft: (left)=>this.getGui().scrollLeft = left,
            // only gets called for pinned sections
            setPinnedContainerWidth: (width)=>{
                const eGui = this.getGui();
                eGui.style.width = width;
                eGui.style.maxWidth = width;
                eGui.style.minWidth = width;
            }
        };
        const ctrl = this.createManagedBean(new $437b23f6a393c3bf$export$1e864ee88f54e7b(this.pinned));
        ctrl.setComp(compProxy, this.getGui());
    }
    selectAndSetTemplate() {
        const pinnedLeft = this.pinned == "left";
        const pinnedRight = this.pinned == "right";
        const template = pinnedLeft ? _HeaderRowContainerComp.PINNED_LEFT_TEMPLATE : pinnedRight ? _HeaderRowContainerComp.PINNED_RIGHT_TEMPLATE : _HeaderRowContainerComp.CENTER_TEMPLATE;
        this.setTemplate(template);
        this.eRowContainer = this.eCenterContainer ? this.eCenterContainer : this.getGui();
    }
    destroyRowComps() {
        this.setCtrls([]);
    }
    destroyRowComp(rowComp) {
        this.destroyBean(rowComp);
        this.eRowContainer.removeChild(rowComp.getGui());
    }
    setCtrls(ctrls) {
        const oldRowComps = this.headerRowComps;
        this.headerRowComps = {};
        this.rowCompsList = [];
        let prevGui;
        const appendEnsuringDomOrder = (rowComp)=>{
            const eGui = rowComp.getGui();
            const notAlreadyIn = eGui.parentElement != this.eRowContainer;
            if (notAlreadyIn) this.eRowContainer.appendChild(eGui);
            if (prevGui) $437b23f6a393c3bf$var$ensureDomOrder(this.eRowContainer, eGui, prevGui);
            prevGui = eGui;
        };
        ctrls.forEach((ctrl)=>{
            const ctrlId = ctrl.getInstanceId();
            const existingComp = oldRowComps[ctrlId];
            delete oldRowComps[ctrlId];
            const rowComp = existingComp ? existingComp : this.createBean(new $437b23f6a393c3bf$export$e63c63fafc55a465(ctrl));
            this.headerRowComps[ctrlId] = rowComp;
            this.rowCompsList.push(rowComp);
            appendEnsuringDomOrder(rowComp);
        });
        $437b23f6a393c3bf$var$getAllValuesInObject(oldRowComps).forEach((c)=>this.destroyRowComp(c));
    }
};
$437b23f6a393c3bf$var$_HeaderRowContainerComp.PINNED_LEFT_TEMPLATE = /* html */ `<div class="ag-pinned-left-header" role="rowgroup"></div>`;
$437b23f6a393c3bf$var$_HeaderRowContainerComp.PINNED_RIGHT_TEMPLATE = /* html */ `<div class="ag-pinned-right-header" role="rowgroup"></div>`;
$437b23f6a393c3bf$var$_HeaderRowContainerComp.CENTER_TEMPLATE = /* html */ `<div class="ag-header-viewport" role="presentation">
            <div class="ag-header-container" ref="eCenterContainer" role="rowgroup"></div>
        </div>`;
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eCenterContainer")
], $437b23f6a393c3bf$var$_HeaderRowContainerComp.prototype, "eCenterContainer", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$_HeaderRowContainerComp.prototype, "init", 1);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$cc3f3d4529c57d95
], $437b23f6a393c3bf$var$_HeaderRowContainerComp.prototype, "destroyRowComps", 1);
var $437b23f6a393c3bf$export$f44f3572151186aa = $437b23f6a393c3bf$var$_HeaderRowContainerComp;
// community-modules/core/src/headerRendering/common/headerNavigationService.ts
var $437b23f6a393c3bf$export$17290b528485e8bd = /* @__PURE__ */ ((HeaderNavigationDirection2)=>{
    HeaderNavigationDirection2[HeaderNavigationDirection2["UP"] = 0] = "UP";
    HeaderNavigationDirection2[HeaderNavigationDirection2["DOWN"] = 1] = "DOWN";
    HeaderNavigationDirection2[HeaderNavigationDirection2["LEFT"] = 2] = "LEFT";
    HeaderNavigationDirection2[HeaderNavigationDirection2["RIGHT"] = 3] = "RIGHT";
    return HeaderNavigationDirection2;
})($437b23f6a393c3bf$export$17290b528485e8bd || {});
var $437b23f6a393c3bf$export$ee63d8b4f36fee20 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.currentHeaderRowWithoutSpan = -1;
    }
    postConstruct() {
        this.ctrlsService.whenReady((p)=>{
            this.gridBodyCon = p.gridBodyCtrl;
        });
        const eDocument = this.gos.getDocument();
        this.addManagedListener(eDocument, "mousedown", ()=>this.setCurrentHeaderRowWithoutSpan(-1));
    }
    getHeaderRowCount() {
        const centerHeaderContainer = this.ctrlsService.getHeaderRowContainerCtrl();
        return centerHeaderContainer ? centerHeaderContainer.getRowCount() : 0;
    }
    /*
   * This method navigates grid header vertically
   * @return {boolean} true to preventDefault on the event that caused this navigation.
   */ navigateVertically(direction, fromHeader, event) {
        if (!fromHeader) fromHeader = this.focusService.getFocusedHeader();
        if (!fromHeader) return false;
        const { headerRowIndex: headerRowIndex, column: column } = fromHeader;
        const rowLen = this.getHeaderRowCount();
        const isUp = direction === 0 /* UP */ ;
        let { headerRowIndex: nextRow, column: nextFocusColumn, headerRowIndexWithoutSpan: headerRowIndexWithoutSpan } = isUp ? this.headerPositionUtils.getColumnVisibleParent(column, headerRowIndex) : this.headerPositionUtils.getColumnVisibleChild(column, headerRowIndex);
        let skipColumn = false;
        if (nextRow < 0) {
            nextRow = 0;
            nextFocusColumn = column;
            skipColumn = true;
        }
        if (nextRow >= rowLen) {
            nextRow = -1;
            this.setCurrentHeaderRowWithoutSpan(-1);
        } else if (headerRowIndexWithoutSpan !== void 0) this.currentHeaderRowWithoutSpan = headerRowIndexWithoutSpan;
        if (!skipColumn && !nextFocusColumn) return false;
        return this.focusService.focusHeaderPosition({
            headerPosition: {
                headerRowIndex: nextRow,
                column: nextFocusColumn
            },
            allowUserOverride: true,
            event: event
        });
    }
    setCurrentHeaderRowWithoutSpan(row) {
        this.currentHeaderRowWithoutSpan = row;
    }
    /*
   * This method navigates grid header horizontally
   * @return {boolean} true to preventDefault on the event that caused this navigation.
   */ navigateHorizontally(direction, fromTab = false, event) {
        const focusedHeader = this.focusService.getFocusedHeader();
        const isLeft = direction === 2 /* LEFT */ ;
        const isRtl = this.gos.get("enableRtl");
        let nextHeader;
        let normalisedDirection;
        if (this.currentHeaderRowWithoutSpan !== -1) focusedHeader.headerRowIndex = this.currentHeaderRowWithoutSpan;
        else this.currentHeaderRowWithoutSpan = focusedHeader.headerRowIndex;
        if (isLeft !== isRtl) {
            normalisedDirection = "Before";
            nextHeader = this.headerPositionUtils.findHeader(focusedHeader, normalisedDirection);
        } else {
            normalisedDirection = "After";
            nextHeader = this.headerPositionUtils.findHeader(focusedHeader, normalisedDirection);
        }
        if (nextHeader || !fromTab) return this.focusService.focusHeaderPosition({
            headerPosition: nextHeader,
            direction: normalisedDirection,
            fromTab: fromTab,
            allowUserOverride: true,
            event: event
        });
        else if (fromTab) {
            const userFunc = this.gos.getCallback("tabToNextHeader");
            if (userFunc) return this.focusService.focusHeaderPositionFromUserFunc({
                userFunc: userFunc,
                headerPosition: nextHeader,
                direction: normalisedDirection
            });
        }
        return this.focusNextHeaderRow(focusedHeader, normalisedDirection, event);
    }
    focusNextHeaderRow(focusedHeader, direction, event) {
        const currentIndex = focusedHeader.headerRowIndex;
        let nextPosition = null;
        let nextRowIndex;
        if (direction === "Before") {
            if (currentIndex > 0) {
                nextRowIndex = currentIndex - 1;
                this.currentHeaderRowWithoutSpan -= 1;
                nextPosition = this.headerPositionUtils.findColAtEdgeForHeaderRow(nextRowIndex, "end");
            }
        } else {
            nextRowIndex = currentIndex + 1;
            if (this.currentHeaderRowWithoutSpan < this.getHeaderRowCount()) this.currentHeaderRowWithoutSpan += 1;
            else this.setCurrentHeaderRowWithoutSpan(-1);
            nextPosition = this.headerPositionUtils.findColAtEdgeForHeaderRow(nextRowIndex, "start");
        }
        if (!nextPosition) return false;
        const { column: column, headerRowIndex: headerRowIndex } = this.headerPositionUtils.getHeaderIndexToFocus(nextPosition.column, nextPosition == null ? void 0 : nextPosition.headerRowIndex);
        return this.focusService.focusHeaderPosition({
            headerPosition: {
                column: column,
                headerRowIndex: headerRowIndex
            },
            direction: direction,
            fromTab: true,
            allowUserOverride: true,
            event: event
        });
    }
    scrollToColumn(column, direction = "After") {
        if (column.getPinned()) return;
        let columnToScrollTo;
        if (column instanceof $437b23f6a393c3bf$export$8a8fbc71323f074) {
            const columns = column.getDisplayedLeafColumns();
            columnToScrollTo = direction === "Before" ? $437b23f6a393c3bf$var$last(columns) : columns[0];
        } else columnToScrollTo = column;
        this.gridBodyCon.getScrollFeature().ensureColumnVisible(columnToScrollTo);
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("focusService")
], $437b23f6a393c3bf$export$ee63d8b4f36fee20.prototype, "focusService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("headerPositionUtils")
], $437b23f6a393c3bf$export$ee63d8b4f36fee20.prototype, "headerPositionUtils", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("ctrlsService")
], $437b23f6a393c3bf$export$ee63d8b4f36fee20.prototype, "ctrlsService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$export$ee63d8b4f36fee20.prototype, "postConstruct", 1);
$437b23f6a393c3bf$export$ee63d8b4f36fee20 = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("headerNavigationService")
], $437b23f6a393c3bf$export$ee63d8b4f36fee20);
// community-modules/core/src/headerRendering/gridHeaderCtrl.ts
var $437b23f6a393c3bf$export$20b300eb69ca4d09 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    setComp(comp, eGui, eFocusableElement) {
        this.comp = comp;
        this.eGui = eGui;
        this.createManagedBean(new $437b23f6a393c3bf$export$5510e53ed3962582(eFocusableElement, {
            onTabKeyDown: this.onTabKeyDown.bind(this),
            handleKeyDown: this.handleKeyDown.bind(this),
            onFocusOut: this.onFocusOut.bind(this)
        }));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_PIVOT_MODE_CHANGED, this.onPivotModeChanged.bind(this));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
        this.onPivotModeChanged();
        this.setupHeaderHeight();
        const listener = this.onHeaderContextMenu.bind(this);
        this.addManagedListener(this.eGui, "contextmenu", listener);
        this.mockContextMenuForIPad(listener);
        this.ctrlsService.register("gridHeaderCtrl", this);
    }
    setupHeaderHeight() {
        const listener = this.setHeaderHeight.bind(this);
        listener();
        this.addManagedPropertyListener("headerHeight", listener);
        this.addManagedPropertyListener("pivotHeaderHeight", listener);
        this.addManagedPropertyListener("groupHeaderHeight", listener);
        this.addManagedPropertyListener("pivotGroupHeaderHeight", listener);
        this.addManagedPropertyListener("floatingFiltersHeight", listener);
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_DISPLAYED_COLUMNS_CHANGED, listener);
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_HEADER_HEIGHT_CHANGED, listener);
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_GRID_STYLES_CHANGED, listener);
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_ADVANCED_FILTER_ENABLED_CHANGED, listener);
    }
    getHeaderHeight() {
        return this.headerHeight;
    }
    setHeaderHeight() {
        const { columnModel: columnModel } = this;
        let numberOfFloating = 0;
        let headerRowCount = columnModel.getHeaderRowCount();
        let totalHeaderHeight;
        const hasFloatingFilters = this.filterManager.hasFloatingFilters();
        if (hasFloatingFilters) {
            headerRowCount++;
            numberOfFloating = 1;
        }
        const groupHeight = this.columnModel.getColumnGroupHeaderRowHeight();
        const headerHeight = this.columnModel.getColumnHeaderRowHeight();
        const numberOfNonGroups = 1 + numberOfFloating;
        const numberOfGroups = headerRowCount - numberOfNonGroups;
        totalHeaderHeight = numberOfFloating * columnModel.getFloatingFiltersHeight();
        totalHeaderHeight += numberOfGroups * groupHeight;
        totalHeaderHeight += headerHeight;
        if (this.headerHeight === totalHeaderHeight) return;
        this.headerHeight = totalHeaderHeight;
        const px = `${totalHeaderHeight + 1}px`;
        this.comp.setHeightAndMinHeight(px);
        this.eventService.dispatchEvent({
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_HEADER_HEIGHT_CHANGED
        });
    }
    onPivotModeChanged() {
        const pivotMode = this.columnModel.isPivotMode();
        this.comp.addOrRemoveCssClass("ag-pivot-on", pivotMode);
        this.comp.addOrRemoveCssClass("ag-pivot-off", !pivotMode);
    }
    onDisplayedColumnsChanged() {
        const columns = this.columnModel.getAllDisplayedColumns();
        const shouldAllowOverflow = columns.some((col)=>col.isSpanHeaderHeight());
        this.comp.addOrRemoveCssClass("ag-header-allow-overflow", shouldAllowOverflow);
    }
    onTabKeyDown(e) {
        const isRtl = this.gos.get("enableRtl");
        const direction = e.shiftKey !== isRtl ? 2 /* LEFT */  : 3 /* RIGHT */ ;
        if (this.headerNavigationService.navigateHorizontally(direction, true, e) || this.focusService.focusNextGridCoreContainer(e.shiftKey)) e.preventDefault();
    }
    handleKeyDown(e) {
        let direction = null;
        switch(e.key){
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT:
                direction = 2 /* LEFT */ ;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT:
                if (!$437b23f6a393c3bf$var$exists(direction)) direction = 3 /* RIGHT */ ;
                this.headerNavigationService.navigateHorizontally(direction, false, e);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
                direction = 0 /* UP */ ;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
                if (!$437b23f6a393c3bf$var$exists(direction)) direction = 1 /* DOWN */ ;
                if (this.headerNavigationService.navigateVertically(direction, null, e)) e.preventDefault();
                break;
            default:
                return;
        }
    }
    onFocusOut(e) {
        const { relatedTarget: relatedTarget } = e;
        if (!relatedTarget && this.eGui.contains(this.gos.getActiveDomElement())) return;
        if (!this.eGui.contains(relatedTarget)) this.focusService.clearFocusedHeader();
    }
    onHeaderContextMenu(mouseEvent, touch, touchEvent) {
        if (!mouseEvent && !touchEvent || !this.menuService.isHeaderContextMenuEnabled()) return;
        const { target: target } = mouseEvent != null ? mouseEvent : touch;
        if (target === this.eGui || target === this.ctrlsService.getHeaderRowContainerCtrl().getViewport()) this.menuService.showHeaderContextMenu(void 0, mouseEvent, touchEvent);
    }
    mockContextMenuForIPad(listener) {
        if (!$437b23f6a393c3bf$var$isIOSUserAgent()) return;
        const touchListener = new $437b23f6a393c3bf$export$7b2e93987414b382(this.eGui);
        const longTapListener = (event)=>{
            listener(void 0, event.touchStart, event.touchEvent);
        };
        this.addManagedListener(touchListener, $437b23f6a393c3bf$export$7b2e93987414b382.EVENT_LONG_TAP, longTapListener);
        this.addDestroyFunc(()=>touchListener.destroy());
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("headerNavigationService")
], $437b23f6a393c3bf$export$20b300eb69ca4d09.prototype, "headerNavigationService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("focusService")
], $437b23f6a393c3bf$export$20b300eb69ca4d09.prototype, "focusService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnModel")
], $437b23f6a393c3bf$export$20b300eb69ca4d09.prototype, "columnModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("ctrlsService")
], $437b23f6a393c3bf$export$20b300eb69ca4d09.prototype, "ctrlsService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("filterManager")
], $437b23f6a393c3bf$export$20b300eb69ca4d09.prototype, "filterManager", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("menuService")
], $437b23f6a393c3bf$export$20b300eb69ca4d09.prototype, "menuService", 2);
// community-modules/core/src/headerRendering/gridHeaderComp.ts
var $437b23f6a393c3bf$var$_GridHeaderComp = class _GridHeaderComp extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super(_GridHeaderComp.TEMPLATE);
    }
    postConstruct() {
        const compProxy = {
            addOrRemoveCssClass: (cssClassName, on)=>this.addOrRemoveCssClass(cssClassName, on),
            setHeightAndMinHeight: (height)=>{
                this.getGui().style.height = height;
                this.getGui().style.minHeight = height;
            }
        };
        const ctrl = this.createManagedBean(new $437b23f6a393c3bf$export$20b300eb69ca4d09());
        ctrl.setComp(compProxy, this.getGui(), this.getFocusableElement());
        const addContainer = (container)=>{
            this.createManagedBean(container);
            this.appendChild(container);
        };
        addContainer(new $437b23f6a393c3bf$export$f44f3572151186aa("left"));
        addContainer(new $437b23f6a393c3bf$export$f44f3572151186aa(null));
        addContainer(new $437b23f6a393c3bf$export$f44f3572151186aa("right"));
    }
};
$437b23f6a393c3bf$var$_GridHeaderComp.TEMPLATE = /* html */ `<div class="ag-header" role="presentation"/>`;
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$_GridHeaderComp.prototype, "postConstruct", 1);
var $437b23f6a393c3bf$export$a83f8d9da6e79f4 = $437b23f6a393c3bf$var$_GridHeaderComp;
// community-modules/core/src/headerRendering/common/horizontalResizeService.ts
var $437b23f6a393c3bf$export$8c88ee8741066b8b = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    addResizeBar(params) {
        const dragSource = {
            dragStartPixels: params.dragStartPixels || 0,
            eElement: params.eResizeBar,
            onDragStart: this.onDragStart.bind(this, params),
            onDragStop: this.onDragStop.bind(this, params),
            onDragging: this.onDragging.bind(this, params),
            includeTouch: true,
            stopPropagationForTouch: true
        };
        this.dragService.addDragSource(dragSource);
        const finishedWithResizeFunc = ()=>this.dragService.removeDragSource(dragSource);
        return finishedWithResizeFunc;
    }
    onDragStart(params, mouseEvent) {
        this.dragStartX = mouseEvent.clientX;
        this.setResizeIcons();
        const shiftKey = mouseEvent instanceof MouseEvent && mouseEvent.shiftKey === true;
        params.onResizeStart(shiftKey);
    }
    setResizeIcons() {
        const ctrl = this.ctrlsService.get("gridCtrl");
        ctrl.setResizeCursor(true);
        ctrl.disableUserSelect(true);
    }
    onDragStop(params, mouseEvent) {
        params.onResizeEnd(this.resizeAmount);
        this.resetIcons();
    }
    resetIcons() {
        const ctrl = this.ctrlsService.get("gridCtrl");
        ctrl.setResizeCursor(false);
        ctrl.disableUserSelect(false);
    }
    onDragging(params, mouseEvent) {
        this.resizeAmount = mouseEvent.clientX - this.dragStartX;
        params.onResizing(this.resizeAmount);
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("dragService")
], $437b23f6a393c3bf$export$8c88ee8741066b8b.prototype, "dragService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("ctrlsService")
], $437b23f6a393c3bf$export$8c88ee8741066b8b.prototype, "ctrlsService", 2);
$437b23f6a393c3bf$export$8c88ee8741066b8b = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("horizontalResizeService")
], $437b23f6a393c3bf$export$8c88ee8741066b8b);
// community-modules/core/src/headerRendering/cells/column/standardMenu.ts
var $437b23f6a393c3bf$export$ddca88023f936464 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    hideActiveMenu() {
        if (this.hidePopup) this.hidePopup();
    }
    showMenuAfterMouseEvent(column, mouseEvent, containerType) {
        this.showPopup(column, (eMenu)=>{
            this.popupService.positionPopupUnderMouseEvent({
                column: column,
                type: containerType,
                mouseEvent: mouseEvent,
                ePopup: eMenu
            });
        }, containerType, mouseEvent.target, this.menuService.isLegacyMenuEnabled());
    }
    showMenuAfterButtonClick(column, eventSource, containerType) {
        let multiplier = -1;
        let alignSide = "left";
        const isLegacyMenuEnabled = this.menuService.isLegacyMenuEnabled();
        if (!isLegacyMenuEnabled && this.gos.get("enableRtl")) {
            multiplier = 1;
            alignSide = "right";
        }
        let nudgeX = isLegacyMenuEnabled ? void 0 : 4 * multiplier;
        let nudgeY = isLegacyMenuEnabled ? void 0 : 4;
        this.showPopup(column, (eMenu)=>{
            this.popupService.positionPopupByComponent({
                type: containerType,
                eventSource: eventSource,
                ePopup: eMenu,
                nudgeX: nudgeX,
                nudgeY: nudgeY,
                alignSide: alignSide,
                keepWithinBounds: true,
                position: "under",
                column: column
            });
        }, containerType, eventSource, isLegacyMenuEnabled);
    }
    showPopup(column, positionCallback, containerType, eventSource, isLegacyMenuEnabled) {
        const comp = column ? this.createBean(new $437b23f6a393c3bf$export$70acaf0e0e30e7d(column, "COLUMN_MENU")) : void 0;
        this.activeMenu = comp;
        if (!(comp == null ? void 0 : comp.hasFilter()) || !column) throw new Error("AG Grid - unable to show popup filter, filter instantiation failed");
        const eMenu = document.createElement("div");
        $437b23f6a393c3bf$var$setAriaRole(eMenu, "presentation");
        eMenu.classList.add("ag-menu");
        if (!isLegacyMenuEnabled) eMenu.classList.add("ag-filter-menu");
        this.tabListener = this.addManagedListener(eMenu, "keydown", (e)=>this.trapFocusWithin(e, eMenu));
        eMenu.appendChild(comp == null ? void 0 : comp.getGui());
        let hidePopup;
        const afterGuiDetached = ()=>comp == null ? void 0 : comp.afterGuiDetached();
        const anchorToElement = this.menuService.isColumnMenuAnchoringEnabled() ? eventSource != null ? eventSource : this.ctrlsService.getGridBodyCtrl().getGui() : void 0;
        const closedCallback = (e)=>{
            column.setMenuVisible(false, "contextMenu");
            const isKeyboardEvent = e instanceof KeyboardEvent;
            if (this.tabListener) this.tabListener = this.tabListener();
            if (isKeyboardEvent && eventSource && $437b23f6a393c3bf$var$isVisible(eventSource)) {
                const focusableEl = this.focusService.findTabbableParent(eventSource);
                if (focusableEl) focusableEl.focus();
            }
            afterGuiDetached();
            this.destroyBean(this.activeMenu);
            this.dispatchVisibleChangedEvent(false, containerType, column);
        };
        const translate = this.localeService.getLocaleTextFunc();
        const ariaLabel = isLegacyMenuEnabled && containerType !== "columnFilter" ? translate("ariaLabelColumnMenu", "Column Menu") : translate("ariaLabelColumnFilter", "Column Filter");
        const addPopupRes = this.popupService.addPopup({
            modal: true,
            eChild: eMenu,
            closeOnEsc: true,
            closedCallback: closedCallback,
            positionCallback: ()=>positionCallback(eMenu),
            anchorToElement: anchorToElement,
            ariaLabel: ariaLabel
        });
        if (addPopupRes) this.hidePopup = hidePopup = addPopupRes.hideFunc;
        comp.afterInit().then(()=>{
            positionCallback(eMenu);
            comp.afterGuiAttached({
                container: containerType,
                hidePopup: hidePopup
            });
        });
        column.setMenuVisible(true, "contextMenu");
        this.dispatchVisibleChangedEvent(true, containerType, column);
    }
    trapFocusWithin(e, menu) {
        if (e.key !== $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB || e.defaultPrevented || this.focusService.findNextFocusableElement(menu, false, e.shiftKey)) return;
        e.preventDefault();
        this.focusService.focusInto(menu, e.shiftKey);
    }
    dispatchVisibleChangedEvent(visible, containerType, column) {
        const displayedEvent = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_MENU_VISIBLE_CHANGED,
            visible: visible,
            switchingTab: false,
            key: containerType,
            column: column != null ? column : null
        };
        this.eventService.dispatchEvent(displayedEvent);
    }
    isMenuEnabled(column) {
        var _a;
        return column.isFilterAllowed() && ((_a = column.getColDef().menuTabs) != null ? _a : [
            "filterMenuTab"
        ]).includes("filterMenuTab");
    }
    showMenuAfterContextMenuEvent() {}
    destroy() {
        this.destroyBean(this.activeMenu);
        super.destroy();
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("filterManager")
], $437b23f6a393c3bf$export$ddca88023f936464.prototype, "filterManager", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("popupService")
], $437b23f6a393c3bf$export$ddca88023f936464.prototype, "popupService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("focusService")
], $437b23f6a393c3bf$export$ddca88023f936464.prototype, "focusService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("ctrlsService")
], $437b23f6a393c3bf$export$ddca88023f936464.prototype, "ctrlsService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("menuService")
], $437b23f6a393c3bf$export$ddca88023f936464.prototype, "menuService", 2);
$437b23f6a393c3bf$export$ddca88023f936464 = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("filterMenuFactory")
], $437b23f6a393c3bf$export$ddca88023f936464);
// community-modules/core/src/widgets/tabGuardCtrl.ts
var $437b23f6a393c3bf$export$3be5727576441c72 = /* @__PURE__ */ ((TabGuardClassNames2)=>{
    TabGuardClassNames2["TAB_GUARD"] = "ag-tab-guard";
    TabGuardClassNames2["TAB_GUARD_TOP"] = "ag-tab-guard-top";
    TabGuardClassNames2["TAB_GUARD_BOTTOM"] = "ag-tab-guard-bottom";
    return TabGuardClassNames2;
})($437b23f6a393c3bf$export$3be5727576441c72 || {});
var $437b23f6a393c3bf$export$3074753638c3772c = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(params){
        super();
        this.skipTabGuardFocus = false;
        this.forcingFocusOut = false;
        const { comp: comp, eTopGuard: eTopGuard, eBottomGuard: eBottomGuard, focusTrapActive: focusTrapActive, forceFocusOutWhenTabGuardsAreEmpty: forceFocusOutWhenTabGuardsAreEmpty, focusInnerElement: focusInnerElement, onFocusIn: onFocusIn, onFocusOut: onFocusOut, shouldStopEventPropagation: shouldStopEventPropagation, onTabKeyDown: onTabKeyDown, handleKeyDown: handleKeyDown, eFocusableElement: eFocusableElement } = params;
        this.comp = comp;
        this.eTopGuard = eTopGuard;
        this.eBottomGuard = eBottomGuard;
        this.providedFocusInnerElement = focusInnerElement;
        this.eFocusableElement = eFocusableElement;
        this.focusTrapActive = !!focusTrapActive;
        this.forceFocusOutWhenTabGuardsAreEmpty = !!forceFocusOutWhenTabGuardsAreEmpty;
        this.providedFocusIn = onFocusIn;
        this.providedFocusOut = onFocusOut;
        this.providedShouldStopEventPropagation = shouldStopEventPropagation;
        this.providedOnTabKeyDown = onTabKeyDown;
        this.providedHandleKeyDown = handleKeyDown;
    }
    postConstruct() {
        this.createManagedBean(new $437b23f6a393c3bf$export$5510e53ed3962582(this.eFocusableElement, {
            shouldStopEventPropagation: ()=>this.shouldStopEventPropagation(),
            onTabKeyDown: (e)=>this.onTabKeyDown(e),
            handleKeyDown: (e)=>this.handleKeyDown(e),
            onFocusIn: (e)=>this.onFocusIn(e),
            onFocusOut: (e)=>this.onFocusOut(e)
        }));
        this.activateTabGuards();
        [
            this.eTopGuard,
            this.eBottomGuard
        ].forEach((guard)=>this.addManagedListener(guard, "focus", this.onFocus.bind(this)));
    }
    handleKeyDown(e) {
        if (this.providedHandleKeyDown) this.providedHandleKeyDown(e);
    }
    tabGuardsAreActive() {
        return !!this.eTopGuard && this.eTopGuard.hasAttribute("tabIndex");
    }
    shouldStopEventPropagation() {
        if (this.providedShouldStopEventPropagation) return this.providedShouldStopEventPropagation();
        return false;
    }
    activateTabGuards() {
        if (this.forcingFocusOut) return;
        const tabIndex = this.gos.get("tabIndex");
        this.comp.setTabIndex(tabIndex.toString());
    }
    deactivateTabGuards() {
        this.comp.setTabIndex();
    }
    onFocus(e) {
        if (this.skipTabGuardFocus) {
            this.skipTabGuardFocus = false;
            return;
        }
        if (this.forceFocusOutWhenTabGuardsAreEmpty) {
            const isEmpty = this.focusService.findFocusableElements(this.eFocusableElement, ".ag-tab-guard").length === 0;
            if (isEmpty) {
                this.findNextElementOutsideAndFocus(e.target === this.eBottomGuard);
                return;
            }
        }
        const fromBottom = e.target === this.eBottomGuard;
        if (this.providedFocusInnerElement) this.providedFocusInnerElement(fromBottom);
        else this.focusInnerElement(fromBottom);
    }
    findNextElementOutsideAndFocus(up) {
        const eDocument = this.gos.getDocument();
        const focusableEls = this.focusService.findFocusableElements(eDocument.body, null, true);
        const index = focusableEls.indexOf(up ? this.eTopGuard : this.eBottomGuard);
        if (index === -1) return;
        let start;
        let end;
        if (up) {
            start = 0;
            end = index;
        } else {
            start = index + 1;
            end = focusableEls.length;
        }
        const focusableRange = focusableEls.slice(start, end);
        const targetTabIndex = this.gos.get("tabIndex");
        focusableRange.sort((a, b)=>{
            const indexA = parseInt(a.getAttribute("tabindex") || "0");
            const indexB = parseInt(b.getAttribute("tabindex") || "0");
            if (indexB === targetTabIndex) return 1;
            if (indexA === targetTabIndex) return -1;
            if (indexA === 0) return 1;
            if (indexB === 0) return -1;
            return indexA - indexB;
        });
        focusableRange[up ? focusableRange.length - 1 : 0].focus();
    }
    onFocusIn(e) {
        if (this.focusTrapActive) return;
        if (this.providedFocusIn) this.providedFocusIn(e);
        this.deactivateTabGuards();
    }
    onFocusOut(e) {
        if (this.focusTrapActive) return;
        if (this.providedFocusOut) this.providedFocusOut(e);
        if (!this.eFocusableElement.contains(e.relatedTarget)) this.activateTabGuards();
    }
    onTabKeyDown(e) {
        if (this.providedOnTabKeyDown) {
            this.providedOnTabKeyDown(e);
            return;
        }
        if (this.focusTrapActive) return;
        if (e.defaultPrevented) return;
        const tabGuardsAreActive = this.tabGuardsAreActive();
        if (tabGuardsAreActive) this.deactivateTabGuards();
        const nextRoot = this.getNextFocusableElement(e.shiftKey);
        if (tabGuardsAreActive) setTimeout(()=>this.activateTabGuards(), 0);
        if (!nextRoot) return;
        nextRoot.focus();
        e.preventDefault();
    }
    focusInnerElement(fromBottom = false) {
        const focusable = this.focusService.findFocusableElements(this.eFocusableElement);
        if (this.tabGuardsAreActive()) {
            focusable.splice(0, 1);
            focusable.splice(focusable.length - 1, 1);
        }
        if (!focusable.length) return;
        focusable[fromBottom ? focusable.length - 1 : 0].focus({
            preventScroll: true
        });
    }
    getNextFocusableElement(backwards) {
        return this.focusService.findNextFocusableElement(this.eFocusableElement, false, backwards);
    }
    forceFocusOutOfContainer(up = false) {
        if (this.forcingFocusOut) return;
        const tabGuardToFocus = up ? this.eTopGuard : this.eBottomGuard;
        this.activateTabGuards();
        this.skipTabGuardFocus = true;
        this.forcingFocusOut = true;
        tabGuardToFocus.focus();
        window.setTimeout(()=>{
            this.forcingFocusOut = false;
            this.activateTabGuards();
        });
    }
    isTabGuard(element) {
        return element === this.eTopGuard || element === this.eBottomGuard;
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("focusService")
], $437b23f6a393c3bf$export$3074753638c3772c.prototype, "focusService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$export$3074753638c3772c.prototype, "postConstruct", 1);
// community-modules/core/src/widgets/tabGuardComp.ts
var $437b23f6a393c3bf$export$5a26e3abd1c845b6 = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    initialiseTabGuard(params) {
        this.eTopGuard = this.createTabGuard("top");
        this.eBottomGuard = this.createTabGuard("bottom");
        this.eFocusableElement = this.getFocusableElement();
        const tabGuards = [
            this.eTopGuard,
            this.eBottomGuard
        ];
        const compProxy = {
            setTabIndex: (tabIndex)=>{
                tabGuards.forEach((tabGuard)=>tabIndex != null ? tabGuard.setAttribute("tabindex", tabIndex) : tabGuard.removeAttribute("tabindex"));
            }
        };
        this.addTabGuards(this.eTopGuard, this.eBottomGuard);
        this.tabGuardCtrl = this.createManagedBean(new $437b23f6a393c3bf$export$3074753638c3772c({
            comp: compProxy,
            focusTrapActive: !!params.focusTrapActive,
            eTopGuard: this.eTopGuard,
            eBottomGuard: this.eBottomGuard,
            eFocusableElement: this.eFocusableElement,
            onFocusIn: params.onFocusIn,
            onFocusOut: params.onFocusOut,
            focusInnerElement: params.focusInnerElement,
            handleKeyDown: params.handleKeyDown,
            onTabKeyDown: params.onTabKeyDown,
            shouldStopEventPropagation: params.shouldStopEventPropagation,
            forceFocusOutWhenTabGuardsAreEmpty: params.forceFocusOutWhenTabGuardsAreEmpty
        }));
    }
    createTabGuard(side) {
        const tabGuard = document.createElement("div");
        const cls = side === "top" ? "ag-tab-guard-top" /* TAB_GUARD_TOP */  : "ag-tab-guard-bottom" /* TAB_GUARD_BOTTOM */ ;
        tabGuard.classList.add("ag-tab-guard" /* TAB_GUARD */ , cls);
        $437b23f6a393c3bf$var$setAriaRole(tabGuard, "presentation");
        return tabGuard;
    }
    addTabGuards(topTabGuard, bottomTabGuard) {
        this.eFocusableElement.insertAdjacentElement("afterbegin", topTabGuard);
        this.eFocusableElement.insertAdjacentElement("beforeend", bottomTabGuard);
    }
    removeAllChildrenExceptTabGuards() {
        const tabGuards = [
            this.eTopGuard,
            this.eBottomGuard
        ];
        $437b23f6a393c3bf$var$clearElement(this.getFocusableElement());
        this.addTabGuards(...tabGuards);
    }
    forceFocusOutOfContainer(up = false) {
        this.tabGuardCtrl.forceFocusOutOfContainer(up);
    }
    appendChild(newChild, container) {
        if (!$437b23f6a393c3bf$var$isNodeOrElement(newChild)) newChild = newChild.getGui();
        const { eBottomGuard: bottomTabGuard } = this;
        if (bottomTabGuard) bottomTabGuard.insertAdjacentElement("beforebegin", newChild);
        else super.appendChild(newChild, container);
    }
};
// community-modules/core/src/layout/tabbedLayout.ts
var $437b23f6a393c3bf$var$_TabbedLayout = class _TabbedLayout extends $437b23f6a393c3bf$export$5a26e3abd1c845b6 {
    constructor(params){
        super(_TabbedLayout.getTemplate(params.cssClass));
        this.items = [];
        this.tabbedItemScrollMap = /* @__PURE__ */ new Map();
        this.params = params;
    }
    postConstruct() {
        this.setupHeader();
        if (this.params.items) this.params.items.forEach((item)=>this.addItem(item));
        this.initialiseTabGuard({
            onTabKeyDown: this.onTabKeyDown.bind(this),
            handleKeyDown: this.handleKeyDown.bind(this),
            focusInnerElement: this.focusInnerElement.bind(this),
            focusTrapActive: true
        });
        this.addDestroyFunc(()=>{
            var _a, _b, _c;
            return (_c = (_b = (_a = this.activeItem) == null ? void 0 : _a.tabbedItem) == null ? void 0 : _b.afterDetachedCallback) == null ? void 0 : _c.call(_b);
        });
    }
    static getTemplate(cssClass) {
        return /* html */ `<div class="ag-tabs ${cssClass}">
            <div ref="eHeader"></div>
            <div ref="eBody" role="presentation" class="ag-tabs-body ${cssClass ? `${cssClass}-body` : ""}"></div>
        </div>`;
    }
    setupHeader() {
        const { enableCloseButton: enableCloseButton, cssClass: cssClass } = this.params;
        const addCssClasses = (el, suffix)=>{
            el.classList.add(`ag-tabs-${suffix}`);
            if (cssClass) el.classList.add(`${cssClass}-${suffix}`);
        };
        if (enableCloseButton) {
            this.setupCloseButton(addCssClasses);
            this.eTabHeader = this.gos.getDocument().createElement("div");
            addCssClasses(this.eHeader, "header-wrapper");
            $437b23f6a393c3bf$var$setAriaRole(this.eHeader, "presentation");
            this.eHeader.appendChild(this.eTabHeader);
        } else this.eTabHeader = this.eHeader;
        $437b23f6a393c3bf$var$setAriaRole(this.eTabHeader, "tablist");
        addCssClasses(this.eTabHeader, "header");
    }
    setupCloseButton(addCssClasses) {
        const eDocument = this.gos.getDocument();
        const eCloseButton = eDocument.createElement("button");
        addCssClasses(eCloseButton, "close-button");
        const eIcon = $437b23f6a393c3bf$var$createIconNoSpan("close", this.gos, void 0, true);
        $437b23f6a393c3bf$var$setAriaLabel(eCloseButton, this.params.closeButtonAriaLabel);
        eCloseButton.appendChild(eIcon);
        this.addManagedListener(eCloseButton, "click", ()=>{
            var _a, _b;
            return (_b = (_a = this.params).onCloseClicked) == null ? void 0 : _b.call(_a);
        });
        const eCloseButtonWrapper = eDocument.createElement("div");
        addCssClasses(eCloseButtonWrapper, "close-button-wrapper");
        $437b23f6a393c3bf$var$setAriaRole(eCloseButtonWrapper, "presentation");
        eCloseButtonWrapper.appendChild(eCloseButton);
        this.eHeader.appendChild(eCloseButtonWrapper);
        this.eCloseButton = eCloseButton;
    }
    handleKeyDown(e) {
        switch(e.key){
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT:
                if (!this.eTabHeader.contains(this.gos.getActiveDomElement())) return;
                const isRightKey = e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT;
                const isRtl = this.gos.get("enableRtl");
                const currentPosition = this.items.indexOf(this.activeItem);
                const nextPosition = isRightKey !== isRtl ? Math.min(currentPosition + 1, this.items.length - 1) : Math.max(currentPosition - 1, 0);
                if (currentPosition === nextPosition) return;
                e.preventDefault();
                const nextItem = this.items[nextPosition];
                this.showItemWrapper(nextItem);
                nextItem.eHeaderButton.focus();
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
                e.stopPropagation();
                break;
        }
    }
    onTabKeyDown(e) {
        var _a, _b, _c, _d;
        if (e.defaultPrevented) return;
        const { focusService: focusService, eHeader: eHeader, eBody: eBody, activeItem: activeItem, params: params } = this;
        const { suppressTrapFocus: suppressTrapFocus, enableCloseButton: enableCloseButton } = params;
        const activeElement = this.gos.getActiveDomElement();
        const target = e.target;
        const backwards = e.shiftKey;
        if (eHeader.contains(activeElement)) {
            e.preventDefault();
            if (enableCloseButton && backwards && !((_a = this.eCloseButton) == null ? void 0 : _a.contains(activeElement))) (_b = this.eCloseButton) == null || _b.focus();
            else if (suppressTrapFocus && backwards) (_c = this.focusService.findFocusableElementBeforeTabGuard(this.gos.getDocument().body, target)) == null || _c.focus();
            else this.focusBody(e.shiftKey);
            return;
        }
        let nextEl = null;
        if (focusService.isTargetUnderManagedComponent(eBody, target)) {
            if (backwards) nextEl = this.focusService.findFocusableElementBeforeTabGuard(eBody, target);
            if (!nextEl && !suppressTrapFocus) nextEl = activeItem.eHeaderButton;
        }
        if (!nextEl && eBody.contains(activeElement)) {
            nextEl = focusService.findNextFocusableElement(eBody, false, backwards);
            if (!nextEl) {
                e.preventDefault();
                if (suppressTrapFocus && !backwards) this.forceFocusOutOfContainer(backwards);
                else if (enableCloseButton && !backwards) (_d = this.eCloseButton) == null || _d.focus();
                else this.focusHeader();
                return;
            }
        }
        if (nextEl) {
            e.preventDefault();
            nextEl.focus();
        }
    }
    focusInnerElement(fromBottom) {
        if (fromBottom) this.focusHeader();
        else this.focusBody(true);
    }
    focusHeader(preventScroll) {
        this.activeItem.eHeaderButton.focus({
            preventScroll: preventScroll
        });
    }
    focusBody(fromBottom) {
        this.focusService.focusInto(this.eBody, fromBottom);
    }
    setAfterAttachedParams(params) {
        this.afterAttachedParams = params;
    }
    showFirstItem() {
        if (this.items.length > 0) this.showItemWrapper(this.items[0]);
    }
    addItem(item) {
        const eHeaderButton = document.createElement("span");
        $437b23f6a393c3bf$var$setAriaRole(eHeaderButton, "tab");
        eHeaderButton.setAttribute("tabindex", "-1");
        eHeaderButton.appendChild(item.title);
        eHeaderButton.classList.add("ag-tab");
        this.eTabHeader.appendChild(eHeaderButton);
        $437b23f6a393c3bf$var$setAriaLabel(eHeaderButton, item.titleLabel);
        const wrapper = {
            tabbedItem: item,
            eHeaderButton: eHeaderButton
        };
        this.items.push(wrapper);
        eHeaderButton.addEventListener("click", this.showItemWrapper.bind(this, wrapper));
    }
    showItem(tabbedItem) {
        const itemWrapper = this.items.find((wrapper)=>wrapper.tabbedItem === tabbedItem);
        if (itemWrapper) this.showItemWrapper(itemWrapper);
    }
    showItemWrapper(wrapper) {
        var _a, _b, _c, _d, _e, _f;
        const { tabbedItem: tabbedItem, eHeaderButton: eHeaderButton } = wrapper;
        (_b = (_a = this.params).onItemClicked) == null || _b.call(_a, {
            item: tabbedItem
        });
        if (this.activeItem === wrapper) {
            (_d = (_c = this.params).onActiveItemClicked) == null || _d.call(_c);
            return;
        }
        if (this.lastScrollListener) this.lastScrollListener = this.lastScrollListener();
        $437b23f6a393c3bf$var$clearElement(this.eBody);
        tabbedItem.bodyPromise.then((body)=>{
            this.eBody.appendChild(body);
            const onlyUnmanaged = !this.focusService.isKeyboardMode();
            if (!this.params.suppressFocusBodyOnOpen) this.focusService.focusInto(this.eBody, false, onlyUnmanaged);
            if (tabbedItem.afterAttachedCallback) tabbedItem.afterAttachedCallback(this.afterAttachedParams);
            if (this.params.keepScrollPosition) {
                const scrollableContainer = tabbedItem.getScrollableContainer && tabbedItem.getScrollableContainer() || body;
                this.lastScrollListener = this.addManagedListener(scrollableContainer, "scroll", ()=>{
                    this.tabbedItemScrollMap.set(tabbedItem.name, scrollableContainer.scrollTop);
                });
                const scrollPosition = this.tabbedItemScrollMap.get(tabbedItem.name);
                if (scrollPosition !== void 0) setTimeout(()=>{
                    scrollableContainer.scrollTop = scrollPosition;
                }, 0);
            }
        });
        if (this.activeItem) {
            this.activeItem.eHeaderButton.classList.remove("ag-tab-selected");
            (_f = (_e = this.activeItem.tabbedItem).afterDetachedCallback) == null || _f.call(_e);
        }
        eHeaderButton.classList.add("ag-tab-selected");
        this.activeItem = wrapper;
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("focusService")
], $437b23f6a393c3bf$var$_TabbedLayout.prototype, "focusService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eHeader")
], $437b23f6a393c3bf$var$_TabbedLayout.prototype, "eHeader", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eBody")
], $437b23f6a393c3bf$var$_TabbedLayout.prototype, "eBody", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$_TabbedLayout.prototype, "postConstruct", 1);
var $437b23f6a393c3bf$export$e71fa82861e8f8 = $437b23f6a393c3bf$var$_TabbedLayout;
// community-modules/core/src/misc/resizeObserverService.ts
var $437b23f6a393c3bf$var$DEBOUNCE_DELAY = 50;
var $437b23f6a393c3bf$export$c3ae9ac02599b50f = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.polyfillFunctions = [];
    }
    observeResize(element, callback) {
        const win = this.gos.getWindow();
        const useBrowserResizeObserver = ()=>{
            const resizeObserver = new win.ResizeObserver(callback);
            resizeObserver.observe(element);
            return ()=>resizeObserver.disconnect();
        };
        const usePolyfill = ()=>{
            var _a, _b;
            let widthLastTime = (_a = element == null ? void 0 : element.clientWidth) != null ? _a : 0;
            let heightLastTime = (_b = element == null ? void 0 : element.clientHeight) != null ? _b : 0;
            let running = true;
            const periodicallyCheckWidthAndHeight = ()=>{
                var _a2, _b2;
                if (running) {
                    const newWidth = (_a2 = element == null ? void 0 : element.clientWidth) != null ? _a2 : 0;
                    const newHeight = (_b2 = element == null ? void 0 : element.clientHeight) != null ? _b2 : 0;
                    const changed = newWidth !== widthLastTime || newHeight !== heightLastTime;
                    if (changed) {
                        widthLastTime = newWidth;
                        heightLastTime = newHeight;
                        callback();
                    }
                    this.doNextPolyfillTurn(periodicallyCheckWidthAndHeight);
                }
            };
            periodicallyCheckWidthAndHeight();
            return ()=>running = false;
        };
        const suppressResize = this.gos.get("suppressBrowserResizeObserver");
        const resizeObserverExists = !!win.ResizeObserver;
        if (resizeObserverExists && !suppressResize) return useBrowserResizeObserver();
        return this.getFrameworkOverrides().wrapIncoming(()=>usePolyfill(), "resize-observer");
    }
    doNextPolyfillTurn(func) {
        this.polyfillFunctions.push(func);
        this.schedulePolyfill();
    }
    schedulePolyfill() {
        if (this.polyfillScheduled) return;
        const executeAllFuncs = ()=>{
            const funcs = this.polyfillFunctions;
            this.polyfillScheduled = false;
            this.polyfillFunctions = [];
            funcs.forEach((f)=>f());
        };
        this.polyfillScheduled = true;
        window.setTimeout(executeAllFuncs, $437b23f6a393c3bf$var$DEBOUNCE_DELAY);
    }
};
$437b23f6a393c3bf$export$c3ae9ac02599b50f = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("resizeObserverService")
], $437b23f6a393c3bf$export$c3ae9ac02599b50f);
// community-modules/core/src/misc/animationFrameService.ts
var $437b23f6a393c3bf$export$2963e6121f7c3146 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        // p1 and p2 are create tasks are to do with row and cell creation.
        // for them we want to execute according to row order, so we use
        // TaskItem so we know what index the item is for.
        this.createTasksP1 = {
            list: [],
            sorted: false
        };
        // eg drawing back-ground of rows
        this.createTasksP2 = {
            list: [],
            sorted: false
        };
        // eg cell renderers, adding hover functionality
        // destroy tasks are to do with row removal. they are done after row creation as the user will need to see new
        // rows first (as blank is scrolled into view), when we remove the old rows (no longer in view) is not as
        // important.
        this.destroyTasks = [];
        this.ticking = false;
        // we need to know direction of scroll, to build up rows in the direction of
        // the scroll. eg if user scrolls down, we extend the rows by building down.
        this.scrollGoingDown = true;
        this.lastPage = 0;
        this.lastScrollTop = 0;
        this.taskCount = 0;
        this.cancelledTasks = /* @__PURE__ */ new Set();
    }
    setScrollTop(scrollTop) {
        const isPaginationActive = this.gos.get("pagination");
        this.scrollGoingDown = scrollTop >= this.lastScrollTop;
        if (isPaginationActive && scrollTop === 0) {
            const currentPage = this.paginationProxy.getCurrentPage();
            if (currentPage !== this.lastPage) {
                this.lastPage = currentPage;
                this.scrollGoingDown = true;
            }
        }
        this.lastScrollTop = scrollTop;
    }
    init() {
        this.useAnimationFrame = !this.gos.get("suppressAnimationFrame");
    }
    isOn() {
        return this.useAnimationFrame;
    }
    // this method is for our AG Grid sanity only - if animation frames are turned off,
    // then no place in the code should be looking to add any work to be done in animation
    // frames. this stops bugs - where some code is asking for a frame to be executed
    // when it should not.
    verifyAnimationFrameOn(methodName) {
        if (this.useAnimationFrame === false) console.warn(`AG Grid: AnimationFrameService.${methodName} called but animation frames are off`);
    }
    createTask(task, index, list) {
        this.verifyAnimationFrameOn(list);
        const taskItem = {
            task: task,
            index: index,
            createOrder: ++this.taskCount
        };
        this.addTaskToList(this[list], taskItem);
        this.schedule();
    }
    cancelTask(task) {
        this.cancelledTasks.add(task);
    }
    addTaskToList(taskList, task) {
        taskList.list.push(task);
        taskList.sorted = false;
    }
    sortTaskList(taskList) {
        if (taskList.sorted) return;
        const sortDirection = this.scrollGoingDown ? 1 : -1;
        taskList.list.sort((a, b)=>a.index !== b.index ? sortDirection * (b.index - a.index) : b.createOrder - a.createOrder);
        taskList.sorted = true;
    }
    addDestroyTask(task) {
        this.verifyAnimationFrameOn("createTasksP3");
        this.destroyTasks.push(task);
        this.schedule();
    }
    executeFrame(millis) {
        this.verifyAnimationFrameOn("executeFrame");
        const p1TaskList = this.createTasksP1;
        const p1Tasks = p1TaskList.list;
        const p2TaskList = this.createTasksP2;
        const p2Tasks = p2TaskList.list;
        const destroyTasks = this.destroyTasks;
        const frameStart = /* @__PURE__ */ new Date().getTime();
        let duration = /* @__PURE__ */ new Date().getTime() - frameStart;
        const noMaxMillis = millis <= 0;
        const gridBodyCon = this.ctrlsService.getGridBodyCtrl();
        while(noMaxMillis || duration < millis){
            const gridBodyDidSomething = gridBodyCon.getScrollFeature().scrollGridIfNeeded();
            if (!gridBodyDidSomething) {
                let task;
                if (p1Tasks.length) {
                    this.sortTaskList(p1TaskList);
                    task = p1Tasks.pop().task;
                } else if (p2Tasks.length) {
                    this.sortTaskList(p2TaskList);
                    task = p2Tasks.pop().task;
                } else if (destroyTasks.length) task = destroyTasks.pop();
                else {
                    this.cancelledTasks.clear();
                    break;
                }
                if (!this.cancelledTasks.has(task)) task();
            }
            duration = /* @__PURE__ */ new Date().getTime() - frameStart;
        }
        if (p1Tasks.length || p2Tasks.length || destroyTasks.length) this.requestFrame();
        else this.stopTicking();
    }
    stopTicking() {
        this.ticking = false;
    }
    flushAllFrames() {
        if (!this.useAnimationFrame) return;
        this.executeFrame(-1);
    }
    schedule() {
        if (!this.useAnimationFrame) return;
        if (!this.ticking) {
            this.ticking = true;
            this.requestFrame();
        }
    }
    requestFrame() {
        const callback = this.executeFrame.bind(this, 60);
        this.requestAnimationFrame(callback);
    }
    requestAnimationFrame(callback) {
        const win = this.gos.getWindow();
        if (win.requestAnimationFrame) win.requestAnimationFrame(callback);
        else if (win.webkitRequestAnimationFrame) win.webkitRequestAnimationFrame(callback);
        else win.setTimeout(callback, 0);
    }
    isQueueEmpty() {
        return !this.ticking;
    }
    // a debounce utility used for parts of the app involved with rendering.
    // the advantage over normal debounce is the client can call flushAllFrames()
    // to make sure all rendering is complete. we don't wait any milliseconds,
    // as this is intended to batch calls in one VM turn.
    debounce(func) {
        let pending = false;
        return ()=>{
            if (!this.isOn()) {
                window.setTimeout(func, 0);
                return;
            }
            if (pending) return;
            pending = true;
            this.addDestroyTask(()=>{
                pending = false;
                func();
            });
        };
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("ctrlsService")
], $437b23f6a393c3bf$export$2963e6121f7c3146.prototype, "ctrlsService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("paginationProxy")
], $437b23f6a393c3bf$export$2963e6121f7c3146.prototype, "paginationProxy", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$export$2963e6121f7c3146.prototype, "init", 1);
$437b23f6a393c3bf$export$2963e6121f7c3146 = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("animationFrameService")
], $437b23f6a393c3bf$export$2963e6121f7c3146);
// community-modules/core/src/interfaces/iClientSideRowModel.ts
var $437b23f6a393c3bf$export$42ac378faabadc9d = /* @__PURE__ */ ((ClientSideRowModelSteps2)=>{
    ClientSideRowModelSteps2["EVERYTHING"] = "group";
    ClientSideRowModelSteps2["FILTER"] = "filter";
    ClientSideRowModelSteps2["SORT"] = "sort";
    ClientSideRowModelSteps2["MAP"] = "map";
    ClientSideRowModelSteps2["AGGREGATE"] = "aggregate";
    ClientSideRowModelSteps2["FILTER_AGGREGATES"] = "filter_aggregates";
    ClientSideRowModelSteps2["PIVOT"] = "pivot";
    ClientSideRowModelSteps2["NOTHING"] = "nothing";
    return ClientSideRowModelSteps2;
})($437b23f6a393c3bf$export$42ac378faabadc9d || {});
// community-modules/core/src/misc/expansionService.ts
var $437b23f6a393c3bf$export$609b78da5e2f116c = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    postConstruct() {
        this.isClientSideRowModel = this.rowModel.getType() === "clientSide";
    }
    expandRows(rowIds) {
        if (!this.isClientSideRowModel) return;
        const rowIdSet = new Set(rowIds);
        this.rowModel.forEachNode((node)=>{
            if (node.id && rowIdSet.has(node.id)) node.expanded = true;
        });
        this.onGroupExpandedOrCollapsed();
    }
    getExpandedRows() {
        const expandedRows = [];
        this.rowModel.forEachNode(({ expanded: expanded, id: id })=>{
            if (expanded && id) expandedRows.push(id);
        });
        return expandedRows;
    }
    expandAll(value) {
        if (!this.isClientSideRowModel) return;
        this.rowModel.expandOrCollapseAll(value);
    }
    setRowNodeExpanded(rowNode, expanded, expandParents, forceSync) {
        if (rowNode) {
            if (expandParents && rowNode.parent && rowNode.parent.level !== -1) this.setRowNodeExpanded(rowNode.parent, expanded, expandParents, forceSync);
            rowNode.setExpanded(expanded, void 0, forceSync);
        }
    }
    onGroupExpandedOrCollapsed() {
        if (!this.isClientSideRowModel) return;
        this.rowModel.refreshModel({
            step: "map" /* MAP */ 
        });
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowModel")
], $437b23f6a393c3bf$export$609b78da5e2f116c.prototype, "rowModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$export$609b78da5e2f116c.prototype, "postConstruct", 1);
$437b23f6a393c3bf$export$609b78da5e2f116c = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("expansionService")
], $437b23f6a393c3bf$export$609b78da5e2f116c);
// community-modules/core/src/misc/menuService.ts
var $437b23f6a393c3bf$export$ec78627b94a587e2 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    postConstruct() {
        var _a;
        this.activeMenuFactory = (_a = this.enterpriseMenuFactory) != null ? _a : this.filterMenuFactory;
    }
    showColumnMenu(params) {
        this.showColumnMenuCommon(this.activeMenuFactory, params, "columnMenu");
    }
    showFilterMenu(params) {
        const menuFactory = this.enterpriseMenuFactory && this.isLegacyMenuEnabled() ? this.enterpriseMenuFactory : this.filterMenuFactory;
        this.showColumnMenuCommon(menuFactory, params, params.containerType, true);
    }
    showHeaderContextMenu(column, mouseEvent, touchEvent) {
        this.activeMenuFactory.showMenuAfterContextMenuEvent(column, mouseEvent, touchEvent);
    }
    getContextMenuPosition(rowNode, column) {
        const rowCtrl = this.getRowCtrl(rowNode);
        const eGui = this.getCellGui(rowCtrl, column);
        if (!eGui) {
            if (rowCtrl) return {
                x: 0,
                y: rowCtrl.getRowYPosition()
            };
            return {
                x: 0,
                y: 0
            };
        }
        const rect = eGui.getBoundingClientRect();
        return {
            x: rect.x + rect.width / 2,
            y: rect.y + rect.height / 2
        };
    }
    showContextMenu(params) {
        var _a, _b, _c;
        const { column: column, rowNode: rowNode } = params;
        let { anchorToElement: anchorToElement, value: value } = params;
        if (rowNode && column && value == null) value = rowNode.getValueFromValueService(column);
        if (anchorToElement == null) anchorToElement = this.getContextMenuAnchorElement(rowNode, column);
        (_c = this.contextMenuFactory) == null || _c.onContextMenu((_a = params.mouseEvent) != null ? _a : null, (_b = params.touchEvent) != null ? _b : null, rowNode != null ? rowNode : null, column != null ? column : null, value, anchorToElement);
    }
    showColumnChooser(params) {
        var _a;
        (_a = this.columnChooserFactory) == null || _a.showColumnChooser(params);
    }
    hidePopupMenu() {
        var _a;
        (_a = this.contextMenuFactory) == null || _a.hideActiveMenu();
        this.activeMenuFactory.hideActiveMenu();
    }
    hideColumnChooser() {
        var _a;
        (_a = this.columnChooserFactory) == null || _a.hideActiveColumnChooser();
    }
    isColumnMenuInHeaderEnabled(column) {
        const { suppressMenu: suppressMenu, suppressHeaderMenuButton: suppressHeaderMenuButton } = column.getColDef();
        const isSuppressMenuButton = suppressHeaderMenuButton != null ? suppressHeaderMenuButton : suppressMenu;
        return !isSuppressMenuButton && this.activeMenuFactory.isMenuEnabled(column) && (this.isLegacyMenuEnabled() || !!this.enterpriseMenuFactory);
    }
    isFilterMenuInHeaderEnabled(column) {
        return !column.getColDef().suppressHeaderFilterButton && this.filterManager.isFilterAllowed(column);
    }
    isHeaderContextMenuEnabled(column) {
        return !(column == null ? void 0 : column.getColDef().suppressHeaderContextMenu) && this.getColumnMenuType() === "new";
    }
    isHeaderMenuButtonAlwaysShowEnabled() {
        return this.isSuppressMenuHide();
    }
    isHeaderMenuButtonEnabled() {
        const menuHides = !this.isSuppressMenuHide();
        const onIpadAndMenuHides = $437b23f6a393c3bf$var$isIOSUserAgent() && menuHides;
        return !onIpadAndMenuHides;
    }
    isHeaderFilterButtonEnabled(column) {
        return this.isFilterMenuInHeaderEnabled(column) && !this.isLegacyMenuEnabled() && !this.isFloatingFilterButtonDisplayed(column);
    }
    isFilterMenuItemEnabled(column) {
        return this.filterManager.isFilterAllowed(column) && !this.isLegacyMenuEnabled() && !this.isFilterMenuInHeaderEnabled(column) && !this.isFloatingFilterButtonDisplayed(column);
    }
    isColumnMenuAnchoringEnabled() {
        return !this.isLegacyMenuEnabled();
    }
    areAdditionalColumnMenuItemsEnabled() {
        return this.getColumnMenuType() === "new";
    }
    isLegacyMenuEnabled() {
        return this.getColumnMenuType() === "legacy";
    }
    isFloatingFilterButtonEnabled(column) {
        var _a;
        const colDef = column.getColDef();
        const legacySuppressFilterButton = (_a = colDef.floatingFilterComponentParams) == null ? void 0 : _a.suppressFilterButton;
        if (legacySuppressFilterButton != null) $437b23f6a393c3bf$var$warnOnce(`As of v31.1, 'colDef.floatingFilterComponentParams.suppressFilterButton' is deprecated. Use 'colDef.suppressFloatingFilterButton' instead.`);
        return colDef.suppressFloatingFilterButton == null ? !legacySuppressFilterButton : !colDef.suppressFloatingFilterButton;
    }
    getColumnMenuType() {
        var _a;
        return (_a = this.gos.get("columnMenu")) != null ? _a : "legacy";
    }
    isFloatingFilterButtonDisplayed(column) {
        return !!column.getColDef().floatingFilter && this.isFloatingFilterButtonEnabled(column);
    }
    isSuppressMenuHide() {
        const suppressMenuHide = this.gos.get("suppressMenuHide");
        if (this.isLegacyMenuEnabled()) return suppressMenuHide;
        else return this.gos.exists("suppressMenuHide") ? suppressMenuHide : true;
    }
    showColumnMenuCommon(menuFactory, params, containerType, filtersOnly) {
        const { column: column, positionBy: positionBy } = params;
        if (positionBy === "button") {
            const { buttonElement: buttonElement } = params;
            menuFactory.showMenuAfterButtonClick(column, buttonElement, containerType, filtersOnly);
        } else if (positionBy === "mouse") {
            const { mouseEvent: mouseEvent } = params;
            menuFactory.showMenuAfterMouseEvent(column, mouseEvent, containerType, filtersOnly);
        } else if (column) {
            this.ctrlsService.getGridBodyCtrl().getScrollFeature().ensureColumnVisible(column, "auto");
            this.animationFrameService.requestAnimationFrame(()=>{
                const headerCellCtrl = this.ctrlsService.getHeaderRowContainerCtrl(column.getPinned()).getHeaderCtrlForColumn(column);
                menuFactory.showMenuAfterButtonClick(column, headerCellCtrl.getAnchorElementForMenu(filtersOnly), containerType, true);
            });
        }
    }
    getRowCtrl(rowNode) {
        const { rowIndex: rowIndex, rowPinned: rowPinned } = rowNode || {};
        if (rowIndex == null) return;
        return this.rowRenderer.getRowByPosition({
            rowIndex: rowIndex,
            rowPinned: rowPinned
        }) || void 0;
    }
    getCellGui(rowCtrl, column) {
        if (!rowCtrl || !column) return;
        const cellCtrl = rowCtrl.getCellCtrl(column);
        return (cellCtrl == null ? void 0 : cellCtrl.getGui()) || void 0;
    }
    getContextMenuAnchorElement(rowNode, column) {
        const gridBodyEl = this.ctrlsService.getGridBodyCtrl().getGridBodyElement();
        const rowCtrl = this.getRowCtrl(rowNode);
        if (!rowCtrl) return gridBodyEl;
        const cellGui = this.getCellGui(rowCtrl, column);
        if (cellGui) return cellGui;
        if (rowCtrl.isFullWidth()) return rowCtrl.getFullWidthElement();
        return gridBodyEl;
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("filterMenuFactory")
], $437b23f6a393c3bf$export$ec78627b94a587e2.prototype, "filterMenuFactory", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("ctrlsService")
], $437b23f6a393c3bf$export$ec78627b94a587e2.prototype, "ctrlsService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("animationFrameService")
], $437b23f6a393c3bf$export$ec78627b94a587e2.prototype, "animationFrameService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("filterManager")
], $437b23f6a393c3bf$export$ec78627b94a587e2.prototype, "filterManager", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowRenderer")
], $437b23f6a393c3bf$export$ec78627b94a587e2.prototype, "rowRenderer", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$7acb7b24c478f9c6("columnChooserFactory")
], $437b23f6a393c3bf$export$ec78627b94a587e2.prototype, "columnChooserFactory", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$7acb7b24c478f9c6("contextMenuFactory")
], $437b23f6a393c3bf$export$ec78627b94a587e2.prototype, "contextMenuFactory", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$7acb7b24c478f9c6("enterpriseMenuFactory")
], $437b23f6a393c3bf$export$ec78627b94a587e2.prototype, "enterpriseMenuFactory", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$export$ec78627b94a587e2.prototype, "postConstruct", 1);
$437b23f6a393c3bf$export$ec78627b94a587e2 = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("menuService")
], $437b23f6a393c3bf$export$ec78627b94a587e2);
// community-modules/core/src/rendering/autoWidthCalculator.ts
var $437b23f6a393c3bf$export$cc129c761c9af6b5 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    postConstruct() {
        this.ctrlsService.whenReady((p)=>{
            this.centerRowContainerCtrl = p.center;
        });
    }
    // this is the trick: we create a dummy container and clone all the cells
    // into the dummy, then check the dummy's width. then destroy the dummy
    // as we don't need it any more.
    // drawback: only the cells visible on the screen are considered
    getPreferredWidthForColumn(column, skipHeader) {
        const eHeaderCell = this.getHeaderCellForColumn(column);
        if (!eHeaderCell) return -1;
        const elements = this.rowRenderer.getAllCellsForColumn(column);
        if (!skipHeader) elements.push(eHeaderCell);
        return this.addElementsToContainerAndGetWidth(elements);
    }
    getPreferredWidthForColumnGroup(columnGroup) {
        const eHeaderCell = this.getHeaderCellForColumn(columnGroup);
        if (!eHeaderCell) return -1;
        return this.addElementsToContainerAndGetWidth([
            eHeaderCell
        ]);
    }
    addElementsToContainerAndGetWidth(elements) {
        const eDummyContainer = document.createElement("form");
        eDummyContainer.style.position = "fixed";
        const eBodyContainer = this.centerRowContainerCtrl.getContainerElement();
        elements.forEach((el)=>this.cloneItemIntoDummy(el, eDummyContainer));
        eBodyContainer.appendChild(eDummyContainer);
        const dummyContainerWidth = eDummyContainer.offsetWidth;
        eBodyContainer.removeChild(eDummyContainer);
        const autoSizePadding = this.getAutoSizePadding();
        return dummyContainerWidth + autoSizePadding;
    }
    getAutoSizePadding() {
        return this.gos.get("autoSizePadding");
    }
    getHeaderCellForColumn(column) {
        let element = null;
        this.ctrlsService.getHeaderRowContainerCtrls().forEach((container)=>{
            const res = container.getHtmlElementForColumnHeader(column);
            if (res != null) element = res;
        });
        return element;
    }
    cloneItemIntoDummy(eCell, eDummyContainer) {
        const eCellClone = eCell.cloneNode(true);
        eCellClone.style.width = "";
        eCellClone.style.position = "static";
        eCellClone.style.left = "";
        const eCloneParent = document.createElement("div");
        const eCloneParentClassList = eCloneParent.classList;
        const isHeader = [
            "ag-header-cell",
            "ag-header-group-cell"
        ].some((cls)=>eCellClone.classList.contains(cls));
        if (isHeader) {
            eCloneParentClassList.add("ag-header", "ag-header-row");
            eCloneParent.style.position = "static";
        } else eCloneParentClassList.add("ag-row");
        let pointer = eCell.parentElement;
        while(pointer){
            const isRow = [
                "ag-header-row",
                "ag-row"
            ].some((cls)=>pointer.classList.contains(cls));
            if (isRow) {
                for(let i = 0; i < pointer.classList.length; i++){
                    const item = pointer.classList[i];
                    if (item != "ag-row-position-absolute") eCloneParentClassList.add(item);
                }
                break;
            }
            pointer = pointer.parentElement;
        }
        eCloneParent.appendChild(eCellClone);
        eDummyContainer.appendChild(eCloneParent);
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowRenderer")
], $437b23f6a393c3bf$export$cc129c761c9af6b5.prototype, "rowRenderer", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("ctrlsService")
], $437b23f6a393c3bf$export$cc129c761c9af6b5.prototype, "ctrlsService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowCssClassCalculator")
], $437b23f6a393c3bf$export$cc129c761c9af6b5.prototype, "rowCssClassCalculator", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$export$cc129c761c9af6b5.prototype, "postConstruct", 1);
$437b23f6a393c3bf$export$cc129c761c9af6b5 = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("autoWidthCalculator")
], $437b23f6a393c3bf$export$cc129c761c9af6b5);
// community-modules/core/src/rendering/features/stickyRowFeature.ts
var $437b23f6a393c3bf$var$StickyRowFeature = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(createRowCon, destroyRowCtrls){
        super();
        this.createRowCon = createRowCon;
        this.destroyRowCtrls = destroyRowCtrls;
        this.stickyTopRowCtrls = [];
        this.stickyBottomRowCtrls = [];
        this.topContainerHeight = 0;
        this.bottomContainerHeight = 0;
    }
    postConstruct() {
        this.isClientSide = this.rowModel.getType() === "clientSide";
        this.ctrlsService.whenReady((params)=>{
            this.gridBodyCtrl = params.gridBodyCtrl;
        });
    }
    getStickyTopRowCtrls() {
        return this.stickyTopRowCtrls;
    }
    getStickyBottomRowCtrls() {
        return this.stickyBottomRowCtrls;
    }
    /**
   * Get the last pixel of the group, this pixel is used to push the sticky node up out of the viewport.
   */ getLastPixelOfGroup(row) {
        return this.isClientSide ? this.getClientSideLastPixelOfGroup(row) : this.getServerSideLastPixelOfGroup(row);
    }
    /**
   * Get the first pixel of the group, this pixel is used to push the sticky node down out of the viewport
   */ getFirstPixelOfGroup(row) {
        if (row.footer) return row.sibling.rowTop + row.sibling.rowHeight - 1;
        if (row.hasChildren()) return row.rowTop - 1;
        return 0;
    }
    getServerSideLastPixelOfGroup(row) {
        var _a, _b, _c, _d;
        if (this.isClientSide) throw new Error("This func should only be called in server side row model.");
        if (row.isExpandable() || row.footer) {
            if (row.master) return row.detailNode.rowTop + row.detailNode.rowHeight;
            const noOrContiguousSiblings = !row.sibling || Math.abs(row.sibling.rowIndex - row.rowIndex) === 1;
            if (noOrContiguousSiblings) {
                let storeBounds = (_a = row.childStore) == null ? void 0 : _a.getStoreBounds();
                if (row.footer) storeBounds = (_b = row.sibling.childStore) == null ? void 0 : _b.getStoreBounds();
                return ((_c = storeBounds == null ? void 0 : storeBounds.heightPx) != null ? _c : 0) + ((_d = storeBounds == null ? void 0 : storeBounds.topPx) != null ? _d : 0);
            }
            if (row.footer) return row.rowTop + row.rowHeight;
            return row.sibling.rowTop + row.sibling.rowHeight;
        }
        return Number.MAX_SAFE_INTEGER;
    }
    getClientSideLastPixelOfGroup(row) {
        if (!this.isClientSide) throw new Error("This func should only be called in client side row model.");
        if (row.isExpandable() || row.footer) {
            const grandTotalAtTop = row.footer && row.rowIndex === 0;
            const noOrContiguousSiblings = !row.sibling || Math.abs(row.sibling.rowIndex - row.rowIndex) === 1;
            if (grandTotalAtTop || noOrContiguousSiblings) {
                let lastAncestor = row.footer ? row.sibling : row;
                while(lastAncestor.isExpandable() && lastAncestor.expanded){
                    if (lastAncestor.master) lastAncestor = lastAncestor.detailNode;
                    else if (lastAncestor.childrenAfterSort) {
                        if (lastAncestor.childrenAfterSort.length === 0) break;
                        lastAncestor = $437b23f6a393c3bf$var$last(lastAncestor.childrenAfterSort);
                    }
                }
                return lastAncestor.rowTop + lastAncestor.rowHeight;
            }
            if (row.footer) return row.rowTop + row.rowHeight;
            return row.sibling.rowTop + row.sibling.rowHeight;
        }
        return Number.MAX_SAFE_INTEGER;
    }
    updateStickyRows(container) {
        const isTop = container === "top";
        let newStickyContainerHeight = 0;
        if (!this.canRowsBeSticky()) return this.refreshNodesAndContainerHeight(container, /* @__PURE__ */ new Set(), newStickyContainerHeight);
        const pixelAtContainerBoundary = isTop ? this.rowRenderer.getFirstVisibleVerticalPixel() : this.rowRenderer.getLastVisibleVerticalPixel();
        const newStickyRows = /* @__PURE__ */ new Set();
        const addStickyRow = (stickyRow)=>{
            newStickyRows.add(stickyRow);
            if (isTop) {
                const lastChildBottom = this.getLastPixelOfGroup(stickyRow);
                const stickRowBottom = pixelAtContainerBoundary + newStickyContainerHeight + stickyRow.rowHeight;
                if (lastChildBottom < stickRowBottom) stickyRow.stickyRowTop = newStickyContainerHeight + (lastChildBottom - stickRowBottom);
                else stickyRow.stickyRowTop = newStickyContainerHeight;
            } else {
                const lastChildBottom = this.getFirstPixelOfGroup(stickyRow);
                const stickRowTop = pixelAtContainerBoundary - (newStickyContainerHeight + stickyRow.rowHeight);
                if (lastChildBottom > stickRowTop) stickyRow.stickyRowTop = newStickyContainerHeight - (lastChildBottom - stickRowTop);
                else stickyRow.stickyRowTop = newStickyContainerHeight;
            }
            newStickyContainerHeight = 0;
            newStickyRows.forEach((rowNode)=>{
                const thisRowLastPx = rowNode.stickyRowTop + rowNode.rowHeight;
                if (newStickyContainerHeight < thisRowLastPx) newStickyContainerHeight = thisRowLastPx;
            });
        };
        const suppressFootersSticky = this.areFooterRowsStickySuppressed();
        const suppressGroupsSticky = this.gos.get("suppressGroupRowsSticky");
        const isRowSticky = (row)=>{
            if (!row.displayed) return false;
            if (row.footer) {
                if (suppressFootersSticky === true) return false;
                if (suppressFootersSticky === "grand" && row.level === -1) return false;
                if (suppressFootersSticky === "group" && row.level > -1) return false;
                const alreadySticking = newStickyRows.has(row);
                return !alreadySticking;
            }
            if (row.isExpandable()) {
                if (suppressGroupsSticky === true) return false;
                const alreadySticking = newStickyRows.has(row);
                return !alreadySticking && row.expanded;
            }
            return false;
        };
        for(let i = 0; i < 100; i++){
            let firstPixelAfterStickyRows = pixelAtContainerBoundary + newStickyContainerHeight;
            if (!isTop) firstPixelAfterStickyRows = pixelAtContainerBoundary - newStickyContainerHeight;
            const firstIndex = this.rowModel.getRowIndexAtPixel(firstPixelAfterStickyRows);
            const firstRow = this.rowModel.getRow(firstIndex);
            if (firstRow == null) break;
            const ancestors = this.getStickyAncestors(firstRow);
            const firstMissingParent = ancestors.find((parent)=>(isTop ? parent.rowIndex < firstIndex : parent.rowIndex > firstIndex) && isRowSticky(parent));
            if (firstMissingParent) {
                addStickyRow(firstMissingParent);
                continue;
            }
            const isFirstRowOutsideViewport = isTop ? firstRow.rowTop < firstPixelAfterStickyRows : firstRow.rowTop + firstRow.rowHeight > firstPixelAfterStickyRows;
            if (isFirstRowOutsideViewport && isRowSticky(firstRow)) {
                addStickyRow(firstRow);
                continue;
            }
            break;
        }
        if (!isTop) newStickyRows.forEach((rowNode)=>{
            rowNode.stickyRowTop = newStickyContainerHeight - (rowNode.stickyRowTop + rowNode.rowHeight);
        });
        return this.refreshNodesAndContainerHeight(container, newStickyRows, newStickyContainerHeight);
    }
    areFooterRowsStickySuppressed() {
        const suppressFootersSticky = this.gos.get("suppressStickyTotalRow");
        if (suppressFootersSticky === true) return true;
        const suppressGroupRows = !!this.gos.get("groupIncludeFooter") || suppressFootersSticky === "group";
        const suppressGrandRows = !!this.gos.get("groupIncludeTotalFooter") || suppressFootersSticky === "grand";
        if (suppressGroupRows && suppressGrandRows) return true;
        if (suppressGrandRows) return "grand";
        if (suppressGroupRows) return "group";
        return false;
    }
    canRowsBeSticky() {
        const isStickyEnabled = this.gos.isGroupRowsSticky();
        const suppressFootersSticky = this.areFooterRowsStickySuppressed();
        const suppressGroupsSticky = this.gos.get("suppressGroupRowsSticky");
        return isStickyEnabled && (!suppressFootersSticky || !suppressGroupsSticky);
    }
    getStickyAncestors(rowNode) {
        const ancestors = [];
        let p = rowNode.footer ? rowNode.sibling : rowNode.parent;
        while(p){
            if (p.sibling) ancestors.push(p.sibling);
            ancestors.push(p);
            p = p.parent;
        }
        return ancestors.reverse();
    }
    checkStickyRows() {
        const hasTopUpdated = this.updateStickyRows("top");
        const hasBottomUpdated = this.updateStickyRows("bottom");
        return hasTopUpdated || hasBottomUpdated;
    }
    destroyStickyCtrls() {
        this.refreshNodesAndContainerHeight("top", /* @__PURE__ */ new Set(), 0);
        this.refreshNodesAndContainerHeight("bottom", /* @__PURE__ */ new Set(), 0);
    }
    refreshStickyNode(stickRowNode) {
        const allStickyNodes = /* @__PURE__ */ new Set();
        if (this.stickyTopRowCtrls.some((ctrl)=>ctrl.getRowNode() === stickRowNode)) {
            for(let i = 0; i < this.stickyTopRowCtrls.length; i++){
                const currentNode = this.stickyTopRowCtrls[i].getRowNode();
                if (currentNode !== stickRowNode) allStickyNodes.add(currentNode);
            }
            if (this.refreshNodesAndContainerHeight("top", allStickyNodes, this.topContainerHeight)) this.checkStickyRows();
            return;
        }
        for(let i = 0; i < this.stickyBottomRowCtrls.length; i++){
            const currentNode = this.stickyBottomRowCtrls[i].getRowNode();
            if (currentNode !== stickRowNode) allStickyNodes.add(currentNode);
        }
        if (this.refreshNodesAndContainerHeight("bottom", allStickyNodes, this.bottomContainerHeight)) this.checkStickyRows();
    }
    /**
   * Destroy old ctrls and create new ctrls where necessary.
   */ refreshNodesAndContainerHeight(container, newStickyNodes, height) {
        const isTop = container === "top";
        const previousCtrls = isTop ? this.stickyTopRowCtrls : this.stickyBottomRowCtrls;
        const removedCtrlsMap = {};
        const remainingCtrls = [];
        for(let i = 0; i < previousCtrls.length; i++){
            const node = previousCtrls[i].getRowNode();
            const hasBeenRemoved = !newStickyNodes.has(node);
            if (hasBeenRemoved) {
                removedCtrlsMap[node.id] = previousCtrls[i];
                node.sticky = false;
                continue;
            }
            remainingCtrls.push(previousCtrls[i]);
        }
        const existingNodes = /* @__PURE__ */ new Set();
        for(let i = 0; i < remainingCtrls.length; i++)existingNodes.add(remainingCtrls[i].getRowNode());
        const newCtrls = [];
        newStickyNodes.forEach((node)=>{
            if (existingNodes.has(node)) return;
            node.sticky = true;
            newCtrls.push(this.createRowCon(node, false, false));
        });
        let hasSomethingChanged = !!newCtrls.length || remainingCtrls.length !== previousCtrls.length;
        if (isTop) {
            if (this.topContainerHeight !== height) {
                this.topContainerHeight = height;
                this.gridBodyCtrl.setStickyTopHeight(height);
                hasSomethingChanged = true;
            }
        } else if (this.bottomContainerHeight !== height) {
            this.bottomContainerHeight = height;
            this.gridBodyCtrl.setStickyBottomHeight(height);
            hasSomethingChanged = true;
        }
        this.destroyRowCtrls(removedCtrlsMap, false);
        const newCtrlsList = [
            ...remainingCtrls,
            ...newCtrls
        ];
        newCtrlsList.sort((a, b)=>b.getRowNode().rowIndex - a.getRowNode().rowIndex);
        if (!isTop) newCtrlsList.reverse();
        newCtrlsList.forEach((ctrl)=>ctrl.setRowTop(ctrl.getRowNode().stickyRowTop));
        if (!hasSomethingChanged) return false;
        if (isTop) this.stickyTopRowCtrls = newCtrlsList;
        else this.stickyBottomRowCtrls = newCtrlsList;
        return true;
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowModel")
], $437b23f6a393c3bf$var$StickyRowFeature.prototype, "rowModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowRenderer")
], $437b23f6a393c3bf$var$StickyRowFeature.prototype, "rowRenderer", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("ctrlsService")
], $437b23f6a393c3bf$var$StickyRowFeature.prototype, "ctrlsService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$StickyRowFeature.prototype, "postConstruct", 1);
// community-modules/core/src/rendering/rowRenderer.ts
var $437b23f6a393c3bf$export$a41edaea3b7c09c8 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.destroyFuncsForColumnListeners = [];
        // map of row ids to row objects. keeps track of which elements
        // are rendered for which rows in the dom.
        this.rowCtrlsByRowIndex = {};
        this.zombieRowCtrls = {};
        this.allRowCtrls = [];
        this.topRowCtrls = [];
        this.bottomRowCtrls = [];
        // we only allow one refresh at a time, otherwise the internal memory structure here
        // will get messed up. this can happen if the user has a cellRenderer, and inside the
        // renderer they call an API method that results in another pass of the refresh,
        // then it will be trying to draw rows in the middle of a refresh.
        this.refreshInProgress = false;
        this.dataFirstRenderedFired = false;
        this.setupRangeSelectionListeners = ()=>{
            const onRangeSelectionChanged = ()=>{
                this.getAllCellCtrls().forEach((cellCtrl)=>cellCtrl.onRangeSelectionChanged());
            };
            const onColumnMovedPinnedVisible = ()=>{
                this.getAllCellCtrls().forEach((cellCtrl)=>cellCtrl.updateRangeBordersIfRangeCount());
            };
            const addRangeSelectionListeners = ()=>{
                this.eventService.addEventListener($437b23f6a393c3bf$export$ada873a34909da65.EVENT_RANGE_SELECTION_CHANGED, onRangeSelectionChanged);
                this.eventService.addEventListener($437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_MOVED, onColumnMovedPinnedVisible);
                this.eventService.addEventListener($437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_PINNED, onColumnMovedPinnedVisible);
                this.eventService.addEventListener($437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_VISIBLE, onColumnMovedPinnedVisible);
            };
            const removeRangeSelectionListeners = ()=>{
                this.eventService.removeEventListener($437b23f6a393c3bf$export$ada873a34909da65.EVENT_RANGE_SELECTION_CHANGED, onRangeSelectionChanged);
                this.eventService.removeEventListener($437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_MOVED, onColumnMovedPinnedVisible);
                this.eventService.removeEventListener($437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_PINNED, onColumnMovedPinnedVisible);
                this.eventService.removeEventListener($437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_VISIBLE, onColumnMovedPinnedVisible);
            };
            this.addDestroyFunc(()=>removeRangeSelectionListeners());
            this.addManagedPropertyListener("enableRangeSelection", (params)=>{
                const isEnabled = params.currentValue;
                if (isEnabled) addRangeSelectionListeners();
                else removeRangeSelectionListeners();
            });
            const rangeSelectionEnabled = this.gos.get("enableRangeSelection");
            if (rangeSelectionEnabled) addRangeSelectionListeners();
        };
    }
    postConstruct() {
        this.ctrlsService.whenReady((p)=>{
            this.gridBodyCtrl = p.gridBodyCtrl;
            this.initialise();
        });
    }
    initialise() {
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_PAGINATION_CHANGED, this.onPageLoaded.bind(this));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_PINNED_ROW_DATA_CHANGED, this.onPinnedRowDataChanged.bind(this));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_DISPLAYED_COLUMNS_CHANGED, this.onDisplayedColumnsChanged.bind(this));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_BODY_SCROLL, this.onBodyScroll.bind(this));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_BODY_HEIGHT_CHANGED, this.redraw.bind(this));
        this.addManagedPropertyListeners([
            "domLayout",
            "embedFullWidthRows"
        ], ()=>this.onDomLayoutChanged());
        this.addManagedPropertyListeners([
            "suppressMaxRenderedRowRestriction",
            "rowBuffer"
        ], ()=>this.redraw());
        this.addManagedPropertyListeners([
            "suppressCellFocus",
            "getBusinessKeyForNode",
            "fullWidthCellRenderer",
            "fullWidthCellRendererParams",
            "rowStyle",
            "getRowStyle",
            "rowClass",
            "getRowClass",
            "rowClassRules",
            "suppressStickyTotalRow",
            "groupRowRenderer",
            "groupRowRendererParams",
            // maybe only needs to refresh FW rows...
            "loadingCellRenderer",
            "loadingCellRendererParams",
            "detailCellRenderer",
            "detailCellRendererParams",
            "enableRangeSelection",
            "enableCellTextSelection"
        ], ()=>this.redrawRows());
        if (this.gos.isGroupRowsSticky()) {
            const rowModelType = this.rowModel.getType();
            if (rowModelType === "clientSide" || rowModelType === "serverSide") this.stickyRowFeature = this.createManagedBean(new $437b23f6a393c3bf$var$StickyRowFeature(this.createRowCon.bind(this), this.destroyRowCtrls.bind(this)));
        }
        this.registerCellEventListeners();
        this.initialiseCache();
        this.printLayout = this.gos.isDomLayout("print");
        this.embedFullWidthRows = this.printLayout || this.gos.get("embedFullWidthRows");
        this.redrawAfterModelUpdate();
    }
    initialiseCache() {
        if (this.gos.get("keepDetailRows")) {
            const countProp = this.getKeepDetailRowsCount();
            const count = countProp != null ? countProp : 3;
            this.cachedRowCtrls = new $437b23f6a393c3bf$var$RowCtrlCache(count);
        }
    }
    getKeepDetailRowsCount() {
        return this.gos.get("keepDetailRowsCount");
    }
    getStickyTopRowCtrls() {
        if (!this.stickyRowFeature) return [];
        return this.stickyRowFeature.getStickyTopRowCtrls();
    }
    getStickyBottomRowCtrls() {
        if (!this.stickyRowFeature) return [];
        return this.stickyRowFeature.getStickyBottomRowCtrls();
    }
    updateAllRowCtrls() {
        const liveList = $437b23f6a393c3bf$var$getAllValuesInObject(this.rowCtrlsByRowIndex);
        const zombieList = $437b23f6a393c3bf$var$getAllValuesInObject(this.zombieRowCtrls);
        const cachedList = this.cachedRowCtrls ? this.cachedRowCtrls.getEntries() : [];
        if (zombieList.length > 0 || cachedList.length > 0) this.allRowCtrls = [
            ...liveList,
            ...zombieList,
            ...cachedList
        ];
        else this.allRowCtrls = liveList;
    }
    onCellFocusChanged(event) {
        this.getAllCellCtrls().forEach((cellCtrl)=>cellCtrl.onCellFocused(event));
        this.getFullWidthRowCtrls().forEach((rowCtrl)=>rowCtrl.onFullWidthRowFocused(event));
    }
    // in a clean design, each cell would register for each of these events. however when scrolling, all the cells
    // registering and de-registering for events is a performance bottleneck. so we register here once and inform
    // all active cells.
    registerCellEventListeners() {
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_CELL_FOCUSED, (event)=>{
            this.onCellFocusChanged(event);
        });
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_CELL_FOCUS_CLEARED, ()=>{
            this.onCellFocusChanged();
        });
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_FLASH_CELLS, (event)=>{
            this.getAllCellCtrls().forEach((cellCtrl)=>cellCtrl.onFlashCells(event));
        });
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_HOVER_CHANGED, ()=>{
            this.getAllCellCtrls().forEach((cellCtrl)=>cellCtrl.onColumnHover());
        });
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_DISPLAYED_COLUMNS_CHANGED, ()=>{
            this.getAllCellCtrls().forEach((cellCtrl)=>cellCtrl.onDisplayedColumnsChanged());
        });
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, ()=>{
            if (this.printLayout) this.getAllCellCtrls().forEach((cellCtrl)=>cellCtrl.onLeftChanged());
        });
        this.setupRangeSelectionListeners();
        this.refreshListenersToColumnsForCellComps();
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_GRID_COLUMNS_CHANGED, this.refreshListenersToColumnsForCellComps.bind(this));
        this.addDestroyFunc(this.removeGridColumnListeners.bind(this));
    }
    // executes all functions in destroyFuncsForColumnListeners and then clears the list
    removeGridColumnListeners() {
        this.destroyFuncsForColumnListeners.forEach((func)=>func());
        this.destroyFuncsForColumnListeners.length = 0;
    }
    // this function adds listeners onto all the grid columns, which are the column that we could have cellComps for.
    // when the grid columns change, we add listeners again. in an ideal design, each CellComp would just register to
    // the column it belongs to on creation, however this was a bottleneck with the number of cells, so do it here
    // once instead.
    refreshListenersToColumnsForCellComps() {
        this.removeGridColumnListeners();
        const cols = this.columnModel.getAllGridColumns();
        cols.forEach((col)=>{
            const forEachCellWithThisCol = (callback)=>{
                this.getAllCellCtrls().forEach((cellCtrl)=>{
                    if (cellCtrl.getColumn() === col) callback(cellCtrl);
                });
            };
            const leftChangedListener = ()=>{
                forEachCellWithThisCol((cellCtrl)=>cellCtrl.onLeftChanged());
            };
            const widthChangedListener = ()=>{
                forEachCellWithThisCol((cellCtrl)=>cellCtrl.onWidthChanged());
            };
            const firstRightPinnedChangedListener = ()=>{
                forEachCellWithThisCol((cellCtrl)=>cellCtrl.onFirstRightPinnedChanged());
            };
            const lastLeftPinnedChangedListener = ()=>{
                forEachCellWithThisCol((cellCtrl)=>cellCtrl.onLastLeftPinnedChanged());
            };
            const colDefChangedListener = ()=>{
                forEachCellWithThisCol((cellCtrl)=>cellCtrl.onColDefChanged());
            };
            col.addEventListener("leftChanged", leftChangedListener);
            col.addEventListener("widthChanged", widthChangedListener);
            col.addEventListener("firstRightPinnedChanged", firstRightPinnedChangedListener);
            col.addEventListener("lastLeftPinnedChanged", lastLeftPinnedChangedListener);
            col.addEventListener("colDefChanged", colDefChangedListener);
            this.destroyFuncsForColumnListeners.push(()=>{
                col.removeEventListener("leftChanged", leftChangedListener);
                col.removeEventListener("widthChanged", widthChangedListener);
                col.removeEventListener("firstRightPinnedChanged", firstRightPinnedChangedListener);
                col.removeEventListener("lastLeftPinnedChanged", lastLeftPinnedChangedListener);
                col.removeEventListener("colDefChanged", colDefChangedListener);
            });
        });
    }
    onDomLayoutChanged() {
        const printLayout = this.gos.isDomLayout("print");
        const embedFullWidthRows = printLayout || this.gos.get("embedFullWidthRows");
        const destroyRows = embedFullWidthRows !== this.embedFullWidthRows || this.printLayout !== printLayout;
        this.printLayout = printLayout;
        this.embedFullWidthRows = embedFullWidthRows;
        if (destroyRows) this.redrawAfterModelUpdate({
            domLayoutChanged: true
        });
    }
    // for row models that have datasources, when we update the datasource, we need to force the rowRenderer
    // to redraw all rows. otherwise the old rows from the old datasource will stay displayed.
    datasourceChanged() {
        this.firstRenderedRow = 0;
        this.lastRenderedRow = -1;
        const rowIndexesToRemove = Object.keys(this.rowCtrlsByRowIndex);
        this.removeRowCtrls(rowIndexesToRemove);
    }
    onPageLoaded(event) {
        const params = {
            recycleRows: event.keepRenderedRows,
            animate: event.animate,
            newData: event.newData,
            newPage: event.newPage,
            // because this is a model updated event (not pinned rows), we
            // can skip updating the pinned rows. this is needed so that if user
            // is doing transaction updates, the pinned rows are not getting constantly
            // trashed - or editing cells in pinned rows are not refreshed and put into read mode
            onlyBody: true
        };
        this.redrawAfterModelUpdate(params);
    }
    getAllCellsForColumn(column) {
        const res = [];
        this.getAllRowCtrls().forEach((rowCtrl)=>{
            const eCell = rowCtrl.getCellElement(column);
            if (eCell) res.push(eCell);
        });
        return res;
    }
    refreshFloatingRowComps() {
        this.refreshFloatingRows(this.topRowCtrls, this.pinnedRowModel.getPinnedTopRowData());
        this.refreshFloatingRows(this.bottomRowCtrls, this.pinnedRowModel.getPinnedBottomRowData());
    }
    getTopRowCtrls() {
        return this.topRowCtrls;
    }
    getCentreRowCtrls() {
        return this.allRowCtrls;
    }
    getBottomRowCtrls() {
        return this.bottomRowCtrls;
    }
    refreshFloatingRows(rowComps, rowNodes) {
        rowComps.forEach((row)=>{
            row.destroyFirstPass();
            row.destroySecondPass();
        });
        rowComps.length = 0;
        if (!rowNodes) return;
        rowNodes.forEach((rowNode)=>{
            const rowCtrl = new $437b23f6a393c3bf$export$e449e57ac30326ed(rowNode, this.beans, false, false, this.printLayout);
            rowComps.push(rowCtrl);
        });
    }
    onPinnedRowDataChanged() {
        const params = {
            recycleRows: true
        };
        this.redrawAfterModelUpdate(params);
    }
    redrawRow(rowNode, suppressEvent = false) {
        var _a;
        if (rowNode.sticky) this.stickyRowFeature.refreshStickyNode(rowNode);
        else if ((_a = this.cachedRowCtrls) == null ? void 0 : _a.has(rowNode)) {
            this.cachedRowCtrls.removeRow(rowNode);
            return;
        } else {
            const destroyAndRecreateCtrl = (dataStruct)=>{
                const ctrl = dataStruct[rowNode.rowIndex];
                if (!ctrl) return;
                if (ctrl.getRowNode() !== rowNode) return;
                ctrl.destroyFirstPass();
                ctrl.destroySecondPass();
                dataStruct[rowNode.rowIndex] = this.createRowCon(rowNode, false, false);
            };
            switch(rowNode.rowPinned){
                case "top":
                    destroyAndRecreateCtrl(this.topRowCtrls);
                    break;
                case "bottom":
                    destroyAndRecreateCtrl(this.bottomRowCtrls);
                    break;
                default:
                    destroyAndRecreateCtrl(this.rowCtrlsByRowIndex);
                    this.updateAllRowCtrls();
            }
        }
        if (!suppressEvent) this.dispatchDisplayedRowsChanged(false);
    }
    redrawRows(rowNodes) {
        const partialRefresh = rowNodes != null;
        if (partialRefresh) {
            rowNodes == null || rowNodes.forEach((node)=>this.redrawRow(node, true));
            this.dispatchDisplayedRowsChanged(false);
            return;
        }
        this.redrawAfterModelUpdate();
    }
    getCellToRestoreFocusToAfterRefresh(params) {
        const focusedCell = (params == null ? void 0 : params.suppressKeepFocus) ? null : this.focusService.getFocusCellToUseAfterRefresh();
        if (focusedCell == null) return null;
        const activeElement = this.gos.getActiveDomElement();
        const cellDomData = this.gos.getDomData(activeElement, $437b23f6a393c3bf$export$4fd76abbfd48a7b6.DOM_DATA_KEY_CELL_CTRL);
        const rowDomData = this.gos.getDomData(activeElement, $437b23f6a393c3bf$export$e449e57ac30326ed.DOM_DATA_KEY_ROW_CTRL);
        const gridElementFocused = cellDomData || rowDomData;
        return gridElementFocused ? focusedCell : null;
    }
    // gets called from:
    // +) initialisation (in registerGridComp) params = null
    // +) onDomLayoutChanged, params = null
    // +) onPageLoaded, recycleRows, animate, newData, newPage from event, onlyBody=true
    // +) onPinnedRowDataChanged, recycleRows = true
    // +) redrawRows (from Grid API), recycleRows = true/false
    redrawAfterModelUpdate(params = {}) {
        this.getLockOnRefresh();
        const focusedCell = this.getCellToRestoreFocusToAfterRefresh(params);
        this.updateContainerHeights();
        this.scrollToTopIfNewData(params);
        const recycleRows = !params.domLayoutChanged && !!params.recycleRows;
        const animate = params.animate && this.gos.isAnimateRows();
        const rowsToRecycle = recycleRows ? this.getRowsToRecycle() : null;
        if (!recycleRows) this.removeAllRowComps();
        this.workOutFirstAndLastRowsToRender();
        if (this.stickyRowFeature) this.stickyRowFeature.checkStickyRows();
        this.recycleRows(rowsToRecycle, animate);
        this.gridBodyCtrl.updateRowCount();
        if (!params.onlyBody) this.refreshFloatingRowComps();
        this.dispatchDisplayedRowsChanged();
        if (focusedCell != null) this.restoreFocusedCell(focusedCell);
        this.releaseLockOnRefresh();
    }
    scrollToTopIfNewData(params) {
        const scrollToTop = params.newData || params.newPage;
        const suppressScrollToTop = this.gos.get("suppressScrollOnNewData");
        if (scrollToTop && !suppressScrollToTop) this.gridBodyCtrl.getScrollFeature().scrollToTop();
    }
    updateContainerHeights() {
        if (this.printLayout) {
            this.rowContainerHeightService.setModelHeight(null);
            return;
        }
        let containerHeight = this.paginationProxy.getCurrentPageHeight();
        if (containerHeight === 0) containerHeight = 1;
        this.rowContainerHeightService.setModelHeight(containerHeight);
    }
    getLockOnRefresh() {
        if (this.refreshInProgress) throw new Error("AG Grid: cannot get grid to draw rows when it is in the middle of drawing rows. Your code probably called a grid API method while the grid was in the render stage. To overcome this, put the API call into a timeout, e.g. instead of api.redrawRows(), call setTimeout(function() { api.redrawRows(); }, 0). To see what part of your code that caused the refresh check this stacktrace.");
        this.refreshInProgress = true;
    }
    releaseLockOnRefresh() {
        this.refreshInProgress = false;
    }
    isRefreshInProgress() {
        return this.refreshInProgress;
    }
    // sets the focus to the provided cell, if the cell is provided. this way, the user can call refresh without
    // worry about the focus been lost. this is important when the user is using keyboard navigation to do edits
    // and the cellEditor is calling 'refresh' to get other cells to update (as other cells might depend on the
    // edited cell).
    restoreFocusedCell(cellPosition) {
        if (cellPosition) {
            this.focusService.setRestoreFocusedCell(cellPosition);
            this.onCellFocusChanged(this.beans.gos.addGridCommonParams({
                rowIndex: cellPosition.rowIndex,
                column: cellPosition.column,
                rowPinned: cellPosition.rowPinned,
                forceBrowserFocus: true,
                preventScrollOnBrowserFocus: true,
                type: "mock"
            }));
        }
    }
    stopEditing(cancel = false) {
        this.getAllRowCtrls().forEach((rowCtrl)=>{
            rowCtrl.stopEditing(cancel);
        });
    }
    getAllCellCtrls() {
        const res = [];
        const rowCtrls = this.getAllRowCtrls();
        const rowCtrlsLength = rowCtrls.length;
        for(let i = 0; i < rowCtrlsLength; i++){
            const cellCtrls = rowCtrls[i].getAllCellCtrls();
            const cellCtrlsLength = cellCtrls.length;
            for(let j = 0; j < cellCtrlsLength; j++)res.push(cellCtrls[j]);
        }
        return res;
    }
    getAllRowCtrls() {
        const stickyTopRowCtrls = this.stickyRowFeature && this.stickyRowFeature.getStickyTopRowCtrls() || [];
        const stickyBottomRowCtrls = this.stickyRowFeature && this.stickyRowFeature.getStickyBottomRowCtrls() || [];
        const res = [
            ...this.topRowCtrls,
            ...this.bottomRowCtrls,
            ...stickyTopRowCtrls,
            ...stickyBottomRowCtrls
        ];
        for(const key in this.rowCtrlsByRowIndex)res.push(this.rowCtrlsByRowIndex[key]);
        return res;
    }
    addRenderedRowListener(eventName, rowIndex, callback) {
        const rowComp = this.rowCtrlsByRowIndex[rowIndex];
        if (rowComp) rowComp.addEventListener(eventName, callback);
    }
    flashCells(params = {}) {
        this.getCellCtrls(params.rowNodes, params.columns).forEach((cellCtrl)=>cellCtrl.flashCell(params));
    }
    refreshCells(params = {}) {
        const refreshCellParams = {
            forceRefresh: params.force,
            newData: false,
            suppressFlash: params.suppressFlash
        };
        this.getCellCtrls(params.rowNodes, params.columns).forEach((cellCtrl)=>cellCtrl.refreshOrDestroyCell(refreshCellParams));
        if (params.rowNodes) {
            this.getRowCtrls(params.rowNodes).forEach((rowCtrl)=>{
                if (!rowCtrl.isFullWidth()) return;
                const refreshed = rowCtrl.refreshFullWidth();
                if (!refreshed) this.redrawRow(rowCtrl.getRowNode(), true);
            });
            this.dispatchDisplayedRowsChanged(false);
        }
    }
    getCellRendererInstances(params) {
        var _a;
        const cellRenderers = this.getCellCtrls(params.rowNodes, params.columns).map((cellCtrl)=>cellCtrl.getCellRenderer()).filter((renderer)=>renderer != null);
        if ((_a = params.columns) == null ? void 0 : _a.length) return cellRenderers;
        const fullWidthRenderers = [];
        const rowIdMap = this.mapRowNodes(params.rowNodes);
        this.getAllRowCtrls().forEach((rowCtrl)=>{
            if (rowIdMap && !this.isRowInMap(rowCtrl.getRowNode(), rowIdMap)) return;
            if (!rowCtrl.isFullWidth()) return;
            const renderers = rowCtrl.getFullWidthCellRenderers();
            for(let i = 0; i < renderers.length; i++){
                const renderer = renderers[i];
                if (renderer != null) fullWidthRenderers.push(renderer);
            }
        });
        return [
            ...fullWidthRenderers,
            ...cellRenderers
        ];
    }
    getCellEditorInstances(params) {
        const res = [];
        this.getCellCtrls(params.rowNodes, params.columns).forEach((cellCtrl)=>{
            const cellEditor = cellCtrl.getCellEditor();
            if (cellEditor) res.push(cellEditor);
        });
        return res;
    }
    getEditingCells() {
        const res = [];
        this.getAllCellCtrls().forEach((cellCtrl)=>{
            if (cellCtrl.isEditing()) {
                const cellPosition = cellCtrl.getCellPosition();
                res.push(cellPosition);
            }
        });
        return res;
    }
    mapRowNodes(rowNodes) {
        if (!rowNodes) return;
        const res = {
            top: {},
            bottom: {},
            normal: {}
        };
        rowNodes.forEach((rowNode)=>{
            const id = rowNode.id;
            switch(rowNode.rowPinned){
                case "top":
                    res.top[id] = rowNode;
                    break;
                case "bottom":
                    res.bottom[id] = rowNode;
                    break;
                default:
                    res.normal[id] = rowNode;
                    break;
            }
        });
        return res;
    }
    isRowInMap(rowNode, rowIdsMap) {
        const id = rowNode.id;
        const floating = rowNode.rowPinned;
        switch(floating){
            case "top":
                return rowIdsMap.top[id] != null;
            case "bottom":
                return rowIdsMap.bottom[id] != null;
            default:
                return rowIdsMap.normal[id] != null;
        }
    }
    /**
   * @param rowNodes if provided, returns the RowCtrls for the provided rowNodes. otherwise returns all RowCtrls.
   */ getRowCtrls(rowNodes) {
        const rowIdsMap = this.mapRowNodes(rowNodes);
        const allRowCtrls = this.getAllRowCtrls();
        if (!rowNodes || !rowIdsMap) return allRowCtrls;
        return allRowCtrls.filter((rowCtrl)=>{
            const rowNode = rowCtrl.getRowNode();
            return this.isRowInMap(rowNode, rowIdsMap);
        });
    }
    // returns CellCtrl's that match the provided rowNodes and columns. eg if one row node
    // and two columns provided, that identifies 4 cells, so 4 CellCtrl's returned.
    getCellCtrls(rowNodes, columns) {
        let colIdsMap;
        if ($437b23f6a393c3bf$var$exists(columns)) {
            colIdsMap = {};
            columns.forEach((colKey)=>{
                const column = this.columnModel.getGridColumn(colKey);
                if ($437b23f6a393c3bf$var$exists(column)) colIdsMap[column.getId()] = true;
            });
        }
        const res = [];
        this.getRowCtrls(rowNodes).forEach((rowCtrl)=>{
            rowCtrl.getAllCellCtrls().forEach((cellCtrl)=>{
                const colId = cellCtrl.getColumn().getId();
                const excludeColFromRefresh = colIdsMap && !colIdsMap[colId];
                if (excludeColFromRefresh) return;
                res.push(cellCtrl);
            });
        });
        return res;
    }
    destroy() {
        this.removeAllRowComps();
        super.destroy();
    }
    removeAllRowComps() {
        const rowIndexesToRemove = Object.keys(this.rowCtrlsByRowIndex);
        this.removeRowCtrls(rowIndexesToRemove);
        if (this.stickyRowFeature) this.stickyRowFeature.destroyStickyCtrls();
    }
    getRowsToRecycle() {
        const stubNodeIndexes = [];
        $437b23f6a393c3bf$var$iterateObject(this.rowCtrlsByRowIndex, (index, rowCtrl)=>{
            const stubNode = rowCtrl.getRowNode().id == null;
            if (stubNode) stubNodeIndexes.push(index);
        });
        this.removeRowCtrls(stubNodeIndexes);
        const ctrlsByIdMap = {};
        $437b23f6a393c3bf$var$iterateObject(this.rowCtrlsByRowIndex, (index, rowCtrl)=>{
            const rowNode = rowCtrl.getRowNode();
            ctrlsByIdMap[rowNode.id] = rowCtrl;
        });
        this.rowCtrlsByRowIndex = {};
        return ctrlsByIdMap;
    }
    // takes array of row indexes
    removeRowCtrls(rowsToRemove, suppressAnimation = false) {
        rowsToRemove.forEach((indexToRemove)=>{
            const rowCtrl = this.rowCtrlsByRowIndex[indexToRemove];
            if (rowCtrl) {
                rowCtrl.destroyFirstPass(suppressAnimation);
                rowCtrl.destroySecondPass();
            }
            delete this.rowCtrlsByRowIndex[indexToRemove];
        });
    }
    onBodyScroll(e) {
        if (e.direction !== "vertical") return;
        this.redraw({
            afterScroll: true
        });
    }
    // gets called when rows don't change, but viewport does, so after:
    // 1) height of grid body changes, ie number of displayed rows has changed
    // 2) grid scrolled to new position
    // 3) ensure index visible (which is a scroll)
    redraw(params = {}) {
        const { afterScroll: afterScroll } = params;
        let cellFocused;
        if (this.stickyRowFeature && $437b23f6a393c3bf$var$browserSupportsPreventScroll()) cellFocused = this.getCellToRestoreFocusToAfterRefresh() || void 0;
        const oldFirstRow = this.firstRenderedRow;
        const oldLastRow = this.lastRenderedRow;
        this.workOutFirstAndLastRowsToRender();
        let hasStickyRowChanges = false;
        if (this.stickyRowFeature) hasStickyRowChanges = this.stickyRowFeature.checkStickyRows();
        const rangeChanged = this.firstRenderedRow !== oldFirstRow || this.lastRenderedRow !== oldLastRow;
        if (afterScroll && !hasStickyRowChanges && !rangeChanged) return;
        this.getLockOnRefresh();
        this.recycleRows(null, false, afterScroll);
        this.releaseLockOnRefresh();
        this.dispatchDisplayedRowsChanged(afterScroll && !hasStickyRowChanges);
        if (cellFocused != null) {
            const newFocusedCell = this.getCellToRestoreFocusToAfterRefresh();
            if (cellFocused != null && newFocusedCell == null) {
                this.animationFrameService.flushAllFrames();
                this.restoreFocusedCell(cellFocused);
            }
        }
    }
    removeRowCompsNotToDraw(indexesToDraw, suppressAnimation) {
        const indexesToDrawMap = {};
        indexesToDraw.forEach((index)=>indexesToDrawMap[index] = true);
        const existingIndexes = Object.keys(this.rowCtrlsByRowIndex);
        const indexesNotToDraw = existingIndexes.filter((index)=>!indexesToDrawMap[index]);
        this.removeRowCtrls(indexesNotToDraw, suppressAnimation);
    }
    calculateIndexesToDraw(rowsToRecycle) {
        let indexesToDraw = $437b23f6a393c3bf$var$createArrayOfNumbers(this.firstRenderedRow, this.lastRenderedRow);
        const checkRowToDraw = (indexStr, rowComp)=>{
            const index = rowComp.getRowNode().rowIndex;
            if (index == null) return;
            if (index < this.firstRenderedRow || index > this.lastRenderedRow) {
                if (this.doNotUnVirtualiseRow(rowComp)) indexesToDraw.push(index);
            }
        };
        $437b23f6a393c3bf$var$iterateObject(this.rowCtrlsByRowIndex, checkRowToDraw);
        $437b23f6a393c3bf$var$iterateObject(rowsToRecycle, checkRowToDraw);
        indexesToDraw.sort((a, b)=>a - b);
        const ret = [];
        for(let i = 0; i < indexesToDraw.length; i++){
            const currRow = indexesToDraw[i];
            const rowNode = this.paginationProxy.getRow(currRow);
            if (rowNode && !rowNode.sticky) ret.push(currRow);
        }
        return ret;
    }
    recycleRows(rowsToRecycle, animate = false, afterScroll = false) {
        const indexesToDraw = this.calculateIndexesToDraw(rowsToRecycle);
        if (this.printLayout || afterScroll) animate = false;
        this.removeRowCompsNotToDraw(indexesToDraw, !animate);
        const rowCtrls = [];
        indexesToDraw.forEach((rowIndex)=>{
            const rowCtrl = this.createOrUpdateRowCtrl(rowIndex, rowsToRecycle, animate, afterScroll);
            if ($437b23f6a393c3bf$var$exists(rowCtrl)) rowCtrls.push(rowCtrl);
        });
        if (rowsToRecycle) {
            const useAnimationFrame = afterScroll && !this.gos.get("suppressAnimationFrame") && !this.printLayout;
            if (useAnimationFrame) this.beans.animationFrameService.addDestroyTask(()=>{
                this.destroyRowCtrls(rowsToRecycle, animate);
                this.updateAllRowCtrls();
                this.dispatchDisplayedRowsChanged();
            });
            else this.destroyRowCtrls(rowsToRecycle, animate);
        }
        this.updateAllRowCtrls();
    }
    dispatchDisplayedRowsChanged(afterScroll = false) {
        const event = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_DISPLAYED_ROWS_CHANGED,
            afterScroll: afterScroll
        };
        this.eventService.dispatchEvent(event);
    }
    onDisplayedColumnsChanged() {
        const pinningLeft = this.columnModel.isPinningLeft();
        const pinningRight = this.columnModel.isPinningRight();
        const atLeastOneChanged = this.pinningLeft !== pinningLeft || pinningRight !== this.pinningRight;
        if (atLeastOneChanged) {
            this.pinningLeft = pinningLeft;
            this.pinningRight = pinningRight;
            if (this.embedFullWidthRows) this.redrawFullWidthEmbeddedRows();
        }
    }
    // when embedding, what gets showed in each section depends on what is pinned. eg if embedding group expand / collapse,
    // then it should go into the pinned left area if pinning left, or the center area if not pinning.
    redrawFullWidthEmbeddedRows() {
        const rowsToRemove = [];
        this.getFullWidthRowCtrls().forEach((fullWidthCtrl)=>{
            const rowIndex = fullWidthCtrl.getRowNode().rowIndex;
            rowsToRemove.push(rowIndex.toString());
        });
        this.refreshFloatingRowComps();
        this.removeRowCtrls(rowsToRemove);
        this.redraw({
            afterScroll: true
        });
    }
    getFullWidthRowCtrls(rowNodes) {
        const rowNodesMap = this.mapRowNodes(rowNodes);
        return this.getAllRowCtrls().filter((rowCtrl)=>{
            if (!rowCtrl.isFullWidth()) return false;
            const rowNode = rowCtrl.getRowNode();
            if (rowNodesMap != null && !this.isRowInMap(rowNode, rowNodesMap)) return false;
            return true;
        });
    }
    createOrUpdateRowCtrl(rowIndex, rowsToRecycle, animate, afterScroll) {
        let rowNode;
        let rowCtrl = this.rowCtrlsByRowIndex[rowIndex];
        if (!rowCtrl) {
            rowNode = this.paginationProxy.getRow(rowIndex);
            if ($437b23f6a393c3bf$var$exists(rowNode) && $437b23f6a393c3bf$var$exists(rowsToRecycle) && rowsToRecycle[rowNode.id] && rowNode.alreadyRendered) {
                rowCtrl = rowsToRecycle[rowNode.id];
                rowsToRecycle[rowNode.id] = null;
            }
        }
        const creatingNewRowCtrl = !rowCtrl;
        if (creatingNewRowCtrl) {
            if (!rowNode) rowNode = this.paginationProxy.getRow(rowIndex);
            if ($437b23f6a393c3bf$var$exists(rowNode)) rowCtrl = this.createRowCon(rowNode, animate, afterScroll);
            else return;
        }
        if (rowNode) rowNode.alreadyRendered = true;
        this.rowCtrlsByRowIndex[rowIndex] = rowCtrl;
        return rowCtrl;
    }
    destroyRowCtrls(rowCtrlsMap, animate) {
        const executeInAWhileFuncs = [];
        $437b23f6a393c3bf$var$iterateObject(rowCtrlsMap, (nodeId, rowCtrl)=>{
            if (!rowCtrl) return;
            if (this.cachedRowCtrls && rowCtrl.isCacheable()) {
                this.cachedRowCtrls.addRow(rowCtrl);
                return;
            }
            rowCtrl.destroyFirstPass(!animate);
            if (animate) {
                this.zombieRowCtrls[rowCtrl.getInstanceId()] = rowCtrl;
                executeInAWhileFuncs.push(()=>{
                    rowCtrl.destroySecondPass();
                    delete this.zombieRowCtrls[rowCtrl.getInstanceId()];
                });
            } else rowCtrl.destroySecondPass();
        });
        if (animate) {
            executeInAWhileFuncs.push(()=>{
                this.updateAllRowCtrls();
                this.dispatchDisplayedRowsChanged();
            });
            $437b23f6a393c3bf$var$executeInAWhile(executeInAWhileFuncs);
        }
    }
    getRowBuffer() {
        return this.gos.get("rowBuffer");
    }
    getRowBufferInPixels() {
        const rowsToBuffer = this.getRowBuffer();
        const defaultRowHeight = this.gos.getRowHeightAsNumber();
        return rowsToBuffer * defaultRowHeight;
    }
    workOutFirstAndLastRowsToRender() {
        this.rowContainerHeightService.updateOffset();
        let newFirst;
        let newLast;
        if (!this.paginationProxy.isRowsToRender()) {
            newFirst = 0;
            newLast = -1;
        } else if (this.printLayout) {
            this.environment.refreshRowHeightVariable();
            newFirst = this.paginationProxy.getPageFirstRow();
            newLast = this.paginationProxy.getPageLastRow();
        } else {
            const bufferPixels = this.getRowBufferInPixels();
            const gridBodyCtrl = this.ctrlsService.getGridBodyCtrl();
            const suppressRowVirtualisation = this.gos.get("suppressRowVirtualisation");
            let rowHeightsChanged = false;
            let firstPixel;
            let lastPixel;
            do {
                const paginationOffset = this.paginationProxy.getPixelOffset();
                const { pageFirstPixel: pageFirstPixel, pageLastPixel: pageLastPixel } = this.paginationProxy.getCurrentPagePixelRange();
                const divStretchOffset = this.rowContainerHeightService.getDivStretchOffset();
                const bodyVRange = gridBodyCtrl.getScrollFeature().getVScrollPosition();
                const bodyTopPixel = bodyVRange.top;
                const bodyBottomPixel = bodyVRange.bottom;
                if (suppressRowVirtualisation) {
                    firstPixel = pageFirstPixel + divStretchOffset;
                    lastPixel = pageLastPixel + divStretchOffset;
                } else {
                    firstPixel = Math.max(bodyTopPixel + paginationOffset - bufferPixels, pageFirstPixel) + divStretchOffset;
                    lastPixel = Math.min(bodyBottomPixel + paginationOffset + bufferPixels, pageLastPixel) + divStretchOffset;
                }
                this.firstVisibleVPixel = Math.max(bodyTopPixel + paginationOffset, pageFirstPixel) + divStretchOffset;
                this.lastVisibleVPixel = Math.min(bodyBottomPixel + paginationOffset, pageLastPixel) + divStretchOffset;
                rowHeightsChanged = this.ensureAllRowsInRangeHaveHeightsCalculated(firstPixel, lastPixel);
            }while (rowHeightsChanged);
            let firstRowIndex = this.paginationProxy.getRowIndexAtPixel(firstPixel);
            let lastRowIndex = this.paginationProxy.getRowIndexAtPixel(lastPixel);
            const pageFirstRow = this.paginationProxy.getPageFirstRow();
            const pageLastRow = this.paginationProxy.getPageLastRow();
            if (firstRowIndex < pageFirstRow) firstRowIndex = pageFirstRow;
            if (lastRowIndex > pageLastRow) lastRowIndex = pageLastRow;
            newFirst = firstRowIndex;
            newLast = lastRowIndex;
        }
        const rowLayoutNormal = this.gos.isDomLayout("normal");
        const suppressRowCountRestriction = this.gos.get("suppressMaxRenderedRowRestriction");
        const rowBufferMaxSize = Math.max(this.getRowBuffer(), 500);
        if (rowLayoutNormal && !suppressRowCountRestriction) {
            if (newLast - newFirst > rowBufferMaxSize) newLast = newFirst + rowBufferMaxSize;
        }
        const firstDiffers = newFirst !== this.firstRenderedRow;
        const lastDiffers = newLast !== this.lastRenderedRow;
        if (firstDiffers || lastDiffers) {
            this.firstRenderedRow = newFirst;
            this.lastRenderedRow = newLast;
            const event = {
                type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_VIEWPORT_CHANGED,
                firstRow: newFirst,
                lastRow: newLast
            };
            this.eventService.dispatchEvent(event);
        }
    }
    /**
   * This event will only be fired once, and is queued until after the browser next renders.
   * This allows us to fire an event during the start of the render cycle, when we first see data being rendered
   * but not execute the event until all of the data has finished being rendered to the dom.
   */ dispatchFirstDataRenderedEvent() {
        if (this.dataFirstRenderedFired) return;
        this.dataFirstRenderedFired = true;
        const event = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_FIRST_DATA_RENDERED,
            firstRow: this.firstRenderedRow,
            lastRow: this.lastRenderedRow
        };
        window.requestAnimationFrame(()=>{
            this.beans.eventService.dispatchEvent(event);
        });
    }
    ensureAllRowsInRangeHaveHeightsCalculated(topPixel, bottomPixel) {
        const res = this.paginationProxy.ensureRowHeightsValid(topPixel, bottomPixel, -1, -1);
        if (res) this.updateContainerHeights();
        return res;
    }
    getFirstVisibleVerticalPixel() {
        return this.firstVisibleVPixel;
    }
    getLastVisibleVerticalPixel() {
        return this.lastVisibleVPixel;
    }
    getFirstVirtualRenderedRow() {
        return this.firstRenderedRow;
    }
    getLastVirtualRenderedRow() {
        return this.lastRenderedRow;
    }
    // check that none of the rows to remove are editing or focused as:
    // a) if editing, we want to keep them, otherwise the user will loose the context of the edit,
    //    eg user starts editing, enters some text, then scrolls down and then up, next time row rendered
    //    the edit is reset - so we want to keep it rendered.
    // b) if focused, we want ot keep keyboard focus, so if user ctrl+c, it goes to clipboard,
    //    otherwise the user can range select and drag (with focus cell going out of the viewport)
    //    and then ctrl+c, nothing will happen if cell is removed from dom.
    // c) if detail record of master detail, as users complained that the context of detail rows
    //    was getting lost when detail row out of view. eg user expands to show detail row,
    //    then manipulates the detail panel (eg sorts the detail grid), then context is lost
    //    after detail panel is scrolled out of / into view.
    doNotUnVirtualiseRow(rowComp) {
        const REMOVE_ROW = false;
        const KEEP_ROW = true;
        const rowNode = rowComp.getRowNode();
        const rowHasFocus = this.focusService.isRowNodeFocused(rowNode);
        const rowIsEditing = rowComp.isEditing();
        const rowIsDetail = rowNode.detail;
        const mightWantToKeepRow = rowHasFocus || rowIsEditing || rowIsDetail;
        if (!mightWantToKeepRow) return REMOVE_ROW;
        const rowNodePresent = this.paginationProxy.isRowPresent(rowNode);
        return rowNodePresent ? KEEP_ROW : REMOVE_ROW;
    }
    createRowCon(rowNode, animate, afterScroll) {
        const rowCtrlFromCache = this.cachedRowCtrls ? this.cachedRowCtrls.getRow(rowNode) : null;
        if (rowCtrlFromCache) return rowCtrlFromCache;
        const suppressAnimationFrame = this.gos.get("suppressAnimationFrame");
        const useAnimationFrameForCreate = afterScroll && !suppressAnimationFrame && !this.printLayout;
        const res = new $437b23f6a393c3bf$export$e449e57ac30326ed(rowNode, this.beans, animate, useAnimationFrameForCreate, this.printLayout);
        return res;
    }
    getRenderedNodes() {
        const renderedRows = this.rowCtrlsByRowIndex;
        return Object.values(renderedRows).map((rowCtrl)=>rowCtrl.getRowNode());
    }
    getRowByPosition(rowPosition) {
        let rowCtrl;
        const { rowIndex: rowIndex } = rowPosition;
        switch(rowPosition.rowPinned){
            case "top":
                rowCtrl = this.topRowCtrls[rowIndex];
                break;
            case "bottom":
                rowCtrl = this.bottomRowCtrls[rowIndex];
                break;
            default:
                rowCtrl = this.rowCtrlsByRowIndex[rowIndex];
                if (!rowCtrl) {
                    rowCtrl = this.getStickyTopRowCtrls().find((ctrl)=>ctrl.getRowNode().rowIndex === rowIndex) || null;
                    if (!rowCtrl) rowCtrl = this.getStickyBottomRowCtrls().find((ctrl)=>ctrl.getRowNode().rowIndex === rowIndex) || null;
                }
                break;
        }
        return rowCtrl;
    }
    // returns true if any row between startIndex and endIndex is rendered. used by
    // SSRM or IRM, as they don't want to purge visible blocks from cache.
    isRangeInRenderedViewport(startIndex, endIndex) {
        const parentClosed = startIndex == null || endIndex == null;
        if (parentClosed) return false;
        const blockAfterViewport = startIndex > this.lastRenderedRow;
        const blockBeforeViewport = endIndex < this.firstRenderedRow;
        const blockInsideViewport = !blockBeforeViewport && !blockAfterViewport;
        return blockInsideViewport;
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("animationFrameService")
], $437b23f6a393c3bf$export$a41edaea3b7c09c8.prototype, "animationFrameService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("paginationProxy")
], $437b23f6a393c3bf$export$a41edaea3b7c09c8.prototype, "paginationProxy", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnModel")
], $437b23f6a393c3bf$export$a41edaea3b7c09c8.prototype, "columnModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("pinnedRowModel")
], $437b23f6a393c3bf$export$a41edaea3b7c09c8.prototype, "pinnedRowModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowModel")
], $437b23f6a393c3bf$export$a41edaea3b7c09c8.prototype, "rowModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("focusService")
], $437b23f6a393c3bf$export$a41edaea3b7c09c8.prototype, "focusService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("beans")
], $437b23f6a393c3bf$export$a41edaea3b7c09c8.prototype, "beans", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowContainerHeightService")
], $437b23f6a393c3bf$export$a41edaea3b7c09c8.prototype, "rowContainerHeightService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("ctrlsService")
], $437b23f6a393c3bf$export$a41edaea3b7c09c8.prototype, "ctrlsService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$export$a41edaea3b7c09c8.prototype, "postConstruct", 1);
$437b23f6a393c3bf$export$a41edaea3b7c09c8 = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("rowRenderer")
], $437b23f6a393c3bf$export$a41edaea3b7c09c8);
var $437b23f6a393c3bf$var$RowCtrlCache = class {
    constructor(maxCount){
        // map for fast access
        this.entriesMap = {};
        // list for keeping order
        this.entriesList = [];
        this.maxCount = maxCount;
    }
    addRow(rowCtrl) {
        this.entriesMap[rowCtrl.getRowNode().id] = rowCtrl;
        this.entriesList.push(rowCtrl);
        rowCtrl.setCached(true);
        if (this.entriesList.length > this.maxCount) {
            const rowCtrlToDestroy = this.entriesList[0];
            rowCtrlToDestroy.destroyFirstPass();
            rowCtrlToDestroy.destroySecondPass();
            this.removeFromCache(rowCtrlToDestroy);
        }
    }
    getRow(rowNode) {
        if (rowNode == null || rowNode.id == null) return null;
        const res = this.entriesMap[rowNode.id];
        if (!res) return null;
        this.removeFromCache(res);
        res.setCached(false);
        const rowNodeMismatch = res.getRowNode() != rowNode;
        return rowNodeMismatch ? null : res;
    }
    has(rowNode) {
        return this.entriesMap[rowNode.id] != null;
    }
    removeRow(rowNode) {
        const rowNodeId = rowNode.id;
        const ctrl = this.entriesMap[rowNodeId];
        delete this.entriesMap[rowNodeId];
        $437b23f6a393c3bf$var$removeFromArray(this.entriesList, ctrl);
    }
    removeFromCache(rowCtrl) {
        const rowNodeId = rowCtrl.getRowNode().id;
        delete this.entriesMap[rowNodeId];
        $437b23f6a393c3bf$var$removeFromArray(this.entriesList, rowCtrl);
    }
    getEntries() {
        return this.entriesList;
    }
};
// community-modules/core/src/pinnedRowModel/pinnedRowModel.ts
var $437b23f6a393c3bf$export$d44126a5f53c99d9 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    init() {
        this.setPinnedTopRowData();
        this.setPinnedBottomRowData();
        this.addManagedPropertyListener("pinnedTopRowData", ()=>this.setPinnedTopRowData());
        this.addManagedPropertyListener("pinnedBottomRowData", ()=>this.setPinnedBottomRowData());
    }
    isEmpty(floating) {
        const rows = floating === "top" ? this.pinnedTopRows : this.pinnedBottomRows;
        return $437b23f6a393c3bf$var$missingOrEmpty(rows);
    }
    isRowsToRender(floating) {
        return !this.isEmpty(floating);
    }
    getRowAtPixel(pixel, floating) {
        const rows = floating === "top" ? this.pinnedTopRows : this.pinnedBottomRows;
        if ($437b23f6a393c3bf$var$missingOrEmpty(rows)) return 0;
        for(let i = 0; i < rows.length; i++){
            const rowNode = rows[i];
            const rowTopPixel = rowNode.rowTop + rowNode.rowHeight - 1;
            if (rowTopPixel >= pixel) return i;
        }
        return rows.length - 1;
    }
    setPinnedTopRowData() {
        const rowData = this.gos.get("pinnedTopRowData");
        this.pinnedTopRows = this.createNodesFromData(rowData, true);
        const event = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_PINNED_ROW_DATA_CHANGED
        };
        this.eventService.dispatchEvent(event);
    }
    setPinnedBottomRowData() {
        const rowData = this.gos.get("pinnedBottomRowData");
        this.pinnedBottomRows = this.createNodesFromData(rowData, false);
        const event = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_PINNED_ROW_DATA_CHANGED
        };
        this.eventService.dispatchEvent(event);
    }
    createNodesFromData(allData, isTop) {
        const rowNodes = [];
        if (allData) {
            let nextRowTop = 0;
            allData.forEach((dataItem, index)=>{
                const rowNode = new $437b23f6a393c3bf$export$6af91cd58ec2edf9(this.beans);
                rowNode.data = dataItem;
                const idPrefix = isTop ? $437b23f6a393c3bf$export$6af91cd58ec2edf9.ID_PREFIX_TOP_PINNED : $437b23f6a393c3bf$export$6af91cd58ec2edf9.ID_PREFIX_BOTTOM_PINNED;
                rowNode.id = idPrefix + index;
                rowNode.rowPinned = isTop ? "top" : "bottom";
                rowNode.setRowTop(nextRowTop);
                rowNode.setRowHeight(this.gos.getRowHeightForNode(rowNode).height);
                rowNode.setRowIndex(index);
                nextRowTop += rowNode.rowHeight;
                rowNodes.push(rowNode);
            });
        }
        return rowNodes;
    }
    getPinnedTopRowData() {
        return this.pinnedTopRows;
    }
    getPinnedBottomRowData() {
        return this.pinnedBottomRows;
    }
    getPinnedTopTotalHeight() {
        return this.getTotalHeight(this.pinnedTopRows);
    }
    getPinnedTopRowCount() {
        return this.pinnedTopRows ? this.pinnedTopRows.length : 0;
    }
    getPinnedBottomRowCount() {
        return this.pinnedBottomRows ? this.pinnedBottomRows.length : 0;
    }
    getPinnedTopRow(index) {
        return this.pinnedTopRows[index];
    }
    getPinnedBottomRow(index) {
        return this.pinnedBottomRows[index];
    }
    forEachPinnedTopRow(callback) {
        if ($437b23f6a393c3bf$var$missingOrEmpty(this.pinnedTopRows)) return;
        this.pinnedTopRows.forEach(callback);
    }
    forEachPinnedBottomRow(callback) {
        if ($437b23f6a393c3bf$var$missingOrEmpty(this.pinnedBottomRows)) return;
        this.pinnedBottomRows.forEach(callback);
    }
    getPinnedBottomTotalHeight() {
        return this.getTotalHeight(this.pinnedBottomRows);
    }
    getTotalHeight(rowNodes) {
        if (!rowNodes || rowNodes.length === 0) return 0;
        const lastNode = $437b23f6a393c3bf$var$last(rowNodes);
        return lastNode.rowTop + lastNode.rowHeight;
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("beans")
], $437b23f6a393c3bf$export$d44126a5f53c99d9.prototype, "beans", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$export$d44126a5f53c99d9.prototype, "init", 1);
$437b23f6a393c3bf$export$d44126a5f53c99d9 = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("pinnedRowModel")
], $437b23f6a393c3bf$export$d44126a5f53c99d9);
// community-modules/core/src/interfaces/serverSideTransaction.ts
var $437b23f6a393c3bf$export$58e95be8934cbc38 = /* @__PURE__ */ ((ServerSideTransactionResultStatus2)=>{
    ServerSideTransactionResultStatus2["Applied"] = "Applied";
    ServerSideTransactionResultStatus2["StoreNotFound"] = "StoreNotFound";
    ServerSideTransactionResultStatus2["StoreLoading"] = "StoreLoading";
    ServerSideTransactionResultStatus2["StoreWaitingToLoad"] = "StoreWaitingToLoad";
    ServerSideTransactionResultStatus2["StoreLoadingFailed"] = "StoreLoadingFailed";
    ServerSideTransactionResultStatus2["StoreWrongType"] = "StoreWrongType";
    ServerSideTransactionResultStatus2["Cancelled"] = "Cancelled";
    ServerSideTransactionResultStatus2["StoreNotStarted"] = "StoreNotStarted";
    return ServerSideTransactionResultStatus2;
})($437b23f6a393c3bf$export$58e95be8934cbc38 || {});
// community-modules/core/src/utils/changedPath.ts
var $437b23f6a393c3bf$export$cb4d9114a9732e85 = class {
    constructor(keepingColumns, rootNode){
        // whether changed path is active of not. it is active when a) doing
        // a transaction update or b) doing change detection. if we are doing
        // a CSRM refresh for other reasons (after sort or filter, or user calling
        // setRowData() without delta mode) then we are not active. we are also
        // marked as not active if secondary columns change in pivot (as this impacts
        // aggregations)
        this.active = true;
        // for each node in the change path, we also store which columns need
        // to be re-aggregated.
        this.nodeIdsToColumns = {};
        // for quick lookup, all items in the change path are mapped by nodeId
        this.mapToItems = {};
        this.keepingColumns = keepingColumns;
        this.pathRoot = {
            rowNode: rootNode,
            children: null
        };
        this.mapToItems[rootNode.id] = this.pathRoot;
    }
    // can be set inactive by:
    // a) ClientSideRowModel, if no transactions or
    // b) PivotService, if secondary columns changed
    setInactive() {
        this.active = false;
    }
    isActive() {
        return this.active;
    }
    depthFirstSearchChangedPath(pathItem, callback) {
        if (pathItem.children) for(let i = 0; i < pathItem.children.length; i++)this.depthFirstSearchChangedPath(pathItem.children[i], callback);
        callback(pathItem.rowNode);
    }
    depthFirstSearchEverything(rowNode, callback, traverseEverything) {
        if (rowNode.childrenAfterGroup) for(let i = 0; i < rowNode.childrenAfterGroup.length; i++){
            const childNode = rowNode.childrenAfterGroup[i];
            if (childNode.childrenAfterGroup) this.depthFirstSearchEverything(rowNode.childrenAfterGroup[i], callback, traverseEverything);
            else if (traverseEverything) callback(childNode);
        }
        callback(rowNode);
    }
    // traverseLeafNodes -> used when NOT doing changed path, ie traversing everything. the callback
    // will be called for child nodes in addition to parent nodes.
    forEachChangedNodeDepthFirst(callback, traverseLeafNodes = false, includeUnchangedNodes = false) {
        if (this.active && !includeUnchangedNodes) this.depthFirstSearchChangedPath(this.pathRoot, callback);
        else this.depthFirstSearchEverything(this.pathRoot.rowNode, callback, traverseLeafNodes);
    }
    executeFromRootNode(callback) {
        callback(this.pathRoot.rowNode);
    }
    createPathItems(rowNode) {
        let pointer = rowNode;
        let newEntryCount = 0;
        while(!this.mapToItems[pointer.id]){
            const newEntry = {
                rowNode: pointer,
                children: null
            };
            this.mapToItems[pointer.id] = newEntry;
            newEntryCount++;
            pointer = pointer.parent;
        }
        return newEntryCount;
    }
    populateColumnsMap(rowNode, columns) {
        if (!this.keepingColumns || !columns) return;
        let pointer = rowNode;
        while(pointer){
            if (!this.nodeIdsToColumns[pointer.id]) this.nodeIdsToColumns[pointer.id] = {};
            columns.forEach((col)=>this.nodeIdsToColumns[pointer.id][col.getId()] = true);
            pointer = pointer.parent;
        }
    }
    linkPathItems(rowNode, newEntryCount) {
        let pointer = rowNode;
        for(let i = 0; i < newEntryCount; i++){
            const thisItem = this.mapToItems[pointer.id];
            const parentItem = this.mapToItems[pointer.parent.id];
            if (!parentItem.children) parentItem.children = [];
            parentItem.children.push(thisItem);
            pointer = pointer.parent;
        }
    }
    // called by
    // 1) change detection (provides cols) and
    // 2) groupStage if doing transaction update (doesn't provide cols)
    addParentNode(rowNode, columns) {
        if (!rowNode || rowNode.isRowPinned()) return;
        const newEntryCount = this.createPathItems(rowNode);
        this.linkPathItems(rowNode, newEntryCount);
        this.populateColumnsMap(rowNode, columns);
    }
    canSkip(rowNode) {
        return this.active && !this.mapToItems[rowNode.id];
    }
    getValueColumnsForNode(rowNode, valueColumns) {
        if (!this.keepingColumns) return valueColumns;
        const colsForThisNode = this.nodeIdsToColumns[rowNode.id];
        const result = valueColumns.filter((col)=>colsForThisNode[col.getId()]);
        return result;
    }
    getNotValueColumnsForNode(rowNode, valueColumns) {
        if (!this.keepingColumns) return null;
        const colsForThisNode = this.nodeIdsToColumns[rowNode.id];
        const result = valueColumns.filter((col)=>!colsForThisNode[col.getId()]);
        return result;
    }
};
// community-modules/core/src/rowNodeCache/rowNodeBlock.ts
var $437b23f6a393c3bf$var$_RowNodeBlock = class _RowNodeBlock extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(id){
        super();
        this.state = _RowNodeBlock.STATE_WAITING_TO_LOAD;
        this.version = 0;
        this.id = id;
    }
    getId() {
        return this.id;
    }
    load() {
        this.state = _RowNodeBlock.STATE_LOADING;
        this.loadFromDatasource();
    }
    getVersion() {
        return this.version;
    }
    setStateWaitingToLoad() {
        this.version++;
        this.state = _RowNodeBlock.STATE_WAITING_TO_LOAD;
    }
    getState() {
        return this.state;
    }
    pageLoadFailed(version) {
        const requestMostRecentAndLive = this.isRequestMostRecentAndLive(version);
        if (requestMostRecentAndLive) {
            this.state = _RowNodeBlock.STATE_FAILED;
            this.processServerFail();
        }
        this.dispatchLoadCompleted(false);
    }
    success(version, params) {
        this.successCommon(version, params);
    }
    pageLoaded(version, rows, lastRow) {
        this.successCommon(version, {
            rowData: rows,
            rowCount: lastRow
        });
    }
    isRequestMostRecentAndLive(version) {
        const thisIsMostRecentRequest = version === this.version;
        const weAreNotDestroyed = this.isAlive();
        return thisIsMostRecentRequest && weAreNotDestroyed;
    }
    successCommon(version, params) {
        this.dispatchLoadCompleted();
        const requestMostRecentAndLive = this.isRequestMostRecentAndLive(version);
        if (requestMostRecentAndLive) {
            this.state = _RowNodeBlock.STATE_LOADED;
            this.processServerResult(params);
        }
    }
    dispatchLoadCompleted(success = true) {
        const event = {
            type: _RowNodeBlock.EVENT_LOAD_COMPLETE,
            success: success,
            block: this
        };
        this.dispatchEvent(event);
    }
};
$437b23f6a393c3bf$var$_RowNodeBlock.EVENT_LOAD_COMPLETE = "loadComplete";
$437b23f6a393c3bf$var$_RowNodeBlock.STATE_WAITING_TO_LOAD = "needsLoading";
$437b23f6a393c3bf$var$_RowNodeBlock.STATE_LOADING = "loading";
$437b23f6a393c3bf$var$_RowNodeBlock.STATE_LOADED = "loaded";
$437b23f6a393c3bf$var$_RowNodeBlock.STATE_FAILED = "failed";
var $437b23f6a393c3bf$export$eb7378abb0bca09e = $437b23f6a393c3bf$var$_RowNodeBlock;
// community-modules/core/src/rowNodeCache/rowNodeBlockLoader.ts
var $437b23f6a393c3bf$export$6bcc4682a6134db1 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.activeBlockLoadsCount = 0;
        this.blocks = [];
        this.active = true;
    }
    postConstruct() {
        this.maxConcurrentRequests = this.getMaxConcurrentDatasourceRequests();
        const blockLoadDebounceMillis = this.gos.get("blockLoadDebounceMillis");
        if (blockLoadDebounceMillis && blockLoadDebounceMillis > 0) this.checkBlockToLoadDebounce = $437b23f6a393c3bf$export$71511d61b312f219.debounce(this.performCheckBlocksToLoad.bind(this), blockLoadDebounceMillis);
    }
    setBeans(loggerFactory) {
        this.logger = loggerFactory.create("RowNodeBlockLoader");
    }
    getMaxConcurrentDatasourceRequests() {
        const res = this.gos.get("maxConcurrentDatasourceRequests");
        if (res == null) return 2;
        if (res <= 0) return;
        return res;
    }
    addBlock(block) {
        this.blocks.push(block);
        block.addEventListener($437b23f6a393c3bf$export$eb7378abb0bca09e.EVENT_LOAD_COMPLETE, this.loadComplete.bind(this));
        this.checkBlockToLoad();
    }
    removeBlock(block) {
        $437b23f6a393c3bf$export$71511d61b312f219.removeFromArray(this.blocks, block);
    }
    destroy() {
        super.destroy();
        this.active = false;
    }
    loadComplete() {
        this.activeBlockLoadsCount--;
        this.checkBlockToLoad();
        this.dispatchEvent({
            type: $437b23f6a393c3bf$export$6bcc4682a6134db1.BLOCK_LOADED_EVENT
        });
        if (this.activeBlockLoadsCount == 0) this.dispatchEvent({
            type: $437b23f6a393c3bf$export$6bcc4682a6134db1.BLOCK_LOADER_FINISHED_EVENT
        });
    }
    checkBlockToLoad() {
        if (this.checkBlockToLoadDebounce) this.checkBlockToLoadDebounce();
        else this.performCheckBlocksToLoad();
    }
    performCheckBlocksToLoad() {
        if (!this.active) return;
        this.printCacheStatus();
        if (this.maxConcurrentRequests != null && this.activeBlockLoadsCount >= this.maxConcurrentRequests) {
            this.logger.log(`checkBlockToLoad: max loads exceeded`);
            return;
        }
        const loadAvailability = this.getAvailableLoadingCount();
        const blocksToLoad = this.blocks.filter((block)=>block.getState() === $437b23f6a393c3bf$export$eb7378abb0bca09e.STATE_WAITING_TO_LOAD).slice(0, loadAvailability);
        this.registerLoads(blocksToLoad.length);
        blocksToLoad.forEach((block)=>block.load());
        this.printCacheStatus();
    }
    getBlockState() {
        if (this.gos.isRowModelType("serverSide")) {
            const ssrm = this.rowModel;
            return ssrm.getBlockStates();
        }
        const result = {};
        this.blocks.forEach((block)=>{
            const { id: id, state: state } = block.getBlockStateJson();
            result[id] = state;
        });
        return result;
    }
    printCacheStatus() {
        if (this.logger.isLogging()) this.logger.log(`printCacheStatus: activePageLoadsCount = ${this.activeBlockLoadsCount}, blocks = ${JSON.stringify(this.getBlockState())}`);
    }
    isLoading() {
        return this.activeBlockLoadsCount > 0;
    }
    registerLoads(count) {
        this.activeBlockLoadsCount += count;
    }
    getAvailableLoadingCount() {
        return this.maxConcurrentRequests !== void 0 ? this.maxConcurrentRequests - this.activeBlockLoadsCount : void 0;
    }
};
$437b23f6a393c3bf$export$6bcc4682a6134db1.BLOCK_LOADED_EVENT = "blockLoaded";
$437b23f6a393c3bf$export$6bcc4682a6134db1.BLOCK_LOADER_FINISHED_EVENT = "blockLoaderFinished";
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowModel")
], $437b23f6a393c3bf$export$6bcc4682a6134db1.prototype, "rowModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$export$6bcc4682a6134db1.prototype, "postConstruct", 1);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$var$__decorateParam(0, $437b23f6a393c3bf$export$c3215dfb7fd4803b("loggerFactory"))
], $437b23f6a393c3bf$export$6bcc4682a6134db1.prototype, "setBeans", 1);
$437b23f6a393c3bf$export$6bcc4682a6134db1 = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("rowNodeBlockLoader")
], $437b23f6a393c3bf$export$6bcc4682a6134db1);
// community-modules/core/src/pagination/paginationProxy.ts
var $437b23f6a393c3bf$export$beda096b980d328 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.currentPage = 0;
        this.topDisplayedRowIndex = 0;
        this.bottomDisplayedRowIndex = 0;
        this.pixelOffset = 0;
        this.masterRowCount = 0;
    }
    postConstruct() {
        this.active = this.gos.get("pagination");
        this.pageSizeFromGridOptions = this.gos.get("paginationPageSize");
        this.paginateChildRows = this.isPaginateChildRows();
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_MODEL_UPDATED, this.onModelUpdated.bind(this));
        this.addManagedPropertyListener("pagination", this.onPaginationGridOptionChanged.bind(this));
        this.addManagedPropertyListener("paginationPageSize", this.onPageSizeGridOptionChanged.bind(this));
        this.onModelUpdated();
    }
    ensureRowHeightsValid(startPixel, endPixel, startLimitIndex, endLimitIndex) {
        const res = this.rowModel.ensureRowHeightsValid(startPixel, endPixel, this.getPageFirstRow(), this.getPageLastRow());
        if (res) this.calculatePages();
        return res;
    }
    isPaginateChildRows() {
        const shouldPaginate = this.gos.get("groupRemoveSingleChildren") || this.gos.get("groupRemoveLowestSingleChildren");
        if (shouldPaginate) return true;
        return this.gos.get("paginateChildRows");
    }
    onModelUpdated(modelUpdatedEvent) {
        this.calculatePages();
        const paginationChangedEvent = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_PAGINATION_CHANGED,
            animate: modelUpdatedEvent ? modelUpdatedEvent.animate : false,
            newData: modelUpdatedEvent ? modelUpdatedEvent.newData : false,
            newPage: modelUpdatedEvent ? modelUpdatedEvent.newPage : false,
            newPageSize: modelUpdatedEvent ? modelUpdatedEvent.newPageSize : false,
            keepRenderedRows: modelUpdatedEvent ? modelUpdatedEvent.keepRenderedRows : false
        };
        this.eventService.dispatchEvent(paginationChangedEvent);
    }
    onPaginationGridOptionChanged() {
        this.active = this.gos.get("pagination");
        this.calculatePages();
        const paginationChangedEvent = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_PAGINATION_CHANGED,
            animate: false,
            newData: false,
            newPage: false,
            newPageSize: false,
            // important to keep rendered rows, otherwise every time grid is resized,
            // we would destroy all the rows.
            keepRenderedRows: true
        };
        this.eventService.dispatchEvent(paginationChangedEvent);
    }
    onPageSizeGridOptionChanged() {
        this.setPageSize(this.gos.get("paginationPageSize"), "gridOptions");
    }
    goToPage(page) {
        if (!this.active || this.currentPage === page || typeof this.currentPage !== "number") return;
        this.currentPage = page;
        this.calculatePages();
        const paginationChangedEvent = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_PAGINATION_CHANGED,
            animate: false,
            newData: false,
            newPage: true,
            newPageSize: false,
            keepRenderedRows: false
        };
        this.eventService.dispatchEvent(paginationChangedEvent);
    }
    getPixelOffset() {
        return this.pixelOffset;
    }
    getRow(index) {
        return this.rowModel.getRow(index);
    }
    getRowNode(id) {
        return this.rowModel.getRowNode(id);
    }
    getRowIndexAtPixel(pixel) {
        return this.rowModel.getRowIndexAtPixel(pixel);
    }
    getCurrentPageHeight() {
        if ($437b23f6a393c3bf$var$missing(this.topRowBounds) || $437b23f6a393c3bf$var$missing(this.bottomRowBounds)) return 0;
        return Math.max(this.bottomRowBounds.rowTop + this.bottomRowBounds.rowHeight - this.topRowBounds.rowTop, 0);
    }
    getCurrentPagePixelRange() {
        const pageFirstPixel = this.topRowBounds ? this.topRowBounds.rowTop : 0;
        const pageLastPixel = this.bottomRowBounds ? this.bottomRowBounds.rowTop + this.bottomRowBounds.rowHeight : 0;
        return {
            pageFirstPixel: pageFirstPixel,
            pageLastPixel: pageLastPixel
        };
    }
    isRowPresent(rowNode) {
        if (!this.rowModel.isRowPresent(rowNode)) return false;
        const nodeIsInPage = rowNode.rowIndex >= this.topDisplayedRowIndex && rowNode.rowIndex <= this.bottomDisplayedRowIndex;
        return nodeIsInPage;
    }
    isEmpty() {
        return this.rowModel.isEmpty();
    }
    isRowsToRender() {
        return this.rowModel.isRowsToRender();
    }
    forEachNode(callback) {
        return this.rowModel.forEachNode(callback);
    }
    forEachNodeOnPage(callback) {
        const firstRow = this.getPageFirstRow();
        const lastRow = this.getPageLastRow();
        for(let i = firstRow; i <= lastRow; i++){
            const node = this.getRow(i);
            if (node) callback(node);
        }
    }
    getType() {
        return this.rowModel.getType();
    }
    getRowBounds(index) {
        const res = this.rowModel.getRowBounds(index);
        res.rowIndex = index;
        return res;
    }
    getPageFirstRow() {
        return this.topRowBounds ? this.topRowBounds.rowIndex : -1;
    }
    getPageLastRow() {
        return this.bottomRowBounds ? this.bottomRowBounds.rowIndex : -1;
    }
    getRowCount() {
        return this.rowModel.getRowCount();
    }
    getPageForIndex(index) {
        return Math.floor(index / this.pageSize);
    }
    goToPageWithIndex(index) {
        if (!this.active) return;
        const pageNumber = this.getPageForIndex(index);
        this.goToPage(pageNumber);
    }
    isRowInPage(row) {
        if (!this.active) return true;
        const rowPage = this.getPageForIndex(row.rowIndex);
        return rowPage === this.currentPage;
    }
    isLastPageFound() {
        return this.rowModel.isLastRowIndexKnown();
    }
    getCurrentPage() {
        return this.currentPage;
    }
    goToNextPage() {
        this.goToPage(this.currentPage + 1);
    }
    goToPreviousPage() {
        this.goToPage(this.currentPage - 1);
    }
    goToFirstPage() {
        this.goToPage(0);
    }
    goToLastPage() {
        const rowCount = this.rowModel.getRowCount();
        const lastPage = Math.floor(rowCount / this.pageSize);
        this.goToPage(lastPage);
    }
    getPageSize() {
        return this.pageSize;
    }
    getTotalPages() {
        return this.totalPages;
    }
    /** This is only for state setting before data has been loaded */ setPage(page) {
        this.currentPage = page;
    }
    get pageSize() {
        if ($437b23f6a393c3bf$var$exists(this.pageSizeAutoCalculated)) return this.pageSizeAutoCalculated;
        if ($437b23f6a393c3bf$var$exists(this.pageSizeFromPageSizeSelector)) return this.pageSizeFromPageSizeSelector;
        if ($437b23f6a393c3bf$var$exists(this.pageSizeFromInitialState)) return this.pageSizeFromInitialState;
        if ($437b23f6a393c3bf$var$exists(this.pageSizeFromGridOptions)) return this.pageSizeFromGridOptions;
        return this.defaultPageSize;
    }
    unsetAutoCalculatedPageSize() {
        if (this.pageSizeAutoCalculated === void 0) return;
        const oldPageSize = this.pageSizeAutoCalculated;
        this.pageSizeAutoCalculated = void 0;
        if (this.pageSize === oldPageSize) return;
        this.calculatePages();
        const paginationChangedEvent = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_PAGINATION_CHANGED,
            animate: false,
            newData: false,
            newPage: false,
            newPageSize: true,
            keepRenderedRows: false
        };
        this.eventService.dispatchEvent(paginationChangedEvent);
    }
    setPageSize(size, source) {
        const currentSize = this.pageSize;
        switch(source){
            case "autoCalculated":
                this.pageSizeAutoCalculated = size;
                break;
            case "pageSizeSelector":
                this.pageSizeFromPageSizeSelector = size;
                if (this.currentPage !== 0) this.goToFirstPage();
                break;
            case "initialState":
                this.pageSizeFromInitialState = size;
                break;
            case "gridOptions":
                this.pageSizeFromGridOptions = size;
                this.pageSizeFromInitialState = void 0;
                this.pageSizeFromPageSizeSelector = void 0;
                if (this.currentPage !== 0) this.goToFirstPage();
                break;
        }
        if (currentSize !== this.pageSize) {
            this.calculatePages();
            const paginationChangedEvent = {
                type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_PAGINATION_CHANGED,
                animate: false,
                newData: false,
                newPage: false,
                newPageSize: true,
                keepRenderedRows: true
            };
            this.eventService.dispatchEvent(paginationChangedEvent);
        }
    }
    calculatePages() {
        if (this.active) {
            if (this.paginateChildRows) this.calculatePagesAllRows();
            else this.calculatePagesMasterRowsOnly();
        } else this.calculatedPagesNotActive();
        this.topRowBounds = this.rowModel.getRowBounds(this.topDisplayedRowIndex);
        if (this.topRowBounds) this.topRowBounds.rowIndex = this.topDisplayedRowIndex;
        this.bottomRowBounds = this.rowModel.getRowBounds(this.bottomDisplayedRowIndex);
        if (this.bottomRowBounds) this.bottomRowBounds.rowIndex = this.bottomDisplayedRowIndex;
        this.setPixelOffset($437b23f6a393c3bf$var$exists(this.topRowBounds) ? this.topRowBounds.rowTop : 0);
    }
    setPixelOffset(value) {
        if (this.pixelOffset === value) return;
        this.pixelOffset = value;
        this.eventService.dispatchEvent({
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_PAGINATION_PIXEL_OFFSET_CHANGED
        });
    }
    setZeroRows() {
        this.masterRowCount = 0;
        this.topDisplayedRowIndex = 0;
        this.bottomDisplayedRowIndex = -1;
        this.currentPage = 0;
        this.totalPages = 0;
    }
    adjustCurrentPageIfInvalid() {
        if (this.currentPage >= this.totalPages) this.currentPage = this.totalPages - 1;
        if (!isFinite(this.currentPage) || isNaN(this.currentPage) || this.currentPage < 0) this.currentPage = 0;
    }
    calculatePagesMasterRowsOnly() {
        this.masterRowCount = this.rowModel.getTopLevelRowCount();
        if (this.masterRowCount <= 0) {
            this.setZeroRows();
            return;
        }
        const masterLastRowIndex = this.masterRowCount - 1;
        this.totalPages = Math.floor(masterLastRowIndex / this.pageSize) + 1;
        this.adjustCurrentPageIfInvalid();
        const masterPageStartIndex = this.pageSize * this.currentPage;
        let masterPageEndIndex = this.pageSize * (this.currentPage + 1) - 1;
        if (masterPageEndIndex > masterLastRowIndex) masterPageEndIndex = masterLastRowIndex;
        this.topDisplayedRowIndex = this.rowModel.getTopLevelRowDisplayedIndex(masterPageStartIndex);
        if (masterPageEndIndex === masterLastRowIndex) this.bottomDisplayedRowIndex = this.rowModel.getRowCount() - 1;
        else {
            const firstIndexNotToShow = this.rowModel.getTopLevelRowDisplayedIndex(masterPageEndIndex + 1);
            this.bottomDisplayedRowIndex = firstIndexNotToShow - 1;
        }
    }
    getMasterRowCount() {
        return this.masterRowCount;
    }
    calculatePagesAllRows() {
        this.masterRowCount = this.rowModel.getRowCount();
        if (this.masterRowCount === 0) {
            this.setZeroRows();
            return;
        }
        const maxRowIndex = this.masterRowCount - 1;
        this.totalPages = Math.floor(maxRowIndex / this.pageSize) + 1;
        this.adjustCurrentPageIfInvalid();
        this.topDisplayedRowIndex = this.pageSize * this.currentPage;
        this.bottomDisplayedRowIndex = this.pageSize * (this.currentPage + 1) - 1;
        if (this.bottomDisplayedRowIndex > maxRowIndex) this.bottomDisplayedRowIndex = maxRowIndex;
    }
    calculatedPagesNotActive() {
        this.setPageSize(void 0, "autoCalculated");
        this.totalPages = 1;
        this.currentPage = 0;
        this.topDisplayedRowIndex = 0;
        this.bottomDisplayedRowIndex = this.rowModel.getRowCount() - 1;
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowModel")
], $437b23f6a393c3bf$export$beda096b980d328.prototype, "rowModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$export$beda096b980d328.prototype, "postConstruct", 1);
$437b23f6a393c3bf$export$beda096b980d328 = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("paginationProxy")
], $437b23f6a393c3bf$export$beda096b980d328);
// community-modules/core/src/styling/stylingService.ts
var $437b23f6a393c3bf$export$cf53ce5e31dacc9f = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    processAllCellClasses(colDef, params, onApplicableClass, onNotApplicableClass) {
        this.processClassRules(void 0, colDef.cellClassRules, params, onApplicableClass, onNotApplicableClass);
        this.processStaticCellClasses(colDef, params, onApplicableClass);
    }
    processClassRules(previousClassRules, classRules, params, onApplicableClass, onNotApplicableClass) {
        if (classRules == null && previousClassRules == null) return;
        const classesToApply = {};
        const classesToRemove = {};
        const forEachSingleClass = (className, callback)=>{
            className.split(" ").forEach((singleClass)=>{
                if (singleClass.trim() == "") return;
                callback(singleClass);
            });
        };
        if (classRules) {
            const classNames = Object.keys(classRules);
            for(let i = 0; i < classNames.length; i++){
                const className = classNames[i];
                const rule = classRules[className];
                let resultOfRule;
                if (typeof rule === "string") resultOfRule = this.expressionService.evaluate(rule, params);
                else if (typeof rule === "function") resultOfRule = rule(params);
                forEachSingleClass(className, (singleClass)=>{
                    resultOfRule ? classesToApply[singleClass] = true : classesToRemove[singleClass] = true;
                });
            }
        }
        if (previousClassRules && onNotApplicableClass) Object.keys(previousClassRules).forEach((className)=>forEachSingleClass(className, (singleClass)=>{
                if (!classesToApply[singleClass]) classesToRemove[singleClass] = true;
            }));
        if (onNotApplicableClass) Object.keys(classesToRemove).forEach(onNotApplicableClass);
        Object.keys(classesToApply).forEach(onApplicableClass);
    }
    getStaticCellClasses(colDef, params) {
        const { cellClass: cellClass } = colDef;
        if (!cellClass) return [];
        let classOrClasses;
        if (typeof cellClass === "function") {
            const cellClassFunc = cellClass;
            classOrClasses = cellClassFunc(params);
        } else classOrClasses = cellClass;
        if (typeof classOrClasses === "string") classOrClasses = [
            classOrClasses
        ];
        return classOrClasses || [];
    }
    processStaticCellClasses(colDef, params, onApplicableClass) {
        const classOrClasses = this.getStaticCellClasses(colDef, params);
        classOrClasses.forEach((cssClassItem)=>{
            onApplicableClass(cssClassItem);
        });
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("expressionService")
], $437b23f6a393c3bf$export$cf53ce5e31dacc9f.prototype, "expressionService", 2);
$437b23f6a393c3bf$export$cf53ce5e31dacc9f = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("stylingService")
], $437b23f6a393c3bf$export$cf53ce5e31dacc9f);
// community-modules/core/src/widgets/agToggleButton.ts
var $437b23f6a393c3bf$export$167b21bf245ce0bf = class extends $437b23f6a393c3bf$export$b00c508c1ae18d07 {
    constructor(config){
        super(config, "ag-toggle-button");
    }
    setValue(value, silent) {
        super.setValue(value, silent);
        this.addOrRemoveCssClass("ag-selected", this.getValue());
        return this;
    }
};
// community-modules/core/src/widgets/agInputTextArea.ts
var $437b23f6a393c3bf$export$fd677433260ffbc8 = class extends $437b23f6a393c3bf$var$AgAbstractInputField {
    constructor(config){
        super(config, "ag-text-area", null, "textarea");
    }
    setValue(value, silent) {
        const ret = super.setValue(value, silent);
        this.eInput.value = value;
        return ret;
    }
    setCols(cols) {
        this.eInput.cols = cols;
        return this;
    }
    setRows(rows) {
        this.eInput.rows = rows;
        return this;
    }
};
// community-modules/core/src/widgets/agInputDateField.ts
var $437b23f6a393c3bf$export$9e01ec8ba43de612 = class extends $437b23f6a393c3bf$export$8c027679838afd47 {
    constructor(config){
        super(config, "ag-date-field", "date");
    }
    postConstruct() {
        super.postConstruct();
        this.addManagedListener(this.eInput, "wheel", this.onWheel.bind(this));
        const usingSafari = $437b23f6a393c3bf$var$isBrowserSafari();
        this.addManagedListener(this.eInput, "mousedown", ()=>{
            if (this.isDisabled() || usingSafari) return;
            this.eInput.focus();
        });
        this.eInput.step = "any";
    }
    onWheel(e) {
        if (this.gos.getActiveDomElement() === this.eInput) e.preventDefault();
    }
    setMin(minDate) {
        var _a;
        const min = minDate instanceof Date ? (_a = $437b23f6a393c3bf$var$serialiseDate(minDate != null ? minDate : null, false)) != null ? _a : void 0 : minDate;
        if (this.min === min) return this;
        this.min = min;
        $437b23f6a393c3bf$var$addOrRemoveAttribute(this.eInput, "min", min);
        return this;
    }
    setMax(maxDate) {
        var _a;
        const max = maxDate instanceof Date ? (_a = $437b23f6a393c3bf$var$serialiseDate(maxDate != null ? maxDate : null, false)) != null ? _a : void 0 : maxDate;
        if (this.max === max) return this;
        this.max = max;
        $437b23f6a393c3bf$var$addOrRemoveAttribute(this.eInput, "max", max);
        return this;
    }
    setStep(step) {
        if (this.step === step) return this;
        this.step = step;
        $437b23f6a393c3bf$var$addOrRemoveAttribute(this.eInput, "step", step);
        return this;
    }
    getDate() {
        var _a;
        if (!this.eInput.validity.valid) return void 0;
        return (_a = $437b23f6a393c3bf$var$parseDateTimeFromString(this.getValue())) != null ? _a : void 0;
    }
    setDate(date, silent) {
        this.setValue($437b23f6a393c3bf$var$serialiseDate(date != null ? date : null, false), silent);
    }
};
// community-modules/core/src/widgets/agInputRange.ts
var $437b23f6a393c3bf$export$59243fd7dabffb56 = class extends $437b23f6a393c3bf$var$AgAbstractInputField {
    constructor(config){
        super(config, "ag-range-field", "range");
    }
    postConstruct() {
        super.postConstruct();
        const { min: min, max: max, step: step } = this.config;
        if (min != null) this.setMinValue(min);
        if (max != null) this.setMaxValue(max);
        this.setStep(step || 1);
    }
    addInputListeners() {
        this.addManagedListener(this.eInput, "input", (e)=>{
            const value = e.target.value;
            this.setValue(value);
        });
    }
    setMinValue(value) {
        this.min = value;
        this.eInput.setAttribute("min", value.toString());
        return this;
    }
    setMaxValue(value) {
        this.max = value;
        this.eInput.setAttribute("max", value.toString());
        return this;
    }
    setStep(value) {
        this.eInput.setAttribute("step", value.toString());
        return this;
    }
    setValue(value, silent) {
        if (this.min != null) value = Math.max(parseFloat(value), this.min).toString();
        if (this.max != null) value = Math.min(parseFloat(value), this.max).toString();
        const ret = super.setValue(value, silent);
        this.eInput.value = value;
        return ret;
    }
};
// community-modules/core/src/widgets/agRichSelectRow.ts
var $437b23f6a393c3bf$var$RichSelectRow = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(params, wrapperEl){
        super(/* html */ `<div class="ag-rich-select-row" role="presentation"></div>`);
        this.params = params;
        this.wrapperEl = wrapperEl;
    }
    postConstruct() {
        this.addManagedListener(this.getGui(), "click", this.onClick.bind(this));
    }
    setState(value) {
        let formattedValue = "";
        if (this.params.valueFormatter) formattedValue = this.params.valueFormatter(value);
        const rendererSuccessful = this.populateWithRenderer(value, formattedValue);
        if (!rendererSuccessful) this.populateWithoutRenderer(value, formattedValue);
        this.value = value;
    }
    highlightString(matchString) {
        const { parsedValue: parsedValue } = this;
        if (this.params.cellRenderer || !$437b23f6a393c3bf$var$exists(parsedValue)) return;
        let hasMatch = $437b23f6a393c3bf$var$exists(matchString);
        if (hasMatch) {
            const index = parsedValue == null ? void 0 : parsedValue.toLocaleLowerCase().indexOf(matchString.toLocaleLowerCase());
            if (index >= 0) {
                const highlightEndIndex = index + matchString.length;
                const startPart = $437b23f6a393c3bf$var$escapeString(parsedValue.slice(0, index), true);
                const highlightedPart = $437b23f6a393c3bf$var$escapeString(parsedValue.slice(index, highlightEndIndex), true);
                const endPart = $437b23f6a393c3bf$var$escapeString(parsedValue.slice(highlightEndIndex));
                this.renderValueWithoutRenderer(`${startPart}<span class="ag-rich-select-row-text-highlight">${highlightedPart}</span>${endPart}`);
            } else hasMatch = false;
        }
        if (!hasMatch) this.renderValueWithoutRenderer(parsedValue);
    }
    updateHighlighted(highlighted) {
        var _a;
        const eGui = this.getGui();
        const parentId = `ag-rich-select-row-${this.getCompId()}`;
        (_a = eGui.parentElement) == null || _a.setAttribute("id", parentId);
        if (highlighted) {
            const parentAriaEl = this.getParentComponent().getAriaElement();
            $437b23f6a393c3bf$var$setAriaActiveDescendant(parentAriaEl, parentId);
            this.wrapperEl.setAttribute("data-active-option", parentId);
        }
        $437b23f6a393c3bf$var$setAriaSelected(eGui.parentElement, highlighted);
        this.addOrRemoveCssClass("ag-rich-select-row-selected", highlighted);
    }
    populateWithoutRenderer(value, valueFormatted) {
        const eDocument = this.gos.getDocument();
        const eGui = this.getGui();
        const span = eDocument.createElement("span");
        span.style.overflow = "hidden";
        span.style.textOverflow = "ellipsis";
        const parsedValue = $437b23f6a393c3bf$var$escapeString($437b23f6a393c3bf$var$exists(valueFormatted) ? valueFormatted : value, true);
        this.parsedValue = $437b23f6a393c3bf$var$exists(parsedValue) ? parsedValue : null;
        eGui.appendChild(span);
        this.renderValueWithoutRenderer(parsedValue);
        this.setTooltip({
            newTooltipText: this.parsedValue,
            shouldDisplayTooltip: ()=>span.scrollWidth > span.clientWidth
        });
    }
    renderValueWithoutRenderer(value) {
        const span = this.getGui().querySelector("span");
        if (!span) return;
        span.innerHTML = $437b23f6a393c3bf$var$exists(value) ? value : "&nbsp;";
    }
    populateWithRenderer(value, valueFormatted) {
        let cellRendererPromise;
        let userCompDetails;
        if (this.params.cellRenderer) userCompDetails = this.userComponentFactory.getCellRendererDetails(this.params, {
            value: value,
            valueFormatted: valueFormatted,
            setTooltip: (value2, shouldDisplayTooltip)=>{
                this.setTooltip({
                    newTooltipText: value2,
                    shouldDisplayTooltip: shouldDisplayTooltip
                });
            }
        });
        if (userCompDetails) cellRendererPromise = userCompDetails.newAgStackInstance();
        if (cellRendererPromise) $437b23f6a393c3bf$var$bindCellRendererToHtmlElement(cellRendererPromise, this.getGui());
        if (cellRendererPromise) {
            cellRendererPromise.then((childComponent)=>{
                this.addDestroyFunc(()=>{
                    this.getContext().destroyBean(childComponent);
                });
            });
            return true;
        }
        return false;
    }
    onClick() {
        const parent = this.getParentComponent();
        const event = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_FIELD_PICKER_VALUE_SELECTED,
            fromEnterKey: false,
            value: this.value
        };
        parent == null || parent.dispatchEvent(event);
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("userComponentFactory")
], $437b23f6a393c3bf$var$RichSelectRow.prototype, "userComponentFactory", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$RichSelectRow.prototype, "postConstruct", 1);
// community-modules/core/src/widgets/virtualList.ts
var $437b23f6a393c3bf$var$_VirtualList = class _VirtualList extends $437b23f6a393c3bf$export$5a26e3abd1c845b6 {
    constructor(params){
        super(_VirtualList.getTemplate((params == null ? void 0 : params.cssIdentifier) || "default"));
        this.renderedRows = /* @__PURE__ */ new Map();
        this.rowHeight = 20;
        this.pageSize = -1;
        this.isScrolling = false;
        this.isHeightFromTheme = true;
        const { cssIdentifier: cssIdentifier = "default", ariaRole: ariaRole = "listbox", listName: listName } = params || {};
        this.cssIdentifier = cssIdentifier;
        this.ariaRole = ariaRole;
        this.listName = listName;
    }
    postConstruct() {
        this.addScrollListener();
        this.rowHeight = this.getItemHeight();
        this.addResizeObserver();
        this.initialiseTabGuard({
            onFocusIn: (e)=>this.onFocusIn(e),
            onFocusOut: (e)=>this.onFocusOut(e),
            focusInnerElement: (fromBottom)=>this.focusInnerElement(fromBottom),
            onTabKeyDown: (e)=>this.onTabKeyDown(e),
            handleKeyDown: (e)=>this.handleKeyDown(e)
        });
        this.setAriaProperties();
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_GRID_STYLES_CHANGED, this.onGridStylesChanged.bind(this));
    }
    onGridStylesChanged() {
        this.rowHeight = this.getItemHeight();
        this.refresh();
    }
    setAriaProperties() {
        const translate = this.localeService.getLocaleTextFunc();
        const listName = translate("ariaDefaultListName", this.listName || "List");
        const ariaEl = this.eContainer;
        $437b23f6a393c3bf$var$setAriaRole(ariaEl, this.ariaRole);
        $437b23f6a393c3bf$var$setAriaLabel(ariaEl, listName);
    }
    addResizeObserver() {
        const listener = ()=>this.animationFrameService.requestAnimationFrame(()=>this.drawVirtualRows());
        const destroyObserver = this.resizeObserverService.observeResize(this.getGui(), listener);
        this.addDestroyFunc(destroyObserver);
    }
    focusInnerElement(fromBottom) {
        this.focusRow(fromBottom ? this.model.getRowCount() - 1 : 0);
    }
    onFocusIn(e) {
        const target = e.target;
        if (target.classList.contains("ag-virtual-list-item")) this.lastFocusedRowIndex = $437b23f6a393c3bf$var$getAriaPosInSet(target) - 1;
    }
    onFocusOut(e) {
        if (!this.getFocusableElement().contains(e.relatedTarget)) this.lastFocusedRowIndex = null;
    }
    handleKeyDown(e) {
        switch(e.key){
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
                if (this.navigate(e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP)) e.preventDefault();
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_HOME:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_END:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_UP:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_DOWN:
                if (this.navigateToPage(e.key) !== null) e.preventDefault();
                break;
        }
    }
    onTabKeyDown(e) {
        if (this.navigate(e.shiftKey)) e.preventDefault();
        else {
            $437b23f6a393c3bf$var$stopPropagationForAgGrid(e);
            this.forceFocusOutOfContainer(e.shiftKey);
        }
    }
    navigate(up) {
        if (this.lastFocusedRowIndex == null) return false;
        const nextRow = this.lastFocusedRowIndex + (up ? -1 : 1);
        if (nextRow < 0 || nextRow >= this.model.getRowCount()) return false;
        this.focusRow(nextRow);
        return true;
    }
    navigateToPage(key, fromItem = "focused") {
        let hasFocus = false;
        if (fromItem === "focused") {
            fromItem = this.getLastFocusedRow();
            hasFocus = true;
        }
        const rowCount = this.model.getRowCount() - 1;
        let newIndex = -1;
        if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_HOME) newIndex = 0;
        else if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_END) newIndex = rowCount;
        else if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_DOWN) newIndex = Math.min(fromItem + this.pageSize, rowCount);
        else if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_UP) newIndex = Math.max(fromItem - this.pageSize, 0);
        if (newIndex === -1) return null;
        if (hasFocus) this.focusRow(newIndex);
        else this.ensureIndexVisible(newIndex);
        return newIndex;
    }
    getLastFocusedRow() {
        return this.lastFocusedRowIndex;
    }
    focusRow(rowNumber) {
        if (this.isScrolling) return;
        this.isScrolling = true;
        this.ensureIndexVisible(rowNumber);
        this.animationFrameService.requestAnimationFrame(()=>{
            this.isScrolling = false;
            if (!this.isAlive()) return;
            const renderedRow = this.renderedRows.get(rowNumber);
            if (renderedRow) renderedRow.eDiv.focus();
        });
    }
    getComponentAt(rowIndex) {
        const comp = this.renderedRows.get(rowIndex);
        return comp && comp.rowComponent;
    }
    forEachRenderedRow(func) {
        this.renderedRows.forEach((value, key)=>func(value.rowComponent, key));
    }
    static getTemplate(cssIdentifier) {
        return /* html */ `<div class="ag-virtual-list-viewport ag-${cssIdentifier}-virtual-list-viewport" role="presentation">
                <div class="ag-virtual-list-container ag-${cssIdentifier}-virtual-list-container" ref="eContainer"></div>
            </div>`;
    }
    getItemHeight() {
        if (!this.isHeightFromTheme) return this.rowHeight;
        return this.environment.getListItemHeight();
    }
    /**
   * Returns true if the view had to be scrolled, otherwise, false.
   */ ensureIndexVisible(index, scrollPartialIntoView = true) {
        const lastRow = this.model.getRowCount();
        if (typeof index !== "number" || index < 0 || index >= lastRow) {
            console.warn("AG Grid: invalid row index for ensureIndexVisible: " + index);
            return false;
        }
        const rowTopPixel = index * this.rowHeight;
        const rowBottomPixel = rowTopPixel + this.rowHeight;
        const eGui = this.getGui();
        const viewportTopPixel = eGui.scrollTop;
        const viewportHeight = eGui.offsetHeight;
        const viewportBottomPixel = viewportTopPixel + viewportHeight;
        const diff = scrollPartialIntoView ? 0 : this.rowHeight;
        const viewportScrolledPastRow = viewportTopPixel > rowTopPixel + diff;
        const viewportScrolledBeforeRow = viewportBottomPixel < rowBottomPixel - diff;
        if (viewportScrolledPastRow) {
            eGui.scrollTop = rowTopPixel;
            return true;
        }
        if (viewportScrolledBeforeRow) {
            const newScrollPosition = rowBottomPixel - viewportHeight;
            eGui.scrollTop = newScrollPosition;
            return true;
        }
        return false;
    }
    setComponentCreator(componentCreator) {
        this.componentCreator = componentCreator;
    }
    setComponentUpdater(componentUpdater) {
        this.componentUpdater = componentUpdater;
    }
    getRowHeight() {
        return this.rowHeight;
    }
    getScrollTop() {
        return this.getGui().scrollTop;
    }
    setRowHeight(rowHeight) {
        this.isHeightFromTheme = false;
        this.rowHeight = rowHeight;
        this.refresh();
    }
    refresh(softRefresh) {
        if (this.model == null || !this.isAlive()) return;
        const rowCount = this.model.getRowCount();
        this.eContainer.style.height = `${rowCount * this.rowHeight}px`;
        $437b23f6a393c3bf$var$waitUntil(()=>this.eContainer.clientHeight >= rowCount * this.rowHeight, ()=>{
            if (!this.isAlive()) return;
            if (this.canSoftRefresh(softRefresh)) this.drawVirtualRows(true);
            else {
                this.clearVirtualRows();
                this.drawVirtualRows();
            }
        });
    }
    canSoftRefresh(softRefresh) {
        return !!(softRefresh && this.renderedRows.size && typeof this.model.areRowsEqual === "function" && this.componentUpdater);
    }
    clearVirtualRows() {
        this.renderedRows.forEach((_2, rowIndex)=>this.removeRow(rowIndex));
    }
    drawVirtualRows(softRefresh) {
        if (!this.isAlive() || !this.model) return;
        const gui = this.getGui();
        const topPixel = gui.scrollTop;
        const bottomPixel = topPixel + gui.offsetHeight;
        const firstRow = Math.floor(topPixel / this.rowHeight);
        const lastRow = Math.floor(bottomPixel / this.rowHeight);
        this.pageSize = Math.floor((bottomPixel - topPixel) / this.rowHeight);
        this.ensureRowsRendered(firstRow, lastRow, softRefresh);
    }
    ensureRowsRendered(start, finish, softRefresh) {
        this.renderedRows.forEach((_2, rowIndex)=>{
            if ((rowIndex < start || rowIndex > finish) && rowIndex !== this.lastFocusedRowIndex) this.removeRow(rowIndex);
        });
        if (softRefresh) this.refreshRows();
        for(let rowIndex = start; rowIndex <= finish; rowIndex++){
            if (this.renderedRows.has(rowIndex)) continue;
            if (rowIndex < this.model.getRowCount()) this.insertRow(rowIndex);
        }
    }
    insertRow(rowIndex) {
        const value = this.model.getRow(rowIndex);
        const eDiv = document.createElement("div");
        eDiv.classList.add("ag-virtual-list-item", `ag-${this.cssIdentifier}-virtual-list-item`);
        $437b23f6a393c3bf$var$setAriaRole(eDiv, this.ariaRole === "tree" ? "treeitem" : "option");
        $437b23f6a393c3bf$var$setAriaSetSize(eDiv, this.model.getRowCount());
        $437b23f6a393c3bf$var$setAriaPosInSet(eDiv, rowIndex + 1);
        eDiv.setAttribute("tabindex", "-1");
        eDiv.style.height = `${this.rowHeight}px`;
        eDiv.style.top = `${this.rowHeight * rowIndex}px`;
        const rowComponent = this.componentCreator(value, eDiv);
        rowComponent.addGuiEventListener("focusin", ()=>this.lastFocusedRowIndex = rowIndex);
        eDiv.appendChild(rowComponent.getGui());
        if (this.renderedRows.has(rowIndex - 1)) this.renderedRows.get(rowIndex - 1).eDiv.insertAdjacentElement("afterend", eDiv);
        else if (this.renderedRows.has(rowIndex + 1)) this.renderedRows.get(rowIndex + 1).eDiv.insertAdjacentElement("beforebegin", eDiv);
        else this.eContainer.appendChild(eDiv);
        this.renderedRows.set(rowIndex, {
            rowComponent: rowComponent,
            eDiv: eDiv,
            value: value
        });
    }
    removeRow(rowIndex) {
        const component = this.renderedRows.get(rowIndex);
        this.eContainer.removeChild(component.eDiv);
        this.destroyBean(component.rowComponent);
        this.renderedRows.delete(rowIndex);
    }
    refreshRows() {
        const rowCount = this.model.getRowCount();
        this.renderedRows.forEach((row, rowIndex)=>{
            var _a, _b;
            if (rowIndex >= rowCount) this.removeRow(rowIndex);
            else {
                const newValue = this.model.getRow(rowIndex);
                if ((_b = (_a = this.model).areRowsEqual) == null ? void 0 : _b.call(_a, row.value, newValue)) this.componentUpdater(newValue, row.rowComponent);
                else this.removeRow(rowIndex);
            }
        });
    }
    addScrollListener() {
        this.addGuiEventListener("scroll", ()=>this.drawVirtualRows(), {
            passive: true
        });
    }
    setModel(model) {
        this.model = model;
    }
    getAriaElement() {
        return this.eContainer;
    }
    destroy() {
        if (!this.isAlive()) return;
        this.clearVirtualRows();
        super.destroy();
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("resizeObserverService")
], $437b23f6a393c3bf$var$_VirtualList.prototype, "resizeObserverService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("animationFrameService")
], $437b23f6a393c3bf$var$_VirtualList.prototype, "animationFrameService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eContainer")
], $437b23f6a393c3bf$var$_VirtualList.prototype, "eContainer", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$_VirtualList.prototype, "postConstruct", 1);
var $437b23f6a393c3bf$export$8aa850fa810c1c21 = $437b23f6a393c3bf$var$_VirtualList;
// community-modules/core/src/widgets/agRichSelect.ts
var $437b23f6a393c3bf$var$TEMPLATE2 = /* html */ `
    <div class="ag-picker-field" role="presentation">
        <div ref="eLabel"></div>
            <div ref="eWrapper" class="ag-wrapper ag-picker-field-wrapper ag-rich-select-value ag-picker-collapsed">
            <div ref="eDisplayField" class="ag-picker-field-display"></div>
            <ag-input-text-field ref="eInput" class="ag-rich-select-field-input"></ag-input-text-field>
            <div ref="eIcon" class="ag-picker-field-icon" aria-hidden="true"></div>
        </div>
    </div>`;
var $437b23f6a393c3bf$export$16d6ce2fe866e420 = class extends $437b23f6a393c3bf$export$1f14489b6fdeb99b {
    constructor(config){
        var _a, _b;
        super($437b23f6a393c3bf$var$__spreadProps($437b23f6a393c3bf$var$__spreadValues({
            pickerAriaLabelKey: "ariaLabelRichSelectField",
            pickerAriaLabelValue: "Rich Select Field",
            pickerType: "ag-list",
            className: "ag-rich-select",
            pickerIcon: "smallDown",
            ariaRole: "combobox",
            template: (_a = config == null ? void 0 : config.template) != null ? _a : $437b23f6a393c3bf$var$TEMPLATE2,
            modalPicker: false
        }, config), {
            // maxPickerHeight needs to be set after expanding `config`
            maxPickerHeight: (_b = config == null ? void 0 : config.maxPickerHeight) != null ? _b : "calc(var(--ag-row-height) * 6.5)"
        }));
        this.searchString = "";
        this.highlightedItem = -1;
        this.lastRowHovered = -1;
        this.searchStringCreator = null;
        const { cellRowHeight: cellRowHeight, value: value, valueList: valueList, searchStringCreator: searchStringCreator } = config || {};
        if (cellRowHeight != null) this.cellRowHeight = cellRowHeight;
        if (value !== void 0) this.value = value;
        if (valueList != null) this.values = valueList;
        if (searchStringCreator) this.searchStringCreator = searchStringCreator;
    }
    postConstruct() {
        super.postConstruct();
        this.createLoadingElement();
        this.createListComponent();
        const { allowTyping: allowTyping, placeholder: placeholder } = this.config;
        if (allowTyping) {
            this.eInput.setAutoComplete(false).setInputPlaceholder(placeholder);
            this.eDisplayField.classList.add("ag-hidden");
        } else this.eInput.setDisplayed(false);
        this.eWrapper.tabIndex = this.gos.get("tabIndex");
        const { searchDebounceDelay: searchDebounceDelay = 300 } = this.config;
        this.clearSearchString = $437b23f6a393c3bf$var$debounce(this.clearSearchString, searchDebounceDelay);
        this.renderSelectedValue();
        if (allowTyping) {
            this.eInput.onValueChange((value)=>this.searchTextFromString(value));
            this.addManagedListener(this.eWrapper, "focus", this.onWrapperFocus.bind(this));
        }
        this.addManagedListener(this.eWrapper, "focusout", this.onWrapperFocusOut.bind(this));
    }
    createLoadingElement() {
        const eDocument = this.gos.getDocument();
        const translate = this.localeService.getLocaleTextFunc();
        const el = eDocument.createElement("div");
        el.classList.add("ag-loading-text");
        el.innerText = translate("loadingOoo", "Loading...");
        this.eLoading = el;
    }
    createListComponent() {
        this.listComponent = this.createBean(new $437b23f6a393c3bf$export$8aa850fa810c1c21({
            cssIdentifier: "rich-select"
        }));
        this.listComponent.setComponentCreator(this.createRowComponent.bind(this));
        const componentUpdater = (item, component)=>{};
        this.listComponent.setComponentUpdater(componentUpdater);
        this.listComponent.setParentComponent(this);
        this.addManagedListener(this.listComponent, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_FIELD_PICKER_VALUE_SELECTED, (e)=>{
            this.onListValueSelected(e.value, e.fromEnterKey);
        });
        const { cellRowHeight: cellRowHeight } = this;
        if (cellRowHeight) this.listComponent.setRowHeight(cellRowHeight);
        const eListGui = this.listComponent.getGui();
        const eListAriaEl = this.listComponent.getAriaElement();
        this.addManagedListener(eListGui, "mousemove", this.onPickerMouseMove.bind(this));
        this.addManagedListener(eListGui, "mousedown", (e)=>e.preventDefault());
        eListGui.classList.add("ag-rich-select-list");
        const listId = `ag-rich-select-list-${this.listComponent.getCompId()}`;
        eListAriaEl.setAttribute("id", listId);
        const translate = this.localeService.getLocaleTextFunc();
        const ariaLabel = translate(this.config.pickerAriaLabelKey, this.config.pickerAriaLabelValue);
        $437b23f6a393c3bf$var$setAriaLabel(eListAriaEl, ariaLabel);
        $437b23f6a393c3bf$var$setAriaControls(this.eWrapper, eListAriaEl);
    }
    renderSelectedValue() {
        const { value: value, eDisplayField: eDisplayField, config: config } = this;
        const { allowTyping: allowTyping, initialInputValue: initialInputValue } = this.config;
        const valueFormatted = this.config.valueFormatter ? this.config.valueFormatter(value) : value;
        if (allowTyping) {
            this.eInput.setValue(initialInputValue != null ? initialInputValue : valueFormatted);
            return;
        }
        let userCompDetails;
        if (config.cellRenderer) userCompDetails = this.userComponentFactory.getCellRendererDetails(this.config, {
            value: value,
            valueFormatted: valueFormatted
        });
        let userCompDetailsPromise;
        if (userCompDetails) userCompDetailsPromise = userCompDetails.newAgStackInstance();
        if (userCompDetailsPromise) {
            $437b23f6a393c3bf$var$clearElement(eDisplayField);
            $437b23f6a393c3bf$var$bindCellRendererToHtmlElement(userCompDetailsPromise, eDisplayField);
            userCompDetailsPromise.then((renderer)=>{
                this.addDestroyFunc(()=>this.getContext().destroyBean(renderer));
            });
        } else {
            if ($437b23f6a393c3bf$var$exists(this.value)) {
                eDisplayField.innerText = valueFormatted;
                eDisplayField.classList.remove("ag-display-as-placeholder");
            } else {
                const { placeholder: placeholder } = config;
                if ($437b23f6a393c3bf$var$exists(placeholder)) {
                    eDisplayField.innerHTML = `${$437b23f6a393c3bf$var$escapeString(placeholder)}`;
                    eDisplayField.classList.add("ag-display-as-placeholder");
                } else $437b23f6a393c3bf$var$clearElement(eDisplayField);
            }
            this.setTooltip({
                newTooltipText: valueFormatted != null ? valueFormatted : null,
                shouldDisplayTooltip: ()=>this.eDisplayField.scrollWidth > this.eDisplayField.clientWidth
            });
        }
    }
    getCurrentValueIndex() {
        const { currentList: currentList, value: value } = this;
        if (value == null || !currentList) return -1;
        for(let i = 0; i < currentList.length; i++){
            if (currentList[i] === value) return i;
        }
        return -1;
    }
    highlightFilterMatch() {
        var _a;
        (_a = this.listComponent) == null || _a.forEachRenderedRow((cmp, idx)=>{
            cmp.highlightString(this.searchString);
        });
    }
    highlightSelectedValue(index) {
        var _a;
        if (index == null) index = this.getCurrentValueIndex();
        this.highlightedItem = index;
        (_a = this.listComponent) == null || _a.forEachRenderedRow((cmp, idx)=>{
            const highlighted = index === -1 ? false : this.highlightedItem === idx;
            cmp.updateHighlighted(highlighted);
        });
    }
    setRowHeight(height) {
        if (height !== this.cellRowHeight) this.cellRowHeight = height;
        if (this.listComponent) this.listComponent.setRowHeight(height);
    }
    createPickerComponent() {
        const { values: values2 } = this;
        if (values2) this.setValueList({
            valueList: values2
        });
        return this.listComponent;
    }
    setSearchStringCreator(searchStringFn) {
        this.searchStringCreator = searchStringFn;
    }
    setValueList(params) {
        const { valueList: valueList, refresh: refresh } = params;
        if (!this.listComponent) return;
        if (this.currentList === valueList) return;
        this.currentList = valueList;
        this.listComponent.setModel({
            getRowCount: ()=>valueList.length,
            getRow: (index)=>valueList[index],
            areRowsEqual: (oldRow, newRow)=>oldRow === newRow
        });
        if (refresh) {
            if (!this.values) {
                this.values = valueList;
                if (this.isPickerDisplayed) this.showCurrentValueInPicker();
            } else this.listComponent.refresh(true);
        }
    }
    showPicker() {
        super.showPicker();
        this.showCurrentValueInPicker();
        this.displayOrHidePicker();
    }
    showCurrentValueInPicker() {
        var _a, _b;
        if (!this.listComponent) return;
        if (!this.currentList) {
            if (this.isPickerDisplayed && this.eLoading) this.listComponent.appendChild(this.eLoading);
            return;
        }
        if ((_a = this.eLoading) == null ? void 0 : _a.offsetParent) (_b = this.eLoading.parentElement) == null || _b.removeChild(this.eLoading);
        const currentValueIndex = this.getCurrentValueIndex();
        if (currentValueIndex !== -1) {
            this.listComponent.refresh();
            this.listComponent.ensureIndexVisible(currentValueIndex);
            this.listComponent.refresh(true);
            this.highlightSelectedValue(currentValueIndex);
        } else this.listComponent.refresh();
    }
    beforeHidePicker() {
        this.highlightedItem = -1;
        super.beforeHidePicker();
    }
    onWrapperFocus() {
        if (!this.eInput) return;
        const focusableEl = this.eInput.getFocusableElement();
        focusableEl.focus();
        focusableEl.select();
    }
    onWrapperFocusOut(e) {
        if (!this.eWrapper.contains(e.relatedTarget)) this.hidePicker();
    }
    buildSearchStringFromKeyboardEvent(searchKey) {
        let { key: key } = searchKey;
        if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.BACKSPACE) {
            this.searchString = this.searchString.slice(0, -1);
            key = "";
        } else if (!$437b23f6a393c3bf$var$isEventFromPrintableCharacter(searchKey)) return;
        searchKey.preventDefault();
        this.searchTextFromCharacter(key);
    }
    searchTextFromCharacter(char) {
        this.searchString += char;
        this.runSearch();
        this.clearSearchString();
    }
    searchTextFromString(str) {
        if (str == null) str = "";
        this.searchString = str;
        this.runSearch();
    }
    buildSearchStrings(values2) {
        const { valueFormatter: valueFormatter = (value)=>value } = this.config;
        let searchStrings;
        if (typeof values2[0] === "number" || typeof values2[0] === "string") searchStrings = values2.map((v)=>valueFormatter(v));
        else if (typeof values2[0] === "object" && this.searchStringCreator) searchStrings = this.searchStringCreator(values2);
        return searchStrings;
    }
    getSuggestionsAndFilteredValues(searchValue, valueList) {
        let suggestions = [];
        let filteredValues = [];
        if (!searchValue.length) return {
            suggestions: suggestions,
            filteredValues: filteredValues
        };
        const { searchType: searchType = "fuzzy", filterList: filterList } = this.config;
        if (searchType === "fuzzy") {
            const fuzzySearchResult = $437b23f6a393c3bf$var$fuzzySuggestions(this.searchString, valueList, true);
            suggestions = fuzzySearchResult.values;
            const indices = fuzzySearchResult.indices;
            if (filterList && indices.length) for(let i = 0; i < indices.length; i++)filteredValues.push(this.values[indices[i]]);
        } else suggestions = valueList.filter((val, idx)=>{
            const currentValue = val.toLocaleLowerCase();
            const valueToMatch = this.searchString.toLocaleLowerCase();
            const isMatch = searchType === "match" ? currentValue.startsWith(valueToMatch) : currentValue.indexOf(valueToMatch) !== -1;
            if (filterList && isMatch) filteredValues.push(this.values[idx]);
            return isMatch;
        });
        return {
            suggestions: suggestions,
            filteredValues: filteredValues
        };
    }
    filterListModel(filteredValues) {
        const { filterList: filterList } = this.config;
        if (!filterList) return;
        this.setValueList({
            valueList: filteredValues,
            refresh: true
        });
        this.alignPickerToComponent();
    }
    runSearch() {
        var _a, _b;
        const { values: values2 } = this;
        const searchStrings = this.buildSearchStrings(values2);
        if (!searchStrings) {
            this.highlightSelectedValue(-1);
            return;
        }
        const { suggestions: suggestions, filteredValues: filteredValues } = this.getSuggestionsAndFilteredValues(this.searchString, searchStrings);
        const { filterList: filterList, highlightMatch: highlightMatch, searchType: searchType = "fuzzy" } = this.config;
        const filterValueLen = filteredValues.length;
        const shouldFilter = !!(filterList && this.searchString !== "");
        this.filterListModel(shouldFilter ? filteredValues : values2);
        if (suggestions.length) {
            const topSuggestionIndex = shouldFilter ? 0 : searchStrings.indexOf(suggestions[0]);
            this.selectListItem(topSuggestionIndex);
        } else {
            this.highlightSelectedValue(-1);
            if (!shouldFilter || filterValueLen) (_a = this.listComponent) == null || _a.ensureIndexVisible(0);
            else if (shouldFilter) {
                this.getAriaElement().removeAttribute("data-active-option");
                const eListAriaEl = (_b = this.listComponent) == null ? void 0 : _b.getAriaElement();
                if (eListAriaEl) $437b23f6a393c3bf$var$setAriaActiveDescendant(eListAriaEl, null);
            }
        }
        if (highlightMatch && searchType !== "fuzzy") this.highlightFilterMatch();
        this.displayOrHidePicker();
    }
    displayOrHidePicker() {
        var _a;
        const eListGui = (_a = this.listComponent) == null ? void 0 : _a.getGui();
        const toggleValue = this.currentList ? this.currentList.length === 0 : false;
        eListGui == null || eListGui.classList.toggle("ag-hidden", toggleValue);
    }
    clearSearchString() {
        this.searchString = "";
    }
    selectListItem(index, preventUnnecessaryScroll) {
        if (!this.isPickerDisplayed || !this.currentList || !this.listComponent || index < 0 || index >= this.currentList.length) return;
        const wasScrolled = this.listComponent.ensureIndexVisible(index, !preventUnnecessaryScroll);
        if (wasScrolled && !preventUnnecessaryScroll) this.listComponent.refresh(true);
        this.highlightSelectedValue(index);
    }
    setValue(value, silent, fromPicker) {
        const index = this.currentList ? this.currentList.indexOf(value) : -1;
        if (index === -1) return this;
        this.value = value;
        if (!fromPicker) this.selectListItem(index);
        this.renderSelectedValue();
        return super.setValue(value, silent);
    }
    createRowComponent(value) {
        const row = new $437b23f6a393c3bf$var$RichSelectRow(this.config, this.eWrapper);
        row.setParentComponent(this.listComponent);
        this.getContext().createBean(row);
        row.setState(value);
        const { highlightMatch: highlightMatch, searchType: searchType = "fuzzy" } = this.config;
        if (highlightMatch && searchType !== "fuzzy") row.highlightString(this.searchString);
        return row;
    }
    getRowForMouseEvent(e) {
        const { listComponent: listComponent } = this;
        if (!listComponent) return -1;
        const eGui = listComponent == null ? void 0 : listComponent.getGui();
        const rect = eGui.getBoundingClientRect();
        const scrollTop = listComponent.getScrollTop();
        const mouseY = e.clientY - rect.top + scrollTop;
        return Math.floor(mouseY / listComponent.getRowHeight());
    }
    onPickerMouseMove(e) {
        if (!this.listComponent) return;
        const row = this.getRowForMouseEvent(e);
        if (row !== -1 && row != this.lastRowHovered) {
            this.lastRowHovered = row;
            this.selectListItem(row, true);
        }
    }
    onNavigationKeyDown(event, key) {
        event.preventDefault();
        const isDown = key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN;
        if (!this.isPickerDisplayed && isDown) {
            this.showPicker();
            return;
        }
        const oldIndex = this.highlightedItem;
        const diff = isDown ? 1 : -1;
        const newIndex = oldIndex === -1 ? 0 : oldIndex + diff;
        this.selectListItem(newIndex);
    }
    onPageNavigation(key) {
        var _a;
        if (!this.isPickerDisplayed) return;
        const newIndex = (_a = this.listComponent) == null ? void 0 : _a.navigateToPage(key, this.highlightedItem);
        if (newIndex != null) this.animationFrameService.requestAnimationFrame(()=>{
            if (!this.isAlive()) return null;
            this.highlightSelectedValue(newIndex);
        });
    }
    onEnterKeyDown(e) {
        if (!this.isPickerDisplayed) return;
        e.preventDefault();
        if (this.currentList) this.onListValueSelected(this.currentList[this.highlightedItem], true);
    }
    onTabKeyDown() {
        if (!this.isPickerDisplayed || !this.currentList) return;
        this.setValue(this.currentList[this.highlightedItem], false, true);
    }
    onListValueSelected(value, fromEnterKey) {
        this.setValue(value, false, true);
        this.dispatchPickerEvent(value, fromEnterKey);
        this.hidePicker();
    }
    dispatchPickerEvent(value, fromEnterKey) {
        const event = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_FIELD_PICKER_VALUE_SELECTED,
            fromEnterKey: fromEnterKey,
            value: value
        };
        this.dispatchEvent(event);
    }
    getFocusableElement() {
        const { allowTyping: allowTyping } = this.config;
        if (allowTyping) return this.eInput.getFocusableElement();
        return super.getFocusableElement();
    }
    onKeyDown(event) {
        const key = event.key;
        const { allowTyping: allowTyping } = this.config;
        switch(key){
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT:
                if (!allowTyping) event.preventDefault();
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_HOME:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_END:
                if (allowTyping) {
                    event.preventDefault();
                    const inputEl = this.eInput.getInputElement();
                    const target = key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_HOME ? 0 : inputEl.value.length;
                    inputEl.setSelectionRange(target, target);
                    break;
                }
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_UP:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_DOWN:
                event.preventDefault();
                this.onPageNavigation(key);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
                this.onNavigationKeyDown(event, key);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ESCAPE:
                if (this.isPickerDisplayed) {
                    if ($437b23f6a393c3bf$var$isVisible(this.listComponent.getGui())) {
                        event.preventDefault();
                        $437b23f6a393c3bf$var$stopPropagationForAgGrid(event);
                    }
                    this.hidePicker();
                }
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER:
                this.onEnterKeyDown(event);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB:
                this.onTabKeyDown();
                break;
            default:
                if (!allowTyping) this.buildSearchStringFromKeyboardEvent(event);
        }
    }
    destroy() {
        if (this.listComponent) {
            this.destroyBean(this.listComponent);
            this.listComponent = void 0;
        }
        this.eLoading = void 0;
        super.destroy();
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("userComponentFactory")
], $437b23f6a393c3bf$export$16d6ce2fe866e420.prototype, "userComponentFactory", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("animationFrameService")
], $437b23f6a393c3bf$export$16d6ce2fe866e420.prototype, "animationFrameService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eInput")
], $437b23f6a393c3bf$export$16d6ce2fe866e420.prototype, "eInput", 2);
// community-modules/core/src/widgets/agSlider.ts
var $437b23f6a393c3bf$var$_AgSlider = class _AgSlider extends $437b23f6a393c3bf$export$d72ea6e1c340e03b {
    constructor(config){
        super(config, _AgSlider.TEMPLATE);
        this.labelAlignment = "top";
    }
    init() {
        this.eSlider.addCssClass("ag-slider-field");
        const { minValue: minValue, maxValue: maxValue, textFieldWidth: textFieldWidth, step: step, value: value, onValueChange: onValueChange } = this.config;
        if (minValue != null) this.setMinValue(minValue);
        if (maxValue != null) this.setMaxValue(maxValue);
        if (textFieldWidth != null) this.setTextFieldWidth(textFieldWidth);
        if (step != null) this.setStep(step);
        if (value != null) this.setValue(value);
        if (onValueChange != null) this.onValueChange(onValueChange);
    }
    onValueChange(callbackFn) {
        const eventChanged = $437b23f6a393c3bf$export$ada873a34909da65.EVENT_FIELD_VALUE_CHANGED;
        this.addManagedListener(this.eText, eventChanged, ()=>{
            const textValue = parseFloat(this.eText.getValue());
            this.eSlider.setValue(textValue.toString(), true);
            callbackFn(textValue || 0);
        });
        this.addManagedListener(this.eSlider, eventChanged, ()=>{
            const sliderValue = this.eSlider.getValue();
            this.eText.setValue(sliderValue, true);
            callbackFn(parseFloat(sliderValue));
        });
        return this;
    }
    setSliderWidth(width) {
        this.eSlider.setWidth(width);
        return this;
    }
    setTextFieldWidth(width) {
        this.eText.setWidth(width);
        return this;
    }
    setMinValue(minValue) {
        this.eSlider.setMinValue(minValue);
        this.eText.setMin(minValue);
        return this;
    }
    setMaxValue(maxValue) {
        this.eSlider.setMaxValue(maxValue);
        this.eText.setMax(maxValue);
        return this;
    }
    getValue() {
        return this.eText.getValue();
    }
    setValue(value, silent) {
        if (this.getValue() === value) return this;
        this.eText.setValue(value, true);
        this.eSlider.setValue(value, true);
        if (!silent) this.dispatchEvent({
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_FIELD_VALUE_CHANGED
        });
        return this;
    }
    setStep(step) {
        this.eSlider.setStep(step);
        this.eText.setStep(step);
        return this;
    }
};
$437b23f6a393c3bf$var$_AgSlider.TEMPLATE = /* html */ `<div class="ag-slider">
            <label ref="eLabel"></label>
            <div class="ag-wrapper ag-slider-wrapper">
                <ag-input-range ref="eSlider"></ag-input-range>
                <ag-input-number-field ref="eText"></ag-input-number-field>
            </div>
        </div>`;
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eLabel")
], $437b23f6a393c3bf$var$_AgSlider.prototype, "eLabel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eSlider")
], $437b23f6a393c3bf$var$_AgSlider.prototype, "eSlider", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eText")
], $437b23f6a393c3bf$var$_AgSlider.prototype, "eText", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$_AgSlider.prototype, "init", 1);
var $437b23f6a393c3bf$export$393c85b733ccd61d = $437b23f6a393c3bf$var$_AgSlider;
// community-modules/core/src/widgets/agGroupComponent.ts
var $437b23f6a393c3bf$var$_AgGroupComponent = class _AgGroupComponent extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(params = {}){
        super(_AgGroupComponent.getTemplate(params));
        this.params = params;
        this.suppressEnabledCheckbox = true;
        this.suppressToggleExpandOnEnableChange = false;
        const { enabled: enabled, items: items, suppressEnabledCheckbox: suppressEnabledCheckbox, expanded: expanded, suppressToggleExpandOnEnableChange: suppressToggleExpandOnEnableChange, useToggle: toggleMode } = params;
        this.cssIdentifier = params.cssIdentifier || "default";
        this.enabled = enabled != null ? enabled : true;
        this.items = items || [];
        this.useToggle = toggleMode != null ? toggleMode : false;
        this.alignItems = params.alignItems || "center";
        this.expanded = expanded == null ? true : expanded;
        if (suppressEnabledCheckbox != null) this.suppressEnabledCheckbox = suppressEnabledCheckbox;
        if (suppressToggleExpandOnEnableChange != null) this.suppressToggleExpandOnEnableChange = suppressToggleExpandOnEnableChange;
    }
    static getTemplate(params) {
        const cssIdentifier = params.cssIdentifier || "default";
        const direction = params.direction || "vertical";
        return /* html */ `
            <div class="ag-group ag-${cssIdentifier}-group" role="presentation">
                <div ref="eToolbar" class="ag-group-toolbar ag-${cssIdentifier}-group-toolbar">
                    <ag-checkbox ref="cbGroupEnabled"></ag-checkbox>
                </div>
                <div ref="eContainer" class="ag-group-container ag-group-container-${direction} ag-${cssIdentifier}-group-container"></div>
            </div>
        `;
    }
    postConstruct() {
        this.setupTitleBar();
        if (this.items.length) {
            const initialItems = this.items;
            this.items = [];
            this.addItems(initialItems);
        }
        const localeTextFunc = this.localeService.getLocaleTextFunc();
        this.cbGroupEnabled.setLabel(localeTextFunc("enabled", "Enabled"));
        if (this.enabled) this.setEnabled(this.enabled, void 0, true);
        this.setAlignItems(this.alignItems);
        const { onEnableChange: onEnableChange, suppressOpenCloseIcons: suppressOpenCloseIcons } = this.params;
        this.hideEnabledCheckbox(this.suppressEnabledCheckbox);
        this.hideOpenCloseIcons(suppressOpenCloseIcons != null ? suppressOpenCloseIcons : false);
        this.refreshChildDisplay();
        $437b23f6a393c3bf$var$setDisplayed(this.eContainer, this.expanded);
        this.cbGroupEnabled.onValueChange((newSelection)=>{
            this.setEnabled(newSelection, true, this.suppressToggleExpandOnEnableChange);
            this.dispatchEnableChangeEvent(newSelection);
        });
        if (onEnableChange != null) this.onEnableChange(onEnableChange);
    }
    refreshChildDisplay() {
        var _a;
        $437b23f6a393c3bf$var$setDisplayed(this.eToolbar, this.expanded && !this.suppressEnabledCheckbox);
        (_a = this.eTitleBar) == null || _a.refreshOnExpand(this.expanded);
    }
    isExpanded() {
        return this.expanded;
    }
    setAlignItems(alignment) {
        if (this.alignItems !== alignment) this.removeCssClass(`ag-group-item-alignment-${this.alignItems}`);
        this.alignItems = alignment;
        const newCls = `ag-group-item-alignment-${this.alignItems}`;
        this.addCssClass(newCls);
        return this;
    }
    toggleGroupExpand(expanded) {
        var _a;
        let silent = false;
        if (((_a = this.eTitleBar) == null ? void 0 : _a.isSuppressCollapse()) && !this.useToggle) {
            expanded = true;
            silent = true;
        } else {
            expanded = expanded != null ? expanded : !this.expanded;
            if (this.expanded === expanded) return this;
        }
        this.expanded = expanded;
        this.refreshChildDisplay();
        $437b23f6a393c3bf$var$setDisplayed(this.eContainer, expanded);
        if (!silent) this.dispatchEvent({
            type: expanded ? _AgGroupComponent.EVENT_EXPANDED : _AgGroupComponent.EVENT_COLLAPSED
        });
        return this;
    }
    addItems(items) {
        items.forEach((item)=>this.addItem(item));
    }
    prependItem(item) {
        this.insertItem(item, true);
    }
    addItem(item) {
        this.insertItem(item, false);
    }
    insertItem(item, prepend) {
        const container = this.eContainer;
        const el = item instanceof $437b23f6a393c3bf$export$16fa2f45be04daa8 ? item.getGui() : item;
        el.classList.add("ag-group-item", `ag-${this.cssIdentifier}-group-item`);
        if (prepend) {
            container.insertAdjacentElement("afterbegin", el);
            this.items.unshift(el);
        } else {
            container.appendChild(el);
            this.items.push(el);
        }
    }
    hideItem(hide, index) {
        const itemToHide = this.items[index];
        $437b23f6a393c3bf$var$setDisplayed(itemToHide, !hide);
    }
    getItemIndex(item) {
        const el = item instanceof $437b23f6a393c3bf$export$16fa2f45be04daa8 ? item.getGui() : item;
        return this.items.indexOf(el);
    }
    setTitle(title) {
        var _a;
        (_a = this.eTitleBar) == null || _a.setTitle(title);
        return this;
    }
    addTitleBarWidget(el) {
        var _a;
        (_a = this.eTitleBar) == null || _a.addWidget(el);
        return this;
    }
    addCssClassToTitleBar(cssClass) {
        var _a;
        (_a = this.eTitleBar) == null || _a.addCssClass(cssClass);
    }
    dispatchEnableChangeEvent(enabled) {
        const event = {
            type: _AgGroupComponent.EVENT_ENABLE_CHANGE,
            enabled: enabled
        };
        this.dispatchEvent(event);
    }
    setEnabled(enabled, skipToggle, skipExpand) {
        var _a;
        this.enabled = enabled;
        this.refreshDisabledStyles();
        if (!skipExpand) this.toggleGroupExpand(enabled);
        if (!skipToggle) {
            this.cbGroupEnabled.setValue(enabled);
            (_a = this.eToggle) == null || _a.setValue(enabled);
        }
        return this;
    }
    isEnabled() {
        return this.enabled;
    }
    onEnableChange(callbackFn) {
        this.addManagedListener(this, _AgGroupComponent.EVENT_ENABLE_CHANGE, (event)=>callbackFn(event.enabled));
        return this;
    }
    hideEnabledCheckbox(hide) {
        this.suppressEnabledCheckbox = hide;
        this.refreshChildDisplay();
        this.refreshDisabledStyles();
        return this;
    }
    hideOpenCloseIcons(hide) {
        var _a;
        (_a = this.eTitleBar) == null || _a.hideOpenCloseIcons(hide);
        return this;
    }
    refreshDisabledStyles() {
        var _a;
        const disabled = !this.enabled;
        this.eContainer.classList.toggle("ag-disabled", disabled);
        (_a = this.eTitleBar) == null || _a.refreshDisabledStyles(this.suppressEnabledCheckbox && disabled);
        this.eContainer.classList.toggle("ag-disabled-group-container", disabled);
    }
    setupTitleBar() {
        const titleBar = this.useToggle ? this.createToggleTitleBar() : this.createDefaultTitleBar();
        this.eToolbar.insertAdjacentElement("beforebegin", titleBar.getGui());
    }
    createDefaultTitleBar() {
        const titleBar = this.createManagedBean(new $437b23f6a393c3bf$var$DefaultTitleBar(this.params));
        this.eTitleBar = titleBar;
        titleBar.refreshOnExpand(this.expanded);
        this.addManagedListener(titleBar, $437b23f6a393c3bf$var$DefaultTitleBar.EVENT_EXPAND_CHANGED, (event)=>this.toggleGroupExpand(event.expanded));
        return titleBar;
    }
    createToggleTitleBar() {
        var _a;
        const eToggle = this.createManagedBean(new $437b23f6a393c3bf$export$167b21bf245ce0bf({
            value: this.enabled,
            label: this.params.title,
            labelAlignment: "left",
            labelWidth: "flex",
            onValueChange: (enabled)=>{
                this.setEnabled(enabled, true);
                this.dispatchEnableChangeEvent(enabled);
            }
        }));
        eToggle.addCssClass("ag-group-title-bar");
        eToggle.addCssClass(`ag-${(_a = this.params.cssIdentifier) != null ? _a : "default"}-group-title-bar ag-unselectable`);
        this.eToggle = eToggle;
        this.toggleGroupExpand(this.enabled);
        return eToggle;
    }
};
$437b23f6a393c3bf$var$_AgGroupComponent.EVENT_EXPANDED = "expanded";
$437b23f6a393c3bf$var$_AgGroupComponent.EVENT_COLLAPSED = "collapsed";
$437b23f6a393c3bf$var$_AgGroupComponent.EVENT_ENABLE_CHANGE = "enableChange";
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eToolbar")
], $437b23f6a393c3bf$var$_AgGroupComponent.prototype, "eToolbar", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("cbGroupEnabled")
], $437b23f6a393c3bf$var$_AgGroupComponent.prototype, "cbGroupEnabled", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eContainer")
], $437b23f6a393c3bf$var$_AgGroupComponent.prototype, "eContainer", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$_AgGroupComponent.prototype, "postConstruct", 1);
var $437b23f6a393c3bf$export$ad535c478b02d5b4 = $437b23f6a393c3bf$var$_AgGroupComponent;
var $437b23f6a393c3bf$var$TITLE_BAR_DISABLED_CLASS = "ag-disabled-group-title-bar";
var $437b23f6a393c3bf$var$_DefaultTitleBar = class _DefaultTitleBar extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(params = {}){
        super(_DefaultTitleBar.getTemplate(params));
        this.suppressOpenCloseIcons = false;
        const { title: title, suppressOpenCloseIcons: suppressOpenCloseIcons } = params;
        if (!!title && title.length > 0) this.title = title;
        if (suppressOpenCloseIcons != null) this.suppressOpenCloseIcons = suppressOpenCloseIcons;
    }
    static getTemplate(params) {
        var _a;
        const cssIdentifier = (_a = params.cssIdentifier) != null ? _a : "default";
        return /* html */ `
            <div class="ag-group-title-bar ag-${cssIdentifier}-group-title-bar ag-unselectable" role="button">
                <span class="ag-group-title-bar-icon ag-${cssIdentifier}-group-title-bar-icon" ref="eGroupOpenedIcon" role="presentation"></span>
                <span class="ag-group-title-bar-icon ag-${cssIdentifier}-group-title-bar-icon" ref="eGroupClosedIcon" role="presentation"></span>
                <span ref="eTitle" class="ag-group-title ag-${cssIdentifier}-group-title"></span>
            </div>
        `;
    }
    postConstruct() {
        this.setTitle(this.title);
        this.hideOpenCloseIcons(this.suppressOpenCloseIcons);
        this.setupExpandContract();
    }
    setupExpandContract() {
        this.eGroupClosedIcon.appendChild($437b23f6a393c3bf$var$createIcon("columnSelectClosed", this.gos, null));
        this.eGroupOpenedIcon.appendChild($437b23f6a393c3bf$var$createIcon("columnSelectOpen", this.gos, null));
        this.addManagedListener(this.getGui(), "click", ()=>this.dispatchExpandChanged());
        this.addManagedListener(this.getGui(), "keydown", (e)=>{
            switch(e.key){
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER:
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.SPACE:
                    e.preventDefault();
                    this.dispatchExpandChanged();
                    break;
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT:
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT:
                    e.preventDefault();
                    this.dispatchExpandChanged(e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT);
                    break;
            }
        });
    }
    refreshOnExpand(expanded) {
        this.refreshAriaStatus(expanded);
        this.refreshOpenCloseIcons(expanded);
    }
    refreshAriaStatus(expanded) {
        if (!this.suppressOpenCloseIcons) $437b23f6a393c3bf$var$setAriaExpanded(this.getGui(), expanded);
    }
    refreshOpenCloseIcons(expanded) {
        const showIcon = !this.suppressOpenCloseIcons;
        $437b23f6a393c3bf$var$setDisplayed(this.eGroupOpenedIcon, showIcon && expanded);
        $437b23f6a393c3bf$var$setDisplayed(this.eGroupClosedIcon, showIcon && !expanded);
    }
    isSuppressCollapse() {
        return this.suppressOpenCloseIcons;
    }
    dispatchExpandChanged(expanded) {
        const event = {
            type: _DefaultTitleBar.EVENT_EXPAND_CHANGED,
            expanded: expanded
        };
        this.dispatchEvent(event);
    }
    setTitle(title) {
        const eGui = this.getGui();
        const hasTitle = !!title && title.length > 0;
        title = hasTitle ? title : void 0;
        this.eTitle.textContent = title != null ? title : "";
        $437b23f6a393c3bf$var$setDisplayed(eGui, hasTitle);
        if (title !== this.title) this.title = title;
        const disabled = eGui.classList.contains($437b23f6a393c3bf$var$TITLE_BAR_DISABLED_CLASS);
        this.refreshDisabledStyles(disabled);
        return this;
    }
    addWidget(el) {
        this.getGui().appendChild(el);
        return this;
    }
    hideOpenCloseIcons(hide) {
        this.suppressOpenCloseIcons = hide;
        if (hide) this.dispatchExpandChanged(true);
        return this;
    }
    refreshDisabledStyles(disabled) {
        const eGui = this.getGui();
        if (disabled) {
            eGui.classList.add($437b23f6a393c3bf$var$TITLE_BAR_DISABLED_CLASS);
            eGui.removeAttribute("tabindex");
        } else {
            eGui.classList.remove($437b23f6a393c3bf$var$TITLE_BAR_DISABLED_CLASS);
            if (typeof this.title === "string") eGui.setAttribute("tabindex", "0");
            else eGui.removeAttribute("tabindex");
        }
    }
};
$437b23f6a393c3bf$var$_DefaultTitleBar.EVENT_EXPAND_CHANGED = "expandedChanged";
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eGroupOpenedIcon")
], $437b23f6a393c3bf$var$_DefaultTitleBar.prototype, "eGroupOpenedIcon", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eGroupClosedIcon")
], $437b23f6a393c3bf$var$_DefaultTitleBar.prototype, "eGroupClosedIcon", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eTitle")
], $437b23f6a393c3bf$var$_DefaultTitleBar.prototype, "eTitle", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$_DefaultTitleBar.prototype, "postConstruct", 1);
var $437b23f6a393c3bf$var$DefaultTitleBar = $437b23f6a393c3bf$var$_DefaultTitleBar;
// community-modules/core/src/widgets/agMenuList.ts
var $437b23f6a393c3bf$export$b113b1dd8295ef83 = class extends $437b23f6a393c3bf$export$5a26e3abd1c845b6 {
    constructor(level = 0, params){
        super(/* html */ `<div class="ag-menu-list" role="tree"></div>`);
        this.level = level;
        this.menuItems = [];
        this.params = params != null ? params : {
            column: null,
            node: null,
            value: null
        };
    }
    postConstruct() {
        this.initialiseTabGuard({
            onTabKeyDown: (e)=>this.onTabKeyDown(e),
            handleKeyDown: (e)=>this.handleKeyDown(e),
            onFocusIn: (e)=>this.handleFocusIn(e),
            onFocusOut: (e)=>this.handleFocusOut(e)
        });
    }
    onTabKeyDown(e) {
        const parent = this.getParentComponent();
        const parentGui = parent && parent.getGui();
        const isManaged = parentGui && parentGui.classList.contains("ag-focus-managed");
        if (!isManaged) e.preventDefault();
        if (e.shiftKey) this.closeIfIsChild(e);
    }
    handleKeyDown(e) {
        switch(e.key){
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT:
                e.preventDefault();
                this.handleNavKey(e.key);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ESCAPE:
                if (this.closeIfIsChild()) $437b23f6a393c3bf$var$stopPropagationForAgGrid(e);
                break;
        }
    }
    handleFocusIn(e) {
        var _a, _b;
        const oldFocusedElement = e.relatedTarget;
        if (!this.tabGuardCtrl.isTabGuard(oldFocusedElement) && (this.getGui().contains(oldFocusedElement) || ((_b = (_a = this.activeMenuItem) == null ? void 0 : _a.getSubMenuGui()) == null ? void 0 : _b.contains(oldFocusedElement)))) return;
        if (this.activeMenuItem) this.activeMenuItem.activate();
        else this.activateFirstItem();
    }
    handleFocusOut(e) {
        var _a;
        const newFocusedElement = e.relatedTarget;
        if (!this.activeMenuItem || this.getGui().contains(newFocusedElement) || ((_a = this.activeMenuItem.getSubMenuGui()) == null ? void 0 : _a.contains(newFocusedElement))) return;
        if (!this.activeMenuItem.isSubMenuOpening()) this.activeMenuItem.deactivate();
    }
    clearActiveItem() {
        if (this.activeMenuItem) {
            this.activeMenuItem.deactivate();
            this.activeMenuItem = null;
        }
    }
    addMenuItems(menuItems) {
        if (menuItems == null) return;
        $437b23f6a393c3bf$export$30ec7836a4847721.all(menuItems.map((menuItemOrString)=>{
            if (menuItemOrString === "separator") return $437b23f6a393c3bf$export$30ec7836a4847721.resolve({
                eGui: this.createSeparator()
            });
            else if (typeof menuItemOrString === "string") {
                console.warn(`AG Grid: unrecognised menu item ${menuItemOrString}`);
                return $437b23f6a393c3bf$export$30ec7836a4847721.resolve({
                    eGui: null
                });
            } else return this.addItem(menuItemOrString);
        })).then((elements)=>{
            elements.forEach((element)=>{
                if (element == null ? void 0 : element.eGui) {
                    this.appendChild(element.eGui);
                    if (element.comp) this.menuItems.push(element.comp);
                }
            });
        });
    }
    addItem(menuItemDef) {
        const menuItem = this.createManagedBean(new $437b23f6a393c3bf$export$908d4fd0a47034b5());
        return menuItem.init({
            menuItemDef: menuItemDef,
            isAnotherSubMenuOpen: ()=>this.menuItems.some((m)=>m.isSubMenuOpen()),
            level: this.level,
            contextParams: this.params
        }).then(()=>{
            menuItem.setParentComponent(this);
            this.addManagedListener(menuItem, $437b23f6a393c3bf$export$908d4fd0a47034b5.EVENT_CLOSE_MENU, (event)=>{
                this.dispatchEvent(event);
            });
            this.addManagedListener(menuItem, $437b23f6a393c3bf$export$908d4fd0a47034b5.EVENT_MENU_ITEM_ACTIVATED, (event)=>{
                if (this.activeMenuItem && this.activeMenuItem !== event.menuItem) this.activeMenuItem.deactivate();
                this.activeMenuItem = event.menuItem;
            });
            return {
                comp: menuItem,
                eGui: menuItem.getGui()
            };
        });
    }
    activateFirstItem() {
        const item = this.menuItems.filter((currentItem)=>!currentItem.isDisabled())[0];
        if (!item) return;
        item.activate();
    }
    createSeparator() {
        const separatorHtml = /* html */ `
            <div class="ag-menu-separator" aria-hidden="true">
                <div class="ag-menu-separator-part"></div>
                <div class="ag-menu-separator-part"></div>
                <div class="ag-menu-separator-part"></div>
                <div class="ag-menu-separator-part"></div>
            </div>`;
        return $437b23f6a393c3bf$var$loadTemplate(separatorHtml);
    }
    handleNavKey(key) {
        switch(key){
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
                const nextItem = this.findNextItem(key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP);
                if (nextItem && nextItem !== this.activeMenuItem) nextItem.activate();
                return;
        }
        const left = this.gos.get("enableRtl") ? $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT : $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT;
        if (key === left) this.closeIfIsChild();
        else this.openChild();
    }
    closeIfIsChild(e) {
        const parentItem = this.getParentComponent();
        if (parentItem && parentItem instanceof $437b23f6a393c3bf$export$908d4fd0a47034b5) {
            if (e) e.preventDefault();
            parentItem.closeSubMenu();
            parentItem.getGui().focus();
            return true;
        }
        return false;
    }
    openChild() {
        if (this.activeMenuItem) this.activeMenuItem.openSubMenu(true);
    }
    findNextItem(up) {
        const items = this.menuItems.filter((item)=>!item.isDisabled());
        if (!items.length) return;
        if (!this.activeMenuItem) return up ? $437b23f6a393c3bf$var$last(items) : items[0];
        if (up) items.reverse();
        let nextItem;
        let foundCurrent = false;
        for(let i = 0; i < items.length; i++){
            const item = items[i];
            if (!foundCurrent) {
                if (item === this.activeMenuItem) foundCurrent = true;
                continue;
            }
            nextItem = item;
            break;
        }
        if (foundCurrent && !nextItem) return items[0];
        return nextItem || this.activeMenuItem;
    }
    destroy() {
        this.clearActiveItem();
        super.destroy();
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("focusService")
], $437b23f6a393c3bf$export$b113b1dd8295ef83.prototype, "focusService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$export$b113b1dd8295ef83.prototype, "postConstruct", 1);
// community-modules/core/src/widgets/agMenuPanel.ts
var $437b23f6a393c3bf$export$afc64d33b32952ba = class extends $437b23f6a393c3bf$export$5a26e3abd1c845b6 {
    constructor(wrappedComponent){
        super();
        this.wrappedComponent = wrappedComponent;
        this.setTemplateFromElement(wrappedComponent.getGui());
    }
    postConstruct() {
        this.initialiseTabGuard({
            onTabKeyDown: (e)=>this.onTabKeyDown(e),
            handleKeyDown: (e)=>this.handleKeyDown(e)
        });
    }
    handleKeyDown(e) {
        if (e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ESCAPE) this.closePanel();
    }
    onTabKeyDown(e) {
        if (e.defaultPrevented) return;
        this.closePanel();
        e.preventDefault();
    }
    closePanel() {
        const menuItem = this.parentComponent;
        menuItem.closeSubMenu();
        setTimeout(()=>menuItem.getGui().focus(), 0);
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$export$afc64d33b32952ba.prototype, "postConstruct", 1);
// community-modules/core/src/widgets/agMenuItemComponent.ts
var $437b23f6a393c3bf$var$_AgMenuItemComponent = class _AgMenuItemComponent extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.isActive = false;
        this.subMenuIsOpen = false;
        this.subMenuIsOpening = false;
        this.suppressRootStyles = true;
        this.suppressAria = true;
        this.suppressFocus = true;
    }
    init(params) {
        var _a, _b;
        const { menuItemDef: menuItemDef, isAnotherSubMenuOpen: isAnotherSubMenuOpen, level: level, childComponent: childComponent, contextParams: contextParams } = params;
        this.params = params.menuItemDef;
        this.level = level;
        this.isAnotherSubMenuOpen = isAnotherSubMenuOpen;
        this.childComponent = childComponent;
        this.contextParams = contextParams;
        this.cssClassPrefix = (_b = (_a = this.params.menuItemParams) == null ? void 0 : _a.cssClassPrefix) != null ? _b : "ag-menu-option";
        const compDetails = this.userComponentFactory.getMenuItemCompDetails(this.params, $437b23f6a393c3bf$var$__spreadProps($437b23f6a393c3bf$var$__spreadValues({}, menuItemDef), {
            level: level,
            isAnotherSubMenuOpen: isAnotherSubMenuOpen,
            openSubMenu: (activateFirstItem)=>this.openSubMenu(activateFirstItem),
            closeSubMenu: ()=>this.closeSubMenu(),
            closeMenu: (event)=>this.closeMenu(event),
            updateTooltip: (tooltip, shouldDisplayTooltip)=>this.refreshTooltip(tooltip, shouldDisplayTooltip),
            onItemActivated: ()=>this.onItemActivated()
        }));
        return compDetails.newAgStackInstance().then((comp)=>{
            var _a2;
            this.menuItemComp = comp;
            const configureDefaults = (_a2 = comp.configureDefaults) == null ? void 0 : _a2.call(comp);
            if (configureDefaults) this.configureDefaults(configureDefaults === true ? void 0 : configureDefaults);
        });
    }
    addListeners(eGui, params) {
        if (!(params == null ? void 0 : params.suppressClick)) this.addManagedListener(eGui, "click", (e)=>this.onItemSelected(e));
        if (!(params == null ? void 0 : params.suppressKeyboardSelect)) this.addManagedListener(eGui, "keydown", (e)=>{
            if (e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER || e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.SPACE) {
                e.preventDefault();
                this.onItemSelected(e);
            }
        });
        if (!(params == null ? void 0 : params.suppressMouseDown)) this.addManagedListener(eGui, "mousedown", (e)=>{
            e.stopPropagation();
            e.preventDefault();
        });
        if (!(params == null ? void 0 : params.suppressMouseOver)) {
            this.addManagedListener(eGui, "mouseenter", ()=>this.onMouseEnter());
            this.addManagedListener(eGui, "mouseleave", ()=>this.onMouseLeave());
        }
    }
    isDisabled() {
        return !!this.params.disabled;
    }
    openSubMenu(activateFirstItem = false) {
        var _a, _b;
        this.closeSubMenu();
        if (!this.params.subMenu) return;
        this.subMenuIsOpening = true;
        const ePopup = $437b23f6a393c3bf$var$loadTemplate(/* html */ `<div class="ag-menu" role="presentation"></div>`);
        this.eSubMenuGui = ePopup;
        let destroySubMenu;
        let afterGuiAttached = ()=>{
            this.subMenuIsOpening = false;
        };
        if (this.childComponent) {
            const menuPanel = this.createBean(new $437b23f6a393c3bf$export$afc64d33b32952ba(this.childComponent));
            menuPanel.setParentComponent(this);
            const subMenuGui = menuPanel.getGui();
            const mouseEvent = "mouseenter";
            const mouseEnterListener = ()=>this.cancelDeactivate();
            subMenuGui.addEventListener(mouseEvent, mouseEnterListener);
            destroySubMenu = ()=>subMenuGui.removeEventListener(mouseEvent, mouseEnterListener);
            ePopup.appendChild(subMenuGui);
            if (this.childComponent.afterGuiAttached) afterGuiAttached = ()=>{
                this.childComponent.afterGuiAttached();
                this.subMenuIsOpening = false;
            };
        } else if (this.params.subMenu) {
            const childMenu = this.createBean(new $437b23f6a393c3bf$export$b113b1dd8295ef83(this.level + 1, this.contextParams));
            childMenu.setParentComponent(this);
            childMenu.addMenuItems(this.params.subMenu);
            ePopup.appendChild(childMenu.getGui());
            this.addManagedListener(childMenu, _AgMenuItemComponent.EVENT_CLOSE_MENU, (e)=>this.dispatchEvent(e));
            childMenu.addGuiEventListener("mouseenter", ()=>this.cancelDeactivate());
            destroySubMenu = ()=>this.destroyBean(childMenu);
            if (activateFirstItem) afterGuiAttached = ()=>{
                childMenu.activateFirstItem();
                this.subMenuIsOpening = false;
            };
        }
        const positionCallback = this.popupService.positionPopupForMenu.bind(this.popupService, {
            eventSource: this.eGui,
            ePopup: ePopup
        });
        const translate = this.localeService.getLocaleTextFunc();
        const addPopupRes = this.popupService.addPopup({
            modal: true,
            eChild: ePopup,
            positionCallback: positionCallback,
            anchorToElement: this.eGui,
            ariaLabel: translate("ariaLabelSubMenu", "SubMenu"),
            afterGuiAttached: afterGuiAttached
        });
        this.subMenuIsOpen = true;
        this.setAriaExpanded(true);
        this.hideSubMenu = ()=>{
            var _a2, _b2;
            if (addPopupRes) addPopupRes.hideFunc();
            this.subMenuIsOpen = false;
            this.setAriaExpanded(false);
            destroySubMenu();
            (_b2 = (_a2 = this.menuItemComp).setExpanded) == null || _b2.call(_a2, false);
            this.eSubMenuGui = void 0;
        };
        (_b = (_a = this.menuItemComp).setExpanded) == null || _b.call(_a, true);
    }
    setAriaExpanded(expanded) {
        if (!this.suppressAria) $437b23f6a393c3bf$var$setAriaExpanded(this.eGui, expanded);
    }
    closeSubMenu() {
        if (!this.hideSubMenu) return;
        this.hideSubMenu();
        this.hideSubMenu = null;
        this.setAriaExpanded(false);
    }
    isSubMenuOpen() {
        return this.subMenuIsOpen;
    }
    isSubMenuOpening() {
        return this.subMenuIsOpening;
    }
    activate(openSubMenu) {
        var _a, _b;
        this.cancelActivate();
        if (this.params.disabled) return;
        this.isActive = true;
        if (!this.suppressRootStyles) this.eGui.classList.add(`${this.cssClassPrefix}-active`);
        (_b = (_a = this.menuItemComp).setActive) == null || _b.call(_a, true);
        if (!this.suppressFocus) this.eGui.focus({
            preventScroll: true
        });
        if (openSubMenu && this.params.subMenu) window.setTimeout(()=>{
            if (this.isAlive() && this.isActive) this.openSubMenu();
        }, 300);
        this.onItemActivated();
    }
    deactivate() {
        var _a, _b;
        this.cancelDeactivate();
        if (!this.suppressRootStyles) this.eGui.classList.remove(`${this.cssClassPrefix}-active`);
        (_b = (_a = this.menuItemComp).setActive) == null || _b.call(_a, false);
        this.isActive = false;
        if (this.subMenuIsOpen) this.hideSubMenu();
    }
    getGui() {
        return this.menuItemComp.getGui();
    }
    getParentComponent() {
        return this.parentComponent;
    }
    setParentComponent(component) {
        this.parentComponent = component;
    }
    getSubMenuGui() {
        return this.eSubMenuGui;
    }
    onItemSelected(event) {
        var _a, _b;
        (_b = (_a = this.menuItemComp).select) == null || _b.call(_a);
        if (this.params.action) this.getFrameworkOverrides().wrapOutgoing(()=>this.params.action(this.gos.addGridCommonParams($437b23f6a393c3bf$var$__spreadValues({}, this.contextParams))));
        else this.openSubMenu(event && event.type === "keydown");
        if (this.params.subMenu && !this.params.action || this.params.suppressCloseOnSelect) return;
        this.closeMenu(event);
    }
    closeMenu(event) {
        const e = {
            type: _AgMenuItemComponent.EVENT_CLOSE_MENU
        };
        if (event) {
            if (event instanceof MouseEvent) e.mouseEvent = event;
            else e.keyboardEvent = event;
        }
        this.dispatchEvent(e);
    }
    onItemActivated() {
        const event = {
            type: _AgMenuItemComponent.EVENT_MENU_ITEM_ACTIVATED,
            menuItem: this
        };
        this.dispatchEvent(event);
    }
    cancelActivate() {
        if (this.activateTimeoutId) {
            window.clearTimeout(this.activateTimeoutId);
            this.activateTimeoutId = 0;
        }
    }
    cancelDeactivate() {
        if (this.deactivateTimeoutId) {
            window.clearTimeout(this.deactivateTimeoutId);
            this.deactivateTimeoutId = 0;
        }
    }
    onMouseEnter() {
        this.cancelDeactivate();
        if (this.isAnotherSubMenuOpen()) this.activateTimeoutId = window.setTimeout(()=>this.activate(true), _AgMenuItemComponent.ACTIVATION_DELAY);
        else this.activate(true);
    }
    onMouseLeave() {
        this.cancelActivate();
        if (this.isSubMenuOpen()) this.deactivateTimeoutId = window.setTimeout(()=>this.deactivate(), _AgMenuItemComponent.ACTIVATION_DELAY);
        else this.deactivate();
    }
    configureDefaults(params) {
        var _a, _b, _c;
        if (!this.menuItemComp) {
            setTimeout(()=>this.configureDefaults(params));
            return;
        }
        let eGui = this.menuItemComp.getGui();
        const rootElement = (_b = (_a = this.menuItemComp).getRootElement) == null ? void 0 : _b.call(_a);
        if (rootElement) {
            if (!(params == null ? void 0 : params.suppressRootStyles)) eGui.classList.add("ag-menu-option-custom");
            eGui = rootElement;
        }
        this.eGui = eGui;
        this.suppressRootStyles = !!(params == null ? void 0 : params.suppressRootStyles);
        if (!this.suppressRootStyles) {
            eGui.classList.add(this.cssClassPrefix);
            (_c = this.params.cssClasses) == null || _c.forEach((it)=>eGui.classList.add(it));
            if (this.params.disabled) eGui.classList.add(`${this.cssClassPrefix}-disabled`);
        }
        if (!(params == null ? void 0 : params.suppressTooltip)) this.refreshTooltip(this.params.tooltip);
        this.suppressAria = !!(params == null ? void 0 : params.suppressAria);
        if (!this.suppressAria) {
            $437b23f6a393c3bf$var$setAriaRole(eGui, "treeitem");
            $437b23f6a393c3bf$var$setAriaLevel(eGui, this.level + 1);
            if (this.params.disabled) $437b23f6a393c3bf$var$setAriaDisabled(eGui, true);
        }
        if (!(params == null ? void 0 : params.suppressTabIndex)) eGui.setAttribute("tabindex", "-1");
        if (!this.params.disabled) this.addListeners(eGui, params);
        this.suppressFocus = !!(params == null ? void 0 : params.suppressFocus);
    }
    refreshTooltip(tooltip, shouldDisplayTooltip) {
        this.tooltip = tooltip;
        if (this.tooltipFeature) this.tooltipFeature = this.destroyBean(this.tooltipFeature);
        if (!tooltip || !this.menuItemComp) return;
        this.tooltipFeature = this.createBean(new $437b23f6a393c3bf$export$e5073a590d24815c({
            getGui: ()=>this.getGui(),
            getTooltipValue: ()=>this.tooltip,
            getLocation: ()=>"menu",
            shouldDisplayTooltip: shouldDisplayTooltip
        }));
    }
    destroy() {
        if (this.tooltipFeature) this.tooltipFeature = this.destroyBean(this.tooltipFeature);
        super.destroy();
    }
};
$437b23f6a393c3bf$var$_AgMenuItemComponent.EVENT_CLOSE_MENU = "closeMenu";
$437b23f6a393c3bf$var$_AgMenuItemComponent.EVENT_MENU_ITEM_ACTIVATED = "menuItemActivated";
$437b23f6a393c3bf$var$_AgMenuItemComponent.ACTIVATION_DELAY = 80;
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("popupService")
], $437b23f6a393c3bf$var$_AgMenuItemComponent.prototype, "popupService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("userComponentFactory")
], $437b23f6a393c3bf$var$_AgMenuItemComponent.prototype, "userComponentFactory", 2);
var $437b23f6a393c3bf$export$908d4fd0a47034b5 = $437b23f6a393c3bf$var$_AgMenuItemComponent;
// community-modules/core/src/widgets/agPanel.ts
var $437b23f6a393c3bf$var$_AgPanel = class _AgPanel extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(config){
        super(_AgPanel.getTemplate(config));
        this.config = config;
        this.closable = true;
    }
    static getTemplate(config) {
        const cssIdentifier = config.cssIdentifier || "default";
        return /* html */ `<div class="ag-panel ag-${cssIdentifier}-panel" tabindex="-1">
            <div ref="eTitleBar" class="ag-panel-title-bar ag-${cssIdentifier}-panel-title-bar ag-unselectable">
                <span ref="eTitle" class="ag-panel-title-bar-title ag-${cssIdentifier}-panel-title-bar-title"></span>
                <div ref="eTitleBarButtons" class="ag-panel-title-bar-buttons ag-${cssIdentifier}-panel-title-bar-buttons"></div>
            </div>
            <div ref="eContentWrapper" class="ag-panel-content-wrapper ag-${cssIdentifier}-panel-content-wrapper"></div>
        </div>`;
    }
    postConstruct() {
        const { component: component, closable: closable, hideTitleBar: hideTitleBar, title: title, minWidth: minWidth = 250, width: width, minHeight: minHeight = 250, height: height, centered: centered, popup: popup, x: x, y: y } = this.config;
        this.positionableFeature = new $437b23f6a393c3bf$export$c53a5d9f1fb0f7f6(this.getGui(), {
            minWidth: minWidth,
            width: width,
            minHeight: minHeight,
            height: height,
            centered: centered,
            x: x,
            y: y,
            popup: popup,
            calculateTopBuffer: ()=>this.positionableFeature.getHeight() - this.getBodyHeight()
        });
        this.createManagedBean(this.positionableFeature);
        const eGui = this.getGui();
        if (component) this.setBodyComponent(component);
        if (!hideTitleBar) {
            if (title) this.setTitle(title);
            this.setClosable(closable != null ? closable : this.closable);
        } else $437b23f6a393c3bf$var$setDisplayed(this.eTitleBar, false);
        this.addManagedListener(this.eTitleBar, "mousedown", (e)=>{
            if (eGui.contains(e.relatedTarget) || eGui.contains(this.gos.getActiveDomElement()) || this.eTitleBarButtons.contains(e.target)) {
                e.preventDefault();
                return;
            }
            const focusEl = this.eContentWrapper.querySelector("button, [href], input, select, textarea, [tabindex]");
            if (focusEl) focusEl.focus();
        });
        if (popup && this.positionableFeature.isPositioned()) return;
        if (this.renderComponent) this.renderComponent();
        this.positionableFeature.initialisePosition();
        this.eContentWrapper.style.height = "0";
    }
    renderComponent() {
        const eGui = this.getGui();
        eGui.focus();
        this.close = ()=>{
            eGui.parentElement.removeChild(eGui);
            this.destroy();
        };
    }
    getHeight() {
        return this.positionableFeature.getHeight();
    }
    setHeight(height) {
        this.positionableFeature.setHeight(height);
    }
    getWidth() {
        return this.positionableFeature.getWidth();
    }
    setWidth(width) {
        this.positionableFeature.setWidth(width);
    }
    setClosable(closable) {
        if (closable !== this.closable) this.closable = closable;
        if (closable) {
            const closeButtonComp = this.closeButtonComp = new $437b23f6a393c3bf$export$16fa2f45be04daa8(_AgPanel.CLOSE_BTN_TEMPLATE);
            this.getContext().createBean(closeButtonComp);
            const eGui = closeButtonComp.getGui();
            const child = $437b23f6a393c3bf$var$createIconNoSpan("close", this.gos);
            child.classList.add("ag-panel-title-bar-button-icon");
            eGui.appendChild(child);
            this.addTitleBarButton(closeButtonComp);
            closeButtonComp.addManagedListener(eGui, "click", this.onBtClose.bind(this));
        } else if (this.closeButtonComp) {
            const eGui = this.closeButtonComp.getGui();
            eGui.parentElement.removeChild(eGui);
            this.closeButtonComp = this.destroyBean(this.closeButtonComp);
        }
    }
    setBodyComponent(bodyComponent) {
        bodyComponent.setParentComponent(this);
        this.eContentWrapper.appendChild(bodyComponent.getGui());
    }
    addTitleBarButton(button, position) {
        const eTitleBarButtons = this.eTitleBarButtons;
        const buttons = eTitleBarButtons.children;
        const len = buttons.length;
        if (position == null) position = len;
        position = Math.max(0, Math.min(position, len));
        button.addCssClass("ag-panel-title-bar-button");
        const eGui = button.getGui();
        if (position === 0) eTitleBarButtons.insertAdjacentElement("afterbegin", eGui);
        else if (position === len) eTitleBarButtons.insertAdjacentElement("beforeend", eGui);
        else buttons[position - 1].insertAdjacentElement("afterend", eGui);
        button.setParentComponent(this);
    }
    getBodyHeight() {
        return $437b23f6a393c3bf$var$getInnerHeight(this.eContentWrapper);
    }
    getBodyWidth() {
        return $437b23f6a393c3bf$var$getInnerWidth(this.eContentWrapper);
    }
    setTitle(title) {
        this.eTitle.innerText = title;
    }
    // called when user hits the 'x' in the top right
    onBtClose() {
        this.close();
    }
    destroy() {
        if (this.closeButtonComp) this.closeButtonComp = this.destroyBean(this.closeButtonComp);
        const eGui = this.getGui();
        if (eGui && $437b23f6a393c3bf$var$isVisible(eGui)) this.close();
        super.destroy();
    }
};
$437b23f6a393c3bf$var$_AgPanel.CLOSE_BTN_TEMPLATE = /* html */ `<div class="ag-button"></div>`;
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eContentWrapper")
], $437b23f6a393c3bf$var$_AgPanel.prototype, "eContentWrapper", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eTitleBar")
], $437b23f6a393c3bf$var$_AgPanel.prototype, "eTitleBar", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eTitleBarButtons")
], $437b23f6a393c3bf$var$_AgPanel.prototype, "eTitleBarButtons", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eTitle")
], $437b23f6a393c3bf$var$_AgPanel.prototype, "eTitle", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$_AgPanel.prototype, "postConstruct", 1);
var $437b23f6a393c3bf$export$36e6d4f6293bbc52 = $437b23f6a393c3bf$var$_AgPanel;
// community-modules/core/src/widgets/agDialog.ts
var $437b23f6a393c3bf$export$c9fd1c3b091fd3ea = class extends $437b23f6a393c3bf$export$36e6d4f6293bbc52 {
    constructor(config){
        super($437b23f6a393c3bf$var$__spreadProps($437b23f6a393c3bf$var$__spreadValues({}, config), {
            popup: true
        }));
        this.isMaximizable = false;
        this.isMaximized = false;
        this.maximizeListeners = [];
        this.resizeListenerDestroy = null;
        this.lastPosition = {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
    }
    postConstruct() {
        const eGui = this.getGui();
        const { movable: movable, resizable: resizable, maximizable: maximizable } = this.config;
        this.addCssClass("ag-dialog");
        super.postConstruct();
        this.addManagedListener(eGui, "focusin", (e)=>{
            this.popupService.bringPopupToFront(eGui);
        });
        if (movable) this.setMovable(movable);
        if (maximizable) this.setMaximizable(maximizable);
        if (resizable) this.setResizable(resizable);
    }
    renderComponent() {
        const eGui = this.getGui();
        const { alwaysOnTop: alwaysOnTop, modal: modal, title: title, afterGuiAttached: afterGuiAttached } = this.config;
        const translate = this.localeService.getLocaleTextFunc();
        const addPopupRes = this.popupService.addPopup({
            modal: modal,
            eChild: eGui,
            closeOnEsc: true,
            closedCallback: this.onClosed.bind(this),
            alwaysOnTop: alwaysOnTop,
            ariaLabel: title || translate("ariaLabelDialog", "Dialog"),
            afterGuiAttached: afterGuiAttached
        });
        if (addPopupRes) this.close = addPopupRes.hideFunc;
    }
    onClosed(event) {
        var _a, _b;
        this.destroy();
        (_b = (_a = this.config).closedCallback) == null || _b.call(_a, event);
    }
    toggleMaximize() {
        const position = this.positionableFeature.getPosition();
        if (this.isMaximized) {
            const { x: x, y: y, width: width, height: height } = this.lastPosition;
            this.setWidth(width);
            this.setHeight(height);
            this.positionableFeature.offsetElement(x, y);
        } else {
            this.lastPosition.width = this.getWidth();
            this.lastPosition.height = this.getHeight();
            this.lastPosition.x = position.x;
            this.lastPosition.y = position.y;
            this.positionableFeature.offsetElement(0, 0);
            this.setHeight("100%");
            this.setWidth("100%");
        }
        this.isMaximized = !this.isMaximized;
        this.refreshMaximizeIcon();
    }
    refreshMaximizeIcon() {
        $437b23f6a393c3bf$var$setDisplayed(this.maximizeIcon, !this.isMaximized);
        $437b23f6a393c3bf$var$setDisplayed(this.minimizeIcon, this.isMaximized);
    }
    clearMaximizebleListeners() {
        if (this.maximizeListeners.length) {
            this.maximizeListeners.forEach((destroyListener)=>destroyListener());
            this.maximizeListeners.length = 0;
        }
        if (this.resizeListenerDestroy) {
            this.resizeListenerDestroy();
            this.resizeListenerDestroy = null;
        }
    }
    destroy() {
        this.maximizeButtonComp = this.destroyBean(this.maximizeButtonComp);
        this.clearMaximizebleListeners();
        super.destroy();
    }
    setResizable(resizable) {
        this.positionableFeature.setResizable(resizable);
    }
    setMovable(movable) {
        this.positionableFeature.setMovable(movable, this.eTitleBar);
    }
    setMaximizable(maximizable) {
        if (!maximizable) {
            this.clearMaximizebleListeners();
            if (this.maximizeButtonComp) {
                this.destroyBean(this.maximizeButtonComp);
                this.maximizeButtonComp = this.maximizeIcon = this.minimizeIcon = void 0;
            }
            return;
        }
        const eTitleBar = this.eTitleBar;
        if (!eTitleBar || maximizable === this.isMaximizable) return;
        const maximizeButtonComp = this.buildMaximizeAndMinimizeElements();
        this.refreshMaximizeIcon();
        maximizeButtonComp.addManagedListener(maximizeButtonComp.getGui(), "click", this.toggleMaximize.bind(this));
        this.addTitleBarButton(maximizeButtonComp, 0);
        this.maximizeListeners.push(this.addManagedListener(eTitleBar, "dblclick", this.toggleMaximize.bind(this)));
        this.resizeListenerDestroy = this.addManagedListener(this, "resize", ()=>{
            this.isMaximized = false;
            this.refreshMaximizeIcon();
        });
    }
    buildMaximizeAndMinimizeElements() {
        const maximizeButtonComp = this.maximizeButtonComp = this.createBean(new $437b23f6a393c3bf$export$16fa2f45be04daa8(/* html */ `<div class="ag-dialog-button"></span>`));
        const eGui = maximizeButtonComp.getGui();
        this.maximizeIcon = $437b23f6a393c3bf$var$createIconNoSpan("maximize", this.gos);
        eGui.appendChild(this.maximizeIcon);
        this.maximizeIcon.classList.add("ag-panel-title-bar-button-icon");
        this.minimizeIcon = $437b23f6a393c3bf$var$createIconNoSpan("minimize", this.gos);
        eGui.appendChild(this.minimizeIcon);
        this.minimizeIcon.classList.add("ag-panel-title-bar-button-icon");
        return maximizeButtonComp;
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("popupService")
], $437b23f6a393c3bf$export$c9fd1c3b091fd3ea.prototype, "popupService", 2);
// community-modules/core/src/widgets/popupService.ts
var $437b23f6a393c3bf$var$instanceIdSeq = 0;
var $437b23f6a393c3bf$export$27497a369f7303c1 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.popupList = [];
    }
    postConstruct() {
        this.ctrlsService.whenReady((p)=>{
            this.gridCtrl = p.gridCtrl;
        });
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_GRID_STYLES_CHANGED, this.handleThemeChange.bind(this));
    }
    getPopupParent() {
        const ePopupParent = this.gos.get("popupParent");
        if (ePopupParent) return ePopupParent;
        return this.gridCtrl.getGui();
    }
    positionPopupForMenu(params) {
        const { eventSource: eventSource, ePopup: ePopup } = params;
        const popupIdx = this.getPopupIndex(ePopup);
        if (popupIdx !== -1) {
            const popup = this.popupList[popupIdx];
            popup.alignedToElement = eventSource;
        }
        const sourceRect = eventSource.getBoundingClientRect();
        const parentRect = this.getParentRect();
        const y = this.keepXYWithinBounds(ePopup, sourceRect.top - parentRect.top, 0 /* vertical */ );
        const minWidth = ePopup.clientWidth > 0 ? ePopup.clientWidth : 200;
        ePopup.style.minWidth = `${minWidth}px`;
        const widthOfParent = parentRect.right - parentRect.left;
        const maxX = widthOfParent - minWidth;
        let x;
        if (this.gos.get("enableRtl")) {
            x = xLeftPosition();
            if (x < 0) {
                x = xRightPosition();
                this.setAlignedStyles(ePopup, "left");
            }
            if (x > maxX) {
                x = 0;
                this.setAlignedStyles(ePopup, "right");
            }
        } else {
            x = xRightPosition();
            if (x > maxX) {
                x = xLeftPosition();
                this.setAlignedStyles(ePopup, "right");
            }
            if (x < 0) {
                x = 0;
                this.setAlignedStyles(ePopup, "left");
            }
        }
        ePopup.style.left = `${x}px`;
        ePopup.style.top = `${y}px`;
        function xRightPosition() {
            return sourceRect.right - parentRect.left - 2;
        }
        function xLeftPosition() {
            return sourceRect.left - parentRect.left - minWidth;
        }
    }
    positionPopupUnderMouseEvent(params) {
        const { ePopup: ePopup, nudgeX: nudgeX, nudgeY: nudgeY, skipObserver: skipObserver } = params;
        this.positionPopup({
            ePopup: ePopup,
            nudgeX: nudgeX,
            nudgeY: nudgeY,
            keepWithinBounds: true,
            skipObserver: skipObserver,
            updatePosition: ()=>this.calculatePointerAlign(params.mouseEvent),
            postProcessCallback: ()=>this.callPostProcessPopup(params.type, params.ePopup, null, params.mouseEvent, params.column, params.rowNode)
        });
    }
    calculatePointerAlign(e) {
        const parentRect = this.getParentRect();
        return {
            x: e.clientX - parentRect.left,
            y: e.clientY - parentRect.top
        };
    }
    positionPopupByComponent(params) {
        const { ePopup: ePopup, nudgeX: nudgeX, nudgeY: nudgeY, keepWithinBounds: keepWithinBounds, eventSource: eventSource, alignSide: alignSide = "left", position: position = "over", column: column, rowNode: rowNode, type: type } = params;
        const sourceRect = eventSource.getBoundingClientRect();
        const parentRect = this.getParentRect();
        const popupIdx = this.getPopupIndex(ePopup);
        if (popupIdx !== -1) {
            const popup = this.popupList[popupIdx];
            popup.alignedToElement = eventSource;
        }
        const updatePosition = ()=>{
            let x = sourceRect.left - parentRect.left;
            if (alignSide === "right") x -= ePopup.offsetWidth - sourceRect.width;
            let y;
            if (position === "over") {
                y = sourceRect.top - parentRect.top;
                this.setAlignedStyles(ePopup, "over");
            } else {
                this.setAlignedStyles(ePopup, "under");
                const alignSide2 = this.shouldRenderUnderOrAbove(ePopup, sourceRect, parentRect, params.nudgeY || 0);
                if (alignSide2 === "under") y = sourceRect.top - parentRect.top + sourceRect.height;
                else y = sourceRect.top - ePopup.offsetHeight - (nudgeY || 0) * 2 - parentRect.top;
            }
            return {
                x: x,
                y: y
            };
        };
        this.positionPopup({
            ePopup: ePopup,
            nudgeX: nudgeX,
            nudgeY: nudgeY,
            keepWithinBounds: keepWithinBounds,
            updatePosition: updatePosition,
            postProcessCallback: ()=>this.callPostProcessPopup(type, ePopup, eventSource, null, column, rowNode)
        });
    }
    shouldRenderUnderOrAbove(ePopup, targetCompRect, parentRect, nudgeY) {
        const spaceAvailableUnder = parentRect.bottom - targetCompRect.bottom;
        const spaceAvailableAbove = targetCompRect.top - parentRect.top;
        const spaceRequired = ePopup.offsetHeight + nudgeY;
        if (spaceAvailableUnder > spaceRequired) return "under";
        if (spaceAvailableAbove > spaceRequired || spaceAvailableAbove > spaceAvailableUnder) return "above";
        return "under";
    }
    setAlignedStyles(ePopup, positioned) {
        const popupIdx = this.getPopupIndex(ePopup);
        if (popupIdx === -1) return;
        const popup = this.popupList[popupIdx];
        const { alignedToElement: alignedToElement } = popup;
        if (!alignedToElement) return;
        const positions = [
            "right",
            "left",
            "over",
            "above",
            "under"
        ];
        positions.forEach((position)=>{
            alignedToElement.classList.remove(`ag-has-popup-positioned-${position}`);
            ePopup.classList.remove(`ag-popup-positioned-${position}`);
        });
        if (!positioned) return;
        alignedToElement.classList.add(`ag-has-popup-positioned-${positioned}`);
        ePopup.classList.add(`ag-popup-positioned-${positioned}`);
    }
    callPostProcessPopup(type, ePopup, eventSource, mouseEvent, column, rowNode) {
        const callback = this.gos.getCallback("postProcessPopup");
        if (callback) {
            const params = {
                column: column,
                rowNode: rowNode,
                ePopup: ePopup,
                type: type,
                eventSource: eventSource,
                mouseEvent: mouseEvent
            };
            callback(params);
        }
    }
    positionPopup(params) {
        const { ePopup: ePopup, keepWithinBounds: keepWithinBounds, nudgeX: nudgeX, nudgeY: nudgeY, skipObserver: skipObserver, updatePosition: updatePosition } = params;
        const lastSize = {
            width: 0,
            height: 0
        };
        const updatePopupPosition = (fromResizeObserver = false)=>{
            let { x: x, y: y } = updatePosition();
            if (fromResizeObserver && ePopup.clientWidth === lastSize.width && ePopup.clientHeight === lastSize.height) return;
            lastSize.width = ePopup.clientWidth;
            lastSize.height = ePopup.clientHeight;
            if (nudgeX) x += nudgeX;
            if (nudgeY) y += nudgeY;
            if (keepWithinBounds) {
                x = this.keepXYWithinBounds(ePopup, x, 1 /* horizontal */ );
                y = this.keepXYWithinBounds(ePopup, y, 0 /* vertical */ );
            }
            ePopup.style.left = `${x}px`;
            ePopup.style.top = `${y}px`;
            if (params.postProcessCallback) params.postProcessCallback();
        };
        updatePopupPosition();
        if (!skipObserver) {
            const resizeObserverDestroyFunc = this.resizeObserverService.observeResize(ePopup, ()=>updatePopupPosition(true));
            setTimeout(()=>resizeObserverDestroyFunc(), $437b23f6a393c3bf$export$27497a369f7303c1.WAIT_FOR_POPUP_CONTENT_RESIZE);
        }
    }
    getActivePopups() {
        return this.popupList.map((popup)=>popup.element);
    }
    getPopupList() {
        return this.popupList;
    }
    getParentRect() {
        const eDocument = this.gos.getDocument();
        let popupParent = this.getPopupParent();
        if (popupParent === eDocument.body) popupParent = eDocument.documentElement;
        else if (getComputedStyle(popupParent).position === "static") popupParent = popupParent.offsetParent;
        return $437b23f6a393c3bf$var$getElementRectWithOffset(popupParent);
    }
    keepXYWithinBounds(ePopup, position, direction) {
        const isVertical = direction === 0 /* vertical */ ;
        const sizeProperty = isVertical ? "clientHeight" : "clientWidth";
        const anchorProperty = isVertical ? "top" : "left";
        const offsetProperty = isVertical ? "offsetHeight" : "offsetWidth";
        const scrollPositionProperty = isVertical ? "scrollTop" : "scrollLeft";
        const eDocument = this.gos.getDocument();
        const docElement = eDocument.documentElement;
        const popupParent = this.getPopupParent();
        const parentRect = popupParent.getBoundingClientRect();
        const documentRect = eDocument.documentElement.getBoundingClientRect();
        const isBody = popupParent === eDocument.body;
        const offsetSize = ePopup[offsetProperty];
        const getSize = isVertical ? $437b23f6a393c3bf$var$getAbsoluteHeight : $437b23f6a393c3bf$var$getAbsoluteWidth;
        let sizeOfParent = isBody ? getSize(docElement) + docElement[scrollPositionProperty] : popupParent[sizeProperty];
        if (isBody) sizeOfParent -= Math.abs(documentRect[anchorProperty] - parentRect[anchorProperty]);
        const max = sizeOfParent - offsetSize;
        return Math.min(Math.max(position, 0), Math.abs(max));
    }
    addPopup(params) {
        const eDocument = this.gos.getDocument();
        const { eChild: eChild, ariaLabel: ariaLabel, alwaysOnTop: alwaysOnTop, positionCallback: positionCallback, anchorToElement: anchorToElement } = params;
        if (!eDocument) {
            console.warn("AG Grid: could not find the document, document is empty");
            return {
                hideFunc: ()=>{}
            };
        }
        const pos = this.getPopupIndex(eChild);
        if (pos !== -1) {
            const popup = this.popupList[pos];
            return {
                hideFunc: popup.hideFunc
            };
        }
        this.initialisePopupPosition(eChild);
        const wrapperEl = this.createPopupWrapper(eChild, ariaLabel, !!alwaysOnTop);
        const removeListeners = this.addEventListenersToPopup($437b23f6a393c3bf$var$__spreadProps($437b23f6a393c3bf$var$__spreadValues({}, params), {
            wrapperEl: wrapperEl
        }));
        if (positionCallback) positionCallback();
        this.addPopupToPopupList(eChild, wrapperEl, removeListeners, anchorToElement);
        return {
            hideFunc: removeListeners
        };
    }
    initialisePopupPosition(element) {
        const ePopupParent = this.getPopupParent();
        const ePopupParentRect = ePopupParent.getBoundingClientRect();
        if (!$437b23f6a393c3bf$var$exists(element.style.top)) element.style.top = `${ePopupParentRect.top * -1}px`;
        if (!$437b23f6a393c3bf$var$exists(element.style.left)) element.style.left = `${ePopupParentRect.left * -1}px`;
    }
    createPopupWrapper(element, ariaLabel, alwaysOnTop) {
        const ePopupParent = this.getPopupParent();
        const eWrapper = document.createElement("div");
        const { allThemes: allThemes } = this.environment.getTheme();
        if (allThemes.length) eWrapper.classList.add(...allThemes);
        eWrapper.classList.add("ag-popup");
        element.classList.add(this.gos.get("enableRtl") ? "ag-rtl" : "ag-ltr", "ag-popup-child");
        if (!element.hasAttribute("role")) $437b23f6a393c3bf$var$setAriaRole(element, "dialog");
        $437b23f6a393c3bf$var$setAriaLabel(element, ariaLabel);
        eWrapper.appendChild(element);
        ePopupParent.appendChild(eWrapper);
        if (alwaysOnTop) this.setAlwaysOnTop(element, true);
        else this.bringPopupToFront(element);
        return eWrapper;
    }
    handleThemeChange() {
        const { allThemes: allThemes } = this.environment.getTheme();
        for (const popup of this.popupList){
            for (const className of Array.from(popup.wrapper.classList))if (className.startsWith("ag-theme-")) popup.wrapper.classList.remove(className);
            if (allThemes.length) popup.wrapper.classList.add(...allThemes);
        }
    }
    addEventListenersToPopup(params) {
        const eDocument = this.gos.getDocument();
        const ePopupParent = this.getPopupParent();
        const { wrapperEl: wrapperEl, eChild: popupEl, closedCallback: closedCallback, afterGuiAttached: afterGuiAttached, closeOnEsc: closeOnEsc, modal: modal } = params;
        let popupHidden = false;
        const hidePopupOnKeyboardEvent = (event)=>{
            if (!wrapperEl.contains(this.gos.getActiveDomElement())) return;
            const key = event.key;
            if (key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ESCAPE && !$437b23f6a393c3bf$var$isStopPropagationForAgGrid(event)) removeListeners({
                keyboardEvent: event
            });
        };
        const hidePopupOnMouseEvent = (event)=>removeListeners({
                mouseEvent: event
            });
        const hidePopupOnTouchEvent = (event)=>removeListeners({
                touchEvent: event
            });
        const removeListeners = (popupParams = {})=>{
            const { mouseEvent: mouseEvent, touchEvent: touchEvent, keyboardEvent: keyboardEvent, forceHide: forceHide } = popupParams;
            if (!forceHide && // we don't hide popup if the event was on the child, or any
            // children of this child
            (this.isEventFromCurrentPopup({
                mouseEvent: mouseEvent,
                touchEvent: touchEvent
            }, popupEl) || // this method should only be called once. the client can have different
            // paths, each one wanting to close, so this method may be called multiple times.
            popupHidden)) return;
            popupHidden = true;
            ePopupParent.removeChild(wrapperEl);
            eDocument.removeEventListener("keydown", hidePopupOnKeyboardEvent);
            eDocument.removeEventListener("mousedown", hidePopupOnMouseEvent);
            eDocument.removeEventListener("touchstart", hidePopupOnTouchEvent);
            eDocument.removeEventListener("contextmenu", hidePopupOnMouseEvent);
            this.eventService.removeEventListener($437b23f6a393c3bf$export$ada873a34909da65.EVENT_DRAG_STARTED, hidePopupOnMouseEvent);
            if (closedCallback) closedCallback(mouseEvent || touchEvent || keyboardEvent);
            this.removePopupFromPopupList(popupEl);
        };
        if (afterGuiAttached) afterGuiAttached({
            hidePopup: removeListeners
        });
        window.setTimeout(()=>{
            if (closeOnEsc) eDocument.addEventListener("keydown", hidePopupOnKeyboardEvent);
            if (modal) {
                eDocument.addEventListener("mousedown", hidePopupOnMouseEvent);
                this.eventService.addEventListener($437b23f6a393c3bf$export$ada873a34909da65.EVENT_DRAG_STARTED, hidePopupOnMouseEvent);
                eDocument.addEventListener("touchstart", hidePopupOnTouchEvent);
                eDocument.addEventListener("contextmenu", hidePopupOnMouseEvent);
            }
        }, 0);
        return removeListeners;
    }
    addPopupToPopupList(element, wrapperEl, removeListeners, anchorToElement) {
        this.popupList.push({
            element: element,
            wrapper: wrapperEl,
            hideFunc: removeListeners,
            instanceId: $437b23f6a393c3bf$var$instanceIdSeq++,
            isAnchored: !!anchorToElement
        });
        if (anchorToElement) this.setPopupPositionRelatedToElement(element, anchorToElement);
    }
    getPopupIndex(el) {
        return this.popupList.findIndex((p)=>p.element === el);
    }
    setPopupPositionRelatedToElement(popupEl, relativeElement) {
        const popupIndex = this.getPopupIndex(popupEl);
        if (popupIndex === -1) return;
        const popup = this.popupList[popupIndex];
        if (popup.stopAnchoringPromise) popup.stopAnchoringPromise.then((destroyFunc)=>destroyFunc && destroyFunc());
        popup.stopAnchoringPromise = void 0;
        popup.isAnchored = false;
        if (!relativeElement) return;
        const destroyPositionTracker = this.keepPopupPositionedRelativeTo({
            element: relativeElement,
            ePopup: popupEl,
            hidePopup: popup.hideFunc
        });
        popup.stopAnchoringPromise = destroyPositionTracker;
        popup.isAnchored = true;
        return destroyPositionTracker;
    }
    removePopupFromPopupList(element) {
        this.setAlignedStyles(element, null);
        this.setPopupPositionRelatedToElement(element, null);
        this.popupList = this.popupList.filter((p)=>p.element !== element);
    }
    keepPopupPositionedRelativeTo(params) {
        const eParent = this.getPopupParent();
        const parentRect = eParent.getBoundingClientRect();
        const { element: element, ePopup: ePopup } = params;
        const sourceRect = element.getBoundingClientRect();
        const initialDiffTop = parentRect.top - sourceRect.top;
        const initialDiffLeft = parentRect.left - sourceRect.left;
        let lastDiffTop = initialDiffTop;
        let lastDiffLeft = initialDiffLeft;
        const topPx = ePopup.style.top;
        const top = parseInt(topPx.substring(0, topPx.length - 1), 10);
        const leftPx = ePopup.style.left;
        const left = parseInt(leftPx.substring(0, leftPx.length - 1), 10);
        return new $437b23f6a393c3bf$export$30ec7836a4847721((resolve)=>{
            this.getFrameworkOverrides().setInterval(()=>{
                const pRect = eParent.getBoundingClientRect();
                const sRect = element.getBoundingClientRect();
                const elementNotInDom = sRect.top == 0 && sRect.left == 0 && sRect.height == 0 && sRect.width == 0;
                if (elementNotInDom) {
                    params.hidePopup();
                    return;
                }
                const currentDiffTop = pRect.top - sRect.top;
                if (currentDiffTop != lastDiffTop) {
                    const newTop = this.keepXYWithinBounds(ePopup, top + initialDiffTop - currentDiffTop, 0 /* vertical */ );
                    ePopup.style.top = `${newTop}px`;
                }
                lastDiffTop = currentDiffTop;
                const currentDiffLeft = pRect.left - sRect.left;
                if (currentDiffLeft != lastDiffLeft) {
                    const newLeft = this.keepXYWithinBounds(ePopup, left + initialDiffLeft - currentDiffLeft, 1 /* horizontal */ );
                    ePopup.style.left = `${newLeft}px`;
                }
                lastDiffLeft = currentDiffLeft;
            }, 200).then((intervalId)=>{
                const result = ()=>{
                    if (intervalId != null) window.clearInterval(intervalId);
                };
                resolve(result);
            });
        });
    }
    hasAnchoredPopup() {
        return this.popupList.some((popup)=>popup.isAnchored);
    }
    isEventFromCurrentPopup(params, target) {
        const { mouseEvent: mouseEvent, touchEvent: touchEvent } = params;
        const event = mouseEvent ? mouseEvent : touchEvent;
        if (!event) return false;
        const indexOfThisChild = this.getPopupIndex(target);
        if (indexOfThisChild === -1) return false;
        for(let i = indexOfThisChild; i < this.popupList.length; i++){
            const popup = this.popupList[i];
            if ($437b23f6a393c3bf$var$isElementInEventPath(popup.element, event)) return true;
        }
        return this.isElementWithinCustomPopup(event.target);
    }
    isElementWithinCustomPopup(el) {
        const eDocument = this.gos.getDocument();
        while(el && el !== eDocument.body){
            if (el.classList.contains("ag-custom-component-popup") || el.parentElement === null) return true;
            el = el.parentElement;
        }
        return false;
    }
    getWrapper(ePopup) {
        while(!ePopup.classList.contains("ag-popup") && ePopup.parentElement)ePopup = ePopup.parentElement;
        return ePopup.classList.contains("ag-popup") ? ePopup : null;
    }
    setAlwaysOnTop(ePopup, alwaysOnTop) {
        const eWrapper = this.getWrapper(ePopup);
        if (!eWrapper) return;
        eWrapper.classList.toggle("ag-always-on-top", !!alwaysOnTop);
        if (alwaysOnTop) this.bringPopupToFront(eWrapper);
    }
    bringPopupToFront(ePopup) {
        const parent = this.getPopupParent();
        const popupList = Array.prototype.slice.call(parent.querySelectorAll(".ag-popup"));
        const popupLen = popupList.length;
        const alwaysOnTopList = Array.prototype.slice.call(parent.querySelectorAll(".ag-popup.ag-always-on-top"));
        const onTopLength = alwaysOnTopList.length;
        const eWrapper = this.getWrapper(ePopup);
        if (!eWrapper || popupLen <= 1 || !parent.contains(ePopup)) return;
        const pos = popupList.indexOf(eWrapper);
        const innerEls = eWrapper.querySelectorAll("div");
        const innerElsScrollMap = [];
        innerEls.forEach((el)=>{
            if (el.scrollTop !== 0) innerElsScrollMap.push([
                el,
                el.scrollTop
            ]);
        });
        if (onTopLength) {
            const isPopupAlwaysOnTop = eWrapper.classList.contains("ag-always-on-top");
            if (isPopupAlwaysOnTop) {
                if (pos !== popupLen - 1) $437b23f6a393c3bf$var$last(alwaysOnTopList).insertAdjacentElement("afterend", eWrapper);
            } else if (pos !== popupLen - onTopLength - 1) alwaysOnTopList[0].insertAdjacentElement("beforebegin", eWrapper);
        } else if (pos !== popupLen - 1) $437b23f6a393c3bf$var$last(popupList).insertAdjacentElement("afterend", eWrapper);
        while(innerElsScrollMap.length){
            const currentEl = innerElsScrollMap.pop();
            currentEl[0].scrollTop = currentEl[1];
        }
    }
};
$437b23f6a393c3bf$export$27497a369f7303c1.WAIT_FOR_POPUP_CONTENT_RESIZE = 200;
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("focusService")
], $437b23f6a393c3bf$export$27497a369f7303c1.prototype, "focusService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("ctrlsService")
], $437b23f6a393c3bf$export$27497a369f7303c1.prototype, "ctrlsService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("resizeObserverService")
], $437b23f6a393c3bf$export$27497a369f7303c1.prototype, "resizeObserverService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$export$27497a369f7303c1.prototype, "postConstruct", 1);
$437b23f6a393c3bf$export$27497a369f7303c1 = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("popupService")
], $437b23f6a393c3bf$export$27497a369f7303c1);
// community-modules/core/src/widgets/agAutocompleteRow.ts
var $437b23f6a393c3bf$var$AgAutocompleteRow = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super(/* html */ `
        <div class="ag-autocomplete-row" role="presentation">
            <div class="ag-autocomplete-row-label"></div>
        </div>`);
        this.hasHighlighting = false;
    }
    setState(value, selected) {
        this.value = value;
        this.render();
        this.updateSelected(selected);
    }
    updateSelected(selected) {
        this.addOrRemoveCssClass("ag-autocomplete-row-selected", selected);
    }
    setSearchString(searchString) {
        var _a;
        let keepHighlighting = false;
        if ($437b23f6a393c3bf$var$exists(searchString)) {
            const index = (_a = this.value) == null ? void 0 : _a.toLocaleLowerCase().indexOf(searchString.toLocaleLowerCase());
            if (index >= 0) {
                keepHighlighting = true;
                this.hasHighlighting = true;
                const highlightEndIndex = index + searchString.length;
                const startPart = $437b23f6a393c3bf$var$escapeString(this.value.slice(0, index));
                const highlightedPart = $437b23f6a393c3bf$var$escapeString(this.value.slice(index, highlightEndIndex));
                const endPart = $437b23f6a393c3bf$var$escapeString(this.value.slice(highlightEndIndex));
                this.getGui().lastElementChild.innerHTML = `${startPart}<b>${highlightedPart}</b>${endPart}`;
            }
        }
        if (!keepHighlighting && this.hasHighlighting) {
            this.hasHighlighting = false;
            this.render();
        }
    }
    render() {
        var _a;
        this.getGui().lastElementChild.innerHTML = (_a = $437b23f6a393c3bf$var$escapeString(this.value)) != null ? _a : "&nbsp;";
    }
};
// community-modules/core/src/widgets/agAutocompleteList.ts
var $437b23f6a393c3bf$var$_AgAutocompleteList = class _AgAutocompleteList extends $437b23f6a393c3bf$export$9fac2d040f3ed438 {
    constructor(params){
        super(_AgAutocompleteList.TEMPLATE);
        this.params = params;
        this.searchString = "";
    }
    destroy() {
        super.destroy();
    }
    init() {
        this.autocompleteEntries = this.params.autocompleteEntries;
        this.virtualList = this.createManagedBean(new $437b23f6a393c3bf$export$8aa850fa810c1c21({
            cssIdentifier: "autocomplete"
        }));
        this.virtualList.setComponentCreator(this.createRowComponent.bind(this));
        this.eList.appendChild(this.virtualList.getGui());
        this.virtualList.setModel({
            getRowCount: ()=>this.autocompleteEntries.length,
            getRow: (index)=>this.autocompleteEntries[index]
        });
        const virtualListGui = this.virtualList.getGui();
        this.addManagedListener(virtualListGui, "click", ()=>this.params.onConfirmed());
        this.addManagedListener(virtualListGui, "mousemove", this.onMouseMove.bind(this));
        this.addManagedListener(virtualListGui, "mousedown", (e)=>e.preventDefault());
        this.setSelectedValue(0);
    }
    onNavigationKeyDown(event, key) {
        event.preventDefault();
        const oldIndex = this.autocompleteEntries.indexOf(this.selectedValue);
        const newIndex = key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP ? oldIndex - 1 : oldIndex + 1;
        this.checkSetSelectedValue(newIndex);
    }
    setSearch(searchString) {
        this.searchString = searchString;
        if ($437b23f6a393c3bf$var$exists(searchString)) this.runSearch();
        else {
            this.autocompleteEntries = this.params.autocompleteEntries;
            this.virtualList.refresh();
            this.checkSetSelectedValue(0);
        }
        this.updateSearchInList();
    }
    runContainsSearch(searchString, searchStrings) {
        let topMatch;
        let topMatchStartsWithSearchString = false;
        const lowerCaseSearchString = searchString.toLocaleLowerCase();
        const allMatches = searchStrings.filter((string)=>{
            const lowerCaseString = string.toLocaleLowerCase();
            const index = lowerCaseString.indexOf(lowerCaseSearchString);
            const startsWithSearchString = index === 0;
            const isMatch = index >= 0;
            if (isMatch && (!topMatch || !topMatchStartsWithSearchString && startsWithSearchString || topMatchStartsWithSearchString === startsWithSearchString && string.length < topMatch.length)) {
                topMatch = string;
                topMatchStartsWithSearchString = startsWithSearchString;
            }
            return isMatch;
        });
        if (!topMatch && allMatches.length) topMatch = allMatches[0];
        return {
            topMatch: topMatch,
            allMatches: allMatches
        };
    }
    runSearch() {
        var _a, _b;
        const { autocompleteEntries: autocompleteEntries } = this.params;
        const searchStrings = autocompleteEntries.map((v)=>{
            var _a2;
            return (_a2 = v.displayValue) != null ? _a2 : v.key;
        });
        let matchingStrings;
        let topSuggestion;
        if (this.params.useFuzzySearch) {
            matchingStrings = $437b23f6a393c3bf$var$fuzzySuggestions(this.searchString, searchStrings, true).values;
            topSuggestion = matchingStrings.length ? matchingStrings[0] : void 0;
        } else {
            const containsMatches = this.runContainsSearch(this.searchString, searchStrings);
            matchingStrings = containsMatches.allMatches;
            topSuggestion = containsMatches.topMatch;
        }
        let filteredEntries = autocompleteEntries.filter(({ key: key, displayValue: displayValue })=>matchingStrings.includes(displayValue != null ? displayValue : key));
        if (!filteredEntries.length && this.selectedValue && ((_b = (_a = this.params) == null ? void 0 : _a.forceLastSelection) == null ? void 0 : _b.call(_a, this.selectedValue, this.searchString))) filteredEntries = [
            this.selectedValue
        ];
        this.autocompleteEntries = filteredEntries;
        this.virtualList.refresh();
        if (!topSuggestion) return;
        const topSuggestionIndex = matchingStrings.indexOf(topSuggestion);
        this.checkSetSelectedValue(topSuggestionIndex);
    }
    updateSearchInList() {
        this.virtualList.forEachRenderedRow((row)=>row.setSearchString(this.searchString));
    }
    checkSetSelectedValue(index) {
        if (index >= 0 && index < this.autocompleteEntries.length) this.setSelectedValue(index);
    }
    setSelectedValue(index) {
        const value = this.autocompleteEntries[index];
        if (this.selectedValue === value) return;
        this.selectedValue = value;
        this.virtualList.ensureIndexVisible(index);
        this.virtualList.forEachRenderedRow((cmp, idx)=>{
            cmp.updateSelected(index === idx);
        });
    }
    createRowComponent(value) {
        var _a;
        const row = new $437b23f6a393c3bf$var$AgAutocompleteRow();
        this.getContext().createBean(row);
        row.setState((_a = value.displayValue) != null ? _a : value.key, value === this.selectedValue);
        return row;
    }
    onMouseMove(mouseEvent) {
        const rect = this.virtualList.getGui().getBoundingClientRect();
        const scrollTop = this.virtualList.getScrollTop();
        const mouseY = mouseEvent.clientY - rect.top + scrollTop;
        const row = Math.floor(mouseY / this.virtualList.getRowHeight());
        this.checkSetSelectedValue(row);
    }
    afterGuiAttached() {
        this.virtualList.refresh();
    }
    getSelectedValue() {
        var _a;
        if (!this.autocompleteEntries.length) return null;
        return (_a = this.selectedValue) != null ? _a : null;
    }
};
$437b23f6a393c3bf$var$_AgAutocompleteList.TEMPLATE = /* html */ `<div class="ag-autocomplete-list-popup">
            <div ref="eList" class="ag-autocomplete-list"></div>
        <div>`;
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eList")
], $437b23f6a393c3bf$var$_AgAutocompleteList.prototype, "eList", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$_AgAutocompleteList.prototype, "init", 1);
var $437b23f6a393c3bf$var$AgAutocompleteList = $437b23f6a393c3bf$var$_AgAutocompleteList;
// community-modules/core/src/widgets/agAutocomplete.ts
var $437b23f6a393c3bf$var$_AgAutocomplete = class _AgAutocomplete extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super(/* html */ `
            <div class="ag-autocomplete" role="presentation">
                <ag-input-text-field ref="eAutocompleteInput"></ag-input-text-field>
            </div>`);
        this.isListOpen = false;
        this.lastPosition = 0;
        this.valid = true;
    }
    postConstruct() {
        this.eAutocompleteInput.onValueChange((value)=>this.onValueChanged(value));
        this.eAutocompleteInput.getInputElement().setAttribute("autocomplete", "off");
        this.addGuiEventListener("keydown", this.onKeyDown.bind(this));
        this.addGuiEventListener("click", this.updatePositionAndList.bind(this));
        this.addDestroyFunc(()=>{
            this.destroyBean(this.autocompleteList);
        });
        this.addGuiEventListener("focusout", ()=>this.onFocusOut());
    }
    onValueChanged(value) {
        const parsedValue = $437b23f6a393c3bf$var$makeNull(value);
        this.updateValue(parsedValue);
        this.updateAutocompleteList(parsedValue);
    }
    updateValue(value) {
        this.updateLastPosition();
        this.dispatchEvent({
            type: _AgAutocomplete.EVENT_VALUE_CHANGED,
            value: value
        });
        this.validate(value);
    }
    updateAutocompleteList(value) {
        var _a, _b, _c, _d;
        const autocompleteListParams = (_b = (_a = this.listGenerator) == null ? void 0 : _a.call(this, value, this.lastPosition)) != null ? _b : {
            enabled: false
        };
        if (!autocompleteListParams.type || autocompleteListParams.type !== ((_c = this.autocompleteListParams) == null ? void 0 : _c.type)) {
            if (this.isListOpen) this.closeList();
        }
        this.autocompleteListParams = autocompleteListParams;
        if ((_d = this.autocompleteListParams) == null ? void 0 : _d.enabled) {
            if (!this.isListOpen) this.openList();
            const { searchString: searchString } = this.autocompleteListParams;
            this.autocompleteList.setSearch(searchString != null ? searchString : "");
        } else if (this.isListOpen) this.closeList();
    }
    onKeyDown(event) {
        const key = event.key;
        this.updateLastPosition();
        switch(key){
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER:
                this.onEnterKeyDown(event);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.TAB:
                this.onTabKeyDown(event);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
                this.onUpDownKeyDown(event, key);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_HOME:
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.PAGE_END:
                setTimeout(()=>{
                    this.updatePositionAndList();
                });
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.ESCAPE:
                this.onEscapeKeyDown(event);
                break;
            case $437b23f6a393c3bf$export$e9e0d96f49f57c33.SPACE:
                if (event.ctrlKey && !this.isListOpen) {
                    event.preventDefault();
                    this.forceOpenList();
                }
                break;
        }
    }
    confirmSelection() {
        var _a;
        const selectedValue = (_a = this.autocompleteList) == null ? void 0 : _a.getSelectedValue();
        if (selectedValue) {
            this.closeList();
            this.dispatchEvent({
                type: _AgAutocomplete.EVENT_OPTION_SELECTED,
                value: this.getValue(),
                position: this.lastPosition,
                updateEntry: selectedValue,
                autocompleteType: this.autocompleteListParams.type
            });
        }
    }
    onTabKeyDown(event) {
        if (this.isListOpen) {
            event.preventDefault();
            event.stopPropagation();
            this.confirmSelection();
        }
    }
    onEnterKeyDown(event) {
        event.preventDefault();
        if (this.isListOpen) this.confirmSelection();
        else this.onCompleted();
    }
    onUpDownKeyDown(event, key) {
        var _a;
        event.preventDefault();
        if (!this.isListOpen) this.forceOpenList();
        else (_a = this.autocompleteList) == null || _a.onNavigationKeyDown(event, key);
    }
    onEscapeKeyDown(event) {
        if (this.isListOpen) {
            event.preventDefault();
            event.stopPropagation();
            this.closeList();
            this.setCaret(this.lastPosition, true);
        }
    }
    onFocusOut() {
        if (this.isListOpen) this.closeList();
    }
    updatePositionAndList() {
        var _a;
        this.updateLastPosition();
        this.updateAutocompleteList((_a = this.eAutocompleteInput.getValue()) != null ? _a : null);
    }
    setCaret(position, setFocus) {
        const eDocument = this.gos.getDocument();
        const activeEl = this.gos.getActiveDomElement();
        if (setFocus && (!activeEl || activeEl === eDocument.body)) this.eAutocompleteInput.getFocusableElement().focus();
        const eInput = this.eAutocompleteInput.getInputElement();
        eInput.setSelectionRange(position, position);
        if (position === eInput.value.length) eInput.scrollLeft = eInput.scrollWidth;
    }
    forceOpenList() {
        this.onValueChanged(this.eAutocompleteInput.getValue());
    }
    updateLastPosition() {
        var _a;
        this.lastPosition = (_a = this.eAutocompleteInput.getInputElement().selectionStart) != null ? _a : 0;
    }
    validate(value) {
        var _a;
        if (!this.validator) return;
        this.validationMessage = this.validator(value);
        this.eAutocompleteInput.getInputElement().setCustomValidity((_a = this.validationMessage) != null ? _a : "");
        this.valid = !this.validationMessage;
        this.dispatchEvent({
            type: _AgAutocomplete.EVENT_VALID_CHANGED,
            isValid: this.valid,
            validationMessage: this.validationMessage
        });
    }
    openList() {
        this.isListOpen = true;
        this.autocompleteList = this.createBean(new $437b23f6a393c3bf$var$AgAutocompleteList({
            autocompleteEntries: this.autocompleteListParams.entries,
            onConfirmed: ()=>this.confirmSelection(),
            forceLastSelection: this.forceLastSelection
        }));
        const ePopupGui = this.autocompleteList.getGui();
        const positionParams = {
            ePopup: ePopupGui,
            type: "autocomplete",
            eventSource: this.getGui(),
            position: "under",
            alignSide: this.gos.get("enableRtl") ? "right" : "left",
            keepWithinBounds: true
        };
        const addPopupRes = this.popupService.addPopup({
            eChild: ePopupGui,
            anchorToElement: this.getGui(),
            positionCallback: ()=>this.popupService.positionPopupByComponent(positionParams),
            ariaLabel: this.listAriaLabel
        });
        this.hidePopup = addPopupRes.hideFunc;
        this.autocompleteList.afterGuiAttached();
    }
    closeList() {
        this.isListOpen = false;
        this.hidePopup();
        this.destroyBean(this.autocompleteList);
        this.autocompleteList = null;
    }
    onCompleted() {
        if (this.isListOpen) this.closeList();
        this.dispatchEvent({
            type: _AgAutocomplete.EVENT_VALUE_CONFIRMED,
            value: this.getValue(),
            isValid: this.isValid()
        });
    }
    getValue() {
        return $437b23f6a393c3bf$var$makeNull(this.eAutocompleteInput.getValue());
    }
    setInputPlaceholder(placeholder) {
        this.eAutocompleteInput.setInputPlaceholder(placeholder);
        return this;
    }
    setInputAriaLabel(label) {
        this.eAutocompleteInput.setInputAriaLabel(label);
        return this;
    }
    setListAriaLabel(label) {
        this.listAriaLabel = label;
        return this;
    }
    setListGenerator(listGenerator) {
        this.listGenerator = listGenerator;
        return this;
    }
    setValidator(validator) {
        this.validator = validator;
        return this;
    }
    isValid() {
        return this.valid;
    }
    setValue(params) {
        const { value: value, position: position, silent: silent, updateListOnlyIfOpen: updateListOnlyIfOpen, restoreFocus: restoreFocus } = params;
        this.eAutocompleteInput.setValue(value, true);
        this.setCaret(position != null ? position : this.lastPosition, restoreFocus);
        if (!silent) this.updateValue(value);
        if (!updateListOnlyIfOpen || this.isListOpen) this.updateAutocompleteList(value);
    }
    setForceLastSelection(forceLastSelection) {
        this.forceLastSelection = forceLastSelection;
        return this;
    }
    setInputDisabled(disabled) {
        this.eAutocompleteInput.setDisabled(disabled);
        return this;
    }
};
$437b23f6a393c3bf$var$_AgAutocomplete.EVENT_VALUE_CHANGED = "eventValueChanged";
$437b23f6a393c3bf$var$_AgAutocomplete.EVENT_VALUE_CONFIRMED = "eventValueConfirmed";
$437b23f6a393c3bf$var$_AgAutocomplete.EVENT_OPTION_SELECTED = "eventOptionSelected";
$437b23f6a393c3bf$var$_AgAutocomplete.EVENT_VALID_CHANGED = "eventValidChanged";
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("popupService")
], $437b23f6a393c3bf$var$_AgAutocomplete.prototype, "popupService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eAutocompleteInput")
], $437b23f6a393c3bf$var$_AgAutocomplete.prototype, "eAutocompleteInput", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$_AgAutocomplete.prototype, "postConstruct", 1);
var $437b23f6a393c3bf$export$b26fb295f8aa6b61 = $437b23f6a393c3bf$var$_AgAutocomplete;
// community-modules/core/src/widgets/pillDragComp.ts
var $437b23f6a393c3bf$var$_PillDragComp = class _PillDragComp extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(dragSourceDropTarget, ghost, horizontal, template){
        super();
        this.dragSourceDropTarget = dragSourceDropTarget;
        this.ghost = ghost;
        this.horizontal = horizontal;
        this.template = template;
    }
    init() {
        var _a;
        this.setTemplate((_a = this.template) != null ? _a : _PillDragComp.TEMPLATE);
        const eGui = this.getGui();
        this.addElementClasses(eGui);
        this.addElementClasses(this.eDragHandle, "drag-handle");
        this.addElementClasses(this.eText, "text");
        this.addElementClasses(this.eButton, "button");
        this.eDragHandle.appendChild($437b23f6a393c3bf$var$createIconNoSpan("columnDrag", this.gos));
        this.eButton.appendChild($437b23f6a393c3bf$var$createIconNoSpan("cancel", this.gos));
        this.setupComponents();
        if (!this.ghost && this.isDraggable()) this.addDragSource();
        this.setupAria();
        this.setupTooltip();
        this.activateTabIndex();
        this.refreshDraggable();
    }
    isDraggable() {
        return true;
    }
    refreshDraggable() {
        this.eDragHandle.classList.toggle("ag-column-select-column-readonly", !this.isDraggable());
    }
    setupAria() {
        const translate = this.localeService.getLocaleTextFunc();
        const ariaInstructions = [
            this.getAriaDisplayName()
        ];
        this.addAdditionalAriaInstructions(ariaInstructions, translate);
        $437b23f6a393c3bf$var$setAriaLabel(this.getGui(), ariaInstructions.join(". "));
    }
    addAdditionalAriaInstructions(ariaInstructions, translate) {
        if (this.isRemovable()) {
            const deleteAria = translate("ariaDropZoneColumnComponentDescription", "Press DELETE to remove");
            ariaInstructions.push(deleteAria);
        }
    }
    setupTooltip() {
        const refresh = ()=>{
            const newTooltipText = this.getTooltip();
            this.setTooltip({
                newTooltipText: newTooltipText
            });
        };
        refresh();
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_NEW_COLUMNS_LOADED, refresh);
    }
    getDragSourceId() {
        return void 0;
    }
    getDefaultIconName() {
        return $437b23f6a393c3bf$export$3529111922becfa6.ICON_NOT_ALLOWED;
    }
    addDragSource() {
        const { dragAndDropService: dragAndDropService, eDragHandle: eDragHandle } = this;
        const getDragItem = this.createGetDragItem();
        const defaultIconName = this.getDefaultIconName();
        const dragSource = {
            type: this.getDragSourceType(),
            sourceId: this.getDragSourceId(),
            eElement: eDragHandle,
            getDefaultIconName: ()=>defaultIconName,
            getDragItem: getDragItem,
            dragItemName: this.getDisplayName()
        };
        dragAndDropService.addDragSource(dragSource, true);
        this.addDestroyFunc(()=>dragAndDropService.removeDragSource(dragSource));
    }
    setupComponents() {
        this.setTextValue();
        this.setupRemove();
        if (this.ghost) this.addCssClass("ag-column-drop-cell-ghost");
    }
    isRemovable() {
        return true;
    }
    refreshRemove() {
        $437b23f6a393c3bf$var$setDisplayed(this.eButton, this.isRemovable());
    }
    setupRemove() {
        this.refreshRemove();
        const agEvent = {
            type: _PillDragComp.EVENT_COLUMN_REMOVE
        };
        this.addGuiEventListener("keydown", (e)=>this.onKeyDown(e));
        this.addManagedListener(this.eButton, "click", (mouseEvent)=>{
            this.dispatchEvent(agEvent);
            mouseEvent.stopPropagation();
        });
        const touchListener = new $437b23f6a393c3bf$export$7b2e93987414b382(this.eButton);
        this.addManagedListener(touchListener, $437b23f6a393c3bf$export$7b2e93987414b382.EVENT_TAP, ()=>{
            this.dispatchEvent(agEvent);
        });
        this.addDestroyFunc(touchListener.destroy.bind(touchListener));
    }
    onKeyDown(e) {
        const isDelete = e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.DELETE;
        if (isDelete) {
            if (this.isRemovable()) {
                e.preventDefault();
                this.dispatchEvent({
                    type: _PillDragComp.EVENT_COLUMN_REMOVE
                });
            }
        }
    }
    getDisplayValue() {
        return this.getDisplayName();
    }
    setTextValue() {
        const displayValue = this.getDisplayValue();
        const displayValueSanitised = $437b23f6a393c3bf$var$escapeString(displayValue);
        this.eText.innerHTML = displayValueSanitised;
    }
    addElementClasses(el, suffix) {
        suffix = suffix ? `-${suffix}` : "";
        const direction = this.horizontal ? "horizontal" : "vertical";
        el.classList.add(`ag-column-drop-cell${suffix}`, `ag-column-drop-${direction}-cell${suffix}`);
    }
    destroy() {
        super.destroy();
        this.dragSourceDropTarget = null;
    }
};
$437b23f6a393c3bf$var$_PillDragComp.EVENT_COLUMN_REMOVE = "columnRemove";
$437b23f6a393c3bf$var$_PillDragComp.TEMPLATE = /* html */ `<span role="option">
          <span ref="eDragHandle" class="ag-drag-handle ag-column-drop-cell-drag-handle" role="presentation"></span>
          <span ref="eText" class="ag-column-drop-cell-text" aria-hidden="true"></span>
          <span ref="eButton" class="ag-column-drop-cell-button" role="presentation"></span>
        </span>`;
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("dragAndDropService")
], $437b23f6a393c3bf$var$_PillDragComp.prototype, "dragAndDropService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eText")
], $437b23f6a393c3bf$var$_PillDragComp.prototype, "eText", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eDragHandle")
], $437b23f6a393c3bf$var$_PillDragComp.prototype, "eDragHandle", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eButton")
], $437b23f6a393c3bf$var$_PillDragComp.prototype, "eButton", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$_PillDragComp.prototype, "init", 1);
var $437b23f6a393c3bf$export$35edd0e9295b87d1 = $437b23f6a393c3bf$var$_PillDragComp;
// community-modules/core/src/widgets/pillDropZonePanel.ts
var $437b23f6a393c3bf$var$_PillDropZonePanel = class _PillDropZonePanel extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(horizontal){
        super(/* html */ `<div class="ag-unselectable" role="presentation"></div>`);
        this.horizontal = horizontal;
        this.state = _PillDropZonePanel.STATE_NOT_DRAGGING;
        this.guiDestroyFunctions = [];
        this.childPillComponents = [];
        this.resizeEnabled = false;
        this.addElementClasses(this.getGui());
        this.ePillDropList = document.createElement("div");
        this.addElementClasses(this.ePillDropList, "list");
        $437b23f6a393c3bf$var$setAriaRole(this.ePillDropList, "listbox");
    }
    isHorizontal() {
        return this.horizontal;
    }
    toggleResizable(resizable) {
        this.positionableFeature.setResizable(resizable ? {
            bottom: true
        } : false);
        this.resizeEnabled = resizable;
    }
    isSourceEventFromTarget(draggingEvent) {
        const { dropZoneTarget: dropZoneTarget, dragSource: dragSource } = draggingEvent;
        return dropZoneTarget.contains(dragSource.eElement);
    }
    destroy() {
        this.destroyGui();
        super.destroy();
    }
    destroyGui() {
        this.guiDestroyFunctions.forEach((func)=>func());
        this.guiDestroyFunctions.length = 0;
        this.childPillComponents.length = 0;
        $437b23f6a393c3bf$var$clearElement(this.getGui());
        $437b23f6a393c3bf$var$clearElement(this.ePillDropList);
    }
    init(params) {
        this.params = params != null ? params : {};
        this.createManagedBean(new $437b23f6a393c3bf$export$5510e53ed3962582(this.getFocusableElement(), {
            handleKeyDown: this.handleKeyDown.bind(this)
        }));
        this.setupDropTarget();
        this.positionableFeature = new $437b23f6a393c3bf$export$c53a5d9f1fb0f7f6(this.getGui(), {
            minHeight: 100
        });
        this.createManagedBean(this.positionableFeature);
        this.refreshGui();
        $437b23f6a393c3bf$var$setAriaLabel(this.ePillDropList, this.getAriaLabel());
    }
    handleKeyDown(e) {
        const isVertical = !this.horizontal;
        let isNext = e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN;
        let isPrevious = e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP;
        if (!isVertical) {
            const isRtl = this.gos.get("enableRtl");
            isNext = !isRtl && e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT || isRtl && e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT;
            isPrevious = !isRtl && e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT || isRtl && e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT;
        }
        if (!isNext && !isPrevious) return;
        const el = this.focusService.findNextFocusableElement(this.getFocusableElement(), false, isPrevious);
        if (el) {
            e.preventDefault();
            el.focus();
        }
    }
    addElementClasses(el, suffix) {
        suffix = suffix ? `-${suffix}` : "";
        const direction = this.horizontal ? "horizontal" : "vertical";
        el.classList.add(`ag-column-drop${suffix}`, `ag-column-drop-${direction}${suffix}`);
    }
    setupDropTarget() {
        this.dropTarget = {
            getContainer: this.getGui.bind(this),
            getIconName: this.getIconName.bind(this),
            onDragging: this.onDragging.bind(this),
            onDragEnter: this.onDragEnter.bind(this),
            onDragLeave: this.onDragLeave.bind(this),
            onDragStop: this.onDragStop.bind(this),
            isInterestedIn: this.isInterestedIn.bind(this)
        };
        this.dragAndDropService.addDropTarget(this.dropTarget);
    }
    minimumAllowedNewInsertIndex() {
        return 0;
    }
    checkInsertIndex(draggingEvent) {
        const newIndex = this.getNewInsertIndex(draggingEvent);
        if (newIndex < 0) return false;
        const minimumAllowedIndex = this.minimumAllowedNewInsertIndex();
        const newAdjustedIndex = Math.max(minimumAllowedIndex, newIndex);
        const changed = newAdjustedIndex !== this.insertIndex;
        if (changed) this.insertIndex = newAdjustedIndex;
        return changed;
    }
    getNewInsertIndex(draggingEvent) {
        const mouseEvent = draggingEvent.event;
        const mouseLocation = this.horizontal ? mouseEvent.clientX : mouseEvent.clientY;
        const boundsList = this.childPillComponents.map((comp)=>comp.getGui().getBoundingClientRect());
        const hoveredIndex = boundsList.findIndex((rect)=>this.horizontal ? rect.right > mouseLocation && rect.left < mouseLocation : rect.top < mouseLocation && rect.bottom > mouseLocation);
        if (hoveredIndex === -1) {
            const enableRtl = this.gos.get("enableRtl");
            const isLast = boundsList.every((rect)=>mouseLocation > (this.horizontal ? rect.right : rect.bottom));
            if (isLast) return enableRtl && this.horizontal ? 0 : this.childPillComponents.length;
            const isFirst = boundsList.every((rect)=>mouseLocation < (this.horizontal ? rect.left : rect.top));
            if (isFirst) return enableRtl && this.horizontal ? this.childPillComponents.length : 0;
            return this.insertIndex;
        }
        if (this.insertIndex <= hoveredIndex) return hoveredIndex + 1;
        return hoveredIndex;
    }
    checkDragStartedBySelf(draggingEvent) {
        if (this.state !== _PillDropZonePanel.STATE_NOT_DRAGGING) return;
        this.state = _PillDropZonePanel.STATE_REARRANGE_ITEMS;
        this.potentialDndItems = this.getItems(draggingEvent.dragSource.getDragItem());
        this.refreshGui();
        this.checkInsertIndex(draggingEvent);
        this.refreshGui();
    }
    onDragging(draggingEvent) {
        this.checkDragStartedBySelf(draggingEvent);
        if (this.checkInsertIndex(draggingEvent)) this.refreshGui();
    }
    handleDragEnterEnd(draggingEvent) {}
    onDragEnter(draggingEvent) {
        const dragItems = this.getItems(draggingEvent.dragSource.getDragItem());
        this.state = _PillDropZonePanel.STATE_NEW_ITEMS_IN;
        const goodDragItems = dragItems.filter((item)=>this.isItemDroppable(item, draggingEvent));
        const alreadyPresent = goodDragItems.every((item)=>this.childPillComponents.map((cmp)=>cmp.getItem()).indexOf(item) !== -1);
        if (goodDragItems.length === 0) return;
        this.potentialDndItems = goodDragItems;
        if (alreadyPresent) {
            this.state = _PillDropZonePanel.STATE_NOT_DRAGGING;
            return;
        }
        this.handleDragEnterEnd(draggingEvent);
        this.checkInsertIndex(draggingEvent);
        this.refreshGui();
    }
    isPotentialDndItems() {
        return $437b23f6a393c3bf$var$existsAndNotEmpty(this.potentialDndItems);
    }
    handleDragLeaveEnd(draggingEvent) {}
    onDragLeave(draggingEvent) {
        if (this.state === _PillDropZonePanel.STATE_REARRANGE_ITEMS) {
            const items = this.getItems(draggingEvent.dragSource.getDragItem());
            this.removeItems(items);
        }
        if (this.isPotentialDndItems()) {
            this.handleDragLeaveEnd(draggingEvent);
            this.potentialDndItems = [];
            this.refreshGui();
        }
        this.state = _PillDropZonePanel.STATE_NOT_DRAGGING;
    }
    refreshOnDragStop() {
        return true;
    }
    onDragStop() {
        if (this.isPotentialDndItems()) {
            let success = false;
            if (this.state === _PillDropZonePanel.STATE_NEW_ITEMS_IN) {
                this.addItems(this.potentialDndItems);
                success = true;
            } else success = this.rearrangeItems(this.potentialDndItems);
            this.potentialDndItems = [];
            if (this.refreshOnDragStop() || !success) this.refreshGui();
        }
        this.state = _PillDropZonePanel.STATE_NOT_DRAGGING;
    }
    removeItems(itemsToRemove) {
        const newItemList = this.getExistingItems().filter((item)=>!$437b23f6a393c3bf$var$includes(itemsToRemove, item));
        this.updateItems(newItemList);
    }
    addItems(itemsToAdd) {
        if (!itemsToAdd) return;
        const newItemList = this.getExistingItems().slice();
        const itemsToAddNoDuplicates = itemsToAdd.filter((item)=>newItemList.indexOf(item) < 0);
        $437b23f6a393c3bf$var$insertArrayIntoArray(newItemList, itemsToAddNoDuplicates, this.insertIndex);
        this.updateItems(newItemList);
    }
    addItem(item) {
        this.insertIndex = this.getExistingItems().length;
        this.addItems([
            item
        ]);
        this.refreshGui();
    }
    rearrangeItems(itemsToAdd) {
        const newItemList = this.getNonGhostItems().slice();
        $437b23f6a393c3bf$var$insertArrayIntoArray(newItemList, itemsToAdd, this.insertIndex);
        if ($437b23f6a393c3bf$var$areEqual(newItemList, this.getExistingItems())) return false;
        this.updateItems(newItemList);
        return true;
    }
    refreshGui() {
        const scrollTop = this.ePillDropList.scrollTop;
        const resizeEnabled = this.resizeEnabled;
        const focusedIndex = this.getFocusedItem();
        let alternateElement = this.focusService.findNextFocusableElement();
        if (!alternateElement) alternateElement = this.focusService.findNextFocusableElement(void 0, false, true);
        this.toggleResizable(false);
        this.destroyGui();
        this.addIconAndTitleToGui();
        this.addEmptyMessageToGui();
        this.addItemsToGui();
        if (!this.isHorizontal()) this.ePillDropList.scrollTop = scrollTop;
        if (resizeEnabled) this.toggleResizable(resizeEnabled);
        if (this.focusService.isKeyboardMode()) this.restoreFocus(focusedIndex, alternateElement);
    }
    getFocusedItem() {
        const eGui = this.getGui();
        const activeElement = this.gos.getActiveDomElement();
        if (!eGui.contains(activeElement)) return -1;
        const items = Array.from(eGui.querySelectorAll(".ag-column-drop-cell"));
        return items.indexOf(activeElement);
    }
    restoreFocus(index, alternateElement) {
        const eGui = this.getGui();
        const items = Array.from(eGui.querySelectorAll(".ag-column-drop-cell"));
        if (index === -1) return;
        if (items.length === 0) alternateElement.focus();
        const indexToFocus = Math.min(items.length - 1, index);
        const el = items[indexToFocus];
        if (el) el.focus();
    }
    focusList(fromBottom) {
        const index = fromBottom ? this.childPillComponents.length - 1 : 0;
        this.restoreFocus(index, this.getFocusableElement());
    }
    getNonGhostItems() {
        const existingItems = this.getExistingItems();
        if (this.isPotentialDndItems()) return existingItems.filter((item)=>!$437b23f6a393c3bf$var$includes(this.potentialDndItems, item));
        return existingItems;
    }
    addItemsToGui() {
        const nonGhostItems = this.getNonGhostItems();
        const itemsToAddToGui = nonGhostItems.map((item)=>this.createItemComponent(item, false));
        if (this.isPotentialDndItems()) {
            const dndItems = this.potentialDndItems.map((item)=>this.createItemComponent(item, true));
            if (this.insertIndex >= itemsToAddToGui.length) itemsToAddToGui.push(...dndItems);
            else itemsToAddToGui.splice(this.insertIndex, 0, ...dndItems);
        }
        this.appendChild(this.ePillDropList);
        itemsToAddToGui.forEach((itemComponent, index)=>{
            if (index > 0) this.addArrow(this.ePillDropList);
            this.ePillDropList.appendChild(itemComponent.getGui());
        });
        this.addAriaLabelsToComponents();
    }
    addAriaLabelsToComponents() {
        this.childPillComponents.forEach((comp, idx)=>{
            const eGui = comp.getGui();
            $437b23f6a393c3bf$var$setAriaPosInSet(eGui, idx + 1);
            $437b23f6a393c3bf$var$setAriaSetSize(eGui, this.childPillComponents.length);
        });
    }
    createItemComponent(item, ghost) {
        const itemComponent = this.createPillComponent(item, this.dropTarget, ghost, this.horizontal);
        itemComponent.addEventListener($437b23f6a393c3bf$export$35edd0e9295b87d1.EVENT_COLUMN_REMOVE, this.removeItems.bind(this, [
            item
        ]));
        this.context.createBean(itemComponent);
        this.guiDestroyFunctions.push(()=>this.destroyBean(itemComponent));
        if (!ghost) this.childPillComponents.push(itemComponent);
        return itemComponent;
    }
    addIconAndTitleToGui() {
        const { title: title, icon: eGroupIcon } = this.params;
        if (!title || !eGroupIcon) return;
        const eTitleBar = document.createElement("div");
        $437b23f6a393c3bf$var$setAriaHidden(eTitleBar, true);
        this.addElementClasses(eTitleBar, "title-bar");
        this.addElementClasses(eGroupIcon, "icon");
        this.addOrRemoveCssClass("ag-column-drop-empty", this.isExistingItemsEmpty());
        eTitleBar.appendChild(eGroupIcon);
        if (!this.horizontal) {
            const eTitle = document.createElement("span");
            this.addElementClasses(eTitle, "title");
            eTitle.innerHTML = title;
            eTitleBar.appendChild(eTitle);
        }
        this.appendChild(eTitleBar);
    }
    isExistingItemsEmpty() {
        return this.getExistingItems().length === 0;
    }
    addEmptyMessageToGui() {
        const { emptyMessage: emptyMessage } = this.params;
        if (!emptyMessage || !this.isExistingItemsEmpty() || this.isPotentialDndItems()) return;
        const eMessage = document.createElement("span");
        eMessage.innerHTML = emptyMessage;
        this.addElementClasses(eMessage, "empty-message");
        this.ePillDropList.appendChild(eMessage);
    }
    addArrow(eParent) {
        if (this.horizontal) {
            const enableRtl = this.gos.get("enableRtl");
            const icon = $437b23f6a393c3bf$var$createIconNoSpan(enableRtl ? "smallLeft" : "smallRight", this.gos);
            this.addElementClasses(icon, "cell-separator");
            eParent.appendChild(icon);
        }
    }
};
$437b23f6a393c3bf$var$_PillDropZonePanel.STATE_NOT_DRAGGING = "notDragging";
$437b23f6a393c3bf$var$_PillDropZonePanel.STATE_NEW_ITEMS_IN = "newItemsIn";
$437b23f6a393c3bf$var$_PillDropZonePanel.STATE_REARRANGE_ITEMS = "rearrangeItems";
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("focusService")
], $437b23f6a393c3bf$var$_PillDropZonePanel.prototype, "focusService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("dragAndDropService")
], $437b23f6a393c3bf$var$_PillDropZonePanel.prototype, "dragAndDropService", 2);
var $437b23f6a393c3bf$export$50f4ce491a627136 = $437b23f6a393c3bf$var$_PillDropZonePanel;
// community-modules/core/src/vanillaFrameworkOverrides.ts
var $437b23f6a393c3bf$var$PASSIVE_EVENTS2 = [
    "touchstart",
    "touchend",
    "touchmove",
    "touchcancel"
];
var $437b23f6a393c3bf$export$8174ad74937c6482 = class {
    constructor(frameworkName = "javascript"){
        this.frameworkName = frameworkName;
        this.renderingEngine = "vanilla";
        this.wrapIncoming = (callback)=>callback();
        this.wrapOutgoing = (callback)=>callback();
    }
    setInterval(action, timeout) {
        return new $437b23f6a393c3bf$export$30ec7836a4847721((resolve)=>{
            resolve(window.setInterval(action, timeout));
        });
    }
    // for Vanilla JS, we just add the event to the element
    addEventListener(element, type, listener, useCapture) {
        const isPassive = $437b23f6a393c3bf$var$includes($437b23f6a393c3bf$var$PASSIVE_EVENTS2, type);
        element.addEventListener(type, listener, {
            capture: !!useCapture,
            passive: isPassive
        });
    }
    get shouldWrapOutgoing() {
        return false;
    }
    frameworkComponent(name) {
        return null;
    }
    isFrameworkComponent(comp) {
        return false;
    }
    getDocLink(path) {
        const framework = this.frameworkName === "solid" ? "react" : this.frameworkName;
        return `https://www.ag-grid.com/${framework}-data-grid${path ? `/${path}` : ""}`;
    }
};
// community-modules/core/src/cellNavigationService.ts
var $437b23f6a393c3bf$export$672e779a12850b13 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    // returns null if no cell to focus on, ie at the end of the grid
    getNextCellToFocus(key, focusedCell, ctrlPressed = false) {
        if (ctrlPressed) return this.getNextCellToFocusWithCtrlPressed(key, focusedCell);
        return this.getNextCellToFocusWithoutCtrlPressed(key, focusedCell);
    }
    getNextCellToFocusWithCtrlPressed(key, focusedCell) {
        const upKey = key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP;
        const downKey = key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN;
        const leftKey = key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT;
        let column;
        let rowIndex;
        if (upKey || downKey) {
            rowIndex = upKey ? this.paginationProxy.getPageFirstRow() : this.paginationProxy.getPageLastRow();
            column = focusedCell.column;
        } else {
            const allColumns = this.columnModel.getAllDisplayedColumns();
            const isRtl = this.gos.get("enableRtl");
            rowIndex = focusedCell.rowIndex;
            column = leftKey !== isRtl ? allColumns[0] : $437b23f6a393c3bf$var$last(allColumns);
        }
        return {
            rowIndex: rowIndex,
            rowPinned: null,
            column: column
        };
    }
    getNextCellToFocusWithoutCtrlPressed(key, focusedCell) {
        let pointer = focusedCell;
        let finished = false;
        while(!finished){
            switch(key){
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.UP:
                    pointer = this.getCellAbove(pointer);
                    break;
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.DOWN:
                    pointer = this.getCellBelow(pointer);
                    break;
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.RIGHT:
                    if (this.gos.get("enableRtl")) pointer = this.getCellToLeft(pointer);
                    else pointer = this.getCellToRight(pointer);
                    break;
                case $437b23f6a393c3bf$export$e9e0d96f49f57c33.LEFT:
                    if (this.gos.get("enableRtl")) pointer = this.getCellToRight(pointer);
                    else pointer = this.getCellToLeft(pointer);
                    break;
                default:
                    pointer = null;
                    console.warn("AG Grid: unknown key for navigation " + key);
                    break;
            }
            if (pointer) finished = this.isCellGoodToFocusOn(pointer);
            else finished = true;
        }
        return pointer;
    }
    isCellGoodToFocusOn(gridCell) {
        const column = gridCell.column;
        let rowNode;
        switch(gridCell.rowPinned){
            case "top":
                rowNode = this.pinnedRowModel.getPinnedTopRow(gridCell.rowIndex);
                break;
            case "bottom":
                rowNode = this.pinnedRowModel.getPinnedBottomRow(gridCell.rowIndex);
                break;
            default:
                rowNode = this.rowModel.getRow(gridCell.rowIndex);
                break;
        }
        if (!rowNode) return false;
        const suppressNavigable = column.isSuppressNavigable(rowNode);
        return !suppressNavigable;
    }
    getCellToLeft(lastCell) {
        if (!lastCell) return null;
        const colToLeft = this.columnModel.getDisplayedColBefore(lastCell.column);
        if (!colToLeft) return null;
        return {
            rowIndex: lastCell.rowIndex,
            column: colToLeft,
            rowPinned: lastCell.rowPinned
        };
    }
    getCellToRight(lastCell) {
        if (!lastCell) return null;
        const colToRight = this.columnModel.getDisplayedColAfter(lastCell.column);
        if (!colToRight) return null;
        return {
            rowIndex: lastCell.rowIndex,
            column: colToRight,
            rowPinned: lastCell.rowPinned
        };
    }
    getRowBelow(rowPosition) {
        const index = rowPosition.rowIndex;
        const pinned = rowPosition.rowPinned;
        if (this.isLastRowInContainer(rowPosition)) switch(pinned){
            case "bottom":
                return null;
            case "top":
                if (this.rowModel.isRowsToRender()) return {
                    rowIndex: this.paginationProxy.getPageFirstRow(),
                    rowPinned: null
                };
                if (this.pinnedRowModel.isRowsToRender("bottom")) return {
                    rowIndex: 0,
                    rowPinned: "bottom"
                };
                return null;
            default:
                if (this.pinnedRowModel.isRowsToRender("bottom")) return {
                    rowIndex: 0,
                    rowPinned: "bottom"
                };
                return null;
        }
        const rowNode = this.rowModel.getRow(rowPosition.rowIndex);
        const nextStickyPosition = this.getNextStickyPosition(rowNode);
        if (nextStickyPosition) return nextStickyPosition;
        return {
            rowIndex: index + 1,
            rowPinned: pinned
        };
    }
    getNextStickyPosition(rowNode, up) {
        if (!this.gos.isGroupRowsSticky() || !rowNode || !rowNode.sticky) return;
        const isTopCtrls = this.rowRenderer.getStickyTopRowCtrls().some((ctrl)=>ctrl.getRowNode().rowIndex === rowNode.rowIndex);
        let stickyRowCtrls = [];
        if (isTopCtrls) stickyRowCtrls = [
            ...this.rowRenderer.getStickyTopRowCtrls()
        ].sort((a, b)=>a.getRowNode().rowIndex - b.getRowNode().rowIndex);
        else stickyRowCtrls = [
            ...this.rowRenderer.getStickyBottomRowCtrls()
        ].sort((a, b)=>b.getRowNode().rowIndex - a.getRowNode().rowIndex);
        const diff = up ? -1 : 1;
        const idx = stickyRowCtrls.findIndex((ctrl)=>ctrl.getRowNode().rowIndex === rowNode.rowIndex);
        const nextCtrl = stickyRowCtrls[idx + diff];
        if (nextCtrl) return {
            rowIndex: nextCtrl.getRowNode().rowIndex,
            rowPinned: null
        };
    }
    getCellBelow(lastCell) {
        if (!lastCell) return null;
        const rowBelow = this.getRowBelow(lastCell);
        if (rowBelow) return {
            rowIndex: rowBelow.rowIndex,
            column: lastCell.column,
            rowPinned: rowBelow.rowPinned
        };
        return null;
    }
    isLastRowInContainer(rowPosition) {
        const pinned = rowPosition.rowPinned;
        const index = rowPosition.rowIndex;
        if (pinned === "top") {
            const lastTopIndex = this.pinnedRowModel.getPinnedTopRowData().length - 1;
            return lastTopIndex <= index;
        }
        if (pinned === "bottom") {
            const lastBottomIndex = this.pinnedRowModel.getPinnedBottomRowData().length - 1;
            return lastBottomIndex <= index;
        }
        const lastBodyIndex = this.paginationProxy.getPageLastRow();
        return lastBodyIndex <= index;
    }
    getRowAbove(rowPosition) {
        const index = rowPosition.rowIndex;
        const pinned = rowPosition.rowPinned;
        const isFirstRow = pinned ? index === 0 : index === this.paginationProxy.getPageFirstRow();
        if (isFirstRow) {
            if (pinned === "top") return null;
            if (!pinned) {
                if (this.pinnedRowModel.isRowsToRender("top")) return this.getLastFloatingTopRow();
                return null;
            }
            if (this.rowModel.isRowsToRender()) return this.getLastBodyCell();
            if (this.pinnedRowModel.isRowsToRender("top")) return this.getLastFloatingTopRow();
            return null;
        }
        const rowNode = this.rowModel.getRow(rowPosition.rowIndex);
        const nextStickyPosition = this.getNextStickyPosition(rowNode, true);
        if (nextStickyPosition) return nextStickyPosition;
        return {
            rowIndex: index - 1,
            rowPinned: pinned
        };
    }
    getCellAbove(lastCell) {
        if (!lastCell) return null;
        const rowAbove = this.getRowAbove({
            rowIndex: lastCell.rowIndex,
            rowPinned: lastCell.rowPinned
        });
        if (rowAbove) return {
            rowIndex: rowAbove.rowIndex,
            column: lastCell.column,
            rowPinned: rowAbove.rowPinned
        };
        return null;
    }
    getLastBodyCell() {
        const lastBodyRow = this.paginationProxy.getPageLastRow();
        return {
            rowIndex: lastBodyRow,
            rowPinned: null
        };
    }
    getLastFloatingTopRow() {
        const lastFloatingRow = this.pinnedRowModel.getPinnedTopRowData().length - 1;
        return {
            rowIndex: lastFloatingRow,
            rowPinned: "top"
        };
    }
    getNextTabbedCell(gridCell, backwards) {
        if (backwards) return this.getNextTabbedCellBackwards(gridCell);
        return this.getNextTabbedCellForwards(gridCell);
    }
    getNextTabbedCellForwards(gridCell) {
        const displayedColumns = this.columnModel.getAllDisplayedColumns();
        let newRowIndex = gridCell.rowIndex;
        let newFloating = gridCell.rowPinned;
        let newColumn = this.columnModel.getDisplayedColAfter(gridCell.column);
        if (!newColumn) {
            newColumn = displayedColumns[0];
            const rowBelow = this.getRowBelow(gridCell);
            if ($437b23f6a393c3bf$var$missing(rowBelow)) return null;
            if (!rowBelow.rowPinned && !this.paginationProxy.isRowInPage(rowBelow)) return null;
            newRowIndex = rowBelow ? rowBelow.rowIndex : null;
            newFloating = rowBelow ? rowBelow.rowPinned : null;
        }
        return {
            rowIndex: newRowIndex,
            column: newColumn,
            rowPinned: newFloating
        };
    }
    getNextTabbedCellBackwards(gridCell) {
        const displayedColumns = this.columnModel.getAllDisplayedColumns();
        let newRowIndex = gridCell.rowIndex;
        let newFloating = gridCell.rowPinned;
        let newColumn = this.columnModel.getDisplayedColBefore(gridCell.column);
        if (!newColumn) {
            newColumn = $437b23f6a393c3bf$var$last(displayedColumns);
            const rowAbove = this.getRowAbove({
                rowIndex: gridCell.rowIndex,
                rowPinned: gridCell.rowPinned
            });
            if ($437b23f6a393c3bf$var$missing(rowAbove)) return null;
            if (!rowAbove.rowPinned && !this.paginationProxy.isRowInPage(rowAbove)) return null;
            newRowIndex = rowAbove ? rowAbove.rowIndex : null;
            newFloating = rowAbove ? rowAbove.rowPinned : null;
        }
        return {
            rowIndex: newRowIndex,
            column: newColumn,
            rowPinned: newFloating
        };
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnModel")
], $437b23f6a393c3bf$export$672e779a12850b13.prototype, "columnModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowModel")
], $437b23f6a393c3bf$export$672e779a12850b13.prototype, "rowModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowRenderer")
], $437b23f6a393c3bf$export$672e779a12850b13.prototype, "rowRenderer", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("pinnedRowModel")
], $437b23f6a393c3bf$export$672e779a12850b13.prototype, "pinnedRowModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("paginationProxy")
], $437b23f6a393c3bf$export$672e779a12850b13.prototype, "paginationProxy", 2);
$437b23f6a393c3bf$export$672e779a12850b13 = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("cellNavigationService")
], $437b23f6a393c3bf$export$672e779a12850b13);
// community-modules/core/src/alignedGridsService.ts
var $437b23f6a393c3bf$export$64acd562943cc6b9 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        // flag to mark if we are consuming. to avoid cyclic events (ie other grid firing back to master
        // while processing a master event) we mark this if consuming an event, and if we are, then
        // we don't fire back any events.
        this.consuming = false;
    }
    setBeans(loggerFactory) {
        this.logger = loggerFactory.create("AlignedGridsService");
    }
    getAlignedGridApis() {
        var _a;
        let alignedGrids = (_a = this.gos.get("alignedGrids")) != null ? _a : [];
        const isCallbackConfig = typeof alignedGrids === "function";
        if (typeof alignedGrids === "function") alignedGrids = alignedGrids();
        const seeUrl = ()=>`See ${this.getFrameworkOverrides().getDocLink("aligned-grids")}`;
        const apis = alignedGrids.map((alignedGrid)=>{
            var _a2;
            if (!alignedGrid) {
                $437b23f6a393c3bf$var$errorOnce(`alignedGrids contains an undefined option.`);
                if (!isCallbackConfig) $437b23f6a393c3bf$var$errorOnce(`You may want to configure via a callback to avoid setup race conditions:
                     "alignedGrids: () => [linkedGrid]"`);
                $437b23f6a393c3bf$var$errorOnce(seeUrl());
                return;
            }
            if (alignedGrid instanceof $437b23f6a393c3bf$export$8f1681b1712fcf78) return alignedGrid;
            const refOrComp = alignedGrid;
            if ("current" in refOrComp) return (_a2 = refOrComp.current) == null ? void 0 : _a2.api;
            else {
                if (!refOrComp.api) $437b23f6a393c3bf$var$errorOnce(`alignedGrids - No api found on the linked grid. If you are passing gridOptions to alignedGrids since v31 this is no longer valid. ${seeUrl()}`);
                return refOrComp.api;
            }
        }).filter((api)=>!!api && !api.isDestroyed());
        return apis;
    }
    init() {
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_MOVED, this.fireColumnEvent.bind(this));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_VISIBLE, this.fireColumnEvent.bind(this));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_PINNED, this.fireColumnEvent.bind(this));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_GROUP_OPENED, this.fireColumnEvent.bind(this));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_RESIZED, this.fireColumnEvent.bind(this));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_BODY_SCROLL, this.fireScrollEvent.bind(this));
    }
    // common logic across all the fire methods
    fireEvent(callback) {
        if (this.consuming) return;
        this.getAlignedGridApis().forEach((api)=>{
            if (api.isDestroyed()) return;
            const alignedGridService = api.__getAlignedGridService();
            callback(alignedGridService);
        });
    }
    // common logic across all consume methods. very little common logic, however extracting
    // guarantees consistency across the methods.
    onEvent(callback) {
        this.consuming = true;
        callback();
        this.consuming = false;
    }
    fireColumnEvent(event) {
        this.fireEvent((alignedGridsService)=>{
            alignedGridsService.onColumnEvent(event);
        });
    }
    fireScrollEvent(event) {
        if (event.direction !== "horizontal") return;
        this.fireEvent((alignedGridsService)=>{
            alignedGridsService.onScrollEvent(event);
        });
    }
    onScrollEvent(event) {
        this.onEvent(()=>{
            const gridBodyCon = this.ctrlsService.getGridBodyCtrl();
            gridBodyCon.getScrollFeature().setHorizontalScrollPosition(event.left, true);
        });
    }
    getMasterColumns(event) {
        const result = [];
        if (event.columns) event.columns.forEach((column)=>{
            result.push(column);
        });
        else if (event.column) result.push(event.column);
        return result;
    }
    getColumnIds(event) {
        const result = [];
        if (event.columns) event.columns.forEach((column)=>{
            result.push(column.getColId());
        });
        else if (event.column) result.push(event.column.getColId());
        return result;
    }
    onColumnEvent(event) {
        this.onEvent(()=>{
            switch(event.type){
                case $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_MOVED:
                case $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_VISIBLE:
                case $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_PINNED:
                case $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_RESIZED:
                    const colEvent = event;
                    this.processColumnEvent(colEvent);
                    break;
                case $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_GROUP_OPENED:
                    const groupOpenedEvent = event;
                    this.processGroupOpenedEvent(groupOpenedEvent);
                    break;
                case $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_PIVOT_CHANGED:
                    console.warn("AG Grid: pivoting is not supported with aligned grids. You can only use one of these features at a time in a grid.");
                    break;
            }
        });
    }
    processGroupOpenedEvent(groupOpenedEvent) {
        groupOpenedEvent.columnGroups.forEach((masterGroup)=>{
            let otherColumnGroup = null;
            if (masterGroup) {
                const groupId = masterGroup.getGroupId();
                otherColumnGroup = this.columnModel.getProvidedColumnGroup(groupId);
            }
            if (masterGroup && !otherColumnGroup) return;
            this.logger.log("onColumnEvent-> processing " + groupOpenedEvent + " expanded = " + masterGroup.isExpanded());
            this.columnModel.setColumnGroupOpened(otherColumnGroup, masterGroup.isExpanded(), "alignedGridChanged");
        });
    }
    processColumnEvent(colEvent) {
        var _a;
        const masterColumn = colEvent.column;
        let otherColumn = null;
        if (masterColumn) otherColumn = this.columnModel.getPrimaryColumn(masterColumn.getColId());
        if (masterColumn && !otherColumn) return;
        const masterColumns = this.getMasterColumns(colEvent);
        switch(colEvent.type){
            case $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_MOVED:
                {
                    const movedEvent = colEvent;
                    const srcColState = colEvent.api.getColumnState();
                    const destColState = srcColState.map((s)=>({
                            colId: s.colId
                        }));
                    this.columnModel.applyColumnState({
                        state: destColState,
                        applyOrder: true
                    }, "alignedGridChanged");
                    this.logger.log(`onColumnEvent-> processing ${colEvent.type} toIndex = ${movedEvent.toIndex}`);
                }
                break;
            case $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_VISIBLE:
                {
                    const visibleEvent = colEvent;
                    const srcColState = colEvent.api.getColumnState();
                    const destColState = srcColState.map((s)=>({
                            colId: s.colId,
                            hide: s.hide
                        }));
                    this.columnModel.applyColumnState({
                        state: destColState
                    }, "alignedGridChanged");
                    this.logger.log(`onColumnEvent-> processing ${colEvent.type} visible = ${visibleEvent.visible}`);
                }
                break;
            case $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_PINNED:
                {
                    const pinnedEvent = colEvent;
                    const srcColState = colEvent.api.getColumnState();
                    const destColState = srcColState.map((s)=>({
                            colId: s.colId,
                            pinned: s.pinned
                        }));
                    this.columnModel.applyColumnState({
                        state: destColState
                    }, "alignedGridChanged");
                    this.logger.log(`onColumnEvent-> processing ${colEvent.type} pinned = ${pinnedEvent.pinned}`);
                }
                break;
            case $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_RESIZED:
                const resizedEvent = colEvent;
                const columnWidths = {};
                masterColumns.forEach((column)=>{
                    this.logger.log(`onColumnEvent-> processing ${colEvent.type} actualWidth = ${column.getActualWidth()}`);
                    columnWidths[column.getId()] = {
                        key: column.getColId(),
                        newWidth: column.getActualWidth()
                    };
                });
                (_a = resizedEvent.flexColumns) == null || _a.forEach((col)=>{
                    if (columnWidths[col.getId()]) delete columnWidths[col.getId()];
                });
                this.columnModel.setColumnWidths(Object.values(columnWidths), false, resizedEvent.finished, "alignedGridChanged");
                break;
        }
        const gridBodyCon = this.ctrlsService.getGridBodyCtrl();
        const isVerticalScrollShowing2 = gridBodyCon.isVerticalScrollShowing();
        this.getAlignedGridApis().forEach((api)=>{
            api.setGridOption("alwaysShowVerticalScroll", isVerticalScrollShowing2);
        });
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnModel")
], $437b23f6a393c3bf$export$64acd562943cc6b9.prototype, "columnModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("ctrlsService")
], $437b23f6a393c3bf$export$64acd562943cc6b9.prototype, "ctrlsService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$var$__decorateParam(0, $437b23f6a393c3bf$export$c3215dfb7fd4803b("loggerFactory"))
], $437b23f6a393c3bf$export$64acd562943cc6b9.prototype, "setBeans", 1);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$export$64acd562943cc6b9.prototype, "init", 1);
$437b23f6a393c3bf$export$64acd562943cc6b9 = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("alignedGridsService")
], $437b23f6a393c3bf$export$64acd562943cc6b9);
// community-modules/core/src/selectionService.ts
var $437b23f6a393c3bf$var$SelectionService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.selectedNodes = /* @__PURE__ */ new Map();
        this.lastRowNode = null;
    }
    init() {
        this.rowSelection = this.gos.get("rowSelection");
        this.groupSelectsChildren = this.gos.get("groupSelectsChildren");
        this.addManagedPropertyListeners([
            "groupSelectsChildren",
            "rowSelection"
        ], ()=>{
            this.groupSelectsChildren = this.gos.get("groupSelectsChildren");
            this.rowSelection = this.gos.get("rowSelection");
            this.deselectAllRowNodes({
                source: "api"
            });
        });
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_SELECTED, this.onRowSelected.bind(this));
    }
    destroy() {
        super.destroy();
        this.resetNodes();
        this.lastRowNode = null;
    }
    isMultiselect() {
        return this.rowSelection === "multiple";
    }
    setNodesSelected(params) {
        var _a;
        const { newValue: newValue, clearSelection: clearSelection, suppressFinishActions: suppressFinishActions, rangeSelect: rangeSelect, nodes: nodes, event: event, source: source = "api" } = params;
        if (nodes.length === 0) return 0;
        if (nodes.length > 1 && !this.isMultiselect()) {
            console.warn(`AG Grid: cannot multi select while rowSelection='single'`);
            return 0;
        }
        const groupSelectsFiltered = this.groupSelectsChildren && params.groupSelectsFiltered === true;
        const filteredNodes = nodes.map((node)=>node.footer ? node.sibling : node);
        if (rangeSelect) {
            if (nodes.length > 1) {
                console.warn("AG Grid: cannot range select while selecting multiple rows");
                return 0;
            }
            let toNode = null;
            if (source === "checkboxSelected" && newValue === false && this.lastRowNode) {
                if (this.lastRowNode.id) toNode = this.lastRowNode;
                else this.lastRowNode = null;
            }
            if (toNode == null) toNode = this.getLastSelectedNode();
            if (toNode) {
                const fromNode = filteredNodes[0];
                const newRowClicked = fromNode !== toNode;
                if (newRowClicked && this.isMultiselect()) return this.selectRange(fromNode, toNode, newValue, source);
            }
        }
        this.lastRowNode = newValue ? null : filteredNodes[0];
        let updatedCount = 0;
        for(let i = 0; i < filteredNodes.length; i++){
            const node = filteredNodes[i];
            const skipThisNode = groupSelectsFiltered && node.group;
            if (!skipThisNode) {
                const thisNodeWasSelected = node.selectThisNode(newValue, event, source);
                if (thisNodeWasSelected) updatedCount++;
            }
            if (this.groupSelectsChildren && ((_a = node.childrenAfterGroup) == null ? void 0 : _a.length)) updatedCount += this.selectChildren(node, newValue, groupSelectsFiltered, source);
        }
        if (!suppressFinishActions) {
            const clearOtherNodes = newValue && (clearSelection || !this.isMultiselect());
            if (clearOtherNodes) updatedCount += this.clearOtherNodes(filteredNodes[0], source);
            if (updatedCount > 0) {
                this.updateGroupsFromChildrenSelections(source);
                const event2 = {
                    type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_SELECTION_CHANGED,
                    source: source
                };
                this.eventService.dispatchEvent(event2);
            }
        }
        return updatedCount;
    }
    // selects all rows between this node and the last selected node (or the top if this is the first selection).
    // not to be mixed up with 'cell range selection' where you drag the mouse, this is row range selection, by
    // holding down 'shift'.
    selectRange(fromNode, toNode, value = true, source) {
        const nodesToSelect = this.rowModel.getNodesInRangeForSelection(fromNode, toNode);
        let updatedCount = 0;
        nodesToSelect.forEach((rowNode)=>{
            if (rowNode.group && this.groupSelectsChildren) return;
            const nodeWasSelected = rowNode.selectThisNode(value, void 0, source);
            if (nodeWasSelected) updatedCount++;
        });
        this.updateGroupsFromChildrenSelections(source);
        const event = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_SELECTION_CHANGED,
            source: source
        };
        this.eventService.dispatchEvent(event);
        return updatedCount;
    }
    selectChildren(node, newValue, groupSelectsFiltered, source) {
        const children = groupSelectsFiltered ? node.childrenAfterAggFilter : node.childrenAfterGroup;
        if ($437b23f6a393c3bf$var$missing(children)) return 0;
        return this.setNodesSelected({
            newValue: newValue,
            clearSelection: false,
            suppressFinishActions: true,
            groupSelectsFiltered: groupSelectsFiltered,
            source: source,
            nodes: children
        });
    }
    getLastSelectedNode() {
        const selectedKeys = Array.from(this.selectedNodes.keys());
        if (selectedKeys.length == 0) return null;
        const node = this.selectedNodes.get($437b23f6a393c3bf$var$last(selectedKeys));
        if (node) return node;
        return null;
    }
    getSelectedNodes() {
        const selectedNodes = [];
        this.selectedNodes.forEach((rowNode)=>{
            if (rowNode) selectedNodes.push(rowNode);
        });
        return selectedNodes;
    }
    getSelectedRows() {
        const selectedRows = [];
        this.selectedNodes.forEach((rowNode)=>{
            if (rowNode && rowNode.data) selectedRows.push(rowNode.data);
        });
        return selectedRows;
    }
    getSelectionCount() {
        return this.selectedNodes.size;
    }
    /**
   * This method is used by the CSRM to remove groups which are being disposed of,
   * events do not need fired in this case
   */ filterFromSelection(predicate) {
        const newSelectedNodes = /* @__PURE__ */ new Map();
        this.selectedNodes.forEach((rowNode, key)=>{
            const passesPredicate = rowNode && predicate(rowNode);
            if (passesPredicate) newSelectedNodes.set(key, rowNode);
        });
        this.selectedNodes = newSelectedNodes;
    }
    // should only be called if groupSelectsChildren=true
    updateGroupsFromChildrenSelections(source, changedPath) {
        if (!this.groupSelectsChildren) return false;
        if (this.rowModel.getType() !== "clientSide") return false;
        const clientSideRowModel = this.rowModel;
        const rootNode = clientSideRowModel.getRootNode();
        if (!changedPath) {
            changedPath = new $437b23f6a393c3bf$export$cb4d9114a9732e85(true, rootNode);
            changedPath.setInactive();
        }
        let selectionChanged = false;
        changedPath.forEachChangedNodeDepthFirst((rowNode)=>{
            if (rowNode !== rootNode) {
                const selected = rowNode.calculateSelectedFromChildren();
                selectionChanged = rowNode.selectThisNode(selected === null ? false : selected, void 0, source) || selectionChanged;
            }
        });
        return selectionChanged;
    }
    clearOtherNodes(rowNodeToKeepSelected, source) {
        const groupsToRefresh = /* @__PURE__ */ new Map();
        let updatedCount = 0;
        this.selectedNodes.forEach((otherRowNode)=>{
            if (otherRowNode && otherRowNode.id !== rowNodeToKeepSelected.id) {
                const rowNode = this.selectedNodes.get(otherRowNode.id);
                updatedCount += rowNode.setSelectedParams({
                    newValue: false,
                    clearSelection: false,
                    suppressFinishActions: true,
                    source: source
                });
                if (this.groupSelectsChildren && otherRowNode.parent) groupsToRefresh.set(otherRowNode.parent.id, otherRowNode.parent);
            }
        });
        groupsToRefresh.forEach((group)=>{
            const selected = group.calculateSelectedFromChildren();
            group.selectThisNode(selected === null ? false : selected, void 0, source);
        });
        return updatedCount;
    }
    onRowSelected(event) {
        const rowNode = event.node;
        if (this.groupSelectsChildren && rowNode.group) return;
        if (rowNode.isSelected()) this.selectedNodes.set(rowNode.id, rowNode);
        else this.selectedNodes.delete(rowNode.id);
    }
    syncInRowNode(rowNode, oldNode) {
        this.syncInOldRowNode(rowNode, oldNode);
        this.syncInNewRowNode(rowNode);
    }
    // if the id has changed for the node, then this means the rowNode
    // is getting used for a different data item, which breaks
    // our selectedNodes, as the node now is mapped by the old id
    // which is inconsistent. so to keep the old node as selected,
    // we swap in the clone (with the old id and old data). this means
    // the oldNode is effectively a daemon we keep a reference to,
    // so if client calls api.getSelectedNodes(), it gets the daemon
    // in the result. when the client un-selects, the reference to the
    // daemon is removed. the daemon, because it's an oldNode, is not
    // used by the grid for rendering, it's a copy of what the node used
    // to be like before the id was changed.
    syncInOldRowNode(rowNode, oldNode) {
        const oldNodeHasDifferentId = $437b23f6a393c3bf$var$exists(oldNode) && rowNode.id !== oldNode.id;
        if (oldNodeHasDifferentId && oldNode) {
            const id = oldNode.id;
            const oldNodeSelected = this.selectedNodes.get(id) == rowNode;
            if (oldNodeSelected) this.selectedNodes.set(oldNode.id, oldNode);
        }
    }
    syncInNewRowNode(rowNode) {
        if (this.selectedNodes.has(rowNode.id)) {
            rowNode.setSelectedInitialValue(true);
            this.selectedNodes.set(rowNode.id, rowNode);
        } else rowNode.setSelectedInitialValue(false);
    }
    reset(source) {
        const selectionCount = this.getSelectionCount();
        this.resetNodes();
        if (selectionCount) {
            const event = {
                type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_SELECTION_CHANGED,
                source: source
            };
            this.eventService.dispatchEvent(event);
        }
    }
    resetNodes() {
        var _a;
        (_a = this.selectedNodes) == null || _a.clear();
    }
    // returns a list of all nodes at 'best cost' - a feature to be used
    // with groups / trees. if a group has all it's children selected,
    // then the group appears in the result, but not the children.
    // Designed for use with 'children' as the group selection type,
    // where groups don't actually appear in the selection normally.
    getBestCostNodeSelection() {
        if (this.rowModel.getType() !== "clientSide") return;
        const clientSideRowModel = this.rowModel;
        const topLevelNodes = clientSideRowModel.getTopLevelNodes();
        if (topLevelNodes === null) return;
        const result = [];
        function traverse(nodes) {
            for(let i = 0, l = nodes.length; i < l; i++){
                const node = nodes[i];
                if (node.isSelected()) result.push(node);
                else {
                    const maybeGroup = node;
                    if (maybeGroup.group && maybeGroup.children) traverse(maybeGroup.children);
                }
            }
        }
        traverse(topLevelNodes);
        return result;
    }
    isEmpty() {
        let count = 0;
        this.selectedNodes.forEach((rowNode)=>{
            if (rowNode) count++;
        });
        return count === 0;
    }
    deselectAllRowNodes(params) {
        const callback = (rowNode)=>rowNode.selectThisNode(false, void 0, source);
        const rowModelClientSide = this.rowModel.getType() === "clientSide";
        const { source: source, justFiltered: justFiltered, justCurrentPage: justCurrentPage } = params;
        if (justCurrentPage || justFiltered) {
            if (!rowModelClientSide) {
                console.error("AG Grid: selecting just filtered only works when gridOptions.rowModelType='clientSide'");
                return;
            }
            this.getNodesToSelect(justFiltered, justCurrentPage).forEach(callback);
        } else {
            this.selectedNodes.forEach((rowNode)=>{
                if (rowNode) callback(rowNode);
            });
            this.reset(source);
        }
        if (rowModelClientSide && this.groupSelectsChildren) this.updateGroupsFromChildrenSelections(source);
        const event = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_SELECTION_CHANGED,
            source: source
        };
        this.eventService.dispatchEvent(event);
    }
    getSelectedCounts(justFiltered, justCurrentPage) {
        let selectedCount = 0;
        let notSelectedCount = 0;
        const callback = (node)=>{
            if (this.groupSelectsChildren && node.group) return;
            if (node.isSelected()) selectedCount++;
            else if (!node.selectable) ;
            else notSelectedCount++;
        };
        this.getNodesToSelect(justFiltered, justCurrentPage).forEach(callback);
        return {
            selectedCount: selectedCount,
            notSelectedCount: notSelectedCount
        };
    }
    getSelectAllState(justFiltered, justCurrentPage) {
        const { selectedCount: selectedCount, notSelectedCount: notSelectedCount } = this.getSelectedCounts(justFiltered, justCurrentPage);
        if (selectedCount === 0 && notSelectedCount === 0) return false;
        if (selectedCount > 0 && notSelectedCount > 0) return null;
        return selectedCount > 0;
    }
    hasNodesToSelect(justFiltered = false, justCurrentPage = false) {
        return this.getNodesToSelect(justFiltered, justCurrentPage).filter((node)=>node.selectable).length > 0;
    }
    /**
   * @param justFiltered whether to just include nodes which have passed the filter
   * @param justCurrentPage whether to just include nodes on the current page
   * @returns all nodes including unselectable nodes which are the target of this selection attempt
   */ getNodesToSelect(justFiltered = false, justCurrentPage = false) {
        if (this.rowModel.getType() !== "clientSide") throw new Error(`selectAll only available when rowModelType='clientSide', ie not ${this.rowModel.getType()}`);
        const nodes = [];
        if (justCurrentPage) {
            this.paginationProxy.forEachNodeOnPage((node)=>{
                if (!node.group) {
                    nodes.push(node);
                    return;
                }
                if (!node.expanded) {
                    const recursivelyAddChildren = (child)=>{
                        var _a;
                        nodes.push(child);
                        if ((_a = child.childrenAfterFilter) == null ? void 0 : _a.length) child.childrenAfterFilter.forEach(recursivelyAddChildren);
                    };
                    recursivelyAddChildren(node);
                    return;
                }
                if (!this.groupSelectsChildren) nodes.push(node);
            });
            return nodes;
        }
        const clientSideRowModel = this.rowModel;
        if (justFiltered) {
            clientSideRowModel.forEachNodeAfterFilter((node)=>{
                nodes.push(node);
            });
            return nodes;
        }
        clientSideRowModel.forEachNode((node)=>{
            nodes.push(node);
        });
        return nodes;
    }
    selectAllRowNodes(params) {
        if (this.rowModel.getType() !== "clientSide") throw new Error(`selectAll only available when rowModelType='clientSide', ie not ${this.rowModel.getType()}`);
        const { source: source, justFiltered: justFiltered, justCurrentPage: justCurrentPage } = params;
        const callback = (rowNode)=>rowNode.selectThisNode(true, void 0, source);
        this.getNodesToSelect(justFiltered, justCurrentPage).forEach(callback);
        if (this.rowModel.getType() === "clientSide" && this.groupSelectsChildren) this.updateGroupsFromChildrenSelections(source);
        const event = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_SELECTION_CHANGED,
            source: source
        };
        this.eventService.dispatchEvent(event);
    }
    getSelectionState() {
        const selectedIds = [];
        this.selectedNodes.forEach((node)=>{
            if (node == null ? void 0 : node.id) selectedIds.push(node.id);
        });
        return selectedIds.length ? selectedIds : null;
    }
    setSelectionState(state, source) {
        if (!Array.isArray(state)) return;
        const rowIds = new Set(state);
        const nodes = [];
        this.rowModel.forEachNode((node)=>{
            if (rowIds.has(node.id)) nodes.push(node);
        });
        this.setNodesSelected({
            newValue: true,
            nodes: nodes,
            source: source
        });
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowModel")
], $437b23f6a393c3bf$var$SelectionService.prototype, "rowModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("paginationProxy")
], $437b23f6a393c3bf$var$SelectionService.prototype, "paginationProxy", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$SelectionService.prototype, "init", 1);
$437b23f6a393c3bf$var$SelectionService = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("selectionService")
], $437b23f6a393c3bf$var$SelectionService);
// community-modules/core/src/columns/columnApi.ts
var $437b23f6a393c3bf$export$77ba9896796af9bf = class {
    constructor(gridAp){
        this.viaApi = (funcName, ...args)=>{
            $437b23f6a393c3bf$var$warnOnce(`Since v31, 'columnApi.${funcName}' is deprecated and moved to 'api.${funcName}'.`);
            return this.api[funcName](...args);
        };
        this.api = gridAp;
    }
    /** @deprecated v31 use `api.sizeColumnsToFit()` instead.   */ sizeColumnsToFit(gridWidth) {
        this.viaApi("sizeColumnsToFit", gridWidth);
    }
    /** @deprecated v31 use `api.setColumnGroupOpened() instead. */ setColumnGroupOpened(group, newValue) {
        this.viaApi("setColumnGroupOpened", group, newValue);
    }
    /** @deprecated v31 use `api.getColumnGroup() instead. */ getColumnGroup(name, instanceId) {
        return this.viaApi("getColumnGroup", name, instanceId);
    }
    /** @deprecated v31 use `api.getProvidedColumnGroup() instead. */ getProvidedColumnGroup(name) {
        return this.viaApi("getProvidedColumnGroup", name);
    }
    /** @deprecated v31 use `api.getDisplayNameForColumn() instead. */ getDisplayNameForColumn(column, location) {
        return this.viaApi("getDisplayNameForColumn", column, location);
    }
    /** @deprecated v31 use `api.getDisplayNameForColumnGroup() instead. */ getDisplayNameForColumnGroup(columnGroup, location) {
        return this.viaApi("getDisplayNameForColumnGroup", columnGroup, location);
    }
    /** @deprecated v31 use `api.getColumn() instead. */ getColumn(key) {
        return this.viaApi("getColumn", key);
    }
    /** @deprecated v31 use `api.getColumns() instead. */ getColumns() {
        return this.viaApi("getColumns");
    }
    /** @deprecated v31 use `api.applyColumnState() instead. */ applyColumnState(params) {
        return this.viaApi("applyColumnState", params);
    }
    /** @deprecated v31 use `api.getColumnState() instead. */ getColumnState() {
        return this.viaApi("getColumnState");
    }
    /** @deprecated v31 use `api.resetColumnState() instead. */ resetColumnState() {
        this.viaApi("resetColumnState");
    }
    /** @deprecated v31 use `api.getColumnGroupState() instead. */ getColumnGroupState() {
        return this.viaApi("getColumnGroupState");
    }
    /** @deprecated v31 use `api.setColumnGroupState() instead. */ setColumnGroupState(stateItems) {
        this.viaApi("setColumnGroupState", stateItems);
    }
    /** @deprecated v31 use `api.resetColumnGroupState() instead. */ resetColumnGroupState() {
        this.viaApi("resetColumnGroupState");
    }
    /** @deprecated v31 use `api.isPinning() instead. */ isPinning() {
        return this.viaApi("isPinning");
    }
    /** @deprecated v31 use `api.isPinningLeft() instead. */ isPinningLeft() {
        return this.viaApi("isPinningLeft");
    }
    /** @deprecated v31 use `api.isPinningRight() instead. */ isPinningRight() {
        return this.viaApi("isPinningRight");
    }
    /** @deprecated v31 use `api.getDisplayedColAfter() instead. */ getDisplayedColAfter(col) {
        return this.viaApi("getDisplayedColAfter", col);
    }
    /** @deprecated v31 use `api.getDisplayedColBefore() instead. */ getDisplayedColBefore(col) {
        return this.viaApi("getDisplayedColBefore", col);
    }
    /** @deprecated v31 use `api.setColumnVisible() instead. */ setColumnVisible(key, visible) {
        this.viaApi("setColumnVisible", key, visible);
    }
    /** @deprecated v31 use `api.setColumnsVisible() instead. */ setColumnsVisible(keys2, visible) {
        this.viaApi("setColumnsVisible", keys2, visible);
    }
    /** @deprecated v31 use `api.setColumnPinned() instead. */ setColumnPinned(key, pinned) {
        this.viaApi("setColumnPinned", key, pinned);
    }
    /** @deprecated v31 use `api.setColumnsPinned() instead. */ setColumnsPinned(keys2, pinned) {
        this.viaApi("setColumnsPinned", keys2, pinned);
    }
    /** @deprecated v31 use `api.getAllGridColumns() instead. */ getAllGridColumns() {
        return this.viaApi("getAllGridColumns");
    }
    /** @deprecated v31 use `api.getDisplayedLeftColumns() instead. */ getDisplayedLeftColumns() {
        return this.viaApi("getDisplayedLeftColumns");
    }
    /** @deprecated v31 use `api.getDisplayedCenterColumns() instead. */ getDisplayedCenterColumns() {
        return this.viaApi("getDisplayedCenterColumns");
    }
    /** @deprecated v31 use `api.getDisplayedRightColumns() instead. */ getDisplayedRightColumns() {
        return this.viaApi("getDisplayedRightColumns");
    }
    /** @deprecated v31 use `api.getAllDisplayedColumns() instead. */ getAllDisplayedColumns() {
        return this.viaApi("getAllDisplayedColumns");
    }
    /** @deprecated v31 use `api.getAllDisplayedVirtualColumns() instead. */ getAllDisplayedVirtualColumns() {
        return this.viaApi("getAllDisplayedVirtualColumns");
    }
    /** @deprecated v31 use `api.moveColumn() instead. */ moveColumn(key, toIndex) {
        this.viaApi("moveColumn", key, toIndex);
    }
    /** @deprecated v31 use `api.moveColumnByIndex() instead. */ moveColumnByIndex(fromIndex, toIndex) {
        this.viaApi("moveColumnByIndex", fromIndex, toIndex);
    }
    /** @deprecated v31 use `api.moveColumns() instead. */ moveColumns(columnsToMoveKeys, toIndex) {
        this.viaApi("moveColumns", columnsToMoveKeys, toIndex);
    }
    /** @deprecated v31 use `api.moveRowGroupColumn() instead. */ moveRowGroupColumn(fromIndex, toIndex) {
        this.viaApi("moveRowGroupColumn", fromIndex, toIndex);
    }
    /** @deprecated v31 use `api.setColumnAggFunc() instead. */ setColumnAggFunc(key, aggFunc) {
        this.viaApi("setColumnAggFunc", key, aggFunc);
    }
    /** @deprecated v31 use `api.setColumnWidth() instead. */ setColumnWidth(key, newWidth, finished = true, source) {
        this.viaApi("setColumnWidth", key, newWidth, finished, source);
    }
    /** @deprecated v31 use `api.setColumnWidths() instead. */ setColumnWidths(columnWidths, finished = true, source) {
        this.viaApi("setColumnWidths", columnWidths, finished, source);
    }
    /** @deprecated v31 use `api.setPivotMode() instead. */ setPivotMode(pivotMode) {
        this.viaApi("setPivotMode", pivotMode);
    }
    /** @deprecated v31 use `api.isPivotMode() instead. */ isPivotMode() {
        return this.viaApi("isPivotMode");
    }
    /** @deprecated v31 use `api.getPivotResultColumn() instead. */ getPivotResultColumn(pivotKeys, valueColKey) {
        return this.viaApi("getPivotResultColumn", pivotKeys, valueColKey);
    }
    /** @deprecated v31 use `api.setValueColumns() instead. */ setValueColumns(colKeys) {
        this.viaApi("setValueColumns", colKeys);
    }
    /** @deprecated v31 use `api.getValueColumns() instead. */ getValueColumns() {
        return this.viaApi("getValueColumns");
    }
    /** @deprecated v31 use `api.removeValueColumn() instead. */ removeValueColumn(colKey) {
        this.viaApi("removeValueColumn", colKey);
    }
    /** @deprecated v31 use `api.removeValueColumns() instead. */ removeValueColumns(colKeys) {
        this.viaApi("removeValueColumns", colKeys);
    }
    /** @deprecated v31 use `api.addValueColumn() instead. */ addValueColumn(colKey) {
        this.viaApi("addValueColumn", colKey);
    }
    /** @deprecated v31 use `api.addValueColumns() instead. */ addValueColumns(colKeys) {
        this.viaApi("addValueColumns", colKeys);
    }
    /** @deprecated v31 use `api.setRowGroupColumns() instead. */ setRowGroupColumns(colKeys) {
        this.viaApi("setRowGroupColumns", colKeys);
    }
    /** @deprecated v31 use `api.removeRowGroupColumn() instead. */ removeRowGroupColumn(colKey) {
        this.viaApi("removeRowGroupColumn", colKey);
    }
    /** @deprecated v31 use `api.removeRowGroupColumns() instead. */ removeRowGroupColumns(colKeys) {
        this.viaApi("removeRowGroupColumns", colKeys);
    }
    /** @deprecated v31 use `api.addRowGroupColumn() instead. */ addRowGroupColumn(colKey) {
        this.viaApi("addRowGroupColumn", colKey);
    }
    /** @deprecated v31 use `api.addRowGroupColumns() instead. */ addRowGroupColumns(colKeys) {
        this.viaApi("addRowGroupColumns", colKeys);
    }
    /** @deprecated v31 use `api.getRowGroupColumns() instead. */ getRowGroupColumns() {
        return this.viaApi("getRowGroupColumns");
    }
    /** @deprecated v31 use `api.setPivotColumns() instead. */ setPivotColumns(colKeys) {
        this.viaApi("setPivotColumns", colKeys);
    }
    /** @deprecated v31 use `api.removePivotColumn() instead. */ removePivotColumn(colKey) {
        this.viaApi("removePivotColumn", colKey);
    }
    /** @deprecated v31 use `api.removePivotColumns() instead. */ removePivotColumns(colKeys) {
        this.viaApi("removePivotColumns", colKeys);
    }
    /** @deprecated v31 use `api.addPivotColumn() instead. */ addPivotColumn(colKey) {
        this.viaApi("addPivotColumn", colKey);
    }
    /** @deprecated v31 use `api.addPivotColumns() instead. */ addPivotColumns(colKeys) {
        this.viaApi("addPivotColumns", colKeys);
    }
    /** @deprecated v31 use `api.getPivotColumns() instead. */ getPivotColumns() {
        return this.viaApi("getPivotColumns");
    }
    /** @deprecated v31 use `api.getLeftDisplayedColumnGroups() instead. */ getLeftDisplayedColumnGroups() {
        return this.viaApi("getLeftDisplayedColumnGroups");
    }
    /** @deprecated v31 use `api.getCenterDisplayedColumnGroups() instead. */ getCenterDisplayedColumnGroups() {
        return this.viaApi("getCenterDisplayedColumnGroups");
    }
    /** @deprecated v31 use `api.getRightDisplayedColumnGroups() instead. */ getRightDisplayedColumnGroups() {
        return this.viaApi("getRightDisplayedColumnGroups");
    }
    /** @deprecated v31 use `api.getAllDisplayedColumnGroups() instead. */ getAllDisplayedColumnGroups() {
        return this.viaApi("getAllDisplayedColumnGroups");
    }
    /** @deprecated v31 use `api.autoSizeColumn() instead. */ autoSizeColumn(key, skipHeader) {
        return this.viaApi("autoSizeColumn", key, skipHeader);
    }
    /** @deprecated v31 use `api.autoSizeColumns() instead. */ autoSizeColumns(keys2, skipHeader) {
        this.viaApi("autoSizeColumns", keys2, skipHeader);
    }
    /** @deprecated v31 use `api.autoSizeAllColumns() instead. */ autoSizeAllColumns(skipHeader) {
        this.viaApi("autoSizeAllColumns", skipHeader);
    }
    /** @deprecated v31 use `api.setPivotResultColumns() instead. */ setPivotResultColumns(colDefs) {
        this.viaApi("setPivotResultColumns", colDefs);
    }
    /** @deprecated v31 use `api.getPivotResultColumns() instead. */ getPivotResultColumns() {
        return this.viaApi("getPivotResultColumns");
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("gridApi")
], $437b23f6a393c3bf$export$77ba9896796af9bf.prototype, "api", 2);
$437b23f6a393c3bf$export$77ba9896796af9bf = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("columnApi")
], $437b23f6a393c3bf$export$77ba9896796af9bf);
// community-modules/core/src/valueService/valueService.ts
var $437b23f6a393c3bf$export$c52638093d9fc6a3 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.initialised = false;
        this.isSsrm = false;
    }
    init() {
        this.isSsrm = this.gos.isRowModelType("serverSide");
        this.cellExpressions = this.gos.get("enableCellExpressions");
        this.isTreeData = this.gos.get("treeData");
        this.initialised = true;
        const listener = (event)=>this.callColumnCellValueChangedHandler(event);
        const async = this.gos.useAsyncEvents();
        this.eventService.addEventListener($437b23f6a393c3bf$export$ada873a34909da65.EVENT_CELL_VALUE_CHANGED, listener, async);
        this.addDestroyFunc(()=>this.eventService.removeEventListener($437b23f6a393c3bf$export$ada873a34909da65.EVENT_CELL_VALUE_CHANGED, listener, async));
        this.addManagedPropertyListener("treeData", (propChange)=>this.isTreeData = propChange.currentValue);
    }
    getValue(column, rowNode, forFilter = false, ignoreAggData = false) {
        if (!this.initialised) this.init();
        if (!rowNode) return;
        const colDef = column.getColDef();
        const field = colDef.field;
        const colId = column.getColId();
        const data = rowNode.data;
        let result;
        const groupDataExists = rowNode.groupData && rowNode.groupData[colId] !== void 0;
        const aggDataExists = !ignoreAggData && rowNode.aggData && rowNode.aggData[colId] !== void 0;
        const ignoreSsrmAggData = this.isSsrm && ignoreAggData && !!column.getColDef().aggFunc;
        const ssrmFooterGroupCol = this.isSsrm && rowNode.footer && rowNode.field && (column.getColDef().showRowGroup === true || column.getColDef().showRowGroup === rowNode.field);
        if (forFilter && colDef.filterValueGetter) result = this.executeFilterValueGetter(colDef.filterValueGetter, data, column, rowNode);
        else if (this.isTreeData && aggDataExists) result = rowNode.aggData[colId];
        else if (this.isTreeData && colDef.valueGetter) result = this.executeValueGetter(colDef.valueGetter, data, column, rowNode);
        else if (this.isTreeData && field && data) result = $437b23f6a393c3bf$var$getValueUsingField(data, field, column.isFieldContainsDots());
        else if (groupDataExists) result = rowNode.groupData[colId];
        else if (aggDataExists) result = rowNode.aggData[colId];
        else if (colDef.valueGetter) result = this.executeValueGetter(colDef.valueGetter, data, column, rowNode);
        else if (ssrmFooterGroupCol) result = $437b23f6a393c3bf$var$getValueUsingField(data, rowNode.field, column.isFieldContainsDots());
        else if (field && data && !ignoreSsrmAggData) result = $437b23f6a393c3bf$var$getValueUsingField(data, field, column.isFieldContainsDots());
        if (this.cellExpressions && typeof result === "string" && result.indexOf("=") === 0) {
            const cellValueGetter = result.substring(1);
            result = this.executeValueGetter(cellValueGetter, data, column, rowNode);
        }
        if (result == null) {
            const openedGroup = this.getOpenedGroup(rowNode, column);
            if (openedGroup != null) return openedGroup;
        }
        return result;
    }
    parseValue(column, rowNode, newValue, oldValue) {
        const colDef = column.getColDef();
        const params = this.gos.addGridCommonParams({
            node: rowNode,
            data: rowNode == null ? void 0 : rowNode.data,
            oldValue: oldValue,
            newValue: newValue,
            colDef: colDef,
            column: column
        });
        const valueParser = colDef.valueParser;
        if ($437b23f6a393c3bf$var$exists(valueParser)) {
            if (typeof valueParser === "function") return valueParser(params);
            return this.expressionService.evaluate(valueParser, params);
        }
        return newValue;
    }
    formatValue(column, node, value, suppliedFormatter, useFormatterFromColumn = true) {
        let result = null;
        let formatter;
        const colDef = column.getColDef();
        if (suppliedFormatter) formatter = suppliedFormatter;
        else if (useFormatterFromColumn) formatter = colDef.valueFormatter;
        if (formatter) {
            const params = this.gos.addGridCommonParams({
                value: value,
                node: node,
                data: node ? node.data : null,
                colDef: colDef,
                column: column
            });
            if (typeof formatter === "function") result = formatter(params);
            else result = this.expressionService.evaluate(formatter, params);
        } else if (colDef.refData) return colDef.refData[value] || "";
        if (result == null && Array.isArray(value)) result = value.join(", ");
        return result;
    }
    getOpenedGroup(rowNode, column) {
        if (!this.gos.get("showOpenedGroup")) return;
        const colDef = column.getColDef();
        if (!colDef.showRowGroup) return;
        const showRowGroup = column.getColDef().showRowGroup;
        let pointer = rowNode.parent;
        while(pointer != null){
            if (pointer.rowGroupColumn && (showRowGroup === true || showRowGroup === pointer.rowGroupColumn.getColId())) return pointer.key;
            pointer = pointer.parent;
        }
        return void 0;
    }
    /**
   * Sets the value of a GridCell
   * @param rowNode The `RowNode` to be updated
   * @param colKey The `Column` to be updated
   * @param newValue The new value to be set
   * @param eventSource The event source
   * @returns `True` if the value has been updated, otherwise`False`.
   */ setValue(rowNode, colKey, newValue, eventSource) {
        const column = this.columnModel.getPrimaryColumn(colKey);
        if (!rowNode || !column) return false;
        if ($437b23f6a393c3bf$var$missing(rowNode.data)) rowNode.data = {};
        const { field: field, valueSetter: valueSetter } = column.getColDef();
        if ($437b23f6a393c3bf$var$missing(field) && $437b23f6a393c3bf$var$missing(valueSetter)) {
            console.warn(`AG Grid: you need either field or valueSetter set on colDef for editing to work`);
            return false;
        }
        if (!this.dataTypeService.checkType(column, newValue)) {
            console.warn(`AG Grid: Data type of the new value does not match the cell data type of the column`);
            return false;
        }
        const params = this.gos.addGridCommonParams({
            node: rowNode,
            data: rowNode.data,
            oldValue: this.getValue(column, rowNode),
            newValue: newValue,
            colDef: column.getColDef(),
            column: column
        });
        params.newValue = newValue;
        let valueWasDifferent;
        if ($437b23f6a393c3bf$var$exists(valueSetter)) {
            if (typeof valueSetter === "function") valueWasDifferent = valueSetter(params);
            else valueWasDifferent = this.expressionService.evaluate(valueSetter, params);
        } else valueWasDifferent = this.setValueUsingField(rowNode.data, field, newValue, column.isFieldContainsDots());
        if (valueWasDifferent === void 0) valueWasDifferent = true;
        if (!valueWasDifferent) return false;
        rowNode.resetQuickFilterAggregateText();
        this.valueCache.onDataChanged();
        params.newValue = this.getValue(column, rowNode);
        const event = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_CELL_VALUE_CHANGED,
            event: null,
            rowIndex: rowNode.rowIndex,
            rowPinned: rowNode.rowPinned,
            column: params.column,
            api: params.api,
            columnApi: params.columnApi,
            colDef: params.colDef,
            context: params.context,
            data: rowNode.data,
            node: rowNode,
            oldValue: params.oldValue,
            newValue: params.newValue,
            value: params.newValue,
            source: eventSource
        };
        this.eventService.dispatchEvent(event);
        return true;
    }
    callColumnCellValueChangedHandler(event) {
        const onCellValueChanged = event.colDef.onCellValueChanged;
        if (typeof onCellValueChanged === "function") this.getFrameworkOverrides().wrapOutgoing(()=>{
            onCellValueChanged({
                node: event.node,
                data: event.data,
                oldValue: event.oldValue,
                newValue: event.newValue,
                colDef: event.colDef,
                column: event.column,
                api: event.api,
                columnApi: event.columnApi,
                context: event.context
            });
        });
    }
    setValueUsingField(data, field, newValue, isFieldContainsDots) {
        if (!field) return false;
        let valuesAreSame = false;
        if (!isFieldContainsDots) {
            valuesAreSame = data[field] === newValue;
            if (!valuesAreSame) data[field] = newValue;
        } else {
            const fieldPieces = field.split(".");
            let currentObject = data;
            while(fieldPieces.length > 0 && currentObject){
                const fieldPiece = fieldPieces.shift();
                if (fieldPieces.length === 0) {
                    valuesAreSame = currentObject[fieldPiece] === newValue;
                    if (!valuesAreSame) currentObject[fieldPiece] = newValue;
                } else currentObject = currentObject[fieldPiece];
            }
        }
        return !valuesAreSame;
    }
    executeFilterValueGetter(valueGetter, data, column, rowNode) {
        const params = this.gos.addGridCommonParams({
            data: data,
            node: rowNode,
            column: column,
            colDef: column.getColDef(),
            getValue: this.getValueCallback.bind(this, rowNode)
        });
        if (typeof valueGetter === "function") return valueGetter(params);
        return this.expressionService.evaluate(valueGetter, params);
    }
    executeValueGetter(valueGetter, data, column, rowNode) {
        const colId = column.getColId();
        const valueFromCache = this.valueCache.getValue(rowNode, colId);
        if (valueFromCache !== void 0) return valueFromCache;
        const params = this.gos.addGridCommonParams({
            data: data,
            node: rowNode,
            column: column,
            colDef: column.getColDef(),
            getValue: this.getValueCallback.bind(this, rowNode)
        });
        let result;
        if (typeof valueGetter === "function") result = valueGetter(params);
        else result = this.expressionService.evaluate(valueGetter, params);
        this.valueCache.setValue(rowNode, colId, result);
        return result;
    }
    getValueCallback(node, field) {
        const otherColumn = this.columnModel.getPrimaryColumn(field);
        if (otherColumn) return this.getValue(otherColumn, node);
        return null;
    }
    // used by row grouping and pivot, to get key for a row. col can be a pivot col or a row grouping col
    getKeyForNode(col, rowNode) {
        const value = this.getValue(col, rowNode);
        const keyCreator = col.getColDef().keyCreator;
        let result = value;
        if (keyCreator) {
            const keyParams = this.gos.addGridCommonParams({
                value: value,
                colDef: col.getColDef(),
                column: col,
                node: rowNode,
                data: rowNode.data
            });
            result = keyCreator(keyParams);
        }
        if (typeof result === "string" || result == null) return result;
        result = String(result);
        if (result === "[object Object]") $437b23f6a393c3bf$var$warnOnce("a column you are grouping or pivoting by has objects as values. If you want to group by complex objects then either a) use a colDef.keyCreator (se AG Grid docs) or b) to toString() on the object to return a key");
        return result;
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("expressionService")
], $437b23f6a393c3bf$export$c52638093d9fc6a3.prototype, "expressionService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnModel")
], $437b23f6a393c3bf$export$c52638093d9fc6a3.prototype, "columnModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("valueCache")
], $437b23f6a393c3bf$export$c52638093d9fc6a3.prototype, "valueCache", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("dataTypeService")
], $437b23f6a393c3bf$export$c52638093d9fc6a3.prototype, "dataTypeService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$export$c52638093d9fc6a3.prototype, "init", 1);
$437b23f6a393c3bf$export$c52638093d9fc6a3 = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("valueService")
], $437b23f6a393c3bf$export$c52638093d9fc6a3);
// community-modules/core/src/valueService/expressionService.ts
var $437b23f6a393c3bf$export$4ce5344b7d88a0e2 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.expressionToFunctionCache = {};
    }
    setBeans(loggerFactory) {
        this.logger = loggerFactory.create("ExpressionService");
    }
    evaluate(expression, params) {
        if (typeof expression === "string") return this.evaluateExpression(expression, params);
        else console.error("AG Grid: value should be either a string or a function", expression);
    }
    evaluateExpression(expression, params) {
        try {
            const javaScriptFunction = this.createExpressionFunction(expression);
            const result = javaScriptFunction(params.value, params.context, params.oldValue, params.newValue, params.value, params.node, params.data, params.colDef, params.rowIndex, params.api, params.columnApi, params.getValue, params.column, params.columnGroup);
            return result;
        } catch (e) {
            console.log("Processing of the expression failed");
            console.log("Expression = " + expression);
            console.log("Params =", params);
            console.log("Exception = " + e);
            return null;
        }
    }
    createExpressionFunction(expression) {
        if (this.expressionToFunctionCache[expression]) return this.expressionToFunctionCache[expression];
        const functionBody = this.createFunctionBody(expression);
        const theFunction = new Function("x, ctx, oldValue, newValue, value, node, data, colDef, rowIndex, api, columnApi, getValue, column, columnGroup", functionBody);
        this.expressionToFunctionCache[expression] = theFunction;
        return theFunction;
    }
    createFunctionBody(expression) {
        if (expression.indexOf("return") >= 0) return expression;
        else return "return " + expression + ";";
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$var$__decorateParam(0, $437b23f6a393c3bf$export$c3215dfb7fd4803b("loggerFactory"))
], $437b23f6a393c3bf$export$4ce5344b7d88a0e2.prototype, "setBeans", 1);
$437b23f6a393c3bf$export$4ce5344b7d88a0e2 = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("expressionService")
], $437b23f6a393c3bf$export$4ce5344b7d88a0e2);
// community-modules/core/src/logger.ts
var $437b23f6a393c3bf$export$e0f5ef03cd95415a = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    setBeans(gos) {
        this.logging = gos.get("debug");
    }
    create(name) {
        return new $437b23f6a393c3bf$export$efa9a398d6368992(name, this.isLogging.bind(this));
    }
    isLogging() {
        return this.logging;
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$var$__decorateParam(0, $437b23f6a393c3bf$export$c3215dfb7fd4803b("gridOptionsService"))
], $437b23f6a393c3bf$export$e0f5ef03cd95415a.prototype, "setBeans", 1);
$437b23f6a393c3bf$export$e0f5ef03cd95415a = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("loggerFactory")
], $437b23f6a393c3bf$export$e0f5ef03cd95415a);
var $437b23f6a393c3bf$export$efa9a398d6368992 = class {
    constructor(name, isLoggingFunc){
        this.name = name;
        this.isLoggingFunc = isLoggingFunc;
    }
    isLogging() {
        return this.isLoggingFunc();
    }
    log(message) {
        if (this.isLoggingFunc()) console.log("AG Grid." + this.name + ": " + message);
    }
};
// community-modules/core/src/gridComp/gridCtrl.ts
var $437b23f6a393c3bf$export$f3c741dac0be9745 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    setComp(view, eGridDiv, eGui) {
        this.view = view;
        this.eGridHostDiv = eGridDiv;
        this.eGui = eGui;
        this.eGui.setAttribute("grid-id", this.context.getGridId());
        this.dragAndDropService.addDropTarget({
            getContainer: ()=>this.eGui,
            isInterestedIn: (type)=>type === 1 /* HeaderCell */  || type === 0 /* ToolPanel */ ,
            getIconName: ()=>$437b23f6a393c3bf$export$3529111922becfa6.ICON_NOT_ALLOWED
        });
        this.mouseEventService.stampTopLevelGridCompWithGridInstance(eGridDiv);
        this.createManagedBean(new $437b23f6a393c3bf$var$LayoutFeature(this.view));
        this.addRtlSupport();
        const unsubscribeFromResize = this.resizeObserverService.observeResize(this.eGridHostDiv, this.onGridSizeChanged.bind(this));
        this.addDestroyFunc(()=>unsubscribeFromResize());
        this.ctrlsService.register("gridCtrl", this);
    }
    isDetailGrid() {
        var _a;
        const el = this.focusService.findTabbableParent(this.getGui());
        return ((_a = el == null ? void 0 : el.getAttribute("row-id")) == null ? void 0 : _a.startsWith("detail")) || false;
    }
    showDropZones() {
        return $437b23f6a393c3bf$export$dc053975cc7f6c11.__isRegistered("@ag-grid-enterprise/row-grouping" /* RowGroupingModule */ , this.context.getGridId());
    }
    showSideBar() {
        return $437b23f6a393c3bf$export$dc053975cc7f6c11.__isRegistered("@ag-grid-enterprise/side-bar" /* SideBarModule */ , this.context.getGridId());
    }
    showStatusBar() {
        return $437b23f6a393c3bf$export$dc053975cc7f6c11.__isRegistered("@ag-grid-enterprise/status-bar" /* StatusBarModule */ , this.context.getGridId());
    }
    showWatermark() {
        return $437b23f6a393c3bf$export$dc053975cc7f6c11.__isRegistered("@ag-grid-enterprise/core" /* EnterpriseCoreModule */ , this.context.getGridId());
    }
    onGridSizeChanged() {
        const event = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_GRID_SIZE_CHANGED,
            clientWidth: this.eGridHostDiv.clientWidth,
            clientHeight: this.eGridHostDiv.clientHeight
        };
        this.eventService.dispatchEvent(event);
    }
    addRtlSupport() {
        const cssClass = this.gos.get("enableRtl") ? "ag-rtl" : "ag-ltr";
        this.view.setRtlClass(cssClass);
    }
    destroyGridUi() {
        this.view.destroyGridUi();
    }
    getGui() {
        return this.eGui;
    }
    setResizeCursor(on) {
        this.view.setCursor(on ? "ew-resize" : null);
    }
    disableUserSelect(on) {
        this.view.setUserSelect(on ? "none" : null);
    }
    focusNextInnerContainer(backwards) {
        const focusableContainers = this.view.getFocusableContainers();
        const activeEl = this.gos.getActiveDomElement();
        const idxWithFocus = focusableContainers.findIndex((container)=>container.contains(activeEl));
        const nextIdx = idxWithFocus + (backwards ? -1 : 1);
        if (nextIdx <= 0 || nextIdx >= focusableContainers.length) return false;
        return this.focusService.focusInto(focusableContainers[nextIdx]);
    }
    focusInnerElement(fromBottom) {
        const focusableContainers = this.view.getFocusableContainers();
        const allColumns = this.columnModel.getAllDisplayedColumns();
        if (fromBottom) {
            if (focusableContainers.length > 1) return this.focusService.focusInto($437b23f6a393c3bf$var$last(focusableContainers), true);
            const lastColumn = $437b23f6a393c3bf$var$last(allColumns);
            if (this.focusService.focusGridView(lastColumn, true)) return true;
        }
        if (this.gos.get("headerHeight") === 0 || this.gos.get("suppressHeaderFocus")) {
            if (this.focusService.focusGridView(allColumns[0])) return true;
            for(let i = 1; i < focusableContainers.length; i++){
                if (this.focusService.focusInto(focusableContainers[i])) return true;
            }
            return false;
        }
        return this.focusService.focusFirstHeader();
    }
    forceFocusOutOfContainer(up = false) {
        this.view.forceFocusOutOfContainer(up);
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("focusService")
], $437b23f6a393c3bf$export$f3c741dac0be9745.prototype, "focusService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("resizeObserverService")
], $437b23f6a393c3bf$export$f3c741dac0be9745.prototype, "resizeObserverService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnModel")
], $437b23f6a393c3bf$export$f3c741dac0be9745.prototype, "columnModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("ctrlsService")
], $437b23f6a393c3bf$export$f3c741dac0be9745.prototype, "ctrlsService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("mouseEventService")
], $437b23f6a393c3bf$export$f3c741dac0be9745.prototype, "mouseEventService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("dragAndDropService")
], $437b23f6a393c3bf$export$f3c741dac0be9745.prototype, "dragAndDropService", 2);
// community-modules/core/src/gridComp/gridComp.ts
var $437b23f6a393c3bf$export$f29859a2c0c53119 = class extends $437b23f6a393c3bf$export$5a26e3abd1c845b6 {
    constructor(eGridDiv){
        super();
        this.eGridDiv = eGridDiv;
    }
    postConstruct() {
        this.logger = this.loggerFactory.create("GridComp");
        const compProxy = {
            destroyGridUi: ()=>this.destroyBean(this),
            setRtlClass: (cssClass)=>this.addCssClass(cssClass),
            forceFocusOutOfContainer: this.forceFocusOutOfContainer.bind(this),
            updateLayoutClasses: this.updateLayoutClasses.bind(this),
            getFocusableContainers: this.getFocusableContainers.bind(this),
            setUserSelect: (value)=>{
                this.getGui().style.userSelect = value != null ? value : "";
                this.getGui().style.webkitUserSelect = value != null ? value : "";
            },
            setCursor: (value)=>{
                this.getGui().style.cursor = value != null ? value : "";
            }
        };
        this.ctrl = this.createManagedBean(new $437b23f6a393c3bf$export$f3c741dac0be9745());
        const template = this.createTemplate();
        this.setTemplate(template);
        this.ctrl.setComp(compProxy, this.eGridDiv, this.getGui());
        this.insertGridIntoDom();
        this.initialiseTabGuard({
            // we want to override the default behaviour to do nothing for onTabKeyDown
            onTabKeyDown: ()=>void 0,
            focusInnerElement: (fromBottom)=>this.ctrl.focusInnerElement(fromBottom),
            forceFocusOutWhenTabGuardsAreEmpty: true
        });
    }
    insertGridIntoDom() {
        const eGui = this.getGui();
        this.eGridDiv.appendChild(eGui);
        this.addDestroyFunc(()=>{
            this.eGridDiv.removeChild(eGui);
            this.logger.log("Grid removed from DOM");
        });
    }
    updateLayoutClasses(cssClass, params) {
        const eRootWrapperBodyClassList = this.eRootWrapperBody.classList;
        eRootWrapperBodyClassList.toggle("ag-layout-auto-height" /* AUTO_HEIGHT */ , params.autoHeight);
        eRootWrapperBodyClassList.toggle("ag-layout-normal" /* NORMAL */ , params.normal);
        eRootWrapperBodyClassList.toggle("ag-layout-print" /* PRINT */ , params.print);
        this.addOrRemoveCssClass("ag-layout-auto-height" /* AUTO_HEIGHT */ , params.autoHeight);
        this.addOrRemoveCssClass("ag-layout-normal" /* NORMAL */ , params.normal);
        this.addOrRemoveCssClass("ag-layout-print" /* PRINT */ , params.print);
    }
    createTemplate() {
        const dropZones = this.ctrl.showDropZones() ? "<ag-grid-header-drop-zones></ag-grid-header-drop-zones>" : "";
        const sideBar = this.ctrl.showSideBar() ? '<ag-side-bar ref="sideBar"></ag-side-bar>' : "";
        const statusBar = this.ctrl.showStatusBar() ? '<ag-status-bar ref="statusBar"></ag-status-bar>' : "";
        const watermark = this.ctrl.showWatermark() ? "<ag-watermark></ag-watermark>" : "";
        const template = /* html */ `<div class="ag-root-wrapper" role="presentation">
                ${dropZones}
                <div class="ag-root-wrapper-body" ref="rootWrapperBody" role="presentation">
                    <ag-grid-body ref="gridBody"></ag-grid-body>
                    ${sideBar}
                </div>
                ${statusBar}
                <ag-pagination></ag-pagination>
                ${watermark}
            </div>`;
        return template;
    }
    getFocusableElement() {
        return this.eRootWrapperBody;
    }
    getFocusableContainers() {
        const focusableContainers = [
            this.gridBodyComp.getGui()
        ];
        if (this.sideBarComp) focusableContainers.push(this.sideBarComp.getGui());
        return focusableContainers.filter((el)=>$437b23f6a393c3bf$var$isVisible(el));
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("loggerFactory")
], $437b23f6a393c3bf$export$f29859a2c0c53119.prototype, "loggerFactory", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("gridBody")
], $437b23f6a393c3bf$export$f29859a2c0c53119.prototype, "gridBodyComp", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("sideBar")
], $437b23f6a393c3bf$export$f29859a2c0c53119.prototype, "sideBarComp", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("rootWrapperBody")
], $437b23f6a393c3bf$export$f29859a2c0c53119.prototype, "eRootWrapperBody", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$export$f29859a2c0c53119.prototype, "postConstruct", 1);
// community-modules/core/src/sortController.ts
var $437b23f6a393c3bf$export$765594e5be71a851 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    progressSort(column, multiSort, source) {
        const nextDirection = this.getNextSortDirection(column);
        this.setSortForColumn(column, nextDirection, multiSort, source);
    }
    setSortForColumn(column, sort, multiSort, source) {
        if (sort !== "asc" && sort !== "desc") sort = null;
        const isColumnsSortingCoupledToGroup = this.gos.isColumnsSortingCoupledToGroup();
        let columnsToUpdate = [
            column
        ];
        if (isColumnsSortingCoupledToGroup) {
            if (column.getColDef().showRowGroup) {
                const rowGroupColumns = this.columnModel.getSourceColumnsForGroupColumn(column);
                const sortableRowGroupColumns = rowGroupColumns == null ? void 0 : rowGroupColumns.filter((col)=>col.isSortable());
                if (sortableRowGroupColumns) columnsToUpdate = [
                    column,
                    ...sortableRowGroupColumns
                ];
            }
        }
        columnsToUpdate.forEach((col)=>col.setSort(sort, source));
        const doingMultiSort = (multiSort || this.gos.get("alwaysMultiSort")) && !this.gos.get("suppressMultiSort");
        const updatedColumns = [];
        if (!doingMultiSort) {
            const clearedColumns = this.clearSortBarTheseColumns(columnsToUpdate, source);
            updatedColumns.push(...clearedColumns);
        }
        this.updateSortIndex(column);
        updatedColumns.push(...columnsToUpdate);
        this.dispatchSortChangedEvents(source, updatedColumns);
    }
    updateSortIndex(lastColToChange) {
        const isCoupled = this.gos.isColumnsSortingCoupledToGroup();
        const groupParent = this.columnModel.getGroupDisplayColumnForGroup(lastColToChange.getId());
        const lastSortIndexCol = isCoupled ? groupParent || lastColToChange : lastColToChange;
        const allSortedCols = this.getColumnsWithSortingOrdered();
        this.columnModel.getPrimaryAndSecondaryAndAutoColumns().forEach((col)=>col.setSortIndex(null));
        const allSortedColsWithoutChangesOrGroups = allSortedCols.filter((col)=>{
            if (isCoupled && col.getColDef().showRowGroup) return false;
            return col !== lastSortIndexCol;
        });
        const sortedColsWithIndices = !!lastSortIndexCol.getSort() ? [
            ...allSortedColsWithoutChangesOrGroups,
            lastSortIndexCol
        ] : allSortedColsWithoutChangesOrGroups;
        sortedColsWithIndices.forEach((col, idx)=>{
            col.setSortIndex(idx);
        });
    }
    // gets called by API, so if data changes, use can call this, which will end up
    // working out the sort order again of the rows.
    onSortChanged(source, columns) {
        this.dispatchSortChangedEvents(source, columns);
    }
    isSortActive() {
        const allCols = this.columnModel.getPrimaryAndSecondaryAndAutoColumns();
        const sortedCols = allCols.filter((column)=>!!column.getSort());
        return sortedCols && sortedCols.length > 0;
    }
    dispatchSortChangedEvents(source, columns) {
        const event = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_SORT_CHANGED,
            source: source
        };
        if (columns) event.columns = columns;
        this.eventService.dispatchEvent(event);
    }
    clearSortBarTheseColumns(columnsToSkip, source) {
        const clearedColumns = [];
        this.columnModel.getPrimaryAndSecondaryAndAutoColumns().forEach((columnToClear)=>{
            if (!columnsToSkip.includes(columnToClear)) {
                if (!!columnToClear.getSort()) clearedColumns.push(columnToClear);
                columnToClear.setSort(void 0, source);
            }
        });
        return clearedColumns;
    }
    getNextSortDirection(column) {
        let sortingOrder;
        if (column.getColDef().sortingOrder) sortingOrder = column.getColDef().sortingOrder;
        else if (this.gos.get("sortingOrder")) sortingOrder = this.gos.get("sortingOrder");
        else sortingOrder = $437b23f6a393c3bf$export$765594e5be71a851.DEFAULT_SORTING_ORDER;
        if (!Array.isArray(sortingOrder) || sortingOrder.length <= 0) {
            console.warn(`AG Grid: sortingOrder must be an array with at least one element, currently it's ${sortingOrder}`);
            return null;
        }
        const currentIndex = sortingOrder.indexOf(column.getSort());
        const notInArray = currentIndex < 0;
        const lastItemInArray = currentIndex == sortingOrder.length - 1;
        let result;
        if (notInArray || lastItemInArray) result = sortingOrder[0];
        else result = sortingOrder[currentIndex + 1];
        if ($437b23f6a393c3bf$export$765594e5be71a851.DEFAULT_SORTING_ORDER.indexOf(result) < 0) {
            console.warn("AG Grid: invalid sort type " + result);
            return null;
        }
        return result;
    }
    /**
   * @returns a map of sort indexes for every sorted column, if groups sort primaries then they will have equivalent indices
   */ getIndexedSortMap() {
        let allSortedCols = this.columnModel.getPrimaryAndSecondaryAndAutoColumns().filter((col)=>!!col.getSort());
        if (this.columnModel.isPivotMode()) {
            const isSortingLinked = this.gos.isColumnsSortingCoupledToGroup();
            allSortedCols = allSortedCols.filter((col)=>{
                const isAggregated = !!col.getAggFunc();
                const isSecondary = !col.isPrimary();
                const isGroup = isSortingLinked ? this.columnModel.getGroupDisplayColumnForGroup(col.getId()) : col.getColDef().showRowGroup;
                return isAggregated || isSecondary || isGroup;
            });
        }
        const sortedRowGroupCols = this.columnModel.getRowGroupColumns().filter((col)=>!!col.getSort());
        const allColsIndexes = {};
        allSortedCols.forEach((col, index)=>allColsIndexes[col.getId()] = index);
        allSortedCols.sort((a, b)=>{
            const iA = a.getSortIndex();
            const iB = b.getSortIndex();
            if (iA != null && iB != null) return iA - iB;
            else if (iA == null && iB == null) {
                const posA = allColsIndexes[a.getId()];
                const posB = allColsIndexes[b.getId()];
                return posA > posB ? 1 : -1;
            } else if (iB == null) return -1;
            else return 1;
        });
        const isSortLinked = this.gos.isColumnsSortingCoupledToGroup() && !!sortedRowGroupCols.length;
        if (isSortLinked) allSortedCols = [
            ...new Set(// if linked sorting, replace all columns with the display group column for index purposes, and ensure uniqueness
            allSortedCols.map((col)=>{
                var _a;
                return (_a = this.columnModel.getGroupDisplayColumnForGroup(col.getId())) != null ? _a : col;
            }))
        ];
        const indexMap = /* @__PURE__ */ new Map();
        allSortedCols.forEach((col, idx)=>indexMap.set(col, idx));
        if (isSortLinked) sortedRowGroupCols.forEach((col)=>{
            const groupDisplayCol = this.columnModel.getGroupDisplayColumnForGroup(col.getId());
            indexMap.set(col, indexMap.get(groupDisplayCol));
        });
        return indexMap;
    }
    getColumnsWithSortingOrdered() {
        return [
            ...this.getIndexedSortMap().entries()
        ].sort(([col1, idx1], [col2, idx2])=>idx1 - idx2).map(([col])=>col);
    }
    // used by server side row models, to sent sort to server
    getSortModel() {
        return this.getColumnsWithSortingOrdered().filter((column)=>column.getSort()).map((column)=>({
                sort: column.getSort(),
                colId: column.getId()
            }));
    }
    getSortOptions() {
        return this.getColumnsWithSortingOrdered().filter((column)=>column.getSort()).map((column)=>({
                sort: column.getSort(),
                column: column
            }));
    }
    canColumnDisplayMixedSort(column) {
        const isColumnSortCouplingActive = this.gos.isColumnsSortingCoupledToGroup();
        const isGroupDisplayColumn = !!column.getColDef().showRowGroup;
        return isColumnSortCouplingActive && isGroupDisplayColumn;
    }
    getDisplaySortForColumn(column) {
        const linkedColumns = this.columnModel.getSourceColumnsForGroupColumn(column);
        if (!this.canColumnDisplayMixedSort(column) || !(linkedColumns == null ? void 0 : linkedColumns.length)) return column.getSort();
        const columnHasUniqueData = column.getColDef().field != null || !!column.getColDef().valueGetter;
        const sortableColumns = columnHasUniqueData ? [
            column,
            ...linkedColumns
        ] : linkedColumns;
        const firstSort = sortableColumns[0].getSort();
        const allMatch = sortableColumns.every((col)=>col.getSort() == firstSort);
        if (!allMatch) return "mixed";
        return firstSort;
    }
    getDisplaySortIndexForColumn(column) {
        return this.getIndexedSortMap().get(column);
    }
};
$437b23f6a393c3bf$export$765594e5be71a851.DEFAULT_SORTING_ORDER = [
    "asc",
    "desc",
    null
];
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnModel")
], $437b23f6a393c3bf$export$765594e5be71a851.prototype, "columnModel", 2);
$437b23f6a393c3bf$export$765594e5be71a851 = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("sortController")
], $437b23f6a393c3bf$export$765594e5be71a851);
// community-modules/core/src/focusService.ts
var $437b23f6a393c3bf$export$a48e931b7fcc2862 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    static addKeyboardModeEvents(doc) {
        if (this.instanceCount > 0) return;
        doc.addEventListener("keydown", $437b23f6a393c3bf$export$a48e931b7fcc2862.toggleKeyboardMode);
        doc.addEventListener("mousedown", $437b23f6a393c3bf$export$a48e931b7fcc2862.toggleKeyboardMode);
    }
    static removeKeyboardModeEvents(doc) {
        if (this.instanceCount > 0) return;
        doc.addEventListener("keydown", $437b23f6a393c3bf$export$a48e931b7fcc2862.toggleKeyboardMode);
        doc.addEventListener("mousedown", $437b23f6a393c3bf$export$a48e931b7fcc2862.toggleKeyboardMode);
    }
    static toggleKeyboardMode(event) {
        const isKeyboardActive = $437b23f6a393c3bf$export$a48e931b7fcc2862.keyboardModeActive;
        const isKeyboardEvent = event.type === "keydown";
        if (isKeyboardEvent) {
            if (event.ctrlKey || event.metaKey || event.altKey) return;
        }
        if (isKeyboardActive === isKeyboardEvent) return;
        $437b23f6a393c3bf$export$a48e931b7fcc2862.keyboardModeActive = isKeyboardEvent;
    }
    static unregisterGridCompController(doc) {
        $437b23f6a393c3bf$export$a48e931b7fcc2862.removeKeyboardModeEvents(doc);
    }
    init() {
        const clearFocusedCellListener = this.clearFocusedCell.bind(this);
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_PIVOT_MODE_CHANGED, clearFocusedCellListener);
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_NEW_COLUMNS_LOADED, this.onColumnEverythingChanged.bind(this));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_GROUP_OPENED, clearFocusedCellListener);
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_ROW_GROUP_CHANGED, clearFocusedCellListener);
        this.registerKeyboardFocusEvents();
        this.ctrlsService.whenReady((p)=>{
            this.gridCtrl = p.gridCtrl;
        });
    }
    registerKeyboardFocusEvents() {
        const eDocument = this.gos.getDocument();
        $437b23f6a393c3bf$export$a48e931b7fcc2862.addKeyboardModeEvents(eDocument);
        $437b23f6a393c3bf$export$a48e931b7fcc2862.instanceCount++;
        this.addDestroyFunc(()=>{
            $437b23f6a393c3bf$export$a48e931b7fcc2862.instanceCount--;
            $437b23f6a393c3bf$export$a48e931b7fcc2862.unregisterGridCompController(eDocument);
        });
    }
    onColumnEverythingChanged() {
        if (!this.focusedCellPosition) return;
        const col = this.focusedCellPosition.column;
        const colFromColumnModel = this.columnModel.getGridColumn(col.getId());
        if (col !== colFromColumnModel) this.clearFocusedCell();
    }
    isKeyboardMode() {
        return $437b23f6a393c3bf$export$a48e931b7fcc2862.keyboardModeActive;
    }
    // we check if the browser is focusing something, and if it is, and
    // it's the cell we think is focused, then return the cell. so this
    // methods returns the cell if a) we think it has focus and b) the
    // browser thinks it has focus. this then returns nothing if we
    // first focus a cell, then second click outside the grid, as then the
    // grid cell will still be focused as far as the grid is concerned,
    // however the browser focus will have moved somewhere else.
    getFocusCellToUseAfterRefresh() {
        if (this.gos.get("suppressFocusAfterRefresh") || !this.focusedCellPosition) return null;
        if (this.isDomDataMissingInHierarchy(this.gos.getActiveDomElement(), $437b23f6a393c3bf$export$e449e57ac30326ed.DOM_DATA_KEY_ROW_CTRL)) return null;
        return this.focusedCellPosition;
    }
    getFocusHeaderToUseAfterRefresh() {
        if (this.gos.get("suppressFocusAfterRefresh") || !this.focusedHeaderPosition) return null;
        if (this.isDomDataMissingInHierarchy(this.gos.getActiveDomElement(), $437b23f6a393c3bf$export$879ff627d5a4d5c.DOM_DATA_KEY_HEADER_CTRL)) return null;
        return this.focusedHeaderPosition;
    }
    isDomDataMissingInHierarchy(eBrowserCell, key) {
        let ePointer = eBrowserCell;
        while(ePointer){
            const data = this.gos.getDomData(ePointer, key);
            if (data) return false;
            ePointer = ePointer.parentNode;
        }
        return true;
    }
    getFocusedCell() {
        return this.focusedCellPosition;
    }
    shouldRestoreFocus(cell) {
        if (this.isCellRestoreFocused(cell)) {
            setTimeout(()=>{
                this.restoredFocusedCellPosition = null;
            }, 0);
            return true;
        }
        return false;
    }
    isCellRestoreFocused(cellPosition) {
        if (this.restoredFocusedCellPosition == null) return false;
        return this.cellPositionUtils.equals(cellPosition, this.restoredFocusedCellPosition);
    }
    setRestoreFocusedCell(cellPosition) {
        if (this.getFrameworkOverrides().renderingEngine === "react") this.restoredFocusedCellPosition = cellPosition;
    }
    getFocusEventParams() {
        const { rowIndex: rowIndex, rowPinned: rowPinned, column: column } = this.focusedCellPosition;
        const params = {
            rowIndex: rowIndex,
            rowPinned: rowPinned,
            column: column,
            isFullWidthCell: false
        };
        const rowCtrl = this.rowRenderer.getRowByPosition({
            rowIndex: rowIndex,
            rowPinned: rowPinned
        });
        if (rowCtrl) params.isFullWidthCell = rowCtrl.isFullWidth();
        return params;
    }
    clearFocusedCell() {
        this.restoredFocusedCellPosition = null;
        if (this.focusedCellPosition == null) return;
        const event = $437b23f6a393c3bf$var$__spreadValues({
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_CELL_FOCUS_CLEARED
        }, this.getFocusEventParams());
        this.focusedCellPosition = null;
        this.eventService.dispatchEvent(event);
    }
    setFocusedCell(params) {
        const { column: column, rowIndex: rowIndex, rowPinned: rowPinned, forceBrowserFocus: forceBrowserFocus = false, preventScrollOnBrowserFocus: preventScrollOnBrowserFocus = false } = params;
        const gridColumn = this.columnModel.getGridColumn(column);
        if (!gridColumn) {
            this.focusedCellPosition = null;
            return;
        }
        this.focusedCellPosition = gridColumn ? {
            rowIndex: rowIndex,
            rowPinned: $437b23f6a393c3bf$var$makeNull(rowPinned),
            column: gridColumn
        } : null;
        const event = $437b23f6a393c3bf$var$__spreadProps($437b23f6a393c3bf$var$__spreadValues({
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_CELL_FOCUSED
        }, this.getFocusEventParams()), {
            forceBrowserFocus: forceBrowserFocus,
            preventScrollOnBrowserFocus: preventScrollOnBrowserFocus,
            floating: null
        });
        this.eventService.dispatchEvent(event);
    }
    isCellFocused(cellPosition) {
        if (this.focusedCellPosition == null) return false;
        return this.cellPositionUtils.equals(cellPosition, this.focusedCellPosition);
    }
    isRowNodeFocused(rowNode) {
        return this.isRowFocused(rowNode.rowIndex, rowNode.rowPinned);
    }
    isHeaderWrapperFocused(headerCtrl) {
        if (this.focusedHeaderPosition == null) return false;
        const column = headerCtrl.getColumnGroupChild();
        const headerRowIndex = headerCtrl.getRowIndex();
        const pinned = headerCtrl.getPinned();
        const { column: focusedColumn, headerRowIndex: focusedHeaderRowIndex } = this.focusedHeaderPosition;
        return column === focusedColumn && headerRowIndex === focusedHeaderRowIndex && pinned == focusedColumn.getPinned();
    }
    clearFocusedHeader() {
        this.focusedHeaderPosition = null;
    }
    getFocusedHeader() {
        return this.focusedHeaderPosition;
    }
    setFocusedHeader(headerRowIndex, column) {
        this.focusedHeaderPosition = {
            headerRowIndex: headerRowIndex,
            column: column
        };
    }
    focusHeaderPosition(params) {
        if (this.gos.get("suppressHeaderFocus")) return false;
        const { direction: direction, fromTab: fromTab, allowUserOverride: allowUserOverride, event: event, fromCell: fromCell, rowWithoutSpanValue: rowWithoutSpanValue } = params;
        let { headerPosition: headerPosition } = params;
        if (fromCell && this.filterManager.isAdvancedFilterHeaderActive()) return this.focusAdvancedFilter(headerPosition);
        if (allowUserOverride) {
            const currentPosition = this.getFocusedHeader();
            const headerRowCount = this.headerNavigationService.getHeaderRowCount();
            if (fromTab) {
                const userFunc = this.gos.getCallback("tabToNextHeader");
                if (userFunc) headerPosition = this.getHeaderPositionFromUserFunc({
                    userFunc: userFunc,
                    direction: direction,
                    currentPosition: currentPosition,
                    headerPosition: headerPosition,
                    headerRowCount: headerRowCount
                });
            } else {
                const userFunc = this.gos.getCallback("navigateToNextHeader");
                if (userFunc && event) {
                    const params2 = {
                        key: event.key,
                        previousHeaderPosition: currentPosition,
                        nextHeaderPosition: headerPosition,
                        headerRowCount: headerRowCount,
                        event: event
                    };
                    headerPosition = userFunc(params2);
                }
            }
        }
        if (!headerPosition) return false;
        return this.focusProvidedHeaderPosition({
            headerPosition: headerPosition,
            direction: direction,
            event: event,
            fromCell: fromCell,
            rowWithoutSpanValue: rowWithoutSpanValue
        });
    }
    focusHeaderPositionFromUserFunc(params) {
        if (this.gos.get("suppressHeaderFocus")) return false;
        const { userFunc: userFunc, headerPosition: headerPosition, direction: direction, event: event } = params;
        const currentPosition = this.getFocusedHeader();
        const headerRowCount = this.headerNavigationService.getHeaderRowCount();
        const newHeaderPosition = this.getHeaderPositionFromUserFunc({
            userFunc: userFunc,
            direction: direction,
            currentPosition: currentPosition,
            headerPosition: headerPosition,
            headerRowCount: headerRowCount
        });
        return !!newHeaderPosition && this.focusProvidedHeaderPosition({
            headerPosition: newHeaderPosition,
            direction: direction,
            event: event
        });
    }
    getHeaderPositionFromUserFunc(params) {
        const { userFunc: userFunc, direction: direction, currentPosition: currentPosition, headerPosition: headerPosition, headerRowCount: headerRowCount } = params;
        const userFuncParams = {
            backwards: direction === "Before",
            previousHeaderPosition: currentPosition,
            nextHeaderPosition: headerPosition,
            headerRowCount: headerRowCount
        };
        const userResult = userFunc(userFuncParams);
        if (userResult === true || userResult === null) {
            if (userResult === null) $437b23f6a393c3bf$var$warnOnce("Returning `null` from tabToNextHeader is deprecated. Return `true` to stay on the current header, or `false` to let the browser handle the tab behaviour.");
            return currentPosition;
        }
        if (userResult === false) return null;
        return userResult;
    }
    focusProvidedHeaderPosition(params) {
        const { headerPosition: headerPosition, direction: direction, fromCell: fromCell, rowWithoutSpanValue: rowWithoutSpanValue, event: event } = params;
        if (headerPosition.headerRowIndex === -1) {
            if (this.filterManager.isAdvancedFilterHeaderActive()) return this.focusAdvancedFilter(headerPosition);
            return this.focusGridView(headerPosition.column);
        }
        this.headerNavigationService.scrollToColumn(headerPosition.column, direction);
        const headerRowContainerCtrl = this.ctrlsService.getHeaderRowContainerCtrl(headerPosition.column.getPinned());
        const focusSuccess = headerRowContainerCtrl.focusHeader(headerPosition.headerRowIndex, headerPosition.column, event);
        if (focusSuccess && (rowWithoutSpanValue != null || fromCell)) this.headerNavigationService.setCurrentHeaderRowWithoutSpan(rowWithoutSpanValue != null ? rowWithoutSpanValue : -1);
        return focusSuccess;
    }
    focusFirstHeader() {
        let firstColumn = this.columnModel.getAllDisplayedColumns()[0];
        if (!firstColumn) return false;
        if (firstColumn.getParent()) firstColumn = this.columnModel.getColumnGroupAtLevel(firstColumn, 0);
        const headerPosition = this.headerPositionUtils.getHeaderIndexToFocus(firstColumn, 0);
        return this.focusHeaderPosition({
            headerPosition: headerPosition,
            rowWithoutSpanValue: 0
        });
    }
    focusLastHeader(event) {
        const headerRowIndex = this.headerNavigationService.getHeaderRowCount() - 1;
        const column = $437b23f6a393c3bf$var$last(this.columnModel.getAllDisplayedColumns());
        return this.focusHeaderPosition({
            headerPosition: {
                headerRowIndex: headerRowIndex,
                column: column
            },
            rowWithoutSpanValue: -1,
            event: event
        });
    }
    focusPreviousFromFirstCell(event) {
        if (this.filterManager.isAdvancedFilterHeaderActive()) return this.focusAdvancedFilter(null);
        return this.focusLastHeader(event);
    }
    isAnyCellFocused() {
        return !!this.focusedCellPosition;
    }
    isRowFocused(rowIndex, floating) {
        if (this.focusedCellPosition == null) return false;
        return this.focusedCellPosition.rowIndex === rowIndex && this.focusedCellPosition.rowPinned === $437b23f6a393c3bf$var$makeNull(floating);
    }
    findFocusableElements(rootNode, exclude, onlyUnmanaged = false) {
        const focusableString = $437b23f6a393c3bf$var$FOCUSABLE_SELECTOR;
        let excludeString = $437b23f6a393c3bf$var$FOCUSABLE_EXCLUDE;
        if (exclude) excludeString += ", " + exclude;
        if (onlyUnmanaged) excludeString += ', [tabindex="-1"]';
        const nodes = Array.prototype.slice.apply(rootNode.querySelectorAll(focusableString)).filter((node)=>{
            return $437b23f6a393c3bf$var$isVisible(node);
        });
        const excludeNodes = Array.prototype.slice.apply(rootNode.querySelectorAll(excludeString));
        if (!excludeNodes.length) return nodes;
        const diff = (a, b)=>a.filter((element)=>b.indexOf(element) === -1);
        return diff(nodes, excludeNodes);
    }
    focusInto(rootNode, up = false, onlyUnmanaged = false) {
        const focusableElements = this.findFocusableElements(rootNode, null, onlyUnmanaged);
        const toFocus = up ? $437b23f6a393c3bf$var$last(focusableElements) : focusableElements[0];
        if (toFocus) {
            toFocus.focus({
                preventScroll: true
            });
            return true;
        }
        return false;
    }
    findFocusableElementBeforeTabGuard(rootNode, referenceElement) {
        if (!referenceElement) return null;
        const focusableElements = this.findFocusableElements(rootNode);
        const referenceIndex = focusableElements.indexOf(referenceElement);
        if (referenceIndex === -1) return null;
        let lastTabGuardIndex = -1;
        for(let i = referenceIndex - 1; i >= 0; i--)if (focusableElements[i].classList.contains("ag-tab-guard-top" /* TAB_GUARD_TOP */ )) {
            lastTabGuardIndex = i;
            break;
        }
        if (lastTabGuardIndex <= 0) return null;
        return focusableElements[lastTabGuardIndex - 1];
    }
    findNextFocusableElement(rootNode = this.eGridDiv, onlyManaged, backwards) {
        const focusable = this.findFocusableElements(rootNode, onlyManaged ? ':not([tabindex="-1"])' : null);
        const activeEl = this.gos.getActiveDomElement();
        let currentIndex;
        if (onlyManaged) currentIndex = focusable.findIndex((el)=>el.contains(activeEl));
        else currentIndex = focusable.indexOf(activeEl);
        const nextIndex = currentIndex + (backwards ? -1 : 1);
        if (nextIndex < 0 || nextIndex >= focusable.length) return null;
        return focusable[nextIndex];
    }
    isTargetUnderManagedComponent(rootNode, target) {
        if (!target) return false;
        const managedContainers = rootNode.querySelectorAll(`.${$437b23f6a393c3bf$export$5510e53ed3962582.FOCUS_MANAGED_CLASS}`);
        if (!managedContainers.length) return false;
        for(let i = 0; i < managedContainers.length; i++){
            if (managedContainers[i].contains(target)) return true;
        }
        return false;
    }
    findTabbableParent(node, limit = 5) {
        let counter = 0;
        while(node && $437b23f6a393c3bf$var$getTabIndex(node) === null && ++counter <= limit)node = node.parentElement;
        if ($437b23f6a393c3bf$var$getTabIndex(node) === null) return null;
        return node;
    }
    focusGridView(column, backwards) {
        var _a;
        if (this.gos.get("suppressCellFocus")) {
            if (backwards) {
                if (!this.gos.get("suppressHeaderFocus")) return this.focusLastHeader();
                return this.focusNextGridCoreContainer(true, true);
            }
            return this.focusNextGridCoreContainer(false);
        }
        const nextRow = backwards ? this.rowPositionUtils.getLastRow() : this.rowPositionUtils.getFirstRow();
        if (!nextRow) return false;
        const { rowIndex: rowIndex, rowPinned: rowPinned } = nextRow;
        const focusedHeader = this.getFocusedHeader();
        if (!column && focusedHeader) column = focusedHeader.column;
        if (rowIndex == null || !column) return false;
        this.navigationService.ensureCellVisible({
            rowIndex: rowIndex,
            column: column,
            rowPinned: rowPinned
        });
        this.setFocusedCell({
            rowIndex: rowIndex,
            column: column,
            rowPinned: $437b23f6a393c3bf$var$makeNull(rowPinned),
            forceBrowserFocus: true
        });
        (_a = this.rangeService) == null || _a.setRangeToCell({
            rowIndex: rowIndex,
            rowPinned: rowPinned,
            column: column
        });
        return true;
    }
    focusNextGridCoreContainer(backwards, forceOut = false) {
        if (!forceOut && this.gridCtrl.focusNextInnerContainer(backwards)) return true;
        if (forceOut || !backwards && !this.gridCtrl.isDetailGrid()) this.gridCtrl.forceFocusOutOfContainer(backwards);
        return false;
    }
    focusAdvancedFilter(position) {
        var _a, _b;
        this.advancedFilterFocusColumn = position == null ? void 0 : position.column;
        return (_b = (_a = this.advancedFilterService) == null ? void 0 : _a.getCtrl().focusHeaderComp()) != null ? _b : false;
    }
    focusNextFromAdvancedFilter(backwards, forceFirstColumn) {
        var _a, _b;
        const column = (_b = forceFirstColumn ? void 0 : this.advancedFilterFocusColumn) != null ? _b : (_a = this.columnModel.getAllDisplayedColumns()) == null ? void 0 : _a[0];
        if (backwards) return this.focusHeaderPosition({
            headerPosition: {
                column: column,
                headerRowIndex: this.headerNavigationService.getHeaderRowCount() - 1
            }
        });
        else return this.focusGridView(column);
    }
    clearAdvancedFilterColumn() {
        this.advancedFilterFocusColumn = void 0;
    }
};
$437b23f6a393c3bf$export$a48e931b7fcc2862.keyboardModeActive = false;
$437b23f6a393c3bf$export$a48e931b7fcc2862.instanceCount = 0;
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("eGridDiv")
], $437b23f6a393c3bf$export$a48e931b7fcc2862.prototype, "eGridDiv", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnModel")
], $437b23f6a393c3bf$export$a48e931b7fcc2862.prototype, "columnModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("headerNavigationService")
], $437b23f6a393c3bf$export$a48e931b7fcc2862.prototype, "headerNavigationService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("headerPositionUtils")
], $437b23f6a393c3bf$export$a48e931b7fcc2862.prototype, "headerPositionUtils", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowRenderer")
], $437b23f6a393c3bf$export$a48e931b7fcc2862.prototype, "rowRenderer", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowPositionUtils")
], $437b23f6a393c3bf$export$a48e931b7fcc2862.prototype, "rowPositionUtils", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("cellPositionUtils")
], $437b23f6a393c3bf$export$a48e931b7fcc2862.prototype, "cellPositionUtils", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("navigationService")
], $437b23f6a393c3bf$export$a48e931b7fcc2862.prototype, "navigationService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("ctrlsService")
], $437b23f6a393c3bf$export$a48e931b7fcc2862.prototype, "ctrlsService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("filterManager")
], $437b23f6a393c3bf$export$a48e931b7fcc2862.prototype, "filterManager", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$7acb7b24c478f9c6("rangeService")
], $437b23f6a393c3bf$export$a48e931b7fcc2862.prototype, "rangeService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$7acb7b24c478f9c6("advancedFilterService")
], $437b23f6a393c3bf$export$a48e931b7fcc2862.prototype, "advancedFilterService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$export$a48e931b7fcc2862.prototype, "init", 1);
$437b23f6a393c3bf$export$a48e931b7fcc2862 = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("focusService")
], $437b23f6a393c3bf$export$a48e931b7fcc2862);
// community-modules/core/src/rendering/columnHoverService.ts
var $437b23f6a393c3bf$var$ColumnHoverService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    setMouseOver(columns) {
        this.selectedColumns = columns;
        const event = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_HOVER_CHANGED
        };
        this.eventService.dispatchEvent(event);
    }
    clearMouseOver() {
        this.selectedColumns = null;
        const event = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_HOVER_CHANGED
        };
        this.eventService.dispatchEvent(event);
    }
    isHovered(column) {
        return !!this.selectedColumns && this.selectedColumns.indexOf(column) >= 0;
    }
};
$437b23f6a393c3bf$var$ColumnHoverService = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("columnHoverService")
], $437b23f6a393c3bf$var$ColumnHoverService);
// community-modules/core/src/rendering/columnAnimationService.ts
var $437b23f6a393c3bf$var$ColumnAnimationService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.executeNextFuncs = [];
        this.executeLaterFuncs = [];
        this.active = false;
        this.suppressAnimation = false;
        this.animationThreadCount = 0;
    }
    postConstruct() {
        this.ctrlsService.whenReady((p)=>this.gridBodyCtrl = p.gridBodyCtrl);
    }
    isActive() {
        return this.active && !this.suppressAnimation;
    }
    setSuppressAnimation(suppress) {
        this.suppressAnimation = suppress;
    }
    start() {
        if (this.active) return;
        if (this.gos.get("suppressColumnMoveAnimation")) return;
        if (this.gos.get("enableRtl")) return;
        this.ensureAnimationCssClassPresent();
        this.active = true;
    }
    finish() {
        if (!this.active) return;
        this.flush(()=>{
            this.active = false;
        });
    }
    executeNextVMTurn(func) {
        if (this.active) this.executeNextFuncs.push(func);
        else func();
    }
    executeLaterVMTurn(func) {
        if (this.active) this.executeLaterFuncs.push(func);
        else func();
    }
    ensureAnimationCssClassPresent() {
        this.animationThreadCount++;
        const animationThreadCountCopy = this.animationThreadCount;
        this.gridBodyCtrl.setColumnMovingCss(true);
        this.executeLaterFuncs.push(()=>{
            if (this.animationThreadCount === animationThreadCountCopy) this.gridBodyCtrl.setColumnMovingCss(false);
        });
    }
    flush(callback) {
        if (this.executeNextFuncs.length === 0 && this.executeLaterFuncs.length === 0) {
            callback();
            return;
        }
        const runFuncs = (queue)=>{
            while(queue.length){
                const func = queue.pop();
                if (func) func();
            }
        };
        this.getFrameworkOverrides().wrapIncoming(()=>{
            window.setTimeout(()=>runFuncs(this.executeNextFuncs), 0);
            window.setTimeout(()=>{
                callback();
                runFuncs(this.executeLaterFuncs);
            }, 200);
        });
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("ctrlsService")
], $437b23f6a393c3bf$var$ColumnAnimationService.prototype, "ctrlsService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$ColumnAnimationService.prototype, "postConstruct", 1);
$437b23f6a393c3bf$var$ColumnAnimationService = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("columnAnimationService")
], $437b23f6a393c3bf$var$ColumnAnimationService);
// community-modules/core/src/pagination/paginationAutoPageSizeService.ts
var $437b23f6a393c3bf$var$PaginationAutoPageSizeService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    postConstruct() {
        this.ctrlsService.whenReady((p)=>{
            this.centerRowsCtrl = p.center;
            this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_BODY_HEIGHT_CHANGED, this.checkPageSize.bind(this));
            this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_SCROLL_VISIBILITY_CHANGED, this.checkPageSize.bind(this));
            this.addManagedPropertyListener("paginationAutoPageSize", this.onPaginationAutoSizeChanged.bind(this));
            this.checkPageSize();
        });
    }
    notActive() {
        return !this.gos.get("paginationAutoPageSize") || this.centerRowsCtrl == null;
    }
    onPaginationAutoSizeChanged() {
        if (this.notActive()) this.paginationProxy.unsetAutoCalculatedPageSize();
        else this.checkPageSize();
    }
    checkPageSize() {
        if (this.notActive()) return;
        const bodyHeight = this.centerRowsCtrl.getViewportSizeFeature().getBodyHeight();
        if (bodyHeight > 0) {
            const update = ()=>{
                const rowHeight = this.gos.getRowHeightAsNumber();
                const newPageSize = Math.floor(bodyHeight / rowHeight);
                this.paginationProxy.setPageSize(newPageSize, "autoCalculated");
            };
            if (!this.isBodyRendered) {
                update();
                this.isBodyRendered = true;
            } else $437b23f6a393c3bf$var$debounce(()=>update(), 50)();
        } else this.isBodyRendered = false;
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("ctrlsService")
], $437b23f6a393c3bf$var$PaginationAutoPageSizeService.prototype, "ctrlsService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("paginationProxy")
], $437b23f6a393c3bf$var$PaginationAutoPageSizeService.prototype, "paginationProxy", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$PaginationAutoPageSizeService.prototype, "postConstruct", 1);
$437b23f6a393c3bf$var$PaginationAutoPageSizeService = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("paginationAutoPageSizeService")
], $437b23f6a393c3bf$var$PaginationAutoPageSizeService);
// community-modules/core/src/valueService/valueCache.ts
var $437b23f6a393c3bf$export$8bb85f19590498f6 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.cacheVersion = 0;
    }
    init() {
        this.active = this.gos.get("valueCache");
        this.neverExpires = this.gos.get("valueCacheNeverExpires");
    }
    onDataChanged() {
        if (this.neverExpires) return;
        this.expire();
    }
    expire() {
        this.cacheVersion++;
    }
    setValue(rowNode, colId, value) {
        if (this.active) {
            if (rowNode.__cacheVersion !== this.cacheVersion) {
                rowNode.__cacheVersion = this.cacheVersion;
                rowNode.__cacheData = {};
            }
            rowNode.__cacheData[colId] = value;
        }
    }
    getValue(rowNode, colId) {
        if (!this.active || rowNode.__cacheVersion !== this.cacheVersion) return void 0;
        return rowNode.__cacheData[colId];
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$export$8bb85f19590498f6.prototype, "init", 1);
$437b23f6a393c3bf$export$8bb85f19590498f6 = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("valueCache")
], $437b23f6a393c3bf$export$8bb85f19590498f6);
// community-modules/core/src/valueService/changeDetectionService.ts
var $437b23f6a393c3bf$var$SOURCE_PASTE = "paste";
var $437b23f6a393c3bf$var$ChangeDetectionService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    init() {
        if (this.rowModel.getType() === "clientSide") this.clientSideRowModel = this.rowModel;
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_CELL_VALUE_CHANGED, this.onCellValueChanged.bind(this));
    }
    onCellValueChanged(event) {
        if (event.source === $437b23f6a393c3bf$var$SOURCE_PASTE) return;
        this.doChangeDetection(event.node, event.column);
    }
    doChangeDetection(rowNode, column) {
        if (this.gos.get("suppressChangeDetection")) return;
        const nodesToRefresh = [
            rowNode
        ];
        if (this.clientSideRowModel && !rowNode.isRowPinned()) {
            const onlyChangedColumns = this.gos.get("aggregateOnlyChangedColumns");
            const changedPath = new $437b23f6a393c3bf$export$cb4d9114a9732e85(onlyChangedColumns, this.clientSideRowModel.getRootNode());
            changedPath.addParentNode(rowNode.parent, [
                column
            ]);
            this.clientSideRowModel.doAggregate(changedPath);
            changedPath.forEachChangedNodeDepthFirst((rowNode2)=>{
                nodesToRefresh.push(rowNode2);
            });
        }
        this.rowRenderer.refreshCells({
            rowNodes: nodesToRefresh
        });
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowModel")
], $437b23f6a393c3bf$var$ChangeDetectionService.prototype, "rowModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowRenderer")
], $437b23f6a393c3bf$var$ChangeDetectionService.prototype, "rowRenderer", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$ChangeDetectionService.prototype, "init", 1);
$437b23f6a393c3bf$var$ChangeDetectionService = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("changeDetectionService")
], $437b23f6a393c3bf$var$ChangeDetectionService);
// community-modules/core/src/components/framework/agComponentUtils.ts
var $437b23f6a393c3bf$var$AgComponentUtils = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    adaptFunction(propertyName, jsCompFunc) {
        const metadata = this.componentMetadataProvider.retrieve(propertyName);
        if (metadata && metadata.functionAdapter) return metadata.functionAdapter(jsCompFunc);
        return null;
    }
    adaptCellRendererFunction(callback) {
        class Adapter {
            refresh(params) {
                return false;
            }
            getGui() {
                return this.eGui;
            }
            init(params) {
                const callbackResult = callback(params);
                const type = typeof callbackResult;
                if (type === "string" || type === "number" || type === "boolean") {
                    this.eGui = $437b23f6a393c3bf$var$loadTemplate("<span>" + callbackResult + "</span>");
                    return;
                }
                if (callbackResult == null) {
                    this.eGui = $437b23f6a393c3bf$var$loadTemplate("<span></span>");
                    return;
                }
                this.eGui = callbackResult;
            }
        }
        return Adapter;
    }
    doesImplementIComponent(candidate) {
        if (!candidate) return false;
        return candidate.prototype && "getGui" in candidate.prototype;
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("componentMetadataProvider")
], $437b23f6a393c3bf$var$AgComponentUtils.prototype, "componentMetadataProvider", 2);
$437b23f6a393c3bf$var$AgComponentUtils = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("agComponentUtils")
], $437b23f6a393c3bf$var$AgComponentUtils);
// community-modules/core/src/components/framework/componentMetadataProvider.ts
var $437b23f6a393c3bf$var$ComponentMetadataProvider = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    postConstruct() {
        this.componentMetaData = {
            dateComponent: {
                mandatoryMethodList: [
                    "getDate",
                    "setDate"
                ],
                optionalMethodList: [
                    "afterGuiAttached",
                    "setInputPlaceholder",
                    "setInputAriaLabel",
                    "setDisabled",
                    "onParamsUpdated",
                    "refresh"
                ]
            },
            detailCellRenderer: {
                mandatoryMethodList: [],
                optionalMethodList: [
                    "refresh"
                ],
                functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
            },
            headerComponent: {
                mandatoryMethodList: [],
                optionalMethodList: [
                    "refresh"
                ]
            },
            headerGroupComponent: {
                mandatoryMethodList: [],
                optionalMethodList: []
            },
            loadingCellRenderer: {
                mandatoryMethodList: [],
                optionalMethodList: [],
                functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
            },
            loadingOverlayComponent: {
                mandatoryMethodList: [],
                optionalMethodList: [
                    "refresh"
                ]
            },
            noRowsOverlayComponent: {
                mandatoryMethodList: [],
                optionalMethodList: [
                    "refresh"
                ]
            },
            floatingFilterComponent: {
                mandatoryMethodList: [
                    "onParentModelChanged"
                ],
                optionalMethodList: [
                    "afterGuiAttached",
                    "onParamsUpdated",
                    "refresh"
                ]
            },
            cellRenderer: {
                mandatoryMethodList: [],
                optionalMethodList: [
                    "refresh",
                    "afterGuiAttached"
                ],
                functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
            },
            cellEditor: {
                mandatoryMethodList: [
                    "getValue"
                ],
                optionalMethodList: [
                    "isPopup",
                    "isCancelBeforeStart",
                    "isCancelAfterEnd",
                    "getPopupPosition",
                    "focusIn",
                    "focusOut",
                    "afterGuiAttached",
                    "refresh"
                ]
            },
            innerRenderer: {
                mandatoryMethodList: [],
                optionalMethodList: [
                    "afterGuiAttached"
                ],
                functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
            },
            fullWidthCellRenderer: {
                mandatoryMethodList: [],
                optionalMethodList: [
                    "refresh",
                    "afterGuiAttached"
                ],
                functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
            },
            groupRowRenderer: {
                mandatoryMethodList: [],
                optionalMethodList: [
                    "afterGuiAttached"
                ],
                functionAdapter: this.agComponentUtils.adaptCellRendererFunction.bind(this.agComponentUtils)
            },
            filter: {
                mandatoryMethodList: [
                    "isFilterActive",
                    "doesFilterPass",
                    "getModel",
                    "setModel"
                ],
                optionalMethodList: [
                    "afterGuiAttached",
                    "afterGuiDetached",
                    "onNewRowsLoaded",
                    "getModelAsString",
                    "onFloatingFilterChanged",
                    "onAnyFilterChanged",
                    "refresh"
                ]
            },
            statusPanel: {
                mandatoryMethodList: [],
                optionalMethodList: [
                    "refresh"
                ]
            },
            toolPanel: {
                mandatoryMethodList: [],
                optionalMethodList: [
                    "refresh",
                    "getState"
                ]
            },
            tooltipComponent: {
                mandatoryMethodList: [],
                optionalMethodList: []
            },
            menuItem: {
                mandatoryMethodList: [],
                optionalMethodList: [
                    "setActive",
                    "select",
                    "setExpanded",
                    "configureDefaults"
                ]
            }
        };
    }
    retrieve(name) {
        return this.componentMetaData[name];
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("agComponentUtils")
], $437b23f6a393c3bf$var$ComponentMetadataProvider.prototype, "agComponentUtils", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$ComponentMetadataProvider.prototype, "postConstruct", 1);
$437b23f6a393c3bf$var$ComponentMetadataProvider = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("componentMetadataProvider")
], $437b23f6a393c3bf$var$ComponentMetadataProvider);
// community-modules/core/src/environment.ts
var $437b23f6a393c3bf$var$DEFAULT_ROW_HEIGHT = 25;
var $437b23f6a393c3bf$var$MIN_COL_WIDTH = 10;
var $437b23f6a393c3bf$var$MAT_GRID_SIZE = 8;
var $437b23f6a393c3bf$var$BASE_GRID_SIZE = 4;
var $437b23f6a393c3bf$var$BALHAM_GRID_SIZE = 4;
var $437b23f6a393c3bf$var$ALPINE_GRID_SIZE = 6;
var $437b23f6a393c3bf$var$QUARTZ_ICON_SIZE = 16;
var $437b23f6a393c3bf$var$QUARTZ_FONT_SIZE = 14;
var $437b23f6a393c3bf$var$QUARTZ_GRID_SIZE = 8;
var $437b23f6a393c3bf$var$HARD_CODED_SIZES = {
    // this item is required for custom themes
    "ag-theme-custom": {
        headerHeight: 25,
        headerCellMinWidth: 24,
        listItemHeight: $437b23f6a393c3bf$var$BASE_GRID_SIZE * 5,
        rowHeight: 25,
        chartMenuPanelWidth: 220
    },
    "ag-theme-material": {
        headerHeight: $437b23f6a393c3bf$var$MAT_GRID_SIZE * 7,
        headerCellMinWidth: 48,
        listItemHeight: $437b23f6a393c3bf$var$MAT_GRID_SIZE * 4,
        rowHeight: $437b23f6a393c3bf$var$MAT_GRID_SIZE * 6,
        chartMenuPanelWidth: 240
    },
    "ag-theme-balham": {
        headerHeight: $437b23f6a393c3bf$var$BALHAM_GRID_SIZE * 8,
        headerCellMinWidth: 24,
        listItemHeight: $437b23f6a393c3bf$var$BALHAM_GRID_SIZE * 6,
        rowHeight: $437b23f6a393c3bf$var$BALHAM_GRID_SIZE * 7,
        chartMenuPanelWidth: 220
    },
    "ag-theme-alpine": {
        headerHeight: $437b23f6a393c3bf$var$ALPINE_GRID_SIZE * 8,
        headerCellMinWidth: 36,
        listItemHeight: $437b23f6a393c3bf$var$ALPINE_GRID_SIZE * 4,
        rowHeight: $437b23f6a393c3bf$var$ALPINE_GRID_SIZE * 7,
        chartMenuPanelWidth: 240
    },
    "ag-theme-quartz": {
        headerHeight: $437b23f6a393c3bf$var$QUARTZ_FONT_SIZE + $437b23f6a393c3bf$var$QUARTZ_GRID_SIZE * 4.25,
        headerCellMinWidth: 36,
        listItemHeight: $437b23f6a393c3bf$var$QUARTZ_ICON_SIZE + $437b23f6a393c3bf$var$QUARTZ_GRID_SIZE,
        rowHeight: $437b23f6a393c3bf$var$QUARTZ_FONT_SIZE + $437b23f6a393c3bf$var$QUARTZ_GRID_SIZE * 3.5,
        chartMenuPanelWidth: 260
    }
};
var $437b23f6a393c3bf$var$SASS_PROPERTY_BUILDER = {
    headerHeight: [
        "ag-header-row"
    ],
    headerCellMinWidth: [
        "ag-header-cell"
    ],
    listItemHeight: [
        "ag-virtual-list-item"
    ],
    rowHeight: [
        "ag-row"
    ],
    chartMenuPanelWidth: [
        "ag-chart-docked-container"
    ]
};
var $437b23f6a393c3bf$export$7dc6752a22ab011a = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.calculatedSizes = {};
        this.calculatedTheme = null;
    }
    postConstruct() {
        var _a;
        const el = (_a = this.getTheme().el) != null ? _a : this.eGridDiv;
        this.addManagedPropertyListener("rowHeight", ()=>this.refreshRowHeightVariable());
        this.mutationObserver = new MutationObserver(()=>{
            this.calculatedSizes = {};
            this.calculatedTheme = null;
            this.calculatedTheme = this.getTheme();
            this.fireGridStylesChangedEvent();
        });
        this.mutationObserver.observe(el || this.eGridDiv, {
            attributes: true,
            attributeFilter: [
                "class"
            ]
        });
    }
    fireGridStylesChangedEvent() {
        const event = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_GRID_STYLES_CHANGED
        };
        this.eventService.dispatchEvent(event);
    }
    getSassVariable(key) {
        const { themeFamily: themeFamily, el: el } = this.getTheme();
        if (!themeFamily || themeFamily.indexOf("ag-theme") !== 0) return;
        if (!this.calculatedSizes) this.calculatedSizes = {};
        if (!this.calculatedSizes[themeFamily]) this.calculatedSizes[themeFamily] = {};
        const size = this.calculatedSizes[themeFamily][key];
        if (size != null) return size;
        this.calculatedSizes[themeFamily][key] = this.calculateValueForSassProperty(key, themeFamily, el);
        return this.calculatedSizes[themeFamily][key];
    }
    calculateValueForSassProperty(property, theme, themeElement) {
        const useTheme = "ag-theme-" + (theme.match("material") ? "material" : theme.match("balham") ? "balham" : theme.match("alpine") ? "alpine" : "custom");
        const defaultValue = $437b23f6a393c3bf$var$HARD_CODED_SIZES[useTheme][property];
        const eDocument = this.gos.getDocument();
        if (!themeElement) themeElement = this.eGridDiv;
        if (!$437b23f6a393c3bf$var$SASS_PROPERTY_BUILDER[property]) return defaultValue;
        const classList = $437b23f6a393c3bf$var$SASS_PROPERTY_BUILDER[property];
        const div = eDocument.createElement("div");
        const classesFromThemeElement = Array.from(themeElement.classList);
        div.classList.add(theme, ...classesFromThemeElement);
        div.style.position = "absolute";
        const el = classList.reduce((prevEl, currentClass)=>{
            const currentDiv = eDocument.createElement("div");
            currentDiv.style.position = "static";
            currentDiv.classList.add(currentClass);
            prevEl.appendChild(currentDiv);
            return currentDiv;
        }, div);
        let calculatedValue = 0;
        if (eDocument.body) {
            eDocument.body.appendChild(div);
            const sizeName = property.toLowerCase().indexOf("height") !== -1 ? "height" : "width";
            calculatedValue = parseInt(window.getComputedStyle(el)[sizeName], 10);
            eDocument.body.removeChild(div);
        }
        return calculatedValue || defaultValue;
    }
    isThemeDark() {
        const { theme: theme } = this.getTheme();
        return !!theme && theme.indexOf("dark") >= 0;
    }
    chartMenuPanelWidth() {
        return this.getSassVariable("chartMenuPanelWidth");
    }
    getTheme() {
        if (this.calculatedTheme) return this.calculatedTheme;
        const reg = /\bag-(material|(?:theme-([\w\-]*)))\b/g;
        let el = this.eGridDiv;
        let themeMatch = null;
        let allThemes = [];
        while(el){
            themeMatch = reg.exec(el.className);
            if (!themeMatch) el = el.parentElement || void 0;
            else {
                const matched = el.className.match(reg);
                if (matched) allThemes = matched;
                break;
            }
        }
        if (!themeMatch) return {
            allThemes: allThemes
        };
        const theme = themeMatch[0];
        this.calculatedTheme = {
            theme: theme,
            el: el,
            themeFamily: theme.replace(/-dark$/, ""),
            allThemes: allThemes
        };
        return this.calculatedTheme;
    }
    getFromTheme(defaultValue, sassVariableName) {
        var _a;
        return (_a = this.getSassVariable(sassVariableName)) != null ? _a : defaultValue;
    }
    getDefaultRowHeight() {
        return this.getFromTheme($437b23f6a393c3bf$var$DEFAULT_ROW_HEIGHT, "rowHeight");
    }
    getListItemHeight() {
        return this.getFromTheme(20, "listItemHeight");
    }
    refreshRowHeightVariable() {
        const oldRowHeight = this.eGridDiv.style.getPropertyValue("--ag-line-height").trim();
        const height = this.gos.get("rowHeight");
        if (height == null || isNaN(height) || !isFinite(height)) {
            if (oldRowHeight !== null) this.eGridDiv.style.setProperty("--ag-line-height", null);
            return -1;
        }
        const newRowHeight = `${height}px`;
        if (oldRowHeight != newRowHeight) {
            this.eGridDiv.style.setProperty("--ag-line-height", newRowHeight);
            return height;
        }
        return oldRowHeight != "" ? parseFloat(oldRowHeight) : -1;
    }
    getMinColWidth() {
        const measuredMin = this.getFromTheme(null, "headerCellMinWidth");
        return $437b23f6a393c3bf$var$exists(measuredMin) ? Math.max(measuredMin, $437b23f6a393c3bf$var$MIN_COL_WIDTH) : $437b23f6a393c3bf$var$MIN_COL_WIDTH;
    }
    destroy() {
        this.calculatedSizes = null;
        if (this.mutationObserver) this.mutationObserver.disconnect();
        super.destroy();
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("eGridDiv")
], $437b23f6a393c3bf$export$7dc6752a22ab011a.prototype, "eGridDiv", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$export$7dc6752a22ab011a.prototype, "postConstruct", 1);
$437b23f6a393c3bf$export$7dc6752a22ab011a = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("environment")
], $437b23f6a393c3bf$export$7dc6752a22ab011a);
// community-modules/core/src/rendering/rowContainerHeightService.ts
var $437b23f6a393c3bf$var$RowContainerHeightService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        // the scrollY position
        this.scrollY = 0;
        // how tall the body is
        this.uiBodyHeight = 0;
    }
    agWire(loggerFactory) {
        this.logger = loggerFactory.create("RowContainerHeightService");
    }
    postConstruct() {
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_BODY_HEIGHT_CHANGED, this.updateOffset.bind(this));
        this.maxDivHeight = $437b23f6a393c3bf$var$getMaxDivHeight();
        this.logger.log("maxDivHeight = " + this.maxDivHeight);
    }
    isStretching() {
        return this.stretching;
    }
    getDivStretchOffset() {
        return this.divStretchOffset;
    }
    updateOffset() {
        if (!this.stretching) return;
        const gridBodyCon = this.ctrlsService.getGridBodyCtrl();
        const newScrollY = gridBodyCon.getScrollFeature().getVScrollPosition().top;
        const newBodyHeight = this.getUiBodyHeight();
        const atLeastOneChanged = newScrollY !== this.scrollY || newBodyHeight !== this.uiBodyHeight;
        if (atLeastOneChanged) {
            this.scrollY = newScrollY;
            this.uiBodyHeight = newBodyHeight;
            this.calculateOffset();
        }
    }
    calculateOffset() {
        this.setUiContainerHeight(this.maxDivHeight);
        this.pixelsToShave = this.modelHeight - this.uiContainerHeight;
        this.maxScrollY = this.uiContainerHeight - this.uiBodyHeight;
        const scrollPercent = this.scrollY / this.maxScrollY;
        const divStretchOffset = scrollPercent * this.pixelsToShave;
        this.logger.log(`Div Stretch Offset = ${divStretchOffset} (${this.pixelsToShave} * ${scrollPercent})`);
        this.setDivStretchOffset(divStretchOffset);
    }
    setUiContainerHeight(height) {
        if (height !== this.uiContainerHeight) {
            this.uiContainerHeight = height;
            this.eventService.dispatchEvent({
                type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_CONTAINER_HEIGHT_CHANGED
            });
        }
    }
    clearOffset() {
        this.setUiContainerHeight(this.modelHeight);
        this.pixelsToShave = 0;
        this.setDivStretchOffset(0);
    }
    setDivStretchOffset(newOffset) {
        const newOffsetFloor = typeof newOffset === "number" ? Math.floor(newOffset) : null;
        if (this.divStretchOffset === newOffsetFloor) return;
        this.divStretchOffset = newOffsetFloor;
        this.eventService.dispatchEvent({
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_HEIGHT_SCALE_CHANGED
        });
    }
    setModelHeight(modelHeight) {
        this.modelHeight = modelHeight;
        this.stretching = modelHeight != null && this.maxDivHeight > 0 && modelHeight > this.maxDivHeight;
        if (this.stretching) this.calculateOffset();
        else this.clearOffset();
    }
    getUiContainerHeight() {
        return this.uiContainerHeight;
    }
    getRealPixelPosition(modelPixel) {
        return modelPixel - this.divStretchOffset;
    }
    getUiBodyHeight() {
        const gridBodyCon = this.ctrlsService.getGridBodyCtrl();
        const pos = gridBodyCon.getScrollFeature().getVScrollPosition();
        return pos.bottom - pos.top;
    }
    getScrollPositionForPixel(rowTop) {
        if (this.pixelsToShave <= 0) return rowTop;
        const modelMaxScroll = this.modelHeight - this.getUiBodyHeight();
        const scrollPercent = rowTop / modelMaxScroll;
        const scrollPixel = this.maxScrollY * scrollPercent;
        return scrollPixel;
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("ctrlsService")
], $437b23f6a393c3bf$var$RowContainerHeightService.prototype, "ctrlsService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$var$__decorateParam(0, $437b23f6a393c3bf$export$c3215dfb7fd4803b("loggerFactory"))
], $437b23f6a393c3bf$var$RowContainerHeightService.prototype, "agWire", 1);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$RowContainerHeightService.prototype, "postConstruct", 1);
$437b23f6a393c3bf$var$RowContainerHeightService = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("rowContainerHeightService")
], $437b23f6a393c3bf$var$RowContainerHeightService);
// community-modules/core/src/rowNodes/selectableService.ts
var $437b23f6a393c3bf$export$75ae26c229338c6b = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    init() {
        this.addManagedPropertyListener("isRowSelectable", ()=>this.updateSelectable());
    }
    /**
   * Used by CSRM only, to update selectable state after group state changes.
   */ updateSelectableAfterGrouping() {
        this.updateSelectable(true);
    }
    updateSelectable(skipLeafNodes = false) {
        const isRowSelecting = !!this.gos.get("rowSelection");
        const isRowSelectable = this.gos.get("isRowSelectable");
        if (!isRowSelecting || !isRowSelectable) return;
        const isGroupSelectsChildren = this.gos.get("groupSelectsChildren");
        const isCsrmGroupSelectsChildren = this.rowModel.getType() === "clientSide" && isGroupSelectsChildren;
        const nodesToDeselect = [];
        const nodeCallback = (node)=>{
            if (skipLeafNodes && !node.group) return;
            if (isCsrmGroupSelectsChildren && node.group) {
                const hasSelectableChild = node.childrenAfterGroup.some((rowNode)=>rowNode.selectable === true);
                node.setRowSelectable(hasSelectableChild, true);
                return;
            }
            const rowSelectable = isRowSelectable ? isRowSelectable(node) : true;
            node.setRowSelectable(rowSelectable, true);
            if (!rowSelectable && node.isSelected()) nodesToDeselect.push(node);
        };
        if (isCsrmGroupSelectsChildren) {
            const csrm = this.rowModel;
            const changedPath = new $437b23f6a393c3bf$export$cb4d9114a9732e85(false, csrm.getRootNode());
            changedPath.forEachChangedNodeDepthFirst(nodeCallback, true, true);
        } else this.rowModel.forEachNode(nodeCallback);
        if (nodesToDeselect.length) this.selectionService.setNodesSelected({
            nodes: nodesToDeselect,
            newValue: false,
            source: "selectableChanged"
        });
        if (isCsrmGroupSelectsChildren && this.selectionService instanceof $437b23f6a393c3bf$var$SelectionService) this.selectionService.updateGroupsFromChildrenSelections("selectableChanged");
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowModel")
], $437b23f6a393c3bf$export$75ae26c229338c6b.prototype, "rowModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("selectionService")
], $437b23f6a393c3bf$export$75ae26c229338c6b.prototype, "selectionService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$export$75ae26c229338c6b.prototype, "init", 1);
$437b23f6a393c3bf$export$75ae26c229338c6b = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("selectableService")
], $437b23f6a393c3bf$export$75ae26c229338c6b);
// community-modules/core/src/pagination/paginationComp.ts
var $437b23f6a393c3bf$var$PaginationComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super();
        this.previousAndFirstButtonsDisabled = false;
        this.nextButtonDisabled = false;
        this.lastButtonDisabled = false;
        this.areListenersSetup = false;
    }
    postConstruct() {
        const isRtl = this.gos.get("enableRtl");
        this.setTemplate(this.getTemplate());
        const { btFirst: btFirst, btPrevious: btPrevious, btNext: btNext, btLast: btLast, pageSizeComp: pageSizeComp } = this;
        this.activateTabIndex([
            btFirst,
            btPrevious,
            btNext,
            btLast
        ]);
        btFirst.insertAdjacentElement("afterbegin", $437b23f6a393c3bf$var$createIconNoSpan(isRtl ? "last" : "first", this.gos));
        btPrevious.insertAdjacentElement("afterbegin", $437b23f6a393c3bf$var$createIconNoSpan(isRtl ? "next" : "previous", this.gos));
        btNext.insertAdjacentElement("afterbegin", $437b23f6a393c3bf$var$createIconNoSpan(isRtl ? "previous" : "next", this.gos));
        btLast.insertAdjacentElement("afterbegin", $437b23f6a393c3bf$var$createIconNoSpan(isRtl ? "first" : "last", this.gos));
        this.addManagedPropertyListener("pagination", this.onPaginationChanged.bind(this));
        this.addManagedPropertyListener("suppressPaginationPanel", this.onPaginationChanged.bind(this));
        this.addManagedPropertyListeners([
            "paginationPageSizeSelector",
            "paginationAutoPageSize",
            "suppressPaginationPanel"
        ], ()=>this.onPageSizeRelatedOptionsChange());
        this.pageSizeComp.toggleSelectDisplay(this.pageSizeComp.shouldShowPageSizeSelector());
        this.onPaginationChanged();
    }
    onPaginationChanged() {
        const isPaging = this.gos.get("pagination");
        const paginationPanelEnabled = isPaging && !this.gos.get("suppressPaginationPanel");
        this.setDisplayed(paginationPanelEnabled);
        if (!paginationPanelEnabled) return;
        this.setupListeners();
        this.enableOrDisableButtons();
        this.updateRowLabels();
        this.setCurrentPageLabel();
        this.setTotalLabels();
        this.onPageSizeRelatedOptionsChange();
    }
    onPageSizeRelatedOptionsChange() {
        this.pageSizeComp.toggleSelectDisplay(this.pageSizeComp.shouldShowPageSizeSelector());
    }
    setupListeners() {
        if (!this.areListenersSetup) {
            this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_PAGINATION_CHANGED, this.onPaginationChanged.bind(this));
            [
                {
                    el: this.btFirst,
                    fn: this.onBtFirst.bind(this)
                },
                {
                    el: this.btPrevious,
                    fn: this.onBtPrevious.bind(this)
                },
                {
                    el: this.btNext,
                    fn: this.onBtNext.bind(this)
                },
                {
                    el: this.btLast,
                    fn: this.onBtLast.bind(this)
                }
            ].forEach((item)=>{
                const { el: el, fn: fn } = item;
                this.addManagedListener(el, "click", fn);
                this.addManagedListener(el, "keydown", (e)=>{
                    if (e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.ENTER || e.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.SPACE) {
                        e.preventDefault();
                        fn();
                    }
                });
            });
            this.areListenersSetup = true;
        }
    }
    onBtFirst() {
        if (!this.previousAndFirstButtonsDisabled) this.paginationProxy.goToFirstPage();
    }
    setCurrentPageLabel() {
        const pagesExist = this.paginationProxy.getTotalPages() > 0;
        const currentPage = this.paginationProxy.getCurrentPage();
        const toDisplay = pagesExist ? currentPage + 1 : 0;
        this.lbCurrent.textContent = this.formatNumber(toDisplay);
    }
    formatNumber(value) {
        const userFunc = this.gos.getCallback("paginationNumberFormatter");
        if (userFunc) {
            const params = {
                value: value
            };
            return userFunc(params);
        }
        const localeTextFunc = this.localeService.getLocaleTextFunc();
        const thousandSeparator = localeTextFunc("thousandSeparator", ",");
        const decimalSeparator = localeTextFunc("decimalSeparator", ".");
        return $437b23f6a393c3bf$var$formatNumberCommas(value, thousandSeparator, decimalSeparator);
    }
    getTemplate() {
        const localeTextFunc = this.localeService.getLocaleTextFunc();
        const strPage = localeTextFunc("page", "Page");
        const strTo = localeTextFunc("to", "to");
        const strOf = localeTextFunc("of", "of");
        const strFirst = localeTextFunc("firstPage", "First Page");
        const strPrevious = localeTextFunc("previousPage", "Previous Page");
        const strNext = localeTextFunc("nextPage", "Next Page");
        const strLast = localeTextFunc("lastPage", "Last Page");
        const compId = this.getCompId();
        return /* html */ `<div class="ag-paging-panel ag-unselectable" id="ag-${compId}">
                <ag-page-size-selector ref="pageSizeComp"></ag-page-size-selector>
                <span class="ag-paging-row-summary-panel" role="status">
                    <span id="ag-${compId}-first-row" ref="lbFirstRowOnPage" class="ag-paging-row-summary-panel-number"></span>
                    <span id="ag-${compId}-to">${strTo}</span>
                    <span id="ag-${compId}-last-row" ref="lbLastRowOnPage" class="ag-paging-row-summary-panel-number"></span>
                    <span id="ag-${compId}-of">${strOf}</span>
                    <span id="ag-${compId}-row-count" ref="lbRecordCount" class="ag-paging-row-summary-panel-number"></span>
                </span>
                <span class="ag-paging-page-summary-panel" role="presentation">
                    <div ref="btFirst" class="ag-button ag-paging-button" role="button" aria-label="${strFirst}"></div>
                    <div ref="btPrevious" class="ag-button ag-paging-button" role="button" aria-label="${strPrevious}"></div>
                    <span class="ag-paging-description" role="status">
                        <span id="ag-${compId}-start-page">${strPage}</span>
                        <span id="ag-${compId}-start-page-number" ref="lbCurrent" class="ag-paging-number"></span>
                        <span id="ag-${compId}-of-page">${strOf}</span>
                        <span id="ag-${compId}-of-page-number" ref="lbTotal" class="ag-paging-number"></span>
                    </span>
                    <div ref="btNext" class="ag-button ag-paging-button" role="button" aria-label="${strNext}"></div>
                    <div ref="btLast" class="ag-button ag-paging-button" role="button" aria-label="${strLast}"></div>
                </span>
            </div>`;
    }
    onBtNext() {
        if (!this.nextButtonDisabled) this.paginationProxy.goToNextPage();
    }
    onBtPrevious() {
        if (!this.previousAndFirstButtonsDisabled) this.paginationProxy.goToPreviousPage();
    }
    onBtLast() {
        if (!this.lastButtonDisabled) this.paginationProxy.goToLastPage();
    }
    enableOrDisableButtons() {
        const currentPage = this.paginationProxy.getCurrentPage();
        const maxRowFound = this.paginationProxy.isLastPageFound();
        const totalPages = this.paginationProxy.getTotalPages();
        this.previousAndFirstButtonsDisabled = currentPage === 0;
        this.toggleButtonDisabled(this.btFirst, this.previousAndFirstButtonsDisabled);
        this.toggleButtonDisabled(this.btPrevious, this.previousAndFirstButtonsDisabled);
        const zeroPagesToDisplay = this.isZeroPagesToDisplay();
        const onLastPage = currentPage === totalPages - 1;
        this.nextButtonDisabled = onLastPage || zeroPagesToDisplay;
        this.lastButtonDisabled = !maxRowFound || zeroPagesToDisplay || currentPage === totalPages - 1;
        this.toggleButtonDisabled(this.btNext, this.nextButtonDisabled);
        this.toggleButtonDisabled(this.btLast, this.lastButtonDisabled);
    }
    toggleButtonDisabled(button, disabled) {
        $437b23f6a393c3bf$var$setAriaDisabled(button, disabled);
        button.classList.toggle("ag-disabled", disabled);
    }
    updateRowLabels() {
        const currentPage = this.paginationProxy.getCurrentPage();
        const pageSize = this.paginationProxy.getPageSize();
        const maxRowFound = this.paginationProxy.isLastPageFound();
        const rowCount = this.paginationProxy.isLastPageFound() ? this.paginationProxy.getMasterRowCount() : null;
        let startRow;
        let endRow;
        if (this.isZeroPagesToDisplay()) startRow = endRow = 0;
        else {
            startRow = pageSize * currentPage + 1;
            endRow = startRow + pageSize - 1;
            if (maxRowFound && endRow > rowCount) endRow = rowCount;
        }
        this.lbFirstRowOnPage.textContent = this.formatNumber(startRow);
        if (this.rowNodeBlockLoader.isLoading()) {
            const translate = this.localeService.getLocaleTextFunc();
            this.lbLastRowOnPage.innerHTML = translate("pageLastRowUnknown", "?");
        } else this.lbLastRowOnPage.textContent = this.formatNumber(endRow);
    }
    isZeroPagesToDisplay() {
        const maxRowFound = this.paginationProxy.isLastPageFound();
        const totalPages = this.paginationProxy.getTotalPages();
        return maxRowFound && totalPages === 0;
    }
    setTotalLabels() {
        const lastPageFound = this.paginationProxy.isLastPageFound();
        const totalPages = this.paginationProxy.getTotalPages();
        const rowCount = lastPageFound ? this.paginationProxy.getMasterRowCount() : null;
        if (rowCount === 1) {
            const firstRow = this.paginationProxy.getRow(0);
            const hiddenGroupRow = firstRow && firstRow.group && !(firstRow.groupData || firstRow.aggData);
            if (hiddenGroupRow) {
                this.setTotalLabelsToZero();
                return;
            }
        }
        if (lastPageFound) {
            this.lbTotal.textContent = this.formatNumber(totalPages);
            this.lbRecordCount.textContent = this.formatNumber(rowCount);
        } else {
            const moreText = this.localeService.getLocaleTextFunc()("more", "more");
            this.lbTotal.innerHTML = moreText;
            this.lbRecordCount.innerHTML = moreText;
        }
    }
    setTotalLabelsToZero() {
        this.lbFirstRowOnPage.textContent = this.formatNumber(0);
        this.lbCurrent.textContent = this.formatNumber(0);
        this.lbLastRowOnPage.textContent = this.formatNumber(0);
        this.lbTotal.textContent = this.formatNumber(0);
        this.lbRecordCount.textContent = this.formatNumber(0);
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("paginationProxy")
], $437b23f6a393c3bf$var$PaginationComp.prototype, "paginationProxy", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowNodeBlockLoader")
], $437b23f6a393c3bf$var$PaginationComp.prototype, "rowNodeBlockLoader", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("btFirst")
], $437b23f6a393c3bf$var$PaginationComp.prototype, "btFirst", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("btPrevious")
], $437b23f6a393c3bf$var$PaginationComp.prototype, "btPrevious", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("btNext")
], $437b23f6a393c3bf$var$PaginationComp.prototype, "btNext", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("btLast")
], $437b23f6a393c3bf$var$PaginationComp.prototype, "btLast", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("lbRecordCount")
], $437b23f6a393c3bf$var$PaginationComp.prototype, "lbRecordCount", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("lbFirstRowOnPage")
], $437b23f6a393c3bf$var$PaginationComp.prototype, "lbFirstRowOnPage", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("lbLastRowOnPage")
], $437b23f6a393c3bf$var$PaginationComp.prototype, "lbLastRowOnPage", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("lbCurrent")
], $437b23f6a393c3bf$var$PaginationComp.prototype, "lbCurrent", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("lbTotal")
], $437b23f6a393c3bf$var$PaginationComp.prototype, "lbTotal", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("pageSizeComp")
], $437b23f6a393c3bf$var$PaginationComp.prototype, "pageSizeComp", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$PaginationComp.prototype, "postConstruct", 1);
// community-modules/core/src/rendering/overlays/overlayWrapperComponent.ts
var $437b23f6a393c3bf$var$_OverlayWrapperComponent = class _OverlayWrapperComponent extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super(_OverlayWrapperComponent.TEMPLATE);
        this.inProgress = false;
        this.destroyRequested = false;
    }
    updateLayoutClasses(cssClass, params) {
        const overlayWrapperClassList = this.eOverlayWrapper.classList;
        overlayWrapperClassList.toggle("ag-layout-auto-height" /* AUTO_HEIGHT */ , params.autoHeight);
        overlayWrapperClassList.toggle("ag-layout-normal" /* NORMAL */ , params.normal);
        overlayWrapperClassList.toggle("ag-layout-print" /* PRINT */ , params.print);
    }
    postConstruct() {
        this.createManagedBean(new $437b23f6a393c3bf$var$LayoutFeature(this));
        this.setDisplayed(false, {
            skipAriaHidden: true
        });
        this.overlayService.registerOverlayWrapperComp(this);
    }
    setWrapperTypeClass(overlayWrapperCssClass) {
        const overlayWrapperClassList = this.eOverlayWrapper.classList;
        if (this.activeOverlayWrapperCssClass) overlayWrapperClassList.toggle(this.activeOverlayWrapperCssClass, false);
        this.activeOverlayWrapperCssClass = overlayWrapperCssClass;
        overlayWrapperClassList.toggle(overlayWrapperCssClass, true);
    }
    showOverlay(overlayComp, overlayWrapperCssClass, updateListenerDestroyFunc) {
        if (this.inProgress) return;
        this.setWrapperTypeClass(overlayWrapperCssClass);
        this.destroyActiveOverlay();
        this.inProgress = true;
        if (overlayComp) overlayComp.then((comp)=>{
            this.inProgress = false;
            this.eOverlayWrapper.appendChild(comp.getGui());
            this.activeOverlay = comp;
            this.updateListenerDestroyFunc = updateListenerDestroyFunc;
            if (this.destroyRequested) {
                this.destroyRequested = false;
                this.destroyActiveOverlay();
            }
        });
        this.setDisplayed(true, {
            skipAriaHidden: true
        });
    }
    destroyActiveOverlay() {
        var _a;
        if (this.inProgress) {
            this.destroyRequested = true;
            return;
        }
        if (!this.activeOverlay) return;
        this.activeOverlay = this.getContext().destroyBean(this.activeOverlay);
        (_a = this.updateListenerDestroyFunc) == null || _a.call(this);
        $437b23f6a393c3bf$var$clearElement(this.eOverlayWrapper);
    }
    hideOverlay() {
        this.destroyActiveOverlay();
        this.setDisplayed(false, {
            skipAriaHidden: true
        });
    }
    destroy() {
        this.destroyActiveOverlay();
        super.destroy();
    }
};
// wrapping in outer div, and wrapper, is needed to center the loading icon
$437b23f6a393c3bf$var$_OverlayWrapperComponent.TEMPLATE = /* html */ `
        <div class="ag-overlay" role="presentation">
            <div class="ag-overlay-panel" role="presentation">
                <div class="ag-overlay-wrapper" ref="eOverlayWrapper" role="presentation"></div>
            </div>
        </div>`;
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("overlayService")
], $437b23f6a393c3bf$var$_OverlayWrapperComponent.prototype, "overlayService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eOverlayWrapper")
], $437b23f6a393c3bf$var$_OverlayWrapperComponent.prototype, "eOverlayWrapper", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$_OverlayWrapperComponent.prototype, "postConstruct", 1);
var $437b23f6a393c3bf$var$OverlayWrapperComponent = $437b23f6a393c3bf$var$_OverlayWrapperComponent;
// community-modules/core/src/entities/rowPositionUtils.ts
var $437b23f6a393c3bf$export$27e6ff2feb462d0f = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    getFirstRow() {
        let rowIndex = 0;
        let rowPinned;
        if (this.pinnedRowModel.getPinnedTopRowCount()) rowPinned = "top";
        else if (this.rowModel.getRowCount()) {
            rowPinned = null;
            rowIndex = this.paginationProxy.getPageFirstRow();
        } else if (this.pinnedRowModel.getPinnedBottomRowCount()) rowPinned = "bottom";
        return rowPinned === void 0 ? null : {
            rowIndex: rowIndex,
            rowPinned: rowPinned
        };
    }
    getLastRow() {
        let rowIndex;
        let rowPinned = null;
        const pinnedBottomCount = this.pinnedRowModel.getPinnedBottomRowCount();
        const pinnedTopCount = this.pinnedRowModel.getPinnedTopRowCount();
        if (pinnedBottomCount) {
            rowPinned = "bottom";
            rowIndex = pinnedBottomCount - 1;
        } else if (this.rowModel.getRowCount()) {
            rowPinned = null;
            rowIndex = this.paginationProxy.getPageLastRow();
        } else if (pinnedTopCount) {
            rowPinned = "top";
            rowIndex = pinnedTopCount - 1;
        }
        return rowIndex === void 0 ? null : {
            rowIndex: rowIndex,
            rowPinned: rowPinned
        };
    }
    getRowNode(gridRow) {
        switch(gridRow.rowPinned){
            case "top":
                return this.pinnedRowModel.getPinnedTopRowData()[gridRow.rowIndex];
            case "bottom":
                return this.pinnedRowModel.getPinnedBottomRowData()[gridRow.rowIndex];
            default:
                return this.rowModel.getRow(gridRow.rowIndex);
        }
    }
    sameRow(rowA, rowB) {
        if (!rowA && !rowB) return true;
        if (rowA && !rowB || !rowA && rowB) return false;
        return rowA.rowIndex === rowB.rowIndex && rowA.rowPinned == rowB.rowPinned;
    }
    // tests if this row selection is before the other row selection
    before(rowA, rowB) {
        switch(rowA.rowPinned){
            case "top":
                if (rowB.rowPinned !== "top") return true;
                break;
            case "bottom":
                if (rowB.rowPinned !== "bottom") return false;
                break;
            default:
                if ($437b23f6a393c3bf$var$exists(rowB.rowPinned)) return rowB.rowPinned !== "top";
                break;
        }
        return rowA.rowIndex < rowB.rowIndex;
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowModel")
], $437b23f6a393c3bf$export$27e6ff2feb462d0f.prototype, "rowModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("pinnedRowModel")
], $437b23f6a393c3bf$export$27e6ff2feb462d0f.prototype, "pinnedRowModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("paginationProxy")
], $437b23f6a393c3bf$export$27e6ff2feb462d0f.prototype, "paginationProxy", 2);
$437b23f6a393c3bf$export$27e6ff2feb462d0f = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("rowPositionUtils")
], $437b23f6a393c3bf$export$27e6ff2feb462d0f);
// community-modules/core/src/entities/cellPositionUtils.ts
var $437b23f6a393c3bf$export$d4b97c43369f9635 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    createId(cellPosition) {
        const { rowIndex: rowIndex, rowPinned: rowPinned, column: column } = cellPosition;
        return this.createIdFromValues({
            rowIndex: rowIndex,
            column: column,
            rowPinned: rowPinned
        });
    }
    createIdFromValues(cellPosition) {
        const { rowIndex: rowIndex, rowPinned: rowPinned, column: column } = cellPosition;
        return `${rowIndex}.${rowPinned == null ? "null" : rowPinned}.${column.getId()}`;
    }
    equals(cellA, cellB) {
        const colsMatch = cellA.column === cellB.column;
        const floatingMatch = cellA.rowPinned === cellB.rowPinned;
        const indexMatch = cellA.rowIndex === cellB.rowIndex;
        return colsMatch && floatingMatch && indexMatch;
    }
};
$437b23f6a393c3bf$export$d4b97c43369f9635 = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("cellPositionUtils")
], $437b23f6a393c3bf$export$d4b97c43369f9635);
// community-modules/core/src/undoRedo/undoRedoStack.ts
var $437b23f6a393c3bf$var$UndoRedoAction = class {
    constructor(cellValueChanges){
        this.cellValueChanges = cellValueChanges;
    }
};
var $437b23f6a393c3bf$var$RangeUndoRedoAction = class extends $437b23f6a393c3bf$var$UndoRedoAction {
    constructor(cellValueChanges, initialRange, finalRange, ranges){
        super(cellValueChanges);
        this.initialRange = initialRange;
        this.finalRange = finalRange;
        this.ranges = ranges;
    }
};
var $437b23f6a393c3bf$var$_UndoRedoStack = class _UndoRedoStack {
    constructor(maxStackSize){
        this.actionStack = [];
        this.maxStackSize = maxStackSize ? maxStackSize : _UndoRedoStack.DEFAULT_STACK_SIZE;
        this.actionStack = new Array(this.maxStackSize);
    }
    pop() {
        return this.actionStack.pop();
    }
    push(item) {
        const shouldAddActions = item.cellValueChanges && item.cellValueChanges.length > 0;
        if (!shouldAddActions) return;
        if (this.actionStack.length === this.maxStackSize) this.actionStack.shift();
        this.actionStack.push(item);
    }
    clear() {
        this.actionStack = [];
    }
    getCurrentStackSize() {
        return this.actionStack.length;
    }
};
$437b23f6a393c3bf$var$_UndoRedoStack.DEFAULT_STACK_SIZE = 10;
var $437b23f6a393c3bf$var$UndoRedoStack = $437b23f6a393c3bf$var$_UndoRedoStack;
// community-modules/core/src/undoRedo/undoRedoService.ts
var $437b23f6a393c3bf$var$UndoRedoService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.cellValueChanges = [];
        this.activeCellEdit = null;
        this.activeRowEdit = null;
        this.isPasting = false;
        this.isRangeInAction = false;
        this.onCellValueChanged = (event)=>{
            const eventCell = {
                column: event.column,
                rowIndex: event.rowIndex,
                rowPinned: event.rowPinned
            };
            const isCellEditing = this.activeCellEdit !== null && this.cellPositionUtils.equals(this.activeCellEdit, eventCell);
            const isRowEditing = this.activeRowEdit !== null && this.rowPositionUtils.sameRow(this.activeRowEdit, eventCell);
            const shouldCaptureAction = isCellEditing || isRowEditing || this.isPasting || this.isRangeInAction;
            if (!shouldCaptureAction) return;
            const { rowPinned: rowPinned, rowIndex: rowIndex, column: column, oldValue: oldValue, value: value } = event;
            const cellValueChange = {
                rowPinned: rowPinned,
                rowIndex: rowIndex,
                columnId: column.getColId(),
                newValue: value,
                oldValue: oldValue
            };
            this.cellValueChanges.push(cellValueChange);
        };
        this.clearStacks = ()=>{
            this.undoStack.clear();
            this.redoStack.clear();
        };
    }
    init() {
        if (!this.gos.get("undoRedoCellEditing")) return;
        const undoRedoLimit = this.gos.get("undoRedoCellEditingLimit");
        if (undoRedoLimit <= 0) return;
        this.undoStack = new $437b23f6a393c3bf$var$UndoRedoStack(undoRedoLimit);
        this.redoStack = new $437b23f6a393c3bf$var$UndoRedoStack(undoRedoLimit);
        this.addRowEditingListeners();
        this.addCellEditingListeners();
        this.addPasteListeners();
        this.addFillListeners();
        this.addCellKeyListeners();
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_CELL_VALUE_CHANGED, this.onCellValueChanged);
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_MODEL_UPDATED, (e)=>{
            if (!e.keepUndoRedoStack) this.clearStacks();
        });
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_PIVOT_MODE_CHANGED, this.clearStacks);
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_NEW_COLUMNS_LOADED, this.clearStacks);
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_GROUP_OPENED, this.clearStacks);
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_ROW_GROUP_CHANGED, this.clearStacks);
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_MOVED, this.clearStacks);
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_PINNED, this.clearStacks);
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_VISIBLE, this.clearStacks);
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_DRAG_END, this.clearStacks);
        this.ctrlsService.whenReady((p)=>{
            this.gridBodyCtrl = p.gridBodyCtrl;
        });
    }
    getCurrentUndoStackSize() {
        return this.undoStack ? this.undoStack.getCurrentStackSize() : 0;
    }
    getCurrentRedoStackSize() {
        return this.redoStack ? this.redoStack.getCurrentStackSize() : 0;
    }
    undo(source) {
        const startEvent = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_UNDO_STARTED,
            source: source
        };
        this.eventService.dispatchEvent(startEvent);
        const operationPerformed = this.undoRedo(this.undoStack, this.redoStack, "initialRange", "oldValue", "undo");
        const endEvent = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_UNDO_ENDED,
            source: source,
            operationPerformed: operationPerformed
        };
        this.eventService.dispatchEvent(endEvent);
    }
    redo(source) {
        const startEvent = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_REDO_STARTED,
            source: source
        };
        this.eventService.dispatchEvent(startEvent);
        const operationPerformed = this.undoRedo(this.redoStack, this.undoStack, "finalRange", "newValue", "redo");
        const endEvent = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_REDO_ENDED,
            source: source,
            operationPerformed: operationPerformed
        };
        this.eventService.dispatchEvent(endEvent);
    }
    undoRedo(undoRedoStack, opposingUndoRedoStack, rangeProperty, cellValueChangeProperty, source) {
        if (!undoRedoStack) return false;
        const undoRedoAction = undoRedoStack.pop();
        if (!undoRedoAction || !undoRedoAction.cellValueChanges) return false;
        this.processAction(undoRedoAction, (cellValueChange)=>cellValueChange[cellValueChangeProperty], source);
        if (undoRedoAction instanceof $437b23f6a393c3bf$var$RangeUndoRedoAction) this.processRange(this.rangeService, undoRedoAction.ranges || [
            undoRedoAction[rangeProperty]
        ]);
        else this.processCell(undoRedoAction.cellValueChanges);
        opposingUndoRedoStack.push(undoRedoAction);
        return true;
    }
    processAction(action, valueExtractor, source) {
        action.cellValueChanges.forEach((cellValueChange)=>{
            const { rowIndex: rowIndex, rowPinned: rowPinned, columnId: columnId } = cellValueChange;
            const rowPosition = {
                rowIndex: rowIndex,
                rowPinned: rowPinned
            };
            const currentRow = this.rowPositionUtils.getRowNode(rowPosition);
            if (!currentRow.displayed) return;
            currentRow.setDataValue(columnId, valueExtractor(cellValueChange), source);
        });
    }
    processRange(rangeService, ranges) {
        let lastFocusedCell;
        rangeService.removeAllCellRanges(true);
        ranges.forEach((range, idx)=>{
            if (!range) return;
            const startRow = range.startRow;
            const endRow = range.endRow;
            if (idx === ranges.length - 1) {
                lastFocusedCell = {
                    rowPinned: startRow.rowPinned,
                    rowIndex: startRow.rowIndex,
                    columnId: range.startColumn.getColId()
                };
                this.setLastFocusedCell(lastFocusedCell);
            }
            const cellRangeParams = {
                rowStartIndex: startRow.rowIndex,
                rowStartPinned: startRow.rowPinned,
                rowEndIndex: endRow.rowIndex,
                rowEndPinned: endRow.rowPinned,
                columnStart: range.startColumn,
                columns: range.columns
            };
            rangeService.addCellRange(cellRangeParams);
        });
    }
    processCell(cellValueChanges) {
        const cellValueChange = cellValueChanges[0];
        const { rowIndex: rowIndex, rowPinned: rowPinned } = cellValueChange;
        const rowPosition = {
            rowIndex: rowIndex,
            rowPinned: rowPinned
        };
        const row = this.rowPositionUtils.getRowNode(rowPosition);
        const lastFocusedCell = {
            rowPinned: cellValueChange.rowPinned,
            rowIndex: row.rowIndex,
            columnId: cellValueChange.columnId
        };
        this.setLastFocusedCell(lastFocusedCell, this.rangeService);
    }
    setLastFocusedCell(lastFocusedCell, rangeService) {
        const { rowIndex: rowIndex, columnId: columnId, rowPinned: rowPinned } = lastFocusedCell;
        const scrollFeature = this.gridBodyCtrl.getScrollFeature();
        const column = this.columnModel.getGridColumn(columnId);
        if (!column) return;
        scrollFeature.ensureIndexVisible(rowIndex);
        scrollFeature.ensureColumnVisible(column);
        const cellPosition = {
            rowIndex: rowIndex,
            column: column,
            rowPinned: rowPinned
        };
        this.focusService.setFocusedCell($437b23f6a393c3bf$var$__spreadProps($437b23f6a393c3bf$var$__spreadValues({}, cellPosition), {
            forceBrowserFocus: true
        }));
        rangeService == null || rangeService.setRangeToCell(cellPosition);
    }
    addRowEditingListeners() {
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_EDITING_STARTED, (e)=>{
            this.activeRowEdit = {
                rowIndex: e.rowIndex,
                rowPinned: e.rowPinned
            };
        });
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_EDITING_STOPPED, ()=>{
            const action = new $437b23f6a393c3bf$var$UndoRedoAction(this.cellValueChanges);
            this.pushActionsToUndoStack(action);
            this.activeRowEdit = null;
        });
    }
    addCellEditingListeners() {
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_CELL_EDITING_STARTED, (e)=>{
            this.activeCellEdit = {
                column: e.column,
                rowIndex: e.rowIndex,
                rowPinned: e.rowPinned
            };
        });
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_CELL_EDITING_STOPPED, (e)=>{
            this.activeCellEdit = null;
            const shouldPushAction = e.valueChanged && !this.activeRowEdit && !this.isPasting && !this.isRangeInAction;
            if (shouldPushAction) {
                const action = new $437b23f6a393c3bf$var$UndoRedoAction(this.cellValueChanges);
                this.pushActionsToUndoStack(action);
            }
        });
    }
    addPasteListeners() {
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_PASTE_START, ()=>{
            this.isPasting = true;
        });
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_PASTE_END, ()=>{
            const action = new $437b23f6a393c3bf$var$UndoRedoAction(this.cellValueChanges);
            this.pushActionsToUndoStack(action);
            this.isPasting = false;
        });
    }
    addFillListeners() {
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_FILL_START, ()=>{
            this.isRangeInAction = true;
        });
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_FILL_END, (event)=>{
            const action = new $437b23f6a393c3bf$var$RangeUndoRedoAction(this.cellValueChanges, event.initialRange, event.finalRange);
            this.pushActionsToUndoStack(action);
            this.isRangeInAction = false;
        });
    }
    addCellKeyListeners() {
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_KEY_SHORTCUT_CHANGED_CELL_START, ()=>{
            this.isRangeInAction = true;
        });
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_KEY_SHORTCUT_CHANGED_CELL_END, ()=>{
            let action;
            if (this.rangeService && this.gos.get("enableRangeSelection")) action = new $437b23f6a393c3bf$var$RangeUndoRedoAction(this.cellValueChanges, void 0, void 0, [
                ...this.rangeService.getCellRanges()
            ]);
            else action = new $437b23f6a393c3bf$var$UndoRedoAction(this.cellValueChanges);
            this.pushActionsToUndoStack(action);
            this.isRangeInAction = false;
        });
    }
    pushActionsToUndoStack(action) {
        this.undoStack.push(action);
        this.cellValueChanges = [];
        this.redoStack.clear();
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("focusService")
], $437b23f6a393c3bf$var$UndoRedoService.prototype, "focusService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("ctrlsService")
], $437b23f6a393c3bf$var$UndoRedoService.prototype, "ctrlsService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("cellPositionUtils")
], $437b23f6a393c3bf$var$UndoRedoService.prototype, "cellPositionUtils", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowPositionUtils")
], $437b23f6a393c3bf$var$UndoRedoService.prototype, "rowPositionUtils", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnModel")
], $437b23f6a393c3bf$var$UndoRedoService.prototype, "columnModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$7acb7b24c478f9c6("rangeService")
], $437b23f6a393c3bf$var$UndoRedoService.prototype, "rangeService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$UndoRedoService.prototype, "init", 1);
$437b23f6a393c3bf$var$UndoRedoService = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("undoRedoService")
], $437b23f6a393c3bf$var$UndoRedoService);
// community-modules/core/src/headerRendering/common/headerPosition.ts
var $437b23f6a393c3bf$export$4dfb519ecc588412 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    findHeader(focusedHeader, direction) {
        let nextColumn;
        let getColMethod;
        if (focusedHeader.column instanceof $437b23f6a393c3bf$export$8a8fbc71323f074) nextColumn = this.columnModel.getDisplayedGroupAtDirection(focusedHeader.column, direction);
        else {
            getColMethod = `getDisplayedCol${direction}`;
            nextColumn = this.columnModel[getColMethod](focusedHeader.column);
        }
        if (!nextColumn) return;
        let { headerRowIndex: headerRowIndex } = focusedHeader;
        if (this.getHeaderRowType(headerRowIndex) !== "filter" /* FLOATING_FILTER */ ) {
            const columnsInPath = [
                nextColumn
            ];
            while(nextColumn.getParent()){
                nextColumn = nextColumn.getParent();
                columnsInPath.push(nextColumn);
            }
            nextColumn = columnsInPath[columnsInPath.length - 1 - headerRowIndex];
        }
        const { column: column, headerRowIndex: indexToFocus } = this.getHeaderIndexToFocus(nextColumn, headerRowIndex);
        return {
            column: column,
            headerRowIndex: indexToFocus
        };
    }
    getHeaderIndexToFocus(column, currentIndex) {
        let nextColumn;
        if (column instanceof $437b23f6a393c3bf$export$8a8fbc71323f074 && this.isAnyChildSpanningHeaderHeight(column) && column.isPadding()) {
            const targetColumn = column;
            nextColumn = targetColumn.getLeafColumns()[0];
            let col = nextColumn;
            while(col !== targetColumn){
                currentIndex++;
                col = col.getParent();
            }
        }
        return {
            column: nextColumn || column,
            headerRowIndex: currentIndex
        };
    }
    isAnyChildSpanningHeaderHeight(columnGroup) {
        if (!columnGroup) return false;
        return columnGroup.getLeafColumns().some((col)=>col.isSpanHeaderHeight());
    }
    getColumnVisibleParent(currentColumn, currentIndex) {
        const currentRowType = this.getHeaderRowType(currentIndex);
        const isFloatingFilter = currentRowType === "filter" /* FLOATING_FILTER */ ;
        const isColumn = currentRowType === "column" /* COLUMN */ ;
        let nextFocusColumn = isFloatingFilter ? currentColumn : currentColumn.getParent();
        let nextRow = currentIndex - 1;
        let headerRowIndexWithoutSpan = nextRow;
        if (isColumn && this.isAnyChildSpanningHeaderHeight(currentColumn.getParent())) {
            while(nextFocusColumn && nextFocusColumn.isPadding()){
                nextFocusColumn = nextFocusColumn.getParent();
                nextRow--;
            }
            headerRowIndexWithoutSpan = nextRow;
            if (nextRow < 0) {
                nextFocusColumn = currentColumn;
                nextRow = currentIndex;
                headerRowIndexWithoutSpan = void 0;
            }
        }
        return {
            column: nextFocusColumn,
            headerRowIndex: nextRow,
            headerRowIndexWithoutSpan: headerRowIndexWithoutSpan
        };
    }
    getColumnVisibleChild(column, currentIndex, direction = "After") {
        const currentRowType = this.getHeaderRowType(currentIndex);
        let nextFocusColumn = column;
        let nextRow = currentIndex + 1;
        let headerRowIndexWithoutSpan = nextRow;
        if (currentRowType === "group" /* COLUMN_GROUP */ ) {
            const leafColumns = column.getDisplayedLeafColumns();
            const leafColumn = direction === "After" ? leafColumns[0] : $437b23f6a393c3bf$var$last(leafColumns);
            const columnsInTheWay = [];
            let currentColumn = leafColumn;
            while(currentColumn.getParent() !== column){
                currentColumn = currentColumn.getParent();
                columnsInTheWay.push(currentColumn);
            }
            nextFocusColumn = leafColumn;
            if (leafColumn.isSpanHeaderHeight()) for(let i = columnsInTheWay.length - 1; i >= 0; i--){
                const colToFocus = columnsInTheWay[i];
                if (!colToFocus.isPadding()) {
                    nextFocusColumn = colToFocus;
                    break;
                }
                nextRow++;
            }
            else {
                nextFocusColumn = $437b23f6a393c3bf$var$last(columnsInTheWay);
                if (!nextFocusColumn) nextFocusColumn = leafColumn;
            }
        }
        return {
            column: nextFocusColumn,
            headerRowIndex: nextRow,
            headerRowIndexWithoutSpan: headerRowIndexWithoutSpan
        };
    }
    getHeaderRowType(rowIndex) {
        const centerHeaderContainer = this.ctrlsService.getHeaderRowContainerCtrl();
        if (centerHeaderContainer) return centerHeaderContainer.getRowType(rowIndex);
    }
    findColAtEdgeForHeaderRow(level, position) {
        const displayedColumns = this.columnModel.getAllDisplayedColumns();
        const column = displayedColumns[position === "start" ? 0 : displayedColumns.length - 1];
        if (!column) return;
        const childContainer = this.ctrlsService.getHeaderRowContainerCtrl(column.getPinned());
        const type = childContainer.getRowType(level);
        if (type == "group" /* COLUMN_GROUP */ ) {
            const columnGroup = this.columnModel.getColumnGroupAtLevel(column, level);
            return {
                headerRowIndex: level,
                column: columnGroup
            };
        }
        return {
            // if type==null, means the header level didn't exist
            headerRowIndex: type == null ? -1 : level,
            column: column
        };
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnModel")
], $437b23f6a393c3bf$export$4dfb519ecc588412.prototype, "columnModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("ctrlsService")
], $437b23f6a393c3bf$export$4dfb519ecc588412.prototype, "ctrlsService", 2);
$437b23f6a393c3bf$export$4dfb519ecc588412 = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("headerPositionUtils")
], $437b23f6a393c3bf$export$4dfb519ecc588412);
// community-modules/core/src/columns/columnDefFactory.ts
var $437b23f6a393c3bf$var$ColumnDefFactory = class {
    buildColumnDefs(cols, rowGroupColumns, pivotColumns) {
        const res = [];
        const colGroupDefs = {};
        cols.forEach((col)=>{
            const colDef = this.createDefFromColumn(col, rowGroupColumns, pivotColumns);
            let addToResult = true;
            let childDef = colDef;
            let pointer = col.getOriginalParent();
            let lastPointer = null;
            while(pointer){
                let parentDef = null;
                if (pointer.isPadding()) {
                    pointer = pointer.getOriginalParent();
                    continue;
                }
                const existingParentDef = colGroupDefs[pointer.getGroupId()];
                if (existingParentDef) {
                    existingParentDef.children.push(childDef);
                    addToResult = false;
                    break;
                }
                parentDef = this.createDefFromGroup(pointer);
                if (parentDef) {
                    parentDef.children = [
                        childDef
                    ];
                    colGroupDefs[parentDef.groupId] = parentDef;
                    childDef = parentDef;
                    pointer = pointer.getOriginalParent();
                }
                if (pointer != null && lastPointer === pointer) {
                    addToResult = false;
                    break;
                }
                lastPointer = pointer;
            }
            if (addToResult) res.push(childDef);
        });
        return res;
    }
    createDefFromGroup(group) {
        const defCloned = $437b23f6a393c3bf$var$deepCloneDefinition(group.getColGroupDef(), [
            "children"
        ]);
        if (defCloned) defCloned.groupId = group.getGroupId();
        return defCloned;
    }
    createDefFromColumn(col, rowGroupColumns, pivotColumns) {
        const colDefCloned = $437b23f6a393c3bf$var$deepCloneDefinition(col.getColDef());
        colDefCloned.colId = col.getColId();
        colDefCloned.width = col.getActualWidth();
        colDefCloned.rowGroup = col.isRowGroupActive();
        colDefCloned.rowGroupIndex = col.isRowGroupActive() ? rowGroupColumns.indexOf(col) : null;
        colDefCloned.pivot = col.isPivotActive();
        colDefCloned.pivotIndex = col.isPivotActive() ? pivotColumns.indexOf(col) : null;
        colDefCloned.aggFunc = col.isValueActive() ? col.getAggFunc() : null;
        colDefCloned.hide = col.isVisible() ? void 0 : true;
        colDefCloned.pinned = col.isPinned() ? col.getPinned() : null;
        colDefCloned.sort = col.getSort() ? col.getSort() : null;
        colDefCloned.sortIndex = col.getSortIndex() != null ? col.getSortIndex() : null;
        return colDefCloned;
    }
};
$437b23f6a393c3bf$var$ColumnDefFactory = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("columnDefFactory")
], $437b23f6a393c3bf$var$ColumnDefFactory);
// community-modules/core/src/rendering/row/rowCssClassCalculator.ts
var $437b23f6a393c3bf$var$RowCssClassCalculator = class {
    getInitialRowClasses(params) {
        const classes = [];
        if ($437b23f6a393c3bf$var$exists(params.extraCssClass)) classes.push(params.extraCssClass);
        classes.push("ag-row");
        classes.push(params.rowFocused ? "ag-row-focus" : "ag-row-no-focus");
        if (params.fadeRowIn) classes.push("ag-opacity-zero");
        classes.push(params.rowIsEven ? "ag-row-even" : "ag-row-odd");
        if (params.rowNode.isRowPinned()) classes.push("ag-row-pinned");
        if (params.rowNode.isSelected()) classes.push("ag-row-selected");
        if (params.rowNode.footer) classes.push("ag-row-footer");
        classes.push("ag-row-level-" + params.rowLevel);
        if (params.rowNode.stub) classes.push("ag-row-loading");
        if (params.fullWidthRow) classes.push("ag-full-width-row");
        if (params.expandable) {
            classes.push("ag-row-group");
            classes.push(params.rowNode.expanded ? "ag-row-group-expanded" : "ag-row-group-contracted");
        }
        if (params.rowNode.dragging) classes.push("ag-row-dragging");
        $437b23f6a393c3bf$var$pushAll(classes, this.processClassesFromGridOptions(params.rowNode));
        $437b23f6a393c3bf$var$pushAll(classes, this.preProcessRowClassRules(params.rowNode));
        classes.push(params.printLayout ? "ag-row-position-relative" : "ag-row-position-absolute");
        if (params.firstRowOnPage) classes.push("ag-row-first");
        if (params.lastRowOnPage) classes.push("ag-row-last");
        if (params.fullWidthRow) {
            if (params.pinned === "left") classes.push("ag-cell-last-left-pinned");
            if (params.pinned === "right") classes.push("ag-cell-first-right-pinned");
        }
        return classes;
    }
    processClassesFromGridOptions(rowNode) {
        const res = [];
        const process = (rowCls)=>{
            if (typeof rowCls === "string") res.push(rowCls);
            else if (Array.isArray(rowCls)) rowCls.forEach((e)=>res.push(e));
        };
        const rowClass = this.gos.get("rowClass");
        if (rowClass) {
            if (typeof rowClass === "function") {
                console.warn("AG Grid: rowClass should not be a function, please use getRowClass instead");
                return [];
            }
            process(rowClass);
        }
        const rowClassFunc = this.gos.getCallback("getRowClass");
        if (rowClassFunc) {
            const params = {
                data: rowNode.data,
                node: rowNode,
                rowIndex: rowNode.rowIndex
            };
            const rowClassFuncResult = rowClassFunc(params);
            process(rowClassFuncResult);
        }
        return res;
    }
    preProcessRowClassRules(rowNode) {
        const res = [];
        this.processRowClassRules(rowNode, (className)=>{
            res.push(className);
        }, (className)=>{});
        return res;
    }
    processRowClassRules(rowNode, onApplicableClass, onNotApplicableClass) {
        const rowClassParams = this.gos.addGridCommonParams({
            data: rowNode.data,
            node: rowNode,
            rowIndex: rowNode.rowIndex
        });
        this.stylingService.processClassRules(void 0, this.gos.get("rowClassRules"), rowClassParams, onApplicableClass, onNotApplicableClass);
    }
    calculateRowLevel(rowNode) {
        if (rowNode.group) return rowNode.level;
        return rowNode.parent ? rowNode.parent.level + 1 : 0;
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("stylingService")
], $437b23f6a393c3bf$var$RowCssClassCalculator.prototype, "stylingService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("gridOptionsService")
], $437b23f6a393c3bf$var$RowCssClassCalculator.prototype, "gos", 2);
$437b23f6a393c3bf$var$RowCssClassCalculator = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("rowCssClassCalculator")
], $437b23f6a393c3bf$var$RowCssClassCalculator);
// community-modules/core/src/rowNodes/rowNodeSorter.ts
var $437b23f6a393c3bf$export$5cc6416c85df0cc5 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    init() {
        this.isAccentedSort = this.gos.get("accentedSort");
        this.primaryColumnsSortGroups = this.gos.isColumnsSortingCoupledToGroup();
        this.addManagedPropertyListener("accentedSort", (propChange)=>this.isAccentedSort = propChange.currentValue);
        this.addManagedPropertyListener("autoGroupColumnDef", ()=>this.primaryColumnsSortGroups = this.gos.isColumnsSortingCoupledToGroup());
    }
    doFullSort(rowNodes, sortOptions) {
        const mapper = (rowNode, pos)=>({
                currentPos: pos,
                rowNode: rowNode
            });
        const sortedRowNodes = rowNodes.map(mapper);
        sortedRowNodes.sort(this.compareRowNodes.bind(this, sortOptions));
        return sortedRowNodes.map((item)=>item.rowNode);
    }
    compareRowNodes(sortOptions, sortedNodeA, sortedNodeB) {
        const nodeA = sortedNodeA.rowNode;
        const nodeB = sortedNodeB.rowNode;
        for(let i = 0, len = sortOptions.length; i < len; i++){
            const sortOption = sortOptions[i];
            const isDescending = sortOption.sort === "desc";
            const valueA = this.getValue(nodeA, sortOption.column);
            const valueB = this.getValue(nodeB, sortOption.column);
            let comparatorResult;
            const providedComparator = this.getComparator(sortOption, nodeA);
            if (providedComparator) comparatorResult = providedComparator(valueA, valueB, nodeA, nodeB, isDescending);
            else comparatorResult = $437b23f6a393c3bf$export$71511d61b312f219.defaultComparator(valueA, valueB, this.isAccentedSort);
            const validResult = !isNaN(comparatorResult);
            if (validResult && comparatorResult !== 0) return sortOption.sort === "asc" ? comparatorResult : comparatorResult * -1;
        }
        return sortedNodeA.currentPos - sortedNodeB.currentPos;
    }
    getComparator(sortOption, rowNode) {
        const column = sortOption.column;
        const comparatorOnCol = column.getColDef().comparator;
        if (comparatorOnCol != null) return comparatorOnCol;
        if (!column.getColDef().showRowGroup) return;
        const groupLeafField = !rowNode.group && column.getColDef().field;
        if (!groupLeafField) return;
        const primaryColumn = this.columnModel.getPrimaryColumn(groupLeafField);
        if (!primaryColumn) return;
        return primaryColumn.getColDef().comparator;
    }
    getValue(node, column) {
        var _a, _b;
        if (!this.primaryColumnsSortGroups) return this.valueService.getValue(column, node, false, false);
        const isNodeGroupedAtLevel = node.rowGroupColumn === column;
        if (isNodeGroupedAtLevel) {
            const isGroupRows = this.gos.isGroupUseEntireRow(this.columnModel.isPivotActive());
            if (isGroupRows) {
                const leafChild = (_a = node.allLeafChildren) == null ? void 0 : _a[0];
                if (leafChild) return this.valueService.getValue(column, leafChild, false, false);
                return void 0;
            }
            const displayCol = this.columnModel.getGroupDisplayColumnForGroup(column.getId());
            if (!displayCol) return void 0;
            return (_b = node.groupData) == null ? void 0 : _b[displayCol.getId()];
        }
        if (node.group && column.getColDef().showRowGroup) return void 0;
        return this.valueService.getValue(column, node, false, false);
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("valueService")
], $437b23f6a393c3bf$export$5cc6416c85df0cc5.prototype, "valueService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnModel")
], $437b23f6a393c3bf$export$5cc6416c85df0cc5.prototype, "columnModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$export$5cc6416c85df0cc5.prototype, "init", 1);
$437b23f6a393c3bf$export$5cc6416c85df0cc5 = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("rowNodeSorter")
], $437b23f6a393c3bf$export$5cc6416c85df0cc5);
// community-modules/core/src/ctrlsService.ts
var $437b23f6a393c3bf$export$1ec35376f0ed6145 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.params = {};
        this.ready = false;
        this.readyCallbacks = [];
    }
    checkReady() {
        const params = this.params;
        this.ready = params.gridCtrl != null && params.gridBodyCtrl != null && params.center != null && params.left != null && params.right != null && params.bottomCenter != null && params.bottomLeft != null && params.bottomRight != null && params.topCenter != null && params.topLeft != null && params.topRight != null && params.stickyTopCenter != null && params.stickyTopLeft != null && params.stickyTopRight != null && params.stickyBottomCenter != null && params.stickyBottomLeft != null && params.stickyBottomRight != null && params.centerHeader != null && params.leftHeader != null && params.rightHeader != null && params.fakeHScrollComp != null && params.fakeVScrollComp != null && params.gridHeaderCtrl != null;
        if (this.ready) {
            this.readyCallbacks.forEach((c)=>c(params));
            this.readyCallbacks.length = 0;
        }
    }
    whenReady(callback) {
        if (this.ready) callback(this.params);
        else this.readyCallbacks.push(callback);
    }
    register(ctrlType, ctrl) {
        this.params[ctrlType] = ctrl;
        this.checkReady();
    }
    registerHeaderContainer(ctrl, pinned) {
        switch(pinned){
            case "left":
                this.params.leftHeader = ctrl;
                break;
            case "right":
                this.params.rightHeader = ctrl;
                break;
            default:
                this.params.centerHeader = ctrl;
                break;
        }
        this.checkReady();
    }
    get(ctrlType) {
        return this.params[ctrlType];
    }
    getParams() {
        return this.params;
    }
    getGridBodyCtrl() {
        return this.params.gridBodyCtrl;
    }
    getHeaderRowContainerCtrls() {
        return [
            this.params.leftHeader,
            this.params.rightHeader,
            this.params.centerHeader
        ];
    }
    getHeaderRowContainerCtrl(pinned) {
        switch(pinned){
            case "left":
                return this.params.leftHeader;
            case "right":
                return this.params.rightHeader;
            default:
                return this.params.centerHeader;
        }
    }
};
$437b23f6a393c3bf$export$1ec35376f0ed6145.NAME = "ctrlsService";
$437b23f6a393c3bf$export$1ec35376f0ed6145 = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9($437b23f6a393c3bf$export$1ec35376f0ed6145.NAME)
], $437b23f6a393c3bf$export$1ec35376f0ed6145);
// community-modules/core/src/ctrlsFactory.ts
var $437b23f6a393c3bf$var$CtrlsFactory = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.registry = {};
    }
    register(meta) {
        this.registry[meta.controllerName] = meta.controllerClass;
    }
    getInstance(name) {
        const ControllerClass = this.registry[name];
        if (ControllerClass == null) return void 0;
        return new ControllerClass();
    }
};
$437b23f6a393c3bf$var$CtrlsFactory = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("ctrlsFactory")
], $437b23f6a393c3bf$var$CtrlsFactory);
// community-modules/core/src/gridBodyComp/abstractFakeScrollComp.ts
var $437b23f6a393c3bf$var$AbstractFakeScrollComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(template, direction){
        super(template);
        this.direction = direction;
        this.hideTimeout = null;
    }
    postConstruct() {
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_SCROLL_VISIBILITY_CHANGED, this.onScrollVisibilityChanged.bind(this));
        this.onScrollVisibilityChanged();
        this.addOrRemoveCssClass("ag-apple-scrollbar", $437b23f6a393c3bf$var$isMacOsUserAgent() || $437b23f6a393c3bf$var$isIOSUserAgent());
    }
    initialiseInvisibleScrollbar() {
        if (this.invisibleScrollbar !== void 0) return;
        this.invisibleScrollbar = $437b23f6a393c3bf$var$isInvisibleScrollbar();
        if (this.invisibleScrollbar) {
            this.hideAndShowInvisibleScrollAsNeeded();
            this.addActiveListenerToggles();
        }
    }
    addActiveListenerToggles() {
        const activateEvents = [
            "mouseenter",
            "mousedown",
            "touchstart"
        ];
        const deactivateEvents = [
            "mouseleave",
            "touchend"
        ];
        const eGui = this.getGui();
        activateEvents.forEach((eventName)=>this.addManagedListener(eGui, eventName, ()=>this.addOrRemoveCssClass("ag-scrollbar-active", true)));
        deactivateEvents.forEach((eventName)=>this.addManagedListener(eGui, eventName, ()=>this.addOrRemoveCssClass("ag-scrollbar-active", false)));
    }
    onScrollVisibilityChanged() {
        if (this.invisibleScrollbar === void 0) this.initialiseInvisibleScrollbar();
        this.animationFrameService.requestAnimationFrame(()=>this.setScrollVisible());
    }
    hideAndShowInvisibleScrollAsNeeded() {
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_BODY_SCROLL, (params)=>{
            if (params.direction === this.direction) {
                if (this.hideTimeout !== null) {
                    window.clearTimeout(this.hideTimeout);
                    this.hideTimeout = null;
                }
                this.addOrRemoveCssClass("ag-scrollbar-scrolling", true);
            }
        });
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_BODY_SCROLL_END, ()=>{
            this.hideTimeout = window.setTimeout(()=>{
                this.addOrRemoveCssClass("ag-scrollbar-scrolling", false);
                this.hideTimeout = null;
            }, 400);
        });
    }
    attemptSettingScrollPosition(value) {
        const viewport = this.getViewport();
        $437b23f6a393c3bf$var$waitUntil(()=>$437b23f6a393c3bf$var$isVisible(viewport), ()=>this.setScrollPosition(value), 100);
    }
    getViewport() {
        return this.eViewport;
    }
    getContainer() {
        return this.eContainer;
    }
    onScrollCallback(fn) {
        this.addManagedListener(this.getViewport(), "scroll", fn);
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eViewport")
], $437b23f6a393c3bf$var$AbstractFakeScrollComp.prototype, "eViewport", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eContainer")
], $437b23f6a393c3bf$var$AbstractFakeScrollComp.prototype, "eContainer", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("scrollVisibleService")
], $437b23f6a393c3bf$var$AbstractFakeScrollComp.prototype, "scrollVisibleService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("ctrlsService")
], $437b23f6a393c3bf$var$AbstractFakeScrollComp.prototype, "ctrlsService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("animationFrameService")
], $437b23f6a393c3bf$var$AbstractFakeScrollComp.prototype, "animationFrameService", 2);
// community-modules/core/src/gridBodyComp/fakeHScrollComp.ts
var $437b23f6a393c3bf$var$_FakeHScrollComp = class _FakeHScrollComp extends $437b23f6a393c3bf$var$AbstractFakeScrollComp {
    constructor(){
        super(_FakeHScrollComp.TEMPLATE, "horizontal");
    }
    postConstruct() {
        super.postConstruct();
        const spacerWidthsListener = this.setFakeHScrollSpacerWidths.bind(this);
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_DISPLAYED_COLUMNS_CHANGED, spacerWidthsListener);
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, spacerWidthsListener);
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_PINNED_ROW_DATA_CHANGED, this.onPinnedRowDataChanged.bind(this));
        this.addManagedPropertyListener("domLayout", spacerWidthsListener);
        this.ctrlsService.register("fakeHScrollComp", this);
        this.createManagedBean(new $437b23f6a393c3bf$var$CenterWidthFeature((width)=>this.eContainer.style.width = `${width}px`));
        this.addManagedPropertyListeners([
            "suppressHorizontalScroll"
        ], this.onScrollVisibilityChanged.bind(this));
    }
    initialiseInvisibleScrollbar() {
        if (this.invisibleScrollbar !== void 0) return;
        this.enableRtl = this.gos.get("enableRtl");
        super.initialiseInvisibleScrollbar();
        if (this.invisibleScrollbar) this.refreshCompBottom();
    }
    onPinnedRowDataChanged() {
        this.refreshCompBottom();
    }
    refreshCompBottom() {
        if (!this.invisibleScrollbar) return;
        const bottomPinnedHeight = this.pinnedRowModel.getPinnedBottomTotalHeight();
        this.getGui().style.bottom = `${bottomPinnedHeight}px`;
    }
    onScrollVisibilityChanged() {
        super.onScrollVisibilityChanged();
        this.setFakeHScrollSpacerWidths();
    }
    setFakeHScrollSpacerWidths() {
        const vScrollShowing = this.scrollVisibleService.isVerticalScrollShowing();
        let rightSpacing = this.columnModel.getDisplayedColumnsRightWidth();
        const scrollOnRight = !this.enableRtl && vScrollShowing;
        const scrollbarWidth = this.gos.getScrollbarWidth();
        if (scrollOnRight) rightSpacing += scrollbarWidth;
        $437b23f6a393c3bf$var$setFixedWidth(this.eRightSpacer, rightSpacing);
        this.eRightSpacer.classList.toggle("ag-scroller-corner", rightSpacing <= scrollbarWidth);
        let leftSpacing = this.columnModel.getDisplayedColumnsLeftWidth();
        const scrollOnLeft = this.enableRtl && vScrollShowing;
        if (scrollOnLeft) leftSpacing += scrollbarWidth;
        $437b23f6a393c3bf$var$setFixedWidth(this.eLeftSpacer, leftSpacing);
        this.eLeftSpacer.classList.toggle("ag-scroller-corner", leftSpacing <= scrollbarWidth);
    }
    setScrollVisible() {
        const hScrollShowing = this.scrollVisibleService.isHorizontalScrollShowing();
        const invisibleScrollbar2 = this.invisibleScrollbar;
        const isSuppressHorizontalScroll = this.gos.get("suppressHorizontalScroll");
        const scrollbarWidth = hScrollShowing ? this.gos.getScrollbarWidth() || 0 : 0;
        const adjustedScrollbarWidth = scrollbarWidth === 0 && invisibleScrollbar2 ? 16 : scrollbarWidth;
        const scrollContainerSize = !isSuppressHorizontalScroll ? adjustedScrollbarWidth : 0;
        this.addOrRemoveCssClass("ag-scrollbar-invisible", invisibleScrollbar2);
        $437b23f6a393c3bf$var$setFixedHeight(this.getGui(), scrollContainerSize);
        $437b23f6a393c3bf$var$setFixedHeight(this.eViewport, scrollContainerSize);
        $437b23f6a393c3bf$var$setFixedHeight(this.eContainer, scrollContainerSize);
        this.setDisplayed(hScrollShowing, {
            skipAriaHidden: true
        });
    }
    getScrollPosition() {
        return $437b23f6a393c3bf$var$getScrollLeft(this.getViewport(), this.enableRtl);
    }
    setScrollPosition(value) {
        if (!$437b23f6a393c3bf$var$isVisible(this.getViewport())) this.attemptSettingScrollPosition(value);
        $437b23f6a393c3bf$var$setScrollLeft(this.getViewport(), value, this.enableRtl);
    }
};
$437b23f6a393c3bf$var$_FakeHScrollComp.TEMPLATE = /* html */ `<div class="ag-body-horizontal-scroll" aria-hidden="true">
            <div class="ag-horizontal-left-spacer" ref="eLeftSpacer"></div>
            <div class="ag-body-horizontal-scroll-viewport" ref="eViewport">
                <div class="ag-body-horizontal-scroll-container" ref="eContainer"></div>
            </div>
            <div class="ag-horizontal-right-spacer" ref="eRightSpacer"></div>
        </div>`;
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eLeftSpacer")
], $437b23f6a393c3bf$var$_FakeHScrollComp.prototype, "eLeftSpacer", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$8a4e90ba380c343c("eRightSpacer")
], $437b23f6a393c3bf$var$_FakeHScrollComp.prototype, "eRightSpacer", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnModel")
], $437b23f6a393c3bf$var$_FakeHScrollComp.prototype, "columnModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("pinnedRowModel")
], $437b23f6a393c3bf$var$_FakeHScrollComp.prototype, "pinnedRowModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$_FakeHScrollComp.prototype, "postConstruct", 1);
var $437b23f6a393c3bf$var$FakeHScrollComp = $437b23f6a393c3bf$var$_FakeHScrollComp;
// community-modules/core/src/gridBodyComp/pinnedWidthService.ts
var $437b23f6a393c3bf$var$PinnedWidthService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    postConstruct() {
        const listener = this.checkContainerWidths.bind(this);
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_DISPLAYED_COLUMNS_CHANGED, listener);
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_DISPLAYED_COLUMNS_WIDTH_CHANGED, listener);
        this.addManagedPropertyListener("domLayout", listener);
    }
    checkContainerWidths() {
        const printLayout = this.gos.isDomLayout("print");
        const newLeftWidth = printLayout ? 0 : this.columnModel.getDisplayedColumnsLeftWidth();
        const newRightWidth = printLayout ? 0 : this.columnModel.getDisplayedColumnsRightWidth();
        if (newLeftWidth != this.leftWidth) {
            this.leftWidth = newLeftWidth;
            this.eventService.dispatchEvent({
                type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_LEFT_PINNED_WIDTH_CHANGED
            });
        }
        if (newRightWidth != this.rightWidth) {
            this.rightWidth = newRightWidth;
            this.eventService.dispatchEvent({
                type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_RIGHT_PINNED_WIDTH_CHANGED
            });
        }
    }
    getPinnedRightWidth() {
        return this.rightWidth;
    }
    getPinnedLeftWidth() {
        return this.leftWidth;
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnModel")
], $437b23f6a393c3bf$var$PinnedWidthService.prototype, "columnModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$PinnedWidthService.prototype, "postConstruct", 1);
$437b23f6a393c3bf$var$PinnedWidthService = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("pinnedWidthService")
], $437b23f6a393c3bf$var$PinnedWidthService);
// community-modules/core/src/entities/rowNodeEventThrottle.ts
var $437b23f6a393c3bf$var$RowNodeEventThrottle = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.events = [];
    }
    postConstruct() {
        if (this.rowModel.getType() == "clientSide") this.clientSideRowModel = this.rowModel;
    }
    // because the user can call rowNode.setExpanded() many times in one VM turn,
    // we throttle the calls to ClientSideRowModel using animationFrameService. this means for 100
    // row nodes getting expanded, we only update the CSRM once, and then we fire all events after
    // CSRM has updated.
    //
    // if we did not do this, then the user could call setExpanded on 100+ rows, causing the grid
    // to re-render 100+ times, which would be a performance lag.
    //
    // we use animationFrameService
    // rather than _.debounce() so this will get done if anyone flushes the animationFrameService
    // (eg user calls api.ensureRowVisible(), which in turn flushes ).
    dispatchExpanded(event, forceSync) {
        if (this.clientSideRowModel == null) {
            this.eventService.dispatchEvent(event);
            return;
        }
        this.events.push(event);
        const func = ()=>{
            if (this.clientSideRowModel) this.clientSideRowModel.onRowGroupOpened();
            this.events.forEach((e)=>this.eventService.dispatchEvent(e));
            this.events = [];
        };
        if (forceSync) func();
        else {
            if (this.dispatchExpandedDebounced == null) this.dispatchExpandedDebounced = this.animationFrameService.debounce(func);
            this.dispatchExpandedDebounced();
        }
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("animationFrameService")
], $437b23f6a393c3bf$var$RowNodeEventThrottle.prototype, "animationFrameService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowModel")
], $437b23f6a393c3bf$var$RowNodeEventThrottle.prototype, "rowModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$RowNodeEventThrottle.prototype, "postConstruct", 1);
$437b23f6a393c3bf$var$RowNodeEventThrottle = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("rowNodeEventThrottle")
], $437b23f6a393c3bf$var$RowNodeEventThrottle);
// community-modules/core/src/validation/rules/colDefValidations.ts
var $437b23f6a393c3bf$var$COLUMN_DEFINITION_DEPRECATIONS = {
    columnsMenuParams: {
        version: "31.1",
        message: "Use `columnChooserParams` instead."
    },
    suppressMenu: {
        version: "31.1",
        message: "Use `suppressHeaderMenuButton` instead."
    },
    suppressCellFlash: {
        version: "31.2",
        message: "Use `enableCellChangeFlash={false}` in the ColDef"
    },
    dndSource: {
        version: "31.2",
        message: "This feature has been replaced by `Row Dragging to an External DropZone`."
    },
    dndSourceOnRowDrag: {
        version: "31.2",
        message: "This feature has been replaced by `Row Dragging to an External DropZone`."
    }
};
var $437b23f6a393c3bf$var$CSRM_REQUIRES_ROW_GROUP_MODULE = (_options, gridOptions)=>{
    var _a;
    if (((_a = gridOptions.rowModelType) != null ? _a : "clientSide") === "clientSide") return {
        module: "@ag-grid-enterprise/row-grouping" /* RowGroupingModule */ 
    };
    return null;
};
var $437b23f6a393c3bf$var$COLUMN_DEFINITION_VALIDATIONS = {
    // supported on all row models, but need module for client side.
    enableRowGroup: $437b23f6a393c3bf$var$CSRM_REQUIRES_ROW_GROUP_MODULE,
    rowGroup: $437b23f6a393c3bf$var$CSRM_REQUIRES_ROW_GROUP_MODULE,
    rowGroupIndex: $437b23f6a393c3bf$var$CSRM_REQUIRES_ROW_GROUP_MODULE,
    enablePivot: $437b23f6a393c3bf$var$CSRM_REQUIRES_ROW_GROUP_MODULE,
    enableValue: $437b23f6a393c3bf$var$CSRM_REQUIRES_ROW_GROUP_MODULE,
    pivot: $437b23f6a393c3bf$var$CSRM_REQUIRES_ROW_GROUP_MODULE,
    pivotIndex: $437b23f6a393c3bf$var$CSRM_REQUIRES_ROW_GROUP_MODULE,
    aggFunc: $437b23f6a393c3bf$var$CSRM_REQUIRES_ROW_GROUP_MODULE,
    cellEditor: (options)=>{
        if (options.cellEditor === "agRichSelect" || options.cellEditor === "agRichSelectCellEditor") return {
            module: "@ag-grid-enterprise/rich-select" /* RichSelectModule */ 
        };
        return null;
    },
    menuTabs: (options)=>{
        var _a;
        const enterpriseMenuTabs = [
            "columnsMenuTab",
            "generalMenuTab"
        ];
        if ((_a = options.menuTabs) == null ? void 0 : _a.some((tab)=>enterpriseMenuTabs.includes(tab))) return {
            module: "@ag-grid-enterprise/menu" /* MenuModule */ 
        };
        return null;
    },
    columnsMenuParams: {
        module: [
            "@ag-grid-enterprise/menu" /* MenuModule */ ,
            "@ag-grid-enterprise/column-tool-panel" /* ColumnsToolPanelModule */ 
        ]
    },
    columnChooserParams: {
        module: [
            "@ag-grid-enterprise/menu" /* MenuModule */ ,
            "@ag-grid-enterprise/column-tool-panel" /* ColumnsToolPanelModule */ 
        ]
    },
    headerCheckboxSelection: {
        supportedRowModels: [
            "clientSide",
            "serverSide"
        ],
        dependencies: (_options, { rowSelection: rowSelection })=>rowSelection === "multiple" ? null : "headerCheckboxSelection is only supported with rowSelection=multiple"
    },
    headerCheckboxSelectionFilteredOnly: {
        supportedRowModels: [
            "clientSide"
        ],
        dependencies: (_options, { rowSelection: rowSelection })=>rowSelection === "multiple" ? null : "headerCheckboxSelectionFilteredOnly is only supported with rowSelection=multiple"
    },
    headerCheckboxSelectionCurrentPageOnly: {
        supportedRowModels: [
            "clientSide"
        ],
        dependencies: (_options, { rowSelection: rowSelection })=>rowSelection === "multiple" ? null : "headerCheckboxSelectionCurrentPageOnly is only supported with rowSelection=multiple"
    },
    children: ()=>$437b23f6a393c3bf$var$COL_DEF_VALIDATORS
};
var $437b23f6a393c3bf$var$colDefPropertyMap = {
    headerName: void 0,
    columnGroupShow: void 0,
    headerClass: void 0,
    toolPanelClass: void 0,
    headerValueGetter: void 0,
    pivotKeys: void 0,
    groupId: void 0,
    colId: void 0,
    sort: void 0,
    initialSort: void 0,
    field: void 0,
    type: void 0,
    cellDataType: void 0,
    tooltipComponent: void 0,
    tooltipField: void 0,
    headerTooltip: void 0,
    cellClass: void 0,
    showRowGroup: void 0,
    filter: void 0,
    initialAggFunc: void 0,
    defaultAggFunc: void 0,
    aggFunc: void 0,
    pinned: void 0,
    initialPinned: void 0,
    chartDataType: void 0,
    cellAriaRole: void 0,
    cellEditorPopupPosition: void 0,
    headerGroupComponent: void 0,
    headerGroupComponentParams: void 0,
    cellStyle: void 0,
    cellRenderer: void 0,
    cellRendererParams: void 0,
    cellEditor: void 0,
    cellEditorParams: void 0,
    filterParams: void 0,
    pivotValueColumn: void 0,
    headerComponent: void 0,
    headerComponentParams: void 0,
    floatingFilterComponent: void 0,
    floatingFilterComponentParams: void 0,
    tooltipComponentParams: void 0,
    refData: void 0,
    columnsMenuParams: void 0,
    columnChooserParams: void 0,
    children: void 0,
    sortingOrder: void 0,
    allowedAggFuncs: void 0,
    menuTabs: void 0,
    pivotTotalColumnIds: void 0,
    cellClassRules: void 0,
    icons: void 0,
    sortIndex: void 0,
    initialSortIndex: void 0,
    flex: void 0,
    initialFlex: void 0,
    width: void 0,
    initialWidth: void 0,
    minWidth: void 0,
    maxWidth: void 0,
    rowGroupIndex: void 0,
    initialRowGroupIndex: void 0,
    pivotIndex: void 0,
    initialPivotIndex: void 0,
    suppressCellFlash: void 0,
    suppressColumnsToolPanel: void 0,
    suppressFiltersToolPanel: void 0,
    openByDefault: void 0,
    marryChildren: void 0,
    suppressStickyLabel: void 0,
    hide: void 0,
    initialHide: void 0,
    rowGroup: void 0,
    initialRowGroup: void 0,
    pivot: void 0,
    initialPivot: void 0,
    checkboxSelection: void 0,
    showDisabledCheckboxes: void 0,
    headerCheckboxSelection: void 0,
    headerCheckboxSelectionFilteredOnly: void 0,
    headerCheckboxSelectionCurrentPageOnly: void 0,
    suppressMenu: void 0,
    suppressHeaderMenuButton: void 0,
    suppressMovable: void 0,
    lockPosition: void 0,
    lockVisible: void 0,
    lockPinned: void 0,
    unSortIcon: void 0,
    suppressSizeToFit: void 0,
    suppressAutoSize: void 0,
    enableRowGroup: void 0,
    enablePivot: void 0,
    enableValue: void 0,
    editable: void 0,
    suppressPaste: void 0,
    suppressNavigable: void 0,
    enableCellChangeFlash: void 0,
    rowDrag: void 0,
    dndSource: void 0,
    autoHeight: void 0,
    wrapText: void 0,
    sortable: void 0,
    resizable: void 0,
    singleClickEdit: void 0,
    floatingFilter: void 0,
    cellEditorPopup: void 0,
    suppressFillHandle: void 0,
    wrapHeaderText: void 0,
    autoHeaderHeight: void 0,
    dndSourceOnRowDrag: void 0,
    valueGetter: void 0,
    valueSetter: void 0,
    filterValueGetter: void 0,
    keyCreator: void 0,
    valueFormatter: void 0,
    valueParser: void 0,
    comparator: void 0,
    equals: void 0,
    pivotComparator: void 0,
    suppressKeyboardEvent: void 0,
    suppressHeaderKeyboardEvent: void 0,
    colSpan: void 0,
    rowSpan: void 0,
    getQuickFilterText: void 0,
    onCellValueChanged: void 0,
    onCellClicked: void 0,
    onCellDoubleClicked: void 0,
    onCellContextMenu: void 0,
    rowDragText: void 0,
    tooltipValueGetter: void 0,
    cellRendererSelector: void 0,
    cellEditorSelector: void 0,
    suppressSpanHeaderHeight: void 0,
    useValueFormatterForExport: void 0,
    useValueParserForImport: void 0,
    mainMenuItems: void 0,
    contextMenuItems: void 0,
    suppressFloatingFilterButton: void 0,
    suppressHeaderFilterButton: void 0,
    suppressHeaderContextMenu: void 0,
    loadingCellRenderer: void 0,
    loadingCellRendererParams: void 0,
    loadingCellRendererSelector: void 0
};
var $437b23f6a393c3bf$var$ALL_PROPERTIES = Object.keys($437b23f6a393c3bf$var$colDefPropertyMap);
var $437b23f6a393c3bf$var$COL_DEF_VALIDATORS = {
    objectName: "colDef",
    allProperties: $437b23f6a393c3bf$var$ALL_PROPERTIES,
    docsUrl: "column-properties/",
    deprecations: $437b23f6a393c3bf$var$COLUMN_DEFINITION_DEPRECATIONS,
    validations: $437b23f6a393c3bf$var$COLUMN_DEFINITION_VALIDATIONS
};
// community-modules/core/src/validation/rules/gridOptionsValidations.ts
var $437b23f6a393c3bf$var$GRID_OPTION_DEPRECATIONS = {
    enableChartToolPanelsButton: {
        version: "29"
    },
    functionsPassive: {
        version: "29.2"
    },
    onColumnRowGroupChangeRequest: {
        version: "29.2"
    },
    onColumnPivotChangeRequest: {
        version: "29.2"
    },
    onColumnValueChangeRequest: {
        version: "29.2"
    },
    onColumnAggFuncChangeRequest: {
        version: "29.2"
    },
    serverSideFilterAllLevels: {
        version: "30",
        message: "All server-side group levels are now filtered by default. This can be toggled using `serverSideOnlyRefreshFilteredGroups`."
    },
    suppressAggAtRootLevel: {
        version: "30",
        message: "The root level aggregation is now suppressed by default. This can be toggled using  `alwaysAggregateAtRootLevel`."
    },
    excludeHiddenColumnsFromQuickFilter: {
        version: "30",
        message: "Hidden columns are now excluded from the Quick Filter by default. This can be toggled using `includeHiddenColumnsInQuickFilter`."
    },
    enterMovesDown: {
        version: "30",
        renamed: "enterNavigatesVertically"
    },
    enterMovesDownAfterEdit: {
        version: "30",
        renamed: "enterNavigatesVerticallyAfterEdit"
    },
    suppressParentsInRowNodes: {
        version: "30.2",
        message: "Using suppressParentsInRowNodes is no longer recommended. To serialize nodes it is now recommended to instead remove the parent node reference before serialization."
    },
    advancedFilterModel: {
        version: "31",
        message: "Use `initialState.filter.advancedFilterModel` instead."
    },
    suppressAsyncEvents: {
        version: "31",
        message: "Events should be handled asynchronously."
    },
    cellFadeDelay: {
        version: "31.1",
        renamed: "cellFadeDuration"
    },
    cellFlashDelay: {
        version: "31.1",
        renamed: "cellFlashDuration"
    },
    suppressServerSideInfiniteScroll: {
        version: "31.1"
    },
    serverSideSortOnServer: {
        version: "31.1"
    },
    serverSideFilterOnServer: {
        version: "31.1"
    },
    enableCellChangeFlash: {
        version: "31.2",
        message: "Use `enableCellChangeFlash` in the `ColDef` or `defaultColDef` for all columns."
    },
    groupIncludeFooter: {
        version: "31.3",
        message: "Use `groupTotalRow` instead."
    },
    groupIncludeTotalFooter: {
        version: "31.3",
        message: "Use `grandTotalRow` instead."
    }
};
var $437b23f6a393c3bf$var$GRID_OPTION_DEFAULTS = {
    suppressContextMenu: false,
    preventDefaultOnContextMenu: false,
    allowContextMenuWithControlKey: false,
    suppressMenuHide: false,
    enableBrowserTooltips: false,
    tooltipTrigger: "hover",
    tooltipShowDelay: 2e3,
    tooltipHideDelay: 1e4,
    tooltipMouseTrack: false,
    tooltipShowMode: "standard",
    tooltipInteraction: false,
    copyHeadersToClipboard: false,
    copyGroupHeadersToClipboard: false,
    clipboardDelimiter: "	",
    suppressCopyRowsToClipboard: false,
    suppressCopySingleCellRanges: false,
    suppressLastEmptyLineOnPaste: false,
    suppressClipboardPaste: false,
    suppressClipboardApi: false,
    suppressCutToClipboard: false,
    maintainColumnOrder: false,
    suppressFieldDotNotation: false,
    allowDragFromColumnsToolPanel: false,
    suppressMovableColumns: false,
    suppressColumnMoveAnimation: false,
    suppressDragLeaveHidesColumns: false,
    suppressRowGroupHidesColumns: false,
    suppressAutoSize: false,
    autoSizePadding: 20,
    skipHeaderOnAutoSize: false,
    singleClickEdit: false,
    suppressClickEdit: false,
    readOnlyEdit: false,
    stopEditingWhenCellsLoseFocus: false,
    enterNavigatesVertically: false,
    enterNavigatesVerticallyAfterEdit: false,
    enableCellEditingOnBackspace: false,
    undoRedoCellEditing: false,
    undoRedoCellEditingLimit: 10,
    suppressCsvExport: false,
    suppressExcelExport: false,
    cacheQuickFilter: false,
    includeHiddenColumnsInQuickFilter: false,
    excludeChildrenWhenTreeDataFiltering: false,
    enableAdvancedFilter: false,
    includeHiddenColumnsInAdvancedFilter: false,
    enableCharts: false,
    suppressChartToolPanelsButton: false,
    masterDetail: false,
    keepDetailRows: false,
    keepDetailRowsCount: 10,
    detailRowAutoHeight: false,
    tabIndex: 0,
    rowBuffer: 10,
    valueCache: false,
    valueCacheNeverExpires: false,
    enableCellExpressions: false,
    suppressTouch: false,
    suppressFocusAfterRefresh: false,
    suppressAsyncEvents: false,
    suppressBrowserResizeObserver: false,
    suppressPropertyNamesCheck: false,
    suppressChangeDetection: false,
    debug: false,
    suppressLoadingOverlay: false,
    suppressNoRowsOverlay: false,
    pagination: false,
    paginationPageSize: 100,
    paginationPageSizeSelector: true,
    paginationAutoPageSize: false,
    paginateChildRows: false,
    suppressPaginationPanel: false,
    pivotMode: false,
    pivotPanelShow: "never",
    pivotDefaultExpanded: 0,
    pivotSuppressAutoColumn: false,
    suppressExpandablePivotGroups: false,
    functionsReadOnly: false,
    suppressAggFuncInHeader: false,
    alwaysAggregateAtRootLevel: false,
    aggregateOnlyChangedColumns: false,
    suppressAggFilteredOnly: false,
    removePivotHeaderRowWhenSingleValueColumn: false,
    animateRows: true,
    enableCellChangeFlash: false,
    cellFlashDelay: 500,
    cellFlashDuration: 500,
    cellFadeDelay: 1e3,
    cellFadeDuration: 1e3,
    allowShowChangeAfterFilter: false,
    domLayout: "normal",
    ensureDomOrder: false,
    enableRtl: false,
    suppressColumnVirtualisation: false,
    suppressMaxRenderedRowRestriction: false,
    suppressRowVirtualisation: false,
    rowDragManaged: false,
    suppressRowDrag: false,
    suppressMoveWhenRowDragging: false,
    rowDragEntireRow: false,
    rowDragMultiRow: false,
    embedFullWidthRows: false,
    groupDisplayType: "singleColumn",
    groupDefaultExpanded: 0,
    groupMaintainOrder: false,
    groupSelectsChildren: false,
    groupIncludeTotalFooter: false,
    groupSuppressBlankHeader: false,
    groupSelectsFiltered: false,
    showOpenedGroup: false,
    groupRemoveSingleChildren: false,
    groupRemoveLowestSingleChildren: false,
    groupHideOpenParents: false,
    groupAllowUnbalanced: false,
    rowGroupPanelShow: "never",
    suppressMakeColumnVisibleAfterUnGroup: false,
    treeData: false,
    rowGroupPanelSuppressSort: false,
    suppressGroupRowsSticky: false,
    rowModelType: "clientSide",
    asyncTransactionWaitMillis: 50,
    suppressModelUpdateAfterUpdateTransaction: false,
    cacheOverflowSize: 1,
    infiniteInitialRowCount: 1,
    serverSideInitialRowCount: 1,
    suppressServerSideInfiniteScroll: false,
    cacheBlockSize: 100,
    maxBlocksInCache: -1,
    maxConcurrentDatasourceRequests: 2,
    blockLoadDebounceMillis: 0,
    purgeClosedRowNodes: false,
    serverSideSortAllLevels: false,
    serverSideOnlyRefreshFilteredGroups: false,
    serverSideSortOnServer: false,
    serverSideFilterOnServer: false,
    serverSidePivotResultFieldSeparator: "_",
    viewportRowModelPageSize: 5,
    viewportRowModelBufferSize: 5,
    alwaysShowHorizontalScroll: false,
    alwaysShowVerticalScroll: false,
    debounceVerticalScrollbar: false,
    suppressHorizontalScroll: false,
    suppressScrollOnNewData: false,
    suppressScrollWhenPopupsAreOpen: false,
    suppressAnimationFrame: false,
    suppressMiddleClickScrolls: false,
    suppressPreventDefaultOnMouseWheel: false,
    rowMultiSelectWithClick: false,
    suppressRowDeselection: false,
    suppressRowClickSelection: false,
    suppressCellFocus: false,
    suppressHeaderFocus: false,
    suppressMultiRangeSelection: false,
    enableCellTextSelection: false,
    enableRangeSelection: false,
    enableRangeHandle: false,
    enableFillHandle: false,
    fillHandleDirection: "xy",
    suppressClearOnFillReduction: false,
    accentedSort: false,
    unSortIcon: false,
    suppressMultiSort: false,
    alwaysMultiSort: false,
    suppressMaintainUnsortedOrder: false,
    suppressRowHoverHighlight: false,
    suppressRowTransform: false,
    columnHoverHighlight: false,
    deltaSort: false,
    enableGroupEdit: false,
    suppressGroupMaintainValueType: false,
    functionsPassive: false,
    groupLockGroupColumns: 0,
    serverSideEnableClientSideSort: false,
    suppressServerSideFullWidthLoadingRow: false,
    pivotMaxGeneratedColumns: -1
};
var $437b23f6a393c3bf$var$GRID_OPTION_VALIDATIONS = {
    sideBar: {
        module: "@ag-grid-enterprise/side-bar" /* SideBarModule */ 
    },
    statusBar: {
        module: "@ag-grid-enterprise/status-bar" /* StatusBarModule */ 
    },
    enableCharts: {
        module: "@ag-grid-enterprise/charts" /* GridChartsModule */ 
    },
    getMainMenuItems: {
        module: "@ag-grid-enterprise/menu" /* MenuModule */ 
    },
    getContextMenuItems: {
        module: "@ag-grid-enterprise/menu" /* MenuModule */ 
    },
    allowContextMenuWithControlKey: {
        module: "@ag-grid-enterprise/menu" /* MenuModule */ 
    },
    enableAdvancedFilter: {
        module: "@ag-grid-enterprise/advanced-filter" /* AdvancedFilterModule */ 
    },
    treeData: {
        supportedRowModels: [
            "clientSide",
            "serverSide"
        ],
        module: "@ag-grid-enterprise/row-grouping" /* RowGroupingModule */ ,
        dependencies: (options)=>{
            var _a;
            const rowModel = (_a = options.rowModelType) != null ? _a : "clientSide";
            switch(rowModel){
                case "clientSide":
                    const csrmWarning = `treeData requires 'getDataPath' in the ${rowModel} row model.`;
                    return options.getDataPath ? null : csrmWarning;
                case "serverSide":
                    const ssrmWarning = `treeData requires 'isServerSideGroup' and 'getServerSideGroupKey' in the ${rowModel} row model.`;
                    return options.isServerSideGroup && options.getServerSideGroupKey ? null : ssrmWarning;
            }
            return null;
        }
    },
    masterDetail: {
        module: "@ag-grid-enterprise/master-detail" /* MasterDetailModule */ 
    },
    enableRangeSelection: {
        module: "@ag-grid-enterprise/range-selection" /* RangeSelectionModule */ 
    },
    enableRangeHandle: {
        dependencies: {
            enableRangeSelection: [
                true
            ]
        }
    },
    enableFillHandle: {
        dependencies: {
            enableRangeSelection: [
                true
            ]
        }
    },
    groupDefaultExpanded: {
        supportedRowModels: [
            "clientSide"
        ]
    },
    groupIncludeFooter: {
        supportedRowModels: [
            "clientSide",
            "serverSide"
        ],
        dependencies: (options)=>{
            var _a;
            const rowModel = (_a = options.rowModelType) != null ? _a : "clientSide";
            switch(rowModel){
                case "clientSide":
                    return null;
                case "serverSide":
                    const warning = "groupIncludeFooter is not supported alongside suppressServerSideInfiniteScroll";
                    return options.suppressServerSideInfiniteScroll ? warning : null;
            }
            return null;
        }
    },
    groupIncludeTotalFooter: {
        supportedRowModels: [
            "clientSide"
        ]
    },
    groupRemoveSingleChildren: {
        dependencies: {
            groupHideOpenParents: [
                void 0,
                false
            ],
            groupRemoveLowestSingleChildren: [
                void 0,
                false
            ]
        }
    },
    groupRemoveLowestSingleChildren: {
        dependencies: {
            groupHideOpenParents: [
                void 0,
                false
            ],
            groupRemoveSingleChildren: [
                void 0,
                false
            ]
        }
    },
    groupSelectsChildren: {
        dependencies: {
            rowSelection: [
                "multiple"
            ]
        }
    },
    suppressParentsInRowNodes: {
        dependencies: {
            groupSelectsChildren: [
                void 0,
                false
            ]
        }
    },
    viewportDatasource: {
        supportedRowModels: [
            "viewport"
        ],
        module: "@ag-grid-enterprise/viewport-row-model" /* ViewportRowModelModule */ 
    },
    serverSideDatasource: {
        supportedRowModels: [
            "serverSide"
        ],
        module: "@ag-grid-enterprise/server-side-row-model" /* ServerSideRowModelModule */ 
    },
    cacheBlockSize: {
        supportedRowModels: [
            "serverSide",
            "infinite"
        ]
    },
    datasource: {
        supportedRowModels: [
            "infinite"
        ],
        module: "@ag-grid-community/infinite-row-model" /* InfiniteRowModelModule */ 
    },
    rowData: {
        supportedRowModels: [
            "clientSide"
        ],
        module: "@ag-grid-community/client-side-row-model" /* ClientSideRowModelModule */ 
    },
    columnDefs: ()=>$437b23f6a393c3bf$var$COL_DEF_VALIDATORS,
    defaultColDef: ()=>$437b23f6a393c3bf$var$COL_DEF_VALIDATORS,
    defaultColGroupDef: ()=>$437b23f6a393c3bf$var$COL_DEF_VALIDATORS,
    autoGroupColumnDef: ()=>$437b23f6a393c3bf$var$COL_DEF_VALIDATORS
};
var $437b23f6a393c3bf$var$GRID_OPTIONS_VALIDATORS = {
    objectName: "gridOptions",
    allProperties: [
        ...$437b23f6a393c3bf$export$4d1a0127671c9c1f.ALL_PROPERTIES,
        ...$437b23f6a393c3bf$export$1f1b72b628161f7c.EVENT_CALLBACKS
    ],
    propertyExceptions: [
        "api",
        "columnApi"
    ],
    docsUrl: "grid-options/",
    deprecations: $437b23f6a393c3bf$var$GRID_OPTION_DEPRECATIONS,
    validations: $437b23f6a393c3bf$var$GRID_OPTION_VALIDATIONS
};
// community-modules/core/src/gridOptionsService.ts
var $437b23f6a393c3bf$export$4e35ad424d98ee6 = class {
    constructor(){
        this.destroyed = false;
        this.domDataKey = "__AG_" + Math.random().toString();
        this.propertyEventService = new $437b23f6a393c3bf$export$895d7dc49f082ca1();
        // responsible for calling the onXXX functions on gridOptions
        // It forces events defined in GridOptionsService.alwaysSyncGlobalEvents to be fired synchronously.
        // This is required for events such as GridPreDestroyed.
        // Other events can be fired asynchronously or synchronously depending on config.
        this.globalEventHandlerFactory = (restrictToSyncOnly)=>{
            return (eventName, event)=>{
                if (this.destroyed) return;
                const alwaysSync = $437b23f6a393c3bf$export$12e4e9a3cbd0ec07.has(eventName);
                if (alwaysSync && !restrictToSyncOnly || !alwaysSync && restrictToSyncOnly) return;
                const eventHandlerName = $437b23f6a393c3bf$export$1f1b72b628161f7c.getCallbackForEvent(eventName);
                const eventHandler = this.gridOptions[eventHandlerName];
                if (typeof eventHandler === "function") this.frameworkOverrides.wrapOutgoing(()=>{
                    eventHandler(event);
                });
            };
        };
    }
    // This is quicker then having code call gridOptionsService.get('context')
    get context() {
        return this.gridOptions["context"];
    }
    init() {
        this.columnApi = new $437b23f6a393c3bf$export$77ba9896796af9bf(this.api);
        const async = !this.get("suppressAsyncEvents");
        this.eventService.addGlobalListener(this.globalEventHandlerFactory().bind(this), async);
        this.eventService.addGlobalListener(this.globalEventHandlerFactory(true).bind(this), false);
        this.propertyEventService.setFrameworkOverrides(this.frameworkOverrides);
        this.getScrollbarWidth();
    }
    destroy() {
        this.destroyed = true;
        this.columnApi = void 0;
    }
    /**
   * Get the raw value of the GridOptions property provided.
   * @param property
   */ get(property) {
        var _a;
        return (_a = this.gridOptions[property]) != null ? _a : $437b23f6a393c3bf$var$GRID_OPTION_DEFAULTS[property];
    }
    /**
   * Get the GridOption callback but wrapped so that the common params of api,columnApi and context are automatically applied to the params.
   * @param property GridOption callback properties based on the fact that this property has a callback with params extending AgGridCommon
   */ getCallback(property) {
        return this.mergeGridCommonParams(this.gridOptions[property]);
    }
    /**
   * Returns `true` if a value has been specified for this GridOption.
   * @param property GridOption property
   */ exists(property) {
        return $437b23f6a393c3bf$var$exists(this.gridOptions[property]);
    }
    /**
  * Wrap the user callback and attach the api, columnApi and context to the params object on the way through.
  * @param callback User provided callback
  * @returns Wrapped callback where the params object not require api, columnApi and context
  */ mergeGridCommonParams(callback) {
        if (callback) {
            const wrapped = (callbackParams)=>{
                const mergedParams = callbackParams;
                mergedParams.api = this.api;
                mergedParams.columnApi = this.columnApi;
                mergedParams.context = this.context;
                return callback(mergedParams);
            };
            return wrapped;
        }
        return callback;
    }
    static toBoolean(value) {
        if (typeof value === "boolean") return value;
        if (typeof value === "string") return value.toUpperCase() === "TRUE" || value == "";
        return false;
    }
    static toNumber(value) {
        if (typeof value === "number") return value;
        if (typeof value === "string") {
            const parsed = parseInt(value);
            if (isNaN(parsed)) return void 0;
            return parsed;
        }
        return void 0;
    }
    static toConstrainedNum(min, max) {
        return (value)=>{
            const num = $437b23f6a393c3bf$export$4e35ad424d98ee6.toNumber(value);
            if (num == null || num < min || num > max) return void 0;
            return num;
        };
    }
    static getCoercedValue(key, value) {
        const coerceFunc = $437b23f6a393c3bf$export$4e35ad424d98ee6.PROPERTY_COERCIONS.get(key);
        if (!coerceFunc) return value;
        return coerceFunc(value);
    }
    static getCoercedGridOptions(gridOptions) {
        const newGo = {};
        Object.entries(gridOptions).forEach(([key, value])=>{
            const coercedValue = $437b23f6a393c3bf$export$4e35ad424d98ee6.getCoercedValue(key, value);
            newGo[key] = coercedValue;
        });
        return newGo;
    }
    updateGridOptions({ options: options, force: force, source: source = "api" }) {
        const changeSet = {
            id: $437b23f6a393c3bf$export$4e35ad424d98ee6.changeSetId++,
            properties: []
        };
        const events = [];
        Object.entries(options).forEach(([key, value])=>{
            if (source === "api" && $437b23f6a393c3bf$var$INITIAL_GRID_OPTION_KEYS[key]) $437b23f6a393c3bf$var$warnOnce(`${key} is an initial property and cannot be updated.`);
            const coercedValue = $437b23f6a393c3bf$export$4e35ad424d98ee6.getCoercedValue(key, value);
            const shouldForce = force || typeof coercedValue === "object" && source === "api";
            const previousValue = this.gridOptions[key];
            if (shouldForce || previousValue !== coercedValue) {
                this.gridOptions[key] = coercedValue;
                const event = {
                    type: key,
                    currentValue: coercedValue,
                    previousValue: previousValue,
                    changeSet: changeSet,
                    source: source
                };
                events.push(event);
            }
        });
        this.validationService.processGridOptions(this.gridOptions);
        changeSet.properties = events.map((event)=>event.type);
        events.forEach((event)=>{
            if (this.gridOptions.debug) console.log(`AG Grid: Updated property ${event.type} from `, event.previousValue, " to  ", event.currentValue);
            this.propertyEventService.dispatchEvent(event);
        });
    }
    addEventListener(key, listener) {
        this.propertyEventService.addEventListener(key, listener);
    }
    removeEventListener(key, listener) {
        this.propertyEventService.removeEventListener(key, listener);
    }
    // *************** Helper methods ************************** //
    // Methods to share common GridOptions related logic that goes above accessing a single property
    // the user might be using some non-standard scrollbar, eg a scrollbar that has zero
    // width and overlays (like the Safari scrollbar, but presented in Chrome). so we
    // allow the user to provide the scroll width before we work it out.
    getScrollbarWidth() {
        if (this.scrollbarWidth == null) {
            const useGridOptions = typeof this.gridOptions.scrollbarWidth === "number" && this.gridOptions.scrollbarWidth >= 0;
            const scrollbarWidth = useGridOptions ? this.gridOptions.scrollbarWidth : $437b23f6a393c3bf$var$getScrollbarWidth();
            if (scrollbarWidth != null) {
                this.scrollbarWidth = scrollbarWidth;
                this.eventService.dispatchEvent({
                    type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_SCROLLBAR_WIDTH_CHANGED
                });
            }
        }
        return this.scrollbarWidth;
    }
    isRowModelType(rowModelType) {
        return this.gridOptions.rowModelType === rowModelType || rowModelType === "clientSide" && $437b23f6a393c3bf$var$missing(this.gridOptions.rowModelType);
    }
    isDomLayout(domLayout) {
        var _a;
        const gridLayout = (_a = this.gridOptions.domLayout) != null ? _a : "normal";
        return gridLayout === domLayout;
    }
    isRowSelection() {
        return this.gridOptions.rowSelection === "single" || this.gridOptions.rowSelection === "multiple";
    }
    useAsyncEvents() {
        return !this.get("suppressAsyncEvents");
    }
    isGetRowHeightFunction() {
        return typeof this.gridOptions.getRowHeight === "function";
    }
    getRowHeightForNode(rowNode, allowEstimate = false, defaultRowHeight) {
        if (defaultRowHeight == null) defaultRowHeight = this.environment.getDefaultRowHeight();
        if (this.isGetRowHeightFunction()) {
            if (allowEstimate) return {
                height: defaultRowHeight,
                estimated: true
            };
            const params = {
                node: rowNode,
                data: rowNode.data
            };
            const height = this.getCallback("getRowHeight")(params);
            if (this.isNumeric(height)) {
                if (height === 0) $437b23f6a393c3bf$var$warnOnce("The return of `getRowHeight` cannot be zero. If the intention is to hide rows, use a filter instead.");
                return {
                    height: Math.max(1, height),
                    estimated: false
                };
            }
        }
        if (rowNode.detail && this.get("masterDetail")) return this.getMasterDetailRowHeight();
        const rowHeight = this.gridOptions.rowHeight && this.isNumeric(this.gridOptions.rowHeight) ? this.gridOptions.rowHeight : defaultRowHeight;
        return {
            height: rowHeight,
            estimated: false
        };
    }
    getMasterDetailRowHeight() {
        if (this.get("detailRowAutoHeight")) return {
            height: 1,
            estimated: false
        };
        if (this.isNumeric(this.gridOptions.detailRowHeight)) return {
            height: this.gridOptions.detailRowHeight,
            estimated: false
        };
        return {
            height: 300,
            estimated: false
        };
    }
    // we don't allow dynamic row height for virtual paging
    getRowHeightAsNumber() {
        if (!this.gridOptions.rowHeight || $437b23f6a393c3bf$var$missing(this.gridOptions.rowHeight)) return this.environment.getDefaultRowHeight();
        const rowHeight = this.environment.refreshRowHeightVariable();
        if (rowHeight !== -1) return rowHeight;
        console.warn("AG Grid row height must be a number if not using standard row model");
        return this.environment.getDefaultRowHeight();
    }
    isNumeric(value) {
        return !isNaN(value) && typeof value === "number" && isFinite(value);
    }
    getDomDataKey() {
        return this.domDataKey;
    }
    // returns the dom data, or undefined if not found
    getDomData(element, key) {
        const domData = element[this.getDomDataKey()];
        return domData ? domData[key] : void 0;
    }
    setDomData(element, key, value) {
        const domDataKey = this.getDomDataKey();
        let domData = element[domDataKey];
        if ($437b23f6a393c3bf$var$missing(domData)) {
            domData = {};
            element[domDataKey] = domData;
        }
        domData[key] = value;
    }
    getDocument() {
        let result = null;
        if (this.gridOptions.getDocument && $437b23f6a393c3bf$var$exists(this.gridOptions.getDocument)) result = this.gridOptions.getDocument();
        else if (this.eGridDiv) result = this.eGridDiv.ownerDocument;
        if (result && $437b23f6a393c3bf$var$exists(result)) return result;
        return document;
    }
    getWindow() {
        const eDocument = this.getDocument();
        return eDocument.defaultView || window;
    }
    getRootNode() {
        return this.eGridDiv.getRootNode();
    }
    getActiveDomElement() {
        return this.getRootNode().activeElement;
    }
    getAsyncTransactionWaitMillis() {
        return $437b23f6a393c3bf$var$exists(this.gridOptions.asyncTransactionWaitMillis) ? this.gridOptions.asyncTransactionWaitMillis : 50;
    }
    isAnimateRows() {
        if (this.get("ensureDomOrder")) return false;
        return this.get("animateRows");
    }
    isGroupRowsSticky() {
        if (this.get("paginateChildRows") || this.get("groupHideOpenParents") || this.isDomLayout("print")) return false;
        return true;
    }
    isColumnsSortingCoupledToGroup() {
        const autoGroupColumnDef = this.gridOptions.autoGroupColumnDef;
        return !(autoGroupColumnDef == null ? void 0 : autoGroupColumnDef.comparator) && !this.get("treeData");
    }
    getGroupAggFiltering() {
        const userValue = this.gridOptions.groupAggFiltering;
        if (typeof userValue === "function") return this.getCallback("groupAggFiltering");
        if (userValue === true) return ()=>true;
        return void 0;
    }
    getGrandTotalRow() {
        const userValue = this.gridOptions.grandTotalRow;
        if (userValue) return userValue;
        const legacyValue = this.gridOptions.groupIncludeTotalFooter;
        if (legacyValue) return "bottom";
        return void 0;
    }
    getGroupTotalRowCallback() {
        const userValue = this.get("groupTotalRow");
        if (typeof userValue === "function") return this.getCallback("groupTotalRow");
        if (userValue) return ()=>userValue;
        const legacyValue = this.get("groupIncludeFooter");
        if (typeof legacyValue === "function") {
            const legacyCallback = this.getCallback("groupIncludeFooter");
            return (p)=>{
                return legacyCallback(p) ? "bottom" : void 0;
            };
        }
        return ()=>legacyValue ? "bottom" : void 0;
    }
    isGroupMultiAutoColumn() {
        if (this.gridOptions.groupDisplayType) return this.gridOptions.groupDisplayType === "multipleColumns";
        return this.get("groupHideOpenParents");
    }
    isGroupUseEntireRow(pivotMode) {
        if (pivotMode) return false;
        return this.gridOptions.groupDisplayType === "groupRows";
    }
    getGridCommonParams() {
        return {
            api: this.api,
            columnApi: this.columnApi,
            context: this.context
        };
    }
    addGridCommonParams(params) {
        const updatedParams = params;
        updatedParams.api = this.api;
        updatedParams.columnApi = this.columnApi;
        updatedParams.context = this.context;
        return updatedParams;
    }
};
/**
 * Handles value coercion including validation of ranges etc. If value is invalid, undefined is set, allowing default to be used.
 */ $437b23f6a393c3bf$export$4e35ad424d98ee6.PROPERTY_COERCIONS = new Map([
    ...$437b23f6a393c3bf$export$4d1a0127671c9c1f.BOOLEAN_PROPERTIES.map((key)=>[
            key,
            $437b23f6a393c3bf$export$4e35ad424d98ee6.toBoolean
        ]),
    ...$437b23f6a393c3bf$export$4d1a0127671c9c1f.NUMBER_PROPERTIES.map((key)=>[
            key,
            $437b23f6a393c3bf$export$4e35ad424d98ee6.toNumber
        ]),
    [
        "groupAggFiltering",
        (val)=>typeof val === "function" ? val : $437b23f6a393c3bf$export$4e35ad424d98ee6.toBoolean(val)
    ],
    [
        "pageSize",
        $437b23f6a393c3bf$export$4e35ad424d98ee6.toConstrainedNum(1, Number.MAX_VALUE)
    ],
    [
        "autoSizePadding",
        $437b23f6a393c3bf$export$4e35ad424d98ee6.toConstrainedNum(0, Number.MAX_VALUE)
    ],
    [
        "keepDetailRowsCount",
        $437b23f6a393c3bf$export$4e35ad424d98ee6.toConstrainedNum(1, Number.MAX_VALUE)
    ],
    [
        "rowBuffer",
        $437b23f6a393c3bf$export$4e35ad424d98ee6.toConstrainedNum(0, Number.MAX_VALUE)
    ],
    [
        "infiniteInitialRowCount",
        $437b23f6a393c3bf$export$4e35ad424d98ee6.toConstrainedNum(1, Number.MAX_VALUE)
    ],
    [
        "cacheOverflowSize",
        $437b23f6a393c3bf$export$4e35ad424d98ee6.toConstrainedNum(1, Number.MAX_VALUE)
    ],
    [
        "cacheBlockSize",
        $437b23f6a393c3bf$export$4e35ad424d98ee6.toConstrainedNum(1, Number.MAX_VALUE)
    ],
    [
        "serverSideInitialRowCount",
        $437b23f6a393c3bf$export$4e35ad424d98ee6.toConstrainedNum(1, Number.MAX_VALUE)
    ],
    [
        "viewportRowModelPageSize",
        $437b23f6a393c3bf$export$4e35ad424d98ee6.toConstrainedNum(1, Number.MAX_VALUE)
    ],
    [
        "viewportRowModelBufferSize",
        $437b23f6a393c3bf$export$4e35ad424d98ee6.toConstrainedNum(0, Number.MAX_VALUE)
    ]
]);
$437b23f6a393c3bf$export$4e35ad424d98ee6.changeSetId = 0;
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("gridOptions")
], $437b23f6a393c3bf$export$4e35ad424d98ee6.prototype, "gridOptions", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("eventService")
], $437b23f6a393c3bf$export$4e35ad424d98ee6.prototype, "eventService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("environment")
], $437b23f6a393c3bf$export$4e35ad424d98ee6.prototype, "environment", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("frameworkOverrides")
], $437b23f6a393c3bf$export$4e35ad424d98ee6.prototype, "frameworkOverrides", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("eGridDiv")
], $437b23f6a393c3bf$export$4e35ad424d98ee6.prototype, "eGridDiv", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("validationService")
], $437b23f6a393c3bf$export$4e35ad424d98ee6.prototype, "validationService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("gridApi")
], $437b23f6a393c3bf$export$4e35ad424d98ee6.prototype, "api", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$export$4e35ad424d98ee6.prototype, "init", 1);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$cc3f3d4529c57d95
], $437b23f6a393c3bf$export$4e35ad424d98ee6.prototype, "destroy", 1);
$437b23f6a393c3bf$export$4e35ad424d98ee6 = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("gridOptionsService")
], $437b23f6a393c3bf$export$4e35ad424d98ee6);
// community-modules/core/src/localeService.ts
var $437b23f6a393c3bf$export$f325e19d05d9c36d = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    getLocaleTextFunc() {
        const getLocaleText = this.gos.getCallback("getLocaleText");
        if (getLocaleText) return (key, defaultValue, variableValues)=>{
            const params = {
                key: key,
                defaultValue: defaultValue,
                variableValues: variableValues
            };
            return getLocaleText(params);
        };
        const localeText = this.gos.get("localeText");
        return (key, defaultValue, variableValues)=>{
            let localisedText = localeText && localeText[key];
            if (localisedText && variableValues && variableValues.length) {
                let found = 0;
                while(true){
                    if (found >= variableValues.length) break;
                    const idx = localisedText.indexOf("${variable}");
                    if (idx === -1) break;
                    localisedText = localisedText.replace("${variable}", variableValues[found++]);
                }
            }
            return localisedText != null ? localisedText : defaultValue;
        };
    }
};
$437b23f6a393c3bf$export$f325e19d05d9c36d = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("localeService")
], $437b23f6a393c3bf$export$f325e19d05d9c36d);
// community-modules/core/src/gridBodyComp/fakeVScrollComp.ts
var $437b23f6a393c3bf$var$_FakeVScrollComp = class _FakeVScrollComp extends $437b23f6a393c3bf$var$AbstractFakeScrollComp {
    constructor(){
        super(_FakeVScrollComp.TEMPLATE, "vertical");
    }
    postConstruct() {
        super.postConstruct();
        this.createManagedBean(new $437b23f6a393c3bf$var$SetHeightFeature(this.eContainer));
        this.ctrlsService.register("fakeVScrollComp", this);
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_CONTAINER_HEIGHT_CHANGED, this.onRowContainerHeightChanged.bind(this));
    }
    setScrollVisible() {
        const vScrollShowing = this.scrollVisibleService.isVerticalScrollShowing();
        const invisibleScrollbar2 = this.invisibleScrollbar;
        const scrollbarWidth = vScrollShowing ? this.gos.getScrollbarWidth() || 0 : 0;
        const adjustedScrollbarWidth = scrollbarWidth === 0 && invisibleScrollbar2 ? 16 : scrollbarWidth;
        this.addOrRemoveCssClass("ag-scrollbar-invisible", invisibleScrollbar2);
        $437b23f6a393c3bf$var$setFixedWidth(this.getGui(), adjustedScrollbarWidth);
        $437b23f6a393c3bf$var$setFixedWidth(this.eViewport, adjustedScrollbarWidth);
        $437b23f6a393c3bf$var$setFixedWidth(this.eContainer, adjustedScrollbarWidth);
        this.setDisplayed(vScrollShowing, {
            skipAriaHidden: true
        });
    }
    onRowContainerHeightChanged() {
        const { ctrlsService: ctrlsService } = this;
        const gridBodyCtrl = ctrlsService.getGridBodyCtrl();
        const gridBodyViewportEl = gridBodyCtrl.getBodyViewportElement();
        const eViewportScrollTop = this.getScrollPosition();
        const gridBodyViewportScrollTop = gridBodyViewportEl.scrollTop;
        if (eViewportScrollTop != gridBodyViewportScrollTop) this.setScrollPosition(gridBodyViewportScrollTop, true);
    }
    getScrollPosition() {
        return this.getViewport().scrollTop;
    }
    setScrollPosition(value, force) {
        if (!force && !$437b23f6a393c3bf$var$isVisible(this.getViewport())) this.attemptSettingScrollPosition(value);
        this.getViewport().scrollTop = value;
    }
};
$437b23f6a393c3bf$var$_FakeVScrollComp.TEMPLATE = /* html */ `<div class="ag-body-vertical-scroll" aria-hidden="true">
            <div class="ag-body-vertical-scroll-viewport" ref="eViewport">
                <div class="ag-body-vertical-scroll-container" ref="eContainer"></div>
            </div>
        </div>`;
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$_FakeVScrollComp.prototype, "postConstruct", 1);
var $437b23f6a393c3bf$var$FakeVScrollComp = $437b23f6a393c3bf$var$_FakeVScrollComp;
// community-modules/core/src/columns/dataTypeService.ts
var $437b23f6a393c3bf$var$MONTH_LOCALE_TEXT = {
    january: "January",
    february: "February",
    march: "March",
    april: "April",
    may: "May",
    june: "June",
    july: "July",
    august: "August",
    september: "September",
    october: "October",
    november: "November",
    december: "December"
};
var $437b23f6a393c3bf$var$MONTH_KEYS = [
    "january",
    "february",
    "march",
    "april",
    "may",
    "june",
    "july",
    "august",
    "september",
    "october",
    "november",
    "december"
];
var $437b23f6a393c3bf$export$167d98081c349dc = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.dataTypeDefinitions = {};
        this.isWaitingForRowData = false;
        this.isColumnTypeOverrideInDataTypeDefinitions = false;
        // keep track of any column state updates whilst waiting for data types to be inferred
        this.columnStateUpdatesPendingInference = {};
        this.columnStateUpdateListenerDestroyFuncs = [];
    }
    init() {
        this.groupHideOpenParents = this.gos.get("groupHideOpenParents");
        this.addManagedPropertyListener("groupHideOpenParents", ()=>{
            this.groupHideOpenParents = this.gos.get("groupHideOpenParents");
        });
        this.processDataTypeDefinitions();
        this.addManagedPropertyListener("dataTypeDefinitions", (event)=>{
            this.processDataTypeDefinitions();
            this.columnModel.recreateColumnDefs($437b23f6a393c3bf$var$convertSourceType(event.source));
        });
    }
    processDataTypeDefinitions() {
        var _a;
        const defaultDataTypes = this.getDefaultDataTypes();
        this.dataTypeDefinitions = {};
        Object.entries(defaultDataTypes).forEach(([cellDataType, dataTypeDefinition])=>{
            this.dataTypeDefinitions[cellDataType] = $437b23f6a393c3bf$var$__spreadProps($437b23f6a393c3bf$var$__spreadValues({}, dataTypeDefinition), {
                groupSafeValueFormatter: this.createGroupSafeValueFormatter(dataTypeDefinition)
            });
        });
        const dataTypeDefinitions = (_a = this.gos.get("dataTypeDefinitions")) != null ? _a : {};
        this.dataTypeMatchers = {};
        Object.entries(dataTypeDefinitions).forEach(([cellDataType, dataTypeDefinition])=>{
            const mergedDataTypeDefinition = this.processDataTypeDefinition(dataTypeDefinition, dataTypeDefinitions, [
                cellDataType
            ], defaultDataTypes);
            if (mergedDataTypeDefinition) {
                this.dataTypeDefinitions[cellDataType] = mergedDataTypeDefinition;
                if (dataTypeDefinition.dataTypeMatcher) this.dataTypeMatchers[cellDataType] = dataTypeDefinition.dataTypeMatcher;
            }
        });
        this.checkObjectValueHandlers(defaultDataTypes);
        [
            "dateString",
            "text",
            "number",
            "boolean",
            "date"
        ].forEach((cellDataType)=>{
            const overriddenDataTypeMatcher = this.dataTypeMatchers[cellDataType];
            if (overriddenDataTypeMatcher) delete this.dataTypeMatchers[cellDataType];
            this.dataTypeMatchers[cellDataType] = overriddenDataTypeMatcher != null ? overriddenDataTypeMatcher : defaultDataTypes[cellDataType].dataTypeMatcher;
        });
    }
    mergeDataTypeDefinitions(parentDataTypeDefinition, childDataTypeDefinition) {
        const mergedDataTypeDefinition = $437b23f6a393c3bf$var$__spreadValues($437b23f6a393c3bf$var$__spreadValues({}, parentDataTypeDefinition), childDataTypeDefinition);
        if (parentDataTypeDefinition.columnTypes && childDataTypeDefinition.columnTypes && childDataTypeDefinition.appendColumnTypes) mergedDataTypeDefinition.columnTypes = [
            ...this.convertColumnTypes(parentDataTypeDefinition.columnTypes),
            ...this.convertColumnTypes(childDataTypeDefinition.columnTypes)
        ];
        return mergedDataTypeDefinition;
    }
    processDataTypeDefinition(dataTypeDefinition, dataTypeDefinitions, alreadyProcessedDataTypes, defaultDataTypes) {
        let mergedDataTypeDefinition;
        const extendsCellDataType = dataTypeDefinition.extendsDataType;
        if (dataTypeDefinition.columnTypes) this.isColumnTypeOverrideInDataTypeDefinitions = true;
        if (dataTypeDefinition.extendsDataType === dataTypeDefinition.baseDataType) {
            let baseDataTypeDefinition = defaultDataTypes[extendsCellDataType];
            const overriddenBaseDataTypeDefinition = dataTypeDefinitions[extendsCellDataType];
            if (baseDataTypeDefinition && overriddenBaseDataTypeDefinition) baseDataTypeDefinition = overriddenBaseDataTypeDefinition;
            if (!this.validateDataTypeDefinition(dataTypeDefinition, baseDataTypeDefinition, extendsCellDataType)) return void 0;
            mergedDataTypeDefinition = this.mergeDataTypeDefinitions(baseDataTypeDefinition, dataTypeDefinition);
        } else {
            if (alreadyProcessedDataTypes.includes(extendsCellDataType)) {
                $437b23f6a393c3bf$var$warnOnce('Data type definition hierarchies (via the "extendsDataType" property) cannot contain circular references.');
                return void 0;
            }
            const extendedDataTypeDefinition = dataTypeDefinitions[extendsCellDataType];
            if (!this.validateDataTypeDefinition(dataTypeDefinition, extendedDataTypeDefinition, extendsCellDataType)) return void 0;
            const mergedExtendedDataTypeDefinition = this.processDataTypeDefinition(extendedDataTypeDefinition, dataTypeDefinitions, [
                ...alreadyProcessedDataTypes,
                extendsCellDataType
            ], defaultDataTypes);
            if (!mergedExtendedDataTypeDefinition) return void 0;
            mergedDataTypeDefinition = this.mergeDataTypeDefinitions(mergedExtendedDataTypeDefinition, dataTypeDefinition);
        }
        return $437b23f6a393c3bf$var$__spreadProps($437b23f6a393c3bf$var$__spreadValues({}, mergedDataTypeDefinition), {
            groupSafeValueFormatter: this.createGroupSafeValueFormatter(mergedDataTypeDefinition)
        });
    }
    validateDataTypeDefinition(dataTypeDefinition, parentDataTypeDefinition, parentCellDataType) {
        if (!parentDataTypeDefinition) {
            $437b23f6a393c3bf$var$warnOnce(`The data type definition ${parentCellDataType} does not exist.`);
            return false;
        }
        if (parentDataTypeDefinition.baseDataType !== dataTypeDefinition.baseDataType) {
            $437b23f6a393c3bf$var$warnOnce('The "baseDataType" property of a data type definition must match that of its parent.');
            return false;
        }
        return true;
    }
    createGroupSafeValueFormatter(dataTypeDefinition) {
        if (!dataTypeDefinition.valueFormatter) return void 0;
        return (params)=>{
            var _a, _b;
            if ((_a = params.node) == null ? void 0 : _a.group) {
                const aggFunc = params.column.getAggFunc();
                if (aggFunc) {
                    if (aggFunc === "first" || aggFunc === "last") return dataTypeDefinition.valueFormatter(params);
                    if (dataTypeDefinition.baseDataType === "number" && aggFunc !== "count") {
                        if (typeof params.value === "number") return dataTypeDefinition.valueFormatter(params);
                        if (typeof params.value === "object") {
                            if (!params.value) return void 0;
                            if ("toNumber" in params.value) return dataTypeDefinition.valueFormatter($437b23f6a393c3bf$var$__spreadProps($437b23f6a393c3bf$var$__spreadValues({}, params), {
                                value: params.value.toNumber()
                            }));
                            if ("value" in params.value) return dataTypeDefinition.valueFormatter($437b23f6a393c3bf$var$__spreadProps($437b23f6a393c3bf$var$__spreadValues({}, params), {
                                value: params.value.value
                            }));
                        }
                    }
                }
                if (!this.gos.get("suppressGroupMaintainValueType")) return void 0;
            } else if (this.groupHideOpenParents && params.column.isRowGroupActive()) {
                if (typeof params.value !== "string" || ((_b = dataTypeDefinition.dataTypeMatcher) == null ? void 0 : _b.call(dataTypeDefinition, params.value))) return dataTypeDefinition.valueFormatter(params);
                if (!this.gos.get("suppressGroupMaintainValueType")) return void 0;
            }
            return dataTypeDefinition.valueFormatter(params);
        };
    }
    updateColDefAndGetDataTypeDefinitionColumnType(colDef, userColDef, colId) {
        let { cellDataType: cellDataType } = userColDef;
        const { field: field } = userColDef;
        if (cellDataType === void 0) cellDataType = colDef.cellDataType;
        if (cellDataType == null || cellDataType === true) cellDataType = this.canInferCellDataType(colDef, userColDef) ? this.inferCellDataType(field, colId) : false;
        if (!cellDataType) {
            colDef.cellDataType = false;
            return void 0;
        }
        const dataTypeDefinition = this.dataTypeDefinitions[cellDataType];
        if (!dataTypeDefinition) {
            $437b23f6a393c3bf$var$warnOnce(`Missing data type definition - "${cellDataType}"`);
            return void 0;
        }
        colDef.cellDataType = cellDataType;
        if (dataTypeDefinition.groupSafeValueFormatter) colDef.valueFormatter = dataTypeDefinition.groupSafeValueFormatter;
        if (dataTypeDefinition.valueParser) colDef.valueParser = dataTypeDefinition.valueParser;
        if (!dataTypeDefinition.suppressDefaultProperties) this.setColDefPropertiesForBaseDataType(colDef, dataTypeDefinition, colId);
        return dataTypeDefinition.columnTypes;
    }
    updateColDefAndGetColumnType(colDef, userColDef, colId) {
        var _a, _b;
        const dataTypeDefinitionColumnType = this.updateColDefAndGetDataTypeDefinitionColumnType(colDef, userColDef, colId);
        const columnTypes = (_b = (_a = userColDef.type) != null ? _a : dataTypeDefinitionColumnType) != null ? _b : colDef.type;
        colDef.type = columnTypes;
        return columnTypes ? this.convertColumnTypes(columnTypes) : void 0;
    }
    addColumnListeners(column) {
        if (!this.isWaitingForRowData) return;
        const columnStateUpdates = this.columnStateUpdatesPendingInference[column.getColId()];
        if (!columnStateUpdates) return;
        const columnListener = (event)=>{
            columnStateUpdates.add(event.key);
        };
        column.addEventListener($437b23f6a393c3bf$export$816b5d811295e6bc.EVENT_STATE_UPDATED, columnListener);
        this.columnStateUpdateListenerDestroyFuncs.push(()=>column.removeEventListener($437b23f6a393c3bf$export$816b5d811295e6bc.EVENT_STATE_UPDATED, columnListener));
    }
    canInferCellDataType(colDef, userColDef) {
        var _a;
        if (this.rowModel.getType() !== "clientSide") return false;
        const propsToCheckForInference = {
            cellRenderer: true,
            valueGetter: true,
            valueParser: true,
            refData: true
        };
        if (this.doColDefPropsPreventInference(userColDef, propsToCheckForInference)) return false;
        const columnTypes = userColDef.type === null ? colDef.type : userColDef.type;
        if (columnTypes) {
            const columnTypeDefs = (_a = this.gos.get("columnTypes")) != null ? _a : {};
            const hasPropsPreventingInference = this.convertColumnTypes(columnTypes).some((columnType)=>{
                const columnTypeDef = columnTypeDefs[columnType.trim()];
                return columnTypeDef && this.doColDefPropsPreventInference(columnTypeDef, propsToCheckForInference);
            });
            if (hasPropsPreventingInference) return false;
        }
        return !this.doColDefPropsPreventInference(colDef, propsToCheckForInference);
    }
    doColDefPropsPreventInference(colDef, propsToCheckForInference) {
        return [
            [
                "cellRenderer",
                "agSparklineCellRenderer"
            ],
            [
                "valueGetter",
                void 0
            ],
            [
                "valueParser",
                void 0
            ],
            [
                "refData",
                void 0
            ]
        ].some(([prop, comparisonValue])=>this.doesColDefPropPreventInference(colDef, propsToCheckForInference, prop, comparisonValue));
    }
    doesColDefPropPreventInference(colDef, checkProps, prop, comparisonValue) {
        if (!checkProps[prop]) return false;
        const value = colDef[prop];
        if (value === null) {
            checkProps[prop] = false;
            return false;
        } else return comparisonValue === void 0 ? !!value : value === comparisonValue;
    }
    inferCellDataType(field, colId) {
        var _a;
        if (!field) return void 0;
        let value;
        const initialData = this.getInitialData();
        if (initialData) {
            const fieldContainsDots = field.indexOf(".") >= 0 && !this.gos.get("suppressFieldDotNotation");
            value = $437b23f6a393c3bf$var$getValueUsingField(initialData, field, fieldContainsDots);
        } else this.initWaitForRowData(colId);
        if (value == null) return void 0;
        const [cellDataType] = (_a = Object.entries(this.dataTypeMatchers).find(([_cellDataType, dataTypeMatcher])=>dataTypeMatcher(value))) != null ? _a : [
            "object"
        ];
        return cellDataType;
    }
    getInitialData() {
        const rowData = this.gos.get("rowData");
        if (rowData == null ? void 0 : rowData.length) return rowData[0];
        else if (this.initialData) return this.initialData;
        else {
            const rowNodes = this.rowModel.getRootNode().allLeafChildren;
            if (rowNodes == null ? void 0 : rowNodes.length) return rowNodes[0].data;
        }
        return null;
    }
    initWaitForRowData(colId) {
        this.columnStateUpdatesPendingInference[colId] = /* @__PURE__ */ new Set();
        if (this.isWaitingForRowData) return;
        this.isWaitingForRowData = true;
        const columnTypeOverridesExist = this.isColumnTypeOverrideInDataTypeDefinitions;
        if (columnTypeOverridesExist) this.columnModel.queueResizeOperations();
        const destroyFunc = this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_DATA_UPDATE_STARTED, (event)=>{
            const { firstRowData: firstRowData } = event;
            if (!firstRowData) return;
            destroyFunc == null || destroyFunc();
            this.isWaitingForRowData = false;
            this.processColumnsPendingInference(firstRowData, columnTypeOverridesExist);
            this.columnStateUpdatesPendingInference = {};
            if (columnTypeOverridesExist) this.columnModel.processResizeOperations();
            const dataTypesInferredEvent = {
                type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_DATA_TYPES_INFERRED
            };
            this.eventService.dispatchEvent(dataTypesInferredEvent);
        });
    }
    isPendingInference() {
        return this.isWaitingForRowData;
    }
    processColumnsPendingInference(firstRowData, columnTypeOverridesExist) {
        this.initialData = firstRowData;
        const state = [];
        this.columnStateUpdateListenerDestroyFuncs.forEach((destroyFunc)=>destroyFunc());
        this.columnStateUpdateListenerDestroyFuncs = [];
        const newRowGroupColumnStateWithoutIndex = {};
        const newPivotColumnStateWithoutIndex = {};
        Object.entries(this.columnStateUpdatesPendingInference).forEach(([colId, columnStateUpdates])=>{
            const column = this.columnModel.getGridColumn(colId);
            if (!column) return;
            const oldColDef = column.getColDef();
            if (!this.columnModel.resetColumnDefIntoColumn(column, "cellDataTypeInferred")) return;
            const newColDef = column.getColDef();
            if (columnTypeOverridesExist && newColDef.type && newColDef.type !== oldColDef.type) {
                const updatedColumnState = this.getUpdatedColumnState(column, columnStateUpdates);
                if (updatedColumnState.rowGroup && updatedColumnState.rowGroupIndex == null) newRowGroupColumnStateWithoutIndex[colId] = updatedColumnState;
                if (updatedColumnState.pivot && updatedColumnState.pivotIndex == null) newPivotColumnStateWithoutIndex[colId] = updatedColumnState;
                state.push(updatedColumnState);
            }
        });
        if (columnTypeOverridesExist) state.push(...this.columnModel.generateColumnStateForRowGroupAndPivotIndexes(newRowGroupColumnStateWithoutIndex, newPivotColumnStateWithoutIndex));
        if (state.length) this.columnModel.applyColumnState({
            state: state
        }, "cellDataTypeInferred");
        this.initialData = null;
    }
    getUpdatedColumnState(column, columnStateUpdates) {
        const columnState = this.columnModel.getColumnStateFromColDef(column);
        columnStateUpdates.forEach((key)=>{
            delete columnState[key];
            if (key === "rowGroup") delete columnState.rowGroupIndex;
            else if (key === "pivot") delete columnState.pivotIndex;
        });
        return columnState;
    }
    checkObjectValueHandlers(defaultDataTypes) {
        const resolvedObjectDataTypeDefinition = this.dataTypeDefinitions.object;
        const defaultObjectDataTypeDefinition = defaultDataTypes.object;
        this.hasObjectValueParser = resolvedObjectDataTypeDefinition.valueParser !== defaultObjectDataTypeDefinition.valueParser;
        this.hasObjectValueFormatter = resolvedObjectDataTypeDefinition.valueFormatter !== defaultObjectDataTypeDefinition.valueFormatter;
    }
    convertColumnTypes(type) {
        let typeKeys = [];
        if (type instanceof Array) {
            const invalidArray = type.some((a)=>typeof a !== "string");
            if (invalidArray) console.warn("if colDef.type is supplied an array it should be of type 'string[]'");
            else typeKeys = type;
        } else if (typeof type === "string") typeKeys = type.split(",");
        else console.warn("colDef.type should be of type 'string' | 'string[]'");
        return typeKeys;
    }
    getDateStringTypeDefinition(column) {
        var _a;
        if (!column) return this.dataTypeDefinitions.dateString;
        return (_a = this.getDataTypeDefinition(column)) != null ? _a : this.dataTypeDefinitions.dateString;
    }
    getDateParserFunction(column) {
        return this.getDateStringTypeDefinition(column).dateParser;
    }
    getDateFormatterFunction(column) {
        return this.getDateStringTypeDefinition(column).dateFormatter;
    }
    getDataTypeDefinition(column) {
        const colDef = column.getColDef();
        if (!colDef.cellDataType) return void 0;
        return this.dataTypeDefinitions[colDef.cellDataType];
    }
    getBaseDataType(column) {
        var _a;
        return (_a = this.getDataTypeDefinition(column)) == null ? void 0 : _a.baseDataType;
    }
    checkType(column, value) {
        var _a;
        if (value == null) return true;
        const dataTypeMatcher = (_a = this.getDataTypeDefinition(column)) == null ? void 0 : _a.dataTypeMatcher;
        if (!dataTypeMatcher) return true;
        return dataTypeMatcher(value);
    }
    validateColDef(colDef) {
        if (colDef.cellDataType === "object") {
            if (colDef.valueFormatter === this.dataTypeDefinitions.object.groupSafeValueFormatter && !this.hasObjectValueFormatter) $437b23f6a393c3bf$var$warnOnce('Cell data type is "object" but no value formatter has been provided. Please either provide an object data type definition with a value formatter, or set "colDef.valueFormatter"');
            if (colDef.editable && colDef.valueParser === this.dataTypeDefinitions.object.valueParser && !this.hasObjectValueParser) $437b23f6a393c3bf$var$warnOnce('Cell data type is "object" but no value parser has been provided. Please either provide an object data type definition with a value parser, or set "colDef.valueParser"');
        }
    }
    setColDefPropertiesForBaseDataType(colDef, dataTypeDefinition, colId) {
        const formatValue = (column, node, value)=>{
            let valueFormatter = column.getColDef().valueFormatter;
            if (valueFormatter === dataTypeDefinition.groupSafeValueFormatter) valueFormatter = dataTypeDefinition.valueFormatter;
            return this.valueService.formatValue(column, node, value, valueFormatter);
        };
        const usingSetFilter = $437b23f6a393c3bf$export$dc053975cc7f6c11.__isRegistered("@ag-grid-enterprise/set-filter" /* SetFilterModule */ , this.context.getGridId());
        const translate = this.localeService.getLocaleTextFunc();
        const mergeFilterParams = (params)=>{
            const { filterParams: filterParams } = colDef;
            colDef.filterParams = typeof filterParams === "object" ? $437b23f6a393c3bf$var$__spreadValues($437b23f6a393c3bf$var$__spreadValues({}, filterParams), params) : params;
        };
        switch(dataTypeDefinition.baseDataType){
            case "number":
                colDef.cellEditor = "agNumberCellEditor";
                if (usingSetFilter) mergeFilterParams({
                    comparator: (a, b)=>{
                        const valA = a == null ? 0 : parseInt(a);
                        const valB = b == null ? 0 : parseInt(b);
                        if (valA === valB) return 0;
                        return valA > valB ? 1 : -1;
                    }
                });
                break;
            case "boolean":
                colDef.cellEditor = "agCheckboxCellEditor";
                colDef.cellRenderer = "agCheckboxCellRenderer";
                colDef.suppressKeyboardEvent = (params)=>!!params.colDef.editable && params.event.key === $437b23f6a393c3bf$export$e9e0d96f49f57c33.SPACE;
                if (usingSetFilter) mergeFilterParams({
                    valueFormatter: (params)=>{
                        if (!$437b23f6a393c3bf$var$exists(params.value)) return translate("blanks", "(Blanks)");
                        return translate(String(params.value), params.value ? "True" : "False");
                    }
                });
                else mergeFilterParams({
                    maxNumConditions: 1,
                    debounceMs: 0,
                    filterOptions: [
                        "empty",
                        {
                            displayKey: "true",
                            displayName: "True",
                            predicate: (_filterValues, cellValue)=>cellValue,
                            numberOfInputs: 0
                        },
                        {
                            displayKey: "false",
                            displayName: "False",
                            predicate: (_filterValues, cellValue)=>cellValue === false,
                            numberOfInputs: 0
                        }
                    ]
                });
                break;
            case "date":
                colDef.cellEditor = "agDateCellEditor";
                colDef.keyCreator = (params)=>formatValue(params.column, params.node, params.value);
                if (usingSetFilter) mergeFilterParams({
                    valueFormatter: (params)=>{
                        const valueFormatted = formatValue(params.column, params.node, params.value);
                        return $437b23f6a393c3bf$var$exists(valueFormatted) ? valueFormatted : translate("blanks", "(Blanks)");
                    },
                    treeList: true,
                    treeListFormatter: (pathKey, level)=>{
                        if (level === 1 && pathKey != null) {
                            const monthKey = $437b23f6a393c3bf$var$MONTH_KEYS[Number(pathKey) - 1];
                            return translate(monthKey, $437b23f6a393c3bf$var$MONTH_LOCALE_TEXT[monthKey]);
                        }
                        return pathKey != null ? pathKey : translate("blanks", "(Blanks)");
                    }
                });
                break;
            case "dateString":
                {
                    colDef.cellEditor = "agDateStringCellEditor";
                    colDef.keyCreator = (params)=>formatValue(params.column, params.node, params.value);
                    const convertToDate = dataTypeDefinition.dateParser;
                    if (usingSetFilter) mergeFilterParams({
                        valueFormatter: (params)=>{
                            const valueFormatted = formatValue(params.column, params.node, params.value);
                            return $437b23f6a393c3bf$var$exists(valueFormatted) ? valueFormatted : translate("blanks", "(Blanks)");
                        },
                        treeList: true,
                        treeListPathGetter: (value)=>{
                            const date = convertToDate(value != null ? value : void 0);
                            return date ? [
                                String(date.getFullYear()),
                                String(date.getMonth() + 1),
                                String(date.getDate())
                            ] : null;
                        },
                        treeListFormatter: (pathKey, level)=>{
                            if (level === 1 && pathKey != null) {
                                const monthKey = $437b23f6a393c3bf$var$MONTH_KEYS[Number(pathKey) - 1];
                                return translate(monthKey, $437b23f6a393c3bf$var$MONTH_LOCALE_TEXT[monthKey]);
                            }
                            return pathKey != null ? pathKey : translate("blanks", "(Blanks)");
                        }
                    });
                    else mergeFilterParams({
                        comparator: (filterDate, cellValue)=>{
                            const cellAsDate = convertToDate(cellValue);
                            if (cellValue == null || cellAsDate < filterDate) return -1;
                            if (cellAsDate > filterDate) return 1;
                            return 0;
                        }
                    });
                    break;
                }
            case "object":
                colDef.cellEditorParams = {
                    useFormatter: true
                };
                colDef.comparator = (a, b)=>{
                    const column = this.columnModel.getPrimaryColumn(colId);
                    const colDef2 = column == null ? void 0 : column.getColDef();
                    if (!column || !colDef2) return 0;
                    const valA = a == null ? "" : formatValue(column, null, a);
                    const valB = b == null ? "" : formatValue(column, null, b);
                    if (valA === valB) return 0;
                    return valA > valB ? 1 : -1;
                };
                colDef.keyCreator = (params)=>formatValue(params.column, params.node, params.value);
                if (usingSetFilter) mergeFilterParams({
                    valueFormatter: (params)=>{
                        const valueFormatted = formatValue(params.column, params.node, params.value);
                        return $437b23f6a393c3bf$var$exists(valueFormatted) ? valueFormatted : translate("blanks", "(Blanks)");
                    }
                });
                else colDef.filterValueGetter = (params)=>formatValue(params.column, params.node, this.valueService.getValue(params.column, params.node));
                break;
        }
    }
    getDefaultDataTypes() {
        const defaultDateFormatMatcher = (value)=>!!value.match("^\\d{4}-\\d{2}-\\d{2}$");
        const translate = this.localeService.getLocaleTextFunc();
        return {
            number: {
                baseDataType: "number",
                // can be empty space with legacy copy
                valueParser: (params)=>{
                    var _a, _b;
                    return ((_b = (_a = params.newValue) == null ? void 0 : _a.trim) == null ? void 0 : _b.call(_a)) === "" ? null : Number(params.newValue);
                },
                valueFormatter: (params)=>{
                    if (params.value == null) return "";
                    if (typeof params.value !== "number" || isNaN(params.value)) return translate("invalidNumber", "Invalid Number");
                    return String(params.value);
                },
                dataTypeMatcher: (value)=>typeof value === "number"
            },
            text: {
                baseDataType: "text",
                valueParser: (params)=>params.newValue === "" ? null : $437b23f6a393c3bf$var$toStringOrNull(params.newValue),
                dataTypeMatcher: (value)=>typeof value === "string"
            },
            boolean: {
                baseDataType: "boolean",
                valueParser: (params)=>{
                    var _a, _b;
                    if (params.newValue == null) return params.newValue;
                    return ((_b = (_a = params.newValue) == null ? void 0 : _a.trim) == null ? void 0 : _b.call(_a)) === "" ? null : String(params.newValue).toLowerCase() === "true";
                },
                valueFormatter: (params)=>params.value == null ? "" : String(params.value),
                dataTypeMatcher: (value)=>typeof value === "boolean"
            },
            date: {
                baseDataType: "date",
                valueParser: (params)=>$437b23f6a393c3bf$var$parseDateTimeFromString(params.newValue == null ? null : String(params.newValue)),
                valueFormatter: (params)=>{
                    var _a;
                    if (params.value == null) return "";
                    if (!(params.value instanceof Date) || isNaN(params.value.getTime())) return translate("invalidDate", "Invalid Date");
                    return (_a = $437b23f6a393c3bf$var$serialiseDate(params.value, false)) != null ? _a : "";
                },
                dataTypeMatcher: (value)=>value instanceof Date
            },
            dateString: {
                baseDataType: "dateString",
                dateParser: (value)=>{
                    var _a;
                    return (_a = $437b23f6a393c3bf$var$parseDateTimeFromString(value)) != null ? _a : void 0;
                },
                dateFormatter: (value)=>{
                    var _a;
                    return (_a = $437b23f6a393c3bf$var$serialiseDate(value != null ? value : null, false)) != null ? _a : void 0;
                },
                valueParser: (params)=>defaultDateFormatMatcher(String(params.newValue)) ? params.newValue : null,
                valueFormatter: (params)=>defaultDateFormatMatcher(String(params.value)) ? params.value : "",
                dataTypeMatcher: (value)=>typeof value === "string" && defaultDateFormatMatcher(value)
            },
            object: {
                baseDataType: "object",
                valueParser: ()=>null,
                valueFormatter: (params)=>{
                    var _a;
                    return (_a = $437b23f6a393c3bf$var$toStringOrNull(params.value)) != null ? _a : "";
                }
            }
        };
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowModel")
], $437b23f6a393c3bf$export$167d98081c349dc.prototype, "rowModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnModel")
], $437b23f6a393c3bf$export$167d98081c349dc.prototype, "columnModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("valueService")
], $437b23f6a393c3bf$export$167d98081c349dc.prototype, "valueService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$export$167d98081c349dc.prototype, "init", 1);
$437b23f6a393c3bf$export$167d98081c349dc = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("dataTypeService")
], $437b23f6a393c3bf$export$167d98081c349dc);
// community-modules/core/src/syncService.ts
var $437b23f6a393c3bf$var$SyncService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.waitingForColumns = false;
    }
    postConstruct() {
        this.addManagedPropertyListener("columnDefs", (event)=>this.setColumnDefs(event));
    }
    start() {
        this.ctrlsService.whenReady(()=>{
            const columnDefs = this.gos.get("columnDefs");
            if (columnDefs) this.setColumnsAndData(columnDefs);
            else this.waitingForColumns = true;
            this.gridReady();
        });
    }
    setColumnsAndData(columnDefs) {
        this.columnModel.setColumnDefs(columnDefs != null ? columnDefs : [], "gridInitializing");
        this.rowModel.start();
    }
    gridReady() {
        this.dispatchGridReadyEvent();
        const isEnterprise = $437b23f6a393c3bf$export$dc053975cc7f6c11.__isRegistered("@ag-grid-enterprise/core" /* EnterpriseCoreModule */ , this.context.getGridId());
        const logger = new $437b23f6a393c3bf$export$efa9a398d6368992("AG Grid", ()=>this.gos.get("debug"));
        logger.log(`initialised successfully, enterprise = ${isEnterprise}`);
    }
    dispatchGridReadyEvent() {
        const readyEvent = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_GRID_READY
        };
        this.eventService.dispatchEvent(readyEvent);
    }
    setColumnDefs(event) {
        const columnDefs = this.gos.get("columnDefs");
        if (!columnDefs) return;
        if (this.waitingForColumns) {
            this.waitingForColumns = false;
            this.setColumnsAndData(columnDefs);
            return;
        }
        this.columnModel.setColumnDefs(columnDefs, $437b23f6a393c3bf$var$convertSourceType(event.source));
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("ctrlsService")
], $437b23f6a393c3bf$var$SyncService.prototype, "ctrlsService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnModel")
], $437b23f6a393c3bf$var$SyncService.prototype, "columnModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowModel")
], $437b23f6a393c3bf$var$SyncService.prototype, "rowModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$SyncService.prototype, "postConstruct", 1);
$437b23f6a393c3bf$var$SyncService = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("syncService")
], $437b23f6a393c3bf$var$SyncService);
// community-modules/core/src/rendering/overlays/overlayService.ts
var $437b23f6a393c3bf$var$OverlayService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.manuallyDisplayed = false;
    }
    postConstruct() {
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_DATA_UPDATED, ()=>this.onRowDataUpdated());
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_NEW_COLUMNS_LOADED, ()=>this.onNewColumnsLoaded());
    }
    registerOverlayWrapperComp(overlayWrapperComp) {
        this.overlayWrapperComp = overlayWrapperComp;
        if (!this.gos.get("columnDefs") || this.gos.isRowModelType("clientSide") && !this.gos.get("rowData")) this.showLoadingOverlay();
    }
    showLoadingOverlay() {
        if (this.gos.get("suppressLoadingOverlay")) return;
        const params = {};
        const compDetails = this.userComponentFactory.getLoadingOverlayCompDetails(params);
        this.showOverlay(compDetails, "ag-overlay-loading-wrapper", "loadingOverlayComponentParams");
    }
    showNoRowsOverlay() {
        if (this.gos.get("suppressNoRowsOverlay")) return;
        const params = {};
        const compDetails = this.userComponentFactory.getNoRowsOverlayCompDetails(params);
        this.showOverlay(compDetails, "ag-overlay-no-rows-wrapper", "noRowsOverlayComponentParams");
    }
    showOverlay(compDetails, wrapperCssClass, gridOption) {
        const promise = compDetails.newAgStackInstance();
        const listenerDestroyFunc = this.addManagedPropertyListener(gridOption, ({ currentValue: currentValue })=>{
            promise.then((comp)=>{
                if (comp.refresh) comp.refresh(this.gos.addGridCommonParams($437b23f6a393c3bf$var$__spreadValues({}, currentValue != null ? currentValue : {})));
            });
        });
        this.manuallyDisplayed = this.columnModel.isReady() && !this.paginationProxy.isEmpty();
        this.overlayWrapperComp.showOverlay(promise, wrapperCssClass, listenerDestroyFunc);
    }
    hideOverlay() {
        this.manuallyDisplayed = false;
        this.overlayWrapperComp.hideOverlay();
    }
    showOrHideOverlay() {
        const isEmpty = this.paginationProxy.isEmpty();
        const isSuppressNoRowsOverlay = this.gos.get("suppressNoRowsOverlay");
        if (isEmpty && !isSuppressNoRowsOverlay) this.showNoRowsOverlay();
        else this.hideOverlay();
    }
    onRowDataUpdated() {
        this.showOrHideOverlay();
    }
    onNewColumnsLoaded() {
        if (this.columnModel.isReady() && !this.paginationProxy.isEmpty() && !this.manuallyDisplayed) this.hideOverlay();
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("userComponentFactory")
], $437b23f6a393c3bf$var$OverlayService.prototype, "userComponentFactory", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("paginationProxy")
], $437b23f6a393c3bf$var$OverlayService.prototype, "paginationProxy", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnModel")
], $437b23f6a393c3bf$var$OverlayService.prototype, "columnModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$OverlayService.prototype, "postConstruct", 1);
$437b23f6a393c3bf$var$OverlayService = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("overlayService")
], $437b23f6a393c3bf$var$OverlayService);
// community-modules/core/src/misc/stateService.ts
var $437b23f6a393c3bf$var$StateService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.suppressEvents = true;
        this.queuedUpdateSources = /* @__PURE__ */ new Set();
        this.dispatchStateUpdateEventDebounced = $437b23f6a393c3bf$var$debounce(()=>this.dispatchQueuedStateUpdateEvents(), 0);
        // If user is doing a manual expand all node by node, we don't want to process one at a time.
        // EVENT_ROW_GROUP_OPENED is already async, so no impact of making the state async here.
        this.onRowGroupOpenedDebounced = $437b23f6a393c3bf$var$debounce(()=>this.updateCachedState("rowGroupExpansion", this.getRowGroupExpansionState()), 0);
        // similar to row expansion, want to debounce. However, selection is synchronous, so need to mark as stale in case `getState` is called.
        this.onRowSelectedDebounced = $437b23f6a393c3bf$var$debounce(()=>{
            this.staleStateKeys.delete("rowSelection");
            this.updateCachedState("rowSelection", this.getRowSelectionState());
        }, 0);
        this.staleStateKeys = /* @__PURE__ */ new Set();
    }
    postConstruct() {
        var _a;
        this.isClientSideRowModel = this.rowModel.getType() === "clientSide";
        this.cachedState = (_a = this.gos.get("initialState")) != null ? _a : {};
        this.ctrlsService.whenReady(()=>this.suppressEventsAndDispatchInitEvent(()=>this.setupStateOnGridReady()));
        const newColumnsLoadedDestroyFunc = this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_NEW_COLUMNS_LOADED, ({ source: source })=>{
            if (source === "gridInitializing") {
                newColumnsLoadedDestroyFunc == null || newColumnsLoadedDestroyFunc();
                this.suppressEventsAndDispatchInitEvent(()=>this.setupStateOnColumnsInitialised());
            }
        });
        const rowCountReadyDestroyFunc = this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_COUNT_READY, ()=>{
            rowCountReadyDestroyFunc == null || rowCountReadyDestroyFunc();
            this.suppressEventsAndDispatchInitEvent(()=>this.setupStateOnRowCountReady());
        });
        const firstDataRenderedDestroyFunc = this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_FIRST_DATA_RENDERED, ()=>{
            firstDataRenderedDestroyFunc == null || firstDataRenderedDestroyFunc();
            this.suppressEventsAndDispatchInitEvent(()=>this.setupStateOnFirstDataRendered());
        });
    }
    getState() {
        if (this.staleStateKeys.size) this.refreshStaleState();
        return this.cachedState;
    }
    setupStateOnGridReady() {
        this.updateCachedState("sideBar", this.getSideBarState());
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_TOOL_PANEL_VISIBLE_CHANGED, ()=>this.updateCachedState("sideBar", this.getSideBarState()));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_SIDE_BAR_UPDATED, ()=>this.updateCachedState("sideBar", this.getSideBarState()));
    }
    setupStateOnColumnsInitialised() {
        var _a;
        const initialState = (_a = this.gos.get("initialState")) != null ? _a : {};
        this.setColumnState(initialState);
        this.setColumnGroupState(initialState);
        this.updateColumnState([
            "aggregation",
            "columnOrder",
            "columnPinning",
            "columnSizing",
            "columnVisibility",
            "pivot",
            "pivot",
            "rowGroup",
            "sort"
        ]);
        this.updateCachedState("columnGroup", this.getColumnGroupState());
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_VALUE_CHANGED, ()=>this.updateColumnState([
                "aggregation"
            ]));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_MOVED, ()=>this.updateColumnState([
                "columnOrder"
            ]));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_PINNED, ()=>this.updateColumnState([
                "columnPinning"
            ]));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_RESIZED, ()=>this.updateColumnState([
                "columnSizing"
            ]));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_VISIBLE, ()=>this.updateColumnState([
                "columnVisibility"
            ]));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_PIVOT_CHANGED, ()=>this.updateColumnState([
                "pivot"
            ]));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_PIVOT_MODE_CHANGED, ()=>this.updateColumnState([
                "pivot"
            ]));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_ROW_GROUP_CHANGED, ()=>this.updateColumnState([
                "rowGroup"
            ]));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_SORT_CHANGED, ()=>this.updateColumnState([
                "sort"
            ]));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_NEW_COLUMNS_LOADED, ()=>this.updateColumnState([
                "aggregation",
                "columnOrder",
                "columnPinning",
                "columnSizing",
                "columnVisibility",
                "pivot",
                "pivot",
                "rowGroup",
                "sort"
            ]));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_GROUP_OPENED, ()=>this.updateCachedState("columnGroup", this.getColumnGroupState()));
    }
    setupStateOnRowCountReady() {
        var _a;
        const { filter: filterState, rowGroupExpansion: rowGroupExpansionState, rowSelection: rowSelectionState, pagination: paginationState } = (_a = this.gos.get("initialState")) != null ? _a : {};
        const advancedFilterModel = this.gos.get("advancedFilterModel");
        if (filterState || advancedFilterModel) this.setFilterState(filterState, advancedFilterModel);
        if (rowGroupExpansionState) this.setRowGroupExpansionState(rowGroupExpansionState);
        if (rowSelectionState) this.setRowSelectionState(rowSelectionState);
        if (paginationState) this.setPaginationState(paginationState);
        this.updateCachedState("filter", this.getFilterState());
        this.updateCachedState("rowGroupExpansion", this.getRowGroupExpansionState());
        this.updateCachedState("rowSelection", this.getRowSelectionState());
        this.updateCachedState("pagination", this.getPaginationState());
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_FILTER_CHANGED, ()=>this.updateCachedState("filter", this.getFilterState()));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_GROUP_OPENED, ()=>this.onRowGroupOpenedDebounced());
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_EXPAND_COLLAPSE_ALL, ()=>this.updateCachedState("rowGroupExpansion", this.getRowGroupExpansionState()));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_SELECTION_CHANGED, ()=>{
            this.staleStateKeys.add("rowSelection");
            this.onRowSelectedDebounced();
        });
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_PAGINATION_CHANGED, (event)=>{
            if (event.newPage || event.newPageSize) this.updateCachedState("pagination", this.getPaginationState());
        });
    }
    setupStateOnFirstDataRendered() {
        var _a;
        const { scroll: scrollState, rangeSelection: rangeSelectionState, focusedCell: focusedCellState, columnOrder: columnOrderState } = (_a = this.gos.get("initialState")) != null ? _a : {};
        if (focusedCellState) this.setFocusedCellState(focusedCellState);
        if (rangeSelectionState) this.setRangeSelectionState(rangeSelectionState);
        if (scrollState) this.setScrollState(scrollState);
        this.setColumnPivotState(!!(columnOrderState == null ? void 0 : columnOrderState.orderedColIds));
        this.updateCachedState("sideBar", this.getSideBarState());
        this.updateCachedState("focusedCell", this.getFocusedCellState());
        this.updateCachedState("rangeSelection", this.getRangeSelectionState());
        this.updateCachedState("scroll", this.getScrollState());
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_CELL_FOCUSED, ()=>this.updateCachedState("focusedCell", this.getFocusedCellState()));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_RANGE_SELECTION_CHANGED, (event)=>{
            if (event.finished) this.updateCachedState("rangeSelection", this.getRangeSelectionState());
        });
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_BODY_SCROLL_END, ()=>this.updateCachedState("scroll", this.getScrollState()));
    }
    getColumnState() {
        const pivotMode = this.columnModel.isPivotMode();
        const sortColumns = [];
        const groupColIds = [];
        const aggregationColumns = [];
        const pivotColIds = [];
        const leftColIds = [];
        const rightColIds = [];
        const hiddenColIds = [];
        const columnSizes = [];
        const columns = [];
        const columnState = this.columnModel.getColumnState();
        for(let i = 0; i < columnState.length; i++){
            const { colId: colId, sort: sort, sortIndex: sortIndex, rowGroup: rowGroup, rowGroupIndex: rowGroupIndex, aggFunc: aggFunc, pivot: pivot, pivotIndex: pivotIndex, pinned: pinned, hide: hide, width: width, flex: flex } = columnState[i];
            columns.push(colId);
            if (sort) sortColumns[sortIndex != null ? sortIndex : 0] = {
                colId: colId,
                sort: sort
            };
            if (rowGroup) groupColIds[rowGroupIndex != null ? rowGroupIndex : 0] = colId;
            if (typeof aggFunc === "string") aggregationColumns.push({
                colId: colId,
                aggFunc: aggFunc
            });
            if (pivot) pivotColIds[pivotIndex != null ? pivotIndex : 0] = colId;
            if (pinned) (pinned === "right" ? rightColIds : leftColIds).push(colId);
            if (hide) hiddenColIds.push(colId);
            if (flex || width) columnSizes.push({
                colId: colId,
                flex: flex != null ? flex : void 0,
                width: width
            });
        }
        return {
            sort: sortColumns.length ? {
                sortModel: sortColumns
            } : void 0,
            rowGroup: groupColIds.length ? {
                groupColIds: groupColIds
            } : void 0,
            aggregation: aggregationColumns.length ? {
                aggregationModel: aggregationColumns
            } : void 0,
            pivot: pivotColIds.length || pivotMode ? {
                pivotMode: pivotMode,
                pivotColIds: pivotColIds
            } : void 0,
            columnPinning: leftColIds.length || rightColIds.length ? {
                leftColIds: leftColIds,
                rightColIds: rightColIds
            } : void 0,
            columnVisibility: hiddenColIds.length ? {
                hiddenColIds: hiddenColIds
            } : void 0,
            columnSizing: columnSizes.length ? {
                columnSizingModel: columnSizes
            } : void 0,
            columnOrder: columns.length ? {
                orderedColIds: columns
            } : void 0
        };
    }
    setColumnState(initialState) {
        const { sort: sortState, rowGroup: groupState, aggregation: aggregationState, pivot: pivotState, columnPinning: columnPinningState, columnVisibility: columnVisibilityState, columnSizing: columnSizingState, columnOrder: columnOrderState } = initialState;
        const columnStateMap = {};
        const getColumnState = (colId)=>{
            let columnState = columnStateMap[colId];
            if (columnState) return columnState;
            columnState = {
                colId: colId
            };
            columnStateMap[colId] = columnState;
            return columnState;
        };
        if (sortState) sortState.sortModel.forEach(({ colId: colId, sort: sort }, sortIndex)=>{
            const columnState = getColumnState(colId);
            columnState.sort = sort;
            columnState.sortIndex = sortIndex;
        });
        if (groupState) groupState.groupColIds.forEach((colId, rowGroupIndex)=>{
            const columnState = getColumnState(colId);
            columnState.rowGroup = true;
            columnState.rowGroupIndex = rowGroupIndex;
        });
        if (aggregationState) aggregationState.aggregationModel.forEach(({ colId: colId, aggFunc: aggFunc })=>{
            getColumnState(colId).aggFunc = aggFunc;
        });
        if (pivotState) {
            pivotState.pivotColIds.forEach((colId, pivotIndex)=>{
                const columnState = getColumnState(colId);
                columnState.pivot = true;
                columnState.pivotIndex = pivotIndex;
            });
            this.gos.updateGridOptions({
                options: {
                    pivotMode: pivotState.pivotMode
                },
                source: "gridInitializing"
            });
        }
        if (columnPinningState) {
            columnPinningState.leftColIds.forEach((colId)=>{
                getColumnState(colId).pinned = "left";
            });
            columnPinningState.rightColIds.forEach((colId)=>{
                getColumnState(colId).pinned = "right";
            });
        }
        if (columnVisibilityState) columnVisibilityState.hiddenColIds.forEach((colId)=>{
            getColumnState(colId).hide = true;
        });
        if (columnSizingState) columnSizingState.columnSizingModel.forEach(({ colId: colId, flex: flex, width: width })=>{
            const columnState = getColumnState(colId);
            columnState.flex = flex != null ? flex : null;
            columnState.width = width;
        });
        const columns = columnOrderState == null ? void 0 : columnOrderState.orderedColIds;
        const applyOrder = !!(columns == null ? void 0 : columns.length);
        const columnStates = applyOrder ? columns.map((colId)=>getColumnState(colId)) : Object.values(columnStateMap);
        if (columnStates.length) {
            this.columnStates = columnStates;
            const defaultState = {
                sort: null,
                sortIndex: null,
                rowGroup: null,
                rowGroupIndex: null,
                aggFunc: null,
                pivot: null,
                pivotIndex: null,
                pinned: null,
                hide: null,
                flex: null
            };
            this.columnModel.applyColumnState({
                state: columnStates,
                applyOrder: applyOrder,
                defaultState: defaultState
            }, "gridInitializing");
        }
    }
    setColumnPivotState(applyOrder) {
        const columnStates = this.columnStates;
        this.columnStates = void 0;
        const columnGroupStates = this.columnGroupStates;
        this.columnGroupStates = void 0;
        if (!this.columnModel.isSecondaryColumnsPresent()) return;
        if (columnStates) {
            let secondaryColumnStates = [];
            for (const columnState of columnStates)if (this.columnModel.getSecondaryColumn(columnState.colId)) secondaryColumnStates.push(columnState);
            this.columnModel.applyColumnState({
                state: secondaryColumnStates,
                applyOrder: applyOrder
            }, "gridInitializing");
        }
        if (columnGroupStates) this.columnModel.setColumnGroupState(columnGroupStates, "gridInitializing");
    }
    getColumnGroupState() {
        const columnGroupState = this.columnModel.getColumnGroupState();
        const openColumnGroups = [];
        columnGroupState.forEach(({ groupId: groupId, open: open })=>{
            if (open) openColumnGroups.push(groupId);
        });
        return openColumnGroups.length ? {
            openColumnGroupIds: openColumnGroups
        } : void 0;
    }
    setColumnGroupState(initialState) {
        var _a;
        if (!initialState.hasOwnProperty("columnGroup")) return;
        const openColumnGroups = new Set((_a = initialState.columnGroup) == null ? void 0 : _a.openColumnGroupIds);
        const existingColumnGroupState = this.columnModel.getColumnGroupState();
        const stateItems = existingColumnGroupState.map(({ groupId: groupId })=>{
            const open = openColumnGroups.has(groupId);
            if (open) openColumnGroups.delete(groupId);
            return {
                groupId: groupId,
                open: open
            };
        });
        openColumnGroups.forEach((groupId)=>{
            stateItems.push({
                groupId: groupId,
                open: true
            });
        });
        if (stateItems.length) this.columnGroupStates = stateItems;
        this.columnModel.setColumnGroupState(stateItems, "gridInitializing");
    }
    getFilterState() {
        var _a;
        let filterModel = this.filterManager.getFilterModel();
        if (filterModel && Object.keys(filterModel).length === 0) filterModel = void 0;
        const advancedFilterModel = (_a = this.filterManager.getAdvancedFilterModel()) != null ? _a : void 0;
        return filterModel || advancedFilterModel ? {
            filterModel: filterModel,
            advancedFilterModel: advancedFilterModel
        } : void 0;
    }
    setFilterState(filterState, gridOptionAdvancedFilterModel) {
        const { filterModel: filterModel, advancedFilterModel: advancedFilterModel } = filterState != null ? filterState : {
            advancedFilterModel: gridOptionAdvancedFilterModel
        };
        if (filterModel) this.filterManager.setFilterModel(filterModel, "columnFilter");
        if (advancedFilterModel) this.filterManager.setAdvancedFilterModel(advancedFilterModel);
    }
    getRangeSelectionState() {
        var _a;
        const cellRanges = (_a = this.rangeService) == null ? void 0 : _a.getCellRanges().map((cellRange)=>{
            const { id: id, type: type, startRow: startRow, endRow: endRow, columns: columns, startColumn: startColumn } = cellRange;
            return {
                id: id,
                type: type,
                startRow: startRow,
                endRow: endRow,
                colIds: columns.map((column)=>column.getColId()),
                startColId: startColumn.getColId()
            };
        });
        return (cellRanges == null ? void 0 : cellRanges.length) ? {
            cellRanges: cellRanges
        } : void 0;
    }
    setRangeSelectionState(rangeSelectionState) {
        if (!this.gos.get("enableRangeSelection") || !this.rangeService) return;
        const cellRanges = [];
        rangeSelectionState.cellRanges.forEach((cellRange)=>{
            const columns = [];
            cellRange.colIds.forEach((colId)=>{
                const column = this.columnModel.getGridColumn(colId);
                if (column) columns.push(column);
            });
            if (!columns.length) return;
            let startColumn = this.columnModel.getGridColumn(cellRange.startColId);
            if (!startColumn) {
                const allColumns = this.columnModel.getAllDisplayedColumns();
                const columnSet = new Set(columns);
                startColumn = allColumns.find((column)=>columnSet.has(column));
            }
            cellRanges.push($437b23f6a393c3bf$var$__spreadProps($437b23f6a393c3bf$var$__spreadValues({}, cellRange), {
                columns: columns,
                startColumn: startColumn
            }));
        });
        this.rangeService.setCellRanges(cellRanges);
    }
    getScrollState() {
        var _a, _b, _c;
        if (!this.isClientSideRowModel) return void 0;
        const scrollFeature = (_a = this.ctrlsService.getGridBodyCtrl()) == null ? void 0 : _a.getScrollFeature();
        const { left: left } = (_b = scrollFeature == null ? void 0 : scrollFeature.getHScrollPosition()) != null ? _b : {
            left: 0
        };
        const { top: top } = (_c = scrollFeature == null ? void 0 : scrollFeature.getVScrollPosition()) != null ? _c : {
            top: 0
        };
        return top || left ? {
            top: top,
            left: left
        } : void 0;
    }
    setScrollState(scrollState) {
        var _a;
        if (!this.isClientSideRowModel) return;
        const { top: top, left: left } = scrollState;
        (_a = this.ctrlsService.getGridBodyCtrl()) == null || _a.getScrollFeature().setScrollPosition(top, left);
    }
    getSideBarState() {
        var _a, _b;
        return (_b = (_a = this.sideBarService) == null ? void 0 : _a.getSideBarComp()) == null ? void 0 : _b.getState();
    }
    getFocusedCellState() {
        if (!this.isClientSideRowModel) return void 0;
        const focusedCell = this.focusService.getFocusedCell();
        if (focusedCell) {
            const { column: column, rowIndex: rowIndex, rowPinned: rowPinned } = focusedCell;
            return {
                colId: column.getColId(),
                rowIndex: rowIndex,
                rowPinned: rowPinned
            };
        }
        return void 0;
    }
    setFocusedCellState(focusedCellState) {
        if (!this.isClientSideRowModel) return;
        const { colId: colId, rowIndex: rowIndex, rowPinned: rowPinned } = focusedCellState;
        this.focusService.setFocusedCell({
            column: this.columnModel.getGridColumn(colId),
            rowIndex: rowIndex,
            rowPinned: rowPinned,
            forceBrowserFocus: true,
            preventScrollOnBrowserFocus: true
        });
    }
    getPaginationState() {
        const page = this.paginationProxy.getCurrentPage();
        const pageSize = !this.gos.get("paginationAutoPageSize") ? this.paginationProxy.getPageSize() : void 0;
        if (!page && !pageSize) return;
        return {
            page: page,
            pageSize: pageSize
        };
    }
    setPaginationState(paginationState) {
        if (paginationState.pageSize && !this.gos.get("paginationAutoPageSize")) this.paginationProxy.setPageSize(paginationState.pageSize, "initialState");
        if (typeof paginationState.page === "number") this.paginationProxy.setPage(paginationState.page);
    }
    getRowSelectionState() {
        var _a;
        const selectionState = this.selectionService.getSelectionState();
        const noSelections = !selectionState || !Array.isArray(selectionState) && (selectionState.selectAll === false || selectionState.selectAllChildren === false) && !((_a = selectionState == null ? void 0 : selectionState.toggledNodes) == null ? void 0 : _a.length);
        return noSelections ? void 0 : selectionState;
    }
    setRowSelectionState(rowSelectionState) {
        this.selectionService.setSelectionState(rowSelectionState, "gridInitializing");
    }
    getRowGroupExpansionState() {
        const expandedRowGroups = this.expansionService.getExpandedRows();
        return expandedRowGroups.length ? {
            expandedRowGroupIds: expandedRowGroups
        } : void 0;
    }
    setRowGroupExpansionState(rowGroupExpansionState) {
        this.expansionService.expandRows(rowGroupExpansionState.expandedRowGroupIds);
    }
    updateColumnState(features) {
        const newColumnState = this.getColumnState();
        let hasChanged = false;
        Object.entries(newColumnState).forEach(([key, value])=>{
            if (!$437b23f6a393c3bf$var$jsonEquals(value, this.cachedState[key])) hasChanged = true;
        });
        this.cachedState = $437b23f6a393c3bf$var$__spreadValues($437b23f6a393c3bf$var$__spreadValues({}, this.cachedState), newColumnState);
        if (hasChanged) this.dispatchStateUpdateEvent(features);
    }
    updateCachedState(key, value) {
        const existingValue = this.cachedState[key];
        this.setCachedStateValue(key, value);
        if (!$437b23f6a393c3bf$var$jsonEquals(value, existingValue)) this.dispatchStateUpdateEvent([
            key
        ]);
    }
    setCachedStateValue(key, value) {
        this.cachedState = $437b23f6a393c3bf$var$__spreadProps($437b23f6a393c3bf$var$__spreadValues({}, this.cachedState), {
            [key]: value
        });
    }
    refreshStaleState() {
        this.staleStateKeys.forEach((key)=>{
            switch(key){
                case "rowSelection":
                    this.setCachedStateValue(key, this.getRowSelectionState());
                    break;
            }
        });
        this.staleStateKeys.clear();
    }
    dispatchStateUpdateEvent(sources) {
        if (this.suppressEvents) return;
        sources.forEach((source)=>this.queuedUpdateSources.add(source));
        this.dispatchStateUpdateEventDebounced();
    }
    dispatchQueuedStateUpdateEvents() {
        const sources = Array.from(this.queuedUpdateSources);
        this.queuedUpdateSources.clear();
        const event = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_STATE_UPDATED,
            sources: sources,
            state: this.cachedState
        };
        this.eventService.dispatchEvent(event);
    }
    suppressEventsAndDispatchInitEvent(updateFunc) {
        this.suppressEvents = true;
        this.columnAnimationService.setSuppressAnimation(true);
        updateFunc();
        setTimeout(()=>{
            this.suppressEvents = false;
            this.queuedUpdateSources.clear();
            if (!this.isAlive()) return;
            this.columnAnimationService.setSuppressAnimation(false);
            this.dispatchStateUpdateEvent([
                "gridInitializing"
            ]);
        });
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("filterManager")
], $437b23f6a393c3bf$var$StateService.prototype, "filterManager", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("ctrlsService")
], $437b23f6a393c3bf$var$StateService.prototype, "ctrlsService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("focusService")
], $437b23f6a393c3bf$var$StateService.prototype, "focusService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnModel")
], $437b23f6a393c3bf$var$StateService.prototype, "columnModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("paginationProxy")
], $437b23f6a393c3bf$var$StateService.prototype, "paginationProxy", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowModel")
], $437b23f6a393c3bf$var$StateService.prototype, "rowModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("selectionService")
], $437b23f6a393c3bf$var$StateService.prototype, "selectionService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("expansionService")
], $437b23f6a393c3bf$var$StateService.prototype, "expansionService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnAnimationService")
], $437b23f6a393c3bf$var$StateService.prototype, "columnAnimationService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$7acb7b24c478f9c6("sideBarService")
], $437b23f6a393c3bf$var$StateService.prototype, "sideBarService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$7acb7b24c478f9c6("rangeService")
], $437b23f6a393c3bf$var$StateService.prototype, "rangeService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$StateService.prototype, "postConstruct", 1);
$437b23f6a393c3bf$var$StateService = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("stateService")
], $437b23f6a393c3bf$var$StateService);
// community-modules/core/src/validation/validationService.ts
var $437b23f6a393c3bf$var$ValidationService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    init() {
        this.processGridOptions(this.gridOptions);
    }
    processGridOptions(options) {
        this.processOptions(options, $437b23f6a393c3bf$var$GRID_OPTIONS_VALIDATORS);
    }
    processColumnDefs(options) {
        this.processOptions(options, $437b23f6a393c3bf$var$COL_DEF_VALIDATORS);
    }
    processOptions(options, validator) {
        const { validations: validations, deprecations: deprecations, allProperties: allProperties, propertyExceptions: propertyExceptions, objectName: objectName, docsUrl: docsUrl } = validator;
        if (allProperties && this.gridOptions.suppressPropertyNamesCheck !== true) this.checkProperties(options, [
            ...propertyExceptions != null ? propertyExceptions : [],
            ...Object.keys(deprecations)
        ], allProperties, objectName, docsUrl);
        const warnings = /* @__PURE__ */ new Set();
        const optionKeys = Object.keys(options);
        optionKeys.forEach((key)=>{
            var _a;
            const deprecation = deprecations[key];
            if (deprecation) {
                if ("renamed" in deprecation) {
                    const { renamed: renamed, version: version } = deprecation;
                    warnings.add(`As of v${version}, ${String(key)} is deprecated. Please use ${String(renamed)} instead.`);
                    options[renamed] = options[key];
                } else {
                    const { message: message, version: version } = deprecation;
                    warnings.add(`As of v${version}, ${String(key)} is deprecated. ${message != null ? message : ""}`);
                }
            }
            const value = options[key];
            if (value == null || value === false) return;
            const rulesOrGetter = validations[key];
            let rules;
            if (!rulesOrGetter) return;
            else if (typeof rulesOrGetter === "function") {
                const fromGetter = rulesOrGetter(options, this.gridOptions);
                if (!fromGetter) return;
                if ("objectName" in fromGetter) {
                    const value2 = options[key];
                    if (Array.isArray(value2)) {
                        value2.forEach((item)=>{
                            this.processOptions(item, fromGetter);
                        });
                        return;
                    }
                    this.processOptions(options[key], fromGetter);
                    return;
                }
                rules = fromGetter;
            } else rules = rulesOrGetter;
            const { module: module, dependencies: dependencies, supportedRowModels: supportedRowModels } = rules;
            if (supportedRowModels) {
                const rowModel = (_a = this.gridOptions.rowModelType) != null ? _a : "clientSide";
                if (!supportedRowModels.includes(rowModel)) {
                    warnings.add(`${String(key)} is not supported with the '${rowModel}' row model.`);
                    return;
                }
            }
            if (module) {
                const modules = Array.isArray(module) ? module : [
                    module
                ];
                let allRegistered = true;
                modules.forEach((m)=>{
                    if (!$437b23f6a393c3bf$export$dc053975cc7f6c11.__assertRegistered(m, String(key), this.context.getGridId())) {
                        allRegistered = false;
                        warnings.add(`${String(key)} is only available when ${m} is loaded.`);
                    }
                });
                if (!allRegistered) return;
            }
            if (dependencies) {
                const warning = this.checkForWarning(key, dependencies, options);
                if (warning) {
                    warnings.add(warning);
                    return;
                }
            }
        });
        if (warnings.size > 0) warnings.forEach((warning)=>{
            $437b23f6a393c3bf$var$warnOnce(warning);
        });
    }
    checkForWarning(key, validator, options) {
        if (typeof validator === "function") return validator(options, this.gridOptions);
        const optionEntries = Object.entries(validator);
        const failed = optionEntries.find(([key2, value])=>{
            const gridOptionValue = options[key2];
            return !value.includes(gridOptionValue);
        });
        if (!failed) return null;
        const [failedKey, possibleOptions] = failed;
        if (possibleOptions.length > 1) return `'${String(key)}' requires '${failedKey}' to be one of [${possibleOptions.join(", ")}].`;
        return `'${String(key)}' requires '${failedKey}' to be ${possibleOptions[0]}.`;
    }
    checkProperties(object, exceptions, validProperties, containerName, docsUrl) {
        const VUE_FRAMEWORK_PROPS = [
            "__ob__",
            "__v_skip",
            "__metadata__"
        ];
        const invalidProperties = $437b23f6a393c3bf$var$fuzzyCheckStrings(Object.getOwnPropertyNames(object), [
            ...VUE_FRAMEWORK_PROPS,
            ...exceptions,
            ...validProperties
        ], validProperties);
        $437b23f6a393c3bf$var$iterateObject(invalidProperties, (key, value)=>{
            $437b23f6a393c3bf$var$warnOnce(`invalid ${containerName} property '${key}' did you mean any of these: ${value.slice(0, 8).join(", ")}`);
        });
        if (Object.keys(invalidProperties).length > 0 && docsUrl) {
            const url = this.getFrameworkOverrides().getDocLink(docsUrl);
            $437b23f6a393c3bf$var$warnOnce(`to see all the valid ${containerName} properties please check: ${url}`);
        }
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("gridOptions")
], $437b23f6a393c3bf$var$ValidationService.prototype, "gridOptions", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$ValidationService.prototype, "init", 1);
$437b23f6a393c3bf$var$ValidationService = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("validationService")
], $437b23f6a393c3bf$var$ValidationService);
// community-modules/core/src/misc/apiEventService.ts
var $437b23f6a393c3bf$var$ApiEventService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.syncEventListeners = /* @__PURE__ */ new Map();
        this.asyncEventListeners = /* @__PURE__ */ new Map();
        this.syncGlobalEventListeners = /* @__PURE__ */ new Set();
        this.globalEventListenerPairs = /* @__PURE__ */ new Map();
    }
    postConstruct() {
        this.frameworkEventWrappingService = new $437b23f6a393c3bf$var$FrameworkEventListenerService(this.getFrameworkOverrides());
    }
    addEventListener(eventType, userListener) {
        const listener = this.frameworkEventWrappingService.wrap(userListener);
        const async = this.gos.useAsyncEvents() && !$437b23f6a393c3bf$export$12e4e9a3cbd0ec07.has(eventType);
        const listeners = async ? this.asyncEventListeners : this.syncEventListeners;
        if (!listeners.has(eventType)) listeners.set(eventType, /* @__PURE__ */ new Set());
        listeners.get(eventType).add(listener);
        this.eventService.addEventListener(eventType, listener, async);
    }
    removeEventListener(eventType, userListener) {
        var _a;
        const listener = this.frameworkEventWrappingService.unwrap(userListener);
        const asyncListeners = this.asyncEventListeners.get(eventType);
        const hasAsync = !!(asyncListeners == null ? void 0 : asyncListeners.delete(listener));
        if (!hasAsync) (_a = this.syncEventListeners.get(eventType)) == null || _a.delete(listener);
        this.eventService.removeEventListener(eventType, listener, hasAsync);
    }
    addGlobalListener(userListener) {
        const listener = this.frameworkEventWrappingService.wrapGlobal(userListener);
        const async = this.gos.useAsyncEvents();
        if (async) {
            const syncListener = (eventType, event)=>{
                if ($437b23f6a393c3bf$export$12e4e9a3cbd0ec07.has(eventType)) listener(eventType, event);
            };
            const asyncListener = (eventType, event)=>{
                if (!$437b23f6a393c3bf$export$12e4e9a3cbd0ec07.has(eventType)) listener(eventType, event);
            };
            this.globalEventListenerPairs.set(userListener, {
                syncListener: syncListener,
                asyncListener: asyncListener
            });
            this.eventService.addGlobalListener(syncListener, false);
            this.eventService.addGlobalListener(asyncListener, true);
        } else {
            this.syncGlobalEventListeners.add(listener);
            this.eventService.addGlobalListener(listener, false);
        }
    }
    removeGlobalListener(userListener) {
        const listener = this.frameworkEventWrappingService.unwrapGlobal(userListener);
        const hasAsync = this.globalEventListenerPairs.has(listener);
        if (hasAsync) {
            const { syncListener: syncListener, asyncListener: asyncListener } = this.globalEventListenerPairs.get(listener);
            this.eventService.removeGlobalListener(syncListener, false);
            this.eventService.removeGlobalListener(asyncListener, true);
            this.globalEventListenerPairs.delete(userListener);
        } else {
            this.syncGlobalEventListeners.delete(listener);
            this.eventService.removeGlobalListener(listener, false);
        }
    }
    destroyEventListeners(map, async) {
        map.forEach((listeners, eventType)=>{
            listeners.forEach((listener)=>this.eventService.removeEventListener(eventType, listener, async));
            listeners.clear();
        });
        map.clear();
    }
    destroyGlobalListeners(set, async) {
        set.forEach((listener)=>this.eventService.removeGlobalListener(listener, async));
        set.clear();
    }
    destroy() {
        super.destroy();
        this.destroyEventListeners(this.syncEventListeners, false);
        this.destroyEventListeners(this.asyncEventListeners, true);
        this.destroyGlobalListeners(this.syncGlobalEventListeners, false);
        this.globalEventListenerPairs.forEach(({ syncListener: syncListener, asyncListener: asyncListener })=>{
            this.eventService.removeGlobalListener(syncListener, false);
            this.eventService.removeGlobalListener(asyncListener, true);
        });
        this.globalEventListenerPairs.clear();
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$ApiEventService.prototype, "postConstruct", 1);
$437b23f6a393c3bf$var$ApiEventService = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("apiEventService")
], $437b23f6a393c3bf$var$ApiEventService);
// community-modules/core/src/pagination/pageSizeSelector/pageSizeSelectorComp.ts
var $437b23f6a393c3bf$var$PageSizeSelectorComp = class extends $437b23f6a393c3bf$export$16fa2f45be04daa8 {
    constructor(){
        super(/* html */ `<span class="ag-paging-page-size"></span>`);
        this.hasEmptyOption = false;
        this.handlePageSizeItemSelected = ()=>{
            if (!this.selectPageSizeComp) return;
            const newValue = this.selectPageSizeComp.getValue();
            if (!newValue) return;
            const paginationPageSize = Number(newValue);
            if (isNaN(paginationPageSize) || paginationPageSize < 1 || paginationPageSize === this.paginationProxy.getPageSize()) return;
            this.paginationProxy.setPageSize(paginationPageSize, "pageSizeSelector");
            if (this.hasEmptyOption) this.toggleSelectDisplay(true);
            this.selectPageSizeComp.getFocusableElement().focus();
        };
    }
    init() {
        this.addManagedPropertyListener("paginationPageSizeSelector", ()=>{
            this.onPageSizeSelectorValuesChange();
        });
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_PAGINATION_CHANGED, (event)=>this.handlePaginationChanged(event));
    }
    handlePaginationChanged(paginationChangedEvent) {
        if (!this.selectPageSizeComp || !(paginationChangedEvent == null ? void 0 : paginationChangedEvent.newPageSize)) return;
        const paginationPageSize = this.paginationProxy.getPageSize();
        if (this.getPageSizeSelectorValues().includes(paginationPageSize)) this.selectPageSizeComp.setValue(paginationPageSize.toString());
        else if (this.hasEmptyOption) this.selectPageSizeComp.setValue("");
        else this.toggleSelectDisplay(true);
    }
    toggleSelectDisplay(show) {
        if (this.selectPageSizeComp) this.reset();
        if (!show) return;
        this.reloadPageSizesSelector();
        if (!this.selectPageSizeComp) return;
        this.appendChild(this.selectPageSizeComp);
    }
    reset() {
        $437b23f6a393c3bf$var$clearElement(this.getGui());
        if (!this.selectPageSizeComp) return;
        this.destroyBean(this.selectPageSizeComp);
        this.selectPageSizeComp = void 0;
    }
    onPageSizeSelectorValuesChange() {
        if (!this.selectPageSizeComp) return;
        if (this.shouldShowPageSizeSelector()) this.reloadPageSizesSelector();
    }
    shouldShowPageSizeSelector() {
        return this.gos.get("pagination") && !this.gos.get("suppressPaginationPanel") && !this.gos.get("paginationAutoPageSize") && this.gos.get("paginationPageSizeSelector") !== false;
    }
    reloadPageSizesSelector() {
        const pageSizeOptions = this.getPageSizeSelectorValues();
        const paginationPageSizeOption = this.paginationProxy.getPageSize();
        const shouldAddAndSelectEmptyOption = !paginationPageSizeOption || !pageSizeOptions.includes(paginationPageSizeOption);
        if (shouldAddAndSelectEmptyOption) {
            pageSizeOptions.unshift("");
            $437b23f6a393c3bf$var$warnOnce(`The paginationPageSize grid option is set to a value that is not in the list of page size options.
                Please make sure that the paginationPageSize grid option is set to one of the values in the 
                paginationPageSizeSelector array, or set the paginationPageSizeSelector to false to hide the page size selector.`);
        }
        if (this.selectPageSizeComp) {
            this.destroyBean(this.selectPageSizeComp);
            this.selectPageSizeComp = void 0;
        }
        const localeTextFunc = this.localeService.getLocaleTextFunc();
        const localisedLabel = localeTextFunc("pageSizeSelectorLabel", "Page Size:");
        const options = pageSizeOptions.map((value)=>({
                value: String(value),
                text: String(value)
            }));
        const localisedAriaLabel = localeTextFunc("ariaPageSizeSelectorLabel", "Page Size");
        this.selectPageSizeComp = this.createManagedBean(new $437b23f6a393c3bf$export$6f9c460854d56032()).addOptions(options).setValue(String(shouldAddAndSelectEmptyOption ? "" : paginationPageSizeOption)).setAriaLabel(localisedAriaLabel).setLabel(localisedLabel).onValueChange(()=>this.handlePageSizeItemSelected());
        this.hasEmptyOption = shouldAddAndSelectEmptyOption;
    }
    getPageSizeSelectorValues() {
        const defaultValues = [
            20,
            50,
            100
        ];
        const paginationPageSizeSelectorValues = this.gos.get("paginationPageSizeSelector");
        if (!Array.isArray(paginationPageSizeSelectorValues) || !this.validateValues(paginationPageSizeSelectorValues)) return defaultValues;
        return [
            ...paginationPageSizeSelectorValues
        ].sort((a, b)=>a - b);
    }
    validateValues(values2) {
        if (!values2.length) {
            $437b23f6a393c3bf$var$warnOnce(`The paginationPageSizeSelector grid option is an empty array. This is most likely a mistake.
                If you want to hide the page size selector, please set the paginationPageSizeSelector to false.`);
            return false;
        }
        for(let i = 0; i < values2.length; i++){
            const value = values2[i];
            const isNumber = typeof value === "number";
            const isPositive = value > 0;
            if (!isNumber) {
                $437b23f6a393c3bf$var$warnOnce(`The paginationPageSizeSelector grid option contains a non-numeric value.
                    Please make sure that all values in the paginationPageSizeSelector array are numbers.`);
                return false;
            }
            if (!isPositive) {
                $437b23f6a393c3bf$var$warnOnce(`The paginationPageSizeSelector grid option contains a negative number or zero.
                    Please make sure that all values in the paginationPageSizeSelector array are positive.`);
                return false;
            }
        }
        return true;
    }
    destroy() {
        this.toggleSelectDisplay(false);
        super.destroy();
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("paginationProxy")
], $437b23f6a393c3bf$var$PageSizeSelectorComp.prototype, "paginationProxy", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$PageSizeSelectorComp.prototype, "init", 1);
// community-modules/core/src/rendering/ariaAnnouncementService.ts
var $437b23f6a393c3bf$var$AriaAnnouncementService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super();
        this.descriptionContainer = null;
        this.announceValue = $437b23f6a393c3bf$var$debounce(this.announceValue.bind(this), 200);
    }
    postConstruct() {
        const eDocument = this.gos.getDocument();
        const div = this.descriptionContainer = eDocument.createElement("div");
        div.classList.add("ag-aria-description-container");
        $437b23f6a393c3bf$var$setAriaLive(div, "polite");
        $437b23f6a393c3bf$var$setAriaRelevant(div, "additions text");
        $437b23f6a393c3bf$var$setAriaAtomic(div, true);
        this.eGridDiv.appendChild(div);
    }
    announceValue(value) {
        if (!this.descriptionContainer) return;
        this.descriptionContainer.textContent = "";
        setTimeout(()=>{
            if (this.isAlive() && this.descriptionContainer) this.descriptionContainer.textContent = value;
        }, 50);
    }
    destroy() {
        super.destroy();
        const { descriptionContainer: descriptionContainer } = this;
        if (descriptionContainer) {
            $437b23f6a393c3bf$var$clearElement(descriptionContainer);
            if (descriptionContainer.parentElement) descriptionContainer.parentElement.removeChild(descriptionContainer);
        }
        this.descriptionContainer = null;
        this.eGridDiv = null;
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("eGridDiv")
], $437b23f6a393c3bf$var$AriaAnnouncementService.prototype, "eGridDiv", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$AriaAnnouncementService.prototype, "postConstruct", 1);
$437b23f6a393c3bf$var$AriaAnnouncementService = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("ariaAnnouncementService")
], $437b23f6a393c3bf$var$AriaAnnouncementService);
// community-modules/core/src/grid.ts
var $437b23f6a393c3bf$var$GlobalGridOptions = class {
};
$437b23f6a393c3bf$var$GlobalGridOptions.gridOptions = void 0;
function $437b23f6a393c3bf$export$9def8154c643bfd1(gridOptions) {
    $437b23f6a393c3bf$var$GlobalGridOptions.gridOptions = gridOptions;
}
function $437b23f6a393c3bf$export$fce123c48a7b4eae(eGridDiv, gridOptions, params) {
    if (!gridOptions) {
        $437b23f6a393c3bf$var$errorOnce("No gridOptions provided to createGrid");
        return {};
    }
    const api = new $437b23f6a393c3bf$export$7759b93c6200a2f9().create(eGridDiv, gridOptions, (context)=>{
        const gridComp = new $437b23f6a393c3bf$export$f29859a2c0c53119(eGridDiv);
        context.createBean(gridComp);
    }, void 0, params);
    if (!Object.isFrozen(gridOptions) && !(params == null ? void 0 : params.frameworkOverrides)) {
        const apiUrl = "https://ag-grid.com/javascript-data-grid/grid-interface/#grid-api";
        Object.defineProperty(gridOptions, "api", {
            get: ()=>{
                $437b23f6a393c3bf$var$errorOnce(`gridOptions.api is no longer supported. See ${apiUrl}.`);
                return void 0;
            },
            configurable: true
        });
        Object.defineProperty(gridOptions, "columnApi", {
            get: ()=>{
                $437b23f6a393c3bf$var$errorOnce(`gridOptions.columnApi is no longer supported and all methods moved to the grid api. See ${apiUrl}.`);
                return void 0;
            },
            configurable: true
        });
    }
    return api;
}
var $437b23f6a393c3bf$export$ef2184bd89960b14 = class {
    // Not typed to enable setting api / columnApi for backwards compatibility
    constructor(eGridDiv, gridOptions, params){
        $437b23f6a393c3bf$var$warnOnce("Since v31 new Grid(...) is deprecated. Use createGrid instead: `const gridApi = createGrid(...)`. The grid api is returned from createGrid and will not be available on gridOptions.");
        if (!gridOptions) {
            $437b23f6a393c3bf$var$errorOnce("No gridOptions provided to the grid");
            return;
        }
        this.gridOptions = gridOptions;
        const api = new $437b23f6a393c3bf$export$7759b93c6200a2f9().create(eGridDiv, gridOptions, (context)=>{
            const gridComp = new $437b23f6a393c3bf$export$f29859a2c0c53119(eGridDiv);
            const bean = context.createBean(gridComp);
            bean.addDestroyFunc(()=>{
                this.destroy();
            });
        }, void 0, params);
        this.gridOptions.api = api;
        this.gridOptions.columnApi = new $437b23f6a393c3bf$export$77ba9896796af9bf(api);
    }
    destroy() {
        var _a;
        if (this.gridOptions) {
            (_a = this.gridOptions.api) == null || _a.destroy();
            delete this.gridOptions.api;
            delete this.gridOptions.columnApi;
        }
    }
};
var $437b23f6a393c3bf$var$nextGridId = 1;
var $437b23f6a393c3bf$export$7759b93c6200a2f9 = class {
    create(eGridDiv, providedOptions, createUi, acceptChanges, params) {
        var _a;
        let mergedGridOps = {};
        if ($437b23f6a393c3bf$var$GlobalGridOptions.gridOptions) {
            $437b23f6a393c3bf$var$mergeDeep(mergedGridOps, $437b23f6a393c3bf$var$GlobalGridOptions.gridOptions, true, true);
            mergedGridOps = $437b23f6a393c3bf$var$__spreadValues($437b23f6a393c3bf$var$__spreadValues({}, mergedGridOps), providedOptions);
        } else mergedGridOps = providedOptions;
        const gridOptions = $437b23f6a393c3bf$export$4e35ad424d98ee6.getCoercedGridOptions(mergedGridOps);
        const debug = !!gridOptions.debug;
        const gridId = (_a = gridOptions.gridId) != null ? _a : String($437b23f6a393c3bf$var$nextGridId++);
        const registeredModules = this.getRegisteredModules(params, gridId);
        const beanClasses = this.createBeansList(gridOptions.rowModelType, registeredModules, gridId);
        const providedBeanInstances = this.createProvidedBeans(eGridDiv, gridOptions, params);
        if (!beanClasses) {
            $437b23f6a393c3bf$var$errorOnce("Failed to create grid.");
            return void 0;
        }
        const contextParams = {
            providedBeanInstances: providedBeanInstances,
            beanClasses: beanClasses,
            debug: debug,
            gridId: gridId
        };
        const contextLogger = new $437b23f6a393c3bf$export$efa9a398d6368992("Context", ()=>contextParams.debug);
        const context = new $437b23f6a393c3bf$export$841858b892ce1f4c(contextParams, contextLogger);
        const beans = context.getBean("beans");
        this.registerModuleUserComponents(beans, registeredModules);
        this.registerStackComponents(beans, registeredModules);
        this.registerControllers(beans, registeredModules);
        createUi(context);
        beans.syncService.start();
        if (acceptChanges) acceptChanges(context);
        const gridApi = context.getBean("gridApi");
        return gridApi;
    }
    registerControllers(beans, registeredModules) {
        registeredModules.forEach((module)=>{
            if (module.controllers) module.controllers.forEach((meta)=>beans.ctrlsFactory.register(meta));
        });
    }
    registerStackComponents(beans, registeredModules) {
        const agStackComponents = this.createAgStackComponentsList(registeredModules);
        beans.agStackComponentsRegistry.setupComponents(agStackComponents);
    }
    getRegisteredModules(params, gridId) {
        const passedViaConstructor = params ? params.modules : null;
        const registered = $437b23f6a393c3bf$export$dc053975cc7f6c11.__getRegisteredModules(gridId);
        const allModules = [];
        const mapNames = {};
        const addModule = (moduleBased, mod, gridId2)=>{
            const addIndividualModule = (currentModule)=>{
                if (!mapNames[currentModule.moduleName]) {
                    mapNames[currentModule.moduleName] = true;
                    allModules.push(currentModule);
                    $437b23f6a393c3bf$export$dc053975cc7f6c11.__register(currentModule, moduleBased, gridId2);
                }
            };
            addIndividualModule(mod);
            if (mod.dependantModules) mod.dependantModules.forEach((m)=>addModule(moduleBased, m, gridId2));
        };
        if (passedViaConstructor) passedViaConstructor.forEach((m)=>addModule(true, m, gridId));
        if (registered) registered.forEach((m)=>addModule(!$437b23f6a393c3bf$export$dc053975cc7f6c11.__isPackageBased(), m, void 0));
        return allModules;
    }
    registerModuleUserComponents(beans, registeredModules) {
        const moduleUserComps = this.extractModuleEntity(registeredModules, (module)=>module.userComponents ? module.userComponents : []);
        moduleUserComps.forEach((compMeta)=>{
            beans.userComponentRegistry.registerDefaultComponent(compMeta.componentName, compMeta.componentClass);
        });
    }
    createProvidedBeans(eGridDiv, gridOptions, params) {
        let frameworkOverrides = params ? params.frameworkOverrides : null;
        if ($437b23f6a393c3bf$var$missing(frameworkOverrides)) frameworkOverrides = new $437b23f6a393c3bf$export$8174ad74937c6482();
        const seed = {
            gridOptions: gridOptions,
            eGridDiv: eGridDiv,
            globalEventListener: params ? params.globalEventListener : null,
            globalSyncEventListener: params ? params.globalSyncEventListener : null,
            frameworkOverrides: frameworkOverrides
        };
        if (params && params.providedBeanInstances) Object.assign(seed, params.providedBeanInstances);
        return seed;
    }
    createAgStackComponentsList(registeredModules) {
        let components = [
            {
                componentName: "AgCheckbox",
                componentClass: $437b23f6a393c3bf$export$b00c508c1ae18d07
            },
            {
                componentName: "AgRadioButton",
                componentClass: $437b23f6a393c3bf$export$5caa9ea96bbb722
            },
            {
                componentName: "AgToggleButton",
                componentClass: $437b23f6a393c3bf$export$167b21bf245ce0bf
            },
            {
                componentName: "AgInputTextField",
                componentClass: $437b23f6a393c3bf$export$8c027679838afd47
            },
            {
                componentName: "AgInputTextArea",
                componentClass: $437b23f6a393c3bf$export$fd677433260ffbc8
            },
            {
                componentName: "AgInputNumberField",
                componentClass: $437b23f6a393c3bf$export$c8aa0be99738aee
            },
            {
                componentName: "AgInputDateField",
                componentClass: $437b23f6a393c3bf$export$9e01ec8ba43de612
            },
            {
                componentName: "AgInputRange",
                componentClass: $437b23f6a393c3bf$export$59243fd7dabffb56
            },
            {
                componentName: "AgRichSelect",
                componentClass: $437b23f6a393c3bf$export$16d6ce2fe866e420
            },
            {
                componentName: "AgSelect",
                componentClass: $437b23f6a393c3bf$export$6f9c460854d56032
            },
            {
                componentName: "AgSlider",
                componentClass: $437b23f6a393c3bf$export$393c85b733ccd61d
            },
            {
                componentName: "AgGridBody",
                componentClass: $437b23f6a393c3bf$export$fb561602f10e2162
            },
            {
                componentName: "AgHeaderRoot",
                componentClass: $437b23f6a393c3bf$export$a83f8d9da6e79f4
            },
            {
                componentName: "AgSortIndicator",
                componentClass: $437b23f6a393c3bf$export$220e9505c6bd76f6
            },
            {
                componentName: "AgPagination",
                componentClass: $437b23f6a393c3bf$var$PaginationComp
            },
            {
                componentName: "AgPageSizeSelector",
                componentClass: $437b23f6a393c3bf$var$PageSizeSelectorComp
            },
            {
                componentName: "AgOverlayWrapper",
                componentClass: $437b23f6a393c3bf$var$OverlayWrapperComponent
            },
            {
                componentName: "AgGroupComponent",
                componentClass: $437b23f6a393c3bf$export$ad535c478b02d5b4
            },
            {
                componentName: "AgRowContainer",
                componentClass: $437b23f6a393c3bf$export$a301f7d71bb9bd77
            },
            {
                componentName: "AgFakeHorizontalScroll",
                componentClass: $437b23f6a393c3bf$var$FakeHScrollComp
            },
            {
                componentName: "AgFakeVerticalScroll",
                componentClass: $437b23f6a393c3bf$var$FakeVScrollComp
            },
            {
                componentName: "AgAutocomplete",
                componentClass: $437b23f6a393c3bf$export$b26fb295f8aa6b61
            }
        ];
        const moduleAgStackComps = this.extractModuleEntity(registeredModules, (module)=>module.agStackComponents ? module.agStackComponents : []);
        components = components.concat(moduleAgStackComps);
        return components;
    }
    createBeansList(rowModelType = "clientSide", registeredModules, gridId) {
        const rowModelModules = registeredModules.filter((module)=>!module.rowModel || module.rowModel === rowModelType);
        const rowModelModuleNames = {
            clientSide: "@ag-grid-community/client-side-row-model" /* ClientSideRowModelModule */ ,
            infinite: "@ag-grid-community/infinite-row-model" /* InfiniteRowModelModule */ ,
            serverSide: "@ag-grid-enterprise/server-side-row-model" /* ServerSideRowModelModule */ ,
            viewport: "@ag-grid-enterprise/viewport-row-model" /* ViewportRowModelModule */ 
        };
        if (!rowModelModuleNames[rowModelType]) {
            $437b23f6a393c3bf$var$errorOnce("Could not find row model for rowModelType = " + rowModelType);
            return;
        }
        if (!$437b23f6a393c3bf$export$dc053975cc7f6c11.__assertRegistered(rowModelModuleNames[rowModelType], `rowModelType = '${rowModelType}'`, gridId)) return;
        const beans = [
            $437b23f6a393c3bf$export$e1272dadeadaca63,
            $437b23f6a393c3bf$export$27e6ff2feb462d0f,
            $437b23f6a393c3bf$export$d4b97c43369f9635,
            $437b23f6a393c3bf$export$4dfb519ecc588412,
            $437b23f6a393c3bf$var$PaginationAutoPageSizeService,
            $437b23f6a393c3bf$export$8f1681b1712fcf78,
            $437b23f6a393c3bf$export$84607ca0a5de10d3,
            $437b23f6a393c3bf$var$AgComponentUtils,
            $437b23f6a393c3bf$var$ComponentMetadataProvider,
            $437b23f6a393c3bf$export$c3ae9ac02599b50f,
            $437b23f6a393c3bf$export$b32ef18681c5348a,
            $437b23f6a393c3bf$var$RowContainerHeightService,
            $437b23f6a393c3bf$export$8c88ee8741066b8b,
            $437b23f6a393c3bf$export$f325e19d05d9c36d,
            $437b23f6a393c3bf$var$ValidationService,
            $437b23f6a393c3bf$export$d44126a5f53c99d9,
            $437b23f6a393c3bf$export$590729638d17528a,
            $437b23f6a393c3bf$export$de11801d74224ab,
            $437b23f6a393c3bf$export$895d7dc49f082ca1,
            $437b23f6a393c3bf$export$4e35ad424d98ee6,
            $437b23f6a393c3bf$export$27497a369f7303c1,
            $437b23f6a393c3bf$var$SelectionService,
            $437b23f6a393c3bf$export$4c85e4ca0d95642f,
            $437b23f6a393c3bf$export$c9dec256e4c9f340,
            $437b23f6a393c3bf$export$ee63d8b4f36fee20,
            $437b23f6a393c3bf$export$beda096b980d328,
            $437b23f6a393c3bf$export$a41edaea3b7c09c8,
            $437b23f6a393c3bf$export$4ce5344b7d88a0e2,
            $437b23f6a393c3bf$export$a988f568cf9d5725,
            $437b23f6a393c3bf$export$64acd562943cc6b9,
            $437b23f6a393c3bf$export$2a4aa3d46d9c7613,
            $437b23f6a393c3bf$export$8bb85f19590498f6,
            $437b23f6a393c3bf$export$c52638093d9fc6a3,
            $437b23f6a393c3bf$export$e0f5ef03cd95415a,
            $437b23f6a393c3bf$export$cc129c761c9af6b5,
            $437b23f6a393c3bf$export$ddca88023f936464,
            $437b23f6a393c3bf$export$3529111922becfa6,
            $437b23f6a393c3bf$export$77ba9896796af9bf,
            $437b23f6a393c3bf$export$a48e931b7fcc2862,
            $437b23f6a393c3bf$export$2e403e146bc377e1,
            $437b23f6a393c3bf$export$7dc6752a22ab011a,
            $437b23f6a393c3bf$export$672e779a12850b13,
            $437b23f6a393c3bf$export$cf53ce5e31dacc9f,
            $437b23f6a393c3bf$export$eca0fad328f0291c,
            $437b23f6a393c3bf$export$765594e5be71a851,
            $437b23f6a393c3bf$var$ColumnHoverService,
            $437b23f6a393c3bf$var$ColumnAnimationService,
            $437b23f6a393c3bf$export$75ae26c229338c6b,
            $437b23f6a393c3bf$var$AutoGroupColService,
            $437b23f6a393c3bf$var$ChangeDetectionService,
            $437b23f6a393c3bf$export$2963e6121f7c3146,
            $437b23f6a393c3bf$var$UndoRedoService,
            $437b23f6a393c3bf$export$7d237966671a050f,
            $437b23f6a393c3bf$var$ColumnDefFactory,
            $437b23f6a393c3bf$var$RowCssClassCalculator,
            $437b23f6a393c3bf$export$6bcc4682a6134db1,
            $437b23f6a393c3bf$export$5cc6416c85df0cc5,
            $437b23f6a393c3bf$export$1ec35376f0ed6145,
            $437b23f6a393c3bf$var$PinnedWidthService,
            $437b23f6a393c3bf$var$RowNodeEventThrottle,
            $437b23f6a393c3bf$var$CtrlsFactory,
            $437b23f6a393c3bf$export$167d98081c349dc,
            $437b23f6a393c3bf$var$QuickFilterService,
            $437b23f6a393c3bf$var$SyncService,
            $437b23f6a393c3bf$var$OverlayService,
            $437b23f6a393c3bf$var$StateService,
            $437b23f6a393c3bf$export$609b78da5e2f116c,
            $437b23f6a393c3bf$var$ApiEventService,
            $437b23f6a393c3bf$var$AriaAnnouncementService,
            $437b23f6a393c3bf$export$ec78627b94a587e2
        ];
        const moduleBeans = this.extractModuleEntity(rowModelModules, (module)=>module.beans ? module.beans : []);
        beans.push(...moduleBeans);
        const beansNoDuplicates = [];
        beans.forEach((bean)=>{
            if (beansNoDuplicates.indexOf(bean) < 0) beansNoDuplicates.push(bean);
        });
        return beansNoDuplicates;
    }
    extractModuleEntity(moduleEntities, extractor) {
        return [].concat(...moduleEntities.map(extractor));
    }
};
// community-modules/core/src/components/framework/frameworkComponentWrapper.ts
var $437b23f6a393c3bf$export$157f014d661b6f19 = class {
    wrap(OriginalConstructor, mandatoryMethodList, optionalMethodList = [], componentType) {
        const wrapper = this.createWrapper(OriginalConstructor, componentType);
        mandatoryMethodList.forEach((methodName)=>{
            this.createMethod(wrapper, methodName, true);
        });
        optionalMethodList.forEach((methodName)=>{
            this.createMethod(wrapper, methodName, false);
        });
        return wrapper;
    }
    unwrap(comp) {
        return comp;
    }
    createMethod(wrapper, methodName, mandatory) {
        wrapper.addMethod(methodName, this.createMethodProxy(wrapper, methodName, mandatory));
    }
    createMethodProxy(wrapper, methodName, mandatory) {
        return function() {
            if (wrapper.hasMethod(methodName)) return wrapper.callMethod(methodName, arguments);
            if (mandatory) console.warn("AG Grid: Framework component is missing the method " + methodName + "()");
            return null;
        };
    }
};
// community-modules/core/src/interfaces/iChartOptions.ts
var $437b23f6a393c3bf$export$95ec81232b2e8791 = class {
};
$437b23f6a393c3bf$export$95ec81232b2e8791.CHART_TYPE_TO_SERIES_TYPE = {
    column: "bar",
    groupedColumn: "bar",
    stackedColumn: "bar",
    normalizedColumn: "bar",
    bar: "bar",
    groupedBar: "bar",
    stackedBar: "bar",
    normalizedBar: "bar",
    line: "line",
    scatter: "scatter",
    bubble: "bubble",
    pie: "pie",
    donut: "donut",
    doughnut: "donut",
    area: "area",
    stackedArea: "area",
    normalizedArea: "area",
    histogram: "histogram",
    radarLine: "radar-line",
    radarArea: "radar-area",
    nightingale: "nightingale",
    radialColumn: "radial-column",
    radialBar: "radial-bar",
    sunburst: "sunburst",
    rangeBar: "range-bar",
    rangeArea: "range-area",
    boxPlot: "box-plot",
    treemap: "treemap",
    heatmap: "heatmap",
    waterfall: "waterfall"
};
$437b23f6a393c3bf$export$95ec81232b2e8791.COMBO_CHART_TYPES = [
    "columnLineCombo",
    "areaColumnCombo",
    "customCombo"
];
$437b23f6a393c3bf$export$95ec81232b2e8791.SERIES_GROUP_TYPES = [
    "grouped",
    "stacked",
    "normalized"
];
// community-modules/core/src/interfaces/iSparklineCellRendererParams.ts
var $437b23f6a393c3bf$export$c8e24a0d0ec865d3 = /* @__PURE__ */ ((BarColumnLabelPlacement2)=>{
    BarColumnLabelPlacement2["InsideBase"] = "insideBase";
    BarColumnLabelPlacement2["InsideEnd"] = "insideEnd";
    BarColumnLabelPlacement2["Center"] = "center";
    BarColumnLabelPlacement2["OutsideEnd"] = "outsideEnd";
    return BarColumnLabelPlacement2;
})($437b23f6a393c3bf$export$c8e24a0d0ec865d3 || {});
// community-modules/core/src/main.ts
var $437b23f6a393c3bf$var$globalObj = typeof $parcel$global === "undefined" ? {} : $parcel$global;
$437b23f6a393c3bf$var$globalObj.HTMLElement = typeof HTMLElement === "undefined" ? {} : HTMLElement;
$437b23f6a393c3bf$var$globalObj.HTMLButtonElement = typeof HTMLButtonElement === "undefined" ? {} : HTMLButtonElement;
$437b23f6a393c3bf$var$globalObj.HTMLSelectElement = typeof HTMLSelectElement === "undefined" ? {} : HTMLSelectElement;
$437b23f6a393c3bf$var$globalObj.HTMLInputElement = typeof HTMLInputElement === "undefined" ? {} : HTMLInputElement;
$437b23f6a393c3bf$var$globalObj.Node = typeof Node === "undefined" ? {} : Node;
$437b23f6a393c3bf$var$globalObj.MouseEvent = typeof MouseEvent === "undefined" ? {} : MouseEvent;
// community-modules/client-side-row-model/src/clientSideRowModel/clientSideNodeManager.ts
var $437b23f6a393c3bf$var$_ClientSideNodeManager = class _ClientSideNodeManager {
    constructor(rootNode, gos, eventService, columnModel, selectionService, beans){
        this.nextId = 0;
        // has row data actually been set
        this.rowCountReady = false;
        // when user is provide the id's, we also keep a map of ids to row nodes for convenience
        this.allNodesMap = {};
        this.rootNode = rootNode;
        this.gos = gos;
        this.eventService = eventService;
        this.columnModel = columnModel;
        this.beans = beans;
        this.selectionService = selectionService;
        this.rootNode.group = true;
        this.rootNode.level = -1;
        this.rootNode.id = _ClientSideNodeManager.ROOT_NODE_ID;
        this.rootNode.allLeafChildren = [];
        this.rootNode.childrenAfterGroup = [];
        this.rootNode.childrenAfterSort = [];
        this.rootNode.childrenAfterAggFilter = [];
        this.rootNode.childrenAfterFilter = [];
    }
    getCopyOfNodesMap() {
        return $437b23f6a393c3bf$export$71511d61b312f219.cloneObject(this.allNodesMap);
    }
    getRowNode(id) {
        return this.allNodesMap[id];
    }
    setRowData(rowData) {
        if (typeof rowData === "string") {
            console.warn("AG Grid: rowData must be an array.");
            return;
        }
        this.rowCountReady = true;
        this.dispatchRowDataUpdateStartedEvent(rowData);
        const rootNode = this.rootNode;
        const sibling = this.rootNode.sibling;
        rootNode.childrenAfterFilter = null;
        rootNode.childrenAfterGroup = null;
        rootNode.childrenAfterAggFilter = null;
        rootNode.childrenAfterSort = null;
        rootNode.childrenMapped = null;
        rootNode.updateHasChildren();
        this.nextId = 0;
        this.allNodesMap = {};
        if (rowData) rootNode.allLeafChildren = rowData.map((dataItem)=>this.createNode(dataItem, this.rootNode, _ClientSideNodeManager.TOP_LEVEL));
        else {
            rootNode.allLeafChildren = [];
            rootNode.childrenAfterGroup = [];
        }
        if (sibling) {
            sibling.childrenAfterFilter = rootNode.childrenAfterFilter;
            sibling.childrenAfterGroup = rootNode.childrenAfterGroup;
            sibling.childrenAfterAggFilter = rootNode.childrenAfterAggFilter;
            sibling.childrenAfterSort = rootNode.childrenAfterSort;
            sibling.childrenMapped = rootNode.childrenMapped;
            sibling.allLeafChildren = rootNode.allLeafChildren;
        }
    }
    updateRowData(rowDataTran, rowNodeOrder) {
        this.rowCountReady = true;
        this.dispatchRowDataUpdateStartedEvent(rowDataTran.add);
        const rowNodeTransaction = {
            remove: [],
            update: [],
            add: []
        };
        const nodesToUnselect = [];
        this.executeRemove(rowDataTran, rowNodeTransaction, nodesToUnselect);
        this.executeUpdate(rowDataTran, rowNodeTransaction, nodesToUnselect);
        this.executeAdd(rowDataTran, rowNodeTransaction);
        this.updateSelection(nodesToUnselect, "rowDataChanged");
        if (rowNodeOrder) $437b23f6a393c3bf$export$71511d61b312f219.sortRowNodesByOrder(this.rootNode.allLeafChildren, rowNodeOrder);
        return rowNodeTransaction;
    }
    isRowCountReady() {
        return this.rowCountReady;
    }
    dispatchRowDataUpdateStartedEvent(rowData) {
        const event = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_DATA_UPDATE_STARTED,
            firstRowData: (rowData == null ? void 0 : rowData.length) ? rowData[0] : null
        };
        this.eventService.dispatchEvent(event);
    }
    updateSelection(nodesToUnselect, source) {
        const selectionChanged = nodesToUnselect.length > 0;
        if (selectionChanged) this.selectionService.setNodesSelected({
            newValue: false,
            nodes: nodesToUnselect,
            suppressFinishActions: true,
            source: source
        });
        this.selectionService.updateGroupsFromChildrenSelections(source);
        if (selectionChanged) {
            const event = {
                type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_SELECTION_CHANGED,
                source: source
            };
            this.eventService.dispatchEvent(event);
        }
    }
    executeAdd(rowDataTran, rowNodeTransaction) {
        var _a;
        const { add: add, addIndex: addIndex } = rowDataTran;
        if ($437b23f6a393c3bf$export$71511d61b312f219.missingOrEmpty(add)) return;
        const newNodes = add.map((item)=>this.createNode(item, this.rootNode, _ClientSideNodeManager.TOP_LEVEL));
        if (typeof addIndex === "number" && addIndex >= 0) {
            const { allLeafChildren: allLeafChildren } = this.rootNode;
            const len = allLeafChildren.length;
            let normalisedAddIndex = addIndex;
            const isTreeData = this.gos.get("treeData");
            if (isTreeData && addIndex > 0 && len > 0) {
                for(let i = 0; i < len; i++)if (((_a = allLeafChildren[i]) == null ? void 0 : _a.rowIndex) == addIndex - 1) {
                    normalisedAddIndex = i + 1;
                    break;
                }
            }
            const nodesBeforeIndex = allLeafChildren.slice(0, normalisedAddIndex);
            const nodesAfterIndex = allLeafChildren.slice(normalisedAddIndex, allLeafChildren.length);
            this.rootNode.allLeafChildren = [
                ...nodesBeforeIndex,
                ...newNodes,
                ...nodesAfterIndex
            ];
        } else this.rootNode.allLeafChildren = [
            ...this.rootNode.allLeafChildren,
            ...newNodes
        ];
        if (this.rootNode.sibling) this.rootNode.sibling.allLeafChildren = this.rootNode.allLeafChildren;
        rowNodeTransaction.add = newNodes;
    }
    executeRemove(rowDataTran, rowNodeTransaction, nodesToUnselect) {
        const { remove: remove } = rowDataTran;
        if ($437b23f6a393c3bf$export$71511d61b312f219.missingOrEmpty(remove)) return;
        const rowIdsRemoved = {};
        remove.forEach((item)=>{
            const rowNode = this.lookupRowNode(item);
            if (!rowNode) return;
            if (rowNode.isSelected()) nodesToUnselect.push(rowNode);
            rowNode.clearRowTopAndRowIndex();
            rowIdsRemoved[rowNode.id] = true;
            delete this.allNodesMap[rowNode.id];
            rowNodeTransaction.remove.push(rowNode);
        });
        this.rootNode.allLeafChildren = this.rootNode.allLeafChildren.filter((rowNode)=>!rowIdsRemoved[rowNode.id]);
        if (this.rootNode.sibling) this.rootNode.sibling.allLeafChildren = this.rootNode.allLeafChildren;
    }
    executeUpdate(rowDataTran, rowNodeTransaction, nodesToUnselect) {
        const { update: update } = rowDataTran;
        if ($437b23f6a393c3bf$export$71511d61b312f219.missingOrEmpty(update)) return;
        update.forEach((item)=>{
            const rowNode = this.lookupRowNode(item);
            if (!rowNode) return;
            rowNode.updateData(item);
            if (!rowNode.selectable && rowNode.isSelected()) nodesToUnselect.push(rowNode);
            this.setMasterForRow(rowNode, item, _ClientSideNodeManager.TOP_LEVEL, false);
            rowNodeTransaction.update.push(rowNode);
        });
    }
    lookupRowNode(data) {
        const getRowIdFunc = this.gos.getCallback("getRowId");
        let rowNode;
        if (getRowIdFunc) {
            const id = getRowIdFunc({
                data: data,
                level: 0
            });
            rowNode = this.allNodesMap[id];
            if (!rowNode) {
                console.error(`AG Grid: could not find row id=${id}, data item was not found for this id`);
                return null;
            }
        } else {
            rowNode = this.rootNode.allLeafChildren.find((node)=>node.data === data);
            if (!rowNode) {
                console.error(`AG Grid: could not find data item as object was not found`, data);
                console.error(`Consider using getRowId to help the Grid find matching row data`);
                return null;
            }
        }
        return rowNode || null;
    }
    createNode(dataItem, parent, level) {
        const node = new $437b23f6a393c3bf$export$6af91cd58ec2edf9(this.beans);
        node.group = false;
        this.setMasterForRow(node, dataItem, level, true);
        const suppressParentsInRowNodes = this.gos.get("suppressParentsInRowNodes");
        if (parent && !suppressParentsInRowNodes) node.parent = parent;
        node.level = level;
        node.setDataAndId(dataItem, this.nextId.toString());
        if (this.allNodesMap[node.id]) console.warn(`AG Grid: duplicate node id '${node.id}' detected from getRowId callback, this could cause issues in your grid.`);
        this.allNodesMap[node.id] = node;
        this.nextId++;
        return node;
    }
    setMasterForRow(rowNode, data, level, setExpanded) {
        const isTreeData = this.gos.get("treeData");
        if (isTreeData) {
            rowNode.setMaster(false);
            if (setExpanded) rowNode.expanded = false;
        } else {
            const masterDetail = this.gos.get("masterDetail");
            if (masterDetail) {
                const isRowMasterFunc = this.gos.get("isRowMaster");
                if (isRowMasterFunc) rowNode.setMaster(isRowMasterFunc(data));
                else rowNode.setMaster(true);
            } else rowNode.setMaster(false);
            if (setExpanded) {
                const rowGroupColumns = this.columnModel.getRowGroupColumns();
                const numRowGroupColumns = rowGroupColumns ? rowGroupColumns.length : 0;
                const masterRowLevel = level + numRowGroupColumns;
                rowNode.expanded = rowNode.master ? this.isExpanded(masterRowLevel) : false;
            }
        }
    }
    isExpanded(level) {
        const expandByDefault = this.gos.get("groupDefaultExpanded");
        if (expandByDefault === -1) return true;
        return level < expandByDefault;
    }
};
$437b23f6a393c3bf$var$_ClientSideNodeManager.TOP_LEVEL = 0;
$437b23f6a393c3bf$var$_ClientSideNodeManager.ROOT_NODE_ID = "ROOT_NODE_ID";
var $437b23f6a393c3bf$var$ClientSideNodeManager = $437b23f6a393c3bf$var$_ClientSideNodeManager;
// community-modules/client-side-row-model/src/clientSideRowModel/clientSideRowModel.ts
var $437b23f6a393c3bf$var$ClientSideRowModel = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(){
        super(...arguments);
        this.onRowHeightChanged_debounced = $437b23f6a393c3bf$export$71511d61b312f219.debounce(this.onRowHeightChanged.bind(this), 100);
        this.rowsToDisplay = [];
        /** Has the start method been called */ this.hasStarted = false;
        /** E.g. data has been set into the node manager already */ this.shouldSkipSettingDataOnStart = false;
        /**
     * This is to prevent refresh model being called when it's already being called.
     * E.g. the group stage can trigger initial state filter model to be applied. This fires onFilterChanged,
     * which then triggers the listener here that calls refresh model again but at the filter stage
     * (which is about to be run by the original call).
     */ this.isRefreshingModel = false;
        this.rowCountReady = false;
    }
    init() {
        const refreshEverythingFunc = this.refreshModel.bind(this, {
            step: "group" /* EVERYTHING */ 
        });
        const animate = !this.gos.get("suppressAnimationFrame");
        const refreshEverythingAfterColsChangedFunc = this.refreshModel.bind(this, {
            step: "group" /* EVERYTHING */ ,
            // after cols change, row grouping (the first stage) could of changed
            afterColumnsChanged: true,
            keepRenderedRows: true,
            animate: // we want animations cos sorting or filtering could be applied
            animate
        });
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_NEW_COLUMNS_LOADED, refreshEverythingAfterColsChangedFunc);
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_ROW_GROUP_CHANGED, refreshEverythingFunc);
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_VALUE_CHANGED, this.onValueChanged.bind(this));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_PIVOT_CHANGED, this.refreshModel.bind(this, {
            step: "pivot" /* PIVOT */ 
        }));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_FILTER_CHANGED, this.onFilterChanged.bind(this));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_SORT_CHANGED, this.onSortChanged.bind(this));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_COLUMN_PIVOT_MODE_CHANGED, refreshEverythingFunc);
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_GRID_STYLES_CHANGED, this.onGridStylesChanges.bind(this));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_GRID_READY, ()=>this.onGridReady());
        this.addPropertyListeners();
        this.rootNode = new $437b23f6a393c3bf$export$6af91cd58ec2edf9(this.beans);
        this.nodeManager = new $437b23f6a393c3bf$var$ClientSideNodeManager(this.rootNode, this.gos, this.eventService, this.columnModel, this.selectionService, this.beans);
    }
    addPropertyListeners() {
        const resetProps = /* @__PURE__ */ new Set([
            "treeData",
            "masterDetail"
        ]);
        const groupStageRefreshProps = /* @__PURE__ */ new Set([
            "suppressParentsInRowNodes",
            "groupDefaultExpanded",
            "groupAllowUnbalanced",
            "initialGroupOrderComparator",
            "groupHideOpenParents",
            "groupDisplayType"
        ]);
        const filterStageRefreshProps = /* @__PURE__ */ new Set([
            "excludeChildrenWhenTreeDataFiltering"
        ]);
        const pivotStageRefreshProps = /* @__PURE__ */ new Set([
            "removePivotHeaderRowWhenSingleValueColumn",
            "pivotRowTotals",
            "pivotColumnGroupTotals",
            "suppressExpandablePivotGroups"
        ]);
        const aggregateStageRefreshProps = /* @__PURE__ */ new Set([
            "getGroupRowAgg",
            "alwaysAggregateAtRootLevel",
            "groupIncludeTotalFooter",
            "suppressAggFilteredOnly",
            "grandTotalRow"
        ]);
        const sortStageRefreshProps = /* @__PURE__ */ new Set([
            "postSortRows",
            "groupDisplayType",
            "accentedSort"
        ]);
        const filterAggStageRefreshProps = /* @__PURE__ */ new Set([]);
        const flattenStageRefreshProps = /* @__PURE__ */ new Set([
            "groupRemoveSingleChildren",
            "groupRemoveLowestSingleChildren",
            "groupIncludeFooter",
            "groupTotalRow"
        ]);
        const allProps = [
            ...resetProps,
            ...groupStageRefreshProps,
            ...filterStageRefreshProps,
            ...pivotStageRefreshProps,
            ...pivotStageRefreshProps,
            ...aggregateStageRefreshProps,
            ...sortStageRefreshProps,
            ...filterAggStageRefreshProps,
            ...flattenStageRefreshProps
        ];
        this.addManagedPropertyListeners(allProps, (params)=>{
            var _a;
            const properties = (_a = params.changeSet) == null ? void 0 : _a.properties;
            if (!properties) return;
            const arePropertiesImpacted = (propSet)=>properties.some((prop)=>propSet.has(prop));
            if (arePropertiesImpacted(resetProps)) {
                this.setRowData(this.rootNode.allLeafChildren.map((child)=>child.data));
                return;
            }
            if (arePropertiesImpacted(groupStageRefreshProps)) {
                this.refreshModel({
                    step: "group" /* EVERYTHING */ 
                });
                return;
            }
            if (arePropertiesImpacted(filterStageRefreshProps)) {
                this.refreshModel({
                    step: "filter" /* FILTER */ 
                });
                return;
            }
            if (arePropertiesImpacted(pivotStageRefreshProps)) {
                this.refreshModel({
                    step: "pivot" /* PIVOT */ 
                });
                return;
            }
            if (arePropertiesImpacted(aggregateStageRefreshProps)) {
                this.refreshModel({
                    step: "aggregate" /* AGGREGATE */ 
                });
                return;
            }
            if (arePropertiesImpacted(sortStageRefreshProps)) {
                this.refreshModel({
                    step: "sort" /* SORT */ 
                });
                return;
            }
            if (arePropertiesImpacted(filterAggStageRefreshProps)) {
                this.refreshModel({
                    step: "filter_aggregates" /* FILTER_AGGREGATES */ 
                });
                return;
            }
            if (arePropertiesImpacted(flattenStageRefreshProps)) this.refreshModel({
                step: "map" /* MAP */ 
            });
        });
        this.addManagedPropertyListener("rowHeight", ()=>this.resetRowHeights());
    }
    start() {
        this.hasStarted = true;
        if (this.shouldSkipSettingDataOnStart) this.dispatchUpdateEventsAndRefresh();
        else this.setInitialData();
    }
    setInitialData() {
        const rowData = this.gos.get("rowData");
        if (rowData) {
            this.shouldSkipSettingDataOnStart = true;
            this.setRowData(rowData);
        }
    }
    ensureRowHeightsValid(startPixel, endPixel, startLimitIndex, endLimitIndex) {
        let atLeastOneChange;
        let res = false;
        do {
            atLeastOneChange = false;
            const rowAtStartPixel = this.getRowIndexAtPixel(startPixel);
            const rowAtEndPixel = this.getRowIndexAtPixel(endPixel);
            const firstRow = Math.max(rowAtStartPixel, startLimitIndex);
            const lastRow = Math.min(rowAtEndPixel, endLimitIndex);
            for(let rowIndex = firstRow; rowIndex <= lastRow; rowIndex++){
                const rowNode = this.getRow(rowIndex);
                if (rowNode.rowHeightEstimated) {
                    const rowHeight = this.gos.getRowHeightForNode(rowNode);
                    rowNode.setRowHeight(rowHeight.height);
                    atLeastOneChange = true;
                    res = true;
                }
            }
            if (atLeastOneChange) this.setRowTopAndRowIndex();
        }while (atLeastOneChange);
        return res;
    }
    setRowTopAndRowIndex() {
        const defaultRowHeight = this.environment.getDefaultRowHeight();
        let nextRowTop = 0;
        const displayedRowsMapped = /* @__PURE__ */ new Set();
        const allowEstimate = this.gos.isDomLayout("normal");
        for(let i = 0; i < this.rowsToDisplay.length; i++){
            const rowNode = this.rowsToDisplay[i];
            if (rowNode.id != null) displayedRowsMapped.add(rowNode.id);
            if (rowNode.rowHeight == null) {
                const rowHeight = this.gos.getRowHeightForNode(rowNode, allowEstimate, defaultRowHeight);
                rowNode.setRowHeight(rowHeight.height, rowHeight.estimated);
            }
            rowNode.setRowTop(nextRowTop);
            rowNode.setRowIndex(i);
            nextRowTop += rowNode.rowHeight;
        }
        return displayedRowsMapped;
    }
    clearRowTopAndRowIndex(changedPath, displayedRowsMapped) {
        const changedPathActive = changedPath.isActive();
        const clearIfNotDisplayed = (rowNode)=>{
            if (rowNode && rowNode.id != null && !displayedRowsMapped.has(rowNode.id)) rowNode.clearRowTopAndRowIndex();
        };
        const recurse = (rowNode)=>{
            clearIfNotDisplayed(rowNode);
            clearIfNotDisplayed(rowNode.detailNode);
            clearIfNotDisplayed(rowNode.sibling);
            if (rowNode.hasChildren()) {
                if (rowNode.childrenAfterGroup) {
                    const isRootNode = rowNode.level == -1;
                    const skipChildren = changedPathActive && !isRootNode && !rowNode.expanded;
                    if (!skipChildren) rowNode.childrenAfterGroup.forEach(recurse);
                }
            }
        };
        recurse(this.rootNode);
    }
    // returns false if row was moved, otherwise true
    ensureRowsAtPixel(rowNodes, pixel, increment = 0) {
        const indexAtPixelNow = this.getRowIndexAtPixel(pixel);
        const rowNodeAtPixelNow = this.getRow(indexAtPixelNow);
        const animate = !this.gos.get("suppressAnimationFrame");
        if (rowNodeAtPixelNow === rowNodes[0]) return false;
        rowNodes.forEach((rowNode)=>{
            $437b23f6a393c3bf$export$71511d61b312f219.removeFromArray(this.rootNode.allLeafChildren, rowNode);
        });
        rowNodes.forEach((rowNode, idx)=>{
            $437b23f6a393c3bf$export$71511d61b312f219.insertIntoArray(this.rootNode.allLeafChildren, rowNode, Math.max(indexAtPixelNow + increment, 0) + idx);
        });
        this.refreshModel({
            step: "group" /* EVERYTHING */ ,
            keepRenderedRows: true,
            keepEditingRows: true,
            animate: animate
        });
        return true;
    }
    highlightRowAtPixel(rowNode, pixel) {
        const indexAtPixelNow = pixel != null ? this.getRowIndexAtPixel(pixel) : null;
        const rowNodeAtPixelNow = indexAtPixelNow != null ? this.getRow(indexAtPixelNow) : null;
        if (!rowNodeAtPixelNow || !rowNode || rowNodeAtPixelNow === rowNode || pixel == null) {
            if (this.lastHighlightedRow) {
                this.lastHighlightedRow.setHighlighted(null);
                this.lastHighlightedRow = null;
            }
            return;
        }
        const highlight = this.getHighlightPosition(pixel, rowNodeAtPixelNow);
        if (this.lastHighlightedRow && this.lastHighlightedRow !== rowNodeAtPixelNow) {
            this.lastHighlightedRow.setHighlighted(null);
            this.lastHighlightedRow = null;
        }
        rowNodeAtPixelNow.setHighlighted(highlight);
        this.lastHighlightedRow = rowNodeAtPixelNow;
    }
    getHighlightPosition(pixel, rowNode) {
        if (!rowNode) {
            const index = this.getRowIndexAtPixel(pixel);
            rowNode = this.getRow(index || 0);
            if (!rowNode) return 1 /* Below */ ;
        }
        const { rowTop: rowTop, rowHeight: rowHeight } = rowNode;
        return pixel - rowTop < rowHeight / 2 ? 0 /* Above */  : 1 /* Below */ ;
    }
    getLastHighlightedRowNode() {
        return this.lastHighlightedRow;
    }
    isLastRowIndexKnown() {
        return true;
    }
    getRowCount() {
        if (this.rowsToDisplay) return this.rowsToDisplay.length;
        return 0;
    }
    getTopLevelRowCount() {
        const showingRootNode = this.rowsToDisplay && this.rowsToDisplay[0] === this.rootNode;
        if (showingRootNode) return 1;
        const filteredChildren = this.rootNode.childrenAfterAggFilter;
        return filteredChildren ? filteredChildren.length : 0;
    }
    getTopLevelRowDisplayedIndex(topLevelIndex) {
        const showingRootNode = this.rowsToDisplay && this.rowsToDisplay[0] === this.rootNode;
        if (showingRootNode) return topLevelIndex;
        let rowNode = this.rootNode.childrenAfterSort[topLevelIndex];
        if (this.gos.get("groupHideOpenParents")) while(rowNode.expanded && rowNode.childrenAfterSort && rowNode.childrenAfterSort.length > 0)rowNode = rowNode.childrenAfterSort[0];
        return rowNode.rowIndex;
    }
    getRowBounds(index) {
        if ($437b23f6a393c3bf$export$71511d61b312f219.missing(this.rowsToDisplay)) return null;
        const rowNode = this.rowsToDisplay[index];
        if (rowNode) return {
            rowTop: rowNode.rowTop,
            rowHeight: rowNode.rowHeight
        };
        return null;
    }
    onRowGroupOpened() {
        const animate = this.gos.isAnimateRows();
        this.refreshModel({
            step: "map" /* MAP */ ,
            keepRenderedRows: true,
            animate: animate
        });
    }
    onFilterChanged(event) {
        if (event.afterDataChange) return;
        const animate = this.gos.isAnimateRows();
        const primaryOrQuickFilterChanged = event.columns.length === 0 || event.columns.some((col)=>col.isPrimary());
        const step = primaryOrQuickFilterChanged ? "filter" /* FILTER */  : "filter_aggregates" /* FILTER_AGGREGATES */ ;
        this.refreshModel({
            step: step,
            keepRenderedRows: true,
            animate: animate
        });
    }
    onSortChanged() {
        const animate = this.gos.isAnimateRows();
        this.refreshModel({
            step: "sort" /* SORT */ ,
            keepRenderedRows: true,
            animate: animate,
            keepEditingRows: true
        });
    }
    getType() {
        return "clientSide";
    }
    onValueChanged() {
        if (this.columnModel.isPivotActive()) this.refreshModel({
            step: "pivot" /* PIVOT */ 
        });
        else this.refreshModel({
            step: "aggregate" /* AGGREGATE */ 
        });
    }
    createChangePath(rowNodeTransactions) {
        const noTransactions = $437b23f6a393c3bf$export$71511d61b312f219.missingOrEmpty(rowNodeTransactions);
        const changedPath = new $437b23f6a393c3bf$export$cb4d9114a9732e85(false, this.rootNode);
        if (noTransactions || this.gos.get("treeData")) changedPath.setInactive();
        return changedPath;
    }
    isSuppressModelUpdateAfterUpdateTransaction(params) {
        if (!this.gos.get("suppressModelUpdateAfterUpdateTransaction")) return false;
        if (params.rowNodeTransactions == null) return false;
        const transWithAddsOrDeletes = params.rowNodeTransactions.filter((tx)=>tx.add != null && tx.add.length > 0 || tx.remove != null && tx.remove.length > 0);
        const transactionsContainUpdatesOnly = transWithAddsOrDeletes == null || transWithAddsOrDeletes.length == 0;
        return transactionsContainUpdatesOnly;
    }
    buildRefreshModelParams(step) {
        let paramsStep = "group" /* EVERYTHING */ ;
        const stepsMapped = {
            everything: "group" /* EVERYTHING */ ,
            group: "group" /* EVERYTHING */ ,
            filter: "filter" /* FILTER */ ,
            map: "map" /* MAP */ ,
            aggregate: "aggregate" /* AGGREGATE */ ,
            sort: "sort" /* SORT */ ,
            pivot: "pivot" /* PIVOT */ 
        };
        if ($437b23f6a393c3bf$export$71511d61b312f219.exists(step)) paramsStep = stepsMapped[step];
        if ($437b23f6a393c3bf$export$71511d61b312f219.missing(paramsStep)) {
            console.error(`AG Grid: invalid step ${step}, available steps are ${Object.keys(stepsMapped).join(", ")}`);
            return void 0;
        }
        const animate = !this.gos.get("suppressAnimationFrame");
        const modelParams = {
            step: paramsStep,
            keepRenderedRows: true,
            keepEditingRows: true,
            animate: animate
        };
        return modelParams;
    }
    refreshModel(paramsOrStep) {
        if (!this.hasStarted || this.isRefreshingModel || this.columnModel.shouldRowModelIgnoreRefresh()) return;
        let params = typeof paramsOrStep === "object" && "step" in paramsOrStep ? paramsOrStep : this.buildRefreshModelParams(paramsOrStep);
        if (!params) return;
        if (this.isSuppressModelUpdateAfterUpdateTransaction(params)) return;
        const changedPath = this.createChangePath(params.rowNodeTransactions);
        this.isRefreshingModel = true;
        switch(params.step){
            case "group" /* EVERYTHING */ :
                this.doRowGrouping(params.rowNodeTransactions, params.rowNodeOrder, changedPath, !!params.afterColumnsChanged);
            case "filter" /* FILTER */ :
                this.doFilter(changedPath);
            case "pivot" /* PIVOT */ :
                this.doPivot(changedPath);
            case "aggregate" /* AGGREGATE */ :
                this.doAggregate(changedPath);
            case "filter_aggregates" /* FILTER_AGGREGATES */ :
                this.doFilterAggregates(changedPath);
            case "sort" /* SORT */ :
                this.doSort(params.rowNodeTransactions, changedPath);
            case "map" /* MAP */ :
                this.doRowsToDisplay();
        }
        const displayedNodesMapped = this.setRowTopAndRowIndex();
        this.clearRowTopAndRowIndex(changedPath, displayedNodesMapped);
        this.isRefreshingModel = false;
        const event = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_MODEL_UPDATED,
            animate: params.animate,
            keepRenderedRows: params.keepRenderedRows,
            newData: params.newData,
            newPage: false,
            keepUndoRedoStack: params.keepUndoRedoStack
        };
        this.eventService.dispatchEvent(event);
    }
    isEmpty() {
        const rowsMissing = $437b23f6a393c3bf$export$71511d61b312f219.missing(this.rootNode.allLeafChildren) || this.rootNode.allLeafChildren.length === 0;
        return $437b23f6a393c3bf$export$71511d61b312f219.missing(this.rootNode) || rowsMissing || !this.columnModel.isReady();
    }
    isRowsToRender() {
        return $437b23f6a393c3bf$export$71511d61b312f219.exists(this.rowsToDisplay) && this.rowsToDisplay.length > 0;
    }
    getNodesInRangeForSelection(firstInRange, lastInRange) {
        let started = !lastInRange;
        let finished = false;
        const result = [];
        const groupsSelectChildren = this.gos.get("groupSelectsChildren");
        this.forEachNodeAfterFilterAndSort((rowNode)=>{
            if (finished) return;
            if (started) {
                if (rowNode === lastInRange || rowNode === firstInRange) {
                    finished = true;
                    if (rowNode.group && groupsSelectChildren) {
                        result.push(...rowNode.allLeafChildren);
                        return;
                    }
                }
            }
            if (!started) {
                if (rowNode !== lastInRange && rowNode !== firstInRange) return;
                started = true;
            }
            const includeThisNode = !rowNode.group || !groupsSelectChildren;
            if (includeThisNode) {
                result.push(rowNode);
                return;
            }
        });
        return result;
    }
    setDatasource(datasource) {
        console.error("AG Grid: should never call setDatasource on clientSideRowController");
    }
    getTopLevelNodes() {
        return this.rootNode ? this.rootNode.childrenAfterGroup : null;
    }
    getRootNode() {
        return this.rootNode;
    }
    getRow(index) {
        return this.rowsToDisplay[index];
    }
    isRowPresent(rowNode) {
        return this.rowsToDisplay.indexOf(rowNode) >= 0;
    }
    getRowIndexAtPixel(pixelToMatch) {
        if (this.isEmpty() || this.rowsToDisplay.length === 0) return -1;
        let bottomPointer = 0;
        let topPointer = this.rowsToDisplay.length - 1;
        if (pixelToMatch <= 0) return 0;
        const lastNode = $437b23f6a393c3bf$export$71511d61b312f219.last(this.rowsToDisplay);
        if (lastNode.rowTop <= pixelToMatch) return this.rowsToDisplay.length - 1;
        let oldBottomPointer = -1;
        let oldTopPointer = -1;
        while(true){
            const midPointer = Math.floor((bottomPointer + topPointer) / 2);
            const currentRowNode = this.rowsToDisplay[midPointer];
            if (this.isRowInPixel(currentRowNode, pixelToMatch)) return midPointer;
            if (currentRowNode.rowTop < pixelToMatch) bottomPointer = midPointer + 1;
            else if (currentRowNode.rowTop > pixelToMatch) topPointer = midPointer - 1;
            const caughtInInfiniteLoop = oldBottomPointer === bottomPointer && oldTopPointer === topPointer;
            if (caughtInInfiniteLoop) return midPointer;
            oldBottomPointer = bottomPointer;
            oldTopPointer = topPointer;
        }
    }
    isRowInPixel(rowNode, pixelToMatch) {
        const topPixel = rowNode.rowTop;
        const bottomPixel = rowNode.rowTop + rowNode.rowHeight;
        const pixelInRow = topPixel <= pixelToMatch && bottomPixel > pixelToMatch;
        return pixelInRow;
    }
    forEachLeafNode(callback) {
        if (this.rootNode.allLeafChildren) this.rootNode.allLeafChildren.forEach((rowNode, index)=>callback(rowNode, index));
    }
    forEachNode(callback, includeFooterNodes = false) {
        this.recursivelyWalkNodesAndCallback({
            nodes: [
                ...this.rootNode.childrenAfterGroup || []
            ],
            callback: callback,
            recursionType: 0 /* Normal */ ,
            index: 0,
            includeFooterNodes: includeFooterNodes
        });
    }
    forEachNodeAfterFilter(callback, includeFooterNodes = false) {
        this.recursivelyWalkNodesAndCallback({
            nodes: [
                ...this.rootNode.childrenAfterAggFilter || []
            ],
            callback: callback,
            recursionType: 1 /* AfterFilter */ ,
            index: 0,
            includeFooterNodes: includeFooterNodes
        });
    }
    forEachNodeAfterFilterAndSort(callback, includeFooterNodes = false) {
        this.recursivelyWalkNodesAndCallback({
            nodes: [
                ...this.rootNode.childrenAfterSort || []
            ],
            callback: callback,
            recursionType: 2 /* AfterFilterAndSort */ ,
            index: 0,
            includeFooterNodes: includeFooterNodes
        });
    }
    forEachPivotNode(callback, includeFooterNodes = false) {
        this.recursivelyWalkNodesAndCallback({
            nodes: [
                this.rootNode
            ],
            callback: callback,
            recursionType: 3 /* PivotNodes */ ,
            index: 0,
            includeFooterNodes: includeFooterNodes
        });
    }
    // iterates through each item in memory, and calls the callback function
    // nodes - the rowNodes to traverse
    // callback - the user provided callback
    // recursion type - need this to know what child nodes to recurse, eg if looking at all nodes, or filtered notes etc
    // index - works similar to the index in forEach in javascript's array function
    recursivelyWalkNodesAndCallback(params) {
        const { nodes: nodes, callback: callback, recursionType: recursionType, includeFooterNodes: includeFooterNodes } = params;
        let { index: index } = params;
        const addFooters = (position)=>{
            var _a;
            const parentNode = (_a = nodes[0]) == null ? void 0 : _a.parent;
            if (!parentNode) return;
            const grandTotal = includeFooterNodes && this.gos.getGrandTotalRow();
            const isGroupIncludeFooter = this.gos.getGroupTotalRowCallback();
            const groupTotal = includeFooterNodes && isGroupIncludeFooter({
                node: parentNode
            });
            const isRootNode = parentNode === this.rootNode;
            if (isRootNode) {
                if (grandTotal === position) {
                    parentNode.createFooter();
                    callback(parentNode.sibling, index++);
                }
                return;
            }
            if (groupTotal === position) {
                parentNode.createFooter();
                callback(parentNode.sibling, index++);
            }
        };
        addFooters("top");
        for(let i = 0; i < nodes.length; i++){
            const node = nodes[i];
            callback(node, index++);
            if (node.hasChildren() && !node.footer) {
                let nodeChildren = null;
                switch(recursionType){
                    case 0 /* Normal */ :
                        nodeChildren = node.childrenAfterGroup;
                        break;
                    case 1 /* AfterFilter */ :
                        nodeChildren = node.childrenAfterAggFilter;
                        break;
                    case 2 /* AfterFilterAndSort */ :
                        nodeChildren = node.childrenAfterSort;
                        break;
                    case 3 /* PivotNodes */ :
                        nodeChildren = !node.leafGroup ? node.childrenAfterSort : null;
                        break;
                }
                if (nodeChildren) index = this.recursivelyWalkNodesAndCallback({
                    nodes: [
                        ...nodeChildren
                    ],
                    callback: callback,
                    recursionType: recursionType,
                    index: index,
                    includeFooterNodes: includeFooterNodes
                });
            }
        }
        addFooters("bottom");
        return index;
    }
    // it's possible to recompute the aggregate without doing the other parts
    // + api.refreshClientSideRowModel('aggregate')
    doAggregate(changedPath) {
        var _a;
        (_a = this.aggregationStage) == null || _a.execute({
            rowNode: this.rootNode,
            changedPath: changedPath
        });
    }
    doFilterAggregates(changedPath) {
        if (this.filterAggregatesStage) this.filterAggregatesStage.execute({
            rowNode: this.rootNode,
            changedPath: changedPath
        });
        else this.rootNode.childrenAfterAggFilter = this.rootNode.childrenAfterFilter;
    }
    // + gridApi.expandAll()
    // + gridApi.collapseAll()
    expandOrCollapseAll(expand) {
        const usingTreeData = this.gos.get("treeData");
        const usingPivotMode = this.columnModel.isPivotActive();
        const recursiveExpandOrCollapse = (rowNodes)=>{
            if (!rowNodes) return;
            rowNodes.forEach((rowNode)=>{
                const actionRow = ()=>{
                    rowNode.expanded = expand;
                    recursiveExpandOrCollapse(rowNode.childrenAfterGroup);
                };
                if (usingTreeData) {
                    const hasChildren = $437b23f6a393c3bf$export$71511d61b312f219.exists(rowNode.childrenAfterGroup);
                    if (hasChildren) actionRow();
                    return;
                }
                if (usingPivotMode) {
                    const notLeafGroup = !rowNode.leafGroup;
                    if (notLeafGroup) actionRow();
                    return;
                }
                const isRowGroup = rowNode.group;
                if (isRowGroup) actionRow();
            });
        };
        if (this.rootNode) recursiveExpandOrCollapse(this.rootNode.childrenAfterGroup);
        this.refreshModel({
            step: "map" /* MAP */ 
        });
        const eventSource = expand ? "expandAll" : "collapseAll";
        const event = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_EXPAND_COLLAPSE_ALL,
            source: eventSource
        };
        this.eventService.dispatchEvent(event);
    }
    doSort(rowNodeTransactions, changedPath) {
        this.sortStage.execute({
            rowNode: this.rootNode,
            rowNodeTransactions: rowNodeTransactions,
            changedPath: changedPath
        });
    }
    doRowGrouping(rowNodeTransactions, rowNodeOrder, changedPath, afterColumnsChanged) {
        if (this.groupStage) {
            if (rowNodeTransactions) this.groupStage.execute({
                rowNode: this.rootNode,
                rowNodeTransactions: rowNodeTransactions,
                rowNodeOrder: rowNodeOrder,
                changedPath: changedPath
            });
            else this.groupStage.execute({
                rowNode: this.rootNode,
                changedPath: changedPath,
                afterColumnsChanged: afterColumnsChanged
            });
            if (this.gos.get("groupSelectsChildren")) {
                const selectionChanged = this.selectionService.updateGroupsFromChildrenSelections("rowGroupChanged", changedPath);
                if (selectionChanged) {
                    const event = {
                        type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_SELECTION_CHANGED,
                        source: "rowGroupChanged"
                    };
                    this.eventService.dispatchEvent(event);
                }
            }
        } else {
            this.rootNode.childrenAfterGroup = this.rootNode.allLeafChildren;
            if (this.rootNode.sibling) this.rootNode.sibling.childrenAfterGroup = this.rootNode.childrenAfterGroup;
            this.rootNode.updateHasChildren();
        }
        if (this.nodeManager.isRowCountReady()) {
            this.rowCountReady = true;
            this.eventService.dispatchEventOnce({
                type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_COUNT_READY
            });
        }
    }
    doFilter(changedPath) {
        this.filterStage.execute({
            rowNode: this.rootNode,
            changedPath: changedPath
        });
    }
    doPivot(changedPath) {
        var _a;
        (_a = this.pivotStage) == null || _a.execute({
            rowNode: this.rootNode,
            changedPath: changedPath
        });
    }
    getCopyOfNodesMap() {
        return this.nodeManager.getCopyOfNodesMap();
    }
    getRowNode(id) {
        const idIsGroup = typeof id == "string" && id.indexOf($437b23f6a393c3bf$export$6af91cd58ec2edf9.ID_PREFIX_ROW_GROUP) == 0;
        if (idIsGroup) {
            let res = void 0;
            this.forEachNode((node)=>{
                if (node.id === id) res = node;
            });
            return res;
        }
        return this.nodeManager.getRowNode(id);
    }
    // rows: the rows to put into the model
    setRowData(rowData) {
        this.selectionService.reset("rowDataChanged");
        this.nodeManager.setRowData(rowData);
        if (this.hasStarted) this.dispatchUpdateEventsAndRefresh();
    }
    dispatchUpdateEventsAndRefresh() {
        const rowDataUpdatedEvent = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_DATA_UPDATED
        };
        this.eventService.dispatchEvent(rowDataUpdatedEvent);
        this.refreshModel({
            step: "group" /* EVERYTHING */ ,
            newData: true
        });
    }
    batchUpdateRowData(rowDataTransaction, callback) {
        if (this.applyAsyncTransactionsTimeout == null) {
            this.rowDataTransactionBatch = [];
            const waitMillis = this.gos.getAsyncTransactionWaitMillis();
            this.applyAsyncTransactionsTimeout = window.setTimeout(()=>{
                this.executeBatchUpdateRowData();
            }, waitMillis);
        }
        this.rowDataTransactionBatch.push({
            rowDataTransaction: rowDataTransaction,
            callback: callback
        });
    }
    flushAsyncTransactions() {
        if (this.applyAsyncTransactionsTimeout != null) {
            clearTimeout(this.applyAsyncTransactionsTimeout);
            this.executeBatchUpdateRowData();
        }
    }
    executeBatchUpdateRowData() {
        this.valueCache.onDataChanged();
        const callbackFuncsBound = [];
        const rowNodeTrans = [];
        let forceRowNodeOrder = false;
        if (this.rowDataTransactionBatch) this.rowDataTransactionBatch.forEach((tranItem)=>{
            const rowNodeTran = this.nodeManager.updateRowData(tranItem.rowDataTransaction, void 0);
            rowNodeTrans.push(rowNodeTran);
            if (tranItem.callback) callbackFuncsBound.push(tranItem.callback.bind(null, rowNodeTran));
            if (typeof tranItem.rowDataTransaction.addIndex === "number") forceRowNodeOrder = true;
        });
        this.commonUpdateRowData(rowNodeTrans, void 0, forceRowNodeOrder);
        if (callbackFuncsBound.length > 0) window.setTimeout(()=>{
            callbackFuncsBound.forEach((func)=>func());
        }, 0);
        if (rowNodeTrans.length > 0) {
            const event = {
                type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_ASYNC_TRANSACTIONS_FLUSHED,
                results: rowNodeTrans
            };
            this.eventService.dispatchEvent(event);
        }
        this.rowDataTransactionBatch = null;
        this.applyAsyncTransactionsTimeout = void 0;
    }
    updateRowData(rowDataTran, rowNodeOrder) {
        this.valueCache.onDataChanged();
        const rowNodeTran = this.nodeManager.updateRowData(rowDataTran, rowNodeOrder);
        const forceRowNodeOrder = typeof rowDataTran.addIndex === "number";
        this.commonUpdateRowData([
            rowNodeTran
        ], rowNodeOrder, forceRowNodeOrder);
        return rowNodeTran;
    }
    createRowNodeOrder() {
        const suppressSortOrder = this.gos.get("suppressMaintainUnsortedOrder");
        if (suppressSortOrder) return;
        const orderMap = {};
        if (this.rootNode && this.rootNode.allLeafChildren) for(let index = 0; index < this.rootNode.allLeafChildren.length; index++){
            const node = this.rootNode.allLeafChildren[index];
            orderMap[node.id] = index;
        }
        return orderMap;
    }
    // common to updateRowData and batchUpdateRowData
    commonUpdateRowData(rowNodeTrans, rowNodeOrder, forceRowNodeOrder) {
        if (!this.hasStarted) return;
        const animate = !this.gos.get("suppressAnimationFrame");
        if (forceRowNodeOrder) rowNodeOrder = this.createRowNodeOrder();
        const event = {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_DATA_UPDATED
        };
        this.eventService.dispatchEvent(event);
        this.refreshModel({
            step: "group" /* EVERYTHING */ ,
            rowNodeTransactions: rowNodeTrans,
            rowNodeOrder: rowNodeOrder,
            keepRenderedRows: true,
            keepEditingRows: true,
            animate: animate
        });
    }
    doRowsToDisplay() {
        this.rowsToDisplay = this.flattenStage.execute({
            rowNode: this.rootNode
        });
    }
    onRowHeightChanged() {
        this.refreshModel({
            step: "map" /* MAP */ ,
            keepRenderedRows: true,
            keepEditingRows: true,
            keepUndoRedoStack: true
        });
    }
    /** This method is debounced. It is used for row auto-height. If we don't debounce,
   * then the Row Models will end up recalculating each row position
   * for each row height change and result in the Row Renderer laying out rows.
   * This is particularly bad if using print layout, and showing eg 1,000 rows,
   * each row will change it's height, causing Row Model to update 1,000 times.
   */ onRowHeightChangedDebounced() {
        this.onRowHeightChanged_debounced();
    }
    resetRowHeights() {
        const atLeastOne = this.resetRowHeightsForAllRowNodes();
        this.rootNode.setRowHeight(this.rootNode.rowHeight, true);
        if (this.rootNode.sibling) this.rootNode.sibling.setRowHeight(this.rootNode.sibling.rowHeight, true);
        if (atLeastOne) this.onRowHeightChanged();
    }
    resetRowHeightsForAllRowNodes() {
        let atLeastOne = false;
        this.forEachNode((rowNode)=>{
            rowNode.setRowHeight(rowNode.rowHeight, true);
            const detailNode = rowNode.detailNode;
            if (detailNode) detailNode.setRowHeight(detailNode.rowHeight, true);
            if (rowNode.sibling) rowNode.sibling.setRowHeight(rowNode.sibling.rowHeight, true);
            atLeastOne = true;
        });
        return atLeastOne;
    }
    onGridStylesChanges() {
        if (this.columnModel.isAutoRowHeightActive()) return;
        this.resetRowHeights();
    }
    onGridReady() {
        if (this.hasStarted) return;
        this.setInitialData();
    }
    isRowDataLoaded() {
        return this.rowCountReady;
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnModel")
], $437b23f6a393c3bf$var$ClientSideRowModel.prototype, "columnModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("selectionService")
], $437b23f6a393c3bf$var$ClientSideRowModel.prototype, "selectionService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("valueCache")
], $437b23f6a393c3bf$var$ClientSideRowModel.prototype, "valueCache", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("beans")
], $437b23f6a393c3bf$var$ClientSideRowModel.prototype, "beans", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("filterStage")
], $437b23f6a393c3bf$var$ClientSideRowModel.prototype, "filterStage", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("sortStage")
], $437b23f6a393c3bf$var$ClientSideRowModel.prototype, "sortStage", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("flattenStage")
], $437b23f6a393c3bf$var$ClientSideRowModel.prototype, "flattenStage", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$7acb7b24c478f9c6("groupStage")
], $437b23f6a393c3bf$var$ClientSideRowModel.prototype, "groupStage", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$7acb7b24c478f9c6("aggregationStage")
], $437b23f6a393c3bf$var$ClientSideRowModel.prototype, "aggregationStage", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$7acb7b24c478f9c6("pivotStage")
], $437b23f6a393c3bf$var$ClientSideRowModel.prototype, "pivotStage", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$7acb7b24c478f9c6("filterAggregatesStage")
], $437b23f6a393c3bf$var$ClientSideRowModel.prototype, "filterAggregatesStage", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$ClientSideRowModel.prototype, "init", 1);
$437b23f6a393c3bf$var$ClientSideRowModel = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("rowModel")
], $437b23f6a393c3bf$var$ClientSideRowModel);
// community-modules/client-side-row-model/src/clientSideRowModel/filterStage.ts
var $437b23f6a393c3bf$var$FilterStage = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    execute(params) {
        const { changedPath: changedPath } = params;
        this.filterService.filter(changedPath);
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("filterService")
], $437b23f6a393c3bf$var$FilterStage.prototype, "filterService", 2);
$437b23f6a393c3bf$var$FilterStage = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("filterStage")
], $437b23f6a393c3bf$var$FilterStage);
// community-modules/client-side-row-model/src/clientSideRowModel/sortStage.ts
var $437b23f6a393c3bf$var$SortStage = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    execute(params) {
        const sortOptions = this.sortController.getSortOptions();
        const sortActive = $437b23f6a393c3bf$export$71511d61b312f219.exists(sortOptions) && sortOptions.length > 0;
        const deltaSort = sortActive && $437b23f6a393c3bf$export$71511d61b312f219.exists(params.rowNodeTransactions) && this.gos.get("deltaSort");
        const sortContainsGroupColumns = sortOptions.some((opt)=>{
            const isSortingCoupled = this.gos.isColumnsSortingCoupledToGroup();
            if (isSortingCoupled) return opt.column.isPrimary() && opt.column.isRowGroupActive();
            return !!opt.column.getColDef().showRowGroup;
        });
        this.sortService.sort(sortOptions, sortActive, deltaSort, params.rowNodeTransactions, params.changedPath, sortContainsGroupColumns);
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("sortService")
], $437b23f6a393c3bf$var$SortStage.prototype, "sortService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("sortController")
], $437b23f6a393c3bf$var$SortStage.prototype, "sortController", 2);
$437b23f6a393c3bf$var$SortStage = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("sortStage")
], $437b23f6a393c3bf$var$SortStage);
// community-modules/client-side-row-model/src/clientSideRowModel/flattenStage.ts
var $437b23f6a393c3bf$var$FlattenStage = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    execute(params) {
        const rootNode = params.rowNode;
        const result = [];
        const skipLeafNodes = this.beans.columnModel.isPivotMode();
        const showRootNode = skipLeafNodes && rootNode.leafGroup;
        const topList = showRootNode ? [
            rootNode
        ] : rootNode.childrenAfterSort;
        const details = this.getFlattenDetails();
        this.recursivelyAddToRowsToDisplay(details, topList, result, skipLeafNodes, 0);
        const atLeastOneRowPresent = result.length > 0;
        const includeGrandTotalRow = !showRootNode && atLeastOneRowPresent && details.grandTotalRow;
        if (includeGrandTotalRow) {
            rootNode.createFooter();
            const addToTop = details.grandTotalRow === "top";
            this.addRowNodeToRowsToDisplay(details, rootNode.sibling, result, 0, addToTop);
        }
        return result;
    }
    getFlattenDetails() {
        const groupRemoveSingleChildren = this.gos.get("groupRemoveSingleChildren");
        const groupRemoveLowestSingleChildren = !groupRemoveSingleChildren && this.gos.get("groupRemoveLowestSingleChildren");
        return {
            groupRemoveLowestSingleChildren: groupRemoveLowestSingleChildren,
            groupRemoveSingleChildren: groupRemoveSingleChildren,
            isGroupMultiAutoColumn: this.gos.isGroupMultiAutoColumn(),
            hideOpenParents: this.gos.get("groupHideOpenParents"),
            grandTotalRow: this.gos.getGrandTotalRow(),
            groupTotalRow: this.gos.getGroupTotalRowCallback()
        };
    }
    recursivelyAddToRowsToDisplay(details, rowsToFlatten, result, skipLeafNodes, uiLevel) {
        if ($437b23f6a393c3bf$export$71511d61b312f219.missingOrEmpty(rowsToFlatten)) return;
        for(let i = 0; i < rowsToFlatten.length; i++){
            const rowNode = rowsToFlatten[i];
            const isParent = rowNode.hasChildren();
            const isSkippedLeafNode = skipLeafNodes && !isParent;
            const isRemovedSingleChildrenGroup = details.groupRemoveSingleChildren && isParent && rowNode.childrenAfterGroup.length === 1;
            const isRemovedLowestSingleChildrenGroup = details.groupRemoveLowestSingleChildren && isParent && rowNode.leafGroup && rowNode.childrenAfterGroup.length === 1;
            const neverAllowToExpand = skipLeafNodes && rowNode.leafGroup;
            const isHiddenOpenParent = details.hideOpenParents && rowNode.expanded && !rowNode.master && !neverAllowToExpand;
            const thisRowShouldBeRendered = !isSkippedLeafNode && !isHiddenOpenParent && !isRemovedSingleChildrenGroup && !isRemovedLowestSingleChildrenGroup;
            if (thisRowShouldBeRendered) this.addRowNodeToRowsToDisplay(details, rowNode, result, uiLevel);
            if (skipLeafNodes && rowNode.leafGroup) continue;
            if (isParent) {
                const excludedParent = isRemovedSingleChildrenGroup || isRemovedLowestSingleChildrenGroup;
                if (rowNode.expanded || excludedParent) {
                    const doesRowShowFooter = details.groupTotalRow({
                        node: rowNode
                    });
                    if (!doesRowShowFooter) rowNode.destroyFooter();
                    const uiLevelForChildren = excludedParent ? uiLevel : uiLevel + 1;
                    if (doesRowShowFooter === "top") {
                        rowNode.createFooter();
                        this.addRowNodeToRowsToDisplay(details, rowNode.sibling, result, uiLevelForChildren);
                    }
                    this.recursivelyAddToRowsToDisplay(details, rowNode.childrenAfterSort, result, skipLeafNodes, uiLevelForChildren);
                    if (doesRowShowFooter === "bottom") {
                        rowNode.createFooter();
                        this.addRowNodeToRowsToDisplay(details, rowNode.sibling, result, uiLevelForChildren);
                    }
                }
            } else if (rowNode.master && rowNode.expanded) {
                const detailNode = this.createDetailNode(rowNode);
                this.addRowNodeToRowsToDisplay(details, detailNode, result, uiLevel);
            }
        }
    }
    // duplicated method, it's also in floatingRowModel
    addRowNodeToRowsToDisplay(details, rowNode, result, uiLevel, addToTop) {
        if (addToTop) result.unshift(rowNode);
        else result.push(rowNode);
        rowNode.setUiLevel(details.isGroupMultiAutoColumn ? 0 : uiLevel);
    }
    createDetailNode(masterNode) {
        if ($437b23f6a393c3bf$export$71511d61b312f219.exists(masterNode.detailNode)) return masterNode.detailNode;
        const detailNode = new $437b23f6a393c3bf$export$6af91cd58ec2edf9(this.beans);
        detailNode.detail = true;
        detailNode.selectable = false;
        detailNode.parent = masterNode;
        if ($437b23f6a393c3bf$export$71511d61b312f219.exists(masterNode.id)) detailNode.id = "detail_" + masterNode.id;
        detailNode.data = masterNode.data;
        detailNode.level = masterNode.level + 1;
        masterNode.detailNode = detailNode;
        return detailNode;
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("beans")
], $437b23f6a393c3bf$var$FlattenStage.prototype, "beans", 2);
$437b23f6a393c3bf$var$FlattenStage = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("flattenStage")
], $437b23f6a393c3bf$var$FlattenStage);
// community-modules/client-side-row-model/src/clientSideRowModel/sortService.ts
var $437b23f6a393c3bf$var$SortService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    sort(sortOptions, sortActive, useDeltaSort, rowNodeTransactions, changedPath, sortContainsGroupColumns) {
        const groupMaintainOrder = this.gos.get("groupMaintainOrder");
        const groupColumnsPresent = this.columnModel.getAllGridColumns().some((c)=>c.isRowGroupActive());
        let allDirtyNodes = {};
        if (useDeltaSort && rowNodeTransactions) allDirtyNodes = this.calculateDirtyNodes(rowNodeTransactions);
        const isPivotMode = this.columnModel.isPivotMode();
        const postSortFunc = this.gos.getCallback("postSortRows");
        const callback = (rowNode)=>{
            var _a;
            this.pullDownGroupDataForHideOpenParents(rowNode.childrenAfterAggFilter, true);
            const skipSortingPivotLeafs = isPivotMode && rowNode.leafGroup;
            let skipSortingGroups = groupMaintainOrder && groupColumnsPresent && !rowNode.leafGroup && !sortContainsGroupColumns;
            if (skipSortingGroups) {
                const nextGroup = (_a = this.columnModel.getRowGroupColumns()) == null ? void 0 : _a[rowNode.level + 1];
                const wasSortExplicitlyRemoved = (nextGroup == null ? void 0 : nextGroup.getSort()) === null;
                const childrenToBeSorted = rowNode.childrenAfterAggFilter.slice(0);
                if (rowNode.childrenAfterSort && !wasSortExplicitlyRemoved) {
                    const indexedOrders = {};
                    rowNode.childrenAfterSort.forEach((node, idx)=>{
                        indexedOrders[node.id] = idx;
                    });
                    childrenToBeSorted.sort((row1, row2)=>{
                        var _a2, _b;
                        return ((_a2 = indexedOrders[row1.id]) != null ? _a2 : 0) - ((_b = indexedOrders[row2.id]) != null ? _b : 0);
                    });
                }
                rowNode.childrenAfterSort = childrenToBeSorted;
            } else if (!sortActive || skipSortingPivotLeafs) rowNode.childrenAfterSort = rowNode.childrenAfterAggFilter.slice(0);
            else if (useDeltaSort) rowNode.childrenAfterSort = this.doDeltaSort(rowNode, allDirtyNodes, changedPath, sortOptions);
            else rowNode.childrenAfterSort = this.rowNodeSorter.doFullSort(rowNode.childrenAfterAggFilter, sortOptions);
            if (rowNode.sibling) rowNode.sibling.childrenAfterSort = rowNode.childrenAfterSort;
            this.updateChildIndexes(rowNode);
            if (postSortFunc) {
                const params = {
                    nodes: rowNode.childrenAfterSort
                };
                postSortFunc(params);
            }
        };
        if (changedPath) changedPath.forEachChangedNodeDepthFirst(callback);
        this.updateGroupDataForHideOpenParents(changedPath);
    }
    calculateDirtyNodes(rowNodeTransactions) {
        const dirtyNodes = {};
        const addNodesFunc = (rowNodes)=>{
            if (rowNodes) rowNodes.forEach((rowNode)=>dirtyNodes[rowNode.id] = true);
        };
        if (rowNodeTransactions) rowNodeTransactions.forEach((tran)=>{
            addNodesFunc(tran.add);
            addNodesFunc(tran.update);
            addNodesFunc(tran.remove);
        });
        return dirtyNodes;
    }
    doDeltaSort(rowNode, allTouchedNodes, changedPath, sortOptions) {
        const unsortedRows = rowNode.childrenAfterAggFilter;
        const oldSortedRows = rowNode.childrenAfterSort;
        if (!oldSortedRows) return this.rowNodeSorter.doFullSort(unsortedRows, sortOptions);
        const untouchedRowsMap = {};
        const touchedRows = [];
        unsortedRows.forEach((row)=>{
            if (allTouchedNodes[row.id] || !changedPath.canSkip(row)) touchedRows.push(row);
            else untouchedRowsMap[row.id] = true;
        });
        const sortedUntouchedRows = oldSortedRows.filter((child)=>untouchedRowsMap[child.id]);
        const mapNodeToSortedNode = (rowNode2, pos)=>({
                currentPos: pos,
                rowNode: rowNode2
            });
        const sortedChangedRows = touchedRows.map(mapNodeToSortedNode).sort((a, b)=>this.rowNodeSorter.compareRowNodes(sortOptions, a, b));
        return this.mergeSortedArrays(sortOptions, sortedChangedRows, sortedUntouchedRows.map(mapNodeToSortedNode)).map(({ rowNode: rowNode2 })=>rowNode2);
    }
    // Merge two sorted arrays into each other
    mergeSortedArrays(sortOptions, arr1, arr2) {
        const res = [];
        let i = 0;
        let j = 0;
        while(i < arr1.length && j < arr2.length){
            const compareResult = this.rowNodeSorter.compareRowNodes(sortOptions, arr1[i], arr2[j]);
            if (compareResult < 0) res.push(arr1[i++]);
            else res.push(arr2[j++]);
        }
        while(i < arr1.length)res.push(arr1[i++]);
        while(j < arr2.length)res.push(arr2[j++]);
        return res;
    }
    updateChildIndexes(rowNode) {
        if ($437b23f6a393c3bf$export$71511d61b312f219.missing(rowNode.childrenAfterSort)) return;
        const listToSort = rowNode.childrenAfterSort;
        for(let i = 0; i < listToSort.length; i++){
            const child = listToSort[i];
            const firstChild = i === 0;
            const lastChild = i === rowNode.childrenAfterSort.length - 1;
            child.setFirstChild(firstChild);
            child.setLastChild(lastChild);
            child.setChildIndex(i);
        }
    }
    updateGroupDataForHideOpenParents(changedPath) {
        if (!this.gos.get("groupHideOpenParents")) return;
        if (this.gos.get("treeData")) {
            $437b23f6a393c3bf$export$71511d61b312f219.warnOnce(`The property hideOpenParents dose not work with Tree Data. This is because Tree Data has values at the group level, it doesn't make sense to hide them.`);
            return false;
        }
        const callback = (rowNode)=>{
            this.pullDownGroupDataForHideOpenParents(rowNode.childrenAfterSort, false);
            rowNode.childrenAfterSort.forEach((child)=>{
                if (child.hasChildren()) callback(child);
            });
        };
        if (changedPath) changedPath.executeFromRootNode((rowNode)=>callback(rowNode));
    }
    pullDownGroupDataForHideOpenParents(rowNodes, clearOperation) {
        if (!this.gos.get("groupHideOpenParents") || $437b23f6a393c3bf$export$71511d61b312f219.missing(rowNodes)) return;
        rowNodes.forEach((childRowNode)=>{
            const groupDisplayCols = this.columnModel.getGroupDisplayColumns();
            groupDisplayCols.forEach((groupDisplayCol)=>{
                const showRowGroup = groupDisplayCol.getColDef().showRowGroup;
                if (typeof showRowGroup !== "string") {
                    console.error("AG Grid: groupHideOpenParents only works when specifying specific columns for colDef.showRowGroup");
                    return;
                }
                const displayingGroupKey = showRowGroup;
                const rowGroupColumn = this.columnModel.getPrimaryColumn(displayingGroupKey);
                const thisRowNodeMatches = rowGroupColumn === childRowNode.rowGroupColumn;
                if (thisRowNodeMatches) return;
                if (clearOperation) childRowNode.setGroupValue(groupDisplayCol.getId(), void 0);
                else {
                    const parentToStealFrom = childRowNode.getFirstChildOfFirstChild(rowGroupColumn);
                    if (parentToStealFrom) childRowNode.setGroupValue(groupDisplayCol.getId(), parentToStealFrom.key);
                }
            });
        });
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnModel")
], $437b23f6a393c3bf$var$SortService.prototype, "columnModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowNodeSorter")
], $437b23f6a393c3bf$var$SortService.prototype, "rowNodeSorter", 2);
$437b23f6a393c3bf$var$SortService = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("sortService")
], $437b23f6a393c3bf$var$SortService);
// community-modules/client-side-row-model/src/clientSideRowModel/filterService.ts
var $437b23f6a393c3bf$var$FilterService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    filter(changedPath) {
        const filterActive = this.filterManager.isChildFilterPresent();
        this.filterNodes(filterActive, changedPath);
    }
    filterNodes(filterActive, changedPath) {
        const filterCallback = (rowNode, includeChildNodes)=>{
            if (rowNode.hasChildren()) {
                if (filterActive && !includeChildNodes) rowNode.childrenAfterFilter = rowNode.childrenAfterGroup.filter((childNode)=>{
                    const passBecauseChildren = childNode.childrenAfterFilter && childNode.childrenAfterFilter.length > 0;
                    const passBecauseDataPasses = childNode.data && this.filterManager.doesRowPassFilter({
                        rowNode: childNode
                    });
                    return passBecauseChildren || passBecauseDataPasses;
                });
                else rowNode.childrenAfterFilter = rowNode.childrenAfterGroup;
            } else rowNode.childrenAfterFilter = rowNode.childrenAfterGroup;
            if (rowNode.sibling) rowNode.sibling.childrenAfterFilter = rowNode.childrenAfterFilter;
        };
        if (this.doingTreeDataFiltering()) {
            const treeDataDepthFirstFilter = (rowNode, alreadyFoundInParent)=>{
                if (rowNode.childrenAfterGroup) for(let i = 0; i < rowNode.childrenAfterGroup.length; i++){
                    const childNode = rowNode.childrenAfterGroup[i];
                    const foundInParent = alreadyFoundInParent || this.filterManager.doesRowPassFilter({
                        rowNode: childNode
                    });
                    if (childNode.childrenAfterGroup) treeDataDepthFirstFilter(rowNode.childrenAfterGroup[i], foundInParent);
                    else filterCallback(childNode, foundInParent);
                }
                filterCallback(rowNode, alreadyFoundInParent);
            };
            const treeDataFilterCallback = (rowNode)=>treeDataDepthFirstFilter(rowNode, false);
            changedPath.executeFromRootNode(treeDataFilterCallback);
        } else {
            const defaultFilterCallback = (rowNode)=>filterCallback(rowNode, false);
            changedPath.forEachChangedNodeDepthFirst(defaultFilterCallback, true);
        }
    }
    doingTreeDataFiltering() {
        return this.gos.get("treeData") && !this.gos.get("excludeChildrenWhenTreeDataFiltering");
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("filterManager")
], $437b23f6a393c3bf$var$FilterService.prototype, "filterManager", 2);
$437b23f6a393c3bf$var$FilterService = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("filterService")
], $437b23f6a393c3bf$var$FilterService);
// community-modules/client-side-row-model/src/clientSideRowModel/immutableService.ts
var $437b23f6a393c3bf$var$ImmutableService = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    postConstruct() {
        if (this.rowModel.getType() === "clientSide") {
            this.clientSideRowModel = this.rowModel;
            this.addManagedPropertyListener("rowData", ()=>this.onRowDataUpdated());
        }
    }
    isActive() {
        const getRowIdProvided = this.gos.exists("getRowId");
        const resetRowDataOnUpdate = this.gos.get("resetRowDataOnUpdate");
        if (resetRowDataOnUpdate) return false;
        return getRowIdProvided;
    }
    setRowData(rowData) {
        const transactionAndMap = this.createTransactionForRowData(rowData);
        if (!transactionAndMap) return;
        const [transaction, orderIdMap] = transactionAndMap;
        this.clientSideRowModel.updateRowData(transaction, orderIdMap);
    }
    // converts the setRowData() command to a transaction
    createTransactionForRowData(rowData) {
        if ($437b23f6a393c3bf$export$71511d61b312f219.missing(this.clientSideRowModel)) {
            console.error("AG Grid: ImmutableService only works with ClientSideRowModel");
            return;
        }
        const getRowIdFunc = this.gos.getCallback("getRowId");
        if (getRowIdFunc == null) {
            console.error("AG Grid: ImmutableService requires getRowId() callback to be implemented, your row data needs IDs!");
            return;
        }
        const transaction = {
            remove: [],
            update: [],
            add: []
        };
        const existingNodesMap = this.clientSideRowModel.getCopyOfNodesMap();
        const suppressSortOrder = this.gos.get("suppressMaintainUnsortedOrder");
        const orderMap = suppressSortOrder ? void 0 : {};
        if ($437b23f6a393c3bf$export$71511d61b312f219.exists(rowData)) rowData.forEach((data, index)=>{
            const id = getRowIdFunc({
                data: data,
                level: 0
            });
            const existingNode = existingNodesMap[id];
            if (orderMap) orderMap[id] = index;
            if (existingNode) {
                const dataHasChanged = existingNode.data !== data;
                if (dataHasChanged) transaction.update.push(data);
                existingNodesMap[id] = void 0;
            } else transaction.add.push(data);
        });
        $437b23f6a393c3bf$export$71511d61b312f219.iterateObject(existingNodesMap, (id, rowNode)=>{
            if (rowNode) transaction.remove.push(rowNode.data);
        });
        return [
            transaction,
            orderMap
        ];
    }
    onRowDataUpdated() {
        const rowData = this.gos.get("rowData");
        if (!rowData) return;
        if (this.isActive()) this.setRowData(rowData);
        else {
            this.selectionService.reset("rowDataChanged");
            this.clientSideRowModel.setRowData(rowData);
        }
    }
};
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowModel")
], $437b23f6a393c3bf$var$ImmutableService.prototype, "rowModel", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowRenderer")
], $437b23f6a393c3bf$var$ImmutableService.prototype, "rowRenderer", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$4bf29303185cb747("selectionService")
], $437b23f6a393c3bf$var$ImmutableService.prototype, "selectionService", 2);
$437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$ImmutableService.prototype, "postConstruct", 1);
$437b23f6a393c3bf$var$ImmutableService = $437b23f6a393c3bf$var$__decorateClass([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("immutableService")
], $437b23f6a393c3bf$var$ImmutableService);
// community-modules/client-side-row-model/src/version.ts
var $437b23f6a393c3bf$var$VERSION = "31.3.4";
// community-modules/client-side-row-model/src/clientSideRowModelModule.ts
var $437b23f6a393c3bf$export$4c74201d5a94c8e5 = {
    version: $437b23f6a393c3bf$var$VERSION,
    moduleName: "@ag-grid-community/client-side-row-model" /* ClientSideRowModelModule */ ,
    rowModel: "clientSide",
    beans: [
        $437b23f6a393c3bf$var$ClientSideRowModel,
        $437b23f6a393c3bf$var$FilterStage,
        $437b23f6a393c3bf$var$SortStage,
        $437b23f6a393c3bf$var$FlattenStage,
        $437b23f6a393c3bf$var$SortService,
        $437b23f6a393c3bf$var$FilterService,
        $437b23f6a393c3bf$var$ImmutableService
    ]
};
// community-modules/infinite-row-model/dist/package/main.esm.mjs
var $437b23f6a393c3bf$var$__defProp2 = Object.defineProperty;
var $437b23f6a393c3bf$var$__getOwnPropDesc2 = Object.getOwnPropertyDescriptor;
var $437b23f6a393c3bf$var$__decorateClass2 = (decorators, target, key, kind)=>{
    var result = kind > 1 ? void 0 : kind ? $437b23f6a393c3bf$var$__getOwnPropDesc2(target, key) : target;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
    if (kind && result) $437b23f6a393c3bf$var$__defProp2(target, key, result);
    return result;
};
var $437b23f6a393c3bf$var$__decorateParam2 = (index, decorator)=>(target, key)=>decorator(target, key, index);
var $437b23f6a393c3bf$var$InfiniteBlock = class extends $437b23f6a393c3bf$export$eb7378abb0bca09e {
    constructor(id, parentCache, params){
        super(id);
        this.parentCache = parentCache;
        this.params = params;
        this.startRow = id * params.blockSize;
        this.endRow = this.startRow + params.blockSize;
    }
    postConstruct() {
        this.createRowNodes();
    }
    getBlockStateJson() {
        return {
            id: "" + this.getId(),
            state: {
                blockNumber: this.getId(),
                startRow: this.getStartRow(),
                endRow: this.getEndRow(),
                pageStatus: this.getState()
            }
        };
    }
    setDataAndId(rowNode, data, index) {
        if ($437b23f6a393c3bf$export$71511d61b312f219.exists(data)) rowNode.setDataAndId(data, index.toString());
        else rowNode.setDataAndId(void 0, void 0);
    }
    loadFromDatasource() {
        const params = this.createLoadParams();
        if ($437b23f6a393c3bf$export$71511d61b312f219.missing(this.params.datasource.getRows)) {
            console.warn(`AG Grid: datasource is missing getRows method`);
            return;
        }
        window.setTimeout(()=>{
            this.params.datasource.getRows(params);
        }, 0);
    }
    processServerFail() {}
    createLoadParams() {
        const params = {
            startRow: this.getStartRow(),
            endRow: this.getEndRow(),
            successCallback: this.pageLoaded.bind(this, this.getVersion()),
            failCallback: this.pageLoadFailed.bind(this, this.getVersion()),
            sortModel: this.params.sortModel,
            filterModel: this.params.filterModel,
            context: this.gos.getGridCommonParams().context
        };
        return params;
    }
    forEachNode(callback, sequence, rowCount) {
        this.rowNodes.forEach((rowNode, index)=>{
            const rowIndex = this.startRow + index;
            if (rowIndex < rowCount) callback(rowNode, sequence.next());
        });
    }
    getLastAccessed() {
        return this.lastAccessed;
    }
    getRow(rowIndex, dontTouchLastAccessed = false) {
        if (!dontTouchLastAccessed) this.lastAccessed = this.params.lastAccessedSequence.next();
        const localIndex = rowIndex - this.startRow;
        return this.rowNodes[localIndex];
    }
    getStartRow() {
        return this.startRow;
    }
    getEndRow() {
        return this.endRow;
    }
    // creates empty row nodes, data is missing as not loaded yet
    createRowNodes() {
        this.rowNodes = [];
        for(let i = 0; i < this.params.blockSize; i++){
            const rowIndex = this.startRow + i;
            const rowNode = new $437b23f6a393c3bf$export$6af91cd58ec2edf9(this.beans);
            rowNode.setRowHeight(this.params.rowHeight);
            rowNode.uiLevel = 0;
            rowNode.setRowIndex(rowIndex);
            rowNode.setRowTop(this.params.rowHeight * rowIndex);
            this.rowNodes.push(rowNode);
        }
    }
    processServerResult(params) {
        this.rowNodes.forEach((rowNode, index)=>{
            const data = params.rowData ? params.rowData[index] : void 0;
            if (!rowNode.id && rowNode.alreadyRendered && data) {
                this.rowNodes[index] = new $437b23f6a393c3bf$export$6af91cd58ec2edf9(this.beans);
                this.rowNodes[index].setRowIndex(rowNode.rowIndex);
                this.rowNodes[index].setRowTop(rowNode.rowTop);
                this.rowNodes[index].setRowHeight(rowNode.rowHeight);
                rowNode.clearRowTopAndRowIndex();
            }
            this.setDataAndId(this.rowNodes[index], data, this.startRow + index);
        });
        const finalRowCount = params.rowCount != null && params.rowCount >= 0 ? params.rowCount : void 0;
        this.parentCache.pageLoaded(this, finalRowCount);
    }
    destroyRowNodes() {
        this.rowNodes.forEach((rowNode)=>{
            rowNode.clearRowTopAndRowIndex();
        });
    }
};
$437b23f6a393c3bf$var$__decorateClass2([
    $437b23f6a393c3bf$export$4bf29303185cb747("beans")
], $437b23f6a393c3bf$var$InfiniteBlock.prototype, "beans", 2);
$437b23f6a393c3bf$var$__decorateClass2([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$InfiniteBlock.prototype, "postConstruct", 1);
$437b23f6a393c3bf$var$__decorateClass2([
    $437b23f6a393c3bf$export$cc3f3d4529c57d95
], $437b23f6a393c3bf$var$InfiniteBlock.prototype, "destroyRowNodes", 1);
var $437b23f6a393c3bf$var$_InfiniteCache = class _InfiniteCache2 extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    constructor(params){
        super();
        this.lastRowIndexKnown = false;
        this.blocks = {};
        this.blockCount = 0;
        this.rowCount = params.initialRowCount;
        this.params = params;
    }
    setBeans(loggerFactory) {
        this.logger = loggerFactory.create("InfiniteCache");
    }
    // the rowRenderer will not pass dontCreatePage, meaning when rendering the grid,
    // it will want new pages in the cache as it asks for rows. only when we are inserting /
    // removing rows via the api is dontCreatePage set, where we move rows between the pages.
    getRow(rowIndex, dontCreatePage = false) {
        const blockId = Math.floor(rowIndex / this.params.blockSize);
        let block = this.blocks[blockId];
        if (!block) {
            if (dontCreatePage) return void 0;
            block = this.createBlock(blockId);
        }
        return block.getRow(rowIndex);
    }
    createBlock(blockNumber) {
        const newBlock = this.createBean(new $437b23f6a393c3bf$var$InfiniteBlock(blockNumber, this, this.params));
        this.blocks[newBlock.getId()] = newBlock;
        this.blockCount++;
        this.purgeBlocksIfNeeded(newBlock);
        this.params.rowNodeBlockLoader.addBlock(newBlock);
        return newBlock;
    }
    // we have this on infinite row model only, not server side row model,
    // because for server side, it would leave the children in inconsistent
    // state - eg if a node had children, but after the refresh it had data
    // for a different row, then the children would be with the wrong row node.
    refreshCache() {
        const nothingToRefresh = this.blockCount == 0;
        if (nothingToRefresh) {
            this.purgeCache();
            return;
        }
        this.getBlocksInOrder().forEach((block)=>block.setStateWaitingToLoad());
        this.params.rowNodeBlockLoader.checkBlockToLoad();
    }
    destroyAllBlocks() {
        this.getBlocksInOrder().forEach((block)=>this.destroyBlock(block));
    }
    getRowCount() {
        return this.rowCount;
    }
    isLastRowIndexKnown() {
        return this.lastRowIndexKnown;
    }
    // block calls this, when page loaded
    pageLoaded(block, lastRow) {
        if (!this.isAlive()) return;
        this.logger.log(`onPageLoaded: page = ${block.getId()}, lastRow = ${lastRow}`);
        this.checkRowCount(block, lastRow);
        this.onCacheUpdated();
    }
    purgeBlocksIfNeeded(blockToExclude) {
        const blocksForPurging = this.getBlocksInOrder().filter((b)=>b != blockToExclude);
        const lastAccessedComparator = (a, b)=>b.getLastAccessed() - a.getLastAccessed();
        blocksForPurging.sort(lastAccessedComparator);
        const maxBlocksProvided = this.params.maxBlocksInCache > 0;
        const blocksToKeep = maxBlocksProvided ? this.params.maxBlocksInCache - 1 : null;
        const emptyBlocksToKeep = _InfiniteCache2.MAX_EMPTY_BLOCKS_TO_KEEP - 1;
        blocksForPurging.forEach((block, index)=>{
            const purgeBecauseBlockEmpty = block.getState() === $437b23f6a393c3bf$var$InfiniteBlock.STATE_WAITING_TO_LOAD && index >= emptyBlocksToKeep;
            const purgeBecauseCacheFull = maxBlocksProvided ? index >= blocksToKeep : false;
            if (purgeBecauseBlockEmpty || purgeBecauseCacheFull) {
                if (this.isBlockCurrentlyDisplayed(block)) return;
                if (this.isBlockFocused(block)) return;
                this.removeBlockFromCache(block);
            }
        });
    }
    isBlockFocused(block) {
        const focusedCell = this.focusService.getFocusCellToUseAfterRefresh();
        if (!focusedCell) return false;
        if (focusedCell.rowPinned != null) return false;
        const blockIndexStart = block.getStartRow();
        const blockIndexEnd = block.getEndRow();
        const hasFocus = focusedCell.rowIndex >= blockIndexStart && focusedCell.rowIndex < blockIndexEnd;
        return hasFocus;
    }
    isBlockCurrentlyDisplayed(block) {
        const startIndex = block.getStartRow();
        const endIndex = block.getEndRow() - 1;
        return this.rowRenderer.isRangeInRenderedViewport(startIndex, endIndex);
    }
    removeBlockFromCache(blockToRemove) {
        if (!blockToRemove) return;
        this.destroyBlock(blockToRemove);
    }
    checkRowCount(block, lastRow) {
        if (typeof lastRow === "number" && lastRow >= 0) {
            this.rowCount = lastRow;
            this.lastRowIndexKnown = true;
        } else if (!this.lastRowIndexKnown) {
            const lastRowIndex = (block.getId() + 1) * this.params.blockSize;
            const lastRowIndexPlusOverflow = lastRowIndex + this.params.overflowSize;
            if (this.rowCount < lastRowIndexPlusOverflow) this.rowCount = lastRowIndexPlusOverflow;
        }
    }
    setRowCount(rowCount, lastRowIndexKnown) {
        this.rowCount = rowCount;
        if ($437b23f6a393c3bf$export$71511d61b312f219.exists(lastRowIndexKnown)) this.lastRowIndexKnown = lastRowIndexKnown;
        if (!this.lastRowIndexKnown) {
            if (this.rowCount % this.params.blockSize === 0) this.rowCount++;
        }
        this.onCacheUpdated();
    }
    forEachNodeDeep(callback) {
        const sequence = new $437b23f6a393c3bf$export$9bbf3cc62ef6fcad();
        this.getBlocksInOrder().forEach((block)=>block.forEachNode(callback, sequence, this.rowCount));
    }
    getBlocksInOrder() {
        const blockComparator = (a, b)=>a.getId() - b.getId();
        const blocks = $437b23f6a393c3bf$export$71511d61b312f219.getAllValuesInObject(this.blocks).sort(blockComparator);
        return blocks;
    }
    destroyBlock(block) {
        delete this.blocks[block.getId()];
        this.destroyBean(block);
        this.blockCount--;
        this.params.rowNodeBlockLoader.removeBlock(block);
    }
    // gets called 1) row count changed 2) cache purged 3) items inserted
    onCacheUpdated() {
        if (this.isAlive()) {
            this.destroyAllBlocksPastVirtualRowCount();
            const event = {
                type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_STORE_UPDATED
            };
            this.eventService.dispatchEvent(event);
        }
    }
    destroyAllBlocksPastVirtualRowCount() {
        const blocksToDestroy = [];
        this.getBlocksInOrder().forEach((block)=>{
            const startRow = block.getId() * this.params.blockSize;
            if (startRow >= this.rowCount) blocksToDestroy.push(block);
        });
        if (blocksToDestroy.length > 0) blocksToDestroy.forEach((block)=>this.destroyBlock(block));
    }
    purgeCache() {
        this.getBlocksInOrder().forEach((block)=>this.removeBlockFromCache(block));
        this.lastRowIndexKnown = false;
        if (this.rowCount === 0) this.rowCount = this.params.initialRowCount;
        this.onCacheUpdated();
    }
    getRowNodesInRange(firstInRange, lastInRange) {
        const result = [];
        let lastBlockId = -1;
        let inActiveRange = false;
        const numberSequence = new $437b23f6a393c3bf$export$9bbf3cc62ef6fcad();
        if ($437b23f6a393c3bf$export$71511d61b312f219.missing(firstInRange)) inActiveRange = true;
        let foundGapInSelection = false;
        this.getBlocksInOrder().forEach((block)=>{
            if (foundGapInSelection) return;
            if (inActiveRange && lastBlockId + 1 !== block.getId()) {
                foundGapInSelection = true;
                return;
            }
            lastBlockId = block.getId();
            block.forEachNode((rowNode)=>{
                const hitFirstOrLast = rowNode === firstInRange || rowNode === lastInRange;
                if (inActiveRange || hitFirstOrLast) result.push(rowNode);
                if (hitFirstOrLast) inActiveRange = !inActiveRange;
            }, numberSequence, this.rowCount);
        });
        const invalidRange = foundGapInSelection || inActiveRange;
        return invalidRange ? [] : result;
    }
};
$437b23f6a393c3bf$var$_InfiniteCache.MAX_EMPTY_BLOCKS_TO_KEEP = 2;
$437b23f6a393c3bf$var$__decorateClass2([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowRenderer")
], $437b23f6a393c3bf$var$_InfiniteCache.prototype, "rowRenderer", 2);
$437b23f6a393c3bf$var$__decorateClass2([
    $437b23f6a393c3bf$export$4bf29303185cb747("focusService")
], $437b23f6a393c3bf$var$_InfiniteCache.prototype, "focusService", 2);
$437b23f6a393c3bf$var$__decorateClass2([
    $437b23f6a393c3bf$var$__decorateParam2(0, $437b23f6a393c3bf$export$c3215dfb7fd4803b("loggerFactory"))
], $437b23f6a393c3bf$var$_InfiniteCache.prototype, "setBeans", 1);
$437b23f6a393c3bf$var$__decorateClass2([
    $437b23f6a393c3bf$export$cc3f3d4529c57d95
], $437b23f6a393c3bf$var$_InfiniteCache.prototype, "destroyAllBlocks", 1);
var $437b23f6a393c3bf$var$InfiniteCache = $437b23f6a393c3bf$var$_InfiniteCache;
var $437b23f6a393c3bf$var$InfiniteRowModel = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    getRowBounds(index) {
        return {
            rowHeight: this.rowHeight,
            rowTop: this.rowHeight * index
        };
    }
    // we don't implement as lazy row heights is not supported in this row model
    ensureRowHeightsValid(startPixel, endPixel, startLimitIndex, endLimitIndex) {
        return false;
    }
    init() {
        if (!this.gos.isRowModelType("infinite")) return;
        this.rowHeight = this.gos.getRowHeightAsNumber();
        this.addEventListeners();
        this.addDestroyFunc(()=>this.destroyCache());
        this.verifyProps();
    }
    verifyProps() {
        if (this.gos.exists("initialGroupOrderComparator")) $437b23f6a393c3bf$export$71511d61b312f219.warnOnce("initialGroupOrderComparator cannot be used with Infinite Row Model as sorting is done on the server side");
    }
    start() {
        this.setDatasource(this.gos.get("datasource"));
    }
    destroyDatasource() {
        if (this.datasource) {
            this.getContext().destroyBean(this.datasource);
            this.rowRenderer.datasourceChanged();
            this.datasource = null;
        }
    }
    addEventListeners() {
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_FILTER_CHANGED, this.onFilterChanged.bind(this));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_SORT_CHANGED, this.onSortChanged.bind(this));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_NEW_COLUMNS_LOADED, this.onColumnEverything.bind(this));
        this.addManagedListener(this.eventService, $437b23f6a393c3bf$export$ada873a34909da65.EVENT_STORE_UPDATED, this.onCacheUpdated.bind(this));
        this.addManagedPropertyListener("datasource", ()=>this.setDatasource(this.gos.get("datasource")));
        this.addManagedPropertyListener("cacheBlockSize", ()=>this.resetCache());
        this.addManagedPropertyListener("rowHeight", ()=>{
            this.rowHeight = this.gos.getRowHeightAsNumber();
            this.cacheParams.rowHeight = this.rowHeight;
            this.updateRowHeights();
        });
    }
    onFilterChanged() {
        this.reset();
    }
    onSortChanged() {
        this.reset();
    }
    onColumnEverything() {
        let resetRequired;
        if (this.cacheParams) resetRequired = this.isSortModelDifferent();
        else resetRequired = true;
        if (resetRequired) this.reset();
    }
    isSortModelDifferent() {
        return !$437b23f6a393c3bf$export$71511d61b312f219.jsonEquals(this.cacheParams.sortModel, this.sortController.getSortModel());
    }
    getType() {
        return "infinite";
    }
    setDatasource(datasource) {
        this.destroyDatasource();
        this.datasource = datasource;
        if (datasource) this.reset();
    }
    isEmpty() {
        return !this.infiniteCache;
    }
    isRowsToRender() {
        return !!this.infiniteCache;
    }
    getNodesInRangeForSelection(firstInRange, lastInRange) {
        return this.infiniteCache ? this.infiniteCache.getRowNodesInRange(firstInRange, lastInRange) : [];
    }
    reset() {
        if (!this.datasource) return;
        const getRowIdFunc = this.gos.getCallback("getRowId");
        const userGeneratingIds = getRowIdFunc != null;
        if (!userGeneratingIds) this.selectionService.reset("rowDataChanged");
        this.resetCache();
    }
    createModelUpdatedEvent() {
        return {
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_MODEL_UPDATED,
            // not sure if these should all be false - noticed if after implementing,
            // maybe they should be true?
            newPage: false,
            newPageSize: false,
            newData: false,
            keepRenderedRows: true,
            animate: false
        };
    }
    resetCache() {
        this.destroyCache();
        this.cacheParams = {
            // the user provided datasource
            datasource: this.datasource,
            // sort and filter model
            filterModel: this.filterManager.getFilterModel(),
            sortModel: this.sortController.getSortModel(),
            rowNodeBlockLoader: this.rowNodeBlockLoader,
            // properties - this way we take a snapshot of them, so if user changes any, they will be
            // used next time we create a new cache, which is generally after a filter or sort change,
            // or a new datasource is set
            initialRowCount: this.gos.get("infiniteInitialRowCount"),
            maxBlocksInCache: this.gos.get("maxBlocksInCache"),
            rowHeight: this.gos.getRowHeightAsNumber(),
            // if user doesn't provide overflow, we use default overflow of 1, so user can scroll past
            // the current page and request first row of next page
            overflowSize: this.gos.get("cacheOverflowSize"),
            // page size needs to be 1 or greater. having it at 1 would be silly, as you would be hitting the
            // server for one page at a time. so the default if not specified is 100.
            blockSize: this.gos.get("cacheBlockSize"),
            // the cache could create this, however it is also used by the pages, so handy to create it
            // here as the settings are also passed to the pages
            lastAccessedSequence: new $437b23f6a393c3bf$export$9bbf3cc62ef6fcad()
        };
        this.infiniteCache = this.createBean(new $437b23f6a393c3bf$var$InfiniteCache(this.cacheParams));
        this.eventService.dispatchEventOnce({
            type: $437b23f6a393c3bf$export$ada873a34909da65.EVENT_ROW_COUNT_READY
        });
        const event = this.createModelUpdatedEvent();
        this.eventService.dispatchEvent(event);
    }
    updateRowHeights() {
        this.forEachNode((node)=>{
            node.setRowHeight(this.rowHeight);
            node.setRowTop(this.rowHeight * node.rowIndex);
        });
        const event = this.createModelUpdatedEvent();
        this.eventService.dispatchEvent(event);
    }
    destroyCache() {
        if (this.infiniteCache) this.infiniteCache = this.destroyBean(this.infiniteCache);
    }
    onCacheUpdated() {
        const event = this.createModelUpdatedEvent();
        this.eventService.dispatchEvent(event);
    }
    getRow(rowIndex) {
        if (!this.infiniteCache) return void 0;
        if (rowIndex >= this.infiniteCache.getRowCount()) return void 0;
        return this.infiniteCache.getRow(rowIndex);
    }
    getRowNode(id) {
        let result;
        this.forEachNode((rowNode)=>{
            if (rowNode.id === id) result = rowNode;
        });
        return result;
    }
    forEachNode(callback) {
        if (this.infiniteCache) this.infiniteCache.forEachNodeDeep(callback);
    }
    getTopLevelRowCount() {
        return this.getRowCount();
    }
    getTopLevelRowDisplayedIndex(topLevelIndex) {
        return topLevelIndex;
    }
    getRowIndexAtPixel(pixel) {
        if (this.rowHeight !== 0) {
            const rowIndexForPixel = Math.floor(pixel / this.rowHeight);
            const lastRowIndex = this.getRowCount() - 1;
            if (rowIndexForPixel > lastRowIndex) return lastRowIndex;
            return rowIndexForPixel;
        }
        return 0;
    }
    getRowCount() {
        return this.infiniteCache ? this.infiniteCache.getRowCount() : 0;
    }
    isRowPresent(rowNode) {
        const foundRowNode = this.getRowNode(rowNode.id);
        return !!foundRowNode;
    }
    refreshCache() {
        if (this.infiniteCache) this.infiniteCache.refreshCache();
    }
    purgeCache() {
        if (this.infiniteCache) this.infiniteCache.purgeCache();
    }
    // for iRowModel
    isLastRowIndexKnown() {
        if (this.infiniteCache) return this.infiniteCache.isLastRowIndexKnown();
        return false;
    }
    setRowCount(rowCount, lastRowIndexKnown) {
        if (this.infiniteCache) this.infiniteCache.setRowCount(rowCount, lastRowIndexKnown);
    }
};
$437b23f6a393c3bf$var$__decorateClass2([
    $437b23f6a393c3bf$export$4bf29303185cb747("filterManager")
], $437b23f6a393c3bf$var$InfiniteRowModel.prototype, "filterManager", 2);
$437b23f6a393c3bf$var$__decorateClass2([
    $437b23f6a393c3bf$export$4bf29303185cb747("sortController")
], $437b23f6a393c3bf$var$InfiniteRowModel.prototype, "sortController", 2);
$437b23f6a393c3bf$var$__decorateClass2([
    $437b23f6a393c3bf$export$4bf29303185cb747("selectionService")
], $437b23f6a393c3bf$var$InfiniteRowModel.prototype, "selectionService", 2);
$437b23f6a393c3bf$var$__decorateClass2([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowRenderer")
], $437b23f6a393c3bf$var$InfiniteRowModel.prototype, "rowRenderer", 2);
$437b23f6a393c3bf$var$__decorateClass2([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowNodeBlockLoader")
], $437b23f6a393c3bf$var$InfiniteRowModel.prototype, "rowNodeBlockLoader", 2);
$437b23f6a393c3bf$var$__decorateClass2([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$var$InfiniteRowModel.prototype, "init", 1);
$437b23f6a393c3bf$var$__decorateClass2([
    $437b23f6a393c3bf$export$cc3f3d4529c57d95
], $437b23f6a393c3bf$var$InfiniteRowModel.prototype, "destroyDatasource", 1);
$437b23f6a393c3bf$var$InfiniteRowModel = $437b23f6a393c3bf$var$__decorateClass2([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("rowModel")
], $437b23f6a393c3bf$var$InfiniteRowModel);
var $437b23f6a393c3bf$var$VERSION2 = "31.3.4";
var $437b23f6a393c3bf$export$ca8341149bdd39bc = {
    version: $437b23f6a393c3bf$var$VERSION2,
    moduleName: "@ag-grid-community/infinite-row-model" /* InfiniteRowModelModule */ ,
    rowModel: "infinite",
    beans: [
        $437b23f6a393c3bf$var$InfiniteRowModel
    ]
};
// community-modules/csv-export/dist/package/main.esm.mjs
var $437b23f6a393c3bf$var$__defProp3 = Object.defineProperty;
var $437b23f6a393c3bf$var$__defProps2 = Object.defineProperties;
var $437b23f6a393c3bf$var$__getOwnPropDesc3 = Object.getOwnPropertyDescriptor;
var $437b23f6a393c3bf$var$__getOwnPropDescs2 = Object.getOwnPropertyDescriptors;
var $437b23f6a393c3bf$var$__getOwnPropSymbols2 = Object.getOwnPropertySymbols;
var $437b23f6a393c3bf$var$__hasOwnProp2 = Object.prototype.hasOwnProperty;
var $437b23f6a393c3bf$var$__propIsEnum2 = Object.prototype.propertyIsEnumerable;
var $437b23f6a393c3bf$var$__defNormalProp2 = (obj, key, value)=>key in obj ? $437b23f6a393c3bf$var$__defProp3(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $437b23f6a393c3bf$var$__spreadValues2 = (a, b)=>{
    for(var prop in b || (b = {}))if ($437b23f6a393c3bf$var$__hasOwnProp2.call(b, prop)) $437b23f6a393c3bf$var$__defNormalProp2(a, prop, b[prop]);
    if ($437b23f6a393c3bf$var$__getOwnPropSymbols2) {
        for (var prop of $437b23f6a393c3bf$var$__getOwnPropSymbols2(b))if ($437b23f6a393c3bf$var$__propIsEnum2.call(b, prop)) $437b23f6a393c3bf$var$__defNormalProp2(a, prop, b[prop]);
    }
    return a;
};
var $437b23f6a393c3bf$var$__spreadProps2 = (a, b)=>$437b23f6a393c3bf$var$__defProps2(a, $437b23f6a393c3bf$var$__getOwnPropDescs2(b));
var $437b23f6a393c3bf$var$__decorateClass3 = (decorators, target, key, kind)=>{
    var result = kind > 1 ? void 0 : kind ? $437b23f6a393c3bf$var$__getOwnPropDesc3(target, key) : target;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
    if (kind && result) $437b23f6a393c3bf$var$__defProp3(target, key, result);
    return result;
};
var $437b23f6a393c3bf$var$__async = (__this, __arguments, generator)=>{
    return new Promise((resolve, reject)=>{
        var fulfilled = (value)=>{
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = (value)=>{
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = (x)=>x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $437b23f6a393c3bf$export$b335f23c5aead909 = class {
    setBeans(beans) {
        this.beans = beans;
    }
    getFileName(fileName) {
        const extension = this.getDefaultFileExtension();
        if (fileName == null || !fileName.length) fileName = this.getDefaultFileName();
        return fileName.indexOf(".") === -1 ? `${fileName}.${extension}` : fileName;
    }
    getData(params) {
        const serializingSession = this.createSerializingSession(params);
        return this.beans.gridSerializer.serialize(serializingSession, params);
    }
    getDefaultFileName() {
        return `export.${this.getDefaultFileExtension()}`;
    }
};
var $437b23f6a393c3bf$export$5018ab277b833b61 = class {
    constructor(config){
        this.groupColumns = [];
        const { columnModel: columnModel, valueService: valueService, gos: gos, processCellCallback: processCellCallback, processHeaderCallback: processHeaderCallback, processGroupHeaderCallback: processGroupHeaderCallback, processRowGroupCallback: processRowGroupCallback } = config;
        this.columnModel = columnModel;
        this.valueService = valueService;
        this.gos = gos;
        this.processCellCallback = processCellCallback;
        this.processHeaderCallback = processHeaderCallback;
        this.processGroupHeaderCallback = processGroupHeaderCallback;
        this.processRowGroupCallback = processRowGroupCallback;
    }
    prepare(columnsToExport) {
        this.groupColumns = columnsToExport.filter((col)=>!!col.getColDef().showRowGroup);
    }
    extractHeaderValue(column) {
        const value = this.getHeaderName(this.processHeaderCallback, column);
        return value != null ? value : "";
    }
    extractRowCellValue(column, index, accumulatedRowIndex, type, node) {
        const hideOpenParents = this.gos.get("groupHideOpenParents");
        const value = (!hideOpenParents || node.footer) && this.shouldRenderGroupSummaryCell(node, column, index) ? this.createValueForGroupNode(column, node) : this.valueService.getValue(column, node);
        const processedValue = this.processCell({
            accumulatedRowIndex: accumulatedRowIndex,
            rowNode: node,
            column: column,
            value: value,
            processCellCallback: this.processCellCallback,
            type: type
        });
        return processedValue;
    }
    shouldRenderGroupSummaryCell(node, column, currentColumnIndex) {
        var _a;
        const isGroupNode = node && node.group;
        if (!isGroupNode) return false;
        const currentColumnGroupIndex = this.groupColumns.indexOf(column);
        if (currentColumnGroupIndex !== -1) {
            if (((_a = node.groupData) == null ? void 0 : _a[column.getId()]) != null) return true;
            if (this.gos.isRowModelType("serverSide") && node.group) return true;
            if (node.footer && node.level === -1) {
                const colDef = column.getColDef();
                const isFullWidth = colDef == null || colDef.showRowGroup === true;
                return isFullWidth || colDef.showRowGroup === this.columnModel.getRowGroupColumns()[0].getId();
            }
        }
        const isGroupUseEntireRow = this.gos.isGroupUseEntireRow(this.columnModel.isPivotMode());
        return currentColumnIndex === 0 && isGroupUseEntireRow;
    }
    getHeaderName(callback, column) {
        if (callback) return callback(this.gos.addGridCommonParams({
            column: column
        }));
        return this.columnModel.getDisplayNameForColumn(column, "csv", true);
    }
    createValueForGroupNode(column, node) {
        if (this.processRowGroupCallback) return this.processRowGroupCallback(this.gos.addGridCommonParams({
            column: column,
            node: node
        }));
        const isTreeData = this.gos.get("treeData");
        const isSuppressGroupMaintainValueType = this.gos.get("suppressGroupMaintainValueType");
        const getValueFromNode = (node2)=>{
            var _a, _b;
            if (isTreeData || isSuppressGroupMaintainValueType) return node2.key;
            const value = (_a = node2.groupData) == null ? void 0 : _a[column.getId()];
            if (!value || !node2.rowGroupColumn || node2.rowGroupColumn.getColDef().useValueFormatterForExport === false) return value;
            return (_b = this.valueService.formatValue(node2.rowGroupColumn, node2, value)) != null ? _b : value;
        };
        const isFooter = node.footer;
        const keys2 = [
            getValueFromNode(node)
        ];
        if (!this.gos.isGroupMultiAutoColumn()) while(node.parent){
            node = node.parent;
            keys2.push(getValueFromNode(node));
        }
        const groupValue = keys2.reverse().join(" -> ");
        return isFooter ? `Total ${groupValue}` : groupValue;
    }
    processCell(params) {
        var _a;
        const { accumulatedRowIndex: accumulatedRowIndex, rowNode: rowNode, column: column, value: value, processCellCallback: processCellCallback, type: type } = params;
        if (processCellCallback) return {
            value: (_a = processCellCallback(this.gos.addGridCommonParams({
                accumulatedRowIndex: accumulatedRowIndex,
                column: column,
                node: rowNode,
                value: value,
                type: type,
                parseValue: (valueToParse)=>this.valueService.parseValue(column, rowNode, valueToParse, this.valueService.getValue(column, rowNode)),
                formatValue: (valueToFormat)=>{
                    var _a2;
                    return (_a2 = this.valueService.formatValue(column, rowNode, valueToFormat)) != null ? _a2 : valueToFormat;
                }
            }))) != null ? _a : ""
        };
        if (column.getColDef().useValueFormatterForExport !== false) return {
            value: value != null ? value : "",
            valueFormatted: this.valueService.formatValue(column, rowNode, value)
        };
        return {
            value: value != null ? value : ""
        };
    }
};
var $437b23f6a393c3bf$export$ef06e7620d37c296 = class {
    static download(fileName, content) {
        const win = document.defaultView || window;
        if (!win) {
            console.warn("AG Grid: There is no `window` associated with the current `document`");
            return;
        }
        const element = document.createElement("a");
        const url = win.URL.createObjectURL(content);
        element.setAttribute("href", url);
        element.setAttribute("download", fileName);
        element.style.display = "none";
        document.body.appendChild(element);
        element.dispatchEvent(new MouseEvent("click", {
            bubbles: false,
            cancelable: true,
            view: win
        }));
        document.body.removeChild(element);
        win.setTimeout(()=>{
            win.URL.revokeObjectURL(url);
        }, 0);
    }
};
var $437b23f6a393c3bf$var$LINE_SEPARATOR = "\r\n";
var $437b23f6a393c3bf$var$CsvSerializingSession = class extends $437b23f6a393c3bf$export$5018ab277b833b61 {
    constructor(config){
        super(config);
        this.isFirstLine = true;
        this.result = "";
        const { suppressQuotes: suppressQuotes, columnSeparator: columnSeparator } = config;
        this.suppressQuotes = suppressQuotes;
        this.columnSeparator = columnSeparator;
    }
    addCustomContent(content) {
        if (!content) return;
        if (typeof content === "string") {
            if (!/^\s*\n/.test(content)) this.beginNewLine();
            content = content.replace(/\r?\n/g, $437b23f6a393c3bf$var$LINE_SEPARATOR);
            this.result += content;
        } else content.forEach((row)=>{
            this.beginNewLine();
            row.forEach((cell, index)=>{
                if (index !== 0) this.result += this.columnSeparator;
                this.result += this.putInQuotes(cell.data.value || "");
                if (cell.mergeAcross) this.appendEmptyCells(cell.mergeAcross);
            });
        });
    }
    onNewHeaderGroupingRow() {
        this.beginNewLine();
        return {
            onColumn: this.onNewHeaderGroupingRowColumn.bind(this)
        };
    }
    onNewHeaderGroupingRowColumn(columnGroup, header, index, span) {
        if (index != 0) this.result += this.columnSeparator;
        this.result += this.putInQuotes(header);
        this.appendEmptyCells(span);
    }
    appendEmptyCells(count) {
        for(let i = 1; i <= count; i++)this.result += this.columnSeparator + this.putInQuotes("");
    }
    onNewHeaderRow() {
        this.beginNewLine();
        return {
            onColumn: this.onNewHeaderRowColumn.bind(this)
        };
    }
    onNewHeaderRowColumn(column, index) {
        if (index != 0) this.result += this.columnSeparator;
        this.result += this.putInQuotes(this.extractHeaderValue(column));
    }
    onNewBodyRow() {
        this.beginNewLine();
        return {
            onColumn: this.onNewBodyRowColumn.bind(this)
        };
    }
    onNewBodyRowColumn(column, index, node) {
        var _a;
        if (index != 0) this.result += this.columnSeparator;
        const rowCellValue = this.extractRowCellValue(column, index, index, "csv", node);
        this.result += this.putInQuotes((_a = rowCellValue.valueFormatted) != null ? _a : rowCellValue.value);
    }
    putInQuotes(value) {
        if (this.suppressQuotes) return value;
        if (value === null || value === void 0) return '""';
        let stringValue;
        if (typeof value === "string") stringValue = value;
        else if (typeof value.toString === "function") stringValue = value.toString();
        else {
            console.warn("AG Grid: unknown value type during csv conversion");
            stringValue = "";
        }
        const valueEscaped = stringValue.replace(/"/g, '""');
        return '"' + valueEscaped + '"';
    }
    parse() {
        return this.result;
    }
    beginNewLine() {
        if (!this.isFirstLine) this.result += $437b23f6a393c3bf$var$LINE_SEPARATOR;
        this.isFirstLine = false;
    }
};
var $437b23f6a393c3bf$export$8ff7d5e0eafc769c = class extends $437b23f6a393c3bf$export$b335f23c5aead909 {
    postConstruct() {
        this.setBeans({
            gridSerializer: this.gridSerializer,
            gos: this.gos
        });
    }
    getMergedParams(params) {
        const baseParams = this.gos.get("defaultCsvExportParams");
        return Object.assign({}, baseParams, params);
    }
    export(userParams) {
        if (this.isExportSuppressed()) {
            console.warn(`AG Grid: Export cancelled. Export is not allowed as per your configuration.`);
            return;
        }
        const mergedParams = this.getMergedParams(userParams);
        const data = this.getData(mergedParams);
        const packagedFile = new Blob([
            "\uFEFF",
            data
        ], {
            type: "text/plain"
        });
        const fileName = typeof mergedParams.fileName === "function" ? mergedParams.fileName(this.gos.getGridCommonParams()) : mergedParams.fileName;
        $437b23f6a393c3bf$export$ef06e7620d37c296.download(this.getFileName(fileName), packagedFile);
    }
    exportDataAsCsv(params) {
        this.export(params);
    }
    getDataAsCsv(params, skipDefaultParams = false) {
        const mergedParams = skipDefaultParams ? Object.assign({}, params) : this.getMergedParams(params);
        return this.getData(mergedParams);
    }
    getDefaultFileExtension() {
        return "csv";
    }
    createSerializingSession(params) {
        const { columnModel: columnModel, valueService: valueService, gos: gos } = this;
        const { processCellCallback: processCellCallback, processHeaderCallback: processHeaderCallback, processGroupHeaderCallback: processGroupHeaderCallback, processRowGroupCallback: processRowGroupCallback, suppressQuotes: suppressQuotes, columnSeparator: columnSeparator } = params;
        return new $437b23f6a393c3bf$var$CsvSerializingSession({
            columnModel: columnModel,
            valueService: valueService,
            gos: gos,
            processCellCallback: processCellCallback || void 0,
            processHeaderCallback: processHeaderCallback || void 0,
            processGroupHeaderCallback: processGroupHeaderCallback || void 0,
            processRowGroupCallback: processRowGroupCallback || void 0,
            suppressQuotes: suppressQuotes || false,
            columnSeparator: columnSeparator || ","
        });
    }
    isExportSuppressed() {
        return this.gos.get("suppressCsvExport");
    }
};
$437b23f6a393c3bf$var$__decorateClass3([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnModel")
], $437b23f6a393c3bf$export$8ff7d5e0eafc769c.prototype, "columnModel", 2);
$437b23f6a393c3bf$var$__decorateClass3([
    $437b23f6a393c3bf$export$4bf29303185cb747("valueService")
], $437b23f6a393c3bf$export$8ff7d5e0eafc769c.prototype, "valueService", 2);
$437b23f6a393c3bf$var$__decorateClass3([
    $437b23f6a393c3bf$export$4bf29303185cb747("gridSerializer")
], $437b23f6a393c3bf$export$8ff7d5e0eafc769c.prototype, "gridSerializer", 2);
$437b23f6a393c3bf$var$__decorateClass3([
    $437b23f6a393c3bf$export$4bf29303185cb747("gridOptionsService")
], $437b23f6a393c3bf$export$8ff7d5e0eafc769c.prototype, "gos", 2);
$437b23f6a393c3bf$var$__decorateClass3([
    $437b23f6a393c3bf$export$e7d0339d3610248e
], $437b23f6a393c3bf$export$8ff7d5e0eafc769c.prototype, "postConstruct", 1);
$437b23f6a393c3bf$export$8ff7d5e0eafc769c = $437b23f6a393c3bf$var$__decorateClass3([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("csvCreator")
], $437b23f6a393c3bf$export$8ff7d5e0eafc769c);
var $437b23f6a393c3bf$export$6c09164be112ad33 = /* @__PURE__ */ ((RowType2)=>{
    RowType2[RowType2["HEADER_GROUPING"] = 0] = "HEADER_GROUPING";
    RowType2[RowType2["HEADER"] = 1] = "HEADER";
    RowType2[RowType2["BODY"] = 2] = "BODY";
    return RowType2;
})($437b23f6a393c3bf$export$6c09164be112ad33 || {});
var $437b23f6a393c3bf$export$6ec40cbcb0344850 = class extends $437b23f6a393c3bf$export$2032c8ef3788dfbd {
    serialize(gridSerializingSession, params = {}) {
        const { allColumns: allColumns, columnKeys: columnKeys, skipRowGroups: skipRowGroups } = params;
        const columnsToExport = this.getColumnsToExport(allColumns, skipRowGroups, columnKeys);
        const serializeChain = $437b23f6a393c3bf$export$71511d61b312f219.compose(// first pass, put in the header names of the cols
        this.prepareSession(columnsToExport), this.prependContent(params), this.exportColumnGroups(params, columnsToExport), this.exportHeaders(params, columnsToExport), this.processPinnedTopRows(params, columnsToExport), this.processRows(params, columnsToExport), this.processPinnedBottomRows(params, columnsToExport), this.appendContent(params));
        return serializeChain(gridSerializingSession).parse();
    }
    processRow(gridSerializingSession, params, columnsToExport, node) {
        const rowSkipper = params.shouldRowBeSkipped || (()=>false);
        const skipSingleChildrenGroup = this.gos.get("groupRemoveSingleChildren");
        const skipLowestSingleChildrenGroup = this.gos.get("groupRemoveLowestSingleChildren");
        const isClipboardExport = params.rowPositions != null;
        const isExplicitExportSelection = isClipboardExport || !!params.onlySelected;
        const hideOpenParents = this.gos.get("groupHideOpenParents") && !isExplicitExportSelection;
        const isLeafNode = this.columnModel.isPivotMode() ? node.leafGroup : !node.group;
        const isFooter = !!node.footer;
        const skipRowGroups = params.skipRowGroups;
        const shouldSkipLowestGroup = skipLowestSingleChildrenGroup && node.leafGroup;
        const shouldSkipCurrentGroup = node.allChildrenCount === 1 && (skipSingleChildrenGroup || shouldSkipLowestGroup);
        if (!isLeafNode && !isFooter && (params.skipRowGroups || shouldSkipCurrentGroup || hideOpenParents) || params.onlySelected && !node.isSelected() || params.skipPinnedTop && node.rowPinned === "top" || params.skipPinnedBottom && node.rowPinned === "bottom") return;
        const nodeIsRootNode = node.level === -1;
        if (nodeIsRootNode && !isLeafNode && !isFooter) return;
        const shouldRowBeSkipped = rowSkipper(this.gos.addGridCommonParams({
            node: node
        }));
        if (shouldRowBeSkipped) return;
        const rowAccumulator = gridSerializingSession.onNewBodyRow(node);
        columnsToExport.forEach((column, index)=>{
            rowAccumulator.onColumn(column, index, node);
        });
        if (params.getCustomContentBelowRow) {
            const content = params.getCustomContentBelowRow(this.gos.addGridCommonParams({
                node: node
            }));
            if (content) gridSerializingSession.addCustomContent(content);
        }
    }
    appendContent(params) {
        return (gridSerializingSession)=>{
            const appendContent = params.appendContent;
            if (appendContent) gridSerializingSession.addCustomContent(appendContent);
            return gridSerializingSession;
        };
    }
    prependContent(params) {
        return (gridSerializingSession)=>{
            const prependContent = params.prependContent;
            if (prependContent) gridSerializingSession.addCustomContent(prependContent);
            return gridSerializingSession;
        };
    }
    prepareSession(columnsToExport) {
        return (gridSerializingSession)=>{
            gridSerializingSession.prepare(columnsToExport);
            return gridSerializingSession;
        };
    }
    exportColumnGroups(params, columnsToExport) {
        return (gridSerializingSession)=>{
            if (!params.skipColumnGroupHeaders) {
                const groupInstanceIdCreator = new $437b23f6a393c3bf$export$b3b24737a74261fb();
                const displayedGroups = this.displayedGroupCreator.createDisplayedGroups(columnsToExport, groupInstanceIdCreator, null);
                this.recursivelyAddHeaderGroups(displayedGroups, gridSerializingSession, params.processGroupHeaderCallback);
            }
            return gridSerializingSession;
        };
    }
    exportHeaders(params, columnsToExport) {
        return (gridSerializingSession)=>{
            if (!params.skipColumnHeaders) {
                const gridRowIterator = gridSerializingSession.onNewHeaderRow();
                columnsToExport.forEach((column, index)=>{
                    gridRowIterator.onColumn(column, index, void 0);
                });
            }
            return gridSerializingSession;
        };
    }
    processPinnedTopRows(params, columnsToExport) {
        return (gridSerializingSession)=>{
            const processRow = this.processRow.bind(this, gridSerializingSession, params, columnsToExport);
            if (params.rowPositions) params.rowPositions.filter((position)=>position.rowPinned === "top").sort((a, b)=>a.rowIndex - b.rowIndex).map((position)=>this.pinnedRowModel.getPinnedTopRow(position.rowIndex)).forEach(processRow);
            else this.pinnedRowModel.forEachPinnedTopRow(processRow);
            return gridSerializingSession;
        };
    }
    processRows(params, columnsToExport) {
        return (gridSerializingSession)=>{
            const rowModel = this.rowModel;
            const rowModelType = rowModel.getType();
            const usingCsrm = rowModelType === "clientSide";
            const usingSsrm = rowModelType === "serverSide";
            const onlySelectedNonStandardModel = !usingCsrm && params.onlySelected;
            const processRow = this.processRow.bind(this, gridSerializingSession, params, columnsToExport);
            const { exportedRows: exportedRows = "filteredAndSorted" } = params;
            if (params.rowPositions) params.rowPositions.filter((position)=>position.rowPinned == null).sort((a, b)=>a.rowIndex - b.rowIndex).map((position)=>rowModel.getRow(position.rowIndex)).forEach(processRow);
            else if (this.columnModel.isPivotMode()) {
                if (usingCsrm) rowModel.forEachPivotNode(processRow, true);
                else if (usingSsrm) rowModel.forEachNodeAfterFilterAndSort(processRow, true);
                else rowModel.forEachNode(processRow);
            } else if (params.onlySelectedAllPages || onlySelectedNonStandardModel) {
                const selectedNodes = this.selectionService.getSelectedNodes();
                this.replicateSortedOrder(selectedNodes);
                selectedNodes.forEach(processRow);
            } else {
                if (exportedRows === "all") rowModel.forEachNode(processRow);
                else if (usingCsrm) rowModel.forEachNodeAfterFilterAndSort(processRow, true);
                else if (usingSsrm) rowModel.forEachNodeAfterFilterAndSort(processRow, true);
                else rowModel.forEachNode(processRow);
            }
            return gridSerializingSession;
        };
    }
    replicateSortedOrder(rows) {
        const sortOptions = this.sortController.getSortOptions();
        const compareNodes = (rowA, rowB)=>{
            var _a, _b, _c, _d;
            if (rowA.rowIndex != null && rowB.rowIndex != null) return rowA.rowIndex - rowB.rowIndex;
            if (rowA.level === rowB.level) {
                if (((_a = rowA.parent) == null ? void 0 : _a.id) === ((_b = rowB.parent) == null ? void 0 : _b.id)) return this.rowNodeSorter.compareRowNodes(sortOptions, {
                    rowNode: rowA,
                    currentPos: (_c = rowA.rowIndex) != null ? _c : -1
                }, {
                    rowNode: rowB,
                    currentPos: (_d = rowB.rowIndex) != null ? _d : -1
                });
                return compareNodes(rowA.parent, rowB.parent);
            }
            if (rowA.level > rowB.level) return compareNodes(rowA.parent, rowB);
            return compareNodes(rowA, rowB.parent);
        };
        rows.sort(compareNodes);
    }
    processPinnedBottomRows(params, columnsToExport) {
        return (gridSerializingSession)=>{
            const processRow = this.processRow.bind(this, gridSerializingSession, params, columnsToExport);
            if (params.rowPositions) params.rowPositions.filter((position)=>position.rowPinned === "bottom").sort((a, b)=>a.rowIndex - b.rowIndex).map((position)=>this.pinnedRowModel.getPinnedBottomRow(position.rowIndex)).forEach(processRow);
            else this.pinnedRowModel.forEachPinnedBottomRow(processRow);
            return gridSerializingSession;
        };
    }
    getColumnsToExport(allColumns = false, skipRowGroups = false, columnKeys) {
        const isPivotMode = this.columnModel.isPivotMode();
        if (columnKeys && columnKeys.length) return this.columnModel.getGridColumns(columnKeys);
        const isTreeData = this.gos.get("treeData");
        let columnsToExport = [];
        if (allColumns && !isPivotMode) columnsToExport = this.columnModel.getAllGridColumns();
        else columnsToExport = this.columnModel.getAllDisplayedColumns();
        if (skipRowGroups && !isTreeData) columnsToExport = columnsToExport.filter((column)=>column.getColId() !== $437b23f6a393c3bf$export$a7016588c430dba6);
        return columnsToExport;
    }
    recursivelyAddHeaderGroups(displayedGroups, gridSerializingSession, processGroupHeaderCallback) {
        const directChildrenHeaderGroups = [];
        displayedGroups.forEach((columnGroupChild)=>{
            const columnGroup = columnGroupChild;
            if (!columnGroup.getChildren) return;
            columnGroup.getChildren().forEach((it)=>directChildrenHeaderGroups.push(it));
        });
        if (displayedGroups.length > 0 && displayedGroups[0] instanceof $437b23f6a393c3bf$export$8a8fbc71323f074) this.doAddHeaderHeader(gridSerializingSession, displayedGroups, processGroupHeaderCallback);
        if (directChildrenHeaderGroups && directChildrenHeaderGroups.length > 0) this.recursivelyAddHeaderGroups(directChildrenHeaderGroups, gridSerializingSession, processGroupHeaderCallback);
    }
    doAddHeaderHeader(gridSerializingSession, displayedGroups, processGroupHeaderCallback) {
        const gridRowIterator = gridSerializingSession.onNewHeaderGroupingRow();
        let columnIndex = 0;
        displayedGroups.forEach((columnGroupChild)=>{
            const columnGroup = columnGroupChild;
            let name;
            if (processGroupHeaderCallback) name = processGroupHeaderCallback(this.gos.addGridCommonParams({
                columnGroup: columnGroup
            }));
            else name = this.columnModel.getDisplayNameForColumnGroup(columnGroup, "header");
            const collapsibleGroupRanges = columnGroup.getLeafColumns().reduce((collapsibleGroups, currentColumn, currentIdx, arr)=>{
                let lastGroup = $437b23f6a393c3bf$export$71511d61b312f219.last(collapsibleGroups);
                const groupShow = currentColumn.getColumnGroupShow() === "open";
                if (!groupShow) {
                    if (lastGroup && lastGroup[1] == null) lastGroup[1] = currentIdx - 1;
                } else if (!lastGroup || lastGroup[1] != null) {
                    lastGroup = [
                        currentIdx
                    ];
                    collapsibleGroups.push(lastGroup);
                }
                if (currentIdx === arr.length - 1 && lastGroup && lastGroup[1] == null) lastGroup[1] = currentIdx;
                return collapsibleGroups;
            }, []);
            gridRowIterator.onColumn(columnGroup, name || "", columnIndex++, columnGroup.getLeafColumns().length - 1, collapsibleGroupRanges);
        });
    }
};
$437b23f6a393c3bf$var$__decorateClass3([
    $437b23f6a393c3bf$export$4bf29303185cb747("displayedGroupCreator")
], $437b23f6a393c3bf$export$6ec40cbcb0344850.prototype, "displayedGroupCreator", 2);
$437b23f6a393c3bf$var$__decorateClass3([
    $437b23f6a393c3bf$export$4bf29303185cb747("columnModel")
], $437b23f6a393c3bf$export$6ec40cbcb0344850.prototype, "columnModel", 2);
$437b23f6a393c3bf$var$__decorateClass3([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowModel")
], $437b23f6a393c3bf$export$6ec40cbcb0344850.prototype, "rowModel", 2);
$437b23f6a393c3bf$var$__decorateClass3([
    $437b23f6a393c3bf$export$4bf29303185cb747("pinnedRowModel")
], $437b23f6a393c3bf$export$6ec40cbcb0344850.prototype, "pinnedRowModel", 2);
$437b23f6a393c3bf$var$__decorateClass3([
    $437b23f6a393c3bf$export$4bf29303185cb747("selectionService")
], $437b23f6a393c3bf$export$6ec40cbcb0344850.prototype, "selectionService", 2);
$437b23f6a393c3bf$var$__decorateClass3([
    $437b23f6a393c3bf$export$4bf29303185cb747("rowNodeSorter")
], $437b23f6a393c3bf$export$6ec40cbcb0344850.prototype, "rowNodeSorter", 2);
$437b23f6a393c3bf$var$__decorateClass3([
    $437b23f6a393c3bf$export$4bf29303185cb747("sortController")
], $437b23f6a393c3bf$export$6ec40cbcb0344850.prototype, "sortController", 2);
$437b23f6a393c3bf$export$6ec40cbcb0344850 = $437b23f6a393c3bf$var$__decorateClass3([
    $437b23f6a393c3bf$export$24f477b6454bfaa9("gridSerializer")
], $437b23f6a393c3bf$export$6ec40cbcb0344850);
var $437b23f6a393c3bf$var$VERSION3 = "31.3.4";
var $437b23f6a393c3bf$export$f744275d8b795fc2 = {
    version: $437b23f6a393c3bf$var$VERSION3,
    moduleName: "@ag-grid-community/csv-export" /* CsvExportModule */ ,
    beans: [
        $437b23f6a393c3bf$export$8ff7d5e0eafc769c,
        $437b23f6a393c3bf$export$6ec40cbcb0344850
    ]
};
var $437b23f6a393c3bf$var$LINE_SEPARATOR2 = "\r\n";
var $437b23f6a393c3bf$export$1abb521838b54ff = class {
    static createHeader(headerElement = {}) {
        const headerStart = "<?";
        const headerEnd = "?>";
        const keys2 = [
            "version"
        ];
        if (!headerElement.version) headerElement.version = "1.0";
        if (headerElement.encoding) keys2.push("encoding");
        if (headerElement.standalone) keys2.push("standalone");
        const att = keys2.map((key)=>`${key}="${headerElement[key]}"`).join(" ");
        return `${headerStart}xml ${att} ${headerEnd}`;
    }
    static createXml(xmlElement, booleanTransformer) {
        let props = "";
        if (xmlElement.properties) {
            if (xmlElement.properties.prefixedAttributes) xmlElement.properties.prefixedAttributes.forEach((prefixedSet)=>{
                Object.keys(prefixedSet.map).forEach((key)=>{
                    props += this.returnAttributeIfPopulated(prefixedSet.prefix + key, prefixedSet.map[key], booleanTransformer);
                });
            });
            if (xmlElement.properties.rawMap) Object.keys(xmlElement.properties.rawMap).forEach((key)=>{
                props += this.returnAttributeIfPopulated(key, xmlElement.properties.rawMap[key], booleanTransformer);
            });
        }
        let result = "<" + xmlElement.name + props;
        if (!xmlElement.children && xmlElement.textNode == null) return result + "/>" + $437b23f6a393c3bf$var$LINE_SEPARATOR2;
        if (xmlElement.textNode != null) return result + ">" + xmlElement.textNode + "</" + xmlElement.name + ">" + $437b23f6a393c3bf$var$LINE_SEPARATOR2;
        result += ">" + $437b23f6a393c3bf$var$LINE_SEPARATOR2;
        if (xmlElement.children) xmlElement.children.forEach((it)=>{
            result += this.createXml(it, booleanTransformer);
        });
        return result + "</" + xmlElement.name + ">" + $437b23f6a393c3bf$var$LINE_SEPARATOR2;
    }
    static returnAttributeIfPopulated(key, value, booleanTransformer) {
        if (!value && value !== "" && value !== 0) return "";
        let xmlValue = value;
        if (typeof value === "boolean") {
            if (booleanTransformer) xmlValue = booleanTransformer(value);
        }
        return ` ${key}="${xmlValue}"`;
    }
};
var $437b23f6a393c3bf$var$convertTime = (date)=>{
    let time = date.getHours();
    time <<= 6;
    time = time | date.getMinutes();
    time <<= 5;
    time = time | date.getSeconds() / 2;
    return time;
};
var $437b23f6a393c3bf$var$convertDate = (date)=>{
    let dt = date.getFullYear() - 1980;
    dt <<= 4;
    dt = dt | date.getMonth() + 1;
    dt <<= 5;
    dt = dt | date.getDate();
    return dt;
};
function $437b23f6a393c3bf$var$convertDecToHex(number, bytes) {
    let hex = "";
    for(let i = 0; i < bytes; i++){
        hex += String.fromCharCode(number & 255);
        number >>>= 8;
    }
    return hex;
}
var $437b23f6a393c3bf$var$getCrcFromCrc32TableAndByteArray = (content)=>{
    if (!content.length) return 0;
    let crc = -1;
    let j = 0;
    let k = 0;
    let l = 0;
    for(let i = 0; i < content.length; i++){
        j = content[i];
        k = (crc ^ j) & 255;
        l = $437b23f6a393c3bf$var$crcTable[k];
        crc = crc >>> 8 ^ l;
    }
    return crc ^ -1;
};
var $437b23f6a393c3bf$var$getCrcFromCrc32Table = (content)=>{
    if (!content.length) return 0;
    if (typeof content === "string") return $437b23f6a393c3bf$var$getCrcFromCrc32TableAndByteArray(new TextEncoder().encode(content));
    return $437b23f6a393c3bf$var$getCrcFromCrc32TableAndByteArray(content);
};
var $437b23f6a393c3bf$var$crcTable = new Uint32Array([
    0,
    1996959894,
    3993919788,
    2567524794,
    124634137,
    1886057615,
    3915621685,
    2657392035,
    249268274,
    2044508324,
    3772115230,
    2547177864,
    162941995,
    2125561021,
    3887607047,
    2428444049,
    498536548,
    1789927666,
    4089016648,
    2227061214,
    450548861,
    1843258603,
    4107580753,
    2211677639,
    325883990,
    1684777152,
    4251122042,
    2321926636,
    335633487,
    1661365465,
    4195302755,
    2366115317,
    997073096,
    1281953886,
    3579855332,
    2724688242,
    1006888145,
    1258607687,
    3524101629,
    2768942443,
    901097722,
    1119000684,
    3686517206,
    2898065728,
    853044451,
    1172266101,
    3705015759,
    2882616665,
    651767980,
    1373503546,
    3369554304,
    3218104598,
    565507253,
    1454621731,
    3485111705,
    3099436303,
    671266974,
    1594198024,
    3322730930,
    2970347812,
    795835527,
    1483230225,
    3244367275,
    3060149565,
    1994146192,
    31158534,
    2563907772,
    4023717930,
    1907459465,
    112637215,
    2680153253,
    3904427059,
    2013776290,
    251722036,
    2517215374,
    3775830040,
    2137656763,
    141376813,
    2439277719,
    3865271297,
    1802195444,
    476864866,
    2238001368,
    4066508878,
    1812370925,
    453092731,
    2181625025,
    4111451223,
    1706088902,
    314042704,
    2344532202,
    4240017532,
    1658658271,
    366619977,
    2362670323,
    4224994405,
    1303535960,
    984961486,
    2747007092,
    3569037538,
    1256170817,
    1037604311,
    2765210733,
    3554079995,
    1131014506,
    879679996,
    2909243462,
    3663771856,
    1141124467,
    855842277,
    2852801631,
    3708648649,
    1342533948,
    654459306,
    3188396048,
    3373015174,
    1466479909,
    544179635,
    3110523913,
    3462522015,
    1591671054,
    702138776,
    2966460450,
    3352799412,
    1504918807,
    783551873,
    3082640443,
    3233442989,
    3988292384,
    2596254646,
    62317068,
    1957810842,
    3939845945,
    2647816111,
    81470997,
    1943803523,
    3814918930,
    2489596804,
    225274430,
    2053790376,
    3826175755,
    2466906013,
    167816743,
    2097651377,
    4027552580,
    2265490386,
    503444072,
    1762050814,
    4150417245,
    2154129355,
    426522225,
    1852507879,
    4275313526,
    2312317920,
    282753626,
    1742555852,
    4189708143,
    2394877945,
    397917763,
    1622183637,
    3604390888,
    2714866558,
    953729732,
    1340076626,
    3518719985,
    2797360999,
    1068828381,
    1219638859,
    3624741850,
    2936675148,
    906185462,
    1090812512,
    3747672003,
    2825379669,
    829329135,
    1181335161,
    3412177804,
    3160834842,
    628085408,
    1382605366,
    3423369109,
    3138078467,
    570562233,
    1426400815,
    3317316542,
    2998733608,
    733239954,
    1555261956,
    3268935591,
    3050360625,
    752459403,
    1541320221,
    2607071920,
    3965973030,
    1969922972,
    40735498,
    2617837225,
    3943577151,
    1913087877,
    83908371,
    2512341634,
    3803740692,
    2075208622,
    213261112,
    2463272603,
    3855990285,
    2094854071,
    198958881,
    2262029012,
    4057260610,
    1759359992,
    534414190,
    2176718541,
    4139329115,
    1873836001,
    414664567,
    2282248934,
    4279200368,
    1711684554,
    285281116,
    2405801727,
    4167216745,
    1634467795,
    376229701,
    2685067896,
    3608007406,
    1308918612,
    956543938,
    2808555105,
    3495958263,
    1231636301,
    1047427035,
    2932959818,
    3654703836,
    1088359270,
    936918e3,
    2847714899,
    3736837829,
    1202900863,
    817233897,
    3183342108,
    3401237130,
    1404277552,
    615818150,
    3134207493,
    3453421203,
    1423857449,
    601450431,
    3009837614,
    3294710456,
    1567103746,
    711928724,
    3020668471,
    3272380065,
    1510334235,
    755167117
]);
var $437b23f6a393c3bf$var$compressBlob = (data)=>$437b23f6a393c3bf$var$__async(void 0, null, function*() {
        let chunksSize = 0;
        const chunks = [];
        const writeCompressedData = new WritableStream({
            write: (chunk)=>{
                chunks.push(chunk);
                chunksSize += chunk.length;
            }
        });
        const readable = new ReadableStream({
            start: (controller)=>{
                const reader = new FileReader();
                reader.onload = (e)=>{
                    var _a;
                    if ((_a = e.target) == null ? void 0 : _a.result) controller.enqueue(e.target.result);
                    controller.close();
                };
                reader.readAsArrayBuffer(data);
            }
        });
        const compressStream = new window.CompressionStream("deflate-raw");
        yield readable.pipeThrough(compressStream).pipeTo(writeCompressedData);
        return {
            size: chunksSize,
            content: new Blob(chunks)
        };
    });
var $437b23f6a393c3bf$var$deflateLocalFile = (rawContent)=>$437b23f6a393c3bf$var$__async(void 0, null, function*() {
        const contentAsBlob = new Blob([
            rawContent
        ]);
        const { size: compressedSize, content: compressedContent } = yield $437b23f6a393c3bf$var$compressBlob(contentAsBlob);
        const compressedContentAsUint8Array = new Uint8Array((yield compressedContent.arrayBuffer()));
        return {
            size: compressedSize,
            content: compressedContentAsUint8Array
        };
    });
var { utf8_encode: $437b23f6a393c3bf$var$utf8_encode2 } = $437b23f6a393c3bf$export$71511d61b312f219;
var $437b23f6a393c3bf$var$getDeflatedHeaderAndContent = (currentFile, offset)=>$437b23f6a393c3bf$var$__async(void 0, null, function*() {
        const { content: content } = currentFile;
        const { size: size, content: rawContent } = !content ? {
            size: 0,
            content: Uint8Array.from([])
        } : $437b23f6a393c3bf$var$getDecodedContent(content);
        let deflatedContent = void 0;
        let deflatedSize = void 0;
        let deflationPerformed = false;
        const shouldDeflate = currentFile.type === "file" && rawContent && size > 0;
        if (shouldDeflate) {
            const result = yield $437b23f6a393c3bf$var$deflateLocalFile(rawContent);
            deflatedContent = result.content;
            deflatedSize = result.size;
            deflationPerformed = true;
        }
        const headers = $437b23f6a393c3bf$var$getHeaders(currentFile, deflationPerformed, offset, size, rawContent, deflatedSize);
        return $437b23f6a393c3bf$var$__spreadProps2($437b23f6a393c3bf$var$__spreadValues2({}, headers), {
            content: deflatedContent || rawContent,
            isCompressed: deflationPerformed
        });
    });
var $437b23f6a393c3bf$var$getHeaderAndContent = (currentFile, offset)=>{
    const { content: content } = currentFile;
    const { content: rawContent } = !content ? {
        content: Uint8Array.from([])
    } : $437b23f6a393c3bf$var$getDecodedContent(content);
    const headers = $437b23f6a393c3bf$var$getHeaders(currentFile, false, offset, rawContent.length, rawContent, void 0);
    return $437b23f6a393c3bf$var$__spreadProps2($437b23f6a393c3bf$var$__spreadValues2({}, headers), {
        content: rawContent,
        isCompressed: false
    });
};
var $437b23f6a393c3bf$var$getHeaders = (currentFile, isCompressed, offset, rawSize, rawContent, deflatedSize)=>{
    const { content: content, path: path, created: creationDate } = currentFile;
    const time = $437b23f6a393c3bf$var$convertTime(creationDate);
    const dt = $437b23f6a393c3bf$var$convertDate(creationDate);
    const crcFlag = $437b23f6a393c3bf$var$getCrcFromCrc32Table(rawContent);
    const zipSize = deflatedSize !== void 0 ? deflatedSize : rawSize;
    const utfPath = $437b23f6a393c3bf$var$utf8_encode2(path);
    const isUTF8 = utfPath !== path;
    let extraFields = "";
    if (isUTF8) {
        const uExtraFieldPath = $437b23f6a393c3bf$var$convertDecToHex(1, 1) + $437b23f6a393c3bf$var$convertDecToHex($437b23f6a393c3bf$var$getCrcFromCrc32Table(utfPath), 4) + utfPath;
        extraFields = "up" + $437b23f6a393c3bf$var$convertDecToHex(uExtraFieldPath.length, 2) + uExtraFieldPath;
    }
    const commonHeader = "\x14\0" + // version needed to extract
    (isUTF8 ? "\0\b" : "\0\0") + // Language encoding flag (EFS) (12th bit turned on)
    $437b23f6a393c3bf$var$convertDecToHex(isCompressed ? 8 : 0, 2) + // As per ECMA-376 Part 2 specs
    $437b23f6a393c3bf$var$convertDecToHex(time, 2) + // last modified time
    $437b23f6a393c3bf$var$convertDecToHex(dt, 2) + // last modified date
    $437b23f6a393c3bf$var$convertDecToHex(zipSize ? crcFlag : 0, 4) + $437b23f6a393c3bf$var$convertDecToHex(deflatedSize != null ? deflatedSize : rawSize, 4) + // compressed size
    $437b23f6a393c3bf$var$convertDecToHex(rawSize, 4) + // uncompressed size
    $437b23f6a393c3bf$var$convertDecToHex(utfPath.length, 2) + // file name length
    $437b23f6a393c3bf$var$convertDecToHex(extraFields.length, 2);
    const localFileHeader = "PK\x03\x04" + commonHeader + utfPath + extraFields;
    const centralDirectoryHeader = "PK\x01\x02\x14\0" + commonHeader + // file header
    "\0\0\0\0\0\0" + (content ? "\0\0\0\0" : "\x10\0\0\0") + // external file attributes
    $437b23f6a393c3bf$var$convertDecToHex(offset, 4) + // relative offset of local header
    utfPath + // file name
    extraFields;
    return {
        localFileHeader: Uint8Array.from(localFileHeader, (c)=>c.charCodeAt(0)),
        centralDirectoryHeader: Uint8Array.from(centralDirectoryHeader, (c)=>c.charCodeAt(0))
    };
};
var $437b23f6a393c3bf$var$buildCentralDirectoryEnd = (tLen, cLen, lLen)=>{
    const str = "PK\x05\x06\0\0\0\0" + $437b23f6a393c3bf$var$convertDecToHex(tLen, 2) + // total number of entries in the central folder
    $437b23f6a393c3bf$var$convertDecToHex(tLen, 2) + // total number of entries in the central folder
    $437b23f6a393c3bf$var$convertDecToHex(cLen, 4) + // size of the central folder
    $437b23f6a393c3bf$var$convertDecToHex(lLen, 4) + // central folder start offset
    "\0\0";
    return Uint8Array.from(str, (c)=>c.charCodeAt(0));
};
var $437b23f6a393c3bf$var$convertStringToByteArray = (str)=>{
    const bytes = new Uint8Array(str.length);
    for(let i = 0; i < str.length; i++)bytes[i] = str.charCodeAt(i);
    return bytes;
};
var $437b23f6a393c3bf$var$getDecodedContent = (content)=>{
    let contentToUse;
    if (typeof content === "string") {
        const base64String = atob(content.split(";base64,")[1]);
        contentToUse = $437b23f6a393c3bf$var$convertStringToByteArray(base64String);
    } else contentToUse = content;
    return {
        size: contentToUse.length,
        content: contentToUse
    };
};
var $437b23f6a393c3bf$export$35dc58f6886fc963 = class {
    static addFolders(paths) {
        paths.forEach(this.addFolder.bind(this));
    }
    static addFolder(path) {
        this.folders.push({
            path: path,
            created: /* @__PURE__ */ new Date(),
            isBase64: false,
            type: "folder"
        });
    }
    static addFile(path, content, isBase64 = false) {
        this.files.push({
            path: path,
            created: /* @__PURE__ */ new Date(),
            content: isBase64 ? content : new TextEncoder().encode(content),
            isBase64: isBase64,
            type: "file"
        });
    }
    static getZipFile(mimeType = "application/zip") {
        return $437b23f6a393c3bf$var$__async(this, null, function*() {
            const textOutput = yield this.buildCompressedFileStream();
            this.clearStream();
            return new Blob([
                textOutput
            ], {
                type: mimeType
            });
        });
    }
    static getUncompressedZipFile(mimeType = "application/zip") {
        const textOutput = this.buildFileStream();
        this.clearStream();
        return new Blob([
            textOutput
        ], {
            type: mimeType
        });
    }
    static clearStream() {
        this.folders = [];
        this.files = [];
    }
    static packageFiles(files) {
        let fileData = new Uint8Array(0);
        let folderData = new Uint8Array(0);
        let filesContentAndHeaderLength = 0;
        let folderHeadersLength = 0;
        for (const currentFile of files){
            const { localFileHeader: localFileHeader, centralDirectoryHeader: centralDirectoryHeader, content: content } = currentFile;
            const dataWithHeader = new Uint8Array(fileData.length + localFileHeader.length);
            dataWithHeader.set(fileData);
            dataWithHeader.set(localFileHeader, fileData.length);
            fileData = dataWithHeader;
            const dataWithContent = new Uint8Array(fileData.length + content.length);
            dataWithContent.set(fileData);
            dataWithContent.set(content, fileData.length);
            fileData = dataWithContent;
            const folderDataWithFolderHeader = new Uint8Array(folderData.length + centralDirectoryHeader.length);
            folderDataWithFolderHeader.set(folderData);
            folderDataWithFolderHeader.set(centralDirectoryHeader, folderData.length);
            folderData = folderDataWithFolderHeader;
            filesContentAndHeaderLength += localFileHeader.length + content.length;
            folderHeadersLength += centralDirectoryHeader.length;
        }
        const folderEnd = $437b23f6a393c3bf$var$buildCentralDirectoryEnd(files.length, folderHeadersLength, filesContentAndHeaderLength);
        const result = new Uint8Array(fileData.length + folderData.length + folderEnd.length);
        result.set(fileData);
        result.set(folderData, fileData.length);
        result.set(folderEnd, fileData.length + folderData.length);
        return result;
    }
    static buildCompressedFileStream() {
        return $437b23f6a393c3bf$var$__async(this, null, function*() {
            const totalFiles = [
                ...this.folders,
                ...this.files
            ];
            const readyFiles = [];
            let lL = 0;
            for (const currentFile of totalFiles){
                const output = yield $437b23f6a393c3bf$var$getDeflatedHeaderAndContent(currentFile, lL);
                const { localFileHeader: localFileHeader, content: content } = output;
                readyFiles.push(output);
                lL += localFileHeader.length + content.length;
            }
            return this.packageFiles(readyFiles);
        });
    }
    static buildFileStream() {
        const totalFiles = [
            ...this.folders,
            ...this.files
        ];
        const readyFiles = [];
        let lL = 0;
        for (const currentFile of totalFiles){
            const readyFile = $437b23f6a393c3bf$var$getHeaderAndContent(currentFile, lL);
            const { localFileHeader: localFileHeader, content: content } = readyFile;
            readyFiles.push(readyFile);
            lL += localFileHeader.length + content.length;
        }
        return this.packageFiles(readyFiles);
    }
};
$437b23f6a393c3bf$export$35dc58f6886fc963.folders = [];
$437b23f6a393c3bf$export$35dc58f6886fc963.files = [];
// packages/ag-grid-community/src/main.ts
$437b23f6a393c3bf$export$dc053975cc7f6c11.__registerModules([
    $437b23f6a393c3bf$export$4c74201d5a94c8e5,
    $437b23f6a393c3bf$export$ca8341149bdd39bc,
    $437b23f6a393c3bf$export$f744275d8b795fc2
], false, void 0);

});

parcelRegister("iTJTu", function(module, exports) {

$parcel$export(module.exports, "AgErrorBarSupportedSeriesTypes", () => $d77b025aa58d633c$export$8d1e42e0e779ee56);
$parcel$export(module.exports, "AgTooltipPositionType", () => $d77b025aa58d633c$export$a277a8c996e5a5f6);
$parcel$export(module.exports, "__FORCE_MODULE_DETECTION", () => $d77b025aa58d633c$export$7fe631c427af9815);
$parcel$export(module.exports, "time", () => $d77b025aa58d633c$export$2da9be4cfdb689b1);
$parcel$export(module.exports, "Marker", () => $d77b025aa58d633c$export$e98856a975cab58e);
$parcel$export(module.exports, "AgCharts", () => $d77b025aa58d633c$export$e93fe4969a168dc7);
$parcel$export(module.exports, "AgChart", () => $d77b025aa58d633c$export$5f62ab335cae0d0b);
$parcel$export(module.exports, "VERSION", () => $d77b025aa58d633c$export$a4ad2735b021c132);
$parcel$export(module.exports, "_Scene", () => $d77b025aa58d633c$export$f88ced8f90c5ae15);
$parcel$export(module.exports, "_Theme", () => $d77b025aa58d633c$export$d23fb0bb3c916391);
$parcel$export(module.exports, "_Scale", () => $d77b025aa58d633c$export$fa86e017a5c0b409);
$parcel$export(module.exports, "_Util", () => $d77b025aa58d633c$export$48e12db5e55fd3a3);
$parcel$export(module.exports, "_ModuleSupport", () => $d77b025aa58d633c$export$d0f5d10b4c7de308);
var $d77b025aa58d633c$var$__defProp = Object.defineProperty;
var $d77b025aa58d633c$var$__defProps = Object.defineProperties;
var $d77b025aa58d633c$var$__getOwnPropDesc = Object.getOwnPropertyDescriptor;
var $d77b025aa58d633c$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $d77b025aa58d633c$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $d77b025aa58d633c$var$__getProtoOf = Object.getPrototypeOf;
var $d77b025aa58d633c$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $d77b025aa58d633c$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $d77b025aa58d633c$var$__reflectGet = Reflect.get;
var $d77b025aa58d633c$var$__knownSymbol = (name, symbol)=>{
    return (symbol = Symbol[name]) ? symbol : Symbol.for("Symbol." + name);
};
var $d77b025aa58d633c$var$__pow = Math.pow;
var $d77b025aa58d633c$var$__defNormalProp = (obj, key, value)=>key in obj ? $d77b025aa58d633c$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $d77b025aa58d633c$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($d77b025aa58d633c$var$__hasOwnProp.call(b, prop)) $d77b025aa58d633c$var$__defNormalProp(a, prop, b[prop]);
    if ($d77b025aa58d633c$var$__getOwnPropSymbols) {
        for (var prop of $d77b025aa58d633c$var$__getOwnPropSymbols(b))if ($d77b025aa58d633c$var$__propIsEnum.call(b, prop)) $d77b025aa58d633c$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $d77b025aa58d633c$var$__spreadProps = (a, b)=>$d77b025aa58d633c$var$__defProps(a, $d77b025aa58d633c$var$__getOwnPropDescs(b));
var $d77b025aa58d633c$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($d77b025aa58d633c$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $d77b025aa58d633c$var$__getOwnPropSymbols) {
        for (var prop of $d77b025aa58d633c$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $d77b025aa58d633c$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $d77b025aa58d633c$var$__export = (target, all)=>{
    for(var name in all)$d77b025aa58d633c$var$__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var $d77b025aa58d633c$var$__decorateClass = (decorators, target, key, kind)=>{
    var result = kind > 1 ? void 0 : kind ? $d77b025aa58d633c$var$__getOwnPropDesc(target, key) : target;
    for(var i = decorators.length - 1, decorator; i >= 0; i--)if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
    if (kind && result) $d77b025aa58d633c$var$__defProp(target, key, result);
    return result;
};
var $d77b025aa58d633c$var$__superGet = (cls, obj, key)=>$d77b025aa58d633c$var$__reflectGet($d77b025aa58d633c$var$__getProtoOf(cls), key, obj);
var $d77b025aa58d633c$var$__async = (__this, __arguments, generator)=>{
    return new Promise((resolve, reject)=>{
        var fulfilled = (value)=>{
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = (value)=>{
            try {
                step(generator.throw(value));
            } catch (e) {
                reject(e);
            }
        };
        var step = (x)=>x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
var $d77b025aa58d633c$var$__await = function(promise, isYieldStar) {
    this[0] = promise;
    this[1] = isYieldStar;
};
var $d77b025aa58d633c$var$__yieldStar = (value)=>{
    var obj = value[$d77b025aa58d633c$var$__knownSymbol("asyncIterator")];
    var isAwait = false;
    var method;
    var it = {};
    if (obj == null) {
        obj = value[$d77b025aa58d633c$var$__knownSymbol("iterator")]();
        method = (k)=>it[k] = (x)=>obj[k](x);
    } else {
        obj = obj.call(value);
        method = (k)=>it[k] = (v)=>{
                if (isAwait) {
                    isAwait = false;
                    if (k === "throw") throw v;
                    return v;
                }
                isAwait = true;
                return {
                    done: false,
                    value: new $d77b025aa58d633c$var$__await(new Promise((resolve)=>{
                        var x = obj[k](v);
                        if (!(x instanceof Object)) throw TypeError("Object expected");
                        resolve(x);
                    }), 1)
                };
            };
    }
    return it[$d77b025aa58d633c$var$__knownSymbol("iterator")] = ()=>it, method("next"), "throw" in obj ? method("throw") : it.throw = (x)=>{
        throw x;
    }, "return" in obj && method("return"), it;
};
// packages/ag-charts-community/src/options/chart/errorBarOptions.ts
var $d77b025aa58d633c$export$8d1e42e0e779ee56 = [
    "bar",
    "line",
    "scatter"
];
// packages/ag-charts-community/src/options/chart/navigatorOptions.ts
var $d77b025aa58d633c$var$__MINI_CHART_SERIES_OPTIONS = {};
var $d77b025aa58d633c$var$__VERIFY_MINI_CHART_SERIES_OPTIONS = void 0;
$d77b025aa58d633c$var$__VERIFY_MINI_CHART_SERIES_OPTIONS = $d77b025aa58d633c$var$__MINI_CHART_SERIES_OPTIONS;
// packages/ag-charts-community/src/options/chart/tooltipOptions.ts
var $d77b025aa58d633c$export$a277a8c996e5a5f6 = /* @__PURE__ */ ((AgTooltipPositionType2)=>{
    AgTooltipPositionType2["POINTER"] = "pointer";
    AgTooltipPositionType2["NODE"] = "node";
    AgTooltipPositionType2["TOP"] = "top";
    AgTooltipPositionType2["RIGHT"] = "right";
    AgTooltipPositionType2["BOTTOM"] = "bottom";
    AgTooltipPositionType2["LEFT"] = "left";
    AgTooltipPositionType2["TOP_LEFT"] = "top-left";
    AgTooltipPositionType2["TOP_RIGHT"] = "top-right";
    AgTooltipPositionType2["BOTTOM_RIGHT"] = "bottom-right";
    AgTooltipPositionType2["BOTTOM_LEFT"] = "bottom-left";
    return AgTooltipPositionType2;
})($d77b025aa58d633c$export$a277a8c996e5a5f6 || {});
// packages/ag-charts-community/src/options/chart/themeOptions.ts
var $d77b025aa58d633c$var$__THEME_OVERRIDES = {};
var $d77b025aa58d633c$var$__VERIFY_THEME_OVERRIDES = void 0;
$d77b025aa58d633c$var$__VERIFY_THEME_OVERRIDES = $d77b025aa58d633c$var$__THEME_OVERRIDES;
// packages/ag-charts-community/src/options/agChartOptions.ts
var $d77b025aa58d633c$export$7fe631c427af9815 = 0;
// packages/ag-charts-community/src/util/time/index.ts
var $d77b025aa58d633c$export$2da9be4cfdb689b1 = {};
$d77b025aa58d633c$var$__export($d77b025aa58d633c$export$2da9be4cfdb689b1, {
    day: ()=>$d77b025aa58d633c$var$day,
    friday: ()=>$d77b025aa58d633c$var$friday,
    hour: ()=>$d77b025aa58d633c$var$hour,
    millisecond: ()=>$d77b025aa58d633c$var$millisecond,
    minute: ()=>$d77b025aa58d633c$var$minute,
    monday: ()=>$d77b025aa58d633c$var$monday,
    month: ()=>$d77b025aa58d633c$var$month,
    saturday: ()=>$d77b025aa58d633c$var$saturday,
    second: ()=>$d77b025aa58d633c$var$second,
    sunday: ()=>$d77b025aa58d633c$var$sunday,
    thursday: ()=>$d77b025aa58d633c$var$thursday,
    tuesday: ()=>$d77b025aa58d633c$var$tuesday,
    utcDay: ()=>$d77b025aa58d633c$var$utcDay,
    utcHour: ()=>$d77b025aa58d633c$var$utcHour,
    utcMinute: ()=>$d77b025aa58d633c$var$utcMinute,
    utcMonth: ()=>$d77b025aa58d633c$var$utcMonth,
    utcYear: ()=>$d77b025aa58d633c$var$utcYear,
    wednesday: ()=>$d77b025aa58d633c$var$wednesday,
    year: ()=>$d77b025aa58d633c$var$year
});
// packages/ag-charts-community/src/util/function.ts
var $d77b025aa58d633c$var$doOnceState = /* @__PURE__ */ new Map();
function $d77b025aa58d633c$var$doOnce(func, key) {
    if ($d77b025aa58d633c$var$doOnceState.has(key)) return;
    $d77b025aa58d633c$var$doOnceState.set(key, true);
    func();
}
$d77b025aa58d633c$var$doOnce.clear = ()=>$d77b025aa58d633c$var$doOnceState.clear();
function $d77b025aa58d633c$var$identity(x) {
    return x;
}
function* $d77b025aa58d633c$var$iterate(...iterators) {
    for (const iterator of iterators)yield* $d77b025aa58d633c$var$__yieldStar(iterator);
}
function* $d77b025aa58d633c$var$iterateReverseArray(array) {
    for(let j = array.length - 1; j >= 0; j--)yield array[j];
}
function $d77b025aa58d633c$var$throttle(callback, waitMs = 0, options) {
    const { leading: leading = true, trailing: trailing = true } = options != null ? options : {};
    let timerId;
    let lastArgs;
    let shouldWait = false;
    function timeoutHandler() {
        if (trailing && lastArgs) {
            timerId = setTimeout(timeoutHandler, waitMs);
            callback(...lastArgs);
        } else shouldWait = false;
        lastArgs = null;
    }
    function throttleCallback(...args) {
        if (shouldWait) lastArgs = args;
        else {
            shouldWait = true;
            timerId = setTimeout(timeoutHandler, waitMs);
            if (leading) callback(...args);
            else lastArgs = args;
        }
    }
    return Object.assign(throttleCallback, {
        cancel () {
            clearTimeout(timerId);
            shouldWait = false;
            lastArgs = null;
        }
    });
}
function $d77b025aa58d633c$var$joinFunctions(...fns) {
    return ()=>{
        for (const fn of fns)fn();
    };
}
// packages/ag-charts-community/src/util/logger.ts
var $d77b025aa58d633c$var$Logger = {
    log (...logContent) {
        console.log(...logContent);
    },
    warn (message, ...logContent) {
        console.warn(`AG Charts - ${message}`, ...logContent);
    },
    error (message, ...logContent) {
        if (typeof message === "object") console.error(`AG Charts error`, message, ...logContent);
        else console.error(`AG Charts - ${message}`, ...logContent);
    },
    table (...logContent) {
        console.table(...logContent);
    },
    warnOnce (message, ...logContent) {
        $d77b025aa58d633c$var$doOnce(()=>$d77b025aa58d633c$var$Logger.warn(message, ...logContent), `Logger.warn: ${message}`);
    },
    errorOnce (message, ...logContent) {
        $d77b025aa58d633c$var$doOnce(()=>$d77b025aa58d633c$var$Logger.error(message, ...logContent), `Logger.error: ${message}`);
    }
};
// packages/ag-charts-community/src/util/time/interval.ts
var $d77b025aa58d633c$var$TimeInterval = class {
    constructor(_encode, _decode, _rangeCallback){
        this._encode = _encode;
        this._decode = _decode;
        this._rangeCallback = _rangeCallback;
    }
    /**
   * Returns a new date representing the latest interval boundary date before or equal to date.
   * For example, `day.floor(date)` typically returns 12:00 AM local time on the given date.
   * @param date
   */ floor(date) {
        const d = new Date(date);
        const e = this._encode(d);
        return this._decode(e);
    }
    /**
   * Returns a new date representing the earliest interval boundary date after or equal to date.
   * @param date
   */ ceil(date) {
        const d = new Date(Number(date) - 1);
        const e = this._encode(d);
        return this._decode(e + 1);
    }
    /**
   * Returns an array of dates representing every interval boundary after or equal to start (inclusive) and before stop (exclusive).
   * @param start Range start.
   * @param stop Range end.
   * @param extend If specified, the requested range will be extended to the closest "nice" values.
   */ range(start, stop, extend) {
        var _a;
        const rangeCallback = (_a = this._rangeCallback) == null ? void 0 : _a.call(this, start, stop);
        const e0 = this._encode(extend ? this.floor(start) : this.ceil(start));
        const e1 = this._encode(extend ? this.ceil(stop) : this.floor(stop));
        if (e1 < e0) return [];
        const range3 = [];
        for(let e = e0; e <= e1; e++){
            const d = this._decode(e);
            range3.push(d);
        }
        rangeCallback == null || rangeCallback();
        return range3;
    }
};
var $d77b025aa58d633c$var$CountableTimeInterval = class extends $d77b025aa58d633c$var$TimeInterval {
    getOffset(snapTo, step) {
        const s = typeof snapTo === "number" || snapTo instanceof Date ? this._encode(new Date(snapTo)) : 0;
        return Math.floor(s) % step;
    }
    /**
   * Returns a filtered view of this interval representing every step'th date.
   * It can be a number of minutes, hours, days etc.
   * Must be a positive integer.
   * @param step
   */ every(step, options) {
        let offset4 = 0;
        let rangeCallback;
        const unsafeStep = step;
        step = Math.max(1, Math.round(step));
        if (unsafeStep !== step) $d77b025aa58d633c$var$Logger.warnOnce(`interval step of [${unsafeStep}] rounded to [${step}].`);
        const { snapTo: snapTo = "start" } = options != null ? options : {};
        if (typeof snapTo === "string") {
            const initialOffset = offset4;
            rangeCallback = (start, stop)=>{
                const s = snapTo === "start" ? start : stop;
                offset4 = this.getOffset(s, step);
                return ()=>offset4 = initialOffset;
            };
        } else if (typeof snapTo === "number") offset4 = this.getOffset(new Date(snapTo), step);
        else if (snapTo instanceof Date) offset4 = this.getOffset(snapTo, step);
        const encode13 = (date)=>{
            const e = this._encode(date);
            return Math.floor((e - offset4) / step);
        };
        const decode13 = (encoded)=>{
            return this._decode(encoded * step + offset4);
        };
        return new $d77b025aa58d633c$var$TimeInterval(encode13, decode13, rangeCallback);
    }
};
// packages/ag-charts-community/src/util/time/millisecond.ts
function $d77b025aa58d633c$var$encode(date) {
    return date.getTime();
}
function $d77b025aa58d633c$var$decode(encoded) {
    return new Date(encoded);
}
var $d77b025aa58d633c$var$millisecond = new $d77b025aa58d633c$var$CountableTimeInterval($d77b025aa58d633c$var$encode, $d77b025aa58d633c$var$decode);
var $d77b025aa58d633c$var$millisecond_default = $d77b025aa58d633c$var$millisecond;
// packages/ag-charts-community/src/util/time/duration.ts
var $d77b025aa58d633c$var$epochYear = /* @__PURE__ */ new Date(0).getFullYear();
var $d77b025aa58d633c$var$durationSecond = 1e3;
var $d77b025aa58d633c$var$durationMinute = $d77b025aa58d633c$var$durationSecond * 60;
var $d77b025aa58d633c$var$durationHour = $d77b025aa58d633c$var$durationMinute * 60;
var $d77b025aa58d633c$var$durationDay = $d77b025aa58d633c$var$durationHour * 24;
var $d77b025aa58d633c$var$durationWeek = $d77b025aa58d633c$var$durationDay * 7;
var $d77b025aa58d633c$var$durationMonth = $d77b025aa58d633c$var$durationDay * 30;
var $d77b025aa58d633c$var$durationYear = $d77b025aa58d633c$var$durationDay * 365;
// packages/ag-charts-community/src/util/time/second.ts
var $d77b025aa58d633c$var$offset = /* @__PURE__ */ new Date().getTimezoneOffset() * $d77b025aa58d633c$var$durationMinute;
function $d77b025aa58d633c$var$encode2(date) {
    return Math.floor((date.getTime() - $d77b025aa58d633c$var$offset) / $d77b025aa58d633c$var$durationSecond);
}
function $d77b025aa58d633c$var$decode2(encoded) {
    return new Date($d77b025aa58d633c$var$offset + encoded * $d77b025aa58d633c$var$durationSecond);
}
var $d77b025aa58d633c$var$second = new $d77b025aa58d633c$var$CountableTimeInterval($d77b025aa58d633c$var$encode2, $d77b025aa58d633c$var$decode2);
var $d77b025aa58d633c$var$second_default = $d77b025aa58d633c$var$second;
// packages/ag-charts-community/src/util/time/minute.ts
var $d77b025aa58d633c$var$offset2 = /* @__PURE__ */ new Date().getTimezoneOffset() * $d77b025aa58d633c$var$durationMinute;
function $d77b025aa58d633c$var$encode3(date) {
    return Math.floor((date.getTime() - $d77b025aa58d633c$var$offset2) / $d77b025aa58d633c$var$durationMinute);
}
function $d77b025aa58d633c$var$decode3(encoded) {
    return new Date($d77b025aa58d633c$var$offset2 + encoded * $d77b025aa58d633c$var$durationMinute);
}
var $d77b025aa58d633c$var$minute = new $d77b025aa58d633c$var$CountableTimeInterval($d77b025aa58d633c$var$encode3, $d77b025aa58d633c$var$decode3);
var $d77b025aa58d633c$var$minute_default = $d77b025aa58d633c$var$minute;
// packages/ag-charts-community/src/util/time/hour.ts
var $d77b025aa58d633c$var$offset3 = /* @__PURE__ */ new Date().getTimezoneOffset() * $d77b025aa58d633c$var$durationMinute;
function $d77b025aa58d633c$var$encode4(date) {
    return Math.floor((date.getTime() - $d77b025aa58d633c$var$offset3) / $d77b025aa58d633c$var$durationHour);
}
function $d77b025aa58d633c$var$decode4(encoded) {
    return new Date($d77b025aa58d633c$var$offset3 + encoded * $d77b025aa58d633c$var$durationHour);
}
var $d77b025aa58d633c$var$hour = new $d77b025aa58d633c$var$CountableTimeInterval($d77b025aa58d633c$var$encode4, $d77b025aa58d633c$var$decode4);
var $d77b025aa58d633c$var$hour_default = $d77b025aa58d633c$var$hour;
// packages/ag-charts-community/src/util/time/day.ts
function $d77b025aa58d633c$var$encode5(date) {
    const tzOffsetMs = date.getTimezoneOffset() * $d77b025aa58d633c$var$durationMinute;
    return Math.floor((date.getTime() - tzOffsetMs) / $d77b025aa58d633c$var$durationDay);
}
function $d77b025aa58d633c$var$decode5(encoded) {
    const d = new Date(1970, 0, 1);
    d.setDate(d.getDate() + encoded);
    return d;
}
var $d77b025aa58d633c$var$day = new $d77b025aa58d633c$var$CountableTimeInterval($d77b025aa58d633c$var$encode5, $d77b025aa58d633c$var$decode5);
var $d77b025aa58d633c$var$day_default = $d77b025aa58d633c$var$day;
// packages/ag-charts-community/src/util/time/week.ts
function $d77b025aa58d633c$var$weekday(weekStart) {
    const thursday2 = 4;
    const dayShift = (7 + weekStart - thursday2) % 7;
    function encode13(date) {
        const tzOffsetMs = date.getTimezoneOffset() * $d77b025aa58d633c$var$durationMinute;
        return Math.floor((date.getTime() - tzOffsetMs) / $d77b025aa58d633c$var$durationWeek - dayShift / 7);
    }
    function decode13(encoded) {
        const d = new Date(1970, 0, 1);
        d.setDate(d.getDate() + encoded * 7 + dayShift);
        return d;
    }
    return new $d77b025aa58d633c$var$CountableTimeInterval(encode13, decode13);
}
var $d77b025aa58d633c$var$sunday = $d77b025aa58d633c$var$weekday(0);
var $d77b025aa58d633c$var$monday = $d77b025aa58d633c$var$weekday(1);
var $d77b025aa58d633c$var$tuesday = $d77b025aa58d633c$var$weekday(2);
var $d77b025aa58d633c$var$wednesday = $d77b025aa58d633c$var$weekday(3);
var $d77b025aa58d633c$var$thursday = $d77b025aa58d633c$var$weekday(4);
var $d77b025aa58d633c$var$friday = $d77b025aa58d633c$var$weekday(5);
var $d77b025aa58d633c$var$saturday = $d77b025aa58d633c$var$weekday(6);
var $d77b025aa58d633c$var$week_default = $d77b025aa58d633c$var$sunday;
// packages/ag-charts-community/src/util/time/month.ts
function $d77b025aa58d633c$var$encode6(date) {
    return date.getFullYear() * 12 + date.getMonth();
}
function $d77b025aa58d633c$var$decode6(encoded) {
    const year2 = Math.floor(encoded / 12);
    const month2 = encoded - year2 * 12;
    return new Date(year2, month2, 1);
}
var $d77b025aa58d633c$var$month = new $d77b025aa58d633c$var$CountableTimeInterval($d77b025aa58d633c$var$encode6, $d77b025aa58d633c$var$decode6);
var $d77b025aa58d633c$var$month_default = $d77b025aa58d633c$var$month;
// packages/ag-charts-community/src/util/time/year.ts
function $d77b025aa58d633c$var$encode7(date) {
    return date.getFullYear();
}
function $d77b025aa58d633c$var$decode7(encoded) {
    const d = /* @__PURE__ */ new Date();
    d.setFullYear(encoded);
    d.setMonth(0, 1);
    d.setHours(0, 0, 0, 0);
    return d;
}
var $d77b025aa58d633c$var$year = new $d77b025aa58d633c$var$CountableTimeInterval($d77b025aa58d633c$var$encode7, $d77b025aa58d633c$var$decode7);
var $d77b025aa58d633c$var$year_default = $d77b025aa58d633c$var$year;
// packages/ag-charts-community/src/util/time/utcMinute.ts
function $d77b025aa58d633c$var$encode8(date) {
    return Math.floor(date.getTime() / $d77b025aa58d633c$var$durationMinute);
}
function $d77b025aa58d633c$var$decode8(encoded) {
    return new Date(encoded * $d77b025aa58d633c$var$durationMinute);
}
var $d77b025aa58d633c$var$utcMinute = new $d77b025aa58d633c$var$CountableTimeInterval($d77b025aa58d633c$var$encode8, $d77b025aa58d633c$var$decode8);
// packages/ag-charts-community/src/util/time/utcHour.ts
function $d77b025aa58d633c$var$encode9(date) {
    return Math.floor(date.getTime() / $d77b025aa58d633c$var$durationHour);
}
function $d77b025aa58d633c$var$decode9(encoded) {
    return new Date(encoded * $d77b025aa58d633c$var$durationHour);
}
var $d77b025aa58d633c$var$utcHour = new $d77b025aa58d633c$var$CountableTimeInterval($d77b025aa58d633c$var$encode9, $d77b025aa58d633c$var$decode9);
// packages/ag-charts-community/src/util/time/utcDay.ts
function $d77b025aa58d633c$var$encode10(date) {
    return Math.floor(date.getTime() / $d77b025aa58d633c$var$durationDay);
}
function $d77b025aa58d633c$var$decode10(encoded) {
    const d = /* @__PURE__ */ new Date(0);
    d.setUTCDate(d.getUTCDate() + encoded);
    d.setUTCHours(0, 0, 0, 0);
    return d;
}
var $d77b025aa58d633c$var$utcDay = new $d77b025aa58d633c$var$CountableTimeInterval($d77b025aa58d633c$var$encode10, $d77b025aa58d633c$var$decode10);
// packages/ag-charts-community/src/util/time/utcMonth.ts
function $d77b025aa58d633c$var$encode11(date) {
    return date.getUTCFullYear() * 12 + date.getUTCMonth();
}
function $d77b025aa58d633c$var$decode11(encoded) {
    const year2 = Math.floor(encoded / 12);
    const month2 = encoded - year2 * 12;
    return new Date(Date.UTC(year2, month2, 1));
}
var $d77b025aa58d633c$var$utcMonth = new $d77b025aa58d633c$var$CountableTimeInterval($d77b025aa58d633c$var$encode11, $d77b025aa58d633c$var$decode11);
// packages/ag-charts-community/src/util/time/utcYear.ts
function $d77b025aa58d633c$var$encode12(date) {
    return date.getUTCFullYear();
}
function $d77b025aa58d633c$var$decode12(encoded) {
    const d = /* @__PURE__ */ new Date();
    d.setUTCFullYear(encoded);
    d.setUTCMonth(0, 1);
    d.setUTCHours(0, 0, 0, 0);
    return d;
}
var $d77b025aa58d633c$var$utcYear = new $d77b025aa58d633c$var$CountableTimeInterval($d77b025aa58d633c$var$encode12, $d77b025aa58d633c$var$decode12);
// packages/ag-charts-community/src/module/enterpriseModule.ts
var $d77b025aa58d633c$var$enterpriseModule = {
    isEnterprise: false
};
// packages/ag-charts-community/src/module/module.ts
var $d77b025aa58d633c$var$BaseModuleInstance = class {
    constructor(){
        this.destroyFns = [];
    }
    destroy() {
        for (const destroyFn of this.destroyFns)destroyFn();
    }
};
var $d77b025aa58d633c$var$ModuleRegistry = class {
    constructor(){
        this.modules = [];
        this.dependencies = /* @__PURE__ */ new Set();
        this.dependents = /* @__PURE__ */ new Set();
    }
    register(...modules) {
        for (const module of modules){
            this.registerDependencies(module);
            const otherModule = this.modules.find((other)=>module.type === other.type && module.optionsKey === other.optionsKey && module.identifier === other.identifier);
            if (otherModule) {
                if (module.packageType === "enterprise" && otherModule.packageType === "community") {
                    const index = this.modules.indexOf(otherModule);
                    this.modules.splice(index, 1, module);
                }
            } else this.modules.push(module);
        }
    }
    hasEnterpriseModules() {
        return this.modules.some((m)=>m.packageType === "enterprise");
    }
    *byType(...types) {
        for (const module of this.modules)if (types.includes(module.type) && this.dependencies.has(module.optionsKey)) yield module;
        for (const module of this.modules)if (types.includes(module.type) && !this.dependencies.has(module.optionsKey) && !this.dependents.has(module.optionsKey)) yield module;
        for (const module of this.modules)if (types.includes(module.type) && this.dependents.has(module.optionsKey)) yield module;
    }
    registerDependencies(module) {
        if (module.dependencies == null || module.dependencies.length === 0) return;
        if (this.dependencies.has(module.optionsKey)) throw new Error(`Module [${module.optionsKey}] can not both be depended upon by any module and have dependencies of [${module.dependencies}].`);
        for (const dep of module.dependencies){
            if (this.dependents.has(dep)) throw new Error(`Module [${dep}] can not both be depended upon by any module and have dependencies of [${module.optionsKey}].`);
            this.dependencies.add(dep);
        }
        this.dependents.add(module.optionsKey);
    }
};
var $d77b025aa58d633c$var$moduleRegistry = new $d77b025aa58d633c$var$ModuleRegistry();
// packages/ag-charts-community/src/chart/factory/axisRegistry.ts
var $d77b025aa58d633c$var$AxisRegistry = class {
    constructor(){
        this.axesMap = /* @__PURE__ */ new Map();
        this.hidden = /* @__PURE__ */ new Set();
        this.themeTemplates = /* @__PURE__ */ new Map();
    }
    register(axisType, module) {
        this.axesMap.set(axisType, module.instanceConstructor);
        if (module.themeTemplate) this.setThemeTemplate(axisType, module.themeTemplate);
        if (module.hidden) this.hidden.add(axisType);
    }
    create(axisType, moduleContext) {
        const AxisConstructor = this.axesMap.get(axisType);
        if (AxisConstructor) return new AxisConstructor(moduleContext);
        throw new Error(`AG Charts - unknown axis type: ${axisType}`);
    }
    has(axisType) {
        return this.axesMap.has(axisType);
    }
    keys() {
        return this.axesMap.keys();
    }
    publicKeys() {
        return [
            ...this.keys()
        ].filter((k)=>!this.hidden.has(k));
    }
    setThemeTemplate(axisType, themeTemplate) {
        this.themeTemplates.set(axisType, themeTemplate);
        return this;
    }
    getThemeTemplate(axisType) {
        return this.themeTemplates.get(axisType);
    }
};
var $d77b025aa58d633c$var$axisRegistry = new $d77b025aa58d633c$var$AxisRegistry();
// packages/ag-charts-community/src/util/decorator.ts
var $d77b025aa58d633c$var$BREAK_TRANSFORM_CHAIN = Symbol("BREAK");
var $d77b025aa58d633c$var$CONFIG_KEY = "__decorator_config";
function $d77b025aa58d633c$var$initialiseConfig(target, propertyKeyOrSymbol) {
    if (Object.getOwnPropertyDescriptor(target, $d77b025aa58d633c$var$CONFIG_KEY) == null) Object.defineProperty(target, $d77b025aa58d633c$var$CONFIG_KEY, {
        value: {}
    });
    const config = target[$d77b025aa58d633c$var$CONFIG_KEY];
    const propertyKey = propertyKeyOrSymbol.toString();
    if (typeof config[propertyKey] !== "undefined") return config[propertyKey];
    const valuesMap = /* @__PURE__ */ new WeakMap();
    config[propertyKey] = {
        setters: [],
        getters: [],
        observers: [],
        valuesMap: valuesMap
    };
    const descriptor = Object.getOwnPropertyDescriptor(target, propertyKeyOrSymbol);
    const prevSet = descriptor == null ? void 0 : descriptor.set;
    const prevGet = descriptor == null ? void 0 : descriptor.get;
    const getter = function() {
        let value = prevGet ? prevGet.call(this) : valuesMap.get(this);
        for (const transformFn of config[propertyKey].getters){
            value = transformFn(this, propertyKeyOrSymbol, value);
            if (value === $d77b025aa58d633c$var$BREAK_TRANSFORM_CHAIN) return;
        }
        return value;
    };
    const setter = function(value) {
        const { setters: setters, observers: observers } = config[propertyKey];
        let oldValue;
        if (setters.some((f)=>f.length > 2)) oldValue = prevGet ? prevGet.call(this) : valuesMap.get(this);
        for (const transformFn of setters){
            value = transformFn(this, propertyKeyOrSymbol, value, oldValue);
            if (value === $d77b025aa58d633c$var$BREAK_TRANSFORM_CHAIN) return;
        }
        if (prevSet) prevSet.call(this, value);
        else valuesMap.set(this, value);
        for (const observerFn of observers)observerFn(this, value, oldValue);
    };
    Object.defineProperty(target, propertyKeyOrSymbol, {
        set: setter,
        get: getter,
        enumerable: true,
        configurable: false
    });
    return config[propertyKey];
}
function $d77b025aa58d633c$var$addTransformToInstanceProperty(setTransform, getTransform, configMetadata) {
    return (target, propertyKeyOrSymbol)=>{
        const config = $d77b025aa58d633c$var$initialiseConfig(target, propertyKeyOrSymbol);
        config.setters.push(setTransform);
        if (getTransform) config.getters.unshift(getTransform);
        if (configMetadata) Object.assign(config, configMetadata);
    };
}
function $d77b025aa58d633c$var$addObserverToInstanceProperty(setObserver) {
    return (target, propertyKeyOrSymbol)=>{
        $d77b025aa58d633c$var$initialiseConfig(target, propertyKeyOrSymbol).observers.push(setObserver);
    };
}
function $d77b025aa58d633c$var$isDecoratedObject(target) {
    return typeof target !== "undefined" && $d77b025aa58d633c$var$CONFIG_KEY in target;
}
function $d77b025aa58d633c$var$listDecoratedProperties(target) {
    const targets = /* @__PURE__ */ new Set();
    while($d77b025aa58d633c$var$isDecoratedObject(target)){
        targets.add(target == null ? void 0 : target[$d77b025aa58d633c$var$CONFIG_KEY]);
        target = Object.getPrototypeOf(target);
    }
    return Array.from(targets).flatMap((configMap)=>Object.keys(configMap));
}
function $d77b025aa58d633c$var$extractDecoratedProperties(target) {
    return $d77b025aa58d633c$var$listDecoratedProperties(target).reduce((result, key)=>{
        var _a;
        result[key] = (_a = target[key]) != null ? _a : null;
        return result;
    }, {});
}
function $d77b025aa58d633c$var$extractDecoratedPropertyMetadata(target, propertyKeyOrSymbol) {
    const propertyKey = propertyKeyOrSymbol.toString();
    while($d77b025aa58d633c$var$isDecoratedObject(target)){
        const config = target[$d77b025aa58d633c$var$CONFIG_KEY];
        if (Object.hasOwn(config, propertyKey)) return config[propertyKey];
        target = Object.getPrototypeOf(target);
    }
}
// packages/ag-charts-community/src/util/type-guards.ts
function $d77b025aa58d633c$var$isDefined(val) {
    return val != null;
}
function $d77b025aa58d633c$var$isArray(value) {
    return Array.isArray(value);
}
function $d77b025aa58d633c$var$isBoolean(value) {
    return typeof value === "boolean";
}
function $d77b025aa58d633c$var$isDate(value) {
    return value instanceof Date;
}
function $d77b025aa58d633c$var$isValidDate(value) {
    return $d77b025aa58d633c$var$isDate(value) && !isNaN(Number(value));
}
function $d77b025aa58d633c$var$isRegExp(value) {
    return value instanceof RegExp;
}
function $d77b025aa58d633c$var$isFunction(value) {
    return typeof value === "function";
}
function $d77b025aa58d633c$var$isObject(value) {
    return typeof value === "object" && value !== null && !$d77b025aa58d633c$var$isArray(value);
}
function $d77b025aa58d633c$var$isObjectLike(value) {
    return $d77b025aa58d633c$var$isArray(value) || $d77b025aa58d633c$var$isPlainObject(value);
}
function $d77b025aa58d633c$var$isPlainObject(value) {
    return typeof value === "object" && value !== null && value.constructor === Object;
}
function $d77b025aa58d633c$var$isString(value) {
    return typeof value === "string";
}
function $d77b025aa58d633c$var$isNumber(value) {
    return typeof value === "number";
}
function $d77b025aa58d633c$var$isFiniteNumber(value) {
    return $d77b025aa58d633c$var$isNumber(value) && Number.isFinite(value);
}
function $d77b025aa58d633c$var$isHtmlElement(value) {
    return typeof window !== "undefined" && value instanceof HTMLElement;
}
function $d77b025aa58d633c$var$isEnumKey(enumObject, enumKey) {
    return $d77b025aa58d633c$var$isString(enumKey) && Object.keys(enumObject).includes(enumKey);
}
function $d77b025aa58d633c$var$isEnumValue(enumObject, enumValue) {
    return Object.values(enumObject).includes(enumValue);
}
function $d77b025aa58d633c$var$isSymbol(value) {
    return typeof value === "symbol";
}
// packages/ag-charts-community/src/util/object.ts
function $d77b025aa58d633c$var$deepMerge(...sources) {
    return $d77b025aa58d633c$var$mergeDefaults(...sources.reverse());
}
function $d77b025aa58d633c$var$mergeDefaults(...sources) {
    var _a;
    const target = {};
    for (const source of sources){
        if (!$d77b025aa58d633c$var$isObject(source)) continue;
        const keys = $d77b025aa58d633c$var$isDecoratedObject(source) ? $d77b025aa58d633c$var$listDecoratedProperties(source) : Object.keys(source);
        for (const key of keys)if ($d77b025aa58d633c$var$isPlainObject(target[key]) && $d77b025aa58d633c$var$isPlainObject(source[key])) target[key] = $d77b025aa58d633c$var$mergeDefaults(target[key], source[key]);
        else (_a = target[key]) != null ? _a : target[key] = source[key];
    }
    return target;
}
function $d77b025aa58d633c$var$mergeArrayDefaults(dataArray, ...itemDefaults) {
    if (itemDefaults && $d77b025aa58d633c$var$isArray(dataArray)) return dataArray.map((item)=>$d77b025aa58d633c$var$mergeDefaults(item, ...itemDefaults));
    return dataArray;
}
function $d77b025aa58d633c$var$mapValues(object, mapper) {
    return Object.entries(object).reduce((result, [key, value])=>{
        result[key] = mapper(value, key, object);
        return result;
    }, {});
}
function $d77b025aa58d633c$var$without(object, keys) {
    const clone = $d77b025aa58d633c$var$__spreadValues({}, object);
    for (const key of keys)delete clone[key];
    return clone;
}
function $d77b025aa58d633c$var$getPath(object, path) {
    const pathArray = $d77b025aa58d633c$var$isArray(path) ? path : path.split(".");
    return pathArray.reduce((value, pathKey)=>value[pathKey], object);
}
var $d77b025aa58d633c$var$SKIP_JS_BUILTINS = /* @__PURE__ */ new Set([
    "__proto__",
    "constructor",
    "prototype"
]);
function $d77b025aa58d633c$var$setPath(object, path, newValue) {
    const pathArray = $d77b025aa58d633c$var$isArray(path) ? path.slice() : path.split(".");
    const lastKey = pathArray.pop();
    if (pathArray.some((p)=>$d77b025aa58d633c$var$SKIP_JS_BUILTINS.has(p))) return;
    const lastObject = pathArray.reduce((value, pathKey)=>value[pathKey], object);
    lastObject[lastKey] = newValue;
}
function $d77b025aa58d633c$var$partialAssign(keysToCopy, target, source) {
    if (source === void 0) return target;
    for (const key of keysToCopy){
        const value = source[key];
        if (value !== void 0) target[key] = value;
    }
    return target;
}
// packages/ag-charts-community/src/chart/factory/chartTypes.ts
var $d77b025aa58d633c$var$ChartTypes = class extends Map {
    get(seriesType) {
        var _a;
        return (_a = super.get(seriesType)) != null ? _a : "unknown";
    }
    isCartesian(seriesType) {
        return this.get(seriesType) === "cartesian";
    }
    isPolar(seriesType) {
        return this.get(seriesType) === "polar";
    }
    isHierarchy(seriesType) {
        return this.get(seriesType) === "hierarchy";
    }
    isTopology(seriesType) {
        return this.get(seriesType) === "topology";
    }
    get seriesTypes() {
        return Array.from(this.keys());
    }
    get cartesianTypes() {
        return this.seriesTypes.filter((t)=>this.isCartesian(t));
    }
    get polarTypes() {
        return this.seriesTypes.filter((t)=>this.isPolar(t));
    }
    get hierarchyTypes() {
        return this.seriesTypes.filter((t)=>this.isHierarchy(t));
    }
    get topologyTypes() {
        return this.seriesTypes.filter((t)=>this.isTopology(t));
    }
};
var $d77b025aa58d633c$var$ChartDefaults = class extends Map {
    set(chartType2, defaults) {
        return super.set(chartType2, $d77b025aa58d633c$var$mergeDefaults(defaults, this.get(chartType2)));
    }
};
var $d77b025aa58d633c$var$chartTypes = new $d77b025aa58d633c$var$ChartTypes();
var $d77b025aa58d633c$var$publicChartTypes = new $d77b025aa58d633c$var$ChartTypes();
var $d77b025aa58d633c$var$chartDefaults = new $d77b025aa58d633c$var$ChartDefaults();
// packages/ag-charts-community/src/chart/factory/expectedEnterpriseModules.ts
var $d77b025aa58d633c$var$EXPECTED_ENTERPRISE_MODULES = [
    {
        type: "root",
        optionsKey: "animation",
        chartTypes: [
            "cartesian",
            "polar",
            "hierarchy",
            "topology"
        ]
    },
    {
        type: "root",
        optionsKey: "annotations",
        chartTypes: [
            "cartesian"
        ]
    },
    {
        type: "root",
        optionsKey: "background",
        chartTypes: [
            "cartesian",
            "polar",
            "hierarchy",
            "topology"
        ],
        optionsInnerKey: "image"
    },
    {
        type: "root",
        optionsKey: "contextMenu",
        chartTypes: [
            "cartesian",
            "polar",
            "hierarchy",
            "topology"
        ]
    },
    {
        type: "root",
        optionsKey: "dataSource",
        chartTypes: [
            "cartesian",
            "polar",
            "hierarchy",
            "topology"
        ]
    },
    {
        type: "root",
        optionsKey: "sync",
        chartTypes: [
            "cartesian"
        ]
    },
    {
        type: "root",
        optionsKey: "zoom",
        chartTypes: [
            "cartesian",
            "topology"
        ]
    },
    {
        type: "legend",
        optionsKey: "gradientLegend",
        chartTypes: [
            "cartesian",
            "polar",
            "hierarchy",
            "topology"
        ],
        identifier: "gradient"
    },
    {
        type: "root",
        optionsKey: "navigator",
        chartTypes: [
            "cartesian"
        ],
        optionsInnerKey: "miniChart"
    },
    {
        type: "axis",
        optionsKey: "axes[]",
        chartTypes: [
            "polar"
        ],
        identifier: "angle-category"
    },
    {
        type: "axis",
        optionsKey: "axes[]",
        chartTypes: [
            "polar"
        ],
        identifier: "angle-number"
    },
    {
        type: "axis",
        optionsKey: "axes[]",
        chartTypes: [
            "polar"
        ],
        identifier: "radius-category"
    },
    {
        type: "axis",
        optionsKey: "axes[]",
        chartTypes: [
            "polar"
        ],
        identifier: "radius-number"
    },
    {
        type: "axis",
        optionsKey: "axes[]",
        chartTypes: [
            "cartesian"
        ],
        identifier: "ordinal-time"
    },
    {
        type: "axis-option",
        optionsKey: "crosshair",
        chartTypes: [
            "cartesian"
        ]
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "cartesian"
        ],
        identifier: "box-plot"
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "cartesian"
        ],
        identifier: "candlestick"
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "cartesian"
        ],
        identifier: "ohlc"
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "cartesian"
        ],
        identifier: "bullet"
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "cartesian"
        ],
        identifier: "heatmap"
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "cartesian"
        ],
        identifier: "range-area"
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "cartesian"
        ],
        identifier: "range-bar"
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "cartesian"
        ],
        identifier: "waterfall"
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "polar"
        ],
        identifier: "nightingale"
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "polar"
        ],
        identifier: "radar-area"
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "polar"
        ],
        identifier: "radar-line"
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "polar"
        ],
        identifier: "radial-bar"
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "polar"
        ],
        identifier: "radial-column"
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "hierarchy"
        ],
        identifier: "sunburst"
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "hierarchy"
        ],
        identifier: "treemap"
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "topology"
        ],
        identifier: "map-shape"
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "topology"
        ],
        identifier: "map-line"
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "topology"
        ],
        identifier: "map-marker"
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "topology"
        ],
        identifier: "map-shape-background"
    },
    {
        type: "series",
        optionsKey: "series[]",
        chartTypes: [
            "topology"
        ],
        identifier: "map-line-background"
    },
    {
        type: "series-option",
        optionsKey: "errorBar",
        chartTypes: [
            "cartesian"
        ],
        identifier: "error-bars"
    }
];
function $d77b025aa58d633c$var$isEnterpriseSeriesType(type) {
    return $d77b025aa58d633c$var$EXPECTED_ENTERPRISE_MODULES.some((s)=>s.type === "series" && s.identifier === type);
}
function $d77b025aa58d633c$var$getEnterpriseSeriesChartTypes(type) {
    var _a;
    return (_a = $d77b025aa58d633c$var$EXPECTED_ENTERPRISE_MODULES.find((s)=>s.type === "series" && s.identifier === type)) == null ? void 0 : _a.chartTypes;
}
function $d77b025aa58d633c$var$isEnterpriseCartesian(seriesType) {
    var _a;
    const type = (_a = $d77b025aa58d633c$var$getEnterpriseSeriesChartTypes(seriesType)) == null ? void 0 : _a.find((v)=>v === "cartesian");
    return type === "cartesian";
}
function $d77b025aa58d633c$var$isEnterprisePolar(seriesType) {
    var _a;
    const type = (_a = $d77b025aa58d633c$var$getEnterpriseSeriesChartTypes(seriesType)) == null ? void 0 : _a.find((v)=>v === "polar");
    return type === "polar";
}
function $d77b025aa58d633c$var$isEnterpriseHierarchy(seriesType) {
    var _a;
    const type = (_a = $d77b025aa58d633c$var$getEnterpriseSeriesChartTypes(seriesType)) == null ? void 0 : _a.find((v)=>v === "hierarchy");
    return type === "hierarchy";
}
function $d77b025aa58d633c$var$isEnterpriseTopology(seriesType) {
    var _a;
    const type = (_a = $d77b025aa58d633c$var$getEnterpriseSeriesChartTypes(seriesType)) == null ? void 0 : _a.find((v)=>v === "topology");
    return type === "topology";
}
function $d77b025aa58d633c$var$isEnterpriseModule(module) {
    return module.packageType === "enterprise";
}
function $d77b025aa58d633c$var$verifyIfModuleExpected(module) {
    var _a;
    if (!$d77b025aa58d633c$var$isEnterpriseModule(module)) throw new Error("AG Charts - internal configuration error, only enterprise modules need verification.");
    const stub = $d77b025aa58d633c$var$EXPECTED_ENTERPRISE_MODULES.find((s)=>{
        return s.type === module.type && s.optionsKey === module.optionsKey && s.identifier === module.identifier && module.chartTypes.every((t)=>s.chartTypes.includes(t));
    });
    if (stub) {
        (_a = stub.useCount) != null ? _a : stub.useCount = 0;
        stub.useCount++;
    }
    return stub != null;
}
function $d77b025aa58d633c$var$getUnusedExpectedModules() {
    return $d77b025aa58d633c$var$EXPECTED_ENTERPRISE_MODULES.filter(({ useCount: useCount })=>useCount == null || useCount === 0);
}
// packages/ag-charts-community/src/chart/mapping/types.ts
function $d77b025aa58d633c$var$optionsType(input) {
    var _a, _b, _c;
    return (_c = (_b = (_a = input.series) == null ? void 0 : _a[0]) == null ? void 0 : _b.type) != null ? _c : "line";
}
function $d77b025aa58d633c$var$isAgCartesianChartOptions(input) {
    const specifiedType = $d77b025aa58d633c$var$optionsType(input);
    if (specifiedType == null) return true;
    if (specifiedType === "cartesian") {
        $d77b025aa58d633c$var$Logger.warnOnce(`type '${specifiedType}' is deprecated, use a series type instead`);
        return true;
    }
    return $d77b025aa58d633c$var$chartTypes.isCartesian(specifiedType) || $d77b025aa58d633c$var$isEnterpriseCartesian(specifiedType);
}
function $d77b025aa58d633c$var$isAgPolarChartOptions(input) {
    const specifiedType = $d77b025aa58d633c$var$optionsType(input);
    if (specifiedType == null) return false;
    if (specifiedType === "polar") {
        $d77b025aa58d633c$var$Logger.warnOnce(`type '${specifiedType}' is deprecated, use a series type instead`);
        return true;
    }
    return $d77b025aa58d633c$var$chartTypes.isPolar(specifiedType) || $d77b025aa58d633c$var$isEnterprisePolar(specifiedType);
}
function $d77b025aa58d633c$var$isAgHierarchyChartOptions(input) {
    const specifiedType = $d77b025aa58d633c$var$optionsType(input);
    if (specifiedType == null) return false;
    if (specifiedType === "hierarchy") {
        $d77b025aa58d633c$var$Logger.warnOnce(`type '${specifiedType}' is deprecated, use a series type instead`);
        return true;
    }
    return $d77b025aa58d633c$var$chartTypes.isHierarchy(specifiedType) || $d77b025aa58d633c$var$isEnterpriseHierarchy(specifiedType);
}
function $d77b025aa58d633c$var$isAgTopologyChartOptions(input) {
    const specifiedType = $d77b025aa58d633c$var$optionsType(input);
    if (specifiedType == null) return false;
    if (specifiedType === "topology") {
        $d77b025aa58d633c$var$Logger.warnOnce(`type '${specifiedType}' is deprecated, use a series type instead`);
        return true;
    }
    return $d77b025aa58d633c$var$chartTypes.isTopology(specifiedType) || $d77b025aa58d633c$var$isEnterpriseTopology(specifiedType);
}
function $d77b025aa58d633c$var$isAgPolarChartOptionsWithSeriesBasedLegend(input) {
    const specifiedType = $d77b025aa58d633c$var$optionsType(input);
    return $d77b025aa58d633c$var$isAgPolarChartOptions(input) && specifiedType !== "pie" && specifiedType !== "donut";
}
function $d77b025aa58d633c$var$isSeriesOptionType(input) {
    if (input == null) return false;
    return $d77b025aa58d633c$var$chartTypes.has(input);
}
function $d77b025aa58d633c$var$isAxisOptionType(input) {
    if (input == null) return false;
    return $d77b025aa58d633c$var$axisRegistry.has(input);
}
// packages/ag-charts-community/src/chart/factory/processEnterpriseOptions.ts
function $d77b025aa58d633c$var$removeUsedEnterpriseOptions(options) {
    var _a, _b, _c, _d;
    const usedOptions = [];
    const optionsChartType = $d77b025aa58d633c$var$chartTypes.get($d77b025aa58d633c$var$optionsType(options));
    for (const { type: type, chartTypes: moduleChartTypes, optionsKey: optionsKey, optionsInnerKey: optionsInnerKey, identifier: identifier } of $d77b025aa58d633c$var$EXPECTED_ENTERPRISE_MODULES){
        if (optionsChartType !== "unknown" && !moduleChartTypes.includes(optionsChartType)) continue;
        if (type === "root" || type === "legend") {
            const optionValue = options[optionsKey];
            if (optionValue == null) continue;
            if (!optionsInnerKey) {
                usedOptions.push(optionsKey);
                delete options[optionsKey];
            } else if (optionValue[optionsInnerKey]) {
                usedOptions.push(`${optionsKey}.${optionsInnerKey}`);
                delete optionValue[optionsInnerKey];
            }
        } else if (type === "axis") {
            if (!("axes" in options) || !((_a = options.axes) == null ? void 0 : _a.some((axis)=>axis.type === identifier))) continue;
            usedOptions.push(`axis[type=${identifier}]`);
            options.axes = options.axes.filter((axis)=>axis.type !== identifier);
        } else if (type === "axis-option") {
            if (!("axes" in options) || !((_b = options.axes) == null ? void 0 : _b.some((axis)=>axis[optionsKey]))) continue;
            usedOptions.push(`axis.${optionsKey}`);
            options.axes.forEach((axis)=>{
                if (axis[optionsKey]) delete axis[optionsKey];
            });
        } else if (type === "series") {
            if (!((_c = options.series) == null ? void 0 : _c.some((series)=>series.type === identifier))) continue;
            usedOptions.push(`series[type=${identifier}]`);
            options.series = options.series.filter((series)=>series.type !== identifier);
        } else if (type === "series-option") {
            if (!((_d = options.series) == null ? void 0 : _d.some((series)=>series[optionsKey]))) continue;
            usedOptions.push(`series.${optionsKey}`);
            options.series.forEach((series)=>{
                if (series[optionsKey]) delete series[optionsKey];
            });
        }
    }
    if (usedOptions.length) {
        let enterprisePackageName = "ag-charts-enterprise";
        let enterpriseReferenceUrl = "https://charts.ag-grid.com/javascript/installation/";
        if (options.mode === "integrated") {
            enterprisePackageName = "ag-grid-charts-enterprise' or 'ag-grid-enterprise/charts-enterprise";
            enterpriseReferenceUrl = "https://www.ag-grid.com/javascript-data-grid/integrated-charts-installation/";
        }
        $d77b025aa58d633c$var$Logger.warnOnce([
            `unable to use these enterprise features as '${enterprisePackageName}' has not been loaded:`,
            "",
            ...usedOptions,
            "",
            `See: ${enterpriseReferenceUrl}`
        ].join("\n"));
    }
}
// packages/ag-charts-community/src/util/properties.ts
var $d77b025aa58d633c$var$BaseProperties = class {
    set(properties) {
        const { className: className = this.constructor.name } = this.constructor;
        if (typeof properties !== "object") {
            $d77b025aa58d633c$var$Logger.warn(`unable to set ${className} - expecting a properties object`);
            return this;
        }
        const keys = new Set(Object.keys(properties));
        for (const propertyKey of $d77b025aa58d633c$var$listDecoratedProperties(this))if (keys.has(propertyKey)) {
            const value = properties[propertyKey];
            const self = this;
            if ($d77b025aa58d633c$var$isProperties(self[propertyKey])) self[propertyKey] = self[propertyKey] instanceof $d77b025aa58d633c$var$PropertiesArray ? self[propertyKey].reset(value) : self[propertyKey].set(value);
            else self[propertyKey] = value;
            keys.delete(propertyKey);
        }
        for (const unknownKey of keys)$d77b025aa58d633c$var$Logger.warn(`unable to set [${unknownKey}] in ${className} - property is unknown`);
        return this;
    }
    isValid() {
        return $d77b025aa58d633c$var$listDecoratedProperties(this).every((propertyKey)=>{
            const { optional: optional } = $d77b025aa58d633c$var$extractDecoratedPropertyMetadata(this, propertyKey);
            const valid = optional || typeof this[propertyKey] !== "undefined";
            if (!valid) $d77b025aa58d633c$var$Logger.warnOnce(`[${propertyKey}] is required.`);
            return valid;
        });
    }
    toJson() {
        return $d77b025aa58d633c$var$listDecoratedProperties(this).reduce((object, propertyKey)=>{
            const propertyValue = this[propertyKey];
            object[propertyKey] = $d77b025aa58d633c$var$isProperties(propertyValue) ? propertyValue.toJson() : propertyValue;
            return object;
        }, {});
    }
};
var $d77b025aa58d633c$var$PropertiesArray = class _PropertiesArray extends Array {
    constructor(itemFactory, ...properties){
        super(properties.length);
        Object.defineProperty(this, "itemFactory", {
            value: itemFactory,
            enumerable: false,
            configurable: false
        });
        this.set(properties);
    }
    set(properties) {
        if ($d77b025aa58d633c$var$isArray(properties)) {
            this.length = properties.length;
            for(let i = 0; i < properties.length; i++)this[i] = new this.itemFactory().set(properties[i]);
        }
        return this;
    }
    reset(properties) {
        return new _PropertiesArray(this.itemFactory, ...properties);
    }
    toJson() {
        return this.map((value)=>{
            var _a, _b;
            return (_b = (_a = value == null ? void 0 : value.toJson) == null ? void 0 : _a.call(value)) != null ? _b : value;
        });
    }
};
function $d77b025aa58d633c$var$isProperties(value) {
    return value instanceof $d77b025aa58d633c$var$BaseProperties || value instanceof $d77b025aa58d633c$var$PropertiesArray;
}
// packages/ag-charts-community/src/util/json.ts
var $d77b025aa58d633c$var$CLASS_INSTANCE_TYPE = "class-instance";
function $d77b025aa58d633c$var$jsonDiff(source, target, skip) {
    if ($d77b025aa58d633c$var$isArray(target)) {
        if (!$d77b025aa58d633c$var$isArray(source) || source.length !== target.length || target.some((v, i)=>$d77b025aa58d633c$var$jsonDiff(source[i], v) != null)) return target;
    } else if ($d77b025aa58d633c$var$isPlainObject(target)) {
        if (!$d77b025aa58d633c$var$isPlainObject(source)) return target;
        const result = {};
        const allKeys = /* @__PURE__ */ new Set([
            ...Object.keys(source),
            ...Object.keys(target)
        ]);
        for (const key of allKeys){
            if (source[key] === target[key] || (skip == null ? void 0 : skip.includes(key))) continue;
            if (typeof source[key] === typeof target[key]) {
                const diff2 = $d77b025aa58d633c$var$jsonDiff(source[key], target[key]);
                if (diff2 !== null) result[key] = diff2;
            } else result[key] = target[key];
        }
        return Object.keys(result).length ? result : null;
    } else if (source !== target) return target;
    return null;
}
function $d77b025aa58d633c$var$deepClone(source, options) {
    if ($d77b025aa58d633c$var$isArray(source)) return source.map((item)=>$d77b025aa58d633c$var$deepClone(item, options));
    if ($d77b025aa58d633c$var$isPlainObject(source)) return $d77b025aa58d633c$var$mapValues(source, (value, key)=>{
        var _a;
        return ((_a = options == null ? void 0 : options.shallow) == null ? void 0 : _a.includes(key)) ? $d77b025aa58d633c$var$shallowClone(value) : $d77b025aa58d633c$var$deepClone(value, options);
    });
    return $d77b025aa58d633c$var$shallowClone(source);
}
function $d77b025aa58d633c$var$shallowClone(source) {
    if ($d77b025aa58d633c$var$isArray(source)) return [
        ...source
    ];
    if ($d77b025aa58d633c$var$isPlainObject(source)) return $d77b025aa58d633c$var$__spreadValues({}, source);
    if ($d77b025aa58d633c$var$isDate(source)) return new Date(source);
    if ($d77b025aa58d633c$var$isRegExp(source)) return new RegExp(source.source, source.flags);
    return source;
}
function $d77b025aa58d633c$var$jsonWalk(json, visit, opts, ...jsons) {
    var _a;
    if ($d77b025aa58d633c$var$isArray(json)) {
        visit(json, ...jsons);
        json.forEach((node, index)=>{
            $d77b025aa58d633c$var$jsonWalk(node, visit, opts, ...$d77b025aa58d633c$var$keyMapper(jsons, index));
        });
    } else if ($d77b025aa58d633c$var$isPlainObject(json)) {
        visit(json, ...jsons);
        for (const key of Object.keys(json)){
            if ((_a = opts == null ? void 0 : opts.skip) == null ? void 0 : _a.includes(key)) continue;
            const value = json[key];
            if ($d77b025aa58d633c$var$isArray(value) || $d77b025aa58d633c$var$isPlainObject(value)) $d77b025aa58d633c$var$jsonWalk(value, visit, opts, ...$d77b025aa58d633c$var$keyMapper(jsons, key));
        }
    }
}
function $d77b025aa58d633c$var$jsonApply(target, source, params = {}) {
    const { path: path, constructedArrays: constructedArrays, matcherPath: matcherPath = path == null ? void 0 : path.replace(/(\[[0-9+]+])/i, "[]"), skip: skip = [] } = params;
    if (target == null) throw new Error(`AG Charts - target is uninitialised: ${path != null ? path : "<root>"}`);
    if (source == null) return target;
    if ($d77b025aa58d633c$var$isProperties(target)) return target.set(source);
    const targetAny = target;
    const targetType = $d77b025aa58d633c$var$classify(target);
    for(const property in source){
        if ($d77b025aa58d633c$var$SKIP_JS_BUILTINS.has(property)) continue;
        const propertyMatcherPath = `${matcherPath ? matcherPath + "." : ""}${property}`;
        if (skip.includes(propertyMatcherPath)) continue;
        const newValue = source[property];
        const propertyPath = `${path ? path + "." : ""}${property}`;
        const targetClass = targetAny.constructor;
        const currentValue = targetAny[property];
        let ctr;
        try {
            const currentValueType = $d77b025aa58d633c$var$classify(currentValue);
            const newValueType = $d77b025aa58d633c$var$classify(newValue);
            if (targetType === $d77b025aa58d633c$var$CLASS_INSTANCE_TYPE && !(property in target)) {
                $d77b025aa58d633c$var$Logger.warn(`unable to set [${propertyPath}] in ${targetClass == null ? void 0 : targetClass.name} - property is unknown`);
                continue;
            }
            if (currentValueType != null && newValueType != null && newValueType !== currentValueType && (currentValueType !== $d77b025aa58d633c$var$CLASS_INSTANCE_TYPE || newValueType !== "object")) {
                $d77b025aa58d633c$var$Logger.warn(`unable to set [${propertyPath}] in ${targetClass == null ? void 0 : targetClass.name} - can't apply type of [${newValueType}], allowed types are: [${currentValueType}]`);
                continue;
            }
            if ($d77b025aa58d633c$var$isProperties(currentValue)) targetAny[property].set(newValue);
            else if (newValueType === "array") {
                ctr != null ? ctr : ctr = constructedArrays == null ? void 0 : constructedArrays.get(currentValue);
                if (ctr == null) targetAny[property] = newValue;
                else {
                    const newValueArray = newValue;
                    targetAny[property] = newValueArray.map((v)=>$d77b025aa58d633c$var$jsonApply(new ctr(), v, $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, params), {
                            path: propertyPath,
                            matcherPath: propertyMatcherPath + "[]"
                        })));
                }
            } else if (newValueType === $d77b025aa58d633c$var$CLASS_INSTANCE_TYPE) targetAny[property] = newValue;
            else if (newValueType === "object") {
                if (currentValue != null) $d77b025aa58d633c$var$jsonApply(currentValue, newValue, $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, params), {
                    path: propertyPath,
                    matcherPath: propertyMatcherPath
                }));
                else if (ctr == null) {
                    targetAny[property] = {};
                    $d77b025aa58d633c$var$jsonApply(targetAny[property], newValue, $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, params), {
                        path: propertyPath,
                        matcherPath: propertyMatcherPath
                    }));
                } else targetAny[property] = $d77b025aa58d633c$var$jsonApply(new ctr(), newValue, $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, params), {
                    path: propertyPath,
                    matcherPath: propertyMatcherPath
                }));
            } else targetAny[property] = newValue;
        } catch (error) {
            $d77b025aa58d633c$var$Logger.warn(`unable to set [${propertyPath}] in [${targetClass == null ? void 0 : targetClass.name}]; nested error is: ${error.message}`);
        }
    }
    return target;
}
function $d77b025aa58d633c$var$keyMapper(data, key) {
    return data.map((dataObject)=>dataObject == null ? void 0 : dataObject[key]);
}
function $d77b025aa58d633c$var$classify(value) {
    if (value == null) return null;
    if ($d77b025aa58d633c$var$isHtmlElement(value) || $d77b025aa58d633c$var$isDate(value)) return "primitive";
    if ($d77b025aa58d633c$var$isArray(value)) return "array";
    if ($d77b025aa58d633c$var$isObject(value)) return $d77b025aa58d633c$var$isPlainObject(value) ? "object" : $d77b025aa58d633c$var$CLASS_INSTANCE_TYPE;
    if ($d77b025aa58d633c$var$isFunction(value)) return "function";
    return "primitive";
}
// packages/ag-charts-community/src/chart/factory/seriesRegistry.ts
var $d77b025aa58d633c$var$SeriesRegistry = class {
    constructor(){
        this.seriesMap = /* @__PURE__ */ new Map();
        this.themeTemplates = /* @__PURE__ */ new Map();
    }
    register(seriesType, { chartTypes: [chartType2], instanceConstructor: instanceConstructor, defaultAxes: defaultAxes, themeTemplate: themeTemplate, enterpriseThemeTemplate: enterpriseThemeTemplate, paletteFactory: paletteFactory, solo: solo, stackable: stackable, groupable: groupable, stackedByDefault: stackedByDefault, swapDefaultAxesCondition: swapDefaultAxesCondition, hidden: hidden }) {
        this.setThemeTemplate(seriesType, themeTemplate, enterpriseThemeTemplate);
        this.seriesMap.set(seriesType, {
            instanceConstructor: instanceConstructor,
            defaultAxes: defaultAxes,
            paletteFactory: paletteFactory,
            solo: solo,
            stackable: stackable,
            groupable: groupable,
            stackedByDefault: stackedByDefault,
            swapDefaultAxesCondition: swapDefaultAxesCondition
        });
        $d77b025aa58d633c$var$chartTypes.set(seriesType, chartType2);
        if (!hidden) $d77b025aa58d633c$var$publicChartTypes.set(seriesType, chartType2);
    }
    create(seriesType, moduleContext) {
        var _a;
        const SeriesConstructor = (_a = this.seriesMap.get(seriesType)) == null ? void 0 : _a.instanceConstructor;
        if (SeriesConstructor) return new SeriesConstructor(moduleContext);
        throw new Error(`AG Charts - unknown series type: ${seriesType}`);
    }
    cloneDefaultAxes(seriesType) {
        var _a;
        const defaultAxes = (_a = this.seriesMap.get(seriesType)) == null ? void 0 : _a.defaultAxes;
        return defaultAxes ? {
            axes: $d77b025aa58d633c$var$deepClone(defaultAxes)
        } : null;
    }
    setThemeTemplate(seriesType, themeTemplate, enterpriseThemeTemplate = {}) {
        const currentTemplate = this.themeTemplates.get(seriesType);
        this.themeTemplates.set(seriesType, {
            community: $d77b025aa58d633c$var$mergeDefaults(themeTemplate, currentTemplate == null ? void 0 : currentTemplate.community),
            enterprise: $d77b025aa58d633c$var$mergeDefaults(enterpriseThemeTemplate, themeTemplate, currentTemplate == null ? void 0 : currentTemplate.community)
        });
    }
    getThemeTemplate(seriesType) {
        const themeTemplate = this.themeTemplates.get(seriesType);
        return $d77b025aa58d633c$var$enterpriseModule.isEnterprise ? themeTemplate == null ? void 0 : themeTemplate.enterprise : themeTemplate == null ? void 0 : themeTemplate.community;
    }
    getPaletteFactory(seriesType) {
        var _a;
        return (_a = this.seriesMap.get(seriesType)) == null ? void 0 : _a.paletteFactory;
    }
    isSolo(seriesType) {
        var _a, _b;
        return (_b = (_a = this.seriesMap.get(seriesType)) == null ? void 0 : _a.solo) != null ? _b : false;
    }
    isGroupable(seriesType) {
        var _a, _b;
        return (_b = (_a = this.seriesMap.get(seriesType)) == null ? void 0 : _a.groupable) != null ? _b : false;
    }
    isStackable(seriesType) {
        var _a, _b;
        return (_b = (_a = this.seriesMap.get(seriesType)) == null ? void 0 : _a.stackable) != null ? _b : false;
    }
    isStackedByDefault(seriesType) {
        var _a, _b;
        return (_b = (_a = this.seriesMap.get(seriesType)) == null ? void 0 : _a.stackedByDefault) != null ? _b : false;
    }
    isDefaultAxisSwapNeeded(options) {
        var _a, _b, _c;
        let result;
        for (const series of (_a = options.series) != null ? _a : []){
            const { type: type = "line" } = series;
            const isDefaultAxisSwapped = (_c = (_b = this.seriesMap.get(type)) == null ? void 0 : _b.swapDefaultAxesCondition) == null ? void 0 : _c.call(_b, series);
            if (isDefaultAxisSwapped != null) {
                if (result != null && result != isDefaultAxisSwapped) throw new Error("AG Charts - The provided series have incompatible directions");
                result = isDefaultAxisSwapped;
            }
        }
        return result;
    }
};
var $d77b025aa58d633c$var$seriesRegistry = new $d77b025aa58d633c$var$SeriesRegistry();
// packages/ag-charts-community/src/chart/factory/legendRegistry.ts
var $d77b025aa58d633c$var$LegendRegistry = class {
    constructor(){
        this.legendMap = /* @__PURE__ */ new Map();
        this.themeTemplates = /* @__PURE__ */ new Map();
    }
    register(legendType, { optionsKey: optionsKey, instanceConstructor: instanceConstructor, themeTemplate: themeTemplate }) {
        this.legendMap.set(legendType, {
            optionsKey: optionsKey,
            instanceConstructor: instanceConstructor
        });
        this.themeTemplates.set(optionsKey, themeTemplate);
    }
    create(legendType, moduleContext) {
        var _a;
        const LegendConstructor = (_a = this.legendMap.get(legendType)) == null ? void 0 : _a.instanceConstructor;
        if (LegendConstructor) return new LegendConstructor(moduleContext);
        throw new Error(`AG Charts - unknown legend type: ${legendType}`);
    }
    getThemeTemplates() {
        return Object.fromEntries(this.themeTemplates);
    }
    getKeys() {
        return Array.from(this.legendMap.entries()).reduce((result, [legendType, record])=>{
            result[legendType] = record.optionsKey;
            return result;
        }, {});
    }
};
var $d77b025aa58d633c$var$legendRegistry = new $d77b025aa58d633c$var$LegendRegistry();
// packages/ag-charts-community/src/chart/themes/constants.ts
var $d77b025aa58d633c$var$FONT_SIZE = /* @__PURE__ */ ((FONT_SIZE2)=>{
    FONT_SIZE2[FONT_SIZE2["SMALL"] = 12] = "SMALL";
    FONT_SIZE2[FONT_SIZE2["MEDIUM"] = 13] = "MEDIUM";
    FONT_SIZE2[FONT_SIZE2["LARGE"] = 17] = "LARGE";
    return FONT_SIZE2;
})($d77b025aa58d633c$var$FONT_SIZE || {});
var $d77b025aa58d633c$var$FONT_WEIGHT = /* @__PURE__ */ ((FONT_WEIGHT3)=>{
    FONT_WEIGHT3["NORMAL"] = "normal";
    FONT_WEIGHT3["BOLD"] = "bold";
    FONT_WEIGHT3["BOLDER"] = "bolder";
    FONT_WEIGHT3["LIGHTER"] = "lighter";
    return FONT_WEIGHT3;
})($d77b025aa58d633c$var$FONT_WEIGHT || {});
var $d77b025aa58d633c$var$POSITION = /* @__PURE__ */ ((POSITION3)=>{
    POSITION3["TOP"] = "top";
    POSITION3["RIGHT"] = "right";
    POSITION3["BOTTOM"] = "bottom";
    POSITION3["LEFT"] = "left";
    return POSITION3;
})($d77b025aa58d633c$var$POSITION || {});
var $d77b025aa58d633c$var$CARTESIAN_AXIS_TYPE = /* @__PURE__ */ ((CARTESIAN_AXIS_TYPE2)=>{
    CARTESIAN_AXIS_TYPE2["CATEGORY"] = "category";
    CARTESIAN_AXIS_TYPE2["ORDINAL_TIME"] = "ordinal-time";
    CARTESIAN_AXIS_TYPE2["NUMBER"] = "number";
    CARTESIAN_AXIS_TYPE2["TIME"] = "time";
    CARTESIAN_AXIS_TYPE2["LOG"] = "log";
    return CARTESIAN_AXIS_TYPE2;
})($d77b025aa58d633c$var$CARTESIAN_AXIS_TYPE || {});
var $d77b025aa58d633c$var$POLAR_AXIS_TYPE = /* @__PURE__ */ ((POLAR_AXIS_TYPE2)=>{
    POLAR_AXIS_TYPE2["ANGLE_CATEGORY"] = "angle-category";
    POLAR_AXIS_TYPE2["ANGLE_NUMBER"] = "angle-number";
    POLAR_AXIS_TYPE2["RADIUS_CATEGORY"] = "radius-category";
    POLAR_AXIS_TYPE2["RADIUS_NUMBER"] = "radius-number";
    return POLAR_AXIS_TYPE2;
})($d77b025aa58d633c$var$POLAR_AXIS_TYPE || {});
var $d77b025aa58d633c$var$POLAR_AXIS_SHAPE = /* @__PURE__ */ ((POLAR_AXIS_SHAPE2)=>{
    POLAR_AXIS_SHAPE2["CIRCLE"] = "circle";
    POLAR_AXIS_SHAPE2["POLYGON"] = "polygon";
    return POLAR_AXIS_SHAPE2;
})($d77b025aa58d633c$var$POLAR_AXIS_SHAPE || {});
// packages/ag-charts-community/src/chart/themes/defaultColors.ts
var $d77b025aa58d633c$var$DEFAULT_FILLS = {
    BLUE: "#5090dc",
    ORANGE: "#ffa03a",
    GREEN: "#459d55",
    CYAN: "#34bfe1",
    YELLOW: "#e1cc00",
    VIOLET: "#9669cb",
    GRAY: "#b5b5b5",
    MAGENTA: "#bd5aa7",
    BROWN: "#8a6224",
    RED: "#ef5452"
};
var $d77b025aa58d633c$var$DEFAULT_STROKES = {
    BLUE: "#2b5c95",
    ORANGE: "#cc6f10",
    GREEN: "#1e652e",
    CYAN: "#18859e",
    YELLOW: "#a69400",
    VIOLET: "#603c88",
    GRAY: "#575757",
    MAGENTA: "#7d2f6d",
    BROWN: "#4f3508",
    RED: "#a82529"
};
// packages/ag-charts-community/src/chart/themes/symbols.ts
var $d77b025aa58d633c$var$IS_DARK_THEME = Symbol("is-dark-theme");
var $d77b025aa58d633c$var$EXTENDS_AXES_DEFAULTS = Symbol("extends-axes-defaults");
var $d77b025aa58d633c$var$EXTENDS_AXES_LINE_DEFAULTS = Symbol("extends-axes-line-defaults");
var $d77b025aa58d633c$var$EXTENDS_AXES_TICK_DEFAULTS = Symbol("extends-axes-tick-defaults");
var $d77b025aa58d633c$var$EXTENDS_AXES_GRID_LINE_DEFAULTS = Symbol("extends-axes-grid-line-defaults");
var $d77b025aa58d633c$var$EXTENDS_SERIES_DEFAULTS = Symbol("extends-series-defaults");
var $d77b025aa58d633c$var$EXTENDS_CARTESIAN_MARKER_DEFAULTS = Symbol("extends-cartesian-marker-defaults");
var $d77b025aa58d633c$var$DEFAULT_FONT_FAMILY = Symbol("default-font");
var $d77b025aa58d633c$var$DEFAULT_LABEL_COLOUR = Symbol("default-label-colour");
var $d77b025aa58d633c$var$DEFAULT_INVERTED_LABEL_COLOUR = Symbol("default-inverted-label-colour");
var $d77b025aa58d633c$var$DEFAULT_INSIDE_SERIES_LABEL_COLOUR = Symbol("default-inside-series-label-colour");
var $d77b025aa58d633c$var$DEFAULT_MUTED_LABEL_COLOUR = Symbol("default-muted-label-colour");
var $d77b025aa58d633c$var$DEFAULT_AXIS_GRID_COLOUR = Symbol("default-axis-grid-colour");
var $d77b025aa58d633c$var$DEFAULT_AXIS_LINE_COLOUR = Symbol("default-axis-line-colour");
var $d77b025aa58d633c$var$DEFAULT_CROSS_LINES_COLOUR = Symbol("default-cross-lines-colour");
var $d77b025aa58d633c$var$DEFAULT_BACKGROUND_COLOUR = Symbol("default-background-colour");
var $d77b025aa58d633c$var$DEFAULT_SHADOW_COLOUR = Symbol("default-shadow-colour");
var $d77b025aa58d633c$var$DEFAULT_COLOURS = Symbol("default-colours");
var $d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_POSITIVE_COLOURS = Symbol("default-waterfall-series-positive-colors");
var $d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_NEGATIVE_COLOURS = Symbol("default-waterfall-series-negative-colors");
var $d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_TOTAL_COLOURS = Symbol("default-waterfall-series-total-colors");
var $d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_CONNECTOR_LINE_STROKE = Symbol("default-waterfall-series-connector-line-stroke");
var $d77b025aa58d633c$var$DEFAULT_POLAR_SERIES_STROKE = Symbol("default-polar-series-stroke");
var $d77b025aa58d633c$var$DEFAULT_DIVERGING_SERIES_COLOUR_RANGE = Symbol("default-diverging-series-colour-range");
var $d77b025aa58d633c$var$DEFAULT_HIERARCHY_FILLS = Symbol("default-hierarchy-fills");
var $d77b025aa58d633c$var$DEFAULT_HIERARCHY_STROKES = Symbol("default-hierarchy-strokes");
var $d77b025aa58d633c$var$DEFAULT_ANNOTATION_STROKE = Symbol("default-annotation-stroke");
var $d77b025aa58d633c$var$DEFAULT_ANNOTATION_BACKGROUND_FILL = Symbol("default-annotation-background-fill");
var $d77b025aa58d633c$var$DEFAULT_ANNOTATION_HANDLE_FILL = Symbol("default-annotation-handle-fill");
// packages/ag-charts-community/src/chart/themes/chartTheme.ts
var $d77b025aa58d633c$var$DEFAULT_BACKGROUND_FILL = "white";
var $d77b025aa58d633c$var$DEFAULT_PALETTE = {
    fills: Object.values($d77b025aa58d633c$var$DEFAULT_FILLS),
    strokes: Object.values($d77b025aa58d633c$var$DEFAULT_STROKES)
};
var $d77b025aa58d633c$var$CHART_TYPE_CONFIG = {
    get cartesian () {
        return {
            seriesTypes: $d77b025aa58d633c$var$chartTypes.cartesianTypes,
            commonOptions: [
                "zoom",
                "navigator"
            ]
        };
    },
    get polar () {
        return {
            seriesTypes: $d77b025aa58d633c$var$chartTypes.polarTypes,
            commonOptions: []
        };
    },
    get hierarchy () {
        return {
            seriesTypes: $d77b025aa58d633c$var$chartTypes.hierarchyTypes,
            commonOptions: []
        };
    },
    get topology () {
        return {
            seriesTypes: $d77b025aa58d633c$var$chartTypes.topologyTypes,
            commonOptions: []
        };
    }
};
var $d77b025aa58d633c$var$CHART_TYPE_SPECIFIC_COMMON_OPTIONS = Object.values($d77b025aa58d633c$var$CHART_TYPE_CONFIG).reduce((r, { commonOptions: commonOptions })=>r.concat(commonOptions), []);
var $d77b025aa58d633c$var$_ChartTheme = class _ChartTheme {
    getPalette() {
        return $d77b025aa58d633c$var$DEFAULT_PALETTE;
    }
    static getAxisDefaults(overrideDefaults) {
        return $d77b025aa58d633c$var$mergeDefaults(overrideDefaults, {
            title: {
                enabled: false,
                text: "Axis Title",
                spacing: 25,
                fontWeight: "normal" /* NORMAL */ ,
                fontSize: 13 /* MEDIUM */ ,
                fontFamily: $d77b025aa58d633c$var$DEFAULT_FONT_FAMILY,
                color: $d77b025aa58d633c$var$DEFAULT_LABEL_COLOUR
            },
            label: {
                fontSize: 12 /* SMALL */ ,
                fontFamily: $d77b025aa58d633c$var$DEFAULT_FONT_FAMILY,
                padding: 5,
                color: $d77b025aa58d633c$var$DEFAULT_LABEL_COLOUR,
                avoidCollisions: true
            },
            line: {
                enabled: true,
                width: 1,
                color: $d77b025aa58d633c$var$DEFAULT_AXIS_LINE_COLOUR
            },
            tick: {
                enabled: false,
                width: 1,
                color: $d77b025aa58d633c$var$DEFAULT_AXIS_LINE_COLOUR
            },
            gridLine: {
                enabled: true,
                style: [
                    {
                        stroke: $d77b025aa58d633c$var$DEFAULT_AXIS_GRID_COLOUR,
                        lineDash: []
                    }
                ]
            },
            crossLines: {
                enabled: false,
                fill: $d77b025aa58d633c$var$DEFAULT_CROSS_LINES_COLOUR,
                stroke: $d77b025aa58d633c$var$DEFAULT_CROSS_LINES_COLOUR,
                fillOpacity: 0.1,
                strokeWidth: 1,
                label: {
                    enabled: false,
                    fontSize: 12 /* SMALL */ ,
                    fontFamily: $d77b025aa58d633c$var$DEFAULT_FONT_FAMILY,
                    padding: 5,
                    color: $d77b025aa58d633c$var$DEFAULT_LABEL_COLOUR
                }
            }
        });
    }
    static getSeriesDefaults() {
        return {
            visible: true,
            showInLegend: true,
            highlightStyle: {
                item: {
                    fill: "#ffffff54",
                    stroke: `#0006`,
                    strokeWidth: 2
                },
                series: {
                    dimOpacity: 1
                }
            },
            nodeClickRange: "exact",
            tooltip: {
                enabled: true
            }
        };
    }
    static getCartesianSeriesMarkerDefaults() {
        return {
            enabled: true,
            shape: "circle",
            size: 7,
            strokeWidth: 1
        };
    }
    static getChartDefaults() {
        return {
            background: {
                visible: true,
                fill: $d77b025aa58d633c$var$DEFAULT_BACKGROUND_COLOUR
            },
            padding: {
                top: 20,
                right: 20,
                bottom: 20,
                left: 20
            },
            keyboard: {
                enabled: true
            },
            title: {
                enabled: false,
                text: "Title",
                fontWeight: "normal" /* NORMAL */ ,
                fontSize: 17 /* LARGE */ ,
                fontFamily: $d77b025aa58d633c$var$DEFAULT_FONT_FAMILY,
                color: $d77b025aa58d633c$var$DEFAULT_LABEL_COLOUR,
                wrapping: "hyphenate"
            },
            subtitle: {
                enabled: false,
                text: "Subtitle",
                spacing: 20,
                fontSize: 13 /* MEDIUM */ ,
                fontFamily: $d77b025aa58d633c$var$DEFAULT_FONT_FAMILY,
                color: $d77b025aa58d633c$var$DEFAULT_MUTED_LABEL_COLOUR,
                wrapping: "hyphenate"
            },
            footnote: {
                enabled: false,
                text: "Footnote",
                spacing: 20,
                fontSize: 13 /* MEDIUM */ ,
                fontFamily: $d77b025aa58d633c$var$DEFAULT_FONT_FAMILY,
                color: "rgb(140, 140, 140)",
                wrapping: "hyphenate"
            },
            legend: {
                position: "bottom" /* BOTTOM */ ,
                spacing: 30,
                listeners: {},
                item: {
                    paddingX: 16,
                    paddingY: 8,
                    marker: {
                        size: 15,
                        padding: 8
                    },
                    toggleSeriesVisible: true,
                    label: {
                        color: $d77b025aa58d633c$var$DEFAULT_LABEL_COLOUR,
                        fontSize: 12 /* SMALL */ ,
                        fontFamily: $d77b025aa58d633c$var$DEFAULT_FONT_FAMILY
                    }
                },
                reverseOrder: false,
                pagination: {
                    marker: {
                        size: 12
                    },
                    activeStyle: {
                        fill: $d77b025aa58d633c$var$DEFAULT_LABEL_COLOUR
                    },
                    inactiveStyle: {
                        fill: $d77b025aa58d633c$var$DEFAULT_MUTED_LABEL_COLOUR
                    },
                    highlightStyle: {
                        fill: $d77b025aa58d633c$var$DEFAULT_LABEL_COLOUR
                    },
                    label: {
                        color: $d77b025aa58d633c$var$DEFAULT_LABEL_COLOUR
                    }
                }
            },
            tooltip: {
                enabled: true,
                darkTheme: $d77b025aa58d633c$var$IS_DARK_THEME,
                range: "nearest",
                delay: 0
            },
            overlays: {
                loading: {
                    darkTheme: $d77b025aa58d633c$var$IS_DARK_THEME
                },
                noData: {
                    darkTheme: $d77b025aa58d633c$var$IS_DARK_THEME
                },
                noVisibleSeries: {
                    darkTheme: $d77b025aa58d633c$var$IS_DARK_THEME
                }
            },
            listeners: {}
        };
    }
    constructor(options = {}){
        const { overrides: overrides, palette: palette10 } = $d77b025aa58d633c$var$deepClone(options);
        const defaults = this.createChartConfigPerChartType(this.getDefaults());
        if (overrides) this.mergeOverrides(defaults, overrides);
        this.config = Object.freeze(this.templateTheme(defaults));
        this.palette = $d77b025aa58d633c$var$mergeDefaults(palette10, this.getPalette());
    }
    mergeOverrides(defaults, overrides) {
        for (const { seriesTypes: seriesTypes, commonOptions: commonOptions } of Object.values($d77b025aa58d633c$var$CHART_TYPE_CONFIG)){
            const cleanedCommon = $d77b025aa58d633c$var$__spreadValues({}, overrides.common);
            for (const commonKey of $d77b025aa58d633c$var$CHART_TYPE_SPECIFIC_COMMON_OPTIONS)if (!commonOptions.includes(commonKey)) delete cleanedCommon[commonKey];
            if (!cleanedCommon) continue;
            for (const s of seriesTypes){
                const seriesType = s;
                defaults[seriesType] = $d77b025aa58d633c$var$mergeDefaults(cleanedCommon, defaults[seriesType]);
            }
        }
        $d77b025aa58d633c$var$chartTypes.seriesTypes.forEach((s)=>{
            const seriesType = s;
            if (overrides[seriesType]) defaults[seriesType] = $d77b025aa58d633c$var$mergeDefaults(overrides[seriesType], defaults[seriesType]);
        });
    }
    createChartConfigPerChartType(config) {
        for (const [nextType, { seriesTypes: seriesTypes }] of Object.entries($d77b025aa58d633c$var$CHART_TYPE_CONFIG)){
            const typeDefaults = $d77b025aa58d633c$var$chartDefaults.get(nextType);
            for (const seriesType of seriesTypes)config[seriesType] || (config[seriesType] = $d77b025aa58d633c$var$deepClone(typeDefaults));
        }
        return config;
    }
    getDefaults() {
        const getOverridesByType = (chartType2, seriesTypes)=>{
            var _a;
            const result = {};
            const chartTypeDefaults = $d77b025aa58d633c$var$__spreadValues($d77b025aa58d633c$var$__spreadValues($d77b025aa58d633c$var$__spreadValues({
                axes: {}
            }, $d77b025aa58d633c$var$legendRegistry.getThemeTemplates()), _ChartTheme.getChartDefaults()), $d77b025aa58d633c$var$chartDefaults.get(chartType2));
            for (const seriesType of seriesTypes){
                result[seriesType] = $d77b025aa58d633c$var$mergeDefaults($d77b025aa58d633c$var$seriesRegistry.getThemeTemplate(seriesType), (_a = result[seriesType]) != null ? _a : $d77b025aa58d633c$var$deepClone(chartTypeDefaults));
                const { axes: axes } = result[seriesType];
                for (const axisType of $d77b025aa58d633c$var$axisRegistry.keys())axes[axisType] = $d77b025aa58d633c$var$mergeDefaults(axes[axisType], $d77b025aa58d633c$var$axisRegistry.getThemeTemplate(axisType), chartType2 === "cartesian" && _ChartTheme.cartesianAxisDefault[axisType]);
            }
            return result;
        };
        return $d77b025aa58d633c$var$mergeDefaults(getOverridesByType("cartesian", $d77b025aa58d633c$var$chartTypes.cartesianTypes), getOverridesByType("polar", $d77b025aa58d633c$var$chartTypes.polarTypes), getOverridesByType("hierarchy", $d77b025aa58d633c$var$chartTypes.hierarchyTypes), getOverridesByType("topology", $d77b025aa58d633c$var$chartTypes.topologyTypes));
    }
    templateTheme(themeTemplate) {
        const themeInstance = $d77b025aa58d633c$var$deepClone(themeTemplate);
        const { extensions: extensions, properties: properties } = this.getTemplateParameters();
        $d77b025aa58d633c$var$jsonWalk(themeInstance, (node)=>{
            if (node["__extends__"]) {
                const extendsValue = node["__extends__"];
                const source = extensions.get(extendsValue);
                if (source == null) throw new Error(`AG Charts - no template variable provided for: ${extendsValue}`);
                Object.keys(source).forEach((key)=>{
                    if (!(key in node)) node[key] = source[key];
                    else if ($d77b025aa58d633c$var$isObject(node[key])) node[key] = $d77b025aa58d633c$var$mergeDefaults(node[key], source[key]);
                });
                delete node["__extends__"];
            }
            if ($d77b025aa58d633c$var$isArray(node)) for(let i = 0; i < node.length; i++){
                const symbol = node[i];
                if (properties.has(symbol)) node[i] = properties.get(symbol);
            }
            else {
                for (const [name, value] of Object.entries(node))if (properties.has(value)) node[name] = properties.get(value);
            }
        });
        return $d77b025aa58d633c$var$deepClone(themeInstance);
    }
    static getDefaultColors() {
        return {
            fills: $d77b025aa58d633c$var$DEFAULT_FILLS,
            strokes: $d77b025aa58d633c$var$DEFAULT_STROKES
        };
    }
    static getWaterfallSeriesDefaultPositiveColors() {
        return {
            fill: $d77b025aa58d633c$var$DEFAULT_FILLS.BLUE,
            stroke: $d77b025aa58d633c$var$DEFAULT_STROKES.BLUE,
            label: {
                color: $d77b025aa58d633c$var$DEFAULT_LABEL_COLOUR
            }
        };
    }
    static getWaterfallSeriesDefaultNegativeColors() {
        return {
            fill: $d77b025aa58d633c$var$DEFAULT_FILLS.ORANGE,
            stroke: $d77b025aa58d633c$var$DEFAULT_STROKES.ORANGE,
            label: {
                color: $d77b025aa58d633c$var$DEFAULT_LABEL_COLOUR
            }
        };
    }
    static getWaterfallSeriesDefaultTotalColors() {
        return {
            fill: $d77b025aa58d633c$var$DEFAULT_FILLS.GRAY,
            stroke: $d77b025aa58d633c$var$DEFAULT_STROKES.GRAY,
            label: {
                color: $d77b025aa58d633c$var$DEFAULT_LABEL_COLOUR
            }
        };
    }
    getTemplateParameters() {
        const extensions = /* @__PURE__ */ new Map();
        extensions.set($d77b025aa58d633c$var$EXTENDS_AXES_DEFAULTS, _ChartTheme.getAxisDefaults());
        extensions.set($d77b025aa58d633c$var$EXTENDS_AXES_LINE_DEFAULTS, _ChartTheme.getAxisDefaults().line);
        extensions.set($d77b025aa58d633c$var$EXTENDS_AXES_TICK_DEFAULTS, _ChartTheme.getAxisDefaults().tick);
        extensions.set($d77b025aa58d633c$var$EXTENDS_AXES_GRID_LINE_DEFAULTS, _ChartTheme.getAxisDefaults().gridLine);
        extensions.set($d77b025aa58d633c$var$EXTENDS_SERIES_DEFAULTS, _ChartTheme.getSeriesDefaults());
        extensions.set($d77b025aa58d633c$var$EXTENDS_CARTESIAN_MARKER_DEFAULTS, _ChartTheme.getCartesianSeriesMarkerDefaults());
        const properties = /* @__PURE__ */ new Map();
        properties.set($d77b025aa58d633c$var$IS_DARK_THEME, false);
        properties.set($d77b025aa58d633c$var$DEFAULT_FONT_FAMILY, "Verdana, sans-serif");
        properties.set($d77b025aa58d633c$var$DEFAULT_LABEL_COLOUR, "rgb(70, 70, 70)");
        properties.set($d77b025aa58d633c$var$DEFAULT_INVERTED_LABEL_COLOUR, "white");
        properties.set($d77b025aa58d633c$var$DEFAULT_MUTED_LABEL_COLOUR, "rgb(140, 140, 140)");
        properties.set($d77b025aa58d633c$var$DEFAULT_AXIS_GRID_COLOUR, "rgb(224,234,241)");
        properties.set($d77b025aa58d633c$var$DEFAULT_AXIS_LINE_COLOUR, "rgb(195, 195, 195)");
        properties.set($d77b025aa58d633c$var$DEFAULT_CROSS_LINES_COLOUR, "rgb(70, 70, 70)");
        properties.set($d77b025aa58d633c$var$DEFAULT_INSIDE_SERIES_LABEL_COLOUR, $d77b025aa58d633c$var$DEFAULT_BACKGROUND_FILL);
        properties.set($d77b025aa58d633c$var$DEFAULT_BACKGROUND_COLOUR, $d77b025aa58d633c$var$DEFAULT_BACKGROUND_FILL);
        properties.set($d77b025aa58d633c$var$DEFAULT_SHADOW_COLOUR, "rgba(0, 0, 0, 0.5)");
        properties.set($d77b025aa58d633c$var$DEFAULT_DIVERGING_SERIES_COLOUR_RANGE, [
            $d77b025aa58d633c$var$DEFAULT_FILLS.ORANGE,
            $d77b025aa58d633c$var$DEFAULT_FILLS.YELLOW,
            $d77b025aa58d633c$var$DEFAULT_FILLS.GREEN
        ]);
        properties.set($d77b025aa58d633c$var$DEFAULT_HIERARCHY_FILLS, [
            "#ffffff",
            "#e0e5ea",
            "#c1ccd5",
            "#a3b4c1",
            "#859cad"
        ]);
        properties.set($d77b025aa58d633c$var$DEFAULT_HIERARCHY_STROKES, [
            "#ffffff",
            "#c5cbd1",
            "#a4b1bd",
            "#8498a9",
            "#648096"
        ]);
        properties.set($d77b025aa58d633c$var$DEFAULT_POLAR_SERIES_STROKE, $d77b025aa58d633c$var$DEFAULT_BACKGROUND_FILL);
        properties.set($d77b025aa58d633c$var$DEFAULT_COLOURS, _ChartTheme.getDefaultColors());
        properties.set($d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_POSITIVE_COLOURS, _ChartTheme.getWaterfallSeriesDefaultPositiveColors());
        properties.set($d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_NEGATIVE_COLOURS, _ChartTheme.getWaterfallSeriesDefaultNegativeColors());
        properties.set($d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_TOTAL_COLOURS, _ChartTheme.getWaterfallSeriesDefaultTotalColors());
        properties.set($d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_CONNECTOR_LINE_STROKE, _ChartTheme.getWaterfallSeriesDefaultTotalColors().stroke);
        properties.set($d77b025aa58d633c$var$DEFAULT_ANNOTATION_STROKE, $d77b025aa58d633c$var$DEFAULT_STROKES.BLUE);
        properties.set($d77b025aa58d633c$var$DEFAULT_ANNOTATION_BACKGROUND_FILL, $d77b025aa58d633c$var$DEFAULT_FILLS.BLUE);
        properties.set($d77b025aa58d633c$var$DEFAULT_ANNOTATION_HANDLE_FILL, $d77b025aa58d633c$var$DEFAULT_BACKGROUND_FILL);
        return {
            extensions: extensions,
            properties: properties
        };
    }
};
$d77b025aa58d633c$var$_ChartTheme.cartesianAxisDefault = {
    ["number" /* NUMBER */ ]: $d77b025aa58d633c$var$_ChartTheme.getAxisDefaults({
        line: {
            enabled: false
        }
    }),
    ["log" /* LOG */ ]: $d77b025aa58d633c$var$_ChartTheme.getAxisDefaults({
        base: 10,
        line: {
            enabled: false
        }
    }),
    ["category" /* CATEGORY */ ]: $d77b025aa58d633c$var$_ChartTheme.getAxisDefaults({
        groupPaddingInner: 0.1,
        label: {
            autoRotate: true
        },
        gridLine: {
            enabled: false
        }
    }),
    ["time" /* TIME */ ]: $d77b025aa58d633c$var$_ChartTheme.getAxisDefaults({
        gridLine: {
            enabled: false
        }
    }),
    "grouped-category": $d77b025aa58d633c$var$_ChartTheme.getAxisDefaults()
};
var $d77b025aa58d633c$var$ChartTheme = $d77b025aa58d633c$var$_ChartTheme;
// packages/ag-charts-community/src/chart/themes/darkTheme.ts
var $d77b025aa58d633c$var$DEFAULT_DARK_BACKGROUND_FILL = "#192232";
var $d77b025aa58d633c$var$DEFAULT_DARK_FILLS = {
    BLUE: "#5090dc",
    ORANGE: "#ffa03a",
    GREEN: "#459d55",
    CYAN: "#34bfe1",
    YELLOW: "#e1cc00",
    VIOLET: "#9669cb",
    GRAY: "#b5b5b5",
    MAGENTA: "#bd5aa7",
    BROWN: "#8a6224",
    RED: "#ef5452"
};
var $d77b025aa58d633c$var$DEFAULT_DARK_STROKES = {
    BLUE: "#74a8e6",
    ORANGE: "#ffbe70",
    GREEN: "#6cb176",
    CYAN: "#75d4ef",
    YELLOW: "#f6e559",
    VIOLET: "#aa86d8",
    GRAY: "#a1a1a1",
    MAGENTA: "#ce7ab9",
    BROWN: "#997b52",
    RED: "#ff7872"
};
var $d77b025aa58d633c$var$palette = {
    fills: Object.values($d77b025aa58d633c$var$DEFAULT_DARK_FILLS),
    strokes: Object.values($d77b025aa58d633c$var$DEFAULT_DARK_STROKES)
};
var $d77b025aa58d633c$var$DarkTheme = class _DarkTheme extends $d77b025aa58d633c$var$ChartTheme {
    static getDefaultColors() {
        return {
            fills: $d77b025aa58d633c$var$DEFAULT_DARK_FILLS,
            strokes: $d77b025aa58d633c$var$DEFAULT_DARK_STROKES
        };
    }
    static getWaterfallSeriesDefaultPositiveColors() {
        return {
            fill: $d77b025aa58d633c$var$DEFAULT_DARK_FILLS.BLUE,
            stroke: $d77b025aa58d633c$var$DEFAULT_DARK_STROKES.BLUE,
            label: {
                color: "white"
            }
        };
    }
    static getWaterfallSeriesDefaultNegativeColors() {
        return {
            fill: $d77b025aa58d633c$var$DEFAULT_DARK_FILLS.ORANGE,
            stroke: $d77b025aa58d633c$var$DEFAULT_DARK_STROKES.ORANGE,
            label: {
                color: "white"
            }
        };
    }
    static getWaterfallSeriesDefaultTotalColors() {
        return {
            fill: $d77b025aa58d633c$var$DEFAULT_DARK_FILLS.GRAY,
            stroke: $d77b025aa58d633c$var$DEFAULT_DARK_STROKES.GRAY,
            label: {
                color: "white"
            }
        };
    }
    getTemplateParameters() {
        const result = super.getTemplateParameters();
        result.properties.set($d77b025aa58d633c$var$IS_DARK_THEME, true);
        result.properties.set($d77b025aa58d633c$var$DEFAULT_COLOURS, _DarkTheme.getDefaultColors());
        result.properties.set($d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_POSITIVE_COLOURS, _DarkTheme.getWaterfallSeriesDefaultPositiveColors());
        result.properties.set($d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_NEGATIVE_COLOURS, _DarkTheme.getWaterfallSeriesDefaultNegativeColors());
        result.properties.set($d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_TOTAL_COLOURS, _DarkTheme.getWaterfallSeriesDefaultTotalColors());
        result.properties.set($d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_CONNECTOR_LINE_STROKE, _DarkTheme.getWaterfallSeriesDefaultTotalColors().stroke);
        result.properties.set($d77b025aa58d633c$var$DEFAULT_POLAR_SERIES_STROKE, $d77b025aa58d633c$var$DEFAULT_DARK_BACKGROUND_FILL);
        result.properties.set($d77b025aa58d633c$var$DEFAULT_LABEL_COLOUR, "white");
        result.properties.set($d77b025aa58d633c$var$DEFAULT_MUTED_LABEL_COLOUR, "#7D91A0");
        result.properties.set($d77b025aa58d633c$var$DEFAULT_AXIS_GRID_COLOUR, "#545A6E");
        result.properties.set($d77b025aa58d633c$var$DEFAULT_CROSS_LINES_COLOUR, "white");
        result.properties.set($d77b025aa58d633c$var$DEFAULT_DIVERGING_SERIES_COLOUR_RANGE, [
            $d77b025aa58d633c$var$DEFAULT_DARK_FILLS.ORANGE,
            $d77b025aa58d633c$var$DEFAULT_DARK_FILLS.YELLOW,
            $d77b025aa58d633c$var$DEFAULT_DARK_FILLS.GREEN
        ]);
        result.properties.set($d77b025aa58d633c$var$DEFAULT_HIERARCHY_FILLS, [
            "#192834",
            "#253746",
            "#324859",
            "#3f596c",
            "#4d6a80"
        ]);
        result.properties.set($d77b025aa58d633c$var$DEFAULT_HIERARCHY_STROKES, [
            "#192834",
            "#3b5164",
            "#496275",
            "#577287",
            "#668399"
        ]);
        result.properties.set($d77b025aa58d633c$var$DEFAULT_BACKGROUND_COLOUR, $d77b025aa58d633c$var$DEFAULT_DARK_BACKGROUND_FILL);
        result.properties.set($d77b025aa58d633c$var$DEFAULT_INSIDE_SERIES_LABEL_COLOUR, $d77b025aa58d633c$var$DEFAULT_DARK_BACKGROUND_FILL);
        result.properties.set($d77b025aa58d633c$var$DEFAULT_ANNOTATION_STROKE, $d77b025aa58d633c$var$DEFAULT_DARK_STROKES.BLUE);
        result.properties.set($d77b025aa58d633c$var$DEFAULT_ANNOTATION_BACKGROUND_FILL, $d77b025aa58d633c$var$DEFAULT_DARK_FILLS.BLUE);
        result.properties.set($d77b025aa58d633c$var$DEFAULT_ANNOTATION_HANDLE_FILL, $d77b025aa58d633c$var$DEFAULT_DARK_BACKGROUND_FILL);
        return result;
    }
    getPalette() {
        return $d77b025aa58d633c$var$palette;
    }
    constructor(options){
        super(options);
    }
};
// packages/ag-charts-community/src/chart/themes/materialDark.ts
var $d77b025aa58d633c$var$MATERIAL_DARK_FILLS = {
    BLUE: "#2196F3",
    ORANGE: "#FF9800",
    GREEN: "#4CAF50",
    CYAN: "#00BCD4",
    YELLOW: "#FFEB3B",
    VIOLET: "#7E57C2",
    GRAY: "#9E9E9E",
    MAGENTA: "#F06292",
    BROWN: "#795548",
    RED: "#F44336"
};
var $d77b025aa58d633c$var$MATERIAL_DARK_STROKES = {
    BLUE: "#90CAF9",
    ORANGE: "#FFCC80",
    GREEN: "#A5D6A7",
    CYAN: "#80DEEA",
    YELLOW: "#FFF9C4",
    VIOLET: "#B39DDB",
    GRAY: "#E0E0E0",
    MAGENTA: "#F48FB1",
    BROWN: "#A1887F",
    RED: "#EF9A9A"
};
var $d77b025aa58d633c$var$palette2 = {
    fills: Object.values($d77b025aa58d633c$var$MATERIAL_DARK_FILLS),
    strokes: Object.values($d77b025aa58d633c$var$MATERIAL_DARK_STROKES)
};
var $d77b025aa58d633c$var$MaterialDark = class _MaterialDark extends $d77b025aa58d633c$var$DarkTheme {
    static getDefaultColors() {
        return {
            fills: $d77b025aa58d633c$var$MATERIAL_DARK_FILLS,
            strokes: $d77b025aa58d633c$var$MATERIAL_DARK_STROKES
        };
    }
    static getWaterfallSeriesDefaultPositiveColors() {
        return {
            fill: $d77b025aa58d633c$var$MATERIAL_DARK_FILLS.BLUE,
            stroke: $d77b025aa58d633c$var$MATERIAL_DARK_STROKES.BLUE,
            label: {
                color: "white"
            }
        };
    }
    static getWaterfallSeriesDefaultNegativeColors() {
        return {
            fill: $d77b025aa58d633c$var$MATERIAL_DARK_FILLS.RED,
            stroke: $d77b025aa58d633c$var$MATERIAL_DARK_STROKES.RED,
            label: {
                color: "white"
            }
        };
    }
    static getWaterfallSeriesDefaultTotalColors() {
        return {
            fill: $d77b025aa58d633c$var$MATERIAL_DARK_FILLS.GRAY,
            stroke: $d77b025aa58d633c$var$MATERIAL_DARK_STROKES.GRAY,
            label: {
                color: "white"
            }
        };
    }
    getTemplateParameters() {
        const result = super.getTemplateParameters();
        result.properties.set($d77b025aa58d633c$var$DEFAULT_COLOURS, _MaterialDark.getDefaultColors());
        result.properties.set($d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_POSITIVE_COLOURS, _MaterialDark.getWaterfallSeriesDefaultPositiveColors());
        result.properties.set($d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_NEGATIVE_COLOURS, _MaterialDark.getWaterfallSeriesDefaultNegativeColors());
        result.properties.set($d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_TOTAL_COLOURS, _MaterialDark.getWaterfallSeriesDefaultTotalColors());
        result.properties.set($d77b025aa58d633c$var$DEFAULT_DIVERGING_SERIES_COLOUR_RANGE, [
            $d77b025aa58d633c$var$MATERIAL_DARK_FILLS.ORANGE,
            $d77b025aa58d633c$var$MATERIAL_DARK_FILLS.YELLOW,
            $d77b025aa58d633c$var$MATERIAL_DARK_FILLS.GREEN
        ]);
        result.properties.set($d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_CONNECTOR_LINE_STROKE, _MaterialDark.getWaterfallSeriesDefaultTotalColors().stroke);
        result.properties.set($d77b025aa58d633c$var$DEFAULT_ANNOTATION_STROKE, $d77b025aa58d633c$var$MATERIAL_DARK_STROKES.BLUE);
        result.properties.set($d77b025aa58d633c$var$DEFAULT_ANNOTATION_BACKGROUND_FILL, $d77b025aa58d633c$var$MATERIAL_DARK_FILLS.BLUE);
        return result;
    }
    getPalette() {
        return $d77b025aa58d633c$var$palette2;
    }
};
// packages/ag-charts-community/src/chart/themes/materialLight.ts
var $d77b025aa58d633c$var$MATERIAL_LIGHT_FILLS = {
    BLUE: "#2196F3",
    ORANGE: "#FF9800",
    GREEN: "#4CAF50",
    CYAN: "#00BCD4",
    YELLOW: "#FFEB3B",
    VIOLET: "#7E57C2",
    GRAY: "#9E9E9E",
    MAGENTA: "#F06292",
    BROWN: "#795548",
    RED: "#F44336"
};
var $d77b025aa58d633c$var$MATERIAL_LIGHT_STROKES = {
    BLUE: "#1565C0",
    ORANGE: "#E65100",
    GREEN: "#2E7D32",
    CYAN: "#00838F",
    YELLOW: "#F9A825",
    VIOLET: "#4527A0",
    GRAY: "#616161",
    MAGENTA: "#C2185B",
    BROWN: "#4E342E",
    RED: "#B71C1C"
};
var $d77b025aa58d633c$var$palette3 = {
    fills: Object.values($d77b025aa58d633c$var$MATERIAL_LIGHT_FILLS),
    strokes: Object.values($d77b025aa58d633c$var$MATERIAL_LIGHT_STROKES)
};
var $d77b025aa58d633c$var$MaterialLight = class _MaterialLight extends $d77b025aa58d633c$var$ChartTheme {
    static getDefaultColors() {
        return {
            fills: $d77b025aa58d633c$var$MATERIAL_LIGHT_FILLS,
            strokes: $d77b025aa58d633c$var$MATERIAL_LIGHT_STROKES
        };
    }
    static getWaterfallSeriesDefaultPositiveColors() {
        return {
            fill: $d77b025aa58d633c$var$MATERIAL_LIGHT_FILLS.BLUE,
            stroke: $d77b025aa58d633c$var$MATERIAL_LIGHT_STROKES.BLUE,
            label: {
                color: $d77b025aa58d633c$var$DEFAULT_LABEL_COLOUR
            }
        };
    }
    static getWaterfallSeriesDefaultNegativeColors() {
        return {
            fill: $d77b025aa58d633c$var$MATERIAL_LIGHT_FILLS.RED,
            stroke: $d77b025aa58d633c$var$MATERIAL_LIGHT_STROKES.RED,
            label: {
                color: $d77b025aa58d633c$var$DEFAULT_LABEL_COLOUR
            }
        };
    }
    static getWaterfallSeriesDefaultTotalColors() {
        return {
            fill: $d77b025aa58d633c$var$MATERIAL_LIGHT_FILLS.GRAY,
            stroke: $d77b025aa58d633c$var$MATERIAL_LIGHT_STROKES.GRAY,
            label: {
                color: $d77b025aa58d633c$var$DEFAULT_LABEL_COLOUR
            }
        };
    }
    getTemplateParameters() {
        const result = super.getTemplateParameters();
        result.properties.set($d77b025aa58d633c$var$DEFAULT_COLOURS, _MaterialLight.getDefaultColors());
        result.properties.set($d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_POSITIVE_COLOURS, _MaterialLight.getWaterfallSeriesDefaultPositiveColors());
        result.properties.set($d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_NEGATIVE_COLOURS, _MaterialLight.getWaterfallSeriesDefaultNegativeColors());
        result.properties.set($d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_TOTAL_COLOURS, _MaterialLight.getWaterfallSeriesDefaultTotalColors());
        result.properties.set($d77b025aa58d633c$var$DEFAULT_DIVERGING_SERIES_COLOUR_RANGE, [
            $d77b025aa58d633c$var$MATERIAL_LIGHT_FILLS.ORANGE,
            $d77b025aa58d633c$var$MATERIAL_LIGHT_FILLS.YELLOW,
            $d77b025aa58d633c$var$MATERIAL_LIGHT_FILLS.GREEN
        ]);
        result.properties.set($d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_CONNECTOR_LINE_STROKE, _MaterialLight.getWaterfallSeriesDefaultTotalColors().stroke);
        result.properties.set($d77b025aa58d633c$var$DEFAULT_ANNOTATION_STROKE, $d77b025aa58d633c$var$MATERIAL_LIGHT_STROKES.BLUE);
        result.properties.set($d77b025aa58d633c$var$DEFAULT_ANNOTATION_BACKGROUND_FILL, $d77b025aa58d633c$var$MATERIAL_LIGHT_FILLS.BLUE);
        return result;
    }
    getPalette() {
        return $d77b025aa58d633c$var$palette3;
    }
};
// packages/ag-charts-community/src/chart/themes/polychromaDark.ts
var $d77b025aa58d633c$var$POLYCHROMA_DARK_FILLS = {
    BLUE: "#436ff4",
    PURPLE: "#9a7bff",
    MAGENTA: "#d165d2",
    PINK: "#f0598b",
    RED: "#f47348",
    ORANGE: "#f2a602",
    YELLOW: "#e9e201",
    GREEN: "#21b448",
    CYAN: "#00b9a2",
    MODERATE_BLUE: "#00aee4"
};
var $d77b025aa58d633c$var$POLYCHROMA_DARK_STROKES = {
    BLUE: "#6698ff",
    PURPLE: "#c0a3ff",
    MAGENTA: "#fc8dfc",
    PINK: "#ff82b1",
    RED: "#ff9b70",
    ORANGE: "#ffcf4e",
    YELLOW: "#ffff58",
    GREEN: "#58dd70",
    CYAN: "#51e2c9",
    MODERATE_BLUE: "#4fd7ff"
};
var $d77b025aa58d633c$var$POLYCHROMA_DARK_FILL_GRAY = "#bbbbbb";
var $d77b025aa58d633c$var$POLYCHROMA_DARK_STROKE_GRAY = "#eeeeee";
var $d77b025aa58d633c$var$palette4 = {
    fills: Object.values($d77b025aa58d633c$var$POLYCHROMA_DARK_FILLS),
    strokes: Object.values($d77b025aa58d633c$var$POLYCHROMA_DARK_STROKES)
};
var $d77b025aa58d633c$var$PolychromaDark = class _PolychromaDark extends $d77b025aa58d633c$var$DarkTheme {
    static getDefaultColors() {
        return {
            fills: $d77b025aa58d633c$var$POLYCHROMA_DARK_FILLS,
            strokes: $d77b025aa58d633c$var$POLYCHROMA_DARK_STROKES
        };
    }
    static getWaterfallSeriesDefaultPositiveColors() {
        return {
            fill: $d77b025aa58d633c$var$POLYCHROMA_DARK_FILLS.BLUE,
            stroke: $d77b025aa58d633c$var$POLYCHROMA_DARK_STROKES.BLUE,
            label: {
                color: "white"
            }
        };
    }
    static getWaterfallSeriesDefaultNegativeColors() {
        return {
            fill: $d77b025aa58d633c$var$POLYCHROMA_DARK_FILLS.RED,
            stroke: $d77b025aa58d633c$var$POLYCHROMA_DARK_STROKES.RED,
            label: {
                color: "white"
            }
        };
    }
    static getWaterfallSeriesDefaultTotalColors() {
        return {
            fill: $d77b025aa58d633c$var$POLYCHROMA_DARK_FILL_GRAY,
            stroke: $d77b025aa58d633c$var$POLYCHROMA_DARK_STROKE_GRAY,
            label: {
                color: "white"
            }
        };
    }
    getTemplateParameters() {
        const result = super.getTemplateParameters();
        result.properties.set($d77b025aa58d633c$var$DEFAULT_COLOURS, _PolychromaDark.getDefaultColors());
        result.properties.set($d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_POSITIVE_COLOURS, _PolychromaDark.getWaterfallSeriesDefaultPositiveColors());
        result.properties.set($d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_NEGATIVE_COLOURS, _PolychromaDark.getWaterfallSeriesDefaultNegativeColors());
        result.properties.set($d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_TOTAL_COLOURS, _PolychromaDark.getWaterfallSeriesDefaultTotalColors());
        result.properties.set($d77b025aa58d633c$var$DEFAULT_DIVERGING_SERIES_COLOUR_RANGE, [
            $d77b025aa58d633c$var$POLYCHROMA_DARK_FILLS.BLUE,
            $d77b025aa58d633c$var$POLYCHROMA_DARK_FILLS.RED
        ]);
        result.properties.set($d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_CONNECTOR_LINE_STROKE, _PolychromaDark.getWaterfallSeriesDefaultTotalColors().stroke);
        result.properties.set($d77b025aa58d633c$var$DEFAULT_ANNOTATION_STROKE, $d77b025aa58d633c$var$POLYCHROMA_DARK_STROKES.BLUE);
        result.properties.set($d77b025aa58d633c$var$DEFAULT_ANNOTATION_BACKGROUND_FILL, $d77b025aa58d633c$var$POLYCHROMA_DARK_FILLS.BLUE);
        return result;
    }
    getPalette() {
        return $d77b025aa58d633c$var$palette4;
    }
};
// packages/ag-charts-community/src/chart/themes/polychromaLight.ts
var $d77b025aa58d633c$var$POLYCHROMA_LIGHT_FILLS = {
    BLUE: "#436ff4",
    PURPLE: "#9a7bff",
    MAGENTA: "#d165d2",
    PINK: "#f0598b",
    RED: "#f47348",
    ORANGE: "#f2a602",
    YELLOW: "#e9e201",
    GREEN: "#21b448",
    CYAN: "#00b9a2",
    MODERATE_BLUE: "#00aee4"
};
var $d77b025aa58d633c$var$POLYCHROMA_LIGHT_STROKES = {
    BLUE: "#2346c9",
    PURPLE: "#7653d4",
    MAGENTA: "#a73da9",
    PINK: "#c32d66",
    RED: "#c84b1c",
    ORANGE: "#c87f00",
    YELLOW: "#c1b900",
    GREEN: "#008c1c",
    CYAN: "#00927c",
    MODERATE_BLUE: "#0087bb"
};
var $d77b025aa58d633c$var$POLYCHROMA_LIGHT_FILL_GRAY = "#bbbbbb";
var $d77b025aa58d633c$var$POLYCHROMA_LIGHT_STROKE_GRAY = "#888888";
var $d77b025aa58d633c$var$palette5 = {
    fills: Object.values($d77b025aa58d633c$var$POLYCHROMA_LIGHT_FILLS),
    strokes: Object.values($d77b025aa58d633c$var$POLYCHROMA_LIGHT_STROKES)
};
var $d77b025aa58d633c$var$PolychromaLight = class _PolychromaLight extends $d77b025aa58d633c$var$ChartTheme {
    static getDefaultColors() {
        return {
            fills: $d77b025aa58d633c$var$POLYCHROMA_LIGHT_FILLS,
            strokes: $d77b025aa58d633c$var$POLYCHROMA_LIGHT_STROKES
        };
    }
    static getWaterfallSeriesDefaultPositiveColors() {
        return {
            fill: $d77b025aa58d633c$var$POLYCHROMA_LIGHT_FILLS.BLUE,
            stroke: $d77b025aa58d633c$var$POLYCHROMA_LIGHT_STROKES.BLUE,
            label: {
                color: $d77b025aa58d633c$var$DEFAULT_LABEL_COLOUR
            }
        };
    }
    static getWaterfallSeriesDefaultNegativeColors() {
        return {
            fill: $d77b025aa58d633c$var$POLYCHROMA_LIGHT_FILLS.RED,
            stroke: $d77b025aa58d633c$var$POLYCHROMA_LIGHT_STROKES.RED,
            label: {
                color: $d77b025aa58d633c$var$DEFAULT_LABEL_COLOUR
            }
        };
    }
    static getWaterfallSeriesDefaultTotalColors() {
        return {
            fill: $d77b025aa58d633c$var$POLYCHROMA_LIGHT_FILL_GRAY,
            stroke: $d77b025aa58d633c$var$POLYCHROMA_LIGHT_STROKE_GRAY,
            label: {
                color: $d77b025aa58d633c$var$DEFAULT_LABEL_COLOUR
            }
        };
    }
    getTemplateParameters() {
        const result = super.getTemplateParameters();
        result.properties.set($d77b025aa58d633c$var$DEFAULT_COLOURS, _PolychromaLight.getDefaultColors());
        result.properties.set($d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_POSITIVE_COLOURS, _PolychromaLight.getWaterfallSeriesDefaultPositiveColors());
        result.properties.set($d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_NEGATIVE_COLOURS, _PolychromaLight.getWaterfallSeriesDefaultNegativeColors());
        result.properties.set($d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_TOTAL_COLOURS, _PolychromaLight.getWaterfallSeriesDefaultTotalColors());
        result.properties.set($d77b025aa58d633c$var$DEFAULT_DIVERGING_SERIES_COLOUR_RANGE, [
            $d77b025aa58d633c$var$POLYCHROMA_LIGHT_FILLS.BLUE,
            $d77b025aa58d633c$var$POLYCHROMA_LIGHT_FILLS.RED
        ]);
        result.properties.set($d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_CONNECTOR_LINE_STROKE, _PolychromaLight.getWaterfallSeriesDefaultTotalColors().stroke);
        result.properties.set($d77b025aa58d633c$var$DEFAULT_ANNOTATION_STROKE, $d77b025aa58d633c$var$POLYCHROMA_LIGHT_STROKES.BLUE);
        result.properties.set($d77b025aa58d633c$var$DEFAULT_ANNOTATION_BACKGROUND_FILL, $d77b025aa58d633c$var$POLYCHROMA_LIGHT_FILLS.BLUE);
        return result;
    }
    getPalette() {
        return $d77b025aa58d633c$var$palette5;
    }
};
// packages/ag-charts-community/src/chart/themes/sheetsDark.ts
var $d77b025aa58d633c$var$SHEETS_DARK_FILLS = {
    BLUE: "#4472C4",
    ORANGE: "#ED7D31",
    GRAY: "#A5A5A5",
    YELLOW: "#FFC000",
    MODERATE_BLUE: "#5B9BD5",
    GREEN: "#70AD47",
    DARK_GRAY: "#7B7B7B",
    DARK_BLUE: "#264478",
    VERY_DARK_GRAY: "#636363",
    DARK_YELLOW: "#997300"
};
var $d77b025aa58d633c$var$SHEETS_DARK_STROKES = {
    BLUE: "#6899ee",
    ORANGE: "#ffa55d",
    GRAY: "#cdcdcd",
    YELLOW: "#ffea53",
    MODERATE_BLUE: "#82c3ff",
    GREEN: "#96d56f",
    DARK_GRAY: "#a1a1a1",
    DARK_BLUE: "#47689f",
    VERY_DARK_GRAY: "#878787",
    DARK_YELLOW: "#c0993d"
};
var $d77b025aa58d633c$var$palette6 = {
    fills: Object.values($d77b025aa58d633c$var$SHEETS_DARK_FILLS),
    strokes: Object.values($d77b025aa58d633c$var$SHEETS_DARK_STROKES)
};
var $d77b025aa58d633c$var$SheetsDark = class _SheetsDark extends $d77b025aa58d633c$var$DarkTheme {
    static getDefaultColors() {
        return {
            fills: $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, $d77b025aa58d633c$var$SHEETS_DARK_FILLS), {
                RED: $d77b025aa58d633c$var$SHEETS_DARK_FILLS.ORANGE
            }),
            strokes: $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, $d77b025aa58d633c$var$SHEETS_DARK_STROKES), {
                RED: $d77b025aa58d633c$var$SHEETS_DARK_STROKES.ORANGE
            })
        };
    }
    static getWaterfallSeriesDefaultPositiveColors() {
        return {
            fill: $d77b025aa58d633c$var$SHEETS_DARK_FILLS.BLUE,
            stroke: $d77b025aa58d633c$var$SHEETS_DARK_STROKES.BLUE,
            label: {
                color: "white"
            }
        };
    }
    static getWaterfallSeriesDefaultNegativeColors() {
        return {
            fill: $d77b025aa58d633c$var$SHEETS_DARK_FILLS.ORANGE,
            stroke: $d77b025aa58d633c$var$SHEETS_DARK_STROKES.ORANGE,
            label: {
                color: "white"
            }
        };
    }
    static getWaterfallSeriesDefaultTotalColors() {
        return {
            fill: $d77b025aa58d633c$var$SHEETS_DARK_FILLS.GRAY,
            stroke: $d77b025aa58d633c$var$SHEETS_DARK_STROKES.GRAY,
            label: {
                color: "white"
            }
        };
    }
    getTemplateParameters() {
        const result = super.getTemplateParameters();
        result.properties.set($d77b025aa58d633c$var$DEFAULT_COLOURS, _SheetsDark.getDefaultColors());
        result.properties.set($d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_POSITIVE_COLOURS, _SheetsDark.getWaterfallSeriesDefaultPositiveColors());
        result.properties.set($d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_NEGATIVE_COLOURS, _SheetsDark.getWaterfallSeriesDefaultNegativeColors());
        result.properties.set($d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_TOTAL_COLOURS, _SheetsDark.getWaterfallSeriesDefaultTotalColors());
        result.properties.set($d77b025aa58d633c$var$DEFAULT_DIVERGING_SERIES_COLOUR_RANGE, [
            $d77b025aa58d633c$var$SHEETS_DARK_FILLS.ORANGE,
            $d77b025aa58d633c$var$SHEETS_DARK_FILLS.YELLOW,
            $d77b025aa58d633c$var$SHEETS_DARK_FILLS.GREEN
        ]);
        result.properties.set($d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_CONNECTOR_LINE_STROKE, _SheetsDark.getWaterfallSeriesDefaultTotalColors().stroke);
        result.properties.set($d77b025aa58d633c$var$DEFAULT_ANNOTATION_STROKE, $d77b025aa58d633c$var$SHEETS_DARK_STROKES.BLUE);
        result.properties.set($d77b025aa58d633c$var$DEFAULT_ANNOTATION_BACKGROUND_FILL, $d77b025aa58d633c$var$SHEETS_DARK_FILLS.BLUE);
        return result;
    }
    getPalette() {
        return $d77b025aa58d633c$var$palette6;
    }
};
// packages/ag-charts-community/src/chart/themes/sheetsLight.ts
var $d77b025aa58d633c$var$SHEETS_LIGHT_FILLS = {
    BLUE: "#5281d5",
    ORANGE: "#ff8d44",
    GRAY: "#b5b5b5",
    YELLOW: "#ffd02f",
    MODERATE_BLUE: "#6aabe6",
    GREEN: "#7fbd57",
    DARK_GRAY: "#8a8a8a",
    DARK_BLUE: "#335287",
    VERY_DARK_GRAY: "#717171",
    DARK_YELLOW: "#a98220"
};
var $d77b025aa58d633c$var$SHEETS_LIGHT_STROKES = {
    BLUE: "#214d9b",
    ORANGE: "#c25600",
    GRAY: "#7f7f7f",
    YELLOW: "#d59800",
    MODERATE_BLUE: "#3575ac",
    GREEN: "#4b861a",
    DARK_GRAY: "#575757",
    DARK_BLUE: "#062253",
    VERY_DARK_GRAY: "#414141",
    DARK_YELLOW: "#734f00"
};
var $d77b025aa58d633c$var$palette7 = {
    fills: Object.values($d77b025aa58d633c$var$SHEETS_LIGHT_FILLS),
    strokes: Object.values($d77b025aa58d633c$var$SHEETS_LIGHT_STROKES)
};
var $d77b025aa58d633c$var$SheetsLight = class _SheetsLight extends $d77b025aa58d633c$var$ChartTheme {
    static getDefaultColors() {
        return {
            fills: $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, $d77b025aa58d633c$var$SHEETS_LIGHT_FILLS), {
                RED: $d77b025aa58d633c$var$SHEETS_LIGHT_FILLS.ORANGE
            }),
            strokes: $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, $d77b025aa58d633c$var$SHEETS_LIGHT_STROKES), {
                RED: $d77b025aa58d633c$var$SHEETS_LIGHT_STROKES.ORANGE
            })
        };
    }
    static getWaterfallSeriesDefaultPositiveColors() {
        return {
            fill: $d77b025aa58d633c$var$SHEETS_LIGHT_FILLS.BLUE,
            stroke: $d77b025aa58d633c$var$SHEETS_LIGHT_STROKES.BLUE,
            label: {
                color: $d77b025aa58d633c$var$DEFAULT_LABEL_COLOUR
            }
        };
    }
    static getWaterfallSeriesDefaultNegativeColors() {
        return {
            fill: $d77b025aa58d633c$var$SHEETS_LIGHT_FILLS.ORANGE,
            stroke: $d77b025aa58d633c$var$SHEETS_LIGHT_STROKES.ORANGE,
            label: {
                color: $d77b025aa58d633c$var$DEFAULT_LABEL_COLOUR
            }
        };
    }
    static getWaterfallSeriesDefaultTotalColors() {
        return {
            fill: $d77b025aa58d633c$var$SHEETS_LIGHT_FILLS.GRAY,
            stroke: $d77b025aa58d633c$var$SHEETS_LIGHT_STROKES.GRAY,
            label: {
                color: $d77b025aa58d633c$var$DEFAULT_LABEL_COLOUR
            }
        };
    }
    getTemplateParameters() {
        const result = super.getTemplateParameters();
        result.properties.set($d77b025aa58d633c$var$DEFAULT_COLOURS, _SheetsLight.getDefaultColors());
        result.properties.set($d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_POSITIVE_COLOURS, _SheetsLight.getWaterfallSeriesDefaultPositiveColors());
        result.properties.set($d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_NEGATIVE_COLOURS, _SheetsLight.getWaterfallSeriesDefaultNegativeColors());
        result.properties.set($d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_TOTAL_COLOURS, _SheetsLight.getWaterfallSeriesDefaultTotalColors());
        result.properties.set($d77b025aa58d633c$var$DEFAULT_DIVERGING_SERIES_COLOUR_RANGE, [
            $d77b025aa58d633c$var$SHEETS_LIGHT_FILLS.ORANGE,
            $d77b025aa58d633c$var$SHEETS_LIGHT_FILLS.YELLOW,
            $d77b025aa58d633c$var$SHEETS_LIGHT_FILLS.GREEN
        ]);
        result.properties.set($d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_CONNECTOR_LINE_STROKE, _SheetsLight.getWaterfallSeriesDefaultTotalColors().stroke);
        result.properties.set($d77b025aa58d633c$var$DEFAULT_ANNOTATION_STROKE, $d77b025aa58d633c$var$SHEETS_LIGHT_STROKES.BLUE);
        result.properties.set($d77b025aa58d633c$var$DEFAULT_ANNOTATION_BACKGROUND_FILL, $d77b025aa58d633c$var$SHEETS_LIGHT_FILLS.BLUE);
        return result;
    }
    getPalette() {
        return $d77b025aa58d633c$var$palette7;
    }
};
// packages/ag-charts-community/src/chart/themes/vividDark.ts
var $d77b025aa58d633c$var$VIVID_DARK_FILLS = {
    BLUE: "#0083ff",
    ORANGE: "#ff6600",
    GREEN: "#00af00",
    CYAN: "#00ccff",
    YELLOW: "#f7c700",
    VIOLET: "#ac26ff",
    GRAY: "#a7a7b7",
    MAGENTA: "#e800c5",
    BROWN: "#b54300",
    RED: "#ff0000"
};
var $d77b025aa58d633c$var$VIVID_DARK_STROKES = {
    BLUE: "#67b7ff",
    ORANGE: "#ffc24d",
    GREEN: "#5cc86f",
    CYAN: "#54ebff",
    VIOLET: "#c18aff",
    YELLOW: "#fff653",
    GRAY: "#aeaeae",
    MAGENTA: "#f078d4",
    BROWN: "#ba8438",
    RED: "#ff726e"
};
var $d77b025aa58d633c$var$palette8 = {
    fills: Object.values($d77b025aa58d633c$var$VIVID_DARK_FILLS),
    strokes: Object.values($d77b025aa58d633c$var$VIVID_DARK_STROKES)
};
var $d77b025aa58d633c$var$VividDark = class _VividDark extends $d77b025aa58d633c$var$DarkTheme {
    static getDefaultColors() {
        return {
            fills: $d77b025aa58d633c$var$VIVID_DARK_FILLS,
            strokes: $d77b025aa58d633c$var$VIVID_DARK_STROKES
        };
    }
    static getWaterfallSeriesDefaultPositiveColors() {
        return {
            fill: $d77b025aa58d633c$var$VIVID_DARK_FILLS.BLUE,
            stroke: $d77b025aa58d633c$var$VIVID_DARK_STROKES.BLUE,
            label: {
                color: "white"
            }
        };
    }
    static getWaterfallSeriesDefaultNegativeColors() {
        return {
            fill: $d77b025aa58d633c$var$VIVID_DARK_FILLS.ORANGE,
            stroke: $d77b025aa58d633c$var$VIVID_DARK_STROKES.ORANGE,
            label: {
                color: "white"
            }
        };
    }
    static getWaterfallSeriesDefaultTotalColors() {
        return {
            fill: $d77b025aa58d633c$var$VIVID_DARK_FILLS.GRAY,
            stroke: $d77b025aa58d633c$var$VIVID_DARK_STROKES.GRAY,
            label: {
                color: "white"
            }
        };
    }
    getTemplateParameters() {
        const result = super.getTemplateParameters();
        result.properties.set($d77b025aa58d633c$var$DEFAULT_COLOURS, _VividDark.getDefaultColors());
        result.properties.set($d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_POSITIVE_COLOURS, _VividDark.getWaterfallSeriesDefaultPositiveColors());
        result.properties.set($d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_NEGATIVE_COLOURS, _VividDark.getWaterfallSeriesDefaultNegativeColors());
        result.properties.set($d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_TOTAL_COLOURS, _VividDark.getWaterfallSeriesDefaultTotalColors());
        result.properties.set($d77b025aa58d633c$var$DEFAULT_DIVERGING_SERIES_COLOUR_RANGE, [
            $d77b025aa58d633c$var$VIVID_DARK_FILLS.ORANGE,
            $d77b025aa58d633c$var$VIVID_DARK_FILLS.YELLOW,
            $d77b025aa58d633c$var$VIVID_DARK_FILLS.GREEN
        ]);
        result.properties.set($d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_CONNECTOR_LINE_STROKE, _VividDark.getWaterfallSeriesDefaultTotalColors().stroke);
        result.properties.set($d77b025aa58d633c$var$DEFAULT_ANNOTATION_STROKE, $d77b025aa58d633c$var$VIVID_DARK_STROKES.BLUE);
        result.properties.set($d77b025aa58d633c$var$DEFAULT_ANNOTATION_BACKGROUND_FILL, $d77b025aa58d633c$var$VIVID_DARK_FILLS.BLUE);
        return result;
    }
    getPalette() {
        return $d77b025aa58d633c$var$palette8;
    }
};
// packages/ag-charts-community/src/chart/themes/vividLight.ts
var $d77b025aa58d633c$var$VIVID_FILLS = {
    BLUE: "#0083ff",
    ORANGE: "#ff6600",
    GREEN: "#00af00",
    CYAN: "#00ccff",
    YELLOW: "#f7c700",
    VIOLET: "#ac26ff",
    GRAY: "#a7a7b7",
    MAGENTA: "#e800c5",
    BROWN: "#b54300",
    RED: "#ff0000"
};
var $d77b025aa58d633c$var$VIVID_STROKES = {
    BLUE: "#0f68c0",
    ORANGE: "#d47100",
    GREEN: "#007922",
    CYAN: "#009ac2",
    VIOLET: "#bca400",
    YELLOW: "#753cac",
    GRAY: "#646464",
    MAGENTA: "#9b2685",
    BROWN: "#6c3b00",
    RED: "#cb0021"
};
var $d77b025aa58d633c$var$palette9 = {
    fills: Object.values($d77b025aa58d633c$var$VIVID_FILLS),
    strokes: Object.values($d77b025aa58d633c$var$VIVID_STROKES)
};
var $d77b025aa58d633c$var$VividLight = class _VividLight extends $d77b025aa58d633c$var$ChartTheme {
    static getDefaultColors() {
        return {
            fills: $d77b025aa58d633c$var$VIVID_FILLS,
            strokes: $d77b025aa58d633c$var$VIVID_STROKES
        };
    }
    static getWaterfallSeriesDefaultPositiveColors() {
        return {
            fill: $d77b025aa58d633c$var$VIVID_FILLS.BLUE,
            stroke: $d77b025aa58d633c$var$VIVID_STROKES.BLUE,
            label: {
                color: $d77b025aa58d633c$var$DEFAULT_LABEL_COLOUR
            }
        };
    }
    static getWaterfallSeriesDefaultNegativeColors() {
        return {
            fill: $d77b025aa58d633c$var$VIVID_FILLS.ORANGE,
            stroke: $d77b025aa58d633c$var$VIVID_STROKES.ORANGE,
            label: {
                color: $d77b025aa58d633c$var$DEFAULT_LABEL_COLOUR
            }
        };
    }
    static getWaterfallSeriesDefaultTotalColors() {
        return {
            fill: $d77b025aa58d633c$var$VIVID_FILLS.GRAY,
            stroke: $d77b025aa58d633c$var$VIVID_STROKES.GRAY,
            label: {
                color: $d77b025aa58d633c$var$DEFAULT_LABEL_COLOUR
            }
        };
    }
    getTemplateParameters() {
        const result = super.getTemplateParameters();
        result.properties.set($d77b025aa58d633c$var$DEFAULT_COLOURS, _VividLight.getDefaultColors());
        result.properties.set($d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_POSITIVE_COLOURS, _VividLight.getWaterfallSeriesDefaultPositiveColors());
        result.properties.set($d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_NEGATIVE_COLOURS, _VividLight.getWaterfallSeriesDefaultNegativeColors());
        result.properties.set($d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_TOTAL_COLOURS, _VividLight.getWaterfallSeriesDefaultTotalColors());
        result.properties.set($d77b025aa58d633c$var$DEFAULT_DIVERGING_SERIES_COLOUR_RANGE, [
            $d77b025aa58d633c$var$VIVID_FILLS.ORANGE,
            $d77b025aa58d633c$var$VIVID_FILLS.YELLOW,
            $d77b025aa58d633c$var$VIVID_FILLS.GREEN
        ]);
        result.properties.set($d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_CONNECTOR_LINE_STROKE, _VividLight.getWaterfallSeriesDefaultTotalColors().stroke);
        result.properties.set($d77b025aa58d633c$var$DEFAULT_ANNOTATION_STROKE, $d77b025aa58d633c$var$VIVID_STROKES.BLUE);
        result.properties.set($d77b025aa58d633c$var$DEFAULT_ANNOTATION_BACKGROUND_FILL, $d77b025aa58d633c$var$VIVID_FILLS.BLUE);
        return result;
    }
    getPalette() {
        return $d77b025aa58d633c$var$palette9;
    }
};
// packages/ag-charts-community/src/chart/mapping/themes.ts
var $d77b025aa58d633c$var$lightTheme = ()=>new $d77b025aa58d633c$var$ChartTheme();
var $d77b025aa58d633c$var$darkTheme = ()=>new $d77b025aa58d633c$var$DarkTheme();
var $d77b025aa58d633c$var$lightThemes = {
    undefined: $d77b025aa58d633c$var$lightTheme,
    null: $d77b025aa58d633c$var$lightTheme,
    "ag-default": $d77b025aa58d633c$var$lightTheme,
    "ag-sheets": ()=>new $d77b025aa58d633c$var$SheetsLight(),
    "ag-polychroma": ()=>new $d77b025aa58d633c$var$PolychromaLight(),
    "ag-vivid": ()=>new $d77b025aa58d633c$var$VividLight(),
    "ag-material": ()=>new $d77b025aa58d633c$var$MaterialLight()
};
var $d77b025aa58d633c$var$darkThemes = {
    undefined: $d77b025aa58d633c$var$darkTheme,
    null: $d77b025aa58d633c$var$darkTheme,
    "ag-default-dark": $d77b025aa58d633c$var$darkTheme,
    "ag-sheets-dark": ()=>new $d77b025aa58d633c$var$SheetsDark(),
    "ag-polychroma-dark": ()=>new $d77b025aa58d633c$var$PolychromaDark(),
    "ag-vivid-dark": ()=>new $d77b025aa58d633c$var$VividDark(),
    "ag-material-dark": ()=>new $d77b025aa58d633c$var$MaterialDark()
};
var $d77b025aa58d633c$var$themes = $d77b025aa58d633c$var$__spreadValues($d77b025aa58d633c$var$__spreadValues({}, $d77b025aa58d633c$var$darkThemes), $d77b025aa58d633c$var$lightThemes);
function $d77b025aa58d633c$var$validateChartThemeObject(unknownObject) {
    if (unknownObject === null) return;
    let valid = true;
    const { baseTheme: baseTheme, palette: palette10, overrides: overrides } = unknownObject;
    if (baseTheme !== void 0 && typeof baseTheme !== "string" && typeof baseTheme !== "object") {
        $d77b025aa58d633c$var$Logger.warn(`invalid theme.baseTheme type ${typeof baseTheme}, expected (string | object).`);
        valid = false;
    }
    if (overrides !== void 0 && typeof overrides !== "object") {
        $d77b025aa58d633c$var$Logger.warn(`invalid theme.overrides type ${typeof overrides}, expected object.`);
        valid = false;
    }
    if (typeof palette10 === "object") {
        if (palette10 !== null) {
            const { fills: fills, strokes: strokes } = palette10;
            if (fills !== void 0 && !Array.isArray(fills)) {
                $d77b025aa58d633c$var$Logger.warn(`theme.overrides.fills must be undefined or an array`);
                valid = false;
            }
            if (strokes !== void 0 && !Array.isArray(strokes)) {
                $d77b025aa58d633c$var$Logger.warn(`theme.overrides.strokes must be undefined or an array`);
                valid = false;
            }
        }
    } else if (palette10 !== void 0) {
        $d77b025aa58d633c$var$Logger.warn(`invalid theme.palette type ${typeof palette10}, expected object.`);
        valid = false;
    }
    if (valid) return unknownObject;
}
function $d77b025aa58d633c$var$validateChartTheme(value) {
    if (value === void 0 || typeof value === "string" || value instanceof $d77b025aa58d633c$var$ChartTheme) return value;
    if (typeof value === "object") return $d77b025aa58d633c$var$validateChartThemeObject(value);
    $d77b025aa58d633c$var$Logger.warn(`invalid theme value type ${typeof value}, expected object or string.`);
}
function $d77b025aa58d633c$var$getChartTheme(unvalidatedValue) {
    let value = $d77b025aa58d633c$var$validateChartTheme(unvalidatedValue);
    if (value instanceof $d77b025aa58d633c$var$ChartTheme) return value;
    if (value == null || typeof value === "string") {
        const stockTheme = $d77b025aa58d633c$var$themes[value];
        if (stockTheme) return stockTheme();
        $d77b025aa58d633c$var$Logger.warnOnce(`the theme [${value}] is invalid, using [ag-default] instead.`);
        return $d77b025aa58d633c$var$lightTheme();
    }
    const overrides = [];
    let palette10;
    while(typeof value === "object"){
        overrides.push(value.overrides);
        palette10 != null ? palette10 : palette10 = value.palette;
        value = value.baseTheme;
    }
    const flattenedTheme = {
        baseTheme: value,
        overrides: $d77b025aa58d633c$var$mergeDefaults(...overrides),
        palette: palette10
    };
    const baseTheme = flattenedTheme.baseTheme ? $d77b025aa58d633c$var$getChartTheme(flattenedTheme.baseTheme) : $d77b025aa58d633c$var$lightTheme();
    return new baseTheme.constructor(flattenedTheme);
}
// packages/ag-charts-community/src/util/array.ts
function $d77b025aa58d633c$var$extent(values) {
    if (values.length === 0) return;
    let min = Infinity;
    let max = -Infinity;
    for (let n of values){
        if (n instanceof Date) n = n.getTime();
        if (typeof n !== "number") continue;
        if (n < min) min = n;
        if (n > max) max = n;
    }
    const result = [
        min,
        max
    ];
    if (result.every(isFinite)) return result;
}
function $d77b025aa58d633c$var$normalisedExtent(d, min, max) {
    return $d77b025aa58d633c$var$normalisedExtentWithMetadata(d, min, max).extent;
}
function $d77b025aa58d633c$var$normalisedExtentWithMetadata(d, min, max) {
    var _a;
    let clipped = false;
    if (d.length > 2) d = (_a = $d77b025aa58d633c$var$extent(d)) != null ? _a : [
        NaN,
        NaN
    ];
    if (!isNaN(min)) {
        clipped || (clipped = min > d[0]);
        d = [
            min,
            d[1]
        ];
    }
    if (!isNaN(max)) {
        clipped || (clipped = max < d[1]);
        d = [
            d[0],
            max
        ];
    }
    if (d[0] > d[1]) d = [];
    return {
        extent: d,
        clipped: clipped
    };
}
function $d77b025aa58d633c$var$arraysEqual(a, b) {
    if (a == null || b == null || a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++){
        if (Array.isArray(a[i]) && Array.isArray(b[i])) {
            if (!$d77b025aa58d633c$var$arraysEqual(a[i], b[i])) return false;
        } else if (a[i] !== b[i]) return false;
    }
    return true;
}
function $d77b025aa58d633c$var$toArray(value) {
    if (typeof value === "undefined") return [];
    return Array.isArray(value) ? value : [
        value
    ];
}
function $d77b025aa58d633c$var$unique(array) {
    return Array.from(new Set(array));
}
function $d77b025aa58d633c$var$groupBy(array, iteratee) {
    return array.reduce((result, item)=>{
        var _a;
        const groupKey = iteratee(item);
        (_a = result[groupKey]) != null ? _a : result[groupKey] = [];
        result[groupKey].push(item);
        return result;
    }, {});
}
function $d77b025aa58d633c$var$circularSliceArray(data, size, offset4 = 0) {
    if (data.length === 0) return [];
    const result = [];
    for(let i = 0; i < size; i++)result.push(data.at((i + offset4) % data.length));
    return result;
}
function $d77b025aa58d633c$var$bifurcate(isLeft, array) {
    return array.reduce(([left, right], value)=>isLeft(value) ? [
            [
                ...left,
                value
            ],
            right
        ] : [
            left,
            [
                ...right,
                value
            ]
        ], [
        [],
        []
    ]);
}
function* $d77b025aa58d633c$var$mapIterable(src, predicate) {
    for (const e of src)yield predicate(e);
}
function $d77b025aa58d633c$var$constStringsIncludes(array, value) {
    const casting = array;
    return casting.includes(value);
}
function $d77b025aa58d633c$var$isInStringUnion(unionValues, value) {
    return $d77b025aa58d633c$var$constStringsIncludes(unionValues, value);
}
function $d77b025aa58d633c$var$allInStringUnion(unionValues, values) {
    return !values.some((v)=>!$d77b025aa58d633c$var$isInStringUnion(unionValues, v));
}
// packages/ag-charts-community/src/util/dom.ts
var $d77b025aa58d633c$var$verifiedGlobals = {};
var $d77b025aa58d633c$var$injectCache = /* @__PURE__ */ new WeakMap();
if (typeof window !== "undefined") $d77b025aa58d633c$var$verifiedGlobals.window = window;
else if (typeof $parcel$global !== "undefined") $d77b025aa58d633c$var$verifiedGlobals.window = $parcel$global.window;
if (typeof document !== "undefined") $d77b025aa58d633c$var$verifiedGlobals.document = document;
else if (typeof $parcel$global !== "undefined") $d77b025aa58d633c$var$verifiedGlobals.document = $parcel$global.document;
function $d77b025aa58d633c$var$getDocument(propertyName) {
    var _a;
    return propertyName ? (_a = $d77b025aa58d633c$var$verifiedGlobals.document) == null ? void 0 : _a[propertyName] : $d77b025aa58d633c$var$verifiedGlobals.document;
}
function $d77b025aa58d633c$var$getWindow(propertyName) {
    var _a;
    return propertyName ? (_a = $d77b025aa58d633c$var$verifiedGlobals.window) == null ? void 0 : _a[propertyName] : $d77b025aa58d633c$var$verifiedGlobals.window;
}
function $d77b025aa58d633c$var$createElement(tagName, className, style) {
    const element2 = $d77b025aa58d633c$var$getDocument().createElement(tagName);
    if (typeof className === "object") {
        style = className;
        className = void 0;
    }
    if (className) element2.classList.add(className);
    if (style) Object.assign(element2.style, style);
    return element2;
}
function $d77b025aa58d633c$var$downloadUrl(dataUrl, fileName) {
    const { body: body } = $d77b025aa58d633c$var$getDocument();
    const element2 = $d77b025aa58d633c$var$createElement("a", {
        display: "none"
    });
    element2.href = dataUrl;
    element2.download = fileName;
    body.appendChild(element2);
    element2.click();
    setTimeout(()=>body.removeChild(element2));
}
function $d77b025aa58d633c$var$injectStyle(cssStyle, uniqueId) {
    var _a, _b;
    const document2 = $d77b025aa58d633c$var$getDocument();
    if (uniqueId && ((_a = $d77b025aa58d633c$var$injectCache.get(document2)) == null ? void 0 : _a.has(uniqueId))) return;
    const styleElement = $d77b025aa58d633c$var$createElement("style");
    styleElement.innerHTML = cssStyle;
    document2.head.insertBefore(styleElement, document2.head.querySelector("style"));
    if (uniqueId && !$d77b025aa58d633c$var$injectCache.has(document2)) $d77b025aa58d633c$var$injectCache.set(document2, /* @__PURE__ */ new Set([
        uniqueId
    ]));
    else if (uniqueId) (_b = $d77b025aa58d633c$var$injectCache.get(document2)) == null || _b.add(uniqueId);
}
function $d77b025aa58d633c$var$setDocument(document2) {
    $d77b025aa58d633c$var$verifiedGlobals.document = document2;
}
function $d77b025aa58d633c$var$setWindow(window2) {
    $d77b025aa58d633c$var$verifiedGlobals.window = window2;
}
// packages/ag-charts-community/src/util/debug.ts
var $d77b025aa58d633c$var$LONG_TIME_PERIOD_THRESHOLD = 2e3;
var $d77b025aa58d633c$var$timeOfLastLog = Date.now();
var $d77b025aa58d633c$var$logTimeGap = ()=>{
    const timeSinceLastLog = Date.now() - $d77b025aa58d633c$var$timeOfLastLog;
    if (timeSinceLastLog > $d77b025aa58d633c$var$LONG_TIME_PERIOD_THRESHOLD) {
        const prettyDuration = (Math.floor(timeSinceLastLog / 100) / 10).toFixed(1);
        $d77b025aa58d633c$var$Logger.log(`**** ${prettyDuration}s since last log message ****`);
    }
    $d77b025aa58d633c$var$timeOfLastLog = Date.now();
};
var $d77b025aa58d633c$var$Debug = {
    create (...debugSelectors) {
        const resultFn = (...logContent)=>{
            if ($d77b025aa58d633c$var$Debug.check(...debugSelectors)) {
                if (typeof logContent[0] === "function") logContent = $d77b025aa58d633c$var$toArray(logContent[0]());
                $d77b025aa58d633c$var$logTimeGap();
                $d77b025aa58d633c$var$Logger.log(...logContent);
            }
        };
        return Object.assign(resultFn, {
            check: ()=>$d77b025aa58d633c$var$Debug.check(...debugSelectors)
        });
    },
    check (...debugSelectors) {
        if (debugSelectors.length === 0) debugSelectors.push(true);
        const chartDebug = $d77b025aa58d633c$var$toArray($d77b025aa58d633c$var$getWindow("agChartsDebug"));
        return chartDebug.some((selector)=>debugSelectors.includes(selector));
    }
};
// packages/ag-charts-community/src/module/optionsModule.ts
var $d77b025aa58d633c$var$unthemedSeries = /* @__PURE__ */ new Set([
    "map-shape-background",
    "map-line-background"
]);
var $d77b025aa58d633c$var$ChartOptions = class {
    constructor(userOptions, specialOverrides){
        var _b, _c, _d;
        const cloneOptions = {
            shallow: [
                "data"
            ]
        };
        const options = $d77b025aa58d633c$var$deepClone(userOptions, cloneOptions);
        const chartType2 = this.optionsType(options);
        this.sanityCheckAndCleanup(options);
        this.userOptions = options;
        this.activeTheme = $d77b025aa58d633c$var$getChartTheme(options.theme);
        this.defaultAxes = this.getDefaultAxes(options);
        this.specialOverrides = this.specialOverridesDefaults($d77b025aa58d633c$var$__spreadValues({}, specialOverrides));
        const _a = this.getSeriesThemeConfig(chartType2), { axes: axesThemes = {}, annotations: annotationsThemes = {}, series: _ } = _a, themeDefaults = $d77b025aa58d633c$var$__objRest(_a, [
            "axes",
            "annotations",
            "series"
        ]);
        this.processedOptions = $d77b025aa58d633c$var$deepClone($d77b025aa58d633c$var$mergeDefaults(this.userOptions, themeDefaults, this.defaultAxes), cloneOptions);
        this.processAxesOptions(this.processedOptions, axesThemes);
        this.processSeriesOptions(this.processedOptions);
        this.processMiniChartSeriesOptions(this.processedOptions);
        this.processAnnotationsOptions(this.processedOptions, annotationsThemes);
        if (($d77b025aa58d633c$var$isAgCartesianChartOptions(this.processedOptions) || $d77b025aa58d633c$var$isAgPolarChartOptionsWithSeriesBasedLegend(this.processedOptions)) && ((_b = this.processedOptions.legend) == null ? void 0 : _b.enabled) == null) {
            (_d = (_c = this.processedOptions).legend) != null ? _d : _c.legend = {};
            this.processedOptions.legend.enabled = this.processedOptions.series.length > 1;
        }
        this.enableConfiguredOptions(this.processedOptions);
        if (!$d77b025aa58d633c$var$enterpriseModule.isEnterprise) $d77b025aa58d633c$var$removeUsedEnterpriseOptions(this.processedOptions);
    }
    getOptions() {
        var _a;
        return (_a = this.processedOptions) != null ? _a : {};
    }
    diffOptions(options) {
        return $d77b025aa58d633c$var$jsonDiff(options, this.processedOptions);
    }
    getSeriesThemeConfig(seriesType) {
        var _a, _b;
        return $d77b025aa58d633c$var$deepClone((_b = (_a = this.activeTheme) == null ? void 0 : _a.config[seriesType]) != null ? _b : {});
    }
    getDefaultAxes(options) {
        const optionsType2 = this.optionsType(options);
        const axesDefaults = $d77b025aa58d633c$var$seriesRegistry.cloneDefaultAxes(optionsType2);
        if ($d77b025aa58d633c$var$seriesRegistry.isDefaultAxisSwapNeeded(options)) this.swapAxesPosition(axesDefaults);
        return axesDefaults;
    }
    optionsType(options) {
        var _a, _b, _c;
        return (_c = (_b = (_a = options.series) == null ? void 0 : _a[0]) == null ? void 0 : _b.type) != null ? _c : "line";
    }
    sanityCheckAndCleanup(options) {
        var _a;
        this.deprecationWarnings(options);
        this.axesTypeIntegrity(options);
        this.seriesTypeIntegrity(options);
        this.soloSeriesIntegrity(options);
        this.removeDisabledOptions(options);
        this.removeLeftoverSymbols(options);
        if (((_a = options.series) == null ? void 0 : _a.some((s)=>s.type === "bullet")) && options.sync != null && options.sync.enabled !== false) {
            $d77b025aa58d633c$var$Logger.warnOnce("bullet series cannot be synced, disabling synchronization.");
            delete options.sync;
        }
    }
    swapAxesPosition(options) {
        var _a;
        if ($d77b025aa58d633c$var$isAgCartesianChartOptions(options)) {
            const [axis0, axis1] = (_a = options.axes) != null ? _a : [];
            options.axes = [
                $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, axis0), {
                    position: axis1.position
                }),
                $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, axis1), {
                    position: axis0.position
                })
            ];
        }
    }
    processAxesOptions(options, axesThemes) {
        if (!("axes" in options)) return;
        options.axes = options.axes.map((axis)=>{
            var _a, _c, _d;
            const _b = $d77b025aa58d633c$var$mergeDefaults((_a = axesThemes[axis.type]) == null ? void 0 : _a[axis.position], axesThemes[axis.type]), { crossLines: crossLinesTheme } = _b, axisTheme = $d77b025aa58d633c$var$__objRest(_b, [
                "crossLines"
            ]);
            if (axis.crossLines) axis.crossLines = $d77b025aa58d633c$var$mergeArrayDefaults(axis.crossLines, crossLinesTheme);
            const gridLineStyle = (_c = axisTheme.gridLine) == null ? void 0 : _c.style;
            if (((_d = axis.gridLine) == null ? void 0 : _d.style) && (gridLineStyle == null ? void 0 : gridLineStyle.length)) axis.gridLine.style = axis.gridLine.style.map((style, index)=>style.stroke != null || style.lineDash != null ? $d77b025aa58d633c$var$mergeDefaults(style, gridLineStyle.at(index % gridLineStyle.length)) : style);
            const _e = $d77b025aa58d633c$var$mergeDefaults(axis, axisTheme), { top: _1, right: _2, bottom: _3, left: _4 } = _e, axisOptions = $d77b025aa58d633c$var$__objRest(_e, [
                "top",
                "right",
                "bottom",
                "left"
            ]);
            return axisOptions;
        });
    }
    processSeriesOptions(options) {
        const defaultSeriesType = this.getDefaultSeriesType(options);
        const defaultTooltipPosition = this.getTooltipPositionDefaults(options);
        const userPalette = Boolean($d77b025aa58d633c$var$isObject(options.theme) && options.theme.palette);
        const paletteOptions = {
            colourIndex: 0,
            userPalette: userPalette
        };
        const processedSeries = options.series.map((series)=>{
            var _a, _b;
            (_a = series.type) != null ? _a : series.type = defaultSeriesType;
            const _c = (_b = this.getSeriesThemeConfig(series.type).series) != null ? _b : {}, { innerLabels: innerLabelsTheme } = _c, seriesTheme = $d77b025aa58d633c$var$__objRest(_c, [
                "innerLabels"
            ]);
            const seriesPaletteOptions = $d77b025aa58d633c$var$unthemedSeries.has(series.type) ? {
                colourIndex: 0,
                userPalette: userPalette
            } : paletteOptions;
            const palette10 = this.getSeriesPalette(series.type, seriesPaletteOptions);
            const seriesOptions = $d77b025aa58d633c$var$mergeDefaults(this.getSeriesGroupingOptions(series), series, defaultTooltipPosition, seriesTheme, palette10);
            if (seriesOptions.innerLabels) seriesOptions.innerLabels = $d77b025aa58d633c$var$mergeArrayDefaults(seriesOptions.innerLabels, innerLabelsTheme);
            return this.activeTheme.templateTheme(seriesOptions);
        });
        options.series = this.setSeriesGroupingOptions(processedSeries);
    }
    processMiniChartSeriesOptions(options) {
        var _a, _b;
        let miniChartSeries = (_b = (_a = options.navigator) == null ? void 0 : _a.miniChart) == null ? void 0 : _b.series;
        if (miniChartSeries == null) return;
        const paletteOptions = {
            colourIndex: 0,
            userPalette: Boolean($d77b025aa58d633c$var$isObject(options.theme) && options.theme.palette)
        };
        miniChartSeries = miniChartSeries.map((series)=>{
            var _a2, _b2;
            (_a2 = series.type) != null ? _a2 : series.type = "line";
            const _c = (_b2 = this.getSeriesThemeConfig(series.type).series) != null ? _b2 : {}, { innerLabels: _ } = _c, seriesTheme = $d77b025aa58d633c$var$__objRest(_c, [
                "innerLabels"
            ]);
            const seriesOptions = $d77b025aa58d633c$var$mergeDefaults(this.getSeriesGroupingOptions(series), series, seriesTheme, this.getSeriesPalette(series.type, paletteOptions));
            return this.activeTheme.templateTheme(seriesOptions);
        });
        options.navigator.miniChart.series = this.setSeriesGroupingOptions(miniChartSeries);
    }
    processAnnotationsOptions(options, _annotationsThemes) {
        if (!$d77b025aa58d633c$var$isAgCartesianChartOptions(options)) return;
    }
    getSeriesPalette(seriesType, options) {
        const paletteFactory = $d77b025aa58d633c$var$seriesRegistry.getPaletteFactory(seriesType);
        const { colourIndex: colourOffset, userPalette: userPalette } = options;
        const { fills: fills = [], strokes: strokes = [] } = this.activeTheme.palette;
        return paletteFactory == null ? void 0 : paletteFactory({
            userPalette: userPalette,
            colorsCount: Math.max(fills.length, strokes.length),
            themeTemplateParameters: this.activeTheme.getTemplateParameters(),
            takeColors (count) {
                options.colourIndex += count;
                return {
                    fills: $d77b025aa58d633c$var$circularSliceArray(fills, count, colourOffset),
                    strokes: $d77b025aa58d633c$var$circularSliceArray(strokes, count, colourOffset)
                };
            }
        });
    }
    getSeriesGroupingOptions(series) {
        const groupable = $d77b025aa58d633c$var$seriesRegistry.isGroupable(series.type);
        const stackable = $d77b025aa58d633c$var$seriesRegistry.isStackable(series.type);
        const stackedByDefault = $d77b025aa58d633c$var$seriesRegistry.isStackedByDefault(series.type);
        if (series.grouped && !groupable) $d77b025aa58d633c$var$Logger.warnOnce(`unsupported grouping of series type "${series.type}".`);
        if ((series.stacked || series.stackGroup) && !stackable) $d77b025aa58d633c$var$Logger.warnOnce(`unsupported stacking of series type "${series.type}".`);
        let { grouped: grouped, stacked: stacked } = series;
        stacked != null ? stacked : stacked = (stackedByDefault || series.stackGroup != null) && !(groupable && grouped);
        grouped != null ? grouped : grouped = true;
        return {
            stacked: stackable && stacked,
            grouped: groupable && grouped && !(stackable && stacked)
        };
    }
    setSeriesGroupingOptions(allSeries) {
        const seriesGroups = this.getSeriesGrouping(allSeries);
        $d77b025aa58d633c$var$Debug.create(true, "opts")("setSeriesGroupingOptions() - series grouping: ", seriesGroups);
        const groupIdx = {};
        const groupCount2 = seriesGroups.reduce((countMap, seriesGroup)=>{
            var _a, _b;
            if (seriesGroup.groupType === "default" /* DEFAULT */ ) return countMap;
            (_b = countMap[_a = seriesGroup.seriesType]) != null ? _b : countMap[_a] = 0;
            countMap[seriesGroup.seriesType] += seriesGroup.groupType === "stack" /* STACK */  ? 1 : seriesGroup.series.length;
            return countMap;
        }, {});
        return seriesGroups.flatMap((seriesGroup)=>{
            var _a, _b;
            (_b = groupIdx[_a = seriesGroup.seriesType]) != null ? _b : groupIdx[_a] = 0;
            switch(seriesGroup.groupType){
                case "stack" /* STACK */ :
                    const groupIndex = groupIdx[seriesGroup.seriesType]++;
                    return seriesGroup.series.map((series, stackIndex)=>Object.assign(series, {
                            seriesGrouping: {
                                groupIndex: groupIndex,
                                groupCount: groupCount2[seriesGroup.seriesType],
                                stackIndex: stackIndex,
                                stackCount: seriesGroup.series.length
                            }
                        }));
                case "group" /* GROUP */ :
                    return seriesGroup.series.map((series)=>Object.assign(series, {
                            seriesGrouping: {
                                groupIndex: groupIdx[seriesGroup.seriesType]++,
                                groupCount: groupCount2[seriesGroup.seriesType],
                                stackIndex: 0,
                                stackCount: 0
                            }
                        }));
            }
            return seriesGroup.series;
        }).map((_a)=>{
            var _b = _a, { stacked: _, grouped: __ } = _b, seriesOptions = $d77b025aa58d633c$var$__objRest(_b, [
                "stacked",
                "grouped"
            ]);
            return seriesOptions;
        });
    }
    getSeriesGroupId(series) {
        var _a;
        return [
            series.type,
            series.xKey,
            series.stacked ? (_a = series.stackGroup) != null ? _a : "stacked" : "grouped"
        ].filter(Boolean).join("-");
    }
    getSeriesGrouping(allSeries) {
        const groupMap = /* @__PURE__ */ new Map();
        return allSeries.reduce((result, series)=>{
            const seriesType = series.type;
            if (!series.stacked && !series.grouped) result.push({
                groupType: "default" /* DEFAULT */ ,
                seriesType: seriesType,
                series: [
                    series
                ]
            });
            else {
                const groupId = this.getSeriesGroupId(series);
                if (!groupMap.has(groupId)) {
                    const groupType = series.stacked ? "stack" /* STACK */  : "group" /* GROUP */ ;
                    const record = {
                        groupType: groupType,
                        seriesType: seriesType,
                        series: []
                    };
                    groupMap.set(groupId, record);
                    result.push(record);
                }
                groupMap.get(groupId).series.push(series);
            }
            return result;
        }, []);
    }
    getDefaultSeriesType(options) {
        if ($d77b025aa58d633c$var$isAgCartesianChartOptions(options)) return "line";
        else if ($d77b025aa58d633c$var$isAgPolarChartOptions(options)) return "pie";
        else if ($d77b025aa58d633c$var$isAgHierarchyChartOptions(options)) return "treemap";
        else if ($d77b025aa58d633c$var$isAgTopologyChartOptions(options)) return "map-shape";
        throw new Error("Invalid chart options type detected.");
    }
    getTooltipPositionDefaults(options) {
        var _a;
        const position = (_a = options.tooltip) == null ? void 0 : _a.position;
        if (!$d77b025aa58d633c$var$isPlainObject(position)) return;
        const { type: type, xOffset: xOffset, yOffset: yOffset } = position;
        const result = {};
        if ($d77b025aa58d633c$var$isString(type) && $d77b025aa58d633c$var$isEnumValue($d77b025aa58d633c$export$a277a8c996e5a5f6, type)) result.type = type;
        if ($d77b025aa58d633c$var$isFiniteNumber(xOffset)) result.xOffset = xOffset;
        if ($d77b025aa58d633c$var$isFiniteNumber(yOffset)) result.yOffset = yOffset;
        return {
            tooltip: {
                position: result
            }
        };
    }
    deprecationWarnings(options) {
        const deprecatedArrayProps = {
            yKeys: "yKey",
            yNames: "yName"
        };
        Object.entries(deprecatedArrayProps).forEach(([oldProp, newProp])=>{
            var _a;
            if ((_a = options.series) == null ? void 0 : _a.some((s)=>s[oldProp] != null)) $d77b025aa58d633c$var$Logger.warnOnce(`Property [series.${oldProp}] is deprecated, please use [series.${newProp}] and multiple series instead.`);
        });
    }
    axesTypeIntegrity(options) {
        var _a;
        if ("axes" in options) {
            const axes = (_a = options.axes) != null ? _a : [];
            for (const { type: type } of axes)if (!$d77b025aa58d633c$var$isAxisOptionType(type)) {
                delete options.axes;
                const expectedTypes = Array.from($d77b025aa58d633c$var$axisRegistry.publicKeys()).join(", ");
                $d77b025aa58d633c$var$Logger.warnOnce(`unknown axis type: ${type}; expected one of: ${expectedTypes}`);
            }
        }
    }
    seriesTypeIntegrity(options) {
        var _a;
        const series = (_a = options.series) != null ? _a : [];
        options.series = series.filter(({ type: type })=>{
            if (type == null || $d77b025aa58d633c$var$isSeriesOptionType(type) || $d77b025aa58d633c$var$isEnterpriseSeriesType(type)) return true;
            $d77b025aa58d633c$var$Logger.warnOnce(`unknown series type: ${type}; expected one of: ${$d77b025aa58d633c$var$publicChartTypes.seriesTypes.join(", ")}`);
        });
    }
    soloSeriesIntegrity(options) {
        const allSeries = options.series;
        if (allSeries && allSeries.length > 1 && allSeries.some((series)=>$d77b025aa58d633c$var$seriesRegistry.isSolo(series.type))) {
            const mainSeriesType = this.optionsType(options);
            if ($d77b025aa58d633c$var$seriesRegistry.isSolo(mainSeriesType)) {
                $d77b025aa58d633c$var$Logger.warn(`series[0] of type '${mainSeriesType}' is incompatible with other series types. Only processing series[0]`);
                options.series = allSeries.slice(0, 1);
            } else {
                const { solo: solo, nonSolo: nonSolo } = $d77b025aa58d633c$var$groupBy(allSeries, (s)=>$d77b025aa58d633c$var$seriesRegistry.isSolo(s.type) ? "solo" : "nonSolo");
                const rejects = $d77b025aa58d633c$var$unique(solo.map((s)=>s.type)).join(", ");
                $d77b025aa58d633c$var$Logger.warn(`Unable to mix these series types with the lead series type: ${rejects}`);
                options.series = nonSolo;
            }
        }
    }
    enableConfiguredOptions(options) {
        $d77b025aa58d633c$var$jsonWalk(this.userOptions, (visitingUserOpts, visitingMergedOpts)=>{
            if (visitingMergedOpts && "enabled" in visitingMergedOpts && !visitingMergedOpts._enabledFromTheme && visitingUserOpts.enabled == null) visitingMergedOpts.enabled = true;
        }, {
            skip: [
                "data",
                "theme"
            ]
        }, options);
        $d77b025aa58d633c$var$jsonWalk(options, (visitingMergedOpts)=>{
            if (visitingMergedOpts._enabledFromTheme != null) delete visitingMergedOpts._enabledFromTheme;
        }, {
            skip: [
                "data",
                "theme"
            ]
        });
    }
    removeDisabledOptions(options) {
        $d77b025aa58d633c$var$jsonWalk(options, (optionsNode)=>{
            if ("enabled" in optionsNode && optionsNode.enabled === false) Object.keys(optionsNode).forEach((key)=>{
                if (key === "enabled") return;
                delete optionsNode[key];
            });
        }, {
            skip: [
                "data",
                "theme"
            ]
        });
    }
    removeLeftoverSymbols(options) {
        $d77b025aa58d633c$var$jsonWalk(options, (optionsNode)=>{
            if (!optionsNode || !$d77b025aa58d633c$var$isObject(optionsNode)) return;
            for (const [key, value] of Object.entries(optionsNode))if ($d77b025aa58d633c$var$isSymbol(value)) delete optionsNode[key];
        }, {
            skip: [
                "data"
            ]
        });
    }
    specialOverridesDefaults(options) {
        if (options.window != null) $d77b025aa58d633c$var$setWindow(options.window);
        else if (typeof window !== "undefined") options.window = window;
        else if (typeof $parcel$global !== "undefined") options.window = $parcel$global.window;
        if (options.document != null) $d77b025aa58d633c$var$setDocument(options.document);
        else if (typeof document !== "undefined") options.document = document;
        else if (typeof $parcel$global !== "undefined") options.document = $parcel$global.document;
        if (options.window == null) throw new Error("AG Charts - unable to resolve global window");
        if (options.document == null) throw new Error("AG Charts - unable to resolve global document");
        return options;
    }
};
// packages/ag-charts-community/src/util/deprecation.ts
function $d77b025aa58d633c$var$createDeprecationWarning() {
    return (key, message)=>{
        const msg = [
            `Property [${key}] is deprecated.`,
            message
        ].filter(Boolean).join(" ");
        $d77b025aa58d633c$var$Logger.warnOnce(msg);
    };
}
function $d77b025aa58d633c$var$Deprecated(message, opts) {
    const warnDeprecated = $d77b025aa58d633c$var$createDeprecationWarning();
    const def = opts == null ? void 0 : opts.default;
    return $d77b025aa58d633c$var$addTransformToInstanceProperty((_, key, value)=>{
        if (value !== def) warnDeprecated(key.toString(), message);
        return value;
    });
}
function $d77b025aa58d633c$var$DeprecatedAndRenamedTo(newPropName, mapValue) {
    const warnDeprecated = $d77b025aa58d633c$var$createDeprecationWarning();
    return $d77b025aa58d633c$var$addTransformToInstanceProperty((target, key, value)=>{
        if (value !== target[newPropName]) {
            warnDeprecated(key.toString(), `Use [${newPropName}] instead.`);
            $d77b025aa58d633c$var$setPath(target, newPropName, mapValue ? mapValue(value) : value);
        }
        return $d77b025aa58d633c$var$BREAK_TRANSFORM_CHAIN;
    }, (target, key)=>{
        warnDeprecated(key.toString(), `Use [${newPropName}] instead.`);
        return $d77b025aa58d633c$var$getPath(target, newPropName);
    });
}
// packages/ag-charts-community/src/motion/fromToMotion.ts
var $d77b025aa58d633c$var$fromToMotion_exports = {};
$d77b025aa58d633c$var$__export($d77b025aa58d633c$var$fromToMotion_exports, {
    NODE_UPDATE_STATE_TO_PHASE_MAPPING: ()=>$d77b025aa58d633c$var$NODE_UPDATE_STATE_TO_PHASE_MAPPING,
    fromToMotion: ()=>$d77b025aa58d633c$var$fromToMotion,
    staticFromToMotion: ()=>$d77b025aa58d633c$var$staticFromToMotion
});
// packages/ag-charts-community/src/util/id.ts
var $d77b025aa58d633c$var$ID_MAP = /* @__PURE__ */ new Map();
function $d77b025aa58d633c$var$resetIds() {
    $d77b025aa58d633c$var$ID_MAP.clear();
}
function $d77b025aa58d633c$var$createId(instance) {
    var _a;
    const constructor = instance.constructor;
    const className = Object.hasOwn(constructor, "className") ? constructor.className : constructor.name;
    if (!className) throw new Error(`The ${constructor} is missing the 'className' property.`);
    const nextId = ((_a = $d77b025aa58d633c$var$ID_MAP.get(className)) != null ? _a : 0) + 1;
    $d77b025aa58d633c$var$ID_MAP.set(className, nextId);
    return `${className}-${nextId}`;
}
// packages/ag-charts-community/src/util/interpolating.ts
var $d77b025aa58d633c$var$interpolate = "$interpolate";
var $d77b025aa58d633c$var$isInterpolating = (x)=>x[$d77b025aa58d633c$var$interpolate] != null;
// packages/ag-charts-community/src/util/number.ts
function $d77b025aa58d633c$var$clamp(min, value, max) {
    return Math.min(max, Math.max(min, value));
}
function $d77b025aa58d633c$var$clampArray(value, array) {
    const [min, max] = $d77b025aa58d633c$var$findMinMax(array);
    return $d77b025aa58d633c$var$clamp(min, value, max);
}
function $d77b025aa58d633c$var$findMinMax(array) {
    return array.length ? [
        Math.min(...array),
        Math.max(...array)
    ] : [];
}
function $d77b025aa58d633c$var$findRangeExtent(array) {
    const [min, max] = $d77b025aa58d633c$var$findMinMax(array);
    return max - min;
}
function $d77b025aa58d633c$var$isEqual(a, b, epsilon2 = 1e-10) {
    return Math.abs(a - b) < epsilon2;
}
function $d77b025aa58d633c$var$isNegative(value) {
    return Math.sign(value) === -1 || Object.is(value, -0);
}
function $d77b025aa58d633c$var$round(value, decimals = 2) {
    const base = $d77b025aa58d633c$var$__pow(10, decimals);
    return Math.round(value * base) / base;
}
function $d77b025aa58d633c$var$toFixed(value, fractionOrSignificantDigits = 2) {
    const power = Math.floor(Math.log(Math.abs(value)) / Math.LN10);
    if (power >= 0 || !isFinite(power)) return value.toFixed(fractionOrSignificantDigits);
    return value.toFixed(Math.abs(power) - 1 + fractionOrSignificantDigits);
}
function $d77b025aa58d633c$var$mod(n, m) {
    return Math.floor(n % m + (n < 0 ? m : 0));
}
function $d77b025aa58d633c$var$countFractionDigits(value, maximumFractionDigits = 10) {
    const [, decimal = ""] = (Math.abs(value) % 1).toLocaleString("en-GB", {
        minimumFractionDigits: 0,
        maximumFractionDigits: maximumFractionDigits
    }).split(".");
    return decimal.length;
}
// packages/ag-charts-community/src/scene/nearest.ts
function $d77b025aa58d633c$var$nearestSquared(x, y, objects, maxDistanceSquared = Infinity) {
    const result = {
        nearest: void 0,
        distanceSquared: maxDistanceSquared
    };
    for (const obj of objects){
        const thisDistance = obj.distanceSquared(x, y);
        if (thisDistance === 0) return {
            nearest: obj,
            distanceSquared: 0
        };
        else if (thisDistance < result.distanceSquared) {
            result.nearest = obj;
            result.distanceSquared = thisDistance;
        }
    }
    return result;
}
function $d77b025aa58d633c$var$nearestSquaredInContainer(x, y, container, maxDistanceSquared = Infinity) {
    const { x: tx, y: ty } = container.transformPoint(x, y);
    const result = {
        nearest: void 0,
        distanceSquared: maxDistanceSquared
    };
    for (const child of container.children){
        const { nearest: nearest, distanceSquared: distanceSquared2 } = child.nearestSquared(tx, ty, result.distanceSquared);
        if (distanceSquared2 === 0) return {
            nearest: nearest,
            distanceSquared: distanceSquared2
        };
        else if (distanceSquared2 < result.distanceSquared) {
            result.nearest = nearest;
            result.distanceSquared = distanceSquared2;
        }
    }
    return result;
}
// packages/ag-charts-community/src/scene/bbox.ts
var $d77b025aa58d633c$var$_BBox = class _BBox {
    constructor(x, y, width, height){
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }
    clone() {
        const { x: x, y: y, width: width, height: height } = this;
        return new _BBox(x, y, width, height);
    }
    equals(other) {
        return this.x === other.x && this.y === other.y && this.width === other.width && this.height === other.height;
    }
    containsPoint(x, y) {
        return x >= this.x && x <= this.x + this.width && y >= this.y && y <= this.y + this.height;
    }
    collidesBBox(other) {
        return this.x < other.x + other.width && this.x + this.width > other.x && this.y < other.y + other.height && this.y + this.height > other.y;
    }
    computeCenter() {
        return {
            x: this.x + this.width / 2,
            y: this.y + this.height / 2
        };
    }
    isFinite() {
        return Number.isFinite(this.x) && Number.isFinite(this.y) && Number.isFinite(this.width) && Number.isFinite(this.height);
    }
    distanceSquared(x, y) {
        if (this.containsPoint(x, y)) return 0;
        const dx = x - $d77b025aa58d633c$var$clamp(this.x, x, this.x + this.width);
        const dy = y - $d77b025aa58d633c$var$clamp(this.y, y, this.y + this.height);
        return dx * dx + dy * dy;
    }
    static nearestBox(x, y, boxes) {
        return $d77b025aa58d633c$var$nearestSquared(x, y, boxes);
    }
    clip(clipRect) {
        if (clipRect === void 0) return this;
        const x1 = Math.max(this.x, clipRect.x);
        const y1 = Math.max(this.y, clipRect.y);
        const x2 = Math.min(this.x + this.width, clipRect.x + clipRect.width);
        const y2 = Math.min(this.y + this.height, clipRect.y + clipRect.height);
        this.x = x1;
        this.y = y1;
        this.width = Math.max(0, x2 - x1);
        this.height = Math.max(0, y2 - y1);
        return this;
    }
    shrink(amount, position) {
        const apply = (pos, amt)=>{
            switch(pos){
                case "top":
                    this.y += amt;
                case "bottom":
                    this.height -= amt;
                    break;
                case "left":
                    this.x += amt;
                case "right":
                    this.width -= amt;
                    break;
                case "vertical":
                    this.y += amt;
                    this.height -= amt * 2;
                    break;
                case "horizontal":
                    this.x += amt;
                    this.width -= amt * 2;
                    break;
                case void 0:
                    this.x += amt;
                    this.width -= amt * 2;
                    this.y += amt;
                    this.height -= amt * 2;
                    break;
                default:
            }
        };
        if (typeof amount === "number") apply(position, amount);
        else if (typeof amount === "object") Object.entries(amount).forEach(([pos, amt])=>apply(pos, amt));
        return this;
    }
    grow(amount, position) {
        if (typeof amount === "number") this.shrink(-amount, position);
        else {
            const paddingCopy = $d77b025aa58d633c$var$__spreadValues({}, amount);
            for(const key in paddingCopy)paddingCopy[key] *= -1;
            this.shrink(paddingCopy);
        }
        return this;
    }
    combine(other) {
        const { x: x, y: y, width: width, height: height } = this;
        this.x = Math.min(x, other.x);
        this.y = Math.min(y, other.y);
        this.width = Math.max(x + width, other.x + other.width) - this.x;
        this.height = Math.max(y + height, other.y + other.height) - this.y;
    }
    static merge(boxes) {
        let left = Infinity;
        let top = Infinity;
        let right = -Infinity;
        let bottom = -Infinity;
        for (const box of boxes){
            if (box.x < left) left = box.x;
            if (box.y < top) top = box.y;
            if (box.x + box.width > right) right = box.x + box.width;
            if (box.y + box.height > bottom) bottom = box.y + box.height;
        }
        return new _BBox(left, top, right - left, bottom - top);
    }
    [$d77b025aa58d633c$var$interpolate](other, d) {
        return new _BBox(this.x * (1 - d) + other.x * d, this.y * (1 - d) + other.y * d, this.width * (1 - d) + other.width * d, this.height * (1 - d) + other.height * d);
    }
};
$d77b025aa58d633c$var$_BBox.zero = new $d77b025aa58d633c$var$_BBox(0, 0, 0, 0);
$d77b025aa58d633c$var$_BBox.NaN = new $d77b025aa58d633c$var$_BBox(NaN, NaN, NaN, NaN);
var $d77b025aa58d633c$var$BBox = $d77b025aa58d633c$var$_BBox;
// packages/ag-charts-community/src/scene/changeDetectable.ts
var $d77b025aa58d633c$var$RedrawType = /* @__PURE__ */ ((RedrawType2)=>{
    RedrawType2[RedrawType2["NONE"] = 0] = "NONE";
    RedrawType2[RedrawType2["TRIVIAL"] = 1] = "TRIVIAL";
    RedrawType2[RedrawType2["MINOR"] = 2] = "MINOR";
    RedrawType2[RedrawType2["MAJOR"] = 3] = "MAJOR";
    return RedrawType2;
})($d77b025aa58d633c$var$RedrawType || {});
function $d77b025aa58d633c$var$functionConstructorAvailable() {
    try {
        new Function("return true");
        return true;
    } catch (e) {
        return false;
    }
}
var $d77b025aa58d633c$var$STRING_FUNCTION_USEABLE = $d77b025aa58d633c$var$functionConstructorAvailable();
function $d77b025aa58d633c$var$SceneChangeDetection(opts) {
    const { changeCb: changeCb, convertor: convertor } = opts != null ? opts : {};
    return function(target, key) {
        const privateKey = `__${key}`;
        if (target[key]) return;
        if ($d77b025aa58d633c$var$STRING_FUNCTION_USEABLE && changeCb == null && convertor == null) $d77b025aa58d633c$var$prepareFastGetSet(target, key, privateKey, opts);
        else $d77b025aa58d633c$var$prepareSlowGetSet(target, key, privateKey, opts);
    };
}
function $d77b025aa58d633c$var$prepareFastGetSet(target, key, privateKey, opts) {
    const { redraw: redraw = 1 /* TRIVIAL */ , type: type = "normal", checkDirtyOnAssignment: checkDirtyOnAssignment = false } = opts != null ? opts : {};
    const setterJs = new Function("value", `
        const oldValue = this.${privateKey};
        if (value !== oldValue) {
            this.${privateKey} = value;
            ${type === "normal" ? `this.markDirty(this, ${redraw});` : ""}
            ${type === "transform" ? `this.markDirtyTransform(${redraw});` : ""}
            ${type === "path" ? `if (!this._dirtyPath) { this._dirtyPath = true; this.markDirty(this, ${redraw}); }` : ""}
            ${type === "font" ? `if (!this._dirtyFont) { this._dirtyFont = true; this.markDirty(this, ${redraw}); }` : ""}
        }
        ${checkDirtyOnAssignment ? `if (value != null && value._dirty > ${0 /* NONE */ }) { this.markDirty(value, value._dirty); }` : ""}
`);
    const getterJs = new Function(`return this.${privateKey};`);
    Object.defineProperty(target, key, {
        set: setterJs,
        get: getterJs,
        enumerable: true,
        configurable: true
    });
}
function $d77b025aa58d633c$var$prepareSlowGetSet(target, key, privateKey, opts) {
    const { redraw: redraw = 1 /* TRIVIAL */ , type: type = "normal", changeCb: changeCb, convertor: convertor, checkDirtyOnAssignment: checkDirtyOnAssignment = false } = opts != null ? opts : {};
    const setter = function(value) {
        const oldValue = this[privateKey];
        value = convertor ? convertor(value) : value;
        if (value !== oldValue) {
            this[privateKey] = value;
            if (type === "normal") this.markDirty(this, redraw);
            if (type === "transform") this.markDirtyTransform(redraw);
            if (type === "path" && !this._dirtyPath) {
                this._dirtyPath = true;
                this.markDirty(this, redraw);
            }
            if (type === "font" && !this._dirtyFont) {
                this._dirtyFont = true;
                this.markDirty(this, redraw);
            }
            changeCb == null || changeCb(this);
        }
        if (checkDirtyOnAssignment && value != null && value._dirty > 0 /* NONE */ ) this.markDirty(value, value._dirty);
    };
    const getter = function() {
        return this[privateKey];
    };
    Object.defineProperty(target, key, {
        set: setter,
        get: getter,
        enumerable: true,
        configurable: true
    });
}
var $d77b025aa58d633c$var$ChangeDetectable = class {
    constructor(){
        this._dirty = 3 /* MAJOR */ ;
    }
    markDirty(_source, type = 1 /* TRIVIAL */ ) {
        if (this._dirty < type) this._dirty = type;
    }
    markClean(_opts) {
        this._dirty = 0 /* NONE */ ;
    }
    isDirty() {
        return this._dirty > 0 /* NONE */ ;
    }
};
// packages/ag-charts-community/src/scene/matrix.ts
var $d77b025aa58d633c$var$_Matrix = class _Matrix {
    get e() {
        return [
            ...this.elements
        ];
    }
    constructor(elements3 = [
        1,
        0,
        0,
        1,
        0,
        0
    ]){
        this.elements = elements3;
    }
    setElements(elements3) {
        const e = this.elements;
        e[0] = elements3[0];
        e[1] = elements3[1];
        e[2] = elements3[2];
        e[3] = elements3[3];
        e[4] = elements3[4];
        e[5] = elements3[5];
        return this;
    }
    get identity() {
        const e = this.elements;
        return e[0] === 1 && e[1] === 0 && e[2] === 0 && e[3] === 1 && e[4] === 0 && e[5] === 0;
    }
    /**
   * Performs the AxB matrix multiplication and saves the result
   * to `C`, if given, or to `A` otherwise.
   */ AxB(A, B, C) {
        const a = A[0] * B[0] + A[2] * B[1], b = A[1] * B[0] + A[3] * B[1], c = A[0] * B[2] + A[2] * B[3], d = A[1] * B[2] + A[3] * B[3], e = A[0] * B[4] + A[2] * B[5] + A[4], f = A[1] * B[4] + A[3] * B[5] + A[5];
        C = C != null ? C : A;
        C[0] = a;
        C[1] = b;
        C[2] = c;
        C[3] = d;
        C[4] = e;
        C[5] = f;
    }
    /**
   * The `other` matrix gets post-multiplied to the current matrix.
   * Returns the current matrix.
   * @param other
   */ multiplySelf(other) {
        this.AxB(this.elements, other.elements);
        return this;
    }
    /**
   * The `other` matrix gets post-multiplied to the current matrix.
   * Returns a new matrix.
   * @param other
   */ multiply(other) {
        const elements3 = new Array(6);
        this.AxB(this.elements, other.elements, elements3);
        return new _Matrix(elements3);
    }
    preMultiplySelf(other) {
        this.AxB(other.elements, this.elements, this.elements);
        return this;
    }
    /**
   * Returns the inverse of this matrix as a new matrix.
   */ inverse() {
        const el = this.elements;
        let a = el[0], b = el[1], c = el[2], d = el[3];
        const e = el[4], f = el[5];
        const rD = 1 / (a * d - b * c);
        a *= rD;
        b *= rD;
        c *= rD;
        d *= rD;
        return new _Matrix([
            d,
            -b,
            -c,
            a,
            c * f - d * e,
            b * e - a * f
        ]);
    }
    /**
   * Save the inverse of this matrix to the given matrix.
   */ inverseTo(other) {
        const el = this.elements;
        let a = el[0], b = el[1], c = el[2], d = el[3];
        const e = el[4], f = el[5];
        const rD = 1 / (a * d - b * c);
        a *= rD;
        b *= rD;
        c *= rD;
        d *= rD;
        other.setElements([
            d,
            -b,
            -c,
            a,
            c * f - d * e,
            b * e - a * f
        ]);
        return this;
    }
    invertSelf() {
        const el = this.elements;
        let a = el[0], b = el[1], c = el[2], d = el[3];
        const e = el[4], f = el[5];
        const rD = 1 / (a * d - b * c);
        a *= rD;
        b *= rD;
        c *= rD;
        d *= rD;
        el[0] = d;
        el[1] = -b;
        el[2] = -c;
        el[3] = a;
        el[4] = c * f - d * e;
        el[5] = b * e - a * f;
        return this;
    }
    transformPoint(x, y) {
        const e = this.elements;
        return {
            x: x * e[0] + y * e[2] + e[4],
            y: x * e[1] + y * e[3] + e[5]
        };
    }
    transformBBox(bbox, target) {
        const elements3 = this.elements;
        const xx = elements3[0];
        const xy = elements3[1];
        const yx = elements3[2];
        const yy = elements3[3];
        const h_w = bbox.width * 0.5;
        const h_h = bbox.height * 0.5;
        const cx = bbox.x + h_w;
        const cy = bbox.y + h_h;
        const w = Math.abs(h_w * xx) + Math.abs(h_h * yx);
        const h = Math.abs(h_w * xy) + Math.abs(h_h * yy);
        if (!target) target = new $d77b025aa58d633c$var$BBox(0, 0, 0, 0);
        target.x = cx * xx + cy * yx + elements3[4] - w;
        target.y = cx * xy + cy * yy + elements3[5] - h;
        target.width = w + w;
        target.height = h + h;
        return target;
    }
    toContext(ctx) {
        if (this.identity) return;
        const e = this.elements;
        ctx.transform(e[0], e[1], e[2], e[3], e[4], e[5]);
    }
    static flyweight(sourceMatrix) {
        return _Matrix.instance.setElements(sourceMatrix.elements);
    }
    static updateTransformMatrix(matrix, scalingX, scalingY, rotation, translationX, translationY, opts) {
        const [bbcx, bbcy] = [
            0,
            0
        ];
        const sx = scalingX;
        const sy = scalingY;
        let scx;
        let scy;
        if (sx === 1 && sy === 1) {
            scx = 0;
            scy = 0;
        } else {
            scx = (opts == null ? void 0 : opts.scalingCenterX) == null ? bbcx : opts == null ? void 0 : opts.scalingCenterX;
            scy = (opts == null ? void 0 : opts.scalingCenterY) == null ? bbcy : opts == null ? void 0 : opts.scalingCenterY;
        }
        const r = rotation;
        const cos = Math.cos(r);
        const sin = Math.sin(r);
        let rcx;
        let rcy;
        if (r === 0) {
            rcx = 0;
            rcy = 0;
        } else {
            rcx = (opts == null ? void 0 : opts.rotationCenterX) == null ? bbcx : opts == null ? void 0 : opts.rotationCenterX;
            rcy = (opts == null ? void 0 : opts.rotationCenterY) == null ? bbcy : opts == null ? void 0 : opts.rotationCenterY;
        }
        const tx = translationX;
        const ty = translationY;
        const tx4 = scx * (1 - sx) - rcx;
        const ty4 = scy * (1 - sy) - rcy;
        matrix.setElements([
            cos * sx,
            sin * sx,
            -sin * sy,
            cos * sy,
            cos * tx4 - sin * ty4 + rcx + tx,
            sin * tx4 + cos * ty4 + rcy + ty
        ]);
        return matrix;
    }
    static fromContext(ctx) {
        const domMatrix = ctx.getTransform();
        return new _Matrix([
            domMatrix.a,
            domMatrix.b,
            domMatrix.c,
            domMatrix.d,
            domMatrix.e,
            domMatrix.f
        ]);
    }
};
$d77b025aa58d633c$var$_Matrix.instance = new $d77b025aa58d633c$var$_Matrix();
var $d77b025aa58d633c$var$Matrix = $d77b025aa58d633c$var$_Matrix;
// packages/ag-charts-community/src/scene/node.ts
var $d77b025aa58d633c$var$PointerEvents = /* @__PURE__ */ ((PointerEvents2)=>{
    PointerEvents2[PointerEvents2["All"] = 0] = "All";
    PointerEvents2[PointerEvents2["None"] = 1] = "None";
    return PointerEvents2;
})($d77b025aa58d633c$var$PointerEvents || {});
var $d77b025aa58d633c$var$_Node = class _Node extends $d77b025aa58d633c$var$ChangeDetectable {
    constructor({ isVirtual: isVirtual, tag: tag, zIndex: zIndex } = {}){
        super();
        /** Unique number to allow creation order to be easily determined. */ this.serialNumber = _Node._nextSerialNumber++;
        /**
     * Unique node ID in the form `ClassName-NaturalNumber`.
     */ this.id = $d77b025aa58d633c$var$createId(this);
        /**
     * To simplify the type system (especially in Selections) we don't have the `Parent` node
     * (one that has children). Instead, we mimic HTML DOM, where any node can have children.
     * But we still need to distinguish regular leaf nodes from container leafs somehow.
     */ this.isContainerNode = false;
        this._virtualChildren = [];
        this._children = [];
        // Used to check for duplicate nodes.
        this.childSet = {};
        // These matrices may need to have package level visibility
        // for performance optimization purposes.
        this.matrix = new $d77b025aa58d633c$var$Matrix();
        this.dirtyTransform = false;
        this.scalingX = 1;
        this.scalingY = 1;
        this.scalingCenterX = null;
        this.scalingCenterY = null;
        this.rotationCenterX = null;
        this.rotationCenterY = null;
        this.rotation = 0;
        this.translationX = 0;
        this.translationY = 0;
        this._childNodeCounts = {
            groups: 0,
            nonGroups: 0
        };
        this.visible = true;
        this.dirtyZIndex = false;
        this.zIndex = 0;
        /** Discriminators for render order within a zIndex. */ this.zIndexSubOrder = void 0;
        this.pointerEvents = 0 /* All */ ;
        this.isVirtual = isVirtual != null ? isVirtual : false;
        this.tag = tag != null ? tag : NaN;
        this.zIndex = zIndex != null ? zIndex : 0;
    }
    /**
   * Some arbitrary data bound to the node.
   */ get datum() {
        var _a, _b;
        return (_b = this._datum) != null ? _b : (_a = this._parent) == null ? void 0 : _a.datum;
    }
    get previousDatum() {
        return this._previousDatum;
    }
    set datum(datum) {
        if (this._datum !== datum) this._previousDatum = this._datum;
        this._datum = datum;
    }
    _setLayerManager(value) {
        this._layerManager = value;
        this._debug = value == null ? void 0 : value.debug;
        for (const child of this._children)child._setLayerManager(value);
        for (const child of this._virtualChildren)child._setLayerManager(value);
    }
    get layerManager() {
        return this._layerManager;
    }
    *ancestors() {
        let node = this;
        while(node = node.parent)yield node;
    }
    *traverseUp() {
        yield this;
        yield* $d77b025aa58d633c$var$__yieldStar(this.ancestors());
    }
    get parent() {
        return this._parent;
    }
    get children() {
        return this._virtualChildren.length ? this._children.concat(this._virtualChildren.flatMap((next)=>next.children)) : this._children;
    }
    get virtualChildren() {
        return this._virtualChildren;
    }
    hasVirtualChildren() {
        return this._virtualChildren.length > 0;
    }
    // new Set<Node>()
    setProperties(styles, pickKeys) {
        const keys = pickKeys != null ? pickKeys : Object.keys(styles);
        for (const key of keys)this[key] = styles[key];
        return this;
    }
    /**
   * Appends one or more new node instances to this parent.
   * If one needs to:
   * - move a child to the end of the list of children
   * - move a child from one parent to another (including parents in other scenes)
   * one should use the {@link insertBefore} method instead.
   * @param nodes A node or nodes to append.
   */ append(nodes) {
        if (!Array.isArray(nodes)) nodes = [
            nodes
        ];
        for (const node of nodes){
            if (node.parent) throw new Error(`${node} already belongs to another parent: ${node.parent}.`);
            if (node.layerManager) throw new Error(`${node} already belongs to a scene: ${node.layerManager}.`);
            if (this.childSet[node.id]) throw new Error(`Duplicate ${node.constructor.name} node: ${node}`);
            if (node.isVirtual) this._virtualChildren.push(node);
            else this._children.push(node);
            this.childSet[node.id] = true;
            node._parent = this;
            node._setLayerManager(this.layerManager);
        }
        this.dirtyZIndex = true;
        this.markDirty(this, 3 /* MAJOR */ );
    }
    appendChild(node) {
        this.append(node);
        return node;
    }
    removeChild(node) {
        const error = ()=>{
            throw new Error(`The node to be removed is not a child of this node.`);
        };
        if (node.parent !== this) error();
        if (node.isVirtual) {
            const i = this._virtualChildren.indexOf(node);
            if (i < 0) error();
            this._virtualChildren.splice(i, 1);
        } else {
            const i = this._children.indexOf(node);
            if (i < 0) error();
            this._children.splice(i, 1);
        }
        delete this.childSet[node.id];
        node._parent = void 0;
        node._setLayerManager();
        this.dirtyZIndex = true;
        this.markDirty(node, 3 /* MAJOR */ );
        return node;
    }
    calculateCumulativeMatrix() {
        this.computeTransformMatrix();
        const matrix = $d77b025aa58d633c$var$Matrix.flyweight(this.matrix);
        for (const parent of this.ancestors()){
            parent.computeTransformMatrix();
            matrix.preMultiplySelf(parent.matrix);
        }
        return matrix;
    }
    transformPoint(x, y) {
        const matrix = this.calculateCumulativeMatrix();
        return matrix.invertSelf().transformPoint(x, y);
    }
    inverseTransformPoint(x, y) {
        const matrix = this.calculateCumulativeMatrix();
        return matrix.transformPoint(x, y);
    }
    transformBBox(bbox) {
        const matrix = this.calculateCumulativeMatrix();
        return matrix.invertSelf().transformBBox(bbox);
    }
    inverseTransformBBox(bbox) {
        const matrix = this.calculateCumulativeMatrix();
        return matrix.transformBBox(bbox);
    }
    markDirtyTransform() {
        this.dirtyTransform = true;
        this.markDirty(this, 3 /* MAJOR */ );
    }
    containsPoint(_x, _y) {
        return false;
    }
    /**
   * Hit testing method.
   * Recursively checks if the given point is inside this node or any of its children.
   * Returns the first matching node or `undefined`.
   * Nodes that render later (show on top) are hit tested first.
   */ pickNode(x, y) {
        var _a;
        if (!this.visible || this.pointerEvents === 1 /* None */  || !this.containsPoint(x, y)) return;
        const { children: children } = this;
        if (children.length > 1e3) for(let i = children.length - 1; i >= 0; i--){
            const child = children[i];
            const containsPoint = (_a = child.computeTransformedBBox()) == null ? void 0 : _a.containsPoint(x, y);
            const hit = containsPoint ? child.pickNode(x, y) : void 0;
            if (hit) return hit;
        }
        else if (children.length) for(let i = children.length - 1; i >= 0; i--){
            const hit = children[i].pickNode(x, y);
            if (hit) return hit;
        }
        else if (!this.isContainerNode) return this;
    }
    getCachedBBox() {
        var _a;
        return (_a = this.cachedBBox) != null ? _a : $d77b025aa58d633c$var$BBox.zero;
    }
    computeBBox() {
        return;
    }
    computeTransformedBBox() {
        const bbox = this.computeBBox();
        if (!bbox) return;
        this.computeTransformMatrix();
        const matrix = $d77b025aa58d633c$var$Matrix.flyweight(this.matrix);
        for (const parent of this.ancestors()){
            parent.computeTransformMatrix();
            matrix.preMultiplySelf(parent.matrix);
        }
        matrix.transformBBox(bbox, bbox);
        return bbox;
    }
    computeTransformMatrix() {
        if (!this.dirtyTransform) return;
        const { matrix: matrix, scalingX: scalingX, scalingY: scalingY, rotation: rotation, translationX: translationX, translationY: translationY, scalingCenterX: scalingCenterX, scalingCenterY: scalingCenterY, rotationCenterX: rotationCenterX, rotationCenterY: rotationCenterY } = this;
        $d77b025aa58d633c$var$Matrix.updateTransformMatrix(matrix, scalingX, scalingY, rotation, translationX, translationY, {
            scalingCenterX: scalingCenterX,
            scalingCenterY: scalingCenterY,
            rotationCenterX: rotationCenterX,
            rotationCenterY: rotationCenterY
        });
        this.dirtyTransform = false;
    }
    /** Perform any pre-rendering initialization. */ preRender() {
        this._childNodeCounts.groups = 0;
        this._childNodeCounts.nonGroups = 1;
        for (const child of this.children){
            const childCounts = child.preRender();
            this._childNodeCounts.groups += childCounts.groups;
            this._childNodeCounts.nonGroups += childCounts.nonGroups;
        }
        return this._childNodeCounts;
    }
    render(renderCtx) {
        const { stats: stats } = renderCtx;
        this._dirty = 0 /* NONE */ ;
        this.cachedBBox = this.computeBBox();
        if (stats) stats.nodesRendered++;
    }
    markDirty(_source, type = 1 /* TRIVIAL */ , parentType = type) {
        if (this._dirty > type || this._dirty === type && type === parentType) return;
        this._dirty = type;
        if (this.parent) this.parent.markDirty(this, parentType);
        else if (this.layerManager) this.layerManager.markDirty();
    }
    get dirty() {
        return this._dirty;
    }
    markClean(opts) {
        const { force: force = false, recursive: recursive = true } = opts != null ? opts : {};
        if (this._dirty === 0 /* NONE */  && !force) return;
        this._dirty = 0 /* NONE */ ;
        if (recursive !== false) for (const child of this._virtualChildren)child.markClean({
            force: force
        });
        if (recursive === true) for (const child of this._children)child.markClean({
            force: force
        });
    }
    onVisibleChange() {}
    get nodeCount() {
        let count = 1;
        let dirtyCount = this._dirty >= 0 /* NONE */  || this.dirtyTransform ? 1 : 0;
        let visibleCount = this.visible ? 1 : 0;
        const countChild = (child)=>{
            const { count: childCount, visibleCount: childVisibleCount, dirtyCount: childDirtyCount } = child.nodeCount;
            count += childCount;
            visibleCount += childVisibleCount;
            dirtyCount += childDirtyCount;
        };
        for (const child of this._children)countChild(child);
        for (const child of this._virtualChildren)countChild(child);
        return {
            count: count,
            visibleCount: visibleCount,
            dirtyCount: dirtyCount
        };
    }
    onZIndexChange() {
        if (this.parent) this.parent.dirtyZIndex = true;
    }
};
$d77b025aa58d633c$var$_Node._nextSerialNumber = 0;
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        type: "transform"
    })
], $d77b025aa58d633c$var$_Node.prototype, "scalingX", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        type: "transform"
    })
], $d77b025aa58d633c$var$_Node.prototype, "scalingY", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        type: "transform"
    })
], $d77b025aa58d633c$var$_Node.prototype, "scalingCenterX", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        type: "transform"
    })
], $d77b025aa58d633c$var$_Node.prototype, "scalingCenterY", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        type: "transform"
    })
], $d77b025aa58d633c$var$_Node.prototype, "rotationCenterX", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        type: "transform"
    })
], $d77b025aa58d633c$var$_Node.prototype, "rotationCenterY", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        type: "transform"
    })
], $d77b025aa58d633c$var$_Node.prototype, "rotation", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        type: "transform"
    })
], $d77b025aa58d633c$var$_Node.prototype, "translationX", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        type: "transform"
    })
], $d77b025aa58d633c$var$_Node.prototype, "translationY", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 3 /* MAJOR */ ,
        changeCb: (target)=>target.onVisibleChange()
    })
], $d77b025aa58d633c$var$_Node.prototype, "visible", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 1 /* TRIVIAL */ ,
        changeCb: (target)=>target.onZIndexChange()
    })
], $d77b025aa58d633c$var$_Node.prototype, "zIndex", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 1 /* TRIVIAL */ ,
        changeCb: (target)=>target.onZIndexChange()
    })
], $d77b025aa58d633c$var$_Node.prototype, "zIndexSubOrder", 2);
var $d77b025aa58d633c$var$Node = $d77b025aa58d633c$var$_Node;
// packages/ag-charts-community/src/util/color.ts
var $d77b025aa58d633c$var$srgbToLinear = (value)=>{
    const sign = value < 0 ? -1 : 1;
    const abs = Math.abs(value);
    if (abs <= 0.04045) return value / 12.92;
    return sign * $d77b025aa58d633c$var$__pow((abs + 0.055) / 1.055, 2.4);
};
var $d77b025aa58d633c$var$srgbFromLinear = (value)=>{
    const sign = value < 0 ? -1 : 1;
    const abs = Math.abs(value);
    if (abs > 31308e-7) return sign * (1.055 * $d77b025aa58d633c$var$__pow(abs, 1 / 2.4) - 0.055);
    return 12.92 * value;
};
var $d77b025aa58d633c$var$_Color = class _Color {
    /**
   * Every color component should be in the [0, 1] range.
   * Some easing functions (such as elastic easing) can overshoot the target value by some amount.
   * So, when animating colors, if the source or target color components are already near
   * or at the edge of the allowed [0, 1] range, it is possible for the intermediate color
   * component value to end up outside of that range mid-animation. For this reason the constructor
   * performs range checking/constraining.
   * @param r Red component.
   * @param g Green component.
   * @param b Blue component.
   * @param a Alpha (opacity) component.
   */ constructor(r, g, b, a = 1){
        this.r = $d77b025aa58d633c$var$clamp(0, r || 0, 1);
        this.g = $d77b025aa58d633c$var$clamp(0, g || 0, 1);
        this.b = $d77b025aa58d633c$var$clamp(0, b || 0, 1);
        this.a = $d77b025aa58d633c$var$clamp(0, a || 0, 1);
    }
    /**
   * A color string can be in one of the following formats to be valid:
   * - #rgb
   * - #rrggbb
   * - rgb(r, g, b)
   * - rgba(r, g, b, a)
   * - CSS color name such as 'white', 'orange', 'cyan', etc.
   */ static validColorString(str) {
        if (str.indexOf("#") >= 0) return !!_Color.parseHex(str);
        if (str.indexOf("rgb") >= 0) return !!_Color.stringToRgba(str);
        return !!_Color.nameToHex[str.toLowerCase()];
    }
    /**
   * The given string can be in one of the following formats:
   * - #rgb
   * - #rrggbb
   * - rgb(r, g, b)
   * - rgba(r, g, b, a)
   * - CSS color name such as 'white', 'orange', 'cyan', etc.
   * @param str
   */ static fromString(str) {
        if (str.indexOf("#") >= 0) return _Color.fromHexString(str);
        const hex = _Color.nameToHex[str.toLowerCase()];
        if (hex) return _Color.fromHexString(hex);
        if (str.indexOf("rgb") >= 0) return _Color.fromRgbaString(str);
        throw new Error(`Invalid color string: '${str}'`);
    }
    static tryParseFromString(str) {
        try {
            return _Color.fromString(str);
        } catch (e) {
            $d77b025aa58d633c$var$Logger.warnOnce(`invalid color string: '${str}'.`);
            return _Color.fromArray([
                0,
                0,
                0
            ]);
        }
    }
    // See https://drafts.csswg.org/css-color/#hex-notation
    static parseHex(input) {
        input = input.replace(/ /g, "").slice(1);
        let parts;
        switch(input.length){
            case 6:
            case 8:
                parts = [];
                for(let i = 0; i < input.length; i += 2)parts.push(parseInt(`${input[i]}${input[i + 1]}`, 16));
                break;
            case 3:
            case 4:
                parts = input.split("").map((p)=>parseInt(p, 16)).map((p)=>p + p * 16);
                break;
        }
        if ((parts == null ? void 0 : parts.length) >= 3 && parts.every((p)=>p >= 0)) {
            if (parts.length === 3) parts.push(255);
            return parts;
        }
    }
    static fromHexString(str) {
        const values = _Color.parseHex(str);
        if (values) {
            const [r, g, b, a] = values;
            return new _Color(r / 255, g / 255, b / 255, a / 255);
        }
        throw new Error(`Malformed hexadecimal color string: '${str}'`);
    }
    static stringToRgba(str) {
        let [po, pc] = [
            NaN,
            NaN
        ];
        for(let i = 0; i < str.length; i++){
            const c = str[i];
            if (!po && c === "(") po = i;
            else if (c === ")") {
                pc = i;
                break;
            }
        }
        const contents = po && pc && str.substring(po + 1, pc);
        if (!contents) return;
        const parts = contents.split(",");
        const rgba = [];
        for(let i = 0; i < parts.length; i++){
            const part = parts[i];
            let value = parseFloat(part);
            if (isNaN(value)) return;
            if (part.indexOf("%") >= 0) {
                value = $d77b025aa58d633c$var$clamp(0, value, 100);
                value /= 100;
            } else if (i === 3) value = $d77b025aa58d633c$var$clamp(0, value, 1);
            else {
                value = $d77b025aa58d633c$var$clamp(0, value, 255);
                value /= 255;
            }
            rgba.push(value);
        }
        return rgba;
    }
    static fromRgbaString(str) {
        const rgba = _Color.stringToRgba(str);
        if (rgba) {
            if (rgba.length === 3) return new _Color(rgba[0], rgba[1], rgba[2]);
            else if (rgba.length === 4) return new _Color(rgba[0], rgba[1], rgba[2], rgba[3]);
        }
        throw new Error(`Malformed rgb/rgba color string: '${str}'`);
    }
    static fromArray(arr) {
        if (arr.length === 4) return new _Color(arr[0], arr[1], arr[2], arr[3]);
        if (arr.length === 3) return new _Color(arr[0], arr[1], arr[2]);
        throw new Error("The given array should contain 3 or 4 color components (numbers).");
    }
    static fromHSB(h, s, b, alpha = 1) {
        const rgb = _Color.HSBtoRGB(h, s, b);
        return new _Color(rgb[0], rgb[1], rgb[2], alpha);
    }
    static fromHSL(h, s, l, alpha = 1) {
        const rgb = _Color.HSLtoRGB(h, s, l);
        return new _Color(rgb[0], rgb[1], rgb[2], alpha);
    }
    static fromOKLCH(l, c, h, alpha = 1) {
        const rgb = _Color.OKLCHtoRGB(l, c, h);
        return new _Color(rgb[0], rgb[1], rgb[2], alpha);
    }
    static padHex(str) {
        return str.length === 1 ? "0" + str : str;
    }
    toHexString() {
        let hex = "#" + _Color.padHex(Math.round(this.r * 255).toString(16)) + _Color.padHex(Math.round(this.g * 255).toString(16)) + _Color.padHex(Math.round(this.b * 255).toString(16));
        if (this.a < 1) hex += _Color.padHex(Math.round(this.a * 255).toString(16));
        return hex;
    }
    toRgbaString(fractionDigits = 3) {
        const components = [
            Math.round(this.r * 255),
            Math.round(this.g * 255),
            Math.round(this.b * 255)
        ];
        const k = Math.pow(10, fractionDigits);
        if (this.a !== 1) {
            components.push(Math.round(this.a * k) / k);
            return `rgba(${components.join(", ")})`;
        }
        return `rgb(${components.join(", ")})`;
    }
    toString() {
        if (this.a === 1) return this.toHexString();
        return this.toRgbaString();
    }
    toHSB() {
        return _Color.RGBtoHSB(this.r, this.g, this.b);
    }
    static RGBtoOKLCH(r, g, b) {
        const LSRGB0 = $d77b025aa58d633c$var$srgbToLinear(r);
        const LSRGB1 = $d77b025aa58d633c$var$srgbToLinear(g);
        const LSRGB2 = $d77b025aa58d633c$var$srgbToLinear(b);
        const LMS0 = Math.cbrt(0.4122214708 * LSRGB0 + 0.5363325363 * LSRGB1 + 0.0514459929 * LSRGB2);
        const LMS1 = Math.cbrt(0.2119034982 * LSRGB0 + 0.6806995451 * LSRGB1 + 0.1073969566 * LSRGB2);
        const LMS2 = Math.cbrt(0.0883024619 * LSRGB0 + 0.2817188376 * LSRGB1 + 0.6299787005 * LSRGB2);
        const OKLAB0 = 0.2104542553 * LMS0 + 0.793617785 * LMS1 - 0.0040720468 * LMS2;
        const OKLAB1 = 1.9779984951 * LMS0 - 2.428592205 * LMS1 + 0.4505937099 * LMS2;
        const OKLAB2 = 0.0259040371 * LMS0 + 0.7827717662 * LMS1 - 0.808675766 * LMS2;
        const hue = Math.atan2(OKLAB2, OKLAB1) * 180 / Math.PI;
        const OKLCH0 = OKLAB0;
        const OKLCH1 = Math.hypot(OKLAB1, OKLAB2);
        const OKLCH2 = hue >= 0 ? hue : hue + 360;
        return [
            OKLCH0,
            OKLCH1,
            OKLCH2
        ];
    }
    static OKLCHtoRGB(l, c, h) {
        const OKLAB0 = l;
        const OKLAB1 = c * Math.cos(h * Math.PI / 180);
        const OKLAB2 = c * Math.sin(h * Math.PI / 180);
        const LMS0 = $d77b025aa58d633c$var$__pow(OKLAB0 + 0.3963377774 * OKLAB1 + 0.2158037573 * OKLAB2, 3);
        const LMS1 = $d77b025aa58d633c$var$__pow(OKLAB0 - 0.1055613458 * OKLAB1 - 0.0638541728 * OKLAB2, 3);
        const LMS2 = $d77b025aa58d633c$var$__pow(OKLAB0 - 0.0894841775 * OKLAB1 - 1.291485548 * OKLAB2, 3);
        const LSRGB0 = 4.0767416621 * LMS0 - 3.3077115913 * LMS1 + 0.2309699292 * LMS2;
        const LSRGB1 = -1.2684380046 * LMS0 + 2.6097574011 * LMS1 - 0.3413193965 * LMS2;
        const LSRGB2 = -0.0041960863 * LMS0 - 0.7034186147 * LMS1 + 1.707614701 * LMS2;
        const SRGB0 = $d77b025aa58d633c$var$srgbFromLinear(LSRGB0);
        const SRGB1 = $d77b025aa58d633c$var$srgbFromLinear(LSRGB1);
        const SRGB2 = $d77b025aa58d633c$var$srgbFromLinear(LSRGB2);
        return [
            SRGB0,
            SRGB1,
            SRGB2
        ];
    }
    static RGBtoHSL(r, g, b) {
        const min = Math.min(r, g, b);
        const max = Math.max(r, g, b);
        const l = (max + min) / 2;
        let h;
        let s;
        if (max === min) {
            h = NaN;
            s = 0;
        } else {
            const delta2 = max - min;
            s = l > 0.5 ? delta2 / (2 - max - min) : delta2 / (max + min);
            if (max === r) h = (g - b) / delta2 + (g < b ? 6 : 0);
            else if (max === g) h = (b - r) / delta2 + 2;
            else h = (r - g) / delta2 + 4;
            h *= 60;
        }
        return [
            h,
            s,
            l
        ];
    }
    static HSLtoRGB(h, s, l) {
        if (s === 0) return [
            l,
            l,
            l
        ];
        const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        const p = 2 * l - q;
        function hueToRgb(t) {
            if (t < 0) t += 1;
            if (t > 1) t -= 1;
            if (t < 1 / 6) return p + (q - p) * 6 * t;
            if (t < 0.5) return q;
            if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
            return p;
        }
        const r = hueToRgb(h / 360 + 1 / 3);
        const g = hueToRgb(h / 360);
        const b = hueToRgb(h / 360 - 1 / 3);
        return [
            r,
            g,
            b
        ];
    }
    /**
   * Converts the given RGB triple to an array of HSB (HSV) components.
   * The hue component will be `NaN` for achromatic colors.
   */ static RGBtoHSB(r, g, b) {
        const min = Math.min(r, g, b);
        const max = Math.max(r, g, b);
        const S = max === 0 ? 0 : (max - min) / max;
        let H = NaN;
        if (min !== max) {
            const delta2 = max - min;
            const rc = (max - r) / delta2;
            const gc = (max - g) / delta2;
            const bc = (max - b) / delta2;
            if (r === max) H = bc - gc;
            else if (g === max) H = 2 + rc - bc;
            else H = 4 + gc - rc;
            H /= 6;
            if (H < 0) H = H + 1;
        }
        return [
            H * 360,
            S,
            max
        ];
    }
    /**
   * Converts the given HSB (HSV) triple to an array of RGB components.
   */ static HSBtoRGB(H, S, B) {
        if (isNaN(H)) H = 0;
        H = (H % 360 + 360) % 360 / 360;
        let r = 0;
        let g = 0;
        let b = 0;
        if (S === 0) r = g = b = B;
        else {
            const h = (H - Math.floor(H)) * 6;
            const f = h - Math.floor(h);
            const p = B * (1 - S);
            const q = B * (1 - S * f);
            const t = B * (1 - S * (1 - f));
            switch(h >> 0){
                case 0:
                    r = B;
                    g = t;
                    b = p;
                    break;
                case 1:
                    r = q;
                    g = B;
                    b = p;
                    break;
                case 2:
                    r = p;
                    g = B;
                    b = t;
                    break;
                case 3:
                    r = p;
                    g = q;
                    b = B;
                    break;
                case 4:
                    r = t;
                    g = p;
                    b = B;
                    break;
                case 5:
                    r = B;
                    g = p;
                    b = q;
                    break;
            }
        }
        return [
            r,
            g,
            b
        ];
    }
    derive(hueShift, saturationFactor, brightnessFactor, opacityFactor) {
        const hsb = _Color.RGBtoHSB(this.r, this.g, this.b);
        let b = hsb[2];
        if (b == 0 && brightnessFactor > 1) b = 0.05;
        const h = ((hsb[0] + hueShift) % 360 + 360) % 360;
        const s = $d77b025aa58d633c$var$clamp(0, hsb[1] * saturationFactor, 1);
        b = $d77b025aa58d633c$var$clamp(0, b * brightnessFactor, 1);
        const a = $d77b025aa58d633c$var$clamp(0, this.a * opacityFactor, 1);
        const rgba = _Color.HSBtoRGB(h, s, b);
        rgba.push(a);
        return _Color.fromArray(rgba);
    }
    brighter() {
        return this.derive(0, 1, 1 / 0.7, 1);
    }
    darker() {
        return this.derive(0, 1, 0.7, 1);
    }
    static interpolate(color, other) {
        const c0 = _Color.tryParseFromString(color);
        const c1 = _Color.tryParseFromString(other);
        return (t)=>{
            const i = (x, y)=>x * (1 - t) + y * t;
            const c = new _Color(i(c0.r, c1.r), i(c0.g, c1.g), i(c0.b, c1.b), i(c0.a, c1.a));
            return c.toString();
        };
    }
};
$d77b025aa58d633c$var$_Color.didDebug = false;
/**
 * CSS Color Module Level 4:
 * https://drafts.csswg.org/css-color/#named-colors
 */ $d77b025aa58d633c$var$_Color.nameToHex = Object.freeze({
    aliceblue: "#F0F8FF",
    antiquewhite: "#FAEBD7",
    aqua: "#00FFFF",
    aquamarine: "#7FFFD4",
    azure: "#F0FFFF",
    beige: "#F5F5DC",
    bisque: "#FFE4C4",
    black: "#000000",
    blanchedalmond: "#FFEBCD",
    blue: "#0000FF",
    blueviolet: "#8A2BE2",
    brown: "#A52A2A",
    burlywood: "#DEB887",
    cadetblue: "#5F9EA0",
    chartreuse: "#7FFF00",
    chocolate: "#D2691E",
    coral: "#FF7F50",
    cornflowerblue: "#6495ED",
    cornsilk: "#FFF8DC",
    crimson: "#DC143C",
    cyan: "#00FFFF",
    darkblue: "#00008B",
    darkcyan: "#008B8B",
    darkgoldenrod: "#B8860B",
    darkgray: "#A9A9A9",
    darkgreen: "#006400",
    darkgrey: "#A9A9A9",
    darkkhaki: "#BDB76B",
    darkmagenta: "#8B008B",
    darkolivegreen: "#556B2F",
    darkorange: "#FF8C00",
    darkorchid: "#9932CC",
    darkred: "#8B0000",
    darksalmon: "#E9967A",
    darkseagreen: "#8FBC8F",
    darkslateblue: "#483D8B",
    darkslategray: "#2F4F4F",
    darkslategrey: "#2F4F4F",
    darkturquoise: "#00CED1",
    darkviolet: "#9400D3",
    deeppink: "#FF1493",
    deepskyblue: "#00BFFF",
    dimgray: "#696969",
    dimgrey: "#696969",
    dodgerblue: "#1E90FF",
    firebrick: "#B22222",
    floralwhite: "#FFFAF0",
    forestgreen: "#228B22",
    fuchsia: "#FF00FF",
    gainsboro: "#DCDCDC",
    ghostwhite: "#F8F8FF",
    gold: "#FFD700",
    goldenrod: "#DAA520",
    gray: "#808080",
    green: "#008000",
    greenyellow: "#ADFF2F",
    grey: "#808080",
    honeydew: "#F0FFF0",
    hotpink: "#FF69B4",
    indianred: "#CD5C5C",
    indigo: "#4B0082",
    ivory: "#FFFFF0",
    khaki: "#F0E68C",
    lavender: "#E6E6FA",
    lavenderblush: "#FFF0F5",
    lawngreen: "#7CFC00",
    lemonchiffon: "#FFFACD",
    lightblue: "#ADD8E6",
    lightcoral: "#F08080",
    lightcyan: "#E0FFFF",
    lightgoldenrodyellow: "#FAFAD2",
    lightgray: "#D3D3D3",
    lightgreen: "#90EE90",
    lightgrey: "#D3D3D3",
    lightpink: "#FFB6C1",
    lightsalmon: "#FFA07A",
    lightseagreen: "#20B2AA",
    lightskyblue: "#87CEFA",
    lightslategray: "#778899",
    lightslategrey: "#778899",
    lightsteelblue: "#B0C4DE",
    lightyellow: "#FFFFE0",
    lime: "#00FF00",
    limegreen: "#32CD32",
    linen: "#FAF0E6",
    magenta: "#FF00FF",
    maroon: "#800000",
    mediumaquamarine: "#66CDAA",
    mediumblue: "#0000CD",
    mediumorchid: "#BA55D3",
    mediumpurple: "#9370DB",
    mediumseagreen: "#3CB371",
    mediumslateblue: "#7B68EE",
    mediumspringgreen: "#00FA9A",
    mediumturquoise: "#48D1CC",
    mediumvioletred: "#C71585",
    midnightblue: "#191970",
    mintcream: "#F5FFFA",
    mistyrose: "#FFE4E1",
    moccasin: "#FFE4B5",
    navajowhite: "#FFDEAD",
    navy: "#000080",
    oldlace: "#FDF5E6",
    olive: "#808000",
    olivedrab: "#6B8E23",
    orange: "#FFA500",
    orangered: "#FF4500",
    orchid: "#DA70D6",
    palegoldenrod: "#EEE8AA",
    palegreen: "#98FB98",
    paleturquoise: "#AFEEEE",
    palevioletred: "#DB7093",
    papayawhip: "#FFEFD5",
    peachpuff: "#FFDAB9",
    peru: "#CD853F",
    pink: "#FFC0CB",
    plum: "#DDA0DD",
    powderblue: "#B0E0E6",
    purple: "#800080",
    rebeccapurple: "#663399",
    red: "#FF0000",
    rosybrown: "#BC8F8F",
    royalblue: "#4169E1",
    saddlebrown: "#8B4513",
    salmon: "#FA8072",
    sandybrown: "#F4A460",
    seagreen: "#2E8B57",
    seashell: "#FFF5EE",
    sienna: "#A0522D",
    silver: "#C0C0C0",
    skyblue: "#87CEEB",
    slateblue: "#6A5ACD",
    slategray: "#708090",
    slategrey: "#708090",
    snow: "#FFFAFA",
    springgreen: "#00FF7F",
    steelblue: "#4682B4",
    tan: "#D2B48C",
    teal: "#008080",
    thistle: "#D8BFD8",
    tomato: "#FF6347",
    transparent: "#00000000",
    turquoise: "#40E0D0",
    violet: "#EE82EE",
    wheat: "#F5DEB3",
    white: "#FFFFFF",
    whitesmoke: "#F5F5F5",
    yellow: "#FFFF00",
    yellowgreen: "#9ACD32"
});
var $d77b025aa58d633c$var$Color = $d77b025aa58d633c$var$_Color;
// packages/ag-charts-community/src/util/interpolate.ts
function $d77b025aa58d633c$var$interpolateNumber(a, b) {
    return (d)=>Number(a) * (1 - d) + Number(b) * d;
}
function $d77b025aa58d633c$var$interpolateColor(a, b) {
    if (typeof a === "string") try {
        a = $d77b025aa58d633c$var$Color.fromString(a);
    } catch (e) {
        a = $d77b025aa58d633c$var$Color.fromArray([
            0,
            0,
            0
        ]);
    }
    if (typeof b === "string") try {
        b = $d77b025aa58d633c$var$Color.fromString(b);
    } catch (e) {
        b = $d77b025aa58d633c$var$Color.fromArray([
            0,
            0,
            0
        ]);
    }
    const red = $d77b025aa58d633c$var$interpolateNumber(a.r, b.r);
    const green = $d77b025aa58d633c$var$interpolateNumber(a.g, b.g);
    const blue = $d77b025aa58d633c$var$interpolateNumber(a.b, b.b);
    const alpha = $d77b025aa58d633c$var$interpolateNumber(a.a, b.a);
    return (d)=>$d77b025aa58d633c$var$Color.fromArray([
            red(d),
            green(d),
            blue(d),
            alpha(d)
        ]).toRgbaString();
}
// packages/ag-charts-community/src/motion/easing.ts
var $d77b025aa58d633c$var$easing_exports = {};
$d77b025aa58d633c$var$__export($d77b025aa58d633c$var$easing_exports, {
    easeIn: ()=>$d77b025aa58d633c$var$easeIn,
    easeInOut: ()=>$d77b025aa58d633c$var$easeInOut,
    easeInOutQuad: ()=>$d77b025aa58d633c$var$easeInOutQuad,
    easeInQuad: ()=>$d77b025aa58d633c$var$easeInQuad,
    easeOut: ()=>$d77b025aa58d633c$var$easeOut,
    easeOutQuad: ()=>$d77b025aa58d633c$var$easeOutQuad,
    inverseEaseOut: ()=>$d77b025aa58d633c$var$inverseEaseOut,
    linear: ()=>$d77b025aa58d633c$var$linear
});
var $d77b025aa58d633c$var$linear = (n)=>n;
var $d77b025aa58d633c$var$easeIn = (n)=>1 - Math.cos(n * Math.PI / 2);
var $d77b025aa58d633c$var$easeOut = (n)=>Math.sin(n * Math.PI / 2);
var $d77b025aa58d633c$var$easeInOut = (n)=>-(Math.cos(n * Math.PI) - 1) / 2;
var $d77b025aa58d633c$var$easeInQuad = (n)=>n * n;
var $d77b025aa58d633c$var$easeOutQuad = (n)=>1 - $d77b025aa58d633c$var$__pow(1 - n, 2);
var $d77b025aa58d633c$var$easeInOutQuad = (n)=>n < 0.5 ? 2 * n * n : 1 - $d77b025aa58d633c$var$__pow(-2 * n + 2, 2) / 2;
var $d77b025aa58d633c$var$inverseEaseOut = (x)=>2 * Math.asin(x) / Math.PI;
// packages/ag-charts-community/src/motion/animation.ts
var $d77b025aa58d633c$var$QUICK_TRANSITION = 0.2;
var $d77b025aa58d633c$var$PHASE_ORDER = [
    "initial",
    "remove",
    "update",
    "add",
    "trailing",
    "end",
    "none"
];
var $d77b025aa58d633c$var$PHASE_METADATA = {
    initial: {
        animationDuration: 1,
        animationDelay: 0
    },
    add: {
        animationDuration: 0.25,
        animationDelay: 0.75
    },
    remove: {
        animationDuration: 0.25,
        animationDelay: 0
    },
    update: {
        animationDuration: 0.5,
        animationDelay: 0.25
    },
    trailing: {
        animationDuration: $d77b025aa58d633c$var$QUICK_TRANSITION,
        animationDelay: 1,
        skipIfNoEarlierAnimations: true
    },
    end: {
        animationDelay: 1 + $d77b025aa58d633c$var$QUICK_TRANSITION,
        animationDuration: 0,
        skipIfNoEarlierAnimations: true
    },
    none: {
        animationDuration: 0,
        animationDelay: 0
    }
};
var $d77b025aa58d633c$var$RepeatType = /* @__PURE__ */ ((RepeatType2)=>{
    RepeatType2["Loop"] = "loop";
    RepeatType2["Reverse"] = "reverse";
    return RepeatType2;
})($d77b025aa58d633c$var$RepeatType || {});
function $d77b025aa58d633c$var$isNodeArray(array) {
    return array.every((n)=>n instanceof $d77b025aa58d633c$var$Node);
}
function $d77b025aa58d633c$var$deconstructSelectionsOrNodes(selectionsOrNodes) {
    return $d77b025aa58d633c$var$isNodeArray(selectionsOrNodes) ? {
        nodes: selectionsOrNodes,
        selections: []
    } : {
        nodes: [],
        selections: selectionsOrNodes
    };
}
var $d77b025aa58d633c$var$Animation = class {
    constructor(opts){
        this.isComplete = false;
        this.elapsed = 0;
        this.iteration = 0;
        this.isPlaying = false;
        this.isReverse = false;
        var _a, _b, _c, _d, _e, _f, _g;
        this.id = opts.id;
        this.groupId = opts.groupId;
        this.autoplay = (_a = opts.autoplay) != null ? _a : true;
        this.ease = (_b = opts.ease) != null ? _b : $d77b025aa58d633c$var$linear;
        this.phase = opts.phase;
        const durationProportion = (_c = opts.duration) != null ? _c : $d77b025aa58d633c$var$PHASE_METADATA[this.phase].animationDuration;
        this.duration = durationProportion * opts.defaultDuration;
        this.delay = ((_d = opts.delay) != null ? _d : 0) * opts.defaultDuration;
        this.onComplete = opts.onComplete;
        this.onPlay = opts.onPlay;
        this.onStop = opts.onStop;
        this.onUpdate = opts.onUpdate;
        this.interpolate = this.createInterpolator(opts.from, opts.to);
        this.from = opts.from;
        if (opts.skip === true) {
            (_e = this.onUpdate) == null || _e.call(this, opts.to, false, this);
            (_f = this.onStop) == null || _f.call(this, this);
            (_g = this.onComplete) == null || _g.call(this, this);
            this.isComplete = true;
        }
        if (opts.collapsable !== false) this.duration = this.checkCollapse(opts, this.duration);
    }
    checkCollapse(opts, calculatedDuration) {
        if (opts.from === opts.to) return 0;
        const diff2 = typeof opts.from === "object" ? $d77b025aa58d633c$var$jsonDiff(opts.from, opts.to) : null;
        if (diff2) return calculatedDuration;
        return 0;
    }
    play(initialUpdate = false) {
        var _a, _b;
        if (this.isPlaying || this.isComplete) return;
        this.isPlaying = true;
        (_a = this.onPlay) == null || _a.call(this, this);
        if (!this.autoplay) return;
        this.autoplay = false;
        if (!initialUpdate) return;
        (_b = this.onUpdate) == null || _b.call(this, this.from, true, this);
    }
    pause() {
        this.isPlaying = false;
    }
    stop() {
        var _a;
        this.isPlaying = false;
        if (!this.isComplete) {
            this.isComplete = true;
            (_a = this.onStop) == null || _a.call(this, this);
        }
    }
    update(time2) {
        var _a, _b;
        if (this.isComplete) return time2;
        if (!this.isPlaying && this.autoplay) this.play(true);
        const previousElapsed = this.elapsed;
        this.elapsed += time2;
        if (this.delay > this.elapsed) return 0;
        const value = this.interpolate(this.isReverse ? 1 - this.delta : this.delta);
        (_a = this.onUpdate) == null || _a.call(this, value, false, this);
        const totalDuration = this.delay + this.duration;
        if (this.elapsed >= totalDuration) {
            this.stop();
            this.isComplete = true;
            (_b = this.onComplete) == null || _b.call(this, this);
            return time2 - (totalDuration - previousElapsed);
        }
        return 0;
    }
    get delta() {
        return this.ease($d77b025aa58d633c$var$clamp(0, (this.elapsed - this.delay) / this.duration, 1));
    }
    createInterpolator(from, to) {
        if (typeof to !== "object" || $d77b025aa58d633c$var$isInterpolating(to)) return this.interpolateValue(from, to);
        const interpolatorEntries = [];
        for(const key in to){
            const interpolator = this.interpolateValue(from[key], to[key]);
            if (interpolator != null) interpolatorEntries.push([
                key,
                interpolator
            ]);
        }
        return (d)=>{
            const result = {};
            for (const [key, interpolator] of interpolatorEntries)result[key] = interpolator(d);
            return result;
        };
    }
    interpolateValue(a, b) {
        if (a === void 0 || b === void 0) return;
        else if ($d77b025aa58d633c$var$isInterpolating(a)) return (d)=>a[$d77b025aa58d633c$var$interpolate](b, d);
        try {
            switch(typeof a){
                case "number":
                    return $d77b025aa58d633c$var$interpolateNumber(a, b);
                case "string":
                    return $d77b025aa58d633c$var$interpolateColor(a, b);
                case "boolean":
                    if (a === b) return ()=>a;
                    break;
            }
        } catch (e) {}
        throw new Error(`Unable to interpolate values: ${a}, ${b}`);
    }
};
// packages/ag-charts-community/src/motion/fromToMotion.ts
var $d77b025aa58d633c$var$NODE_UPDATE_STATE_TO_PHASE_MAPPING = {
    added: "add",
    updated: "update",
    removed: "remove",
    unknown: "initial",
    "no-op": "none"
};
function $d77b025aa58d633c$var$fromToMotion(groupId, subId, animationManager, selectionsOrNodes, fns, getDatumId, diff2) {
    const { fromFn: fromFn, toFn: toFn, intermediateFn: intermediateFn } = fns;
    const { nodes: nodes, selections: selections } = $d77b025aa58d633c$var$deconstructSelectionsOrNodes(selectionsOrNodes);
    const processNodes = (liveNodes, subNodes)=>{
        var _c;
        let prevFromProps;
        let liveNodeIndex = 0;
        let nodeIndex = 0;
        for (const node of subNodes){
            const isLive = liveNodes[liveNodeIndex] === node;
            const ctx = {
                last: nodeIndex >= subNodes.length - 1,
                lastLive: liveNodeIndex >= liveNodes.length - 1,
                prev: subNodes[nodeIndex - 1],
                prevFromProps: prevFromProps,
                prevLive: liveNodes[liveNodeIndex - 1],
                next: subNodes[nodeIndex + 1],
                nextLive: liveNodes[liveNodeIndex + (isLive ? 1 : 0)]
            };
            const animationId = `${groupId}_${subId}_${node.id}`;
            animationManager.stopByAnimationId(animationId);
            let status = "unknown";
            if (!isLive) status = "removed";
            else if (getDatumId && diff2) status = $d77b025aa58d633c$var$calculateStatus(node, node.datum, getDatumId, diff2);
            const _a = fromFn(node, node.datum, status, ctx), { phase: phase, start: start, finish: finish, delay: delay, duration: duration } = _a, from = $d77b025aa58d633c$var$__objRest(_a, [
                "phase",
                "start",
                "finish",
                "delay",
                "duration"
            ]);
            const _b = toFn(node, node.datum, status, ctx), { phase: toPhase, start: toStart, finish: toFinish, delay: toDelay, duration: toDuration } = _b, to = $d77b025aa58d633c$var$__objRest(_b, [
                "phase",
                "start",
                "finish",
                "delay",
                "duration"
            ]);
            const collapsable = finish == null && toFinish == null;
            animationManager.animate({
                id: animationId,
                groupId: groupId,
                phase: (_c = phase != null ? phase : toPhase) != null ? _c : "update",
                duration: duration != null ? duration : toDuration,
                delay: delay != null ? delay : toDelay,
                from: from,
                to: to,
                ease: $d77b025aa58d633c$var$easeOut,
                collapsable: collapsable,
                onPlay: ()=>{
                    node.setProperties($d77b025aa58d633c$var$__spreadValues($d77b025aa58d633c$var$__spreadValues({}, start), toStart));
                },
                onUpdate (props) {
                    node.setProperties(props);
                    if (intermediateFn) node.setProperties(intermediateFn(node, node.datum, status, ctx));
                },
                onStop: ()=>{
                    node.setProperties($d77b025aa58d633c$var$__spreadValues($d77b025aa58d633c$var$__spreadValues($d77b025aa58d633c$var$__spreadValues($d77b025aa58d633c$var$__spreadValues($d77b025aa58d633c$var$__spreadValues($d77b025aa58d633c$var$__spreadValues({}, start), toStart), from), to), finish), toFinish));
                }
            });
            if (isLive) liveNodeIndex++;
            nodeIndex++;
            prevFromProps = from;
        }
    };
    let selectionIndex = 0;
    for (const selection of selections){
        const selectionNodes = selection.nodes();
        const liveNodes = selectionNodes.filter((n)=>!selection.isGarbage(n));
        processNodes(liveNodes, selectionNodes);
        animationManager.animate({
            id: `${groupId}_${subId}_selection_${selectionIndex}`,
            groupId: groupId,
            phase: "end",
            from: 0,
            to: 1,
            ease: $d77b025aa58d633c$var$easeOut,
            onStop () {
                selection.cleanup();
            }
        });
        selectionIndex++;
    }
    processNodes(nodes, nodes);
}
function $d77b025aa58d633c$var$staticFromToMotion(groupId, subId, animationManager, selectionsOrNodes, from, to, extraOpts) {
    const { nodes: nodes, selections: selections } = $d77b025aa58d633c$var$deconstructSelectionsOrNodes(selectionsOrNodes);
    const { start: start, finish: finish, phase: phase } = extraOpts;
    const collapsable = finish == null;
    animationManager.animate({
        id: `${groupId}_${subId}`,
        groupId: groupId,
        phase: phase != null ? phase : "update",
        from: from,
        to: to,
        ease: $d77b025aa58d633c$var$easeOut,
        collapsable: collapsable,
        onPlay: ()=>{
            if (!start) return;
            for (const node of nodes)node.setProperties(start);
            for (const selection of selections)for (const node of selection.nodes())node.setProperties(start);
        },
        onUpdate (props) {
            for (const node of nodes)node.setProperties(props);
            for (const selection of selections)for (const node of selection.nodes())node.setProperties(props);
        },
        onStop: ()=>{
            for (const node of nodes)node.setProperties($d77b025aa58d633c$var$__spreadValues($d77b025aa58d633c$var$__spreadValues({}, to), finish));
            for (const selection of selections)for (const node of selection.nodes())node.setProperties($d77b025aa58d633c$var$__spreadValues($d77b025aa58d633c$var$__spreadValues({}, to), finish));
        }
    });
}
function $d77b025aa58d633c$var$calculateStatus(node, datum, getDatumId, diff2) {
    const id = getDatumId(node, datum);
    if (diff2.added.has(id)) return "added";
    if (diff2.removed.has(id)) return "removed";
    return "updated";
}
// packages/ag-charts-community/src/util/angle.ts
var $d77b025aa58d633c$var$twoPi = Math.PI * 2;
function $d77b025aa58d633c$var$normalizeAngle360(radians) {
    radians %= $d77b025aa58d633c$var$twoPi;
    radians += $d77b025aa58d633c$var$twoPi;
    radians %= $d77b025aa58d633c$var$twoPi;
    return radians;
}
function $d77b025aa58d633c$var$normalizeAngle360Inclusive(radians) {
    radians %= $d77b025aa58d633c$var$twoPi;
    radians += $d77b025aa58d633c$var$twoPi;
    if (radians !== $d77b025aa58d633c$var$twoPi) radians %= $d77b025aa58d633c$var$twoPi;
    return radians;
}
function $d77b025aa58d633c$var$normalizeAngle180(radians) {
    radians %= $d77b025aa58d633c$var$twoPi;
    if (radians < -Math.PI) radians += $d77b025aa58d633c$var$twoPi;
    else if (radians >= Math.PI) radians -= $d77b025aa58d633c$var$twoPi;
    return radians;
}
function $d77b025aa58d633c$var$isBetweenAngles(targetAngle, startAngle, endAngle) {
    const t = $d77b025aa58d633c$var$normalizeAngle360(targetAngle);
    const a0 = $d77b025aa58d633c$var$normalizeAngle360(startAngle);
    const a1 = $d77b025aa58d633c$var$normalizeAngle360Inclusive(endAngle);
    if (a0 <= a1) return a0 <= t && t <= a1;
    else return a0 <= t || t <= a1;
}
function $d77b025aa58d633c$var$toRadians(degrees) {
    return degrees / 180 * Math.PI;
}
function $d77b025aa58d633c$var$toDegrees(radians) {
    return radians / Math.PI * 180;
}
function $d77b025aa58d633c$var$angleBetween(angle0, angle1) {
    angle0 = $d77b025aa58d633c$var$normalizeAngle360(angle0);
    angle1 = $d77b025aa58d633c$var$normalizeAngle360(angle1);
    return angle1 - angle0 + (angle0 > angle1 ? 2 * Math.PI : 0);
}
function $d77b025aa58d633c$var$displacePointFromVector(centerX, centerY, radius, angle) {
    const x = centerX + radius * Math.cos(angle);
    const y = centerY + radius * Math.sin(angle);
    return {
        x: x,
        y: y
    };
}
// packages/ag-charts-community/src/scale/invalidating.ts
var $d77b025aa58d633c$var$Invalidating = (target, propertyKey)=>{
    const mappedProperty = Symbol(String(propertyKey));
    target[mappedProperty] = void 0;
    Object.defineProperty(target, propertyKey, {
        get () {
            return this[mappedProperty];
        },
        set (newValue) {
            const oldValue = this[mappedProperty];
            if (oldValue !== newValue) {
                this[mappedProperty] = newValue;
                this.invalid = true;
            }
        },
        enumerable: true,
        configurable: false
    });
};
// packages/ag-charts-community/src/scale/bandScale.ts
var $d77b025aa58d633c$var$_BandScale = class _BandScale {
    constructor(){
        this.type = "band";
        this.invalid = true;
        this.interval = void 0;
        /**
     * Maps datum to its index in the {@link domain} array.
     * Used to check for duplicate datums (not allowed).
     */ this.index = /* @__PURE__ */ new Map();
        /**
     * The output range values for datum at each index.
     */ this.ordinalRange = [];
        /**
     * Contains unique datums only. Since `{}` is used in place of `Map`
     * for IE11 compatibility, the datums are converted `toString` before
     * the uniqueness check.
     */ this._domain = [];
        this.range = [
            0,
            1
        ];
        this._bandwidth = 1;
        this._step = 1;
        this._rawBandwidth = 1;
        /**
     * The ratio of the range that is reserved for space between bands.
     */ this._paddingInner = 0;
        /**
     * The ratio of the range that is reserved for space before the first
     * and after the last band.
     */ this._paddingOuter = 0;
        this.round = false;
    }
    static is(value) {
        return value instanceof _BandScale;
    }
    refresh() {
        if (!this.invalid) return;
        this.invalid = false;
        this.update();
        if (this.invalid) $d77b025aa58d633c$var$Logger.warnOnce("Expected update to not invalidate scale");
    }
    set domain(values) {
        this.invalid = true;
        const domain = [];
        this.index = /* @__PURE__ */ new Map();
        const index = this.index;
        values.forEach((value)=>{
            if (this.getIndex(value) === void 0) index.set(value, domain.push(value) - 1);
        });
        this._domain = domain;
    }
    get domain() {
        return this._domain;
    }
    ticks() {
        this.refresh();
        let { interval: interval = 1 } = this;
        if (typeof interval !== "number") interval = Number(interval);
        const step = Math.abs(Math.round(interval));
        return this._domain.filter((_, i)=>i % step === 0);
    }
    convert(d) {
        this.refresh();
        const i = this.getIndex(d);
        if (i === void 0) return NaN;
        const r = this.ordinalRange[i];
        if (r === void 0) return NaN;
        return r;
    }
    invert(position) {
        this.refresh();
        const index = this.ordinalRange.findIndex((p)=>p === position);
        return this.domain[index];
    }
    invertNearest(position) {
        var _a;
        this.refresh();
        let nearest = -1;
        let minDistance = Infinity;
        const index = this.ordinalRange.findIndex((p, i)=>{
            if (p === position) return true;
            const distance2 = Math.abs(position - p);
            if (distance2 < minDistance) {
                minDistance = distance2;
                nearest = i;
            }
            return false;
        });
        return (_a = this.domain[index]) != null ? _a : this.domain[nearest];
    }
    get bandwidth() {
        this.refresh();
        return this._bandwidth;
    }
    get step() {
        this.refresh();
        return this._step;
    }
    get rawBandwidth() {
        this.refresh();
        return this._rawBandwidth;
    }
    set padding(value) {
        value = $d77b025aa58d633c$var$clamp(0, value, 1);
        this._paddingInner = value;
        this._paddingOuter = value;
    }
    get padding() {
        return this._paddingInner;
    }
    set paddingInner(value) {
        this._paddingInner = $d77b025aa58d633c$var$clamp(0, value, 1);
    }
    get paddingInner() {
        return this._paddingInner;
    }
    set paddingOuter(value) {
        this._paddingOuter = $d77b025aa58d633c$var$clamp(0, value, 1);
    }
    get paddingOuter() {
        return this._paddingOuter;
    }
    update() {
        const count = this._domain.length;
        if (count === 0) return;
        const round3 = this.round;
        const paddingInner = this._paddingInner;
        const paddingOuter = this._paddingOuter;
        const [r0, r1] = this.range;
        const width = r1 - r0;
        const rawStep = width / Math.max(1, count + 2 * paddingOuter - paddingInner);
        const step = round3 ? Math.floor(rawStep) : rawStep;
        const fullBandWidth = step * (count - paddingInner);
        const x0 = r0 + (width - fullBandWidth) / 2;
        const start = round3 ? Math.round(x0) : x0;
        const bw = step * (1 - paddingInner);
        const bandwidth = round3 ? Math.round(bw) : bw;
        const rawBandwidth = rawStep * (1 - paddingInner);
        const values = [];
        for(let i = 0; i < count; i++)values.push(start + step * i);
        this._bandwidth = bandwidth;
        this._rawBandwidth = rawBandwidth;
        this._step = step;
        this.ordinalRange = values;
    }
    getIndex(value) {
        if (!(value instanceof Date)) return this.index.get(value);
        const valueOf = value.valueOf();
        let index = 0;
        for (const key of this.index.keys()){
            if (key instanceof Date && key.valueOf() === valueOf) return index;
            index++;
        }
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Invalidating
], $d77b025aa58d633c$var$_BandScale.prototype, "interval", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Invalidating
], $d77b025aa58d633c$var$_BandScale.prototype, "range", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Invalidating
], $d77b025aa58d633c$var$_BandScale.prototype, "round", 2);
var $d77b025aa58d633c$var$BandScale = $d77b025aa58d633c$var$_BandScale;
// packages/ag-charts-community/src/util/default.ts
function $d77b025aa58d633c$var$Default(defaultValue, replaces = [
    void 0
]) {
    return $d77b025aa58d633c$var$addTransformToInstanceProperty((_, __, v)=>{
        if (replaces.includes(v)) return $d77b025aa58d633c$var$isFunction(defaultValue) ? defaultValue(v) : defaultValue;
        return v;
    });
}
// packages/ag-charts-community/src/util/validation.ts
function $d77b025aa58d633c$var$Validate(predicate, options = {}) {
    const { optional: optional = false, property: overrideProperty } = options;
    return $d77b025aa58d633c$var$addTransformToInstanceProperty((target, property, value)=>{
        var _a;
        const context = $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, options), {
            target: target,
            property: property
        });
        if (optional && typeof value === "undefined" || predicate(value, context)) {
            if ($d77b025aa58d633c$var$isProperties(target[property]) && !$d77b025aa58d633c$var$isProperties(value)) {
                target[property].set(value);
                return target[property];
            }
            return value;
        }
        const cleanKey = overrideProperty != null ? overrideProperty : String(property).replace(/^_*/, "");
        const targetName = (_a = target.constructor.className) != null ? _a : target.constructor.name.replace(/Properties$/, "");
        let valueString = $d77b025aa58d633c$var$stringify(value);
        const maxLength = 50;
        if (valueString != null && valueString.length > maxLength) {
            const excessCharacters = valueString.length - maxLength;
            valueString = valueString.slice(0, maxLength) + `... (+${excessCharacters} characters)`;
        }
        $d77b025aa58d633c$var$Logger.warn(`Property [${cleanKey}] of [${targetName}] cannot be set to [${valueString}]${predicate.message ? `; expecting ${$d77b025aa58d633c$var$getPredicateMessage(predicate, context)}` : ""}, ignoring.`);
        return $d77b025aa58d633c$var$BREAK_TRANSFORM_CHAIN;
    }, void 0, {
        optional: optional
    });
}
var $d77b025aa58d633c$var$AND = (...predicates)=>{
    const messages = [];
    return $d77b025aa58d633c$var$predicateWithMessage((value, ctx)=>{
        messages.length = 0;
        return predicates.every((predicate)=>{
            const isValid = predicate(value, ctx);
            if (!isValid) messages.push($d77b025aa58d633c$var$getPredicateMessage(predicate, ctx));
            return isValid;
        });
    }, ()=>messages.filter(Boolean).join(" AND "));
};
var $d77b025aa58d633c$var$OR = (...predicates)=>$d77b025aa58d633c$var$predicateWithMessage((value, ctx)=>predicates.some((predicate)=>predicate(value, ctx)), (ctx)=>predicates.map($d77b025aa58d633c$var$getPredicateMessageMapper(ctx)).filter(Boolean).join(" OR "));
var $d77b025aa58d633c$var$OBJECT = $d77b025aa58d633c$var$attachObjectRestrictions($d77b025aa58d633c$var$predicateWithMessage((value, ctx)=>$d77b025aa58d633c$var$isProperties(value) || $d77b025aa58d633c$var$isObject(value) && $d77b025aa58d633c$var$isProperties(ctx.target[ctx.property]), "a properties object"));
var $d77b025aa58d633c$var$PLAIN_OBJECT = $d77b025aa58d633c$var$attachObjectRestrictions($d77b025aa58d633c$var$predicateWithMessage((value)=>$d77b025aa58d633c$var$isObject(value), "an object"));
var $d77b025aa58d633c$var$BOOLEAN = $d77b025aa58d633c$var$predicateWithMessage($d77b025aa58d633c$var$isBoolean, "a boolean");
var $d77b025aa58d633c$var$FUNCTION = $d77b025aa58d633c$var$predicateWithMessage($d77b025aa58d633c$var$isFunction, "a function");
var $d77b025aa58d633c$var$STRING = $d77b025aa58d633c$var$predicateWithMessage($d77b025aa58d633c$var$isString, "a string");
var $d77b025aa58d633c$var$NUMBER = $d77b025aa58d633c$var$attachNumberRestrictions($d77b025aa58d633c$var$predicateWithMessage($d77b025aa58d633c$var$isFiniteNumber, "a number"));
var $d77b025aa58d633c$var$NAN = $d77b025aa58d633c$var$predicateWithMessage((value)=>$d77b025aa58d633c$var$isNumber(value) && isNaN(value), "NaN");
var $d77b025aa58d633c$var$POSITIVE_NUMBER = $d77b025aa58d633c$var$NUMBER.restrict({
    min: 0
});
var $d77b025aa58d633c$var$RATIO = $d77b025aa58d633c$var$NUMBER.restrict({
    min: 0,
    max: 1
});
var $d77b025aa58d633c$var$DEGREE = $d77b025aa58d633c$var$NUMBER.restrict({
    min: -360,
    max: 360
});
var $d77b025aa58d633c$var$NUMBER_OR_NAN = $d77b025aa58d633c$var$OR($d77b025aa58d633c$var$NUMBER, $d77b025aa58d633c$var$NAN);
var $d77b025aa58d633c$var$ARRAY = $d77b025aa58d633c$var$attachArrayRestrictions($d77b025aa58d633c$var$predicateWithMessage($d77b025aa58d633c$var$isArray, "an array"));
var $d77b025aa58d633c$var$ARRAY_OF = (predicate, message)=>$d77b025aa58d633c$var$predicateWithMessage((value, ctx)=>$d77b025aa58d633c$var$isArray(value) && value.every((item)=>predicate(item, ctx)), (ctx)=>{
        var _a;
        const arrayMessage = (_a = $d77b025aa58d633c$var$getPredicateMessage($d77b025aa58d633c$var$ARRAY, ctx)) != null ? _a : "";
        return message ? `${arrayMessage} of ${message}` : arrayMessage;
    });
var $d77b025aa58d633c$var$isComparable = (value)=>$d77b025aa58d633c$var$isFiniteNumber(value) || $d77b025aa58d633c$var$isValidDate(value);
var $d77b025aa58d633c$var$LESS_THAN = (otherField)=>$d77b025aa58d633c$var$predicateWithMessage((v, ctx)=>!$d77b025aa58d633c$var$isComparable(v) || !$d77b025aa58d633c$var$isComparable(ctx.target[otherField]) || v < ctx.target[otherField], `to be less than ${otherField}`);
var $d77b025aa58d633c$var$GREATER_THAN = (otherField)=>$d77b025aa58d633c$var$predicateWithMessage((v, ctx)=>!$d77b025aa58d633c$var$isComparable(v) || !$d77b025aa58d633c$var$isComparable(ctx.target[otherField]) || v > ctx.target[otherField], `to be greater than ${otherField}`);
var $d77b025aa58d633c$var$DATE = $d77b025aa58d633c$var$predicateWithMessage($d77b025aa58d633c$var$isValidDate, "Date object");
var $d77b025aa58d633c$var$DATE_OR_DATETIME_MS = $d77b025aa58d633c$var$OR($d77b025aa58d633c$var$DATE, $d77b025aa58d633c$var$POSITIVE_NUMBER);
var $d77b025aa58d633c$var$colorMessage = `A color string can be in one of the following formats to be valid: #rgb, #rrggbb, rgb(r, g, b), rgba(r, g, b, a) or a CSS color name such as 'white', 'orange', 'cyan', etc`;
var $d77b025aa58d633c$var$COLOR_STRING = $d77b025aa58d633c$var$predicateWithMessage((v)=>$d77b025aa58d633c$var$isString(v) && $d77b025aa58d633c$var$Color.validColorString(v), `color String. ${$d77b025aa58d633c$var$colorMessage}`);
var $d77b025aa58d633c$var$COLOR_STRING_ARRAY = $d77b025aa58d633c$var$predicateWithMessage($d77b025aa58d633c$var$ARRAY_OF($d77b025aa58d633c$var$COLOR_STRING), `color strings. ${$d77b025aa58d633c$var$colorMessage}`);
var $d77b025aa58d633c$var$BOOLEAN_ARRAY = $d77b025aa58d633c$var$ARRAY_OF($d77b025aa58d633c$var$BOOLEAN, "boolean values");
var $d77b025aa58d633c$var$NUMBER_ARRAY = $d77b025aa58d633c$var$ARRAY_OF($d77b025aa58d633c$var$NUMBER, "numbers");
var $d77b025aa58d633c$var$STRING_ARRAY = $d77b025aa58d633c$var$ARRAY_OF($d77b025aa58d633c$var$STRING, "strings");
var $d77b025aa58d633c$var$DATE_ARRAY = $d77b025aa58d633c$var$predicateWithMessage($d77b025aa58d633c$var$ARRAY_OF($d77b025aa58d633c$var$DATE), "Date objects");
var $d77b025aa58d633c$var$OBJECT_ARRAY = $d77b025aa58d633c$var$predicateWithMessage($d77b025aa58d633c$var$ARRAY_OF($d77b025aa58d633c$var$OBJECT), "objects");
var $d77b025aa58d633c$var$LINE_CAP = $d77b025aa58d633c$var$UNION([
    "butt",
    "round",
    "square"
], "a line cap");
var $d77b025aa58d633c$var$LINE_JOIN = $d77b025aa58d633c$var$UNION([
    "round",
    "bevel",
    "miter"
], "a line join");
var $d77b025aa58d633c$var$LINE_DASH = $d77b025aa58d633c$var$predicateWithMessage($d77b025aa58d633c$var$ARRAY_OF($d77b025aa58d633c$var$POSITIVE_NUMBER), "numbers specifying the length in pixels of alternating dashes and gaps, for example, [6, 3] means dashes with a length of 6 pixels with gaps between of 3 pixels.");
var $d77b025aa58d633c$var$POSITION2 = $d77b025aa58d633c$var$UNION([
    "top",
    "right",
    "bottom",
    "left"
], "a position");
var $d77b025aa58d633c$var$FONT_STYLE = $d77b025aa58d633c$var$UNION([
    "normal",
    "italic",
    "oblique"
], "a font style");
var $d77b025aa58d633c$var$FONT_WEIGHT2 = $d77b025aa58d633c$var$OR($d77b025aa58d633c$var$UNION([
    "normal",
    "bold",
    "bolder",
    "lighter"
], "a font weight"), $d77b025aa58d633c$var$NUMBER.restrict({
    min: 1,
    max: 1e3
}));
var $d77b025aa58d633c$var$TEXT_WRAP = $d77b025aa58d633c$var$UNION([
    "never",
    "always",
    "hyphenate",
    "on-space"
], "a text wrap strategy");
var $d77b025aa58d633c$var$TEXT_ALIGN = $d77b025aa58d633c$var$UNION([
    "left",
    "center",
    "right"
], "a text align");
var $d77b025aa58d633c$var$VERTICAL_ALIGN = $d77b025aa58d633c$var$UNION([
    "top",
    "middle",
    "bottom"
], "a vertical align");
var $d77b025aa58d633c$var$OVERFLOW_STRATEGY = $d77b025aa58d633c$var$UNION([
    "ellipsis",
    "hide"
], "an overflow strategy");
var $d77b025aa58d633c$var$DIRECTION = $d77b025aa58d633c$var$UNION([
    "horizontal",
    "vertical"
], "a direction");
var $d77b025aa58d633c$var$PLACEMENT = $d77b025aa58d633c$var$UNION([
    "inside",
    "outside"
], "a placement");
var $d77b025aa58d633c$var$INTERACTION_RANGE = $d77b025aa58d633c$var$OR($d77b025aa58d633c$var$UNION([
    "exact",
    "nearest"
], "interaction range"), $d77b025aa58d633c$var$NUMBER);
var $d77b025aa58d633c$var$LABEL_PLACEMENT = $d77b025aa58d633c$var$UNION([
    "top",
    "bottom",
    "left",
    "right"
]);
function $d77b025aa58d633c$var$UNION(options, message = "a") {
    return $d77b025aa58d633c$var$predicateWithMessage((v)=>options.includes(v), `${message} keyword such as ${$d77b025aa58d633c$var$joinUnionOptions(options)}`);
}
var $d77b025aa58d633c$var$MIN_SPACING = $d77b025aa58d633c$var$OR($d77b025aa58d633c$var$AND($d77b025aa58d633c$var$NUMBER.restrict({
    min: 1
}), $d77b025aa58d633c$var$LESS_THAN("maxSpacing")), $d77b025aa58d633c$var$NAN);
var $d77b025aa58d633c$var$MAX_SPACING = $d77b025aa58d633c$var$OR($d77b025aa58d633c$var$AND($d77b025aa58d633c$var$NUMBER.restrict({
    min: 1
}), $d77b025aa58d633c$var$GREATER_THAN("minSpacing")), $d77b025aa58d633c$var$NAN);
function $d77b025aa58d633c$var$predicateWithMessage(predicate, message) {
    predicate.message = message;
    return predicate;
}
function $d77b025aa58d633c$var$joinUnionOptions(options) {
    const values = options.map((option)=>`'${option}'`);
    if (values.length === 1) return values[0];
    const lastValue = values.pop();
    return `${values.join(", ")} or ${lastValue}`;
}
function $d77b025aa58d633c$var$getPredicateMessage(predicate, ctx) {
    return $d77b025aa58d633c$var$isFunction(predicate.message) ? predicate.message(ctx) : predicate.message;
}
function $d77b025aa58d633c$var$getPredicateMessageMapper(ctx) {
    return (predicate)=>$d77b025aa58d633c$var$getPredicateMessage(predicate, ctx);
}
function $d77b025aa58d633c$var$attachArrayRestrictions(predicate) {
    return Object.assign(predicate, {
        restrict ({ length: length, minLength: minLength } = {}) {
            let message = "an array";
            if ($d77b025aa58d633c$var$isNumber(minLength) && minLength > 0) message = "a non-empty array";
            else if ($d77b025aa58d633c$var$isNumber(length)) message = `an array of length ${length}`;
            return $d77b025aa58d633c$var$predicateWithMessage((value)=>$d77b025aa58d633c$var$isArray(value) && ($d77b025aa58d633c$var$isNumber(length) ? value.length === length : true) && ($d77b025aa58d633c$var$isNumber(minLength) ? value.length >= minLength : true), message);
        }
    });
}
function $d77b025aa58d633c$var$attachNumberRestrictions(predicate) {
    return Object.assign(predicate, {
        restrict ({ min: min, max: max } = {}) {
            const message = [
                "a number"
            ];
            const hasMin = $d77b025aa58d633c$var$isNumber(min);
            const hasMax = $d77b025aa58d633c$var$isNumber(max);
            if (hasMin && hasMax) message.push(`between ${min} and ${max} inclusive`);
            else if (hasMin) message.push(`greater than or equal to ${min}`);
            else if (hasMax) message.push(`less than or equal to ${max}`);
            return $d77b025aa58d633c$var$predicateWithMessage((value)=>$d77b025aa58d633c$var$isFiniteNumber(value) && (hasMin ? value >= min : true) && (hasMax ? value <= max : true), message.join(" "));
        }
    });
}
function $d77b025aa58d633c$var$attachObjectRestrictions(predicate) {
    return Object.assign(predicate, {
        restrict (objectType) {
            return $d77b025aa58d633c$var$predicateWithMessage((value)=>value instanceof objectType, (ctx)=>{
                var _a;
                return (_a = $d77b025aa58d633c$var$getPredicateMessage(predicate, ctx)) != null ? _a : `an instance of ${objectType.name}`;
            });
        }
    });
}
function $d77b025aa58d633c$var$stringify(value) {
    if (typeof value === "number") {
        if (isNaN(value)) return "NaN";
        if (value === Infinity) return "Infinity";
        if (value === -Infinity) return "-Infinity";
    }
    return JSON.stringify(value);
}
// packages/ag-charts-community/src/chart/axis/axisTick.ts
var $d77b025aa58d633c$var$TICK_INTERVAL = $d77b025aa58d633c$var$predicateWithMessage((value)=>$d77b025aa58d633c$var$isFiniteNumber(value) && value > 0 || value instanceof $d77b025aa58d633c$var$TimeInterval, `a non-zero positive Number value or, for a time axis, a Time Interval such as 'agCharts.time.month'`);
var $d77b025aa58d633c$var$AxisTick = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.enabled = true;
        this.width = 1;
        this.size = 6;
        this.color = void 0;
        this.interval = void 0;
        this.values = void 0;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN)
], $d77b025aa58d633c$var$AxisTick.prototype, "enabled", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$AxisTick.prototype, "width", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$AxisTick.prototype, "size", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$COLOR_STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$AxisTick.prototype, "color", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$TICK_INTERVAL, {
        optional: true
    })
], $d77b025aa58d633c$var$AxisTick.prototype, "interval", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$ARRAY, {
        optional: true
    })
], $d77b025aa58d633c$var$AxisTick.prototype, "values", 2);
// packages/ag-charts-community/src/chart/chartAxisDirection.ts
var $d77b025aa58d633c$var$ChartAxisDirection = /* @__PURE__ */ ((ChartAxisDirection2)=>{
    ChartAxisDirection2["X"] = "x";
    ChartAxisDirection2["Y"] = "y";
    return ChartAxisDirection2;
})($d77b025aa58d633c$var$ChartAxisDirection || {});
// packages/ag-charts-community/src/chart/chartOptions.ts
var $d77b025aa58d633c$var$JSON_APPLY_PLUGINS = {
    constructedArrays: /* @__PURE__ */ new WeakMap()
};
function $d77b025aa58d633c$var$assignJsonApplyConstructedArray(array, ctor) {
    var _a;
    (_a = $d77b025aa58d633c$var$JSON_APPLY_PLUGINS.constructedArrays) == null || _a.set(array, ctor);
}
// packages/ag-charts-community/src/scale/continuousScale.ts
var $d77b025aa58d633c$var$_ContinuousScale = class _ContinuousScale {
    constructor(domain, range3){
        this.invalid = true;
        this.nice = false;
        this.interval = void 0;
        this.tickCount = _ContinuousScale.defaultTickCount;
        this.minTickCount = 0;
        this.maxTickCount = Infinity;
        this.niceDomain = [];
        this.defaultClampMode = "raw";
        this.domain = domain;
        this.range = range3;
    }
    static is(value) {
        return value instanceof _ContinuousScale;
    }
    transform(x) {
        return x;
    }
    transformInvert(x) {
        return x;
    }
    calcBandwidth(smallestInterval = 1) {
        const { range: range3 } = this;
        const domain = this.getDomain();
        const rangeDistance = Math.abs(range3[1] - range3[0]);
        const intervals = Math.abs(domain[1] - domain[0]) / smallestInterval + 1;
        const maxBands = Math.floor(rangeDistance);
        const bands = Math.min(intervals, maxBands);
        return rangeDistance / Math.max(1, bands);
    }
    getDomain() {
        if (this.nice) {
            this.refresh();
            if (this.niceDomain.length) return this.niceDomain;
        }
        return this.domain;
    }
    convert(x, opts) {
        var _a;
        const clampMode = (_a = opts == null ? void 0 : opts.clampMode) != null ? _a : this.defaultClampMode;
        if (!this.domain || this.domain.length < 2) return NaN;
        this.refresh();
        const domain = this.getDomain().map((d)=>this.transform(d));
        const [d0, d1] = domain;
        const { range: range3 } = this;
        const [r0, r1] = range3;
        x = this.transform(x);
        if (clampMode === "clamped") {
            const [start, stop] = $d77b025aa58d633c$var$findMinMax(domain.map(Number));
            if (Number(x) < start) return r0;
            else if (Number(x) > stop) return r1;
        }
        if (d0 === d1) return (r0 + r1) / 2;
        else if (x === d0) return r0;
        else if (x === d1) return r1;
        return r0 + (Number(x) - Number(d0)) / (Number(d1) - Number(d0)) * (r1 - r0);
    }
    invert(x) {
        this.refresh();
        const domain = this.getDomain().map((d2)=>this.transform(d2));
        const [d0, d1] = domain;
        const { range: range3 } = this;
        const [r0, r1] = range3;
        const isReversed = r0 > r1;
        const rMin = isReversed ? r1 : r0;
        const rMax = isReversed ? r0 : r1;
        let d;
        if (x < rMin) return isReversed ? d1 : d0;
        else if (x > rMax) return isReversed ? d0 : d1;
        else if (r0 === r1) d = this.toDomain((Number(d0) + Number(d1)) / 2);
        else d = this.toDomain(Number(d0) + (x - r0) / (r1 - r0) * (Number(d1) - Number(d0)));
        return this.transformInvert(d);
    }
    refresh() {
        if (!this.invalid) return;
        this.invalid = false;
        this.update();
        if (this.invalid) $d77b025aa58d633c$var$Logger.warnOnce("Expected update to not invalidate scale");
    }
    getPixelRange() {
        const [a, b] = this.range;
        return Math.abs(b - a);
    }
};
$d77b025aa58d633c$var$_ContinuousScale.defaultTickCount = 5;
$d77b025aa58d633c$var$_ContinuousScale.defaultMaxTickCount = 6;
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Invalidating
], $d77b025aa58d633c$var$_ContinuousScale.prototype, "domain", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Invalidating
], $d77b025aa58d633c$var$_ContinuousScale.prototype, "range", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Invalidating
], $d77b025aa58d633c$var$_ContinuousScale.prototype, "nice", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Invalidating
], $d77b025aa58d633c$var$_ContinuousScale.prototype, "interval", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Invalidating
], $d77b025aa58d633c$var$_ContinuousScale.prototype, "tickCount", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Invalidating
], $d77b025aa58d633c$var$_ContinuousScale.prototype, "minTickCount", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Invalidating
], $d77b025aa58d633c$var$_ContinuousScale.prototype, "maxTickCount", 2);
var $d77b025aa58d633c$var$ContinuousScale = $d77b025aa58d633c$var$_ContinuousScale;
// packages/ag-charts-community/src/util/timeFormat.ts
var $d77b025aa58d633c$var$CONSTANTS = {
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
};
function $d77b025aa58d633c$var$dayOfYear(date, startOfYear = new Date(date.getFullYear(), 0, 1)) {
    const startOffset = date.getTimezoneOffset() - startOfYear.getTimezoneOffset();
    const timeDiff = date.getTime() - startOfYear.getTime() + startOffset * 6e4;
    const timeOneDay = 36e5 * 24;
    return Math.floor(timeDiff / timeOneDay);
}
function $d77b025aa58d633c$var$weekOfYear(date, startDay) {
    const startOfYear = new Date(date.getFullYear(), 0, 1);
    const startOfYearDay = startOfYear.getDay();
    const firstWeekStartOffset = (startDay - startOfYearDay + 7) % 7;
    const startOffset = new Date(date.getFullYear(), 0, firstWeekStartOffset + 1);
    if (startOffset <= date) return Math.floor($d77b025aa58d633c$var$dayOfYear(date, startOffset) / 7) + 1;
    return 0;
}
var $d77b025aa58d633c$var$SUNDAY = 0;
var $d77b025aa58d633c$var$MONDAY = 1;
var $d77b025aa58d633c$var$THURSDAY = 4;
function $d77b025aa58d633c$var$isoWeekOfYear(date, year2 = date.getFullYear()) {
    const firstOfYear = new Date(year2, 0, 1);
    const firstOfYearDay = firstOfYear.getDay();
    const firstThursdayOffset = ($d77b025aa58d633c$var$THURSDAY - firstOfYearDay + 7) % 7;
    const startOffset = new Date(year2, 0, firstThursdayOffset - ($d77b025aa58d633c$var$THURSDAY - $d77b025aa58d633c$var$MONDAY) + 1);
    if (startOffset <= date) return Math.floor($d77b025aa58d633c$var$dayOfYear(date, startOffset) / 7) + 1;
    return $d77b025aa58d633c$var$isoWeekOfYear(date, year2 - 1);
}
function $d77b025aa58d633c$var$timezone(date) {
    const offset4 = date.getTimezoneOffset();
    const unsignedOffset = Math.abs(offset4);
    const sign = offset4 > 0 ? "-" : "+";
    return `${sign}${$d77b025aa58d633c$var$pad(Math.floor(unsignedOffset / 60), 2, "0")}${$d77b025aa58d633c$var$pad(Math.floor(unsignedOffset % 60), 2, "0")}`;
}
var $d77b025aa58d633c$var$FORMATTERS = {
    a: (d)=>$d77b025aa58d633c$var$CONSTANTS.shortDays[d.getDay()],
    A: (d)=>$d77b025aa58d633c$var$CONSTANTS.days[d.getDay()],
    b: (d)=>$d77b025aa58d633c$var$CONSTANTS.shortMonths[d.getMonth()],
    B: (d)=>$d77b025aa58d633c$var$CONSTANTS.months[d.getMonth()],
    c: "%x, %X",
    d: (d, p)=>$d77b025aa58d633c$var$pad(d.getDate(), 2, p != null ? p : "0"),
    e: "%_d",
    f: (d, p)=>$d77b025aa58d633c$var$pad(d.getMilliseconds() * 1e3, 6, p != null ? p : "0"),
    H: (d, p)=>$d77b025aa58d633c$var$pad(d.getHours(), 2, p != null ? p : "0"),
    I: (d, p)=>{
        const hours = d.getHours() % 12;
        return hours === 0 ? "12" : $d77b025aa58d633c$var$pad(hours, 2, p != null ? p : "0");
    },
    j: (d, p)=>$d77b025aa58d633c$var$pad($d77b025aa58d633c$var$dayOfYear(d) + 1, 3, p != null ? p : "0"),
    m: (d, p)=>$d77b025aa58d633c$var$pad(d.getMonth() + 1, 2, p != null ? p : "0"),
    M: (d, p)=>$d77b025aa58d633c$var$pad(d.getMinutes(), 2, p != null ? p : "0"),
    L: (d, p)=>$d77b025aa58d633c$var$pad(d.getMilliseconds(), 3, p != null ? p : "0"),
    p: (d)=>d.getHours() < 12 ? "AM" : "PM",
    Q: (d)=>String(d.getTime()),
    s: (d)=>String(Math.floor(d.getTime() / 1e3)),
    S: (d, p)=>$d77b025aa58d633c$var$pad(d.getSeconds(), 2, p != null ? p : "0"),
    u: (d)=>{
        let day2 = d.getDay();
        if (day2 < 1) day2 += 7;
        return String(day2 % 7);
    },
    U: (d, p)=>$d77b025aa58d633c$var$pad($d77b025aa58d633c$var$weekOfYear(d, $d77b025aa58d633c$var$SUNDAY), 2, p != null ? p : "0"),
    V: (d, p)=>$d77b025aa58d633c$var$pad($d77b025aa58d633c$var$isoWeekOfYear(d), 2, p != null ? p : "0"),
    w: (d, p)=>$d77b025aa58d633c$var$pad(d.getDay(), 2, p != null ? p : "0"),
    W: (d, p)=>$d77b025aa58d633c$var$pad($d77b025aa58d633c$var$weekOfYear(d, $d77b025aa58d633c$var$MONDAY), 2, p != null ? p : "0"),
    x: "%-m/%-d/%Y",
    X: "%-I:%M:%S %p",
    y: (d, p)=>$d77b025aa58d633c$var$pad(d.getFullYear() % 100, 2, p != null ? p : "0"),
    Y: (d, p)=>$d77b025aa58d633c$var$pad(d.getFullYear(), 4, p != null ? p : "0"),
    Z: (d)=>$d77b025aa58d633c$var$timezone(d),
    "%": ()=>"%"
};
var $d77b025aa58d633c$var$PADS = {
    _: " ",
    "0": "0",
    "-": ""
};
function $d77b025aa58d633c$var$pad(value, size, padChar) {
    const output = String(Math.floor(value));
    if (output.length >= size) return output;
    return `${padChar.repeat(size - output.length)}${output}`;
}
function $d77b025aa58d633c$var$buildFormatter(formatString) {
    const formatParts = [];
    while(formatString.length > 0){
        let nextEscapeIdx = formatString.indexOf("%");
        if (nextEscapeIdx !== 0) {
            const literalPart = nextEscapeIdx > 0 ? formatString.substring(0, nextEscapeIdx) : formatString;
            formatParts.push(literalPart);
        }
        if (nextEscapeIdx < 0) break;
        const maybePadSpecifier = formatString[nextEscapeIdx + 1];
        const maybePad = $d77b025aa58d633c$var$PADS[maybePadSpecifier];
        if (maybePad != null) nextEscapeIdx++;
        const maybeFormatterSpecifier = formatString[nextEscapeIdx + 1];
        const maybeFormatter = $d77b025aa58d633c$var$FORMATTERS[maybeFormatterSpecifier];
        if (typeof maybeFormatter === "function") formatParts.push([
            maybeFormatter,
            maybePad
        ]);
        else if (typeof maybeFormatter === "string") {
            const formatter = $d77b025aa58d633c$var$buildFormatter(maybeFormatter);
            formatParts.push([
                formatter,
                maybePad
            ]);
        } else formatParts.push(`${maybePad != null ? maybePad : ""}${maybeFormatterSpecifier}`);
        formatString = formatString.substring(nextEscapeIdx + 2);
    }
    return (dateTime)=>{
        const dateTimeAsDate = typeof dateTime === "number" ? new Date(dateTime) : dateTime;
        return formatParts.map((c)=>typeof c === "string" ? c : c[0](dateTimeAsDate, c[1])).join("");
    };
}
// packages/ag-charts-community/src/util/timeFormatDefaults.ts
function $d77b025aa58d633c$var$dateToNumber(x) {
    return x instanceof Date ? x.getTime() : x;
}
function $d77b025aa58d633c$var$defaultTimeTickFormat(ticks, domain) {
    const formatString = $d77b025aa58d633c$var$calculateDefaultTimeTickFormat(ticks, domain);
    return (date)=>$d77b025aa58d633c$var$buildFormatter(formatString)(date);
}
function $d77b025aa58d633c$var$calculateDefaultTimeTickFormat(ticks = [], domain = ticks) {
    let defaultTimeFormat = 8 /* YEAR */ ;
    const updateFormat = (format2)=>{
        if (format2 < defaultTimeFormat) defaultTimeFormat = format2;
    };
    for (const value of ticks){
        const format2 = $d77b025aa58d633c$var$getLowestGranularityFormat(value);
        updateFormat(format2);
    }
    const startDomain = $d77b025aa58d633c$var$dateToNumber(domain[0]);
    const endDomain = $d77b025aa58d633c$var$dateToNumber(domain.at(-1));
    const startYear = new Date(startDomain).getFullYear();
    const stopYear = new Date(endDomain).getFullYear();
    const yearChange = stopYear - startYear > 0;
    return $d77b025aa58d633c$var$formatStringBuilder(defaultTimeFormat, yearChange, ticks);
}
function $d77b025aa58d633c$var$getLowestGranularityFormat(value) {
    if ($d77b025aa58d633c$var$second_default.floor(value) < value) return 0 /* MILLISECOND */ ;
    else if ($d77b025aa58d633c$var$minute_default.floor(value) < value) return 1 /* SECOND */ ;
    else if ($d77b025aa58d633c$var$hour_default.floor(value) < value) return 2 /* MINUTE */ ;
    else if ($d77b025aa58d633c$var$day_default.floor(value) < value) return 3 /* HOUR */ ;
    else if ($d77b025aa58d633c$var$month_default.floor(value) < value) {
        if ($d77b025aa58d633c$var$week_default.floor(value) < value) return 4 /* WEEK_DAY */ ;
        return 5 /* SHORT_MONTH */ ;
    } else if ($d77b025aa58d633c$var$year_default.floor(value) < value) return 6 /* MONTH */ ;
    return 8 /* YEAR */ ;
}
function $d77b025aa58d633c$var$formatStringBuilder(defaultTimeFormat, yearChange, ticks) {
    const firstTick = $d77b025aa58d633c$var$dateToNumber(ticks[0]);
    const lastTick = $d77b025aa58d633c$var$dateToNumber(ticks.at(-1));
    const extent2 = Math.abs(lastTick - firstTick);
    const activeYear = yearChange || defaultTimeFormat === 8 /* YEAR */ ;
    const activeDate = extent2 === 0;
    const parts = [
        [
            "hour",
            6 * $d77b025aa58d633c$var$durationHour,
            14 * $d77b025aa58d633c$var$durationDay,
            3 /* HOUR */ ,
            "%I %p"
        ],
        [
            "hour",
            $d77b025aa58d633c$var$durationMinute,
            6 * $d77b025aa58d633c$var$durationHour,
            3 /* HOUR */ ,
            "%I:%M"
        ],
        [
            "second",
            1e3,
            6 * $d77b025aa58d633c$var$durationHour,
            1 /* SECOND */ ,
            ":%S"
        ],
        [
            "ms",
            0,
            6 * $d77b025aa58d633c$var$durationHour,
            0 /* MILLISECOND */ ,
            ".%L"
        ],
        [
            "am/pm",
            $d77b025aa58d633c$var$durationMinute,
            6 * $d77b025aa58d633c$var$durationHour,
            3 /* HOUR */ ,
            "%p"
        ],
        " ",
        [
            "day",
            $d77b025aa58d633c$var$durationDay,
            1 * $d77b025aa58d633c$var$durationWeek,
            4 /* WEEK_DAY */ ,
            "%a"
        ],
        [
            "month",
            activeDate ? 0 : $d77b025aa58d633c$var$durationWeek,
            52 * $d77b025aa58d633c$var$durationWeek,
            5 /* SHORT_MONTH */ ,
            "%b %d"
        ],
        [
            "month",
            5 * $d77b025aa58d633c$var$durationWeek,
            10 * $d77b025aa58d633c$var$durationYear,
            6 /* MONTH */ ,
            "%B"
        ],
        " ",
        [
            "year",
            activeYear ? 0 : $d77b025aa58d633c$var$durationYear,
            Infinity,
            8 /* YEAR */ ,
            "%Y"
        ]
    ];
    const formatParts = parts.filter((v)=>{
        if (typeof v === "string") return true;
        const [_, min, max, format2] = v;
        return format2 >= defaultTimeFormat && min <= extent2 && extent2 < max;
    }).reduce((r, next)=>{
        if (typeof next === "string") r.result.push(next);
        else if (!r.used.has(next[0])) {
            r.result.push(next);
            r.used.add(next[0]);
        }
        return r;
    }, {
        result: [],
        used: /* @__PURE__ */ new Set()
    }).result;
    const firstFormat = formatParts.findIndex((v)=>typeof v !== "string");
    const lastFormat = formatParts.length - [
        ...formatParts
    ].reverse().findIndex((v)=>typeof v !== "string");
    return formatParts.slice(firstFormat, lastFormat).map((v)=>typeof v === "string" ? v : v[4]).join("").replaceAll(/\s+/g, " ").trim();
}
// packages/ag-charts-community/src/util/ticks.ts
var $d77b025aa58d633c$var$createNumericTicks = (fractionDigits, takingValues = [])=>Object.assign(takingValues, {
        fractionDigits: fractionDigits
    });
function $d77b025aa58d633c$var$ticks_default(start, stop, count, minCount, maxCount) {
    if (count < 2) return $d77b025aa58d633c$var$range(start, stop, stop - start);
    const step = $d77b025aa58d633c$var$tickStep(start, stop, count, minCount, maxCount);
    if (isNaN(step)) return $d77b025aa58d633c$var$createNumericTicks(0);
    start = Math.ceil(start / step) * step;
    stop = Math.floor(stop / step) * step;
    return $d77b025aa58d633c$var$range(start, stop, step);
}
var $d77b025aa58d633c$var$tickMultipliers = [
    1,
    2,
    5,
    10
];
function $d77b025aa58d633c$var$tickStep(a, b, count, minCount = 0, maxCount = Infinity) {
    const extent2 = Math.abs(b - a);
    const rawStep = extent2 / count;
    const power = Math.floor(Math.log10(rawStep));
    const step = Math.pow(10, power);
    const m = $d77b025aa58d633c$var$tickMultipliers.map((multiplier)=>{
        const s = multiplier * step;
        const c = Math.ceil(extent2 / s);
        const isWithinBounds = c >= minCount && c <= maxCount;
        const diffCount = Math.abs(c - count);
        return {
            multiplier: multiplier,
            isWithinBounds: isWithinBounds,
            diffCount: diffCount
        };
    }).sort((a2, b2)=>{
        if (a2.isWithinBounds !== b2.isWithinBounds) return a2.isWithinBounds ? -1 : 1;
        return a2.diffCount - b2.diffCount;
    })[0].multiplier;
    if (!m || isNaN(m)) return NaN;
    return m * step;
}
function $d77b025aa58d633c$var$singleTickDomain(a, b) {
    const extent2 = Math.abs(b - a);
    const power = Math.floor(Math.log10(extent2));
    const step = Math.pow(10, power);
    const roundStart = a > b ? Math.ceil : Math.floor;
    const roundStop = b < a ? Math.floor : Math.ceil;
    return $d77b025aa58d633c$var$tickMultipliers.map((multiplier)=>{
        const s = multiplier * step;
        const start = roundStart(a / s) * s;
        const end = roundStop(b / s) * s;
        const error = 1 - extent2 / Math.abs(end - start);
        const domain = [
            start,
            end
        ];
        return {
            error: error,
            domain: domain
        };
    }).sort((a2, b2)=>a2.error - b2.error)[0].domain;
}
function $d77b025aa58d633c$var$range(start, stop, step) {
    const d0 = Math.min(start, stop);
    const d1 = Math.max(start, stop);
    const fractionalDigits = $d77b025aa58d633c$var$countFractionDigits(step);
    const f = Math.pow(10, fractionalDigits);
    const n = Math.ceil((d1 - d0) / step);
    const values = $d77b025aa58d633c$var$createNumericTicks(fractionalDigits);
    for(let i = 0; i <= n; i++){
        const value = d0 + step * i;
        values.push(Math.round(value * f) / f);
    }
    return values;
}
function $d77b025aa58d633c$var$isDenseInterval({ start: start, stop: stop, interval: interval, count: count, availableRange: availableRange }) {
    const domain = stop - start;
    const step = typeof interval === "number" ? interval : 1;
    count != null ? count : count = domain / step;
    if (count >= availableRange) {
        $d77b025aa58d633c$var$Logger.warnOnce(`the configured interval results in more than 1 item per pixel, ignoring. Supply a larger interval or omit this configuration`);
        return true;
    }
    return false;
}
// packages/ag-charts-community/src/scale/timeScale.ts
var $d77b025aa58d633c$var$_TimeScale = class _TimeScale extends $d77b025aa58d633c$var$ContinuousScale {
    constructor(){
        super([], [
            0,
            1
        ]);
        this.type = "time";
    }
    toDomain(d) {
        return new Date(d);
    }
    /**
   * @param options Tick interval options.
   * @param options.start The start time (timestamp).
   * @param options.stop The end time (timestamp).
   * @param options.count Number of intervals between ticks.
   */ static getTickInterval({ start: start, stop: stop, count: count, minCount: minCount, maxCount: maxCount, target: target }) {
        let countableTimeInterval;
        let step;
        const tickCount = count != null ? count : $d77b025aa58d633c$var$ContinuousScale.defaultTickCount;
        const targetInterval = target != null ? target : Math.abs(stop - start) / Math.max(tickCount, 1);
        const i = _TimeScale.getIntervalIndex(targetInterval);
        if (i === 0) {
            step = Math.max($d77b025aa58d633c$var$tickStep(start, stop, tickCount, minCount, maxCount), 1);
            countableTimeInterval = $d77b025aa58d633c$var$millisecond_default;
        } else if (i === _TimeScale.tickIntervals.length) {
            const y0 = start / $d77b025aa58d633c$var$durationYear;
            const y1 = stop / $d77b025aa58d633c$var$durationYear;
            step = target === void 0 ? $d77b025aa58d633c$var$tickStep(y0, y1, tickCount, minCount, maxCount) : 1;
            countableTimeInterval = $d77b025aa58d633c$var$year_default;
        } else {
            const diff0 = targetInterval - _TimeScale.tickIntervals[i - 1][2];
            const diff1 = _TimeScale.tickIntervals[i][2] - targetInterval;
            const index = diff0 < diff1 ? i - 1 : i;
            [countableTimeInterval, step] = _TimeScale.tickIntervals[index];
        }
        return countableTimeInterval.every(step);
    }
    static getIntervalIndex(target) {
        let i = 0;
        while(i < _TimeScale.tickIntervals.length && target > _TimeScale.tickIntervals[i][2])i++;
        return i;
    }
    invert(y) {
        return new Date(super.invert(y));
    }
    /**
   * Returns uniformly-spaced dates that represent the scale's domain.
   */ ticks() {
        if (!this.domain || this.domain.length < 2) return [];
        this.refresh();
        const [t0, t1] = this.getDomain().map($d77b025aa58d633c$var$dateToNumber);
        const start = Math.min(t0, t1);
        const stop = Math.max(t0, t1);
        const { interval: interval, nice: nice, tickCount: tickCount, minTickCount: minTickCount, maxTickCount: maxTickCount } = this;
        if (interval !== void 0) {
            const availableRange = this.getPixelRange();
            const ticks = _TimeScale.getTicksForInterval({
                start: start,
                stop: stop,
                interval: interval,
                availableRange: availableRange
            });
            return ticks != null ? ticks : _TimeScale.getDefaultTicks({
                start: start,
                stop: stop,
                tickCount: tickCount,
                minTickCount: minTickCount,
                maxTickCount: maxTickCount
            });
        }
        if (nice) {
            if (tickCount === 2) return this.niceDomain;
            if (tickCount === 1) return this.niceDomain.slice(0, 1);
        }
        return _TimeScale.getDefaultTicks({
            start: start,
            stop: stop,
            tickCount: tickCount,
            minTickCount: minTickCount,
            maxTickCount: maxTickCount
        });
    }
    static getDefaultTicks({ start: start, stop: stop, tickCount: tickCount, minTickCount: minTickCount, maxTickCount: maxTickCount }) {
        const t = _TimeScale.getTickInterval({
            start: start,
            stop: stop,
            count: tickCount,
            minCount: minTickCount,
            maxCount: maxTickCount
        });
        return t ? t.range(new Date(start), new Date(stop)) : [];
    }
    static getTicksForInterval({ start: start, stop: stop, interval: interval, availableRange: availableRange }) {
        if (!interval) return [];
        if (interval instanceof $d77b025aa58d633c$var$TimeInterval) {
            const ticks2 = interval.range(new Date(start), new Date(stop));
            if ($d77b025aa58d633c$var$isDenseInterval({
                start: start,
                stop: stop,
                interval: interval,
                count: ticks2.length,
                availableRange: availableRange
            })) return;
            return ticks2;
        }
        const absInterval = Math.abs(interval);
        if ($d77b025aa58d633c$var$isDenseInterval({
            start: start,
            stop: stop,
            interval: absInterval,
            availableRange: availableRange
        })) return;
        const reversedInterval = [
            ..._TimeScale.tickIntervals
        ];
        reversedInterval.reverse();
        const timeInterval = reversedInterval.find((tickInterval)=>absInterval % tickInterval[2] === 0);
        if (timeInterval) {
            const i = timeInterval[0].every(absInterval / (timeInterval[2] / timeInterval[1]));
            return i.range(new Date(start), new Date(stop));
        }
        let date = new Date(start);
        const stopDate = new Date(stop);
        const ticks = [];
        while(date <= stopDate){
            ticks.push(date);
            date = new Date(date);
            date.setMilliseconds(date.getMilliseconds() + absInterval);
        }
        return ticks;
    }
    /**
   * Returns a time format function suitable for displaying tick values.
   * @param specifier If the specifier string is provided, this method is equivalent to
   * the {@link TimeLocaleObject.format} method.
   * If no specifier is provided, this method returns the default time format function.
   */ tickFormat({ ticks: ticks, domain: domain, specifier: specifier }) {
        return specifier == null ? $d77b025aa58d633c$var$defaultTimeTickFormat(ticks, domain) : $d77b025aa58d633c$var$buildFormatter(specifier);
    }
    update() {
        if (!this.domain || this.domain.length < 2) return;
        if (this.nice) this.updateNiceDomain();
    }
    /**
   * Extends the domain so that it starts and ends on nice round values.
   * This method typically modifies the scale’s domain, and may only extend the bounds to the nearest round value.
   */ updateNiceDomain() {
        const maxAttempts = 4;
        let [d0, d1] = this.domain;
        for(let i = 0; i < maxAttempts; i++){
            this.updateNiceDomainIteration(d0, d1);
            const [n0, n1] = this.niceDomain;
            if ($d77b025aa58d633c$var$dateToNumber(d0) === $d77b025aa58d633c$var$dateToNumber(n0) && $d77b025aa58d633c$var$dateToNumber(d1) === $d77b025aa58d633c$var$dateToNumber(n1)) break;
            d0 = n0;
            d1 = n1;
        }
    }
    updateNiceDomainIteration(d0, d1) {
        const start = Math.min($d77b025aa58d633c$var$dateToNumber(d0), $d77b025aa58d633c$var$dateToNumber(d1));
        const stop = Math.max($d77b025aa58d633c$var$dateToNumber(d0), $d77b025aa58d633c$var$dateToNumber(d1));
        const isReversed = d0 > d1;
        const { interval: interval } = this;
        let i;
        if (interval instanceof $d77b025aa58d633c$var$TimeInterval) i = interval;
        else {
            const tickCount = typeof interval === "number" ? (stop - start) / Math.max(interval, 1) : this.tickCount;
            i = _TimeScale.getTickInterval({
                start: start,
                stop: stop,
                count: tickCount,
                minCount: this.minTickCount,
                maxCount: this.maxTickCount
            });
        }
        if (i) {
            const intervalRange = i.range(new Date(start), new Date(stop), true);
            const domain = isReversed ? [
                ...intervalRange
            ].reverse() : intervalRange;
            const n0 = domain[0];
            const n1 = domain.at(-1);
            this.niceDomain = [
                n0,
                n1
            ];
        }
    }
};
/**
 * Array of default tick intervals in the following format:
 *
 *     [
 *         interval (unit of time),
 *         number of units (step),
 *         the length of that number of units in milliseconds
 *     ]
 */ $d77b025aa58d633c$var$_TimeScale.tickIntervals = [
    [
        $d77b025aa58d633c$var$second_default,
        1,
        $d77b025aa58d633c$var$durationSecond
    ],
    [
        $d77b025aa58d633c$var$second_default,
        5,
        5 * $d77b025aa58d633c$var$durationSecond
    ],
    [
        $d77b025aa58d633c$var$second_default,
        15,
        15 * $d77b025aa58d633c$var$durationSecond
    ],
    [
        $d77b025aa58d633c$var$second_default,
        30,
        30 * $d77b025aa58d633c$var$durationSecond
    ],
    [
        $d77b025aa58d633c$var$minute_default,
        1,
        $d77b025aa58d633c$var$durationMinute
    ],
    [
        $d77b025aa58d633c$var$minute_default,
        5,
        5 * $d77b025aa58d633c$var$durationMinute
    ],
    [
        $d77b025aa58d633c$var$minute_default,
        15,
        15 * $d77b025aa58d633c$var$durationMinute
    ],
    [
        $d77b025aa58d633c$var$minute_default,
        30,
        30 * $d77b025aa58d633c$var$durationMinute
    ],
    [
        $d77b025aa58d633c$var$hour_default,
        1,
        $d77b025aa58d633c$var$durationHour
    ],
    [
        $d77b025aa58d633c$var$hour_default,
        3,
        3 * $d77b025aa58d633c$var$durationHour
    ],
    [
        $d77b025aa58d633c$var$hour_default,
        6,
        6 * $d77b025aa58d633c$var$durationHour
    ],
    [
        $d77b025aa58d633c$var$hour_default,
        12,
        12 * $d77b025aa58d633c$var$durationHour
    ],
    [
        $d77b025aa58d633c$var$day_default,
        1,
        $d77b025aa58d633c$var$durationDay
    ],
    [
        $d77b025aa58d633c$var$day_default,
        2,
        2 * $d77b025aa58d633c$var$durationDay
    ],
    [
        $d77b025aa58d633c$var$week_default,
        1,
        $d77b025aa58d633c$var$durationWeek
    ],
    [
        $d77b025aa58d633c$var$week_default,
        2,
        2 * $d77b025aa58d633c$var$durationWeek
    ],
    [
        $d77b025aa58d633c$var$week_default,
        3,
        3 * $d77b025aa58d633c$var$durationWeek
    ],
    [
        $d77b025aa58d633c$var$month_default,
        1,
        $d77b025aa58d633c$var$durationMonth
    ],
    [
        $d77b025aa58d633c$var$month_default,
        2,
        2 * $d77b025aa58d633c$var$durationMonth
    ],
    [
        $d77b025aa58d633c$var$month_default,
        3,
        3 * $d77b025aa58d633c$var$durationMonth
    ],
    [
        $d77b025aa58d633c$var$month_default,
        4,
        4 * $d77b025aa58d633c$var$durationMonth
    ],
    [
        $d77b025aa58d633c$var$month_default,
        6,
        6 * $d77b025aa58d633c$var$durationMonth
    ],
    [
        $d77b025aa58d633c$var$year_default,
        1,
        $d77b025aa58d633c$var$durationYear
    ]
];
var $d77b025aa58d633c$var$TimeScale = $d77b025aa58d633c$var$_TimeScale;
// packages/ag-charts-community/src/scale/ordinalTimeScale.ts
var $d77b025aa58d633c$var$_OrdinalTimeScale = class _OrdinalTimeScale extends $d77b025aa58d633c$var$BandScale {
    constructor(){
        super(...arguments);
        this.type = "ordinal-time";
        this.tickCount = $d77b025aa58d633c$var$ContinuousScale.defaultTickCount;
        this.minTickCount = 0;
        this.maxTickCount = Infinity;
        this.interval = void 0;
        this.index = /* @__PURE__ */ new Map();
        /**
     * Contains unique datums only. Since `{}` is used in place of `Map`
     * for IE11 compatibility, the datums are converted `toString` before
     * the uniqueness check.
     */ this._domain = [];
    }
    static is(value) {
        return value instanceof _OrdinalTimeScale;
    }
    toDomain(d) {
        return new Date(d);
    }
    set domain(values) {
        this.invalid = true;
        if (values.length === 0) {
            this._domain = [];
            return;
        }
        const domain = this.updateIndex(values);
        this._domain = domain;
    }
    get domain() {
        return this._domain;
    }
    updateIndex(values) {
        this.index = /* @__PURE__ */ new Map();
        const { index: index } = this;
        const domain = [];
        const extents = [];
        const isReversed = values[0] > values.at(-1);
        const indexShift = isReversed ? 0 : 1;
        values.forEach((value, i2)=>{
            const nextValue = values[i2 + 1];
            const e02 = isReversed ? value : this.toDomain($d77b025aa58d633c$var$dateToNumber(value) + 1);
            const e12 = isReversed ? this.toDomain($d77b025aa58d633c$var$dateToNumber(nextValue) + 1) : nextValue;
            const dateRange2 = isReversed ? [
                e12,
                e02
            ] : [
                e02,
                e12
            ];
            domain.push(value);
            if (nextValue !== void 0 && index.get(dateRange2) === void 0) {
                extents.push(Math.abs($d77b025aa58d633c$var$dateToNumber(e12) - $d77b025aa58d633c$var$dateToNumber(e02)));
                index.set(dateRange2, i2 + indexShift);
            }
        });
        extents.sort((a, b)=>a - b);
        const bands = extents.length;
        const middleIndex = Math.floor(bands / 2);
        this.medianInterval = bands > 2 && bands % 2 === 0 ? (extents[middleIndex - 1] + extents[middleIndex + 1]) / 2 : extents[middleIndex];
        const intervalIndex = Math.max(0, $d77b025aa58d633c$var$TimeScale.getIntervalIndex(this.medianInterval) - 1);
        const [countableTimeInterval, step] = $d77b025aa58d633c$var$TimeScale.tickIntervals[intervalIndex];
        const interval = countableTimeInterval.every(step);
        const i = isReversed ? values.length - 1 : 0;
        const e1 = values[i];
        const e0 = interval.floor(values[i]);
        const dateRange = [
            e0,
            e1
        ];
        index.set(dateRange, i);
        return domain;
    }
    ticks() {
        if (!this.domain) return [];
        this.refresh();
        const [t0, t1] = [
            $d77b025aa58d633c$var$dateToNumber(this.domain[0]),
            $d77b025aa58d633c$var$dateToNumber(this.domain.at(-1))
        ];
        const start = Math.min(t0, t1);
        const stop = Math.max(t0, t1);
        const isReversed = t0 > t1;
        let ticks;
        if (this.interval !== void 0) ticks = this.getTicksForInterval({
            start: start,
            stop: stop,
            interval: this.interval
        });
        const n = this.domain.length;
        const { maxTickCount: maxTickCount, tickCount: tickCount } = this;
        let { minTickCount: minTickCount } = this;
        let medianInterval;
        if (isFinite(maxTickCount) && n <= maxTickCount) {
            minTickCount = Math.max(1, n);
            medianInterval = this.medianInterval;
        }
        ticks != null ? ticks : ticks = this.getDefaultTicks({
            start: start,
            stop: stop,
            tickCount: tickCount,
            minTickCount: minTickCount,
            maxTickCount: maxTickCount,
            isReversed: isReversed,
            interval: medianInterval
        });
        const tickPositions = /* @__PURE__ */ new Set();
        return ticks.filter((tick)=>{
            const position = this.convert(tick);
            if (isNaN(position) || tickPositions.has(position)) return false;
            tickPositions.add(position);
            return true;
        });
    }
    getDefaultTicks({ start: start, stop: stop, tickCount: tickCount, minTickCount: minTickCount, maxTickCount: maxTickCount, isReversed: isReversed, interval: interval }) {
        const tickInterval = $d77b025aa58d633c$var$TimeScale.getTickInterval({
            start: start,
            stop: stop,
            count: tickCount,
            minCount: minTickCount,
            maxCount: maxTickCount,
            target: interval
        });
        if (!tickInterval) return [];
        const tickEvery = Math.ceil(this.domain.length / maxTickCount);
        const ticks = [];
        for (const [dateRange, index] of this.index.entries()){
            if (index % tickEvery > 0) continue;
            const tick = isReversed ? tickInterval.ceil(dateRange[0]) : tickInterval.floor(dateRange[1]);
            ticks.splice(index, 0, tick);
        }
        return ticks;
    }
    getTicksForInterval({ start: start, stop: stop, interval: interval }) {
        var _a;
        const [r0, r1] = this.range;
        const availableRange = Math.abs(r1 - r0);
        return (_a = $d77b025aa58d633c$var$TimeScale.getTicksForInterval({
            start: start,
            stop: stop,
            interval: interval,
            availableRange: availableRange
        })) != null ? _a : [];
    }
    convert(d) {
        if (typeof d === "number") d = new Date(d);
        if (!(d instanceof Date)) return NaN;
        this.refresh();
        let i;
        for (const [dateRange, index] of this.index.entries())if (d >= dateRange[0] && d <= dateRange[1]) {
            i = index;
            break;
        }
        if (i === void 0) return NaN;
        const r = this.ordinalRange[i];
        if (r === void 0) return NaN;
        return r;
    }
    /**
   * Returns a time format function suitable for displaying tick values.
   * @param specifier If the specifier string is provided, this method is equivalent to
   * the {@link TimeLocaleObject.format} method.
   * If no specifier is provided, this method returns the default time format function.
   */ tickFormat({ ticks: ticks, domain: domain, specifier: specifier }) {
        return specifier == null ? $d77b025aa58d633c$var$defaultTimeTickFormat(ticks, domain) : $d77b025aa58d633c$var$buildFormatter(specifier);
    }
    invert(y) {
        return new Date(super.invert(y));
    }
    invertNearest(y) {
        return new Date(super.invertNearest(y));
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Invalidating
], $d77b025aa58d633c$var$_OrdinalTimeScale.prototype, "tickCount", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Invalidating
], $d77b025aa58d633c$var$_OrdinalTimeScale.prototype, "minTickCount", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Invalidating
], $d77b025aa58d633c$var$_OrdinalTimeScale.prototype, "maxTickCount", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Invalidating
], $d77b025aa58d633c$var$_OrdinalTimeScale.prototype, "interval", 2);
var $d77b025aa58d633c$var$OrdinalTimeScale = $d77b025aa58d633c$var$_OrdinalTimeScale;
// packages/ag-charts-community/src/util/compare.ts
function $d77b025aa58d633c$var$ascendingStringNumberUndefined(a, b) {
    if (typeof a === "number" && typeof b === "number") return a - b;
    else if (typeof a === "string" && typeof b === "string") return a.localeCompare(b);
    else if (a == null && b == null) return 0;
    else if (a == null) return -1;
    else if (b == null) return 1;
    return String(a).localeCompare(String(b));
}
function $d77b025aa58d633c$var$toLiteral(v) {
    return typeof v === "function" ? v() : v;
}
function $d77b025aa58d633c$var$compoundAscending(a, b, comparator) {
    for(const idx in a){
        const diff2 = comparator($d77b025aa58d633c$var$toLiteral(a[idx]), $d77b025aa58d633c$var$toLiteral(b[idx]));
        if (diff2 !== 0) return diff2;
    }
    return 0;
}
// packages/ag-charts-community/src/scene/group.ts
var $d77b025aa58d633c$var$_Group = class _Group extends $d77b025aa58d633c$var$Node {
    constructor(opts){
        var _a;
        super({
            isVirtual: opts == null ? void 0 : opts.isVirtual
        });
        this.opts = opts;
        this.opacity = 1;
        this.lastBBox = void 0;
        const { zIndex: zIndex, zIndexSubOrder: zIndexSubOrder } = opts != null ? opts : {};
        this.isContainerNode = true;
        if (zIndex !== void 0) this.zIndex = zIndex;
        if (zIndexSubOrder !== void 0) this.zIndexSubOrder = zIndexSubOrder;
        this.name = (_a = this.opts) == null ? void 0 : _a.name;
    }
    static is(value) {
        return value instanceof _Group;
    }
    onZIndexChange() {
        var _a;
        super.onZIndexChange();
        if (this.layer) (_a = this._layerManager) == null || _a.moveLayer(this.layer, this.zIndex, this.zIndexSubOrder);
    }
    isLayer() {
        return this.layer != null;
    }
    _setLayerManager(layersManager) {
        if (this._layerManager && this.layer) {
            this._layerManager.removeLayer(this.layer);
            this.layer = void 0;
        }
        if (this.layer) throw new Error("AG Charts - unable to deregister scene rendering layer!");
        super._setLayerManager(layersManager);
    }
    initialiseLayer() {
        var _a;
        if (this.layer) return;
        if (!this._layerManager || ((_a = this.opts) == null ? void 0 : _a.layer) !== true) return;
        this.layer = this._layerManager.addLayer({
            name: this.name,
            zIndex: this.zIndex,
            zIndexSubOrder: this.zIndexSubOrder,
            getComputedOpacity: ()=>this.getComputedOpacity(),
            getVisibility: ()=>this.getVisibility()
        });
    }
    getComputedOpacity() {
        let opacity = 1;
        for (const node of this.traverseUp())if (node instanceof _Group) opacity *= node.opacity;
        return opacity;
    }
    getVisibility() {
        for (const node of this.traverseUp()){
            if (!node.visible) return false;
        }
        return true;
    }
    onVisibleChange() {
        if (this.layer) this.layer.enabled = this.visible;
    }
    markDirty(source, type = 1 /* TRIVIAL */ ) {
        if (this.isVirtual) {
            super.markDirty(source, type);
            return;
        }
        let parentType = type;
        if (type < 2 /* MINOR */  || this.layer != null) parentType = 1 /* TRIVIAL */ ;
        super.markDirty(source, type, parentType);
    }
    // We consider a group to be boundless, thus any point belongs to it.
    containsPoint(_x, _y) {
        return true;
    }
    computeBBox() {
        this.computeTransformMatrix();
        return _Group.computeBBox(this.children);
    }
    computeTransformedBBox() {
        return this.computeBBox();
    }
    preRender() {
        var _a, _b;
        const counts = super.preRender();
        counts.groups += 1;
        counts.nonGroups -= 1;
        if (((_a = this.opts) == null ? void 0 : _a.layer) !== true || this.layer != null) return counts;
        if (counts.nonGroups > 0) this.initialiseLayer();
        if (((_b = this.opts) == null ? void 0 : _b.nonEmptyChildDerivedZIndex) && counts.nonGroups > 0) this.deriveZIndexFromChildren();
        return counts;
    }
    deriveZIndexFromChildren() {
        var _a;
        const children = this.children.filter((c)=>c._childNodeCounts.nonGroups > 0);
        this.sortChildren(children);
        const lastChild = children.at(-1);
        this.zIndex = (_a = lastChild == null ? void 0 : lastChild.zIndex) != null ? _a : -Infinity;
        this.zIndexSubOrder = lastChild == null ? void 0 : lastChild.zIndexSubOrder;
    }
    render(renderCtx) {
        var _a, _b;
        const { opts: { name: name } = {}, _debug: debug3 } = this;
        const { dirty: dirty, dirtyZIndex: dirtyZIndex, layer: layer, children: children, clipRect: clipRect, dirtyTransform: dirtyTransform } = this;
        let { ctx: ctx, forceRender: forceRender, clipBBox: clipBBox } = renderCtx;
        const { resized: resized, stats: stats } = renderCtx;
        const canvasCtxTransform = ctx.getTransform();
        const isDirty = dirty >= 2 /* MINOR */  || dirtyZIndex || resized;
        let isChildDirty = isDirty;
        let isChildLayerDirty = false;
        for (const child of children){
            isChildDirty || (isChildDirty = child.layerManager == null && child.dirty >= 1 /* TRIVIAL */ );
            isChildLayerDirty || (isChildLayerDirty = child.layerManager != null && child.dirty >= 1 /* TRIVIAL */ );
            if (isChildDirty) break;
        }
        if (name) debug3 == null || debug3({
            name: name,
            group: this,
            isDirty: isDirty,
            isChildDirty: isChildDirty,
            dirtyTransform: dirtyTransform,
            renderCtx: renderCtx,
            forceRender: forceRender
        });
        if (dirtyTransform) forceRender = "dirtyTransform";
        else if (layer) {
            const currentBBox = this.computeBBox();
            if (this.lastBBox === void 0 || !this.lastBBox.equals(currentBBox)) {
                forceRender = "dirtyTransform";
                this.lastBBox = currentBBox;
            }
        }
        if (!isDirty && !isChildDirty && !isChildLayerDirty && !forceRender) {
            if (name && stats) debug3 == null || debug3({
                name: name,
                result: "skipping",
                renderCtx: renderCtx,
                counts: this.nodeCount,
                group: this
            });
            if (layer && stats) {
                stats.layersSkipped++;
                stats.nodesSkipped += this.nodeCount.count;
            }
            this.markClean({
                recursive: false
            });
            return;
        }
        const groupVisible = this.visible;
        if (layer) {
            ctx = layer.context;
            ctx.save();
            ctx.setTransform(layer.pixelRatio, 0, 0, layer.pixelRatio, 0, 0);
            if (forceRender !== "dirtyTransform") forceRender = isChildDirty || dirtyZIndex;
            if (forceRender) layer.clear();
            if (clipBBox) {
                const { width: width, height: height, x: x, y: y } = clipBBox;
                debug3 == null || debug3(()=>({
                        name: name,
                        clipBBox: clipBBox,
                        ctxTransform: ctx.getTransform(),
                        renderCtx: renderCtx,
                        group: this
                    }));
                ctx.beginPath();
                ctx.rect(x, y, width, height);
                ctx.clip();
            }
            ctx.setTransform(canvasCtxTransform);
        } else ctx.globalAlpha *= this.opacity;
        this.computeTransformMatrix();
        this.matrix.toContext(ctx);
        if (clipRect) {
            const { x: x, y: y, width: width, height: height } = clipRect;
            ctx.save();
            debug3 == null || debug3(()=>({
                    name: name,
                    clipRect: clipRect,
                    ctxTransform: ctx.getTransform(),
                    renderCtx: renderCtx,
                    group: this
                }));
            ctx.beginPath();
            ctx.rect(x, y, width, height);
            ctx.clip();
            clipBBox = this.matrix.transformBBox(clipRect);
        }
        const hasVirtualChildren = this.hasVirtualChildren();
        if (dirtyZIndex) {
            this.sortChildren(children);
            if (forceRender !== "dirtyTransform") forceRender = true;
        } else if (hasVirtualChildren) this.sortChildren(children);
        const renderContextChanged = forceRender !== renderCtx.forceRender || clipBBox !== renderCtx.clipBBox || ctx !== renderCtx.ctx;
        const childRenderContext = renderContextChanged ? $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, renderCtx), {
            ctx: ctx,
            forceRender: forceRender,
            clipBBox: clipBBox
        }) : renderCtx;
        let skipped = 0;
        for (const child of children){
            if (!child.visible || !groupVisible) {
                child.markClean();
                if (stats) skipped += child.nodeCount.count;
                continue;
            }
            if (!forceRender && child.dirty === 0 /* NONE */ ) {
                if (stats) skipped += child.nodeCount.count;
                continue;
            }
            ctx.save();
            child.render(childRenderContext);
            ctx.restore();
        }
        if (stats) stats.nodesSkipped += skipped;
        super.render(renderCtx);
        if (clipRect) ctx.restore();
        if (hasVirtualChildren) for (const child of this.virtualChildren)child.markClean({
            recursive: "virtual"
        });
        if (layer) {
            if (stats) stats.layersRendered++;
            ctx.restore();
            if (forceRender) layer.snapshot();
            (_b = (_a = layer.context).verifyDepthZero) == null || _b.call(_a);
        }
        if (name && stats) debug3 == null || debug3({
            name: name,
            result: "rendered",
            skipped: skipped,
            renderCtx: renderCtx,
            counts: this.nodeCount,
            group: this
        });
    }
    sortChildren(children) {
        this.dirtyZIndex = false;
        children.sort((a, b)=>{
            var _a, _b;
            return $d77b025aa58d633c$var$compoundAscending([
                a.zIndex,
                ...(_a = a.zIndexSubOrder) != null ? _a : [
                    void 0,
                    void 0
                ],
                a.serialNumber
            ], [
                b.zIndex,
                ...(_b = b.zIndexSubOrder) != null ? _b : [
                    void 0,
                    void 0
                ],
                b.serialNumber
            ], $d77b025aa58d633c$var$ascendingStringNumberUndefined);
        });
    }
    static computeBBox(nodes) {
        let left = Infinity;
        let right = -Infinity;
        let top = Infinity;
        let bottom = -Infinity;
        for (const n of nodes){
            if (!n.visible) continue;
            const bbox = n.computeTransformedBBox();
            if (!bbox) continue;
            const { x: x, y: y, width: width, height: height } = bbox;
            if (x < left) left = x;
            if (y < top) top = y;
            if (x + width > right) right = x + width;
            if (y + height > bottom) bottom = y + height;
        }
        return new $d77b025aa58d633c$var$BBox(left, top, right - left, bottom - top);
    }
    /**
   * Transforms bbox given in the canvas coordinate space to bbox in this group's coordinate space and
   * sets this group's clipRect to the transformed bbox.
   * @param bbox clipRect bbox in the canvas coordinate space.
   */ setClipRectInGroupCoordinateSpace(bbox) {
        this.clipRect = bbox ? this.transformBBox(bbox) : void 0;
    }
};
$d77b025aa58d633c$var$_Group.className = "Group";
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 3 /* MAJOR */ ,
        convertor: (v)=>$d77b025aa58d633c$var$clamp(0, v, 1)
    })
], $d77b025aa58d633c$var$_Group.prototype, "opacity", 2);
var $d77b025aa58d633c$var$Group = $d77b025aa58d633c$var$_Group;
// packages/ag-charts-community/src/scene/gradient/gradient.ts
var $d77b025aa58d633c$var$Gradient = class {
    constructor(stops = []){
        this.stops = stops;
    }
};
// packages/ag-charts-community/src/scene/gradient/linearGradient.ts
var $d77b025aa58d633c$var$LinearGradient = class extends $d77b025aa58d633c$var$Gradient {
    constructor(stops, angle = 0){
        super(stops);
        this.angle = angle;
    }
    createGradient(ctx, bbox) {
        const angleOffset = 90;
        const { stops: stops, angle: angle } = this;
        const radians = $d77b025aa58d633c$var$normalizeAngle360($d77b025aa58d633c$var$toRadians(angle + angleOffset));
        const cos = Math.cos(radians);
        const sin = Math.sin(radians);
        const w = bbox.width;
        const h = bbox.height;
        const cx = bbox.x + w * 0.5;
        const cy = bbox.y + h * 0.5;
        if (w > 0 && h > 0) {
            const diagonal = Math.sqrt(h * h + w * w) / 2;
            const diagonalAngle = Math.atan2(h, w);
            let quarteredAngle;
            if (radians < Math.PI / 2) quarteredAngle = radians;
            else if (radians < Math.PI) quarteredAngle = Math.PI - radians;
            else if (radians < 1.5 * Math.PI) quarteredAngle = radians - Math.PI;
            else quarteredAngle = 2 * Math.PI - radians;
            const l = diagonal * Math.abs(Math.cos(quarteredAngle - diagonalAngle));
            const gradient = ctx.createLinearGradient(cx + cos * l, cy + sin * l, cx - cos * l, cy - sin * l);
            for (const stop of stops)gradient.addColorStop(stop.offset, stop.color);
            return gradient;
        }
        return "black";
    }
};
// packages/ag-charts-community/src/scene/shape/shape.ts
var $d77b025aa58d633c$var$LINEAR_GRADIENT_REGEXP = /^linear-gradient\((.*?)deg,\s*(.*?)\s*\)$/i;
var $d77b025aa58d633c$var$_Shape = class _Shape extends $d77b025aa58d633c$var$Node {
    constructor(){
        super(...arguments);
        this.fillOpacity = 1;
        this.strokeOpacity = 1;
        this.fill = _Shape.defaultStyles.fill;
        this.stroke = _Shape.defaultStyles.stroke;
        this.strokeWidth = _Shape.defaultStyles.strokeWidth;
        this.lineDash = _Shape.defaultStyles.lineDash;
        this.lineDashOffset = _Shape.defaultStyles.lineDashOffset;
        this.lineCap = _Shape.defaultStyles.lineCap;
        this.lineJoin = _Shape.defaultStyles.lineJoin;
        this.opacity = _Shape.defaultStyles.opacity;
        this.fillShadow = _Shape.defaultStyles.fillShadow;
    }
    /**
   * Restores the default styles introduced by this subclass.
   */ restoreOwnStyles() {
        const { defaultStyles: defaultStyles } = this.constructor;
        Object.assign(this, defaultStyles);
    }
    onFillChange() {
        const { fill: fill } = this;
        let linearGradientMatch;
        if ((fill == null ? void 0 : fill.startsWith("linear-gradient")) && (linearGradientMatch = $d77b025aa58d633c$var$LINEAR_GRADIENT_REGEXP.exec(fill))) {
            const angle = parseFloat(linearGradientMatch[1]);
            const colors = [];
            const colorsPart = linearGradientMatch[2];
            const colorRegex = /(#[0-9a-f]+)|(rgba?\(.+?\))|([a-z]+)/gi;
            let c;
            while(c = colorRegex.exec(colorsPart))colors.push(c[0]);
            this.gradient = new $d77b025aa58d633c$var$LinearGradient(colors.map((color, index)=>({
                    color: color,
                    offset: index / (colors.length - 1)
                })), angle);
        } else this.gradient = void 0;
    }
    /**
   * Returns a device-pixel aligned coordinate (or length if length is supplied).
   *
   * NOTE: Not suitable for strokes, since the stroke needs to be offset to the middle
   * of a device pixel.
   */ align(start, length) {
        var _a, _b, _c;
        const pixelRatio = (_c = (_b = (_a = this.layerManager) == null ? void 0 : _a.canvas) == null ? void 0 : _b.pixelRatio) != null ? _c : 1;
        const alignedStart = Math.round(start * pixelRatio) / pixelRatio;
        if (length == null) return alignedStart;
        else if (length === 0) return 0;
        else if (length < 1) return Math.ceil(length * pixelRatio) / pixelRatio;
        return Math.round((length + start) * pixelRatio) / pixelRatio - alignedStart;
    }
    fillStroke(ctx, path) {
        this.renderFill(ctx, path);
        this.renderStroke(ctx, path);
    }
    renderFill(ctx, path) {
        if (this.fill) {
            const { globalAlpha: globalAlpha } = ctx;
            this.applyFill(ctx);
            this.applyFillAlpha(ctx);
            this.applyShadow(ctx);
            this.executeFill(ctx, path);
            ctx.globalAlpha = globalAlpha;
        }
        ctx.shadowColor = "rgba(0, 0, 0, 0)";
    }
    executeFill(ctx, path) {
        path ? ctx.fill(path) : ctx.fill();
    }
    applyFill(ctx) {
        var _a, _b;
        ctx.fillStyle = (_b = (_a = this.gradient) == null ? void 0 : _a.createGradient(ctx, this.computeBBox())) != null ? _b : this.fill;
    }
    applyFillAlpha(ctx) {
        ctx.globalAlpha *= this.opacity * this.fillOpacity;
    }
    applyShadow(ctx) {
        var _a, _b;
        const pixelRatio = (_b = (_a = this.layerManager) == null ? void 0 : _a.canvas.pixelRatio) != null ? _b : 1;
        const fillShadow = this.fillShadow;
        if (fillShadow == null ? void 0 : fillShadow.enabled) {
            ctx.shadowColor = fillShadow.color;
            ctx.shadowOffsetX = fillShadow.xOffset * pixelRatio;
            ctx.shadowOffsetY = fillShadow.yOffset * pixelRatio;
            ctx.shadowBlur = fillShadow.blur * pixelRatio;
        }
    }
    renderStroke(ctx, path) {
        if (this.stroke && this.strokeWidth) {
            const { globalAlpha: globalAlpha } = ctx;
            ctx.strokeStyle = this.stroke;
            ctx.globalAlpha *= this.opacity * this.strokeOpacity;
            ctx.lineWidth = this.strokeWidth;
            if (this.lineDash) ctx.setLineDash(this.lineDash);
            if (this.lineDashOffset) ctx.lineDashOffset = this.lineDashOffset;
            if (this.lineCap) ctx.lineCap = this.lineCap;
            if (this.lineJoin) ctx.lineJoin = this.lineJoin;
            this.executeStroke(ctx, path);
            ctx.globalAlpha = globalAlpha;
        }
    }
    executeStroke(ctx, path) {
        path ? ctx.stroke(path) : ctx.stroke();
    }
    containsPoint(x, y) {
        return this.isPointInPath(x, y);
    }
};
/**
 * Defaults for style properties. Note that properties that affect the position
 * and shape of the node are not considered style properties, for example:
 * `x`, `y`, `width`, `height`, `radius`, `rotation`, etc.
 * Can be used to reset to the original styling after some custom styling
 * has been applied (using the `restoreOwnStyles` method).
 * These static defaults are meant to be inherited by subclasses.
 */ $d77b025aa58d633c$var$_Shape.defaultStyles = {
    fill: "black",
    stroke: void 0,
    strokeWidth: 0,
    lineDash: void 0,
    lineDashOffset: 0,
    lineCap: void 0,
    lineJoin: void 0,
    opacity: 1,
    fillShadow: void 0
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 2 /* MINOR */ 
    })
], $d77b025aa58d633c$var$_Shape.prototype, "fillOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 2 /* MINOR */ 
    })
], $d77b025aa58d633c$var$_Shape.prototype, "strokeOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 2 /* MINOR */ ,
        changeCb: (s)=>s.onFillChange()
    })
], $d77b025aa58d633c$var$_Shape.prototype, "fill", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 2 /* MINOR */ 
    })
], $d77b025aa58d633c$var$_Shape.prototype, "stroke", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 2 /* MINOR */ 
    })
], $d77b025aa58d633c$var$_Shape.prototype, "strokeWidth", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 2 /* MINOR */ 
    })
], $d77b025aa58d633c$var$_Shape.prototype, "lineDash", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 2 /* MINOR */ 
    })
], $d77b025aa58d633c$var$_Shape.prototype, "lineDashOffset", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 2 /* MINOR */ 
    })
], $d77b025aa58d633c$var$_Shape.prototype, "lineCap", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 2 /* MINOR */ 
    })
], $d77b025aa58d633c$var$_Shape.prototype, "lineJoin", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 2 /* MINOR */ ,
        convertor: (v)=>$d77b025aa58d633c$var$clamp(0, v, 1)
    })
], $d77b025aa58d633c$var$_Shape.prototype, "opacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 2 /* MINOR */ ,
        checkDirtyOnAssignment: true
    })
], $d77b025aa58d633c$var$_Shape.prototype, "fillShadow", 2);
var $d77b025aa58d633c$var$Shape = $d77b025aa58d633c$var$_Shape;
// packages/ag-charts-community/src/scene/shape/range.ts
var $d77b025aa58d633c$var$Range = class extends $d77b025aa58d633c$var$Shape {
    constructor(opts = {}){
        super(opts);
        this.x1 = 0;
        this.y1 = 0;
        this.x2 = 0;
        this.y2 = 0;
        this.startLine = false;
        this.endLine = false;
        this.isRange = false;
        this.restoreOwnStyles();
    }
    computeBBox() {
        return new $d77b025aa58d633c$var$BBox(this.x1, this.y1, this.x2 - this.x1, this.y2 - this.y1);
    }
    isPointInPath(_x, _y) {
        return false;
    }
    render(renderCtx) {
        var _a;
        const { ctx: ctx, forceRender: forceRender, stats: stats } = renderCtx;
        if (this.dirty === 0 /* NONE */  && !forceRender) {
            if (stats) stats.nodesSkipped += this.nodeCount.count;
            return;
        }
        this.computeTransformMatrix();
        this.matrix.toContext(ctx);
        let { x1: x1, y1: y1, x2: x2, y2: y2 } = this;
        x1 = this.align(x1);
        y1 = this.align(y1);
        x2 = this.align(x2);
        y2 = this.align(y2);
        const { fill: fill, opacity: opacity, isRange: isRange } = this;
        const fillActive = !!(isRange && fill);
        if (fillActive) {
            const { fillOpacity: fillOpacity } = this;
            ctx.fillStyle = fill;
            ctx.globalAlpha = opacity * fillOpacity;
            ctx.beginPath();
            ctx.moveTo(x1, y1);
            ctx.lineTo(x2, y1);
            ctx.lineTo(x2, y2);
            ctx.lineTo(x1, y2);
            ctx.closePath();
            ctx.fill();
        }
        const { stroke: stroke, strokeWidth: strokeWidth, startLine: startLine, endLine: endLine } = this;
        const strokeActive = !!((startLine || endLine) && stroke && strokeWidth);
        if (strokeActive) {
            const { strokeOpacity: strokeOpacity, lineDash: lineDash, lineDashOffset: lineDashOffset, lineCap: lineCap, lineJoin: lineJoin } = this;
            ctx.strokeStyle = stroke;
            ctx.globalAlpha = opacity * strokeOpacity;
            ctx.lineWidth = strokeWidth;
            if (lineDash) ctx.setLineDash(lineDash);
            if (lineDashOffset) ctx.lineDashOffset = lineDashOffset;
            if (lineCap) ctx.lineCap = lineCap;
            if (lineJoin) ctx.lineJoin = lineJoin;
            ctx.beginPath();
            if (startLine) {
                ctx.moveTo(x1, y1);
                ctx.lineTo(x2, y1);
            }
            if (endLine) {
                ctx.moveTo(x2, y2);
                ctx.lineTo(x1, y2);
            }
            ctx.stroke();
        }
        (_a = this.fillShadow) == null || _a.markClean();
        super.render(renderCtx);
    }
};
$d77b025aa58d633c$var$Range.className = "Range";
$d77b025aa58d633c$var$Range.defaultStyles = $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, $d77b025aa58d633c$var$Shape.defaultStyles), {
    strokeWidth: 1
});
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 2 /* MINOR */ 
    })
], $d77b025aa58d633c$var$Range.prototype, "x1", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 2 /* MINOR */ 
    })
], $d77b025aa58d633c$var$Range.prototype, "y1", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 2 /* MINOR */ 
    })
], $d77b025aa58d633c$var$Range.prototype, "x2", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 2 /* MINOR */ 
    })
], $d77b025aa58d633c$var$Range.prototype, "y2", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 2 /* MINOR */ 
    })
], $d77b025aa58d633c$var$Range.prototype, "startLine", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 2 /* MINOR */ 
    })
], $d77b025aa58d633c$var$Range.prototype, "endLine", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 2 /* MINOR */ 
    })
], $d77b025aa58d633c$var$Range.prototype, "isRange", 2);
// packages/ag-charts-community/src/util/memo.ts
var $d77b025aa58d633c$var$memorizedFns = /* @__PURE__ */ new WeakMap();
var $d77b025aa58d633c$var$memorizedMap = /* @__PURE__ */ new WeakMap();
function $d77b025aa58d633c$var$memo(params, fnGenerator) {
    var _a, _b, _c;
    const serialisedParams = JSON.stringify(params, null, 0);
    if (!$d77b025aa58d633c$var$memorizedFns.has(fnGenerator)) $d77b025aa58d633c$var$memorizedFns.set(fnGenerator, /* @__PURE__ */ new Map());
    if (!((_a = $d77b025aa58d633c$var$memorizedFns.get(fnGenerator)) == null ? void 0 : _a.has(serialisedParams))) (_b = $d77b025aa58d633c$var$memorizedFns.get(fnGenerator)) == null || _b.set(serialisedParams, fnGenerator(params));
    return (_c = $d77b025aa58d633c$var$memorizedFns.get(fnGenerator)) == null ? void 0 : _c.get(serialisedParams);
}
function $d77b025aa58d633c$var$memoizeFunction(baseFn) {
    return (params, ...rest)=>{
        var _a, _b, _c;
        const serialisedParams = JSON.stringify(params, null, 0);
        if (!$d77b025aa58d633c$var$memorizedMap.has(baseFn)) $d77b025aa58d633c$var$memorizedMap.set(baseFn, /* @__PURE__ */ new Map());
        if (!((_a = $d77b025aa58d633c$var$memorizedMap.get(baseFn)) == null ? void 0 : _a.has(serialisedParams))) (_b = $d77b025aa58d633c$var$memorizedMap.get(baseFn)) == null || _b.set(serialisedParams, baseFn(params, ...rest));
        return (_c = $d77b025aa58d633c$var$memorizedMap.get(baseFn)) == null ? void 0 : _c.get(serialisedParams);
    };
}
// packages/ag-charts-community/src/scene/shape/text.ts
var $d77b025aa58d633c$var$ellipsis = "\u2026";
function $d77b025aa58d633c$var$SceneFontChangeDetection(opts) {
    const { redraw: redraw = 3 /* MAJOR */ , changeCb: changeCb } = opts != null ? opts : {};
    return $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: redraw,
        type: "font",
        changeCb: changeCb
    });
}
var $d77b025aa58d633c$var$_Text = class _Text extends $d77b025aa58d633c$var$Shape {
    constructor(){
        super(...arguments);
        this.x = 0;
        this.y = 0;
        this.lines = [];
        this.text = void 0;
        this._dirtyFont = true;
        this.fontSize = 10;
        this.fontFamily = "sans-serif";
        this.textAlign = _Text.defaultStyles.textAlign;
        this.textBaseline = _Text.defaultStyles.textBaseline;
    }
    onTextChange() {
        var _a, _b;
        this.lines = (_b = (_a = this.text) == null ? void 0 : _a.split("\n").map((s)=>s.trim())) != null ? _b : [];
    }
    get font() {
        if (this._font == null || this._dirtyFont) {
            this._dirtyFont = false;
            this._font = $d77b025aa58d633c$var$getFont(this);
        }
        return this._font;
    }
    computeBBox() {
        const { x: x, y: y, lines: lines, lineHeight: lineHeight, textBaseline: textBaseline, textAlign: textAlign } = this;
        const { top: top, left: left, width: width, height: height } = _Text.getTextSizeMultiline(lines, $d77b025aa58d633c$var$getFont(this), textBaseline, textAlign, lineHeight);
        return new $d77b025aa58d633c$var$BBox(x - left, y - top, width, height);
    }
    getLineHeight(line) {
        var _a, _b;
        if (this.lineHeight) return this.lineHeight;
        const metrics = _Text.measureText(line, this.font, this.textBaseline, this.textAlign);
        return(// Fallback to emHeightAscent + emHeightDescent is needed for server-side rendering.
        ((_a = metrics.fontBoundingBoxAscent) != null ? _a : metrics.emHeightAscent) + ((_b = metrics.fontBoundingBoxDescent) != null ? _b : metrics.emHeightDescent));
    }
    isPointInPath(x, y) {
        const point = this.transformPoint(x, y);
        const bbox = this.computeBBox();
        return bbox ? bbox.containsPoint(point.x, point.y) : false;
    }
    render(renderCtx) {
        const { ctx: ctx, forceRender: forceRender, stats: stats } = renderCtx;
        if (this.dirty === 0 /* NONE */  && !forceRender) {
            if (stats) stats.nodesSkipped += this.nodeCount.count;
            return;
        }
        if (!this.lines.length || !this.layerManager) {
            if (stats) stats.nodesSkipped += this.nodeCount.count;
            return;
        }
        this.computeTransformMatrix();
        this.matrix.toContext(ctx);
        const { fill: fill, stroke: stroke, strokeWidth: strokeWidth } = this;
        ctx.font = this.font;
        ctx.textAlign = this.textAlign;
        ctx.textBaseline = this.textBaseline;
        const pixelRatio = this.layerManager.canvas.pixelRatio || 1;
        const { globalAlpha: globalAlpha } = ctx;
        if (fill) {
            ctx.fillStyle = fill;
            ctx.globalAlpha = globalAlpha * this.opacity * this.fillOpacity;
            const { fillShadow: fillShadow } = this;
            if (fillShadow == null ? void 0 : fillShadow.enabled) {
                ctx.shadowColor = fillShadow.color;
                ctx.shadowOffsetX = fillShadow.xOffset * pixelRatio;
                ctx.shadowOffsetY = fillShadow.yOffset * pixelRatio;
                ctx.shadowBlur = fillShadow.blur * pixelRatio;
            }
            this.renderLines((line, x, y)=>ctx.fillText(line, x, y));
        }
        if (stroke && strokeWidth) {
            ctx.strokeStyle = stroke;
            ctx.lineWidth = strokeWidth;
            ctx.globalAlpha = globalAlpha * this.opacity * this.strokeOpacity;
            const { lineDash: lineDash, lineDashOffset: lineDashOffset, lineCap: lineCap, lineJoin: lineJoin } = this;
            if (lineDash) ctx.setLineDash(lineDash);
            if (lineDashOffset) ctx.lineDashOffset = lineDashOffset;
            if (lineCap) ctx.lineCap = lineCap;
            if (lineJoin) ctx.lineJoin = lineJoin;
            this.renderLines((line, x, y)=>ctx.strokeText(line, x, y));
        }
        super.render(renderCtx);
    }
    renderLines(renderCallback) {
        const { lines: lines, x: x, y: y } = this;
        const lineHeights = lines.map((line)=>this.getLineHeight(line));
        const totalHeight = lineHeights.reduce((a, b)=>a + b, 0);
        let offsetY = (lineHeights[0] - totalHeight) * _Text.getVerticalModifier(this.textBaseline);
        for(let i = 0; i < lines.length; i++){
            renderCallback(lines[i], x, y + offsetY);
            offsetY += lineHeights[i];
        }
    }
    static wrapLines(text, maxWidth, maxHeight, textProps, wrapping, overflow) {
        const canOverflow = overflow !== "hide";
        const measurer = new $d77b025aa58d633c$var$TextMeasurer(textProps);
        const lines = text.split(/\r?\n/g);
        if (lines.length === 0) return {
            lines: void 0,
            truncated: false
        };
        if (wrapping === "never") {
            const { text: truncText, truncated: truncated2 } = _Text.truncateLine(lines[0], maxWidth, measurer, canOverflow ? "auto" : "never");
            return {
                lines: truncText != null ? [
                    truncText
                ] : void 0,
                truncated: truncated2
            };
        }
        const wrappedLines = [];
        let cumulativeHeight = 0;
        let truncated = false;
        for (const line of lines){
            const wrappedLine = _Text.wrapLine(line, maxWidth, maxHeight, measurer, textProps, wrapping, cumulativeHeight, canOverflow);
            if (wrappedLine == null) return {
                lines: void 0,
                truncated: false
            };
            wrappedLines.push(...wrappedLine.result);
            cumulativeHeight = wrappedLine.cumulativeHeight;
            if (wrappedLine.truncated) {
                truncated = true;
                break;
            }
        }
        return {
            lines: wrappedLines,
            truncated: truncated
        };
    }
    static wrap(text, maxWidth, maxHeight, textProps, wrapping, overflow = "ellipsis") {
        var _a;
        const { lines: lines, truncated: truncated } = _Text.wrapLines(text, maxWidth, maxHeight, textProps, wrapping, overflow);
        return {
            text: (_a = lines == null ? void 0 : lines.join("\n").trim()) != null ? _a : "",
            truncated: truncated
        };
    }
    static wrapLine(text, maxWidth, maxHeight, measurer, textProps, wrapping, cumulativeHeight, canOverflow) {
        text = text.trim();
        if (!text) return {
            result: [],
            truncated: false,
            cumulativeHeight: cumulativeHeight
        };
        const initialSize = measurer.size(text);
        if (initialSize.width <= maxWidth) return {
            result: [
                text
            ],
            truncated: false,
            cumulativeHeight: cumulativeHeight + initialSize.height
        };
        if (initialSize.height > maxHeight || measurer.width("W") > maxWidth) return canOverflow ? {
            result: [],
            truncated: true,
            cumulativeHeight: cumulativeHeight
        } : void 0;
        const words = text.split(/\s+/g);
        const wrapResult = _Text.wrapLineSequentially(words, maxWidth, maxHeight, measurer, textProps, wrapping, cumulativeHeight, canOverflow);
        if (wrapResult == null) return;
        cumulativeHeight = wrapResult.cumulativeHeight;
        let { lines: lines } = wrapResult;
        if (!(wrapResult.wordsBrokenOrTruncated || wrapResult.linesTruncated)) {
            const linesCount = wrapResult.lines.length;
            const balanced = _Text.wrapLineBalanced(words, maxWidth, measurer, linesCount);
            if (balanced.length === lines.length) lines = balanced;
        }
        const wrappedText = lines.map((ln)=>ln.join(" "));
        return {
            result: wrappedText,
            truncated: wrapResult.linesTruncated,
            cumulativeHeight: cumulativeHeight
        };
    }
    static breakWord(word, firstLineWidth, maxWidth, hyphens, measurer) {
        const isPunctuationAt = (index)=>_Text.punctuationMarks.includes(word[index]);
        const h = hyphens ? measurer.width("-") : 0;
        const breaks = [];
        let partWidth = 0;
        let p = 0;
        for(let i = 0; i < word.length; i++){
            const c = word[i];
            const w = measurer.width(c);
            const limit = p === 0 ? firstLineWidth : maxWidth;
            if (partWidth + w + h > limit) {
                breaks.push(i);
                partWidth = 0;
                p++;
            }
            partWidth += w;
        }
        const parts = [];
        let start = 0;
        for (const index of breaks){
            let part = word.substring(start, index);
            if (hyphens && part.length > 0 && !isPunctuationAt(index - 1) && !isPunctuationAt(index)) part += "-";
            parts.push(part);
            start = index;
        }
        parts.push(word.substring(start));
        return parts;
    }
    static truncateLine(text, maxWidth, measurer, ellipsisMode) {
        text = text.trimEnd();
        const lineWidth = measurer.width(text);
        if (lineWidth > maxWidth && ellipsisMode === "never") return {
            text: void 0,
            truncated: false
        };
        else if (lineWidth <= maxWidth && ellipsisMode !== "force") return {
            text: text,
            truncated: false
        };
        const ellipsisWidth = measurer.width($d77b025aa58d633c$var$ellipsis);
        let trunc = text;
        let truncWidth = lineWidth;
        while(trunc.length > 0 && truncWidth + ellipsisWidth > maxWidth){
            trunc = trunc.slice(0, -1).trimEnd();
            truncWidth = measurer.width(trunc);
        }
        if (truncWidth + ellipsisWidth <= maxWidth) return {
            text: `${trunc}${$d77b025aa58d633c$var$ellipsis}`,
            truncated: true
        };
        else return {
            text: void 0,
            truncated: false
        };
    }
    static wrapLineSequentially(words, maxWidth, maxHeight, measurer, textProps, wrapping, cumulativeHeight, canOverflow) {
        const { fontSize: fontSize = 0, lineHeight: lineHeight = fontSize * _Text.defaultLineHeightRatio } = textProps;
        const breakWord = wrapping === "always" || wrapping === "hyphenate";
        const hyphenate = wrapping === "hyphenate";
        const spaceWidth = measurer.width(" ");
        let wordsBrokenOrTruncated = false;
        let linesTruncated = false;
        const lines = [];
        let currentLine = [];
        let lineWidth = 0;
        const getReturnValue = ()=>({
                lines: lines,
                linesTruncated: linesTruncated,
                wordsBrokenOrTruncated: wordsBrokenOrTruncated,
                cumulativeHeight: cumulativeHeight
            });
        const truncateLastLine = ()=>{
            if (!canOverflow) return;
            const lastLine = currentLine.join(" ");
            const { text: text } = _Text.truncateLine(lastLine, maxWidth, measurer, "force");
            if (text == null) return;
            currentLine.splice(0, currentLine.length, text);
            linesTruncated = true;
            return getReturnValue();
        };
        const addNewLine = ()=>{
            const expectedHeight = cumulativeHeight + lineHeight;
            if (expectedHeight >= maxHeight) return false;
            currentLine = [];
            lineWidth = 0;
            cumulativeHeight = expectedHeight;
            lines.push(currentLine);
            return true;
        };
        if (!addNewLine()) return truncateLastLine();
        for(let i = 0; i < words.length; i++){
            const word = words[i];
            const wordWidth = measurer.width(word);
            const expectedSpaceWidth = currentLine.length === 0 ? 0 : spaceWidth;
            const expectedLineWidth = lineWidth + expectedSpaceWidth + wordWidth;
            if (expectedLineWidth <= maxWidth) {
                currentLine.push(word);
                lineWidth = expectedLineWidth;
                continue;
            }
            if (wordWidth <= maxWidth) {
                if (!addNewLine()) return truncateLastLine();
                currentLine.push(word);
                lineWidth = wordWidth;
                continue;
            }
            wordsBrokenOrTruncated = true;
            if (breakWord) {
                const availWidth = maxWidth - lineWidth - expectedSpaceWidth;
                const parts = _Text.breakWord(word, availWidth, maxWidth, hyphenate, measurer);
                for(let p = 0; p < parts.length; p++){
                    const part = parts[p];
                    part && currentLine.push(part);
                    if (p === parts.length - 1) lineWidth = measurer.width(part);
                    else if (!addNewLine()) return truncateLastLine();
                }
            } else if (canOverflow) {
                if (!addNewLine()) return truncateLastLine();
                const { text: text } = _Text.truncateLine(word, maxWidth, measurer, "force");
                if (text == null) return;
                currentLine.push(text);
                if (i < words.length - 1) linesTruncated = true;
                break;
            } else return;
        }
        return getReturnValue();
    }
    static wrapLineBalanced(words, maxWidth, measurer, linesCount) {
        const totalWordsWidth = words.reduce((sum2, w)=>sum2 + measurer.width(w), 0);
        const spaceWidth = measurer.width(" ");
        const totalSpaceWidth = spaceWidth * (words.length - linesCount - 2);
        const averageLineWidth = (totalWordsWidth + totalSpaceWidth) / linesCount;
        const lines = [];
        let currentLine = [];
        let lineWidth = measurer.width(words[0]);
        let newLine = true;
        for (const word of words){
            const width = measurer.width(word);
            if (newLine) {
                currentLine = [];
                currentLine.push(word);
                lineWidth = width;
                newLine = false;
                lines.push(currentLine);
                continue;
            }
            const expectedLineWidth = lineWidth + spaceWidth + width;
            if (expectedLineWidth <= averageLineWidth) {
                currentLine.push(word);
                lineWidth = expectedLineWidth;
            } else if (expectedLineWidth <= maxWidth) {
                currentLine.push(word);
                newLine = true;
            } else {
                currentLine = [
                    word
                ];
                lineWidth = width;
                lines.push(currentLine);
            }
        }
        return lines;
    }
    setFont(props) {
        this.fontFamily = props.fontFamily;
        this.fontSize = props.fontSize;
        this.fontStyle = props.fontStyle;
        this.fontWeight = props.fontWeight;
    }
    setAlign(props) {
        this.textAlign = props.textAlign;
        this.textBaseline = props.textBaseline;
    }
    static getVerticalModifier(textBaseline) {
        switch(textBaseline){
            case "top":
            case "hanging":
                return 0;
            case "bottom":
            case "alphabetic":
            case "ideographic":
                return 1;
            case "middle":
                return 0.5;
        }
    }
    static get textContext() {
        if (!this._textContext) {
            const canvasElement = $d77b025aa58d633c$var$createElement("canvas");
            canvasElement.width = 0;
            canvasElement.height = 0;
            this._textContext = canvasElement.getContext("2d");
        }
        return this._textContext;
    }
    static measureText(text, font, textBaseline, textAlign) {
        return this._measureText({
            text: text,
            font: font,
            textBaseline: textBaseline,
            textAlign: textAlign
        });
    }
    /**
   * Returns the width and height of the measured text.
   * @param text The single-line text to measure.
   * @param font The font shorthand string.
   */ static getTextSize(text, font) {
        return this._getTextSize({
            text: text,
            font: font
        });
    }
    static getTextSizeMultiline(lines, font, textBaseline = _Text.defaultStyles.textBaseline, textAlign = _Text.defaultStyles.textAlign, lineHeight) {
        var _a, _b;
        let top = 0;
        let left = 0;
        let width = 0;
        let height = 0;
        let baselineDistance = 0;
        for (const [i, text] of lines.entries()){
            const metrics = this._measureText({
                text: text,
                font: font,
                textBaseline: textBaseline,
                textAlign: textAlign
            });
            left = Math.max(left, metrics.actualBoundingBoxLeft);
            width = Math.max(width, metrics.width);
            if (i == 0) {
                top += metrics.actualBoundingBoxAscent;
                height += metrics.actualBoundingBoxAscent;
            } else baselineDistance += (_a = metrics.fontBoundingBoxAscent) != null ? _a : metrics.emHeightAscent;
            if (i == lines.length - 1) height += metrics.actualBoundingBoxDescent;
            else baselineDistance += (_b = metrics.fontBoundingBoxDescent) != null ? _b : metrics.emHeightDescent;
        }
        if (lineHeight != null) baselineDistance = (lines.length - 1) * lineHeight;
        height += baselineDistance;
        top += baselineDistance * _Text.getVerticalModifier(textBaseline);
        return {
            top: top,
            left: left,
            width: width,
            height: height
        };
    }
};
$d77b025aa58d633c$var$_Text.className = "Text";
// The default line spacing for document editors is usually 1.15
$d77b025aa58d633c$var$_Text.defaultLineHeightRatio = 1.15;
$d77b025aa58d633c$var$_Text.defaultStyles = Object.assign({}, $d77b025aa58d633c$var$Shape.defaultStyles, {
    textAlign: "start",
    fontStyle: void 0,
    fontWeight: void 0,
    fontSize: 10,
    fontFamily: "sans-serif",
    textBaseline: "alphabetic"
});
$d77b025aa58d633c$var$_Text.ellipsis = $d77b025aa58d633c$var$ellipsis;
$d77b025aa58d633c$var$_Text.punctuationMarks = [
    ".",
    ",",
    "-",
    ":",
    ";",
    "!",
    "?",
    `'`,
    '"',
    "(",
    ")"
];
$d77b025aa58d633c$var$_Text._measureText = $d77b025aa58d633c$var$memoizeFunction(({ text: text, font: font, textBaseline: textBaseline, textAlign: textAlign })=>{
    const ctx = $d77b025aa58d633c$var$_Text.textContext;
    if (ctx.font !== font) ctx.font = font;
    if (ctx.textBaseline !== textBaseline) ctx.textBaseline = textBaseline;
    if (ctx.textAlign !== textAlign) ctx.textAlign = textAlign;
    return ctx.measureText(text);
});
$d77b025aa58d633c$var$_Text._getTextSize = $d77b025aa58d633c$var$memoizeFunction(({ text: text, font: font })=>{
    const ctx = $d77b025aa58d633c$var$_Text.textContext;
    if (ctx.font !== font) ctx.font = font;
    const metrics = ctx.measureText(text);
    return {
        width: metrics.width,
        height: metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent
    };
});
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 3 /* MAJOR */ 
    })
], $d77b025aa58d633c$var$_Text.prototype, "x", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 3 /* MAJOR */ 
    })
], $d77b025aa58d633c$var$_Text.prototype, "y", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 3 /* MAJOR */ ,
        changeCb: (o)=>o.onTextChange()
    })
], $d77b025aa58d633c$var$_Text.prototype, "text", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneFontChangeDetection()
], $d77b025aa58d633c$var$_Text.prototype, "fontStyle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneFontChangeDetection()
], $d77b025aa58d633c$var$_Text.prototype, "fontWeight", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneFontChangeDetection()
], $d77b025aa58d633c$var$_Text.prototype, "fontSize", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneFontChangeDetection()
], $d77b025aa58d633c$var$_Text.prototype, "fontFamily", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 3 /* MAJOR */ 
    })
], $d77b025aa58d633c$var$_Text.prototype, "textAlign", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 3 /* MAJOR */ 
    })
], $d77b025aa58d633c$var$_Text.prototype, "textBaseline", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 3 /* MAJOR */ 
    })
], $d77b025aa58d633c$var$_Text.prototype, "lineHeight", 2);
var $d77b025aa58d633c$var$Text = $d77b025aa58d633c$var$_Text;
var $d77b025aa58d633c$var$TextMeasurer = class {
    constructor(font){
        this.font = $d77b025aa58d633c$var$isString(font) ? font : $d77b025aa58d633c$var$getFont(font);
    }
    size(text) {
        return text.includes("\n") ? $d77b025aa58d633c$var$Text.getTextSizeMultiline(text.split("\n").map((s)=>s.trim()), this.font) : $d77b025aa58d633c$var$Text.getTextSize(text, this.font);
    }
    width(text) {
        const { width: width } = this.size(text);
        return width;
    }
};
function $d77b025aa58d633c$var$getFont(fontProps) {
    const { fontFamily: fontFamily, fontSize: fontSize, fontStyle: fontStyle, fontWeight: fontWeight } = fontProps;
    return [
        fontStyle != null ? fontStyle : "",
        fontWeight != null ? fontWeight : "",
        fontSize + "px",
        fontFamily
    ].join(" ").trim();
}
// packages/ag-charts-community/src/chart/label.ts
var $d77b025aa58d633c$var$Label = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.enabled = true;
        this.fontSize = 12;
        this.fontFamily = "Verdana, sans-serif";
    }
    getFont() {
        return $d77b025aa58d633c$var$getFont(this);
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN)
], $d77b025aa58d633c$var$Label.prototype, "enabled", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$COLOR_STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$Label.prototype, "color", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$FONT_STYLE, {
        optional: true
    })
], $d77b025aa58d633c$var$Label.prototype, "fontStyle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$FONT_WEIGHT2, {
        optional: true
    })
], $d77b025aa58d633c$var$Label.prototype, "fontWeight", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$Label.prototype, "fontSize", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING)
], $d77b025aa58d633c$var$Label.prototype, "fontFamily", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$FUNCTION, {
        optional: true
    })
], $d77b025aa58d633c$var$Label.prototype, "formatter", 2);
function $d77b025aa58d633c$var$calculateLabelRotation(opts) {
    const { parallelFlipRotation: parallelFlipRotation = 0, regularFlipRotation: regularFlipRotation = 0 } = opts;
    const configuredRotation = opts.rotation ? $d77b025aa58d633c$var$normalizeAngle360($d77b025aa58d633c$var$toRadians(opts.rotation)) : 0;
    const parallelFlipFlag = !configuredRotation && parallelFlipRotation >= 0 && parallelFlipRotation <= Math.PI ? -1 : 1;
    const regularFlipFlag = !configuredRotation && regularFlipRotation >= 0 && regularFlipRotation <= Math.PI ? -1 : 1;
    let defaultRotation = 0;
    if (opts.parallel) defaultRotation = parallelFlipFlag * Math.PI / 2;
    else if (regularFlipFlag === -1) defaultRotation = Math.PI;
    return {
        configuredRotation: configuredRotation,
        defaultRotation: defaultRotation,
        parallelFlipFlag: parallelFlipFlag,
        regularFlipFlag: regularFlipFlag
    };
}
function $d77b025aa58d633c$var$getLabelSpacing(minSpacing, rotated) {
    if (!isNaN(minSpacing)) return minSpacing;
    return rotated ? 0 : 10;
}
function $d77b025aa58d633c$var$getTextBaseline(parallel, labelRotation, sideFlag, parallelFlipFlag) {
    if (parallel && !labelRotation) return sideFlag * parallelFlipFlag === -1 ? "hanging" : "bottom";
    return "middle";
}
function $d77b025aa58d633c$var$getTextAlign(parallel, labelRotation, labelAutoRotation, sideFlag, regularFlipFlag) {
    const labelRotated = labelRotation > 0 && labelRotation <= Math.PI;
    const labelAutoRotated = labelAutoRotation > 0 && labelAutoRotation <= Math.PI;
    const alignFlag = labelRotated || labelAutoRotated ? -1 : 1;
    if (parallel) {
        if (labelRotation || labelAutoRotation) {
            if (sideFlag * alignFlag === -1) return "end";
        } else return "center";
    } else if (sideFlag * regularFlipFlag === -1) return "end";
    return "start";
}
function $d77b025aa58d633c$var$calculateLabelBBox(text, bbox, labelX, labelY, labelMatrix) {
    const { width: width, height: height } = bbox;
    const translatedBBox = new $d77b025aa58d633c$var$BBox(labelX, labelY, 0, 0);
    labelMatrix.transformBBox(translatedBBox, bbox);
    const { x: x, y: y } = bbox;
    bbox.width = width;
    bbox.height = height;
    return {
        point: {
            x: x,
            y: y
        },
        label: {
            text: text,
            width: width,
            height: height
        }
    };
}
// packages/ag-charts-community/src/chart/layers.ts
var $d77b025aa58d633c$var$Layers = /* @__PURE__ */ ((Layers2)=>{
    Layers2[Layers2["SERIES_BACKGROUND_ZINDEX"] = 0] = "SERIES_BACKGROUND_ZINDEX";
    Layers2[Layers2["AXIS_GRID_ZINDEX"] = 1] = "AXIS_GRID_ZINDEX";
    Layers2[Layers2["AXIS_ZINDEX"] = 2] = "AXIS_ZINDEX";
    Layers2[Layers2["SERIES_CROSSLINE_RANGE_ZINDEX"] = 3] = "SERIES_CROSSLINE_RANGE_ZINDEX";
    Layers2[Layers2["SERIES_LAYER_ZINDEX"] = 4] = "SERIES_LAYER_ZINDEX";
    Layers2[Layers2["SERIES_HIGHLIGHT_ZINDEX"] = 5] = "SERIES_HIGHLIGHT_ZINDEX";
    Layers2[Layers2["AXIS_FOREGROUND_ZINDEX"] = 6] = "AXIS_FOREGROUND_ZINDEX";
    Layers2[Layers2["SERIES_CROSSHAIR_ZINDEX"] = 7] = "SERIES_CROSSHAIR_ZINDEX";
    Layers2[Layers2["SERIES_LABEL_ZINDEX"] = 8] = "SERIES_LABEL_ZINDEX";
    Layers2[Layers2["SERIES_CROSSLINE_LINE_ZINDEX"] = 9] = "SERIES_CROSSLINE_LINE_ZINDEX";
    Layers2[Layers2["SERIES_ANNOTATION_ZINDEX"] = 10] = "SERIES_ANNOTATION_ZINDEX";
    Layers2[Layers2["LEGEND_ZINDEX"] = 11] = "LEGEND_ZINDEX";
    Layers2[Layers2["NAVIGATOR_ZINDEX"] = 12] = "NAVIGATOR_ZINDEX";
    return Layers2;
})($d77b025aa58d633c$var$Layers || {});
// packages/ag-charts-community/src/util/value.ts
function $d77b025aa58d633c$var$isStringObject(value) {
    return value != null && Object.hasOwn(value, "toString") && $d77b025aa58d633c$var$isString(value.toString());
}
function $d77b025aa58d633c$var$isNumberObject(value) {
    return value != null && Object.hasOwn(value, "valueOf") && $d77b025aa58d633c$var$isFiniteNumber(value.valueOf());
}
function $d77b025aa58d633c$var$isContinuous(value) {
    return $d77b025aa58d633c$var$isFiniteNumber(value) || $d77b025aa58d633c$var$isValidDate(value) || $d77b025aa58d633c$var$isNumberObject(value);
}
function $d77b025aa58d633c$var$checkDatum(value, isContinuousScale) {
    return value != null && (!isContinuousScale || $d77b025aa58d633c$var$isContinuous(value));
}
function $d77b025aa58d633c$var$transformIntegratedCategoryValue(value) {
    if ($d77b025aa58d633c$var$isStringObject(value) && Object.hasOwn(value, "id")) return value.id;
    return value;
}
// packages/ag-charts-community/src/chart/crossline/crossLine.ts
var $d77b025aa58d633c$var$MATCHING_CROSSLINE_TYPE = (property)=>{
    return property === "value" ? $d77b025aa58d633c$var$predicateWithMessage((_, ctx)=>ctx.target["type"] === "line", (ctx)=>ctx.target["type"] === "range" ? `crossLine type 'range' to have a 'range' property instead of 'value'` : `crossLine property 'type' to be 'line'`) : $d77b025aa58d633c$var$predicateWithMessage((_, ctx)=>ctx.target["type"] === "range", (ctx)=>ctx.target.type === "line" ? `crossLine type 'line' to have a 'value' property instead of 'range'` : `crossLine property 'type' to be 'range'`);
};
var $d77b025aa58d633c$var$validateCrossLineValues = (type, value, range3, scale2)=>{
    const lineCrossLine = type === "line" && value !== void 0;
    const rangeCrossLine = type === "range" && range3 !== void 0;
    if (!lineCrossLine && !rangeCrossLine) return true;
    const [start, end] = range3 != null ? range3 : [
        value,
        void 0
    ];
    const isContinuous2 = $d77b025aa58d633c$var$ContinuousScale.is(scale2) || $d77b025aa58d633c$var$OrdinalTimeScale.is(scale2);
    const validStart = $d77b025aa58d633c$var$checkDatum(start, isContinuous2) && !isNaN(scale2.convert(start));
    const validEnd = $d77b025aa58d633c$var$checkDatum(end, isContinuous2) && !isNaN(scale2.convert(end));
    if (lineCrossLine && validStart || rangeCrossLine && validStart && validEnd) return true;
    const message = [
        `Expecting crossLine`
    ];
    if (rangeCrossLine) {
        if (!validStart) message.push(`range start ${$d77b025aa58d633c$var$stringify(start)}`);
        if (!validEnd) message.push(`${validStart ? "" : "and "}range end ${$d77b025aa58d633c$var$stringify(end)}`);
    } else message.push(`value ${$d77b025aa58d633c$var$stringify(start)}`);
    message.push(`to match the axis scale domain.`);
    $d77b025aa58d633c$var$Logger.warnOnce(message.join(" "));
    return false;
};
// packages/ag-charts-community/src/chart/crossline/crossLineLabelPosition.ts
var $d77b025aa58d633c$var$horizontalCrosslineTranslationDirections = {
    top: {
        xTranslationDirection: 0,
        yTranslationDirection: -1
    },
    bottom: {
        xTranslationDirection: 0,
        yTranslationDirection: 1
    },
    left: {
        xTranslationDirection: -1,
        yTranslationDirection: 0
    },
    right: {
        xTranslationDirection: 1,
        yTranslationDirection: 0
    },
    topLeft: {
        xTranslationDirection: 1,
        yTranslationDirection: -1
    },
    topRight: {
        xTranslationDirection: -1,
        yTranslationDirection: -1
    },
    bottomLeft: {
        xTranslationDirection: 1,
        yTranslationDirection: 1
    },
    bottomRight: {
        xTranslationDirection: -1,
        yTranslationDirection: 1
    },
    inside: {
        xTranslationDirection: 0,
        yTranslationDirection: 0
    },
    insideLeft: {
        xTranslationDirection: 1,
        yTranslationDirection: 0
    },
    insideRight: {
        xTranslationDirection: -1,
        yTranslationDirection: 0
    },
    insideTop: {
        xTranslationDirection: 0,
        yTranslationDirection: 1
    },
    insideBottom: {
        xTranslationDirection: 0,
        yTranslationDirection: -1
    },
    insideTopLeft: {
        xTranslationDirection: 1,
        yTranslationDirection: 1
    },
    insideBottomLeft: {
        xTranslationDirection: 1,
        yTranslationDirection: -1
    },
    insideTopRight: {
        xTranslationDirection: -1,
        yTranslationDirection: 1
    },
    insideBottomRight: {
        xTranslationDirection: -1,
        yTranslationDirection: -1
    }
};
var $d77b025aa58d633c$var$verticalCrossLineTranslationDirections = {
    top: {
        xTranslationDirection: 1,
        yTranslationDirection: 0
    },
    bottom: {
        xTranslationDirection: -1,
        yTranslationDirection: 0
    },
    left: {
        xTranslationDirection: 0,
        yTranslationDirection: -1
    },
    right: {
        xTranslationDirection: 0,
        yTranslationDirection: 1
    },
    topLeft: {
        xTranslationDirection: -1,
        yTranslationDirection: -1
    },
    topRight: {
        xTranslationDirection: -1,
        yTranslationDirection: 1
    },
    bottomLeft: {
        xTranslationDirection: 1,
        yTranslationDirection: -1
    },
    bottomRight: {
        xTranslationDirection: 1,
        yTranslationDirection: 1
    },
    inside: {
        xTranslationDirection: 0,
        yTranslationDirection: 0
    },
    insideLeft: {
        xTranslationDirection: 0,
        yTranslationDirection: 1
    },
    insideRight: {
        xTranslationDirection: 0,
        yTranslationDirection: -1
    },
    insideTop: {
        xTranslationDirection: -1,
        yTranslationDirection: 0
    },
    insideBottom: {
        xTranslationDirection: 1,
        yTranslationDirection: 0
    },
    insideTopLeft: {
        xTranslationDirection: -1,
        yTranslationDirection: 1
    },
    insideBottomLeft: {
        xTranslationDirection: 1,
        yTranslationDirection: 1
    },
    insideTopRight: {
        xTranslationDirection: -1,
        yTranslationDirection: -1
    },
    insideBottomRight: {
        xTranslationDirection: 1,
        yTranslationDirection: -1
    }
};
function $d77b025aa58d633c$var$calculateLabelTranslation({ yDirection: yDirection, padding: padding = 0, position: position = "top", bbox: bbox }) {
    const crossLineTranslationDirections = yDirection ? $d77b025aa58d633c$var$horizontalCrosslineTranslationDirections : $d77b025aa58d633c$var$verticalCrossLineTranslationDirections;
    const { xTranslationDirection: xTranslationDirection, yTranslationDirection: yTranslationDirection } = crossLineTranslationDirections[position];
    const w = yDirection ? bbox.width : bbox.height;
    const h = yDirection ? bbox.height : bbox.width;
    const xTranslation = xTranslationDirection * (padding + w / 2);
    const yTranslation = yTranslationDirection * (padding + h / 2);
    return {
        xTranslation: xTranslation,
        yTranslation: yTranslation
    };
}
function $d77b025aa58d633c$var$calculateLabelChartPadding({ yDirection: yDirection, bbox: bbox, padding: padding = 0, position: position = "top" }) {
    const chartPadding = {};
    if (position.startsWith("inside")) return chartPadding;
    if (position === "top" && !yDirection) chartPadding.top = padding + bbox.height;
    else if (position === "bottom" && !yDirection) chartPadding.bottom = padding + bbox.height;
    else if (position === "left" && yDirection) chartPadding.left = padding + bbox.width;
    else if (position === "right" && yDirection) chartPadding.right = padding + bbox.width;
    return chartPadding;
}
var $d77b025aa58d633c$var$POSITION_TOP_COORDINATES = ({ yDirection: yDirection, xEnd: xEnd, yStart: yStart, yEnd: yEnd })=>{
    if (yDirection) return {
        x: xEnd / 2,
        y: yStart
    };
    else return {
        x: xEnd,
        y: isNaN(yEnd) ? yStart : (yStart + yEnd) / 2
    };
};
var $d77b025aa58d633c$var$POSITION_LEFT_COORDINATES = ({ yDirection: yDirection, xStart: xStart, xEnd: xEnd, yStart: yStart, yEnd: yEnd })=>{
    if (yDirection) return {
        x: xStart,
        y: isNaN(yEnd) ? yStart : (yStart + yEnd) / 2
    };
    else return {
        x: xEnd / 2,
        y: yStart
    };
};
var $d77b025aa58d633c$var$POSITION_RIGHT_COORDINATES = ({ yDirection: yDirection, xEnd: xEnd, yStart: yStart, yEnd: yEnd })=>{
    if (yDirection) return {
        x: xEnd,
        y: isNaN(yEnd) ? yStart : (yStart + yEnd) / 2
    };
    else return {
        x: xEnd / 2,
        y: isNaN(yEnd) ? yStart : yEnd
    };
};
var $d77b025aa58d633c$var$POSITION_BOTTOM_COORDINATES = ({ yDirection: yDirection, xStart: xStart, xEnd: xEnd, yStart: yStart, yEnd: yEnd })=>{
    if (yDirection) return {
        x: xEnd / 2,
        y: isNaN(yEnd) ? yStart : yEnd
    };
    else return {
        x: xStart,
        y: isNaN(yEnd) ? yStart : (yStart + yEnd) / 2
    };
};
var $d77b025aa58d633c$var$POSITION_INSIDE_COORDINATES = ({ xEnd: xEnd, yStart: yStart, yEnd: yEnd })=>{
    return {
        x: xEnd / 2,
        y: isNaN(yEnd) ? yStart : (yStart + yEnd) / 2
    };
};
var $d77b025aa58d633c$var$POSITION_TOP_LEFT_COORDINATES = ({ yDirection: yDirection, xStart: xStart, xEnd: xEnd, yStart: yStart })=>{
    if (yDirection) return {
        x: xStart / 2,
        y: yStart
    };
    else return {
        x: xEnd,
        y: yStart
    };
};
var $d77b025aa58d633c$var$POSITION_BOTTOM_LEFT_COORDINATES = ({ yDirection: yDirection, xStart: xStart, yStart: yStart, yEnd: yEnd })=>{
    if (yDirection) return {
        x: xStart,
        y: isNaN(yEnd) ? yStart : yEnd
    };
    else return {
        x: xStart,
        y: yStart
    };
};
var $d77b025aa58d633c$var$POSITION_TOP_RIGHT_COORDINATES = ({ yDirection: yDirection, xEnd: xEnd, yStart: yStart, yEnd: yEnd })=>{
    if (yDirection) return {
        x: xEnd,
        y: yStart
    };
    else return {
        x: xEnd,
        y: isNaN(yEnd) ? yStart : yEnd
    };
};
var $d77b025aa58d633c$var$POSITION_BOTTOM_RIGHT_COORDINATES = ({ yDirection: yDirection, xStart: xStart, xEnd: xEnd, yStart: yStart, yEnd: yEnd })=>{
    if (yDirection) return {
        x: xEnd,
        y: isNaN(yEnd) ? yStart : yEnd
    };
    else return {
        x: xStart,
        y: isNaN(yEnd) ? yStart : yEnd
    };
};
var $d77b025aa58d633c$var$labelDirectionHandling = {
    top: {
        c: $d77b025aa58d633c$var$POSITION_TOP_COORDINATES
    },
    bottom: {
        c: $d77b025aa58d633c$var$POSITION_BOTTOM_COORDINATES
    },
    left: {
        c: $d77b025aa58d633c$var$POSITION_LEFT_COORDINATES
    },
    right: {
        c: $d77b025aa58d633c$var$POSITION_RIGHT_COORDINATES
    },
    topLeft: {
        c: $d77b025aa58d633c$var$POSITION_TOP_LEFT_COORDINATES
    },
    topRight: {
        c: $d77b025aa58d633c$var$POSITION_TOP_RIGHT_COORDINATES
    },
    bottomLeft: {
        c: $d77b025aa58d633c$var$POSITION_BOTTOM_LEFT_COORDINATES
    },
    bottomRight: {
        c: $d77b025aa58d633c$var$POSITION_BOTTOM_RIGHT_COORDINATES
    },
    inside: {
        c: $d77b025aa58d633c$var$POSITION_INSIDE_COORDINATES
    },
    insideLeft: {
        c: $d77b025aa58d633c$var$POSITION_LEFT_COORDINATES
    },
    insideRight: {
        c: $d77b025aa58d633c$var$POSITION_RIGHT_COORDINATES
    },
    insideTop: {
        c: $d77b025aa58d633c$var$POSITION_TOP_COORDINATES
    },
    insideBottom: {
        c: $d77b025aa58d633c$var$POSITION_BOTTOM_COORDINATES
    },
    insideTopLeft: {
        c: $d77b025aa58d633c$var$POSITION_TOP_LEFT_COORDINATES
    },
    insideBottomLeft: {
        c: $d77b025aa58d633c$var$POSITION_BOTTOM_LEFT_COORDINATES
    },
    insideTopRight: {
        c: $d77b025aa58d633c$var$POSITION_TOP_RIGHT_COORDINATES
    },
    insideBottomRight: {
        c: $d77b025aa58d633c$var$POSITION_BOTTOM_RIGHT_COORDINATES
    }
};
// packages/ag-charts-community/src/chart/crossline/cartesianCrossLine.ts
var $d77b025aa58d633c$var$CROSSLINE_LABEL_POSITION = $d77b025aa58d633c$var$UNION([
    "top",
    "left",
    "right",
    "bottom",
    "topLeft",
    "topRight",
    "bottomLeft",
    "bottomRight",
    "inside",
    "insideLeft",
    "insideRight",
    "insideTop",
    "insideBottom",
    "insideTopLeft",
    "insideBottomLeft",
    "insideTopRight",
    "insideBottomRight"
], "crossLine label position");
var $d77b025aa58d633c$var$CartesianCrossLineLabel = class {
    constructor(){
        this.enabled = void 0;
        this.text = void 0;
        this.fontStyle = void 0;
        this.fontWeight = void 0;
        this.fontSize = 14;
        this.fontFamily = "Verdana, sans-serif";
        this.padding = 5;
        this.color = "rgba(87, 87, 87, 1)";
        this.position = void 0;
        this.rotation = void 0;
        this.parallel = void 0;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN, {
        optional: true
    })
], $d77b025aa58d633c$var$CartesianCrossLineLabel.prototype, "enabled", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$CartesianCrossLineLabel.prototype, "text", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$FONT_STYLE, {
        optional: true
    })
], $d77b025aa58d633c$var$CartesianCrossLineLabel.prototype, "fontStyle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$FONT_WEIGHT2, {
        optional: true
    })
], $d77b025aa58d633c$var$CartesianCrossLineLabel.prototype, "fontWeight", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$CartesianCrossLineLabel.prototype, "fontSize", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING)
], $d77b025aa58d633c$var$CartesianCrossLineLabel.prototype, "fontFamily", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$NUMBER)
], $d77b025aa58d633c$var$CartesianCrossLineLabel.prototype, "padding", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$COLOR_STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$CartesianCrossLineLabel.prototype, "color", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$CROSSLINE_LABEL_POSITION, {
        optional: true
    })
], $d77b025aa58d633c$var$CartesianCrossLineLabel.prototype, "position", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$DEGREE, {
        optional: true
    })
], $d77b025aa58d633c$var$CartesianCrossLineLabel.prototype, "rotation", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN, {
        optional: true
    })
], $d77b025aa58d633c$var$CartesianCrossLineLabel.prototype, "parallel", 2);
var $d77b025aa58d633c$var$_CartesianCrossLine = class _CartesianCrossLine {
    constructor(){
        this.id = $d77b025aa58d633c$var$createId(this);
        this.enabled = void 0;
        this.type = void 0;
        this.range = void 0;
        this.value = void 0;
        this.fill = void 0;
        this.fillOpacity = void 0;
        this.stroke = void 0;
        this.strokeWidth = void 0;
        this.strokeOpacity = void 0;
        this.lineDash = void 0;
        this.label = new $d77b025aa58d633c$var$CartesianCrossLineLabel();
        this.scale = void 0;
        this.clippedRange = [
            -Infinity,
            Infinity
        ];
        this.gridLength = 0;
        this.sideFlag = -1;
        this.parallelFlipRotation = 0;
        this.regularFlipRotation = 0;
        this.direction = "x" /* X */ ;
        this.group = new $d77b025aa58d633c$var$Group({
            name: `${this.id}`,
            layer: true,
            zIndex: _CartesianCrossLine.LINE_LAYER_ZINDEX
        });
        this.labelGroup = new $d77b025aa58d633c$var$Group({
            name: `${this.id}`,
            layer: true,
            zIndex: _CartesianCrossLine.LABEL_LAYER_ZINDEX
        });
        this.crossLineRange = new $d77b025aa58d633c$var$Range();
        this.crossLineLabel = new $d77b025aa58d633c$var$Text();
        this.labelPoint = void 0;
        this.data = [];
        this.startLine = false;
        this.endLine = false;
        this.isRange = false;
        const { group: group2, labelGroup: labelGroup, crossLineRange: crossLineRange, crossLineLabel: crossLineLabel } = this;
        group2.append(crossLineRange);
        labelGroup.append(crossLineLabel);
        crossLineRange.pointerEvents = 1 /* None */ ;
    }
    update(visible) {
        const { enabled: enabled, data: data, type: type, value: value, range: range3, scale: scale2 } = this;
        if (!type || !scale2 || !enabled || !visible || !$d77b025aa58d633c$var$validateCrossLineValues(type, value, range3, scale2) || data.length === 0) {
            this.group.visible = false;
            this.labelGroup.visible = false;
            return;
        }
        this.group.visible = visible;
        this.labelGroup.visible = visible;
        this.group.zIndex = this.getZIndex(this.isRange);
        this.updateNodes();
    }
    calculateLayout(visible, reversedAxis) {
        if (!visible) return;
        const dataCreated = this.createNodeData(reversedAxis);
        if (!dataCreated) return;
        const { sideFlag: sideFlag, gridLength: gridLength, data: data } = this;
        const boxes = [];
        const x1 = 0;
        const x2 = sideFlag * gridLength;
        const y1 = data[0];
        const y2 = data[1];
        const crossLineBox = new $d77b025aa58d633c$var$BBox(Math.min(x1, x2), Math.min(y1, y2), Math.abs(x1 - x2), Math.abs(y1 - y2));
        boxes.push(crossLineBox);
        const labelBox = this.computeLabelBBox();
        if (labelBox) boxes.push(labelBox);
        return $d77b025aa58d633c$var$BBox.merge(boxes);
    }
    updateNodes() {
        this.updateRangeNode();
        if (this.label.enabled) {
            this.updateLabel();
            this.positionLabel();
        }
    }
    createNodeData(reversedAxis) {
        var _a, _b, _c;
        const { scale: scale2, gridLength: gridLength, sideFlag: sideFlag, direction: direction, label: { position: position = "top" }, clippedRange: clippedRange, strokeWidth: strokeWidth = 0 } = this;
        this.data = [];
        if (!scale2) return false;
        const bandwidth = (_a = scale2.bandwidth) != null ? _a : 0;
        const step = (_b = scale2.step) != null ? _b : 0;
        const padding = (reversedAxis ? -1 : 1) * (scale2 instanceof $d77b025aa58d633c$var$BandScale ? (step - bandwidth) / 2 : 0);
        const [xStart, xEnd] = [
            0,
            sideFlag * gridLength
        ];
        let [yStart, yEnd] = this.getRange();
        const ordinalTimeScalePadding = yEnd === void 0 && $d77b025aa58d633c$var$OrdinalTimeScale.is(scale2) ? bandwidth / 2 + padding : 0;
        let [clampedYStart, clampedYEnd] = [
            Number(scale2.convert(yStart, {
                clampMode: "clamped"
            })) - padding + ordinalTimeScalePadding,
            scale2.convert(yEnd, {
                clampMode: "clamped"
            }) + bandwidth + padding
        ];
        clampedYStart = $d77b025aa58d633c$var$clampArray(clampedYStart, clippedRange);
        clampedYEnd = $d77b025aa58d633c$var$clampArray(clampedYEnd, clippedRange);
        [yStart, yEnd] = [
            Number(scale2.convert(yStart)) + ordinalTimeScalePadding,
            scale2.convert(yEnd) + bandwidth
        ];
        const validRange = (yStart === clampedYStart || yEnd === clampedYEnd || clampedYStart !== clampedYEnd) && Math.abs(clampedYEnd - clampedYStart) > 0;
        if (validRange && clampedYStart > clampedYEnd) {
            [clampedYStart, clampedYEnd] = [
                clampedYEnd,
                clampedYStart
            ];
            [yStart, yEnd] = [
                yEnd,
                yStart
            ];
        }
        if (yStart - padding >= clampedYStart) yStart -= padding;
        if (yEnd + padding <= clampedYEnd) yEnd += padding;
        this.isRange = validRange;
        this.startLine = strokeWidth > 0 && yStart >= clampedYStart && yStart <= clampedYStart + padding;
        this.endLine = strokeWidth > 0 && yEnd >= clampedYEnd - bandwidth - padding && yEnd <= clampedYEnd;
        if (!validRange && !this.startLine && !this.endLine) return false;
        this.data = [
            clampedYStart,
            clampedYEnd
        ];
        if (this.label.enabled) {
            const yDirection = direction === "y" /* Y */ ;
            const { c: c = $d77b025aa58d633c$var$POSITION_TOP_COORDINATES } = (_c = $d77b025aa58d633c$var$labelDirectionHandling[position]) != null ? _c : {};
            const { x: labelX, y: labelY } = c({
                yDirection: yDirection,
                xStart: xStart,
                xEnd: xEnd,
                yStart: clampedYStart,
                yEnd: clampedYEnd
            });
            this.labelPoint = {
                x: labelX,
                y: labelY
            };
        }
        return true;
    }
    updateRangeNode() {
        var _a;
        const { crossLineRange: crossLineRange, sideFlag: sideFlag, gridLength: gridLength, data: data, startLine: startLine, endLine: endLine, isRange: isRange, fill: fill, fillOpacity: fillOpacity, stroke: stroke, strokeWidth: strokeWidth, lineDash: lineDash } = this;
        crossLineRange.x1 = 0;
        crossLineRange.x2 = sideFlag * gridLength;
        crossLineRange.y1 = data[0];
        crossLineRange.y2 = data[1];
        crossLineRange.startLine = startLine;
        crossLineRange.endLine = endLine;
        crossLineRange.isRange = isRange;
        crossLineRange.fill = fill;
        crossLineRange.fillOpacity = fillOpacity != null ? fillOpacity : 1;
        crossLineRange.stroke = stroke;
        crossLineRange.strokeWidth = strokeWidth != null ? strokeWidth : 1;
        crossLineRange.strokeOpacity = (_a = this.strokeOpacity) != null ? _a : 1;
        crossLineRange.lineDash = lineDash;
    }
    updateLabel() {
        const { crossLineLabel: crossLineLabel, label: label } = this;
        if (!label.text) return;
        crossLineLabel.fontStyle = label.fontStyle;
        crossLineLabel.fontWeight = label.fontWeight;
        crossLineLabel.fontSize = label.fontSize;
        crossLineLabel.fontFamily = label.fontFamily;
        crossLineLabel.fill = label.color;
        crossLineLabel.text = label.text;
    }
    positionLabel() {
        const { crossLineLabel: crossLineLabel, labelPoint: { x: x, y: y } = {}, label: { parallel: parallel, rotation: rotation, position: position = "top", padding: padding = 0 }, direction: direction, parallelFlipRotation: parallelFlipRotation, regularFlipRotation: regularFlipRotation } = this;
        if (x === void 0 || y === void 0) return;
        const { defaultRotation: defaultRotation, configuredRotation: configuredRotation } = $d77b025aa58d633c$var$calculateLabelRotation({
            rotation: rotation,
            parallel: parallel,
            regularFlipRotation: regularFlipRotation,
            parallelFlipRotation: parallelFlipRotation
        });
        crossLineLabel.rotation = defaultRotation + configuredRotation;
        crossLineLabel.textBaseline = "middle";
        crossLineLabel.textAlign = "center";
        const bbox = crossLineLabel.computeTransformedBBox();
        if (!bbox) return;
        const yDirection = direction === "y" /* Y */ ;
        const { xTranslation: xTranslation, yTranslation: yTranslation } = $d77b025aa58d633c$var$calculateLabelTranslation({
            yDirection: yDirection,
            padding: padding,
            position: position,
            bbox: bbox
        });
        crossLineLabel.translationX = x + xTranslation;
        crossLineLabel.translationY = y + yTranslation;
    }
    getZIndex(isRange = false) {
        if (isRange) return _CartesianCrossLine.RANGE_LAYER_ZINDEX;
        return _CartesianCrossLine.LINE_LAYER_ZINDEX;
    }
    getRange() {
        var _a;
        const { value: value, range: range3, scale: scale2 } = this;
        const isContinuous2 = $d77b025aa58d633c$var$ContinuousScale.is(scale2) || $d77b025aa58d633c$var$OrdinalTimeScale.is(scale2);
        const start = (_a = range3 == null ? void 0 : range3[0]) != null ? _a : value;
        let end = range3 == null ? void 0 : range3[1];
        if (!isContinuous2 && end === void 0) end = start;
        if (isContinuous2 && start === end) end = void 0;
        return [
            start,
            end
        ];
    }
    computeLabelBBox() {
        const { label: label } = this;
        if (!label.enabled) return;
        const tempText = new $d77b025aa58d633c$var$Text();
        tempText.fontFamily = label.fontFamily;
        tempText.fontSize = label.fontSize;
        tempText.fontStyle = label.fontStyle;
        tempText.fontWeight = label.fontWeight;
        tempText.text = label.text;
        const { labelPoint: { x: x, y: y } = {}, label: { parallel: parallel, rotation: rotation, position: position = "top", padding: padding = 0 }, direction: direction, parallelFlipRotation: parallelFlipRotation, regularFlipRotation: regularFlipRotation } = this;
        if (x === void 0 || y === void 0) return;
        const { configuredRotation: configuredRotation } = $d77b025aa58d633c$var$calculateLabelRotation({
            rotation: rotation,
            parallel: parallel,
            regularFlipRotation: regularFlipRotation,
            parallelFlipRotation: parallelFlipRotation
        });
        tempText.rotation = configuredRotation;
        tempText.textBaseline = "middle";
        tempText.textAlign = "center";
        const bbox = tempText.computeTransformedBBox();
        if (!bbox) return;
        const yDirection = direction === "y" /* Y */ ;
        const { xTranslation: xTranslation, yTranslation: yTranslation } = $d77b025aa58d633c$var$calculateLabelTranslation({
            yDirection: yDirection,
            padding: padding,
            position: position,
            bbox: bbox
        });
        tempText.translationX = x + xTranslation;
        tempText.translationY = y + yTranslation;
        return tempText.computeTransformedBBox();
    }
    calculatePadding(padding) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const { isRange: isRange, startLine: startLine, endLine: endLine, direction: direction, label: { padding: labelPadding = 0, position: position = "top" } } = this;
        if (!isRange && !startLine && !endLine) return;
        const crossLineLabelBBox = this.computeLabelBBox();
        if ((crossLineLabelBBox == null ? void 0 : crossLineLabelBBox.x) == null || (crossLineLabelBBox == null ? void 0 : crossLineLabelBBox.y) == null) return;
        const chartPadding = $d77b025aa58d633c$var$calculateLabelChartPadding({
            yDirection: direction === "y" /* Y */ ,
            padding: labelPadding,
            position: position,
            bbox: crossLineLabelBBox
        });
        padding.left = Math.max((_a = padding.left) != null ? _a : 0, (_b = chartPadding.left) != null ? _b : 0);
        padding.right = Math.max((_c = padding.right) != null ? _c : 0, (_d = chartPadding.right) != null ? _d : 0);
        padding.top = Math.max((_e = padding.top) != null ? _e : 0, (_f = chartPadding.top) != null ? _f : 0);
        padding.bottom = Math.max((_g = padding.bottom) != null ? _g : 0, (_h = chartPadding.bottom) != null ? _h : 0);
    }
};
$d77b025aa58d633c$var$_CartesianCrossLine.LINE_LAYER_ZINDEX = 9 /* SERIES_CROSSLINE_LINE_ZINDEX */ ;
$d77b025aa58d633c$var$_CartesianCrossLine.RANGE_LAYER_ZINDEX = 3 /* SERIES_CROSSLINE_RANGE_ZINDEX */ ;
$d77b025aa58d633c$var$_CartesianCrossLine.LABEL_LAYER_ZINDEX = 8 /* SERIES_LABEL_ZINDEX */ ;
$d77b025aa58d633c$var$_CartesianCrossLine.className = "CrossLine";
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN, {
        optional: true
    })
], $d77b025aa58d633c$var$_CartesianCrossLine.prototype, "enabled", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$UNION([
        "range",
        "line"
    ], "a crossLine type"), {
        optional: true
    })
], $d77b025aa58d633c$var$_CartesianCrossLine.prototype, "type", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$AND($d77b025aa58d633c$var$MATCHING_CROSSLINE_TYPE("range"), $d77b025aa58d633c$var$ARRAY.restrict({
        length: 2
    })), {
        optional: true
    })
], $d77b025aa58d633c$var$_CartesianCrossLine.prototype, "range", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$MATCHING_CROSSLINE_TYPE("value"), {
        optional: true
    })
], $d77b025aa58d633c$var$_CartesianCrossLine.prototype, "value", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$COLOR_STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$_CartesianCrossLine.prototype, "fill", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$RATIO, {
        optional: true
    })
], $d77b025aa58d633c$var$_CartesianCrossLine.prototype, "fillOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$COLOR_STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$_CartesianCrossLine.prototype, "stroke", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$NUMBER, {
        optional: true
    })
], $d77b025aa58d633c$var$_CartesianCrossLine.prototype, "strokeWidth", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$RATIO, {
        optional: true
    })
], $d77b025aa58d633c$var$_CartesianCrossLine.prototype, "strokeOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$LINE_DASH, {
        optional: true
    })
], $d77b025aa58d633c$var$_CartesianCrossLine.prototype, "lineDash", 2);
var $d77b025aa58d633c$var$CartesianCrossLine = $d77b025aa58d633c$var$_CartesianCrossLine;
// packages/ag-charts-community/src/module/moduleMap.ts
var $d77b025aa58d633c$var$ModuleMap = class {
    constructor(){
        this.moduleMap = /* @__PURE__ */ new Map();
    }
    *modules() {
        for (const m of this.moduleMap.values())yield m.moduleInstance;
    }
    addModule(module, moduleFactory) {
        if (this.moduleMap.has(module.optionsKey)) throw new Error(`AG Charts - module already initialised: ${module.optionsKey}`);
        this.moduleMap.set(module.optionsKey, {
            module: module,
            moduleInstance: moduleFactory(module)
        });
    }
    removeModule(module) {
        var _a;
        const moduleKey = $d77b025aa58d633c$var$isString(module) ? module : module.optionsKey;
        (_a = this.moduleMap.get(moduleKey)) == null || _a.moduleInstance.destroy();
        this.moduleMap.delete(moduleKey);
    }
    getModule(module) {
        var _a;
        return (_a = this.moduleMap.get($d77b025aa58d633c$var$isString(module) ? module : module.optionsKey)) == null ? void 0 : _a.moduleInstance;
    }
    isEnabled(module) {
        return this.moduleMap.has($d77b025aa58d633c$var$isString(module) ? module : module.optionsKey);
    }
    mapModules(callback) {
        return Array.from(this.moduleMap.values(), (m, i)=>callback(m.moduleInstance, i));
    }
    destroy() {
        var _a;
        for (const moduleKey of this.moduleMap.keys())(_a = this.moduleMap.get(moduleKey)) == null || _a.moduleInstance.destroy();
        this.moduleMap.clear();
    }
};
// packages/ag-charts-community/src/motion/resetMotion.ts
var $d77b025aa58d633c$var$resetMotion_exports = {};
$d77b025aa58d633c$var$__export($d77b025aa58d633c$var$resetMotion_exports, {
    resetMotion: ()=>$d77b025aa58d633c$var$resetMotion
});
function $d77b025aa58d633c$var$resetMotion(selectionsOrNodes, propsFn) {
    const { nodes: nodes, selections: selections } = $d77b025aa58d633c$var$deconstructSelectionsOrNodes(selectionsOrNodes);
    for (const selection of selections){
        for (const node of selection.nodes()){
            const from = propsFn(node, node.datum);
            node.setProperties(from);
        }
        selection.cleanup();
    }
    for (const node of nodes){
        const from = propsFn(node, node.datum);
        node.setProperties(from);
    }
}
// packages/ag-charts-community/src/motion/states.ts
var $d77b025aa58d633c$var$StateMachine = class {
    constructor(initialState, states, preTransitionCb){
        this.states = states;
        this.preTransitionCb = preTransitionCb;
        this.debug = $d77b025aa58d633c$var$Debug.create(true, "animation");
        this.state = initialState;
        this.debug(`%c${this.constructor.name} | init -> ${initialState}`, "color: green");
    }
    transition(event, data) {
        var _a, _b;
        const currentStateConfig = this.states[this.state];
        const destinationTransition = currentStateConfig == null ? void 0 : currentStateConfig[event];
        if (!destinationTransition) {
            this.debug(`%c${this.constructor.name} | ${this.state} -> ${event} -> ${this.state}`, "color: grey");
            return;
        }
        let destinationState = this.state;
        if (typeof destinationTransition === "string") destinationState = destinationTransition;
        else if (typeof destinationTransition === "object") destinationState = destinationTransition.target;
        this.debug(`%c${this.constructor.name} | ${this.state} -> ${event} -> ${destinationState}`, "color: green");
        (_a = this.preTransitionCb) == null || _a.call(this, this.state, destinationState);
        this.state = destinationState;
        if (typeof destinationTransition === "function") destinationTransition(data);
        else if (typeof destinationTransition === "object") (_b = destinationTransition.action) == null || _b.call(destinationTransition, data);
        return this.state;
    }
};
// packages/ag-charts-community/src/util/numberFormat.ts
var $d77b025aa58d633c$var$group = (content)=>`(${content})`;
var $d77b025aa58d633c$var$optionalGroup = (content)=>`${$d77b025aa58d633c$var$group(content)}?`;
var $d77b025aa58d633c$var$nonCapturingGroup = (content)=>$d77b025aa58d633c$var$optionalGroup(`?:${content}`);
var $d77b025aa58d633c$var$formatRegEx = (()=>{
    const fill = ".";
    const align = "[<>=^]";
    const sign = "[+\\-( ]";
    const symbol = "[$\u20AC\xa3\xa5\u20A3\u20B9#]";
    const zero = "0";
    const width = "\\d+";
    const comma = ",";
    const precision = "\\d+";
    const tilde = "~";
    const type = "[%a-z]";
    return new RegExp([
        "^",
        $d77b025aa58d633c$var$nonCapturingGroup(`${$d77b025aa58d633c$var$optionalGroup(fill)}${$d77b025aa58d633c$var$group(align)}`),
        $d77b025aa58d633c$var$optionalGroup(sign),
        $d77b025aa58d633c$var$optionalGroup(symbol),
        $d77b025aa58d633c$var$optionalGroup(zero),
        $d77b025aa58d633c$var$optionalGroup(width),
        $d77b025aa58d633c$var$optionalGroup(comma),
        $d77b025aa58d633c$var$nonCapturingGroup(`\\.${$d77b025aa58d633c$var$group(precision)}`),
        $d77b025aa58d633c$var$optionalGroup(tilde),
        $d77b025aa58d633c$var$optionalGroup(type),
        "$"
    ].join(""), "i");
})();
var $d77b025aa58d633c$var$surroundedRegEx = (()=>{
    const prefix = ".*?";
    const content = ".+?";
    const suffix = ".*?";
    return new RegExp([
        "^",
        $d77b025aa58d633c$var$group(prefix),
        `#\\{${$d77b025aa58d633c$var$group(content)}\\}`,
        $d77b025aa58d633c$var$group(suffix),
        "$"
    ].join(""));
})();
function $d77b025aa58d633c$var$parseFormatter(formatter) {
    let prefix;
    let suffix;
    const surrounded = $d77b025aa58d633c$var$surroundedRegEx.exec(formatter);
    if (surrounded) [, prefix, formatter, suffix] = surrounded;
    const match = $d77b025aa58d633c$var$formatRegEx.exec(formatter);
    if (!match) throw new Error(`The number formatter is invalid: ${formatter}`);
    const [, fill, align, sign, symbol, zero, width, comma, precision, trim, type] = match;
    return {
        fill: fill,
        align: align,
        sign: sign,
        symbol: symbol,
        zero: zero,
        width: parseInt(width),
        comma: comma,
        precision: parseInt(precision),
        trim: Boolean(trim),
        type: type,
        prefix: prefix,
        suffix: suffix
    };
}
function $d77b025aa58d633c$var$format(formatter) {
    const options = typeof formatter === "string" ? $d77b025aa58d633c$var$parseFormatter(formatter) : formatter;
    const { fill: fill, align: align, sign: sign = "-", symbol: symbol, zero: zero, width: width, comma: comma, type: type, prefix: prefix = "", suffix: suffix = "", precision: precision } = options;
    let { trim: trim } = options;
    const precisionIsNaN = precision === void 0 || isNaN(precision);
    let formatBody;
    if (!type) {
        formatBody = $d77b025aa58d633c$var$decimalTypes["g"];
        trim = true;
    } else if (type in $d77b025aa58d633c$var$decimalTypes && type in $d77b025aa58d633c$var$integerTypes) formatBody = precisionIsNaN ? $d77b025aa58d633c$var$integerTypes[type] : $d77b025aa58d633c$var$decimalTypes[type];
    else if (type in $d77b025aa58d633c$var$decimalTypes) formatBody = $d77b025aa58d633c$var$decimalTypes[type];
    else if (type in $d77b025aa58d633c$var$integerTypes) formatBody = $d77b025aa58d633c$var$integerTypes[type];
    else throw new Error(`The number formatter type is invalid: ${type}`);
    let formatterPrecision;
    if (precision == null || precisionIsNaN) formatterPrecision = type ? 6 : 12;
    else formatterPrecision = precision;
    return (n)=>{
        let result = formatBody(n, formatterPrecision);
        if (trim) result = $d77b025aa58d633c$var$removeTrailingZeros(result);
        if (comma) result = $d77b025aa58d633c$var$insertSeparator(result, comma);
        result = $d77b025aa58d633c$var$addSign(n, result, sign);
        if (symbol && symbol !== "#") result = `${symbol}${result}`;
        if (symbol === "#" && type === "x") result = `0x${result}`;
        if (type === "s") result = `${result}${$d77b025aa58d633c$var$getSIPrefix(n)}`;
        if (type === "%" || type === "p") result = `${result}%`;
        if (width != null && !isNaN(width)) result = $d77b025aa58d633c$var$addPadding(result, width, fill != null ? fill : zero, align);
        result = `${prefix}${result}${suffix}`;
        return result;
    };
}
var $d77b025aa58d633c$var$absFloor = (n)=>Math.floor(Math.abs(n));
var $d77b025aa58d633c$var$integerTypes = {
    b: (n)=>$d77b025aa58d633c$var$absFloor(n).toString(2),
    c: (n)=>String.fromCharCode(n),
    d: (n)=>Math.round(Math.abs(n)).toFixed(0),
    o: (n)=>$d77b025aa58d633c$var$absFloor(n).toString(8),
    x: (n)=>$d77b025aa58d633c$var$absFloor(n).toString(16),
    X: (n)=>$d77b025aa58d633c$var$integerTypes.x(n).toUpperCase(),
    n: (n)=>$d77b025aa58d633c$var$integerTypes.d(n),
    "%": (n)=>`${$d77b025aa58d633c$var$absFloor(n * 100).toFixed(0)}`
};
var $d77b025aa58d633c$var$decimalTypes = {
    e: (n, f)=>Math.abs(n).toExponential(f),
    E: (n, f)=>$d77b025aa58d633c$var$decimalTypes.e(n, f).toUpperCase(),
    f: (n, f)=>Math.abs(n).toFixed(f),
    F: (n, f)=>$d77b025aa58d633c$var$decimalTypes.f(n, f).toUpperCase(),
    g: (n, f)=>{
        if (n === 0) return "0";
        const a = Math.abs(n);
        const p = Math.floor(Math.log10(a));
        if (p >= -4 && p < f) return a.toFixed(f - 1 - p);
        return a.toExponential(f - 1);
    },
    G: (n, f)=>$d77b025aa58d633c$var$decimalTypes.g(n, f).toUpperCase(),
    n: (n, f)=>$d77b025aa58d633c$var$decimalTypes.g(n, f),
    p: (n, f)=>$d77b025aa58d633c$var$decimalTypes.r(n * 100, f),
    r: (n, f)=>{
        if (n === 0) return "0";
        const a = Math.abs(n);
        const p = Math.floor(Math.log10(a));
        const q = p - (f - 1);
        if (q <= 0) return a.toFixed(-q);
        const x = Math.pow(10, q);
        return (Math.round(a / x) * x).toFixed();
    },
    s: (n, f)=>{
        const p = $d77b025aa58d633c$var$getSIPrefixPower(n);
        return $d77b025aa58d633c$var$decimalTypes.r(n / Math.pow(10, p), f);
    },
    "%": (n, f)=>$d77b025aa58d633c$var$decimalTypes.f(n * 100, f)
};
function $d77b025aa58d633c$var$removeTrailingZeros(numString) {
    return numString.replace(/\.0+$/, "").replace(/(\.[1-9])0+$/, "$1");
}
function $d77b025aa58d633c$var$insertSeparator(numString, separator) {
    let dotIndex = numString.indexOf(".");
    if (dotIndex < 0) dotIndex = numString.length;
    const integerChars = numString.substring(0, dotIndex).split("");
    const fractionalPart = numString.substring(dotIndex);
    for(let i = integerChars.length - 3; i > 0; i -= 3)integerChars.splice(i, 0, separator);
    return `${integerChars.join("")}${fractionalPart}`;
}
function $d77b025aa58d633c$var$getSIPrefix(n) {
    return $d77b025aa58d633c$var$siPrefixes[$d77b025aa58d633c$var$getSIPrefixPower(n)];
}
function $d77b025aa58d633c$var$getSIPrefixPower(n) {
    return $d77b025aa58d633c$var$clamp($d77b025aa58d633c$var$minSIPrefix, n ? Math.floor(Math.log10(Math.abs(n)) / 3) * 3 : 0, $d77b025aa58d633c$var$maxSIPrefix);
}
var $d77b025aa58d633c$var$minSIPrefix = -24;
var $d77b025aa58d633c$var$maxSIPrefix = 24;
var $d77b025aa58d633c$var$siPrefixes = {
    [$d77b025aa58d633c$var$minSIPrefix]: "y",
    [-21]: "z",
    [-18]: "a",
    [-15]: "f",
    [-12]: "p",
    [-9]: "n",
    [-6]: "\xb5",
    [-3]: "m",
    [0]: "",
    [3]: "k",
    [6]: "M",
    [9]: "G",
    [12]: "T",
    [15]: "P",
    [18]: "E",
    [21]: "Z",
    [$d77b025aa58d633c$var$maxSIPrefix]: "Y"
};
var $d77b025aa58d633c$var$minusSign = "\u2212";
function $d77b025aa58d633c$var$addSign(num, numString, signType = "") {
    if (signType === "(") return num >= 0 ? numString : `(${numString})`;
    const plusSign = signType === "+" ? "+" : "";
    return `${num >= 0 ? plusSign : $d77b025aa58d633c$var$minusSign}${numString}`;
}
function $d77b025aa58d633c$var$addPadding(numString, width, fill = " ", align = ">") {
    let result = numString;
    if (align === ">" || !align) result = result.padStart(width, fill);
    else if (align === "<") result = result.padEnd(width, fill);
    else if (align === "^") {
        const padWidth = Math.max(0, width - result.length);
        const padLeft = Math.ceil(padWidth / 2);
        const padRight = Math.floor(padWidth / 2);
        result = result.padStart(padLeft + result.length, fill);
        result = result.padEnd(padRight + result.length, fill);
    }
    return result;
}
function $d77b025aa58d633c$var$tickFormat(ticks, formatter) {
    const options = $d77b025aa58d633c$var$parseFormatter(formatter != null ? formatter : ",f");
    const { precision: precision } = options;
    if (precision == null || isNaN(precision)) {
        if (options.type === "f" || options.type === "%") options.precision = Math.max(...ticks.map((x)=>{
            if (typeof x !== "number" || x === 0) return 0;
            const l = Math.floor(Math.log10(Math.abs(x)));
            const digits = options.type ? 6 : 12;
            const exp = x.toExponential(digits - 1).replace(/\.?0+e/, "e");
            const dotIndex = exp.indexOf(".");
            if (dotIndex < 0) return l >= 0 ? 0 : -l;
            const s = exp.indexOf("e") - dotIndex;
            return Math.max(0, s - l - 1);
        }));
        else if (!options.type || options.type in $d77b025aa58d633c$var$decimalTypes) options.precision = Math.max(...ticks.map((x)=>{
            if (typeof x !== "number") return 0;
            const exp = x.toExponential((options.type ? 6 : 12) - 1).replace(/\.?0+e/, "e");
            return exp.substring(0, exp.indexOf("e")).replace(".", "").length;
        }));
    }
    const f = $d77b025aa58d633c$var$format(options);
    return (n)=>f(Number(n));
}
// packages/ag-charts-community/src/scale/logScale.ts
var $d77b025aa58d633c$var$_LogScale = class _LogScale extends $d77b025aa58d633c$var$ContinuousScale {
    constructor(){
        super([
            1,
            10
        ], [
            0,
            1
        ]);
        this.type = "log";
        this.base = 10;
        this.baseLog = $d77b025aa58d633c$var$identity;
        this.basePow = $d77b025aa58d633c$var$identity;
        this.log = (x)=>{
            const start = Math.min(...this.domain);
            return start >= 0 ? this.baseLog(x) : -this.baseLog(-x);
        };
        this.pow = (x)=>{
            const start = Math.min(...this.domain);
            return start >= 0 ? this.basePow(x) : -this.basePow(-x);
        };
        this.defaultClampMode = "clamped";
    }
    toDomain(d) {
        return d;
    }
    transform(x) {
        const start = Math.min(...this.domain);
        return start >= 0 ? Math.log(x) : -Math.log(-x);
    }
    transformInvert(x) {
        const start = Math.min(...this.domain);
        return start >= 0 ? Math.exp(x) : -Math.exp(-x);
    }
    refresh() {
        if (this.base <= 0) {
            this.base = 0;
            $d77b025aa58d633c$var$Logger.warnOnce("expecting a finite Number greater than to 0");
        }
        super.refresh();
    }
    update() {
        if (!this.domain || this.domain.length < 2) return;
        this.baseLog = _LogScale.getBaseLogMethod(this.base);
        this.basePow = _LogScale.getBasePowerMethod(this.base);
        if (this.nice) this.updateNiceDomain();
    }
    updateNiceDomain() {
        const [d0, d1] = this.domain;
        const roundStart = d0 > d1 ? Math.ceil : Math.floor;
        const roundStop = d0 > d1 ? Math.floor : Math.ceil;
        const n0 = this.pow(roundStart(this.log(d0)));
        const n1 = this.pow(roundStop(this.log(d1)));
        this.niceDomain = [
            n0,
            n1
        ];
    }
    ticks() {
        var _a;
        const count = (_a = this.tickCount) != null ? _a : 10;
        if (!this.domain || this.domain.length < 2 || count < 1) return [];
        this.refresh();
        const base = this.base;
        const [d0, d1] = this.getDomain();
        const start = Math.min(d0, d1);
        const stop = Math.max(d0, d1);
        let p0 = this.log(start);
        let p1 = this.log(stop);
        if (this.interval) {
            const step = Math.abs(this.interval);
            const absDiff = Math.abs(p1 - p0);
            let ticks2 = $d77b025aa58d633c$var$range(p0, p1, Math.min(absDiff, step));
            ticks2 = $d77b025aa58d633c$var$createNumericTicks(ticks2.fractionDigits, ticks2.map((x)=>this.pow(x)).filter((t)=>t >= start && t <= stop));
            const availableRange = this.getPixelRange();
            if (!$d77b025aa58d633c$var$isDenseInterval({
                start: start,
                stop: stop,
                interval: step,
                count: ticks2.length,
                availableRange: availableRange
            })) return ticks2;
        }
        const isBaseInteger = base % 1 === 0;
        const isDiffLarge = p1 - p0 >= count;
        if (!isBaseInteger || isDiffLarge) {
            let ticks2 = $d77b025aa58d633c$var$ticks_default(p0, p1, Math.min(p1 - p0, count));
            ticks2 = $d77b025aa58d633c$var$createNumericTicks(ticks2.fractionDigits, ticks2.map((x)=>this.pow(x)));
            return ticks2;
        }
        const ticks = [];
        const isPositive = start > 0;
        p0 = Math.floor(p0) - 1;
        p1 = Math.round(p1) + 1;
        const availableSpacing = $d77b025aa58d633c$var$findRangeExtent(this.range) / count;
        let lastTickPosition = Infinity;
        for(let p = p0; p <= p1; p++){
            const nextMagnitudeTickPosition = this.convert(this.pow(p + 1));
            for(let k = 1; k < base; k++){
                const q = isPositive ? k : base - k + 1;
                const t = this.pow(p) * q;
                const tickPosition = this.convert(t);
                const prevSpacing = Math.abs(lastTickPosition - tickPosition);
                const nextSpacing = Math.abs(tickPosition - nextMagnitudeTickPosition);
                const fits = prevSpacing >= availableSpacing && nextSpacing >= availableSpacing;
                if (t >= start && t <= stop && (k === 1 || fits || ticks.length === 0)) {
                    ticks.push(t);
                    lastTickPosition = tickPosition;
                }
            }
        }
        return ticks;
    }
    tickFormat({ count: count, ticks: ticks, specifier: specifier }) {
        if (count !== Infinity && ticks == null) this.ticks();
        specifier != null ? specifier : specifier = this.base === 10 ? ".0e" : ",";
        return $d77b025aa58d633c$var$isString(specifier) ? $d77b025aa58d633c$var$format(specifier) : specifier;
    }
    static getBaseLogMethod(base) {
        switch(base){
            case 10:
                return Math.log10;
            case Math.E:
                return Math.log;
            case 2:
                return Math.log2;
            default:
                const logBase = Math.log(base);
                return (x)=>Math.log(x) / logBase;
        }
    }
    static getBasePowerMethod(base) {
        switch(base){
            case 10:
                return (x)=>x >= 0 ? $d77b025aa58d633c$var$__pow(10, x) : 1 / $d77b025aa58d633c$var$__pow(10, -x);
            case Math.E:
                return Math.exp;
            default:
                return (x)=>$d77b025aa58d633c$var$__pow(base, x);
        }
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Invalidating
], $d77b025aa58d633c$var$_LogScale.prototype, "base", 2);
var $d77b025aa58d633c$var$LogScale = $d77b025aa58d633c$var$_LogScale;
// packages/ag-charts-community/src/scene/selection.ts
var $d77b025aa58d633c$var$Selection = class _Selection {
    constructor(parentNode, classOrFactory, autoCleanup = true){
        this.parentNode = parentNode;
        this.autoCleanup = autoCleanup;
        this.garbageBin = /* @__PURE__ */ new Set();
        this._nodesMap = /* @__PURE__ */ new Map();
        this._nodes = [];
        this.data = [];
        this.debug = $d77b025aa58d633c$var$Debug.create(true, "scene", "scene:selections");
        this.nodeFactory = Object.prototype.isPrototypeOf.call($d77b025aa58d633c$var$Node, classOrFactory) ? ()=>new classOrFactory() : classOrFactory;
    }
    static select(parent, classOrFactory, garbageCollection = true) {
        return new _Selection(parent, classOrFactory, garbageCollection);
    }
    static selectAll(parent, predicate) {
        const results = [];
        const traverse = (node)=>{
            if (predicate(node)) results.push(node);
            node.children.forEach(traverse);
        };
        traverse(parent);
        return results;
    }
    static selectByClass(node, Class, ...ExtraClasses) {
        return _Selection.selectAll(node, (n)=>{
            return n instanceof Class || ExtraClasses.some((C)=>n instanceof C);
        });
    }
    static selectByTag(node, tag) {
        return _Selection.selectAll(node, (n)=>n.tag === tag);
    }
    createNode(datum, initializer, idx) {
        const node = this.nodeFactory(datum);
        node.datum = datum;
        initializer == null || initializer(node);
        if (idx == null) this._nodes.push(node);
        else this._nodes.splice(idx, 0, node);
        this.parentNode.appendChild(node);
        return node;
    }
    /**
   * Update the data in a selection. If an `getDatumId()` function is provided, maintain a list of ids related to
   * the nodes. Otherwise, take the more efficient route of simply creating and destroying nodes at the end
   * of the array.
   */ update(data, initializer, getDatumId) {
        if (this.garbageBin.size > 0) this.debug(`Selection - update() called with pending garbage: ${data}`);
        if (getDatumId) {
            const dataMap = new Map(data.map((datum, idx)=>[
                    getDatumId(datum),
                    [
                        datum,
                        idx
                    ]
                ]));
            for (const [node, datumId] of this._nodesMap.entries())if (dataMap.has(datumId)) {
                const [newDatum] = dataMap.get(datumId);
                node.datum = newDatum;
                this.garbageBin.delete(node);
                dataMap.delete(datumId);
            } else this.garbageBin.add(node);
            for (const [datumId, [datum, idx]] of dataMap.entries())this._nodesMap.set(this.createNode(datum, initializer, idx), datumId);
        } else {
            const maxLength = Math.max(data.length, this.data.length);
            for(let i = 0; i < maxLength; i++){
                if (i >= data.length) this.garbageBin.add(this._nodes[i]);
                else if (i >= this._nodes.length) this.createNode(data[i], initializer);
                else {
                    this._nodes[i].datum = data[i];
                    this.garbageBin.delete(this._nodes[i]);
                }
            }
        }
        this.data = data.slice();
        if (this.autoCleanup) this.cleanup();
        return this;
    }
    cleanup() {
        if (this.garbageBin.size === 0) return this;
        this._nodes = this._nodes.filter((node)=>{
            if (this.garbageBin.has(node)) {
                this._nodesMap.delete(node);
                this.garbageBin.delete(node);
                this.parentNode.removeChild(node);
                return false;
            }
            return true;
        });
        return this;
    }
    clear() {
        this.update([]);
        return this;
    }
    isGarbage(node) {
        return this.garbageBin.has(node);
    }
    hasGarbage() {
        return this.garbageBin.size > 0;
    }
    each(iterate2) {
        for (const entry of this._nodes.entries())iterate2(entry[1], entry[1].datum, entry[0]);
        return this;
    }
    *[Symbol.iterator]() {
        for(let index = 0; index < this._nodes.length; index++){
            const node = this._nodes[index];
            const datum = this._nodes[index].datum;
            yield {
                node: node,
                datum: datum,
                index: index
            };
        }
    }
    select(predicate) {
        return _Selection.selectAll(this.parentNode, predicate);
    }
    selectByClass(Class) {
        return _Selection.selectByClass(this.parentNode, Class);
    }
    selectByTag(tag) {
        return _Selection.selectByTag(this.parentNode, tag);
    }
    nodes() {
        return this._nodes;
    }
};
// packages/ag-charts-community/src/util/distance.ts
function $d77b025aa58d633c$var$pointsDistanceSquared(x1, y1, x2, y2) {
    const dx = x1 - x2;
    const dy = y1 - y2;
    return dx * dx + dy * dy;
}
function $d77b025aa58d633c$var$lineDistanceSquared(x, y, x1, y1, x2, y2, best) {
    if (x1 === x2 && y1 === y2) return Math.min(best, $d77b025aa58d633c$var$pointsDistanceSquared(x, y, x1, y1));
    const dx = x2 - x1;
    const dy = y2 - y1;
    const t = Math.max(0, Math.min(1, ((x - x1) * dx + (y - y1) * dy) / (dx * dx + dy * dy)));
    const ix = x1 + t * dx;
    const iy = y1 + t * dy;
    return Math.min(best, $d77b025aa58d633c$var$pointsDistanceSquared(x, y, ix, iy));
}
function $d77b025aa58d633c$var$arcDistanceSquared(x, y, cx, cy, radius, startAngle, endAngle, counterClockwise, best) {
    if (counterClockwise) [endAngle, startAngle] = [
        startAngle,
        endAngle
    ];
    const angle = Math.atan2(y - cy, x - cx);
    if (!$d77b025aa58d633c$var$isBetweenAngles(angle, startAngle, endAngle)) {
        const startX = cx + Math.cos(startAngle) * radius;
        const startY = cy + Math.sin(startAngle) * radius;
        const endX = cx + Math.cos(startAngle) * radius;
        const endY = cy + Math.sin(startAngle) * radius;
        return Math.min(best, $d77b025aa58d633c$var$pointsDistanceSquared(x, y, startX, startY), $d77b025aa58d633c$var$pointsDistanceSquared(x, y, endX, endY));
    }
    const distToArc = radius - Math.sqrt($d77b025aa58d633c$var$pointsDistanceSquared(x, y, cx, cy));
    return Math.min(best, distToArc * distToArc);
}
// packages/ag-charts-community/src/scene/shape/line.ts
var $d77b025aa58d633c$var$Line = class extends $d77b025aa58d633c$var$Shape {
    constructor(opts = {}){
        super(opts);
        this.x1 = 0;
        this.y1 = 0;
        this.x2 = 0;
        this.y2 = 0;
        this.restoreOwnStyles();
    }
    set x(value) {
        this.x1 = value;
        this.x2 = value;
    }
    set y(value) {
        this.y1 = value;
        this.y2 = value;
    }
    computeBBox() {
        return new $d77b025aa58d633c$var$BBox(Math.min(this.x1, this.x2), Math.min(this.y1, this.y2), Math.abs(this.x2 - this.x1), Math.abs(this.y2 - this.y1));
    }
    isPointInPath(px, py) {
        if (this.x1 === this.x2 || this.y1 === this.y2) {
            const { x: x, y: y } = this.transformPoint(px, py);
            return this.computeBBox().grow(this.strokeWidth / 2).containsPoint(x, y);
        }
        return false;
    }
    distanceSquared(px, py) {
        const { x1: x1, y1: y1, x2: x2, y2: y2 } = this;
        return $d77b025aa58d633c$var$lineDistanceSquared(px, py, x1, y1, x2, y2, Infinity);
    }
    render(renderCtx) {
        var _a;
        const { ctx: ctx, forceRender: forceRender, stats: stats, devicePixelRatio: devicePixelRatio } = renderCtx;
        if (this.dirty === 0 /* NONE */  && !forceRender) {
            if (stats) stats.nodesSkipped += this.nodeCount.count;
            return;
        }
        this.computeTransformMatrix();
        this.matrix.toContext(ctx);
        let { x1: x1, y1: y1, x2: x2, y2: y2 } = this;
        if (x1 === x2) {
            const { strokeWidth: strokeWidth } = this;
            const x = Math.round(x1 * devicePixelRatio) / devicePixelRatio + Math.trunc(strokeWidth * devicePixelRatio) % 2 / (devicePixelRatio * 2);
            x1 = x;
            x2 = x;
        } else if (y1 === y2) {
            const { strokeWidth: strokeWidth } = this;
            const y = Math.round(y1 * devicePixelRatio) / devicePixelRatio + Math.trunc(strokeWidth * devicePixelRatio) % 2 / (devicePixelRatio * 2);
            y1 = y;
            y2 = y;
        }
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        this.fillStroke(ctx);
        (_a = this.fillShadow) == null || _a.markClean();
        super.render(renderCtx);
    }
};
$d77b025aa58d633c$var$Line.className = "Line";
$d77b025aa58d633c$var$Line.defaultStyles = Object.assign({}, $d77b025aa58d633c$var$Shape.defaultStyles, {
    fill: void 0,
    strokeWidth: 1
});
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 3 /* MAJOR */ 
    })
], $d77b025aa58d633c$var$Line.prototype, "x1", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 3 /* MAJOR */ 
    })
], $d77b025aa58d633c$var$Line.prototype, "y1", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 3 /* MAJOR */ 
    })
], $d77b025aa58d633c$var$Line.prototype, "x2", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 3 /* MAJOR */ 
    })
], $d77b025aa58d633c$var$Line.prototype, "y2", 2);
// packages/ag-charts-community/src/scene/util/labelPlacement.ts
function $d77b025aa58d633c$var$circleRectOverlap(c, unitCenter, x, y, w, h) {
    if (c.size === 0) return false;
    let cx = c.x;
    let cy = c.y;
    if (unitCenter != null) {
        cx -= (unitCenter.x - 0.5) * c.size;
        cy -= (unitCenter.y - 0.5) * c.size;
    }
    let edgeX = cx;
    if (cx < x) edgeX = x;
    else if (cx > x + w) edgeX = x + w;
    let edgeY = cy;
    if (cy < y) edgeY = y;
    else if (cy > y + h) edgeY = y + h;
    const dx = cx - edgeX;
    const dy = cy - edgeY;
    const d = Math.sqrt(dx * dx + dy * dy);
    return d <= c.size * 0.5;
}
function $d77b025aa58d633c$var$rectRectOverlap(r1, x2, y2, w2, h2) {
    const xOverlap = r1.x + r1.width > x2 && r1.x < x2 + w2;
    const yOverlap = r1.y + r1.height > y2 && r1.y < y2 + h2;
    return xOverlap && yOverlap;
}
function $d77b025aa58d633c$var$rectContainsRect(r1, r2x, r2y, r2w, r2h) {
    return r2x + r2w < r1.x + r1.width && r2x > r1.x && r2y > r1.y && r2y + r2h < r1.y + r1.height;
}
function $d77b025aa58d633c$var$isPointLabelDatum(x) {
    return x != null && typeof x.point === "object" && typeof x.label === "object";
}
var $d77b025aa58d633c$var$labelPlacements = {
    top: {
        x: 0,
        y: -1
    },
    bottom: {
        x: 0,
        y: 1
    },
    left: {
        x: -1,
        y: 0
    },
    right: {
        x: 1,
        y: 0
    }
};
function $d77b025aa58d633c$var$placeLabels(data, bounds, padding = 5) {
    var _a, _b;
    const result = [];
    data = data.map((d)=>d.slice().sort((a, b)=>b.point.size - a.point.size));
    for(let j = 0; j < data.length; j++){
        const labels = result[j] = [];
        const datum = data[j];
        if (!((datum == null ? void 0 : datum.length) && datum[0].label)) continue;
        for(let i = 0, ln = datum.length; i < ln; i++){
            const d = datum[i];
            const { point: point, label: label, marker: marker } = d;
            const { text: text, width: width, height: height } = label;
            const r = point.size * 0.5;
            let dx = 0;
            let dy = 0;
            if (r > 0 && d.placement != null) {
                const placement = $d77b025aa58d633c$var$labelPlacements[d.placement];
                dx = (width * 0.5 + r + padding) * placement.x;
                dy = (height * 0.5 + r + padding) * placement.y;
            }
            const x = point.x - width * 0.5 + dx - (((_a = marker == null ? void 0 : marker.center.x) != null ? _a : 0.5) - 0.5) * point.size;
            const y = point.y - height * 0.5 + dy - (((_b = marker == null ? void 0 : marker.center.y) != null ? _b : 0.5) - 0.5) * point.size;
            const withinBounds = !bounds || $d77b025aa58d633c$var$rectContainsRect(bounds, x, y, width, height);
            if (!withinBounds) continue;
            const overlapPoints = data.some((dataDatums)=>dataDatums.some((dataDatum)=>{
                    var _a2;
                    return $d77b025aa58d633c$var$circleRectOverlap(dataDatum.point, (_a2 = dataDatum.marker) == null ? void 0 : _a2.center, x, y, width, height);
                }));
            if (overlapPoints) continue;
            const overlapLabels = result.some((l2)=>l2.some((l3)=>$d77b025aa58d633c$var$rectRectOverlap(l3, x, y, width, height)));
            if (overlapLabels) continue;
            labels.push({
                index: i,
                text: text,
                x: x,
                y: y,
                width: width,
                height: height,
                datum: d
            });
        }
    }
    return result;
}
function $d77b025aa58d633c$var$axisLabelsOverlap(data, padding) {
    const result = [];
    for(let i = 0; i < data.length; i++){
        const datum = data[i];
        const { point: { x: x, y: y }, label: { text: text } } = datum;
        let { label: { width: width, height: height } } = datum;
        width += padding != null ? padding : 0;
        height += padding != null ? padding : 0;
        const overlapLabels = result.some((l)=>{
            return $d77b025aa58d633c$var$rectRectOverlap(l, x, y, width, height);
        });
        if (overlapLabels) return true;
        result.push({
            index: i,
            text: text,
            x: x,
            y: y,
            width: width,
            height: height,
            datum: datum
        });
    }
    return false;
}
// packages/ag-charts-community/src/util/equal.ts
function $d77b025aa58d633c$var$areArrayItemsStrictlyEqual(arrA, arrB) {
    return arrA.length === arrB.length && arrA.every((a, i)=>{
        const b = arrB[i];
        if (Array.isArray(a) && Array.isArray(b)) return $d77b025aa58d633c$var$areArrayItemsStrictlyEqual(a, b);
        return a === b;
    });
}
function $d77b025aa58d633c$var$areArrayNumbersEqual(arrA, arrB) {
    return arrA.length === arrB.length && arrA.every((item, i)=>Number(item) === Number(arrB[i]));
}
// packages/ag-charts-community/src/util/proxy.ts
function $d77b025aa58d633c$var$ProxyProperty(proxyPath) {
    const pathArray = $d77b025aa58d633c$var$isArray(proxyPath) ? proxyPath : proxyPath.split(".");
    if (pathArray.length === 1) {
        const [property] = pathArray;
        return $d77b025aa58d633c$var$addTransformToInstanceProperty((target, _, value)=>target[property] = value, (target)=>target[property]);
    }
    return $d77b025aa58d633c$var$addTransformToInstanceProperty((target, _, value)=>$d77b025aa58d633c$var$setPath(target, pathArray, value), (target)=>$d77b025aa58d633c$var$getPath(target, pathArray));
}
function $d77b025aa58d633c$var$ProxyOnWrite(proxyProperty) {
    return $d77b025aa58d633c$var$addTransformToInstanceProperty((target, _, value)=>target[proxyProperty] = value);
}
function $d77b025aa58d633c$var$ProxyPropertyOnWrite(childName, childProperty) {
    return $d77b025aa58d633c$var$addTransformToInstanceProperty((target, key, value)=>target[childName][childProperty != null ? childProperty : key] = value);
}
function $d77b025aa58d633c$var$ActionOnSet(opts) {
    const { newValue: newValueFn, oldValue: oldValueFn, changeValue: changeValueFn } = opts;
    return $d77b025aa58d633c$var$addTransformToInstanceProperty((target, _, newValue, oldValue)=>{
        if (newValue !== oldValue) {
            if (oldValue !== void 0) oldValueFn == null || oldValueFn.call(target, oldValue);
            if (newValue !== void 0) newValueFn == null || newValueFn.call(target, newValue);
            changeValueFn == null || changeValueFn.call(target, newValue, oldValue);
        }
        return newValue;
    });
}
function $d77b025aa58d633c$var$ObserveChanges(observerFn) {
    return $d77b025aa58d633c$var$addObserverToInstanceProperty(observerFn);
}
// packages/ag-charts-community/src/util/attributeUtil.ts
function $d77b025aa58d633c$var$setAttribute(e, qualifiedName, value) {
    if (value === void 0 || value === "") e == null || e.removeAttribute(qualifiedName);
    else e == null || e.setAttribute(qualifiedName, value.toString());
}
// packages/ag-charts-community/src/util/placement.ts
function $d77b025aa58d633c$var$calculatePlacement(naturalWidth, naturalHeight, containerWidth, containerHeight, bounds) {
    let { top: top, right: right, bottom: bottom, left: left, width: width, height: height } = bounds;
    if (left != null) {
        if (width != null) right = containerWidth - left + width;
        else if (right != null) width = containerWidth - left - right;
    } else if (right != null && width != null) left = containerWidth - right - width;
    if (top != null) {
        if (height != null) bottom = containerHeight - top - height;
        else if (bottom != null) height = containerHeight - bottom - top;
    } else if (bottom != null && height != null) top = containerHeight - bottom - height;
    if (width == null) {
        if (height == null) {
            width = naturalWidth;
            height = naturalHeight;
        } else width = Math.ceil(naturalWidth * height / naturalHeight);
    } else if (height == null) height = Math.ceil(naturalHeight * width / naturalWidth);
    if (left == null) {
        if (right == null) left = Math.floor((containerWidth - width) / 2);
        else left = containerWidth - right - width;
    }
    if (top == null) {
        if (bottom == null) top = Math.floor((containerHeight - height) / 2);
        else top = containerHeight - height - bottom;
    }
    return {
        x: left,
        y: top,
        width: width,
        height: height
    };
}
// packages/ag-charts-community/src/chart/tooltip/tooltip.ts
var $d77b025aa58d633c$var$DEFAULT_TOOLTIP_CLASS = "ag-chart-tooltip";
var $d77b025aa58d633c$var$DEFAULT_TOOLTIP_DARK_CLASS = "ag-chart-dark-tooltip";
var $d77b025aa58d633c$var$EMPTY_TOOLTIP_CONTENT = {
    html: "",
    ariaLabel: ""
};
function $d77b025aa58d633c$var$toAccessibleText(inputHtml) {
    const lineConverter = (_match, offset4, str)=>{
        if (offset4 === 0 || str[offset4 - 1] !== ".") return ". ";
        return " ";
    };
    return inputHtml.replace(/<br\s*\/?>/g, lineConverter).replace(/<\/p\s+>/g, lineConverter).replace(/<\/li\s*\/>/g, lineConverter).replace(/<[^>]+>/g, "");
}
function $d77b025aa58d633c$var$toTooltipHtml(input, defaults) {
    var _a, _b, _c;
    if (typeof input === "string") return {
        html: input,
        ariaLabel: input
    };
    const { content: content = (_a = defaults == null ? void 0 : defaults.content) != null ? _a : "", title: title = defaults == null ? void 0 : defaults.title, color: color = (_b = defaults == null ? void 0 : defaults.color) != null ? _b : "white", backgroundColor: backgroundColor = (_c = defaults == null ? void 0 : defaults.backgroundColor) != null ? _c : "#888" } = input;
    const titleHtml = title ? `<div class="${$d77b025aa58d633c$var$DEFAULT_TOOLTIP_CLASS}-title"
        style="color: ${color}; background-color: ${backgroundColor}">${title}</div>` : "";
    const titleAria = title ? `${title}: ` : "";
    const contentHtml = content ? `<div class="${$d77b025aa58d633c$var$DEFAULT_TOOLTIP_CLASS}-content">${content}</div>` : "";
    return {
        html: `${titleHtml}${contentHtml}`,
        ariaLabel: $d77b025aa58d633c$var$toAccessibleText(`${titleAria}${content}`)
    };
}
var $d77b025aa58d633c$var$TooltipPosition = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        /** The type of positioning for the tooltip. By default, the tooltip follows the pointer. */ this.type = "pointer";
        /** The horizontal offset in pixels for the position of the tooltip. */ this.xOffset = 0;
        /** The vertical offset in pixels for the position of the tooltip. */ this.yOffset = 0;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$UNION([
        "pointer",
        "node",
        "top",
        "right",
        "bottom",
        "left",
        "top-left",
        "top-right",
        "bottom-right",
        "bottom-left"
    ], "a position type"))
], $d77b025aa58d633c$var$TooltipPosition.prototype, "type", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$NUMBER)
], $d77b025aa58d633c$var$TooltipPosition.prototype, "xOffset", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$NUMBER)
], $d77b025aa58d633c$var$TooltipPosition.prototype, "yOffset", 2);
var $d77b025aa58d633c$var$Tooltip = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super();
        this.enabled = true;
        this.delay = 0;
        this.range = "nearest";
        this.wrapping = "hyphenate";
        this.position = new $d77b025aa58d633c$var$TooltipPosition();
        this.darkTheme = false;
        this.enableInteraction = false;
        this.lastVisibilityChange = Date.now();
        this.wrapTypes = [
            "always",
            "hyphenate",
            "on-space",
            "never"
        ];
        this.showTimeout = 0;
        this._showArrow = true;
        this.element = $d77b025aa58d633c$var$createElement("div", $d77b025aa58d633c$var$DEFAULT_TOOLTIP_CLASS);
        $d77b025aa58d633c$var$setAttribute(this.element, "aria-hidden", true);
        this.root = $d77b025aa58d633c$var$getDocument("body");
        this.root.appendChild(this.element);
    }
    destroy() {
        this.element.remove();
    }
    isVisible() {
        return !this.element.classList.contains($d77b025aa58d633c$var$DEFAULT_TOOLTIP_CLASS + "-hidden");
    }
    /**
   * Shows tooltip at the given event's coordinates.
   * If the `html` parameter is missing, moves the existing tooltip to the new position.
   */ show(canvasRect, meta, content, instantly = false) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i;
        const { element: element2 } = this;
        if (content != null) element2.innerHTML = content.html;
        else if (!element2.innerHTML) {
            this.toggle(false);
            return;
        }
        const positionType = (_b = (_a = meta.position) == null ? void 0 : _a.type) != null ? _b : this.position.type;
        const xOffset = (_d = (_c = meta.position) == null ? void 0 : _c.xOffset) != null ? _d : 0;
        const yOffset = (_f = (_e = meta.position) == null ? void 0 : _e.yOffset) != null ? _f : 0;
        const tooltipBounds = this.getTooltipBounds({
            positionType: positionType,
            meta: meta,
            yOffset: yOffset,
            xOffset: xOffset,
            canvasRect: canvasRect
        });
        const windowBounds = this.getWindowSize();
        const position = $d77b025aa58d633c$var$calculatePlacement(element2.clientWidth, element2.clientHeight, canvasRect.width, canvasRect.height, tooltipBounds);
        position.x += canvasRect.x;
        position.y += canvasRect.y;
        const left = $d77b025aa58d633c$var$clamp(0, position.x, windowBounds.width - element2.clientWidth - 1);
        const top = $d77b025aa58d633c$var$clamp(0, position.y, windowBounds.height - element2.clientHeight);
        const constrained = left !== position.x || top !== position.y;
        const defaultShowArrow = (positionType === "node" || positionType === "pointer") && !constrained && !xOffset && !yOffset;
        const showArrow = (_h = (_g = meta.showArrow) != null ? _g : this.showArrow) != null ? _h : defaultShowArrow;
        this.updateShowArrow(showArrow);
        element2.style.transform = `translate(${Math.round(left)}px, ${Math.round(top)}px)`;
        this.enableInteraction = (_i = meta.enableInteraction) != null ? _i : false;
        if (this.delay > 0 && !instantly) {
            this.toggle(false);
            this.showTimeout = setTimeout(()=>{
                this.toggle(true);
            }, this.delay);
        } else this.toggle(true);
    }
    getWindowSize() {
        const { innerWidth: innerWidth, innerHeight: innerHeight } = $d77b025aa58d633c$var$getWindow();
        return {
            width: innerWidth,
            height: innerHeight
        };
    }
    toggle(visible) {
        const { classList: classList } = this.element;
        const toggleClass = (name, include)=>classList.toggle(`${$d77b025aa58d633c$var$DEFAULT_TOOLTIP_CLASS}-${name}`, include);
        const wasVisible = this.isVisible();
        let timeSinceLastVisibilityChangeMs = Infinity;
        if (!visible) clearTimeout(this.showTimeout);
        if (wasVisible !== visible) {
            const now = Date.now();
            timeSinceLastVisibilityChangeMs = now - this.lastVisibilityChange;
            this.lastVisibilityChange = now;
        }
        const animatedMoveThresholdMs = 100;
        const thrashingThresholdMs = 5;
        const noAnimation = !wasVisible && visible && timeSinceLastVisibilityChangeMs > animatedMoveThresholdMs;
        if (timeSinceLastVisibilityChangeMs > thrashingThresholdMs) toggleClass("no-animation", noAnimation);
        toggleClass("no-interaction", !this.enableInteraction);
        toggleClass("hidden", !visible);
        toggleClass("arrow", this._showArrow);
        classList.toggle($d77b025aa58d633c$var$DEFAULT_TOOLTIP_DARK_CLASS, this.darkTheme);
        for (const wrapType of this.wrapTypes)classList.toggle(`${$d77b025aa58d633c$var$DEFAULT_TOOLTIP_CLASS}-wrap-${wrapType}`, wrapType === this.wrapping);
    }
    pointerLeftOntoTooltip(event) {
        var _a;
        if (!this.enableInteraction) return false;
        const classList = (_a = event.sourceEvent.relatedTarget) == null ? void 0 : _a.classList;
        const classes = [
            "",
            "-title",
            "-content"
        ];
        const classListContains = Boolean(classes.filter((c)=>classList == null ? void 0 : classList.contains(`${$d77b025aa58d633c$var$DEFAULT_TOOLTIP_CLASS}${c}`)));
        return classList !== void 0 && classListContains;
    }
    updateShowArrow(show) {
        this._showArrow = show;
    }
    getTooltipBounds({ positionType: positionType, meta: meta, yOffset: yOffset, xOffset: xOffset, canvasRect: canvasRect }) {
        const { clientWidth: tooltipWidth, clientHeight: tooltipHeight } = this.element;
        const bounds = {
            width: tooltipWidth,
            height: tooltipHeight
        };
        switch(positionType){
            case "node":
            case "pointer":
                bounds.top = meta.offsetY + yOffset - tooltipHeight - 8;
                bounds.left = meta.offsetX + xOffset - tooltipWidth / 2;
                return bounds;
            case "top":
                bounds.top = yOffset;
                bounds.left = canvasRect.width / 2 - tooltipWidth / 2 + xOffset;
                return bounds;
            case "right":
                bounds.top = canvasRect.height / 2 - tooltipHeight / 2 + yOffset;
                bounds.left = canvasRect.width - tooltipWidth / 2 + xOffset;
                return bounds;
            case "left":
                bounds.top = canvasRect.height / 2 - tooltipHeight / 2 + yOffset;
                bounds.left = xOffset;
                return bounds;
            case "bottom":
                bounds.top = canvasRect.height - tooltipHeight + yOffset;
                bounds.left = canvasRect.width / 2 - tooltipWidth / 2 + xOffset;
                return bounds;
            case "top-left":
                bounds.top = yOffset;
                bounds.left = xOffset;
                return bounds;
            case "top-right":
                bounds.top = yOffset;
                bounds.left = canvasRect.width - tooltipWidth + xOffset;
                return bounds;
            case "bottom-right":
                bounds.top = canvasRect.height - tooltipHeight + yOffset;
                bounds.left = canvasRect.width - tooltipWidth + xOffset;
                return bounds;
            case "bottom-left":
                bounds.top = canvasRect.height - tooltipHeight + yOffset;
                bounds.left = xOffset;
                return bounds;
        }
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN)
], $d77b025aa58d633c$var$Tooltip.prototype, "enabled", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN, {
        optional: true
    })
], $d77b025aa58d633c$var$Tooltip.prototype, "showArrow", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ObserveChanges((target, newValue, oldValue)=>{
        if (newValue) target.element.classList.add(newValue);
        if (oldValue) target.element.classList.remove(oldValue);
    }),
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$Tooltip.prototype, "class", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$Tooltip.prototype, "delay", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$INTERACTION_RANGE)
], $d77b025aa58d633c$var$Tooltip.prototype, "range", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$TEXT_WRAP)
], $d77b025aa58d633c$var$Tooltip.prototype, "wrapping", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$Tooltip.prototype, "position", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN)
], $d77b025aa58d633c$var$Tooltip.prototype, "darkTheme", 2);
// packages/ag-charts-community/src/chart/caption.ts
var $d77b025aa58d633c$var$Caption = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.id = $d77b025aa58d633c$var$createId(this);
        this.node = new $d77b025aa58d633c$var$Text({
            zIndex: 1
        }).setProperties({
            textAlign: "center",
            pointerEvents: 1 /* None */ 
        });
        this.enabled = false;
        this.textAlign = "center";
        this.fontSize = 10;
        this.fontFamily = "sans-serif";
        this.wrapping = "always";
        this.truncated = false;
    }
    getOrAddRegion(moduleCtx, regionName) {
        if (regionName === "root") return moduleCtx.regionManager.getRegion("root");
        else return moduleCtx.regionManager.addRegionFromProperties({
            name: regionName,
            bboxproviders: [
                this.node
            ],
            canInteraction: ()=>this.enabled && this.node.visible
        });
    }
    registerInteraction(moduleCtx, regionName) {
        const region = this.getOrAddRegion(moduleCtx, regionName);
        const destroyFns = [
            region.addListener("hover", (event)=>this.handleMouseMove(moduleCtx, event)),
            region.addListener("leave", (event)=>this.handleMouseLeave(moduleCtx, event))
        ];
        return $d77b025aa58d633c$var$joinFunctions(...destroyFns);
    }
    computeTextWrap(containerWidth, containerHeight) {
        var _a, _b;
        const { text: text, wrapping: wrapping } = this;
        const maxWidth = Math.min((_a = this.maxWidth) != null ? _a : Infinity, containerWidth);
        const maxHeight = (_b = this.maxHeight) != null ? _b : containerHeight;
        if (!isFinite(maxWidth) && !isFinite(maxHeight)) {
            this.node.text = text;
            return;
        }
        const { text: wrappedText, truncated: truncated } = $d77b025aa58d633c$var$Text.wrap(text != null ? text : "", maxWidth, maxHeight, this, wrapping);
        this.node.text = wrappedText;
        this.truncated = truncated;
    }
    updateTooltip(moduleCtx, event) {
        if (event !== void 0 && this.enabled && this.node.visible && this.truncated) {
            const { offsetX: offsetX, offsetY: offsetY } = event;
            moduleCtx.tooltipManager.updateTooltip(this.id, {
                offsetX: offsetX,
                offsetY: offsetY,
                lastPointerEvent: event,
                showArrow: false
            }, $d77b025aa58d633c$var$toTooltipHtml({
                content: this.text
            }));
            return true;
        }
        return false;
    }
    handleMouseMove(moduleCtx, event) {
        if (this.updateTooltip(moduleCtx, event)) event.consume();
    }
    handleMouseLeave(moduleCtx, _event) {
        moduleCtx.tooltipManager.removeTooltip(this.id);
    }
};
$d77b025aa58d633c$var$Caption.SMALL_PADDING = 10;
$d77b025aa58d633c$var$Caption.LARGE_PADDING = 20;
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN)
], $d77b025aa58d633c$var$Caption.prototype, "enabled", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    }),
    $d77b025aa58d633c$var$ProxyPropertyOnWrite("node")
], $d77b025aa58d633c$var$Caption.prototype, "text", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$TEXT_ALIGN, {
        optional: true
    }),
    $d77b025aa58d633c$var$ProxyPropertyOnWrite("node")
], $d77b025aa58d633c$var$Caption.prototype, "textAlign", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$FONT_STYLE, {
        optional: true
    }),
    $d77b025aa58d633c$var$ProxyPropertyOnWrite("node")
], $d77b025aa58d633c$var$Caption.prototype, "fontStyle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$FONT_WEIGHT2, {
        optional: true
    }),
    $d77b025aa58d633c$var$ProxyPropertyOnWrite("node")
], $d77b025aa58d633c$var$Caption.prototype, "fontWeight", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER),
    $d77b025aa58d633c$var$ProxyPropertyOnWrite("node")
], $d77b025aa58d633c$var$Caption.prototype, "fontSize", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING),
    $d77b025aa58d633c$var$ProxyPropertyOnWrite("node")
], $d77b025aa58d633c$var$Caption.prototype, "fontFamily", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$COLOR_STRING, {
        optional: true
    }),
    $d77b025aa58d633c$var$ProxyPropertyOnWrite("node", "fill")
], $d77b025aa58d633c$var$Caption.prototype, "color", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER, {
        optional: true
    })
], $d77b025aa58d633c$var$Caption.prototype, "spacing", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER, {
        optional: true
    })
], $d77b025aa58d633c$var$Caption.prototype, "lineHeight", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER, {
        optional: true
    })
], $d77b025aa58d633c$var$Caption.prototype, "maxWidth", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER, {
        optional: true
    })
], $d77b025aa58d633c$var$Caption.prototype, "maxHeight", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$TEXT_WRAP)
], $d77b025aa58d633c$var$Caption.prototype, "wrapping", 2);
// packages/ag-charts-community/src/chart/axis/axisGridLine.ts
var $d77b025aa58d633c$var$GRID_STYLE_KEYS = [
    "stroke",
    "lineDash"
];
var $d77b025aa58d633c$var$GRID_STYLE = $d77b025aa58d633c$var$ARRAY_OF((value)=>$d77b025aa58d633c$var$isObject(value) && Object.keys(value).every((key)=>$d77b025aa58d633c$var$GRID_STYLE_KEYS.includes(key)), "objects with gridline style properties such as 'stroke' or 'lineDash'");
var $d77b025aa58d633c$var$AxisGridLine = class {
    constructor(){
        this.enabled = true;
        this.width = 1;
        this.style = [
            {
                stroke: void 0,
                lineDash: []
            }
        ];
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN)
], $d77b025aa58d633c$var$AxisGridLine.prototype, "enabled", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$AxisGridLine.prototype, "width", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$GRID_STYLE)
], $d77b025aa58d633c$var$AxisGridLine.prototype, "style", 2);
// packages/ag-charts-community/src/chart/axis/axisLabel.ts
var $d77b025aa58d633c$var$AxisLabel = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.enabled = true;
        this.autoWrap = false;
        this.fontSize = 12;
        this.fontFamily = "Verdana, sans-serif";
        this.padding = 5;
        this.minSpacing = NaN;
        this.color = "rgba(87, 87, 87, 1)";
        this.avoidCollisions = true;
        this.mirrored = false;
        this.parallel = false;
    }
    /**
   * The side of the axis line to position the labels on.
   * -1 = left (default)
   * 1 = right
   */ getSideFlag() {
        return this.mirrored ? 1 : -1;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN)
], $d77b025aa58d633c$var$AxisLabel.prototype, "enabled", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN, {
        optional: true
    })
], $d77b025aa58d633c$var$AxisLabel.prototype, "autoWrap", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER, {
        optional: true
    })
], $d77b025aa58d633c$var$AxisLabel.prototype, "maxWidth", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER, {
        optional: true
    })
], $d77b025aa58d633c$var$AxisLabel.prototype, "maxHeight", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$FONT_STYLE, {
        optional: true
    })
], $d77b025aa58d633c$var$AxisLabel.prototype, "fontStyle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$FONT_WEIGHT2, {
        optional: true
    })
], $d77b025aa58d633c$var$AxisLabel.prototype, "fontWeight", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$NUMBER.restrict({
        min: 1
    }))
], $d77b025aa58d633c$var$AxisLabel.prototype, "fontSize", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING)
], $d77b025aa58d633c$var$AxisLabel.prototype, "fontFamily", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$AxisLabel.prototype, "padding", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$NUMBER_OR_NAN),
    $d77b025aa58d633c$var$Default(NaN)
], $d77b025aa58d633c$var$AxisLabel.prototype, "minSpacing", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$COLOR_STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$AxisLabel.prototype, "color", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$DEGREE, {
        optional: true
    })
], $d77b025aa58d633c$var$AxisLabel.prototype, "rotation", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN)
], $d77b025aa58d633c$var$AxisLabel.prototype, "avoidCollisions", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN)
], $d77b025aa58d633c$var$AxisLabel.prototype, "mirrored", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN)
], $d77b025aa58d633c$var$AxisLabel.prototype, "parallel", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$FUNCTION, {
        optional: true
    })
], $d77b025aa58d633c$var$AxisLabel.prototype, "formatter", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$AxisLabel.prototype, "format", 2);
// packages/ag-charts-community/src/chart/axis/axisLine.ts
var $d77b025aa58d633c$var$AxisLine = class {
    constructor(){
        this.enabled = true;
        this.width = 1;
        this.color = void 0;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN)
], $d77b025aa58d633c$var$AxisLine.prototype, "enabled", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$AxisLine.prototype, "width", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$COLOR_STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$AxisLine.prototype, "color", 2);
// packages/ag-charts-community/src/chart/axis/axisTitle.ts
var $d77b025aa58d633c$var$AxisTitle = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.enabled = false;
        this.spacing = $d77b025aa58d633c$var$Caption.SMALL_PADDING;
        this.fontSize = 10;
        this.fontFamily = "sans-serif";
        this.wrapping = "always";
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN)
], $d77b025aa58d633c$var$AxisTitle.prototype, "enabled", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$AxisTitle.prototype, "text", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER, {
        optional: true
    })
], $d77b025aa58d633c$var$AxisTitle.prototype, "spacing", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$FONT_STYLE, {
        optional: true
    })
], $d77b025aa58d633c$var$AxisTitle.prototype, "fontStyle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$FONT_WEIGHT2, {
        optional: true
    })
], $d77b025aa58d633c$var$AxisTitle.prototype, "fontWeight", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$AxisTitle.prototype, "fontSize", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING)
], $d77b025aa58d633c$var$AxisTitle.prototype, "fontFamily", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$COLOR_STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$AxisTitle.prototype, "color", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$TEXT_WRAP)
], $d77b025aa58d633c$var$AxisTitle.prototype, "wrapping", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$FUNCTION, {
        optional: true
    })
], $d77b025aa58d633c$var$AxisTitle.prototype, "formatter", 2);
// packages/ag-charts-community/src/chart/axis/axisUtil.ts
function $d77b025aa58d633c$var$prepareAxisAnimationContext(axis) {
    const [requestedRangeMin, requestedRangeMax] = $d77b025aa58d633c$var$findMinMax(axis.range);
    const min = Math.floor(requestedRangeMin);
    const max = Math.ceil(requestedRangeMax);
    return {
        min: min,
        max: max,
        visible: min !== max
    };
}
var $d77b025aa58d633c$var$fullCircle = Math.PI * 2;
var $d77b025aa58d633c$var$halfCircle = $d77b025aa58d633c$var$fullCircle / 2;
function $d77b025aa58d633c$var$normaliseEndRotation(start, end) {
    const directDistance = Math.abs(end - start);
    if (directDistance < $d77b025aa58d633c$var$halfCircle) return end;
    if (start > end) return end + $d77b025aa58d633c$var$fullCircle;
    return end - $d77b025aa58d633c$var$fullCircle;
}
function $d77b025aa58d633c$var$prepareAxisAnimationFunctions(ctx) {
    const outOfBounds = (y, range3)=>{
        const [min = ctx.min, max = ctx.max] = $d77b025aa58d633c$var$findMinMax(range3 != null ? range3 : []);
        return y < min || y > max;
    };
    const tick = {
        fromFn (node, datum, status) {
            let y = node.y1 + node.translationY;
            let opacity = node.opacity;
            if (status === "added" || outOfBounds(node.datum.translationY, node.datum.range)) {
                y = datum.translationY;
                opacity = 0;
            }
            return {
                y: 0,
                translationY: y,
                opacity: opacity,
                phase: $d77b025aa58d633c$var$NODE_UPDATE_STATE_TO_PHASE_MAPPING[status]
            };
        },
        toFn (_node, datum, status) {
            const y = datum.translationY;
            let opacity = 1;
            if (status === "removed") opacity = 0;
            return {
                y: 0,
                translationY: y,
                opacity: opacity,
                finish: {
                    y: // Set explicit y after animation so it's pixel aligned
                    y,
                    translationY: 0
                }
            };
        },
        intermediateFn (node, _datum, _status) {
            return {
                visible: !outOfBounds(node.y)
            };
        }
    };
    const label = {
        fromFn (node, newDatum, status) {
            var _a;
            const datum = (_a = node.previousDatum) != null ? _a : newDatum;
            const x = datum.x;
            const y = datum.y;
            const rotationCenterX = datum.rotationCenterX;
            let translationY = Math.round(node.translationY);
            let rotation = datum.rotation;
            let opacity = node.opacity;
            if (status === "removed" || outOfBounds(datum.y, datum.range)) rotation = newDatum.rotation;
            else if (status === "added" || outOfBounds(node.datum.y, node.datum.range)) {
                translationY = Math.round(datum.translationY);
                opacity = 0;
                rotation = newDatum.rotation;
            }
            return {
                x: x,
                y: y,
                rotationCenterX: rotationCenterX,
                translationY: translationY,
                rotation: rotation,
                opacity: opacity,
                phase: $d77b025aa58d633c$var$NODE_UPDATE_STATE_TO_PHASE_MAPPING[status]
            };
        },
        toFn (node, datum, status) {
            var _a, _b;
            const x = datum.x;
            const y = datum.y;
            const rotationCenterX = datum.rotationCenterX;
            const translationY = Math.round(datum.translationY);
            let rotation = 0;
            let opacity = 1;
            if (status === "added") {
                opacity = 1;
                rotation = datum.rotation;
            } else if (status === "removed") {
                opacity = 0;
                rotation = datum.rotation;
            } else rotation = $d77b025aa58d633c$var$normaliseEndRotation((_b = (_a = node.previousDatum) == null ? void 0 : _a.rotation) != null ? _b : datum.rotation, datum.rotation);
            return {
                x: x,
                y: y,
                rotationCenterX: rotationCenterX,
                translationY: translationY,
                rotation: rotation,
                opacity: opacity,
                finish: {
                    rotation: datum.rotation
                }
            };
        }
    };
    const line = {
        fromFn (node, datum) {
            var _a;
            return $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, (_a = node.previousDatum) != null ? _a : datum), {
                phase: $d77b025aa58d633c$var$NODE_UPDATE_STATE_TO_PHASE_MAPPING["updated"]
            });
        },
        toFn (_node, datum) {
            return $d77b025aa58d633c$var$__spreadValues({}, datum);
        }
    };
    const group2 = {
        fromFn (node, _datum) {
            const { rotation: rotation, translationX: translationX, translationY: translationY } = node;
            return {
                rotation: rotation,
                translationX: translationX,
                translationY: translationY,
                phase: $d77b025aa58d633c$var$NODE_UPDATE_STATE_TO_PHASE_MAPPING["updated"]
            };
        },
        toFn (_node, datum) {
            const { rotation: rotation, translationX: translationX, translationY: translationY } = datum;
            return {
                rotation: rotation,
                translationX: translationX,
                translationY: translationY
            };
        }
    };
    return {
        tick: tick,
        line: line,
        label: label,
        group: group2
    };
}
function $d77b025aa58d633c$var$resetAxisGroupFn() {
    return (_node, datum)=>{
        return {
            rotation: datum.rotation,
            rotationCenterX: datum.rotationCenterX,
            rotationCenterY: datum.rotationCenterY,
            translationX: datum.translationX,
            translationY: datum.translationY
        };
    };
}
function $d77b025aa58d633c$var$resetAxisSelectionFn(ctx) {
    const { visible: rangeVisible, min: min, max: max } = ctx;
    return (_node, datum)=>{
        const y = datum.translationY;
        const visible = rangeVisible && y >= min && y <= max;
        return {
            y: y,
            translationY: 0,
            opacity: 1,
            visible: visible
        };
    };
}
function $d77b025aa58d633c$var$resetAxisLabelSelectionFn() {
    return (_node, datum)=>{
        return {
            x: datum.x,
            y: datum.y,
            translationY: datum.translationY,
            rotation: datum.rotation,
            rotationCenterX: datum.rotationCenterX
        };
    };
}
function $d77b025aa58d633c$var$resetAxisLineSelectionFn() {
    return (_node, datum)=>{
        return $d77b025aa58d633c$var$__spreadValues({}, datum);
    };
}
// packages/ag-charts-community/src/chart/axis/axis.ts
var $d77b025aa58d633c$var$_Axis = class _Axis {
    constructor(moduleCtx, scale2, options){
        this.moduleCtx = moduleCtx;
        this.scale = scale2;
        this.id = $d77b025aa58d633c$var$createId(this);
        this.nice = true;
        this.reverse = false;
        this.keys = [];
        this.dataDomain = {
            domain: [],
            clipped: false
        };
        this.boundSeries = [];
        this.includeInvisibleDomains = false;
        this.interactionEnabled = true;
        this.axisGroup = new $d77b025aa58d633c$var$Group({
            name: `${this.id}-axis`,
            zIndex: 2 /* AXIS_ZINDEX */ 
        });
        this.lineNode = this.axisGroup.appendChild(new $d77b025aa58d633c$var$Line());
        this.tickLineGroup = this.axisGroup.appendChild(new $d77b025aa58d633c$var$Group({
            name: `${this.id}-Axis-tick-lines`,
            zIndex: 2 /* AXIS_ZINDEX */ 
        }));
        this.tickLabelGroup = this.axisGroup.appendChild(new $d77b025aa58d633c$var$Group({
            name: `${this.id}-Axis-tick-labels`,
            zIndex: 2 /* AXIS_ZINDEX */ 
        }));
        this.crossLineGroup = new $d77b025aa58d633c$var$Group({
            name: `${this.id}-CrossLines`
        });
        this.gridGroup = new $d77b025aa58d633c$var$Group({
            name: `${this.id}-Axis-grid`
        });
        this.gridLineGroup = this.gridGroup.appendChild(new $d77b025aa58d633c$var$Group({
            name: `${this.id}-gridLines`,
            zIndex: 1 /* AXIS_GRID_ZINDEX */ 
        }));
        this.tickLineGroupSelection = $d77b025aa58d633c$var$Selection.select(this.tickLineGroup, $d77b025aa58d633c$var$Line, false);
        this.tickLabelGroupSelection = $d77b025aa58d633c$var$Selection.select(this.tickLabelGroup, $d77b025aa58d633c$var$Text, false);
        this.gridLineGroupSelection = $d77b025aa58d633c$var$Selection.select(this.gridLineGroup, $d77b025aa58d633c$var$Line, false);
        this.line = new $d77b025aa58d633c$var$AxisLine();
        this.tick = this.createTick();
        this.gridLine = new $d77b025aa58d633c$var$AxisGridLine();
        this.label = this.createLabel();
        this.defaultTickMinSpacing = _Axis.defaultTickMinSpacing;
        this.translation = {
            x: 0,
            y: 0
        };
        this.rotation = 0;
        // axis rotation angle in degrees
        this.layout = {
            label: {
                fractionDigits: 0,
                padding: this.label.padding,
                format: this.label.format
            }
        };
        this.destroyFns = [];
        this.range = [
            0,
            1
        ];
        this.visibleRange = [
            0,
            1
        ];
        this.title = new $d77b025aa58d633c$var$AxisTitle();
        this._titleCaption = new $d77b025aa58d633c$var$Caption();
        this.gridLength = 0;
        this.fractionDigits = 0;
        /**
     * The distance between the grid ticks and the axis ticks.
     */ this.gridPadding = 0;
        /**
     * Is used to avoid collisions between axis labels and series.
     */ this.seriesAreaPadding = 0;
        this.tickGenerationResult = void 0;
        this.maxThickness = Infinity;
        this.moduleMap = new $d77b025aa58d633c$var$ModuleMap();
        this.refreshScale();
        this.destroyFns.push(this._titleCaption.registerInteraction(this.moduleCtx, "root"));
        this._titleCaption.node.rotation = -Math.PI / 2;
        this.axisGroup.appendChild(this._titleCaption.node);
        this.destroyFns.push(moduleCtx.regionManager.getRegion("series").addListener("hover", (e)=>this.checkAxisHover(e)));
        this.animationManager = moduleCtx.animationManager;
        this.animationState = new $d77b025aa58d633c$var$StateMachine("empty", {
            empty: {
                update: {
                    target: "ready",
                    action: ()=>this.resetSelectionNodes()
                },
                reset: "empty"
            },
            ready: {
                update: (data)=>this.animateReadyUpdate(data),
                resize: ()=>this.resetSelectionNodes(),
                reset: "empty"
            }
        });
        this._crossLines = [];
        this.assignCrossLineArrayConstructor(this._crossLines);
        let previousSize = void 0;
        this.destroyFns.push(moduleCtx.layoutService.addListener("layout-complete", (e)=>{
            if (previousSize != null && $d77b025aa58d633c$var$jsonDiff(e.chart, previousSize) != null) this.animationState.transition("resize");
            previousSize = $d77b025aa58d633c$var$__spreadValues({}, e.chart);
        }));
        if ((options == null ? void 0 : options.respondsToZoom) !== false) this.destroyFns.push(moduleCtx.updateService.addListener("update-complete", (e)=>{
            this.minRect = e.minRect;
        }));
    }
    get type() {
        var _a;
        return (_a = this.constructor.type) != null ? _a : "";
    }
    set crossLines(value) {
        var _a, _b;
        (_a = this._crossLines) == null || _a.forEach((crossLine)=>this.detachCrossLine(crossLine));
        if (value) this.assignCrossLineArrayConstructor(value);
        this._crossLines = value;
        (_b = this._crossLines) == null || _b.forEach((crossLine)=>{
            this.attachCrossLine(crossLine);
            this.initCrossLine(crossLine);
        });
    }
    get crossLines() {
        return this._crossLines;
    }
    resetAnimation(phase) {
        if (phase === "initial") this.animationState.transition("reset");
    }
    attachCrossLine(crossLine) {
        this.crossLineGroup.appendChild(crossLine.group);
        this.crossLineGroup.appendChild(crossLine.labelGroup);
    }
    detachCrossLine(crossLine) {
        this.crossLineGroup.removeChild(crossLine.group);
        this.crossLineGroup.removeChild(crossLine.labelGroup);
    }
    destroy() {
        this.moduleMap.destroy();
        this.destroyFns.forEach((f)=>f());
    }
    refreshScale() {
        var _a;
        this.range = this.scale.range.slice();
        (_a = this.crossLines) == null || _a.forEach(this.initCrossLine, this);
    }
    updateRange() {
        var _a;
        const { range: rr, visibleRange: vr, scale: scale2 } = this;
        const span = (rr[1] - rr[0]) / (vr[1] - vr[0]);
        const shift = span * vr[0];
        const start = rr[0] - shift;
        scale2.range = [
            start,
            start + span
        ];
        (_a = this.crossLines) == null || _a.forEach((crossLine)=>{
            crossLine.clippedRange = [
                rr[0],
                rr[1]
            ];
        });
    }
    setCrossLinesVisible(visible) {
        this.crossLineGroup.visible = visible;
    }
    attachAxis(axisNode, gridNode) {
        gridNode.appendChild(this.gridGroup);
        axisNode.appendChild(this.axisGroup);
        axisNode.appendChild(this.crossLineGroup);
    }
    detachAxis(axisNode, gridNode) {
        gridNode.removeChild(this.gridGroup);
        axisNode.removeChild(this.axisGroup);
        axisNode.removeChild(this.crossLineGroup);
    }
    /**
   * Checks if a point or an object is in range.
   * @param x A point (or object's starting point).
   * @param width Object's width.
   * @param tolerance Expands the range on both ends by this amount.
   */ inRange(x, width = 0, tolerance = 0) {
        const [min, max] = $d77b025aa58d633c$var$findMinMax(this.range);
        return x + width >= min - tolerance && x <= max + tolerance;
    }
    onLabelFormatChange(ticks, _domain, format2) {
        const { scale: scale2, fractionDigits: fractionDigits } = this;
        const logScale = scale2 instanceof $d77b025aa58d633c$var$LogScale;
        const defaultLabelFormatter = !logScale && fractionDigits > 0 ? (x)=>typeof x === "number" ? x.toFixed(fractionDigits) : String(x) : (x)=>String(x);
        if (format2 && scale2 && scale2.tickFormat) try {
            this.labelFormatter = scale2.tickFormat({
                ticks: ticks,
                specifier: format2
            });
        } catch (e) {
            this.labelFormatter = defaultLabelFormatter;
            $d77b025aa58d633c$var$Logger.warnOnce(`the axis label format string ${format2} is invalid. No formatting will be applied`);
        }
        else this.labelFormatter = defaultLabelFormatter;
    }
    setTickInterval(interval) {
        var _a;
        this.scale.interval = (_a = this.tick.interval) != null ? _a : interval;
    }
    setTickCount(count, minTickCount, maxTickCount) {
        const { scale: scale2 } = this;
        const continuous = $d77b025aa58d633c$var$ContinuousScale.is(scale2) || $d77b025aa58d633c$var$OrdinalTimeScale.is(scale2);
        if (!(count && continuous)) return;
        if (typeof count === "number") {
            scale2.tickCount = count;
            scale2.minTickCount = minTickCount != null ? minTickCount : 0;
            scale2.maxTickCount = maxTickCount != null ? maxTickCount : Infinity;
            return;
        }
        if (scale2 instanceof $d77b025aa58d633c$var$TimeScale) this.setTickInterval(count);
    }
    onGridLengthChange(value, prevValue) {
        var _a;
        if (prevValue && !value || !prevValue && value) this.onGridVisibilityChange();
        (_a = this.crossLines) == null || _a.forEach(this.initCrossLine, this);
    }
    onGridVisibilityChange() {
        this.gridLineGroupSelection.clear();
    }
    createLabel() {
        return new $d77b025aa58d633c$var$AxisLabel();
    }
    checkAxisHover(event) {
        if (!this.interactionEnabled) return;
        const bbox = this.computeBBox();
        const isInAxis = bbox.containsPoint(event.offsetX, event.offsetY);
        if (!isInAxis) return;
        this.moduleCtx.chartEventManager.axisHover(this.id, this.direction);
    }
    /**
   * Creates/removes/updates the scene graph nodes that constitute the axis.
   */ update(_primaryTickCount = 0, animated = true) {
        if (!this.tickGenerationResult) return;
        const { rotation: rotation, parallelFlipRotation: parallelFlipRotation, regularFlipRotation: regularFlipRotation } = this.calculateRotations();
        const sideFlag = this.label.getSideFlag();
        this.updatePosition();
        const lineData = this.getAxisLineCoordinates();
        const { tickData: tickData, combinedRotation: combinedRotation, textBaseline: textBaseline, textAlign: textAlign, primaryTickCount: primaryTickCount } = this.tickGenerationResult;
        const previousTicks = this.tickLabelGroupSelection.nodes().map((node)=>node.datum.tickId);
        this.updateSelections(lineData, tickData.ticks, {
            combinedRotation: combinedRotation,
            textAlign: textAlign,
            textBaseline: textBaseline,
            range: this.scale.range
        });
        if (!animated || this.animationManager.isSkipped()) this.resetSelectionNodes();
        else {
            const diff2 = this.calculateUpdateDiff(previousTicks, tickData);
            this.animationState.transition("update", diff2);
        }
        this.updateAxisLine();
        this.updateLabels();
        this.updateVisibility();
        this.updateGridLines(sideFlag);
        this.updateTickLines();
        this.updateTitle({
            anyTickVisible: tickData.ticks.length > 0
        });
        this.updateCrossLines({
            rotation: rotation,
            parallelFlipRotation: parallelFlipRotation,
            regularFlipRotation: regularFlipRotation
        });
        this.updateLayoutState();
        return primaryTickCount;
    }
    getAxisLineCoordinates() {
        const [min, max] = $d77b025aa58d633c$var$findMinMax(this.range);
        return {
            x: 0,
            y1: min,
            y2: max
        };
    }
    getTickLineCoordinates(datum) {
        const sideFlag = this.label.getSideFlag();
        const x = sideFlag * this.getTickSize();
        const x1 = Math.min(0, x);
        const x2 = x1 + Math.abs(x);
        const y = datum.translationY;
        return {
            x1: x1,
            x2: x2,
            y: y
        };
    }
    getTickLabelProps(datum, params) {
        const { label: label } = this;
        const { combinedRotation: combinedRotation, textBaseline: textBaseline, textAlign: textAlign, range: range3 } = params;
        const text = datum.tickLabel;
        const sideFlag = label.getSideFlag();
        const labelX = sideFlag * (this.getTickSize() + label.padding + this.seriesAreaPadding);
        const visible = text !== "" && text != null;
        return {
            tickId: datum.tickId,
            translationY: datum.translationY,
            fill: label.color,
            fontFamily: label.fontFamily,
            fontSize: label.fontSize,
            fontStyle: label.fontStyle,
            fontWeight: label.fontWeight,
            rotation: combinedRotation,
            rotationCenterX: labelX,
            text: text,
            textAlign: textAlign,
            textBaseline: textBaseline,
            visible: visible,
            x: labelX,
            y: 0,
            range: range3
        };
    }
    getTickSize() {
        return this.tick.enabled ? this.tick.size : this.createTick().size;
    }
    setTitleProps(caption, params) {
        var _a;
        const { title: title } = this;
        if (!title.enabled) {
            caption.enabled = false;
            return;
        }
        caption.color = title.color;
        caption.fontFamily = title.fontFamily;
        caption.fontSize = title.fontSize;
        caption.fontStyle = title.fontStyle;
        caption.fontWeight = title.fontWeight;
        caption.enabled = title.enabled;
        caption.wrapping = title.wrapping;
        if (title.enabled) {
            const titleNode = caption.node;
            const padding = ((_a = title.spacing) != null ? _a : 0) + params.spacing;
            const sideFlag = this.label.getSideFlag();
            const parallelFlipRotation = $d77b025aa58d633c$var$normalizeAngle360(this.rotation);
            const titleRotationFlag = sideFlag === -1 && parallelFlipRotation > Math.PI && parallelFlipRotation < Math.PI * 2 ? -1 : 1;
            const rotation = titleRotationFlag * sideFlag * Math.PI / 2;
            const textBaseline = titleRotationFlag === 1 ? "bottom" : "top";
            const { range: range3 } = this;
            const x = Math.floor(titleRotationFlag * sideFlag * (range3[0] + range3[1]) / 2);
            const y = sideFlag === -1 ? Math.floor(titleRotationFlag * -padding) : Math.floor(-padding);
            const { callbackCache: callbackCache } = this.moduleCtx;
            const { formatter: formatter = (p)=>p.defaultValue } = title;
            const text = callbackCache.call(formatter, this.getTitleFormatterParams());
            titleNode.setProperties({
                rotation: rotation,
                text: text,
                textBaseline: textBaseline,
                visible: true,
                x: x,
                y: y
            });
        }
    }
    calculateLayout(primaryTickCount) {
        var _b, _c;
        const { rotation: rotation, parallelFlipRotation: parallelFlipRotation, regularFlipRotation: regularFlipRotation } = this.calculateRotations();
        const sideFlag = this.label.getSideFlag();
        const labelX = sideFlag * (this.getTickSize() + this.label.padding + this.seriesAreaPadding);
        this.updateScale();
        this.tickGenerationResult = this.generateTicks({
            primaryTickCount: primaryTickCount,
            parallelFlipRotation: parallelFlipRotation,
            regularFlipRotation: regularFlipRotation,
            labelX: labelX,
            sideFlag: sideFlag
        });
        this.updateLayoutState();
        const _a = this.tickGenerationResult, { tickData: tickData, combinedRotation: combinedRotation, textBaseline: textBaseline, textAlign: textAlign } = _a, ticksResult = $d77b025aa58d633c$var$__objRest(_a, [
            "tickData",
            "combinedRotation",
            "textBaseline",
            "textAlign"
        ]);
        const boxes = [];
        const { x: x, y1: y1, y2: y2 } = this.getAxisLineCoordinates();
        const lineBox = new $d77b025aa58d633c$var$BBox(x + Math.min(sideFlag * this.seriesAreaPadding, 0), y1, this.seriesAreaPadding, y2 - y1);
        boxes.push(lineBox);
        if (this.tick.enabled) tickData.ticks.forEach((datum)=>{
            const { x1: x1, x2: x2, y: y } = this.getTickLineCoordinates(datum);
            const tickLineBox = new $d77b025aa58d633c$var$BBox(x1, y, x2 - x1, 0);
            boxes.push(tickLineBox);
        });
        if (this.label.enabled) {
            const tempText = new $d77b025aa58d633c$var$Text();
            tickData.ticks.forEach((datum)=>{
                const labelProps = this.getTickLabelProps(datum, {
                    combinedRotation: combinedRotation,
                    textAlign: textAlign,
                    textBaseline: textBaseline,
                    range: this.scale.range
                });
                if (!labelProps.visible) return;
                tempText.setProperties($d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, labelProps), {
                    translationY: Math.round(datum.translationY)
                }));
                const box = tempText.computeTransformedBBox();
                if (box) boxes.push(box);
            });
        }
        const getTransformBox = (bbox2)=>{
            const matrix = new $d77b025aa58d633c$var$Matrix();
            const { rotation: axisRotation, translationX: translationX, translationY: translationY, rotationCenterX: rotationCenterX, rotationCenterY: rotationCenterY } = this.getAxisTransform();
            $d77b025aa58d633c$var$Matrix.updateTransformMatrix(matrix, 1, 1, axisRotation, translationX, translationY, {
                scalingCenterX: 0,
                scalingCenterY: 0,
                rotationCenterX: rotationCenterX,
                rotationCenterY: rotationCenterY
            });
            return matrix.transformBBox(bbox2);
        };
        if ((_b = this.title) == null ? void 0 : _b.enabled) {
            const caption = new $d77b025aa58d633c$var$Caption();
            const spacing = $d77b025aa58d633c$var$BBox.merge(boxes).width;
            this.setTitleProps(caption, {
                spacing: spacing
            });
            const titleNode = caption.node;
            const titleBox = titleNode.computeTransformedBBox();
            if (titleBox) boxes.push(titleBox);
        }
        const bbox = $d77b025aa58d633c$var$BBox.merge(boxes);
        const transformedBBox = getTransformBox(bbox);
        const anySeriesActive = this.isAnySeriesActive();
        (_c = this.crossLines) == null || _c.forEach((crossLine)=>{
            var _a2;
            crossLine.sideFlag = -sideFlag;
            crossLine.direction = rotation === -Math.PI / 2 ? "x" /* X */  : "y" /* Y */ ;
            if (crossLine instanceof $d77b025aa58d633c$var$CartesianCrossLine) crossLine.label.parallel = (_a2 = crossLine.label.parallel) != null ? _a2 : this.label.parallel;
            crossLine.parallelFlipRotation = parallelFlipRotation;
            crossLine.regularFlipRotation = regularFlipRotation;
            crossLine.calculateLayout(anySeriesActive, this.reverse);
        });
        primaryTickCount = ticksResult.primaryTickCount;
        return {
            primaryTickCount: primaryTickCount,
            bbox: transformedBBox
        };
    }
    updateLayoutState() {
        this.layout.label = {
            fractionDigits: this.fractionDigits,
            padding: this.label.padding,
            format: this.label.format
        };
    }
    setDomain(domain) {
        this.dataDomain = this.normaliseDataDomain(domain);
        if (this.reverse) this.dataDomain.domain.reverse();
        this.scale.domain = this.dataDomain.domain;
    }
    updateScale() {
        this.updateRange();
        this.calculateDomain();
        this.setTickInterval(this.tick.interval);
        const { scale: scale2, nice: nice } = this;
        if (!$d77b025aa58d633c$var$ContinuousScale.is(scale2)) return;
        scale2.nice = nice;
        scale2.update();
    }
    calculateRotations() {
        const rotation = $d77b025aa58d633c$var$toRadians(this.rotation);
        const parallelFlipRotation = $d77b025aa58d633c$var$normalizeAngle360(rotation);
        const regularFlipRotation = $d77b025aa58d633c$var$normalizeAngle360(rotation - Math.PI / 2);
        return {
            rotation: rotation,
            parallelFlipRotation: parallelFlipRotation,
            regularFlipRotation: regularFlipRotation
        };
    }
    generateTicks({ primaryTickCount: primaryTickCount, parallelFlipRotation: parallelFlipRotation, regularFlipRotation: regularFlipRotation, labelX: labelX, sideFlag: sideFlag }) {
        var _a;
        const { scale: scale2, tick: tick, label: { parallel: parallel, rotation: rotation, fontFamily: fontFamily, fontSize: fontSize, fontStyle: fontStyle, fontWeight: fontWeight } } = this;
        const secondaryAxis = primaryTickCount !== void 0;
        const { defaultRotation: defaultRotation, configuredRotation: configuredRotation, parallelFlipFlag: parallelFlipFlag, regularFlipFlag: regularFlipFlag } = $d77b025aa58d633c$var$calculateLabelRotation({
            rotation: rotation,
            parallel: parallel,
            regularFlipRotation: regularFlipRotation,
            parallelFlipRotation: parallelFlipRotation
        });
        const initialRotation = configuredRotation + defaultRotation;
        const labelMatrix = new $d77b025aa58d633c$var$Matrix();
        const { maxTickCount: maxTickCount } = this.estimateTickCount({
            minSpacing: tick.minSpacing,
            maxSpacing: (_a = tick.maxSpacing) != null ? _a : NaN
        });
        const continuous = $d77b025aa58d633c$var$ContinuousScale.is(scale2) || $d77b025aa58d633c$var$OrdinalTimeScale.is(scale2);
        const maxIterations = !continuous || isNaN(maxTickCount) ? 10 : maxTickCount;
        let textAlign = $d77b025aa58d633c$var$getTextAlign(parallel, configuredRotation, 0, sideFlag, regularFlipFlag);
        const textBaseline = $d77b025aa58d633c$var$getTextBaseline(parallel, configuredRotation, sideFlag, parallelFlipFlag);
        const textProps = {
            fontFamily: fontFamily,
            fontSize: fontSize,
            fontStyle: fontStyle,
            fontWeight: fontWeight,
            textBaseline: textBaseline,
            textAlign: textAlign
        };
        let tickData = {
            rawTicks: [],
            ticks: [],
            labelCount: 0
        };
        let index = 0;
        let autoRotation = 0;
        let labelOverlap = true;
        let terminate = false;
        while(labelOverlap && index <= maxIterations){
            if (terminate) break;
            autoRotation = 0;
            textAlign = $d77b025aa58d633c$var$getTextAlign(parallel, configuredRotation, 0, sideFlag, regularFlipFlag);
            const tickStrategies = this.getTickStrategies({
                secondaryAxis: secondaryAxis,
                index: index
            });
            for (const strategy of tickStrategies){
                ({ tickData: tickData, index: index, autoRotation: autoRotation, terminate: terminate } = strategy({
                    index: index,
                    tickData: tickData,
                    textProps: textProps,
                    labelOverlap: labelOverlap,
                    terminate: terminate,
                    primaryTickCount: primaryTickCount
                }));
                const rotated = configuredRotation !== 0 || autoRotation !== 0;
                const labelRotation = initialRotation + autoRotation;
                textAlign = $d77b025aa58d633c$var$getTextAlign(parallel, configuredRotation, autoRotation, sideFlag, regularFlipFlag);
                labelOverlap = this.label.avoidCollisions ? this.checkLabelOverlap(labelRotation, rotated, labelMatrix, tickData.ticks, labelX, $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, textProps), {
                    textAlign: textAlign
                })) : false;
            }
        }
        const combinedRotation = defaultRotation + configuredRotation + autoRotation;
        if (!secondaryAxis && tickData.rawTicks.length > 0) primaryTickCount = tickData.rawTicks.length;
        return {
            tickData: tickData,
            primaryTickCount: primaryTickCount,
            combinedRotation: combinedRotation,
            textBaseline: textBaseline,
            textAlign: textAlign
        };
    }
    getTickStrategies({ index: iteration, secondaryAxis: secondaryAxis }) {
        const { scale: scale2, label: label, tick: tick } = this;
        const continuous = $d77b025aa58d633c$var$ContinuousScale.is(scale2) || $d77b025aa58d633c$var$OrdinalTimeScale.is(scale2);
        const avoidLabelCollisions = label.enabled && label.avoidCollisions;
        const filterTicks = !continuous && iteration !== 0 && avoidLabelCollisions;
        const autoRotate = label.autoRotate === true && label.rotation === void 0;
        const strategies = [];
        let tickGenerationType;
        if (this.tick.values) tickGenerationType = 3 /* VALUES */ ;
        else if (secondaryAxis) tickGenerationType = 1 /* CREATE_SECONDARY */ ;
        else if (filterTicks) tickGenerationType = 2 /* FILTER */ ;
        else tickGenerationType = 0 /* CREATE */ ;
        const tickGenerationStrategy = ({ index: index, tickData: tickData, primaryTickCount: primaryTickCount, terminate: terminate })=>this.createTickData(tickGenerationType, index, tickData, terminate, primaryTickCount);
        strategies.push(tickGenerationStrategy);
        if (!continuous && !isNaN(tick.minSpacing)) {
            const tickFilterStrategy = ({ index: index, tickData: tickData, primaryTickCount: primaryTickCount, terminate: terminate })=>this.createTickData(2 /* FILTER */ , index, tickData, terminate, primaryTickCount);
            strategies.push(tickFilterStrategy);
        }
        if (!avoidLabelCollisions) return strategies;
        if (label.autoWrap) {
            const autoWrapStrategy = ({ index: index, tickData: tickData, textProps: textProps })=>this.wrapLabels(tickData, index, textProps);
            strategies.push(autoWrapStrategy);
        } else if (autoRotate) {
            const autoRotateStrategy = ({ index: index, tickData: tickData, labelOverlap: labelOverlap, terminate: terminate })=>({
                    index: index,
                    tickData: tickData,
                    autoRotation: this.getAutoRotation(labelOverlap),
                    terminate: terminate
                });
            strategies.push(autoRotateStrategy);
        }
        return strategies;
    }
    createTickData(tickGenerationType, index, tickData, terminate, primaryTickCount) {
        var _a;
        const { scale: scale2, tick: tick } = this;
        const { maxTickCount: maxTickCount, minTickCount: minTickCount, defaultTickCount: defaultTickCount } = this.estimateTickCount({
            minSpacing: tick.minSpacing,
            maxSpacing: (_a = tick.maxSpacing) != null ? _a : NaN
        });
        const continuous = $d77b025aa58d633c$var$ContinuousScale.is(scale2) || $d77b025aa58d633c$var$OrdinalTimeScale.is(scale2);
        const maxIterations = !continuous || isNaN(maxTickCount) ? 10 : maxTickCount;
        let tickCount = continuous ? Math.max(defaultTickCount - index, minTickCount) : maxTickCount;
        const regenerateTicks = tick.interval === void 0 && tick.values === void 0 && tickCount > minTickCount && (continuous || tickGenerationType === 2 /* FILTER */ );
        let unchanged = true;
        while(unchanged && index <= maxIterations){
            const prevTicks = tickData.rawTicks;
            tickCount = continuous ? Math.max(defaultTickCount - index, minTickCount) : maxTickCount;
            const { rawTicks: rawTicks, ticks: ticks, labelCount: labelCount } = this.getTicks({
                tickGenerationType: tickGenerationType,
                previousTicks: prevTicks,
                tickCount: tickCount,
                minTickCount: minTickCount,
                maxTickCount: maxTickCount,
                primaryTickCount: primaryTickCount
            });
            tickData.rawTicks = rawTicks;
            tickData.ticks = ticks;
            tickData.labelCount = labelCount;
            unchanged = regenerateTicks ? $d77b025aa58d633c$var$areArrayNumbersEqual(rawTicks, prevTicks) : false;
            index++;
        }
        const shouldTerminate = tick.interval !== void 0 || tick.values !== void 0;
        terminate || (terminate = shouldTerminate);
        return {
            tickData: tickData,
            index: index,
            autoRotation: 0,
            terminate: terminate
        };
    }
    checkLabelOverlap(rotation, rotated, labelMatrix, tickData, labelX, textProps) {
        $d77b025aa58d633c$var$Matrix.updateTransformMatrix(labelMatrix, 1, 1, rotation, 0, 0);
        const labelData = this.createLabelData(tickData, labelX, textProps, labelMatrix);
        const labelSpacing = $d77b025aa58d633c$var$getLabelSpacing(this.label.minSpacing, rotated);
        return $d77b025aa58d633c$var$axisLabelsOverlap(labelData, labelSpacing);
    }
    createLabelData(tickData, labelX, textProps, labelMatrix) {
        const labelData = [];
        const measurer = new $d77b025aa58d633c$var$TextMeasurer(textProps);
        for (const { tickLabel: tickLabel, translationY: translationY } of tickData){
            if (tickLabel === "" || tickLabel == null) continue;
            const { width: width, height: height } = measurer.size(tickLabel);
            const bbox = new $d77b025aa58d633c$var$BBox(labelX, translationY, width, height);
            const labelDatum = $d77b025aa58d633c$var$calculateLabelBBox(tickLabel, bbox, labelX, translationY, labelMatrix);
            labelData.push(labelDatum);
        }
        return labelData;
    }
    getAutoRotation(labelOverlap) {
        var _a;
        return labelOverlap ? $d77b025aa58d633c$var$normalizeAngle360($d77b025aa58d633c$var$toRadians((_a = this.label.autoRotateAngle) != null ? _a : 0)) : 0;
    }
    getTicks({ tickGenerationType: tickGenerationType, previousTicks: previousTicks, tickCount: tickCount, minTickCount: minTickCount, maxTickCount: maxTickCount, primaryTickCount: primaryTickCount }) {
        var _a;
        const { range: range3, scale: scale2, visibleRange: visibleRange } = this;
        let rawTicks;
        switch(tickGenerationType){
            case 3 /* VALUES */ :
                if ($d77b025aa58d633c$var$ContinuousScale.is(scale2)) {
                    const [d0, d1] = $d77b025aa58d633c$var$findMinMax(scale2.getDomain().map(Number));
                    rawTicks = this.tick.values.filter((value)=>value >= d0 && value <= d1).sort((a, b)=>a - b);
                } else rawTicks = this.tick.values;
                break;
            case 1 /* CREATE_SECONDARY */ :
                if ($d77b025aa58d633c$var$ContinuousScale.is(scale2)) rawTicks = this.updateSecondaryAxisTicks(primaryTickCount);
                else rawTicks = this.createTicks(tickCount, minTickCount, maxTickCount);
                break;
            case 2 /* FILTER */ :
                rawTicks = this.filterTicks(previousTicks, tickCount);
                break;
            default:
                rawTicks = this.createTicks(tickCount, minTickCount, maxTickCount);
                break;
        }
        this.fractionDigits = rawTicks.fractionDigits >= 0 ? rawTicks.fractionDigits : 0;
        const halfBandwidth = ((_a = scale2.bandwidth) != null ? _a : 0) / 2;
        const ticks = [];
        let labelCount = 0;
        const tickIdCounts = /* @__PURE__ */ new Map();
        const start = Math.max(0, Math.floor(visibleRange[0] * rawTicks.length));
        const end = Math.min(rawTicks.length, Math.ceil(visibleRange[1] * rawTicks.length));
        const filteredTicks = rawTicks.slice(start, end);
        this.onLabelFormatChange(filteredTicks, rawTicks, this.label.format);
        for(let i = 0; i < filteredTicks.length; i++){
            const tick = filteredTicks[i];
            const translationY = scale2.convert(tick) + halfBandwidth;
            if (range3.length > 0 && !this.inRange(translationY, 0, 1e-3)) continue;
            const tickLabel = this.formatTick(tick, start + i);
            let tickId = tickLabel;
            if (tickIdCounts.has(tickId)) {
                const count = tickIdCounts.get(tickId);
                tickIdCounts.set(tickId, count + 1);
                tickId = `${tickId}_${count}`;
            } else tickIdCounts.set(tickId, 1);
            ticks.push({
                tick: tick,
                tickId: tickId,
                tickLabel: tickLabel,
                translationY: Math.floor(translationY)
            });
            if (tickLabel === "" || tickLabel == null) continue;
            labelCount++;
        }
        return {
            rawTicks: rawTicks,
            ticks: ticks,
            labelCount: labelCount
        };
    }
    filterTicks(ticks, tickCount) {
        var _a;
        const tickSpacing = !isNaN(this.tick.minSpacing) || !isNaN((_a = this.tick.maxSpacing) != null ? _a : NaN);
        const keepEvery = tickSpacing ? Math.ceil(ticks.length / tickCount) : 2;
        return ticks.filter((_, i)=>i % keepEvery === 0);
    }
    createTicks(tickCount, minTickCount, maxTickCount) {
        var _a, _b, _c;
        this.setTickCount(tickCount, minTickCount, maxTickCount);
        return (_c = (_b = (_a = this.scale).ticks) == null ? void 0 : _b.call(_a)) != null ? _c : [];
    }
    estimateTickCount({ minSpacing: minSpacing, maxSpacing: maxSpacing }) {
        const { minRect: minRect, label: { avoidCollisions: avoidCollisions } } = this;
        if (!avoidCollisions) return {
            minTickCount: $d77b025aa58d633c$var$ContinuousScale.defaultMaxTickCount,
            maxTickCount: $d77b025aa58d633c$var$ContinuousScale.defaultMaxTickCount,
            defaultTickCount: $d77b025aa58d633c$var$ContinuousScale.defaultMaxTickCount
        };
        const rangeWithBleed = this.calculateRangeWithBleed();
        const defaultMinSpacing = Math.max(this.defaultTickMinSpacing, rangeWithBleed / $d77b025aa58d633c$var$ContinuousScale.defaultMaxTickCount);
        let clampMaxTickCount = !isNaN(maxSpacing);
        if (isNaN(minSpacing)) minSpacing = defaultMinSpacing;
        if (isNaN(maxSpacing)) maxSpacing = rangeWithBleed;
        if (minSpacing > maxSpacing) {
            if (minSpacing === defaultMinSpacing) minSpacing = maxSpacing;
            else maxSpacing = minSpacing;
        }
        let minRectDistance = 1;
        if (minRect) minRectDistance = this.direction === "x" /* X */  ? minRect.width : minRect.height;
        clampMaxTickCount && (clampMaxTickCount = minRectDistance < defaultMinSpacing);
        const maxTickCount = $d77b025aa58d633c$var$clamp(1, Math.floor(rangeWithBleed / minSpacing), clampMaxTickCount ? Math.min(Math.floor(rangeWithBleed / minRectDistance), 100) : 100);
        const minTickCount = Math.min(maxTickCount, Math.ceil(rangeWithBleed / maxSpacing));
        const defaultTickCount = $d77b025aa58d633c$var$clamp(minTickCount, $d77b025aa58d633c$var$ContinuousScale.defaultTickCount, maxTickCount);
        return {
            minTickCount: minTickCount,
            maxTickCount: maxTickCount,
            defaultTickCount: defaultTickCount
        };
    }
    updateVisibility() {
        if (this.moduleCtx.animationManager.isSkipped()) this.resetSelectionNodes();
        this.tickLineGroup.visible = this.tick.enabled;
        this.gridLineGroup.visible = this.gridLine.enabled;
        this.tickLabelGroup.visible = this.label.enabled;
    }
    updateCrossLines({ rotation: rotation, parallelFlipRotation: parallelFlipRotation, regularFlipRotation: regularFlipRotation }) {
        var _a;
        const sideFlag = this.label.getSideFlag();
        const anySeriesActive = this.isAnySeriesActive();
        (_a = this.crossLines) == null || _a.forEach((crossLine)=>{
            var _a2;
            crossLine.sideFlag = -sideFlag;
            crossLine.direction = rotation === -Math.PI / 2 ? "x" /* X */  : "y" /* Y */ ;
            if (crossLine instanceof $d77b025aa58d633c$var$CartesianCrossLine) crossLine.label.parallel = (_a2 = crossLine.label.parallel) != null ? _a2 : this.label.parallel;
            crossLine.parallelFlipRotation = parallelFlipRotation;
            crossLine.regularFlipRotation = regularFlipRotation;
            crossLine.update(anySeriesActive);
        });
    }
    updateTickLines() {
        const { tick: tick, label: label } = this;
        const sideFlag = label.getSideFlag();
        this.tickLineGroupSelection.each((line)=>{
            line.strokeWidth = tick.width;
            line.stroke = tick.color;
            line.x1 = sideFlag * this.getTickSize();
            line.x2 = 0;
        });
    }
    calculateAvailableRange() {
        return $d77b025aa58d633c$var$findRangeExtent(this.range);
    }
    /**
   * Calculates the available range with an additional "bleed" beyond the canvas that encompasses the full axis when
   * the visible range is only a portion of the axis.
   */ calculateRangeWithBleed() {
        const visibleScale = 1 / $d77b025aa58d633c$var$findRangeExtent(this.visibleRange);
        return $d77b025aa58d633c$var$round(this.calculateAvailableRange() * visibleScale, 2);
    }
    calculateDomain() {
        const visibleSeries = this.boundSeries.filter((s)=>this.includeInvisibleDomains || s.isEnabled());
        const domains = visibleSeries.flatMap((series)=>series.getDomain(this.direction));
        this.setDomain(domains);
    }
    getAxisTransform() {
        return {
            rotation: $d77b025aa58d633c$var$toRadians(this.rotation),
            rotationCenterX: 0,
            rotationCenterY: 0,
            translationX: Math.floor(this.translation.x),
            translationY: Math.floor(this.translation.y)
        };
    }
    updatePosition() {
        const { crossLineGroup: crossLineGroup, axisGroup: axisGroup, gridGroup: gridGroup, translation: translation, gridLineGroupSelection: gridLineGroupSelection, gridPadding: gridPadding, gridLength: gridLength } = this;
        const { rotation: rotation } = this.calculateRotations();
        const sideFlag = this.label.getSideFlag();
        const translationX = Math.floor(translation.x);
        const translationY = Math.floor(translation.y);
        crossLineGroup.setProperties({
            rotation: rotation,
            translationX: translationX,
            translationY: translationY
        });
        gridGroup.setProperties({
            rotation: rotation,
            translationX: translationX,
            translationY: translationY
        });
        axisGroup.datum = this.getAxisTransform();
        gridLineGroupSelection.each((line)=>{
            line.x1 = gridPadding;
            line.x2 = -sideFlag * gridLength + gridPadding;
        });
    }
    updateSecondaryAxisTicks(_primaryTickCount) {
        throw new Error("AG Charts - unexpected call to updateSecondaryAxisTicks() - check axes configuration.");
    }
    updateSelections(lineData, data, params) {
        this.lineNode.datum = lineData;
        this.gridLineGroupSelection.update(this.gridLength ? data : [], (group2)=>group2.append(new $d77b025aa58d633c$var$Line()), (datum)=>datum.tickId);
        this.tickLineGroupSelection.update(data, (group2)=>group2.appendChild(new $d77b025aa58d633c$var$Line()), (datum)=>datum.tickId);
        this.tickLabelGroupSelection.update(data.map((d)=>this.getTickLabelProps(d, params)), (group2)=>group2.appendChild(new $d77b025aa58d633c$var$Text()), (datum)=>datum.tickId);
    }
    updateAxisLine() {
        const { line: line } = this;
        const strokeWidth = line.enabled ? line.width : 0;
        this.lineNode.setProperties({
            stroke: line.color,
            strokeWidth: strokeWidth
        });
    }
    updateGridLines(sideFlag) {
        const { gridLine: { style: style, width: width }, gridPadding: gridPadding, gridLength: gridLength } = this;
        if (gridLength === 0 || style.length === 0) return;
        this.gridLineGroupSelection.each((line, _, index)=>{
            const { stroke: stroke, lineDash: lineDash } = style[index % style.length];
            line.setProperties({
                x1: gridPadding,
                x2: -sideFlag * gridLength + gridPadding,
                fill: void 0,
                stroke: stroke,
                strokeWidth: width,
                lineDash: lineDash
            });
        });
    }
    updateLabels() {
        const { label: label } = this;
        if (!label.enabled) return;
        this.tickLabelGroupSelection.each((node, datum)=>{
            node.setProperties(datum, [
                "fill",
                "fontFamily",
                "fontSize",
                "fontStyle",
                "fontWeight",
                "text",
                "textAlign",
                "textBaseline"
            ]);
        });
    }
    wrapLabels(tickData, index, labelProps) {
        const { parallel: parallel, maxWidth: maxWidth, maxHeight: maxHeight } = this.label;
        let defaultMaxWidth = this.maxThickness;
        let defaultMaxHeight = Math.round(this.calculateAvailableRange() / tickData.labelCount);
        if (parallel) [defaultMaxWidth, defaultMaxHeight] = [
            defaultMaxHeight,
            defaultMaxWidth
        ];
        tickData.ticks.forEach((tickDatum)=>{
            const { text: text } = $d77b025aa58d633c$var$Text.wrap(tickDatum.tickLabel, maxWidth != null ? maxWidth : defaultMaxWidth, maxHeight != null ? maxHeight : defaultMaxHeight, labelProps, "hyphenate");
            tickDatum.tickLabel = text;
        });
        return {
            tickData: tickData,
            index: index,
            autoRotation: 0,
            terminate: true
        };
    }
    updateTitle(params) {
        const { rotation: rotation, title: title, _titleCaption: _titleCaption, lineNode: lineNode, tickLineGroup: tickLineGroup, tickLabelGroup: tickLabelGroup } = this;
        if (!title) {
            _titleCaption.enabled = false;
            return;
        }
        let spacing = 0;
        if (title.enabled && params.anyTickVisible) {
            const tickBBox = $d77b025aa58d633c$var$Group.computeBBox([
                tickLineGroup,
                tickLabelGroup,
                lineNode
            ]);
            const tickWidth = rotation === 0 ? tickBBox.width : tickBBox.height;
            spacing += tickWidth + (this.tickLabelGroup.visible ? 0 : this.seriesAreaPadding);
        }
        this.setTitleProps(_titleCaption, {
            spacing: spacing
        });
    }
    // For formatting (nice rounded) tick values.
    formatTick(datum, index) {
        return this.datumFormatter(index)(datum);
    }
    // For formatting arbitrary values between the ticks.
    formatDatum(datum) {
        return String(datum);
    }
    datumFormatter(index = 0) {
        const { label: label, labelFormatter: labelFormatter, fractionDigits: fractionDigits, moduleCtx: { callbackCache: callbackCache } } = this;
        if (label.formatter) return (datum)=>{
            var _a;
            return (_a = callbackCache.call(label.formatter, {
                value: fractionDigits > 0 ? datum : String(datum),
                index: index,
                fractionDigits: fractionDigits,
                formatter: labelFormatter
            })) != null ? _a : datum;
        };
        else if (labelFormatter) return (datum)=>{
            var _a;
            return (_a = callbackCache.call(labelFormatter, datum)) != null ? _a : String(datum);
        };
        return (datum)=>String(datum);
    }
    computeBBox() {
        return this.axisGroup.computeBBox();
    }
    initCrossLine(crossLine) {
        crossLine.scale = this.scale;
        crossLine.gridLength = this.gridLength;
    }
    isAnySeriesActive() {
        return this.boundSeries.some((s)=>this.includeInvisibleDomains || s.isEnabled());
    }
    clipTickLines(x, y, width, height) {
        this.tickLineGroup.setClipRectInGroupCoordinateSpace(new $d77b025aa58d633c$var$BBox(x, y, width, height));
    }
    clipGrid(x, y, width, height) {
        this.gridGroup.setClipRectInGroupCoordinateSpace(new $d77b025aa58d633c$var$BBox(x, y, width, height));
    }
    calculatePadding(min, max) {
        const padding = Math.abs(this.reverse ? max : min) * 0.01;
        return [
            padding,
            padding
        ];
    }
    getTitleFormatterParams() {
        var _a;
        const boundSeries = this.boundSeries.reduce((acc, next)=>{
            const keys = next.getKeys(this.direction);
            const names = next.getNames(this.direction);
            for(let idx = 0; idx < keys.length; idx++)acc.push({
                key: keys[idx],
                name: names[idx]
            });
            return acc;
        }, []);
        return {
            direction: this.direction,
            boundSeries: boundSeries,
            defaultValue: (_a = this.title) == null ? void 0 : _a.text
        };
    }
    normaliseDataDomain(d) {
        return {
            domain: [
                ...d
            ],
            clipped: false
        };
    }
    getLayoutState() {
        return $d77b025aa58d633c$var$__spreadValues({
            rect: this.computeBBox(),
            gridPadding: this.gridPadding,
            seriesAreaPadding: this.seriesAreaPadding,
            tickSize: this.getTickSize(),
            direction: this.direction,
            domain: this.dataDomain.domain,
            scale: this.scale
        }, this.layout);
    }
    getModuleMap() {
        return this.moduleMap;
    }
    createModuleContext() {
        var _a;
        (_a = this.axisContext) != null ? _a : this.axisContext = this.createAxisContext();
        return $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, this.moduleCtx), {
            parent: this.axisContext
        });
    }
    createAxisContext() {
        return {
            axisId: this.id,
            direction: this.direction,
            continuous: $d77b025aa58d633c$var$ContinuousScale.is(this.scale),
            keys: ()=>this.boundSeries.flatMap((s)=>s.getKeys(this.direction)),
            seriesKeyProperties: ()=>this.boundSeries.reduce((keys, series)=>{
                    const seriesKeys = series.getKeyProperties(this.direction);
                    seriesKeys.forEach((key)=>{
                        if (keys.indexOf(key) < 0) keys.push(key);
                    });
                    return keys;
                }, []),
            scaleValueFormatter: (specifier)=>{
                var _a, _b;
                return specifier ? (_b = (_a = this.scale).tickFormat) == null ? void 0 : _b.call(_a, {
                    specifier: specifier
                }) : this.formatDatum;
            },
            scaleBandwidth: ()=>{
                var _a;
                return (_a = this.scale.bandwidth) != null ? _a : 0;
            },
            scaleConvert: (val)=>this.scale.convert(val),
            scaleInvert: (val)=>{
                var _a, _b;
                return (_b = (_a = this.scale).invert) == null ? void 0 : _b.call(_a, val);
            }
        };
    }
    animateReadyUpdate(diff2) {
        const { animationManager: animationManager } = this.moduleCtx;
        const selectionCtx = $d77b025aa58d633c$var$prepareAxisAnimationContext(this);
        const fns = $d77b025aa58d633c$var$prepareAxisAnimationFunctions(selectionCtx);
        $d77b025aa58d633c$var$fromToMotion(this.id, "axis-group", animationManager, [
            this.axisGroup
        ], fns.group);
        $d77b025aa58d633c$var$fromToMotion(this.id, "line", animationManager, [
            this.lineNode
        ], fns.line);
        $d77b025aa58d633c$var$fromToMotion(this.id, "line-paths", animationManager, [
            this.gridLineGroupSelection,
            this.tickLineGroupSelection
        ], fns.tick, (_, d)=>d.tickId, diff2);
        $d77b025aa58d633c$var$fromToMotion(this.id, "tick-labels", animationManager, [
            this.tickLabelGroupSelection
        ], fns.label, (_, d)=>d.tickId, diff2);
    }
    resetSelectionNodes() {
        const { gridLineGroupSelection: gridLineGroupSelection, tickLineGroupSelection: tickLineGroupSelection, tickLabelGroupSelection: tickLabelGroupSelection, lineNode: lineNode } = this;
        const selectionCtx = $d77b025aa58d633c$var$prepareAxisAnimationContext(this);
        $d77b025aa58d633c$var$resetMotion([
            this.axisGroup
        ], $d77b025aa58d633c$var$resetAxisGroupFn());
        $d77b025aa58d633c$var$resetMotion([
            gridLineGroupSelection,
            tickLineGroupSelection
        ], $d77b025aa58d633c$var$resetAxisSelectionFn(selectionCtx));
        $d77b025aa58d633c$var$resetMotion([
            tickLabelGroupSelection
        ], $d77b025aa58d633c$var$resetAxisLabelSelectionFn());
        $d77b025aa58d633c$var$resetMotion([
            lineNode
        ], $d77b025aa58d633c$var$resetAxisLineSelectionFn());
    }
    calculateUpdateDiff(previous, tickData) {
        const added = /* @__PURE__ */ new Set();
        const removed = /* @__PURE__ */ new Set();
        const tickMap = {};
        const tickCount = Math.max(previous.length, tickData.ticks.length);
        for(let i = 0; i < tickCount; i++){
            const tickDatum = tickData.ticks[i];
            const prev = previous[i];
            const tick = tickDatum == null ? void 0 : tickDatum.tickId;
            tickMap[tick != null ? tick : prev] = tickDatum;
            if (prev === tick) continue;
            if (removed.has(tick)) removed.delete(tick);
            else if (tick) added.add(tick);
            if (added.has(prev)) added.delete(prev);
            else if (prev) removed.add(prev);
        }
        return {
            changed: added.size > 0 || removed.size > 0,
            added: added,
            removed: removed
        };
    }
    isReversed() {
        return this.reverse;
    }
};
$d77b025aa58d633c$var$_Axis.defaultTickMinSpacing = 50;
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN)
], $d77b025aa58d633c$var$_Axis.prototype, "nice", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN)
], $d77b025aa58d633c$var$_Axis.prototype, "reverse", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING_ARRAY)
], $d77b025aa58d633c$var$_Axis.prototype, "keys", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT, {
        optional: true
    })
], $d77b025aa58d633c$var$_Axis.prototype, "title", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ObserveChanges((target, value, oldValue)=>target.onGridLengthChange(value, oldValue))
], $d77b025aa58d633c$var$_Axis.prototype, "gridLength", 2);
var $d77b025aa58d633c$var$Axis = $d77b025aa58d633c$var$_Axis;
// packages/ag-charts-community/src/chart/axis/cartesianAxisLabel.ts
var $d77b025aa58d633c$var$CartesianAxisLabel = class extends $d77b025aa58d633c$var$AxisLabel {
    constructor(){
        super(...arguments);
        this.autoRotateAngle = 335;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN, {
        optional: true
    })
], $d77b025aa58d633c$var$CartesianAxisLabel.prototype, "autoRotate", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$DEGREE)
], $d77b025aa58d633c$var$CartesianAxisLabel.prototype, "autoRotateAngle", 2);
// packages/ag-charts-community/src/chart/axis/cartesianAxis.ts
var $d77b025aa58d633c$var$_CartesianAxis = class _CartesianAxis extends $d77b025aa58d633c$var$Axis {
    constructor(){
        super(...arguments);
        this.thickness = 0;
        this.position = "left";
    }
    static is(value) {
        return value instanceof _CartesianAxis;
    }
    get direction() {
        return [
            "top",
            "bottom"
        ].includes(this.position) ? "x" /* X */  : "y" /* Y */ ;
    }
    updateDirection() {
        switch(this.position){
            case "top":
                this.rotation = -90;
                this.label.mirrored = true;
                this.label.parallel = true;
                break;
            case "right":
                this.rotation = 0;
                this.label.mirrored = true;
                this.label.parallel = false;
                break;
            case "bottom":
                this.rotation = -90;
                this.label.mirrored = false;
                this.label.parallel = true;
                break;
            case "left":
                this.rotation = 0;
                this.label.mirrored = false;
                this.label.parallel = false;
                break;
        }
        if (this.axisContext) {
            this.axisContext.position = this.position;
            this.axisContext.direction = this.direction;
        }
    }
    update(primaryTickCount, animated) {
        this.updateDirection();
        return super.update(primaryTickCount, animated);
    }
    calculateLayout(primaryTickCount) {
        this.updateDirection();
        return super.calculateLayout(primaryTickCount);
    }
    createAxisContext() {
        return $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, super.createAxisContext()), {
            position: this.position
        });
    }
    assignCrossLineArrayConstructor(crossLines) {
        $d77b025aa58d633c$var$assignJsonApplyConstructedArray(crossLines, $d77b025aa58d633c$var$CartesianCrossLine);
    }
    createLabel() {
        return new $d77b025aa58d633c$var$CartesianAxisLabel();
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$_CartesianAxis.prototype, "thickness", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITION2)
], $d77b025aa58d633c$var$_CartesianAxis.prototype, "position", 2);
var $d77b025aa58d633c$var$CartesianAxis = $d77b025aa58d633c$var$_CartesianAxis;
// packages/ag-charts-community/src/chart/axis/categoryAxis.ts
var $d77b025aa58d633c$var$CategoryAxisTick = class extends $d77b025aa58d633c$var$AxisTick {
    constructor(){
        super(...arguments);
        this.minSpacing = NaN;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$MIN_SPACING),
    $d77b025aa58d633c$var$Default(NaN)
], $d77b025aa58d633c$var$CategoryAxisTick.prototype, "minSpacing", 2);
var $d77b025aa58d633c$var$CategoryAxis = class extends $d77b025aa58d633c$var$CartesianAxis {
    constructor(moduleCtx, scale2 = new $d77b025aa58d633c$var$BandScale()){
        super(moduleCtx, scale2);
        this._paddingOverrideEnabled = false;
        this.groupPaddingInner = 0.1;
        this.includeInvisibleDomains = true;
    }
    set paddingInner(value) {
        this._paddingOverrideEnabled = true;
        this.scale.paddingInner = value;
    }
    get paddingInner() {
        this._paddingOverrideEnabled = true;
        return this.scale.paddingInner;
    }
    set paddingOuter(value) {
        this.scale.paddingOuter = value;
    }
    get paddingOuter() {
        return this.scale.paddingOuter;
    }
    createTick() {
        return new $d77b025aa58d633c$var$CategoryAxisTick();
    }
    normaliseDataDomain(d) {
        const domain = [];
        const uniqueValues = /* @__PURE__ */ new Set();
        for (const v of d){
            const key = v instanceof Date ? v.getTime() : v;
            if (!uniqueValues.has(key)) {
                uniqueValues.add(key);
                domain.push(v);
            }
        }
        return {
            domain: domain,
            clipped: false
        };
    }
    calculateDomain() {
        if (!this._paddingOverrideEnabled) {
            const paddings = this.boundSeries.map((s)=>{
                var _a;
                return (_a = s.getBandScalePadding) == null ? void 0 : _a.call(s);
            }).filter((p)=>p != null);
            if (paddings.length > 0) {
                this.scale.paddingInner = Math.min(...paddings.map((p)=>p.inner));
                this.scale.paddingOuter = Math.max(...paddings.map((p)=>p.outer));
            }
        }
        return super.calculateDomain();
    }
};
$d77b025aa58d633c$var$CategoryAxis.className = "CategoryAxis";
$d77b025aa58d633c$var$CategoryAxis.type = "category";
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$RATIO)
], $d77b025aa58d633c$var$CategoryAxis.prototype, "groupPaddingInner", 2);
// packages/ag-charts-community/src/chart/axis/tree.ts
var $d77b025aa58d633c$var$TreeNode = class {
    // current number in sibling group (index)
    constructor(label = "", parent, number = 0){
        this.x = 0;
        this.y = 0;
        this.subtreeLeft = NaN;
        this.subtreeRight = NaN;
        this.screenX = 0;
        this.screenY = 0;
        this.children = [];
        this.leafCount = 0;
        this.prelim = 0;
        this.mod = 0;
        this.ancestor = this;
        this.change = 0;
        this.shift = 0;
        this.label = label;
        this.parent = parent;
        this.depth = parent ? parent.depth + 1 : 0;
        this.number = number;
    }
    getLeftSibling() {
        return this.number > 0 && this.parent ? this.parent.children[this.number - 1] : void 0;
    }
    getLeftmostSibling() {
        return this.number > 0 && this.parent ? this.parent.children[0] : void 0;
    }
    // traverse the left contour of a subtree, return the successor of v on this contour
    nextLeft() {
        return this.children ? this.children[0] : this.thread;
    }
    // traverse the right contour of a subtree, return the successor of v on this contour
    nextRight() {
        return this.children ? this.children[this.children.length - 1] : this.thread;
    }
    getSiblings() {
        return this.parent ? this.parent.children.filter((_, i)=>i !== this.number) : [];
    }
};
function $d77b025aa58d633c$var$ticksToTree(ticks, pad2 = true) {
    const root = new $d77b025aa58d633c$var$TreeNode();
    let depth = 0;
    if (pad2) ticks.forEach((tick)=>depth = Math.max(depth, tick.labels.length));
    ticks.forEach((tick)=>{
        if (pad2) while(tick.labels.length < depth)tick.labels.unshift("");
        $d77b025aa58d633c$var$insertTick(root, tick);
    });
    return root;
}
function $d77b025aa58d633c$var$insertTick(root, tick) {
    const pathParts = tick.labels.slice().reverse();
    const lastPartIndex = pathParts.length - 1;
    pathParts.forEach((pathPart, partIndex)=>{
        const children = root.children;
        const existingNode = children.find((child)=>child.label === pathPart);
        const isNotLeaf = partIndex !== lastPartIndex;
        if (existingNode && isNotLeaf) root = existingNode;
        else {
            const node = new $d77b025aa58d633c$var$TreeNode(pathPart, root);
            node.number = children.length;
            children.push(node);
            if (isNotLeaf) root = node;
        }
    });
}
function $d77b025aa58d633c$var$moveSubtree(wm, wp, shift) {
    const subtrees = wp.number - wm.number;
    const ratio = shift / subtrees;
    wp.change -= ratio;
    wp.shift += shift;
    wm.change += ratio;
    wp.prelim += shift;
    wp.mod += shift;
}
function $d77b025aa58d633c$var$ancestor(vim, v, defaultAncestor) {
    return v.getSiblings().indexOf(vim.ancestor) >= 0 ? vim.ancestor : defaultAncestor;
}
function $d77b025aa58d633c$var$executeShifts(v) {
    const children = v.children;
    if (children) {
        let shift = 0;
        let change = 0;
        for(let i = children.length - 1; i >= 0; i--){
            const w = children[i];
            w.prelim += shift;
            w.mod += shift;
            change += w.change;
            shift += w.shift + change;
        }
    }
}
function $d77b025aa58d633c$var$apportion(v, defaultAncestor, distance2) {
    const w = v.getLeftSibling();
    if (w) {
        let vop = v;
        let vip = v;
        let vim = w;
        let vom = vip.getLeftmostSibling();
        let sip = vip.mod;
        let sop = vop.mod;
        let sim = vim.mod;
        let som = vom.mod;
        while(vim.nextRight() && vip.nextLeft()){
            vim = vim.nextRight();
            vip = vip.nextLeft();
            vom = vom.nextLeft();
            vop = vop.nextRight();
            vop.ancestor = v;
            const shift = vim.prelim + sim - (vip.prelim + sip) + distance2;
            if (shift > 0) {
                $d77b025aa58d633c$var$moveSubtree($d77b025aa58d633c$var$ancestor(vim, v, defaultAncestor), v, shift);
                sip += shift;
                sop += shift;
            }
            sim += vim.mod;
            sip += vip.mod;
            som += vom.mod;
            sop += vop.mod;
        }
        if (vim.nextRight() && !vop.nextRight()) {
            vop.thread = vim.nextRight();
            vop.mod += sim - sop;
        } else {
            if (vip.nextLeft() && !vom.nextLeft()) {
                vom.thread = vip.nextLeft();
                vom.mod += sip - som;
            }
            defaultAncestor = v;
        }
    }
    return defaultAncestor;
}
function $d77b025aa58d633c$var$firstWalk(node, distance2) {
    const children = node.children;
    if (children.length) {
        let defaultAncestor = children[0];
        children.forEach((child)=>{
            $d77b025aa58d633c$var$firstWalk(child, distance2);
            defaultAncestor = $d77b025aa58d633c$var$apportion(child, defaultAncestor, distance2);
        });
        $d77b025aa58d633c$var$executeShifts(node);
        const midpoint = (children[0].prelim + children.at(-1).prelim) / 2;
        const leftSibling = node.getLeftSibling();
        if (leftSibling) {
            node.prelim = leftSibling.prelim + distance2;
            node.mod = node.prelim - midpoint;
        } else node.prelim = midpoint;
    } else {
        const leftSibling = node.getLeftSibling();
        node.prelim = leftSibling ? leftSibling.prelim + distance2 : 0;
    }
}
var $d77b025aa58d633c$var$Dimensions = class {
    constructor(){
        this.top = Infinity;
        this.right = -Infinity;
        this.bottom = -Infinity;
        this.left = Infinity;
    }
    update(node, xy) {
        const { x: x, y: y } = xy(node);
        if (x > this.right) this.right = x;
        if (x < this.left) this.left = x;
        if (y > this.bottom) this.bottom = y;
        if (y < this.top) this.top = y;
    }
};
function $d77b025aa58d633c$var$secondWalk(v, m, layout) {
    v.x = v.prelim + m;
    v.y = v.depth;
    layout.update(v);
    v.children.forEach((w)=>$d77b025aa58d633c$var$secondWalk(w, m + v.mod, layout));
}
function $d77b025aa58d633c$var$thirdWalk(v) {
    const children = v.children;
    let leafCount = 0;
    children.forEach((w)=>{
        $d77b025aa58d633c$var$thirdWalk(w);
        if (w.children.length) leafCount += w.leafCount;
        else leafCount++;
    });
    v.leafCount = leafCount;
    if (children.length) {
        v.subtreeLeft = children[0].subtreeLeft;
        v.subtreeRight = children[v.children.length - 1].subtreeRight;
        v.x = (v.subtreeLeft + v.subtreeRight) / 2;
    } else {
        v.subtreeLeft = v.x;
        v.subtreeRight = v.x;
    }
}
function $d77b025aa58d633c$var$treeLayout(root) {
    const layout = new $d77b025aa58d633c$var$TreeLayout();
    $d77b025aa58d633c$var$firstWalk(root, 1);
    $d77b025aa58d633c$var$secondWalk(root, -root.prelim, layout);
    $d77b025aa58d633c$var$thirdWalk(root);
    return layout;
}
var $d77b025aa58d633c$var$TreeLayout = class {
    constructor(){
        this.dimensions = new $d77b025aa58d633c$var$Dimensions();
        this.leafCount = 0;
        this.nodes = [];
        // One might want to process leaf nodes separately from the rest of the tree.
        // For example, position labels corresponding to leafs vertically, rather than horizontally.
        this.leafNodes = [];
        this.nonLeafNodes = [];
        this.depth = 0;
    }
    update(node) {
        this.dimensions.update(node, (n)=>({
                x: n.x,
                y: n.y
            }));
        if (node.children.length) this.nonLeafNodes.push(node);
        else {
            this.leafCount++;
            this.leafNodes.push(node);
        }
        if (node.depth > this.depth) this.depth = node.depth;
        this.nodes.push(node);
    }
    resize(width, height, shiftX = 0, shiftY = 0, flipX = false) {
        const xSteps = this.leafCount - 1;
        const ySteps = this.depth;
        const dimensions = this.dimensions;
        let scalingX = 1;
        let scalingY = 1;
        if (width > 0 && xSteps) {
            const existingSpacingX = (dimensions.right - dimensions.left) / xSteps;
            const desiredSpacingX = width / xSteps;
            scalingX = desiredSpacingX / existingSpacingX;
            if (flipX) scalingX = -scalingX;
        }
        if (height > 0 && ySteps) {
            const existingSpacingY = (dimensions.bottom - dimensions.top) / ySteps;
            const desiredSpacingY = height / ySteps;
            scalingY = desiredSpacingY / existingSpacingY;
        }
        const screenDimensions = new $d77b025aa58d633c$var$Dimensions();
        this.nodes.forEach((node)=>{
            node.screenX = node.x * scalingX;
            node.screenY = node.y * scalingY;
            screenDimensions.update(node, (n)=>({
                    x: n.screenX,
                    y: n.screenY
                }));
        });
        const offsetX = -screenDimensions.left;
        const offsetY = -screenDimensions.top;
        this.nodes.forEach((node)=>{
            node.screenX += offsetX + shiftX;
            node.screenY += offsetY + shiftY;
        });
    }
};
// packages/ag-charts-community/src/chart/axis/groupedCategoryAxis.ts
var $d77b025aa58d633c$var$GroupedCategoryAxisLabel = class extends $d77b025aa58d633c$var$AxisLabel {
    constructor(){
        super(...arguments);
        this.grid = false;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN)
], $d77b025aa58d633c$var$GroupedCategoryAxisLabel.prototype, "grid", 2);
var $d77b025aa58d633c$var$GroupedCategoryAxis = class extends $d77b025aa58d633c$var$CartesianAxis {
    constructor(moduleCtx){
        super(moduleCtx, new $d77b025aa58d633c$var$BandScale());
        // Label scale (labels are positioned between ticks, tick count = label count + 1).
        // We don't call is `labelScale` for consistency with other axes.
        this.tickScale = new $d77b025aa58d633c$var$BandScale();
        this.line = new $d77b025aa58d633c$var$AxisLine();
        this.label = new $d77b025aa58d633c$var$GroupedCategoryAxisLabel();
        this.labelColor = "rgba(87, 87, 87, 1)";
        this.includeInvisibleDomains = true;
        const { tickLineGroup: tickLineGroup, tickLabelGroup: tickLabelGroup, gridLineGroup: gridLineGroup, tickScale: tickScale, scale: scale2 } = this;
        scale2.paddingOuter = 0.1;
        scale2.paddingInner = scale2.paddingOuter * 2;
        this.refreshScale();
        tickScale.paddingInner = 1;
        tickScale.paddingOuter = 0;
        this.gridLineSelection = $d77b025aa58d633c$var$Selection.select(gridLineGroup, $d77b025aa58d633c$var$Line);
        this.axisLineSelection = $d77b025aa58d633c$var$Selection.select(tickLineGroup, $d77b025aa58d633c$var$Line);
        this.separatorSelection = $d77b025aa58d633c$var$Selection.select(tickLineGroup, $d77b025aa58d633c$var$Line);
        this.labelSelection = $d77b025aa58d633c$var$Selection.select(tickLabelGroup, $d77b025aa58d633c$var$Text);
    }
    updateRange() {
        const { range: rr, visibleRange: vr, scale: scale2 } = this;
        const span = (rr[1] - rr[0]) / (vr[1] - vr[0]);
        const shift = span * vr[0];
        const start = rr[0] - shift;
        this.tickScale.range = scale2.range = [
            start,
            start + span
        ];
        this.resizeTickTree();
    }
    resizeTickTree() {
        var _a;
        const s = this.scale;
        const range3 = s.domain.length ? [
            s.convert(s.domain[0]),
            s.convert(s.domain[s.domain.length - 1])
        ] : s.range;
        const layout = this.tickTreeLayout;
        const lineHeight = this.lineHeight;
        if (layout) layout.resize(Math.abs(range3[1] - range3[0]), layout.depth * lineHeight, (Math.min(range3[0], range3[1]) || 0) + ((_a = s.bandwidth) != null ? _a : 0) / 2, -layout.depth * lineHeight, range3[1] - range3[0] < 0);
    }
    get lineHeight() {
        return this.label.fontSize * 1.5;
    }
    /**
   * The length of the grid. The grid is only visible in case of a non-zero value.
   */ onGridVisibilityChange() {
        this.gridLineSelection.clear();
        this.labelSelection.clear();
    }
    createTick() {
        return new $d77b025aa58d633c$var$CategoryAxisTick();
    }
    calculateDomain() {
        var _a;
        const { direction: direction } = this;
        let isNumericX = null;
        const flatDomains = this.boundSeries.filter((s)=>s.visible).flatMap((series)=>{
            if (direction === "y" /* Y */  || isNumericX) return series.getDomain(direction);
            if (isNumericX === null) {
                const domain2 = series.getDomain(direction);
                isNumericX = $d77b025aa58d633c$var$isNumber(domain2[0]);
                return domain2;
            }
            return [];
        });
        this.setDomain((_a = $d77b025aa58d633c$var$extent(flatDomains)) != null ? _a : $d77b025aa58d633c$var$unique(flatDomains));
        const { domain: domain } = this.dataDomain;
        this.tickTreeLayout = $d77b025aa58d633c$var$treeLayout($d77b025aa58d633c$var$ticksToTree(domain));
        this.tickScale.domain = domain.concat("");
        this.resizeTickTree();
    }
    /**
   * Creates/removes/updates the scene graph nodes that constitute the axis.
   * Supposed to be called _manually_ after changing _any_ of the axis properties.
   * This allows to bulk set axis properties before updating the nodes.
   * The node changes made by this method are rendered on the next animation frame.
   * We could schedule this method call automatically on the next animation frame
   * when any of the axis properties change (the way we do when properties of scene graph's
   * nodes change), but this will mean that we first wait for the next animation
   * frame to make changes to the nodes of the axis, then wait for another animation
   * frame to render those changes. It's nice to have everything update automatically,
   * but this extra level of async indirection will not just introduce an unwanted delay,
   * it will also make it harder to reason about the program.
   */ update() {
        if (!this.computedLayout) return;
        this.updatePosition();
        this.updateTitleCaption();
        this.updateCategoryLabels();
        this.updateSeparators();
        this.updateAxisLines();
        this.updateCategoryGridLines();
        this.resetSelectionNodes();
    }
    updateTitleCaption() {
        const { _titleCaption: _titleCaption } = this;
        _titleCaption.node.visible = false;
    }
    updateCategoryLabels() {
        if (!this.computedLayout) return;
        const { tickLabelLayout: tickLabelLayout } = this.computedLayout;
        const labelSelection = this.labelSelection.update(tickLabelLayout);
        labelSelection.each((node, datum)=>{
            node.setProperties(datum);
        });
    }
    updateSeparators() {
        if (!this.computedLayout) return;
        const { separatorLayout: separatorLayout } = this.computedLayout;
        const { range: range3 } = this;
        const epsilon2 = 1e-7;
        const separatorSelection = this.separatorSelection.update(separatorLayout);
        separatorSelection.each((line, datum)=>{
            line.x1 = datum.x1;
            line.x2 = datum.x2;
            line.y1 = datum.y;
            line.y2 = datum.y;
            line.visible = datum.y >= range3[0] - epsilon2 && datum.y <= range3[1] + epsilon2;
            line.stroke = this.tick.color;
            line.fill = void 0;
            line.strokeWidth = 1;
        });
    }
    updateAxisLines() {
        if (!this.computedLayout) return;
        const { axisLineLayout: axisLineLayout } = this.computedLayout;
        const axisLineSelection = this.axisLineSelection.update(axisLineLayout);
        axisLineSelection.each((line, datum)=>{
            line.setProperties($d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, datum), {
                stroke: this.line.color,
                strokeWidth: this.line.width
            }));
            line.x1 = datum.x;
            line.x2 = datum.x;
            line.y1 = datum.y1;
            line.y2 = datum.y2;
            line.strokeWidth = this.line.width;
            line.stroke = this.line.color;
        });
    }
    updateCategoryGridLines() {
        const { gridLength: gridLength, gridLine: gridLine, label: label, range: range3, tickScale: tickScale } = this;
        const ticks = tickScale.ticks();
        const sideFlag = label.getSideFlag();
        const gridSelection = this.gridLineSelection.update(gridLength ? ticks : []);
        if (gridLength) {
            const { width: width, style: style } = gridLine;
            const styleCount = style.length;
            gridSelection.each((line, datum, index)=>{
                const y = Math.round(tickScale.convert(datum));
                line.x1 = 0;
                line.x2 = -sideFlag * gridLength;
                line.y1 = y;
                line.y2 = y;
                line.visible = y >= range3[0] && y <= range3[1];
                const { stroke: stroke, lineDash: lineDash } = style[index % styleCount];
                line.stroke = stroke;
                line.strokeWidth = width;
                line.lineDash = lineDash;
                line.fill = void 0;
            });
        }
    }
    computeLayout() {
        this.updateDirection();
        this.calculateDomain();
        this.updateRange();
        const { scale: scale2, label: label, label: { parallel: parallel }, moduleCtx: { callbackCache: callbackCache }, range: range3, title: title, title: { formatter: formatter = (p)=>p.defaultValue } = {} } = this;
        const rangeStart = scale2.range[0];
        const rangeEnd = scale2.range[1];
        const rangeLength = Math.abs(rangeEnd - rangeStart);
        const bandwidth = rangeLength / scale2.domain.length || 0;
        const keepEvery = Math.ceil(label.fontSize / bandwidth);
        const rotation = $d77b025aa58d633c$var$toRadians(this.rotation);
        const isHorizontal = Math.abs(Math.cos(rotation)) < 1e-8;
        const sideFlag = label.getSideFlag();
        const lineHeight = this.lineHeight;
        const tickTreeLayout = this.tickTreeLayout;
        const labels = scale2.ticks();
        const treeLabels = tickTreeLayout ? tickTreeLayout.nodes : [];
        const isLabelTree = tickTreeLayout ? tickTreeLayout.depth > 1 : false;
        const { defaultRotation: defaultRotation, configuredRotation: configuredRotation, parallelFlipFlag: parallelFlipFlag } = $d77b025aa58d633c$var$calculateLabelRotation({
            rotation: label.rotation,
            parallel: parallel,
            regularFlipRotation: $d77b025aa58d633c$var$normalizeAngle360(rotation - Math.PI / 2),
            parallelFlipRotation: $d77b025aa58d633c$var$normalizeAngle360(rotation)
        });
        const tickLabelLayout = [];
        const copyLabelProps = (node)=>{
            return {
                fill: node.fill,
                fontFamily: node.fontFamily,
                fontSize: node.fontSize,
                fontStyle: node.fontStyle,
                fontWeight: node.fontWeight,
                rotation: node.rotation,
                rotationCenterX: node.rotationCenterX,
                rotationCenterY: node.rotationCenterY,
                text: node.text,
                textAlign: node.textAlign,
                textBaseline: node.textBaseline,
                translationX: node.translationX,
                translationY: node.translationY,
                visible: node.visible,
                x: node.x,
                y: node.y
            };
        };
        const labelBBoxes = /* @__PURE__ */ new Map();
        let maxLeafLabelWidth = 0;
        const tempText = new $d77b025aa58d633c$var$Text();
        const setLabelProps = (datum, index)=>{
            var _a;
            tempText.setProperties({
                fill: label.color,
                fontFamily: label.fontFamily,
                fontSize: label.fontSize,
                fontStyle: label.fontStyle,
                fontWeight: label.fontWeight,
                textAlign: "center",
                textBaseline: parallelFlipFlag === -1 ? "bottom" : "hanging",
                translationX: datum.screenY - label.fontSize * 0.25,
                translationY: datum.screenX
            });
            if (index === 0) {
                const isCaptionEnabled = (title == null ? void 0 : title.enabled) && labels.length > 0;
                if (!isCaptionEnabled) return false;
                const text = callbackCache.call(formatter, this.getTitleFormatterParams());
                tempText.setProperties({
                    fill: title.color,
                    fontFamily: title.fontFamily,
                    fontSize: title.fontSize,
                    fontStyle: title.fontStyle,
                    fontWeight: title.fontWeight,
                    text: text,
                    textBaseline: "hanging",
                    translationX: datum.screenY - label.fontSize * 0.25,
                    translationY: datum.screenX
                });
            } else if (index % keepEvery === 0) {
                const isInRange = datum.screenX >= range3[0] && datum.screenX <= range3[1];
                if (!isInRange) return false;
                if (label.formatter) tempText.text = (_a = callbackCache.call(label.formatter, {
                    value: String(datum.label),
                    index: index
                })) != null ? _a : String(datum.label);
                else tempText.text = String(datum.label);
            } else return false;
            return true;
        };
        treeLabels.forEach((datum, index)=>{
            const isVisible = setLabelProps(datum, index);
            if (!isVisible) return;
            const bbox2 = tempText.computeTransformedBBox();
            if (!bbox2) return;
            labelBBoxes.set(index, bbox2);
            const isLeaf = !datum.children.length;
            if (isLeaf && bbox2.width > maxLeafLabelWidth) maxLeafLabelWidth = bbox2.width;
        });
        const labelX = sideFlag * label.padding;
        const labelGrid = this.label.grid;
        const separatorData = [];
        treeLabels.forEach((datum, index)=>{
            let visible = setLabelProps(datum, index);
            const id = index;
            tempText.x = labelX;
            tempText.rotationCenterX = labelX;
            const isLeaf = !datum.children.length;
            if (isLeaf) {
                tempText.rotation = configuredRotation;
                tempText.textAlign = "end";
                tempText.textBaseline = "middle";
            } else {
                tempText.translationX -= maxLeafLabelWidth - lineHeight + this.label.padding;
                const availableRange = datum.leafCount * bandwidth;
                const bbox2 = labelBBoxes.get(id);
                if (bbox2 && bbox2.width > availableRange) {
                    visible = false;
                    labelBBoxes.delete(id);
                } else if (isHorizontal) tempText.rotation = defaultRotation;
                else tempText.rotation = -Math.PI / 2;
            }
            if (datum.parent && isLabelTree) {
                const y = isLeaf ? datum.screenX - bandwidth / 2 : datum.screenX - datum.leafCount * bandwidth / 2;
                if (isLeaf) {
                    if (datum.number !== datum.children.length - 1 || labelGrid) separatorData.push({
                        y: y,
                        x1: 0,
                        x2: -maxLeafLabelWidth - this.label.padding * 2
                    });
                } else {
                    const x = -maxLeafLabelWidth - this.label.padding * 2 + datum.screenY;
                    separatorData.push({
                        y: y,
                        x1: x + lineHeight,
                        x2: x
                    });
                }
            }
            let props;
            if (visible) {
                const bbox2 = tempText.computeTransformedBBox();
                if (bbox2) labelBBoxes.set(index, bbox2);
                props = $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, copyLabelProps(tempText)), {
                    visible: visible
                });
            } else {
                labelBBoxes.delete(index);
                props = {
                    visible: visible
                };
            }
            tickLabelLayout.push(props);
        });
        let minX = 0;
        separatorData.forEach((d)=>minX = Math.min(minX, d.x2));
        separatorData.push({
            y: Math.max(rangeStart, rangeEnd),
            x1: 0,
            x2: minX
        });
        const separatorLayout = [];
        const separatorBoxes = [];
        const epsilon2 = 1e-7;
        separatorData.forEach((datum)=>{
            if (datum.y >= range3[0] - epsilon2 && datum.y <= range3[1] + epsilon2) {
                const { x1: x1, x2: x2, y: y } = datum;
                const separatorBox = new $d77b025aa58d633c$var$BBox(Math.min(x1, x2), y, Math.abs(x1 - x2), 0);
                separatorBoxes.push(separatorBox);
                separatorLayout.push({
                    x1: x1,
                    x2: x2,
                    y: y
                });
            }
        });
        const axisLineLayout = [];
        const axisLineBoxes = [];
        const lineCount = tickTreeLayout ? tickTreeLayout.depth + 1 : 1;
        for(let i = 0; i < lineCount; i++){
            const visible = labels.length > 0 && (i === 0 || labelGrid && isLabelTree);
            const x = i > 0 ? -maxLeafLabelWidth - this.label.padding * 2 - (i - 1) * lineHeight : 0;
            const lineBox = new $d77b025aa58d633c$var$BBox(x, Math.min(...range3), 0, Math.abs(range3[1] - range3[0]));
            axisLineBoxes.push(lineBox);
            axisLineLayout.push({
                x: x,
                y1: range3[0],
                y2: range3[1],
                visible: visible
            });
        }
        const getTransformBox = (bbox2)=>{
            const matrix = new $d77b025aa58d633c$var$Matrix();
            const { rotation: axisRotation, translationX: translationX, translationY: translationY, rotationCenterX: rotationCenterX, rotationCenterY: rotationCenterY } = this.getAxisTransform();
            $d77b025aa58d633c$var$Matrix.updateTransformMatrix(matrix, 1, 1, axisRotation, translationX, translationY, {
                scalingCenterX: 0,
                scalingCenterY: 0,
                rotationCenterX: rotationCenterX,
                rotationCenterY: rotationCenterY
            });
            return matrix.transformBBox(bbox2);
        };
        const bbox = $d77b025aa58d633c$var$BBox.merge([
            ...labelBBoxes.values(),
            ...separatorBoxes,
            ...axisLineBoxes
        ]);
        const transformedBBox = getTransformBox(bbox);
        return {
            bbox: transformedBBox,
            tickLabelLayout: tickLabelLayout,
            separatorLayout: separatorLayout,
            axisLineLayout: axisLineLayout
        };
    }
    calculateLayout() {
        const { axisLineLayout: axisLineLayout, separatorLayout: separatorLayout, tickLabelLayout: tickLabelLayout, bbox: bbox } = this.computeLayout();
        this.computedLayout = {
            axisLineLayout: axisLineLayout,
            separatorLayout: separatorLayout,
            tickLabelLayout: tickLabelLayout
        };
        return {
            bbox: bbox,
            primaryTickCount: void 0
        };
    }
};
$d77b025aa58d633c$var$GroupedCategoryAxis.className = "GroupedCategoryAxis";
$d77b025aa58d633c$var$GroupedCategoryAxis.type = "grouped-category";
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$COLOR_STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$GroupedCategoryAxis.prototype, "labelColor", 2);
// packages/ag-charts-community/src/util/userAgent.ts
function $d77b025aa58d633c$var$hasConstrainedCanvasMemory() {
    if (typeof navigator === "undefined") return false;
    const iPhoneOSMatch = navigator.userAgent.match(/\(iPhone; CPU iPhone OS (\d+_\d+_\d+) like Mac OS X\)/);
    if (iPhoneOSMatch == null) return false;
    const [major, minor] = iPhoneOSMatch[1].split("_").map(Number);
    return major < 16 || major === 16 && minor < 6;
}
// packages/ag-charts-community/src/scene/canvas/hdpiCanvas.ts
var $d77b025aa58d633c$var$_HdpiCanvas = class _HdpiCanvas {
    constructor(options){
        this.enabled = true;
        this.width = 600;
        this.height = 300;
        const { width: width, height: height, pixelRatio: pixelRatio, position: position, insertAsFirstChild: insertAsFirstChild } = options;
        this.insertAsFirstChild = insertAsFirstChild != null ? insertAsFirstChild : false;
        this.pixelRatio = $d77b025aa58d633c$var$hasConstrainedCanvasMemory() ? 1 : pixelRatio != null ? pixelRatio : $d77b025aa58d633c$var$getWindow("devicePixelRatio");
        this.element = $d77b025aa58d633c$var$createElement("canvas");
        this.element.width = Math.round((width != null ? width : this.width) * this.pixelRatio);
        this.element.height = Math.round((height != null ? height : this.height) * this.pixelRatio);
        if (position) this.element.style.position = position;
        this.context = this.element.getContext("2d");
        this.onEnabledChange();
        this.resize(width != null ? width : 0, height != null ? height : 0);
        _HdpiCanvas.debugContext(this.context);
    }
    static is(value) {
        return value instanceof _HdpiCanvas;
    }
    drawImage(context, dx = 0, dy = 0) {
        return context.drawImage(this.context.canvas, dx, dy);
    }
    toDataURL(type) {
        return this.element.toDataURL(type);
    }
    resize(width, height) {
        if (!(width > 0 && height > 0)) return;
        const { element: element2, context: context, pixelRatio: pixelRatio } = this;
        element2.width = Math.round(width * pixelRatio);
        element2.height = Math.round(height * pixelRatio);
        context.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        element2.style.width = width + "px";
        element2.style.height = height + "px";
        this.width = width;
        this.height = height;
    }
    snapshot() {}
    clear() {
        this.context.save();
        this.context.setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
        this.context.clearRect(0, 0, this.width, this.height);
        this.context.restore();
    }
    destroy() {
        this.element.remove();
        this.element.width = 0;
        this.element.height = 0;
        this.context.clearRect(0, 0, 0, 0);
        Object.freeze(this);
    }
    onContainerChange(newValue, oldValue) {
        var _a, _b, _c, _d;
        if (newValue === oldValue) return;
        (_a = this.element.parentNode) == null || _a.removeChild(this.element);
        if (this.insertAsFirstChild && ((_b = this.container) == null ? void 0 : _b.firstChild)) (_c = this.container) == null || _c.insertBefore(this.element, this.container.firstChild);
        else (_d = this.container) == null || _d.appendChild(this.element);
    }
    onEnabledChange() {
        if (this.element) this.element.style.display = this.enabled ? "block" : "none";
    }
    // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
    static debugContext(ctx) {
        if ($d77b025aa58d633c$var$Debug.check("canvas")) {
            const save = ctx.save.bind(ctx);
            const restore = ctx.restore.bind(ctx);
            let depth = 0;
            Object.assign(ctx, {
                save () {
                    save();
                    depth++;
                },
                restore () {
                    if (depth === 0) throw new Error("AG Charts - Unable to restore() past depth 0");
                    restore();
                    depth--;
                },
                verifyDepthZero () {
                    if (depth !== 0) throw new Error(`AG Charts - Save/restore depth is non-zero: ${depth}`);
                }
            });
        }
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ObserveChanges((target)=>target.onEnabledChange())
], $d77b025aa58d633c$var$_HdpiCanvas.prototype, "enabled", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ObserveChanges((target, newValue, oldValue)=>target.onContainerChange(newValue, oldValue))
], $d77b025aa58d633c$var$_HdpiCanvas.prototype, "container", 2);
var $d77b025aa58d633c$var$HdpiCanvas = $d77b025aa58d633c$var$_HdpiCanvas;
// packages/ag-charts-community/src/scene/layersManager.ts
var $d77b025aa58d633c$var$LayersManager = class _LayersManager {
    constructor(canvas, markDirty){
        this.canvas = canvas;
        this.markDirty = markDirty;
        this.debug = $d77b025aa58d633c$var$Debug.create(true, "scene");
        this.layersMap = /* @__PURE__ */ new Map();
        this.nextZIndex = 0;
        this.nextLayerId = 0;
    }
    static sortLayers(a, b) {
        var _a, _b;
        return $d77b025aa58d633c$var$compoundAscending([
            a.zIndex,
            ...(_a = a.zIndexSubOrder) != null ? _a : [
                void 0,
                void 0
            ],
            a.id
        ], [
            b.zIndex,
            ...(_b = b.zIndexSubOrder) != null ? _b : [
                void 0,
                void 0
            ],
            b.id
        ], $d77b025aa58d633c$var$ascendingStringNumberUndefined);
    }
    get size() {
        return this.layersMap.size;
    }
    forEach(callback) {
        Array.from(this.layersMap.values()).sort(_LayersManager.sortLayers).forEach(callback);
    }
    resize(width, height) {
        this.canvas.resize(width, height);
        this.layersMap.forEach(({ canvas: canvas })=>canvas.resize(width, height));
    }
    addLayer(opts) {
        const { width: width, height: height, pixelRatio: pixelRatio } = this.canvas;
        const { zIndex: zIndex = this.nextZIndex++, name: name, zIndexSubOrder: zIndexSubOrder, getComputedOpacity: getComputedOpacity, getVisibility: getVisibility } = opts;
        const canvas = new $d77b025aa58d633c$var$HdpiCanvas({
            width: width,
            height: height,
            pixelRatio: pixelRatio,
            position: "absolute"
        });
        const newLayer = {
            id: this.nextLayerId++,
            name: name,
            canvas: canvas,
            zIndex: zIndex,
            zIndexSubOrder: zIndexSubOrder,
            getComputedOpacity: getComputedOpacity,
            getVisibility: getVisibility
        };
        if (zIndex >= this.nextZIndex) this.nextZIndex = zIndex + 1;
        this.layersMap.set(canvas, newLayer);
        this.debug("Scene.addLayer() - layers", this.layersMap);
        return newLayer.canvas;
    }
    removeLayer(canvas) {
        if (this.layersMap.has(canvas)) {
            this.layersMap.delete(canvas);
            canvas.destroy();
            this.markDirty();
            this.debug("Scene.removeLayer() -  layers", this.layersMap);
        }
    }
    moveLayer(canvas, newZIndex, newZIndexSubOrder) {
        const layer = this.layersMap.get(canvas);
        if (layer) {
            layer.zIndex = newZIndex;
            layer.zIndexSubOrder = newZIndexSubOrder;
            this.markDirty();
            this.debug("Scene.moveLayer() -  layers", this.layersMap);
        }
    }
    clear() {
        this.layersMap.clear();
    }
};
// packages/ag-charts-community/src/scene/sceneDebug.ts
function $d77b025aa58d633c$var$debugStats(layersManager, debugSplitTimes, ctx, renderCtxStats, extraDebugStats = {}) {
    if (!$d77b025aa58d633c$var$Debug.check("scene:stats" /* SCENE_STATS */ , "scene:stats:verbose" /* SCENE_STATS_VERBOSE */ )) return;
    const { layersRendered: layersRendered = 0, layersSkipped: layersSkipped = 0, nodesRendered: nodesRendered = 0, nodesSkipped: nodesSkipped = 0 } = renderCtxStats != null ? renderCtxStats : {};
    const end = performance.now();
    const _a = debugSplitTimes, { start: start } = _a, durations = $d77b025aa58d633c$var$__objRest(_a, [
        "start"
    ]);
    const splits = Object.entries(durations).map(([n, t])=>{
        return $d77b025aa58d633c$var$time(n, t);
    }).filter((v)=>v != null).join(" + ");
    const extras = Object.entries(extraDebugStats).map(([k, v])=>`${k}: ${v}`).join(" ; ");
    const detailedStats = $d77b025aa58d633c$var$Debug.check("scene:stats:verbose" /* SCENE_STATS_VERBOSE */ );
    const stats = [
        `${$d77b025aa58d633c$var$time("\u23F1\uFE0F", start, end)} (${splits})`,
        `${extras}`,
        `Layers: ${detailedStats ? $d77b025aa58d633c$var$pct(layersRendered, layersSkipped) : layersManager.size}`,
        detailedStats ? `Nodes: ${$d77b025aa58d633c$var$pct(nodesRendered, nodesSkipped)}` : null
    ].filter($d77b025aa58d633c$var$isString);
    const statsSize = new Map(stats.map((t)=>[
            t,
            $d77b025aa58d633c$var$Text.getTextSize(t, ctx.font)
        ]));
    const width = Math.max(...Array.from(statsSize.values(), (s)=>s.width));
    const height = $d77b025aa58d633c$var$accumulate(statsSize.values(), (s)=>s.height);
    ctx.save();
    ctx.fillStyle = "white";
    ctx.fillRect(0, 0, width, height);
    ctx.fillStyle = "black";
    let y = 0;
    for (const [stat, size] of statsSize.entries()){
        y += size.height;
        ctx.fillText(stat, 2, y);
    }
    ctx.restore();
}
function $d77b025aa58d633c$var$debugSceneNodeHighlight(ctx, debugNodes) {
    ctx.save();
    for (const [name, node] of Object.entries(debugNodes)){
        const bbox = node.computeTransformedBBox();
        if (!bbox) {
            $d77b025aa58d633c$var$Logger.log(`Scene.render() - no bbox for debugged node [${name}].`);
            continue;
        }
        ctx.globalAlpha = 0.8;
        ctx.strokeStyle = "red";
        ctx.lineWidth = 1;
        ctx.strokeRect(bbox.x, bbox.y, bbox.width, bbox.height);
        ctx.fillStyle = "red";
        ctx.strokeStyle = "white";
        ctx.font = "16px sans-serif";
        ctx.textBaseline = "top";
        ctx.textAlign = "left";
        ctx.lineWidth = 2;
        ctx.strokeText(name, bbox.x, bbox.y, bbox.width);
        ctx.fillText(name, bbox.x, bbox.y, bbox.width);
    }
    ctx.restore();
}
function $d77b025aa58d633c$var$buildTree(node) {
    var _a, _b;
    if (!$d77b025aa58d633c$var$Debug.check(true, "scene" /* SCENE */ )) return {};
    return $d77b025aa58d633c$var$__spreadValues($d77b025aa58d633c$var$__spreadValues({
        node: node,
        name: (_a = node instanceof $d77b025aa58d633c$var$Group ? node.name : null) != null ? _a : node.id,
        dirty: $d77b025aa58d633c$var$RedrawType[node.dirty]
    }, ((_b = node.parent) == null ? void 0 : _b.isVirtual) ? {
        virtualParentDirty: $d77b025aa58d633c$var$RedrawType[node.parent.dirty],
        virtualParent: node.parent
    } : {}), node.children.map((c)=>$d77b025aa58d633c$var$buildTree(c)).reduce((result, childTree)=>{
        let { name: treeNodeName } = childTree;
        const { node: { visible: visible, opacity: opacity, zIndex: zIndex, zIndexSubOrder: zIndexSubOrder }, node: childNode, virtualParent: virtualParent } = childTree;
        if (!visible || opacity <= 0) treeNodeName = `(${treeNodeName})`;
        if (childNode instanceof $d77b025aa58d633c$var$Group && childNode.isLayer()) treeNodeName = `*${treeNodeName}*`;
        const key = [
            `${treeNodeName != null ? treeNodeName : "<unknown>"}`,
            `z: ${zIndex}`,
            zIndexSubOrder && `zo: ${zIndexSubOrder.map((v)=>typeof v === "function" ? `${v()} (fn)` : v).join(" / ")}`,
            virtualParent && `(virtual parent)`
        ].filter((v)=>!!v).join(" ");
        let selectedKey = key;
        let index = 1;
        while(result[selectedKey] != null && index < 100)selectedKey = `${key} (${index++})`;
        result[selectedKey] = childTree;
        return result;
    }, {}));
}
function $d77b025aa58d633c$var$buildDirtyTree(node) {
    var _a;
    if (node.dirty === 0 /* NONE */ ) return {
        dirtyTree: {},
        paths: []
    };
    const childrenDirtyTree = node.children.map((c)=>$d77b025aa58d633c$var$buildDirtyTree(c)).filter((c)=>c.paths.length > 0);
    const name = $d77b025aa58d633c$var$Group.is(node) ? (_a = node.name) != null ? _a : node.id : node.id;
    const paths = childrenDirtyTree.length ? childrenDirtyTree.flatMap((c)=>c.paths).map((p)=>`${name}.${p}`) : [
        name
    ];
    return {
        dirtyTree: $d77b025aa58d633c$var$__spreadValues({
            name: name,
            node: node,
            dirty: $d77b025aa58d633c$var$RedrawType[node.dirty]
        }, childrenDirtyTree.map((c)=>c.dirtyTree).filter((t)=>t.dirty != null).reduce((result, childTree)=>{
            var _a2;
            result[(_a2 = childTree.name) != null ? _a2 : "<unknown>"] = childTree;
            return result;
        }, {})),
        paths: paths
    };
}
function $d77b025aa58d633c$var$pct(rendered, skipped) {
    const total = rendered + skipped;
    return `${rendered} / ${total} (${Math.round(100 * rendered / total)}%)`;
}
function $d77b025aa58d633c$var$time(name, start, end) {
    const duration = end != null ? end - start : start;
    return `${name}: ${Math.round(duration * 100) / 100}ms`;
}
function $d77b025aa58d633c$var$accumulate(iterator, mapper) {
    let sum2 = 0;
    for (const item of iterator)sum2 += mapper(item);
    return sum2;
}
// packages/ag-charts-community/src/scene/scene.ts
var $d77b025aa58d633c$var$Scene = class {
    constructor({ width: width, height: height, pixelRatio: pixelRatio, canvasPosition: canvasPosition }){
        this.debug = $d77b025aa58d633c$var$Debug.create(true, "scene" /* SCENE */ );
        this.id = $d77b025aa58d633c$var$createId(this);
        this.root = null;
        this.isDirty = false;
        this.canvas = new $d77b025aa58d633c$var$HdpiCanvas({
            width: width,
            height: height,
            pixelRatio: pixelRatio,
            position: canvasPosition,
            insertAsFirstChild: canvasPosition === "absolute"
        });
        this.layersManager = new $d77b025aa58d633c$var$LayersManager(this.canvas, ()=>{
            this.isDirty = true;
        });
    }
    get width() {
        var _a, _b;
        return (_b = (_a = this.pendingSize) == null ? void 0 : _a[0]) != null ? _b : this.canvas.width;
    }
    get height() {
        var _a, _b;
        return (_b = (_a = this.pendingSize) == null ? void 0 : _a[1]) != null ? _b : this.canvas.height;
    }
    setContainer(value) {
        this.canvas.container = value;
        return this;
    }
    setRoot(node) {
        var _a;
        if (this.root === node) return this;
        this.isDirty = true;
        (_a = this.root) == null || _a._setLayerManager();
        this.root = node;
        if (node) {
            node.visible = true;
            node._setLayerManager(this.layersManager);
        }
        return this;
    }
    attachNode(node) {
        var _a;
        (_a = this.root) == null || _a.appendChild(node);
        return ()=>this.removeChild(node);
    }
    appendChild(node) {
        var _a;
        (_a = this.root) == null || _a.appendChild(node);
        return this;
    }
    removeChild(node) {
        var _a;
        (_a = this.root) == null || _a.removeChild(node);
        return this;
    }
    download(fileName, fileFormat) {
        var _a;
        $d77b025aa58d633c$var$downloadUrl(this.canvas.toDataURL(fileFormat), (_a = fileName == null ? void 0 : fileName.trim()) != null ? _a : "image");
    }
    /** NOTE: Integrated Charts undocumented image download method. */ getDataURL(fileFormat) {
        return this.canvas.toDataURL(fileFormat);
    }
    resize(width, height) {
        width = Math.round(width);
        height = Math.round(height);
        if (width > 0 && height > 0 && (width !== this.width || height !== this.height)) {
            this.pendingSize = [
                width,
                height
            ];
            this.isDirty = true;
            return true;
        }
        return false;
    }
    render(opts) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            var _a, _b;
            const { debugSplitTimes: debugSplitTimes = {
                start: performance.now()
            }, extraDebugStats: extraDebugStats } = opts != null ? opts : {};
            const { canvas: canvas, canvas: { context: ctx } = {}, root: root, pendingSize: pendingSize } = this;
            if (!ctx) return;
            const renderStartTime = performance.now();
            if (pendingSize) {
                this.layersManager.resize(...pendingSize);
                this.pendingSize = void 0;
            }
            if (root && !root.visible) {
                this.isDirty = false;
                return;
            }
            if (root && !this.isDirty) {
                if (this.debug.check()) this.debug("Scene.render() - no-op", {
                    redrawType: $d77b025aa58d633c$var$RedrawType[root.dirty],
                    tree: $d77b025aa58d633c$var$buildTree(root)
                });
                $d77b025aa58d633c$var$debugStats(this.layersManager, debugSplitTimes, ctx, void 0, extraDebugStats);
                return;
            }
            const renderCtx = {
                ctx: ctx,
                devicePixelRatio: (_a = this.canvas.pixelRatio) != null ? _a : 1,
                forceRender: true,
                resized: Boolean(pendingSize),
                debugNodes: {}
            };
            if ($d77b025aa58d633c$var$Debug.check("scene:stats:verbose" /* SCENE_STATS_VERBOSE */ )) renderCtx.stats = {
                layersRendered: 0,
                layersSkipped: 0,
                nodesRendered: 0,
                nodesSkipped: 0
            };
            let canvasCleared = false;
            if (!root || root.dirty >= 1 /* TRIVIAL */ ) {
                canvasCleared = true;
                canvas.clear();
            }
            if (root && $d77b025aa58d633c$var$Debug.check("scene:dirtyTree" /* SCENE_DIRTY_TREE */ )) {
                const { dirtyTree: dirtyTree, paths: paths } = $d77b025aa58d633c$var$buildDirtyTree(root);
                $d77b025aa58d633c$var$Debug.create("scene:dirtyTree" /* SCENE_DIRTY_TREE */ )("Scene.render() - dirtyTree", {
                    dirtyTree: dirtyTree,
                    paths: paths
                });
            }
            if (root && canvasCleared) {
                this.debug("Scene.render() - before", {
                    redrawType: $d77b025aa58d633c$var$RedrawType[root.dirty],
                    canvasCleared: canvasCleared,
                    tree: $d77b025aa58d633c$var$buildTree(root)
                });
                if (root.visible) {
                    root.preRender();
                    ctx.save();
                    root.render(renderCtx);
                    ctx.restore();
                }
            }
            debugSplitTimes["\u270D\uFE0F"] = performance.now() - renderStartTime;
            if (this.layersManager.size && canvasCleared) {
                const layerRenderStart = performance.now();
                ctx.save();
                ctx.resetTransform();
                this.layersManager.forEach((layer)=>{
                    if (layer.canvas.enabled && layer.getVisibility()) {
                        ctx.globalAlpha = layer.getComputedOpacity();
                        layer.canvas.drawImage(ctx);
                    }
                });
                ctx.restore();
                debugSplitTimes["\u26D9"] = performance.now() - layerRenderStart;
            }
            (_b = ctx.verifyDepthZero) == null || _b.call(ctx);
            this.isDirty = false;
            $d77b025aa58d633c$var$debugStats(this.layersManager, debugSplitTimes, ctx, renderCtx.stats, extraDebugStats);
            $d77b025aa58d633c$var$debugSceneNodeHighlight(ctx, renderCtx.debugNodes);
            if (root && this.debug.check()) this.debug("Scene.render() - after", {
                redrawType: $d77b025aa58d633c$var$RedrawType[root.dirty],
                tree: $d77b025aa58d633c$var$buildTree(root),
                canvasCleared: canvasCleared
            });
        });
    }
    /** Alternative to destroy() that preserves re-usable resources. */ strip() {
        const { context: context, pixelRatio: pixelRatio } = this.canvas;
        context.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
        this.layersManager.clear();
        this.setRoot(null);
        this.isDirty = false;
    }
    destroy() {
        this.canvas.container = void 0;
        this.strip();
        this.canvas.destroy();
        Object.assign(this, {
            canvas: void 0
        });
    }
};
$d77b025aa58d633c$var$Scene.className = "Scene";
// packages/ag-charts-community/src/styles/icons.ts
var $d77b025aa58d633c$var$icons_default = `
[class^='ag-charts-icon'] {
    display: block;
    /* speak: none; */
    mask-size: contain;
    mask-repeat: no-repeat;
    background-color: currentColor;
}

.ag-charts-icon-zoom-in {
    mask-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJsdWNpZGUgbHVjaWRlLXpvb20taW4iPjxjaXJjbGUgY3g9IjExIiBjeT0iMTEiIHI9IjgiLz48bGluZSB4MT0iMjEiIHgyPSIxNi42NSIgeTE9IjIxIiB5Mj0iMTYuNjUiLz48bGluZSB4MT0iMTEiIHgyPSIxMSIgeTE9IjgiIHkyPSIxNCIvPjxsaW5lIHgxPSI4IiB4Mj0iMTQiIHkxPSIxMSIgeTI9IjExIi8+PC9zdmc+);
}

.ag-charts-icon-zoom-out {
    mask-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJsdWNpZGUgbHVjaWRlLXpvb20tb3V0Ij48Y2lyY2xlIGN4PSIxMSIgY3k9IjExIiByPSI4Ii8+PGxpbmUgeDE9IjIxIiB4Mj0iMTYuNjUiIHkxPSIyMSIgeTI9IjE2LjY1Ii8+PGxpbmUgeDE9IjgiIHgyPSIxNCIgeTE9IjExIiB5Mj0iMTEiLz48L3N2Zz4=);
}

.ag-charts-icon-reset {
    mask-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJsdWNpZGUgbHVjaWRlLXJvdGF0ZS1jY3ciPjxwYXRoIGQ9Ik0zIDEyYTkgOSAwIDEgMCA5LTkgOS43NSA5Ljc1IDAgMCAwLTYuNzQgMi43NEwzIDgiLz48cGF0aCBkPSJNMyAzdjVoNSIvPjwvc3ZnPg==);
}

.ag-charts-icon-pan-left {
    mask-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJsdWNpZGUgbHVjaWRlLWNoZXZyb24tbGVmdCI+PHBhdGggZD0ibTE1IDE4LTYtNiA2LTYiLz48L3N2Zz4=);
}

.ag-charts-icon-pan-right {
    mask-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJsdWNpZGUgbHVjaWRlLWNoZXZyb24tcmlnaHQiPjxwYXRoIGQ9Im05IDE4IDYtNi02LTYiLz48L3N2Zz4=);
}

.ag-charts-icon-pan-start {
    mask-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJsdWNpZGUgbHVjaWRlLWNoZXZyb24tZmlyc3QiPjxwYXRoIGQ9Im0xNyAxOC02LTYgNi02Ii8+PHBhdGggZD0iTTcgNnYxMiIvPjwvc3ZnPg==);
}

.ag-charts-icon-pan-end {
    mask-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIGNsYXNzPSJsdWNpZGUgbHVjaWRlLWNoZXZyb24tbGFzdCI+PHBhdGggZD0ibTcgMTggNi02LTYtNiIvPjxwYXRoIGQ9Ik0xNyA2djEyIi8+PC9zdmc+);
}

`;
// packages/ag-charts-community/src/styles/reset.ts
var $d77b025aa58d633c$var$reset_default = `
[class^='ag-charts'],
[class^='ag-charts']:focus,
[class^='ag-charts']:after,
[class^='ag-charts']:before {
    box-sizing: border-box;
    outline: none;
}

button[class^='ag-charts'] {
    background: none;
    border: 0;
}

`;
// packages/ag-charts-community/src/styles/theme-default.ts
var $d77b025aa58d633c$var$theme_default_default = `
.ag-charts-theme-default,
.ag-charts-theme-default-dark {
    /* Colors */
    --ag-charts-active-color: var(--ag-active-color, #2196f3);
    --ag-charts-background-color: var(--ag-background-color, #fff);
    --ag-charts-foreground-color: var(--ag-foreground-color, #181d1f);
    --ag-charts-border-color: var(--ag-border-color, #dddddd);

    /* Sizing */
    --ag-charts-font-size: var(--ag-font-size, 14px);
    --ag-charts-size: var(--ag-grid-size, 8px);

    /* Borders */
    --ag-charts-border: var(--ag-borders, solid 1px);
    --ag-charts-border-critical: var(--ag-borders-critical, solid 1px);

    /* Toolbar */
    --ag-charts-toolbar-foreground-color: var(--ag-header-foreground-color, var(--ag-charts-foreground-color));
    --ag-charts-toolbar-background-color: var(
        --ag-header-background-color,
        color-mix(in srgb, var(--ag-charts-background-color), var(--ag-charts-foreground-color) 2%)
    );
    --ag-charts-toolbar-size: var(--ag-header-height, 48px);
    --ag-charts-toolbar-padding: calc(var(--ag-charts-size) * 2);
    --ag-charts-toolbar-border: var(--ag-charts-border, solid 1px) var(--ag-charts-border-color);
    --ag-charts-toolbar-border-critical: var(--ag-charts-border-critical, solid 1px) var(--ag-charts-border-color);
    --ag-charts-toolbar-hover-color: color-mix(in srgb, var(--ag-charts-background-color), var(--ag-charts-active-color) 12%);
    --ag-charts-toolbar-disabled-foreground-color: var(
        --ag-disabled-foreground-color,
        color-mix(in srgb, transparent, var(--ag-charts-toolbar-foreground-color) 50%)
    );
    --ag-charts-toolbar-disabled-background-color: var(
        --ag-input-disabled-background-color,
        color-mix(in srgb, var(--ag-charts-toolbar-background-color), var(--ag-charts-toolbar-foreground-color) 6%)
    );
    --ag-charts-toolbar-gap: var(--ag-charts-size);

    /* Buttons */
    --ag-charts-button-padding: var(--ag-charts-size);
    --ag-charts-button-radius: var(--ag-border-radius, 4px);

    /* Focus Indicator */
    --ag-charts-focus-border: solid 2px var(--ag-input-focus-border-color, var(--ag-charts-active-color));
    --ag-charts-focus-border-shadow: var(--ag-input-focus-box-shadow, 0 0 0 3px color-mix(in srgb, transparent, var(--ag-charts-focus-border) 47%));

    /* Icons */
    --ag-charts-icon-font-family: 'agChartsDefault';
    --ag-charts-icon-font-weight: normal;
    --ag-charts-icon-font-color: color-mix(in srgb, transparent, var(--ag-charts-foreground-color), 90%);
}

`;
// packages/ag-charts-community/src/styles/theme-default-dark.ts
var $d77b025aa58d633c$var$theme_default_dark_default = `
.ag-charts-theme-default-dark {
    /* Colors */
    --ag-charts-background-color: var(--ag-background-color, color-mix(in srgb, #fff, #182230 97%));
    --ag-charts-foreground-color: var(--ag-foreground-color, #fff);
    --ag-charts-border-color: var(--ag-border-color, rgba(255, 255, 255, 0.16));
    --ag-charts-hover-color: var(
        --ag-row-hover-color,
        color-mix(in srgb, transparent, var(--ag-charts-active-color) 20%)
    );

    /* Toolbar */
    --ag-charts-toolbar-background-color: var(--ag-header-background-color, color-mix(in srgb, #fff, #182230 93%));
}

`;
// packages/ag-charts-community/src/styles/styles.ts
var $d77b025aa58d633c$var$styles_default = `
/* Reset */
${$d77b025aa58d633c$var$reset_default}

/* Icons */
${$d77b025aa58d633c$var$icons_default}

/* AG Charts Theme Default */
${$d77b025aa58d633c$var$theme_default_default}

/* AG Charts Theme Default Dark */
${$d77b025aa58d633c$var$theme_default_dark_default}
`;
// packages/ag-charts-community/src/util/async.ts
function $d77b025aa58d633c$var$sleep(sleepTimeoutMs) {
    return new Promise((resolve)=>{
        setTimeout(()=>resolve(void 0), sleepTimeoutMs);
    });
}
// packages/ag-charts-community/src/util/mutex.ts
var $d77b025aa58d633c$var$Mutex = class {
    constructor(){
        this.available = true;
        this.acquireQueue = [];
    }
    acquire(cb) {
        return new Promise((resolve)=>{
            this.acquireQueue.push([
                cb,
                resolve
            ]);
            if (this.available) this.dispatchNext().catch((e)=>$d77b025aa58d633c$var$Logger.errorOnce(e));
        });
    }
    acquireImmediately(cb) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            if (!this.available) return false;
            yield this.acquire(cb);
            return true;
        });
    }
    waitForClearAcquireQueue() {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            return this.acquire(()=>$d77b025aa58d633c$var$__async(this, null, function*() {
                    return void 0;
                }));
        });
    }
    dispatchNext() {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            var _a, _b;
            this.available = false;
            let [next, done] = (_a = this.acquireQueue.shift()) != null ? _a : [];
            while(next){
                try {
                    yield next();
                    done == null || done();
                } catch (error) {
                    $d77b025aa58d633c$var$Logger.error("mutex callback error", error);
                    done == null || done();
                }
                [next, done] = (_b = this.acquireQueue.shift()) != null ? _b : [];
            }
            this.available = true;
        });
    }
};
// packages/ag-charts-community/src/util/observable.ts
var $d77b025aa58d633c$var$Observable = class {
    constructor(){
        this.eventListeners = /* @__PURE__ */ new Map();
    }
    addEventListener(eventType, listener) {
        if (typeof listener !== "function") throw new Error("AG Charts - listener must be a Function");
        const eventTypeListeners = this.eventListeners.get(eventType);
        if (eventTypeListeners) eventTypeListeners.add(listener);
        else this.eventListeners.set(eventType, /* @__PURE__ */ new Set([
            listener
        ]));
    }
    removeEventListener(type, listener) {
        var _a;
        (_a = this.eventListeners.get(type)) == null || _a.delete(listener);
        if (this.eventListeners.size === 0) this.eventListeners.delete(type);
    }
    hasEventListener(type) {
        return this.eventListeners.has(type);
    }
    clearEventListeners() {
        this.eventListeners.clear();
    }
    fireEvent(event) {
        var _a;
        (_a = this.eventListeners.get(event.type)) == null || _a.forEach((listener)=>listener(event));
    }
};
// packages/ag-charts-community/src/util/padding.ts
var $d77b025aa58d633c$var$Padding = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(top = 0, right = top, bottom = top, left = right){
        super();
        this.top = top;
        this.right = right;
        this.bottom = bottom;
        this.left = left;
    }
    clear() {
        this.top = this.right = this.bottom = this.left = 0;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$Padding.prototype, "top", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$Padding.prototype, "right", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$Padding.prototype, "bottom", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$Padding.prototype, "left", 2);
// packages/ag-charts-community/src/util/render.ts
function $d77b025aa58d633c$var$debouncedAnimationFrame(cb) {
    return $d77b025aa58d633c$var$buildScheduler((innerCb, _delayMs)=>requestAnimationFrame(innerCb), cb);
}
function $d77b025aa58d633c$var$debouncedCallback(cb) {
    return $d77b025aa58d633c$var$buildScheduler((innerCb, delayMs = 0)=>setTimeout(innerCb, delayMs), cb);
}
function $d77b025aa58d633c$var$buildScheduler(scheduleFn, cb) {
    let scheduleCount = 0;
    let promiseRunning = false;
    let awaitingPromise;
    let awaitingDone;
    const busy = ()=>{
        return promiseRunning;
    };
    const done = ()=>{
        promiseRunning = false;
        awaitingDone == null || awaitingDone();
        awaitingDone = void 0;
        awaitingPromise = void 0;
        if (scheduleCount > 0) scheduleFn(scheduleCb);
    };
    const scheduleCb = ()=>{
        const count = scheduleCount;
        scheduleCount = 0;
        promiseRunning = true;
        const maybePromise = cb({
            count: count
        });
        if (!maybePromise) {
            done();
            return;
        }
        maybePromise.then(done, done);
    };
    return {
        schedule (delayMs) {
            if (scheduleCount === 0 && !busy()) scheduleFn(scheduleCb, delayMs);
            scheduleCount++;
        },
        await () {
            return $d77b025aa58d633c$var$__async(this, null, function*() {
                if (!busy()) return;
                if (awaitingPromise == null) awaitingPromise = new Promise((resolve)=>{
                    awaitingDone = resolve;
                });
                while(busy())yield awaitingPromise;
            });
        }
    };
}
// packages/ag-charts-community/src/util/sizeMonitor.ts
var $d77b025aa58d633c$var$SizeMonitor = class {
    constructor(){
        this.elements = /* @__PURE__ */ new Map();
        this.documentReady = false;
        this.queuedObserveRequests = [];
        this.onLoad = ()=>{
            this.documentReady = true;
            this.queuedObserveRequests.forEach(([el, cb])=>this.observe(el, cb));
            this.queuedObserveRequests = [];
        };
        var _a;
        if (typeof ResizeObserver === "undefined") return;
        this.resizeObserver = new ResizeObserver((entries)=>{
            for (const { target: target, contentRect: contentRect } of entries){
                const { width: width, height: height } = contentRect;
                this.checkSize(this.elements.get(target), target, width, height);
            }
        });
        this.documentReady = $d77b025aa58d633c$var$getDocument("readyState") === "complete";
        if (!this.documentReady) (_a = $d77b025aa58d633c$var$getWindow()) == null || _a.addEventListener("load", this.onLoad);
    }
    destroy() {
        var _a, _b;
        (_a = $d77b025aa58d633c$var$getWindow()) == null || _a.removeEventListener("load", this.onLoad);
        (_b = this.resizeObserver) == null || _b.disconnect();
        this.resizeObserver = null;
    }
    checkSize(entry, element2, width, height) {
        var _a, _b;
        if (!entry) return;
        if (width !== ((_a = entry.size) == null ? void 0 : _a.width) || height !== ((_b = entry.size) == null ? void 0 : _b.height)) {
            entry.size = {
                width: width,
                height: height
            };
            entry.cb(entry.size, element2);
        }
    }
    // Only a single callback is supported.
    observe(element2, cb) {
        var _a;
        if (!this.documentReady) {
            this.queuedObserveRequests.push([
                element2,
                cb
            ]);
            return;
        }
        if (this.elements.has(element2)) this.removeFromQueue(element2);
        else (_a = this.resizeObserver) == null || _a.observe(element2);
        this.elements.set(element2, {
            cb: cb
        });
    }
    unobserve(element2) {
        var _a;
        (_a = this.resizeObserver) == null || _a.unobserve(element2);
        this.elements.delete(element2);
        this.removeFromQueue(element2);
        if (!this.elements.size) this.destroy();
    }
    removeFromQueue(element2) {
        this.queuedObserveRequests = this.queuedObserveRequests.filter(([el])=>el !== element2);
    }
};
// packages/ag-charts-community/src/util/callbackCache.ts
var $d77b025aa58d633c$var$CallbackCache = class {
    constructor(){
        this.cache = /* @__PURE__ */ new WeakMap();
    }
    call(fn, ...params) {
        let serialisedParams;
        let paramCache = this.cache.get(fn);
        const invoke = ()=>{
            try {
                const result = fn(...params);
                if (paramCache && serialisedParams != null) paramCache.set(serialisedParams, result);
                return result;
            } catch (e) {
                $d77b025aa58d633c$var$Logger.warnOnce(`User callback errored, ignoring`, e);
                return;
            }
        };
        try {
            serialisedParams = JSON.stringify(params);
        } catch (e) {
            return invoke();
        }
        if (paramCache == null) {
            paramCache = /* @__PURE__ */ new Map();
            this.cache.set(fn, paramCache);
        }
        if (!paramCache.has(serialisedParams)) return invoke();
        return paramCache.get(serialisedParams);
    }
    invalidateCache() {
        this.cache = /* @__PURE__ */ new WeakMap();
    }
};
// packages/ag-charts-community/src/chart/annotation/annotationManager.ts
var $d77b025aa58d633c$var$AnnotationManager = class {
    constructor(annotationRoot){
        this.annotationRoot = annotationRoot;
    }
    attachNode(node) {
        this.annotationRoot.append(node);
        return ()=>{
            var _a;
            (_a = this.annotationRoot) == null || _a.removeChild(node);
            return this;
        };
    }
    setAnnotationStyles(styles) {
        this.styles = styles;
    }
    getAnnotationTypeStyles(type) {
        var _a;
        return (_a = this.styles) == null ? void 0 : _a[type];
    }
};
// packages/ag-charts-community/src/util/listeners.ts
var $d77b025aa58d633c$var$Listeners = class {
    constructor(){
        this.registeredListeners = /* @__PURE__ */ new Map();
    }
    addListener(eventType, handler) {
        const record = {
            symbol: Symbol(eventType),
            handler: handler
        };
        if (this.registeredListeners.has(eventType)) this.registeredListeners.get(eventType).push(record);
        else this.registeredListeners.set(eventType, [
            record
        ]);
        return ()=>this.removeListener(record.symbol);
    }
    removeListener(eventSymbol) {
        for (const [type, listeners] of this.registeredListeners.entries()){
            const matchIndex = listeners.findIndex((listener)=>listener.symbol === eventSymbol);
            if (matchIndex >= 0) {
                listeners.splice(matchIndex, 1);
                if (listeners.length === 0) this.registeredListeners.delete(type);
                break;
            }
        }
    }
    dispatch(eventType, ...params) {
        for (const listener of this.getListenersByType(eventType))try {
            listener.handler(...params);
        } catch (e) {
            $d77b025aa58d633c$var$Logger.errorOnce(e);
        }
    }
    dispatchWrapHandlers(eventType, wrapFn, ...params) {
        for (const listener of this.getListenersByType(eventType))try {
            wrapFn(listener.handler, ...params);
        } catch (e) {
            $d77b025aa58d633c$var$Logger.errorOnce(e);
        }
    }
    getListenersByType(eventType) {
        var _a;
        return (_a = this.registeredListeners.get(eventType)) != null ? _a : [];
    }
    destroy() {
        this.registeredListeners.clear();
    }
};
// packages/ag-charts-community/src/chart/data/dataService.ts
var $d77b025aa58d633c$var$DataService = class extends $d77b025aa58d633c$var$Listeners {
    constructor(animationManager){
        super();
        this.animationManager = animationManager;
        this.dispatchOnlyLatest = true;
        this.dispatchThrottle = 0;
        this.requestThrottle = 300;
        this.isLoadingInitialData = false;
        this.isLoadingData = false;
        this.freshRequests = [];
        this.requestCounter = 0;
        this.debug = $d77b025aa58d633c$var$Debug.create(true, "data-model", "data-source");
        this.throttledFetch = this.createThrottledFetch(this.requestThrottle);
        this.throttledDispatch = this.createThrottledDispatch(this.dispatchThrottle);
    }
    updateCallback(dataSourceCallback) {
        if (typeof dataSourceCallback !== "function") return;
        this.debug("DataService - updated data source callback");
        this.dataSourceCallback = dataSourceCallback;
        this.isLoadingInitialData = true;
        this.animationManager.skip();
        this.dispatch("data-source-change");
    }
    clearCallback() {
        this.dataSourceCallback = void 0;
    }
    load(params) {
        this.isLoadingData = true;
        this.throttledFetch(params);
    }
    isLazy() {
        return this.dataSourceCallback != null;
    }
    isLoading() {
        return this.isLazy() && (this.isLoadingInitialData || this.isLoadingData);
    }
    createThrottledFetch(requestThrottle) {
        return $d77b025aa58d633c$var$throttle((params)=>this.fetch(params), requestThrottle, {
            leading: false,
            trailing: true
        });
    }
    createThrottledDispatch(dispatchThrottle) {
        return $d77b025aa58d633c$var$throttle((id, data)=>{
            this.debug(`DataService - dispatching 'data-load' | ${id}`);
            this.dispatch("data-load", {
                type: "data-load",
                data: data
            });
        }, dispatchThrottle, {
            leading: true,
            trailing: true
        });
    }
    fetch(params) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            if (!this.dataSourceCallback) throw new Error("DataService - [dataSource.getData] callback not initialised");
            const start = performance.now();
            const id = this.requestCounter++;
            this.debug(`DataService - requesting | ${id}`);
            this.freshRequests.push(id);
            let response;
            try {
                response = yield this.dataSourceCallback(params);
                this.debug(`DataService - response | ${performance.now() - start}ms | ${id}`);
            } catch (error) {
                this.debug(`DataService - request failed | ${id}`);
                $d77b025aa58d633c$var$Logger.errorOnce(`DataService - request failed | [${error}]`);
            }
            this.isLoadingInitialData = false;
            const requestIndex = this.freshRequests.findIndex((rid)=>rid === id);
            if (requestIndex === -1 || this.dispatchOnlyLatest && requestIndex !== this.freshRequests.length - 1) {
                this.debug(`DataService - discarding stale request | ${id}`);
                return;
            }
            this.freshRequests = this.freshRequests.slice(requestIndex + 1);
            if (this.freshRequests.length === 0) this.isLoadingData = false;
            if (Array.isArray(response)) this.throttledDispatch(id, response);
            else this.dispatch("data-error");
        });
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ActionOnSet({
        newValue (dispatchThrottle) {
            this.throttledDispatch = this.createThrottledDispatch(dispatchThrottle);
        }
    })
], $d77b025aa58d633c$var$DataService.prototype, "dispatchThrottle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ActionOnSet({
        newValue (requestThrottle) {
            this.throttledFetch = this.createThrottledFetch(requestThrottle);
        }
    })
], $d77b025aa58d633c$var$DataService.prototype, "requestThrottle", 2);
// packages/ag-charts-community/src/chart/interaction/animationBatch.ts
var $d77b025aa58d633c$var$AnimationBatch = class {
    constructor(maxAnimationTime){
        this.maxAnimationTime = maxAnimationTime;
        this.debug = $d77b025aa58d633c$var$Debug.create(true, "animation");
        this.controllers = /* @__PURE__ */ new Map();
        this.stoppedCbs = /* @__PURE__ */ new Set();
        this.currentPhase = 0;
        this.phases = new Map($d77b025aa58d633c$var$PHASE_ORDER.map((p)=>[
                p,
                []
            ]));
        this.skipAnimations = false;
        this.animationTimeConsumed = 0;
        /** Guard against premature animation execution. */ this.isReady = false;
    }
    get size() {
        return this.controllers.size;
    }
    get consumedTimeMs() {
        return this.animationTimeConsumed;
    }
    isActive() {
        return this.controllers.size > 0;
    }
    getActiveControllers() {
        var _a;
        return (_a = this.phases.get($d77b025aa58d633c$var$PHASE_ORDER[this.currentPhase])) != null ? _a : [];
    }
    checkOverlappingId(id) {
        if (id != null && this.controllers.has(id)) {
            this.controllers.get(id).stop();
            this.debug(`Skipping animation batch due to update of existing animation: ${id}`);
            this.skip();
        }
    }
    addAnimation(animation) {
        var _a;
        if (animation.isComplete) return;
        const animationPhaseIdx = $d77b025aa58d633c$var$PHASE_ORDER.indexOf(animation.phase);
        if (animationPhaseIdx < this.currentPhase) {
            this.debug(`Skipping animation due to being for an earlier phase`, animation.id);
            animation.stop();
            return;
        }
        this.controllers.set(animation.id, animation);
        (_a = this.phases.get(animation.phase)) == null || _a.push(animation);
    }
    removeAnimation(animation) {
        this.controllers.delete(animation.id);
        const phase = this.phases.get(animation.phase);
        const index = phase == null ? void 0 : phase.indexOf(animation);
        if (index != null && index >= 0) phase == null || phase.splice(index, 1);
    }
    progress(deltaTime) {
        if (!this.isReady) return;
        let unusedTime = deltaTime === 0 ? 0.01 : deltaTime;
        const refresh = ()=>{
            const phase2 = $d77b025aa58d633c$var$PHASE_ORDER[this.currentPhase];
            return {
                phaseControllers: [
                    ...this.getActiveControllers()
                ],
                phase: phase2,
                phaseMeta: $d77b025aa58d633c$var$PHASE_METADATA[phase2]
            };
        };
        let { phase: phase, phaseControllers: phaseControllers, phaseMeta: phaseMeta } = refresh();
        const arePhasesComplete = ()=>$d77b025aa58d633c$var$PHASE_ORDER[this.currentPhase] == null;
        const progressPhase = ()=>{
            ({ phase: phase, phaseControllers: phaseControllers, phaseMeta: phaseMeta } = refresh());
            while(!arePhasesComplete() && phaseControllers.length === 0){
                this.currentPhase++;
                ({ phase: phase, phaseControllers: phaseControllers, phaseMeta: phaseMeta } = refresh());
                this.debug(`AnimationBatch - phase changing to ${phase}`, {
                    unusedTime: unusedTime
                }, phaseControllers);
            }
        };
        const total = this.controllers.size;
        this.debug(`AnimationBatch - ${deltaTime}ms; phase ${phase} with ${phaseControllers == null ? void 0 : phaseControllers.length} of ${total}`);
        do {
            const phaseDeltaTime = unusedTime;
            const skipPhase = phaseMeta.skipIfNoEarlierAnimations && this.animationTimeConsumed === 0;
            let completeCount = 0;
            for (const controller of phaseControllers){
                if (skipPhase) controller.stop();
                else unusedTime = Math.min(controller.update(phaseDeltaTime), unusedTime);
                if (controller.isComplete) {
                    completeCount++;
                    this.removeAnimation(controller);
                }
            }
            this.animationTimeConsumed += phaseDeltaTime - unusedTime;
            this.debug(`AnimationBatch - updated ${phaseControllers.length} controllers; ${completeCount} completed`);
            this.debug(`AnimationBatch - animationTimeConsumed: ${this.animationTimeConsumed}`);
            progressPhase();
        }while (unusedTime > 0 && !arePhasesComplete());
        if (this.animationTimeConsumed > this.maxAnimationTime) {
            $d77b025aa58d633c$var$Logger.warnOnce("Animation batch exceeded max animation time, skipping.", new Map(this.controllers.entries()));
            this.stop();
        }
    }
    ready() {
        if (this.isReady) return;
        this.isReady = true;
        this.debug(`AnimationBatch - ready; skipped: ${this.skipAnimations}`, [
            ...this.controllers
        ]);
        let skipAll = true;
        for (const [, controller] of this.controllers)if (controller.duration > 0 && $d77b025aa58d633c$var$PHASE_METADATA[controller.phase].skipIfNoEarlierAnimations !== true) {
            skipAll = false;
            break;
        }
        if (!skipAll) {
            for (const [, controller] of this.controllers)if (controller.autoplay) controller.play(true);
        }
    }
    skip(skip = true) {
        if (this.skipAnimations === false && skip === true) {
            for (const controller of this.controllers.values())controller.stop();
            this.controllers.clear();
        }
        this.skipAnimations = skip;
    }
    play() {
        for (const controller of this.controllers.values())controller.play();
    }
    pause() {
        for (const controller of this.controllers.values())controller.pause();
    }
    stop() {
        for (const controller of this.controllers.values())try {
            controller.stop();
            this.removeAnimation(controller);
        } catch (error) {
            $d77b025aa58d633c$var$Logger.error("Error during animation stop", error);
        }
        this.dispatchStopped();
    }
    stopByAnimationId(id) {
        if (id != null && this.controllers.has(id)) {
            const controller = this.controllers.get(id);
            if (controller) {
                controller.stop();
                this.removeAnimation(controller);
            }
        }
    }
    stopByAnimationGroupId(id) {
        for (const controller of this.controllers.values())if (controller.groupId === id) this.stopByAnimationId(controller.id);
    }
    dispatchStopped() {
        this.stoppedCbs.forEach((cb)=>cb());
        this.stoppedCbs.clear();
    }
    isSkipped() {
        return this.skipAnimations;
    }
    destroy() {
        this.stop();
        this.controllers.clear();
    }
};
// packages/ag-charts-community/src/chart/interaction/baseManager.ts
var $d77b025aa58d633c$var$BaseManager = class {
    constructor(){
        this.listeners = new $d77b025aa58d633c$var$Listeners();
        this.destroyFns = [];
    }
    addListener(type, handler) {
        return this.listeners.addListener(type, handler);
    }
    removeListener(listenerSymbol) {
        this.listeners.removeListener(listenerSymbol);
    }
    destroy() {
        this.listeners.destroy();
        this.destroyFns.forEach((fn)=>fn());
    }
};
// packages/ag-charts-community/src/chart/interaction/consumableEvent.ts
function $d77b025aa58d633c$var$buildConsumable(obj) {
    const builtEvent = $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, obj), {
        consumed: false,
        consume () {
            var _a, _b;
            builtEvent.consumed = true;
            if (obj.sourceEvent instanceof Event) (_a = obj.sourceEvent) == null || _a.preventDefault();
            else (_b = obj.sourceEvent) == null || _b.consume();
        }
    });
    return builtEvent;
}
function $d77b025aa58d633c$var$buildConsumptionHandler() {
    return (handler, e)=>{
        if (!e.consumed) handler(e);
    };
}
function $d77b025aa58d633c$var$dispatchTypedConsumable(listeners, type, event) {
    listeners.dispatchWrapHandlers(type, $d77b025aa58d633c$var$buildConsumptionHandler(), event);
}
// packages/ag-charts-community/src/chart/interaction/interactionManager.ts
var $d77b025aa58d633c$var$POINTER_INTERACTION_TYPES = [
    "click",
    "dblclick",
    "contextmenu",
    "hover",
    "drag-start",
    "drag",
    "drag-end",
    "leave",
    "enter",
    "page-left",
    "wheel"
];
var $d77b025aa58d633c$var$FOCUS_INTERACTION_TYPES = [
    "blur",
    "focus"
];
var $d77b025aa58d633c$var$KEY_INTERACTION_TYPES = [
    "keydown",
    "keyup"
];
var $d77b025aa58d633c$var$WINDOW_EVENT_HANDLERS = [
    "pagehide",
    "mousemove",
    "mouseup"
];
var $d77b025aa58d633c$var$EVENT_HANDLERS = [
    "click",
    "dblclick",
    "contextmenu",
    "mousedown",
    "mouseout",
    "mouseenter",
    "touchstart",
    "touchmove",
    "touchend",
    "touchcancel",
    "wheel",
    "blur",
    "focus",
    "keydown",
    "keyup"
];
var $d77b025aa58d633c$var$CSS = `
.ag-chart-wrapper {
    touch-action: none;
}
`;
var $d77b025aa58d633c$var$InteractionState = /* @__PURE__ */ ((InteractionState2)=>{
    InteractionState2[InteractionState2["Default"] = 16] = "Default";
    InteractionState2[InteractionState2["ZoomDrag"] = 8] = "ZoomDrag";
    InteractionState2[InteractionState2["Annotations"] = 4] = "Annotations";
    InteractionState2[InteractionState2["ContextMenu"] = 2] = "ContextMenu";
    InteractionState2[InteractionState2["Animation"] = 1] = "Animation";
    InteractionState2[InteractionState2["All"] = 31] = "All";
    return InteractionState2;
})($d77b025aa58d633c$var$InteractionState || {});
var $d77b025aa58d633c$var$_InteractionManager = class _InteractionManager extends $d77b025aa58d633c$var$BaseManager {
    constructor(keyboardOptions, element2){
        super();
        this.keyboardOptions = keyboardOptions;
        this.debug = $d77b025aa58d633c$var$Debug.create(true, "interaction");
        this.eventHandler = (event)=>this.processEvent(event);
        this.mouseDown = false;
        this.touchDown = false;
        this.clickHistory = [
            {
                offsetX: NaN,
                offsetY: NaN,
                type: "mousedown"
            }
        ];
        this.dblclickHistory = [
            {
                offsetX: NaN,
                offsetY: NaN,
                type: "mousedown"
            },
            {
                offsetX: NaN,
                offsetY: NaN,
                type: "mouseup"
            },
            {
                offsetX: NaN,
                offsetY: NaN,
                type: "mousedown"
            }
        ];
        this.stateQueue = 17 /* Animation */ ;
        this.rootElement = $d77b025aa58d633c$var$getDocument("body");
        this.element = element2;
        for (const type of $d77b025aa58d633c$var$EVENT_HANDLERS){
            if (type.startsWith("touch")) element2.addEventListener(type, this.eventHandler, {
                passive: true
            });
            else if (type === "wheel") element2.addEventListener(type, this.eventHandler, {
                passive: false
            });
            else element2.addEventListener(type, this.eventHandler);
        }
        for (const type of $d77b025aa58d633c$var$WINDOW_EVENT_HANDLERS)$d77b025aa58d633c$var$getWindow().addEventListener(type, this.eventHandler);
        $d77b025aa58d633c$var$injectStyle($d77b025aa58d633c$var$CSS, "interactionManager");
    }
    destroy() {
        super.destroy();
        for (const type of $d77b025aa58d633c$var$WINDOW_EVENT_HANDLERS)$d77b025aa58d633c$var$getWindow().removeEventListener(type, this.eventHandler);
        for (const type of $d77b025aa58d633c$var$EVENT_HANDLERS)this.element.removeEventListener(type, this.eventHandler);
    }
    // Wrapper to only broadcast events when the InteractionManager is a given state.
    addListener(type, handler, triggeringStates = 16 /* Default */ ) {
        return super.addListener(type, (e)=>{
            const currentState = this.getState();
            if (currentState & triggeringStates) handler(e);
        });
    }
    pushState(state) {
        this.stateQueue |= state;
    }
    popState(state) {
        this.stateQueue &= ~state;
    }
    getState() {
        return this.stateQueue & -this.stateQueue;
    }
    processEvent(event) {
        const types = this.decideInteractionEventTypes(event);
        if (types.length > 0) this.dispatchEvent(event, types).catch((e)=>$d77b025aa58d633c$var$Logger.errorOnce(e));
    }
    dispatchEvent(event, types) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            if ($d77b025aa58d633c$var$allInStringUnion($d77b025aa58d633c$var$POINTER_INTERACTION_TYPES, types)) this.dispatchPointerEvent(event, types);
            else if ($d77b025aa58d633c$var$allInStringUnion($d77b025aa58d633c$var$FOCUS_INTERACTION_TYPES, types)) for (const type of types)$d77b025aa58d633c$var$dispatchTypedConsumable(this.listeners, type, $d77b025aa58d633c$var$buildConsumable({
                type: type,
                sourceEvent: event
            }));
            else if ($d77b025aa58d633c$var$allInStringUnion($d77b025aa58d633c$var$KEY_INTERACTION_TYPES, types)) for (const type of types)$d77b025aa58d633c$var$dispatchTypedConsumable(this.listeners, type, $d77b025aa58d633c$var$buildConsumable({
                type: type,
                sourceEvent: event
            }));
        });
    }
    dispatchPointerEvent(event, types) {
        const coords = this.calculateCoordinates(event);
        if (coords == null) return;
        for (const type of types)$d77b025aa58d633c$var$dispatchTypedConsumable(this.listeners, type, this.buildPointerEvent($d77b025aa58d633c$var$__spreadValues({
            type: type,
            event: event
        }, coords)));
    }
    recordDown(event) {
        if (event instanceof MouseEvent) {
            $d77b025aa58d633c$var$partialAssign([
                "offsetX",
                "offsetY"
            ], this.clickHistory[0], event);
            $d77b025aa58d633c$var$partialAssign([
                "offsetX",
                "offsetY"
            ], this.dblclickHistory[2], this.dblclickHistory[0]);
            $d77b025aa58d633c$var$partialAssign([
                "offsetX",
                "offsetY"
            ], this.dblclickHistory[0], event);
        }
        this.dragStartElement = event.target;
    }
    recordUp(event) {
        if (event instanceof MouseEvent) $d77b025aa58d633c$var$partialAssign([
            "offsetX",
            "offsetY"
        ], this.dblclickHistory[1], event);
        this.dragStartElement = void 0;
    }
    decideInteractionEventTypes(event) {
        const dragStart = "drag-start";
        switch(event.type){
            case "blur":
            case "focus":
            case "keydown":
            case "keyup":
                return this.keyboardOptions.enabled ? [
                    event.type
                ] : [];
            case "click":
            case "dblclick":
            case "contextmenu":
            case "wheel":
                return [
                    event.type
                ];
            case "mousedown":
                if (!this.isEventOverElement(event)) return [];
                this.mouseDown = true;
                this.recordDown(event);
                return [
                    dragStart
                ];
            case "touchstart":
                if (!this.isEventOverElement(event)) return [];
                this.touchDown = true;
                this.recordDown(event);
                return [
                    dragStart
                ];
            case "touchmove":
            case "mousemove":
                if (!this.mouseDown && !this.touchDown && !this.isEventOverElement(event)) return [];
                return this.mouseDown || this.touchDown ? [
                    "drag"
                ] : [
                    "hover"
                ];
            case "mouseup":
                if (!this.mouseDown && !this.isEventOverElement(event)) return [];
                this.mouseDown = false;
                this.recordUp(event);
                return [
                    "drag-end"
                ];
            case "touchend":
                if (!this.touchDown && !this.isEventOverElement(event)) return [];
                this.touchDown = false;
                this.recordUp(event);
                return [
                    "drag-end"
                ];
            case "mouseout":
            case "touchcancel":
                return [
                    "leave"
                ];
            case "mouseenter":
                const mouseButtonDown = event instanceof MouseEvent && (event.buttons & 1) === 1;
                if (this.mouseDown !== mouseButtonDown) {
                    this.mouseDown = mouseButtonDown;
                    return [
                        mouseButtonDown ? dragStart : "drag-end"
                    ];
                }
                return [
                    "enter"
                ];
            case "pagehide":
                return [
                    "page-left"
                ];
        }
        return [];
    }
    isEventOverElement(event) {
        var _a, _b, _c;
        return event.target === this.element || ((_a = event.target) == null ? void 0 : _a.parentElement) === this.element || ((_c = (_b = event.target) == null ? void 0 : _b.parentElement) == null ? void 0 : _c.parentElement) === this.element;
    }
    calculateCoordinates(event) {
        var _a;
        if (event instanceof MouseEvent) return this.getMouseEventCoords(event);
        else if (typeof TouchEvent !== "undefined" && event instanceof TouchEvent) {
            const lastTouch = (_a = event.touches[0]) != null ? _a : event.changedTouches[0];
            const { clientX: clientX, clientY: clientY, pageX: pageX, pageY: pageY } = lastTouch;
            return $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, _InteractionManager.NULL_COORDS), {
                clientX: clientX,
                clientY: clientY,
                pageX: pageX,
                pageY: pageY
            });
        } else if (event instanceof PageTransitionEvent) {
            if (event.persisted) return;
            return _InteractionManager.NULL_COORDS;
        }
    }
    getMouseEventCoords(event) {
        const { clientX: clientX, clientY: clientY, pageX: pageX, pageY: pageY } = event;
        let { offsetX: offsetX, offsetY: offsetY } = event;
        const offsets = (el)=>{
            let x = 0;
            let y = 0;
            while(el){
                x += el.offsetLeft;
                y += el.offsetTop;
                el = el.offsetParent;
            }
            return {
                x: x,
                y: y
            };
        };
        if (this.dragStartElement != null && event.target !== this.dragStartElement) {
            const offsetDragStart = offsets(this.dragStartElement);
            const offsetEvent = offsets(event.target);
            offsetX -= offsetDragStart.x - offsetEvent.x;
            offsetY -= offsetDragStart.y - offsetEvent.y;
        }
        return {
            clientX: clientX,
            clientY: clientY,
            pageX: pageX,
            pageY: pageY,
            offsetX: offsetX,
            offsetY: offsetY
        };
    }
    isWheelEvent(event) {
        return event.type === "wheel";
    }
    buildPointerEvent(opts) {
        const { type: type, event: event, clientX: clientX, clientY: clientY } = opts;
        let { offsetX: offsetX, offsetY: offsetY, pageX: pageX, pageY: pageY } = opts;
        if (!$d77b025aa58d633c$var$isFiniteNumber(offsetX) || !$d77b025aa58d633c$var$isFiniteNumber(offsetY)) {
            const rect = this.element.getBoundingClientRect();
            offsetX = clientX - rect.left;
            offsetY = clientY - rect.top;
        }
        if (!$d77b025aa58d633c$var$isFiniteNumber(pageX) || !$d77b025aa58d633c$var$isFiniteNumber(pageY)) {
            const pageRect = this.rootElement.getBoundingClientRect();
            pageX = clientX - pageRect.left;
            pageY = clientY - pageRect.top;
        }
        let [deltaX, deltaY] = [
            NaN,
            NaN
        ];
        if (this.isWheelEvent(event)) {
            const factor = event.deltaMode === 0 ? 0.01 : 1;
            deltaX = event.deltaX * factor;
            deltaY = event.deltaY * factor;
        }
        let pointerHistory = [];
        if (event.type === "click") pointerHistory = this.clickHistory;
        else if (event.type === "dblclick") pointerHistory = this.dblclickHistory;
        const builtEvent = $d77b025aa58d633c$var$buildConsumable({
            type: type,
            offsetX: offsetX,
            offsetY: offsetY,
            pageX: pageX,
            pageY: pageY,
            deltaX: deltaX,
            deltaY: deltaY,
            pointerHistory: pointerHistory,
            sourceEvent: event
        });
        this.debug("InteractionManager - builtEvent: ", builtEvent);
        return builtEvent;
    }
};
$d77b025aa58d633c$var$_InteractionManager.NULL_COORDS = {
    clientX: -Infinity,
    clientY: -Infinity,
    pageX: -Infinity,
    pageY: -Infinity,
    offsetX: -Infinity,
    offsetY: -Infinity
};
var $d77b025aa58d633c$var$InteractionManager = $d77b025aa58d633c$var$_InteractionManager;
// packages/ag-charts-community/src/chart/interaction/animationManager.ts
function $d77b025aa58d633c$var$validAnimationDuration(testee) {
    if (testee == null) return true;
    return !isNaN(testee) && testee >= 0 && testee <= 2;
}
var $d77b025aa58d633c$var$AnimationManager = class extends $d77b025aa58d633c$var$BaseManager {
    constructor(interactionManager, chartUpdateMutex){
        super();
        this.interactionManager = interactionManager;
        this.chartUpdateMutex = chartUpdateMutex;
        this.defaultDuration = 1e3;
        this.batch = new $d77b025aa58d633c$var$AnimationBatch(this.defaultDuration * 1.5);
        this.debug = $d77b025aa58d633c$var$Debug.create(true, "animation");
        this.rafAvailable = typeof requestAnimationFrame !== "undefined";
        this.isPlaying = false;
        this.requestId = null;
        this.skipAnimations = false;
    }
    /**
   * Create an animation to tween a value between the `from` and `to` properties. If an animation already exists
   * with the same `id`, immediately stop it.
   */ animate(_a) {
        var opts = $d77b025aa58d633c$var$__objRest(_a, []);
        var _a2;
        const batch = this.batch;
        try {
            batch.checkOverlappingId(opts.id);
        } catch (error) {
            this.failsafeOnError(error);
            return;
        }
        const id = (_a2 = opts.id) != null ? _a2 : Math.random().toString();
        const skip = this.isSkipped() || opts.phase === "none";
        if (skip) this.debug("AnimationManager - skipping animation");
        const { delay: delay, duration: duration } = opts;
        if (!$d77b025aa58d633c$var$validAnimationDuration(delay)) throw new Error(`Animation delay of ${delay} is unsupported (${id})`);
        if (!$d77b025aa58d633c$var$validAnimationDuration(duration)) throw new Error(`Animation duration of ${duration} is unsupported (${id})`);
        const animation = new $d77b025aa58d633c$var$Animation($d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, opts), {
            id: id,
            skip: skip,
            autoplay: this.isPlaying ? opts.autoplay : false,
            phase: opts.phase,
            defaultDuration: this.defaultDuration
        }));
        if (this.forceTimeJump(animation, this.defaultDuration)) return;
        this.batch.addAnimation(animation);
        return animation;
    }
    play() {
        if (this.isPlaying) return;
        this.isPlaying = true;
        this.debug("AnimationManager.play()");
        try {
            this.batch.play();
        } catch (error) {
            this.failsafeOnError(error);
        }
        this.requestAnimation();
    }
    pause() {
        if (!this.isPlaying) return;
        this.isPlaying = false;
        this.cancelAnimation();
        this.debug("AnimationManager.pause()");
        try {
            this.batch.pause();
        } catch (error) {
            this.failsafeOnError(error);
        }
    }
    stop() {
        this.isPlaying = false;
        this.cancelAnimation();
        this.debug("AnimationManager.stop()");
        this.batch.stop();
    }
    stopByAnimationId(id) {
        try {
            this.batch.stopByAnimationId(id);
        } catch (error) {
            this.failsafeOnError(error);
        }
    }
    stopByAnimationGroupId(id) {
        try {
            this.batch.stopByAnimationGroupId(id);
        } catch (error) {
            this.failsafeOnError(error);
        }
    }
    reset() {
        if (this.isPlaying) {
            this.stop();
            this.play();
        } else this.stop();
    }
    skip(skip = true) {
        this.skipAnimations = skip;
    }
    isSkipped() {
        return !this.rafAvailable || this.skipAnimations || this.batch.isSkipped();
    }
    isActive() {
        return this.isPlaying && this.batch.isActive();
    }
    skipCurrentBatch() {
        if (this.debug.check()) this.debug(`AnimationManager - skipCurrentBatch()`, {
            stack: new Error().stack
        });
        this.batch.skip();
    }
    /** Mocking point for tests to guarantee that animation updates happen. */ isSkippingFrames() {
        return true;
    }
    /** Mocking point for tests to capture requestAnimationFrame callbacks. */ scheduleAnimationFrame(cb) {
        this.requestId = requestAnimationFrame(cb);
    }
    /** Mocking point for tests to skip animations to a specific point in time. */ forceTimeJump(_animation, _defaultDuration) {
        return false;
    }
    requestAnimation() {
        if (!this.rafAvailable) return;
        if (!this.batch.isActive() || this.requestId !== null) return;
        let prevTime;
        const onAnimationFrame = (time2)=>$d77b025aa58d633c$var$__async(this, null, function*() {
                const executeAnimationFrame = ()=>$d77b025aa58d633c$var$__async(this, null, function*() {
                        const deltaTime = time2 - (prevTime != null ? prevTime : time2);
                        prevTime = time2;
                        this.debug("AnimationManager - onAnimationFrame()", {
                            controllersCount: this.batch.size,
                            deltaTime: deltaTime
                        });
                        this.interactionManager.pushState(1 /* Animation */ );
                        try {
                            this.batch.progress(deltaTime);
                        } catch (error) {
                            this.failsafeOnError(error);
                        }
                        this.listeners.dispatch("animation-frame", {
                            type: "animation-frame",
                            deltaMs: deltaTime
                        });
                    });
                if (this.isSkippingFrames()) yield this.chartUpdateMutex.acquireImmediately(executeAnimationFrame);
                else yield this.chartUpdateMutex.acquire(executeAnimationFrame);
                if (this.batch.isActive()) this.scheduleAnimationFrame(onAnimationFrame);
                else {
                    this.batch.stop();
                    this.listeners.dispatch("animation-stop", {
                        type: "animation-stop",
                        deltaMs: this.batch.consumedTimeMs
                    });
                }
            });
        this.listeners.dispatch("animation-start", {
            type: "animation-start",
            deltaMs: 0
        });
        this.scheduleAnimationFrame(onAnimationFrame);
    }
    cancelAnimation() {
        if (this.requestId === null) return;
        cancelAnimationFrame(this.requestId);
        this.requestId = null;
        this.startBatch();
    }
    failsafeOnError(error, cancelAnimation = true) {
        $d77b025aa58d633c$var$Logger.error("Error during animation, skipping animations", error);
        if (cancelAnimation) this.cancelAnimation();
    }
    startBatch(skipAnimations) {
        this.debug(`AnimationManager - startBatch() with skipAnimations=${skipAnimations}.`);
        this.reset();
        this.batch.stop();
        this.batch.destroy();
        this.batch = new $d77b025aa58d633c$var$AnimationBatch(this.defaultDuration * 1.5);
        if (skipAnimations === true) this.batch.skip();
    }
    endBatch() {
        if (this.batch.isActive()) {
            this.batch.ready();
            this.requestAnimation();
        } else {
            this.interactionManager.popState(1 /* Animation */ );
            if (this.batch.isSkipped()) this.batch.skip(false);
        }
    }
    onBatchStop(cb) {
        this.batch.stoppedCbs.add(cb);
    }
};
// packages/ag-charts-community/src/chart/interaction/ariaAnnouncementServices.ts
var $d77b025aa58d633c$var$AriaAnnouncementService = class _AriaAnnouncementService {
    constructor(canvas){
        this.canvas = canvas;
        this.debug = $d77b025aa58d633c$var$Debug.create(true, "aria");
        this.canvas.appendChild(this.liveElem = _AriaAnnouncementService.createAnnouncer());
    }
    static createAnnouncer() {
        const e = $d77b025aa58d633c$var$getDocument().createElement("div");
        e.classList.add("ag-charts-aria-announcer");
        $d77b025aa58d633c$var$setAttribute(e, "role", "status");
        $d77b025aa58d633c$var$setAttribute(e, "aria-live", "assertive");
        return e;
    }
    destroy() {
        this.canvas.removeChild(this.liveElem);
    }
    announceValue(value) {
        this.debug(`AriaAnnouncementService - announceValue: ${value}`);
        this.liveElem.textContent = value;
    }
};
// packages/ag-charts-community/src/chart/interaction/chartEventManager.ts
var $d77b025aa58d633c$var$ChartEventManager = class extends $d77b025aa58d633c$var$BaseManager {
    legendItemClick(series, itemId, enabled, legendItemName) {
        const event = {
            type: "legend-item-click",
            series: series,
            itemId: itemId,
            enabled: enabled,
            legendItemName: legendItemName
        };
        this.listeners.dispatch("legend-item-click", event);
    }
    legendItemDoubleClick(series, itemId, enabled, numVisibleItems, legendItemName) {
        const event = {
            type: "legend-item-double-click",
            series: series,
            itemId: itemId,
            enabled: enabled,
            legendItemName: legendItemName,
            numVisibleItems: numVisibleItems
        };
        this.listeners.dispatch("legend-item-double-click", event);
    }
    axisHover(axisId, direction) {
        const event = {
            type: "axis-hover",
            axisId: axisId,
            direction: direction
        };
        this.listeners.dispatch("axis-hover", event);
    }
};
// packages/ag-charts-community/src/chart/interaction/contextMenuRegistry.ts
var $d77b025aa58d633c$var$ContextMenuRegistry = class {
    constructor(){
        this.defaultActions = [];
        this.disabledActions = /* @__PURE__ */ new Set();
    }
    copyDefaultActions() {
        return [
            ...this.defaultActions
        ];
    }
    registerDefaultAction(action) {
        if (action.id && this.defaultActions.find(({ id: id })=>id === action.id)) return;
        this.defaultActions.push(action);
    }
    enableAction(actionId) {
        this.disabledActions.delete(actionId);
    }
    disableAction(actionId) {
        this.disabledActions.add(actionId);
    }
    isDisabled(actionId) {
        return this.disabledActions.has(actionId);
    }
};
// packages/ag-charts-community/src/util/stateTracker.ts
var $d77b025aa58d633c$var$StateTracker = class extends Map {
    constructor(defaultValue, defaultState){
        super();
        this.defaultValue = defaultValue;
        this.defaultState = defaultState;
    }
    set(key, value) {
        this.delete(key);
        if (typeof value !== "undefined") super.set(key, value);
        return this;
    }
    stateId() {
        var _a;
        return (_a = Array.from(this.keys()).pop()) != null ? _a : this.defaultState;
    }
    stateValue() {
        var _a;
        return (_a = Array.from(this.values()).pop()) != null ? _a : this.defaultValue;
    }
};
// packages/ag-charts-community/src/chart/interaction/cursorManager.ts
var $d77b025aa58d633c$var$CursorManager = class {
    constructor(element2){
        this.element = element2;
        this.stateTracker = new $d77b025aa58d633c$var$StateTracker("default");
    }
    updateCursor(callerId, style) {
        this.stateTracker.set(callerId, style);
        this.element.style.cursor = this.stateTracker.stateValue();
    }
    getCursor() {
        return this.element.style.cursor;
    }
};
// packages/ag-charts-community/src/chart/interaction/gestureDetector.ts
function $d77b025aa58d633c$var$distanceSquared(finger1, finger2) {
    const dx = finger1.screenX - finger2.screenX;
    const dy = finger1.screenY - finger2.screenY;
    return dx * dx + dy * dy;
}
function $d77b025aa58d633c$var$distance(finger1, finger2) {
    return Math.sqrt($d77b025aa58d633c$var$distanceSquared(finger1, finger2));
}
var $d77b025aa58d633c$var$MIN_DISTANCE_TO_START_PINCH = 1;
var $d77b025aa58d633c$var$GestureDetector = class extends $d77b025aa58d633c$var$BaseManager {
    constructor(element2){
        super();
        this.touchstart = (event)=>this.onTouchStart(event);
        this.touchmove = (event)=>this.onTouchMove(event);
        this.touchend = (event)=>this.onTouchEnd(event);
        this.touchcancel = (event)=>this.onTouchCancel(event);
        this.pinch = {
            finger1: {
                identifier: NaN,
                screenX: NaN,
                screenY: NaN
            },
            finger2: {
                identifier: NaN,
                screenX: NaN,
                screenY: NaN
            },
            origin: {
                x: NaN,
                y: NaN
            },
            distance: NaN,
            status: 0 /* Off */ 
        };
        this.element = element2;
        element2.addEventListener("touchstart", this.touchstart, {
            passive: true
        });
        element2.addEventListener("touchmove", this.touchmove, {
            passive: true
        });
        element2.addEventListener("touchend", this.touchend);
        element2.addEventListener("touchcancel", this.touchcancel);
    }
    destroy() {
        const { element: element2 } = this;
        element2.removeEventListener("touchstart", this.touchstart);
        element2.removeEventListener("touchmove", this.touchmove);
        element2.removeEventListener("touchend", this.touchend);
        element2.removeEventListener("touchcancel", this.touchcancel);
    }
    findPinchTouches(moveEvent) {
        const { touches: touches } = moveEvent;
        const { finger1: finger1, finger2: finger2 } = this.pinch;
        if (this.pinch.status !== 0 /* Off */  && touches.length === 2) {
            if (touches[0].identifier === finger1.identifier && touches[1].identifier === finger2.identifier) return [
                touches[0],
                touches[1]
            ];
            if (touches[0].identifier === finger2.identifier && touches[1].identifier === finger1.identifier) return [
                touches[1],
                touches[0]
            ];
        }
    }
    copyTouchData(event) {
        const keys = [
            "identifier",
            "screenX",
            "screenY"
        ];
        $d77b025aa58d633c$var$partialAssign(keys, this.pinch.finger1, event.touches[0]);
        $d77b025aa58d633c$var$partialAssign(keys, this.pinch.finger2, event.touches[1]);
        this.pinch.distance = $d77b025aa58d633c$var$distance(this.pinch.finger1, this.pinch.finger2);
    }
    dispatchPinchEvent(type, deltaDistance) {
        const { finger1: finger1, finger2: finger2, origin: origin } = this.pinch;
        const newEvent = {
            type: type,
            finger1: finger1,
            finger2: finger2,
            deltaDistance: deltaDistance,
            origin: origin
        };
        this.listeners.dispatch(type, newEvent);
    }
    onTouchStart(event) {
        this.stopPinchTracking();
        const { pinch: pinch } = this;
        if (event.touches.length === 2) {
            pinch.status = 1 /* Initialized */ ;
            this.copyTouchData(event);
            pinch.origin.x = (event.touches[0].clientX + event.touches[1].clientX) / 2;
            pinch.origin.y = (event.touches[0].clientY + event.touches[1].clientY) / 2;
        }
    }
    onTouchMove(event) {
        const pinchTouches = this.findPinchTouches(event);
        if (pinchTouches !== void 0) {
            const [touch1, touch2] = pinchTouches;
            const { pinch: pinch } = this;
            const newDistance = $d77b025aa58d633c$var$distance(touch1, touch2);
            const deltaDistance = newDistance - pinch.distance;
            if (pinch.status === 1 /* Initialized */ ) {
                if (Math.abs(deltaDistance) > $d77b025aa58d633c$var$MIN_DISTANCE_TO_START_PINCH) {
                    pinch.status = 2 /* Running */ ;
                    this.copyTouchData(event);
                    this.dispatchPinchEvent("pinch-start", 0);
                }
            } else if (pinch.status === 2 /* Running */ ) {
                pinch.distance = newDistance;
                this.copyTouchData(event);
                this.dispatchPinchEvent("pinch-move", deltaDistance);
            } else $d77b025aa58d633c$var$Logger.error(`unexpected pinch.status: ${pinch.status}`);
        }
    }
    onTouchEnd(_event) {
        this.stopPinchTracking();
    }
    onTouchCancel(_event) {
        this.stopPinchTracking();
    }
    stopPinchTracking() {
        const { pinch: pinch } = this;
        if (pinch.status === 2 /* Running */ ) this.dispatchPinchEvent("pinch-end", 0);
        this.pinch.status = 0 /* Off */ ;
    }
};
// packages/ag-charts-community/src/chart/interaction/highlightManager.ts
var $d77b025aa58d633c$var$HighlightManager = class extends $d77b025aa58d633c$var$BaseManager {
    constructor(){
        super(...arguments);
        this.highlightStates = new $d77b025aa58d633c$var$StateTracker();
        this.pickedStates = new $d77b025aa58d633c$var$StateTracker();
    }
    updateHighlight(callerId, highlightedDatum) {
        const { activeHighlight: previousHighlight } = this;
        this.highlightStates.set(callerId, highlightedDatum);
        this.activeHighlight = this.highlightStates.stateValue();
        if (!this.isEqual(this.activeHighlight, previousHighlight)) this.listeners.dispatch("highlight-change", {
            type: "highlight-change",
            currentHighlight: this.activeHighlight,
            previousHighlight: previousHighlight
        });
    }
    getActiveHighlight() {
        return this.activeHighlight;
    }
    updatePicked(callerId, clickableDatum) {
        this.pickedStates.set(callerId, clickableDatum);
        this.activePicked = this.pickedStates.stateValue();
    }
    getActivePicked() {
        return this.activePicked;
    }
    isEqual(a, b) {
        return a === b || (a == null ? void 0 : a.series) === (b == null ? void 0 : b.series) && (a == null ? void 0 : a.itemId) === (b == null ? void 0 : b.itemId) && (a == null ? void 0 : a.datum) === (b == null ? void 0 : b.datum);
    }
};
// packages/ag-charts-community/src/chart/interaction/keyNavManager.ts
var $d77b025aa58d633c$var$KeyNavManager = class extends $d77b025aa58d633c$var$BaseManager {
    constructor(interactionManager){
        super();
        this.hasBrowserFocus = false;
        this.isMouseBlurred = false;
        this.isClicking = false;
        this.destroyFns.push(interactionManager.addListener("drag-start", (e)=>this.onClickStart(e), 31 /* All */ ), interactionManager.addListener("click", (e)=>this.onClickStop(e), 31 /* All */ ), interactionManager.addListener("drag-end", (e)=>this.onClickStop(e), 31 /* All */ ), interactionManager.addListener("wheel", (e)=>this.mouseBlur(e)), interactionManager.addListener("hover", (e)=>this.mouseBlur(e)), interactionManager.addListener("drag", (e)=>this.mouseBlur(e)), interactionManager.addListener("blur", (e)=>this.onBlur(e), 31 /* All */ ), interactionManager.addListener("focus", (e)=>this.onFocus(e), 31 /* All */ ), interactionManager.addListener("keydown", (e)=>this.onKeyDown(e), 31 /* All */ ));
    }
    destroy() {
        super.destroy();
    }
    onClickStart(event) {
        this.isClicking = true;
        this.mouseBlur(event);
    }
    onClickStop(event) {
        this.isClicking = false;
        this.mouseBlur(event);
    }
    mouseBlur(event) {
        if (!this.hasBrowserFocus) return;
        if (!this.isMouseBlurred) {
            this.dispatch("blur", 0, event);
            this.isMouseBlurred = true;
        }
    }
    onBlur(event) {
        this.hasBrowserFocus = false;
        this.isMouseBlurred = false;
        this.dispatch("blur", 0, event);
    }
    onFocus(event) {
        this.hasBrowserFocus = true;
        if (this.isClicking) this.isMouseBlurred = true;
        else {
            this.dispatch("browserfocus", 1, event);
            this.dispatch("tab", 0, event);
        }
    }
    onKeyDown(event) {
        if (!this.hasBrowserFocus || this.isClicking) return;
        this.isMouseBlurred = false;
        switch(event.sourceEvent.code){
            case "Tab":
                if (event.sourceEvent.shiftKey) return this.dispatch("tab", -1, event);
                else return this.dispatch("tab", 1, event);
            case "ArrowDown":
                return this.dispatch("nav-vert", 1, event);
            case "ArrowUp":
                return this.dispatch("nav-vert", -1, event);
            case "ArrowLeft":
                return this.dispatch("nav-hori", -1, event);
            case "ArrowRight":
                return this.dispatch("nav-hori", 1, event);
            case "Space":
            case "Enter":
                return this.dispatch("submit", 0, event);
        }
    }
    dispatch(type, delta2, interactionEvent) {
        const event = $d77b025aa58d633c$var$buildConsumable({
            type: type,
            delta: delta2,
            sourceEvent: interactionEvent
        });
        $d77b025aa58d633c$var$dispatchTypedConsumable(this.listeners, type, event);
    }
};
// packages/ag-charts-community/src/chart/interaction/focusStyles.ts
var $d77b025aa58d633c$var$focusStyles_exports = {};
$d77b025aa58d633c$var$__export($d77b025aa58d633c$var$focusStyles_exports, {
    block: ()=>$d77b025aa58d633c$var$block,
    css: ()=>$d77b025aa58d633c$var$css,
    elements: ()=>$d77b025aa58d633c$var$elements,
    modifiers: ()=>$d77b025aa58d633c$var$modifiers
});
var $d77b025aa58d633c$var$block = "ag-charts-focus";
var $d77b025aa58d633c$var$elements = {
    wrapper: `${$d77b025aa58d633c$var$block}__wrapper`,
    indicator: `${$d77b025aa58d633c$var$block}__indicator`
};
var $d77b025aa58d633c$var$modifiers = {
    hidden: `${$d77b025aa58d633c$var$block}--hidden`
};
var $d77b025aa58d633c$var$css = `
.${$d77b025aa58d633c$var$block}.${$d77b025aa58d633c$var$elements.wrapper} {
    position: relative;
    display: block;
    pointer-events: none;
    user-select: none;
    overflow: hidden;
    top: 0;
    left: 0;
}

.${$d77b025aa58d633c$var$block}.${$d77b025aa58d633c$var$elements.indicator} {
    position: absolute;
    display: block;
    pointer-events: none;
    user-select: none;
    border: var(--ag-charts-focus-border);
    box-shadow: var(--ag-charts-focus-border-shadow);
}

.${$d77b025aa58d633c$var$modifiers.hidden} {
    visibility: hidden;
}
`;
// packages/ag-charts-community/src/chart/interaction/regionManager.ts
var $d77b025aa58d633c$var$REGION_TAB_ORDERING = [
    "series",
    "legend"
];
var $d77b025aa58d633c$var$RegionListeners = class extends $d77b025aa58d633c$var$Listeners {
};
var $d77b025aa58d633c$var$RegionManager = class {
    constructor(interactionManager, keyNavManager, canvasElement, element2){
        this.interactionManager = interactionManager;
        this.keyNavManager = keyNavManager;
        this.canvasElement = canvasElement;
        this.currentTabIndex = 0;
        this.isDragging = false;
        this.leftCanvas = false;
        this.regions = /* @__PURE__ */ new Map();
        this.destroyFns = [];
        this.destroyFns.push(...$d77b025aa58d633c$var$POINTER_INTERACTION_TYPES.map((eventName)=>interactionManager.addListener(eventName, this.processPointerEvent.bind(this), 31 /* All */ )), this.keyNavManager.addListener("blur", this.onNav.bind(this)), this.keyNavManager.addListener("browserfocus", this.onFocus.bind(this)), this.keyNavManager.addListener("tab", this.onTab.bind(this)), this.keyNavManager.addListener("nav-vert", this.onNav.bind(this)), this.keyNavManager.addListener("nav-hori", this.onNav.bind(this)), this.keyNavManager.addListener("submit", this.onNav.bind(this)));
        $d77b025aa58d633c$var$injectStyle($d77b025aa58d633c$var$css, $d77b025aa58d633c$var$block);
        this.focusWrapper = $d77b025aa58d633c$var$getDocument().createElement("div");
        this.focusIndicator = $d77b025aa58d633c$var$getDocument().createElement("div");
        this.focusWrapper.appendChild(this.focusIndicator);
        element2.appendChild(this.focusWrapper);
        const { block: block3, elements: elements3, modifiers: modifiers3 } = $d77b025aa58d633c$var$focusStyles_exports;
        this.focusWrapper.classList.add(block3, elements3.wrapper);
        this.focusIndicator.classList.add(block3, elements3.indicator, modifiers3.hidden);
    }
    destroy() {
        this.destroyFns.forEach((fn)=>fn());
        this.currentRegion = void 0;
        for (const region of this.regions.values())region.listeners.destroy();
        this.focusWrapper.remove();
        this.regions.clear();
    }
    addRegionFromProperties(properties) {
        const region = {
            properties: properties,
            listeners: new $d77b025aa58d633c$var$RegionListeners()
        };
        this.regions.set(properties.name, region);
        return this.makeObserver(region);
    }
    addRegion(name, bboxprovider, ...extraProviders) {
        return this.addRegionFromProperties({
            name: name,
            bboxproviders: [
                bboxprovider,
                ...extraProviders
            ],
            canInteraction: ()=>true
        });
    }
    getRegion(name) {
        return this.makeObserver(this.regions.get(name));
    }
    find(x, y) {
        const matches = [];
        for (const [_name, region] of this.regions.entries())for (const provider of region.properties.bboxproviders){
            const bbox = provider.getCachedBBox();
            if (bbox.containsPoint(x, y)) matches.push([
                region,
                bbox.width * bbox.height
            ]);
        }
        return matches.sort((a, b)=>a[1] - b[1]).map((m)=>m[0]);
    }
    // This method return a wrapper object that matches the interface of InteractionManager.addListener.
    // The intent is to allow the InteractionManager and RegionManager to be used almost interchangeably.
    makeObserver(region) {
        const { interactionManager: interactionManager } = this;
        class ObservableRegionImplementation {
            addListener(type, handler, triggeringStates = 16 /* Default */ ) {
                var _a;
                return (_a = region == null ? void 0 : region.listeners.addListener(type, (e)=>{
                    if (!e.consumed) {
                        const currentState = interactionManager.getState();
                        if (currentState & triggeringStates) handler(e);
                    }
                })) != null ? _a : ()=>{};
            }
        }
        return new ObservableRegionImplementation();
    }
    checkPointerHistory(targetRegion, event) {
        for (const historyEvent of event.pointerHistory){
            const historyRegion = this.pickRegion(historyEvent.offsetX, historyEvent.offsetY);
            if (targetRegion.properties.name !== (historyRegion == null ? void 0 : historyRegion.properties.name)) return false;
        }
        return true;
    }
    dispatch(region, event) {
        region == null || region.listeners.dispatch(event.type, event);
    }
    // Process events during a drag action. Returns false if this event should follow the standard
    // RegionManager.processEvent flow, or true if this event already processed by this function.
    handleDragging(event) {
        const { currentRegion: currentRegion } = this;
        switch(event.type){
            case "drag-start":
                this.isDragging = true;
                this.leftCanvas = false;
                break;
            case "leave":
                this.leftCanvas = true;
                return this.isDragging;
            case "enter":
                this.leftCanvas = false;
                return this.isDragging;
            case "drag":
                if (this.isDragging) {
                    this.dispatch(currentRegion, event);
                    return true;
                }
                break;
            case "drag-end":
                if (this.isDragging) {
                    this.isDragging = false;
                    this.dispatch(currentRegion, event);
                    if (this.leftCanvas) this.dispatch(currentRegion, $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, event), {
                        type: "leave"
                    }));
                    return true;
                }
                break;
        }
        return false;
    }
    processPointerEvent(event) {
        if (this.handleDragging(event)) return;
        const { currentRegion: currentRegion } = this;
        const newRegion = this.pickRegion(event.offsetX, event.offsetY);
        if (currentRegion !== void 0 && (newRegion == null ? void 0 : newRegion.properties.name) !== currentRegion.properties.name) this.dispatch(currentRegion, $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, event), {
            type: "leave"
        }));
        if (newRegion !== void 0 && newRegion.properties.name !== (currentRegion == null ? void 0 : currentRegion.properties.name)) this.dispatch(newRegion, $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, event), {
            type: "enter"
        }));
        if (newRegion !== void 0 && this.checkPointerHistory(newRegion, event)) this.dispatch(newRegion, event);
        this.currentRegion = newRegion;
    }
    pickRegion(x, y) {
        const matchingRegions = this.find(x, y);
        return matchingRegions.length > 0 ? matchingRegions[0] : void 0;
    }
    getTabRegion(tabIndex) {
        if (tabIndex !== void 0 && tabIndex >= 0 && tabIndex < $d77b025aa58d633c$var$REGION_TAB_ORDERING.length) return this.regions.get($d77b025aa58d633c$var$REGION_TAB_ORDERING[tabIndex]);
        return void 0;
    }
    dispatchTabStart(event) {
        const { delta: delta2, sourceEvent: sourceEvent } = event;
        const startEvent = $d77b025aa58d633c$var$buildConsumable({
            type: "tab-start",
            delta: delta2,
            sourceEvent: sourceEvent
        });
        const focusedRegion = this.getTabRegion(this.currentTabIndex);
        this.dispatch(focusedRegion, startEvent);
        return !!startEvent.consumed;
    }
    getNextInteractableTabIndex(currentIndex, delta2) {
        const direction = delta2 < 0 ? -1 : 1;
        let i = currentIndex;
        while(delta2 !== 0){
            const region = this.getTabRegion(i + direction);
            if (region === void 0) return void 0;
            else if (region.properties.canInteraction()) delta2 = delta2 - direction;
            i = i + direction;
        }
        return i;
    }
    validateCurrentTabIndex() {
        var _a;
        const focusedRegion = this.getTabRegion(this.currentTabIndex);
        if (focusedRegion !== void 0 && !focusedRegion.properties.canInteraction()) this.currentTabIndex = (_a = this.getNextInteractableTabIndex(-1, 1)) != null ? _a : 0;
    }
    onFocus(event) {
        const { delta: delta2, sourceEvent: sourceEvent } = event;
        const newIndex = delta2 > 0 ? this.getNextInteractableTabIndex(-1, 1) : this.getNextInteractableTabIndex($d77b025aa58d633c$var$REGION_TAB_ORDERING.length, -1);
        this.currentTabIndex = newIndex != null ? newIndex : 0;
        const focusedRegion = this.getTabRegion(this.currentTabIndex);
        if (focusedRegion) this.dispatch(focusedRegion, $d77b025aa58d633c$var$buildConsumable({
            type: "tab",
            delta: delta2,
            sourceEvent: sourceEvent
        }));
    }
    onTab(event) {
        const consumed = this.dispatchTabStart(event);
        if (consumed) return;
        this.validateCurrentTabIndex();
        const newTabIndex = this.getNextInteractableTabIndex(this.currentTabIndex, event.delta);
        const newRegion = this.getTabRegion(newTabIndex);
        const focusedRegion = this.getTabRegion(this.currentTabIndex);
        if (newTabIndex !== void 0) this.currentTabIndex = newTabIndex;
        if (focusedRegion !== void 0 && (newRegion == null ? void 0 : newRegion.properties.name) !== focusedRegion.properties.name) {
            const { delta: delta2, sourceEvent: sourceEvent } = event;
            const blurEvent = $d77b025aa58d633c$var$buildConsumable({
                type: "blur",
                delta: delta2,
                sourceEvent: sourceEvent
            });
            this.dispatch(focusedRegion, blurEvent);
        }
        if (newRegion === void 0 || !newRegion.properties.canInteraction()) this.updateFocusIndicatorRect(void 0);
        else this.dispatch(newRegion, event);
    }
    onNav(event) {
        const focusedRegion = this.getTabRegion(this.currentTabIndex);
        this.dispatch(focusedRegion, event);
    }
    updateFocusWrapperRect() {
        this.focusWrapper.style.width = this.canvasElement.style.width;
        this.focusWrapper.style.height = this.canvasElement.style.height;
    }
    updateFocusIndicatorRect(rect) {
        if (rect == null) {
            this.focusIndicator.classList.add($d77b025aa58d633c$var$modifiers.hidden);
            return;
        }
        this.updateFocusWrapperRect();
        this.focusIndicator.classList.remove($d77b025aa58d633c$var$modifiers.hidden);
        this.focusIndicator.style.width = `${rect.width}px`;
        this.focusIndicator.style.height = `${rect.height}px`;
        this.focusIndicator.style.left = `${rect.x}px`;
        this.focusIndicator.style.top = `${rect.y}px`;
    }
};
// packages/ag-charts-community/src/chart/interaction/toolbarManager.ts
var $d77b025aa58d633c$var$ToolbarManager = class extends $d77b025aa58d633c$var$BaseManager {
    constructor(element2){
        super();
        this.element = element2;
    }
    static isGroup(group2, event) {
        return event.group === group2;
    }
    pressButton(group2, value) {
        this.listeners.dispatch("button-pressed", {
            type: "button-pressed",
            group: group2,
            value: value
        });
    }
    toggleGroup(group2, visible) {
        this.listeners.dispatch("group-toggled", {
            type: "group-toggled",
            group: group2,
            visible: visible
        });
    }
    toggleButton(group2, value, enabled) {
        this.listeners.dispatch("button-toggled", {
            type: "button-toggled",
            group: group2,
            value: value,
            enabled: enabled
        });
    }
    proxyGroupOptions(group2, options) {
        this.listeners.dispatch("proxy-group-options", {
            type: "proxy-group-options",
            group: group2,
            options: options
        });
    }
};
// packages/ag-charts-community/src/chart/interaction/tooltipManager.ts
var $d77b025aa58d633c$var$defaultTooltipCss = `
.${$d77b025aa58d633c$var$DEFAULT_TOOLTIP_CLASS} {
    transition: transform 0.1s ease;
    max-width: 100%;
    position: fixed;
    left: 0px;
    top: 0px;
    z-index: 99999;
    font: 12px Verdana, sans-serif;
    color: rgb(70, 70, 70);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);
}

.${$d77b025aa58d633c$var$DEFAULT_TOOLTIP_CLASS}-wrap-always {
    overflow-wrap: break-word;
    word-break: break-word;
    hyphens: none;
}

.${$d77b025aa58d633c$var$DEFAULT_TOOLTIP_CLASS}-wrap-hyphenate {
    overflow-wrap: break-word;
    word-break: break-word;
    hyphens: auto;
}

.${$d77b025aa58d633c$var$DEFAULT_TOOLTIP_CLASS}-wrap-on-space {
    overflow-wrap: normal;
    word-break: normal;
}

.${$d77b025aa58d633c$var$DEFAULT_TOOLTIP_CLASS}-wrap-never {
    white-space: pre;
    text-overflow: ellipsis;
}

.${$d77b025aa58d633c$var$DEFAULT_TOOLTIP_CLASS}-no-interaction {
    pointer-events: none;
    user-select: none;
}

.${$d77b025aa58d633c$var$DEFAULT_TOOLTIP_CLASS}-no-animation {
    transition: none !important;
}

.${$d77b025aa58d633c$var$DEFAULT_TOOLTIP_CLASS}-hidden {
    visibility: hidden;
}

.${$d77b025aa58d633c$var$DEFAULT_TOOLTIP_CLASS}-title {
    overflow: hidden;
    position: relative;
    padding: 8px 14px;
    border-top-left-radius: 2px;
    border-top-right-radius: 2px;
    color: white;
    background-color: #888888;
    z-index: 1;
    text-overflow: inherit;
}

.${$d77b025aa58d633c$var$DEFAULT_TOOLTIP_CLASS}-title:only-child {
    border-bottom-left-radius: 2px;
    border-bottom-right-radius: 2px;
}

.${$d77b025aa58d633c$var$DEFAULT_TOOLTIP_CLASS}-content {
    overflow: hidden;
    padding: 6px 14px;
    line-height: 1.7em;
    background: white;
    border-bottom-left-radius: 2px;
    border-bottom-right-radius: 2px;
    border: 1px solid rgba(0, 0, 0, 0.15);
    overflow: hidden;
    text-overflow: inherit;
}

.${$d77b025aa58d633c$var$DEFAULT_TOOLTIP_CLASS}-arrow::before {
    content: "";

    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);

    border: 5px solid #d9d9d9;

    border-left-color: transparent;
    border-right-color: transparent;
    border-bottom-color: transparent;

    width: 0;
    height: 0;

    margin: 0 auto;
}

.${$d77b025aa58d633c$var$DEFAULT_TOOLTIP_CLASS}-arrow::after {
    content: "";

    position: absolute;
    top: calc(100% - 1px);
    left: 50%;
    transform: translateX(-50%);

    border: 5px solid white;

    border-left-color: transparent;
    border-right-color: transparent;
    border-bottom-color: transparent;

    width: 0;
    height: 0;

    margin: 0 auto;
}

.ag-chart-wrapper {
    box-sizing: border-box;
    overflow: hidden;
}
`;
var $d77b025aa58d633c$var$TooltipManager = class {
    constructor(canvasElement, tooltip){
        this.canvasElement = canvasElement;
        this.tooltip = tooltip;
        this.stateTracker = new $d77b025aa58d633c$var$StateTracker();
        this.appliedState = null;
        if (typeof IntersectionObserver !== "undefined") {
            const observer = new IntersectionObserver((entries)=>{
                for (const entry of entries)if (entry.target === this.canvasElement && entry.intersectionRatio === 0) this.tooltip.toggle(false);
            }, {
                root: this.tooltip.root
            });
            observer.observe(this.canvasElement);
            this.observer = observer;
        }
        $d77b025aa58d633c$var$injectStyle($d77b025aa58d633c$var$defaultTooltipCss, "tooltip");
    }
    updateTooltip(callerId, meta, content) {
        var _a;
        if (!this.tooltip.enabled) return;
        content != null ? content : content = (_a = this.stateTracker.get(callerId)) == null ? void 0 : _a.content;
        this.stateTracker.set(callerId, {
            content: content,
            meta: meta
        });
        this.applyStates();
    }
    removeTooltip(callerId) {
        if (!this.tooltip.enabled) return;
        this.stateTracker.delete(callerId);
        this.applyStates();
    }
    getTooltipMeta(callerId) {
        var _a;
        return (_a = this.stateTracker.get(callerId)) == null ? void 0 : _a.meta;
    }
    destroy() {
        var _a;
        (_a = this.observer) == null || _a.unobserve(this.canvasElement);
    }
    applyStates() {
        var _a;
        const id = this.stateTracker.stateId();
        const state = id ? this.stateTracker.get(id) : null;
        if ((state == null ? void 0 : state.meta) == null || (state == null ? void 0 : state.content) == null) {
            this.appliedState = null;
            this.tooltip.toggle(false);
            return;
        }
        const canvasRect = this.canvasElement.getBoundingClientRect();
        if (((_a = this.appliedState) == null ? void 0 : _a.content) === (state == null ? void 0 : state.content)) {
            const renderInstantly = this.tooltip.isVisible();
            this.tooltip.show(canvasRect, state == null ? void 0 : state.meta, null, renderInstantly);
        } else this.tooltip.show(canvasRect, state == null ? void 0 : state.meta, state == null ? void 0 : state.content);
        this.appliedState = state;
    }
    static makeTooltipMeta(event, datum) {
        var _a, _b, _c, _d, _e, _f, _g;
        const { offsetX: offsetX, offsetY: offsetY } = event;
        const { tooltip: tooltip } = datum.series.properties;
        const meta = {
            offsetX: offsetX,
            offsetY: offsetY,
            enableInteraction: (_b = (_a = tooltip.interaction) == null ? void 0 : _a.enabled) != null ? _b : false,
            lastPointerEvent: {
                type: event.type,
                offsetX: offsetX,
                offsetY: offsetY
            },
            showArrow: tooltip.showArrow,
            position: {
                type: tooltip.position.type,
                xOffset: tooltip.position.xOffset,
                yOffset: tooltip.position.yOffset
            }
        };
        const refPoint = (_g = (_d = (_c = datum.yBar) == null ? void 0 : _c.upperPoint) != null ? _d : datum.midPoint) != null ? _g : (_f = (_e = datum.series).datumMidPoint) == null ? void 0 : _f.call(_e, datum);
        if (tooltip.position.type === "node" && refPoint) {
            const { x: x, y: y } = refPoint;
            const point = datum.series.contentGroup.inverseTransformPoint(x, y);
            return $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, meta), {
                offsetX: Math.round(point.x),
                offsetY: Math.round(point.y)
            });
        }
        return meta;
    }
};
// packages/ag-charts-community/src/chart/layout/layoutService.ts
var $d77b025aa58d633c$var$LayoutService = class extends $d77b025aa58d633c$var$Listeners {
    constructor(){
        super(...arguments);
        this.layoutComplete = "layout-complete";
    }
    addListener(eventType, handler) {
        if (this.isLayoutStage(eventType) || this.isLayoutComplete(eventType)) return super.addListener(eventType, handler);
        throw new Error(`AG Charts - unsupported listener type: ${eventType}`);
    }
    dispatchPerformLayout(stage, ctx) {
        if (this.isLayoutStage(stage)) return this.getListenersByType(stage).reduce((result, listener)=>{
            try {
                return listener.handler(result);
            } catch (e) {
                $d77b025aa58d633c$var$Logger.errorOnce(e);
                return result;
            }
        }, ctx);
        return ctx;
    }
    dispatchLayoutComplete(event) {
        this.dispatch(this.layoutComplete, event);
    }
    isLayoutStage(eventType) {
        return eventType !== this.layoutComplete;
    }
    isLayoutComplete(eventType) {
        return eventType === this.layoutComplete;
    }
};
// packages/ag-charts-community/src/chart/series/seriesStateManager.ts
var $d77b025aa58d633c$var$SeriesStateManager = class {
    constructor(){
        this.groups = {};
    }
    registerSeries({ id: id, seriesGrouping: seriesGrouping, visible: visible, type: type }) {
        var _a, _b;
        if (!seriesGrouping) return;
        (_b = (_a = this.groups)[type]) != null ? _b : _a[type] = {};
        this.groups[type][id] = {
            grouping: seriesGrouping,
            visible: visible
        };
    }
    deregisterSeries({ id: id, type: type }) {
        if (this.groups[type]) delete this.groups[type][id];
        if (this.groups[type] && Object.keys(this.groups[type]).length === 0) delete this.groups[type];
    }
    getVisiblePeerGroupIndex({ type: type, seriesGrouping: seriesGrouping, visible: visible }) {
        var _a;
        if (!seriesGrouping) return {
            visibleGroupCount: visible ? 1 : 0,
            visibleSameStackCount: visible ? 1 : 0,
            index: 0
        };
        const visibleGroupsSet = /* @__PURE__ */ new Set();
        const visibleSameStackSet = /* @__PURE__ */ new Set();
        for (const entry of Object.values((_a = this.groups[type]) != null ? _a : {})){
            if (!entry.visible) continue;
            visibleGroupsSet.add(entry.grouping.groupIndex);
            if (entry.grouping.groupIndex === seriesGrouping.groupIndex) visibleSameStackSet.add(entry.grouping.stackIndex);
        }
        const visibleGroups = Array.from(visibleGroupsSet);
        visibleGroups.sort((a, b)=>a - b);
        return {
            visibleGroupCount: visibleGroups.length,
            visibleSameStackCount: visibleSameStackSet.size,
            index: visibleGroups.indexOf(seriesGrouping.groupIndex)
        };
    }
};
// packages/ag-charts-community/src/chart/chartUpdateType.ts
var $d77b025aa58d633c$var$ChartUpdateType = /* @__PURE__ */ ((ChartUpdateType2)=>{
    ChartUpdateType2[ChartUpdateType2["FULL"] = 0] = "FULL";
    ChartUpdateType2[ChartUpdateType2["UPDATE_DATA"] = 1] = "UPDATE_DATA";
    ChartUpdateType2[ChartUpdateType2["PROCESS_DATA"] = 2] = "PROCESS_DATA";
    ChartUpdateType2[ChartUpdateType2["PERFORM_LAYOUT"] = 3] = "PERFORM_LAYOUT";
    ChartUpdateType2[ChartUpdateType2["SERIES_UPDATE"] = 4] = "SERIES_UPDATE";
    ChartUpdateType2[ChartUpdateType2["TOOLTIP_RECALCULATION"] = 5] = "TOOLTIP_RECALCULATION";
    ChartUpdateType2[ChartUpdateType2["SCENE_RENDER"] = 6] = "SCENE_RENDER";
    ChartUpdateType2[ChartUpdateType2["NONE"] = 7] = "NONE";
    return ChartUpdateType2;
})($d77b025aa58d633c$var$ChartUpdateType || {});
// packages/ag-charts-community/src/chart/updateService.ts
var $d77b025aa58d633c$var$UpdateService = class extends $d77b025aa58d633c$var$Listeners {
    constructor(updateCallback){
        super();
        this.updateCallback = updateCallback;
    }
    update(type = 0 /* FULL */ , options) {
        this.updateCallback(type, options);
    }
    dispatchUpdateComplete(rects) {
        this.dispatch("update-complete", {
            type: "update-complete",
            minRect: rects == null ? void 0 : rects.minRect,
            minVisibleRect: rects == null ? void 0 : rects.minVisibleRect
        });
    }
};
// packages/ag-charts-community/src/chart/chartContext.ts
var $d77b025aa58d633c$var$ChartContext = class {
    constructor(chart, vars){
        const { scene: scene, syncManager: syncManager, element: element2, updateCallback: updateCallback, updateMutex: updateMutex } = vars;
        this.chartService = chart;
        this.scene = scene;
        this.syncManager = syncManager;
        this.zoomManager = chart.zoomManager;
        this.annotationManager = new $d77b025aa58d633c$var$AnnotationManager(chart.annotationRoot);
        this.ariaAnnouncementService = new $d77b025aa58d633c$var$AriaAnnouncementService(scene.canvas.element);
        this.chartEventManager = new $d77b025aa58d633c$var$ChartEventManager();
        this.contextMenuRegistry = new $d77b025aa58d633c$var$ContextMenuRegistry();
        this.cursorManager = new $d77b025aa58d633c$var$CursorManager(element2);
        this.highlightManager = new $d77b025aa58d633c$var$HighlightManager();
        this.interactionManager = new $d77b025aa58d633c$var$InteractionManager(chart.keyboard, element2);
        this.keyNavManager = new $d77b025aa58d633c$var$KeyNavManager(this.interactionManager);
        this.regionManager = new $d77b025aa58d633c$var$RegionManager(this.interactionManager, this.keyNavManager, this.scene.canvas.element, element2);
        this.toolbarManager = new $d77b025aa58d633c$var$ToolbarManager(element2);
        this.gestureDetector = new $d77b025aa58d633c$var$GestureDetector(element2);
        this.layoutService = new $d77b025aa58d633c$var$LayoutService();
        this.updateService = new $d77b025aa58d633c$var$UpdateService(updateCallback);
        this.seriesStateManager = new $d77b025aa58d633c$var$SeriesStateManager();
        this.callbackCache = new $d77b025aa58d633c$var$CallbackCache();
        this.animationManager = new $d77b025aa58d633c$var$AnimationManager(this.interactionManager, updateMutex);
        this.animationManager.skip();
        this.animationManager.play();
        this.dataService = new $d77b025aa58d633c$var$DataService(this.animationManager);
        this.tooltipManager = new $d77b025aa58d633c$var$TooltipManager(this.scene.canvas.element, chart.tooltip);
    }
    destroy() {
        this.tooltipManager.destroy();
        this.regionManager.destroy();
        this.keyNavManager.destroy();
        this.interactionManager.destroy();
        this.animationManager.stop();
        this.animationManager.destroy();
        this.ariaAnnouncementService.destroy();
        this.chartEventManager.destroy();
        this.highlightManager.destroy();
        this.callbackCache.invalidateCache();
        this.animationManager.reset();
        this.syncManager.destroy();
    }
};
// packages/ag-charts-community/src/chart/chartHighlight.ts
var $d77b025aa58d633c$var$ChartHighlight = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.range = "tooltip";
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$UNION([
        "tooltip",
        "node"
    ], "a range"))
], $d77b025aa58d633c$var$ChartHighlight.prototype, "range", 2);
// packages/ag-charts-community/src/chart/data/dataDomain.ts
var $d77b025aa58d633c$var$DiscreteDomain = class _DiscreteDomain {
    constructor(){
        this.domain = /* @__PURE__ */ new Set();
    }
    static is(value) {
        return value instanceof _DiscreteDomain;
    }
    extend(val) {
        this.domain.add(val);
    }
    getDomain() {
        return Array.from(this.domain);
    }
};
var $d77b025aa58d633c$var$ContinuousDomain = class _ContinuousDomain {
    constructor(){
        this.domain = [
            Infinity,
            -Infinity
        ];
    }
    static is(value) {
        return value instanceof _ContinuousDomain;
    }
    static extendDomain(values, domain = [
        Infinity,
        -Infinity
    ]) {
        for (const value of values){
            if (typeof value !== "number") continue;
            if (domain[0] > value) domain[0] = value;
            if (domain[1] < value) domain[1] = value;
        }
        return domain;
    }
    extend(value) {
        if (this.domain[0] > value) this.domain[0] = value;
        if (this.domain[1] < value) this.domain[1] = value;
    }
    getDomain() {
        return [
            ...this.domain
        ];
    }
};
// packages/ag-charts-community/src/chart/data/dataModel.ts
function $d77b025aa58d633c$var$toKeyString(keys) {
    return keys.map((key)=>$d77b025aa58d633c$var$isObject(key) ? JSON.stringify(key) : key).join("-");
}
function $d77b025aa58d633c$var$round2(val) {
    const accuracy = 1e4;
    if (Number.isInteger(val)) return val;
    else if (Math.abs(val) > accuracy) return Math.trunc(val);
    return Math.round(val * accuracy) / accuracy;
}
function $d77b025aa58d633c$var$fixNumericExtentInternal(extent2) {
    if (extent2 == null) return [];
    let [min, max] = extent2.map(Number);
    if (min === 0 && max === 0) return [
        0,
        1
    ];
    if (min === Infinity && max === -Infinity) return [];
    else if (min === Infinity) min = 0;
    else if (max === -Infinity) max = 0;
    return $d77b025aa58d633c$var$isFiniteNumber(min) && $d77b025aa58d633c$var$isFiniteNumber(max) ? [
        min,
        max
    ] : [];
}
function $d77b025aa58d633c$var$fixNumericExtent(extent2, axis) {
    var _a;
    const fixedExtent = $d77b025aa58d633c$var$fixNumericExtentInternal(extent2);
    if (fixedExtent.length === 0) return fixedExtent;
    let [min, max] = fixedExtent;
    if (min === max) {
        const [paddingMin, paddingMax] = (_a = axis == null ? void 0 : axis.calculatePadding(min, max)) != null ? _a : [
            1,
            1
        ];
        min -= paddingMin;
        max += paddingMax;
    }
    return [
        min,
        max
    ];
}
function $d77b025aa58d633c$var$getMissCount(scopeProvider, missMap) {
    var _a;
    return (_a = missMap == null ? void 0 : missMap.get(scopeProvider.id)) != null ? _a : 0;
}
var $d77b025aa58d633c$var$INVALID_VALUE = Symbol("invalid");
var $d77b025aa58d633c$var$DataModel = class {
    constructor(opts, mode = "standalone"){
        this.opts = opts;
        this.mode = mode;
        this.debug = $d77b025aa58d633c$var$Debug.create(true, "data-model");
        this.scopeCache = /* @__PURE__ */ new Map();
        this.keys = [];
        this.values = [];
        this.aggregates = [];
        this.groupProcessors = [];
        this.propertyProcessors = [];
        this.reducers = [];
        this.processors = [];
        let keys = true;
        for (const next of opts.props){
            if (next.type === "key" && !keys) throw new Error("AG Charts - internal config error: keys must come before values.");
            if (next.type === "value" && keys) keys = false;
        }
        const verifyMatchGroupId = ({ matchGroupIds: matchGroupIds = [] })=>{
            for (const matchGroupId of matchGroupIds){
                if (this.values.every((def)=>def.groupId !== matchGroupId)) throw new Error(`AG Charts - internal config error: matchGroupIds properties must match defined groups (${matchGroupId}).`);
            }
        };
        for (const def of opts.props)switch(def.type){
            case "key":
                this.keys.push($d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, def), {
                    index: this.keys.length,
                    missing: /* @__PURE__ */ new Map()
                }));
                break;
            case "value":
                if (def.property == null) throw new Error(`AG Charts - internal config error: no properties specified for value definitions: ${JSON.stringify(def)}`);
                this.values.push($d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, def), {
                    index: this.values.length,
                    missing: /* @__PURE__ */ new Map()
                }));
                break;
            case "aggregate":
                verifyMatchGroupId(def);
                this.aggregates.push($d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, def), {
                    index: this.aggregates.length
                }));
                break;
            case "group-value-processor":
                verifyMatchGroupId(def);
                this.groupProcessors.push($d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, def), {
                    index: this.groupProcessors.length
                }));
                break;
            case "property-value-processor":
                this.propertyProcessors.push($d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, def), {
                    index: this.propertyProcessors.length
                }));
                break;
            case "reducer":
                this.reducers.push($d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, def), {
                    index: this.reducers.length
                }));
                break;
            case "processor":
                this.processors.push($d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, def), {
                    index: this.processors.length
                }));
                break;
        }
    }
    resolveProcessedDataDefById(scope, searchId) {
        var _a;
        const def = (_a = this.scopeCache.get(scope.id)) == null ? void 0 : _a.get(searchId);
        if (!def) throw new Error(`AG Charts - didn't find property definition for [${searchId}, ${scope.id}]`);
        return {
            index: def.index,
            def: def
        };
    }
    resolveProcessedDataIndexById(scope, searchId) {
        return this.resolveProcessedDataDefById(scope, searchId).index;
    }
    resolveProcessedDataDefsByIds(scope, searchIds) {
        return searchIds.map((searchId)=>[
                searchId,
                this.resolveProcessedDataDefById(scope, searchId)
            ]);
    }
    resolveProcessedDataDefsValues(defs, { keys: keys, values: values }) {
        const result = {};
        for (const [searchId, { index: index, def: def }] of defs){
            const processedData = def.type === "key" ? keys : values;
            result[searchId] = processedData[index];
        }
        return result;
    }
    getDomain(scope, searchId, type = "value", processedData) {
        var _a;
        const domains = this.getDomainsByType(type, processedData);
        return (_a = domains == null ? void 0 : domains[this.resolveProcessedDataIndexById(scope, searchId)]) != null ? _a : [];
    }
    getDomainsByType(type, processedData) {
        switch(type){
            case "key":
                return processedData.domain.keys;
            case "value":
                return processedData.domain.values;
            case "aggregate":
                return processedData.domain.aggValues;
            case "group-value-processor":
                return processedData.domain.groups;
            default:
                return null;
        }
    }
    processData(data, sources) {
        var _a;
        const { opts: { groupByKeys: groupByKeys, groupByFn: groupByFn }, aggregates: aggregates, groupProcessors: groupProcessors, reducers: reducers, processors: processors, propertyProcessors: propertyProcessors } = this;
        const start = performance.now();
        if (groupByKeys && this.keys.length === 0) return;
        let processedData = this.extractData(data, sources);
        if (groupByKeys) processedData = this.groupData(processedData);
        else if (groupByFn) processedData = this.groupData(processedData, groupByFn(processedData));
        if (groupProcessors.length > 0) this.postProcessGroups(processedData);
        if (aggregates.length > 0) this.aggregateData(processedData);
        if (propertyProcessors.length > 0) this.postProcessProperties(processedData);
        if (reducers.length > 0) this.reduceData(processedData);
        if (processors.length > 0) this.postProcessData(processedData);
        if (data.length > 0) for (const def of $d77b025aa58d633c$var$iterate(this.keys, this.values)){
            for (const [scope, missCount] of def.missing)if (missCount >= data.length) {
                const scopeHint = scope == null ? "" : ` for ${scope}`;
                $d77b025aa58d633c$var$Logger.warnOnce(`the key '${def.property}' was not found in any data element${scopeHint}.`);
            }
        }
        const end = performance.now();
        processedData.time = end - start;
        if (this.debug.check()) $d77b025aa58d633c$var$logProcessedData(processedData);
        this.scopeCache.clear();
        for (const def of $d77b025aa58d633c$var$iterate(this.keys, this.values, this.aggregates)){
            if (!def.idsMap) continue;
            for (const [scope, ids] of def.idsMap)for (const id of ids){
                if (!this.scopeCache.has(scope)) this.scopeCache.set(scope, /* @__PURE__ */ new Map([
                    [
                        id,
                        def
                    ]
                ]));
                else if ((_a = this.scopeCache.get(scope)) == null ? void 0 : _a.has(id)) throw new Error("duplicate definition ids on the same scope are not allowed.");
                else this.scopeCache.get(scope).set(id, def);
            }
        }
        return processedData;
    }
    valueGroupIdxLookup({ matchGroupIds: matchGroupIds }) {
        const result = [];
        for (const [index, def] of this.values.entries())if (!matchGroupIds || def.groupId && matchGroupIds.includes(def.groupId)) result.push(index);
        return result;
    }
    valueIdxLookup(scopes, prop) {
        const noScopesToMatch = scopes == null || scopes.length === 0;
        const propId = typeof prop === "string" ? prop : prop.id;
        const hasMatchingScopeId = (def)=>{
            if (def.idsMap) for (const [scope, ids] of def.idsMap){
                if ((scopes == null ? void 0 : scopes.includes(scope)) && ids.has(propId)) return true;
            }
            return false;
        };
        const result = this.values.findIndex((def)=>{
            const validDefScopes = def.scopes == null || noScopesToMatch && !def.scopes.length || def.scopes.some((s)=>scopes == null ? void 0 : scopes.includes(s));
            return validDefScopes && (def.property === propId || def.id === propId || hasMatchingScopeId(def));
        });
        if (result === -1) throw new Error(`AG Charts - configuration error, unknown property ${JSON.stringify(prop)} in scope(s) ${JSON.stringify(scopes)}`);
        return result;
    }
    extractData(data, sources) {
        var _a, _b, _c, _d;
        const { dataDomain: dataDomain, processValue: processValue, scopes: scopes, allScopesHaveSameDefs: allScopesHaveSameDefs } = this.initDataDomainProcessor();
        const sourcesById = new Map(sources == null ? void 0 : sources.map((s)=>[
                s.id,
                s
            ]));
        const { keys: keyDefs, values: valueDefs } = this;
        const resultData = new Array(data.length);
        let resultDataIdx = 0;
        let partialValidDataCount = 0;
        for (const [datumIdx, datum] of data.entries()){
            const sourceDatums = {};
            const validScopes = scopes.size > 0 ? new Set(scopes) : void 0;
            const keys = new Array(keyDefs.length);
            let keyIdx = 0;
            let key;
            for (const def of keyDefs){
                key = processValue(def, datum, key);
                if (key === $d77b025aa58d633c$var$INVALID_VALUE) break;
                if (keys) keys[keyIdx++] = key;
            }
            if (key === $d77b025aa58d633c$var$INVALID_VALUE) continue;
            const values = valueDefs.length > 0 ? new Array(valueDefs.length) : void 0;
            let value;
            for (const [valueDefIdx, def] of valueDefs.entries()){
                for (const scope of (_a = def.scopes) != null ? _a : scopes){
                    const source = sourcesById.get(scope);
                    const valueDatum = (_b = source == null ? void 0 : source.data[datumIdx]) != null ? _b : datum;
                    value = processValue(def, valueDatum, value, scope);
                    if (value === $d77b025aa58d633c$var$INVALID_VALUE || !values) continue;
                    if (source != null && def.includeProperty !== false) {
                        const property = def.includeProperty && def.id != null ? def.id : def.property;
                        (_c = sourceDatums[scope]) != null ? _c : sourceDatums[scope] = {};
                        sourceDatums[scope][property] = value;
                    }
                    values[valueDefIdx] = value;
                }
                if (value === $d77b025aa58d633c$var$INVALID_VALUE) {
                    if (allScopesHaveSameDefs) break;
                    for (const scope of (_d = def.scopes) != null ? _d : scopes)validScopes == null || validScopes.delete(scope);
                    if ((validScopes == null ? void 0 : validScopes.size) === 0) break;
                }
            }
            if (value === $d77b025aa58d633c$var$INVALID_VALUE && allScopesHaveSameDefs) continue;
            if ((validScopes == null ? void 0 : validScopes.size) === 0) continue;
            const result = {
                datum: $d77b025aa58d633c$var$__spreadValues($d77b025aa58d633c$var$__spreadValues({}, datum), sourceDatums),
                keys: keys,
                values: values
            };
            if (!allScopesHaveSameDefs && validScopes && validScopes.size < scopes.size) {
                partialValidDataCount++;
                result.validScopes = new Set(validScopes);
            }
            resultData[resultDataIdx++] = result;
        }
        resultData.length = resultDataIdx;
        const propertyDomain = (def)=>{
            const defDomain = dataDomain.get(def);
            const result = defDomain.getDomain();
            if ($d77b025aa58d633c$var$ContinuousDomain.is(defDomain) && result[0] > result[1]) return [];
            return result;
        };
        return {
            type: "ungrouped",
            input: {
                count: data.length
            },
            data: resultData,
            domain: {
                keys: keyDefs.map(propertyDomain),
                values: valueDefs.map(propertyDomain)
            },
            defs: {
                allScopesHaveSameDefs: allScopesHaveSameDefs,
                keys: keyDefs,
                values: valueDefs
            },
            partialValidDataCount: partialValidDataCount,
            time: 0
        };
    }
    groupData(data, groupingFn) {
        var _a;
        const processedData = /* @__PURE__ */ new Map();
        for (const dataEntry of data.data){
            const { keys: keys, values: values, datum: datum, validScopes: validScopes } = dataEntry;
            const group2 = (_a = groupingFn == null ? void 0 : groupingFn(dataEntry)) != null ? _a : keys;
            const groupStr = $d77b025aa58d633c$var$toKeyString(group2);
            if (processedData.has(groupStr)) {
                const existingData = processedData.get(groupStr);
                existingData.values.push(values);
                existingData.datum.push(datum);
                if (validScopes != null && existingData.validScopes != null) {
                    for (const scope of existingData.validScopes)if (!validScopes.has(scope)) existingData.validScopes.delete(scope);
                }
            } else processedData.set(groupStr, {
                keys: group2,
                values: [
                    values
                ],
                datum: [
                    datum
                ],
                validScopes: validScopes
            });
        }
        const resultData = new Array(processedData.size);
        const resultGroups = new Array(processedData.size);
        let dataIndex = 0;
        for (const { keys: keys, values: values, datum: datum, validScopes: validScopes } of processedData.values()){
            if ((validScopes == null ? void 0 : validScopes.size) === 0) continue;
            resultGroups[dataIndex] = keys;
            resultData[dataIndex++] = {
                keys: keys,
                values: values,
                datum: datum,
                validScopes: validScopes
            };
        }
        return $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, data), {
            type: "grouped",
            data: resultData,
            domain: $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, data.domain), {
                groups: resultGroups
            })
        });
    }
    aggregateData(processedData) {
        var _a, _b, _c, _d, _e, _f, _g;
        const isUngrouped = processedData.type === "ungrouped";
        processedData.domain.aggValues = [];
        for (const [index, def] of this.aggregates.entries()){
            const indices = this.valueGroupIdxLookup(def);
            const domain = [
                Infinity,
                -Infinity
            ];
            for (const datum of processedData.data){
                (_a = datum.aggValues) != null ? _a : datum.aggValues = new Array(this.aggregates.length);
                if (datum.validScopes) continue;
                const values = isUngrouped ? [
                    datum.values
                ] : datum.values;
                let groupAggValues = (_c = (_b = def.groupAggregateFunction) == null ? void 0 : _b.call(def)) != null ? _c : [
                    Infinity,
                    -Infinity
                ];
                for (const distinctValues of values){
                    const valuesToAgg = indices.map((valueIdx)=>distinctValues[valueIdx]);
                    const valuesAgg = def.aggregateFunction(valuesToAgg, datum.keys);
                    if (valuesAgg) groupAggValues = (_e = (_d = def.groupAggregateFunction) == null ? void 0 : _d.call(def, valuesAgg, groupAggValues)) != null ? _e : $d77b025aa58d633c$var$ContinuousDomain.extendDomain(valuesAgg, groupAggValues);
                }
                const finalValues = ((_g = (_f = def.finalFunction) == null ? void 0 : _f.call(def, groupAggValues)) != null ? _g : groupAggValues).map((v)=>$d77b025aa58d633c$var$round2(v));
                datum.aggValues[index] = finalValues;
                $d77b025aa58d633c$var$ContinuousDomain.extendDomain(finalValues, domain);
            }
            processedData.domain.aggValues.push(domain);
        }
    }
    postProcessGroups(processedData) {
        var _a, _b;
        const { groupProcessors: groupProcessors } = this;
        const affectedIndices = /* @__PURE__ */ new Set();
        const updatedDomains = /* @__PURE__ */ new Map();
        const groupProcessorIndices = /* @__PURE__ */ new Map();
        const groupProcessorInitFns = /* @__PURE__ */ new Map();
        for (const processor of groupProcessors){
            const indices = this.valueGroupIdxLookup(processor);
            groupProcessorIndices.set(processor, indices);
            groupProcessorInitFns.set(processor, processor.adjust());
            for (const idx of indices){
                const valueDef = this.values[idx];
                const isDiscrete = valueDef.valueType === "category";
                affectedIndices.add(idx);
                updatedDomains.set(idx, isDiscrete ? new $d77b025aa58d633c$var$DiscreteDomain() : new $d77b025aa58d633c$var$ContinuousDomain());
            }
        }
        const updateDomains = (values)=>{
            var _a2;
            for (const valueIndex of affectedIndices)(_a2 = updatedDomains.get(valueIndex)) == null || _a2.extend(values[valueIndex]);
        };
        for (const group2 of processedData.data){
            for (const processor of groupProcessors){
                if (group2.validScopes) continue;
                const valueIndexes = (_a = groupProcessorIndices.get(processor)) != null ? _a : [];
                const adjustFn = (_b = groupProcessorInitFns.get(processor)) == null ? void 0 : _b();
                if (!adjustFn) continue;
                if (processedData.type === "grouped") {
                    for (const values of group2.values)if (values) adjustFn(values, valueIndexes);
                } else if (group2.values) adjustFn(group2.values, valueIndexes);
            }
            if (processedData.type === "grouped") for (const values of group2.values)updateDomains(values);
            else updateDomains(group2.values);
        }
        for (const [idx, dataDomain] of updatedDomains)processedData.domain.values[idx] = dataDomain.getDomain();
    }
    postProcessProperties(processedData) {
        for (const { adjust: adjust, property: property, scopes: scopes } of this.propertyProcessors)adjust()(processedData, this.valueIdxLookup(scopes, property));
    }
    reduceData(processedData) {
        var _a, _b;
        (_a = processedData.reduced) != null ? _a : processedData.reduced = {};
        for (const def of this.reducers){
            const reducer = def.reducer();
            let accValue = def.initialValue;
            for (const datum of processedData.data)if (!datum.validScopes || ((_b = def.scopes) == null ? void 0 : _b.some((s)=>{
                var _a2;
                return (_a2 = datum.validScopes) == null ? void 0 : _a2.has(s);
            }))) accValue = reducer(accValue, datum);
            processedData.reduced[def.property] = accValue;
        }
    }
    postProcessData(processedData) {
        var _a;
        (_a = processedData.reduced) != null ? _a : processedData.reduced = {};
        for (const def of this.processors)processedData.reduced[def.property] = def.calculate(processedData);
    }
    initDataDomainProcessor() {
        const { keys: keyDefs, values: valueDefs } = this;
        const scopes = /* @__PURE__ */ new Set();
        for (const valueDef of valueDefs){
            if (!valueDef.scopes) continue;
            for (const scope of valueDef.scopes)scopes.add(scope);
        }
        const dataDomain = /* @__PURE__ */ new Map();
        const processorFns = /* @__PURE__ */ new Map();
        let allScopesHaveSameDefs = true;
        const initDataDomain = ()=>{
            var _a;
            for (const def of $d77b025aa58d633c$var$iterate(keyDefs, valueDefs))if (def.valueType === "category") dataDomain.set(def, new $d77b025aa58d633c$var$DiscreteDomain());
            else {
                dataDomain.set(def, new $d77b025aa58d633c$var$ContinuousDomain());
                allScopesHaveSameDefs && (allScopesHaveSameDefs = ((_a = def.scopes) != null ? _a : []).length === scopes.size);
            }
        };
        initDataDomain();
        const accessors = this.buildAccessors($d77b025aa58d633c$var$iterate(keyDefs, valueDefs));
        const processValue = (def, datum, previousDatum, scope)=>{
            var _a, _b, _c, _d, _e;
            let valueInDatum;
            let value;
            if (accessors.has(def.property)) {
                try {
                    value = accessors.get(def.property)(datum);
                } catch (error) {}
                valueInDatum = value != null;
            } else {
                valueInDatum = def.property in datum;
                value = valueInDatum ? datum[def.property] : def.missingValue;
            }
            if (def.forceValue != null) {
                const valueNegative = valueInDatum && $d77b025aa58d633c$var$isNegative(value);
                value = valueNegative ? -1 * def.forceValue : def.forceValue;
                valueInDatum = true;
            }
            const missingValueDef = "missingValue" in def;
            if (!valueInDatum && !missingValueDef) {
                const missCount = (_a = def.missing.get(scope)) != null ? _a : 0;
                def.missing.set(scope, missCount + 1);
            }
            if (!dataDomain.has(def)) initDataDomain();
            if (valueInDatum && !((_c = (_b = def.validation) == null ? void 0 : _b.call(def, value, datum)) != null ? _c : true)) {
                if ("invalidValue" in def) value = def.invalidValue;
                else {
                    if (this.mode !== "integrated") $d77b025aa58d633c$var$Logger.warnOnce(`invalid value of type [${typeof value}] ignored:`, `[${value}]`);
                    return $d77b025aa58d633c$var$INVALID_VALUE;
                }
            }
            if (def.processor) {
                if (!processorFns.has(def)) processorFns.set(def, def.processor());
                value = (_d = processorFns.get(def)) == null ? void 0 : _d(value, previousDatum === $d77b025aa58d633c$var$INVALID_VALUE ? void 0 : previousDatum);
            }
            (_e = dataDomain.get(def)) == null || _e.extend(value);
            return value;
        };
        return {
            dataDomain: dataDomain,
            processValue: processValue,
            initDataDomain: initDataDomain,
            scopes: scopes,
            allScopesHaveSameDefs: allScopesHaveSameDefs
        };
    }
    buildAccessors(defs) {
        const result = /* @__PURE__ */ new Map();
        if (this.mode === "integrated") return result;
        for (const def of defs){
            const isPath = def.property.includes(".") || def.property.includes("[");
            if (!isPath) continue;
            let fnBody;
            if (def.property.startsWith("[")) fnBody = `return datum${def.property};`;
            else fnBody = `return datum.${def.property};`;
            result.set(def.property, new Function("datum", fnBody));
        }
        return result;
    }
};
function $d77b025aa58d633c$var$logProcessedData(processedData) {
    var _a, _b;
    const logValues = (name, data)=>{
        if (data.length > 0) {
            $d77b025aa58d633c$var$Logger.log(`DataModel.processData() - ${name}`);
            $d77b025aa58d633c$var$Logger.table(data);
        }
    };
    $d77b025aa58d633c$var$Logger.log("DataModel.processData() - processedData", processedData);
    logValues("Key Domains", processedData.domain.keys);
    logValues("Group Domains", (_a = processedData.domain.groups) != null ? _a : []);
    logValues("Value Domains", processedData.domain.values);
    logValues("Aggregate Domains", (_b = processedData.domain.aggValues) != null ? _b : []);
    if (processedData.type === "grouped") {
        const flattenedValues = processedData.data.reduce((acc, next)=>{
            var _a2, _b2;
            const keys = (_a2 = next.keys) != null ? _a2 : [];
            const aggValues = (_b2 = next.aggValues) != null ? _b2 : [];
            const skipKeys = next.keys.map(()=>void 0);
            const skipAggValues = aggValues == null ? void 0 : aggValues.map(()=>void 0);
            acc.push(...next.values.map((v, i)=>[
                    ...i === 0 ? keys : skipKeys,
                    ...v != null ? v : [],
                    ...i == 0 ? aggValues : skipAggValues
                ]));
            return acc;
        }, []);
        logValues("Values", flattenedValues);
    } else {
        const flattenedValues = processedData.data.reduce((acc, next)=>{
            var _a2;
            const aggValues = (_a2 = next.aggValues) != null ? _a2 : [];
            acc.push([
                ...next.keys,
                ...next.values,
                ...aggValues
            ]);
            return acc;
        }, []);
        logValues("Values", flattenedValues);
    }
}
// packages/ag-charts-community/src/chart/data/dataController.ts
var $d77b025aa58d633c$var$_DataController = class _DataController {
    constructor(mode){
        this.mode = mode;
        this.debug = $d77b025aa58d633c$var$Debug.create(true, "data-model");
        this.requested = [];
        this.status = "setup";
    }
    request(id, data, opts) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            if (this.status !== "setup") throw new Error(`AG Charts - data request after data setup phase.`);
            return new Promise((resolve, reject)=>{
                this.requested.push({
                    id: id,
                    opts: opts,
                    data: data,
                    resolve: resolve,
                    reject: reject
                });
            });
        });
    }
    execute() {
        if (this.status !== "setup") throw new Error(`AG Charts - data request after data setup phase.`);
        this.status = "executed";
        this.debug("DataController.execute() - requested", this.requested);
        const valid = this.validateRequests(this.requested);
        this.debug("DataController.execute() - validated", valid);
        const merged = this.mergeRequested(valid);
        this.debug("DataController.execute() - merged", merged);
        if (this.debug.check()) $d77b025aa58d633c$var$getWindow().processedData = [];
        const scopes = this.requested.map(({ id: id })=>id);
        const needsValueExtraction = this.hasMultipleDataSources(valid);
        for (const { opts: opts, data: data, resolves: resolves, rejects: rejects, ids: ids } of merged)try {
            const dataModel = new $d77b025aa58d633c$var$DataModel(opts, this.mode);
            const processedData = dataModel.processData(data, valid);
            if (this.debug.check()) $d77b025aa58d633c$var$getWindow("processedData").push(processedData);
            if ((processedData == null ? void 0 : processedData.partialValidDataCount) === 0) resolves.forEach((resolve, requestIdx)=>resolve({
                    dataModel: dataModel,
                    processedData: this.processScopedData(ids[requestIdx], processedData, scopes, needsValueExtraction)
                }));
            else if (processedData) this.splitResult(dataModel, processedData, ids, resolves);
            else rejects.forEach((cb)=>cb(new Error(`AG Charts - no processed data generated`)));
        } catch (error) {
            rejects.forEach((cb)=>cb(error));
        }
    }
    hasMultipleDataSources(validRequests) {
        if (validRequests.length) {
            const [{ data: data }, ...restRequests] = validRequests;
            return restRequests.some((v)=>data !== v.data);
        }
        return false;
    }
    processScopedData(id, processedData, ids, needsValueExtraction) {
        const extractDatum = (datum)=>{
            if (Array.isArray(datum)) return datum.map(extractDatum);
            const extracted = needsValueExtraction ? $d77b025aa58d633c$var$__spreadValues($d77b025aa58d633c$var$__spreadValues({}, datum), datum[id]) : datum;
            for (const otherId of ids)delete extracted[otherId];
            return extracted;
        };
        const extractValues = (values)=>{
            var _a;
            if (Array.isArray(values)) return values.map(extractValues);
            return (_a = values == null ? void 0 : values[id]) != null ? _a : values;
        };
        return $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, processedData), {
            data: processedData.data.map((datum)=>{
                var _a;
                return $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, datum), {
                    datum: extractDatum(datum.datum),
                    values: needsValueExtraction ? (_a = datum.values) == null ? void 0 : _a.map(extractValues) : datum.values
                });
            })
        });
    }
    validateRequests(requested) {
        const valid = [];
        for (const [index, request] of requested.entries())if (index > 0 && request.data.length !== requested[0].data.length && request.opts.groupByData === false) request.reject(new Error("all series[].data arrays must be of the same length and have matching keys."));
        else valid.push(request);
        return valid;
    }
    mergeRequested(requested) {
        const grouped = [];
        for (const request of requested){
            const match = grouped.find(_DataController.groupMatch(request));
            if (match) match.push(request);
            else grouped.push([
                request
            ]);
        }
        return grouped.map(_DataController.mergeRequests);
    }
    splitResult(dataModel, processedData, scopes, resolves) {
        for(let i = 0; i < scopes.length; i++){
            const scope = scopes[i];
            const resolve = resolves[i];
            resolve({
                dataModel: dataModel,
                processedData: $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, processedData), {
                    data: processedData.data.filter(({ validScopes: validScopes })=>{
                        var _a;
                        return (_a = validScopes == null ? void 0 : validScopes.has(scope)) != null ? _a : true;
                    })
                })
            });
        }
    }
    static groupMatch({ data: data, opts: opts }) {
        function keys(props) {
            return props.filter((p)=>p.type === "key").map((p)=>p.property).join(";");
        }
        return ([group2])=>(opts.groupByData === false || group2.data === data) && group2.opts.groupByKeys === opts.groupByKeys && group2.opts.groupByFn === opts.groupByFn && keys(group2.opts.props) === keys(opts.props);
    }
    static mergeRequests(requests) {
        return requests.reduce((result, _a)=>{
            var { id: id, data: data, resolve: resolve, reject: reject, opts: _b } = _a, _c = _b, { props: props } = _c, opts = $d77b025aa58d633c$var$__objRest(_c, [
                "props"
            ]);
            var _a2, _b2, _c2, _d, _e;
            result.ids.push(id);
            result.rejects.push(reject);
            result.resolves.push(resolve);
            (_a2 = result.data) != null ? _a2 : result.data = data;
            (_b2 = result.opts) != null ? _b2 : result.opts = $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, opts), {
                props: []
            });
            for (const prop of props){
                const clone = $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, prop), {
                    scopes: [
                        id
                    ]
                });
                _DataController.createIdsMap(id, clone);
                const match = result.opts.props.find((existing)=>existing.type === clone.type && _DataController.deepEqual(existing, clone));
                if (!match) {
                    result.opts.props.push(clone);
                    continue;
                }
                (_c2 = match.scopes) != null ? _c2 : match.scopes = [];
                match.scopes.push(...(_d = clone.scopes) != null ? _d : []);
                if ((match.type === "key" || match.type === "value") && ((_e = clone.idsMap) == null ? void 0 : _e.size)) _DataController.mergeIdsMap(clone.idsMap, match.idsMap);
            }
            return result;
        }, {
            ids: [],
            rejects: [],
            resolves: [],
            data: null,
            opts: null
        });
    }
    static mergeIdsMap(fromMap, toMap) {
        for (const [scope, ids] of fromMap){
            if (toMap.has(scope)) for (const id of ids)toMap.get(scope).add(id);
            else toMap.set(scope, new Set(ids));
        }
    }
    static createIdsMap(scope, prop) {
        var _a;
        if (prop.id == null) return;
        (_a = prop.idsMap) != null ? _a : prop.idsMap = /* @__PURE__ */ new Map();
        if (prop.idsMap.has(scope)) prop.idsMap.get(scope).add(prop.id);
        else prop.idsMap.set(scope, /* @__PURE__ */ new Set([
            prop.id
        ]));
    }
    static deepEqual(a, b) {
        if (a === b) return true;
        if (a && b && typeof a == "object" && typeof b == "object") {
            if (a.constructor !== b.constructor) return false;
            let i, length;
            if (Array.isArray(a)) {
                length = a.length;
                if (length !== b.length) return false;
                for(i = length - 1; i >= 0; i--){
                    if (!_DataController.deepEqual(a[i], b[i])) return false;
                }
                return true;
            }
            const keys = Object.keys(a);
            length = keys.length;
            if (length !== Object.keys(b).length) return false;
            for(i = length - 1; i >= 0; i--){
                const key = keys[i];
                if (!_DataController.skipKeys.has(key) && (!Object.hasOwn(b, key) || !_DataController.deepEqual(a[key], b[key]))) return false;
            }
            return true;
        }
        return false;
    }
};
// optimized version of deep equality for `mergeRequests` which can potentially loop over 1M times
$d77b025aa58d633c$var$_DataController.skipKeys = /* @__PURE__ */ new Set([
    "id",
    "idsMap",
    "type",
    "scopes"
]);
var $d77b025aa58d633c$var$DataController = $d77b025aa58d633c$var$_DataController;
// packages/ag-charts-community/src/chart/interaction/syncManager.ts
var $d77b025aa58d633c$var$_SyncManager = class _SyncManager extends $d77b025aa58d633c$var$BaseManager {
    constructor(chart){
        super();
        this.chart = chart;
    }
    subscribe(groupId = _SyncManager.DEFAULT_GROUP) {
        let syncGroup = this.get(groupId);
        if (!syncGroup) {
            syncGroup = /* @__PURE__ */ new Set();
            _SyncManager.chartsGroups.set(groupId, syncGroup);
        }
        syncGroup.add(this.chart);
        return this;
    }
    unsubscribe(groupId = _SyncManager.DEFAULT_GROUP) {
        var _a;
        (_a = this.get(groupId)) == null || _a.delete(this.chart);
        return this;
    }
    getChart() {
        return this.chart;
    }
    getGroup(groupId = _SyncManager.DEFAULT_GROUP) {
        const syncGroup = this.get(groupId);
        return syncGroup ? Array.from(syncGroup) : [];
    }
    getGroupSiblings(groupId = _SyncManager.DEFAULT_GROUP) {
        return this.getGroup(groupId).filter((chart)=>chart !== this.chart);
    }
    get(groupId) {
        return _SyncManager.chartsGroups.get(groupId);
    }
};
$d77b025aa58d633c$var$_SyncManager.chartsGroups = /* @__PURE__ */ new Map();
$d77b025aa58d633c$var$_SyncManager.DEFAULT_GROUP = Symbol("sync-group-default");
var $d77b025aa58d633c$var$SyncManager = $d77b025aa58d633c$var$_SyncManager;
// packages/ag-charts-community/src/chart/interaction/zoomManager.ts
var $d77b025aa58d633c$var$ZoomManager = class extends $d77b025aa58d633c$var$BaseManager {
    constructor(){
        super(...arguments);
        this.axisZoomManagers = /* @__PURE__ */ new Map();
        this.state = new $d77b025aa58d633c$var$StateTracker(void 0, "initial");
        this.rejectCallbacks = /* @__PURE__ */ new Map();
    }
    updateAxes(axes) {
        var _a;
        const zoomManagers = new Map(axes.map((axis)=>[
                axis.id,
                this.axisZoomManagers.get(axis.id)
            ]));
        this.axisZoomManagers.clear();
        for (const axis of axes)this.axisZoomManagers.set(axis.id, (_a = zoomManagers.get(axis.id)) != null ? _a : new $d77b025aa58d633c$var$AxisZoomManager(axis));
        if (this.state.size > 0 && axes.length > 0) this.updateZoom(this.state.stateId(), this.state.stateValue());
    }
    updateZoom(callerId, newZoom, canChangeInitial = true, rejectCallback) {
        var _a;
        if (rejectCallback) this.rejectCallbacks.set(callerId, rejectCallback);
        if (this.axisZoomManagers.size === 0) {
            const stateId = this.state.stateId();
            if (stateId === "initial" || stateId === callerId || canChangeInitial) {
                this.state.set(callerId, newZoom);
                if (stateId !== callerId) (_a = this.rejectCallbacks.get(stateId)) == null || _a(callerId);
            } else rejectCallback == null || rejectCallback(stateId);
            return;
        }
        this.state.set(callerId, newZoom);
        this.axisZoomManagers.forEach((axis)=>{
            axis.updateZoom(callerId, newZoom == null ? void 0 : newZoom[axis.getDirection()]);
        });
        this.applyChanges(callerId);
    }
    updateAxisZoom(callerId, axisId, newZoom) {
        var _a;
        (_a = this.axisZoomManagers.get(axisId)) == null || _a.updateZoom(callerId, newZoom);
        this.applyChanges(callerId);
    }
    // Fire this event to signal to listeners that the view is changing through a zoom and/or pan change.
    fireZoomPanStartEvent(callerId) {
        this.listeners.dispatch("zoom-pan-start", {
            type: "zoom-pan-start",
            callerId: callerId
        });
    }
    getZoom() {
        let x;
        let y;
        this.axisZoomManagers.forEach((axis)=>{
            if (axis.getDirection() === "x" /* X */ ) x != null ? x : x = axis.getZoom();
            else if (axis.getDirection() === "y" /* Y */ ) y != null ? y : y = axis.getZoom();
        });
        if (x || y) return {
            x: x,
            y: y
        };
    }
    getAxisZoom(axisId) {
        var _a, _b;
        return (_b = (_a = this.axisZoomManagers.get(axisId)) == null ? void 0 : _a.getZoom()) != null ? _b : {
            min: 0,
            max: 1
        };
    }
    getAxisZooms() {
        const axes = {};
        for (const [axisId, axis] of this.axisZoomManagers.entries())axes[axisId] = {
            direction: axis.getDirection(),
            zoom: axis.getZoom()
        };
        return axes;
    }
    applyChanges(callerId) {
        const changed = Array.from(this.axisZoomManagers.values(), (axis)=>axis.applyChanges()).some(Boolean);
        if (!changed) return;
        const axes = {};
        for (const [axisId, axis] of this.axisZoomManagers.entries())axes[axisId] = axis.getZoom();
        this.listeners.dispatch("zoom-change", $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({
            type: "zoom-change"
        }, this.getZoom()), {
            axes: axes,
            callerId: callerId
        }));
    }
};
var $d77b025aa58d633c$var$AxisZoomManager = class {
    constructor(axis){
        this.axis = axis;
        const [min = 0, max = 1] = axis.visibleRange;
        this.state = new $d77b025aa58d633c$var$StateTracker({
            min: min,
            max: max
        });
        this.currentZoom = this.state.stateValue();
    }
    getDirection() {
        return this.axis.direction;
    }
    updateZoom(callerId, newZoom) {
        this.state.set(callerId, newZoom);
    }
    getZoom() {
        return $d77b025aa58d633c$var$deepClone(this.state.stateValue());
    }
    applyChanges() {
        const prevZoom = this.currentZoom;
        this.currentZoom = this.state.stateValue();
        return prevZoom.min !== this.currentZoom.min || prevZoom.max !== this.currentZoom.max;
    }
};
// packages/ag-charts-community/src/chart/keyboard.ts
var $d77b025aa58d633c$var$Keyboard = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.enabled = false;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN)
], $d77b025aa58d633c$var$Keyboard.prototype, "enabled", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$NUMBER)
], $d77b025aa58d633c$var$Keyboard.prototype, "tabIndex", 2);
// packages/ag-charts-community/src/chart/keyboardUtil.ts
function $d77b025aa58d633c$var$makeKeyboardPointerEvent(regionManager, pick) {
    const { bbox: bbox, showFocusBox: showFocusBox } = pick;
    if (showFocusBox) regionManager.updateFocusIndicatorRect(pick.bbox);
    if (bbox !== void 0) {
        const { x: offsetX, y: offsetY } = bbox.computeCenter();
        return {
            type: "keyboard",
            offsetX: offsetX,
            offsetY: offsetY
        };
    }
    return void 0;
}
// packages/ag-charts-community/src/chart/mapping/prepareAxis.ts
var $d77b025aa58d633c$var$CARTESIAN_AXIS_POSITIONS = [
    "top",
    "right",
    "bottom",
    "left"
];
var $d77b025aa58d633c$var$CARTESIAN_AXIS_TYPES = [
    "category",
    "grouped-category",
    "ordinal-time",
    "number",
    "log",
    "time"
];
function $d77b025aa58d633c$var$hasCartesianAxisPosition(axis) {
    const allowedTypes = $d77b025aa58d633c$var$CARTESIAN_AXIS_TYPES;
    return allowedTypes.includes(axis.type);
}
function $d77b025aa58d633c$var$isCartesianAxisOptions(options) {
    const allowedTypes = $d77b025aa58d633c$var$CARTESIAN_AXIS_TYPES;
    return allowedTypes.includes(options.type);
}
function $d77b025aa58d633c$var$isAxisPosition(position) {
    const allowedPositions = $d77b025aa58d633c$var$CARTESIAN_AXIS_POSITIONS;
    return typeof position === "string" && allowedPositions.includes(position);
}
var $d77b025aa58d633c$var$AxisPositionGuesser = class {
    constructor(){
        this.result = [];
        this.valid = [];
        this.invalid = [];
    }
    push(axis, options) {
        const { result: result, valid: valid, invalid: invalid } = this;
        if ($d77b025aa58d633c$var$isCartesianAxisOptions(options)) {
            if ($d77b025aa58d633c$var$isAxisPosition(options.position)) valid.push(axis);
            else invalid.push(axis);
        }
        result.push(axis);
    }
    guessInvalidPositions() {
        const takenPosition = this.valid.filter((v)=>$d77b025aa58d633c$var$hasCartesianAxisPosition(v)).map((v)=>v.position).filter((v)=>v !== void 0);
        const guesses = [
            "top",
            "right",
            "bottom",
            "left"
        ];
        for (const invalidAxis of this.invalid){
            let nextGuess = guesses.pop();
            while(takenPosition.includes(nextGuess) && nextGuess !== void 0)nextGuess = guesses.pop();
            if (nextGuess === void 0) break;
            invalidAxis.position = nextGuess;
        }
        return this.result;
    }
};
// packages/ag-charts-community/src/chart/mapping/prepareSeries.ts
var $d77b025aa58d633c$var$MATCHING_KEYS = [
    "direction",
    "xKey",
    "yKey",
    "sizeKey",
    "angleKey",
    "radiusKey",
    "normalizedTo",
    "stacked",
    "grouped",
    "stackGroup"
];
function $d77b025aa58d633c$var$matchSeriesOptions(series, optSeries, oldOptsSeries) {
    var _a, _b, _c, _d;
    const generateKey = (type, i)=>{
        const result = [
            type
        ];
        for (const key of $d77b025aa58d633c$var$MATCHING_KEYS)if (key in i && i[key] != null) result.push(`${key}=${i[key]}`);
        return result.join(";");
    };
    const seriesMap = /* @__PURE__ */ new Map();
    let idx = 0;
    for (const s of series){
        const key = generateKey(s.type, s.properties);
        if (!seriesMap.has(key)) seriesMap.set(key, []);
        (_a = seriesMap.get(key)) == null || _a.push([
            s,
            idx++
        ]);
    }
    const optsMap = /* @__PURE__ */ new Map();
    for (const o of optSeries){
        const key = generateKey(o.type, o);
        if (!optsMap.has(key)) optsMap.set(key, []);
        (_b = optsMap.get(key)) == null || _b.push(o);
    }
    const overlap = [
        ...seriesMap.keys()
    ].some((k)=>optsMap.has(k));
    if (!overlap) return {
        status: "no-overlap",
        oldKeys: seriesMap.keys(),
        newKeys: optsMap.keys()
    };
    const changes = [];
    let targetIdx = -1;
    for (const [key, optArray] of optsMap.entries())for (const opts of optArray){
        targetIdx++;
        const seriesArray = seriesMap.get(key);
        if (seriesArray == null || seriesArray.length < 1) {
            changes.push({
                opts: opts,
                idx: targetIdx,
                status: "add"
            });
            seriesMap.delete(key);
            continue;
        }
        const [outputSeries, outputIdx] = seriesArray.shift();
        const previousOpts = (_c = oldOptsSeries == null ? void 0 : oldOptsSeries[outputIdx]) != null ? _c : {};
        const diff2 = $d77b025aa58d633c$var$jsonDiff(previousOpts, opts != null ? opts : {});
        const { groupIndex: groupIndex, stackIndex: stackIndex } = (_d = diff2 == null ? void 0 : diff2.seriesGrouping) != null ? _d : {};
        if (groupIndex != null || stackIndex != null) changes.push({
            opts: opts,
            series: outputSeries,
            diff: diff2,
            idx: outputIdx,
            status: "series-grouping"
        });
        else if (diff2) changes.push({
            opts: opts,
            series: outputSeries,
            diff: diff2,
            idx: outputIdx,
            status: "update"
        });
        else changes.push({
            opts: opts,
            series: outputSeries,
            idx: outputIdx,
            status: "no-op"
        });
        if (seriesArray.length === 0) seriesMap.delete(key);
    }
    for (const seriesArray of seriesMap.values())for (const [outputSeries, outputIdx] of seriesArray)changes.push({
        series: outputSeries,
        idx: outputIdx,
        status: "remove"
    });
    return {
        status: "overlap",
        changes: changes
    };
}
// packages/ag-charts-community/src/chart/modulesManager.ts
var $d77b025aa58d633c$var$ModulesManager = class extends $d77b025aa58d633c$var$ModuleMap {
    applyOptions(options) {
        for (const m of this.moduleMap.values())if (m.module.optionsKey in options && $d77b025aa58d633c$var$isProperties(m.moduleInstance)) m.moduleInstance.set(options[m.module.optionsKey]);
    }
    *legends() {
        for (const { module: module, moduleInstance: moduleInstance } of this.moduleMap.values()){
            if (module.type !== "legend") continue;
            yield {
                legendType: module.identifier,
                legend: moduleInstance
            };
        }
    }
};
// packages/ag-charts-community/src/chart/overlay/overlay.ts
var $d77b025aa58d633c$var$DEFAULT_OVERLAY_CLASS = "ag-chart-overlay";
var $d77b025aa58d633c$var$DEFAULT_OVERLAY_DARK_CLASS = "ag-chart-dark-overlay";
var $d77b025aa58d633c$var$Overlay = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(className, defaultText){
        super();
        this.className = className;
        this.defaultText = defaultText;
        this.darkTheme = false;
    }
    getText() {
        var _a;
        return (_a = this.text) != null ? _a : this.defaultText;
    }
    getElement(animationManager, rect) {
        var _a;
        (_a = this.element) != null ? _a : this.element = $d77b025aa58d633c$var$createElement("div", $d77b025aa58d633c$var$DEFAULT_OVERLAY_CLASS, {
            position: "absolute"
        });
        this.element.classList.toggle($d77b025aa58d633c$var$DEFAULT_OVERLAY_DARK_CLASS, this.darkTheme);
        this.focusBox = rect;
        const element2 = this.element;
        element2.style.left = `${rect.x}px`;
        element2.style.top = `${rect.y}px`;
        element2.style.width = `${rect.width}px`;
        element2.style.height = `${rect.height}px`;
        if (this.renderer) {
            const htmlContent = this.renderer();
            if (htmlContent instanceof HTMLElement) element2.replaceChildren(htmlContent);
            else element2.innerHTML = htmlContent;
        } else {
            const content = $d77b025aa58d633c$var$createElement("div", {
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                boxSizing: "border-box",
                height: "100%",
                margin: "8px",
                font: "12px Verdana, sans-serif"
            });
            content.innerText = this.getText();
            element2.replaceChildren(content);
            animationManager == null || animationManager.animate({
                from: 0,
                to: 1,
                id: "overlay",
                phase: "add",
                groupId: "opacity",
                onUpdate (value) {
                    element2.style.opacity = String(value);
                },
                onStop () {
                    element2.style.opacity = "1";
                }
            });
        }
        return this.element;
    }
    removeElement(animationManager) {
        if (!this.element) return;
        if (animationManager) {
            const { element: element2 } = this;
            animationManager.animate({
                from: 1,
                to: 0,
                phase: "remove",
                id: "overlay",
                groupId: "opacity",
                onUpdate (value) {
                    element2.style.opacity = String(value);
                },
                onStop () {
                    element2.remove();
                }
            });
        } else this.element.remove();
        this.element = void 0;
        this.focusBox = void 0;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$Overlay.prototype, "text", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$FUNCTION, {
        optional: true
    })
], $d77b025aa58d633c$var$Overlay.prototype, "renderer", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN)
], $d77b025aa58d633c$var$Overlay.prototype, "darkTheme", 2);
// packages/ag-charts-community/src/chart/overlay/chartOverlays.ts
var $d77b025aa58d633c$var$ChartOverlays = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.loading = new $d77b025aa58d633c$var$Overlay("ag-chart-loading-overlay", "Loading data...");
        this.noData = new $d77b025aa58d633c$var$Overlay("ag-chart-no-data-overlay", "No data to display");
        this.noVisibleSeries = new $d77b025aa58d633c$var$Overlay("ag-chart-no-visible-series", "No visible series");
    }
    getFocusInfo() {
        for (const overlay of [
            this.loading,
            this.noData,
            this.noVisibleSeries
        ]){
            if (overlay.focusBox !== void 0) return {
                text: overlay.getText(),
                rect: overlay.focusBox
            };
        }
        return void 0;
    }
    destroy() {
        this.loading.removeElement();
        this.noData.removeElement();
        this.noVisibleSeries.removeElement();
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$ChartOverlays.prototype, "loading", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$ChartOverlays.prototype, "noData", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$ChartOverlays.prototype, "noVisibleSeries", 2);
// packages/ag-charts-community/src/chart/overlay/loadingSpinner.ts
var $d77b025aa58d633c$var$defaultOverlayCss = `
.${$d77b025aa58d633c$var$DEFAULT_OVERLAY_CLASS} {
    color: #181d1f;
}

.${$d77b025aa58d633c$var$DEFAULT_OVERLAY_CLASS}.${$d77b025aa58d633c$var$DEFAULT_OVERLAY_DARK_CLASS} {
    color: #ffffff;
}

.${$d77b025aa58d633c$var$DEFAULT_OVERLAY_CLASS}--loading {
    color: rgb(140, 140, 140); /* DEFAULT_MUTED_LABEL_COLOUR */
}

.${$d77b025aa58d633c$var$DEFAULT_OVERLAY_CLASS}__loading-background {
    background: white; /* DEFAULT_BACKGROUND_FILL */
}

.${$d77b025aa58d633c$var$DEFAULT_OVERLAY_CLASS}.${$d77b025aa58d633c$var$DEFAULT_OVERLAY_DARK_CLASS} .${$d77b025aa58d633c$var$DEFAULT_OVERLAY_CLASS}__loading-background {
    background: #192232; /* DEFAULT_DARK_BACKGROUND_FILL */
}
`;
function $d77b025aa58d633c$var$getLoadingSpinner(text, defaultDuration) {
    const { animationDuration: animationDuration } = $d77b025aa58d633c$var$PHASE_METADATA["add"];
    const duration = animationDuration * defaultDuration;
    const container = $d77b025aa58d633c$var$createElement("div", `${$d77b025aa58d633c$var$DEFAULT_OVERLAY_CLASS}--loading`, {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        height: "100%",
        boxSizing: "border-box",
        font: "13px Verdana, sans-serif",
        // FONT_SIZE.MEDIUM
        userSelect: "none",
        animation: `ag-charts-loading ${duration}ms linear 50ms both`
    });
    const matrix = $d77b025aa58d633c$var$createElement("span", {
        width: "45px",
        height: "40px",
        backgroundImage: [
            "linear-gradient(#0000 calc(1 * 100% / 6), #ccc 0 calc(3 * 100% / 6), #0000 0), ",
            "linear-gradient(#0000 calc(2 * 100% / 6), #ccc 0 calc(4 * 100% / 6), #0000 0), ",
            "linear-gradient(#0000 calc(3 * 100% / 6), #ccc 0 calc(5 * 100% / 6), #0000 0)"
        ].join(""),
        backgroundSize: "10px 400%",
        backgroundRepeat: "no-repeat",
        animation: "ag-charts-loading-matrix 1s infinite linear"
    });
    const label = $d77b025aa58d633c$var$createElement("p", {
        marginTop: "1em"
    });
    label.innerText = text;
    const background = $d77b025aa58d633c$var$createElement("div", `${$d77b025aa58d633c$var$DEFAULT_OVERLAY_CLASS}__loading-background`, {
        position: "absolute",
        inset: "0",
        opacity: "0.5",
        zIndex: "-1"
    });
    const animationStyles = $d77b025aa58d633c$var$createElement("style");
    animationStyles.innerText = [
        "@keyframes ag-charts-loading { from { opacity: 0 } to { opacity: 1 } }",
        "@keyframes ag-charts-loading-matrix {",
        "0% { background-position: 0% 0%, 50% 0%, 100% 0%; }",
        "100% { background-position: 0% 100%, 50% 100%, 100% 100%; }",
        "}"
    ].join(" ");
    container.replaceChildren(animationStyles, matrix, label, background);
    $d77b025aa58d633c$var$injectStyle($d77b025aa58d633c$var$defaultOverlayCss, "chartOverlays");
    return container;
}
// packages/ag-charts-community/src/chart/data/aggregateFunctions.ts
function $d77b025aa58d633c$var$sumValues(values, accumulator = [
    0,
    0
]) {
    for (const value of values){
        if (typeof value !== "number") continue;
        if (value < 0) accumulator[0] += value;
        if (value > 0) accumulator[1] += value;
    }
    return accumulator;
}
function $d77b025aa58d633c$var$sum(id, matchGroupId) {
    const result = {
        id: id,
        matchGroupIds: [
            matchGroupId
        ],
        type: "aggregate",
        aggregateFunction: (values)=>$d77b025aa58d633c$var$sumValues(values)
    };
    return result;
}
function $d77b025aa58d633c$var$groupSum(id, matchGroupId) {
    return {
        id: id,
        type: "aggregate",
        matchGroupIds: matchGroupId ? [
            matchGroupId
        ] : void 0,
        aggregateFunction: (values)=>$d77b025aa58d633c$var$sumValues(values),
        groupAggregateFunction: (next, acc = [
            0,
            0
        ])=>{
            var _a, _b;
            acc[0] += (_a = next == null ? void 0 : next[0]) != null ? _a : 0;
            acc[1] += (_b = next == null ? void 0 : next[1]) != null ? _b : 0;
            return acc;
        }
    };
}
function $d77b025aa58d633c$var$range2(id, matchGroupId) {
    const result = {
        id: id,
        matchGroupIds: [
            matchGroupId
        ],
        type: "aggregate",
        aggregateFunction: (values)=>$d77b025aa58d633c$var$ContinuousDomain.extendDomain(values)
    };
    return result;
}
function $d77b025aa58d633c$var$groupCount(id) {
    return {
        id: id,
        type: "aggregate",
        aggregateFunction: ()=>[
                0,
                1
            ],
        groupAggregateFunction: (next, acc = [
            0,
            0
        ])=>{
            var _a, _b;
            acc[0] += (_a = next == null ? void 0 : next[0]) != null ? _a : 0;
            acc[1] += (_b = next == null ? void 0 : next[1]) != null ? _b : 0;
            return acc;
        }
    };
}
function $d77b025aa58d633c$var$groupAverage(id, matchGroupId) {
    const def = {
        id: id,
        matchGroupIds: matchGroupId ? [
            matchGroupId
        ] : void 0,
        type: "aggregate",
        aggregateFunction: (values)=>$d77b025aa58d633c$var$sumValues(values),
        groupAggregateFunction: (next, acc = [
            0,
            0,
            -1
        ])=>{
            var _a, _b;
            acc[0] += (_a = next == null ? void 0 : next[0]) != null ? _a : 0;
            acc[1] += (_b = next == null ? void 0 : next[1]) != null ? _b : 0;
            acc[2]++;
            return acc;
        },
        finalFunction: (acc = [
            0,
            0,
            0
        ])=>{
            const result = acc[0] + acc[1];
            if (result >= 0) return [
                0,
                result / acc[2]
            ];
            return [
                result / acc[2],
                0
            ];
        }
    };
    return def;
}
function $d77b025aa58d633c$var$area(id, aggFn, matchGroupId) {
    const result = {
        id: id,
        matchGroupIds: matchGroupId ? [
            matchGroupId
        ] : void 0,
        type: "aggregate",
        aggregateFunction: (values, keyRange = [])=>{
            const keyWidth = keyRange[1] - keyRange[0];
            return aggFn.aggregateFunction(values).map((v)=>v / keyWidth);
        }
    };
    if (aggFn.groupAggregateFunction) result.groupAggregateFunction = aggFn.groupAggregateFunction;
    return result;
}
function $d77b025aa58d633c$var$accumulatedValue(onlyPositive) {
    return ()=>{
        let value = 0;
        return (datum)=>{
            if (!$d77b025aa58d633c$var$isFiniteNumber(datum)) return datum;
            value += onlyPositive ? Math.max(0, datum) : datum;
            return value;
        };
    };
}
function $d77b025aa58d633c$var$trailingAccumulatedValue() {
    return ()=>{
        let value = 0;
        return (datum)=>{
            if (!$d77b025aa58d633c$var$isFiniteNumber(datum)) return datum;
            const trailingValue = value;
            value += datum;
            return trailingValue;
        };
    };
}
// packages/ag-charts-community/src/chart/data/processors.ts
var $d77b025aa58d633c$var$SMALLEST_KEY_INTERVAL = {
    type: "reducer",
    property: "smallestKeyInterval",
    initialValue: Infinity,
    reducer: ()=>{
        let prevX = NaN;
        return (smallestSoFar = Infinity, next)=>{
            const nextX = next.keys[0];
            const interval = Math.abs(nextX - prevX);
            prevX = nextX;
            if (!isNaN(interval) && interval > 0 && interval < smallestSoFar) return interval;
            return smallestSoFar;
        };
    }
};
var $d77b025aa58d633c$var$SORT_DOMAIN_GROUPS = {
    type: "processor",
    property: "sortedGroupDomain",
    calculate: ({ domain: { groups: groups } })=>groups == null ? void 0 : groups.slice().sort((a, b)=>{
            for(let i = 0; i < a.length; i++){
                const result = a[i] - b[i];
                if (result !== 0) return result;
            }
            return 0;
        })
};
function $d77b025aa58d633c$var$normaliseFnBuilder({ normaliseTo: normaliseTo, mode: mode }) {
    const normalise = (val, extent2)=>{
        const result = val * normaliseTo / extent2;
        if (result >= 0) return Math.min(normaliseTo, result);
        return Math.max(-normaliseTo, result);
    };
    return ()=>()=>(values, valueIndexes)=>{
                const valuesExtent = [
                    0,
                    0
                ];
                for (const valueIdx of valueIndexes){
                    const value = values[valueIdx];
                    const valIdx = value < 0 ? 0 : 1;
                    if (mode === "sum") valuesExtent[valIdx] += value;
                    else if (valIdx === 0) valuesExtent[valIdx] = Math.min(valuesExtent[valIdx], value);
                    else valuesExtent[valIdx] = Math.max(valuesExtent[valIdx], value);
                }
                const extent2 = Math.max(Math.abs(valuesExtent[0]), valuesExtent[1]);
                for (const valueIdx of valueIndexes)values[valueIdx] = normalise(values[valueIdx], extent2);
            };
}
function $d77b025aa58d633c$var$normaliseGroupTo(matchGroupIds, normaliseTo, mode = "sum") {
    return {
        type: "group-value-processor",
        matchGroupIds: matchGroupIds,
        adjust: $d77b025aa58d633c$var$memo({
            normaliseTo: normaliseTo,
            mode: mode
        }, $d77b025aa58d633c$var$normaliseFnBuilder)
    };
}
function $d77b025aa58d633c$var$normalisePropertyFnBuilder({ normaliseTo: normaliseTo, zeroDomain: zeroDomain, rangeMin: rangeMin, rangeMax: rangeMax }) {
    const normaliseSpan = normaliseTo[1] - normaliseTo[0];
    const normalise = (val, start, span)=>{
        const result = normaliseTo[0] + (val - start) / span * normaliseSpan;
        if (span === 0) return zeroDomain;
        else if (result >= normaliseTo[1]) return normaliseTo[1];
        else if (result < normaliseTo[0]) return normaliseTo[0];
        return result;
    };
    return ()=>(pData, pIdx)=>{
            let [start, end] = pData.domain.values[pIdx];
            if (rangeMin != null) start = rangeMin;
            if (rangeMax != null) end = rangeMax;
            const span = end - start;
            pData.domain.values[pIdx] = [
                normaliseTo[0],
                normaliseTo[1]
            ];
            for (const group2 of pData.data){
                let groupValues = group2.values;
                if (pData.type === "ungrouped") groupValues = [
                    groupValues
                ];
                for (const values of groupValues)values[pIdx] = normalise(values[pIdx], start, span);
            }
        };
}
function $d77b025aa58d633c$var$normalisePropertyTo(property, normaliseTo, zeroDomain, rangeMin, rangeMax) {
    return {
        type: "property-value-processor",
        property: property,
        adjust: $d77b025aa58d633c$var$memo({
            normaliseTo: normaliseTo,
            rangeMin: rangeMin,
            rangeMax: rangeMax,
            zeroDomain: zeroDomain
        }, $d77b025aa58d633c$var$normalisePropertyFnBuilder)
    };
}
function $d77b025aa58d633c$var$animationValidation(valueKeyIds) {
    return {
        type: "processor",
        property: "animationValidation",
        calculate (result) {
            const { keys: keys, values: values } = result.defs;
            const { input: input, data: data } = result;
            let uniqueKeys = true;
            let orderedKeys = true;
            const valueKeys = [];
            for(let k = 0; k < values.length; k++){
                if (!(valueKeyIds == null ? void 0 : valueKeyIds.includes(values[k].id))) continue;
                valueKeys.push([
                    k,
                    values[k]
                ]);
            }
            const processKey = (idx, def, type)=>{
                var _a;
                if (def.valueType === "category") {
                    const keyValues = result.domain[type][idx];
                    uniqueKeys && (uniqueKeys = keyValues.length === input.count);
                    return;
                }
                let lastValue = (_a = data[0]) == null ? void 0 : _a[type][idx];
                for(let d = 1; (uniqueKeys || orderedKeys) && d < data.length; d++){
                    const keyValue = data[d][type][idx];
                    orderedKeys && (orderedKeys = lastValue <= keyValue);
                    uniqueKeys && (uniqueKeys = lastValue !== keyValue);
                    lastValue = keyValue;
                }
            };
            for(let k = 0; (uniqueKeys || orderedKeys) && k < keys.length; k++)processKey(k, keys[k], "keys");
            for(let k = 0; (uniqueKeys || orderedKeys) && k < valueKeys.length; k++){
                const [idx, key] = valueKeys[k];
                processKey(idx, key, "values");
            }
            return {
                uniqueKeys: uniqueKeys,
                orderedKeys: orderedKeys
            };
        }
    };
}
function $d77b025aa58d633c$var$buildGroupAccFn({ mode: mode, separateNegative: separateNegative }) {
    return ()=>()=>(values, valueIndexes)=>{
                const acc = [
                    0,
                    0
                ];
                for (const valueIdx of valueIndexes){
                    const currentVal = values[valueIdx];
                    const accIndex = $d77b025aa58d633c$var$isNegative(currentVal) && separateNegative ? 0 : 1;
                    if (!$d77b025aa58d633c$var$isFiniteNumber(currentVal)) continue;
                    if (mode === "normal") acc[accIndex] += currentVal;
                    values[valueIdx] = acc[accIndex];
                    if (mode === "trailing") acc[accIndex] += currentVal;
                }
            };
}
function $d77b025aa58d633c$var$buildGroupWindowAccFn({ mode: mode, sum: sum2 }) {
    return ()=>{
        const lastValues = [];
        let firstRow = true;
        return ()=>{
            return (values, valueIndexes)=>{
                let acc = 0;
                for (const valueIdx of valueIndexes){
                    const currentVal = values[valueIdx];
                    const lastValue = firstRow && sum2 === "current" ? 0 : lastValues[valueIdx];
                    lastValues[valueIdx] = currentVal;
                    const sumValue = sum2 === "current" ? currentVal : lastValue;
                    if (!$d77b025aa58d633c$var$isFiniteNumber(currentVal) || !$d77b025aa58d633c$var$isFiniteNumber(lastValue)) {
                        values[valueIdx] = acc;
                        continue;
                    }
                    if (mode === "normal") acc += sumValue;
                    values[valueIdx] = acc;
                    if (mode === "trailing") acc += sumValue;
                }
                firstRow = false;
            };
        };
    };
}
function $d77b025aa58d633c$var$accumulateGroup(matchGroupId, mode, sum2, separateNegative = false) {
    let adjust;
    if (mode.startsWith("window")) {
        const modeParam = mode.endsWith("-trailing") ? "trailing" : "normal";
        adjust = $d77b025aa58d633c$var$memo({
            mode: modeParam,
            sum: sum2
        }, $d77b025aa58d633c$var$buildGroupWindowAccFn);
    } else adjust = $d77b025aa58d633c$var$memo({
        mode: mode,
        separateNegative: separateNegative
    }, $d77b025aa58d633c$var$buildGroupAccFn);
    return {
        type: "group-value-processor",
        matchGroupIds: [
            matchGroupId
        ],
        adjust: adjust
    };
}
function $d77b025aa58d633c$var$diff(previousData, updateMovedData = true) {
    return {
        type: "processor",
        property: "diff",
        calculate: (processedData)=>{
            const moved = /* @__PURE__ */ new Map();
            const added = /* @__PURE__ */ new Map();
            const updated = /* @__PURE__ */ new Map();
            const removed = /* @__PURE__ */ new Map();
            const length = Math.max(previousData.data.length, processedData.data.length);
            for(let i = 0; i < length; i++){
                const prev = previousData.data[i];
                const datum = processedData.data[i];
                const prevId = prev ? $d77b025aa58d633c$var$createDatumId(prev.keys) : "";
                const datumId = datum ? $d77b025aa58d633c$var$createDatumId(datum.keys) : "";
                if (datum && prev && prevId === datumId) {
                    if (!$d77b025aa58d633c$var$arraysEqual(prev.values, datum.values)) updated.set(datumId, datum);
                    continue;
                }
                if (removed.has(datumId)) {
                    if (updateMovedData || !$d77b025aa58d633c$var$arraysEqual(removed.get(datumId).values, datum.values)) {
                        updated.set(datumId, datum);
                        moved.set(datumId, datum);
                    }
                    removed.delete(datumId);
                } else if (datum) added.set(datumId, datum);
                if (added.has(prevId)) {
                    if (updateMovedData || !$d77b025aa58d633c$var$arraysEqual(added.get(prevId).values, prev.values)) {
                        updated.set(prevId, prev);
                        moved.set(prevId, prev);
                    }
                    added.delete(prevId);
                } else if (prev) {
                    updated.delete(prevId);
                    removed.set(prevId, prev);
                }
            }
            const changed = added.size > 0 || updated.size > 0 || removed.size > 0;
            return {
                changed: changed,
                added: added,
                updated: updated,
                removed: removed,
                moved: moved
            };
        }
    };
}
function $d77b025aa58d633c$var$createDatumId(keys, ...extraKeys) {
    let result;
    if ($d77b025aa58d633c$var$isArray(keys)) result = keys.map((key)=>$d77b025aa58d633c$var$transformIntegratedCategoryValue(key)).join("___");
    else result = $d77b025aa58d633c$var$transformIntegratedCategoryValue(keys);
    const primitiveType = typeof result === "string" || typeof result === "number" || result instanceof Date;
    if (primitiveType && extraKeys.length > 0) result += `___${extraKeys.join("___")}`;
    return result;
}
// packages/ag-charts-community/src/chart/series/series.ts
var $d77b025aa58d633c$var$SeriesNodePickMode = /* @__PURE__ */ ((SeriesNodePickMode2)=>{
    SeriesNodePickMode2[SeriesNodePickMode2["EXACT_SHAPE_MATCH"] = 0] = "EXACT_SHAPE_MATCH";
    SeriesNodePickMode2[SeriesNodePickMode2["NEAREST_BY_MAIN_AXIS_FIRST"] = 1] = "NEAREST_BY_MAIN_AXIS_FIRST";
    SeriesNodePickMode2[SeriesNodePickMode2["NEAREST_BY_MAIN_CATEGORY_AXIS_FIRST"] = 2] = "NEAREST_BY_MAIN_CATEGORY_AXIS_FIRST";
    SeriesNodePickMode2[SeriesNodePickMode2["NEAREST_NODE"] = 3] = "NEAREST_NODE";
    return SeriesNodePickMode2;
})($d77b025aa58d633c$var$SeriesNodePickMode || {});
function $d77b025aa58d633c$var$basicContinuousCheckDatumValidation(value) {
    return value != null && $d77b025aa58d633c$var$isContinuous(value);
}
function $d77b025aa58d633c$var$basicDiscreteCheckDatumValidation(value) {
    return value != null;
}
function $d77b025aa58d633c$var$getValidationFn(scaleType) {
    switch(scaleType){
        case "number":
        case "log":
        case "ordinal-time":
        case "time":
        case "color":
            return $d77b025aa58d633c$var$basicContinuousCheckDatumValidation;
        default:
            return $d77b025aa58d633c$var$basicDiscreteCheckDatumValidation;
    }
}
function $d77b025aa58d633c$var$getValueType(scaleType) {
    switch(scaleType){
        case "number":
        case "log":
        case "time":
        case "color":
            return "range";
        default:
            return "category";
    }
}
function $d77b025aa58d633c$var$keyProperty(propName, scaleType, opts = {}) {
    const result = $d77b025aa58d633c$var$__spreadValues({
        property: propName,
        type: "key",
        valueType: $d77b025aa58d633c$var$getValueType(scaleType),
        validation: $d77b025aa58d633c$var$getValidationFn(scaleType)
    }, opts);
    return result;
}
function $d77b025aa58d633c$var$valueProperty(propName, scaleType, opts = {}) {
    const result = $d77b025aa58d633c$var$__spreadValues({
        property: propName,
        type: "value",
        valueType: $d77b025aa58d633c$var$getValueType(scaleType),
        validation: $d77b025aa58d633c$var$getValidationFn(scaleType)
    }, opts);
    return result;
}
function $d77b025aa58d633c$var$rangedValueProperty(propName, opts = {}) {
    const _a = opts, { min: min = -Infinity, max: max = Infinity } = _a, defOpts = $d77b025aa58d633c$var$__objRest(_a, [
        "min",
        "max"
    ]);
    return $d77b025aa58d633c$var$__spreadValues({
        type: "value",
        property: propName,
        valueType: "range",
        validation: $d77b025aa58d633c$var$basicContinuousCheckDatumValidation,
        processor: ()=>(datum)=>$d77b025aa58d633c$var$isFiniteNumber(datum) ? $d77b025aa58d633c$var$clamp(min, datum, max) : datum
    }, defOpts);
}
function $d77b025aa58d633c$var$accumulativeValueProperty(propName, scaleType, opts = {}) {
    const _a = opts, { onlyPositive: onlyPositive } = _a, defOpts = $d77b025aa58d633c$var$__objRest(_a, [
        "onlyPositive"
    ]);
    const result = $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, $d77b025aa58d633c$var$valueProperty(propName, scaleType, defOpts)), {
        processor: $d77b025aa58d633c$var$accumulatedValue(onlyPositive)
    });
    return result;
}
function $d77b025aa58d633c$var$trailingAccumulatedValueProperty(propName, scaleType, opts = {}) {
    const result = $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, $d77b025aa58d633c$var$valueProperty(propName, scaleType, opts)), {
        processor: $d77b025aa58d633c$var$trailingAccumulatedValue()
    });
    return result;
}
function $d77b025aa58d633c$var$groupAccumulativeValueProperty(propName, mode, sum2 = "current", opts, scaleType) {
    return [
        $d77b025aa58d633c$var$valueProperty(propName, scaleType, opts),
        $d77b025aa58d633c$var$accumulateGroup(opts.groupId, mode, sum2, opts.separateNegative),
        ...opts.rangeId != null ? [
            $d77b025aa58d633c$var$range2(opts.rangeId, opts.groupId)
        ] : []
    ];
}
var $d77b025aa58d633c$var$SeriesNodeEvent = class {
    constructor(type, event, { datum: datum }, series){
        this.type = type;
        this.event = event;
        this.datum = datum;
        this.seriesId = series.id;
    }
};
var $d77b025aa58d633c$var$SeriesGroupingChangedEvent = class {
    constructor(series, seriesGrouping, oldGrouping){
        this.series = series;
        this.seriesGrouping = seriesGrouping;
        this.oldGrouping = oldGrouping;
        this.type = "groupingChanged";
    }
};
var $d77b025aa58d633c$var$Series = class extends $d77b025aa58d633c$var$Observable {
    constructor(seriesOpts){
        super();
        this.destroyFns = [];
        this.seriesGrouping = void 0;
        this.NodeEvent = $d77b025aa58d633c$var$SeriesNodeEvent;
        this.internalId = $d77b025aa58d633c$var$createId(this);
        // The group node that contains all the nodes used to render this series.
        this.rootGroup = new $d77b025aa58d633c$var$Group({
            name: "seriesRoot",
            isVirtual: true
        });
        this.axes = {
            ["x" /* X */ ]: void 0,
            ["y" /* Y */ ]: void 0
        };
        this.directions = [
            "x" /* X */ ,
            "y" /* Y */ 
        ];
        // Flag to determine if we should recalculate node data.
        this.nodeDataRefresh = true;
        this.moduleMap = new $d77b025aa58d633c$var$ModuleMap();
        this._declarationOrder = -1;
        this.seriesListeners = new $d77b025aa58d633c$var$Listeners();
        const { moduleCtx: moduleCtx, pickModes: pickModes = [
            1 /* NEAREST_BY_MAIN_AXIS_FIRST */ 
        ], directionKeys: directionKeys = {}, directionNames: directionNames = {}, contentGroupVirtual: contentGroupVirtual = true, canHaveAxes: canHaveAxes = false } = seriesOpts;
        this.ctx = moduleCtx;
        this.directionKeys = directionKeys;
        this.directionNames = directionNames;
        this.canHaveAxes = canHaveAxes;
        this.contentGroup = this.rootGroup.appendChild(new $d77b025aa58d633c$var$Group({
            name: `${this.internalId}-content`,
            isVirtual: contentGroupVirtual,
            zIndex: 4 /* SERIES_LAYER_ZINDEX */ ,
            zIndexSubOrder: this.getGroupZIndexSubOrder("data")
        }));
        this.highlightGroup = new $d77b025aa58d633c$var$Group({
            name: `${this.internalId}-highlight`,
            isVirtual: contentGroupVirtual,
            zIndex: 4 /* SERIES_LAYER_ZINDEX */ ,
            zIndexSubOrder: this.getGroupZIndexSubOrder("highlight")
        });
        this.highlightNode = this.highlightGroup.appendChild(new $d77b025aa58d633c$var$Group({
            name: "highlightNode",
            zIndex: 0
        }));
        this.highlightLabel = this.highlightGroup.appendChild(new $d77b025aa58d633c$var$Group({
            name: "highlightLabel",
            zIndex: 10
        }));
        this.pickModes = pickModes;
        this.labelGroup = this.rootGroup.appendChild(new $d77b025aa58d633c$var$Group({
            name: `${this.internalId}-series-labels`,
            zIndex: 8 /* SERIES_LABEL_ZINDEX */ 
        }));
        this.annotationGroup = new $d77b025aa58d633c$var$Group({
            name: `${this.id}-annotation`,
            isVirtual: contentGroupVirtual,
            zIndex: 4 /* SERIES_LAYER_ZINDEX */ ,
            zIndexSubOrder: this.getGroupZIndexSubOrder("annotation")
        });
    }
    get id() {
        var _a, _b;
        return (_b = (_a = this.properties) == null ? void 0 : _a.id) != null ? _b : this.internalId;
    }
    get type() {
        var _a;
        return (_a = this.constructor.type) != null ? _a : "";
    }
    get data() {
        var _a;
        return (_a = this._data) != null ? _a : this._chartData;
    }
    set visible(value) {
        this.properties.visible = value;
        this.visibleChanged();
    }
    get visible() {
        return this.properties.visible;
    }
    get hasData() {
        return this.data != null && this.data.length > 0;
    }
    get tooltipEnabled() {
        var _a, _b;
        return (_b = (_a = this.properties.tooltip) == null ? void 0 : _a.enabled) != null ? _b : false;
    }
    onDataChange() {
        this.nodeDataRefresh = true;
    }
    setOptionsData(input) {
        this._data = input;
        this.onDataChange();
    }
    setChartData(input) {
        this._chartData = input;
        if (this.data === input) this.onDataChange();
    }
    onSeriesGroupingChange(prev, next) {
        const { internalId: internalId, type: type, visible: visible } = this;
        if (prev) this.ctx.seriesStateManager.deregisterSeries({
            id: internalId,
            type: type
        });
        if (next) this.ctx.seriesStateManager.registerSeries({
            id: internalId,
            type: type,
            visible: visible,
            seriesGrouping: next
        });
        this.fireEvent(new $d77b025aa58d633c$var$SeriesGroupingChangedEvent(this, next, prev));
    }
    getBandScalePadding() {
        return {
            inner: 1,
            outer: 0
        };
    }
    getGroupZIndexSubOrder(type, subIndex = 0) {
        let mainAdjust = 0;
        switch(type){
            case "data":
            case "paths":
                break;
            case "labels":
                mainAdjust += 2e4;
                break;
            case "marker":
                mainAdjust += 1e4;
                break;
            case "highlight":
                subIndex += 15e3;
                break;
            case "annotation":
                mainAdjust += 15e3;
                break;
        }
        const main = ()=>this._declarationOrder + mainAdjust;
        return [
            main,
            subIndex
        ];
    }
    addListener(type, listener) {
        return this.seriesListeners.addListener(type, listener);
    }
    dispatch(type, event) {
        this.seriesListeners.dispatch(type, event);
    }
    addChartEventListeners() {
        return;
    }
    destroy() {
        this.destroyFns.forEach((f)=>f());
        this.destroyFns = [];
        this.ctx.seriesStateManager.deregisterSeries(this);
    }
    getDirectionValues(direction, properties) {
        const resolvedDirection = this.resolveKeyDirection(direction);
        const keys = properties == null ? void 0 : properties[resolvedDirection];
        const values = [];
        if (!keys) return values;
        const addValues = (...items)=>{
            for (const value of items){
                if (Array.isArray(value)) addValues(...value);
                else if (typeof value === "object") addValues(...Object.values(value));
                else values.push(value);
            }
        };
        addValues(...keys.map((key)=>this.properties[key]));
        return values;
    }
    getKeys(direction) {
        return this.getDirectionValues(direction, this.directionKeys);
    }
    getKeyProperties(direction) {
        var _a;
        return (_a = this.directionKeys[this.resolveKeyDirection(direction)]) != null ? _a : [];
    }
    getNames(direction) {
        return this.getDirectionValues(direction, this.directionNames);
    }
    resolveKeyDirection(direction) {
        return direction;
    }
    // The union of the series domain ('community') and series-option domains ('enterprise').
    getDomain(direction) {
        const seriesDomain = this.getSeriesDomain(direction);
        const moduleDomains = this.moduleMap.mapModules((module)=>module.getDomain(direction));
        return seriesDomain.concat(moduleDomains.flat());
    }
    // Indicate that something external changed and we should recalculate nodeData.
    markNodeDataDirty() {
        this.nodeDataRefresh = true;
    }
    visibleChanged() {
        this.ctx.seriesStateManager.registerSeries(this);
    }
    getOpacity() {
        const defaultOpacity = 1;
        const { dimOpacity: dimOpacity = 1, enabled: enabled = true } = this.properties.highlightStyle.series;
        if (!enabled || dimOpacity === defaultOpacity) return defaultOpacity;
        switch(this.isItemIdHighlighted()){
            case 0 /* None */ :
            case 1 /* This */ :
                return defaultOpacity;
            case 2 /* Other */ :
            default:
                return dimOpacity;
        }
    }
    getStrokeWidth(defaultStrokeWidth) {
        const { strokeWidth: strokeWidth, enabled: enabled = true } = this.properties.highlightStyle.series;
        if (!enabled || strokeWidth === void 0) return defaultStrokeWidth;
        switch(this.isItemIdHighlighted()){
            case 1 /* This */ :
                return strokeWidth;
            case 0 /* None */ :
            case 2 /* Other */ :
                return defaultStrokeWidth;
        }
    }
    isItemIdHighlighted() {
        var _a, _b;
        const series = (_b = (_a = this.ctx.highlightManager) == null ? void 0 : _a.getActiveHighlight()) == null ? void 0 : _b.series;
        if (series == null) return 0 /* None */ ;
        if (series !== this) return 2 /* Other */ ;
        return 1 /* This */ ;
    }
    getModuleTooltipParams() {
        return this.moduleMap.mapModules((module)=>module.getTooltipParams()).reduce((total, current)=>Object.assign(total, current), {});
    }
    pickNode(point, limitPickModes) {
        const { pickModes: pickModes, visible: visible, rootGroup: rootGroup } = this;
        if (!visible || !rootGroup.visible) return;
        for (const pickMode of pickModes){
            if (limitPickModes && !limitPickModes.includes(pickMode)) continue;
            let match;
            switch(pickMode){
                case 0 /* EXACT_SHAPE_MATCH */ :
                    match = this.pickNodeExactShape(point);
                    break;
                case 1 /* NEAREST_BY_MAIN_AXIS_FIRST */ :
                case 2 /* NEAREST_BY_MAIN_CATEGORY_AXIS_FIRST */ :
                    match = this.pickNodeMainAxisFirst(point, pickMode === 2 /* NEAREST_BY_MAIN_CATEGORY_AXIS_FIRST */ );
                    break;
                case 3 /* NEAREST_NODE */ :
                    match = this.pickNodeClosestDatum(point);
                    break;
            }
            if (match) return {
                pickMode: pickMode,
                match: match.datum,
                distance: match.distance
            };
        }
    }
    pickNodeExactShape(point) {
        const match = this.contentGroup.pickNode(point.x, point.y);
        if (match && match.datum.missing !== true) return {
            datum: match.datum,
            distance: 0
        };
        return void 0;
    }
    pickNodeClosestDatum(_point) {
        throw new Error("AG Charts - Series.pickNodeClosestDatum() not implemented");
    }
    pickNodeNearestDistantObject(point, items) {
        const match = $d77b025aa58d633c$var$nearestSquared(point.x, point.y, items);
        if (match.nearest !== void 0 && match.nearest.datum.missing !== true) return {
            datum: match.nearest.datum,
            distance: Math.sqrt(match.distanceSquared)
        };
        return void 0;
    }
    pickNodeMainAxisFirst(_point, _requireCategoryAxis) {
        throw new Error("AG Charts - Series.pickNodeMainAxisFirst() not implemented");
    }
    fireNodeClickEvent(event, datum) {
        this.fireEvent(new this.NodeEvent("nodeClick", event, datum, this));
    }
    fireNodeDoubleClickEvent(event, datum) {
        this.fireEvent(new this.NodeEvent("nodeDoubleClick", event, datum, this));
    }
    createNodeContextMenuActionEvent(event, datum) {
        return new this.NodeEvent("nodeContextMenuAction", event, datum, this);
    }
    toggleSeriesItem(itemId, enabled) {
        this.visible = enabled;
        this.nodeDataRefresh = true;
        this.dispatch("visibility-changed", {
            itemId: itemId,
            enabled: enabled
        });
    }
    isEnabled() {
        return this.visible;
    }
    getModuleMap() {
        return this.moduleMap;
    }
    createModuleContext() {
        return $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, this.ctx), {
            series: this
        });
    }
    getLabelText(label, params, defaultFormatter = String) {
        var _a;
        if (label.formatter) return (_a = this.ctx.callbackCache.call(label.formatter, $d77b025aa58d633c$var$__spreadValues({
            seriesId: this.id
        }, params))) != null ? _a : defaultFormatter(params.value);
        return defaultFormatter(params.value);
    }
    getMarkerStyle(marker, params, defaultStyle = marker.getStyle()) {
        var _a, _b;
        const defaultSize = {
            size: (_b = (_a = params.datum.point) == null ? void 0 : _a.size) != null ? _b : 0
        };
        const markerStyle = $d77b025aa58d633c$var$mergeDefaults(defaultSize, defaultStyle);
        if (marker.formatter) {
            const style = this.ctx.callbackCache.call(marker.formatter, $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues($d77b025aa58d633c$var$__spreadValues({
                seriesId: this.id
            }, markerStyle), params), {
                datum: params.datum.datum
            }));
            return $d77b025aa58d633c$var$mergeDefaults(style, markerStyle);
        }
        return markerStyle;
    }
    updateMarkerStyle(markerNode, marker, params, defaultStyle = marker.getStyle(), { applyTranslation: applyTranslation = true } = {}) {
        const { point: point } = params.datum;
        const activeStyle = this.getMarkerStyle(marker, params, defaultStyle);
        const visible = this.visible && activeStyle.size > 0 && point && !isNaN(point.x) && !isNaN(point.y);
        if (applyTranslation) markerNode.setProperties($d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({
            visible: visible
        }, activeStyle), {
            translationX: point == null ? void 0 : point.x,
            translationY: point == null ? void 0 : point.y
        }));
        else markerNode.setProperties($d77b025aa58d633c$var$__spreadValues({
            visible: visible
        }, activeStyle));
        if (typeof marker.shape === "function" && !markerNode.dirtyPath) {
            markerNode.path.clear(true);
            markerNode.updatePath();
            markerNode.checkPathDirty();
        }
    }
    getMinRects(_width, _height) {
        return;
    }
    get nodeDataDependencies() {
        var _a;
        return (_a = this._nodeDataDependencies) != null ? _a : {
            seriesRectWidth: NaN,
            seriesRectHeight: NaN
        };
    }
    checkResize(newSeriesRect) {
        const { width: seriesRectWidth, height: seriesRectHeight } = newSeriesRect != null ? newSeriesRect : {
            width: NaN,
            height: NaN
        };
        const newNodeDataDependencies = newSeriesRect ? {
            seriesRectWidth: seriesRectWidth,
            seriesRectHeight: seriesRectHeight
        } : void 0;
        const resize = $d77b025aa58d633c$var$jsonDiff(this.nodeDataDependencies, newNodeDataDependencies) != null;
        if (resize) {
            this._nodeDataDependencies = newNodeDataDependencies;
            this.markNodeDataDirty();
        }
        return resize;
    }
    pickFocus(_opts) {
        return void 0;
    }
};
$d77b025aa58d633c$var$Series.highlightedZIndex = 1e12;
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ActionOnSet({
        changeValue: function(newVal, oldVal) {
            this.onSeriesGroupingChange(oldVal, newVal);
        }
    })
], $d77b025aa58d633c$var$Series.prototype, "seriesGrouping", 2);
// packages/ag-charts-community/src/chart/series/seriesLayerManager.ts
var $d77b025aa58d633c$var$SERIES_THRESHOLD_FOR_AGGRESSIVE_LAYER_REDUCTION = 30;
var $d77b025aa58d633c$var$SeriesLayerManager = class {
    constructor(seriesRoot, highlightRoot, annotationRoot){
        this.seriesRoot = seriesRoot;
        this.highlightRoot = highlightRoot;
        this.annotationRoot = annotationRoot;
        this.groups = {};
        this.series = {};
        this.expectedSeriesCount = 1;
        this.mode = "normal";
    }
    setSeriesCount(count) {
        this.expectedSeriesCount = count;
    }
    requestGroup(seriesConfig) {
        var _a, _b, _c, _d;
        const { internalId: internalId, type: type, rootGroup: seriesRootGroup, highlightGroup: seriesHighlightGroup, annotationGroup: seriesAnnotationGroup, seriesGrouping: seriesGrouping } = seriesConfig;
        const { groupIndex: groupIndex = internalId } = seriesGrouping != null ? seriesGrouping : {};
        if (this.series[internalId] != null) throw new Error(`AG Charts - series already has an allocated layer: ${this.series[internalId]}`);
        if (Object.keys(this.series).length === 0) this.mode = this.expectedSeriesCount >= $d77b025aa58d633c$var$SERIES_THRESHOLD_FOR_AGGRESSIVE_LAYER_REDUCTION ? "aggressive-grouping" : "normal";
        (_b = (_a = this.groups)[type]) != null ? _b : _a[type] = {};
        const lookupIndex = this.lookupIdx(groupIndex);
        let groupInfo = this.groups[type][lookupIndex];
        if (!groupInfo) groupInfo = (_d = (_c = this.groups[type])[lookupIndex]) != null ? _d : _c[lookupIndex] = {
            seriesIds: [],
            group: this.seriesRoot.appendChild(new $d77b025aa58d633c$var$Group({
                name: `${type}-content`,
                layer: true,
                zIndex: 4 /* SERIES_LAYER_ZINDEX */ ,
                zIndexSubOrder: seriesConfig.getGroupZIndexSubOrder("data")
            })),
            highlight: this.highlightRoot.appendChild(new $d77b025aa58d633c$var$Group({
                name: `${type}-highlight`,
                zIndex: 4 /* SERIES_LAYER_ZINDEX */ ,
                zIndexSubOrder: seriesConfig.getGroupZIndexSubOrder("highlight")
            })),
            annotation: this.annotationRoot.appendChild(new $d77b025aa58d633c$var$Group({
                name: `${type}-annotation`,
                zIndex: 4 /* SERIES_LAYER_ZINDEX */ ,
                zIndexSubOrder: seriesConfig.getGroupZIndexSubOrder("annotation")
            }))
        };
        this.series[internalId] = {
            layerState: groupInfo,
            seriesConfig: seriesConfig
        };
        groupInfo.seriesIds.push(internalId);
        groupInfo.group.appendChild(seriesRootGroup);
        groupInfo.highlight.appendChild(seriesHighlightGroup);
        groupInfo.annotation.appendChild(seriesAnnotationGroup);
        return groupInfo.group;
    }
    changeGroup(seriesConfig) {
        var _a, _b;
        const { internalId: internalId, seriesGrouping: seriesGrouping, type: type, rootGroup: rootGroup, highlightGroup: highlightGroup, annotationGroup: annotationGroup, oldGrouping: oldGrouping } = seriesConfig;
        const { groupIndex: groupIndex = internalId } = seriesGrouping != null ? seriesGrouping : {};
        if ((_b = (_a = this.groups[type]) == null ? void 0 : _a[groupIndex]) == null ? void 0 : _b.seriesIds.includes(internalId)) return;
        if (this.series[internalId] != null) this.releaseGroup({
            internalId: internalId,
            seriesGrouping: oldGrouping,
            type: type,
            rootGroup: rootGroup,
            highlightGroup: highlightGroup,
            annotationGroup: annotationGroup
        });
        this.requestGroup(seriesConfig);
    }
    releaseGroup(seriesConfig) {
        var _a, _b, _c, _d, _e;
        const { internalId: internalId, seriesGrouping: seriesGrouping, rootGroup: rootGroup, highlightGroup: highlightGroup, annotationGroup: annotationGroup, type: type } = seriesConfig;
        const { groupIndex: groupIndex = internalId } = seriesGrouping != null ? seriesGrouping : {};
        if (this.series[internalId] == null) throw new Error(`AG Charts - series doesn't have an allocated layer: ${internalId}`);
        const lookupIndex = this.lookupIdx(groupIndex);
        const groupInfo = (_c = (_a = this.groups[type]) == null ? void 0 : _a[lookupIndex]) != null ? _c : (_b = this.series[internalId]) == null ? void 0 : _b.layerState;
        if (groupInfo) {
            groupInfo.seriesIds = groupInfo.seriesIds.filter((v)=>v !== internalId);
            groupInfo.group.removeChild(rootGroup);
            groupInfo.highlight.removeChild(highlightGroup);
            groupInfo.annotation.removeChild(annotationGroup);
        }
        if ((groupInfo == null ? void 0 : groupInfo.seriesIds.length) === 0) {
            this.seriesRoot.removeChild(groupInfo.group);
            this.highlightRoot.removeChild(groupInfo.highlight);
            this.annotationRoot.removeChild(groupInfo.annotation);
            delete this.groups[type][lookupIndex];
            delete this.groups[type][internalId];
        } else if ((groupInfo == null ? void 0 : groupInfo.seriesIds.length) > 0) {
            const leadSeriesConfig = (_e = this.series[(_d = groupInfo == null ? void 0 : groupInfo.seriesIds) == null ? void 0 : _d[0]]) == null ? void 0 : _e.seriesConfig;
            groupInfo.group.zIndexSubOrder = leadSeriesConfig == null ? void 0 : leadSeriesConfig.getGroupZIndexSubOrder("data");
            groupInfo.highlight.zIndexSubOrder = leadSeriesConfig == null ? void 0 : leadSeriesConfig.getGroupZIndexSubOrder("highlight");
            groupInfo.annotation.zIndexSubOrder = leadSeriesConfig == null ? void 0 : leadSeriesConfig.getGroupZIndexSubOrder("annotation");
        }
        delete this.series[internalId];
    }
    lookupIdx(groupIndex) {
        if (this.mode === "normal") return groupIndex;
        if (typeof groupIndex === "string") {
            groupIndex = Number(groupIndex.split("-").slice(-1)[0]);
            if (!groupIndex) return 0;
        }
        return Math.floor($d77b025aa58d633c$var$clamp(0, groupIndex / this.expectedSeriesCount, 1) * $d77b025aa58d633c$var$SERIES_THRESHOLD_FOR_AGGRESSIVE_LAYER_REDUCTION);
    }
    destroy() {
        for (const groups of Object.values(this.groups))for (const groupInfo of Object.values(groups)){
            this.seriesRoot.removeChild(groupInfo.group);
            this.highlightRoot.removeChild(groupInfo.highlight);
            this.annotationRoot.removeChild(groupInfo.annotation);
        }
        this.groups = {};
        this.series = {};
    }
};
// packages/ag-charts-community/src/chart/update/baseLayoutProcessor.ts
var $d77b025aa58d633c$var$BaseLayoutProcessor = class {
    constructor(chartLike, layoutService){
        this.chartLike = chartLike;
        this.layoutService = layoutService;
        this.destroyFns = [];
        this.destroyFns.push(// eslint-disable-next-line sonarjs/no-duplicate-string
        this.layoutService.addListener("start-layout", (e)=>this.positionPadding(e.shrinkRect)), this.layoutService.addListener("start-layout", (e)=>this.positionCaptions(e.shrinkRect)));
    }
    destroy() {
        this.destroyFns.forEach((cb)=>cb());
    }
    positionPadding(shrinkRect) {
        const { padding: padding } = this.chartLike;
        shrinkRect.shrink(padding.left, "left");
        shrinkRect.shrink(padding.top, "top");
        shrinkRect.shrink(padding.right, "right");
        shrinkRect.shrink(padding.bottom, "bottom");
        return {
            shrinkRect: shrinkRect
        };
    }
    positionCaptions(shrinkRect) {
        var _a, _b;
        const { title: title, subtitle: subtitle, footnote: footnote } = this.chartLike;
        const newShrinkRect = shrinkRect.clone();
        const updateCaption = (caption)=>{
            var _a2;
            const defaultCaptionHeight = shrinkRect.height / 10;
            const captionLineHeight = (_a2 = caption.lineHeight) != null ? _a2 : caption.fontSize * $d77b025aa58d633c$var$Text.defaultLineHeightRatio;
            const maxWidth = shrinkRect.width;
            const maxHeight = Math.max(captionLineHeight, defaultCaptionHeight);
            caption.computeTextWrap(maxWidth, maxHeight);
        };
        const computeX = (align)=>{
            if (align === "left") return newShrinkRect.x;
            else if (align === "right") return newShrinkRect.x + newShrinkRect.width;
            else if (align !== "center") $d77b025aa58d633c$var$Logger.error(`invalid textAlign value: ${align}`);
            return newShrinkRect.x + newShrinkRect.width / 2;
        };
        const positionTopAndShrinkBBox = (caption, spacing)=>{
            const baseY = newShrinkRect.y;
            caption.node.x = computeX(caption.textAlign);
            caption.node.y = baseY;
            caption.node.textBaseline = "top";
            updateCaption(caption);
            const bbox = caption.node.computeBBox();
            const bboxHeight = Math.ceil(bbox.y - baseY + bbox.height + spacing);
            newShrinkRect.shrink(bboxHeight, "top");
        };
        const positionBottomAndShrinkBBox = (caption, spacing)=>{
            const baseY = newShrinkRect.y + newShrinkRect.height;
            caption.node.x = computeX(caption.textAlign);
            caption.node.y = baseY;
            caption.node.textBaseline = "bottom";
            updateCaption(caption);
            const bbox = caption.node.computeBBox();
            const bboxHeight = Math.ceil(baseY - bbox.y + spacing);
            newShrinkRect.shrink(bboxHeight, "bottom");
        };
        title.node.visible = title.enabled;
        subtitle.node.visible = subtitle.enabled;
        footnote.node.visible = footnote.enabled;
        if (title.enabled) {
            const { spacing: spacing = subtitle.enabled ? $d77b025aa58d633c$var$Caption.SMALL_PADDING : $d77b025aa58d633c$var$Caption.LARGE_PADDING } = title;
            positionTopAndShrinkBBox(title, spacing);
        }
        if (subtitle.enabled) positionTopAndShrinkBBox(subtitle, (_a = subtitle.spacing) != null ? _a : 0);
        if (footnote.enabled) positionBottomAndShrinkBBox(footnote, (_b = footnote.spacing) != null ? _b : 0);
        return {
            shrinkRect: newShrinkRect
        };
    }
};
// packages/ag-charts-community/src/chart/update/dataWindowProcessor.ts
var $d77b025aa58d633c$var$DataWindowProcessor = class {
    constructor(chart, dataService, updateService, zoomManager){
        this.chart = chart;
        this.dataService = dataService;
        this.updateService = updateService;
        this.zoomManager = zoomManager;
        this.dirtyZoom = false;
        this.dirtyDataSource = false;
        this.lastAxisZooms = /* @__PURE__ */ new Map();
        this.destroyFns = [];
        this.destroyFns.push(this.dataService.addListener("data-source-change", ()=>this.onDataSourceChange()), this.dataService.addListener("data-load", ()=>this.onDataLoad()), this.dataService.addListener("data-error", ()=>this.onDataError()), this.updateService.addListener("update-complete", ()=>this.onUpdateComplete()), this.zoomManager.addListener("zoom-change", ()=>this.onZoomChange()));
    }
    destroy() {
        this.destroyFns.forEach((cb)=>cb());
    }
    onDataLoad() {
        this.updateService.update(1 /* UPDATE_DATA */ );
    }
    onDataError() {
        this.updateService.update(3 /* PERFORM_LAYOUT */ );
    }
    onDataSourceChange() {
        this.dirtyDataSource = true;
    }
    onUpdateComplete() {
        if (!this.dirtyZoom && !this.dirtyDataSource) return;
        this.updateWindow().catch((e)=>$d77b025aa58d633c$var$Logger.errorOnce(e));
    }
    onZoomChange() {
        this.dirtyZoom = true;
    }
    updateWindow() {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            if (!this.dataService.isLazy()) return;
            const axis = this.getValidAxis();
            let window2;
            let shouldRefresh = true;
            if (axis) {
                const zoom2 = this.zoomManager.getAxisZoom(axis.id);
                window2 = this.getAxisWindow(axis, zoom2);
                shouldRefresh = this.shouldRefresh(axis, zoom2);
            }
            this.dirtyZoom = false;
            this.dirtyDataSource = false;
            if (!shouldRefresh) return;
            this.dataService.load({
                windowStart: window2 == null ? void 0 : window2.min,
                windowEnd: window2 == null ? void 0 : window2.max
            });
        });
    }
    getValidAxis() {
        return this.chart.axes.find((axis)=>axis.type === "time");
    }
    shouldRefresh(axis, zoom2) {
        if (this.dirtyDataSource) return true;
        if (!this.dirtyZoom) return false;
        const lastZoom = this.lastAxisZooms.get(axis.id);
        if (lastZoom && zoom2.min === lastZoom.min && zoom2.max === lastZoom.max) return false;
        this.lastAxisZooms.set(axis.id, zoom2);
        return true;
    }
    getAxisWindow(axis, zoom2) {
        var _a, _b;
        const domain = (_b = (_a = axis.scale).getDomain) == null ? void 0 : _b.call(_a);
        if (!zoom2 || !domain || domain.length === 0 || isNaN(Number(domain[0]))) return;
        const diff2 = Number(domain[1]) - Number(domain[0]);
        const min = new Date(Number(domain[0]) + diff2 * zoom2.min);
        const max = new Date(Number(domain[0]) + diff2 * zoom2.max);
        return {
            min: min,
            max: max
        };
    }
};
// packages/ag-charts-community/src/chart/update/overlaysProcessor.ts
var $d77b025aa58d633c$var$OverlaysProcessor = class {
    constructor(chartLike, overlays, dataService, layoutService, animationManager){
        this.chartLike = chartLike;
        this.overlays = overlays;
        this.dataService = dataService;
        this.layoutService = layoutService;
        this.animationManager = animationManager;
        this.destroyFns = [];
        this.destroyFns.push(this.layoutService.addListener("layout-complete", (e)=>this.onLayoutComplete(e)));
    }
    destroy() {
        this.destroyFns.forEach((cb)=>cb());
    }
    onLayoutComplete({ series: { rect: rect } }) {
        const isLoading = this.dataService.isLoading();
        const hasData = this.chartLike.series.some((s)=>s.hasData);
        const anySeriesVisible = this.chartLike.series.some((s)=>s.visible);
        this.toggleOverlay(this.overlays.loading, rect, isLoading);
        this.toggleOverlay(this.overlays.noData, rect, !isLoading && !hasData);
        this.toggleOverlay(this.overlays.noVisibleSeries, rect, hasData && !anySeriesVisible);
    }
    toggleOverlay(overlay, seriesRect, visible) {
        if (visible) {
            const element2 = overlay.getElement(this.animationManager, seriesRect);
            this.chartLike.element.append(element2);
        } else overlay.removeElement(this.animationManager);
    }
};
// packages/ag-charts-community/src/chart/chart.ts
var $d77b025aa58d633c$var$debug = $d77b025aa58d633c$var$Debug.create(true, "opts");
var $d77b025aa58d633c$var$SeriesArea = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.padding = new $d77b025aa58d633c$var$Padding(0);
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN, {
        optional: true
    })
], $d77b025aa58d633c$var$SeriesArea.prototype, "clip", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$SeriesArea.prototype, "padding", 2);
var $d77b025aa58d633c$var$_Chart = class _Chart extends $d77b025aa58d633c$var$Observable {
    constructor(options, resources){
        var _a, _b, _c;
        super();
        this.id = $d77b025aa58d633c$var$createId(this);
        this.seriesRoot = new $d77b025aa58d633c$var$Group({
            name: `${this.id}-series-root`
        });
        this.highlightRoot = new $d77b025aa58d633c$var$Group({
            name: `${this.id}-highlight-root`,
            layer: true,
            zIndex: 5 /* SERIES_HIGHLIGHT_ZINDEX */ ,
            nonEmptyChildDerivedZIndex: true
        });
        this.annotationRoot = new $d77b025aa58d633c$var$Group({
            name: `${this.id}-annotation-root`,
            layer: true,
            zIndex: 10 /* SERIES_ANNOTATION_ZINDEX */ 
        });
        this.debug = $d77b025aa58d633c$var$Debug.create();
        this.extraDebugStats = {};
        this.data = [];
        this._firstAutoSize = true;
        this.padding = new $d77b025aa58d633c$var$Padding(20);
        this.seriesArea = new $d77b025aa58d633c$var$SeriesArea();
        this.title = new $d77b025aa58d633c$var$Caption();
        this.subtitle = new $d77b025aa58d633c$var$Caption();
        this.footnote = new $d77b025aa58d633c$var$Caption();
        this.keyboard = new $d77b025aa58d633c$var$Keyboard();
        this.mode = "standalone";
        this.destroyed = false;
        this._skipSync = false;
        this._destroyFns = [];
        this.chartAnimationPhase = "initial";
        this.modulesManager = new $d77b025aa58d633c$var$ModulesManager();
        // FIXME: zoomManager should be owned by ctx, but it can't because it is used by CartesianChart.onAxisChange before ctx is initialised
        this.zoomManager = new $d77b025aa58d633c$var$ZoomManager();
        this.processors = [];
        this.processedOptions = {};
        this.userOptions = {};
        this.queuedUserOptions = [];
        this._pendingFactoryUpdatesCount = 0;
        this._performUpdateNoRenderCount = 0;
        this._performUpdateSkipAnimations = false;
        this.performUpdateType = 7 /* NONE */ ;
        this.updateShortcutCount = 0;
        this.seriesToUpdate = /* @__PURE__ */ new Set();
        this.updateMutex = new $d77b025aa58d633c$var$Mutex();
        this.updateRequestors = {};
        this.performUpdateTrigger = $d77b025aa58d633c$var$debouncedCallback((_0)=>$d77b025aa58d633c$var$__async(this, [
                _0
            ], function*({ count: count }) {
                if (this.destroyed) return;
                this.updateMutex.acquire(()=>$d77b025aa58d633c$var$__async(this, null, function*() {
                        try {
                            yield this.performUpdate(count);
                        } catch (error) {
                            $d77b025aa58d633c$var$Logger.error("update error", error);
                        }
                    })).catch((e)=>$d77b025aa58d633c$var$Logger.errorOnce(e));
            }));
        this._performUpdateSplits = {};
        this.axes = [];
        this.series = [];
        this.focus = {
            hasFocus: false,
            series: void 0,
            seriesIndex: 0,
            datumIndex: 0,
            datum: void 0
        };
        this.pointerScheduler = $d77b025aa58d633c$var$debouncedAnimationFrame(()=>{
            if (!this.lastInteractionEvent) return;
            if (this.performUpdateType <= 4 /* SERIES_UPDATE */ ) {
                this.pointerScheduler.schedule();
                return;
            }
            this.handlePointer(this.lastInteractionEvent, false);
            this.lastInteractionEvent = void 0;
        });
        this.onSeriesNodeClick = (event)=>{
            const seriesNodeClickEvent = $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, event), {
                type: "seriesNodeClick"
            });
            Object.defineProperty(seriesNodeClickEvent, "series", {
                enumerable: false,
                // Should display the deprecation warning
                get: ()=>event.series
            });
            this.fireEvent(seriesNodeClickEvent);
        };
        this.onSeriesNodeDoubleClick = (event)=>{
            const seriesNodeDoubleClick = $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, event), {
                type: "seriesNodeDoubleClick"
            });
            this.fireEvent(seriesNodeDoubleClick);
        };
        this.seriesGroupingChanged = (event)=>{
            if (!(event instanceof $d77b025aa58d633c$var$SeriesGroupingChangedEvent)) return;
            const { series: series, seriesGrouping: seriesGrouping, oldGrouping: oldGrouping } = event;
            if (series.rootGroup.parent == null) return;
            this.seriesLayerManager.changeGroup({
                internalId: series.internalId,
                type: series.type,
                rootGroup: series.rootGroup,
                highlightGroup: series.highlightGroup,
                annotationGroup: series.annotationGroup,
                getGroupZIndexSubOrder: (type)=>series.getGroupZIndexSubOrder(type),
                seriesGrouping: seriesGrouping,
                oldGrouping: oldGrouping
            });
        };
        this.dataProcessListeners = /* @__PURE__ */ new Set();
        this.chartOptions = options;
        let scene = resources == null ? void 0 : resources.scene;
        const element2 = (_a = resources == null ? void 0 : resources.element) != null ? _a : $d77b025aa58d633c$var$createElement("div", "ag-chart-wrapper", {
            position: "relative",
            userSelect: "none"
        });
        const container = resources == null ? void 0 : resources.container;
        this.element = element2;
        const root = new $d77b025aa58d633c$var$Group({
            name: "root"
        });
        root.visible = false;
        root.append(this.seriesRoot);
        root.append(this.highlightRoot);
        root.append(this.annotationRoot);
        this.axisGridGroup = new $d77b025aa58d633c$var$Group({
            name: "Axes-Grids",
            layer: true,
            zIndex: 1 /* AXIS_GRID_ZINDEX */ 
        });
        root.appendChild(this.axisGridGroup);
        this.axisGroup = new $d77b025aa58d633c$var$Group({
            name: "Axes",
            layer: true,
            zIndex: 2 /* AXIS_ZINDEX */ 
        });
        root.appendChild(this.axisGroup);
        this.sizeMonitor = new $d77b025aa58d633c$var$SizeMonitor();
        this.sizeMonitor.observe(this.element, (size)=>this.rawResize(size));
        const { overrideDevicePixelRatio: overrideDevicePixelRatio } = options.specialOverrides;
        scene != null ? scene : scene = new $d77b025aa58d633c$var$Scene({
            pixelRatio: overrideDevicePixelRatio,
            canvasPosition: "absolute"
        });
        scene.setRoot(root).setContainer(element2);
        this.autoSize = true;
        this.tooltip = new $d77b025aa58d633c$var$Tooltip();
        this.seriesLayerManager = new $d77b025aa58d633c$var$SeriesLayerManager(this.seriesRoot, this.highlightRoot, this.annotationRoot);
        const ctx = this.ctx = new $d77b025aa58d633c$var$ChartContext(this, {
            scene: scene,
            syncManager: new $d77b025aa58d633c$var$SyncManager(this),
            element: element2,
            updateCallback: (type = 0 /* FULL */ , opts)=>this.update(type, opts),
            updateMutex: this.updateMutex
        });
        this.overlays = new $d77b025aa58d633c$var$ChartOverlays();
        (_c = (_b = this.overlays.loading).renderer) != null ? _c : _b.renderer = ()=>$d77b025aa58d633c$var$getLoadingSpinner(this.overlays.loading.getText(), ctx.animationManager.defaultDuration);
        this.processors = [
            new $d77b025aa58d633c$var$BaseLayoutProcessor(this, ctx.layoutService),
            new $d77b025aa58d633c$var$DataWindowProcessor(this, ctx.dataService, ctx.updateService, ctx.zoomManager),
            new $d77b025aa58d633c$var$OverlaysProcessor(this, this.overlays, ctx.dataService, ctx.layoutService, ctx.animationManager)
        ];
        this.highlight = new $d77b025aa58d633c$var$ChartHighlight();
        this.container = container;
        const { All: All } = $d77b025aa58d633c$var$InteractionState;
        const moduleContext = this.getModuleContext();
        const seriesRegion = ctx.regionManager.addRegion("series", this.seriesRoot, this.axisGroup);
        ctx.regionManager.addRegion("root", root);
        this._destroyFns.push(ctx.dataService.addListener("data-load", (event)=>{
            this.data = event.data;
        }), ctx.scene.attachNode(this.title.node), ctx.scene.attachNode(this.subtitle.node), ctx.scene.attachNode(this.footnote.node), this.title.registerInteraction(moduleContext, "title"), this.subtitle.registerInteraction(moduleContext, "subtitle"), this.footnote.registerInteraction(moduleContext, "footnote"), ctx.interactionManager.addListener("click", (event)=>this.onClick(event)), ctx.interactionManager.addListener("dblclick", (event)=>this.onDoubleClick(event)), seriesRegion.addListener("hover", (event)=>this.onMouseMove(event)), seriesRegion.addListener("leave", (event)=>this.onLeave(event)), seriesRegion.addListener("blur", ()=>this.onBlur()), seriesRegion.addListener("tab", (event)=>this.onTab(event)), seriesRegion.addListener("nav-vert", (event)=>this.onNavVert(event)), seriesRegion.addListener("nav-hori", (event)=>this.onNavHori(event)), seriesRegion.addListener("submit", (event)=>this.onSubmit(event)), ctx.keyNavManager.addListener("browserfocus", (event)=>this.onBrowserFocus(event)), ctx.interactionManager.addListener("page-left", ()=>this.destroy()), ctx.interactionManager.addListener("contextmenu", (event)=>this.onContextMenu(event), All), ctx.animationManager.addListener("animation-start", ()=>this.onAnimationStart()), ctx.animationManager.addListener("animation-frame", ()=>{
            this.update(6 /* SCENE_RENDER */ );
        }), ctx.highlightManager.addListener("highlight-change", (event)=>this.changeHighlightDatum(event)), ctx.zoomManager.addListener("zoom-pan-start", ()=>this.resetPointer()), ctx.zoomManager.addListener("zoom-change", ()=>{
            this.resetPointer();
            this.series.map((s)=>{
                var _a2;
                return (_a2 = s.animationState) == null ? void 0 : _a2.transition("updateData");
            });
            const skipAnimations = this.chartAnimationPhase !== "initial";
            this.update(3 /* PERFORM_LAYOUT */ , {
                forceNodeDataRefresh: true,
                skipAnimations: skipAnimations
            });
        }));
    }
    static getInstance(element2) {
        return _Chart.chartsInstances.get(element2);
    }
    /** NOTE: This is exposed for use by Integrated charts only. */ get canvasElement() {
        return this.ctx.scene.canvas.element;
    }
    /** NOTE: This is exposed for use by Integrated charts only. */ getCanvasDataURL(fileFormat) {
        return this.ctx.scene.getDataURL(fileFormat);
    }
    onAutoSizeChange(value) {
        const { style: style } = this.element;
        if (value) {
            style.display = "block";
            style.width = "100%";
            style.height = "100%";
            if (!this._lastAutoSize) return;
            this.resize(void 0, void 0, "autoSize option");
        } else {
            style.display = "inline-block";
            style.width = "auto";
            style.height = "auto";
        }
    }
    download(fileName, fileFormat) {
        this.ctx.scene.download(fileName, fileFormat);
    }
    getOptions() {
        var _a;
        return (_a = this.queuedUserOptions.at(-1)) != null ? _a : this.userOptions;
    }
    getModuleContext() {
        return this.ctx;
    }
    getAriaLabel() {
        var _a;
        const captionText = [
            this.title,
            this.subtitle,
            this.footnote
        ].filter((caption)=>caption.enabled && caption.text).map((caption)=>caption.text).join(". ");
        const nSeries = (_a = this.series.length) != null ? _a : 0;
        return `chart, ${nSeries} series, ${captionText}`;
    }
    resetAnimations() {
        this.chartAnimationPhase = "initial";
        for (const series of this.series)series.resetAnimation(this.chartAnimationPhase);
        for (const axis of this.axes)axis.resetAnimation(this.chartAnimationPhase);
        this.animationRect = void 0;
        this.ctx.animationManager.reset();
    }
    skipAnimations() {
        this.ctx.animationManager.skipCurrentBatch();
        this._performUpdateSkipAnimations = true;
    }
    destroy(opts) {
        if (this.destroyed) return;
        const keepTransferableResources = opts == null ? void 0 : opts.keepTransferableResources;
        let result;
        this.performUpdateType = 7 /* NONE */ ;
        this._destroyFns.forEach((fn)=>fn());
        this.processors.forEach((p)=>p.destroy());
        this.tooltip.destroy();
        this.overlays.destroy();
        this.sizeMonitor.unobserve(this.element);
        this.modulesManager.destroy();
        if (keepTransferableResources) {
            this.ctx.scene.strip();
            result = {
                container: this.container,
                scene: this.ctx.scene,
                element: this.element
            };
        } else {
            this.ctx.scene.destroy();
            this.container = void 0;
        }
        this.destroySeries(this.series);
        this.seriesLayerManager.destroy();
        this.axes.forEach((a)=>a.destroy());
        this.axes = [];
        this.animationRect = void 0;
        this.ctx.destroy();
        this.zoomManager.destroy();
        this.destroyed = true;
        Object.freeze(this);
        return result;
    }
    resetPointer(highlightOnly = false) {
        if (!highlightOnly) this.ctx.tooltipManager.removeTooltip(this.id);
        this.ctx.highlightManager.updateHighlight(this.id);
        this.lastInteractionEvent = void 0;
    }
    requestFactoryUpdate(cb) {
        if (this.destroyed) return;
        this._pendingFactoryUpdatesCount++;
        this.updateMutex.acquire(()=>$d77b025aa58d633c$var$__async(this, null, function*() {
                if (this.destroyed) return;
                yield cb(this);
                if (this.destroyed) return;
                this._pendingFactoryUpdatesCount--;
            })).catch((e)=>$d77b025aa58d633c$var$Logger.errorOnce(e));
    }
    update(type = 0 /* FULL */ , opts) {
        var _a, _b;
        const { forceNodeDataRefresh: forceNodeDataRefresh = false, skipAnimations: skipAnimations, seriesToUpdate: seriesToUpdate = this.series, newAnimationBatch: newAnimationBatch } = opts != null ? opts : {};
        if (forceNodeDataRefresh) this.series.forEach((series)=>series.markNodeDataDirty());
        for (const series of seriesToUpdate)this.seriesToUpdate.add(series);
        if (skipAnimations) {
            this.ctx.animationManager.skipCurrentBatch();
            this._performUpdateSkipAnimations = true;
        }
        if (newAnimationBatch && this.ctx.animationManager.isActive()) this._performUpdateSkipAnimations = true;
        this._skipSync = (_a = opts == null ? void 0 : opts.skipSync) != null ? _a : false;
        if (this.debug.check()) {
            let stack = (_b = new Error().stack) != null ? _b : "<unknown>";
            stack = stack.replace(/\([^)]*/g, "");
            this.updateRequestors[stack] = type;
        }
        if (type < this.performUpdateType) {
            this.performUpdateType = type;
            this.performUpdateTrigger.schedule(opts == null ? void 0 : opts.backOffMs);
        }
    }
    performUpdate(count) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            var _a;
            const { performUpdateType: performUpdateType, extraDebugStats: extraDebugStats, _performUpdateSplits: splits, ctx: ctx } = this;
            const seriesToUpdate = [
                ...this.seriesToUpdate
            ];
            this.performUpdateType = 7 /* NONE */ ;
            this.seriesToUpdate.clear();
            if (this.updateShortcutCount === 0 && performUpdateType < 6 /* SCENE_RENDER */ ) {
                ctx.animationManager.startBatch(this._performUpdateSkipAnimations);
                ctx.animationManager.onBatchStop(()=>this.chartAnimationPhase = "ready");
            }
            this.debug("Chart.performUpdate() - start", $d77b025aa58d633c$var$ChartUpdateType[performUpdateType]);
            let previousSplit = performance.now();
            (_a = splits.start) != null ? _a : splits.start = previousSplit;
            const updateSplits = (splitName)=>{
                var _a2;
                (_a2 = splits[splitName]) != null ? _a2 : splits[splitName] = 0;
                splits[splitName] += performance.now() - previousSplit;
                previousSplit = performance.now();
            };
            let updateDeferred = false;
            switch(performUpdateType){
                case 0 /* FULL */ :
                    this.updateDOM();
                case 1 /* UPDATE_DATA */ :
                    yield this.updateData();
                    updateSplits("\u2B07\uFE0F");
                case 2 /* PROCESS_DATA */ :
                    yield this.processData();
                    this.resetPointer(true);
                    updateSplits("\uD83C\uDFED");
                case 3 /* PERFORM_LAYOUT */ :
                    if (this.checkUpdateShortcut(3 /* PERFORM_LAYOUT */ )) break;
                    if (!this.checkFirstAutoSize(seriesToUpdate)) {
                        updateDeferred = true;
                        break;
                    }
                    yield this.processLayout();
                    updateSplits("\u2316");
                case 4 /* SERIES_UPDATE */ :
                    if (this.checkUpdateShortcut(4 /* SERIES_UPDATE */ )) break;
                    const { seriesRect: seriesRect } = this;
                    yield Promise.all(seriesToUpdate.map((series)=>series.update({
                            seriesRect: seriesRect
                        })));
                    updateSplits("\uD83E\uDD14");
                case 5 /* TOOLTIP_RECALCULATION */ :
                    if (this.checkUpdateShortcut(5 /* TOOLTIP_RECALCULATION */ )) break;
                    const tooltipMeta = ctx.tooltipManager.getTooltipMeta(this.id);
                    if (performUpdateType <= 4 /* SERIES_UPDATE */  && (tooltipMeta == null ? void 0 : tooltipMeta.lastPointerEvent) != null) this.handlePointer(tooltipMeta.lastPointerEvent, true);
                    updateSplits("\u2196");
                case 6 /* SCENE_RENDER */ :
                    if (this.checkUpdateShortcut(6 /* SCENE_RENDER */ )) break;
                    ctx.animationManager.endBatch();
                    extraDebugStats["updateShortcutCount"] = this.updateShortcutCount;
                    yield ctx.scene.render({
                        debugSplitTimes: splits,
                        extraDebugStats: extraDebugStats
                    });
                    this.ctx.regionManager.updateFocusWrapperRect();
                    this.extraDebugStats = {};
                    for(const key in splits)delete splits[key];
                case 7 /* NONE */ :
                    this.updateShortcutCount = 0;
                    this.updateRequestors = {};
                    this._performUpdateSkipAnimations = false;
                    ctx.animationManager.endBatch();
            }
            if (!updateDeferred) ctx.updateService.dispatchUpdateComplete(this.getMinRects());
            const end = performance.now();
            this.debug("Chart.performUpdate() - end", {
                chart: this,
                durationMs: Math.round((end - splits["start"]) * 100) / 100,
                count: count,
                performUpdateType: $d77b025aa58d633c$var$ChartUpdateType[performUpdateType]
            });
        });
    }
    updateThemeClassName() {
        const { element: element2, processedOptions: { theme: theme } } = this;
        const themeClassNamePrefix = "ag-charts-theme-";
        const validThemeClassNames = [
            `${themeClassNamePrefix}default`,
            `${themeClassNamePrefix}default-dark`
        ];
        let themeClassName = validThemeClassNames[0];
        let isDark = false;
        if (typeof theme === "string") {
            themeClassName = theme.replace("ag-", themeClassNamePrefix);
            isDark = theme.includes("-dark");
        } else if (typeof (theme == null ? void 0 : theme.baseTheme) === "string") {
            themeClassName = theme.baseTheme.replace("ag-", themeClassNamePrefix);
            isDark = theme.baseTheme.includes("-dark");
        }
        if (!validThemeClassNames.includes(themeClassName)) themeClassName = isDark ? validThemeClassNames[1] : validThemeClassNames[0];
        element2.classList.forEach((className)=>{
            if (className.startsWith(themeClassNamePrefix) && className !== themeClassName) element2.classList.remove(className);
        });
        element2.classList.add(themeClassName);
    }
    updateDOM() {
        this.updateThemeClassName();
        const { enabled: enabled, tabIndex: tabIndex } = this.keyboard;
        this.element.tabIndex = enabled ? tabIndex != null ? tabIndex : 0 : -1;
        $d77b025aa58d633c$var$setAttribute(this.ctx.scene.canvas.element, "role", "figure");
        $d77b025aa58d633c$var$setAttribute(this.ctx.scene.canvas.element, "aria-label", this.getAriaLabel());
    }
    checkUpdateShortcut(checkUpdateType) {
        const maxShortcuts = 3;
        if (this.updateShortcutCount > maxShortcuts) {
            $d77b025aa58d633c$var$Logger.warn(`exceeded the maximum number of simultaneous updates (${maxShortcuts + 1}), discarding changes and rendering`, this.updateRequestors);
            return false;
        }
        if (this.performUpdateType <= checkUpdateType) {
            this.updateShortcutCount++;
            return true;
        }
        return false;
    }
    checkFirstAutoSize(seriesToUpdate) {
        if (this.autoSize && !this._lastAutoSize) {
            const count = this._performUpdateNoRenderCount++;
            const backOffMs = $d77b025aa58d633c$var$__pow(count + 1, 2) * 40;
            if (count < 8) {
                this.update(3 /* PERFORM_LAYOUT */ , {
                    seriesToUpdate: seriesToUpdate,
                    backOffMs: backOffMs
                });
                this.debug("Chart.checkFirstAutoSize() - backing off until first size update", backOffMs);
                return false;
            }
            this.debug("Chart.checkFirstAutoSize() - timeout for first size update.");
        }
        this._performUpdateNoRenderCount = 0;
        return true;
    }
    onAxisChange(newValue, oldValue = []) {
        for (const axis of oldValue){
            if (newValue.includes(axis)) continue;
            axis.detachAxis(this.axisGroup, this.axisGridGroup);
            axis.destroy();
        }
        for (const axis of newValue){
            if (oldValue == null ? void 0 : oldValue.includes(axis)) continue;
            axis.attachAxis(this.axisGroup, this.axisGridGroup);
        }
    }
    onSeriesChange(newValue, oldValue) {
        var _a, _b;
        const seriesToDestroy = (_a = oldValue == null ? void 0 : oldValue.filter((series)=>!newValue.includes(series))) != null ? _a : [];
        this.destroySeries(seriesToDestroy);
        (_b = this.seriesLayerManager) == null || _b.setSeriesCount(newValue.length);
        for (const series of newValue){
            if (oldValue == null ? void 0 : oldValue.includes(series)) continue;
            if (series.rootGroup.parent == null) this.seriesLayerManager.requestGroup(series);
            const chart = this;
            series.chart = {
                get mode () {
                    return chart.mode;
                },
                get isMiniChart () {
                    return false;
                },
                get seriesRect () {
                    return chart.seriesRect;
                },
                placeLabels () {
                    return chart.placeLabels();
                }
            };
            series.resetAnimation(this.chartAnimationPhase);
            this.addSeriesListeners(series);
            series.addChartEventListeners();
        }
    }
    destroySeries(allSeries) {
        allSeries == null || allSeries.forEach((series)=>{
            series.removeEventListener("nodeClick", this.onSeriesNodeClick);
            series.removeEventListener("nodeDoubleClick", this.onSeriesNodeDoubleClick);
            series.removeEventListener("groupingChanged", this.seriesGroupingChanged);
            series.destroy();
            this.seriesLayerManager.releaseGroup(series);
            series.chart = void 0;
        });
    }
    addSeriesListeners(series) {
        if (this.hasEventListener("seriesNodeClick")) series.addEventListener("nodeClick", this.onSeriesNodeClick);
        if (this.hasEventListener("seriesNodeDoubleClick")) series.addEventListener("nodeDoubleClick", this.onSeriesNodeDoubleClick);
        series.addEventListener("groupingChanged", this.seriesGroupingChanged);
    }
    updateAllSeriesListeners() {
        this.series.forEach((series)=>{
            series.removeEventListener("nodeClick", this.onSeriesNodeClick);
            series.removeEventListener("nodeDoubleClick", this.onSeriesNodeDoubleClick);
            this.addSeriesListeners(series);
        });
    }
    assignSeriesToAxes() {
        this.axes.forEach((axis)=>{
            axis.boundSeries = this.series.filter((s)=>{
                const seriesAxis = s.axes[axis.direction];
                return seriesAxis === axis;
            });
        });
    }
    assignAxesToSeries() {
        const directionToAxesMap = $d77b025aa58d633c$var$groupBy(this.axes, (axis)=>axis.direction);
        this.series.forEach((series)=>{
            series.directions.forEach((direction)=>{
                const directionAxes = directionToAxesMap[direction];
                if (!directionAxes) {
                    $d77b025aa58d633c$var$Logger.warnOnce(`no available axis for direction [${direction}]; check series and axes configuration.`);
                    return;
                }
                const seriesKeys = series.getKeys(direction);
                const newAxis = directionAxes.find((axis)=>!axis.keys.length || seriesKeys.some((key)=>axis.keys.includes(key)));
                if (!newAxis) {
                    $d77b025aa58d633c$var$Logger.warnOnce(`no matching axis for direction [${direction}] and keys [${seriesKeys}]; check series and axes configuration.`);
                    return;
                }
                series.axes[direction] = newAxis;
            });
        });
    }
    rawResize({ width: width, height: height }) {
        var _a;
        if (!this.autoSize) return;
        width = Math.floor(width);
        height = Math.floor(height);
        if (width === 0 && height === 0) return;
        const [autoWidth = 0, authHeight = 0] = (_a = this._lastAutoSize) != null ? _a : [];
        if (autoWidth === width && authHeight === height) return;
        this._lastAutoSize = [
            width,
            height
        ];
        this.resize(void 0, void 0, "SizeMonitor");
    }
    resize(width, height, source) {
        var _a, _b, _c, _d;
        const { scene: scene, animationManager: animationManager } = this.ctx;
        width != null ? width : width = (_b = this.width) != null ? _b : this.autoSize ? (_a = this._lastAutoSize) == null ? void 0 : _a[0] : scene.canvas.width;
        height != null ? height : height = (_d = this.height) != null ? _d : this.autoSize ? (_c = this._lastAutoSize) == null ? void 0 : _c[1] : scene.canvas.height;
        this.debug(`Chart.resize() from ${source}`, {
            width: width,
            height: height,
            stack: new Error().stack
        });
        if (!width || !height || !$d77b025aa58d633c$var$isFiniteNumber(width) || !$d77b025aa58d633c$var$isFiniteNumber(height)) return;
        if (scene.resize(width, height)) {
            this.resetPointer();
            animationManager.reset();
            let skipAnimations = true;
            if (this.autoSize && this._firstAutoSize) {
                skipAnimations = false;
                this._firstAutoSize = false;
            }
            this.update(3 /* PERFORM_LAYOUT */ , {
                forceNodeDataRefresh: true,
                skipAnimations: skipAnimations
            });
        }
    }
    updateData() {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            this.series.forEach((s)=>s.setChartData(this.data));
            const modulePromises = this.modulesManager.mapModules((m)=>{
                var _a;
                return (_a = m.updateData) == null ? void 0 : _a.call(m, {
                    data: this.data
                });
            });
            yield Promise.all(modulePromises);
        });
    }
    processData() {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            if (this.series.some((s)=>s.canHaveAxes)) {
                this.assignAxesToSeries();
                const syncModule = this.modulesManager.getModule("sync");
                if (syncModule == null ? void 0 : syncModule.enabled) syncModule.syncAxes(this._skipSync);
                else this.assignSeriesToAxes();
            }
            const dataController = new $d77b025aa58d633c$var$DataController(this.mode);
            const seriesPromises = this.series.map((s)=>s.processData(dataController));
            const modulePromises = this.modulesManager.mapModules((m)=>{
                var _a;
                return (_a = m.processData) == null ? void 0 : _a.call(m, {
                    dataController: dataController
                });
            });
            dataController.execute();
            yield Promise.all([
                ...seriesPromises,
                ...modulePromises
            ]);
            for (const { legendType: legendType, legend: legend } of this.modulesManager.legends())legend.data = this.getLegendData(legendType, this.mode !== "integrated");
            this.dataProcessListeners.forEach((resolve)=>resolve());
            this.dataProcessListeners.clear();
        });
    }
    placeLabels() {
        const visibleSeries = [];
        const data = [];
        for (const series of this.series){
            if (!series.visible) continue;
            const labelData = series.getLabelData();
            if ($d77b025aa58d633c$var$isPointLabelDatum(labelData == null ? void 0 : labelData[0])) {
                data.push(labelData);
                visibleSeries.push(series);
            }
        }
        const { seriesRect: seriesRect } = this;
        const { top: top, right: right, bottom: bottom, left: left } = this.seriesArea.padding;
        const labels = seriesRect && data.length > 0 ? $d77b025aa58d633c$var$placeLabels(data, {
            x: -left,
            y: -top,
            width: seriesRect.width + left + right,
            height: seriesRect.height + top + bottom
        }) : [];
        return new Map(labels.map((l, i)=>[
                visibleSeries[i],
                l
            ]));
    }
    getLegendData(legendType, warnConflicts) {
        var _a, _b, _c;
        const legendData = this.series.filter((s)=>s.properties.showInLegend).flatMap((s)=>s.getLegendData(legendType));
        const isCategoryLegendData = (data)=>data.every((d)=>d.legendType === "category");
        if (warnConflicts && isCategoryLegendData(legendData)) {
            const seriesMarkerFills = {};
            const seriesTypeMap = new Map(this.series.map((s)=>[
                    s.id,
                    s.type
                ]));
            for (const { seriesId: seriesId, marker: marker, label: label } of legendData){
                if (marker.fill == null) continue;
                const seriesType = seriesTypeMap.get(seriesId);
                const markerFill = (_a = seriesMarkerFills[seriesType]) != null ? _a : seriesMarkerFills[seriesType] = {};
                (_c = markerFill[_b = label.text]) != null ? _c : markerFill[_b] = marker.fill;
                if (markerFill[label.text] !== marker.fill) $d77b025aa58d633c$var$Logger.warnOnce(`legend item '${label.text}' has multiple fill colors, this may cause unexpected behaviour.`);
            }
        }
        return legendData;
    }
    processLayout() {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            var _a;
            const oldRect = this.animationRect;
            yield this.performLayout();
            if (oldRect && !((_a = this.animationRect) == null ? void 0 : _a.equals(oldRect))) this.ctx.animationManager.skipCurrentBatch();
            this.debug("Chart.performUpdate() - seriesRect", this.seriesRect);
        });
    }
    performLayout() {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            const { width: width, height: height } = this.ctx.scene;
            let ctx = {
                shrinkRect: new $d77b025aa58d633c$var$BBox(0, 0, width, height)
            };
            ctx = this.ctx.layoutService.dispatchPerformLayout("start-layout", ctx);
            ctx = this.ctx.layoutService.dispatchPerformLayout("before-series", ctx);
            const modulePromises = this.modulesManager.mapModules((m)=>$d77b025aa58d633c$var$__async(this, null, function*() {
                    if (m.performLayout != null) ctx = yield m.performLayout(ctx);
                }));
            yield Promise.all(modulePromises);
            return ctx.shrinkRect;
        });
    }
    // x/y are local canvas coordinates in CSS pixels, not actual pixels
    pickSeriesNode(point, exactMatchOnly, maxDistance) {
        var _a, _b;
        const start = performance.now();
        const pickModes = exactMatchOnly ? [
            0 /* EXACT_SHAPE_MATCH */ 
        ] : void 0;
        const reverseSeries = [
            ...this.series
        ].reverse();
        let result;
        for (const series of reverseSeries){
            if (!series.visible || !series.rootGroup.visible) continue;
            const { match: match, distance: distance2 } = (_a = series.pickNode(point, pickModes)) != null ? _a : {};
            if (!match || distance2 == null) continue;
            if ((!result || result.distance > distance2) && distance2 <= (maxDistance != null ? maxDistance : Infinity)) result = {
                series: series,
                distance: distance2,
                datum: match
            };
            if (distance2 === 0) break;
        }
        this.extraDebugStats["pickSeriesNode"] = Math.round(((_b = this.extraDebugStats["pickSeriesNode"]) != null ? _b : 0) + (performance.now() - start));
        return result;
    }
    onMouseMove(event) {
        this.lastInteractionEvent = event;
        this.pointerScheduler.schedule();
        this.extraDebugStats["mouseX"] = event.offsetX;
        this.extraDebugStats["mouseY"] = event.offsetY;
        this.update(6 /* SCENE_RENDER */ );
    }
    onLeave(event) {
        if (!this.tooltip.pointerLeftOntoTooltip(event)) {
            this.resetPointer();
            this.update(6 /* SCENE_RENDER */ );
            this.ctx.cursorManager.updateCursor("chart");
        }
    }
    onBrowserFocus(event) {
        if (event.delta > 0) {
            this.focus.datum = void 0;
            this.focus.series = void 0;
            this.focus.datumIndex = 0;
            this.focus.seriesIndex = 0;
        } else {
            this.focus.datum = void 0;
            this.focus.series = void 0;
            this.focus.datumIndex = Infinity;
            this.focus.seriesIndex = Infinity;
        }
    }
    onAnimationStart() {
        if (this.focus.hasFocus) this.onBlur();
    }
    onBlur() {
        this.ctx.regionManager.updateFocusIndicatorRect(void 0);
        this.resetPointer();
        this.focus.hasFocus = false;
    }
    onTab(event) {
        this.handleFocus();
        event.consume();
        this.focus.hasFocus = true;
    }
    onNavVert(event) {
        this.focus.seriesIndex += event.delta;
        this.handleFocus();
        event.consume();
    }
    onNavHori(event) {
        this.focus.datumIndex += event.delta;
        this.handleFocus(event.delta);
        event.consume();
    }
    onSubmit(event) {
        const { series: series, datum: datum } = this.focus;
        const sourceEvent = event.sourceEvent.sourceEvent;
        if (series !== void 0 && datum !== void 0) series.fireNodeClickEvent(sourceEvent, datum);
        else this.fireEvent({
            type: "click",
            event: sourceEvent
        });
    }
    onContextMenu(event) {
        this.ctx.tooltipManager.removeTooltip(this.id);
        const { Default: Default2, ContextMenu: ContextMenu } = $d77b025aa58d633c$var$InteractionState;
        if (this.ctx.interactionManager.getState() & (Default2 | ContextMenu)) this.checkSeriesNodeRange(event, ()=>{
            this.ctx.highlightManager.updateHighlight(this.id);
        });
    }
    handleFocus(datumIndexDelta) {
        this.focus.hasFocus = true;
        const overlayFocus = this.overlays.getFocusInfo();
        if (overlayFocus == null) this.handleSeriesFocus(datumIndexDelta != null ? datumIndexDelta : 0);
        else {
            this.ctx.regionManager.updateFocusIndicatorRect(overlayFocus.rect);
            this.ctx.ariaAnnouncementService.announceValue(overlayFocus.text);
        }
    }
    handleSeriesFocus(datumIndexDelta) {
        const { series: series, seriesRect: seriesRect, focus: focus } = this;
        const visibleSeries = series.filter((s)=>s.visible);
        if (visibleSeries.length === 0) return;
        focus.seriesIndex = $d77b025aa58d633c$var$clamp(0, focus.seriesIndex, visibleSeries.length - 1);
        focus.series = visibleSeries[focus.seriesIndex];
        const pick = focus.series.pickFocus({
            datumIndex: focus.datumIndex,
            datumIndexDelta: datumIndexDelta,
            seriesRect: seriesRect
        });
        if (pick === void 0) return;
        const { datum: datum, datumIndex: datumIndex } = pick;
        focus.datumIndex = datumIndex;
        focus.datum = datum;
        const keyboardEvent = $d77b025aa58d633c$var$makeKeyboardPointerEvent(this.ctx.regionManager, pick);
        if (keyboardEvent !== void 0) {
            this.lastInteractionEvent = keyboardEvent;
            const html = focus.series.getTooltipHtml(datum);
            const meta = $d77b025aa58d633c$var$TooltipManager.makeTooltipMeta(this.lastInteractionEvent, datum);
            this.ctx.highlightManager.updateHighlight(this.id, datum);
            this.ctx.tooltipManager.updateTooltip(this.id, meta, html);
            this.ctx.ariaAnnouncementService.announceValue(html.ariaLabel);
        }
    }
    static isHoverEvent(event) {
        return event !== void 0 && event.type === "hover";
    }
    handlePointer(event, redisplay) {
        if (this.ctx.interactionManager.getState() !== 16 /* Default */  || !_Chart.isHoverEvent(event)) return;
        const { lastPick: lastPick, hoverRect: hoverRect } = this;
        const { offsetX: offsetX, offsetY: offsetY } = event;
        const disablePointer = (highlightOnly = false)=>{
            if (lastPick) this.resetPointer(highlightOnly);
        };
        if (redisplay ? this.ctx.animationManager.isActive() : !(hoverRect == null ? void 0 : hoverRect.containsPoint(offsetX, offsetY))) {
            disablePointer();
            return;
        }
        this.handlePointerTooltip(event, disablePointer);
        this.handlePointerNode(event);
    }
    handlePointerTooltip(event, disablePointer) {
        const { lastPick: lastPick, tooltip: tooltip } = this;
        const { range: range3 } = tooltip;
        const { offsetX: offsetX, offsetY: offsetY } = event;
        let pixelRange;
        if ($d77b025aa58d633c$var$isFiniteNumber(range3)) pixelRange = range3;
        const pick = this.pickSeriesNode({
            x: offsetX,
            y: offsetY
        }, range3 === "exact", pixelRange);
        if (!pick) {
            this.ctx.tooltipManager.removeTooltip(this.id);
            if (this.highlight.range === "tooltip") disablePointer(true);
            return;
        }
        const isNewDatum = this.highlight.range === "node" || !lastPick || lastPick !== pick.datum;
        let html;
        if (isNewDatum) {
            html = pick.series.getTooltipHtml(pick.datum);
            if (this.highlight.range === "tooltip") this.ctx.highlightManager.updateHighlight(this.id, pick.datum);
        }
        const isPixelRange = pixelRange != null;
        const tooltipEnabled = this.tooltip.enabled && pick.series.tooltipEnabled;
        const exactlyMatched = range3 === "exact" && pick.distance === 0;
        const rangeMatched = range3 === "nearest" || isPixelRange || exactlyMatched;
        const shouldUpdateTooltip = tooltipEnabled && rangeMatched && (!isNewDatum || html !== void 0);
        const meta = $d77b025aa58d633c$var$TooltipManager.makeTooltipMeta(event, pick.datum);
        if (shouldUpdateTooltip) this.ctx.tooltipManager.updateTooltip(this.id, meta, html);
    }
    handlePointerNode(event) {
        const found = this.checkSeriesNodeRange(event, (series, datum)=>{
            if (series.hasEventListener("nodeClick") || series.hasEventListener("nodeDoubleClick")) this.ctx.cursorManager.updateCursor("chart", "pointer");
            if (this.highlight.range === "node") this.ctx.highlightManager.updateHighlight(this.id, datum);
        });
        if (!found) {
            this.ctx.cursorManager.updateCursor("chart");
            if (this.highlight.range === "node") this.ctx.highlightManager.updateHighlight(this.id);
        }
    }
    onClick(event) {
        if (this.checkSeriesNodeClick(event)) {
            this.update(4 /* SERIES_UPDATE */ );
            return;
        }
        this.fireEvent({
            type: "click",
            event: event.sourceEvent
        });
    }
    onDoubleClick(event) {
        if (this.checkSeriesNodeDoubleClick(event)) {
            this.update(4 /* SERIES_UPDATE */ );
            return;
        }
        this.fireEvent({
            type: "doubleClick",
            event: event.sourceEvent
        });
    }
    checkSeriesNodeClick(event) {
        return this.checkSeriesNodeRange(event, (series, datum)=>series.fireNodeClickEvent(event.sourceEvent, datum));
    }
    checkSeriesNodeDoubleClick(event) {
        return this.checkSeriesNodeRange(event, (series, datum)=>series.fireNodeDoubleClickEvent(event.sourceEvent, datum));
    }
    checkSeriesNodeRange(event, callback) {
        var _a;
        const nearestNode = this.pickSeriesNode({
            x: event.offsetX,
            y: event.offsetY
        }, false);
        const datum = nearestNode == null ? void 0 : nearestNode.datum;
        const nodeClickRange = datum == null ? void 0 : datum.series.properties.nodeClickRange;
        let pixelRange;
        if ($d77b025aa58d633c$var$isFiniteNumber(nodeClickRange)) pixelRange = nodeClickRange;
        let pickedNode = this.pickSeriesNode({
            x: event.offsetX,
            y: event.offsetY
        }, true);
        if (pickedNode) this.ctx.highlightManager.updatePicked(this.id, pickedNode.datum);
        else this.ctx.highlightManager.updatePicked(this.id);
        if (datum && nodeClickRange === "nearest") {
            callback(datum.series, datum);
            return true;
        }
        if (nodeClickRange !== "exact") pickedNode = this.pickSeriesNode({
            x: event.offsetX,
            y: event.offsetY
        }, false, pixelRange);
        if (!pickedNode) return false;
        const isPixelRange = pixelRange != null;
        const exactlyMatched = nodeClickRange === "exact" && pickedNode.distance === 0;
        if (isPixelRange || exactlyMatched) {
            const allMatch = event.pointerHistory === void 0 || ((_a = event.pointerHistory) == null ? void 0 : _a.every((pastEvent)=>{
                const historyPoint = {
                    x: pastEvent.offsetX,
                    y: pastEvent.offsetY
                };
                const historyNode = this.pickSeriesNode(historyPoint, false, pixelRange);
                return (historyNode == null ? void 0 : historyNode.datum) === (pickedNode == null ? void 0 : pickedNode.datum);
            }));
            if (allMatch) {
                callback(pickedNode.series, pickedNode.datum);
                return true;
            }
        }
        return false;
    }
    changeHighlightDatum(event) {
        var _a, _b;
        const seriesToUpdate = /* @__PURE__ */ new Set();
        const { series: newSeries, datum: newDatum } = (_a = event.currentHighlight) != null ? _a : {};
        const { series: lastSeries, datum: lastDatum } = (_b = event.previousHighlight) != null ? _b : {};
        if (lastSeries) seriesToUpdate.add(lastSeries);
        if (newSeries) seriesToUpdate.add(newSeries);
        if ((lastSeries == null ? void 0 : lastSeries.properties.cursor) && lastDatum) this.ctx.cursorManager.updateCursor(lastSeries.id);
        if ((newSeries == null ? void 0 : newSeries.properties.cursor) && newDatum) this.ctx.cursorManager.updateCursor(newSeries.id, newSeries.properties.cursor);
        this.lastPick = event.currentHighlight;
        const updateAll = newSeries == null || lastSeries == null;
        if (updateAll) this.update(4 /* SERIES_UPDATE */ );
        else this.update(4 /* SERIES_UPDATE */ , {
            seriesToUpdate: seriesToUpdate
        });
    }
    waitForUpdate(timeoutMs = 1e4, failOnTimeout = false) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            const start = performance.now();
            if (this._pendingFactoryUpdatesCount > 0) yield this.updateMutex.waitForClearAcquireQueue();
            while(this.performUpdateType !== 7 /* NONE */ ){
                if (performance.now() - start > timeoutMs) {
                    const message = `Chart.waitForUpdate() timeout of ${timeoutMs} reached - first chart update taking too long.`;
                    if (failOnTimeout) throw new Error(message);
                    else $d77b025aa58d633c$var$Logger.warnOnce(message);
                }
                yield $d77b025aa58d633c$var$sleep(50);
            }
            yield this.updateMutex.waitForClearAcquireQueue();
        });
    }
    waitForDataProcess(timeout) {
        return new Promise((resolve)=>{
            this.dataProcessListeners.add(resolve);
            if ($d77b025aa58d633c$var$isNumber(timeout)) setTimeout(()=>{
                if (this.dataProcessListeners.has(resolve)) {
                    this.dataProcessListeners.delete(resolve);
                    resolve();
                }
            }, timeout);
        });
    }
    getMinRects() {
        const { width: width, height: height } = this.ctx.scene;
        const minRects = this.series.map((series)=>series.getMinRects(width, height)).filter($d77b025aa58d633c$var$isDefined);
        if (minRects.length === 0) return;
        let maxWidth = 0;
        let maxHeight = 0;
        let maxVisibleWidth = 0;
        let maxVisibleHeight = 0;
        for (const { minRect: minRect2, minVisibleRect: minVisibleRect2 } of minRects){
            maxWidth = Math.max(maxWidth, minRect2.width);
            maxHeight = Math.max(maxHeight, minRect2.height);
            maxVisibleWidth = Math.max(maxVisibleWidth, minVisibleRect2.width);
            maxVisibleHeight = Math.max(maxVisibleHeight, minVisibleRect2.height);
        }
        const minRect = new $d77b025aa58d633c$var$BBox(0, 0, maxWidth, maxHeight);
        let minVisibleRect = minRect.clone();
        if (maxVisibleWidth > 0 && maxVisibleHeight > 0) minVisibleRect = new $d77b025aa58d633c$var$BBox(0, 0, maxVisibleWidth, maxVisibleHeight);
        return {
            minRect: minRect,
            minVisibleRect: minVisibleRect
        };
    }
    filterMiniChartSeries(series) {
        return series == null ? void 0 : series.filter((s)=>s.showInMiniChart !== false);
    }
    applyOptions(chartOptions) {
        var _a, _b, _c, _d, _e;
        const oldOpts = this.processedOptions;
        const deltaOptions = chartOptions.diffOptions(oldOpts);
        const userOptions = chartOptions.userOptions;
        if (deltaOptions == null) return;
        $d77b025aa58d633c$var$debug("AgChartV2.updateDelta() - applying delta", deltaOptions);
        const completeOptions = $d77b025aa58d633c$var$mergeDefaults(deltaOptions, oldOpts);
        const modulesChanged = this.applyModules(completeOptions);
        const skip = [
            "type",
            "data",
            "series",
            "listeners",
            "theme",
            "legend.listeners",
            "navigator.miniChart.series",
            "navigator.miniChart.label",
            "axes",
            "topology"
        ];
        if (deltaOptions.listeners) this.registerListeners(this, deltaOptions.listeners);
        $d77b025aa58d633c$var$jsonApply(this, deltaOptions, {
            skip: skip
        });
        let forceNodeDataRefresh = false;
        let seriesStatus = "no-op";
        if ((_a = deltaOptions.series) == null ? void 0 : _a.length) {
            seriesStatus = this.applySeries(this, deltaOptions.series, oldOpts == null ? void 0 : oldOpts.series);
            forceNodeDataRefresh = true;
        }
        if (seriesStatus === "replaced") this.resetAnimations();
        if (this.applyAxes(this, completeOptions, oldOpts, seriesStatus)) forceNodeDataRefresh = true;
        if (deltaOptions.data) this.data = deltaOptions.data;
        if (((_b = deltaOptions.legend) == null ? void 0 : _b.listeners) && this.modulesManager.isEnabled("legend")) Object.assign(this.legend.listeners, deltaOptions.legend.listeners);
        if (deltaOptions.listeners) this.updateAllSeriesListeners();
        this.chartOptions = chartOptions;
        this.processedOptions = completeOptions;
        this.userOptions = $d77b025aa58d633c$var$mergeDefaults(userOptions, this.userOptions);
        const navigatorModule = this.modulesManager.getModule("navigator");
        const zoomModule = this.modulesManager.getModule("zoom");
        if (!(navigatorModule == null ? void 0 : navigatorModule.enabled) && !(zoomModule == null ? void 0 : zoomModule.enabled)) this.ctx.zoomManager.updateZoom("chart");
        const miniChart = navigatorModule == null ? void 0 : navigatorModule.miniChart;
        const miniChartSeries = (_e = (_d = (_c = completeOptions.navigator) == null ? void 0 : _c.miniChart) == null ? void 0 : _d.series) != null ? _e : completeOptions.series;
        if ((miniChart == null ? void 0 : miniChart.enabled) === true && miniChartSeries != null) this.applyMiniChartOptions(miniChart, miniChartSeries, completeOptions, oldOpts);
        else if ((miniChart == null ? void 0 : miniChart.enabled) === false) {
            miniChart.series = [];
            miniChart.axes = [];
        }
        $d77b025aa58d633c$var$injectStyle($d77b025aa58d633c$var$styles_default, "chart");
        this.ctx.annotationManager.setAnnotationStyles(chartOptions.annotationThemes);
        forceNodeDataRefresh || (forceNodeDataRefresh = this.shouldForceNodeDataRefresh(deltaOptions, seriesStatus));
        const majorChange = forceNodeDataRefresh || modulesChanged;
        const updateType = majorChange ? 0 /* FULL */  : 3 /* PERFORM_LAYOUT */ ;
        this.maybeResetAnimations(seriesStatus);
        $d77b025aa58d633c$var$debug("AgChartV2.applyChartOptions() - update type", $d77b025aa58d633c$var$ChartUpdateType[updateType], {
            seriesStatus: seriesStatus,
            forceNodeDataRefresh: forceNodeDataRefresh
        });
        this.update(updateType, {
            forceNodeDataRefresh: forceNodeDataRefresh,
            newAnimationBatch: true
        });
    }
    maybeResetAnimations(seriesStatus) {
        if (this.mode !== "standalone") return;
        switch(seriesStatus){
            case "series-grouping-change":
            case "replaced":
                this.resetAnimations();
                break;
            default:
        }
    }
    shouldForceNodeDataRefresh(deltaOptions, seriesStatus) {
        const seriesDataUpdate = !!deltaOptions.data || seriesStatus === "data-change" || seriesStatus === "replaced";
        const legendKeys = $d77b025aa58d633c$var$legendRegistry.getKeys();
        const optionsHaveLegend = Object.values(legendKeys).some((legendKey)=>deltaOptions[legendKey] != null);
        const otherRefreshUpdate = deltaOptions.title != null && deltaOptions.subtitle != null;
        return seriesDataUpdate || optionsHaveLegend || otherRefreshUpdate;
    }
    applyMiniChartOptions(miniChart, miniChartSeries, completeOptions, oldOpts) {
        var _a, _b, _c, _d, _e;
        const oldSeries = (_c = (_b = (_a = oldOpts == null ? void 0 : oldOpts.navigator) == null ? void 0 : _a.miniChart) == null ? void 0 : _b.series) != null ? _c : oldOpts == null ? void 0 : oldOpts.series;
        const miniChartSeriesStatus = this.applySeries(miniChart, this.filterMiniChartSeries(miniChartSeries), this.filterMiniChartSeries(oldSeries));
        this.applyAxes(miniChart, completeOptions, oldOpts, miniChartSeriesStatus, [
            "axes[].tick",
            "axes[].thickness",
            "axes[].title",
            "axes[].crosshair",
            "axes[].gridLine",
            "axes[].label"
        ]);
        const axes = miniChart.axes;
        const horizontalAxis = axes.find((axis)=>axis.direction === "x" /* X */ );
        for (const axis of axes){
            axis.gridLine.enabled = false;
            axis.label.enabled = axis === horizontalAxis;
            axis.tick.enabled = false;
            axis.interactionEnabled = false;
        }
        if (horizontalAxis != null) {
            const miniChartOpts = (_d = completeOptions.navigator) == null ? void 0 : _d.miniChart;
            const labelOptions = miniChartOpts == null ? void 0 : miniChartOpts.label;
            const intervalOptions = (_e = miniChartOpts == null ? void 0 : miniChartOpts.label) == null ? void 0 : _e.interval;
            horizontalAxis.line.enabled = false;
            horizontalAxis.label.set($d77b025aa58d633c$var$without(labelOptions, [
                "interval",
                "rotation",
                "minSpacing",
                "autoRotate",
                "autoRotateAngle"
            ]));
            horizontalAxis.tick.set($d77b025aa58d633c$var$without(intervalOptions, [
                "enabled",
                "width",
                "size",
                "color",
                "interval",
                "step"
            ]));
            const step = intervalOptions == null ? void 0 : intervalOptions.step;
            if (step != null) horizontalAxis.tick.interval = step;
        }
    }
    applyModules(options) {
        var _a;
        const { type: chartType2 } = this.constructor;
        let modulesChanged = false;
        for (const module of $d77b025aa58d633c$var$moduleRegistry.byType("root", "legend")){
            const isConfigured = options[module.optionsKey] != null;
            const shouldBeEnabled = isConfigured && module.chartTypes.includes(chartType2);
            if (shouldBeEnabled === this.modulesManager.isEnabled(module)) continue;
            if (shouldBeEnabled) {
                this.modulesManager.addModule(module, (m)=>new m.instanceConstructor(this.getModuleContext()));
                if (module.type === "legend") (_a = this.modulesManager.getModule(module)) == null || _a.attachLegend(this.ctx.scene);
                this[module.optionsKey] = this.modulesManager.getModule(module);
            } else {
                this.modulesManager.removeModule(module);
                delete this[module.optionsKey];
            }
            modulesChanged = true;
        }
        return modulesChanged;
    }
    applySeries(chart, optSeries, oldOptSeries) {
        var _a;
        if (!optSeries) return "no-change";
        const matchResult = $d77b025aa58d633c$var$matchSeriesOptions(chart.series, optSeries, oldOptSeries);
        if (matchResult.status === "no-overlap") {
            $d77b025aa58d633c$var$debug(`AgChartV2.applySeries() - creating new series instances, status: ${matchResult.status}`, matchResult);
            chart.series = optSeries.map((opts)=>this.createSeries(opts));
            return "replaced";
        }
        $d77b025aa58d633c$var$debug(`AgChartV2.applySeries() - matchResult`, matchResult);
        const seriesInstances = [];
        let dataChanged = false;
        let groupingChanged = false;
        let isUpdated = false;
        for (const change of matchResult.changes){
            groupingChanged || (groupingChanged = change.status === "series-grouping");
            dataChanged || (dataChanged = ((_a = change.diff) == null ? void 0 : _a.data) != null);
            isUpdated || (isUpdated = change.status !== "no-op");
            switch(change.status){
                case "add":
                    const newSeries = this.createSeries(change.opts);
                    seriesInstances.push(newSeries);
                    $d77b025aa58d633c$var$debug(`AgChartV2.applySeries() - created new series`, newSeries);
                    break;
                case "remove":
                    $d77b025aa58d633c$var$debug(`AgChartV2.applySeries() - removing series at previous idx ${change.idx}`, change.series);
                    break;
                case "no-op":
                    seriesInstances.push(change.series);
                    $d77b025aa58d633c$var$debug(`AgChartV2.applySeries() - no change to series at previous idx ${change.idx}`, change.series);
                    break;
                case "series-grouping":
                case "update":
                default:
                    const { series: series, diff: diff2, idx: idx } = change;
                    $d77b025aa58d633c$var$debug(`AgChartV2.applySeries() - applying series diff previous idx ${idx}`, diff2, series);
                    this.applySeriesValues(series, diff2);
                    series.markNodeDataDirty();
                    seriesInstances.push(series);
            }
        }
        for(let idx = 0; idx < seriesInstances.length; idx++)seriesInstances[idx]._declarationOrder = idx;
        $d77b025aa58d633c$var$debug(`AgChartV2.applySeries() - final series instances`, seriesInstances);
        chart.series = seriesInstances;
        if (groupingChanged) return "series-grouping-change";
        if (dataChanged) return "data-change";
        return isUpdated ? "updated" : "no-op";
    }
    applyAxes(chart, options, oldOpts, seriesStatus, skip = []) {
        if (!("axes" in options) || !options.axes) return false;
        skip = [
            "axes[].type",
            ...skip
        ];
        const { axes: axes } = options;
        const forceRecreate = seriesStatus === "replaced";
        const matchingTypes = !forceRecreate && chart.axes.length === axes.length && chart.axes.every((a, i)=>a.type === axes[i].type);
        if (matchingTypes && $d77b025aa58d633c$var$isAgCartesianChartOptions(oldOpts)) {
            chart.axes.forEach((axis, index)=>{
                var _a, _b;
                const previousOpts = (_b = (_a = oldOpts.axes) == null ? void 0 : _a[index]) != null ? _b : {};
                const axisDiff = $d77b025aa58d633c$var$jsonDiff(previousOpts, axes[index]);
                $d77b025aa58d633c$var$debug(`AgChartV2.applyAxes() - applying axis diff idx ${index}`, axisDiff);
                const path = `axes[${index}]`;
                $d77b025aa58d633c$var$jsonApply(axis, axisDiff, $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, $d77b025aa58d633c$var$JSON_APPLY_PLUGINS), {
                    path: path,
                    skip: skip
                }));
            });
            return true;
        }
        $d77b025aa58d633c$var$debug(`AgChartV2.applyAxes() - creating new axes instances; seriesStatus: ${seriesStatus}`);
        chart.axes = this.createAxis(axes, skip);
        return true;
    }
    createSeries(seriesOptions) {
        const seriesInstance = $d77b025aa58d633c$var$seriesRegistry.create(seriesOptions.type, this.getModuleContext());
        this.applySeriesOptionModules(seriesInstance, seriesOptions);
        this.applySeriesValues(seriesInstance, seriesOptions);
        return seriesInstance;
    }
    applySeriesOptionModules(series, options) {
        const moduleContext = series.createModuleContext();
        const moduleMap = series.getModuleMap();
        for (const module of $d77b025aa58d633c$var$moduleRegistry.byType("series-option"))if (module.optionsKey in options && module.seriesTypes.includes(series.type)) moduleMap.addModule(module, (m)=>new m.instanceConstructor(moduleContext));
    }
    applySeriesValues(target, options) {
        const moduleMap = target.getModuleMap();
        const _a = options, { type: _, data: data, listeners: listeners, seriesGrouping: seriesGrouping, showInMiniChart: __ } = _a, seriesOptions = $d77b025aa58d633c$var$__objRest(_a, [
            "type",
            "data",
            "listeners",
            "seriesGrouping",
            "showInMiniChart"
        ]);
        for (const moduleDef of $d77b025aa58d633c$var$EXPECTED_ENTERPRISE_MODULES){
            if (moduleDef.type !== "series-option") continue;
            if (moduleDef.optionsKey in seriesOptions) {
                const module = moduleMap.getModule(moduleDef.optionsKey);
                const moduleOptions = seriesOptions[moduleDef.optionsKey];
                delete seriesOptions[moduleDef.optionsKey];
                module.properties.set(moduleOptions);
            }
        }
        target.properties.set(seriesOptions);
        if ("data" in options) target.setOptionsData(data);
        if (listeners) this.registerListeners(target, listeners);
        if ("seriesGrouping" in options) {
            if (seriesGrouping == null) target.seriesGrouping = void 0;
            else target.seriesGrouping = $d77b025aa58d633c$var$__spreadValues($d77b025aa58d633c$var$__spreadValues({}, target.seriesGrouping), seriesGrouping);
        }
    }
    createAxis(options, skip) {
        const guesser = new $d77b025aa58d633c$var$AxisPositionGuesser();
        const moduleContext = this.getModuleContext();
        for(let index = 0; index < options.length; index++){
            const axisOptions = options[index];
            const axis = $d77b025aa58d633c$var$axisRegistry.create(axisOptions.type, moduleContext);
            this.applyAxisModules(axis, axisOptions);
            $d77b025aa58d633c$var$jsonApply(axis, axisOptions, $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, $d77b025aa58d633c$var$JSON_APPLY_PLUGINS), {
                path: `axes[${index}]`,
                skip: skip
            }));
            guesser.push(axis, axisOptions);
        }
        return guesser.guessInvalidPositions();
    }
    applyAxisModules(axis, options) {
        const moduleContext = axis.createModuleContext();
        const moduleMap = axis.getModuleMap();
        for (const module of $d77b025aa58d633c$var$moduleRegistry.byType("axis-option")){
            const shouldBeEnabled = options[module.optionsKey] != null;
            if (shouldBeEnabled === moduleMap.isEnabled(module)) continue;
            if (shouldBeEnabled) {
                moduleMap.addModule(module, (m)=>new m.instanceConstructor(moduleContext));
                axis[module.optionsKey] = moduleMap.getModule(module);
            } else {
                moduleMap.removeModule(module);
                delete axis[module.optionsKey];
            }
        }
    }
    registerListeners(source, listeners) {
        source.clearEventListeners();
        for (const [property, listener] of Object.entries(listeners))if ($d77b025aa58d633c$var$isFunction(listener)) source.addEventListener(property, listener);
    }
};
$d77b025aa58d633c$var$_Chart.chartsInstances = /* @__PURE__ */ new WeakMap();
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ActionOnSet({
        newValue (value) {
            if (this.destroyed) return;
            value.setAttribute("data-ag-charts", "");
            value.appendChild(this.element);
            $d77b025aa58d633c$var$_Chart.chartsInstances.set(value, this);
        },
        oldValue (value) {
            value.removeAttribute("data-ag-charts");
            value.removeChild(this.element);
            $d77b025aa58d633c$var$_Chart.chartsInstances.delete(value);
        }
    })
], $d77b025aa58d633c$var$_Chart.prototype, "container", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ActionOnSet({
        newValue (value) {
            this.resize(value, void 0, "width option");
        }
    })
], $d77b025aa58d633c$var$_Chart.prototype, "width", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ActionOnSet({
        newValue (value) {
            this.resize(void 0, value, "height option");
        }
    })
], $d77b025aa58d633c$var$_Chart.prototype, "height", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ActionOnSet({
        newValue (value) {
            this.onAutoSizeChange(value);
        }
    }),
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN)
], $d77b025aa58d633c$var$_Chart.prototype, "autoSize", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$_Chart.prototype, "padding", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$_Chart.prototype, "seriesArea", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$_Chart.prototype, "title", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$_Chart.prototype, "subtitle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$_Chart.prototype, "footnote", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$_Chart.prototype, "keyboard", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$UNION([
        "standalone",
        "integrated"
    ], "a chart mode"))
], $d77b025aa58d633c$var$_Chart.prototype, "mode", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ActionOnSet({
        changeValue (newValue, oldValue) {
            this.onAxisChange(newValue, oldValue);
        }
    })
], $d77b025aa58d633c$var$_Chart.prototype, "axes", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ActionOnSet({
        changeValue (newValue, oldValue) {
            this.onSeriesChange(newValue, oldValue);
        }
    })
], $d77b025aa58d633c$var$_Chart.prototype, "series", 2);
var $d77b025aa58d633c$var$Chart = $d77b025aa58d633c$var$_Chart;
// packages/ag-charts-community/src/scene/polyRoots.ts
function $d77b025aa58d633c$var$linearRoot(a, b) {
    const t = -b / a;
    return a !== 0 && t >= 0 && t <= 1 ? [
        t
    ] : [];
}
function $d77b025aa58d633c$var$quadraticRoots(a, b, c) {
    if (a === 0) return $d77b025aa58d633c$var$linearRoot(b, c);
    const D = b * b - 4 * a * c;
    const roots = [];
    if (D === 0) {
        const t = -b / (2 * a);
        if (t >= 0 && t <= 1) roots.push(t);
    } else if (D > 0) {
        const rD = Math.sqrt(D);
        const t1 = (-b - rD) / (2 * a);
        const t2 = (-b + rD) / (2 * a);
        if (t1 >= 0 && t1 <= 1) roots.push(t1);
        if (t2 >= 0 && t2 <= 1) roots.push(t2);
    }
    return roots;
}
function $d77b025aa58d633c$var$cubicRoots(a, b, c, d) {
    if (a === 0) return $d77b025aa58d633c$var$quadraticRoots(b, c, d);
    const A = b / a;
    const B = c / a;
    const C = d / a;
    const Q = (3 * B - A * A) / 9;
    const R = (9 * A * B - 27 * C - 2 * A * A * A) / 54;
    const D = Q * Q * Q + R * R;
    const third = 1 / 3;
    const roots = [];
    if (D >= 0) {
        const rD = Math.sqrt(D);
        const S = Math.sign(R + rD) * Math.pow(Math.abs(R + rD), third);
        const T = Math.sign(R - rD) * Math.pow(Math.abs(R - rD), third);
        const Im = Math.abs(Math.sqrt(3) * (S - T) / 2);
        const t = -third * A + (S + T);
        if (t >= 0 && t <= 1) roots.push(t);
        if (Im === 0) {
            const t2 = -third * A - (S + T) / 2;
            if (t2 >= 0 && t2 <= 1) roots.push(t2);
        }
    } else {
        const theta = Math.acos(R / Math.sqrt(-Q * Q * Q));
        const thirdA = third * A;
        const twoSqrtQ = 2 * Math.sqrt(-Q);
        const t1 = twoSqrtQ * Math.cos(third * theta) - thirdA;
        const t2 = twoSqrtQ * Math.cos(third * (theta + 2 * Math.PI)) - thirdA;
        const t3 = twoSqrtQ * Math.cos(third * (theta + 4 * Math.PI)) - thirdA;
        if (t1 >= 0 && t1 <= 1) roots.push(t1);
        if (t2 >= 0 && t2 <= 1) roots.push(t2);
        if (t3 >= 0 && t3 <= 1) roots.push(t3);
    }
    return roots;
}
// packages/ag-charts-community/src/scene/intersection.ts
function $d77b025aa58d633c$var$segmentIntersection(ax1, ay1, ax2, ay2, bx1, by1, bx2, by2) {
    const d = (ax2 - ax1) * (by2 - by1) - (ay2 - ay1) * (bx2 - bx1);
    if (d === 0) return 0;
    const ua = ((bx2 - bx1) * (ay1 - by1) - (ax1 - bx1) * (by2 - by1)) / d;
    const ub = ((ax2 - ax1) * (ay1 - by1) - (ay2 - ay1) * (ax1 - bx1)) / d;
    if (ua >= 0 && ua <= 1 && ub >= 0 && ub <= 1) return 1;
    return 0;
}
function $d77b025aa58d633c$var$cubicSegmentIntersections(px1, py1, px2, py2, px3, py3, px4, py4, x1, y1, x2, y2) {
    let intersections = 0;
    const A = y1 - y2;
    const B = x2 - x1;
    const C = x1 * (y2 - y1) - y1 * (x2 - x1);
    const bx = $d77b025aa58d633c$var$bezierCoefficients(px1, px2, px3, px4);
    const by = $d77b025aa58d633c$var$bezierCoefficients(py1, py2, py3, py4);
    const a = A * bx[0] + B * by[0];
    const b = A * bx[1] + B * by[1];
    const c = A * bx[2] + B * by[2];
    const d = A * bx[3] + B * by[3] + C;
    const roots = $d77b025aa58d633c$var$cubicRoots(a, b, c, d);
    for (const t of roots){
        const tt = t * t;
        const ttt = t * tt;
        const x = bx[0] * ttt + bx[1] * tt + bx[2] * t + bx[3];
        const y = by[0] * ttt + by[1] * tt + by[2] * t + by[3];
        let s;
        if (x1 === x2) s = (y - y1) / (y2 - y1);
        else s = (x - x1) / (x2 - x1);
        if (s >= 0 && s <= 1) intersections++;
    }
    return intersections;
}
function $d77b025aa58d633c$var$bezierCoefficients(P1, P2, P3, P4) {
    return [
        // Bézier expressed as matrix operations:
        -P1 + 3 * P2 - 3 * P3 + P4,
        //                 |-1  3 -3  1| |P1|
        3 * P1 - 6 * P2 + 3 * P3,
        //   [t^3 t^2 t 1] | 3 -6  3  0| |P2|
        -3 * P1 + 3 * P2,
        //                 |-3  3  0  0| |P3|
        P1
    ];
}
function $d77b025aa58d633c$var$arcIntersections(cx, cy, r, startAngle, endAngle, counterClockwise, x1, y1, x2, y2) {
    if (isNaN(cx) || isNaN(cy)) return 0;
    if (counterClockwise) [endAngle, startAngle] = [
        startAngle,
        endAngle
    ];
    const k = (y2 - y1) / (x2 - x1);
    const y0 = y1 - k * x1;
    const a = Math.pow(k, 2) + 1;
    const b = 2 * (k * (y0 - cy) - cx);
    const c = Math.pow(cx, 2) + Math.pow(y0 - cy, 2) - Math.pow(r, 2);
    const d = Math.pow(b, 2) - 4 * a * c;
    if (d < 0) return 0;
    const i1x = (-b + Math.sqrt(d)) / 2 / a;
    const i2x = (-b - Math.sqrt(d)) / 2 / a;
    let intersections = 0;
    [
        i1x,
        i2x
    ].forEach((x)=>{
        const isXInsideLine = x >= Math.min(x1, x2) && x <= Math.max(x1, x2);
        if (!isXInsideLine) return;
        const y = k * x + y0;
        const adjacent = x - cx;
        const opposite = y - cy;
        const angle = Math.atan2(opposite, adjacent);
        if ($d77b025aa58d633c$var$isBetweenAngles(angle, startAngle, endAngle)) intersections++;
    });
    return intersections;
}
// packages/ag-charts-community/src/scene/extendedPath2D.ts
var $d77b025aa58d633c$var$ExtendedPath2D = class {
    constructor(){
        // The methods of this class will likely be called many times per animation frame,
        // and any allocation can trigger a GC cycle during animation, so we attempt
        // to minimize the number of allocations.
        this.path2d = new Path2D();
        this.previousCommands = [];
        this.previousParams = [];
        this.previousClosedPath = false;
        this.commands = [];
        this.params = [];
        this.openedPath = false;
        this.closedPath = false;
    }
    isDirty() {
        return this.closedPath !== this.previousClosedPath || this.previousCommands.length !== this.commands.length || this.previousParams.length !== this.params.length || this.previousCommands.toString() !== this.commands.toString() || this.previousParams.toString() !== this.params.toString();
    }
    getPath2D() {
        return this.path2d;
    }
    moveTo(x, y) {
        this.openedPath = true;
        this.path2d.moveTo(x, y);
        this.commands.push(0 /* Move */ );
        this.params.push(x, y);
    }
    lineTo(x, y) {
        if (this.openedPath) {
            this.path2d.lineTo(x, y);
            this.commands.push(1 /* Line */ );
            this.params.push(x, y);
        } else this.moveTo(x, y);
    }
    rect(x, y, width, height) {
        this.moveTo(x, y);
        this.lineTo(x + width, y);
        this.lineTo(x + width, y + height);
        this.lineTo(x, y + height);
        this.closePath();
    }
    roundRect(x, y, width, height, radii) {
        radii = Math.min(radii, width / 2, height / 2);
        this.moveTo(x, y + radii);
        this.arc(x + radii, y + radii, radii, Math.PI, 1.5 * Math.PI);
        this.lineTo(x + radii, y);
        this.lineTo(x + width - radii, y);
        this.arc(x + width - radii, y + radii, radii, 1.5 * Math.PI, 2 * Math.PI);
        this.lineTo(x + width, y + radii);
        this.lineTo(x + width, y + height - radii);
        this.arc(x + width - radii, y + height - radii, radii, 0, Math.PI / 2);
        this.lineTo(x + width - radii, y + height);
        this.lineTo(x + radii, y + height);
        this.arc(x + +radii, y + height - radii, radii, Math.PI / 2, Math.PI);
        this.lineTo(x, y + height - radii);
        this.closePath();
    }
    arc(x, y, r, sAngle, eAngle, counterClockwise) {
        this.openedPath = true;
        this.path2d.arc(x, y, r, sAngle, eAngle, counterClockwise);
        this.commands.push(2 /* Arc */ );
        this.params.push(x, y, r, sAngle, eAngle, counterClockwise ? 1 : 0);
    }
    cubicCurveTo(cx1, cy1, cx2, cy2, x, y) {
        if (!this.openedPath) this.moveTo(cx1, cy1);
        this.path2d.bezierCurveTo(cx1, cy1, cx2, cy2, x, y);
        this.commands.push(3 /* Curve */ );
        this.params.push(cx1, cy1, cx2, cy2, x, y);
    }
    closePath() {
        if (this.openedPath) {
            this.path2d.closePath();
            this.commands.push(4 /* ClosePath */ );
            this.openedPath = false;
            this.closedPath = true;
        }
    }
    clear(trackChanges) {
        if (trackChanges) {
            this.previousCommands = this.commands;
            this.previousParams = this.params;
            this.previousClosedPath = this.closedPath;
        }
        this.path2d = new Path2D();
        this.openedPath = false;
        this.closedPath = false;
        this.commands = [];
        this.params = [];
    }
    isPointInPath(x, y) {
        const commands = this.commands;
        const params = this.params;
        const cn = commands.length;
        const ox = -10000;
        const oy = -10000;
        let sx = NaN;
        let sy = NaN;
        let px = 0;
        let py = 0;
        let intersectionCount = 0;
        for(let ci = 0, pi = 0; ci < cn; ci++)switch(commands[ci]){
            case 0 /* Move */ :
                intersectionCount += $d77b025aa58d633c$var$segmentIntersection(sx, sy, px, py, ox, oy, x, y);
                px = params[pi++];
                sx = px;
                py = params[pi++];
                sy = py;
                break;
            case 1 /* Line */ :
                intersectionCount += $d77b025aa58d633c$var$segmentIntersection(px, py, params[pi++], params[pi++], ox, oy, x, y);
                px = params[pi - 2];
                py = params[pi - 1];
                break;
            case 3 /* Curve */ :
                intersectionCount += $d77b025aa58d633c$var$cubicSegmentIntersections(px, py, params[pi++], params[pi++], params[pi++], params[pi++], params[pi++], params[pi++], ox, oy, x, y);
                px = params[pi - 2];
                py = params[pi - 1];
                break;
            case 2 /* Arc */ :
                const cx = params[pi++];
                const cy = params[pi++];
                const r = params[pi++];
                const startAngle = params[pi++];
                const endAngle = params[pi++];
                const counterClockwise = Boolean(params[pi++]);
                intersectionCount += $d77b025aa58d633c$var$arcIntersections(cx, cy, r, startAngle, endAngle, counterClockwise, ox, oy, x, y);
                if (!isNaN(sx)) {
                    const startX = cx + Math.cos(startAngle) * r;
                    const startY = cy + Math.sin(startAngle) * r;
                    intersectionCount += $d77b025aa58d633c$var$segmentIntersection(px, py, startX, startY, ox, oy, x, y);
                }
                px = cx + Math.cos(endAngle) * r;
                py = cy + Math.sin(endAngle) * r;
                break;
            case 4 /* ClosePath */ :
                intersectionCount += $d77b025aa58d633c$var$segmentIntersection(sx, sy, px, py, ox, oy, x, y);
                break;
        }
        return intersectionCount % 2 === 1;
    }
    distanceSquared(x, y) {
        let best = Infinity;
        const commands = this.commands;
        const params = this.params;
        const cn = commands.length;
        let sx = NaN;
        let sy = NaN;
        let px = 0;
        let py = 0;
        for(let ci = 0, pi = 0; ci < cn; ci++)switch(commands[ci]){
            case 0 /* Move */ :
                px = sx = params[pi++];
                py = sy = params[pi++];
                break;
            case 1 /* Line */ :
                {
                    const nx = params[pi++];
                    const ny = params[pi++];
                    best = $d77b025aa58d633c$var$lineDistanceSquared(x, y, px, py, nx, ny, best);
                    break;
                }
            case 3 /* Curve */ :
                $d77b025aa58d633c$var$Logger.error("Command.Curve distanceSquare not implemented");
                break;
            case 2 /* Arc */ :
                {
                    const cx = params[pi++];
                    const cy = params[pi++];
                    const r = params[pi++];
                    const startAngle = params[pi++];
                    const endAngle = params[pi++];
                    const startX = cx + Math.cos(startAngle) * r;
                    const startY = cy + Math.sin(startAngle) * r;
                    const counterClockwise = Boolean(params[pi++]);
                    best = $d77b025aa58d633c$var$lineDistanceSquared(x, y, px, py, startX, startY, best);
                    best = $d77b025aa58d633c$var$arcDistanceSquared(x, y, cx, cy, r, startAngle, endAngle, counterClockwise, best);
                    px = cx + Math.cos(endAngle) * r;
                    py = cy + Math.sin(endAngle) * r;
                    break;
                }
            case 4 /* ClosePath */ :
                best = $d77b025aa58d633c$var$lineDistanceSquared(x, y, px, py, sx, sy, best);
                break;
        }
        return best;
    }
    getPoints() {
        const { commands: commands, params: params } = this;
        const coords = [];
        let pi = 0;
        for(let ci = 0; ci < commands.length; ci++)switch(commands[ci]){
            case 0 /* Move */ :
            case 1 /* Line */ :
                coords.push({
                    x: params[pi++],
                    y: params[pi++]
                });
                break;
            case 3 /* Curve */ :
                pi += 4;
                coords.push({
                    x: params[pi++],
                    y: params[pi++]
                });
                break;
            case 2 /* Arc */ :
                coords.push({
                    x: params[pi++],
                    y: params[pi++]
                });
                pi += 4;
                break;
            case 4 /* ClosePath */ :
                break;
        }
        return coords;
    }
};
// packages/ag-charts-community/src/scene/shape/path.ts
function $d77b025aa58d633c$var$ScenePathChangeDetection(opts) {
    const { redraw: redraw = 3 /* MAJOR */ , changeCb: changeCb, convertor: convertor } = opts != null ? opts : {};
    return $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: redraw,
        type: "path",
        convertor: convertor,
        changeCb: changeCb
    });
}
var $d77b025aa58d633c$var$Path = class extends $d77b025aa58d633c$var$Shape {
    constructor(){
        super(...arguments);
        /**
     * Declare a path to retain for later rendering and hit testing
     * using custom Path2D class. Think of it as a TypeScript version
     * of the native Path2D (with some differences) that works in all browsers.
     */ this.path = new $d77b025aa58d633c$var$ExtendedPath2D();
        this._clipX = NaN;
        this._clipY = NaN;
        /**
     * The path only has to be updated when certain attributes change.
     * For example, if transform attributes (such as `translationX`)
     * are changed, we don't have to update the path. The `dirtyPath` flag
     * is how we keep track if the path has to be updated or not.
     */ this._dirtyPath = true;
    }
    set clipX(value) {
        this._clipX = value;
        this.dirtyPath = true;
    }
    set clipY(value) {
        this._clipY = value;
        this.dirtyPath = true;
    }
    set dirtyPath(value) {
        if (this._dirtyPath !== value) {
            this._dirtyPath = value;
            if (value) this.markDirty(this, 3 /* MAJOR */ );
        }
    }
    get dirtyPath() {
        return this._dirtyPath;
    }
    checkPathDirty() {
        var _a, _b, _c, _d;
        if (this._dirtyPath) return;
        this.dirtyPath = this.path.isDirty() || ((_b = (_a = this.fillShadow) == null ? void 0 : _a.isDirty()) != null ? _b : false) || ((_d = (_c = this._clipPath) == null ? void 0 : _c.isDirty()) != null ? _d : false);
    }
    isPointInPath(x, y) {
        const point = this.transformPoint(x, y);
        return this.path.closedPath && this.path.isPointInPath(point.x, point.y);
    }
    distanceSquared(x, y) {
        const point = this.transformPoint(x, y);
        return this.path.distanceSquared(point.x, point.y);
    }
    isDirtyPath() {
        return false;
    }
    updatePath() {}
    render(renderCtx) {
        var _a, _b, _c, _d, _e;
        const { ctx: ctx, forceRender: forceRender, stats: stats } = renderCtx;
        if (this.dirty === 0 /* NONE */  && !forceRender) {
            if (stats) stats.nodesSkipped += this.nodeCount.count;
            return;
        }
        this.computeTransformMatrix();
        this.matrix.toContext(ctx);
        if (this.dirtyPath || this.isDirtyPath()) {
            this.updatePath();
            this.dirtyPath = false;
        }
        if (!isNaN(this._clipX) && !isNaN(this._clipY) && this.clipMode != null) {
            ctx.save();
            const margin = this.strokeWidth / 2;
            (_a = this._clipPath) != null ? _a : this._clipPath = new $d77b025aa58d633c$var$ExtendedPath2D();
            this._clipPath.clear();
            this._clipPath.rect(-margin, -margin, this._clipX + margin, this._clipY + margin + margin);
            if (this.clipMode === "normal") ctx.clip((_b = this._clipPath) == null ? void 0 : _b.getPath2D());
            if (this._clipX > 0 && this._clipY > 0) this.drawPath(ctx);
            if (this.clipMode === "punch-out") {
                ctx.clip((_c = this._clipPath) == null ? void 0 : _c.getPath2D());
                const { x: x = -10000, y: y = -10000, width: width = 2e4, height: height = 2e4 } = (_d = this.computeBBox()) != null ? _d : {};
                ctx.clearRect(x, y, width, height);
            }
            ctx.restore();
        } else this.drawPath(ctx);
        (_e = this.fillShadow) == null || _e.markClean();
        super.render(renderCtx);
    }
    drawPath(ctx) {
        this.fillStroke(ctx, this.path.getPath2D());
    }
};
$d77b025aa58d633c$var$Path.className = "Path";
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ScenePathChangeDetection()
], $d77b025aa58d633c$var$Path.prototype, "clipMode", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ScenePathChangeDetection()
], $d77b025aa58d633c$var$Path.prototype, "clipX", 1);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ScenePathChangeDetection()
], $d77b025aa58d633c$var$Path.prototype, "clipY", 1);
// packages/ag-charts-community/src/scene/util/quadtree.ts
var $d77b025aa58d633c$var$QuadtreeNearest = class {
    constructor(capacity, maxdepth, boundary){
        this.root = new $d77b025aa58d633c$var$QuadtreeNodeNearest(capacity, maxdepth, boundary);
    }
    clear(boundary) {
        this.root.clear(boundary);
    }
    addValue(hitTester, value) {
        const elem = {
            hitTester: hitTester,
            value: value,
            distanceSquared: (x, y)=>{
                return hitTester.distanceSquared(x, y);
            }
        };
        this.root.addElem(elem);
    }
    find(x, y) {
        const arg = {
            best: {
                nearest: void 0,
                distanceSquared: Infinity
            }
        };
        this.root.find(x, y, arg);
        return arg.best;
    }
};
var $d77b025aa58d633c$var$QuadtreeSubdivisions = class {
    constructor(nw, ne, sw, se){
        this.nw = nw;
        this.ne = ne;
        this.sw = sw;
        this.se = se;
    }
    addElem(elem) {
        this.nw.addElem(elem);
        this.ne.addElem(elem);
        this.sw.addElem(elem);
        this.se.addElem(elem);
    }
    find(x, y, arg) {
        this.nw.find(x, y, arg);
        this.ne.find(x, y, arg);
        this.sw.find(x, y, arg);
        this.se.find(x, y, arg);
    }
};
var $d77b025aa58d633c$var$QuadtreeNode = class {
    constructor(capacity, maxdepth, boundary){
        this.capacity = capacity;
        this.maxdepth = maxdepth;
        this.boundary = boundary != null ? boundary : $d77b025aa58d633c$var$BBox.NaN;
        this.elems = [];
        this.subdivisions = void 0;
    }
    clear(boundary) {
        this.elems.length = 0;
        this.boundary = boundary;
        this.subdivisions = void 0;
    }
    addElem(e) {
        if (this.addCondition(e)) {
            if (this.subdivisions === void 0) {
                if (this.maxdepth === 0 || this.elems.length < this.capacity) this.elems.push(e);
                else this.subdivide(e);
            } else this.subdivisions.addElem(e);
        }
    }
    find(x, y, arg) {
        if (this.findCondition(x, y, arg)) {
            if (this.subdivisions === void 0) this.findAction(x, y, arg);
            else this.subdivisions.find(x, y, arg);
        }
    }
    subdivide(newElem) {
        this.subdivisions = this.makeSubdivisions();
        for (const e of this.elems)this.subdivisions.addElem(e);
        this.subdivisions.addElem(newElem);
        this.elems.length = 0;
    }
    makeSubdivisions() {
        const { x: x, y: y, width: width, height: height } = this.boundary;
        const { capacity: capacity } = this;
        const depth = this.maxdepth - 1;
        const halfWidth = width / 2;
        const halfHeight = height / 2;
        const nwBoundary = new $d77b025aa58d633c$var$BBox(x, y, halfWidth, halfHeight);
        const neBoundary = new $d77b025aa58d633c$var$BBox(x + halfWidth, y, halfWidth, halfHeight);
        const swBoundary = new $d77b025aa58d633c$var$BBox(x, y + halfHeight, halfWidth, halfHeight);
        const seBoundary = new $d77b025aa58d633c$var$BBox(x + halfWidth, y + halfHeight, halfWidth, halfHeight);
        return new $d77b025aa58d633c$var$QuadtreeSubdivisions(this.child(capacity, depth, nwBoundary), this.child(capacity, depth, neBoundary), this.child(capacity, depth, swBoundary), this.child(capacity, depth, seBoundary));
    }
};
var $d77b025aa58d633c$var$QuadtreeNodeNearest = class _QuadtreeNodeNearest extends $d77b025aa58d633c$var$QuadtreeNode {
    addCondition(e) {
        const { x: x, y: y } = e.hitTester.midPoint;
        return this.boundary.containsPoint(x, y);
    }
    findCondition(x, y, arg) {
        const { best: best } = arg;
        return best.distanceSquared !== 0 && this.boundary.distanceSquared(x, y) < best.distanceSquared;
    }
    findAction(x, y, arg) {
        const other = $d77b025aa58d633c$var$nearestSquared(x, y, this.elems, arg.best.distanceSquared);
        if (other.nearest !== void 0 && other.distanceSquared < arg.best.distanceSquared) arg.best = other;
    }
    child(capacity, depth, boundary) {
        return new _QuadtreeNodeNearest(capacity, depth, boundary);
    }
};
// packages/ag-charts-community/src/chart/marker/marker.ts
var $d77b025aa58d633c$export$e98856a975cab58e = class extends $d77b025aa58d633c$var$Path {
    constructor(){
        super(...arguments);
        this.x = 0;
        this.y = 0;
        this.size = 12;
    }
    computeBBox() {
        const { x: x, y: y, size: size } = this;
        const { center: center } = this.constructor;
        return new $d77b025aa58d633c$var$BBox(x - size * center.x, y - size * center.y, size, size);
    }
    applyPath(s, moves) {
        const { path: path } = this;
        let { x: x, y: y } = this;
        if (this.repeat != null) {
            x = 0;
            y = 0;
        }
        path.clear();
        for (const { x: mx, y: my, t: t } of moves){
            x += mx * s;
            y += my * s;
            if (t === "move") path.moveTo(x, y);
            else path.lineTo(x, y);
        }
        path.closePath();
    }
    executeFill(ctx, path) {
        if (!path) return;
        if (this.repeat == null) return super.executeFill(ctx, path);
        ctx.save();
        let x = this.translationX;
        let y = this.translationY;
        for (const translation of this.repeat){
            ctx.translate(translation.x - x, translation.y - y);
            ctx.fill(path);
            x = translation.x;
            y = translation.y;
        }
        ctx.restore();
    }
    executeStroke(ctx, path) {
        if (!path) return;
        if (this.repeat == null) return super.executeStroke(ctx, path);
        ctx.save();
        let x = this.translationX;
        let y = this.translationY;
        for (const translation of this.repeat){
            ctx.translate(translation.x - x, translation.y - y);
            ctx.stroke(path);
            x = translation.x;
            y = translation.y;
        }
        ctx.restore();
    }
};
$d77b025aa58d633c$export$e98856a975cab58e.center = {
    x: 0.5,
    y: 0.5
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ScenePathChangeDetection()
], $d77b025aa58d633c$export$e98856a975cab58e.prototype, "x", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ScenePathChangeDetection()
], $d77b025aa58d633c$export$e98856a975cab58e.prototype, "y", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ScenePathChangeDetection({
        convertor: Math.abs
    })
], $d77b025aa58d633c$export$e98856a975cab58e.prototype, "size", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ScenePathChangeDetection()
], $d77b025aa58d633c$export$e98856a975cab58e.prototype, "repeat", 2);
// packages/ag-charts-community/src/chart/marker/circle.ts
var $d77b025aa58d633c$var$Circle = class extends $d77b025aa58d633c$export$e98856a975cab58e {
    updatePath() {
        const { x: x, y: y, path: path, size: size } = this;
        const r = size / 2;
        path.clear();
        path.arc(x, y, r, 0, Math.PI * 2);
        path.closePath();
    }
};
$d77b025aa58d633c$var$Circle.className = "Circle";
// packages/ag-charts-community/src/chart/marker/cross.ts
var $d77b025aa58d633c$var$_Cross = class _Cross extends $d77b025aa58d633c$export$e98856a975cab58e {
    updatePath() {
        const s = this.size / 4.2;
        super.applyPath(s, _Cross.moves);
    }
};
$d77b025aa58d633c$var$_Cross.className = "Cross";
$d77b025aa58d633c$var$_Cross.moves = [
    {
        x: -1,
        y: 0,
        t: "move"
    },
    {
        x: -1,
        y: -1
    },
    {
        x: 1,
        y: -1
    },
    {
        x: 1,
        y: 1
    },
    {
        x: 1,
        y: -1
    },
    {
        x: 1,
        y: 1
    },
    {
        x: -1,
        y: 1
    },
    {
        x: 1,
        y: 1
    },
    {
        x: -1,
        y: 1
    },
    {
        x: -1,
        y: -1
    },
    {
        x: -1,
        y: 1
    },
    {
        x: -1,
        y: -1
    }
];
var $d77b025aa58d633c$var$Cross = $d77b025aa58d633c$var$_Cross;
// packages/ag-charts-community/src/chart/marker/diamond.ts
var $d77b025aa58d633c$var$_Diamond = class _Diamond extends $d77b025aa58d633c$export$e98856a975cab58e {
    updatePath() {
        const s = this.size / 2;
        super.applyPath(s, _Diamond.moves);
    }
};
$d77b025aa58d633c$var$_Diamond.className = "Diamond";
$d77b025aa58d633c$var$_Diamond.moves = [
    {
        x: 0,
        y: -1,
        t: "move"
    },
    {
        x: 1,
        y: 1
    },
    {
        x: -1,
        y: 1
    },
    {
        x: -1,
        y: -1
    },
    {
        x: 1,
        y: -1
    }
];
var $d77b025aa58d633c$var$Diamond = $d77b025aa58d633c$var$_Diamond;
// packages/ag-charts-community/src/chart/marker/heart.ts
var $d77b025aa58d633c$var$Heart = class extends $d77b025aa58d633c$export$e98856a975cab58e {
    rad(degree) {
        return degree / 180 * Math.PI;
    }
    updatePath() {
        const { x: x, path: path, size: size, rad: rad } = this;
        const r = size / 4;
        const y = this.y + r / 2;
        path.clear();
        path.arc(x - r, y - r, r, rad(130), rad(330));
        path.arc(x + r, y - r, r, rad(220), rad(50));
        path.lineTo(x, y + r);
        path.closePath();
    }
};
$d77b025aa58d633c$var$Heart.className = "Heart";
// packages/ag-charts-community/src/chart/marker/pin.ts
var $d77b025aa58d633c$var$Pin = class extends $d77b025aa58d633c$export$e98856a975cab58e {
    updatePath() {
        const { path: path, x: x, y: y } = this;
        const s = this.size;
        const cx = 0.5;
        const cy = 1;
        path.clear();
        path.moveTo(x + (0.15625 - cx) * s, y + (0.34375 - cy) * s);
        path.cubicCurveTo(x + (0.15625 - cx) * s, y + (0.151491 - cy) * s, x + (0.307741 - cx) * s, y + (0 - cy) * s, x + (0.5 - cx) * s, y + (0 - cy) * s);
        path.cubicCurveTo(x + (0.692259 - cx) * s, y + (0 - cy) * s, x + (0.84375 - cx) * s, y + (0.151491 - cy) * s, x + (0.84375 - cx) * s, y + (0.34375 - cy) * s);
        path.cubicCurveTo(x + (0.84375 - cx) * s, y + (0.493824 - cy) * s, x + (0.784625 - cx) * s, y + (0.600181 - cy) * s, x + (0.716461 - cx) * s, y + (0.695393 - cy) * s);
        path.cubicCurveTo(x + (0.699009 - cx) * s, y + (0.719769 - cy) * s, x + (0.681271 - cx) * s, y + (0.743104 - cy) * s, x + (0.663785 - cx) * s, y + (0.766105 - cy) * s);
        path.cubicCurveTo(x + (0.611893 - cx) * s, y + (0.834367 - cy) * s, x + (0.562228 - cx) * s, y + (0.899699 - cy) * s, x + (0.528896 - cx) * s, y + (0.980648 - cy) * s);
        path.cubicCurveTo(x + (0.524075 - cx) * s, y + (0.992358 - cy) * s, x + (0.512663 - cx) * s, y + (1 - cy) * s, x + (0.5 - cx) * s, y + (1 - cy) * s);
        path.cubicCurveTo(x + (0.487337 - cx) * s, y + (1 - cy) * s, x + (0.475925 - cx) * s, y + (0.992358 - cy) * s, x + (0.471104 - cx) * s, y + (0.980648 - cy) * s);
        path.cubicCurveTo(x + (0.487337 - cx) * s, y + (1 - cy) * s, x + (0.475925 - cx) * s, y + (0.992358 - cy) * s, x + (0.471104 - cx) * s, y + (0.980648 - cy) * s);
        path.cubicCurveTo(x + (0.437772 - cx) * s, y + (0.899699 - cy) * s, x + (0.388107 - cx) * s, y + (0.834367 - cy) * s, x + (0.336215 - cx) * s, y + (0.766105 - cy) * s);
        path.cubicCurveTo(x + (0.318729 - cx) * s, y + (0.743104 - cy) * s, x + (0.300991 - cx) * s, y + (0.719769 - cy) * s, x + (0.283539 - cx) * s, y + (0.695393 - cy) * s);
        path.cubicCurveTo(x + (0.215375 - cx) * s, y + (0.600181 - cy) * s, x + (0.15625 - cx) * s, y + (0.493824 - cy) * s, x + (0.15625 - cx) * s, y + (0.34375 - cy) * s);
        path.closePath();
    }
};
$d77b025aa58d633c$var$Pin.className = "MapPin";
$d77b025aa58d633c$var$Pin.center = {
    x: 0.5,
    y: 1
};
// packages/ag-charts-community/src/chart/marker/plus.ts
var $d77b025aa58d633c$var$_Plus = class _Plus extends $d77b025aa58d633c$export$e98856a975cab58e {
    updatePath() {
        const s = this.size / 3;
        super.applyPath(s, _Plus.moves);
    }
};
$d77b025aa58d633c$var$_Plus.className = "Plus";
$d77b025aa58d633c$var$_Plus.moves = [
    {
        x: -0.5,
        y: -0.5,
        t: "move"
    },
    {
        x: 0,
        y: -1
    },
    {
        x: 1,
        y: 0
    },
    {
        x: 0,
        y: 1
    },
    {
        x: 1,
        y: 0
    },
    {
        x: 0,
        y: 1
    },
    {
        x: -1,
        y: 0
    },
    {
        x: 0,
        y: 1
    },
    {
        x: -1,
        y: 0
    },
    {
        x: 0,
        y: -1
    },
    {
        x: -1,
        y: 0
    },
    {
        x: 0,
        y: -1
    }
];
var $d77b025aa58d633c$var$Plus = $d77b025aa58d633c$var$_Plus;
// packages/ag-charts-community/src/chart/marker/square.ts
var $d77b025aa58d633c$var$Square = class extends $d77b025aa58d633c$export$e98856a975cab58e {
    updatePath() {
        const { path: path, x: x, y: y } = this;
        const hs = this.size / 2;
        path.clear();
        path.moveTo(this.align(x - hs), this.align(y - hs));
        path.lineTo(this.align(x + hs), this.align(y - hs));
        path.lineTo(this.align(x + hs), this.align(y + hs));
        path.lineTo(this.align(x - hs), this.align(y + hs));
        path.closePath();
    }
};
$d77b025aa58d633c$var$Square.className = "Square";
// packages/ag-charts-community/src/chart/marker/star.ts
var $d77b025aa58d633c$var$Star = class extends $d77b025aa58d633c$export$e98856a975cab58e {
    updatePath() {
        const { x: x, y: y, path: path, size: size } = this;
        const spikes = 5;
        const innerRadius = size / 2;
        const rotation = Math.PI / 2;
        path.clear();
        for(let i = 0; i < spikes * 2; i++){
            const radius = i % 2 === 0 ? size : innerRadius;
            const angle = i * Math.PI / spikes - rotation;
            const xCoordinate = x + Math.cos(angle) * radius;
            const yCoordinate = y + Math.sin(angle) * radius;
            path.lineTo(xCoordinate, yCoordinate);
        }
        path.closePath();
    }
};
$d77b025aa58d633c$var$Star.className = "Star";
// packages/ag-charts-community/src/chart/marker/triangle.ts
var $d77b025aa58d633c$var$_Triangle = class _Triangle extends $d77b025aa58d633c$export$e98856a975cab58e {
    updatePath() {
        const s = this.size * 1.1;
        super.applyPath(s, _Triangle.moves);
    }
};
$d77b025aa58d633c$var$_Triangle.className = "Triangle";
$d77b025aa58d633c$var$_Triangle.moves = [
    {
        x: 0,
        y: -0.48,
        t: "move"
    },
    {
        x: 0.5,
        y: 0.87
    },
    {
        x: -1,
        y: 0
    }
];
var $d77b025aa58d633c$var$Triangle = $d77b025aa58d633c$var$_Triangle;
// packages/ag-charts-community/src/chart/marker/util.ts
var $d77b025aa58d633c$var$MARKER_SHAPES = {
    circle: $d77b025aa58d633c$var$Circle,
    cross: $d77b025aa58d633c$var$Cross,
    diamond: $d77b025aa58d633c$var$Diamond,
    heart: $d77b025aa58d633c$var$Heart,
    pin: $d77b025aa58d633c$var$Pin,
    plus: $d77b025aa58d633c$var$Plus,
    square: $d77b025aa58d633c$var$Square,
    star: $d77b025aa58d633c$var$Star,
    triangle: $d77b025aa58d633c$var$Triangle
};
var $d77b025aa58d633c$var$MARKER_SUPPORTED_SHAPES = Object.keys($d77b025aa58d633c$var$MARKER_SHAPES);
function $d77b025aa58d633c$var$isMarkerShape(shape) {
    return typeof shape === "string" && $d77b025aa58d633c$var$MARKER_SUPPORTED_SHAPES.includes(shape);
}
function $d77b025aa58d633c$var$getMarker(shape = $d77b025aa58d633c$var$Square) {
    if ($d77b025aa58d633c$var$isMarkerShape(shape)) return $d77b025aa58d633c$var$MARKER_SHAPES[shape];
    if (typeof shape === "function") return shape;
    return $d77b025aa58d633c$var$Square;
}
// packages/ag-charts-community/src/chart/series/dataModelSeries.ts
var $d77b025aa58d633c$var$DataModelSeries = class extends $d77b025aa58d633c$var$Series {
    constructor(){
        super(...arguments);
        this.showFocusBox = true;
    }
    getScaleInformation({ xScale: xScale, yScale: yScale }) {
        const isContinuousX = $d77b025aa58d633c$var$ContinuousScale.is(xScale);
        const isContinuousY = $d77b025aa58d633c$var$ContinuousScale.is(yScale);
        return {
            isContinuousX: isContinuousX,
            isContinuousY: isContinuousY,
            xScaleType: xScale == null ? void 0 : xScale.type,
            yScaleType: yScale == null ? void 0 : yScale.type
        };
    }
    getModulePropertyDefinitions() {
        var _a, _b;
        const xScale = (_a = this.axes["x" /* X */ ]) == null ? void 0 : _a.scale;
        const yScale = (_b = this.axes["y" /* Y */ ]) == null ? void 0 : _b.scale;
        return this.moduleMap.mapModules((mod2)=>mod2.getPropertyDefinitions(this.getScaleInformation({
                xScale: xScale,
                yScale: yScale
            }))).flat();
    }
    // Request data, but with message dispatching to series-options (modules).
    requestDataModel(dataController, data, opts) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            opts.props.push(...this.getModulePropertyDefinitions());
            const { dataModel: dataModel, processedData: processedData } = yield dataController.request(this.id, data != null ? data : [], opts);
            this.dataModel = dataModel;
            this.processedData = processedData;
            this.dispatch("data-processed", {
                dataModel: dataModel,
                processedData: processedData
            });
            return {
                dataModel: dataModel,
                processedData: processedData
            };
        });
    }
    isProcessedDataAnimatable() {
        var _a, _b;
        const validationResults = (_b = (_a = this.processedData) == null ? void 0 : _a.reduced) == null ? void 0 : _b.animationValidation;
        if (!validationResults) return true;
        const { orderedKeys: orderedKeys, uniqueKeys: uniqueKeys } = validationResults;
        return orderedKeys && uniqueKeys;
    }
    checkProcessedDataAnimatable() {
        if (!this.isProcessedDataAnimatable()) this.ctx.animationManager.skipCurrentBatch();
    }
    pickFocus(opts) {
        return this.doPickFocus(opts, this);
    }
    // The legend behaves differently for Pie and Donut series. We need to use a seriesItemEnabled
    // array to determine whether a datum has been toggled on/off using the legend.
    doPickFocus(opts, derivedSeries) {
        const nodeData = this.getNodeData();
        if (nodeData === void 0 || nodeData.length === 0) return void 0;
        const { datumIndexDelta: datumIndexDelta, seriesRect: seriesRect } = opts;
        const datumIndex = this.computeFocusDatumIndex(opts, nodeData, derivedSeries.seriesItemEnabled);
        if (datumIndex === void 0) return void 0;
        const { showFocusBox: showFocusBox } = this;
        const datum = nodeData[datumIndex];
        const bbox = this.computeFocusBounds({
            datumIndex: datumIndex,
            datumIndexDelta: datumIndexDelta,
            seriesRect: seriesRect
        });
        if (bbox !== void 0) return {
            bbox: bbox,
            showFocusBox: showFocusBox,
            datum: datum,
            datumIndex: datumIndex
        };
    }
    computeFocusDatumIndex(opts, nodeData, seriesItemEnabled) {
        if (seriesItemEnabled && nodeData.length !== seriesItemEnabled.length) $d77b025aa58d633c$var$Logger.error(`invalid state: nodeData.length (${nodeData.length} !== seriesItemEnabled.length (${seriesItemEnabled == null ? void 0 : seriesItemEnabled.length})`);
        const isDatumEnabled = (datumIndex2)=>{
            const nodeDatum = nodeData[datumIndex2];
            return (nodeDatum.missing === void 0 || nodeDatum.missing === false) && (seriesItemEnabled === void 0 || seriesItemEnabled[datumIndex2]);
        };
        const searchBackward = (datumIndex2)=>{
            while(datumIndex2 >= 0 && !isDatumEnabled(datumIndex2))datumIndex2--;
            return datumIndex2 === -1 ? void 0 : datumIndex2;
        };
        const searchForward = (datumIndex2)=>{
            while(datumIndex2 < nodeData.length && !isDatumEnabled(datumIndex2))datumIndex2++;
            return datumIndex2 === nodeData.length ? void 0 : datumIndex2;
        };
        let datumIndex;
        const clampedIndex = $d77b025aa58d633c$var$clamp(0, opts.datumIndex, nodeData.length - 1);
        if (opts.datumIndexDelta < 0) datumIndex = searchBackward(clampedIndex);
        else if (opts.datumIndexDelta > 0) datumIndex = searchForward(clampedIndex);
        else {
            datumIndex != null ? datumIndex : datumIndex = searchForward(clampedIndex);
            datumIndex != null ? datumIndex : datumIndex = searchBackward(clampedIndex);
        }
        if (datumIndex === void 0) {
            if (opts.datumIndexDelta === 0) return void 0;
            else return opts.datumIndex - opts.datumIndexDelta;
        } else return datumIndex;
    }
};
// packages/ag-charts-community/src/chart/series/seriesProperties.ts
var $d77b025aa58d633c$var$SeriesItemHighlightStyle = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.fill = "rgba(255,255,255, 0.33)";
        this.stroke = `rgba(0, 0, 0, 0.4)`;
        this.strokeWidth = 2;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$COLOR_STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$SeriesItemHighlightStyle.prototype, "fill", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$RATIO, {
        optional: true
    })
], $d77b025aa58d633c$var$SeriesItemHighlightStyle.prototype, "fillOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$COLOR_STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$SeriesItemHighlightStyle.prototype, "stroke", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER, {
        optional: true
    })
], $d77b025aa58d633c$var$SeriesItemHighlightStyle.prototype, "strokeWidth", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$RATIO, {
        optional: true
    })
], $d77b025aa58d633c$var$SeriesItemHighlightStyle.prototype, "strokeOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$LINE_DASH, {
        optional: true
    })
], $d77b025aa58d633c$var$SeriesItemHighlightStyle.prototype, "lineDash", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER, {
        optional: true
    })
], $d77b025aa58d633c$var$SeriesItemHighlightStyle.prototype, "lineDashOffset", 2);
var $d77b025aa58d633c$var$SeriesHighlightStyle = class extends $d77b025aa58d633c$var$BaseProperties {
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER, {
        optional: true
    })
], $d77b025aa58d633c$var$SeriesHighlightStyle.prototype, "strokeWidth", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$RATIO, {
        optional: true
    })
], $d77b025aa58d633c$var$SeriesHighlightStyle.prototype, "dimOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN, {
        optional: true
    })
], $d77b025aa58d633c$var$SeriesHighlightStyle.prototype, "enabled", 2);
var $d77b025aa58d633c$var$TextHighlightStyle = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.color = "black";
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$COLOR_STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$TextHighlightStyle.prototype, "color", 2);
var $d77b025aa58d633c$var$HighlightStyle = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.item = new $d77b025aa58d633c$var$SeriesItemHighlightStyle();
        this.series = new $d77b025aa58d633c$var$SeriesHighlightStyle();
        this.text = new $d77b025aa58d633c$var$TextHighlightStyle();
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$HighlightStyle.prototype, "item", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$HighlightStyle.prototype, "series", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$HighlightStyle.prototype, "text", 2);
var $d77b025aa58d633c$var$SeriesProperties = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.visible = true;
        this.showInLegend = true;
        this.cursor = "default";
        this.nodeClickRange = "exact";
        this.highlightStyle = new $d77b025aa58d633c$var$HighlightStyle();
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$SeriesProperties.prototype, "id", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN)
], $d77b025aa58d633c$var$SeriesProperties.prototype, "visible", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN)
], $d77b025aa58d633c$var$SeriesProperties.prototype, "showInLegend", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING)
], $d77b025aa58d633c$var$SeriesProperties.prototype, "cursor", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$INTERACTION_RANGE)
], $d77b025aa58d633c$var$SeriesProperties.prototype, "nodeClickRange", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$SeriesProperties.prototype, "highlightStyle", 2);
// packages/ag-charts-community/src/chart/series/cartesian/cartesianSeries.ts
var $d77b025aa58d633c$var$DEFAULT_CARTESIAN_DIRECTION_KEYS = {
    ["x" /* X */ ]: [
        "xKey"
    ],
    ["y" /* Y */ ]: [
        "yKey"
    ]
};
var $d77b025aa58d633c$var$DEFAULT_CARTESIAN_DIRECTION_NAMES = {
    ["x" /* X */ ]: [
        "xName"
    ],
    ["y" /* Y */ ]: [
        "yName"
    ]
};
var $d77b025aa58d633c$var$CartesianSeriesNodeEvent = class extends $d77b025aa58d633c$var$SeriesNodeEvent {
    constructor(type, nativeEvent, datum, series){
        super(type, nativeEvent, datum, series);
        this.xKey = series.properties.xKey;
        this.yKey = series.properties.yKey;
    }
};
var $d77b025aa58d633c$var$CartesianSeriesProperties = class extends $d77b025aa58d633c$var$SeriesProperties {
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$CartesianSeriesProperties.prototype, "legendItemName", 2);
var $d77b025aa58d633c$var$CartesianSeries = class extends $d77b025aa58d633c$var$DataModelSeries {
    constructor(_a){
        var _b = _a, { pathsPerSeries: pathsPerSeries = 1, hasMarkers: hasMarkers = false, hasHighlightedLabels: hasHighlightedLabels = false, pathsZIndexSubOrderOffset: pathsZIndexSubOrderOffset = [], datumSelectionGarbageCollection: datumSelectionGarbageCollection = true, markerSelectionGarbageCollection: markerSelectionGarbageCollection = true, animationAlwaysUpdateSelections: animationAlwaysUpdateSelections = false, animationResetFns: animationResetFns, directionKeys: directionKeys, directionNames: directionNames } = _b, otherOpts = $d77b025aa58d633c$var$__objRest(_b, [
            "pathsPerSeries",
            "hasMarkers",
            "hasHighlightedLabels",
            "pathsZIndexSubOrderOffset",
            "datumSelectionGarbageCollection",
            "markerSelectionGarbageCollection",
            "animationAlwaysUpdateSelections",
            "animationResetFns",
            "directionKeys",
            "directionNames"
        ]);
        super($d77b025aa58d633c$var$__spreadValues({
            directionKeys: directionKeys,
            directionNames: directionNames,
            canHaveAxes: true
        }, otherOpts));
        this.NodeEvent = $d77b025aa58d633c$var$CartesianSeriesNodeEvent;
        this.dataNodeGroup = this.contentGroup.appendChild(new $d77b025aa58d633c$var$Group({
            name: `${this.id}-series-dataNodes`,
            zIndex: 4 /* SERIES_LAYER_ZINDEX */ ,
            zIndexSubOrder: this.getGroupZIndexSubOrder("data")
        }));
        this.markerGroup = this.contentGroup.appendChild(new $d77b025aa58d633c$var$Group({
            name: `${this.id}-series-markers`,
            zIndex: 4 /* SERIES_LAYER_ZINDEX */ ,
            zIndexSubOrder: this.getGroupZIndexSubOrder("marker")
        }));
        this.labelGroup = this.contentGroup.appendChild(new $d77b025aa58d633c$var$Group({
            name: `${this.id}-series-labels`,
            zIndex: 8 /* SERIES_LABEL_ZINDEX */ ,
            zIndexSubOrder: this.getGroupZIndexSubOrder("labels")
        }));
        this.labelSelection = $d77b025aa58d633c$var$Selection.select(this.labelGroup, $d77b025aa58d633c$var$Text);
        this.highlightSelection = $d77b025aa58d633c$var$Selection.select(this.highlightNode, ()=>this.opts.hasMarkers ? this.markerFactory() : this.nodeFactory());
        this.highlightLabelSelection = $d77b025aa58d633c$var$Selection.select(this.highlightLabel, $d77b025aa58d633c$var$Text);
        this.annotationSelections = /* @__PURE__ */ new Set();
        this.minRectsCache = {
            dirtyNodeData: true
        };
        this.debug = $d77b025aa58d633c$var$Debug.create();
        if (!directionKeys || !directionNames) throw new Error(`Unable to initialise series type ${this.type}`);
        this.opts = {
            pathsPerSeries: pathsPerSeries,
            hasMarkers: hasMarkers,
            hasHighlightedLabels: hasHighlightedLabels,
            pathsZIndexSubOrderOffset: pathsZIndexSubOrderOffset,
            directionKeys: directionKeys,
            directionNames: directionNames,
            animationResetFns: animationResetFns,
            animationAlwaysUpdateSelections: animationAlwaysUpdateSelections,
            datumSelectionGarbageCollection: datumSelectionGarbageCollection,
            markerSelectionGarbageCollection: markerSelectionGarbageCollection
        };
        this.paths = [];
        for(let index = 0; index < pathsPerSeries; index++){
            this.paths[index] = new $d77b025aa58d633c$var$Path();
            this.paths[index].zIndex = 4 /* SERIES_LAYER_ZINDEX */ ;
            this.paths[index].zIndexSubOrder = this.getGroupZIndexSubOrder("paths", index);
            this.contentGroup.appendChild(this.paths[index]);
        }
        this.datumSelection = $d77b025aa58d633c$var$Selection.select(this.dataNodeGroup, ()=>this.nodeFactory(), datumSelectionGarbageCollection);
        this.markerSelection = $d77b025aa58d633c$var$Selection.select(this.markerGroup, ()=>this.markerFactory(), markerSelectionGarbageCollection);
        this.animationState = new $d77b025aa58d633c$var$StateMachine("empty", {
            empty: {
                update: {
                    target: "ready",
                    action: (data)=>this.animateEmptyUpdateReady(data)
                },
                reset: "empty",
                skip: "ready",
                disable: "disabled"
            },
            ready: {
                updateData: "waiting",
                clear: "clearing",
                highlight: (data)=>this.animateReadyHighlight(data),
                highlightMarkers: (data)=>this.animateReadyHighlightMarkers(data),
                resize: (data)=>this.animateReadyResize(data),
                reset: "empty",
                skip: "ready",
                disable: "disabled"
            },
            waiting: {
                update: {
                    target: "ready",
                    action: (data)=>this.animateWaitingUpdateReady(data)
                },
                reset: "empty",
                skip: "ready",
                disable: "disabled"
            },
            disabled: {
                update: (data)=>this.resetAllAnimation(data),
                reset: "empty"
            },
            clearing: {
                update: {
                    target: "empty",
                    action: (data)=>this.animateClearingUpdateEmpty(data)
                },
                reset: "empty",
                skip: "ready"
            }
        }, ()=>this.checkProcessedDataAnimatable());
    }
    get contextNodeData() {
        return this._contextNodeData;
    }
    getNodeData() {
        var _a;
        return (_a = this.contextNodeData) == null ? void 0 : _a.nodeData;
    }
    resetAnimation(phase) {
        if (phase === "initial") this.animationState.transition("reset");
        else if (phase === "ready") this.animationState.transition("skip");
        else if (phase === "disabled") this.animationState.transition("disable");
    }
    addChartEventListeners() {
        this.destroyFns.push(this.ctx.chartEventManager.addListener("legend-item-click", (event)=>this.onLegendItemClick(event)), this.ctx.chartEventManager.addListener("legend-item-double-click", (event)=>this.onLegendItemDoubleClick(event)));
    }
    destroy() {
        super.destroy();
        this._contextNodeData = void 0;
    }
    update(_0) {
        return $d77b025aa58d633c$var$__async(this, arguments, function*({ seriesRect: seriesRect }) {
            var _a, _b;
            const { visible: visible, _contextNodeData: previousContextData } = this;
            const series = (_b = (_a = this.ctx.highlightManager) == null ? void 0 : _a.getActiveHighlight()) == null ? void 0 : _b.series;
            const seriesHighlighted = series === this;
            const resize = this.checkResize(seriesRect);
            const highlightItems = yield this.updateHighlightSelection(seriesHighlighted);
            yield this.updateSelections(visible);
            yield this.updateNodes(highlightItems, seriesHighlighted, visible);
            const animationData = this.getAnimationData(seriesRect, previousContextData);
            if (!animationData) return;
            if (resize) this.animationState.transition("resize", animationData);
            this.animationState.transition("update", animationData);
        });
    }
    updateSelections(anySeriesItemEnabled) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            var _a, _b;
            const animationSkipUpdate = !this.opts.animationAlwaysUpdateSelections && this.ctx.animationManager.isSkipped();
            if (!anySeriesItemEnabled && animationSkipUpdate) return;
            if (!this.nodeDataRefresh && !this.isPathOrSelectionDirty()) return;
            if (this.nodeDataRefresh) {
                this.nodeDataRefresh = false;
                this.debug(`CartesianSeries.updateSelections() - calling createNodeData() for`, this.id);
                this.markQuadtreeDirty();
                this._contextNodeData = yield this.createNodeData();
                const animationValid = this.isProcessedDataAnimatable();
                if (this._contextNodeData) (_b = (_a = this._contextNodeData).animationValid) != null ? _b : _a.animationValid = animationValid;
                this.minRectsCache.dirtyNodeData = true;
                const { dataModel: dataModel, processedData: processedData } = this;
                if (dataModel !== void 0 && processedData !== void 0) this.dispatch("data-update", {
                    dataModel: dataModel,
                    processedData: processedData
                });
            }
            yield this.updateSeriesSelections();
        });
    }
    updateSeriesSelections(seriesHighlighted) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            const { datumSelection: datumSelection, labelSelection: labelSelection, markerSelection: markerSelection, paths: paths } = this;
            const contextData = this._contextNodeData;
            if (!contextData) return;
            const { nodeData: nodeData, labelData: labelData, itemId: itemId } = contextData;
            yield this.updatePaths({
                seriesHighlighted: seriesHighlighted,
                itemId: itemId,
                contextData: contextData,
                paths: paths
            });
            this.datumSelection = yield this.updateDatumSelection({
                nodeData: nodeData,
                datumSelection: datumSelection
            });
            this.labelSelection = yield this.updateLabelSelection({
                labelData: labelData,
                labelSelection: labelSelection
            });
            if (this.opts.hasMarkers) this.markerSelection = yield this.updateMarkerSelection({
                nodeData: nodeData,
                markerSelection: markerSelection
            });
        });
    }
    markerFactory() {
        const MarkerShape = $d77b025aa58d633c$var$getMarker();
        return new MarkerShape();
    }
    getGroupZIndexSubOrder(type, subIndex = 0) {
        var _a;
        const result = super.getGroupZIndexSubOrder(type, subIndex);
        if (type === "paths") {
            const [superFn] = result;
            const pathOffset = (_a = this.opts.pathsZIndexSubOrderOffset[subIndex]) != null ? _a : 0;
            result[0] = $d77b025aa58d633c$var$isFunction(superFn) ? ()=>Number(superFn()) + pathOffset : Number(superFn) + pathOffset;
        }
        return result;
    }
    updateNodes(highlightedItems, seriesHighlighted, anySeriesItemEnabled) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            var _a;
            const { highlightSelection: highlightSelection, highlightLabelSelection: highlightLabelSelection, opts: { hasMarkers: hasMarkers, hasHighlightedLabels: hasHighlightedLabels } } = this;
            const animationEnabled = !this.ctx.animationManager.isSkipped();
            const visible = this.visible && this._contextNodeData != null && anySeriesItemEnabled;
            this.rootGroup.visible = animationEnabled || visible;
            this.contentGroup.visible = animationEnabled || visible;
            this.highlightGroup.visible = (animationEnabled || visible) && seriesHighlighted;
            const opacity = this.getOpacity();
            if (hasMarkers) {
                yield this.updateMarkerNodes({
                    markerSelection: highlightSelection,
                    isHighlight: true
                });
                this.animationState.transition("highlightMarkers", highlightSelection);
            } else {
                yield this.updateDatumNodes({
                    datumSelection: highlightSelection,
                    isHighlight: true
                });
                this.animationState.transition("highlight", highlightSelection);
            }
            if (hasHighlightedLabels) yield this.updateLabelNodes({
                labelSelection: highlightLabelSelection
            });
            const { dataNodeGroup: dataNodeGroup, markerGroup: markerGroup, datumSelection: datumSelection, labelSelection: labelSelection, markerSelection: markerSelection, paths: paths, labelGroup: labelGroup } = this;
            const { itemId: itemId } = (_a = this.contextNodeData) != null ? _a : {};
            dataNodeGroup.opacity = opacity;
            dataNodeGroup.visible = animationEnabled || visible;
            labelGroup.visible = visible;
            if (hasMarkers) {
                markerGroup.opacity = opacity;
                markerGroup.zIndex = dataNodeGroup.zIndex >= 4 /* SERIES_LAYER_ZINDEX */  ? dataNodeGroup.zIndex : dataNodeGroup.zIndex + 1;
                markerGroup.visible = visible;
            }
            if (labelGroup) labelGroup.opacity = opacity;
            yield this.updatePathNodes({
                seriesHighlighted: seriesHighlighted,
                itemId: itemId,
                paths: paths,
                opacity: opacity,
                visible: visible,
                animationEnabled: animationEnabled
            });
            if (!dataNodeGroup.visible) return;
            yield this.updateDatumNodes({
                datumSelection: datumSelection,
                highlightedItems: highlightedItems,
                isHighlight: false
            });
            yield this.updateLabelNodes({
                labelSelection: labelSelection
            });
            if (hasMarkers) yield this.updateMarkerNodes({
                markerSelection: markerSelection,
                isHighlight: false
            });
        });
    }
    getHighlightLabelData(labelData, highlightedItem) {
        const labelItems = labelData.filter((ld)=>ld.datum === highlightedItem.datum && ld.itemId === highlightedItem.itemId);
        return labelItems.length === 0 ? void 0 : labelItems;
    }
    getHighlightData(_nodeData, highlightedItem) {
        return highlightedItem ? [
            highlightedItem
        ] : void 0;
    }
    updateHighlightSelection(seriesHighlighted) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            var _a;
            const { highlightSelection: highlightSelection, highlightLabelSelection: highlightLabelSelection, _contextNodeData: contextNodeData } = this;
            if (!contextNodeData) return;
            const highlightedDatum = (_a = this.ctx.highlightManager) == null ? void 0 : _a.getActiveHighlight();
            const item = seriesHighlighted && (highlightedDatum == null ? void 0 : highlightedDatum.datum) ? highlightedDatum : void 0;
            let labelItems;
            let highlightItems;
            if (item != null) {
                const labelsEnabled = this.isLabelEnabled();
                const { labelData: labelData, nodeData: nodeData } = contextNodeData;
                highlightItems = this.getHighlightData(nodeData, item);
                labelItems = labelsEnabled ? this.getHighlightLabelData(labelData, item) : void 0;
            }
            this.highlightSelection = yield this.updateHighlightSelectionItem({
                items: highlightItems,
                highlightSelection: highlightSelection
            });
            this.highlightLabelSelection = yield this.updateHighlightSelectionLabel({
                items: labelItems,
                highlightLabelSelection: highlightLabelSelection
            });
            return highlightItems;
        });
    }
    markQuadtreeDirty() {
        this.quadtree = void 0;
    }
    *datumNodesIter() {
        for (const { node: node } of this.datumSelection){
            if (node.datum.missing === true) continue;
            yield node;
        }
    }
    getQuadTree() {
        if (this.quadtree === void 0) {
            const { width: width, height: height } = this.ctx.scene.canvas;
            const canvasRect = new $d77b025aa58d633c$var$BBox(0, 0, width, height);
            this.quadtree = new $d77b025aa58d633c$var$QuadtreeNearest(100, 10, canvasRect);
            this.initQuadTree(this.quadtree);
        }
        return this.quadtree;
    }
    initQuadTree(_quadtree) {}
    pickNodeExactShape(point) {
        var _a;
        const result = super.pickNodeExactShape(point);
        if (result) return result;
        const { x: x, y: y } = point;
        const { opts: { hasMarkers: hasMarkers } } = this;
        let match;
        const { dataNodeGroup: dataNodeGroup, markerGroup: markerGroup } = this;
        match = dataNodeGroup.pickNode(x, y);
        if (!match && hasMarkers) match = markerGroup == null ? void 0 : markerGroup.pickNode(x, y);
        if (match && match.datum.missing !== true) return {
            datum: match.datum,
            distance: 0
        };
        for (const mod2 of this.moduleMap.modules()){
            const { datum: datum } = (_a = mod2.pickNodeExact(point)) != null ? _a : {};
            if (datum == null) continue;
            if ((datum == null ? void 0 : datum.missing) === true) continue;
            return {
                datum: datum,
                distance: 0
            };
        }
    }
    pickNodeClosestDatum(point) {
        var _a, _b;
        const { x: x, y: y } = point;
        const { axes: axes, rootGroup: rootGroup, _contextNodeData: contextNodeData } = this;
        if (!contextNodeData) return;
        const xAxis = axes["x" /* X */ ];
        const yAxis = axes["y" /* Y */ ];
        const hitPoint = rootGroup.transformPoint(x, y);
        let minDistance = Infinity;
        let closestDatum;
        for (const datum of contextNodeData.nodeData){
            const { point: { x: datumX = NaN, y: datumY = NaN } = {} } = datum;
            if (isNaN(datumX) || isNaN(datumY)) continue;
            const isInRange = (xAxis == null ? void 0 : xAxis.inRange(datumX)) && (yAxis == null ? void 0 : yAxis.inRange(datumY));
            if (!isInRange) continue;
            const distance2 = Math.max($d77b025aa58d633c$var$__pow(hitPoint.x - datumX, 2) + $d77b025aa58d633c$var$__pow(hitPoint.y - datumY, 2), 0);
            if (distance2 < minDistance) {
                minDistance = distance2;
                closestDatum = datum;
            }
        }
        for (const mod2 of this.moduleMap.modules()){
            const modPick = mod2.pickNodeNearest(point);
            if (modPick !== void 0 && modPick.distanceSquared < minDistance) {
                minDistance = modPick.distanceSquared;
                closestDatum = modPick.datum;
                break;
            }
        }
        if (closestDatum) {
            const distance2 = Math.max(Math.sqrt(minDistance) - ((_b = (_a = closestDatum.point) == null ? void 0 : _a.size) != null ? _b : 0), 0);
            return {
                datum: closestDatum,
                distance: distance2
            };
        }
    }
    pickNodeMainAxisFirst(point, requireCategoryAxis) {
        var _a, _b, _c, _d;
        const { x: x, y: y } = point;
        const { axes: axes, rootGroup: rootGroup, _contextNodeData: contextNodeData } = this;
        if (!contextNodeData) return;
        const xAxis = axes["x" /* X */ ];
        const yAxis = axes["y" /* Y */ ];
        const directions2 = [
            xAxis,
            yAxis
        ].filter((a)=>a instanceof $d77b025aa58d633c$var$CategoryAxis).map((a)=>a.direction);
        if (requireCategoryAxis && directions2.length === 0) return;
        const [primaryDirection = "x" /* X */ ] = directions2;
        const hitPoint = rootGroup.transformPoint(x, y);
        const hitPointCoords = primaryDirection === "x" /* X */  ? [
            hitPoint.x,
            hitPoint.y
        ] : [
            hitPoint.y,
            hitPoint.x
        ];
        const minDistance = [
            Infinity,
            Infinity
        ];
        let closestDatum;
        for (const datum of contextNodeData.nodeData){
            const { x: datumX = NaN, y: datumY = NaN } = (_b = (_a = datum.point) != null ? _a : datum.midPoint) != null ? _b : {};
            if (isNaN(datumX) || isNaN(datumY) || datum.missing === true) continue;
            const isInRange = (xAxis == null ? void 0 : xAxis.inRange(datumX)) && (yAxis == null ? void 0 : yAxis.inRange(datumY));
            if (!isInRange) continue;
            const datumPoint = primaryDirection === "x" /* X */  ? [
                datumX,
                datumY
            ] : [
                datumY,
                datumX
            ];
            let newMinDistance = true;
            for(let i = 0; i < datumPoint.length; i++){
                const dist = Math.abs(datumPoint[i] - hitPointCoords[i]);
                if (dist > minDistance[i]) {
                    newMinDistance = false;
                    break;
                }
                if (dist < minDistance[i]) {
                    minDistance[i] = dist;
                    minDistance.fill(Infinity, i + 1, minDistance.length);
                }
            }
            if (newMinDistance) closestDatum = datum;
        }
        if (closestDatum) {
            let closestDistanceSquared = Math.max($d77b025aa58d633c$var$__pow(minDistance[0], 2) + $d77b025aa58d633c$var$__pow(minDistance[1], 2) - ((_d = (_c = closestDatum.point) == null ? void 0 : _c.size) != null ? _d : 0), 0);
            for (const mod2 of this.moduleMap.modules()){
                const modPick = mod2.pickNodeMainAxisFirst(point);
                if (modPick !== void 0 && modPick.distanceSquared < closestDistanceSquared) {
                    closestDatum = modPick.datum;
                    closestDistanceSquared = modPick.distanceSquared;
                    break;
                }
            }
            return {
                datum: closestDatum,
                distance: Math.sqrt(closestDistanceSquared)
            };
        }
    }
    onLegendItemClick(event) {
        const { legendItemName: legendItemName } = this.properties;
        const { enabled: enabled, itemId: itemId, series: series } = event;
        const matchedLegendItemName = legendItemName != null && legendItemName === event.legendItemName;
        if (series.id === this.id || matchedLegendItemName) this.toggleSeriesItem(itemId, enabled);
    }
    onLegendItemDoubleClick(event) {
        const { enabled: enabled, itemId: itemId, series: series, numVisibleItems: numVisibleItems } = event;
        const { legendItemName: legendItemName } = this.properties;
        const matchedLegendItemName = legendItemName != null && legendItemName === event.legendItemName;
        if (series.id === this.id || matchedLegendItemName) this.toggleSeriesItem(itemId, true);
        else if (enabled && numVisibleItems === 1) this.toggleSeriesItem(itemId, true);
        else this.toggleSeriesItem(itemId, false);
    }
    isPathOrSelectionDirty() {
        return false;
    }
    getLabelData() {
        return [];
    }
    shouldFlipXY() {
        return false;
    }
    /**
   * Get the minimum bounding box that contains any adjacent two nodes. The axes are treated independently, so this
   * may not represent the same two points for both directions. The dimensions represent the greatest distance
   * between any two adjacent nodes.
   */ getMinRects(width, height) {
        const { dirtyNodeData: dirtyNodeData, sizeCache: sizeCache, minRect: minRect, minVisibleRect: minVisibleRect } = this.minRectsCache;
        const newSizeCache = JSON.stringify({
            width: width,
            height: height
        });
        const dirtySize = newSizeCache !== sizeCache;
        if (!dirtySize && !dirtyNodeData && minRect && minVisibleRect) return {
            minRect: minRect,
            minVisibleRect: minVisibleRect
        };
        const rects = this.computeMinRects(width, height);
        this.minRectsCache = {
            dirtyNodeData: false,
            sizeCache: newSizeCache,
            minRect: rects == null ? void 0 : rects.minRect,
            minVisibleRect: rects == null ? void 0 : rects.minVisibleRect
        };
        return rects;
    }
    computeMinRects(width, height) {
        var _a, _b;
        const context = this._contextNodeData;
        if (!(context == null ? void 0 : context.nodeData.length)) return;
        const { nodeData: nodeData } = context;
        const minRectXs = Array(nodeData.length);
        const minRectYs = Array(nodeData.length);
        for (const [i, { midPoint: midPoint }] of nodeData.entries()){
            minRectXs[i] = (_a = midPoint == null ? void 0 : midPoint.x) != null ? _a : 0;
            minRectYs[i] = (_b = midPoint == null ? void 0 : midPoint.y) != null ? _b : 0;
        }
        minRectXs.sort((a, b)=>a - b);
        minRectYs.sort((a, b)=>a - b);
        let zeroX, widthX, zeroY, heightY;
        let maxWidth = 0;
        let maxHeight = 0;
        for(let i = 1; i < nodeData.length; i++){
            if (minRectXs[i] >= 0) zeroX != null ? zeroX : zeroX = i;
            if (minRectXs[i] > width) widthX != null ? widthX : widthX = i;
            if (minRectYs[i] >= 0) zeroY != null ? zeroY : zeroY = i;
            if (minRectYs[i] > height) heightY != null ? heightY : heightY = i;
            maxWidth = Math.max(maxWidth, minRectXs[i] - minRectXs[i - 1]);
            maxHeight = Math.max(maxHeight, minRectYs[i] - minRectYs[i - 1]);
        }
        widthX != null ? widthX : widthX = nodeData.length;
        heightY != null ? heightY : heightY = nodeData.length;
        const minVisibleRectXs = zeroX != null && widthX != null ? minRectXs.slice(zeroX, widthX) : [];
        const minVisibleRectYs = zeroY != null && heightY != null ? minRectYs.slice(zeroY, heightY) : [];
        let maxVisibleWidth = 0;
        let maxVisibleHeight = 0;
        for(let i = 1; i < Math.max(minVisibleRectXs.length, minVisibleRectYs.length); i++){
            const x1 = minVisibleRectXs[i];
            const x2 = minVisibleRectXs[i - 1];
            const y1 = minVisibleRectYs[i];
            const y2 = minVisibleRectYs[i - 1];
            if (x1 != null && x2 != null) maxVisibleWidth = Math.max(maxVisibleWidth, x1 - x2);
            if (y1 != null && y2 != null) maxVisibleHeight = Math.max(maxVisibleHeight, y1 - y2);
        }
        const minRect = new $d77b025aa58d633c$var$BBox(0, 0, maxWidth, maxHeight);
        const minVisibleRect = new $d77b025aa58d633c$var$BBox(0, 0, maxVisibleWidth, maxVisibleHeight);
        return {
            minRect: minRect,
            minVisibleRect: minVisibleRect
        };
    }
    updateHighlightSelectionItem(opts) {
        const { opts: { hasMarkers: hasMarkers } } = this;
        const { items: items, highlightSelection: highlightSelection } = opts;
        const nodeData = items != null ? items : [];
        if (hasMarkers) {
            const markerSelection = highlightSelection;
            return this.updateMarkerSelection({
                nodeData: nodeData,
                markerSelection: markerSelection
            });
        } else return this.updateDatumSelection({
            nodeData: nodeData,
            datumSelection: highlightSelection
        });
    }
    updateHighlightSelectionLabel(opts) {
        var _a;
        return this.updateLabelSelection({
            labelData: (_a = opts.items) != null ? _a : [],
            labelSelection: opts.highlightLabelSelection
        });
    }
    updateDatumSelection(opts) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            return opts.datumSelection;
        });
    }
    updateDatumNodes(_opts) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {});
    }
    updateMarkerSelection(opts) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            return opts.markerSelection;
        });
    }
    updateMarkerNodes(_opts) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {});
    }
    updatePaths(opts) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            opts.paths.forEach((p)=>p.visible = false);
        });
    }
    updatePathNodes(opts) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            const { paths: paths, opacity: opacity, visible: visible } = opts;
            for (const path of paths){
                path.opacity = opacity;
                path.visible = visible;
            }
        });
    }
    resetAllAnimation(data) {
        var _a, _b, _c;
        const { path: path, datum: datum, label: label, marker: marker } = (_b = (_a = this.opts) == null ? void 0 : _a.animationResetFns) != null ? _b : {};
        this.ctx.animationManager.stopByAnimationGroupId(this.id);
        if (path) data.paths.forEach((paths)=>{
            $d77b025aa58d633c$var$resetMotion([
                paths
            ], path);
        });
        if (datum) $d77b025aa58d633c$var$resetMotion([
            data.datumSelection
        ], datum);
        if (label) $d77b025aa58d633c$var$resetMotion([
            data.labelSelection
        ], label);
        if (marker && this.opts.hasMarkers) $d77b025aa58d633c$var$resetMotion([
            data.markerSelection
        ], marker);
        if (((_c = data.contextData) == null ? void 0 : _c.animationValid) === false) this.ctx.animationManager.skipCurrentBatch();
    }
    animateEmptyUpdateReady(data) {
        this.ctx.animationManager.skipCurrentBatch();
        this.resetAllAnimation(data);
    }
    animateWaitingUpdateReady(data) {
        this.ctx.animationManager.skipCurrentBatch();
        this.resetAllAnimation(data);
    }
    animateReadyHighlight(data) {
        var _a, _b;
        const { datum: datum } = (_b = (_a = this.opts) == null ? void 0 : _a.animationResetFns) != null ? _b : {};
        if (datum) $d77b025aa58d633c$var$resetMotion([
            data
        ], datum);
    }
    animateReadyHighlightMarkers(data) {
        var _a, _b;
        const { marker: marker } = (_b = (_a = this.opts) == null ? void 0 : _a.animationResetFns) != null ? _b : {};
        if (marker) $d77b025aa58d633c$var$resetMotion([
            data
        ], marker);
    }
    animateReadyResize(data) {
        this.resetAllAnimation(data);
    }
    animateClearingUpdateEmpty(data) {
        this.ctx.animationManager.skipCurrentBatch();
        this.resetAllAnimation(data);
    }
    animationTransitionClear() {
        const animationData = this.getAnimationData();
        if (!animationData) return;
        this.animationState.transition("clear", animationData);
    }
    getAnimationData(seriesRect, previousContextData) {
        const { _contextNodeData: contextData } = this;
        if (!contextData) return;
        const animationData = {
            datumSelection: this.datumSelection,
            markerSelection: this.markerSelection,
            labelSelection: this.labelSelection,
            annotationSelections: [
                ...this.annotationSelections
            ],
            contextData: contextData,
            previousContextData: previousContextData,
            paths: this.paths,
            seriesRect: seriesRect
        };
        return animationData;
    }
    calculateScaling() {
        const result = {};
        for (const direction of Object.values($d77b025aa58d633c$var$ChartAxisDirection)){
            const axis = this.axes[direction];
            if (!axis) continue;
            if (axis.scale instanceof $d77b025aa58d633c$var$LogScale) {
                const { range: range3, domain: domain } = axis.scale;
                result[direction] = {
                    type: "log",
                    convert: (d)=>axis.scale.convert(d),
                    domain: [
                        domain[0],
                        domain[1]
                    ],
                    range: [
                        range3[0],
                        range3[1]
                    ]
                };
            } else if (axis.scale instanceof $d77b025aa58d633c$var$ContinuousScale) {
                const { range: range3 } = axis.scale;
                const domain = axis.scale.getDomain();
                result[direction] = {
                    type: "continuous",
                    domain: [
                        domain[0],
                        domain[1]
                    ],
                    range: [
                        range3[0],
                        range3[1]
                    ]
                };
            } else if (axis.scale) {
                const { domain: domain } = axis.scale;
                result[direction] = {
                    type: "category",
                    domain: domain,
                    range: domain.map((d)=>axis.scale.convert(d))
                };
            }
        }
        return result;
    }
};
// packages/ag-charts-community/src/chart/cartesianChart.ts
var $d77b025aa58d633c$var$directions = [
    "top",
    "right",
    "bottom",
    "left"
];
var $d77b025aa58d633c$var$_CartesianChart = class _CartesianChart extends $d77b025aa58d633c$var$Chart {
    constructor(options, resources){
        super(options, resources);
        /** Integrated Charts feature state - not used in Standalone Charts. */ this.paired = true;
        this.firstSeriesTranslation = true;
        this._lastCrossLineIds = void 0;
        this._lastAxisWidths = {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0
        };
        this._lastClipSeries = false;
        this._lastVisibility = {
            crossLines: true,
            series: true
        };
    }
    onAxisChange(newValue, oldValue) {
        super.onAxisChange(newValue, oldValue);
        this.zoomManager.updateAxes(newValue);
    }
    destroySeries(series) {
        super.destroySeries(series);
        this.firstSeriesTranslation = true;
    }
    performLayout() {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            const shrinkRect = yield $d77b025aa58d633c$var$__superGet(_CartesianChart.prototype, this, "performLayout").call(this);
            const { firstSeriesTranslation: firstSeriesTranslation, seriesRoot: seriesRoot, annotationRoot: annotationRoot, highlightRoot: highlightRoot } = this;
            const { animationRect: animationRect, seriesRect: seriesRect, visibility: visibility, clipSeries: clipSeries } = this.updateAxes(shrinkRect);
            this.seriesRoot.visible = visibility.series;
            this.seriesRect = seriesRect;
            this.animationRect = animationRect;
            const { x: x, y: y } = seriesRect;
            if (firstSeriesTranslation) {
                for (const group2 of [
                    seriesRoot,
                    annotationRoot,
                    highlightRoot
                ]){
                    group2.translationX = Math.floor(x);
                    group2.translationY = Math.floor(y);
                }
                this.firstSeriesTranslation = false;
            } else {
                const { translationX: translationX, translationY: translationY } = seriesRoot;
                $d77b025aa58d633c$var$staticFromToMotion(this.id, "seriesRect", this.ctx.animationManager, [
                    seriesRoot,
                    highlightRoot,
                    annotationRoot
                ], {
                    translationX: translationX,
                    translationY: translationY
                }, {
                    translationX: Math.floor(x),
                    translationY: Math.floor(y)
                }, {
                    phase: "update"
                });
            }
            const seriesPaddedRect = seriesRect.clone().grow(this.seriesArea.padding);
            this.hoverRect = seriesPaddedRect;
            const clipRect = this.seriesArea.clip || clipSeries ? seriesPaddedRect : void 0;
            seriesRoot.setClipRectInGroupCoordinateSpace(clipRect);
            highlightRoot.setClipRectInGroupCoordinateSpace(clipRect);
            annotationRoot.setClipRectInGroupCoordinateSpace(clipRect);
            this.ctx.layoutService.dispatchLayoutComplete({
                type: "layout-complete",
                chart: {
                    width: this.ctx.scene.width,
                    height: this.ctx.scene.height
                },
                clipSeries: clipSeries,
                series: {
                    rect: seriesRect,
                    paddedRect: seriesPaddedRect,
                    visible: visibility.series,
                    shouldFlipXY: this.shouldFlipXY()
                },
                axes: this.axes.map((axis)=>$d77b025aa58d633c$var$__spreadValues({
                        id: axis.id
                    }, axis.getLayoutState()))
            });
            const modulePromises = this.modulesManager.mapModules((m)=>{
                var _a;
                return (_a = m.performCartesianLayout) == null ? void 0 : _a.call(m, {
                    seriesRect: seriesRect
                });
            });
            yield Promise.all(modulePromises);
            return shrinkRect;
        });
    }
    updateAxes(inputShrinkRect) {
        var _a;
        const crossLineIds = this.axes.flatMap((axis)=>{
            var _a2;
            return (_a2 = axis.crossLines) != null ? _a2 : [];
        }).map((crossLine)=>crossLine.id);
        const axesValid = this._lastCrossLineIds != null && this._lastCrossLineIds.length === crossLineIds.length && this._lastCrossLineIds.every((id, index)=>crossLineIds[index] === id);
        let axisWidths;
        let clipSeries;
        let visibility;
        if (axesValid) {
            axisWidths = $d77b025aa58d633c$var$__spreadValues({}, this._lastAxisWidths);
            clipSeries = this._lastClipSeries;
            visibility = $d77b025aa58d633c$var$__spreadValues({}, this._lastVisibility);
        } else {
            axisWidths = {
                top: 0,
                bottom: 0,
                left: 0,
                right: 0
            };
            clipSeries = false;
            visibility = {
                crossLines: true,
                series: true
            };
            this._lastCrossLineIds = crossLineIds;
        }
        const liveAxisWidths = new Set(this.axes.map((a)=>a.position));
        for (const position of Object.keys(axisWidths))if (!liveAxisWidths.has(position)) delete axisWidths[position];
        const stableOutputs = (otherAxisWidths, otherClipSeries, otherVisibility)=>{
            if (Object.keys(otherAxisWidths).some((k)=>axisWidths[k] == null)) return false;
            return visibility.crossLines === otherVisibility.crossLines && visibility.series === otherVisibility.series && // Check for existing axis positions and equality.
            Object.entries(axisWidths).every(([p, w])=>{
                const otherW = otherAxisWidths[p];
                if (w != null || otherW != null) return w === otherW;
                return true;
            }) && clipSeries === otherClipSeries;
        };
        const ceilValues = (records)=>$d77b025aa58d633c$var$mapValues(records, (value)=>{
                if (value && Math.abs(value) === Infinity) return 0;
                return value != null ? Math.ceil(value) : value;
            });
        let lastPassAxisWidths = {};
        let lastPassVisibility = {};
        let lastPassClipSeries = false;
        let seriesRect = (_a = this.seriesRect) == null ? void 0 : _a.clone();
        let count = 0;
        let primaryTickCounts = {};
        do {
            Object.assign(axisWidths, lastPassAxisWidths);
            clipSeries = lastPassClipSeries;
            Object.assign(visibility, lastPassVisibility);
            const result = this.updateAxesPass(axisWidths, inputShrinkRect.clone(), seriesRect);
            lastPassAxisWidths = ceilValues(result.axisWidths);
            lastPassVisibility = result.visibility;
            lastPassClipSeries = result.clipSeries;
            seriesRect = result.seriesRect;
            primaryTickCounts = result.primaryTickCounts;
            if (count++ > 10) {
                $d77b025aa58d633c$var$Logger.warn("unable to find stable axis layout.");
                break;
            }
        }while (!stableOutputs(lastPassAxisWidths, lastPassClipSeries, lastPassVisibility));
        this.axes.forEach((axis)=>{
            axis.update(primaryTickCounts[axis.direction]);
        });
        const clipRectPadding = 5;
        this.axes.forEach((axis)=>{
            axis.setCrossLinesVisible(visibility.crossLines);
            if (!seriesRect) return;
            axis.clipGrid(seriesRect.x, seriesRect.y, seriesRect.width + clipRectPadding, seriesRect.height + clipRectPadding);
            switch(axis.position){
                case "left":
                case "right":
                    axis.clipTickLines(inputShrinkRect.x, seriesRect.y, inputShrinkRect.width + clipRectPadding, seriesRect.height + clipRectPadding);
                    break;
                case "top":
                case "bottom":
                    axis.clipTickLines(seriesRect.x, inputShrinkRect.y, seriesRect.width + clipRectPadding, inputShrinkRect.height + clipRectPadding);
                    break;
            }
        });
        this._lastAxisWidths = axisWidths;
        this._lastVisibility = visibility;
        return {
            seriesRect: seriesRect,
            animationRect: inputShrinkRect,
            visibility: visibility,
            clipSeries: clipSeries
        };
    }
    updateAxesPass(axisWidths, bounds, lastPassSeriesRect) {
        const visited = {};
        const newAxisWidths = {};
        const visibility = {
            series: true,
            crossLines: true
        };
        let clipSeries = false;
        const primaryTickCounts = {};
        const paddedBounds = this.applySeriesPadding(bounds);
        const crossLinePadding = lastPassSeriesRect ? this.buildCrossLinePadding(axisWidths) : {};
        const axisBound = this.buildAxisBound(paddedBounds, axisWidths, crossLinePadding, visibility);
        const seriesRect = this.buildSeriesRect(axisBound, axisWidths);
        this.axes.forEach((axis)=>{
            var _a, _b;
            const { position: position = "left" } = axis;
            const { clipSeries: newClipSeries, axisThickness: axisThickness, axisOffset: axisOffset } = this.calculateAxisDimensions({
                axis: axis,
                seriesRect: seriesRect,
                paddedBounds: paddedBounds,
                axisWidths: axisWidths,
                newAxisWidths: newAxisWidths,
                primaryTickCounts: primaryTickCounts,
                clipSeries: clipSeries,
                addInterAxisPadding: ((_a = visited[position]) != null ? _a : 0) > 0
            });
            visited[position] = ((_b = visited[position]) != null ? _b : 0) + 1;
            clipSeries = clipSeries || newClipSeries;
            this.positionAxis({
                axis: axis,
                axisBound: axisBound,
                axisOffset: axisOffset,
                axisThickness: axisThickness,
                axisWidths: axisWidths,
                primaryTickCounts: primaryTickCounts,
                seriesRect: seriesRect
            });
        });
        return {
            clipSeries: clipSeries,
            seriesRect: seriesRect,
            axisWidths: newAxisWidths,
            visibility: visibility,
            primaryTickCounts: primaryTickCounts
        };
    }
    buildCrossLinePadding(axisWidths) {
        var _a;
        const crossLinePadding = {};
        this.axes.forEach((axis)=>{
            if (axis.crossLines) axis.crossLines.forEach((crossLine)=>{
                var _a2;
                (_a2 = crossLine.calculatePadding) == null || _a2.call(crossLine, crossLinePadding);
            });
        });
        for (const [side, padding = 0] of Object.entries(crossLinePadding))crossLinePadding[side] = Math.max(padding - ((_a = axisWidths[side]) != null ? _a : 0), 0);
        return crossLinePadding;
    }
    applySeriesPadding(bounds) {
        const paddedRect = bounds.clone();
        const reversedAxes = this.axes.slice().reverse();
        $d77b025aa58d633c$var$directions.forEach((dir)=>{
            const padding = this.seriesArea.padding[dir];
            const axis = reversedAxes.find((a)=>a.position === dir);
            if (axis) axis.seriesAreaPadding = padding;
            else paddedRect.shrink(padding, dir);
        });
        return paddedRect;
    }
    buildAxisBound(bounds, axisWidths, crossLinePadding, visibility) {
        var _a, _b, _c, _d;
        const result = bounds.clone();
        const { top: top = 0, right: right = 0, bottom: bottom = 0, left: left = 0 } = crossLinePadding;
        const horizontalPadding = left + right;
        const verticalPadding = top + bottom;
        const totalWidth = ((_a = axisWidths.left) != null ? _a : 0) + ((_b = axisWidths.right) != null ? _b : 0) + horizontalPadding;
        const totalHeight = ((_c = axisWidths.top) != null ? _c : 0) + ((_d = axisWidths.bottom) != null ? _d : 0) + verticalPadding;
        if (result.width <= totalWidth || result.height <= totalHeight) {
            visibility.crossLines = false;
            visibility.series = false;
            return result;
        }
        result.x += left;
        result.y += top;
        result.width -= horizontalPadding;
        result.height -= verticalPadding;
        return result;
    }
    buildSeriesRect(axisBound, axisWidths) {
        const result = axisBound.clone();
        const { top: top, bottom: bottom, left: left, right: right } = axisWidths;
        result.x += left != null ? left : 0;
        result.y += top != null ? top : 0;
        result.width -= (left != null ? left : 0) + (right != null ? right : 0);
        result.height -= (top != null ? top : 0) + (bottom != null ? bottom : 0);
        result.width = Math.max(0, result.width);
        result.height = Math.max(0, result.height);
        return result;
    }
    clampToOutsideSeriesRect(seriesRect, value, dimension, direction) {
        const { x: x, y: y, width: width, height: height } = seriesRect;
        const clampBounds = [
            x,
            y,
            x + width,
            y + height
        ];
        const compareTo = clampBounds[(dimension === "x" ? 0 : 1) + (direction === 1 ? 0 : 2)];
        const clampFn = direction === 1 ? Math.min : Math.max;
        return clampFn(value, compareTo);
    }
    calculateAxisDimensions(opts) {
        var _a, _b, _c, _d;
        const { axis: axis, seriesRect: seriesRect, paddedBounds: paddedBounds, axisWidths: axisWidths, newAxisWidths: newAxisWidths, primaryTickCounts: primaryTickCounts, addInterAxisPadding: addInterAxisPadding } = opts;
        let { clipSeries: clipSeries } = opts;
        const { position: position = "left", direction: direction } = axis;
        const isCategory = axis instanceof $d77b025aa58d633c$var$CategoryAxis || axis instanceof $d77b025aa58d633c$var$GroupedCategoryAxis;
        const isLeftRight = position === "left" || position === "right";
        const axisOffset = (_a = newAxisWidths[position]) != null ? _a : 0;
        const { min: min, max: max } = this.ctx.zoomManager.getAxisZoom(axis.id);
        if (isLeftRight) {
            if (isCategory) {
                axis.range = [
                    0,
                    seriesRect.height
                ];
                axis.visibleRange = [
                    1 - max,
                    1 - min
                ];
            } else {
                axis.range = [
                    seriesRect.height,
                    0
                ];
                axis.visibleRange = [
                    min,
                    max
                ];
            }
            axis.gridLength = seriesRect.width;
        } else {
            axis.range = [
                0,
                seriesRect.width
            ];
            axis.visibleRange = [
                min,
                max
            ];
            axis.gridLength = seriesRect.height;
        }
        let primaryTickCount = axis.nice ? primaryTickCounts[direction] : void 0;
        const isVertical = direction === "y" /* Y */ ;
        const paddedBoundsCoefficient = 0.3;
        if (axis.thickness) axis.maxThickness = axis.thickness;
        else axis.maxThickness = (isVertical ? paddedBounds.width : paddedBounds.height) * paddedBoundsCoefficient;
        const layout = axis.calculateLayout(primaryTickCount);
        primaryTickCount = layout.primaryTickCount;
        (_b = primaryTickCounts[direction]) != null ? _b : primaryTickCounts[direction] = primaryTickCount;
        clipSeries || (clipSeries = axis.dataDomain.clipped || axis.visibleRange[0] > 0 || axis.visibleRange[1] < 1);
        let axisThickness;
        if (axis.thickness != null && axis.thickness > 0) axisThickness = axis.thickness;
        else {
            const { bbox: bbox } = layout;
            axisThickness = isVertical ? bbox.width : bbox.height;
        }
        const axisPadding = 15;
        if (addInterAxisPadding) axisThickness += axisPadding;
        axisThickness = Math.ceil(axisThickness);
        newAxisWidths[position] = ((_c = newAxisWidths[position]) != null ? _c : 0) + axisThickness;
        axis.gridPadding = ((_d = axisWidths[position]) != null ? _d : 0) - newAxisWidths[position];
        return {
            clipSeries: clipSeries,
            axisThickness: axisThickness,
            axisOffset: axisOffset,
            primaryTickCount: primaryTickCount
        };
    }
    positionAxis(opts) {
        var _a, _b, _c, _d;
        const { axis: axis, axisBound: axisBound, axisWidths: axisWidths, seriesRect: seriesRect, axisOffset: axisOffset, axisThickness: axisThickness } = opts;
        const { position: position } = axis;
        switch(position){
            case "top":
                axis.translation.x = axisBound.x + ((_a = axisWidths.left) != null ? _a : 0);
                axis.translation.y = this.clampToOutsideSeriesRect(seriesRect, axisBound.y + 1 + axisOffset + axisThickness, "y", 1);
                break;
            case "bottom":
                axis.translation.x = axisBound.x + ((_b = axisWidths.left) != null ? _b : 0);
                axis.translation.y = this.clampToOutsideSeriesRect(seriesRect, axisBound.y + axisBound.height + 1 - axisThickness - axisOffset, "y", -1);
                break;
            case "left":
                axis.translation.y = axisBound.y + ((_c = axisWidths.top) != null ? _c : 0);
                axis.translation.x = this.clampToOutsideSeriesRect(seriesRect, axisBound.x + axisOffset + axisThickness, "x", 1);
                break;
            case "right":
                axis.translation.y = axisBound.y + ((_d = axisWidths.top) != null ? _d : 0);
                axis.translation.x = this.clampToOutsideSeriesRect(seriesRect, axisBound.x + axisBound.width - axisThickness - axisOffset, "x", -1);
                break;
        }
        axis.updatePosition({
            rotation: $d77b025aa58d633c$var$toRadians(axis.rotation),
            sideFlag: axis.label.getSideFlag()
        });
    }
    shouldFlipXY() {
        return !this.series.some((series)=>!(series instanceof $d77b025aa58d633c$var$CartesianSeries && series.shouldFlipXY()));
    }
};
$d77b025aa58d633c$var$_CartesianChart.className = "CartesianChart";
$d77b025aa58d633c$var$_CartesianChart.type = "cartesian";
var $d77b025aa58d633c$var$CartesianChart = $d77b025aa58d633c$var$_CartesianChart;
// packages/ag-charts-community/src/chart/chartProxy.ts
var $d77b025aa58d633c$var$_AgChartInstanceProxy = class _AgChartInstanceProxy {
    static isInstance(x) {
        var _a;
        if (x instanceof _AgChartInstanceProxy) return true;
        if (((_a = x.constructor) == null ? void 0 : _a.name) === "AgChartInstanceProxy" && x.chart != null) return true;
        return x.chart != null && this.validateImplementation(x);
    }
    static validateImplementation(x) {
        var _a;
        const chartProps = [
            "getOptions",
            "destroy"
        ];
        const signatureProps = Object.keys((_a = Object.getPrototypeOf(x)) != null ? _a : {});
        return chartProps.every((prop)=>signatureProps.includes(prop));
    }
    constructor(chart){
        this.chart = chart;
    }
    getOptions() {
        return $d77b025aa58d633c$var$deepClone(this.chart.getOptions());
    }
    resetAnimations() {
        this.chart.resetAnimations();
    }
    skipAnimations() {
        this.chart.skipAnimations();
    }
    destroy() {
        this.chart.destroy();
    }
};
$d77b025aa58d633c$var$_AgChartInstanceProxy.chartInstances = /* @__PURE__ */ new WeakMap();
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ActionOnSet({
        oldValue (chart) {
            $d77b025aa58d633c$var$_AgChartInstanceProxy.chartInstances.delete(chart);
        },
        newValue (chart) {
            $d77b025aa58d633c$var$_AgChartInstanceProxy.chartInstances.set(chart, this);
        }
    })
], $d77b025aa58d633c$var$_AgChartInstanceProxy.prototype, "chart", 2);
var $d77b025aa58d633c$var$AgChartInstanceProxy = $d77b025aa58d633c$var$_AgChartInstanceProxy;
// packages/ag-charts-community/src/scale/linearScale.ts
var $d77b025aa58d633c$var$LinearScale = class extends $d77b025aa58d633c$var$ContinuousScale {
    constructor(){
        super([
            0,
            1
        ], [
            0,
            1
        ]);
        this.type = "number";
    }
    toDomain(d) {
        return d;
    }
    ticks() {
        var _a;
        const count = (_a = this.tickCount) != null ? _a : $d77b025aa58d633c$var$ContinuousScale.defaultTickCount;
        if (!this.domain || this.domain.length < 2 || count < 1 || this.domain.some((d)=>!isFinite(d))) return [];
        this.refresh();
        const [d0, d1] = this.getDomain();
        const { interval: interval } = this;
        if (interval) {
            const step = Math.abs(interval);
            const availableRange = this.getPixelRange();
            if (!$d77b025aa58d633c$var$isDenseInterval({
                start: d0,
                stop: d1,
                interval: step,
                availableRange: availableRange
            })) return $d77b025aa58d633c$var$range(d0, d1, step);
        }
        return $d77b025aa58d633c$var$ticks_default(d0, d1, count, this.minTickCount, this.maxTickCount);
    }
    update() {
        if (!this.domain || this.domain.length < 2) return;
        if (this.nice) this.updateNiceDomain();
    }
    getTickStep(start, stop) {
        var _a, _b;
        const count = (_a = this.tickCount) != null ? _a : $d77b025aa58d633c$var$ContinuousScale.defaultTickCount;
        return (_b = this.interval) != null ? _b : $d77b025aa58d633c$var$tickStep(start, stop, count, this.minTickCount, this.maxTickCount);
    }
    /**
   * Extends the domain so that it starts and ends on nice round values.
   */ updateNiceDomain() {
        var _a;
        const count = (_a = this.tickCount) != null ? _a : $d77b025aa58d633c$var$ContinuousScale.defaultTickCount;
        if (count < 1) {
            this.niceDomain = [
                ...this.domain
            ];
            return;
        }
        let [start, stop] = this.domain;
        if (count === 1) [start, stop] = $d77b025aa58d633c$var$singleTickDomain(start, stop);
        else {
            const roundStart = start > stop ? Math.ceil : Math.floor;
            const roundStop = stop < start ? Math.floor : Math.ceil;
            const maxAttempts = 4;
            for(let i = 0; i < maxAttempts; i++){
                const prev0 = start;
                const prev1 = stop;
                const step = this.getTickStep(start, stop);
                const [d0, d1] = this.domain;
                if (step >= 1) {
                    start = roundStart(d0 / step) * step;
                    stop = roundStop(d1 / step) * step;
                } else {
                    const s = 1 / step;
                    start = roundStart(d0 * s) / s;
                    stop = roundStop(d1 * s) / s;
                }
                if (start === prev0 && stop === prev1) break;
            }
        }
        this.niceDomain = [
            start,
            stop
        ];
    }
    tickFormat({ ticks: specifiedTicks, specifier: specifier }) {
        return $d77b025aa58d633c$var$tickFormat(specifiedTicks != null ? specifiedTicks : this.ticks(), specifier);
    }
};
// packages/ag-charts-community/src/util/secondaryAxisTicks.ts
function $d77b025aa58d633c$var$calculateNiceSecondaryAxis(domain, primaryTickCount, reverse) {
    let [start, stop] = $d77b025aa58d633c$var$findMinMax(domain);
    start = $d77b025aa58d633c$var$calculateNiceStart(Math.floor(start), stop, primaryTickCount);
    const step = $d77b025aa58d633c$var$getTickStep(start, stop, primaryTickCount);
    const segments = primaryTickCount - 1;
    stop = start + segments * step;
    const d = reverse ? [
        stop,
        start
    ] : [
        start,
        stop
    ];
    const ticks = $d77b025aa58d633c$var$getTicks(start, step, primaryTickCount);
    return [
        d,
        ticks
    ];
}
function $d77b025aa58d633c$var$calculateNiceStart(a, b, count) {
    const rawStep = Math.abs(b - a) / (count - 1);
    const order = Math.floor(Math.log10(rawStep));
    const magnitude = Math.pow(10, order);
    return Math.floor(a / magnitude) * magnitude;
}
function $d77b025aa58d633c$var$getTicks(start, step, count) {
    const stepPower = Math.floor(Math.log10(step));
    const fractionDigits = step > 0 && step < 1 ? Math.abs(stepPower) : 0;
    const f = Math.pow(10, fractionDigits);
    const ticks = $d77b025aa58d633c$var$createNumericTicks(fractionDigits);
    for(let i = 0; i < count; i++){
        const tick = start + step * i;
        ticks[i] = Math.round(tick * f) / f;
    }
    return ticks;
}
function $d77b025aa58d633c$var$getTickStep(start, stop, count) {
    const segments = count - 1;
    const rawStep = (stop - start) / segments;
    return $d77b025aa58d633c$var$calculateNextNiceStep(rawStep);
}
function $d77b025aa58d633c$var$calculateNextNiceStep(rawStep) {
    const order = Math.floor(Math.log10(rawStep));
    const magnitude = Math.pow(10, order);
    const step = rawStep / magnitude * 10;
    if (step > 0 && step <= 1) return magnitude / 10;
    if (step > 1 && step <= 2) return 2 * magnitude / 10;
    if (step > 1 && step <= 5) return 5 * magnitude / 10;
    if (step > 5 && step <= 10) return 10 * magnitude / 10;
    if (step > 10 && step <= 20) return 20 * magnitude / 10;
    if (step > 20 && step <= 40) return 40 * magnitude / 10;
    if (step > 40 && step <= 50) return 50 * magnitude / 10;
    if (step > 50 && step <= 100) return 100 * magnitude / 10;
    return step;
}
// packages/ag-charts-community/src/chart/axis/numberAxis.ts
var $d77b025aa58d633c$var$NumberAxisTick = class extends $d77b025aa58d633c$var$AxisTick {
    constructor(){
        super(...arguments);
        this.minSpacing = NaN;
        this.maxSpacing = NaN;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$MIN_SPACING),
    $d77b025aa58d633c$var$Default(NaN)
], $d77b025aa58d633c$var$NumberAxisTick.prototype, "minSpacing", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$MAX_SPACING),
    $d77b025aa58d633c$var$Default(NaN)
], $d77b025aa58d633c$var$NumberAxisTick.prototype, "maxSpacing", 2);
var $d77b025aa58d633c$var$NumberAxis = class extends $d77b025aa58d633c$var$CartesianAxis {
    constructor(moduleCtx, scale2 = new $d77b025aa58d633c$var$LinearScale()){
        super(moduleCtx, scale2);
        this.min = NaN;
        this.max = NaN;
    }
    normaliseDataDomain(d) {
        const { min: min, max: max } = this;
        const { extent: extent2, clipped: clipped } = $d77b025aa58d633c$var$normalisedExtentWithMetadata(d, min, max);
        return {
            domain: extent2,
            clipped: clipped
        };
    }
    createTick() {
        return new $d77b025aa58d633c$var$NumberAxisTick();
    }
    updateSecondaryAxisTicks(primaryTickCount) {
        if (this.dataDomain == null) throw new Error("AG Charts - dataDomain not calculated, cannot perform tick calculation.");
        if (this.dataDomain.domain.length === 0) return [];
        const [d, ticks] = $d77b025aa58d633c$var$calculateNiceSecondaryAxis(this.dataDomain.domain, primaryTickCount != null ? primaryTickCount : 0, this.reverse);
        this.scale.nice = false;
        this.scale.domain = d;
        this.scale.update();
        return ticks;
    }
    formatDatum(datum) {
        if (typeof datum === "number") return datum.toFixed(2);
        else return String(datum);
    }
};
$d77b025aa58d633c$var$NumberAxis.className = "NumberAxis";
$d77b025aa58d633c$var$NumberAxis.type = "number";
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$AND($d77b025aa58d633c$var$NUMBER_OR_NAN, $d77b025aa58d633c$var$LESS_THAN("max"))),
    $d77b025aa58d633c$var$Default(NaN)
], $d77b025aa58d633c$var$NumberAxis.prototype, "min", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$AND($d77b025aa58d633c$var$NUMBER_OR_NAN, $d77b025aa58d633c$var$GREATER_THAN("min"))),
    $d77b025aa58d633c$var$Default(NaN)
], $d77b025aa58d633c$var$NumberAxis.prototype, "max", 2);
// packages/ag-charts-community/src/chart/axis/logAxis.ts
var $d77b025aa58d633c$var$NON_ZERO_NUMBER = $d77b025aa58d633c$var$predicateWithMessage((value)=>$d77b025aa58d633c$var$isNumber(value) && value !== 0, "a non-zero number");
var $d77b025aa58d633c$var$LogAxis = class extends $d77b025aa58d633c$var$NumberAxis {
    constructor(moduleCtx){
        super(moduleCtx, new $d77b025aa58d633c$var$LogScale());
        this.min = NaN;
        this.max = NaN;
    }
    normaliseDataDomain(d) {
        const { min: min, max: max } = this;
        const { extent: extent2, clipped: clipped } = $d77b025aa58d633c$var$normalisedExtentWithMetadata(d, min, max);
        const isInverted = extent2[0] > extent2[1];
        const crossesZero = extent2[0] < 0 && extent2[1] > 0;
        const hasZeroExtent = extent2[0] === 0 && extent2[1] === 0;
        const invalidDomain = isInverted || crossesZero || hasZeroExtent;
        if (invalidDomain) {
            if (crossesZero) $d77b025aa58d633c$var$Logger.warn(`the data domain crosses zero, the chart data cannot be rendered. See log axis documentation for more information.`);
            else if (hasZeroExtent) $d77b025aa58d633c$var$Logger.warn(`the data domain has 0 extent, no data is rendered.`);
        }
        if (extent2[0] === 0) extent2[0] = 1;
        if (extent2[1] === 0) extent2[1] = -1;
        return {
            domain: extent2,
            clipped: clipped
        };
    }
    set base(value) {
        this.scale.base = value;
    }
    get base() {
        return this.scale.base;
    }
};
$d77b025aa58d633c$var$LogAxis.className = "LogAxis";
$d77b025aa58d633c$var$LogAxis.type = "log";
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$AND($d77b025aa58d633c$var$NUMBER_OR_NAN, $d77b025aa58d633c$var$NON_ZERO_NUMBER, $d77b025aa58d633c$var$LESS_THAN("max"))),
    $d77b025aa58d633c$var$Default(NaN)
], $d77b025aa58d633c$var$LogAxis.prototype, "min", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$AND($d77b025aa58d633c$var$NUMBER_OR_NAN, $d77b025aa58d633c$var$NON_ZERO_NUMBER, $d77b025aa58d633c$var$GREATER_THAN("min"))),
    $d77b025aa58d633c$var$Default(NaN)
], $d77b025aa58d633c$var$LogAxis.prototype, "max", 2);
// packages/ag-charts-community/src/chart/axis/timeAxis.ts
var $d77b025aa58d633c$var$TimeAxisTick = class extends $d77b025aa58d633c$var$AxisTick {
    constructor(){
        super(...arguments);
        this.minSpacing = NaN;
        this.maxSpacing = NaN;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$MIN_SPACING),
    $d77b025aa58d633c$var$Default(NaN)
], $d77b025aa58d633c$var$TimeAxisTick.prototype, "minSpacing", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$MAX_SPACING),
    $d77b025aa58d633c$var$Default(NaN)
], $d77b025aa58d633c$var$TimeAxisTick.prototype, "maxSpacing", 2);
var $d77b025aa58d633c$var$TimeAxis = class extends $d77b025aa58d633c$var$CartesianAxis {
    constructor(moduleCtx){
        super(moduleCtx, new $d77b025aa58d633c$var$TimeScale());
        this.min = void 0;
        this.max = void 0;
        this.refreshScale();
    }
    normaliseDataDomain(d) {
        var _a;
        let { min: min, max: max } = this;
        let clipped = false;
        if (typeof min === "number") min = new Date(min);
        if (typeof max === "number") max = new Date(max);
        if (d.length > 2) d = ((_a = $d77b025aa58d633c$var$extent(d)) != null ? _a : [
            0,
            1e3
        ]).map((x)=>new Date(x));
        if (min instanceof Date) {
            clipped || (clipped = min > d[0]);
            d = [
                min,
                d[1]
            ];
        }
        if (max instanceof Date) {
            clipped || (clipped = max < d[1]);
            d = [
                d[0],
                max
            ];
        }
        if (d[0] > d[1]) d = [];
        return {
            domain: d,
            clipped: clipped
        };
    }
    createTick() {
        return new $d77b025aa58d633c$var$TimeAxisTick();
    }
    onLabelFormatChange(ticks, domain, format2) {
        if (format2) super.onLabelFormatChange(ticks, domain, format2);
        else this.labelFormatter = this.scale.tickFormat({
            ticks: ticks,
            domain: domain
        });
    }
    calculatePadding() {
        return [
            0,
            0
        ];
    }
    formatDatum(datum) {
        var _a;
        const formatter = this.scale.tickFormat({
            specifier: "%m/%d/%y, %H:%M:%S"
        });
        return (_a = this.moduleCtx.callbackCache.call(formatter, datum)) != null ? _a : String(datum);
    }
};
$d77b025aa58d633c$var$TimeAxis.className = "TimeAxis";
$d77b025aa58d633c$var$TimeAxis.type = "time";
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$AND($d77b025aa58d633c$var$DATE_OR_DATETIME_MS, $d77b025aa58d633c$var$LESS_THAN("max")), {
        optional: true
    })
], $d77b025aa58d633c$var$TimeAxis.prototype, "min", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$AND($d77b025aa58d633c$var$DATE_OR_DATETIME_MS, $d77b025aa58d633c$var$GREATER_THAN("min")), {
        optional: true
    })
], $d77b025aa58d633c$var$TimeAxis.prototype, "max", 2);
// packages/ag-charts-community/src/scene/shape/rect.ts
var $d77b025aa58d633c$var$epsilon = 1e-6;
var $d77b025aa58d633c$var$cornerEdges = (leadingEdge, trailingEdge, leadingInset, trailingInset, cornerRadius)=>{
    let leadingClipped = false;
    let trailingClipped = false;
    let leading0 = trailingInset - Math.sqrt(Math.max($d77b025aa58d633c$var$__pow(cornerRadius, 2) - $d77b025aa58d633c$var$__pow(leadingInset, 2), 0));
    let leading1 = 0;
    let trailing0 = 0;
    let trailing1 = leadingInset - Math.sqrt(Math.max($d77b025aa58d633c$var$__pow(cornerRadius, 2) - $d77b025aa58d633c$var$__pow(trailingInset, 2), 0));
    if (leading0 > leadingEdge) {
        leadingClipped = true;
        leading0 = leadingEdge;
        leading1 = leadingInset - Math.sqrt(Math.max($d77b025aa58d633c$var$__pow(cornerRadius, 2) - $d77b025aa58d633c$var$__pow(trailingInset - leadingEdge, 2)));
    } else if (leading0 < $d77b025aa58d633c$var$epsilon) leading0 = 0;
    if (trailing1 > trailingEdge) {
        trailingClipped = true;
        trailing0 = trailingInset - Math.sqrt(Math.max($d77b025aa58d633c$var$__pow(cornerRadius, 2) - $d77b025aa58d633c$var$__pow(leadingInset - trailingEdge, 2)));
        trailing1 = trailingEdge;
    } else if (trailing1 < $d77b025aa58d633c$var$epsilon) trailing1 = 0;
    return {
        leading0: leading0,
        leading1: leading1,
        trailing0: trailing0,
        trailing1: trailing1,
        leadingClipped: leadingClipped,
        trailingClipped: trailingClipped
    };
};
var $d77b025aa58d633c$var$drawCorner = (path, { x0: x0, y0: y0, x1: x1, y1: y1, cx: cx, cy: cy }, cornerRadius, move)=>{
    if (move) path.moveTo(x0, y0);
    if (x0 !== x1 || y0 !== y1) {
        const r0 = Math.atan2(y0 - cy, x0 - cx);
        const r1 = Math.atan2(y1 - cy, x1 - cx);
        path.arc(cx, cy, cornerRadius, r0, r1);
    } else path.lineTo(x0, y0);
};
var $d77b025aa58d633c$var$insetCornerRadiusRect = (path, x, y, width, height, cornerRadii, clipBBox)=>{
    let { topLeft: topLeftCornerRadius, topRight: topRightCornerRadius, bottomRight: bottomRightCornerRadius, bottomLeft: bottomLeftCornerRadius } = cornerRadii;
    const maxVerticalCornerRadius = Math.max(topLeftCornerRadius + bottomLeftCornerRadius, topRightCornerRadius + bottomRightCornerRadius);
    const maxHorizontalCornerRadius = Math.max(topLeftCornerRadius + topRightCornerRadius, bottomLeftCornerRadius + bottomRightCornerRadius);
    if (maxVerticalCornerRadius <= 0 && maxHorizontalCornerRadius <= 0) {
        if (clipBBox == null) path.rect(x, y, width, height);
        else path.rect(clipBBox.x, clipBBox.y, clipBBox.width, clipBBox.height);
        return;
    } else if (clipBBox == null && topLeftCornerRadius === topRightCornerRadius && topLeftCornerRadius === bottomRightCornerRadius && topLeftCornerRadius === bottomLeftCornerRadius) {
        path.roundRect(x, y, width, height, topLeftCornerRadius);
        return;
    }
    if (width < 0) {
        x += width;
        width = Math.abs(width);
    }
    if (height < 0) {
        y += height;
        height = Math.abs(height);
    }
    if (width <= 0 || height <= 0) return;
    if (clipBBox == null) clipBBox = new $d77b025aa58d633c$var$BBox(x, y, width, height);
    else {
        const x0 = Math.max(x, clipBBox.x);
        const x1 = Math.min(x + width, clipBBox.x + clipBBox.width);
        const y0 = Math.max(y, clipBBox.y);
        const y1 = Math.min(y + height, clipBBox.y + clipBBox.height);
        clipBBox = new $d77b025aa58d633c$var$BBox(x0, y0, x1 - x0, y1 - y0);
    }
    const borderScale = Math.max(maxVerticalCornerRadius / height, maxHorizontalCornerRadius / width, 1);
    if (borderScale > 1) {
        topLeftCornerRadius /= borderScale;
        topRightCornerRadius /= borderScale;
        bottomRightCornerRadius /= borderScale;
        bottomLeftCornerRadius /= borderScale;
    }
    let drawTopLeftCorner = true;
    let drawTopRightCorner = true;
    let drawBottomRightCorner = true;
    let drawBottomLeftCorner = true;
    let topLeftCorner;
    let topRightCorner;
    let bottomRightCorner;
    let bottomLeftCorner;
    if (drawTopLeftCorner) {
        const nodes = $d77b025aa58d633c$var$cornerEdges(clipBBox.height, clipBBox.width, Math.max(x + topLeftCornerRadius - clipBBox.x, 0), Math.max(y + topLeftCornerRadius - clipBBox.y, 0), topLeftCornerRadius);
        if (nodes.leadingClipped) drawBottomLeftCorner = false;
        if (nodes.trailingClipped) drawTopRightCorner = false;
        const x0 = Math.max(clipBBox.x + nodes.leading1, clipBBox.x);
        const y0 = Math.max(clipBBox.y + nodes.leading0, clipBBox.y);
        const x1 = Math.max(clipBBox.x + nodes.trailing1, clipBBox.x);
        const y1 = Math.max(clipBBox.y + nodes.trailing0, clipBBox.y);
        const cx = x + topLeftCornerRadius;
        const cy = y + topLeftCornerRadius;
        topLeftCorner = {
            x0: x0,
            y0: y0,
            x1: x1,
            y1: y1,
            cx: cx,
            cy: cy
        };
    }
    if (drawTopRightCorner) {
        const nodes = $d77b025aa58d633c$var$cornerEdges(clipBBox.width, clipBBox.height, Math.max(y + topRightCornerRadius - clipBBox.y, 0), Math.max(clipBBox.x + clipBBox.width - (x + width - topRightCornerRadius), 0), topRightCornerRadius);
        if (nodes.leadingClipped) drawTopLeftCorner = false;
        if (nodes.trailingClipped) drawBottomRightCorner = false;
        const x0 = Math.min(clipBBox.x + clipBBox.width - nodes.leading0, clipBBox.x + clipBBox.width);
        const y0 = Math.max(clipBBox.y + nodes.leading1, clipBBox.y);
        const x1 = Math.min(clipBBox.x + clipBBox.width - nodes.trailing0, clipBBox.x + clipBBox.width);
        const y1 = Math.max(clipBBox.y + nodes.trailing1, clipBBox.y);
        const cx = x + width - topRightCornerRadius;
        const cy = y + topRightCornerRadius;
        topRightCorner = {
            x0: x0,
            y0: y0,
            x1: x1,
            y1: y1,
            cx: cx,
            cy: cy
        };
    }
    if (drawBottomRightCorner) {
        const nodes = $d77b025aa58d633c$var$cornerEdges(clipBBox.height, clipBBox.width, Math.max(clipBBox.x + clipBBox.width - (x + width - bottomRightCornerRadius), 0), Math.max(clipBBox.y + clipBBox.height - (y + height - bottomRightCornerRadius), 0), bottomRightCornerRadius);
        if (nodes.leadingClipped) drawTopRightCorner = false;
        if (nodes.trailingClipped) drawBottomLeftCorner = false;
        const x0 = Math.min(clipBBox.x + clipBBox.width - nodes.leading1, clipBBox.x + clipBBox.width);
        const y0 = Math.min(clipBBox.y + clipBBox.height - nodes.leading0, clipBBox.y + clipBBox.height);
        const x1 = Math.min(clipBBox.x + clipBBox.width - nodes.trailing1, clipBBox.x + clipBBox.width);
        const y1 = Math.min(clipBBox.y + clipBBox.height - nodes.trailing0, clipBBox.y + clipBBox.height);
        const cx = x + width - bottomRightCornerRadius;
        const cy = y + height - bottomRightCornerRadius;
        bottomRightCorner = {
            x0: x0,
            y0: y0,
            x1: x1,
            y1: y1,
            cx: cx,
            cy: cy
        };
    }
    if (drawBottomLeftCorner) {
        const nodes = $d77b025aa58d633c$var$cornerEdges(clipBBox.width, clipBBox.height, Math.max(clipBBox.y + clipBBox.height - (y + height - bottomLeftCornerRadius), 0), Math.max(x + bottomLeftCornerRadius - clipBBox.x, 0), bottomLeftCornerRadius);
        if (nodes.leadingClipped) drawBottomRightCorner = false;
        if (nodes.trailingClipped) drawTopLeftCorner = false;
        const x0 = Math.max(clipBBox.x + nodes.leading0, clipBBox.x);
        const y0 = Math.min(clipBBox.y + clipBBox.height - nodes.leading1, clipBBox.y + clipBBox.height);
        const x1 = Math.max(clipBBox.x + nodes.trailing0, clipBBox.x);
        const y1 = Math.min(clipBBox.y + clipBBox.height - nodes.trailing1, clipBBox.y + clipBBox.height);
        const cx = x + bottomLeftCornerRadius;
        const cy = y + height - bottomLeftCornerRadius;
        bottomLeftCorner = {
            x0: x0,
            y0: y0,
            x1: x1,
            y1: y1,
            cx: cx,
            cy: cy
        };
    }
    let didMove = false;
    if (drawTopLeftCorner && topLeftCorner != null) {
        $d77b025aa58d633c$var$drawCorner(path, topLeftCorner, topLeftCornerRadius, !didMove);
        didMove || (didMove = true);
    }
    if (drawTopRightCorner && topRightCorner != null) {
        $d77b025aa58d633c$var$drawCorner(path, topRightCorner, topRightCornerRadius, !didMove);
        didMove || (didMove = true);
    }
    if (drawBottomRightCorner && bottomRightCorner != null) {
        $d77b025aa58d633c$var$drawCorner(path, bottomRightCorner, bottomRightCornerRadius, !didMove);
        didMove || (didMove = true);
    }
    if (drawBottomLeftCorner && bottomLeftCorner != null) {
        $d77b025aa58d633c$var$drawCorner(path, bottomLeftCorner, bottomLeftCornerRadius, !didMove);
        didMove || (didMove = true);
    }
    path.closePath();
};
var $d77b025aa58d633c$var$Rect = class extends $d77b025aa58d633c$var$Path {
    constructor(){
        super(...arguments);
        this.borderPath = new $d77b025aa58d633c$var$ExtendedPath2D();
        this.x = 0;
        this.y = 0;
        this.width = 10;
        this.height = 10;
        this.topLeftCornerRadius = 0;
        this.topRightCornerRadius = 0;
        this.bottomRightCornerRadius = 0;
        this.bottomLeftCornerRadius = 0;
        this.clipBBox = void 0;
        this.crisp = false;
        this.lastUpdatePathStrokeWidth = $d77b025aa58d633c$var$Shape.defaultStyles.strokeWidth;
        this.effectiveStrokeWidth = $d77b025aa58d633c$var$Shape.defaultStyles.strokeWidth;
        this.hittester = super.isPointInPath;
        this.distanceCalculator = super.distanceSquared;
        /**
     * When the rectangle's width or height is less than a pixel
     * and crisp mode is on, the rectangle will still fit into the pixel,
     * but will be less opaque to make an effect of holding less space.
     */ this.microPixelEffectOpacity = 1;
    }
    set cornerRadius(cornerRadius) {
        this.topLeftCornerRadius = cornerRadius;
        this.topRightCornerRadius = cornerRadius;
        this.bottomRightCornerRadius = cornerRadius;
        this.bottomLeftCornerRadius = cornerRadius;
    }
    isDirtyPath() {
        return this.lastUpdatePathStrokeWidth !== this.strokeWidth || Boolean(this.path.isDirty() || this.borderPath.isDirty());
    }
    updatePath() {
        var _a, _b, _c;
        const { path: path, borderPath: borderPath, crisp: crisp, topLeftCornerRadius: topLeft, topRightCornerRadius: topRight, bottomRightCornerRadius: bottomRight, bottomLeftCornerRadius: bottomLeft } = this;
        let { x: x, y: y, width: w, height: h, strokeWidth: strokeWidth, clipBBox: clipBBox } = this;
        const pixelRatio = (_b = (_a = this.layerManager) == null ? void 0 : _a.canvas.pixelRatio) != null ? _b : 1;
        const pixelSize = 1 / pixelRatio;
        let microPixelEffectOpacity = 1;
        path.clear(true);
        borderPath.clear(true);
        if (crisp) {
            if (w <= pixelSize) microPixelEffectOpacity *= w / pixelSize;
            if (h <= pixelSize) microPixelEffectOpacity *= h / pixelSize;
            w = this.align(x, w);
            h = this.align(y, h);
            x = this.align(x);
            y = this.align(y);
            clipBBox = clipBBox != null ? new $d77b025aa58d633c$var$BBox(this.align(clipBBox.x), this.align(clipBBox.y), this.align(clipBBox.x, clipBBox.width), this.align(clipBBox.y, clipBBox.height)) : void 0;
        }
        if (strokeWidth) {
            if (w < pixelSize) {
                const lx = x + pixelSize / 2;
                borderPath.moveTo(lx, y);
                borderPath.lineTo(lx, y + h);
                strokeWidth = pixelSize;
                this.borderClipPath = void 0;
            } else if (h < pixelSize) {
                const ly = y + pixelSize / 2;
                borderPath.moveTo(x, ly);
                borderPath.lineTo(x + w, ly);
                strokeWidth = pixelSize;
                this.borderClipPath = void 0;
            } else if (strokeWidth < w && strokeWidth < h) {
                const halfStrokeWidth = strokeWidth / 2;
                x += halfStrokeWidth;
                y += halfStrokeWidth;
                w -= strokeWidth;
                h -= strokeWidth;
                const adjustedClipBBox = clipBBox == null ? void 0 : clipBBox.clone().shrink(halfStrokeWidth);
                const cornerRadii = {
                    topLeft: topLeft > 0 ? topLeft - strokeWidth : 0,
                    topRight: topRight > 0 ? topRight - strokeWidth : 0,
                    bottomRight: bottomRight > 0 ? bottomRight - strokeWidth : 0,
                    bottomLeft: bottomLeft > 0 ? bottomLeft - strokeWidth : 0
                };
                this.borderClipPath = void 0;
                if (w > 0 && h > 0 && (adjustedClipBBox == null || (adjustedClipBBox == null ? void 0 : adjustedClipBBox.width) > 0 && (adjustedClipBBox == null ? void 0 : adjustedClipBBox.height) > 0)) {
                    $d77b025aa58d633c$var$insetCornerRadiusRect(path, x, y, w, h, cornerRadii, adjustedClipBBox);
                    $d77b025aa58d633c$var$insetCornerRadiusRect(borderPath, x, y, w, h, cornerRadii, adjustedClipBBox);
                }
            } else {
                this.borderClipPath = (_c = this.borderClipPath) != null ? _c : new $d77b025aa58d633c$var$ExtendedPath2D();
                this.borderClipPath.clear(true);
                this.borderClipPath.rect(x, y, w, h);
                borderPath.rect(x, y, w, h);
            }
        } else {
            const cornerRadii = {
                topLeft: topLeft,
                topRight: topRight,
                bottomRight: bottomRight,
                bottomLeft: bottomLeft
            };
            this.borderClipPath = void 0;
            $d77b025aa58d633c$var$insetCornerRadiusRect(path, x, y, w, h, cornerRadii, clipBBox);
        }
        if ([
            topLeft,
            topRight,
            bottomRight,
            bottomLeft
        ].every((r)=>r === 0)) {
            this.hittester = (hitX, hitY)=>{
                const point = this.transformPoint(hitX, hitY);
                return this.getCachedBBox().containsPoint(point.x, point.y);
            };
            this.distanceSquared = (hitX, hitY)=>this.getCachedBBox().distanceSquared(hitX, hitY);
        } else {
            this.hittester = super.isPointInPath;
            this.distanceCalculator = super.distanceSquared;
        }
        this.effectiveStrokeWidth = strokeWidth;
        this.lastUpdatePathStrokeWidth = strokeWidth;
        this.microPixelEffectOpacity = microPixelEffectOpacity;
    }
    computeBBox() {
        var _a;
        const { x: x, y: y, width: width, height: height, clipBBox: clipBBox } = this;
        return (_a = clipBBox == null ? void 0 : clipBBox.clone()) != null ? _a : new $d77b025aa58d633c$var$BBox(x, y, width, height);
    }
    isPointInPath(x, y) {
        return this.hittester(x, y);
    }
    get midPoint() {
        return {
            x: this.x + this.width / 2,
            y: this.y + this.height / 2
        };
    }
    distanceSquared(x, y) {
        return this.distanceCalculator(x, y);
    }
    applyFillAlpha(ctx) {
        const { fillOpacity: fillOpacity, microPixelEffectOpacity: microPixelEffectOpacity, opacity: opacity } = this;
        ctx.globalAlpha *= opacity * fillOpacity * microPixelEffectOpacity;
    }
    renderStroke(ctx) {
        const { stroke: stroke, effectiveStrokeWidth: effectiveStrokeWidth } = this;
        if (stroke && effectiveStrokeWidth) {
            const { globalAlpha: globalAlpha } = ctx;
            const { strokeOpacity: strokeOpacity, lineDash: lineDash, lineDashOffset: lineDashOffset, lineCap: lineCap, lineJoin: lineJoin, borderPath: borderPath, borderClipPath: borderClipPath, opacity: opacity, microPixelEffectOpacity: microPixelEffectOpacity } = this;
            if (borderClipPath) ctx.clip(borderClipPath.getPath2D());
            ctx.strokeStyle = stroke;
            ctx.globalAlpha *= opacity * strokeOpacity * microPixelEffectOpacity;
            ctx.lineWidth = effectiveStrokeWidth;
            if (lineDash) ctx.setLineDash(lineDash);
            if (lineDashOffset) ctx.lineDashOffset = lineDashOffset;
            if (lineCap) ctx.lineCap = lineCap;
            if (lineJoin) ctx.lineJoin = lineJoin;
            ctx.stroke(borderPath.getPath2D());
            ctx.globalAlpha = globalAlpha;
        }
    }
};
$d77b025aa58d633c$var$Rect.className = "Rect";
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ScenePathChangeDetection()
], $d77b025aa58d633c$var$Rect.prototype, "x", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ScenePathChangeDetection()
], $d77b025aa58d633c$var$Rect.prototype, "y", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ScenePathChangeDetection()
], $d77b025aa58d633c$var$Rect.prototype, "width", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ScenePathChangeDetection()
], $d77b025aa58d633c$var$Rect.prototype, "height", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ScenePathChangeDetection()
], $d77b025aa58d633c$var$Rect.prototype, "topLeftCornerRadius", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ScenePathChangeDetection()
], $d77b025aa58d633c$var$Rect.prototype, "topRightCornerRadius", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ScenePathChangeDetection()
], $d77b025aa58d633c$var$Rect.prototype, "bottomRightCornerRadius", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ScenePathChangeDetection()
], $d77b025aa58d633c$var$Rect.prototype, "bottomLeftCornerRadius", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ScenePathChangeDetection()
], $d77b025aa58d633c$var$Rect.prototype, "clipBBox", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ScenePathChangeDetection()
], $d77b025aa58d633c$var$Rect.prototype, "crisp", 2);
// packages/ag-charts-community/src/chart/background/background.ts
var $d77b025aa58d633c$var$Background = class extends $d77b025aa58d633c$var$BaseModuleInstance {
    constructor(ctx){
        super();
        this.node = new $d77b025aa58d633c$var$Group({
            name: "background",
            zIndex: 0 /* SERIES_BACKGROUND_ZINDEX */ 
        });
        this.rectNode = new $d77b025aa58d633c$var$Rect();
        this.visible = true;
        this.fill = "white";
        this.node.appendChild(this.rectNode);
        this.destroyFns.push(ctx.scene.attachNode(this.node), ctx.layoutService.addListener("layout-complete", (e)=>this.onLayoutComplete(e)));
    }
    onLayoutComplete(e) {
        const { width: width, height: height } = e.chart;
        this.rectNode.width = width;
        this.rectNode.height = height;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN),
    $d77b025aa58d633c$var$ProxyPropertyOnWrite("node", "visible")
], $d77b025aa58d633c$var$Background.prototype, "visible", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$COLOR_STRING, {
        optional: true
    }),
    $d77b025aa58d633c$var$ProxyPropertyOnWrite("rectNode", "fill")
], $d77b025aa58d633c$var$Background.prototype, "fill", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT, {
        optional: true
    })
], $d77b025aa58d633c$var$Background.prototype, "image", 2);
// packages/ag-charts-community/src/chart/background/backgroundModule.ts
var $d77b025aa58d633c$var$BackgroundModule = {
    type: "root",
    optionsKey: "background",
    packageType: "community",
    chartTypes: [
        "cartesian",
        "polar",
        "hierarchy",
        "topology"
    ],
    instanceConstructor: $d77b025aa58d633c$var$Background
};
// packages/ag-charts-community/src/chart/gridLayout.ts
function $d77b025aa58d633c$var$gridLayout({ orientation: orientation, bboxes: bboxes, maxHeight: maxHeight, maxWidth: maxWidth, itemPaddingY: itemPaddingY = 0, itemPaddingX: itemPaddingX = 0, forceResult: forceResult = false }) {
    const horizontal = orientation === "horizontal";
    const primary = {
        max: horizontal ? maxWidth : maxHeight,
        fn: horizontal ? (b)=>b.width : (b)=>b.height,
        padding: horizontal ? itemPaddingX : itemPaddingY
    };
    const secondary = {
        max: horizontal ? maxHeight : maxWidth,
        fn: horizontal ? (b)=>b.height : (b)=>b.width,
        padding: horizontal ? itemPaddingY : itemPaddingX
    };
    let processedBBoxCount = 0;
    const rawPages = [];
    while(processedBBoxCount < bboxes.length){
        const unprocessedBBoxes = bboxes.slice(processedBBoxCount);
        const result = $d77b025aa58d633c$var$processBBoxes(unprocessedBBoxes, processedBBoxCount, primary, secondary, forceResult);
        if (!result) return;
        processedBBoxCount += result.processedBBoxCount;
        rawPages.push(result.pageIndices);
    }
    return $d77b025aa58d633c$var$buildPages(rawPages, orientation, bboxes, itemPaddingY, itemPaddingX);
}
function $d77b025aa58d633c$var$processBBoxes(bboxes, indexOffset, primary, secondary, forceResult) {
    const minGuess = 1;
    let startingGuess = $d77b025aa58d633c$var$estimateStartingGuess(bboxes, primary);
    if (startingGuess < minGuess) {
        if (!forceResult) return;
        startingGuess = minGuess;
    }
    let guess = startingGuess;
    while(guess >= minGuess){
        const pageIndices = $d77b025aa58d633c$var$calculatePage(bboxes, indexOffset, guess, primary, secondary, forceResult);
        if (pageIndices == null && guess <= minGuess) return;
        if (pageIndices == null) {
            guess--;
            continue;
        }
        if (typeof pageIndices === "number") {
            if (pageIndices <= minGuess) return;
            guess = pageIndices < guess && pageIndices > minGuess ? pageIndices : guess;
            guess--;
            continue;
        }
        const processedBBoxCount = pageIndices.length * pageIndices[0].length;
        return {
            processedBBoxCount: processedBBoxCount,
            pageIndices: pageIndices
        };
    }
}
function $d77b025aa58d633c$var$calculatePage(bboxes, indexOffset, primaryCount, primary, secondary, forceResult) {
    var _a;
    const result = [];
    let sumSecondary = 0;
    let currentMaxSecondary = 0;
    let currentPrimaryIndices = [];
    const maxPrimaryValues = [];
    for(let bboxIndex = 0; bboxIndex < bboxes.length; bboxIndex++){
        const primaryValueIdx = (bboxIndex + primaryCount) % primaryCount;
        if (primaryValueIdx === 0) {
            sumSecondary += currentMaxSecondary;
            currentMaxSecondary = 0;
            if (currentPrimaryIndices.length > 0) result.push(currentPrimaryIndices);
            currentPrimaryIndices = [];
        }
        const primaryValue = primary.fn(bboxes[bboxIndex]) + primary.padding;
        maxPrimaryValues[primaryValueIdx] = Math.max((_a = maxPrimaryValues[primaryValueIdx]) != null ? _a : 0, primaryValue);
        currentMaxSecondary = Math.max(currentMaxSecondary, secondary.fn(bboxes[bboxIndex]) + secondary.padding);
        const currentSecondaryDimension = sumSecondary + currentMaxSecondary;
        const returnResult = !forceResult || result.length > 0;
        if (currentSecondaryDimension > secondary.max && returnResult) {
            currentPrimaryIndices = [];
            break;
        }
        const sumPrimary = maxPrimaryValues.reduce((sum2, next)=>sum2 + next, 0);
        if (sumPrimary > primary.max && !forceResult) {
            if (maxPrimaryValues.length < primaryCount) return maxPrimaryValues.length;
            return;
        }
        currentPrimaryIndices.push(bboxIndex + indexOffset);
    }
    if (currentPrimaryIndices.length > 0) result.push(currentPrimaryIndices);
    return result.length > 0 ? result : void 0;
}
function $d77b025aa58d633c$var$buildPages(rawPages, orientation, bboxes, itemPaddingY, itemPaddingX) {
    let maxPageWidth = 0;
    let maxPageHeight = 0;
    const pages = rawPages.map((indices)=>{
        if (orientation === "horizontal") indices = $d77b025aa58d633c$var$transpose(indices);
        let endIndex = 0;
        const columns = indices.map((colIndices)=>{
            const colBBoxes = colIndices.map((bboxIndex)=>{
                endIndex = Math.max(bboxIndex, endIndex);
                return bboxes[bboxIndex];
            });
            let columnHeight = 0;
            let columnWidth = 0;
            colBBoxes.forEach((bbox)=>{
                columnHeight += bbox.height + itemPaddingY;
                columnWidth = Math.max(columnWidth, bbox.width + itemPaddingX);
            });
            return {
                indices: colIndices,
                bboxes: colBBoxes,
                columnHeight: Math.ceil(columnHeight),
                columnWidth: Math.ceil(columnWidth)
            };
        });
        let pageWidth = 0;
        let pageHeight = 0;
        columns.forEach((column)=>{
            pageWidth += column.columnWidth;
            pageHeight = Math.max(pageHeight, column.columnHeight);
        });
        maxPageWidth = Math.max(pageWidth, maxPageWidth);
        maxPageHeight = Math.max(pageHeight, maxPageHeight);
        return {
            columns: columns,
            startIndex: indices[0][0],
            endIndex: endIndex,
            pageWidth: pageWidth,
            pageHeight: pageHeight
        };
    });
    return {
        pages: pages,
        maxPageWidth: maxPageWidth,
        maxPageHeight: maxPageHeight
    };
}
function $d77b025aa58d633c$var$transpose(data) {
    const result = [];
    for (const _ of data[0])result.push([]);
    data.forEach((innerData, dataIdx)=>{
        innerData.forEach((item, itemIdx)=>{
            result[itemIdx][dataIdx] = item;
        });
    });
    return result;
}
function $d77b025aa58d633c$var$estimateStartingGuess(bboxes, primary) {
    const n = bboxes.length;
    let primarySum = 0;
    for(let bboxIndex = 0; bboxIndex < n; bboxIndex++){
        primarySum += primary.fn(bboxes[bboxIndex]) + primary.padding;
        if (primarySum > primary.max) {
            const ratio = n / bboxIndex;
            if (ratio < 2) return Math.ceil(n / 2);
            return bboxIndex;
        }
    }
    return n;
}
// packages/ag-charts-community/src/chart/markerLabel.ts
var $d77b025aa58d633c$var$MarkerLabel = class extends $d77b025aa58d633c$var$Group {
    constructor(){
        super({
            name: "markerLabelGroup"
        });
        this.label = new $d77b025aa58d633c$var$Text();
        this.line = new $d77b025aa58d633c$var$Line();
        this._marker = new $d77b025aa58d633c$var$Square();
        this._markerSize = 15;
        this._spacing = 8;
        const { marker: marker, label: label, line: line } = this;
        label.textBaseline = "middle";
        label.fontSize = 12;
        label.fontFamily = "Verdana, sans-serif";
        label.fill = "black";
        label.y = 1;
        this.append([
            line,
            marker,
            label
        ]);
        this.update();
    }
    set marker(value) {
        if (this._marker !== value) {
            this.removeChild(this._marker);
            this._marker = value;
            this.appendChild(value);
            this.update();
        }
    }
    get marker() {
        return this._marker;
    }
    set markerSize(value) {
        if (this._markerSize !== value) {
            this._markerSize = value;
            this.update();
        }
    }
    get markerSize() {
        return this._markerSize;
    }
    set spacing(value) {
        if (this._spacing !== value) {
            this._spacing = value;
            this.update();
        }
    }
    get spacing() {
        return this._spacing;
    }
    setSeriesStrokeOffset(xOff) {
        const offset4 = this.marker.size / 2 + xOff;
        this.line.x1 = -offset4;
        this.line.x2 = offset4;
        this.line.y1 = 0;
        this.line.y2 = 0;
        this.line.markDirtyTransform();
        this.update();
    }
    update() {
        const { markerSize: markerSize } = this;
        const center = this.marker.constructor.center;
        this.marker.size = markerSize;
        this.marker.x = (center.x - 0.5) * markerSize;
        this.marker.y = (center.y - 0.5) * markerSize;
        const lineEnd = this.line.visible ? this.line.x2 : -Infinity;
        const markerEnd = markerSize / 2;
        this.label.x = Math.max(lineEnd, markerEnd) + this.spacing;
    }
    render(renderCtx) {
        this.marker.opacity = this.opacity;
        this.label.opacity = this.opacity;
        this.line.opacity = this.opacity;
        super.render(renderCtx);
    }
};
$d77b025aa58d633c$var$MarkerLabel.className = "MarkerLabel";
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyPropertyOnWrite("label")
], $d77b025aa58d633c$var$MarkerLabel.prototype, "text", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyPropertyOnWrite("label")
], $d77b025aa58d633c$var$MarkerLabel.prototype, "fontStyle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyPropertyOnWrite("label")
], $d77b025aa58d633c$var$MarkerLabel.prototype, "fontWeight", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyPropertyOnWrite("label")
], $d77b025aa58d633c$var$MarkerLabel.prototype, "fontSize", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyPropertyOnWrite("label")
], $d77b025aa58d633c$var$MarkerLabel.prototype, "fontFamily", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyPropertyOnWrite("label", "fill")
], $d77b025aa58d633c$var$MarkerLabel.prototype, "color", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyPropertyOnWrite("marker", "fill")
], $d77b025aa58d633c$var$MarkerLabel.prototype, "markerFill", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyPropertyOnWrite("marker", "stroke")
], $d77b025aa58d633c$var$MarkerLabel.prototype, "markerStroke", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyPropertyOnWrite("marker", "strokeWidth")
], $d77b025aa58d633c$var$MarkerLabel.prototype, "markerStrokeWidth", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyPropertyOnWrite("marker", "fillOpacity")
], $d77b025aa58d633c$var$MarkerLabel.prototype, "markerFillOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyPropertyOnWrite("marker", "strokeOpacity")
], $d77b025aa58d633c$var$MarkerLabel.prototype, "markerStrokeOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyPropertyOnWrite("marker", "visible")
], $d77b025aa58d633c$var$MarkerLabel.prototype, "markerVisible", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyPropertyOnWrite("line", "stroke")
], $d77b025aa58d633c$var$MarkerLabel.prototype, "lineStroke", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyPropertyOnWrite("line", "strokeWidth")
], $d77b025aa58d633c$var$MarkerLabel.prototype, "lineStrokeWidth", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyPropertyOnWrite("line", "strokeOpacity")
], $d77b025aa58d633c$var$MarkerLabel.prototype, "lineStrokeOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyPropertyOnWrite("line", "lineDash")
], $d77b025aa58d633c$var$MarkerLabel.prototype, "lineLineDash", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ProxyPropertyOnWrite("line", "visible")
], $d77b025aa58d633c$var$MarkerLabel.prototype, "lineVisible", 2);
// packages/ag-charts-community/src/chart/pagination/pagination.ts
var $d77b025aa58d633c$var$PaginationLabel = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.color = "black";
        this.fontStyle = void 0;
        this.fontWeight = void 0;
        this.fontSize = 12;
        this.fontFamily = "Verdana, sans-serif";
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$COLOR_STRING)
], $d77b025aa58d633c$var$PaginationLabel.prototype, "color", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$FONT_STYLE, {
        optional: true
    })
], $d77b025aa58d633c$var$PaginationLabel.prototype, "fontStyle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$FONT_WEIGHT2, {
        optional: true
    })
], $d77b025aa58d633c$var$PaginationLabel.prototype, "fontWeight", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$PaginationLabel.prototype, "fontSize", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING)
], $d77b025aa58d633c$var$PaginationLabel.prototype, "fontFamily", 2);
var $d77b025aa58d633c$var$PaginationMarkerStyle = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.size = 15;
        this.fill = void 0;
        this.fillOpacity = void 0;
        this.stroke = void 0;
        this.strokeWidth = 1;
        this.strokeOpacity = 1;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$PaginationMarkerStyle.prototype, "size", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$COLOR_STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$PaginationMarkerStyle.prototype, "fill", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$RATIO, {
        optional: true
    })
], $d77b025aa58d633c$var$PaginationMarkerStyle.prototype, "fillOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$COLOR_STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$PaginationMarkerStyle.prototype, "stroke", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$PaginationMarkerStyle.prototype, "strokeWidth", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$RATIO)
], $d77b025aa58d633c$var$PaginationMarkerStyle.prototype, "strokeOpacity", 2);
var $d77b025aa58d633c$var$PaginationMarker = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(parent){
        super();
        this.parent = parent;
        this.shape = $d77b025aa58d633c$var$Triangle;
        this.size = 15;
        this.padding = 8;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ActionOnSet({
        changeValue () {
            if (this.parent.marker === this) this.parent.onMarkerShapeChange();
        }
    })
], $d77b025aa58d633c$var$PaginationMarker.prototype, "shape", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$PaginationMarker.prototype, "size", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$PaginationMarker.prototype, "padding", 2);
var $d77b025aa58d633c$var$Pagination = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(chartUpdateCallback, pageUpdateCallback, regionManager, cursorManager){
        super();
        this.chartUpdateCallback = chartUpdateCallback;
        this.pageUpdateCallback = pageUpdateCallback;
        this.regionManager = regionManager;
        this.cursorManager = cursorManager;
        this.id = $d77b025aa58d633c$var$createId(this);
        this.marker = new $d77b025aa58d633c$var$PaginationMarker(this);
        this.activeStyle = new $d77b025aa58d633c$var$PaginationMarkerStyle();
        this.inactiveStyle = new $d77b025aa58d633c$var$PaginationMarkerStyle();
        this.highlightStyle = new $d77b025aa58d633c$var$PaginationMarkerStyle();
        this.label = new $d77b025aa58d633c$var$PaginationLabel();
        this.group = new $d77b025aa58d633c$var$Group({
            name: "pagination"
        });
        this.labelNode = new $d77b025aa58d633c$var$Text();
        this.destroyFns = [];
        this.totalPages = 0;
        this.currentPage = 0;
        this.translationX = 0;
        this.translationY = 0;
        this.nextButtonDisabled = false;
        this.previousButtonDisabled = false;
        this._visible = true;
        this._enabled = true;
        this._orientation = "vertical";
        this._nextButton = new $d77b025aa58d633c$var$Triangle();
        this._previousButton = new $d77b025aa58d633c$var$Triangle();
        this.labelNode.setProperties({
            textBaseline: "middle",
            fontSize: 12,
            fontFamily: "Verdana, sans-serif",
            fill: "black",
            y: 1
        });
        this.group.append([
            this.nextButton,
            this.previousButton,
            this.labelNode
        ]);
        const region = this.regionManager.addRegion("pagination", this.group);
        this.destroyFns.push(region.addListener("click", (event)=>this.onPaginationClick(event)), region.addListener("hover", (event)=>this.onPaginationMouseMove(event)));
        this.update();
        this.updateMarkers();
    }
    destroy() {
        this.destroyFns.forEach((f)=>f());
    }
    set visible(value) {
        this._visible = value;
        this.updateGroupVisibility();
    }
    get visible() {
        return this._visible;
    }
    set enabled(value) {
        this._enabled = value;
        this.updateGroupVisibility();
    }
    get enabled() {
        return this._enabled;
    }
    updateGroupVisibility() {
        this.group.visible = this.enabled && this.visible;
    }
    set orientation(value) {
        this._orientation = value;
        switch(value){
            case "horizontal":
                this.previousButton.rotation = -Math.PI / 2;
                this.nextButton.rotation = Math.PI / 2;
                break;
            case "vertical":
            default:
                this.previousButton.rotation = 0;
                this.nextButton.rotation = Math.PI;
        }
    }
    get orientation() {
        return this._orientation;
    }
    set nextButton(value) {
        if (this._nextButton !== value) {
            this.group.removeChild(this._nextButton);
            this._nextButton = value;
            this.group.appendChild(value);
        }
    }
    get nextButton() {
        return this._nextButton;
    }
    set previousButton(value) {
        if (this._previousButton !== value) {
            this.group.removeChild(this._previousButton);
            this._previousButton = value;
            this.group.appendChild(value);
        }
    }
    get previousButton() {
        return this._previousButton;
    }
    update() {
        this.updateLabel();
        this.updatePositions();
        this.enableOrDisableButtons();
    }
    updatePositions() {
        this.group.translationX = this.translationX;
        this.group.translationY = this.translationY;
        this.updateLabelPosition();
        this.updateNextButtonPosition();
    }
    updateLabelPosition() {
        const { size: markerSize, padding: markerPadding } = this.marker;
        this.nextButton.size = markerSize;
        this.previousButton.size = markerSize;
        this.labelNode.x = markerSize / 2 + markerPadding;
    }
    updateNextButtonPosition() {
        const labelBBox = this.labelNode.computeBBox();
        this.nextButton.translationX = labelBBox.x + labelBBox.width + this.marker.size / 2 + this.marker.padding;
    }
    updateLabel() {
        const { currentPage: currentPage, totalPages: pages, labelNode: labelNode, label: { color: color, fontStyle: fontStyle, fontWeight: fontWeight, fontSize: fontSize, fontFamily: fontFamily } } = this;
        labelNode.text = `${currentPage + 1} / ${pages}`;
        labelNode.fill = color;
        labelNode.fontStyle = fontStyle;
        labelNode.fontWeight = fontWeight;
        labelNode.fontSize = fontSize;
        labelNode.fontFamily = fontFamily;
    }
    updateMarkers() {
        const { nextButton: nextButton, previousButton: previousButton, nextButtonDisabled: nextButtonDisabled, previousButtonDisabled: previousButtonDisabled, activeStyle: activeStyle, inactiveStyle: inactiveStyle, highlightStyle: highlightStyle, highlightActive: highlightActive } = this;
        const buttonStyle = (button, disabled)=>{
            if (disabled) return inactiveStyle;
            else if (button === highlightActive) return highlightStyle;
            return activeStyle;
        };
        this.updateMarker(nextButton, buttonStyle("next", nextButtonDisabled));
        this.updateMarker(previousButton, buttonStyle("previous", previousButtonDisabled));
    }
    updateMarker(marker, style) {
        var _a;
        const { size: size } = this.marker;
        marker.size = size;
        marker.fill = style.fill;
        marker.fillOpacity = (_a = style.fillOpacity) != null ? _a : 1;
        marker.stroke = style.stroke;
        marker.strokeWidth = style.strokeWidth;
        marker.strokeOpacity = style.strokeOpacity;
    }
    enableOrDisableButtons() {
        const { currentPage: currentPage, totalPages: totalPages } = this;
        const zeroPagesToDisplay = totalPages === 0;
        const onLastPage = currentPage === totalPages - 1;
        const onFirstPage = currentPage === 0;
        this.nextButtonDisabled = onLastPage || zeroPagesToDisplay;
        this.previousButtonDisabled = onFirstPage || zeroPagesToDisplay;
    }
    nextButtonContainsPoint(offsetX, offsetY) {
        return !this.nextButtonDisabled && this.nextButton.containsPoint(offsetX, offsetY);
    }
    previousButtonContainsPoint(offsetX, offsetY) {
        return !this.previousButtonDisabled && this.previousButton.containsPoint(offsetX, offsetY);
    }
    clickNext() {
        this.incrementPage();
        this.onPaginationChanged();
    }
    clickPrevious() {
        this.decrementPage();
        this.onPaginationChanged();
    }
    setPage(pageNumber) {
        pageNumber = $d77b025aa58d633c$var$clamp(0, pageNumber, this.totalPages - 1);
        if (this.currentPage !== pageNumber) {
            this.currentPage = pageNumber;
            this.onPaginationChanged();
        }
    }
    onPaginationClick(event) {
        const { offsetX: offsetX, offsetY: offsetY } = event;
        if (this.nextButtonContainsPoint(offsetX, offsetY)) {
            this.clickNext();
            event.consume();
        } else if (this.previousButtonContainsPoint(offsetX, offsetY)) {
            this.clickPrevious();
            event.consume();
        }
    }
    onPaginationMouseMove(event) {
        const { offsetX: offsetX, offsetY: offsetY } = event;
        if (this.nextButtonContainsPoint(offsetX, offsetY)) {
            this.cursorManager.updateCursor(this.id, "pointer");
            this.highlightActive = "next";
        } else if (this.previousButtonContainsPoint(offsetX, offsetY)) {
            this.cursorManager.updateCursor(this.id, "pointer");
            this.highlightActive = "previous";
        } else {
            this.cursorManager.updateCursor(this.id);
            this.highlightActive = void 0;
        }
        this.updateMarkers();
        this.chartUpdateCallback(6 /* SCENE_RENDER */ );
    }
    onPaginationChanged() {
        this.pageUpdateCallback(this.currentPage);
    }
    incrementPage() {
        this.currentPage = Math.min(this.currentPage + 1, this.totalPages - 1);
    }
    decrementPage() {
        this.currentPage = Math.max(this.currentPage - 1, 0);
    }
    onMarkerShapeChange() {
        const Marker2 = $d77b025aa58d633c$var$getMarker(this.marker.shape || $d77b025aa58d633c$var$Triangle);
        this.previousButton = new Marker2();
        this.nextButton = new Marker2();
        this.updatePositions();
        this.updateMarkers();
        this.chartUpdateCallback(6 /* SCENE_RENDER */ );
    }
    attachPagination(node) {
        node.append(this.group);
    }
    computeBBox() {
        return this.group.computeBBox();
    }
};
$d77b025aa58d633c$var$Pagination.className = "Pagination";
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$Pagination.prototype, "marker", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$Pagination.prototype, "activeStyle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$Pagination.prototype, "inactiveStyle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$Pagination.prototype, "highlightStyle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$Pagination.prototype, "label", 2);
// packages/ag-charts-community/src/chart/legend.ts
var $d77b025aa58d633c$var$LegendLabel = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.maxLength = void 0;
        this.color = "black";
        this.fontStyle = void 0;
        this.fontWeight = void 0;
        this.fontSize = 12;
        this.fontFamily = "Verdana, sans-serif";
        this.formatter = void 0;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER, {
        optional: true
    })
], $d77b025aa58d633c$var$LegendLabel.prototype, "maxLength", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$COLOR_STRING)
], $d77b025aa58d633c$var$LegendLabel.prototype, "color", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$FONT_STYLE, {
        optional: true
    })
], $d77b025aa58d633c$var$LegendLabel.prototype, "fontStyle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$FONT_WEIGHT2, {
        optional: true
    })
], $d77b025aa58d633c$var$LegendLabel.prototype, "fontWeight", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$LegendLabel.prototype, "fontSize", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING)
], $d77b025aa58d633c$var$LegendLabel.prototype, "fontFamily", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$FUNCTION, {
        optional: true
    })
], $d77b025aa58d633c$var$LegendLabel.prototype, "formatter", 2);
var $d77b025aa58d633c$var$LegendMarker = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.size = 15;
        this.padding = 8;
        this.enabled = true;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ObserveChanges((target)=>{
        var _a;
        return (_a = target.parent) == null ? void 0 : _a.onMarkerShapeChange();
    })
], $d77b025aa58d633c$var$LegendMarker.prototype, "shape", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$LegendMarker.prototype, "size", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$LegendMarker.prototype, "padding", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER, {
        optional: true
    })
], $d77b025aa58d633c$var$LegendMarker.prototype, "strokeWidth", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN)
], $d77b025aa58d633c$var$LegendMarker.prototype, "enabled", 2);
var $d77b025aa58d633c$var$LegendLine = class extends $d77b025aa58d633c$var$BaseProperties {
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER, {
        optional: true
    })
], $d77b025aa58d633c$var$LegendLine.prototype, "strokeWidth", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER, {
        optional: true
    })
], $d77b025aa58d633c$var$LegendLine.prototype, "length", 2);
var $d77b025aa58d633c$var$LegendItem = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.paddingX = 16;
        this.paddingY = 8;
        this.toggleSeriesVisible = true;
        this.showSeriesStroke = false;
        this.marker = new $d77b025aa58d633c$var$LegendMarker();
        this.label = new $d77b025aa58d633c$var$LegendLabel();
        this.line = new $d77b025aa58d633c$var$LegendLine();
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER, {
        optional: true
    })
], $d77b025aa58d633c$var$LegendItem.prototype, "maxWidth", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$LegendItem.prototype, "paddingX", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$LegendItem.prototype, "paddingY", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN)
], $d77b025aa58d633c$var$LegendItem.prototype, "toggleSeriesVisible", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN)
], $d77b025aa58d633c$var$LegendItem.prototype, "showSeriesStroke", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$LegendItem.prototype, "marker", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$LegendItem.prototype, "label", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$LegendItem.prototype, "line", 2);
var $d77b025aa58d633c$var$LegendListeners = class extends $d77b025aa58d633c$var$BaseProperties {
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$FUNCTION, {
        optional: true
    })
], $d77b025aa58d633c$var$LegendListeners.prototype, "legendItemClick", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$FUNCTION, {
        optional: true
    })
], $d77b025aa58d633c$var$LegendListeners.prototype, "legendItemDoubleClick", 2);
var $d77b025aa58d633c$var$Legend = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(ctx){
        super();
        this.ctx = ctx;
        this.id = $d77b025aa58d633c$var$createId(this);
        this.group = new $d77b025aa58d633c$var$Group({
            name: "legend",
            layer: true,
            zIndex: 11 /* LEGEND_ZINDEX */ 
        });
        this.itemSelection = $d77b025aa58d633c$var$Selection.select(this.group, $d77b025aa58d633c$var$MarkerLabel);
        this.oldSize = [
            0,
            0
        ];
        this.pages = [];
        this.maxPageSize = [
            0,
            0
        ];
        /** Item index to track on re-pagination, so current page updates appropriately. */ this.paginationTrackingIndex = 0;
        this.truncatedItems = /* @__PURE__ */ new Set();
        this._data = [];
        this.item = new $d77b025aa58d633c$var$LegendItem();
        this.listeners = new $d77b025aa58d633c$var$LegendListeners();
        this.enabled = true;
        this.position = "bottom";
        this.spacing = 20;
        this.characterWidths = /* @__PURE__ */ new Map();
        this.destroyFns = [];
        this.size = [
            0,
            0
        ];
        this._visible = true;
        this.focus = {
            mode: "item",
            index: 0
        };
        this.item.marker.parent = this;
        this.pagination = new $d77b025aa58d633c$var$Pagination((type)=>ctx.updateService.update(type), (page)=>this.updatePageNumber(page), ctx.regionManager, ctx.cursorManager);
        this.pagination.attachPagination(this.group);
        this.item.marker.parent = this;
        const animationState = 17 /* Animation */ ;
        const region = ctx.regionManager.addRegionFromProperties({
            name: "legend",
            bboxproviders: [
                this.group
            ],
            canInteraction: ()=>this.enabled && this.group.visible
        });
        this.destroyFns.push(region.addListener("click", (e)=>this.checkLegendClick(e), animationState), region.addListener("dblclick", (e)=>this.checkLegendDoubleClick(e), animationState), region.addListener("hover", (e)=>this.handleLegendMouseMove(e)), region.addListener("leave", (e)=>this.handleLegendMouseExit(e), animationState), region.addListener("enter", (e)=>this.handleLegendMouseEnter(e), animationState), region.addListener("blur", (e)=>this.onBlur(e)), region.addListener("tab", (e)=>this.onTab(e)), region.addListener("tab-start", (e)=>this.onTabStart(e)), region.addListener("nav-vert", (e)=>this.onNav(e)), region.addListener("nav-hori", (e)=>this.onNav(e)), region.addListener("submit", (e)=>this.onSubmit(e)), ctx.layoutService.addListener("start-layout", (e)=>this.positionLegend(e.shrinkRect)), ()=>this.detachLegend());
    }
    set data(value) {
        this._data = value;
        this.updateGroupVisibility();
    }
    get data() {
        return this._data;
    }
    destroy() {
        this.destroyFns.forEach((f)=>f());
        this.pagination.destroy();
    }
    onMarkerShapeChange() {
        this.itemSelection.clear();
        this.group.markDirty(this.group, 2 /* MINOR */ );
    }
    getOrientation() {
        if (this.orientation !== void 0) return this.orientation;
        switch(this.position){
            case "right":
            case "left":
                return "vertical";
            case "bottom":
            case "top":
                return "horizontal";
        }
    }
    getCharacterWidths(font) {
        const { characterWidths: characterWidths } = this;
        if (characterWidths.has(font)) return characterWidths.get(font);
        const cw = {
            "...": $d77b025aa58d633c$var$Text.getTextSize("...", font).width
        };
        characterWidths.set(font, cw);
        return cw;
    }
    set visible(value) {
        this._visible = value;
        this.updateGroupVisibility();
    }
    get visible() {
        return this._visible;
    }
    updateGroupVisibility() {
        this.group.visible = this.enabled && this.visible && this.data.length > 0;
    }
    attachLegend(scene) {
        scene.appendChild(this.group);
    }
    detachLegend() {
        var _a;
        (_a = this.group.parent) == null || _a.removeChild(this.group);
    }
    getItemLabel(datum) {
        const { ctx: { callbackCache: callbackCache } } = this;
        const { formatter: formatter } = this.item.label;
        if (formatter) return callbackCache.call(formatter, {
            itemId: datum.itemId,
            value: datum.label.text,
            seriesId: datum.seriesId
        });
        return datum.label.text;
    }
    /**
   * The method is given the desired size of the legend, which only serves as a hint.
   * The vertically oriented legend will take as much horizontal space as needed, but will
   * respect the height constraints, and the horizontal legend will take as much vertical
   * space as needed in an attempt not to exceed the given width.
   * After the layout is done, the {@link size} will contain the actual size of the legend.
   * If the actual size is not the same as the previous actual size, the legend will fire
   * the 'layoutChange' event to communicate that another layout is needed, and the above
   * process should be repeated.
   * @param width
   * @param height
   */ calcLayout(width, height) {
        const { paddingX: paddingX, paddingY: paddingY, label: label, maxWidth: maxWidth, marker: { size: markerSize, padding: markerPadding, shape: markerShape }, label: { maxLength: maxLength = Infinity, fontStyle: fontStyle, fontWeight: fontWeight, fontSize: fontSize, fontFamily: fontFamily }, line: itemLine, showSeriesStroke: showSeriesStroke } = this.item;
        const data = [
            ...this.data
        ];
        if (this.reverseOrder) data.reverse();
        this.itemSelection.update(data);
        const bboxes = [];
        const font = $d77b025aa58d633c$var$getFont(label);
        const itemMaxWidthPercentage = 0.8;
        const maxItemWidth = maxWidth != null ? maxWidth : width * itemMaxWidthPercentage;
        const paddedMarkerWidth = markerSize + markerPadding + paddingX;
        this.itemSelection.each((markerLabel, datum)=>{
            var _a, _b, _c;
            const Marker2 = $d77b025aa58d633c$var$getMarker(markerShape != null ? markerShape : datum.marker.shape);
            const markerEnabled = (_a = datum.marker.enabled) != null ? _a : this.item.marker.enabled;
            if (!(markerLabel.marker && markerLabel.marker instanceof Marker2)) markerLabel.marker = new Marker2();
            markerLabel.markerSize = markerSize;
            markerLabel.spacing = markerPadding;
            markerLabel.fontStyle = fontStyle;
            markerLabel.fontWeight = fontWeight;
            markerLabel.fontSize = fontSize;
            markerLabel.fontFamily = fontFamily;
            const id = (_b = datum.itemId) != null ? _b : datum.id;
            const labelText = this.getItemLabel(datum);
            const text = (labelText != null ? labelText : "<unknown>").replace(/\r?\n/g, " ");
            markerLabel.text = this.truncate(text, maxLength, maxItemWidth, paddedMarkerWidth, font, id);
            if (showSeriesStroke && datum.line !== void 0) {
                markerLabel.lineVisible = true;
                markerLabel.markerVisible = markerEnabled;
                markerLabel.setSeriesStrokeOffset((_c = itemLine.length) != null ? _c : 5);
            } else {
                markerLabel.lineVisible = false;
                markerLabel.markerVisible = true;
            }
            bboxes.push(markerLabel.computeBBox());
        });
        width = Math.max(1, width);
        height = Math.max(1, height);
        if (!isFinite(width)) return false;
        const size = this.size;
        const oldSize = this.oldSize;
        size[0] = width;
        size[1] = height;
        if (size[0] !== oldSize[0] || size[1] !== oldSize[1]) {
            oldSize[0] = size[0];
            oldSize[1] = size[1];
        }
        const { pages: pages, maxPageHeight: maxPageHeight, maxPageWidth: maxPageWidth } = this.updatePagination(bboxes, width, height);
        this.pages = pages;
        this.maxPageSize = [
            maxPageWidth - paddingX,
            maxPageHeight - paddingY
        ];
        const pageNumber = this.pagination.currentPage;
        const page = this.pages[pageNumber];
        if (this.pages.length < 1 || !page) {
            this.visible = false;
            return;
        }
        this.visible = true;
        this.updatePositions(pageNumber);
        this.update();
    }
    truncate(text, maxCharLength, maxItemWidth, paddedMarkerWidth, font, id) {
        const ellipsis2 = `...`;
        const textChars = text.split("");
        let addEllipsis = false;
        if (text.length > maxCharLength) {
            text = `${text.substring(0, maxCharLength)}`;
            addEllipsis = true;
        }
        const labelWidth = Math.floor(paddedMarkerWidth + $d77b025aa58d633c$var$Text.getTextSize(text, font).width);
        if (labelWidth > maxItemWidth) {
            let truncatedText = "";
            const characterWidths = this.getCharacterWidths(font);
            let cumulativeWidth = paddedMarkerWidth + characterWidths[ellipsis2];
            for (const char of textChars){
                if (!characterWidths[char]) characterWidths[char] = $d77b025aa58d633c$var$Text.getTextSize(char, font).width;
                cumulativeWidth += characterWidths[char];
                if (cumulativeWidth > maxItemWidth) break;
                truncatedText += char;
            }
            text = truncatedText;
            addEllipsis = true;
        }
        if (addEllipsis) {
            text += ellipsis2;
            this.truncatedItems.add(id);
        } else this.truncatedItems.delete(id);
        return text;
    }
    updatePagination(bboxes, width, height) {
        const orientation = this.getOrientation();
        const trackingIndex = Math.min(this.paginationTrackingIndex, bboxes.length);
        this.pagination.orientation = orientation;
        this.pagination.translationX = 0;
        this.pagination.translationY = 0;
        const { pages: pages, maxPageHeight: maxPageHeight, maxPageWidth: maxPageWidth, paginationBBox: paginationBBox, paginationVertical: paginationVertical } = this.calculatePagination(bboxes, width, height);
        const newCurrentPage = pages.findIndex((p)=>p.endIndex >= trackingIndex);
        this.pagination.currentPage = $d77b025aa58d633c$var$clamp(0, newCurrentPage, pages.length - 1);
        const { paddingX: itemPaddingX, paddingY: itemPaddingY } = this.item;
        const paginationComponentPadding = 8;
        const legendItemsWidth = maxPageWidth - itemPaddingX;
        const legendItemsHeight = maxPageHeight - itemPaddingY;
        let paginationX = 0;
        let paginationY = -paginationBBox.y - this.item.marker.size / 2;
        if (paginationVertical) paginationY += legendItemsHeight + paginationComponentPadding;
        else {
            paginationX += -paginationBBox.x + legendItemsWidth + paginationComponentPadding;
            paginationY += (legendItemsHeight - paginationBBox.height) / 2;
        }
        this.pagination.translationX = paginationX;
        this.pagination.translationY = paginationY;
        this.pagination.update();
        this.pagination.updateMarkers();
        return {
            maxPageHeight: maxPageHeight,
            maxPageWidth: maxPageWidth,
            pages: pages
        };
    }
    calculatePagination(bboxes, width, height) {
        var _a, _b, _c;
        const { paddingX: itemPaddingX, paddingY: itemPaddingY } = this.item;
        const orientation = this.getOrientation();
        const paginationVertical = [
            "left",
            "right"
        ].includes(this.position);
        let paginationBBox = this.pagination.computeBBox();
        let lastPassPaginationBBox = new $d77b025aa58d633c$var$BBox(0, 0, 0, 0);
        let pages = [];
        let maxPageWidth = 0;
        let maxPageHeight = 0;
        let count = 0;
        const stableOutput = (bbox)=>{
            return bbox.width === paginationBBox.width && bbox.height === paginationBBox.height;
        };
        const forceResult = this.maxWidth !== void 0 && this.maxHeight !== void 0;
        do {
            if (count++ > 10) {
                $d77b025aa58d633c$var$Logger.warn("unable to find stable legend layout.");
                break;
            }
            paginationBBox = lastPassPaginationBBox;
            const maxWidth = width - (paginationVertical ? 0 : paginationBBox.width);
            const maxHeight = height - (paginationVertical ? paginationBBox.height : 0);
            const layout = $d77b025aa58d633c$var$gridLayout({
                orientation: orientation,
                bboxes: bboxes,
                maxHeight: maxHeight,
                maxWidth: maxWidth,
                itemPaddingY: itemPaddingY,
                itemPaddingX: itemPaddingX,
                forceResult: forceResult
            });
            pages = (_a = layout == null ? void 0 : layout.pages) != null ? _a : [];
            maxPageWidth = (_b = layout == null ? void 0 : layout.maxPageWidth) != null ? _b : 0;
            maxPageHeight = (_c = layout == null ? void 0 : layout.maxPageHeight) != null ? _c : 0;
            const totalPages = pages.length;
            this.pagination.visible = totalPages > 1;
            this.pagination.totalPages = totalPages;
            this.pagination.update();
            lastPassPaginationBBox = this.pagination.computeBBox();
            if (!this.pagination.visible) break;
        }while (!stableOutput(lastPassPaginationBBox));
        return {
            maxPageWidth: maxPageWidth,
            maxPageHeight: maxPageHeight,
            pages: pages,
            paginationBBox: paginationBBox,
            paginationVertical: paginationVertical
        };
    }
    getPageItemCount(pageNumber) {
        let count = 0;
        for (const col of this.pages[pageNumber].columns)count += col.indices.length;
        return count;
    }
    getNodeIndexFromFocusIndex() {
        const { index: index } = this.focus;
        const page = this.pages[this.pagination.currentPage];
        let itemCount = 0;
        for (const col of page.columns){
            if (index < itemCount + col.indices.length) return col.indices[index - itemCount];
            else itemCount += col.indices.length;
        }
        return -1;
    }
    updatePositions(pageNumber = 0) {
        const { item: { paddingY: paddingY }, itemSelection: itemSelection, pages: pages } = this;
        if (pages.length < 1 || !pages[pageNumber]) return;
        const { columns: columns, startIndex: visibleStart, endIndex: visibleEnd } = pages[pageNumber];
        let x = 0;
        let y = 0;
        const columnCount = columns.length;
        const rowCount = columns[0].indices.length;
        const horizontal = this.getOrientation() === "horizontal";
        const itemHeight = columns[0].bboxes[0].height + paddingY;
        const rowSumColumnWidths = [];
        itemSelection.each((markerLabel, _, i)=>{
            var _a, _b;
            if (i < visibleStart || i > visibleEnd) {
                markerLabel.visible = false;
                return;
            }
            const pageIndex = i - visibleStart;
            let columnIndex = 0;
            let rowIndex = 0;
            if (horizontal) {
                columnIndex = pageIndex % columnCount;
                rowIndex = Math.floor(pageIndex / columnCount);
            } else {
                columnIndex = Math.floor(pageIndex / rowCount);
                rowIndex = pageIndex % rowCount;
            }
            markerLabel.visible = true;
            const column = columns[columnIndex];
            if (!column) return;
            y = itemHeight * rowIndex;
            x = (_a = rowSumColumnWidths[rowIndex]) != null ? _a : 0;
            rowSumColumnWidths[rowIndex] = ((_b = rowSumColumnWidths[rowIndex]) != null ? _b : 0) + column.columnWidth;
            markerLabel.translationX = Math.floor(x);
            markerLabel.translationY = Math.floor(y);
        });
    }
    updatePageNumber(pageNumber) {
        const { pages: pages } = this;
        const { startIndex: startIndex, endIndex: endIndex } = pages[pageNumber];
        if (startIndex === 0) this.paginationTrackingIndex = 0;
        else if (pageNumber === pages.length - 1) this.paginationTrackingIndex = endIndex;
        else this.paginationTrackingIndex = Math.floor((startIndex + endIndex) / 2);
        this.pagination.update();
        this.pagination.updateMarkers();
        this.updatePositions(pageNumber);
        this.ctx.updateService.update(6 /* SCENE_RENDER */ );
    }
    update() {
        const { label: { color: color }, marker: itemMarker, line: itemLine, showSeriesStroke: showSeriesStroke } = this.item;
        this.itemSelection.each((markerLabel, datum)=>{
            var _a, _b;
            const marker = datum.marker;
            markerLabel.markerFill = marker.fill;
            markerLabel.markerStroke = marker.stroke;
            markerLabel.markerStrokeWidth = (_a = itemMarker.strokeWidth) != null ? _a : Math.min(2, marker.strokeWidth);
            markerLabel.markerFillOpacity = marker.fillOpacity;
            markerLabel.markerStrokeOpacity = marker.strokeOpacity;
            markerLabel.opacity = datum.enabled ? 1 : 0.5;
            markerLabel.color = color;
            const { line: line } = datum;
            if (showSeriesStroke && line !== void 0) {
                markerLabel.lineStroke = line.stroke;
                markerLabel.lineStrokeOpacity = line.strokeOpacity;
                markerLabel.lineStrokeWidth = (_b = itemLine.strokeWidth) != null ? _b : Math.min(2, line.strokeWidth);
                markerLabel.lineLineDash = line.lineDash;
            }
        });
    }
    getDatumForPoint(x, y) {
        const visibleChildBBoxes = [];
        const closestLeftTop = {
            dist: Infinity,
            datum: void 0
        };
        for (const child of this.group.children){
            if (!child.visible) continue;
            if (!(child instanceof $d77b025aa58d633c$var$MarkerLabel)) continue;
            const childBBox = child.computeBBox();
            childBBox.grow(this.item.paddingX / 2, "horizontal");
            childBBox.grow(this.item.paddingY / 2, "vertical");
            if (childBBox.containsPoint(x, y)) return child.datum;
            const distX = x - childBBox.x - this.item.paddingX / 2;
            const distY = y - childBBox.y - this.item.paddingY / 2;
            const dist = $d77b025aa58d633c$var$__pow(distX, 2) + $d77b025aa58d633c$var$__pow(distY, 2);
            const toTheLeftTop = distX >= 0 && distY >= 0;
            if (toTheLeftTop && dist < closestLeftTop.dist) {
                closestLeftTop.dist = dist;
                closestLeftTop.datum = child.datum;
            }
            visibleChildBBoxes.push(childBBox);
        }
        const pageBBox = $d77b025aa58d633c$var$BBox.merge(visibleChildBBoxes);
        if (!pageBBox.containsPoint(x, y)) return;
        return closestLeftTop.datum;
    }
    computePagedBBox() {
        const actualBBox = this.group.computeBBox();
        if (this.pages.length <= 1) return actualBBox;
        const [maxPageWidth, maxPageHeight] = this.maxPageSize;
        actualBBox.height = Math.max(maxPageHeight, actualBBox.height);
        actualBBox.width = Math.max(maxPageWidth, actualBBox.width);
        return actualBBox;
    }
    checkLegendClick(event) {
        const datum = this.getDatumForPoint(event.offsetX, event.offsetY);
        if (this.doClick(datum)) event.consume();
    }
    doClick(datum) {
        const { listeners: { legendItemClick: legendItemClick }, ctx: { chartService: chartService, highlightManager: highlightManager }, item: { toggleSeriesVisible: toggleSeriesVisible }, preventHidingAll: preventHidingAll } = this;
        if (!datum) return false;
        const { id: id, itemId: itemId, enabled: enabled } = datum;
        const series = chartService.series.find((s)=>s.id === id);
        if (!series) return false;
        let newEnabled = enabled;
        if (toggleSeriesVisible) {
            newEnabled = !enabled;
            if (preventHidingAll && !newEnabled) {
                const numVisibleItems = chartService.series.flatMap((s)=>s.getLegendData("category")).filter((d)=>d.enabled).length;
                if (numVisibleItems < 2) newEnabled = true;
            }
            const status = newEnabled ? "visible" : "hidden";
            this.ctx.ariaAnnouncementService.announceValue(`${status}`);
            this.ctx.chartEventManager.legendItemClick(series, itemId, newEnabled, datum.legendItemName);
        }
        if (newEnabled) highlightManager.updateHighlight(this.id, {
            series: series,
            itemId: itemId,
            datum: void 0
        });
        else highlightManager.updateHighlight(this.id);
        this.ctx.updateService.update(2 /* PROCESS_DATA */ , {
            forceNodeDataRefresh: true
        });
        legendItemClick == null || legendItemClick({
            type: "click",
            enabled: newEnabled,
            itemId: itemId,
            seriesId: series.id
        });
        return true;
    }
    checkLegendDoubleClick(event) {
        var _a;
        const { listeners: { legendItemDoubleClick: legendItemDoubleClick }, ctx: { chartService: chartService }, item: { toggleSeriesVisible: toggleSeriesVisible } } = this;
        if (chartService.mode === "integrated") return;
        const datum = this.getDatumForPoint(event.offsetX, event.offsetY);
        if (!datum) return;
        const { id: id, itemId: itemId, seriesId: seriesId } = datum;
        const series = chartService.series.find((s)=>s.id === id);
        if (!series) return;
        event.consume();
        if (toggleSeriesVisible) {
            const legendData = chartService.series.flatMap((s)=>s.getLegendData("category"));
            const numVisibleItems = legendData.filter((d)=>d.enabled).length;
            const clickedItem = legendData.find((d)=>d.itemId === itemId && d.seriesId === seriesId);
            this.ctx.chartEventManager.legendItemDoubleClick(series, itemId, (_a = clickedItem == null ? void 0 : clickedItem.enabled) != null ? _a : false, numVisibleItems, clickedItem == null ? void 0 : clickedItem.legendItemName);
        }
        this.ctx.updateService.update(2 /* PROCESS_DATA */ , {
            forceNodeDataRefresh: true
        });
        legendItemDoubleClick == null || legendItemDoubleClick({
            type: "dblclick",
            enabled: true,
            itemId: itemId,
            seriesId: series.id
        });
    }
    handleLegendMouseMove(event) {
        if (!this.enabled) return;
        const { offsetX: offsetX, offsetY: offsetY } = event;
        event.consume();
        const datum = this.getDatumForPoint(offsetX, offsetY);
        this.doHover(event, datum);
    }
    doHover(event, datum) {
        var _a;
        const { item: { toggleSeriesVisible: toggleSeriesVisible }, listeners: listeners } = this;
        if (event === void 0 || datum === void 0) {
            this.ctx.cursorManager.updateCursor(this.id);
            this.ctx.highlightManager.updateHighlight(this.id);
            return;
        }
        const series = datum ? this.ctx.chartService.series.find((s)=>s.id === (datum == null ? void 0 : datum.id)) : void 0;
        if (datum && this.truncatedItems.has((_a = datum.itemId) != null ? _a : datum.id)) {
            const { offsetX: offsetX, offsetY: offsetY } = event;
            this.ctx.tooltipManager.updateTooltip(this.id, {
                offsetX: offsetX,
                offsetY: offsetY,
                lastPointerEvent: event,
                showArrow: false
            }, $d77b025aa58d633c$var$toTooltipHtml({
                content: this.getItemLabel(datum)
            }));
        } else this.ctx.tooltipManager.removeTooltip(this.id);
        if (toggleSeriesVisible || listeners.legendItemClick != null || listeners.legendItemDoubleClick != null) this.ctx.cursorManager.updateCursor(this.id, "pointer");
        if ((datum == null ? void 0 : datum.enabled) && series) this.ctx.highlightManager.updateHighlight(this.id, {
            series: series,
            itemId: datum == null ? void 0 : datum.itemId,
            datum: void 0
        });
        else this.ctx.highlightManager.updateHighlight(this.id);
    }
    handleLegendMouseExit(_event) {
        this.doMouseExit();
    }
    doMouseExit() {
        this.ctx.cursorManager.updateCursor(this.id);
        this.ctx.tooltipManager.removeTooltip(this.id);
        if (this.ctx.interactionManager.getState() === 16 /* Default */ ) this.ctx.highlightManager.updateHighlight(this.id);
    }
    handleLegendMouseEnter(event) {
        const { enabled: enabled, item: { toggleSeriesVisible: toggle }, listeners: { legendItemClick: clickListener, legendItemDoubleClick: dblclickListener } } = this;
        const datum = this.getDatumForPoint(event.offsetX, event.offsetY);
        if (enabled && datum !== void 0 && (toggle || clickListener != null || dblclickListener != null)) this.ctx.cursorManager.updateCursor(this.id, "pointer");
    }
    onBlur(_event) {
        this.doMouseExit();
        this.focus.mode = "item";
        this.ctx.regionManager.updateFocusIndicatorRect(void 0);
    }
    onTab(event) {
        this.updateFocus();
        event.consume();
    }
    onTabStart(event) {
        if (!this.pagination.visible || !this.pagination.enabled) return;
        const consumeTabStart = (newMode)=>{
            this.focus.mode = newMode;
            this.updateFocus();
            event.consume();
        };
        if (this.focus.mode === "item" && event.delta === 1) {
            this.focus.index = this.pagination.currentPage === 0 ? 1 : 0;
            consumeTabStart("page");
        } else if (this.focus.mode === "page" && event.delta === -1) {
            this.focus.index = 0;
            consumeTabStart("item");
        }
    }
    onNav(event) {
        if (this.focus.mode === "item") {
            const newIndex = this.focus.index + event.delta;
            const pageItemCount = this.getPageItemCount(this.pagination.currentPage);
            this.focus.index = $d77b025aa58d633c$var$clamp(-1, newIndex, pageItemCount);
            this.updateFocus();
            event.consume();
        } else if (this.focus.mode === "page") {
            if (event.delta < 0) this.focus.index = 0;
            if (event.delta > 0) this.focus.index = 1;
            this.updateFocus();
            event.consume();
        }
    }
    onSubmit(_event) {
        if (this.focus.mode === "item") this.doClick(this.getFocusedItem().datum);
        else if (this.focus.mode === "page") {
            if (this.focus.index === 0) this.pagination.clickPrevious();
            if (this.focus.index === 1) this.pagination.clickNext();
            this.ctx.ariaAnnouncementService.announceValue(`Legend page ${this.pagination.currentPage + 1} of ${this.pages.length}`);
        }
    }
    maybeChangeFocusPage() {
        const oldPage = this.pagination.currentPage;
        const oldPageItemCount = this.getPageItemCount(oldPage);
        if (this.focus.index === -1) this.pagination.setPage(oldPage - 1);
        else if (this.focus.index === oldPageItemCount) this.pagination.setPage(oldPage + 1);
        else return;
        const { currentPage: currentPage } = this.pagination;
        if (oldPage === currentPage) this.focus.index = $d77b025aa58d633c$var$clamp(0, this.focus.index, oldPageItemCount - 1);
        else if (this.focus.index === -1) this.focus.index = this.getPageItemCount(currentPage) - 1;
        else this.focus.index = 0;
    }
    getFocusedItem() {
        if (this.focus.mode !== "item") {
            $d77b025aa58d633c$var$Logger.error(`getFocusedItem() should be called only when focus.mode is 'item'`);
            return {
                nodeIndex: -1,
                node: void 0,
                datum: void 0
            };
        }
        this.maybeChangeFocusPage();
        const nodeIndex = this.getNodeIndexFromFocusIndex();
        if (nodeIndex < 0) {
            $d77b025aa58d633c$var$Logger.error(`Cannot access negative nodeIndex ${nodeIndex}`);
            return {
                nodeIndex: -1,
                node: void 0,
                datum: void 0
            };
        }
        const node = this.itemSelection.nodes()[nodeIndex];
        const data = this.data;
        let datum;
        if (nodeIndex < data.length) datum = this.data[nodeIndex];
        else $d77b025aa58d633c$var$Logger.error(`Cannot access datum[${nodeIndex}]`);
        return {
            nodeIndex: nodeIndex,
            node: node,
            datum: datum
        };
    }
    updateFocus() {
        const { focus: focus, pagination: pagination } = this;
        if (focus.mode === "item") {
            const { nodeIndex: nodeIndex, node: node, datum: datum } = this.getFocusedItem();
            if (datum === void 0) return;
            const bbox = node == null ? void 0 : node.computeTransformedBBox();
            this.doHover($d77b025aa58d633c$var$makeKeyboardPointerEvent(this.ctx.regionManager, {
                bbox: bbox,
                showFocusBox: true
            }), datum);
            const label = datum && this.getItemLabel(datum);
            if (label) {
                const visibility = datum.enabled ? "visible" : "hidden";
                this.ctx.ariaAnnouncementService.announceValue(`Legend item ${nodeIndex + 1} of ${this.data.length}, ${label}, ${visibility}`);
            }
        } else if (focus.mode === "page") {
            const button = focus.index === 0 ? pagination.previousButton : pagination.nextButton;
            this.ctx.regionManager.updateFocusIndicatorRect(button.computeTransformedBBox());
            const value = [
                "Previous legend page",
                "Next legend page"
            ][focus.index];
            this.ctx.ariaAnnouncementService.announceValue(`${value}, button`);
        }
    }
    positionLegend(shrinkRect) {
        const newShrinkRect = shrinkRect.clone();
        if (!this.enabled || !this.data.length) return {
            shrinkRect: newShrinkRect
        };
        const [legendWidth, legendHeight] = this.calculateLegendDimensions(shrinkRect);
        this.group.translationX = 0;
        this.group.translationY = 0;
        this.calcLayout(legendWidth, legendHeight);
        const legendBBox = this.computePagedBBox();
        const calculateTranslationPerpendicularDimension = ()=>{
            switch(this.position){
                case "top":
                case "left":
                    return 0;
                case "bottom":
                    return shrinkRect.height - legendBBox.height;
                case "right":
                default:
                    return shrinkRect.width - legendBBox.width;
            }
        };
        if (this.visible) {
            let translationX;
            let translationY;
            switch(this.position){
                case "top":
                case "bottom":
                    translationX = (shrinkRect.width - legendBBox.width) / 2;
                    translationY = calculateTranslationPerpendicularDimension();
                    newShrinkRect.shrink(legendBBox.height, this.position);
                    break;
                case "left":
                case "right":
                default:
                    translationX = calculateTranslationPerpendicularDimension();
                    translationY = (shrinkRect.height - legendBBox.height) / 2;
                    newShrinkRect.shrink(legendBBox.width, this.position);
            }
            this.group.translationX = Math.floor(-legendBBox.x + shrinkRect.x + translationX);
            this.group.translationY = Math.floor(-legendBBox.y + shrinkRect.y + translationY);
        }
        if (this.visible && this.enabled && this.data.length) {
            const legendPadding = this.spacing;
            newShrinkRect.shrink(legendPadding, this.position);
            const legendPositionedBBox = legendBBox.clone();
            legendPositionedBBox.x += this.group.translationX;
            legendPositionedBBox.y += this.group.translationY;
        }
        return {
            shrinkRect: newShrinkRect
        };
    }
    calculateLegendDimensions(shrinkRect) {
        const { width: width, height: height } = shrinkRect;
        const aspectRatio = width / height;
        const maxCoefficient = 0.5;
        const minHeightCoefficient = 0.2;
        const minWidthCoefficient = 0.25;
        let legendWidth, legendHeight;
        switch(this.position){
            case "top":
            case "bottom":
                const heightCoefficient = aspectRatio < 1 ? Math.min(maxCoefficient, minHeightCoefficient * (1 / aspectRatio)) : minHeightCoefficient;
                legendWidth = this.maxWidth ? Math.min(this.maxWidth, width) : width;
                legendHeight = this.maxHeight ? Math.min(this.maxHeight, height) : Math.round(height * heightCoefficient);
                break;
            case "left":
            case "right":
            default:
                const widthCoefficient = aspectRatio > 1 ? Math.min(maxCoefficient, minWidthCoefficient * aspectRatio) : minWidthCoefficient;
                legendWidth = this.maxWidth ? Math.min(this.maxWidth, width) : Math.round(width * widthCoefficient);
                legendHeight = this.maxHeight ? Math.min(this.maxHeight, height) : height;
        }
        return [
            legendWidth,
            legendHeight
        ];
    }
};
$d77b025aa58d633c$var$Legend.className = "Legend";
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$Legend.prototype, "pagination", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$Legend.prototype, "item", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$Legend.prototype, "listeners", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ObserveChanges((target)=>target.updateGroupVisibility()),
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN)
], $d77b025aa58d633c$var$Legend.prototype, "enabled", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITION2)
], $d77b025aa58d633c$var$Legend.prototype, "position", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER, {
        optional: true
    })
], $d77b025aa58d633c$var$Legend.prototype, "maxWidth", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER, {
        optional: true
    })
], $d77b025aa58d633c$var$Legend.prototype, "maxHeight", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN, {
        optional: true
    })
], $d77b025aa58d633c$var$Legend.prototype, "reverseOrder", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$UNION([
        "horizontal",
        "vertical"
    ], "an orientation"), {
        optional: true
    })
], $d77b025aa58d633c$var$Legend.prototype, "orientation", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN, {
        optional: true
    })
], $d77b025aa58d633c$var$Legend.prototype, "preventHidingAll", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$Legend.prototype, "spacing", 2);
// packages/ag-charts-community/src/chart/legendModule.ts
var $d77b025aa58d633c$var$CommunityLegendModule = {
    type: "legend",
    optionsKey: "legend",
    identifier: "category",
    chartTypes: [
        "cartesian",
        "polar",
        "hierarchy",
        "topology"
    ],
    instanceConstructor: $d77b025aa58d633c$var$Legend,
    packageType: "community"
};
// packages/ag-charts-community/src/chart/navigator/shapes/rangeHandle.ts
var $d77b025aa58d633c$var$RangeHandle = class extends $d77b025aa58d633c$var$Path {
    constructor(){
        super(...arguments);
        this.zIndex = 3;
        this._fill = "#f2f2f2";
        this._stroke = "#999999";
        this._strokeWidth = 1;
        this._lineCap = "square";
        this._centerX = 0;
        this._centerY = 0;
        this._width = 8;
        this._gripLineGap = 2;
        this._gripLineLength = 8;
        this._height = 16;
    }
    set centerX(value) {
        if (this._centerX !== value) {
            this._centerX = value;
            this.dirtyPath = true;
        }
    }
    get centerX() {
        return this._centerX;
    }
    set centerY(value) {
        if (this._centerY !== value) {
            this._centerY = value;
            this.dirtyPath = true;
        }
    }
    get centerY() {
        return this._centerY;
    }
    set width(value) {
        if (this._width !== value) {
            this._width = value;
            this.dirtyPath = true;
        }
    }
    get width() {
        return this._width;
    }
    set gripLineGap(value) {
        if (this._gripLineGap !== value) {
            this._gripLineGap = value;
            this.dirtyPath = true;
        }
    }
    get gripLineGap() {
        return this._gripLineGap;
    }
    set gripLineLength(value) {
        if (this._gripLineLength !== value) {
            this._gripLineLength = value;
            this.dirtyPath = true;
        }
    }
    get gripLineLength() {
        return this._gripLineLength;
    }
    set height(value) {
        if (this._height !== value) {
            this._height = value;
            this.dirtyPath = true;
        }
    }
    get height() {
        return this._height;
    }
    layout(x, y) {
        this.centerX = x;
        this.centerY = y;
    }
    static align(minHandle, maxHandle, x, y, width, height, min, max) {
        const handlePixelAlign = minHandle.strokeWidth / 2;
        const minHandleX = minHandle.align(x + width * min) + handlePixelAlign;
        const maxHandleX = minHandleX + minHandle.align(x + width * min, width * (max - min)) - 2 * handlePixelAlign;
        const handleY = minHandle.align(y + height / 2) + handlePixelAlign;
        minHandle.layout(minHandleX, handleY);
        maxHandle.layout(maxHandleX, handleY);
    }
    computeBBox() {
        const { centerX: centerX, centerY: centerY, width: width, height: height } = this;
        const x = centerX - width / 2;
        const y = centerY - height / 2;
        return new $d77b025aa58d633c$var$BBox(x, y, width, height);
    }
    isPointInPath(x, y) {
        const point = this.transformPoint(x, y);
        const bbox = this.computeBBox();
        return bbox.containsPoint(point.x, point.y);
    }
    updatePath() {
        var _a, _b, _c;
        const { centerX: centerX, centerY: centerY, path: path, strokeWidth: strokeWidth, gripLineGap: gripLineGap, gripLineLength: gripLineLength } = this;
        const pixelRatio = (_c = (_b = (_a = this.layerManager) == null ? void 0 : _a.canvas) == null ? void 0 : _b.pixelRatio) != null ? _c : 1;
        path.clear();
        const halfWidth = Math.floor(this.width / 2 * pixelRatio) / pixelRatio;
        const halfHeight = Math.floor(this.height / 2 * pixelRatio) / pixelRatio;
        path.moveTo(centerX - halfWidth, centerY - halfHeight);
        path.lineTo(centerX + halfWidth, centerY - halfHeight);
        path.lineTo(centerX + halfWidth, centerY + halfHeight);
        path.lineTo(centerX - halfWidth, centerY + halfHeight);
        path.closePath();
        const dx = Math.floor((gripLineGap + strokeWidth) / 2 * pixelRatio) / pixelRatio;
        const dy = Math.floor(gripLineLength / 2 * pixelRatio) / pixelRatio;
        path.moveTo(centerX - dx, centerY - dy);
        path.lineTo(centerX - dx, centerY + dy);
        path.moveTo(centerX + dx, centerY - dy);
        path.lineTo(centerX + dx, centerY + dy);
    }
};
$d77b025aa58d633c$var$RangeHandle.className = "RangeHandle";
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$COLOR_STRING)
], $d77b025aa58d633c$var$RangeHandle.prototype, "_fill", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$COLOR_STRING)
], $d77b025aa58d633c$var$RangeHandle.prototype, "_stroke", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$RangeHandle.prototype, "_strokeWidth", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$LINE_CAP)
], $d77b025aa58d633c$var$RangeHandle.prototype, "_lineCap", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$RangeHandle.prototype, "_width", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$RangeHandle.prototype, "_gripLineGap", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$RangeHandle.prototype, "_gripLineLength", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$RangeHandle.prototype, "_height", 2);
// packages/ag-charts-community/src/chart/navigator/shapes/rangeMask.ts
var $d77b025aa58d633c$var$RangeMask = class extends $d77b025aa58d633c$var$Path {
    constructor(){
        super(...arguments);
        this.zIndex = 2;
        this.x = 0;
        this.y = 0;
        this.width = 200;
        this.height = 30;
        this.min = 0;
        this.max = 1;
    }
    layout(x, y, width, height) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.dirtyPath = true;
    }
    update(min, max) {
        this.min = isNaN(min) ? this.min : min;
        this.max = isNaN(max) ? this.max : max;
        this.dirtyPath = true;
    }
    computeBBox() {
        const { x: x, y: y, width: width, height: height } = this;
        return new $d77b025aa58d633c$var$BBox(x, y, width, height);
    }
    computeVisibleRangeBBox() {
        const { x: x, y: y, width: width, height: height, min: min, max: max } = this;
        const minX = x + width * min;
        const maxX = x + width * max;
        return new $d77b025aa58d633c$var$BBox(minX, y, maxX - minX, height);
    }
    updatePath() {
        const { path: path, x: x, y: y, width: width, height: height, min: min, max: max, strokeWidth: strokeWidth } = this;
        const pixelAlign = strokeWidth / 2;
        path.clear();
        const ax = this.align(x) + pixelAlign;
        const ay = this.align(y) + pixelAlign;
        const axw = ax + this.align(x, width) - 2 * pixelAlign;
        const ayh = ay + this.align(y, height) - 2 * pixelAlign;
        path.moveTo(ax, ay);
        path.lineTo(axw, ay);
        path.lineTo(axw, ayh);
        path.lineTo(ax, ayh);
        path.closePath();
        const minX = this.align(x + width * min) + pixelAlign;
        const maxX = minX + this.align(x + width * min, width * (max - min)) - 2 * pixelAlign;
        path.moveTo(minX, ay);
        path.lineTo(minX, ayh);
        path.lineTo(maxX, ayh);
        path.lineTo(maxX, ay);
        path.closePath();
    }
};
$d77b025aa58d633c$var$RangeMask.className = "RangeMask";
// packages/ag-charts-community/src/chart/navigator/shapes/rangeSelector.ts
var $d77b025aa58d633c$var$RangeSelector = class extends $d77b025aa58d633c$var$Group {
    constructor(children){
        super({
            name: "rangeSelectorGroup",
            layer: true,
            zIndex: 12 /* NAVIGATOR_ZINDEX */ 
        });
        this.x = 0;
        this.y = 0;
        this.width = 200;
        this.height = 30;
        this.lOffset = 0;
        this.rOffset = 0;
        this.isContainerNode = true;
        this.background = new $d77b025aa58d633c$var$Group({
            name: "navigator-background"
        });
        this.background.zIndex = 1;
        this.appendChild(this.background);
        this.append(children);
    }
    layout(x, y, width, height, lOffset, rOffset) {
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
        this.lOffset = lOffset;
        this.rOffset = rOffset;
        this.background.translationX = x;
        this.background.translationY = y;
    }
    updateBackground(oldGroup, newGroup) {
        if (oldGroup != null) this.background.removeChild(oldGroup);
        if (newGroup != null) this.background.appendChild(newGroup);
    }
    computeBBox() {
        const { x: x, y: y, width: width, height: height, lOffset: lOffset, rOffset: rOffset } = this;
        return new $d77b025aa58d633c$var$BBox(x - lOffset, y, width + (lOffset + rOffset), height);
    }
};
// packages/ag-charts-community/src/chart/navigator/navigator.ts
var $d77b025aa58d633c$var$Navigator = class extends $d77b025aa58d633c$var$BaseModuleInstance {
    constructor(ctx){
        super();
        this.ctx = ctx;
        this.miniChart = void 0;
        this.enabled = false;
        this.mask = new $d77b025aa58d633c$var$RangeMask();
        this.minHandle = new $d77b025aa58d633c$var$RangeHandle();
        this.maxHandle = new $d77b025aa58d633c$var$RangeHandle();
        this.height = 30;
        this.margin = 10;
        this.x = 0;
        this.y = 0;
        this.width = 0;
        this.rangeSelector = new $d77b025aa58d633c$var$RangeSelector([
            this.mask,
            this.minHandle,
            this.maxHandle
        ]);
        this._min = 0;
        this._max = 1;
        this.minRange = 1e-3;
        const region = ctx.regionManager.addRegion("navigator", this.rangeSelector);
        const dragStates = 25 /* ZoomDrag */ ;
        this.destroyFns.push(ctx.scene.attachNode(this.rangeSelector), region.addListener("hover", (event)=>this.onHover(event), dragStates), region.addListener("drag-start", (event)=>this.onDragStart(event), dragStates), region.addListener("drag", (event)=>this.onDrag(event), dragStates), region.addListener("drag-end", ()=>this.onDragEnd(), dragStates), region.addListener("leave", (event)=>this.onLeave(event), dragStates), ctx.zoomManager.addListener("zoom-change", (event)=>this.onZoomChange(event)));
        this.updateGroupVisibility();
    }
    updateBackground(oldGroup, newGroup) {
        var _a;
        (_a = this.rangeSelector) == null || _a.updateBackground(oldGroup, newGroup);
    }
    updateGroupVisibility() {
        const { enabled: enabled } = this;
        if (this.rangeSelector == null || enabled === this.rangeSelector.visible) return;
        this.rangeSelector.visible = enabled;
        if (enabled) this.updateZoom();
        else this.ctx.zoomManager.updateZoom("navigator");
    }
    performLayout(_0) {
        return $d77b025aa58d633c$var$__async(this, arguments, function*({ shrinkRect: shrinkRect }) {
            if (this.enabled) {
                const navigatorTotalHeight = this.height + this.margin;
                shrinkRect.shrink(navigatorTotalHeight, "bottom");
                this.y = shrinkRect.y + shrinkRect.height + this.margin;
            } else this.y = 0;
            return {
                shrinkRect: shrinkRect
            };
        });
    }
    performCartesianLayout(opts) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            const { x: x, width: width } = opts.seriesRect;
            if (this.enabled) {
                const { y: y, height: height } = this;
                this.layoutNodes(x, y, width, height);
            }
            this.x = x;
            this.width = width;
        });
    }
    onHover(event) {
        if (!this.enabled) return;
        const { mask: mask, minHandle: minHandle, maxHandle: maxHandle } = this;
        const { offsetX: offsetX, offsetY: offsetY } = event;
        if (minHandle.containsPoint(offsetX, offsetY) || maxHandle.containsPoint(offsetX, offsetY)) this.ctx.cursorManager.updateCursor("navigator", "ew-resize");
        else if (mask.computeVisibleRangeBBox().containsPoint(offsetX, offsetY)) this.ctx.cursorManager.updateCursor("navigator", "grab");
        else this.ctx.cursorManager.updateCursor("navigator");
    }
    onDragStart(event) {
        if (!this.enabled) return;
        const { mask: mask, minHandle: minHandle, maxHandle: maxHandle, x: x, width: width, _min: min } = this;
        const { offsetX: offsetX, offsetY: offsetY } = event;
        if (minHandle.zIndex < maxHandle.zIndex) {
            if (maxHandle.containsPoint(offsetX, offsetY)) this.dragging = "max";
            else if (minHandle.containsPoint(offsetX, offsetY)) this.dragging = "min";
        } else if (minHandle.containsPoint(offsetX, offsetY)) this.dragging = "min";
        else if (maxHandle.containsPoint(offsetX, offsetY)) this.dragging = "max";
        if (this.dragging == null && mask.computeVisibleRangeBBox().containsPoint(offsetX, offsetY)) {
            this.dragging = "pan";
            this.panStart = (offsetX - x) / width - min;
        }
        if (this.dragging != null) this.ctx.zoomManager.fireZoomPanStartEvent("navigator");
    }
    onDrag(event) {
        if (!this.enabled || this.dragging == null) return;
        const { dragging: dragging, minRange: minRange, panStart: panStart, x: x, width: width } = this;
        let { _min: min, _max: max } = this;
        const { offsetX: offsetX } = event;
        const ratio = (offsetX - x) / width;
        if (dragging === "min") min = $d77b025aa58d633c$var$clamp(0, ratio, max - minRange);
        else if (dragging === "max") max = $d77b025aa58d633c$var$clamp(min + minRange, ratio, 1);
        else if (dragging === "pan" && panStart != null) {
            const span = max - min;
            min = $d77b025aa58d633c$var$clamp(0, ratio - panStart, 1 - span);
            max = min + span;
        }
        this._min = min;
        this._max = max;
        this.updateZoom();
    }
    onDragEnd() {
        this.dragging = void 0;
    }
    onLeave(_event) {
        this.ctx.cursorManager.updateCursor("navigator");
    }
    onZoomChange(event) {
        const { x: x } = event;
        if (!x) return;
        this._min = x.min;
        this._max = x.max;
        this.updateNodes(x.min, x.max);
    }
    layoutNodes(x, y, width, height) {
        const { rangeSelector: rangeSelector, mask: mask, minHandle: minHandle, maxHandle: maxHandle, _min: min, _max: max } = this;
        rangeSelector.layout(x, y, width, height, minHandle.width / 2, maxHandle.width / 2);
        mask.layout(x, y, width, height);
        $d77b025aa58d633c$var$RangeHandle.align(minHandle, maxHandle, x, y, width, height, min, max);
        if (min + (max - min) / 2 < 0.5) {
            minHandle.zIndex = 3;
            maxHandle.zIndex = 4;
        } else {
            minHandle.zIndex = 4;
            maxHandle.zIndex = 3;
        }
    }
    updateNodes(min, max) {
        this.mask.update(min, max);
    }
    updateZoom() {
        if (!this.enabled) return;
        const { _min: min, _max: max } = this;
        const zoom2 = this.ctx.zoomManager.getZoom();
        if (min == null || max == null) return;
        const warnOnConflict = (stateId)=>{
            if (this.min == null && this.max == null) return;
            $d77b025aa58d633c$var$Logger.warnOnce(`Could not apply [navigator.min] or [navigator.max] as [${stateId}] has modified the initial zoom state.`);
        };
        return this.ctx.zoomManager.updateZoom("navigator", {
            x: {
                min: min,
                max: max
            },
            y: zoom2 == null ? void 0 : zoom2.y
        }, false, warnOnConflict);
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT, {
        optional: true
    })
], $d77b025aa58d633c$var$Navigator.prototype, "miniChart", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN),
    $d77b025aa58d633c$var$ObserveChanges((target)=>target.updateGroupVisibility())
], $d77b025aa58d633c$var$Navigator.prototype, "enabled", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$Navigator.prototype, "height", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$Navigator.prototype, "margin", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ActionOnSet({
        newValue (min) {
            this._min = min;
            this.updateZoom();
        }
    }),
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$AND($d77b025aa58d633c$var$RATIO, $d77b025aa58d633c$var$LESS_THAN("max")), {
        optional: true
    })
], $d77b025aa58d633c$var$Navigator.prototype, "min", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ActionOnSet({
        newValue (max) {
            this._max = max;
            this.updateZoom();
        }
    }),
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$AND($d77b025aa58d633c$var$RATIO, $d77b025aa58d633c$var$GREATER_THAN("min")), {
        optional: true
    })
], $d77b025aa58d633c$var$Navigator.prototype, "max", 2);
// packages/ag-charts-community/src/chart/navigator/navigatorModule.ts
var $d77b025aa58d633c$var$NavigatorModule = {
    type: "root",
    optionsKey: "navigator",
    packageType: "community",
    chartTypes: [
        "cartesian"
    ],
    instanceConstructor: $d77b025aa58d633c$var$Navigator,
    themeTemplate: {
        navigator: {
            enabled: false,
            height: 30,
            mask: {
                fill: "#999999",
                stroke: "#999999",
                strokeWidth: 1,
                fillOpacity: 0.2
            },
            minHandle: {
                fill: "#f2f2f2",
                stroke: "#999999",
                strokeWidth: 1,
                width: 9,
                height: 16,
                gripLineGap: 1,
                gripLineLength: 8
            },
            maxHandle: {
                fill: "#f2f2f2",
                stroke: "#999999",
                strokeWidth: 1,
                width: 9,
                height: 16,
                gripLineGap: 1,
                gripLineLength: 8
            }
        }
    }
};
// packages/ag-charts-community/src/module/theme.ts
var $d77b025aa58d633c$var$singleSeriesPaletteFactory = ({ takeColors: takeColors })=>{
    const { fills: [fill], strokes: [stroke] } = takeColors(1);
    return {
        fill: fill,
        stroke: stroke
    };
};
var $d77b025aa58d633c$var$markerPaletteFactory = (params)=>{
    const { fill: fill, stroke: stroke } = $d77b025aa58d633c$var$singleSeriesPaletteFactory(params);
    return {
        marker: {
            fill: fill,
            stroke: stroke
        }
    };
};
// packages/ag-charts-community/src/motion/pathMotion.ts
function $d77b025aa58d633c$var$pathMotion(groupId, subId, animationManager, paths, fns) {
    const { addPhaseFn: addPhaseFn, updatePhaseFn: updatePhaseFn, removePhaseFn: removePhaseFn } = fns;
    const animate = (phase, path, updateFn)=>{
        animationManager.animate({
            id: `${groupId}_${subId}_${path.id}_${phase}`,
            groupId: groupId,
            from: 0,
            to: 1,
            ease: $d77b025aa58d633c$var$easeOut,
            collapsable: false,
            onUpdate (ratio, preInit) {
                if (preInit && phase !== "removed") return;
                path.path.clear(true);
                updateFn(ratio, path);
                path.checkPathDirty();
            },
            onStop () {
                if (phase !== "added") return;
                path.path.clear(true);
                updateFn(1, path);
                path.checkPathDirty();
            },
            phase: $d77b025aa58d633c$var$NODE_UPDATE_STATE_TO_PHASE_MAPPING[phase]
        });
    };
    for (const path of paths){
        if (!animationManager.isSkipped()) {
            animate("removed", path, removePhaseFn);
            animate("updated", path, updatePhaseFn);
        }
        animate("added", path, addPhaseFn);
    }
}
// packages/ag-charts-community/src/util/sanitize.ts
var $d77b025aa58d633c$var$element = null;
function $d77b025aa58d633c$var$sanitizeHtml(text) {
    if (text == null) return;
    else if (text === "") return "";
    $d77b025aa58d633c$var$element != null ? $d77b025aa58d633c$var$element : $d77b025aa58d633c$var$element = $d77b025aa58d633c$var$createElement("div");
    $d77b025aa58d633c$var$element.textContent = String(text);
    return $d77b025aa58d633c$var$element.innerHTML;
}
// packages/ag-charts-community/src/chart/series/seriesLabelUtil.ts
function $d77b025aa58d633c$var$seriesLabelFadeInAnimation({ id: id }, subId, animationManager, ...labelSelections) {
    $d77b025aa58d633c$var$staticFromToMotion(id, subId, animationManager, labelSelections, {
        opacity: 0
    }, {
        opacity: 1
    }, {
        phase: "trailing"
    });
}
function $d77b025aa58d633c$var$seriesLabelFadeOutAnimation({ id: id }, subId, animationManager, ...labelSelections) {
    $d77b025aa58d633c$var$staticFromToMotion(id, subId, animationManager, labelSelections, {
        opacity: 1
    }, {
        opacity: 0
    }, {
        phase: "remove"
    });
}
function $d77b025aa58d633c$var$resetLabelFn(_node) {
    return {
        opacity: 1
    };
}
// packages/ag-charts-community/src/scene/util/changeDetectableProperties.ts
var $d77b025aa58d633c$var$ChangeDetectableProperties = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this._dirty = 3 /* MAJOR */ ;
    }
    markDirty(_source, type = 1 /* TRIVIAL */ ) {
        if (this._dirty < type) this._dirty = type;
    }
    markClean(_opts) {
        this._dirty = 0 /* NONE */ ;
    }
    isDirty() {
        return this._dirty > 0 /* NONE */ ;
    }
};
// packages/ag-charts-community/src/scene/dropShadow.ts
var $d77b025aa58d633c$var$DropShadow = class extends $d77b025aa58d633c$var$ChangeDetectableProperties {
    constructor(){
        super(...arguments);
        this.enabled = true;
        this.color = "rgba(0, 0, 0, 0.5)";
        this.xOffset = 0;
        this.yOffset = 0;
        this.blur = 5;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN),
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 3 /* MAJOR */ 
    })
], $d77b025aa58d633c$var$DropShadow.prototype, "enabled", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$COLOR_STRING),
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 3 /* MAJOR */ 
    })
], $d77b025aa58d633c$var$DropShadow.prototype, "color", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$NUMBER),
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 3 /* MAJOR */ 
    })
], $d77b025aa58d633c$var$DropShadow.prototype, "xOffset", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$NUMBER),
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 3 /* MAJOR */ 
    })
], $d77b025aa58d633c$var$DropShadow.prototype, "yOffset", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER),
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 3 /* MAJOR */ 
    })
], $d77b025aa58d633c$var$DropShadow.prototype, "blur", 2);
// packages/ag-charts-community/src/chart/series/seriesMarker.ts
var $d77b025aa58d633c$var$MARKER_SHAPE = $d77b025aa58d633c$var$predicateWithMessage((value)=>$d77b025aa58d633c$var$isMarkerShape(value) || typeof $d77b025aa58d633c$export$e98856a975cab58e === "function" && Object.create(value.prototype) instanceof $d77b025aa58d633c$export$e98856a975cab58e, `a marker shape keyword such as 'circle', 'diamond' or 'square' or an object extending the Marker class`);
var $d77b025aa58d633c$var$SeriesMarker = class extends $d77b025aa58d633c$var$ChangeDetectableProperties {
    constructor(){
        super(...arguments);
        this.enabled = true;
        this.shape = $d77b025aa58d633c$var$Circle;
        this.size = 6;
        this.fillOpacity = 1;
        this.strokeWidth = 1;
        this.strokeOpacity = 1;
    }
    getStyle() {
        const { size: size, fill: fill, fillOpacity: fillOpacity, stroke: stroke, strokeWidth: strokeWidth, strokeOpacity: strokeOpacity } = this;
        return {
            size: size,
            fill: fill,
            fillOpacity: fillOpacity,
            stroke: stroke,
            strokeWidth: strokeWidth,
            strokeOpacity: strokeOpacity
        };
    }
    getDiameter() {
        return this.size + this.strokeWidth;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN),
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 3 /* MAJOR */ 
    })
], $d77b025aa58d633c$var$SeriesMarker.prototype, "enabled", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$MARKER_SHAPE),
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 3 /* MAJOR */ 
    })
], $d77b025aa58d633c$var$SeriesMarker.prototype, "shape", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER),
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 3 /* MAJOR */ 
    })
], $d77b025aa58d633c$var$SeriesMarker.prototype, "size", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$COLOR_STRING, {
        optional: true
    }),
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 3 /* MAJOR */ 
    })
], $d77b025aa58d633c$var$SeriesMarker.prototype, "fill", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$RATIO),
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 3 /* MAJOR */ 
    })
], $d77b025aa58d633c$var$SeriesMarker.prototype, "fillOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$COLOR_STRING, {
        optional: true
    }),
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 3 /* MAJOR */ 
    })
], $d77b025aa58d633c$var$SeriesMarker.prototype, "stroke", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER),
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 3 /* MAJOR */ 
    })
], $d77b025aa58d633c$var$SeriesMarker.prototype, "strokeWidth", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$RATIO),
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 3 /* MAJOR */ 
    })
], $d77b025aa58d633c$var$SeriesMarker.prototype, "strokeOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$FUNCTION, {
        optional: true
    }),
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 3 /* MAJOR */ 
    })
], $d77b025aa58d633c$var$SeriesMarker.prototype, "formatter", 2);
// packages/ag-charts-community/src/chart/series/seriesTooltip.ts
var $d77b025aa58d633c$var$SeriesTooltipInteraction = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.enabled = false;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN)
], $d77b025aa58d633c$var$SeriesTooltipInteraction.prototype, "enabled", 2);
var $d77b025aa58d633c$var$SeriesTooltip = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.enabled = true;
        this.interaction = new $d77b025aa58d633c$var$SeriesTooltipInteraction();
        this.position = new $d77b025aa58d633c$var$TooltipPosition();
    }
    toTooltipHtml(defaults, params) {
        if (this.renderer) return $d77b025aa58d633c$var$toTooltipHtml(this.renderer(params), defaults);
        return $d77b025aa58d633c$var$toTooltipHtml(defaults);
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN)
], $d77b025aa58d633c$var$SeriesTooltip.prototype, "enabled", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN, {
        optional: true
    })
], $d77b025aa58d633c$var$SeriesTooltip.prototype, "showArrow", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$FUNCTION, {
        optional: true
    })
], $d77b025aa58d633c$var$SeriesTooltip.prototype, "renderer", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$SeriesTooltip.prototype, "interaction", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$SeriesTooltip.prototype, "position", 2);
// packages/ag-charts-community/src/chart/series/cartesian/areaSeriesProperties.ts
var $d77b025aa58d633c$var$AreaSeriesProperties = class extends $d77b025aa58d633c$var$CartesianSeriesProperties {
    constructor(){
        super(...arguments);
        this.xName = void 0;
        this.fill = "#c16068";
        this.fillOpacity = 1;
        this.stroke = "#874349";
        this.strokeWidth = 2;
        this.strokeOpacity = 1;
        this.lineDash = [
            0
        ];
        this.lineDashOffset = 0;
        this.shadow = new $d77b025aa58d633c$var$DropShadow();
        this.marker = new $d77b025aa58d633c$var$SeriesMarker();
        this.label = new $d77b025aa58d633c$var$Label();
        this.tooltip = new $d77b025aa58d633c$var$SeriesTooltip();
        this.connectMissingData = false;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING)
], $d77b025aa58d633c$var$AreaSeriesProperties.prototype, "xKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$AreaSeriesProperties.prototype, "xName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING)
], $d77b025aa58d633c$var$AreaSeriesProperties.prototype, "yKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$AreaSeriesProperties.prototype, "yName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER, {
        optional: true
    })
], $d77b025aa58d633c$var$AreaSeriesProperties.prototype, "normalizedTo", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$COLOR_STRING)
], $d77b025aa58d633c$var$AreaSeriesProperties.prototype, "fill", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$RATIO)
], $d77b025aa58d633c$var$AreaSeriesProperties.prototype, "fillOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$COLOR_STRING)
], $d77b025aa58d633c$var$AreaSeriesProperties.prototype, "stroke", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$AreaSeriesProperties.prototype, "strokeWidth", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$RATIO)
], $d77b025aa58d633c$var$AreaSeriesProperties.prototype, "strokeOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$LINE_DASH)
], $d77b025aa58d633c$var$AreaSeriesProperties.prototype, "lineDash", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$AreaSeriesProperties.prototype, "lineDashOffset", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$AreaSeriesProperties.prototype, "shadow", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$AreaSeriesProperties.prototype, "marker", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$AreaSeriesProperties.prototype, "label", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$AreaSeriesProperties.prototype, "tooltip", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN)
], $d77b025aa58d633c$var$AreaSeriesProperties.prototype, "connectMissingData", 2);
// packages/ag-charts-community/src/chart/series/cartesian/markerUtil.ts
function $d77b025aa58d633c$var$markerFadeInAnimation({ id: id }, animationManager, status, ...markerSelections) {
    const params = {
        phase: status ? $d77b025aa58d633c$var$NODE_UPDATE_STATE_TO_PHASE_MAPPING[status] : "trailing"
    };
    $d77b025aa58d633c$var$staticFromToMotion(id, "markers", animationManager, markerSelections, {
        opacity: 0
    }, {
        opacity: 1
    }, params);
    markerSelections.forEach((s)=>s.cleanup());
}
function $d77b025aa58d633c$var$markerScaleInAnimation({ id: id }, animationManager, ...markerSelections) {
    $d77b025aa58d633c$var$staticFromToMotion(id, "markers", animationManager, markerSelections, {
        scalingX: 0,
        scalingY: 0
    }, {
        scalingX: 1,
        scalingY: 1
    }, {
        phase: "initial"
    });
    markerSelections.forEach((s)=>s.cleanup());
}
function $d77b025aa58d633c$var$markerSwipeScaleInAnimation({ id: id, nodeDataDependencies: nodeDataDependencies }, animationManager, ...markerSelections) {
    const seriesWidth = nodeDataDependencies.seriesRectWidth;
    const fromFn = (_, datum)=>{
        var _a, _b;
        const x = (_b = (_a = datum.midPoint) == null ? void 0 : _a.x) != null ? _b : seriesWidth;
        let delay = $d77b025aa58d633c$var$clamp(0, $d77b025aa58d633c$var$inverseEaseOut(x / seriesWidth), 1);
        if (isNaN(delay)) delay = 0;
        return {
            scalingX: 0,
            scalingY: 0,
            delay: delay,
            duration: $d77b025aa58d633c$var$QUICK_TRANSITION,
            phase: "initial"
        };
    };
    const toFn = ()=>{
        return {
            scalingX: 1,
            scalingY: 1
        };
    };
    $d77b025aa58d633c$var$fromToMotion(id, "markers", animationManager, markerSelections, {
        fromFn: fromFn,
        toFn: toFn
    });
}
function $d77b025aa58d633c$var$resetMarkerFn(_node) {
    return {
        opacity: 1,
        scalingX: 1,
        scalingY: 1
    };
}
function $d77b025aa58d633c$var$resetMarkerPositionFn(_node, datum) {
    var _a, _b, _c, _d;
    return {
        translationX: (_b = (_a = datum.point) == null ? void 0 : _a.x) != null ? _b : NaN,
        translationY: (_d = (_c = datum.point) == null ? void 0 : _c.y) != null ? _d : NaN
    };
}
function $d77b025aa58d633c$var$prepareMarkerAnimation(pairMap, parentStatus) {
    const readFirstPair = (xValue, type)=>{
        const val = pairMap[type][xValue];
        return Array.isArray(val) ? val[0] : val;
    };
    const markerStatus = (datum)=>{
        const { xValue: xValue } = datum;
        if (pairMap.moved[xValue]) return {
            point: readFirstPair(xValue, "moved"),
            status: "updated"
        };
        else if (pairMap.removed[xValue]) return {
            point: readFirstPair(xValue, "removed"),
            status: "removed"
        };
        else if (pairMap.added[xValue]) return {
            point: readFirstPair(xValue, "added"),
            status: "added"
        };
        return {
            status: "unknown"
        };
    };
    const fromFn = (marker, datum)=>{
        var _a, _b, _c, _d, _e, _f;
        const { status: status, point: point } = markerStatus(datum);
        if (status === "unknown") return {
            opacity: 0
        };
        const defaults = {
            translationX: (_b = (_a = point == null ? void 0 : point.from) == null ? void 0 : _a.x) != null ? _b : marker.translationX,
            translationY: (_d = (_c = point == null ? void 0 : point.from) == null ? void 0 : _c.y) != null ? _d : marker.translationY,
            opacity: marker.opacity,
            phase: $d77b025aa58d633c$var$NODE_UPDATE_STATE_TO_PHASE_MAPPING[status]
        };
        if (parentStatus === "added") return $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, defaults), {
            opacity: 0,
            translationX: (_e = point == null ? void 0 : point.to) == null ? void 0 : _e.x,
            translationY: (_f = point == null ? void 0 : point.to) == null ? void 0 : _f.y,
            phase: $d77b025aa58d633c$var$NODE_UPDATE_STATE_TO_PHASE_MAPPING["added"]
        });
        if (status === "added") defaults.opacity = 0;
        return defaults;
    };
    const toFn = (_marker, datum)=>{
        var _a, _b;
        const { status: status, point: point } = markerStatus(datum);
        if (status === "unknown") return {
            opacity: 0
        };
        const defaults = {
            translationX: datum.point.x,
            translationY: datum.point.y,
            opacity: 1,
            phase: $d77b025aa58d633c$var$NODE_UPDATE_STATE_TO_PHASE_MAPPING[status]
        };
        if (status === "removed" || parentStatus === "removed") return $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, defaults), {
            translationX: (_a = point == null ? void 0 : point.to) == null ? void 0 : _a.x,
            translationY: (_b = point == null ? void 0 : point.to) == null ? void 0 : _b.y,
            opacity: 0,
            phase: $d77b025aa58d633c$var$NODE_UPDATE_STATE_TO_PHASE_MAPPING["removed"]
        });
        return defaults;
    };
    return {
        fromFn: fromFn,
        toFn: toFn
    };
}
function $d77b025aa58d633c$var$computeMarkerFocusBounds(series, { datumIndex: datumIndex }) {
    const nodeData = series.getNodeData();
    if (nodeData === void 0) return void 0;
    const datum = nodeData[datumIndex];
    if (datum === void 0 || datum.point === void 0) return void 0;
    const size = series.getFormattedMarkerStyle(datum).size;
    const radius = size / 2;
    const { x: x, y: y } = series.contentGroup.inverseTransformPoint(datum.point.x - radius, datum.point.y - radius);
    return new $d77b025aa58d633c$var$BBox(x, y, size, size);
}
// packages/ag-charts-community/src/chart/series/cartesian/pathUtil.ts
function $d77b025aa58d633c$var$minMax(nodeData) {
    return nodeData.reduce(({ min: min, max: max }, node)=>{
        if (min == null || min.point.x > node.point.x) min = node;
        if (max == null || max.point.x < node.point.x) max = node;
        return {
            min: min,
            max: max
        };
    }, {});
}
function $d77b025aa58d633c$var$intersectionOnLine(a, b, targetX) {
    const m = (b.y - a.y) / (b.x - a.x);
    const y = (targetX - a.x) * m + a.y;
    return {
        x: targetX,
        y: y
    };
}
function $d77b025aa58d633c$var$backfillPathPoint(results, process, skip, processFn) {
    let prevMarkerIdx = -1, nextMarkerIdx = 0;
    const toProcess = [];
    while(nextMarkerIdx < results.length){
        if (results[nextMarkerIdx].change === process) {
            toProcess.push(results[nextMarkerIdx]);
            nextMarkerIdx++;
            continue;
        }
        if (results[nextMarkerIdx].change === skip) {
            nextMarkerIdx++;
            continue;
        }
        if (toProcess.length > 0) {
            processFn(toProcess, prevMarkerIdx, nextMarkerIdx);
            toProcess.length = 0;
        }
        prevMarkerIdx = nextMarkerIdx;
        nextMarkerIdx++;
    }
    if (toProcess.length > 0) processFn(toProcess, prevMarkerIdx, nextMarkerIdx);
}
function $d77b025aa58d633c$var$backfillPathPointData(result, splitMode) {
    $d77b025aa58d633c$var$backfillPathPoint(result, "out", "in", (toProcess, sIdx, eIdx)=>{
        var _a, _b;
        if (sIdx === -1 && result[eIdx]) toProcess.forEach((d)=>d.to = result[eIdx].from);
        else if (eIdx === result.length && result[sIdx]) toProcess.forEach((d)=>d.to = result[sIdx].from);
        else if (splitMode === "intersect" && ((_a = result[sIdx]) == null ? void 0 : _a.from) && ((_b = result[eIdx]) == null ? void 0 : _b.from)) toProcess.forEach((d)=>d.to = $d77b025aa58d633c$var$intersectionOnLine(result[sIdx].from, result[eIdx].from, d.from.x));
        else toProcess.forEach((d)=>d.to = d.from);
    });
    $d77b025aa58d633c$var$backfillPathPoint(result, "in", "out", (toProcess, sIdx, eIdx)=>{
        var _a, _b;
        if (sIdx === -1 && result[eIdx]) toProcess.forEach((d)=>d.from = result[eIdx].to);
        else if (eIdx === result.length && result[sIdx]) toProcess.forEach((d)=>d.from = result[sIdx].to);
        else if (splitMode === "intersect" && ((_a = result[sIdx]) == null ? void 0 : _a.to) && ((_b = result[eIdx]) == null ? void 0 : _b.to)) toProcess.forEach((d)=>d.from = $d77b025aa58d633c$var$intersectionOnLine(result[sIdx].to, result[eIdx].to, d.to.x));
        else toProcess.forEach((d)=>d.from = d.to);
    });
}
function $d77b025aa58d633c$var$calculatePoint(from, to, ratio) {
    const x1 = isNaN(from.x) ? to.x : from.x;
    const y1 = isNaN(from.y) ? to.y : from.y;
    const xd = to.x - from.x;
    const yd = to.y - from.y;
    const xr = isNaN(xd) ? 0 : xd * ratio;
    const yr = isNaN(yd) ? 0 : yd * ratio;
    return {
        x: x1 + xr,
        y: y1 + yr
    };
}
function $d77b025aa58d633c$var$renderPartialPath(pairData, ratios, path) {
    const { path: linePath } = path;
    let previousTo;
    for (const data of pairData){
        const { from: from, to: to } = data;
        const ratio = ratios[data.change];
        if (ratio == null || from == null || to == null) continue;
        const { x: x, y: y } = $d77b025aa58d633c$var$calculatePoint(from, to, ratio);
        if (data.moveTo === false) linePath.lineTo(x, y);
        else if (data.moveTo === true || !previousTo) linePath.moveTo(x, y);
        else if (previousTo) {
            const moveToRatio = data.moveTo === "in" ? ratio : 1 - ratio;
            const { x: midPointX, y: midPointY } = $d77b025aa58d633c$var$calculatePoint(previousTo, {
                x: x,
                y: y
            }, moveToRatio);
            linePath.lineTo(midPointX, midPointY);
            linePath.moveTo(x, y);
        }
        previousTo = {
            x: x,
            y: y
        };
    }
}
function $d77b025aa58d633c$var$pathSwipeInAnimation({ id: id, visible: visible, nodeDataDependencies: nodeDataDependencies }, animationManager, ...paths) {
    const { seriesRectWidth: width, seriesRectHeight: height } = nodeDataDependencies;
    $d77b025aa58d633c$var$staticFromToMotion(id, "path_properties", animationManager, paths, {
        clipX: 0
    }, {
        clipX: width
    }, {
        phase: "initial",
        start: {
            clipMode: "normal",
            clipY: height,
            visible: visible
        },
        finish: {
            clipMode: void 0,
            visible: visible
        }
    });
}
function $d77b025aa58d633c$var$pathFadeInAnimation({ id: id }, subId, animationManager, phase = "add", ...selection) {
    $d77b025aa58d633c$var$staticFromToMotion(id, subId, animationManager, selection, {
        opacity: 0
    }, {
        opacity: 1
    }, {
        phase: phase
    });
}
function $d77b025aa58d633c$var$pathFadeOutAnimation({ id: id }, subId, animationManager, ...selection) {
    $d77b025aa58d633c$var$staticFromToMotion(id, subId, animationManager, selection, {
        opacity: 1
    }, {
        opacity: 0
    }, {
        phase: "remove"
    });
}
function $d77b025aa58d633c$var$buildResetPathFn(opts) {
    return (_node)=>{
        return {
            opacity: opts.getOpacity(),
            clipScalingX: 1,
            clipMode: void 0
        };
    };
}
function $d77b025aa58d633c$var$updateClipPath({ nodeDataDependencies: nodeDataDependencies }, path) {
    const toFinite = (value)=>isFinite(value) ? value : 0;
    path.clipX = toFinite(nodeDataDependencies.seriesRectWidth);
    path.clipY = toFinite(nodeDataDependencies.seriesRectHeight);
}
// packages/ag-charts-community/src/chart/series/cartesian/scaling.ts
function $d77b025aa58d633c$var$isContinuousScaling(scaling) {
    return scaling.type === "continuous" || scaling.type === "log";
}
function $d77b025aa58d633c$var$isCategoryScaling(scaling) {
    return scaling.type === "category";
}
function $d77b025aa58d633c$var$areEqual(a, b) {
    return a.domain.length === b.domain.length && a.range.length === b.range.length && a.domain.every((val, index)=>val === b.domain[index]) && a.range.every((val, index)=>val === b.range[index]);
}
function $d77b025aa58d633c$var$areScalingEqual(a, b) {
    if (a === void 0 || b === void 0) return a !== void 0 || b !== void 0;
    if ($d77b025aa58d633c$var$isContinuousScaling(a) && $d77b025aa58d633c$var$isContinuousScaling(b)) return a.type === b.type && $d77b025aa58d633c$var$areEqual(a, b);
    if ($d77b025aa58d633c$var$isCategoryScaling(a) && $d77b025aa58d633c$var$isCategoryScaling(b)) return $d77b025aa58d633c$var$areEqual(a, b);
    return false;
}
// packages/ag-charts-community/src/chart/series/cartesian/lineUtil.ts
function $d77b025aa58d633c$var$scale(val, scaling) {
    if (!scaling) return NaN;
    if (val instanceof Date) val = val.getTime();
    if (scaling.type === "continuous" && typeof val === "number") {
        const domainRatio = (val - scaling.domain[0]) / (scaling.domain[1] - scaling.domain[0]);
        return domainRatio * (scaling.range[1] - scaling.range[0]) + scaling.range[0];
    }
    if (scaling.type === "log" && typeof val === "number") return scaling.convert(val);
    const matchingIndex = scaling.domain.findIndex((d)=>d === val);
    if (matchingIndex >= 0) return scaling.range[matchingIndex];
    return NaN;
}
function $d77b025aa58d633c$var$scalesChanged(newData, oldData) {
    return !$d77b025aa58d633c$var$areScalingEqual(newData.scales.x, oldData.scales.x) || !$d77b025aa58d633c$var$areScalingEqual(newData.scales.y, oldData.scales.y);
}
function $d77b025aa58d633c$var$closeMatch(a, b) {
    const an = Number(a);
    const bn = Number(b);
    if (!isNaN(an) && !isNaN(bn)) return Math.abs(bn - an) < 0.25;
    return a === b;
}
function $d77b025aa58d633c$var$calculateMoveTo(from = false, to = false) {
    if (from === to) return Boolean(from);
    return from ? "in" : "out";
}
function $d77b025aa58d633c$var$pairContinuousData(newData, oldData, opts = {}) {
    var _a, _b, _c, _d;
    const { backfillSplitMode: backfillSplitMode = "intersect" } = opts;
    const toNewScale = (oldDatum)=>{
        var _a2, _b2;
        return {
            x: $d77b025aa58d633c$var$scale((_a2 = oldDatum.xValue) != null ? _a2 : NaN, newData.scales.x),
            y: $d77b025aa58d633c$var$scale((_b2 = oldDatum.yValue) != null ? _b2 : NaN, newData.scales.y)
        };
    };
    const toOldScale = (newDatum)=>{
        var _a2, _b2;
        return {
            x: $d77b025aa58d633c$var$scale((_a2 = newDatum.xValue) != null ? _a2 : NaN, oldData.scales.x),
            y: $d77b025aa58d633c$var$scale((_b2 = newDatum.yValue) != null ? _b2 : NaN, oldData.scales.y)
        };
    };
    const result = [];
    const resultMap = {
        added: {},
        moved: {},
        removed: {}
    };
    const pairUp = (from, to, xValue, change = "move")=>{
        if (from && (isNaN(from.point.x) || isNaN(from.point.y))) from = to;
        const resultPoint = {
            from: from == null ? void 0 : from.point,
            to: to == null ? void 0 : to.point,
            moveTo: $d77b025aa58d633c$var$calculateMoveTo(from == null ? void 0 : from.point.moveTo, to == null ? void 0 : to.point.moveTo),
            change: change
        };
        if (change === "move") {
            resultMap.moved[xValue] = resultPoint;
            oldIdx++;
            newIdx++;
        } else if (change === "in") {
            resultMap.added[xValue] = resultPoint;
            newIdx++;
        } else if (change === "out") {
            resultMap.removed[xValue] = resultPoint;
            oldIdx++;
        }
        result.push(resultPoint);
    };
    const { min: minFromNode, max: maxFromNode } = $d77b025aa58d633c$var$minMax(oldData.nodeData);
    const { min: minToNode, max: maxToNode } = $d77b025aa58d633c$var$minMax(newData.nodeData);
    let oldIdx = 0;
    let newIdx = 0;
    while(oldIdx < oldData.nodeData.length || newIdx < newData.nodeData.length){
        const from = oldData.nodeData[oldIdx];
        const to = newData.nodeData[newIdx];
        const fromShifted = from ? toNewScale(from) : void 0;
        const toUnshifted = to ? toOldScale(to) : void 0;
        const NA = void 0;
        if (fromShifted && $d77b025aa58d633c$var$closeMatch(fromShifted.x, to == null ? void 0 : to.point.x)) pairUp(from, to, to.xValue, "move");
        else if (fromShifted && fromShifted.x < ((_a = minToNode == null ? void 0 : minToNode.point.x) != null ? _a : -Infinity)) pairUp(from, NA, from.xValue, "out");
        else if (fromShifted && fromShifted.x > ((_b = maxToNode == null ? void 0 : maxToNode.point.x) != null ? _b : Infinity)) pairUp(from, NA, from.xValue, "out");
        else if (toUnshifted && toUnshifted.x < ((_c = minFromNode == null ? void 0 : minFromNode.point.x) != null ? _c : -Infinity)) pairUp(NA, to, to.xValue, "in");
        else if (toUnshifted && toUnshifted.x > ((_d = maxFromNode == null ? void 0 : maxFromNode.point.x) != null ? _d : Infinity)) pairUp(NA, to, to.xValue, "in");
        else if (fromShifted && fromShifted.x < (to == null ? void 0 : to.point.x)) pairUp(from, NA, from.xValue, "out");
        else if (toUnshifted && toUnshifted.x < (from == null ? void 0 : from.point.x)) pairUp(NA, to, to.xValue, "in");
        else if (from) pairUp(from, NA, from.xValue, "out");
        else if (to) pairUp(NA, to, to.xValue, "in");
        else throw new Error("Unable to process points");
    }
    $d77b025aa58d633c$var$backfillPathPointData(result, backfillSplitMode);
    return {
        result: result,
        resultMap: resultMap
    };
}
function $d77b025aa58d633c$var$pairCategoryData(newData, oldData, diff2, opts = {}) {
    var _a, _b, _c;
    const { backfillSplitMode: backfillSplitMode = "intersect", multiDatum: multiDatum = false } = opts;
    const result = [];
    const resultMapSingle = {
        added: {},
        moved: {},
        removed: {}
    };
    const resultMapMulti = {
        added: {},
        moved: {},
        removed: {}
    };
    const pointResultMapping = {
        in: "added",
        move: "moved",
        out: "removed"
    };
    let previousResultPoint = void 0;
    let previousXValue = void 0;
    const addToResultMap = (xValue, newPoint)=>{
        var _a2, _b2;
        const type = pointResultMapping[newPoint.change];
        if (multiDatum) {
            (_b2 = (_a2 = resultMapMulti[type])[xValue]) != null ? _b2 : _a2[xValue] = [];
            resultMapMulti[type][xValue].push(newPoint);
        } else resultMapSingle[type][xValue] = newPoint;
        previousResultPoint = newPoint;
        previousXValue = $d77b025aa58d633c$var$transformIntegratedCategoryValue(xValue);
    };
    let oldIndex = 0;
    let newIndex = 0;
    let isXUnordered = false;
    while(oldIndex < oldData.nodeData.length || newIndex < newData.nodeData.length){
        const before = oldData.nodeData[oldIndex];
        const after = newData.nodeData[newIndex];
        const bXValue = $d77b025aa58d633c$var$transformIntegratedCategoryValue(before == null ? void 0 : before.xValue);
        const aXValue = $d77b025aa58d633c$var$transformIntegratedCategoryValue(after == null ? void 0 : after.xValue);
        let resultPoint;
        if (bXValue === aXValue) {
            resultPoint = {
                change: "move",
                moveTo: $d77b025aa58d633c$var$calculateMoveTo((_a = before.point.moveTo) != null ? _a : false, after.point.moveTo),
                from: before.point,
                to: after.point
            };
            addToResultMap(before == null ? void 0 : before.xValue, resultPoint);
            oldIndex++;
            newIndex++;
        } else if (diff2 == null ? void 0 : diff2.removed.has(String(bXValue))) {
            resultPoint = {
                change: "out",
                moveTo: (_b = before.point.moveTo) != null ? _b : false,
                from: before.point
            };
            addToResultMap(before == null ? void 0 : before.xValue, resultPoint);
            oldIndex++;
        } else if (diff2 == null ? void 0 : diff2.added.has(String(aXValue))) {
            resultPoint = {
                change: "in",
                moveTo: (_c = after.point.moveTo) != null ? _c : false,
                to: after.point
            };
            addToResultMap(after == null ? void 0 : after.xValue, resultPoint);
            newIndex++;
        } else if (multiDatum && previousResultPoint && previousXValue === bXValue) {
            resultPoint = $d77b025aa58d633c$var$__spreadValues({}, previousResultPoint);
            addToResultMap(before == null ? void 0 : before.xValue, resultPoint);
            oldIndex++;
        } else if (multiDatum && previousResultPoint && previousXValue === aXValue) {
            resultPoint = $d77b025aa58d633c$var$__spreadValues({}, previousResultPoint);
            addToResultMap(after == null ? void 0 : after.xValue, resultPoint);
            newIndex++;
        } else {
            isXUnordered = true;
            break;
        }
        result.push(resultPoint);
    }
    let previousX = -Infinity;
    isXUnordered || (isXUnordered = result.some((pathPoint)=>{
        const { change: marker, to: { x: x = -Infinity } = {} } = pathPoint;
        if (marker === "out") return;
        const unordered = x < previousX;
        previousX = x;
        return unordered;
    }));
    if (isXUnordered) return {
        result: void 0,
        resultMap: void 0
    };
    $d77b025aa58d633c$var$backfillPathPointData(result, backfillSplitMode);
    return {
        result: result,
        resultMap: multiDatum ? resultMapMulti : resultMapSingle
    };
}
function $d77b025aa58d633c$var$determinePathStatus(newData, oldData, pairData) {
    var _a, _b, _c, _d;
    let status = "updated";
    const visible = (data)=>{
        return data.visible;
    };
    if (!visible(oldData) && visible(newData)) status = "added";
    else if (visible(oldData) && !visible(newData)) status = "removed";
    else for(let i = 0; i < pairData.length; i++){
        if (pairData[i].change !== "move") break;
        if (((_a = pairData[i].from) == null ? void 0 : _a.x) !== ((_b = pairData[i].to) == null ? void 0 : _b.x)) break;
        if (((_c = pairData[i].from) == null ? void 0 : _c.y) !== ((_d = pairData[i].to) == null ? void 0 : _d.y)) break;
        if (i === pairData.length - 1) return "no-op";
    }
    return status;
}
function $d77b025aa58d633c$var$prepareLinePathPropertyAnimation(status, visibleToggleMode) {
    const phase = visibleToggleMode === "none" ? "updated" : status;
    const result = {
        fromFn: (_path)=>{
            let mixin;
            if (status === "removed") mixin = {
                finish: {
                    visible: false
                }
            };
            else if (status === "added") mixin = {
                start: {
                    visible: true
                }
            };
            else mixin = {};
            return $d77b025aa58d633c$var$__spreadValues({
                phase: $d77b025aa58d633c$var$NODE_UPDATE_STATE_TO_PHASE_MAPPING[phase]
            }, mixin);
        },
        toFn: (_path)=>{
            return {
                phase: $d77b025aa58d633c$var$NODE_UPDATE_STATE_TO_PHASE_MAPPING[phase]
            };
        }
    };
    if (visibleToggleMode === "fade") return {
        fromFn: (path)=>{
            const opacity = status === "added" ? 0 : path.opacity;
            return $d77b025aa58d633c$var$__spreadValues({
                opacity: opacity
            }, result.fromFn(path));
        },
        toFn: (path)=>{
            const opacity = status === "removed" ? 0 : 1;
            return $d77b025aa58d633c$var$__spreadValues({
                opacity: opacity
            }, result.toFn(path));
        }
    };
    return result;
}
function $d77b025aa58d633c$var$prepareLinePathAnimationFns(newData, oldData, pairData, visibleToggleMode, render) {
    const status = $d77b025aa58d633c$var$determinePathStatus(newData, oldData, pairData);
    const removePhaseFn = (ratio, path)=>{
        render(pairData, {
            move: 0,
            out: ratio
        }, path);
    };
    const updatePhaseFn = (ratio, path)=>{
        render(pairData, {
            move: ratio
        }, path);
    };
    const addPhaseFn = (ratio, path)=>{
        render(pairData, {
            move: 1,
            in: ratio
        }, path);
    };
    const pathProperties = $d77b025aa58d633c$var$prepareLinePathPropertyAnimation(status, visibleToggleMode);
    return {
        status: status,
        path: {
            addPhaseFn: addPhaseFn,
            updatePhaseFn: updatePhaseFn,
            removePhaseFn: removePhaseFn
        },
        pathProperties: pathProperties
    };
}
function $d77b025aa58d633c$var$prepareLinePathAnimation(newData, oldData, diff2) {
    var _a, _b, _c;
    const isCategoryBased = ((_a = newData.scales.x) == null ? void 0 : _a.type) === "category";
    const wasCategoryBased = ((_b = oldData.scales.x) == null ? void 0 : _b.type) === "category";
    if (isCategoryBased !== wasCategoryBased) return;
    const { result: pairData, resultMap: pairMap } = isCategoryBased ? $d77b025aa58d633c$var$pairCategoryData(newData, oldData, diff2) : $d77b025aa58d633c$var$pairContinuousData(newData, oldData);
    let status = "updated";
    if (oldData.visible && !newData.visible) status = "removed";
    else if (!oldData.visible && newData.visible) status = "added";
    if (pairData === void 0 || pairMap === void 0) return;
    const hasMotion = ((_c = diff2 == null ? void 0 : diff2.changed) != null ? _c : true) || $d77b025aa58d633c$var$scalesChanged(newData, oldData) || status !== "updated";
    const pathFns = $d77b025aa58d633c$var$prepareLinePathAnimationFns(newData, oldData, pairData, "fade", $d77b025aa58d633c$var$renderPartialPath);
    const marker = $d77b025aa58d633c$var$prepareMarkerAnimation(pairMap, status);
    return $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, pathFns), {
        marker: marker,
        hasMotion: hasMotion
    });
}
// packages/ag-charts-community/src/chart/series/cartesian/areaUtil.ts
var $d77b025aa58d633c$var$AreaSeriesTag = /* @__PURE__ */ ((AreaSeriesTag2)=>{
    AreaSeriesTag2[AreaSeriesTag2["Fill"] = 0] = "Fill";
    AreaSeriesTag2[AreaSeriesTag2["Stroke"] = 1] = "Stroke";
    AreaSeriesTag2[AreaSeriesTag2["Marker"] = 2] = "Marker";
    AreaSeriesTag2[AreaSeriesTag2["Label"] = 3] = "Label";
    return AreaSeriesTag2;
})($d77b025aa58d633c$var$AreaSeriesTag || {});
function $d77b025aa58d633c$var$splitFillPoints(context) {
    const { points: points, phantomPoints: phantomPoints } = context.fillData;
    return {
        top: points,
        bottom: phantomPoints
    };
}
function $d77b025aa58d633c$var$prepPoints(key, ctx, points) {
    return {
        scales: ctx.scales,
        nodeData: points[key],
        visible: ctx.visible
    };
}
function $d77b025aa58d633c$var$pairFillCategoryData(newData, oldData, diff2) {
    const oldPoints = $d77b025aa58d633c$var$splitFillPoints(oldData);
    const newPoints = $d77b025aa58d633c$var$splitFillPoints(newData);
    const pairOpts = {
        multiDatum: true
    };
    return {
        top: $d77b025aa58d633c$var$pairCategoryData($d77b025aa58d633c$var$prepPoints("top", newData, newPoints), $d77b025aa58d633c$var$prepPoints("top", oldData, oldPoints), diff2, pairOpts),
        bottom: $d77b025aa58d633c$var$pairCategoryData($d77b025aa58d633c$var$prepPoints("bottom", newData, newPoints), $d77b025aa58d633c$var$prepPoints("bottom", oldData, oldPoints), diff2, pairOpts)
    };
}
function $d77b025aa58d633c$var$pairFillContinuousData(newData, oldData) {
    const oldPoints = $d77b025aa58d633c$var$splitFillPoints(oldData);
    const newPoints = $d77b025aa58d633c$var$splitFillPoints(newData);
    return {
        top: $d77b025aa58d633c$var$pairContinuousData($d77b025aa58d633c$var$prepPoints("top", newData, newPoints), $d77b025aa58d633c$var$prepPoints("top", oldData, oldPoints)),
        bottom: $d77b025aa58d633c$var$pairContinuousData($d77b025aa58d633c$var$prepPoints("bottom", newData, newPoints), $d77b025aa58d633c$var$prepPoints("bottom", oldData, oldPoints))
    };
}
function $d77b025aa58d633c$var$prepareAreaPathAnimation(newData, oldData, diff2) {
    var _a, _b;
    const isCategoryBased = ((_a = newData.scales.x) == null ? void 0 : _a.type) === "category";
    const wasCategoryBased = ((_b = oldData.scales.x) == null ? void 0 : _b.type) === "category";
    if (isCategoryBased !== wasCategoryBased) return;
    let status = "updated";
    if (oldData.visible && !newData.visible) status = "removed";
    else if (!oldData.visible && newData.visible) status = "added";
    const prepareMarkerPairs = ()=>{
        if (isCategoryBased) return $d77b025aa58d633c$var$pairCategoryData(newData, oldData, diff2, {
            backfillSplitMode: "static",
            multiDatum: true
        });
        return $d77b025aa58d633c$var$pairContinuousData(newData, oldData, {
            backfillSplitMode: "static"
        });
    };
    const prepareFillPairs = ()=>{
        if (isCategoryBased) return $d77b025aa58d633c$var$pairFillCategoryData(newData, oldData, diff2);
        return $d77b025aa58d633c$var$pairFillContinuousData(newData, oldData);
    };
    const { resultMap: markerPairMap } = prepareMarkerPairs();
    const { top: top, bottom: bottom } = prepareFillPairs();
    if (markerPairMap === void 0 || top.result === void 0 || bottom.result === void 0) return;
    const pairData = [
        ...top.result,
        ...bottom.result.reverse()
    ];
    const stackVisible = oldData.stackVisible ? newData.stackVisible : false;
    const fadeMode = stackVisible ? "none" : "fade";
    const fill = $d77b025aa58d633c$var$prepareLinePathAnimationFns(newData, oldData, pairData, fadeMode, $d77b025aa58d633c$var$renderPartialPath);
    const marker = $d77b025aa58d633c$var$prepareMarkerAnimation(markerPairMap, status);
    return {
        status: fill.status,
        fill: fill,
        marker: marker
    };
}
// packages/ag-charts-community/src/chart/series/cartesian/areaSeries.ts
var $d77b025aa58d633c$var$AreaSeries = class extends $d77b025aa58d633c$var$CartesianSeries {
    constructor(moduleCtx){
        super({
            moduleCtx: moduleCtx,
            directionKeys: $d77b025aa58d633c$var$DEFAULT_CARTESIAN_DIRECTION_KEYS,
            directionNames: $d77b025aa58d633c$var$DEFAULT_CARTESIAN_DIRECTION_NAMES,
            pathsPerSeries: 2,
            pathsZIndexSubOrderOffset: [
                0,
                1e3
            ],
            hasMarkers: true,
            markerSelectionGarbageCollection: false,
            pickModes: [
                1 /* NEAREST_BY_MAIN_AXIS_FIRST */ ,
                0 /* EXACT_SHAPE_MATCH */ 
            ],
            animationResetFns: {
                path: $d77b025aa58d633c$var$buildResetPathFn({
                    getOpacity: ()=>this.getOpacity()
                }),
                label: $d77b025aa58d633c$var$resetLabelFn,
                marker: (node, datum)=>$d77b025aa58d633c$var$__spreadValues($d77b025aa58d633c$var$__spreadValues({}, $d77b025aa58d633c$var$resetMarkerFn(node)), $d77b025aa58d633c$var$resetMarkerPositionFn(node, datum))
            }
        });
        this.properties = new $d77b025aa58d633c$var$AreaSeriesProperties();
    }
    processData(dataController) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            var _a, _b;
            if (this.data == null || !this.properties.isValid()) return;
            const { data: data, visible: visible, seriesGrouping: { groupIndex: groupIndex = this.id, stackCount: stackCount = 1 } = {} } = this;
            const { xKey: xKey, yKey: yKey, connectMissingData: connectMissingData, normalizedTo: normalizedTo } = this.properties;
            const animationEnabled = !this.ctx.animationManager.isSkipped();
            const xScale = (_a = this.axes["x" /* X */ ]) == null ? void 0 : _a.scale;
            const yScale = (_b = this.axes["y" /* Y */ ]) == null ? void 0 : _b.scale;
            const { isContinuousX: isContinuousX, xScaleType: xScaleType, yScaleType: yScaleType } = this.getScaleInformation({
                xScale: xScale,
                yScale: yScale
            });
            const ids = [
                `area-stack-${groupIndex}-yValues`,
                `area-stack-${groupIndex}-yValues-trailing`,
                `area-stack-${groupIndex}-yValues-prev`,
                `area-stack-${groupIndex}-yValues-trailing-prev`,
                `area-stack-${groupIndex}-yValues-marker`
            ];
            const extraProps = [];
            if ($d77b025aa58d633c$var$isDefined(normalizedTo)) {
                extraProps.push($d77b025aa58d633c$var$normaliseGroupTo([
                    ids[0],
                    ids[1],
                    ids[4]
                ], normalizedTo, "range"));
                extraProps.push($d77b025aa58d633c$var$normaliseGroupTo([
                    ids[2],
                    ids[3]
                ], normalizedTo, "range"));
            }
            if (!isContinuousX && animationEnabled && this.processedData) extraProps.push($d77b025aa58d633c$var$diff(this.processedData));
            if (animationEnabled) extraProps.push($d77b025aa58d633c$var$animationValidation());
            const common = {
                invalidValue: null
            };
            if (connectMissingData && stackCount > 1) common.invalidValue = 0;
            if (!visible) common.forceValue = 0;
            yield this.requestDataModel(dataController, data, {
                props: [
                    $d77b025aa58d633c$var$keyProperty(xKey, xScaleType, {
                        id: "xValue"
                    }),
                    $d77b025aa58d633c$var$valueProperty(yKey, yScaleType, $d77b025aa58d633c$var$__spreadValues({
                        id: `yValueRaw`
                    }, common)),
                    ...$d77b025aa58d633c$var$groupAccumulativeValueProperty(yKey, "window", "current", $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({
                        id: `yValueEnd`
                    }, common), {
                        groupId: ids[0]
                    }), yScaleType),
                    ...$d77b025aa58d633c$var$groupAccumulativeValueProperty(yKey, "window-trailing", "current", $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({
                        id: `yValueStart`
                    }, common), {
                        groupId: ids[1]
                    }), yScaleType),
                    ...$d77b025aa58d633c$var$groupAccumulativeValueProperty(yKey, "window", "last", $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({
                        id: `yValuePreviousEnd`
                    }, common), {
                        groupId: ids[2]
                    }), yScaleType),
                    ...$d77b025aa58d633c$var$groupAccumulativeValueProperty(yKey, "window-trailing", "last", $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({
                        id: `yValuePreviousStart`
                    }, common), {
                        groupId: ids[3]
                    }), yScaleType),
                    ...$d77b025aa58d633c$var$groupAccumulativeValueProperty(yKey, "normal", "current", $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({
                        id: `yValueCumulative`
                    }, common), {
                        groupId: ids[4]
                    }), yScaleType),
                    ...extraProps
                ],
                groupByKeys: true,
                groupByData: false
            });
            this.animationState.transition("updateData");
        });
    }
    getSeriesDomain(direction) {
        const { processedData: processedData, dataModel: dataModel, axes: axes } = this;
        if (!processedData || !dataModel || processedData.data.length === 0) return [];
        const xAxis = axes["x" /* X */ ];
        const yAxis = axes["y" /* Y */ ];
        const keyDef = dataModel.resolveProcessedDataDefById(this, `xValue`);
        const keys = dataModel.getDomain(this, `xValue`, "key", processedData);
        const yExtent = dataModel.getDomain(this, `yValueEnd`, "value", processedData);
        if (direction === "x" /* X */ ) {
            if ((keyDef == null ? void 0 : keyDef.def.type) === "key" && keyDef.def.valueType === "category") return keys;
            return $d77b025aa58d633c$var$fixNumericExtent($d77b025aa58d633c$var$extent(keys), xAxis);
        } else if (yAxis instanceof $d77b025aa58d633c$var$LogAxis || yAxis instanceof $d77b025aa58d633c$var$TimeAxis) return $d77b025aa58d633c$var$fixNumericExtent(yExtent, yAxis);
        else {
            const fixedYExtent = [
                yExtent[0] > 0 ? 0 : yExtent[0],
                yExtent[1] < 0 ? 0 : yExtent[1]
            ];
            return $d77b025aa58d633c$var$fixNumericExtent(fixedYExtent, yAxis);
        }
    }
    createNodeData() {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            var _a;
            const { axes: axes, data: data, processedData: { data: groupedData } = {}, dataModel: dataModel } = this;
            const xAxis = axes["x" /* X */ ];
            const yAxis = axes["y" /* Y */ ];
            if (!xAxis || !yAxis || !data || !dataModel || !this.properties.isValid()) return;
            const { yKey: yKey, xKey: xKey, marker: marker, label: label, fill: seriesFill, stroke: seriesStroke, connectMissingData: connectMissingData } = this.properties;
            const { scale: xScale } = xAxis;
            const { scale: yScale } = yAxis;
            const { isContinuousY: isContinuousY } = this.getScaleInformation({
                xScale: xScale,
                yScale: yScale
            });
            const xOffset = ((_a = xScale.bandwidth) != null ? _a : 0) / 2;
            const defs = dataModel.resolveProcessedDataDefsByIds(this, [
                `yValueStart`,
                `yValueEnd`,
                `yValueRaw`,
                `yValuePreviousStart`,
                `yValuePreviousEnd`,
                `yValueCumulative`
            ]);
            const createMovePoint = (plainPoint)=>$d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, plainPoint), {
                    point: $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, plainPoint.point), {
                        moveTo: true
                    })
                });
            const createPathCoordinates = (xValue, lastYEnd, yEnd)=>{
                const x = xScale.convert(xValue) + xOffset;
                const prevYCoordinate = yScale.convert(lastYEnd);
                const currYCoordinate = yScale.convert(yEnd);
                return [
                    {
                        point: {
                            x: x,
                            y: currYCoordinate
                        },
                        yValue: yEnd,
                        xValue: xValue
                    },
                    {
                        point: {
                            x: x,
                            y: prevYCoordinate
                        },
                        yValue: lastYEnd,
                        xValue: xValue
                    }
                ];
            };
            const createMarkerCoordinate = (xDatum, yEnd, rawYDatum)=>{
                let currY;
                if ($d77b025aa58d633c$var$isDefined(this.properties.normalizedTo) ? isContinuousY && $d77b025aa58d633c$var$isContinuous(rawYDatum) : !isNaN(rawYDatum)) currY = yEnd;
                return {
                    x: xScale.convert(xDatum) + xOffset,
                    y: yScale.convert(currY),
                    size: marker.size
                };
            };
            const itemId = yKey;
            const labelData = [];
            const markerData = [];
            const { visibleSameStackCount: visibleSameStackCount } = this.ctx.seriesStateManager.getVisiblePeerGroupIndex(this);
            const context = {
                itemId: itemId,
                fillData: {
                    itemId: itemId,
                    points: [],
                    phantomPoints: []
                },
                strokeData: {
                    itemId: itemId,
                    points: []
                },
                labelData: labelData,
                nodeData: markerData,
                scales: this.calculateScaling(),
                visible: this.visible,
                stackVisible: visibleSameStackCount > 0
            };
            const fillPoints = context.fillData.points;
            const fillPhantomPoints = context.fillData.phantomPoints;
            const strokePoints = context.strokeData.points;
            let datumIdx = -1;
            let lastXDatum;
            let lastYDatum = -Infinity;
            groupedData == null || groupedData.forEach((datumGroup)=>{
                const { keys: keys, keys: [xDatum], datum: datumArray, values: valuesArray } = datumGroup;
                valuesArray.forEach((values, valueIdx)=>{
                    var _a2, _b, _c;
                    datumIdx++;
                    const seriesDatum = datumArray[valueIdx];
                    const dataValues = dataModel.resolveProcessedDataDefsValues(defs, {
                        keys: keys,
                        values: values
                    });
                    const { yValueRaw: yDatum, yValueCumulative: yValueCumulative } = dataValues;
                    let { yValueStart: yValueStart, yValueEnd: yValueEnd, yValuePreviousStart: yValuePreviousStart, yValuePreviousEnd: yValuePreviousEnd } = dataValues;
                    const validPoint = yDatum != null;
                    const point = createMarkerCoordinate(xDatum, +yValueCumulative, yDatum);
                    if (validPoint && marker) markerData.push({
                        index: datumIdx,
                        series: this,
                        itemId: itemId,
                        datum: seriesDatum,
                        midPoint: {
                            x: point.x,
                            y: point.y
                        },
                        cumulativeValue: yValueEnd,
                        yValue: yDatum,
                        xValue: xDatum,
                        yKey: yKey,
                        xKey: xKey,
                        point: point,
                        fill: (_a2 = marker.fill) != null ? _a2 : seriesFill,
                        stroke: (_b = marker.stroke) != null ? _b : seriesStroke,
                        strokeWidth: (_c = marker.strokeWidth) != null ? _c : this.getStrokeWidth(this.properties.strokeWidth)
                    });
                    if (validPoint && label) {
                        const labelText = this.getLabelText(label, {
                            value: yDatum,
                            datum: seriesDatum,
                            xKey: xKey,
                            yKey: yKey,
                            xName: this.properties.xName,
                            yName: this.properties.yName
                        }, (value)=>$d77b025aa58d633c$var$isFiniteNumber(value) ? value.toFixed(2) : String(value));
                        labelData.push({
                            index: datumIdx,
                            series: this,
                            itemId: yKey,
                            datum: seriesDatum,
                            x: point.x,
                            y: point.y,
                            label: labelText ? {
                                text: labelText,
                                fontStyle: label.fontStyle,
                                fontWeight: label.fontWeight,
                                fontSize: label.fontSize,
                                fontFamily: label.fontFamily,
                                textAlign: "center",
                                textBaseline: "bottom",
                                fill: label.color
                            } : void 0
                        });
                    }
                    const xValid = lastXDatum != null && xDatum != null;
                    const yValid = lastYDatum != null && validPoint;
                    if (!yValid) {
                        yValueStart = yValueStart != null ? yValueStart : 0;
                        yValueEnd = yValueStart != null ? yValueStart : 0;
                        yValuePreviousStart = yValuePreviousStart != null ? yValuePreviousStart : 0;
                        yValuePreviousEnd = yValuePreviousStart != null ? yValuePreviousStart : 0;
                    }
                    const [prevTop, prevBottom] = createPathCoordinates(lastXDatum, yValuePreviousStart, yValuePreviousEnd);
                    const [top, bottom] = createPathCoordinates(xDatum, yValueStart, yValueEnd);
                    if (xValid && (!connectMissingData || yValid)) {
                        fillPoints.push(prevTop, top);
                        fillPhantomPoints.push(prevBottom, bottom);
                    }
                    if (yValid && datumIdx > 0) strokePoints.push(createMovePoint(prevTop), top);
                    lastXDatum = xDatum;
                    lastYDatum = yDatum;
                });
            });
            if (strokePoints.length > 0) strokePoints[0] = createMovePoint(strokePoints[0]);
            return context;
        });
    }
    isPathOrSelectionDirty() {
        return this.properties.marker.isDirty();
    }
    markerFactory() {
        const { shape: shape } = this.properties.marker;
        const MarkerShape = $d77b025aa58d633c$var$getMarker(shape);
        return new MarkerShape();
    }
    updatePathNodes(opts) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            const { opacity: opacity, visible: visible, animationEnabled: animationEnabled } = opts;
            const [fill, stroke] = opts.paths;
            const strokeWidth = this.getStrokeWidth(this.properties.strokeWidth);
            stroke.setProperties({
                tag: 1 /* Stroke */ ,
                fill: void 0,
                lineJoin: stroke.lineCap = "round",
                pointerEvents: 1 /* None */ ,
                stroke: this.properties.stroke,
                strokeWidth: strokeWidth,
                strokeOpacity: this.properties.strokeOpacity,
                lineDash: this.properties.lineDash,
                lineDashOffset: this.properties.lineDashOffset,
                opacity: opacity,
                visible: visible
            });
            fill.setProperties({
                tag: 0 /* Fill */ ,
                stroke: void 0,
                lineJoin: "round",
                pointerEvents: 1 /* None */ ,
                fill: this.properties.fill,
                fillOpacity: this.properties.fillOpacity,
                lineDash: this.properties.lineDash,
                lineDashOffset: this.properties.lineDashOffset,
                strokeOpacity: this.properties.strokeOpacity,
                fillShadow: this.properties.shadow,
                opacity: opacity,
                visible: visible || animationEnabled,
                strokeWidth: strokeWidth
            });
            $d77b025aa58d633c$var$updateClipPath(this, stroke);
            $d77b025aa58d633c$var$updateClipPath(this, fill);
        });
    }
    updatePaths(opts) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            this.updateAreaPaths(opts.paths, opts.contextData);
        });
    }
    updateAreaPaths(paths, contextData) {
        this.updateFillPath(paths, contextData);
        this.updateStrokePath(paths, contextData);
    }
    updateFillPath(paths, contextData) {
        const { fillData: fillData } = contextData;
        const [fill] = paths;
        const { path: fillPath } = fill;
        fillPath.clear(true);
        let lastPoint;
        for (const { point: point } of $d77b025aa58d633c$var$iterate(fillData.points, $d77b025aa58d633c$var$iterateReverseArray(fillData.phantomPoints))){
            if (point.moveTo) fillPath.moveTo(point.x, point.y);
            else if ((lastPoint == null ? void 0 : lastPoint.y) !== point.y) {
                if (lastPoint) fillPath.lineTo(lastPoint.x, lastPoint.y);
                fillPath.lineTo(point.x, point.y);
            }
            lastPoint = point;
        }
        if (lastPoint) fillPath.lineTo(lastPoint.x, lastPoint.y);
        fillPath.closePath();
        fill.checkPathDirty();
    }
    updateStrokePath(paths, contextData) {
        const { strokeData: strokeData } = contextData;
        const [, stroke] = paths;
        const { path: strokePath } = stroke;
        strokePath.clear(true);
        for (const { point: point } of strokeData.points)if (point.moveTo) strokePath.moveTo(point.x, point.y);
        else strokePath.lineTo(point.x, point.y);
        stroke.checkPathDirty();
    }
    updateMarkerSelection(opts) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            const { nodeData: nodeData, markerSelection: markerSelection } = opts;
            if (this.properties.marker.isDirty()) {
                markerSelection.clear();
                markerSelection.cleanup();
            }
            return markerSelection.update(this.properties.marker.enabled ? nodeData : []);
        });
    }
    updateMarkerNodes(opts) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            const { markerSelection: markerSelection, isHighlight: highlighted } = opts;
            const { xKey: xKey, yKey: yKey, marker: marker, fill: fill, stroke: stroke, strokeWidth: strokeWidth, fillOpacity: fillOpacity, strokeOpacity: strokeOpacity, highlightStyle: highlightStyle } = this.properties;
            const baseStyle = $d77b025aa58d633c$var$mergeDefaults(highlighted && highlightStyle.item, marker.getStyle(), {
                fill: fill,
                stroke: stroke,
                strokeWidth: strokeWidth,
                fillOpacity: fillOpacity,
                strokeOpacity: strokeOpacity
            });
            markerSelection.each((node, datum)=>{
                this.updateMarkerStyle(node, marker, {
                    datum: datum,
                    highlighted: highlighted,
                    xKey: xKey,
                    yKey: yKey
                }, baseStyle);
            });
            if (!highlighted) this.properties.marker.markClean();
        });
    }
    updateLabelSelection(opts) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            const { labelData: labelData, labelSelection: labelSelection } = opts;
            return labelSelection.update(labelData, (text)=>{
                text.tag = 3 /* Label */ ;
            });
        });
    }
    updateLabelNodes(opts) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            const { labelSelection: labelSelection } = opts;
            const { enabled: labelEnabled, fontStyle: fontStyle, fontWeight: fontWeight, fontSize: fontSize, fontFamily: fontFamily, color: color } = this.properties.label;
            labelSelection.each((text, datum)=>{
                const { x: x, y: y, label: label } = datum;
                if (label && labelEnabled && this.visible) {
                    text.fontStyle = fontStyle;
                    text.fontWeight = fontWeight;
                    text.fontSize = fontSize;
                    text.fontFamily = fontFamily;
                    text.textAlign = label.textAlign;
                    text.textBaseline = label.textBaseline;
                    text.text = label.text;
                    text.x = x;
                    text.y = y - 10;
                    text.fill = color;
                    text.visible = true;
                } else text.visible = false;
            });
        });
    }
    getTooltipHtml(nodeDatum) {
        const { id: seriesId, axes: axes, dataModel: dataModel } = this;
        const { xKey: xKey, xName: xName, yName: yName, tooltip: tooltip, marker: marker } = this.properties;
        const { yKey: yKey, xValue: xValue, yValue: yValue, datum: datum, itemId: itemId } = nodeDatum;
        const xAxis = axes["x" /* X */ ];
        const yAxis = axes["y" /* Y */ ];
        if (!this.properties.isValid() || !(xAxis && yAxis && $d77b025aa58d633c$var$isFiniteNumber(yValue)) || !dataModel) return $d77b025aa58d633c$var$EMPTY_TOOLTIP_CONTENT;
        const xString = xAxis.formatDatum(xValue);
        const yString = yAxis.formatDatum(yValue);
        const title = $d77b025aa58d633c$var$sanitizeHtml(yName);
        const content = $d77b025aa58d633c$var$sanitizeHtml(xString + ": " + yString);
        const baseStyle = $d77b025aa58d633c$var$mergeDefaults({
            fill: this.properties.fill
        }, marker.getStyle(), {
            stroke: this.properties.stroke,
            strokeWidth: this.properties.strokeWidth
        });
        const { fill: color } = this.getMarkerStyle(marker, {
            datum: nodeDatum,
            xKey: xKey,
            yKey: yKey,
            highlighted: false
        }, baseStyle);
        return tooltip.toTooltipHtml({
            title: title,
            content: content,
            backgroundColor: color
        }, {
            datum: datum,
            itemId: itemId,
            xKey: xKey,
            xName: xName,
            yKey: yKey,
            yName: yName,
            color: color,
            title: title,
            seriesId: seriesId
        });
    }
    getLegendData(legendType) {
        var _a, _b, _c, _d;
        if (!((_a = this.data) == null ? void 0 : _a.length) || !this.properties.isValid() || legendType !== "category") return [];
        const { yKey: yKey, yName: yName, fill: fill, stroke: stroke, fillOpacity: fillOpacity, strokeOpacity: strokeOpacity, strokeWidth: strokeWidth, lineDash: lineDash, marker: marker, visible: visible } = this.properties;
        const useAreaFill = !marker.enabled || marker.fill === void 0;
        return [
            {
                legendType: legendType,
                id: this.id,
                itemId: yKey,
                seriesId: this.id,
                enabled: visible,
                label: {
                    text: yName != null ? yName : yKey
                },
                marker: {
                    shape: marker.shape,
                    fill: useAreaFill ? fill : marker.fill,
                    fillOpacity: useAreaFill ? fillOpacity : marker.fillOpacity,
                    stroke: (_b = marker.stroke) != null ? _b : stroke,
                    strokeOpacity: (_c = marker.strokeOpacity) != null ? _c : strokeOpacity,
                    strokeWidth: (_d = marker.strokeWidth) != null ? _d : 0,
                    enabled: marker.enabled || strokeWidth <= 0
                },
                line: {
                    stroke: stroke,
                    strokeOpacity: strokeOpacity,
                    strokeWidth: strokeWidth,
                    lineDash: lineDash
                }
            }
        ];
    }
    animateEmptyUpdateReady(animationData) {
        const { markerSelection: markerSelection, labelSelection: labelSelection, contextData: contextData, paths: paths } = animationData;
        const { animationManager: animationManager } = this.ctx;
        this.updateAreaPaths(paths, contextData);
        $d77b025aa58d633c$var$pathSwipeInAnimation(this, animationManager, ...paths);
        $d77b025aa58d633c$var$resetMotion([
            markerSelection
        ], $d77b025aa58d633c$var$resetMarkerPositionFn);
        $d77b025aa58d633c$var$markerSwipeScaleInAnimation(this, animationManager, markerSelection);
        $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "labels", animationManager, labelSelection);
    }
    animateReadyResize(animationData) {
        const { contextData: contextData, paths: paths } = animationData;
        this.updateAreaPaths(paths, contextData);
        super.animateReadyResize(animationData);
    }
    animateWaitingUpdateReady(animationData) {
        var _a, _b;
        const { animationManager: animationManager } = this.ctx;
        const { markerSelection: markerSelection, labelSelection: labelSelection, contextData: contextData, paths: paths, previousContextData: previousContextData } = animationData;
        const [fill, stroke] = paths;
        if (fill == null && stroke == null) return;
        super.resetAllAnimation(animationData);
        const update = ()=>{
            this.updateAreaPaths(paths, contextData);
            this.updateStrokePath(paths, contextData);
        };
        const skip = ()=>{
            animationManager.skipCurrentBatch();
            update();
        };
        if (contextData == null || previousContextData == null) {
            update();
            $d77b025aa58d633c$var$markerFadeInAnimation(this, animationManager, "added", markerSelection);
            $d77b025aa58d633c$var$pathFadeInAnimation(this, "fill_path_properties", animationManager, "add", fill);
            $d77b025aa58d633c$var$pathFadeInAnimation(this, "stroke", animationManager, "trailing", stroke);
            $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "labels", animationManager, labelSelection);
            return;
        }
        const fns = $d77b025aa58d633c$var$prepareAreaPathAnimation(contextData, previousContextData, (_b = (_a = this.processedData) == null ? void 0 : _a.reduced) == null ? void 0 : _b.diff);
        if (fns === void 0) {
            skip();
            return;
        } else if (fns.status === "no-op") return;
        $d77b025aa58d633c$var$markerFadeInAnimation(this, animationManager, void 0, markerSelection);
        $d77b025aa58d633c$var$fromToMotion(this.id, "fill_path_properties", animationManager, [
            fill
        ], fns.fill.pathProperties);
        $d77b025aa58d633c$var$pathMotion(this.id, "fill_path_update", animationManager, [
            fill
        ], fns.fill.path);
        this.updateStrokePath(paths, contextData);
        $d77b025aa58d633c$var$pathFadeInAnimation(this, "stroke", animationManager, "trailing", stroke);
        $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "labels", animationManager, labelSelection);
    }
    isLabelEnabled() {
        return this.properties.label.enabled;
    }
    nodeFactory() {
        return new $d77b025aa58d633c$var$Group();
    }
    getFormattedMarkerStyle(datum) {
        const { xKey: xKey, yKey: yKey } = datum;
        return this.getMarkerStyle(this.properties.marker, {
            datum: datum,
            xKey: xKey,
            yKey: yKey,
            highlighted: true
        });
    }
    computeFocusBounds(opts) {
        return $d77b025aa58d633c$var$computeMarkerFocusBounds(this, opts);
    }
};
$d77b025aa58d633c$var$AreaSeries.className = "AreaSeries";
$d77b025aa58d633c$var$AreaSeries.type = "area";
// packages/ag-charts-community/src/chart/series/cartesian/areaSeriesModule.ts
var $d77b025aa58d633c$var$AreaSeriesModule = {
    type: "series",
    optionsKey: "series[]",
    packageType: "community",
    chartTypes: [
        "cartesian"
    ],
    identifier: "area",
    instanceConstructor: $d77b025aa58d633c$var$AreaSeries,
    stackable: true,
    defaultAxes: [
        {
            type: "number" /* NUMBER */ ,
            position: "left" /* LEFT */ 
        },
        {
            type: "category" /* CATEGORY */ ,
            position: "bottom" /* BOTTOM */ 
        }
    ],
    themeTemplate: {
        series: {
            __extends__: $d77b025aa58d633c$var$EXTENDS_SERIES_DEFAULTS,
            nodeClickRange: "nearest",
            tooltip: {
                position: {
                    type: "node"
                }
            },
            fillOpacity: 0.8,
            strokeOpacity: 1,
            strokeWidth: 0,
            lineDash: [
                0
            ],
            lineDashOffset: 0,
            shadow: {
                enabled: false,
                color: $d77b025aa58d633c$var$DEFAULT_SHADOW_COLOUR,
                xOffset: 3,
                yOffset: 3,
                blur: 5
            },
            marker: {
                __extends__: $d77b025aa58d633c$var$EXTENDS_CARTESIAN_MARKER_DEFAULTS,
                enabled: false,
                fillOpacity: 1,
                strokeOpacity: 1,
                strokeWidth: 0
            },
            label: {
                enabled: false,
                fontSize: 12,
                fontFamily: $d77b025aa58d633c$var$DEFAULT_FONT_FAMILY,
                color: $d77b025aa58d633c$var$DEFAULT_LABEL_COLOUR
            }
        }
    },
    paletteFactory: (params)=>{
        const { marker: marker } = $d77b025aa58d633c$var$markerPaletteFactory(params);
        return {
            fill: marker.fill,
            stroke: marker.stroke,
            marker: marker
        };
    }
};
// packages/ag-charts-community/src/chart/series/cartesian/quadtreeUtil.ts
function* $d77b025aa58d633c$var$childrenIter(parent) {
    for (const node of parent.children)yield node;
}
function $d77b025aa58d633c$var$addHitTestersToQuadtree(quadtree, hitTesters) {
    for (const node of hitTesters){
        const datum = node.datum;
        if (datum === void 0) $d77b025aa58d633c$var$Logger.error("undefined datum");
        else quadtree.addValue(node, datum);
    }
}
function $d77b025aa58d633c$var$findQuadtreeMatch(series, point) {
    const { x: x, y: y } = series.contentGroup.transformPoint(point.x, point.y);
    const { nearest: nearest, distanceSquared: distanceSquared2 } = series.getQuadTree().find(x, y);
    if (nearest !== void 0) return {
        datum: nearest.value,
        distance: Math.sqrt(distanceSquared2)
    };
    return void 0;
}
// packages/ag-charts-community/src/chart/series/cartesian/abstractBarSeries.ts
var $d77b025aa58d633c$var$AbstractBarSeriesProperties = class extends $d77b025aa58d633c$var$CartesianSeriesProperties {
    constructor(){
        super(...arguments);
        this.direction = "vertical";
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$DIRECTION)
], $d77b025aa58d633c$var$AbstractBarSeriesProperties.prototype, "direction", 2);
var $d77b025aa58d633c$var$AbstractBarSeries = class extends $d77b025aa58d633c$var$CartesianSeries {
    constructor(){
        super(...arguments);
        /**
     * Used to get the position of bars within each group.
     */ this.groupScale = new $d77b025aa58d633c$var$BandScale();
        this.smallestDataInterval = void 0;
    }
    getBandScalePadding() {
        return {
            inner: 0.2,
            outer: 0.1
        };
    }
    shouldFlipXY() {
        return !this.isVertical();
    }
    isVertical() {
        return this.properties.direction === "vertical";
    }
    getBarDirection() {
        return this.shouldFlipXY() ? "x" /* X */  : "y" /* Y */ ;
    }
    getCategoryDirection() {
        return this.shouldFlipXY() ? "y" /* Y */  : "x" /* X */ ;
    }
    getValueAxis() {
        const direction = this.getBarDirection();
        return this.axes[direction];
    }
    getCategoryAxis() {
        const direction = this.getCategoryDirection();
        return this.axes[direction];
    }
    updateGroupScale(xAxis) {
        const { groupScale: groupScale, smallestDataInterval: smallestDataInterval, ctx: { seriesStateManager: seriesStateManager } } = this;
        const xScale = xAxis.scale;
        const xBandWidth = $d77b025aa58d633c$var$ContinuousScale.is(xScale) ? xScale.calcBandwidth(smallestDataInterval) : xScale.bandwidth;
        const domain = [];
        const { index: groupIndex, visibleGroupCount: visibleGroupCount } = seriesStateManager.getVisiblePeerGroupIndex(this);
        for(let groupIdx = 0; groupIdx < visibleGroupCount; groupIdx++)domain.push(String(groupIdx));
        groupScale.domain = domain;
        groupScale.range = [
            0,
            xBandWidth != null ? xBandWidth : 0
        ];
        if (xAxis instanceof $d77b025aa58d633c$var$CategoryAxis) groupScale.paddingInner = xAxis.groupPaddingInner;
        else if (xAxis instanceof $d77b025aa58d633c$var$GroupedCategoryAxis) groupScale.padding = 0.1;
        else groupScale.padding = 0;
        groupScale.round = groupScale.padding !== 0;
        const barWidth = groupScale.bandwidth >= 1 ? // Pixel-rounded value for low-volume bar charts.
        groupScale.bandwidth : // Handle high-volume bar charts gracefully.
        groupScale.rawBandwidth;
        return {
            barWidth: barWidth,
            groupIndex: groupIndex
        };
    }
    resolveKeyDirection(direction) {
        if (this.getBarDirection() === "x" /* X */ ) {
            if (direction === "x" /* X */ ) return "y" /* Y */ ;
            return "x" /* X */ ;
        }
        return direction;
    }
    initQuadTree(quadtree) {
        $d77b025aa58d633c$var$addHitTestersToQuadtree(quadtree, this.datumNodesIter());
    }
    pickNodeClosestDatum(point) {
        return $d77b025aa58d633c$var$findQuadtreeMatch(this, point);
    }
};
// packages/ag-charts-community/src/chart/series/cartesian/barSeriesProperties.ts
var $d77b025aa58d633c$var$BarSeriesLabel = class extends $d77b025aa58d633c$var$Label {
    constructor(){
        super(...arguments);
        this.placement = "inside";
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$PLACEMENT)
], $d77b025aa58d633c$var$BarSeriesLabel.prototype, "placement", 2);
var $d77b025aa58d633c$var$BarSeriesProperties = class extends $d77b025aa58d633c$var$AbstractBarSeriesProperties {
    constructor(){
        super(...arguments);
        this.fill = "#c16068";
        this.fillOpacity = 1;
        this.stroke = "#874349";
        this.strokeWidth = 1;
        this.strokeOpacity = 1;
        this.lineDash = [
            0
        ];
        this.lineDashOffset = 0;
        this.cornerRadius = 0;
        this.shadow = new $d77b025aa58d633c$var$DropShadow();
        this.label = new $d77b025aa58d633c$var$BarSeriesLabel();
        this.tooltip = new $d77b025aa58d633c$var$SeriesTooltip();
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING)
], $d77b025aa58d633c$var$BarSeriesProperties.prototype, "xKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$BarSeriesProperties.prototype, "xName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING)
], $d77b025aa58d633c$var$BarSeriesProperties.prototype, "yKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$BarSeriesProperties.prototype, "yName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$BarSeriesProperties.prototype, "stackGroup", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$NUMBER, {
        optional: true
    })
], $d77b025aa58d633c$var$BarSeriesProperties.prototype, "normalizedTo", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$COLOR_STRING)
], $d77b025aa58d633c$var$BarSeriesProperties.prototype, "fill", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$RATIO)
], $d77b025aa58d633c$var$BarSeriesProperties.prototype, "fillOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$COLOR_STRING)
], $d77b025aa58d633c$var$BarSeriesProperties.prototype, "stroke", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$BarSeriesProperties.prototype, "strokeWidth", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$RATIO)
], $d77b025aa58d633c$var$BarSeriesProperties.prototype, "strokeOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$LINE_DASH)
], $d77b025aa58d633c$var$BarSeriesProperties.prototype, "lineDash", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$BarSeriesProperties.prototype, "lineDashOffset", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$BarSeriesProperties.prototype, "cornerRadius", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$FUNCTION, {
        optional: true
    })
], $d77b025aa58d633c$var$BarSeriesProperties.prototype, "formatter", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT, {
        optional: true
    })
], $d77b025aa58d633c$var$BarSeriesProperties.prototype, "shadow", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$BarSeriesProperties.prototype, "label", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$BarSeriesProperties.prototype, "tooltip", 2);
// packages/ag-charts-community/src/chart/series/cartesian/barUtil.ts
function $d77b025aa58d633c$var$updateRect({ rect: rect, config: config }) {
    const { crisp: crisp = true, fill: fill, stroke: stroke, strokeWidth: strokeWidth, fillOpacity: fillOpacity, strokeOpacity: strokeOpacity, lineDash: lineDash, lineDashOffset: lineDashOffset, fillShadow: fillShadow, cornerRadius: cornerRadius = 0, topLeftCornerRadius: topLeftCornerRadius = true, topRightCornerRadius: topRightCornerRadius = true, bottomRightCornerRadius: bottomRightCornerRadius = true, bottomLeftCornerRadius: bottomLeftCornerRadius = true, visible: visible = true } = config;
    rect.crisp = crisp;
    rect.fill = fill;
    rect.stroke = stroke;
    rect.strokeWidth = strokeWidth;
    rect.fillOpacity = fillOpacity;
    rect.strokeOpacity = strokeOpacity;
    rect.lineDash = lineDash;
    rect.lineDashOffset = lineDashOffset;
    rect.fillShadow = fillShadow;
    rect.topLeftCornerRadius = topLeftCornerRadius ? cornerRadius : 0;
    rect.topRightCornerRadius = topRightCornerRadius ? cornerRadius : 0;
    rect.bottomRightCornerRadius = bottomRightCornerRadius ? cornerRadius : 0;
    rect.bottomLeftCornerRadius = bottomLeftCornerRadius ? cornerRadius : 0;
    rect.visible = visible;
}
function $d77b025aa58d633c$var$getRectConfig(_a) {
    var _b = _a, { datum: datum, isHighlighted: isHighlighted, style: style, highlightStyle: highlightStyle, formatter: formatter, seriesId: seriesId, ctx: { callbackCache: callbackCache } } = _b, opts = $d77b025aa58d633c$var$__objRest(_b, [
        "datum",
        "isHighlighted",
        "style",
        "highlightStyle",
        "formatter",
        "seriesId",
        "ctx"
    ]);
    var _a2, _b2, _c, _d, _e, _f;
    const { fill: fill, fillOpacity: fillOpacity, stroke: stroke, strokeWidth: strokeWidth } = $d77b025aa58d633c$var$mergeDefaults(isHighlighted && highlightStyle, style);
    const { strokeOpacity: strokeOpacity, fillShadow: fillShadow, lineDash: lineDash, lineDashOffset: lineDashOffset, cornerRadius: cornerRadius = 0, topLeftCornerRadius: topLeftCornerRadius = true, topRightCornerRadius: topRightCornerRadius = true, bottomRightCornerRadius: bottomRightCornerRadius = true, bottomLeftCornerRadius: bottomLeftCornerRadius = true } = style;
    let format2;
    if (formatter) format2 = callbackCache.call(formatter, $d77b025aa58d633c$var$__spreadValues({
        datum: datum.datum,
        xKey: datum.xKey,
        fill: fill,
        stroke: stroke,
        strokeWidth: strokeWidth,
        cornerRadius: cornerRadius,
        highlighted: isHighlighted,
        seriesId: seriesId
    }, opts));
    return {
        fill: (_a2 = format2 == null ? void 0 : format2.fill) != null ? _a2 : fill,
        stroke: (_b2 = format2 == null ? void 0 : format2.stroke) != null ? _b2 : stroke,
        strokeWidth: (_c = format2 == null ? void 0 : format2.strokeWidth) != null ? _c : strokeWidth,
        fillOpacity: (_d = format2 == null ? void 0 : format2.fillOpacity) != null ? _d : fillOpacity,
        strokeOpacity: (_e = format2 == null ? void 0 : format2.strokeOpacity) != null ? _e : strokeOpacity,
        lineDash: lineDash,
        lineDashOffset: lineDashOffset,
        fillShadow: fillShadow,
        cornerRadius: (_f = format2 == null ? void 0 : format2.cornerRadius) != null ? _f : cornerRadius,
        topLeftCornerRadius: topLeftCornerRadius,
        topRightCornerRadius: topRightCornerRadius,
        bottomRightCornerRadius: bottomRightCornerRadius,
        bottomLeftCornerRadius: bottomLeftCornerRadius
    };
}
function $d77b025aa58d633c$var$checkCrisp(visibleRange = []) {
    const [visibleMin, visibleMax] = visibleRange;
    const isZoomed = visibleMin !== 0 || visibleMax !== 1;
    return !isZoomed;
}
var $d77b025aa58d633c$var$isDatumNegative = (datum)=>{
    var _a;
    return $d77b025aa58d633c$var$isNegative((_a = datum.yValue) != null ? _a : 0);
};
function $d77b025aa58d633c$var$collapsedStartingBarPosition(isVertical, axes, mode) {
    const { startingX: startingX, startingY: startingY } = $d77b025aa58d633c$var$getStartingValues(isVertical, axes);
    const calculate = (datum, prevDatum)=>{
        let x = isVertical ? datum.x : startingX;
        let y = isVertical ? startingY : datum.y;
        let width = isVertical ? datum.width : 0;
        let height = isVertical ? 0 : datum.height;
        const { opacity: opacity } = datum;
        if (prevDatum && (isNaN(x) || isNaN(y))) {
            ({ x: x, y: y } = prevDatum);
            width = isVertical ? prevDatum.width : 0;
            height = isVertical ? 0 : prevDatum.height;
            if (isVertical && !$d77b025aa58d633c$var$isDatumNegative(prevDatum)) y += prevDatum.height;
            else if (!isVertical && $d77b025aa58d633c$var$isDatumNegative(prevDatum)) x += prevDatum.width;
        }
        let clipBBox;
        if (datum.clipBBox == null) clipBBox = void 0;
        else if ($d77b025aa58d633c$var$isDatumNegative(datum)) clipBBox = isVertical ? new $d77b025aa58d633c$var$BBox(x, y - height, width, height) : new $d77b025aa58d633c$var$BBox(x - width, y, width, height);
        else clipBBox = new $d77b025aa58d633c$var$BBox(x, y, width, height);
        return {
            x: x,
            y: y,
            width: width,
            height: height,
            clipBBox: clipBBox,
            opacity: opacity
        };
    };
    return {
        isVertical: isVertical,
        calculate: calculate,
        mode: mode
    };
}
function $d77b025aa58d633c$var$midpointStartingBarPosition(isVertical, mode) {
    return {
        isVertical: isVertical,
        calculate: (datum)=>{
            return {
                x: isVertical ? datum.x : datum.x + datum.width / 2,
                y: isVertical ? datum.y + datum.height / 2 : datum.y,
                width: isVertical ? datum.width : 0,
                height: isVertical ? 0 : datum.height,
                clipBBox: datum.clipBBox,
                opacity: datum.opacity
            };
        },
        mode: mode
    };
}
function $d77b025aa58d633c$var$prepareBarAnimationFunctions(initPos) {
    const isRemoved = (datum)=>datum == null || isNaN(datum.x) || isNaN(datum.y);
    const fromFn = (rect, datum, status)=>{
        if (status === "updated" && isRemoved(datum)) status = "removed";
        else if (status === "updated" && isRemoved(rect.previousDatum)) status = "added";
        let source;
        if (status === "added" && rect.previousDatum == null && initPos.mode === "fade") source = $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, $d77b025aa58d633c$var$resetBarSelectionsFn(rect, datum)), {
            opacity: 0
        });
        else if (status === "unknown" || status === "added") source = initPos.calculate(datum, rect.previousDatum);
        else source = {
            x: rect.x,
            y: rect.y,
            width: rect.width,
            height: rect.height,
            clipBBox: rect.clipBBox,
            opacity: rect.opacity
        };
        const phase = $d77b025aa58d633c$var$NODE_UPDATE_STATE_TO_PHASE_MAPPING[status];
        return $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, source), {
            phase: phase
        });
    };
    const toFn = (rect, datum, status)=>{
        let source;
        if (status === "removed" && rect.datum == null && initPos.mode === "fade") source = $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, $d77b025aa58d633c$var$resetBarSelectionsFn(rect, datum)), {
            opacity: 0
        });
        else if (status === "removed" || isRemoved(datum)) source = initPos.calculate(datum, rect.previousDatum);
        else source = {
            x: datum.x,
            y: datum.y,
            width: datum.width,
            height: datum.height,
            clipBBox: datum.clipBBox,
            opacity: datum.opacity
        };
        return source;
    };
    return {
        toFn: toFn,
        fromFn: fromFn
    };
}
function $d77b025aa58d633c$var$getStartingValues(isVertical, axes) {
    const axis = axes[isVertical ? "y" /* Y */  : "x" /* X */ ];
    let startingX = Infinity;
    let startingY = 0;
    if (!axis) return {
        startingX: startingX,
        startingY: startingY
    };
    if (isVertical) startingY = axis.scale.convert($d77b025aa58d633c$var$ContinuousScale.is(axis.scale) ? 0 : Math.max(...axis.range));
    else startingX = axis.scale.convert($d77b025aa58d633c$var$ContinuousScale.is(axis.scale) ? 0 : Math.min(...axis.range));
    return {
        startingX: startingX,
        startingY: startingY
    };
}
function $d77b025aa58d633c$var$resetBarSelectionsFn(_node, { x: x, y: y, width: width, height: height, clipBBox: clipBBox, opacity: opacity }) {
    return {
        x: x,
        y: y,
        width: width,
        height: height,
        clipBBox: clipBBox,
        opacity: opacity
    };
}
function $d77b025aa58d633c$var$computeBarFocusBounds(datum, barGroup, seriesRect) {
    if (datum === void 0) return void 0;
    const { x: x, y: y, width: width, height: height } = datum;
    return barGroup.inverseTransformBBox(new $d77b025aa58d633c$var$BBox(x, y, width, height)).clip(seriesRect);
}
// packages/ag-charts-community/src/chart/series/cartesian/labelUtil.ts
function $d77b025aa58d633c$var$updateLabelNode(textNode, label, labelDatum) {
    if (label.enabled && labelDatum) {
        const { x: x, y: y, text: text, textAlign: textAlign, textBaseline: textBaseline } = labelDatum;
        const { color: fill, fontStyle: fontStyle, fontWeight: fontWeight, fontSize: fontSize, fontFamily: fontFamily } = label;
        textNode.setProperties({
            visible: true,
            x: x,
            y: y,
            text: text,
            fill: fill,
            fontStyle: fontStyle,
            fontWeight: fontWeight,
            fontSize: fontSize,
            fontFamily: fontFamily,
            textAlign: textAlign,
            textBaseline: textBaseline
        });
    } else textNode.visible = false;
}
function $d77b025aa58d633c$var$adjustLabelPlacement({ isPositive: isPositive, isVertical: isVertical, placement: placement, padding: padding = 0, rect: rect }) {
    let x = rect.x + rect.width / 2;
    let y = rect.y + rect.height / 2;
    let textAlign = "center";
    let textBaseline = "middle";
    switch(placement){
        case "start":
            if (isVertical) {
                y = isPositive ? rect.y + rect.height + padding : rect.y - padding;
                textBaseline = isPositive ? "top" : "bottom";
            } else {
                x = isPositive ? rect.x - padding : rect.x + rect.width + padding;
                textAlign = isPositive ? "start" : "end";
            }
            break;
        case "outside":
        case "end":
            if (isVertical) {
                y = isPositive ? rect.y - padding : rect.y + rect.height + padding;
                textBaseline = isPositive ? "bottom" : "top";
            } else {
                x = isPositive ? rect.x + rect.width + padding : rect.x - padding;
                textAlign = isPositive ? "start" : "end";
            }
            break;
    }
    return {
        x: x,
        y: y,
        textAlign: textAlign,
        textBaseline: textBaseline
    };
}
// packages/ag-charts-community/src/chart/series/cartesian/barSeries.ts
var $d77b025aa58d633c$var$BarSeries = class extends $d77b025aa58d633c$var$AbstractBarSeries {
    constructor(moduleCtx){
        super({
            moduleCtx: moduleCtx,
            directionKeys: $d77b025aa58d633c$var$DEFAULT_CARTESIAN_DIRECTION_KEYS,
            directionNames: $d77b025aa58d633c$var$DEFAULT_CARTESIAN_DIRECTION_NAMES,
            pickModes: [
                0 /* EXACT_SHAPE_MATCH */ 
            ],
            pathsPerSeries: 0,
            hasHighlightedLabels: true,
            datumSelectionGarbageCollection: false,
            animationAlwaysUpdateSelections: true,
            animationResetFns: {
                datum: $d77b025aa58d633c$var$resetBarSelectionsFn,
                label: $d77b025aa58d633c$var$resetLabelFn
            }
        });
        this.properties = new $d77b025aa58d633c$var$BarSeriesProperties();
    }
    processData(dataController) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            var _a, _b, _c;
            if (!this.properties.isValid() || !this.data) return;
            const { seriesGrouping: { groupIndex: groupIndex = this.id } = {}, data: data = [] } = this;
            const { xKey: xKey, yKey: yKey, normalizedTo: normalizedTo } = this.properties;
            const animationEnabled = !this.ctx.animationManager.isSkipped();
            const xScale = (_a = this.getCategoryAxis()) == null ? void 0 : _a.scale;
            const yScale = (_b = this.getValueAxis()) == null ? void 0 : _b.scale;
            const { isContinuousX: isContinuousX, xScaleType: xScaleType, yScaleType: yScaleType } = this.getScaleInformation({
                xScale: xScale,
                yScale: yScale
            });
            const stackGroupName = `bar-stack-${groupIndex}-yValues`;
            const stackGroupTrailingName = `${stackGroupName}-trailing`;
            const extraProps = [];
            if ($d77b025aa58d633c$var$isFiniteNumber(normalizedTo)) extraProps.push($d77b025aa58d633c$var$normaliseGroupTo([
                stackGroupName,
                stackGroupTrailingName
            ], Math.abs(normalizedTo), "range"));
            if (animationEnabled && this.processedData) extraProps.push($d77b025aa58d633c$var$diff(this.processedData));
            if (animationEnabled) extraProps.push($d77b025aa58d633c$var$animationValidation());
            const visibleProps = this.visible ? {} : {
                forceValue: 0
            };
            const { processedData: processedData } = yield this.requestDataModel(dataController, data, {
                props: [
                    $d77b025aa58d633c$var$keyProperty(xKey, xScaleType, {
                        id: "xValue"
                    }),
                    $d77b025aa58d633c$var$valueProperty(yKey, yScaleType, $d77b025aa58d633c$var$__spreadValues({
                        id: `yValue-raw`,
                        invalidValue: null
                    }, visibleProps)),
                    ...$d77b025aa58d633c$var$groupAccumulativeValueProperty(yKey, "normal", "current", $d77b025aa58d633c$var$__spreadValues({
                        id: `yValue-end`,
                        rangeId: `yValue-range`,
                        invalidValue: null,
                        missingValue: 0,
                        groupId: stackGroupName,
                        separateNegative: true
                    }, visibleProps), yScaleType),
                    ...$d77b025aa58d633c$var$groupAccumulativeValueProperty(yKey, "trailing", "current", $d77b025aa58d633c$var$__spreadValues({
                        id: `yValue-start`,
                        invalidValue: null,
                        missingValue: 0,
                        groupId: stackGroupTrailingName,
                        separateNegative: true
                    }, visibleProps), yScaleType),
                    ...isContinuousX ? [
                        $d77b025aa58d633c$var$SMALLEST_KEY_INTERVAL
                    ] : [],
                    ...extraProps
                ],
                groupByKeys: true,
                groupByData: false
            });
            this.smallestDataInterval = (_c = processedData.reduced) == null ? void 0 : _c.smallestKeyInterval;
            this.animationState.transition("updateData");
        });
    }
    getSeriesDomain(direction) {
        var _a;
        const { processedData: processedData, dataModel: dataModel, smallestDataInterval: smallestDataInterval } = this;
        if (!processedData || !dataModel || processedData.data.length === 0) return [];
        const categoryAxis = this.getCategoryAxis();
        const valueAxis = this.getValueAxis();
        const keyDef = dataModel.resolveProcessedDataDefById(this, `xValue`);
        const keys = dataModel.getDomain(this, `xValue`, "key", processedData);
        const yExtent = dataModel.getDomain(this, `yValue-end`, "value", processedData);
        if (direction === this.getCategoryDirection()) {
            if ((keyDef == null ? void 0 : keyDef.def.type) === "key" && keyDef.def.valueType === "category") return keys;
            const scalePadding = $d77b025aa58d633c$var$isFiniteNumber(smallestDataInterval) ? smallestDataInterval * 0.5 : 0;
            const keysExtent = (_a = $d77b025aa58d633c$var$extent(keys)) != null ? _a : [
                NaN,
                NaN
            ];
            const d0 = keysExtent[0] + -scalePadding;
            const d1 = keysExtent[1] + scalePadding;
            return $d77b025aa58d633c$var$fixNumericExtent([
                d0,
                d1
            ], categoryAxis);
        } else if (this.getValueAxis() instanceof $d77b025aa58d633c$var$LogAxis) return $d77b025aa58d633c$var$fixNumericExtent(yExtent, valueAxis);
        else {
            const fixedYExtent = [
                Math.min(0, yExtent[0]),
                Math.max(0, yExtent[1])
            ];
            return $d77b025aa58d633c$var$fixNumericExtent(fixedYExtent, valueAxis);
        }
    }
    createNodeData() {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            const { dataModel: dataModel } = this;
            const xAxis = this.getCategoryAxis();
            const yAxis = this.getValueAxis();
            if (!dataModel || !xAxis || !yAxis || !this.properties.isValid()) return;
            const xScale = xAxis.scale;
            const yScale = yAxis.scale;
            const { xKey: xKey, yKey: yKey, xName: xName, yName: yName, fill: fill, stroke: stroke, strokeWidth: strokeWidth, cornerRadius: cornerRadius, legendItemName: legendItemName, label: label } = this.properties;
            const yReversed = yAxis.isReversed();
            const { barWidth: barWidth, groupIndex: groupIndex } = this.updateGroupScale(xAxis);
            const barOffset = $d77b025aa58d633c$var$ContinuousScale.is(xScale) ? barWidth * -0.5 : 0;
            const xIndex = dataModel.resolveProcessedDataIndexById(this, `xValue`);
            const yRawIndex = dataModel.resolveProcessedDataIndexById(this, `yValue-raw`);
            const yStartIndex = dataModel.resolveProcessedDataIndexById(this, `yValue-start`);
            const yEndIndex = dataModel.resolveProcessedDataIndexById(this, `yValue-end`);
            const yRangeIndex = dataModel.resolveProcessedDataIndexById(this, `yValue-range`);
            const animationEnabled = !this.ctx.animationManager.isSkipped();
            const context = {
                itemId: yKey,
                nodeData: [],
                labelData: [],
                scales: this.calculateScaling(),
                visible: this.visible || animationEnabled
            };
            const { groupScale: groupScale, processedData: processedData } = this;
            processedData == null || processedData.data.forEach(({ keys: keys, datum: seriesDatum, values: values, aggValues: aggValues })=>{
                values.forEach((value, valueIndex)=>{
                    var _a;
                    const xValue = keys[xIndex];
                    const x = xScale.convert(xValue);
                    const currY = +value[yEndIndex];
                    const prevY = +value[yStartIndex];
                    const yRawValue = value[yRawIndex];
                    const isPositive = yRawValue >= 0 && !Object.is(yRawValue, -0);
                    const isUpward = isPositive !== yReversed;
                    const yRange = (_a = aggValues == null ? void 0 : aggValues[yRangeIndex][isPositive ? 1 : 0]) != null ? _a : 0;
                    const barX = x + groupScale.convert(String(groupIndex)) + barOffset;
                    if (isNaN(currY)) return;
                    const y = yScale.convert(currY);
                    const bottomY = yScale.convert(prevY);
                    const barAlongX = this.getBarDirection() === "x" /* X */ ;
                    const bboxHeight = yScale.convert(yRange);
                    const bboxBottom = yScale.convert(0);
                    const rect = {
                        x: barAlongX ? Math.min(y, bottomY) : barX,
                        y: barAlongX ? barX : Math.min(y, bottomY),
                        width: barAlongX ? Math.abs(bottomY - y) : barWidth,
                        height: barAlongX ? barWidth : Math.abs(bottomY - y)
                    };
                    const clipBBox = new $d77b025aa58d633c$var$BBox(rect.x, rect.y, rect.width, rect.height);
                    const barRect = {
                        x: barAlongX ? Math.min(bboxBottom, bboxHeight) : barX,
                        y: barAlongX ? barX : Math.min(bboxBottom, bboxHeight),
                        width: barAlongX ? Math.abs(bboxBottom - bboxHeight) : barWidth,
                        height: barAlongX ? barWidth : Math.abs(bboxBottom - bboxHeight),
                        clipBBox: clipBBox
                    };
                    const { fontStyle: labelFontStyle, fontWeight: labelFontWeight, fontSize: labelFontSize, fontFamily: labelFontFamily, color: labelColor, placement: placement } = label;
                    const labelText = this.getLabelText(this.properties.label, {
                        datum: seriesDatum[valueIndex],
                        value: yRawValue,
                        xKey: xKey,
                        yKey: yKey,
                        xName: xName,
                        yName: yName,
                        legendItemName: legendItemName
                    }, (v)=>$d77b025aa58d633c$var$isFiniteNumber(v) ? v.toFixed(2) : String(v));
                    const labelDatum = labelText ? $d77b025aa58d633c$var$__spreadValues({
                        text: labelText,
                        fill: labelColor,
                        fontStyle: labelFontStyle,
                        fontWeight: labelFontWeight,
                        fontSize: labelFontSize,
                        fontFamily: labelFontFamily
                    }, $d77b025aa58d633c$var$adjustLabelPlacement({
                        isPositive: isPositive,
                        isVertical: !barAlongX,
                        placement: placement,
                        rect: rect
                    })) : void 0;
                    const lengthRatioMultiplier = this.shouldFlipXY() ? rect.height : rect.width;
                    const nodeData = {
                        series: this,
                        itemId: yKey,
                        datum: seriesDatum[valueIndex],
                        valueIndex: valueIndex,
                        cumulativeValue: currY,
                        xValue: xValue,
                        yValue: yRawValue,
                        yKey: yKey,
                        xKey: xKey,
                        capDefaults: {
                            lengthRatioMultiplier: lengthRatioMultiplier,
                            lengthMax: lengthRatioMultiplier
                        },
                        x: barRect.x,
                        y: barRect.y,
                        width: barRect.width,
                        height: barRect.height,
                        midPoint: {
                            x: rect.x + rect.width / 2,
                            y: rect.y + rect.height / 2
                        },
                        fill: fill,
                        stroke: stroke,
                        opacity: 1,
                        strokeWidth: strokeWidth,
                        cornerRadius: cornerRadius,
                        topLeftCornerRadius: barAlongX !== isUpward,
                        topRightCornerRadius: isUpward,
                        bottomRightCornerRadius: barAlongX === isUpward,
                        bottomLeftCornerRadius: !isUpward,
                        clipBBox: clipBBox,
                        label: labelDatum,
                        missing: yRawValue == null
                    };
                    context.nodeData.push(nodeData);
                    context.labelData.push(nodeData);
                });
            });
            return context;
        });
    }
    nodeFactory() {
        return new $d77b025aa58d633c$var$Rect();
    }
    updateDatumSelection(opts) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            return opts.datumSelection.update(opts.nodeData, (rect)=>{
                rect.tag = 0 /* Bar */ ;
            }, (datum)=>$d77b025aa58d633c$var$createDatumId(datum.xValue, datum.valueIndex));
        });
    }
    updateDatumNodes(opts) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            if (!this.properties.isValid()) return;
            const { yKey: yKey, stackGroup: stackGroup, fill: fill, fillOpacity: fillOpacity, stroke: stroke, strokeWidth: strokeWidth, strokeOpacity: strokeOpacity, lineDash: lineDash, lineDashOffset: lineDashOffset, formatter: formatter, shadow: shadow, highlightStyle: { item: itemHighlightStyle } } = this.properties;
            const xAxis = this.axes["x" /* X */ ];
            const crisp = $d77b025aa58d633c$var$checkCrisp(xAxis == null ? void 0 : xAxis.visibleRange);
            const categoryAlongX = this.getCategoryDirection() === "x" /* X */ ;
            opts.datumSelection.each((rect, datum)=>{
                var _a, _b, _c, _d;
                const style = {
                    fill: fill,
                    stroke: stroke,
                    fillOpacity: fillOpacity,
                    strokeOpacity: strokeOpacity,
                    lineDash: lineDash,
                    lineDashOffset: lineDashOffset,
                    fillShadow: shadow,
                    strokeWidth: this.getStrokeWidth(strokeWidth),
                    cornerRadius: datum.cornerRadius,
                    topLeftCornerRadius: datum.topLeftCornerRadius,
                    topRightCornerRadius: datum.topRightCornerRadius,
                    bottomRightCornerRadius: datum.bottomRightCornerRadius,
                    bottomLeftCornerRadius: datum.bottomLeftCornerRadius
                };
                const visible = categoryAlongX ? ((_b = (_a = datum.clipBBox) == null ? void 0 : _a.width) != null ? _b : datum.width) > 0 : ((_d = (_c = datum.clipBBox) == null ? void 0 : _c.height) != null ? _d : datum.height) > 0;
                const config = $d77b025aa58d633c$var$getRectConfig({
                    datum: datum,
                    ctx: this.ctx,
                    seriesId: this.id,
                    isHighlighted: opts.isHighlight,
                    highlightStyle: itemHighlightStyle,
                    yKey: yKey,
                    style: style,
                    formatter: formatter,
                    stackGroup: stackGroup
                });
                config.crisp = crisp;
                config.visible = visible;
                $d77b025aa58d633c$var$updateRect({
                    rect: rect,
                    config: config
                });
            });
        });
    }
    updateLabelSelection(opts) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            const data = this.isLabelEnabled() ? opts.labelData : [];
            return opts.labelSelection.update(data, (text)=>{
                text.tag = 1 /* Label */ ;
                text.pointerEvents = 1 /* None */ ;
            });
        });
    }
    updateLabelNodes(opts) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            opts.labelSelection.each((textNode, datum)=>{
                $d77b025aa58d633c$var$updateLabelNode(textNode, this.properties.label, datum.label);
            });
        });
    }
    getTooltipHtml(nodeDatum) {
        var _a;
        const { id: seriesId, processedData: processedData, ctx: { callbackCache: callbackCache } } = this;
        const xAxis = this.getCategoryAxis();
        const yAxis = this.getValueAxis();
        if (!processedData || !this.properties.isValid() || !xAxis || !yAxis) return $d77b025aa58d633c$var$EMPTY_TOOLTIP_CONTENT;
        const { xKey: xKey, yKey: yKey, xName: xName, yName: yName, fill: fill, stroke: stroke, strokeWidth: strokeWidth, tooltip: tooltip, formatter: formatter, stackGroup: stackGroup, legendItemName: legendItemName } = this.properties;
        const { xValue: xValue, yValue: yValue, datum: datum, itemId: itemId } = nodeDatum;
        const xString = xAxis.formatDatum(xValue);
        const yString = yAxis.formatDatum(yValue);
        const title = $d77b025aa58d633c$var$sanitizeHtml(yName);
        const content = $d77b025aa58d633c$var$sanitizeHtml(xString + ": " + yString);
        let format2;
        if (formatter) format2 = callbackCache.call(formatter, {
            seriesId: seriesId,
            datum: datum,
            xKey: xKey,
            yKey: yKey,
            stackGroup: stackGroup,
            fill: fill,
            stroke: stroke,
            strokeWidth: this.getStrokeWidth(strokeWidth),
            highlighted: false
        });
        const color = (_a = format2 == null ? void 0 : format2.fill) != null ? _a : fill;
        return tooltip.toTooltipHtml({
            title: title,
            content: content,
            backgroundColor: color
        }, $d77b025aa58d633c$var$__spreadValues({
            seriesId: seriesId,
            itemId: itemId,
            datum: datum,
            xKey: xKey,
            yKey: yKey,
            xName: xName,
            yName: yName,
            stackGroup: stackGroup,
            title: title,
            color: color,
            legendItemName: legendItemName
        }, this.getModuleTooltipParams()));
    }
    getLegendData(legendType) {
        var _a, _b;
        const { showInLegend: showInLegend } = this.properties;
        if (legendType !== "category" || !((_a = this.data) == null ? void 0 : _a.length) || !this.properties.isValid() || !showInLegend) return [];
        const { yKey: yKey, yName: yName, fill: fill, stroke: stroke, strokeWidth: strokeWidth, fillOpacity: fillOpacity, strokeOpacity: strokeOpacity, legendItemName: legendItemName, visible: visible } = this.properties;
        return [
            {
                legendType: "category",
                id: this.id,
                itemId: yKey,
                seriesId: this.id,
                enabled: visible,
                label: {
                    text: (_b = legendItemName != null ? legendItemName : yName) != null ? _b : yKey
                },
                marker: {
                    fill: fill,
                    fillOpacity: fillOpacity,
                    stroke: stroke,
                    strokeWidth: strokeWidth,
                    strokeOpacity: strokeOpacity
                },
                legendItemName: legendItemName
            }
        ];
    }
    animateEmptyUpdateReady({ datumSelection: datumSelection, labelSelection: labelSelection, annotationSelections: annotationSelections }) {
        const fns = $d77b025aa58d633c$var$prepareBarAnimationFunctions($d77b025aa58d633c$var$collapsedStartingBarPosition(this.isVertical(), this.axes, "normal"));
        $d77b025aa58d633c$var$fromToMotion(this.id, "nodes", this.ctx.animationManager, [
            datumSelection
        ], fns);
        $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "labels", this.ctx.animationManager, labelSelection);
        $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "annotations", this.ctx.animationManager, ...annotationSelections);
    }
    animateWaitingUpdateReady(data) {
        var _a, _b, _c;
        const { datumSelection: datumSelection, labelSelection: labelSelection, annotationSelections: annotationSelections, previousContextData: previousContextData } = data;
        this.ctx.animationManager.stopByAnimationGroupId(this.id);
        const dataDiff = (_b = (_a = this.processedData) == null ? void 0 : _a.reduced) == null ? void 0 : _b.diff;
        const mode = previousContextData == null ? "fade" : "normal";
        const fns = $d77b025aa58d633c$var$prepareBarAnimationFunctions($d77b025aa58d633c$var$collapsedStartingBarPosition(this.isVertical(), this.axes, mode));
        $d77b025aa58d633c$var$fromToMotion(this.id, "nodes", this.ctx.animationManager, [
            datumSelection
        ], fns, (_, datum)=>$d77b025aa58d633c$var$createDatumId(datum.xValue, datum.valueIndex), dataDiff);
        const hasMotion = (_c = dataDiff == null ? void 0 : dataDiff.changed) != null ? _c : true;
        if (hasMotion) {
            $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "labels", this.ctx.animationManager, labelSelection);
            $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "annotations", this.ctx.animationManager, ...annotationSelections);
        }
    }
    isLabelEnabled() {
        return this.properties.label.enabled;
    }
    computeFocusBounds({ datumIndex: datumIndex, seriesRect: seriesRect }) {
        var _a;
        const datumBox = (_a = this.contextNodeData) == null ? void 0 : _a.nodeData[datumIndex].clipBBox;
        return $d77b025aa58d633c$var$computeBarFocusBounds(datumBox, this.contentGroup, seriesRect);
    }
};
$d77b025aa58d633c$var$BarSeries.className = "BarSeries";
$d77b025aa58d633c$var$BarSeries.type = "bar";
// packages/ag-charts-community/src/chart/series/cartesian/barSeriesModule.ts
var $d77b025aa58d633c$var$BarSeriesModule = {
    type: "series",
    optionsKey: "series[]",
    packageType: "community",
    chartTypes: [
        "cartesian"
    ],
    identifier: "bar",
    instanceConstructor: $d77b025aa58d633c$var$BarSeries,
    stackable: true,
    groupable: true,
    defaultAxes: [
        {
            type: "number" /* NUMBER */ ,
            position: "left" /* LEFT */ 
        },
        {
            type: "category" /* CATEGORY */ ,
            position: "bottom" /* BOTTOM */ 
        }
    ],
    swapDefaultAxesCondition: (series)=>(series == null ? void 0 : series.direction) === "horizontal",
    themeTemplate: {
        series: {
            __extends__: $d77b025aa58d633c$var$EXTENDS_SERIES_DEFAULTS,
            direction: "vertical",
            fillOpacity: 1,
            strokeWidth: 0,
            lineDash: [
                0
            ],
            lineDashOffset: 0,
            label: {
                enabled: false,
                fontWeight: "normal" /* NORMAL */ ,
                fontSize: 12,
                fontFamily: $d77b025aa58d633c$var$DEFAULT_FONT_FAMILY,
                color: $d77b025aa58d633c$var$DEFAULT_INSIDE_SERIES_LABEL_COLOUR,
                placement: "inside"
            },
            shadow: {
                enabled: false,
                color: $d77b025aa58d633c$var$DEFAULT_SHADOW_COLOUR,
                xOffset: 3,
                yOffset: 3,
                blur: 5
            }
        }
    },
    enterpriseThemeTemplate: {
        series: {
            errorBar: {
                cap: {
                    lengthRatio: 0.3
                }
            }
        }
    },
    paletteFactory: $d77b025aa58d633c$var$singleSeriesPaletteFactory
};
// packages/ag-charts-community/src/scale/colorScale.ts
var $d77b025aa58d633c$var$convertColorStringToOklcha = (v)=>{
    const color = $d77b025aa58d633c$var$Color.fromString(v);
    const [l, c, h] = $d77b025aa58d633c$var$Color.RGBtoOKLCH(color.r, color.g, color.b);
    return {
        l: l,
        c: c,
        h: h,
        a: color.a
    };
};
var $d77b025aa58d633c$var$interpolateOklch = (x, y, d)=>{
    d = $d77b025aa58d633c$var$clamp(0, d, 1);
    let h;
    let c;
    if (Number.isNaN(x.h) && Number.isNaN(y.h)) {
        h = 0;
        c = 0;
    } else if (Number.isNaN(x.h)) {
        h = y.h;
        c = y.c;
    } else if (Number.isNaN(y.h)) {
        h = x.h;
        c = x.c;
    } else {
        const xH = x.h;
        let yH = y.h;
        const deltaH = y.h - x.h;
        if (deltaH > 180) yH -= 360;
        else if (deltaH < -180) yH += 360;
        h = xH * (1 - d) + yH * d;
        c = x.c * (1 - d) + y.c * d;
    }
    const l = x.l * (1 - d) + y.l * d;
    const a = x.a * (1 - d) + y.a * d;
    return $d77b025aa58d633c$var$Color.fromOKLCH(l, c, h, a);
};
var $d77b025aa58d633c$var$ColorScale = class {
    constructor(){
        this.type = "color";
        this.invalid = true;
        this.domain = [
            0,
            1
        ];
        this.range = [
            "red",
            "blue"
        ];
        this.parsedRange = this.range.map($d77b025aa58d633c$var$convertColorStringToOklcha);
    }
    update() {
        const { domain: domain, range: range3 } = this;
        if (domain.length < 2) {
            $d77b025aa58d633c$var$Logger.warnOnce("`colorDomain` should have at least 2 values.");
            if (domain.length === 0) domain.push(0, 1);
            else if (domain.length === 1) domain.push(domain[0] + 1);
        }
        for(let i = 1; i < domain.length; i++){
            const a = domain[i - 1];
            const b = domain[i];
            if (a >= b) {
                $d77b025aa58d633c$var$Logger.warnOnce("`colorDomain` values should be supplied in ascending order.");
                domain.sort((a2, b2)=>a2 - b2);
                break;
            }
        }
        if (range3.length < domain.length) for(let i = range3.length; i < domain.length; i++)range3.push(range3.length > 0 ? range3[0] : "black");
        this.parsedRange = this.range.map($d77b025aa58d633c$var$convertColorStringToOklcha);
    }
    convert(x) {
        this.refresh();
        const { domain: domain, range: range3, parsedRange: parsedRange } = this;
        const d0 = domain[0];
        const d1 = domain.at(-1);
        const r0 = range3[0];
        const r1 = range3[range3.length - 1];
        if (x <= d0) return r0;
        if (x >= d1) return r1;
        let index;
        let q;
        if (domain.length === 2) {
            const t = (x - d0) / (d1 - d0);
            const step = 1 / (range3.length - 1);
            index = range3.length <= 2 ? 0 : Math.min(Math.floor(t * (range3.length - 1)), range3.length - 2);
            q = (t - index * step) / step;
        } else {
            for(index = 0; index < domain.length - 2; index++){
                if (x < domain[index + 1]) break;
            }
            const a = domain[index];
            const b = domain[index + 1];
            q = (x - a) / (b - a);
        }
        const c0 = parsedRange[index];
        const c1 = parsedRange[index + 1];
        return $d77b025aa58d633c$var$interpolateOklch(c0, c1, q).toRgbaString();
    }
    refresh() {
        if (!this.invalid) return;
        this.invalid = false;
        this.update();
        if (this.invalid) $d77b025aa58d633c$var$Logger.warnOnce("Expected update to not invalidate scale");
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Invalidating
], $d77b025aa58d633c$var$ColorScale.prototype, "domain", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Invalidating
], $d77b025aa58d633c$var$ColorScale.prototype, "range", 2);
// packages/ag-charts-community/src/chart/series/cartesian/bubbleSeriesProperties.ts
var $d77b025aa58d633c$var$BubbleSeriesMarker = class extends $d77b025aa58d633c$var$SeriesMarker {
    constructor(){
        super(...arguments);
        this.maxSize = 30;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER),
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 3 /* MAJOR */ 
    })
], $d77b025aa58d633c$var$BubbleSeriesMarker.prototype, "maxSize", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$NUMBER_ARRAY, {
        optional: true
    }),
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 3 /* MAJOR */ 
    })
], $d77b025aa58d633c$var$BubbleSeriesMarker.prototype, "domain", 2);
var $d77b025aa58d633c$var$BubbleSeriesLabel = class extends $d77b025aa58d633c$var$Label {
    constructor(){
        super(...arguments);
        this.placement = "top";
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$LABEL_PLACEMENT)
], $d77b025aa58d633c$var$BubbleSeriesLabel.prototype, "placement", 2);
var $d77b025aa58d633c$var$BubbleSeriesProperties = class extends $d77b025aa58d633c$var$CartesianSeriesProperties {
    constructor(){
        super(...arguments);
        this.colorRange = [
            "#ffff00",
            "#00ff00",
            "#0000ff"
        ];
        this.marker = new $d77b025aa58d633c$var$BubbleSeriesMarker();
        this.label = new $d77b025aa58d633c$var$BubbleSeriesLabel();
        this.tooltip = new $d77b025aa58d633c$var$SeriesTooltip();
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING)
], $d77b025aa58d633c$var$BubbleSeriesProperties.prototype, "xKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING)
], $d77b025aa58d633c$var$BubbleSeriesProperties.prototype, "yKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING)
], $d77b025aa58d633c$var$BubbleSeriesProperties.prototype, "sizeKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$BubbleSeriesProperties.prototype, "labelKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$BubbleSeriesProperties.prototype, "colorKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$BubbleSeriesProperties.prototype, "xName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$BubbleSeriesProperties.prototype, "yName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$BubbleSeriesProperties.prototype, "sizeName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$BubbleSeriesProperties.prototype, "labelName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$BubbleSeriesProperties.prototype, "colorName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$NUMBER_ARRAY, {
        optional: true
    })
], $d77b025aa58d633c$var$BubbleSeriesProperties.prototype, "colorDomain", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$COLOR_STRING_ARRAY)
], $d77b025aa58d633c$var$BubbleSeriesProperties.prototype, "colorRange", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$BubbleSeriesProperties.prototype, "title", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$BubbleSeriesProperties.prototype, "marker", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$BubbleSeriesProperties.prototype, "label", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$BubbleSeriesProperties.prototype, "tooltip", 2);
// packages/ag-charts-community/src/chart/series/cartesian/bubbleSeries.ts
var $d77b025aa58d633c$var$BubbleSeriesNodeEvent = class extends $d77b025aa58d633c$var$CartesianSeriesNodeEvent {
    constructor(type, nativeEvent, datum, series){
        super(type, nativeEvent, datum, series);
        this.sizeKey = series.properties.sizeKey;
    }
};
var $d77b025aa58d633c$var$BubbleSeries = class extends $d77b025aa58d633c$var$CartesianSeries {
    constructor(moduleCtx){
        super({
            moduleCtx: moduleCtx,
            directionKeys: $d77b025aa58d633c$var$DEFAULT_CARTESIAN_DIRECTION_KEYS,
            directionNames: $d77b025aa58d633c$var$DEFAULT_CARTESIAN_DIRECTION_NAMES,
            pickModes: [
                2 /* NEAREST_BY_MAIN_CATEGORY_AXIS_FIRST */ ,
                3 /* NEAREST_NODE */ ,
                0 /* EXACT_SHAPE_MATCH */ 
            ],
            pathsPerSeries: 0,
            hasMarkers: true,
            markerSelectionGarbageCollection: false,
            animationResetFns: {
                label: $d77b025aa58d633c$var$resetLabelFn,
                marker: $d77b025aa58d633c$var$resetMarkerFn
            }
        });
        this.NodeEvent = $d77b025aa58d633c$var$BubbleSeriesNodeEvent;
        this.properties = new $d77b025aa58d633c$var$BubbleSeriesProperties();
        this.sizeScale = new $d77b025aa58d633c$var$LinearScale();
        this.colorScale = new $d77b025aa58d633c$var$ColorScale();
    }
    processData(dataController) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            var _a, _b, _c, _d;
            if (!this.properties.isValid() || this.data == null || !this.visible) return;
            const xScale = (_a = this.axes["x" /* X */ ]) == null ? void 0 : _a.scale;
            const yScale = (_b = this.axes["y" /* Y */ ]) == null ? void 0 : _b.scale;
            const { xScaleType: xScaleType, yScaleType: yScaleType } = this.getScaleInformation({
                xScale: xScale,
                yScale: yScale
            });
            const colorScaleType = this.colorScale.type;
            const sizeScaleType = this.sizeScale.type;
            const { xKey: xKey, yKey: yKey, sizeKey: sizeKey, labelKey: labelKey, colorDomain: colorDomain, colorRange: colorRange, colorKey: colorKey, marker: marker } = this.properties;
            const { dataModel: dataModel, processedData: processedData } = yield this.requestDataModel(dataController, this.data, {
                props: [
                    $d77b025aa58d633c$var$keyProperty(xKey, xScaleType, {
                        id: "xKey-raw"
                    }),
                    $d77b025aa58d633c$var$keyProperty(yKey, yScaleType, {
                        id: "yKey-raw"
                    }),
                    ...labelKey ? [
                        $d77b025aa58d633c$var$keyProperty(labelKey, "band", {
                            id: `labelKey-raw`
                        })
                    ] : [],
                    $d77b025aa58d633c$var$valueProperty(xKey, xScaleType, {
                        id: `xValue`
                    }),
                    $d77b025aa58d633c$var$valueProperty(yKey, yScaleType, {
                        id: `yValue`
                    }),
                    $d77b025aa58d633c$var$valueProperty(sizeKey, sizeScaleType, {
                        id: `sizeValue`
                    }),
                    ...colorKey ? [
                        $d77b025aa58d633c$var$valueProperty(colorKey, colorScaleType, {
                            id: `colorValue`
                        })
                    ] : [],
                    ...labelKey ? [
                        $d77b025aa58d633c$var$valueProperty(labelKey, "band", {
                            id: `labelValue`
                        })
                    ] : []
                ]
            });
            const sizeKeyIdx = dataModel.resolveProcessedDataIndexById(this, `sizeValue`);
            const processedSize = (_c = processedData.domain.values[sizeKeyIdx]) != null ? _c : [];
            this.sizeScale.domain = marker.domain ? marker.domain : processedSize;
            if (colorKey) {
                const colorKeyIdx = dataModel.resolveProcessedDataIndexById(this, `colorValue`);
                this.colorScale.domain = (_d = colorDomain != null ? colorDomain : processedData.domain.values[colorKeyIdx]) != null ? _d : [];
                this.colorScale.range = colorRange;
                this.colorScale.update();
            }
            this.animationState.transition("updateData");
        });
    }
    getSeriesDomain(direction) {
        const { dataModel: dataModel, processedData: processedData } = this;
        if (!processedData || !dataModel) return [];
        const id = direction === "x" /* X */  ? `xValue` : `yValue`;
        const dataDef = dataModel.resolveProcessedDataDefById(this, id);
        const domain = dataModel.getDomain(this, id, "value", processedData);
        if ((dataDef == null ? void 0 : dataDef.def.type) === "value" && (dataDef == null ? void 0 : dataDef.def.valueType) === "category") return domain;
        const axis = this.axes[direction];
        return $d77b025aa58d633c$var$fixNumericExtent($d77b025aa58d633c$var$extent(domain), axis);
    }
    createNodeData() {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            var _a, _b, _c;
            const { axes: axes, dataModel: dataModel, processedData: processedData, colorScale: colorScale, sizeScale: sizeScale } = this;
            const { xKey: xKey, yKey: yKey, sizeKey: sizeKey, labelKey: labelKey, xName: xName, yName: yName, sizeName: sizeName, labelName: labelName, label: label, colorKey: colorKey, marker: marker, visible: visible } = this.properties;
            const markerShape = $d77b025aa58d633c$var$getMarker(marker.shape);
            const { placement: placement } = label;
            const xAxis = axes["x" /* X */ ];
            const yAxis = axes["y" /* Y */ ];
            if (!(dataModel && processedData && visible && xAxis && yAxis)) return;
            const xDataIdx = dataModel.resolveProcessedDataIndexById(this, `xValue`);
            const yDataIdx = dataModel.resolveProcessedDataIndexById(this, `yValue`);
            const sizeDataIdx = sizeKey ? dataModel.resolveProcessedDataIndexById(this, `sizeValue`) : -1;
            const colorDataIdx = colorKey ? dataModel.resolveProcessedDataIndexById(this, `colorValue`) : -1;
            const labelDataIdx = labelKey ? dataModel.resolveProcessedDataIndexById(this, `labelValue`) : -1;
            const xScale = xAxis.scale;
            const yScale = yAxis.scale;
            const xOffset = ((_a = xScale.bandwidth) != null ? _a : 0) / 2;
            const yOffset = ((_b = yScale.bandwidth) != null ? _b : 0) / 2;
            const nodeData = [];
            sizeScale.range = [
                marker.size,
                marker.maxSize
            ];
            const font = label.getFont();
            for (const { values: values, datum: datum } of (_c = processedData.data) != null ? _c : []){
                const xDatum = values[xDataIdx];
                const yDatum = values[yDataIdx];
                const x = xScale.convert(xDatum) + xOffset;
                const y = yScale.convert(yDatum) + yOffset;
                const labelText = this.getLabelText(label, {
                    value: labelKey ? values[labelDataIdx] : yDatum,
                    datum: datum,
                    xKey: xKey,
                    yKey: yKey,
                    sizeKey: sizeKey,
                    labelKey: labelKey,
                    xName: xName,
                    yName: yName,
                    sizeName: sizeName,
                    labelName: labelName
                });
                const size = $d77b025aa58d633c$var$Text.getTextSize(String(labelText), font);
                const markerSize = sizeKey ? sizeScale.convert(values[sizeDataIdx]) : marker.size;
                const fill = colorKey ? colorScale.convert(values[colorDataIdx]) : void 0;
                nodeData.push({
                    series: this,
                    itemId: yKey,
                    yKey: yKey,
                    xKey: xKey,
                    datum: datum,
                    xValue: xDatum,
                    yValue: yDatum,
                    sizeValue: values[sizeDataIdx],
                    point: {
                        x: x,
                        y: y,
                        size: markerSize
                    },
                    midPoint: {
                        x: x,
                        y: y
                    },
                    fill: fill,
                    label: $d77b025aa58d633c$var$__spreadValues({
                        text: labelText
                    }, size),
                    marker: markerShape,
                    placement: placement
                });
            }
            return {
                itemId: yKey,
                nodeData: nodeData,
                labelData: nodeData,
                scales: this.calculateScaling(),
                visible: this.visible
            };
        });
    }
    isPathOrSelectionDirty() {
        return this.properties.marker.isDirty();
    }
    getLabelData() {
        var _a, _b;
        return (_b = (_a = this.contextNodeData) == null ? void 0 : _a.labelData) != null ? _b : [];
    }
    markerFactory() {
        const { shape: shape } = this.properties.marker;
        const MarkerShape = $d77b025aa58d633c$var$getMarker(shape);
        return new MarkerShape();
    }
    updateMarkerSelection(opts) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            const { nodeData: nodeData, markerSelection: markerSelection } = opts;
            if (this.properties.marker.isDirty()) {
                markerSelection.clear();
                markerSelection.cleanup();
            }
            const data = this.properties.marker.enabled ? nodeData : [];
            return markerSelection.update(data, void 0, (datum)=>$d77b025aa58d633c$var$createDatumId([
                    datum.xValue,
                    datum.yValue,
                    datum.label.text
                ]));
        });
    }
    updateMarkerNodes(opts) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            const { markerSelection: markerSelection, isHighlight: highlighted } = opts;
            const { xKey: xKey, yKey: yKey, sizeKey: sizeKey, labelKey: labelKey, marker: marker } = this.properties;
            const baseStyle = $d77b025aa58d633c$var$mergeDefaults(highlighted && this.properties.highlightStyle.item, marker.getStyle());
            this.sizeScale.range = [
                marker.size,
                marker.maxSize
            ];
            markerSelection.each((node, datum)=>{
                this.updateMarkerStyle(node, marker, {
                    datum: datum,
                    highlighted: highlighted,
                    xKey: xKey,
                    yKey: yKey,
                    sizeKey: sizeKey,
                    labelKey: labelKey
                }, baseStyle);
            });
            if (!highlighted) this.properties.marker.markClean();
        });
    }
    updateLabelSelection(opts) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            var _a, _b;
            const placedLabels = this.properties.label.enabled ? (_b = (_a = this.chart) == null ? void 0 : _a.placeLabels().get(this)) != null ? _b : [] : [];
            return opts.labelSelection.update(placedLabels.map((v)=>$d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, v.datum), {
                    point: {
                        x: v.x,
                        y: v.y,
                        size: v.datum.point.size
                    }
                })));
        });
    }
    updateLabelNodes(opts) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            const { label: label } = this.properties;
            opts.labelSelection.each((text, datum)=>{
                var _a, _b, _c, _d;
                text.text = datum.label.text;
                text.fill = label.color;
                text.x = (_b = (_a = datum.point) == null ? void 0 : _a.x) != null ? _b : 0;
                text.y = (_d = (_c = datum.point) == null ? void 0 : _c.y) != null ? _d : 0;
                text.fontStyle = label.fontStyle;
                text.fontWeight = label.fontWeight;
                text.fontSize = label.fontSize;
                text.fontFamily = label.fontFamily;
                text.textAlign = "left";
                text.textBaseline = "top";
            });
        });
    }
    getTooltipHtml(nodeDatum) {
        var _a;
        const xAxis = this.axes["x" /* X */ ];
        const yAxis = this.axes["y" /* Y */ ];
        if (!this.properties.isValid() || !xAxis || !yAxis) return $d77b025aa58d633c$var$EMPTY_TOOLTIP_CONTENT;
        const { xKey: xKey, yKey: yKey, sizeKey: sizeKey, labelKey: labelKey, xName: xName, yName: yName, sizeName: sizeName, labelName: labelName, marker: marker, tooltip: tooltip } = this.properties;
        const title = (_a = this.properties.title) != null ? _a : yName;
        const baseStyle = $d77b025aa58d633c$var$mergeDefaults({
            fill: nodeDatum.fill,
            strokeWidth: this.getStrokeWidth(marker.strokeWidth)
        }, marker.getStyle());
        const { fill: color = "gray" } = this.getMarkerStyle(marker, {
            datum: nodeDatum,
            highlighted: false,
            xKey: xKey,
            yKey: yKey,
            sizeKey: sizeKey,
            labelKey: labelKey
        }, baseStyle);
        const { datum: datum, xValue: xValue, yValue: yValue, sizeValue: sizeValue, label: { text: labelText }, itemId: itemId } = nodeDatum;
        const xString = $d77b025aa58d633c$var$sanitizeHtml(xAxis.formatDatum(xValue));
        const yString = $d77b025aa58d633c$var$sanitizeHtml(yAxis.formatDatum(yValue));
        let content = `<b>${$d77b025aa58d633c$var$sanitizeHtml(xName != null ? xName : xKey)}</b>: ${xString}<br><b>${$d77b025aa58d633c$var$sanitizeHtml(yName != null ? yName : yKey)}</b>: ${yString}`;
        if (sizeKey) content += `<br><b>${$d77b025aa58d633c$var$sanitizeHtml(sizeName != null ? sizeName : sizeKey)}</b>: ${$d77b025aa58d633c$var$sanitizeHtml(String(sizeValue))}`;
        if (labelKey) content = `<b>${$d77b025aa58d633c$var$sanitizeHtml(labelName != null ? labelName : labelKey)}</b>: ${$d77b025aa58d633c$var$sanitizeHtml(labelText)}<br>` + content;
        return tooltip.toTooltipHtml({
            title: title,
            content: content,
            backgroundColor: color
        }, {
            datum: datum,
            itemId: itemId,
            xKey: xKey,
            xName: xName,
            yKey: yKey,
            yName: yName,
            sizeKey: sizeKey,
            sizeName: sizeName,
            labelKey: labelKey,
            labelName: labelName,
            title: title,
            color: color,
            seriesId: this.id
        });
    }
    getLegendData() {
        var _a, _b;
        if (!((_a = this.data) == null ? void 0 : _a.length) || !this.properties.isValid()) return [];
        const { yKey: yKey, yName: yName, title: title, marker: marker, visible: visible } = this.properties;
        const { shape: shape, fill: fill, stroke: stroke, fillOpacity: fillOpacity, strokeOpacity: strokeOpacity, strokeWidth: strokeWidth } = marker;
        return [
            {
                legendType: "category",
                id: this.id,
                itemId: yKey,
                seriesId: this.id,
                enabled: visible,
                label: {
                    text: (_b = title != null ? title : yName) != null ? _b : yKey
                },
                marker: {
                    shape: shape,
                    fill: fill != null ? fill : "rgba(0, 0, 0, 0)",
                    stroke: stroke != null ? stroke : "rgba(0, 0, 0, 0)",
                    fillOpacity: fillOpacity != null ? fillOpacity : 1,
                    strokeOpacity: strokeOpacity != null ? strokeOpacity : 1,
                    strokeWidth: strokeWidth != null ? strokeWidth : 0
                }
            }
        ];
    }
    animateEmptyUpdateReady({ markerSelection: markerSelection, labelSelection: labelSelection }) {
        $d77b025aa58d633c$var$markerScaleInAnimation(this, this.ctx.animationManager, markerSelection);
        $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "labels", this.ctx.animationManager, labelSelection);
    }
    isLabelEnabled() {
        return this.properties.label.enabled;
    }
    nodeFactory() {
        return new $d77b025aa58d633c$var$Group();
    }
    getFormattedMarkerStyle(datum) {
        const { xKey: xKey, yKey: yKey, sizeKey: sizeKey, labelKey: labelKey } = this.properties;
        return this.getMarkerStyle(this.properties.marker, {
            datum: datum,
            xKey: xKey,
            yKey: yKey,
            sizeKey: sizeKey,
            labelKey: labelKey,
            highlighted: false
        });
    }
    computeFocusBounds(opts) {
        return $d77b025aa58d633c$var$computeMarkerFocusBounds(this, opts);
    }
};
$d77b025aa58d633c$var$BubbleSeries.className = "BubbleSeries";
$d77b025aa58d633c$var$BubbleSeries.type = "bubble";
// packages/ag-charts-community/src/chart/series/cartesian/bubbleSeriesModule.ts
var $d77b025aa58d633c$var$BubbleSeriesModule = {
    type: "series",
    optionsKey: "series[]",
    packageType: "community",
    chartTypes: [
        "cartesian"
    ],
    identifier: "bubble",
    instanceConstructor: $d77b025aa58d633c$var$BubbleSeries,
    defaultAxes: [
        {
            type: "number" /* NUMBER */ ,
            position: "bottom" /* BOTTOM */ 
        },
        {
            type: "number" /* NUMBER */ ,
            position: "left" /* LEFT */ 
        }
    ],
    themeTemplate: {
        series: {
            __extends__: $d77b025aa58d633c$var$EXTENDS_SERIES_DEFAULTS,
            tooltip: {
                position: {
                    type: "node"
                }
            },
            marker: {
                __extends__: $d77b025aa58d633c$var$EXTENDS_CARTESIAN_MARKER_DEFAULTS,
                maxSize: 30,
                fillOpacity: 0.8
            },
            label: {
                enabled: false,
                fontSize: 12,
                fontFamily: $d77b025aa58d633c$var$DEFAULT_FONT_FAMILY,
                color: $d77b025aa58d633c$var$DEFAULT_LABEL_COLOUR
            }
        }
    },
    paletteFactory: $d77b025aa58d633c$var$markerPaletteFactory
};
// packages/ag-charts-community/src/chart/series/cartesian/histogramSeriesProperties.ts
var $d77b025aa58d633c$var$HistogramSeriesProperties = class extends $d77b025aa58d633c$var$CartesianSeriesProperties {
    constructor(){
        super(...arguments);
        this.fillOpacity = 1;
        this.strokeWidth = 1;
        this.strokeOpacity = 1;
        this.lineDash = [
            0
        ];
        this.lineDashOffset = 0;
        this.cornerRadius = 0;
        this.areaPlot = false;
        this.aggregation = "sum";
        this.shadow = new $d77b025aa58d633c$var$DropShadow();
        this.label = new $d77b025aa58d633c$var$Label();
        this.tooltip = new $d77b025aa58d633c$var$SeriesTooltip();
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING)
], $d77b025aa58d633c$var$HistogramSeriesProperties.prototype, "xKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$HistogramSeriesProperties.prototype, "yKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$HistogramSeriesProperties.prototype, "xName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$HistogramSeriesProperties.prototype, "yName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$COLOR_STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$HistogramSeriesProperties.prototype, "fill", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$RATIO)
], $d77b025aa58d633c$var$HistogramSeriesProperties.prototype, "fillOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$COLOR_STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$HistogramSeriesProperties.prototype, "stroke", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$HistogramSeriesProperties.prototype, "strokeWidth", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$RATIO)
], $d77b025aa58d633c$var$HistogramSeriesProperties.prototype, "strokeOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$LINE_DASH)
], $d77b025aa58d633c$var$HistogramSeriesProperties.prototype, "lineDash", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$HistogramSeriesProperties.prototype, "lineDashOffset", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$HistogramSeriesProperties.prototype, "cornerRadius", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN)
], $d77b025aa58d633c$var$HistogramSeriesProperties.prototype, "areaPlot", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$ARRAY, {
        optional: true
    })
], $d77b025aa58d633c$var$HistogramSeriesProperties.prototype, "bins", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$UNION([
        "count",
        "sum",
        "mean"
    ], "a histogram aggregation"))
], $d77b025aa58d633c$var$HistogramSeriesProperties.prototype, "aggregation", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER, {
        optional: true
    })
], $d77b025aa58d633c$var$HistogramSeriesProperties.prototype, "binCount", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$HistogramSeriesProperties.prototype, "shadow", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$HistogramSeriesProperties.prototype, "label", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$HistogramSeriesProperties.prototype, "tooltip", 2);
// packages/ag-charts-community/src/chart/series/cartesian/histogramSeries.ts
var $d77b025aa58d633c$var$defaultBinCount = 10;
var $d77b025aa58d633c$var$HistogramSeries = class extends $d77b025aa58d633c$var$CartesianSeries {
    constructor(moduleCtx){
        super({
            moduleCtx: moduleCtx,
            directionKeys: $d77b025aa58d633c$var$DEFAULT_CARTESIAN_DIRECTION_KEYS,
            directionNames: $d77b025aa58d633c$var$DEFAULT_CARTESIAN_DIRECTION_NAMES,
            pickModes: [
                0 /* EXACT_SHAPE_MATCH */ 
            ],
            datumSelectionGarbageCollection: false,
            animationResetFns: {
                datum: $d77b025aa58d633c$var$resetBarSelectionsFn,
                label: $d77b025aa58d633c$var$resetLabelFn
            }
        });
        this.properties = new $d77b025aa58d633c$var$HistogramSeriesProperties();
        this.calculatedBins = [];
    }
    // During processData phase, used to unify different ways of the user specifying
    // the bins. Returns bins in format[[min1, max1], [min2, max2], ... ].
    deriveBins(xDomain) {
        const binStarts = $d77b025aa58d633c$var$ticks_default(xDomain[0], xDomain[1], $d77b025aa58d633c$var$defaultBinCount);
        const binSize = $d77b025aa58d633c$var$tickStep(xDomain[0], xDomain[1], $d77b025aa58d633c$var$defaultBinCount);
        const [firstBinEnd] = binStarts;
        const expandStartToBin = (n)=>[
                n,
                n + binSize
            ];
        return [
            [
                firstBinEnd - binSize,
                firstBinEnd
            ],
            ...binStarts.map(expandStartToBin)
        ];
    }
    calculateNiceBins(domain, binCount) {
        const startGuess = Math.floor(domain[0]);
        const stop = domain[1];
        const segments = binCount || 1;
        const { start: start, binSize: binSize } = this.calculateNiceStart(startGuess, stop, segments);
        return this.getBins(start, stop, binSize, segments);
    }
    getBins(start, stop, step, count) {
        const bins = [];
        const precision = this.calculatePrecision(step);
        for(let i = 0; i < count; i++){
            const a = Math.round((start + i * step) * precision) / precision;
            let b = Math.round((start + (i + 1) * step) * precision) / precision;
            if (i === count - 1) b = Math.max(b, stop);
            bins[i] = [
                a,
                b
            ];
        }
        return bins;
    }
    calculatePrecision(step) {
        let precision = 10;
        if (isFinite(step) && step > 0) while(step < 1){
            precision *= 10;
            step *= 10;
        }
        return precision;
    }
    calculateNiceStart(a, b, segments) {
        const binSize = Math.abs(b - a) / segments;
        const order = Math.floor(Math.log10(binSize));
        const magnitude = Math.pow(10, order);
        const start = Math.floor(a / magnitude) * magnitude;
        return {
            start: start,
            binSize: binSize
        };
    }
    processData(dataController) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            var _a, _b;
            if (!this.visible) {
                this.processedData = void 0;
                this.animationState.transition("updateData");
            }
            const { xKey: xKey, yKey: yKey, areaPlot: areaPlot, aggregation: aggregation } = this.properties;
            const xScale = (_a = this.axes["x" /* X */ ]) == null ? void 0 : _a.scale;
            const yScale = (_b = this.axes["y" /* Y */ ]) == null ? void 0 : _b.scale;
            const { xScaleType: xScaleType, yScaleType: yScaleType } = this.getScaleInformation({
                yScale: yScale,
                xScale: xScale
            });
            const props = [
                $d77b025aa58d633c$var$keyProperty(xKey, xScaleType),
                $d77b025aa58d633c$var$SORT_DOMAIN_GROUPS
            ];
            if (yKey) {
                let aggProp = $d77b025aa58d633c$var$groupCount("groupAgg");
                if (aggregation === "count") ;
                else if (aggregation === "sum") aggProp = $d77b025aa58d633c$var$groupSum("groupAgg");
                else if (aggregation === "mean") aggProp = $d77b025aa58d633c$var$groupAverage("groupAgg");
                if (areaPlot) aggProp = $d77b025aa58d633c$var$area("groupAgg", aggProp);
                props.push($d77b025aa58d633c$var$valueProperty(yKey, yScaleType, {
                    invalidValue: void 0
                }), aggProp);
            } else {
                let aggProp = $d77b025aa58d633c$var$groupCount("groupAgg");
                if (areaPlot) aggProp = $d77b025aa58d633c$var$area("groupAgg", aggProp);
                props.push(aggProp);
            }
            const groupByFn = (dataSet)=>{
                var _a2;
                const xExtent = $d77b025aa58d633c$var$fixNumericExtent(dataSet.domain.keys[0]);
                if (xExtent.length === 0) {
                    dataSet.domain.groups = [];
                    return ()=>[];
                }
                const bins = $d77b025aa58d633c$var$isNumber(this.properties.binCount) ? this.calculateNiceBins(xExtent, this.properties.binCount) : (_a2 = this.properties.bins) != null ? _a2 : this.deriveBins(xExtent);
                const binCount = bins.length;
                this.calculatedBins = [
                    ...bins
                ];
                return (item)=>{
                    const xValue = item.keys[0];
                    for(let i = 0; i < binCount; i++){
                        const nextBin = bins[i];
                        if (xValue >= nextBin[0] && xValue < nextBin[1]) return nextBin;
                        if (i === binCount - 1 && xValue <= nextBin[1]) return nextBin;
                    }
                    return [];
                };
            };
            if (!this.ctx.animationManager.isSkipped() && this.processedData) props.push($d77b025aa58d633c$var$diff(this.processedData, false));
            yield this.requestDataModel(dataController, this.data, {
                props: props,
                groupByFn: groupByFn
            });
            this.animationState.transition("updateData");
        });
    }
    getSeriesDomain(direction) {
        var _a, _b, _c, _d;
        const { processedData: processedData, dataModel: dataModel } = this;
        if (!processedData || !dataModel || !this.calculatedBins.length) return [];
        const yDomain = dataModel.getDomain(this, `groupAgg`, "aggregate", processedData);
        const xDomainMin = (_a = this.calculatedBins) == null ? void 0 : _a[0][0];
        const xDomainMax = (_d = this.calculatedBins) == null ? void 0 : _d[((_c = (_b = this.calculatedBins) == null ? void 0 : _b.length) != null ? _c : 0) - 1][1];
        if (direction === "x" /* X */ ) return $d77b025aa58d633c$var$fixNumericExtent([
            xDomainMin,
            xDomainMax
        ]);
        return $d77b025aa58d633c$var$fixNumericExtent(yDomain);
    }
    createNodeData() {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            var _a;
            const { id: seriesId, axes: axes, processedData: processedData, ctx: { callbackCache: callbackCache } } = this;
            const xAxis = axes["x" /* X */ ];
            const yAxis = axes["y" /* Y */ ];
            if (!xAxis || !yAxis) return;
            const { scale: xScale } = xAxis;
            const { scale: yScale } = yAxis;
            const { xKey: xKey, yKey: yKey, xName: xName, yName: yName, fill: fill, stroke: stroke, strokeWidth: strokeWidth, cornerRadius: cornerRadius } = this.properties;
            const { formatter: labelFormatter = (params)=>String(params.value), fontStyle: labelFontStyle, fontWeight: labelFontWeight, fontSize: labelFontSize, fontFamily: labelFontFamily, color: labelColor } = this.properties.label;
            const nodeData = [];
            const context = {
                itemId: (_a = this.properties.yKey) != null ? _a : this.id,
                nodeData: nodeData,
                labelData: nodeData,
                scales: this.calculateScaling(),
                animationValid: true,
                visible: this.visible
            };
            if (!this.visible || !processedData || processedData.type !== "grouped") return context;
            processedData.data.forEach((group2)=>{
                var _a2;
                const { aggValues: [[negativeAgg, positiveAgg]] = [
                    [
                        0,
                        0
                    ]
                ], datum: datum, datum: { length: frequency }, keys: domain, keys: [xDomainMin, xDomainMax] } = group2;
                const xMinPx = xScale.convert(xDomainMin);
                const xMaxPx = xScale.convert(xDomainMax);
                const total = negativeAgg + positiveAgg;
                const yZeroPx = yScale.convert(0);
                const yMaxPx = yScale.convert(total);
                const w = Math.abs(xMaxPx - xMinPx);
                const h = Math.abs(yMaxPx - yZeroPx);
                const x = Math.min(xMinPx, xMaxPx);
                const y = Math.min(yZeroPx, yMaxPx);
                let selectionDatumLabel = void 0;
                if (total !== 0) selectionDatumLabel = {
                    text: (_a2 = callbackCache.call(labelFormatter, {
                        value: total,
                        datum: datum,
                        seriesId: seriesId,
                        xKey: xKey,
                        yKey: yKey,
                        xName: xName,
                        yName: yName
                    })) != null ? _a2 : String(total),
                    fontStyle: labelFontStyle,
                    fontWeight: labelFontWeight,
                    fontSize: labelFontSize,
                    fontFamily: labelFontFamily,
                    fill: labelColor,
                    x: x + w / 2,
                    y: y + h / 2
                };
                const nodeMidPoint = {
                    x: x + w / 2,
                    y: y + h / 2
                };
                const yAxisReversed = yAxis.isReversed();
                nodeData.push({
                    series: this,
                    datum: datum,
                    // required by SeriesNodeDatum, but might not make sense here
                    // since each selection is an aggregation of multiple data.
                    aggregatedValue: total,
                    frequency: frequency,
                    domain: domain,
                    yKey: yKey,
                    xKey: xKey,
                    x: x,
                    y: y,
                    xValue: xMinPx,
                    yValue: yMaxPx,
                    width: w,
                    height: h,
                    midPoint: nodeMidPoint,
                    fill: fill,
                    stroke: stroke,
                    cornerRadius: cornerRadius,
                    topLeftCornerRadius: !yAxisReversed,
                    topRightCornerRadius: !yAxisReversed,
                    bottomRightCornerRadius: yAxisReversed,
                    bottomLeftCornerRadius: yAxisReversed,
                    opacity: 1,
                    strokeWidth: strokeWidth,
                    label: selectionDatumLabel
                });
            });
            nodeData.sort((a, b)=>a.x - b.x);
            return context;
        });
    }
    nodeFactory() {
        return new $d77b025aa58d633c$var$Rect();
    }
    updateDatumSelection(opts) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            const { nodeData: nodeData, datumSelection: datumSelection } = opts;
            return datumSelection.update(nodeData, (rect)=>{
                rect.tag = 0 /* Bin */ ;
                rect.crisp = true;
            }, (datum)=>datum.domain.join("_"));
        });
    }
    updateDatumNodes(opts) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            const { isHighlight: isDatumHighlighted } = opts;
            const { fillOpacity: seriesFillOpacity, strokeOpacity: strokeOpacity, lineDash: lineDash, lineDashOffset: lineDashOffset, shadow: shadow, highlightStyle: { item: { fill: highlightedFill, fillOpacity: highlightFillOpacity = seriesFillOpacity, stroke: highlightedStroke, strokeWidth: highlightedDatumStrokeWidth } } } = this.properties;
            opts.datumSelection.each((rect, datum, index)=>{
                var _a, _b;
                const { cornerRadius: cornerRadius, topLeftCornerRadius: topLeftCornerRadius, topRightCornerRadius: topRightCornerRadius, bottomRightCornerRadius: bottomRightCornerRadius, bottomLeftCornerRadius: bottomLeftCornerRadius } = datum;
                const strokeWidth = isDatumHighlighted && highlightedDatumStrokeWidth !== void 0 ? highlightedDatumStrokeWidth : datum.strokeWidth;
                const fillOpacity = isDatumHighlighted ? highlightFillOpacity : seriesFillOpacity;
                rect.fill = (_a = isDatumHighlighted ? highlightedFill : void 0) != null ? _a : datum.fill;
                rect.stroke = (_b = isDatumHighlighted ? highlightedStroke : void 0) != null ? _b : datum.stroke;
                rect.fillOpacity = fillOpacity;
                rect.strokeOpacity = strokeOpacity;
                rect.strokeWidth = strokeWidth;
                rect.lineDash = lineDash;
                rect.lineDashOffset = lineDashOffset;
                rect.topLeftCornerRadius = topLeftCornerRadius ? cornerRadius : 0;
                rect.topRightCornerRadius = topRightCornerRadius ? cornerRadius : 0;
                rect.bottomRightCornerRadius = bottomRightCornerRadius ? cornerRadius : 0;
                rect.bottomLeftCornerRadius = bottomLeftCornerRadius ? cornerRadius : 0;
                rect.fillShadow = shadow;
                rect.zIndex = isDatumHighlighted ? $d77b025aa58d633c$var$Series.highlightedZIndex : index;
                rect.visible = datum.height > 0;
            });
        });
    }
    updateLabelSelection(opts) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            const { labelData: labelData, labelSelection: labelSelection } = opts;
            return labelSelection.update(labelData, (text)=>{
                text.tag = 1 /* Label */ ;
                text.pointerEvents = 1 /* None */ ;
                text.textAlign = "center";
                text.textBaseline = "middle";
            });
        });
    }
    updateLabelNodes(opts) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            const labelEnabled = this.isLabelEnabled();
            opts.labelSelection.each((text, datum)=>{
                const label = datum.label;
                if (label && labelEnabled) {
                    text.text = label.text;
                    text.x = label.x;
                    text.y = label.y;
                    text.fontStyle = label.fontStyle;
                    text.fontWeight = label.fontWeight;
                    text.fontSize = label.fontSize;
                    text.fontFamily = label.fontFamily;
                    text.fill = label.fill;
                    text.visible = true;
                } else text.visible = false;
            });
        });
    }
    initQuadTree(quadtree) {
        $d77b025aa58d633c$var$addHitTestersToQuadtree(quadtree, $d77b025aa58d633c$var$childrenIter(this.contentGroup.children[0]));
    }
    pickNodeClosestDatum(point) {
        return $d77b025aa58d633c$var$findQuadtreeMatch(this, point);
    }
    getTooltipHtml(nodeDatum) {
        const xAxis = this.axes["x" /* X */ ];
        const yAxis = this.axes["y" /* Y */ ];
        if (!this.properties.isValid() || !xAxis || !yAxis) return $d77b025aa58d633c$var$EMPTY_TOOLTIP_CONTENT;
        const { xKey: xKey, yKey: yKey, xName: xName, yName: yName, fill: color, aggregation: aggregation, tooltip: tooltip } = this.properties;
        const { aggregatedValue: aggregatedValue, frequency: frequency, domain: [rangeMin, rangeMax], itemId: itemId } = nodeDatum;
        const title = `${$d77b025aa58d633c$var$sanitizeHtml(xName != null ? xName : xKey)}: ${xAxis.formatDatum(rangeMin)} - ${xAxis.formatDatum(rangeMax)}`;
        let content = yKey ? `<b>${$d77b025aa58d633c$var$sanitizeHtml(yName != null ? yName : yKey)} (${aggregation})</b>: ${yAxis.formatDatum(aggregatedValue)}<br>` : "";
        content += `<b>Frequency</b>: ${frequency}`;
        const defaults = {
            title: title,
            backgroundColor: color,
            content: content
        };
        return tooltip.toTooltipHtml(defaults, {
            datum: {
                data: nodeDatum.datum,
                aggregatedValue: nodeDatum.aggregatedValue,
                domain: nodeDatum.domain,
                frequency: nodeDatum.frequency
            },
            itemId: itemId,
            xKey: xKey,
            xName: xName,
            yKey: yKey,
            yName: yName,
            color: color,
            title: title,
            seriesId: this.id
        });
    }
    getLegendData(legendType) {
        var _a, _b;
        if (!((_a = this.data) == null ? void 0 : _a.length) || legendType !== "category") return [];
        const { xKey: xKey, yName: yName, fill: fill, fillOpacity: fillOpacity, stroke: stroke, strokeWidth: strokeWidth, strokeOpacity: strokeOpacity, visible: visible } = this.properties;
        return [
            {
                legendType: "category",
                id: this.id,
                itemId: xKey,
                seriesId: this.id,
                enabled: visible,
                label: {
                    text: (_b = yName != null ? yName : xKey) != null ? _b : "Frequency"
                },
                marker: {
                    fill: fill != null ? fill : "rgba(0, 0, 0, 0)",
                    stroke: stroke != null ? stroke : "rgba(0, 0, 0, 0)",
                    fillOpacity: fillOpacity,
                    strokeOpacity: strokeOpacity,
                    strokeWidth: strokeWidth
                }
            }
        ];
    }
    animateEmptyUpdateReady({ datumSelection: datumSelection, labelSelection: labelSelection }) {
        const fns = $d77b025aa58d633c$var$prepareBarAnimationFunctions($d77b025aa58d633c$var$collapsedStartingBarPosition(true, this.axes, "normal"));
        $d77b025aa58d633c$var$fromToMotion(this.id, "datums", this.ctx.animationManager, [
            datumSelection
        ], fns);
        $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "labels", this.ctx.animationManager, labelSelection);
    }
    animateWaitingUpdateReady(data) {
        var _a, _b;
        const dataDiff = (_b = (_a = this.processedData) == null ? void 0 : _a.reduced) == null ? void 0 : _b.diff;
        const fns = $d77b025aa58d633c$var$prepareBarAnimationFunctions($d77b025aa58d633c$var$collapsedStartingBarPosition(true, this.axes, "normal"));
        $d77b025aa58d633c$var$fromToMotion(this.id, "datums", this.ctx.animationManager, [
            data.datumSelection
        ], fns, (_, datum)=>$d77b025aa58d633c$var$createDatumId(datum.domain), dataDiff);
        $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "labels", this.ctx.animationManager, data.labelSelection);
    }
    isLabelEnabled() {
        return this.properties.label.enabled;
    }
    computeFocusBounds({ datumIndex: datumIndex, seriesRect: seriesRect }) {
        var _a;
        return $d77b025aa58d633c$var$computeBarFocusBounds((_a = this.contextNodeData) == null ? void 0 : _a.nodeData[datumIndex], this.contentGroup, seriesRect);
    }
};
$d77b025aa58d633c$var$HistogramSeries.className = "HistogramSeries";
$d77b025aa58d633c$var$HistogramSeries.type = "histogram";
// packages/ag-charts-community/src/chart/series/cartesian/histogramSeriesModule.ts
var $d77b025aa58d633c$var$HistogramSeriesModule = {
    type: "series",
    optionsKey: "series[]",
    packageType: "community",
    chartTypes: [
        "cartesian"
    ],
    identifier: "histogram",
    instanceConstructor: $d77b025aa58d633c$var$HistogramSeries,
    defaultAxes: [
        {
            type: "number" /* NUMBER */ ,
            position: "bottom" /* BOTTOM */ 
        },
        {
            type: "number" /* NUMBER */ ,
            position: "left" /* LEFT */ 
        }
    ],
    themeTemplate: {
        series: {
            __extends__: $d77b025aa58d633c$var$EXTENDS_SERIES_DEFAULTS,
            strokeWidth: 1,
            fillOpacity: 1,
            strokeOpacity: 1,
            lineDash: [
                0
            ],
            lineDashOffset: 0,
            label: {
                enabled: false,
                fontSize: 12,
                fontFamily: $d77b025aa58d633c$var$DEFAULT_FONT_FAMILY,
                color: $d77b025aa58d633c$var$DEFAULT_INSIDE_SERIES_LABEL_COLOUR
            },
            shadow: {
                enabled: false,
                color: $d77b025aa58d633c$var$DEFAULT_SHADOW_COLOUR,
                xOffset: 3,
                yOffset: 3,
                blur: 5
            }
        }
    },
    paletteFactory: ({ takeColors: takeColors })=>{
        const { fills: [fill], strokes: [stroke] } = takeColors(1);
        return {
            fill: fill,
            stroke: stroke
        };
    }
};
// packages/ag-charts-community/src/chart/series/cartesian/lineSeriesProperties.ts
var $d77b025aa58d633c$var$LineSeriesProperties = class extends $d77b025aa58d633c$var$CartesianSeriesProperties {
    constructor(){
        super(...arguments);
        this.stroke = "#874349";
        this.strokeWidth = 2;
        this.strokeOpacity = 1;
        this.lineDash = [
            0
        ];
        this.lineDashOffset = 0;
        this.marker = new $d77b025aa58d633c$var$SeriesMarker();
        this.label = new $d77b025aa58d633c$var$Label();
        this.tooltip = new $d77b025aa58d633c$var$SeriesTooltip();
        this.connectMissingData = false;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING)
], $d77b025aa58d633c$var$LineSeriesProperties.prototype, "xKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING)
], $d77b025aa58d633c$var$LineSeriesProperties.prototype, "yKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$LineSeriesProperties.prototype, "xName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$LineSeriesProperties.prototype, "yName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$LineSeriesProperties.prototype, "title", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$COLOR_STRING)
], $d77b025aa58d633c$var$LineSeriesProperties.prototype, "stroke", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$LineSeriesProperties.prototype, "strokeWidth", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$RATIO)
], $d77b025aa58d633c$var$LineSeriesProperties.prototype, "strokeOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$LINE_DASH)
], $d77b025aa58d633c$var$LineSeriesProperties.prototype, "lineDash", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$LineSeriesProperties.prototype, "lineDashOffset", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$LineSeriesProperties.prototype, "marker", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$LineSeriesProperties.prototype, "label", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$LineSeriesProperties.prototype, "tooltip", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN)
], $d77b025aa58d633c$var$LineSeriesProperties.prototype, "connectMissingData", 2);
// packages/ag-charts-community/src/chart/series/cartesian/lineSeries.ts
var $d77b025aa58d633c$var$LineSeries = class extends $d77b025aa58d633c$var$CartesianSeries {
    constructor(moduleCtx){
        super({
            moduleCtx: moduleCtx,
            directionKeys: $d77b025aa58d633c$var$DEFAULT_CARTESIAN_DIRECTION_KEYS,
            directionNames: $d77b025aa58d633c$var$DEFAULT_CARTESIAN_DIRECTION_NAMES,
            hasMarkers: true,
            pickModes: [
                2 /* NEAREST_BY_MAIN_CATEGORY_AXIS_FIRST */ ,
                3 /* NEAREST_NODE */ ,
                0 /* EXACT_SHAPE_MATCH */ 
            ],
            markerSelectionGarbageCollection: false,
            animationResetFns: {
                path: $d77b025aa58d633c$var$buildResetPathFn({
                    getOpacity: ()=>this.getOpacity()
                }),
                label: $d77b025aa58d633c$var$resetLabelFn,
                marker: (node, datum)=>$d77b025aa58d633c$var$__spreadValues($d77b025aa58d633c$var$__spreadValues({}, $d77b025aa58d633c$var$resetMarkerFn(node)), $d77b025aa58d633c$var$resetMarkerPositionFn(node, datum))
            }
        });
        this.properties = new $d77b025aa58d633c$var$LineSeriesProperties();
    }
    processData(dataController) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            var _a, _b;
            if (!this.properties.isValid() || this.data == null) return;
            const { xKey: xKey, yKey: yKey } = this.properties;
            const animationEnabled = !this.ctx.animationManager.isSkipped();
            const xScale = (_a = this.axes["x" /* X */ ]) == null ? void 0 : _a.scale;
            const yScale = (_b = this.axes["y" /* Y */ ]) == null ? void 0 : _b.scale;
            const { isContinuousX: isContinuousX, xScaleType: xScaleType, yScaleType: yScaleType } = this.getScaleInformation({
                xScale: xScale,
                yScale: yScale
            });
            const props = [];
            if (!isContinuousX) props.push($d77b025aa58d633c$var$keyProperty(xKey, xScaleType, {
                id: "xKey"
            }));
            if (animationEnabled) {
                props.push($d77b025aa58d633c$var$animationValidation(isContinuousX ? [
                    "xValue"
                ] : void 0));
                if (this.processedData) props.push($d77b025aa58d633c$var$diff(this.processedData));
            }
            props.push($d77b025aa58d633c$var$valueProperty(xKey, xScaleType, {
                id: "xValue"
            }), $d77b025aa58d633c$var$valueProperty(yKey, yScaleType, {
                id: "yValue",
                invalidValue: void 0
            }));
            yield this.requestDataModel(dataController, this.data, {
                props: props
            });
            this.animationState.transition("updateData");
        });
    }
    getSeriesDomain(direction) {
        const { axes: axes, dataModel: dataModel, processedData: processedData } = this;
        if (!processedData || !dataModel) return [];
        const xAxis = axes["x" /* X */ ];
        const yAxis = axes["y" /* Y */ ];
        const xDef = dataModel.resolveProcessedDataDefById(this, `xValue`);
        if (direction === "x" /* X */ ) {
            const domain = dataModel.getDomain(this, `xValue`, "value", processedData);
            if ((xDef == null ? void 0 : xDef.def.type) === "value" && xDef.def.valueType === "category") return domain;
            return $d77b025aa58d633c$var$fixNumericExtent($d77b025aa58d633c$var$extent(domain), xAxis);
        } else {
            const domain = dataModel.getDomain(this, `yValue`, "value", processedData);
            return $d77b025aa58d633c$var$fixNumericExtent(domain, yAxis);
        }
    }
    createNodeData() {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            var _a, _b, _c;
            const { processedData: processedData, dataModel: dataModel, axes: axes } = this;
            const xAxis = axes["x" /* X */ ];
            const yAxis = axes["y" /* Y */ ];
            if (!processedData || !dataModel || !xAxis || !yAxis) return;
            const { xKey: xKey, yKey: yKey, xName: xName, yName: yName, marker: marker, label: label, connectMissingData: connectMissingData, legendItemName: legendItemName } = this.properties;
            const xScale = xAxis.scale;
            const yScale = yAxis.scale;
            const xOffset = ((_a = xScale.bandwidth) != null ? _a : 0) / 2;
            const yOffset = ((_b = yScale.bandwidth) != null ? _b : 0) / 2;
            const nodeData = [];
            const size = marker.enabled ? marker.size : 0;
            const xIdx = dataModel.resolveProcessedDataIndexById(this, `xValue`);
            const yIdx = dataModel.resolveProcessedDataIndexById(this, `yValue`);
            let moveTo = true;
            let nextPoint;
            for(let i = 0; i < processedData.data.length; i++){
                const { datum: datum, values: values } = nextPoint != null ? nextPoint : processedData.data[i];
                const xDatum = values[xIdx];
                const yDatum = values[yIdx];
                if (yDatum === void 0) moveTo = !connectMissingData;
                else {
                    const x = xScale.convert(xDatum) + xOffset;
                    if (isNaN(x)) {
                        moveTo = !connectMissingData;
                        nextPoint = void 0;
                        continue;
                    }
                    nextPoint = ((_c = processedData.data[i + 1]) == null ? void 0 : _c.values[yIdx]) === void 0 ? void 0 : processedData.data[i + 1];
                    const y = yScale.convert(yDatum) + yOffset;
                    const labelText = this.getLabelText(label, {
                        value: yDatum,
                        datum: datum,
                        xKey: xKey,
                        yKey: yKey,
                        xName: xName,
                        yName: yName,
                        legendItemName: legendItemName
                    }, (value)=>$d77b025aa58d633c$var$isFiniteNumber(value) ? value.toFixed(2) : String(value));
                    nodeData.push({
                        series: this,
                        datum: datum,
                        yKey: yKey,
                        xKey: xKey,
                        point: {
                            x: x,
                            y: y,
                            moveTo: moveTo,
                            size: size
                        },
                        midPoint: {
                            x: x,
                            y: y
                        },
                        yValue: yDatum,
                        xValue: xDatum,
                        capDefaults: {
                            lengthRatioMultiplier: this.properties.marker.getDiameter(),
                            lengthMax: Infinity
                        },
                        label: labelText ? {
                            text: labelText,
                            fontStyle: label.fontStyle,
                            fontWeight: label.fontWeight,
                            fontSize: label.fontSize,
                            fontFamily: label.fontFamily,
                            textAlign: "center",
                            textBaseline: "bottom",
                            fill: label.color
                        } : void 0
                    });
                    moveTo = false;
                }
            }
            return {
                itemId: yKey,
                nodeData: nodeData,
                labelData: nodeData,
                scales: this.calculateScaling(),
                visible: this.visible
            };
        });
    }
    isPathOrSelectionDirty() {
        return this.properties.marker.isDirty();
    }
    markerFactory() {
        const { shape: shape } = this.properties.marker;
        const MarkerShape = $d77b025aa58d633c$var$getMarker(shape);
        return new MarkerShape();
    }
    updatePathNodes(opts) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            const { paths: [lineNode], opacity: opacity, visible: visible, animationEnabled: animationEnabled } = opts;
            lineNode.setProperties({
                fill: void 0,
                lineJoin: "round",
                pointerEvents: 1 /* None */ ,
                opacity: opacity,
                stroke: this.properties.stroke,
                strokeWidth: this.getStrokeWidth(this.properties.strokeWidth),
                strokeOpacity: this.properties.strokeOpacity,
                lineDash: this.properties.lineDash,
                lineDashOffset: this.properties.lineDashOffset
            });
            if (!animationEnabled) lineNode.visible = visible;
            $d77b025aa58d633c$var$updateClipPath(this, lineNode);
        });
    }
    updateMarkerSelection(opts) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            let { nodeData: nodeData } = opts;
            const { markerSelection: markerSelection } = opts;
            const { shape: shape, enabled: enabled } = this.properties.marker;
            nodeData = shape && enabled ? nodeData : [];
            if (this.properties.marker.isDirty()) {
                markerSelection.clear();
                markerSelection.cleanup();
            }
            return markerSelection.update(nodeData, void 0, (datum)=>$d77b025aa58d633c$var$createDatumId(datum.xValue));
        });
    }
    updateMarkerNodes(opts) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            const { markerSelection: markerSelection, isHighlight: highlighted } = opts;
            const { xKey: xKey, yKey: yKey, stroke: stroke, strokeWidth: strokeWidth, strokeOpacity: strokeOpacity, marker: marker, highlightStyle: highlightStyle } = this.properties;
            const baseStyle = $d77b025aa58d633c$var$mergeDefaults(highlighted && highlightStyle.item, marker.getStyle(), {
                stroke: stroke,
                strokeWidth: strokeWidth,
                strokeOpacity: strokeOpacity
            });
            const applyTranslation = this.ctx.animationManager.isSkipped();
            markerSelection.each((node, datum)=>{
                this.updateMarkerStyle(node, marker, {
                    datum: datum,
                    highlighted: highlighted,
                    xKey: xKey,
                    yKey: yKey
                }, baseStyle, {
                    applyTranslation: applyTranslation
                });
            });
            if (!highlighted) marker.markClean();
        });
    }
    updateLabelSelection(opts) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            return opts.labelSelection.update(this.isLabelEnabled() ? opts.labelData : []);
        });
    }
    updateLabelNodes(opts) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            const { enabled: enabled, fontStyle: fontStyle, fontWeight: fontWeight, fontSize: fontSize, fontFamily: fontFamily, color: color } = this.properties.label;
            opts.labelSelection.each((text, datum)=>{
                const { point: point, label: label } = datum;
                if (datum && label && enabled) {
                    text.fontStyle = fontStyle;
                    text.fontWeight = fontWeight;
                    text.fontSize = fontSize;
                    text.fontFamily = fontFamily;
                    text.textAlign = label.textAlign;
                    text.textBaseline = label.textBaseline;
                    text.text = label.text;
                    text.x = point.x;
                    text.y = point.y - 10;
                    text.fill = color;
                    text.visible = true;
                } else text.visible = false;
            });
        });
    }
    getTooltipHtml(nodeDatum) {
        var _a;
        const xAxis = this.axes["x" /* X */ ];
        const yAxis = this.axes["y" /* Y */ ];
        if (!this.properties.isValid() || !xAxis || !yAxis) return $d77b025aa58d633c$var$EMPTY_TOOLTIP_CONTENT;
        const { xKey: xKey, yKey: yKey, xName: xName, yName: yName, strokeWidth: strokeWidth, marker: marker, tooltip: tooltip } = this.properties;
        const { datum: datum, xValue: xValue, yValue: yValue, itemId: itemId } = nodeDatum;
        const xString = xAxis.formatDatum(xValue);
        const yString = yAxis.formatDatum(yValue);
        const title = $d77b025aa58d633c$var$sanitizeHtml((_a = this.properties.title) != null ? _a : yName);
        const content = $d77b025aa58d633c$var$sanitizeHtml(xString + ": " + yString);
        const baseStyle = $d77b025aa58d633c$var$mergeDefaults({
            fill: marker.stroke
        }, marker.getStyle(), {
            strokeWidth: strokeWidth
        });
        const { fill: color } = this.getMarkerStyle(marker, {
            datum: nodeDatum,
            xKey: xKey,
            yKey: yKey,
            highlighted: false
        }, baseStyle);
        return tooltip.toTooltipHtml({
            title: title,
            content: content,
            backgroundColor: color
        }, $d77b025aa58d633c$var$__spreadValues({
            datum: datum,
            itemId: itemId,
            xKey: xKey,
            xName: xName,
            yKey: yKey,
            yName: yName,
            title: title,
            color: color,
            seriesId: this.id
        }, this.getModuleTooltipParams()));
    }
    getLegendData(legendType) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
        if (!(((_a = this.data) == null ? void 0 : _a.length) && this.properties.isValid() && legendType === "category")) return [];
        const { yKey: yKey, yName: yName, stroke: stroke, strokeOpacity: strokeOpacity, strokeWidth: strokeWidth, lineDash: lineDash, title: title, marker: marker, visible: visible, legendItemName: legendItemName } = this.properties;
        const color0 = "rgba(0, 0, 0, 0)";
        return [
            {
                legendType: "category",
                id: this.id,
                itemId: yKey,
                legendItemName: legendItemName,
                seriesId: this.id,
                enabled: visible,
                label: {
                    text: (_c = (_b = legendItemName != null ? legendItemName : title) != null ? _b : yName) != null ? _c : yKey
                },
                marker: {
                    shape: marker.shape,
                    fill: (_d = marker.fill) != null ? _d : color0,
                    stroke: (_f = (_e = marker.stroke) != null ? _e : stroke) != null ? _f : color0,
                    fillOpacity: (_g = marker.fillOpacity) != null ? _g : 1,
                    strokeOpacity: (_i = (_h = marker.strokeOpacity) != null ? _h : strokeOpacity) != null ? _i : 1,
                    strokeWidth: (_j = marker.strokeWidth) != null ? _j : 0,
                    enabled: marker.enabled
                },
                line: {
                    stroke: stroke != null ? stroke : color0,
                    strokeOpacity: strokeOpacity,
                    strokeWidth: strokeWidth,
                    lineDash: lineDash
                }
            }
        ];
    }
    updatePaths(opts) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            this.updateLinePaths(opts.paths, opts.contextData);
        });
    }
    updateLinePaths(paths, contextData) {
        const { nodeData: nodeData } = contextData;
        const [lineNode] = paths;
        const { path: linePath } = lineNode;
        linePath.clear(true);
        for (const data of nodeData)if (data.point.moveTo) linePath.moveTo(data.point.x, data.point.y);
        else linePath.lineTo(data.point.x, data.point.y);
        lineNode.checkPathDirty();
    }
    animateEmptyUpdateReady(animationData) {
        const { markerSelection: markerSelection, labelSelection: labelSelection, annotationSelections: annotationSelections, contextData: contextData, paths: paths } = animationData;
        const { animationManager: animationManager } = this.ctx;
        this.updateLinePaths(paths, contextData);
        $d77b025aa58d633c$var$pathSwipeInAnimation(this, animationManager, ...paths);
        $d77b025aa58d633c$var$resetMotion([
            markerSelection
        ], $d77b025aa58d633c$var$resetMarkerPositionFn);
        $d77b025aa58d633c$var$markerSwipeScaleInAnimation(this, animationManager, markerSelection);
        $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "labels", animationManager, labelSelection);
        $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "annotations", animationManager, ...annotationSelections);
    }
    animateReadyResize(animationData) {
        const { contextData: contextData, paths: paths } = animationData;
        this.updateLinePaths(paths, contextData);
        super.animateReadyResize(animationData);
    }
    animateWaitingUpdateReady(animationData) {
        var _a, _b;
        const { animationManager: animationManager } = this.ctx;
        const { markerSelection: markerSelections, labelSelection: labelSelections, annotationSelections: annotationSelections, contextData: contextData, paths: paths, previousContextData: previousContextData } = animationData;
        const [path] = paths;
        super.resetAllAnimation(animationData);
        const update = ()=>{
            this.updateLinePaths(paths, contextData);
        };
        const skip = ()=>{
            animationManager.skipCurrentBatch();
            update();
        };
        if (contextData == null || previousContextData == null) {
            update();
            $d77b025aa58d633c$var$markerFadeInAnimation(this, animationManager, "added", markerSelections);
            $d77b025aa58d633c$var$pathFadeInAnimation(this, "path_properties", animationManager, "add", path);
            $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "labels", animationManager, labelSelections);
            $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "annotations", animationManager, ...annotationSelections);
            return;
        }
        const fns = $d77b025aa58d633c$var$prepareLinePathAnimation(contextData, previousContextData, (_b = (_a = this.processedData) == null ? void 0 : _a.reduced) == null ? void 0 : _b.diff);
        if (fns === void 0) {
            skip();
            return;
        } else if (fns.status === "no-op") return;
        $d77b025aa58d633c$var$markerFadeInAnimation(this, animationManager, void 0, markerSelections);
        $d77b025aa58d633c$var$fromToMotion(this.id, "path_properties", animationManager, [
            path
        ], fns.pathProperties);
        $d77b025aa58d633c$var$pathMotion(this.id, "path_update", animationManager, [
            path
        ], fns.path);
        if (fns.hasMotion) {
            $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "labels", animationManager, labelSelections);
            $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "annotations", animationManager, ...annotationSelections);
        }
    }
    isLabelEnabled() {
        return this.properties.label.enabled;
    }
    getBandScalePadding() {
        return {
            inner: 1,
            outer: 0.1
        };
    }
    nodeFactory() {
        return new $d77b025aa58d633c$var$Group();
    }
    getFormattedMarkerStyle(datum) {
        const { xKey: xKey, yKey: yKey } = this.properties;
        return this.getMarkerStyle(this.properties.marker, {
            datum: datum,
            xKey: xKey,
            yKey: yKey,
            highlighted: true
        });
    }
    computeFocusBounds(opts) {
        return $d77b025aa58d633c$var$computeMarkerFocusBounds(this, opts);
    }
};
$d77b025aa58d633c$var$LineSeries.className = "LineSeries";
$d77b025aa58d633c$var$LineSeries.type = "line";
// packages/ag-charts-community/src/chart/series/cartesian/lineSeriesModule.ts
var $d77b025aa58d633c$var$LineSeriesModule = {
    type: "series",
    optionsKey: "series[]",
    packageType: "community",
    chartTypes: [
        "cartesian"
    ],
    identifier: "line",
    instanceConstructor: $d77b025aa58d633c$var$LineSeries,
    defaultAxes: [
        {
            type: "number" /* NUMBER */ ,
            position: "left" /* LEFT */ 
        },
        {
            type: "category" /* CATEGORY */ ,
            position: "bottom" /* BOTTOM */ 
        }
    ],
    themeTemplate: {
        series: {
            __extends__: $d77b025aa58d633c$var$EXTENDS_SERIES_DEFAULTS,
            tooltip: {
                position: {
                    type: "node"
                }
            },
            strokeWidth: 2,
            strokeOpacity: 1,
            lineDash: [
                0
            ],
            lineDashOffset: 0,
            marker: {
                __extends__: $d77b025aa58d633c$var$EXTENDS_CARTESIAN_MARKER_DEFAULTS,
                fillOpacity: 1,
                strokeOpacity: 1,
                strokeWidth: 0
            },
            label: {
                enabled: false,
                fontSize: 12,
                fontFamily: $d77b025aa58d633c$var$DEFAULT_FONT_FAMILY,
                color: $d77b025aa58d633c$var$DEFAULT_LABEL_COLOUR
            }
        }
    },
    enterpriseThemeTemplate: {
        series: {
            errorBar: {
                cap: {
                    lengthRatio: 1
                }
            }
        }
    },
    paletteFactory: (params)=>{
        const { marker: marker } = $d77b025aa58d633c$var$markerPaletteFactory(params);
        return {
            stroke: marker.fill,
            marker: marker
        };
    }
};
// packages/ag-charts-community/src/chart/series/cartesian/scatterSeriesProperties.ts
var $d77b025aa58d633c$var$ScatterSeriesLabel = class extends $d77b025aa58d633c$var$Label {
    constructor(){
        super(...arguments);
        this.placement = "top";
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$LABEL_PLACEMENT)
], $d77b025aa58d633c$var$ScatterSeriesLabel.prototype, "placement", 2);
var $d77b025aa58d633c$var$ScatterSeriesProperties = class extends $d77b025aa58d633c$var$CartesianSeriesProperties {
    constructor(){
        super(...arguments);
        this.colorRange = [
            "#ffff00",
            "#00ff00",
            "#0000ff"
        ];
        this.marker = new $d77b025aa58d633c$var$SeriesMarker();
        this.label = new $d77b025aa58d633c$var$ScatterSeriesLabel();
        this.tooltip = new $d77b025aa58d633c$var$SeriesTooltip();
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING)
], $d77b025aa58d633c$var$ScatterSeriesProperties.prototype, "xKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING)
], $d77b025aa58d633c$var$ScatterSeriesProperties.prototype, "yKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$ScatterSeriesProperties.prototype, "labelKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$ScatterSeriesProperties.prototype, "colorKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$ScatterSeriesProperties.prototype, "xName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$ScatterSeriesProperties.prototype, "yName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$ScatterSeriesProperties.prototype, "labelName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$ScatterSeriesProperties.prototype, "colorName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$NUMBER_ARRAY, {
        optional: true
    })
], $d77b025aa58d633c$var$ScatterSeriesProperties.prototype, "colorDomain", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$COLOR_STRING_ARRAY)
], $d77b025aa58d633c$var$ScatterSeriesProperties.prototype, "colorRange", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$ScatterSeriesProperties.prototype, "title", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$ScatterSeriesProperties.prototype, "marker", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$ScatterSeriesProperties.prototype, "label", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$ScatterSeriesProperties.prototype, "tooltip", 2);
// packages/ag-charts-community/src/chart/series/cartesian/scatterSeries.ts
var $d77b025aa58d633c$var$ScatterSeries = class extends $d77b025aa58d633c$var$CartesianSeries {
    constructor(moduleCtx){
        super({
            moduleCtx: moduleCtx,
            directionKeys: $d77b025aa58d633c$var$DEFAULT_CARTESIAN_DIRECTION_KEYS,
            directionNames: $d77b025aa58d633c$var$DEFAULT_CARTESIAN_DIRECTION_NAMES,
            pickModes: [
                2 /* NEAREST_BY_MAIN_CATEGORY_AXIS_FIRST */ ,
                3 /* NEAREST_NODE */ ,
                0 /* EXACT_SHAPE_MATCH */ 
            ],
            pathsPerSeries: 0,
            hasMarkers: true,
            markerSelectionGarbageCollection: false,
            animationResetFns: {
                marker: $d77b025aa58d633c$var$resetMarkerFn,
                label: $d77b025aa58d633c$var$resetLabelFn
            }
        });
        this.properties = new $d77b025aa58d633c$var$ScatterSeriesProperties();
        this.colorScale = new $d77b025aa58d633c$var$ColorScale();
    }
    processData(dataController) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            var _a, _b, _c;
            if (!this.properties.isValid() || this.data == null || !this.visible) return;
            const xScale = (_a = this.axes["x" /* X */ ]) == null ? void 0 : _a.scale;
            const yScale = (_b = this.axes["y" /* Y */ ]) == null ? void 0 : _b.scale;
            const { xScaleType: xScaleType, yScaleType: yScaleType } = this.getScaleInformation({
                xScale: xScale,
                yScale: yScale
            });
            const colorScaleType = this.colorScale.type;
            const { xKey: xKey, yKey: yKey, labelKey: labelKey, colorKey: colorKey, colorDomain: colorDomain, colorRange: colorRange } = this.properties;
            const { dataModel: dataModel, processedData: processedData } = yield this.requestDataModel(dataController, this.data, {
                props: [
                    $d77b025aa58d633c$var$keyProperty(xKey, xScaleType, {
                        id: "xKey-raw"
                    }),
                    $d77b025aa58d633c$var$keyProperty(yKey, yScaleType, {
                        id: "yKey-raw"
                    }),
                    ...labelKey ? [
                        $d77b025aa58d633c$var$keyProperty(labelKey, "band", {
                            id: `labelKey-raw`
                        })
                    ] : [],
                    $d77b025aa58d633c$var$valueProperty(xKey, xScaleType, {
                        id: `xValue`
                    }),
                    $d77b025aa58d633c$var$valueProperty(yKey, yScaleType, {
                        id: `yValue`
                    }),
                    ...colorKey ? [
                        $d77b025aa58d633c$var$valueProperty(colorKey, colorScaleType, {
                            id: `colorValue`
                        })
                    ] : [],
                    ...labelKey ? [
                        $d77b025aa58d633c$var$valueProperty(labelKey, "band", {
                            id: `labelValue`
                        })
                    ] : []
                ]
            });
            if (colorKey) {
                const colorKeyIdx = dataModel.resolveProcessedDataIndexById(this, `colorValue`);
                this.colorScale.domain = (_c = colorDomain != null ? colorDomain : processedData.domain.values[colorKeyIdx]) != null ? _c : [];
                this.colorScale.range = colorRange;
                this.colorScale.update();
            }
            this.animationState.transition("updateData");
        });
    }
    getSeriesDomain(direction) {
        const { dataModel: dataModel, processedData: processedData } = this;
        if (!processedData || !dataModel) return [];
        const id = direction === "x" /* X */  ? `xValue` : `yValue`;
        const dataDef = dataModel.resolveProcessedDataDefById(this, id);
        const domain = dataModel.getDomain(this, id, "value", processedData);
        if ((dataDef == null ? void 0 : dataDef.def.type) === "value" && (dataDef == null ? void 0 : dataDef.def.valueType) === "category") return domain;
        const axis = this.axes[direction];
        return $d77b025aa58d633c$var$fixNumericExtent($d77b025aa58d633c$var$extent(domain), axis);
    }
    createNodeData() {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            var _a, _b, _c;
            const { axes: axes, dataModel: dataModel, processedData: processedData, colorScale: colorScale } = this;
            const { xKey: xKey, yKey: yKey, labelKey: labelKey, colorKey: colorKey, xName: xName, yName: yName, labelName: labelName, marker: marker, label: label, visible: visible } = this.properties;
            const { placement: placement } = label;
            const markerShape = $d77b025aa58d633c$var$getMarker(marker.shape);
            const xAxis = axes["x" /* X */ ];
            const yAxis = axes["y" /* Y */ ];
            if (!(dataModel && processedData && visible && xAxis && yAxis)) return;
            const xDataIdx = dataModel.resolveProcessedDataIndexById(this, `xValue`);
            const yDataIdx = dataModel.resolveProcessedDataIndexById(this, `yValue`);
            const colorDataIdx = colorKey ? dataModel.resolveProcessedDataIndexById(this, `colorValue`) : -1;
            const labelDataIdx = labelKey ? dataModel.resolveProcessedDataIndexById(this, `labelValue`) : -1;
            const xScale = xAxis.scale;
            const yScale = yAxis.scale;
            const xOffset = ((_a = xScale.bandwidth) != null ? _a : 0) / 2;
            const yOffset = ((_b = yScale.bandwidth) != null ? _b : 0) / 2;
            const nodeData = [];
            const font = label.getFont();
            for (const { values: values, datum: datum } of (_c = processedData.data) != null ? _c : []){
                const xDatum = values[xDataIdx];
                const yDatum = values[yDataIdx];
                const x = xScale.convert(xDatum) + xOffset;
                const y = yScale.convert(yDatum) + yOffset;
                const labelText = this.getLabelText(label, {
                    value: labelKey ? values[labelDataIdx] : yDatum,
                    datum: datum,
                    xKey: xKey,
                    yKey: yKey,
                    labelKey: labelKey,
                    xName: xName,
                    yName: yName,
                    labelName: labelName
                });
                const size = $d77b025aa58d633c$var$Text.getTextSize(labelText, font);
                const fill = colorKey ? colorScale.convert(values[colorDataIdx]) : void 0;
                nodeData.push({
                    series: this,
                    itemId: yKey,
                    yKey: yKey,
                    xKey: xKey,
                    datum: datum,
                    xValue: xDatum,
                    yValue: yDatum,
                    capDefaults: {
                        lengthRatioMultiplier: marker.getDiameter(),
                        lengthMax: Infinity
                    },
                    point: {
                        x: x,
                        y: y,
                        size: marker.size
                    },
                    midPoint: {
                        x: x,
                        y: y
                    },
                    fill: fill,
                    label: $d77b025aa58d633c$var$__spreadValues({
                        text: labelText
                    }, size),
                    marker: markerShape,
                    placement: placement
                });
            }
            return {
                itemId: yKey,
                nodeData: nodeData,
                labelData: nodeData,
                scales: this.calculateScaling(),
                visible: this.visible
            };
        });
    }
    isPathOrSelectionDirty() {
        return this.properties.marker.isDirty();
    }
    getLabelData() {
        var _a, _b;
        return (_b = (_a = this.contextNodeData) == null ? void 0 : _a.labelData) != null ? _b : [];
    }
    markerFactory() {
        const { shape: shape } = this.properties.marker;
        const MarkerShape = $d77b025aa58d633c$var$getMarker(shape);
        return new MarkerShape();
    }
    updateMarkerSelection(opts) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            const { nodeData: nodeData, markerSelection: markerSelection } = opts;
            if (this.properties.marker.isDirty()) {
                markerSelection.clear();
                markerSelection.cleanup();
            }
            return markerSelection.update(this.properties.marker.enabled ? nodeData : []);
        });
    }
    updateMarkerNodes(opts) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            const { markerSelection: markerSelection, isHighlight: highlighted } = opts;
            const { xKey: xKey, yKey: yKey, labelKey: labelKey, marker: marker, highlightStyle: highlightStyle } = this.properties;
            const baseStyle = $d77b025aa58d633c$var$mergeDefaults(highlighted && highlightStyle.item, marker.getStyle());
            markerSelection.each((node, datum)=>{
                this.updateMarkerStyle(node, marker, {
                    datum: datum,
                    highlighted: highlighted,
                    xKey: xKey,
                    yKey: yKey,
                    labelKey: labelKey
                }, baseStyle);
            });
            if (!highlighted) marker.markClean();
        });
    }
    updateLabelSelection(opts) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            var _a, _b;
            const placedLabels = this.isLabelEnabled() ? (_b = (_a = this.chart) == null ? void 0 : _a.placeLabels().get(this)) != null ? _b : [] : [];
            return opts.labelSelection.update(placedLabels.map(({ datum: datum, x: x, y: y })=>$d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, datum), {
                    point: {
                        x: x,
                        y: y,
                        size: datum.point.size
                    },
                    placement: "top"
                })), (text)=>{
                text.pointerEvents = 1 /* None */ ;
            });
        });
    }
    updateLabelNodes(opts) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            const { label: label } = this.properties;
            opts.labelSelection.each((text, datum)=>{
                var _a, _b, _c, _d;
                text.text = datum.label.text;
                text.fill = label.color;
                text.x = (_b = (_a = datum.point) == null ? void 0 : _a.x) != null ? _b : 0;
                text.y = (_d = (_c = datum.point) == null ? void 0 : _c.y) != null ? _d : 0;
                text.fontStyle = label.fontStyle;
                text.fontWeight = label.fontWeight;
                text.fontSize = label.fontSize;
                text.fontFamily = label.fontFamily;
                text.textAlign = "left";
                text.textBaseline = "top";
            });
        });
    }
    getTooltipHtml(nodeDatum) {
        const xAxis = this.axes["x" /* X */ ];
        const yAxis = this.axes["y" /* Y */ ];
        if (!this.properties.isValid() || !xAxis || !yAxis) return $d77b025aa58d633c$var$EMPTY_TOOLTIP_CONTENT;
        const { xKey: xKey, yKey: yKey, labelKey: labelKey, xName: xName, yName: yName, labelName: labelName, title: title = yName, marker: marker, tooltip: tooltip } = this.properties;
        const { datum: datum, xValue: xValue, yValue: yValue, label: label, itemId: itemId } = nodeDatum;
        const baseStyle = $d77b025aa58d633c$var$mergeDefaults({
            fill: nodeDatum.fill,
            strokeWidth: this.getStrokeWidth(marker.strokeWidth)
        }, marker.getStyle());
        const { fill: color = "gray" } = this.getMarkerStyle(marker, {
            datum: nodeDatum,
            highlighted: false,
            xKey: xKey,
            yKey: yKey,
            labelKey: labelKey
        }, baseStyle);
        const xString = $d77b025aa58d633c$var$sanitizeHtml(xAxis.formatDatum(xValue));
        const yString = $d77b025aa58d633c$var$sanitizeHtml(yAxis.formatDatum(yValue));
        let content = `<b>${$d77b025aa58d633c$var$sanitizeHtml(xName != null ? xName : xKey)}</b>: ${xString}<br><b>${$d77b025aa58d633c$var$sanitizeHtml(yName != null ? yName : yKey)}</b>: ${yString}`;
        if (labelKey) content = `<b>${$d77b025aa58d633c$var$sanitizeHtml(labelName != null ? labelName : labelKey)}</b>: ${$d77b025aa58d633c$var$sanitizeHtml(label.text)}<br>` + content;
        return tooltip.toTooltipHtml({
            title: title,
            content: content,
            backgroundColor: color
        }, $d77b025aa58d633c$var$__spreadValues({
            datum: datum,
            itemId: itemId,
            xKey: xKey,
            xName: xName,
            yKey: yKey,
            yName: yName,
            labelKey: labelKey,
            labelName: labelName,
            title: title,
            color: color,
            seriesId: this.id
        }, this.getModuleTooltipParams()));
    }
    getLegendData(legendType) {
        var _a, _b, _c, _d, _e, _f;
        const { yKey: yKey, yName: yName, title: title, marker: marker, visible: visible } = this.properties;
        const { fill: fill, stroke: stroke, fillOpacity: fillOpacity, strokeOpacity: strokeOpacity, strokeWidth: strokeWidth } = marker;
        if (!((_a = this.data) == null ? void 0 : _a.length) || !this.properties.isValid() || legendType !== "category") return [];
        return [
            {
                legendType: "category",
                id: this.id,
                itemId: yKey,
                seriesId: this.id,
                enabled: visible,
                label: {
                    text: (_b = title != null ? title : yName) != null ? _b : yKey
                },
                marker: {
                    shape: marker.shape,
                    fill: (_d = (_c = marker.fill) != null ? _c : fill) != null ? _d : "rgba(0, 0, 0, 0)",
                    stroke: (_f = (_e = marker.stroke) != null ? _e : stroke) != null ? _f : "rgba(0, 0, 0, 0)",
                    fillOpacity: fillOpacity != null ? fillOpacity : 1,
                    strokeOpacity: strokeOpacity != null ? strokeOpacity : 1,
                    strokeWidth: strokeWidth != null ? strokeWidth : 0
                }
            }
        ];
    }
    animateEmptyUpdateReady(data) {
        const { markerSelection: markerSelection, labelSelection: labelSelection, annotationSelections: annotationSelections } = data;
        $d77b025aa58d633c$var$markerScaleInAnimation(this, this.ctx.animationManager, markerSelection);
        $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "labels", this.ctx.animationManager, labelSelection);
        $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "annotations", this.ctx.animationManager, ...annotationSelections);
    }
    isLabelEnabled() {
        return this.properties.label.enabled;
    }
    nodeFactory() {
        return new $d77b025aa58d633c$var$Group();
    }
    getFormattedMarkerStyle(datum) {
        const { xKey: xKey, yKey: yKey, labelKey: labelKey } = this.properties;
        return this.getMarkerStyle(this.properties.marker, {
            datum: datum,
            xKey: xKey,
            yKey: yKey,
            labelKey: labelKey,
            highlighted: true
        });
    }
    computeFocusBounds(opts) {
        return $d77b025aa58d633c$var$computeMarkerFocusBounds(this, opts);
    }
};
$d77b025aa58d633c$var$ScatterSeries.className = "ScatterSeries";
$d77b025aa58d633c$var$ScatterSeries.type = "scatter";
// packages/ag-charts-community/src/chart/series/cartesian/scatterSeriesModule.ts
var $d77b025aa58d633c$var$ScatterSeriesModule = {
    type: "series",
    optionsKey: "series[]",
    packageType: "community",
    chartTypes: [
        "cartesian"
    ],
    identifier: "scatter",
    instanceConstructor: $d77b025aa58d633c$var$ScatterSeries,
    defaultAxes: [
        {
            type: "number" /* NUMBER */ ,
            position: "bottom" /* BOTTOM */ 
        },
        {
            type: "number" /* NUMBER */ ,
            position: "left" /* LEFT */ 
        }
    ],
    themeTemplate: {
        series: {
            __extends__: $d77b025aa58d633c$var$EXTENDS_SERIES_DEFAULTS,
            tooltip: {
                position: {
                    type: "node"
                }
            },
            marker: {
                __extends__: $d77b025aa58d633c$var$EXTENDS_CARTESIAN_MARKER_DEFAULTS,
                fillOpacity: 0.8
            },
            label: {
                enabled: false,
                fontSize: 12,
                fontFamily: $d77b025aa58d633c$var$DEFAULT_FONT_FAMILY,
                color: $d77b025aa58d633c$var$DEFAULT_LABEL_COLOUR
            }
        }
    },
    enterpriseThemeTemplate: {
        series: {
            errorBar: {
                cap: {
                    lengthRatio: 1
                }
            }
        }
    },
    paletteFactory: $d77b025aa58d633c$var$markerPaletteFactory
};
// packages/ag-charts-community/src/scene/sectorBox.ts
var $d77b025aa58d633c$var$SectorBox = class _SectorBox {
    constructor(startAngle, endAngle, innerRadius, outerRadius){
        this.startAngle = startAngle;
        this.endAngle = endAngle;
        this.innerRadius = innerRadius;
        this.outerRadius = outerRadius;
    }
    clone() {
        const { startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius } = this;
        return new _SectorBox(startAngle, endAngle, innerRadius, outerRadius);
    }
    [$d77b025aa58d633c$var$interpolate](other, d) {
        return new _SectorBox(this.startAngle * (1 - d) + other.startAngle * d, this.endAngle * (1 - d) + other.endAngle * d, this.innerRadius * (1 - d) + other.innerRadius * d, this.outerRadius * (1 - d) + other.outerRadius * d);
    }
};
// packages/ag-charts-community/src/scene/util/sector.ts
function $d77b025aa58d633c$var$isPointInSector(x, y, sector) {
    const radius = Math.sqrt(Math.pow(x, 2) + Math.pow(y, 2));
    const { innerRadius: innerRadius, outerRadius: outerRadius } = sector;
    if (sector.startAngle === sector.endAngle || radius < Math.min(innerRadius, outerRadius) || radius > Math.max(innerRadius, outerRadius)) return false;
    const startAngle = $d77b025aa58d633c$var$normalizeAngle180(sector.startAngle);
    const endAngle = $d77b025aa58d633c$var$normalizeAngle180(sector.endAngle);
    const angle = Math.atan2(y, x);
    return startAngle < endAngle ? angle <= endAngle && angle >= startAngle : angle <= endAngle && angle >= -Math.PI || angle >= startAngle && angle <= Math.PI;
}
function $d77b025aa58d633c$var$lineCollidesSector(line, sector) {
    const { startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius } = sector;
    const outerStart = {
        x: outerRadius * Math.cos(startAngle),
        y: outerRadius * Math.sin(startAngle)
    };
    const outerEnd = {
        x: outerRadius * Math.cos(endAngle),
        y: outerRadius * Math.sin(endAngle)
    };
    const innerStart = innerRadius === 0 ? {
        x: 0,
        y: 0
    } : {
        x: innerRadius * Math.cos(startAngle),
        y: innerRadius * Math.sin(startAngle)
    };
    const innerEnd = innerRadius === 0 ? {
        x: 0,
        y: 0
    } : {
        x: innerRadius * Math.cos(endAngle),
        y: innerRadius * Math.sin(endAngle)
    };
    return $d77b025aa58d633c$var$segmentIntersection(line.start.x, line.start.y, line.end.x, line.end.y, outerStart.x, outerStart.y, innerStart.x, innerStart.y) || $d77b025aa58d633c$var$segmentIntersection(line.start.x, line.start.y, line.end.x, line.end.y, outerEnd.x, outerEnd.y, innerEnd.x, innerEnd.y) || $d77b025aa58d633c$var$arcIntersections(0, 0, outerRadius, startAngle, endAngle, true, line.start.x, line.start.y, line.end.x, line.end.y);
}
function $d77b025aa58d633c$var$boxCollidesSector(box, sector) {
    const topLeft = {
        x: box.x,
        y: box.y
    };
    const topRight = {
        x: box.x + box.width,
        y: box.y
    };
    const bottomLeft = {
        x: box.x,
        y: box.y + box.height
    };
    const bottomRight = {
        x: box.x + box.width,
        y: box.y + box.height
    };
    return $d77b025aa58d633c$var$lineCollidesSector({
        start: topLeft,
        end: topRight
    }, sector) || $d77b025aa58d633c$var$lineCollidesSector({
        start: bottomLeft,
        end: bottomRight
    }, sector);
}
function $d77b025aa58d633c$var$radiiScalingFactor(r, sweep, a, b) {
    if (a === 0 && b === 0) return 0;
    const fs1 = Math.asin(Math.abs(1 * a) / (r + 1 * a)) + Math.asin(Math.abs(1 * b) / (r + 1 * b)) - sweep;
    if (fs1 < 0) return 1;
    let start = 0;
    let end = 1;
    for(let i = 0; i < 8; i += 1){
        const s = (start + end) / 2;
        const fs = Math.asin(Math.abs(s * a) / (r + s * a)) + Math.asin(Math.abs(s * b) / (r + s * b)) - sweep;
        if (fs < 0) start = s;
        else end = s;
    }
    return start;
}
var $d77b025aa58d633c$var$delta = 1e-6;
function $d77b025aa58d633c$var$clockwiseAngle(angle, relativeToStartAngle) {
    if ($d77b025aa58d633c$var$angleBetween(angle, relativeToStartAngle) < $d77b025aa58d633c$var$delta) return relativeToStartAngle;
    else return $d77b025aa58d633c$var$normalizeAngle360(angle - relativeToStartAngle) + relativeToStartAngle;
}
function $d77b025aa58d633c$var$clockwiseAngles(startAngle, endAngle, relativeToStartAngle = 0) {
    const fullPie = Math.abs(endAngle - startAngle) >= 2 * Math.PI;
    const sweepAngle = fullPie ? 2 * Math.PI : $d77b025aa58d633c$var$normalizeAngle360(endAngle - startAngle);
    startAngle = $d77b025aa58d633c$var$clockwiseAngle(startAngle, relativeToStartAngle);
    endAngle = startAngle + sweepAngle;
    return {
        startAngle: startAngle,
        endAngle: endAngle
    };
}
function $d77b025aa58d633c$var$arcRadialLineIntersectionAngle(cx, cy, r, startAngle, endAngle, clipAngle) {
    const sinA = Math.sin(clipAngle);
    const cosA = Math.cos(clipAngle);
    const c = $d77b025aa58d633c$var$__pow(cx, 2) + $d77b025aa58d633c$var$__pow(cy, 2) - $d77b025aa58d633c$var$__pow(r, 2);
    let p0x = NaN;
    let p0y = NaN;
    let p1x = NaN;
    let p1y = NaN;
    if (cosA > 0.5) {
        const tanA = sinA / cosA;
        const a = 1 + $d77b025aa58d633c$var$__pow(tanA, 2);
        const b = -2 * (cx + cy * tanA);
        const d = $d77b025aa58d633c$var$__pow(b, 2) - 4 * a * c;
        if (d < 0) return;
        const x0 = (-b + Math.sqrt(d)) / (2 * a);
        const x1 = (-b - Math.sqrt(d)) / (2 * a);
        p0x = x0;
        p0y = x0 * tanA;
        p1x = x1;
        p1y = x1 * tanA;
    } else {
        const cotA = cosA / sinA;
        const a = 1 + $d77b025aa58d633c$var$__pow(cotA, 2);
        const b = -2 * (cy + cx * cotA);
        const d = $d77b025aa58d633c$var$__pow(b, 2) - 4 * a * c;
        if (d < 0) return;
        const y0 = (-b + Math.sqrt(d)) / (2 * a);
        const y1 = (-b - Math.sqrt(d)) / (2 * a);
        p0x = y0 * cotA;
        p0y = y0;
        p1x = y1 * cotA;
        p1y = y1;
    }
    const normalisedX = cosA;
    const normalisedY = sinA;
    const p0DotNormalized = p0x * normalisedX + p0y * normalisedY;
    const p1DotNormalized = p1x * normalisedX + p1y * normalisedY;
    const a0 = p0DotNormalized > 0 ? $d77b025aa58d633c$var$clockwiseAngle(Math.atan2(p0y - cy, p0x - cx), startAngle) : NaN;
    const a1 = p1DotNormalized > 0 ? $d77b025aa58d633c$var$clockwiseAngle(Math.atan2(p1y - cy, p1x - cx), startAngle) : NaN;
    if (a0 >= startAngle && a0 <= endAngle) return a0;
    else if (a1 >= startAngle && a1 <= endAngle) return a1;
}
function $d77b025aa58d633c$var$arcCircleIntersectionAngle(cx, cy, r, startAngle, endAngle, circleR) {
    const d = Math.hypot(cx, cy);
    const d1 = ($d77b025aa58d633c$var$__pow(d, 2) - $d77b025aa58d633c$var$__pow(r, 2) + $d77b025aa58d633c$var$__pow(circleR, 2)) / (2 * d);
    const d2 = d - d1;
    const theta = Math.atan2(cy, cx);
    const deltaTheta = Math.acos(-d2 / r);
    const a0 = $d77b025aa58d633c$var$clockwiseAngle(theta + deltaTheta, startAngle);
    const a1 = $d77b025aa58d633c$var$clockwiseAngle(theta - deltaTheta, startAngle);
    if (a0 >= startAngle && a0 <= endAngle) return a0;
    else if (a1 >= startAngle && a1 <= endAngle) return a1;
}
// packages/ag-charts-community/src/scene/shape/sector.ts
var $d77b025aa58d633c$var$Arc = class {
    constructor(cx, cy, r, a0, a1){
        this.cx = cx;
        this.cy = cy;
        this.r = r;
        this.a0 = a0;
        this.a1 = a1;
        if (this.a0 >= this.a1) {
            this.a0 = NaN;
            this.a1 = NaN;
        }
    }
    isValid() {
        return Number.isFinite(this.a0) && Number.isFinite(this.a1);
    }
    pointAt(a) {
        return {
            x: this.cx + this.r * Math.cos(a),
            y: this.cy + this.r * Math.sin(a)
        };
    }
    clipStart(a) {
        if (a == null || !this.isValid() || a < this.a0) return;
        this.a0 = a;
        if (Number.isNaN(a) || this.a0 >= this.a1) {
            this.a0 = NaN;
            this.a1 = NaN;
        }
    }
    clipEnd(a) {
        if (a == null || !this.isValid() || a > this.a1) return;
        this.a1 = a;
        if (Number.isNaN(a) || this.a0 >= this.a1) {
            this.a0 = NaN;
            this.a1 = NaN;
        }
    }
};
var $d77b025aa58d633c$var$Sector = class extends $d77b025aa58d633c$var$Path {
    constructor(){
        super(...arguments);
        this.centerX = 0;
        this.centerY = 0;
        this.innerRadius = 10;
        this.outerRadius = 20;
        this.startAngle = 0;
        this.endAngle = Math.PI * 2;
        this.clipSector = void 0;
        this.concentricEdgeInset = 0;
        this.radialEdgeInset = 0;
        this.startOuterCornerRadius = 0;
        this.endOuterCornerRadius = 0;
        this.startInnerCornerRadius = 0;
        this.endInnerCornerRadius = 0;
    }
    set inset(value) {
        this.concentricEdgeInset = value;
        this.radialEdgeInset = value;
    }
    set cornerRadius(value) {
        this.startOuterCornerRadius = value;
        this.endOuterCornerRadius = value;
        this.startInnerCornerRadius = value;
        this.endInnerCornerRadius = value;
    }
    computeBBox() {
        const radius = this.outerRadius;
        return new $d77b025aa58d633c$var$BBox(this.centerX - radius, this.centerY - radius, radius * 2, radius * 2);
    }
    normalizedRadii() {
        const { concentricEdgeInset: concentricEdgeInset } = this;
        return {
            innerRadius: Math.max(Math.min(this.innerRadius, this.outerRadius) + concentricEdgeInset, 0),
            outerRadius: Math.max(Math.max(this.innerRadius, this.outerRadius) - concentricEdgeInset, 0)
        };
    }
    normalizedClipSector() {
        const { clipSector: clipSector } = this;
        if (clipSector == null) return;
        const { startAngle: startAngle, endAngle: endAngle } = $d77b025aa58d633c$var$clockwiseAngles(this.startAngle, this.endAngle);
        const { innerRadius: innerRadius, outerRadius: outerRadius } = this.normalizedRadii();
        const clipAngles = $d77b025aa58d633c$var$clockwiseAngles(clipSector.startAngle, clipSector.endAngle, startAngle);
        return new $d77b025aa58d633c$var$SectorBox(Math.max(startAngle, clipAngles.startAngle), Math.min(endAngle, clipAngles.endAngle), Math.max(innerRadius, clipSector.innerRadius), Math.min(outerRadius, clipSector.outerRadius));
    }
    getAngleOffset(radius) {
        return radius > 0 ? this.radialEdgeInset / radius : 0;
    }
    arc(r, angleSweep, a0, a1, outerArc, innerArc, start, inner) {
        if (r <= 0) return;
        const { startAngle: startAngle, endAngle: endAngle } = $d77b025aa58d633c$var$clockwiseAngles(this.startAngle, this.endAngle);
        const { innerRadius: innerRadius, outerRadius: outerRadius } = this.normalizedRadii();
        const clipSector = this.normalizedClipSector();
        if (inner && innerRadius <= 0) return;
        const innerAngleOffset = this.getAngleOffset(innerRadius);
        const outerAngleOffset = this.getAngleOffset(outerRadius);
        const angleOffset = inner ? this.getAngleOffset(innerRadius + r) : this.getAngleOffset(outerRadius - r);
        const angle = start ? startAngle + angleOffset + angleSweep : endAngle - angleOffset - angleSweep;
        const radius = inner ? innerRadius + r : outerRadius - r;
        const cx = radius * Math.cos(angle);
        const cy = radius * Math.sin(angle);
        if (clipSector != null) {
            const delta2 = 1e-6;
            if (!start && !(angle >= startAngle - delta2 && angle <= clipSector.endAngle - delta2)) return;
            if (start && !(angle >= clipSector.startAngle + delta2 && angle <= endAngle - delta2)) return;
            if (inner && !(radius >= clipSector.innerRadius - delta2)) return;
            if (!inner && !(radius <= clipSector.outerRadius + delta2)) return;
        }
        const arc = new $d77b025aa58d633c$var$Arc(cx, cy, r, a0, a1);
        if (clipSector != null) {
            if (inner) {
                arc.clipStart($d77b025aa58d633c$var$arcRadialLineIntersectionAngle(cx, cy, r, a0, a1, clipSector.endAngle - innerAngleOffset));
                arc.clipEnd($d77b025aa58d633c$var$arcRadialLineIntersectionAngle(cx, cy, r, a0, a1, clipSector.startAngle + innerAngleOffset));
            } else {
                arc.clipStart($d77b025aa58d633c$var$arcRadialLineIntersectionAngle(cx, cy, r, a0, a1, clipSector.startAngle + outerAngleOffset));
                arc.clipEnd($d77b025aa58d633c$var$arcRadialLineIntersectionAngle(cx, cy, r, a0, a1, clipSector.endAngle - outerAngleOffset));
            }
            let circleClipStart;
            let circleClipEnd;
            if (start) {
                circleClipStart = $d77b025aa58d633c$var$arcCircleIntersectionAngle(cx, cy, r, a0, a1, clipSector.innerRadius);
                circleClipEnd = $d77b025aa58d633c$var$arcCircleIntersectionAngle(cx, cy, r, a0, a1, clipSector.outerRadius);
            } else {
                circleClipStart = $d77b025aa58d633c$var$arcCircleIntersectionAngle(cx, cy, r, a0, a1, clipSector.outerRadius);
                circleClipEnd = $d77b025aa58d633c$var$arcCircleIntersectionAngle(cx, cy, r, a0, a1, clipSector.innerRadius);
            }
            arc.clipStart(circleClipStart);
            arc.clipEnd(circleClipEnd);
            if (circleClipStart != null) {
                const { x: x2, y: y2 } = arc.pointAt(circleClipStart);
                const theta2 = $d77b025aa58d633c$var$clockwiseAngle(Math.atan2(y2, x2), startAngle);
                if (start) innerArc == null || innerArc.clipStart(theta2);
                else outerArc.clipEnd(theta2);
            }
            if (circleClipEnd != null) {
                const { x: x2, y: y2 } = arc.pointAt(circleClipEnd);
                const theta2 = $d77b025aa58d633c$var$clockwiseAngle(Math.atan2(y2, x2), startAngle);
                if (start) outerArc.clipStart(theta2);
                else innerArc == null || innerArc.clipEnd(theta2);
            }
        }
        if (clipSector != null) {
            const { x: x2, y: y2 } = arc.pointAt((arc.a0 + arc.a1) / 2);
            if (!$d77b025aa58d633c$var$isPointInSector(x2, y2, clipSector)) return;
        }
        const { x: x, y: y } = arc.pointAt(start === inner ? arc.a0 : arc.a1);
        const theta = $d77b025aa58d633c$var$clockwiseAngle(Math.atan2(y, x), startAngle);
        const radialArc = inner ? innerArc : outerArc;
        if (start) radialArc == null || radialArc.clipStart(theta);
        else radialArc == null || radialArc.clipEnd(theta);
        return arc;
    }
    updatePath() {
        var _a, _b, _c, _d, _e;
        const delta2 = 1e-6;
        const { path: path, centerX: centerX, centerY: centerY, concentricEdgeInset: concentricEdgeInset, radialEdgeInset: radialEdgeInset } = this;
        let { startOuterCornerRadius: startOuterCornerRadius, endOuterCornerRadius: endOuterCornerRadius, startInnerCornerRadius: startInnerCornerRadius, endInnerCornerRadius: endInnerCornerRadius } = this;
        const { startAngle: startAngle, endAngle: endAngle } = $d77b025aa58d633c$var$clockwiseAngles(this.startAngle, this.endAngle);
        const { innerRadius: innerRadius, outerRadius: outerRadius } = this.normalizedRadii();
        const clipSector = this.normalizedClipSector();
        const sweepAngle = endAngle - startAngle;
        const fullPie = sweepAngle >= 2 * Math.PI - delta2;
        path.clear();
        if (((_a = clipSector == null ? void 0 : clipSector.startAngle) != null ? _a : startAngle) === ((_b = clipSector == null ? void 0 : clipSector.endAngle) != null ? _b : endAngle)) return;
        else if (fullPie && this.clipSector == null && startOuterCornerRadius === 0 && endOuterCornerRadius === 0 && startInnerCornerRadius === 0 && endInnerCornerRadius === 0) {
            path.moveTo(centerX + outerRadius * Math.cos(startAngle), centerY + outerRadius * Math.sin(startAngle));
            path.arc(centerX, centerY, outerRadius, startAngle, endAngle);
            if (innerRadius > concentricEdgeInset) {
                path.moveTo(centerX + innerRadius * Math.cos(endAngle), centerY + innerRadius * Math.sin(endAngle));
                path.arc(centerX, centerY, innerRadius, endAngle, startAngle, true);
            }
            path.closePath();
            return;
        }
        const innerAngleOffset = this.getAngleOffset(innerRadius);
        const outerAngleOffset = this.getAngleOffset(outerRadius);
        const outerAngleExceeded = sweepAngle < 2 * outerAngleOffset;
        if (outerAngleExceeded) return;
        const hasInnerSweep = ((_c = clipSector == null ? void 0 : clipSector.innerRadius) != null ? _c : innerRadius) > concentricEdgeInset;
        const innerAngleExceeded = innerRadius < concentricEdgeInset || sweepAngle < 2 * innerAngleOffset;
        const radialLength = outerRadius - innerRadius;
        const maxRadialLength = Math.max(startOuterCornerRadius, startInnerCornerRadius, endOuterCornerRadius, endInnerCornerRadius);
        const initialScalingFactor = maxRadialLength > 0 ? Math.min(radialLength / maxRadialLength, 1) : 1;
        startOuterCornerRadius *= initialScalingFactor;
        endOuterCornerRadius *= initialScalingFactor;
        startInnerCornerRadius *= initialScalingFactor;
        endInnerCornerRadius *= initialScalingFactor;
        const outerScalingFactor = $d77b025aa58d633c$var$radiiScalingFactor(outerRadius, sweepAngle - 2 * outerAngleOffset, -startOuterCornerRadius, -endOuterCornerRadius);
        startOuterCornerRadius *= outerScalingFactor;
        endOuterCornerRadius *= outerScalingFactor;
        if (!innerAngleExceeded && hasInnerSweep) {
            const innerScalingFactor = $d77b025aa58d633c$var$radiiScalingFactor(innerRadius, sweepAngle - 2 * innerAngleOffset, startInnerCornerRadius, endInnerCornerRadius);
            startInnerCornerRadius *= innerScalingFactor;
            endInnerCornerRadius *= innerScalingFactor;
        } else {
            startInnerCornerRadius = 0;
            endInnerCornerRadius = 0;
        }
        const maxCombinedRadialLength = Math.max(startOuterCornerRadius + startInnerCornerRadius, endOuterCornerRadius + endInnerCornerRadius);
        const edgesScalingFactor = maxCombinedRadialLength > 0 ? Math.min(radialLength / maxCombinedRadialLength, 1) : 1;
        startOuterCornerRadius *= edgesScalingFactor;
        endOuterCornerRadius *= edgesScalingFactor;
        startInnerCornerRadius *= edgesScalingFactor;
        endInnerCornerRadius *= edgesScalingFactor;
        let startOuterCornerRadiusAngleSweep = 0;
        let endOuterCornerRadiusAngleSweep = 0;
        const startOuterCornerRadiusSweep = startOuterCornerRadius / (outerRadius - startOuterCornerRadius);
        const endOuterCornerRadiusSweep = endOuterCornerRadius / (outerRadius - endOuterCornerRadius);
        if (startOuterCornerRadiusSweep >= 0 && startOuterCornerRadiusSweep < 1 - delta2) startOuterCornerRadiusAngleSweep = Math.asin(startOuterCornerRadiusSweep);
        else {
            startOuterCornerRadiusAngleSweep = sweepAngle / 2;
            const maxStartOuterCornerRadius = outerRadius / (1 / Math.sin(startOuterCornerRadiusAngleSweep) + 1);
            startOuterCornerRadius = Math.min(maxStartOuterCornerRadius, startOuterCornerRadius);
        }
        if (endOuterCornerRadiusSweep >= 0 && endOuterCornerRadiusSweep < 1 - delta2) endOuterCornerRadiusAngleSweep = Math.asin(endOuterCornerRadiusSweep);
        else {
            endOuterCornerRadiusAngleSweep = sweepAngle / 2;
            const maxEndOuterCornerRadius = outerRadius / (1 / Math.sin(endOuterCornerRadiusAngleSweep) + 1);
            endOuterCornerRadius = Math.min(maxEndOuterCornerRadius, endOuterCornerRadius);
        }
        const startInnerCornerRadiusAngleSweep = Math.asin(startInnerCornerRadius / (innerRadius + startInnerCornerRadius));
        const endInnerCornerRadiusAngleSweep = Math.asin(endInnerCornerRadius / (innerRadius + endInnerCornerRadius));
        const outerArcRadius = (_d = clipSector == null ? void 0 : clipSector.outerRadius) != null ? _d : outerRadius;
        const outerArcRadiusOffset = this.getAngleOffset(outerArcRadius);
        const outerArc = new $d77b025aa58d633c$var$Arc(0, 0, outerArcRadius, startAngle + outerArcRadiusOffset, endAngle - outerArcRadiusOffset);
        const innerArcRadius = (_e = clipSector == null ? void 0 : clipSector.innerRadius) != null ? _e : innerRadius;
        const innerArcRadiusOffset = this.getAngleOffset(innerArcRadius);
        const innerArc = hasInnerSweep ? new $d77b025aa58d633c$var$Arc(0, 0, innerArcRadius, startAngle + innerArcRadiusOffset, endAngle - innerArcRadiusOffset) : void 0;
        if (clipSector != null) {
            outerArc.clipStart(clipSector.startAngle);
            outerArc.clipEnd(clipSector.endAngle);
            innerArc == null || innerArc.clipStart(clipSector.startAngle);
            innerArc == null || innerArc.clipEnd(clipSector.endAngle);
        }
        const startOuterArc = this.arc(startOuterCornerRadius, startOuterCornerRadiusAngleSweep, startAngle - Math.PI * 0.5, startAngle + startOuterCornerRadiusAngleSweep, outerArc, innerArc, true, false);
        const endOuterArc = this.arc(endOuterCornerRadius, endOuterCornerRadiusAngleSweep, endAngle - endOuterCornerRadiusAngleSweep, endAngle + Math.PI * 0.5, outerArc, innerArc, false, false);
        const endInnerArc = this.arc(endInnerCornerRadius, endInnerCornerRadiusAngleSweep, endAngle + Math.PI * 0.5, endAngle + Math.PI - endInnerCornerRadiusAngleSweep, outerArc, innerArc, false, true);
        const startInnerArc = this.arc(startInnerCornerRadius, startInnerCornerRadiusAngleSweep, startAngle + Math.PI + startInnerCornerRadiusAngleSweep, startAngle + Math.PI * 1.5, outerArc, innerArc, true, true);
        if (innerAngleExceeded) {
            const x = sweepAngle < Math.PI * 0.5 ? radialEdgeInset * (1 + Math.cos(sweepAngle)) / Math.sin(sweepAngle) : NaN;
            let r;
            if (x > 0 && x < outerRadius) r = Math.max(Math.hypot(radialEdgeInset, x), innerRadius);
            else r = innerRadius;
            const midAngle = startAngle + sweepAngle * 0.5;
            path.moveTo(centerX + r * Math.cos(midAngle), centerY + r * Math.sin(midAngle));
        } else if ((startInnerArc == null ? void 0 : startInnerArc.isValid()) === true) {
            const { x: x, y: y } = startInnerArc.pointAt(startInnerArc.a1);
            path.moveTo(centerX + x, centerY + y);
        } else if ((innerArc == null ? void 0 : innerArc.isValid()) === true) {
            const { x: x, y: y } = innerArc.pointAt(innerArc.a0);
            path.moveTo(centerX + x, centerY + y);
        } else {
            const midAngle = startAngle + sweepAngle / 2;
            const cx = innerRadius * Math.cos(midAngle);
            const cy = innerRadius * Math.sin(midAngle);
            path.moveTo(centerX + cx, centerY + cy);
        }
        if ((startOuterArc == null ? void 0 : startOuterArc.isValid()) === true) {
            const { cx: cx, cy: cy, r: r, a0: a0, a1: a1 } = startOuterArc;
            path.arc(centerX + cx, centerY + cy, r, a0, a1);
        }
        if (outerArc.isValid()) {
            const { r: r, a0: a0, a1: a1 } = outerArc;
            path.arc(centerX, centerY, r, a0, a1);
        }
        if ((endOuterArc == null ? void 0 : endOuterArc.isValid()) === true) {
            const { cx: cx, cy: cy, r: r, a0: a0, a1: a1 } = endOuterArc;
            path.arc(centerX + cx, centerY + cy, r, a0, a1);
        }
        if (!innerAngleExceeded) {
            if ((endInnerArc == null ? void 0 : endInnerArc.isValid()) === true) {
                const { cx: cx, cy: cy, r: r, a0: a0, a1: a1 } = endInnerArc;
                path.arc(centerX + cx, centerY + cy, r, a0, a1);
            }
            if ((innerArc == null ? void 0 : innerArc.isValid()) === true) {
                const { r: r, a0: a0, a1: a1 } = innerArc;
                path.arc(centerX, centerY, r, a1, a0, true);
            }
            if ((startInnerArc == null ? void 0 : startInnerArc.isValid()) === true) {
                const { cx: cx, cy: cy, r: r, a0: a0, a1: a1 } = startInnerArc;
                path.arc(centerX + cx, centerY + cy, r, a0, a1);
            }
        }
        path.closePath();
    }
    isPointInPath(x, y) {
        var _a;
        const point = this.transformPoint(x, y);
        const { startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius } = (_a = this.clipSector) != null ? _a : this;
        return $d77b025aa58d633c$var$isPointInSector(point.x, point.y, {
            startAngle: startAngle,
            endAngle: endAngle,
            innerRadius: Math.min(innerRadius, outerRadius),
            outerRadius: Math.max(innerRadius, outerRadius)
        });
    }
};
$d77b025aa58d633c$var$Sector.className = "Sector";
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ScenePathChangeDetection()
], $d77b025aa58d633c$var$Sector.prototype, "centerX", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ScenePathChangeDetection()
], $d77b025aa58d633c$var$Sector.prototype, "centerY", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ScenePathChangeDetection()
], $d77b025aa58d633c$var$Sector.prototype, "innerRadius", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ScenePathChangeDetection()
], $d77b025aa58d633c$var$Sector.prototype, "outerRadius", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ScenePathChangeDetection()
], $d77b025aa58d633c$var$Sector.prototype, "startAngle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ScenePathChangeDetection()
], $d77b025aa58d633c$var$Sector.prototype, "endAngle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ScenePathChangeDetection()
], $d77b025aa58d633c$var$Sector.prototype, "clipSector", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ScenePathChangeDetection()
], $d77b025aa58d633c$var$Sector.prototype, "concentricEdgeInset", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ScenePathChangeDetection()
], $d77b025aa58d633c$var$Sector.prototype, "radialEdgeInset", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ScenePathChangeDetection()
], $d77b025aa58d633c$var$Sector.prototype, "startOuterCornerRadius", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ScenePathChangeDetection()
], $d77b025aa58d633c$var$Sector.prototype, "endOuterCornerRadius", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ScenePathChangeDetection()
], $d77b025aa58d633c$var$Sector.prototype, "startInnerCornerRadius", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ScenePathChangeDetection()
], $d77b025aa58d633c$var$Sector.prototype, "endInnerCornerRadius", 2);
// packages/ag-charts-community/src/chart/series/polar/donutSeriesProperties.ts
var $d77b025aa58d633c$var$DonutTitle = class extends $d77b025aa58d633c$var$Caption {
    constructor(){
        super(...arguments);
        this.showInLegend = false;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN)
], $d77b025aa58d633c$var$DonutTitle.prototype, "showInLegend", 2);
var $d77b025aa58d633c$var$DonutInnerLabel = class extends $d77b025aa58d633c$var$Label {
    constructor(){
        super(...arguments);
        this.margin = 2;
    }
    set(properties, _reset) {
        return super.set(properties);
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING)
], $d77b025aa58d633c$var$DonutInnerLabel.prototype, "text", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$NUMBER)
], $d77b025aa58d633c$var$DonutInnerLabel.prototype, "margin", 2);
var $d77b025aa58d633c$var$DonutInnerCircle = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.fill = "transparent";
        this.fillOpacity = 1;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$COLOR_STRING)
], $d77b025aa58d633c$var$DonutInnerCircle.prototype, "fill", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$RATIO)
], $d77b025aa58d633c$var$DonutInnerCircle.prototype, "fillOpacity", 2);
var $d77b025aa58d633c$var$DonutSeriesCalloutLabel = class extends $d77b025aa58d633c$var$Label {
    constructor(){
        super(...arguments);
        this.offset = 3;
        this.minAngle = 0;
        this.minSpacing = 4;
        this.maxCollisionOffset = 50;
        this.avoidCollisions = true;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$DonutSeriesCalloutLabel.prototype, "offset", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$DEGREE)
], $d77b025aa58d633c$var$DonutSeriesCalloutLabel.prototype, "minAngle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$DonutSeriesCalloutLabel.prototype, "minSpacing", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$DonutSeriesCalloutLabel.prototype, "maxCollisionOffset", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN)
], $d77b025aa58d633c$var$DonutSeriesCalloutLabel.prototype, "avoidCollisions", 2);
var $d77b025aa58d633c$var$DonutSeriesSectorLabel = class extends $d77b025aa58d633c$var$Label {
    constructor(){
        super(...arguments);
        this.positionOffset = 0;
        this.positionRatio = 0.5;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$NUMBER)
], $d77b025aa58d633c$var$DonutSeriesSectorLabel.prototype, "positionOffset", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$RATIO)
], $d77b025aa58d633c$var$DonutSeriesSectorLabel.prototype, "positionRatio", 2);
var $d77b025aa58d633c$var$DonutSeriesCalloutLine = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.length = 10;
        this.strokeWidth = 1;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$COLOR_STRING_ARRAY, {
        optional: true
    })
], $d77b025aa58d633c$var$DonutSeriesCalloutLine.prototype, "colors", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$DonutSeriesCalloutLine.prototype, "length", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$DonutSeriesCalloutLine.prototype, "strokeWidth", 2);
var $d77b025aa58d633c$var$DonutSeriesProperties = class extends $d77b025aa58d633c$var$SeriesProperties {
    constructor(){
        super(...arguments);
        this.fills = Object.values($d77b025aa58d633c$var$DEFAULT_FILLS);
        this.strokes = Object.values($d77b025aa58d633c$var$DEFAULT_STROKES);
        this.fillOpacity = 1;
        this.strokeOpacity = 1;
        this.lineDash = [
            0
        ];
        this.lineDashOffset = 0;
        this.cornerRadius = 0;
        this.rotation = 0;
        this.outerRadiusOffset = 0;
        this.outerRadiusRatio = 1;
        this.strokeWidth = 1;
        this.sectorSpacing = void 0;
        this.innerLabels = new $d77b025aa58d633c$var$PropertiesArray($d77b025aa58d633c$var$DonutInnerLabel);
        this.title = new $d77b025aa58d633c$var$DonutTitle();
        this.innerCircle = new $d77b025aa58d633c$var$DonutInnerCircle();
        this.shadow = new $d77b025aa58d633c$var$DropShadow();
        this.calloutLabel = new $d77b025aa58d633c$var$DonutSeriesCalloutLabel();
        this.sectorLabel = new $d77b025aa58d633c$var$DonutSeriesSectorLabel();
        this.calloutLine = new $d77b025aa58d633c$var$DonutSeriesCalloutLine();
        this.tooltip = new $d77b025aa58d633c$var$SeriesTooltip();
        this.__BACKGROUND_COLOR_DO_NOT_USE = void 0;
    }
    isValid() {
        const superIsValid = super.isValid();
        if (this.innerRadiusRatio == null && this.innerRadiusOffset == null) {
            $d77b025aa58d633c$var$Logger.warnOnce("Either an [innerRadiusRatio] or an [innerRadiusOffset] must be set to render a donut series.");
            return false;
        }
        return superIsValid;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING)
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "angleKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "angleName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "radiusKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "radiusName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER, {
        optional: true
    })
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "radiusMin", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER, {
        optional: true
    })
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "radiusMax", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "calloutLabelKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "calloutLabelName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "sectorLabelKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "sectorLabelName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "legendItemKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$COLOR_STRING_ARRAY)
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "fills", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$COLOR_STRING_ARRAY)
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "strokes", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$RATIO)
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "fillOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$RATIO)
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "strokeOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$LINE_DASH)
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "lineDash", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "lineDashOffset", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "cornerRadius", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$FUNCTION, {
        optional: true
    })
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "formatter", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$DEGREE)
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "rotation", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$NUMBER)
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "outerRadiusOffset", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$RATIO)
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "outerRadiusRatio", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$NUMBER, {
        optional: true
    })
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "innerRadiusOffset", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$RATIO, {
        optional: true
    })
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "innerRadiusRatio", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "strokeWidth", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER, {
        optional: true
    })
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "sectorSpacing", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT_ARRAY)
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "innerLabels", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "title", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "innerCircle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "shadow", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "calloutLabel", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "sectorLabel", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "calloutLine", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "tooltip", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$DonutSeriesProperties.prototype, "__BACKGROUND_COLOR_DO_NOT_USE", 2);
// packages/ag-charts-community/src/chart/series/polar/pieUtil.ts
function $d77b025aa58d633c$var$preparePieSeriesAnimationFunctions(initialLoad, rotationDegrees, scaleFn, oldScaleFn) {
    const scale2 = [
        scaleFn.convert(0),
        scaleFn.convert(1)
    ];
    const oldScale = [
        oldScaleFn.convert(0),
        oldScaleFn.convert(1)
    ];
    const rotation = Math.PI / -2 + $d77b025aa58d633c$var$toRadians(rotationDegrees);
    const phase = initialLoad ? "initial" : "update";
    const scaleToNewRadius = ({ radius: radius })=>{
        return {
            innerRadius: scale2[0],
            outerRadius: scale2[0] + (scale2[1] - scale2[0]) * radius
        };
    };
    const scaleToOldRadius = ({ radius: radius })=>{
        return {
            innerRadius: oldScale[0],
            outerRadius: oldScale[0] + (oldScale[1] - oldScale[0]) * radius
        };
    };
    const fromFn = (sect, datum, status, { prevFromProps: prevFromProps })=>{
        var _a, _b, _c, _d, _e, _f;
        let { startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius } = sect;
        let { fill: fill, stroke: stroke } = datum.sectorFormat;
        if (status === "unknown" || status === "added" && !prevFromProps) {
            startAngle = rotation;
            endAngle = rotation;
            innerRadius = datum.innerRadius;
            outerRadius = datum.outerRadius;
        } else if (status === "added" && prevFromProps) {
            startAngle = (_a = prevFromProps.endAngle) != null ? _a : rotation;
            endAngle = (_b = prevFromProps.endAngle) != null ? _b : rotation;
            innerRadius = (_c = prevFromProps.innerRadius) != null ? _c : datum.innerRadius;
            outerRadius = (_d = prevFromProps.outerRadius) != null ? _d : datum.outerRadius;
        }
        if (status === "added" && !initialLoad) {
            const radii = scaleToOldRadius(datum);
            innerRadius = radii.innerRadius;
            outerRadius = radii.outerRadius;
        }
        if (status === "updated") {
            fill = (_e = sect.fill) != null ? _e : fill;
            stroke = (_f = sect.stroke) != null ? _f : stroke;
        }
        return {
            startAngle: startAngle,
            endAngle: endAngle,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            fill: fill,
            stroke: stroke,
            phase: phase
        };
    };
    const toFn = (_sect, datum, status, { prevLive: prevLive })=>{
        var _a, _b;
        let { startAngle: startAngle, endAngle: endAngle, innerRadius: innerRadius, outerRadius: outerRadius } = datum;
        const { stroke: stroke, fill: fill } = datum.sectorFormat;
        if (status === "removed" && prevLive) {
            startAngle = (_a = prevLive.datum) == null ? void 0 : _a.endAngle;
            endAngle = (_b = prevLive.datum) == null ? void 0 : _b.endAngle;
        } else if (status === "removed" && !prevLive) {
            startAngle = rotation;
            endAngle = rotation;
        }
        if (status === "removed") {
            const radii = scaleToNewRadius(datum);
            innerRadius = radii.innerRadius;
            outerRadius = radii.outerRadius;
        }
        return {
            startAngle: startAngle,
            endAngle: endAngle,
            outerRadius: outerRadius,
            innerRadius: innerRadius,
            stroke: stroke,
            fill: fill
        };
    };
    const innerCircleFromFn = (node, _)=>{
        var _a, _b, _c;
        return {
            size: (_c = (_b = (_a = node.previousDatum) == null ? void 0 : _a.radius) != null ? _b : node.size) != null ? _c : 0,
            phase: phase
        };
    };
    const innerCircleToFn = (_, datum)=>{
        var _a;
        return {
            size: (_a = datum.radius) != null ? _a : 0
        };
    };
    return {
        nodes: {
            toFn: toFn,
            fromFn: fromFn
        },
        innerCircle: {
            fromFn: innerCircleFromFn,
            toFn: innerCircleToFn
        }
    };
}
function $d77b025aa58d633c$var$resetPieSelectionsFn(_node, datum) {
    return {
        startAngle: datum.startAngle,
        endAngle: datum.endAngle,
        innerRadius: datum.innerRadius,
        outerRadius: datum.outerRadius,
        fill: datum.sectorFormat.fill,
        stroke: datum.sectorFormat.stroke
    };
}
function $d77b025aa58d633c$var$pickByMatchingAngle(series, point) {
    const dy = point.y - series.centerY;
    const dx = point.x - series.centerX;
    const angle = Math.atan2(dy, dx);
    const sectors = series.getItemNodes();
    for (const sector of sectors){
        if (sector.datum.missing === true) continue;
        if ($d77b025aa58d633c$var$isBetweenAngles(angle, sector.startAngle, sector.endAngle)) {
            const radius = Math.sqrt(dx * dx + dy * dy);
            let distance2 = 0;
            if (radius < sector.innerRadius) distance2 = sector.innerRadius - radius;
            else if (radius > sector.outerRadius) distance2 = radius - sector.outerRadius;
            return {
                datum: sector.datum,
                distance: distance2
            };
        }
    }
    return void 0;
}
function $d77b025aa58d633c$var$computeSectorFocusBounds(series, opts) {
    const nodeData = series.getNodeData();
    if (nodeData === void 0) return void 0;
    const { centerX: centerX, centerY: centerY } = series;
    const datum = nodeData[opts.datumIndex];
    const pointVars = [
        {
            radius: datum.innerRadius,
            angle: datum.startAngle
        },
        {
            radius: datum.innerRadius,
            angle: datum.endAngle
        },
        {
            radius: datum.outerRadius,
            angle: datum.startAngle
        },
        {
            radius: datum.outerRadius,
            angle: datum.endAngle
        }
    ];
    const rightAngles = [
        0,
        Math.PI / 2,
        Math.PI,
        3 * Math.PI / 2
    ];
    for (const rightAngle of rightAngles)if ($d77b025aa58d633c$var$isBetweenAngles(rightAngle, datum.startAngle, datum.endAngle)) pointVars.push({
        radius: datum.outerRadius,
        angle: rightAngle
    });
    const points = pointVars.map(({ radius: radius, angle: angle })=>$d77b025aa58d633c$var$displacePointFromVector(centerX, centerY, radius, angle));
    const xs = points.map((p)=>p.x);
    const ys = points.map((p)=>p.y);
    const x = Math.min(...xs);
    const y = Math.min(...ys);
    const width = Math.max(...xs) - x;
    const height = Math.max(...ys) - y;
    return new $d77b025aa58d633c$var$BBox(x, y, width, height);
}
// packages/ag-charts-community/src/chart/series/polar/polarSeries.ts
var $d77b025aa58d633c$var$PolarSeries = class extends $d77b025aa58d633c$var$DataModelSeries {
    constructor(_a){
        var _b = _a, { useLabelLayer: useLabelLayer = false, pickModes: pickModes = [
            0 /* EXACT_SHAPE_MATCH */ 
        ], canHaveAxes: canHaveAxes = false, animationResetFns: animationResetFns } = _b, opts = $d77b025aa58d633c$var$__objRest(_b, [
            "useLabelLayer",
            "pickModes",
            "canHaveAxes",
            "animationResetFns"
        ]);
        super($d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, opts), {
            useLabelLayer: useLabelLayer,
            pickModes: pickModes,
            contentGroupVirtual: false,
            directionKeys: {
                ["x" /* X */ ]: [
                    "angleKey"
                ],
                ["y" /* Y */ ]: [
                    "radiusKey"
                ]
            },
            directionNames: {
                ["x" /* X */ ]: [
                    "angleName"
                ],
                ["y" /* Y */ ]: [
                    "radiusName"
                ]
            },
            canHaveAxes: canHaveAxes
        }));
        this.itemGroup = this.contentGroup.appendChild(new $d77b025aa58d633c$var$Group());
        this.nodeData = [];
        this.itemSelection = $d77b025aa58d633c$var$Selection.select(this.itemGroup, ()=>this.nodeFactory(), false);
        this.labelSelection = $d77b025aa58d633c$var$Selection.select(this.labelGroup, $d77b025aa58d633c$var$Text, false);
        this.highlightSelection = $d77b025aa58d633c$var$Selection.select(this.highlightGroup, ()=>this.nodeFactory());
        /**
     * The center of the polar series (for example, the center of a pie).
     * If the polar chart has multiple series, all of them will have their
     * center set to the same value as a result of the polar chart layout.
     * The center coordinates are not supposed to be set by the user.
     */ this.centerX = 0;
        this.centerY = 0;
        /**
     * The maximum radius the series can use.
     * This value is set automatically as a result of the polar chart layout
     * and is not supposed to be set by the user.
     */ this.radius = 0;
        this.showFocusBox = false;
        this.itemGroup.zIndexSubOrder = [
            ()=>this._declarationOrder,
            1
        ];
        this.animationResetFns = animationResetFns;
        this.animationState = new $d77b025aa58d633c$var$StateMachine("empty", {
            empty: {
                update: {
                    target: "ready",
                    action: (data)=>this.animateEmptyUpdateReady(data)
                },
                reset: "empty",
                skip: "ready"
            },
            ready: {
                updateData: "waiting",
                clear: "clearing",
                highlight: (data)=>this.animateReadyHighlight(data),
                highlightMarkers: (data)=>this.animateReadyHighlightMarkers(data),
                resize: (data)=>this.animateReadyResize(data),
                reset: "empty",
                skip: "ready"
            },
            waiting: {
                update: {
                    target: "ready",
                    action: (data)=>this.animateWaitingUpdateReady(data)
                },
                reset: "empty",
                skip: "ready"
            },
            clearing: {
                update: {
                    target: "empty",
                    action: (data)=>this.animateClearingUpdateEmpty(data)
                },
                reset: "empty",
                skip: "ready"
            }
        }, ()=>this.checkProcessedDataAnimatable());
    }
    getItemNodes() {
        return this.itemGroup.children;
    }
    getNodeData() {
        return this.nodeData;
    }
    resetAnimation(phase) {
        if (phase === "initial") this.animationState.transition("reset");
        else if (phase === "ready") this.animationState.transition("skip");
    }
    getLabelData() {
        return [];
    }
    computeLabelsBBox(_options, _seriesRect) {
        return null;
    }
    resetAllAnimation() {
        var _a;
        const { item: item, label: label } = (_a = this.animationResetFns) != null ? _a : {};
        this.ctx.animationManager.stopByAnimationGroupId(this.id);
        if (item) $d77b025aa58d633c$var$resetMotion([
            this.itemSelection,
            this.highlightSelection
        ], item);
        if (label) $d77b025aa58d633c$var$resetMotion([
            this.labelSelection
        ], label);
        this.itemSelection.cleanup();
        this.labelSelection.cleanup();
        this.highlightSelection.cleanup();
    }
    animateEmptyUpdateReady(_data) {
        this.ctx.animationManager.skipCurrentBatch();
        this.resetAllAnimation();
    }
    animateWaitingUpdateReady(_data) {
        this.ctx.animationManager.skipCurrentBatch();
        this.resetAllAnimation();
    }
    animateReadyHighlight(_data) {
        var _a;
        const { item: item } = (_a = this.animationResetFns) != null ? _a : {};
        if (item) $d77b025aa58d633c$var$resetMotion([
            this.highlightSelection
        ], item);
    }
    animateReadyHighlightMarkers(_data) {}
    animateReadyResize(_data) {
        this.resetAllAnimation();
    }
    animateClearingUpdateEmpty(_data) {
        this.ctx.animationManager.skipCurrentBatch();
        this.resetAllAnimation();
    }
    animationTransitionClear() {
        this.animationState.transition("clear", this.getAnimationData());
    }
    getAnimationData(seriesRect) {
        return {
            seriesRect: seriesRect
        };
    }
};
// packages/ag-charts-community/src/chart/series/polar/donutSeries.ts
var $d77b025aa58d633c$var$DonutSeriesNodeEvent = class extends $d77b025aa58d633c$var$SeriesNodeEvent {
    constructor(type, nativeEvent, datum, series){
        super(type, nativeEvent, datum, series);
        this.angleKey = series.properties.angleKey;
        this.radiusKey = series.properties.radiusKey;
        this.calloutLabelKey = series.properties.calloutLabelKey;
        this.sectorLabelKey = series.properties.sectorLabelKey;
    }
};
var $d77b025aa58d633c$var$DonutSeries = class extends $d77b025aa58d633c$var$PolarSeries {
    constructor(moduleCtx){
        super({
            moduleCtx: moduleCtx,
            pickModes: [
                0 /* EXACT_SHAPE_MATCH */ 
            ],
            useLabelLayer: true,
            animationResetFns: {
                item: $d77b025aa58d633c$var$resetPieSelectionsFn,
                label: $d77b025aa58d633c$var$resetLabelFn
            }
        });
        this.properties = new $d77b025aa58d633c$var$DonutSeriesProperties();
        this.previousRadiusScale = new $d77b025aa58d633c$var$LinearScale();
        this.radiusScale = new $d77b025aa58d633c$var$LinearScale();
        // The group node that contains the background graphics.
        this.backgroundGroup = this.rootGroup.appendChild(new $d77b025aa58d633c$var$Group({
            name: `${this.id}-background`,
            layer: true,
            zIndex: 0 /* SERIES_BACKGROUND_ZINDEX */ 
        }));
        // AG-6193 If the sum of all datums is 0, then we'll draw 1 or 2 rings to represent the empty series.
        this.zerosumRingsGroup = this.backgroundGroup.appendChild(new $d77b025aa58d633c$var$Group({
            name: `${this.id}-zerosumRings`
        }));
        this.zerosumOuterRing = this.zerosumRingsGroup.appendChild(new $d77b025aa58d633c$var$Circle());
        this.zerosumInnerRing = this.zerosumRingsGroup.appendChild(new $d77b025aa58d633c$var$Circle());
        this.innerCircleGroup = this.backgroundGroup.appendChild(new $d77b025aa58d633c$var$Group({
            name: `${this.id}-innerCircle`
        }));
        // When a user toggles a series item (e.g. from the legend), its boolean state is recorded here.
        this.seriesItemEnabled = [];
        this.surroundingRadius = void 0;
        this.NodeEvent = $d77b025aa58d633c$var$DonutSeriesNodeEvent;
        this.angleScale = new $d77b025aa58d633c$var$LinearScale();
        this.angleScale.domain = [
            0,
            1
        ];
        this.angleScale.range = [
            -Math.PI,
            Math.PI
        ].map((angle)=>angle + Math.PI / 2);
        const pieCalloutLabels = new $d77b025aa58d633c$var$Group({
            name: "pieCalloutLabels"
        });
        const pieSectorLabels = new $d77b025aa58d633c$var$Group({
            name: "pieSectorLabels"
        });
        const innerLabels = new $d77b025aa58d633c$var$Group({
            name: "innerLabels"
        });
        this.labelGroup.append(pieCalloutLabels);
        this.labelGroup.append(pieSectorLabels);
        this.labelGroup.append(innerLabels);
        this.calloutLabelSelection = $d77b025aa58d633c$var$Selection.select(pieCalloutLabels, $d77b025aa58d633c$var$Group);
        this.sectorLabelSelection = $d77b025aa58d633c$var$Selection.select(pieSectorLabels, $d77b025aa58d633c$var$Text);
        this.innerLabelsSelection = $d77b025aa58d633c$var$Selection.select(innerLabels, $d77b025aa58d633c$var$Text);
        this.innerCircleSelection = $d77b025aa58d633c$var$Selection.select(this.innerCircleGroup, $d77b025aa58d633c$var$Circle);
    }
    addChartEventListeners() {
        var _a;
        this.destroyFns.push((_a = this.ctx.chartEventManager) == null ? void 0 : _a.addListener("legend-item-click", (event)=>this.onLegendItemClick(event)));
    }
    get visible() {
        return super.visible && (this.seriesItemEnabled.length === 0 || this.seriesItemEnabled.some((visible)=>visible));
    }
    nodeFactory() {
        return new $d77b025aa58d633c$var$Sector();
    }
    getSeriesDomain(direction) {
        if (direction === "x" /* X */ ) return this.angleScale.domain;
        else return this.radiusScale.domain;
    }
    processData(dataController) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            var _a, _b, _c, _d, _e;
            if (this.data == null || !this.properties.isValid()) return;
            let { data: data } = this;
            const { visible: visible, seriesItemEnabled: seriesItemEnabled } = this;
            const { angleKey: angleKey, radiusKey: radiusKey, calloutLabelKey: calloutLabelKey, sectorLabelKey: sectorLabelKey, legendItemKey: legendItemKey } = this.properties;
            const animationEnabled = !this.ctx.animationManager.isSkipped();
            const extraKeyProps = [];
            const extraProps = [];
            if (legendItemKey) extraKeyProps.push($d77b025aa58d633c$var$keyProperty(legendItemKey, "band", {
                id: `legendItemKey`
            }));
            else if (calloutLabelKey) extraKeyProps.push($d77b025aa58d633c$var$keyProperty(calloutLabelKey, "band", {
                id: `calloutLabelKey`
            }));
            else if (sectorLabelKey) extraKeyProps.push($d77b025aa58d633c$var$keyProperty(sectorLabelKey, "band", {
                id: `sectorLabelKey`
            }));
            const radiusScaleType = this.radiusScale.type;
            const angleScaleType = this.radiusScale.type;
            if (radiusKey) extraProps.push($d77b025aa58d633c$var$rangedValueProperty(radiusKey, {
                id: "radiusValue",
                min: (_a = this.properties.radiusMin) != null ? _a : 0,
                max: this.properties.radiusMax
            }), $d77b025aa58d633c$var$valueProperty(radiusKey, radiusScaleType, {
                id: `radiusRaw`
            }), // Raw value pass-through.
            $d77b025aa58d633c$var$normalisePropertyTo({
                id: "radiusValue"
            }, [
                0,
                1
            ], 1, (_b = this.properties.radiusMin) != null ? _b : 0, this.properties.radiusMax));
            if (calloutLabelKey) extraProps.push($d77b025aa58d633c$var$valueProperty(calloutLabelKey, "band", {
                id: `calloutLabelValue`
            }));
            if (sectorLabelKey) extraProps.push($d77b025aa58d633c$var$valueProperty(sectorLabelKey, "band", {
                id: `sectorLabelValue`
            }));
            if (legendItemKey) extraProps.push($d77b025aa58d633c$var$valueProperty(legendItemKey, "band", {
                id: `legendItemValue`
            }));
            if (animationEnabled && this.processedData && extraKeyProps.length > 0) extraProps.push($d77b025aa58d633c$var$diff(this.processedData));
            extraProps.push($d77b025aa58d633c$var$animationValidation());
            data = data.map((d, idx)=>visible && seriesItemEnabled[idx] ? d : $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, d), {
                    [angleKey]: 0
                }));
            yield this.requestDataModel(dataController, data, {
                props: [
                    ...extraKeyProps,
                    $d77b025aa58d633c$var$accumulativeValueProperty(angleKey, angleScaleType, {
                        id: `angleValue`,
                        onlyPositive: true
                    }),
                    $d77b025aa58d633c$var$valueProperty(angleKey, angleScaleType, {
                        id: `angleRaw`
                    }),
                    // Raw value pass-through.
                    $d77b025aa58d633c$var$normalisePropertyTo({
                        id: "angleValue"
                    }, [
                        0,
                        1
                    ], 0, 0),
                    ...extraProps
                ]
            });
            for (const valueDef of (_e = (_d = (_c = this.processedData) == null ? void 0 : _c.defs) == null ? void 0 : _d.values) != null ? _e : []){
                const { id: id, missing: missing, property: property } = valueDef;
                const missCount = $d77b025aa58d633c$var$getMissCount(this, missing);
                if (id !== "angleRaw" && missCount > 0) $d77b025aa58d633c$var$Logger.warnOnce(`no value was found for the key '${String(property)}' on ${missCount} data element${missCount > 1 ? "s" : ""}`);
            }
            this.animationState.transition("updateData");
        });
    }
    maybeRefreshNodeData() {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            var _a;
            if (!this.nodeDataRefresh) return;
            const { nodeData: nodeData = [] } = (_a = yield this.createNodeData()) != null ? _a : {};
            this.nodeData = nodeData;
            this.nodeDataRefresh = false;
        });
    }
    getProcessedDataIndexes(dataModel) {
        const angleIdx = dataModel.resolveProcessedDataIndexById(this, `angleValue`);
        const radiusIdx = this.properties.radiusKey ? dataModel.resolveProcessedDataIndexById(this, `radiusValue`) : -1;
        const calloutLabelIdx = this.properties.calloutLabelKey ? dataModel.resolveProcessedDataIndexById(this, `calloutLabelValue`) : -1;
        const sectorLabelIdx = this.properties.sectorLabelKey ? dataModel.resolveProcessedDataIndexById(this, `sectorLabelValue`) : -1;
        const legendItemIdx = this.properties.legendItemKey ? dataModel.resolveProcessedDataIndexById(this, `legendItemValue`) : -1;
        return {
            angleIdx: angleIdx,
            radiusIdx: radiusIdx,
            calloutLabelIdx: calloutLabelIdx,
            sectorLabelIdx: sectorLabelIdx,
            legendItemIdx: legendItemIdx
        };
    }
    createNodeData() {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            const { id: seriesId, processedData: processedData, dataModel: dataModel, angleScale: angleScale } = this;
            const { rotation: rotation, innerRadiusRatio: innerRadiusRatio } = this.properties;
            if (!this.properties.isValid()) {
                this.zerosumOuterRing.visible = true;
                this.zerosumInnerRing.visible = true;
                return {
                    itemId: seriesId,
                    nodeData: [],
                    labelData: []
                };
            }
            if (!processedData || !dataModel || processedData.type !== "ungrouped") return;
            const { angleIdx: angleIdx, radiusIdx: radiusIdx, calloutLabelIdx: calloutLabelIdx, sectorLabelIdx: sectorLabelIdx, legendItemIdx: legendItemIdx } = this.getProcessedDataIndexes(dataModel);
            let currentStart = 0;
            let sum2 = 0;
            const nodeData = processedData.data.map((group2, index)=>{
                var _a;
                const { datum: datum, values: values } = group2;
                const currentValue = values[angleIdx];
                const startAngle = angleScale.convert(currentStart) + $d77b025aa58d633c$var$toRadians(rotation);
                currentStart = currentValue;
                sum2 += currentValue;
                const endAngle = angleScale.convert(currentStart) + $d77b025aa58d633c$var$toRadians(rotation);
                const span = Math.abs(endAngle - startAngle);
                const midAngle = startAngle + span / 2;
                const angleValue = values[angleIdx + 1];
                const radius = radiusIdx >= 0 ? (_a = values[radiusIdx]) != null ? _a : 1 : 1;
                const radiusValue = radiusIdx >= 0 ? values[radiusIdx + 1] : void 0;
                const legendItemValue = legendItemIdx >= 0 ? values[legendItemIdx] : void 0;
                const labels = this.getLabels(datum, midAngle, span, true, values[calloutLabelIdx], values[sectorLabelIdx], legendItemValue);
                const sectorFormat = this.getSectorFormat(datum, index, false);
                return $d77b025aa58d633c$var$__spreadValues({
                    itemId: index,
                    series: this,
                    datum: datum,
                    index: index,
                    angleValue: angleValue,
                    midAngle: midAngle,
                    midCos: Math.cos(midAngle),
                    midSin: Math.sin(midAngle),
                    startAngle: startAngle,
                    endAngle: endAngle,
                    sectorFormat: sectorFormat,
                    radiusValue: radiusValue,
                    radius: radius,
                    innerRadius: Math.max(this.radiusScale.convert(0), 0),
                    outerRadius: Math.max(this.radiusScale.convert(radius), 0),
                    legendItemValue: legendItemValue
                }, labels);
            });
            this.zerosumOuterRing.visible = sum2 === 0;
            this.zerosumInnerRing.visible = sum2 === 0 && innerRadiusRatio != null && innerRadiusRatio !== 1 && innerRadiusRatio > 0;
            return {
                itemId: seriesId,
                nodeData: nodeData,
                labelData: nodeData
            };
        });
    }
    getLabels(datum, midAngle, span, skipDisabled, calloutLabelValue, sectorLabelValue, legendItemValue) {
        const { calloutLabel: calloutLabel, sectorLabel: sectorLabel, legendItemKey: legendItemKey } = this.properties;
        const calloutLabelKey = !skipDisabled || calloutLabel.enabled ? this.properties.calloutLabelKey : void 0;
        const sectorLabelKey = !skipDisabled || sectorLabel.enabled ? this.properties.sectorLabelKey : void 0;
        if (!calloutLabelKey && !sectorLabelKey && !legendItemKey) return {};
        const labelFormatterParams = {
            datum: datum,
            angleKey: this.properties.angleKey,
            angleName: this.properties.angleName,
            radiusKey: this.properties.radiusKey,
            radiusName: this.properties.radiusName,
            calloutLabelKey: this.properties.calloutLabelKey,
            calloutLabelName: this.properties.calloutLabelName,
            sectorLabelKey: this.properties.sectorLabelKey,
            sectorLabelName: this.properties.sectorLabelName,
            legendItemKey: this.properties.legendItemKey
        };
        const result = {};
        if (calloutLabelKey && span > $d77b025aa58d633c$var$toRadians(calloutLabel.minAngle)) result.calloutLabel = $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, this.getTextAlignment(midAngle)), {
            text: this.getLabelText(calloutLabel, $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, labelFormatterParams), {
                value: calloutLabelValue
            })),
            hidden: false,
            collisionTextAlign: void 0,
            collisionOffsetY: 0,
            box: void 0
        });
        if (sectorLabelKey) result.sectorLabel = {
            text: this.getLabelText(sectorLabel, $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, labelFormatterParams), {
                value: sectorLabelValue
            }))
        };
        if (legendItemKey != null && legendItemValue != null) result.legendItem = {
            key: legendItemKey,
            text: legendItemValue
        };
        return result;
    }
    getTextAlignment(midAngle) {
        const quadrantTextOpts = [
            {
                textAlign: "center",
                textBaseline: "bottom"
            },
            {
                textAlign: "left",
                textBaseline: "middle"
            },
            {
                textAlign: "center",
                textBaseline: "hanging"
            },
            {
                textAlign: "right",
                textBaseline: "middle"
            }
        ];
        const midAngle180 = $d77b025aa58d633c$var$normalizeAngle180(midAngle);
        const quadrantStart = -0.75 * Math.PI;
        const quadrantOffset = midAngle180 - quadrantStart;
        const quadrant = Math.floor(quadrantOffset / (Math.PI / 2));
        const quadrantIndex = $d77b025aa58d633c$var$mod(quadrant, quadrantTextOpts.length);
        return quadrantTextOpts[quadrantIndex];
    }
    getSectorFormat(datum, formatIndex, highlight) {
        var _a, _b, _c, _d, _e;
        const { callbackCache: callbackCache, highlightManager: highlightManager } = this.ctx;
        const { angleKey: angleKey, radiusKey: radiusKey, fills: fills, strokes: strokes, formatter: formatter, sectorSpacing: sectorSpacing, __BACKGROUND_COLOR_DO_NOT_USE: __BACKGROUND_COLOR_DO_NOT_USE } = this.properties;
        const highlightedDatum = highlightManager.getActiveHighlight();
        const isDatumHighlighted = highlight && (highlightedDatum == null ? void 0 : highlightedDatum.series) === this && formatIndex === highlightedDatum.itemId;
        let defaultStroke = strokes[formatIndex % strokes.length];
        if (sectorSpacing == null && defaultStroke == null) defaultStroke = __BACKGROUND_COLOR_DO_NOT_USE;
        const { fill: fill, fillOpacity: fillOpacity, stroke: stroke, strokeWidth: strokeWidth, strokeOpacity: strokeOpacity } = $d77b025aa58d633c$var$mergeDefaults(isDatumHighlighted && this.properties.highlightStyle.item, {
            fill: fills.length > 0 ? fills[formatIndex % fills.length] : void 0,
            fillOpacity: this.properties.fillOpacity,
            stroke: defaultStroke,
            strokeWidth: this.getStrokeWidth(this.properties.strokeWidth),
            strokeOpacity: this.getOpacity()
        });
        let format2;
        if (formatter) format2 = callbackCache.call(formatter, {
            datum: datum,
            angleKey: angleKey,
            radiusKey: radiusKey,
            fill: fill,
            stroke: stroke,
            fills: fills,
            strokes: strokes,
            strokeWidth: strokeWidth,
            highlighted: isDatumHighlighted,
            seriesId: this.id
        });
        return {
            fill: (_a = format2 == null ? void 0 : format2.fill) != null ? _a : fill,
            fillOpacity: (_b = format2 == null ? void 0 : format2.fillOpacity) != null ? _b : fillOpacity,
            stroke: (_c = format2 == null ? void 0 : format2.stroke) != null ? _c : stroke,
            strokeWidth: (_d = format2 == null ? void 0 : format2.strokeWidth) != null ? _d : strokeWidth,
            strokeOpacity: (_e = format2 == null ? void 0 : format2.strokeOpacity) != null ? _e : strokeOpacity
        };
    }
    getInnerRadius() {
        const { radius: radius } = this;
        const { innerRadiusRatio: innerRadiusRatio = 1, innerRadiusOffset: innerRadiusOffset = 0 } = this.properties;
        const innerRadius = radius * innerRadiusRatio + innerRadiusOffset;
        if (innerRadius === radius || innerRadius < 0) return 0;
        return innerRadius;
    }
    getOuterRadius() {
        const { outerRadiusRatio: outerRadiusRatio, outerRadiusOffset: outerRadiusOffset } = this.properties;
        return Math.max(this.radius * outerRadiusRatio + outerRadiusOffset, 0);
    }
    updateRadiusScale(resize) {
        const newRange = [
            this.getInnerRadius(),
            this.getOuterRadius()
        ];
        this.radiusScale.range = newRange;
        if (resize) this.previousRadiusScale.range = newRange;
        this.nodeData = this.nodeData.map((_a)=>{
            var _b = _a, { radius: radius } = _b, d = $d77b025aa58d633c$var$__objRest(_b, [
                "radius"
            ]);
            return $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, d), {
                radius: radius,
                innerRadius: Math.max(this.radiusScale.convert(0), 0),
                outerRadius: Math.max(this.radiusScale.convert(radius), 0)
            });
        });
    }
    getTitleTranslationY() {
        var _a, _b;
        const outerRadius = Math.max(0, this.radiusScale.range[1]);
        if (outerRadius === 0) return NaN;
        const spacing = (_b = (_a = this.properties.title) == null ? void 0 : _a.spacing) != null ? _b : 0;
        const titleOffset = 2 + spacing;
        const dy = Math.max(0, -outerRadius);
        return -outerRadius - titleOffset - dy;
    }
    update(_0) {
        return $d77b025aa58d633c$var$__async(this, arguments, function*({ seriesRect: seriesRect }) {
            const { title: title } = this.properties;
            const newNodeDataDependencies = {
                seriesRectWidth: seriesRect == null ? void 0 : seriesRect.width,
                seriesRectHeight: seriesRect == null ? void 0 : seriesRect.height
            };
            const resize = $d77b025aa58d633c$var$jsonDiff(this.nodeDataDependencies, newNodeDataDependencies) != null;
            if (resize) this._nodeDataDependencies = newNodeDataDependencies;
            yield this.maybeRefreshNodeData();
            this.updateTitleNodes();
            this.updateRadiusScale(resize);
            this.contentGroup.translationX = this.centerX;
            this.contentGroup.translationY = this.centerY;
            this.highlightGroup.translationX = this.centerX;
            this.highlightGroup.translationY = this.centerY;
            this.backgroundGroup.translationX = this.centerX;
            this.backgroundGroup.translationY = this.centerY;
            if (this.labelGroup) {
                this.labelGroup.translationX = this.centerX;
                this.labelGroup.translationY = this.centerY;
            }
            if (title) {
                const dy = this.getTitleTranslationY();
                const titleBox = title.node.computeBBox();
                title.node.visible = title.enabled && isFinite(dy) && !this.bboxIntersectsSurroundingSeries(titleBox, 0, dy);
                title.node.translationY = isFinite(dy) ? dy : 0;
            }
            for (const circle of [
                this.zerosumInnerRing,
                this.zerosumOuterRing
            ]){
                circle.fillOpacity = 0;
                circle.stroke = this.properties.calloutLabel.color;
                circle.strokeWidth = 1;
                circle.strokeOpacity = 1;
            }
            this.updateNodeMidPoint();
            yield this.updateSelections();
            yield this.updateNodes(seriesRect);
        });
    }
    updateTitleNodes() {
        var _a, _b;
        const { oldTitle: oldTitle } = this;
        const { title: title } = this.properties;
        if (oldTitle !== title) {
            if (oldTitle) (_a = this.labelGroup) == null || _a.removeChild(oldTitle.node);
            if (title) {
                title.node.textBaseline = "bottom";
                (_b = this.labelGroup) == null || _b.appendChild(title.node);
            }
            this.oldTitle = title;
        }
    }
    updateNodeMidPoint() {
        this.nodeData.forEach((d)=>{
            const radius = d.innerRadius + (d.outerRadius - d.innerRadius) / 2;
            d.midPoint = {
                x: d.midCos * Math.max(0, radius),
                y: d.midSin * Math.max(0, radius)
            };
        });
    }
    updateSelections() {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            yield this.updateGroupSelection();
            this.updateInnerCircleSelection();
        });
    }
    updateGroupSelection() {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            const { itemSelection: itemSelection, highlightSelection: highlightSelection, calloutLabelSelection: calloutLabelSelection, sectorLabelSelection: sectorLabelSelection, innerLabelsSelection: innerLabelsSelection } = this;
            const update = (selection, clone)=>{
                let nodeData = this.nodeData;
                if (clone) nodeData = nodeData.map((datum)=>$d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, datum), {
                        sectorFormat: $d77b025aa58d633c$var$__spreadValues({}, datum.sectorFormat)
                    }));
                selection.update(nodeData, void 0, (datum)=>this.getDatumId(datum));
                if (this.ctx.animationManager.isSkipped()) selection.cleanup();
            };
            update(itemSelection, false);
            update(highlightSelection, true);
            calloutLabelSelection.update(this.nodeData, (group2)=>{
                const line = new $d77b025aa58d633c$var$Line();
                line.tag = 0 /* Callout */ ;
                line.pointerEvents = 1 /* None */ ;
                group2.appendChild(line);
                const text = new $d77b025aa58d633c$var$Text();
                text.tag = 1 /* Label */ ;
                text.pointerEvents = 1 /* None */ ;
                group2.appendChild(text);
            });
            sectorLabelSelection.update(this.nodeData, (node)=>{
                node.pointerEvents = 1 /* None */ ;
            });
            innerLabelsSelection.update(this.properties.innerLabels, (node)=>{
                node.pointerEvents = 1 /* None */ ;
            });
        });
    }
    updateInnerCircleSelection() {
        const { innerCircle: innerCircle } = this.properties;
        let radius = 0;
        const innerRadius = this.getInnerRadius();
        if (innerRadius > 0) {
            const circleRadius = Math.min(innerRadius, this.getOuterRadius());
            const antiAliasingPadding = 1;
            radius = Math.ceil(circleRadius * 2 + antiAliasingPadding);
        }
        const datums = innerCircle ? [
            {
                radius: radius
            }
        ] : [];
        this.innerCircleSelection.update(datums);
    }
    updateNodes(seriesRect) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            const highlightedDatum = this.ctx.highlightManager.getActiveHighlight();
            const isVisible = this.visible && this.seriesItemEnabled.indexOf(true) >= 0;
            this.rootGroup.visible = isVisible;
            this.backgroundGroup.visible = isVisible;
            this.contentGroup.visible = isVisible;
            this.highlightGroup.visible = isVisible && (highlightedDatum == null ? void 0 : highlightedDatum.series) === this;
            if (this.labelGroup) this.labelGroup.visible = isVisible;
            this.contentGroup.opacity = this.getOpacity();
            this.innerCircleSelection.each((node, { radius: radius })=>{
                var _a, _b;
                node.setProperties({
                    fill: (_a = this.properties.innerCircle) == null ? void 0 : _a.fill,
                    opacity: (_b = this.properties.innerCircle) == null ? void 0 : _b.fillOpacity,
                    size: radius
                });
            });
            const updateSectorFn = (sector, datum, _index, isDatumHighlighted)=>{
                const format2 = this.getSectorFormat(datum.datum, datum.itemId, isDatumHighlighted);
                datum.sectorFormat.fill = format2.fill;
                datum.sectorFormat.stroke = format2.stroke;
                const animationDisabled = this.ctx.animationManager.isSkipped();
                if (animationDisabled) {
                    sector.startAngle = datum.startAngle;
                    sector.endAngle = datum.endAngle;
                    sector.innerRadius = datum.innerRadius;
                    sector.outerRadius = datum.outerRadius;
                }
                if (isDatumHighlighted || animationDisabled) {
                    sector.fill = format2.fill;
                    sector.stroke = format2.stroke;
                }
                sector.strokeWidth = format2.strokeWidth;
                sector.fillOpacity = format2.fillOpacity;
                sector.strokeOpacity = this.properties.strokeOpacity;
                sector.lineDash = this.properties.lineDash;
                sector.lineDashOffset = this.properties.lineDashOffset;
                sector.fillShadow = this.properties.shadow;
                sector.cornerRadius = this.properties.cornerRadius;
                sector.inset = this.properties.sectorSpacing != null ? (this.properties.sectorSpacing + (format2.stroke != null ? format2.strokeWidth : 0)) / 2 : 0;
                sector.lineJoin = this.properties.sectorSpacing != null ? "miter" : "round";
            };
            this.itemSelection.each((node, datum, index)=>updateSectorFn(node, datum, index, false));
            this.highlightSelection.each((node, datum, index)=>{
                const isDatumHighlighted = (highlightedDatum == null ? void 0 : highlightedDatum.series) === this && node.datum.itemId === highlightedDatum.itemId;
                updateSectorFn(node, datum, index, true);
                node.visible = isDatumHighlighted;
            });
            this.updateCalloutLineNodes();
            this.updateCalloutLabelNodes(seriesRect);
            this.updateSectorLabelNodes();
            this.updateInnerLabelNodes();
            this.updateZerosumRings();
            this.animationState.transition("update");
        });
    }
    updateCalloutLineNodes() {
        var _a;
        const { calloutLine: calloutLine } = this.properties;
        const calloutLength = calloutLine.length;
        const calloutStrokeWidth = calloutLine.strokeWidth;
        const calloutColors = (_a = calloutLine.colors) != null ? _a : this.properties.strokes;
        const { offset: offset4 } = this.properties.calloutLabel;
        this.calloutLabelSelection.selectByTag(0 /* Callout */ ).forEach((line, index)=>{
            var _a2;
            const datum = line.datum;
            const { calloutLabel: label, outerRadius: outerRadius } = datum;
            if ((label == null ? void 0 : label.text) && !label.hidden && outerRadius !== 0) {
                line.visible = true;
                line.strokeWidth = calloutStrokeWidth;
                line.stroke = calloutColors[index % calloutColors.length];
                line.fill = void 0;
                const x1 = datum.midCos * outerRadius;
                const y1 = datum.midSin * outerRadius;
                let x2 = datum.midCos * (outerRadius + calloutLength);
                let y2 = datum.midSin * (outerRadius + calloutLength);
                const isMoved = (_a2 = label.collisionTextAlign) != null ? _a2 : label.collisionOffsetY !== 0;
                if (isMoved && label.box != null) {
                    const box = label.box;
                    let cx = x2;
                    let cy = y2;
                    if (x2 < box.x) cx = box.x;
                    else if (x2 > box.x + box.width) cx = box.x + box.width;
                    if (y2 < box.y) cy = box.y;
                    else if (y2 > box.y + box.height) cy = box.y + box.height;
                    const dx = cx - x2;
                    const dy = cy - y2;
                    const length = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));
                    const paddedLength = length - offset4;
                    if (paddedLength > 0) {
                        x2 = x2 + dx * paddedLength / length;
                        y2 = y2 + dy * paddedLength / length;
                    }
                }
                line.x1 = x1;
                line.y1 = y1;
                line.x2 = x2;
                line.y2 = y2;
            } else line.visible = false;
        });
    }
    getLabelOverflow(text, box, seriesRect) {
        const seriesLeft = seriesRect.x - this.centerX;
        const seriesRight = seriesRect.x + seriesRect.width - this.centerX;
        const seriesTop = seriesRect.y - this.centerY;
        const seriesBottom = seriesRect.y + seriesRect.height - this.centerY;
        const errPx = 1;
        let visibleTextPart = 1;
        if (box.x + errPx < seriesLeft) visibleTextPart = (box.x + box.width - seriesLeft) / box.width;
        else if (box.x + box.width - errPx > seriesRight) visibleTextPart = (seriesRight - box.x) / box.width;
        const hasVerticalOverflow = box.y + errPx < seriesTop || box.y + box.height - errPx > seriesBottom;
        const textLength = visibleTextPart === 1 ? text.length : Math.floor(text.length * visibleTextPart) - 1;
        const hasSurroundingSeriesOverflow = this.bboxIntersectsSurroundingSeries(box);
        return {
            textLength: textLength,
            hasVerticalOverflow: hasVerticalOverflow,
            hasSurroundingSeriesOverflow: hasSurroundingSeriesOverflow
        };
    }
    bboxIntersectsSurroundingSeries(box, dx = 0, dy = 0) {
        const { surroundingRadius: surroundingRadius } = this;
        if (surroundingRadius == null) return false;
        const corners = [
            {
                x: box.x + dx,
                y: box.y + dy
            },
            {
                x: box.x + box.width + dx,
                y: box.y + dy
            },
            {
                x: box.x + box.width + dx,
                y: box.y + box.height + dy
            },
            {
                x: box.x + dx,
                y: box.y + box.height + dy
            }
        ];
        const sur2 = $d77b025aa58d633c$var$__pow(surroundingRadius, 2);
        return corners.some((corner)=>$d77b025aa58d633c$var$__pow(corner.x, 2) + $d77b025aa58d633c$var$__pow(corner.y, 2) > sur2);
    }
    computeCalloutLabelCollisionOffsets() {
        const { radiusScale: radiusScale } = this;
        const { calloutLabel: calloutLabel, calloutLine: calloutLine } = this.properties;
        const { offset: offset4, minSpacing: minSpacing } = calloutLabel;
        const innerRadius = radiusScale.convert(0);
        const shouldSkip = (datum)=>{
            const label = datum.calloutLabel;
            return !label || datum.outerRadius === 0;
        };
        const fullData = this.nodeData;
        const data = this.nodeData.filter((t)=>!shouldSkip(t));
        data.forEach((datum)=>{
            const label = datum.calloutLabel;
            if (label == null) return;
            label.hidden = false;
            label.collisionTextAlign = void 0;
            label.collisionOffsetY = 0;
        });
        if (data.length <= 1) return;
        const leftLabels = data.filter((d)=>d.midCos < 0).sort((a, b)=>a.midSin - b.midSin);
        const rightLabels = data.filter((d)=>d.midCos >= 0).sort((a, b)=>a.midSin - b.midSin);
        const topLabels = data.filter((d)=>{
            var _a;
            return d.midSin < 0 && ((_a = d.calloutLabel) == null ? void 0 : _a.textAlign) === "center";
        }).sort((a, b)=>a.midCos - b.midCos);
        const bottomLabels = data.filter((d)=>{
            var _a;
            return d.midSin >= 0 && ((_a = d.calloutLabel) == null ? void 0 : _a.textAlign) === "center";
        }).sort((a, b)=>a.midCos - b.midCos);
        const tempTextNode = new $d77b025aa58d633c$var$Text();
        const getTextBBox = (datum)=>{
            var _a;
            const label = datum.calloutLabel;
            if (label == null) return new $d77b025aa58d633c$var$BBox(0, 0, 0, 0);
            const labelRadius = datum.outerRadius + calloutLine.length + offset4;
            const x = datum.midCos * labelRadius;
            const y = datum.midSin * labelRadius + label.collisionOffsetY;
            tempTextNode.text = label.text;
            tempTextNode.x = x;
            tempTextNode.y = y;
            tempTextNode.setFont(this.properties.calloutLabel);
            tempTextNode.setAlign({
                textAlign: (_a = label.collisionTextAlign) != null ? _a : label.textAlign,
                textBaseline: label.textBaseline
            });
            return tempTextNode.computeBBox();
        };
        const avoidNeighbourYCollision = (label, next, direction)=>{
            const box = getTextBBox(label).grow(minSpacing / 2);
            const other = getTextBBox(next).grow(minSpacing / 2);
            const collidesOrBehind = box.x < other.x + other.width && box.x + box.width > other.x && (direction === "to-top" ? box.y < other.y + other.height : box.y + box.height > other.y);
            if (collidesOrBehind) {
                const dy = direction === "to-top" ? box.y - other.y - other.height : box.y + box.height - other.y;
                next.calloutLabel.collisionOffsetY = dy;
            }
        };
        const avoidYCollisions = (labels)=>{
            const midLabel = labels.slice().sort((a, b)=>Math.abs(a.midSin) - Math.abs(b.midSin))[0];
            const midIndex = labels.indexOf(midLabel);
            for(let i = midIndex - 1; i >= 0; i--){
                const prev = labels[i + 1];
                const next = labels[i];
                avoidNeighbourYCollision(prev, next, "to-top");
            }
            for(let i = midIndex + 1; i < labels.length; i++){
                const prev = labels[i - 1];
                const next = labels[i];
                avoidNeighbourYCollision(prev, next, "to-bottom");
            }
        };
        const avoidXCollisions = (labels)=>{
            const labelsCollideLabelsByY = data.some((datum)=>datum.calloutLabel.collisionOffsetY !== 0);
            const boxes = labels.map((label)=>getTextBBox(label));
            const paddedBoxes = boxes.map((box)=>box.clone().grow(minSpacing / 2));
            let labelsCollideLabelsByX = false;
            for(let i = 0; i < paddedBoxes.length && !labelsCollideLabelsByX; i++){
                const box = paddedBoxes[i];
                for(let j = i + 1; j < labels.length; j++){
                    const other = paddedBoxes[j];
                    if (box.collidesBBox(other)) {
                        labelsCollideLabelsByX = true;
                        break;
                    }
                }
            }
            const sectors = fullData.map((datum)=>{
                const { startAngle: startAngle, endAngle: endAngle, outerRadius: outerRadius } = datum;
                return {
                    startAngle: startAngle,
                    endAngle: endAngle,
                    innerRadius: innerRadius,
                    outerRadius: outerRadius
                };
            });
            const labelsCollideSectors = boxes.some((box)=>{
                return sectors.some((sector)=>$d77b025aa58d633c$var$boxCollidesSector(box, sector));
            });
            if (!labelsCollideLabelsByX && !labelsCollideLabelsByY && !labelsCollideSectors) return;
            labels.filter((d)=>d.calloutLabel.textAlign === "center").forEach((d)=>{
                const label = d.calloutLabel;
                if (d.midCos < 0) label.collisionTextAlign = "right";
                else if (d.midCos > 0) label.collisionTextAlign = "left";
                else label.collisionTextAlign = "center";
            });
        };
        avoidYCollisions(leftLabels);
        avoidYCollisions(rightLabels);
        avoidXCollisions(topLabels);
        avoidXCollisions(bottomLabels);
    }
    updateCalloutLabelNodes(seriesRect) {
        const { radiusScale: radiusScale } = this;
        const { calloutLabel: calloutLabel, calloutLine: calloutLine } = this.properties;
        const calloutLength = calloutLine.length;
        const { offset: offset4, color: color } = calloutLabel;
        const tempTextNode = new $d77b025aa58d633c$var$Text();
        this.calloutLabelSelection.selectByTag(1 /* Label */ ).forEach((text)=>{
            var _a;
            const { datum: datum } = text;
            const label = datum.calloutLabel;
            const radius = radiusScale.convert(datum.radius);
            const outerRadius = Math.max(0, radius);
            if (!(label == null ? void 0 : label.text) || outerRadius === 0 || label.hidden) {
                text.visible = false;
                return;
            }
            const labelRadius = outerRadius + calloutLength + offset4;
            const x = datum.midCos * labelRadius;
            const y = datum.midSin * labelRadius + label.collisionOffsetY;
            const align = {
                textAlign: (_a = label.collisionTextAlign) != null ? _a : label.textAlign,
                textBaseline: label.textBaseline
            };
            tempTextNode.text = label.text;
            tempTextNode.x = x;
            tempTextNode.y = y;
            tempTextNode.setFont(this.properties.calloutLabel);
            tempTextNode.setAlign(align);
            const box = tempTextNode.computeBBox();
            let displayText = label.text;
            let visible = true;
            if (calloutLabel.avoidCollisions) {
                const { textLength: textLength, hasVerticalOverflow: hasVerticalOverflow } = this.getLabelOverflow(label.text, box, seriesRect);
                displayText = label.text.length === textLength ? label.text : `${label.text.substring(0, textLength)}\u2026`;
                visible = !hasVerticalOverflow;
            }
            text.text = displayText;
            text.x = x;
            text.y = y;
            text.setFont(this.properties.calloutLabel);
            text.setAlign(align);
            text.fill = color;
            text.visible = visible;
        });
    }
    computeLabelsBBox(options, seriesRect) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            const { calloutLabel: calloutLabel, calloutLine: calloutLine } = this.properties;
            const calloutLength = calloutLine.length;
            const { offset: offset4, maxCollisionOffset: maxCollisionOffset, minSpacing: minSpacing } = calloutLabel;
            if (!calloutLabel.avoidCollisions) return null;
            yield this.maybeRefreshNodeData();
            this.updateRadiusScale(false);
            this.computeCalloutLabelCollisionOffsets();
            const textBoxes = [];
            const text = new $d77b025aa58d633c$var$Text();
            let titleBox;
            const { title: title } = this.properties;
            if ((title == null ? void 0 : title.text) && title.enabled) {
                const dy = this.getTitleTranslationY();
                if (isFinite(dy)) {
                    text.text = title.text;
                    text.x = 0;
                    text.y = dy;
                    text.setFont(title);
                    text.setAlign({
                        textBaseline: "bottom",
                        textAlign: "center"
                    });
                    titleBox = text.computeBBox();
                    textBoxes.push(titleBox);
                }
            }
            this.nodeData.forEach((datum)=>{
                var _a;
                const label = datum.calloutLabel;
                if (!label || datum.outerRadius === 0) return null;
                const labelRadius = datum.outerRadius + calloutLength + offset4;
                const x = datum.midCos * labelRadius;
                const y = datum.midSin * labelRadius + label.collisionOffsetY;
                text.text = label.text;
                text.x = x;
                text.y = y;
                text.setFont(this.properties.calloutLabel);
                text.setAlign({
                    textAlign: (_a = label.collisionTextAlign) != null ? _a : label.textAlign,
                    textBaseline: label.textBaseline
                });
                const box = text.computeBBox();
                label.box = box;
                if (Math.abs(label.collisionOffsetY) > maxCollisionOffset) {
                    label.hidden = true;
                    return;
                }
                if (titleBox) {
                    const seriesTop = seriesRect.y - this.centerY;
                    const titleCleanArea = new $d77b025aa58d633c$var$BBox(titleBox.x - minSpacing, seriesTop, titleBox.width + 2 * minSpacing, titleBox.y + titleBox.height + minSpacing - seriesTop);
                    if (box.collidesBBox(titleCleanArea)) {
                        label.hidden = true;
                        return;
                    }
                }
                if (options.hideWhenNecessary) {
                    const { textLength: textLength, hasVerticalOverflow: hasVerticalOverflow, hasSurroundingSeriesOverflow: hasSurroundingSeriesOverflow } = this.getLabelOverflow(label.text, box, seriesRect);
                    const isTooShort = label.text.length > 2 && textLength < 2;
                    if (hasVerticalOverflow || isTooShort || hasSurroundingSeriesOverflow) {
                        label.hidden = true;
                        return;
                    }
                }
                label.hidden = false;
                textBoxes.push(box);
            });
            if (textBoxes.length === 0) return null;
            return $d77b025aa58d633c$var$BBox.merge(textBoxes);
        });
    }
    updateSectorLabelNodes() {
        const { radiusScale: radiusScale } = this;
        const innerRadius = radiusScale.convert(0);
        const { fontSize: fontSize, fontStyle: fontStyle, fontWeight: fontWeight, fontFamily: fontFamily, positionOffset: positionOffset, positionRatio: positionRatio, color: color } = this.properties.sectorLabel;
        this.sectorLabelSelection.each((text, datum)=>{
            const { sectorLabel: sectorLabel, outerRadius: outerRadius } = datum;
            let isTextVisible = false;
            if (sectorLabel && outerRadius !== 0) {
                const labelRadius = innerRadius * (1 - positionRatio) + outerRadius * positionRatio + positionOffset;
                text.fill = color;
                text.fontStyle = fontStyle;
                text.fontWeight = fontWeight;
                text.fontSize = fontSize;
                text.fontFamily = fontFamily;
                text.text = sectorLabel.text;
                text.x = datum.midCos * labelRadius;
                text.y = datum.midSin * labelRadius;
                text.textAlign = "center";
                text.textBaseline = "middle";
                const bbox = text.computeBBox();
                const corners = [
                    [
                        bbox.x,
                        bbox.y
                    ],
                    [
                        bbox.x + bbox.width,
                        bbox.y
                    ],
                    [
                        bbox.x + bbox.width,
                        bbox.y + bbox.height
                    ],
                    [
                        bbox.x,
                        bbox.y + bbox.height
                    ]
                ];
                const { startAngle: startAngle, endAngle: endAngle } = datum;
                const sectorBounds = {
                    startAngle: startAngle,
                    endAngle: endAngle,
                    innerRadius: innerRadius,
                    outerRadius: outerRadius
                };
                if (corners.every(([x, y])=>$d77b025aa58d633c$var$isPointInSector(x, y, sectorBounds))) isTextVisible = true;
            }
            text.visible = isTextVisible;
        });
    }
    updateInnerLabelNodes() {
        const textBBoxes = [];
        const margins = [];
        this.innerLabelsSelection.each((text, datum)=>{
            const { fontStyle: fontStyle, fontWeight: fontWeight, fontSize: fontSize, fontFamily: fontFamily, color: color } = datum;
            text.fontStyle = fontStyle;
            text.fontWeight = fontWeight;
            text.fontSize = fontSize;
            text.fontFamily = fontFamily;
            text.text = datum.text;
            text.x = 0;
            text.y = 0;
            text.fill = color;
            text.textAlign = "center";
            text.textBaseline = "alphabetic";
            textBBoxes.push(text.computeBBox());
            margins.push(datum.margin);
        });
        const getMarginTop = (index)=>index === 0 ? 0 : margins[index];
        const getMarginBottom = (index)=>index === margins.length - 1 ? 0 : margins[index];
        const totalHeight = textBBoxes.reduce((sum2, bbox, i)=>{
            return sum2 + bbox.height + getMarginTop(i) + getMarginBottom(i);
        }, 0);
        const totalWidth = Math.max(...textBBoxes.map((bbox)=>bbox.width));
        const innerRadius = this.getInnerRadius();
        const labelRadius = Math.sqrt(Math.pow(totalWidth / 2, 2) + Math.pow(totalHeight / 2, 2));
        const labelsVisible = labelRadius <= (innerRadius > 0 ? innerRadius : this.getOuterRadius());
        const textBottoms = [];
        for(let i = 0, prev = -totalHeight / 2; i < textBBoxes.length; i++){
            const bbox = textBBoxes[i];
            const bottom = bbox.height + prev + getMarginTop(i);
            textBottoms.push(bottom);
            prev = bottom + getMarginBottom(i);
        }
        this.innerLabelsSelection.each((text, _datum, index)=>{
            text.y = textBottoms[index];
            text.visible = labelsVisible;
        });
    }
    updateZerosumRings() {
        this.zerosumOuterRing.size = this.getOuterRadius() * 2;
        this.zerosumInnerRing.size = this.getInnerRadius() * 2;
    }
    getDatumLegendName(nodeDatum) {
        const { angleKey: angleKey, calloutLabelKey: calloutLabelKey, sectorLabelKey: sectorLabelKey, legendItemKey: legendItemKey } = this.properties;
        const { sectorLabel: sectorLabel, calloutLabel: calloutLabel, legendItem: legendItem } = nodeDatum;
        if (legendItemKey && legendItem !== void 0) return legendItem.text;
        else if (calloutLabelKey && calloutLabelKey !== angleKey && (calloutLabel == null ? void 0 : calloutLabel.text) !== void 0) return calloutLabel.text;
        else if (sectorLabelKey && sectorLabelKey !== angleKey && (sectorLabel == null ? void 0 : sectorLabel.text) !== void 0) return sectorLabel.text;
    }
    pickNodeClosestDatum(point) {
        return $d77b025aa58d633c$var$pickByMatchingAngle(this, point);
    }
    getTooltipHtml(nodeDatum) {
        var _a;
        if (!this.properties.isValid()) return $d77b025aa58d633c$var$EMPTY_TOOLTIP_CONTENT;
        const { datum: datum, angleValue: angleValue, sectorFormat: { fill: color }, itemId: itemId } = nodeDatum;
        const title = $d77b025aa58d633c$var$sanitizeHtml((_a = this.properties.title) == null ? void 0 : _a.text);
        const content = $d77b025aa58d633c$var$isFiniteNumber(angleValue) ? $d77b025aa58d633c$var$toFixed(angleValue) : String(angleValue);
        const labelText = this.getDatumLegendName(nodeDatum);
        return this.properties.tooltip.toTooltipHtml({
            title: title != null ? title : labelText,
            content: title && labelText ? `${labelText}: ${content}` : content,
            backgroundColor: color
        }, {
            datum: datum,
            itemId: itemId,
            title: title,
            color: color,
            seriesId: this.id,
            angleKey: this.properties.angleKey,
            angleName: this.properties.angleName,
            radiusKey: this.properties.radiusKey,
            radiusName: this.properties.radiusName,
            calloutLabelKey: this.properties.calloutLabelKey,
            calloutLabelName: this.properties.calloutLabelName,
            sectorLabelKey: this.properties.sectorLabelKey,
            sectorLabelName: this.properties.sectorLabelName,
            legendItemKey: this.properties.legendItemKey
        });
    }
    getLegendData(legendType) {
        var _a, _b, _c, _d, _e;
        const { visible: visible, processedData: processedData, dataModel: dataModel } = this;
        if (!dataModel || !(processedData == null ? void 0 : processedData.data.length) || !this.properties.isValid() || legendType !== "category") return [];
        const { angleKey: angleKey, calloutLabelKey: calloutLabelKey, sectorLabelKey: sectorLabelKey, legendItemKey: legendItemKey } = this.properties;
        if (!legendItemKey && (!calloutLabelKey || calloutLabelKey === angleKey) && (!sectorLabelKey || sectorLabelKey === angleKey)) return [];
        const { calloutLabelIdx: calloutLabelIdx, sectorLabelIdx: sectorLabelIdx, legendItemIdx: legendItemIdx } = this.getProcessedDataIndexes(dataModel);
        const titleText = ((_a = this.properties.title) == null ? void 0 : _a.showInLegend) && this.properties.title.text;
        const legendData = [];
        for(let index = 0; index < processedData.data.length; index++){
            const { datum: datum, values: values } = processedData.data[index];
            const labelParts = [];
            if (titleText) labelParts.push(titleText);
            const labels = this.getLabels(datum, 2 * Math.PI, 2 * Math.PI, false, values[calloutLabelIdx], values[sectorLabelIdx], values[legendItemIdx]);
            if (legendItemKey && labels.legendItem !== void 0) labelParts.push(labels.legendItem.text);
            else if (calloutLabelKey && calloutLabelKey !== angleKey && ((_b = labels.calloutLabel) == null ? void 0 : _b.text) !== void 0) labelParts.push((_c = labels.calloutLabel) == null ? void 0 : _c.text);
            else if (sectorLabelKey && sectorLabelKey !== angleKey && ((_d = labels.sectorLabel) == null ? void 0 : _d.text) !== void 0) labelParts.push((_e = labels.sectorLabel) == null ? void 0 : _e.text);
            if (labelParts.length === 0) continue;
            const sectorFormat = this.getSectorFormat(datum, index, false);
            legendData.push({
                legendType: "category",
                id: this.id,
                itemId: index,
                seriesId: this.id,
                enabled: visible && this.seriesItemEnabled[index],
                label: {
                    text: labelParts.join(" - ")
                },
                marker: {
                    fill: sectorFormat.fill,
                    stroke: sectorFormat.stroke,
                    fillOpacity: this.properties.fillOpacity,
                    strokeOpacity: this.properties.strokeOpacity,
                    strokeWidth: this.properties.strokeWidth
                },
                legendItemName: legendItemKey != null ? datum[legendItemKey] : void 0
            });
        }
        return legendData;
    }
    onLegendItemClick(event) {
        const { enabled: enabled, itemId: itemId, series: series, legendItemName: legendItemName } = event;
        if (series.id === this.id) this.toggleSeriesItem(itemId, enabled);
        else if (legendItemName != null) this.toggleOtherSeriesItems(legendItemName, enabled);
    }
    toggleSeriesItem(itemId, enabled) {
        this.seriesItemEnabled[itemId] = enabled;
        this.nodeDataRefresh = true;
    }
    toggleOtherSeriesItems(legendItemName, enabled) {
        var _a;
        if (!this.properties.legendItemKey || !this.dataModel) return;
        const legendItemIdx = this.dataModel.resolveProcessedDataIndexById(this, `legendItemValue`);
        (_a = this.processedData) == null || _a.data.forEach(({ values: values }, datumItemId)=>{
            if (values[legendItemIdx] === legendItemName) this.toggleSeriesItem(datumItemId, enabled);
        });
    }
    animateEmptyUpdateReady(_data) {
        const { animationManager: animationManager } = this.ctx;
        const fns = $d77b025aa58d633c$var$preparePieSeriesAnimationFunctions(true, this.properties.rotation, this.radiusScale, this.previousRadiusScale);
        $d77b025aa58d633c$var$fromToMotion(this.id, "nodes", animationManager, [
            this.itemSelection,
            this.highlightSelection
        ], fns.nodes);
        $d77b025aa58d633c$var$fromToMotion(this.id, `innerCircle`, animationManager, [
            this.innerCircleSelection
        ], fns.innerCircle);
        $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "callout", animationManager, this.calloutLabelSelection);
        $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "sector", animationManager, this.sectorLabelSelection);
        $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "inner", animationManager, this.innerLabelsSelection);
        this.previousRadiusScale.range = this.radiusScale.range;
    }
    animateWaitingUpdateReady() {
        var _a, _b, _c, _d, _e, _f;
        const { itemSelection: itemSelection, highlightSelection: highlightSelection, processedData: processedData, radiusScale: radiusScale, previousRadiusScale: previousRadiusScale } = this;
        const { animationManager: animationManager } = this.ctx;
        const dataDiff = (_a = processedData == null ? void 0 : processedData.reduced) == null ? void 0 : _a.diff;
        this.ctx.animationManager.stopByAnimationGroupId(this.id);
        const supportedDiff = ((_b = dataDiff == null ? void 0 : dataDiff.moved.size) != null ? _b : 0) === 0;
        const hasKeys = ((_c = processedData == null ? void 0 : processedData.defs.keys.length) != null ? _c : 0) > 0;
        const hasUniqueKeys = (_f = (_e = (_d = processedData == null ? void 0 : processedData.reduced) == null ? void 0 : _d.animationValidation) == null ? void 0 : _e.uniqueKeys) != null ? _f : true;
        if (!supportedDiff || !hasKeys || !hasUniqueKeys) this.ctx.animationManager.skipCurrentBatch();
        const fns = $d77b025aa58d633c$var$preparePieSeriesAnimationFunctions(false, this.properties.rotation, radiusScale, previousRadiusScale);
        $d77b025aa58d633c$var$fromToMotion(this.id, "nodes", animationManager, [
            itemSelection,
            highlightSelection
        ], fns.nodes, (_, datum)=>this.getDatumId(datum), dataDiff);
        $d77b025aa58d633c$var$fromToMotion(this.id, `innerCircle`, animationManager, [
            this.innerCircleSelection
        ], fns.innerCircle);
        $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "callout", this.ctx.animationManager, this.calloutLabelSelection);
        $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "sector", this.ctx.animationManager, this.sectorLabelSelection);
        $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "inner", this.ctx.animationManager, this.innerLabelsSelection);
        this.previousRadiusScale.range = this.radiusScale.range;
    }
    animateClearingUpdateEmpty() {
        const { itemSelection: itemSelection, highlightSelection: highlightSelection, radiusScale: radiusScale, previousRadiusScale: previousRadiusScale } = this;
        const { animationManager: animationManager } = this.ctx;
        const fns = $d77b025aa58d633c$var$preparePieSeriesAnimationFunctions(false, this.properties.rotation, radiusScale, previousRadiusScale);
        $d77b025aa58d633c$var$fromToMotion(this.id, "nodes", animationManager, [
            itemSelection,
            highlightSelection
        ], fns.nodes);
        $d77b025aa58d633c$var$fromToMotion(this.id, `innerCircle`, animationManager, [
            this.innerCircleSelection
        ], fns.innerCircle);
        $d77b025aa58d633c$var$seriesLabelFadeOutAnimation(this, "callout", this.ctx.animationManager, this.calloutLabelSelection);
        $d77b025aa58d633c$var$seriesLabelFadeOutAnimation(this, "sector", this.ctx.animationManager, this.sectorLabelSelection);
        $d77b025aa58d633c$var$seriesLabelFadeOutAnimation(this, "inner", this.ctx.animationManager, this.innerLabelsSelection);
        this.previousRadiusScale.range = this.radiusScale.range;
    }
    getDatumIdFromData(datum) {
        var _a, _b, _c;
        const { calloutLabelKey: calloutLabelKey, sectorLabelKey: sectorLabelKey, legendItemKey: legendItemKey } = this.properties;
        if (!((_c = (_b = (_a = this.processedData) == null ? void 0 : _a.reduced) == null ? void 0 : _b.animationValidation) == null ? void 0 : _c.uniqueKeys)) return;
        if (legendItemKey) return datum[legendItemKey];
        else if (calloutLabelKey) return datum[calloutLabelKey];
        else if (sectorLabelKey) return datum[sectorLabelKey];
    }
    getDatumId(datum) {
        const { index: index } = datum;
        const datumId = this.getDatumIdFromData(datum.datum);
        return datumId != null ? String(datumId) : `${index}`;
    }
    onDataChange() {
        var _a;
        const { data: data, seriesItemEnabled: seriesItemEnabled } = this;
        this.seriesItemEnabled = (_a = data == null ? void 0 : data.map((_, index)=>{
            var _a2;
            return (_a2 = seriesItemEnabled[index]) != null ? _a2 : true;
        })) != null ? _a : [];
    }
    computeFocusBounds(opts) {
        return $d77b025aa58d633c$var$computeSectorFocusBounds(this, opts);
    }
};
$d77b025aa58d633c$var$DonutSeries.className = "DonutSeries";
$d77b025aa58d633c$var$DonutSeries.type = "donut";
// packages/ag-charts-community/src/chart/series/polar/pieTheme.ts
var $d77b025aa58d633c$var$pieTheme = {
    series: {
        __extends__: $d77b025aa58d633c$var$EXTENDS_SERIES_DEFAULTS,
        title: {
            enabled: true,
            fontStyle: void 0,
            fontWeight: "normal" /* NORMAL */ ,
            fontSize: 14,
            fontFamily: $d77b025aa58d633c$var$DEFAULT_FONT_FAMILY,
            color: $d77b025aa58d633c$var$DEFAULT_MUTED_LABEL_COLOUR,
            spacing: 5
        },
        calloutLabel: {
            enabled: true,
            fontStyle: void 0,
            fontWeight: void 0,
            fontSize: 12,
            fontFamily: $d77b025aa58d633c$var$DEFAULT_FONT_FAMILY,
            color: $d77b025aa58d633c$var$DEFAULT_LABEL_COLOUR,
            offset: 3,
            minAngle: 0
        },
        sectorLabel: {
            enabled: true,
            fontStyle: void 0,
            fontWeight: "normal" /* NORMAL */ ,
            fontSize: 12,
            fontFamily: $d77b025aa58d633c$var$DEFAULT_FONT_FAMILY,
            color: $d77b025aa58d633c$var$DEFAULT_INSIDE_SERIES_LABEL_COLOUR,
            positionOffset: 0,
            positionRatio: 0.5
        },
        calloutLine: {
            length: 10,
            strokeWidth: 2
        },
        fillOpacity: 1,
        strokeOpacity: 1,
        strokeWidth: 1,
        lineDash: [
            0
        ],
        lineDashOffset: 0,
        rotation: 0,
        // @todo(AG-10275) Uncomment this
        // sectorSpacing: 1,
        shadow: {
            enabled: false,
            color: $d77b025aa58d633c$var$DEFAULT_SHADOW_COLOUR,
            xOffset: 3,
            yOffset: 3,
            blur: 5
        },
        innerLabels: {
            fontStyle: void 0,
            fontWeight: void 0,
            fontSize: 12,
            fontFamily: $d77b025aa58d633c$var$DEFAULT_FONT_FAMILY,
            color: $d77b025aa58d633c$var$DEFAULT_LABEL_COLOUR,
            margin: 2
        },
        // @todo(AG-10275) Remove this
        // @ts-expect-error
        __BACKGROUND_COLOR_DO_NOT_USE: $d77b025aa58d633c$var$DEFAULT_BACKGROUND_COLOUR
    }
};
var $d77b025aa58d633c$var$piePaletteFactory = ({ takeColors: takeColors, colorsCount: colorsCount, userPalette: userPalette })=>{
    const { fills: fills, strokes: strokes } = takeColors(colorsCount);
    return {
        fills: fills,
        strokes: userPalette ? strokes : [],
        calloutLine: {
            colors: strokes
        }
    };
};
// packages/ag-charts-community/src/chart/series/polar/donutSeriesModule.ts
var $d77b025aa58d633c$var$DonutSeriesModule = {
    type: "series",
    optionsKey: "series[]",
    packageType: "community",
    chartTypes: [
        "polar"
    ],
    identifier: "donut",
    instanceConstructor: $d77b025aa58d633c$var$DonutSeries,
    themeTemplate: $d77b025aa58d633c$var$pieTheme,
    paletteFactory: $d77b025aa58d633c$var$piePaletteFactory
};
// packages/ag-charts-community/src/chart/series/polar/pieSeriesProperties.ts
var $d77b025aa58d633c$var$PieTitle = class extends $d77b025aa58d633c$var$Caption {
    constructor(){
        super(...arguments);
        this.showInLegend = false;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN)
], $d77b025aa58d633c$var$PieTitle.prototype, "showInLegend", 2);
var $d77b025aa58d633c$var$DonutInnerLabel2 = class extends $d77b025aa58d633c$var$Label {
    set(properties, _reset) {
        return super.set(properties);
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Deprecated("Use a Donut Series instead"),
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$DonutInnerLabel2.prototype, "text", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Deprecated("Use a Donut Series instead"),
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$NUMBER, {
        optional: true
    })
], $d77b025aa58d633c$var$DonutInnerLabel2.prototype, "margin", 2);
var $d77b025aa58d633c$var$DonutInnerCircle2 = class extends $d77b025aa58d633c$var$BaseProperties {
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Deprecated("Use a Donut Series instead"),
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$COLOR_STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$DonutInnerCircle2.prototype, "fill", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Deprecated("Use a Donut Series instead"),
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$RATIO, {
        optional: true
    })
], $d77b025aa58d633c$var$DonutInnerCircle2.prototype, "fillOpacity", 2);
var $d77b025aa58d633c$var$PieSeriesCalloutLabel = class extends $d77b025aa58d633c$var$Label {
    constructor(){
        super(...arguments);
        this.offset = 3;
        this.minAngle = 0;
        this.minSpacing = 4;
        this.maxCollisionOffset = 50;
        this.avoidCollisions = true;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$PieSeriesCalloutLabel.prototype, "offset", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$DEGREE)
], $d77b025aa58d633c$var$PieSeriesCalloutLabel.prototype, "minAngle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$PieSeriesCalloutLabel.prototype, "minSpacing", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$PieSeriesCalloutLabel.prototype, "maxCollisionOffset", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN)
], $d77b025aa58d633c$var$PieSeriesCalloutLabel.prototype, "avoidCollisions", 2);
var $d77b025aa58d633c$var$PieSeriesSectorLabel = class extends $d77b025aa58d633c$var$Label {
    constructor(){
        super(...arguments);
        this.positionOffset = 0;
        this.positionRatio = 0.5;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$NUMBER)
], $d77b025aa58d633c$var$PieSeriesSectorLabel.prototype, "positionOffset", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$RATIO)
], $d77b025aa58d633c$var$PieSeriesSectorLabel.prototype, "positionRatio", 2);
var $d77b025aa58d633c$var$PieSeriesCalloutLine = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(){
        super(...arguments);
        this.length = 10;
        this.strokeWidth = 1;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$COLOR_STRING_ARRAY, {
        optional: true
    })
], $d77b025aa58d633c$var$PieSeriesCalloutLine.prototype, "colors", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$PieSeriesCalloutLine.prototype, "length", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$PieSeriesCalloutLine.prototype, "strokeWidth", 2);
var $d77b025aa58d633c$var$PieSeriesProperties = class extends $d77b025aa58d633c$var$SeriesProperties {
    constructor(){
        super(...arguments);
        this.fills = Object.values($d77b025aa58d633c$var$DEFAULT_FILLS);
        this.strokes = Object.values($d77b025aa58d633c$var$DEFAULT_STROKES);
        this.fillOpacity = 1;
        this.strokeOpacity = 1;
        this.lineDash = [
            0
        ];
        this.lineDashOffset = 0;
        this.cornerRadius = 0;
        this.rotation = 0;
        this.outerRadiusOffset = 0;
        this.outerRadiusRatio = 1;
        this.strokeWidth = 1;
        this.sectorSpacing = void 0;
        this.innerLabels = new $d77b025aa58d633c$var$PropertiesArray($d77b025aa58d633c$var$DonutInnerLabel2);
        this.title = new $d77b025aa58d633c$var$PieTitle();
        this.innerCircle = new $d77b025aa58d633c$var$DonutInnerCircle2();
        this.shadow = new $d77b025aa58d633c$var$DropShadow();
        this.calloutLabel = new $d77b025aa58d633c$var$PieSeriesCalloutLabel();
        this.sectorLabel = new $d77b025aa58d633c$var$PieSeriesSectorLabel();
        this.calloutLine = new $d77b025aa58d633c$var$PieSeriesCalloutLine();
        this.tooltip = new $d77b025aa58d633c$var$SeriesTooltip();
        this.__BACKGROUND_COLOR_DO_NOT_USE = void 0;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING)
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "angleKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "angleName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "radiusKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "radiusName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER, {
        optional: true
    })
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "radiusMin", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER, {
        optional: true
    })
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "radiusMax", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "calloutLabelKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "calloutLabelName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "sectorLabelKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "sectorLabelName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "legendItemKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$COLOR_STRING_ARRAY)
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "fills", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$COLOR_STRING_ARRAY)
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "strokes", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$RATIO)
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "fillOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$RATIO)
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "strokeOpacity", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$LINE_DASH)
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "lineDash", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "lineDashOffset", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "cornerRadius", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$FUNCTION, {
        optional: true
    })
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "formatter", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$DEGREE)
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "rotation", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$NUMBER)
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "outerRadiusOffset", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$RATIO)
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "outerRadiusRatio", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Deprecated("Use a Donut Series instead"),
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$NUMBER, {
        optional: true
    })
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "innerRadiusOffset", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Deprecated("Use a Donut Series instead"),
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$RATIO, {
        optional: true
    })
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "innerRadiusRatio", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER)
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "strokeWidth", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$POSITIVE_NUMBER, {
        optional: true
    })
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "sectorSpacing", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT_ARRAY)
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "innerLabels", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "title", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "innerCircle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "shadow", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "calloutLabel", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "sectorLabel", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "calloutLine", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$OBJECT)
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "tooltip", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$PieSeriesProperties.prototype, "__BACKGROUND_COLOR_DO_NOT_USE", 2);
// packages/ag-charts-community/src/chart/series/polar/pieSeries.ts
var $d77b025aa58d633c$var$PieSeriesNodeEvent = class extends $d77b025aa58d633c$var$SeriesNodeEvent {
    constructor(type, nativeEvent, datum, series){
        super(type, nativeEvent, datum, series);
        this.angleKey = series.properties.angleKey;
        this.radiusKey = series.properties.radiusKey;
        this.calloutLabelKey = series.properties.calloutLabelKey;
        this.sectorLabelKey = series.properties.sectorLabelKey;
    }
};
var $d77b025aa58d633c$var$PieSeries = class extends $d77b025aa58d633c$var$PolarSeries {
    constructor(moduleCtx){
        super({
            moduleCtx: moduleCtx,
            pickModes: [
                0 /* EXACT_SHAPE_MATCH */ 
            ],
            useLabelLayer: true,
            animationResetFns: {
                item: $d77b025aa58d633c$var$resetPieSelectionsFn,
                label: $d77b025aa58d633c$var$resetLabelFn
            }
        });
        this.properties = new $d77b025aa58d633c$var$PieSeriesProperties();
        this.previousRadiusScale = new $d77b025aa58d633c$var$LinearScale();
        this.radiusScale = new $d77b025aa58d633c$var$LinearScale();
        // The group node that contains the background graphics.
        this.backgroundGroup = this.rootGroup.appendChild(new $d77b025aa58d633c$var$Group({
            name: `${this.id}-background`,
            layer: true,
            zIndex: 0 /* SERIES_BACKGROUND_ZINDEX */ 
        }));
        // AG-6193 If the sum of all datums is 0, then we'll draw 1 or 2 rings to represent the empty series.
        this.zerosumRingsGroup = this.backgroundGroup.appendChild(new $d77b025aa58d633c$var$Group({
            name: `${this.id}-zerosumRings`
        }));
        this.zerosumOuterRing = this.zerosumRingsGroup.appendChild(new $d77b025aa58d633c$var$Circle());
        this.zerosumInnerRing = this.zerosumRingsGroup.appendChild(new $d77b025aa58d633c$var$Circle());
        this.innerCircleGroup = this.backgroundGroup.appendChild(new $d77b025aa58d633c$var$Group({
            name: `${this.id}-innerCircle`
        }));
        // When a user toggles a series item (e.g. from the legend), its boolean state is recorded here.
        this.seriesItemEnabled = [];
        this.surroundingRadius = void 0;
        this.NodeEvent = $d77b025aa58d633c$var$PieSeriesNodeEvent;
        this.angleScale = new $d77b025aa58d633c$var$LinearScale();
        this.angleScale.domain = [
            0,
            1
        ];
        this.angleScale.range = [
            -Math.PI,
            Math.PI
        ].map((angle)=>angle + Math.PI / 2);
        const pieCalloutLabels = new $d77b025aa58d633c$var$Group({
            name: "pieCalloutLabels"
        });
        const pieSectorLabels = new $d77b025aa58d633c$var$Group({
            name: "pieSectorLabels"
        });
        const innerLabels = new $d77b025aa58d633c$var$Group({
            name: "innerLabels"
        });
        this.labelGroup.append(pieCalloutLabels);
        this.labelGroup.append(pieSectorLabels);
        this.labelGroup.append(innerLabels);
        this.calloutLabelSelection = $d77b025aa58d633c$var$Selection.select(pieCalloutLabels, $d77b025aa58d633c$var$Group);
        this.sectorLabelSelection = $d77b025aa58d633c$var$Selection.select(pieSectorLabels, $d77b025aa58d633c$var$Text);
        this.innerLabelsSelection = $d77b025aa58d633c$var$Selection.select(innerLabels, $d77b025aa58d633c$var$Text);
        this.innerCircleSelection = $d77b025aa58d633c$var$Selection.select(this.innerCircleGroup, $d77b025aa58d633c$var$Circle);
    }
    addChartEventListeners() {
        var _a;
        this.destroyFns.push((_a = this.ctx.chartEventManager) == null ? void 0 : _a.addListener("legend-item-click", (event)=>this.onLegendItemClick(event)));
    }
    get visible() {
        return super.visible && (this.seriesItemEnabled.length === 0 || this.seriesItemEnabled.some((visible)=>visible));
    }
    nodeFactory() {
        return new $d77b025aa58d633c$var$Sector();
    }
    getSeriesDomain(direction) {
        if (direction === "x" /* X */ ) return this.angleScale.domain;
        else return this.radiusScale.domain;
    }
    processData(dataController) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            var _a, _b, _c, _d, _e;
            if (this.data == null || !this.properties.isValid()) return;
            let { data: data } = this;
            const { visible: visible, seriesItemEnabled: seriesItemEnabled } = this;
            const { angleKey: angleKey, radiusKey: radiusKey, calloutLabelKey: calloutLabelKey, sectorLabelKey: sectorLabelKey, legendItemKey: legendItemKey } = this.properties;
            const animationEnabled = !this.ctx.animationManager.isSkipped();
            const extraKeyProps = [];
            const extraProps = [];
            if (legendItemKey) extraKeyProps.push($d77b025aa58d633c$var$keyProperty(legendItemKey, "band", {
                id: `legendItemKey`
            }));
            else if (calloutLabelKey) extraKeyProps.push($d77b025aa58d633c$var$keyProperty(calloutLabelKey, "band", {
                id: `calloutLabelKey`
            }));
            else if (sectorLabelKey) extraKeyProps.push($d77b025aa58d633c$var$keyProperty(sectorLabelKey, "band", {
                id: `sectorLabelKey`
            }));
            const radiusScaleType = this.radiusScale.type;
            const angleScaleType = this.radiusScale.type;
            if (radiusKey) extraProps.push($d77b025aa58d633c$var$rangedValueProperty(radiusKey, {
                id: "radiusValue",
                min: (_a = this.properties.radiusMin) != null ? _a : 0,
                max: this.properties.radiusMax
            }), $d77b025aa58d633c$var$valueProperty(radiusKey, radiusScaleType, {
                id: `radiusRaw`
            }), // Raw value pass-through.
            $d77b025aa58d633c$var$normalisePropertyTo({
                id: "radiusValue"
            }, [
                0,
                1
            ], 1, (_b = this.properties.radiusMin) != null ? _b : 0, this.properties.radiusMax));
            if (calloutLabelKey) extraProps.push($d77b025aa58d633c$var$valueProperty(calloutLabelKey, "band", {
                id: `calloutLabelValue`
            }));
            if (sectorLabelKey) extraProps.push($d77b025aa58d633c$var$valueProperty(sectorLabelKey, "band", {
                id: `sectorLabelValue`
            }));
            if (legendItemKey) extraProps.push($d77b025aa58d633c$var$valueProperty(legendItemKey, "band", {
                id: `legendItemValue`
            }));
            if (animationEnabled && this.processedData && extraKeyProps.length > 0) extraProps.push($d77b025aa58d633c$var$diff(this.processedData));
            extraProps.push($d77b025aa58d633c$var$animationValidation());
            data = data.map((d, idx)=>visible && seriesItemEnabled[idx] ? d : $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, d), {
                    [angleKey]: 0
                }));
            yield this.requestDataModel(dataController, data, {
                props: [
                    ...extraKeyProps,
                    $d77b025aa58d633c$var$accumulativeValueProperty(angleKey, angleScaleType, {
                        id: `angleValue`,
                        onlyPositive: true
                    }),
                    $d77b025aa58d633c$var$valueProperty(angleKey, angleScaleType, {
                        id: `angleRaw`
                    }),
                    // Raw value pass-through.
                    $d77b025aa58d633c$var$normalisePropertyTo({
                        id: "angleValue"
                    }, [
                        0,
                        1
                    ], 0, 0),
                    ...extraProps
                ]
            });
            for (const valueDef of (_e = (_d = (_c = this.processedData) == null ? void 0 : _c.defs) == null ? void 0 : _d.values) != null ? _e : []){
                const { id: id, missing: missing, property: property } = valueDef;
                const missCount = $d77b025aa58d633c$var$getMissCount(this, missing);
                if (id !== "angleRaw" && missCount > 0) $d77b025aa58d633c$var$Logger.warnOnce(`no value was found for the key '${String(property)}' on ${missCount} data element${missCount > 1 ? "s" : ""}`);
            }
            this.animationState.transition("updateData");
        });
    }
    maybeRefreshNodeData() {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            var _a;
            if (!this.nodeDataRefresh) return;
            const { nodeData: nodeData = [] } = (_a = yield this.createNodeData()) != null ? _a : {};
            this.nodeData = nodeData;
            this.nodeDataRefresh = false;
        });
    }
    getProcessedDataIndexes(dataModel) {
        const angleIdx = dataModel.resolveProcessedDataIndexById(this, `angleValue`);
        const radiusIdx = this.properties.radiusKey ? dataModel.resolveProcessedDataIndexById(this, `radiusValue`) : -1;
        const calloutLabelIdx = this.properties.calloutLabelKey ? dataModel.resolveProcessedDataIndexById(this, `calloutLabelValue`) : -1;
        const sectorLabelIdx = this.properties.sectorLabelKey ? dataModel.resolveProcessedDataIndexById(this, `sectorLabelValue`) : -1;
        const legendItemIdx = this.properties.legendItemKey ? dataModel.resolveProcessedDataIndexById(this, `legendItemValue`) : -1;
        return {
            angleIdx: angleIdx,
            radiusIdx: radiusIdx,
            calloutLabelIdx: calloutLabelIdx,
            sectorLabelIdx: sectorLabelIdx,
            legendItemIdx: legendItemIdx
        };
    }
    createNodeData() {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            const { id: seriesId, processedData: processedData, dataModel: dataModel, angleScale: angleScale } = this;
            const { rotation: rotation } = this.properties;
            if (!processedData || !dataModel || processedData.type !== "ungrouped") return;
            const { angleIdx: angleIdx, radiusIdx: radiusIdx, calloutLabelIdx: calloutLabelIdx, sectorLabelIdx: sectorLabelIdx, legendItemIdx: legendItemIdx } = this.getProcessedDataIndexes(dataModel);
            let currentStart = 0;
            let sum2 = 0;
            const nodeData = processedData.data.map((group2, index)=>{
                var _a;
                const { datum: datum, values: values } = group2;
                const currentValue = values[angleIdx];
                const startAngle = angleScale.convert(currentStart) + $d77b025aa58d633c$var$toRadians(rotation);
                currentStart = currentValue;
                sum2 += currentValue;
                const endAngle = angleScale.convert(currentStart) + $d77b025aa58d633c$var$toRadians(rotation);
                const span = Math.abs(endAngle - startAngle);
                const midAngle = startAngle + span / 2;
                const angleValue = values[angleIdx + 1];
                const radius = radiusIdx >= 0 ? (_a = values[radiusIdx]) != null ? _a : 1 : 1;
                const radiusValue = radiusIdx >= 0 ? values[radiusIdx + 1] : void 0;
                const legendItemValue = legendItemIdx >= 0 ? values[legendItemIdx] : void 0;
                const labels = this.getLabels(datum, midAngle, span, true, values[calloutLabelIdx], values[sectorLabelIdx], legendItemValue);
                const sectorFormat = this.getSectorFormat(datum, index, false);
                return $d77b025aa58d633c$var$__spreadValues({
                    itemId: index,
                    series: this,
                    datum: datum,
                    index: index,
                    angleValue: angleValue,
                    midAngle: midAngle,
                    midCos: Math.cos(midAngle),
                    midSin: Math.sin(midAngle),
                    startAngle: startAngle,
                    endAngle: endAngle,
                    sectorFormat: sectorFormat,
                    radiusValue: radiusValue,
                    radius: radius,
                    innerRadius: Math.max(this.radiusScale.convert(0), 0),
                    outerRadius: Math.max(this.radiusScale.convert(radius), 0),
                    legendItemValue: legendItemValue
                }, labels);
            });
            this.zerosumOuterRing.visible = sum2 === 0;
            const { innerRadiusRatio: innerRadiusRatio = 1 } = this.properties;
            this.zerosumInnerRing.visible = sum2 === 0 && innerRadiusRatio !== 1 && innerRadiusRatio > 0;
            return {
                itemId: seriesId,
                nodeData: nodeData,
                labelData: nodeData
            };
        });
    }
    getLabels(datum, midAngle, span, skipDisabled, calloutLabelValue, sectorLabelValue, legendItemValue) {
        const { calloutLabel: calloutLabel, sectorLabel: sectorLabel, legendItemKey: legendItemKey } = this.properties;
        const calloutLabelKey = !skipDisabled || calloutLabel.enabled ? this.properties.calloutLabelKey : void 0;
        const sectorLabelKey = !skipDisabled || sectorLabel.enabled ? this.properties.sectorLabelKey : void 0;
        if (!calloutLabelKey && !sectorLabelKey && !legendItemKey) return {};
        const labelFormatterParams = {
            datum: datum,
            angleKey: this.properties.angleKey,
            angleName: this.properties.angleName,
            radiusKey: this.properties.radiusKey,
            radiusName: this.properties.radiusName,
            calloutLabelKey: this.properties.calloutLabelKey,
            calloutLabelName: this.properties.calloutLabelName,
            sectorLabelKey: this.properties.sectorLabelKey,
            sectorLabelName: this.properties.sectorLabelName,
            legendItemKey: this.properties.legendItemKey
        };
        const result = {};
        if (calloutLabelKey && span > $d77b025aa58d633c$var$toRadians(calloutLabel.minAngle)) result.calloutLabel = $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, this.getTextAlignment(midAngle)), {
            text: this.getLabelText(calloutLabel, $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, labelFormatterParams), {
                value: calloutLabelValue
            })),
            hidden: false,
            collisionTextAlign: void 0,
            collisionOffsetY: 0,
            box: void 0
        });
        if (sectorLabelKey) result.sectorLabel = {
            text: this.getLabelText(sectorLabel, $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, labelFormatterParams), {
                value: sectorLabelValue
            }))
        };
        if (legendItemKey != null && legendItemValue != null) result.legendItem = {
            key: legendItemKey,
            text: legendItemValue
        };
        return result;
    }
    getTextAlignment(midAngle) {
        const quadrantTextOpts = [
            {
                textAlign: "center",
                textBaseline: "bottom"
            },
            {
                textAlign: "left",
                textBaseline: "middle"
            },
            {
                textAlign: "center",
                textBaseline: "hanging"
            },
            {
                textAlign: "right",
                textBaseline: "middle"
            }
        ];
        const midAngle180 = $d77b025aa58d633c$var$normalizeAngle180(midAngle);
        const quadrantStart = -0.75 * Math.PI;
        const quadrantOffset = midAngle180 - quadrantStart;
        const quadrant = Math.floor(quadrantOffset / (Math.PI / 2));
        const quadrantIndex = $d77b025aa58d633c$var$mod(quadrant, quadrantTextOpts.length);
        return quadrantTextOpts[quadrantIndex];
    }
    getSectorFormat(datum, formatIndex, highlight) {
        var _a, _b, _c, _d, _e;
        const { callbackCache: callbackCache, highlightManager: highlightManager } = this.ctx;
        const { angleKey: angleKey, radiusKey: radiusKey, fills: fills, strokes: strokes, formatter: formatter, sectorSpacing: sectorSpacing, __BACKGROUND_COLOR_DO_NOT_USE: __BACKGROUND_COLOR_DO_NOT_USE } = this.properties;
        const highlightedDatum = highlightManager.getActiveHighlight();
        const isDatumHighlighted = highlight && (highlightedDatum == null ? void 0 : highlightedDatum.series) === this && formatIndex === highlightedDatum.itemId;
        let defaultStroke = strokes[formatIndex % strokes.length];
        if (sectorSpacing != null) defaultStroke != null ? defaultStroke : defaultStroke = __BACKGROUND_COLOR_DO_NOT_USE;
        const { fill: fill, fillOpacity: fillOpacity, stroke: stroke, strokeWidth: strokeWidth, strokeOpacity: strokeOpacity } = $d77b025aa58d633c$var$mergeDefaults(isDatumHighlighted && this.properties.highlightStyle.item, {
            fill: fills.length > 0 ? fills[formatIndex % fills.length] : void 0,
            fillOpacity: this.properties.fillOpacity,
            stroke: defaultStroke,
            strokeWidth: this.getStrokeWidth(this.properties.strokeWidth),
            strokeOpacity: this.getOpacity()
        });
        let format2;
        if (formatter) format2 = callbackCache.call(formatter, {
            datum: datum,
            angleKey: angleKey,
            radiusKey: radiusKey,
            fill: fill,
            stroke: stroke,
            fills: fills,
            strokes: strokes,
            strokeWidth: strokeWidth,
            highlighted: isDatumHighlighted,
            seriesId: this.id
        });
        return {
            fill: (_a = format2 == null ? void 0 : format2.fill) != null ? _a : fill,
            fillOpacity: (_b = format2 == null ? void 0 : format2.fillOpacity) != null ? _b : fillOpacity,
            stroke: (_c = format2 == null ? void 0 : format2.stroke) != null ? _c : stroke,
            strokeWidth: (_d = format2 == null ? void 0 : format2.strokeWidth) != null ? _d : strokeWidth,
            strokeOpacity: (_e = format2 == null ? void 0 : format2.strokeOpacity) != null ? _e : strokeOpacity
        };
    }
    getInnerRadius() {
        const { radius: radius } = this;
        const { innerRadiusRatio: innerRadiusRatio = 1, innerRadiusOffset: innerRadiusOffset = 0 } = this.properties;
        const innerRadius = radius * innerRadiusRatio + innerRadiusOffset;
        if (innerRadius === radius || innerRadius < 0) return 0;
        return innerRadius;
    }
    getOuterRadius() {
        return Math.max(this.radius * this.properties.outerRadiusRatio + this.properties.outerRadiusOffset, 0);
    }
    updateRadiusScale(resize) {
        const newRange = [
            this.getInnerRadius(),
            this.getOuterRadius()
        ];
        this.radiusScale.range = newRange;
        if (resize) this.previousRadiusScale.range = newRange;
        this.nodeData = this.nodeData.map((_a)=>{
            var _b = _a, { radius: radius } = _b, d = $d77b025aa58d633c$var$__objRest(_b, [
                "radius"
            ]);
            return $d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, d), {
                radius: radius,
                innerRadius: Math.max(this.radiusScale.convert(0), 0),
                outerRadius: Math.max(this.radiusScale.convert(radius), 0)
            });
        });
    }
    getTitleTranslationY() {
        var _a, _b;
        const outerRadius = Math.max(0, this.radiusScale.range[1]);
        if (outerRadius === 0) return NaN;
        const spacing = (_b = (_a = this.properties.title) == null ? void 0 : _a.spacing) != null ? _b : 0;
        const titleOffset = 2 + spacing;
        const dy = Math.max(0, -outerRadius);
        return -outerRadius - titleOffset - dy;
    }
    update(_0) {
        return $d77b025aa58d633c$var$__async(this, arguments, function*({ seriesRect: seriesRect }) {
            const { title: title } = this.properties;
            const newNodeDataDependencies = {
                seriesRectWidth: seriesRect == null ? void 0 : seriesRect.width,
                seriesRectHeight: seriesRect == null ? void 0 : seriesRect.height
            };
            const resize = $d77b025aa58d633c$var$jsonDiff(this.nodeDataDependencies, newNodeDataDependencies) != null;
            if (resize) this._nodeDataDependencies = newNodeDataDependencies;
            yield this.maybeRefreshNodeData();
            this.updateTitleNodes();
            this.updateRadiusScale(resize);
            this.contentGroup.translationX = this.centerX;
            this.contentGroup.translationY = this.centerY;
            this.highlightGroup.translationX = this.centerX;
            this.highlightGroup.translationY = this.centerY;
            this.backgroundGroup.translationX = this.centerX;
            this.backgroundGroup.translationY = this.centerY;
            if (this.labelGroup) {
                this.labelGroup.translationX = this.centerX;
                this.labelGroup.translationY = this.centerY;
            }
            if (title) {
                const dy = this.getTitleTranslationY();
                const titleBox = title.node.computeBBox();
                title.node.visible = title.enabled && isFinite(dy) && !this.bboxIntersectsSurroundingSeries(titleBox, 0, dy);
                title.node.translationY = isFinite(dy) ? dy : 0;
            }
            for (const circle of [
                this.zerosumInnerRing,
                this.zerosumOuterRing
            ]){
                circle.fillOpacity = 0;
                circle.stroke = this.properties.calloutLabel.color;
                circle.strokeWidth = 1;
                circle.strokeOpacity = 1;
            }
            this.updateNodeMidPoint();
            yield this.updateSelections();
            yield this.updateNodes(seriesRect);
        });
    }
    updateTitleNodes() {
        var _a, _b;
        const { oldTitle: oldTitle } = this;
        const { title: title } = this.properties;
        if (oldTitle !== title) {
            if (oldTitle) (_a = this.labelGroup) == null || _a.removeChild(oldTitle.node);
            if (title) {
                title.node.textBaseline = "bottom";
                (_b = this.labelGroup) == null || _b.appendChild(title.node);
            }
            this.oldTitle = title;
        }
    }
    updateNodeMidPoint() {
        this.nodeData.forEach((d)=>{
            const radius = d.innerRadius + (d.outerRadius - d.innerRadius) / 2;
            d.midPoint = {
                x: d.midCos * Math.max(0, radius),
                y: d.midSin * Math.max(0, radius)
            };
        });
    }
    updateSelections() {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            yield this.updateGroupSelection();
            this.updateInnerCircleSelection();
        });
    }
    updateGroupSelection() {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            const { itemSelection: itemSelection, highlightSelection: highlightSelection, calloutLabelSelection: calloutLabelSelection, sectorLabelSelection: sectorLabelSelection, innerLabelsSelection: innerLabelsSelection } = this;
            const update = (selection, clone)=>{
                let nodeData = this.nodeData;
                if (clone) nodeData = nodeData.map((datum)=>$d77b025aa58d633c$var$__spreadProps($d77b025aa58d633c$var$__spreadValues({}, datum), {
                        sectorFormat: $d77b025aa58d633c$var$__spreadValues({}, datum.sectorFormat)
                    }));
                selection.update(nodeData, void 0, (datum)=>this.getDatumId(datum));
                if (this.ctx.animationManager.isSkipped()) selection.cleanup();
            };
            update(itemSelection, false);
            update(highlightSelection, true);
            calloutLabelSelection.update(this.nodeData, (group2)=>{
                const line = new $d77b025aa58d633c$var$Line();
                line.tag = 0 /* Callout */ ;
                line.pointerEvents = 1 /* None */ ;
                group2.appendChild(line);
                const text = new $d77b025aa58d633c$var$Text();
                text.tag = 1 /* Label */ ;
                text.pointerEvents = 1 /* None */ ;
                group2.appendChild(text);
            });
            sectorLabelSelection.update(this.nodeData, (node)=>{
                node.pointerEvents = 1 /* None */ ;
            });
            innerLabelsSelection.update(this.properties.innerLabels, (node)=>{
                node.pointerEvents = 1 /* None */ ;
            });
        });
    }
    updateInnerCircleSelection() {
        const { innerCircle: innerCircle } = this.properties;
        let radius = 0;
        const innerRadius = this.getInnerRadius();
        if (innerRadius > 0) {
            const circleRadius = Math.min(innerRadius, this.getOuterRadius());
            const antiAliasingPadding = 1;
            radius = Math.ceil(circleRadius * 2 + antiAliasingPadding);
        }
        const datums = innerCircle ? [
            {
                radius: radius
            }
        ] : [];
        this.innerCircleSelection.update(datums);
    }
    updateNodes(seriesRect) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            const highlightedDatum = this.ctx.highlightManager.getActiveHighlight();
            const isVisible = this.visible && this.seriesItemEnabled.indexOf(true) >= 0;
            this.rootGroup.visible = isVisible;
            this.backgroundGroup.visible = isVisible;
            this.contentGroup.visible = isVisible;
            this.highlightGroup.visible = isVisible && (highlightedDatum == null ? void 0 : highlightedDatum.series) === this;
            if (this.labelGroup) this.labelGroup.visible = isVisible;
            this.contentGroup.opacity = this.getOpacity();
            this.innerCircleSelection.each((node, { radius: radius })=>{
                var _a, _b;
                node.setProperties({
                    fill: (_a = this.properties.innerCircle) == null ? void 0 : _a.fill,
                    opacity: (_b = this.properties.innerCircle) == null ? void 0 : _b.fillOpacity,
                    size: radius
                });
            });
            const updateSectorFn = (sector, datum, _index, isDatumHighlighted)=>{
                const format2 = this.getSectorFormat(datum.datum, datum.itemId, isDatumHighlighted);
                datum.sectorFormat.fill = format2.fill;
                datum.sectorFormat.stroke = format2.stroke;
                const animationDisabled = this.ctx.animationManager.isSkipped();
                if (animationDisabled) {
                    sector.startAngle = datum.startAngle;
                    sector.endAngle = datum.endAngle;
                    sector.innerRadius = datum.innerRadius;
                    sector.outerRadius = datum.outerRadius;
                }
                if (isDatumHighlighted || animationDisabled) {
                    sector.fill = format2.fill;
                    sector.stroke = format2.stroke;
                }
                sector.strokeWidth = format2.strokeWidth;
                sector.fillOpacity = format2.fillOpacity;
                sector.strokeOpacity = this.properties.strokeOpacity;
                sector.lineDash = this.properties.lineDash;
                sector.lineDashOffset = this.properties.lineDashOffset;
                sector.fillShadow = this.properties.shadow;
                sector.cornerRadius = this.properties.cornerRadius;
                sector.inset = this.properties.sectorSpacing != null ? (this.properties.sectorSpacing + (format2.stroke != null ? format2.strokeWidth : 0)) / 2 : 0;
                sector.lineJoin = this.properties.sectorSpacing != null ? "miter" : "round";
            };
            this.itemSelection.each((node, datum, index)=>updateSectorFn(node, datum, index, false));
            this.highlightSelection.each((node, datum, index)=>{
                const isDatumHighlighted = (highlightedDatum == null ? void 0 : highlightedDatum.series) === this && node.datum.itemId === highlightedDatum.itemId;
                updateSectorFn(node, datum, index, true);
                node.visible = isDatumHighlighted;
            });
            this.updateCalloutLineNodes();
            this.updateCalloutLabelNodes(seriesRect);
            this.updateSectorLabelNodes();
            this.updateInnerLabelNodes();
            this.updateZerosumRings();
            this.animationState.transition("update");
        });
    }
    updateCalloutLineNodes() {
        var _a;
        const { calloutLine: calloutLine } = this.properties;
        const calloutLength = calloutLine.length;
        const calloutStrokeWidth = calloutLine.strokeWidth;
        const calloutColors = (_a = calloutLine.colors) != null ? _a : this.properties.strokes;
        const { offset: offset4 } = this.properties.calloutLabel;
        this.calloutLabelSelection.selectByTag(0 /* Callout */ ).forEach((line, index)=>{
            var _a2;
            const datum = line.datum;
            const { calloutLabel: label, outerRadius: outerRadius } = datum;
            if ((label == null ? void 0 : label.text) && !label.hidden && outerRadius !== 0) {
                line.visible = true;
                line.strokeWidth = calloutStrokeWidth;
                line.stroke = calloutColors[index % calloutColors.length];
                line.fill = void 0;
                const x1 = datum.midCos * outerRadius;
                const y1 = datum.midSin * outerRadius;
                let x2 = datum.midCos * (outerRadius + calloutLength);
                let y2 = datum.midSin * (outerRadius + calloutLength);
                const isMoved = (_a2 = label.collisionTextAlign) != null ? _a2 : label.collisionOffsetY !== 0;
                if (isMoved && label.box != null) {
                    const box = label.box;
                    let cx = x2;
                    let cy = y2;
                    if (x2 < box.x) cx = box.x;
                    else if (x2 > box.x + box.width) cx = box.x + box.width;
                    if (y2 < box.y) cy = box.y;
                    else if (y2 > box.y + box.height) cy = box.y + box.height;
                    const dx = cx - x2;
                    const dy = cy - y2;
                    const length = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));
                    const paddedLength = length - offset4;
                    if (paddedLength > 0) {
                        x2 = x2 + dx * paddedLength / length;
                        y2 = y2 + dy * paddedLength / length;
                    }
                }
                line.x1 = x1;
                line.y1 = y1;
                line.x2 = x2;
                line.y2 = y2;
            } else line.visible = false;
        });
    }
    getLabelOverflow(text, box, seriesRect) {
        const seriesLeft = seriesRect.x - this.centerX;
        const seriesRight = seriesRect.x + seriesRect.width - this.centerX;
        const seriesTop = seriesRect.y - this.centerY;
        const seriesBottom = seriesRect.y + seriesRect.height - this.centerY;
        const errPx = 1;
        let visibleTextPart = 1;
        if (box.x + errPx < seriesLeft) visibleTextPart = (box.x + box.width - seriesLeft) / box.width;
        else if (box.x + box.width - errPx > seriesRight) visibleTextPart = (seriesRight - box.x) / box.width;
        const hasVerticalOverflow = box.y + errPx < seriesTop || box.y + box.height - errPx > seriesBottom;
        const textLength = visibleTextPart === 1 ? text.length : Math.floor(text.length * visibleTextPart) - 1;
        const hasSurroundingSeriesOverflow = this.bboxIntersectsSurroundingSeries(box);
        return {
            textLength: textLength,
            hasVerticalOverflow: hasVerticalOverflow,
            hasSurroundingSeriesOverflow: hasSurroundingSeriesOverflow
        };
    }
    bboxIntersectsSurroundingSeries(box, dx = 0, dy = 0) {
        const { surroundingRadius: surroundingRadius } = this;
        if (surroundingRadius == null) return false;
        const corners = [
            {
                x: box.x + dx,
                y: box.y + dy
            },
            {
                x: box.x + box.width + dx,
                y: box.y + dy
            },
            {
                x: box.x + box.width + dx,
                y: box.y + box.height + dy
            },
            {
                x: box.x + dx,
                y: box.y + box.height + dy
            }
        ];
        const sur2 = $d77b025aa58d633c$var$__pow(surroundingRadius, 2);
        return corners.some((corner)=>$d77b025aa58d633c$var$__pow(corner.x, 2) + $d77b025aa58d633c$var$__pow(corner.y, 2) > sur2);
    }
    computeCalloutLabelCollisionOffsets() {
        const { radiusScale: radiusScale } = this;
        const { calloutLabel: calloutLabel, calloutLine: calloutLine } = this.properties;
        const { offset: offset4, minSpacing: minSpacing } = calloutLabel;
        const innerRadius = radiusScale.convert(0);
        const shouldSkip = (datum)=>{
            const label = datum.calloutLabel;
            return !label || datum.outerRadius === 0;
        };
        const fullData = this.nodeData;
        const data = this.nodeData.filter((t)=>!shouldSkip(t));
        data.forEach((datum)=>{
            const label = datum.calloutLabel;
            if (label == null) return;
            label.hidden = false;
            label.collisionTextAlign = void 0;
            label.collisionOffsetY = 0;
        });
        if (data.length <= 1) return;
        const leftLabels = data.filter((d)=>d.midCos < 0).sort((a, b)=>a.midSin - b.midSin);
        const rightLabels = data.filter((d)=>d.midCos >= 0).sort((a, b)=>a.midSin - b.midSin);
        const topLabels = data.filter((d)=>{
            var _a;
            return d.midSin < 0 && ((_a = d.calloutLabel) == null ? void 0 : _a.textAlign) === "center";
        }).sort((a, b)=>a.midCos - b.midCos);
        const bottomLabels = data.filter((d)=>{
            var _a;
            return d.midSin >= 0 && ((_a = d.calloutLabel) == null ? void 0 : _a.textAlign) === "center";
        }).sort((a, b)=>a.midCos - b.midCos);
        const tempTextNode = new $d77b025aa58d633c$var$Text();
        const getTextBBox = (datum)=>{
            var _a;
            const label = datum.calloutLabel;
            if (label == null) return new $d77b025aa58d633c$var$BBox(0, 0, 0, 0);
            const labelRadius = datum.outerRadius + calloutLine.length + offset4;
            const x = datum.midCos * labelRadius;
            const y = datum.midSin * labelRadius + label.collisionOffsetY;
            tempTextNode.text = label.text;
            tempTextNode.x = x;
            tempTextNode.y = y;
            tempTextNode.setFont(this.properties.calloutLabel);
            tempTextNode.setAlign({
                textAlign: (_a = label.collisionTextAlign) != null ? _a : label.textAlign,
                textBaseline: label.textBaseline
            });
            return tempTextNode.computeBBox();
        };
        const avoidNeighbourYCollision = (label, next, direction)=>{
            const box = getTextBBox(label).grow(minSpacing / 2);
            const other = getTextBBox(next).grow(minSpacing / 2);
            const collidesOrBehind = box.x < other.x + other.width && box.x + box.width > other.x && (direction === "to-top" ? box.y < other.y + other.height : box.y + box.height > other.y);
            if (collidesOrBehind) {
                const dy = direction === "to-top" ? box.y - other.y - other.height : box.y + box.height - other.y;
                next.calloutLabel.collisionOffsetY = dy;
            }
        };
        const avoidYCollisions = (labels)=>{
            const midLabel = labels.slice().sort((a, b)=>Math.abs(a.midSin) - Math.abs(b.midSin))[0];
            const midIndex = labels.indexOf(midLabel);
            for(let i = midIndex - 1; i >= 0; i--){
                const prev = labels[i + 1];
                const next = labels[i];
                avoidNeighbourYCollision(prev, next, "to-top");
            }
            for(let i = midIndex + 1; i < labels.length; i++){
                const prev = labels[i - 1];
                const next = labels[i];
                avoidNeighbourYCollision(prev, next, "to-bottom");
            }
        };
        const avoidXCollisions = (labels)=>{
            const labelsCollideLabelsByY = data.some((datum)=>datum.calloutLabel.collisionOffsetY !== 0);
            const boxes = labels.map((label)=>getTextBBox(label));
            const paddedBoxes = boxes.map((box)=>box.clone().grow(minSpacing / 2));
            let labelsCollideLabelsByX = false;
            for(let i = 0; i < paddedBoxes.length && !labelsCollideLabelsByX; i++){
                const box = paddedBoxes[i];
                for(let j = i + 1; j < labels.length; j++){
                    const other = paddedBoxes[j];
                    if (box.collidesBBox(other)) {
                        labelsCollideLabelsByX = true;
                        break;
                    }
                }
            }
            const sectors = fullData.map((datum)=>{
                const { startAngle: startAngle, endAngle: endAngle, outerRadius: outerRadius } = datum;
                return {
                    startAngle: startAngle,
                    endAngle: endAngle,
                    innerRadius: innerRadius,
                    outerRadius: outerRadius
                };
            });
            const labelsCollideSectors = boxes.some((box)=>{
                return sectors.some((sector)=>$d77b025aa58d633c$var$boxCollidesSector(box, sector));
            });
            if (!labelsCollideLabelsByX && !labelsCollideLabelsByY && !labelsCollideSectors) return;
            labels.filter((d)=>d.calloutLabel.textAlign === "center").forEach((d)=>{
                const label = d.calloutLabel;
                if (d.midCos < 0) label.collisionTextAlign = "right";
                else if (d.midCos > 0) label.collisionTextAlign = "left";
                else label.collisionTextAlign = "center";
            });
        };
        avoidYCollisions(leftLabels);
        avoidYCollisions(rightLabels);
        avoidXCollisions(topLabels);
        avoidXCollisions(bottomLabels);
    }
    updateCalloutLabelNodes(seriesRect) {
        const { radiusScale: radiusScale } = this;
        const { calloutLabel: calloutLabel, calloutLine: calloutLine } = this.properties;
        const calloutLength = calloutLine.length;
        const { offset: offset4, color: color } = calloutLabel;
        const tempTextNode = new $d77b025aa58d633c$var$Text();
        this.calloutLabelSelection.selectByTag(1 /* Label */ ).forEach((text)=>{
            var _a;
            const { datum: datum } = text;
            const label = datum.calloutLabel;
            const radius = radiusScale.convert(datum.radius);
            const outerRadius = Math.max(0, radius);
            if (!(label == null ? void 0 : label.text) || outerRadius === 0 || label.hidden) {
                text.visible = false;
                return;
            }
            const labelRadius = outerRadius + calloutLength + offset4;
            const x = datum.midCos * labelRadius;
            const y = datum.midSin * labelRadius + label.collisionOffsetY;
            const align = {
                textAlign: (_a = label.collisionTextAlign) != null ? _a : label.textAlign,
                textBaseline: label.textBaseline
            };
            tempTextNode.text = label.text;
            tempTextNode.x = x;
            tempTextNode.y = y;
            tempTextNode.setFont(this.properties.calloutLabel);
            tempTextNode.setAlign(align);
            const box = tempTextNode.computeBBox();
            let displayText = label.text;
            let visible = true;
            if (calloutLabel.avoidCollisions) {
                const { textLength: textLength, hasVerticalOverflow: hasVerticalOverflow } = this.getLabelOverflow(label.text, box, seriesRect);
                displayText = label.text.length === textLength ? label.text : `${label.text.substring(0, textLength)}\u2026`;
                visible = !hasVerticalOverflow;
            }
            text.text = displayText;
            text.x = x;
            text.y = y;
            text.setFont(this.properties.calloutLabel);
            text.setAlign(align);
            text.fill = color;
            text.visible = visible;
        });
    }
    computeLabelsBBox(options, seriesRect) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            const { calloutLabel: calloutLabel, calloutLine: calloutLine } = this.properties;
            const calloutLength = calloutLine.length;
            const { offset: offset4, maxCollisionOffset: maxCollisionOffset, minSpacing: minSpacing } = calloutLabel;
            if (!calloutLabel.avoidCollisions) return null;
            yield this.maybeRefreshNodeData();
            this.updateRadiusScale(false);
            this.computeCalloutLabelCollisionOffsets();
            const textBoxes = [];
            const text = new $d77b025aa58d633c$var$Text();
            let titleBox;
            const { title: title } = this.properties;
            if ((title == null ? void 0 : title.text) && title.enabled) {
                const dy = this.getTitleTranslationY();
                if (isFinite(dy)) {
                    text.text = title.text;
                    text.x = 0;
                    text.y = dy;
                    text.setFont(title);
                    text.setAlign({
                        textBaseline: "bottom",
                        textAlign: "center"
                    });
                    titleBox = text.computeBBox();
                    textBoxes.push(titleBox);
                }
            }
            this.nodeData.forEach((datum)=>{
                var _a;
                const label = datum.calloutLabel;
                if (!label || datum.outerRadius === 0) return null;
                const labelRadius = datum.outerRadius + calloutLength + offset4;
                const x = datum.midCos * labelRadius;
                const y = datum.midSin * labelRadius + label.collisionOffsetY;
                text.text = label.text;
                text.x = x;
                text.y = y;
                text.setFont(this.properties.calloutLabel);
                text.setAlign({
                    textAlign: (_a = label.collisionTextAlign) != null ? _a : label.textAlign,
                    textBaseline: label.textBaseline
                });
                const box = text.computeBBox();
                label.box = box;
                if (Math.abs(label.collisionOffsetY) > maxCollisionOffset) {
                    label.hidden = true;
                    return;
                }
                if (titleBox) {
                    const seriesTop = seriesRect.y - this.centerY;
                    const titleCleanArea = new $d77b025aa58d633c$var$BBox(titleBox.x - minSpacing, seriesTop, titleBox.width + 2 * minSpacing, titleBox.y + titleBox.height + minSpacing - seriesTop);
                    if (box.collidesBBox(titleCleanArea)) {
                        label.hidden = true;
                        return;
                    }
                }
                if (options.hideWhenNecessary) {
                    const { textLength: textLength, hasVerticalOverflow: hasVerticalOverflow, hasSurroundingSeriesOverflow: hasSurroundingSeriesOverflow } = this.getLabelOverflow(label.text, box, seriesRect);
                    const isTooShort = label.text.length > 2 && textLength < 2;
                    if (hasVerticalOverflow || isTooShort || hasSurroundingSeriesOverflow) {
                        label.hidden = true;
                        return;
                    }
                }
                label.hidden = false;
                textBoxes.push(box);
            });
            if (textBoxes.length === 0) return null;
            return $d77b025aa58d633c$var$BBox.merge(textBoxes);
        });
    }
    updateSectorLabelNodes() {
        const { radiusScale: radiusScale } = this;
        const innerRadius = radiusScale.convert(0);
        const { fontSize: fontSize, fontStyle: fontStyle, fontWeight: fontWeight, fontFamily: fontFamily, positionOffset: positionOffset, positionRatio: positionRatio, color: color } = this.properties.sectorLabel;
        const isDonut = innerRadius > 0;
        const singleVisibleSector = this.seriesItemEnabled.filter(Boolean).length === 1;
        this.sectorLabelSelection.each((text, datum)=>{
            const { sectorLabel: sectorLabel, outerRadius: outerRadius } = datum;
            let isTextVisible = false;
            if (sectorLabel && outerRadius !== 0) {
                const labelRadius = innerRadius * (1 - positionRatio) + outerRadius * positionRatio + positionOffset;
                text.fill = color;
                text.fontStyle = fontStyle;
                text.fontWeight = fontWeight;
                text.fontSize = fontSize;
                text.fontFamily = fontFamily;
                text.text = sectorLabel.text;
                const shouldPutTextInCenter = !isDonut && singleVisibleSector;
                if (shouldPutTextInCenter) {
                    text.x = 0;
                    text.y = 0;
                } else {
                    text.x = datum.midCos * labelRadius;
                    text.y = datum.midSin * labelRadius;
                }
                text.textAlign = "center";
                text.textBaseline = "middle";
                const bbox = text.computeBBox();
                const corners = [
                    [
                        bbox.x,
                        bbox.y
                    ],
                    [
                        bbox.x + bbox.width,
                        bbox.y
                    ],
                    [
                        bbox.x + bbox.width,
                        bbox.y + bbox.height
                    ],
                    [
                        bbox.x,
                        bbox.y + bbox.height
                    ]
                ];
                const { startAngle: startAngle, endAngle: endAngle } = datum;
                const sectorBounds = {
                    startAngle: startAngle,
                    endAngle: endAngle,
                    innerRadius: innerRadius,
                    outerRadius: outerRadius
                };
                if (corners.every(([x, y])=>$d77b025aa58d633c$var$isPointInSector(x, y, sectorBounds))) isTextVisible = true;
            }
            text.visible = isTextVisible;
        });
    }
    updateInnerLabelNodes() {
        const textBBoxes = [];
        const margins = [];
        this.innerLabelsSelection.each((text, datum)=>{
            const { fontStyle: fontStyle, fontWeight: fontWeight, fontSize: fontSize, fontFamily: fontFamily, color: color, margin: margin = 2 } = datum;
            text.fontStyle = fontStyle;
            text.fontWeight = fontWeight;
            text.fontSize = fontSize;
            text.fontFamily = fontFamily;
            text.text = datum.text;
            text.x = 0;
            text.y = 0;
            text.fill = color;
            text.textAlign = "center";
            text.textBaseline = "alphabetic";
            textBBoxes.push(text.computeBBox());
            margins.push(margin);
        });
        const getMarginTop = (index)=>index === 0 ? 0 : margins[index];
        const getMarginBottom = (index)=>index === margins.length - 1 ? 0 : margins[index];
        const totalHeight = textBBoxes.reduce((sum2, bbox, i)=>{
            return sum2 + bbox.height + getMarginTop(i) + getMarginBottom(i);
        }, 0);
        const totalWidth = Math.max(...textBBoxes.map((bbox)=>bbox.width));
        const innerRadius = this.getInnerRadius();
        const labelRadius = Math.sqrt(Math.pow(totalWidth / 2, 2) + Math.pow(totalHeight / 2, 2));
        const labelsVisible = labelRadius <= (innerRadius > 0 ? innerRadius : this.getOuterRadius());
        const textBottoms = [];
        for(let i = 0, prev = -totalHeight / 2; i < textBBoxes.length; i++){
            const bbox = textBBoxes[i];
            const bottom = bbox.height + prev + getMarginTop(i);
            textBottoms.push(bottom);
            prev = bottom + getMarginBottom(i);
        }
        this.innerLabelsSelection.each((text, _datum, index)=>{
            text.y = textBottoms[index];
            text.visible = labelsVisible;
        });
    }
    updateZerosumRings() {
        this.zerosumOuterRing.size = this.getOuterRadius() * 2;
        this.zerosumInnerRing.size = this.getInnerRadius() * 2;
    }
    getDatumLegendName(nodeDatum) {
        const { angleKey: angleKey, calloutLabelKey: calloutLabelKey, sectorLabelKey: sectorLabelKey, legendItemKey: legendItemKey } = this.properties;
        const { sectorLabel: sectorLabel, calloutLabel: calloutLabel, legendItem: legendItem } = nodeDatum;
        if (legendItemKey && legendItem !== void 0) return legendItem.text;
        else if (calloutLabelKey && calloutLabelKey !== angleKey && (calloutLabel == null ? void 0 : calloutLabel.text) !== void 0) return calloutLabel.text;
        else if (sectorLabelKey && sectorLabelKey !== angleKey && (sectorLabel == null ? void 0 : sectorLabel.text) !== void 0) return sectorLabel.text;
    }
    pickNodeClosestDatum(point) {
        return $d77b025aa58d633c$var$pickByMatchingAngle(this, point);
    }
    getTooltipHtml(nodeDatum) {
        var _a;
        if (!this.properties.isValid()) return $d77b025aa58d633c$var$EMPTY_TOOLTIP_CONTENT;
        const { datum: datum, angleValue: angleValue, sectorFormat: { fill: color }, itemId: itemId } = nodeDatum;
        const title = $d77b025aa58d633c$var$sanitizeHtml((_a = this.properties.title) == null ? void 0 : _a.text);
        const content = $d77b025aa58d633c$var$isFiniteNumber(angleValue) ? $d77b025aa58d633c$var$toFixed(angleValue) : String(angleValue);
        const labelText = this.getDatumLegendName(nodeDatum);
        return this.properties.tooltip.toTooltipHtml({
            title: title != null ? title : labelText,
            content: title && labelText ? `${labelText}: ${content}` : content,
            backgroundColor: color
        }, {
            datum: datum,
            itemId: itemId,
            title: title,
            color: color,
            seriesId: this.id,
            angleKey: this.properties.angleKey,
            angleName: this.properties.angleName,
            radiusKey: this.properties.radiusKey,
            radiusName: this.properties.radiusName,
            calloutLabelKey: this.properties.calloutLabelKey,
            calloutLabelName: this.properties.calloutLabelName,
            sectorLabelKey: this.properties.sectorLabelKey,
            sectorLabelName: this.properties.sectorLabelName,
            legendItemKey: this.properties.legendItemKey
        });
    }
    getLegendData(legendType) {
        var _a, _b, _c, _d, _e;
        const { visible: visible, processedData: processedData, dataModel: dataModel } = this;
        if (!dataModel || !(processedData == null ? void 0 : processedData.data.length) || legendType !== "category") return [];
        const { angleKey: angleKey, calloutLabelKey: calloutLabelKey, sectorLabelKey: sectorLabelKey, legendItemKey: legendItemKey } = this.properties;
        if (!legendItemKey && (!calloutLabelKey || calloutLabelKey === angleKey) && (!sectorLabelKey || sectorLabelKey === angleKey)) return [];
        const { calloutLabelIdx: calloutLabelIdx, sectorLabelIdx: sectorLabelIdx, legendItemIdx: legendItemIdx } = this.getProcessedDataIndexes(dataModel);
        const titleText = ((_a = this.properties.title) == null ? void 0 : _a.showInLegend) && this.properties.title.text;
        const legendData = [];
        for(let index = 0; index < processedData.data.length; index++){
            const { datum: datum, values: values } = processedData.data[index];
            const labelParts = [];
            if (titleText) labelParts.push(titleText);
            const labels = this.getLabels(datum, 2 * Math.PI, 2 * Math.PI, false, values[calloutLabelIdx], values[sectorLabelIdx], values[legendItemIdx]);
            if (legendItemKey && labels.legendItem !== void 0) labelParts.push(labels.legendItem.text);
            else if (calloutLabelKey && calloutLabelKey !== angleKey && ((_b = labels.calloutLabel) == null ? void 0 : _b.text) !== void 0) labelParts.push((_c = labels.calloutLabel) == null ? void 0 : _c.text);
            else if (sectorLabelKey && sectorLabelKey !== angleKey && ((_d = labels.sectorLabel) == null ? void 0 : _d.text) !== void 0) labelParts.push((_e = labels.sectorLabel) == null ? void 0 : _e.text);
            if (labelParts.length === 0) continue;
            const sectorFormat = this.getSectorFormat(datum, index, false);
            legendData.push({
                legendType: "category",
                id: this.id,
                itemId: index,
                seriesId: this.id,
                enabled: visible && this.seriesItemEnabled[index],
                label: {
                    text: labelParts.join(" - ")
                },
                marker: {
                    fill: sectorFormat.fill,
                    stroke: sectorFormat.stroke,
                    fillOpacity: this.properties.fillOpacity,
                    strokeOpacity: this.properties.strokeOpacity,
                    strokeWidth: this.properties.strokeWidth
                },
                legendItemName: legendItemKey != null ? datum[legendItemKey] : void 0
            });
        }
        return legendData;
    }
    onLegendItemClick(event) {
        const { enabled: enabled, itemId: itemId, series: series, legendItemName: legendItemName } = event;
        if (series.id === this.id) this.toggleSeriesItem(itemId, enabled);
        else if (legendItemName != null) this.toggleOtherSeriesItems(legendItemName, enabled);
    }
    toggleSeriesItem(itemId, enabled) {
        this.seriesItemEnabled[itemId] = enabled;
        this.nodeDataRefresh = true;
    }
    toggleOtherSeriesItems(legendItemName, enabled) {
        var _a;
        if (!this.properties.legendItemKey || !this.dataModel) return;
        const legendItemIdx = this.dataModel.resolveProcessedDataIndexById(this, `legendItemValue`);
        (_a = this.processedData) == null || _a.data.forEach(({ values: values }, datumItemId)=>{
            if (values[legendItemIdx] === legendItemName) this.toggleSeriesItem(datumItemId, enabled);
        });
    }
    animateEmptyUpdateReady(_data) {
        const { animationManager: animationManager } = this.ctx;
        const fns = $d77b025aa58d633c$var$preparePieSeriesAnimationFunctions(true, this.properties.rotation, this.radiusScale, this.previousRadiusScale);
        $d77b025aa58d633c$var$fromToMotion(this.id, "nodes", animationManager, [
            this.itemSelection,
            this.highlightSelection
        ], fns.nodes);
        $d77b025aa58d633c$var$fromToMotion(this.id, `innerCircle`, animationManager, [
            this.innerCircleSelection
        ], fns.innerCircle);
        $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "callout", animationManager, this.calloutLabelSelection);
        $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "sector", animationManager, this.sectorLabelSelection);
        $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "inner", animationManager, this.innerLabelsSelection);
        this.previousRadiusScale.range = this.radiusScale.range;
    }
    animateWaitingUpdateReady() {
        var _a, _b, _c, _d, _e, _f;
        const { itemSelection: itemSelection, highlightSelection: highlightSelection, processedData: processedData, radiusScale: radiusScale, previousRadiusScale: previousRadiusScale } = this;
        const { animationManager: animationManager } = this.ctx;
        const dataDiff = (_a = processedData == null ? void 0 : processedData.reduced) == null ? void 0 : _a.diff;
        this.ctx.animationManager.stopByAnimationGroupId(this.id);
        const supportedDiff = ((_b = dataDiff == null ? void 0 : dataDiff.moved.size) != null ? _b : 0) === 0;
        const hasKeys = ((_c = processedData == null ? void 0 : processedData.defs.keys.length) != null ? _c : 0) > 0;
        const hasUniqueKeys = (_f = (_e = (_d = processedData == null ? void 0 : processedData.reduced) == null ? void 0 : _d.animationValidation) == null ? void 0 : _e.uniqueKeys) != null ? _f : true;
        if (!supportedDiff || !hasKeys || !hasUniqueKeys) this.ctx.animationManager.skipCurrentBatch();
        const fns = $d77b025aa58d633c$var$preparePieSeriesAnimationFunctions(false, this.properties.rotation, radiusScale, previousRadiusScale);
        $d77b025aa58d633c$var$fromToMotion(this.id, "nodes", animationManager, [
            itemSelection,
            highlightSelection
        ], fns.nodes, (_, datum)=>this.getDatumId(datum), dataDiff);
        $d77b025aa58d633c$var$fromToMotion(this.id, `innerCircle`, animationManager, [
            this.innerCircleSelection
        ], fns.innerCircle);
        $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "callout", this.ctx.animationManager, this.calloutLabelSelection);
        $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "sector", this.ctx.animationManager, this.sectorLabelSelection);
        $d77b025aa58d633c$var$seriesLabelFadeInAnimation(this, "inner", this.ctx.animationManager, this.innerLabelsSelection);
        this.previousRadiusScale.range = this.radiusScale.range;
    }
    animateClearingUpdateEmpty() {
        const { itemSelection: itemSelection, highlightSelection: highlightSelection, radiusScale: radiusScale, previousRadiusScale: previousRadiusScale } = this;
        const { animationManager: animationManager } = this.ctx;
        const fns = $d77b025aa58d633c$var$preparePieSeriesAnimationFunctions(false, this.properties.rotation, radiusScale, previousRadiusScale);
        $d77b025aa58d633c$var$fromToMotion(this.id, "nodes", animationManager, [
            itemSelection,
            highlightSelection
        ], fns.nodes);
        $d77b025aa58d633c$var$fromToMotion(this.id, `innerCircle`, animationManager, [
            this.innerCircleSelection
        ], fns.innerCircle);
        $d77b025aa58d633c$var$seriesLabelFadeOutAnimation(this, "callout", this.ctx.animationManager, this.calloutLabelSelection);
        $d77b025aa58d633c$var$seriesLabelFadeOutAnimation(this, "sector", this.ctx.animationManager, this.sectorLabelSelection);
        $d77b025aa58d633c$var$seriesLabelFadeOutAnimation(this, "inner", this.ctx.animationManager, this.innerLabelsSelection);
        this.previousRadiusScale.range = this.radiusScale.range;
    }
    getDatumIdFromData(datum) {
        var _a, _b, _c;
        const { calloutLabelKey: calloutLabelKey, sectorLabelKey: sectorLabelKey, legendItemKey: legendItemKey } = this.properties;
        if (!((_c = (_b = (_a = this.processedData) == null ? void 0 : _a.reduced) == null ? void 0 : _b.animationValidation) == null ? void 0 : _c.uniqueKeys)) return;
        if (legendItemKey) return datum[legendItemKey];
        else if (calloutLabelKey) return datum[calloutLabelKey];
        else if (sectorLabelKey) return datum[sectorLabelKey];
    }
    getDatumId(datum) {
        const { index: index } = datum;
        const datumId = this.getDatumIdFromData(datum.datum);
        return datumId != null ? String(datumId) : `${index}`;
    }
    onDataChange() {
        var _a;
        const { data: data, seriesItemEnabled: seriesItemEnabled } = this;
        this.seriesItemEnabled = (_a = data == null ? void 0 : data.map((_, index)=>{
            var _a2;
            return (_a2 = seriesItemEnabled[index]) != null ? _a2 : true;
        })) != null ? _a : [];
    }
    computeFocusBounds(opts) {
        return $d77b025aa58d633c$var$computeSectorFocusBounds(this, opts);
    }
};
$d77b025aa58d633c$var$PieSeries.className = "PieSeries";
$d77b025aa58d633c$var$PieSeries.type = "pie";
// packages/ag-charts-community/src/chart/series/polar/pieSeriesModule.ts
var $d77b025aa58d633c$var$PieSeriesModule = {
    type: "series",
    optionsKey: "series[]",
    packageType: "community",
    chartTypes: [
        "polar"
    ],
    identifier: "pie",
    instanceConstructor: $d77b025aa58d633c$var$PieSeries,
    themeTemplate: $d77b025aa58d633c$var$pieTheme,
    paletteFactory: $d77b025aa58d633c$var$piePaletteFactory
};
// packages/ag-charts-community/src/chart/toolbar/toolbarTypes.ts
var $d77b025aa58d633c$var$TOOLBAR_ALIGNMENTS = [
    "start",
    "center",
    "end"
];
var $d77b025aa58d633c$var$TOOLBAR_GROUPS = [
    "annotations",
    "ranges",
    "zoom"
];
var $d77b025aa58d633c$var$ToolbarPosition = /* @__PURE__ */ ((ToolbarPosition2)=>{
    ToolbarPosition2["Top"] = "top";
    ToolbarPosition2["Right"] = "right";
    ToolbarPosition2["Bottom"] = "bottom";
    ToolbarPosition2["Left"] = "left";
    ToolbarPosition2["FloatingTop"] = "floating-top";
    ToolbarPosition2["FloatingBottom"] = "floating-bottom";
    return ToolbarPosition2;
})($d77b025aa58d633c$var$ToolbarPosition || {});
var $d77b025aa58d633c$var$TOOLBAR_POSITIONS = Object.values($d77b025aa58d633c$var$ToolbarPosition);
// packages/ag-charts-community/src/chart/toolbar/toolbarProperties.ts
var $d77b025aa58d633c$var$ToolbarGroupProperties = class extends $d77b025aa58d633c$var$BaseProperties {
    constructor(onChange, onButtonsChange){
        super();
        this.onChange = onChange;
        this.onButtonsChange = onButtonsChange;
        this.align = "start";
        this.position = "top" /* Top */ ;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ObserveChanges((target)=>{
        target.onChange(target.enabled);
    }),
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN)
], $d77b025aa58d633c$var$ToolbarGroupProperties.prototype, "enabled", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ObserveChanges((target)=>{
        target.onChange(target.enabled);
    }),
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$UNION([
        "start",
        "center",
        "end"
    ]), {
        optional: true
    })
], $d77b025aa58d633c$var$ToolbarGroupProperties.prototype, "align", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ObserveChanges((target)=>{
        target.onChange(target.enabled);
    }),
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$UNION([
        "top",
        "right",
        "bottom",
        "left",
        "floating-top",
        "floating-bottom"
    ]), {
        optional: true
    })
], $d77b025aa58d633c$var$ToolbarGroupProperties.prototype, "position", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ObserveChanges((target)=>{
        target.onButtonsChange(target.buttons);
    }),
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$ARRAY, {
        optional: true
    })
], $d77b025aa58d633c$var$ToolbarGroupProperties.prototype, "buttons", 2);
// packages/ag-charts-community/src/chart/toolbar/toolbarStyles.ts
var $d77b025aa58d633c$var$block2 = "ag-charts-toolbar";
var $d77b025aa58d633c$var$elements2 = {
    align: `${$d77b025aa58d633c$var$block2}__align`,
    button: `${$d77b025aa58d633c$var$block2}__button`,
    icon: `${$d77b025aa58d633c$var$block2}__icon`,
    label: `${$d77b025aa58d633c$var$block2}__label`
};
var $d77b025aa58d633c$var$modifiers2 = {
    ["top" /* Top */ ]: `${$d77b025aa58d633c$var$block2}--top`,
    ["right" /* Right */ ]: `${$d77b025aa58d633c$var$block2}--right`,
    ["bottom" /* Bottom */ ]: `${$d77b025aa58d633c$var$block2}--bottom`,
    ["left" /* Left */ ]: `${$d77b025aa58d633c$var$block2}--left`,
    ["floating-top" /* FloatingTop */ ]: `${$d77b025aa58d633c$var$block2}--floating-top`,
    ["floating-bottom" /* FloatingBottom */ ]: `${$d77b025aa58d633c$var$block2}--floating-bottom`,
    hidden: `${$d77b025aa58d633c$var$block2}--hidden`,
    preventFlash: `${$d77b025aa58d633c$var$block2}--prevent-flash`,
    floatingHidden: `${$d77b025aa58d633c$var$block2}--floating-hidden`,
    align: {
        start: `${$d77b025aa58d633c$var$elements2.align}--start`,
        center: `${$d77b025aa58d633c$var$elements2.align}--center`,
        end: `${$d77b025aa58d633c$var$elements2.align}--end`
    },
    button: {
        hidden: `${$d77b025aa58d633c$var$elements2.button}--hidden`
    }
};
var $d77b025aa58d633c$var$css2 = `
.${$d77b025aa58d633c$var$block2} {
    align-items: center;
    background: var(--ag-charts-toolbar-background-color);
    border-bottom: var(--ag-charts-toolbar-border-critical);
    border-top: var(--ag-charts-toolbar-border-critical);
    border-left: var(--ag-charts-toolbar-border);
    border-right: var(--ag-charts-toolbar-border);
    display: flex;
    flex-wrap: nowrap;
    opacity: 1;
    position: absolute;
    transform: translateY(0);
    transition: opacity 0.2s ease-in-out, transform 0.2s ease-in-out;
}

.${$d77b025aa58d633c$var$modifiers2.hidden},
.${$d77b025aa58d633c$var$modifiers2.preventFlash} {
    visibility: hidden;
}

.${$d77b025aa58d633c$var$modifiers2.floatingHidden} {
    opacity: 0;
    transition: opacity 0.4s ease-in-out;
}

.${$d77b025aa58d633c$var$modifiers2["top" /* Top */ ]},
.${$d77b025aa58d633c$var$modifiers2["bottom" /* Bottom */ ]} {
    flex-direction: row;
    height: var(--ag-charts-toolbar-size);
    padding: 0 var(--ag-charts-toolbar-padding);
    width: 100%;
}

.${$d77b025aa58d633c$var$modifiers2["left" /* Left */ ]},
.${$d77b025aa58d633c$var$modifiers2["right" /* Right */ ]} {
    flex-direction: column;
    padding: var(--ag-charts-toolbar-padding) 0;
    width: var(--ag-charts-toolbar-size);
}

.${$d77b025aa58d633c$var$modifiers2["floating-top" /* FloatingTop */ ]},
.${$d77b025aa58d633c$var$modifiers2["floating-bottom" /* FloatingBottom */ ]} {
    background: none;
    border: none;
    flex-direction: row;
    height: var(--ag-charts-toolbar-size);
    overflow: hidden;
    padding: 0 var(--ag-charts-toolbar-padding);
    pointer-events: none;
    width: 100%;
}

.${$d77b025aa58d633c$var$elements2.align} {
    display: flex;
    flex-direction: inherit;
    flex-wrap: inherit;
    max-width: 100%;
}

.${$d77b025aa58d633c$var$modifiers2.align.center},
.${$d77b025aa58d633c$var$modifiers2.align.end} {
    margin-left: auto;
}

.${$d77b025aa58d633c$var$modifiers2["left" /* Left */ ]} .${$d77b025aa58d633c$var$modifiers2.align.center},
.${$d77b025aa58d633c$var$modifiers2["left" /* Left */ ]} .${$d77b025aa58d633c$var$modifiers2.align.end},
.${$d77b025aa58d633c$var$modifiers2["right" /* Right */ ]} .${$d77b025aa58d633c$var$modifiers2.align.center},
.${$d77b025aa58d633c$var$modifiers2["right" /* Right */ ]} .${$d77b025aa58d633c$var$modifiers2.align.end} {
    margin-left: 0;
    margin-top: auto;
}

.${$d77b025aa58d633c$var$modifiers2["floating-top" /* FloatingTop */ ]} .${$d77b025aa58d633c$var$elements2.align},
.${$d77b025aa58d633c$var$modifiers2["floating-bottom" /* FloatingBottom */ ]} .${$d77b025aa58d633c$var$elements2.align} {
    gap: var(--ag-charts-toolbar-gap);
    transition: transform 0.4s ease-in-out;
}

.${$d77b025aa58d633c$var$elements2.button} {
    align-items: center;
    border-radius: var(--ag-charts-button-radius);
    color: var(--ag-charts-toolbar-foreground-color);
    display: flex;
    font-size: 14px;
    font-weight: 500;
    justify-content: center;
    margin: 0;
    padding: var(--ag-charts-button-padding);
    pointer-events: all;
    transition: background-color .25s ease-in-out;
}

.${$d77b025aa58d633c$var$modifiers2["left" /* Left */ ]} .${$d77b025aa58d633c$var$elements2.button},
.${$d77b025aa58d633c$var$modifiers2["right" /* Right */ ]} .${$d77b025aa58d633c$var$elements2.button} {
    height: var(--ag-charts-toolbar-size);
    max-width: 100%;
    overflow: hidden;
}

.${$d77b025aa58d633c$var$modifiers2["floating-top" /* FloatingTop */ ]} .${$d77b025aa58d633c$var$elements2.button},
.${$d77b025aa58d633c$var$modifiers2["floating-bottom" /* FloatingBottom */ ]} .${$d77b025aa58d633c$var$elements2.button} {
    background: var(--ag-charts-toolbar-background-color);
    border: var(--ag-charts-toolbar-border-critical);
}

.${$d77b025aa58d633c$var$modifiers2.button.hidden} {
    display: none;
}

.${$d77b025aa58d633c$var$elements2.button}:hover {
    background: var(--ag-charts-toolbar-hover-color);
}

.${$d77b025aa58d633c$var$elements2.button}:disabled {
    background: var(--ag-charts-toolbar-disabled-background-color);
    color: var(--ag-charts-toolbar-disabled-foreground-color);
}

.${$d77b025aa58d633c$var$elements2.button}:not([disabled]) {
    cursor: pointer;
}

.${$d77b025aa58d633c$var$elements2.icon} {
    height: 1.2em;
    width: 1.2em;
}

.${$d77b025aa58d633c$var$elements2.icon} + .${$d77b025aa58d633c$var$elements2.label} {
    margin-left: var(--ag-charts-size);
}

.${$d77b025aa58d633c$var$elements2.icon},
.${$d77b025aa58d633c$var$elements2.label} {
    pointer-events: none;
}

`;
// packages/ag-charts-community/src/chart/toolbar/toolbar.ts
var $d77b025aa58d633c$var$Toolbar = class extends $d77b025aa58d633c$var$BaseModuleInstance {
    constructor(ctx){
        super();
        this.ctx = ctx;
        this.enabled = true;
        this.annotations = new $d77b025aa58d633c$var$ToolbarGroupProperties(this.onGroupChanged.bind(this, "annotations"), this.onGroupButtonsChanged.bind(this, "annotations"));
        this.ranges = new $d77b025aa58d633c$var$ToolbarGroupProperties(this.onGroupChanged.bind(this, "ranges"), this.onGroupButtonsChanged.bind(this, "ranges"));
        this.zoom = new $d77b025aa58d633c$var$ToolbarGroupProperties(this.onGroupChanged.bind(this, "zoom"), this.onGroupButtonsChanged.bind(this, "zoom"));
        this.margin = 10;
        this.floatingDetectionRange = 28;
        this.positions = {
            ["top" /* Top */ ]: /* @__PURE__ */ new Set(),
            ["right" /* Right */ ]: /* @__PURE__ */ new Set(),
            ["bottom" /* Bottom */ ]: /* @__PURE__ */ new Set(),
            ["left" /* Left */ ]: /* @__PURE__ */ new Set(),
            ["floating-top" /* FloatingTop */ ]: /* @__PURE__ */ new Set(),
            ["floating-bottom" /* FloatingBottom */ ]: /* @__PURE__ */ new Set()
        };
        this.positionAlignments = {
            ["top" /* Top */ ]: {},
            ["right" /* Right */ ]: {},
            ["bottom" /* Bottom */ ]: {},
            ["left" /* Left */ ]: {},
            ["floating-top" /* FloatingTop */ ]: {},
            ["floating-bottom" /* FloatingBottom */ ]: {}
        };
        this.groupCallers = {
            annotations: 0,
            ranges: 0,
            zoom: 0
        };
        this.groupButtons = {
            annotations: [],
            ranges: [],
            zoom: []
        };
        this.pendingButtonToggledEvents = [];
        this.groupProxied = /* @__PURE__ */ new Set();
        this.container = ctx.toolbarManager.element;
        this.elements = {
            ["top" /* Top */ ]: this.container.appendChild($d77b025aa58d633c$var$createElement("div")),
            ["right" /* Right */ ]: this.container.appendChild($d77b025aa58d633c$var$createElement("div")),
            ["bottom" /* Bottom */ ]: this.container.appendChild($d77b025aa58d633c$var$createElement("div")),
            ["left" /* Left */ ]: this.container.appendChild($d77b025aa58d633c$var$createElement("div")),
            ["floating-top" /* FloatingTop */ ]: this.container.appendChild($d77b025aa58d633c$var$createElement("div")),
            ["floating-bottom" /* FloatingBottom */ ]: this.container.appendChild($d77b025aa58d633c$var$createElement("div"))
        };
        $d77b025aa58d633c$var$injectStyle($d77b025aa58d633c$var$css2, $d77b025aa58d633c$var$block2);
        this.renderToolbar("top" /* Top */ );
        this.renderToolbar("right" /* Right */ );
        this.renderToolbar("bottom" /* Bottom */ );
        this.renderToolbar("left" /* Left */ );
        this.renderToolbar("floating-top" /* FloatingTop */ );
        this.renderToolbar("floating-bottom" /* FloatingBottom */ );
        this.toggleVisibilities();
        this.destroyFns.push(ctx.interactionManager.addListener("hover", this.onHover.bind(this), 31 /* All */ ), ctx.interactionManager.addListener("leave", this.onLeave.bind(this), 31 /* All */ ), ctx.toolbarManager.addListener("button-toggled", this.onButtonToggled.bind(this)), ctx.toolbarManager.addListener("group-toggled", this.onGroupToggled.bind(this)), ctx.toolbarManager.addListener("proxy-group-options", this.onProxyGroupOptions.bind(this)), ctx.layoutService.addListener("layout-complete", this.onLayoutComplete.bind(this)), ()=>this.destroyElements());
    }
    destroyElements() {
        for (const element2 of Object.values(this.elements))element2.remove();
    }
    onHover(event) {
        const { enabled: enabled, elements: elements3, floatingDetectionRange: floatingDetectionRange, ctx: { scene: scene } } = this;
        const { offsetY: offsetY, sourceEvent: { target: target } } = event;
        const { FloatingBottom: FloatingBottom, FloatingTop: FloatingTop } = $d77b025aa58d633c$var$ToolbarPosition;
        if (!enabled) return;
        const bottom = elements3[FloatingBottom];
        const top = elements3[FloatingTop];
        const bottomDetectionY = bottom.offsetTop - floatingDetectionRange;
        const bottomVisible = offsetY > bottomDetectionY && offsetY < scene.canvas.element.offsetHeight || target === bottom;
        const topDetectionY = top.offsetTop + top.offsetHeight + floatingDetectionRange;
        const topVisible = offsetY > 0 && offsetY < topDetectionY || target === top;
        bottom.classList.toggle($d77b025aa58d633c$var$modifiers2.floatingHidden, !bottomVisible);
        top.classList.toggle($d77b025aa58d633c$var$modifiers2.floatingHidden, !topVisible);
        this.translateFloatingElements(FloatingBottom, bottomVisible);
        this.translateFloatingElements(FloatingTop, topVisible);
    }
    onLeave(event) {
        const { enabled: enabled, elements: elements3, ctx: { scene: scene } } = this;
        const { relatedTarget: relatedTarget, target: target } = event.sourceEvent;
        const { FloatingBottom: FloatingBottom, FloatingTop: FloatingTop } = $d77b025aa58d633c$var$ToolbarPosition;
        if (!enabled || target !== scene.canvas.element) return;
        const isTargetButton = $d77b025aa58d633c$var$TOOLBAR_GROUPS.some((group2)=>this.groupButtons[group2].some((button)=>button === relatedTarget));
        if (isTargetButton) return;
        elements3[FloatingBottom].classList.add($d77b025aa58d633c$var$modifiers2.floatingHidden);
        elements3[FloatingTop].classList.add($d77b025aa58d633c$var$modifiers2.floatingHidden);
        this.translateFloatingElements(FloatingBottom, false);
        this.translateFloatingElements(FloatingTop, false);
    }
    onGroupChanged(group2) {
        if (this[group2] == null || this.groupProxied.has(group2)) return;
        this.createGroup(group2);
        this.toggleVisibilities();
    }
    onGroupButtonsChanged(group2, buttons) {
        if (!this.enabled || this.groupProxied.has(group2)) return;
        this.createGroupButtons(group2, buttons);
        this.toggleVisibilities();
    }
    onLayoutComplete() {
        for (const position of $d77b025aa58d633c$var$TOOLBAR_POSITIONS)this.elements[position].classList.remove($d77b025aa58d633c$var$modifiers2.preventFlash);
    }
    onButtonToggled(event) {
        const { group: group2, value: value, enabled: enabled } = event;
        if (this.groupButtons[group2].length === 0) {
            this.pendingButtonToggledEvents.push(event);
            return;
        }
        for (const button of this.groupButtons[group2]){
            if (button.dataset.toolbarValue !== `${value}`) continue;
            button.disabled = !enabled;
        }
    }
    onGroupToggled(event) {
        const { group: group2, visible: visible } = event;
        this.toggleGroup(group2, visible);
        this.toggleVisibilities();
    }
    onProxyGroupOptions(event) {
        const { group: group2, options: options } = event;
        this.groupProxied.add(group2);
        this.createGroup(group2, options.enabled, options.position);
        this.createGroupButtons(group2, options.buttons);
        this.toggleGroup(group2, options.enabled);
        this[group2].set(options);
    }
    createGroup(group2, enabled, position) {
        enabled != null ? enabled : enabled = this[group2].enabled;
        position != null ? position : position = this[group2].position;
        for (const pos of $d77b025aa58d633c$var$TOOLBAR_POSITIONS)if (enabled && position === pos) this.positions[pos].add(group2);
        else this.positions[pos].delete(group2);
    }
    createGroupButtons(group2, buttons) {
        var _a, _b;
        for (const button of this.groupButtons[group2])button.remove();
        this.groupButtons[group2] = [];
        const align = (_a = this[group2].align) != null ? _a : "start";
        const position = (_b = this[group2].position) != null ? _b : "top";
        const parent = this.positionAlignments[position][align];
        for (const options of buttons != null ? buttons : []){
            const button = this.createButtonElement(group2, options);
            parent == null || parent.appendChild(button);
            this.groupButtons[group2].push(button);
        }
    }
    toggleGroup(group2, enabled) {
        if (enabled) this.groupCallers[group2] += 1;
        else this.groupCallers[group2] = Math.max(0, this.groupCallers[group2] - 1);
    }
    processPendingEvents() {
        var _a;
        const pendingButtonToggledEvents = ((_a = this.pendingButtonToggledEvents) != null ? _a : []).slice();
        for (const event of pendingButtonToggledEvents)this.onButtonToggled(event);
        this.pendingButtonToggledEvents = [];
    }
    performLayout(_0) {
        return $d77b025aa58d633c$var$__async(this, arguments, function*({ shrinkRect: shrinkRect }) {
            const { elements: elements3, margin: margin } = this;
            if (!elements3.top.classList.contains($d77b025aa58d633c$var$modifiers2.hidden)) shrinkRect.shrink(elements3.top.offsetHeight + margin * 2, "top");
            if (!elements3.right.classList.contains($d77b025aa58d633c$var$modifiers2.hidden)) shrinkRect.shrink(elements3.right.offsetWidth + margin, "right");
            if (!elements3.bottom.classList.contains($d77b025aa58d633c$var$modifiers2.hidden)) shrinkRect.shrink(elements3.bottom.offsetHeight + margin * 2, "bottom");
            if (!elements3.left.classList.contains($d77b025aa58d633c$var$modifiers2.hidden)) shrinkRect.shrink(elements3.left.offsetWidth + margin, "left");
            return {
                shrinkRect: shrinkRect
            };
        });
    }
    performCartesianLayout(opts) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            const { elements: elements3, margin: margin } = this;
            const { seriesRect: seriesRect } = opts;
            const { FloatingBottom: FloatingBottom, FloatingTop: FloatingTop } = $d77b025aa58d633c$var$ToolbarPosition;
            elements3.top.style.top = `${seriesRect.y - elements3.top.offsetHeight - margin * 2}px`;
            elements3.top.style.left = `${margin}px`;
            elements3.top.style.width = `calc(100% - ${margin * 2}px)`;
            elements3.right.style.top = `${seriesRect.y + margin}px`;
            elements3.right.style.right = `${margin}px`;
            elements3.right.style.height = `calc(100% - ${seriesRect.y + margin * 2}px)`;
            elements3.bottom.style.bottom = `${margin}px`;
            elements3.bottom.style.left = `${margin}px`;
            elements3.bottom.style.width = `calc(100% - ${margin * 2}px)`;
            elements3.left.style.top = `${seriesRect.y}px`;
            elements3.left.style.left = `${margin}px`;
            elements3.left.style.height = `calc(100% - ${seriesRect.y + margin * 2}px)`;
            elements3[FloatingTop].style.top = `${seriesRect.y}px`;
            elements3[FloatingTop].style.paddingTop = `${margin}px`;
            elements3[FloatingBottom].style.top = `${seriesRect.y + seriesRect.height - elements3[FloatingBottom].offsetHeight}px`;
            elements3[FloatingBottom].style.paddingBottom = `${margin}px`;
        });
    }
    toggleVisibilities() {
        var _a;
        if (this.elements == null) return;
        const isGroupVisible = (group2)=>this[group2].enabled && this.groupCallers[group2] > 0;
        const isButtonVisible = (element2)=>(button)=>typeof button.value !== "string" && typeof button.value !== "number" || `${button.value}` === element2.dataset.toolbarValue;
        for (const position of $d77b025aa58d633c$var$TOOLBAR_POSITIONS){
            const visible = this.enabled && Array.from(this.positions[position].values()).some(isGroupVisible);
            this.elements[position].classList.toggle($d77b025aa58d633c$var$modifiers2.hidden, !visible);
        }
        for (const group2 of $d77b025aa58d633c$var$TOOLBAR_GROUPS){
            if (this[group2] == null) continue;
            const visible = isGroupVisible(group2);
            for (const button of this.groupButtons[group2]){
                const buttonVisible = visible && ((_a = this[group2].buttons) == null ? void 0 : _a.some(isButtonVisible(button)));
                button.classList.toggle($d77b025aa58d633c$var$modifiers2.button.hidden, !buttonVisible);
            }
        }
    }
    translateFloatingElements(position, visible) {
        const { elements: elements3, margin: margin, positionAlignments: positionAlignments } = this;
        const element2 = elements3[position];
        const alignments = Object.values(positionAlignments[position]);
        for (const align of alignments)align.style.transform = visible && align.style.transform !== "" ? "translateY(0)" : `translateY(${element2.offsetHeight + margin}px)`;
    }
    renderToolbar(position = "top" /* Top */ ) {
        const element2 = this.elements[position];
        element2.classList.add($d77b025aa58d633c$var$block2, $d77b025aa58d633c$var$modifiers2[position], $d77b025aa58d633c$var$modifiers2.preventFlash);
        if (position === "floating-top" /* FloatingTop */  || position === "floating-bottom" /* FloatingBottom */ ) element2.classList.add($d77b025aa58d633c$var$modifiers2.floatingHidden);
        for (const align of $d77b025aa58d633c$var$TOOLBAR_ALIGNMENTS){
            const alignmentElement = $d77b025aa58d633c$var$createElement("div");
            alignmentElement.classList.add($d77b025aa58d633c$var$elements2.align, $d77b025aa58d633c$var$modifiers2.align[align]);
            element2.appendChild(alignmentElement);
            this.positionAlignments[position][align] = alignmentElement;
        }
    }
    createButtonElement(group2, options) {
        const button = $d77b025aa58d633c$var$createElement("button");
        button.classList.add($d77b025aa58d633c$var$elements2.button);
        button.dataset.toolbarGroup = group2;
        button.tabIndex = -1;
        if (typeof options.value === "string" || typeof options.value === "number") button.dataset.toolbarValue = `${options.value}`;
        if (options.tooltip) button.title = options.tooltip;
        let inner = "";
        if (options.icon != null) inner = `<span class="ag-charts-icon-${options.icon} ${$d77b025aa58d633c$var$elements2.icon}"></span>`;
        if (options.label != null) inner = `${inner}<span class="${$d77b025aa58d633c$var$elements2.label}">${options.label}</span>`;
        button.innerHTML = inner;
        button.onclick = this.onButtonPress.bind(this, group2, options.value);
        this.destroyFns.push(()=>button.remove());
        return button;
    }
    onButtonPress(group2, value) {
        this.ctx.toolbarManager.pressButton(group2, value);
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ObserveChanges((target)=>{
        target.processPendingEvents();
        target.toggleVisibilities();
    }),
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$BOOLEAN)
], $d77b025aa58d633c$var$Toolbar.prototype, "enabled", 2);
// packages/ag-charts-community/src/chart/toolbar/toolbarModule.ts
var $d77b025aa58d633c$var$DAY = 86400000;
var $d77b025aa58d633c$var$MONTH = $d77b025aa58d633c$var$DAY * 30;
var $d77b025aa58d633c$var$YEAR = $d77b025aa58d633c$var$DAY * 365;
var $d77b025aa58d633c$var$annotations = {
    enabled: false,
    position: "left",
    align: "start",
    buttons: [
        {
            label: "Li",
            value: "line"
        },
        {
            label: "PCh",
            value: "parallel-channel"
        }
    ]
};
var $d77b025aa58d633c$var$ranges = {
    enabled: false,
    position: "top",
    align: "start",
    buttons: [
        {
            label: "1m",
            value: $d77b025aa58d633c$var$MONTH
        },
        {
            label: "3m",
            value: 3 * $d77b025aa58d633c$var$MONTH
        },
        {
            label: "6m",
            value: 6 * $d77b025aa58d633c$var$MONTH
        },
        {
            label: "YTD",
            value: (_start, end)=>[
                    /* @__PURE__ */ new Date(`${new Date(end).getFullYear()}-01-01`).getTime(),
                    end
                ]
        },
        {
            label: "1y",
            value: $d77b025aa58d633c$var$YEAR
        },
        {
            label: "All",
            value: (start, end)=>[
                    start,
                    end
                ]
        }
    ]
};
var $d77b025aa58d633c$var$zoom = {
    enabled: false,
    position: "top",
    align: "end",
    buttons: [
        {
            icon: "zoom-out",
            tooltip: "Zoom out",
            value: "zoom-out"
        },
        {
            icon: "zoom-in",
            tooltip: "Zoom in",
            value: "zoom-in"
        },
        {
            icon: "pan-left",
            tooltip: "Pan left",
            value: "pan-left"
        },
        {
            icon: "pan-right",
            tooltip: "Pan right",
            value: "pan-right"
        },
        {
            icon: "pan-start",
            tooltip: "Pan to the start",
            value: "pan-start"
        },
        {
            icon: "pan-end",
            tooltip: "Pan to the end",
            value: "pan-end"
        },
        {
            icon: "reset",
            tooltip: "Reset the zoom",
            value: "reset"
        }
    ]
};
var $d77b025aa58d633c$var$ToolbarModule = {
    type: "root",
    optionsKey: "toolbar",
    packageType: "community",
    chartTypes: [
        "cartesian"
    ],
    instanceConstructor: $d77b025aa58d633c$var$Toolbar,
    themeTemplate: {
        toolbar: {
            enabled: true,
            annotations: $d77b025aa58d633c$var$annotations,
            ranges: $d77b025aa58d633c$var$ranges,
            zoom: $d77b025aa58d633c$var$zoom
        }
    }
};
// packages/ag-charts-community/src/chart/factory/registerInbuiltModules.ts
function $d77b025aa58d633c$var$registerInbuiltModules() {
    $d77b025aa58d633c$var$moduleRegistry.register($d77b025aa58d633c$var$BackgroundModule, $d77b025aa58d633c$var$CommunityLegendModule, $d77b025aa58d633c$var$NavigatorModule, $d77b025aa58d633c$var$ToolbarModule, $d77b025aa58d633c$var$AreaSeriesModule, $d77b025aa58d633c$var$BarSeriesModule, $d77b025aa58d633c$var$BubbleSeriesModule, $d77b025aa58d633c$var$LineSeriesModule, $d77b025aa58d633c$var$ScatterSeriesModule, $d77b025aa58d633c$var$DonutSeriesModule, $d77b025aa58d633c$var$PieSeriesModule, $d77b025aa58d633c$var$HistogramSeriesModule);
    for (const AxisConstructor of [
        $d77b025aa58d633c$var$NumberAxis,
        $d77b025aa58d633c$var$CategoryAxis,
        $d77b025aa58d633c$var$TimeAxis,
        $d77b025aa58d633c$var$GroupedCategoryAxis,
        $d77b025aa58d633c$var$LogAxis
    ])$d77b025aa58d633c$var$axisRegistry.register(AxisConstructor.type, {
        instanceConstructor: AxisConstructor,
        hidden: AxisConstructor === $d77b025aa58d633c$var$GroupedCategoryAxis
    });
}
// packages/ag-charts-community/src/chart/factory/setupModules.ts
function $d77b025aa58d633c$var$setupModules() {
    for (const m of $d77b025aa58d633c$var$moduleRegistry.modules){
        if (m.packageType === "enterprise" && !$d77b025aa58d633c$var$verifyIfModuleExpected(m)) $d77b025aa58d633c$var$Logger.errorOnce("Unexpected enterprise module registered: " + m.identifier);
        if (m.type === "root" && m.themeTemplate) for (const chartType2 of m.chartTypes)$d77b025aa58d633c$var$chartDefaults.set(chartType2, m.themeTemplate);
        if (m.type === "series") {
            if (m.chartTypes.length > 1) throw new Error(`AG Charts - Module definition error: ${m.identifier}`);
            $d77b025aa58d633c$var$seriesRegistry.register(m.identifier, m);
        }
        if (m.type === "series-option" && m.themeTemplate) for (const seriesType of m.seriesTypes)$d77b025aa58d633c$var$seriesRegistry.setThemeTemplate(seriesType, m.themeTemplate);
        if (m.type === "axis-option" && m.themeTemplate) for (const axisType of m.axisTypes){
            const axisTypeTheme = m.themeTemplate[axisType];
            const theme = $d77b025aa58d633c$var$__spreadValues($d77b025aa58d633c$var$__spreadValues({}, m.themeTemplate), axisTypeTheme);
            for (const innerAxisType of m.axisTypes)delete theme[innerAxisType];
            $d77b025aa58d633c$var$axisRegistry.setThemeTemplate(axisType, theme);
        }
        if (m.type === "axis") $d77b025aa58d633c$var$axisRegistry.register(m.identifier, m);
        if (m.type === "legend") $d77b025aa58d633c$var$legendRegistry.register(m.identifier, m);
    }
    if ($d77b025aa58d633c$var$moduleRegistry.hasEnterpriseModules()) {
        const expectedButUnused = $d77b025aa58d633c$var$getUnusedExpectedModules();
        if (expectedButUnused.length > 0) $d77b025aa58d633c$var$Logger.errorOnce("Enterprise modules expected but not registered: ", expectedButUnused);
    }
}
// packages/ag-charts-community/src/chart/hierarchyChart.ts
var $d77b025aa58d633c$var$_HierarchyChart = class _HierarchyChart extends $d77b025aa58d633c$var$Chart {
    constructor(options, resources){
        super(options, resources);
    }
    performLayout() {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            const shrinkRect = yield $d77b025aa58d633c$var$__superGet(_HierarchyChart.prototype, this, "performLayout").call(this);
            const { seriesArea: { padding: padding }, seriesRoot: seriesRoot, annotationRoot: annotationRoot, highlightRoot: highlightRoot } = this;
            const fullSeriesRect = shrinkRect.clone();
            shrinkRect.shrink(padding.left, "left");
            shrinkRect.shrink(padding.top, "top");
            shrinkRect.shrink(padding.right, "right");
            shrinkRect.shrink(padding.bottom, "bottom");
            this.seriesRect = shrinkRect;
            this.animationRect = shrinkRect;
            this.hoverRect = shrinkRect;
            for (const group2 of [
                seriesRoot,
                annotationRoot,
                highlightRoot
            ]){
                group2.translationX = Math.floor(shrinkRect.x);
                group2.translationY = Math.floor(shrinkRect.y);
            }
            yield Promise.all(this.series.map((series)=>$d77b025aa58d633c$var$__async(this, null, function*() {
                    yield series.update({
                        seriesRect: shrinkRect
                    });
                })));
            seriesRoot.visible = this.series[0].visible;
            seriesRoot.setClipRectInGroupCoordinateSpace(new $d77b025aa58d633c$var$BBox(shrinkRect.x, shrinkRect.y, shrinkRect.width, shrinkRect.height));
            this.ctx.layoutService.dispatchLayoutComplete({
                type: "layout-complete",
                chart: {
                    width: this.ctx.scene.width,
                    height: this.ctx.scene.height
                },
                clipSeries: false,
                series: {
                    rect: fullSeriesRect,
                    paddedRect: shrinkRect,
                    visible: true
                },
                axes: []
            });
            return shrinkRect;
        });
    }
};
$d77b025aa58d633c$var$_HierarchyChart.className = "HierarchyChart";
$d77b025aa58d633c$var$_HierarchyChart.type = "hierarchy";
var $d77b025aa58d633c$var$HierarchyChart = $d77b025aa58d633c$var$_HierarchyChart;
// packages/ag-charts-community/src/chart/axis/polarAxis.ts
var $d77b025aa58d633c$var$PolarAxis = class extends $d77b025aa58d633c$var$Axis {
    constructor(){
        super(...arguments);
        this.shape = "polygon";
        this.innerRadiusRatio = 0;
        this.defaultTickMinSpacing = 20;
    }
    computeLabelsBBox(_options, _seriesRect) {
        return null;
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$UNION([
        "polygon",
        "circle"
    ], "a polar axis shape"))
], $d77b025aa58d633c$var$PolarAxis.prototype, "shape", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$RATIO)
], $d77b025aa58d633c$var$PolarAxis.prototype, "innerRadiusRatio", 2);
// packages/ag-charts-community/src/chart/polarChart.ts
var $d77b025aa58d633c$var$_PolarChart = class _PolarChart extends $d77b025aa58d633c$var$Chart {
    constructor(options, resources){
        super(options, resources);
        this.padding = new $d77b025aa58d633c$var$Padding(40);
        this.axisGroup.zIndex = 6 /* AXIS_FOREGROUND_ZINDEX */ ;
    }
    performLayout() {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            const shrinkRect = yield $d77b025aa58d633c$var$__superGet(_PolarChart.prototype, this, "performLayout").call(this);
            const fullSeriesRect = shrinkRect.clone();
            this.computeSeriesRect(shrinkRect);
            yield this.computeCircle(shrinkRect);
            this.axes.forEach((axis)=>axis.update());
            this.hoverRect = shrinkRect;
            this.ctx.layoutService.dispatchLayoutComplete({
                type: "layout-complete",
                chart: {
                    width: this.ctx.scene.width,
                    height: this.ctx.scene.height
                },
                clipSeries: false,
                series: {
                    rect: fullSeriesRect,
                    paddedRect: shrinkRect,
                    visible: true
                },
                axes: []
            });
            return shrinkRect;
        });
    }
    updateAxes(cx, cy, radius) {
        var _a, _b;
        const angleAxis = this.axes.find((axis)=>axis.direction === "x" /* X */ );
        const radiusAxis = this.axes.find((axis)=>axis.direction === "y" /* Y */ );
        if (!(angleAxis instanceof $d77b025aa58d633c$var$PolarAxis) || !(radiusAxis instanceof $d77b025aa58d633c$var$PolarAxis)) return;
        const angleScale = angleAxis.scale;
        const angles = (_a = angleScale.ticks) == null ? void 0 : _a.call(angleScale).map((value)=>angleScale.convert(value));
        const innerRadiusRatio = radiusAxis.innerRadiusRatio;
        angleAxis.innerRadiusRatio = innerRadiusRatio;
        (_b = angleAxis.computeRange) == null || _b.call(angleAxis);
        angleAxis.gridLength = radius;
        radiusAxis.gridAngles = angles;
        radiusAxis.gridRange = angleAxis.range;
        radiusAxis.range = [
            radius,
            radius * innerRadiusRatio
        ];
        [
            angleAxis,
            radiusAxis
        ].forEach((axis)=>{
            axis.translation.x = cx;
            axis.translation.y = cy;
            axis.calculateLayout();
        });
    }
    computeSeriesRect(shrinkRect) {
        const { seriesArea: { padding: padding } } = this;
        shrinkRect.shrink(padding.left, "left");
        shrinkRect.shrink(padding.top, "top");
        shrinkRect.shrink(padding.right, "right");
        shrinkRect.shrink(padding.bottom, "bottom");
        this.seriesRect = shrinkRect;
        this.animationRect = shrinkRect;
    }
    computeCircle(seriesBox) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            const polarSeries = this.series.filter((series)=>{
                return series instanceof $d77b025aa58d633c$var$PolarSeries;
            });
            const polarAxes = this.axes.filter((axis)=>{
                return axis instanceof $d77b025aa58d633c$var$PolarAxis;
            });
            const setSeriesCircle = (cx, cy, r)=>{
                this.updateAxes(cx, cy, r);
                polarSeries.forEach((series)=>{
                    series.centerX = cx;
                    series.centerY = cy;
                    series.radius = r;
                });
                const pieSeries = polarSeries.filter((s)=>{
                    return s instanceof $d77b025aa58d633c$var$PieSeries || s instanceof $d77b025aa58d633c$var$DonutSeries;
                });
                if (pieSeries.length > 1) {
                    const innerRadii = pieSeries.map((series)=>{
                        const innerRadius = series.getInnerRadius();
                        return {
                            series: series,
                            innerRadius: innerRadius
                        };
                    }).sort((a, b)=>a.innerRadius - b.innerRadius);
                    innerRadii.at(-1).series.surroundingRadius = void 0;
                    for(let i = 0; i < innerRadii.length - 1; i++)innerRadii[i].series.surroundingRadius = innerRadii[i + 1].innerRadius;
                }
            };
            const centerX = seriesBox.x + seriesBox.width / 2;
            const centerY = seriesBox.y + seriesBox.height / 2;
            const initialRadius = Math.max(0, Math.min(seriesBox.width, seriesBox.height) / 2);
            let radius = initialRadius;
            setSeriesCircle(centerX, centerY, radius);
            const shake = (..._0)=>$d77b025aa58d633c$var$__async(this, [
                    ..._0
                ], function*({ hideWhenNecessary: hideWhenNecessary = false } = {}) {
                    const labelBoxes = [];
                    for (const series of [
                        ...polarAxes,
                        ...polarSeries
                    ]){
                        const box = yield series.computeLabelsBBox({
                            hideWhenNecessary: hideWhenNecessary
                        }, seriesBox);
                        if (box) labelBoxes.push(box);
                    }
                    if (labelBoxes.length === 0) {
                        setSeriesCircle(centerX, centerY, initialRadius);
                        return;
                    }
                    const labelBox = $d77b025aa58d633c$var$BBox.merge(labelBoxes);
                    const refined = this.refineCircle(labelBox, radius, seriesBox);
                    setSeriesCircle(refined.centerX, refined.centerY, refined.radius);
                    if (refined.radius === radius) return;
                    radius = refined.radius;
                });
            yield shake();
            yield shake();
            yield shake();
            yield shake({
                hideWhenNecessary: true
            });
            yield shake({
                hideWhenNecessary: true
            });
            return {
                radius: radius,
                centerX: centerX,
                centerY: centerY
            };
        });
    }
    refineCircle(labelsBox, radius, seriesBox) {
        const minCircleRatio = 0.5;
        const circleLeft = -radius;
        const circleTop = -radius;
        const circleRight = radius;
        const circleBottom = radius;
        let padLeft = Math.max(0, circleLeft - labelsBox.x);
        let padTop = Math.max(0, circleTop - labelsBox.y);
        let padRight = Math.max(0, labelsBox.x + labelsBox.width - circleRight);
        let padBottom = Math.max(0, labelsBox.y + labelsBox.height - circleBottom);
        padLeft = padRight = Math.max(padLeft, padRight);
        padTop = padBottom = Math.max(padTop, padBottom);
        const availCircleWidth = seriesBox.width - padLeft - padRight;
        const availCircleHeight = seriesBox.height - padTop - padBottom;
        let newRadius = Math.min(availCircleWidth, availCircleHeight) / 2;
        const minHorizontalRadius = minCircleRatio * seriesBox.width / 2;
        const minVerticalRadius = minCircleRatio * seriesBox.height / 2;
        const minRadius = Math.min(minHorizontalRadius, minVerticalRadius);
        if (newRadius < minRadius) {
            newRadius = minRadius;
            const horizontalPadding = padLeft + padRight;
            const verticalPadding = padTop + padBottom;
            if (2 * newRadius + verticalPadding > seriesBox.height) {
                const padHeight = seriesBox.height - 2 * newRadius;
                if (Math.min(padTop, padBottom) * 2 > padHeight) {
                    padTop = padHeight / 2;
                    padBottom = padHeight / 2;
                } else if (padTop > padBottom) padTop = padHeight - padBottom;
                else padBottom = padHeight - padTop;
            }
            if (2 * newRadius + horizontalPadding > seriesBox.width) {
                const padWidth = seriesBox.width - 2 * newRadius;
                if (Math.min(padLeft, padRight) * 2 > padWidth) {
                    padLeft = padWidth / 2;
                    padRight = padWidth / 2;
                } else if (padLeft > padRight) padLeft = padWidth - padRight;
                else padRight = padWidth - padLeft;
            }
        }
        const newWidth = padLeft + 2 * newRadius + padRight;
        const newHeight = padTop + 2 * newRadius + padBottom;
        return {
            centerX: seriesBox.x + (seriesBox.width - newWidth) / 2 + padLeft + newRadius,
            centerY: seriesBox.y + (seriesBox.height - newHeight) / 2 + padTop + newRadius,
            radius: newRadius
        };
    }
};
$d77b025aa58d633c$var$_PolarChart.className = "PolarChart";
$d77b025aa58d633c$var$_PolarChart.type = "polar";
var $d77b025aa58d633c$var$PolarChart = $d77b025aa58d633c$var$_PolarChart;
// packages/ag-charts-community/src/chart/series/topology/mercatorScale.ts
var $d77b025aa58d633c$var$radsInDeg = Math.PI / 180;
var $d77b025aa58d633c$var$lonX = (lon)=>lon * $d77b025aa58d633c$var$radsInDeg;
var $d77b025aa58d633c$var$latY = (lat)=>-Math.log(Math.tan(Math.PI * 0.25 + lat * $d77b025aa58d633c$var$radsInDeg * 0.5));
var $d77b025aa58d633c$var$xLon = (x)=>x / $d77b025aa58d633c$var$radsInDeg;
var $d77b025aa58d633c$var$yLat = (y)=>(Math.atan(Math.exp(-y)) - Math.PI * 0.25) / ($d77b025aa58d633c$var$radsInDeg * 0.5);
var $d77b025aa58d633c$var$MercatorScale = class _MercatorScale {
    constructor(domain, range3){
        this.domain = domain;
        this.range = range3;
        this.type = "mercator";
        this.bounds = _MercatorScale.bounds(domain);
    }
    static bounds(domain) {
        const [[lon0, lat0], [lon1, lat1]] = domain;
        const x0 = $d77b025aa58d633c$var$lonX(lon0);
        const y0 = $d77b025aa58d633c$var$latY(lat0);
        const x1 = $d77b025aa58d633c$var$lonX(lon1);
        const y1 = $d77b025aa58d633c$var$latY(lat1);
        return new $d77b025aa58d633c$var$BBox(Math.min(x0, x1), Math.min(y0, y1), Math.abs(x1 - x0), Math.abs(y1 - y0));
    }
    static fixedScale() {
        return new _MercatorScale([
            [
                $d77b025aa58d633c$var$xLon(0),
                $d77b025aa58d633c$var$yLat(0)
            ],
            [
                $d77b025aa58d633c$var$xLon(1),
                $d77b025aa58d633c$var$yLat(1)
            ]
        ], [
            [
                0,
                0
            ],
            [
                1,
                1
            ]
        ]);
    }
    convert([lon, lat]) {
        const [[x0, y0], [x1, y1]] = this.range;
        const xScale = (x1 - x0) / this.bounds.width;
        const yScale = (y1 - y0) / this.bounds.height;
        return [
            ($d77b025aa58d633c$var$lonX(lon) - this.bounds.x) * xScale + x0,
            ($d77b025aa58d633c$var$latY(lat) - this.bounds.y) * yScale + y0
        ];
    }
    invert([x, y]) {
        const [[x0, y0], [x1, y1]] = this.range;
        const xScale = (x1 - x0) / this.bounds.width;
        const yScale = (y1 - y0) / this.bounds.height;
        return [
            $d77b025aa58d633c$var$xLon((x - x0) / xScale + this.bounds.x),
            $d77b025aa58d633c$var$yLat((y - y0) / yScale + this.bounds.y)
        ];
    }
};
// packages/ag-charts-community/src/chart/topologyChart.ts
function $d77b025aa58d633c$var$isTopologySeries(series) {
    return series.type === "map-shape" || series.type === "map-line" || series.type === "map-marker" || series.type === "map-shape-background" || series.type === "map-line-background";
}
var $d77b025aa58d633c$var$_TopologyChart = class _TopologyChart extends $d77b025aa58d633c$var$Chart {
    constructor(options, resources){
        super(options, resources);
        this.xAxis = new $d77b025aa58d633c$var$NumberAxis(this.getModuleContext());
        this.xAxis.position = "bottom";
        this.yAxis = new $d77b025aa58d633c$var$NumberAxis(this.getModuleContext());
        this.yAxis.position = "left";
        this.ctx.zoomManager.updateAxes([
            this.xAxis,
            this.yAxis
        ]);
    }
    updateData() {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            yield $d77b025aa58d633c$var$__superGet(_TopologyChart.prototype, this, "updateData").call(this);
            const { topology: topology } = this.getOptions();
            this.series.forEach((series)=>{
                if ($d77b025aa58d633c$var$isTopologySeries(series)) series.setChartTopology(topology);
            });
        });
    }
    performLayout() {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            const shrinkRect = yield $d77b025aa58d633c$var$__superGet(_TopologyChart.prototype, this, "performLayout").call(this);
            const { seriesArea: { padding: padding }, seriesRoot: seriesRoot, annotationRoot: annotationRoot, highlightRoot: highlightRoot } = this;
            const fullSeriesRect = shrinkRect.clone();
            shrinkRect.shrink(padding.left, "left");
            shrinkRect.shrink(padding.top, "top");
            shrinkRect.shrink(padding.right, "right");
            shrinkRect.shrink(padding.bottom, "bottom");
            this.seriesRect = shrinkRect;
            this.animationRect = shrinkRect;
            this.hoverRect = shrinkRect;
            const mapSeries = this.series.filter($d77b025aa58d633c$var$isTopologySeries);
            const combinedBbox = mapSeries.reduce((combined, series)=>{
                if (!series.visible) return combined;
                const bbox = series.topologyBounds;
                if (bbox == null) return combined;
                if (combined == null) return bbox;
                combined.merge(bbox);
                return combined;
            }, void 0);
            let scale2;
            if (combinedBbox != null) {
                const { lon0: lon0, lat0: lat0, lon1: lon1, lat1: lat1 } = combinedBbox;
                const domain = [
                    [
                        lon0,
                        lat0
                    ],
                    [
                        lon1,
                        lat1
                    ]
                ];
                const bounds = $d77b025aa58d633c$var$MercatorScale.bounds(domain);
                const { width: width, height: height } = shrinkRect;
                const viewBoxScale = Math.min(width / bounds.width, height / bounds.height);
                const viewBoxWidth = bounds.width * viewBoxScale;
                const viewBoxHeight = bounds.height * viewBoxScale;
                const viewBoxOriginX = (width - viewBoxWidth) / 2;
                const viewBoxOriginY = (height - viewBoxHeight) / 2;
                const x0 = viewBoxOriginX;
                const y0 = viewBoxOriginY;
                const x1 = viewBoxOriginX + viewBoxWidth;
                const y1 = viewBoxOriginY + viewBoxHeight;
                const xZoom = this.ctx.zoomManager.getAxisZoom(this.xAxis.id);
                const yZoom = this.ctx.zoomManager.getAxisZoom(this.yAxis.id);
                const xSpan = (x1 - x0) / (xZoom.max - xZoom.min);
                const xStart = x0 - xSpan * xZoom.min;
                const ySpan = (y1 - y0) / (1 - yZoom.min - (1 - yZoom.max));
                const yStart = y0 - ySpan * (1 - yZoom.max);
                scale2 = new $d77b025aa58d633c$var$MercatorScale(domain, [
                    [
                        xStart,
                        yStart
                    ],
                    [
                        xStart + xSpan,
                        yStart + ySpan
                    ]
                ]);
            }
            mapSeries.forEach((series)=>{
                series.scale = scale2;
            });
            const seriesVisible = this.series.some((s)=>s.visible);
            seriesRoot.visible = seriesVisible;
            for (const group2 of [
                seriesRoot,
                annotationRoot,
                highlightRoot
            ]){
                group2.translationX = Math.floor(shrinkRect.x);
                group2.translationY = Math.floor(shrinkRect.y);
                group2.setClipRectInGroupCoordinateSpace(new $d77b025aa58d633c$var$BBox(shrinkRect.x, shrinkRect.y, shrinkRect.width, shrinkRect.height));
            }
            this.ctx.layoutService.dispatchLayoutComplete({
                type: "layout-complete",
                chart: {
                    width: this.ctx.scene.width,
                    height: this.ctx.scene.height
                },
                clipSeries: false,
                series: {
                    rect: fullSeriesRect,
                    paddedRect: shrinkRect,
                    visible: seriesVisible
                },
                axes: []
            });
            return shrinkRect;
        });
    }
};
$d77b025aa58d633c$var$_TopologyChart.className = "TopologyChart";
$d77b025aa58d633c$var$_TopologyChart.type = "topology";
var $d77b025aa58d633c$var$TopologyChart = $d77b025aa58d633c$var$_TopologyChart;
// packages/ag-charts-community/src/chart/agChartV2.ts
var $d77b025aa58d633c$var$debug2 = $d77b025aa58d633c$var$Debug.create(true, "opts");
function $d77b025aa58d633c$var$chartType(options) {
    if ($d77b025aa58d633c$var$isAgCartesianChartOptions(options)) return "cartesian";
    else if ($d77b025aa58d633c$var$isAgPolarChartOptions(options)) return "polar";
    else if ($d77b025aa58d633c$var$isAgHierarchyChartOptions(options)) return "hierarchy";
    else if ($d77b025aa58d633c$var$isAgTopologyChartOptions(options)) return "topology";
    throw new Error(`AG Chart - unknown type of chart for options with type: ${options.type}`);
}
var $d77b025aa58d633c$var$_AgCharts = class _AgCharts {
    static licenseCheck(options) {
        var _a, _b, _c, _d;
        if (this.licenseChecked) return;
        this.licenseManager = (_b = (_a = $d77b025aa58d633c$var$enterpriseModule).licenseManager) == null ? void 0 : _b.call(_a, options);
        (_c = this.licenseManager) == null || _c.setLicenseKey(this.licenseKey, this.gridContext);
        (_d = this.licenseManager) == null || _d.validateLicense();
        this.licenseChecked = true;
    }
    static setLicenseKey(licenseKey) {
        this.licenseKey = licenseKey;
    }
    static setGridContext(gridContext) {
        this.gridContext = gridContext;
    }
    static getLicenseDetails(licenseKey) {
        var _a, _b;
        return (_b = (_a = $d77b025aa58d633c$var$enterpriseModule).licenseManager) == null ? void 0 : _b.call(_a, {}).getLicenseDetails(licenseKey);
    }
    /**
   * Returns the `AgChartInstance` for a DOM node, if there is one.
   */ static getInstance(element2) {
        return $d77b025aa58d633c$var$AgChartsInternal.getInstance(element2);
    }
    /**
   * Create a new `AgChartInstance` based upon the given configuration options.
   */ static create(options) {
        var _a, _b, _c;
        this.licenseCheck(options);
        const chart = $d77b025aa58d633c$var$AgChartsInternal.createOrUpdate(options);
        if ((_a = this.licenseManager) == null ? void 0 : _a.isDisplayWatermark()) (_c = (_b = $d77b025aa58d633c$var$enterpriseModule).injectWatermark) == null || _c.call(_b, chart.chart.element, this.licenseManager.getWatermarkMessage());
        return chart;
    }
    /**
   * Update an existing `AgChartInstance`. Options provided should be complete and not
   * partial.
   *
   * __NOTE__: As each call could trigger a chart redraw, multiple calls to update options in
   * quick succession could result in undesirable flickering, so callers should batch up and/or
   * debounce changes to avoid unintended partial update renderings.
   */ static update(chart, options) {
        if (!$d77b025aa58d633c$var$AgChartInstanceProxy.isInstance(chart)) throw new Error(_AgCharts.INVALID_CHART_REF_MESSAGE);
        $d77b025aa58d633c$var$AgChartsInternal.createOrUpdate(options, chart);
    }
    /**
   * Update an existing `AgChartInstance` by applying a partial set of option changes.
   *
   * __NOTE__: As each call could trigger a chart redraw, each individual delta options update
   * should leave the chart in a valid options state. Also, multiple calls to update options in
   * quick succession could result in undesirable flickering, so callers should batch up and/or
   * debounce changes to avoid unintended partial update renderings.
   */ static updateDelta(chart, deltaOptions) {
        if (!$d77b025aa58d633c$var$AgChartInstanceProxy.isInstance(chart)) throw new Error(_AgCharts.INVALID_CHART_REF_MESSAGE);
        $d77b025aa58d633c$var$AgChartsInternal.updateUserDelta(chart, deltaOptions);
    }
    /**
   * Starts a browser-based image download for the given `AgChartInstance`.
   */ static download(chart, options) {
        if (!(chart instanceof $d77b025aa58d633c$var$AgChartInstanceProxy)) throw new Error(_AgCharts.INVALID_CHART_REF_MESSAGE);
        $d77b025aa58d633c$var$AgChartsInternal.download(chart, options).catch((e)=>$d77b025aa58d633c$var$Logger.errorOnce(e));
    }
    /**
   * Returns a base64-encoded image data URL for the given `AgChartInstance`.
   */ static getImageDataURL(chart, options) {
        if (!(chart instanceof $d77b025aa58d633c$var$AgChartInstanceProxy)) throw new Error(_AgCharts.INVALID_CHART_REF_MESSAGE);
        return $d77b025aa58d633c$var$AgChartsInternal.getImageDataURL(chart, options);
    }
};
$d77b025aa58d633c$var$_AgCharts.INVALID_CHART_REF_MESSAGE = "AG Charts - invalid chart reference passed";
$d77b025aa58d633c$var$_AgCharts.licenseChecked = false;
$d77b025aa58d633c$var$_AgCharts.gridContext = false;
var $d77b025aa58d633c$export$e93fe4969a168dc7 = $d77b025aa58d633c$var$_AgCharts;
var $d77b025aa58d633c$export$5f62ab335cae0d0b = class {
    static warnDeprecated(memberName) {
        const warnDeprecated = $d77b025aa58d633c$var$createDeprecationWarning();
        warnDeprecated(`AgChart.${memberName}`, `Use AgCharts.${memberName} instead`);
    }
    static create(options) {
        this.warnDeprecated("create");
        return $d77b025aa58d633c$export$e93fe4969a168dc7.create(options);
    }
    static update(chart, options) {
        this.warnDeprecated("update");
        return $d77b025aa58d633c$export$e93fe4969a168dc7.update(chart, options);
    }
    static updateDelta(chart, deltaOptions) {
        this.warnDeprecated("updateDelta");
        return $d77b025aa58d633c$export$e93fe4969a168dc7.updateDelta(chart, deltaOptions);
    }
    static download(chart, options) {
        this.warnDeprecated("download");
        return $d77b025aa58d633c$export$e93fe4969a168dc7.download(chart, options);
    }
    static getImageDataURL(chart, options) {
        this.warnDeprecated("getImageDataURL");
        return $d77b025aa58d633c$export$e93fe4969a168dc7.getImageDataURL(chart, options);
    }
};
var $d77b025aa58d633c$var$_AgChartsInternal = class _AgChartsInternal {
    static getInstance(element2) {
        const chart = $d77b025aa58d633c$var$Chart.getInstance(element2);
        return chart ? $d77b025aa58d633c$var$AgChartInstanceProxy.chartInstances.get(chart) : void 0;
    }
    static initialiseModules() {
        if (_AgChartsInternal.initialised) return;
        $d77b025aa58d633c$var$registerInbuiltModules();
        $d77b025aa58d633c$var$setupModules();
        _AgChartsInternal.initialised = true;
    }
    static createOrUpdate(options, proxy) {
        var _b;
        _AgChartsInternal.initialiseModules();
        $d77b025aa58d633c$var$debug2(">>> AgChartV2.createOrUpdate() user options", options);
        const _a = options, { overrideDevicePixelRatio: overrideDevicePixelRatio, document: document2, window: userWindow } = _a, userOptions = $d77b025aa58d633c$var$__objRest(_a, [
            "overrideDevicePixelRatio",
            "document",
            "window"
        ]);
        const chartOptions = new $d77b025aa58d633c$var$ChartOptions(userOptions, {
            overrideDevicePixelRatio: overrideDevicePixelRatio,
            document: document2,
            window: userWindow
        });
        let chart = proxy == null ? void 0 : proxy.chart;
        if (chart == null || $d77b025aa58d633c$var$chartType(userOptions) !== $d77b025aa58d633c$var$chartType(chart.processedOptions)) chart = _AgChartsInternal.createChartInstance(chartOptions, chart);
        if (proxy == null) proxy = new $d77b025aa58d633c$var$AgChartInstanceProxy(chart);
        else proxy.chart = chart;
        if ($d77b025aa58d633c$var$debug2.check() && typeof window !== "undefined") {
            (_b = window.agChartInstances) != null ? _b : window.agChartInstances = {};
            window.agChartInstances[chart.id] = chart;
        }
        chart.queuedUserOptions.push(userOptions);
        chart.requestFactoryUpdate((chartRef)=>{
            chartRef.applyOptions(chartOptions);
            chartRef.queuedUserOptions.splice(0, chartRef.queuedUserOptions.indexOf(userOptions));
        });
        return proxy;
    }
    static updateUserDelta(proxy, deltaOptions) {
        deltaOptions = $d77b025aa58d633c$var$deepClone(deltaOptions, {
            shallow: [
                "data"
            ]
        });
        $d77b025aa58d633c$var$jsonWalk(deltaOptions, (node)=>{
            if (typeof node !== "object") return;
            for (const [key, value] of Object.entries(node))if (typeof value === "undefined") Object.assign(node, {
                [key]: Symbol("UNSET")
            });
        }, {
            skip: [
                "data"
            ]
        });
        const { chart: chart } = proxy;
        const lastUpdateOptions = chart.getOptions();
        const userOptions = $d77b025aa58d633c$var$mergeDefaults(deltaOptions, lastUpdateOptions);
        $d77b025aa58d633c$var$debug2(">>> AgChartV2.updateUserDelta() user delta", deltaOptions);
        $d77b025aa58d633c$var$debug2("AgChartV2.updateUserDelta() - base options", lastUpdateOptions);
        _AgChartsInternal.createOrUpdate(userOptions, proxy);
    }
    /**
   * Returns the content of the current canvas as an image.
   */ static download(proxy, opts) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            try {
                const clone = yield _AgChartsInternal.prepareResizedChart(proxy, opts);
                clone.chart.ctx.scene.download(opts == null ? void 0 : opts.fileName, opts == null ? void 0 : opts.fileFormat);
                clone.destroy();
            } catch (error) {
                $d77b025aa58d633c$var$Logger.errorOnce(error);
            }
        });
    }
    static getImageDataURL(proxy, opts) {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            const clone = yield _AgChartsInternal.prepareResizedChart(proxy, opts);
            const result = clone.chart.ctx.scene.getDataURL(opts == null ? void 0 : opts.fileFormat);
            clone.destroy();
            return result;
        });
    }
    static prepareResizedChart(_0) {
        return $d77b025aa58d633c$var$__async(this, arguments, function*({ chart: chart }, opts = {}) {
            var _a, _b, _c, _d;
            const width = (_b = (_a = opts.width) != null ? _a : chart.width) != null ? _b : chart.ctx.scene.canvas.width;
            const height = (_d = (_c = opts.height) != null ? _c : chart.height) != null ? _d : chart.ctx.scene.canvas.height;
            const options = $d77b025aa58d633c$var$mergeDefaults({
                container: document.createElement("div"),
                overrideDevicePixelRatio: 1,
                autoSize: false,
                width: width,
                height: height
            }, // Disable enterprise features that may interfere with image generation.
            $d77b025aa58d633c$var$moduleRegistry.hasEnterpriseModules() && {
                animation: {
                    enabled: false
                }
            }, chart.userOptions);
            const cloneProxy = _AgChartsInternal.createOrUpdate(options);
            cloneProxy.chart.ctx.zoomManager.updateZoom("agChartV2", chart.ctx.zoomManager.getZoom());
            chart.series.forEach((series, index)=>{
                if (!series.visible) cloneProxy.chart.series[index].visible = false;
            });
            chart.update(0 /* FULL */ , {
                forceNodeDataRefresh: true
            });
            yield cloneProxy.chart.waitForUpdate();
            return cloneProxy;
        });
    }
    static createChartInstance(options, oldChart) {
        const transferableResource = oldChart == null ? void 0 : oldChart.destroy({
            keepTransferableResources: true
        });
        const ChartConstructor = _AgChartsInternal.getChartByOptions(options.processedOptions);
        return new ChartConstructor(options, transferableResource);
    }
    static getChartByOptions(options) {
        if ($d77b025aa58d633c$var$isAgCartesianChartOptions(options)) return $d77b025aa58d633c$var$CartesianChart;
        else if ($d77b025aa58d633c$var$isAgHierarchyChartOptions(options)) return $d77b025aa58d633c$var$HierarchyChart;
        else if ($d77b025aa58d633c$var$isAgPolarChartOptions(options)) return $d77b025aa58d633c$var$PolarChart;
        else if ($d77b025aa58d633c$var$isAgTopologyChartOptions(options)) return $d77b025aa58d633c$var$TopologyChart;
        throw new Error(`AG Charts - couldn't apply configuration, check options are correctly structured and series types are specified`);
    }
};
$d77b025aa58d633c$var$_AgChartsInternal.initialised = false;
var $d77b025aa58d633c$var$AgChartsInternal = $d77b025aa58d633c$var$_AgChartsInternal;
// packages/ag-charts-community/src/version.ts
var $d77b025aa58d633c$export$a4ad2735b021c132 = "9.3.2";
// packages/ag-charts-community/src/integrated-charts-scene.ts
var $d77b025aa58d633c$export$f88ced8f90c5ae15 = {};
$d77b025aa58d633c$var$__export($d77b025aa58d633c$export$f88ced8f90c5ae15, {
    Arc: ()=>$d77b025aa58d633c$var$Arc2,
    BBox: ()=>$d77b025aa58d633c$var$BBox,
    BandScale: ()=>$d77b025aa58d633c$var$BandScale,
    Caption: ()=>$d77b025aa58d633c$var$Caption,
    ChangeDetectableProperties: ()=>$d77b025aa58d633c$var$ChangeDetectableProperties,
    Circle: ()=>$d77b025aa58d633c$var$Circle,
    ContinuousScale: ()=>$d77b025aa58d633c$var$ContinuousScale,
    Diamond: ()=>$d77b025aa58d633c$var$Diamond,
    DropShadow: ()=>$d77b025aa58d633c$var$DropShadow,
    ExtendedPath2D: ()=>$d77b025aa58d633c$var$ExtendedPath2D,
    Group: ()=>$d77b025aa58d633c$var$Group,
    HdpiCanvas: ()=>$d77b025aa58d633c$var$HdpiCanvas,
    Image: ()=>$d77b025aa58d633c$var$Image,
    Label: ()=>$d77b025aa58d633c$var$Label,
    Line: ()=>$d77b025aa58d633c$var$Line,
    LinearGradientFill: ()=>$d77b025aa58d633c$var$LinearGradientFill,
    LinearScale: ()=>$d77b025aa58d633c$var$LinearScale,
    Marker: ()=>$d77b025aa58d633c$export$e98856a975cab58e,
    Node: ()=>$d77b025aa58d633c$var$Node,
    OrdinalTimeScale: ()=>$d77b025aa58d633c$var$OrdinalTimeScale,
    Path: ()=>$d77b025aa58d633c$var$Path,
    PointerEvents: ()=>$d77b025aa58d633c$var$PointerEvents,
    RadialColumnShape: ()=>$d77b025aa58d633c$var$RadialColumnShape,
    Rect: ()=>$d77b025aa58d633c$var$Rect,
    RedrawType: ()=>$d77b025aa58d633c$var$RedrawType,
    Scene: ()=>$d77b025aa58d633c$var$Scene,
    SceneChangeDetection: ()=>$d77b025aa58d633c$var$SceneChangeDetection,
    ScenePathChangeDetection: ()=>$d77b025aa58d633c$var$ScenePathChangeDetection,
    Sector: ()=>$d77b025aa58d633c$var$Sector,
    SectorBox: ()=>$d77b025aa58d633c$var$SectorBox,
    Selection: ()=>$d77b025aa58d633c$var$Selection,
    Shape: ()=>$d77b025aa58d633c$var$Shape,
    Square: ()=>$d77b025aa58d633c$var$Square,
    Text: ()=>$d77b025aa58d633c$var$Text,
    Tooltip: ()=>$d77b025aa58d633c$var$Tooltip,
    Triangle: ()=>$d77b025aa58d633c$var$Triangle,
    easing: ()=>$d77b025aa58d633c$var$easing_exports,
    getFont: ()=>$d77b025aa58d633c$var$getFont,
    getMarker: ()=>$d77b025aa58d633c$var$getMarker,
    getRadialColumnWidth: ()=>$d77b025aa58d633c$var$getRadialColumnWidth,
    motion: ()=>$d77b025aa58d633c$var$motion,
    nearestSquared: ()=>$d77b025aa58d633c$var$nearestSquared,
    nearestSquaredInContainer: ()=>$d77b025aa58d633c$var$nearestSquaredInContainer,
    toRadians: ()=>$d77b025aa58d633c$var$toRadians,
    toTooltipHtml: ()=>$d77b025aa58d633c$var$toTooltipHtml
});
// packages/ag-charts-community/src/scene/shape/arc.ts
var $d77b025aa58d633c$var$Arc2 = class extends $d77b025aa58d633c$var$Path {
    constructor(){
        super();
        this.centerX = 0;
        this.centerY = 0;
        this.radius = 10;
        this.startAngle = 0;
        this.endAngle = Math.PI * 2;
        this.counterClockwise = false;
        this.type = 0 /* Open */ ;
        this.restoreOwnStyles();
    }
    get fullPie() {
        return $d77b025aa58d633c$var$isEqual($d77b025aa58d633c$var$normalizeAngle360(this.startAngle), $d77b025aa58d633c$var$normalizeAngle360(this.endAngle));
    }
    updatePath() {
        const path = this.path;
        path.clear();
        path.arc(this.centerX, this.centerY, this.radius, this.startAngle, this.endAngle, this.counterClockwise);
        if (this.type === 1 /* Chord */ ) path.closePath();
        else if (this.type === 2 /* Round */  && !this.fullPie) {
            path.lineTo(this.centerX, this.centerY);
            path.closePath();
        }
    }
    computeBBox() {
        return new $d77b025aa58d633c$var$BBox(this.centerX - this.radius, this.centerY - this.radius, this.radius * 2, this.radius * 2);
    }
    isPointInPath(x, y) {
        const point = this.transformPoint(x, y);
        const bbox = this.computeBBox();
        return this.type !== 0 /* Open */  && bbox.containsPoint(point.x, point.y) && this.path.isPointInPath(point.x, point.y);
    }
};
$d77b025aa58d633c$var$Arc2.className = "Arc";
$d77b025aa58d633c$var$Arc2.defaultStyles = Object.assign({}, $d77b025aa58d633c$var$Shape.defaultStyles, {
    lineWidth: 1,
    fillStyle: null
});
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ScenePathChangeDetection()
], $d77b025aa58d633c$var$Arc2.prototype, "centerX", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ScenePathChangeDetection()
], $d77b025aa58d633c$var$Arc2.prototype, "centerY", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ScenePathChangeDetection()
], $d77b025aa58d633c$var$Arc2.prototype, "radius", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ScenePathChangeDetection()
], $d77b025aa58d633c$var$Arc2.prototype, "startAngle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ScenePathChangeDetection()
], $d77b025aa58d633c$var$Arc2.prototype, "endAngle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ScenePathChangeDetection()
], $d77b025aa58d633c$var$Arc2.prototype, "counterClockwise", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ScenePathChangeDetection()
], $d77b025aa58d633c$var$Arc2.prototype, "type", 2);
// packages/ag-charts-community/src/scene/shape/linearGradientFill.ts
var $d77b025aa58d633c$var$LinearGradientFill = class extends $d77b025aa58d633c$var$Shape {
    constructor(){
        super(...arguments);
        this.direction = "to-right";
        this.stops = void 0;
        this._mask = void 0;
    }
    get mask() {
        return this._mask;
    }
    set mask(newMask) {
        if (this._mask != null) this.removeChild(this._mask);
        if (newMask != null) this.appendChild(newMask);
        this._mask = newMask;
    }
    isPointInPath(x, y) {
        var _a, _b;
        return (_b = (_a = this.mask) == null ? void 0 : _a.isPointInPath(x, y)) != null ? _b : false;
    }
    computeBBox() {
        var _a;
        return (_a = this.mask) == null ? void 0 : _a.computeBBox();
    }
    render(renderCtx) {
        const { mask: mask, stops: stops } = this;
        const { ctx: ctx, devicePixelRatio: devicePixelRatio } = renderCtx;
        const pixelLength = 1 / devicePixelRatio;
        const maskBbox = mask == null ? void 0 : mask.computeTransformedBBox();
        if (mask == null || stops == null || maskBbox == null) return;
        if (mask.dirtyPath) {
            mask.updatePath();
            mask.dirtyPath = false;
        }
        ctx.save();
        ctx.clip(mask.path.getPath2D());
        ctx.setTransform(devicePixelRatio, 0, 0, devicePixelRatio, 0, 0);
        const x0 = Math.floor(maskBbox.x);
        const x1 = Math.ceil(maskBbox.x + maskBbox.width);
        const y0 = Math.floor(maskBbox.y);
        const y1 = Math.ceil(maskBbox.y + maskBbox.height);
        const colorScale = new $d77b025aa58d633c$var$ColorScale();
        const [i0, i1] = this.direction === "to-right" ? [
            x0,
            x1
        ] : [
            y0,
            y1
        ];
        colorScale.domain = stops.map((_, index)=>{
            return i0 + (i1 - i0) * index / (stops.length - 1);
        });
        colorScale.range = stops;
        colorScale.update();
        if (this.direction === "to-right") {
            const height = y1 - y0;
            for(let x = x0; x <= x1; x += pixelLength){
                ctx.fillStyle = colorScale.convert(x);
                ctx.fillRect(x, y0, pixelLength, height);
            }
        } else {
            const width = x1 - x0;
            for(let y = y0; y <= y1; y += pixelLength){
                ctx.fillStyle = colorScale.convert(y);
                ctx.fillRect(x0, y, width, pixelLength);
            }
        }
        ctx.restore();
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 3 /* MAJOR */ 
    })
], $d77b025aa58d633c$var$LinearGradientFill.prototype, "direction", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 3 /* MAJOR */ 
    })
], $d77b025aa58d633c$var$LinearGradientFill.prototype, "stops", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 3 /* MAJOR */ 
    })
], $d77b025aa58d633c$var$LinearGradientFill.prototype, "_mask", 2);
// packages/ag-charts-community/src/scene/shape/radialColumnShape.ts
function $d77b025aa58d633c$var$rotatePoint(x, y, rotation) {
    const radius = Math.sqrt($d77b025aa58d633c$var$__pow(x, 2) + $d77b025aa58d633c$var$__pow(y, 2));
    const angle = Math.atan2(y, x);
    const rotated = angle + rotation;
    return {
        x: Math.cos(rotated) * radius,
        y: Math.sin(rotated) * radius
    };
}
var $d77b025aa58d633c$var$RadialColumnShape = class extends $d77b025aa58d633c$var$Path {
    constructor(){
        super(...arguments);
        this.borderPath = new $d77b025aa58d633c$var$ExtendedPath2D();
        this.isBeveled = true;
        this.columnWidth = 0;
        this.startAngle = 0;
        this.endAngle = 0;
        this.outerRadius = 0;
        this.innerRadius = 0;
        this.axisInnerRadius = 0;
        this.axisOuterRadius = 0;
        this.isRadiusAxisReversed = false;
    }
    getRotation() {
        const { startAngle: startAngle, endAngle: endAngle } = this;
        const midAngle = $d77b025aa58d633c$var$angleBetween(startAngle, endAngle);
        return $d77b025aa58d633c$var$normalizeAngle360(startAngle + midAngle / 2 + Math.PI / 2);
    }
    updatePath() {
        const { isBeveled: isBeveled } = this;
        if (isBeveled) this.updateBeveledPath();
        else this.updateRectangularPath();
        this.checkPathDirty();
    }
    updateRectangularPath() {
        const { columnWidth: columnWidth, innerRadius: innerRadius, outerRadius: outerRadius, path: path } = this;
        const left = -columnWidth / 2;
        const right = columnWidth / 2;
        const top = -outerRadius;
        const bottom = -innerRadius;
        const rotation = this.getRotation();
        const points = [
            [
                left,
                bottom
            ],
            [
                left,
                top
            ],
            [
                right,
                top
            ],
            [
                right,
                bottom
            ],
            [
                left,
                bottom
            ]
        ].map(([x, y])=>$d77b025aa58d633c$var$rotatePoint(x, y, rotation));
        path.clear(true);
        path.moveTo(points[0].x, points[0].y);
        path.lineTo(points[1].x, points[1].y);
        path.lineTo(points[2].x, points[2].y);
        path.lineTo(points[3].x, points[3].y);
        path.lineTo(points[0].x, points[0].y);
        path.closePath();
    }
    updateBeveledPath() {
        const { columnWidth: columnWidth, path: path, outerRadius: outerRadius, innerRadius: innerRadius, axisInnerRadius: axisInnerRadius, axisOuterRadius: axisOuterRadius, isRadiusAxisReversed: isRadiusAxisReversed } = this;
        const isStackBottom = $d77b025aa58d633c$var$isEqual(innerRadius, axisInnerRadius);
        const sideRotation = Math.asin(columnWidth / 2 / innerRadius);
        const pointRotation = this.getRotation();
        const rotate = (x, y)=>$d77b025aa58d633c$var$rotatePoint(x, y, pointRotation);
        const getTriangleHypotenuse = (leg, otherLeg)=>Math.sqrt($d77b025aa58d633c$var$__pow(leg, 2) + $d77b025aa58d633c$var$__pow(otherLeg, 2));
        const getTriangleLeg = (hypotenuse, otherLeg)=>{
            if (otherLeg > hypotenuse) return 0;
            return Math.sqrt($d77b025aa58d633c$var$__pow(hypotenuse, 2) - $d77b025aa58d633c$var$__pow(otherLeg, 2));
        };
        const compare = (value, otherValue, lessThan)=>lessThan ? value < otherValue : value > otherValue;
        const shouldConnectBottomCircle = isStackBottom && !isNaN(sideRotation) && sideRotation < Math.PI / 6;
        let left = -columnWidth / 2;
        let right = columnWidth / 2;
        const top = -outerRadius;
        const bottom = -innerRadius * (shouldConnectBottomCircle ? Math.cos(sideRotation) : 1);
        const hasBottomIntersection = compare(axisOuterRadius, getTriangleHypotenuse(innerRadius, columnWidth / 2), !isRadiusAxisReversed);
        if (hasBottomIntersection) {
            const bottomIntersectionX = getTriangleLeg(axisOuterRadius, innerRadius);
            left = -bottomIntersectionX;
            right = bottomIntersectionX;
        }
        path.clear(true);
        const bottomLeftPt = rotate(left, bottom);
        path.moveTo(bottomLeftPt.x, bottomLeftPt.y);
        const isEmpty = $d77b025aa58d633c$var$isEqual(innerRadius, outerRadius);
        const hasSideIntersection = compare(axisOuterRadius, getTriangleHypotenuse(outerRadius, columnWidth / 2), !isRadiusAxisReversed);
        if (isEmpty && shouldConnectBottomCircle) path.arc(0, 0, innerRadius, $d77b025aa58d633c$var$normalizeAngle360(-sideRotation - Math.PI / 2) + pointRotation, $d77b025aa58d633c$var$normalizeAngle360(sideRotation - Math.PI / 2) + pointRotation, false);
        else if (hasSideIntersection) {
            const sideIntersectionY = -getTriangleLeg(axisOuterRadius, columnWidth / 2);
            const topIntersectionX = getTriangleLeg(axisOuterRadius, outerRadius);
            if (!hasBottomIntersection) {
                const topLeftPt = rotate(left, sideIntersectionY);
                path.lineTo(topLeftPt.x, topLeftPt.y);
            }
            path.arc(0, 0, axisOuterRadius, Math.atan2(sideIntersectionY, left) + pointRotation, Math.atan2(top, -topIntersectionX) + pointRotation, false);
            if (!$d77b025aa58d633c$var$isEqual(topIntersectionX, 0)) {
                const topRightBevelPt = rotate(topIntersectionX, top);
                path.lineTo(topRightBevelPt.x, topRightBevelPt.y);
            }
            path.arc(0, 0, axisOuterRadius, Math.atan2(top, topIntersectionX) + pointRotation, Math.atan2(sideIntersectionY, right) + pointRotation, false);
        } else {
            const topLeftPt = rotate(left, top);
            const topRightPt = rotate(right, top);
            path.lineTo(topLeftPt.x, topLeftPt.y);
            path.lineTo(topRightPt.x, topRightPt.y);
        }
        const bottomRightPt = rotate(right, bottom);
        path.lineTo(bottomRightPt.x, bottomRightPt.y);
        if (shouldConnectBottomCircle) path.arc(0, 0, innerRadius, $d77b025aa58d633c$var$normalizeAngle360(sideRotation - Math.PI / 2) + pointRotation, $d77b025aa58d633c$var$normalizeAngle360(-sideRotation - Math.PI / 2) + pointRotation, true);
        else {
            const rotatedBottomLeftPt = rotate(left, bottom);
            path.lineTo(rotatedBottomLeftPt.x, rotatedBottomLeftPt.y);
        }
        path.closePath();
    }
};
$d77b025aa58d633c$var$RadialColumnShape.className = "RadialColumnShape";
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ScenePathChangeDetection()
], $d77b025aa58d633c$var$RadialColumnShape.prototype, "isBeveled", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ScenePathChangeDetection()
], $d77b025aa58d633c$var$RadialColumnShape.prototype, "columnWidth", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ScenePathChangeDetection()
], $d77b025aa58d633c$var$RadialColumnShape.prototype, "startAngle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ScenePathChangeDetection()
], $d77b025aa58d633c$var$RadialColumnShape.prototype, "endAngle", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ScenePathChangeDetection()
], $d77b025aa58d633c$var$RadialColumnShape.prototype, "outerRadius", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ScenePathChangeDetection()
], $d77b025aa58d633c$var$RadialColumnShape.prototype, "innerRadius", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ScenePathChangeDetection()
], $d77b025aa58d633c$var$RadialColumnShape.prototype, "axisInnerRadius", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ScenePathChangeDetection()
], $d77b025aa58d633c$var$RadialColumnShape.prototype, "axisOuterRadius", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$ScenePathChangeDetection()
], $d77b025aa58d633c$var$RadialColumnShape.prototype, "isRadiusAxisReversed", 2);
function $d77b025aa58d633c$var$getRadialColumnWidth(startAngle, endAngle, axisOuterRadius, columnWidthRatio, maxColumnWidthRatio) {
    const rotation = $d77b025aa58d633c$var$angleBetween(startAngle, endAngle);
    const pad2 = rotation * (1 - columnWidthRatio) / 2;
    startAngle += pad2;
    endAngle -= pad2;
    if (rotation < 1e-3) return 2 * axisOuterRadius * maxColumnWidthRatio;
    if (rotation >= 2 * Math.PI) {
        const midAngle = startAngle + rotation / 2;
        startAngle = midAngle - Math.PI;
        endAngle = midAngle + Math.PI;
    }
    const startX = axisOuterRadius * Math.cos(startAngle);
    const startY = axisOuterRadius * Math.sin(startAngle);
    const endX = axisOuterRadius * Math.cos(endAngle);
    const endY = axisOuterRadius * Math.sin(endAngle);
    const colWidth = Math.floor(Math.sqrt($d77b025aa58d633c$var$__pow(startX - endX, 2) + $d77b025aa58d633c$var$__pow(startY - endY, 2)));
    const maxWidth = 2 * axisOuterRadius * maxColumnWidthRatio;
    return Math.max(1, Math.min(maxWidth, colWidth));
}
// packages/ag-charts-community/src/scene/image.ts
var $d77b025aa58d633c$var$Image = class extends $d77b025aa58d633c$var$Node {
    constructor(sourceImage){
        super();
        this.x = 0;
        this.y = 0;
        this.width = 0;
        this.height = 0;
        this.opacity = 1;
        this.sourceImage = sourceImage;
    }
    render(renderCtx) {
        const { ctx: ctx, forceRender: forceRender, stats: stats } = renderCtx;
        if (this.dirty === 0 /* NONE */  && !forceRender) {
            if (stats) stats.nodesSkipped++;
            return;
        }
        this.computeTransformMatrix();
        this.matrix.toContext(ctx);
        const image = this.sourceImage;
        ctx.globalAlpha = this.opacity;
        ctx.drawImage(image, 0, 0, image.width, image.height, this.x, this.y, this.width, this.height);
        super.render(renderCtx);
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 3 /* MAJOR */ 
    })
], $d77b025aa58d633c$var$Image.prototype, "x", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 3 /* MAJOR */ 
    })
], $d77b025aa58d633c$var$Image.prototype, "y", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 3 /* MAJOR */ 
    })
], $d77b025aa58d633c$var$Image.prototype, "width", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 3 /* MAJOR */ 
    })
], $d77b025aa58d633c$var$Image.prototype, "height", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$SceneChangeDetection({
        redraw: 3 /* MAJOR */ 
    })
], $d77b025aa58d633c$var$Image.prototype, "opacity", 2);
// packages/ag-charts-community/src/integrated-charts-scene.ts
var $d77b025aa58d633c$var$motion = $d77b025aa58d633c$var$__spreadValues($d77b025aa58d633c$var$__spreadValues({}, $d77b025aa58d633c$var$fromToMotion_exports), $d77b025aa58d633c$var$resetMotion_exports);
// packages/ag-charts-community/src/integrated-charts-theme.ts
var $d77b025aa58d633c$export$d23fb0bb3c916391 = {};
$d77b025aa58d633c$var$__export($d77b025aa58d633c$export$d23fb0bb3c916391, {
    CARTESIAN_AXIS_TYPE: ()=>$d77b025aa58d633c$var$CARTESIAN_AXIS_TYPE,
    ChartTheme: ()=>$d77b025aa58d633c$var$ChartTheme,
    DEFAULT_ANNOTATION_BACKGROUND_FILL: ()=>$d77b025aa58d633c$var$DEFAULT_ANNOTATION_BACKGROUND_FILL,
    DEFAULT_ANNOTATION_HANDLE_FILL: ()=>$d77b025aa58d633c$var$DEFAULT_ANNOTATION_HANDLE_FILL,
    DEFAULT_ANNOTATION_STROKE: ()=>$d77b025aa58d633c$var$DEFAULT_ANNOTATION_STROKE,
    DEFAULT_AXIS_GRID_COLOUR: ()=>$d77b025aa58d633c$var$DEFAULT_AXIS_GRID_COLOUR,
    DEFAULT_AXIS_LINE_COLOUR: ()=>$d77b025aa58d633c$var$DEFAULT_AXIS_LINE_COLOUR,
    DEFAULT_BACKGROUND_COLOUR: ()=>$d77b025aa58d633c$var$DEFAULT_BACKGROUND_COLOUR,
    DEFAULT_COLOURS: ()=>$d77b025aa58d633c$var$DEFAULT_COLOURS,
    DEFAULT_CROSS_LINES_COLOUR: ()=>$d77b025aa58d633c$var$DEFAULT_CROSS_LINES_COLOUR,
    DEFAULT_DIVERGING_SERIES_COLOUR_RANGE: ()=>$d77b025aa58d633c$var$DEFAULT_DIVERGING_SERIES_COLOUR_RANGE,
    DEFAULT_FONT_FAMILY: ()=>$d77b025aa58d633c$var$DEFAULT_FONT_FAMILY,
    DEFAULT_HIERARCHY_FILLS: ()=>$d77b025aa58d633c$var$DEFAULT_HIERARCHY_FILLS,
    DEFAULT_HIERARCHY_STROKES: ()=>$d77b025aa58d633c$var$DEFAULT_HIERARCHY_STROKES,
    DEFAULT_INSIDE_SERIES_LABEL_COLOUR: ()=>$d77b025aa58d633c$var$DEFAULT_INSIDE_SERIES_LABEL_COLOUR,
    DEFAULT_INVERTED_LABEL_COLOUR: ()=>$d77b025aa58d633c$var$DEFAULT_INVERTED_LABEL_COLOUR,
    DEFAULT_LABEL_COLOUR: ()=>$d77b025aa58d633c$var$DEFAULT_LABEL_COLOUR,
    DEFAULT_MUTED_LABEL_COLOUR: ()=>$d77b025aa58d633c$var$DEFAULT_MUTED_LABEL_COLOUR,
    DEFAULT_POLAR_SERIES_STROKE: ()=>$d77b025aa58d633c$var$DEFAULT_POLAR_SERIES_STROKE,
    DEFAULT_SHADOW_COLOUR: ()=>$d77b025aa58d633c$var$DEFAULT_SHADOW_COLOUR,
    DEFAULT_WATERFALL_SERIES_CONNECTOR_LINE_STROKE: ()=>$d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_CONNECTOR_LINE_STROKE,
    DEFAULT_WATERFALL_SERIES_NEGATIVE_COLOURS: ()=>$d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_NEGATIVE_COLOURS,
    DEFAULT_WATERFALL_SERIES_POSITIVE_COLOURS: ()=>$d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_POSITIVE_COLOURS,
    DEFAULT_WATERFALL_SERIES_TOTAL_COLOURS: ()=>$d77b025aa58d633c$var$DEFAULT_WATERFALL_SERIES_TOTAL_COLOURS,
    EXTENDS_AXES_DEFAULTS: ()=>$d77b025aa58d633c$var$EXTENDS_AXES_DEFAULTS,
    EXTENDS_AXES_GRID_LINE_DEFAULTS: ()=>$d77b025aa58d633c$var$EXTENDS_AXES_GRID_LINE_DEFAULTS,
    EXTENDS_AXES_LINE_DEFAULTS: ()=>$d77b025aa58d633c$var$EXTENDS_AXES_LINE_DEFAULTS,
    EXTENDS_AXES_TICK_DEFAULTS: ()=>$d77b025aa58d633c$var$EXTENDS_AXES_TICK_DEFAULTS,
    EXTENDS_CARTESIAN_MARKER_DEFAULTS: ()=>$d77b025aa58d633c$var$EXTENDS_CARTESIAN_MARKER_DEFAULTS,
    EXTENDS_SERIES_DEFAULTS: ()=>$d77b025aa58d633c$var$EXTENDS_SERIES_DEFAULTS,
    FONT_SIZE: ()=>$d77b025aa58d633c$var$FONT_SIZE,
    FONT_WEIGHT: ()=>$d77b025aa58d633c$var$FONT_WEIGHT,
    IS_DARK_THEME: ()=>$d77b025aa58d633c$var$IS_DARK_THEME,
    POLAR_AXIS_SHAPE: ()=>$d77b025aa58d633c$var$POLAR_AXIS_SHAPE,
    POLAR_AXIS_TYPE: ()=>$d77b025aa58d633c$var$POLAR_AXIS_TYPE,
    POSITION: ()=>$d77b025aa58d633c$var$POSITION,
    getChartTheme: ()=>$d77b025aa58d633c$var$getChartTheme,
    markerPaletteFactory: ()=>$d77b025aa58d633c$var$markerPaletteFactory,
    singleSeriesPaletteFactory: ()=>$d77b025aa58d633c$var$singleSeriesPaletteFactory,
    themes: ()=>$d77b025aa58d633c$var$themes2
});
var $d77b025aa58d633c$var$themes2 = $d77b025aa58d633c$var$mapValues($d77b025aa58d633c$var$themes, (themeFactory)=>themeFactory == null ? void 0 : themeFactory());
// packages/ag-charts-community/src/sparklines-scale.ts
var $d77b025aa58d633c$export$fa86e017a5c0b409 = {};
$d77b025aa58d633c$var$__export($d77b025aa58d633c$export$fa86e017a5c0b409, {
    BandScale: ()=>$d77b025aa58d633c$var$BandScale,
    ColorScale: ()=>$d77b025aa58d633c$var$ColorScale,
    ContinuousScale: ()=>$d77b025aa58d633c$var$ContinuousScale,
    Invalidating: ()=>$d77b025aa58d633c$var$Invalidating,
    LinearScale: ()=>$d77b025aa58d633c$var$LinearScale,
    OrdinalTimeScale: ()=>$d77b025aa58d633c$var$OrdinalTimeScale,
    TimeScale: ()=>$d77b025aa58d633c$var$TimeScale
});
// packages/ag-charts-community/src/sparklines-util.ts
var $d77b025aa58d633c$export$48e12db5e55fd3a3 = {};
$d77b025aa58d633c$var$__export($d77b025aa58d633c$export$48e12db5e55fd3a3, {
    Color: ()=>$d77b025aa58d633c$var$Color,
    Logger: ()=>$d77b025aa58d633c$var$Logger,
    Padding: ()=>$d77b025aa58d633c$var$Padding,
    angleBetween: ()=>$d77b025aa58d633c$var$angleBetween,
    areArrayItemsStrictlyEqual: ()=>$d77b025aa58d633c$var$areArrayItemsStrictlyEqual,
    areArrayNumbersEqual: ()=>$d77b025aa58d633c$var$areArrayNumbersEqual,
    bifurcate: ()=>$d77b025aa58d633c$var$bifurcate,
    checkDatum: ()=>$d77b025aa58d633c$var$checkDatum,
    clamp: ()=>$d77b025aa58d633c$var$clamp,
    clampArray: ()=>$d77b025aa58d633c$var$clampArray,
    countFractionDigits: ()=>$d77b025aa58d633c$var$countFractionDigits,
    createId: ()=>$d77b025aa58d633c$var$createId,
    deepClone: ()=>$d77b025aa58d633c$var$deepClone,
    displacePointFromVector: ()=>$d77b025aa58d633c$var$displacePointFromVector,
    extent: ()=>$d77b025aa58d633c$var$extent,
    findMinMax: ()=>$d77b025aa58d633c$var$findMinMax,
    findRangeExtent: ()=>$d77b025aa58d633c$var$findRangeExtent,
    isBetweenAngles: ()=>$d77b025aa58d633c$var$isBetweenAngles,
    isContinuous: ()=>$d77b025aa58d633c$var$isContinuous,
    isDate: ()=>$d77b025aa58d633c$var$isValidDate,
    isDenseInterval: ()=>$d77b025aa58d633c$var$isDenseInterval,
    isEqual: ()=>$d77b025aa58d633c$var$isEqual,
    isNegative: ()=>$d77b025aa58d633c$var$isNegative,
    isNumber: ()=>$d77b025aa58d633c$var$isFiniteNumber,
    isNumberEqual: ()=>$d77b025aa58d633c$var$isEqual,
    isNumberObject: ()=>$d77b025aa58d633c$var$isNumberObject,
    isString: ()=>$d77b025aa58d633c$var$isString,
    isStringObject: ()=>$d77b025aa58d633c$var$isStringObject,
    jsonApply: ()=>$d77b025aa58d633c$var$jsonApply,
    jsonDiff: ()=>$d77b025aa58d633c$var$jsonDiff,
    jsonWalk: ()=>$d77b025aa58d633c$var$jsonWalk,
    mod: ()=>$d77b025aa58d633c$var$mod,
    normalisedExtent: ()=>$d77b025aa58d633c$var$normalisedExtent,
    normalisedExtentWithMetadata: ()=>$d77b025aa58d633c$var$normalisedExtentWithMetadata,
    normalizeAngle180: ()=>$d77b025aa58d633c$var$normalizeAngle180,
    normalizeAngle360: ()=>$d77b025aa58d633c$var$normalizeAngle360,
    normalizeAngle360Inclusive: ()=>$d77b025aa58d633c$var$normalizeAngle360Inclusive,
    range: ()=>$d77b025aa58d633c$var$range,
    resetIds: ()=>$d77b025aa58d633c$var$resetIds,
    round: ()=>$d77b025aa58d633c$var$round,
    sanitizeHtml: ()=>$d77b025aa58d633c$var$sanitizeHtml,
    setAttribute: ()=>$d77b025aa58d633c$var$setAttribute,
    shallowClone: ()=>$d77b025aa58d633c$var$shallowClone,
    tickFormat: ()=>$d77b025aa58d633c$var$tickFormat,
    tickStep: ()=>$d77b025aa58d633c$var$tickStep,
    ticks: ()=>$d77b025aa58d633c$var$ticks_default,
    toDegrees: ()=>$d77b025aa58d633c$var$toDegrees,
    toFixed: ()=>$d77b025aa58d633c$var$toFixed,
    toRadians: ()=>$d77b025aa58d633c$var$toRadians,
    transformIntegratedCategoryValue: ()=>$d77b025aa58d633c$var$transformIntegratedCategoryValue,
    zipObject: ()=>$d77b025aa58d633c$var$zipObject
});
// packages/ag-charts-community/src/util/zip.ts
function $d77b025aa58d633c$var$zipObject(keys, values) {
    const zipped = {};
    if (Array.isArray(values)) for(let i = 0; i < keys.length; i++)zipped[`${keys[i]}`] = values[i];
    else for(let i = 0; i < keys.length; i++)zipped[`${keys[i]}`] = values;
    return zipped;
}
// packages/ag-charts-community/src/module-support.ts
var $d77b025aa58d633c$export$d0f5d10b4c7de308 = {};
$d77b025aa58d633c$var$__export($d77b025aa58d633c$export$d0f5d10b4c7de308, {
    AND: ()=>$d77b025aa58d633c$var$AND,
    ARRAY: ()=>$d77b025aa58d633c$var$ARRAY,
    ARRAY_OF: ()=>$d77b025aa58d633c$var$ARRAY_OF,
    AbstractBarSeries: ()=>$d77b025aa58d633c$var$AbstractBarSeries,
    AbstractBarSeriesProperties: ()=>$d77b025aa58d633c$var$AbstractBarSeriesProperties,
    ActionOnSet: ()=>$d77b025aa58d633c$var$ActionOnSet,
    Animation: ()=>$d77b025aa58d633c$var$Animation,
    AnimationManager: ()=>$d77b025aa58d633c$var$AnimationManager,
    AreaSeriesTag: ()=>$d77b025aa58d633c$var$AreaSeriesTag,
    Axis: ()=>$d77b025aa58d633c$var$Axis,
    AxisLabel: ()=>$d77b025aa58d633c$var$AxisLabel,
    AxisTick: ()=>$d77b025aa58d633c$var$AxisTick,
    BOOLEAN: ()=>$d77b025aa58d633c$var$BOOLEAN,
    BOOLEAN_ARRAY: ()=>$d77b025aa58d633c$var$BOOLEAN_ARRAY,
    Background: ()=>$d77b025aa58d633c$var$Background,
    BackgroundModule: ()=>$d77b025aa58d633c$var$BackgroundModule,
    BaseModuleInstance: ()=>$d77b025aa58d633c$var$BaseModuleInstance,
    BaseProperties: ()=>$d77b025aa58d633c$var$BaseProperties,
    COLOR_STRING: ()=>$d77b025aa58d633c$var$COLOR_STRING,
    COLOR_STRING_ARRAY: ()=>$d77b025aa58d633c$var$COLOR_STRING_ARRAY,
    CartesianAxis: ()=>$d77b025aa58d633c$var$CartesianAxis,
    CartesianSeries: ()=>$d77b025aa58d633c$var$CartesianSeries,
    CartesianSeriesNodeEvent: ()=>$d77b025aa58d633c$var$CartesianSeriesNodeEvent,
    CartesianSeriesProperties: ()=>$d77b025aa58d633c$var$CartesianSeriesProperties,
    CategoryAxis: ()=>$d77b025aa58d633c$var$CategoryAxis,
    CategoryAxisTick: ()=>$d77b025aa58d633c$var$CategoryAxisTick,
    ChartAxisDirection: ()=>$d77b025aa58d633c$var$ChartAxisDirection,
    ChartEventManager: ()=>$d77b025aa58d633c$var$ChartEventManager,
    ChartOptions: ()=>$d77b025aa58d633c$var$ChartOptions,
    ChartUpdateType: ()=>$d77b025aa58d633c$var$ChartUpdateType,
    ContextMenuRegistry: ()=>$d77b025aa58d633c$var$ContextMenuRegistry,
    CursorManager: ()=>$d77b025aa58d633c$var$CursorManager,
    DATE: ()=>$d77b025aa58d633c$var$DATE,
    DATE_ARRAY: ()=>$d77b025aa58d633c$var$DATE_ARRAY,
    DATE_OR_DATETIME_MS: ()=>$d77b025aa58d633c$var$DATE_OR_DATETIME_MS,
    DEFAULT_CARTESIAN_DIRECTION_KEYS: ()=>$d77b025aa58d633c$var$DEFAULT_CARTESIAN_DIRECTION_KEYS,
    DEFAULT_CARTESIAN_DIRECTION_NAMES: ()=>$d77b025aa58d633c$var$DEFAULT_CARTESIAN_DIRECTION_NAMES,
    DEFAULT_TOOLTIP_CLASS: ()=>$d77b025aa58d633c$var$DEFAULT_TOOLTIP_CLASS,
    DEFAULT_TOOLTIP_DARK_CLASS: ()=>$d77b025aa58d633c$var$DEFAULT_TOOLTIP_DARK_CLASS,
    DEGREE: ()=>$d77b025aa58d633c$var$DEGREE,
    DIRECTION: ()=>$d77b025aa58d633c$var$DIRECTION,
    DataController: ()=>$d77b025aa58d633c$var$DataController,
    DataModel: ()=>$d77b025aa58d633c$var$DataModel,
    DataModelSeries: ()=>$d77b025aa58d633c$var$DataModelSeries,
    DataService: ()=>$d77b025aa58d633c$var$DataService,
    Default: ()=>$d77b025aa58d633c$var$Default,
    Deprecated: ()=>$d77b025aa58d633c$var$Deprecated,
    DeprecatedAndRenamedTo: ()=>$d77b025aa58d633c$var$DeprecatedAndRenamedTo,
    EMPTY_TOOLTIP_CONTENT: ()=>$d77b025aa58d633c$var$EMPTY_TOOLTIP_CONTENT,
    FONT_STYLE: ()=>$d77b025aa58d633c$var$FONT_STYLE,
    FONT_WEIGHT: ()=>$d77b025aa58d633c$var$FONT_WEIGHT2,
    FUNCTION: ()=>$d77b025aa58d633c$var$FUNCTION,
    GREATER_THAN: ()=>$d77b025aa58d633c$var$GREATER_THAN,
    GestureDetector: ()=>$d77b025aa58d633c$var$GestureDetector,
    GroupedCategoryAxis: ()=>$d77b025aa58d633c$var$GroupedCategoryAxis,
    HierarchyNode: ()=>$d77b025aa58d633c$var$HierarchyNode,
    HierarchySeries: ()=>$d77b025aa58d633c$var$HierarchySeries,
    HierarchySeriesProperties: ()=>$d77b025aa58d633c$var$HierarchySeriesProperties,
    HighlightManager: ()=>$d77b025aa58d633c$var$HighlightManager,
    HighlightStyle: ()=>$d77b025aa58d633c$var$HighlightStyle,
    INTERACTION_RANGE: ()=>$d77b025aa58d633c$var$INTERACTION_RANGE,
    InteractionManager: ()=>$d77b025aa58d633c$var$InteractionManager,
    InteractionState: ()=>$d77b025aa58d633c$var$InteractionState,
    LABEL_PLACEMENT: ()=>$d77b025aa58d633c$var$LABEL_PLACEMENT,
    LESS_THAN: ()=>$d77b025aa58d633c$var$LESS_THAN,
    LINE_CAP: ()=>$d77b025aa58d633c$var$LINE_CAP,
    LINE_DASH: ()=>$d77b025aa58d633c$var$LINE_DASH,
    LINE_JOIN: ()=>$d77b025aa58d633c$var$LINE_JOIN,
    Layers: ()=>$d77b025aa58d633c$var$Layers,
    LayoutService: ()=>$d77b025aa58d633c$var$LayoutService,
    LonLatBBox: ()=>$d77b025aa58d633c$var$LonLatBBox,
    MARKER_SHAPE: ()=>$d77b025aa58d633c$var$MARKER_SHAPE,
    MATCHING_CROSSLINE_TYPE: ()=>$d77b025aa58d633c$var$MATCHING_CROSSLINE_TYPE,
    MAX_SPACING: ()=>$d77b025aa58d633c$var$MAX_SPACING,
    MIN_SPACING: ()=>$d77b025aa58d633c$var$MIN_SPACING,
    MercatorScale: ()=>$d77b025aa58d633c$var$MercatorScale,
    Motion: ()=>$d77b025aa58d633c$var$easing_exports,
    NAN: ()=>$d77b025aa58d633c$var$NAN,
    NODE_UPDATE_STATE_TO_PHASE_MAPPING: ()=>$d77b025aa58d633c$var$NODE_UPDATE_STATE_TO_PHASE_MAPPING,
    NUMBER: ()=>$d77b025aa58d633c$var$NUMBER,
    NUMBER_ARRAY: ()=>$d77b025aa58d633c$var$NUMBER_ARRAY,
    NUMBER_OR_NAN: ()=>$d77b025aa58d633c$var$NUMBER_OR_NAN,
    Navigator: ()=>$d77b025aa58d633c$var$Navigator,
    NavigatorModule: ()=>$d77b025aa58d633c$var$NavigatorModule,
    OBJECT: ()=>$d77b025aa58d633c$var$OBJECT,
    OBJECT_ARRAY: ()=>$d77b025aa58d633c$var$OBJECT_ARRAY,
    OR: ()=>$d77b025aa58d633c$var$OR,
    OVERFLOW_STRATEGY: ()=>$d77b025aa58d633c$var$OVERFLOW_STRATEGY,
    ObserveChanges: ()=>$d77b025aa58d633c$var$ObserveChanges,
    PHASE_METADATA: ()=>$d77b025aa58d633c$var$PHASE_METADATA,
    PHASE_ORDER: ()=>$d77b025aa58d633c$var$PHASE_ORDER,
    PLACEMENT: ()=>$d77b025aa58d633c$var$PLACEMENT,
    PLAIN_OBJECT: ()=>$d77b025aa58d633c$var$PLAIN_OBJECT,
    POINTER_INTERACTION_TYPES: ()=>$d77b025aa58d633c$var$POINTER_INTERACTION_TYPES,
    POSITION: ()=>$d77b025aa58d633c$var$POSITION2,
    POSITIVE_NUMBER: ()=>$d77b025aa58d633c$var$POSITIVE_NUMBER,
    PolarAxis: ()=>$d77b025aa58d633c$var$PolarAxis,
    PolarSeries: ()=>$d77b025aa58d633c$var$PolarSeries,
    PropertiesArray: ()=>$d77b025aa58d633c$var$PropertiesArray,
    ProxyOnWrite: ()=>$d77b025aa58d633c$var$ProxyOnWrite,
    ProxyProperty: ()=>$d77b025aa58d633c$var$ProxyProperty,
    ProxyPropertyOnWrite: ()=>$d77b025aa58d633c$var$ProxyPropertyOnWrite,
    QUICK_TRANSITION: ()=>$d77b025aa58d633c$var$QUICK_TRANSITION,
    RATIO: ()=>$d77b025aa58d633c$var$RATIO,
    RepeatType: ()=>$d77b025aa58d633c$var$RepeatType,
    SKIP_JS_BUILTINS: ()=>$d77b025aa58d633c$var$SKIP_JS_BUILTINS,
    SMALLEST_KEY_INTERVAL: ()=>$d77b025aa58d633c$var$SMALLEST_KEY_INTERVAL,
    SORT_DOMAIN_GROUPS: ()=>$d77b025aa58d633c$var$SORT_DOMAIN_GROUPS,
    STRING: ()=>$d77b025aa58d633c$var$STRING,
    STRING_ARRAY: ()=>$d77b025aa58d633c$var$STRING_ARRAY,
    Series: ()=>$d77b025aa58d633c$var$Series,
    SeriesGroupingChangedEvent: ()=>$d77b025aa58d633c$var$SeriesGroupingChangedEvent,
    SeriesItemHighlightStyle: ()=>$d77b025aa58d633c$var$SeriesItemHighlightStyle,
    SeriesMarker: ()=>$d77b025aa58d633c$var$SeriesMarker,
    SeriesNodeEvent: ()=>$d77b025aa58d633c$var$SeriesNodeEvent,
    SeriesNodePickMode: ()=>$d77b025aa58d633c$var$SeriesNodePickMode,
    SeriesProperties: ()=>$d77b025aa58d633c$var$SeriesProperties,
    SeriesTooltip: ()=>$d77b025aa58d633c$var$SeriesTooltip,
    StateMachine: ()=>$d77b025aa58d633c$var$StateMachine,
    TEXT_ALIGN: ()=>$d77b025aa58d633c$var$TEXT_ALIGN,
    TEXT_WRAP: ()=>$d77b025aa58d633c$var$TEXT_WRAP,
    ToolbarManager: ()=>$d77b025aa58d633c$var$ToolbarManager,
    Tooltip: ()=>$d77b025aa58d633c$var$Tooltip,
    TooltipManager: ()=>$d77b025aa58d633c$var$TooltipManager,
    TooltipPosition: ()=>$d77b025aa58d633c$var$TooltipPosition,
    UNION: ()=>$d77b025aa58d633c$var$UNION,
    UpdateService: ()=>$d77b025aa58d633c$var$UpdateService,
    VERTICAL_ALIGN: ()=>$d77b025aa58d633c$var$VERTICAL_ALIGN,
    Validate: ()=>$d77b025aa58d633c$var$Validate,
    ZoomManager: ()=>$d77b025aa58d633c$var$ZoomManager,
    __FORCE_MODULE_DETECTION: ()=>$d77b025aa58d633c$var$__FORCE_MODULE_DETECTION2,
    accumulateGroup: ()=>$d77b025aa58d633c$var$accumulateGroup,
    accumulatedValue: ()=>$d77b025aa58d633c$var$accumulatedValue,
    accumulativeValueProperty: ()=>$d77b025aa58d633c$var$accumulativeValueProperty,
    addHitTestersToQuadtree: ()=>$d77b025aa58d633c$var$addHitTestersToQuadtree,
    adjustLabelPlacement: ()=>$d77b025aa58d633c$var$adjustLabelPlacement,
    allInStringUnion: ()=>$d77b025aa58d633c$var$allInStringUnion,
    animationValidation: ()=>$d77b025aa58d633c$var$animationValidation,
    area: ()=>$d77b025aa58d633c$var$area,
    arraysEqual: ()=>$d77b025aa58d633c$var$arraysEqual,
    assignJsonApplyConstructedArray: ()=>$d77b025aa58d633c$var$assignJsonApplyConstructedArray,
    backfillPathPointData: ()=>$d77b025aa58d633c$var$backfillPathPointData,
    basicContinuousCheckDatumValidation: ()=>$d77b025aa58d633c$var$basicContinuousCheckDatumValidation,
    bifurcate: ()=>$d77b025aa58d633c$var$bifurcate,
    buildFormatter: ()=>$d77b025aa58d633c$var$buildFormatter,
    buildResetPathFn: ()=>$d77b025aa58d633c$var$buildResetPathFn,
    calculateDefaultTimeTickFormat: ()=>$d77b025aa58d633c$var$calculateDefaultTimeTickFormat,
    calculatePlacement: ()=>$d77b025aa58d633c$var$calculatePlacement,
    checkCrisp: ()=>$d77b025aa58d633c$var$checkCrisp,
    childrenIter: ()=>$d77b025aa58d633c$var$childrenIter,
    circularSliceArray: ()=>$d77b025aa58d633c$var$circularSliceArray,
    clamp: ()=>$d77b025aa58d633c$var$clamp,
    clampArray: ()=>$d77b025aa58d633c$var$clampArray,
    collapsedStartingBarPosition: ()=>$d77b025aa58d633c$var$collapsedStartingBarPosition,
    computeBarFocusBounds: ()=>$d77b025aa58d633c$var$computeBarFocusBounds,
    computeMarkerFocusBounds: ()=>$d77b025aa58d633c$var$computeMarkerFocusBounds,
    computeSectorFocusBounds: ()=>$d77b025aa58d633c$var$computeSectorFocusBounds,
    convertValuesToScaleByDefs: ()=>$d77b025aa58d633c$var$convertValuesToScaleByDefs,
    countFractionDigits: ()=>$d77b025aa58d633c$var$countFractionDigits,
    createDatumId: ()=>$d77b025aa58d633c$var$createDatumId,
    createDeprecationWarning: ()=>$d77b025aa58d633c$var$createDeprecationWarning,
    createElement: ()=>$d77b025aa58d633c$var$createElement,
    dateToNumber: ()=>$d77b025aa58d633c$var$dateToNumber,
    deconstructSelectionsOrNodes: ()=>$d77b025aa58d633c$var$deconstructSelectionsOrNodes,
    deepClone: ()=>$d77b025aa58d633c$var$deepClone,
    deepMerge: ()=>$d77b025aa58d633c$var$deepMerge,
    defaultTimeTickFormat: ()=>$d77b025aa58d633c$var$defaultTimeTickFormat,
    determinePathStatus: ()=>$d77b025aa58d633c$var$determinePathStatus,
    diff: ()=>$d77b025aa58d633c$var$diff,
    downloadUrl: ()=>$d77b025aa58d633c$var$downloadUrl,
    enterpriseModule: ()=>$d77b025aa58d633c$var$enterpriseModule,
    extent: ()=>$d77b025aa58d633c$var$extent,
    extractDecoratedProperties: ()=>$d77b025aa58d633c$var$extractDecoratedProperties,
    findMinMax: ()=>$d77b025aa58d633c$var$findMinMax,
    findQuadtreeMatch: ()=>$d77b025aa58d633c$var$findQuadtreeMatch,
    findRangeExtent: ()=>$d77b025aa58d633c$var$findRangeExtent,
    fixNumericExtent: ()=>$d77b025aa58d633c$var$fixNumericExtent,
    fromToMotion: ()=>$d77b025aa58d633c$var$fromToMotion,
    getDocument: ()=>$d77b025aa58d633c$var$getDocument,
    getMissCount: ()=>$d77b025aa58d633c$var$getMissCount,
    getPath: ()=>$d77b025aa58d633c$var$getPath,
    getRectConfig: ()=>$d77b025aa58d633c$var$getRectConfig,
    getWindow: ()=>$d77b025aa58d633c$var$getWindow,
    groupAccumulativeValueProperty: ()=>$d77b025aa58d633c$var$groupAccumulativeValueProperty,
    groupAverage: ()=>$d77b025aa58d633c$var$groupAverage,
    groupBy: ()=>$d77b025aa58d633c$var$groupBy,
    groupCount: ()=>$d77b025aa58d633c$var$groupCount,
    groupSum: ()=>$d77b025aa58d633c$var$groupSum,
    injectStyle: ()=>$d77b025aa58d633c$var$injectStyle,
    isArray: ()=>$d77b025aa58d633c$var$isArray,
    isBoolean: ()=>$d77b025aa58d633c$var$isBoolean,
    isDate: ()=>$d77b025aa58d633c$var$isDate,
    isDecoratedObject: ()=>$d77b025aa58d633c$var$isDecoratedObject,
    isDefined: ()=>$d77b025aa58d633c$var$isDefined,
    isEnumKey: ()=>$d77b025aa58d633c$var$isEnumKey,
    isEnumValue: ()=>$d77b025aa58d633c$var$isEnumValue,
    isEqual: ()=>$d77b025aa58d633c$var$isEqual,
    isFiniteNumber: ()=>$d77b025aa58d633c$var$isFiniteNumber,
    isFunction: ()=>$d77b025aa58d633c$var$isFunction,
    isHtmlElement: ()=>$d77b025aa58d633c$var$isHtmlElement,
    isNegative: ()=>$d77b025aa58d633c$var$isNegative,
    isNumber: ()=>$d77b025aa58d633c$var$isNumber,
    isObject: ()=>$d77b025aa58d633c$var$isObject,
    isObjectLike: ()=>$d77b025aa58d633c$var$isObjectLike,
    isPlainObject: ()=>$d77b025aa58d633c$var$isPlainObject,
    isProperties: ()=>$d77b025aa58d633c$var$isProperties,
    isRegExp: ()=>$d77b025aa58d633c$var$isRegExp,
    isString: ()=>$d77b025aa58d633c$var$isString,
    isSymbol: ()=>$d77b025aa58d633c$var$isSymbol,
    isValidDate: ()=>$d77b025aa58d633c$var$isValidDate,
    jsonApply: ()=>$d77b025aa58d633c$var$jsonApply,
    jsonDiff: ()=>$d77b025aa58d633c$var$jsonDiff,
    jsonWalk: ()=>$d77b025aa58d633c$var$jsonWalk,
    keyProperty: ()=>$d77b025aa58d633c$var$keyProperty,
    listDecoratedProperties: ()=>$d77b025aa58d633c$var$listDecoratedProperties,
    mapIterable: ()=>$d77b025aa58d633c$var$mapIterable,
    mapValues: ()=>$d77b025aa58d633c$var$mapValues,
    markerFadeInAnimation: ()=>$d77b025aa58d633c$var$markerFadeInAnimation,
    markerPaletteFactory: ()=>$d77b025aa58d633c$var$markerPaletteFactory,
    markerScaleInAnimation: ()=>$d77b025aa58d633c$var$markerScaleInAnimation,
    markerSwipeScaleInAnimation: ()=>$d77b025aa58d633c$var$markerSwipeScaleInAnimation,
    mergeArrayDefaults: ()=>$d77b025aa58d633c$var$mergeArrayDefaults,
    mergeDefaults: ()=>$d77b025aa58d633c$var$mergeDefaults,
    midpointStartingBarPosition: ()=>$d77b025aa58d633c$var$midpointStartingBarPosition,
    minMax: ()=>$d77b025aa58d633c$var$minMax,
    mod: ()=>$d77b025aa58d633c$var$mod,
    moduleRegistry: ()=>$d77b025aa58d633c$var$moduleRegistry,
    normaliseGroupTo: ()=>$d77b025aa58d633c$var$normaliseGroupTo,
    normalisePropertyTo: ()=>$d77b025aa58d633c$var$normalisePropertyTo,
    normalisedExtent: ()=>$d77b025aa58d633c$var$normalisedExtent,
    normalisedExtentWithMetadata: ()=>$d77b025aa58d633c$var$normalisedExtentWithMetadata,
    pairCategoryData: ()=>$d77b025aa58d633c$var$pairCategoryData,
    pairContinuousData: ()=>$d77b025aa58d633c$var$pairContinuousData,
    partialAssign: ()=>$d77b025aa58d633c$var$partialAssign,
    pathFadeInAnimation: ()=>$d77b025aa58d633c$var$pathFadeInAnimation,
    pathFadeOutAnimation: ()=>$d77b025aa58d633c$var$pathFadeOutAnimation,
    pathSwipeInAnimation: ()=>$d77b025aa58d633c$var$pathSwipeInAnimation,
    pickByMatchingAngle: ()=>$d77b025aa58d633c$var$pickByMatchingAngle,
    predicateWithMessage: ()=>$d77b025aa58d633c$var$predicateWithMessage,
    prepareAreaPathAnimation: ()=>$d77b025aa58d633c$var$prepareAreaPathAnimation,
    prepareAxisAnimationContext: ()=>$d77b025aa58d633c$var$prepareAxisAnimationContext,
    prepareAxisAnimationFunctions: ()=>$d77b025aa58d633c$var$prepareAxisAnimationFunctions,
    prepareBarAnimationFunctions: ()=>$d77b025aa58d633c$var$prepareBarAnimationFunctions,
    prepareLinePathAnimation: ()=>$d77b025aa58d633c$var$prepareLinePathAnimation,
    prepareLinePathAnimationFns: ()=>$d77b025aa58d633c$var$prepareLinePathAnimationFns,
    prepareMarkerAnimation: ()=>$d77b025aa58d633c$var$prepareMarkerAnimation,
    preparePieSeriesAnimationFunctions: ()=>$d77b025aa58d633c$var$preparePieSeriesAnimationFunctions,
    range: ()=>$d77b025aa58d633c$var$range2,
    rangedValueProperty: ()=>$d77b025aa58d633c$var$rangedValueProperty,
    renderPartialPath: ()=>$d77b025aa58d633c$var$renderPartialPath,
    resetAxisGroupFn: ()=>$d77b025aa58d633c$var$resetAxisGroupFn,
    resetAxisLabelSelectionFn: ()=>$d77b025aa58d633c$var$resetAxisLabelSelectionFn,
    resetAxisLineSelectionFn: ()=>$d77b025aa58d633c$var$resetAxisLineSelectionFn,
    resetAxisSelectionFn: ()=>$d77b025aa58d633c$var$resetAxisSelectionFn,
    resetBarSelectionsFn: ()=>$d77b025aa58d633c$var$resetBarSelectionsFn,
    resetIds: ()=>$d77b025aa58d633c$var$resetIds,
    resetLabelFn: ()=>$d77b025aa58d633c$var$resetLabelFn,
    resetMarkerFn: ()=>$d77b025aa58d633c$var$resetMarkerFn,
    resetMarkerPositionFn: ()=>$d77b025aa58d633c$var$resetMarkerPositionFn,
    resetMotion: ()=>$d77b025aa58d633c$var$resetMotion,
    resetPieSelectionsFn: ()=>$d77b025aa58d633c$var$resetPieSelectionsFn,
    round: ()=>$d77b025aa58d633c$var$round,
    seriesLabelFadeInAnimation: ()=>$d77b025aa58d633c$var$seriesLabelFadeInAnimation,
    seriesLabelFadeOutAnimation: ()=>$d77b025aa58d633c$var$seriesLabelFadeOutAnimation,
    setDocument: ()=>$d77b025aa58d633c$var$setDocument,
    setPath: ()=>$d77b025aa58d633c$var$setPath,
    setWindow: ()=>$d77b025aa58d633c$var$setWindow,
    shallowClone: ()=>$d77b025aa58d633c$var$shallowClone,
    singleSeriesPaletteFactory: ()=>$d77b025aa58d633c$var$singleSeriesPaletteFactory,
    staticFromToMotion: ()=>$d77b025aa58d633c$var$staticFromToMotion,
    stringify: ()=>$d77b025aa58d633c$var$stringify,
    sum: ()=>$d77b025aa58d633c$var$sum,
    sumValues: ()=>$d77b025aa58d633c$var$sumValues,
    toArray: ()=>$d77b025aa58d633c$var$toArray,
    toFixed: ()=>$d77b025aa58d633c$var$toFixed,
    toTooltipHtml: ()=>$d77b025aa58d633c$var$toTooltipHtml,
    trailingAccumulatedValue: ()=>$d77b025aa58d633c$var$trailingAccumulatedValue,
    trailingAccumulatedValueProperty: ()=>$d77b025aa58d633c$var$trailingAccumulatedValueProperty,
    unique: ()=>$d77b025aa58d633c$var$unique,
    updateClipPath: ()=>$d77b025aa58d633c$var$updateClipPath,
    updateLabelNode: ()=>$d77b025aa58d633c$var$updateLabelNode,
    updateRect: ()=>$d77b025aa58d633c$var$updateRect,
    validateCrossLineValues: ()=>$d77b025aa58d633c$var$validateCrossLineValues,
    valueProperty: ()=>$d77b025aa58d633c$var$valueProperty,
    without: ()=>$d77b025aa58d633c$var$without
});
// packages/ag-charts-community/src/chart/series/util.ts
function $d77b025aa58d633c$var$convertValuesToScaleByDefs({ defs: defs, values: values, xAxis: xAxis, yAxis: yAxis }) {
    if (!(xAxis && yAxis)) throw new Error("Axes must be defined");
    const result = {};
    for (const [searchId, { def: def }] of defs)if (Object.hasOwn(values, searchId)) {
        const { scale: scale2 } = def.type === "key" ? xAxis : yAxis;
        result[searchId] = Math.round(scale2.convert(values[searchId]));
    }
    return result;
}
// packages/ag-charts-community/src/chart/series/hierarchy/hierarchySeries.ts
var $d77b025aa58d633c$var$_HierarchyNode = class _HierarchyNode {
    constructor(series, index, datum, size, colorValue, fill, stroke, sumSize, depth, parent, children){
        this.series = series;
        this.index = index;
        this.datum = datum;
        this.size = size;
        this.colorValue = colorValue;
        this.fill = fill;
        this.stroke = stroke;
        this.sumSize = sumSize;
        this.depth = depth;
        this.parent = parent;
        this.children = children;
        this.midPoint = {
            x: 0,
            y: 0
        };
    }
    contains(other) {
        let current = other;
        while(current != null && current.index >= this.index){
            if (current === this) return true;
            current = current.parent;
        }
        return false;
    }
    walk(callback, order = _HierarchyNode.Walk.PreOrder) {
        if (order === _HierarchyNode.Walk.PreOrder) callback(this);
        this.children.forEach((child)=>{
            child.walk(callback, order);
        });
        if (order === _HierarchyNode.Walk.PostOrder) callback(this);
    }
    *[Symbol.iterator]() {
        yield this;
        for (const child of this.children)yield* $d77b025aa58d633c$var$__yieldStar(child);
    }
};
$d77b025aa58d633c$var$_HierarchyNode.Walk = {
    PreOrder: 0,
    PostOrder: 1
};
var $d77b025aa58d633c$var$HierarchyNode = $d77b025aa58d633c$var$_HierarchyNode;
var $d77b025aa58d633c$var$HierarchySeries = class extends $d77b025aa58d633c$var$Series {
    constructor(moduleCtx){
        super({
            moduleCtx: moduleCtx,
            pickModes: [
                0 /* EXACT_SHAPE_MATCH */ 
            ],
            contentGroupVirtual: false
        });
        this.rootNode = new $d77b025aa58d633c$var$HierarchyNode(this, 0, void 0, 0, void 0, void 0, void 0, 0, void 0, void 0, []);
        this.colorDomain = [
            0,
            0
        ];
        this.maxDepth = 0;
        this.animationState = new $d77b025aa58d633c$var$StateMachine("empty", {
            empty: {
                update: {
                    target: "ready",
                    action: (data)=>this.animateEmptyUpdateReady(data)
                },
                reset: "empty",
                skip: "ready"
            },
            ready: {
                updateData: "waiting",
                clear: "clearing",
                highlight: (data)=>this.animateReadyHighlight(data),
                resize: (data)=>this.animateReadyResize(data),
                reset: "empty",
                skip: "ready"
            },
            waiting: {
                update: {
                    target: "ready",
                    action: (data)=>this.animateWaitingUpdateReady(data)
                },
                reset: "empty",
                skip: "ready"
            },
            clearing: {
                update: {
                    target: "empty",
                    action: (data)=>this.animateClearingUpdateEmpty(data)
                },
                reset: "empty",
                skip: "ready"
            }
        }, ()=>this.checkProcessedDataAnimatable());
    }
    resetAnimation(phase) {
        if (phase === "initial") this.animationState.transition("reset");
        else if (phase === "ready") this.animationState.transition("skip");
    }
    processData() {
        return $d77b025aa58d633c$var$__async(this, null, function*() {
            var _a, _b;
            const { childrenKey: childrenKey, sizeKey: sizeKey, colorKey: colorKey, fills: fills, strokes: strokes, colorRange: colorRange } = this.properties;
            let index = 0;
            const getIndex = ()=>{
                index += 1;
                return index;
            };
            let maxDepth = 0;
            let minColor = Infinity;
            let maxColor = -Infinity;
            const colors = new Array(((_b = (_a = this.data) == null ? void 0 : _a.length) != null ? _b : 0) + 1).fill(void 0);
            const createNode = (datum, parent)=>{
                const nodeIndex = getIndex();
                const depth = parent.depth != null ? parent.depth + 1 : 0;
                const children = childrenKey != null ? datum[childrenKey] : void 0;
                const isLeaf = children == null || children.length === 0;
                let size = sizeKey != null ? datum[sizeKey] : void 0;
                if (Number.isFinite(size)) size = Math.max(size, 0);
                else size = isLeaf ? 1 : 0;
                const sumSize = size;
                maxDepth = Math.max(maxDepth, depth);
                const color = colorKey != null ? datum[colorKey] : void 0;
                if (typeof color === "number") {
                    colors[nodeIndex] = color;
                    minColor = Math.min(minColor, color);
                    maxColor = Math.max(maxColor, color);
                }
                return appendChildren(new $d77b025aa58d633c$var$HierarchyNode(this, nodeIndex, datum, size, color, void 0, void 0, sumSize, depth, parent, []), children);
            };
            const appendChildren = (node, data)=>{
                data == null || data.forEach((datum)=>{
                    const child = createNode(datum, node);
                    node.children.push(child);
                    node.sumSize += child.sumSize;
                });
                return node;
            };
            const rootNode = appendChildren(new $d77b025aa58d633c$var$HierarchyNode(this, 0, void 0, 0, void 0, void 0, void 0, 0, void 0, void 0, []), this.data);
            const colorDomain = [
                minColor,
                maxColor
            ];
            let colorScale;
            if (colorRange != null && Number.isFinite(minColor) && Number.isFinite(maxColor)) {
                colorScale = new $d77b025aa58d633c$var$ColorScale();
                colorScale.domain = colorDomain;
                colorScale.range = colorRange;
                colorScale.update();
            }
            rootNode.children.forEach((child, childIndex)=>{
                child.walk((node)=>{
                    let fill;
                    const color = colors[node.index];
                    if (color != null) fill = colorScale == null ? void 0 : colorScale.convert(color);
                    fill != null ? fill : fill = fills == null ? void 0 : fills[childIndex % fills.length];
                    node.fill = fill;
                    node.stroke = colorScale == null ? strokes == null ? void 0 : strokes[childIndex % strokes.length] : "rgba(0, 0, 0, 0.2)";
                });
            });
            this.rootNode = rootNode;
            this.maxDepth = maxDepth;
            this.colorDomain = colorDomain;
        });
    }
    update(_0) {
        return $d77b025aa58d633c$var$__async(this, arguments, function*({ seriesRect: seriesRect }) {
            yield this.updateSelections();
            yield this.updateNodes();
            const animationData = this.getAnimationData();
            const resize = this.checkResize(seriesRect);
            if (resize) this.animationState.transition("resize", animationData);
            this.animationState.transition("update", animationData);
        });
    }
    resetAllAnimation(data) {
        var _a;
        const datum = (_a = this.animationResetFns) == null ? void 0 : _a.datum;
        this.ctx.animationManager.stopByAnimationGroupId(this.id);
        if (datum != null) $d77b025aa58d633c$var$resetMotion(data.datumSelections, datum);
    }
    animateEmptyUpdateReady(data) {
        this.ctx.animationManager.skipCurrentBatch();
        this.resetAllAnimation(data);
    }
    animateWaitingUpdateReady(data) {
        this.ctx.animationManager.skipCurrentBatch();
        this.resetAllAnimation(data);
    }
    animateReadyHighlight(data) {
        var _a;
        const datum = (_a = this.animationResetFns) == null ? void 0 : _a.datum;
        if (datum != null) $d77b025aa58d633c$var$resetMotion([
            data
        ], datum);
    }
    animateReadyResize(data) {
        this.resetAllAnimation(data);
    }
    animateClearingUpdateEmpty(data) {
        this.ctx.animationManager.skipCurrentBatch();
        this.resetAllAnimation(data);
    }
    animationTransitionClear() {
        this.animationState.transition("clear", this.getAnimationData());
    }
    getAnimationData() {
        const animationData = {
            datumSelections: [
                this.groupSelection
            ]
        };
        return animationData;
    }
    isProcessedDataAnimatable() {
        return true;
    }
    checkProcessedDataAnimatable() {
        if (!this.isProcessedDataAnimatable()) this.ctx.animationManager.skipCurrentBatch();
    }
    getLabelData() {
        return [];
    }
    getSeriesDomain() {
        return [
            NaN,
            NaN
        ];
    }
    getLegendData(legendType) {
        const { colorKey: colorKey, colorName: colorName, colorRange: colorRange, visible: visible } = this.properties;
        return legendType === "gradient" && colorKey != null && colorRange != null ? [
            {
                legendType: "gradient",
                enabled: visible,
                seriesId: this.id,
                colorName: colorName,
                colorRange: colorRange,
                colorDomain: this.colorDomain
            }
        ] : [];
    }
    getDatumIdFromData(node) {
        return `${node.index}`;
    }
    getDatumId(node) {
        return this.getDatumIdFromData(node);
    }
};
// packages/ag-charts-community/src/chart/series/hierarchy/hierarchySeriesProperties.ts
var $d77b025aa58d633c$var$HierarchySeriesProperties = class extends $d77b025aa58d633c$var$SeriesProperties {
    constructor(){
        super(...arguments);
        this.childrenKey = "children";
        this.fills = Object.values($d77b025aa58d633c$var$DEFAULT_FILLS);
        this.strokes = Object.values($d77b025aa58d633c$var$DEFAULT_STROKES);
    }
};
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING)
], $d77b025aa58d633c$var$HierarchySeriesProperties.prototype, "childrenKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$HierarchySeriesProperties.prototype, "sizeKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$HierarchySeriesProperties.prototype, "colorKey", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$STRING, {
        optional: true
    })
], $d77b025aa58d633c$var$HierarchySeriesProperties.prototype, "colorName", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$COLOR_STRING_ARRAY)
], $d77b025aa58d633c$var$HierarchySeriesProperties.prototype, "fills", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$COLOR_STRING_ARRAY)
], $d77b025aa58d633c$var$HierarchySeriesProperties.prototype, "strokes", 2);
$d77b025aa58d633c$var$__decorateClass([
    $d77b025aa58d633c$var$Validate($d77b025aa58d633c$var$COLOR_STRING_ARRAY, {
        optional: true
    })
], $d77b025aa58d633c$var$HierarchySeriesProperties.prototype, "colorRange", 2);
// packages/ag-charts-community/src/chart/series/topology/lonLatBbox.ts
var $d77b025aa58d633c$var$LonLatBBox = class {
    constructor(lon0, lat0, lon1, lat1){
        this.lon0 = lon0;
        this.lat0 = lat0;
        this.lon1 = lon1;
        this.lat1 = lat1;
    }
    merge(other) {
        this.lon0 = Math.min(this.lon0, other.lon0);
        this.lat0 = Math.min(this.lat0, other.lat0);
        this.lon1 = Math.max(this.lon1, other.lon1);
        this.lat1 = Math.max(this.lat1, other.lat1);
    }
};
// packages/ag-charts-community/src/chart/legendDatum.ts
var $d77b025aa58d633c$var$__FORCE_MODULE_DETECTION2 = 0;

});


parcelRegister("lmFrL", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "isStyledComponent", () => $f8dbcd8598db1f0b$export$7ba318d8d2f06c76);
$parcel$export(module.exports, "version", () => $f8dbcd8598db1f0b$export$83d89fbfd8236492);
$parcel$export(module.exports, "StyleSheetContext", () => $f8dbcd8598db1f0b$export$8c190ef828af4c86);
$parcel$export(module.exports, "StyleSheetConsumer", () => $f8dbcd8598db1f0b$export$91317688fc694efa);
$parcel$export(module.exports, "StyleSheetManager", () => $f8dbcd8598db1f0b$export$a473771da2f0ff7c);
$parcel$export(module.exports, "css", () => $f8dbcd8598db1f0b$export$dbf350e5966cf602);
$parcel$export(module.exports, "ThemeContext", () => $f8dbcd8598db1f0b$export$2c657da244d00bd6);
$parcel$export(module.exports, "ThemeConsumer", () => $f8dbcd8598db1f0b$export$b631efc24e9d5e2f);
$parcel$export(module.exports, "ThemeProvider", () => $f8dbcd8598db1f0b$export$d8964aec282183a3);
$parcel$export(module.exports, "createGlobalStyle", () => $f8dbcd8598db1f0b$export$f0f03736edb61697);
$parcel$export(module.exports, "keyframes", () => $f8dbcd8598db1f0b$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ServerStyleSheet", () => $f8dbcd8598db1f0b$export$ae8c7d15c8b89a20);
$parcel$export(module.exports, "withTheme", () => $f8dbcd8598db1f0b$export$e8748c6a27b910dc);
$parcel$export(module.exports, "useTheme", () => $f8dbcd8598db1f0b$export$93d4e7f90805808f);
$parcel$export(module.exports, "__PRIVATE__", () => $f8dbcd8598db1f0b$export$5c87cfe6c475f500);
$parcel$export(module.exports, "default", () => $f8dbcd8598db1f0b$export$2e2bcd8739ae039);

var $4jPKB = parcelRequire("4jPKB");

var $acw62 = parcelRequire("acw62");

var $i5C3F = parcelRequire("i5C3F");

var $demXJ = parcelRequire("demXJ");

var $iDSBG = parcelRequire("iDSBG");

var $7dGEo = parcelRequire("7dGEo");

var $9ORqK = parcelRequire("9ORqK");

var $hPtJY = parcelRequire("hPtJY");
function $f8dbcd8598db1f0b$var$v() {
    return ($f8dbcd8598db1f0b$var$v = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }).apply(this, arguments);
}
var $f8dbcd8598db1f0b$var$g = function(e, t) {
    for(var n = [
        e[0]
    ], r = 0, o = t.length; r < o; r += 1)n.push(t[r], e[r + 1]);
    return n;
}, $f8dbcd8598db1f0b$var$S = function(t) {
    return null !== t && "object" == typeof t && "[object Object]" === (t.toString ? t.toString() : Object.prototype.toString.call(t)) && !(0, $4jPKB.typeOf)(t);
}, $f8dbcd8598db1f0b$var$w = Object.freeze([]), $f8dbcd8598db1f0b$var$E = Object.freeze({});
function $f8dbcd8598db1f0b$var$b(e) {
    return "function" == typeof e;
}
function $f8dbcd8598db1f0b$var$_(e) {
    return (0, e.displayName) || e.name || "Component";
}
function $f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e) {
    return e && "string" == typeof e.styledComponentId;
}
var $f8dbcd8598db1f0b$var$A = ("undefined" != typeof $hPtJY && undefined, "data-styled"), $f8dbcd8598db1f0b$export$83d89fbfd8236492 = "5.3.3", $f8dbcd8598db1f0b$var$I = "undefined" != typeof window && "HTMLElement" in window, $f8dbcd8598db1f0b$var$P = Boolean("boolean" == typeof SC_DISABLE_SPEEDY ? SC_DISABLE_SPEEDY : (typeof $hPtJY, typeof $hPtJY, false)), $f8dbcd8598db1f0b$var$O = {}, $f8dbcd8598db1f0b$var$R = {};
function $f8dbcd8598db1f0b$var$D() {
    for(var e = arguments.length <= 0 ? void 0 : arguments[0], t = [], n = 1, r = arguments.length; n < r; n += 1)t.push(n < 0 || arguments.length <= n ? void 0 : arguments[n]);
    return t.forEach(function(t) {
        e = e.replace(/%[a-z]/, t);
    }), e;
}
function $f8dbcd8598db1f0b$var$j(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    throw new Error("An error occurred. See https://git.io/JUIaE#" + e + " for more information." + (n.length > 0 ? " Args: " + n.join(", ") : ""));
}
var $f8dbcd8598db1f0b$var$T = function() {
    function e(e) {
        this.groupSizes = new Uint32Array(512), this.length = 512, this.tag = e;
    }
    var t = e.prototype;
    return t.indexOfGroup = function(e) {
        for(var t = 0, n = 0; n < e; n++)t += this.groupSizes[n];
        return t;
    }, t.insertRules = function(e, t) {
        if (e >= this.groupSizes.length) {
            for(var n = this.groupSizes, r = n.length, o = r; e >= o;)(o <<= 1) < 0 && $f8dbcd8598db1f0b$var$j(16, "" + e);
            this.groupSizes = new Uint32Array(o), this.groupSizes.set(n), this.length = o;
            for(var s = r; s < o; s++)this.groupSizes[s] = 0;
        }
        for(var i = this.indexOfGroup(e + 1), a = 0, c = t.length; a < c; a++)this.tag.insertRule(i, t[a]) && (this.groupSizes[e]++, i++);
    }, t.clearGroup = function(e) {
        if (e < this.length) {
            var t = this.groupSizes[e], n = this.indexOfGroup(e), r = n + t;
            this.groupSizes[e] = 0;
            for(var o = n; o < r; o++)this.tag.deleteRule(n);
        }
    }, t.getGroup = function(e) {
        var t = "";
        if (e >= this.length || 0 === this.groupSizes[e]) return t;
        for(var n = this.groupSizes[e], r = this.indexOfGroup(e), o = r + n, s = r; s < o; s++)t += this.tag.getRule(s) + "/*!sc*/\n";
        return t;
    }, e;
}(), $f8dbcd8598db1f0b$var$x = new Map, $f8dbcd8598db1f0b$var$k = new Map, $f8dbcd8598db1f0b$var$V = 1, $f8dbcd8598db1f0b$var$B = function(e) {
    if ($f8dbcd8598db1f0b$var$x.has(e)) return $f8dbcd8598db1f0b$var$x.get(e);
    for(; $f8dbcd8598db1f0b$var$k.has($f8dbcd8598db1f0b$var$V);)$f8dbcd8598db1f0b$var$V++;
    var t = $f8dbcd8598db1f0b$var$V++;
    return $f8dbcd8598db1f0b$var$x.set(e, t), $f8dbcd8598db1f0b$var$k.set(t, e), t;
}, $f8dbcd8598db1f0b$var$z = function(e) {
    return $f8dbcd8598db1f0b$var$k.get(e);
}, $f8dbcd8598db1f0b$var$M = function(e, t) {
    t >= $f8dbcd8598db1f0b$var$V && ($f8dbcd8598db1f0b$var$V = t + 1), $f8dbcd8598db1f0b$var$x.set(e, t), $f8dbcd8598db1f0b$var$k.set(t, e);
}, $f8dbcd8598db1f0b$var$G = "style[" + $f8dbcd8598db1f0b$var$A + '][data-styled-version="5.3.3"]', $f8dbcd8598db1f0b$var$L = new RegExp("^" + $f8dbcd8598db1f0b$var$A + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), $f8dbcd8598db1f0b$var$F = function(e, t, n) {
    for(var r, o = n.split(","), s = 0, i = o.length; s < i; s++)(r = o[s]) && e.registerName(t, r);
}, $f8dbcd8598db1f0b$var$Y = function(e, t) {
    for(var n = (t.textContent || "").split("/*!sc*/\n"), r = [], o = 0, s = n.length; o < s; o++){
        var i = n[o].trim();
        if (i) {
            var a = i.match($f8dbcd8598db1f0b$var$L);
            if (a) {
                var c = 0 | parseInt(a[1], 10), u = a[2];
                0 !== c && ($f8dbcd8598db1f0b$var$M(u, c), $f8dbcd8598db1f0b$var$F(e, u, a[3]), e.getTag().insertRules(c, r)), r.length = 0;
            } else r.push(i);
        }
    }
}, $f8dbcd8598db1f0b$var$q = function() {
    return "undefined" != typeof window && void 0 !== window.__webpack_nonce__ ? window.__webpack_nonce__ : null;
}, $f8dbcd8598db1f0b$var$H = function(e) {
    var t = document.head, n = e || t, r = document.createElement("style"), o = function(e) {
        for(var t = e.childNodes, n = t.length; n >= 0; n--){
            var r = t[n];
            if (r && 1 === r.nodeType && r.hasAttribute($f8dbcd8598db1f0b$var$A)) return r;
        }
    }(n), s = void 0 !== o ? o.nextSibling : null;
    r.setAttribute($f8dbcd8598db1f0b$var$A, "active"), r.setAttribute("data-styled-version", "5.3.3");
    var i = $f8dbcd8598db1f0b$var$q();
    return i && r.setAttribute("nonce", i), n.insertBefore(r, s), r;
}, $f8dbcd8598db1f0b$var$$ = function() {
    function e(e) {
        var t = this.element = $f8dbcd8598db1f0b$var$H(e);
        t.appendChild(document.createTextNode("")), this.sheet = function(e) {
            if (e.sheet) return e.sheet;
            for(var t = document.styleSheets, n = 0, r = t.length; n < r; n++){
                var o = t[n];
                if (o.ownerNode === e) return o;
            }
            $f8dbcd8598db1f0b$var$j(17);
        }(t), this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        try {
            return this.sheet.insertRule(t, e), this.length++, !0;
        } catch (e) {
            return !1;
        }
    }, t.deleteRule = function(e) {
        this.sheet.deleteRule(e), this.length--;
    }, t.getRule = function(e) {
        var t = this.sheet.cssRules[e];
        return void 0 !== t && "string" == typeof t.cssText ? t.cssText : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$W = function() {
    function e(e) {
        var t = this.element = $f8dbcd8598db1f0b$var$H(e);
        this.nodes = t.childNodes, this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        if (e <= this.length && e >= 0) {
            var n = document.createTextNode(t), r = this.nodes[e];
            return this.element.insertBefore(n, r || null), this.length++, !0;
        }
        return !1;
    }, t.deleteRule = function(e) {
        this.element.removeChild(this.nodes[e]), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.nodes[e].textContent : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$U = function() {
    function e(e) {
        this.rules = [], this.length = 0;
    }
    var t = e.prototype;
    return t.insertRule = function(e, t) {
        return e <= this.length && (this.rules.splice(e, 0, t), this.length++, !0);
    }, t.deleteRule = function(e) {
        this.rules.splice(e, 1), this.length--;
    }, t.getRule = function(e) {
        return e < this.length ? this.rules[e] : "";
    }, e;
}(), $f8dbcd8598db1f0b$var$J = $f8dbcd8598db1f0b$var$I, $f8dbcd8598db1f0b$var$X = {
    isServer: !$f8dbcd8598db1f0b$var$I,
    useCSSOMInjection: !$f8dbcd8598db1f0b$var$P
}, $f8dbcd8598db1f0b$var$Z = function() {
    function e(e, t, n) {
        void 0 === e && (e = $f8dbcd8598db1f0b$var$E), void 0 === t && (t = {}), this.options = $f8dbcd8598db1f0b$var$v({}, $f8dbcd8598db1f0b$var$X, {}, e), this.gs = t, this.names = new Map(n), this.server = !!e.isServer, !this.server && $f8dbcd8598db1f0b$var$I && $f8dbcd8598db1f0b$var$J && ($f8dbcd8598db1f0b$var$J = !1, function(e) {
            for(var t = document.querySelectorAll($f8dbcd8598db1f0b$var$G), n = 0, r = t.length; n < r; n++){
                var o = t[n];
                o && "active" !== o.getAttribute($f8dbcd8598db1f0b$var$A) && ($f8dbcd8598db1f0b$var$Y(e, o), o.parentNode && o.parentNode.removeChild(o));
            }
        }(this));
    }
    e.registerId = function(e) {
        return $f8dbcd8598db1f0b$var$B(e);
    };
    var t = e.prototype;
    return t.reconstructWithOptions = function(t, n) {
        return void 0 === n && (n = !0), new e($f8dbcd8598db1f0b$var$v({}, this.options, {}, t), this.gs, n && this.names || void 0);
    }, t.allocateGSInstance = function(e) {
        return this.gs[e] = (this.gs[e] || 0) + 1;
    }, t.getTag = function() {
        var e, t, n, r, o;
        return this.tag || (this.tag = (n = (t = this.options).isServer, r = t.useCSSOMInjection, o = t.target, e = n ? new $f8dbcd8598db1f0b$var$U(o) : r ? new $f8dbcd8598db1f0b$var$$(o) : new $f8dbcd8598db1f0b$var$W(o), new $f8dbcd8598db1f0b$var$T(e)));
    }, t.hasNameForId = function(e, t) {
        return this.names.has(e) && this.names.get(e).has(t);
    }, t.registerName = function(e, t) {
        if ($f8dbcd8598db1f0b$var$B(e), this.names.has(e)) this.names.get(e).add(t);
        else {
            var n = new Set;
            n.add(t), this.names.set(e, n);
        }
    }, t.insertRules = function(e, t, n) {
        this.registerName(e, t), this.getTag().insertRules($f8dbcd8598db1f0b$var$B(e), n);
    }, t.clearNames = function(e) {
        this.names.has(e) && this.names.get(e).clear();
    }, t.clearRules = function(e) {
        this.getTag().clearGroup($f8dbcd8598db1f0b$var$B(e)), this.clearNames(e);
    }, t.clearTag = function() {
        this.tag = void 0;
    }, t.toString = function() {
        return function(e) {
            for(var t = e.getTag(), n = t.length, r = "", o = 0; o < n; o++){
                var s = $f8dbcd8598db1f0b$var$z(o);
                if (void 0 !== s) {
                    var i = e.names.get(s), a = t.getGroup(o);
                    if (i && a && i.size) {
                        var c = $f8dbcd8598db1f0b$var$A + ".g" + o + '[id="' + s + '"]', u = "";
                        void 0 !== i && i.forEach(function(e) {
                            e.length > 0 && (u += e + ",");
                        }), r += "" + a + c + '{content:"' + u + '"}/*!sc*/\n';
                    }
                }
            }
            return r;
        }(this);
    }, e;
}(), $f8dbcd8598db1f0b$var$K = /(a)(d)/gi, $f8dbcd8598db1f0b$var$Q = function(e) {
    return String.fromCharCode(e + (e > 25 ? 39 : 97));
};
function $f8dbcd8598db1f0b$var$ee(e) {
    var t, n = "";
    for(t = Math.abs(e); t > 52; t = t / 52 | 0)n = $f8dbcd8598db1f0b$var$Q(t % 52) + n;
    return ($f8dbcd8598db1f0b$var$Q(t % 52) + n).replace($f8dbcd8598db1f0b$var$K, "$1-$2");
}
var $f8dbcd8598db1f0b$var$te = function(e, t) {
    for(var n = t.length; n;)e = 33 * e ^ t.charCodeAt(--n);
    return e;
}, $f8dbcd8598db1f0b$var$ne = function(e) {
    return $f8dbcd8598db1f0b$var$te(5381, e);
};
function $f8dbcd8598db1f0b$var$re(e) {
    for(var t = 0; t < e.length; t += 1){
        var n = e[t];
        if ($f8dbcd8598db1f0b$var$b(n) && !$f8dbcd8598db1f0b$export$7ba318d8d2f06c76(n)) return !1;
    }
    return !0;
}
var $f8dbcd8598db1f0b$var$oe = $f8dbcd8598db1f0b$var$ne("5.3.3"), $f8dbcd8598db1f0b$var$se = function() {
    function e(e, t, n) {
        this.rules = e, this.staticRulesId = "", this.isStatic = (void 0 === n || n.isStatic) && $f8dbcd8598db1f0b$var$re(e), this.componentId = t, this.baseHash = $f8dbcd8598db1f0b$var$te($f8dbcd8598db1f0b$var$oe, t), this.baseStyle = n, $f8dbcd8598db1f0b$var$Z.registerId(t);
    }
    return e.prototype.generateAndInjectStyles = function(e, t, n) {
        var r = this.componentId, o = [];
        if (this.baseStyle && o.push(this.baseStyle.generateAndInjectStyles(e, t, n)), this.isStatic && !n.hash) {
            if (this.staticRulesId && t.hasNameForId(r, this.staticRulesId)) o.push(this.staticRulesId);
            else {
                var s = $f8dbcd8598db1f0b$var$Ne(this.rules, e, t, n).join(""), i = $f8dbcd8598db1f0b$var$ee($f8dbcd8598db1f0b$var$te(this.baseHash, s) >>> 0);
                if (!t.hasNameForId(r, i)) {
                    var a = n(s, "." + i, void 0, r);
                    t.insertRules(r, i, a);
                }
                o.push(i), this.staticRulesId = i;
            }
        } else {
            for(var c = this.rules.length, u = $f8dbcd8598db1f0b$var$te(this.baseHash, n.hash), l = "", d = 0; d < c; d++){
                var h = this.rules[d];
                if ("string" == typeof h) l += h;
                else if (h) {
                    var p = $f8dbcd8598db1f0b$var$Ne(h, e, t, n), f = Array.isArray(p) ? p.join("") : p;
                    u = $f8dbcd8598db1f0b$var$te(u, f + d), l += f;
                }
            }
            if (l) {
                var m = $f8dbcd8598db1f0b$var$ee(u >>> 0);
                if (!t.hasNameForId(r, m)) {
                    var y = n(l, "." + m, void 0, r);
                    t.insertRules(r, m, y);
                }
                o.push(m);
            }
        }
        return o.join(" ");
    }, e;
}(), $f8dbcd8598db1f0b$var$ie = /^\s*\/\/.*$/gm, $f8dbcd8598db1f0b$var$ae = [
    ":",
    "[",
    ".",
    "#"
];
function $f8dbcd8598db1f0b$var$ce(e) {
    var t, n, r, o, s = void 0 === e ? $f8dbcd8598db1f0b$var$E : e, i = s.options, a = void 0 === i ? $f8dbcd8598db1f0b$var$E : i, c = s.plugins, u = void 0 === c ? $f8dbcd8598db1f0b$var$w : c, l = new (0, $demXJ.default)(a), d = [], h = function(e) {
        function t(t) {
            if (t) try {
                e(t + "}");
            } catch (e) {}
        }
        return function(n, r, o, s, i, a, c, u, l, d) {
            switch(n){
                case 1:
                    if (0 === l && 64 === r.charCodeAt(0)) return e(r + ";"), "";
                    break;
                case 2:
                    if (0 === u) return r + "/*|*/";
                    break;
                case 3:
                    switch(u){
                        case 102:
                        case 112:
                            return e(o[0] + r), "";
                        default:
                            return r + (0 === d ? "/*|*/" : "");
                    }
                case -2:
                    r.split("/*|*/}").forEach(t);
            }
        };
    }(function(e) {
        d.push(e);
    }), f = function(e, r, s) {
        return 0 === r && -1 !== $f8dbcd8598db1f0b$var$ae.indexOf(s[n.length]) || s.match(o) ? e : "." + t;
    };
    function m(e, s, i, a) {
        void 0 === a && (a = "&");
        var c = e.replace($f8dbcd8598db1f0b$var$ie, ""), u = s && i ? i + " " + s + " { " + c + " }" : c;
        return t = a, n = s, r = new RegExp("\\" + n + "\\b", "g"), o = new RegExp("(\\" + n + "\\b){2,}"), l(i || !s ? "" : s, u);
    }
    return l.use([].concat(u, [
        function(e, t, o) {
            2 === e && o.length && o[0].lastIndexOf(n) > 0 && (o[0] = o[0].replace(r, f));
        },
        h,
        function(e) {
            if (-2 === e) {
                var t = d;
                return d = [], t;
            }
        }
    ])), m.hash = u.length ? u.reduce(function(e, t) {
        return t.name || $f8dbcd8598db1f0b$var$j(15), $f8dbcd8598db1f0b$var$te(e, t.name);
    }, 5381).toString() : "", m;
}
var $f8dbcd8598db1f0b$export$8c190ef828af4c86 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(), $f8dbcd8598db1f0b$export$91317688fc694efa = $f8dbcd8598db1f0b$export$8c190ef828af4c86.Consumer, $f8dbcd8598db1f0b$var$de = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(), $f8dbcd8598db1f0b$var$he = ($f8dbcd8598db1f0b$var$de.Consumer, new $f8dbcd8598db1f0b$var$Z), $f8dbcd8598db1f0b$var$pe = $f8dbcd8598db1f0b$var$ce();
function $f8dbcd8598db1f0b$var$fe() {
    return (0, $acw62.useContext)($f8dbcd8598db1f0b$export$8c190ef828af4c86) || $f8dbcd8598db1f0b$var$he;
}
function $f8dbcd8598db1f0b$var$me() {
    return (0, $acw62.useContext)($f8dbcd8598db1f0b$var$de) || $f8dbcd8598db1f0b$var$pe;
}
function $f8dbcd8598db1f0b$export$a473771da2f0ff7c(e) {
    var t = (0, $acw62.useState)(e.stylisPlugins), n = t[0], s = t[1], c = $f8dbcd8598db1f0b$var$fe(), u = (0, $acw62.useMemo)(function() {
        var t = c;
        return e.sheet ? t = e.sheet : e.target && (t = t.reconstructWithOptions({
            target: e.target
        }, !1)), e.disableCSSOMInjection && (t = t.reconstructWithOptions({
            useCSSOMInjection: !1
        })), t;
    }, [
        e.disableCSSOMInjection,
        e.sheet,
        e.target
    ]), l = (0, $acw62.useMemo)(function() {
        return $f8dbcd8598db1f0b$var$ce({
            options: {
                prefix: !e.disableVendorPrefixes
            },
            plugins: n
        });
    }, [
        e.disableVendorPrefixes,
        n
    ]);
    return (0, $acw62.useEffect)(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($i5C3F)))(n, e.stylisPlugins) || s(e.stylisPlugins);
    }, [
        e.stylisPlugins
    ]), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$8c190ef828af4c86.Provider, {
        value: u
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$var$de.Provider, {
        value: l
    }, (0, e.children)));
}
var $f8dbcd8598db1f0b$var$ve = function() {
    function e(e, t) {
        var n = this;
        this.inject = function(e, t) {
            void 0 === t && (t = $f8dbcd8598db1f0b$var$pe);
            var r = n.name + t.hash;
            e.hasNameForId(n.id, r) || e.insertRules(n.id, r, t(n.rules, r, "@keyframes"));
        }, this.toString = function() {
            return $f8dbcd8598db1f0b$var$j(12, String(n.name));
        }, this.name = e, this.id = "sc-keyframes-" + e, this.rules = t;
    }
    return e.prototype.getName = function(e) {
        return void 0 === e && (e = $f8dbcd8598db1f0b$var$pe), this.name + e.hash;
    }, e;
}(), $f8dbcd8598db1f0b$var$ge = /([A-Z])/, $f8dbcd8598db1f0b$var$Se = /([A-Z])/g, $f8dbcd8598db1f0b$var$we = /^ms-/, $f8dbcd8598db1f0b$var$Ee = function(e) {
    return "-" + e.toLowerCase();
};
function $f8dbcd8598db1f0b$var$be(e) {
    return $f8dbcd8598db1f0b$var$ge.test(e) ? e.replace($f8dbcd8598db1f0b$var$Se, $f8dbcd8598db1f0b$var$Ee).replace($f8dbcd8598db1f0b$var$we, "-ms-") : e;
}
var $f8dbcd8598db1f0b$var$_e = function(e) {
    return null == e || !1 === e || "" === e;
};
function $f8dbcd8598db1f0b$var$Ne(e, n, r, o) {
    if (Array.isArray(e)) {
        for(var s, i = [], a = 0, c = e.length; a < c; a += 1)"" !== (s = $f8dbcd8598db1f0b$var$Ne(e[a], n, r, o)) && (Array.isArray(s) ? i.push.apply(i, s) : i.push(s));
        return i;
    }
    if ($f8dbcd8598db1f0b$var$_e(e)) return "";
    if ($f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e)) return "." + e.styledComponentId;
    if ($f8dbcd8598db1f0b$var$b(e)) {
        if ("function" != typeof (l = e) || l.prototype && l.prototype.isReactComponent || !n) return e;
        var u = e(n);
        return $f8dbcd8598db1f0b$var$Ne(u, n, r, o);
    }
    var l;
    return e instanceof $f8dbcd8598db1f0b$var$ve ? r ? (e.inject(r, o), e.getName(o)) : e : $f8dbcd8598db1f0b$var$S(e) ? function e(t, n) {
        var r, o, s = [];
        for(var i in t)t.hasOwnProperty(i) && !$f8dbcd8598db1f0b$var$_e(t[i]) && (Array.isArray(t[i]) && t[i].isCss || $f8dbcd8598db1f0b$var$b(t[i]) ? s.push($f8dbcd8598db1f0b$var$be(i) + ":", t[i], ";") : $f8dbcd8598db1f0b$var$S(t[i]) ? s.push.apply(s, e(t[i], i)) : s.push($f8dbcd8598db1f0b$var$be(i) + ": " + (r = i, null == (o = t[i]) || "boolean" == typeof o || "" === o ? "" : "number" != typeof o || 0 === o || r in (0, $iDSBG.default) ? String(o).trim() : o + "px") + ";"));
        return n ? [
            n + " {"
        ].concat(s, [
            "}"
        ]) : s;
    }(e) : e.toString();
}
var $f8dbcd8598db1f0b$var$Ae = function(e) {
    return Array.isArray(e) && (e.isCss = !0), e;
};
function $f8dbcd8598db1f0b$export$dbf350e5966cf602(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    return $f8dbcd8598db1f0b$var$b(e) || $f8dbcd8598db1f0b$var$S(e) ? $f8dbcd8598db1f0b$var$Ae($f8dbcd8598db1f0b$var$Ne($f8dbcd8598db1f0b$var$g($f8dbcd8598db1f0b$var$w, [
        e
    ].concat(n)))) : 0 === n.length && 1 === e.length && "string" == typeof e[0] ? e : $f8dbcd8598db1f0b$var$Ae($f8dbcd8598db1f0b$var$Ne($f8dbcd8598db1f0b$var$g(e, n)));
}
var $f8dbcd8598db1f0b$var$Ie = /invalid hook call/i, $f8dbcd8598db1f0b$var$Pe = new Set, $f8dbcd8598db1f0b$var$Oe = function(e, t) {
    var n, r, o, e1;
}, $f8dbcd8598db1f0b$var$Re = function(e, t, n) {
    return void 0 === n && (n = $f8dbcd8598db1f0b$var$E), e.theme !== n.theme && e.theme || t || n.theme;
}, $f8dbcd8598db1f0b$var$De = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, $f8dbcd8598db1f0b$var$je = /(^-|-$)/g;
function $f8dbcd8598db1f0b$var$Te(e) {
    return e.replace($f8dbcd8598db1f0b$var$De, "-").replace($f8dbcd8598db1f0b$var$je, "");
}
var $f8dbcd8598db1f0b$var$xe = function(e) {
    return $f8dbcd8598db1f0b$var$ee($f8dbcd8598db1f0b$var$ne(e) >>> 0);
};
function $f8dbcd8598db1f0b$var$ke(e) {
    return "string" == typeof e && true;
}
var $f8dbcd8598db1f0b$var$Ve = function(e) {
    return "function" == typeof e || "object" == typeof e && null !== e && !Array.isArray(e);
}, $f8dbcd8598db1f0b$var$Be = function(e) {
    return "__proto__" !== e && "constructor" !== e && "prototype" !== e;
};
function $f8dbcd8598db1f0b$var$ze(e, t, n) {
    var r = e[n];
    $f8dbcd8598db1f0b$var$Ve(t) && $f8dbcd8598db1f0b$var$Ve(r) ? $f8dbcd8598db1f0b$var$Me(r, t) : e[n] = t;
}
function $f8dbcd8598db1f0b$var$Me(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    for(var o = 0, s = n; o < s.length; o++){
        var i = s[o];
        if ($f8dbcd8598db1f0b$var$Ve(i)) for(var a in i)$f8dbcd8598db1f0b$var$Be(a) && $f8dbcd8598db1f0b$var$ze(e, i[a], a);
    }
    return e;
}
var $f8dbcd8598db1f0b$export$2c657da244d00bd6 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(), $f8dbcd8598db1f0b$export$b631efc24e9d5e2f = $f8dbcd8598db1f0b$export$2c657da244d00bd6.Consumer;
function $f8dbcd8598db1f0b$export$d8964aec282183a3(e) {
    var t = (0, $acw62.useContext)($f8dbcd8598db1f0b$export$2c657da244d00bd6), n = (0, $acw62.useMemo)(function() {
        return function(e, t) {
            if (!e) return $f8dbcd8598db1f0b$var$j(14);
            if ($f8dbcd8598db1f0b$var$b(e)) {
                var n = e(t);
                return n;
            }
            return Array.isArray(e) || "object" != typeof e ? $f8dbcd8598db1f0b$var$j(8) : t ? $f8dbcd8598db1f0b$var$v({}, t, {}, e) : e;
        }(e.theme, t);
    }, [
        e.theme,
        t
    ]);
    return e.children ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$2c657da244d00bd6.Provider, {
        value: n
    }, e.children) : null;
}
var $f8dbcd8598db1f0b$var$Ye = {};
function $f8dbcd8598db1f0b$var$qe(e, t, n) {
    var o = $f8dbcd8598db1f0b$export$7ba318d8d2f06c76(e), i = !$f8dbcd8598db1f0b$var$ke(e), a = t.attrs, c = void 0 === a ? $f8dbcd8598db1f0b$var$w : a, d = t.componentId, h = void 0 === d ? function(e, t) {
        var n = "string" != typeof e ? "sc" : $f8dbcd8598db1f0b$var$Te(e);
        $f8dbcd8598db1f0b$var$Ye[n] = ($f8dbcd8598db1f0b$var$Ye[n] || 0) + 1;
        var r = n + "-" + $f8dbcd8598db1f0b$var$xe("5.3.3" + n + $f8dbcd8598db1f0b$var$Ye[n]);
        return t ? t + "-" + r : r;
    }(t.displayName, t.parentComponentId) : d, p = t.displayName, f = void 0 === p ? function(e) {
        return $f8dbcd8598db1f0b$var$ke(e) ? "styled." + e : "Styled(" + $f8dbcd8598db1f0b$var$_(e) + ")";
    }(e) : p, g = t.displayName && t.componentId ? $f8dbcd8598db1f0b$var$Te(t.displayName) + "-" + t.componentId : t.componentId || h, S = o && e.attrs ? Array.prototype.concat(e.attrs, c).filter(Boolean) : c, A = t.shouldForwardProp;
    o && e.shouldForwardProp && (A = t.shouldForwardProp ? function(n, r, o) {
        return e.shouldForwardProp(n, r, o) && t.shouldForwardProp(n, r, o);
    } : e.shouldForwardProp);
    var C, I = new $f8dbcd8598db1f0b$var$se(n, g, o ? e.componentStyle : void 0), P = I.isStatic && 0 === c.length, O = function(e, t) {
        return function(e, t, n, r) {
            var o = e.attrs, i = e.componentStyle, a = e.defaultProps, c = e.foldedComponentIds, d = e.shouldForwardProp, h = e.styledComponentId, p = e.target;
            var f = function(e, t, n) {
                void 0 === e && (e = $f8dbcd8598db1f0b$var$E);
                var r = $f8dbcd8598db1f0b$var$v({}, t, {
                    theme: e
                }), o = {};
                return n.forEach(function(e) {
                    var t, n, s, i = e;
                    for(t in $f8dbcd8598db1f0b$var$b(i) && (i = i(r)), i)r[t] = o[t] = "className" === t ? (n = o[t], s = i[t], n && s ? n + " " + s : n || s) : i[t];
                }), [
                    r,
                    o
                ];
            }($f8dbcd8598db1f0b$var$Re(t, (0, $acw62.useContext)($f8dbcd8598db1f0b$export$2c657da244d00bd6), a) || $f8dbcd8598db1f0b$var$E, t, o), y = f[0], g = f[1], S = function(e, t, n, r) {
                var o = $f8dbcd8598db1f0b$var$fe(), s = $f8dbcd8598db1f0b$var$me(), i = t ? e.generateAndInjectStyles($f8dbcd8598db1f0b$var$E, o, s) : e.generateAndInjectStyles(n, o, s);
                return i;
            }(i, r, y, void 0), w = n, _ = g.$as || t.$as || g.as || t.as || p, N = $f8dbcd8598db1f0b$var$ke(_), A = g !== t ? $f8dbcd8598db1f0b$var$v({}, t, {}, g) : t, C = {};
            for(var I in A)"$" !== I[0] && "as" !== I && ("forwardedAs" === I ? C.as = A[I] : (d ? d(I, (0, $7dGEo.default), _) : !N || (0, $7dGEo.default)(I)) && (C[I] = A[I]));
            return t.style && g.style !== t.style && (C.style = $f8dbcd8598db1f0b$var$v({}, t.style, {}, g.style)), C.className = Array.prototype.concat(c, h, S !== h ? S : null, t.className, g.className).filter(Boolean).join(" "), C.ref = w, (0, $acw62.createElement)(_, C);
        }(C, e, t, P);
    };
    return O.displayName = f, (C = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(O)).attrs = S, C.componentStyle = I, C.displayName = f, C.shouldForwardProp = A, C.foldedComponentIds = o ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : $f8dbcd8598db1f0b$var$w, C.styledComponentId = g, C.target = o ? e.target : e, C.withComponent = function(e) {
        var r = t.componentId, o = function(e, t) {
            if (null == e) return {};
            var n, r, o = {}, s = Object.keys(e);
            for(r = 0; r < s.length; r++)n = s[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
            return o;
        }(t, [
            "componentId"
        ]), s = r && r + "-" + ($f8dbcd8598db1f0b$var$ke(e) ? e : $f8dbcd8598db1f0b$var$Te($f8dbcd8598db1f0b$var$_(e)));
        return $f8dbcd8598db1f0b$var$qe(e, $f8dbcd8598db1f0b$var$v({}, o, {
            attrs: S,
            componentId: s
        }), n);
    }, Object.defineProperty(C, "defaultProps", {
        get: function() {
            return this._foldedDefaultProps;
        },
        set: function(t) {
            this._foldedDefaultProps = o ? $f8dbcd8598db1f0b$var$Me({}, e.defaultProps, t) : t;
        }
    }), C.toString = function() {
        return "." + C.styledComponentId;
    }, i && (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(C, e, {
        attrs: !0,
        componentStyle: !0,
        displayName: !0,
        foldedComponentIds: !0,
        shouldForwardProp: !0,
        styledComponentId: !0,
        target: !0,
        withComponent: !0
    }), C;
}
var $f8dbcd8598db1f0b$var$He = function(e) {
    return function e(t, r, o) {
        if (void 0 === o && (o = $f8dbcd8598db1f0b$var$E), !(0, $4jPKB.isValidElementType)(r)) return $f8dbcd8598db1f0b$var$j(1, String(r));
        var s = function() {
            return t(r, o, $f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, arguments));
        };
        return s.withConfig = function(n) {
            return e(t, r, $f8dbcd8598db1f0b$var$v({}, o, {}, n));
        }, s.attrs = function(n) {
            return e(t, r, $f8dbcd8598db1f0b$var$v({}, o, {
                attrs: Array.prototype.concat(o.attrs, n).filter(Boolean)
            }));
        }, s;
    }($f8dbcd8598db1f0b$var$qe, e);
};
[
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "big",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    "img",
    "input",
    "ins",
    "kbd",
    "keygen",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "marquee",
    "menu",
    "menuitem",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr",
    "circle",
    "clipPath",
    "defs",
    "ellipse",
    "foreignObject",
    "g",
    "image",
    "line",
    "linearGradient",
    "marker",
    "mask",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "stop",
    "svg",
    "text",
    "textPath",
    "tspan"
].forEach(function(e) {
    $f8dbcd8598db1f0b$var$He[e] = $f8dbcd8598db1f0b$var$He(e);
});
var $f8dbcd8598db1f0b$var$$e = function() {
    function e(e, t) {
        this.rules = e, this.componentId = t, this.isStatic = $f8dbcd8598db1f0b$var$re(e), $f8dbcd8598db1f0b$var$Z.registerId(this.componentId + 1);
    }
    var t = e.prototype;
    return t.createStyles = function(e, t, n, r) {
        var o = r($f8dbcd8598db1f0b$var$Ne(this.rules, t, n, r).join(""), ""), s = this.componentId + e;
        n.insertRules(s, s, o);
    }, t.removeStyles = function(e, t) {
        t.clearRules(this.componentId + e);
    }, t.renderStyles = function(e, t, n, r) {
        e > 2 && $f8dbcd8598db1f0b$var$Z.registerId(this.componentId + e), this.removeStyles(e, n), this.createStyles(e, t, n, r);
    }, e;
}();
function $f8dbcd8598db1f0b$export$f0f03736edb61697(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), o = 1; o < t; o++)n[o - 1] = arguments[o];
    var i = $f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)), a = "sc-global-" + $f8dbcd8598db1f0b$var$xe(JSON.stringify(i)), u = new $f8dbcd8598db1f0b$var$$e(i, a);
    function l(e) {
        var t = $f8dbcd8598db1f0b$var$fe(), n = $f8dbcd8598db1f0b$var$me(), o = (0, $acw62.useContext)($f8dbcd8598db1f0b$export$2c657da244d00bd6), l = (0, $acw62.useRef)(t.allocateGSInstance(a)).current;
        return t.server && h(l, e, t, o, n), (0, $acw62.useLayoutEffect)(function() {
            if (!t.server) return h(l, e, t, o, n), function() {
                return u.removeStyles(l, t);
            };
        }, [
            l,
            e,
            t,
            o,
            n
        ]), null;
    }
    function h(e, t, n, r, o) {
        if (u.isStatic) u.renderStyles(e, $f8dbcd8598db1f0b$var$O, n, o);
        else {
            var s = $f8dbcd8598db1f0b$var$v({}, t, {
                theme: $f8dbcd8598db1f0b$var$Re(t, r, l.defaultProps)
            });
            u.renderStyles(e, s, n, o);
        }
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo(l);
}
function $f8dbcd8598db1f0b$export$d25ddfdf17c3ad3e(e) {
    for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)n[r - 1] = arguments[r];
    var o = $f8dbcd8598db1f0b$export$dbf350e5966cf602.apply(void 0, [
        e
    ].concat(n)).join(""), s = $f8dbcd8598db1f0b$var$xe(o);
    return new $f8dbcd8598db1f0b$var$ve(s, o);
}
var $f8dbcd8598db1f0b$export$ae8c7d15c8b89a20 = function() {
    function e() {
        var e = this;
        this._emitSheetCSS = function() {
            var t = e.instance.toString();
            if (!t) return "";
            var n = $f8dbcd8598db1f0b$var$q();
            return "<style " + [
                n && 'nonce="' + n + '"',
                $f8dbcd8598db1f0b$var$A + '="true"',
                'data-styled-version="5.3.3"'
            ].filter(Boolean).join(" ") + ">" + t + "</style>";
        }, this.getStyleTags = function() {
            return e.sealed ? $f8dbcd8598db1f0b$var$j(2) : e._emitSheetCSS();
        }, this.getStyleElement = function() {
            var t;
            if (e.sealed) return $f8dbcd8598db1f0b$var$j(2);
            var n = ((t = {})[$f8dbcd8598db1f0b$var$A] = "", t["data-styled-version"] = "5.3.3", t.dangerouslySetInnerHTML = {
                __html: e.instance.toString()
            }, t), o = $f8dbcd8598db1f0b$var$q();
            return o && (n.nonce = o), [
                (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", $f8dbcd8598db1f0b$var$v({}, n, {
                    key: "sc-0-0"
                }))
            ];
        }, this.seal = function() {
            e.sealed = !0;
        }, this.instance = new $f8dbcd8598db1f0b$var$Z({
            isServer: !0
        }), this.sealed = !1;
    }
    var t = e.prototype;
    return t.collectStyles = function(e) {
        return this.sealed ? $f8dbcd8598db1f0b$var$j(2) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f8dbcd8598db1f0b$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, e);
    }, t.interleaveWithNodeStream = function(e) {
        return $f8dbcd8598db1f0b$var$j(3);
    }, e;
}(), $f8dbcd8598db1f0b$export$e8748c6a27b910dc = function(e) {
    var t = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function(t, n) {
        var o = (0, $acw62.useContext)($f8dbcd8598db1f0b$export$2c657da244d00bd6), i = e.defaultProps, a = $f8dbcd8598db1f0b$var$Re(t, o, i);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(e, $f8dbcd8598db1f0b$var$v({}, t, {
            theme: a,
            ref: n
        }));
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(t, e), t.displayName = "WithTheme(" + $f8dbcd8598db1f0b$var$_(e) + ")", t;
}, $f8dbcd8598db1f0b$export$93d4e7f90805808f = function() {
    return (0, $acw62.useContext)($f8dbcd8598db1f0b$export$2c657da244d00bd6);
}, $f8dbcd8598db1f0b$export$5c87cfe6c475f500 = {
    StyleSheet: $f8dbcd8598db1f0b$var$Z,
    masterSheet: $f8dbcd8598db1f0b$var$he
};
var $f8dbcd8598db1f0b$export$2e2bcd8739ae039 = $f8dbcd8598db1f0b$var$He;

});
parcelRegister("4jPKB", function(module, exports) {
"use strict";

module.exports = (parcelRequire("9cCWX"));

});

parcelRegister("i5C3F", function(module, exports) {
//
module.exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};

});

parcelRegister("demXJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a1e650477d9d52e$export$2e2bcd8739ae039);
function $9a1e650477d9d52e$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = "", p = "", F = "", G = "", C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, "")), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, "").trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ""));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(""), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ""));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + "{" + k + "}";
                                        break;
                                    case 107:
                                        f = f.replace(fa, "$1 $2");
                                        k = f + "{" + k + "}";
                                        k = 1 === w || 2 === w && L("@" + k, 3) ? "@-webkit-" + k + "@" + k : "@" + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ""));
                                }
                                else k = "";
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, "") : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(" ", ":")).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = "\0\0"), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = "";
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += "\0");
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = "";
                                    break;
                                default:
                                    32 !== g && (y = " ");
                            }
                            break;
                        case 0:
                            y = "\\0";
                            break;
                        case 12:
                            y = "\\f";
                            break;
                        case 11:
                            y = "\\v";
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = "\f" + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += "\r");
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = "", b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(",") + "{" + p + "}";
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ":-moz-$1") + p;
                        break;
                    case 112:
                        p = p.replace(Q, "::-webkit-input-$1") + p.replace(Q, "::-moz-$1") + p.replace(Q, ":-ms-input-$1") + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? "" : d[0] + " "; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + " ", h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, "$1" + d.trim());
            case 58:
                return d.trim() + c.replace(F, "$1" + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf("\f")) return c.replace(F, (58 === d.charCodeAt(0) ? "" : "$1") + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ";", m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(":", 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ";";
            return 1 === w || 2 === w && L(b, 1) ? "-webkit-" + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? "-webkit-" + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? "-webkit-" + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? "-webkit-" + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return "-webkit-" + a + a;
            case 978:
                return "-webkit-" + a + "-moz-" + a + a;
            case 1019:
            case 983:
                return "-webkit-" + a + "-moz-" + a + "-ms-" + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return "-webkit-" + a + a;
                if (0 < a.indexOf("image-set(", 11)) return a.replace(ja, "$1-webkit-$2") + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return "-webkit-box-" + a.replace("-grow", "") + "-webkit-" + a + "-ms-" + a.replace("grow", "positive") + a;
                    case 115:
                        return "-webkit-" + a + "-ms-" + a.replace("shrink", "negative") + a;
                    case 98:
                        return "-webkit-" + a + "-ms-" + a.replace("basis", "preferred-size") + a;
                }
                return "-webkit-" + a + "-ms-" + a + a;
            case 964:
                return "-webkit-" + a + "-ms-flex-" + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify");
                return "-webkit-box-pack" + b + "-webkit-" + a + "-ms-flex-pack" + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ":-webkit-") + a.replace(aa, ":-moz-") + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf("-") + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, "tb");
                        break;
                    case 232:
                        b = a.replace(G, "tb-rl");
                        break;
                    case 220:
                        b = a.replace(G, "lr");
                        break;
                    default:
                        return a;
                }
                return "-webkit-" + a + "-ms-" + b + a;
            case 1017:
                if (-1 === a.indexOf("sticky", 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(":", 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, "-webkit-" + b) + ";" + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, "-webkit-" + (102 < m ? "inline-" : "") + "box") + ";" + a.replace(b, "-webkit-" + b) + ";" + a.replace(b, "-ms-" + b + "box") + ";" + a;
                }
                return a + ";";
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace("-items", ""), "-webkit-" + a + "-webkit-box-" + b + "-ms-flex-" + b + a;
                    case 115:
                        return "-webkit-" + a + "-ms-flex-item-" + a.replace(ba, "") + a;
                    default:
                        return "-webkit-" + a + "-ms-flex-line-pack" + a.replace("align-content", "").replace(ba, "") + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(":") + 1)).charCodeAt(0) ? P(d.replace("stretch", "fill-available"), c, e, h).replace(":fill-available", ":stretch") : a.replace(b, "-webkit-" + b) + a.replace(b, "-moz-" + b.replace("fill-", "")) + a;
                break;
            case 962:
                if (a = "-webkit-" + a + (102 === a.charCodeAt(5) ? "-ms-" + a : "") + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf("transform", 10)) return a.substring(0, a.indexOf(";", 27) + 1).replace(ma, "$1-webkit-$2") + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ":" : "{"), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, "$1"), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ";" ? e.replace(oa, " or ($1)").substring(4) : "(" + c + ")";
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ("function" === typeof d) S[A++] = d;
                else if ("object" === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? "function" !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && "string" === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = "";
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = "";
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $9a1e650477d9d52e$export$2e2bcd8739ae039 = $9a1e650477d9d52e$var$stylis_min;

});

parcelRegister("iDSBG", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9263a4c6739b952$export$2e2bcd8739ae039);
var $d9263a4c6739b952$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $d9263a4c6739b952$export$2e2bcd8739ae039 = $d9263a4c6739b952$var$unitlessKeys;

});

parcelRegister("7dGEo", function(module, exports) {

$parcel$export(module.exports, "default", () => $541ad4d15ffa42f6$export$2e2bcd8739ae039);

var $l7O8P = parcelRequire("l7O8P");
var $541ad4d15ffa42f6$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $541ad4d15ffa42f6$var$index = (0, $l7O8P.default)(function(prop) {
    return $541ad4d15ffa42f6$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $541ad4d15ffa42f6$export$2e2bcd8739ae039 = $541ad4d15ffa42f6$var$index;

});
parcelRegister("l7O8P", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6112573aba91cb3$export$2e2bcd8739ae039);
function $f6112573aba91cb3$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $f6112573aba91cb3$export$2e2bcd8739ae039 = $f6112573aba91cb3$var$memoize;

});


parcelRegister("9ORqK", function(module, exports) {
"use strict";

var $4jPKB = parcelRequire("4jPKB");
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    "$$typeof": true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    "$$typeof": true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$4jPKB.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$4jPKB.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($4jPKB.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component["$$typeof"]] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== "string") {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
module.exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;

});

parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});


parcelRegister("gxPgh", function(module, exports) {

$parcel$export(module.exports, "getInstance", () => $0e439ae7301dd858$export$8bedcca5bbd73999);
$parcel$export(module.exports, "warnReactiveCustomComponents", () => $0e439ae7301dd858$export$e83e01bcf62967be);
$parcel$export(module.exports, "AgGridReact", () => $0e439ae7301dd858$export$4074462c5969a5d8);
$parcel$export(module.exports, "ChangeDetectionStrategyType", () => $0e439ae7301dd858$export$40bdec3d7030ca81);
$parcel$export(module.exports, "useGridCellEditor", () => $0e439ae7301dd858$export$70780aa16b46d041);
$parcel$export(module.exports, "useGridDate", () => $0e439ae7301dd858$export$ae0fe569b475a61);
$parcel$export(module.exports, "useGridFilter", () => $0e439ae7301dd858$export$42838275cbf666c4);
$parcel$export(module.exports, "useGridFloatingFilter", () => $0e439ae7301dd858$export$a2cd2617441b4952);
$parcel$export(module.exports, "useGridMenuItem", () => $0e439ae7301dd858$export$bfb597f578b2979b);

var $acw62 = parcelRequire("acw62");

var $jIDNV = parcelRequire("jIDNV");

var $1u0KT = parcelRequire("1u0KT");

var $kZ6Rz = parcelRequire("kZ6Rz");
var $0e439ae7301dd858$var$__defProp = Object.defineProperty;
var $0e439ae7301dd858$var$__defProps = Object.defineProperties;
var $0e439ae7301dd858$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $0e439ae7301dd858$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $0e439ae7301dd858$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $0e439ae7301dd858$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $0e439ae7301dd858$var$__defNormalProp = (obj, key, value)=>key in obj ? $0e439ae7301dd858$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $0e439ae7301dd858$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($0e439ae7301dd858$var$__hasOwnProp.call(b, prop)) $0e439ae7301dd858$var$__defNormalProp(a, prop, b[prop]);
    if ($0e439ae7301dd858$var$__getOwnPropSymbols) {
        for (var prop of $0e439ae7301dd858$var$__getOwnPropSymbols(b))if ($0e439ae7301dd858$var$__propIsEnum.call(b, prop)) $0e439ae7301dd858$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $0e439ae7301dd858$var$__spreadProps = (a, b)=>$0e439ae7301dd858$var$__defProps(a, $0e439ae7301dd858$var$__getOwnPropDescs(b));
var $0e439ae7301dd858$var$CustomContext = (0, $acw62.createContext)({
    setMethods: ()=>{}
});
// packages/ag-grid-react/src/reactUi/customComp/customWrapperComp.tsx
var $0e439ae7301dd858$var$CustomWrapperComp = (params)=>{
    const { initialProps: initialProps, addUpdateCallback: addUpdateCallback, CustomComponentClass: CustomComponentClass, setMethods: setMethods } = params;
    const [props, setProps] = (0, $acw62.useState)(initialProps);
    (0, $acw62.useEffect)(()=>{
        addUpdateCallback((newProps)=>setProps(newProps));
    }, []);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$CustomContext.Provider, {
        value: {
            setMethods: setMethods
        }
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CustomComponentClass, $0e439ae7301dd858$var$__spreadValues({}, props)));
};
var $0e439ae7301dd858$var$customWrapperComp_default = (0, $acw62.memo)($0e439ae7301dd858$var$CustomWrapperComp);
// packages/ag-grid-react/src/shared/keyGenerator.ts
var $0e439ae7301dd858$var$counter = 0;
function $0e439ae7301dd858$var$generateNewKey() {
    return `agPortalKey_${++$0e439ae7301dd858$var$counter}`;
}
var $0e439ae7301dd858$var$ReactComponent = class {
    constructor(reactComponent, portalManager, componentType, suppressFallbackMethods){
        this.portal = null;
        this.oldPortal = null;
        this.reactComponent = reactComponent;
        this.portalManager = portalManager;
        this.componentType = componentType;
        this.suppressFallbackMethods = !!suppressFallbackMethods;
        this.statelessComponent = this.isStateless(this.reactComponent);
        this.key = $0e439ae7301dd858$var$generateNewKey();
        this.portalKey = $0e439ae7301dd858$var$generateNewKey();
        this.instanceCreated = this.isStatelessComponent() ? (0, $jIDNV.AgPromise).resolve(false) : new (0, $jIDNV.AgPromise)((resolve)=>{
            this.resolveInstanceCreated = resolve;
        });
    }
    getGui() {
        return this.eParentElement;
    }
    /** `getGui()` returns the parent element. This returns the actual root element. */ getRootElement() {
        const firstChild = this.eParentElement.firstChild;
        return firstChild;
    }
    destroy() {
        if (this.componentInstance && typeof this.componentInstance.destroy == "function") this.componentInstance.destroy();
        return this.portalManager.destroyPortal(this.portal);
    }
    createParentElement(params) {
        const componentWrappingElement = this.portalManager.getComponentWrappingElement();
        const eParentElement = document.createElement(componentWrappingElement || "div");
        eParentElement.classList.add("ag-react-container");
        params.reactContainer = eParentElement;
        return eParentElement;
    }
    addParentContainerStyleAndClasses() {
        if (!this.componentInstance) return;
        if (this.componentInstance.getReactContainerStyle && this.componentInstance.getReactContainerStyle()) {
            (0, $jIDNV._).warnOnce('Since v31.1 "getReactContainerStyle" is deprecated. Apply styling directly to ".ag-react-container" if needed.');
            Object.assign(this.eParentElement.style, this.componentInstance.getReactContainerStyle());
        }
        if (this.componentInstance.getReactContainerClasses && this.componentInstance.getReactContainerClasses()) {
            (0, $jIDNV._).warnOnce('Since v31.1 "getReactContainerClasses" is deprecated. Apply styling directly to ".ag-react-container" if needed.');
            const parentContainerClasses = this.componentInstance.getReactContainerClasses();
            parentContainerClasses.forEach((className)=>this.eParentElement.classList.add(className));
        }
    }
    statelessComponentRendered() {
        return this.eParentElement.childElementCount > 0 || this.eParentElement.childNodes.length > 0;
    }
    getFrameworkComponentInstance() {
        return this.componentInstance;
    }
    isStatelessComponent() {
        return this.statelessComponent;
    }
    getReactComponentName() {
        return this.reactComponent.name;
    }
    getMemoType() {
        return this.hasSymbol() ? Symbol.for("react.memo") : 60115;
    }
    hasSymbol() {
        return typeof Symbol === "function" && Symbol.for;
    }
    isStateless(Component3) {
        return typeof Component3 === "function" && !(Component3.prototype && Component3.prototype.isReactComponent) || typeof Component3 === "object" && Component3.$$typeof === this.getMemoType();
    }
    hasMethod(name) {
        const frameworkComponentInstance = this.getFrameworkComponentInstance();
        return !!frameworkComponentInstance && frameworkComponentInstance[name] != null || this.fallbackMethodAvailable(name);
    }
    callMethod(name, args) {
        const frameworkComponentInstance = this.getFrameworkComponentInstance();
        if (this.isStatelessComponent()) return this.fallbackMethod(name, !!args && args[0] ? args[0] : {});
        else if (!!!frameworkComponentInstance) {
            setTimeout(()=>this.callMethod(name, args));
            return;
        }
        const method = frameworkComponentInstance[name];
        if (!!method) return method.apply(frameworkComponentInstance, args);
        if (this.fallbackMethodAvailable(name)) return this.fallbackMethod(name, !!args && args[0] ? args[0] : {});
    }
    addMethod(name, callback) {
        this[name] = callback;
    }
    init(params) {
        this.eParentElement = this.createParentElement(params);
        this.params = params;
        this.createOrUpdatePortal(params);
        return new (0, $jIDNV.AgPromise)((resolve)=>this.createReactComponent(resolve));
    }
    createOrUpdatePortal(params) {
        if (!this.isStatelessComponent()) {
            this.ref = (element)=>{
                var _a;
                this.componentInstance = element;
                this.addParentContainerStyleAndClasses();
                (_a = this.resolveInstanceCreated) == null || _a.call(this, true);
                this.resolveInstanceCreated = void 0;
            };
            params.ref = this.ref;
        }
        this.reactElement = this.createElement(this.reactComponent, $0e439ae7301dd858$var$__spreadProps($0e439ae7301dd858$var$__spreadValues({}, params), {
            key: this.key
        }));
        this.portal = (0, $1u0KT.createPortal)(this.reactElement, this.eParentElement, this.portalKey);
    }
    createElement(reactComponent, props) {
        return (0, $acw62.createElement)(reactComponent, props);
    }
    createReactComponent(resolve) {
        this.portalManager.mountReactPortal(this.portal, this, (value)=>{
            resolve(value);
        });
    }
    isNullValue() {
        return this.valueRenderedIsNull(this.params);
    }
    rendered() {
        return this.isStatelessComponent() && this.statelessComponentRendered() || !!(!this.isStatelessComponent() && this.getFrameworkComponentInstance());
    }
    valueRenderedIsNull(params) {
        if (!this.componentType.cellRenderer) return false;
        const originalConsoleError = console.error;
        try {
            console.error = ()=>{};
            const staticMarkup = (0, $kZ6Rz.renderToStaticMarkup)((0, $acw62.createElement)(this.reactComponent, params));
            return staticMarkup === "";
        } catch (ignore) {} finally{
            console.error = originalConsoleError;
        }
        return false;
    }
    /*
  * fallback methods - these will be invoked if a corresponding instance method is not present
  * for example if refresh is called and is not available on the component instance, then refreshComponent on this
  * class will be invoked instead
  *
  * Currently only refresh is supported
  */ refreshComponent(args) {
        this.oldPortal = this.portal;
        this.createOrUpdatePortal(args);
        this.portalManager.updateReactPortal(this.oldPortal, this.portal);
    }
    fallbackMethod(name, params) {
        const method = this[`${name}Component`];
        if (!this.suppressFallbackMethods && !!method) return method.bind(this)(params);
    }
    fallbackMethodAvailable(name) {
        if (this.suppressFallbackMethods) return false;
        const method = this[`${name}Component`];
        return !!method;
    }
};
// packages/ag-grid-react/src/shared/customComp/customComponentWrapper.ts
function $0e439ae7301dd858$var$addOptionalMethods(optionalMethodNames, providedMethods, component) {
    optionalMethodNames.forEach((methodName)=>{
        const providedMethod = providedMethods[methodName];
        if (providedMethod) component[methodName] = providedMethod;
    });
}
var $0e439ae7301dd858$var$CustomComponentWrapper = class extends $0e439ae7301dd858$var$ReactComponent {
    constructor(){
        super(...arguments);
        this.awaitUpdateCallback = new (0, $jIDNV.AgPromise)((resolve)=>{
            this.resolveUpdateCallback = resolve;
        });
        this.wrapperComponent = $0e439ae7301dd858$var$customWrapperComp_default;
    }
    init(params) {
        this.sourceParams = params;
        return super.init(this.getProps());
    }
    addMethod() {}
    getInstance() {
        return this.instanceCreated.then(()=>this.componentInstance);
    }
    getFrameworkComponentInstance() {
        return this;
    }
    createElement(reactComponent, props) {
        return super.createElement(this.wrapperComponent, {
            initialProps: props,
            CustomComponentClass: reactComponent,
            setMethods: (methods)=>this.setMethods(methods),
            addUpdateCallback: (callback)=>{
                this.updateCallback = ()=>{
                    callback(this.getProps());
                    return new (0, $jIDNV.AgPromise)((resolve)=>{
                        setTimeout(()=>{
                            resolve();
                        });
                    });
                };
                this.resolveUpdateCallback();
            }
        });
    }
    setMethods(methods) {
        this.providedMethods = methods;
        $0e439ae7301dd858$var$addOptionalMethods(this.getOptionalMethods(), this.providedMethods, this);
    }
    getOptionalMethods() {
        return [];
    }
    getProps() {
        return $0e439ae7301dd858$var$__spreadProps($0e439ae7301dd858$var$__spreadValues({}, this.sourceParams), {
            key: this.key,
            ref: this.ref
        });
    }
    refreshProps() {
        if (this.updateCallback) return this.updateCallback();
        return new (0, $jIDNV.AgPromise)((resolve)=>this.awaitUpdateCallback.then(()=>{
                this.updateCallback().then(()=>resolve());
            }));
    }
};
// packages/ag-grid-react/src/shared/customComp/dateComponentWrapper.ts
var $0e439ae7301dd858$var$DateComponentWrapper = class extends $0e439ae7301dd858$var$CustomComponentWrapper {
    constructor(){
        super(...arguments);
        this.date = null;
        this.onDateChange = (date)=>this.updateDate(date);
    }
    getDate() {
        return this.date;
    }
    setDate(date) {
        this.date = date;
        this.refreshProps();
    }
    refresh(params) {
        this.sourceParams = params;
        this.refreshProps();
    }
    getOptionalMethods() {
        return [
            "afterGuiAttached",
            "setInputPlaceholder",
            "setInputAriaLabel",
            "setDisabled"
        ];
    }
    updateDate(date) {
        this.setDate(date);
        this.sourceParams.onDateChanged();
    }
    getProps() {
        const props = super.getProps();
        props.date = this.date;
        props.onDateChange = this.onDateChange;
        delete props.onDateChanged;
        return props;
    }
};
// packages/ag-grid-react/src/shared/customComp/filterComponentWrapper.ts
var $0e439ae7301dd858$var$FilterComponentWrapper = class extends $0e439ae7301dd858$var$CustomComponentWrapper {
    constructor(){
        super(...arguments);
        this.model = null;
        this.onModelChange = (model)=>this.updateModel(model);
        this.onUiChange = ()=>this.sourceParams.filterChangedCallback();
    }
    isFilterActive() {
        return this.model != null;
    }
    doesFilterPass(params) {
        return this.providedMethods.doesFilterPass(params);
    }
    getModel() {
        return this.model;
    }
    setModel(model) {
        this.model = model;
        return this.refreshProps();
    }
    refresh(newParams) {
        this.sourceParams = newParams;
        this.refreshProps();
        return true;
    }
    getOptionalMethods() {
        return [
            "afterGuiAttached",
            "afterGuiDetached",
            "onNewRowsLoaded",
            "getModelAsString",
            "onAnyFilterChanged"
        ];
    }
    updateModel(model) {
        this.setModel(model).then(()=>this.sourceParams.filterChangedCallback());
    }
    getProps() {
        const props = super.getProps();
        props.model = this.model;
        props.onModelChange = this.onModelChange;
        props.onUiChange = this.onUiChange;
        delete props.filterChangedCallback;
        delete props.filterModifiedCallback;
        delete props.valueGetter;
        return props;
    }
};
function $0e439ae7301dd858$var$updateFloatingFilterParent(params, model) {
    params.parentFilterInstance((instance)=>{
        (instance.setModel(model) || (0, $jIDNV.AgPromise).resolve()).then(()=>{
            params.filterParams.filterChangedCallback();
        });
    });
}
var $0e439ae7301dd858$var$FloatingFilterComponentProxy = class {
    constructor(floatingFilterParams, refreshProps){
        this.floatingFilterParams = floatingFilterParams;
        this.refreshProps = refreshProps;
        this.model = null;
        this.onModelChange = (model)=>this.updateModel(model);
    }
    getProps() {
        return $0e439ae7301dd858$var$__spreadProps($0e439ae7301dd858$var$__spreadValues({}, this.floatingFilterParams), {
            model: this.model,
            onModelChange: this.onModelChange
        });
    }
    onParentModelChanged(parentModel) {
        this.model = parentModel;
        this.refreshProps();
    }
    refresh(params) {
        this.floatingFilterParams = params;
        this.refreshProps();
    }
    setMethods(methods) {
        $0e439ae7301dd858$var$addOptionalMethods(this.getOptionalMethods(), methods, this);
    }
    getOptionalMethods() {
        return [
            "afterGuiAttached"
        ];
    }
    updateModel(model) {
        this.model = model;
        this.refreshProps();
        $0e439ae7301dd858$var$updateFloatingFilterParent(this.floatingFilterParams, model);
    }
};
// packages/ag-grid-react/src/shared/customComp/floatingFilterComponentWrapper.ts
var $0e439ae7301dd858$var$FloatingFilterComponentWrapper = class extends $0e439ae7301dd858$var$CustomComponentWrapper {
    constructor(){
        super(...arguments);
        this.model = null;
        this.onModelChange = (model)=>this.updateModel(model);
    }
    onParentModelChanged(parentModel) {
        this.model = parentModel;
        this.refreshProps();
    }
    refresh(newParams) {
        this.sourceParams = newParams;
        this.refreshProps();
    }
    getOptionalMethods() {
        return [
            "afterGuiAttached"
        ];
    }
    updateModel(model) {
        this.model = model;
        this.refreshProps();
        $0e439ae7301dd858$var$updateFloatingFilterParent(this.sourceParams, model);
    }
    getProps() {
        const props = super.getProps();
        props.model = this.model;
        props.onModelChange = this.onModelChange;
        return props;
    }
};
// packages/ag-grid-react/src/shared/customComp/loadingOverlayComponentWrapper.ts
var $0e439ae7301dd858$var$LoadingOverlayComponentWrapper = class extends $0e439ae7301dd858$var$CustomComponentWrapper {
    refresh(params) {
        this.sourceParams = params;
        this.refreshProps();
    }
};
// packages/ag-grid-react/src/shared/customComp/menuItemComponentWrapper.ts
var $0e439ae7301dd858$var$MenuItemComponentWrapper = class extends $0e439ae7301dd858$var$CustomComponentWrapper {
    constructor(){
        super(...arguments);
        this.active = false;
        this.expanded = false;
        this.onActiveChange = (active)=>this.updateActive(active);
    }
    setActive(active) {
        this.awaitSetActive(active);
    }
    setExpanded(expanded) {
        this.expanded = expanded;
        this.refreshProps();
    }
    getOptionalMethods() {
        return [
            "select",
            "configureDefaults"
        ];
    }
    awaitSetActive(active) {
        this.active = active;
        return this.refreshProps();
    }
    updateActive(active) {
        const result = this.awaitSetActive(active);
        if (active) result.then(()=>this.sourceParams.onItemActivated());
    }
    getProps() {
        const props = super.getProps();
        props.active = this.active;
        props.expanded = this.expanded;
        props.onActiveChange = this.onActiveChange;
        delete props.onItemActivated;
        return props;
    }
};
// packages/ag-grid-react/src/shared/customComp/noRowsOverlayComponentWrapper.ts
var $0e439ae7301dd858$var$NoRowsOverlayComponentWrapper = class extends $0e439ae7301dd858$var$CustomComponentWrapper {
    refresh(params) {
        this.sourceParams = params;
        this.refreshProps();
    }
};
// packages/ag-grid-react/src/shared/customComp/statusPanelComponentWrapper.ts
var $0e439ae7301dd858$var$StatusPanelComponentWrapper = class extends $0e439ae7301dd858$var$CustomComponentWrapper {
    refresh(params) {
        this.sourceParams = params;
        this.refreshProps();
        return true;
    }
};
// packages/ag-grid-react/src/shared/customComp/toolPanelComponentWrapper.ts
var $0e439ae7301dd858$var$ToolPanelComponentWrapper = class extends $0e439ae7301dd858$var$CustomComponentWrapper {
    constructor(){
        super(...arguments);
        this.onStateChange = (state)=>this.updateState(state);
    }
    refresh(params) {
        this.sourceParams = params;
        this.refreshProps();
        return true;
    }
    getState() {
        return this.state;
    }
    updateState(state) {
        this.state = state;
        this.refreshProps();
        this.sourceParams.onStateUpdated();
    }
    getProps() {
        const props = super.getProps();
        props.state = this.state;
        props.onStateChange = this.onStateChange;
        return props;
    }
};
// packages/ag-grid-react/src/shared/portalManager.ts
var $0e439ae7301dd858$var$_PortalManager = class _PortalManager {
    constructor(refresher, wrappingElement, maxComponentCreationTimeMs){
        this.destroyed = false;
        this.portals = [];
        this.hasPendingPortalUpdate = false;
        this.wrappingElement = wrappingElement ? wrappingElement : "div";
        this.refresher = refresher;
        this.maxComponentCreationTimeMs = maxComponentCreationTimeMs ? maxComponentCreationTimeMs : _PortalManager.MAX_COMPONENT_CREATION_TIME_IN_MS;
    }
    getPortals() {
        return this.portals;
    }
    destroy() {
        this.destroyed = true;
    }
    destroyPortal(portal) {
        this.portals = this.portals.filter((curPortal)=>curPortal !== portal);
        this.batchUpdate();
    }
    getComponentWrappingElement() {
        return this.wrappingElement;
    }
    mountReactPortal(portal, reactComponent, resolve) {
        this.portals = [
            ...this.portals,
            portal
        ];
        this.waitForInstance(reactComponent, resolve);
        this.batchUpdate();
    }
    updateReactPortal(oldPortal, newPortal) {
        this.portals[this.portals.indexOf(oldPortal)] = newPortal;
        this.batchUpdate();
    }
    batchUpdate() {
        if (this.hasPendingPortalUpdate) return;
        setTimeout(()=>{
            if (!this.destroyed) {
                this.refresher();
                this.hasPendingPortalUpdate = false;
            }
        });
        this.hasPendingPortalUpdate = true;
    }
    waitForInstance(reactComponent, resolve, startTime = Date.now()) {
        if (this.destroyed) {
            resolve(null);
            return;
        }
        if (reactComponent.rendered()) resolve(reactComponent);
        else {
            if (Date.now() - startTime >= this.maxComponentCreationTimeMs && !this.hasPendingPortalUpdate) {
                if (reactComponent.isNullValue()) {
                    resolve(reactComponent);
                    return;
                }
                console.error(`AG Grid: React Component '${reactComponent.getReactComponentName()}' not created within ${this.maxComponentCreationTimeMs}ms.`);
                console.error("    If the component is using `forwardRef` but not `useImperativeHandle`, add the following: `useImperativeHandle(ref, () => ({}));`");
                return;
            }
            window.setTimeout(()=>{
                this.waitForInstance(reactComponent, resolve, startTime);
            });
        }
    }
};
$0e439ae7301dd858$var$_PortalManager.MAX_COMPONENT_CREATION_TIME_IN_MS = 1e3;
var $0e439ae7301dd858$var$PortalManager = $0e439ae7301dd858$var$_PortalManager;
var $0e439ae7301dd858$var$BeansContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({});
var $0e439ae7301dd858$var$classesList = (...list)=>{
    const filtered = list.filter((s)=>s != null && s !== "");
    return filtered.join(" ");
};
var $0e439ae7301dd858$var$CssClasses = class _CssClasses {
    constructor(...initialClasses){
        this.classesMap = {};
        initialClasses.forEach((className)=>{
            this.classesMap[className] = true;
        });
    }
    setClass(className, on) {
        const nothingHasChanged = !!this.classesMap[className] == on;
        if (nothingHasChanged) return this;
        const res = new _CssClasses();
        res.classesMap = $0e439ae7301dd858$var$__spreadValues({}, this.classesMap);
        res.classesMap[className] = on;
        return res;
    }
    toString() {
        const res = Object.keys(this.classesMap).filter((key)=>this.classesMap[key]).join(" ");
        return res;
    }
};
var $0e439ae7301dd858$var$isComponentStateless = (Component3)=>{
    const hasSymbol = ()=>typeof Symbol === "function" && Symbol.for;
    const getMemoType = ()=>hasSymbol() ? Symbol.for("react.memo") : 60115;
    return typeof Component3 === "function" && !(Component3.prototype && Component3.prototype.isReactComponent) || typeof Component3 === "object" && Component3.$$typeof === getMemoType();
};
var $0e439ae7301dd858$var$createRootAndFlushSyncAvailable = (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).createRoot != null && (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).flushSync != null;
var $0e439ae7301dd858$var$disableFlushSync = false;
function $0e439ae7301dd858$var$runWithoutFlushSync(func) {
    if (!$0e439ae7301dd858$var$disableFlushSync) setTimeout(()=>$0e439ae7301dd858$var$disableFlushSync = false, 0);
    $0e439ae7301dd858$var$disableFlushSync = true;
    return func();
}
var $0e439ae7301dd858$var$agFlushSync = (useFlushSync, fn)=>{
    if ($0e439ae7301dd858$var$createRootAndFlushSyncAvailable && useFlushSync && !$0e439ae7301dd858$var$disableFlushSync) (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).flushSync(fn);
    else fn();
};
function $0e439ae7301dd858$var$getNextValueIfDifferent(prev, next, maintainOrder) {
    if (next == null || prev == null) return next;
    if (prev === next || next.length === 0 && prev.length === 0) return prev;
    if (maintainOrder || prev.length === 0 && next.length > 0 || prev.length > 0 && next.length === 0) return next;
    const oldValues = [];
    const newValues = [];
    const prevMap = /* @__PURE__ */ new Map();
    const nextMap = /* @__PURE__ */ new Map();
    for(let i = 0; i < next.length; i++){
        const c = next[i];
        nextMap.set(c.getInstanceId(), c);
    }
    for(let i = 0; i < prev.length; i++){
        const c = prev[i];
        prevMap.set(c.getInstanceId(), c);
        if (nextMap.has(c.getInstanceId())) oldValues.push(c);
    }
    for(let i = 0; i < next.length; i++){
        const c = next[i];
        const instanceId = c.getInstanceId();
        if (!prevMap.has(instanceId)) newValues.push(c);
    }
    if (oldValues.length === prev.length && newValues.length === 0) return prev;
    if (oldValues.length === 0 && newValues.length === next.length) return next;
    if (oldValues.length === 0) return newValues;
    if (newValues.length === 0) return oldValues;
    return [
        ...oldValues,
        ...newValues
    ];
}
// packages/ag-grid-react/src/reactUi/jsComp.tsx
var $0e439ae7301dd858$var$showJsComp = (compDetails, context, eParent, ref)=>{
    const doNothing = !compDetails || compDetails.componentFromFramework || context.isDestroyed();
    if (doNothing) return;
    const promise = compDetails.newAgStackInstance();
    if (!promise) return;
    let comp;
    let compGui;
    let destroyed = false;
    promise.then((c)=>{
        if (destroyed) {
            context.destroyBean(c);
            return;
        }
        comp = c;
        compGui = comp.getGui();
        eParent.appendChild(compGui);
        $0e439ae7301dd858$var$setRef(ref, comp);
    });
    return ()=>{
        destroyed = true;
        if (!comp) return;
        if (compGui && compGui.parentElement) compGui.parentElement.removeChild(compGui);
        context.destroyBean(comp);
        if (ref) $0e439ae7301dd858$var$setRef(ref, void 0);
    };
};
var $0e439ae7301dd858$var$setRef = (ref, value)=>{
    if (!ref) return;
    if (ref instanceof Function) {
        const refCallback = ref;
        refCallback(value);
    } else {
        const refObj = ref;
        refObj.current = value;
    }
};
var $0e439ae7301dd858$var$createSyncJsComp = (compDetails)=>{
    const promise = compDetails.newAgStackInstance();
    if (!promise) return;
    return promise.resolveNow(null, (x)=>x);
};
// packages/ag-grid-react/src/reactUi/cellRenderer/groupCellRenderer.tsx
var $0e439ae7301dd858$var$GroupCellRenderer = (0, $acw62.forwardRef)((props, ref)=>{
    var _a;
    const context = (0, $acw62.useContext)($0e439ae7301dd858$var$BeansContext).context;
    const eGui = (0, $acw62.useRef)(null);
    const eValueRef = (0, $acw62.useRef)(null);
    const eCheckboxRef = (0, $acw62.useRef)(null);
    const eExpandedRef = (0, $acw62.useRef)(null);
    const eContractedRef = (0, $acw62.useRef)(null);
    const ctrlRef = (0, $acw62.useRef)();
    const [innerCompDetails, setInnerCompDetails] = (0, $acw62.useState)();
    const [childCount, setChildCount] = (0, $acw62.useState)();
    const [value, setValue] = (0, $acw62.useState)();
    const [cssClasses, setCssClasses] = (0, $acw62.useState)(()=>new $0e439ae7301dd858$var$CssClasses());
    const [expandedCssClasses, setExpandedCssClasses] = (0, $acw62.useState)(()=>new $0e439ae7301dd858$var$CssClasses("ag-hidden"));
    const [contractedCssClasses, setContractedCssClasses] = (0, $acw62.useState)(()=>new $0e439ae7301dd858$var$CssClasses("ag-hidden"));
    const [checkboxCssClasses, setCheckboxCssClasses] = (0, $acw62.useState)(()=>new $0e439ae7301dd858$var$CssClasses("ag-invisible"));
    (0, $acw62.useImperativeHandle)(ref, ()=>{
        return {
            // force new instance when grid tries to refresh
            refresh () {
                return false;
            }
        };
    });
    (0, $acw62.useLayoutEffect)(()=>{
        return $0e439ae7301dd858$var$showJsComp(innerCompDetails, context, eValueRef.current);
    }, [
        innerCompDetails
    ]);
    const setRef2 = (0, $acw62.useCallback)((ref2)=>{
        eGui.current = ref2;
        if (!eGui.current) {
            context.destroyBean(ctrlRef.current);
            ctrlRef.current = null;
            return;
        }
        const compProxy = {
            setInnerRenderer: (details, valueToDisplay)=>{
                setInnerCompDetails(details);
                setValue(valueToDisplay);
            },
            setChildCount: (count)=>setChildCount(count),
            addOrRemoveCssClass: (name, on)=>setCssClasses((prev)=>prev.setClass(name, on)),
            setContractedDisplayed: (displayed)=>setContractedCssClasses((prev)=>prev.setClass("ag-hidden", !displayed)),
            setExpandedDisplayed: (displayed)=>setExpandedCssClasses((prev)=>prev.setClass("ag-hidden", !displayed)),
            setCheckboxVisible: (visible)=>setCheckboxCssClasses((prev)=>prev.setClass("ag-invisible", !visible))
        };
        ctrlRef.current = context.createBean(new (0, $jIDNV.GroupCellRendererCtrl)());
        ctrlRef.current.init(compProxy, eGui.current, eCheckboxRef.current, eExpandedRef.current, eContractedRef.current, $0e439ae7301dd858$var$GroupCellRenderer, props);
    }, []);
    const className = (0, $acw62.useMemo)(()=>`ag-cell-wrapper ${cssClasses.toString()}`, [
        cssClasses
    ]);
    const expandedClassName = (0, $acw62.useMemo)(()=>`ag-group-expanded ${expandedCssClasses.toString()}`, [
        expandedCssClasses
    ]);
    const contractedClassName = (0, $acw62.useMemo)(()=>`ag-group-contracted ${contractedCssClasses.toString()}`, [
        contractedCssClasses
    ]);
    const checkboxClassName = (0, $acw62.useMemo)(()=>`ag-group-checkbox ${checkboxCssClasses.toString()}`, [
        checkboxCssClasses
    ]);
    const useFwRenderer = innerCompDetails && innerCompDetails.componentFromFramework;
    const FwRenderer = useFwRenderer ? innerCompDetails.componentClass : void 0;
    const useValue = innerCompDetails == null && value != null;
    const escapedValue = (0, $jIDNV._).escapeString(value, true);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", $0e439ae7301dd858$var$__spreadValues({
        className: className,
        ref: setRef2
    }, !props.colDef ? {
        role: (_a = ctrlRef.current) == null ? void 0 : _a.getCellAriaRole()
    } : {}), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: expandedClassName,
        ref: eExpandedRef
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: contractedClassName,
        ref: eContractedRef
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: checkboxClassName,
        ref: eCheckboxRef
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "ag-group-value",
        ref: eValueRef
    }, useValue && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, escapedValue), useFwRenderer && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(FwRenderer, $0e439ae7301dd858$var$__spreadValues({}, innerCompDetails.params))), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "ag-group-child-count"
    }, childCount));
});
var $0e439ae7301dd858$var$groupCellRenderer_default = $0e439ae7301dd858$var$GroupCellRenderer;
var $0e439ae7301dd858$var$HeaderCellComp = (props)=>{
    const { ctrl: ctrl } = props;
    const isAlive = ctrl.isAlive();
    const { context: context } = (0, $acw62.useContext)($0e439ae7301dd858$var$BeansContext);
    const colId = isAlive ? ctrl.getColId() : void 0;
    const [userCompDetails, setUserCompDetails] = (0, $acw62.useState)();
    const eGui = (0, $acw62.useRef)(null);
    const eResize = (0, $acw62.useRef)(null);
    const eHeaderCompWrapper = (0, $acw62.useRef)(null);
    const userCompRef = (0, $acw62.useRef)();
    let cssClassManager = (0, $acw62.useRef)();
    if (isAlive && !cssClassManager.current) cssClassManager.current = new (0, $jIDNV.CssClassManager)(()=>eGui.current);
    const setRef2 = (0, $acw62.useCallback)((e)=>{
        var _a;
        eGui.current = e;
        if (!eGui.current || !isAlive) return;
        const compProxy = {
            setWidth: (width)=>{
                if (eGui.current) eGui.current.style.width = width;
            },
            addOrRemoveCssClass: (name, on)=>cssClassManager.current.addOrRemoveCssClass(name, on),
            setAriaSort: (sort)=>{
                if (eGui.current) sort ? (0, $jIDNV._).setAriaSort(eGui.current, sort) : (0, $jIDNV._).removeAriaSort(eGui.current);
            },
            setUserCompDetails: (compDetails)=>setUserCompDetails(compDetails),
            getUserCompInstance: ()=>userCompRef.current || void 0
        };
        ctrl.setComp(compProxy, eGui.current, eResize.current, eHeaderCompWrapper.current);
        const selectAllGui = ctrl.getSelectAllGui();
        (_a = eResize.current) == null || _a.insertAdjacentElement("afterend", selectAllGui);
    }, []);
    (0, $acw62.useLayoutEffect)(()=>$0e439ae7301dd858$var$showJsComp(userCompDetails, context, eHeaderCompWrapper.current, userCompRef), [
        userCompDetails
    ]);
    (0, $acw62.useEffect)(()=>{
        ctrl.setDragSource(eGui.current);
    }, [
        userCompDetails
    ]);
    const userCompStateless = (0, $acw62.useMemo)(()=>{
        const res = (userCompDetails == null ? void 0 : userCompDetails.componentFromFramework) && $0e439ae7301dd858$var$isComponentStateless(userCompDetails.componentClass);
        return !!res;
    }, [
        userCompDetails
    ]);
    const reactUserComp = userCompDetails && userCompDetails.componentFromFramework;
    const UserCompClass = userCompDetails && userCompDetails.componentClass;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: setRef2,
        className: "ag-header-cell",
        "col-id": colId,
        role: "columnheader"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: eResize,
        className: "ag-header-cell-resize",
        role: "presentation"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: eHeaderCompWrapper,
        className: "ag-header-cell-comp-wrapper",
        role: "presentation"
    }, reactUserComp && userCompStateless && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(UserCompClass, $0e439ae7301dd858$var$__spreadValues({}, userCompDetails.params)), reactUserComp && !userCompStateless && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(UserCompClass, $0e439ae7301dd858$var$__spreadProps($0e439ae7301dd858$var$__spreadValues({}, userCompDetails.params), {
        ref: userCompRef
    }))));
};
var $0e439ae7301dd858$var$headerCellComp_default = (0, $acw62.memo)($0e439ae7301dd858$var$HeaderCellComp);
var $0e439ae7301dd858$var$HeaderGroupCellComp = (props)=>{
    const { context: context } = (0, $acw62.useContext)($0e439ae7301dd858$var$BeansContext);
    const { ctrl: ctrl } = props;
    const [cssClasses, setCssClasses] = (0, $acw62.useState)(()=>new $0e439ae7301dd858$var$CssClasses());
    const [cssResizableClasses, setResizableCssClasses] = (0, $acw62.useState)(()=>new $0e439ae7301dd858$var$CssClasses());
    const [resizableAriaHidden, setResizableAriaHidden] = (0, $acw62.useState)("false");
    const [ariaExpanded, setAriaExpanded] = (0, $acw62.useState)();
    const [userCompDetails, setUserCompDetails] = (0, $acw62.useState)();
    const colId = (0, $acw62.useMemo)(()=>ctrl.getColId(), []);
    const eGui = (0, $acw62.useRef)(null);
    const eResize = (0, $acw62.useRef)(null);
    const userCompRef = (0, $acw62.useRef)();
    const setRef2 = (0, $acw62.useCallback)((e)=>{
        eGui.current = e;
        if (!eGui.current) return;
        const compProxy = {
            setWidth: (width)=>{
                if (eGui.current) eGui.current.style.width = width;
            },
            addOrRemoveCssClass: (name, on)=>setCssClasses((prev)=>prev.setClass(name, on)),
            setUserCompDetails: (compDetails)=>setUserCompDetails(compDetails),
            setResizableDisplayed: (displayed)=>{
                setResizableCssClasses((prev)=>prev.setClass("ag-hidden", !displayed));
                setResizableAriaHidden(!displayed ? "true" : "false");
            },
            setAriaExpanded: (expanded)=>setAriaExpanded(expanded),
            getUserCompInstance: ()=>userCompRef.current || void 0
        };
        ctrl.setComp(compProxy, eGui.current, eResize.current);
    }, []);
    (0, $acw62.useLayoutEffect)(()=>$0e439ae7301dd858$var$showJsComp(userCompDetails, context, eGui.current), [
        userCompDetails
    ]);
    (0, $acw62.useEffect)(()=>{
        if (eGui.current) ctrl.setDragSource(eGui.current);
    }, [
        userCompDetails
    ]);
    const userCompStateless = (0, $acw62.useMemo)(()=>{
        const res = (userCompDetails == null ? void 0 : userCompDetails.componentFromFramework) && $0e439ae7301dd858$var$isComponentStateless(userCompDetails.componentClass);
        return !!res;
    }, [
        userCompDetails
    ]);
    const className = (0, $acw62.useMemo)(()=>"ag-header-group-cell " + cssClasses.toString(), [
        cssClasses
    ]);
    const resizableClassName = (0, $acw62.useMemo)(()=>"ag-header-cell-resize " + cssResizableClasses.toString(), [
        cssResizableClasses
    ]);
    const reactUserComp = userCompDetails && userCompDetails.componentFromFramework;
    const UserCompClass = userCompDetails && userCompDetails.componentClass;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: setRef2,
        className: className,
        "col-id": colId,
        role: "columnheader",
        "aria-expanded": ariaExpanded
    }, reactUserComp && userCompStateless && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(UserCompClass, $0e439ae7301dd858$var$__spreadValues({}, userCompDetails.params)), reactUserComp && !userCompStateless && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(UserCompClass, $0e439ae7301dd858$var$__spreadProps($0e439ae7301dd858$var$__spreadValues({}, userCompDetails.params), {
        ref: userCompRef
    })), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: eResize,
        "aria-hidden": resizableAriaHidden,
        className: resizableClassName
    }));
};
var $0e439ae7301dd858$var$headerGroupCellComp_default = (0, $acw62.memo)($0e439ae7301dd858$var$HeaderGroupCellComp);
function $0e439ae7301dd858$export$8bedcca5bbd73999(wrapperComponent, callback) {
    var _a, _b;
    const promise = (_b = (_a = wrapperComponent == null ? void 0 : wrapperComponent.getInstance) == null ? void 0 : _a.call(wrapperComponent)) != null ? _b : (0, $jIDNV.AgPromise).resolve(void 0);
    promise.then((comp)=>callback(comp));
}
function $0e439ae7301dd858$export$e83e01bcf62967be() {
    (0, $jIDNV._).warnOnce("Using custom components without `reactiveCustomComponents = true` is deprecated.");
}
// packages/ag-grid-react/src/reactUi/header/headerFilterCellComp.tsx
var $0e439ae7301dd858$var$HeaderFilterCellComp = (props)=>{
    const { context: context, gos: gos } = (0, $acw62.useContext)($0e439ae7301dd858$var$BeansContext);
    const [cssClasses, setCssClasses] = (0, $acw62.useState)(()=>new $0e439ae7301dd858$var$CssClasses("ag-header-cell", "ag-floating-filter"));
    const [cssBodyClasses, setBodyCssClasses] = (0, $acw62.useState)(()=>new $0e439ae7301dd858$var$CssClasses());
    const [cssButtonWrapperClasses, setButtonWrapperCssClasses] = (0, $acw62.useState)(()=>new $0e439ae7301dd858$var$CssClasses("ag-floating-filter-button", "ag-hidden"));
    const [buttonWrapperAriaHidden, setButtonWrapperAriaHidden] = (0, $acw62.useState)("false");
    const [userCompDetails, setUserCompDetails] = (0, $acw62.useState)();
    const [renderKey, setRenderKey] = (0, $acw62.useState)(1);
    const eGui = (0, $acw62.useRef)(null);
    const eFloatingFilterBody = (0, $acw62.useRef)(null);
    const eButtonWrapper = (0, $acw62.useRef)(null);
    const eButtonShowMainFilter = (0, $acw62.useRef)(null);
    const userCompResolve = (0, $acw62.useRef)();
    const userCompPromise = (0, $acw62.useRef)();
    const userCompRef = (value)=>{
        if (value == null) return;
        userCompResolve.current && userCompResolve.current(value);
    };
    const { ctrl: ctrl } = props;
    const setRef2 = (0, $acw62.useCallback)((e)=>{
        eGui.current = e;
        if (!eGui.current) return;
        userCompPromise.current = new (0, $jIDNV.AgPromise)((resolve)=>{
            userCompResolve.current = resolve;
        });
        const compProxy = {
            addOrRemoveCssClass: (name, on)=>setCssClasses((prev)=>prev.setClass(name, on)),
            addOrRemoveBodyCssClass: (name, on)=>setBodyCssClasses((prev)=>prev.setClass(name, on)),
            setButtonWrapperDisplayed: (displayed)=>{
                setButtonWrapperCssClasses((prev)=>prev.setClass("ag-hidden", !displayed));
                setButtonWrapperAriaHidden(!displayed ? "true" : "false");
            },
            setWidth: (width)=>{
                if (eGui.current) eGui.current.style.width = width;
            },
            setCompDetails: (compDetails)=>setUserCompDetails(compDetails),
            getFloatingFilterComp: ()=>userCompPromise.current ? userCompPromise.current : null,
            setMenuIcon: (eIcon)=>{
                var _a;
                return (_a = eButtonShowMainFilter.current) == null ? void 0 : _a.appendChild(eIcon);
            }
        };
        ctrl.setComp(compProxy, eGui.current, eButtonShowMainFilter.current, eFloatingFilterBody.current);
    }, []);
    (0, $acw62.useLayoutEffect)(()=>$0e439ae7301dd858$var$showJsComp(userCompDetails, context, eFloatingFilterBody.current, userCompRef), [
        userCompDetails
    ]);
    const className = (0, $acw62.useMemo)(()=>cssClasses.toString(), [
        cssClasses
    ]);
    const bodyClassName = (0, $acw62.useMemo)(()=>cssBodyClasses.toString(), [
        cssBodyClasses
    ]);
    const buttonWrapperClassName = (0, $acw62.useMemo)(()=>cssButtonWrapperClasses.toString(), [
        cssButtonWrapperClasses
    ]);
    const userCompStateless = (0, $acw62.useMemo)(()=>{
        const res = userCompDetails && userCompDetails.componentFromFramework && $0e439ae7301dd858$var$isComponentStateless(userCompDetails.componentClass);
        return !!res;
    }, [
        userCompDetails
    ]);
    const reactiveCustomComponents = (0, $acw62.useMemo)(()=>gos.get("reactiveCustomComponents"), []);
    const floatingFilterCompProxy = (0, $acw62.useMemo)(()=>{
        if (userCompDetails) {
            if (reactiveCustomComponents) {
                const compProxy = new $0e439ae7301dd858$var$FloatingFilterComponentProxy(userCompDetails.params, ()=>setRenderKey((prev)=>prev + 1));
                userCompRef(compProxy);
                return compProxy;
            } else if (userCompDetails.componentFromFramework) $0e439ae7301dd858$export$e83e01bcf62967be();
        }
        return void 0;
    }, [
        userCompDetails
    ]);
    const floatingFilterProps = floatingFilterCompProxy == null ? void 0 : floatingFilterCompProxy.getProps();
    const reactUserComp = userCompDetails && userCompDetails.componentFromFramework;
    const UserCompClass = userCompDetails && userCompDetails.componentClass;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: setRef2,
        className: className,
        role: "gridcell"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: eFloatingFilterBody,
        className: bodyClassName,
        role: "presentation"
    }, reactUserComp && !reactiveCustomComponents && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(UserCompClass, $0e439ae7301dd858$var$__spreadProps($0e439ae7301dd858$var$__spreadValues({}, userCompDetails.params), {
        ref: userCompStateless ? ()=>{} : userCompRef
    })), reactUserComp && reactiveCustomComponents && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$CustomContext.Provider, {
        value: {
            setMethods: (methods)=>floatingFilterCompProxy.setMethods(methods)
        }
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(UserCompClass, $0e439ae7301dd858$var$__spreadValues({}, floatingFilterProps)))), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: eButtonWrapper,
        "aria-hidden": buttonWrapperAriaHidden,
        className: buttonWrapperClassName,
        role: "presentation"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        ref: eButtonShowMainFilter,
        type: "button",
        className: "ag-button ag-floating-filter-button-button",
        tabIndex: -1
    })));
};
var $0e439ae7301dd858$var$headerFilterCellComp_default = (0, $acw62.memo)($0e439ae7301dd858$var$HeaderFilterCellComp);
// packages/ag-grid-react/src/reactUi/header/headerRowComp.tsx
var $0e439ae7301dd858$var$HeaderRowComp = (props)=>{
    const { ctrl: ctrl } = props;
    const { topOffset: topOffset, rowHeight: rowHeight } = (0, $acw62.useMemo)(()=>ctrl.getTopAndHeight(), []);
    const ariaRowIndex = ctrl.getAriaRowIndex();
    const className = ctrl.getHeaderRowClass();
    const [height, setHeight] = (0, $acw62.useState)(()=>rowHeight + "px");
    const [top, setTop] = (0, $acw62.useState)(()=>topOffset + "px");
    const cellCtrlsRef = (0, $acw62.useRef)(null);
    const prevCellCtrlsRef = (0, $acw62.useRef)(null);
    const [cellCtrls, setCellCtrls] = (0, $acw62.useState)(()=>ctrl.getHeaderCtrls());
    const eGui = (0, $acw62.useRef)(null);
    const setRef2 = (0, $acw62.useCallback)((e)=>{
        eGui.current = e;
        if (!e) return;
        const compProxy = {
            setHeight: (height2)=>setHeight(height2),
            setTop: (top2)=>setTop(top2),
            setHeaderCtrls: (ctrls, forceOrder, afterScroll)=>{
                prevCellCtrlsRef.current = cellCtrlsRef.current;
                cellCtrlsRef.current = ctrls;
                const next = $0e439ae7301dd858$var$getNextValueIfDifferent(prevCellCtrlsRef.current, ctrls, forceOrder);
                if (next !== prevCellCtrlsRef.current) $0e439ae7301dd858$var$agFlushSync(afterScroll, ()=>setCellCtrls(next));
            },
            setWidth: (width)=>{
                if (eGui.current) eGui.current.style.width = width;
            }
        };
        ctrl.setComp(compProxy, false);
    }, []);
    const style = (0, $acw62.useMemo)(()=>({
            height: height,
            top: top
        }), [
        height,
        top
    ]);
    const createCellJsx = (0, $acw62.useCallback)((cellCtrl)=>{
        switch(ctrl.getType()){
            case (0, $jIDNV.HeaderRowType).COLUMN_GROUP:
                return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$headerGroupCellComp_default, {
                    ctrl: cellCtrl,
                    key: cellCtrl.getInstanceId()
                });
            case (0, $jIDNV.HeaderRowType).FLOATING_FILTER:
                return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$headerFilterCellComp_default, {
                    ctrl: cellCtrl,
                    key: cellCtrl.getInstanceId()
                });
            default:
                return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$headerCellComp_default, {
                    ctrl: cellCtrl,
                    key: cellCtrl.getInstanceId()
                });
        }
    }, []);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: setRef2,
        className: className,
        role: "row",
        style: style,
        "aria-rowindex": ariaRowIndex
    }, cellCtrls.map(createCellJsx));
};
var $0e439ae7301dd858$var$headerRowComp_default = (0, $acw62.memo)($0e439ae7301dd858$var$HeaderRowComp);
// packages/ag-grid-react/src/reactUi/header/headerRowContainerComp.tsx
var $0e439ae7301dd858$var$HeaderRowContainerComp = (props)=>{
    const [displayed, setDisplayed] = (0, $acw62.useState)(true);
    const [headerRowCtrls, setHeaderRowCtrls] = (0, $acw62.useState)([]);
    const { context: context } = (0, $acw62.useContext)($0e439ae7301dd858$var$BeansContext);
    const eGui = (0, $acw62.useRef)(null);
    const eCenterContainer = (0, $acw62.useRef)(null);
    const headerRowCtrlRef = (0, $acw62.useRef)(null);
    const pinnedLeft = props.pinned === "left";
    const pinnedRight = props.pinned === "right";
    const centre = !pinnedLeft && !pinnedRight;
    const setRef2 = (0, $acw62.useCallback)((e)=>{
        eGui.current = e;
        if (!eGui.current) {
            context.destroyBean(headerRowCtrlRef.current);
            headerRowCtrlRef.current = null;
            return;
        }
        const compProxy = {
            setDisplayed: setDisplayed,
            setCtrls: (ctrls)=>setHeaderRowCtrls(ctrls),
            // centre only
            setCenterWidth: (width)=>{
                if (eCenterContainer.current) eCenterContainer.current.style.width = width;
            },
            setViewportScrollLeft: (left)=>{
                if (eGui.current) eGui.current.scrollLeft = left;
            },
            // pinned only
            setPinnedContainerWidth: (width)=>{
                if (eGui.current) {
                    eGui.current.style.width = width;
                    eGui.current.style.minWidth = width;
                    eGui.current.style.maxWidth = width;
                }
            }
        };
        headerRowCtrlRef.current = context.createBean(new (0, $jIDNV.HeaderRowContainerCtrl)(props.pinned));
        headerRowCtrlRef.current.setComp(compProxy, eGui.current);
    }, []);
    const className = !displayed ? "ag-hidden" : "";
    const insertRowsJsx = ()=>headerRowCtrls.map((ctrl)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$headerRowComp_default, {
                ctrl: ctrl,
                key: ctrl.getInstanceId()
            }));
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, pinnedLeft && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: setRef2,
        className: "ag-pinned-left-header " + className,
        "aria-hidden": !displayed,
        role: "rowgroup"
    }, insertRowsJsx()), pinnedRight && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: setRef2,
        className: "ag-pinned-right-header " + className,
        "aria-hidden": !displayed,
        role: "rowgroup"
    }, insertRowsJsx()), centre && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: setRef2,
        className: "ag-header-viewport " + className,
        role: "presentation"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: eCenterContainer,
        className: "ag-header-container",
        role: "rowgroup"
    }, insertRowsJsx())));
};
var $0e439ae7301dd858$var$headerRowContainerComp_default = (0, $acw62.memo)($0e439ae7301dd858$var$HeaderRowContainerComp);
// packages/ag-grid-react/src/reactUi/header/gridHeaderComp.tsx
var $0e439ae7301dd858$var$GridHeaderComp = ()=>{
    const [cssClasses, setCssClasses] = (0, $acw62.useState)(()=>new $0e439ae7301dd858$var$CssClasses());
    const [height, setHeight] = (0, $acw62.useState)();
    const { context: context } = (0, $acw62.useContext)($0e439ae7301dd858$var$BeansContext);
    const eGui = (0, $acw62.useRef)(null);
    const gridCtrlRef = (0, $acw62.useRef)(null);
    const setRef2 = (0, $acw62.useCallback)((e)=>{
        eGui.current = e;
        if (!e) {
            context.destroyBean(gridCtrlRef.current);
            gridCtrlRef.current = null;
            return;
        }
        const compProxy = {
            addOrRemoveCssClass: (name, on)=>setCssClasses((prev)=>prev.setClass(name, on)),
            setHeightAndMinHeight: (height2)=>setHeight(height2)
        };
        gridCtrlRef.current = context.createBean(new (0, $jIDNV.GridHeaderCtrl)());
        gridCtrlRef.current.setComp(compProxy, eGui.current, eGui.current);
    }, []);
    const className = (0, $acw62.useMemo)(()=>{
        let res = cssClasses.toString();
        return "ag-header " + res;
    }, [
        cssClasses
    ]);
    const style = (0, $acw62.useMemo)(()=>({
            height: height,
            minHeight: height
        }), [
        height
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: setRef2,
        className: className,
        style: style,
        role: "presentation"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$headerRowContainerComp_default, {
        pinned: "left"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$headerRowContainerComp_default, {
        pinned: null
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$headerRowContainerComp_default, {
        pinned: "right"
    }));
};
var $0e439ae7301dd858$var$gridHeaderComp_default = (0, $acw62.memo)($0e439ae7301dd858$var$GridHeaderComp);
var $0e439ae7301dd858$var$useReactCommentEffect = (comment, eForCommentRef)=>{
    (0, $acw62.useEffect)(()=>{
        const eForComment = eForCommentRef.current;
        if (eForComment) {
            const eParent = eForComment.parentElement;
            if (eParent) {
                const eComment = document.createComment(comment);
                eParent.insertBefore(eComment, eForComment);
                return ()=>{
                    eParent.removeChild(eComment);
                };
            }
        }
    }, [
        comment
    ]);
};
var $0e439ae7301dd858$var$reactComment_default = $0e439ae7301dd858$var$useReactCommentEffect;
var $0e439ae7301dd858$var$useEffectOnce = (effect)=>{
    const effectFn = (0, $acw62.useRef)(effect);
    const destroyFn = (0, $acw62.useRef)();
    const effectCalled = (0, $acw62.useRef)(false);
    const rendered = (0, $acw62.useRef)(false);
    const [, setVal] = (0, $acw62.useState)(0);
    if (effectCalled.current) rendered.current = true;
    (0, $acw62.useEffect)(()=>{
        if (!effectCalled.current) {
            destroyFn.current = effectFn.current();
            effectCalled.current = true;
        }
        setVal((val)=>val + 1);
        return ()=>{
            if (!rendered.current) return;
            if (destroyFn.current) destroyFn.current();
        };
    }, []);
};
// packages/ag-grid-react/src/reactUi/cells/popupEditorComp.tsx
var $0e439ae7301dd858$var$PopupEditorComp = (props)=>{
    const [popupEditorWrapper, setPopupEditorWrapper] = (0, $acw62.useState)();
    const { context: context, popupService: popupService, localeService: localeService, gos: gos } = (0, $acw62.useContext)($0e439ae7301dd858$var$BeansContext);
    $0e439ae7301dd858$var$useEffectOnce(()=>{
        const { editDetails: editDetails, cellCtrl: cellCtrl, eParentCell: eParentCell } = props;
        const { compDetails: compDetails } = editDetails;
        const useModelPopup = gos.get("stopEditingWhenCellsLoseFocus");
        const wrapper = context.createBean(new (0, $jIDNV.PopupEditorWrapper)(compDetails.params));
        const ePopupGui = wrapper.getGui();
        if (props.jsChildComp) {
            const eChildGui = props.jsChildComp.getGui();
            if (eChildGui) ePopupGui.appendChild(eChildGui);
        }
        const positionParams = {
            column: cellCtrl.getColumn(),
            rowNode: cellCtrl.getRowNode(),
            type: "popupCellEditor",
            eventSource: eParentCell,
            ePopup: ePopupGui,
            position: editDetails.popupPosition,
            keepWithinBounds: true
        };
        const positionCallback = popupService.positionPopupByComponent.bind(popupService, positionParams);
        const translate = localeService.getLocaleTextFunc();
        const addPopupRes = popupService.addPopup({
            modal: useModelPopup,
            eChild: ePopupGui,
            closeOnEsc: true,
            closedCallback: ()=>{
                cellCtrl.onPopupEditorClosed();
            },
            anchorToElement: eParentCell,
            positionCallback: positionCallback,
            ariaLabel: translate("ariaLabelCellEditor", "Cell Editor")
        });
        const hideEditorPopup = addPopupRes ? addPopupRes.hideFunc : void 0;
        setPopupEditorWrapper(wrapper);
        props.jsChildComp && props.jsChildComp.afterGuiAttached && props.jsChildComp.afterGuiAttached();
        return ()=>{
            if (hideEditorPopup != null) hideEditorPopup();
            context.destroyBean(wrapper);
        };
    });
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, popupEditorWrapper && props.wrappedContent && (0, $1u0KT.createPortal)(props.wrappedContent, popupEditorWrapper.getGui()));
};
var $0e439ae7301dd858$var$popupEditorComp_default = (0, $acw62.memo)($0e439ae7301dd858$var$PopupEditorComp);
var $0e439ae7301dd858$var$useJsCellRenderer = (showDetails, showTools, eCellValue, cellValueVersion, jsCellRendererRef, eGui)=>{
    const { context: context } = (0, $acw62.useContext)($0e439ae7301dd858$var$BeansContext);
    const destroyCellRenderer = (0, $acw62.useCallback)(()=>{
        const comp = jsCellRendererRef.current;
        if (!comp) return;
        const compGui = comp.getGui();
        if (compGui && compGui.parentElement) compGui.parentElement.removeChild(compGui);
        context.destroyBean(comp);
        jsCellRendererRef.current = void 0;
    }, []);
    (0, $acw62.useEffect)(()=>{
        const showValue = showDetails != null;
        const jsCompDetails = showDetails && showDetails.compDetails && !showDetails.compDetails.componentFromFramework;
        const waitingForToolsSetup = showTools && eCellValue == null;
        const showComp = showValue && jsCompDetails && !waitingForToolsSetup;
        if (!showComp) {
            destroyCellRenderer();
            return;
        }
        const compDetails = showDetails.compDetails;
        if (jsCellRendererRef.current) {
            const comp2 = jsCellRendererRef.current;
            const attemptRefresh = comp2.refresh != null && showDetails.force == false;
            const refreshResult = attemptRefresh ? comp2.refresh(compDetails.params) : false;
            const refreshWorked = refreshResult === true || refreshResult === void 0;
            if (refreshWorked) return;
            destroyCellRenderer();
        }
        const promise = compDetails.newAgStackInstance();
        if (!promise) return;
        const comp = promise.resolveNow(null, (x)=>x);
        if (!comp) return;
        const compGui = comp.getGui();
        if (!compGui) return;
        const parent = showTools ? eCellValue : eGui.current;
        parent.appendChild(compGui);
        jsCellRendererRef.current = comp;
    }, [
        showDetails,
        showTools,
        cellValueVersion
    ]);
    (0, $acw62.useEffect)(()=>{
        return destroyCellRenderer;
    }, []);
};
var $0e439ae7301dd858$var$showJsRenderer_default = $0e439ae7301dd858$var$useJsCellRenderer;
var $0e439ae7301dd858$var$CellEditorComponentProxy = class {
    constructor(cellEditorParams, refreshProps){
        this.cellEditorParams = cellEditorParams;
        this.refreshProps = refreshProps;
        this.instanceCreated = new (0, $jIDNV.AgPromise)((resolve)=>{
            this.resolveInstanceCreated = resolve;
        });
        this.onValueChange = (value)=>this.updateValue(value);
        this.value = cellEditorParams.value;
    }
    getProps() {
        return $0e439ae7301dd858$var$__spreadProps($0e439ae7301dd858$var$__spreadValues({}, this.cellEditorParams), {
            initialValue: this.cellEditorParams.value,
            value: this.value,
            onValueChange: this.onValueChange
        });
    }
    getValue() {
        return this.value;
    }
    refresh(params) {
        this.cellEditorParams = params;
        this.refreshProps();
    }
    setMethods(methods) {
        $0e439ae7301dd858$var$addOptionalMethods(this.getOptionalMethods(), methods, this);
    }
    getInstance() {
        return this.instanceCreated.then(()=>this.componentInstance);
    }
    setRef(componentInstance) {
        var _a;
        this.componentInstance = componentInstance;
        (_a = this.resolveInstanceCreated) == null || _a.call(this);
        this.resolveInstanceCreated = void 0;
    }
    getOptionalMethods() {
        return [
            "isPopup",
            "isCancelBeforeStart",
            "isCancelAfterEnd",
            "getPopupPosition",
            "focusIn",
            "focusOut",
            "afterGuiAttached"
        ];
    }
    updateValue(value) {
        this.value = value;
        this.refreshProps();
    }
};
// packages/ag-grid-react/src/reactUi/cells/cellComp.tsx
var $0e439ae7301dd858$var$checkCellEditorDeprecations = (popup, cellEditor, cellCtrl)=>{
    const col = cellCtrl.getColumn();
    if (!popup && cellEditor.isPopup && cellEditor.isPopup()) {
        const msg = `AG Grid: Found an issue in column ${col.getColId()}. If using React, specify an editor is a popup using colDef.cellEditorPopup=true. AG Grid React cannot depend on the editor component specifying if it's in a popup (via the isPopup() method on the editor), as React needs to know this information BEFORE the component is created.`;
        (0, $jIDNV._).doOnce(()=>console.warn(msg), "jsEditorComp-isPopup-" + cellCtrl.getColumn().getColId());
    }
    if (popup && cellEditor.getPopupPosition && cellEditor.getPopupPosition() != null) {
        const msg = `AG Grid: Found an issue in column ${col.getColId()}. If using React, specify an editor popup position using colDef.cellEditorPopupPosition=true. AG Grid React cannot depend on the editor component specifying it's position (via the getPopupPosition() method on the editor), as React needs to know this information BEFORE the component is created.`;
        (0, $jIDNV._).doOnce(()=>console.warn(msg), "jsEditorComp-getPopupPosition-" + cellCtrl.getColumn().getColId());
    }
};
var $0e439ae7301dd858$var$jsxEditorProxy = (editDetails, CellEditorClass, setRef2)=>{
    const { compProxy: compProxy } = editDetails;
    setRef2(compProxy);
    const props = compProxy.getProps();
    const isStateless = $0e439ae7301dd858$var$isComponentStateless(CellEditorClass);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$CustomContext.Provider, {
        value: {
            setMethods: (methods)=>compProxy.setMethods(methods)
        }
    }, isStateless && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CellEditorClass, $0e439ae7301dd858$var$__spreadValues({}, props)), !isStateless && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CellEditorClass, $0e439ae7301dd858$var$__spreadProps($0e439ae7301dd858$var$__spreadValues({}, props), {
        ref: (ref)=>compProxy.setRef(ref)
    })));
};
var $0e439ae7301dd858$var$jsxEditor = (editDetails, CellEditorClass, setRef2)=>{
    const newFormat = editDetails.compProxy;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, !newFormat && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CellEditorClass, $0e439ae7301dd858$var$__spreadProps($0e439ae7301dd858$var$__spreadValues({}, editDetails.compDetails.params), {
        ref: setRef2
    })), newFormat && $0e439ae7301dd858$var$jsxEditorProxy(editDetails, CellEditorClass, setRef2));
};
var $0e439ae7301dd858$var$jsxEditValue = (editDetails, setInlineCellEditorRef, setPopupCellEditorRef, eGui, cellCtrl, jsEditorComp)=>{
    const compDetails = editDetails.compDetails;
    const CellEditorClass = compDetails.componentClass;
    const reactInlineEditor = compDetails.componentFromFramework && !editDetails.popup;
    const reactPopupEditor = compDetails.componentFromFramework && editDetails.popup;
    const jsPopupEditor = !compDetails.componentFromFramework && editDetails.popup;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, reactInlineEditor && $0e439ae7301dd858$var$jsxEditor(editDetails, CellEditorClass, setInlineCellEditorRef), reactPopupEditor && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$popupEditorComp_default, {
        editDetails: editDetails,
        cellCtrl: cellCtrl,
        eParentCell: eGui,
        wrappedContent: $0e439ae7301dd858$var$jsxEditor(editDetails, CellEditorClass, setPopupCellEditorRef)
    }), jsPopupEditor && jsEditorComp && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$popupEditorComp_default, {
        editDetails: editDetails,
        cellCtrl: cellCtrl,
        eParentCell: eGui,
        jsChildComp: jsEditorComp
    }));
};
var $0e439ae7301dd858$var$jsxShowValue = (showDetails, key, parentId, cellRendererRef, showCellWrapper, reactCellRendererStateless, setECellValue)=>{
    const { compDetails: compDetails, value: value } = showDetails;
    const noCellRenderer = !compDetails;
    const reactCellRenderer = compDetails && compDetails.componentFromFramework;
    const CellRendererClass = compDetails && compDetails.componentClass;
    const valueForNoCellRenderer = (value == null ? void 0 : value.toString) ? value.toString() : value;
    const bodyJsxFunc = ()=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, noCellRenderer && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, valueForNoCellRenderer), reactCellRenderer && !reactCellRendererStateless && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CellRendererClass, $0e439ae7301dd858$var$__spreadProps($0e439ae7301dd858$var$__spreadValues({}, compDetails.params), {
            key: key,
            ref: cellRendererRef
        })), reactCellRenderer && reactCellRendererStateless && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CellRendererClass, $0e439ae7301dd858$var$__spreadProps($0e439ae7301dd858$var$__spreadValues({}, compDetails.params), {
            key: key
        })));
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, showCellWrapper ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        role: "presentation",
        id: `cell-${parentId}`,
        className: "ag-cell-value",
        ref: setECellValue
    }, bodyJsxFunc()) : bodyJsxFunc());
};
var $0e439ae7301dd858$var$CellComp = (props)=>{
    const { context: context } = (0, $acw62.useContext)($0e439ae7301dd858$var$BeansContext);
    const { cellCtrl: cellCtrl, printLayout: printLayout, editingRow: editingRow } = props;
    const tabIndex = cellCtrl.getTabIndex();
    const colId = cellCtrl.getColumnIdSanitised();
    const cellInstanceId = cellCtrl.getInstanceId();
    const [renderDetails, setRenderDetails] = (0, $acw62.useState)(()=>cellCtrl.isCellRenderer() ? void 0 : {
            compDetails: void 0,
            value: cellCtrl.getValueToDisplay(),
            force: false
        });
    const [editDetails, setEditDetails] = (0, $acw62.useState)();
    const [renderKey, setRenderKey] = (0, $acw62.useState)(1);
    const [userStyles, setUserStyles] = (0, $acw62.useState)();
    const [includeSelection, setIncludeSelection] = (0, $acw62.useState)(false);
    const [includeRowDrag, setIncludeRowDrag] = (0, $acw62.useState)(false);
    const [includeDndSource, setIncludeDndSource] = (0, $acw62.useState)(false);
    const [jsEditorComp, setJsEditorComp] = (0, $acw62.useState)();
    const forceWrapper = (0, $acw62.useMemo)(()=>cellCtrl.isForceWrapper(), [
        cellCtrl
    ]);
    const cellAriaRole = (0, $acw62.useMemo)(()=>cellCtrl.getCellAriaRole(), [
        cellCtrl
    ]);
    const eGui = (0, $acw62.useRef)(null);
    const cellRendererRef = (0, $acw62.useRef)(null);
    const jsCellRendererRef = (0, $acw62.useRef)();
    const cellEditorRef = (0, $acw62.useRef)();
    const eCellWrapper = (0, $acw62.useRef)();
    const cellWrapperDestroyFuncs = (0, $acw62.useRef)([]);
    const eCellValue = (0, $acw62.useRef)();
    const [cellValueVersion, setCellValueVersion] = (0, $acw62.useState)(0);
    const setCellValueRef = (0, $acw62.useCallback)((ref)=>{
        eCellValue.current = ref;
        setCellValueVersion((v)=>v + 1);
    }, []);
    const showTools = renderDetails != null && (includeSelection || includeDndSource || includeRowDrag);
    const showCellWrapper = forceWrapper || showTools;
    const setCellEditorRef = (0, $acw62.useCallback)((popup, cellEditor)=>{
        cellEditorRef.current = cellEditor;
        if (cellEditor) {
            $0e439ae7301dd858$var$checkCellEditorDeprecations(popup, cellEditor, cellCtrl);
            const editingCancelledByUserComp = cellEditor.isCancelBeforeStart && cellEditor.isCancelBeforeStart();
            if (editingCancelledByUserComp) setTimeout(()=>{
                cellCtrl.stopEditing(true);
                cellCtrl.focusCell(true);
            });
        }
    }, [
        cellCtrl
    ]);
    const setPopupCellEditorRef = (0, $acw62.useCallback)((cellRenderer)=>setCellEditorRef(true, cellRenderer), [
        setCellEditorRef
    ]);
    const setInlineCellEditorRef = (0, $acw62.useCallback)((cellRenderer)=>setCellEditorRef(false, cellRenderer), [
        setCellEditorRef
    ]);
    let cssClassManager = (0, $acw62.useRef)();
    if (!cssClassManager.current) cssClassManager.current = new (0, $jIDNV.CssClassManager)(()=>eGui.current);
    $0e439ae7301dd858$var$showJsRenderer_default(renderDetails, showCellWrapper, eCellValue.current, cellValueVersion, jsCellRendererRef, eGui);
    const lastRenderDetails = (0, $acw62.useRef)();
    (0, $acw62.useLayoutEffect)(()=>{
        const oldDetails = lastRenderDetails.current;
        const newDetails = renderDetails;
        lastRenderDetails.current = renderDetails;
        if (oldDetails == null || oldDetails.compDetails == null || newDetails == null || newDetails.compDetails == null) return;
        const oldCompDetails = oldDetails.compDetails;
        const newCompDetails = newDetails.compDetails;
        if (oldCompDetails.componentClass != newCompDetails.componentClass) return;
        if (cellRendererRef.current == null || cellRendererRef.current.refresh == null) return;
        const result = cellRendererRef.current.refresh(newCompDetails.params);
        if (result != true) setRenderKey((prev)=>prev + 1);
    }, [
        renderDetails
    ]);
    (0, $acw62.useLayoutEffect)(()=>{
        const doingJsEditor = editDetails && !editDetails.compDetails.componentFromFramework;
        if (!doingJsEditor) return;
        const compDetails = editDetails.compDetails;
        const isPopup = editDetails.popup === true;
        const cellEditor = $0e439ae7301dd858$var$createSyncJsComp(compDetails);
        if (!cellEditor) return;
        const compGui = cellEditor.getGui();
        setCellEditorRef(isPopup, cellEditor);
        if (!isPopup) {
            const parentEl = (forceWrapper ? eCellWrapper : eGui).current;
            parentEl == null || parentEl.appendChild(compGui);
            cellEditor.afterGuiAttached && cellEditor.afterGuiAttached();
        }
        setJsEditorComp(cellEditor);
        return ()=>{
            context.destroyBean(cellEditor);
            setCellEditorRef(isPopup, void 0);
            setJsEditorComp(void 0);
            if (compGui && compGui.parentElement) compGui.parentElement.removeChild(compGui);
        };
    }, [
        editDetails
    ]);
    const setCellWrapperRef = (0, $acw62.useCallback)((ref)=>{
        eCellWrapper.current = ref;
        if (!eCellWrapper.current) {
            cellWrapperDestroyFuncs.current.forEach((f)=>f());
            cellWrapperDestroyFuncs.current = [];
            return;
        }
        const addComp = (comp)=>{
            var _a;
            if (comp) {
                const eGui2 = comp.getGui();
                (_a = eCellWrapper.current) == null || _a.insertAdjacentElement("afterbegin", eGui2);
                cellWrapperDestroyFuncs.current.push(()=>{
                    context.destroyBean(comp);
                    (0, $jIDNV._).removeFromParent(eGui2);
                });
            }
            return comp;
        };
        if (includeSelection) {
            const checkboxSelectionComp = cellCtrl.createSelectionCheckbox();
            addComp(checkboxSelectionComp);
        }
        if (includeDndSource) addComp(cellCtrl.createDndSource());
        if (includeRowDrag) addComp(cellCtrl.createRowDragComp());
    }, [
        cellCtrl,
        context,
        includeDndSource,
        includeRowDrag,
        includeSelection
    ]);
    const setRef2 = (0, $acw62.useCallback)((ref)=>{
        eGui.current = ref;
        if (!eGui.current) return;
        if (!cellCtrl) return;
        const compProxy = {
            addOrRemoveCssClass: (name, on)=>cssClassManager.current.addOrRemoveCssClass(name, on),
            setUserStyles: (styles)=>setUserStyles(styles),
            getFocusableElement: ()=>eGui.current,
            setIncludeSelection: (include)=>setIncludeSelection(include),
            setIncludeRowDrag: (include)=>setIncludeRowDrag(include),
            setIncludeDndSource: (include)=>setIncludeDndSource(include),
            getCellEditor: ()=>cellEditorRef.current || null,
            getCellRenderer: ()=>cellRendererRef.current ? cellRendererRef.current : jsCellRendererRef.current,
            getParentOfValue: ()=>eCellValue.current ? eCellValue.current : eCellWrapper.current ? eCellWrapper.current : eGui.current,
            setRenderDetails: (compDetails, value, force)=>{
                setRenderDetails((prev)=>{
                    if ((prev == null ? void 0 : prev.compDetails) !== compDetails || (prev == null ? void 0 : prev.value) !== value || (prev == null ? void 0 : prev.force) !== force) return {
                        value: value,
                        compDetails: compDetails,
                        force: force
                    };
                    else return prev;
                });
            },
            setEditDetails: (compDetails, popup, popupPosition, reactiveCustomComponents)=>{
                if (compDetails) {
                    let compProxy2 = void 0;
                    if (reactiveCustomComponents) compProxy2 = new $0e439ae7301dd858$var$CellEditorComponentProxy(compDetails.params, ()=>setRenderKey((prev)=>prev + 1));
                    else if (compDetails.componentFromFramework) $0e439ae7301dd858$export$e83e01bcf62967be();
                    setEditDetails({
                        compDetails: compDetails,
                        popup: popup,
                        popupPosition: popupPosition,
                        compProxy: compProxy2
                    });
                    if (!popup) setRenderDetails(void 0);
                } else setEditDetails((editDetails2)=>{
                    if (editDetails2 == null ? void 0 : editDetails2.compProxy) cellEditorRef.current = void 0;
                    return void 0;
                });
            }
        };
        const cellWrapperOrUndefined = eCellWrapper.current || void 0;
        cellCtrl.setComp(compProxy, eGui.current, cellWrapperOrUndefined, printLayout, editingRow);
    }, []);
    const reactCellRendererStateless = (0, $acw62.useMemo)(()=>{
        const res = renderDetails && renderDetails.compDetails && renderDetails.compDetails.componentFromFramework && $0e439ae7301dd858$var$isComponentStateless(renderDetails.compDetails.componentClass);
        return !!res;
    }, [
        renderDetails
    ]);
    (0, $acw62.useLayoutEffect)(()=>{
        var _a;
        if (!eGui.current) return;
        cssClassManager.current.addOrRemoveCssClass("ag-cell-value", !showCellWrapper);
        cssClassManager.current.addOrRemoveCssClass("ag-cell-inline-editing", !!editDetails && !editDetails.popup);
        cssClassManager.current.addOrRemoveCssClass("ag-cell-popup-editing", !!editDetails && !!editDetails.popup);
        cssClassManager.current.addOrRemoveCssClass("ag-cell-not-inline-editing", !editDetails || !!editDetails.popup);
        (_a = cellCtrl.getRowCtrl()) == null || _a.setInlineEditingCss(!!editDetails);
        if (cellCtrl.shouldRestoreFocus() && !cellCtrl.isEditing()) eGui.current.focus({
            preventScroll: true
        });
    });
    const showContents = ()=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, renderDetails != null && $0e439ae7301dd858$var$jsxShowValue(renderDetails, renderKey, cellInstanceId, cellRendererRef, showCellWrapper, reactCellRendererStateless, setCellValueRef), editDetails != null && $0e439ae7301dd858$var$jsxEditValue(editDetails, setInlineCellEditorRef, setPopupCellEditorRef, eGui.current, cellCtrl, jsEditorComp));
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: setRef2,
        style: userStyles,
        tabIndex: tabIndex,
        role: cellAriaRole,
        "col-id": colId
    }, showCellWrapper ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "ag-cell-wrapper",
        role: "presentation",
        ref: setCellWrapperRef
    }, showContents()) : showContents());
};
var $0e439ae7301dd858$var$cellComp_default = (0, $acw62.memo)($0e439ae7301dd858$var$CellComp);
// packages/ag-grid-react/src/reactUi/rows/rowComp.tsx
var $0e439ae7301dd858$var$RowComp = (params)=>{
    const { context: context, gos: gos } = (0, $acw62.useContext)($0e439ae7301dd858$var$BeansContext);
    const { rowCtrl: rowCtrl, containerType: containerType } = params;
    const tabIndex = rowCtrl.getTabIndex();
    const domOrderRef = (0, $acw62.useRef)(rowCtrl.getDomOrder());
    const isFullWidth = rowCtrl.isFullWidth();
    const isDisplayed = rowCtrl.getRowNode().displayed;
    const [rowIndex, setRowIndex] = (0, $acw62.useState)(()=>isDisplayed ? rowCtrl.getRowIndex() : null);
    const [rowId, setRowId] = (0, $acw62.useState)(()=>rowCtrl.getRowId());
    const [rowBusinessKey, setRowBusinessKey] = (0, $acw62.useState)(()=>rowCtrl.getBusinessKey());
    const [userStyles, setUserStyles] = (0, $acw62.useState)(()=>rowCtrl.getRowStyles());
    const cellCtrlsRef = (0, $acw62.useRef)(null);
    const prevCellCtrlsRef = (0, $acw62.useRef)(null);
    const [cellCtrls, setCellCtrls] = (0, $acw62.useState)(()=>null);
    const [fullWidthCompDetails, setFullWidthCompDetails] = (0, $acw62.useState)();
    const [top, setTop] = (0, $acw62.useState)(()=>isDisplayed ? rowCtrl.getInitialRowTop(containerType) : void 0);
    const [transform, setTransform] = (0, $acw62.useState)(()=>isDisplayed ? rowCtrl.getInitialTransform(containerType) : void 0);
    const eGui = (0, $acw62.useRef)(null);
    const fullWidthCompRef = (0, $acw62.useRef)();
    const autoHeightSetup = (0, $acw62.useRef)(false);
    const [autoHeightSetupAttempt, setAutoHeightSetupAttempt] = (0, $acw62.useState)(0);
    (0, $acw62.useEffect)(()=>{
        var _a;
        if (autoHeightSetup.current) return;
        if (!fullWidthCompDetails) return;
        if (autoHeightSetupAttempt > 10) return;
        const eChild = (_a = eGui.current) == null ? void 0 : _a.firstChild;
        if (eChild) {
            rowCtrl.setupDetailRowAutoHeight(eChild);
            autoHeightSetup.current = true;
        } else setAutoHeightSetupAttempt((prev)=>prev + 1);
    }, [
        fullWidthCompDetails,
        autoHeightSetupAttempt
    ]);
    let cssClassManager = (0, $acw62.useRef)();
    if (!cssClassManager.current) cssClassManager.current = new (0, $jIDNV.CssClassManager)(()=>eGui.current);
    const setRef2 = (0, $acw62.useCallback)((e)=>{
        eGui.current = e;
        if (!eGui.current) {
            rowCtrl.unsetComp(containerType);
            return;
        }
        if (!rowCtrl.isAlive()) return;
        const compProxy = {
            setTop: // the rowTop is managed by state, instead of direct style manipulation by rowCtrl (like all the other styles)
            // as we need to have an initial value when it's placed into he DOM for the first time, for animation to work.
            setTop,
            setTransform: setTransform,
            // i found using React for managing classes at the row level was to slow, as modifying classes caused a lot of
            // React code to execute, so avoiding React for managing CSS Classes made the grid go much faster.
            addOrRemoveCssClass: (name, on)=>cssClassManager.current.addOrRemoveCssClass(name, on),
            setDomOrder: (domOrder)=>domOrderRef.current = domOrder,
            setRowIndex: setRowIndex,
            setRowId: setRowId,
            setRowBusinessKey: setRowBusinessKey,
            setUserStyles: setUserStyles,
            // if we don't maintain the order, then cols will be ripped out and into the dom
            // when cols reordered, which would stop the CSS transitions from working
            setCellCtrls: (next, useFlushSync)=>{
                prevCellCtrlsRef.current = cellCtrlsRef.current;
                cellCtrlsRef.current = next;
                const nextCells = $0e439ae7301dd858$var$getNextValueIfDifferent(prevCellCtrlsRef.current, next, domOrderRef.current);
                if (nextCells !== prevCellCtrlsRef.current) $0e439ae7301dd858$var$agFlushSync(useFlushSync, ()=>setCellCtrls(nextCells));
            },
            showFullWidth: (compDetails)=>setFullWidthCompDetails(compDetails),
            getFullWidthCellRenderer: ()=>fullWidthCompRef.current,
            refreshFullWidth: (getUpdatedParams)=>{
                if (canRefreshFullWidthRef.current) {
                    setFullWidthCompDetails((prevFullWidthCompDetails)=>$0e439ae7301dd858$var$__spreadProps($0e439ae7301dd858$var$__spreadValues({}, prevFullWidthCompDetails), {
                            params: getUpdatedParams()
                        }));
                    return true;
                } else {
                    if (!fullWidthCompRef.current || !fullWidthCompRef.current.refresh) return false;
                    return fullWidthCompRef.current.refresh(getUpdatedParams());
                }
            }
        };
        rowCtrl.setComp(compProxy, eGui.current, containerType);
    }, []);
    (0, $acw62.useLayoutEffect)(()=>$0e439ae7301dd858$var$showJsComp(fullWidthCompDetails, context, eGui.current, fullWidthCompRef), [
        fullWidthCompDetails
    ]);
    const rowStyles = (0, $acw62.useMemo)(()=>{
        const res = {
            top: top,
            transform: transform
        };
        Object.assign(res, userStyles);
        return res;
    }, [
        top,
        transform,
        userStyles
    ]);
    const showFullWidthFramework = isFullWidth && fullWidthCompDetails && fullWidthCompDetails.componentFromFramework;
    const showCells = !isFullWidth && cellCtrls != null;
    const reactFullWidthCellRendererStateless = (0, $acw62.useMemo)(()=>{
        const res = (fullWidthCompDetails == null ? void 0 : fullWidthCompDetails.componentFromFramework) && $0e439ae7301dd858$var$isComponentStateless(fullWidthCompDetails.componentClass);
        return !!res;
    }, [
        fullWidthCompDetails
    ]);
    const canRefreshFullWidthRef = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        canRefreshFullWidthRef.current = reactFullWidthCellRendererStateless && !!fullWidthCompDetails && !!gos.get("reactiveCustomComponents");
    }, [
        reactFullWidthCellRendererStateless,
        fullWidthCompDetails
    ]);
    const showCellsJsx = ()=>cellCtrls == null ? void 0 : cellCtrls.map((cellCtrl)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$cellComp_default, {
                cellCtrl: cellCtrl,
                editingRow: rowCtrl.isEditing(),
                printLayout: rowCtrl.isPrintLayout(),
                key: cellCtrl.getInstanceId()
            }));
    const showFullWidthFrameworkJsx = ()=>{
        const FullWidthComp = fullWidthCompDetails.componentClass;
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, reactFullWidthCellRendererStateless && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(FullWidthComp, $0e439ae7301dd858$var$__spreadValues({}, fullWidthCompDetails.params)), !reactFullWidthCellRendererStateless && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(FullWidthComp, $0e439ae7301dd858$var$__spreadProps($0e439ae7301dd858$var$__spreadValues({}, fullWidthCompDetails.params), {
            ref: fullWidthCompRef
        })));
    };
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: setRef2,
        role: "row",
        style: rowStyles,
        "row-index": rowIndex,
        "row-id": rowId,
        "row-business-key": rowBusinessKey,
        tabIndex: tabIndex
    }, showCells && showCellsJsx(), showFullWidthFramework && showFullWidthFrameworkJsx());
};
var $0e439ae7301dd858$var$rowComp_default = (0, $acw62.memo)($0e439ae7301dd858$var$RowComp);
// packages/ag-grid-react/src/reactUi/rows/rowContainerComp.tsx
var $0e439ae7301dd858$var$RowContainerComp = (params)=>{
    const { context: context } = (0, $acw62.useContext)($0e439ae7301dd858$var$BeansContext);
    const { name: name } = params;
    const containerType = (0, $acw62.useMemo)(()=>(0, $jIDNV.getRowContainerTypeForName)(name), [
        name
    ]);
    const eViewport = (0, $acw62.useRef)(null);
    const eContainer = (0, $acw62.useRef)(null);
    const rowCtrlsRef = (0, $acw62.useRef)([]);
    const prevRowCtrlsRef = (0, $acw62.useRef)([]);
    const [rowCtrlsOrdered, setRowCtrlsOrdered] = (0, $acw62.useState)(()=>[]);
    const domOrderRef = (0, $acw62.useRef)(false);
    const rowContainerCtrlRef = (0, $acw62.useRef)();
    const cssClasses = (0, $acw62.useMemo)(()=>(0, $jIDNV.RowContainerCtrl).getRowContainerCssClasses(name), [
        name
    ]);
    const viewportClasses = (0, $acw62.useMemo)(()=>$0e439ae7301dd858$var$classesList(cssClasses.viewport), [
        cssClasses
    ]);
    const containerClasses = (0, $acw62.useMemo)(()=>$0e439ae7301dd858$var$classesList(cssClasses.container), [
        cssClasses
    ]);
    const centerTemplate = name === (0, $jIDNV.RowContainerName).CENTER || name === (0, $jIDNV.RowContainerName).TOP_CENTER || name === (0, $jIDNV.RowContainerName).BOTTOM_CENTER || name === (0, $jIDNV.RowContainerName).STICKY_TOP_CENTER || name === (0, $jIDNV.RowContainerName).STICKY_BOTTOM_CENTER;
    const topLevelRef = centerTemplate ? eViewport : eContainer;
    $0e439ae7301dd858$var$reactComment_default(" AG Row Container " + name + " ", topLevelRef);
    const areElementsReady = (0, $acw62.useCallback)(()=>{
        if (centerTemplate) return eViewport.current != null && eContainer.current != null;
        return eContainer.current != null;
    }, []);
    const areElementsRemoved = (0, $acw62.useCallback)(()=>{
        if (centerTemplate) return eViewport.current == null && eContainer.current == null;
        return eContainer.current == null;
    }, []);
    const setRef2 = (0, $acw62.useCallback)(()=>{
        if (areElementsRemoved()) {
            context.destroyBean(rowContainerCtrlRef.current);
            rowContainerCtrlRef.current = null;
        }
        if (areElementsReady()) {
            const updateRowCtrlsOrdered = (useFlushSync)=>{
                const next = $0e439ae7301dd858$var$getNextValueIfDifferent(prevRowCtrlsRef.current, rowCtrlsRef.current, domOrderRef.current);
                if (next !== prevRowCtrlsRef.current) {
                    prevRowCtrlsRef.current = next;
                    $0e439ae7301dd858$var$agFlushSync(useFlushSync, ()=>setRowCtrlsOrdered(next));
                }
            };
            const compProxy = {
                setViewportHeight: (height)=>{
                    if (eViewport.current) eViewport.current.style.height = height;
                },
                setRowCtrls: ({ rowCtrls: rowCtrls, useFlushSync: useFlushSync })=>{
                    const useFlush = !!useFlushSync && rowCtrlsRef.current.length > 0 && rowCtrls.length > 0;
                    rowCtrlsRef.current = rowCtrls;
                    updateRowCtrlsOrdered(useFlush);
                },
                setDomOrder: (domOrder)=>{
                    if (domOrderRef.current != domOrder) {
                        domOrderRef.current = domOrder;
                        updateRowCtrlsOrdered(false);
                    }
                },
                setContainerWidth: (width)=>{
                    if (eContainer.current) eContainer.current.style.width = width;
                }
            };
            rowContainerCtrlRef.current = context.createBean(new (0, $jIDNV.RowContainerCtrl)(name));
            rowContainerCtrlRef.current.setComp(compProxy, eContainer.current, eViewport.current);
        }
    }, [
        areElementsReady,
        areElementsRemoved
    ]);
    const setContainerRef = (0, $acw62.useCallback)((e)=>{
        eContainer.current = e;
        setRef2();
    }, [
        setRef2
    ]);
    const setViewportRef = (0, $acw62.useCallback)((e)=>{
        eViewport.current = e;
        setRef2();
    }, [
        setRef2
    ]);
    const buildContainer = ()=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: containerClasses,
            ref: setContainerRef,
            role: "rowgroup"
        }, rowCtrlsOrdered.map((rowCtrl)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$rowComp_default, {
                rowCtrl: rowCtrl,
                containerType: containerType,
                key: rowCtrl.getInstanceId()
            })));
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, centerTemplate ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: viewportClasses,
        ref: setViewportRef,
        role: "presentation"
    }, buildContainer()) : buildContainer());
};
var $0e439ae7301dd858$var$rowContainerComp_default = (0, $acw62.memo)($0e439ae7301dd858$var$RowContainerComp);
// packages/ag-grid-react/src/reactUi/gridBodyComp.tsx
var $0e439ae7301dd858$var$GridBodyComp = ()=>{
    const { context: context, agStackComponentsRegistry: agStackComponentsRegistry, resizeObserverService: resizeObserverService } = (0, $acw62.useContext)($0e439ae7301dd858$var$BeansContext);
    const [rowAnimationClass, setRowAnimationClass] = (0, $acw62.useState)("");
    const [topHeight, setTopHeight] = (0, $acw62.useState)(0);
    const [bottomHeight, setBottomHeight] = (0, $acw62.useState)(0);
    const [stickyTopHeight, setStickyTopHeight] = (0, $acw62.useState)("0px");
    const [stickyTopTop, setStickyTopTop] = (0, $acw62.useState)("0px");
    const [stickyTopWidth, setStickyTopWidth] = (0, $acw62.useState)("100%");
    const [stickyBottomHeight, setStickyBottomHeight] = (0, $acw62.useState)("0px");
    const [stickyBottomBottom, setStickyBottomBottom] = (0, $acw62.useState)("0px");
    const [stickyBottomWidth, setStickyBottomWidth] = (0, $acw62.useState)("100%");
    const [topDisplay, setTopDisplay] = (0, $acw62.useState)("");
    const [bottomDisplay, setBottomDisplay] = (0, $acw62.useState)("");
    const [forceVerticalScrollClass, setForceVerticalScrollClass] = (0, $acw62.useState)(null);
    const [topAndBottomOverflowY, setTopAndBottomOverflowY] = (0, $acw62.useState)("");
    const [cellSelectableCss, setCellSelectableCss] = (0, $acw62.useState)(null);
    const [layoutClass, setLayoutClass] = (0, $acw62.useState)("ag-layout-normal");
    let cssClassManager = (0, $acw62.useRef)();
    if (!cssClassManager.current) cssClassManager.current = new (0, $jIDNV.CssClassManager)(()=>eRoot.current);
    const eRoot = (0, $acw62.useRef)(null);
    const eTop = (0, $acw62.useRef)(null);
    const eStickyTop = (0, $acw62.useRef)(null);
    const eStickyBottom = (0, $acw62.useRef)(null);
    const eBody = (0, $acw62.useRef)(null);
    const eBodyViewport = (0, $acw62.useRef)(null);
    const eBottom = (0, $acw62.useRef)(null);
    const beansToDestroy = (0, $acw62.useRef)([]);
    const destroyFuncs = (0, $acw62.useRef)([]);
    $0e439ae7301dd858$var$reactComment_default(" AG Grid Body ", eRoot);
    $0e439ae7301dd858$var$reactComment_default(" AG Pinned Top ", eTop);
    $0e439ae7301dd858$var$reactComment_default(" AG Sticky Top ", eStickyTop);
    $0e439ae7301dd858$var$reactComment_default(" AG Middle ", eBodyViewport);
    $0e439ae7301dd858$var$reactComment_default(" AG Pinned Bottom ", eBottom);
    const setRef2 = (0, $acw62.useCallback)((e)=>{
        eRoot.current = e;
        if (!eRoot.current) {
            context.destroyBeans(beansToDestroy.current);
            destroyFuncs.current.forEach((f)=>f());
            beansToDestroy.current = [];
            destroyFuncs.current = [];
            return;
        }
        if (!context) return;
        const newComp = (tag)=>{
            const CompClass = agStackComponentsRegistry.getComponentClass(tag);
            const comp = context.createBean(new CompClass());
            beansToDestroy.current.push(comp);
            return comp;
        };
        const attachToDom = (eParent, eChild)=>{
            eParent.appendChild(eChild);
            destroyFuncs.current.push(()=>eParent.removeChild(eChild));
        };
        attachToDom(eRoot.current, document.createComment(" AG Fake Horizontal Scroll "));
        attachToDom(eRoot.current, newComp("AG-FAKE-HORIZONTAL-SCROLL").getGui());
        attachToDom(eRoot.current, document.createComment(" AG Overlay Wrapper "));
        attachToDom(eRoot.current, newComp("AG-OVERLAY-WRAPPER").getGui());
        if (eBody.current) {
            attachToDom(eBody.current, document.createComment(" AG Fake Vertical Scroll "));
            attachToDom(eBody.current, newComp("AG-FAKE-VERTICAL-SCROLL").getGui());
        }
        const compProxy = {
            setRowAnimationCssOnBodyViewport: setRowAnimationClass,
            setColumnCount: (count)=>{
                if (eRoot.current) (0, $jIDNV._).setAriaColCount(eRoot.current, count);
            },
            setRowCount: (count)=>{
                if (eRoot.current) (0, $jIDNV._).setAriaRowCount(eRoot.current, count);
            },
            setTopHeight: setTopHeight,
            setBottomHeight: setBottomHeight,
            setStickyTopHeight: setStickyTopHeight,
            setStickyTopTop: setStickyTopTop,
            setStickyTopWidth: setStickyTopWidth,
            setTopDisplay: setTopDisplay,
            setBottomDisplay: setBottomDisplay,
            setColumnMovingCss: (cssClass, flag)=>cssClassManager.current.addOrRemoveCssClass(cssClass, flag),
            updateLayoutClasses: setLayoutClass,
            setAlwaysVerticalScrollClass: setForceVerticalScrollClass,
            setPinnedTopBottomOverflowY: setTopAndBottomOverflowY,
            setCellSelectableCss: (cssClass, flag)=>setCellSelectableCss(flag ? cssClass : null),
            setBodyViewportWidth: (width)=>{
                if (eBodyViewport.current) eBodyViewport.current.style.width = width;
            },
            registerBodyViewportResizeListener: (listener)=>{
                if (eBodyViewport.current) {
                    const unsubscribeFromResize = resizeObserverService.observeResize(eBodyViewport.current, listener);
                    destroyFuncs.current.push(()=>unsubscribeFromResize());
                }
            },
            setStickyBottomHeight: setStickyBottomHeight,
            setStickyBottomBottom: setStickyBottomBottom,
            setStickyBottomWidth: setStickyBottomWidth
        };
        const ctrl = context.createBean(new (0, $jIDNV.GridBodyCtrl)());
        beansToDestroy.current.push(ctrl);
        ctrl.setComp(compProxy, eRoot.current, eBodyViewport.current, eTop.current, eBottom.current, eStickyTop.current, eStickyBottom.current);
    }, []);
    const rootClasses = (0, $acw62.useMemo)(()=>$0e439ae7301dd858$var$classesList("ag-root", "ag-unselectable", layoutClass), [
        layoutClass
    ]);
    const bodyViewportClasses = (0, $acw62.useMemo)(()=>$0e439ae7301dd858$var$classesList("ag-body-viewport", rowAnimationClass, layoutClass, forceVerticalScrollClass, cellSelectableCss), [
        rowAnimationClass,
        layoutClass,
        forceVerticalScrollClass,
        cellSelectableCss
    ]);
    const bodyClasses = (0, $acw62.useMemo)(()=>$0e439ae7301dd858$var$classesList("ag-body", layoutClass), [
        layoutClass
    ]);
    const topClasses = (0, $acw62.useMemo)(()=>$0e439ae7301dd858$var$classesList("ag-floating-top", cellSelectableCss), [
        cellSelectableCss
    ]);
    const stickyTopClasses = (0, $acw62.useMemo)(()=>$0e439ae7301dd858$var$classesList("ag-sticky-top", cellSelectableCss), [
        cellSelectableCss
    ]);
    const stickyBottomClasses = (0, $acw62.useMemo)(()=>$0e439ae7301dd858$var$classesList("ag-sticky-bottom", cellSelectableCss), [
        cellSelectableCss
    ]);
    const bottomClasses = (0, $acw62.useMemo)(()=>$0e439ae7301dd858$var$classesList("ag-floating-bottom", cellSelectableCss), [
        cellSelectableCss
    ]);
    const topStyle = (0, $acw62.useMemo)(()=>({
            height: topHeight,
            minHeight: topHeight,
            display: topDisplay,
            overflowY: topAndBottomOverflowY
        }), [
        topHeight,
        topDisplay,
        topAndBottomOverflowY
    ]);
    const stickyTopStyle = (0, $acw62.useMemo)(()=>({
            height: stickyTopHeight,
            top: stickyTopTop,
            width: stickyTopWidth
        }), [
        stickyTopHeight,
        stickyTopTop,
        stickyTopWidth
    ]);
    const stickyBottomStyle = (0, $acw62.useMemo)(()=>({
            height: stickyBottomHeight,
            bottom: stickyBottomBottom,
            width: stickyBottomWidth
        }), [
        stickyBottomHeight,
        stickyBottomBottom,
        stickyBottomWidth
    ]);
    const bottomStyle = (0, $acw62.useMemo)(()=>({
            height: bottomHeight,
            minHeight: bottomHeight,
            display: bottomDisplay,
            overflowY: topAndBottomOverflowY
        }), [
        bottomHeight,
        bottomDisplay,
        topAndBottomOverflowY
    ]);
    const createRowContainer = (container)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$rowContainerComp_default, {
            name: container,
            key: `${container}-container`
        });
    const createSection = ({ section: section, children: children, className: className, style: style })=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            ref: section,
            className: className,
            role: "presentation",
            style: style
        }, children.map(createRowContainer));
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: setRef2,
        className: rootClasses,
        role: "treegrid"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$gridHeaderComp_default, null), createSection({
        section: eTop,
        className: topClasses,
        style: topStyle,
        children: [
            (0, $jIDNV.RowContainerName).TOP_LEFT,
            (0, $jIDNV.RowContainerName).TOP_CENTER,
            (0, $jIDNV.RowContainerName).TOP_RIGHT,
            (0, $jIDNV.RowContainerName).TOP_FULL_WIDTH
        ]
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: bodyClasses,
        ref: eBody,
        role: "presentation"
    }, createSection({
        section: eBodyViewport,
        className: bodyViewportClasses,
        children: [
            (0, $jIDNV.RowContainerName).LEFT,
            (0, $jIDNV.RowContainerName).CENTER,
            (0, $jIDNV.RowContainerName).RIGHT,
            (0, $jIDNV.RowContainerName).FULL_WIDTH
        ]
    })), createSection({
        section: eStickyTop,
        className: stickyTopClasses,
        style: stickyTopStyle,
        children: [
            (0, $jIDNV.RowContainerName).STICKY_TOP_LEFT,
            (0, $jIDNV.RowContainerName).STICKY_TOP_CENTER,
            (0, $jIDNV.RowContainerName).STICKY_TOP_RIGHT,
            (0, $jIDNV.RowContainerName).STICKY_TOP_FULL_WIDTH
        ]
    }), createSection({
        section: eStickyBottom,
        className: stickyBottomClasses,
        style: stickyBottomStyle,
        children: [
            (0, $jIDNV.RowContainerName).STICKY_BOTTOM_LEFT,
            (0, $jIDNV.RowContainerName).STICKY_BOTTOM_CENTER,
            (0, $jIDNV.RowContainerName).STICKY_BOTTOM_RIGHT,
            (0, $jIDNV.RowContainerName).STICKY_BOTTOM_FULL_WIDTH
        ]
    }), createSection({
        section: eBottom,
        className: bottomClasses,
        style: bottomStyle,
        children: [
            (0, $jIDNV.RowContainerName).BOTTOM_LEFT,
            (0, $jIDNV.RowContainerName).BOTTOM_CENTER,
            (0, $jIDNV.RowContainerName).BOTTOM_RIGHT,
            (0, $jIDNV.RowContainerName).BOTTOM_FULL_WIDTH
        ]
    }));
};
var $0e439ae7301dd858$var$gridBodyComp_default = (0, $acw62.memo)($0e439ae7301dd858$var$GridBodyComp);
var $0e439ae7301dd858$var$TabGuardCompRef = (props, forwardRef4)=>{
    const { children: children, eFocusableElement: eFocusableElement, onTabKeyDown: onTabKeyDown, gridCtrl: gridCtrl, forceFocusOutWhenTabGuardsAreEmpty: forceFocusOutWhenTabGuardsAreEmpty } = props;
    const { context: context } = (0, $acw62.useContext)($0e439ae7301dd858$var$BeansContext);
    const topTabGuardRef = (0, $acw62.useRef)(null);
    const bottomTabGuardRef = (0, $acw62.useRef)(null);
    const tabGuardCtrlRef = (0, $acw62.useRef)();
    const setTabIndex = (value)=>{
        const processedValue = value == null ? void 0 : parseInt(value, 10).toString();
        [
            topTabGuardRef,
            bottomTabGuardRef
        ].forEach((tabGuard)=>{
            var _a, _b;
            if (processedValue === void 0) (_a = tabGuard.current) == null || _a.removeAttribute("tabindex");
            else (_b = tabGuard.current) == null || _b.setAttribute("tabindex", processedValue);
        });
    };
    (0, $acw62.useImperativeHandle)(forwardRef4, ()=>({
            forceFocusOutOfContainer (up) {
                var _a;
                (_a = tabGuardCtrlRef.current) == null || _a.forceFocusOutOfContainer(up);
            }
        }));
    const setupCtrl = (0, $acw62.useCallback)(()=>{
        if (!topTabGuardRef.current && !bottomTabGuardRef.current) {
            context.destroyBean(tabGuardCtrlRef.current);
            tabGuardCtrlRef.current = null;
            return;
        }
        if (topTabGuardRef.current && bottomTabGuardRef.current) {
            const compProxy = {
                setTabIndex: setTabIndex
            };
            tabGuardCtrlRef.current = context.createBean(new (0, $jIDNV.TabGuardCtrl)({
                comp: compProxy,
                eTopGuard: topTabGuardRef.current,
                eBottomGuard: bottomTabGuardRef.current,
                eFocusableElement: eFocusableElement,
                onTabKeyDown: onTabKeyDown,
                forceFocusOutWhenTabGuardsAreEmpty: forceFocusOutWhenTabGuardsAreEmpty,
                focusInnerElement: (fromBottom)=>gridCtrl.focusInnerElement(fromBottom)
            }));
        }
    }, []);
    const setTopRef = (0, $acw62.useCallback)((e)=>{
        topTabGuardRef.current = e;
        setupCtrl();
    }, [
        setupCtrl
    ]);
    const setBottomRef = (0, $acw62.useCallback)((e)=>{
        bottomTabGuardRef.current = e;
        setupCtrl();
    }, [
        setupCtrl
    ]);
    const createTabGuard = (side)=>{
        const className = side === "top" ? (0, $jIDNV.TabGuardClassNames).TAB_GUARD_TOP : (0, $jIDNV.TabGuardClassNames).TAB_GUARD_BOTTOM;
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: `${(0, $jIDNV.TabGuardClassNames).TAB_GUARD} ${className}`,
            role: "presentation",
            ref: side === "top" ? setTopRef : setBottomRef
        });
    };
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, createTabGuard("top"), children, createTabGuard("bottom"));
};
var $0e439ae7301dd858$var$TabGuardComp = (0, $acw62.forwardRef)($0e439ae7301dd858$var$TabGuardCompRef);
var $0e439ae7301dd858$var$tabGuardComp_default = (0, $acw62.memo)($0e439ae7301dd858$var$TabGuardComp);
// packages/ag-grid-react/src/reactUi/gridComp.tsx
var $0e439ae7301dd858$var$GridComp = ({ context: context })=>{
    const [rtlClass, setRtlClass] = (0, $acw62.useState)("");
    const [keyboardFocusClass, setKeyboardFocusClass] = (0, $acw62.useState)("");
    const [layoutClass, setLayoutClass] = (0, $acw62.useState)("");
    const [cursor, setCursor] = (0, $acw62.useState)(null);
    const [userSelect, setUserSelect] = (0, $acw62.useState)(null);
    const [initialised, setInitialised] = (0, $acw62.useState)(false);
    const [tabGuardReady, setTabGuardReady] = (0, $acw62.useState)();
    const gridCtrlRef = (0, $acw62.useRef)(null);
    const eRootWrapperRef = (0, $acw62.useRef)(null);
    const tabGuardRef = (0, $acw62.useRef)();
    const [eGridBodyParent, setGridBodyParent] = (0, $acw62.useState)(null);
    const focusInnerElementRef = (0, $acw62.useRef)(()=>void 0);
    const onTabKeyDown = (0, $acw62.useCallback)(()=>void 0, []);
    const beans = (0, $acw62.useMemo)(()=>{
        if (context.isDestroyed()) return null;
        return context.getBean("beans");
    }, [
        context
    ]);
    $0e439ae7301dd858$var$reactComment_default(" AG Grid ", eRootWrapperRef);
    const setRef2 = (0, $acw62.useCallback)((e)=>{
        eRootWrapperRef.current = e;
        if (!eRootWrapperRef.current) {
            context.destroyBean(gridCtrlRef.current);
            gridCtrlRef.current = null;
            return;
        }
        if (context.isDestroyed()) return;
        gridCtrlRef.current = context.createBean(new (0, $jIDNV.GridCtrl)());
        const gridCtrl = gridCtrlRef.current;
        focusInnerElementRef.current = gridCtrl.focusInnerElement.bind(gridCtrl);
        const compProxy = {
            destroyGridUi: ()=>{},
            setRtlClass: // do nothing, as framework users destroy grid by removing the comp
            setRtlClass,
            forceFocusOutOfContainer: (up)=>{
                var _a;
                (_a = tabGuardRef.current) == null || _a.forceFocusOutOfContainer(up);
            },
            updateLayoutClasses: setLayoutClass,
            getFocusableContainers: ()=>{
                var _a, _b;
                const els = [];
                const gridBodyCompEl = (_a = eRootWrapperRef.current) == null ? void 0 : _a.querySelector(".ag-root");
                const sideBarEl = (_b = eRootWrapperRef.current) == null ? void 0 : _b.querySelector(".ag-side-bar:not(.ag-hidden)");
                if (gridBodyCompEl) els.push(gridBodyCompEl);
                if (sideBarEl) els.push(sideBarEl);
                return els;
            },
            setCursor: setCursor,
            setUserSelect: setUserSelect
        };
        gridCtrl.setComp(compProxy, eRootWrapperRef.current, eRootWrapperRef.current);
        setInitialised(true);
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!tabGuardReady || !beans || !gridCtrlRef.current || !eGridBodyParent || !eRootWrapperRef.current) return;
        const gridCtrl = gridCtrlRef.current;
        const beansToDestroy = [];
        const { agStackComponentsRegistry: agStackComponentsRegistry } = beans;
        const HeaderDropZonesClass = agStackComponentsRegistry.getComponentClass("AG-GRID-HEADER-DROP-ZONES");
        const SideBarClass = agStackComponentsRegistry.getComponentClass("AG-SIDE-BAR");
        const StatusBarClass = agStackComponentsRegistry.getComponentClass("AG-STATUS-BAR");
        const WatermarkClass = agStackComponentsRegistry.getComponentClass("AG-WATERMARK");
        const PaginationClass = agStackComponentsRegistry.getComponentClass("AG-PAGINATION");
        const additionalEls = [];
        const eRootWrapper = eRootWrapperRef.current;
        if (gridCtrl.showDropZones() && HeaderDropZonesClass) {
            const headerDropZonesComp = context.createBean(new HeaderDropZonesClass());
            const eGui = headerDropZonesComp.getGui();
            eRootWrapper.insertAdjacentElement("afterbegin", eGui);
            additionalEls.push(eGui);
            beansToDestroy.push(headerDropZonesComp);
        }
        if (gridCtrl.showSideBar() && SideBarClass) {
            const sideBarComp = context.createBean(new SideBarClass());
            const eGui = sideBarComp.getGui();
            const bottomTabGuard = eGridBodyParent.querySelector(".ag-tab-guard-bottom");
            if (bottomTabGuard) {
                bottomTabGuard.insertAdjacentElement("beforebegin", eGui);
                additionalEls.push(eGui);
            }
            beansToDestroy.push(sideBarComp);
        }
        if (gridCtrl.showStatusBar() && StatusBarClass) {
            const statusBarComp = context.createBean(new StatusBarClass());
            const eGui = statusBarComp.getGui();
            eRootWrapper.insertAdjacentElement("beforeend", eGui);
            additionalEls.push(eGui);
            beansToDestroy.push(statusBarComp);
        }
        if (PaginationClass) {
            const paginationComp = context.createBean(new PaginationClass());
            const eGui = paginationComp.getGui();
            eRootWrapper.insertAdjacentElement("beforeend", eGui);
            additionalEls.push(eGui);
            beansToDestroy.push(paginationComp);
        }
        if (gridCtrl.showWatermark() && WatermarkClass) {
            const watermarkComp = context.createBean(new WatermarkClass());
            const eGui = watermarkComp.getGui();
            eRootWrapper.insertAdjacentElement("beforeend", eGui);
            additionalEls.push(eGui);
            beansToDestroy.push(watermarkComp);
        }
        return ()=>{
            context.destroyBeans(beansToDestroy);
            additionalEls.forEach((el)=>{
                if (el.parentElement) el.parentElement.removeChild(el);
            });
        };
    }, [
        tabGuardReady,
        eGridBodyParent,
        beans
    ]);
    const rootWrapperClasses = (0, $acw62.useMemo)(()=>$0e439ae7301dd858$var$classesList("ag-root-wrapper", rtlClass, keyboardFocusClass, layoutClass), [
        rtlClass,
        keyboardFocusClass,
        layoutClass
    ]);
    const rootWrapperBodyClasses = (0, $acw62.useMemo)(()=>$0e439ae7301dd858$var$classesList("ag-root-wrapper-body", "ag-focus-managed", layoutClass), [
        layoutClass
    ]);
    const topStyle = (0, $acw62.useMemo)(()=>({
            userSelect: userSelect != null ? userSelect : "",
            WebkitUserSelect: userSelect != null ? userSelect : "",
            cursor: cursor != null ? cursor : ""
        }), [
        userSelect,
        cursor
    ]);
    const setTabGuardCompRef = (0, $acw62.useCallback)((ref)=>{
        tabGuardRef.current = ref;
        setTabGuardReady(ref !== null);
    }, []);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: setRef2,
        className: rootWrapperClasses,
        style: topStyle,
        role: "presentation"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: rootWrapperBodyClasses,
        ref: setGridBodyParent,
        role: "presentation"
    }, initialised && eGridBodyParent && beans && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$BeansContext.Provider, {
        value: beans
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$tabGuardComp_default, {
        ref: setTabGuardCompRef,
        eFocusableElement: eGridBodyParent,
        onTabKeyDown: onTabKeyDown,
        gridCtrl: gridCtrlRef.current,
        forceFocusOutWhenTabGuardsAreEmpty: true
    }, // we wait for initialised before rending the children, so GridComp has created and registered with it's
    // GridCtrl before we create the child GridBodyComp. Otherwise the GridBodyComp would initialise first,
    // before we have set the the Layout CSS classes, causing the GridBodyComp to render rows to a grid that
    // doesn't have it's height specified, which would result if all the rows getting rendered (and if many rows,
    // hangs the UI)
    /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$gridBodyComp_default, null)))));
};
var $0e439ae7301dd858$var$gridComp_default = (0, $acw62.memo)($0e439ae7301dd858$var$GridComp);
// packages/ag-grid-react/src/reactUi/agGridReactUi.tsx
var $0e439ae7301dd858$var$AgGridReactUi = (props)=>{
    var _a, _b;
    const apiRef = (0, $acw62.useRef)();
    const eGui = (0, $acw62.useRef)(null);
    const portalManager = (0, $acw62.useRef)(null);
    const destroyFuncs = (0, $acw62.useRef)([]);
    const whenReadyFuncs = (0, $acw62.useRef)([]);
    const prevProps = (0, $acw62.useRef)(props);
    const ready = (0, $acw62.useRef)(false);
    const [context, setContext] = (0, $acw62.useState)(void 0);
    const [, setPortalRefresher] = (0, $acw62.useState)(0);
    const setRef2 = (0, $acw62.useCallback)((e)=>{
        eGui.current = e;
        if (!eGui.current) {
            destroyFuncs.current.forEach((f)=>f());
            destroyFuncs.current.length = 0;
            return;
        }
        const modules = props.modules || [];
        if (!portalManager.current) {
            portalManager.current = new $0e439ae7301dd858$var$PortalManager(()=>setPortalRefresher((prev)=>prev + 1), props.componentWrappingElement, props.maxComponentCreationTimeMs);
            destroyFuncs.current.push(()=>{
                var _a2;
                (_a2 = portalManager.current) == null || _a2.destroy();
                portalManager.current = null;
            });
        }
        const mergedGridOps = (0, $jIDNV.ComponentUtil).combineAttributesAndGridOptions(props.gridOptions, props);
        const gridParams = {
            providedBeanInstances: {
                frameworkComponentWrapper: new $0e439ae7301dd858$var$ReactFrameworkComponentWrapper(portalManager.current, !!mergedGridOps.reactiveCustomComponents)
            },
            modules: modules,
            frameworkOverrides: new $0e439ae7301dd858$var$ReactFrameworkOverrides()
        };
        const createUiCallback = (context2)=>{
            setContext(context2);
            destroyFuncs.current.push(()=>{
                context2.destroy();
            });
            const ctrlsService = context2.getBean((0, $jIDNV.CtrlsService).NAME);
            ctrlsService.whenReady(()=>{
                if (context2.isDestroyed()) return;
                const api = apiRef.current;
                if (api) {
                    if (props.setGridApi) props.setGridApi(api, new (0, $jIDNV.ColumnApi)(api));
                }
            });
        };
        const acceptChangesCallback = (context2)=>{
            const ctrlsService = context2.getBean((0, $jIDNV.CtrlsService).NAME);
            ctrlsService.whenReady(()=>{
                whenReadyFuncs.current.forEach((f)=>f());
                whenReadyFuncs.current.length = 0;
                ready.current = true;
            });
        };
        const gridCoreCreator = new (0, $jIDNV.GridCoreCreator)();
        apiRef.current = gridCoreCreator.create(eGui.current, mergedGridOps, createUiCallback, acceptChangesCallback, gridParams);
    }, []);
    const style = (0, $acw62.useMemo)(()=>{
        return $0e439ae7301dd858$var$__spreadValues({
            height: "100%"
        }, props.containerStyle || {});
    }, [
        props.containerStyle
    ]);
    const processWhenReady = (0, $acw62.useCallback)((func)=>{
        if (ready.current) func();
        else whenReadyFuncs.current.push(func);
    }, []);
    (0, $acw62.useEffect)(()=>{
        const changes = $0e439ae7301dd858$var$extractGridPropertyChanges(prevProps.current, props);
        prevProps.current = props;
        processWhenReady(()=>{
            if (apiRef.current) (0, $jIDNV.ComponentUtil).processOnChange(changes, apiRef.current);
        });
    }, [
        props
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: style,
        className: props.className,
        ref: setRef2
    }, context && !context.isDestroyed() ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$gridComp_default, {
        context: context
    }) : null, (_b = (_a = portalManager.current) == null ? void 0 : _a.getPortals()) != null ? _b : null);
};
function $0e439ae7301dd858$var$extractGridPropertyChanges(prevProps, nextProps) {
    const changes = {};
    Object.keys(nextProps).forEach((propKey)=>{
        const propValue = nextProps[propKey];
        if (prevProps[propKey] !== propValue) changes[propKey] = propValue;
    });
    return changes;
}
var $0e439ae7301dd858$var$ReactFrameworkComponentWrapper = class extends (0, $jIDNV.BaseComponentWrapper) {
    constructor(parent, reactiveCustomComponents){
        super();
        this.parent = parent;
        this.reactiveCustomComponents = reactiveCustomComponents;
    }
    createWrapper(UserReactComponent, componentType) {
        if (this.reactiveCustomComponents) {
            const getComponentClass = (propertyName)=>{
                switch(propertyName){
                    case "filter":
                        return $0e439ae7301dd858$var$FilterComponentWrapper;
                    case "floatingFilterComponent":
                        return $0e439ae7301dd858$var$FloatingFilterComponentWrapper;
                    case "dateComponent":
                        return $0e439ae7301dd858$var$DateComponentWrapper;
                    case "loadingOverlayComponent":
                        return $0e439ae7301dd858$var$LoadingOverlayComponentWrapper;
                    case "noRowsOverlayComponent":
                        return $0e439ae7301dd858$var$NoRowsOverlayComponentWrapper;
                    case "statusPanel":
                        return $0e439ae7301dd858$var$StatusPanelComponentWrapper;
                    case "toolPanel":
                        return $0e439ae7301dd858$var$ToolPanelComponentWrapper;
                    case "menuItem":
                        return $0e439ae7301dd858$var$MenuItemComponentWrapper;
                }
            };
            const ComponentClass = getComponentClass(componentType.propertyName);
            if (ComponentClass) return new ComponentClass(UserReactComponent, this.parent, componentType);
        } else switch(componentType.propertyName){
            case "filter":
            case "floatingFilterComponent":
            case "dateComponent":
            case "loadingOverlayComponent":
            case "noRowsOverlayComponent":
            case "statusPanel":
            case "toolPanel":
            case "menuItem":
                $0e439ae7301dd858$export$e83e01bcf62967be();
                break;
        }
        const suppressFallbackMethods = !componentType.cellRenderer && componentType.propertyName !== "toolPanel";
        return new $0e439ae7301dd858$var$ReactComponent(UserReactComponent, this.parent, componentType, suppressFallbackMethods);
    }
};
var $0e439ae7301dd858$var$DetailCellRenderer = (0, $acw62.forwardRef)((props, ref)=>{
    const { ctrlsFactory: ctrlsFactory, context: context, gos: gos, resizeObserverService: resizeObserverService, clientSideRowModel: clientSideRowModel, serverSideRowModel: serverSideRowModel } = (0, $acw62.useContext)($0e439ae7301dd858$var$BeansContext);
    const [cssClasses, setCssClasses] = (0, $acw62.useState)(()=>new $0e439ae7301dd858$var$CssClasses());
    const [gridCssClasses, setGridCssClasses] = (0, $acw62.useState)(()=>new $0e439ae7301dd858$var$CssClasses());
    const [detailGridOptions, setDetailGridOptions] = (0, $acw62.useState)();
    const [detailRowData, setDetailRowData] = (0, $acw62.useState)();
    const ctrlRef = (0, $acw62.useRef)();
    const eGuiRef = (0, $acw62.useRef)(null);
    const resizeObserverDestroyFunc = (0, $acw62.useRef)();
    const parentModules = (0, $acw62.useMemo)(()=>(0, $jIDNV.ModuleRegistry).__getGridRegisteredModules(props.api.getGridId()), [
        props
    ]);
    const topClassName = (0, $acw62.useMemo)(()=>cssClasses.toString() + " ag-details-row", [
        cssClasses
    ]);
    const gridClassName = (0, $acw62.useMemo)(()=>gridCssClasses.toString() + " ag-details-grid", [
        gridCssClasses
    ]);
    if (ref) (0, $acw62.useImperativeHandle)(ref, ()=>({
            refresh () {
                var _a, _b;
                return (_b = (_a = ctrlRef.current) == null ? void 0 : _a.refresh()) != null ? _b : false;
            }
        }));
    if (props.template) (0, $jIDNV._).warnOnce("detailCellRendererParams.template is not supported by AG Grid React. To change the template, provide a Custom Detail Cell Renderer. See https://ag-grid.com/react-data-grid/master-detail-custom-detail/");
    const setRef2 = (0, $acw62.useCallback)((e)=>{
        eGuiRef.current = e;
        if (!eGuiRef.current) {
            context.destroyBean(ctrlRef.current);
            if (resizeObserverDestroyFunc.current) resizeObserverDestroyFunc.current();
            return;
        }
        const compProxy = {
            addOrRemoveCssClass: (name, on)=>setCssClasses((prev)=>prev.setClass(name, on)),
            addOrRemoveDetailGridCssClass: (name, on)=>setGridCssClasses((prev)=>prev.setClass(name, on)),
            setDetailGrid: (gridOptions)=>setDetailGridOptions(gridOptions),
            setRowData: (rowData)=>setDetailRowData(rowData),
            getGui: ()=>eGuiRef.current
        };
        const ctrl = ctrlsFactory.getInstance("detailCellRenderer");
        if (!ctrl) return;
        context.createBean(ctrl);
        ctrl.init(compProxy, props);
        ctrlRef.current = ctrl;
        if (gos.get("detailRowAutoHeight")) {
            const checkRowSizeFunc = ()=>{
                if (eGuiRef.current == null) return;
                const clientHeight = eGuiRef.current.clientHeight;
                if (clientHeight != null && clientHeight > 0) {
                    const updateRowHeightFunc = ()=>{
                        props.node.setRowHeight(clientHeight);
                        if (clientSideRowModel) clientSideRowModel.onRowHeightChanged();
                        else if (serverSideRowModel) serverSideRowModel.onRowHeightChanged();
                    };
                    setTimeout(updateRowHeightFunc, 0);
                }
            };
            resizeObserverDestroyFunc.current = resizeObserverService.observeResize(eGuiRef.current, checkRowSizeFunc);
            checkRowSizeFunc();
        }
    }, []);
    const setGridApi = (0, $acw62.useCallback)((api, columnApi)=>{
        var _a;
        (_a = ctrlRef.current) == null || _a.registerDetailWithMaster(api, columnApi);
    }, []);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: topClassName,
        ref: setRef2
    }, detailGridOptions && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$AgGridReactUi, $0e439ae7301dd858$var$__spreadProps($0e439ae7301dd858$var$__spreadValues({
        className: gridClassName
    }, detailGridOptions), {
        modules: parentModules,
        rowData: detailRowData,
        setGridApi: setGridApi
    })));
});
var $0e439ae7301dd858$var$ReactFrameworkOverrides = class extends (0, $jIDNV.VanillaFrameworkOverrides) {
    constructor(){
        super("react");
        this.frameworkComponents = {
            agGroupCellRenderer: $0e439ae7301dd858$var$groupCellRenderer_default,
            agGroupRowRenderer: $0e439ae7301dd858$var$groupCellRenderer_default,
            agDetailCellRenderer: $0e439ae7301dd858$var$DetailCellRenderer
        };
        this.wrapIncoming = (callback, source)=>{
            if (source === "ensureVisible") return $0e439ae7301dd858$var$runWithoutFlushSync(callback);
            return callback();
        };
        this.renderingEngine = "react";
    }
    frameworkComponent(name) {
        return this.frameworkComponents[name];
    }
    isFrameworkComponent(comp) {
        if (!comp) return false;
        const prototype = comp.prototype;
        const isJsComp = prototype && "getGui" in prototype;
        return !isJsComp;
    }
};
// packages/ag-grid-react/src/agGridReact.tsx
var $0e439ae7301dd858$export$4074462c5969a5d8 = class extends (0, $acw62.Component) {
    constructor(){
        super(...arguments);
        this.apiListeners = [];
        this.setGridApi = (api, columnApi)=>{
            this.api = api;
            this.columnApi = columnApi;
            this.apiListeners.forEach((listener)=>listener(api));
        };
    }
    registerApiListener(listener) {
        this.apiListeners.push(listener);
    }
    componentWillUnmount() {
        this.apiListeners.length = 0;
    }
    render() {
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0e439ae7301dd858$var$AgGridReactUi, $0e439ae7301dd858$var$__spreadProps($0e439ae7301dd858$var$__spreadValues({}, this.props), {
            setGridApi: this.setGridApi
        }));
    }
};
// packages/ag-grid-react/src/shared/interfaces.ts
var $0e439ae7301dd858$export$40bdec3d7030ca81 = /* @__PURE__ */ ((ChangeDetectionStrategyType2)=>{
    ChangeDetectionStrategyType2["IdentityCheck"] = "IdentityCheck";
    ChangeDetectionStrategyType2["DeepValueCheck"] = "DeepValueCheck";
    ChangeDetectionStrategyType2["NoCheck"] = "NoCheck";
    return ChangeDetectionStrategyType2;
})($0e439ae7301dd858$export$40bdec3d7030ca81 || {});
function $0e439ae7301dd858$var$useGridCustomComponent(methods) {
    const { setMethods: setMethods } = (0, $acw62.useContext)($0e439ae7301dd858$var$CustomContext);
    setMethods(methods);
}
function $0e439ae7301dd858$export$70780aa16b46d041(callbacks) {
    $0e439ae7301dd858$var$useGridCustomComponent(callbacks);
}
function $0e439ae7301dd858$export$ae0fe569b475a61(callbacks) {
    return $0e439ae7301dd858$var$useGridCustomComponent(callbacks);
}
function $0e439ae7301dd858$export$42838275cbf666c4(callbacks) {
    return $0e439ae7301dd858$var$useGridCustomComponent(callbacks);
}
function $0e439ae7301dd858$export$a2cd2617441b4952(callbacks) {
    $0e439ae7301dd858$var$useGridCustomComponent(callbacks);
}
function $0e439ae7301dd858$export$bfb597f578b2979b(callbacks) {
    $0e439ae7301dd858$var$useGridCustomComponent(callbacks);
}

});
parcelRegister("kZ6Rz", function(module, exports) {
"use strict";

module.exports = (parcelRequire("3odmW"));

});
parcelRegister("3odmW", function(module, exports) {

$parcel$export(module.exports, "renderToNodeStream", () => $277dfbc9b64034b1$export$307591e98609eddd, (v) => $277dfbc9b64034b1$export$307591e98609eddd = v);
$parcel$export(module.exports, "renderToStaticMarkup", () => $277dfbc9b64034b1$export$eb3a06aef9e6ee51, (v) => $277dfbc9b64034b1$export$eb3a06aef9e6ee51 = v);
$parcel$export(module.exports, "renderToStaticNodeStream", () => $277dfbc9b64034b1$export$b23711c915539651, (v) => $277dfbc9b64034b1$export$b23711c915539651 = v);
$parcel$export(module.exports, "renderToString", () => $277dfbc9b64034b1$export$80e7718417253a51, (v) => $277dfbc9b64034b1$export$80e7718417253a51 = v);
$parcel$export(module.exports, "version", () => $277dfbc9b64034b1$export$83d89fbfd8236492, (v) => $277dfbc9b64034b1$export$83d89fbfd8236492 = v);
/** @license React v17.0.2
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $277dfbc9b64034b1$export$307591e98609eddd;
var $277dfbc9b64034b1$export$eb3a06aef9e6ee51;
var $277dfbc9b64034b1$export$b23711c915539651;
var $277dfbc9b64034b1$export$80e7718417253a51;
var $277dfbc9b64034b1$export$83d89fbfd8236492;
"use strict";

var $8coUR = parcelRequire("8coUR");

var $acw62 = parcelRequire("acw62");
function $277dfbc9b64034b1$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $277dfbc9b64034b1$var$q = 60106, $277dfbc9b64034b1$var$r = 60107, $277dfbc9b64034b1$var$u = 60108, $277dfbc9b64034b1$var$z = 60114, $277dfbc9b64034b1$var$B = 60109, $277dfbc9b64034b1$var$aa = 60110, $277dfbc9b64034b1$var$ba = 60112, $277dfbc9b64034b1$var$D = 60113, $277dfbc9b64034b1$var$ca = 60120, $277dfbc9b64034b1$var$da = 60115, $277dfbc9b64034b1$var$ea = 60116, $277dfbc9b64034b1$var$fa = 60121, $277dfbc9b64034b1$var$ha = 60117, $277dfbc9b64034b1$var$ia = 60119, $277dfbc9b64034b1$var$ja = 60129, $277dfbc9b64034b1$var$ka = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $277dfbc9b64034b1$var$E = Symbol.for;
    $277dfbc9b64034b1$var$q = $277dfbc9b64034b1$var$E("react.portal");
    $277dfbc9b64034b1$var$r = $277dfbc9b64034b1$var$E("react.fragment");
    $277dfbc9b64034b1$var$u = $277dfbc9b64034b1$var$E("react.strict_mode");
    $277dfbc9b64034b1$var$z = $277dfbc9b64034b1$var$E("react.profiler");
    $277dfbc9b64034b1$var$B = $277dfbc9b64034b1$var$E("react.provider");
    $277dfbc9b64034b1$var$aa = $277dfbc9b64034b1$var$E("react.context");
    $277dfbc9b64034b1$var$ba = $277dfbc9b64034b1$var$E("react.forward_ref");
    $277dfbc9b64034b1$var$D = $277dfbc9b64034b1$var$E("react.suspense");
    $277dfbc9b64034b1$var$ca = $277dfbc9b64034b1$var$E("react.suspense_list");
    $277dfbc9b64034b1$var$da = $277dfbc9b64034b1$var$E("react.memo");
    $277dfbc9b64034b1$var$ea = $277dfbc9b64034b1$var$E("react.lazy");
    $277dfbc9b64034b1$var$fa = $277dfbc9b64034b1$var$E("react.block");
    $277dfbc9b64034b1$var$ha = $277dfbc9b64034b1$var$E("react.fundamental");
    $277dfbc9b64034b1$var$ia = $277dfbc9b64034b1$var$E("react.scope");
    $277dfbc9b64034b1$var$ja = $277dfbc9b64034b1$var$E("react.debug_trace_mode");
    $277dfbc9b64034b1$var$ka = $277dfbc9b64034b1$var$E("react.legacy_hidden");
}
function $277dfbc9b64034b1$var$F(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $277dfbc9b64034b1$var$r:
            return "Fragment";
        case $277dfbc9b64034b1$var$q:
            return "Portal";
        case $277dfbc9b64034b1$var$z:
            return "Profiler";
        case $277dfbc9b64034b1$var$u:
            return "StrictMode";
        case $277dfbc9b64034b1$var$D:
            return "Suspense";
        case $277dfbc9b64034b1$var$ca:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $277dfbc9b64034b1$var$aa:
            return (a.displayName || "Context") + ".Consumer";
        case $277dfbc9b64034b1$var$B:
            return (a._context.displayName || "Context") + ".Provider";
        case $277dfbc9b64034b1$var$ba:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case $277dfbc9b64034b1$var$da:
            return $277dfbc9b64034b1$var$F(a.type);
        case $277dfbc9b64034b1$var$fa:
            return $277dfbc9b64034b1$var$F(a._render);
        case $277dfbc9b64034b1$var$ea:
            b = a._payload;
            a = a._init;
            try {
                return $277dfbc9b64034b1$var$F(a(b));
            } catch (c) {}
    }
    return null;
}
var $277dfbc9b64034b1$var$la = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $277dfbc9b64034b1$var$ma = {};
function $277dfbc9b64034b1$var$I(a, b) {
    for(var c = a._threadCount | 0; c <= b; c++)a[c] = a._currentValue2, a._threadCount = c + 1;
}
function $277dfbc9b64034b1$var$na(a, b, c, d) {
    if (d && (d = a.contextType, "object" === typeof d && null !== d)) return $277dfbc9b64034b1$var$I(d, c), d[c];
    if (a = a.contextTypes) {
        c = {};
        for(var f in a)c[f] = b[f];
        b = c;
    } else b = $277dfbc9b64034b1$var$ma;
    return b;
}
for(var $277dfbc9b64034b1$var$J = new Uint16Array(16), $277dfbc9b64034b1$var$K = 0; 15 > $277dfbc9b64034b1$var$K; $277dfbc9b64034b1$var$K++)$277dfbc9b64034b1$var$J[$277dfbc9b64034b1$var$K] = $277dfbc9b64034b1$var$K + 1;
$277dfbc9b64034b1$var$J[15] = 0;
var $277dfbc9b64034b1$var$oa = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $277dfbc9b64034b1$var$pa = Object.prototype.hasOwnProperty, $277dfbc9b64034b1$var$qa = {}, $277dfbc9b64034b1$var$ra = {};
function $277dfbc9b64034b1$var$sa(a) {
    if ($277dfbc9b64034b1$var$pa.call($277dfbc9b64034b1$var$ra, a)) return !0;
    if ($277dfbc9b64034b1$var$pa.call($277dfbc9b64034b1$var$qa, a)) return !1;
    if ($277dfbc9b64034b1$var$oa.test(a)) return $277dfbc9b64034b1$var$ra[a] = !0;
    $277dfbc9b64034b1$var$qa[a] = !0;
    return !1;
}
function $277dfbc9b64034b1$var$ta(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $277dfbc9b64034b1$var$ua(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $277dfbc9b64034b1$var$ta(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $277dfbc9b64034b1$var$M(a, b, c, d, f, h, t) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = h;
    this.removeEmptyString = t;
}
var $277dfbc9b64034b1$var$N = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $277dfbc9b64034b1$var$N[a] = new $277dfbc9b64034b1$var$M(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $277dfbc9b64034b1$var$N[b] = new $277dfbc9b64034b1$var$M(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $277dfbc9b64034b1$var$N[a] = new $277dfbc9b64034b1$var$M(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $277dfbc9b64034b1$var$N[a] = new $277dfbc9b64034b1$var$M(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $277dfbc9b64034b1$var$N[a] = new $277dfbc9b64034b1$var$M(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $277dfbc9b64034b1$var$N[a] = new $277dfbc9b64034b1$var$M(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $277dfbc9b64034b1$var$N[a] = new $277dfbc9b64034b1$var$M(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $277dfbc9b64034b1$var$N[a] = new $277dfbc9b64034b1$var$M(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $277dfbc9b64034b1$var$N[a] = new $277dfbc9b64034b1$var$M(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $277dfbc9b64034b1$var$va = /[\-:]([a-z])/g;
function $277dfbc9b64034b1$var$wa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($277dfbc9b64034b1$var$va, $277dfbc9b64034b1$var$wa);
    $277dfbc9b64034b1$var$N[b] = new $277dfbc9b64034b1$var$M(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($277dfbc9b64034b1$var$va, $277dfbc9b64034b1$var$wa);
    $277dfbc9b64034b1$var$N[b] = new $277dfbc9b64034b1$var$M(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($277dfbc9b64034b1$var$va, $277dfbc9b64034b1$var$wa);
    $277dfbc9b64034b1$var$N[b] = new $277dfbc9b64034b1$var$M(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $277dfbc9b64034b1$var$N[a] = new $277dfbc9b64034b1$var$M(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$277dfbc9b64034b1$var$N.xlinkHref = new $277dfbc9b64034b1$var$M("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $277dfbc9b64034b1$var$N[a] = new $277dfbc9b64034b1$var$M(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var $277dfbc9b64034b1$var$xa = /["'&<>]/;
function $277dfbc9b64034b1$var$O(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $277dfbc9b64034b1$var$xa.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
function $277dfbc9b64034b1$var$ya(a, b) {
    var c = $277dfbc9b64034b1$var$N.hasOwnProperty(a) ? $277dfbc9b64034b1$var$N[a] : null;
    var d;
    if (d = "style" !== a) d = null !== c ? 0 === c.type : !(2 < a.length) || "o" !== a[0] && "O" !== a[0] || "n" !== a[1] && "N" !== a[1] ? !1 : !0;
    if (d || $277dfbc9b64034b1$var$ua(a, b, c, !1)) return "";
    if (null !== c) {
        a = c.attributeName;
        d = c.type;
        if (3 === d || 4 === d && !0 === b) return a + '=""';
        c.sanitizeURL && (b = "" + b);
        return a + '="' + ($277dfbc9b64034b1$var$O(b) + '"');
    }
    return $277dfbc9b64034b1$var$sa(a) ? a + '="' + ($277dfbc9b64034b1$var$O(b) + '"') : "";
}
function $277dfbc9b64034b1$var$za(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $277dfbc9b64034b1$var$Aa = "function" === typeof Object.is ? Object.is : $277dfbc9b64034b1$var$za, $277dfbc9b64034b1$var$P = null, $277dfbc9b64034b1$var$Q = null, $277dfbc9b64034b1$var$R = null, $277dfbc9b64034b1$var$S = !1, $277dfbc9b64034b1$var$T = !1, $277dfbc9b64034b1$var$U = null, $277dfbc9b64034b1$var$V = 0;
function $277dfbc9b64034b1$var$W() {
    if (null === $277dfbc9b64034b1$var$P) throw Error($277dfbc9b64034b1$var$p(321));
    return $277dfbc9b64034b1$var$P;
}
function $277dfbc9b64034b1$var$Ba() {
    if (0 < $277dfbc9b64034b1$var$V) throw Error($277dfbc9b64034b1$var$p(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $277dfbc9b64034b1$var$Ca() {
    null === $277dfbc9b64034b1$var$R ? null === $277dfbc9b64034b1$var$Q ? ($277dfbc9b64034b1$var$S = !1, $277dfbc9b64034b1$var$Q = $277dfbc9b64034b1$var$R = $277dfbc9b64034b1$var$Ba()) : ($277dfbc9b64034b1$var$S = !0, $277dfbc9b64034b1$var$R = $277dfbc9b64034b1$var$Q) : null === $277dfbc9b64034b1$var$R.next ? ($277dfbc9b64034b1$var$S = !1, $277dfbc9b64034b1$var$R = $277dfbc9b64034b1$var$R.next = $277dfbc9b64034b1$var$Ba()) : ($277dfbc9b64034b1$var$S = !0, $277dfbc9b64034b1$var$R = $277dfbc9b64034b1$var$R.next);
    return $277dfbc9b64034b1$var$R;
}
function $277dfbc9b64034b1$var$Da(a, b, c, d) {
    for(; $277dfbc9b64034b1$var$T;)$277dfbc9b64034b1$var$T = !1, $277dfbc9b64034b1$var$V += 1, $277dfbc9b64034b1$var$R = null, c = a(b, d);
    $277dfbc9b64034b1$var$Ea();
    return c;
}
function $277dfbc9b64034b1$var$Ea() {
    $277dfbc9b64034b1$var$P = null;
    $277dfbc9b64034b1$var$T = !1;
    $277dfbc9b64034b1$var$Q = null;
    $277dfbc9b64034b1$var$V = 0;
    $277dfbc9b64034b1$var$R = $277dfbc9b64034b1$var$U = null;
}
function $277dfbc9b64034b1$var$Fa(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $277dfbc9b64034b1$var$Ga(a, b, c) {
    $277dfbc9b64034b1$var$P = $277dfbc9b64034b1$var$W();
    $277dfbc9b64034b1$var$R = $277dfbc9b64034b1$var$Ca();
    if ($277dfbc9b64034b1$var$S) {
        var d = $277dfbc9b64034b1$var$R.queue;
        b = d.dispatch;
        if (null !== $277dfbc9b64034b1$var$U && (c = $277dfbc9b64034b1$var$U.get(d), void 0 !== c)) {
            $277dfbc9b64034b1$var$U.delete(d);
            d = $277dfbc9b64034b1$var$R.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            $277dfbc9b64034b1$var$R.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            $277dfbc9b64034b1$var$R.memoizedState,
            b
        ];
    }
    a = a === $277dfbc9b64034b1$var$Fa ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    $277dfbc9b64034b1$var$R.memoizedState = a;
    a = $277dfbc9b64034b1$var$R.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $277dfbc9b64034b1$var$Ha.bind(null, $277dfbc9b64034b1$var$P, a);
    return [
        $277dfbc9b64034b1$var$R.memoizedState,
        a
    ];
}
function $277dfbc9b64034b1$var$Ia(a, b) {
    $277dfbc9b64034b1$var$P = $277dfbc9b64034b1$var$W();
    $277dfbc9b64034b1$var$R = $277dfbc9b64034b1$var$Ca();
    b = void 0 === b ? null : b;
    if (null !== $277dfbc9b64034b1$var$R) {
        var c = $277dfbc9b64034b1$var$R.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!$277dfbc9b64034b1$var$Aa(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    $277dfbc9b64034b1$var$R.memoizedState = [
        a,
        b
    ];
    return a;
}
function $277dfbc9b64034b1$var$Ha(a, b, c) {
    if (!(25 > $277dfbc9b64034b1$var$V)) throw Error($277dfbc9b64034b1$var$p(301));
    if (a === $277dfbc9b64034b1$var$P) {
        if ($277dfbc9b64034b1$var$T = !0, a = {
            action: c,
            next: null
        }, null === $277dfbc9b64034b1$var$U && ($277dfbc9b64034b1$var$U = new Map), c = $277dfbc9b64034b1$var$U.get(b), void 0 === c) $277dfbc9b64034b1$var$U.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $277dfbc9b64034b1$var$Ja() {}
var $277dfbc9b64034b1$var$X = null, $277dfbc9b64034b1$var$Ka = {
    readContext: function(a) {
        var b = $277dfbc9b64034b1$var$X.threadID;
        $277dfbc9b64034b1$var$I(a, b);
        return a[b];
    },
    useContext: function(a) {
        $277dfbc9b64034b1$var$W();
        var b = $277dfbc9b64034b1$var$X.threadID;
        $277dfbc9b64034b1$var$I(a, b);
        return a[b];
    },
    useMemo: $277dfbc9b64034b1$var$Ia,
    useReducer: $277dfbc9b64034b1$var$Ga,
    useRef: function(a) {
        $277dfbc9b64034b1$var$P = $277dfbc9b64034b1$var$W();
        $277dfbc9b64034b1$var$R = $277dfbc9b64034b1$var$Ca();
        var b = $277dfbc9b64034b1$var$R.memoizedState;
        return null === b ? (a = {
            current: a
        }, $277dfbc9b64034b1$var$R.memoizedState = a) : b;
    },
    useState: function(a) {
        return $277dfbc9b64034b1$var$Ga($277dfbc9b64034b1$var$Fa, a);
    },
    useLayoutEffect: function() {},
    useCallback: function(a, b) {
        return $277dfbc9b64034b1$var$Ia(function() {
            return a;
        }, b);
    },
    useImperativeHandle: $277dfbc9b64034b1$var$Ja,
    useEffect: $277dfbc9b64034b1$var$Ja,
    useDebugValue: $277dfbc9b64034b1$var$Ja,
    useDeferredValue: function(a) {
        $277dfbc9b64034b1$var$W();
        return a;
    },
    useTransition: function() {
        $277dfbc9b64034b1$var$W();
        return [
            function(a) {
                a();
            },
            !1
        ];
    },
    useOpaqueIdentifier: function() {
        return ($277dfbc9b64034b1$var$X.identifierPrefix || "") + "R:" + ($277dfbc9b64034b1$var$X.uniqueID++).toString(36);
    },
    useMutableSource: function(a, b) {
        $277dfbc9b64034b1$var$W();
        return b(a._source);
    }
}, $277dfbc9b64034b1$var$La = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function $277dfbc9b64034b1$var$Ma(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
var $277dfbc9b64034b1$var$Na = {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
}, $277dfbc9b64034b1$var$Oa = $8coUR({
    menuitem: !0
}, $277dfbc9b64034b1$var$Na), $277dfbc9b64034b1$var$Y = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $277dfbc9b64034b1$var$Pa = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($277dfbc9b64034b1$var$Y).forEach(function(a) {
    $277dfbc9b64034b1$var$Pa.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $277dfbc9b64034b1$var$Y[b] = $277dfbc9b64034b1$var$Y[a];
    });
});
var $277dfbc9b64034b1$var$Qa = /([A-Z])/g, $277dfbc9b64034b1$var$Ra = /^ms-/, $277dfbc9b64034b1$var$Z = $acw62.Children.toArray, $277dfbc9b64034b1$var$Sa = $277dfbc9b64034b1$var$la.ReactCurrentDispatcher, $277dfbc9b64034b1$var$Ta = {
    listing: !0,
    pre: !0,
    textarea: !0
}, $277dfbc9b64034b1$var$Ua = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $277dfbc9b64034b1$var$Va = {}, $277dfbc9b64034b1$var$Wa = {};
function $277dfbc9b64034b1$var$Xa(a) {
    if (void 0 === a || null === a) return a;
    var b = "";
    $acw62.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
var $277dfbc9b64034b1$var$Ya = Object.prototype.hasOwnProperty, $277dfbc9b64034b1$var$Za = {
    children: null,
    dangerouslySetInnerHTML: null,
    suppressContentEditableWarning: null,
    suppressHydrationWarning: null
};
function $277dfbc9b64034b1$var$$a(a, b) {
    if (void 0 === a) throw Error($277dfbc9b64034b1$var$p(152, $277dfbc9b64034b1$var$F(b) || "Component"));
}
function $277dfbc9b64034b1$var$ab(a, b, c) {
    function d(d, h) {
        var e = h.prototype && h.prototype.isReactComponent, f = $277dfbc9b64034b1$var$na(h, b, c, e), t = [], g = !1, n = {
            isMounted: function() {
                return !1;
            },
            enqueueForceUpdate: function() {
                if (null === t) return null;
            },
            enqueueReplaceState: function(a, c) {
                g = !0;
                t = [
                    c
                ];
            },
            enqueueSetState: function(a, c) {
                if (null === t) return null;
                t.push(c);
            }
        };
        if (e) {
            if (e = new h(d.props, f, n), "function" === typeof h.getDerivedStateFromProps) {
                var k = h.getDerivedStateFromProps.call(null, d.props, e.state);
                null != k && (e.state = $8coUR({}, e.state, k));
            }
        } else if ($277dfbc9b64034b1$var$P = {}, e = h(d.props, f, n), e = $277dfbc9b64034b1$var$Da(h, d.props, e, f), null == e || null == e.render) {
            a = e;
            $277dfbc9b64034b1$var$$a(a, h);
            return;
        }
        e.props = d.props;
        e.context = f;
        e.updater = n;
        n = e.state;
        void 0 === n && (e.state = n = null);
        if ("function" === typeof e.UNSAFE_componentWillMount || "function" === typeof e.componentWillMount) {
            if ("function" === typeof e.componentWillMount && "function" !== typeof h.getDerivedStateFromProps && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && "function" !== typeof h.getDerivedStateFromProps && e.UNSAFE_componentWillMount(), t.length) {
                n = t;
                var v = g;
                t = null;
                g = !1;
                if (v && 1 === n.length) e.state = n[0];
                else {
                    k = v ? n[0] : e.state;
                    var H = !0;
                    for(v = v ? 1 : 0; v < n.length; v++){
                        var x = n[v];
                        x = "function" === typeof x ? x.call(e, k, d.props, f) : x;
                        null != x && (H ? (H = !1, k = $8coUR({}, k, x)) : $8coUR(k, x));
                    }
                    e.state = k;
                }
            } else t = null;
        }
        a = e.render();
        $277dfbc9b64034b1$var$$a(a, h);
        if ("function" === typeof e.getChildContext && (d = h.childContextTypes, "object" === typeof d)) {
            var y = e.getChildContext();
            for(var A in y)if (!(A in d)) throw Error($277dfbc9b64034b1$var$p(108, $277dfbc9b64034b1$var$F(h) || "Unknown", A));
        }
        y && (b = $8coUR({}, b, y));
    }
    for(; $acw62.isValidElement(a);){
        var f = a, h = f.type;
        if ("function" !== typeof h) break;
        d(f, h);
    }
    return {
        child: a,
        context: b
    };
}
var $277dfbc9b64034b1$var$bb = function() {
    function a(a, b, f) {
        $acw62.isValidElement(a) ? a.type !== $277dfbc9b64034b1$var$r ? a = [
            a
        ] : (a = a.props.children, a = $acw62.isValidElement(a) ? [
            a
        ] : $277dfbc9b64034b1$var$Z(a)) : a = $277dfbc9b64034b1$var$Z(a);
        a = {
            type: null,
            domNamespace: $277dfbc9b64034b1$var$La.html,
            children: a,
            childIndex: 0,
            context: $277dfbc9b64034b1$var$ma,
            footer: ""
        };
        var c = $277dfbc9b64034b1$var$J[0];
        if (0 === c) {
            var d = $277dfbc9b64034b1$var$J;
            c = d.length;
            var g = 2 * c;
            if (!(65536 >= g)) throw Error($277dfbc9b64034b1$var$p(304));
            var e = new Uint16Array(g);
            e.set(d);
            $277dfbc9b64034b1$var$J = e;
            $277dfbc9b64034b1$var$J[0] = c + 1;
            for(d = c; d < g - 1; d++)$277dfbc9b64034b1$var$J[d] = d + 1;
            $277dfbc9b64034b1$var$J[g - 1] = 0;
        } else $277dfbc9b64034b1$var$J[0] = $277dfbc9b64034b1$var$J[c];
        this.threadID = c;
        this.stack = [
            a
        ];
        this.exhausted = !1;
        this.currentSelectValue = null;
        this.previousWasTextNode = !1;
        this.makeStaticMarkup = b;
        this.suspenseDepth = 0;
        this.contextIndex = -1;
        this.contextStack = [];
        this.contextValueStack = [];
        this.uniqueID = 0;
        this.identifierPrefix = f && f.identifierPrefix || "";
    }
    var b = a.prototype;
    b.destroy = function() {
        if (!this.exhausted) {
            this.exhausted = !0;
            this.clearProviders();
            var a = this.threadID;
            $277dfbc9b64034b1$var$J[a] = $277dfbc9b64034b1$var$J[0];
            $277dfbc9b64034b1$var$J[0] = a;
        }
    };
    b.pushProvider = function(a) {
        var b = ++this.contextIndex, c = a.type._context, h = this.threadID;
        $277dfbc9b64034b1$var$I(c, h);
        var t = c[h];
        this.contextStack[b] = c;
        this.contextValueStack[b] = t;
        c[h] = a.props.value;
    };
    b.popProvider = function() {
        var a = this.contextIndex, b = this.contextStack[a], f = this.contextValueStack[a];
        this.contextStack[a] = null;
        this.contextValueStack[a] = null;
        this.contextIndex--;
        b[this.threadID] = f;
    };
    b.clearProviders = function() {
        for(var a = this.contextIndex; 0 <= a; a--)this.contextStack[a][this.threadID] = this.contextValueStack[a];
    };
    b.read = function(a) {
        if (this.exhausted) return null;
        var b = $277dfbc9b64034b1$var$X;
        $277dfbc9b64034b1$var$X = this;
        var c = $277dfbc9b64034b1$var$Sa.current;
        $277dfbc9b64034b1$var$Sa.current = $277dfbc9b64034b1$var$Ka;
        try {
            for(var h = [
                ""
            ], t = !1; h[0].length < a;){
                if (0 === this.stack.length) {
                    this.exhausted = !0;
                    var g = this.threadID;
                    $277dfbc9b64034b1$var$J[g] = $277dfbc9b64034b1$var$J[0];
                    $277dfbc9b64034b1$var$J[0] = g;
                    break;
                }
                var e = this.stack[this.stack.length - 1];
                if (t || e.childIndex >= e.children.length) {
                    var L = e.footer;
                    "" !== L && (this.previousWasTextNode = !1);
                    this.stack.pop();
                    if ("select" === e.type) this.currentSelectValue = null;
                    else if (null != e.type && null != e.type.type && e.type.type.$$typeof === $277dfbc9b64034b1$var$B) this.popProvider(e.type);
                    else if (e.type === $277dfbc9b64034b1$var$D) {
                        this.suspenseDepth--;
                        var G = h.pop();
                        if (t) {
                            t = !1;
                            var C = e.fallbackFrame;
                            if (!C) throw Error($277dfbc9b64034b1$var$p(303));
                            this.stack.push(C);
                            h[this.suspenseDepth] += "<!--$!-->";
                            continue;
                        } else h[this.suspenseDepth] += G;
                    }
                    h[this.suspenseDepth] += L;
                } else {
                    var n = e.children[e.childIndex++], k = "";
                    try {
                        k += this.render(n, e.context, e.domNamespace);
                    } catch (v) {
                        if (null != v && "function" === typeof v.then) throw Error($277dfbc9b64034b1$var$p(294));
                        throw v;
                    } finally{}
                    h.length <= this.suspenseDepth && h.push("");
                    h[this.suspenseDepth] += k;
                }
            }
            return h[0];
        } finally{
            $277dfbc9b64034b1$var$Sa.current = c, $277dfbc9b64034b1$var$X = b, $277dfbc9b64034b1$var$Ea();
        }
    };
    b.render = function(a, b, f) {
        if ("string" === typeof a || "number" === typeof a) {
            f = "" + a;
            if ("" === f) return "";
            if (this.makeStaticMarkup) return $277dfbc9b64034b1$var$O(f);
            if (this.previousWasTextNode) return "<!-- -->" + $277dfbc9b64034b1$var$O(f);
            this.previousWasTextNode = !0;
            return $277dfbc9b64034b1$var$O(f);
        }
        b = $277dfbc9b64034b1$var$ab(a, b, this.threadID);
        a = b.child;
        b = b.context;
        if (null === a || !1 === a) return "";
        if (!$acw62.isValidElement(a)) {
            if (null != a && null != a.$$typeof) {
                f = a.$$typeof;
                if (f === $277dfbc9b64034b1$var$q) throw Error($277dfbc9b64034b1$var$p(257));
                throw Error($277dfbc9b64034b1$var$p(258, f.toString()));
            }
            a = $277dfbc9b64034b1$var$Z(a);
            this.stack.push({
                type: null,
                domNamespace: f,
                children: a,
                childIndex: 0,
                context: b,
                footer: ""
            });
            return "";
        }
        var c = a.type;
        if ("string" === typeof c) return this.renderDOM(a, b, f);
        switch(c){
            case $277dfbc9b64034b1$var$ka:
            case $277dfbc9b64034b1$var$ja:
            case $277dfbc9b64034b1$var$u:
            case $277dfbc9b64034b1$var$z:
            case $277dfbc9b64034b1$var$ca:
            case $277dfbc9b64034b1$var$r:
                return a = $277dfbc9b64034b1$var$Z(a.props.children), this.stack.push({
                    type: null,
                    domNamespace: f,
                    children: a,
                    childIndex: 0,
                    context: b,
                    footer: ""
                }), "";
            case $277dfbc9b64034b1$var$D:
                throw Error($277dfbc9b64034b1$var$p(294));
            case $277dfbc9b64034b1$var$ia:
                throw Error($277dfbc9b64034b1$var$p(343));
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $277dfbc9b64034b1$var$ba:
                $277dfbc9b64034b1$var$P = {};
                var d = c.render(a.props, a.ref);
                d = $277dfbc9b64034b1$var$Da(c.render, a.props, d, a.ref);
                d = $277dfbc9b64034b1$var$Z(d);
                this.stack.push({
                    type: null,
                    domNamespace: f,
                    children: d,
                    childIndex: 0,
                    context: b,
                    footer: ""
                });
                return "";
            case $277dfbc9b64034b1$var$da:
                return a = [
                    $acw62.createElement(c.type, $8coUR({
                        ref: a.ref
                    }, a.props))
                ], this.stack.push({
                    type: null,
                    domNamespace: f,
                    children: a,
                    childIndex: 0,
                    context: b,
                    footer: ""
                }), "";
            case $277dfbc9b64034b1$var$B:
                return c = $277dfbc9b64034b1$var$Z(a.props.children), f = {
                    type: a,
                    domNamespace: f,
                    children: c,
                    childIndex: 0,
                    context: b,
                    footer: ""
                }, this.pushProvider(a), this.stack.push(f), "";
            case $277dfbc9b64034b1$var$aa:
                c = a.type;
                d = a.props;
                var g = this.threadID;
                $277dfbc9b64034b1$var$I(c, g);
                c = $277dfbc9b64034b1$var$Z(d.children(c[g]));
                this.stack.push({
                    type: a,
                    domNamespace: f,
                    children: c,
                    childIndex: 0,
                    context: b,
                    footer: ""
                });
                return "";
            case $277dfbc9b64034b1$var$ha:
                throw Error($277dfbc9b64034b1$var$p(338));
            case $277dfbc9b64034b1$var$ea:
                return c = a.type, d = c._init, c = d(c._payload), a = [
                    $acw62.createElement(c, $8coUR({
                        ref: a.ref
                    }, a.props))
                ], this.stack.push({
                    type: null,
                    domNamespace: f,
                    children: a,
                    childIndex: 0,
                    context: b,
                    footer: ""
                }), "";
        }
        throw Error($277dfbc9b64034b1$var$p(130, null == c ? c : typeof c, ""));
    };
    b.renderDOM = function(a, b, f) {
        var c = a.type.toLowerCase();
        f === $277dfbc9b64034b1$var$La.html && $277dfbc9b64034b1$var$Ma(c);
        if (!$277dfbc9b64034b1$var$Va.hasOwnProperty(c)) {
            if (!$277dfbc9b64034b1$var$Ua.test(c)) throw Error($277dfbc9b64034b1$var$p(65, c));
            $277dfbc9b64034b1$var$Va[c] = !0;
        }
        var d = a.props;
        if ("input" === c) d = $8coUR({
            type: void 0
        }, d, {
            defaultChecked: void 0,
            defaultValue: void 0,
            value: null != d.value ? d.value : d.defaultValue,
            checked: null != d.checked ? d.checked : d.defaultChecked
        });
        else if ("textarea" === c) {
            var g = d.value;
            if (null == g) {
                g = d.defaultValue;
                var e = d.children;
                if (null != e) {
                    if (null != g) throw Error($277dfbc9b64034b1$var$p(92));
                    if (Array.isArray(e)) {
                        if (!(1 >= e.length)) throw Error($277dfbc9b64034b1$var$p(93));
                        e = e[0];
                    }
                    g = "" + e;
                }
                null == g && (g = "");
            }
            d = $8coUR({}, d, {
                value: void 0,
                children: "" + g
            });
        } else if ("select" === c) this.currentSelectValue = null != d.value ? d.value : d.defaultValue, d = $8coUR({}, d, {
            value: void 0
        });
        else if ("option" === c) {
            e = this.currentSelectValue;
            var L = $277dfbc9b64034b1$var$Xa(d.children);
            if (null != e) {
                var G = null != d.value ? d.value + "" : L;
                g = !1;
                if (Array.isArray(e)) {
                    for(var C = 0; C < e.length; C++)if ("" + e[C] === G) {
                        g = !0;
                        break;
                    }
                } else g = "" + e === G;
                d = $8coUR({
                    selected: void 0,
                    children: void 0
                }, d, {
                    selected: g,
                    children: L
                });
            }
        }
        if (g = d) {
            if ($277dfbc9b64034b1$var$Oa[c] && (null != g.children || null != g.dangerouslySetInnerHTML)) throw Error($277dfbc9b64034b1$var$p(137, c));
            if (null != g.dangerouslySetInnerHTML) {
                if (null != g.children) throw Error($277dfbc9b64034b1$var$p(60));
                if (!("object" === typeof g.dangerouslySetInnerHTML && "__html" in g.dangerouslySetInnerHTML)) throw Error($277dfbc9b64034b1$var$p(61));
            }
            if (null != g.style && "object" !== typeof g.style) throw Error($277dfbc9b64034b1$var$p(62));
        }
        g = d;
        e = this.makeStaticMarkup;
        L = 1 === this.stack.length;
        G = "<" + a.type;
        b: if (-1 === c.indexOf("-")) C = "string" === typeof g.is;
        else switch(c){
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
                C = !1;
                break b;
            default:
                C = !0;
        }
        for(w in g)if ($277dfbc9b64034b1$var$Ya.call(g, w)) {
            var n = g[w];
            if (null != n) {
                if ("style" === w) {
                    var k = void 0, v = "", H = "";
                    for(k in n)if (n.hasOwnProperty(k)) {
                        var x = 0 === k.indexOf("--"), y = n[k];
                        if (null != y) {
                            if (x) var A = k;
                            else if (A = k, $277dfbc9b64034b1$var$Wa.hasOwnProperty(A)) A = $277dfbc9b64034b1$var$Wa[A];
                            else {
                                var cb = A.replace($277dfbc9b64034b1$var$Qa, "-$1").toLowerCase().replace($277dfbc9b64034b1$var$Ra, "-ms-");
                                A = $277dfbc9b64034b1$var$Wa[A] = cb;
                            }
                            v += H + A + ":";
                            H = k;
                            x = null == y || "boolean" === typeof y || "" === y ? "" : x || "number" !== typeof y || 0 === y || $277dfbc9b64034b1$var$Y.hasOwnProperty(H) && $277dfbc9b64034b1$var$Y[H] ? ("" + y).trim() : y + "px";
                            v += x;
                            H = ";";
                        }
                    }
                    n = v || null;
                }
                k = null;
                C ? $277dfbc9b64034b1$var$Za.hasOwnProperty(w) || (k = w, k = $277dfbc9b64034b1$var$sa(k) && null != n ? k + '="' + ($277dfbc9b64034b1$var$O(n) + '"') : "") : k = $277dfbc9b64034b1$var$ya(w, n);
                k && (G += " " + k);
            }
        }
        e || L && (G += ' data-reactroot=""');
        var w = G;
        g = "";
        $277dfbc9b64034b1$var$Na.hasOwnProperty(c) ? w += "/>" : (w += ">", g = "</" + a.type + ">");
        a: {
            e = d.dangerouslySetInnerHTML;
            if (null != e) {
                if (null != e.__html) {
                    e = e.__html;
                    break a;
                }
            } else if (e = d.children, "string" === typeof e || "number" === typeof e) {
                e = $277dfbc9b64034b1$var$O(e);
                break a;
            }
            e = null;
        }
        null != e ? (d = [], $277dfbc9b64034b1$var$Ta.hasOwnProperty(c) && "\n" === e.charAt(0) && (w += "\n"), w += e) : d = $277dfbc9b64034b1$var$Z(d.children);
        a = a.type;
        f = null == f || "http://www.w3.org/1999/xhtml" === f ? $277dfbc9b64034b1$var$Ma(a) : "http://www.w3.org/2000/svg" === f && "foreignObject" === a ? "http://www.w3.org/1999/xhtml" : f;
        this.stack.push({
            domNamespace: f,
            type: c,
            children: d,
            childIndex: 0,
            context: b,
            footer: g
        });
        this.previousWasTextNode = !1;
        return w;
    };
    return a;
}();
$277dfbc9b64034b1$export$307591e98609eddd = function() {
    throw Error($277dfbc9b64034b1$var$p(207));
};
$277dfbc9b64034b1$export$eb3a06aef9e6ee51 = function(a, b) {
    a = new $277dfbc9b64034b1$var$bb(a, !0, b);
    try {
        return a.read(Infinity);
    } finally{
        a.destroy();
    }
};
$277dfbc9b64034b1$export$b23711c915539651 = function() {
    throw Error($277dfbc9b64034b1$var$p(208));
};
$277dfbc9b64034b1$export$80e7718417253a51 = function(a, b) {
    a = new $277dfbc9b64034b1$var$bb(a, !1, b);
    try {
        return a.read(Infinity);
    } finally{
        a.destroy();
    }
};
$277dfbc9b64034b1$export$83d89fbfd8236492 = "17.0.2";

});



parcelRegister("eQY4r", function(module, exports) {
"use strict";
var $ad0484d064610f51$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $ad0484d064610f51$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $ad0484d064610f51$var$react_1 = $ad0484d064610f51$var$__importDefault((parcelRequire("acw62")));
parcelRequire("42Cuq");
var $7zMpb = parcelRequire("7zMpb");
const $ad0484d064610f51$var$BtnCellRenderer = (_a)=>{
    var { clicked: clicked, value: value, data: data, color: color } = _a, rest = $ad0484d064610f51$var$__rest(_a, [
        "clicked",
        "value",
        "data",
        "color"
    ]);
    return $ad0484d064610f51$var$react_1.default.createElement($7zMpb.default, {
        dataLwtId: "button-cell-renderer-button-id",
        color: color,
        onClick: ()=>clicked({
                value: value,
                data: data
            })
    }, value);
};
module.exports.default = $ad0484d064610f51$var$BtnCellRenderer;

});
parcelRegister("42Cuq", function(module, exports) {

$parcel$export(module.exports, "Button", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("7zMpb")))));

var $3MHNf = parcelRequire("3MHNf");

var $a3BmB = parcelRequire("a3BmB");

var $6e1HC = parcelRequire("6e1HC");

var $7zMpb = parcelRequire("7zMpb");

var $2iJ7H = parcelRequire("2iJ7H");

});
parcelRegister("3MHNf", function(module, exports) {
"use strict";
var $2c17d340208f53c9$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $2c17d340208f53c9$var$react_1 = $2c17d340208f53c9$var$__importDefault((parcelRequire("acw62")));

const $2c17d340208f53c9$var$classnames_1 = $2c17d340208f53c9$var$__importDefault((parcelRequire("8g1PZ")));

var $3j2Q3 = parcelRequire("3j2Q3");
const $2c17d340208f53c9$var$ButtonToolbar = (props)=>{
    const { className: //
    className, title: title = "Page Title", border: border, children: children, dataLwtId: dataLwtId, role: role = "toolbar", ...restProps } = props;
    const classes = (0, $2c17d340208f53c9$var$classnames_1.default)(className, "btn-toolbar align-items-center", border ? "border-bottom mb-4 pb-3" : false);
    const optionalProps = {};
    if (dataLwtId) optionalProps["data-lwt-id"] = dataLwtId;
    return $2c17d340208f53c9$var$react_1.default.createElement($3j2Q3.default, {
        optionalProps: true,
        className: classes,
        role: role,
        ...restProps
    }, $2c17d340208f53c9$var$react_1.default.createElement("h2", {
        className: "mb-0 mr-auto"
    }, title), children);
};
module.exports.default = $2c17d340208f53c9$var$ButtonToolbar;

});
parcelRegister("8g1PZ", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = "";
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") return arg;
        if (typeof arg !== "object") return "";
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) return arg.toString();
        var classes = "";
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + " " + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRegister("3j2Q3", function(module, exports) {

$parcel$export(module.exports, "default", () => $26855921d10f9a44$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $e9hDx = parcelRequire("e9hDx");
var $26855921d10f9a44$var$propTypes = {
    tag: (0, $e9hDx.tagPropType),
    "aria-label": (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    role: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};
var $26855921d10f9a44$var$defaultProps = {
    tag: "div",
    role: "toolbar"
};
var $26855921d10f9a44$var$ButtonToolbar = function ButtonToolbar(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, attributes = (0, $1En50.default)(props, [
        "className",
        "cssModule",
        "tag"
    ]);
    var classes = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, "btn-toolbar"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({}, attributes, {
        className: classes
    }));
};
$26855921d10f9a44$var$ButtonToolbar.propTypes = $26855921d10f9a44$var$propTypes;
$26855921d10f9a44$var$ButtonToolbar.defaultProps = $26855921d10f9a44$var$defaultProps;
var $26855921d10f9a44$export$2e2bcd8739ae039 = $26855921d10f9a44$var$ButtonToolbar;

});
parcelRegister("e9hDx", function(module, exports) {

$parcel$export(module.exports, "setScrollbarWidth", () => $a4cf9640e316aac0$export$525633cdbd0969b);
$parcel$export(module.exports, "getOriginalBodyPadding", () => $a4cf9640e316aac0$export$f6a6870365e84923);
$parcel$export(module.exports, "conditionallyUpdateScrollbar", () => $a4cf9640e316aac0$export$999f192bbd2b2d9e);
$parcel$export(module.exports, "mapToCssModules", () => $a4cf9640e316aac0$export$30a9f098026c5d15);
$parcel$export(module.exports, "omit", () => $a4cf9640e316aac0$export$30a06c8d3562193f);
$parcel$export(module.exports, "pick", () => $a4cf9640e316aac0$export$357523c63a2253b9);
$parcel$export(module.exports, "warnOnce", () => $a4cf9640e316aac0$export$5b28268982f175ba);
$parcel$export(module.exports, "DOMElement", () => $a4cf9640e316aac0$export$97d587dc2049b818);
$parcel$export(module.exports, "targetPropType", () => $a4cf9640e316aac0$export$41ef22d2f70c9575);
$parcel$export(module.exports, "tagPropType", () => $a4cf9640e316aac0$export$ba0f6daf9558be46);
$parcel$export(module.exports, "TransitionTimeouts", () => $a4cf9640e316aac0$export$b725afd3e8acce35);
$parcel$export(module.exports, "TransitionPropTypeKeys", () => $a4cf9640e316aac0$export$33d93b05441a6936);
$parcel$export(module.exports, "keyCodes", () => $a4cf9640e316aac0$export$6d3e562ac77a9517);
$parcel$export(module.exports, "PopperPlacements", () => $a4cf9640e316aac0$export$b8db120174e0a6fa);
$parcel$export(module.exports, "canUseDOM", () => $a4cf9640e316aac0$export$71594e8a50f746f4);
$parcel$export(module.exports, "isObject", () => $a4cf9640e316aac0$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "getTarget", () => $a4cf9640e316aac0$export$c22522a4dfa48e9c);
$parcel$export(module.exports, "focusableElements", () => $a4cf9640e316aac0$export$e2690578cac908dd);

var $c9Z8w = parcelRequire("c9Z8w");
function $a4cf9640e316aac0$export$ace028f8da1a6300() {
    var scrollDiv = document.createElement("div"); // .modal-scrollbar-measure styles // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/scss/_modal.scss#L106-L113
    scrollDiv.style.position = "absolute";
    scrollDiv.style.top = "-9999px";
    scrollDiv.style.width = "50px";
    scrollDiv.style.height = "50px";
    scrollDiv.style.overflow = "scroll";
    document.body.appendChild(scrollDiv);
    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollbarWidth;
}
function $a4cf9640e316aac0$export$525633cdbd0969b(padding) {
    document.body.style.paddingRight = padding > 0 ? padding + "px" : null;
}
function $a4cf9640e316aac0$export$31b5c8f1131a3a52() {
    return document.body.clientWidth < window.innerWidth;
}
function $a4cf9640e316aac0$export$f6a6870365e84923() {
    var style = window.getComputedStyle(document.body, null);
    return parseInt(style && style.getPropertyValue("padding-right") || 0, 10);
}
function $a4cf9640e316aac0$export$999f192bbd2b2d9e() {
    var scrollbarWidth = $a4cf9640e316aac0$export$ace028f8da1a6300(); // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.6/js/src/modal.js#L433
    var fixedContent = document.querySelectorAll(".fixed-top, .fixed-bottom, .is-fixed, .sticky-top")[0];
    var bodyPadding = fixedContent ? parseInt(fixedContent.style.paddingRight || 0, 10) : 0;
    if ($a4cf9640e316aac0$export$31b5c8f1131a3a52()) $a4cf9640e316aac0$export$525633cdbd0969b(bodyPadding + scrollbarWidth);
}
var $a4cf9640e316aac0$var$globalCssModule;
function $a4cf9640e316aac0$export$e66f39a23d6009b0(cssModule) {
    $a4cf9640e316aac0$var$globalCssModule = cssModule;
}
function $a4cf9640e316aac0$export$30a9f098026c5d15(className, cssModule) {
    if (className === void 0) className = "";
    if (cssModule === void 0) cssModule = $a4cf9640e316aac0$var$globalCssModule;
    if (!cssModule) return className;
    return className.split(" ").map(function(c) {
        return cssModule[c] || c;
    }).join(" ");
}
function $a4cf9640e316aac0$export$30a06c8d3562193f(obj, omitKeys) {
    var result = {};
    Object.keys(obj).forEach(function(key) {
        if (omitKeys.indexOf(key) === -1) result[key] = obj[key];
    });
    return result;
}
function $a4cf9640e316aac0$export$357523c63a2253b9(obj, keys) {
    var pickKeys = Array.isArray(keys) ? keys : [
        keys
    ];
    var length = pickKeys.length;
    var key;
    var result = {};
    while(length > 0){
        length -= 1;
        key = pickKeys[length];
        result[key] = obj[key];
    }
    return result;
}
var $a4cf9640e316aac0$var$warned = {};
function $a4cf9640e316aac0$export$5b28268982f175ba(message) {
    if (!$a4cf9640e316aac0$var$warned[message]) {
        /* istanbul ignore else */ if (typeof console !== "undefined") console.error(message); // eslint-disable-line no-console
        $a4cf9640e316aac0$var$warned[message] = true;
    }
}
function $a4cf9640e316aac0$export$cdd73fc4100a6ef4(propType, explanation) {
    return function validate(props, propName, componentName) {
        if (props[propName] !== null && typeof props[propName] !== "undefined") $a4cf9640e316aac0$export$5b28268982f175ba('"' + propName + '" property of "' + componentName + '" has been deprecated.\n' + explanation);
        for(var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)rest[_key - 3] = arguments[_key];
        return propType.apply(void 0, [
            props,
            propName,
            componentName
        ].concat(rest));
    };
} // Shim Element if needed (e.g. in Node environment)
var $a4cf9640e316aac0$var$Element = typeof window === "object" && window.Element || function() {};
function $a4cf9640e316aac0$export$97d587dc2049b818(props, propName, componentName) {
    if (!(props[propName] instanceof $a4cf9640e316aac0$var$Element)) return new Error("Invalid prop `" + propName + "` supplied to `" + componentName + "`. Expected prop to be an instance of Element. Validation failed.");
}
var $a4cf9640e316aac0$export$41ef22d2f70c9575 = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    $a4cf9640e316aac0$export$97d587dc2049b818,
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        current: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any
    })
]);
var $a4cf9640e316aac0$export$ba0f6daf9558be46 = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        $$typeof: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).symbol,
        render: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
    }),
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            $$typeof: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).symbol,
            render: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
        })
    ]))
]);
var $a4cf9640e316aac0$export$b725afd3e8acce35 = {
    Fade: 150,
    // $transition-fade
    Collapse: 350,
    // $transition-collapse
    Modal: 300,
    // $modal-transition
    Carousel: 600 // $carousel-transition
}; // Duplicated Transition.propType keys to ensure that Reactstrap builds
var $a4cf9640e316aac0$export$33d93b05441a6936 = [
    "in",
    "mountOnEnter",
    "unmountOnExit",
    "appear",
    "enter",
    "exit",
    "timeout",
    "onEnter",
    "onEntering",
    "onEntered",
    "onExit",
    "onExiting",
    "onExited"
];
var $a4cf9640e316aac0$export$9f15c0603df35428 = {
    ENTERING: "entering",
    ENTERED: "entered",
    EXITING: "exiting",
    EXITED: "exited"
};
var $a4cf9640e316aac0$export$6d3e562ac77a9517 = {
    esc: 27,
    space: 32,
    enter: 13,
    tab: 9,
    up: 38,
    down: 40,
    home: 36,
    end: 35,
    n: 78,
    p: 80
};
var $a4cf9640e316aac0$export$b8db120174e0a6fa = [
    "auto-start",
    "auto",
    "auto-end",
    "top-start",
    "top",
    "top-end",
    "right-start",
    "right",
    "right-end",
    "bottom-end",
    "bottom",
    "bottom-start",
    "left-end",
    "left",
    "left-start"
];
var $a4cf9640e316aac0$export$71594e8a50f746f4 = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $a4cf9640e316aac0$export$e10d8bcaa14e0681(target) {
    if (target && typeof target === "object") return "current" in target;
    return false;
}
function $a4cf9640e316aac0$var$getTag(value) {
    if (value == null) return value === undefined ? "[object Undefined]" : "[object Null]";
    return Object.prototype.toString.call(value);
}
function $a4cf9640e316aac0$export$a0a81dc3380ce7d3(value) {
    var type = typeof value;
    var NAN = 0 / 0;
    if (type === "number") return value;
    if (type === "symbol" || type === "object" && $a4cf9640e316aac0$var$getTag(value) === "[object Symbol]") return NAN;
    if ($a4cf9640e316aac0$export$a6cdc56e425d0d0a(value)) {
        var other = typeof value.valueOf === "function" ? value.valueOf() : value;
        value = $a4cf9640e316aac0$export$a6cdc56e425d0d0a(other) ? "" + other : other;
    }
    if (type !== "string") return value === 0 ? value : +value;
    value = value.replace(/^\s+|\s+$/g, "");
    var isBinary = /^0b[01]+$/i.test(value);
    return isBinary || /^0o[0-7]+$/i.test(value) ? parseInt(value.slice(2), isBinary ? 2 : 8) : /^[-+]0x[0-9a-f]+$/i.test(value) ? NAN : +value;
}
function $a4cf9640e316aac0$export$a6cdc56e425d0d0a(value) {
    var type = typeof value;
    return value != null && (type === "object" || type === "function");
}
function $a4cf9640e316aac0$export$f6e2535fb5126e54(value) {
    if (!$a4cf9640e316aac0$export$a6cdc56e425d0d0a(value)) return false;
    var tag = $a4cf9640e316aac0$var$getTag(value);
    return tag === "[object Function]" || tag === "[object AsyncFunction]" || tag === "[object GeneratorFunction]" || tag === "[object Proxy]";
}
function $a4cf9640e316aac0$export$296b302fe9d56784(target) {
    if ($a4cf9640e316aac0$export$e10d8bcaa14e0681(target)) return target.current;
    if ($a4cf9640e316aac0$export$f6e2535fb5126e54(target)) return target();
    if (typeof target === "string" && $a4cf9640e316aac0$export$71594e8a50f746f4) {
        var selection = document.querySelectorAll(target);
        if (!selection.length) selection = document.querySelectorAll("#" + target);
        if (!selection.length) throw new Error("The target '" + target + "' could not be identified in the dom, tip: check spelling");
        return selection;
    }
    return target;
}
function $a4cf9640e316aac0$export$3aa3c75b371c352f(els) {
    if (els === null) return false;
    return Array.isArray(els) || $a4cf9640e316aac0$export$71594e8a50f746f4 && typeof els.length === "number";
}
function $a4cf9640e316aac0$export$c22522a4dfa48e9c(target, allElements) {
    var els = $a4cf9640e316aac0$export$296b302fe9d56784(target);
    if (allElements) {
        if ($a4cf9640e316aac0$export$3aa3c75b371c352f(els)) return els;
        if (els === null) return [];
        return [
            els
        ];
    } else {
        if ($a4cf9640e316aac0$export$3aa3c75b371c352f(els)) return els[0];
        return els;
    }
}
var $a4cf9640e316aac0$export$6723c67dee1450cf = [
    "touchstart",
    "click"
];
function $a4cf9640e316aac0$export$544835a2f8292483(_els, handler, _events, useCapture) {
    var els = _els;
    if (!$a4cf9640e316aac0$export$3aa3c75b371c352f(els)) els = [
        els
    ];
    var events = _events;
    if (typeof events === "string") events = events.split(/\s+/);
    if (!$a4cf9640e316aac0$export$3aa3c75b371c352f(els) || typeof handler !== "function" || !Array.isArray(events)) throw new Error("\n      The first argument of this function must be DOM node or an array on DOM nodes or NodeList.\n      The second must be a function.\n      The third is a string or an array of strings that represents DOM events\n    ");
    Array.prototype.forEach.call(events, function(event) {
        Array.prototype.forEach.call(els, function(el) {
            el.addEventListener(event, handler, useCapture);
        });
    });
    return function removeEvents() {
        Array.prototype.forEach.call(events, function(event) {
            Array.prototype.forEach.call(els, function(el) {
                el.removeEventListener(event, handler, useCapture);
            });
        });
    };
}
var $a4cf9640e316aac0$export$e2690578cac908dd = [
    "a[href]",
    "area[href]",
    "input:not([disabled]):not([type=hidden])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "button:not([disabled])",
    "object",
    "embed",
    "[tabindex]:not(.modal)",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])'
];

});



parcelRegister("a3BmB", function(module, exports) {
"use strict";
var $75272acffa228a0d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $75272acffa228a0d$var$react_1 = $75272acffa228a0d$var$__importDefault((parcelRequire("acw62")));
parcelRequire("42Cuq");
var $7zMpb = parcelRequire("7zMpb");

const $75272acffa228a0d$var$icon_1 = $75272acffa228a0d$var$__importDefault((parcelRequire("lz1xm")));

const $75272acffa228a0d$var$tooltip_1 = $75272acffa228a0d$var$__importDefault((parcelRequire("brMfV")));

var $bew0G = parcelRequire("bew0G");
const $75272acffa228a0d$var$ButtonIcon = (props)=>{
    const { id: //
    id, iconClass: iconClass, iconName: iconName, disabled: disabled, label: label, dataLwtId: dataLwtId, ...restButton } = props;
    const uid = (0, $bew0G.useUID)();
    const optionalProps = {};
    if (dataLwtId) optionalProps["data-lwt-id"] = dataLwtId;
    const optionalPropsIcon = {
        dataLwtId: "icon"
    };
    if (dataLwtId) optionalPropsIcon["dataLwtId"] = `${dataLwtId}-icon`;
    return $75272acffa228a0d$var$react_1.default.createElement($7zMpb.default, {
        ...optionalProps,
        ...restButton,
        id: id || `button-icon-${uid}`,
        disabled: disabled
    }, $75272acffa228a0d$var$react_1.default.createElement($75272acffa228a0d$var$icon_1.default, {
        ...optionalPropsIcon,
        disabled: disabled,
        className: iconClass,
        iconName: iconName || ""
    }), (label || iconName) && $75272acffa228a0d$var$react_1.default.createElement($75272acffa228a0d$var$tooltip_1.default, {
        target: id || `button-icon-${uid}`
    }, label || iconName));
};
module.exports.default = $75272acffa228a0d$var$ButtonIcon;

});
parcelRegister("lz1xm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $fb2e0f188b037d4e$export$2e2bcd8739ae039);

var $8BuLn = parcelRequire("8BuLn");
var $fb2e0f188b037d4e$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($8BuLn)));

});
parcelRegister("8BuLn", function(module, exports) {
"use strict";
var $6439a45aae885e72$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $6439a45aae885e72$var$react_1 = $6439a45aae885e72$var$__importDefault((parcelRequire("acw62")));

const $6439a45aae885e72$var$classnames_1 = $6439a45aae885e72$var$__importDefault((parcelRequire("8g1PZ")));
const $6439a45aae885e72$var$Icon = (props)=>{
    const { iconName: iconName = "person", className: className, dataLwtId: dataLwtId, disabled: disabled } = props;
    const disabledIcon = disabled ? {
        "pointer-events": "none"
    } : {};
    // defining style as a spread operator to avoid compiler error:
    //     `Property 'style' does not exist on type 'IntrinsicAttributes & IconProps & { children?: ReactNode; }'`
    const iconProps = {
        style: disabledIcon
    };
    const classes = (0, $6439a45aae885e72$var$classnames_1.default)("material-icons", className);
    return $6439a45aae885e72$var$react_1.default.createElement("i", {
        className: classes,
        "aria-hidden": true,
        "data-lwt-id": dataLwtId,
        ...iconProps
    }, iconName);
};
module.exports.default = $6439a45aae885e72$var$Icon;

});


parcelRegister("brMfV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $8557a5ed72020cb1$export$2e2bcd8739ae039);

var $4Na7h = parcelRequire("4Na7h");
var $8557a5ed72020cb1$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($4Na7h)));

});
parcelRegister("4Na7h", function(module, exports) {
"use strict";
var $37d395f33e3b7c4c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $37d395f33e3b7c4c$var$react_1 = $37d395f33e3b7c4c$var$__importDefault((parcelRequire("acw62")));

var $8FVNB = parcelRequire("8FVNB");
var $dd1F2 = parcelRequire("dd1F2");
const $37d395f33e3b7c4c$var$Tooltip = (props)=>{
    return props.isOpen || props.toggle ? $37d395f33e3b7c4c$var$react_1.default.createElement($8FVNB.default, {
        ...props,
        "data-lwt-id": props.dataLwtId
    }) : $37d395f33e3b7c4c$var$react_1.default.createElement($dd1F2.default, {
        ...props,
        "data-lwt-id": props.dataLwtId
    });
};
module.exports.default = $37d395f33e3b7c4c$var$Tooltip;

});
parcelRegister("8FVNB", function(module, exports) {

$parcel$export(module.exports, "default", () => $650efcc26609fa40$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $mrQig = parcelRequire("mrQig");
var $650efcc26609fa40$var$defaultProps = {
    placement: "top",
    autohide: true,
    placementPrefix: "bs-tooltip",
    trigger: "hover focus"
};
var $650efcc26609fa40$var$Tooltip = function Tooltip(props) {
    var popperClasses = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("tooltip", "show", props.popperClassName);
    var classes = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("tooltip-inner", props.innerClassName);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $mrQig.default), (0, $8nd05.default)({}, props, {
        popperClassName: popperClasses,
        innerClassName: classes
    }));
};
$650efcc26609fa40$var$Tooltip.propTypes = (0, $mrQig.propTypes);
$650efcc26609fa40$var$Tooltip.defaultProps = $650efcc26609fa40$var$defaultProps;
var $650efcc26609fa40$export$2e2bcd8739ae039 = $650efcc26609fa40$var$Tooltip;

});
parcelRegister("mrQig", function(module, exports) {

$parcel$export(module.exports, "propTypes", () => $0437a71e3374e0db$export$513805011eaa4892);
$parcel$export(module.exports, "default", () => $0437a71e3374e0db$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $hDpcU = parcelRequire("hDpcU");

var $g7ajw = parcelRequire("g7ajw");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $gDJ6B = parcelRequire("gDJ6B");

var $e9hDx = parcelRequire("e9hDx");
var $0437a71e3374e0db$export$513805011eaa4892 = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
    ]),
    placement: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf((0, $e9hDx.PopperPlacements)),
    target: (0, $e9hDx.targetPropType).isRequired,
    container: (0, $e9hDx.targetPropType),
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    hideArrow: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    boundariesElement: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, $e9hDx.DOMElement)
    ]),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    innerClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    arrowClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    popperClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    toggle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    autohide: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    placementPrefix: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    delay: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            show: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
            hide: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
        }),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
    ]),
    modifiers: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    positionFixed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    offset: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
    ]),
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ]),
    trigger: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    fade: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    flip: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
var $0437a71e3374e0db$var$DEFAULT_DELAYS = {
    show: 0,
    hide: 50
};
var $0437a71e3374e0db$var$defaultProps = {
    isOpen: false,
    hideArrow: false,
    autohide: false,
    delay: $0437a71e3374e0db$var$DEFAULT_DELAYS,
    toggle: function toggle() {},
    trigger: "click",
    fade: true
};
function $0437a71e3374e0db$var$isInDOMSubtree(element, subtreeRoot) {
    return subtreeRoot && (element === subtreeRoot || subtreeRoot.contains(element));
}
function $0437a71e3374e0db$var$isInDOMSubtrees(element, subtreeRoots) {
    if (subtreeRoots === void 0) subtreeRoots = [];
    return subtreeRoots && subtreeRoots.length && subtreeRoots.filter(function(subTreeRoot) {
        return $0437a71e3374e0db$var$isInDOMSubtree(element, subTreeRoot);
    })[0];
}
var $0437a71e3374e0db$var$TooltipPopoverWrapper = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(TooltipPopoverWrapper, _React$Component);
    function TooltipPopoverWrapper(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this._targets = [];
        _this.currentTargetElement = null;
        _this.addTargetEvents = _this.addTargetEvents.bind((0, $hDpcU.default)(_this));
        _this.handleDocumentClick = _this.handleDocumentClick.bind((0, $hDpcU.default)(_this));
        _this.removeTargetEvents = _this.removeTargetEvents.bind((0, $hDpcU.default)(_this));
        _this.toggle = _this.toggle.bind((0, $hDpcU.default)(_this));
        _this.showWithDelay = _this.showWithDelay.bind((0, $hDpcU.default)(_this));
        _this.hideWithDelay = _this.hideWithDelay.bind((0, $hDpcU.default)(_this));
        _this.onMouseOverTooltipContent = _this.onMouseOverTooltipContent.bind((0, $hDpcU.default)(_this));
        _this.onMouseLeaveTooltipContent = _this.onMouseLeaveTooltipContent.bind((0, $hDpcU.default)(_this));
        _this.show = _this.show.bind((0, $hDpcU.default)(_this));
        _this.hide = _this.hide.bind((0, $hDpcU.default)(_this));
        _this.onEscKeyDown = _this.onEscKeyDown.bind((0, $hDpcU.default)(_this));
        _this.getRef = _this.getRef.bind((0, $hDpcU.default)(_this));
        _this.state = {
            isOpen: props.isOpen
        };
        _this._isMounted = false;
        return _this;
    }
    var _proto = TooltipPopoverWrapper.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this._isMounted = true;
        this.updateTarget();
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this._isMounted = false;
        this.removeTargetEvents();
        this._targets = null;
        this.clearShowTimeout();
        this.clearHideTimeout();
    };
    TooltipPopoverWrapper.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        if (props.isOpen && !state.isOpen) return {
            isOpen: props.isOpen
        };
        else return null;
    };
    _proto.onMouseOverTooltipContent = function onMouseOverTooltipContent() {
        if (this.props.trigger.indexOf("hover") > -1 && !this.props.autohide) {
            if (this._hideTimeout) this.clearHideTimeout();
            if (this.state.isOpen && !this.props.isOpen) this.toggle();
        }
    };
    _proto.onMouseLeaveTooltipContent = function onMouseLeaveTooltipContent(e) {
        if (this.props.trigger.indexOf("hover") > -1 && !this.props.autohide) {
            if (this._showTimeout) this.clearShowTimeout();
            e.persist();
            this._hideTimeout = setTimeout(this.hide.bind(this, e), this.getDelay("hide"));
        }
    };
    _proto.onEscKeyDown = function onEscKeyDown(e) {
        if (e.key === "Escape") this.hide(e);
    };
    _proto.getRef = function getRef(ref) {
        var innerRef = this.props.innerRef;
        if (innerRef) {
            if (typeof innerRef === "function") innerRef(ref);
            else if (typeof innerRef === "object") innerRef.current = ref;
        }
        this._popover = ref;
    };
    _proto.getDelay = function getDelay(key) {
        var delay = this.props.delay;
        if (typeof delay === "object") return isNaN(delay[key]) ? $0437a71e3374e0db$var$DEFAULT_DELAYS[key] : delay[key];
        return delay;
    };
    _proto.getCurrentTarget = function getCurrentTarget(target) {
        if (!target) return null;
        var index = this._targets.indexOf(target);
        if (index >= 0) return this._targets[index];
        return this.getCurrentTarget(target.parentElement);
    };
    _proto.show = function show(e) {
        if (!this.props.isOpen) {
            this.clearShowTimeout();
            this.currentTargetElement = e ? e.currentTarget || this.getCurrentTarget(e.target) : null;
            if (e && e.composedPath && typeof e.composedPath === "function") {
                var path = e.composedPath();
                this.currentTargetElement = path && path[0] || this.currentTargetElement;
            }
            this.toggle(e);
        }
    };
    _proto.showWithDelay = function showWithDelay(e) {
        if (this._hideTimeout) this.clearHideTimeout();
        this._showTimeout = setTimeout(this.show.bind(this, e), this.getDelay("show"));
    };
    _proto.hide = function hide(e) {
        if (this.props.isOpen) {
            this.clearHideTimeout();
            this.currentTargetElement = null;
            this.toggle(e);
        }
    };
    _proto.hideWithDelay = function hideWithDelay(e) {
        if (this._showTimeout) this.clearShowTimeout();
        this._hideTimeout = setTimeout(this.hide.bind(this, e), this.getDelay("hide"));
    };
    _proto.clearShowTimeout = function clearShowTimeout() {
        clearTimeout(this._showTimeout);
        this._showTimeout = undefined;
    };
    _proto.clearHideTimeout = function clearHideTimeout() {
        clearTimeout(this._hideTimeout);
        this._hideTimeout = undefined;
    };
    _proto.handleDocumentClick = function handleDocumentClick(e) {
        var triggers = this.props.trigger.split(" ");
        if (triggers.indexOf("legacy") > -1 && (this.props.isOpen || $0437a71e3374e0db$var$isInDOMSubtrees(e.target, this._targets))) {
            if (this._hideTimeout) this.clearHideTimeout();
            if (this.props.isOpen && !$0437a71e3374e0db$var$isInDOMSubtree(e.target, this._popover)) this.hideWithDelay(e);
            else if (!this.props.isOpen) this.showWithDelay(e);
        } else if (triggers.indexOf("click") > -1 && $0437a71e3374e0db$var$isInDOMSubtrees(e.target, this._targets)) {
            if (this._hideTimeout) this.clearHideTimeout();
            if (!this.props.isOpen) this.showWithDelay(e);
            else this.hideWithDelay(e);
        }
    };
    _proto.addEventOnTargets = function addEventOnTargets(type, handler, isBubble) {
        this._targets.forEach(function(target) {
            target.addEventListener(type, handler, isBubble);
        });
    };
    _proto.removeEventOnTargets = function removeEventOnTargets(type, handler, isBubble) {
        this._targets.forEach(function(target) {
            target.removeEventListener(type, handler, isBubble);
        });
    };
    _proto.addTargetEvents = function addTargetEvents() {
        if (this.props.trigger) {
            var triggers = this.props.trigger.split(" ");
            if (triggers.indexOf("manual") === -1) {
                if (triggers.indexOf("click") > -1 || triggers.indexOf("legacy") > -1) document.addEventListener("click", this.handleDocumentClick, true);
                if (this._targets && this._targets.length) {
                    if (triggers.indexOf("hover") > -1) {
                        this.addEventOnTargets("mouseover", this.showWithDelay, true);
                        this.addEventOnTargets("mouseout", this.hideWithDelay, true);
                    }
                    if (triggers.indexOf("focus") > -1) {
                        this.addEventOnTargets("focusin", this.show, true);
                        this.addEventOnTargets("focusout", this.hide, true);
                    }
                    this.addEventOnTargets("keydown", this.onEscKeyDown, true);
                }
            }
        }
    };
    _proto.removeTargetEvents = function removeTargetEvents() {
        if (this._targets) {
            this.removeEventOnTargets("mouseover", this.showWithDelay, true);
            this.removeEventOnTargets("mouseout", this.hideWithDelay, true);
            this.removeEventOnTargets("keydown", this.onEscKeyDown, true);
            this.removeEventOnTargets("focusin", this.show, true);
            this.removeEventOnTargets("focusout", this.hide, true);
        }
        document.removeEventListener("click", this.handleDocumentClick, true);
    };
    _proto.updateTarget = function updateTarget() {
        var newTarget = (0, $e9hDx.getTarget)(this.props.target, true);
        if (newTarget !== this._targets) {
            this.removeTargetEvents();
            this._targets = newTarget ? Array.from(newTarget) : [];
            this.currentTargetElement = this.currentTargetElement || this._targets[0];
            this.addTargetEvents();
        }
    };
    _proto.toggle = function toggle(e) {
        if (this.props.disabled || !this._isMounted) return e && e.preventDefault();
        return this.props.toggle(e);
    };
    _proto.render = function render() {
        var _this2 = this;
        if (this.props.isOpen) this.updateTarget();
        var target = this.currentTargetElement || this._targets[0];
        if (!target) return null;
        var _this$props = this.props, className = _this$props.className, cssModule = _this$props.cssModule, innerClassName = _this$props.innerClassName, isOpen = _this$props.isOpen, hideArrow = _this$props.hideArrow, boundariesElement = _this$props.boundariesElement, placement = _this$props.placement, placementPrefix = _this$props.placementPrefix, arrowClassName = _this$props.arrowClassName, popperClassName = _this$props.popperClassName, container = _this$props.container, modifiers = _this$props.modifiers, positionFixed = _this$props.positionFixed, offset = _this$props.offset, fade = _this$props.fade, flip = _this$props.flip, children = _this$props.children;
        var attributes = (0, $e9hDx.omit)(this.props, Object.keys($0437a71e3374e0db$export$513805011eaa4892));
        var popperClasses = (0, $e9hDx.mapToCssModules)(popperClassName, cssModule);
        var classes = (0, $e9hDx.mapToCssModules)(innerClassName, cssModule);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $gDJ6B.default), {
            className: className,
            target: target,
            isOpen: isOpen,
            hideArrow: hideArrow,
            boundariesElement: boundariesElement,
            placement: placement,
            placementPrefix: placementPrefix,
            arrowClassName: arrowClassName,
            popperClassName: popperClasses,
            container: container,
            modifiers: modifiers,
            positionFixed: positionFixed,
            offset: offset,
            cssModule: cssModule,
            fade: fade,
            flip: flip
        }, function(_ref) {
            var scheduleUpdate = _ref.scheduleUpdate;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", (0, $8nd05.default)({}, attributes, {
                ref: _this2.getRef,
                className: classes,
                role: "tooltip",
                onMouseOver: _this2.onMouseOverTooltipContent,
                onMouseLeave: _this2.onMouseLeaveTooltipContent,
                onKeyDown: _this2.onEscKeyDown
            }), typeof children === "function" ? children({
                scheduleUpdate: scheduleUpdate
            }) : children);
        });
    };
    return TooltipPopoverWrapper;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$0437a71e3374e0db$var$TooltipPopoverWrapper.propTypes = $0437a71e3374e0db$export$513805011eaa4892;
$0437a71e3374e0db$var$TooltipPopoverWrapper.defaultProps = $0437a71e3374e0db$var$defaultProps;
var $0437a71e3374e0db$export$2e2bcd8739ae039 = $0437a71e3374e0db$var$TooltipPopoverWrapper;

});
parcelRegister("hDpcU", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd69a1d4c6210e44$export$2e2bcd8739ae039);
function $cd69a1d4c6210e44$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});

parcelRegister("g7ajw", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbb54ce93eb94a95$export$2e2bcd8739ae039);

var $VFVve = parcelRequire("VFVve");
function $bbb54ce93eb94a95$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $VFVve.default)(t, o);
}

});
parcelRegister("VFVve", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ad5d8b55fe970db$export$2e2bcd8739ae039);
function $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e) {
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("gDJ6B", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1d346da9138d5e8$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $hDpcU = parcelRequire("hDpcU");

var $g7ajw = parcelRequire("g7ajw");

var $kSlfw = parcelRequire("kSlfw");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $1u0KT = parcelRequire("1u0KT");

var $8g1PZ = parcelRequire("8g1PZ");

var $3cbhK = parcelRequire("3cbhK");

var $e9hDx = parcelRequire("e9hDx");

var $1HWSx = parcelRequire("1HWSx");
function $c1d346da9138d5e8$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c1d346da9138d5e8$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $c1d346da9138d5e8$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $kSlfw.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $c1d346da9138d5e8$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c1d346da9138d5e8$var$noop() {}
var $c1d346da9138d5e8$var$propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
    ]).isRequired,
    popperClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    placement: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    placementPrefix: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    arrowClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    hideArrow: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    tag: (0, $e9hDx.tagPropType),
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    offset: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
    ]),
    fallbackPlacement: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array
    ]),
    flip: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    container: (0, $e9hDx.targetPropType),
    target: (0, $e9hDx.targetPropType).isRequired,
    modifiers: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    positionFixed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    boundariesElement: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, $e9hDx.DOMElement)
    ]),
    onClosed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    fade: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    transition: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape((0, $1HWSx.default).propTypes)
};
var $c1d346da9138d5e8$var$defaultProps = {
    boundariesElement: "scrollParent",
    placement: "auto",
    hideArrow: false,
    isOpen: false,
    offset: 0,
    fallbackPlacement: "flip",
    flip: true,
    container: "body",
    modifiers: {},
    onClosed: $c1d346da9138d5e8$var$noop,
    fade: true,
    transition: $c1d346da9138d5e8$var$_objectSpread({}, (0, $1HWSx.default).defaultProps)
};
var $c1d346da9138d5e8$var$PopperContent = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(PopperContent, _React$Component);
    function PopperContent(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.setTargetNode = _this.setTargetNode.bind((0, $hDpcU.default)(_this));
        _this.getTargetNode = _this.getTargetNode.bind((0, $hDpcU.default)(_this));
        _this.getRef = _this.getRef.bind((0, $hDpcU.default)(_this));
        _this.onClosed = _this.onClosed.bind((0, $hDpcU.default)(_this));
        _this.state = {
            isOpen: props.isOpen
        };
        return _this;
    }
    PopperContent.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
        if (props.isOpen && !state.isOpen) return {
            isOpen: props.isOpen
        };
        else return null;
    };
    var _proto = PopperContent.prototype;
    _proto.componentDidUpdate = function componentDidUpdate() {
        if (this._element && this._element.childNodes && this._element.childNodes[0] && this._element.childNodes[0].focus) this._element.childNodes[0].focus();
    };
    _proto.setTargetNode = function setTargetNode(node) {
        this.targetNode = typeof node === "string" ? (0, $e9hDx.getTarget)(node) : node;
    };
    _proto.getTargetNode = function getTargetNode() {
        return this.targetNode;
    };
    _proto.getContainerNode = function getContainerNode() {
        return (0, $e9hDx.getTarget)(this.props.container);
    };
    _proto.getRef = function getRef(ref) {
        this._element = ref;
    };
    _proto.onClosed = function onClosed() {
        this.props.onClosed();
        this.setState({
            isOpen: false
        });
    };
    _proto.renderChildren = function renderChildren() {
        var _this$props = this.props, cssModule = _this$props.cssModule, children = _this$props.children, isOpen = _this$props.isOpen, flip = _this$props.flip, target = _this$props.target, offset = _this$props.offset, fallbackPlacement = _this$props.fallbackPlacement, placementPrefix = _this$props.placementPrefix, _arrowClassName = _this$props.arrowClassName, hideArrow = _this$props.hideArrow, _popperClassName = _this$props.popperClassName, tag = _this$props.tag, container = _this$props.container, modifiers = _this$props.modifiers, positionFixed = _this$props.positionFixed, boundariesElement = _this$props.boundariesElement, onClosed = _this$props.onClosed, fade = _this$props.fade, transition = _this$props.transition, placement = _this$props.placement, attrs = (0, $1En50.default)(_this$props, [
            "cssModule",
            "children",
            "isOpen",
            "flip",
            "target",
            "offset",
            "fallbackPlacement",
            "placementPrefix",
            "arrowClassName",
            "hideArrow",
            "popperClassName",
            "tag",
            "container",
            "modifiers",
            "positionFixed",
            "boundariesElement",
            "onClosed",
            "fade",
            "transition",
            "placement"
        ]);
        var arrowClassName = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("arrow", _arrowClassName), cssModule);
        var popperClassName = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(_popperClassName, placementPrefix ? placementPrefix + "-auto" : ""), this.props.cssModule);
        var extendedModifiers = $c1d346da9138d5e8$var$_objectSpread({
            offset: {
                offset: offset
            },
            flip: {
                enabled: flip,
                behavior: fallbackPlacement
            },
            preventOverflow: {
                boundariesElement: boundariesElement
            }
        }, modifiers);
        var popperTransition = $c1d346da9138d5e8$var$_objectSpread($c1d346da9138d5e8$var$_objectSpread($c1d346da9138d5e8$var$_objectSpread({}, (0, $1HWSx.default).defaultProps), transition), {}, {
            baseClass: fade ? transition.baseClass : "",
            timeout: fade ? transition.timeout : 0
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1HWSx.default), (0, $8nd05.default)({}, popperTransition, attrs, {
            in: isOpen,
            onExited: this.onClosed,
            tag: tag
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3cbhK.default), {
            referenceElement: this.targetNode,
            modifiers: extendedModifiers,
            placement: placement,
            positionFixed: positionFixed
        }, function(_ref) {
            var ref = _ref.ref, style = _ref.style, placement = _ref.placement, outOfBoundaries = _ref.outOfBoundaries, arrowProps = _ref.arrowProps, scheduleUpdate = _ref.scheduleUpdate;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                ref: ref,
                style: style,
                className: popperClassName,
                "x-placement": placement,
                "x-out-of-boundaries": outOfBoundaries ? "true" : undefined
            }, typeof children === "function" ? children({
                scheduleUpdate: scheduleUpdate
            }) : children, !hideArrow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                ref: arrowProps.ref,
                className: arrowClassName,
                style: arrowProps.style
            }));
        }));
    };
    _proto.render = function render() {
        this.setTargetNode(this.props.target);
        if (this.state.isOpen) return this.props.container === "inline" ? this.renderChildren() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            ref: this.getRef
        }, this.renderChildren()), this.getContainerNode());
        return null;
    };
    return PopperContent;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$c1d346da9138d5e8$var$PopperContent.propTypes = $c1d346da9138d5e8$var$propTypes;
$c1d346da9138d5e8$var$PopperContent.defaultProps = $c1d346da9138d5e8$var$defaultProps;
var $c1d346da9138d5e8$export$2e2bcd8739ae039 = $c1d346da9138d5e8$var$PopperContent;

});
parcelRegister("kSlfw", function(module, exports) {

$parcel$export(module.exports, "default", () => $f329557dcab6d0bb$export$2e2bcd8739ae039);

var $4ZreY = parcelRequire("4ZreY");
function $f329557dcab6d0bb$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $4ZreY.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});
parcelRegister("4ZreY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a21fd50cbcd11cf$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $cXkjo = parcelRequire("cXkjo");
function $3a21fd50cbcd11cf$export$2e2bcd8739ae039(t) {
    var i = (0, $cXkjo.default)(t, "string");
    return "symbol" == (0, $fSwVM.default)(i) ? i : i + "";
}

});
parcelRegister("fSwVM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8f57191916382d3$export$2e2bcd8739ae039);
function $b8f57191916382d3$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(o);
}

});

parcelRegister("cXkjo", function(module, exports) {

$parcel$export(module.exports, "default", () => $96eac03571e01dbf$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");
function $96eac03571e01dbf$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $fSwVM.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $fSwVM.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("3cbhK", function(module, exports) {

$parcel$export(module.exports, "default", () => $253b3f1d15d57500$export$2e2bcd8739ae039);

var $c05no = parcelRequire("c05no");

var $3p9rK = parcelRequire("3p9rK");

var $6r4zt = parcelRequire("6r4zt");

var $6zC7B = parcelRequire("6zC7B");

var $g5Zhu = parcelRequire("g5Zhu");

var $jwbEB = parcelRequire("jwbEB");

var $acw62 = parcelRequire("acw62");

var $kJWRP = parcelRequire("kJWRP");

var $8j0J5 = parcelRequire("8j0J5");

var $buXxn = parcelRequire("buXxn");
var $253b3f1d15d57500$var$initialStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    opacity: 0,
    pointerEvents: "none"
};
var $253b3f1d15d57500$var$initialArrowStyle = {};
var $253b3f1d15d57500$export$29c3525fc8039ddf = /*#__PURE__*/ function(_React$Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($6r4zt)))(InnerPopper, _React$Component);
    function InnerPopper() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this)), "state", {
            data: undefined,
            placement: undefined
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this)), "popperInstance", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this)), "popperNode", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this)), "arrowNode", null);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this)), "setPopperNode", function(popperNode) {
            if (!popperNode || _this.popperNode === popperNode) return;
            (0, $buXxn.setRef)(_this.props.innerRef, popperNode);
            _this.popperNode = popperNode;
            _this.updatePopperInstance();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this)), "setArrowNode", function(arrowNode) {
            _this.arrowNode = arrowNode;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this)), "updateStateModifier", {
            enabled: true,
            order: 900,
            fn: function fn(data) {
                var placement = data.placement;
                _this.setState({
                    data: data,
                    placement: placement
                });
                return data;
            }
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this)), "getOptions", function() {
            return {
                placement: _this.props.placement,
                eventsEnabled: _this.props.eventsEnabled,
                positionFixed: _this.props.positionFixed,
                modifiers: (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, _this.props.modifiers, {
                    arrow: (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({}, _this.props.modifiers && _this.props.modifiers.arrow, {
                        enabled: !!_this.arrowNode,
                        element: _this.arrowNode
                    }),
                    applyStyle: {
                        enabled: false
                    },
                    updateStateModifier: _this.updateStateModifier
                })
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this)), "getPopperStyle", function() {
            return !_this.popperNode || !_this.state.data ? $253b3f1d15d57500$var$initialStyle : (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
                position: _this.state.data.offsets.popper.position
            }, _this.state.data.styles);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this)), "getPopperPlacement", function() {
            return !_this.state.data ? undefined : _this.state.placement;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this)), "getArrowStyle", function() {
            return !_this.arrowNode || !_this.state.data ? $253b3f1d15d57500$var$initialArrowStyle : _this.state.data.arrowStyles;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this)), "getOutOfBoundariesState", function() {
            return _this.state.data ? _this.state.data.hide : undefined;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this)), "destroyPopperInstance", function() {
            if (!_this.popperInstance) return;
            _this.popperInstance.destroy();
            _this.popperInstance = null;
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this)), "updatePopperInstance", function() {
            _this.destroyPopperInstance();
            var _assertThisInitialize = (0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this)), popperNode = _assertThisInitialize.popperNode;
            var referenceElement = _this.props.referenceElement;
            if (!referenceElement || !popperNode) return;
            _this.popperInstance = new (0, $kJWRP.default)(referenceElement, popperNode, _this.getOptions());
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this)), "scheduleUpdate", function() {
            if (_this.popperInstance) _this.popperInstance.scheduleUpdate();
        });
        return _this;
    }
    var _proto = InnerPopper.prototype;
    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        // If the Popper.js options have changed, update the instance (destroy + create)
        if (this.props.placement !== prevProps.placement || this.props.referenceElement !== prevProps.referenceElement || this.props.positionFixed !== prevProps.positionFixed || !(0, (/*@__PURE__*/$parcel$interopDefault($jwbEB)))(this.props.modifiers, prevProps.modifiers, {
            strict: true
        })) this.updatePopperInstance();
        else if (this.props.eventsEnabled !== prevProps.eventsEnabled && this.popperInstance) this.props.eventsEnabled ? this.popperInstance.enableEventListeners() : this.popperInstance.disableEventListeners();
         // A placement difference in state means popper determined a new placement
        // apart from the props value. By the time the popper element is rendered with
        // the new position Popper has already measured it, if the place change triggers
        // a size change it will result in a misaligned popper. So we schedule an update to be sure.
        if (prevState.placement !== this.state.placement) this.scheduleUpdate();
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        (0, $buXxn.setRef)(this.props.innerRef, null);
        this.destroyPopperInstance();
    };
    _proto.render = function render() {
        return (0, $buXxn.unwrapArray)(this.props.children)({
            ref: this.setPopperNode,
            style: this.getPopperStyle(),
            placement: this.getPopperPlacement(),
            outOfBoundaries: this.getOutOfBoundariesState(),
            scheduleUpdate: this.scheduleUpdate,
            arrowProps: {
                ref: this.setArrowNode,
                style: this.getArrowStyle()
            }
        });
    };
    return InnerPopper;
}($acw62.Component);
(0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))($253b3f1d15d57500$export$29c3525fc8039ddf, "defaultProps", {
    placement: "bottom",
    eventsEnabled: true,
    referenceElement: undefined,
    positionFixed: false
});
var $253b3f1d15d57500$export$803cd8101b6c182b = (0, $kJWRP.default).placements;
function $253b3f1d15d57500$export$2e2bcd8739ae039(_ref) {
    var referenceElement = _ref.referenceElement, props = (0, (/*@__PURE__*/$parcel$interopDefault($c05no)))(_ref, [
        "referenceElement"
    ]);
    return $acw62.createElement((0, $8j0J5.ManagerReferenceNodeContext).Consumer, null, function(referenceNode) {
        return $acw62.createElement($253b3f1d15d57500$export$29c3525fc8039ddf, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
            referenceElement: referenceElement !== undefined ? referenceElement : referenceNode
        }, props));
    });
}

});
parcelRegister("c05no", function(module, exports) {
function $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.includes(n)) continue;
        t[n] = r[n];
    }
    return t;
}
module.exports = $8bc9a7bbcf9a2a3b$var$_objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("3p9rK", function(module, exports) {
function $27ab08c24269de64$var$_extends() {
    return module.exports = $27ab08c24269de64$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $27ab08c24269de64$var$_extends.apply(null, arguments);
}
module.exports = $27ab08c24269de64$var$_extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("6r4zt", function(module, exports) {

var $aAhot = parcelRequire("aAhot");
function $4af8cf748148995c$var$_inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, $aAhot(t, o);
}
module.exports = $4af8cf748148995c$var$_inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("aAhot", function(module, exports) {
function $7b4ac2338b8e8f97$var$_setPrototypeOf(t, e) {
    return module.exports = $7b4ac2338b8e8f97$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $7b4ac2338b8e8f97$var$_setPrototypeOf(t, e);
}
module.exports = $7b4ac2338b8e8f97$var$_setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("6zC7B", function(module, exports) {
function $4c93951af9bb8a88$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
module.exports = $4c93951af9bb8a88$var$_assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("g5Zhu", function(module, exports) {

var $5DKOa = parcelRequire("5DKOa");
function $bb7ca61ce45563c4$var$_defineProperty(e, r, t) {
    return (r = $5DKOa(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
module.exports = $bb7ca61ce45563c4$var$_defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5DKOa", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $010f4e0e13c82e16$var$_typeof = $41YNz.default;

var $fKGZD = parcelRequire("fKGZD");
function $010f4e0e13c82e16$var$toPropertyKey(t) {
    var i = $fKGZD(t, "string");
    return "symbol" == $010f4e0e13c82e16$var$_typeof(i) ? i : i + "";
}
module.exports = $010f4e0e13c82e16$var$toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("41YNz", function(module, exports) {
function $2ef66ab8c52ac1c0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $2ef66ab8c52ac1c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $2ef66ab8c52ac1c0$var$_typeof(o);
}
module.exports = $2ef66ab8c52ac1c0$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fKGZD", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $b77c8068776c2a21$var$_typeof = $41YNz.default;
function $b77c8068776c2a21$var$toPrimitive(t, r) {
    if ("object" != $b77c8068776c2a21$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b77c8068776c2a21$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
module.exports = $b77c8068776c2a21$var$toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("jwbEB", function(module, exports) {

var $81enX = parcelRequire("81enX");

var $f4HGZ = parcelRequire("f4HGZ");

var $eT9RM = parcelRequire("eT9RM");

var $l37Ky = parcelRequire("l37Ky");

var $8n177 = parcelRequire("8n177");

var $eLVVP = parcelRequire("eLVVP");
var $e35a0bae35bfdbad$var$getTime = Date.prototype.getTime;
function $e35a0bae35bfdbad$var$deepEqual(actual, expected, options) {
    var opts = options || {};
    // 7.1. All identical values are equivalent, as determined by ===.
    if (opts.strict ? $eT9RM(actual, expected) : actual === expected) return true;
    // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
    if (!actual || !expected || typeof actual !== "object" && typeof expected !== "object") return opts.strict ? $eT9RM(actual, expected) : actual == expected;
    /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */ // eslint-disable-next-line no-use-before-define
    return $e35a0bae35bfdbad$var$objEquiv(actual, expected, opts);
}
function $e35a0bae35bfdbad$var$isUndefinedOrNull(value) {
    return value === null || value === undefined;
}
function $e35a0bae35bfdbad$var$isBuffer(x) {
    if (!x || typeof x !== "object" || typeof x.length !== "number") return false;
    if (typeof x.copy !== "function" || typeof x.slice !== "function") return false;
    if (x.length > 0 && typeof x[0] !== "number") return false;
    return true;
}
function $e35a0bae35bfdbad$var$objEquiv(a, b, opts) {
    /* eslint max-statements: [2, 50] */ var i, key;
    if (typeof a !== typeof b) return false;
    if ($e35a0bae35bfdbad$var$isUndefinedOrNull(a) || $e35a0bae35bfdbad$var$isUndefinedOrNull(b)) return false;
    // an identical 'prototype' property.
    if (a.prototype !== b.prototype) return false;
    if ($f4HGZ(a) !== $f4HGZ(b)) return false;
    var aIsRegex = $l37Ky(a);
    var bIsRegex = $l37Ky(b);
    if (aIsRegex !== bIsRegex) return false;
    if (aIsRegex || bIsRegex) return a.source === b.source && $8n177(a) === $8n177(b);
    if ($eLVVP(a) && $eLVVP(b)) return $e35a0bae35bfdbad$var$getTime.call(a) === $e35a0bae35bfdbad$var$getTime.call(b);
    var aIsBuffer = $e35a0bae35bfdbad$var$isBuffer(a);
    var bIsBuffer = $e35a0bae35bfdbad$var$isBuffer(b);
    if (aIsBuffer !== bIsBuffer) return false;
    if (aIsBuffer || bIsBuffer) {
        if (a.length !== b.length) return false;
        for(i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    if (typeof a !== typeof b) return false;
    try {
        var ka = $81enX(a);
        var kb = $81enX(b);
    } catch (e) {
        return false;
    }
    // having the same number of owned properties (keys incorporates hasOwnProperty)
    if (ka.length !== kb.length) return false;
    // the same set of keys (although not necessarily the same order),
    ka.sort();
    kb.sort();
    // ~~~cheap key test
    for(i = ka.length - 1; i >= 0; i--){
        if (ka[i] != kb[i]) return false;
    }
    // equivalent values for every corresponding key, and ~~~possibly expensive deep test
    for(i = ka.length - 1; i >= 0; i--){
        key = ka[i];
        if (!$e35a0bae35bfdbad$var$deepEqual(a[key], b[key], opts)) return false;
    }
    return true;
}
module.exports = $e35a0bae35bfdbad$var$deepEqual;

});
parcelRegister("81enX", function(module, exports) {
"use strict";
var $5d69935f2747da8d$var$slice = Array.prototype.slice;

var $z1gio = parcelRequire("z1gio");
var $5d69935f2747da8d$var$origKeys = Object.keys;

var $5d69935f2747da8d$var$keysShim = $5d69935f2747da8d$var$origKeys ? function keys(o) {
    return $5d69935f2747da8d$var$origKeys(o);
} : (parcelRequire("4nFCC"));
var $5d69935f2747da8d$var$originalKeys = Object.keys;
$5d69935f2747da8d$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($z1gio(object)) return $5d69935f2747da8d$var$originalKeys($5d69935f2747da8d$var$slice.call(object));
            return $5d69935f2747da8d$var$originalKeys(object);
        };
    } else Object.keys = $5d69935f2747da8d$var$keysShim;
    return Object.keys || $5d69935f2747da8d$var$keysShim;
};
module.exports = $5d69935f2747da8d$var$keysShim;

});
parcelRegister("z1gio", function(module, exports) {
"use strict";
var $06943f92b55ad7fa$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $06943f92b55ad7fa$var$toStr.call(value);
    var isArgs = str === "[object Arguments]";
    if (!isArgs) isArgs = str !== "[object Array]" && value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $06943f92b55ad7fa$var$toStr.call(value.callee) === "[object Function]";
    return isArgs;
};

});

parcelRegister("4nFCC", function(module, exports) {
"use strict";
var $330998a67e44345d$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $330998a67e44345d$var$has = Object.prototype.hasOwnProperty;
    var $330998a67e44345d$var$toStr = Object.prototype.toString;
    var $330998a67e44345d$var$isArgs = (parcelRequire("z1gio")); // eslint-disable-line global-require
    var $330998a67e44345d$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $330998a67e44345d$var$hasDontEnumBug = !$330998a67e44345d$var$isEnumerable.call({
        toString: null
    }, "toString");
    var $330998a67e44345d$var$hasProtoEnumBug = $330998a67e44345d$var$isEnumerable.call(function() {}, "prototype");
    var $330998a67e44345d$var$dontEnums = [
        "toString",
        "toLocaleString",
        "valueOf",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "constructor"
    ];
    var $330998a67e44345d$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $330998a67e44345d$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $330998a67e44345d$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === "undefined") return false;
        for(var k in window)try {
            if (!$330998a67e44345d$var$excludedKeys["$" + k] && $330998a67e44345d$var$has.call(window, k) && window[k] !== null && typeof window[k] === "object") try {
                $330998a67e44345d$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $330998a67e44345d$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === "undefined" || !$330998a67e44345d$var$hasAutomationEqualityBug) return $330998a67e44345d$var$equalsConstructorPrototype(o);
        try {
            return $330998a67e44345d$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $330998a67e44345d$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === "object";
        var isFunction = $330998a67e44345d$var$toStr.call(object) === "[object Function]";
        var isArguments = $330998a67e44345d$var$isArgs(object);
        var isString = isObject && $330998a67e44345d$var$toStr.call(object) === "[object String]";
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError("Object.keys called on a non-object");
        var skipProto = $330998a67e44345d$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$330998a67e44345d$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === "prototype") && $330998a67e44345d$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($330998a67e44345d$var$hasDontEnumBug) {
            var skipConstructor = $330998a67e44345d$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $330998a67e44345d$var$dontEnums.length; ++k)if (!(skipConstructor && $330998a67e44345d$var$dontEnums[k] === "constructor") && $330998a67e44345d$var$has.call(object, $330998a67e44345d$var$dontEnums[k])) theKeys.push($330998a67e44345d$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $330998a67e44345d$var$keysShim;

});


parcelRegister("f4HGZ", function(module, exports) {
"use strict";

var $af991f1d6c80f097$var$hasToStringTag = (parcelRequire("3KyxH"))();

var $hXu6F = parcelRequire("hXu6F");
var $af991f1d6c80f097$var$$toString = $hXu6F("Object.prototype.toString");
var $af991f1d6c80f097$var$isStandardArguments = function isArguments(value) {
    if ($af991f1d6c80f097$var$hasToStringTag && value && typeof value === "object" && Symbol.toStringTag in value) return false;
    return $af991f1d6c80f097$var$$toString(value) === "[object Arguments]";
};
var $af991f1d6c80f097$var$isLegacyArguments = function isArguments(value) {
    if ($af991f1d6c80f097$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $af991f1d6c80f097$var$$toString(value) !== "[object Array]" && $af991f1d6c80f097$var$$toString(value.callee) === "[object Function]";
};
var $af991f1d6c80f097$var$supportsStandardArguments = function() {
    return $af991f1d6c80f097$var$isStandardArguments(arguments);
}();
$af991f1d6c80f097$var$isStandardArguments.isLegacyArguments = $af991f1d6c80f097$var$isLegacyArguments; // for tests
module.exports = $af991f1d6c80f097$var$supportsStandardArguments ? $af991f1d6c80f097$var$isStandardArguments : $af991f1d6c80f097$var$isLegacyArguments;

});
parcelRegister("3KyxH", function(module, exports) {
"use strict";

var $7YWkK = parcelRequire("7YWkK");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $7YWkK() && !!Symbol.toStringTag;
};

});
parcelRegister("7YWkK", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("hXu6F", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");

var $cOB0F = parcelRequire("cOB0F");
var $d12f4cdcd6b10506$var$$indexOf = $cOB0F($1zENl("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $1zENl(name, !!allowMissing);
    if (typeof intrinsic === "function" && $d12f4cdcd6b10506$var$$indexOf(name, ".prototype.") > -1) return $cOB0F(intrinsic);
    return intrinsic;
};

});
parcelRegister("1zENl", function(module, exports) {
"use strict";
var $1258b452ecf218a1$var$undefined1;

var $5A49f = parcelRequire("5A49f");

var $hDtVy = parcelRequire("hDtVy");

var $9RC8m = parcelRequire("9RC8m");

var $2BaZq = parcelRequire("2BaZq");

var $5Ox6r = parcelRequire("5Ox6r");

var $eEkyn = parcelRequire("eEkyn");

var $hFSMY = parcelRequire("hFSMY");
var $1258b452ecf218a1$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $1258b452ecf218a1$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $1258b452ecf218a1$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $1258b452ecf218a1$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($1258b452ecf218a1$var$$gOPD) try {
    $1258b452ecf218a1$var$$gOPD({}, "");
} catch (e) {
    $1258b452ecf218a1$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $1258b452ecf218a1$var$throwTypeError = function() {
    throw new $eEkyn();
};
var $1258b452ecf218a1$var$ThrowTypeError = $1258b452ecf218a1$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $1258b452ecf218a1$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $1258b452ecf218a1$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $1258b452ecf218a1$var$throwTypeError;
        }
    }
}() : $1258b452ecf218a1$var$throwTypeError;

var $1258b452ecf218a1$var$hasSymbols = (parcelRequire("24qIq"))();

var $1258b452ecf218a1$var$hasProto = (parcelRequire("dSRh6"))();
var $1258b452ecf218a1$var$getProto = Object.getPrototypeOf || ($1258b452ecf218a1$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $1258b452ecf218a1$var$needsEval = {};
var $1258b452ecf218a1$var$TypedArray = typeof Uint8Array === "undefined" || !$1258b452ecf218a1$var$getProto ? undefined : $1258b452ecf218a1$var$getProto(Uint8Array);
var $1258b452ecf218a1$var$INTRINSICS = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": $1258b452ecf218a1$var$needsEval,
    "%AsyncGenerator%": $1258b452ecf218a1$var$needsEval,
    "%AsyncGeneratorFunction%": $1258b452ecf218a1$var$needsEval,
    "%AsyncIteratorPrototype%": $1258b452ecf218a1$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": $5A49f,
    "%eval%": eval,
    "%EvalError%": $hDtVy,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $1258b452ecf218a1$var$$Function,
    "%GeneratorFunction%": $1258b452ecf218a1$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto($1258b452ecf218a1$var$getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$1258b452ecf218a1$var$hasSymbols || !$1258b452ecf218a1$var$getProto ? undefined : $1258b452ecf218a1$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": $9RC8m,
    "%ReferenceError%": $2BaZq,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$1258b452ecf218a1$var$hasSymbols || !$1258b452ecf218a1$var$getProto ? undefined : $1258b452ecf218a1$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $1258b452ecf218a1$var$hasSymbols && $1258b452ecf218a1$var$getProto ? $1258b452ecf218a1$var$getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": $1258b452ecf218a1$var$hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $5Ox6r,
    "%ThrowTypeError%": $1258b452ecf218a1$var$ThrowTypeError,
    "%TypedArray%": $1258b452ecf218a1$var$TypedArray,
    "%TypeError%": $eEkyn,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": $hFSMY,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
if ($1258b452ecf218a1$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $1258b452ecf218a1$var$errorProto = $1258b452ecf218a1$var$getProto($1258b452ecf218a1$var$getProto(e));
    $1258b452ecf218a1$var$INTRINSICS["%Error.prototype%"] = $1258b452ecf218a1$var$errorProto;
}
var $1258b452ecf218a1$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $1258b452ecf218a1$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $1258b452ecf218a1$var$getProto) value = $1258b452ecf218a1$var$getProto(gen.prototype);
    }
    $1258b452ecf218a1$var$INTRINSICS[name] = value;
    return value;
};
var $1258b452ecf218a1$var$LEGACY_ALIASES = {
    __proto__: null,
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $gvair = parcelRequire("gvair");

var $4c4Ky = parcelRequire("4c4Ky");
var $1258b452ecf218a1$var$$concat = $gvair.call(Function.call, Array.prototype.concat);
var $1258b452ecf218a1$var$$spliceApply = $gvair.call(Function.apply, Array.prototype.splice);
var $1258b452ecf218a1$var$$replace = $gvair.call(Function.call, String.prototype.replace);
var $1258b452ecf218a1$var$$strSlice = $gvair.call(Function.call, String.prototype.slice);
var $1258b452ecf218a1$var$$exec = $gvair.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $1258b452ecf218a1$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $1258b452ecf218a1$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $1258b452ecf218a1$var$stringToPath = function stringToPath(string) {
    var first = $1258b452ecf218a1$var$$strSlice(string, 0, 1);
    var last = $1258b452ecf218a1$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $5Ox6r("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $5Ox6r("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $1258b452ecf218a1$var$$replace(string, $1258b452ecf218a1$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $1258b452ecf218a1$var$$replace(subString, $1258b452ecf218a1$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $1258b452ecf218a1$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($4c4Ky($1258b452ecf218a1$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $1258b452ecf218a1$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($4c4Ky($1258b452ecf218a1$var$INTRINSICS, intrinsicName)) {
        var value = $1258b452ecf218a1$var$INTRINSICS[intrinsicName];
        if (value === $1258b452ecf218a1$var$needsEval) value = $1258b452ecf218a1$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $eEkyn("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $5Ox6r("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $eEkyn("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $eEkyn('"allowMissing" argument must be a boolean');
    if ($1258b452ecf218a1$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $5Ox6r("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $1258b452ecf218a1$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $1258b452ecf218a1$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $1258b452ecf218a1$var$$spliceApply(parts, $1258b452ecf218a1$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $1258b452ecf218a1$var$$strSlice(part, 0, 1);
        var last = $1258b452ecf218a1$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $5Ox6r("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($4c4Ky($1258b452ecf218a1$var$INTRINSICS, intrinsicRealName)) value = $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $eEkyn("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($1258b452ecf218a1$var$$gOPD && i + 1 >= parts.length) {
                var desc = $1258b452ecf218a1$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $4c4Ky(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $1258b452ecf218a1$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("5A49f", function(module, exports) {
"use strict";
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("hDtVy", function(module, exports) {
"use strict";
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("9RC8m", function(module, exports) {
"use strict";
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("2BaZq", function(module, exports) {
"use strict";
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("5Ox6r", function(module, exports) {
"use strict";
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("eEkyn", function(module, exports) {
"use strict";
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("hFSMY", function(module, exports) {
"use strict";
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("24qIq", function(module, exports) {
"use strict";
var $1820ada193f67aeb$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $7YWkK = parcelRequire("7YWkK");
module.exports = function hasNativeSymbols() {
    if (typeof $1820ada193f67aeb$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $1820ada193f67aeb$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $7YWkK();
};

});

parcelRegister("dSRh6", function(module, exports) {
"use strict";
var $a1b9a4c94d7d9147$var$test = {
    __proto__: null,
    foo: {}
};
var $a1b9a4c94d7d9147$var$$Object = Object;
/** @type {import('.')} */ module.exports = function hasProto() {
    // @ts-expect-error: TS errors on an inherited property for some reason
    return ({
        __proto__: $a1b9a4c94d7d9147$var$test
    }).foo === $a1b9a4c94d7d9147$var$test.foo && !($a1b9a4c94d7d9147$var$test instanceof $a1b9a4c94d7d9147$var$$Object);
};

});

parcelRegister("gvair", function(module, exports) {
"use strict";

var $kAGnA = parcelRequire("kAGnA");
module.exports = Function.prototype.bind || $kAGnA;

});
parcelRegister("kAGnA", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $efd80b1d7fbb2850$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $efd80b1d7fbb2850$var$toStr = Object.prototype.toString;
var $efd80b1d7fbb2850$var$max = Math.max;
var $efd80b1d7fbb2850$var$funcType = "[object Function]";
var $efd80b1d7fbb2850$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $efd80b1d7fbb2850$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $efd80b1d7fbb2850$var$joiny = function(arr, joiner) {
    var str = "";
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $efd80b1d7fbb2850$var$toStr.apply(target) !== $efd80b1d7fbb2850$var$funcType) throw new TypeError($efd80b1d7fbb2850$var$ERROR_MESSAGE + target);
    var args = $efd80b1d7fbb2850$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $efd80b1d7fbb2850$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $efd80b1d7fbb2850$var$concatty(args, arguments));
    };
    var boundLength = $efd80b1d7fbb2850$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    bound = Function("binder", "return function (" + $efd80b1d7fbb2850$var$joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("4c4Ky", function(module, exports) {
"use strict";
var $30dbf79dbae6c725$var$call = Function.prototype.call;
var $30dbf79dbae6c725$var$$hasOwn = Object.prototype.hasOwnProperty;

var $gvair = parcelRequire("gvair");
/** @type {import('.')} */ module.exports = $gvair.call($30dbf79dbae6c725$var$call, $30dbf79dbae6c725$var$$hasOwn);

});


parcelRegister("cOB0F", function(module, exports) {
"use strict";

var $gvair = parcelRequire("gvair");

var $1zENl = parcelRequire("1zENl");

var $BPe9e = parcelRequire("BPe9e");

var $eEkyn = parcelRequire("eEkyn");
var $9546dce5bd4976bd$var$$apply = $1zENl("%Function.prototype.apply%");
var $9546dce5bd4976bd$var$$call = $1zENl("%Function.prototype.call%");
var $9546dce5bd4976bd$var$$reflectApply = $1zENl("%Reflect.apply%", true) || $gvair.call($9546dce5bd4976bd$var$$call, $9546dce5bd4976bd$var$$apply);

var $jAy3M = parcelRequire("jAy3M");
var $9546dce5bd4976bd$var$$max = $1zENl("%Math.max%");
module.exports = function callBind(originalFunction) {
    if (typeof originalFunction !== "function") throw new $eEkyn("a function is required");
    var func = $9546dce5bd4976bd$var$$reflectApply($gvair, $9546dce5bd4976bd$var$$call, arguments);
    return $BPe9e(func, 1 + $9546dce5bd4976bd$var$$max(0, originalFunction.length - (arguments.length - 1)), true);
};
var $9546dce5bd4976bd$var$applyBind = function applyBind() {
    return $9546dce5bd4976bd$var$$reflectApply($gvair, $9546dce5bd4976bd$var$$apply, arguments);
};
if ($jAy3M) $jAy3M(module.exports, "apply", {
    value: $9546dce5bd4976bd$var$applyBind
});
else module.exports.apply = $9546dce5bd4976bd$var$applyBind;

});
parcelRegister("BPe9e", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");

var $5FEEt = parcelRequire("5FEEt");

var $071b317808876eb5$var$hasDescriptors = (parcelRequire("i16wS"))();

var $dYOee = parcelRequire("dYOee");

var $eEkyn = parcelRequire("eEkyn");
var $071b317808876eb5$var$$floor = $1zENl("%Math.floor%");
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== "function") throw new $eEkyn("`fn` is not a function");
    if (typeof length !== "number" || length < 0 || length > 0xFFFFFFFF || $071b317808876eb5$var$$floor(length) !== length) throw new $eEkyn("`length` must be a positive 32-bit integer");
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ("length" in fn && $dYOee) {
        var desc = $dYOee(fn, "length");
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($071b317808876eb5$var$hasDescriptors) $5FEEt(/** @type {Parameters<define>[0]} */ fn, "length", length, true, true);
        else $5FEEt(/** @type {Parameters<define>[0]} */ fn, "length", length);
    }
    return fn;
};

});
parcelRegister("5FEEt", function(module, exports) {
"use strict";

var $jAy3M = parcelRequire("jAy3M");

var $5Ox6r = parcelRequire("5Ox6r");

var $eEkyn = parcelRequire("eEkyn");

var $dYOee = parcelRequire("dYOee");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new $eEkyn("`obj` must be an object or a function`");
    if (typeof property !== "string" && typeof property !== "symbol") throw new $eEkyn("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $eEkyn("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $eEkyn("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $eEkyn("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $eEkyn("`loose`, if provided, must be a boolean");
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$dYOee && $dYOee(obj, property);
    if ($jAy3M) $jAy3M(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $5Ox6r("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
};

});
parcelRegister("jAy3M", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");
/** @type {import('.')} */ var $e42bccb64e3fb3fd$var$$defineProperty = $1zENl("%Object.defineProperty%", true) || false;
if ($e42bccb64e3fb3fd$var$$defineProperty) try {
    $e42bccb64e3fb3fd$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $e42bccb64e3fb3fd$var$$defineProperty = false;
}
module.exports = $e42bccb64e3fb3fd$var$$defineProperty;

});

parcelRegister("dYOee", function(module, exports) {
"use strict";

var $1zENl = parcelRequire("1zENl");
var $a2d7d74e83f6c3ed$var$$gOPD = $1zENl("%Object.getOwnPropertyDescriptor%", true);
if ($a2d7d74e83f6c3ed$var$$gOPD) try {
    $a2d7d74e83f6c3ed$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $a2d7d74e83f6c3ed$var$$gOPD = null;
}
module.exports = $a2d7d74e83f6c3ed$var$$gOPD;

});


parcelRegister("i16wS", function(module, exports) {
"use strict";

var $jAy3M = parcelRequire("jAy3M");
var $d1dd62937e17e68d$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$jAy3M;
};
$d1dd62937e17e68d$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$jAy3M) return null;
    try {
        return $jAy3M([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $d1dd62937e17e68d$var$hasPropertyDescriptors;

});





parcelRegister("eT9RM", function(module, exports) {
"use strict";

var $1UbTr = parcelRequire("1UbTr");

var $cOB0F = parcelRequire("cOB0F");

var $6wuPW = parcelRequire("6wuPW");

var $5SxoI = parcelRequire("5SxoI");

var $bNbuK = parcelRequire("bNbuK");
var $ad6ddb07ef0cb149$var$polyfill = $cOB0F($5SxoI(), Object);
$1UbTr($ad6ddb07ef0cb149$var$polyfill, {
    getPolyfill: $5SxoI,
    implementation: $6wuPW,
    shim: $bNbuK
});
module.exports = $ad6ddb07ef0cb149$var$polyfill;

});
parcelRegister("1UbTr", function(module, exports) {
"use strict";

var $81enX = parcelRequire("81enX");
var $16343f2546a69e4c$var$hasSymbols = typeof Symbol === "function" && typeof Symbol("foo") === "symbol";
var $16343f2546a69e4c$var$toStr = Object.prototype.toString;
var $16343f2546a69e4c$var$concat = Array.prototype.concat;

var $5FEEt = parcelRequire("5FEEt");
var $16343f2546a69e4c$var$isFunction = function(fn) {
    return typeof fn === "function" && $16343f2546a69e4c$var$toStr.call(fn) === "[object Function]";
};

var $16343f2546a69e4c$var$supportsDescriptors = (parcelRequire("i16wS"))();
var $16343f2546a69e4c$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$16343f2546a69e4c$var$isFunction(predicate) || !predicate()) return;
    }
    if ($16343f2546a69e4c$var$supportsDescriptors) $5FEEt(object, name, value, true);
    else $5FEEt(object, name, value);
};
var $16343f2546a69e4c$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $81enX(map);
    if ($16343f2546a69e4c$var$hasSymbols) props = $16343f2546a69e4c$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$16343f2546a69e4c$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$16343f2546a69e4c$var$defineProperties.supportsDescriptors = !!$16343f2546a69e4c$var$supportsDescriptors;
module.exports = $16343f2546a69e4c$var$defineProperties;

});

parcelRegister("6wuPW", function(module, exports) {
"use strict";
var $4bfda6cb765ad269$var$numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($4bfda6cb765ad269$var$numberIsNaN(a) && $4bfda6cb765ad269$var$numberIsNaN(b)) return true;
    return false;
};

});

parcelRegister("5SxoI", function(module, exports) {
"use strict";

var $6wuPW = parcelRequire("6wuPW");
module.exports = function getPolyfill() {
    return typeof Object.is === "function" ? Object.is : $6wuPW;
};

});

parcelRegister("bNbuK", function(module, exports) {
"use strict";

var $5SxoI = parcelRequire("5SxoI");

var $1UbTr = parcelRequire("1UbTr");
module.exports = function shimObjectIs() {
    var polyfill = $5SxoI();
    $1UbTr(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

});


parcelRegister("l37Ky", function(module, exports) {
"use strict";

var $hXu6F = parcelRequire("hXu6F");

var $f52fe3bd41a86f17$var$hasToStringTag = (parcelRequire("3KyxH"))();
var $f52fe3bd41a86f17$var$has;
var $f52fe3bd41a86f17$var$$exec;
var $f52fe3bd41a86f17$var$isRegexMarker;
var $f52fe3bd41a86f17$var$badStringifier;
if ($f52fe3bd41a86f17$var$hasToStringTag) {
    $f52fe3bd41a86f17$var$has = $hXu6F("Object.prototype.hasOwnProperty");
    $f52fe3bd41a86f17$var$$exec = $hXu6F("RegExp.prototype.exec");
    $f52fe3bd41a86f17$var$isRegexMarker = {};
    var $f52fe3bd41a86f17$var$throwRegexMarker = function() {
        throw $f52fe3bd41a86f17$var$isRegexMarker;
    };
    $f52fe3bd41a86f17$var$badStringifier = {
        toString: $f52fe3bd41a86f17$var$throwRegexMarker,
        valueOf: $f52fe3bd41a86f17$var$throwRegexMarker
    };
    if (typeof Symbol.toPrimitive === "symbol") $f52fe3bd41a86f17$var$badStringifier[Symbol.toPrimitive] = $f52fe3bd41a86f17$var$throwRegexMarker;
}
var $f52fe3bd41a86f17$var$$toString = $hXu6F("Object.prototype.toString");
var $f52fe3bd41a86f17$var$gOPD = Object.getOwnPropertyDescriptor;
var $f52fe3bd41a86f17$var$regexClass = "[object RegExp]";
module.exports = $f52fe3bd41a86f17$var$hasToStringTag ? function isRegex(value) {
    if (!value || typeof value !== "object") return false;
    var descriptor = $f52fe3bd41a86f17$var$gOPD(value, "lastIndex");
    var hasLastIndexDataProperty = descriptor && $f52fe3bd41a86f17$var$has(descriptor, "value");
    if (!hasLastIndexDataProperty) return false;
    try {
        $f52fe3bd41a86f17$var$$exec(value, $f52fe3bd41a86f17$var$badStringifier);
    } catch (e) {
        return e === $f52fe3bd41a86f17$var$isRegexMarker;
    }
} : function isRegex(value) {
    // In older browsers, typeof regex incorrectly returns 'function'
    if (!value || typeof value !== "object" && typeof value !== "function") return false;
    return $f52fe3bd41a86f17$var$$toString(value) === $f52fe3bd41a86f17$var$regexClass;
};

});

parcelRegister("8n177", function(module, exports) {
"use strict";

var $1UbTr = parcelRequire("1UbTr");

var $cOB0F = parcelRequire("cOB0F");

var $3IF4T = parcelRequire("3IF4T");

var $d9j1l = parcelRequire("d9j1l");

var $glox1 = parcelRequire("glox1");
var $618155de6b8eecd6$var$flagsBound = $cOB0F($d9j1l());
$1UbTr($618155de6b8eecd6$var$flagsBound, {
    getPolyfill: $d9j1l,
    implementation: $3IF4T,
    shim: $glox1
});
module.exports = $618155de6b8eecd6$var$flagsBound;

});
parcelRegister("3IF4T", function(module, exports) {
"use strict";

var $8OdwC = parcelRequire("8OdwC");

var $eEkyn = parcelRequire("eEkyn");
var $2b55586061318c76$var$$Object = Object;
module.exports = $8OdwC(function flags() {
    if (this == null || this !== $2b55586061318c76$var$$Object(this)) throw new $eEkyn("RegExp.prototype.flags getter called on non-object");
    var result = "";
    if (this.hasIndices) result += "d";
    if (this.global) result += "g";
    if (this.ignoreCase) result += "i";
    if (this.multiline) result += "m";
    if (this.dotAll) result += "s";
    if (this.unicode) result += "u";
    if (this.unicodeSets) result += "v";
    if (this.sticky) result += "y";
    return result;
}, "get flags", true);

});
parcelRegister("8OdwC", function(module, exports) {
"use strict";

var $5FEEt = parcelRequire("5FEEt");

var $669d7c06db4eb176$var$hasDescriptors = (parcelRequire("i16wS"))();

var $669d7c06db4eb176$var$functionsHaveConfigurableNames = (parcelRequire("1NQyn")).functionsHaveConfigurableNames();

var $eEkyn = parcelRequire("eEkyn");
/** @type {import('.')} */ module.exports = function setFunctionName(fn, name) {
    if (typeof fn !== "function") throw new $eEkyn("`fn` is not a function");
    var loose = arguments.length > 2 && !!arguments[2];
    if (!loose || $669d7c06db4eb176$var$functionsHaveConfigurableNames) {
        if ($669d7c06db4eb176$var$hasDescriptors) $5FEEt(/** @type {Parameters<define>[0]} */ fn, "name", name, true, true);
        else $5FEEt(/** @type {Parameters<define>[0]} */ fn, "name", name);
    }
    return fn;
};

});
parcelRegister("1NQyn", function(module, exports) {
"use strict";
var $15032211f1d46f99$var$functionsHaveNames = function functionsHaveNames() {
    return typeof (function f() {}).name === "string";
};
var $15032211f1d46f99$var$gOPD = Object.getOwnPropertyDescriptor;
if ($15032211f1d46f99$var$gOPD) try {
    $15032211f1d46f99$var$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $15032211f1d46f99$var$gOPD = null;
}
$15032211f1d46f99$var$functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
    if (!$15032211f1d46f99$var$functionsHaveNames() || !$15032211f1d46f99$var$gOPD) return false;
    var desc = $15032211f1d46f99$var$gOPD(function() {}, "name");
    return !!desc && !!desc.configurable;
};
var $15032211f1d46f99$var$$bind = Function.prototype.bind;
$15032211f1d46f99$var$functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
    return $15032211f1d46f99$var$functionsHaveNames() && typeof $15032211f1d46f99$var$$bind === "function" && (function f() {}).bind().name !== "";
};
module.exports = $15032211f1d46f99$var$functionsHaveNames;

});



parcelRegister("d9j1l", function(module, exports) {
"use strict";

var $3IF4T = parcelRequire("3IF4T");

var $1UbTr = parcelRequire("1UbTr");
var $992adeb8827cf321$require$supportsDescriptors = $1UbTr.supportsDescriptors;
var $992adeb8827cf321$var$$gOPD = Object.getOwnPropertyDescriptor;
module.exports = function getPolyfill() {
    if ($992adeb8827cf321$require$supportsDescriptors && /a/mig.flags === "gim") {
        var descriptor = $992adeb8827cf321$var$$gOPD(RegExp.prototype, "flags");
        if (descriptor && typeof descriptor.get === "function" && typeof RegExp.prototype.dotAll === "boolean" && typeof RegExp.prototype.hasIndices === "boolean") {
            /* eslint getter-return: 0 */ var calls = "";
            var o = {};
            Object.defineProperty(o, "hasIndices", {
                get: function() {
                    calls += "d";
                }
            });
            Object.defineProperty(o, "sticky", {
                get: function() {
                    calls += "y";
                }
            });
            if (calls === "dy") return descriptor.get;
        }
    }
    return $3IF4T;
};

});

parcelRegister("glox1", function(module, exports) {
"use strict";

var $1UbTr = parcelRequire("1UbTr");
var $be61a2fd0f680ceb$require$supportsDescriptors = $1UbTr.supportsDescriptors;

var $d9j1l = parcelRequire("d9j1l");
var $be61a2fd0f680ceb$var$gOPD = Object.getOwnPropertyDescriptor;
var $be61a2fd0f680ceb$var$defineProperty = Object.defineProperty;
var $be61a2fd0f680ceb$var$TypeErr = TypeError;
var $be61a2fd0f680ceb$var$getProto = Object.getPrototypeOf;
var $be61a2fd0f680ceb$var$regex = /a/;
module.exports = function shimFlags() {
    if (!$be61a2fd0f680ceb$require$supportsDescriptors || !$be61a2fd0f680ceb$var$getProto) throw new $be61a2fd0f680ceb$var$TypeErr("RegExp.prototype.flags requires a true ES5 environment that supports property descriptors");
    var polyfill = $d9j1l();
    var proto = $be61a2fd0f680ceb$var$getProto($be61a2fd0f680ceb$var$regex);
    var descriptor = $be61a2fd0f680ceb$var$gOPD(proto, "flags");
    if (!descriptor || descriptor.get !== polyfill) $be61a2fd0f680ceb$var$defineProperty(proto, "flags", {
        configurable: true,
        enumerable: false,
        get: polyfill
    });
    return polyfill;
};

});


parcelRegister("eLVVP", function(module, exports) {
"use strict";
var $ac12648141d132f9$var$getDay = Date.prototype.getDay;
var $ac12648141d132f9$var$tryDateObject = function tryDateGetDayCall(value) {
    try {
        $ac12648141d132f9$var$getDay.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $ac12648141d132f9$var$toStr = Object.prototype.toString;
var $ac12648141d132f9$var$dateClass = "[object Date]";

var $ac12648141d132f9$var$hasToStringTag = (parcelRequire("3KyxH"))();
module.exports = function isDateObject(value) {
    if (typeof value !== "object" || value === null) return false;
    return $ac12648141d132f9$var$hasToStringTag ? $ac12648141d132f9$var$tryDateObject(value) : $ac12648141d132f9$var$toStr.call(value) === $ac12648141d132f9$var$dateClass;
};

});


parcelRegister("kJWRP", function(module, exports) {

$parcel$export(module.exports, "default", () => $f195ac6af4853fa1$export$2e2bcd8739ae039);
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.1
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ var $f195ac6af4853fa1$var$isBrowser = typeof window !== "undefined" && typeof document !== "undefined" && typeof navigator !== "undefined";
var $f195ac6af4853fa1$var$timeoutDuration = function() {
    var longerTimeoutBrowsers = [
        "Edge",
        "Trident",
        "Firefox"
    ];
    for(var i = 0; i < longerTimeoutBrowsers.length; i += 1){
        if ($f195ac6af4853fa1$var$isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) return 1;
    }
    return 0;
}();
function $f195ac6af4853fa1$var$microtaskDebounce(fn) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        window.Promise.resolve().then(function() {
            called = false;
            fn();
        });
    };
}
function $f195ac6af4853fa1$var$taskDebounce(fn) {
    var scheduled = false;
    return function() {
        if (!scheduled) {
            scheduled = true;
            setTimeout(function() {
                scheduled = false;
                fn();
            }, $f195ac6af4853fa1$var$timeoutDuration);
        }
    };
}
var $f195ac6af4853fa1$var$supportsMicroTasks = $f195ac6af4853fa1$var$isBrowser && window.Promise;
/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/ var $f195ac6af4853fa1$var$debounce = $f195ac6af4853fa1$var$supportsMicroTasks ? $f195ac6af4853fa1$var$microtaskDebounce : $f195ac6af4853fa1$var$taskDebounce;
/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */ function $f195ac6af4853fa1$var$isFunction(functionToCheck) {
    var getType = {};
    return functionToCheck && getType.toString.call(functionToCheck) === "[object Function]";
}
/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */ function $f195ac6af4853fa1$var$getStyleComputedProperty(element, property) {
    if (element.nodeType !== 1) return [];
    // NOTE: 1 DOM access here
    var window1 = element.ownerDocument.defaultView;
    var css = window1.getComputedStyle(element, null);
    return property ? css[property] : css;
}
/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */ function $f195ac6af4853fa1$var$getParentNode(element) {
    if (element.nodeName === "HTML") return element;
    return element.parentNode || element.host;
}
/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */ function $f195ac6af4853fa1$var$getScrollParent(element) {
    // Return body, `getScroll` will take care to get the correct `scrollTop` from it
    if (!element) return document.body;
    switch(element.nodeName){
        case "HTML":
        case "BODY":
            return element.ownerDocument.body;
        case "#document":
            return element.body;
    }
    // Firefox want us to check `-x` and `-y` variations as well
    var _getStyleComputedProp = $f195ac6af4853fa1$var$getStyleComputedProperty(element), overflow = _getStyleComputedProp.overflow, overflowX = _getStyleComputedProp.overflowX, overflowY = _getStyleComputedProp.overflowY;
    if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) return element;
    return $f195ac6af4853fa1$var$getScrollParent($f195ac6af4853fa1$var$getParentNode(element));
}
/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */ function $f195ac6af4853fa1$var$getReferenceNode(reference) {
    return reference && reference.referenceNode ? reference.referenceNode : reference;
}
var $f195ac6af4853fa1$var$isIE11 = $f195ac6af4853fa1$var$isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var $f195ac6af4853fa1$var$isIE10 = $f195ac6af4853fa1$var$isBrowser && /MSIE 10/.test(navigator.userAgent);
/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */ function $f195ac6af4853fa1$var$isIE(version) {
    if (version === 11) return $f195ac6af4853fa1$var$isIE11;
    if (version === 10) return $f195ac6af4853fa1$var$isIE10;
    return $f195ac6af4853fa1$var$isIE11 || $f195ac6af4853fa1$var$isIE10;
}
/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */ function $f195ac6af4853fa1$var$getOffsetParent(element) {
    if (!element) return document.documentElement;
    var noOffsetParent = $f195ac6af4853fa1$var$isIE(10) ? document.body : null;
    // NOTE: 1 DOM access here
    var offsetParent = element.offsetParent || null;
    // Skip hidden elements which don't have an offsetParent
    while(offsetParent === noOffsetParent && element.nextElementSibling)offsetParent = (element = element.nextElementSibling).offsetParent;
    var nodeName = offsetParent && offsetParent.nodeName;
    if (!nodeName || nodeName === "BODY" || nodeName === "HTML") return element ? element.ownerDocument.documentElement : document.documentElement;
    // .offsetParent will return the closest TH, TD or TABLE in case
    // no offsetParent is present, I hate this job...
    if ([
        "TH",
        "TD",
        "TABLE"
    ].indexOf(offsetParent.nodeName) !== -1 && $f195ac6af4853fa1$var$getStyleComputedProperty(offsetParent, "position") === "static") return $f195ac6af4853fa1$var$getOffsetParent(offsetParent);
    return offsetParent;
}
function $f195ac6af4853fa1$var$isOffsetContainer(element) {
    var nodeName = element.nodeName;
    if (nodeName === "BODY") return false;
    return nodeName === "HTML" || $f195ac6af4853fa1$var$getOffsetParent(element.firstElementChild) === element;
}
/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */ function $f195ac6af4853fa1$var$getRoot(node) {
    if (node.parentNode !== null) return $f195ac6af4853fa1$var$getRoot(node.parentNode);
    return node;
}
/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */ function $f195ac6af4853fa1$var$findCommonOffsetParent(element1, element2) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) return document.documentElement;
    // Here we make sure to give as "start" the element that comes first in the DOM
    var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
    var start = order ? element1 : element2;
    var end = order ? element2 : element1;
    // Get common ancestor container
    var range = document.createRange();
    range.setStart(start, 0);
    range.setEnd(end, 0);
    var commonAncestorContainer = range.commonAncestorContainer;
    // Both nodes are inside #document
    if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
        if ($f195ac6af4853fa1$var$isOffsetContainer(commonAncestorContainer)) return commonAncestorContainer;
        return $f195ac6af4853fa1$var$getOffsetParent(commonAncestorContainer);
    }
    // one of the nodes is inside shadowDOM, find which one
    var element1root = $f195ac6af4853fa1$var$getRoot(element1);
    if (element1root.host) return $f195ac6af4853fa1$var$findCommonOffsetParent(element1root.host, element2);
    else return $f195ac6af4853fa1$var$findCommonOffsetParent(element1, $f195ac6af4853fa1$var$getRoot(element2).host);
}
/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */ function $f195ac6af4853fa1$var$getScroll(element) {
    var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "top";
    var upperSide = side === "top" ? "scrollTop" : "scrollLeft";
    var nodeName = element.nodeName;
    if (nodeName === "BODY" || nodeName === "HTML") {
        var html = element.ownerDocument.documentElement;
        var scrollingElement = element.ownerDocument.scrollingElement || html;
        return scrollingElement[upperSide];
    }
    return element[upperSide];
}
/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */ function $f195ac6af4853fa1$var$includeScroll(rect, element) {
    var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var scrollTop = $f195ac6af4853fa1$var$getScroll(element, "top");
    var scrollLeft = $f195ac6af4853fa1$var$getScroll(element, "left");
    var modifier = subtract ? -1 : 1;
    rect.top += scrollTop * modifier;
    rect.bottom += scrollTop * modifier;
    rect.left += scrollLeft * modifier;
    rect.right += scrollLeft * modifier;
    return rect;
}
/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */ function $f195ac6af4853fa1$var$getBordersSize(styles, axis) {
    var sideA = axis === "x" ? "Left" : "Top";
    var sideB = sideA === "Left" ? "Right" : "Bottom";
    return parseFloat(styles["border" + sideA + "Width"]) + parseFloat(styles["border" + sideB + "Width"]);
}
function $f195ac6af4853fa1$var$getSize(axis, body, html, computedStyle) {
    return Math.max(body["offset" + axis], body["scroll" + axis], html["client" + axis], html["offset" + axis], html["scroll" + axis], $f195ac6af4853fa1$var$isIE(10) ? parseInt(html["offset" + axis]) + parseInt(computedStyle["margin" + (axis === "Height" ? "Top" : "Left")]) + parseInt(computedStyle["margin" + (axis === "Height" ? "Bottom" : "Right")]) : 0);
}
function $f195ac6af4853fa1$var$getWindowSizes(document1) {
    var body = document1.body;
    var html = document1.documentElement;
    var computedStyle = $f195ac6af4853fa1$var$isIE(10) && getComputedStyle(html);
    return {
        height: $f195ac6af4853fa1$var$getSize("Height", body, html, computedStyle),
        width: $f195ac6af4853fa1$var$getSize("Width", body, html, computedStyle)
    };
}
var $f195ac6af4853fa1$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $f195ac6af4853fa1$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $f195ac6af4853fa1$var$defineProperty = function(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
};
var $f195ac6af4853fa1$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */ function $f195ac6af4853fa1$var$getClientRect(offsets) {
    return $f195ac6af4853fa1$var$_extends({}, offsets, {
        right: offsets.left + offsets.width,
        bottom: offsets.top + offsets.height
    });
}
/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */ function $f195ac6af4853fa1$var$getBoundingClientRect(element) {
    var rect = {};
    // IE10 10 FIX: Please, don't ask, the element isn't
    // considered in DOM in some circumstances...
    // This isn't reproducible in IE10 compatibility mode of IE11
    try {
        if ($f195ac6af4853fa1$var$isIE(10)) {
            rect = element.getBoundingClientRect();
            var scrollTop = $f195ac6af4853fa1$var$getScroll(element, "top");
            var scrollLeft = $f195ac6af4853fa1$var$getScroll(element, "left");
            rect.top += scrollTop;
            rect.left += scrollLeft;
            rect.bottom += scrollTop;
            rect.right += scrollLeft;
        } else rect = element.getBoundingClientRect();
    } catch (e) {}
    var result = {
        left: rect.left,
        top: rect.top,
        width: rect.right - rect.left,
        height: rect.bottom - rect.top
    };
    // subtract scrollbar size from sizes
    var sizes = element.nodeName === "HTML" ? $f195ac6af4853fa1$var$getWindowSizes(element.ownerDocument) : {};
    var width = sizes.width || element.clientWidth || result.width;
    var height = sizes.height || element.clientHeight || result.height;
    var horizScrollbar = element.offsetWidth - width;
    var vertScrollbar = element.offsetHeight - height;
    // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
    // we make this check conditional for performance reasons
    if (horizScrollbar || vertScrollbar) {
        var styles = $f195ac6af4853fa1$var$getStyleComputedProperty(element);
        horizScrollbar -= $f195ac6af4853fa1$var$getBordersSize(styles, "x");
        vertScrollbar -= $f195ac6af4853fa1$var$getBordersSize(styles, "y");
        result.width -= horizScrollbar;
        result.height -= vertScrollbar;
    }
    return $f195ac6af4853fa1$var$getClientRect(result);
}
function $f195ac6af4853fa1$var$getOffsetRectRelativeToArbitraryNode(children, parent) {
    var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var isIE10 = $f195ac6af4853fa1$var$isIE(10);
    var isHTML = parent.nodeName === "HTML";
    var childrenRect = $f195ac6af4853fa1$var$getBoundingClientRect(children);
    var parentRect = $f195ac6af4853fa1$var$getBoundingClientRect(parent);
    var scrollParent = $f195ac6af4853fa1$var$getScrollParent(children);
    var styles = $f195ac6af4853fa1$var$getStyleComputedProperty(parent);
    var borderTopWidth = parseFloat(styles.borderTopWidth);
    var borderLeftWidth = parseFloat(styles.borderLeftWidth);
    // In cases where the parent is fixed, we must ignore negative scroll in offset calc
    if (fixedPosition && isHTML) {
        parentRect.top = Math.max(parentRect.top, 0);
        parentRect.left = Math.max(parentRect.left, 0);
    }
    var offsets = $f195ac6af4853fa1$var$getClientRect({
        top: childrenRect.top - parentRect.top - borderTopWidth,
        left: childrenRect.left - parentRect.left - borderLeftWidth,
        width: childrenRect.width,
        height: childrenRect.height
    });
    offsets.marginTop = 0;
    offsets.marginLeft = 0;
    // Subtract margins of documentElement in case it's being used as parent
    // we do this only on HTML because it's the only element that behaves
    // differently when margins are applied to it. The margins are included in
    // the box of the documentElement, in the other cases not.
    if (!isIE10 && isHTML) {
        var marginTop = parseFloat(styles.marginTop);
        var marginLeft = parseFloat(styles.marginLeft);
        offsets.top -= borderTopWidth - marginTop;
        offsets.bottom -= borderTopWidth - marginTop;
        offsets.left -= borderLeftWidth - marginLeft;
        offsets.right -= borderLeftWidth - marginLeft;
        // Attach marginTop and marginLeft because in some circumstances we may need them
        offsets.marginTop = marginTop;
        offsets.marginLeft = marginLeft;
    }
    if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== "BODY") offsets = $f195ac6af4853fa1$var$includeScroll(offsets, parent);
    return offsets;
}
function $f195ac6af4853fa1$var$getViewportOffsetRectRelativeToArtbitraryNode(element) {
    var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var html = element.ownerDocument.documentElement;
    var relativeOffset = $f195ac6af4853fa1$var$getOffsetRectRelativeToArbitraryNode(element, html);
    var width = Math.max(html.clientWidth, window.innerWidth || 0);
    var height = Math.max(html.clientHeight, window.innerHeight || 0);
    var scrollTop = !excludeScroll ? $f195ac6af4853fa1$var$getScroll(html) : 0;
    var scrollLeft = !excludeScroll ? $f195ac6af4853fa1$var$getScroll(html, "left") : 0;
    var offset = {
        top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
        left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
        width: width,
        height: height
    };
    return $f195ac6af4853fa1$var$getClientRect(offset);
}
/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */ function $f195ac6af4853fa1$var$isFixed(element) {
    var nodeName = element.nodeName;
    if (nodeName === "BODY" || nodeName === "HTML") return false;
    if ($f195ac6af4853fa1$var$getStyleComputedProperty(element, "position") === "fixed") return true;
    var parentNode = $f195ac6af4853fa1$var$getParentNode(element);
    if (!parentNode) return false;
    return $f195ac6af4853fa1$var$isFixed(parentNode);
}
/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */ function $f195ac6af4853fa1$var$getFixedPositionOffsetParent(element) {
    // This check is needed to avoid errors in case one of the elements isn't defined for any reason
    if (!element || !element.parentElement || $f195ac6af4853fa1$var$isIE()) return document.documentElement;
    var el = element.parentElement;
    while(el && $f195ac6af4853fa1$var$getStyleComputedProperty(el, "transform") === "none")el = el.parentElement;
    return el || document.documentElement;
}
/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */ function $f195ac6af4853fa1$var$getBoundaries(popper, reference, padding, boundariesElement) {
    var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    // NOTE: 1 DOM access here
    var boundaries = {
        top: 0,
        left: 0
    };
    var offsetParent = fixedPosition ? $f195ac6af4853fa1$var$getFixedPositionOffsetParent(popper) : $f195ac6af4853fa1$var$findCommonOffsetParent(popper, $f195ac6af4853fa1$var$getReferenceNode(reference));
    // Handle viewport case
    if (boundariesElement === "viewport") boundaries = $f195ac6af4853fa1$var$getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
    else {
        // Handle other cases based on DOM element used as boundaries
        var boundariesNode = void 0;
        if (boundariesElement === "scrollParent") {
            boundariesNode = $f195ac6af4853fa1$var$getScrollParent($f195ac6af4853fa1$var$getParentNode(reference));
            if (boundariesNode.nodeName === "BODY") boundariesNode = popper.ownerDocument.documentElement;
        } else if (boundariesElement === "window") boundariesNode = popper.ownerDocument.documentElement;
        else boundariesNode = boundariesElement;
        var offsets = $f195ac6af4853fa1$var$getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
        // In case of HTML, we need a different computation
        if (boundariesNode.nodeName === "HTML" && !$f195ac6af4853fa1$var$isFixed(offsetParent)) {
            var _getWindowSizes = $f195ac6af4853fa1$var$getWindowSizes(popper.ownerDocument), height = _getWindowSizes.height, width = _getWindowSizes.width;
            boundaries.top += offsets.top - offsets.marginTop;
            boundaries.bottom = height + offsets.top;
            boundaries.left += offsets.left - offsets.marginLeft;
            boundaries.right = width + offsets.left;
        } else // for all the other DOM elements, this one is good
        boundaries = offsets;
    }
    // Add paddings
    padding = padding || 0;
    var isPaddingNumber = typeof padding === "number";
    boundaries.left += isPaddingNumber ? padding : padding.left || 0;
    boundaries.top += isPaddingNumber ? padding : padding.top || 0;
    boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
    boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
    return boundaries;
}
function $f195ac6af4853fa1$var$getArea(_ref) {
    var width = _ref.width, height = _ref.height;
    return width * height;
}
/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $f195ac6af4853fa1$var$computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
    var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    if (placement.indexOf("auto") === -1) return placement;
    var boundaries = $f195ac6af4853fa1$var$getBoundaries(popper, reference, padding, boundariesElement);
    var rects = {
        top: {
            width: boundaries.width,
            height: refRect.top - boundaries.top
        },
        right: {
            width: boundaries.right - refRect.right,
            height: boundaries.height
        },
        bottom: {
            width: boundaries.width,
            height: boundaries.bottom - refRect.bottom
        },
        left: {
            width: refRect.left - boundaries.left,
            height: boundaries.height
        }
    };
    var sortedAreas = Object.keys(rects).map(function(key) {
        return $f195ac6af4853fa1$var$_extends({
            key: key
        }, rects[key], {
            area: $f195ac6af4853fa1$var$getArea(rects[key])
        });
    }).sort(function(a, b) {
        return b.area - a.area;
    });
    var filteredAreas = sortedAreas.filter(function(_ref2) {
        var width = _ref2.width, height = _ref2.height;
        return width >= popper.clientWidth && height >= popper.clientHeight;
    });
    var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
    var variation = placement.split("-")[1];
    return computedPlacement + (variation ? "-" + variation : "");
}
/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */ function $f195ac6af4853fa1$var$getReferenceOffsets(state, popper, reference) {
    var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var commonOffsetParent = fixedPosition ? $f195ac6af4853fa1$var$getFixedPositionOffsetParent(popper) : $f195ac6af4853fa1$var$findCommonOffsetParent(popper, $f195ac6af4853fa1$var$getReferenceNode(reference));
    return $f195ac6af4853fa1$var$getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}
/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */ function $f195ac6af4853fa1$var$getOuterSizes(element) {
    var window1 = element.ownerDocument.defaultView;
    var styles = window1.getComputedStyle(element);
    var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
    var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
    var result = {
        width: element.offsetWidth + y,
        height: element.offsetHeight + x
    };
    return result;
}
/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */ function $f195ac6af4853fa1$var$getOppositePlacement(placement) {
    var hash = {
        left: "right",
        right: "left",
        bottom: "top",
        top: "bottom"
    };
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return hash[matched];
    });
}
/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */ function $f195ac6af4853fa1$var$getPopperOffsets(popper, referenceOffsets, placement) {
    placement = placement.split("-")[0];
    // Get popper node sizes
    var popperRect = $f195ac6af4853fa1$var$getOuterSizes(popper);
    // Add position, width and height to our offsets object
    var popperOffsets = {
        width: popperRect.width,
        height: popperRect.height
    };
    // depending by the popper placement we have to compute its offsets slightly differently
    var isHoriz = [
        "right",
        "left"
    ].indexOf(placement) !== -1;
    var mainSide = isHoriz ? "top" : "left";
    var secondarySide = isHoriz ? "left" : "top";
    var measurement = isHoriz ? "height" : "width";
    var secondaryMeasurement = !isHoriz ? "height" : "width";
    popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
    if (placement === secondarySide) popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
    else popperOffsets[secondarySide] = referenceOffsets[$f195ac6af4853fa1$var$getOppositePlacement(secondarySide)];
    return popperOffsets;
}
/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function $f195ac6af4853fa1$var$find(arr, check) {
    // use native find if supported
    if (Array.prototype.find) return arr.find(check);
    // use `filter` to obtain the same behavior of `find`
    return arr.filter(check)[0];
}
/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */ function $f195ac6af4853fa1$var$findIndex(arr, prop, value) {
    // use native findIndex if supported
    if (Array.prototype.findIndex) return arr.findIndex(function(cur) {
        return cur[prop] === value;
    });
    // use `find` + `indexOf` if `findIndex` isn't supported
    var match = $f195ac6af4853fa1$var$find(arr, function(obj) {
        return obj[prop] === value;
    });
    return arr.indexOf(match);
}
/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */ function $f195ac6af4853fa1$var$runModifiers(modifiers, data, ends) {
    var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, $f195ac6af4853fa1$var$findIndex(modifiers, "name", ends));
    modifiersToRun.forEach(function(modifier) {
        if (modifier["function"]) // eslint-disable-line dot-notation
        console.warn("`modifier.function` is deprecated, use `modifier.fn`!");
        var fn = modifier["function"] || modifier.fn; // eslint-disable-line dot-notation
        if (modifier.enabled && $f195ac6af4853fa1$var$isFunction(fn)) {
            // Add properties to offsets to make them a complete clientRect object
            // we do this before each modifier to make sure the previous one doesn't
            // mess with these values
            data.offsets.popper = $f195ac6af4853fa1$var$getClientRect(data.offsets.popper);
            data.offsets.reference = $f195ac6af4853fa1$var$getClientRect(data.offsets.reference);
            data = fn(data, modifier);
        }
    });
    return data;
}
/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */ function $f195ac6af4853fa1$var$update() {
    // if popper is destroyed, don't perform any further update
    if (this.state.isDestroyed) return;
    var data = {
        instance: this,
        styles: {},
        arrowStyles: {},
        attributes: {},
        flipped: false,
        offsets: {}
    };
    // compute reference element offsets
    data.offsets.reference = $f195ac6af4853fa1$var$getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    data.placement = $f195ac6af4853fa1$var$computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
    // store the computed placement inside `originalPlacement`
    data.originalPlacement = data.placement;
    data.positionFixed = this.options.positionFixed;
    // compute the popper offsets
    data.offsets.popper = $f195ac6af4853fa1$var$getPopperOffsets(this.popper, data.offsets.reference, data.placement);
    data.offsets.popper.position = this.options.positionFixed ? "fixed" : "absolute";
    // run the modifiers
    data = $f195ac6af4853fa1$var$runModifiers(this.modifiers, data);
    // the first `update` will call `onCreate` callback
    // the other ones will call `onUpdate` callback
    if (!this.state.isCreated) {
        this.state.isCreated = true;
        this.options.onCreate(data);
    } else this.options.onUpdate(data);
}
/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */ function $f195ac6af4853fa1$var$isModifierEnabled(modifiers, modifierName) {
    return modifiers.some(function(_ref) {
        var name = _ref.name, enabled = _ref.enabled;
        return enabled && name === modifierName;
    });
}
/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */ function $f195ac6af4853fa1$var$getSupportedPropertyName(property) {
    var prefixes = [
        false,
        "ms",
        "Webkit",
        "Moz",
        "O"
    ];
    var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
    for(var i = 0; i < prefixes.length; i++){
        var prefix = prefixes[i];
        var toCheck = prefix ? "" + prefix + upperProp : property;
        if (typeof document.body.style[toCheck] !== "undefined") return toCheck;
    }
    return null;
}
/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */ function $f195ac6af4853fa1$var$destroy() {
    this.state.isDestroyed = true;
    // touch DOM only if `applyStyle` modifier is enabled
    if ($f195ac6af4853fa1$var$isModifierEnabled(this.modifiers, "applyStyle")) {
        this.popper.removeAttribute("x-placement");
        this.popper.style.position = "";
        this.popper.style.top = "";
        this.popper.style.left = "";
        this.popper.style.right = "";
        this.popper.style.bottom = "";
        this.popper.style.willChange = "";
        this.popper.style[$f195ac6af4853fa1$var$getSupportedPropertyName("transform")] = "";
    }
    this.disableEventListeners();
    // remove the popper if user explicitly asked for the deletion on destroy
    // do not use `remove` because IE11 doesn't support it
    if (this.options.removeOnDestroy) this.popper.parentNode.removeChild(this.popper);
    return this;
}
/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */ function $f195ac6af4853fa1$var$getWindow(element) {
    var ownerDocument = element.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView : window;
}
function $f195ac6af4853fa1$var$attachToScrollParents(scrollParent, event, callback, scrollParents) {
    var isBody = scrollParent.nodeName === "BODY";
    var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
    target.addEventListener(event, callback, {
        passive: true
    });
    if (!isBody) $f195ac6af4853fa1$var$attachToScrollParents($f195ac6af4853fa1$var$getScrollParent(target.parentNode), event, callback, scrollParents);
    scrollParents.push(target);
}
/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function $f195ac6af4853fa1$var$setupEventListeners(reference, options, state, updateBound) {
    // Resize event listener on window
    state.updateBound = updateBound;
    $f195ac6af4853fa1$var$getWindow(reference).addEventListener("resize", state.updateBound, {
        passive: true
    });
    // Scroll event listener on scroll parents
    var scrollElement = $f195ac6af4853fa1$var$getScrollParent(reference);
    $f195ac6af4853fa1$var$attachToScrollParents(scrollElement, "scroll", state.updateBound, state.scrollParents);
    state.scrollElement = scrollElement;
    state.eventsEnabled = true;
    return state;
}
/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */ function $f195ac6af4853fa1$var$enableEventListeners() {
    if (!this.state.eventsEnabled) this.state = $f195ac6af4853fa1$var$setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
}
/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */ function $f195ac6af4853fa1$var$removeEventListeners(reference, state) {
    // Remove resize event listener on window
    $f195ac6af4853fa1$var$getWindow(reference).removeEventListener("resize", state.updateBound);
    // Remove scroll event listener on scroll parents
    state.scrollParents.forEach(function(target) {
        target.removeEventListener("scroll", state.updateBound);
    });
    // Reset state
    state.updateBound = null;
    state.scrollParents = [];
    state.scrollElement = null;
    state.eventsEnabled = false;
    return state;
}
/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */ function $f195ac6af4853fa1$var$disableEventListeners() {
    if (this.state.eventsEnabled) {
        cancelAnimationFrame(this.scheduleUpdate);
        this.state = $f195ac6af4853fa1$var$removeEventListeners(this.reference, this.state);
    }
}
/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */ function $f195ac6af4853fa1$var$isNumeric(n) {
    return n !== "" && !isNaN(parseFloat(n)) && isFinite(n);
}
/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function $f195ac6af4853fa1$var$setStyles(element, styles) {
    Object.keys(styles).forEach(function(prop) {
        var unit = "";
        // add unit if the value is numeric and is one of the following
        if ([
            "width",
            "height",
            "top",
            "right",
            "bottom",
            "left"
        ].indexOf(prop) !== -1 && $f195ac6af4853fa1$var$isNumeric(styles[prop])) unit = "px";
        element.style[prop] = styles[prop] + unit;
    });
}
/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */ function $f195ac6af4853fa1$var$setAttributes(element, attributes) {
    Object.keys(attributes).forEach(function(prop) {
        var value = attributes[prop];
        if (value !== false) element.setAttribute(prop, attributes[prop]);
        else element.removeAttribute(prop);
    });
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */ function $f195ac6af4853fa1$var$applyStyle(data) {
    // any property present in `data.styles` will be applied to the popper,
    // in this way we can make the 3rd party modifiers add custom styles to it
    // Be aware, modifiers could override the properties defined in the previous
    // lines of this modifier!
    $f195ac6af4853fa1$var$setStyles(data.instance.popper, data.styles);
    // any property present in `data.attributes` will be applied to the popper,
    // they will be set as HTML attributes of the element
    $f195ac6af4853fa1$var$setAttributes(data.instance.popper, data.attributes);
    // if arrowElement is defined and arrowStyles has some properties
    if (data.arrowElement && Object.keys(data.arrowStyles).length) $f195ac6af4853fa1$var$setStyles(data.arrowElement, data.arrowStyles);
    return data;
}
/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */ function $f195ac6af4853fa1$var$applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
    // compute reference element offsets
    var referenceOffsets = $f195ac6af4853fa1$var$getReferenceOffsets(state, popper, reference, options.positionFixed);
    // compute auto placement, store placement inside the data object,
    // modifiers will be able to edit `placement` if needed
    // and refer to originalPlacement to know the original value
    var placement = $f195ac6af4853fa1$var$computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
    popper.setAttribute("x-placement", placement);
    // Apply `position` to popper before anything else because
    // without the position applied we can't guarantee correct computations
    $f195ac6af4853fa1$var$setStyles(popper, {
        position: options.positionFixed ? "fixed" : "absolute"
    });
    return options;
}
/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */ function $f195ac6af4853fa1$var$getRoundedOffsets(data, shouldRound) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var round = Math.round, floor = Math.floor;
    var noRound = function noRound(v) {
        return v;
    };
    var referenceWidth = round(reference.width);
    var popperWidth = round(popper.width);
    var isVertical = [
        "left",
        "right"
    ].indexOf(data.placement) !== -1;
    var isVariation = data.placement.indexOf("-") !== -1;
    var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
    var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
    var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
    var verticalToInteger = !shouldRound ? noRound : round;
    return {
        left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
        top: verticalToInteger(popper.top),
        bottom: verticalToInteger(popper.bottom),
        right: horizontalToInteger(popper.right)
    };
}
var $f195ac6af4853fa1$var$isFirefox = $f195ac6af4853fa1$var$isBrowser && /Firefox/i.test(navigator.userAgent);
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $f195ac6af4853fa1$var$computeStyle(data, options) {
    var x = options.x, y = options.y;
    var popper = data.offsets.popper;
    // Remove this legacy support in Popper.js v2
    var legacyGpuAccelerationOption = $f195ac6af4853fa1$var$find(data.instance.modifiers, function(modifier) {
        return modifier.name === "applyStyle";
    }).gpuAcceleration;
    if (legacyGpuAccelerationOption !== undefined) console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");
    var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
    var offsetParent = $f195ac6af4853fa1$var$getOffsetParent(data.instance.popper);
    var offsetParentRect = $f195ac6af4853fa1$var$getBoundingClientRect(offsetParent);
    // Styles
    var styles = {
        position: popper.position
    };
    var offsets = $f195ac6af4853fa1$var$getRoundedOffsets(data, window.devicePixelRatio < 2 || !$f195ac6af4853fa1$var$isFirefox);
    var sideA = x === "bottom" ? "top" : "bottom";
    var sideB = y === "right" ? "left" : "right";
    // if gpuAcceleration is set to `true` and transform is supported,
    //  we use `translate3d` to apply the position to the popper we
    // automatically use the supported prefixed version if needed
    var prefixedProperty = $f195ac6af4853fa1$var$getSupportedPropertyName("transform");
    // now, let's make a step back and look at this code closely (wtf?)
    // If the content of the popper grows once it's been positioned, it
    // may happen that the popper gets misplaced because of the new content
    // overflowing its reference element
    // To avoid this problem, we provide two options (x and y), which allow
    // the consumer to define the offset origin.
    // If we position a popper on top of a reference element, we can set
    // `x` to `top` to make the popper grow towards its top instead of
    // its bottom.
    var left = void 0, top = void 0;
    if (sideA === "bottom") {
        // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
        // and not the bottom of the html element
        if (offsetParent.nodeName === "HTML") top = -offsetParent.clientHeight + offsets.bottom;
        else top = -offsetParentRect.height + offsets.bottom;
    } else top = offsets.top;
    if (sideB === "right") {
        if (offsetParent.nodeName === "HTML") left = -offsetParent.clientWidth + offsets.right;
        else left = -offsetParentRect.width + offsets.right;
    } else left = offsets.left;
    if (gpuAcceleration && prefixedProperty) {
        styles[prefixedProperty] = "translate3d(" + left + "px, " + top + "px, 0)";
        styles[sideA] = 0;
        styles[sideB] = 0;
        styles.willChange = "transform";
    } else {
        // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
        var invertTop = sideA === "bottom" ? -1 : 1;
        var invertLeft = sideB === "right" ? -1 : 1;
        styles[sideA] = top * invertTop;
        styles[sideB] = left * invertLeft;
        styles.willChange = sideA + ", " + sideB;
    }
    // Attributes
    var attributes = {
        "x-placement": data.placement
    };
    // Update `data` attributes, styles and arrowStyles
    data.attributes = $f195ac6af4853fa1$var$_extends({}, attributes, data.attributes);
    data.styles = $f195ac6af4853fa1$var$_extends({}, styles, data.styles);
    data.arrowStyles = $f195ac6af4853fa1$var$_extends({}, data.offsets.arrow, data.arrowStyles);
    return data;
}
/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */ function $f195ac6af4853fa1$var$isModifierRequired(modifiers, requestingName, requestedName) {
    var requesting = $f195ac6af4853fa1$var$find(modifiers, function(_ref) {
        var name = _ref.name;
        return name === requestingName;
    });
    var isRequired = !!requesting && modifiers.some(function(modifier) {
        return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
    });
    if (!isRequired) {
        var _requesting = "`" + requestingName + "`";
        var requested = "`" + requestedName + "`";
        console.warn(requested + " modifier is required by " + _requesting + " modifier in order to work, be sure to include it before " + _requesting + "!");
    }
    return isRequired;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $f195ac6af4853fa1$var$arrow(data, options) {
    var _data$offsets$arrow;
    // arrow depends on keepTogether in order to work
    if (!$f195ac6af4853fa1$var$isModifierRequired(data.instance.modifiers, "arrow", "keepTogether")) return data;
    var arrowElement = options.element;
    // if arrowElement is a string, suppose it's a CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = data.instance.popper.querySelector(arrowElement);
        // if arrowElement is not found, don't run the modifier
        if (!arrowElement) return data;
    } else // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
        console.warn("WARNING: `arrow.element` must be child of its popper element!");
        return data;
    }
    var placement = data.placement.split("-")[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isVertical = [
        "left",
        "right"
    ].indexOf(placement) !== -1;
    var len = isVertical ? "height" : "width";
    var sideCapitalized = isVertical ? "Top" : "Left";
    var side = sideCapitalized.toLowerCase();
    var altSide = isVertical ? "left" : "top";
    var opSide = isVertical ? "bottom" : "right";
    var arrowElementSize = $f195ac6af4853fa1$var$getOuterSizes(arrowElement)[len];
    //
    // extends keepTogether behavior making sure the popper and its
    // reference have enough pixels in conjunction
    //
    // top/left side
    if (reference[opSide] - arrowElementSize < popper[side]) data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
    // bottom/right side
    if (reference[side] + arrowElementSize > popper[opSide]) data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
    data.offsets.popper = $f195ac6af4853fa1$var$getClientRect(data.offsets.popper);
    // compute center of the popper
    var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
    // Compute the sideValue using the updated popper offsets
    // take popper margin in account because we don't have this info available
    var css = $f195ac6af4853fa1$var$getStyleComputedProperty(data.instance.popper);
    var popperMarginSide = parseFloat(css["margin" + sideCapitalized]);
    var popperBorderSide = parseFloat(css["border" + sideCapitalized + "Width"]);
    var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
    // prevent arrowElement from being placed not contiguously to its popper
    sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
    data.arrowElement = arrowElement;
    data.offsets.arrow = (_data$offsets$arrow = {}, $f195ac6af4853fa1$var$defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), $f195ac6af4853fa1$var$defineProperty(_data$offsets$arrow, altSide, ""), _data$offsets$arrow);
    return data;
}
/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */ function $f195ac6af4853fa1$var$getOppositeVariation(variation) {
    if (variation === "end") return "start";
    else if (variation === "start") return "end";
    return variation;
}
/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */ var $f195ac6af4853fa1$var$placements = [
    "auto-start",
    "auto",
    "auto-end",
    "top-start",
    "top",
    "top-end",
    "right-start",
    "right",
    "right-end",
    "bottom-end",
    "bottom",
    "bottom-start",
    "left-end",
    "left",
    "left-start"
];
// Get rid of `auto` `auto-start` and `auto-end`
var $f195ac6af4853fa1$var$validPlacements = $f195ac6af4853fa1$var$placements.slice(3);
/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */ function $f195ac6af4853fa1$var$clockwise(placement) {
    var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var index = $f195ac6af4853fa1$var$validPlacements.indexOf(placement);
    var arr = $f195ac6af4853fa1$var$validPlacements.slice(index + 1).concat($f195ac6af4853fa1$var$validPlacements.slice(0, index));
    return counter ? arr.reverse() : arr;
}
var $f195ac6af4853fa1$var$BEHAVIORS = {
    FLIP: "flip",
    CLOCKWISE: "clockwise",
    COUNTERCLOCKWISE: "counterclockwise"
};
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $f195ac6af4853fa1$var$flip(data, options) {
    // if `inner` modifier is enabled, we can't use the `flip` modifier
    if ($f195ac6af4853fa1$var$isModifierEnabled(data.instance.modifiers, "inner")) return data;
    if (data.flipped && data.placement === data.originalPlacement) // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
    var boundaries = $f195ac6af4853fa1$var$getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
    var placement = data.placement.split("-")[0];
    var placementOpposite = $f195ac6af4853fa1$var$getOppositePlacement(placement);
    var variation = data.placement.split("-")[1] || "";
    var flipOrder = [];
    switch(options.behavior){
        case $f195ac6af4853fa1$var$BEHAVIORS.FLIP:
            flipOrder = [
                placement,
                placementOpposite
            ];
            break;
        case $f195ac6af4853fa1$var$BEHAVIORS.CLOCKWISE:
            flipOrder = $f195ac6af4853fa1$var$clockwise(placement);
            break;
        case $f195ac6af4853fa1$var$BEHAVIORS.COUNTERCLOCKWISE:
            flipOrder = $f195ac6af4853fa1$var$clockwise(placement, true);
            break;
        default:
            flipOrder = options.behavior;
    }
    flipOrder.forEach(function(step, index) {
        if (placement !== step || flipOrder.length === index + 1) return data;
        placement = data.placement.split("-")[0];
        placementOpposite = $f195ac6af4853fa1$var$getOppositePlacement(placement);
        var popperOffsets = data.offsets.popper;
        var refOffsets = data.offsets.reference;
        // using floor because the reference offsets may contain decimals we are not going to consider here
        var floor = Math.floor;
        var overlapsRef = placement === "left" && floor(popperOffsets.right) > floor(refOffsets.left) || placement === "right" && floor(popperOffsets.left) < floor(refOffsets.right) || placement === "top" && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === "bottom" && floor(popperOffsets.top) < floor(refOffsets.bottom);
        var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
        var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
        var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
        var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
        var overflowsBoundaries = placement === "left" && overflowsLeft || placement === "right" && overflowsRight || placement === "top" && overflowsTop || placement === "bottom" && overflowsBottom;
        // flip the variation if required
        var isVertical = [
            "top",
            "bottom"
        ].indexOf(placement) !== -1;
        // flips variation if reference element overflows boundaries
        var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === "start" && overflowsLeft || isVertical && variation === "end" && overflowsRight || !isVertical && variation === "start" && overflowsTop || !isVertical && variation === "end" && overflowsBottom);
        // flips variation if popper content overflows boundaries
        var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === "start" && overflowsRight || isVertical && variation === "end" && overflowsLeft || !isVertical && variation === "start" && overflowsBottom || !isVertical && variation === "end" && overflowsTop);
        var flippedVariation = flippedVariationByRef || flippedVariationByContent;
        if (overlapsRef || overflowsBoundaries || flippedVariation) {
            // this boolean to detect any flip loop
            data.flipped = true;
            if (overlapsRef || overflowsBoundaries) placement = flipOrder[index + 1];
            if (flippedVariation) variation = $f195ac6af4853fa1$var$getOppositeVariation(variation);
            data.placement = placement + (variation ? "-" + variation : "");
            // this object contains `position`, we want to preserve it along with
            // any additional property we may add in the future
            data.offsets.popper = $f195ac6af4853fa1$var$_extends({}, data.offsets.popper, $f195ac6af4853fa1$var$getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
            data = $f195ac6af4853fa1$var$runModifiers(data.instance.modifiers, data, "flip");
        }
    });
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $f195ac6af4853fa1$var$keepTogether(data) {
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var placement = data.placement.split("-")[0];
    var floor = Math.floor;
    var isVertical = [
        "top",
        "bottom"
    ].indexOf(placement) !== -1;
    var side = isVertical ? "right" : "bottom";
    var opSide = isVertical ? "left" : "top";
    var measurement = isVertical ? "width" : "height";
    if (popper[side] < floor(reference[opSide])) data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
    if (popper[opSide] > floor(reference[side])) data.offsets.popper[opSide] = floor(reference[side]);
    return data;
}
/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */ function $f195ac6af4853fa1$var$toValue(str, measurement, popperOffsets, referenceOffsets) {
    // separate value from unit
    var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
    var value = +split[1];
    var unit = split[2];
    // If it's not a number it's an operator, I guess
    if (!value) return str;
    if (unit.indexOf("%") === 0) {
        var element = void 0;
        switch(unit){
            case "%p":
                element = popperOffsets;
                break;
            case "%":
            case "%r":
            default:
                element = referenceOffsets;
        }
        var rect = $f195ac6af4853fa1$var$getClientRect(element);
        return rect[measurement] / 100 * value;
    } else if (unit === "vh" || unit === "vw") {
        // if is a vh or vw, we calculate the size based on the viewport
        var size = void 0;
        if (unit === "vh") size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        else size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        return size / 100 * value;
    } else // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
}
/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */ function $f195ac6af4853fa1$var$parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
    var offsets = [
        0,
        0
    ];
    // Use height if placement is left or right and index is 0 otherwise use width
    // in this way the first offset will use an axis and the second one
    // will use the other one
    var useHeight = [
        "right",
        "left"
    ].indexOf(basePlacement) !== -1;
    // Split the offset string to obtain a list of values and operands
    // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
    var fragments = offset.split(/(\+|\-)/).map(function(frag) {
        return frag.trim();
    });
    // Detect if the offset string contains a pair of values or a single one
    // they could be separated by comma or space
    var divider = fragments.indexOf($f195ac6af4853fa1$var$find(fragments, function(frag) {
        return frag.search(/,|\s/) !== -1;
    }));
    if (fragments[divider] && fragments[divider].indexOf(",") === -1) console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");
    // If divider is found, we divide the list of values and operands to divide
    // them by ofset X and Y.
    var splitRegex = /\s*,\s*|\s+/;
    var ops = divider !== -1 ? [
        fragments.slice(0, divider).concat([
            fragments[divider].split(splitRegex)[0]
        ]),
        [
            fragments[divider].split(splitRegex)[1]
        ].concat(fragments.slice(divider + 1))
    ] : [
        fragments
    ];
    // Convert the values with units to absolute pixels to allow our computations
    ops = ops.map(function(op, index) {
        // Most of the units rely on the orientation of the popper
        var measurement = (index === 1 ? !useHeight : useHeight) ? "height" : "width";
        var mergeWithPrevious = false;
        return op// This aggregates any `+` or `-` sign that aren't considered operators
        // e.g.: 10 + +5 => [10, +, +5]
        .reduce(function(a, b) {
            if (a[a.length - 1] === "" && [
                "+",
                "-"
            ].indexOf(b) !== -1) {
                a[a.length - 1] = b;
                mergeWithPrevious = true;
                return a;
            } else if (mergeWithPrevious) {
                a[a.length - 1] += b;
                mergeWithPrevious = false;
                return a;
            } else return a.concat(b);
        }, [])// Here we convert the string values into number values (in px)
        .map(function(str) {
            return $f195ac6af4853fa1$var$toValue(str, measurement, popperOffsets, referenceOffsets);
        });
    });
    // Loop trough the offsets arrays and execute the operations
    ops.forEach(function(op, index) {
        op.forEach(function(frag, index2) {
            if ($f195ac6af4853fa1$var$isNumeric(frag)) offsets[index] += frag * (op[index2 - 1] === "-" ? -1 : 1);
        });
    });
    return offsets;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */ function $f195ac6af4853fa1$var$offset(data, _ref) {
    var offset = _ref.offset;
    var placement = data.placement, _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var basePlacement = placement.split("-")[0];
    var offsets = void 0;
    if ($f195ac6af4853fa1$var$isNumeric(+offset)) offsets = [
        +offset,
        0
    ];
    else offsets = $f195ac6af4853fa1$var$parseOffset(offset, popper, reference, basePlacement);
    if (basePlacement === "left") {
        popper.top += offsets[0];
        popper.left -= offsets[1];
    } else if (basePlacement === "right") {
        popper.top += offsets[0];
        popper.left += offsets[1];
    } else if (basePlacement === "top") {
        popper.left += offsets[0];
        popper.top -= offsets[1];
    } else if (basePlacement === "bottom") {
        popper.left += offsets[0];
        popper.top += offsets[1];
    }
    data.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $f195ac6af4853fa1$var$preventOverflow(data, options) {
    var boundariesElement = options.boundariesElement || $f195ac6af4853fa1$var$getOffsetParent(data.instance.popper);
    // If offsetParent is the reference element, we really want to
    // go one step up and use the next offsetParent as reference to
    // avoid to make this modifier completely useless and look like broken
    if (data.instance.reference === boundariesElement) boundariesElement = $f195ac6af4853fa1$var$getOffsetParent(boundariesElement);
    // NOTE: DOM access here
    // resets the popper's position so that the document size can be calculated excluding
    // the size of the popper element itself
    var transformProp = $f195ac6af4853fa1$var$getSupportedPropertyName("transform");
    var popperStyles = data.instance.popper.style; // assignment to help minification
    var top = popperStyles.top, left = popperStyles.left, transform = popperStyles[transformProp];
    popperStyles.top = "";
    popperStyles.left = "";
    popperStyles[transformProp] = "";
    var boundaries = $f195ac6af4853fa1$var$getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
    // NOTE: DOM access here
    // restores the original style properties after the offsets have been computed
    popperStyles.top = top;
    popperStyles.left = left;
    popperStyles[transformProp] = transform;
    options.boundaries = boundaries;
    var order = options.priority;
    var popper = data.offsets.popper;
    var check = {
        primary: function primary(placement) {
            var value = popper[placement];
            if (popper[placement] < boundaries[placement] && !options.escapeWithReference) value = Math.max(popper[placement], boundaries[placement]);
            return $f195ac6af4853fa1$var$defineProperty({}, placement, value);
        },
        secondary: function secondary(placement) {
            var mainSide = placement === "right" ? "left" : "top";
            var value = popper[mainSide];
            if (popper[placement] > boundaries[placement] && !options.escapeWithReference) value = Math.min(popper[mainSide], boundaries[placement] - (placement === "right" ? popper.width : popper.height));
            return $f195ac6af4853fa1$var$defineProperty({}, mainSide, value);
        }
    };
    order.forEach(function(placement) {
        var side = [
            "left",
            "top"
        ].indexOf(placement) !== -1 ? "primary" : "secondary";
        popper = $f195ac6af4853fa1$var$_extends({}, popper, check[side](placement));
    });
    data.offsets.popper = popper;
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $f195ac6af4853fa1$var$shift(data) {
    var placement = data.placement;
    var basePlacement = placement.split("-")[0];
    var shiftvariation = placement.split("-")[1];
    // if shift shiftvariation is specified, run the modifier
    if (shiftvariation) {
        var _data$offsets = data.offsets, reference = _data$offsets.reference, popper = _data$offsets.popper;
        var isVertical = [
            "bottom",
            "top"
        ].indexOf(basePlacement) !== -1;
        var side = isVertical ? "left" : "top";
        var measurement = isVertical ? "width" : "height";
        var shiftOffsets = {
            start: $f195ac6af4853fa1$var$defineProperty({}, side, reference[side]),
            end: $f195ac6af4853fa1$var$defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
        };
        data.offsets.popper = $f195ac6af4853fa1$var$_extends({}, popper, shiftOffsets[shiftvariation]);
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $f195ac6af4853fa1$var$hide(data) {
    if (!$f195ac6af4853fa1$var$isModifierRequired(data.instance.modifiers, "hide", "preventOverflow")) return data;
    var refRect = data.offsets.reference;
    var bound = $f195ac6af4853fa1$var$find(data.instance.modifiers, function(modifier) {
        return modifier.name === "preventOverflow";
    }).boundaries;
    if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === true) return data;
        data.hide = true;
        data.attributes["x-out-of-boundaries"] = "";
    } else {
        // Avoid unnecessary DOM access if visibility hasn't changed
        if (data.hide === false) return data;
        data.hide = false;
        data.attributes["x-out-of-boundaries"] = false;
    }
    return data;
}
/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */ function $f195ac6af4853fa1$var$inner(data) {
    var placement = data.placement;
    var basePlacement = placement.split("-")[0];
    var _data$offsets = data.offsets, popper = _data$offsets.popper, reference = _data$offsets.reference;
    var isHoriz = [
        "left",
        "right"
    ].indexOf(basePlacement) !== -1;
    var subtractLength = [
        "top",
        "left"
    ].indexOf(basePlacement) === -1;
    popper[isHoriz ? "left" : "top"] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? "width" : "height"] : 0);
    data.placement = $f195ac6af4853fa1$var$getOppositePlacement(placement);
    data.offsets.popper = $f195ac6af4853fa1$var$getClientRect(popper);
    return data;
}
/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */ /**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */ var $f195ac6af4853fa1$var$modifiers = {
    /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */ shift: {
        /** @prop {number} order=100 - Index used to define the order of execution */ order: 100,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $f195ac6af4853fa1$var$shift
    },
    /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */ offset: {
        /** @prop {number} order=200 - Index used to define the order of execution */ order: 200,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $f195ac6af4853fa1$var$offset,
        /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */ offset: 0
    },
    /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */ preventOverflow: {
        /** @prop {number} order=300 - Index used to define the order of execution */ order: 300,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $f195ac6af4853fa1$var$preventOverflow,
        /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */ priority: [
            "left",
            "right",
            "top",
            "bottom"
        ],
        /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */ boundariesElement: "scrollParent"
    },
    /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */ keepTogether: {
        /** @prop {number} order=400 - Index used to define the order of execution */ order: 400,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $f195ac6af4853fa1$var$keepTogether
    },
    /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */ arrow: {
        /** @prop {number} order=500 - Index used to define the order of execution */ order: 500,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $f195ac6af4853fa1$var$arrow,
        /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */ element: "[x-arrow]"
    },
    /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */ flip: {
        /** @prop {number} order=600 - Index used to define the order of execution */ order: 600,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $f195ac6af4853fa1$var$flip,
        /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */ behavior: "flip",
        /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */ padding: 5,
        /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */ boundariesElement: "viewport",
        /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariations: false,
        /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */ flipVariationsByContent: false
    },
    /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */ inner: {
        /** @prop {number} order=700 - Index used to define the order of execution */ order: 700,
        /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */ enabled: false,
        /** @prop {ModifierFn} */ fn: $f195ac6af4853fa1$var$inner
    },
    /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */ hide: {
        /** @prop {number} order=800 - Index used to define the order of execution */ order: 800,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $f195ac6af4853fa1$var$hide
    },
    /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */ computeStyle: {
        /** @prop {number} order=850 - Index used to define the order of execution */ order: 850,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $f195ac6af4853fa1$var$computeStyle,
        /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: true,
        /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */ x: "bottom",
        /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */ y: "right"
    },
    /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */ applyStyle: {
        /** @prop {number} order=900 - Index used to define the order of execution */ order: 900,
        /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */ enabled: true,
        /** @prop {ModifierFn} */ fn: $f195ac6af4853fa1$var$applyStyle,
        /** @prop {Function} */ onLoad: $f195ac6af4853fa1$var$applyStyleOnLoad,
        /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */ gpuAcceleration: undefined
    }
};
/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */ /**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */ var $f195ac6af4853fa1$var$Defaults = {
    /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */ placement: "bottom",
    /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */ positionFixed: false,
    /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */ eventsEnabled: true,
    /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */ removeOnDestroy: false,
    /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */ onCreate: function onCreate() {},
    /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */ onUpdate: function onUpdate() {},
    /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */ modifiers: $f195ac6af4853fa1$var$modifiers
};
/**
 * @callback onCreate
 * @param {dataObject} data
 */ /**
 * @callback onUpdate
 * @param {dataObject} data
 */ // Utils
// Methods
var $f195ac6af4853fa1$var$Popper = function() {
    /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */ function Popper(reference, popper) {
        var _this = this;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        $f195ac6af4853fa1$var$classCallCheck(this, Popper);
        this.scheduleUpdate = function() {
            return requestAnimationFrame(_this.update);
        };
        // make update() debounced, so that it only runs at most once-per-tick
        this.update = $f195ac6af4853fa1$var$debounce(this.update.bind(this));
        // with {} we create a new object with the options inside it
        this.options = $f195ac6af4853fa1$var$_extends({}, Popper.Defaults, options);
        // init state
        this.state = {
            isDestroyed: false,
            isCreated: false,
            scrollParents: []
        };
        // get reference and popper elements (allow jQuery wrappers)
        this.reference = reference && reference.jquery ? reference[0] : reference;
        this.popper = popper && popper.jquery ? popper[0] : popper;
        // Deep merge modifiers options
        this.options.modifiers = {};
        Object.keys($f195ac6af4853fa1$var$_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function(name) {
            _this.options.modifiers[name] = $f195ac6af4853fa1$var$_extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
        });
        // Refactoring modifiers' list (Object => Array)
        this.modifiers = Object.keys(this.options.modifiers).map(function(name) {
            return $f195ac6af4853fa1$var$_extends({
                name: name
            }, _this.options.modifiers[name]);
        })// sort the modifiers by order
        .sort(function(a, b) {
            return a.order - b.order;
        });
        // modifiers have the ability to execute arbitrary code when Popper.js get inited
        // such code is executed in the same order of its modifier
        // they could add new properties to their options configuration
        // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
        this.modifiers.forEach(function(modifierOptions) {
            if (modifierOptions.enabled && $f195ac6af4853fa1$var$isFunction(modifierOptions.onLoad)) modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
        });
        // fire the first update to position the popper in the right place
        this.update();
        var eventsEnabled = this.options.eventsEnabled;
        if (eventsEnabled) // setup event listeners, they will take care of update the position in specific situations
        this.enableEventListeners();
        this.state.eventsEnabled = eventsEnabled;
    }
    // We can't use class properties because they don't get listed in the
    // class prototype and break stuff like Sinon stubs
    $f195ac6af4853fa1$var$createClass(Popper, [
        {
            key: "update",
            value: function update$$1() {
                return $f195ac6af4853fa1$var$update.call(this);
            }
        },
        {
            key: "destroy",
            value: function destroy$$1() {
                return $f195ac6af4853fa1$var$destroy.call(this);
            }
        },
        {
            key: "enableEventListeners",
            value: function enableEventListeners$$1() {
                return $f195ac6af4853fa1$var$enableEventListeners.call(this);
            }
        },
        {
            key: "disableEventListeners",
            value: function disableEventListeners$$1() {
                return $f195ac6af4853fa1$var$disableEventListeners.call(this);
            }
        }
    ]);
    return Popper;
}();
/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */ $f195ac6af4853fa1$var$Popper.Utils = (typeof window !== "undefined" ? window : $parcel$global).PopperUtils;
$f195ac6af4853fa1$var$Popper.placements = $f195ac6af4853fa1$var$placements;
$f195ac6af4853fa1$var$Popper.Defaults = $f195ac6af4853fa1$var$Defaults;
var $f195ac6af4853fa1$export$2e2bcd8739ae039 = $f195ac6af4853fa1$var$Popper;

});

parcelRegister("8j0J5", function(module, exports) {

$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $60c0a9468407f91d$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $60c0a9468407f91d$export$cbabb21c2529b130);
$parcel$export(module.exports, "default", () => $60c0a9468407f91d$export$2e2bcd8739ae039);

var $6r4zt = parcelRequire("6r4zt");

var $6zC7B = parcelRequire("6zC7B");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $k5QaM = parcelRequire("k5QaM");
var $60c0a9468407f91d$export$3dbd3405086fec7b = (0, (/*@__PURE__*/$parcel$interopDefault($k5QaM)))();
var $60c0a9468407f91d$export$cbabb21c2529b130 = (0, (/*@__PURE__*/$parcel$interopDefault($k5QaM)))();
var $60c0a9468407f91d$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React$Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($6r4zt)))(Manager, _React$Component);
    function Manager() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this)), "referenceNode", void 0);
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this)), "setReferenceNode", function(newReferenceNode) {
            if (newReferenceNode && _this.referenceNode !== newReferenceNode) {
                _this.referenceNode = newReferenceNode;
                _this.forceUpdate();
            }
        });
        return _this;
    }
    var _proto = Manager.prototype;
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.referenceNode = null;
    };
    _proto.render = function render() {
        return $acw62.createElement($60c0a9468407f91d$export$3dbd3405086fec7b.Provider, {
            value: this.referenceNode
        }, $acw62.createElement($60c0a9468407f91d$export$cbabb21c2529b130.Provider, {
            value: this.setReferenceNode
        }, this.props.children));
    };
    return Manager;
}($acw62.Component);

});
parcelRegister("k5QaM", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $acw62 = parcelRequire("acw62");
var $ea0cbeb6be7ba059$var$_react2 = $ea0cbeb6be7ba059$var$_interopRequireDefault($acw62);

var $cMatq = parcelRequire("cMatq");
var $ea0cbeb6be7ba059$var$_implementation2 = $ea0cbeb6be7ba059$var$_interopRequireDefault($cMatq);
function $ea0cbeb6be7ba059$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.default = $ea0cbeb6be7ba059$var$_react2.default.createContext || $ea0cbeb6be7ba059$var$_implementation2.default;
module.exports = module.exports["default"];

});
parcelRegister("cMatq", function(module, exports) {
"use strict";
module.exports.__esModule = true;

var $acw62 = parcelRequire("acw62");
var $94d2179455655048$var$_react2 = $94d2179455655048$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");
var $94d2179455655048$var$_propTypes2 = $94d2179455655048$var$_interopRequireDefault($c9Z8w);

var $cBOTA = parcelRequire("cBOTA");
var $94d2179455655048$var$_gud2 = $94d2179455655048$var$_interopRequireDefault($cBOTA);

var $kg9aN = parcelRequire("kg9aN");
var $94d2179455655048$var$_warning2 = $94d2179455655048$var$_interopRequireDefault($kg9aN);
function $94d2179455655048$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $94d2179455655048$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $94d2179455655048$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $94d2179455655048$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $94d2179455655048$var$MAX_SIGNED_31_BIT_INT = 1073741823;
// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function $94d2179455655048$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $94d2179455655048$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $94d2179455655048$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $94d2179455655048$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + (0, $94d2179455655048$var$_gud2.default)() + "__";
    var Provider = function(_Component) {
        $94d2179455655048$var$_inherits(Provider, _Component);
        function Provider() {
            var _temp, _this, _ret;
            $94d2179455655048$var$_classCallCheck(this, Provider);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $94d2179455655048$var$_possibleConstructorReturn(this, _Component.call.apply(_Component, [
                this
            ].concat(args))), _this), _this.emitter = $94d2179455655048$var$createEventEmitter(_this.props.value), _temp), $94d2179455655048$var$_possibleConstructorReturn(_this, _ret);
        }
        Provider.prototype.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits = void 0;
                if ($94d2179455655048$var$objectIs(oldValue, newValue)) changedBits = 0; // No change
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : $94d2179455655048$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        Provider.prototype.render = function render() {
            return this.props.children;
        };
        return Provider;
    }($acw62.Component);
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = $94d2179455655048$var$_propTypes2.default.object.isRequired, _Provider$childContex);
    var Consumer = function(_Component2) {
        $94d2179455655048$var$_inherits(Consumer, _Component2);
        function Consumer() {
            var _temp2, _this2, _ret2;
            $94d2179455655048$var$_classCallCheck(this, Consumer);
            for(var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return _ret2 = (_temp2 = (_this2 = $94d2179455655048$var$_possibleConstructorReturn(this, _Component2.call.apply(_Component2, [
                this
            ].concat(args))), _this2), _this2.state = {
                value: _this2.getValue()
            }, _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            }, _temp2), $94d2179455655048$var$_possibleConstructorReturn(_this2, _ret2);
        }
        Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $94d2179455655048$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        Consumer.prototype.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $94d2179455655048$var$MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
             : observedBits;
        };
        Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        Consumer.prototype.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        Consumer.prototype.render = function render() {
            return $94d2179455655048$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }($acw62.Component);
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = $94d2179455655048$var$_propTypes2.default.object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
module.exports.default = $94d2179455655048$var$createReactContext;
module.exports = module.exports["default"];

});
parcelRegister("cBOTA", function(module, exports) {
// @flow
"use strict";
var $92e06b8def6c7a49$var$key = "__global_unique_id__";
module.exports = function() {
    return $parcel$global[$92e06b8def6c7a49$var$key] = ($parcel$global[$92e06b8def6c7a49$var$key] || 0) + 1;
};

});

parcelRegister("kg9aN", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $ebfc6adce9fdacf8$var$__DEV__ = false;
var $ebfc6adce9fdacf8$var$warning = function() {};
if ($ebfc6adce9fdacf8$var$__DEV__) {
    var $ebfc6adce9fdacf8$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $ebfc6adce9fdacf8$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $ebfc6adce9fdacf8$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = $ebfc6adce9fdacf8$var$warning;

});




parcelRegister("buXxn", function(module, exports) {

$parcel$export(module.exports, "unwrapArray", () => $85f0adf197ea687e$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $85f0adf197ea687e$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $85f0adf197ea687e$export$4bb192c7cacf928f);
/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */ var $85f0adf197ea687e$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $85f0adf197ea687e$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === "function") {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $85f0adf197ea687e$export$d36bdfa510afb180 = function shallowEqual(objA, objB) {
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    if (bKeys.length !== aKeys.length) return false;
    for(var i = 0; i < bKeys.length; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key]) return false;
    }
    return true;
};
var $85f0adf197ea687e$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === "function") return $85f0adf197ea687e$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};

});


parcelRegister("1HWSx", function(module, exports) {

$parcel$export(module.exports, "default", () => $13e77aa65f66c5c2$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $kSlfw = parcelRequire("kSlfw");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $kfIaf = parcelRequire("kfIaf");

var $e9hDx = parcelRequire("e9hDx");
function $13e77aa65f66c5c2$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $13e77aa65f66c5c2$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $13e77aa65f66c5c2$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $kSlfw.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $13e77aa65f66c5c2$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $13e77aa65f66c5c2$var$propTypes = $13e77aa65f66c5c2$var$_objectSpread($13e77aa65f66c5c2$var$_objectSpread({}, (0, $kfIaf.Transition).propTypes), {}, {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node),
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node
    ]),
    tag: (0, $e9hDx.tagPropType),
    baseClass: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    baseClassActive: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
    ])
});
var $13e77aa65f66c5c2$var$defaultProps = $13e77aa65f66c5c2$var$_objectSpread($13e77aa65f66c5c2$var$_objectSpread({}, (0, $kfIaf.Transition).defaultProps), {}, {
    tag: "div",
    baseClass: "fade",
    baseClassActive: "show",
    timeout: (0, $e9hDx.TransitionTimeouts).Fade,
    appear: true,
    enter: true,
    exit: true,
    in: true
});
function $13e77aa65f66c5c2$var$Fade(props) {
    var Tag = props.tag, baseClass = props.baseClass, baseClassActive = props.baseClassActive, className = props.className, cssModule = props.cssModule, children = props.children, innerRef = props.innerRef, otherProps = (0, $1En50.default)(props, [
        "tag",
        "baseClass",
        "baseClassActive",
        "className",
        "cssModule",
        "children",
        "innerRef"
    ]);
    var transitionProps = (0, $e9hDx.pick)(otherProps, (0, $e9hDx.TransitionPropTypeKeys));
    var childProps = (0, $e9hDx.omit)(otherProps, (0, $e9hDx.TransitionPropTypeKeys));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kfIaf.Transition), transitionProps, function(status) {
        var isActive = status === "entered";
        var classes = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, baseClass, isActive && baseClassActive), cssModule);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({
            className: classes
        }, childProps, {
            ref: innerRef
        }), children);
    });
}
$13e77aa65f66c5c2$var$Fade.propTypes = $13e77aa65f66c5c2$var$propTypes;
$13e77aa65f66c5c2$var$Fade.defaultProps = $13e77aa65f66c5c2$var$defaultProps;
var $13e77aa65f66c5c2$export$2e2bcd8739ae039 = $13e77aa65f66c5c2$var$Fade;

});
parcelRegister("kfIaf", function(module, exports) {
"use strict";

var $ebe77776a4866cd5$var$_CSSTransition = $ebe77776a4866cd5$var$_interopRequireDefault((parcelRequire("jgMPM")));

var $ebe77776a4866cd5$var$_ReplaceTransition = $ebe77776a4866cd5$var$_interopRequireDefault((parcelRequire("6AMGZ")));

var $ebe77776a4866cd5$var$_TransitionGroup = $ebe77776a4866cd5$var$_interopRequireDefault((parcelRequire("fq997")));

var $ebe77776a4866cd5$var$_Transition = $ebe77776a4866cd5$var$_interopRequireDefault((parcelRequire("lQkjg")));
function $ebe77776a4866cd5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports = {
    Transition: $ebe77776a4866cd5$var$_Transition.default,
    TransitionGroup: $ebe77776a4866cd5$var$_TransitionGroup.default,
    ReplaceTransition: $ebe77776a4866cd5$var$_ReplaceTransition.default,
    CSSTransition: $ebe77776a4866cd5$var$_CSSTransition.default
};

});
parcelRegister("jgMPM", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = void 0;

var $e0756460e1168596$var$PropTypes = $e0756460e1168596$var$_interopRequireWildcard((parcelRequire("c9Z8w")));

var $e0756460e1168596$var$_addClass = $e0756460e1168596$var$_interopRequireDefault((parcelRequire("gKDls")));

var $e0756460e1168596$var$_removeClass = $e0756460e1168596$var$_interopRequireDefault((parcelRequire("e14iu")));

var $e0756460e1168596$var$_react = $e0756460e1168596$var$_interopRequireDefault((parcelRequire("acw62")));

var $e0756460e1168596$var$_Transition = $e0756460e1168596$var$_interopRequireDefault((parcelRequire("lQkjg")));

function $e0756460e1168596$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e0756460e1168596$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function $e0756460e1168596$var$_extends() {
    $e0756460e1168596$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e0756460e1168596$var$_extends.apply(this, arguments);
}
function $e0756460e1168596$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $e0756460e1168596$var$addClass = function addClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $e0756460e1168596$var$_addClass.default)(node, c);
    });
};
var $e0756460e1168596$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $e0756460e1168596$var$_removeClass.default)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
 * using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity: 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**.
 */ var $e0756460e1168596$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    $e0756460e1168596$var$_inheritsLoose(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.onEnter = function(node, appearing) {
            var _this$getClassNames = _this.getClassNames(appearing ? "appear" : "enter"), className = _this$getClassNames.className;
            _this.removeClasses(node, "exit");
            $e0756460e1168596$var$addClass(node, className);
            if (_this.props.onEnter) _this.props.onEnter(node, appearing);
        };
        _this.onEntering = function(node, appearing) {
            var _this$getClassNames2 = _this.getClassNames(appearing ? "appear" : "enter"), activeClassName = _this$getClassNames2.activeClassName;
            _this.reflowAndAddClass(node, activeClassName);
            if (_this.props.onEntering) _this.props.onEntering(node, appearing);
        };
        _this.onEntered = function(node, appearing) {
            var appearClassName = _this.getClassNames("appear").doneClassName;
            var enterClassName = _this.getClassNames("enter").doneClassName;
            var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;
            _this.removeClasses(node, appearing ? "appear" : "enter");
            $e0756460e1168596$var$addClass(node, doneClassName);
            if (_this.props.onEntered) _this.props.onEntered(node, appearing);
        };
        _this.onExit = function(node) {
            var _this$getClassNames3 = _this.getClassNames("exit"), className = _this$getClassNames3.className;
            _this.removeClasses(node, "appear");
            _this.removeClasses(node, "enter");
            $e0756460e1168596$var$addClass(node, className);
            if (_this.props.onExit) _this.props.onExit(node);
        };
        _this.onExiting = function(node) {
            var _this$getClassNames4 = _this.getClassNames("exit"), activeClassName = _this$getClassNames4.activeClassName;
            _this.reflowAndAddClass(node, activeClassName);
            if (_this.props.onExiting) _this.props.onExiting(node);
        };
        _this.onExited = function(node) {
            var _this$getClassNames5 = _this.getClassNames("exit"), doneClassName = _this$getClassNames5.doneClassName;
            _this.removeClasses(node, "exit");
            $e0756460e1168596$var$addClass(node, doneClassName);
            if (_this.props.onExited) _this.props.onExited(node);
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === "string";
            var prefix = isStringClassNames && classNames ? classNames + "-" : "";
            var className = isStringClassNames ? prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? className + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? className + "-done" : classNames[type + "Done"];
            return {
                className: className,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$getClassNames6 = this.getClassNames(type), className = _this$getClassNames6.className, activeClassName = _this$getClassNames6.activeClassName, doneClassName = _this$getClassNames6.doneClassName;
        className && $e0756460e1168596$var$removeClass(node, className);
        activeClassName && $e0756460e1168596$var$removeClass(node, activeClassName);
        doneClassName && $e0756460e1168596$var$removeClass(node, doneClassName);
    };
    _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (className) {
            /* eslint-disable no-unused-expressions */ node && node.scrollTop;
            /* eslint-enable no-unused-expressions */ $e0756460e1168596$var$addClass(node, className);
        }
    };
    _proto.render = function render() {
        var props = $e0756460e1168596$var$_extends({}, this.props);
        delete props.classNames;
        return $e0756460e1168596$var$_react.default.createElement($e0756460e1168596$var$_Transition.default, $e0756460e1168596$var$_extends({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}($e0756460e1168596$var$_react.default.Component);
$e0756460e1168596$var$CSSTransition.defaultProps = {
    classNames: ""
};
$e0756460e1168596$var$CSSTransition.propTypes = {};
var $e0756460e1168596$var$_default = $e0756460e1168596$var$CSSTransition;
module.exports.default = $e0756460e1168596$var$_default;
module.exports = module.exports["default"];

});
parcelRegister("gKDls", function(module, exports) {
"use strict";

var $1jnue = parcelRequire("1jnue");
module.exports.__esModule = true;
module.exports.default = $c31f76564d15319c$var$addClass;

var $c31f76564d15319c$var$_hasClass = $1jnue((parcelRequire("amvCb")));
function $c31f76564d15319c$var$addClass(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $c31f76564d15319c$var$_hasClass.default)(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}
module.exports = module.exports["default"];

});
parcelRegister("1jnue", function(module, exports) {
function $0f49c8ba50dff6ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
module.exports = $0f49c8ba50dff6ee$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("amvCb", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $78b47b7cc80b5a1f$var$hasClass;
function $78b47b7cc80b5a1f$var$hasClass(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = module.exports["default"];

});


parcelRegister("e14iu", function(module, exports) {
"use strict";
function $a3447e035aa11d0f$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
module.exports = function removeClass(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = $a3447e035aa11d0f$var$replaceClassName(element.className, className);
    else element.setAttribute("class", $a3447e035aa11d0f$var$replaceClassName(element.className && element.className.baseVal || "", className));
};

});

parcelRegister("lQkjg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $fe6e356877d6b229$export$1e511d4a378977f5, (v) => $fe6e356877d6b229$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $fe6e356877d6b229$export$2e2bcd8739ae039, (v) => $fe6e356877d6b229$export$2e2bcd8739ae039 = v);
$parcel$export(module.exports, "EXITING", () => $fe6e356877d6b229$export$4aacc83d4d59139f, (v) => $fe6e356877d6b229$export$4aacc83d4d59139f = v);
$parcel$export(module.exports, "ENTERED", () => $fe6e356877d6b229$export$78e9e6e3e014d60a, (v) => $fe6e356877d6b229$export$78e9e6e3e014d60a = v);
$parcel$export(module.exports, "ENTERING", () => $fe6e356877d6b229$export$df38205c966be359, (v) => $fe6e356877d6b229$export$df38205c966be359 = v);
$parcel$export(module.exports, "EXITED", () => $fe6e356877d6b229$export$84cbff306f539230, (v) => $fe6e356877d6b229$export$84cbff306f539230 = v);
$parcel$export(module.exports, "UNMOUNTED", () => $fe6e356877d6b229$export$bb38bb9a1161268, (v) => $fe6e356877d6b229$export$bb38bb9a1161268 = v);
var $fe6e356877d6b229$export$1e511d4a378977f5;
var $fe6e356877d6b229$export$2e2bcd8739ae039;
var $fe6e356877d6b229$export$4aacc83d4d59139f;
var $fe6e356877d6b229$export$78e9e6e3e014d60a;
var $fe6e356877d6b229$export$df38205c966be359;
var $fe6e356877d6b229$export$84cbff306f539230;
var $fe6e356877d6b229$export$bb38bb9a1161268;
"use strict";
$fe6e356877d6b229$export$1e511d4a378977f5 = true;
$fe6e356877d6b229$export$2e2bcd8739ae039 = $fe6e356877d6b229$export$4aacc83d4d59139f = $fe6e356877d6b229$export$78e9e6e3e014d60a = $fe6e356877d6b229$export$df38205c966be359 = $fe6e356877d6b229$export$84cbff306f539230 = $fe6e356877d6b229$export$bb38bb9a1161268 = void 0;

var $fe6e356877d6b229$var$PropTypes = $fe6e356877d6b229$var$_interopRequireWildcard((parcelRequire("c9Z8w")));

var $fe6e356877d6b229$var$_react = $fe6e356877d6b229$var$_interopRequireDefault((parcelRequire("acw62")));

var $fe6e356877d6b229$var$_reactDom = $fe6e356877d6b229$var$_interopRequireDefault((parcelRequire("1u0KT")));

var $hdX8Q = parcelRequire("hdX8Q");

function $fe6e356877d6b229$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $fe6e356877d6b229$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function $fe6e356877d6b229$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $fe6e356877d6b229$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $fe6e356877d6b229$var$UNMOUNTED = "unmounted";
$fe6e356877d6b229$export$bb38bb9a1161268 = $fe6e356877d6b229$var$UNMOUNTED;
var $fe6e356877d6b229$var$EXITED = "exited";
$fe6e356877d6b229$export$84cbff306f539230 = $fe6e356877d6b229$var$EXITED;
var $fe6e356877d6b229$var$ENTERING = "entering";
$fe6e356877d6b229$export$df38205c966be359 = $fe6e356877d6b229$var$ENTERING;
var $fe6e356877d6b229$var$ENTERED = "entered";
$fe6e356877d6b229$export$78e9e6e3e014d60a = $fe6e356877d6b229$var$ENTERED;
var $fe6e356877d6b229$var$EXITING = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ $fe6e356877d6b229$export$4aacc83d4d59139f = $fe6e356877d6b229$var$EXITING;
var $fe6e356877d6b229$var$Transition = /*#__PURE__*/ function(_React$Component) {
    $fe6e356877d6b229$var$_inheritsLoose(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $fe6e356877d6b229$var$EXITED;
                _this.appearStatus = $fe6e356877d6b229$var$ENTERING;
            } else initialStatus = $fe6e356877d6b229$var$ENTERED;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $fe6e356877d6b229$var$UNMOUNTED;
        else initialStatus = $fe6e356877d6b229$var$EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    var _proto = Transition.prototype;
    _proto.getChildContext = function getChildContext() {
        return {
            transitionGroup: null // allows for nested Transitions
        };
    };
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $fe6e356877d6b229$var$UNMOUNTED) return {
            status: $fe6e356877d6b229$var$EXITED
        };
        return null;
    }; // getSnapshotBeforeUpdate(prevProps) {
    //   let nextStatus = null
    //   if (prevProps !== this.props) {
    //     const { status } = this.state
    //     if (this.props.in) {
    //       if (status !== ENTERING && status !== ENTERED) {
    //         nextStatus = ENTERING
    //       }
    //     } else {
    //       if (status === ENTERING || status === ENTERED) {
    //         nextStatus = EXITING
    //       }
    //     }
    //   }
    //   return { nextStatus }
    // }
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $fe6e356877d6b229$var$ENTERING && status !== $fe6e356877d6b229$var$ENTERED) nextStatus = $fe6e356877d6b229$var$ENTERING;
            } else if (status === $fe6e356877d6b229$var$ENTERING || status === $fe6e356877d6b229$var$ENTERED) nextStatus = $fe6e356877d6b229$var$EXITING;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            var node = $fe6e356877d6b229$var$_reactDom.default.findDOMNode(this);
            if (nextStatus === $fe6e356877d6b229$var$ENTERING) this.performEnter(node, mounting);
            else this.performExit(node);
        } else if (this.props.unmountOnExit && this.state.status === $fe6e356877d6b229$var$EXITED) this.setState({
            status: $fe6e356877d6b229$var$UNMOUNTED
        });
    };
    _proto.performEnter = function performEnter(node, mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter) {
            this.safeSetState({
                status: $fe6e356877d6b229$var$ENTERED
            }, function() {
                _this2.props.onEntered(node);
            });
            return;
        }
        this.props.onEnter(node, appearing);
        this.safeSetState({
            status: $fe6e356877d6b229$var$ENTERING
        }, function() {
            _this2.props.onEntering(node, appearing);
            _this2.onTransitionEnd(node, enterTimeout, function() {
                _this2.safeSetState({
                    status: $fe6e356877d6b229$var$ENTERED
                }, function() {
                    _this2.props.onEntered(node, appearing);
                });
            });
        });
    };
    _proto.performExit = function performExit(node) {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
        if (!exit) {
            this.safeSetState({
                status: $fe6e356877d6b229$var$EXITED
            }, function() {
                _this3.props.onExited(node);
            });
            return;
        }
        this.props.onExit(node);
        this.safeSetState({
            status: $fe6e356877d6b229$var$EXITING
        }, function() {
            _this3.props.onExiting(node);
            _this3.onTransitionEnd(node, timeouts.exit, function() {
                _this3.safeSetState({
                    status: $fe6e356877d6b229$var$EXITED
                }, function() {
                    _this3.props.onExited(node);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
        this.setNextCallback(handler);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) this.props.addEndListener(node, this.nextCallback);
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $fe6e356877d6b229$var$UNMOUNTED) return null;
        var _this$props = this.props, children = _this$props.children, childProps = $fe6e356877d6b229$var$_objectWithoutPropertiesLoose(_this$props, [
            "children"
        ]); // filter props for Transtition
        delete childProps.in;
        delete childProps.mountOnEnter;
        delete childProps.unmountOnExit;
        delete childProps.appear;
        delete childProps.enter;
        delete childProps.exit;
        delete childProps.timeout;
        delete childProps.addEndListener;
        delete childProps.onEnter;
        delete childProps.onEntering;
        delete childProps.onEntered;
        delete childProps.onExit;
        delete childProps.onExiting;
        delete childProps.onExited;
        if (typeof children === "function") return children(status, childProps);
        var child = $fe6e356877d6b229$var$_react.default.Children.only(children);
        return $fe6e356877d6b229$var$_react.default.cloneElement(child, childProps);
    };
    return Transition;
}($fe6e356877d6b229$var$_react.default.Component);
$fe6e356877d6b229$var$Transition.contextTypes = {
    transitionGroup: $fe6e356877d6b229$var$PropTypes.object
};
$fe6e356877d6b229$var$Transition.childContextTypes = {
    transitionGroup: function transitionGroup() {}
};
$fe6e356877d6b229$var$Transition.propTypes = {};
function $fe6e356877d6b229$var$noop() {}
$fe6e356877d6b229$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $fe6e356877d6b229$var$noop,
    onEntering: $fe6e356877d6b229$var$noop,
    onEntered: $fe6e356877d6b229$var$noop,
    onExit: $fe6e356877d6b229$var$noop,
    onExiting: $fe6e356877d6b229$var$noop,
    onExited: $fe6e356877d6b229$var$noop
};
$fe6e356877d6b229$var$Transition.UNMOUNTED = 0;
$fe6e356877d6b229$var$Transition.EXITED = 1;
$fe6e356877d6b229$var$Transition.ENTERING = 2;
$fe6e356877d6b229$var$Transition.ENTERED = 3;
$fe6e356877d6b229$var$Transition.EXITING = 4;
var $fe6e356877d6b229$var$_default = (0, $hdX8Q.polyfill)($fe6e356877d6b229$var$Transition);
$fe6e356877d6b229$export$2e2bcd8739ae039 = $fe6e356877d6b229$var$_default;

});
parcelRegister("hdX8Q", function(module, exports) {

$parcel$export(module.exports, "polyfill", () => $c8a186e1757974bb$export$cea1c58a6db52bca);
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $c8a186e1757974bb$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $c8a186e1757974bb$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $c8a186e1757974bb$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$c8a186e1757974bb$var$componentWillMount.__suppressDeprecationWarning = true;
$c8a186e1757974bb$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$c8a186e1757974bb$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $c8a186e1757974bb$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error("Can only polyfill class components");
    if (typeof Component.getDerivedStateFromProps !== "function" && typeof prototype.getSnapshotBeforeUpdate !== "function") return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === "function") foundWillMountName = "componentWillMount";
    else if (typeof prototype.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
    if (typeof prototype.componentWillReceiveProps === "function") foundWillReceivePropsName = "componentWillReceiveProps";
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
    if (typeof prototype.componentWillUpdate === "function") foundWillUpdateName = "componentWillUpdate";
    else if (typeof prototype.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
        throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + componentName + " uses " + newApiName + " but also contains the following legacy lifecycles:" + (foundWillMountName !== null ? "\n  " + foundWillMountName : "") + (foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "") + (foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\n" + "https://fb.me/react-async-component-lifecycle-hooks");
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === "function") {
        prototype.componentWillMount = $c8a186e1757974bb$var$componentWillMount;
        prototype.componentWillReceiveProps = $c8a186e1757974bb$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === "function") {
        if (typeof prototype.componentDidUpdate !== "function") throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
        prototype.componentWillUpdate = $c8a186e1757974bb$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}

});



parcelRegister("6AMGZ", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = void 0;

var $4ccbe02b7a19610c$var$_propTypes = $4ccbe02b7a19610c$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $4ccbe02b7a19610c$var$_react = $4ccbe02b7a19610c$var$_interopRequireDefault((parcelRequire("acw62")));

var $1u0KT = parcelRequire("1u0KT");

var $4ccbe02b7a19610c$var$_TransitionGroup = $4ccbe02b7a19610c$var$_interopRequireDefault((parcelRequire("fq997")));
function $4ccbe02b7a19610c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4ccbe02b7a19610c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $4ccbe02b7a19610c$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */ var $4ccbe02b7a19610c$var$ReplaceTransition = /*#__PURE__*/ function(_React$Component) {
    $4ccbe02b7a19610c$var$_inheritsLoose(ReplaceTransition, _React$Component);
    function ReplaceTransition() {
        var _this;
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(_args)) || this;
        _this.handleEnter = function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return _this.handleLifecycle("onEnter", 0, args);
        };
        _this.handleEntering = function() {
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            return _this.handleLifecycle("onEntering", 0, args);
        };
        _this.handleEntered = function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            return _this.handleLifecycle("onEntered", 0, args);
        };
        _this.handleExit = function() {
            for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
            return _this.handleLifecycle("onExit", 1, args);
        };
        _this.handleExiting = function() {
            for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
            return _this.handleLifecycle("onExiting", 1, args);
        };
        _this.handleExited = function() {
            for(var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)args[_key7] = arguments[_key7];
            return _this.handleLifecycle("onExited", 1, args);
        };
        return _this;
    }
    var _proto = ReplaceTransition.prototype;
    _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
        var _child$props;
        var children = this.props.children;
        var child = $4ccbe02b7a19610c$var$_react.default.Children.toArray(children)[idx];
        if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
        if (this.props[handler]) this.props[handler]((0, $1u0KT.findDOMNode)(this));
    };
    _proto.render = function render() {
        var _this$props = this.props, children = _this$props.children, inProp = _this$props.in, props = $4ccbe02b7a19610c$var$_objectWithoutPropertiesLoose(_this$props, [
            "children",
            "in"
        ]);
        var _React$Children$toArr = $4ccbe02b7a19610c$var$_react.default.Children.toArray(children), first = _React$Children$toArr[0], second = _React$Children$toArr[1];
        delete props.onEnter;
        delete props.onEntering;
        delete props.onEntered;
        delete props.onExit;
        delete props.onExiting;
        delete props.onExited;
        return $4ccbe02b7a19610c$var$_react.default.createElement($4ccbe02b7a19610c$var$_TransitionGroup.default, props, inProp ? $4ccbe02b7a19610c$var$_react.default.cloneElement(first, {
            key: "first",
            onEnter: this.handleEnter,
            onEntering: this.handleEntering,
            onEntered: this.handleEntered
        }) : $4ccbe02b7a19610c$var$_react.default.cloneElement(second, {
            key: "second",
            onEnter: this.handleExit,
            onEntering: this.handleExiting,
            onEntered: this.handleExited
        }));
    };
    return ReplaceTransition;
}($4ccbe02b7a19610c$var$_react.default.Component);
$4ccbe02b7a19610c$var$ReplaceTransition.propTypes = {};
var $4ccbe02b7a19610c$var$_default = $4ccbe02b7a19610c$var$ReplaceTransition;
module.exports.default = $4ccbe02b7a19610c$var$_default;
module.exports = module.exports["default"];

});
parcelRegister("fq997", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = void 0;

var $b3a060f13256ceed$var$_propTypes = $b3a060f13256ceed$var$_interopRequireDefault((parcelRequire("c9Z8w")));

var $b3a060f13256ceed$var$_react = $b3a060f13256ceed$var$_interopRequireDefault((parcelRequire("acw62")));

var $hdX8Q = parcelRequire("hdX8Q");

var $lLwQT = parcelRequire("lLwQT");
function $b3a060f13256ceed$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b3a060f13256ceed$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $b3a060f13256ceed$var$_extends() {
    $b3a060f13256ceed$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b3a060f13256ceed$var$_extends.apply(this, arguments);
}
function $b3a060f13256ceed$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $b3a060f13256ceed$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var $b3a060f13256ceed$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $b3a060f13256ceed$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
var $b3a060f13256ceed$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    $b3a060f13256ceed$var$_inheritsLoose(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind($b3a060f13256ceed$var$_assertThisInitialized($b3a060f13256ceed$var$_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear
        _this.state = {
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.getChildContext = function getChildContext() {
        return {
            transitionGroup: {
                isMounting: !this.appeared
            }
        };
    };
    _proto.componentDidMount = function componentDidMount() {
        this.appeared = true;
        this.mounted = true;
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $lLwQT.getInitialChildMapping)(nextProps, handleExited) : (0, $lLwQT.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    };
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $lLwQT.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = $b3a060f13256ceed$var$_extends({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = $b3a060f13256ceed$var$_objectWithoutPropertiesLoose(_this$props, [
            "component",
            "childFactory"
        ]);
        var children = $b3a060f13256ceed$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return children;
        return $b3a060f13256ceed$var$_react.default.createElement(Component, props, children);
    };
    return TransitionGroup;
}($b3a060f13256ceed$var$_react.default.Component);
$b3a060f13256ceed$var$TransitionGroup.childContextTypes = {
    transitionGroup: $b3a060f13256ceed$var$_propTypes.default.object.isRequired
};
$b3a060f13256ceed$var$TransitionGroup.propTypes = {};
$b3a060f13256ceed$var$TransitionGroup.defaultProps = $b3a060f13256ceed$var$defaultProps;
var $b3a060f13256ceed$var$_default = (0, $hdX8Q.polyfill)($b3a060f13256ceed$var$TransitionGroup);
module.exports.default = $b3a060f13256ceed$var$_default;
module.exports = module.exports["default"];

});
parcelRegister("lLwQT", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", () => $fd8778843ba2b6b2$export$bbc8a025727ea824, (v) => $fd8778843ba2b6b2$export$bbc8a025727ea824 = v);
$parcel$export(module.exports, "getInitialChildMapping", () => $fd8778843ba2b6b2$export$fa71e2345c31d7a2, (v) => $fd8778843ba2b6b2$export$fa71e2345c31d7a2 = v);
$parcel$export(module.exports, "getNextChildMapping", () => $fd8778843ba2b6b2$export$36fd1af28d383ec0, (v) => $fd8778843ba2b6b2$export$36fd1af28d383ec0 = v);
var $fd8778843ba2b6b2$export$1e511d4a378977f5;
var $fd8778843ba2b6b2$export$bbc8a025727ea824;
var $fd8778843ba2b6b2$export$7a874f95ccf533dd;
var $fd8778843ba2b6b2$export$fa71e2345c31d7a2;
var $fd8778843ba2b6b2$export$36fd1af28d383ec0;
"use strict";
$fd8778843ba2b6b2$export$1e511d4a378977f5 = true;
$fd8778843ba2b6b2$export$bbc8a025727ea824 = $fd8778843ba2b6b2$var$getChildMapping;
$fd8778843ba2b6b2$export$7a874f95ccf533dd = $fd8778843ba2b6b2$var$mergeChildMappings;
$fd8778843ba2b6b2$export$fa71e2345c31d7a2 = $fd8778843ba2b6b2$var$getInitialChildMapping;
$fd8778843ba2b6b2$export$36fd1af28d383ec0 = $fd8778843ba2b6b2$var$getNextChildMapping;

var $acw62 = parcelRequire("acw62");
/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */ function $fd8778843ba2b6b2$var$getChildMapping(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $acw62.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) $acw62.Children.map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */ function $fd8778843ba2b6b2$var$mergeChildMappings(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $fd8778843ba2b6b2$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $fd8778843ba2b6b2$var$getInitialChildMapping(props, onExited) {
    return $fd8778843ba2b6b2$var$getChildMapping(props.children, function(child) {
        return (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $fd8778843ba2b6b2$var$getProp(child, "appear", props),
            enter: $fd8778843ba2b6b2$var$getProp(child, "enter", props),
            exit: $fd8778843ba2b6b2$var$getProp(child, "exit", props)
        });
    });
}
function $fd8778843ba2b6b2$var$getNextChildMapping(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $fd8778843ba2b6b2$var$getChildMapping(nextProps.children);
    var children = $fd8778843ba2b6b2$var$mergeChildMappings(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $acw62.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $acw62.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $fd8778843ba2b6b2$var$getProp(child, "exit", nextProps),
            enter: $fd8778843ba2b6b2$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $acw62.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $fd8778843ba2b6b2$var$getProp(child, "exit", nextProps),
            enter: $fd8778843ba2b6b2$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}

});








parcelRegister("dd1F2", function(module, exports) {

$parcel$export(module.exports, "default", () => $99ddc712750b4a74$export$2e2bcd8739ae039);

var $kSlfw = parcelRequire("kSlfw");

var $8nd05 = parcelRequire("8nd05");

var $hDpcU = parcelRequire("hDpcU");

var $g7ajw = parcelRequire("g7ajw");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8FVNB = parcelRequire("8FVNB");

var $e9hDx = parcelRequire("e9hDx");
function $99ddc712750b4a74$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $99ddc712750b4a74$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $99ddc712750b4a74$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $kSlfw.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $99ddc712750b4a74$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $99ddc712750b4a74$var$omitKeys = [
    "defaultOpen"
];
var $99ddc712750b4a74$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, $g7ajw.default)(UncontrolledTooltip, _Component);
    function UncontrolledTooltip(props) {
        var _this;
        _this = _Component.call(this, props) || this;
        _this.state = {
            isOpen: props.defaultOpen || false
        };
        _this.toggle = _this.toggle.bind((0, $hDpcU.default)(_this));
        return _this;
    }
    var _proto = UncontrolledTooltip.prototype;
    _proto.toggle = function toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8FVNB.default), (0, $8nd05.default)({
            isOpen: this.state.isOpen,
            toggle: this.toggle
        }, (0, $e9hDx.omit)(this.props, $99ddc712750b4a74$var$omitKeys)));
    };
    return UncontrolledTooltip;
}((0, $acw62.Component));
$99ddc712750b4a74$export$2e2bcd8739ae039.propTypes = $99ddc712750b4a74$var$_objectSpread({
    defaultOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
}, (0, $8FVNB.default).propTypes);

});



parcelRegister("bew0G", function(module, exports) {

$parcel$export(module.exports, "useUID", () => $82d9d5049c8c7ec2$export$87d05f07e65211f1);

var $acw62 = parcelRequire("acw62");

var $6CFq5 = parcelRequire("6CFq5");
var $82d9d5049c8c7ec2$var$generateUID = function(context) {
    var quartz = context || (0, $6CFq5.counter);
    var prefix = (0, $6CFq5.getPrefix)(quartz);
    var id = (0, $6CFq5.getId)(quartz);
    var uid = prefix + id;
    var gen = function(item) {
        return uid + quartz.uid(item);
    };
    return {
        uid: uid,
        gen: gen
    };
};
var $82d9d5049c8c7ec2$var$useUIDState = function() {
    // @ts-ignore
    return $acw62.useState($82d9d5049c8c7ec2$var$generateUID($acw62.useContext((0, $6CFq5.source))));
};
var $82d9d5049c8c7ec2$export$87d05f07e65211f1 = function() {
    var uid = $82d9d5049c8c7ec2$var$useUIDState()[0].uid;
    return uid;
};
var $82d9d5049c8c7ec2$export$bb5ca5fba6fb4f1f = function() {
    var gen = $82d9d5049c8c7ec2$var$useUIDState()[0].gen;
    return gen;
};

});
parcelRegister("6CFq5", function(module, exports) {

$parcel$export(module.exports, "counter", () => $4d266bc9c8f3d314$export$e575061ef2a070eb);
$parcel$export(module.exports, "source", () => $4d266bc9c8f3d314$export$b4d5da5f34fb77ad);
$parcel$export(module.exports, "getId", () => $4d266bc9c8f3d314$export$218c8c3169c024d2);
$parcel$export(module.exports, "getPrefix", () => $4d266bc9c8f3d314$export$36e24695f02d4503);

var $acw62 = parcelRequire("acw62");

var $lIPC8 = parcelRequire("lIPC8");
var $4d266bc9c8f3d314$export$1921362e86c73c88 = function(prefix) {
    if (prefix === void 0) prefix = "";
    return {
        value: 1,
        prefix: prefix,
        uid: (0, $lIPC8.generateUID)()
    };
};
var $4d266bc9c8f3d314$export$e575061ef2a070eb = $4d266bc9c8f3d314$export$1921362e86c73c88();
var $4d266bc9c8f3d314$export$b4d5da5f34fb77ad = $acw62.createContext($4d266bc9c8f3d314$export$1921362e86c73c88());
var $4d266bc9c8f3d314$export$218c8c3169c024d2 = function(source) {
    return source.value++;
};
var $4d266bc9c8f3d314$export$36e24695f02d4503 = function(source) {
    return source ? source.prefix : "";
};

});
parcelRegister("lIPC8", function(module, exports) {

$parcel$export(module.exports, "generateUID", () => $fd05be839c660684$export$bdbb4cbb3078e58d);
/**
 * generates a UID factory
 * @internal
 * @example
 * const uid = generateUID();
 * uid(object) = 1;
 * uid(object) = 1;
 * uid(anotherObject) = 2;
 */ var $fd05be839c660684$export$bdbb4cbb3078e58d = function() {
    var counter = 1;
    var map = new WeakMap();
    /**
     * @borrows {uid}
     */ var uid = function(item, index) {
        if (typeof item === "number" || typeof item === "string") return index ? "idx-" + index : "val-" + item;
        if (!map.has(item)) {
            map.set(item, counter++);
            return uid(item);
        }
        return "uid" + map.get(item);
    };
    return uid;
};
var $fd05be839c660684$export$e2a22331486dcca0 = $fd05be839c660684$export$bdbb4cbb3078e58d();

});




parcelRegister("6e1HC", function(module, exports) {
"use strict";
var $48855ef8eb76066d$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $48855ef8eb76066d$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $48855ef8eb76066d$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $48855ef8eb76066d$var$__createBinding(result, mod, k);
    }
    $48855ef8eb76066d$var$__setModuleDefault(result, mod);
    return result;
};
var $48855ef8eb76066d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $48855ef8eb76066d$var$react_1 = $48855ef8eb76066d$var$__importStar((parcelRequire("acw62")));

const $48855ef8eb76066d$var$icon_1 = $48855ef8eb76066d$var$__importDefault((parcelRequire("lz1xm")));

const $48855ef8eb76066d$var$Button_1 = $48855ef8eb76066d$var$__importDefault((parcelRequire("7zMpb")));
const $48855ef8eb76066d$var$ButtonSelect = (props)=>{
    const { onClick: onClick, children: children, className: className, iconClass: iconClass, dataLwtId: dataLwtId, ...restButton } = props;
    const optionalProps = {};
    if (dataLwtId) optionalProps["data-lwt-id"] = dataLwtId;
    const optionalPropsIcon = {
        dataLwtId: "icon"
    };
    if (dataLwtId) optionalPropsIcon["dataLwtId"] = `${dataLwtId}-icon`;
    return $48855ef8eb76066d$var$react_1.default.createElement($48855ef8eb76066d$var$react_1.Fragment, null, $48855ef8eb76066d$var$react_1.default.createElement($48855ef8eb76066d$var$Button_1.default, {
        ...optionalProps,
        ...restButton,
        className: className,
        onClick: onClick
    }, children, $48855ef8eb76066d$var$react_1.default.createElement($48855ef8eb76066d$var$icon_1.default, {
        ...optionalPropsIcon,
        className: iconClass,
        iconName: "check_circle"
    })));
};
module.exports.default = $48855ef8eb76066d$var$ButtonSelect;

});
parcelRegister("7zMpb", function(module, exports) {
"use strict";
var $58415990d35a9d2e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $58415990d35a9d2e$var$classnames_1 = $58415990d35a9d2e$var$__importDefault((parcelRequire("8g1PZ")));

const $58415990d35a9d2e$var$react_1 = $58415990d35a9d2e$var$__importDefault((parcelRequire("acw62")));
const $58415990d35a9d2e$var$Button = $58415990d35a9d2e$var$react_1.default.forwardRef((props, ref)=>{
    const { active: active, block: block, className: className, color: color = "secondary", disabled: disabled, outline: outline, size: size, raised: raised, fab: fab, onClick: onClick, children: children, id: id, dataLwtId: dataLwtId, ...restProps } = props;
    const classes = (0, $58415990d35a9d2e$var$classnames_1.default)("btn", `btn${outline ? "-outline" : ""}-${color}`, size ? `btn-${size}` : false, block ? "btn-block" : false, raised ? "btn-raised" : false, fab ? "btn-fab" : false, disabled, className, {
        active: active
    });
    const optionalProps = {};
    if (dataLwtId) optionalProps["data-lwt-id"] = dataLwtId;
    return $58415990d35a9d2e$var$react_1.default.createElement("button", {
        className: classes,
        id: id,
        type: "button",
        disabled: disabled,
        onClick: !disabled ? onClick : undefined,
        ref: ref,
        ...optionalProps,
        ...restProps
    }, children);
});
$58415990d35a9d2e$var$Button.displayName = "Button";
module.exports.default = $58415990d35a9d2e$var$Button;

});


parcelRegister("2iJ7H", function(module, exports) {
"use strict";
var $1ad043c0ce168671$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $1ad043c0ce168671$var$react_1 = $1ad043c0ce168671$var$__importDefault((parcelRequire("acw62")));

var $8Y0sW = parcelRequire("8Y0sW");
const $1ad043c0ce168671$var$ButtonGroup = ({ dataLwtId: dataLwtId, ...rest })=>{
    const optionalProps = {};
    if (dataLwtId) optionalProps["data-lwt-id"] = dataLwtId;
    return $1ad043c0ce168671$var$react_1.default.createElement($8Y0sW.default, {
        ...rest,
        ...optionalProps
    });
};
module.exports.default = $1ad043c0ce168671$var$ButtonGroup;

});
parcelRegister("8Y0sW", function(module, exports) {

$parcel$export(module.exports, "default", () => $687449d2b784bbd8$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $e9hDx = parcelRequire("e9hDx");
var $687449d2b784bbd8$var$propTypes = {
    tag: (0, $e9hDx.tagPropType),
    "aria-label": (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    role: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    vertical: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
var $687449d2b784bbd8$var$defaultProps = {
    tag: "div",
    role: "group"
};
var $687449d2b784bbd8$var$ButtonGroup = function ButtonGroup(props) {
    var className = props.className, cssModule = props.cssModule, size = props.size, vertical = props.vertical, Tag = props.tag, attributes = (0, $1En50.default)(props, [
        "className",
        "cssModule",
        "size",
        "vertical",
        "tag"
    ]);
    var classes = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, size ? "btn-group-" + size : false, vertical ? "btn-group-vertical" : "btn-group"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({}, attributes, {
        className: classes
    }));
};
$687449d2b784bbd8$var$ButtonGroup.propTypes = $687449d2b784bbd8$var$propTypes;
$687449d2b784bbd8$var$ButtonGroup.defaultProps = $687449d2b784bbd8$var$defaultProps;
var $687449d2b784bbd8$export$2e2bcd8739ae039 = $687449d2b784bbd8$var$ButtonGroup;

});




parcelRegister("ar71Y", function(module, exports) {
"use strict";
var $7991e12e37316b94$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $7991e12e37316b94$var$react_1 = $7991e12e37316b94$var$__importDefault((parcelRequire("acw62")));
parcelRequire("42Cuq");
var $7zMpb = parcelRequire("7zMpb");
const $7991e12e37316b94$var$ActionCellRenderer = (props)=>{
    const { actions: actions, value: value, data: data } = props;
    return $7991e12e37316b94$var$react_1.default.createElement("div", null, actions.map((action)=>{
        return $7991e12e37316b94$var$react_1.default.createElement($7zMpb.default, {
            dataLwtId: "action-cell-renderer-button-id",
            color: action.color,
            className: "btn",
            key: action.name,
            onClick: ()=>{
                action.click({
                    value: value,
                    data: data
                });
            }
        }, action.name);
    }));
};
module.exports.default = $7991e12e37316b94$var$ActionCellRenderer;

});

parcelRegister("sYDkv", function(module, exports) {
"use strict";
var $0571a629116859b6$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $0571a629116859b6$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $0571a629116859b6$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $0571a629116859b6$var$__createBinding(result, mod, k);
    }
    $0571a629116859b6$var$__setModuleDefault(result, mod);
    return result;
};
var $0571a629116859b6$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $0571a629116859b6$var$date_picker_1 = $0571a629116859b6$var$__importDefault((parcelRequire("28fod")));

const $0571a629116859b6$var$react_1 = $0571a629116859b6$var$__importStar((parcelRequire("acw62")));
const $0571a629116859b6$var$DatePickerFilter = (0, $0571a629116859b6$var$react_1.forwardRef)((props, ref)=>{
    const [currentValue, setCurrentValue] = (0, $0571a629116859b6$var$react_1.useState)(null);
    const inputRef = (0, $0571a629116859b6$var$react_1.useRef)(null);
    // expose AG Grid Filter Lifecycle callbacks
    (0, $0571a629116859b6$var$react_1.useImperativeHandle)(ref, ()=>{
        return {
            onParentModelChanged (parentModel) {
                // When the filter is empty we will receive a null value here
                if (!inputRef.current) return;
                if (!parentModel) setCurrentValue(null);
                else setCurrentValue(parentModel.filter);
            }
        };
    });
    const normalizeDate = (date)=>{
        const newD = date;
        newD.setTime(newD.getTime() + newD.getTimezoneOffset() * 60000);
        return newD;
    };
    const onDatePickerChange = (date)=>{
        if (!date) {
            // clear the filter
            props.parentFilterInstance((instance)=>{
                instance.onFloatingFilterChanged(null, null);
            });
            return;
        }
        const normalizedDate = normalizeDate(new Date(date));
        const normalizedDateToString = normalizedDate.setHours(0, 0, 0, 0);
        props.parentFilterInstance((instance)=>{
            instance.onFloatingFilterChanged("equals", new Date(normalizedDateToString));
        });
    };
    return $0571a629116859b6$var$react_1.default.createElement("div", {
        style: {
            margin: "0 2px"
        }
    }, $0571a629116859b6$var$react_1.default.createElement($0571a629116859b6$var$date_picker_1.default, {
        usePortal: true,
        value: currentValue === null || currentValue === void 0 ? void 0 : currentValue.toString(),
        onChange: (date)=>onDatePickerChange(date)
    }));
});
$0571a629116859b6$var$DatePickerFilter.displayName = "DatePickerFilter";
module.exports.default = $0571a629116859b6$var$DatePickerFilter;

});
parcelRegister("28fod", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $18d8442dabf53fd6$export$2e2bcd8739ae039);

var $4rIk2 = parcelRequire("4rIk2");
var $18d8442dabf53fd6$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($4rIk2)));

});
parcelRegister("4rIk2", function(module, exports) {
"use strict";
var $33cc108696ddc4dd$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $33cc108696ddc4dd$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $33cc108696ddc4dd$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $33cc108696ddc4dd$var$__createBinding(result, mod, k);
    }
    $33cc108696ddc4dd$var$__setModuleDefault(result, mod);
    return result;
};
var $33cc108696ddc4dd$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $33cc108696ddc4dd$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $33cc108696ddc4dd$var$classnames_1 = $33cc108696ddc4dd$var$__importDefault((parcelRequire("8g1PZ")));

var $6IhJz = parcelRequire("6IhJz");
var $cFZfS = parcelRequire("cFZfS");

const $33cc108696ddc4dd$var$Locales = $33cc108696ddc4dd$var$__importStar((parcelRequire("j9gmE")));

const $33cc108696ddc4dd$var$react_1 = $33cc108696ddc4dd$var$__importStar((parcelRequire("acw62")));

const $33cc108696ddc4dd$var$react_datepicker_1 = $33cc108696ddc4dd$var$__importStar((parcelRequire("9nVYw")));


const $33cc108696ddc4dd$var$react_text_mask_1 = $33cc108696ddc4dd$var$__importDefault((parcelRequire("8H68z")));

const $33cc108696ddc4dd$var$Portal_1 = $33cc108696ddc4dd$var$__importDefault((parcelRequire("4bj1a")));

const $33cc108696ddc4dd$var$LocalesArray = Object.values($33cc108696ddc4dd$var$Locales);
class $33cc108696ddc4dd$var$DatePicker extends $33cc108696ddc4dd$var$react_1.Component {
    constructor(props){
        super(props);
        this.handleDivChange = (event)=>{
            var _a;
            let selectedDate;
            let backEndDateValue;
            if (event && event.target) {
                const inputEvent = event.target;
                const displayDate = new Date(inputEvent.value);
                if (!(0, $cFZfS.default)(displayDate) || $33cc108696ddc4dd$var$DatePicker.isYearGreaterThan10000(displayDate) || this.props.minDate && displayDate <= this.props.minDate || ((_a = this.props.excludeDates) === null || _a === void 0 ? void 0 : _a.find((date)=>date.setHours(0, 0, 0) === displayDate.getTime()))) {
                    event.preventDefault();
                    return;
                }
                if (displayDate) {
                    if (!isNaN(displayDate.getTime())) {
                        selectedDate = displayDate;
                        backEndDateValue = (0, $6IhJz.default)(selectedDate, this.state.backEndFormat);
                    } else {
                        selectedDate = this.state.selectedDate;
                        backEndDateValue = this.state.selectedDate && (0, $6IhJz.default)(this.state.selectedDate, this.state.backEndFormat);
                    }
                } else selectedDate = null;
                this.changeState(selectedDate, backEndDateValue);
            }
        };
        this.handleChange = (date)=>{
            if (date && $33cc108696ddc4dd$var$DatePicker.isYearGreaterThan10000(date)) return;
            const backEndDateValue = date ? (0, $6IhJz.default)(date, this.state.backEndFormat) : undefined;
            this.changeState(date, backEndDateValue);
        };
        this.handleRefChange = (ref)=>{
            if (ref) this.datePickerRef = ref;
        };
        this.handleKeyDown = (e)=>{
            if (e.key === "Tab") // close the calendar if tab is pressed
            this.datePickerRef.setOpen(false);
            // if all the text is selected, then pressing delete will clear the input
            if (this.props.mask && e.key === "Backspace" && this.datePickerRef.input && this.datePickerRef.input.inputElement) {
                const input = this.datePickerRef.input.inputElement;
                if (input.selectionStart === 0 && input.selectionEnd === input.value.length) this.handleChange(null);
            }
            this.props.onKeyDown && this.props.onKeyDown(e);
        };
        this.handleCalendarClose = ()=>{
            // Work around for input not blurring when calendar is closed
            // This is a know issue with react-datepicker and can be removed when it is fixed
            // https://github.com/Hacker0x01/react-datepicker/issues/2028
            if (this.datePickerRef.input && this.datePickerRef.input.focus) {
                this.datePickerRef.input.focus();
                this.datePickerRef.input.blur();
            }
            if (this.datePickerRef.input.inputElement && this.datePickerRef.input.inputElement.focus) {
                this.datePickerRef.input.inputElement.focus();
                this.datePickerRef.input.inputElement.blur();
            }
            this.props.onCalendarClose && this.props.onCalendarClose();
        };
        this.changeState = (selectedDate, backEndDateValue)=>{
            this.setState({
                selectedDate: selectedDate
            }, ()=>{
                if (this.props.onChange) this.props.onChange(backEndDateValue);
            });
        };
        this.datePickerRef = $33cc108696ddc4dd$var$react_1.default.createRef();
        const value = this.props.value && $33cc108696ddc4dd$var$DatePicker.formatDate(this.props.value);
        this.state = {
            selectedDate: value ? new Date(value.includes("T") ? value.replace(/T.+/, "") : value) : null,
            placeholderText: this.props.placeholderText ? this.props.placeholderText : this.props.displayFormat ? this.props.displayFormat : "MM/DD/YYYY",
            className: this.props.className ? this.props.className : "form-control",
            classNameContainer: this.props.fullWidth ? "react-datepicker-full-width" : "",
            displayFormat: this.props.displayFormat ? this.props.displayFormat : "MM/dd/yyyy",
            backEndFormat: this.props.backEndFormat ? this.props.backEndFormat : "yyyy-MM-dd",
            locale: this.props.locale ? this.props.locale : "en-US"
        };
        $33cc108696ddc4dd$var$DatePicker.registerLocalization(this.props.locale);
    }
    static formatDate(date) {
        return date.replace(/-/g, "/").replace(/\./g, "/");
    }
    static isYearGreaterThan10000(date) {
        return Math.round(date.getFullYear() / 10000) > 0;
    }
    static registerLocalization(code) {
        if (code) {
            const locale = $33cc108696ddc4dd$var$LocalesArray.find((l)=>l.code === code);
            if (locale && locale.code) (0, $33cc108696ddc4dd$var$react_datepicker_1.registerLocale)(locale.code, locale);
        }
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState((prevState)=>{
            const value = nextProps.value && $33cc108696ddc4dd$var$DatePicker.formatDate(nextProps.value);
            const date = nextProps.readOnly ? prevState.selectedDate : value && new Date(value.includes("T") ? value.replace(/T.+/, "") : value) || undefined;
            const className = (0, $33cc108696ddc4dd$var$classnames_1.default)(nextProps.className, prevState.className.indexOf("form-control") !== -1 && "form-control");
            if (nextProps.locale !== prevState.locale) $33cc108696ddc4dd$var$DatePicker.registerLocalization(nextProps.locale);
            return Object.assign(Object.assign({}, prevState), {
                selectedDate: date !== null && date !== undefined && !isNaN(date.getTime()) ? date : null,
                className: className,
                classNameContainer: this.props.fullWidth ? "react-datepicker-full-width" : ""
            });
        });
    }
    render() {
        var _a;
        const _b = this.props, { value: value, placeholderText: placeholderText, displayFormat: displayFormat, className: className, backEndFormat: backEndFormat, locale: locale, usePortal: usePortal, dataLwtId: dataLwtId, readOnly: readOnly, tabIndex: tabIndex, onChange: onChange, onBlur: onBlur, onFocus: onFocus, maskCharacter: maskCharacter = (_a = this.props.maskCharacter) !== null && _a !== void 0 ? _a : "/", mask: mask, onKeyDown: onKeyDown, onCalendarClose: onCalendarClose } = _b, restProps = $33cc108696ddc4dd$var$__rest(_b, [
            "value",
            "placeholderText",
            "displayFormat",
            "className",
            "backEndFormat",
            "locale",
            "usePortal",
            "dataLwtId",
            "readOnly",
            "tabIndex",
            "onChange",
            "onBlur",
            "onFocus",
            "maskCharacter",
            "mask",
            "onKeyDown",
            "onCalendarClose"
        ]);
        // const maskCharacter = this.props.maskCharacter ?? '/';
        const maskCollection = [];
        if (mask && displayFormat) {
            let maskSeparator;
            for(let i = 0; i < displayFormat.length; i++){
                const char = displayFormat.charAt(i);
                switch(char){
                    case "M":
                    case "d":
                    case "y":
                        maskCollection.push(/\d/);
                        break;
                    default:
                        if (maskCollection.length > 0) {
                            if (!maskSeparator) maskSeparator = char;
                            if (char === maskSeparator) maskCollection.push(maskCharacter);
                        }
                        break;
                }
            }
        }
        const optionalProps = {};
        if (usePortal) {
            optionalProps.popperContainer = $33cc108696ddc4dd$var$Portal_1.default;
            optionalProps.popperModifiers = {
                preventOverflow: {
                    enabled: true
                }
            };
        }
        return $33cc108696ddc4dd$var$react_1.default.createElement("div", {
            "data-lwt-id": dataLwtId,
            className: this.state.classNameContainer,
            onChange: this.handleDivChange,
            onClick: (e)=>e.stopPropagation()
        }, $33cc108696ddc4dd$var$react_1.default.createElement($33cc108696ddc4dd$var$react_datepicker_1.default, Object.assign({
            className: this.state.className,
            selected: this.state.selectedDate,
            onChange: this.handleChange,
            isClearable: this.props.isClearable || !readOnly,
            dateFormat: this.state.displayFormat,
            placeholderText: this.state.placeholderText,
            onBlur: onBlur,
            onFocus: onFocus,
            onKeyDown: (e)=>this.handleKeyDown(e),
            onCalendarClose: ()=>this.handleCalendarClose(),
            readOnly: readOnly,
            locale: locale,
            customInput: mask && $33cc108696ddc4dd$var$react_1.default.createElement($33cc108696ddc4dd$var$react_text_mask_1.default, {
                type: "text",
                mask: maskCollection
            }),
            tabIndex: readOnly ? -1 : tabIndex
        }, optionalProps, restProps, {
            ref: this.handleRefChange
        })));
    }
}
module.exports.default = $33cc108696ddc4dd$var$DatePicker;

});
parcelRegister("6IhJz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4e349bc0dbb08c36$export$2e2bcd8739ae039);

var $cFZfS = parcelRequire("cFZfS");

var $8NlMJ = parcelRequire("8NlMJ");

var $gdr0J = parcelRequire("gdr0J");

var $iDIba = parcelRequire("iDIba");

var $6MGGE = parcelRequire("6MGGE");

var $9vfYB = parcelRequire("9vfYB");

var $ebrmh = parcelRequire("ebrmh");

var $esGEx = parcelRequire("esGEx");

var $4LmDH = parcelRequire("4LmDH");

var $2GvpZ = parcelRequire("2GvpZ");

var $d7Pru = parcelRequire("d7Pru");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $4e349bc0dbb08c36$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $4e349bc0dbb08c36$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $4e349bc0dbb08c36$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $4e349bc0dbb08c36$var$doubleQuoteRegExp = /''/g;
var $4e349bc0dbb08c36$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $4e349bc0dbb08c36$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $4LmDH.default)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $2GvpZ.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $d7Pru.default);
    var firstWeekContainsDate = (0, $esGEx.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, $esGEx.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!locale.localize) throw new RangeError("locale must contain localize property");
    if (!locale.formatLong) throw new RangeError("locale must contain formatLong property");
    var originalDate = (0, $gdr0J.default)(dirtyDate);
    if (!(0, $cFZfS.default)(originalDate)) throw new RangeError("Invalid time value");
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $9vfYB.default)(originalDate);
    var utcDate = (0, $8NlMJ.default)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($4e349bc0dbb08c36$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = (0, $6MGGE.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($4e349bc0dbb08c36$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $4e349bc0dbb08c36$var$cleanEscapedString(substring);
        var formatter = (0, $iDIba.default)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $ebrmh.isProtectedWeekYearToken)(substring)) (0, $ebrmh.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $ebrmh.isProtectedDayOfYearToken)(substring)) (0, $ebrmh.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($4e349bc0dbb08c36$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function $4e349bc0dbb08c36$var$cleanEscapedString(input) {
    var matched = input.match($4e349bc0dbb08c36$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($4e349bc0dbb08c36$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("cFZfS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $93a8d45f3f5c7cb9$export$2e2bcd8739ae039);

var $9BdaM = parcelRequire("9BdaM");

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $93a8d45f3f5c7cb9$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    if (!(0, $9BdaM.default)(dirtyDate) && typeof dirtyDate !== "number") return false;
    var date = (0, $gdr0J.default)(dirtyDate);
    return !isNaN(Number(date));
}

});
parcelRegister("9BdaM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $6fd1c9a3eeaafbe4$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $4LmDH = parcelRequire("4LmDH");
function $6fd1c9a3eeaafbe4$export$2e2bcd8739ae039(value) {
    (0, $4LmDH.default)(1, arguments);
    return value instanceof Date || (0, $fSwVM.default)(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}

});
parcelRegister("4LmDH", function(module, exports) {

$parcel$export(module.exports, "default", () => $377d1ce359384586$export$2e2bcd8739ae039);
function $377d1ce359384586$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}

});


parcelRegister("gdr0J", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $bce2d00733a79246$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $4LmDH = parcelRequire("4LmDH");
function $bce2d00733a79246$export$2e2bcd8739ae039(argument) {
    (0, $4LmDH.default)(1, arguments);
    var argStr = Object.prototype.toString.call(argument);
    // Clone the date
    if (argument instanceof Date || (0, $fSwVM.default)(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
            // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}

});


parcelRegister("8NlMJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6673cc5b62dfa592$export$2e2bcd8739ae039);

var $8eaBc = parcelRequire("8eaBc");

var $4LmDH = parcelRequire("4LmDH");

var $esGEx = parcelRequire("esGEx");
function $6673cc5b62dfa592$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $esGEx.default)(dirtyAmount);
    return (0, $8eaBc.default)(dirtyDate, -amount);
}

});
parcelRegister("8eaBc", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fd7da45fede2458$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $5fd7da45fede2458$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var timestamp = (0, $gdr0J.default)(dirtyDate).getTime();
    var amount = (0, $esGEx.default)(dirtyAmount);
    return new Date(timestamp + amount);
}

});
parcelRegister("esGEx", function(module, exports) {

$parcel$export(module.exports, "default", () => $a874c42e2166676d$export$2e2bcd8739ae039);
function $a874c42e2166676d$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}

});



parcelRegister("iDIba", function(module, exports) {

$parcel$export(module.exports, "default", () => $d91e238bf521c720$export$2e2bcd8739ae039);

var $iT1Z6 = parcelRequire("iT1Z6");

var $jsJZZ = parcelRequire("jsJZZ");

var $7sdBg = parcelRequire("7sdBg");

var $gTlfB = parcelRequire("gTlfB");

var $kB1VM = parcelRequire("kB1VM");

var $bGZx9 = parcelRequire("bGZx9");

var $cbpKX = parcelRequire("cbpKX");
var $d91e238bf521c720$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $d91e238bf521c720$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            var signedYear = date.getUTCFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $cbpKX.default).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $kB1VM.default)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            var twoDigitYear = weekYear % 100;
            return (0, $bGZx9.default)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $bGZx9.default)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $7sdBg.default)(date);
        // Padding
        return (0, $bGZx9.default)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $bGZx9.default)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $bGZx9.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $bGZx9.default)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $cbpKX.default).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $bGZx9.default)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $gTlfB.default)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $bGZx9.default)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $jsJZZ.default)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $bGZx9.default)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getUTCDate(), {
            unit: "date"
        });
        return (0, $cbpKX.default).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $iT1Z6.default)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $bGZx9.default)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $bGZx9.default)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $bGZx9.default)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $bGZx9.default)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $d91e238bf521c720$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === "ho") {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $cbpKX.default).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getUTCHours(), {
            unit: "hour"
        });
        return (0, $cbpKX.default).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $bGZx9.default)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $bGZx9.default)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: "minute"
        });
        return (0, $cbpKX.default).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: "second"
        });
        return (0, $cbpKX.default).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $cbpKX.default).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $d91e238bf521c720$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                // Hours and minutes without `:` delimiter
                return $d91e238bf521c720$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $d91e238bf521c720$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $d91e238bf521c720$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                // Hours and minutes without `:` delimiter
                return $d91e238bf521c720$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $d91e238bf521c720$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $d91e238bf521c720$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $d91e238bf521c720$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $d91e238bf521c720$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $d91e238bf521c720$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $bGZx9.default)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $bGZx9.default)(timestamp, token.length);
    }
};
function $d91e238bf521c720$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || "";
    return sign + String(hours) + delimiter + (0, $bGZx9.default)(minutes, 2);
}
function $d91e238bf521c720$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + (0, $bGZx9.default)(Math.abs(offset) / 60, 2);
    }
    return $d91e238bf521c720$var$formatTimezone(offset, dirtyDelimiter);
}
function $d91e238bf521c720$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = (0, $bGZx9.default)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $bGZx9.default)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $d91e238bf521c720$export$2e2bcd8739ae039 = $d91e238bf521c720$var$formatters;

});
parcelRegister("iT1Z6", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbfee7256f9ba04c$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
var $dbfee7256f9ba04c$var$MILLISECONDS_IN_DAY = 86400000;
function $dbfee7256f9ba04c$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $dbfee7256f9ba04c$var$MILLISECONDS_IN_DAY) + 1;
}

});

parcelRegister("jsJZZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2b4503c694c959a$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $bY8nB = parcelRequire("bY8nB");

var $6KmMb = parcelRequire("6KmMb");

var $4LmDH = parcelRequire("4LmDH");
var $e2b4503c694c959a$var$MILLISECONDS_IN_WEEK = 604800000;
function $e2b4503c694c959a$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var diff = (0, $bY8nB.default)(date).getTime() - (0, $6KmMb.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $e2b4503c694c959a$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("bY8nB", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b6bcc549b1c1b29$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $8b6bcc549b1c1b29$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $gdr0J.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("6KmMb", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e98b4d5a2488885$export$2e2bcd8739ae039);

var $7sdBg = parcelRequire("7sdBg");

var $bY8nB = parcelRequire("bY8nB");

var $4LmDH = parcelRequire("4LmDH");
function $4e98b4d5a2488885$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var year = (0, $7sdBg.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $bY8nB.default)(fourthOfJanuary);
    return date;
}

});
parcelRegister("7sdBg", function(module, exports) {

$parcel$export(module.exports, "default", () => $56d5b29bd1df6af4$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");

var $bY8nB = parcelRequire("bY8nB");
function $56d5b29bd1df6af4$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $bY8nB.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $bY8nB.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("gTlfB", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4c2445bc457b574$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $1cqVL = parcelRequire("1cqVL");

var $7Pzkw = parcelRequire("7Pzkw");

var $4LmDH = parcelRequire("4LmDH");
var $c4c2445bc457b574$var$MILLISECONDS_IN_WEEK = 604800000;
function $c4c2445bc457b574$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var diff = (0, $1cqVL.default)(date, options).getTime() - (0, $7Pzkw.default)(date, options).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $c4c2445bc457b574$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("1cqVL", function(module, exports) {

$parcel$export(module.exports, "default", () => $0dfbcd4e04a34858$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");

var $esGEx = parcelRequire("esGEx");

var $2GvpZ = parcelRequire("2GvpZ");
function $0dfbcd4e04a34858$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $4LmDH.default)(1, arguments);
    var defaultOptions = (0, $2GvpZ.getDefaultOptions)();
    var weekStartsOn = (0, $esGEx.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $gdr0J.default)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}

});
parcelRegister("2GvpZ", function(module, exports) {

$parcel$export(module.exports, "getDefaultOptions", () => $1f47e002602f8387$export$430a3269e24b912e);
var $1f47e002602f8387$var$defaultOptions = {};
function $1f47e002602f8387$export$430a3269e24b912e() {
    return $1f47e002602f8387$var$defaultOptions;
}
function $1f47e002602f8387$export$95365be1b0704abc(newOptions) {
    $1f47e002602f8387$var$defaultOptions = newOptions;
}

});


parcelRegister("7Pzkw", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b38b39a484f4993$export$2e2bcd8739ae039);

var $kB1VM = parcelRequire("kB1VM");

var $4LmDH = parcelRequire("4LmDH");

var $1cqVL = parcelRequire("1cqVL");

var $esGEx = parcelRequire("esGEx");

var $2GvpZ = parcelRequire("2GvpZ");
function $5b38b39a484f4993$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $4LmDH.default)(1, arguments);
    var defaultOptions = (0, $2GvpZ.getDefaultOptions)();
    var firstWeekContainsDate = (0, $esGEx.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $kB1VM.default)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $1cqVL.default)(firstWeek, options);
    return date;
}

});
parcelRegister("kB1VM", function(module, exports) {

$parcel$export(module.exports, "default", () => $efe8c2ce4ac4bd36$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");

var $1cqVL = parcelRequire("1cqVL");

var $esGEx = parcelRequire("esGEx");

var $2GvpZ = parcelRequire("2GvpZ");
function $efe8c2ce4ac4bd36$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $2GvpZ.getDefaultOptions)();
    var firstWeekContainsDate = (0, $esGEx.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $1cqVL.default)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $1cqVL.default)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("bGZx9", function(module, exports) {

$parcel$export(module.exports, "default", () => $88335940ad51fc8f$export$2e2bcd8739ae039);
function $88335940ad51fc8f$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = "0" + output;
    return sign + output;
}

});

parcelRegister("cbpKX", function(module, exports) {

$parcel$export(module.exports, "default", () => $8dea7dd01f0b97c2$export$2e2bcd8739ae039);

var $bGZx9 = parcelRequire("bGZx9");
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $8dea7dd01f0b97c2$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $bGZx9.default)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === "M" ? String(month + 1) : (0, $bGZx9.default)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $bGZx9.default)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $bGZx9.default)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $bGZx9.default)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $bGZx9.default)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $bGZx9.default)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $bGZx9.default)(fractionalSeconds, token.length);
    }
};
var $8dea7dd01f0b97c2$export$2e2bcd8739ae039 = $8dea7dd01f0b97c2$var$formatters;

});


parcelRegister("6MGGE", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f085685fa15e740$export$2e2bcd8739ae039);
var $4f085685fa15e740$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
var $4f085685fa15e740$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
var $4f085685fa15e740$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $4f085685fa15e740$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $4f085685fa15e740$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $4f085685fa15e740$var$timeLongFormatter(timePattern, formatLong));
};
var $4f085685fa15e740$var$longFormatters = {
    p: $4f085685fa15e740$var$timeLongFormatter,
    P: $4f085685fa15e740$var$dateTimeLongFormatter
};
var $4f085685fa15e740$export$2e2bcd8739ae039 = $4f085685fa15e740$var$longFormatters;

});

parcelRegister("9vfYB", function(module, exports) {

$parcel$export(module.exports, "default", () => $6eb366e006a8b659$export$2e2bcd8739ae039);
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $6eb366e006a8b659$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}

});

parcelRegister("ebrmh", function(module, exports) {

$parcel$export(module.exports, "isProtectedDayOfYearToken", () => $a5375092e28b891e$export$c6cc36aa33304772);
$parcel$export(module.exports, "isProtectedWeekYearToken", () => $a5375092e28b891e$export$c6b49d6dceb604a1);
$parcel$export(module.exports, "throwProtectedError", () => $a5375092e28b891e$export$8073c1ae88f0e727);
var $a5375092e28b891e$var$protectedDayOfYearTokens = [
    "D",
    "DD"
];
var $a5375092e28b891e$var$protectedWeekYearTokens = [
    "YY",
    "YYYY"
];
function $a5375092e28b891e$export$c6cc36aa33304772(token) {
    return $a5375092e28b891e$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $a5375092e28b891e$export$c6b49d6dceb604a1(token) {
    return $a5375092e28b891e$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $a5375092e28b891e$export$8073c1ae88f0e727(token, format, input) {
    if (token === "YYYY") throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "YY") throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "D") throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "DD") throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}

});

parcelRegister("d7Pru", function(module, exports) {

$parcel$export(module.exports, "default", () => $98e3d5324cb7d94c$export$2e2bcd8739ae039);

var $15nwl = parcelRequire("15nwl");
var $98e3d5324cb7d94c$export$2e2bcd8739ae039 = (0, $15nwl.default);

});
parcelRegister("15nwl", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ca880ce53ce49f9$export$2e2bcd8739ae039);

var $2qFQF = parcelRequire("2qFQF");

var $fW24Y = parcelRequire("fW24Y");

var $1uXR5 = parcelRequire("1uXR5");

var $cPhtT = parcelRequire("cPhtT");

var $2SJ52 = parcelRequire("2SJ52");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $0ca880ce53ce49f9$var$locale = {
    code: "en-US",
    formatDistance: (0, $2qFQF.default),
    formatLong: (0, $fW24Y.default),
    formatRelative: (0, $1uXR5.default),
    localize: (0, $cPhtT.default),
    match: (0, $2SJ52.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $0ca880ce53ce49f9$export$2e2bcd8739ae039 = $0ca880ce53ce49f9$var$locale;

});
parcelRegister("2qFQF", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c4e78b8ee7f66d8$export$2e2bcd8739ae039);
var $1c4e78b8ee7f66d8$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var $1c4e78b8ee7f66d8$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $1c4e78b8ee7f66d8$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
var $1c4e78b8ee7f66d8$export$2e2bcd8739ae039 = $1c4e78b8ee7f66d8$var$formatDistance;

});

parcelRegister("fW24Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $b99de2b03d4f39be$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $b99de2b03d4f39be$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $b99de2b03d4f39be$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $b99de2b03d4f39be$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $b99de2b03d4f39be$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $b99de2b03d4f39be$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $b99de2b03d4f39be$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $b99de2b03d4f39be$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $b99de2b03d4f39be$export$2e2bcd8739ae039 = $b99de2b03d4f39be$var$formatLong;

});
parcelRegister("uq3Ff", function(module, exports) {

$parcel$export(module.exports, "default", () => $05b7040d79e43f9d$export$2e2bcd8739ae039);
function $05b7040d79e43f9d$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

});


parcelRegister("1uXR5", function(module, exports) {

$parcel$export(module.exports, "default", () => $117705cf2af2348d$export$2e2bcd8739ae039);
var $117705cf2af2348d$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var $117705cf2af2348d$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $117705cf2af2348d$var$formatRelativeLocale[token];
};
var $117705cf2af2348d$export$2e2bcd8739ae039 = $117705cf2af2348d$var$formatRelative;

});

parcelRegister("cPhtT", function(module, exports) {

$parcel$export(module.exports, "default", () => $9567ced935a3b497$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $9567ced935a3b497$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var $9567ced935a3b497$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $9567ced935a3b497$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var $9567ced935a3b497$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var $9567ced935a3b497$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var $9567ced935a3b497$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var $9567ced935a3b497$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var $9567ced935a3b497$var$localize = {
    ordinalNumber: $9567ced935a3b497$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $9567ced935a3b497$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $9567ced935a3b497$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $9567ced935a3b497$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $9567ced935a3b497$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $9567ced935a3b497$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $9567ced935a3b497$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $9567ced935a3b497$export$2e2bcd8739ae039 = $9567ced935a3b497$var$localize;

});
parcelRegister("kp3bq", function(module, exports) {

$parcel$export(module.exports, "default", () => $eda89c8f88184c82$export$2e2bcd8739ae039);
function $eda89c8f88184c82$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
        // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

});


parcelRegister("2SJ52", function(module, exports) {

$parcel$export(module.exports, "default", () => $219397ebd8b56b11$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $219397ebd8b56b11$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $219397ebd8b56b11$var$parseOrdinalNumberPattern = /\d+/i;
var $219397ebd8b56b11$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $219397ebd8b56b11$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $219397ebd8b56b11$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $219397ebd8b56b11$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $219397ebd8b56b11$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $219397ebd8b56b11$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $219397ebd8b56b11$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $219397ebd8b56b11$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $219397ebd8b56b11$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $219397ebd8b56b11$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $219397ebd8b56b11$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $219397ebd8b56b11$var$matchOrdinalNumberPattern,
        parsePattern: $219397ebd8b56b11$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $219397ebd8b56b11$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $219397ebd8b56b11$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $219397ebd8b56b11$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $219397ebd8b56b11$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $219397ebd8b56b11$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $219397ebd8b56b11$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $219397ebd8b56b11$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $219397ebd8b56b11$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $219397ebd8b56b11$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $219397ebd8b56b11$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $219397ebd8b56b11$export$2e2bcd8739ae039 = $219397ebd8b56b11$var$match;

});
parcelRegister("gKbFl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c309fdccb9ef673a$export$2e2bcd8739ae039);
function $c309fdccb9ef673a$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $c309fdccb9ef673a$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $c309fdccb9ef673a$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $c309fdccb9ef673a$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $c309fdccb9ef673a$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

});

parcelRegister("7pOAB", function(module, exports) {

$parcel$export(module.exports, "default", () => $56621c36efca199b$export$2e2bcd8739ae039);
function $56621c36efca199b$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}

});





parcelRegister("j9gmE", function(module, exports) {

$parcel$export(module.exports, "af", () => (parcelRequire("f97JX")).default);
$parcel$export(module.exports, "ar", () => (parcelRequire("hkKHo")).default);
$parcel$export(module.exports, "arDZ", () => (parcelRequire("4L4d9")).default);
$parcel$export(module.exports, "arEG", () => (parcelRequire("4cDuC")).default);
$parcel$export(module.exports, "arMA", () => (parcelRequire("hKWGy")).default);
$parcel$export(module.exports, "arSA", () => (parcelRequire("46td8")).default);
$parcel$export(module.exports, "arTN", () => (parcelRequire("blcre")).default);
$parcel$export(module.exports, "az", () => (parcelRequire("3t3sO")).default);
$parcel$export(module.exports, "be", () => (parcelRequire("kzMqz")).default);
$parcel$export(module.exports, "beTarask", () => (parcelRequire("4u97v")).default);
$parcel$export(module.exports, "bg", () => (parcelRequire("h9brY")).default);
$parcel$export(module.exports, "bn", () => (parcelRequire("iLGEY")).default);
$parcel$export(module.exports, "bs", () => (parcelRequire("boKMd")).default);
$parcel$export(module.exports, "ca", () => (parcelRequire("kX4ph")).default);
$parcel$export(module.exports, "cs", () => (parcelRequire("jhRNZ")).default);
$parcel$export(module.exports, "cy", () => (parcelRequire("c7thg")).default);
$parcel$export(module.exports, "da", () => (parcelRequire("2fFal")).default);
$parcel$export(module.exports, "de", () => (parcelRequire("5yLJB")).default);
$parcel$export(module.exports, "deAT", () => (parcelRequire("ddOmO")).default);
$parcel$export(module.exports, "el", () => (parcelRequire("7Pv9E")).default);
$parcel$export(module.exports, "enAU", () => (parcelRequire("6UbtV")).default);
$parcel$export(module.exports, "enCA", () => (parcelRequire("8DB38")).default);
$parcel$export(module.exports, "enGB", () => (parcelRequire("c3iH1")).default);
$parcel$export(module.exports, "enIE", () => (parcelRequire("1N6Qr")).default);
$parcel$export(module.exports, "enIN", () => (parcelRequire("k4Shu")).default);
$parcel$export(module.exports, "enNZ", () => (parcelRequire("ffnag")).default);
$parcel$export(module.exports, "enUS", () => (parcelRequire("15nwl")).default);
$parcel$export(module.exports, "enZA", () => (parcelRequire("8Zadw")).default);
$parcel$export(module.exports, "eo", () => (parcelRequire("9jSlN")).default);
$parcel$export(module.exports, "es", () => (parcelRequire("iLezG")).default);
$parcel$export(module.exports, "et", () => (parcelRequire("goeBf")).default);
$parcel$export(module.exports, "eu", () => (parcelRequire("6l3KT")).default);
$parcel$export(module.exports, "faIR", () => (parcelRequire("kRNmQ")).default);
$parcel$export(module.exports, "fi", () => (parcelRequire("3NGl6")).default);
$parcel$export(module.exports, "fr", () => (parcelRequire("5KUnQ")).default);
$parcel$export(module.exports, "frCA", () => (parcelRequire("7ao6A")).default);
$parcel$export(module.exports, "frCH", () => (parcelRequire("gyxbH")).default);
$parcel$export(module.exports, "fy", () => (parcelRequire("71rFn")).default);
$parcel$export(module.exports, "gd", () => (parcelRequire("80hTX")).default);
$parcel$export(module.exports, "gl", () => (parcelRequire("5wwDM")).default);
$parcel$export(module.exports, "gu", () => (parcelRequire("3muKw")).default);
$parcel$export(module.exports, "he", () => (parcelRequire("c8qu3")).default);
$parcel$export(module.exports, "hi", () => (parcelRequire("a7gvH")).default);
$parcel$export(module.exports, "hr", () => (parcelRequire("22apf")).default);
$parcel$export(module.exports, "ht", () => (parcelRequire("fCx3R")).default);
$parcel$export(module.exports, "hu", () => (parcelRequire("8dm7T")).default);
$parcel$export(module.exports, "hy", () => (parcelRequire("iHvZ6")).default);
$parcel$export(module.exports, "id", () => (parcelRequire("3WIYd")).default);
$parcel$export(module.exports, "is", () => (parcelRequire("aHiNT")).default);
$parcel$export(module.exports, "it", () => (parcelRequire("7OT21")).default);
$parcel$export(module.exports, "itCH", () => (parcelRequire("2ykfi")).default);
$parcel$export(module.exports, "ja", () => (parcelRequire("htvDM")).default);
$parcel$export(module.exports, "jaHira", () => (parcelRequire("9Zo2q")).default);
$parcel$export(module.exports, "ka", () => (parcelRequire("fcYsM")).default);
$parcel$export(module.exports, "kk", () => (parcelRequire("9cYZI")).default);
$parcel$export(module.exports, "km", () => (parcelRequire("ggnHB")).default);
$parcel$export(module.exports, "kn", () => (parcelRequire("eNTfn")).default);
$parcel$export(module.exports, "ko", () => (parcelRequire("at6wq")).default);
$parcel$export(module.exports, "lb", () => (parcelRequire("3Qi5Z")).default);
$parcel$export(module.exports, "lt", () => (parcelRequire("jx56P")).default);
$parcel$export(module.exports, "lv", () => (parcelRequire("bODly")).default);
$parcel$export(module.exports, "mk", () => (parcelRequire("h4pP7")).default);
$parcel$export(module.exports, "mn", () => (parcelRequire("lerBG")).default);
$parcel$export(module.exports, "ms", () => (parcelRequire("7IG4W")).default);
$parcel$export(module.exports, "mt", () => (parcelRequire("drgGi")).default);
$parcel$export(module.exports, "nb", () => (parcelRequire("aDcxd")).default);
$parcel$export(module.exports, "nl", () => (parcelRequire("8zqwg")).default);
$parcel$export(module.exports, "nlBE", () => (parcelRequire("bM2BX")).default);
$parcel$export(module.exports, "nn", () => (parcelRequire("I8kQx")).default);
$parcel$export(module.exports, "oc", () => (parcelRequire("4wyRd")).default);
$parcel$export(module.exports, "pl", () => (parcelRequire("8QtUC")).default);
$parcel$export(module.exports, "pt", () => (parcelRequire("4Oal2")).default);
$parcel$export(module.exports, "ptBR", () => (parcelRequire("d00ab")).default);
$parcel$export(module.exports, "ro", () => (parcelRequire("3Y8EW")).default);
$parcel$export(module.exports, "ru", () => (parcelRequire("ePrM2")).default);
$parcel$export(module.exports, "sk", () => (parcelRequire("fPRwQ")).default);
$parcel$export(module.exports, "sl", () => (parcelRequire("fnMm5")).default);
$parcel$export(module.exports, "sq", () => (parcelRequire("fO6Xu")).default);
$parcel$export(module.exports, "sr", () => (parcelRequire("7PZ4Z")).default);
$parcel$export(module.exports, "srLatn", () => (parcelRequire("cpWED")).default);
$parcel$export(module.exports, "sv", () => (parcelRequire("eNpFC")).default);
$parcel$export(module.exports, "ta", () => (parcelRequire("ajvdM")).default);
$parcel$export(module.exports, "te", () => (parcelRequire("a83pb")).default);
$parcel$export(module.exports, "th", () => (parcelRequire("7bq3f")).default);
$parcel$export(module.exports, "tr", () => (parcelRequire("1wu2L")).default);
$parcel$export(module.exports, "ug", () => (parcelRequire("jpXP0")).default);
$parcel$export(module.exports, "uk", () => (parcelRequire("8ODOt")).default);
$parcel$export(module.exports, "uz", () => (parcelRequire("bvaKV")).default);
$parcel$export(module.exports, "uzCyrl", () => (parcelRequire("ee0r7")).default);
$parcel$export(module.exports, "vi", () => (parcelRequire("h4ZUv")).default);
$parcel$export(module.exports, "zhCN", () => (parcelRequire("61ZHO")).default);
$parcel$export(module.exports, "zhHK", () => (parcelRequire("ezXpQ")).default);
$parcel$export(module.exports, "zhTW", () => (parcelRequire("JpbSs")).default);
// This file is generated automatically by `scripts/build/indices.ts`. Please, don't change it.

var $f97JX = parcelRequire("f97JX");

var $hkKHo = parcelRequire("hkKHo");

var $4L4d9 = parcelRequire("4L4d9");

var $4cDuC = parcelRequire("4cDuC");

var $hKWGy = parcelRequire("hKWGy");

var $46td8 = parcelRequire("46td8");

var $blcre = parcelRequire("blcre");

var $3t3sO = parcelRequire("3t3sO");

var $kzMqz = parcelRequire("kzMqz");

var $4u97v = parcelRequire("4u97v");

var $h9brY = parcelRequire("h9brY");

var $iLGEY = parcelRequire("iLGEY");

var $boKMd = parcelRequire("boKMd");

var $kX4ph = parcelRequire("kX4ph");

var $jhRNZ = parcelRequire("jhRNZ");

var $c7thg = parcelRequire("c7thg");

var $2fFal = parcelRequire("2fFal");

var $5yLJB = parcelRequire("5yLJB");

var $ddOmO = parcelRequire("ddOmO");

var $7Pv9E = parcelRequire("7Pv9E");

var $6UbtV = parcelRequire("6UbtV");

var $8DB38 = parcelRequire("8DB38");

var $c3iH1 = parcelRequire("c3iH1");

var $1N6Qr = parcelRequire("1N6Qr");

var $k4Shu = parcelRequire("k4Shu");

var $ffnag = parcelRequire("ffnag");

var $15nwl = parcelRequire("15nwl");

var $8Zadw = parcelRequire("8Zadw");

var $9jSlN = parcelRequire("9jSlN");

var $iLezG = parcelRequire("iLezG");

var $goeBf = parcelRequire("goeBf");

var $6l3KT = parcelRequire("6l3KT");

var $kRNmQ = parcelRequire("kRNmQ");

var $3NGl6 = parcelRequire("3NGl6");

var $5KUnQ = parcelRequire("5KUnQ");

var $7ao6A = parcelRequire("7ao6A");

var $gyxbH = parcelRequire("gyxbH");

var $71rFn = parcelRequire("71rFn");

var $80hTX = parcelRequire("80hTX");

var $5wwDM = parcelRequire("5wwDM");

var $3muKw = parcelRequire("3muKw");

var $c8qu3 = parcelRequire("c8qu3");

var $a7gvH = parcelRequire("a7gvH");

var $22apf = parcelRequire("22apf");

var $fCx3R = parcelRequire("fCx3R");

var $8dm7T = parcelRequire("8dm7T");

var $iHvZ6 = parcelRequire("iHvZ6");

var $3WIYd = parcelRequire("3WIYd");

var $aHiNT = parcelRequire("aHiNT");

var $7OT21 = parcelRequire("7OT21");

var $2ykfi = parcelRequire("2ykfi");

var $htvDM = parcelRequire("htvDM");

var $9Zo2q = parcelRequire("9Zo2q");

var $fcYsM = parcelRequire("fcYsM");

var $9cYZI = parcelRequire("9cYZI");

var $ggnHB = parcelRequire("ggnHB");

var $eNTfn = parcelRequire("eNTfn");

var $at6wq = parcelRequire("at6wq");

var $3Qi5Z = parcelRequire("3Qi5Z");

var $jx56P = parcelRequire("jx56P");

var $bODly = parcelRequire("bODly");

var $h4pP7 = parcelRequire("h4pP7");

var $lerBG = parcelRequire("lerBG");

var $7IG4W = parcelRequire("7IG4W");

var $drgGi = parcelRequire("drgGi");

var $aDcxd = parcelRequire("aDcxd");

var $8zqwg = parcelRequire("8zqwg");

var $bM2BX = parcelRequire("bM2BX");

var $I8kQx = parcelRequire("I8kQx");

var $4wyRd = parcelRequire("4wyRd");

var $8QtUC = parcelRequire("8QtUC");

var $4Oal2 = parcelRequire("4Oal2");

var $d00ab = parcelRequire("d00ab");

var $3Y8EW = parcelRequire("3Y8EW");

var $ePrM2 = parcelRequire("ePrM2");

var $fPRwQ = parcelRequire("fPRwQ");

var $fnMm5 = parcelRequire("fnMm5");

var $fO6Xu = parcelRequire("fO6Xu");

var $7PZ4Z = parcelRequire("7PZ4Z");

var $cpWED = parcelRequire("cpWED");

var $eNpFC = parcelRequire("eNpFC");

var $ajvdM = parcelRequire("ajvdM");

var $a83pb = parcelRequire("a83pb");

var $7bq3f = parcelRequire("7bq3f");

var $1wu2L = parcelRequire("1wu2L");

var $jpXP0 = parcelRequire("jpXP0");

var $8ODOt = parcelRequire("8ODOt");

var $bvaKV = parcelRequire("bvaKV");

var $ee0r7 = parcelRequire("ee0r7");

var $h4ZUv = parcelRequire("h4ZUv");

var $61ZHO = parcelRequire("61ZHO");

var $ezXpQ = parcelRequire("ezXpQ");

var $JpbSs = parcelRequire("JpbSs");

});
parcelRegister("f97JX", function(module, exports) {

$parcel$export(module.exports, "default", () => $b06db3583fb01044$export$2e2bcd8739ae039);

var $hH3gy = parcelRequire("hH3gy");

var $1UqmS = parcelRequire("1UqmS");

var $74Gsx = parcelRequire("74Gsx");

var $92JQW = parcelRequire("92JQW");

var $a0x9b = parcelRequire("a0x9b");
/**
 * @type {Locale}
 * @category Locales
 * @summary Afrikaans locale.
 * @language Afrikaans
 * @iso-639-2 afr
 * @author Marnus Weststrate [@marnusw]{@link https://github.com/marnusw}
 */ var $b06db3583fb01044$var$locale = {
    code: "af",
    formatDistance: (0, $hH3gy.default),
    formatLong: (0, $1UqmS.default),
    formatRelative: (0, $74Gsx.default),
    localize: (0, $92JQW.default),
    match: (0, $a0x9b.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $b06db3583fb01044$export$2e2bcd8739ae039 = $b06db3583fb01044$var$locale;

});
parcelRegister("hH3gy", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce18fc664d887f81$export$2e2bcd8739ae039);
var $ce18fc664d887f81$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "minder as 'n sekonde",
        other: "minder as {{count}} sekondes"
    },
    xSeconds: {
        one: "1 sekonde",
        other: "{{count}} sekondes"
    },
    halfAMinute: "'n halwe minuut",
    lessThanXMinutes: {
        one: "minder as 'n minuut",
        other: "minder as {{count}} minute"
    },
    xMinutes: {
        one: "'n minuut",
        other: "{{count}} minute"
    },
    aboutXHours: {
        one: "ongeveer 1 uur",
        other: "ongeveer {{count}} ure"
    },
    xHours: {
        one: "1 uur",
        other: "{{count}} ure"
    },
    xDays: {
        one: "1 dag",
        other: "{{count}} dae"
    },
    aboutXWeeks: {
        one: "ongeveer 1 week",
        other: "ongeveer {{count}} weke"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weke"
    },
    aboutXMonths: {
        one: "ongeveer 1 maand",
        other: "ongeveer {{count}} maande"
    },
    xMonths: {
        one: "1 maand",
        other: "{{count}} maande"
    },
    aboutXYears: {
        one: "ongeveer 1 jaar",
        other: "ongeveer {{count}} jaar"
    },
    xYears: {
        one: "1 jaar",
        other: "{{count}} jaar"
    },
    overXYears: {
        one: "meer as 1 jaar",
        other: "meer as {{count}} jaar"
    },
    almostXYears: {
        one: "byna 1 jaar",
        other: "byna {{count}} jaar"
    }
};
var $ce18fc664d887f81$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $ce18fc664d887f81$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "oor " + result;
        else return result + " gelede";
    }
    return result;
};
var $ce18fc664d887f81$export$2e2bcd8739ae039 = $ce18fc664d887f81$var$formatDistance;

});

parcelRegister("1UqmS", function(module, exports) {

$parcel$export(module.exports, "default", () => $163f79907ec11bd1$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $163f79907ec11bd1$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "yyyy/MM/dd"
};
var $163f79907ec11bd1$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $163f79907ec11bd1$var$dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $163f79907ec11bd1$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $163f79907ec11bd1$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $163f79907ec11bd1$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $163f79907ec11bd1$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $163f79907ec11bd1$export$2e2bcd8739ae039 = $163f79907ec11bd1$var$formatLong;

});

parcelRegister("74Gsx", function(module, exports) {

$parcel$export(module.exports, "default", () => $5269d7a180162807$export$2e2bcd8739ae039);
var $5269d7a180162807$var$formatRelativeLocale = {
    lastWeek: "'verlede' eeee 'om' p",
    yesterday: "'gister om' p",
    today: "'vandag om' p",
    tomorrow: "'m\xf4re om' p",
    nextWeek: "eeee 'om' p",
    other: "P"
};
var $5269d7a180162807$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $5269d7a180162807$var$formatRelativeLocale[token];
};
var $5269d7a180162807$export$2e2bcd8739ae039 = $5269d7a180162807$var$formatRelative;

});

parcelRegister("92JQW", function(module, exports) {

$parcel$export(module.exports, "default", () => $6957de6a08f21410$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $6957de6a08f21410$var$eraValues = {
    narrow: [
        "vC",
        "nC"
    ],
    abbreviated: [
        "vC",
        "nC"
    ],
    wide: [
        "voor Christus",
        "na Christus"
    ]
};
var $6957de6a08f21410$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "K1",
        "K2",
        "K3",
        "K4"
    ],
    wide: [
        "1ste kwartaal",
        "2de kwartaal",
        "3de kwartaal",
        "4de kwartaal"
    ]
};
var $6957de6a08f21410$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mrt",
        "Apr",
        "Mei",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Okt",
        "Nov",
        "Des"
    ],
    wide: [
        "Januarie",
        "Februarie",
        "Maart",
        "April",
        "Mei",
        "Junie",
        "Julie",
        "Augustus",
        "September",
        "Oktober",
        "November",
        "Desember"
    ]
};
var $6957de6a08f21410$var$dayValues = {
    narrow: [
        "S",
        "M",
        "D",
        "W",
        "D",
        "V",
        "S"
    ],
    short: [
        "So",
        "Ma",
        "Di",
        "Wo",
        "Do",
        "Vr",
        "Sa"
    ],
    abbreviated: [
        "Son",
        "Maa",
        "Din",
        "Woe",
        "Don",
        "Vry",
        "Sat"
    ],
    wide: [
        "Sondag",
        "Maandag",
        "Dinsdag",
        "Woensdag",
        "Donderdag",
        "Vrydag",
        "Saterdag"
    ]
};
var $6957de6a08f21410$var$dayPeriodValues = {
    narrow: {
        am: "vm",
        pm: "nm",
        midnight: "middernag",
        noon: "middaguur",
        morning: "oggend",
        afternoon: "middag",
        evening: "laat middag",
        night: "aand"
    },
    abbreviated: {
        am: "vm",
        pm: "nm",
        midnight: "middernag",
        noon: "middaguur",
        morning: "oggend",
        afternoon: "middag",
        evening: "laat middag",
        night: "aand"
    },
    wide: {
        am: "vm",
        pm: "nm",
        midnight: "middernag",
        noon: "middaguur",
        morning: "oggend",
        afternoon: "middag",
        evening: "laat middag",
        night: "aand"
    }
};
var $6957de6a08f21410$var$formattingDayPeriodValues = {
    narrow: {
        am: "vm",
        pm: "nm",
        midnight: "middernag",
        noon: "uur die middag",
        morning: "uur die oggend",
        afternoon: "uur die middag",
        evening: "uur die aand",
        night: "uur die aand"
    },
    abbreviated: {
        am: "vm",
        pm: "nm",
        midnight: "middernag",
        noon: "uur die middag",
        morning: "uur die oggend",
        afternoon: "uur die middag",
        evening: "uur die aand",
        night: "uur die aand"
    },
    wide: {
        am: "vm",
        pm: "nm",
        midnight: "middernag",
        noon: "uur die middag",
        morning: "uur die oggend",
        afternoon: "uur die middag",
        evening: "uur die aand",
        night: "uur die aand"
    }
};
var $6957de6a08f21410$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 < 20) switch(rem100){
        case 1:
        case 8:
            return number + "ste";
        default:
            return number + "de";
    }
    return number + "ste";
};
var $6957de6a08f21410$var$localize = {
    ordinalNumber: $6957de6a08f21410$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $6957de6a08f21410$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $6957de6a08f21410$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $6957de6a08f21410$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $6957de6a08f21410$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $6957de6a08f21410$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $6957de6a08f21410$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $6957de6a08f21410$export$2e2bcd8739ae039 = $6957de6a08f21410$var$localize;

});

parcelRegister("a0x9b", function(module, exports) {

$parcel$export(module.exports, "default", () => $74939dcd807618ef$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $74939dcd807618ef$var$matchOrdinalNumberPattern = /^(\d+)(ste|de)?/i;
var $74939dcd807618ef$var$parseOrdinalNumberPattern = /\d+/i;
var $74939dcd807618ef$var$matchEraPatterns = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?C\.?)/,
    wide: /^((voor|na) Christus)/
};
var $74939dcd807618ef$var$parseEraPatterns = {
    any: [
        /^v/,
        /^n/
    ]
};
var $74939dcd807618ef$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234](st|d)e kwartaal/i
};
var $74939dcd807618ef$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $74939dcd807618ef$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(Jan|Feb|Mrt|Apr|Mei|Jun|Jul|Aug|Sep|Okt|Nov|Dec)\.?/i,
    wide: /^(Januarie|Februarie|Maart|April|Mei|Junie|Julie|Augustus|September|Oktober|November|Desember)/i
};
var $74939dcd807618ef$var$parseMonthPatterns = {
    narrow: [
        /^J/i,
        /^F/i,
        /^M/i,
        /^A/i,
        /^M/i,
        /^J/i,
        /^J/i,
        /^A/i,
        /^S/i,
        /^O/i,
        /^N/i,
        /^D/i
    ],
    any: [
        /^Jan/i,
        /^Feb/i,
        /^Mrt/i,
        /^Apr/i,
        /^Mei/i,
        /^Jun/i,
        /^Jul/i,
        /^Aug/i,
        /^Sep/i,
        /^Okt/i,
        /^Nov/i,
        /^Dec/i
    ]
};
var $74939dcd807618ef$var$matchDayPatterns = {
    narrow: /^[smdwv]/i,
    short: /^(So|Ma|Di|Wo|Do|Vr|Sa)/i,
    abbreviated: /^(Son|Maa|Din|Woe|Don|Vry|Sat)/i,
    wide: /^(Sondag|Maandag|Dinsdag|Woensdag|Donderdag|Vrydag|Saterdag)/i
};
var $74939dcd807618ef$var$parseDayPatterns = {
    narrow: [
        /^S/i,
        /^M/i,
        /^D/i,
        /^W/i,
        /^D/i,
        /^V/i,
        /^S/i
    ],
    any: [
        /^So/i,
        /^Ma/i,
        /^Di/i,
        /^Wo/i,
        /^Do/i,
        /^Vr/i,
        /^Sa/i
    ]
};
var $74939dcd807618ef$var$matchDayPeriodPatterns = {
    any: /^(vm|nm|middernag|(?:uur )?die (oggend|middag|aand))/i
};
var $74939dcd807618ef$var$parseDayPeriodPatterns = {
    any: {
        am: /^vm/i,
        pm: /^nm/i,
        midnight: /^middernag/i,
        noon: /^middaguur/i,
        morning: /oggend/i,
        afternoon: /middag/i,
        evening: /laat middag/i,
        night: /aand/i
    }
};
var $74939dcd807618ef$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $74939dcd807618ef$var$matchOrdinalNumberPattern,
        parsePattern: $74939dcd807618ef$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $74939dcd807618ef$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $74939dcd807618ef$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $74939dcd807618ef$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $74939dcd807618ef$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $74939dcd807618ef$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $74939dcd807618ef$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $74939dcd807618ef$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $74939dcd807618ef$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $74939dcd807618ef$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $74939dcd807618ef$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $74939dcd807618ef$export$2e2bcd8739ae039 = $74939dcd807618ef$var$match;

});


parcelRegister("hkKHo", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9e887538ea6d9be$export$2e2bcd8739ae039);

var $58CSL = parcelRequire("58CSL");

var $7ZVeK = parcelRequire("7ZVeK");

var $7wRP5 = parcelRequire("7wRP5");

var $ayHd1 = parcelRequire("ayHd1");

var $i6iIE = parcelRequire("i6iIE");
/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Modern Standard Arabic - Al-fussha).
 * @language Modern Standard Arabic
 * @iso-639-2 ara
 * @author Abdallah Hassan [@AbdallahAHO]{@link https://github.com/AbdallahAHO}
 * @author Koussay Haj Kacem [@essana3]{@link https://github.com/essana3}
 */ var $c9e887538ea6d9be$var$locale = {
    code: "ar",
    formatDistance: (0, $58CSL.default),
    formatLong: (0, $7ZVeK.default),
    formatRelative: (0, $7wRP5.default),
    localize: (0, $ayHd1.default),
    match: (0, $i6iIE.default),
    options: {
        weekStartsOn: 6 /* Saturday */ ,
        firstWeekContainsDate: 1
    }
};
var $c9e887538ea6d9be$export$2e2bcd8739ae039 = $c9e887538ea6d9be$var$locale;

});
parcelRegister("58CSL", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bdbdc5690019aec$export$2e2bcd8739ae039);
var $3bdbdc5690019aec$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u064A\u062A\u0627\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u0627\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u0627\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u0627\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639\u0627 \u062A\u0642\u0631\u064A\u0628\u0627"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u0627\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639\u0627"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627",
        other: "{{count}} \u0634\u0647\u0631\u0627 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u0627\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631\u0627"
    },
    aboutXYears: {
        one: "\u0633\u0646\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0646\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627",
        threeToTen: "{{count}} \u0633\u0646\u0648\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0646\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xYears: {
        one: "\u0633\u0646\u0629 \u0648\u0627\u062D\u062F",
        two: "\u0633\u0646\u062A\u0627\u0646",
        threeToTen: "{{count}} \u0633\u0646\u0648\u0627\u062A",
        other: "{{count}} \u0633\u0646\u0629"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u0629",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u0648\u0627\u062A",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u0629"
    },
    almostXYears: {
        one: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 \u0633\u0646\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 {{count}} \u0633\u0646\u0648\u0627\u062A",
        other: "\u0645\u0627 \u064A\u0642\u0627\u0631\u0628 {{count}} \u0633\u0646\u0629"
    }
};
var $3bdbdc5690019aec$var$formatDistance = function formatDistance(token, count, options) {
    var usageGroup = $3bdbdc5690019aec$var$formatDistanceLocale[token];
    var result;
    if (typeof usageGroup === "string") result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace("{{count}}", String(count));
    else result = usageGroup.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u062E\u0644\u0627\u0644 " + result;
        else return "\u0645\u0646\u0630 " + result;
    }
    return result;
};
var $3bdbdc5690019aec$export$2e2bcd8739ae039 = $3bdbdc5690019aec$var$formatDistance;

});

parcelRegister("7ZVeK", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d2aa0f26c69fd31$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $5d2aa0f26c69fd31$var$dateFormats = {
    full: "EEEE\u060C do MMMM y",
    long: "do MMMM y",
    medium: "d MMM y",
    short: "dd/MM/yyyy"
};
var $5d2aa0f26c69fd31$var$timeFormats = {
    full: "HH:mm:ss",
    long: "HH:mm:ss",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $5d2aa0f26c69fd31$var$dateTimeFormats = {
    full: "{{date}} '\u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
    long: "{{date}} '\u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $5d2aa0f26c69fd31$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $5d2aa0f26c69fd31$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $5d2aa0f26c69fd31$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $5d2aa0f26c69fd31$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $5d2aa0f26c69fd31$export$2e2bcd8739ae039 = $5d2aa0f26c69fd31$var$formatLong;

});

parcelRegister("7wRP5", function(module, exports) {

$parcel$export(module.exports, "default", () => $57b545aa11ec67f9$export$2e2bcd8739ae039);
var $57b545aa11ec67f9$var$formatRelativeLocale = {
    lastWeek: "eeee '\u0627\u0644\u0645\u0627\u0636\u064A \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    yesterday: "'\u0627\u0644\u0623\u0645\u0633 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    tomorrow: "'\u063A\u062F\u0627 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    nextWeek: "eeee '\u0627\u0644\u0642\u0627\u062F\u0645 \u0639\u0646\u062F \u0627\u0644\u0633\u0627\u0639\u0629' p",
    other: "P"
};
var $57b545aa11ec67f9$var$formatRelative = function formatRelative(token) {
    return $57b545aa11ec67f9$var$formatRelativeLocale[token];
};
var $57b545aa11ec67f9$export$2e2bcd8739ae039 = $57b545aa11ec67f9$var$formatRelative;

});

parcelRegister("ayHd1", function(module, exports) {

$parcel$export(module.exports, "default", () => $7afe98c58277087b$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $7afe98c58277087b$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var $7afe98c58277087b$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var $7afe98c58277087b$var$monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u064A",
        "\u064A",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ],
    wide: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
var $7afe98c58277087b$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var $7afe98c58277087b$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    }
};
var $7afe98c58277087b$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0638\u0647\u0631",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0645\u0646\u062A\u0635\u0641 \u0627\u0644\u0644\u064A\u0644"
    }
};
var $7afe98c58277087b$var$ordinalNumber = function ordinalNumber(num) {
    return String(num);
};
var $7afe98c58277087b$var$localize = {
    ordinalNumber: $7afe98c58277087b$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $7afe98c58277087b$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $7afe98c58277087b$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $7afe98c58277087b$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $7afe98c58277087b$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $7afe98c58277087b$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $7afe98c58277087b$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $7afe98c58277087b$export$2e2bcd8739ae039 = $7afe98c58277087b$var$localize;

});

parcelRegister("i6iIE", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2d74ec637d5428a$export$2e2bcd8739ae039);

var $7pOAB = parcelRequire("7pOAB");

var $gKbFl = parcelRequire("gKbFl");
var $d2d74ec637d5428a$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $d2d74ec637d5428a$var$parseOrdinalNumberPattern = /\d+/i;
var $d2d74ec637d5428a$var$matchEraPatterns = {
    narrow: /[قب]/,
    abbreviated: /[قب]\.م\./,
    wide: /(قبل|بعد) الميلاد/
};
var $d2d74ec637d5428a$var$parseEraPatterns = {
    any: [
        /قبل/,
        /بعد/
    ]
};
var $d2d74ec637d5428a$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /ر[1234]/,
    wide: /الربع (الأول|الثاني|الثالث|الرابع)/
};
var $d2d74ec637d5428a$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $d2d74ec637d5428a$var$matchMonthPatterns = {
    narrow: /^[أيفمسند]/,
    abbreviated: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/,
    wide: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
};
var $d2d74ec637d5428a$var$parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ي/i,
        /^ي/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^يناير/i,
        /^فبراير/i,
        /^مارس/i,
        /^أبريل/i,
        /^مايو/i,
        /^يونيو/i,
        /^يوليو/i,
        /^أغسطس/i,
        /^سبتمبر/i,
        /^أكتوبر/i,
        /^نوفمبر/i,
        /^ديسمبر/i
    ]
};
var $d2d74ec637d5428a$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var $d2d74ec637d5428a$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var $d2d74ec637d5428a$var$matchDayPeriodPatterns = {
    narrow: /^(ص|م|منتصف الليل|الظهر|بعد الظهر|في الصباح|في المساء|في الليل)/,
    any: /^(ص|م|منتصف الليل|الظهر|بعد الظهر|في الصباح|في المساء|في الليل)/
};
var $d2d74ec637d5428a$var$parseDayPeriodPatterns = {
    any: {
        am: /^ص/,
        pm: /^م/,
        midnight: /منتصف الليل/,
        noon: /الظهر/,
        afternoon: /بعد الظهر/,
        morning: /في الصباح/,
        evening: /في المساء/,
        night: /في الليل/
    }
};
var $d2d74ec637d5428a$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $d2d74ec637d5428a$var$matchOrdinalNumberPattern,
        parsePattern: $d2d74ec637d5428a$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $d2d74ec637d5428a$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d2d74ec637d5428a$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $d2d74ec637d5428a$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d2d74ec637d5428a$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $d2d74ec637d5428a$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d2d74ec637d5428a$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $d2d74ec637d5428a$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d2d74ec637d5428a$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $d2d74ec637d5428a$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $d2d74ec637d5428a$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $d2d74ec637d5428a$export$2e2bcd8739ae039 = $d2d74ec637d5428a$var$match;

});


parcelRegister("4L4d9", function(module, exports) {

$parcel$export(module.exports, "default", () => $376ed16ebc25b80e$export$2e2bcd8739ae039);

var $hylzV = parcelRequire("hylzV");

var $kIwrL = parcelRequire("kIwrL");

var $cVgJx = parcelRequire("cVgJx");

var $7GgSV = parcelRequire("7GgSV");

var $grSzm = parcelRequire("grSzm");
/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Algerian Arabic).
 * @language Algerian Arabic
 * @iso-639-2 ara
 * @author Badreddine Boumaza [@badre429]{@link https://github.com/badre429}
 * @author Ahmed ElShahat [@elshahat]{@link https://github.com/elshahat}
 */ var $376ed16ebc25b80e$var$locale = {
    code: "ar-DZ",
    formatDistance: (0, $hylzV.default),
    formatLong: (0, $kIwrL.default),
    formatRelative: (0, $cVgJx.default),
    localize: (0, $7GgSV.default),
    match: (0, $grSzm.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $376ed16ebc25b80e$export$2e2bcd8739ae039 = $376ed16ebc25b80e$var$locale;

});
parcelRegister("hylzV", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc7659a7b84591c3$export$2e2bcd8739ae039);
var $cc7659a7b84591c3$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    }
};
var $cc7659a7b84591c3$var$formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    var usageGroup = $cc7659a7b84591c3$var$formatDistanceLocale[token];
    var result;
    if (typeof usageGroup === "string") result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace("{{count}}", String(count));
    else result = usageGroup.other.replace("{{count}}", String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A \u062E\u0644\u0627\u0644 " + result;
        else return "\u0645\u0646\u0630 " + result;
    }
    return result;
};
var $cc7659a7b84591c3$export$2e2bcd8739ae039 = $cc7659a7b84591c3$var$formatDistance;

});

parcelRegister("kIwrL", function(module, exports) {

$parcel$export(module.exports, "default", () => $f15115f607347407$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $f15115f607347407$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $f15115f607347407$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $f15115f607347407$var$dateTimeFormats = {
    full: "{{date}} '\u0639\u0646\u062F' {{time}}",
    long: "{{date}} '\u0639\u0646\u062F' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $f15115f607347407$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $f15115f607347407$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $f15115f607347407$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $f15115f607347407$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $f15115f607347407$export$2e2bcd8739ae039 = $f15115f607347407$var$formatLong;

});

parcelRegister("cVgJx", function(module, exports) {

$parcel$export(module.exports, "default", () => $9687c9cfddd773fa$export$2e2bcd8739ae039);
var $9687c9cfddd773fa$var$formatRelativeLocale = {
    lastWeek: "'\u0623\u062E\u0631' eeee '\u0639\u0646\u062F' p",
    yesterday: "'\u0623\u0645\u0633 \u0639\u0646\u062F' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F' p",
    tomorrow: "'\u063A\u062F\u0627\u064B \u0639\u0646\u062F' p",
    nextWeek: "eeee '\u0639\u0646\u062F' p",
    other: "P"
};
var $9687c9cfddd773fa$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $9687c9cfddd773fa$var$formatRelativeLocale[token];
};
var $9687c9cfddd773fa$export$2e2bcd8739ae039 = $9687c9cfddd773fa$var$formatRelative;

});

parcelRegister("7GgSV", function(module, exports) {

$parcel$export(module.exports, "default", () => $59798da12c88ddb5$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $59798da12c88ddb5$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var $59798da12c88ddb5$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var $59798da12c88ddb5$var$monthValues = {
    narrow: [
        "\u062C",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u062C",
        "\u062C",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u062C\u0627\u0646\u0640",
        "\u0641\u064A\u0641\u0640",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0640",
        "\u062C\u0648\u0627\u0646\u0640",
        "\u062C\u0648\u064A\u0640",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0640",
        "\u0623\u0643\u062A\u0640",
        "\u0646\u0648\u0641\u0640",
        "\u062F\u064A\u0633\u0640"
    ],
    wide: [
        "\u062C\u0627\u0646\u0641\u064A",
        "\u0641\u064A\u0641\u0631\u064A",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u062C\u0648\u0627\u0646",
        "\u062C\u0648\u064A\u0644\u064A\u0629",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
var $59798da12c88ddb5$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u0640",
        "\u062B\u0644\u0627",
        "\u0623\u0631\u0628\u0640",
        "\u062E\u0645\u064A\u0640",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var $59798da12c88ddb5$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    }
};
var $59798da12c88ddb5$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    }
};
var $59798da12c88ddb5$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    return String(dirtyNumber);
};
var $59798da12c88ddb5$var$localize = {
    ordinalNumber: $59798da12c88ddb5$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $59798da12c88ddb5$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $59798da12c88ddb5$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $59798da12c88ddb5$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $59798da12c88ddb5$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $59798da12c88ddb5$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $59798da12c88ddb5$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $59798da12c88ddb5$export$2e2bcd8739ae039 = $59798da12c88ddb5$var$localize;

});

parcelRegister("grSzm", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf997f4dacb8d23c$export$2e2bcd8739ae039);

var $7pOAB = parcelRequire("7pOAB");

var $gKbFl = parcelRequire("gKbFl");
var $bf997f4dacb8d23c$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $bf997f4dacb8d23c$var$parseOrdinalNumberPattern = /\d+/i;
var $bf997f4dacb8d23c$var$matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
    wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
};
var $bf997f4dacb8d23c$var$parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
var $bf997f4dacb8d23c$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ر[1234]/i,
    wide: /^الربع [1234]/i
};
var $bf997f4dacb8d23c$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $bf997f4dacb8d23c$var$matchMonthPatterns = {
    narrow: /^[جفمأسند]/i,
    abbreviated: /^(جان|فيف|مار|أفر|ماي|جوا|جوي|أوت|سبت|أكت|نوف|ديس)/i,
    wide: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/i
};
var $bf997f4dacb8d23c$var$parseMonthPatterns = {
    narrow: [
        /^ج/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ج/i,
        /^ج/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^جان/i,
        /^فيف/i,
        /^مار/i,
        /^أفر/i,
        /^ماي/i,
        /^جوا/i,
        /^جوي/i,
        /^أوت/i,
        /^سبت/i,
        /^أكت/i,
        /^نوف/i,
        /^ديس/i
    ]
};
var $bf997f4dacb8d23c$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var $bf997f4dacb8d23c$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var $bf997f4dacb8d23c$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $bf997f4dacb8d23c$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $bf997f4dacb8d23c$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $bf997f4dacb8d23c$var$matchOrdinalNumberPattern,
        parsePattern: $bf997f4dacb8d23c$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $bf997f4dacb8d23c$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bf997f4dacb8d23c$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $bf997f4dacb8d23c$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bf997f4dacb8d23c$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return Number(index) + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $bf997f4dacb8d23c$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bf997f4dacb8d23c$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $bf997f4dacb8d23c$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bf997f4dacb8d23c$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $bf997f4dacb8d23c$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $bf997f4dacb8d23c$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $bf997f4dacb8d23c$export$2e2bcd8739ae039 = $bf997f4dacb8d23c$var$match;

});


parcelRegister("4cDuC", function(module, exports) {

$parcel$export(module.exports, "default", () => $30f6eae0447c390a$export$2e2bcd8739ae039);

var $9XKg6 = parcelRequire("9XKg6");

var $jVtaO = parcelRequire("jVtaO");

var $8BOQ6 = parcelRequire("8BOQ6");

var $1abVQ = parcelRequire("1abVQ");

var $8mL3D = parcelRequire("8mL3D");
/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Egypt).
 * @language Arabic
 * @iso-639-2 ara
 * @author AbdAllah AbdElFattah [@AbdAllahAbdElFattah13]{@link https://github.com/AbdAllahAbdElFattah13}
 */ var $30f6eae0447c390a$var$locale = {
    code: "ar-EG",
    formatDistance: (0, $9XKg6.default),
    formatLong: (0, $jVtaO.default),
    formatRelative: (0, $8BOQ6.default),
    localize: (0, $1abVQ.default),
    match: (0, $8mL3D.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $30f6eae0447c390a$export$2e2bcd8739ae039 = $30f6eae0447c390a$var$locale;

});
parcelRegister("9XKg6", function(module, exports) {

$parcel$export(module.exports, "default", () => $740d81c17eba162d$export$2e2bcd8739ae039);
var $740d81c17eba162d$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629",
        two: "\u062B\u0627\u0646\u064A\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0633\u0627\u0639\u0629",
        two: "\u062D\u0648\u0627\u0644\u064A \u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0627\u0639\u0629"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0623\u0633\u0628\u0648\u0639",
        two: "\u062D\u0648\u0627\u0644\u064A \u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    aboutXMonths: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0634\u0647\u0631",
        two: "\u062D\u0648\u0627\u0644\u064A \u0634\u0647\u0631\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0623\u0634\u0647\u0631",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0634\u0647\u0631"
    },
    xMonths: {
        one: "\u0634\u0647\u0631",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u062D\u0648\u0627\u0644\u064A \u0633\u0646\u0629",
        two: "\u062D\u0648\u0627\u0644\u064A \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0646\u064A\u0646",
        other: "\u062D\u0648\u0627\u0644\u064A {{count}} \u0633\u0646\u0629"
    },
    xYears: {
        one: "\u0639\u0627\u0645",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u0629",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0633\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u064A\u0646",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0633\u0646\u0629"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u064B\u0627",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u064B\u0627",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u064B\u0627",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u064B\u0627"
    }
};
var $740d81c17eba162d$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $740d81c17eba162d$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2) result = tokenValue.two;
    else if (count <= 10) result = tokenValue.threeToTen.replace("{{count}}", String(count));
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A \u062E\u0644\u0627\u0644 ".concat(result);
        else return "\u0645\u0646\u0630 ".concat(result);
    }
    return result;
};
var $740d81c17eba162d$export$2e2bcd8739ae039 = $740d81c17eba162d$var$formatDistance;

});

parcelRegister("jVtaO", function(module, exports) {

$parcel$export(module.exports, "default", () => $e819f8701b6d01b0$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $e819f8701b6d01b0$var$dateFormats = {
    full: "EEEE\u060C do MMMM y",
    long: "do MMMM y",
    medium: "dd/MMM/y",
    short: "d/MM/y"
};
var $e819f8701b6d01b0$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $e819f8701b6d01b0$var$dateTimeFormats = {
    full: "{{date}} '\u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
    long: "{{date}} '\u0627\u0644\u0633\u0627\u0639\u0629' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $e819f8701b6d01b0$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $e819f8701b6d01b0$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $e819f8701b6d01b0$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $e819f8701b6d01b0$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $e819f8701b6d01b0$export$2e2bcd8739ae039 = $e819f8701b6d01b0$var$formatLong;

});

parcelRegister("8BOQ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $6449370c86c55a6e$export$2e2bcd8739ae039);
var $6449370c86c55a6e$var$formatRelativeLocale = {
    lastWeek: "eeee '\u0627\u0644\u0644\u064A \u062C\u0627\u064A \u0627\u0644\u0633\u0627\u0639\u0629' p",
    yesterday: "'\u0625\u0645\u0628\u0627\u0631\u062D \u0627\u0644\u0633\u0627\u0639\u0629' p",
    today: "'\u0627\u0644\u0646\u0647\u0627\u0631\u062F\u0629 \u0627\u0644\u0633\u0627\u0639\u0629' p",
    tomorrow: "'\u0628\u0643\u0631\u0629 \u0627\u0644\u0633\u0627\u0639\u0629' p",
    nextWeek: "eeee '\u0627\u0644\u0633\u0627\u0639\u0629' p",
    other: "P"
};
var $6449370c86c55a6e$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $6449370c86c55a6e$var$formatRelativeLocale[token];
};
var $6449370c86c55a6e$export$2e2bcd8739ae039 = $6449370c86c55a6e$var$formatRelative;

});

parcelRegister("1abVQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d8ffb0f007600e6$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $0d8ffb0f007600e6$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645",
        "\u0628.\u0645"
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var $0d8ffb0f007600e6$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var $0d8ffb0f007600e6$var$monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u064A",
        "\u064A",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0646\u0627",
        "\u0641\u0628\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u0640",
        "\u064A\u0648\u0644\u0640",
        "\u0623\u063A\u0633\u0640",
        "\u0633\u0628\u062A\u0640",
        "\u0623\u0643\u062A\u0640",
        "\u0646\u0648\u0641\u0640",
        "\u062F\u064A\u0633\u0640"
    ],
    wide: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
var $0d8ffb0f007600e6$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var $0d8ffb0f007600e6$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    }
};
var $0d8ffb0f007600e6$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0638\u0647\u0631\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    }
};
var $0d8ffb0f007600e6$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $0d8ffb0f007600e6$var$localize = {
    ordinalNumber: $0d8ffb0f007600e6$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $0d8ffb0f007600e6$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $0d8ffb0f007600e6$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $0d8ffb0f007600e6$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $0d8ffb0f007600e6$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $0d8ffb0f007600e6$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $0d8ffb0f007600e6$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $0d8ffb0f007600e6$export$2e2bcd8739ae039 = $0d8ffb0f007600e6$var$localize;

});

parcelRegister("8mL3D", function(module, exports) {

$parcel$export(module.exports, "default", () => $6174e17e6d7e6e34$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $6174e17e6d7e6e34$var$matchOrdinalNumberPattern = /^(\d+)/;
var $6174e17e6d7e6e34$var$parseOrdinalNumberPattern = /\d+/i;
var $6174e17e6d7e6e34$var$matchEraPatterns = {
    narrow: /^(ق|ب)/g,
    abbreviated: /^(ق.م|ب.م)/g,
    wide: /^(قبل الميلاد|بعد الميلاد)/g
};
var $6174e17e6d7e6e34$var$parseEraPatterns = {
    any: [
        /^ق/g,
        /^ب/g
    ]
};
var $6174e17e6d7e6e34$var$matchQuarterPatterns = {
    narrow: /^[1234]/,
    abbreviated: /^ر[1234]/,
    wide: /^الربع (الأول|الثاني|الثالث|الرابع)/
};
var $6174e17e6d7e6e34$var$parseQuarterPatterns = {
    wide: [
        /الربع الأول/,
        /الربع الثاني/,
        /الربع الثالث/,
        /الربع الرابع/
    ],
    any: [
        /1/,
        /2/,
        /3/,
        /4/
    ]
};
var $6174e17e6d7e6e34$var$matchMonthPatterns = {
    narrow: /^(ي|ف|م|أ|س|ن|د)/,
    abbreviated: /^(ينا|فبر|مارس|أبريل|مايو|يونـ|يولـ|أغسـ|سبتـ|أكتـ|نوفـ|ديسـ)/,
    wide: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
};
var $6174e17e6d7e6e34$var$parseMonthPatterns = {
    narrow: [
        /^ي/,
        /^ف/,
        /^م/,
        /^أ/,
        /^م/,
        /^ي/,
        /^ي/,
        /^أ/,
        /^س/,
        /^أ/,
        /^ن/,
        /^د/
    ],
    any: [
        /^ينا/,
        /^فبر/,
        /^مارس/,
        /^أبريل/,
        /^مايو/,
        /^يون/,
        /^يول/,
        /^أغس/,
        /^سبت/,
        /^أكت/,
        /^نوف/,
        /^ديس/
    ]
};
var $6174e17e6d7e6e34$var$matchDayPatterns = {
    narrow: /^(ح|ن|ث|ر|خ|ج|س)/,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/,
    abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/
};
var $6174e17e6d7e6e34$var$parseDayPatterns = {
    narrow: [
        /^ح/,
        /^ن/,
        /^ث/,
        /^ر/,
        /^خ/,
        /^ج/,
        /^س/
    ],
    any: [
        /أحد/,
        /اثنين/,
        /ثلاثاء/,
        /أربعاء/,
        /خميس/,
        /جمعة/,
        /سبت/
    ]
};
var $6174e17e6d7e6e34$var$matchDayPeriodPatterns = {
    narrow: /^(ص|م|ن|ظ|في الصباح|بعد الظهر|في المساء|في الليل)/,
    abbreviated: /^(ص|م|نصف الليل|ظهراً|في الصباح|بعد الظهر|في المساء|في الليل)/,
    wide: /^(ص|م|نصف الليل|في الصباح|ظهراً|بعد الظهر|في المساء|في الليل)/,
    any: /^(ص|م|صباح|ظهر|مساء|ليل)/
};
var $6174e17e6d7e6e34$var$parseDayPeriodPatterns = {
    any: {
        am: /^ص/,
        pm: /^م/,
        midnight: /^ن/,
        noon: /^ظ/,
        morning: /^ص/,
        afternoon: /^بعد/,
        evening: /^م/,
        night: /^ل/
    }
};
var $6174e17e6d7e6e34$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $6174e17e6d7e6e34$var$matchOrdinalNumberPattern,
        parsePattern: $6174e17e6d7e6e34$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $6174e17e6d7e6e34$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6174e17e6d7e6e34$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $6174e17e6d7e6e34$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6174e17e6d7e6e34$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $6174e17e6d7e6e34$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6174e17e6d7e6e34$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $6174e17e6d7e6e34$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6174e17e6d7e6e34$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $6174e17e6d7e6e34$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $6174e17e6d7e6e34$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $6174e17e6d7e6e34$export$2e2bcd8739ae039 = $6174e17e6d7e6e34$var$match;

});


parcelRegister("hKWGy", function(module, exports) {

$parcel$export(module.exports, "default", () => $ced44139de8ba77b$export$2e2bcd8739ae039);

var $b4OQ9 = parcelRequire("b4OQ9");

var $3SFuJ = parcelRequire("3SFuJ");

var $gwhjZ = parcelRequire("gwhjZ");

var $4I6F8 = parcelRequire("4I6F8");

var $hzoTn = parcelRequire("hzoTn");
/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Moroccan Arabic).
 * @language Moroccan Arabic
 * @iso-639-2 ara
 * @author Achraf Rrami [@rramiachraf]{@link https://github.com/rramiachraf}
 */ var $ced44139de8ba77b$var$locale = {
    code: "ar-MA",
    formatDistance: (0, $b4OQ9.default),
    formatLong: (0, $3SFuJ.default),
    formatRelative: (0, $gwhjZ.default),
    localize: (0, $4I6F8.default),
    match: (0, $hzoTn.default),
    options: {
        // Monday is 1
        weekStartsOn: 1,
        firstWeekContainsDate: 1
    }
};
var $ced44139de8ba77b$export$2e2bcd8739ae039 = $ced44139de8ba77b$var$locale;

});
parcelRegister("b4OQ9", function(module, exports) {

$parcel$export(module.exports, "default", () => $8107813fc7a598f5$export$2e2bcd8739ae039);
var $8107813fc7a598f5$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    }
};
var $8107813fc7a598f5$var$formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    var usageGroup = $8107813fc7a598f5$var$formatDistanceLocale[token];
    var result;
    if (typeof usageGroup === "string") result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace("{{count}}", String(count));
    else result = usageGroup.other.replace("{{count}}", String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A \u062E\u0644\u0627\u0644 " + result;
        else return "\u0645\u0646\u0630 " + result;
    }
    return result;
};
var $8107813fc7a598f5$export$2e2bcd8739ae039 = $8107813fc7a598f5$var$formatDistance;

});

parcelRegister("3SFuJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d369a33c9fb2147$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $2d369a33c9fb2147$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $2d369a33c9fb2147$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $2d369a33c9fb2147$var$dateTimeFormats = {
    full: "{{date}} '\u0639\u0646\u062F' {{time}}",
    long: "{{date}} '\u0639\u0646\u062F' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $2d369a33c9fb2147$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $2d369a33c9fb2147$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $2d369a33c9fb2147$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $2d369a33c9fb2147$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $2d369a33c9fb2147$export$2e2bcd8739ae039 = $2d369a33c9fb2147$var$formatLong;

});

parcelRegister("gwhjZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c06d1226f799288a$export$2e2bcd8739ae039);
var $c06d1226f799288a$var$formatRelativeLocale = {
    lastWeek: "'\u0623\u062E\u0631' eeee '\u0639\u0646\u062F' p",
    yesterday: "'\u0623\u0645\u0633 \u0639\u0646\u062F' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F' p",
    tomorrow: "'\u063A\u062F\u0627\u064B \u0639\u0646\u062F' p",
    nextWeek: "eeee '\u0639\u0646\u062F' p",
    other: "P"
};
var $c06d1226f799288a$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $c06d1226f799288a$var$formatRelativeLocale[token];
};
var $c06d1226f799288a$export$2e2bcd8739ae039 = $c06d1226f799288a$var$formatRelative;

});

parcelRegister("4I6F8", function(module, exports) {

$parcel$export(module.exports, "default", () => $36e07084ea6db2ad$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $36e07084ea6db2ad$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var $36e07084ea6db2ad$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var $36e07084ea6db2ad$var$monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u064A",
        "\u064A",
        "\u063A",
        "\u0634",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0646\u0627",
        "\u0641\u0628\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u064A\u0648\u0646\u0640",
        "\u064A\u0648\u0644\u0640",
        "\u063A\u0634\u062A",
        "\u0634\u062A\u0646\u0640",
        "\u0623\u0643\u062A\u0640",
        "\u0646\u0648\u0646\u0640",
        "\u062F\u062C\u0646\u0640"
    ],
    wide: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648\u0632",
        "\u063A\u0634\u062A",
        "\u0634\u062A\u0646\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0646\u0628\u0631",
        "\u062F\u062C\u0646\u0628\u0631"
    ]
};
var $36e07084ea6db2ad$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u0640",
        "\u062B\u0644\u0627",
        "\u0623\u0631\u0628\u0640",
        "\u062E\u0645\u064A\u0640",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0625\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var $36e07084ea6db2ad$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    }
};
var $36e07084ea6db2ad$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    }
};
var $36e07084ea6db2ad$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    return String(dirtyNumber);
};
var $36e07084ea6db2ad$var$localize = {
    ordinalNumber: $36e07084ea6db2ad$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $36e07084ea6db2ad$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $36e07084ea6db2ad$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $36e07084ea6db2ad$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $36e07084ea6db2ad$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $36e07084ea6db2ad$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $36e07084ea6db2ad$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $36e07084ea6db2ad$export$2e2bcd8739ae039 = $36e07084ea6db2ad$var$localize;

});

parcelRegister("hzoTn", function(module, exports) {

$parcel$export(module.exports, "default", () => $cca9039e2349716b$export$2e2bcd8739ae039);

var $7pOAB = parcelRequire("7pOAB");

var $gKbFl = parcelRequire("gKbFl");
var $cca9039e2349716b$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $cca9039e2349716b$var$parseOrdinalNumberPattern = /\d+/i;
var $cca9039e2349716b$var$matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
    wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
};
var $cca9039e2349716b$var$parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
var $cca9039e2349716b$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ر[1234]/i,
    wide: /^الربع [1234]/i
};
var $cca9039e2349716b$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $cca9039e2349716b$var$matchMonthPatterns = {
    narrow: /^[يفمأمسند]/i,
    abbreviated: /^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i,
    wide: /^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i
};
var $cca9039e2349716b$var$parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ي/i,
        /^ي/i,
        /^غ/i,
        /^ش/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^ين/i,
        /^فب/i,
        /^مار/i,
        /^أب/i,
        /^ماي/i,
        /^يون/i,
        /^يول/i,
        /^غشت/i,
        /^ش/i,
        /^أك/i,
        /^ن/i,
        /^د/i
    ]
};
var $cca9039e2349716b$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|إثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|إثن|ثلا|أرب|خمي|جمعة|سبت)/i,
    wide: /^(الأحد|الإثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var $cca9039e2349716b$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الإثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^إث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var $cca9039e2349716b$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $cca9039e2349716b$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $cca9039e2349716b$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $cca9039e2349716b$var$matchOrdinalNumberPattern,
        parsePattern: $cca9039e2349716b$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $cca9039e2349716b$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cca9039e2349716b$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $cca9039e2349716b$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cca9039e2349716b$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return Number(index) + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $cca9039e2349716b$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cca9039e2349716b$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $cca9039e2349716b$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cca9039e2349716b$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $cca9039e2349716b$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $cca9039e2349716b$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $cca9039e2349716b$export$2e2bcd8739ae039 = $cca9039e2349716b$var$match;

});


parcelRegister("46td8", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fce619de816ada5$export$2e2bcd8739ae039);

var $h8NWn = parcelRequire("h8NWn");

var $grEX8 = parcelRequire("grEX8");

var $fYYQ1 = parcelRequire("fYYQ1");

var $jlFoh = parcelRequire("jlFoh");

var $gdSCD = parcelRequire("gdSCD");
/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Sauid Arabic).
 * @language Arabic
 * @iso-639-2 ara
 * @author Dhaifallah Alwadani [@dalwadani]{@link https://github.com/dalwadani}
 */ var $2fce619de816ada5$var$locale = {
    code: "ar-SA",
    formatDistance: (0, $h8NWn.default),
    formatLong: (0, $grEX8.default),
    formatRelative: (0, $fYYQ1.default),
    localize: (0, $jlFoh.default),
    match: (0, $gdSCD.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $2fce619de816ada5$export$2e2bcd8739ae039 = $2fce619de816ada5$var$locale;

});
parcelRegister("h8NWn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7a9ec2d85b56b82$export$2e2bcd8739ae039);
var $c7a9ec2d85b56b82$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062B\u0627\u0646\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635\u0641 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u0626\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629 \u0648\u0627\u062D\u062F\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0627\u0639\u0627\u062A",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u064A\u0648\u0645 \u0648\u0627\u062D\u062F",
        two: "\u064A\u0648\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xWeeks: {
        one: "\u0623\u0633\u0628\u0648\u0639 \u0648\u0627\u062D\u062F",
        two: "\u0623\u0633\u0628\u0648\u0639\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0633\u0627\u0628\u064A\u0639",
        other: "{{count}} \u0623\u0633\u0628\u0648\u0639"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xMonths: {
        one: "\u0634\u0647\u0631 \u0648\u0627\u062D\u062F",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    },
    xYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u0648\u0627\u062D\u062F \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628\u0627\u064B"
    }
};
var $c7a9ec2d85b56b82$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $c7a9ec2d85b56b82$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2) result = tokenValue.two;
    else if (count <= 10) result = tokenValue.threeToTen.replace("{{count}}", String(count));
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A \u062E\u0644\u0627\u0644 " + result;
        else return "\u0645\u0646\u0630 " + result;
    }
    return result;
};
var $c7a9ec2d85b56b82$export$2e2bcd8739ae039 = $c7a9ec2d85b56b82$var$formatDistance;

});

parcelRegister("grEX8", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf8eef4de1a4ac7b$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $bf8eef4de1a4ac7b$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $bf8eef4de1a4ac7b$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $bf8eef4de1a4ac7b$var$dateTimeFormats = {
    full: "{{date}} '\u0639\u0646\u062F' {{time}}",
    long: "{{date}} '\u0639\u0646\u062F' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $bf8eef4de1a4ac7b$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $bf8eef4de1a4ac7b$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $bf8eef4de1a4ac7b$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $bf8eef4de1a4ac7b$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $bf8eef4de1a4ac7b$export$2e2bcd8739ae039 = $bf8eef4de1a4ac7b$var$formatLong;

});

parcelRegister("fYYQ1", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba2ba6c6c5af54a1$export$2e2bcd8739ae039);
var $ba2ba6c6c5af54a1$var$formatRelativeLocale = {
    lastWeek: "'\u0623\u062E\u0631' eeee '\u0639\u0646\u062F' p",
    yesterday: "'\u0623\u0645\u0633 \u0639\u0646\u062F' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0639\u0646\u062F' p",
    tomorrow: "'\u063A\u062F\u0627\u064B \u0639\u0646\u062F' p",
    nextWeek: "eeee '\u0639\u0646\u062F' p",
    other: "P"
};
var $ba2ba6c6c5af54a1$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $ba2ba6c6c5af54a1$var$formatRelativeLocale[token];
};
var $ba2ba6c6c5af54a1$export$2e2bcd8739ae039 = $ba2ba6c6c5af54a1$var$formatRelative;

});

parcelRegister("jlFoh", function(module, exports) {

$parcel$export(module.exports, "default", () => $e16015cb507ab245$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $e16015cb507ab245$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var $e16015cb507ab245$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var $e16015cb507ab245$var$monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u064A",
        "\u064A",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0646\u0627",
        "\u0641\u0628\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u0640",
        "\u064A\u0648\u0644\u0640",
        "\u0623\u063A\u0633\u0640",
        "\u0633\u0628\u062A\u0640",
        "\u0623\u0643\u062A\u0640",
        "\u0646\u0648\u0641\u0640",
        "\u062F\u064A\u0633\u0640"
    ],
    wide: [
        "\u064A\u0646\u0627\u064A\u0631",
        "\u0641\u0628\u0631\u0627\u064A\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0628\u0631\u064A\u0644",
        "\u0645\u0627\u064A\u0648",
        "\u064A\u0648\u0646\u064A\u0648",
        "\u064A\u0648\u0644\u064A\u0648",
        "\u0623\u063A\u0633\u0637\u0633",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
var $e16015cb507ab245$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u0640",
        "\u062B\u0644\u0627",
        "\u0623\u0631\u0628\u0640",
        "\u062E\u0645\u064A\u0640",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var $e16015cb507ab245$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0645\u0633\u0627\u0621\u0627\u064B",
        night: "\u0644\u064A\u0644\u0627\u064B"
    }
};
var $e16015cb507ab245$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0645",
        midnight: "\u0646\u0635\u0641 \u0627\u0644\u0644\u064A\u0644",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u0627\u062D\u0627\u064B",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0638\u0640\u0647\u0631",
        evening: "\u0641\u064A \u0627\u0644\u0645\u0633\u0627\u0621",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644"
    }
};
var $e16015cb507ab245$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    return String(dirtyNumber);
};
var $e16015cb507ab245$var$localize = {
    ordinalNumber: $e16015cb507ab245$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $e16015cb507ab245$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $e16015cb507ab245$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $e16015cb507ab245$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $e16015cb507ab245$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $e16015cb507ab245$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $e16015cb507ab245$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $e16015cb507ab245$export$2e2bcd8739ae039 = $e16015cb507ab245$var$localize;

});

parcelRegister("gdSCD", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcf83b1234b34859$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $bcf83b1234b34859$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $bcf83b1234b34859$var$parseOrdinalNumberPattern = /\d+/i;
var $bcf83b1234b34859$var$matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
    wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
};
var $bcf83b1234b34859$var$parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
var $bcf83b1234b34859$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ر[1234]/i,
    wide: /^الربع [1234]/i
};
var $bcf83b1234b34859$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $bcf83b1234b34859$var$matchMonthPatterns = {
    narrow: /^[يفمأمسند]/i,
    abbreviated: /^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i,
    wide: /^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i
};
var $bcf83b1234b34859$var$parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ي/i,
        /^ي/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^ين/i,
        /^ف/i,
        /^مار/i,
        /^أب/i,
        /^ماي/i,
        /^يون/i,
        /^يول/i,
        /^أغ/i,
        /^س/i,
        /^أك/i,
        /^ن/i,
        /^د/i
    ]
};
var $bcf83b1234b34859$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var $bcf83b1234b34859$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var $bcf83b1234b34859$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $bcf83b1234b34859$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $bcf83b1234b34859$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $bcf83b1234b34859$var$matchOrdinalNumberPattern,
        parsePattern: $bcf83b1234b34859$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $bcf83b1234b34859$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bcf83b1234b34859$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $bcf83b1234b34859$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bcf83b1234b34859$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $bcf83b1234b34859$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bcf83b1234b34859$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $bcf83b1234b34859$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bcf83b1234b34859$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $bcf83b1234b34859$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $bcf83b1234b34859$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $bcf83b1234b34859$export$2e2bcd8739ae039 = $bcf83b1234b34859$var$match;

});


parcelRegister("blcre", function(module, exports) {

$parcel$export(module.exports, "default", () => $841b4dd53c3fab28$export$2e2bcd8739ae039);

var $2BCOB = parcelRequire("2BCOB");

var $28SOE = parcelRequire("28SOE");

var $3sV7j = parcelRequire("3sV7j");

var $dCbiF = parcelRequire("dCbiF");

var $capnq = parcelRequire("capnq");
/**
 * @type {Locale}
 * @category Locales
 * @summary Arabic locale (Tunisian Arabic).
 * @language Arabic
 * @iso-639-2 ara
 * @author Koussay Haj Kacem [@essana3]{@link https://github.com/essana3}
 */ var $841b4dd53c3fab28$var$locale = {
    code: "ar-TN",
    formatDistance: (0, $2BCOB.default),
    formatLong: (0, $28SOE.default),
    formatRelative: (0, $3sV7j.default),
    localize: (0, $dCbiF.default),
    match: (0, $capnq.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $841b4dd53c3fab28$export$2e2bcd8739ae039 = $841b4dd53c3fab28$var$locale;

});
parcelRegister("2BCOB", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e5d25603f36bcfa$export$2e2bcd8739ae039);
var $1e5d25603f36bcfa$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062B\u0627\u0646\u064A\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u0632\u0648\u0632 \u062B\u0648\u0627\u0646\u064A",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    xSeconds: {
        one: "\u062B\u0627\u0646\u064A\u0629",
        two: "\u0632\u0648\u0632 \u062B\u0648\u0627\u0646\u064A",
        threeToTen: "{{count}} \u062B\u0648\u0627\u0646\u064A",
        other: "{{count}} \u062B\u0627\u0646\u064A\u0629"
    },
    halfAMinute: "\u0646\u0635 \u062F\u0642\u064A\u0642\u0629",
    lessThanXMinutes: {
        one: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u0629",
        two: "\u0623\u0642\u0644 \u0645\u0646 \u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "\u0623\u0642\u0644 \u0645\u0646 {{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    xMinutes: {
        one: "\u062F\u0642\u064A\u0642\u0629",
        two: "\u062F\u0642\u064A\u0642\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062F\u0642\u0627\u064A\u0642",
        other: "{{count}} \u062F\u0642\u064A\u0642\u0629"
    },
    aboutXHours: {
        one: "\u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0633\u0648\u0627\u064A\u0639 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0633\u0627\u0639\u0629 \u062A\u0642\u0631\u064A\u0628"
    },
    xHours: {
        one: "\u0633\u0627\u0639\u0629",
        two: "\u0633\u0627\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u0633\u0648\u0627\u064A\u0639",
        other: "{{count}} \u0633\u0627\u0639\u0629"
    },
    xDays: {
        one: "\u0646\u0647\u0627\u0631",
        two: "\u0646\u0647\u0627\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u064A\u0627\u0645",
        other: "{{count}} \u064A\u0648\u0645"
    },
    aboutXWeeks: {
        one: "\u062C\u0645\u0639\u0629 \u062A\u0642\u0631\u064A\u0628",
        two: "\u062C\u0645\u0639\u062A\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u062C\u0645\u0627\u0639 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u062C\u0645\u0639\u0629 \u062A\u0642\u0631\u064A\u0628"
    },
    xWeeks: {
        one: "\u062C\u0645\u0639\u0629",
        two: "\u062C\u0645\u0639\u062A\u064A\u0646",
        threeToTen: "{{count}} \u062C\u0645\u0627\u0639",
        other: "{{count}} \u062C\u0645\u0639\u0629"
    },
    aboutXMonths: {
        one: "\u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0634\u0647\u0631\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631\u0629 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0634\u0647\u0631 \u062A\u0642\u0631\u064A\u0628"
    },
    xMonths: {
        one: "\u0634\u0647\u0631",
        two: "\u0634\u0647\u0631\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0634\u0647\u0631\u0629",
        other: "{{count}} \u0634\u0647\u0631"
    },
    aboutXYears: {
        one: "\u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628"
    },
    xYears: {
        one: "\u0639\u0627\u0645",
        two: "\u0639\u0627\u0645\u064A\u0646",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "{{count}} \u0639\u0627\u0645"
    },
    overXYears: {
        one: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645",
        two: "\u0623\u0643\u062B\u0631 \u0645\u0646 \u0639\u0627\u0645\u064A\u0646",
        threeToTen: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0623\u0639\u0648\u0627\u0645",
        other: "\u0623\u0643\u062B\u0631 \u0645\u0646 {{count}} \u0639\u0627\u0645"
    },
    almostXYears: {
        one: "\u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        two: "\u0639\u0627\u0645\u064A\u0646 \u062A\u0642\u0631\u064A\u0628",
        threeToTen: "{{count}} \u0623\u0639\u0648\u0627\u0645 \u062A\u0642\u0631\u064A\u0628",
        other: "{{count}} \u0639\u0627\u0645 \u062A\u0642\u0631\u064A\u0628"
    }
};
var $1e5d25603f36bcfa$var$formatDistance = function formatDistance(token, count, options) {
    var usageGroup = $1e5d25603f36bcfa$var$formatDistanceLocale[token];
    var result;
    if (typeof usageGroup === "string") result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else if (count === 2) result = usageGroup.two;
    else if (count <= 10) result = usageGroup.threeToTen.replace("{{count}}", String(count));
    else result = usageGroup.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0641\u064A " + result;
        else return "\u0639\u0646\u062F\u0648 " + result;
    }
    return result;
};
var $1e5d25603f36bcfa$export$2e2bcd8739ae039 = $1e5d25603f36bcfa$var$formatDistance;

});

parcelRegister("28SOE", function(module, exports) {

$parcel$export(module.exports, "default", () => $18f6d96da5bac8f8$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $18f6d96da5bac8f8$var$dateFormats = {
    full: "EEEE\u060C do MMMM y",
    long: "do MMMM y",
    medium: "d MMM y",
    short: "dd/MM/yyyy"
};
var $18f6d96da5bac8f8$var$timeFormats = {
    full: "HH:mm:ss",
    long: "HH:mm:ss",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $18f6d96da5bac8f8$var$dateTimeFormats = {
    full: "{{date}} '\u0645\u0639' {{time}}",
    long: "{{date}} '\u0645\u0639' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $18f6d96da5bac8f8$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $18f6d96da5bac8f8$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $18f6d96da5bac8f8$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $18f6d96da5bac8f8$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $18f6d96da5bac8f8$export$2e2bcd8739ae039 = $18f6d96da5bac8f8$var$formatLong;

});

parcelRegister("3sV7j", function(module, exports) {

$parcel$export(module.exports, "default", () => $28604ae142560d79$export$2e2bcd8739ae039);
var $28604ae142560d79$var$formatRelativeLocale = {
    lastWeek: "eeee '\u0625\u0644\u064A \u0641\u0627\u062A \u0645\u0639' p",
    yesterday: "'\u0627\u0644\u0628\u0627\u0631\u062D \u0645\u0639' p",
    today: "'\u0627\u0644\u064A\u0648\u0645 \u0645\u0639' p",
    tomorrow: "'\u063A\u062F\u0648\u0629 \u0645\u0639' p",
    nextWeek: "eeee '\u0627\u0644\u062C\u0645\u0639\u0629 \u0627\u0644\u062C\u0627\u064A\u0629 \u0645\u0639' p '\u0646\u0647\u0627\u0631'",
    other: "P"
};
var $28604ae142560d79$var$formatRelative = function formatRelative(token) {
    return $28604ae142560d79$var$formatRelativeLocale[token];
};
var $28604ae142560d79$export$2e2bcd8739ae039 = $28604ae142560d79$var$formatRelative;

});

parcelRegister("dCbiF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e9796ee88e2e9f3$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $9e9796ee88e2e9f3$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0644\u0645\u064A\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0644\u0645\u064A\u0644\u0627\u062F"
    ]
};
var $9e9796ee88e2e9f3$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u06311",
        "\u06312",
        "\u06313",
        "\u06314"
    ],
    wide: [
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0623\u0648\u0644",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0646\u064A",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u062B\u0627\u0644\u062B",
        "\u0627\u0644\u0631\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0639"
    ]
};
var $9e9796ee88e2e9f3$var$monthValues = {
    narrow: [
        "\u062F",
        "\u0646",
        "\u0623",
        "\u0633",
        "\u0623",
        "\u062C",
        "\u062C",
        "\u0645",
        "\u0623",
        "\u0645",
        "\u0641",
        "\u062C"
    ],
    abbreviated: [
        "\u062C\u0627\u0646\u0641\u064A",
        "\u0641\u064A\u0641\u0631\u064A",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u062C\u0648\u0627\u0646",
        "\u062C\u0648\u064A\u0644\u064A\u0629",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ],
    wide: [
        "\u062C\u0627\u0646\u0641\u064A",
        "\u0641\u064A\u0641\u0631\u064A",
        "\u0645\u0627\u0631\u0633",
        "\u0623\u0641\u0631\u064A\u0644",
        "\u0645\u0627\u064A",
        "\u062C\u0648\u0627\u0646",
        "\u062C\u0648\u064A\u0644\u064A\u0629",
        "\u0623\u0648\u062A",
        "\u0633\u0628\u062A\u0645\u0628\u0631",
        "\u0623\u0643\u062A\u0648\u0628\u0631",
        "\u0646\u0648\u0641\u0645\u0628\u0631",
        "\u062F\u064A\u0633\u0645\u0628\u0631"
    ]
};
var $9e9796ee88e2e9f3$var$dayValues = {
    narrow: [
        "\u062D",
        "\u0646",
        "\u062B",
        "\u0631",
        "\u062E",
        "\u062C",
        "\u0633"
    ],
    short: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    abbreviated: [
        "\u0623\u062D\u062F",
        "\u0627\u062B\u0646\u064A\u0646",
        "\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u062E\u0645\u064A\u0633",
        "\u062C\u0645\u0639\u0629",
        "\u0633\u0628\u062A"
    ],
    wide: [
        "\u0627\u0644\u0623\u062D\u062F",
        "\u0627\u0644\u0627\u062B\u0646\u064A\u0646",
        "\u0627\u0644\u062B\u0644\u0627\u062B\u0627\u0621",
        "\u0627\u0644\u0623\u0631\u0628\u0639\u0627\u0621",
        "\u0627\u0644\u062E\u0645\u064A\u0633",
        "\u0627\u0644\u062C\u0645\u0639\u0629",
        "\u0627\u0644\u0633\u0628\u062A"
    ]
};
var $9e9796ee88e2e9f3$var$dayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    }
};
var $9e9796ee88e2e9f3$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0641\u064A \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0641\u064A \u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    },
    abbreviated: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0641\u064A \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0641\u064A \u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    },
    wide: {
        am: "\u0635",
        pm: "\u0639",
        morning: "\u0641\u064A \u0627\u0644\u0635\u0628\u0627\u062D",
        noon: "\u0641\u064A \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        afternoon: "\u0628\u0639\u062F \u0627\u0644\u0642\u0627\u064A\u0644\u0629",
        evening: "\u0641\u064A \u0627\u0644\u0639\u0634\u064A\u0629",
        night: "\u0641\u064A \u0627\u0644\u0644\u064A\u0644",
        midnight: "\u0646\u0635 \u0627\u0644\u0644\u064A\u0644"
    }
};
var $9e9796ee88e2e9f3$var$ordinalNumber = function ordinalNumber(num) {
    return String(num);
};
var $9e9796ee88e2e9f3$var$localize = {
    ordinalNumber: $9e9796ee88e2e9f3$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $9e9796ee88e2e9f3$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $9e9796ee88e2e9f3$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $9e9796ee88e2e9f3$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $9e9796ee88e2e9f3$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $9e9796ee88e2e9f3$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $9e9796ee88e2e9f3$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $9e9796ee88e2e9f3$export$2e2bcd8739ae039 = $9e9796ee88e2e9f3$var$localize;

});

parcelRegister("capnq", function(module, exports) {

$parcel$export(module.exports, "default", () => $8dba1a82466d9ea4$export$2e2bcd8739ae039);

var $7pOAB = parcelRequire("7pOAB");

var $gKbFl = parcelRequire("gKbFl");
var $8dba1a82466d9ea4$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $8dba1a82466d9ea4$var$parseOrdinalNumberPattern = /\d+/i;
var $8dba1a82466d9ea4$var$matchEraPatterns = {
    narrow: /[قب]/,
    abbreviated: /[قب]\.م\./,
    wide: /(قبل|بعد) الميلاد/
};
var $8dba1a82466d9ea4$var$parseEraPatterns = {
    any: [
        /قبل/,
        /بعد/
    ]
};
var $8dba1a82466d9ea4$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /ر[1234]/,
    wide: /الربع (الأول|الثاني|الثالث|الرابع)/
};
var $8dba1a82466d9ea4$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $8dba1a82466d9ea4$var$matchMonthPatterns = {
    narrow: /^[جفمأسند]/,
    abbreviated: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/,
    wide: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
};
var $8dba1a82466d9ea4$var$parseMonthPatterns = {
    narrow: [
        /^ج/i,
        /^ف/i,
        /^م/i,
        /^أ/i,
        /^م/i,
        /^ج/i,
        /^ج/i,
        /^أ/i,
        /^س/i,
        /^أ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^جانفي/i,
        /^فيفري/i,
        /^مارس/i,
        /^أفريل/i,
        /^ماي/i,
        /^جوان/i,
        /^جويلية/i,
        /^أوت/i,
        /^سبتمبر/i,
        /^أكتوبر/i,
        /^نوفمبر/i,
        /^ديسمبر/i
    ]
};
var $8dba1a82466d9ea4$var$matchDayPatterns = {
    narrow: /^[حنثرخجس]/i,
    short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
    wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
};
var $8dba1a82466d9ea4$var$parseDayPatterns = {
    narrow: [
        /^ح/i,
        /^ن/i,
        /^ث/i,
        /^ر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ],
    wide: [
        /^الأحد/i,
        /^الاثنين/i,
        /^الثلاثاء/i,
        /^الأربعاء/i,
        /^الخميس/i,
        /^الجمعة/i,
        /^السبت/i
    ],
    any: [
        /^أح/i,
        /^اث/i,
        /^ث/i,
        /^أر/i,
        /^خ/i,
        /^ج/i,
        /^س/i
    ]
};
var $8dba1a82466d9ea4$var$matchDayPeriodPatterns = {
    narrow: /^(ص|ع|ن ل|ل|(في|مع) (صباح|قايلة|عشية|ليل))/,
    any: /^([صع]|نص الليل|قايلة|(في|مع) (صباح|قايلة|عشية|ليل))/
};
var $8dba1a82466d9ea4$var$parseDayPeriodPatterns = {
    any: {
        am: /^ص/,
        pm: /^ع/,
        midnight: /نص الليل/,
        noon: /قايلة/,
        afternoon: /بعد القايلة/,
        morning: /صباح/,
        evening: /عشية/,
        night: /ليل/
    }
};
var $8dba1a82466d9ea4$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $8dba1a82466d9ea4$var$matchOrdinalNumberPattern,
        parsePattern: $8dba1a82466d9ea4$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $8dba1a82466d9ea4$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8dba1a82466d9ea4$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $8dba1a82466d9ea4$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8dba1a82466d9ea4$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $8dba1a82466d9ea4$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8dba1a82466d9ea4$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $8dba1a82466d9ea4$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8dba1a82466d9ea4$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $8dba1a82466d9ea4$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $8dba1a82466d9ea4$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $8dba1a82466d9ea4$export$2e2bcd8739ae039 = $8dba1a82466d9ea4$var$match;

});


parcelRegister("3t3sO", function(module, exports) {

$parcel$export(module.exports, "default", () => $2866c45f4dfc909e$export$2e2bcd8739ae039);

var $hzSWt = parcelRequire("hzSWt");

var $k266f = parcelRequire("k266f");

var $dxWhF = parcelRequire("dxWhF");

var $fusTi = parcelRequire("fusTi");

var $8mwyo = parcelRequire("8mwyo");
/**
 * @type {Locale}
 * @category Locales
 * @summary Azerbaijani locale.
 * @language Azerbaijani
 * @iso-639-2 aze
 */ var $2866c45f4dfc909e$var$locale = {
    code: "az",
    formatDistance: (0, $hzSWt.default),
    formatLong: (0, $k266f.default),
    formatRelative: (0, $dxWhF.default),
    localize: (0, $fusTi.default),
    match: (0, $8mwyo.default),
    options: {
        weekStartsOn: 1,
        firstWeekContainsDate: 1
    }
};
var $2866c45f4dfc909e$export$2e2bcd8739ae039 = $2866c45f4dfc909e$var$locale;

});
parcelRegister("hzSWt", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccc052e8a09b102e$export$2e2bcd8739ae039);
var $ccc052e8a09b102e$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "bir saniy\u0259d\u0259n az",
        other: "{{count}} bir saniy\u0259d\u0259n az"
    },
    xSeconds: {
        one: "1 saniy\u0259",
        other: "{{count}} saniy\u0259"
    },
    halfAMinute: "yar\u0131m d\u0259qiq\u0259",
    lessThanXMinutes: {
        one: "bir d\u0259qiq\u0259d\u0259n az",
        other: "{{count}} bir d\u0259qiq\u0259d\u0259n az"
    },
    xMinutes: {
        one: "bir d\u0259qiq\u0259",
        other: "{{count}} d\u0259qiq\u0259"
    },
    aboutXHours: {
        one: "t\u0259xmin\u0259n 1 saat",
        other: "t\u0259xmin\u0259n {{count}} saat"
    },
    xHours: {
        one: "1 saat",
        other: "{{count}} saat"
    },
    xDays: {
        one: "1 g\xfcn",
        other: "{{count}} g\xfcn"
    },
    aboutXWeeks: {
        one: "t\u0259xmin\u0259n 1 h\u0259ft\u0259",
        other: "t\u0259xmin\u0259n {{count}} h\u0259ft\u0259"
    },
    xWeeks: {
        one: "1 h\u0259ft\u0259",
        other: "{{count}} h\u0259ft\u0259"
    },
    aboutXMonths: {
        one: "t\u0259xmin\u0259n 1 ay",
        other: "t\u0259xmin\u0259n {{count}} ay"
    },
    xMonths: {
        one: "1 ay",
        other: "{{count}} ay"
    },
    aboutXYears: {
        one: "t\u0259xmin\u0259n 1 il",
        other: "t\u0259xmin\u0259n {{count}} il"
    },
    xYears: {
        one: "1 il",
        other: "{{count}} il"
    },
    overXYears: {
        one: "1 ild\u0259n \xe7ox",
        other: "{{count}} ild\u0259n \xe7ox"
    },
    almostXYears: {
        one: "dem\u0259k olar ki 1 il",
        other: "dem\u0259k olar ki {{count}} il"
    }
};
var $ccc052e8a09b102e$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $ccc052e8a09b102e$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " sonra";
        else return result + " \u0259vv\u0259l";
    }
    return result;
};
var $ccc052e8a09b102e$export$2e2bcd8739ae039 = $ccc052e8a09b102e$var$formatDistance;

});

parcelRegister("k266f", function(module, exports) {

$parcel$export(module.exports, "default", () => $e958b9d9cd4e1906$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $e958b9d9cd4e1906$var$dateFormats = {
    full: "EEEE, do MMMM y 'il'",
    long: "do MMMM y 'il'",
    medium: "d MMM y 'il'",
    short: "dd.MM.yyyy"
};
var $e958b9d9cd4e1906$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
var $e958b9d9cd4e1906$var$dateTimeFormats = {
    full: "{{date}} {{time}} - 'd\u0259'",
    long: "{{date}} {{time}} - 'd\u0259'",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $e958b9d9cd4e1906$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $e958b9d9cd4e1906$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $e958b9d9cd4e1906$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $e958b9d9cd4e1906$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $e958b9d9cd4e1906$export$2e2bcd8739ae039 = $e958b9d9cd4e1906$var$formatLong;

});

parcelRegister("dxWhF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9dcb916e37c58ada$export$2e2bcd8739ae039);
var $9dcb916e37c58ada$var$formatRelativeLocale = {
    lastWeek: "'sonuncu' eeee p -'d\u0259'",
    yesterday: "'d\xfcn\u0259n' p -'d\u0259'",
    today: "'bug\xfcn' p -'d\u0259'",
    tomorrow: "'sabah' p -'d\u0259'",
    nextWeek: "eeee p -'d\u0259'",
    other: "P"
};
var $9dcb916e37c58ada$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $9dcb916e37c58ada$var$formatRelativeLocale[token];
};
var $9dcb916e37c58ada$export$2e2bcd8739ae039 = $9dcb916e37c58ada$var$formatRelative;

});

parcelRegister("fusTi", function(module, exports) {

$parcel$export(module.exports, "default", () => $b470117c3e26d5bc$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $b470117c3e26d5bc$var$eraValues = {
    narrow: [
        "e.\u0259",
        "b.e"
    ],
    abbreviated: [
        "e.\u0259",
        "b.e"
    ],
    wide: [
        "eram\u0131zdan \u0259vv\u0259l",
        "bizim era"
    ]
};
var $b470117c3e26d5bc$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "K1",
        "K2",
        "K3",
        "K4"
    ],
    wide: [
        "1ci kvartal",
        "2ci kvartal",
        "3c\xfc kvartal",
        "4c\xfc kvartal"
    ]
};
var $b470117c3e26d5bc$var$monthValues = {
    narrow: [
        "Y",
        "F",
        "M",
        "A",
        "M",
        "\u0130",
        "\u0130",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Yan",
        "Fev",
        "Mar",
        "Apr",
        "May",
        "\u0130yun",
        "\u0130yul",
        "Avq",
        "Sen",
        "Okt",
        "Noy",
        "Dek"
    ],
    wide: [
        "Yanvar",
        "Fevral",
        "Mart",
        "Aprel",
        "May",
        "\u0130yun",
        "\u0130yul",
        "Avqust",
        "Sentyabr",
        "Oktyabr",
        "Noyabr",
        "Dekabr"
    ]
};
var $b470117c3e26d5bc$var$dayValues = {
    narrow: [
        "B.",
        "B.e",
        "\xc7.a",
        "\xc7.",
        "C.a",
        "C.",
        "\u015E."
    ],
    short: [
        "B.",
        "B.e",
        "\xc7.a",
        "\xc7.",
        "C.a",
        "C.",
        "\u015E."
    ],
    abbreviated: [
        "Baz",
        "Baz.e",
        "\xc7\u0259r.a",
        "\xc7\u0259r",
        "C\xfcm.a",
        "C\xfcm",
        "\u015E\u0259"
    ],
    wide: [
        "Bazar",
        "Bazar ert\u0259si",
        "\xc7\u0259r\u015F\u0259nb\u0259 ax\u015Fam\u0131",
        "\xc7\u0259r\u015F\u0259nb\u0259",
        "C\xfcm\u0259 ax\u015Fam\u0131",
        "C\xfcm\u0259",
        "\u015E\u0259nb\u0259"
    ]
};
var $b470117c3e26d5bc$var$dayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    }
};
var $b470117c3e26d5bc$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "gec\u0259yar\u0131",
        noon: "g\xfcn",
        morning: "s\u0259h\u0259r",
        afternoon: "g\xfcnd\xfcz",
        evening: "ax\u015Fam",
        night: "gec\u0259"
    }
};
var $b470117c3e26d5bc$var$suffixes = {
    1: "-inci",
    5: "-inci",
    8: "-inci",
    70: "-inci",
    80: "-inci",
    2: "-nci",
    7: "-nci",
    20: "-nci",
    50: "-nci",
    3: "-\xfcnc\xfc",
    4: "-\xfcnc\xfc",
    100: "-\xfcnc\xfc",
    6: "-nc\u0131",
    9: "-uncu",
    10: "-uncu",
    30: "-uncu",
    60: "-\u0131nc\u0131",
    90: "-\u0131nc\u0131"
};
var $b470117c3e26d5bc$var$getSuffix = function getSuffix(number) {
    if (number === 0) // special case for zero
    return number + "-\u0131nc\u0131";
    var a = number % 10;
    var b = number % 100 - a;
    var c = number >= 100 ? 100 : null;
    if ($b470117c3e26d5bc$var$suffixes[a]) return $b470117c3e26d5bc$var$suffixes[a];
    else if ($b470117c3e26d5bc$var$suffixes[b]) return $b470117c3e26d5bc$var$suffixes[b];
    else if (c !== null) return $b470117c3e26d5bc$var$suffixes[c];
    return "";
};
var $b470117c3e26d5bc$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var suffix = $b470117c3e26d5bc$var$getSuffix(number);
    return number + suffix;
};
var $b470117c3e26d5bc$var$localize = {
    ordinalNumber: $b470117c3e26d5bc$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $b470117c3e26d5bc$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $b470117c3e26d5bc$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $b470117c3e26d5bc$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $b470117c3e26d5bc$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $b470117c3e26d5bc$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $b470117c3e26d5bc$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $b470117c3e26d5bc$export$2e2bcd8739ae039 = $b470117c3e26d5bc$var$localize;

});

parcelRegister("8mwyo", function(module, exports) {

$parcel$export(module.exports, "default", () => $6169a1525349ac10$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $6169a1525349ac10$var$matchOrdinalNumberPattern = /^(\d+)(-?(ci|inci|nci|uncu|üncü|ncı))?/i;
var $6169a1525349ac10$var$parseOrdinalNumberPattern = /\d+/i;
var $6169a1525349ac10$var$matchEraPatterns = {
    narrow: /^(b|a)$/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)$/i,
    wide: /^(bizim eradan əvvəl|bizim era)$/i
};
var $6169a1525349ac10$var$parseEraPatterns = {
    any: [
        /^b$/i,
        /^(a|c)$/i
    ]
};
var $6169a1525349ac10$var$matchQuarterPatterns = {
    narrow: /^[1234]$/i,
    abbreviated: /^K[1234]$/i,
    wide: /^[1234](ci)? kvartal$/i
};
var $6169a1525349ac10$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $6169a1525349ac10$var$matchMonthPatterns = {
    narrow: /^[(?-i)yfmaisond]$/i,
    abbreviated: /^(Yan|Fev|Mar|Apr|May|İyun|İyul|Avq|Sen|Okt|Noy|Dek)$/i,
    wide: /^(Yanvar|Fevral|Mart|Aprel|May|İyun|İyul|Avgust|Sentyabr|Oktyabr|Noyabr|Dekabr)$/i
};
var $6169a1525349ac10$var$parseMonthPatterns = {
    narrow: [
        /^[(?-i)y]$/i,
        /^[(?-i)f]$/i,
        /^[(?-i)m]$/i,
        /^[(?-i)a]$/i,
        /^[(?-i)m]$/i,
        /^[(?-i)i]$/i,
        /^[(?-i)i]$/i,
        /^[(?-i)a]$/i,
        /^[(?-i)s]$/i,
        /^[(?-i)o]$/i,
        /^[(?-i)n]$/i,
        /^[(?-i)d]$/i
    ],
    abbreviated: [
        /^Yan$/i,
        /^Fev$/i,
        /^Mar$/i,
        /^Apr$/i,
        /^May$/i,
        /^İyun$/i,
        /^İyul$/i,
        /^Avg$/i,
        /^Sen$/i,
        /^Okt$/i,
        /^Noy$/i,
        /^Dek$/i
    ],
    wide: [
        /^Yanvar$/i,
        /^Fevral$/i,
        /^Mart$/i,
        /^Aprel$/i,
        /^May$/i,
        /^İyun$/i,
        /^İyul$/i,
        /^Avgust$/i,
        /^Sentyabr$/i,
        /^Oktyabr$/i,
        /^Noyabr$/i,
        /^Dekabr$/i
    ]
};
var $6169a1525349ac10$var$matchDayPatterns = {
    narrow: /^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
    short: /^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
    abbreviated: /^(Baz\.e|Çər|Çər\.a|Cüm|Cüm\.a|Şə)$/i,
    wide: /^(Bazar|Bazar ertəsi|Çərşənbə axşamı|Çərşənbə|Cümə axşamı|Cümə|Şənbə)$/i
};
var $6169a1525349ac10$var$parseDayPatterns = {
    narrow: [
        /^B\.$/i,
        /^B\.e$/i,
        /^Ç\.a$/i,
        /^Ç\.$/i,
        /^C\.a$/i,
        /^C\.$/i,
        /^Ş\.$/i
    ],
    abbreviated: [
        /^Baz$/i,
        /^Baz\.e$/i,
        /^Çər\.a$/i,
        /^Çər$/i,
        /^Cüm\.a$/i,
        /^Cüm$/i,
        /^Şə$/i
    ],
    wide: [
        /^Bazar$/i,
        /^Bazar ertəsi$/i,
        /^Çərşənbə axşamı$/i,
        /^Çərşənbə$/i,
        /^Cümə axşamı$/i,
        /^Cümə$/i,
        /^Şənbə$/i
    ],
    any: [
        /^B\.$/i,
        /^B\.e$/i,
        /^Ç\.a$/i,
        /^Ç\.$/i,
        /^C\.a$/i,
        /^C\.$/i,
        /^Ş\.$/i
    ]
};
var $6169a1525349ac10$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i,
    any: /^(am|pm|a\.m\.|p\.m\.|AM|PM|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i
};
var $6169a1525349ac10$var$parseDayPeriodPatterns = {
    any: {
        am: /^a$/i,
        pm: /^p$/i,
        midnight: /^gecəyarı$/i,
        noon: /^gün$/i,
        morning: /səhər$/i,
        afternoon: /gündüz$/i,
        evening: /axşam$/i,
        night: /gecə$/i
    }
};
var $6169a1525349ac10$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $6169a1525349ac10$var$matchOrdinalNumberPattern,
        parsePattern: $6169a1525349ac10$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $6169a1525349ac10$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6169a1525349ac10$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $6169a1525349ac10$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6169a1525349ac10$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $6169a1525349ac10$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6169a1525349ac10$var$parseMonthPatterns,
        defaultParseWidth: "narrow"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $6169a1525349ac10$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6169a1525349ac10$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $6169a1525349ac10$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $6169a1525349ac10$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $6169a1525349ac10$export$2e2bcd8739ae039 = $6169a1525349ac10$var$match;

});


parcelRegister("kzMqz", function(module, exports) {

$parcel$export(module.exports, "default", () => $efaca435df0eca3c$export$2e2bcd8739ae039);

var $3qL9x = parcelRequire("3qL9x");

var $g2xiW = parcelRequire("g2xiW");

var $lNj5i = parcelRequire("lNj5i");

var $9gotM = parcelRequire("9gotM");

var $2gID5 = parcelRequire("2gID5");
/**
 * @type {Locale}
 * @category Locales
 * @summary Belarusian locale.
 * @language Belarusian
 * @iso-639-2 bel
 * @author Kiryl Anokhin [@alyrik]{@link https://github.com/alyrik}
 * @author Martin Wind [@arvigeus]{@link https://github.com/mawi12345}
 */ var $efaca435df0eca3c$var$locale = {
    code: "be",
    formatDistance: (0, $3qL9x.default),
    formatLong: (0, $g2xiW.default),
    formatRelative: (0, $lNj5i.default),
    localize: (0, $9gotM.default),
    match: (0, $2gID5.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $efaca435df0eca3c$export$2e2bcd8739ae039 = $efaca435df0eca3c$var$locale;

});
parcelRegister("3qL9x", function(module, exports) {

$parcel$export(module.exports, "default", () => $27f860634c056c13$export$2e2bcd8739ae039);
function $27f860634c056c13$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace("{{count}}", String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace("{{count}}", String(count));
    else return scheme.pluralGenitive.replace("{{count}}", String(count));
}
function $27f860634c056c13$var$buildLocalizeTokenFn(scheme) {
    return function(count, options) {
        if (options && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return $27f860634c056c13$var$declension(scheme.future, count);
                else return "\u043F\u0440\u0430\u0437 " + $27f860634c056c13$var$declension(scheme.regular, count);
            } else {
                if (scheme.past) return $27f860634c056c13$var$declension(scheme.past, count);
                else return $27f860634c056c13$var$declension(scheme.regular, count) + " \u0442\u0430\u043C\u0443";
            }
        } else return $27f860634c056c13$var$declension(scheme.regular, count);
    };
}
var $27f860634c056c13$var$halfAMinute = function halfAMinute(_, options) {
    if (options && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u043F\u0440\u0430\u0437 \u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
        else return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443";
    }
    return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
};
var $27f860634c056c13$var$formatDistanceLocale = {
    lessThanXSeconds: $27f860634c056c13$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: $27f860634c056c13$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: $27f860634c056c13$var$halfAMinute,
    lessThanXMinutes: $27f860634c056c13$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
    }),
    xMinutes: $27f860634c056c13$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0430",
            singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
    }),
    aboutXHours: $27f860634c056c13$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
    }),
    xHours: $27f860634c056c13$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0430",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
    }),
    xDays: $27f860634c056c13$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0437\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043D\u0456",
            pluralGenitive: "{{count}} \u0434\u0437\u0451\u043D"
        }
    }),
    aboutXWeeks: $27f860634c056c13$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            // TODO
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
            // TODO
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E" // TODO
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            // TODO
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            // TODO
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E" // TODO
        }
    }),
    xWeeks: $27f860634c056c13$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    aboutXMonths: $27f860634c056c13$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    xMonths: $27f860634c056c13$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    aboutXYears: $27f860634c056c13$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    xYears: $27f860634c056c13$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    overXYears: $27f860634c056c13$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    almostXYears: $27f860634c056c13$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    })
};
var $27f860634c056c13$var$formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    return $27f860634c056c13$var$formatDistanceLocale[token](count, options);
};
var $27f860634c056c13$export$2e2bcd8739ae039 = $27f860634c056c13$var$formatDistance;

});

parcelRegister("g2xiW", function(module, exports) {

$parcel$export(module.exports, "default", () => $bad6aad783a0d9b9$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $bad6aad783a0d9b9$var$dateFormats = {
    full: "EEEE, d MMMM y '\u0433.'",
    long: "d MMMM y '\u0433.'",
    medium: "d MMM y '\u0433.'",
    short: "dd.MM.y"
};
var $bad6aad783a0d9b9$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
var $bad6aad783a0d9b9$var$dateTimeFormats = {
    any: "{{date}}, {{time}}"
};
var $bad6aad783a0d9b9$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $bad6aad783a0d9b9$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $bad6aad783a0d9b9$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $bad6aad783a0d9b9$var$dateTimeFormats,
        defaultWidth: "any"
    })
};
var $bad6aad783a0d9b9$export$2e2bcd8739ae039 = $bad6aad783a0d9b9$var$formatLong;

});

parcelRegister("lNj5i", function(module, exports) {

$parcel$export(module.exports, "default", () => $fddcfa59f084b676$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $6KZXu = parcelRequire("6KZXu");
var $fddcfa59f084b676$var$accusativeWeekdays = [
    "\u043D\u044F\u0434\u0437\u0435\u043B\u044E",
    "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
    "\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
    "\u0441\u0435\u0440\u0430\u0434\u0443",
    "\u0447\u0430\u0446\u0432\u0435\u0440",
    "\u043F\u044F\u0442\u043D\u0456\u0446\u0443",
    "\u0441\u0443\u0431\u043E\u0442\u0443"
];
function $fddcfa59f084b676$var$lastWeek(day) {
    var weekday = $fddcfa59f084b676$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u0443\u044E " + weekday + " \u0430' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u044B " + weekday + " \u0430' p";
    }
}
function $fddcfa59f084b676$var$thisWeek(day) {
    var weekday = $fddcfa59f084b676$var$accusativeWeekdays[day];
    return "'\u0443 " + weekday + " \u0430' p";
}
function $fddcfa59f084b676$var$nextWeek(day) {
    var weekday = $fddcfa59f084b676$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443\u044E " + weekday + " \u0430' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u044B " + weekday + " \u0430' p";
    }
}
var $fddcfa59f084b676$var$lastWeekFormat = function lastWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, $gdr0J.default)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $6KZXu.default)(date, baseDate, options)) return $fddcfa59f084b676$var$thisWeek(day);
    else return $fddcfa59f084b676$var$lastWeek(day);
};
var $fddcfa59f084b676$var$nextWeekFormat = function nextWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, $gdr0J.default)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $6KZXu.default)(date, baseDate, options)) return $fddcfa59f084b676$var$thisWeek(day);
    else return $fddcfa59f084b676$var$nextWeek(day);
};
var $fddcfa59f084b676$var$formatRelativeLocale = {
    lastWeek: $fddcfa59f084b676$var$lastWeekFormat,
    yesterday: "'\u0443\u0447\u043E\u0440\u0430 \u0430' p",
    today: "'\u0441\u0451\u043D\u043D\u044F \u0430' p",
    tomorrow: "'\u0437\u0430\u045E\u0442\u0440\u0430 \u0430' p",
    nextWeek: $fddcfa59f084b676$var$nextWeekFormat,
    other: "P"
};
var $fddcfa59f084b676$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $fddcfa59f084b676$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
var $fddcfa59f084b676$export$2e2bcd8739ae039 = $fddcfa59f084b676$var$formatRelative;

});
parcelRegister("6KZXu", function(module, exports) {

$parcel$export(module.exports, "default", () => $4eb7199c732101db$export$2e2bcd8739ae039);

var $4LmDH = parcelRequire("4LmDH");

var $1cqVL = parcelRequire("1cqVL");
function $4eb7199c732101db$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight, options) {
    (0, $4LmDH.default)(2, arguments);
    var dateLeftStartOfWeek = (0, $1cqVL.default)(dirtyDateLeft, options);
    var dateRightStartOfWeek = (0, $1cqVL.default)(dirtyDateRight, options);
    return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime();
}

});


parcelRegister("9gotM", function(module, exports) {

$parcel$export(module.exports, "default", () => $6be898c8868972d3$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $6be898c8868972d3$var$eraValues = {
    narrow: [
        "\u0434\u0430 \u043D.\u044D.",
        "\u043D.\u044D."
    ],
    abbreviated: [
        "\u0434\u0430 \u043D. \u044D.",
        "\u043D. \u044D."
    ],
    wide: [
        "\u0434\u0430 \u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B",
        "\u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B"
    ]
};
var $6be898c8868972d3$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-\u044B \u043A\u0432.",
        "2-\u0456 \u043A\u0432.",
        "3-\u0456 \u043A\u0432.",
        "4-\u044B \u043A\u0432."
    ],
    wide: [
        "1-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var $6be898c8868972d3$var$monthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0421",
        "\u041A",
        "\u041C",
        "\u0427",
        "\u041B",
        "\u0416",
        "\u0412",
        "\u041A",
        "\u041B",
        "\u0421"
    ],
    abbreviated: [
        "\u0441\u0442\u0443\u0434\u0437.",
        "\u043B\u044E\u0442.",
        "\u0441\u0430\u043A.",
        "\u043A\u0440\u0430\u0441.",
        "\u043C\u0430\u0439",
        "\u0447\u044D\u0440\u0432.",
        "\u043B\u0456\u043F.",
        "\u0436\u043D.",
        "\u0432\u0435\u0440.",
        "\u043A\u0430\u0441\u0442\u0440.",
        "\u043B\u0456\u0441\u0442.",
        "\u0441\u043D\u0435\u0436."
    ],
    wide: [
        "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044C",
        "\u043B\u044E\u0442\u044B",
        "\u0441\u0430\u043A\u0430\u0432\u0456\u043A",
        "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A",
        "\u043C\u0430\u0439",
        "\u0447\u044D\u0440\u0432\u0435\u043D\u044C",
        "\u043B\u0456\u043F\u0435\u043D\u044C",
        "\u0436\u043D\u0456\u0432\u0435\u043D\u044C",
        "\u0432\u0435\u0440\u0430\u0441\u0435\u043D\u044C",
        "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A",
        "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434",
        "\u0441\u043D\u0435\u0436\u0430\u043D\u044C"
    ]
};
var $6be898c8868972d3$var$formattingMonthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0421",
        "\u041A",
        "\u041C",
        "\u0427",
        "\u041B",
        "\u0416",
        "\u0412",
        "\u041A",
        "\u041B",
        "\u0421"
    ],
    abbreviated: [
        "\u0441\u0442\u0443\u0434\u0437.",
        "\u043B\u044E\u0442.",
        "\u0441\u0430\u043A.",
        "\u043A\u0440\u0430\u0441.",
        "\u043C\u0430\u044F",
        "\u0447\u044D\u0440\u0432.",
        "\u043B\u0456\u043F.",
        "\u0436\u043D.",
        "\u0432\u0435\u0440.",
        "\u043A\u0430\u0441\u0442\u0440.",
        "\u043B\u0456\u0441\u0442.",
        "\u0441\u043D\u0435\u0436."
    ],
    wide: [
        "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044F",
        "\u043B\u044E\u0442\u0430\u0433\u0430",
        "\u0441\u0430\u043A\u0430\u0432\u0456\u043A\u0430",
        "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A\u0430",
        "\u043C\u0430\u044F",
        "\u0447\u044D\u0440\u0432\u0435\u043D\u044F",
        "\u043B\u0456\u043F\u0435\u043D\u044F",
        "\u0436\u043D\u0456\u045E\u043D\u044F",
        "\u0432\u0435\u0440\u0430\u0441\u043D\u044F",
        "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A\u0430",
        "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434\u0430",
        "\u0441\u043D\u0435\u0436\u043D\u044F"
    ]
};
var $6be898c8868972d3$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0410",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0434",
        "\u043F\u043D",
        "\u0430\u045E",
        "\u0441\u0440",
        "\u0447\u0446",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u043D\u044F\u0434\u0437",
        "\u043F\u0430\u043D",
        "\u0430\u045E\u0442",
        "\u0441\u0435\u0440",
        "\u0447\u0430\u0446",
        "\u043F\u044F\u0442",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u043D\u044F\u0434\u0437\u0435\u043B\u044F",
        "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
        "\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
        "\u0441\u0435\u0440\u0430\u0434\u0430",
        "\u0447\u0430\u0446\u0432\u0435\u0440",
        "\u043F\u044F\u0442\u043D\u0456\u0446\u0430",
        "\u0441\u0443\u0431\u043E\u0442\u0430"
    ]
};
var $6be898c8868972d3$var$dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u0430",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0430\u0440",
        night: "\u043D\u043E\u0447"
    }
};
var $6be898c8868972d3$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u044B",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447\u0430\u0440\u0430",
        night: "\u043D\u043E\u0447\u044B"
    }
};
var $6be898c8868972d3$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    var number = Number(dirtyNumber);
    var suffix;
    /** Though it's an incorrect ordinal form of a date we use it here for consistency with other similar locales (ru, uk)
   *  For date-month combinations should be used `d` formatter.
   *  Correct:   `d MMMM` (4 верасня)
   *  Incorrect: `do MMMM` (4-га верасня)
   *
   *  But following the consistency leads to mistakes for literal uses of `do` formatter (ordinal day of month).
   *  So for phrase "5th day of month" (`do дзень месяца`)
   *  library will produce:            `5-га дзень месяца`
   *  but correct spelling should be:  `5-ы дзень месяца`
   *
   *  So I guess there should be a stand-alone and a formatting version of "day of month" formatters
   */ if (unit === "date") suffix = "-\u0433\u0430";
    else if (unit === "hour" || unit === "minute" || unit === "second") suffix = "-\u044F";
    else suffix = (number % 10 === 2 || number % 10 === 3) && number % 100 !== 12 && number % 100 !== 13 ? "-\u0456" : "-\u044B";
    return number + suffix;
};
var $6be898c8868972d3$var$localize = {
    ordinalNumber: $6be898c8868972d3$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $6be898c8868972d3$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $6be898c8868972d3$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $6be898c8868972d3$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $6be898c8868972d3$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $6be898c8868972d3$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $6be898c8868972d3$var$dayPeriodValues,
        defaultWidth: "any",
        formattingValues: $6be898c8868972d3$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $6be898c8868972d3$export$2e2bcd8739ae039 = $6be898c8868972d3$var$localize;

});

parcelRegister("2gID5", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a6fb1de6faa4f79$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $1a6fb1de6faa4f79$var$matchOrdinalNumberPattern = /^(\d+)(-?(е|я|га|і|ы|ае|ая|яя|шы|гі|ці|ты|мы))?/i;
var $1a6fb1de6faa4f79$var$parseOrdinalNumberPattern = /\d+/i;
var $1a6fb1de6faa4f79$var$matchEraPatterns = {
    narrow: /^((да )?н\.?\s?э\.?)/i,
    abbreviated: /^((да )?н\.?\s?э\.?)/i,
    wide: /^(да нашай эры|нашай эры|наша эра)/i
};
var $1a6fb1de6faa4f79$var$parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
var $1a6fb1de6faa4f79$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[ыі]?)? кв.?/i,
    wide: /^[1234](-?[ыі]?)? квартал/i
};
var $1a6fb1de6faa4f79$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $1a6fb1de6faa4f79$var$matchMonthPatterns = {
    narrow: /^[слкмчжв]/i,
    abbreviated: /^(студз|лют|сак|крас|ма[йя]|чэрв|ліп|жн|вер|кастр|ліст|снеж)\.?/i,
    wide: /^(студзен[ья]|лют(ы|ага)|сакавіка?|красавіка?|ма[йя]|чэрвен[ья]|ліпен[ья]|жні(вень|ўня)|верас(ень|ня)|кастрычніка?|лістапада?|снеж(ань|ня))/i
};
var $1a6fb1de6faa4f79$var$parseMonthPatterns = {
    narrow: [
        /^с/i,
        /^л/i,
        /^с/i,
        /^к/i,
        /^м/i,
        /^ч/i,
        /^л/i,
        /^ж/i,
        /^в/i,
        /^к/i,
        /^л/i,
        /^с/i
    ],
    any: [
        /^ст/i,
        /^лю/i,
        /^са/i,
        /^кр/i,
        /^ма/i,
        /^ч/i,
        /^ліп/i,
        /^ж/i,
        /^в/i,
        /^ка/i,
        /^ліс/i,
        /^сн/i
    ]
};
var $1a6fb1de6faa4f79$var$matchDayPatterns = {
    narrow: /^[нпасч]/i,
    short: /^(нд|ня|пн|па|аў|ат|ср|се|чц|ча|пт|пя|сб|су)\.?/i,
    abbreviated: /^(нядз?|ндз|пнд|пан|аўт|срд|сер|чцв|чац|птн|пят|суб).?/i,
    wide: /^(нядзел[яі]|панядзел(ак|ка)|аўтор(ак|ка)|серад[аы]|чацв(ер|ярга)|пятніц[аы]|субот[аы])/i
};
var $1a6fb1de6faa4f79$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^а/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н/i,
        /^п[ан]/i,
        /^а/i,
        /^с[ер]/i,
        /^ч/i,
        /^п[ят]/i,
        /^с[уб]/i
    ]
};
var $1a6fb1de6faa4f79$var$matchDayPeriodPatterns = {
    narrow: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    abbreviated: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    wide: /^([дп]п|поўнач|поўдзень|раніц[аы]|дзень|дня|вечара?|ночы?)/i
};
var $1a6fb1de6faa4f79$var$parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^поўн/i,
        noon: /^поўд/i,
        morning: /^р/i,
        afternoon: /^д[зн]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
var $1a6fb1de6faa4f79$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $1a6fb1de6faa4f79$var$matchOrdinalNumberPattern,
        parsePattern: $1a6fb1de6faa4f79$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $1a6fb1de6faa4f79$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $1a6fb1de6faa4f79$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $1a6fb1de6faa4f79$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $1a6fb1de6faa4f79$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $1a6fb1de6faa4f79$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $1a6fb1de6faa4f79$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $1a6fb1de6faa4f79$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $1a6fb1de6faa4f79$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $1a6fb1de6faa4f79$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $1a6fb1de6faa4f79$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $1a6fb1de6faa4f79$export$2e2bcd8739ae039 = $1a6fb1de6faa4f79$var$match;

});


parcelRegister("4u97v", function(module, exports) {

$parcel$export(module.exports, "default", () => $344109d42197d456$export$2e2bcd8739ae039);

var $esumM = parcelRequire("esumM");

var $2deD8 = parcelRequire("2deD8");

var $a8J6U = parcelRequire("a8J6U");

var $ZmyKf = parcelRequire("ZmyKf");

var $lF05g = parcelRequire("lF05g");
/**
 * @type {Locale}
 * @category Locales
 * @summary Belarusian Classic locale.
 * @language Belarusian Classic
 * @iso-639-2 bel
 * @author Ryhor Nopears [@nopears]{@link https://github.com/nopears}
 */ var $344109d42197d456$var$locale = {
    code: "be-tarask",
    formatDistance: (0, $esumM.default),
    formatLong: (0, $2deD8.default),
    formatRelative: (0, $a8J6U.default),
    localize: (0, $ZmyKf.default),
    match: (0, $lF05g.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $344109d42197d456$export$2e2bcd8739ae039 = $344109d42197d456$var$locale;

});
parcelRegister("esumM", function(module, exports) {

$parcel$export(module.exports, "default", () => $a86b3c584846070a$export$2e2bcd8739ae039);
function $a86b3c584846070a$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace("{{count}}", String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace("{{count}}", String(count));
    else return scheme.pluralGenitive.replace("{{count}}", String(count));
}
function $a86b3c584846070a$var$buildLocalizeTokenFn(scheme) {
    return function(count, options) {
        if (options && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return $a86b3c584846070a$var$declension(scheme.future, count);
                else return "\u043F\u0440\u0430\u0437 " + $a86b3c584846070a$var$declension(scheme.regular, count);
            } else {
                if (scheme.past) return $a86b3c584846070a$var$declension(scheme.past, count);
                else return $a86b3c584846070a$var$declension(scheme.regular, count) + " \u0442\u0430\u043C\u0443";
            }
        } else return $a86b3c584846070a$var$declension(scheme.regular, count);
    };
}
var $a86b3c584846070a$var$halfAMinute = function halfAMinute(_, options) {
    if (options && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u043F\u0440\u0430\u0437 \u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
        else return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443";
    }
    return "\u043F\u0430\u045E\u0445\u0432\u0456\u043B\u0456\u043D\u044B";
};
var $a86b3c584846070a$var$formatDistanceLocale = {
    lessThanXSeconds: $a86b3c584846070a$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: $a86b3c584846070a$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: $a86b3c584846070a$var$halfAMinute,
    lessThanXMinutes: $a86b3c584846070a$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448 \u0437\u0430 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448 \u0437\u0430 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
    }),
    xMinutes: $a86b3c584846070a$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0430",
            singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0445\u0432\u0456\u043B\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0445\u0432\u0456\u043B\u0456\u043D"
        }
    }),
    aboutXHours: $a86b3c584846070a$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
    }),
    xHours: $a86b3c584846070a$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0430",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443 \u0442\u0430\u043C\u0443",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B \u0442\u0430\u043C\u0443",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u0437\u0456\u043D \u0442\u0430\u043C\u0443"
        },
        future: {
            singularNominative: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D\u044B",
            pluralGenitive: "\u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u0437\u0456\u043D"
        }
    }),
    xDays: $a86b3c584846070a$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0437\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043D\u0456",
            pluralGenitive: "{{count}} \u0434\u0437\u0451\u043D"
        }
    }),
    aboutXWeeks: $a86b3c584846070a$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            // TODO
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
            // TODO
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E" // TODO
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            // TODO
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            // TODO
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E" // TODO
        }
    }),
    xWeeks: $a86b3c584846070a$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    aboutXMonths: $a86b3c584846070a$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    xMonths: $a86b3c584846070a$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u044B",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430\u045E"
        }
    }),
    aboutXYears: $a86b3c584846070a$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043A\u0430\u043B\u044F {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E",
            pluralGenitive: "\u043A\u0430\u043B\u044F {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u043F\u0440\u044B\u0431\u043B\u0456\u0437\u043D\u0430 \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    xYears: $a86b3c584846070a$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434",
            singularGenitive: "{{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "{{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    overXYears: $a86b3c584846070a$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448 \u0437\u0430 {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448, \u0447\u044B\u043C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    }),
    almostXYears: $a86b3c584846070a$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0430\u043C\u0430\u043B\u044C {{count}} \u0433\u0430\u0434\u043E\u045E"
        },
        future: {
            singularNominative: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u044B",
            pluralGenitive: "\u0430\u043C\u0430\u043B\u044C \u043F\u0440\u0430\u0437 {{count}} \u0433\u0430\u0434\u043E\u045E"
        }
    })
};
var $a86b3c584846070a$var$formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    return $a86b3c584846070a$var$formatDistanceLocale[token](count, options);
};
var $a86b3c584846070a$export$2e2bcd8739ae039 = $a86b3c584846070a$var$formatDistance;

});

parcelRegister("2deD8", function(module, exports) {

$parcel$export(module.exports, "default", () => $19c824ee8c928ca8$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $19c824ee8c928ca8$var$dateFormats = {
    full: "EEEE, d MMMM y '\u0433.'",
    long: "d MMMM y '\u0433.'",
    medium: "d MMM y '\u0433.'",
    short: "dd.MM.y"
};
var $19c824ee8c928ca8$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
var $19c824ee8c928ca8$var$dateTimeFormats = {
    any: "{{date}}, {{time}}"
};
var $19c824ee8c928ca8$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $19c824ee8c928ca8$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $19c824ee8c928ca8$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $19c824ee8c928ca8$var$dateTimeFormats,
        defaultWidth: "any"
    })
};
var $19c824ee8c928ca8$export$2e2bcd8739ae039 = $19c824ee8c928ca8$var$formatLong;

});

parcelRegister("a8J6U", function(module, exports) {

$parcel$export(module.exports, "default", () => $761da4bbeed235cb$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $6KZXu = parcelRequire("6KZXu");
var $761da4bbeed235cb$var$accusativeWeekdays = [
    "\u043D\u044F\u0434\u0437\u0435\u043B\u044E",
    "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
    "\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
    "\u0441\u0435\u0440\u0430\u0434\u0443",
    "\u0447\u0430\u0446\u044C\u0432\u0435\u0440",
    "\u043F\u044F\u0442\u043D\u0456\u0446\u0443",
    "\u0441\u0443\u0431\u043E\u0442\u0443"
];
function $761da4bbeed235cb$var$lastWeek(day) {
    var weekday = $761da4bbeed235cb$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u0443\u044E " + weekday + " \u0430' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043C\u0456\u043D\u0443\u043B\u044B " + weekday + " \u0430' p";
    }
}
function $761da4bbeed235cb$var$thisWeek(day) {
    var weekday = $761da4bbeed235cb$var$accusativeWeekdays[day];
    return "'\u0443 " + weekday + " \u0430' p";
}
function $761da4bbeed235cb$var$nextWeek(day) {
    var weekday = $761da4bbeed235cb$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443\u044E " + weekday + " \u0430' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u044B " + weekday + " \u0430' p";
    }
}
var $761da4bbeed235cb$var$lastWeekFormat = function lastWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, $gdr0J.default)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $6KZXu.default)(date, baseDate, options)) return $761da4bbeed235cb$var$thisWeek(day);
    else return $761da4bbeed235cb$var$lastWeek(day);
};
var $761da4bbeed235cb$var$nextWeekFormat = function nextWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, $gdr0J.default)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $6KZXu.default)(date, baseDate, options)) return $761da4bbeed235cb$var$thisWeek(day);
    else return $761da4bbeed235cb$var$nextWeek(day);
};
var $761da4bbeed235cb$var$formatRelativeLocale = {
    lastWeek: $761da4bbeed235cb$var$lastWeekFormat,
    yesterday: "'\u0443\u0447\u043E\u0440\u0430 \u0430' p",
    today: "'\u0441\u0451\u043D\u044C\u043D\u044F \u0430' p",
    tomorrow: "'\u0437\u0430\u045E\u0442\u0440\u0430 \u0430' p",
    nextWeek: $761da4bbeed235cb$var$nextWeekFormat,
    other: "P"
};
var $761da4bbeed235cb$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $761da4bbeed235cb$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
var $761da4bbeed235cb$export$2e2bcd8739ae039 = $761da4bbeed235cb$var$formatRelative;

});

parcelRegister("ZmyKf", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b87327295c5084c$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $0b87327295c5084c$var$eraValues = {
    narrow: [
        "\u0434\u0430 \u043D.\u044D.",
        "\u043D.\u044D."
    ],
    abbreviated: [
        "\u0434\u0430 \u043D. \u044D.",
        "\u043D. \u044D."
    ],
    wide: [
        "\u0434\u0430 \u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B",
        "\u043D\u0430\u0448\u0430\u0439 \u044D\u0440\u044B"
    ]
};
var $0b87327295c5084c$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-\u044B \u043A\u0432.",
        "2-\u0456 \u043A\u0432.",
        "3-\u0456 \u043A\u0432.",
        "4-\u044B \u043A\u0432."
    ],
    wide: [
        "1-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0456 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u044B \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var $0b87327295c5084c$var$monthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0421",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0416",
        "\u0412",
        "\u041A",
        "\u041B",
        "\u0421"
    ],
    abbreviated: [
        "\u0441\u0442\u0443\u0434\u0437.",
        "\u043B\u044E\u0442.",
        "\u0441\u0430\u043A.",
        "\u043A\u0440\u0430\u0441.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u044D\u0440\u0432.",
        "\u043B\u0456\u043F.",
        "\u0436\u043D.",
        "\u0432\u0435\u0440.",
        "\u043A\u0430\u0441\u0442\u0440.",
        "\u043B\u0456\u0441\u0442.",
        "\u0441\u044C\u043D\u0435\u0436."
    ],
    wide: [
        "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044C",
        "\u043B\u044E\u0442\u044B",
        "\u0441\u0430\u043A\u0430\u0432\u0456\u043A",
        "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A",
        "\u0442\u0440\u0430\u0432\u0435\u043D\u044C",
        "\u0447\u044D\u0440\u0432\u0435\u043D\u044C",
        "\u043B\u0456\u043F\u0435\u043D\u044C",
        "\u0436\u043D\u0456\u0432\u0435\u043D\u044C",
        "\u0432\u0435\u0440\u0430\u0441\u0435\u043D\u044C",
        "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A",
        "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434",
        "\u0441\u044C\u043D\u0435\u0436\u0430\u043D\u044C"
    ]
};
var $0b87327295c5084c$var$formattingMonthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0421",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0416",
        "\u0412",
        "\u041A",
        "\u041B",
        "\u0421"
    ],
    abbreviated: [
        "\u0441\u0442\u0443\u0434\u0437.",
        "\u043B\u044E\u0442.",
        "\u0441\u0430\u043A.",
        "\u043A\u0440\u0430\u0441.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u044D\u0440\u0432.",
        "\u043B\u0456\u043F.",
        "\u0436\u043D.",
        "\u0432\u0435\u0440.",
        "\u043A\u0430\u0441\u0442\u0440.",
        "\u043B\u0456\u0441\u0442.",
        "\u0441\u044C\u043D\u0435\u0436."
    ],
    wide: [
        "\u0441\u0442\u0443\u0434\u0437\u0435\u043D\u044F",
        "\u043B\u044E\u0442\u0430\u0433\u0430",
        "\u0441\u0430\u043A\u0430\u0432\u0456\u043A\u0430",
        "\u043A\u0440\u0430\u0441\u0430\u0432\u0456\u043A\u0430",
        "\u0442\u0440\u0430\u045E\u043D\u044F",
        "\u0447\u044D\u0440\u0432\u0435\u043D\u044F",
        "\u043B\u0456\u043F\u0435\u043D\u044F",
        "\u0436\u043D\u0456\u045E\u043D\u044F",
        "\u0432\u0435\u0440\u0430\u0441\u043D\u044F",
        "\u043A\u0430\u0441\u0442\u0440\u044B\u0447\u043D\u0456\u043A\u0430",
        "\u043B\u0456\u0441\u0442\u0430\u043F\u0430\u0434\u0430",
        "\u0441\u044C\u043D\u0435\u0436\u043D\u044F"
    ]
};
var $0b87327295c5084c$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0410",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0434",
        "\u043F\u043D",
        "\u0430\u045E",
        "\u0441\u0440",
        "\u0447\u0446",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u043D\u044F\u0434\u0437",
        "\u043F\u0430\u043D",
        "\u0430\u045E\u0442",
        "\u0441\u0435\u0440",
        "\u0447\u0430\u0446\u044C",
        "\u043F\u044F\u0442",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u043D\u044F\u0434\u0437\u0435\u043B\u044F",
        "\u043F\u0430\u043D\u044F\u0434\u0437\u0435\u043B\u0430\u043A",
        "\u0430\u045E\u0442\u043E\u0440\u0430\u043A",
        "\u0441\u0435\u0440\u0430\u0434\u0430",
        "\u0447\u0430\u0446\u044C\u0432\u0435\u0440",
        "\u043F\u044F\u0442\u043D\u0456\u0446\u0430",
        "\u0441\u0443\u0431\u043E\u0442\u0430"
    ]
};
var $0b87327295c5084c$var$dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u0430",
        afternoon: "\u0434\u0437\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0430\u0440",
        night: "\u043D\u043E\u0447"
    }
};
var $0b87327295c5084c$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D.",
        noon: "\u043F\u043E\u045E\u0434.",
        morning: "\u0440\u0430\u043D.",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044B"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u045E\u043D\u0430\u0447",
        noon: "\u043F\u043E\u045E\u0434\u0437\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u0456\u0446\u044B",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447\u0430\u0440\u0430",
        night: "\u043D\u043E\u0447\u044B"
    }
};
var $0b87327295c5084c$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    var number = Number(dirtyNumber);
    var suffix;
    /** Though it's an incorrect ordinal form of a date we use it here for consistency with other similar locales (ru, uk)
   *  For date-month combinations should be used `d` formatter.
   *  Correct:   `d MMMM` (4 верасня)
   *  Incorrect: `do MMMM` (4-га верасня)
   *
   *  But following the consistency leads to mistakes for literal uses of `do` formatter (ordinal day of month).
   *  So for phrase "5th day of month" (`do дзень месяца`)
   *  library will produce:            `5-га дзень месяца`
   *  but correct spelling should be:  `5-ы дзень месяца`
   *
   *  So I guess there should be a stand-alone and a formatting version of "day of month" formatters
   */ if (unit === "date") suffix = "-\u0433\u0430";
    else if (unit === "hour" || unit === "minute" || unit === "second") suffix = "-\u044F";
    else suffix = (number % 10 === 2 || number % 10 === 3) && number % 100 !== 12 && number % 100 !== 13 ? "-\u0456" : "-\u044B";
    return number + suffix;
};
var $0b87327295c5084c$var$localize = {
    ordinalNumber: $0b87327295c5084c$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $0b87327295c5084c$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $0b87327295c5084c$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $0b87327295c5084c$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $0b87327295c5084c$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $0b87327295c5084c$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $0b87327295c5084c$var$dayPeriodValues,
        defaultWidth: "any",
        formattingValues: $0b87327295c5084c$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $0b87327295c5084c$export$2e2bcd8739ae039 = $0b87327295c5084c$var$localize;

});

parcelRegister("lF05g", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc4d7df96cd5631b$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $fc4d7df96cd5631b$var$matchOrdinalNumberPattern = /^(\d+)(-?(е|я|га|і|ы|ае|ая|яя|шы|гі|ці|ты|мы))?/i;
var $fc4d7df96cd5631b$var$parseOrdinalNumberPattern = /\d+/i;
var $fc4d7df96cd5631b$var$matchEraPatterns = {
    narrow: /^((да )?н\.?\s?э\.?)/i,
    abbreviated: /^((да )?н\.?\s?э\.?)/i,
    wide: /^(да нашай эры|нашай эры|наша эра)/i
};
var $fc4d7df96cd5631b$var$parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
var $fc4d7df96cd5631b$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[ыі]?)? кв.?/i,
    wide: /^[1234](-?[ыі]?)? квартал/i
};
var $fc4d7df96cd5631b$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $fc4d7df96cd5631b$var$matchMonthPatterns = {
    narrow: /^[слкмчжв]/i,
    abbreviated: /^(студз|лют|сак|крас|тр(ав)?|чэрв|ліп|жн|вер|кастр|ліст|сьнеж)\.?/i,
    wide: /^(студзен[ья]|лют(ы|ага)|сакавіка?|красавіка?|тра(вень|ўня)|чэрвен[ья]|ліпен[ья]|жні(вень|ўня)|верас(ень|ня)|кастрычніка?|лістапада?|сьнеж(ань|ня))/i
};
var $fc4d7df96cd5631b$var$parseMonthPatterns = {
    narrow: [
        /^с/i,
        /^л/i,
        /^с/i,
        /^к/i,
        /^т/i,
        /^ч/i,
        /^л/i,
        /^ж/i,
        /^в/i,
        /^к/i,
        /^л/i,
        /^с/i
    ],
    any: [
        /^ст/i,
        /^лю/i,
        /^са/i,
        /^кр/i,
        /^тр/i,
        /^ч/i,
        /^ліп/i,
        /^ж/i,
        /^в/i,
        /^ка/i,
        /^ліс/i,
        /^сн/i
    ]
};
var $fc4d7df96cd5631b$var$matchDayPatterns = {
    narrow: /^[нпасч]/i,
    short: /^(нд|ня|пн|па|аў|ат|ср|се|чц|ча|пт|пя|сб|су)\.?/i,
    abbreviated: /^(нядз?|ндз|пнд|пан|аўт|срд|сер|чцьв|чаць|птн|пят|суб).?/i,
    wide: /^(нядзел[яі]|панядзел(ак|ка)|аўтор(ак|ка)|серад[аы]|чацьв(ер|ярга)|пятніц[аы]|субот[аы])/i
};
var $fc4d7df96cd5631b$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^а/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н/i,
        /^п[ан]/i,
        /^а/i,
        /^с[ер]/i,
        /^ч/i,
        /^п[ят]/i,
        /^с[уб]/i
    ]
};
var $fc4d7df96cd5631b$var$matchDayPeriodPatterns = {
    narrow: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    abbreviated: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
    wide: /^([дп]п|поўнач|поўдзень|раніц[аы]|дзень|дня|вечара?|ночы?)/i
};
var $fc4d7df96cd5631b$var$parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^поўн/i,
        noon: /^поўд/i,
        morning: /^р/i,
        afternoon: /^д[зн]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
var $fc4d7df96cd5631b$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $fc4d7df96cd5631b$var$matchOrdinalNumberPattern,
        parsePattern: $fc4d7df96cd5631b$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $fc4d7df96cd5631b$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fc4d7df96cd5631b$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $fc4d7df96cd5631b$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fc4d7df96cd5631b$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $fc4d7df96cd5631b$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fc4d7df96cd5631b$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $fc4d7df96cd5631b$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fc4d7df96cd5631b$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $fc4d7df96cd5631b$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fc4d7df96cd5631b$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $fc4d7df96cd5631b$export$2e2bcd8739ae039 = $fc4d7df96cd5631b$var$match;

});


parcelRegister("h9brY", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7bc28b8f9ab9736$export$2e2bcd8739ae039);

var $d7DzN = parcelRequire("d7DzN");

var $gPTG0 = parcelRequire("gPTG0");

var $9l9DU = parcelRequire("9l9DU");

var $kCL42 = parcelRequire("kCL42");

var $7QKql = parcelRequire("7QKql");
/**
 * @type {Locale}
 * @category Locales
 * @summary Bulgarian locale.
 * @language Bulgarian
 * @iso-639-2 bul
 * @author Nikolay Stoynov [@arvigeus]{@link https://github.com/arvigeus}
 * @author Tsvetan Ovedenski [@fintara]{@link https://github.com/fintara}
 */ var $c7bc28b8f9ab9736$var$locale = {
    code: "bg",
    formatDistance: (0, $d7DzN.default),
    formatLong: (0, $gPTG0.default),
    formatRelative: (0, $9l9DU.default),
    localize: (0, $kCL42.default),
    match: (0, $7QKql.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $c7bc28b8f9ab9736$export$2e2bcd8739ae039 = $c7bc28b8f9ab9736$var$locale;

});
parcelRegister("d7DzN", function(module, exports) {

$parcel$export(module.exports, "default", () => $98daa0d7a8b98ee2$export$2e2bcd8739ae039);
var $98daa0d7a8b98ee2$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    xSeconds: {
        one: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    halfAMinute: "\u043F\u043E\u043B\u043E\u0432\u0438\u043D \u043C\u0438\u043D\u0443\u0442\u0430",
    lessThanXMinutes: {
        one: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "\u043F\u043E-\u043C\u0430\u043B\u043A\u043E \u043E\u0442 {{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
    },
    xMinutes: {
        one: "1 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
    },
    aboutXHours: {
        one: "\u043E\u043A\u043E\u043B\u043E \u0447\u0430\u0441",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u0430"
    },
    xHours: {
        one: "1 \u0447\u0430\u0441",
        other: "{{count}} \u0447\u0430\u0441\u0430"
    },
    xDays: {
        one: "1 \u0434\u0435\u043D",
        other: "{{count}} \u0434\u043D\u0438"
    },
    aboutXWeeks: {
        one: "\u043E\u043A\u043E\u043B\u043E \u0441\u0435\u0434\u043C\u0438\u0446\u0430",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0441\u0435\u0434\u043C\u0438\u0446\u0438"
    },
    xWeeks: {
        one: "1 \u0441\u0435\u0434\u043C\u0438\u0446\u0430",
        other: "{{count}} \u0441\u0435\u0434\u043C\u0438\u0446\u0438"
    },
    aboutXMonths: {
        one: "\u043E\u043A\u043E\u043B\u043E \u043C\u0435\u0441\u0435\u0446",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u0435\u0446\u0430"
    },
    xMonths: {
        one: "1 \u043C\u0435\u0441\u0435\u0446",
        other: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0430"
    },
    aboutXYears: {
        one: "\u043E\u043A\u043E\u043B\u043E \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    xYears: {
        one: "1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    overXYears: {
        one: "\u043D\u0430\u0434 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043D\u0430\u0434 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    almostXYears: {
        one: "\u043F\u043E\u0447\u0442\u0438 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    }
};
var $98daa0d7a8b98ee2$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $98daa0d7a8b98ee2$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0441\u043B\u0435\u0434 " + result;
        else return "\u043F\u0440\u0435\u0434\u0438 " + result;
    }
    return result;
};
var $98daa0d7a8b98ee2$export$2e2bcd8739ae039 = $98daa0d7a8b98ee2$var$formatDistance;

});

parcelRegister("gPTG0", function(module, exports) {

$parcel$export(module.exports, "default", () => $c41c98fb9ab14358$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $c41c98fb9ab14358$var$dateFormats = {
    full: "EEEE, dd MMMM yyyy",
    long: "dd MMMM yyyy",
    medium: "dd MMM yyyy",
    short: "dd/MM/yyyy"
};
var $c41c98fb9ab14358$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "H:mm"
};
var $c41c98fb9ab14358$var$dateTimeFormats = {
    any: "{{date}} {{time}}"
};
var $c41c98fb9ab14358$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $c41c98fb9ab14358$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $c41c98fb9ab14358$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $c41c98fb9ab14358$var$dateTimeFormats,
        defaultWidth: "any"
    })
};
var $c41c98fb9ab14358$export$2e2bcd8739ae039 = $c41c98fb9ab14358$var$formatLong;

});

parcelRegister("9l9DU", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ccd8e0def436de7$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $6KZXu = parcelRequire("6KZXu");
// Adapted from the `ru` translation
var $6ccd8e0def436de7$var$weekdays = [
    "\u043D\u0435\u0434\u0435\u043B\u044F",
    "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
    "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
    "\u0441\u0440\u044F\u0434\u0430",
    "\u0447\u0435\u0442\u0432\u044A\u0440\u0442\u044A\u043A",
    "\u043F\u0435\u0442\u044A\u043A",
    "\u0441\u044A\u0431\u043E\u0442\u0430"
];
function $6ccd8e0def436de7$var$lastWeek(day) {
    var weekday = $6ccd8e0def436de7$var$weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u043C\u0438\u043D\u0430\u043B\u0430\u0442\u0430 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u043C\u0438\u043D\u0430\u043B\u0438\u044F " + weekday + " \u0432' p";
    }
}
function $6ccd8e0def436de7$var$thisWeek(day) {
    var weekday = $6ccd8e0def436de7$var$weekdays[day];
    if (day === 2 /* Tue */ ) return "'\u0432\u044A\u0432 " + weekday + " \u0432' p";
    else return "'\u0432 " + weekday + " \u0432' p";
}
function $6ccd8e0def436de7$var$nextWeek(day) {
    var weekday = $6ccd8e0def436de7$var$weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u0441\u043B\u0435\u0434\u0432\u0430\u0449\u0430\u0442\u0430 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u0441\u043B\u0435\u0434\u0432\u0430\u0449\u0438\u044F " + weekday + " \u0432' p";
    }
}
var $6ccd8e0def436de7$var$lastWeekFormatToken = function lastWeekFormatToken(dirtyDate, baseDate, options) {
    var date = (0, $gdr0J.default)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $6KZXu.default)(date, baseDate, options)) return $6ccd8e0def436de7$var$thisWeek(day);
    else return $6ccd8e0def436de7$var$lastWeek(day);
};
var $6ccd8e0def436de7$var$nextWeekFormatToken = function nextWeekFormatToken(dirtyDate, baseDate, options) {
    var date = (0, $gdr0J.default)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $6KZXu.default)(date, baseDate, options)) return $6ccd8e0def436de7$var$thisWeek(day);
    else return $6ccd8e0def436de7$var$nextWeek(day);
};
var $6ccd8e0def436de7$var$formatRelativeLocale = {
    lastWeek: $6ccd8e0def436de7$var$lastWeekFormatToken,
    yesterday: "'\u0432\u0447\u0435\u0440\u0430 \u0432' p",
    today: "'\u0434\u043D\u0435\u0441 \u0432' p",
    tomorrow: "'\u0443\u0442\u0440\u0435 \u0432' p",
    nextWeek: $6ccd8e0def436de7$var$nextWeekFormatToken,
    other: "P"
};
var $6ccd8e0def436de7$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $6ccd8e0def436de7$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
var $6ccd8e0def436de7$export$2e2bcd8739ae039 = $6ccd8e0def436de7$var$formatRelative;

});

parcelRegister("kCL42", function(module, exports) {

$parcel$export(module.exports, "default", () => $f03bdd330ba78882$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $f03bdd330ba78882$var$eraValues = {
    narrow: [
        "\u043F\u0440.\u043D.\u0435.",
        "\u043D.\u0435."
    ],
    abbreviated: [
        "\u043F\u0440\u0435\u0434\u0438 \u043D. \u0435.",
        "\u043D. \u0435."
    ],
    wide: [
        "\u043F\u0440\u0435\u0434\u0438 \u043D\u043E\u0432\u0430\u0442\u0430 \u0435\u0440\u0430",
        "\u043D\u043E\u0432\u0430\u0442\u0430 \u0435\u0440\u0430"
    ]
};
var $f03bdd330ba78882$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-\u0432\u043E \u0442\u0440\u0438\u043C\u0435\u0441.",
        "2-\u0440\u043E \u0442\u0440\u0438\u043C\u0435\u0441.",
        "3-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441.",
        "4-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441."
    ],
    wide: [
        "1-\u0432\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435",
        "2-\u0440\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435",
        "3-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435",
        "4-\u0442\u043E \u0442\u0440\u0438\u043C\u0435\u0441\u0435\u0447\u0438\u0435"
    ]
};
var $f03bdd330ba78882$var$monthValues = {
    abbreviated: [
        "\u044F\u043D\u0443",
        "\u0444\u0435\u0432",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0439",
        "\u044E\u043D\u0438",
        "\u044E\u043B\u0438",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043F",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u0435",
        "\u0434\u0435\u043A"
    ],
    wide: [
        "\u044F\u043D\u0443\u0430\u0440\u0438",
        "\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0438\u043B",
        "\u043C\u0430\u0439",
        "\u044E\u043D\u0438",
        "\u044E\u043B\u0438",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043F\u0442\u0435\u043C\u0432\u0440\u0438",
        "\u043E\u043A\u0442\u043E\u043C\u0432\u0440\u0438",
        "\u043D\u043E\u0435\u043C\u0432\u0440\u0438",
        "\u0434\u0435\u043A\u0435\u043C\u0432\u0440\u0438"
    ]
};
var $f03bdd330ba78882$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0434",
        "\u043F\u043D",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0442",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0432\u0442\u043E",
        "\u0441\u0440\u044F",
        "\u0447\u0435\u0442",
        "\u043F\u0435\u0442",
        "\u0441\u044A\u0431"
    ],
    wide: [
        "\u043D\u0435\u0434\u0435\u043B\u044F",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
        "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
        "\u0441\u0440\u044F\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u044A\u0440\u0442\u044A\u043A",
        "\u043F\u0435\u0442\u044A\u043A",
        "\u0441\u044A\u0431\u043E\u0442\u0430"
    ]
};
var $f03bdd330ba78882$var$dayPeriodValues = {
    wide: {
        am: "\u043F\u0440\u0435\u0434\u0438 \u043E\u0431\u044F\u0434",
        pm: "\u0441\u043B\u0435\u0434 \u043E\u0431\u044F\u0434",
        midnight: "\u0432 \u043F\u043E\u043B\u0443\u043D\u043E\u0449",
        noon: "\u043D\u0430 \u043E\u0431\u044F\u0434",
        morning: "\u0441\u0443\u0442\u0440\u0438\u043D\u0442\u0430",
        afternoon: "\u0441\u043B\u0435\u0434\u043E\u0431\u0435\u0434",
        evening: "\u0432\u0435\u0447\u0435\u0440\u0442\u0430",
        night: "\u043F\u0440\u0435\u0437 \u043D\u043E\u0449\u0442\u0430"
    }
};
function $f03bdd330ba78882$var$isFeminine(unit) {
    return unit === "year" || unit === "week" || unit === "minute" || unit === "second";
}
function $f03bdd330ba78882$var$isNeuter(unit) {
    return unit === "quarter";
}
function $f03bdd330ba78882$var$numberWithSuffix(number, unit, masculine, feminine, neuter) {
    var suffix = $f03bdd330ba78882$var$isNeuter(unit) ? neuter : $f03bdd330ba78882$var$isFeminine(unit) ? feminine : masculine;
    return number + "-" + suffix;
}
var $f03bdd330ba78882$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    if (number === 0) return $f03bdd330ba78882$var$numberWithSuffix(0, unit, "\u0435\u0432", "\u0435\u0432\u0430", "\u0435\u0432\u043E");
    else if (number % 1000 === 0) return $f03bdd330ba78882$var$numberWithSuffix(number, unit, "\u0435\u043D", "\u043D\u0430", "\u043D\u043E");
    else if (number % 100 === 0) return $f03bdd330ba78882$var$numberWithSuffix(number, unit, "\u0442\u0435\u043D", "\u0442\u043D\u0430", "\u0442\u043D\u043E");
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return $f03bdd330ba78882$var$numberWithSuffix(number, unit, "\u0432\u0438", "\u0432\u0430", "\u0432\u043E");
        case 2:
            return $f03bdd330ba78882$var$numberWithSuffix(number, unit, "\u0440\u0438", "\u0440\u0430", "\u0440\u043E");
        case 7:
        case 8:
            return $f03bdd330ba78882$var$numberWithSuffix(number, unit, "\u043C\u0438", "\u043C\u0430", "\u043C\u043E");
    }
    return $f03bdd330ba78882$var$numberWithSuffix(number, unit, "\u0442\u0438", "\u0442\u0430", "\u0442\u043E");
};
var $f03bdd330ba78882$var$localize = {
    ordinalNumber: $f03bdd330ba78882$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $f03bdd330ba78882$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $f03bdd330ba78882$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $f03bdd330ba78882$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $f03bdd330ba78882$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $f03bdd330ba78882$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};
var $f03bdd330ba78882$export$2e2bcd8739ae039 = $f03bdd330ba78882$var$localize;

});

parcelRegister("7QKql", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b71668d8bfddf91$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $5b71668d8bfddf91$var$matchOrdinalNumberPattern = /^(\d+)(-?[врмт][аи]|-?т?(ен|на)|-?(ев|ева))?/i;
var $5b71668d8bfddf91$var$parseOrdinalNumberPattern = /\d+/i;
var $5b71668d8bfddf91$var$matchEraPatterns = {
    narrow: /^((пр)?н\.?\s?е\.?)/i,
    abbreviated: /^((пр)?н\.?\s?е\.?)/i,
    wide: /^(преди новата ера|новата ера|нова ера)/i
};
var $5b71668d8bfddf91$var$parseEraPatterns = {
    any: [
        /^п/i,
        /^н/i
    ]
};
var $5b71668d8bfddf91$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[врт]?o?)? тримес.?/i,
    wide: /^[1234](-?[врт]?о?)? тримесечие/i
};
var $5b71668d8bfddf91$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $5b71668d8bfddf91$var$matchDayPatterns = {
    narrow: /^[нпвсч]/i,
    short: /^(нд|пн|вт|ср|чт|пт|сб)/i,
    abbreviated: /^(нед|пон|вто|сря|чет|пет|съб)/i,
    wide: /^(неделя|понеделник|вторник|сряда|четвъртък|петък|събота)/i
};
var $5b71668d8bfddf91$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н[ед]/i,
        /^п[он]/i,
        /^вт/i,
        /^ср/i,
        /^ч[ет]/i,
        /^п[ет]/i,
        /^с[ъб]/i
    ]
};
var $5b71668d8bfddf91$var$matchMonthPatterns = {
    abbreviated: /^(яну|фев|мар|апр|май|юни|юли|авг|сеп|окт|ное|дек)/i,
    wide: /^(януари|февруари|март|април|май|юни|юли|август|септември|октомври|ноември|декември)/i
};
var $5b71668d8bfddf91$var$parseMonthPatterns = {
    any: [
        /^я/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^май/i,
        /^юн/i,
        /^юл/i,
        /^ав/i,
        /^се/i,
        /^окт/i,
        /^но/i,
        /^де/i
    ]
};
var $5b71668d8bfddf91$var$matchDayPeriodPatterns = {
    any: /^(преди о|след о|в по|на о|през|веч|сут|следо)/i
};
var $5b71668d8bfddf91$var$parseDayPeriodPatterns = {
    any: {
        am: /^преди о/i,
        pm: /^след о/i,
        midnight: /^в пол/i,
        noon: /^на об/i,
        morning: /^сут/i,
        afternoon: /^следо/i,
        evening: /^веч/i,
        night: /^през н/i
    }
};
var $5b71668d8bfddf91$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $5b71668d8bfddf91$var$matchOrdinalNumberPattern,
        parsePattern: $5b71668d8bfddf91$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $5b71668d8bfddf91$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5b71668d8bfddf91$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $5b71668d8bfddf91$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5b71668d8bfddf91$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $5b71668d8bfddf91$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5b71668d8bfddf91$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $5b71668d8bfddf91$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5b71668d8bfddf91$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $5b71668d8bfddf91$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $5b71668d8bfddf91$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $5b71668d8bfddf91$export$2e2bcd8739ae039 = $5b71668d8bfddf91$var$match;

});


parcelRegister("iLGEY", function(module, exports) {

$parcel$export(module.exports, "default", () => $da9db52a623fe51b$export$2e2bcd8739ae039);

var $kLXGp = parcelRequire("kLXGp");

var $lNjXw = parcelRequire("lNjXw");

var $lkjoL = parcelRequire("lkjoL");

var $ftXbx = parcelRequire("ftXbx");

var $9nWnu = parcelRequire("9nWnu");
/**
 * @type {Locale}
 * @category Locales
 * @summary Bengali locale.
 * @language Bengali
 * @iso-639-2 ben
 * @author Touhidur Rahman [@touhidrahman]{@link https://github.com/touhidrahman}
 * @author Farhad Yasir [@nutboltu]{@link https://github.com/nutboltu}
 */ var $da9db52a623fe51b$var$locale = {
    code: "bn",
    formatDistance: (0, $kLXGp.default),
    formatLong: (0, $lNjXw.default),
    formatRelative: (0, $lkjoL.default),
    localize: (0, $ftXbx.default),
    match: (0, $9nWnu.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $da9db52a623fe51b$export$2e2bcd8739ae039 = $da9db52a623fe51b$var$locale;

});
parcelRegister("kLXGp", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1f67e409ca4e4fe$export$2e2bcd8739ae039);

var $ftXbx = parcelRequire("ftXbx");
var $f1f67e409ca4e4fe$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1"
    },
    xSeconds: {
        one: "\u09E7 \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1",
        other: "{{count}} \u09B8\u09C7\u0995\u09C7\u09A8\u09CD\u09A1"
    },
    halfAMinute: "\u0986\u09A7 \u09AE\u09BF\u09A8\u09BF\u099F",
    lessThanXMinutes: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AE\u09BF\u09A8\u09BF\u099F",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AE\u09BF\u09A8\u09BF\u099F"
    },
    xMinutes: {
        one: "\u09E7 \u09AE\u09BF\u09A8\u09BF\u099F",
        other: "{{count}} \u09AE\u09BF\u09A8\u09BF\u099F"
    },
    aboutXHours: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u0998\u09A8\u09CD\u099F\u09BE",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u0998\u09A8\u09CD\u099F\u09BE"
    },
    xHours: {
        one: "\u09E7 \u0998\u09A8\u09CD\u099F\u09BE",
        other: "{{count}} \u0998\u09A8\u09CD\u099F\u09BE"
    },
    xDays: {
        one: "\u09E7 \u09A6\u09BF\u09A8",
        other: "{{count}} \u09A6\u09BF\u09A8"
    },
    aboutXWeeks: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9"
    },
    xWeeks: {
        one: "\u09E7 \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9",
        other: "{{count}} \u09B8\u09AA\u09CD\u09A4\u09BE\u09B9"
    },
    aboutXMonths: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AE\u09BE\u09B8",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AE\u09BE\u09B8"
    },
    xMonths: {
        one: "\u09E7 \u09AE\u09BE\u09B8",
        other: "{{count}} \u09AE\u09BE\u09B8"
    },
    aboutXYears: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AC\u099B\u09B0",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AC\u099B\u09B0"
    },
    xYears: {
        one: "\u09E7 \u09AC\u099B\u09B0",
        other: "{{count}} \u09AC\u099B\u09B0"
    },
    overXYears: {
        one: "\u09E7 \u09AC\u099B\u09B0\u09C7\u09B0 \u09AC\u09C7\u09B6\u09BF",
        other: "{{count}} \u09AC\u099B\u09B0\u09C7\u09B0 \u09AC\u09C7\u09B6\u09BF"
    },
    almostXYears: {
        one: "\u09AA\u09CD\u09B0\u09BE\u09DF \u09E7 \u09AC\u099B\u09B0",
        other: "\u09AA\u09CD\u09B0\u09BE\u09DF {{count}} \u09AC\u099B\u09B0"
    }
};
var $f1f67e409ca4e4fe$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $f1f67e409ca4e4fe$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", (0, $ftXbx.numberToLocale)(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " \u098F\u09B0 \u09AE\u09A7\u09CD\u09AF\u09C7";
        else return result + " \u0986\u0997\u09C7";
    }
    return result;
};
var $f1f67e409ca4e4fe$export$2e2bcd8739ae039 = $f1f67e409ca4e4fe$var$formatDistance;

});
parcelRegister("ftXbx", function(module, exports) {

$parcel$export(module.exports, "numberToLocale", () => $b4577964699a6882$export$3e1d599946644f03);
$parcel$export(module.exports, "default", () => $b4577964699a6882$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $b4577964699a6882$var$numberValues = {
    locale: {
        "1": "\u09E7",
        "2": "\u09E8",
        "3": "\u09E9",
        "4": "\u09EA",
        "5": "\u09EB",
        "6": "\u09EC",
        "7": "\u09ED",
        "8": "\u09EE",
        "9": "\u09EF",
        "0": "\u09E6"
    },
    number: {
        "\u09E7": "1",
        "\u09E8": "2",
        "\u09E9": "3",
        "\u09EA": "4",
        "\u09EB": "5",
        "\u09EC": "6",
        "\u09ED": "7",
        "\u09EE": "8",
        "\u09EF": "9",
        "\u09E6": "0"
    }
};
var $b4577964699a6882$var$eraValues = {
    narrow: [
        "\u0996\u09CD\u09B0\u09BF\u0983\u09AA\u09C2\u0983",
        "\u0996\u09CD\u09B0\u09BF\u0983"
    ],
    abbreviated: [
        "\u0996\u09CD\u09B0\u09BF\u0983\u09AA\u09C2\u09B0\u09CD\u09AC",
        "\u0996\u09CD\u09B0\u09BF\u0983"
    ],
    wide: [
        "\u0996\u09CD\u09B0\u09BF\u09B8\u09CD\u099F\u09AA\u09C2\u09B0\u09CD\u09AC",
        "\u0996\u09CD\u09B0\u09BF\u09B8\u09CD\u099F\u09BE\u09AC\u09CD\u09A6"
    ]
};
var $b4577964699a6882$var$quarterValues = {
    narrow: [
        "\u09E7",
        "\u09E8",
        "\u09E9",
        "\u09EA"
    ],
    abbreviated: [
        "\u09E7\u09A4\u09CD\u09B0\u09C8",
        "\u09E8\u09A4\u09CD\u09B0\u09C8",
        "\u09E9\u09A4\u09CD\u09B0\u09C8",
        "\u09EA\u09A4\u09CD\u09B0\u09C8"
    ],
    wide: [
        "\u09E7\u09AE \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995",
        "\u09E8\u09DF \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995",
        "\u09E9\u09DF \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995",
        "\u09EA\u09B0\u09CD\u09A5 \u09A4\u09CD\u09B0\u09C8\u09AE\u09BE\u09B8\u09BF\u0995"
    ]
};
var $b4577964699a6882$var$monthValues = {
    narrow: [
        "\u099C\u09BE\u09A8\u09C1",
        "\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1",
        "\u09AE\u09BE\u09B0\u09CD\u099A",
        "\u098F\u09AA\u09CD\u09B0\u09BF\u09B2",
        "\u09AE\u09C7",
        "\u099C\u09C1\u09A8",
        "\u099C\u09C1\u09B2\u09BE\u0987",
        "\u0986\u0997\u09B8\u09CD\u099F",
        "\u09B8\u09C7\u09AA\u09CD\u099F",
        "\u0985\u0995\u09CD\u099F\u09CB",
        "\u09A8\u09AD\u09C7",
        "\u09A1\u09BF\u09B8\u09C7"
    ],
    abbreviated: [
        "\u099C\u09BE\u09A8\u09C1",
        "\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1",
        "\u09AE\u09BE\u09B0\u09CD\u099A",
        "\u098F\u09AA\u09CD\u09B0\u09BF\u09B2",
        "\u09AE\u09C7",
        "\u099C\u09C1\u09A8",
        "\u099C\u09C1\u09B2\u09BE\u0987",
        "\u0986\u0997\u09B8\u09CD\u099F",
        "\u09B8\u09C7\u09AA\u09CD\u099F",
        "\u0985\u0995\u09CD\u099F\u09CB",
        "\u09A8\u09AD\u09C7",
        "\u09A1\u09BF\u09B8\u09C7"
    ],
    wide: [
        "\u099C\u09BE\u09A8\u09C1\u09DF\u09BE\u09B0\u09BF",
        "\u09AB\u09C7\u09AC\u09CD\u09B0\u09C1\u09DF\u09BE\u09B0\u09BF",
        "\u09AE\u09BE\u09B0\u09CD\u099A",
        "\u098F\u09AA\u09CD\u09B0\u09BF\u09B2",
        "\u09AE\u09C7",
        "\u099C\u09C1\u09A8",
        "\u099C\u09C1\u09B2\u09BE\u0987",
        "\u0986\u0997\u09B8\u09CD\u099F",
        "\u09B8\u09C7\u09AA\u09CD\u099F\u09C7\u09AE\u09CD\u09AC\u09B0",
        "\u0985\u0995\u09CD\u099F\u09CB\u09AC\u09B0",
        "\u09A8\u09AD\u09C7\u09AE\u09CD\u09AC\u09B0",
        "\u09A1\u09BF\u09B8\u09C7\u09AE\u09CD\u09AC\u09B0"
    ]
};
var $b4577964699a6882$var$dayValues = {
    narrow: [
        "\u09B0",
        "\u09B8\u09CB",
        "\u09AE",
        "\u09AC\u09C1",
        "\u09AC\u09C3",
        "\u09B6\u09C1",
        "\u09B6"
    ],
    short: [
        "\u09B0\u09AC\u09BF",
        "\u09B8\u09CB\u09AE",
        "\u09AE\u0999\u09CD\u0997\u09B2",
        "\u09AC\u09C1\u09A7",
        "\u09AC\u09C3\u09B9",
        "\u09B6\u09C1\u0995\u09CD\u09B0",
        "\u09B6\u09A8\u09BF"
    ],
    abbreviated: [
        "\u09B0\u09AC\u09BF",
        "\u09B8\u09CB\u09AE",
        "\u09AE\u0999\u09CD\u0997\u09B2",
        "\u09AC\u09C1\u09A7",
        "\u09AC\u09C3\u09B9",
        "\u09B6\u09C1\u0995\u09CD\u09B0",
        "\u09B6\u09A8\u09BF"
    ],
    wide: [
        "\u09B0\u09AC\u09BF\u09AC\u09BE\u09B0",
        "\u09B8\u09CB\u09AE\u09AC\u09BE\u09B0",
        "\u09AE\u0999\u09CD\u0997\u09B2\u09AC\u09BE\u09B0",
        "\u09AC\u09C1\u09A7\u09AC\u09BE\u09B0",
        "\u09AC\u09C3\u09B9\u09B8\u09CD\u09AA\u09A4\u09BF\u09AC\u09BE\u09B0 ",
        "\u09B6\u09C1\u0995\u09CD\u09B0\u09AC\u09BE\u09B0",
        "\u09B6\u09A8\u09BF\u09AC\u09BE\u09B0"
    ]
};
var $b4577964699a6882$var$dayPeriodValues = {
    narrow: {
        am: "\u09AA\u09C2",
        pm: "\u0985\u09AA",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    },
    abbreviated: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    },
    wide: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    }
};
var $b4577964699a6882$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u09AA\u09C2",
        pm: "\u0985\u09AA",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    },
    abbreviated: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    },
    wide: {
        am: "\u09AA\u09C2\u09B0\u09CD\u09AC\u09BE\u09B9\u09CD\u09A8",
        pm: "\u0985\u09AA\u09B0\u09BE\u09B9\u09CD\u09A8",
        midnight: "\u09AE\u09A7\u09CD\u09AF\u09B0\u09BE\u09A4",
        noon: "\u09AE\u09A7\u09CD\u09AF\u09BE\u09B9\u09CD\u09A8",
        morning: "\u09B8\u0995\u09BE\u09B2",
        afternoon: "\u09AC\u09BF\u0995\u09BE\u09B2",
        evening: "\u09B8\u09A8\u09CD\u09A7\u09CD\u09AF\u09BE",
        night: "\u09B0\u09BE\u09A4"
    }
};
function $b4577964699a6882$var$dateOrdinalNumber(number, localeNumber) {
    if (number > 18 && number <= 31) return localeNumber + "\u09B6\u09C7";
    else switch(number){
        case 1:
            return localeNumber + "\u09B2\u09BE";
        case 2:
        case 3:
            return localeNumber + "\u09B0\u09BE";
        case 4:
            return localeNumber + "\u09A0\u09BE";
        default:
            return localeNumber + "\u0987";
    }
}
var $b4577964699a6882$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var localeNumber = $b4577964699a6882$export$3e1d599946644f03(number);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    if (unit === "date") return $b4577964699a6882$var$dateOrdinalNumber(number, localeNumber);
    if (number > 10 || number === 0) return localeNumber + "\u09A4\u09AE";
    var rem10 = number % 10;
    switch(rem10){
        case 2:
        case 3:
            return localeNumber + "\u09DF";
        case 4:
            return localeNumber + "\u09B0\u09CD\u09A5";
        case 6:
            return localeNumber + "\u09B7\u09CD\u09A0";
        default:
            return localeNumber + "\u09AE";
    }
};
function $b4577964699a6882$export$3e1d599946644f03(enNumber) {
    return enNumber.toString().replace(/\d/g, function(match) {
        return $b4577964699a6882$var$numberValues.locale[match];
    });
}
var $b4577964699a6882$var$localize = {
    ordinalNumber: $b4577964699a6882$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $b4577964699a6882$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $b4577964699a6882$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $b4577964699a6882$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $b4577964699a6882$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $b4577964699a6882$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $b4577964699a6882$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $b4577964699a6882$export$2e2bcd8739ae039 = $b4577964699a6882$var$localize;

});


parcelRegister("lNjXw", function(module, exports) {

$parcel$export(module.exports, "default", () => $fddda8052a61deea$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $fddda8052a61deea$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $fddda8052a61deea$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $fddda8052a61deea$var$dateTimeFormats = {
    full: "{{date}} {{time}} '\u09B8\u09AE\u09DF'",
    long: "{{date}} {{time}} '\u09B8\u09AE\u09DF'",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $fddda8052a61deea$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $fddda8052a61deea$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $fddda8052a61deea$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $fddda8052a61deea$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $fddda8052a61deea$export$2e2bcd8739ae039 = $fddda8052a61deea$var$formatLong;

});

parcelRegister("lkjoL", function(module, exports) {

$parcel$export(module.exports, "default", () => $f86a835640c92743$export$2e2bcd8739ae039);
var $f86a835640c92743$var$formatRelativeLocale = {
    lastWeek: "'\u0997\u09A4' eeee '\u09B8\u09AE\u09DF' p",
    yesterday: "'\u0997\u09A4\u0995\u09BE\u09B2' '\u09B8\u09AE\u09DF' p",
    today: "'\u0986\u099C' '\u09B8\u09AE\u09DF' p",
    tomorrow: "'\u0986\u0997\u09BE\u09AE\u09C0\u0995\u09BE\u09B2' '\u09B8\u09AE\u09DF' p",
    nextWeek: "eeee '\u09B8\u09AE\u09DF' p",
    other: "P"
};
var $f86a835640c92743$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $f86a835640c92743$var$formatRelativeLocale[token];
};
var $f86a835640c92743$export$2e2bcd8739ae039 = $f86a835640c92743$var$formatRelative;

});

parcelRegister("9nWnu", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d538baa23aa9670$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $6d538baa23aa9670$var$matchOrdinalNumberPattern = /^(\d+)(ম|য়|র্থ|ষ্ঠ|শে|ই|তম)?/i;
var $6d538baa23aa9670$var$parseOrdinalNumberPattern = /\d+/i;
var $6d538baa23aa9670$var$matchEraPatterns = {
    narrow: /^(খ্রিঃপূঃ|খ্রিঃ)/i,
    abbreviated: /^(খ্রিঃপূর্ব|খ্রিঃ)/i,
    wide: /^(খ্রিস্টপূর্ব|খ্রিস্টাব্দ)/i
};
var $6d538baa23aa9670$var$parseEraPatterns = {
    narrow: [
        /^খ্রিঃপূঃ/i,
        /^খ্রিঃ/i
    ],
    abbreviated: [
        /^খ্রিঃপূর্ব/i,
        /^খ্রিঃ/i
    ],
    wide: [
        /^খ্রিস্টপূর্ব/i,
        /^খ্রিস্টাব্দ/i
    ]
};
var $6d538baa23aa9670$var$matchQuarterPatterns = {
    narrow: /^[১২৩৪]/i,
    abbreviated: /^[১২৩৪]ত্রৈ/i,
    wide: /^[১২৩৪](ম|য়|র্থ)? ত্রৈমাসিক/i
};
var $6d538baa23aa9670$var$parseQuarterPatterns = {
    any: [
        /১/i,
        /২/i,
        /৩/i,
        /৪/i
    ]
};
var $6d538baa23aa9670$var$matchMonthPatterns = {
    narrow: /^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
    abbreviated: /^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
    wide: /^(জানুয়ারি|ফেব্রুয়ারি|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্টেম্বর|অক্টোবর|নভেম্বর|ডিসেম্বর)/i
};
var $6d538baa23aa9670$var$parseMonthPatterns = {
    any: [
        /^জানু/i,
        /^ফেব্রু/i,
        /^মার্চ/i,
        /^এপ্রিল/i,
        /^মে/i,
        /^জুন/i,
        /^জুলাই/i,
        /^আগস্ট/i,
        /^সেপ্ট/i,
        /^অক্টো/i,
        /^নভে/i,
        /^ডিসে/i
    ]
};
var $6d538baa23aa9670$var$matchDayPatterns = {
    narrow: /^(র|সো|ম|বু|বৃ|শু|শ)+/i,
    short: /^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
    abbreviated: /^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
    wide: /^(রবিবার|সোমবার|মঙ্গলবার|বুধবার|বৃহস্পতিবার |শুক্রবার|শনিবার)+/i
};
var $6d538baa23aa9670$var$parseDayPatterns = {
    narrow: [
        /^র/i,
        /^সো/i,
        /^ম/i,
        /^বু/i,
        /^বৃ/i,
        /^শু/i,
        /^শ/i
    ],
    short: [
        /^রবি/i,
        /^সোম/i,
        /^মঙ্গল/i,
        /^বুধ/i,
        /^বৃহ/i,
        /^শুক্র/i,
        /^শনি/i
    ],
    abbreviated: [
        /^রবি/i,
        /^সোম/i,
        /^মঙ্গল/i,
        /^বুধ/i,
        /^বৃহ/i,
        /^শুক্র/i,
        /^শনি/i
    ],
    wide: [
        /^রবিবার/i,
        /^সোমবার/i,
        /^মঙ্গলবার/i,
        /^বুধবার/i,
        /^বৃহস্পতিবার /i,
        /^শুক্রবার/i,
        /^শনিবার/i
    ]
};
var $6d538baa23aa9670$var$matchDayPeriodPatterns = {
    narrow: /^(পূ|অপ|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
    abbreviated: /^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
    wide: /^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i
};
var $6d538baa23aa9670$var$parseDayPeriodPatterns = {
    any: {
        am: /^পূ/i,
        pm: /^অপ/i,
        midnight: /^মধ্যরাত/i,
        noon: /^মধ্যাহ্ন/i,
        morning: /সকাল/i,
        afternoon: /বিকাল/i,
        evening: /সন্ধ্যা/i,
        night: /রাত/i
    }
};
var $6d538baa23aa9670$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $6d538baa23aa9670$var$matchOrdinalNumberPattern,
        parsePattern: $6d538baa23aa9670$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $6d538baa23aa9670$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6d538baa23aa9670$var$parseEraPatterns,
        defaultParseWidth: "wide"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $6d538baa23aa9670$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6d538baa23aa9670$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $6d538baa23aa9670$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6d538baa23aa9670$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $6d538baa23aa9670$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6d538baa23aa9670$var$parseDayPatterns,
        defaultParseWidth: "wide"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $6d538baa23aa9670$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6d538baa23aa9670$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $6d538baa23aa9670$export$2e2bcd8739ae039 = $6d538baa23aa9670$var$match;

});


parcelRegister("boKMd", function(module, exports) {

$parcel$export(module.exports, "default", () => $84c63876b9071cf5$export$2e2bcd8739ae039);

var $cl1bj = parcelRequire("cl1bj");

var $ewOND = parcelRequire("ewOND");

var $RUdUm = parcelRequire("RUdUm");

var $cgzHX = parcelRequire("cgzHX");

var $03g2f = parcelRequire("03g2f");
/**
 * @type {Locale}
 * @category Locales
 * @summary Bosnian locale.
 * @language Bosnian
 * @iso-639-2 bos
 * @author Branislav Lazić [@branislavlazic]{@link https://github.com/branislavlazic}
 */ var $84c63876b9071cf5$var$locale = {
    code: "bs",
    formatDistance: (0, $cl1bj.default),
    formatLong: (0, $ewOND.default),
    formatRelative: (0, $RUdUm.default),
    localize: (0, $cgzHX.default),
    match: (0, $03g2f.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $84c63876b9071cf5$export$2e2bcd8739ae039 = $84c63876b9071cf5$var$locale;

});
parcelRegister("cl1bj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fb85cd3d2671d5b$export$2e2bcd8739ae039);
var $8fb85cd3d2671d5b$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: "manje od 1 sekunde",
            withPrepositionAgo: "manje od 1 sekunde",
            withPrepositionIn: "manje od 1 sekundu"
        },
        dual: "manje od {{count}} sekunde",
        other: "manje od {{count}} sekundi"
    },
    xSeconds: {
        one: {
            standalone: "1 sekunda",
            withPrepositionAgo: "1 sekunde",
            withPrepositionIn: "1 sekundu"
        },
        dual: "{{count}} sekunde",
        other: "{{count}} sekundi"
    },
    halfAMinute: "pola minute",
    lessThanXMinutes: {
        one: {
            standalone: "manje od 1 minute",
            withPrepositionAgo: "manje od 1 minute",
            withPrepositionIn: "manje od 1 minutu"
        },
        dual: "manje od {{count}} minute",
        other: "manje od {{count}} minuta"
    },
    xMinutes: {
        one: {
            standalone: "1 minuta",
            withPrepositionAgo: "1 minute",
            withPrepositionIn: "1 minutu"
        },
        dual: "{{count}} minute",
        other: "{{count}} minuta"
    },
    aboutXHours: {
        one: {
            standalone: "oko 1 sat",
            withPrepositionAgo: "oko 1 sat",
            withPrepositionIn: "oko 1 sat"
        },
        dual: "oko {{count}} sata",
        other: "oko {{count}} sati"
    },
    xHours: {
        one: {
            standalone: "1 sat",
            withPrepositionAgo: "1 sat",
            withPrepositionIn: "1 sat"
        },
        dual: "{{count}} sata",
        other: "{{count}} sati"
    },
    xDays: {
        one: {
            standalone: "1 dan",
            withPrepositionAgo: "1 dan",
            withPrepositionIn: "1 dan"
        },
        dual: "{{count}} dana",
        other: "{{count}} dana"
    },
    aboutXWeeks: {
        one: {
            standalone: "oko 1 sedmicu",
            withPrepositionAgo: "oko 1 sedmicu",
            withPrepositionIn: "oko 1 sedmicu"
        },
        dual: "oko {{count}} sedmice",
        other: "oko {{count}} sedmice"
    },
    xWeeks: {
        one: {
            standalone: "1 sedmicu",
            withPrepositionAgo: "1 sedmicu",
            withPrepositionIn: "1 sedmicu"
        },
        dual: "{{count}} sedmice",
        other: "{{count}} sedmice"
    },
    aboutXMonths: {
        one: {
            standalone: "oko 1 mjesec",
            withPrepositionAgo: "oko 1 mjesec",
            withPrepositionIn: "oko 1 mjesec"
        },
        dual: "oko {{count}} mjeseca",
        other: "oko {{count}} mjeseci"
    },
    xMonths: {
        one: {
            standalone: "1 mjesec",
            withPrepositionAgo: "1 mjesec",
            withPrepositionIn: "1 mjesec"
        },
        dual: "{{count}} mjeseca",
        other: "{{count}} mjeseci"
    },
    aboutXYears: {
        one: {
            standalone: "oko 1 godinu",
            withPrepositionAgo: "oko 1 godinu",
            withPrepositionIn: "oko 1 godinu"
        },
        dual: "oko {{count}} godine",
        other: "oko {{count}} godina"
    },
    xYears: {
        one: {
            standalone: "1 godina",
            withPrepositionAgo: "1 godine",
            withPrepositionIn: "1 godinu"
        },
        dual: "{{count}} godine",
        other: "{{count}} godina"
    },
    overXYears: {
        one: {
            standalone: "preko 1 godinu",
            withPrepositionAgo: "preko 1 godinu",
            withPrepositionIn: "preko 1 godinu"
        },
        dual: "preko {{count}} godine",
        other: "preko {{count}} godina"
    },
    almostXYears: {
        one: {
            standalone: "gotovo 1 godinu",
            withPrepositionAgo: "gotovo 1 godinu",
            withPrepositionIn: "gotovo 1 godinu"
        },
        dual: "gotovo {{count}} godine",
        other: "gotovo {{count}} godina"
    }
};
var $8fb85cd3d2671d5b$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $8fb85cd3d2671d5b$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== "1" // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace("{{count}}", String(count));
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "za " + result;
        else return "prije " + result;
    }
    return result;
};
var $8fb85cd3d2671d5b$export$2e2bcd8739ae039 = $8fb85cd3d2671d5b$var$formatDistance;

});

parcelRegister("ewOND", function(module, exports) {

$parcel$export(module.exports, "default", () => $a93b75967e22723c$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $a93b75967e22723c$var$dateFormats = {
    full: "EEEE, d. MMMM yyyy.",
    long: "d. MMMM yyyy.",
    medium: "d. MMM yy.",
    short: "dd. MM. yy."
};
var $a93b75967e22723c$var$timeFormats = {
    full: "HH:mm:ss (zzzz)",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $a93b75967e22723c$var$dateTimeFormats = {
    full: "{{date}} 'u' {{time}}",
    long: "{{date}} 'u' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $a93b75967e22723c$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $a93b75967e22723c$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $a93b75967e22723c$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $a93b75967e22723c$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $a93b75967e22723c$export$2e2bcd8739ae039 = $a93b75967e22723c$var$formatLong;

});

parcelRegister("RUdUm", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a2090221598a9d5$export$2e2bcd8739ae039);
var $0a2090221598a9d5$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'pro\u0161le nedjelje u' p";
            case 3:
                return "'pro\u0161le srijede u' p";
            case 6:
                return "'pro\u0161le subote u' p";
            default:
                return "'pro\u0161li' EEEE 'u' p";
        }
    },
    yesterday: "'ju\u010De u' p",
    today: "'danas u' p",
    tomorrow: "'sutra u' p",
    nextWeek: function nextWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'sljede\u0107e nedjelje u' p";
            case 3:
                return "'sljede\u0107u srijedu u' p";
            case 6:
                return "'sljede\u0107u subotu u' p";
            default:
                return "'sljede\u0107i' EEEE 'u' p";
        }
    },
    other: "P"
};
var $0a2090221598a9d5$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $0a2090221598a9d5$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
var $0a2090221598a9d5$export$2e2bcd8739ae039 = $0a2090221598a9d5$var$formatRelative;

});

parcelRegister("cgzHX", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ee2ad861c0a49fb$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $8ee2ad861c0a49fb$var$eraValues = {
    narrow: [
        "pr.n.e.",
        "AD"
    ],
    abbreviated: [
        "pr. Hr.",
        "po. Hr."
    ],
    wide: [
        "Prije Hrista",
        "Poslije Hrista"
    ]
};
var $8ee2ad861c0a49fb$var$quarterValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4."
    ],
    abbreviated: [
        "1. kv.",
        "2. kv.",
        "3. kv.",
        "4. kv."
    ],
    wide: [
        "1. kvartal",
        "2. kvartal",
        "3. kvartal",
        "4. kvartal"
    ]
};
var $8ee2ad861c0a49fb$var$monthValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4.",
        "5.",
        "6.",
        "7.",
        "8.",
        "9.",
        "10.",
        "11.",
        "12."
    ],
    abbreviated: [
        "jan",
        "feb",
        "mar",
        "apr",
        "maj",
        "jun",
        "jul",
        "avg",
        "sep",
        "okt",
        "nov",
        "dec"
    ],
    wide: [
        "januar",
        "februar",
        "mart",
        "april",
        "maj",
        "juni",
        "juli",
        "avgust",
        "septembar",
        "oktobar",
        "novembar",
        "decembar"
    ]
};
var $8ee2ad861c0a49fb$var$formattingMonthValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4.",
        "5.",
        "6.",
        "7.",
        "8.",
        "9.",
        "10.",
        "11.",
        "12."
    ],
    abbreviated: [
        "jan",
        "feb",
        "mar",
        "apr",
        "maj",
        "jun",
        "jul",
        "avg",
        "sep",
        "okt",
        "nov",
        "dec"
    ],
    wide: [
        "januar",
        "februar",
        "mart",
        "april",
        "maj",
        "juni",
        "juli",
        "avgust",
        "septembar",
        "oktobar",
        "novembar",
        "decembar"
    ]
};
var $8ee2ad861c0a49fb$var$dayValues = {
    narrow: [
        "N",
        "P",
        "U",
        "S",
        "\u010C",
        "P",
        "S"
    ],
    short: [
        "ned",
        "pon",
        "uto",
        "sre",
        "\u010Det",
        "pet",
        "sub"
    ],
    abbreviated: [
        "ned",
        "pon",
        "uto",
        "sre",
        "\u010Det",
        "pet",
        "sub"
    ],
    wide: [
        "nedjelja",
        "ponedjeljak",
        "utorak",
        "srijeda",
        "\u010Detvrtak",
        "petak",
        "subota"
    ]
};
var $8ee2ad861c0a49fb$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "poslije podne",
        evening: "uve\u010De",
        night: "no\u0107u"
    }
};
var $8ee2ad861c0a49fb$var$formattingDayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "poslije podne",
        evening: "uve\u010De",
        night: "no\u0107u"
    }
};
var $8ee2ad861c0a49fb$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return String(number) + ".";
};
var $8ee2ad861c0a49fb$var$localize = {
    ordinalNumber: $8ee2ad861c0a49fb$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $8ee2ad861c0a49fb$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $8ee2ad861c0a49fb$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $8ee2ad861c0a49fb$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $8ee2ad861c0a49fb$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $8ee2ad861c0a49fb$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $8ee2ad861c0a49fb$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $8ee2ad861c0a49fb$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $8ee2ad861c0a49fb$export$2e2bcd8739ae039 = $8ee2ad861c0a49fb$var$localize;

});

parcelRegister("03g2f", function(module, exports) {

$parcel$export(module.exports, "default", () => $009cb836554e9edd$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $009cb836554e9edd$var$matchOrdinalNumberPattern = /^(\d+)\./i;
var $009cb836554e9edd$var$parseOrdinalNumberPattern = /\d+/i;
var $009cb836554e9edd$var$matchEraPatterns = {
    narrow: /^(pr\.n\.e\.|AD)/i,
    abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
    wide: /^(Prije Hrista|prije nove ere|Poslije Hrista|nova era)/i
};
var $009cb836554e9edd$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|nova)/i
    ]
};
var $009cb836554e9edd$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?kv\.?/i,
    wide: /^[1234]\. kvartal/i
};
var $009cb836554e9edd$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $009cb836554e9edd$var$matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
    wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(juni|juna)|(juli|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
};
var $009cb836554e9edd$var$parseMonthPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^avg/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $009cb836554e9edd$var$matchDayPatterns = {
    narrow: /^[npusčc]/i,
    short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    wide: /^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i
};
var $009cb836554e9edd$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $009cb836554e9edd$var$matchDayPeriodPatterns = {
    any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|poslije podne|ujutru)/i
};
var $009cb836554e9edd$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^pono/i,
        noon: /^pod/i,
        morning: /jutro/i,
        afternoon: /(poslije\s|po)+podne/i,
        evening: /(uvece|uveče)/i,
        night: /(nocu|noću)/i
    }
};
var $009cb836554e9edd$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $009cb836554e9edd$var$matchOrdinalNumberPattern,
        parsePattern: $009cb836554e9edd$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $009cb836554e9edd$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $009cb836554e9edd$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $009cb836554e9edd$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $009cb836554e9edd$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $009cb836554e9edd$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $009cb836554e9edd$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $009cb836554e9edd$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $009cb836554e9edd$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $009cb836554e9edd$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $009cb836554e9edd$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $009cb836554e9edd$export$2e2bcd8739ae039 = $009cb836554e9edd$var$match;

});


parcelRegister("kX4ph", function(module, exports) {

$parcel$export(module.exports, "default", () => $f40cbc6caa45c85c$export$2e2bcd8739ae039);

var $abXZr = parcelRequire("abXZr");

var $9Yact = parcelRequire("9Yact");

var $6qq0r = parcelRequire("6qq0r");

var $07cDl = parcelRequire("07cDl");

var $eLnvA = parcelRequire("eLnvA");
/**
 * @type {Locale}
 * @category Locales
 * @summary Catalan locale.
 * @language Catalan
 * @iso-639-2 cat
 * @author Guillermo Grau [@guigrpa]{@link https://github.com/guigrpa}
 * @author Alex Vizcaino [@avizcaino]{@link https://github.com/avizcaino}
 */ var $f40cbc6caa45c85c$var$locale = {
    code: "ca",
    formatDistance: (0, $abXZr.default),
    formatLong: (0, $9Yact.default),
    formatRelative: (0, $6qq0r.default),
    localize: (0, $07cDl.default),
    match: (0, $eLnvA.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $f40cbc6caa45c85c$export$2e2bcd8739ae039 // throw new Error('ca locale is currently unavailable. Please check the progress of converting this locale to v2.0.0 in this issue on Github: TBA')
 = $f40cbc6caa45c85c$var$locale;

});
parcelRegister("abXZr", function(module, exports) {

$parcel$export(module.exports, "default", () => $76b9773d7b04763a$export$2e2bcd8739ae039);
/**
 * Davant de les xifres que es diuen amb vocal inicial, 1 i 11, s'apostrofen els articles el i la i la preposició de igual que si estiguessin escrits amb lletres.
 *    l'1 de juliol ('l'u')
 *    l'11 de novembre ('l'onze')
 *    l'11a clàusula del contracte ('l'onzena')
 *    la contractació d'11 jugadors ('d'onze')
 *    l'aval d'11.000 socis ('d'onze mil')
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=apostrofaci%25F3+davant+xifres&action=Principal&method=detall_completa&numPagina=1&idHit=11236&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=11236&titol=apostrofaci%F3%20davant%20de%20xifres%20%2F%20apostrofaci%F3%20davant%20de%201%20i%2011&numeroResultat=1&clickLink=detall&tipusCerca=cerca.normes
 */ var $76b9773d7b04763a$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "menys d'un segon",
        eleven: "menys d'onze segons",
        other: "menys de {{count}} segons"
    },
    xSeconds: {
        one: "1 segon",
        other: "{{count}} segons"
    },
    halfAMinute: "mig minut",
    lessThanXMinutes: {
        one: "menys d'un minut",
        eleven: "menys d'onze minuts",
        other: "menys de {{count}} minuts"
    },
    xMinutes: {
        one: "1 minut",
        other: "{{count}} minuts"
    },
    aboutXHours: {
        one: "aproximadament una hora",
        other: "aproximadament {{count}} hores"
    },
    xHours: {
        one: "1 hora",
        other: "{{count}} hores"
    },
    xDays: {
        one: "1 dia",
        other: "{{count}} dies"
    },
    aboutXWeeks: {
        one: "aproximadament una setmana",
        other: "aproximadament {{count}} setmanes"
    },
    xWeeks: {
        one: "1 setmana",
        other: "{{count}} setmanes"
    },
    aboutXMonths: {
        one: "aproximadament un mes",
        other: "aproximadament {{count}} mesos"
    },
    xMonths: {
        one: "1 mes",
        other: "{{count}} mesos"
    },
    aboutXYears: {
        one: "aproximadament un any",
        other: "aproximadament {{count}} anys"
    },
    xYears: {
        one: "1 any",
        other: "{{count}} anys"
    },
    overXYears: {
        one: "m\xe9s d'un any",
        eleven: "m\xe9s d'onze anys",
        other: "m\xe9s de {{count}} anys"
    },
    almostXYears: {
        one: "gaireb\xe9 un any",
        other: "gaireb\xe9 {{count}} anys"
    }
};
var $76b9773d7b04763a$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $76b9773d7b04763a$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 11 && tokenValue.eleven) result = tokenValue.eleven;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "en " + result;
        else return "fa " + result;
    }
    return result;
};
var $76b9773d7b04763a$export$2e2bcd8739ae039 = $76b9773d7b04763a$var$formatDistance;

});

parcelRegister("9Yact", function(module, exports) {

$parcel$export(module.exports, "default", () => $7421a12d1a8e092c$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $7421a12d1a8e092c$var$dateFormats = {
    full: "EEEE, d 'de' MMMM y",
    long: "d 'de' MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
var $7421a12d1a8e092c$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $7421a12d1a8e092c$var$dateTimeFormats = {
    full: "{{date}} 'a les' {{time}}",
    long: "{{date}} 'a les' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $7421a12d1a8e092c$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $7421a12d1a8e092c$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $7421a12d1a8e092c$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $7421a12d1a8e092c$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $7421a12d1a8e092c$export$2e2bcd8739ae039 = $7421a12d1a8e092c$var$formatLong;

});

parcelRegister("6qq0r", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ad958156e269e7b$export$2e2bcd8739ae039);
var $4ad958156e269e7b$var$formatRelativeLocale = {
    lastWeek: "'el' eeee 'passat a la' LT",
    yesterday: "'ahir a la' p",
    today: "'avui a la' p",
    tomorrow: "'dem\xe0 a la' p",
    nextWeek: "eeee 'a la' p",
    other: "P"
};
var $4ad958156e269e7b$var$formatRelativeLocalePlural = {
    lastWeek: "'el' eeee 'passat a les' p",
    yesterday: "'ahir a les' p",
    today: "'avui a les' p",
    tomorrow: "'dem\xe0 a les' p",
    nextWeek: "eeee 'a les' p",
    other: "P"
};
var $4ad958156e269e7b$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    if (date.getUTCHours() !== 1) return $4ad958156e269e7b$var$formatRelativeLocalePlural[token];
    return $4ad958156e269e7b$var$formatRelativeLocale[token];
};
var $4ad958156e269e7b$export$2e2bcd8739ae039 = $4ad958156e269e7b$var$formatRelative;

});

parcelRegister("07cDl", function(module, exports) {

$parcel$export(module.exports, "default", () => $000596858263fc0f$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
/**
 * General information
 * Reference: https://aplicacions.llengua.gencat.cat
 * Reference: https://www.uoc.edu/portal/ca/servei-linguistic/convencions/abreviacions/simbols/simbols-habituals.html
 */ /**
 * Abans de Crist: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abans+de+crist&action=Principal&method=detall_completa&numPagina=1&idHit=6876&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=6876&titol=abans%20de%20Crist%20(abreviatura)%20/%20abans%20de%20Crist%20(sigla)&numeroResultat=1&clickLink=detall&tipusCerca=cerca.fitxes
 * Desprest de Crist: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=despr%E9s+de+crist&action=Principal&method=detall_completa&numPagina=1&idHit=6879&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=6879&titol=despr%E9s%20de%20Crist%20(sigla)%20/%20despr%E9s%20de%20Crist%20(abreviatura)&numeroResultat=1&clickLink=detall&tipusCerca=cerca.fitxes
 */ var $000596858263fc0f$var$eraValues = {
    narrow: [
        "aC",
        "dC"
    ],
    abbreviated: [
        "a. de C.",
        "d. de C."
    ],
    wide: [
        "abans de Crist",
        "despr\xe9s de Crist"
    ]
};
var $000596858263fc0f$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    wide: [
        "1r trimestre",
        "2n trimestre",
        "3r trimestre",
        "4t trimestre"
    ]
};
/**
 * Dins d'un text convé fer servir la forma sencera dels mesos, ja que sempre és més clar el mot sencer que l'abreviatura, encara que aquesta sigui força coneguda.
 * Cal reservar, doncs, les abreviatures per a les llistes o classificacions, els gràfics, les taules o quadres estadístics, els textos publicitaris, etc.
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abreviacions+mesos&action=Principal&method=detall_completa&numPagina=1&idHit=8402&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=8402&titol=abreviatures%20dels%20mesos%20de%20l%27any&numeroResultat=5&clickLink=detall&tipusCerca=cerca.fitxes
 */ var $000596858263fc0f$var$monthValues = {
    narrow: [
        "GN",
        "FB",
        "M\xc7",
        "AB",
        "MG",
        "JN",
        "JL",
        "AG",
        "ST",
        "OC",
        "NV",
        "DS"
    ],
    /**
   * Les abreviatures dels mesos de l'any es formen seguint una de les normes generals de formació d'abreviatures.
   * S'escriu la primera síl·laba i les consonants de la síl·laba següent anteriors a la primera vocal.
   * Els mesos de març, maig i juny no s'abreugen perquè són paraules d'una sola síl·laba.
   */ abbreviated: [
        "gen.",
        "febr.",
        "mar\xe7",
        "abr.",
        "maig",
        "juny",
        "jul.",
        "ag.",
        "set.",
        "oct.",
        "nov.",
        "des."
    ],
    wide: [
        "gener",
        "febrer",
        "mar\xe7",
        "abril",
        "maig",
        "juny",
        "juliol",
        "agost",
        "setembre",
        "octubre",
        "novembre",
        "desembre"
    ]
};
/**
 * Les abreviatures dels dies de la setmana comencen totes amb la lletra d.
 * Tot seguit porten la consonant següent a la i, excepte en el cas de dimarts, dimecres i diumenge, en què aquesta consonant és la m i, per tant, hi podria haver confusió.
 * Per evitar-ho, s'ha substituït la m per una t (en el cas de dimarts), una c (en el cas de dimecres) i una g (en el cas de diumenge), respectivament.
 *
 * Seguint la norma general d'ús de les abreviatures, les dels dies de la setmana sempre porten punt final.
 * Igualment, van amb la primera lletra en majúscula quan la paraula sencera també hi aniria.
 * En canvi, van amb la primera lletra en minúscula quan la inicial de la paraula sencera també hi aniria.
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?input_cercar=abreviatures+dies&action=Principal&method=detall_completa&numPagina=1&idHit=8387&database=FITXES_PUB&tipusFont=Fitxes%20de%20l%27Optimot&idFont=8387&titol=abreviatures%20dels%20dies%20de%20la%20setmana&numeroResultat=1&clickLink=detall&tipusCerca=cerca.tot
 */ var $000596858263fc0f$var$dayValues = {
    narrow: [
        "dg.",
        "dl.",
        "dt.",
        "dm.",
        "dj.",
        "dv.",
        "ds."
    ],
    short: [
        "dg.",
        "dl.",
        "dt.",
        "dm.",
        "dj.",
        "dv.",
        "ds."
    ],
    abbreviated: [
        "dg.",
        "dl.",
        "dt.",
        "dm.",
        "dj.",
        "dv.",
        "ds."
    ],
    wide: [
        "diumenge",
        "dilluns",
        "dimarts",
        "dimecres",
        "dijous",
        "divendres",
        "dissabte"
    ]
};
/**
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/index.html?action=Principal&method=detall&input_cercar=parts+del+dia&numPagina=1&database=FITXES_PUB&idFont=12801&idHit=12801&tipusFont=Fitxes+de+l%27Optimot&numeroResultat=1&databases_avansada=&categories_avansada=&clickLink=detall&titol=Nom+de+les+parts+del+dia&tematica=&tipusCerca=cerca.fitxes
 */ var $000596858263fc0f$var$dayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "mitjanit",
        noon: "migdia",
        morning: "mat\xed",
        afternoon: "tarda",
        evening: "vespre",
        night: "nit"
    },
    abbreviated: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "mitjanit",
        noon: "migdia",
        morning: "mat\xed",
        afternoon: "tarda",
        evening: "vespre",
        night: "nit"
    },
    wide: {
        am: "ante meridiem",
        pm: "post meridiem",
        midnight: "mitjanit",
        noon: "migdia",
        morning: "mat\xed",
        afternoon: "tarda",
        evening: "vespre",
        night: "nit"
    }
};
var $000596858263fc0f$var$formattingDayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "de la mitjanit",
        noon: "del migdia",
        morning: "del mat\xed",
        afternoon: "de la tarda",
        evening: "del vespre",
        night: "de la nit"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "de la mitjanit",
        noon: "del migdia",
        morning: "del mat\xed",
        afternoon: "de la tarda",
        evening: "del vespre",
        night: "de la nit"
    },
    wide: {
        am: "ante meridiem",
        pm: "post meridiem",
        midnight: "de la mitjanit",
        noon: "del migdia",
        morning: "del mat\xed",
        afternoon: "de la tarda",
        evening: "del vespre",
        night: "de la nit"
    }
};
/**
 * Quan van en singular, els nombres ordinals es representen, en forma d’abreviatura, amb la xifra seguida de l’última lletra del mot desplegat.
 * És optatiu posar punt després de la lletra.
 *
 * Reference: https://aplicacions.llengua.gencat.cat/llc/AppJava/pdf/abrevia.pdf#page=18
 */ var $000596858263fc0f$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "r";
        case 2:
            return number + "n";
        case 3:
            return number + "r";
        case 4:
            return number + "t";
    }
    return number + "\xe8";
};
var $000596858263fc0f$var$localize = {
    ordinalNumber: $000596858263fc0f$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $000596858263fc0f$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $000596858263fc0f$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $000596858263fc0f$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $000596858263fc0f$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $000596858263fc0f$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $000596858263fc0f$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $000596858263fc0f$export$2e2bcd8739ae039 = $000596858263fc0f$var$localize;

});

parcelRegister("eLnvA", function(module, exports) {

$parcel$export(module.exports, "default", () => $abf7b0bef7ac64c5$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $abf7b0bef7ac64c5$var$matchOrdinalNumberPattern = /^(\d+)(è|r|n|r|t)?/i;
var $abf7b0bef7ac64c5$var$parseOrdinalNumberPattern = /\d+/i;
var $abf7b0bef7ac64c5$var$matchEraPatterns = {
    narrow: /^(aC|dC)/i,
    abbreviated: /^(a. de C.|d. de C.)/i,
    wide: /^(abans de Crist|despr[eé]s de Crist)/i
};
var $abf7b0bef7ac64c5$var$parseEraPatterns = {
    narrow: [
        /^aC/i,
        /^dC/i
    ],
    abbreviated: [
        /^(a. de C.)/i,
        /^(d. de C.)/i
    ],
    wide: [
        /^(abans de Crist)/i,
        /^(despr[eé]s de Crist)/i
    ]
};
var $abf7b0bef7ac64c5$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](è|r|n|r|t)? trimestre/i
};
var $abf7b0bef7ac64c5$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $abf7b0bef7ac64c5$var$matchMonthPatterns = {
    narrow: /^(GN|FB|MÇ|AB|MG|JN|JL|AG|ST|OC|NV|DS)/i,
    abbreviated: /^(gen.|febr.|març|abr.|maig|juny|jul.|ag.|set.|oct.|nov.|des.)/i,
    wide: /^(gener|febrer|març|abril|maig|juny|juliol|agost|setembre|octubre|novembre|desembre)/i
};
var $abf7b0bef7ac64c5$var$parseMonthPatterns = {
    narrow: [
        /^GN/i,
        /^FB/i,
        /^MÇ/i,
        /^AB/i,
        /^MG/i,
        /^JN/i,
        /^JL/i,
        /^AG/i,
        /^ST/i,
        /^OC/i,
        /^NV/i,
        /^DS/i
    ],
    abbreviated: [
        /^gen./i,
        /^febr./i,
        /^març/i,
        /^abr./i,
        /^maig/i,
        /^juny/i,
        /^jul./i,
        /^ag./i,
        /^set./i,
        /^oct./i,
        /^nov./i,
        /^des./i
    ],
    wide: [
        /^gener/i,
        /^febrer/i,
        /^març/i,
        /^abril/i,
        /^maig/i,
        /^juny/i,
        /^juliol/i,
        /^agost/i,
        /^setembre/i,
        /^octubre/i,
        /^novembre/i,
        /^desembre/i
    ]
};
var $abf7b0bef7ac64c5$var$matchDayPatterns = {
    narrow: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
    short: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
    abbreviated: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
    wide: /^(diumenge|dilluns|dimarts|dimecres|dijous|divendres|dissabte)/i
};
var $abf7b0bef7ac64c5$var$parseDayPatterns = {
    narrow: [
        /^dg./i,
        /^dl./i,
        /^dt./i,
        /^dm./i,
        /^dj./i,
        /^dv./i,
        /^ds./i
    ],
    abbreviated: [
        /^dg./i,
        /^dl./i,
        /^dt./i,
        /^dm./i,
        /^dj./i,
        /^dv./i,
        /^ds./i
    ],
    wide: [
        /^diumenge/i,
        /^dilluns/i,
        /^dimarts/i,
        /^dimecres/i,
        /^dijous/i,
        /^divendres/i,
        /^disssabte/i
    ]
};
var $abf7b0bef7ac64c5$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(del|de la) (matí|tarda|vespre|nit))/i,
    abbreviated: /^([ap]\.?\s?m\.?|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i,
    wide: /^(ante meridiem|post meridiem|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i
};
var $abf7b0bef7ac64c5$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mitjanit/i,
        noon: /^migdia/i,
        morning: /matí/i,
        afternoon: /tarda/i,
        evening: /vespre/i,
        night: /nit/i
    }
};
var $abf7b0bef7ac64c5$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $abf7b0bef7ac64c5$var$matchOrdinalNumberPattern,
        parsePattern: $abf7b0bef7ac64c5$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $abf7b0bef7ac64c5$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $abf7b0bef7ac64c5$var$parseEraPatterns,
        defaultParseWidth: "wide"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $abf7b0bef7ac64c5$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $abf7b0bef7ac64c5$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $abf7b0bef7ac64c5$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $abf7b0bef7ac64c5$var$parseMonthPatterns,
        defaultParseWidth: "wide"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $abf7b0bef7ac64c5$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $abf7b0bef7ac64c5$var$parseDayPatterns,
        defaultParseWidth: "wide"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $abf7b0bef7ac64c5$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $abf7b0bef7ac64c5$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $abf7b0bef7ac64c5$export$2e2bcd8739ae039 = $abf7b0bef7ac64c5$var$match;

});


parcelRegister("jhRNZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0a9577877597dcb$export$2e2bcd8739ae039);

var $b3UHP = parcelRequire("b3UHP");

var $3TYI0 = parcelRequire("3TYI0");

var $8mOFL = parcelRequire("8mOFL");

var $grdIY = parcelRequire("grdIY");

var $eKIPN = parcelRequire("eKIPN");
/**
 * @type {Locale}
 * @category Locales
 * @summary Czech locale.
 * @language Czech
 * @iso-639-2 ces
 * @author David Rus [@davidrus]{@link https://github.com/davidrus}
 * @author Pavel Hrách [@SilenY]{@link https://github.com/SilenY}
 * @author Jozef Bíroš [@JozefBiros]{@link https://github.com/JozefBiros}
 */ var $e0a9577877597dcb$var$locale = {
    code: "cs",
    formatDistance: (0, $b3UHP.default),
    formatLong: (0, $3TYI0.default),
    formatRelative: (0, $8mOFL.default),
    localize: (0, $grdIY.default),
    match: (0, $eKIPN.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $e0a9577877597dcb$export$2e2bcd8739ae039 = $e0a9577877597dcb$var$locale;

});
parcelRegister("b3UHP", function(module, exports) {

$parcel$export(module.exports, "default", () => $80dbf62384776f26$export$2e2bcd8739ae039);
var $80dbf62384776f26$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            regular: "m\xe9n\u011B ne\u017E sekunda",
            past: "p\u0159ed m\xe9n\u011B ne\u017E sekundou",
            future: "za m\xe9n\u011B ne\u017E sekundu"
        },
        few: {
            regular: "m\xe9n\u011B ne\u017E {{count}} sekundy",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} sekundami",
            future: "za m\xe9n\u011B ne\u017E {{count}} sekundy"
        },
        many: {
            regular: "m\xe9n\u011B ne\u017E {{count}} sekund",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} sekundami",
            future: "za m\xe9n\u011B ne\u017E {{count}} sekund"
        }
    },
    xSeconds: {
        one: {
            regular: "sekunda",
            past: "p\u0159ed sekundou",
            future: "za sekundu"
        },
        few: {
            regular: "{{count}} sekundy",
            past: "p\u0159ed {{count}} sekundami",
            future: "za {{count}} sekundy"
        },
        many: {
            regular: "{{count}} sekund",
            past: "p\u0159ed {{count}} sekundami",
            future: "za {{count}} sekund"
        }
    },
    halfAMinute: {
        type: "other",
        other: {
            regular: "p\u016Fl minuty",
            past: "p\u0159ed p\u016Fl minutou",
            future: "za p\u016Fl minuty"
        }
    },
    lessThanXMinutes: {
        one: {
            regular: "m\xe9n\u011B ne\u017E minuta",
            past: "p\u0159ed m\xe9n\u011B ne\u017E minutou",
            future: "za m\xe9n\u011B ne\u017E minutu"
        },
        few: {
            regular: "m\xe9n\u011B ne\u017E {{count}} minuty",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} minutami",
            future: "za m\xe9n\u011B ne\u017E {{count}} minuty"
        },
        many: {
            regular: "m\xe9n\u011B ne\u017E {{count}} minut",
            past: "p\u0159ed m\xe9n\u011B ne\u017E {{count}} minutami",
            future: "za m\xe9n\u011B ne\u017E {{count}} minut"
        }
    },
    xMinutes: {
        one: {
            regular: "minuta",
            past: "p\u0159ed minutou",
            future: "za minutu"
        },
        few: {
            regular: "{{count}} minuty",
            past: "p\u0159ed {{count}} minutami",
            future: "za {{count}} minuty"
        },
        many: {
            regular: "{{count}} minut",
            past: "p\u0159ed {{count}} minutami",
            future: "za {{count}} minut"
        }
    },
    aboutXHours: {
        one: {
            regular: "p\u0159ibli\u017En\u011B hodina",
            past: "p\u0159ibli\u017En\u011B p\u0159ed hodinou",
            future: "p\u0159ibli\u017En\u011B za hodinu"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} hodiny",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} hodinami",
            future: "p\u0159ibli\u017En\u011B za {{count}} hodiny"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} hodin",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} hodinami",
            future: "p\u0159ibli\u017En\u011B za {{count}} hodin"
        }
    },
    xHours: {
        one: {
            regular: "hodina",
            past: "p\u0159ed hodinou",
            future: "za hodinu"
        },
        few: {
            regular: "{{count}} hodiny",
            past: "p\u0159ed {{count}} hodinami",
            future: "za {{count}} hodiny"
        },
        many: {
            regular: "{{count}} hodin",
            past: "p\u0159ed {{count}} hodinami",
            future: "za {{count}} hodin"
        }
    },
    xDays: {
        one: {
            regular: "den",
            past: "p\u0159ed dnem",
            future: "za den"
        },
        few: {
            regular: "{{count}} dny",
            past: "p\u0159ed {{count}} dny",
            future: "za {{count}} dny"
        },
        many: {
            regular: "{{count}} dn\xed",
            past: "p\u0159ed {{count}} dny",
            future: "za {{count}} dn\xed"
        }
    },
    aboutXWeeks: {
        one: {
            regular: "p\u0159ibli\u017En\u011B t\xfdden",
            past: "p\u0159ibli\u017En\u011B p\u0159ed t\xfddnem",
            future: "p\u0159ibli\u017En\u011B za t\xfdden"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} t\xfddny",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} t\xfddny",
            future: "p\u0159ibli\u017En\u011B za {{count}} t\xfddny"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} t\xfddn\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} t\xfddny",
            future: "p\u0159ibli\u017En\u011B za {{count}} t\xfddn\u016F"
        }
    },
    xWeeks: {
        one: {
            regular: "t\xfdden",
            past: "p\u0159ed t\xfddnem",
            future: "za t\xfdden"
        },
        few: {
            regular: "{{count}} t\xfddny",
            past: "p\u0159ed {{count}} t\xfddny",
            future: "za {{count}} t\xfddny"
        },
        many: {
            regular: "{{count}} t\xfddn\u016F",
            past: "p\u0159ed {{count}} t\xfddny",
            future: "za {{count}} t\xfddn\u016F"
        }
    },
    aboutXMonths: {
        one: {
            regular: "p\u0159ibli\u017En\u011B m\u011Bs\xedc",
            past: "p\u0159ibli\u017En\u011B p\u0159ed m\u011Bs\xedcem",
            future: "p\u0159ibli\u017En\u011B za m\u011Bs\xedc"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} m\u011Bs\xedce",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} m\u011Bs\xedci",
            future: "p\u0159ibli\u017En\u011B za {{count}} m\u011Bs\xedce"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} m\u011Bs\xedc\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} m\u011Bs\xedci",
            future: "p\u0159ibli\u017En\u011B za {{count}} m\u011Bs\xedc\u016F"
        }
    },
    xMonths: {
        one: {
            regular: "m\u011Bs\xedc",
            past: "p\u0159ed m\u011Bs\xedcem",
            future: "za m\u011Bs\xedc"
        },
        few: {
            regular: "{{count}} m\u011Bs\xedce",
            past: "p\u0159ed {{count}} m\u011Bs\xedci",
            future: "za {{count}} m\u011Bs\xedce"
        },
        many: {
            regular: "{{count}} m\u011Bs\xedc\u016F",
            past: "p\u0159ed {{count}} m\u011Bs\xedci",
            future: "za {{count}} m\u011Bs\xedc\u016F"
        }
    },
    aboutXYears: {
        one: {
            regular: "p\u0159ibli\u017En\u011B rok",
            past: "p\u0159ibli\u017En\u011B p\u0159ed rokem",
            future: "p\u0159ibli\u017En\u011B za rok"
        },
        few: {
            regular: "p\u0159ibli\u017En\u011B {{count}} roky",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} roky",
            future: "p\u0159ibli\u017En\u011B za {{count}} roky"
        },
        many: {
            regular: "p\u0159ibli\u017En\u011B {{count}} rok\u016F",
            past: "p\u0159ibli\u017En\u011B p\u0159ed {{count}} roky",
            future: "p\u0159ibli\u017En\u011B za {{count}} rok\u016F"
        }
    },
    xYears: {
        one: {
            regular: "rok",
            past: "p\u0159ed rokem",
            future: "za rok"
        },
        few: {
            regular: "{{count}} roky",
            past: "p\u0159ed {{count}} roky",
            future: "za {{count}} roky"
        },
        many: {
            regular: "{{count}} rok\u016F",
            past: "p\u0159ed {{count}} roky",
            future: "za {{count}} rok\u016F"
        }
    },
    overXYears: {
        one: {
            regular: "v\xedce ne\u017E rok",
            past: "p\u0159ed v\xedce ne\u017E rokem",
            future: "za v\xedce ne\u017E rok"
        },
        few: {
            regular: "v\xedce ne\u017E {{count}} roky",
            past: "p\u0159ed v\xedce ne\u017E {{count}} roky",
            future: "za v\xedce ne\u017E {{count}} roky"
        },
        many: {
            regular: "v\xedce ne\u017E {{count}} rok\u016F",
            past: "p\u0159ed v\xedce ne\u017E {{count}} roky",
            future: "za v\xedce ne\u017E {{count}} rok\u016F"
        }
    },
    almostXYears: {
        one: {
            regular: "skoro rok",
            past: "skoro p\u0159ed rokem",
            future: "skoro za rok"
        },
        few: {
            regular: "skoro {{count}} roky",
            past: "skoro p\u0159ed {{count}} roky",
            future: "skoro za {{count}} roky"
        },
        many: {
            regular: "skoro {{count}} rok\u016F",
            past: "skoro p\u0159ed {{count}} roky",
            future: "skoro za {{count}} rok\u016F"
        }
    }
};
var $80dbf62384776f26$var$formatDistance = function formatDistance(token, count, options) {
    var pluralResult;
    var tokenValue = $80dbf62384776f26$var$formatDistanceLocale[token];
    // cs pluralization
    if (tokenValue.type === "other") pluralResult = tokenValue.other;
    else if (count === 1) pluralResult = tokenValue.one;
    else if (count > 1 && count < 5) pluralResult = tokenValue.few;
    else pluralResult = tokenValue.many;
    // times
    var suffixExist = (options === null || options === void 0 ? void 0 : options.addSuffix) === true;
    var comparison = options === null || options === void 0 ? void 0 : options.comparison;
    var timeResult;
    if (suffixExist && comparison === -1) timeResult = pluralResult.past;
    else if (suffixExist && comparison === 1) timeResult = pluralResult.future;
    else timeResult = pluralResult.regular;
    return timeResult.replace("{{count}}", String(count));
};
var $80dbf62384776f26$export$2e2bcd8739ae039 = $80dbf62384776f26$var$formatDistance;

});

parcelRegister("3TYI0", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d7599a5d1763af3$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $2d7599a5d1763af3$var$dateFormats = {
    full: "EEEE, d. MMMM yyyy",
    long: "d. MMMM yyyy",
    medium: "d. M. yyyy",
    short: "dd.MM.yyyy"
};
var $2d7599a5d1763af3$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
var $2d7599a5d1763af3$var$dateTimeFormats = {
    full: "{{date}} 'v' {{time}}",
    long: "{{date}} 'v' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $2d7599a5d1763af3$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $2d7599a5d1763af3$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $2d7599a5d1763af3$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $2d7599a5d1763af3$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $2d7599a5d1763af3$export$2e2bcd8739ae039 = $2d7599a5d1763af3$var$formatLong;

});

parcelRegister("8mOFL", function(module, exports) {

$parcel$export(module.exports, "default", () => $6177af551d3e0219$export$2e2bcd8739ae039);
var $6177af551d3e0219$var$accusativeWeekdays = [
    "ned\u011Bli",
    "pond\u011Bl\xed",
    "\xfater\xfd",
    "st\u0159edu",
    "\u010Dtvrtek",
    "p\xe1tek",
    "sobotu"
];
var $6177af551d3e0219$var$formatRelativeLocale = {
    lastWeek: "'posledn\xed' eeee 've' p",
    yesterday: "'v\u010Dera v' p",
    today: "'dnes v' p",
    tomorrow: "'z\xedtra v' p",
    nextWeek: function nextWeek(date) {
        var day = date.getUTCDay();
        return "'v " + $6177af551d3e0219$var$accusativeWeekdays[day] + " o' p";
    },
    other: "P"
};
var $6177af551d3e0219$var$formatRelative = function formatRelative(token, date) {
    var format = $6177af551d3e0219$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
var $6177af551d3e0219$export$2e2bcd8739ae039 = $6177af551d3e0219$var$formatRelative;

});

parcelRegister("grdIY", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf79d0586a082b59$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $bf79d0586a082b59$var$eraValues = {
    narrow: [
        "p\u0159. n. l.",
        "n. l."
    ],
    abbreviated: [
        "p\u0159. n. l.",
        "n. l."
    ],
    wide: [
        "p\u0159ed na\u0161\xedm letopo\u010Dtem",
        "na\u0161eho letopo\u010Dtu"
    ]
};
var $bf79d0586a082b59$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1. \u010Dtvrtlet\xed",
        "2. \u010Dtvrtlet\xed",
        "3. \u010Dtvrtlet\xed",
        "4. \u010Dtvrtlet\xed"
    ],
    wide: [
        "1. \u010Dtvrtlet\xed",
        "2. \u010Dtvrtlet\xed",
        "3. \u010Dtvrtlet\xed",
        "4. \u010Dtvrtlet\xed"
    ]
};
var $bf79d0586a082b59$var$monthValues = {
    narrow: [
        "L",
        "\xda",
        "B",
        "D",
        "K",
        "\u010C",
        "\u010C",
        "S",
        "Z",
        "\u0158",
        "L",
        "P"
    ],
    abbreviated: [
        "led",
        "\xfano",
        "b\u0159e",
        "dub",
        "kv\u011B",
        "\u010Dvn",
        "\u010Dvc",
        "srp",
        "z\xe1\u0159",
        "\u0159\xedj",
        "lis",
        "pro"
    ],
    wide: [
        "leden",
        "\xfanor",
        "b\u0159ezen",
        "duben",
        "kv\u011Bten",
        "\u010Derven",
        "\u010Dervenec",
        "srpen",
        "z\xe1\u0159\xed",
        "\u0159\xedjen",
        "listopad",
        "prosinec"
    ]
};
var $bf79d0586a082b59$var$formattingMonthValues = {
    narrow: [
        "L",
        "\xda",
        "B",
        "D",
        "K",
        "\u010C",
        "\u010C",
        "S",
        "Z",
        "\u0158",
        "L",
        "P"
    ],
    abbreviated: [
        "led",
        "\xfano",
        "b\u0159e",
        "dub",
        "kv\u011B",
        "\u010Dvn",
        "\u010Dvc",
        "srp",
        "z\xe1\u0159",
        "\u0159\xedj",
        "lis",
        "pro"
    ],
    wide: [
        "ledna",
        "\xfanora",
        "b\u0159ezna",
        "dubna",
        "kv\u011Btna",
        "\u010Dervna",
        "\u010Dervence",
        "srpna",
        "z\xe1\u0159\xed",
        "\u0159\xedjna",
        "listopadu",
        "prosince"
    ]
};
var $bf79d0586a082b59$var$dayValues = {
    narrow: [
        "ne",
        "po",
        "\xfat",
        "st",
        "\u010Dt",
        "p\xe1",
        "so"
    ],
    short: [
        "ne",
        "po",
        "\xfat",
        "st",
        "\u010Dt",
        "p\xe1",
        "so"
    ],
    abbreviated: [
        "ned",
        "pon",
        "\xfate",
        "st\u0159",
        "\u010Dtv",
        "p\xe1t",
        "sob"
    ],
    wide: [
        "ned\u011Ble",
        "pond\u011Bl\xed",
        "\xfater\xfd",
        "st\u0159eda",
        "\u010Dtvrtek",
        "p\xe1tek",
        "sobota"
    ]
};
var $bf79d0586a082b59$var$dayPeriodValues = {
    narrow: {
        am: "dop.",
        pm: "odp.",
        midnight: "p\u016Flnoc",
        noon: "poledne",
        morning: "r\xe1no",
        afternoon: "odpoledne",
        evening: "ve\u010Der",
        night: "noc"
    },
    abbreviated: {
        am: "dop.",
        pm: "odp.",
        midnight: "p\u016Flnoc",
        noon: "poledne",
        morning: "r\xe1no",
        afternoon: "odpoledne",
        evening: "ve\u010Der",
        night: "noc"
    },
    wide: {
        am: "dopoledne",
        pm: "odpoledne",
        midnight: "p\u016Flnoc",
        noon: "poledne",
        morning: "r\xe1no",
        afternoon: "odpoledne",
        evening: "ve\u010Der",
        night: "noc"
    }
};
var $bf79d0586a082b59$var$formattingDayPeriodValues = {
    narrow: {
        am: "dop.",
        pm: "odp.",
        midnight: "p\u016Flnoc",
        noon: "poledne",
        morning: "r\xe1no",
        afternoon: "odpoledne",
        evening: "ve\u010Der",
        night: "noc"
    },
    abbreviated: {
        am: "dop.",
        pm: "odp.",
        midnight: "p\u016Flnoc",
        noon: "poledne",
        morning: "r\xe1no",
        afternoon: "odpoledne",
        evening: "ve\u010Der",
        night: "noc"
    },
    wide: {
        am: "dopoledne",
        pm: "odpoledne",
        midnight: "p\u016Flnoc",
        noon: "poledne",
        morning: "r\xe1no",
        afternoon: "odpoledne",
        evening: "ve\u010Der",
        night: "noc"
    }
};
var $bf79d0586a082b59$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + ".";
};
var $bf79d0586a082b59$var$localize = {
    ordinalNumber: $bf79d0586a082b59$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $bf79d0586a082b59$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $bf79d0586a082b59$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $bf79d0586a082b59$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $bf79d0586a082b59$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $bf79d0586a082b59$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $bf79d0586a082b59$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $bf79d0586a082b59$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $bf79d0586a082b59$export$2e2bcd8739ae039 = $bf79d0586a082b59$var$localize;

});

parcelRegister("eKIPN", function(module, exports) {

$parcel$export(module.exports, "default", () => $abd823bd09b15399$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $abd823bd09b15399$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
var $abd823bd09b15399$var$parseOrdinalNumberPattern = /\d+/i;
var $abd823bd09b15399$var$matchEraPatterns = {
    narrow: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
    abbreviated: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
    wide: /^(p[řr](\.|ed) Kristem|p[řr](\.|ed) na[šs][íi]m letopo[čc]tem|po Kristu|na[šs]eho letopo[čc]tu)/i
};
var $abd823bd09b15399$var$parseEraPatterns = {
    any: [
        /^p[řr]/i,
        /^(po|n)/i
    ]
};
var $abd823bd09b15399$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\. [čc]tvrtlet[íi]/i,
    wide: /^[1234]\. [čc]tvrtlet[íi]/i
};
var $abd823bd09b15399$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $abd823bd09b15399$var$matchMonthPatterns = {
    narrow: /^[lúubdkčcszřrlp]/i,
    abbreviated: /^(led|[úu]no|b[řr]e|dub|kv[ěe]|[čc]vn|[čc]vc|srp|z[áa][řr]|[řr][íi]j|lis|pro)/i,
    wide: /^(leden|ledna|[úu]nora?|b[řr]ezen|b[řr]ezna|duben|dubna|kv[ěe]ten|kv[ěe]tna|[čc]erven(ec|ce)?|[čc]ervna|srpen|srpna|z[áa][řr][íi]|[řr][íi]jen|[řr][íi]jna|listopad(a|u)?|prosinec|prosince)/i
};
var $abd823bd09b15399$var$parseMonthPatterns = {
    narrow: [
        /^l/i,
        /^[úu]/i,
        /^b/i,
        /^d/i,
        /^k/i,
        /^[čc]/i,
        /^[čc]/i,
        /^s/i,
        /^z/i,
        /^[řr]/i,
        /^l/i,
        /^p/i
    ],
    any: [
        /^led/i,
        /^[úu]n/i,
        /^b[řr]e/i,
        /^dub/i,
        /^kv[ěe]/i,
        /^[čc]vn|[čc]erven(?!\w)|[čc]ervna/i,
        /^[čc]vc|[čc]erven(ec|ce)/i,
        /^srp/i,
        /^z[áa][řr]/i,
        /^[řr][íi]j/i,
        /^lis/i,
        /^pro/i
    ]
};
var $abd823bd09b15399$var$matchDayPatterns = {
    narrow: /^[npuúsčps]/i,
    short: /^(ne|po|[úu]t|st|[čc]t|p[áa]|so)/i,
    abbreviated: /^(ned|pon|[úu]te|st[rř]|[čc]tv|p[áa]t|sob)/i,
    wide: /^(ned[ěe]le|pond[ěe]l[íi]|[úu]ter[ýy]|st[řr]eda|[čc]tvrtek|p[áa]tek|sobota)/i
};
var $abd823bd09b15399$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^[úu]/i,
        /^s/i,
        /^[čc]/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^ne/i,
        /^po/i,
        /^[úu]t/i,
        /^st/i,
        /^[čc]t/i,
        /^p[áa]/i,
        /^so/i
    ]
};
var $abd823bd09b15399$var$matchDayPeriodPatterns = {
    any: /^dopoledne|dop\.?|odpoledne|odp\.?|p[ůu]lnoc|poledne|r[áa]no|odpoledne|ve[čc]er|(v )?noci?/i
};
var $abd823bd09b15399$var$parseDayPeriodPatterns = {
    any: {
        am: /^dop/i,
        pm: /^odp/i,
        midnight: /^p[ůu]lnoc/i,
        noon: /^poledne/i,
        morning: /r[áa]no/i,
        afternoon: /odpoledne/i,
        evening: /ve[čc]er/i,
        night: /noc/i
    }
};
var $abd823bd09b15399$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $abd823bd09b15399$var$matchOrdinalNumberPattern,
        parsePattern: $abd823bd09b15399$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $abd823bd09b15399$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $abd823bd09b15399$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $abd823bd09b15399$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $abd823bd09b15399$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $abd823bd09b15399$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $abd823bd09b15399$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $abd823bd09b15399$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $abd823bd09b15399$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $abd823bd09b15399$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $abd823bd09b15399$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $abd823bd09b15399$export$2e2bcd8739ae039 = $abd823bd09b15399$var$match;

});


parcelRegister("c7thg", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d2cd95c44ff2ba9$export$2e2bcd8739ae039);

var $9zCmh = parcelRequire("9zCmh");

var $7h43A = parcelRequire("7h43A");

var $5nIy1 = parcelRequire("5nIy1");

var $kQYfL = parcelRequire("kQYfL");

var $dbFR5 = parcelRequire("dbFR5");
/**
 * @type {Locale}
 * @category Locales
 * @summary Welsh locale.
 * @language Welsh
 * @iso-639-2 cym
 * @author Elwyn Malethan [@elmomalmo]{@link https://github.com/elmomalmo}
 */ var $8d2cd95c44ff2ba9$var$locale = {
    code: "cy",
    formatDistance: (0, $9zCmh.default),
    formatLong: (0, $7h43A.default),
    formatRelative: (0, $5nIy1.default),
    localize: (0, $kQYfL.default),
    match: (0, $dbFR5.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $8d2cd95c44ff2ba9$export$2e2bcd8739ae039 = $8d2cd95c44ff2ba9$var$locale;

});
parcelRegister("9zCmh", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f85231d6054e496$export$2e2bcd8739ae039);
var $6f85231d6054e496$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "llai na eiliad",
        other: "llai na {{count}} eiliad"
    },
    xSeconds: {
        one: "1 eiliad",
        other: "{{count}} eiliad"
    },
    halfAMinute: "hanner munud",
    lessThanXMinutes: {
        one: "llai na munud",
        two: "llai na 2 funud",
        other: "llai na {{count}} munud"
    },
    xMinutes: {
        one: "1 munud",
        two: "2 funud",
        other: "{{count}} munud"
    },
    aboutXHours: {
        one: "tua 1 awr",
        other: "tua {{count}} awr"
    },
    xHours: {
        one: "1 awr",
        other: "{{count}} awr"
    },
    xDays: {
        one: "1 diwrnod",
        two: "2 ddiwrnod",
        other: "{{count}} diwrnod"
    },
    aboutXWeeks: {
        one: "tua 1 wythnos",
        two: "tua pythefnos",
        other: "tua {{count}} wythnos"
    },
    xWeeks: {
        one: "1 wythnos",
        two: "pythefnos",
        other: "{{count}} wythnos"
    },
    aboutXMonths: {
        one: "tua 1 mis",
        two: "tua 2 fis",
        other: "tua {{count}} mis"
    },
    xMonths: {
        one: "1 mis",
        two: "2 fis",
        other: "{{count}} mis"
    },
    aboutXYears: {
        one: "tua 1 flwyddyn",
        two: "tua 2 flynedd",
        other: "tua {{count}} mlynedd"
    },
    xYears: {
        one: "1 flwyddyn",
        two: "2 flynedd",
        other: "{{count}} mlynedd"
    },
    overXYears: {
        one: "dros 1 flwyddyn",
        two: "dros 2 flynedd",
        other: "dros {{count}} mlynedd"
    },
    almostXYears: {
        one: "bron 1 flwyddyn",
        two: "bron 2 flynedd",
        other: "bron {{count}} mlynedd"
    }
};
var $6f85231d6054e496$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $6f85231d6054e496$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2 && !!tokenValue.two) result = tokenValue.two;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "mewn " + result;
        else return result + " yn \xf4l";
    }
    return result;
};
var $6f85231d6054e496$export$2e2bcd8739ae039 = $6f85231d6054e496$var$formatDistance;

});

parcelRegister("7h43A", function(module, exports) {

$parcel$export(module.exports, "default", () => $54bd44877e8d45e8$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $54bd44877e8d45e8$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd/MM/yyyy"
};
var $54bd44877e8d45e8$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $54bd44877e8d45e8$var$dateTimeFormats = {
    full: "{{date}} 'am' {{time}}",
    long: "{{date}} 'am' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $54bd44877e8d45e8$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $54bd44877e8d45e8$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $54bd44877e8d45e8$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $54bd44877e8d45e8$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $54bd44877e8d45e8$export$2e2bcd8739ae039 = $54bd44877e8d45e8$var$formatLong;

});

parcelRegister("5nIy1", function(module, exports) {

$parcel$export(module.exports, "default", () => $3eb1a7fbacf72a51$export$2e2bcd8739ae039);
var $3eb1a7fbacf72a51$var$formatRelativeLocale = {
    lastWeek: "eeee 'diwethaf am' p",
    yesterday: "'ddoe am' p",
    today: "'heddiw am' p",
    tomorrow: "'yfory am' p",
    nextWeek: "eeee 'am' p",
    other: "P"
};
var $3eb1a7fbacf72a51$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $3eb1a7fbacf72a51$var$formatRelativeLocale[token];
};
var $3eb1a7fbacf72a51$export$2e2bcd8739ae039 = $3eb1a7fbacf72a51$var$formatRelative;

});

parcelRegister("kQYfL", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2e76700bc4945e3$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $f2e76700bc4945e3$var$eraValues = {
    narrow: [
        "C",
        "O"
    ],
    abbreviated: [
        "CC",
        "OC"
    ],
    wide: [
        "Cyn Crist",
        "Ar \xf4l Crist"
    ]
};
var $f2e76700bc4945e3$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Ch1",
        "Ch2",
        "Ch3",
        "Ch4"
    ],
    wide: [
        "Chwarter 1af",
        "2ail chwarter",
        "3ydd chwarter",
        "4ydd chwarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $f2e76700bc4945e3$var$monthValues = {
    narrow: [
        "I",
        "Ch",
        "Ma",
        "E",
        "Mi",
        "Me",
        "G",
        "A",
        "Md",
        "H",
        "T",
        "Rh"
    ],
    abbreviated: [
        "Ion",
        "Chwe",
        "Maw",
        "Ebr",
        "Mai",
        "Meh",
        "Gor",
        "Aws",
        "Med",
        "Hyd",
        "Tach",
        "Rhag"
    ],
    wide: [
        "Ionawr",
        "Chwefror",
        "Mawrth",
        "Ebrill",
        "Mai",
        "Mehefin",
        "Gorffennaf",
        "Awst",
        "Medi",
        "Hydref",
        "Tachwedd",
        "Rhagfyr"
    ]
};
var $f2e76700bc4945e3$var$dayValues = {
    narrow: [
        "S",
        "Ll",
        "M",
        "M",
        "I",
        "G",
        "S"
    ],
    short: [
        "Su",
        "Ll",
        "Ma",
        "Me",
        "Ia",
        "Gw",
        "Sa"
    ],
    abbreviated: [
        "Sul",
        "Llun",
        "Maw",
        "Mer",
        "Iau",
        "Gwe",
        "Sad"
    ],
    wide: [
        "dydd Sul",
        "dydd Llun",
        "dydd Mawrth",
        "dydd Mercher",
        "dydd Iau",
        "dydd Gwener",
        "dydd Sadwrn"
    ]
};
var $f2e76700bc4945e3$var$dayPeriodValues = {
    narrow: {
        am: "b",
        pm: "h",
        midnight: "hn",
        noon: "hd",
        morning: "bore",
        afternoon: "prynhawn",
        evening: "gyda'r nos",
        night: "nos"
    },
    abbreviated: {
        am: "yb",
        pm: "yh",
        midnight: "hanner nos",
        noon: "hanner dydd",
        morning: "bore",
        afternoon: "prynhawn",
        evening: "gyda'r nos",
        night: "nos"
    },
    wide: {
        am: "y.b.",
        pm: "y.h.",
        midnight: "hanner nos",
        noon: "hanner dydd",
        morning: "bore",
        afternoon: "prynhawn",
        evening: "gyda'r nos",
        night: "nos"
    }
};
var $f2e76700bc4945e3$var$formattingDayPeriodValues = {
    narrow: {
        am: "b",
        pm: "h",
        midnight: "hn",
        noon: "hd",
        morning: "yn y bore",
        afternoon: "yn y prynhawn",
        evening: "gyda'r nos",
        night: "yn y nos"
    },
    abbreviated: {
        am: "yb",
        pm: "yh",
        midnight: "hanner nos",
        noon: "hanner dydd",
        morning: "yn y bore",
        afternoon: "yn y prynhawn",
        evening: "gyda'r nos",
        night: "yn y nos"
    },
    wide: {
        am: "y.b.",
        pm: "y.h.",
        midnight: "hanner nos",
        noon: "hanner dydd",
        morning: "yn y bore",
        afternoon: "yn y prynhawn",
        evening: "gyda'r nos",
        night: "yn y nos"
    }
};
var $f2e76700bc4945e3$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    if (number < 20) switch(number){
        case 0:
            return number + "fed";
        case 1:
            return number + "af";
        case 2:
            return number + "ail";
        case 3:
        case 4:
            return number + "ydd";
        case 5:
        case 6:
            return number + "ed";
        case 7:
        case 8:
        case 9:
        case 10:
        case 12:
        case 15:
        case 18:
            return number + "fed";
        case 11:
        case 13:
        case 14:
        case 16:
        case 17:
        case 19:
            return number + "eg";
    }
    else if (number >= 50 && number <= 60 || number === 80 || number >= 100) return number + "fed";
    return number + "ain";
};
var $f2e76700bc4945e3$var$localize = {
    ordinalNumber: $f2e76700bc4945e3$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $f2e76700bc4945e3$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $f2e76700bc4945e3$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $f2e76700bc4945e3$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $f2e76700bc4945e3$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $f2e76700bc4945e3$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $f2e76700bc4945e3$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $f2e76700bc4945e3$export$2e2bcd8739ae039 = $f2e76700bc4945e3$var$localize;

});

parcelRegister("dbFR5", function(module, exports) {

$parcel$export(module.exports, "default", () => $999cc506042f93e5$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $999cc506042f93e5$var$matchOrdinalNumberPattern = /^(\d+)(af|ail|ydd|ed|fed|eg|ain)?/i;
var $999cc506042f93e5$var$parseOrdinalNumberPattern = /\d+/i;
var $999cc506042f93e5$var$matchEraPatterns = {
    narrow: /^(c|o)/i,
    abbreviated: /^(c\.?\s?c\.?|o\.?\s?c\.?)/i,
    wide: /^(cyn christ|ar ôl crist|ar ol crist)/i
};
var $999cc506042f93e5$var$parseEraPatterns = {
    wide: [
        /^c/i,
        /^(ar ôl crist|ar ol crist)/i
    ],
    any: [
        /^c/i,
        /^o/i
    ]
};
var $999cc506042f93e5$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ch[1234]/i,
    wide: /^(chwarter 1af)|([234](ail|ydd)? chwarter)/i
};
var $999cc506042f93e5$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $999cc506042f93e5$var$matchMonthPatterns = {
    narrow: /^(i|ch|m|e|g|a|h|t|rh)/i,
    abbreviated: /^(ion|chwe|maw|ebr|mai|meh|gor|aws|med|hyd|tach|rhag)/i,
    wide: /^(ionawr|chwefror|mawrth|ebrill|mai|mehefin|gorffennaf|awst|medi|hydref|tachwedd|rhagfyr)/i
};
var $999cc506042f93e5$var$parseMonthPatterns = {
    narrow: [
        /^i/i,
        /^ch/i,
        /^m/i,
        /^e/i,
        /^m/i,
        /^m/i,
        /^g/i,
        /^a/i,
        /^m/i,
        /^h/i,
        /^t/i,
        /^rh/i
    ],
    any: [
        /^io/i,
        /^ch/i,
        /^maw/i,
        /^e/i,
        /^mai/i,
        /^meh/i,
        /^g/i,
        /^a/i,
        /^med/i,
        /^h/i,
        /^t/i,
        /^rh/i
    ]
};
var $999cc506042f93e5$var$matchDayPatterns = {
    narrow: /^(s|ll|m|i|g)/i,
    short: /^(su|ll|ma|me|ia|gw|sa)/i,
    abbreviated: /^(sul|llun|maw|mer|iau|gwe|sad)/i,
    wide: /^dydd (sul|llun|mawrth|mercher|iau|gwener|sadwrn)/i
};
var $999cc506042f93e5$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^ll/i,
        /^m/i,
        /^m/i,
        /^i/i,
        /^g/i,
        /^s/i
    ],
    wide: [
        /^dydd su/i,
        /^dydd ll/i,
        /^dydd ma/i,
        /^dydd me/i,
        /^dydd i/i,
        /^dydd g/i,
        /^dydd sa/i
    ],
    any: [
        /^su/i,
        /^ll/i,
        /^ma/i,
        /^me/i,
        /^i/i,
        /^g/i,
        /^sa/i
    ]
};
var $999cc506042f93e5$var$matchDayPeriodPatterns = {
    narrow: /^(b|h|hn|hd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i,
    any: /^(y\.?\s?[bh]\.?|hanner nos|hanner dydd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i
};
var $999cc506042f93e5$var$parseDayPeriodPatterns = {
    any: {
        am: /^b|(y\.?\s?b\.?)/i,
        pm: /^h|(y\.?\s?h\.?)|(yr hwyr)/i,
        midnight: /^hn|hanner nos/i,
        noon: /^hd|hanner dydd/i,
        morning: /bore/i,
        afternoon: /prynhawn/i,
        evening: /^gyda'r nos$/i,
        night: /blah/i
    }
};
var $999cc506042f93e5$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $999cc506042f93e5$var$matchOrdinalNumberPattern,
        parsePattern: $999cc506042f93e5$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $999cc506042f93e5$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $999cc506042f93e5$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $999cc506042f93e5$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $999cc506042f93e5$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $999cc506042f93e5$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $999cc506042f93e5$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $999cc506042f93e5$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $999cc506042f93e5$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $999cc506042f93e5$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $999cc506042f93e5$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $999cc506042f93e5$export$2e2bcd8739ae039 = $999cc506042f93e5$var$match;

});


parcelRegister("2fFal", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a3cea2c6defd423$export$2e2bcd8739ae039);

var $jBsZO = parcelRequire("jBsZO");

var $RlDcU = parcelRequire("RlDcU");

var $ihBPW = parcelRequire("ihBPW");

var $1Fcmg = parcelRequire("1Fcmg");

var $8S62Q = parcelRequire("8S62Q");
/**
 * @type {Locale}
 * @category Locales
 * @summary Danish locale.
 * @language Danish
 * @iso-639-2 dan
 * @author Mathias Wøbbe [@MathiasKandelborg]{@link https://github.com/MathiasKandelborg}
 * @author Anders B. Hansen [@Andersbiha]{@link https://github.com/Andersbiha}
 * @author [@kgram]{@link https://github.com/kgram}
 * @author [@stefanbugge]{@link https://github.com/stefanbugge}
 */ var $1a3cea2c6defd423$var$locale = {
    code: "da",
    formatDistance: (0, $jBsZO.default),
    formatLong: (0, $RlDcU.default),
    formatRelative: (0, $ihBPW.default),
    localize: (0, $1Fcmg.default),
    match: (0, $8S62Q.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $1a3cea2c6defd423$export$2e2bcd8739ae039 = $1a3cea2c6defd423$var$locale;

});
parcelRegister("jBsZO", function(module, exports) {

$parcel$export(module.exports, "default", () => $e457f705dc52369d$export$2e2bcd8739ae039);
var $e457f705dc52369d$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mindre end \xe9t sekund",
        other: "mindre end {{count}} sekunder"
    },
    xSeconds: {
        one: "1 sekund",
        other: "{{count}} sekunder"
    },
    halfAMinute: "\xe9t halvt minut",
    lessThanXMinutes: {
        one: "mindre end \xe9t minut",
        other: "mindre end {{count}} minutter"
    },
    xMinutes: {
        one: "1 minut",
        other: "{{count}} minutter"
    },
    aboutXHours: {
        one: "cirka 1 time",
        other: "cirka {{count}} timer"
    },
    xHours: {
        one: "1 time",
        other: "{{count}} timer"
    },
    xDays: {
        one: "1 dag",
        other: "{{count}} dage"
    },
    aboutXWeeks: {
        one: "cirka 1 uge",
        other: "cirka {{count}} uger"
    },
    xWeeks: {
        one: "1 uge",
        other: "{{count}} uger"
    },
    aboutXMonths: {
        one: "cirka 1 m\xe5ned",
        other: "cirka {{count}} m\xe5neder"
    },
    xMonths: {
        one: "1 m\xe5ned",
        other: "{{count}} m\xe5neder"
    },
    aboutXYears: {
        one: "cirka 1 \xe5r",
        other: "cirka {{count}} \xe5r"
    },
    xYears: {
        one: "1 \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "over 1 \xe5r",
        other: "over {{count}} \xe5r"
    },
    almostXYears: {
        one: "n\xe6sten 1 \xe5r",
        other: "n\xe6sten {{count}} \xe5r"
    }
};
var $e457f705dc52369d$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $e457f705dc52369d$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "om " + result;
        else return result + " siden";
    }
    return result;
};
var $e457f705dc52369d$export$2e2bcd8739ae039 = $e457f705dc52369d$var$formatDistance;

});

parcelRegister("RlDcU", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a05bae462066246$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $0a05bae462066246$var$dateFormats = {
    full: "EEEE 'den' d. MMMM y",
    long: "d. MMMM y",
    medium: "d. MMM y",
    short: "dd/MM/y"
};
var $0a05bae462066246$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $0a05bae462066246$var$dateTimeFormats = {
    full: "{{date}} 'kl'. {{time}}",
    long: "{{date}} 'kl'. {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $0a05bae462066246$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $0a05bae462066246$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $0a05bae462066246$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $0a05bae462066246$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $0a05bae462066246$export$2e2bcd8739ae039 = $0a05bae462066246$var$formatLong;

});

parcelRegister("ihBPW", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4f72a2004623fcf$export$2e2bcd8739ae039);
var $d4f72a2004623fcf$var$formatRelativeLocale = {
    lastWeek: "'sidste' eeee 'kl.' p",
    yesterday: "'i g\xe5r kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgen kl.' p",
    nextWeek: "'p\xe5' eeee 'kl.' p",
    other: "P"
};
var $d4f72a2004623fcf$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $d4f72a2004623fcf$var$formatRelativeLocale[token];
};
var $d4f72a2004623fcf$export$2e2bcd8739ae039 = $d4f72a2004623fcf$var$formatRelative;

});

parcelRegister("1Fcmg", function(module, exports) {

$parcel$export(module.exports, "default", () => $136334d5065daf88$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $136334d5065daf88$var$eraValues = {
    narrow: [
        "fvt",
        "vt"
    ],
    abbreviated: [
        "f.v.t.",
        "v.t."
    ],
    wide: [
        "f\xf8r vesterlandsk tidsregning",
        "vesterlandsk tidsregning"
    ]
};
var $136334d5065daf88$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1. kvt.",
        "2. kvt.",
        "3. kvt.",
        "4. kvt."
    ],
    wide: [
        "1. kvartal",
        "2. kvartal",
        "3. kvartal",
        "4. kvartal"
    ]
};
var $136334d5065daf88$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mar.",
        "apr.",
        "maj",
        "jun.",
        "jul.",
        "aug.",
        "sep.",
        "okt.",
        "nov.",
        "dec."
    ],
    wide: [
        "januar",
        "februar",
        "marts",
        "april",
        "maj",
        "juni",
        "juli",
        "august",
        "september",
        "oktober",
        "november",
        "december"
    ]
};
// Note that 'Days - abbreviated - Formatting' has periods at the end.
// https://www.unicode.org/cldr/charts/32/summary/da.html#1760
// This makes grammatical sense in danish, as most abbreviations have periods.
var $136334d5065daf88$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "O",
        "T",
        "F",
        "L"
    ],
    short: [
        "s\xf8",
        "ma",
        "ti",
        "on",
        "to",
        "fr",
        "l\xf8"
    ],
    abbreviated: [
        "s\xf8n.",
        "man.",
        "tir.",
        "ons.",
        "tor.",
        "fre.",
        "l\xf8r."
    ],
    wide: [
        "s\xf8ndag",
        "mandag",
        "tirsdag",
        "onsdag",
        "torsdag",
        "fredag",
        "l\xf8rdag"
    ]
};
var $136334d5065daf88$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "midnat",
        noon: "middag",
        morning: "morgen",
        afternoon: "eftermiddag",
        evening: "aften",
        night: "nat"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnat",
        noon: "middag",
        morning: "morgen",
        afternoon: "eftermiddag",
        evening: "aften",
        night: "nat"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnat",
        noon: "middag",
        morning: "morgen",
        afternoon: "eftermiddag",
        evening: "aften",
        night: "nat"
    }
};
var $136334d5065daf88$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "midnat",
        noon: "middag",
        morning: "om morgenen",
        afternoon: "om eftermiddagen",
        evening: "om aftenen",
        night: "om natten"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnat",
        noon: "middag",
        morning: "om morgenen",
        afternoon: "om eftermiddagen",
        evening: "om aftenen",
        night: "om natten"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnat",
        noon: "middag",
        morning: "om morgenen",
        afternoon: "om eftermiddagen",
        evening: "om aftenen",
        night: "om natten"
    }
};
var $136334d5065daf88$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + ".";
};
var $136334d5065daf88$var$localize = {
    ordinalNumber: $136334d5065daf88$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $136334d5065daf88$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $136334d5065daf88$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $136334d5065daf88$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $136334d5065daf88$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $136334d5065daf88$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $136334d5065daf88$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $136334d5065daf88$export$2e2bcd8739ae039 = $136334d5065daf88$var$localize;

});

parcelRegister("8S62Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $67580e3f20612962$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $67580e3f20612962$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var $67580e3f20612962$var$parseOrdinalNumberPattern = /\d+/i;
var $67580e3f20612962$var$matchEraPatterns = {
    narrow: /^(fKr|fvt|eKr|vt)/i,
    abbreviated: /^(f\.Kr\.?|f\.v\.t\.?|e\.Kr\.?|v\.t\.)/i,
    wide: /^(f.Kr.|før vesterlandsk tidsregning|e.Kr.|vesterlandsk tidsregning)/i
};
var $67580e3f20612962$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^(v|e)/i
    ]
};
var $67580e3f20612962$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]. kvt\./i,
    wide: /^[1234]\.? kvartal/i
};
var $67580e3f20612962$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $67580e3f20612962$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december)/i
};
var $67580e3f20612962$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $67580e3f20612962$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(søn.|man.|tir.|ons.|tor.|fre.|lør.)/i,
    abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
    wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
};
var $67580e3f20612962$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^o/i,
        /^t/i,
        /^f/i,
        /^l/i
    ],
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var $67580e3f20612962$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i,
    any: /^([ap]\.?\s?m\.?|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i
};
var $67580e3f20612962$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /midnat/i,
        noon: /middag/i,
        morning: /morgen/i,
        afternoon: /eftermiddag/i,
        evening: /aften/i,
        night: /nat/i
    }
};
var $67580e3f20612962$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $67580e3f20612962$var$matchOrdinalNumberPattern,
        parsePattern: $67580e3f20612962$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $67580e3f20612962$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $67580e3f20612962$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $67580e3f20612962$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $67580e3f20612962$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $67580e3f20612962$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $67580e3f20612962$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $67580e3f20612962$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $67580e3f20612962$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $67580e3f20612962$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $67580e3f20612962$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $67580e3f20612962$export$2e2bcd8739ae039 = $67580e3f20612962$var$match;

});


parcelRegister("5yLJB", function(module, exports) {

$parcel$export(module.exports, "default", () => $40c527d5a6b775b3$export$2e2bcd8739ae039);

var $6KEW0 = parcelRequire("6KEW0");

var $aDLrd = parcelRequire("aDLrd");

var $kvRNh = parcelRequire("kvRNh");

var $Ws3R1 = parcelRequire("Ws3R1");

var $7c6uY = parcelRequire("7c6uY");
/**
 * @type {Locale}
 * @category Locales
 * @summary German locale.
 * @language German
 * @iso-639-2 deu
 * @author Thomas Eilmsteiner [@DeMuu]{@link https://github.com/DeMuu}
 * @author Asia [@asia-t]{@link https://github.com/asia-t}
 * @author Van Vuong Ngo [@vanvuongngo]{@link https://github.com/vanvuongngo}
 * @author RomanErnst [@pex]{@link https://github.com/pex}
 * @author Philipp Keck [@Philipp91]{@link https://github.com/Philipp91}
 */ var $40c527d5a6b775b3$var$locale = {
    code: "de",
    formatDistance: (0, $6KEW0.default),
    formatLong: (0, $aDLrd.default),
    formatRelative: (0, $kvRNh.default),
    localize: (0, $Ws3R1.default),
    match: (0, $7c6uY.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $40c527d5a6b775b3$export$2e2bcd8739ae039 = $40c527d5a6b775b3$var$locale;

});
parcelRegister("6KEW0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ea6cab80ac3690c$export$2e2bcd8739ae039);
var $4ea6cab80ac3690c$var$formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: "weniger als 1 Sekunde",
            other: "weniger als {{count}} Sekunden"
        },
        withPreposition: {
            one: "weniger als 1 Sekunde",
            other: "weniger als {{count}} Sekunden"
        }
    },
    xSeconds: {
        standalone: {
            one: "1 Sekunde",
            other: "{{count}} Sekunden"
        },
        withPreposition: {
            one: "1 Sekunde",
            other: "{{count}} Sekunden"
        }
    },
    halfAMinute: {
        standalone: "halbe Minute",
        withPreposition: "halben Minute"
    },
    lessThanXMinutes: {
        standalone: {
            one: "weniger als 1 Minute",
            other: "weniger als {{count}} Minuten"
        },
        withPreposition: {
            one: "weniger als 1 Minute",
            other: "weniger als {{count}} Minuten"
        }
    },
    xMinutes: {
        standalone: {
            one: "1 Minute",
            other: "{{count}} Minuten"
        },
        withPreposition: {
            one: "1 Minute",
            other: "{{count}} Minuten"
        }
    },
    aboutXHours: {
        standalone: {
            one: "etwa 1 Stunde",
            other: "etwa {{count}} Stunden"
        },
        withPreposition: {
            one: "etwa 1 Stunde",
            other: "etwa {{count}} Stunden"
        }
    },
    xHours: {
        standalone: {
            one: "1 Stunde",
            other: "{{count}} Stunden"
        },
        withPreposition: {
            one: "1 Stunde",
            other: "{{count}} Stunden"
        }
    },
    xDays: {
        standalone: {
            one: "1 Tag",
            other: "{{count}} Tage"
        },
        withPreposition: {
            one: "1 Tag",
            other: "{{count}} Tagen"
        }
    },
    aboutXWeeks: {
        standalone: {
            one: "etwa 1 Woche",
            other: "etwa {{count}} Wochen"
        },
        withPreposition: {
            one: "etwa 1 Woche",
            other: "etwa {{count}} Wochen"
        }
    },
    xWeeks: {
        standalone: {
            one: "1 Woche",
            other: "{{count}} Wochen"
        },
        withPreposition: {
            one: "1 Woche",
            other: "{{count}} Wochen"
        }
    },
    aboutXMonths: {
        standalone: {
            one: "etwa 1 Monat",
            other: "etwa {{count}} Monate"
        },
        withPreposition: {
            one: "etwa 1 Monat",
            other: "etwa {{count}} Monaten"
        }
    },
    xMonths: {
        standalone: {
            one: "1 Monat",
            other: "{{count}} Monate"
        },
        withPreposition: {
            one: "1 Monat",
            other: "{{count}} Monaten"
        }
    },
    aboutXYears: {
        standalone: {
            one: "etwa 1 Jahr",
            other: "etwa {{count}} Jahre"
        },
        withPreposition: {
            one: "etwa 1 Jahr",
            other: "etwa {{count}} Jahren"
        }
    },
    xYears: {
        standalone: {
            one: "1 Jahr",
            other: "{{count}} Jahre"
        },
        withPreposition: {
            one: "1 Jahr",
            other: "{{count}} Jahren"
        }
    },
    overXYears: {
        standalone: {
            one: "mehr als 1 Jahr",
            other: "mehr als {{count}} Jahre"
        },
        withPreposition: {
            one: "mehr als 1 Jahr",
            other: "mehr als {{count}} Jahren"
        }
    },
    almostXYears: {
        standalone: {
            one: "fast 1 Jahr",
            other: "fast {{count}} Jahre"
        },
        withPreposition: {
            one: "fast 1 Jahr",
            other: "fast {{count}} Jahren"
        }
    }
};
var $4ea6cab80ac3690c$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = options !== null && options !== void 0 && options.addSuffix ? $4ea6cab80ac3690c$var$formatDistanceLocale[token].withPreposition : $4ea6cab80ac3690c$var$formatDistanceLocale[token].standalone;
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return "vor " + result;
    }
    return result;
};
var $4ea6cab80ac3690c$export$2e2bcd8739ae039 = $4ea6cab80ac3690c$var$formatDistance;

});

parcelRegister("aDLrd", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bf258153eaa9e12$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
// DIN 5008: https://de.wikipedia.org/wiki/Datumsformat#DIN_5008
var $7bf258153eaa9e12$var$dateFormats = {
    full: "EEEE, do MMMM y",
    // Montag, 7. Januar 2018
    long: "do MMMM y",
    // 7. Januar 2018
    medium: "do MMM y",
    // 7. Jan. 2018
    short: "dd.MM.y" // 07.01.2018
};
var $7bf258153eaa9e12$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $7bf258153eaa9e12$var$dateTimeFormats = {
    full: "{{date}} 'um' {{time}}",
    long: "{{date}} 'um' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $7bf258153eaa9e12$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $7bf258153eaa9e12$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $7bf258153eaa9e12$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $7bf258153eaa9e12$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $7bf258153eaa9e12$export$2e2bcd8739ae039 = $7bf258153eaa9e12$var$formatLong;

});

parcelRegister("kvRNh", function(module, exports) {

$parcel$export(module.exports, "default", () => $eef06e3cad4a45d7$export$2e2bcd8739ae039);
var $eef06e3cad4a45d7$var$formatRelativeLocale = {
    lastWeek: "'letzten' eeee 'um' p",
    yesterday: "'gestern um' p",
    today: "'heute um' p",
    tomorrow: "'morgen um' p",
    nextWeek: "eeee 'um' p",
    other: "P"
};
var $eef06e3cad4a45d7$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $eef06e3cad4a45d7$var$formatRelativeLocale[token];
};
var $eef06e3cad4a45d7$export$2e2bcd8739ae039 = $eef06e3cad4a45d7$var$formatRelative;

});

parcelRegister("Ws3R1", function(module, exports) {

$parcel$export(module.exports, "default", () => $0afb2f41e7423189$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $0afb2f41e7423189$var$eraValues = {
    narrow: [
        "v.Chr.",
        "n.Chr."
    ],
    abbreviated: [
        "v.Chr.",
        "n.Chr."
    ],
    wide: [
        "vor Christus",
        "nach Christus"
    ]
};
var $0afb2f41e7423189$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1. Quartal",
        "2. Quartal",
        "3. Quartal",
        "4. Quartal"
    ]
};
// Note: in German, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $0afb2f41e7423189$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "M\xe4r",
        "Apr",
        "Mai",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Okt",
        "Nov",
        "Dez"
    ],
    wide: [
        "Januar",
        "Februar",
        "M\xe4rz",
        "April",
        "Mai",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Dezember"
    ]
};
// https://st.unicode.org/cldr-apps/v#/de/Gregorian/
var $0afb2f41e7423189$var$formattingMonthValues = {
    narrow: $0afb2f41e7423189$var$monthValues.narrow,
    abbreviated: [
        "Jan.",
        "Feb.",
        "M\xe4rz",
        "Apr.",
        "Mai",
        "Juni",
        "Juli",
        "Aug.",
        "Sep.",
        "Okt.",
        "Nov.",
        "Dez."
    ],
    wide: $0afb2f41e7423189$var$monthValues.wide
};
var $0afb2f41e7423189$var$dayValues = {
    narrow: [
        "S",
        "M",
        "D",
        "M",
        "D",
        "F",
        "S"
    ],
    short: [
        "So",
        "Mo",
        "Di",
        "Mi",
        "Do",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "So.",
        "Mo.",
        "Di.",
        "Mi.",
        "Do.",
        "Fr.",
        "Sa."
    ],
    wide: [
        "Sonntag",
        "Montag",
        "Dienstag",
        "Mittwoch",
        "Donnerstag",
        "Freitag",
        "Samstag"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/de.html#1881
var $0afb2f41e7423189$var$dayPeriodValues = {
    narrow: {
        am: "vm.",
        pm: "nm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "Morgen",
        afternoon: "Nachm.",
        evening: "Abend",
        night: "Nacht"
    },
    abbreviated: {
        am: "vorm.",
        pm: "nachm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "Morgen",
        afternoon: "Nachmittag",
        evening: "Abend",
        night: "Nacht"
    },
    wide: {
        am: "vormittags",
        pm: "nachmittags",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "Morgen",
        afternoon: "Nachmittag",
        evening: "Abend",
        night: "Nacht"
    }
};
var $0afb2f41e7423189$var$formattingDayPeriodValues = {
    narrow: {
        am: "vm.",
        pm: "nm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "morgens",
        afternoon: "nachm.",
        evening: "abends",
        night: "nachts"
    },
    abbreviated: {
        am: "vorm.",
        pm: "nachm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "morgens",
        afternoon: "nachmittags",
        evening: "abends",
        night: "nachts"
    },
    wide: {
        am: "vormittags",
        pm: "nachmittags",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "morgens",
        afternoon: "nachmittags",
        evening: "abends",
        night: "nachts"
    }
};
var $0afb2f41e7423189$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    return number + ".";
};
var $0afb2f41e7423189$var$localize = {
    ordinalNumber: $0afb2f41e7423189$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $0afb2f41e7423189$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $0afb2f41e7423189$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $0afb2f41e7423189$var$monthValues,
        formattingValues: $0afb2f41e7423189$var$formattingMonthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $0afb2f41e7423189$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $0afb2f41e7423189$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $0afb2f41e7423189$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $0afb2f41e7423189$export$2e2bcd8739ae039 = $0afb2f41e7423189$var$localize;

});

parcelRegister("7c6uY", function(module, exports) {

$parcel$export(module.exports, "default", () => $53ceb1e1b2af0395$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $53ceb1e1b2af0395$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var $53ceb1e1b2af0395$var$parseOrdinalNumberPattern = /\d+/i;
var $53ceb1e1b2af0395$var$matchEraPatterns = {
    narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
};
var $53ceb1e1b2af0395$var$parseEraPatterns = {
    any: [
        /^v/i,
        /^n/i
    ]
};
var $53ceb1e1b2af0395$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? Quartal/i
};
var $53ceb1e1b2af0395$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $53ceb1e1b2af0395$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
    wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
};
var $53ceb1e1b2af0395$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^j[aä]/i,
        /^f/i,
        /^mär/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $53ceb1e1b2af0395$var$matchDayPatterns = {
    narrow: /^[smdmf]/i,
    short: /^(so|mo|di|mi|do|fr|sa)/i,
    abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
    wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
};
var $53ceb1e1b2af0395$var$parseDayPatterns = {
    any: [
        /^so/i,
        /^mo/i,
        /^di/i,
        /^mi/i,
        /^do/i,
        /^f/i,
        /^sa/i
    ]
};
var $53ceb1e1b2af0395$var$matchDayPeriodPatterns = {
    narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
    wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
};
var $53ceb1e1b2af0395$var$parseDayPeriodPatterns = {
    any: {
        am: /^v/i,
        pm: /^n/i,
        midnight: /^Mitte/i,
        noon: /^Mitta/i,
        morning: /morgens/i,
        afternoon: /nachmittags/i,
        // will never be matched. Afternoon is matched by `pm`
        evening: /abends/i,
        night: /nachts/i // will never be matched. Night is matched by `pm`
    }
};
var $53ceb1e1b2af0395$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $53ceb1e1b2af0395$var$matchOrdinalNumberPattern,
        parsePattern: $53ceb1e1b2af0395$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $53ceb1e1b2af0395$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $53ceb1e1b2af0395$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $53ceb1e1b2af0395$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $53ceb1e1b2af0395$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $53ceb1e1b2af0395$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $53ceb1e1b2af0395$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $53ceb1e1b2af0395$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $53ceb1e1b2af0395$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $53ceb1e1b2af0395$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $53ceb1e1b2af0395$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $53ceb1e1b2af0395$export$2e2bcd8739ae039 = $53ceb1e1b2af0395$var$match;

});


parcelRegister("ddOmO", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a038f147f7768ec$export$2e2bcd8739ae039);

var $6KEW0 = parcelRequire("6KEW0");

var $aDLrd = parcelRequire("aDLrd");

var $kvRNh = parcelRequire("kvRNh");

var $7c6uY = parcelRequire("7c6uY");

var $lv7RP = parcelRequire("lv7RP");
/**
 * @type {Locale}
 * @category Locales
 * @summary German locale (Austria).
 * @language German
 * @iso-639-2 deu
 * @author Christoph Tobias Stenglein [@cstenglein]{@link https://github.com/cstenglein}
 */ var $9a038f147f7768ec$var$locale = {
    code: "de-AT",
    formatDistance: (0, $6KEW0.default),
    formatLong: (0, $aDLrd.default),
    formatRelative: (0, $kvRNh.default),
    localize: (0, $lv7RP.default),
    match: (0, $7c6uY.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $9a038f147f7768ec$export$2e2bcd8739ae039 = $9a038f147f7768ec$var$locale;

});
parcelRegister("lv7RP", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa72987a788d7af7$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $fa72987a788d7af7$var$eraValues = {
    narrow: [
        "v.Chr.",
        "n.Chr."
    ],
    abbreviated: [
        "v.Chr.",
        "n.Chr."
    ],
    wide: [
        "vor Christus",
        "nach Christus"
    ]
};
var $fa72987a788d7af7$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1. Quartal",
        "2. Quartal",
        "3. Quartal",
        "4. Quartal"
    ]
};
// Note: in German, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $fa72987a788d7af7$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "J\xe4n",
        "Feb",
        "M\xe4r",
        "Apr",
        "Mai",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Okt",
        "Nov",
        "Dez"
    ],
    wide: [
        "J\xe4nner",
        "Februar",
        "M\xe4rz",
        "April",
        "Mai",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Dezember"
    ]
};
// https://st.unicode.org/cldr-apps/v#/de_AT/Gregorian/
var $fa72987a788d7af7$var$formattingMonthValues = {
    narrow: $fa72987a788d7af7$var$monthValues.narrow,
    abbreviated: [
        "J\xe4n.",
        "Feb.",
        "M\xe4rz",
        "Apr.",
        "Mai",
        "Juni",
        "Juli",
        "Aug.",
        "Sep.",
        "Okt.",
        "Nov.",
        "Dez."
    ],
    wide: $fa72987a788d7af7$var$monthValues.wide
};
var $fa72987a788d7af7$var$dayValues = {
    narrow: [
        "S",
        "M",
        "D",
        "M",
        "D",
        "F",
        "S"
    ],
    short: [
        "So",
        "Mo",
        "Di",
        "Mi",
        "Do",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "So.",
        "Mo.",
        "Di.",
        "Mi.",
        "Do.",
        "Fr.",
        "Sa."
    ],
    wide: [
        "Sonntag",
        "Montag",
        "Dienstag",
        "Mittwoch",
        "Donnerstag",
        "Freitag",
        "Samstag"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/de.html#1881
var $fa72987a788d7af7$var$dayPeriodValues = {
    narrow: {
        am: "vm.",
        pm: "nm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "Morgen",
        afternoon: "Nachm.",
        evening: "Abend",
        night: "Nacht"
    },
    abbreviated: {
        am: "vorm.",
        pm: "nachm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "Morgen",
        afternoon: "Nachmittag",
        evening: "Abend",
        night: "Nacht"
    },
    wide: {
        am: "vormittags",
        pm: "nachmittags",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "Morgen",
        afternoon: "Nachmittag",
        evening: "Abend",
        night: "Nacht"
    }
};
var $fa72987a788d7af7$var$formattingDayPeriodValues = {
    narrow: {
        am: "vm.",
        pm: "nm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "morgens",
        afternoon: "nachm.",
        evening: "abends",
        night: "nachts"
    },
    abbreviated: {
        am: "vorm.",
        pm: "nachm.",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "morgens",
        afternoon: "nachmittags",
        evening: "abends",
        night: "nachts"
    },
    wide: {
        am: "vormittags",
        pm: "nachmittags",
        midnight: "Mitternacht",
        noon: "Mittag",
        morning: "morgens",
        afternoon: "nachmittags",
        evening: "abends",
        night: "nachts"
    }
};
var $fa72987a788d7af7$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    return number + ".";
};
var $fa72987a788d7af7$var$localize = {
    ordinalNumber: $fa72987a788d7af7$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $fa72987a788d7af7$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $fa72987a788d7af7$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $fa72987a788d7af7$var$monthValues,
        formattingValues: $fa72987a788d7af7$var$formattingMonthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $fa72987a788d7af7$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $fa72987a788d7af7$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $fa72987a788d7af7$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $fa72987a788d7af7$export$2e2bcd8739ae039 = $fa72987a788d7af7$var$localize;

});


parcelRegister("7Pv9E", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b3576784cc22d12$export$2e2bcd8739ae039);

var $jk63p = parcelRequire("jk63p");

var $iAxCa = parcelRequire("iAxCa");

var $2tfO7 = parcelRequire("2tfO7");

var $fmXKz = parcelRequire("fmXKz");

var $9BBpW = parcelRequire("9BBpW");
/**
 * @type {Locale}
 * @category Locales
 * @summary Greek locale.
 * @language Greek
 * @iso-639-2 ell
 * @author Fanis Katsimpas [@fanixk]{@link https://github.com/fanixk}
 * @author Theodoros Orfanidis [@teoulas]{@link https://github.com/teoulas}
 */ var $5b3576784cc22d12$var$locale = {
    code: "el",
    formatDistance: (0, $jk63p.default),
    formatLong: (0, $iAxCa.default),
    formatRelative: (0, $2tfO7.default),
    localize: (0, $fmXKz.default),
    match: (0, $9BBpW.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $5b3576784cc22d12$export$2e2bcd8739ae039 = $5b3576784cc22d12$var$locale;

});
parcelRegister("jk63p", function(module, exports) {

$parcel$export(module.exports, "default", () => $e11494cca093c1f9$export$2e2bcd8739ae039);
var $e11494cca093c1f9$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC \u03AD\u03BD\u03B1 \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03BF",
        other: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC {{count}} \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1"
    },
    xSeconds: {
        one: "1 \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03BF",
        other: "{{count}} \u03B4\u03B5\u03C5\u03C4\u03B5\u03C1\u03CC\u03BB\u03B5\u03C0\u03C4\u03B1"
    },
    halfAMinute: "\u03BC\u03B9\u03C3\u03CC \u03BB\u03B5\u03C0\u03C4\u03CC",
    lessThanXMinutes: {
        one: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC \u03AD\u03BD\u03B1 \u03BB\u03B5\u03C0\u03C4\u03CC",
        other: "\u03BB\u03B9\u03B3\u03CC\u03C4\u03B5\u03C1\u03BF \u03B1\u03C0\u03CC {{count}} \u03BB\u03B5\u03C0\u03C4\u03AC"
    },
    xMinutes: {
        one: "1 \u03BB\u03B5\u03C0\u03C4\u03CC",
        other: "{{count}} \u03BB\u03B5\u03C0\u03C4\u03AC"
    },
    aboutXHours: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03CE\u03C1\u03B1",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03CE\u03C1\u03B5\u03C2"
    },
    xHours: {
        one: "1 \u03CE\u03C1\u03B1",
        other: "{{count}} \u03CE\u03C1\u03B5\u03C2"
    },
    xDays: {
        one: "1 \u03B7\u03BC\u03AD\u03C1\u03B1",
        other: "{{count}} \u03B7\u03BC\u03AD\u03C1\u03B5\u03C2"
    },
    aboutXWeeks: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B1",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B5\u03C2"
    },
    xWeeks: {
        one: "1 \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B1",
        other: "{{count}} \u03B5\u03B2\u03B4\u03BF\u03BC\u03AC\u03B4\u03B5\u03C2"
    },
    aboutXMonths: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03BC\u03AE\u03BD\u03B1\u03C2",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03BC\u03AE\u03BD\u03B5\u03C2"
    },
    xMonths: {
        one: "1 \u03BC\u03AE\u03BD\u03B1\u03C2",
        other: "{{count}} \u03BC\u03AE\u03BD\u03B5\u03C2"
    },
    aboutXYears: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    },
    xYears: {
        one: "1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "{{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    },
    overXYears: {
        one: "\u03C0\u03AC\u03BD\u03C9 \u03B1\u03C0\u03CC 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "\u03C0\u03AC\u03BD\u03C9 \u03B1\u03C0\u03CC {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    },
    almostXYears: {
        one: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 1 \u03C7\u03C1\u03CC\u03BD\u03BF",
        other: "\u03C0\u03B5\u03C1\u03AF\u03C0\u03BF\u03C5 {{count}} \u03C7\u03C1\u03CC\u03BD\u03B9\u03B1"
    }
};
var $e11494cca093c1f9$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $e11494cca093c1f9$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u03C3\u03B5 " + result;
        else return result + " \u03C0\u03C1\u03B9\u03BD";
    }
    return result;
};
var $e11494cca093c1f9$export$2e2bcd8739ae039 = $e11494cca093c1f9$var$formatDistance;

});

parcelRegister("iAxCa", function(module, exports) {

$parcel$export(module.exports, "default", () => $d885a9f624be025e$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $d885a9f624be025e$var$dateFormats = {
    full: "EEEE, d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "d/M/yy"
};
var $d885a9f624be025e$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $d885a9f624be025e$var$dateTimeFormats = {
    full: "{{date}} - {{time}}",
    long: "{{date}} - {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $d885a9f624be025e$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $d885a9f624be025e$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $d885a9f624be025e$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $d885a9f624be025e$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $d885a9f624be025e$export$2e2bcd8739ae039 = $d885a9f624be025e$var$formatLong;

});

parcelRegister("2tfO7", function(module, exports) {

$parcel$export(module.exports, "default", () => $1cca8d31c7e6ea34$export$2e2bcd8739ae039);
var $1cca8d31c7e6ea34$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        switch(date.getUTCDay()){
            case 6:
                //Σάββατο
                return "'\u03C4\u03BF \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03BF' eeee '\u03C3\u03C4\u03B9\u03C2' p";
            default:
                return "'\u03C4\u03B7\u03BD \u03C0\u03C1\u03BF\u03B7\u03B3\u03BF\u03CD\u03BC\u03B5\u03BD\u03B7' eeee '\u03C3\u03C4\u03B9\u03C2' p";
        }
    },
    yesterday: "'\u03C7\u03B8\u03B5\u03C2 \u03C3\u03C4\u03B9\u03C2' p",
    today: "'\u03C3\u03AE\u03BC\u03B5\u03C1\u03B1 \u03C3\u03C4\u03B9\u03C2' p",
    tomorrow: "'\u03B1\u03CD\u03C1\u03B9\u03BF \u03C3\u03C4\u03B9\u03C2' p",
    nextWeek: "eeee '\u03C3\u03C4\u03B9\u03C2' p",
    other: "P"
};
var $1cca8d31c7e6ea34$var$formatRelative = function formatRelative(token, date) {
    var format = $1cca8d31c7e6ea34$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
var $1cca8d31c7e6ea34$export$2e2bcd8739ae039 = $1cca8d31c7e6ea34$var$formatRelative;

});

parcelRegister("fmXKz", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3074233f72638fe$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $b3074233f72638fe$var$eraValues = {
    narrow: [
        "\u03C0\u03A7",
        "\u03BC\u03A7"
    ],
    abbreviated: [
        "\u03C0.\u03A7.",
        "\u03BC.\u03A7."
    ],
    wide: [
        "\u03C0\u03C1\u03BF \u03A7\u03C1\u03B9\u03C3\u03C4\u03BF\u03CD",
        "\u03BC\u03B5\u03C4\u03AC \u03A7\u03C1\u03B9\u03C3\u03C4\u03CC\u03BD"
    ]
};
var $b3074233f72638fe$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u03A41",
        "\u03A42",
        "\u03A43",
        "\u03A44"
    ],
    wide: [
        "1\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF",
        "2\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF",
        "3\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF",
        "4\u03BF \u03C4\u03C1\u03AF\u03BC\u03B7\u03BD\u03BF"
    ]
};
var $b3074233f72638fe$var$monthValues = {
    narrow: [
        "\u0399",
        "\u03A6",
        "\u039C",
        "\u0391",
        "\u039C",
        "\u0399",
        "\u0399",
        "\u0391",
        "\u03A3",
        "\u039F",
        "\u039D",
        "\u0394"
    ],
    abbreviated: [
        "\u0399\u03B1\u03BD",
        "\u03A6\u03B5\u03B2",
        "\u039C\u03AC\u03C1",
        "\u0391\u03C0\u03C1",
        "\u039C\u03AC\u03B9",
        "\u0399\u03BF\u03CD\u03BD",
        "\u0399\u03BF\u03CD\u03BB",
        "\u0391\u03CD\u03B3",
        "\u03A3\u03B5\u03C0",
        "\u039F\u03BA\u03C4",
        "\u039D\u03BF\u03AD",
        "\u0394\u03B5\u03BA"
    ],
    wide: [
        "\u0399\u03B1\u03BD\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2",
        "\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03AC\u03C1\u03B9\u03BF\u03C2",
        "\u039C\u03AC\u03C1\u03C4\u03B9\u03BF\u03C2",
        "\u0391\u03C0\u03C1\u03AF\u03BB\u03B9\u03BF\u03C2",
        "\u039C\u03AC\u03B9\u03BF\u03C2",
        "\u0399\u03BF\u03CD\u03BD\u03B9\u03BF\u03C2",
        "\u0399\u03BF\u03CD\u03BB\u03B9\u03BF\u03C2",
        "\u0391\u03CD\u03B3\u03BF\u03C5\u03C3\u03C4\u03BF\u03C2",
        "\u03A3\u03B5\u03C0\u03C4\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2",
        "\u039F\u03BA\u03C4\u03CE\u03B2\u03C1\u03B9\u03BF\u03C2",
        "\u039D\u03BF\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2",
        "\u0394\u03B5\u03BA\u03AD\u03BC\u03B2\u03C1\u03B9\u03BF\u03C2"
    ]
};
var $b3074233f72638fe$var$formattingMonthValues = {
    narrow: [
        "\u0399",
        "\u03A6",
        "\u039C",
        "\u0391",
        "\u039C",
        "\u0399",
        "\u0399",
        "\u0391",
        "\u03A3",
        "\u039F",
        "\u039D",
        "\u0394"
    ],
    abbreviated: [
        "\u0399\u03B1\u03BD",
        "\u03A6\u03B5\u03B2",
        "\u039C\u03B1\u03C1",
        "\u0391\u03C0\u03C1",
        "\u039C\u03B1\u0390",
        "\u0399\u03BF\u03C5\u03BD",
        "\u0399\u03BF\u03C5\u03BB",
        "\u0391\u03C5\u03B3",
        "\u03A3\u03B5\u03C0",
        "\u039F\u03BA\u03C4",
        "\u039D\u03BF\u03B5",
        "\u0394\u03B5\u03BA"
    ],
    wide: [
        "\u0399\u03B1\u03BD\u03BF\u03C5\u03B1\u03C1\u03AF\u03BF\u03C5",
        "\u03A6\u03B5\u03B2\u03C1\u03BF\u03C5\u03B1\u03C1\u03AF\u03BF\u03C5",
        "\u039C\u03B1\u03C1\u03C4\u03AF\u03BF\u03C5",
        "\u0391\u03C0\u03C1\u03B9\u03BB\u03AF\u03BF\u03C5",
        "\u039C\u03B1\u0390\u03BF\u03C5",
        "\u0399\u03BF\u03C5\u03BD\u03AF\u03BF\u03C5",
        "\u0399\u03BF\u03C5\u03BB\u03AF\u03BF\u03C5",
        "\u0391\u03C5\u03B3\u03BF\u03CD\u03C3\u03C4\u03BF\u03C5",
        "\u03A3\u03B5\u03C0\u03C4\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5",
        "\u039F\u03BA\u03C4\u03C9\u03B2\u03C1\u03AF\u03BF\u03C5",
        "\u039D\u03BF\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5",
        "\u0394\u03B5\u03BA\u03B5\u03BC\u03B2\u03C1\u03AF\u03BF\u03C5"
    ]
};
var $b3074233f72638fe$var$dayValues = {
    narrow: [
        "\u039A",
        "\u0394",
        "T",
        "\u03A4",
        "\u03A0",
        "\u03A0",
        "\u03A3"
    ],
    short: [
        "\u039A\u03C5",
        "\u0394\u03B5",
        "\u03A4\u03C1",
        "\u03A4\u03B5",
        "\u03A0\u03AD",
        "\u03A0\u03B1",
        "\u03A3\u03AC"
    ],
    abbreviated: [
        "\u039A\u03C5\u03C1",
        "\u0394\u03B5\u03C5",
        "\u03A4\u03C1\u03AF",
        "\u03A4\u03B5\u03C4",
        "\u03A0\u03AD\u03BC",
        "\u03A0\u03B1\u03C1",
        "\u03A3\u03AC\u03B2"
    ],
    wide: [
        "\u039A\u03C5\u03C1\u03B9\u03B1\u03BA\u03AE",
        "\u0394\u03B5\u03C5\u03C4\u03AD\u03C1\u03B1",
        "\u03A4\u03C1\u03AF\u03C4\u03B7",
        "\u03A4\u03B5\u03C4\u03AC\u03C1\u03C4\u03B7",
        "\u03A0\u03AD\u03BC\u03C0\u03C4\u03B7",
        "\u03A0\u03B1\u03C1\u03B1\u03C3\u03BA\u03B5\u03C5\u03AE",
        "\u03A3\u03AC\u03B2\u03B2\u03B1\u03C4\u03BF"
    ]
};
var $b3074233f72638fe$var$dayPeriodValues = {
    narrow: {
        am: "\u03C0\u03BC",
        pm: "\u03BC\u03BC",
        midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
        noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
        morning: "\u03C0\u03C1\u03C9\u03AF",
        afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
        evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
        night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
    },
    abbreviated: {
        am: "\u03C0.\u03BC.",
        pm: "\u03BC.\u03BC.",
        midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
        noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
        morning: "\u03C0\u03C1\u03C9\u03AF",
        afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
        evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
        night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
    },
    wide: {
        am: "\u03C0.\u03BC.",
        pm: "\u03BC.\u03BC.",
        midnight: "\u03BC\u03B5\u03C3\u03AC\u03BD\u03C5\u03C7\u03C4\u03B1",
        noon: "\u03BC\u03B5\u03C3\u03B7\u03BC\u03AD\u03C1\u03B9",
        morning: "\u03C0\u03C1\u03C9\u03AF",
        afternoon: "\u03B1\u03C0\u03CC\u03B3\u03B5\u03C5\u03BC\u03B1",
        evening: "\u03B2\u03C1\u03AC\u03B4\u03C5",
        night: "\u03BD\u03CD\u03C7\u03C4\u03B1"
    }
};
var $b3074233f72638fe$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    var suffix;
    if (unit === "year" || unit === "month") suffix = "\u03BF\u03C2";
    else if (unit === "week" || unit === "dayOfYear" || unit === "day" || unit === "hour" || unit === "date") suffix = "\u03B7";
    else suffix = "\u03BF";
    return number + suffix;
};
var $b3074233f72638fe$var$localize = {
    ordinalNumber: $b3074233f72638fe$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $b3074233f72638fe$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $b3074233f72638fe$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $b3074233f72638fe$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $b3074233f72638fe$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $b3074233f72638fe$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $b3074233f72638fe$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};
var $b3074233f72638fe$export$2e2bcd8739ae039 = $b3074233f72638fe$var$localize;

});

parcelRegister("9BBpW", function(module, exports) {

$parcel$export(module.exports, "default", () => $6fe49813ba7ebbed$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $6fe49813ba7ebbed$var$matchOrdinalNumberPattern = /^(\d+)(ος|η|ο)?/i;
var $6fe49813ba7ebbed$var$parseOrdinalNumberPattern = /\d+/i;
var $6fe49813ba7ebbed$var$matchEraPatterns = {
    narrow: /^(πΧ|μΧ)/i,
    abbreviated: /^(π\.?\s?χ\.?|π\.?\s?κ\.?\s?χ\.?|μ\.?\s?χ\.?|κ\.?\s?χ\.?)/i,
    wide: /^(προ Χριστο(ύ|υ)|πριν απ(ό|ο) την Κοιν(ή|η) Χρονολογ(ί|ι)α|μετ(ά|α) Χριστ(ό|ο)ν|Κοιν(ή|η) Χρονολογ(ί|ι)α)/i
};
var $6fe49813ba7ebbed$var$parseEraPatterns = {
    any: [
        /^π/i,
        /^(μ|κ)/i
    ]
};
var $6fe49813ba7ebbed$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^τ[1234]/i,
    wide: /^[1234]ο? τρ(ί|ι)μηνο/i
};
var $6fe49813ba7ebbed$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $6fe49813ba7ebbed$var$matchMonthPatterns = {
    narrow: /^[ιφμαμιιασονδ]/i,
    abbreviated: /^(ιαν|φεβ|μ[άα]ρ|απρ|μ[άα][ιΐ]|ιο[ύυ]ν|ιο[ύυ]λ|α[ύυ]γ|σεπ|οκτ|νο[έε]|δεκ)/i,
    wide: /^(μ[άα][ιΐ]|α[ύυ]γο[υύ]στ)(ος|ου)|(ιανου[άα]ρ|φεβρου[άα]ρ|μ[άα]ρτ|απρ[ίι]λ|ιο[ύυ]ν|ιο[ύυ]λ|σεπτ[έε]μβρ|οκτ[ώω]βρ|νο[έε]μβρ|δεκ[έε]μβρ)(ιος|ίου)/i
};
var $6fe49813ba7ebbed$var$parseMonthPatterns = {
    narrow: [
        /^ι/i,
        /^φ/i,
        /^μ/i,
        /^α/i,
        /^μ/i,
        /^ι/i,
        /^ι/i,
        /^α/i,
        /^σ/i,
        /^ο/i,
        /^ν/i,
        /^δ/i
    ],
    any: [
        /^ια/i,
        /^φ/i,
        /^μ[άα]ρ/i,
        /^απ/i,
        /^μ[άα][ιΐ]/i,
        /^ιο[ύυ]ν/i,
        /^ιο[ύυ]λ/i,
        /^α[ύυ]/i,
        /^σ/i,
        /^ο/i,
        /^ν/i,
        /^δ/i
    ]
};
var $6fe49813ba7ebbed$var$matchDayPatterns = {
    narrow: /^[κδτπσ]/i,
    short: /^(κυ|δε|τρ|τε|π[εέ]|π[αά]|σ[αά])/i,
    abbreviated: /^(κυρ|δευ|τρι|τετ|πεμ|παρ|σαβ)/i,
    wide: /^(κυριακ(ή|η)|δευτ(έ|ε)ρα|τρ(ί|ι)τη|τετ(ά|α)ρτη|π(έ|ε)μπτη|παρασκευ(ή|η)|σ(ά|α)ββατο)/i
};
var $6fe49813ba7ebbed$var$parseDayPatterns = {
    narrow: [
        /^κ/i,
        /^δ/i,
        /^τ/i,
        /^τ/i,
        /^π/i,
        /^π/i,
        /^σ/i
    ],
    any: [
        /^κ/i,
        /^δ/i,
        /^τρ/i,
        /^τε/i,
        /^π[εέ]/i,
        /^π[αά]/i,
        /^σ/i
    ]
};
var $6fe49813ba7ebbed$var$matchDayPeriodPatterns = {
    narrow: /^(πμ|μμ|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i,
    any: /^([πμ]\.?\s?μ\.?|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i
};
var $6fe49813ba7ebbed$var$parseDayPeriodPatterns = {
    any: {
        am: /^πμ|π\.\s?μ\./i,
        pm: /^μμ|μ\.\s?μ\./i,
        midnight: /^μεσάν/i,
        noon: /^μεσημ(έ|ε)/i,
        morning: /πρω(ί|ι)/i,
        afternoon: /απ(ό|ο)γευμα/i,
        evening: /βρ(ά|α)δυ/i,
        night: /ν(ύ|υ)χτα/i
    }
};
var $6fe49813ba7ebbed$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $6fe49813ba7ebbed$var$matchOrdinalNumberPattern,
        parsePattern: $6fe49813ba7ebbed$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $6fe49813ba7ebbed$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6fe49813ba7ebbed$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $6fe49813ba7ebbed$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6fe49813ba7ebbed$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $6fe49813ba7ebbed$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6fe49813ba7ebbed$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $6fe49813ba7ebbed$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6fe49813ba7ebbed$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $6fe49813ba7ebbed$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $6fe49813ba7ebbed$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $6fe49813ba7ebbed$export$2e2bcd8739ae039 = $6fe49813ba7ebbed$var$match;

});


parcelRegister("6UbtV", function(module, exports) {

$parcel$export(module.exports, "default", () => $5070e10bd881859c$export$2e2bcd8739ae039);

var $2qFQF = parcelRequire("2qFQF");

var $5l2UL = parcelRequire("5l2UL");

var $1uXR5 = parcelRequire("1uXR5");

var $cPhtT = parcelRequire("cPhtT");

var $2SJ52 = parcelRequire("2SJ52");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (Australia).
 * @language English
 * @iso-639-2 eng
 * @author Julien Malige [@JulienMalige]{@link https://github.com/JulienMalige}
 */ var $5070e10bd881859c$var$locale = {
    code: "en-AU",
    formatDistance: (0, $2qFQF.default),
    formatLong: (0, $5l2UL.default),
    formatRelative: (0, $1uXR5.default),
    localize: (0, $cPhtT.default),
    match: (0, $2SJ52.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $5070e10bd881859c$export$2e2bcd8739ae039 = $5070e10bd881859c$var$locale;

});
parcelRegister("5l2UL", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e312cb322a843cd$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $3e312cb322a843cd$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd/MM/yyyy"
};
var $3e312cb322a843cd$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $3e312cb322a843cd$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $3e312cb322a843cd$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $3e312cb322a843cd$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $3e312cb322a843cd$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $3e312cb322a843cd$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $3e312cb322a843cd$export$2e2bcd8739ae039 = $3e312cb322a843cd$var$formatLong;

});


parcelRegister("8DB38", function(module, exports) {

$parcel$export(module.exports, "default", () => $649eb48911da332e$export$2e2bcd8739ae039);

var $1uXR5 = parcelRequire("1uXR5");

var $cPhtT = parcelRequire("cPhtT");

var $2SJ52 = parcelRequire("2SJ52");

var $7nfYo = parcelRequire("7nfYo");

var $4XHv2 = parcelRequire("4XHv2");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (Canada).
 * @language English
 * @iso-639-2 eng
 * @author Mark Owsiak [@markowsiak]{@link https://github.com/markowsiak}
 * @author Marco Imperatore [@mimperatore]{@link https://github.com/mimperatore}
 */ var $649eb48911da332e$var$locale = {
    code: "en-CA",
    formatDistance: (0, $7nfYo.default),
    formatLong: (0, $4XHv2.default),
    formatRelative: (0, $1uXR5.default),
    localize: (0, $cPhtT.default),
    match: (0, $2SJ52.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $649eb48911da332e$export$2e2bcd8739ae039 = $649eb48911da332e$var$locale;

});
parcelRegister("7nfYo", function(module, exports) {

$parcel$export(module.exports, "default", () => $55e7125168cc0dce$export$2e2bcd8739ae039);
var $55e7125168cc0dce$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "a second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "a minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about an hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "an hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "a day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about a week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "a week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about a month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "a month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about a year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "a year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over a year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost a year",
        other: "almost {{count}} years"
    }
};
var $55e7125168cc0dce$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $55e7125168cc0dce$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
var $55e7125168cc0dce$export$2e2bcd8739ae039 = $55e7125168cc0dce$var$formatDistance;

});

parcelRegister("4XHv2", function(module, exports) {

$parcel$export(module.exports, "default", () => $39ce6a40da555b52$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $39ce6a40da555b52$var$dateFormats = {
    full: "EEEE, MMMM do, yyyy",
    long: "MMMM do, yyyy",
    medium: "MMM d, yyyy",
    short: "yyyy-MM-dd"
};
var $39ce6a40da555b52$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $39ce6a40da555b52$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $39ce6a40da555b52$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $39ce6a40da555b52$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $39ce6a40da555b52$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $39ce6a40da555b52$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $39ce6a40da555b52$export$2e2bcd8739ae039 = $39ce6a40da555b52$var$formatLong;

});


parcelRegister("c3iH1", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c6443de4506cab4$export$2e2bcd8739ae039);

var $2qFQF = parcelRequire("2qFQF");

var $1uXR5 = parcelRequire("1uXR5");

var $cPhtT = parcelRequire("cPhtT");

var $2SJ52 = parcelRequire("2SJ52");

var $7utLT = parcelRequire("7utLT");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United Kingdom).
 * @language English
 * @iso-639-2 eng
 * @author Alex [@glintik]{@link https://github.com/glintik}
 */ var $8c6443de4506cab4$var$locale = {
    code: "en-GB",
    formatDistance: (0, $2qFQF.default),
    formatLong: (0, $7utLT.default),
    formatRelative: (0, $1uXR5.default),
    localize: (0, $cPhtT.default),
    match: (0, $2SJ52.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $8c6443de4506cab4$export$2e2bcd8739ae039 = $8c6443de4506cab4$var$locale;

});
parcelRegister("7utLT", function(module, exports) {

$parcel$export(module.exports, "default", () => $57426dbaa8ce599d$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $57426dbaa8ce599d$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd/MM/yyyy"
};
var $57426dbaa8ce599d$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $57426dbaa8ce599d$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $57426dbaa8ce599d$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $57426dbaa8ce599d$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $57426dbaa8ce599d$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $57426dbaa8ce599d$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $57426dbaa8ce599d$export$2e2bcd8739ae039 = $57426dbaa8ce599d$var$formatLong;

});


parcelRegister("1N6Qr", function(module, exports) {

$parcel$export(module.exports, "default", () => $14dfad4ce73e1a64$export$2e2bcd8739ae039);

var $2qFQF = parcelRequire("2qFQF");

var $1uXR5 = parcelRequire("1uXR5");

var $cPhtT = parcelRequire("cPhtT");

var $2SJ52 = parcelRequire("2SJ52");

var $7utLT = parcelRequire("7utLT");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (Ireland).
 * @language English
 * @iso-639-2 eng
 * @author Tetiana [@tan75]{@link https://github.com/tan75}
 */ var $14dfad4ce73e1a64$var$locale = {
    code: "en-IE",
    formatDistance: (0, $2qFQF.default),
    formatLong: (0, $7utLT.default),
    formatRelative: (0, $1uXR5.default),
    localize: (0, $cPhtT.default),
    match: (0, $2SJ52.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $14dfad4ce73e1a64$export$2e2bcd8739ae039 = $14dfad4ce73e1a64$var$locale;

});

parcelRegister("k4Shu", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9de497c6c6fe141$export$2e2bcd8739ae039);

var $2qFQF = parcelRequire("2qFQF");

var $1uXR5 = parcelRequire("1uXR5");

var $cPhtT = parcelRequire("cPhtT");

var $2SJ52 = parcelRequire("2SJ52");

var $gDNjR = parcelRequire("gDNjR");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (India).
 * @language English
 * @iso-639-2 eng
 * @author Galeel Bhasha Satthar [@gbhasha]{@link https://github.com/gbhasha}
 */ var $e9de497c6c6fe141$var$locale = {
    code: "en-IN",
    formatDistance: (0, $2qFQF.default),
    formatLong: (0, $gDNjR.default),
    formatRelative: (0, $1uXR5.default),
    localize: (0, $cPhtT.default),
    match: (0, $2SJ52.default),
    options: {
        weekStartsOn: 1,
        // Monday is the first day of the week.
        firstWeekContainsDate: 4 // The week that contains Jan 4th is the first week of the year.
    }
};
var $e9de497c6c6fe141$export$2e2bcd8739ae039 = $e9de497c6c6fe141$var$locale;

});
parcelRegister("gDNjR", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1d68ba6f4836c7b$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $c1d68ba6f4836c7b$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM, yyyy",
    medium: "d MMM, yyyy",
    short: "dd/MM/yyyy"
};
var $c1d68ba6f4836c7b$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $c1d68ba6f4836c7b$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $c1d68ba6f4836c7b$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $c1d68ba6f4836c7b$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $c1d68ba6f4836c7b$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $c1d68ba6f4836c7b$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $c1d68ba6f4836c7b$export$2e2bcd8739ae039 = $c1d68ba6f4836c7b$var$formatLong;

});


parcelRegister("ffnag", function(module, exports) {

$parcel$export(module.exports, "default", () => $b19a39b6733ec6c7$export$2e2bcd8739ae039);

var $2qFQF = parcelRequire("2qFQF");

var $1uXR5 = parcelRequire("1uXR5");

var $cPhtT = parcelRequire("cPhtT");

var $2SJ52 = parcelRequire("2SJ52");

var $kN3Ej = parcelRequire("kN3Ej");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (New Zealand).
 * @language English
 * @iso-639-2 eng
 * @author Murray Lucas [@muntact]{@link https://github.com/muntact}
 */ var $b19a39b6733ec6c7$var$locale = {
    code: "en-NZ",
    formatDistance: (0, $2qFQF.default),
    formatLong: (0, $kN3Ej.default),
    formatRelative: (0, $1uXR5.default),
    localize: (0, $cPhtT.default),
    match: (0, $2SJ52.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $b19a39b6733ec6c7$export$2e2bcd8739ae039 = $b19a39b6733ec6c7$var$locale;

});
parcelRegister("kN3Ej", function(module, exports) {

$parcel$export(module.exports, "default", () => $f22b36e772cc2c19$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $f22b36e772cc2c19$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd/MM/yyyy"
};
var $f22b36e772cc2c19$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $f22b36e772cc2c19$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $f22b36e772cc2c19$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $f22b36e772cc2c19$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $f22b36e772cc2c19$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $f22b36e772cc2c19$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $f22b36e772cc2c19$export$2e2bcd8739ae039 = $f22b36e772cc2c19$var$formatLong;

});


parcelRegister("8Zadw", function(module, exports) {

$parcel$export(module.exports, "default", () => $68abf21e9b20acde$export$2e2bcd8739ae039);

var $2qFQF = parcelRequire("2qFQF");

var $1uXR5 = parcelRequire("1uXR5");

var $cPhtT = parcelRequire("cPhtT");

var $2SJ52 = parcelRequire("2SJ52");

var $ldjWZ = parcelRequire("ldjWZ");
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (South Africa).
 * @language English
 * @iso-639-2 eng
 * @author Shaila Kavrakova [@shaykav]{@link https://github.com/shaykav}
 */ var $68abf21e9b20acde$var$locale = {
    code: "en-ZA",
    formatDistance: (0, $2qFQF.default),
    formatLong: (0, $ldjWZ.default),
    formatRelative: (0, $1uXR5.default),
    localize: (0, $cPhtT.default),
    match: (0, $2SJ52.default),
    options: {
        weekStartsOn: 0,
        // Sunday is the first day of the week.
        firstWeekContainsDate: 1 // The week that contains Jan 1st is the first week of the year.
    }
};
var $68abf21e9b20acde$export$2e2bcd8739ae039 = $68abf21e9b20acde$var$locale;

});
parcelRegister("ldjWZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f71a499c6406f03b$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $f71a499c6406f03b$var$dateFormats = {
    full: "EEEE, dd MMMM yyyy",
    long: "dd MMMM yyyy",
    medium: "dd MMM yyyy",
    short: "yyyy/MM/dd"
};
var $f71a499c6406f03b$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $f71a499c6406f03b$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $f71a499c6406f03b$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $f71a499c6406f03b$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $f71a499c6406f03b$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $f71a499c6406f03b$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $f71a499c6406f03b$export$2e2bcd8739ae039 = $f71a499c6406f03b$var$formatLong;

});


parcelRegister("9jSlN", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c900c5129811ce5$export$2e2bcd8739ae039);

var $1wyYU = parcelRequire("1wyYU");

var $2lrV3 = parcelRequire("2lrV3");

var $9jEyQ = parcelRequire("9jEyQ");

var $2OWA7 = parcelRequire("2OWA7");

var $aWnUQ = parcelRequire("aWnUQ");
/**
 * @type {Locale}
 * @category Locales
 * @summary Esperanto locale.
 * @language Esperanto
 * @iso-639-2 epo
 * @author date-fns
 */ var $6c900c5129811ce5$var$locale = {
    code: "eo",
    formatDistance: (0, $1wyYU.default),
    formatLong: (0, $2lrV3.default),
    formatRelative: (0, $9jEyQ.default),
    localize: (0, $2OWA7.default),
    match: (0, $aWnUQ.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $6c900c5129811ce5$export$2e2bcd8739ae039 = $6c900c5129811ce5$var$locale;

});
parcelRegister("1wyYU", function(module, exports) {

$parcel$export(module.exports, "default", () => $11c3ea31cdc01c0f$export$2e2bcd8739ae039);
var $11c3ea31cdc01c0f$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "malpli ol sekundo",
        other: "malpli ol {{count}} sekundoj"
    },
    xSeconds: {
        one: "1 sekundo",
        other: "{{count}} sekundoj"
    },
    halfAMinute: "duonminuto",
    lessThanXMinutes: {
        one: "malpli ol minuto",
        other: "malpli ol {{count}} minutoj"
    },
    xMinutes: {
        one: "1 minuto",
        other: "{{count}} minutoj"
    },
    aboutXHours: {
        one: "proksimume 1 horo",
        other: "proksimume {{count}} horoj"
    },
    xHours: {
        one: "1 horo",
        other: "{{count}} horoj"
    },
    xDays: {
        one: "1 tago",
        other: "{{count}} tagoj"
    },
    aboutXMonths: {
        one: "proksimume 1 monato",
        other: "proksimume {{count}} monatoj"
    },
    xWeeks: {
        one: "1 semajno",
        other: "{{count}} semajnoj"
    },
    aboutXWeeks: {
        one: "proksimume 1 semajno",
        other: "proksimume {{count}} semajnoj"
    },
    xMonths: {
        one: "1 monato",
        other: "{{count}} monatoj"
    },
    aboutXYears: {
        one: "proksimume 1 jaro",
        other: "proksimume {{count}} jaroj"
    },
    xYears: {
        one: "1 jaro",
        other: "{{count}} jaroj"
    },
    overXYears: {
        one: "pli ol 1 jaro",
        other: "pli ol {{count}} jaroj"
    },
    almostXYears: {
        one: "preska\u016D 1 jaro",
        other: "preska\u016D {{count}} jaroj"
    }
};
var $11c3ea31cdc01c0f$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $11c3ea31cdc01c0f$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options !== null && options !== void 0 && options.comparison && options.comparison > 0) return "post " + result;
        else return "anta\u016D " + result;
    }
    return result;
};
var $11c3ea31cdc01c0f$export$2e2bcd8739ae039 = $11c3ea31cdc01c0f$var$formatDistance;

});

parcelRegister("2lrV3", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b5333171f65531f$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $1b5333171f65531f$var$dateFormats = {
    full: "EEEE, do 'de' MMMM y",
    long: "y-MMMM-dd",
    medium: "y-MMM-dd",
    short: "yyyy-MM-dd"
};
var $1b5333171f65531f$var$timeFormats = {
    full: "Ho 'horo kaj' m:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $1b5333171f65531f$var$dateTimeFormats = {
    any: "{{date}} {{time}}"
};
var $1b5333171f65531f$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $1b5333171f65531f$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $1b5333171f65531f$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $1b5333171f65531f$var$dateTimeFormats,
        defaultWidth: "any"
    })
};
var $1b5333171f65531f$export$2e2bcd8739ae039 = $1b5333171f65531f$var$formatLong;

});

parcelRegister("9jEyQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c8559f9659cb262$export$2e2bcd8739ae039);
var $6c8559f9659cb262$var$formatRelativeLocale = {
    lastWeek: "'pasinta' eeee 'je' p",
    yesterday: "'hiera\u016D je' p",
    today: "'hodia\u016D je' p",
    tomorrow: "'morga\u016D je' p",
    nextWeek: "eeee 'je' p",
    other: "P"
};
var $6c8559f9659cb262$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $6c8559f9659cb262$var$formatRelativeLocale[token];
};
var $6c8559f9659cb262$export$2e2bcd8739ae039 = $6c8559f9659cb262$var$formatRelative;

});

parcelRegister("2OWA7", function(module, exports) {

$parcel$export(module.exports, "default", () => $20ddb15a6913a5a7$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $20ddb15a6913a5a7$var$eraValues = {
    narrow: [
        "aK",
        "pK"
    ],
    abbreviated: [
        "a.K.E.",
        "p.K.E."
    ],
    wide: [
        "anta\u016D Komuna Erao",
        "Komuna Erao"
    ]
};
var $20ddb15a6913a5a7$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "K1",
        "K2",
        "K3",
        "K4"
    ],
    wide: [
        "1-a kvaronjaro",
        "2-a kvaronjaro",
        "3-a kvaronjaro",
        "4-a kvaronjaro"
    ]
};
var $20ddb15a6913a5a7$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jan",
        "feb",
        "mar",
        "apr",
        "maj",
        "jun",
        "jul",
        "a\u016Dg",
        "sep",
        "okt",
        "nov",
        "dec"
    ],
    wide: [
        "januaro",
        "februaro",
        "marto",
        "aprilo",
        "majo",
        "junio",
        "julio",
        "a\u016Dgusto",
        "septembro",
        "oktobro",
        "novembro",
        "decembro"
    ]
};
var $20ddb15a6913a5a7$var$dayValues = {
    narrow: [
        "D",
        "L",
        "M",
        "M",
        "\u0134",
        "V",
        "S"
    ],
    short: [
        "di",
        "lu",
        "ma",
        "me",
        "\u0135a",
        "ve",
        "sa"
    ],
    abbreviated: [
        "dim",
        "lun",
        "mar",
        "mer",
        "\u0135a\u016D",
        "ven",
        "sab"
    ],
    wide: [
        "diman\u0109o",
        "lundo",
        "mardo",
        "merkredo",
        "\u0135a\u016Ddo",
        "vendredo",
        "sabato"
    ]
};
var $20ddb15a6913a5a7$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "noktomezo",
        noon: "tagmezo",
        morning: "matene",
        afternoon: "posttagmeze",
        evening: "vespere",
        night: "nokte"
    },
    abbreviated: {
        am: "a.t.m.",
        pm: "p.t.m.",
        midnight: "noktomezo",
        noon: "tagmezo",
        morning: "matene",
        afternoon: "posttagmeze",
        evening: "vespere",
        night: "nokte"
    },
    wide: {
        am: "anta\u016Dtagmeze",
        pm: "posttagmeze",
        midnight: "noktomezo",
        noon: "tagmezo",
        morning: "matene",
        afternoon: "posttagmeze",
        evening: "vespere",
        night: "nokte"
    }
};
var $20ddb15a6913a5a7$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    return number + "-a";
};
var $20ddb15a6913a5a7$var$localize = {
    ordinalNumber: $20ddb15a6913a5a7$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $20ddb15a6913a5a7$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $20ddb15a6913a5a7$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $20ddb15a6913a5a7$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $20ddb15a6913a5a7$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $20ddb15a6913a5a7$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};
var $20ddb15a6913a5a7$export$2e2bcd8739ae039 = $20ddb15a6913a5a7$var$localize;

});

parcelRegister("aWnUQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f71df5b3d4c97be$export$2e2bcd8739ae039);

var $7pOAB = parcelRequire("7pOAB");

var $gKbFl = parcelRequire("gKbFl");
var $7f71df5b3d4c97be$var$matchOrdinalNumberPattern = /^(\d+)(-?a)?/i;
var $7f71df5b3d4c97be$var$parseOrdinalNumberPattern = /\d+/i;
var $7f71df5b3d4c97be$var$matchEraPatterns = {
    narrow: /^([ap]k)/i,
    abbreviated: /^([ap]\.?\s?k\.?\s?e\.?)/i,
    wide: /^((antaǔ |post )?komuna erao)/i
};
var $7f71df5b3d4c97be$var$parseEraPatterns = {
    any: [
        /^a/i,
        /^[kp]/i
    ]
};
var $7f71df5b3d4c97be$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^k[1234]/i,
    wide: /^[1234](-?a)? kvaronjaro/i
};
var $7f71df5b3d4c97be$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $7f71df5b3d4c97be$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|a(ŭ|ux|uh|u)g|sep|okt|nov|dec)/i,
    wide: /^(januaro|februaro|marto|aprilo|majo|junio|julio|a(ŭ|ux|uh|u)gusto|septembro|oktobro|novembro|decembro)/i
};
var $7f71df5b3d4c97be$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^a(u|ŭ)/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $7f71df5b3d4c97be$var$matchDayPatterns = {
    narrow: /^[dlmĵjvs]/i,
    short: /^(di|lu|ma|me|(ĵ|jx|jh|j)a|ve|sa)/i,
    abbreviated: /^(dim|lun|mar|mer|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)|ven|sab)/i,
    wide: /^(diman(ĉ|cx|ch|c)o|lundo|mardo|merkredo|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)do|vendredo|sabato)/i
};
var $7f71df5b3d4c97be$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^(j|ĵ)/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^ma/i,
        /^me/i,
        /^(j|ĵ)/i,
        /^v/i,
        /^s/i
    ]
};
var $7f71df5b3d4c97be$var$matchDayPeriodPatterns = {
    narrow: /^([ap]|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
    abbreviated: /^([ap][.\s]?t[.\s]?m[.\s]?|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
    wide: /^(anta(ŭ|ux)tagmez|posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo]/i
};
var $7f71df5b3d4c97be$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^noktom/i,
        noon: /^t/i,
        morning: /^m/i,
        afternoon: /^posttagmeze/i,
        evening: /^v/i,
        night: /^n/i
    }
};
var $7f71df5b3d4c97be$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $7f71df5b3d4c97be$var$matchOrdinalNumberPattern,
        parsePattern: $7f71df5b3d4c97be$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $7f71df5b3d4c97be$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7f71df5b3d4c97be$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $7f71df5b3d4c97be$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7f71df5b3d4c97be$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $7f71df5b3d4c97be$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7f71df5b3d4c97be$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $7f71df5b3d4c97be$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7f71df5b3d4c97be$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $7f71df5b3d4c97be$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7f71df5b3d4c97be$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $7f71df5b3d4c97be$export$2e2bcd8739ae039 = $7f71df5b3d4c97be$var$match;

});


parcelRegister("iLezG", function(module, exports) {

$parcel$export(module.exports, "default", () => $da87ebfe589059f0$export$2e2bcd8739ae039);

var $itQAg = parcelRequire("itQAg");

var $3eB1S = parcelRequire("3eB1S");

var $jopFx = parcelRequire("jopFx");

var $iM8e9 = parcelRequire("iM8e9");

var $g0HYw = parcelRequire("g0HYw");
/**
 * @type {Locale}
 * @category Locales
 * @summary Spanish locale.
 * @language Spanish
 * @iso-639-2 spa
 * @author Juan Angosto [@juanangosto]{@link https://github.com/juanangosto}
 * @author Guillermo Grau [@guigrpa]{@link https://github.com/guigrpa}
 * @author Fernando Agüero [@fjaguero]{@link https://github.com/fjaguero}
 * @author Gastón Haro [@harogaston]{@link https://github.com/harogaston}
 * @author Yago Carballo [@YagoCarballo]{@link https://github.com/YagoCarballo}
 */ var $da87ebfe589059f0$var$locale = {
    code: "es",
    formatDistance: (0, $itQAg.default),
    formatLong: (0, $3eB1S.default),
    formatRelative: (0, $jopFx.default),
    localize: (0, $iM8e9.default),
    match: (0, $g0HYw.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $da87ebfe589059f0$export$2e2bcd8739ae039 = $da87ebfe589059f0$var$locale;

});
parcelRegister("itQAg", function(module, exports) {

$parcel$export(module.exports, "default", () => $d743b9797c647de3$export$2e2bcd8739ae039);
var $d743b9797c647de3$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "menos de un segundo",
        other: "menos de {{count}} segundos"
    },
    xSeconds: {
        one: "1 segundo",
        other: "{{count}} segundos"
    },
    halfAMinute: "medio minuto",
    lessThanXMinutes: {
        one: "menos de un minuto",
        other: "menos de {{count}} minutos"
    },
    xMinutes: {
        one: "1 minuto",
        other: "{{count}} minutos"
    },
    aboutXHours: {
        one: "alrededor de 1 hora",
        other: "alrededor de {{count}} horas"
    },
    xHours: {
        one: "1 hora",
        other: "{{count}} horas"
    },
    xDays: {
        one: "1 d\xeda",
        other: "{{count}} d\xedas"
    },
    aboutXWeeks: {
        one: "alrededor de 1 semana",
        other: "alrededor de {{count}} semanas"
    },
    xWeeks: {
        one: "1 semana",
        other: "{{count}} semanas"
    },
    aboutXMonths: {
        one: "alrededor de 1 mes",
        other: "alrededor de {{count}} meses"
    },
    xMonths: {
        one: "1 mes",
        other: "{{count}} meses"
    },
    aboutXYears: {
        one: "alrededor de 1 a\xf1o",
        other: "alrededor de {{count}} a\xf1os"
    },
    xYears: {
        one: "1 a\xf1o",
        other: "{{count}} a\xf1os"
    },
    overXYears: {
        one: "m\xe1s de 1 a\xf1o",
        other: "m\xe1s de {{count}} a\xf1os"
    },
    almostXYears: {
        one: "casi 1 a\xf1o",
        other: "casi {{count}} a\xf1os"
    }
};
var $d743b9797c647de3$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $d743b9797c647de3$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "en " + result;
        else return "hace " + result;
    }
    return result;
};
var $d743b9797c647de3$export$2e2bcd8739ae039 = $d743b9797c647de3$var$formatDistance;

});

parcelRegister("3eB1S", function(module, exports) {

$parcel$export(module.exports, "default", () => $25af6727957dfe2d$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $25af6727957dfe2d$var$dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
var $25af6727957dfe2d$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $25af6727957dfe2d$var$dateTimeFormats = {
    full: "{{date}} 'a las' {{time}}",
    long: "{{date}} 'a las' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $25af6727957dfe2d$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $25af6727957dfe2d$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $25af6727957dfe2d$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $25af6727957dfe2d$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $25af6727957dfe2d$export$2e2bcd8739ae039 = $25af6727957dfe2d$var$formatLong;

});

parcelRegister("jopFx", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1e42b835a1f0258$export$2e2bcd8739ae039);
var $e1e42b835a1f0258$var$formatRelativeLocale = {
    lastWeek: "'el' eeee 'pasado a la' p",
    yesterday: "'ayer a la' p",
    today: "'hoy a la' p",
    tomorrow: "'ma\xf1ana a la' p",
    nextWeek: "eeee 'a la' p",
    other: "P"
};
var $e1e42b835a1f0258$var$formatRelativeLocalePlural = {
    lastWeek: "'el' eeee 'pasado a las' p",
    yesterday: "'ayer a las' p",
    today: "'hoy a las' p",
    tomorrow: "'ma\xf1ana a las' p",
    nextWeek: "eeee 'a las' p",
    other: "P"
};
var $e1e42b835a1f0258$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    if (date.getUTCHours() !== 1) return $e1e42b835a1f0258$var$formatRelativeLocalePlural[token];
    else return $e1e42b835a1f0258$var$formatRelativeLocale[token];
};
var $e1e42b835a1f0258$export$2e2bcd8739ae039 = $e1e42b835a1f0258$var$formatRelative;

});

parcelRegister("iM8e9", function(module, exports) {

$parcel$export(module.exports, "default", () => $dab3176ccecf947e$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $dab3176ccecf947e$var$eraValues = {
    narrow: [
        "AC",
        "DC"
    ],
    abbreviated: [
        "AC",
        "DC"
    ],
    wide: [
        "antes de cristo",
        "despu\xe9s de cristo"
    ]
};
var $dab3176ccecf947e$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var $dab3176ccecf947e$var$monthValues = {
    narrow: [
        "e",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "ene",
        "feb",
        "mar",
        "abr",
        "may",
        "jun",
        "jul",
        "ago",
        "sep",
        "oct",
        "nov",
        "dic"
    ],
    wide: [
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre"
    ]
};
var $dab3176ccecf947e$var$dayValues = {
    narrow: [
        "d",
        "l",
        "m",
        "m",
        "j",
        "v",
        "s"
    ],
    short: [
        "do",
        "lu",
        "ma",
        "mi",
        "ju",
        "vi",
        "s\xe1"
    ],
    abbreviated: [
        "dom",
        "lun",
        "mar",
        "mi\xe9",
        "jue",
        "vie",
        "s\xe1b"
    ],
    wide: [
        "domingo",
        "lunes",
        "martes",
        "mi\xe9rcoles",
        "jueves",
        "viernes",
        "s\xe1bado"
    ]
};
var $dab3176ccecf947e$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "md",
        morning: "ma\xf1ana",
        afternoon: "tarde",
        evening: "tarde",
        night: "noche"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "medianoche",
        noon: "mediodia",
        morning: "ma\xf1ana",
        afternoon: "tarde",
        evening: "tarde",
        night: "noche"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "medianoche",
        noon: "mediodia",
        morning: "ma\xf1ana",
        afternoon: "tarde",
        evening: "tarde",
        night: "noche"
    }
};
var $dab3176ccecf947e$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "md",
        morning: "de la ma\xf1ana",
        afternoon: "de la tarde",
        evening: "de la tarde",
        night: "de la noche"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "medianoche",
        noon: "mediodia",
        morning: "de la ma\xf1ana",
        afternoon: "de la tarde",
        evening: "de la tarde",
        night: "de la noche"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "medianoche",
        noon: "mediodia",
        morning: "de la ma\xf1ana",
        afternoon: "de la tarde",
        evening: "de la tarde",
        night: "de la noche"
    }
};
var $dab3176ccecf947e$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\xba";
};
var $dab3176ccecf947e$var$localize = {
    ordinalNumber: $dab3176ccecf947e$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $dab3176ccecf947e$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $dab3176ccecf947e$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $dab3176ccecf947e$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $dab3176ccecf947e$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $dab3176ccecf947e$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $dab3176ccecf947e$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $dab3176ccecf947e$export$2e2bcd8739ae039 = $dab3176ccecf947e$var$localize;

});

parcelRegister("g0HYw", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba7ec1fe458cbff8$export$2e2bcd8739ae039);

var $7pOAB = parcelRequire("7pOAB");

var $gKbFl = parcelRequire("gKbFl");
var $ba7ec1fe458cbff8$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var $ba7ec1fe458cbff8$var$parseOrdinalNumberPattern = /\d+/i;
var $ba7ec1fe458cbff8$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
};
var $ba7ec1fe458cbff8$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes de la era com[uú]n)/i,
        /^(despu[eé]s de cristo|era com[uú]n)/i
    ]
};
var $ba7ec1fe458cbff8$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var $ba7ec1fe458cbff8$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $ba7ec1fe458cbff8$var$matchMonthPatterns = {
    narrow: /^[efmajsond]/i,
    abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
    wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
};
var $ba7ec1fe458cbff8$var$parseMonthPatterns = {
    narrow: [
        /^e/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^en/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^sep/i,
        /^oct/i,
        /^nov/i,
        /^dic/i
    ]
};
var $ba7ec1fe458cbff8$var$matchDayPatterns = {
    narrow: /^[dlmjvs]/i,
    short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
    abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
    wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
};
var $ba7ec1fe458cbff8$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^do/i,
        /^lu/i,
        /^ma/i,
        /^mi/i,
        /^ju/i,
        /^vi/i,
        /^sa/i
    ]
};
var $ba7ec1fe458cbff8$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
    any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
};
var $ba7ec1fe458cbff8$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /^md/i,
        morning: /mañana/i,
        afternoon: /tarde/i,
        evening: /tarde/i,
        night: /noche/i
    }
};
var $ba7ec1fe458cbff8$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $ba7ec1fe458cbff8$var$matchOrdinalNumberPattern,
        parsePattern: $ba7ec1fe458cbff8$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $ba7ec1fe458cbff8$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ba7ec1fe458cbff8$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $ba7ec1fe458cbff8$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ba7ec1fe458cbff8$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $ba7ec1fe458cbff8$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ba7ec1fe458cbff8$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $ba7ec1fe458cbff8$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ba7ec1fe458cbff8$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $ba7ec1fe458cbff8$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $ba7ec1fe458cbff8$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $ba7ec1fe458cbff8$export$2e2bcd8739ae039 = $ba7ec1fe458cbff8$var$match;

});


parcelRegister("goeBf", function(module, exports) {

$parcel$export(module.exports, "default", () => $beea36777e0c6c6c$export$2e2bcd8739ae039);

var $10bZo = parcelRequire("10bZo");

var $5tvmi = parcelRequire("5tvmi");

var $etk3U = parcelRequire("etk3U");

var $kD6V6 = parcelRequire("kD6V6");

var $37oGu = parcelRequire("37oGu");
/**
 * @type {Locale}
 * @category Locales
 * @summary Estonian locale.
 * @language Estonian
 * @iso-639-2 est
 * @author Priit Hansen [@HansenPriit]{@link https://github.com/priithansen}
 */ var $beea36777e0c6c6c$var$locale = {
    code: "et",
    formatDistance: (0, $10bZo.default),
    formatLong: (0, $5tvmi.default),
    formatRelative: (0, $etk3U.default),
    localize: (0, $kD6V6.default),
    match: (0, $37oGu.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $beea36777e0c6c6c$export$2e2bcd8739ae039 = $beea36777e0c6c6c$var$locale;

});
parcelRegister("10bZo", function(module, exports) {

$parcel$export(module.exports, "default", () => $0baf17570fd8842b$export$2e2bcd8739ae039);
var $0baf17570fd8842b$var$formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: "v\xe4hem kui \xfcks sekund",
            other: "v\xe4hem kui {{count}} sekundit"
        },
        withPreposition: {
            one: "v\xe4hem kui \xfche sekundi",
            other: "v\xe4hem kui {{count}} sekundi"
        }
    },
    xSeconds: {
        standalone: {
            one: "\xfcks sekund",
            other: "{{count}} sekundit"
        },
        withPreposition: {
            one: "\xfche sekundi",
            other: "{{count}} sekundi"
        }
    },
    halfAMinute: {
        standalone: "pool minutit",
        withPreposition: "poole minuti"
    },
    lessThanXMinutes: {
        standalone: {
            one: "v\xe4hem kui \xfcks minut",
            other: "v\xe4hem kui {{count}} minutit"
        },
        withPreposition: {
            one: "v\xe4hem kui \xfche minuti",
            other: "v\xe4hem kui {{count}} minuti"
        }
    },
    xMinutes: {
        standalone: {
            one: "\xfcks minut",
            other: "{{count}} minutit"
        },
        withPreposition: {
            one: "\xfche minuti",
            other: "{{count}} minuti"
        }
    },
    aboutXHours: {
        standalone: {
            one: "umbes \xfcks tund",
            other: "umbes {{count}} tundi"
        },
        withPreposition: {
            one: "umbes \xfche tunni",
            other: "umbes {{count}} tunni"
        }
    },
    xHours: {
        standalone: {
            one: "\xfcks tund",
            other: "{{count}} tundi"
        },
        withPreposition: {
            one: "\xfche tunni",
            other: "{{count}} tunni"
        }
    },
    xDays: {
        standalone: {
            one: "\xfcks p\xe4ev",
            other: "{{count}} p\xe4eva"
        },
        withPreposition: {
            one: "\xfche p\xe4eva",
            other: "{{count}} p\xe4eva"
        }
    },
    aboutXWeeks: {
        standalone: {
            one: "umbes \xfcks n\xe4dal",
            other: "umbes {{count}} n\xe4dalat"
        },
        withPreposition: {
            one: "umbes \xfche n\xe4dala",
            other: "umbes {{count}} n\xe4dala"
        }
    },
    xWeeks: {
        standalone: {
            one: "\xfcks n\xe4dal",
            other: "{{count}} n\xe4dalat"
        },
        withPreposition: {
            one: "\xfche n\xe4dala",
            other: "{{count}} n\xe4dala"
        }
    },
    aboutXMonths: {
        standalone: {
            one: "umbes \xfcks kuu",
            other: "umbes {{count}} kuud"
        },
        withPreposition: {
            one: "umbes \xfche kuu",
            other: "umbes {{count}} kuu"
        }
    },
    xMonths: {
        standalone: {
            one: "\xfcks kuu",
            other: "{{count}} kuud"
        },
        withPreposition: {
            one: "\xfche kuu",
            other: "{{count}} kuu"
        }
    },
    aboutXYears: {
        standalone: {
            one: "umbes \xfcks aasta",
            other: "umbes {{count}} aastat"
        },
        withPreposition: {
            one: "umbes \xfche aasta",
            other: "umbes {{count}} aasta"
        }
    },
    xYears: {
        standalone: {
            one: "\xfcks aasta",
            other: "{{count}} aastat"
        },
        withPreposition: {
            one: "\xfche aasta",
            other: "{{count}} aasta"
        }
    },
    overXYears: {
        standalone: {
            one: "rohkem kui \xfcks aasta",
            other: "rohkem kui {{count}} aastat"
        },
        withPreposition: {
            one: "rohkem kui \xfche aasta",
            other: "rohkem kui {{count}} aasta"
        }
    },
    almostXYears: {
        standalone: {
            one: "peaaegu \xfcks aasta",
            other: "peaaegu {{count}} aastat"
        },
        withPreposition: {
            one: "peaaegu \xfche aasta",
            other: "peaaegu {{count}} aasta"
        }
    }
};
var $0baf17570fd8842b$var$formatDistance = function formatDistance(token, count, options) {
    var usageGroup = options !== null && options !== void 0 && options.addSuffix ? $0baf17570fd8842b$var$formatDistanceLocale[token].withPreposition : $0baf17570fd8842b$var$formatDistanceLocale[token].standalone;
    var result;
    if (typeof usageGroup === "string") result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else result = usageGroup.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " p\xe4rast";
        else return result + " eest";
    }
    return result;
};
var $0baf17570fd8842b$export$2e2bcd8739ae039 = $0baf17570fd8842b$var$formatDistance;

});

parcelRegister("5tvmi", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fc7fc5496bcab11$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $3fc7fc5496bcab11$var$dateFormats = {
    full: "EEEE, d. MMMM y",
    long: "d. MMMM y",
    medium: "d. MMM y",
    short: "dd.MM.y"
};
var $3fc7fc5496bcab11$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $3fc7fc5496bcab11$var$dateTimeFormats = {
    full: "{{date}} 'kell' {{time}}",
    long: "{{date}} 'kell' {{time}}",
    medium: "{{date}}. {{time}}",
    short: "{{date}}. {{time}}"
};
var $3fc7fc5496bcab11$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $3fc7fc5496bcab11$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $3fc7fc5496bcab11$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $3fc7fc5496bcab11$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $3fc7fc5496bcab11$export$2e2bcd8739ae039 = $3fc7fc5496bcab11$var$formatLong;

});

parcelRegister("etk3U", function(module, exports) {

$parcel$export(module.exports, "default", () => $a893560be0863b42$export$2e2bcd8739ae039);
var $a893560be0863b42$var$formatRelativeLocale = {
    lastWeek: "'eelmine' eeee 'kell' p",
    yesterday: "'eile kell' p",
    today: "'t\xe4na kell' p",
    tomorrow: "'homme kell' p",
    nextWeek: "'j\xe4rgmine' eeee 'kell' p",
    other: "P"
};
var $a893560be0863b42$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $a893560be0863b42$var$formatRelativeLocale[token];
};
var $a893560be0863b42$export$2e2bcd8739ae039 = $a893560be0863b42$var$formatRelative;

});

parcelRegister("kD6V6", function(module, exports) {

$parcel$export(module.exports, "default", () => $f04cd159735415d7$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $f04cd159735415d7$var$eraValues = {
    narrow: [
        "e.m.a",
        "m.a.j"
    ],
    abbreviated: [
        "e.m.a",
        "m.a.j"
    ],
    wide: [
        "enne meie ajaarvamist",
        "meie ajaarvamise j\xe4rgi"
    ]
};
var $f04cd159735415d7$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "K1",
        "K2",
        "K3",
        "K4"
    ],
    wide: [
        "1. kvartal",
        "2. kvartal",
        "3. kvartal",
        "4. kvartal"
    ]
};
var $f04cd159735415d7$var$monthValues = {
    narrow: [
        "J",
        "V",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jaan",
        "veebr",
        "m\xe4rts",
        "apr",
        "mai",
        "juuni",
        "juuli",
        "aug",
        "sept",
        "okt",
        "nov",
        "dets"
    ],
    wide: [
        "jaanuar",
        "veebruar",
        "m\xe4rts",
        "aprill",
        "mai",
        "juuni",
        "juuli",
        "august",
        "september",
        "oktoober",
        "november",
        "detsember"
    ]
};
var $f04cd159735415d7$var$dayValues = {
    narrow: [
        "P",
        "E",
        "T",
        "K",
        "N",
        "R",
        "L"
    ],
    short: [
        "P",
        "E",
        "T",
        "K",
        "N",
        "R",
        "L"
    ],
    abbreviated: [
        "p\xfchap.",
        "esmasp.",
        "teisip.",
        "kolmap.",
        "neljap.",
        "reede.",
        "laup."
    ],
    wide: [
        "p\xfchap\xe4ev",
        "esmasp\xe4ev",
        "teisip\xe4ev",
        "kolmap\xe4ev",
        "neljap\xe4ev",
        "reede",
        "laup\xe4ev"
    ]
};
var $f04cd159735415d7$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "kesk\xf6\xf6",
        noon: "keskp\xe4ev",
        morning: "hommik",
        afternoon: "p\xe4rastl\xf5una",
        evening: "\xf5htu",
        night: "\xf6\xf6"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "kesk\xf6\xf6",
        noon: "keskp\xe4ev",
        morning: "hommik",
        afternoon: "p\xe4rastl\xf5una",
        evening: "\xf5htu",
        night: "\xf6\xf6"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "kesk\xf6\xf6",
        noon: "keskp\xe4ev",
        morning: "hommik",
        afternoon: "p\xe4rastl\xf5una",
        evening: "\xf5htu",
        night: "\xf6\xf6"
    }
};
var $f04cd159735415d7$var$formattingDayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "kesk\xf6\xf6l",
        noon: "keskp\xe4eval",
        morning: "hommikul",
        afternoon: "p\xe4rastl\xf5unal",
        evening: "\xf5htul",
        night: "\xf6\xf6sel"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "kesk\xf6\xf6l",
        noon: "keskp\xe4eval",
        morning: "hommikul",
        afternoon: "p\xe4rastl\xf5unal",
        evening: "\xf5htul",
        night: "\xf6\xf6sel"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "kesk\xf6\xf6l",
        noon: "keskp\xe4eval",
        morning: "hommikul",
        afternoon: "p\xe4rastl\xf5unal",
        evening: "\xf5htul",
        night: "\xf6\xf6sel"
    }
};
var $f04cd159735415d7$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + ".";
};
var $f04cd159735415d7$var$localize = {
    ordinalNumber: $f04cd159735415d7$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $f04cd159735415d7$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $f04cd159735415d7$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $f04cd159735415d7$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $f04cd159735415d7$var$monthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $f04cd159735415d7$var$dayValues,
        defaultWidth: "wide",
        formattingValues: $f04cd159735415d7$var$dayValues,
        defaultFormattingWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $f04cd159735415d7$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $f04cd159735415d7$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $f04cd159735415d7$export$2e2bcd8739ae039 = $f04cd159735415d7$var$localize;

});

parcelRegister("37oGu", function(module, exports) {

$parcel$export(module.exports, "default", () => $24552c53211770a3$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $24552c53211770a3$var$matchOrdinalNumberPattern = /^\d+\./i;
var $24552c53211770a3$var$parseOrdinalNumberPattern = /\d+/i;
var $24552c53211770a3$var$matchEraPatterns = {
    narrow: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
    abbreviated: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
    wide: /^(enne meie ajaarvamist|meie ajaarvamise järgi|enne Kristust|pärast Kristust)/i
};
var $24552c53211770a3$var$parseEraPatterns = {
    any: [
        /^e/i,
        /^(m|p)/i
    ]
};
var $24552c53211770a3$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234](\.)? kvartal/i
};
var $24552c53211770a3$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $24552c53211770a3$var$matchMonthPatterns = {
    narrow: /^[jvmasond]/i,
    abbreviated: /^(jaan|veebr|märts|apr|mai|juuni|juuli|aug|sept|okt|nov|dets)/i,
    wide: /^(jaanuar|veebruar|märts|aprill|mai|juuni|juuli|august|september|oktoober|november|detsember)/i
};
var $24552c53211770a3$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^v/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^v/i,
        /^mär/i,
        /^ap/i,
        /^mai/i,
        /^juun/i,
        /^juul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $24552c53211770a3$var$matchDayPatterns = {
    narrow: /^[petknrl]/i,
    short: /^[petknrl]/i,
    abbreviated: /^(püh?|esm?|tei?|kolm?|nel?|ree?|laup?)\.?/i,
    wide: /^(pühapäev|esmaspäev|teisipäev|kolmapäev|neljapäev|reede|laupäev)/i
};
var $24552c53211770a3$var$parseDayPatterns = {
    any: [
        /^p/i,
        /^e/i,
        /^t/i,
        /^k/i,
        /^n/i,
        /^r/i,
        /^l/i
    ]
};
var $24552c53211770a3$var$matchDayPeriodPatterns = {
    any: /^(am|pm|keskööl?|keskpäev(al)?|hommik(ul)?|pärastlõunal?|õhtul?|öö(sel)?)/i
};
var $24552c53211770a3$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^keskö/i,
        noon: /^keskp/i,
        morning: /hommik/i,
        afternoon: /pärastlõuna/i,
        evening: /õhtu/i,
        night: /öö/i
    }
};
var $24552c53211770a3$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $24552c53211770a3$var$matchOrdinalNumberPattern,
        parsePattern: $24552c53211770a3$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $24552c53211770a3$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $24552c53211770a3$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $24552c53211770a3$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $24552c53211770a3$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $24552c53211770a3$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $24552c53211770a3$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $24552c53211770a3$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $24552c53211770a3$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $24552c53211770a3$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $24552c53211770a3$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $24552c53211770a3$export$2e2bcd8739ae039 = $24552c53211770a3$var$match;

});


parcelRegister("6l3KT", function(module, exports) {

$parcel$export(module.exports, "default", () => $49d79df30a6a687f$export$2e2bcd8739ae039);

var $l0iKR = parcelRequire("l0iKR");

var $7qiCY = parcelRequire("7qiCY");

var $1C0oL = parcelRequire("1C0oL");

var $hbFh1 = parcelRequire("hbFh1");

var $KdDGc = parcelRequire("KdDGc");
/**
 * @type {Locale}
 * @category Locales
 * @summary Basque locale.
 * @language Basque
 * @iso-639-2 eus
 * @author Jacob Söderblom [@JacobSoderblom]{@link https://github.com/JacobSoderblom}
 */ var $49d79df30a6a687f$var$locale = {
    code: "eu",
    formatDistance: (0, $l0iKR.default),
    formatLong: (0, $7qiCY.default),
    formatRelative: (0, $1C0oL.default),
    localize: (0, $hbFh1.default),
    match: (0, $KdDGc.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $49d79df30a6a687f$export$2e2bcd8739ae039 = $49d79df30a6a687f$var$locale;

});
parcelRegister("l0iKR", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4a8255f1c0bfd20$export$2e2bcd8739ae039);
var $f4a8255f1c0bfd20$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "segundo bat baino gutxiago",
        other: "{{count}} segundo baino gutxiago"
    },
    xSeconds: {
        one: "1 segundo",
        other: "{{count}} segundo"
    },
    halfAMinute: "minutu erdi",
    lessThanXMinutes: {
        one: "minutu bat baino gutxiago",
        other: "{{count}} minutu baino gutxiago"
    },
    xMinutes: {
        one: "1 minutu",
        other: "{{count}} minutu"
    },
    aboutXHours: {
        one: "1 ordu gutxi gorabehera",
        other: "{{count}} ordu gutxi gorabehera"
    },
    xHours: {
        one: "1 ordu",
        other: "{{count}} ordu"
    },
    xDays: {
        one: "1 egun",
        other: "{{count}} egun"
    },
    aboutXWeeks: {
        one: "aste 1 inguru",
        other: "{{count}} aste inguru"
    },
    xWeeks: {
        one: "1 aste",
        other: "{{count}} astean"
    },
    aboutXMonths: {
        one: "1 hilabete gutxi gorabehera",
        other: "{{count}} hilabete gutxi gorabehera"
    },
    xMonths: {
        one: "1 hilabete",
        other: "{{count}} hilabete"
    },
    aboutXYears: {
        one: "1 urte gutxi gorabehera",
        other: "{{count}} urte gutxi gorabehera"
    },
    xYears: {
        one: "1 urte",
        other: "{{count}} urte"
    },
    overXYears: {
        one: "1 urte baino gehiago",
        other: "{{count}} urte baino gehiago"
    },
    almostXYears: {
        one: "ia 1 urte",
        other: "ia {{count}} urte"
    }
};
var $f4a8255f1c0bfd20$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $f4a8255f1c0bfd20$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "en " + result;
        else return "duela " + result;
    }
    return result;
};
var $f4a8255f1c0bfd20$export$2e2bcd8739ae039 = $f4a8255f1c0bfd20$var$formatDistance;

});

parcelRegister("7qiCY", function(module, exports) {

$parcel$export(module.exports, "default", () => $56796925210d3e00$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $56796925210d3e00$var$dateFormats = {
    full: "EEEE, y'ko' MMMM'ren' d'a' y'ren'",
    long: "y'ko' MMMM'ren' d'a'",
    medium: "y MMM d",
    short: "yy/MM/dd"
};
var $56796925210d3e00$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $56796925210d3e00$var$dateTimeFormats = {
    full: "{{date}} 'tan' {{time}}",
    long: "{{date}} 'tan' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $56796925210d3e00$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $56796925210d3e00$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $56796925210d3e00$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $56796925210d3e00$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $56796925210d3e00$export$2e2bcd8739ae039 = $56796925210d3e00$var$formatLong;

});

parcelRegister("1C0oL", function(module, exports) {

$parcel$export(module.exports, "default", () => $12c9a631f1746bcb$export$2e2bcd8739ae039);
var $12c9a631f1746bcb$var$formatRelativeLocale = {
    lastWeek: "'joan den' eeee, LT",
    yesterday: "'atzo,' p",
    today: "'gaur,' p",
    tomorrow: "'bihar,' p",
    nextWeek: "eeee, p",
    other: "P"
};
var $12c9a631f1746bcb$var$formatRelativeLocalePlural = {
    lastWeek: "'joan den' eeee, p",
    yesterday: "'atzo,' p",
    today: "'gaur,' p",
    tomorrow: "'bihar,' p",
    nextWeek: "eeee, p",
    other: "P"
};
var $12c9a631f1746bcb$var$formatRelative = function formatRelative(token, date) {
    if (date.getUTCHours() !== 1) return $12c9a631f1746bcb$var$formatRelativeLocalePlural[token];
    return $12c9a631f1746bcb$var$formatRelativeLocale[token];
};
var $12c9a631f1746bcb$export$2e2bcd8739ae039 = $12c9a631f1746bcb$var$formatRelative;

});

parcelRegister("hbFh1", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8337ad70ca399be$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $c8337ad70ca399be$var$eraValues = {
    narrow: [
        "k.a.",
        "k.o."
    ],
    abbreviated: [
        "k.a.",
        "k.o."
    ],
    wide: [
        "kristo aurretik",
        "kristo ondoren"
    ]
};
var $c8337ad70ca399be$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1H",
        "2H",
        "3H",
        "4H"
    ],
    wide: [
        "1. hiruhilekoa",
        "2. hiruhilekoa",
        "3. hiruhilekoa",
        "4. hiruhilekoa"
    ]
};
var $c8337ad70ca399be$var$monthValues = {
    narrow: [
        "u",
        "o",
        "m",
        "a",
        "m",
        "e",
        "u",
        "a",
        "i",
        "u",
        "a",
        "a"
    ],
    abbreviated: [
        "urt",
        "ots",
        "mar",
        "api",
        "mai",
        "eka",
        "uzt",
        "abu",
        "ira",
        "urr",
        "aza",
        "abe"
    ],
    wide: [
        "urtarrila",
        "otsaila",
        "martxoa",
        "apirila",
        "maiatza",
        "ekaina",
        "uztaila",
        "abuztua",
        "iraila",
        "urria",
        "azaroa",
        "abendua"
    ]
};
var $c8337ad70ca399be$var$dayValues = {
    narrow: [
        "i",
        "a",
        "a",
        "a",
        "o",
        "o",
        "l"
    ],
    short: [
        "ig",
        "al",
        "as",
        "az",
        "og",
        "or",
        "lr"
    ],
    abbreviated: [
        "iga",
        "ast",
        "ast",
        "ast",
        "ost",
        "ost",
        "lar"
    ],
    wide: [
        "igandea",
        "astelehena",
        "asteartea",
        "asteazkena",
        "osteguna",
        "ostirala",
        "larunbata"
    ]
};
var $c8337ad70ca399be$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "ge",
        noon: "eg",
        morning: "goiza",
        afternoon: "arratsaldea",
        evening: "arratsaldea",
        night: "gaua"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "gauerdia",
        noon: "eguerdia",
        morning: "goiza",
        afternoon: "arratsaldea",
        evening: "arratsaldea",
        night: "gaua"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "gauerdia",
        noon: "eguerdia",
        morning: "goiza",
        afternoon: "arratsaldea",
        evening: "arratsaldea",
        night: "gaua"
    }
};
var $c8337ad70ca399be$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "ge",
        noon: "eg",
        morning: "goizean",
        afternoon: "arratsaldean",
        evening: "arratsaldean",
        night: "gauean"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "gauerdia",
        noon: "eguerdia",
        morning: "goizean",
        afternoon: "arratsaldean",
        evening: "arratsaldean",
        night: "gauean"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "gauerdia",
        noon: "eguerdia",
        morning: "goizean",
        afternoon: "arratsaldean",
        evening: "arratsaldean",
        night: "gauean"
    }
};
var $c8337ad70ca399be$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + ".";
};
var $c8337ad70ca399be$var$localize = {
    ordinalNumber: $c8337ad70ca399be$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $c8337ad70ca399be$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $c8337ad70ca399be$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $c8337ad70ca399be$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $c8337ad70ca399be$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $c8337ad70ca399be$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $c8337ad70ca399be$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $c8337ad70ca399be$export$2e2bcd8739ae039 = $c8337ad70ca399be$var$localize;

});

parcelRegister("KdDGc", function(module, exports) {

$parcel$export(module.exports, "default", () => $08aee069a6f85da8$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $08aee069a6f85da8$var$matchOrdinalNumberPattern = /^(\d+)(.)?/i;
var $08aee069a6f85da8$var$parseOrdinalNumberPattern = /\d+/i;
var $08aee069a6f85da8$var$matchEraPatterns = {
    narrow: /^(k.a.|k.o.)/i,
    abbreviated: /^(k.a.|k.o.)/i,
    wide: /^(kristo aurretik|kristo ondoren)/i
};
var $08aee069a6f85da8$var$parseEraPatterns = {
    narrow: [
        /^k.a./i,
        /^k.o./i
    ],
    abbreviated: [
        /^(k.a.)/i,
        /^(k.o.)/i
    ],
    wide: [
        /^(kristo aurretik)/i,
        /^(kristo ondoren)/i
    ]
};
var $08aee069a6f85da8$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]H/i,
    wide: /^[1234](.)? hiruhilekoa/i
};
var $08aee069a6f85da8$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $08aee069a6f85da8$var$matchMonthPatterns = {
    narrow: /^[uomaei]/i,
    abbreviated: /^(urt|ots|mar|api|mai|eka|uzt|abu|ira|urr|aza|abe)/i,
    wide: /^(urtarrila|otsaila|martxoa|apirila|maiatza|ekaina|uztaila|abuztua|iraila|urria|azaroa|abendua)/i
};
var $08aee069a6f85da8$var$parseMonthPatterns = {
    narrow: [
        /^u/i,
        /^o/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^e/i,
        /^u/i,
        /^a/i,
        /^i/i,
        /^u/i,
        /^a/i,
        /^a/i
    ],
    any: [
        /^urt/i,
        /^ots/i,
        /^mar/i,
        /^api/i,
        /^mai/i,
        /^eka/i,
        /^uzt/i,
        /^abu/i,
        /^ira/i,
        /^urr/i,
        /^aza/i,
        /^abe/i
    ]
};
var $08aee069a6f85da8$var$matchDayPatterns = {
    narrow: /^[iaol]/i,
    short: /^(ig|al|as|az|og|or|lr)/i,
    abbreviated: /^(iga|ast|ast|ast|ost|ost|lar)/i,
    wide: /^(igandea|astelehena|asteartea|asteazkena|osteguna|ostirala|larunbata)/i
};
var $08aee069a6f85da8$var$parseDayPatterns = {
    narrow: [
        /^i/i,
        /^a/i,
        /^a/i,
        /^a/i,
        /^o/i,
        /^o/i,
        /^l/i
    ],
    short: [
        /^ig/i,
        /^al/i,
        /^as/i,
        /^az/i,
        /^og/i,
        /^or/i,
        /^lr/i
    ],
    abbreviated: [
        /^iga/i,
        /^ast/i,
        /^ast/i,
        /^ast/i,
        /^ost/i,
        /^ost/i,
        /^lar/i
    ],
    wide: [
        /^igandea/i,
        /^astelehena/i,
        /^asteartea/i,
        /^asteazkena/i,
        /^osteguna/i,
        /^ostirala/i,
        /^larunbata/i
    ]
};
var $08aee069a6f85da8$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|ge|eg|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i,
    any: /^([ap]\.?\s?m\.?|gauerdia|eguerdia|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i
};
var $08aee069a6f85da8$var$parseDayPeriodPatterns = {
    narrow: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^ge/i,
        noon: /^eg/i,
        morning: /goiz/i,
        afternoon: /arratsaldea/i,
        evening: /arratsaldea/i,
        night: /gau/i
    },
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^gauerdia/i,
        noon: /^eguerdia/i,
        morning: /goiz/i,
        afternoon: /arratsaldea/i,
        evening: /arratsaldea/i,
        night: /gau/i
    }
};
var $08aee069a6f85da8$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $08aee069a6f85da8$var$matchOrdinalNumberPattern,
        parsePattern: $08aee069a6f85da8$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $08aee069a6f85da8$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $08aee069a6f85da8$var$parseEraPatterns,
        defaultParseWidth: "wide"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $08aee069a6f85da8$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $08aee069a6f85da8$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $08aee069a6f85da8$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $08aee069a6f85da8$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $08aee069a6f85da8$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $08aee069a6f85da8$var$parseDayPatterns,
        defaultParseWidth: "wide"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $08aee069a6f85da8$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $08aee069a6f85da8$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $08aee069a6f85da8$export$2e2bcd8739ae039 = $08aee069a6f85da8$var$match;

});


parcelRegister("kRNmQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f30f0d3d54aea7b5$export$2e2bcd8739ae039);

var $b7Ezp = parcelRequire("b7Ezp");

var $jPfC5 = parcelRequire("jPfC5");

var $7a7uK = parcelRequire("7a7uK");

var $2aS2O = parcelRequire("2aS2O");

var $bogVE = parcelRequire("bogVE");
/**
 * @type {Locale}
 * @category Locales
 * @summary Persian/Farsi locale (Iran).
 * @language Persian
 * @iso-639-2 ira
 * @author Morteza Ziyae [@mort3za]{@link https://github.com/mort3za}
 */ var $f30f0d3d54aea7b5$var$locale = {
    code: "fa-IR",
    formatDistance: (0, $b7Ezp.default),
    formatLong: (0, $jPfC5.default),
    formatRelative: (0, $7a7uK.default),
    localize: (0, $2aS2O.default),
    match: (0, $bogVE.default),
    options: {
        weekStartsOn: 6 /* Saturday */ ,
        firstWeekContainsDate: 1
    }
};
var $f30f0d3d54aea7b5$export$2e2bcd8739ae039 = $f30f0d3d54aea7b5$var$locale;

});
parcelRegister("b7Ezp", function(module, exports) {

$parcel$export(module.exports, "default", () => $818fd189ffb79a36$export$2e2bcd8739ae039);
var $818fd189ffb79a36$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u06A9\u0645\u062A\u0631 \u0627\u0632 \u06CC\u06A9 \u062B\u0627\u0646\u06CC\u0647",
        other: "\u06A9\u0645\u062A\u0631 \u0627\u0632 {{count}} \u062B\u0627\u0646\u06CC\u0647"
    },
    xSeconds: {
        one: "1 \u062B\u0627\u0646\u06CC\u0647",
        other: "{{count}} \u062B\u0627\u0646\u06CC\u0647"
    },
    halfAMinute: "\u0646\u06CC\u0645 \u062F\u0642\u06CC\u0642\u0647",
    lessThanXMinutes: {
        one: "\u06A9\u0645\u062A\u0631 \u0627\u0632 \u06CC\u06A9 \u062F\u0642\u06CC\u0642\u0647",
        other: "\u06A9\u0645\u062A\u0631 \u0627\u0632 {{count}} \u062F\u0642\u06CC\u0642\u0647"
    },
    xMinutes: {
        one: "1 \u062F\u0642\u06CC\u0642\u0647",
        other: "{{count}} \u062F\u0642\u06CC\u0642\u0647"
    },
    aboutXHours: {
        one: "\u062D\u062F\u0648\u062F 1 \u0633\u0627\u0639\u062A",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0633\u0627\u0639\u062A"
    },
    xHours: {
        one: "1 \u0633\u0627\u0639\u062A",
        other: "{{count}} \u0633\u0627\u0639\u062A"
    },
    xDays: {
        one: "1 \u0631\u0648\u0632",
        other: "{{count}} \u0631\u0648\u0632"
    },
    aboutXWeeks: {
        one: "\u062D\u062F\u0648\u062F 1 \u0647\u0641\u062A\u0647",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0647\u0641\u062A\u0647"
    },
    xWeeks: {
        one: "1 \u0647\u0641\u062A\u0647",
        other: "{{count}} \u0647\u0641\u062A\u0647"
    },
    aboutXMonths: {
        one: "\u062D\u062F\u0648\u062F 1 \u0645\u0627\u0647",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0645\u0627\u0647"
    },
    xMonths: {
        one: "1 \u0645\u0627\u0647",
        other: "{{count}} \u0645\u0627\u0647"
    },
    aboutXYears: {
        one: "\u062D\u062F\u0648\u062F 1 \u0633\u0627\u0644",
        other: "\u062D\u062F\u0648\u062F {{count}} \u0633\u0627\u0644"
    },
    xYears: {
        one: "1 \u0633\u0627\u0644",
        other: "{{count}} \u0633\u0627\u0644"
    },
    overXYears: {
        one: "\u0628\u06CC\u0634\u062A\u0631 \u0627\u0632 1 \u0633\u0627\u0644",
        other: "\u0628\u06CC\u0634\u062A\u0631 \u0627\u0632 {{count}} \u0633\u0627\u0644"
    },
    almostXYears: {
        one: "\u0646\u0632\u062F\u06CC\u06A9 1 \u0633\u0627\u0644",
        other: "\u0646\u0632\u062F\u06CC\u06A9 {{count}} \u0633\u0627\u0644"
    }
};
var $818fd189ffb79a36$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $818fd189ffb79a36$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u062F\u0631 " + result;
        else return result + " \u0642\u0628\u0644";
    }
    return result;
};
var $818fd189ffb79a36$export$2e2bcd8739ae039 = $818fd189ffb79a36$var$formatDistance;

});

parcelRegister("jPfC5", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6eee436b1639669$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $e6eee436b1639669$var$dateFormats = {
    full: "EEEE do MMMM y",
    long: "do MMMM y",
    medium: "d MMM y",
    short: "yyyy/MM/dd"
};
var $e6eee436b1639669$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $e6eee436b1639669$var$dateTimeFormats = {
    full: "{{date}} '\u062F\u0631' {{time}}",
    long: "{{date}} '\u062F\u0631' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $e6eee436b1639669$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $e6eee436b1639669$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $e6eee436b1639669$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $e6eee436b1639669$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $e6eee436b1639669$export$2e2bcd8739ae039 = $e6eee436b1639669$var$formatLong;

});

parcelRegister("7a7uK", function(module, exports) {

$parcel$export(module.exports, "default", () => $536f47e64b15d1e1$export$2e2bcd8739ae039);
var $536f47e64b15d1e1$var$formatRelativeLocale = {
    lastWeek: "eeee '\u06AF\u0630\u0634\u062A\u0647 \u062F\u0631' p",
    yesterday: "'\u062F\u06CC\u0631\u0648\u0632 \u062F\u0631' p",
    today: "'\u0627\u0645\u0631\u0648\u0632 \u062F\u0631' p",
    tomorrow: "'\u0641\u0631\u062F\u0627 \u062F\u0631' p",
    nextWeek: "eeee '\u062F\u0631' p",
    other: "P"
};
var $536f47e64b15d1e1$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $536f47e64b15d1e1$var$formatRelativeLocale[token];
};
var $536f47e64b15d1e1$export$2e2bcd8739ae039 = $536f47e64b15d1e1$var$formatRelative;

});

parcelRegister("2aS2O", function(module, exports) {

$parcel$export(module.exports, "default", () => $19567009015e6e33$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $19567009015e6e33$var$eraValues = {
    narrow: [
        "\u0642",
        "\u0628"
    ],
    abbreviated: [
        "\u0642.\u0645.",
        "\u0628.\u0645."
    ],
    wide: [
        "\u0642\u0628\u0644 \u0627\u0632 \u0645\u06CC\u0644\u0627\u062F",
        "\u0628\u0639\u062F \u0627\u0632 \u0645\u06CC\u0644\u0627\u062F"
    ]
};
var $19567009015e6e33$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u0633\u200C\u06451",
        "\u0633\u200C\u06452",
        "\u0633\u200C\u06453",
        "\u0633\u200C\u06454"
    ],
    wide: [
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 1",
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 2",
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 3",
        "\u0633\u0647\u200C\u0645\u0627\u0647\u0647 4"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $19567009015e6e33$var$monthValues = {
    narrow: [
        "\u0698",
        "\u0641",
        "\u0645",
        "\u0622",
        "\u0645",
        "\u062C",
        "\u062C",
        "\u0622",
        "\u0633",
        "\u0627",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u0698\u0627\u0646\u0640",
        "\u0641\u0648\u0631",
        "\u0645\u0627\u0631\u0633",
        "\u0622\u067E\u0631",
        "\u0645\u06CC",
        "\u062C\u0648\u0646",
        "\u062C\u0648\u0644\u0640",
        "\u0622\u06AF\u0648",
        "\u0633\u067E\u062A\u0640",
        "\u0627\u06A9\u062A\u0640",
        "\u0646\u0648\u0627\u0645\u0640",
        "\u062F\u0633\u0627\u0645\u0640"
    ],
    wide: [
        "\u0698\u0627\u0646\u0648\u06CC\u0647",
        "\u0641\u0648\u0631\u06CC\u0647",
        "\u0645\u0627\u0631\u0633",
        "\u0622\u067E\u0631\u06CC\u0644",
        "\u0645\u06CC",
        "\u062C\u0648\u0646",
        "\u062C\u0648\u0644\u0627\u06CC",
        "\u0622\u06AF\u0648\u0633\u062A",
        "\u0633\u067E\u062A\u0627\u0645\u0628\u0631",
        "\u0627\u06A9\u062A\u0628\u0631",
        "\u0646\u0648\u0627\u0645\u0628\u0631",
        "\u062F\u0633\u0627\u0645\u0628\u0631"
    ]
};
var $19567009015e6e33$var$dayValues = {
    narrow: [
        "\u06CC",
        "\u062F",
        "\u0633",
        "\u0686",
        "\u067E",
        "\u062C",
        "\u0634"
    ],
    short: [
        "1\u0634",
        "2\u0634",
        "3\u0634",
        "4\u0634",
        "5\u0634",
        "\u062C",
        "\u0634"
    ],
    abbreviated: [
        "\u06CC\u06A9\u0634\u0646\u0628\u0647",
        "\u062F\u0648\u0634\u0646\u0628\u0647",
        "\u0633\u0647\u200C\u0634\u0646\u0628\u0647",
        "\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647",
        "\u067E\u0646\u062C\u0634\u0646\u0628\u0647",
        "\u062C\u0645\u0639\u0647",
        "\u0634\u0646\u0628\u0647"
    ],
    wide: [
        "\u06CC\u06A9\u0634\u0646\u0628\u0647",
        "\u062F\u0648\u0634\u0646\u0628\u0647",
        "\u0633\u0647\u200C\u0634\u0646\u0628\u0647",
        "\u0686\u0647\u0627\u0631\u0634\u0646\u0628\u0647",
        "\u067E\u0646\u062C\u0634\u0646\u0628\u0647",
        "\u062C\u0645\u0639\u0647",
        "\u0634\u0646\u0628\u0647"
    ]
};
var $19567009015e6e33$var$dayPeriodValues = {
    narrow: {
        am: "\u0642",
        pm: "\u0628",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635",
        afternoon: "\u0628.\u0638.",
        evening: "\u0639",
        night: "\u0634"
    },
    abbreviated: {
        am: "\u0642.\u0638.",
        pm: "\u0628.\u0638.",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    },
    wide: {
        am: "\u0642\u0628\u0644\u200C\u0627\u0632\u0638\u0647\u0631",
        pm: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    }
};
var $19567009015e6e33$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0642",
        pm: "\u0628",
        midnight: "\u0646",
        noon: "\u0638",
        morning: "\u0635",
        afternoon: "\u0628.\u0638.",
        evening: "\u0639",
        night: "\u0634"
    },
    abbreviated: {
        am: "\u0642.\u0638.",
        pm: "\u0628.\u0638.",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    },
    wide: {
        am: "\u0642\u0628\u0644\u200C\u0627\u0632\u0638\u0647\u0631",
        pm: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        midnight: "\u0646\u06CC\u0645\u0647\u200C\u0634\u0628",
        noon: "\u0638\u0647\u0631",
        morning: "\u0635\u0628\u062D",
        afternoon: "\u0628\u0639\u062F\u0627\u0632\u0638\u0647\u0631",
        evening: "\u0639\u0635\u0631",
        night: "\u0634\u0628"
    }
};
var $19567009015e6e33$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $19567009015e6e33$var$localize = {
    ordinalNumber: $19567009015e6e33$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $19567009015e6e33$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $19567009015e6e33$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $19567009015e6e33$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $19567009015e6e33$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $19567009015e6e33$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $19567009015e6e33$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $19567009015e6e33$export$2e2bcd8739ae039 = $19567009015e6e33$var$localize;

});

parcelRegister("bogVE", function(module, exports) {

$parcel$export(module.exports, "default", () => $84af114edfe5b2ee$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $84af114edfe5b2ee$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $84af114edfe5b2ee$var$parseOrdinalNumberPattern = /\d+/i;
var $84af114edfe5b2ee$var$matchEraPatterns = {
    narrow: /^(ق|ب)/i,
    abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?د\.?\s?م\.?|م\.?\s?|د\.?\s?م\.?)/i,
    wide: /^(قبل از میلاد|قبل از دوران مشترک|میلادی|دوران مشترک|بعد از میلاد)/i
};
var $84af114edfe5b2ee$var$parseEraPatterns = {
    any: [
        /^قبل/i,
        /^بعد/i
    ]
};
var $84af114edfe5b2ee$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^س‌م[1234]/i,
    wide: /^سه‌ماهه [1234]/i
};
var $84af114edfe5b2ee$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $84af114edfe5b2ee$var$matchMonthPatterns = {
    narrow: /^[جژفمآاماسند]/i,
    abbreviated: /^(جنو|ژانـ|ژانویه|فوریه|فور|مارس|آوریل|آپر|مه|می|ژوئن|جون|جول|جولـ|ژوئیه|اوت|آگو|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نوامـ|دسامبر|دسامـ|دسم)/i,
    wide: /^(ژانویه|جنوری|فبروری|فوریه|مارچ|مارس|آپریل|اپریل|ایپریل|آوریل|مه|می|ژوئن|جون|جولای|ژوئیه|آگست|اگست|آگوست|اوت|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نومبر|دسامبر|دسمبر)/i
};
var $84af114edfe5b2ee$var$parseMonthPatterns = {
    narrow: [
        /^(ژ|ج)/i,
        /^ف/i,
        /^م/i,
        /^(آ|ا)/i,
        /^م/i,
        /^(ژ|ج)/i,
        /^(ج|ژ)/i,
        /^(آ|ا)/i,
        /^س/i,
        /^ا/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^ژا/i,
        /^ف/i,
        /^ما/i,
        /^آپ/i,
        /^(می|مه)/i,
        /^(ژوئن|جون)/i,
        /^(ژوئی|جول)/i,
        /^(اوت|آگ)/i,
        /^س/i,
        /^(اوک|اک)/i,
        /^ن/i,
        /^د/i
    ]
};
var $84af114edfe5b2ee$var$matchDayPatterns = {
    narrow: /^[شیدسچپج]/i,
    short: /^(ش|ج|1ش|2ش|3ش|4ش|5ش)/i,
    abbreviated: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i,
    wide: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i
};
var $84af114edfe5b2ee$var$parseDayPatterns = {
    narrow: [
        /^ی/i,
        /^دو/i,
        /^س/i,
        /^چ/i,
        /^پ/i,
        /^ج/i,
        /^ش/i
    ],
    any: [
        /^(ی|1ش|یکشنبه)/i,
        /^(د|2ش|دوشنبه)/i,
        /^(س|3ش|سه‌شنبه)/i,
        /^(چ|4ش|چهارشنبه)/i,
        /^(پ|5ش|پنجشنبه)/i,
        /^(ج|جمعه)/i,
        /^(ش|شنبه)/i
    ]
};
var $84af114edfe5b2ee$var$matchDayPeriodPatterns = {
    narrow: /^(ب|ق|ن|ظ|ص|ب.ظ.|ع|ش)/i,
    abbreviated: /^(ق.ظ.|ب.ظ.|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i,
    wide: /^(قبل‌ازظهر|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i
};
var $84af114edfe5b2ee$var$parseDayPeriodPatterns = {
    any: {
        am: /^(ق|ق.ظ.|قبل‌ازظهر)/i,
        pm: /^(ب|ب.ظ.|بعدازظهر)/i,
        midnight: /^(‌نیمه‌شب|ن)/i,
        noon: /^(ظ|ظهر)/i,
        morning: /(ص|صبح)/i,
        afternoon: /(ب|ب.ظ.|بعدازظهر)/i,
        evening: /(ع|عصر)/i,
        night: /(ش|شب)/i
    }
};
var $84af114edfe5b2ee$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $84af114edfe5b2ee$var$matchOrdinalNumberPattern,
        parsePattern: $84af114edfe5b2ee$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $84af114edfe5b2ee$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $84af114edfe5b2ee$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $84af114edfe5b2ee$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $84af114edfe5b2ee$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $84af114edfe5b2ee$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $84af114edfe5b2ee$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $84af114edfe5b2ee$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $84af114edfe5b2ee$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $84af114edfe5b2ee$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $84af114edfe5b2ee$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $84af114edfe5b2ee$export$2e2bcd8739ae039 = $84af114edfe5b2ee$var$match;

});


parcelRegister("3NGl6", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c46ca671d6511ed$export$2e2bcd8739ae039);

var $1bf6h = parcelRequire("1bf6h");

var $b7hvU = parcelRequire("b7hvU");

var $1XHC2 = parcelRequire("1XHC2");

var $gSgqE = parcelRequire("gSgqE");

var $5KT88 = parcelRequire("5KT88");
/**
 * @type {Locale}
 * @category Locales
 * @summary Finnish locale.
 * @language Finnish
 * @iso-639-2 fin
 * @author Pyry-Samuli Lahti [@Pyppe]{@link https://github.com/Pyppe}
 * @author Edo Rivai [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Samu Juvonen [@sjuvonen]{@link https://github.com/sjuvonen}
 */ var $2c46ca671d6511ed$var$locale = {
    code: "fi",
    formatDistance: (0, $1bf6h.default),
    formatLong: (0, $b7hvU.default),
    formatRelative: (0, $1XHC2.default),
    localize: (0, $gSgqE.default),
    match: (0, $5KT88.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $2c46ca671d6511ed$export$2e2bcd8739ae039 = $2c46ca671d6511ed$var$locale;

});
parcelRegister("1bf6h", function(module, exports) {

$parcel$export(module.exports, "default", () => $0dc2881ab1d08660$export$2e2bcd8739ae039);
function $0dc2881ab1d08660$var$futureSeconds(text) {
    return text.replace(/sekuntia?/, "sekunnin");
}
function $0dc2881ab1d08660$var$futureMinutes(text) {
    return text.replace(/minuuttia?/, "minuutin");
}
function $0dc2881ab1d08660$var$futureHours(text) {
    return text.replace(/tuntia?/, "tunnin");
}
function $0dc2881ab1d08660$var$futureDays(text) {
    return text.replace(/päivää?/, "p\xe4iv\xe4n");
}
function $0dc2881ab1d08660$var$futureWeeks(text) {
    return text.replace(/(viikko|viikkoa)/, "viikon");
}
function $0dc2881ab1d08660$var$futureMonths(text) {
    return text.replace(/(kuukausi|kuukautta)/, "kuukauden");
}
function $0dc2881ab1d08660$var$futureYears(text) {
    return text.replace(/(vuosi|vuotta)/, "vuoden");
}
var $0dc2881ab1d08660$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "alle sekunti",
        other: "alle {{count}} sekuntia",
        futureTense: $0dc2881ab1d08660$var$futureSeconds
    },
    xSeconds: {
        one: "sekunti",
        other: "{{count}} sekuntia",
        futureTense: $0dc2881ab1d08660$var$futureSeconds
    },
    halfAMinute: {
        one: "puoli minuuttia",
        other: "puoli minuuttia",
        futureTense: function futureTense(_text) {
            return "puolen minuutin";
        }
    },
    lessThanXMinutes: {
        one: "alle minuutti",
        other: "alle {{count}} minuuttia",
        futureTense: $0dc2881ab1d08660$var$futureMinutes
    },
    xMinutes: {
        one: "minuutti",
        other: "{{count}} minuuttia",
        futureTense: $0dc2881ab1d08660$var$futureMinutes
    },
    aboutXHours: {
        one: "noin tunti",
        other: "noin {{count}} tuntia",
        futureTense: $0dc2881ab1d08660$var$futureHours
    },
    xHours: {
        one: "tunti",
        other: "{{count}} tuntia",
        futureTense: $0dc2881ab1d08660$var$futureHours
    },
    xDays: {
        one: "p\xe4iv\xe4",
        other: "{{count}} p\xe4iv\xe4\xe4",
        futureTense: $0dc2881ab1d08660$var$futureDays
    },
    aboutXWeeks: {
        one: "noin viikko",
        other: "noin {{count}} viikkoa",
        futureTense: $0dc2881ab1d08660$var$futureWeeks
    },
    xWeeks: {
        one: "viikko",
        other: "{{count}} viikkoa",
        futureTense: $0dc2881ab1d08660$var$futureWeeks
    },
    aboutXMonths: {
        one: "noin kuukausi",
        other: "noin {{count}} kuukautta",
        futureTense: $0dc2881ab1d08660$var$futureMonths
    },
    xMonths: {
        one: "kuukausi",
        other: "{{count}} kuukautta",
        futureTense: $0dc2881ab1d08660$var$futureMonths
    },
    aboutXYears: {
        one: "noin vuosi",
        other: "noin {{count}} vuotta",
        futureTense: $0dc2881ab1d08660$var$futureYears
    },
    xYears: {
        one: "vuosi",
        other: "{{count}} vuotta",
        futureTense: $0dc2881ab1d08660$var$futureYears
    },
    overXYears: {
        one: "yli vuosi",
        other: "yli {{count}} vuotta",
        futureTense: $0dc2881ab1d08660$var$futureYears
    },
    almostXYears: {
        one: "l\xe4hes vuosi",
        other: "l\xe4hes {{count}} vuotta",
        futureTense: $0dc2881ab1d08660$var$futureYears
    }
};
var $0dc2881ab1d08660$var$formatDistance = function formatDistance(token, count, options) {
    var tokenValue = $0dc2881ab1d08660$var$formatDistanceLocale[token];
    var result = count === 1 ? tokenValue.one : tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return tokenValue.futureTense(result) + " kuluttua";
        else return result + " sitten";
    }
    return result;
};
var $0dc2881ab1d08660$export$2e2bcd8739ae039 = $0dc2881ab1d08660$var$formatDistance;

});

parcelRegister("b7hvU", function(module, exports) {

$parcel$export(module.exports, "default", () => $817def00ec556f2b$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $817def00ec556f2b$var$dateFormats = {
    full: "eeee d. MMMM y",
    long: "d. MMMM y",
    medium: "d. MMM y",
    short: "d.M.y"
};
var $817def00ec556f2b$var$timeFormats = {
    full: "HH.mm.ss zzzz",
    long: "HH.mm.ss z",
    medium: "HH.mm.ss",
    short: "HH.mm"
};
var $817def00ec556f2b$var$dateTimeFormats = {
    full: "{{date}} 'klo' {{time}}",
    long: "{{date}} 'klo' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $817def00ec556f2b$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $817def00ec556f2b$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $817def00ec556f2b$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $817def00ec556f2b$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $817def00ec556f2b$export$2e2bcd8739ae039 = $817def00ec556f2b$var$formatLong;

});

parcelRegister("1XHC2", function(module, exports) {

$parcel$export(module.exports, "default", () => $16dd21af50345006$export$2e2bcd8739ae039);
var $16dd21af50345006$var$formatRelativeLocale = {
    lastWeek: "'viime' eeee 'klo' p",
    yesterday: "'eilen klo' p",
    today: "'t\xe4n\xe4\xe4n klo' p",
    tomorrow: "'huomenna klo' p",
    nextWeek: "'ensi' eeee 'klo' p",
    other: "P"
};
var $16dd21af50345006$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $16dd21af50345006$var$formatRelativeLocale[token];
};
var $16dd21af50345006$export$2e2bcd8739ae039 = $16dd21af50345006$var$formatRelative;

});

parcelRegister("gSgqE", function(module, exports) {

$parcel$export(module.exports, "default", () => $c48e6ee98a592c7d$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $c48e6ee98a592c7d$var$eraValues = {
    narrow: [
        "eaa.",
        "jaa."
    ],
    abbreviated: [
        "eaa.",
        "jaa."
    ],
    wide: [
        "ennen ajanlaskun alkua",
        "j\xe4lkeen ajanlaskun alun"
    ]
};
var $c48e6ee98a592c7d$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1. kvartaali",
        "2. kvartaali",
        "3. kvartaali",
        "4. kvartaali"
    ]
};
var $c48e6ee98a592c7d$var$monthValues = {
    narrow: [
        "T",
        "H",
        "M",
        "H",
        "T",
        "K",
        "H",
        "E",
        "S",
        "L",
        "M",
        "J"
    ],
    abbreviated: [
        "tammi",
        "helmi",
        "maalis",
        "huhti",
        "touko",
        "kes\xe4",
        "hein\xe4",
        "elo",
        "syys",
        "loka",
        "marras",
        "joulu"
    ],
    wide: [
        "tammikuu",
        "helmikuu",
        "maaliskuu",
        "huhtikuu",
        "toukokuu",
        "kes\xe4kuu",
        "hein\xe4kuu",
        "elokuu",
        "syyskuu",
        "lokakuu",
        "marraskuu",
        "joulukuu"
    ]
};
var $c48e6ee98a592c7d$var$formattingMonthValues = {
    narrow: $c48e6ee98a592c7d$var$monthValues.narrow,
    abbreviated: $c48e6ee98a592c7d$var$monthValues.abbreviated,
    wide: [
        "tammikuuta",
        "helmikuuta",
        "maaliskuuta",
        "huhtikuuta",
        "toukokuuta",
        "kes\xe4kuuta",
        "hein\xe4kuuta",
        "elokuuta",
        "syyskuuta",
        "lokakuuta",
        "marraskuuta",
        "joulukuuta"
    ]
};
var $c48e6ee98a592c7d$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "K",
        "T",
        "P",
        "L"
    ],
    short: [
        "su",
        "ma",
        "ti",
        "ke",
        "to",
        "pe",
        "la"
    ],
    abbreviated: [
        "sunn.",
        "maan.",
        "tiis.",
        "kesk.",
        "torst.",
        "perj.",
        "la"
    ],
    wide: [
        "sunnuntai",
        "maanantai",
        "tiistai",
        "keskiviikko",
        "torstai",
        "perjantai",
        "lauantai"
    ]
};
var $c48e6ee98a592c7d$var$formattingDayValues = {
    narrow: $c48e6ee98a592c7d$var$dayValues.narrow,
    short: $c48e6ee98a592c7d$var$dayValues.short,
    abbreviated: $c48e6ee98a592c7d$var$dayValues.abbreviated,
    wide: [
        "sunnuntaina",
        "maanantaina",
        "tiistaina",
        "keskiviikkona",
        "torstaina",
        "perjantaina",
        "lauantaina"
    ]
};
var $c48e6ee98a592c7d$var$dayPeriodValues = {
    narrow: {
        am: "ap",
        pm: "ip",
        midnight: "keskiy\xf6",
        noon: "keskip\xe4iv\xe4",
        morning: "ap",
        afternoon: "ip",
        evening: "illalla",
        night: "y\xf6ll\xe4"
    },
    abbreviated: {
        am: "ap",
        pm: "ip",
        midnight: "keskiy\xf6",
        noon: "keskip\xe4iv\xe4",
        morning: "ap",
        afternoon: "ip",
        evening: "illalla",
        night: "y\xf6ll\xe4"
    },
    wide: {
        am: "ap",
        pm: "ip",
        midnight: "keskiy\xf6ll\xe4",
        noon: "keskip\xe4iv\xe4ll\xe4",
        morning: "aamup\xe4iv\xe4ll\xe4",
        afternoon: "iltap\xe4iv\xe4ll\xe4",
        evening: "illalla",
        night: "y\xf6ll\xe4"
    }
};
var $c48e6ee98a592c7d$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + ".";
};
var $c48e6ee98a592c7d$var$localize = {
    ordinalNumber: $c48e6ee98a592c7d$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $c48e6ee98a592c7d$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $c48e6ee98a592c7d$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $c48e6ee98a592c7d$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $c48e6ee98a592c7d$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $c48e6ee98a592c7d$var$dayValues,
        defaultWidth: "wide",
        formattingValues: $c48e6ee98a592c7d$var$formattingDayValues,
        defaultFormattingWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $c48e6ee98a592c7d$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};
var $c48e6ee98a592c7d$export$2e2bcd8739ae039 = $c48e6ee98a592c7d$var$localize;

});

parcelRegister("5KT88", function(module, exports) {

$parcel$export(module.exports, "default", () => $430c035771f8d733$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $430c035771f8d733$var$matchOrdinalNumberPattern = /^(\d+)(\.)/i;
var $430c035771f8d733$var$parseOrdinalNumberPattern = /\d+/i;
var $430c035771f8d733$var$matchEraPatterns = {
    narrow: /^(e|j)/i,
    abbreviated: /^(eaa.|jaa.)/i,
    wide: /^(ennen ajanlaskun alkua|jälkeen ajanlaskun alun)/i
};
var $430c035771f8d733$var$parseEraPatterns = {
    any: [
        /^e/i,
        /^j/i
    ]
};
var $430c035771f8d733$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]\.? kvartaali/i
};
var $430c035771f8d733$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $430c035771f8d733$var$matchMonthPatterns = {
    narrow: /^[thmkeslj]/i,
    abbreviated: /^(tammi|helmi|maalis|huhti|touko|kesä|heinä|elo|syys|loka|marras|joulu)/i,
    wide: /^(tammikuu|helmikuu|maaliskuu|huhtikuu|toukokuu|kesäkuu|heinäkuu|elokuu|syyskuu|lokakuu|marraskuu|joulukuu)(ta)?/i
};
var $430c035771f8d733$var$parseMonthPatterns = {
    narrow: [
        /^t/i,
        /^h/i,
        /^m/i,
        /^h/i,
        /^t/i,
        /^k/i,
        /^h/i,
        /^e/i,
        /^s/i,
        /^l/i,
        /^m/i,
        /^j/i
    ],
    any: [
        /^ta/i,
        /^hel/i,
        /^maa/i,
        /^hu/i,
        /^to/i,
        /^k/i,
        /^hei/i,
        /^e/i,
        /^s/i,
        /^l/i,
        /^mar/i,
        /^j/i
    ]
};
var $430c035771f8d733$var$matchDayPatterns = {
    narrow: /^[smtkpl]/i,
    short: /^(su|ma|ti|ke|to|pe|la)/i,
    abbreviated: /^(sunn.|maan.|tiis.|kesk.|torst.|perj.|la)/i,
    wide: /^(sunnuntai|maanantai|tiistai|keskiviikko|torstai|perjantai|lauantai)(na)?/i
};
var $430c035771f8d733$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^k/i,
        /^t/i,
        /^p/i,
        /^l/i
    ],
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^k/i,
        /^to/i,
        /^p/i,
        /^l/i
    ]
};
var $430c035771f8d733$var$matchDayPeriodPatterns = {
    narrow: /^(ap|ip|keskiyö|keskipäivä|aamupäivällä|iltapäivällä|illalla|yöllä)/i,
    any: /^(ap|ip|keskiyöllä|keskipäivällä|aamupäivällä|iltapäivällä|illalla|yöllä)/i
};
var $430c035771f8d733$var$parseDayPeriodPatterns = {
    any: {
        am: /^ap/i,
        pm: /^ip/i,
        midnight: /^keskiyö/i,
        noon: /^keskipäivä/i,
        morning: /aamupäivällä/i,
        afternoon: /iltapäivällä/i,
        evening: /illalla/i,
        night: /yöllä/i
    }
};
var $430c035771f8d733$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $430c035771f8d733$var$matchOrdinalNumberPattern,
        parsePattern: $430c035771f8d733$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $430c035771f8d733$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $430c035771f8d733$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $430c035771f8d733$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $430c035771f8d733$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $430c035771f8d733$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $430c035771f8d733$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $430c035771f8d733$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $430c035771f8d733$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $430c035771f8d733$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $430c035771f8d733$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $430c035771f8d733$export$2e2bcd8739ae039 = $430c035771f8d733$var$match;

});


parcelRegister("5KUnQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $430cfc3649ba6f68$export$2e2bcd8739ae039);

var $1pz1X = parcelRequire("1pz1X");

var $c7fJp = parcelRequire("c7fJp");

var $djOks = parcelRequire("djOks");

var $cpmLG = parcelRequire("cpmLG");

var $615vX = parcelRequire("615vX");
/**
 * @type {Locale}
 * @category Locales
 * @summary French locale.
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
 */ var $430cfc3649ba6f68$var$locale = {
    code: "fr",
    formatDistance: (0, $1pz1X.default),
    formatLong: (0, $c7fJp.default),
    formatRelative: (0, $djOks.default),
    localize: (0, $cpmLG.default),
    match: (0, $615vX.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $430cfc3649ba6f68$export$2e2bcd8739ae039 = $430cfc3649ba6f68$var$locale;

});
parcelRegister("1pz1X", function(module, exports) {

$parcel$export(module.exports, "default", () => $10734c9823e547c0$export$2e2bcd8739ae039);
var $10734c9823e547c0$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "moins d\u2019une seconde",
        other: "moins de {{count}} secondes"
    },
    xSeconds: {
        one: "1 seconde",
        other: "{{count}} secondes"
    },
    halfAMinute: "30 secondes",
    lessThanXMinutes: {
        one: "moins d\u2019une minute",
        other: "moins de {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "environ 1 heure",
        other: "environ {{count}} heures"
    },
    xHours: {
        one: "1 heure",
        other: "{{count}} heures"
    },
    xDays: {
        one: "1 jour",
        other: "{{count}} jours"
    },
    aboutXWeeks: {
        one: "environ 1 semaine",
        other: "environ {{count}} semaines"
    },
    xWeeks: {
        one: "1 semaine",
        other: "{{count}} semaines"
    },
    aboutXMonths: {
        one: "environ 1 mois",
        other: "environ {{count}} mois"
    },
    xMonths: {
        one: "1 mois",
        other: "{{count}} mois"
    },
    aboutXYears: {
        one: "environ 1 an",
        other: "environ {{count}} ans"
    },
    xYears: {
        one: "1 an",
        other: "{{count}} ans"
    },
    overXYears: {
        one: "plus d\u2019un an",
        other: "plus de {{count}} ans"
    },
    almostXYears: {
        one: "presqu\u2019un an",
        other: "presque {{count}} ans"
    }
};
var $10734c9823e547c0$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var form = $10734c9823e547c0$var$formatDistanceLocale[token];
    if (typeof form === "string") result = form;
    else if (count === 1) result = form.one;
    else result = form.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "dans " + result;
        else return "il y a " + result;
    }
    return result;
};
var $10734c9823e547c0$export$2e2bcd8739ae039 = $10734c9823e547c0$var$formatDistance;

});

parcelRegister("c7fJp", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d225767632dff80$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $8d225767632dff80$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
var $8d225767632dff80$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $8d225767632dff80$var$dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $8d225767632dff80$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $8d225767632dff80$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $8d225767632dff80$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $8d225767632dff80$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $8d225767632dff80$export$2e2bcd8739ae039 = $8d225767632dff80$var$formatLong;

});

parcelRegister("djOks", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b2416f8bd9ccacb$export$2e2bcd8739ae039);
var $9b2416f8bd9ccacb$var$formatRelativeLocale = {
    lastWeek: "eeee 'dernier \xe0' p",
    yesterday: "'hier \xe0' p",
    today: "'aujourd\u2019hui \xe0' p",
    tomorrow: "'demain \xe0' p'",
    nextWeek: "eeee 'prochain \xe0' p",
    other: "P"
};
var $9b2416f8bd9ccacb$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $9b2416f8bd9ccacb$var$formatRelativeLocale[token];
};
var $9b2416f8bd9ccacb$export$2e2bcd8739ae039 = $9b2416f8bd9ccacb$var$formatRelative;

});

parcelRegister("cpmLG", function(module, exports) {

$parcel$export(module.exports, "default", () => $90897b15d7b593c8$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $90897b15d7b593c8$var$eraValues = {
    narrow: [
        "av. J.-C",
        "ap. J.-C"
    ],
    abbreviated: [
        "av. J.-C",
        "ap. J.-C"
    ],
    wide: [
        "avant J\xe9sus-Christ",
        "apr\xe8s J\xe9sus-Christ"
    ]
};
var $90897b15d7b593c8$var$quarterValues = {
    narrow: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    abbreviated: [
        "1er trim.",
        "2\xe8me trim.",
        "3\xe8me trim.",
        "4\xe8me trim."
    ],
    wide: [
        "1er trimestre",
        "2\xe8me trimestre",
        "3\xe8me trimestre",
        "4\xe8me trimestre"
    ]
};
var $90897b15d7b593c8$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "janv.",
        "f\xe9vr.",
        "mars",
        "avr.",
        "mai",
        "juin",
        "juil.",
        "ao\xfbt",
        "sept.",
        "oct.",
        "nov.",
        "d\xe9c."
    ],
    wide: [
        "janvier",
        "f\xe9vrier",
        "mars",
        "avril",
        "mai",
        "juin",
        "juillet",
        "ao\xfbt",
        "septembre",
        "octobre",
        "novembre",
        "d\xe9cembre"
    ]
};
var $90897b15d7b593c8$var$dayValues = {
    narrow: [
        "D",
        "L",
        "M",
        "M",
        "J",
        "V",
        "S"
    ],
    short: [
        "di",
        "lu",
        "ma",
        "me",
        "je",
        "ve",
        "sa"
    ],
    abbreviated: [
        "dim.",
        "lun.",
        "mar.",
        "mer.",
        "jeu.",
        "ven.",
        "sam."
    ],
    wide: [
        "dimanche",
        "lundi",
        "mardi",
        "mercredi",
        "jeudi",
        "vendredi",
        "samedi"
    ]
};
var $90897b15d7b593c8$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "minuit",
        noon: "midi",
        morning: "mat.",
        afternoon: "ap.m.",
        evening: "soir",
        night: "mat."
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "minuit",
        noon: "midi",
        morning: "matin",
        afternoon: "apr\xe8s-midi",
        evening: "soir",
        night: "matin"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "minuit",
        noon: "midi",
        morning: "du matin",
        afternoon: "de l\u2019apr\xe8s-midi",
        evening: "du soir",
        night: "du matin"
    }
};
var $90897b15d7b593c8$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    if (number === 0) return "0";
    var feminineUnits = [
        "year",
        "week",
        "hour",
        "minute",
        "second"
    ];
    var suffix;
    if (number === 1) suffix = unit && feminineUnits.includes(unit) ? "\xe8re" : "er";
    else suffix = "\xe8me";
    return number + suffix;
};
var $90897b15d7b593c8$var$localize = {
    ordinalNumber: $90897b15d7b593c8$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $90897b15d7b593c8$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $90897b15d7b593c8$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $90897b15d7b593c8$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $90897b15d7b593c8$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $90897b15d7b593c8$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};
var $90897b15d7b593c8$export$2e2bcd8739ae039 = $90897b15d7b593c8$var$localize;

});

parcelRegister("615vX", function(module, exports) {

$parcel$export(module.exports, "default", () => $46171d1becc06710$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $46171d1becc06710$var$matchOrdinalNumberPattern = /^(\d+)(ième|ère|ème|er|e)?/i;
var $46171d1becc06710$var$parseOrdinalNumberPattern = /\d+/i;
var $46171d1becc06710$var$matchEraPatterns = {
    narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
    abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
    wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
};
var $46171d1becc06710$var$parseEraPatterns = {
    any: [
        /^av/i,
        /^ap/i
    ]
};
var $46171d1becc06710$var$matchQuarterPatterns = {
    narrow: /^T?[1234]/i,
    abbreviated: /^[1234](er|ème|e)? trim\.?/i,
    wide: /^[1234](er|ème|e)? trimestre/i
};
var $46171d1becc06710$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $46171d1becc06710$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
    wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
};
var $46171d1becc06710$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^av/i,
        /^ma/i,
        /^juin/i,
        /^juil/i,
        /^ao/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $46171d1becc06710$var$matchDayPatterns = {
    narrow: /^[lmjvsd]/i,
    short: /^(di|lu|ma|me|je|ve|sa)/i,
    abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
    wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
};
var $46171d1becc06710$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^di/i,
        /^lu/i,
        /^ma/i,
        /^me/i,
        /^je/i,
        /^ve/i,
        /^sa/i
    ]
};
var $46171d1becc06710$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
    any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
};
var $46171d1becc06710$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^min/i,
        noon: /^mid/i,
        morning: /mat/i,
        afternoon: /ap/i,
        evening: /soir/i,
        night: /nuit/i
    }
};
var $46171d1becc06710$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $46171d1becc06710$var$matchOrdinalNumberPattern,
        parsePattern: $46171d1becc06710$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $46171d1becc06710$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $46171d1becc06710$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $46171d1becc06710$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $46171d1becc06710$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $46171d1becc06710$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $46171d1becc06710$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $46171d1becc06710$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $46171d1becc06710$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $46171d1becc06710$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $46171d1becc06710$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $46171d1becc06710$export$2e2bcd8739ae039 = $46171d1becc06710$var$match;

});


parcelRegister("7ao6A", function(module, exports) {

$parcel$export(module.exports, "default", () => $537c2a65258df409$export$2e2bcd8739ae039);
// Same as fr

var $1pz1X = parcelRequire("1pz1X");

var $djOks = parcelRequire("djOks");

var $cpmLG = parcelRequire("cpmLG");

var $615vX = parcelRequire("615vX");

var $aX8KM = parcelRequire("aX8KM");
/**
 * @type {Locale}
 * @category Locales
 * @summary French locale (Canada).
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
 * @author Gabriele Petrioli [@gpetrioli]{@link https://github.com/gpetrioli}
 */ var $537c2a65258df409$var$locale = {
    code: "fr-CA",
    formatDistance: (0, $1pz1X.default),
    formatLong: (0, $aX8KM.default),
    formatRelative: (0, $djOks.default),
    localize: (0, $cpmLG.default),
    match: (0, $615vX.default),
    // Unique for fr-CA
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $537c2a65258df409$export$2e2bcd8739ae039 = $537c2a65258df409$var$locale;

});
parcelRegister("aX8KM", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f963450f6d45639$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $7f963450f6d45639$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "yy-MM-dd"
};
var $7f963450f6d45639$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $7f963450f6d45639$var$dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $7f963450f6d45639$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $7f963450f6d45639$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $7f963450f6d45639$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $7f963450f6d45639$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $7f963450f6d45639$export$2e2bcd8739ae039 = $7f963450f6d45639$var$formatLong;

});


parcelRegister("gyxbH", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0d990b1774e1d64$export$2e2bcd8739ae039);
// Same as fr

var $1pz1X = parcelRequire("1pz1X");

var $cpmLG = parcelRequire("cpmLG");

var $615vX = parcelRequire("615vX");

var $3cebv = parcelRequire("3cebv");

var $jsTXu = parcelRequire("jsTXu");
/**
 * @type {Locale}
 * @category Locales
 * @summary French locale (Switzerland).
 * @language French
 * @iso-639-2 fra
 * @author Jean Dupouy [@izeau]{@link https://github.com/izeau}
 * @author François B [@fbonzon]{@link https://github.com/fbonzon}
 * @author Van Vuong Ngo [@vanvuongngo]{@link https://github.com/vanvuongngo}
 * @author Alex Hoeing [@dcbn]{@link https://github.com/dcbn}
 */ var $c0d990b1774e1d64$var$locale = {
    code: "fr-CH",
    formatDistance: (0, $1pz1X.default),
    formatLong: (0, $3cebv.default),
    formatRelative: (0, $jsTXu.default),
    localize: (0, $cpmLG.default),
    match: (0, $615vX.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $c0d990b1774e1d64$export$2e2bcd8739ae039 = $c0d990b1774e1d64$var$locale;

});
parcelRegister("3cebv", function(module, exports) {

$parcel$export(module.exports, "default", () => $253d7ed626726d3f$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $253d7ed626726d3f$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd.MM.y"
};
var $253d7ed626726d3f$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $253d7ed626726d3f$var$dateTimeFormats = {
    full: "{{date}} '\xe0' {{time}}",
    long: "{{date}} '\xe0' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $253d7ed626726d3f$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $253d7ed626726d3f$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $253d7ed626726d3f$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $253d7ed626726d3f$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $253d7ed626726d3f$export$2e2bcd8739ae039 = $253d7ed626726d3f$var$formatLong;

});

parcelRegister("jsTXu", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2bc0a0edf8beb41$export$2e2bcd8739ae039);
var $e2bc0a0edf8beb41$var$formatRelativeLocale = {
    lastWeek: "eeee 'la semaine derni\xe8re \xe0' p",
    yesterday: "'hier \xe0' p",
    today: "'aujourd\u2019hui \xe0' p",
    tomorrow: "'demain \xe0' p'",
    nextWeek: "eeee 'la semaine prochaine \xe0' p",
    other: "P"
};
var $e2bc0a0edf8beb41$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $e2bc0a0edf8beb41$var$formatRelativeLocale[token];
};
var $e2bc0a0edf8beb41$export$2e2bcd8739ae039 = $e2bc0a0edf8beb41$var$formatRelative;

});


parcelRegister("71rFn", function(module, exports) {

$parcel$export(module.exports, "default", () => $51ce165c4f76ee1e$export$2e2bcd8739ae039);

var $2FSMq = parcelRequire("2FSMq");

var $2mwl5 = parcelRequire("2mwl5");

var $kDR2y = parcelRequire("kDR2y");

var $fDqhZ = parcelRequire("fDqhZ");

var $717mI = parcelRequire("717mI");
/**
 * @type {Locale}
 * @category Locales
 * @summary Western Frisian locale (Netherlands).
 * @language West Frisian
 * @iso-639-2 fry
 * @author Damon Asberg [@damon02]{@link https://github.com/damon02}
 */ var $51ce165c4f76ee1e$var$locale = {
    code: "fy",
    formatDistance: (0, $2FSMq.default),
    formatLong: (0, $2mwl5.default),
    formatRelative: (0, $kDR2y.default),
    localize: (0, $fDqhZ.default),
    match: (0, $717mI.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $51ce165c4f76ee1e$export$2e2bcd8739ae039 = $51ce165c4f76ee1e$var$locale;

});
parcelRegister("2FSMq", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f29e74a85f540ad$export$2e2bcd8739ae039);
var $1f29e74a85f540ad$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "minder as 1 sekonde",
        other: "minder as {{count}} sekonden"
    },
    xSeconds: {
        one: "1 sekonde",
        other: "{{count}} sekonden"
    },
    halfAMinute: "oardel min\xfat",
    lessThanXMinutes: {
        one: "minder as 1 min\xfat",
        other: "minder as {{count}} minuten"
    },
    xMinutes: {
        one: "1 min\xfat",
        other: "{{count}} minuten"
    },
    aboutXHours: {
        one: "sawat 1 oere",
        other: "sawat {{count}} oere"
    },
    xHours: {
        one: "1 oere",
        other: "{{count}} oere"
    },
    xDays: {
        one: "1 dei",
        other: "{{count}} dagen"
    },
    aboutXWeeks: {
        one: "sawat 1 wike",
        other: "sawat {{count}} wiken"
    },
    xWeeks: {
        one: "1 wike",
        other: "{{count}} wiken"
    },
    aboutXMonths: {
        one: "sawat 1 moanne",
        other: "sawat {{count}} moannen"
    },
    xMonths: {
        one: "1 moanne",
        other: "{{count}} moannen"
    },
    aboutXYears: {
        one: "sawat 1 jier",
        other: "sawat {{count}} jier"
    },
    xYears: {
        one: "1 jier",
        other: "{{count}} jier"
    },
    overXYears: {
        one: "mear as 1 jier",
        other: "mear as {{count}}s jier"
    },
    almostXYears: {
        one: "hast 1 jier",
        other: "hast {{count}} jier"
    }
};
var $1f29e74a85f540ad$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $1f29e74a85f540ad$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "oer " + result;
        else return result + " lyn";
    }
    return result;
};
var $1f29e74a85f540ad$export$2e2bcd8739ae039 = $1f29e74a85f540ad$var$formatDistance;

});

parcelRegister("2mwl5", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b86b8b8db4015ac$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $1b86b8b8db4015ac$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd-MM-y"
};
var $1b86b8b8db4015ac$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $1b86b8b8db4015ac$var$dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $1b86b8b8db4015ac$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $1b86b8b8db4015ac$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $1b86b8b8db4015ac$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $1b86b8b8db4015ac$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $1b86b8b8db4015ac$export$2e2bcd8739ae039 = $1b86b8b8db4015ac$var$formatLong;

});

parcelRegister("kDR2y", function(module, exports) {

$parcel$export(module.exports, "default", () => $f07097dd32913462$export$2e2bcd8739ae039);
var $f07097dd32913462$var$formatRelativeLocale = {
    lastWeek: "'\xf4fr\xfbne' eeee 'om' p",
    yesterday: "'juster om' p",
    today: "'hjoed om' p",
    tomorrow: "'moarn om' p",
    nextWeek: "eeee 'om' p",
    other: "P"
};
var $f07097dd32913462$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $f07097dd32913462$var$formatRelativeLocale[token];
};
var $f07097dd32913462$export$2e2bcd8739ae039 = $f07097dd32913462$var$formatRelative;

});

parcelRegister("fDqhZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b61ee409c4c8d473$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $b61ee409c4c8d473$var$eraValues = {
    narrow: [
        "f.K.",
        "n.K."
    ],
    abbreviated: [
        "f.Kr.",
        "n.Kr."
    ],
    wide: [
        "foar Kristus",
        "nei Kristus"
    ]
};
var $b61ee409c4c8d473$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "K1",
        "K2",
        "K3",
        "K4"
    ],
    wide: [
        "1e fearnsjier",
        "2e fearnsjier",
        "3e fearnsjier",
        "4e fearnsjier"
    ]
};
var $b61ee409c4c8d473$var$monthValues = {
    narrow: [
        "j",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mrt.",
        "apr.",
        "mai.",
        "jun.",
        "jul.",
        "aug.",
        "sep.",
        "okt.",
        "nov.",
        "des."
    ],
    wide: [
        "jannewaris",
        "febrewaris",
        "maart",
        "april",
        "maaie",
        "juny",
        "july",
        "augustus",
        "septimber",
        "oktober",
        "novimber",
        "desimber"
    ]
};
var $b61ee409c4c8d473$var$dayValues = {
    narrow: [
        "s",
        "m",
        "t",
        "w",
        "t",
        "f",
        "s"
    ],
    short: [
        "si",
        "mo",
        "ti",
        "wo",
        "to",
        "fr",
        "so"
    ],
    abbreviated: [
        "snein",
        "moa",
        "tii",
        "woa",
        "ton",
        "fre",
        "sneon"
    ],
    wide: [
        "snein",
        "moandei",
        "tiisdei",
        "woansdei",
        "tongersdei",
        "freed",
        "sneon"
    ]
};
var $b61ee409c4c8d473$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "middei",
        morning: "moarns",
        afternoon: "middeis",
        evening: "j\xfbns",
        night: "nachts"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "middei",
        morning: "moarns",
        afternoon: "middeis",
        evening: "j\xfbns",
        night: "nachts"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "middei",
        morning: "moarns",
        afternoon: "middeis",
        evening: "j\xfbns",
        night: "nachts"
    }
};
var $b61ee409c4c8d473$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "e";
};
var $b61ee409c4c8d473$var$localize = {
    ordinalNumber: $b61ee409c4c8d473$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $b61ee409c4c8d473$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $b61ee409c4c8d473$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $b61ee409c4c8d473$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $b61ee409c4c8d473$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $b61ee409c4c8d473$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};
var $b61ee409c4c8d473$export$2e2bcd8739ae039 = $b61ee409c4c8d473$var$localize;

});

parcelRegister("717mI", function(module, exports) {

$parcel$export(module.exports, "default", () => $51be5707c6b0c658$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $51be5707c6b0c658$var$matchOrdinalNumberPattern = /^(\d+)e?/i;
var $51be5707c6b0c658$var$parseOrdinalNumberPattern = /\d+/i;
var $51be5707c6b0c658$var$matchEraPatterns = {
    narrow: /^([fn]\.? ?K\.?)/,
    abbreviated: /^([fn]\. ?Kr\.?)/,
    wide: /^((foar|nei) Kristus)/
};
var $51be5707c6b0c658$var$parseEraPatterns = {
    any: [
        /^f/,
        /^n/
    ]
};
var $51be5707c6b0c658$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e fearnsjier/i
};
var $51be5707c6b0c658$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $51be5707c6b0c658$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mai.|jun.|jul.|aug.|sep.|okt.|nov.|des.)/i,
    wide: /^(jannewaris|febrewaris|maart|april|maaie|juny|july|augustus|septimber|oktober|novimber|desimber)/i
};
var $51be5707c6b0c658$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^jan/i,
        /^feb/i,
        /^m(r|a)/i,
        /^apr/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^des/i
    ]
};
var $51be5707c6b0c658$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(si|mo|ti|wo|to|fr|so)/i,
    abbreviated: /^(snein|moa|tii|woa|ton|fre|sneon)/i,
    wide: /^(snein|moandei|tiisdei|woansdei|tongersdei|freed|sneon)/i
};
var $51be5707c6b0c658$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^sn/i,
        /^mo/i,
        /^ti/i,
        /^wo/i,
        /^to/i,
        /^fr/i,
        /^sn/i
    ]
};
var $51be5707c6b0c658$var$matchDayPeriodPatterns = {
    any: /^(am|pm|middernacht|middeis|moarns|middei|jûns|nachts)/i
};
var $51be5707c6b0c658$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^middernacht/i,
        noon: /^middei/i,
        morning: /moarns/i,
        afternoon: /^middeis/i,
        evening: /jûns/i,
        night: /nachts/i
    }
};
var $51be5707c6b0c658$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $51be5707c6b0c658$var$matchOrdinalNumberPattern,
        parsePattern: $51be5707c6b0c658$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $51be5707c6b0c658$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $51be5707c6b0c658$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $51be5707c6b0c658$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $51be5707c6b0c658$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $51be5707c6b0c658$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $51be5707c6b0c658$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $51be5707c6b0c658$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $51be5707c6b0c658$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $51be5707c6b0c658$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $51be5707c6b0c658$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $51be5707c6b0c658$export$2e2bcd8739ae039 = $51be5707c6b0c658$var$match;

});


parcelRegister("80hTX", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d3c35b1b2c6f63a$export$2e2bcd8739ae039);

var $icUNI = parcelRequire("icUNI");

var $43uAi = parcelRequire("43uAi");

var $isE0t = parcelRequire("isE0t");

var $ck9Q8 = parcelRequire("ck9Q8");

var $pSwzl = parcelRequire("pSwzl");
/**
 * @type {Locale}
 * @category Locales
 * @summary Scottish Gaelic.
 * @language Scottish Gaelic
 * @iso-639-2 gla
 * @author Lee Driscoll [@leedriscoll]{@link https://github.com/leedriscoll}
 */ var $5d3c35b1b2c6f63a$var$locale = {
    code: "gd",
    formatDistance: (0, $icUNI.default),
    formatLong: (0, $43uAi.default),
    formatRelative: (0, $isE0t.default),
    localize: (0, $ck9Q8.default),
    match: (0, $pSwzl.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $5d3c35b1b2c6f63a$export$2e2bcd8739ae039 = $5d3c35b1b2c6f63a$var$locale;

});
parcelRegister("icUNI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d41568723ca7dcb9$export$2e2bcd8739ae039);
var $d41568723ca7dcb9$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "nas lugha na diog",
        other: "nas lugha na {{count}} diogan"
    },
    xSeconds: {
        one: "1 diog",
        two: "2 dhiog",
        twenty: "20 diog",
        other: "{{count}} diogan"
    },
    halfAMinute: "leth mhionaid",
    lessThanXMinutes: {
        one: "nas lugha na mionaid",
        other: "nas lugha na {{count}} mionaidean"
    },
    xMinutes: {
        one: "1 mionaid",
        two: "2 mhionaid",
        twenty: "20 mionaid",
        other: "{{count}} mionaidean"
    },
    aboutXHours: {
        one: "mu uair de th\xecde",
        other: "mu {{count}} uairean de th\xecde"
    },
    xHours: {
        one: "1 uair de th\xecde",
        two: "2 uair de th\xecde",
        twenty: "20 uair de th\xecde",
        other: "{{count}} uairean de th\xecde"
    },
    xDays: {
        one: "1 l\xe0",
        other: "{{count}} l\xe0"
    },
    aboutXWeeks: {
        one: "mu 1 seachdain",
        other: "mu {{count}} seachdainean"
    },
    xWeeks: {
        one: "1 seachdain",
        other: "{{count}} seachdainean"
    },
    aboutXMonths: {
        one: "mu mh\xecos",
        other: "mu {{count}} m\xecosan"
    },
    xMonths: {
        one: "1 m\xecos",
        other: "{{count}} m\xecosan"
    },
    aboutXYears: {
        one: "mu bhliadhna",
        other: "mu {{count}} bliadhnaichean"
    },
    xYears: {
        one: "1 bhliadhna",
        other: "{{count}} bliadhna"
    },
    overXYears: {
        one: "c\xf2rr is bliadhna",
        other: "c\xf2rr is {{count}} bliadhnaichean"
    },
    almostXYears: {
        one: "cha mh\xf2r bliadhna",
        other: "cha mh\xf2r {{count}} bliadhnaichean"
    }
};
var $d41568723ca7dcb9$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $d41568723ca7dcb9$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2 && !!tokenValue.two) result = tokenValue.two;
    else if (count === 20 && !!tokenValue.twenty) result = tokenValue.twenty;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "ann an " + result;
        else return "o chionn " + result;
    }
    return result;
};
var $d41568723ca7dcb9$export$2e2bcd8739ae039 = $d41568723ca7dcb9$var$formatDistance;

});

parcelRegister("43uAi", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f3f2aa806c2a11a$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $2f3f2aa806c2a11a$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $2f3f2aa806c2a11a$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $2f3f2aa806c2a11a$var$dateTimeFormats = {
    full: "{{date}} 'aig' {{time}}",
    long: "{{date}} 'aig' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $2f3f2aa806c2a11a$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $2f3f2aa806c2a11a$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $2f3f2aa806c2a11a$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $2f3f2aa806c2a11a$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $2f3f2aa806c2a11a$export$2e2bcd8739ae039 = $2f3f2aa806c2a11a$var$formatLong;

});

parcelRegister("isE0t", function(module, exports) {

$parcel$export(module.exports, "default", () => $d709dffc173658ce$export$2e2bcd8739ae039);
var $d709dffc173658ce$var$formatRelativeLocale = {
    lastWeek: "'mu dheireadh' eeee 'aig' p",
    //FIX
    yesterday: "'an-d\xe8 aig' p",
    today: "'an-diugh aig' p",
    tomorrow: "'a-m\xe0ireach aig' p",
    nextWeek: "eeee 'aig' p",
    other: "P"
};
var $d709dffc173658ce$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $d709dffc173658ce$var$formatRelativeLocale[token];
};
var $d709dffc173658ce$export$2e2bcd8739ae039 = $d709dffc173658ce$var$formatRelative;

});

parcelRegister("ck9Q8", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f8efc45162e16c8$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $8f8efc45162e16c8$var$eraValues = {
    narrow: [
        "R",
        "A"
    ],
    abbreviated: [
        "RC",
        "AD"
    ],
    wide: [
        "ro Chr\xecosta",
        "anno domini"
    ]
};
var $8f8efc45162e16c8$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "C1",
        "C2",
        "C3",
        "C4"
    ],
    wide: [
        "a' chiad chairteal",
        "an d\xe0rna cairteal",
        "an treas cairteal",
        "an ceathramh cairteal"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $8f8efc45162e16c8$var$monthValues = {
    narrow: [
        "F",
        "G",
        "M",
        "G",
        "C",
        "\xd2",
        "I",
        "L",
        "S",
        "D",
        "S",
        "D"
    ],
    abbreviated: [
        "Faoi",
        "Gear",
        "M\xe0rt",
        "Gibl",
        "C\xe8it",
        "\xd2gmh",
        "Iuch",
        "L\xf9n",
        "Sult",
        "D\xe0mh",
        "Samh",
        "D\xf9bh"
    ],
    wide: [
        "Am Faoilleach",
        "An Gearran",
        "Am M\xe0rt",
        "An Giblean",
        "An C\xe8itean",
        "An t-\xd2gmhios",
        "An t-Iuchar",
        "An L\xf9nastal",
        "An t-Sultain",
        "An D\xe0mhair",
        "An t-Samhain",
        "An D\xf9bhlachd"
    ]
};
var $8f8efc45162e16c8$var$dayValues = {
    narrow: [
        "D",
        "L",
        "M",
        "C",
        "A",
        "H",
        "S"
    ],
    short: [
        "D\xf2",
        "Lu",
        "M\xe0",
        "Ci",
        "Ar",
        "Ha",
        "Sa"
    ],
    abbreviated: [
        "Did",
        "Dil",
        "Dim",
        "Dic",
        "Dia",
        "Dih",
        "Dis"
    ],
    wide: [
        "Did\xf2mhnaich",
        "Diluain",
        "Dim\xe0irt",
        "Diciadain",
        "Diardaoin",
        "Dihaoine",
        "Disathairne"
    ]
};
var $8f8efc45162e16c8$var$dayPeriodValues = {
    narrow: {
        am: "m",
        pm: "f",
        midnight: "m.o.",
        noon: "m.l.",
        morning: "madainn",
        afternoon: "feasgar",
        evening: "feasgar",
        night: "oidhche"
    },
    abbreviated: {
        am: "M.",
        pm: "F.",
        midnight: "meadhan oidhche",
        noon: "meadhan l\xe0",
        morning: "madainn",
        afternoon: "feasgar",
        evening: "feasgar",
        night: "oidhche"
    },
    wide: {
        am: "m.",
        pm: "f.",
        midnight: "meadhan oidhche",
        noon: "meadhan l\xe0",
        morning: "madainn",
        afternoon: "feasgar",
        evening: "feasgar",
        night: "oidhche"
    }
};
var $8f8efc45162e16c8$var$formattingDayPeriodValues = {
    narrow: {
        am: "m",
        pm: "f",
        midnight: "m.o.",
        noon: "m.l.",
        morning: "sa mhadainn",
        afternoon: "feasgar",
        evening: "feasgar",
        night: "air an oidhche"
    },
    abbreviated: {
        am: "M.",
        pm: "F.",
        midnight: "meadhan oidhche",
        noon: "meadhan l\xe0",
        morning: "sa mhadainn",
        afternoon: "feasgar",
        evening: "feasgar",
        night: "air an oidhche"
    },
    wide: {
        am: "m.",
        pm: "f.",
        midnight: "meadhan oidhche",
        noon: "meadhan l\xe0",
        morning: "sa mhadainn",
        afternoon: "feasgar",
        evening: "feasgar",
        night: "air an oidhche"
    }
};
var $8f8efc45162e16c8$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "d";
        case 2:
            return number + "na";
    }
    if (rem100 === 12) return number + "na";
    return number + "mh";
};
var $8f8efc45162e16c8$var$localize = {
    ordinalNumber: $8f8efc45162e16c8$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $8f8efc45162e16c8$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $8f8efc45162e16c8$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $8f8efc45162e16c8$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $8f8efc45162e16c8$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $8f8efc45162e16c8$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $8f8efc45162e16c8$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $8f8efc45162e16c8$export$2e2bcd8739ae039 = $8f8efc45162e16c8$var$localize;

});

parcelRegister("pSwzl", function(module, exports) {

$parcel$export(module.exports, "default", () => $04dca14e3abd0b79$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $04dca14e3abd0b79$var$matchOrdinalNumberPattern = /^(\d+)(d|na|tr|mh)?/i;
var $04dca14e3abd0b79$var$parseOrdinalNumberPattern = /\d+/i;
var $04dca14e3abd0b79$var$matchEraPatterns = {
    narrow: /^(r|a)/i,
    abbreviated: /^(r\.?\s?c\.?|r\.?\s?a\.?\s?c\.?|a\.?\s?d\.?|a\.?\s?c\.?)/i,
    wide: /^(ro Chrìosta|ron aois choitchinn|anno domini|aois choitcheann)/i
};
var $04dca14e3abd0b79$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $04dca14e3abd0b79$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^c[1234]/i,
    wide: /^[1234](cd|na|tr|mh)? cairteal/i
};
var $04dca14e3abd0b79$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $04dca14e3abd0b79$var$matchMonthPatterns = {
    narrow: /^[fgmcòilsd]/i,
    abbreviated: /^(faoi|gear|màrt|gibl|cèit|ògmh|iuch|lùn|sult|dàmh|samh|dùbh)/i,
    wide: /^(am faoilleach|an gearran|am màrt|an giblean|an cèitean|an t-Ògmhios|an t-Iuchar|an lùnastal|an t-Sultain|an dàmhair|an t-Samhain|an dùbhlachd)/i
};
var $04dca14e3abd0b79$var$parseMonthPatterns = {
    narrow: [
        /^f/i,
        /^g/i,
        /^m/i,
        /^g/i,
        /^c/i,
        /^ò/i,
        /^i/i,
        /^l/i,
        /^s/i,
        /^d/i,
        /^s/i,
        /^d/i
    ],
    any: [
        /^fa/i,
        /^ge/i,
        /^mà/i,
        /^gi/i,
        /^c/i,
        /^ò/i,
        /^i/i,
        /^l/i,
        /^su/i,
        /^d/i,
        /^sa/i,
        /^d/i
    ]
};
var $04dca14e3abd0b79$var$matchDayPatterns = {
    narrow: /^[dlmcahs]/i,
    short: /^(dò|lu|mà|ci|ar|ha|sa)/i,
    abbreviated: /^(did|dil|dim|dic|dia|dih|dis)/i,
    wide: /^(didòmhnaich|diluain|dimàirt|diciadain|diardaoin|dihaoine|disathairne)/i
};
var $04dca14e3abd0b79$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^c/i,
        /^a/i,
        /^h/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^c/i,
        /^a/i,
        /^h/i,
        /^s/i
    ]
};
var $04dca14e3abd0b79$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(san|aig) (madainn|feasgar|feasgar|oidhche))/i,
    any: /^([ap]\.?\s?m\.?|meadhan oidhche|meadhan là|(san|aig) (madainn|feasgar|feasgar|oidhche))/i
};
var $04dca14e3abd0b79$var$parseDayPeriodPatterns = {
    any: {
        am: /^m/i,
        pm: /^f/i,
        midnight: /^meadhan oidhche/i,
        noon: /^meadhan là/i,
        morning: /sa mhadainn/i,
        afternoon: /feasgar/i,
        evening: /feasgar/i,
        night: /air an oidhche/i
    }
};
var $04dca14e3abd0b79$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $04dca14e3abd0b79$var$matchOrdinalNumberPattern,
        parsePattern: $04dca14e3abd0b79$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $04dca14e3abd0b79$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $04dca14e3abd0b79$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $04dca14e3abd0b79$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $04dca14e3abd0b79$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $04dca14e3abd0b79$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $04dca14e3abd0b79$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $04dca14e3abd0b79$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $04dca14e3abd0b79$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $04dca14e3abd0b79$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $04dca14e3abd0b79$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $04dca14e3abd0b79$export$2e2bcd8739ae039 = $04dca14e3abd0b79$var$match;

});


parcelRegister("5wwDM", function(module, exports) {

$parcel$export(module.exports, "default", () => $405942aa7170f3d3$export$2e2bcd8739ae039);

var $9kMN8 = parcelRequire("9kMN8");

var $T4qYV = parcelRequire("T4qYV");

var $1du15 = parcelRequire("1du15");

var $PkwMA = parcelRequire("PkwMA");

var $fK1KI = parcelRequire("fK1KI");
/**
 * @type {Locale}
 * @category Locales
 * @summary Galician locale.
 * @language Galician
 * @iso-639-2 glg
 * @author Alberto Doval - Cocodin Technology[@cocodinTech]{@link https://github.com/cocodinTech}
 * @author Fidel Pita [@fidelpita]{@link https://github.com/fidelpita}
 */ var $405942aa7170f3d3$var$locale = {
    code: "gl",
    formatDistance: (0, $9kMN8.default),
    formatLong: (0, $T4qYV.default),
    formatRelative: (0, $1du15.default),
    localize: (0, $PkwMA.default),
    match: (0, $fK1KI.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $405942aa7170f3d3$export$2e2bcd8739ae039 = $405942aa7170f3d3$var$locale;

});
parcelRegister("9kMN8", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cbbd4476f43f21c$export$2e2bcd8739ae039);
var $6cbbd4476f43f21c$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "menos dun segundo",
        other: "menos de {{count}} segundos"
    },
    xSeconds: {
        one: "1 segundo",
        other: "{{count}} segundos"
    },
    halfAMinute: "medio minuto",
    lessThanXMinutes: {
        one: "menos dun minuto",
        other: "menos de {{count}} minutos"
    },
    xMinutes: {
        one: "1 minuto",
        other: "{{count}} minutos"
    },
    aboutXHours: {
        one: "arredor dunha hora",
        other: "arredor de {{count}} horas"
    },
    xHours: {
        one: "1 hora",
        other: "{{count}} horas"
    },
    xDays: {
        one: "1 d\xeda",
        other: "{{count}} d\xedas"
    },
    aboutXWeeks: {
        one: "arredor dunha semana",
        other: "arredor de {{count}} semanas"
    },
    xWeeks: {
        one: "1 semana",
        other: "{{count}} semanas"
    },
    aboutXMonths: {
        one: "arredor de 1 mes",
        other: "arredor de {{count}} meses"
    },
    xMonths: {
        one: "1 mes",
        other: "{{count}} meses"
    },
    aboutXYears: {
        one: "arredor dun ano",
        other: "arredor de {{count}} anos"
    },
    xYears: {
        one: "1 ano",
        other: "{{count}} anos"
    },
    overXYears: {
        one: "m\xe1is dun ano",
        other: "m\xe1is de {{count}} anos"
    },
    almostXYears: {
        one: "case un ano",
        other: "case {{count}} anos"
    }
};
var $6cbbd4476f43f21c$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $6cbbd4476f43f21c$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "en " + result;
        else return "hai " + result;
    }
    return result;
};
var $6cbbd4476f43f21c$export$2e2bcd8739ae039 = $6cbbd4476f43f21c$var$formatDistance;

});

parcelRegister("T4qYV", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a5893b4b734c224$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $0a5893b4b734c224$var$dateFormats = {
    full: "EEEE, d 'de' MMMM y",
    long: "d 'de' MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
var $0a5893b4b734c224$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $0a5893b4b734c224$var$dateTimeFormats = {
    full: "{{date}} '\xe1s' {{time}}",
    long: "{{date}} '\xe1s' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $0a5893b4b734c224$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $0a5893b4b734c224$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $0a5893b4b734c224$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $0a5893b4b734c224$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $0a5893b4b734c224$export$2e2bcd8739ae039 = $0a5893b4b734c224$var$formatLong;

});

parcelRegister("1du15", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e2e49fc494e4d0a$export$2e2bcd8739ae039);
var $0e2e49fc494e4d0a$var$formatRelativeLocale = {
    lastWeek: "'o' eeee 'pasado \xe1' LT",
    yesterday: "'onte \xe1' p",
    today: "'hoxe \xe1' p",
    tomorrow: "'ma\xf1\xe1 \xe1' p",
    nextWeek: "eeee '\xe1' p",
    other: "P"
};
var $0e2e49fc494e4d0a$var$formatRelativeLocalePlural = {
    lastWeek: "'o' eeee 'pasado \xe1s' p",
    yesterday: "'onte \xe1s' p",
    today: "'hoxe \xe1s' p",
    tomorrow: "'ma\xf1\xe1 \xe1s' p",
    nextWeek: "eeee '\xe1s' p",
    other: "P"
};
var $0e2e49fc494e4d0a$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    if (date.getUTCHours() !== 1) return $0e2e49fc494e4d0a$var$formatRelativeLocalePlural[token];
    return $0e2e49fc494e4d0a$var$formatRelativeLocale[token];
};
var $0e2e49fc494e4d0a$export$2e2bcd8739ae039 = $0e2e49fc494e4d0a$var$formatRelative;

});

parcelRegister("PkwMA", function(module, exports) {

$parcel$export(module.exports, "default", () => $09a4afeb39320b09$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $09a4afeb39320b09$var$eraValues = {
    narrow: [
        "AC",
        "DC"
    ],
    abbreviated: [
        "AC",
        "DC"
    ],
    wide: [
        "antes de cristo",
        "despois de cristo"
    ]
};
var $09a4afeb39320b09$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var $09a4afeb39320b09$var$monthValues = {
    narrow: [
        "e",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "xan",
        "feb",
        "mar",
        "abr",
        "mai",
        "xun",
        "xul",
        "ago",
        "set",
        "out",
        "nov",
        "dec"
    ],
    wide: [
        "xaneiro",
        "febreiro",
        "marzo",
        "abril",
        "maio",
        "xu\xf1o",
        "xullo",
        "agosto",
        "setembro",
        "outubro",
        "novembro",
        "decembro"
    ]
};
var $09a4afeb39320b09$var$dayValues = {
    narrow: [
        "d",
        "l",
        "m",
        "m",
        "j",
        "v",
        "s"
    ],
    short: [
        "do",
        "lu",
        "ma",
        "me",
        "xo",
        "ve",
        "sa"
    ],
    abbreviated: [
        "dom",
        "lun",
        "mar",
        "mer",
        "xov",
        "ven",
        "sab"
    ],
    wide: [
        "domingo",
        "luns",
        "martes",
        "m\xe9rcores",
        "xoves",
        "venres",
        "s\xe1bado"
    ]
};
var $09a4afeb39320b09$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "md",
        morning: "ma\xf1\xe1",
        afternoon: "tarde",
        evening: "tarde",
        night: "noite"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "medianoite",
        noon: "mediod\xeda",
        morning: "ma\xf1\xe1",
        afternoon: "tarde",
        evening: "tardi\xf1a",
        night: "noite"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "medianoite",
        noon: "mediod\xeda",
        morning: "ma\xf1\xe1",
        afternoon: "tarde",
        evening: "tardi\xf1a",
        night: "noite"
    }
};
var $09a4afeb39320b09$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "md",
        morning: "da ma\xf1\xe1",
        afternoon: "da tarde",
        evening: "da tardi\xf1a",
        night: "da noite"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "medianoite",
        noon: "mediod\xeda",
        morning: "da ma\xf1\xe1",
        afternoon: "da tarde",
        evening: "da tardi\xf1a",
        night: "da noite"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "medianoite",
        noon: "mediod\xeda",
        morning: "da ma\xf1\xe1",
        afternoon: "da tarde",
        evening: "da tardi\xf1a",
        night: "da noite"
    }
};
var $09a4afeb39320b09$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\xba";
};
var $09a4afeb39320b09$var$localize = {
    ordinalNumber: $09a4afeb39320b09$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $09a4afeb39320b09$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $09a4afeb39320b09$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $09a4afeb39320b09$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $09a4afeb39320b09$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $09a4afeb39320b09$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $09a4afeb39320b09$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $09a4afeb39320b09$export$2e2bcd8739ae039 = $09a4afeb39320b09$var$localize;

});

parcelRegister("fK1KI", function(module, exports) {

$parcel$export(module.exports, "default", () => $b75c82e7ada2f00f$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $b75c82e7ada2f00f$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var $b75c82e7ada2f00f$var$parseOrdinalNumberPattern = /\d+/i;
var $b75c82e7ada2f00f$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes da era com[uú]n|despois de cristo|era com[uú]n)/i
};
var $b75c82e7ada2f00f$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes da era com[uú]n)/i,
        /^(despois de cristo|era com[uú]n)/i
    ]
};
var $b75c82e7ada2f00f$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var $b75c82e7ada2f00f$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $b75c82e7ada2f00f$var$matchMonthPatterns = {
    narrow: /^[xfmasond]/i,
    abbreviated: /^(xan|feb|mar|abr|mai|xun|xul|ago|set|out|nov|dec)/i,
    wide: /^(xaneiro|febreiro|marzo|abril|maio|xuño|xullo|agosto|setembro|outubro|novembro|decembro)/i
};
var $b75c82e7ada2f00f$var$parseMonthPatterns = {
    narrow: [
        /^x/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^x/i,
        /^x/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^xan/i,
        /^feb/i,
        /^mar/i,
        /^abr/i,
        /^mai/i,
        /^xun/i,
        /^xul/i,
        /^ago/i,
        /^set/i,
        /^out/i,
        /^nov/i,
        /^dec/i
    ]
};
var $b75c82e7ada2f00f$var$matchDayPatterns = {
    narrow: /^[dlmxvs]/i,
    short: /^(do|lu|ma|me|xo|ve|sa)/i,
    abbreviated: /^(dom|lun|mar|mer|xov|ven|sab)/i,
    wide: /^(domingo|luns|martes|m[eé]rcores|xoves|venres|s[áa]bado)/i
};
var $b75c82e7ada2f00f$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^x/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^do/i,
        /^lu/i,
        /^ma/i,
        /^me/i,
        /^xo/i,
        /^ve/i,
        /^sa/i
    ]
};
var $b75c82e7ada2f00f$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(da|[aá]s) (mañ[aá]|tarde|noite))/i,
    any: /^([ap]\.?\s?m\.?|medianoite|mediod[ií]a|(da|[aá]s) (mañ[aá]|tarde|noite))/i
};
var $b75c82e7ada2f00f$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /^md/i,
        morning: /mañ[aá]/i,
        afternoon: /tarde/i,
        evening: /tardiña/i,
        night: /noite/i
    }
};
var $b75c82e7ada2f00f$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $b75c82e7ada2f00f$var$matchOrdinalNumberPattern,
        parsePattern: $b75c82e7ada2f00f$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $b75c82e7ada2f00f$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b75c82e7ada2f00f$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $b75c82e7ada2f00f$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b75c82e7ada2f00f$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $b75c82e7ada2f00f$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b75c82e7ada2f00f$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $b75c82e7ada2f00f$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b75c82e7ada2f00f$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $b75c82e7ada2f00f$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $b75c82e7ada2f00f$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $b75c82e7ada2f00f$export$2e2bcd8739ae039 = $b75c82e7ada2f00f$var$match;

});


parcelRegister("3muKw", function(module, exports) {

$parcel$export(module.exports, "default", () => $272b47552a23bd69$export$2e2bcd8739ae039);

var $6vWLp = parcelRequire("6vWLp");

var $ejFYm = parcelRequire("ejFYm");

var $5k56c = parcelRequire("5k56c");

var $9bT5Y = parcelRequire("9bT5Y");

var $avUTm = parcelRequire("avUTm");
/**
 * @type {Locale}
 * @category Locales
 * @summary Gujarati locale (India).
 * @language Gujarati
 * @iso-639-2 guj
 * @author Manaday Mavani [@ManadayM]{@link https://github.com/manadaym}
 */ var $272b47552a23bd69$var$locale = {
    code: "gu",
    formatDistance: (0, $6vWLp.default),
    formatLong: (0, $ejFYm.default),
    formatRelative: (0, $5k56c.default),
    localize: (0, $9bT5Y.default),
    match: (0, $avUTm.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $272b47552a23bd69$export$2e2bcd8739ae039 = $272b47552a23bd69$var$locale;

});
parcelRegister("6vWLp", function(module, exports) {

$parcel$export(module.exports, "default", () => $4be33890fbddfd81$export$2e2bcd8739ae039);
// Source: https://www.unicode.org/cldr/charts/32/summary/gu.html
var $4be33890fbddfd81$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0AB9\u0AAE\u0AA3\u0ABE\u0A82",
        // CLDR #1461
        other: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AB8\u0AC7\u0A95\u0A82\u0AA1"
    },
    xSeconds: {
        one: "1 \u0AB8\u0AC7\u0A95\u0A82\u0AA1",
        other: "{{count}} \u0AB8\u0AC7\u0A95\u0A82\u0AA1"
    },
    halfAMinute: "\u0A85\u0AA1\u0AA7\u0AC0 \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
    lessThanXMinutes: {
        one: "\u0A86 \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
        // CLDR #1448
        other: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F"
    },
    xMinutes: {
        one: "1 \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F",
        other: "{{count}} \u0AAE\u0ABF\u0AA8\u0ABF\u0A9F"
    },
    aboutXHours: {
        one: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 1 \u0A95\u0AB2\u0ABE\u0A95",
        other: "\u200B\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0A95\u0AB2\u0ABE\u0A95"
    },
    xHours: {
        one: "1 \u0A95\u0AB2\u0ABE\u0A95",
        other: "{{count}} \u0A95\u0AB2\u0ABE\u0A95"
    },
    xDays: {
        one: "1 \u0AA6\u0ABF\u0AB5\u0AB8",
        other: "{{count}} \u0AA6\u0ABF\u0AB5\u0AB8"
    },
    aboutXWeeks: {
        one: "\u0A86\u0AB6\u0AB0\u0AC7 1 \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0AC1\u0A82",
        other: "\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0ABE"
    },
    xWeeks: {
        one: "1 \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0AC1\u0A82",
        other: "{{count}} \u0A85\u0AA0\u0AB5\u0ABE\u0AA1\u0ABF\u0AAF\u0ABE"
    },
    aboutXMonths: {
        one: "\u0A86\u0AB6\u0AB0\u0AC7 1 \u0AAE\u0AB9\u0ABF\u0AA8\u0ACB",
        other: "\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AAE\u0AB9\u0ABF\u0AA8\u0ABE"
    },
    xMonths: {
        one: "1 \u0AAE\u0AB9\u0ABF\u0AA8\u0ACB",
        other: "{{count}} \u0AAE\u0AB9\u0ABF\u0AA8\u0ABE"
    },
    aboutXYears: {
        one: "\u0A86\u0AB6\u0AB0\u0AC7 1 \u0AB5\u0AB0\u0ACD\u0AB7",
        other: "\u0A86\u0AB6\u0AB0\u0AC7 {{count}} \u0AB5\u0AB0\u0ACD\u0AB7"
    },
    xYears: {
        one: "1 \u0AB5\u0AB0\u0ACD\u0AB7",
        other: "{{count}} \u0AB5\u0AB0\u0ACD\u0AB7"
    },
    overXYears: {
        one: "1 \u0AB5\u0AB0\u0ACD\u0AB7\u0AA5\u0AC0 \u0AB5\u0AA7\u0AC1",
        other: "{{count}} \u0AB5\u0AB0\u0ACD\u0AB7\u0AA5\u0AC0 \u0AB5\u0AA7\u0AC1"
    },
    almostXYears: {
        one: "\u0AB2\u0A97\u0AAD\u0A97 1 \u0AB5\u0AB0\u0ACD\u0AB7",
        other: "\u0AB2\u0A97\u0AAD\u0A97 {{count}} \u0AB5\u0AB0\u0ACD\u0AB7"
    }
};
var $4be33890fbddfd81$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $4be33890fbddfd81$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u0AAE\u0ABE\u0A82";
        else return result + " \u0AAA\u0AB9\u0AC7\u0AB2\u0ABE\u0A82";
    }
    return result;
};
var $4be33890fbddfd81$export$2e2bcd8739ae039 = $4be33890fbddfd81$var$formatDistance;

});

parcelRegister("ejFYm", function(module, exports) {

$parcel$export(module.exports, "default", () => $a6c365eb98d63c19$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $a6c365eb98d63c19$var$dateFormats = {
    full: "EEEE, d MMMM, y",
    // CLDR #1825
    long: "d MMMM, y",
    // CLDR #1826
    medium: "d MMM, y",
    // CLDR #1827
    short: "d/M/yy" // CLDR #1828
};
var $a6c365eb98d63c19$var$timeFormats = {
    full: "hh:mm:ss a zzzz",
    // CLDR #1829
    long: "hh:mm:ss a z",
    // CLDR #1830
    medium: "hh:mm:ss a",
    // CLDR #1831
    short: "hh:mm a" // CLDR #1832
};
var $a6c365eb98d63c19$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    // CLDR #1833
    long: "{{date}} {{time}}",
    // CLDR #1834
    medium: "{{date}} {{time}}",
    // CLDR #1835
    short: "{{date}} {{time}}" // CLDR #1836
};
var $a6c365eb98d63c19$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $a6c365eb98d63c19$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $a6c365eb98d63c19$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $a6c365eb98d63c19$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $a6c365eb98d63c19$export$2e2bcd8739ae039 = $a6c365eb98d63c19$var$formatLong;

});

parcelRegister("5k56c", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e02c68e226ecc3a$export$2e2bcd8739ae039);
// Source: https://www.unicode.org/cldr/charts/32/summary/gu.html
var $3e02c68e226ecc3a$var$formatRelativeLocale = {
    lastWeek: "'\u0AAA\u0ABE\u0A9B\u0AB2\u0ABE' eeee p",
    // CLDR #1384
    yesterday: "'\u0A97\u0A88\u0A95\u0ABE\u0AB2\u0AC7' p",
    // CLDR #1409
    today: "'\u0A86\u0A9C\u0AC7' p",
    // CLDR #1410
    tomorrow: "'\u0A86\u0AB5\u0AA4\u0AC0\u0A95\u0ABE\u0AB2\u0AC7' p",
    // CLDR #1411
    nextWeek: "eeee p",
    // CLDR #1386
    other: "P"
};
var $3e02c68e226ecc3a$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $3e02c68e226ecc3a$var$formatRelativeLocale[token];
};
var $3e02c68e226ecc3a$export$2e2bcd8739ae039 = $3e02c68e226ecc3a$var$formatRelative;

});

parcelRegister("9bT5Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b0fe0e869eab541$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
// #1621 - #1630
var $6b0fe0e869eab541$var$eraValues = {
    narrow: [
        "\u0A88\u0AB8\u0AAA\u0AC2",
        "\u0A88\u0AB8"
    ],
    abbreviated: [
        "\u0A88.\u0AB8.\u0AAA\u0AC2\u0AB0\u0ACD\u0AB5\u0AC7",
        "\u0A88.\u0AB8."
    ],
    wide: [
        "\u0A88\u0AB8\u0AB5\u0AC0\u0AB8\u0AA8 \u0AAA\u0AC2\u0AB0\u0ACD\u0AB5\u0AC7",
        "\u0A88\u0AB8\u0AB5\u0AC0\u0AB8\u0AA8"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1631 - #1654
var $6b0fe0e869eab541$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1\u0AB2\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8",
        "2\u0A9C\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8",
        "3\u0A9C\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8",
        "4\u0AA5\u0ACB \u0AA4\u0ACD\u0AB0\u0ABF\u0AAE\u0ABE\u0AB8"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1655 - #1726
var $6b0fe0e869eab541$var$monthValues = {
    narrow: [
        "\u0A9C\u0ABE",
        "\u0AAB\u0AC7",
        "\u0AAE\u0ABE",
        "\u0A8F",
        "\u0AAE\u0AC7",
        "\u0A9C\u0AC2",
        "\u0A9C\u0AC1",
        "\u0A93",
        "\u0AB8",
        "\u0A93",
        "\u0AA8",
        "\u0AA1\u0ABF"
    ],
    abbreviated: [
        "\u0A9C\u0ABE\u0AA8\u0ACD\u0AAF\u0AC1",
        "\u0AAB\u0AC7\u0AAC\u0ACD\u0AB0\u0AC1",
        "\u0AAE\u0ABE\u0AB0\u0ACD\u0A9A",
        "\u0A8F\u0AAA\u0ACD\u0AB0\u0ABF\u0AB2",
        "\u0AAE\u0AC7",
        "\u0A9C\u0AC2\u0AA8",
        "\u0A9C\u0AC1\u0AB2\u0ABE\u0A88",
        "\u0A91\u0A97\u0AB8\u0ACD\u0A9F",
        "\u0AB8\u0AAA\u0ACD\u0A9F\u0AC7",
        "\u0A93\u0A95\u0ACD\u0A9F\u0ACB",
        "\u0AA8\u0AB5\u0AC7",
        "\u0AA1\u0ABF\u0AB8\u0AC7"
    ],
    wide: [
        "\u0A9C\u0ABE\u0AA8\u0ACD\u0AAF\u0AC1\u0A86\u0AB0\u0AC0",
        "\u0AAB\u0AC7\u0AAC\u0ACD\u0AB0\u0AC1\u0A86\u0AB0\u0AC0",
        "\u0AAE\u0ABE\u0AB0\u0ACD\u0A9A",
        "\u0A8F\u0AAA\u0ACD\u0AB0\u0ABF\u0AB2",
        "\u0AAE\u0AC7",
        "\u0A9C\u0AC2\u0AA8",
        "\u0A9C\u0AC1\u0AB2\u0ABE\u0A87",
        "\u0A93\u0A97\u0AB8\u0ACD\u0A9F",
        "\u0AB8\u0AAA\u0ACD\u0A9F\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0",
        "\u0A93\u0A95\u0ACD\u0A9F\u0ACB\u0AAC\u0AB0",
        "\u0AA8\u0AB5\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0",
        "\u0AA1\u0ABF\u0AB8\u0AC7\u0AAE\u0ACD\u0AAC\u0AB0"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1727 - #1768
var $6b0fe0e869eab541$var$dayValues = {
    narrow: [
        "\u0AB0",
        "\u0AB8\u0ACB",
        "\u0AAE\u0A82",
        "\u0AAC\u0AC1",
        "\u0A97\u0AC1",
        "\u0AB6\u0AC1",
        "\u0AB6"
    ],
    short: [
        "\u0AB0",
        "\u0AB8\u0ACB",
        "\u0AAE\u0A82",
        "\u0AAC\u0AC1",
        "\u0A97\u0AC1",
        "\u0AB6\u0AC1",
        "\u0AB6"
    ],
    abbreviated: [
        "\u0AB0\u0AB5\u0ABF",
        "\u0AB8\u0ACB\u0AAE",
        "\u0AAE\u0A82\u0A97\u0AB3",
        "\u0AAC\u0AC1\u0AA7",
        "\u0A97\u0AC1\u0AB0\u0AC1",
        "\u0AB6\u0AC1\u0A95\u0ACD\u0AB0",
        "\u0AB6\u0AA8\u0ABF"
    ],
    wide: [
        "\u0AB0\u0AB5\u0ABF\u0AB5\u0ABE\u0AB0" /* Sunday */ ,
        "\u0AB8\u0ACB\u0AAE\u0AB5\u0ABE\u0AB0" /* Monday */ ,
        "\u0AAE\u0A82\u0A97\u0AB3\u0AB5\u0ABE\u0AB0" /* Tuesday */ ,
        "\u0AAC\u0AC1\u0AA7\u0AB5\u0ABE\u0AB0" /* Wednesday */ ,
        "\u0A97\u0AC1\u0AB0\u0AC1\u0AB5\u0ABE\u0AB0" /* Thursday */ ,
        "\u0AB6\u0AC1\u0A95\u0ACD\u0AB0\u0AB5\u0ABE\u0AB0" /* Friday */ ,
        "\u0AB6\u0AA8\u0ABF\u0AB5\u0ABE\u0AB0" /* Saturday */ 
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/gu.html
// #1783 - #1824
var $6b0fe0e869eab541$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "\u0AAE.\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC.",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "\u200B\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "\u200B\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    }
};
var $6b0fe0e869eab541$var$formattingDayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "\u0AAE.\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "\u200B\u0AAE\u0AA7\u0ACD\u0AAF\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0ABF",
        noon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        morning: "\u0AB8\u0AB5\u0ABE\u0AB0\u0AC7",
        afternoon: "\u0AAC\u0AAA\u0ACB\u0AB0\u0AC7",
        evening: "\u0AB8\u0ABE\u0A82\u0A9C\u0AC7",
        night: "\u0AB0\u0ABE\u0AA4\u0ACD\u0AB0\u0AC7"
    }
};
var $6b0fe0e869eab541$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $6b0fe0e869eab541$var$localize = {
    ordinalNumber: $6b0fe0e869eab541$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $6b0fe0e869eab541$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $6b0fe0e869eab541$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $6b0fe0e869eab541$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $6b0fe0e869eab541$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $6b0fe0e869eab541$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $6b0fe0e869eab541$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $6b0fe0e869eab541$export$2e2bcd8739ae039 = $6b0fe0e869eab541$var$localize;

});

parcelRegister("avUTm", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a78ee30909b675f$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $7a78ee30909b675f$var$matchOrdinalNumberPattern = /^(\d+)(લ|જ|થ|ઠ્ઠ|મ)?/i;
var $7a78ee30909b675f$var$parseOrdinalNumberPattern = /\d+/i;
var $7a78ee30909b675f$var$matchEraPatterns = {
    narrow: /^(ઈસપૂ|ઈસ)/i,
    abbreviated: /^(ઈ\.સ\.પૂર્વે|ઈ\.સ\.)/i,
    wide: /^(ઈસવીસન\sપૂર્વે|ઈસવીસન)/i
};
var $7a78ee30909b675f$var$parseEraPatterns = {
    any: [
        /^ઈસપૂ/i,
        /^ઈસ/i
    ]
};
var $7a78ee30909b675f$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](લો|જો|થો)? ત્રિમાસ/i
};
var $7a78ee30909b675f$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $7a78ee30909b675f$var$matchMonthPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[જાફેમાએમેજૂજુઓસઓનડિ]/i,
    abbreviated: /^(જાન્યુ|ફેબ્રુ|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઈ|ઑગસ્ટ|સપ્ટે|ઓક્ટો|નવે|ડિસે)/i,
    wide: /^(જાન્યુઆરી|ફેબ્રુઆરી|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઇ|ઓગસ્ટ|સપ્ટેમ્બર|ઓક્ટોબર|નવેમ્બર|ડિસેમ્બર)/i
};
var $7a78ee30909b675f$var$parseMonthPatterns = {
    narrow: [
        /^જા/i,
        /^ફે/i,
        /^મા/i,
        /^એ/i,
        /^મે/i,
        /^જૂ/i,
        /^જુ/i,
        /^ઑગ/i,
        /^સ/i,
        /^ઓક્ટો/i,
        /^ન/i,
        /^ડિ/i
    ],
    any: [
        /^જા/i,
        /^ફે/i,
        /^મા/i,
        /^એ/i,
        /^મે/i,
        /^જૂ/i,
        /^જુ/i,
        /^ઑગ/i,
        /^સ/i,
        /^ઓક્ટો/i,
        /^ન/i,
        /^ડિ/i
    ]
};
var $7a78ee30909b675f$var$matchDayPatterns = {
    narrow: /^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
    short: /^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
    abbreviated: /^(રવિ|સોમ|મંગળ|બુધ|ગુરુ|શુક્ર|શનિ)/i,
    wide: /^(રવિવાર|સોમવાર|મંગળવાર|બુધવાર|ગુરુવાર|શુક્રવાર|શનિવાર)/i
};
var $7a78ee30909b675f$var$parseDayPatterns = {
    narrow: [
        /^ર/i,
        /^સો/i,
        /^મં/i,
        /^બુ/i,
        /^ગુ/i,
        /^શુ/i,
        /^શ/i
    ],
    any: [
        /^ર/i,
        /^સો/i,
        /^મં/i,
        /^બુ/i,
        /^ગુ/i,
        /^શુ/i,
        /^શ/i
    ]
};
var $7a78ee30909b675f$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|મ\.?|સ|બ|સાં|રા)/i,
    any: /^(a|p|મ\.?|સ|બ|સાં|રા)/i
};
var $7a78ee30909b675f$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^મ\.?/i,
        noon: /^બ/i,
        morning: /સ/i,
        afternoon: /બ/i,
        evening: /સાં/i,
        night: /રા/i
    }
};
var $7a78ee30909b675f$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $7a78ee30909b675f$var$matchOrdinalNumberPattern,
        parsePattern: $7a78ee30909b675f$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $7a78ee30909b675f$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7a78ee30909b675f$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $7a78ee30909b675f$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7a78ee30909b675f$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $7a78ee30909b675f$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7a78ee30909b675f$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $7a78ee30909b675f$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7a78ee30909b675f$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $7a78ee30909b675f$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $7a78ee30909b675f$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $7a78ee30909b675f$export$2e2bcd8739ae039 = $7a78ee30909b675f$var$match;

});


parcelRegister("c8qu3", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d5ac67d81165cc1$export$2e2bcd8739ae039);

var $fvNJ2 = parcelRequire("fvNJ2");

var $1oLid = parcelRequire("1oLid");

var $1wWuh = parcelRequire("1wWuh");

var $9LjSn = parcelRequire("9LjSn");

var $cj5YF = parcelRequire("cj5YF");
/**
 * @type {Locale}
 * @category Locales
 * @summary Hebrew locale.
 * @language Hebrew
 * @iso-639-2 heb
 * @author Nir Lahad [@nirlah]{@link https://github.com/nirlah}
 */ var $8d5ac67d81165cc1$var$locale = {
    code: "he",
    formatDistance: (0, $fvNJ2.default),
    formatLong: (0, $1oLid.default),
    formatRelative: (0, $1wWuh.default),
    localize: (0, $9LjSn.default),
    match: (0, $cj5YF.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $8d5ac67d81165cc1$export$2e2bcd8739ae039 = $8d5ac67d81165cc1$var$locale;

});
parcelRegister("fvNJ2", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4b052b203da8890$export$2e2bcd8739ae039);
var $b4b052b203da8890$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05E9\u05E0\u05D9\u05D9\u05D4",
        two: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05E9\u05EA\u05D9 \u05E9\u05E0\u05D9\u05D5\u05EA",
        other: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05BE{{count}} \u05E9\u05E0\u05D9\u05D5\u05EA"
    },
    xSeconds: {
        one: "\u05E9\u05E0\u05D9\u05D9\u05D4",
        two: "\u05E9\u05EA\u05D9 \u05E9\u05E0\u05D9\u05D5\u05EA",
        other: "{{count}} \u05E9\u05E0\u05D9\u05D5\u05EA"
    },
    halfAMinute: "\u05D7\u05E6\u05D9 \u05D3\u05E7\u05D4",
    lessThanXMinutes: {
        one: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05D3\u05E7\u05D4",
        two: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05E9\u05EA\u05D9 \u05D3\u05E7\u05D5\u05EA",
        other: "\u05E4\u05D7\u05D5\u05EA \u05DE\u05BE{{count}} \u05D3\u05E7\u05D5\u05EA"
    },
    xMinutes: {
        one: "\u05D3\u05E7\u05D4",
        two: "\u05E9\u05EA\u05D9 \u05D3\u05E7\u05D5\u05EA",
        other: "{{count}} \u05D3\u05E7\u05D5\u05EA"
    },
    aboutXHours: {
        one: "\u05DB\u05E9\u05E2\u05D4",
        two: "\u05DB\u05E9\u05E2\u05EA\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05E9\u05E2\u05D5\u05EA"
    },
    xHours: {
        one: "\u05E9\u05E2\u05D4",
        two: "\u05E9\u05E2\u05EA\u05D9\u05D9\u05DD",
        other: "{{count}} \u05E9\u05E2\u05D5\u05EA"
    },
    xDays: {
        one: "\u05D9\u05D5\u05DD",
        two: "\u05D9\u05D5\u05DE\u05D9\u05D9\u05DD",
        other: "{{count}} \u05D9\u05DE\u05D9\u05DD"
    },
    aboutXWeeks: {
        one: "\u05DB\u05E9\u05D1\u05D5\u05E2",
        two: "\u05DB\u05E9\u05D1\u05D5\u05E2\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05E9\u05D1\u05D5\u05E2\u05D5\u05EA"
    },
    xWeeks: {
        one: "\u05E9\u05D1\u05D5\u05E2",
        two: "\u05E9\u05D1\u05D5\u05E2\u05D9\u05D9\u05DD",
        other: "{{count}} \u05E9\u05D1\u05D5\u05E2\u05D5\u05EA"
    },
    aboutXMonths: {
        one: "\u05DB\u05D7\u05D5\u05D3\u05E9",
        two: "\u05DB\u05D7\u05D5\u05D3\u05E9\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05D7\u05D5\u05D3\u05E9\u05D9\u05DD"
    },
    xMonths: {
        one: "\u05D7\u05D5\u05D3\u05E9",
        two: "\u05D7\u05D5\u05D3\u05E9\u05D9\u05D9\u05DD",
        other: "{{count}} \u05D7\u05D5\u05D3\u05E9\u05D9\u05DD"
    },
    aboutXYears: {
        one: "\u05DB\u05E9\u05E0\u05D4",
        two: "\u05DB\u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "\u05DB\u05BE{{count}} \u05E9\u05E0\u05D9\u05DD"
    },
    xYears: {
        one: "\u05E9\u05E0\u05D4",
        two: "\u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "{{count}} \u05E9\u05E0\u05D9\u05DD"
    },
    overXYears: {
        one: "\u05D9\u05D5\u05EA\u05E8 \u05DE\u05E9\u05E0\u05D4",
        two: "\u05D9\u05D5\u05EA\u05E8 \u05DE\u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "\u05D9\u05D5\u05EA\u05E8 \u05DE\u05BE{{count}} \u05E9\u05E0\u05D9\u05DD"
    },
    almostXYears: {
        one: "\u05DB\u05DE\u05E2\u05D8 \u05E9\u05E0\u05D4",
        two: "\u05DB\u05DE\u05E2\u05D8 \u05E9\u05E0\u05EA\u05D9\u05D9\u05DD",
        other: "\u05DB\u05DE\u05E2\u05D8 {{count}} \u05E9\u05E0\u05D9\u05DD"
    }
};
var $b4b052b203da8890$var$formatDistance = function formatDistance(token, count, options) {
    // Return word instead of `in one day` or `one day ago`
    if (token === "xDays" && options !== null && options !== void 0 && options.addSuffix && count <= 2) {
        if (options.comparison && options.comparison > 0) return count === 1 ? "\u05DE\u05D7\u05E8" : "\u05DE\u05D7\u05E8\u05EA\u05D9\u05D9\u05DD";
        return count === 1 ? "\u05D0\u05EA\u05DE\u05D5\u05DC" : "\u05E9\u05DC\u05E9\u05D5\u05DD";
    }
    var result;
    var tokenValue = $b4b052b203da8890$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2) result = tokenValue.two;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u05D1\u05E2\u05D5\u05D3 " + result;
        else return "\u05DC\u05E4\u05E0\u05D9 " + result;
    }
    return result;
};
var $b4b052b203da8890$export$2e2bcd8739ae039 = $b4b052b203da8890$var$formatDistance;

});

parcelRegister("1oLid", function(module, exports) {

$parcel$export(module.exports, "default", () => $104cb7acff719335$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $104cb7acff719335$var$dateFormats = {
    full: "EEEE, d \u05D1MMMM y",
    long: "d \u05D1MMMM y",
    medium: "d \u05D1MMM y",
    short: "d.M.y"
};
var $104cb7acff719335$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
var $104cb7acff719335$var$dateTimeFormats = {
    full: "{{date}} '\u05D1\u05E9\u05E2\u05D4' {{time}}",
    long: "{{date}} '\u05D1\u05E9\u05E2\u05D4' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $104cb7acff719335$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $104cb7acff719335$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $104cb7acff719335$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $104cb7acff719335$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $104cb7acff719335$export$2e2bcd8739ae039 = $104cb7acff719335$var$formatLong;

});

parcelRegister("1wWuh", function(module, exports) {

$parcel$export(module.exports, "default", () => $11d625f8dae8143b$export$2e2bcd8739ae039);
var $11d625f8dae8143b$var$formatRelativeLocale = {
    lastWeek: "eeee '\u05E9\u05E2\u05D1\u05E8 \u05D1\u05E9\u05E2\u05D4' p",
    yesterday: "'\u05D0\u05EA\u05DE\u05D5\u05DC \u05D1\u05E9\u05E2\u05D4' p",
    today: "'\u05D4\u05D9\u05D5\u05DD \u05D1\u05E9\u05E2\u05D4' p",
    tomorrow: "'\u05DE\u05D7\u05E8 \u05D1\u05E9\u05E2\u05D4' p",
    nextWeek: "eeee '\u05D1\u05E9\u05E2\u05D4' p",
    other: "P"
};
var $11d625f8dae8143b$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $11d625f8dae8143b$var$formatRelativeLocale[token];
};
var $11d625f8dae8143b$export$2e2bcd8739ae039 = $11d625f8dae8143b$var$formatRelative;

});

parcelRegister("9LjSn", function(module, exports) {

$parcel$export(module.exports, "default", () => $71b7ebce4d61f1e7$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $71b7ebce4d61f1e7$var$eraValues = {
    narrow: [
        "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E1",
        "\u05DC\u05E1\u05E4\u05D9\u05E8\u05D4"
    ],
    abbreviated: [
        "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E1",
        "\u05DC\u05E1\u05E4\u05D9\u05E8\u05D4"
    ],
    wide: [
        "\u05DC\u05E4\u05E0\u05D9 \u05D4\u05E1\u05E4\u05D9\u05E8\u05D4",
        "\u05DC\u05E1\u05E4\u05D9\u05E8\u05D4"
    ]
};
var $71b7ebce4d61f1e7$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "\u05E8\u05D1\u05E2\u05D5\u05DF 1",
        "\u05E8\u05D1\u05E2\u05D5\u05DF 2",
        "\u05E8\u05D1\u05E2\u05D5\u05DF 3",
        "\u05E8\u05D1\u05E2\u05D5\u05DF 4"
    ]
};
var $71b7ebce4d61f1e7$var$monthValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12"
    ],
    abbreviated: [
        "\u05D9\u05E0\u05D5\u05F3",
        "\u05E4\u05D1\u05E8\u05F3",
        "\u05DE\u05E8\u05E5",
        "\u05D0\u05E4\u05E8\u05F3",
        "\u05DE\u05D0\u05D9",
        "\u05D9\u05D5\u05E0\u05D9",
        "\u05D9\u05D5\u05DC\u05D9",
        "\u05D0\u05D5\u05D2\u05F3",
        "\u05E1\u05E4\u05D8\u05F3",
        "\u05D0\u05D5\u05E7\u05F3",
        "\u05E0\u05D5\u05D1\u05F3",
        "\u05D3\u05E6\u05DE\u05F3"
    ],
    wide: [
        "\u05D9\u05E0\u05D5\u05D0\u05E8",
        "\u05E4\u05D1\u05E8\u05D5\u05D0\u05E8",
        "\u05DE\u05E8\u05E5",
        "\u05D0\u05E4\u05E8\u05D9\u05DC",
        "\u05DE\u05D0\u05D9",
        "\u05D9\u05D5\u05E0\u05D9",
        "\u05D9\u05D5\u05DC\u05D9",
        "\u05D0\u05D5\u05D2\u05D5\u05E1\u05D8",
        "\u05E1\u05E4\u05D8\u05DE\u05D1\u05E8",
        "\u05D0\u05D5\u05E7\u05D8\u05D5\u05D1\u05E8",
        "\u05E0\u05D5\u05D1\u05DE\u05D1\u05E8",
        "\u05D3\u05E6\u05DE\u05D1\u05E8"
    ]
};
var $71b7ebce4d61f1e7$var$dayValues = {
    narrow: [
        "\u05D0\u05F3",
        "\u05D1\u05F3",
        "\u05D2\u05F3",
        "\u05D3\u05F3",
        "\u05D4\u05F3",
        "\u05D5\u05F3",
        "\u05E9\u05F3"
    ],
    short: [
        "\u05D0\u05F3",
        "\u05D1\u05F3",
        "\u05D2\u05F3",
        "\u05D3\u05F3",
        "\u05D4\u05F3",
        "\u05D5\u05F3",
        "\u05E9\u05F3"
    ],
    abbreviated: [
        "\u05D9\u05D5\u05DD \u05D0\u05F3",
        "\u05D9\u05D5\u05DD \u05D1\u05F3",
        "\u05D9\u05D5\u05DD \u05D2\u05F3",
        "\u05D9\u05D5\u05DD \u05D3\u05F3",
        "\u05D9\u05D5\u05DD \u05D4\u05F3",
        "\u05D9\u05D5\u05DD \u05D5\u05F3",
        "\u05E9\u05D1\u05EA"
    ],
    wide: [
        "\u05D9\u05D5\u05DD \u05E8\u05D0\u05E9\u05D5\u05DF",
        "\u05D9\u05D5\u05DD \u05E9\u05E0\u05D9",
        "\u05D9\u05D5\u05DD \u05E9\u05DC\u05D9\u05E9\u05D9",
        "\u05D9\u05D5\u05DD \u05E8\u05D1\u05D9\u05E2\u05D9",
        "\u05D9\u05D5\u05DD \u05D7\u05DE\u05D9\u05E9\u05D9",
        "\u05D9\u05D5\u05DD \u05E9\u05D9\u05E9\u05D9",
        "\u05D9\u05D5\u05DD \u05E9\u05D1\u05EA"
    ]
};
var $71b7ebce4d61f1e7$var$dayPeriodValues = {
    narrow: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05E2\u05E8\u05D1",
        night: "\u05DC\u05D9\u05DC\u05D4"
    },
    abbreviated: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05E2\u05E8\u05D1",
        night: "\u05DC\u05D9\u05DC\u05D4"
    },
    wide: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05E2\u05E8\u05D1",
        night: "\u05DC\u05D9\u05DC\u05D4"
    }
};
var $71b7ebce4d61f1e7$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D1\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05D1\u05E2\u05E8\u05D1",
        night: "\u05D1\u05DC\u05D9\u05DC\u05D4"
    },
    abbreviated: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05D1\u05E2\u05E8\u05D1",
        night: "\u05D1\u05DC\u05D9\u05DC\u05D4"
    },
    wide: {
        am: "\u05DC\u05E4\u05E0\u05D4\u05F4\u05E6",
        pm: "\u05D0\u05D7\u05D4\u05F4\u05E6",
        midnight: "\u05D7\u05E6\u05D5\u05EA",
        noon: "\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        morning: "\u05D1\u05D1\u05D5\u05E7\u05E8",
        afternoon: "\u05D0\u05D7\u05E8 \u05D4\u05E6\u05D4\u05E8\u05D9\u05D9\u05DD",
        evening: "\u05D1\u05E2\u05E8\u05D1",
        night: "\u05D1\u05DC\u05D9\u05DC\u05D4"
    }
};
var $71b7ebce4d61f1e7$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    // We only show words till 10
    if (number <= 0 || number > 10) return String(number);
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    var isFemale = [
        "year",
        "hour",
        "minute",
        "second"
    ].indexOf(unit) >= 0;
    var male = [
        "\u05E8\u05D0\u05E9\u05D5\u05DF",
        "\u05E9\u05E0\u05D9",
        "\u05E9\u05DC\u05D9\u05E9\u05D9",
        "\u05E8\u05D1\u05D9\u05E2\u05D9",
        "\u05D7\u05DE\u05D9\u05E9\u05D9",
        "\u05E9\u05D9\u05E9\u05D9",
        "\u05E9\u05D1\u05D9\u05E2\u05D9",
        "\u05E9\u05DE\u05D9\u05E0\u05D9",
        "\u05EA\u05E9\u05D9\u05E2\u05D9",
        "\u05E2\u05E9\u05D9\u05E8\u05D9"
    ];
    var female = [
        "\u05E8\u05D0\u05E9\u05D5\u05E0\u05D4",
        "\u05E9\u05E0\u05D9\u05D9\u05D4",
        "\u05E9\u05DC\u05D9\u05E9\u05D9\u05EA",
        "\u05E8\u05D1\u05D9\u05E2\u05D9\u05EA",
        "\u05D7\u05DE\u05D9\u05E9\u05D9\u05EA",
        "\u05E9\u05D9\u05E9\u05D9\u05EA",
        "\u05E9\u05D1\u05D9\u05E2\u05D9\u05EA",
        "\u05E9\u05DE\u05D9\u05E0\u05D9\u05EA",
        "\u05EA\u05E9\u05D9\u05E2\u05D9\u05EA",
        "\u05E2\u05E9\u05D9\u05E8\u05D9\u05EA"
    ];
    var index = number - 1;
    return isFemale ? female[index] : male[index];
};
var $71b7ebce4d61f1e7$var$localize = {
    ordinalNumber: $71b7ebce4d61f1e7$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $71b7ebce4d61f1e7$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $71b7ebce4d61f1e7$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $71b7ebce4d61f1e7$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $71b7ebce4d61f1e7$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $71b7ebce4d61f1e7$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $71b7ebce4d61f1e7$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $71b7ebce4d61f1e7$export$2e2bcd8739ae039 = $71b7ebce4d61f1e7$var$localize;

});

parcelRegister("cj5YF", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f5be5618eaa2279$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $8f5be5618eaa2279$var$matchOrdinalNumberPattern = /^(\d+|(ראשון|שני|שלישי|רביעי|חמישי|שישי|שביעי|שמיני|תשיעי|עשירי|ראשונה|שנייה|שלישית|רביעית|חמישית|שישית|שביעית|שמינית|תשיעית|עשירית))/i;
var $8f5be5618eaa2279$var$parseOrdinalNumberPattern = /^(\d+|רא|שנ|של|רב|ח|שי|שב|שמ|ת|ע)/i;
var $8f5be5618eaa2279$var$matchEraPatterns = {
    narrow: /^ל(ספירה|פנה״ס)/i,
    abbreviated: /^ל(ספירה|פנה״ס)/i,
    wide: /^ל(פני ה)?ספירה/i
};
var $8f5be5618eaa2279$var$parseEraPatterns = {
    any: [
        /^לפ/i,
        /^לס/i
    ]
};
var $8f5be5618eaa2279$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^רבעון [1234]/i
};
var $8f5be5618eaa2279$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $8f5be5618eaa2279$var$matchMonthPatterns = {
    narrow: /^\d+/i,
    abbreviated: /^(ינו|פבר|מרץ|אפר|מאי|יוני|יולי|אוג|ספט|אוק|נוב|דצמ)׳?/i,
    wide: /^(ינואר|פברואר|מרץ|אפריל|מאי|יוני|יולי|אוגוסט|ספטמבר|אוקטובר|נובמבר|דצמבר)/i
};
var $8f5be5618eaa2279$var$parseMonthPatterns = {
    narrow: [
        /^1$/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ינ/i,
        /^פ/i,
        /^מר/i,
        /^אפ/i,
        /^מא/i,
        /^יונ/i,
        /^יול/i,
        /^אוג/i,
        /^ס/i,
        /^אוק/i,
        /^נ/i,
        /^ד/i
    ]
};
var $8f5be5618eaa2279$var$matchDayPatterns = {
    narrow: /^[אבגדהוש]׳/i,
    short: /^[אבגדהוש]׳/i,
    abbreviated: /^(שבת|יום (א|ב|ג|ד|ה|ו)׳)/i,
    wide: /^יום (ראשון|שני|שלישי|רביעי|חמישי|שישי|שבת)/i
};
var $8f5be5618eaa2279$var$parseDayPatterns = {
    abbreviated: [
        /א׳$/i,
        /ב׳$/i,
        /ג׳$/i,
        /ד׳$/i,
        /ה׳$/i,
        /ו׳$/i,
        /^ש/i
    ],
    wide: [
        /ן$/i,
        /ני$/i,
        /לישי$/i,
        /עי$/i,
        /מישי$/i,
        /שישי$/i,
        /ת$/i
    ],
    any: [
        /^א/i,
        /^ב/i,
        /^ג/i,
        /^ד/i,
        /^ה/i,
        /^ו/i,
        /^ש/i
    ]
};
var $8f5be5618eaa2279$var$matchDayPeriodPatterns = {
    any: /^(אחר ה|ב)?(חצות|צהריים|בוקר|ערב|לילה|אחה״צ|לפנה״צ)/i
};
var $8f5be5618eaa2279$var$parseDayPeriodPatterns = {
    any: {
        am: /^לפ/i,
        pm: /^אחה/i,
        midnight: /^ח/i,
        noon: /^צ/i,
        morning: /בוקר/i,
        afternoon: /בצ|אחר/i,
        evening: /ערב/i,
        night: /לילה/i
    }
};
var $8f5be5618eaa2279$var$ordinalName = [
    "\u05E8\u05D0",
    "\u05E9\u05E0",
    "\u05E9\u05DC",
    "\u05E8\u05D1",
    "\u05D7",
    "\u05E9\u05D9",
    "\u05E9\u05D1",
    "\u05E9\u05DE",
    "\u05EA",
    "\u05E2"
];
var $8f5be5618eaa2279$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $8f5be5618eaa2279$var$matchOrdinalNumberPattern,
        parsePattern: $8f5be5618eaa2279$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            var number = parseInt(value, 10);
            return isNaN(number) ? $8f5be5618eaa2279$var$ordinalName.indexOf(value) + 1 : number;
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $8f5be5618eaa2279$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8f5be5618eaa2279$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $8f5be5618eaa2279$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8f5be5618eaa2279$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $8f5be5618eaa2279$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8f5be5618eaa2279$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $8f5be5618eaa2279$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8f5be5618eaa2279$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $8f5be5618eaa2279$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $8f5be5618eaa2279$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $8f5be5618eaa2279$export$2e2bcd8739ae039 = $8f5be5618eaa2279$var$match;

});


parcelRegister("a7gvH", function(module, exports) {

$parcel$export(module.exports, "default", () => $75d75d72d52f218c$export$2e2bcd8739ae039);

var $6oirq = parcelRequire("6oirq");

var $bIafH = parcelRequire("bIafH");

var $3Jpbh = parcelRequire("3Jpbh");

var $bkjvh = parcelRequire("bkjvh");

var $kqPao = parcelRequire("kqPao");
/**
 * @type {Locale}
 * @category Locales
 * @summary Hindi locale (India).
 * @language Hindi
 * @iso-639-2 hin
 * @author Mukesh Mandiwal [@mukeshmandiwal]{@link https://github.com/mukeshmandiwal}
 */ var $75d75d72d52f218c$var$locale = {
    code: "hi",
    formatDistance: (0, $6oirq.default),
    formatLong: (0, $bIafH.default),
    formatRelative: (0, $3Jpbh.default),
    localize: (0, $bkjvh.default),
    match: (0, $kqPao.default),
    options: {
        weekStartsOn: 0 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $75d75d72d52f218c$export$2e2bcd8739ae039 = $75d75d72d52f218c$var$locale;

});
parcelRegister("6oirq", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a734a04e810a051$export$2e2bcd8739ae039);

var $bkjvh = parcelRequire("bkjvh");
var $4a734a04e810a051$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0967 \u0938\u0947\u0915\u0902\u0921 \u0938\u0947 \u0915\u092E",
        // CLDR #1310
        other: "{{count}} \u0938\u0947\u0915\u0902\u0921 \u0938\u0947 \u0915\u092E"
    },
    xSeconds: {
        one: "\u0967 \u0938\u0947\u0915\u0902\u0921",
        other: "{{count}} \u0938\u0947\u0915\u0902\u0921"
    },
    halfAMinute: "\u0906\u0927\u093E \u092E\u093F\u0928\u091F",
    lessThanXMinutes: {
        one: "\u0967 \u092E\u093F\u0928\u091F \u0938\u0947 \u0915\u092E",
        other: "{{count}} \u092E\u093F\u0928\u091F \u0938\u0947 \u0915\u092E"
    },
    xMinutes: {
        one: "\u0967 \u092E\u093F\u0928\u091F",
        // CLDR #1307
        other: "{{count}} \u092E\u093F\u0928\u091F"
    },
    aboutXHours: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0918\u0902\u091F\u093E",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0918\u0902\u091F\u0947"
    },
    xHours: {
        one: "\u0967 \u0918\u0902\u091F\u093E",
        // CLDR #1304
        other: "{{count}} \u0918\u0902\u091F\u0947" // CLDR #4467
    },
    xDays: {
        one: "\u0967 \u0926\u093F\u0928",
        // CLDR #1286
        other: "{{count}} \u0926\u093F\u0928"
    },
    aboutXWeeks: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0938\u092A\u094D\u0924\u093E\u0939",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0938\u092A\u094D\u0924\u093E\u0939"
    },
    xWeeks: {
        one: "\u0967 \u0938\u092A\u094D\u0924\u093E\u0939",
        other: "{{count}} \u0938\u092A\u094D\u0924\u093E\u0939"
    },
    aboutXMonths: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u092E\u0939\u0940\u0928\u093E",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u092E\u0939\u0940\u0928\u0947"
    },
    xMonths: {
        one: "\u0967 \u092E\u0939\u0940\u0928\u093E",
        other: "{{count}} \u092E\u0939\u0940\u0928\u0947"
    },
    aboutXYears: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0935\u0930\u094D\u0937",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0935\u0930\u094D\u0937" // CLDR #4823
    },
    xYears: {
        one: "\u0967 \u0935\u0930\u094D\u0937",
        other: "{{count}} \u0935\u0930\u094D\u0937"
    },
    overXYears: {
        one: "\u0967 \u0935\u0930\u094D\u0937 \u0938\u0947 \u0905\u0927\u093F\u0915",
        other: "{{count}} \u0935\u0930\u094D\u0937 \u0938\u0947 \u0905\u0927\u093F\u0915"
    },
    almostXYears: {
        one: "\u0932\u0917\u092D\u0917 \u0967 \u0935\u0930\u094D\u0937",
        other: "\u0932\u0917\u092D\u0917 {{count}} \u0935\u0930\u094D\u0937"
    }
};
var $4a734a04e810a051$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $4a734a04e810a051$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", (0, $bkjvh.numberToLocale)(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u092E\u0947 ";
        else return result + " \u092A\u0939\u0932\u0947";
    }
    return result;
};
var $4a734a04e810a051$export$2e2bcd8739ae039 = $4a734a04e810a051$var$formatDistance;

});
parcelRegister("bkjvh", function(module, exports) {

$parcel$export(module.exports, "numberToLocale", () => $83f0b0fbe4c1b42a$export$3e1d599946644f03);
$parcel$export(module.exports, "localeToNumber", () => $83f0b0fbe4c1b42a$export$b431cabd737c2a);
$parcel$export(module.exports, "default", () => $83f0b0fbe4c1b42a$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $83f0b0fbe4c1b42a$var$numberValues = {
    locale: {
        "1": "\u0967",
        "2": "\u0968",
        "3": "\u0969",
        "4": "\u096A",
        "5": "\u096B",
        "6": "\u096C",
        "7": "\u096D",
        "8": "\u096E",
        "9": "\u096F",
        "0": "\u0966"
    },
    number: {
        "\u0967": "1",
        "\u0968": "2",
        "\u0969": "3",
        "\u096A": "4",
        "\u096B": "5",
        "\u096C": "6",
        "\u096D": "7",
        "\u096E": "8",
        "\u096F": "9",
        "\u0966": "0"
    }
};
// CLDR #1585 - #1592
var $83f0b0fbe4c1b42a$var$eraValues = {
    narrow: [
        "\u0908\u0938\u093E-\u092A\u0942\u0930\u094D\u0935",
        "\u0908\u0938\u094D\u0935\u0940"
    ],
    abbreviated: [
        "\u0908\u0938\u093E-\u092A\u0942\u0930\u094D\u0935",
        "\u0908\u0938\u094D\u0935\u0940"
    ],
    wide: [
        "\u0908\u0938\u093E-\u092A\u0942\u0930\u094D\u0935",
        "\u0908\u0938\u0935\u0940 \u0938\u0928"
    ]
};
// CLDR #1593 - #1616
var $83f0b0fbe4c1b42a$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u0924\u093F1",
        "\u0924\u093F2",
        "\u0924\u093F3",
        "\u0924\u093F4"
    ],
    wide: [
        "\u092A\u0939\u0932\u0940 \u0924\u093F\u092E\u093E\u0939\u0940",
        "\u0926\u0942\u0938\u0930\u0940 \u0924\u093F\u092E\u093E\u0939\u0940",
        "\u0924\u0940\u0938\u0930\u0940 \u0924\u093F\u092E\u093E\u0939\u0940",
        "\u091A\u094C\u0925\u0940 \u0924\u093F\u092E\u093E\u0939\u0940"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
// https://www.unicode.org/cldr/charts/32/summary/hi.html
// CLDR #1617 - #1688
var $83f0b0fbe4c1b42a$var$monthValues = {
    narrow: [
        "\u091C",
        "\u092B\u093C",
        "\u092E\u093E",
        "\u0905",
        "\u092E\u0908",
        "\u091C\u0942",
        "\u091C\u0941",
        "\u0905\u0917",
        "\u0938\u093F",
        "\u0905\u0915\u094D\u091F\u0942",
        "\u0928",
        "\u0926\u093F"
    ],
    abbreviated: [
        "\u091C\u0928",
        "\u092B\u093C\u0930",
        "\u092E\u093E\u0930\u094D\u091A",
        "\u0905\u092A\u094D\u0930\u0948\u0932",
        "\u092E\u0908",
        "\u091C\u0942\u0928",
        "\u091C\u0941\u0932",
        "\u0905\u0917",
        "\u0938\u093F\u0924",
        "\u0905\u0915\u094D\u091F\u0942",
        "\u0928\u0935",
        "\u0926\u093F\u0938"
    ],
    wide: [
        "\u091C\u0928\u0935\u0930\u0940",
        "\u092B\u093C\u0930\u0935\u0930\u0940",
        "\u092E\u093E\u0930\u094D\u091A",
        "\u0905\u092A\u094D\u0930\u0948\u0932",
        "\u092E\u0908",
        "\u091C\u0942\u0928",
        "\u091C\u0941\u0932\u093E\u0908",
        "\u0905\u0917\u0938\u094D\u0924",
        "\u0938\u093F\u0924\u0902\u092C\u0930",
        "\u0905\u0915\u094D\u091F\u0942\u092C\u0930",
        "\u0928\u0935\u0902\u092C\u0930",
        "\u0926\u093F\u0938\u0902\u092C\u0930"
    ]
};
// CLDR #1689 - #1744
var $83f0b0fbe4c1b42a$var$dayValues = {
    narrow: [
        "\u0930",
        "\u0938\u094B",
        "\u092E\u0902",
        "\u092C\u0941",
        "\u0917\u0941",
        "\u0936\u0941",
        "\u0936"
    ],
    short: [
        "\u0930",
        "\u0938\u094B",
        "\u092E\u0902",
        "\u092C\u0941",
        "\u0917\u0941",
        "\u0936\u0941",
        "\u0936"
    ],
    abbreviated: [
        "\u0930\u0935\u093F",
        "\u0938\u094B\u092E",
        "\u092E\u0902\u0917\u0932",
        "\u092C\u0941\u0927",
        "\u0917\u0941\u0930\u0941",
        "\u0936\u0941\u0915\u094D\u0930",
        "\u0936\u0928\u093F"
    ],
    wide: [
        "\u0930\u0935\u093F\u0935\u093E\u0930",
        "\u0938\u094B\u092E\u0935\u093E\u0930",
        "\u092E\u0902\u0917\u0932\u0935\u093E\u0930",
        "\u092C\u0941\u0927\u0935\u093E\u0930",
        "\u0917\u0941\u0930\u0941\u0935\u093E\u0930",
        "\u0936\u0941\u0915\u094D\u0930\u0935\u093E\u0930",
        "\u0936\u0928\u093F\u0935\u093E\u0930"
    ]
};
var $83f0b0fbe4c1b42a$var$dayPeriodValues = {
    narrow: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    },
    abbreviated: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    },
    wide: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    }
};
var $83f0b0fbe4c1b42a$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    },
    abbreviated: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    },
    wide: {
        am: "\u092A\u0942\u0930\u094D\u0935\u093E\u0939\u094D\u0928",
        pm: "\u0905\u092A\u0930\u093E\u0939\u094D\u0928",
        midnight: "\u092E\u0927\u094D\u092F\u0930\u093E\u0924\u094D\u0930\u093F",
        noon: "\u0926\u094B\u092A\u0939\u0930",
        morning: "\u0938\u0941\u092C\u0939",
        afternoon: "\u0926\u094B\u092A\u0939\u0930",
        evening: "\u0936\u093E\u092E",
        night: "\u0930\u093E\u0924"
    }
};
var $83f0b0fbe4c1b42a$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return $83f0b0fbe4c1b42a$export$3e1d599946644f03(number);
};
function $83f0b0fbe4c1b42a$export$b431cabd737c2a(locale) {
    var enNumber = locale.toString().replace(/[१२३४५६७८९०]/g, function(match) {
        return $83f0b0fbe4c1b42a$var$numberValues.number[match];
    });
    return Number(enNumber);
}
function $83f0b0fbe4c1b42a$export$3e1d599946644f03(enNumber) {
    return enNumber.toString().replace(/\d/g, function(match) {
        return $83f0b0fbe4c1b42a$var$numberValues.locale[match];
    });
}
var $83f0b0fbe4c1b42a$var$localize = {
    ordinalNumber: $83f0b0fbe4c1b42a$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $83f0b0fbe4c1b42a$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $83f0b0fbe4c1b42a$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $83f0b0fbe4c1b42a$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $83f0b0fbe4c1b42a$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $83f0b0fbe4c1b42a$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $83f0b0fbe4c1b42a$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $83f0b0fbe4c1b42a$export$2e2bcd8739ae039 = $83f0b0fbe4c1b42a$var$localize;

});


parcelRegister("bIafH", function(module, exports) {

$parcel$export(module.exports, "default", () => $886bc1a2dba73583$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $886bc1a2dba73583$var$dateFormats = {
    full: "EEEE, do MMMM, y",
    // CLDR #1787
    long: "do MMMM, y",
    // CLDR #1788
    medium: "d MMM, y",
    // CLDR #1789
    short: "dd/MM/yyyy" // CLDR #1790
};
var $886bc1a2dba73583$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    // CLDR #1791
    long: "h:mm:ss a z",
    // CLDR #1792
    medium: "h:mm:ss a",
    // CLDR #1793
    short: "h:mm a" // CLDR #1794
};
var $886bc1a2dba73583$var$dateTimeFormats = {
    full: "{{date}} '\u0915\u094B' {{time}}",
    // CLDR #1795
    long: "{{date}} '\u0915\u094B' {{time}}",
    // CLDR #1796
    medium: "{{date}}, {{time}}",
    // CLDR #1797
    short: "{{date}}, {{time}}" // CLDR #1798
};
var $886bc1a2dba73583$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $886bc1a2dba73583$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $886bc1a2dba73583$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $886bc1a2dba73583$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $886bc1a2dba73583$export$2e2bcd8739ae039 = $886bc1a2dba73583$var$formatLong;

});

parcelRegister("3Jpbh", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b791b7a6d9ead4d$export$2e2bcd8739ae039);
var $2b791b7a6d9ead4d$var$formatRelativeLocale = {
    lastWeek: "'\u092A\u093F\u091B\u0932\u0947' eeee p",
    yesterday: "'\u0915\u0932' p",
    today: "'\u0906\u091C' p",
    tomorrow: "'\u0915\u0932' p",
    nextWeek: "eeee '\u0915\u094B' p",
    other: "P"
};
var $2b791b7a6d9ead4d$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $2b791b7a6d9ead4d$var$formatRelativeLocale[token];
};
var $2b791b7a6d9ead4d$export$2e2bcd8739ae039 = $2b791b7a6d9ead4d$var$formatRelative;

});

parcelRegister("kqPao", function(module, exports) {

$parcel$export(module.exports, "default", () => $edfdecfff3c0f348$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");

var $bkjvh = parcelRequire("bkjvh");
var $edfdecfff3c0f348$var$matchOrdinalNumberPattern = /^[०१२३४५६७८९]+/i;
var $edfdecfff3c0f348$var$parseOrdinalNumberPattern = /^[०१२३४५६७८९]+/i;
var $edfdecfff3c0f348$var$matchEraPatterns = {
    narrow: /^(ईसा-पूर्व|ईस्वी)/i,
    abbreviated: /^(ईसा\.?\s?पूर्व\.?|ईसा\.?)/i,
    wide: /^(ईसा-पूर्व|ईसवी पूर्व|ईसवी सन|ईसवी)/i
};
var $edfdecfff3c0f348$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $edfdecfff3c0f348$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ति[1234]/i,
    wide: /^[1234](पहली|दूसरी|तीसरी|चौथी)? तिमाही/i
};
var $edfdecfff3c0f348$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $edfdecfff3c0f348$var$matchMonthPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[जफ़माअप्मईजूनजुअगसिअक्तनदि]/i,
    abbreviated: /^(जन|फ़र|मार्च|अप्|मई|जून|जुल|अग|सित|अक्तू|नव|दिस)/i,
    wide: /^(जनवरी|फ़रवरी|मार्च|अप्रैल|मई|जून|जुलाई|अगस्त|सितंबर|अक्तूबर|नवंबर|दिसंबर)/i
};
var $edfdecfff3c0f348$var$parseMonthPatterns = {
    narrow: [
        /^ज/i,
        /^फ़/i,
        /^मा/i,
        /^अप्/i,
        /^मई/i,
        /^जू/i,
        /^जु/i,
        /^अग/i,
        /^सि/i,
        /^अक्तू/i,
        /^न/i,
        /^दि/i
    ],
    any: [
        /^जन/i,
        /^फ़/i,
        /^मा/i,
        /^अप्/i,
        /^मई/i,
        /^जू/i,
        /^जु/i,
        /^अग/i,
        /^सि/i,
        /^अक्तू/i,
        /^नव/i,
        /^दिस/i
    ]
};
var $edfdecfff3c0f348$var$matchDayPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[रविसोममंगलबुधगुरुशुक्रशनि]/i,
    short: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
    abbreviated: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
    wide: /^(रविवार|सोमवार|मंगलवार|बुधवार|गुरुवार|शुक्रवार|शनिवार)/i
};
var $edfdecfff3c0f348$var$parseDayPatterns = {
    narrow: [
        /^रवि/i,
        /^सोम/i,
        /^मंगल/i,
        /^बुध/i,
        /^गुरु/i,
        /^शुक्र/i,
        /^शनि/i
    ],
    any: [
        /^रवि/i,
        /^सोम/i,
        /^मंगल/i,
        /^बुध/i,
        /^गुरु/i,
        /^शुक्र/i,
        /^शनि/i
    ]
};
var $edfdecfff3c0f348$var$matchDayPeriodPatterns = {
    narrow: /^(पू|अ|म|द.\?|सु|दो|शा|रा)/i,
    any: /^(पूर्वाह्न|अपराह्न|म|द.\?|सु|दो|शा|रा)/i
};
var $edfdecfff3c0f348$var$parseDayPeriodPatterns = {
    any: {
        am: /^पूर्वाह्न/i,
        pm: /^अपराह्न/i,
        midnight: /^मध्य/i,
        noon: /^दो/i,
        morning: /सु/i,
        afternoon: /दो/i,
        evening: /शा/i,
        night: /रा/i
    }
};
var $edfdecfff3c0f348$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $edfdecfff3c0f348$var$matchOrdinalNumberPattern,
        parsePattern: $edfdecfff3c0f348$var$parseOrdinalNumberPattern,
        valueCallback: (0, $bkjvh.localeToNumber)
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $edfdecfff3c0f348$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $edfdecfff3c0f348$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $edfdecfff3c0f348$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $edfdecfff3c0f348$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $edfdecfff3c0f348$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $edfdecfff3c0f348$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $edfdecfff3c0f348$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $edfdecfff3c0f348$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $edfdecfff3c0f348$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $edfdecfff3c0f348$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $edfdecfff3c0f348$export$2e2bcd8739ae039 = $edfdecfff3c0f348$var$match;

});


parcelRegister("22apf", function(module, exports) {

$parcel$export(module.exports, "default", () => $17b3d723bf61a7ee$export$2e2bcd8739ae039);

var $4H10Y = parcelRequire("4H10Y");

var $8PzVK = parcelRequire("8PzVK");

var $bVUxw = parcelRequire("bVUxw");

var $aM2Ik = parcelRequire("aM2Ik");

var $kHuBJ = parcelRequire("kHuBJ");
/**
 * @type {Locale}
 * @category Locales
 * @summary Croatian locale.
 * @language Croatian
 * @iso-639-2 hrv
 * @author Matija Marohnić [@silvenon]{@link https://github.com/silvenon}
 * @author Manico [@manico]{@link https://github.com/manico}
 * @author Ivan Jeržabek [@jerzabek]{@link https://github.com/jerzabek}
 */ var $17b3d723bf61a7ee$var$locale = {
    code: "hr",
    formatDistance: (0, $4H10Y.default),
    formatLong: (0, $8PzVK.default),
    formatRelative: (0, $bVUxw.default),
    localize: (0, $aM2Ik.default),
    match: (0, $kHuBJ.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $17b3d723bf61a7ee$export$2e2bcd8739ae039 = $17b3d723bf61a7ee$var$locale;

});
parcelRegister("4H10Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $36abf70d1780b80f$export$2e2bcd8739ae039);
var $36abf70d1780b80f$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: "manje od 1 sekunde",
            withPrepositionAgo: "manje od 1 sekunde",
            withPrepositionIn: "manje od 1 sekundu"
        },
        dual: "manje od {{count}} sekunde",
        other: "manje od {{count}} sekundi"
    },
    xSeconds: {
        one: {
            standalone: "1 sekunda",
            withPrepositionAgo: "1 sekunde",
            withPrepositionIn: "1 sekundu"
        },
        dual: "{{count}} sekunde",
        other: "{{count}} sekundi"
    },
    halfAMinute: "pola minute",
    lessThanXMinutes: {
        one: {
            standalone: "manje od 1 minute",
            withPrepositionAgo: "manje od 1 minute",
            withPrepositionIn: "manje od 1 minutu"
        },
        dual: "manje od {{count}} minute",
        other: "manje od {{count}} minuta"
    },
    xMinutes: {
        one: {
            standalone: "1 minuta",
            withPrepositionAgo: "1 minute",
            withPrepositionIn: "1 minutu"
        },
        dual: "{{count}} minute",
        other: "{{count}} minuta"
    },
    aboutXHours: {
        one: {
            standalone: "oko 1 sat",
            withPrepositionAgo: "oko 1 sat",
            withPrepositionIn: "oko 1 sat"
        },
        dual: "oko {{count}} sata",
        other: "oko {{count}} sati"
    },
    xHours: {
        one: {
            standalone: "1 sat",
            withPrepositionAgo: "1 sat",
            withPrepositionIn: "1 sat"
        },
        dual: "{{count}} sata",
        other: "{{count}} sati"
    },
    xDays: {
        one: {
            standalone: "1 dan",
            withPrepositionAgo: "1 dan",
            withPrepositionIn: "1 dan"
        },
        dual: "{{count}} dana",
        other: "{{count}} dana"
    },
    aboutXWeeks: {
        one: {
            standalone: "oko 1 tjedan",
            withPrepositionAgo: "oko 1 tjedan",
            withPrepositionIn: "oko 1 tjedan"
        },
        dual: "oko {{count}} tjedna",
        other: "oko {{count}} tjedana"
    },
    xWeeks: {
        one: {
            standalone: "1 tjedan",
            withPrepositionAgo: "1 tjedan",
            withPrepositionIn: "1 tjedan"
        },
        dual: "{{count}} tjedna",
        other: "{{count}} tjedana"
    },
    aboutXMonths: {
        one: {
            standalone: "oko 1 mjesec",
            withPrepositionAgo: "oko 1 mjesec",
            withPrepositionIn: "oko 1 mjesec"
        },
        dual: "oko {{count}} mjeseca",
        other: "oko {{count}} mjeseci"
    },
    xMonths: {
        one: {
            standalone: "1 mjesec",
            withPrepositionAgo: "1 mjesec",
            withPrepositionIn: "1 mjesec"
        },
        dual: "{{count}} mjeseca",
        other: "{{count}} mjeseci"
    },
    aboutXYears: {
        one: {
            standalone: "oko 1 godinu",
            withPrepositionAgo: "oko 1 godinu",
            withPrepositionIn: "oko 1 godinu"
        },
        dual: "oko {{count}} godine",
        other: "oko {{count}} godina"
    },
    xYears: {
        one: {
            standalone: "1 godina",
            withPrepositionAgo: "1 godine",
            withPrepositionIn: "1 godinu"
        },
        dual: "{{count}} godine",
        other: "{{count}} godina"
    },
    overXYears: {
        one: {
            standalone: "preko 1 godinu",
            withPrepositionAgo: "preko 1 godinu",
            withPrepositionIn: "preko 1 godinu"
        },
        dual: "preko {{count}} godine",
        other: "preko {{count}} godina"
    },
    almostXYears: {
        one: {
            standalone: "gotovo 1 godinu",
            withPrepositionAgo: "gotovo 1 godinu",
            withPrepositionIn: "gotovo 1 godinu"
        },
        dual: "gotovo {{count}} godine",
        other: "gotovo {{count}} godina"
    }
};
var $36abf70d1780b80f$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $36abf70d1780b80f$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== "1" // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace("{{count}}", String(count));
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "za " + result;
        else return "prije " + result;
    }
    return result;
};
var $36abf70d1780b80f$export$2e2bcd8739ae039 = $36abf70d1780b80f$var$formatDistance;

});

parcelRegister("8PzVK", function(module, exports) {

$parcel$export(module.exports, "default", () => $66def52c9a493c43$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $66def52c9a493c43$var$dateFormats = {
    full: "EEEE, d. MMMM y.",
    long: "d. MMMM y.",
    medium: "d. MMM y.",
    short: "dd. MM. y."
};
var $66def52c9a493c43$var$timeFormats = {
    full: "HH:mm:ss (zzzz)",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $66def52c9a493c43$var$dateTimeFormats = {
    full: "{{date}} 'u' {{time}}",
    long: "{{date}} 'u' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $66def52c9a493c43$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $66def52c9a493c43$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $66def52c9a493c43$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $66def52c9a493c43$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $66def52c9a493c43$export$2e2bcd8739ae039 = $66def52c9a493c43$var$formatLong;

});

parcelRegister("bVUxw", function(module, exports) {

$parcel$export(module.exports, "default", () => $8b00e02e4fed62df$export$2e2bcd8739ae039);
var $8b00e02e4fed62df$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'pro\u0161lu nedjelju u' p";
            case 3:
                return "'pro\u0161lu srijedu u' p";
            case 6:
                return "'pro\u0161lu subotu u' p";
            default:
                return "'pro\u0161li' EEEE 'u' p";
        }
    },
    yesterday: "'ju\u010Der u' p",
    today: "'danas u' p",
    tomorrow: "'sutra u' p",
    nextWeek: function nextWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'idu\u0107u nedjelju u' p";
            case 3:
                return "'idu\u0107u srijedu u' p";
            case 6:
                return "'idu\u0107u subotu u' p";
            default:
                return "'pro\u0161li' EEEE 'u' p";
        }
    },
    other: "P"
};
var $8b00e02e4fed62df$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $8b00e02e4fed62df$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
var $8b00e02e4fed62df$export$2e2bcd8739ae039 = $8b00e02e4fed62df$var$formatRelative;

});

parcelRegister("aM2Ik", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d807e09a5d08683$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $7d807e09a5d08683$var$eraValues = {
    narrow: [
        "pr.n.e.",
        "AD"
    ],
    abbreviated: [
        "pr. Kr.",
        "po. Kr."
    ],
    wide: [
        "Prije Krista",
        "Poslije Krista"
    ]
};
var $7d807e09a5d08683$var$quarterValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4."
    ],
    abbreviated: [
        "1. kv.",
        "2. kv.",
        "3. kv.",
        "4. kv."
    ],
    wide: [
        "1. kvartal",
        "2. kvartal",
        "3. kvartal",
        "4. kvartal"
    ]
};
var $7d807e09a5d08683$var$monthValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4.",
        "5.",
        "6.",
        "7.",
        "8.",
        "9.",
        "10.",
        "11.",
        "12."
    ],
    abbreviated: [
        "sij",
        "velj",
        "o\u017Eu",
        "tra",
        "svi",
        "lip",
        "srp",
        "kol",
        "ruj",
        "lis",
        "stu",
        "pro"
    ],
    wide: [
        "sije\u010Danj",
        "velja\u010Da",
        "o\u017Eujak",
        "travanj",
        "svibanj",
        "lipanj",
        "srpanj",
        "kolovoz",
        "rujan",
        "listopad",
        "studeni",
        "prosinac"
    ]
};
var $7d807e09a5d08683$var$formattingMonthValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4.",
        "5.",
        "6.",
        "7.",
        "8.",
        "9.",
        "10.",
        "11.",
        "12."
    ],
    abbreviated: [
        "sij",
        "velj",
        "o\u017Eu",
        "tra",
        "svi",
        "lip",
        "srp",
        "kol",
        "ruj",
        "lis",
        "stu",
        "pro"
    ],
    wide: [
        "sije\u010Dnja",
        "velja\u010De",
        "o\u017Eujka",
        "travnja",
        "svibnja",
        "lipnja",
        "srpnja",
        "kolovoza",
        "rujna",
        "listopada",
        "studenog",
        "prosinca"
    ]
};
var $7d807e09a5d08683$var$dayValues = {
    narrow: [
        "N",
        "P",
        "U",
        "S",
        "\u010C",
        "P",
        "S"
    ],
    short: [
        "ned",
        "pon",
        "uto",
        "sri",
        "\u010Det",
        "pet",
        "sub"
    ],
    abbreviated: [
        "ned",
        "pon",
        "uto",
        "sri",
        "\u010Det",
        "pet",
        "sub"
    ],
    wide: [
        "nedjelja",
        "ponedjeljak",
        "utorak",
        "srijeda",
        "\u010Detvrtak",
        "petak",
        "subota"
    ]
};
var $7d807e09a5d08683$var$formattingDayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutro",
        afternoon: "popodne",
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutro",
        afternoon: "popodne",
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutro",
        afternoon: "poslije podne",
        evening: "nave\u010Der",
        night: "no\u0107u"
    }
};
var $7d807e09a5d08683$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutro",
        afternoon: "popodne",
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutro",
        afternoon: "popodne",
        evening: "nave\u010Der",
        night: "no\u0107u"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutro",
        afternoon: "poslije podne",
        evening: "nave\u010Der",
        night: "no\u0107u"
    }
};
var $7d807e09a5d08683$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + ".";
};
var $7d807e09a5d08683$var$localize = {
    ordinalNumber: $7d807e09a5d08683$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $7d807e09a5d08683$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $7d807e09a5d08683$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $7d807e09a5d08683$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $7d807e09a5d08683$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $7d807e09a5d08683$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $7d807e09a5d08683$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $7d807e09a5d08683$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $7d807e09a5d08683$export$2e2bcd8739ae039 = $7d807e09a5d08683$var$localize;

});

parcelRegister("kHuBJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $03e39b1c2afad1a9$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $03e39b1c2afad1a9$var$matchOrdinalNumberPattern = /^(\d+)\./i;
var $03e39b1c2afad1a9$var$parseOrdinalNumberPattern = /\d+/i;
var $03e39b1c2afad1a9$var$matchEraPatterns = {
    narrow: /^(pr\.n\.e\.|AD)/i,
    abbreviated: /^(pr\.\s?Kr\.|po\.\s?Kr\.)/i,
    wide: /^(Prije Krista|prije nove ere|Poslije Krista|nova era)/i
};
var $03e39b1c2afad1a9$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|nova)/i
    ]
};
var $03e39b1c2afad1a9$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?kv\.?/i,
    wide: /^[1234]\. kvartal/i
};
var $03e39b1c2afad1a9$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $03e39b1c2afad1a9$var$matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(sij|velj|(ožu|ozu)|tra|svi|lip|srp|kol|ruj|lis|stu|pro)/i,
    wide: /^((siječanj|siječnja|sijecanj|sijecnja)|(veljača|veljače|veljaca|veljace)|(ožujak|ožujka|ozujak|ozujka)|(travanj|travnja)|(svibanj|svibnja)|(lipanj|lipnja)|(srpanj|srpnja)|(kolovoz|kolovoza)|(rujan|rujna)|(listopad|listopada)|(studeni|studenog)|(prosinac|prosinca))/i
};
var $03e39b1c2afad1a9$var$parseMonthPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i,
        /8/i,
        /9/i,
        /10/i,
        /11/i,
        /12/i
    ],
    abbreviated: [
        /^sij/i,
        /^velj/i,
        /^(ožu|ozu)/i,
        /^tra/i,
        /^svi/i,
        /^lip/i,
        /^srp/i,
        /^kol/i,
        /^ruj/i,
        /^lis/i,
        /^stu/i,
        /^pro/i
    ],
    wide: [
        /^sij/i,
        /^velj/i,
        /^(ožu|ozu)/i,
        /^tra/i,
        /^svi/i,
        /^lip/i,
        /^srp/i,
        /^kol/i,
        /^ruj/i,
        /^lis/i,
        /^stu/i,
        /^pro/i
    ]
};
var $03e39b1c2afad1a9$var$matchDayPatterns = {
    narrow: /^[npusčc]/i,
    short: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
    abbreviated: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
    wide: /^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i
};
var $03e39b1c2afad1a9$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $03e39b1c2afad1a9$var$matchDayPeriodPatterns = {
    any: /^(am|pm|ponoc|ponoć|(po)?podne|navecer|navečer|noću|poslije podne|ujutro)/i
};
var $03e39b1c2afad1a9$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^pono/i,
        noon: /^pod/i,
        morning: /jutro/i,
        afternoon: /(poslije\s|po)+podne/i,
        evening: /(navece|naveče)/i,
        night: /(nocu|noću)/i
    }
};
var $03e39b1c2afad1a9$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $03e39b1c2afad1a9$var$matchOrdinalNumberPattern,
        parsePattern: $03e39b1c2afad1a9$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $03e39b1c2afad1a9$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $03e39b1c2afad1a9$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $03e39b1c2afad1a9$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $03e39b1c2afad1a9$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $03e39b1c2afad1a9$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $03e39b1c2afad1a9$var$parseMonthPatterns,
        defaultParseWidth: "wide"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $03e39b1c2afad1a9$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $03e39b1c2afad1a9$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $03e39b1c2afad1a9$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $03e39b1c2afad1a9$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $03e39b1c2afad1a9$export$2e2bcd8739ae039 = $03e39b1c2afad1a9$var$match;

});


parcelRegister("fCx3R", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5f40ceb3604e48d$export$2e2bcd8739ae039);

var $fLomn = parcelRequire("fLomn");

var $gfef2 = parcelRequire("gfef2");

var $3lv7v = parcelRequire("3lv7v");

var $lSgAJ = parcelRequire("lSgAJ");

var $bFnoJ = parcelRequire("bFnoJ");
/**
 * @type {Locale}
 * @category Locales
 * @summary Haitian Creole locale.
 * @language Haitian Creole
 * @iso-639-2 hat
 * @author Rubens Mariuzzo [@rmariuzzo]{@link https://github.com/rmariuzzo}
 * @author Watson Marcelain [@watsongm24]{@link https://github.com/watsongm24}
 */ var $b5f40ceb3604e48d$var$locale = {
    code: "ht",
    formatDistance: (0, $fLomn.default),
    formatLong: (0, $gfef2.default),
    formatRelative: (0, $3lv7v.default),
    localize: (0, $lSgAJ.default),
    match: (0, $bFnoJ.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $b5f40ceb3604e48d$export$2e2bcd8739ae039 = $b5f40ceb3604e48d$var$locale;

});
parcelRegister("fLomn", function(module, exports) {

$parcel$export(module.exports, "default", () => $b79e242f26198400$export$2e2bcd8739ae039);
var $b79e242f26198400$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mwens pase yon segond",
        other: "mwens pase {{count}} segond"
    },
    xSeconds: {
        one: "1 segond",
        other: "{{count}} segond"
    },
    halfAMinute: "30 segond",
    lessThanXMinutes: {
        one: "mwens pase yon minit",
        other: "mwens pase {{count}} minit"
    },
    xMinutes: {
        one: "1 minit",
        other: "{{count}} minit"
    },
    aboutXHours: {
        one: "anviwon in\xe8",
        other: "anviwon {{count}} \xe8"
    },
    xHours: {
        one: "1 l\xe8",
        other: "{{count}} l\xe8"
    },
    xDays: {
        one: "1 jou",
        other: "{{count}} jou"
    },
    aboutXWeeks: {
        one: "anviwon 1 sem\xe8n",
        other: "anviwon {{count}} sem\xe8n"
    },
    xWeeks: {
        one: "1 sem\xe8n",
        other: "{{count}} sem\xe8n"
    },
    aboutXMonths: {
        one: "anviwon 1 mwa",
        other: "anviwon {{count}} mwa"
    },
    xMonths: {
        one: "1 mwa",
        other: "{{count}} mwa"
    },
    aboutXYears: {
        one: "anviwon 1 an",
        other: "anviwon {{count}} an"
    },
    xYears: {
        one: "1 an",
        other: "{{count}} an"
    },
    overXYears: {
        one: "plis pase 1 an",
        other: "plis pase {{count}} an"
    },
    almostXYears: {
        one: "pr\xe8ske 1 an",
        other: "pr\xe8ske {{count}} an"
    }
};
var $b79e242f26198400$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $b79e242f26198400$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "nan " + result;
        else return "sa f\xe8 " + result;
    }
    return result;
};
var $b79e242f26198400$export$2e2bcd8739ae039 = $b79e242f26198400$var$formatDistance;

});

parcelRegister("gfef2", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd391822963d78ff$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $bd391822963d78ff$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
var $bd391822963d78ff$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $bd391822963d78ff$var$dateTimeFormats = {
    full: "{{date}} 'nan l\xe8' {{time}}",
    long: "{{date}} 'nan l\xe8' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $bd391822963d78ff$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $bd391822963d78ff$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $bd391822963d78ff$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $bd391822963d78ff$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $bd391822963d78ff$export$2e2bcd8739ae039 = $bd391822963d78ff$var$formatLong;

});

parcelRegister("3lv7v", function(module, exports) {

$parcel$export(module.exports, "default", () => $26fb7914e5e262f8$export$2e2bcd8739ae039);
var $26fb7914e5e262f8$var$formatRelativeLocale = {
    lastWeek: "eeee 'pase nan l\xe8' p",
    yesterday: "'y\xe8 nan l\xe8' p",
    today: "'jodi a' p",
    tomorrow: "'demen nan l\xe8' p'",
    nextWeek: "eeee 'pwochen nan l\xe8' p",
    other: "P"
};
var $26fb7914e5e262f8$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $26fb7914e5e262f8$var$formatRelativeLocale[token];
};
var $26fb7914e5e262f8$export$2e2bcd8739ae039 = $26fb7914e5e262f8$var$formatRelative;

});

parcelRegister("lSgAJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fecb82db95a4e259$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $fecb82db95a4e259$var$eraValues = {
    narrow: [
        "av. J.-K",
        "ap. J.-K"
    ],
    abbreviated: [
        "av. J.-K",
        "ap. J.-K"
    ],
    wide: [
        "anvan Jezi Kris",
        "apre Jezi Kris"
    ]
};
var $fecb82db95a4e259$var$quarterValues = {
    narrow: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    abbreviated: [
        "1ye trim.",
        "2y\xe8m trim.",
        "3y\xe8m trim.",
        "4y\xe8m trim."
    ],
    wide: [
        "1ye trim\xe8s",
        "2y\xe8m trim\xe8s",
        "3y\xe8m trim\xe8s",
        "4y\xe8m trim\xe8s"
    ]
};
var $fecb82db95a4e259$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "O",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "janv.",
        "fevr.",
        "mas",
        "avr.",
        "me",
        "jen",
        "jiy\xe8",
        "out",
        "sept.",
        "okt.",
        "nov.",
        "des."
    ],
    wide: [
        "janvye",
        "fevrye",
        "mas",
        "avril",
        "me",
        "jen",
        "jiy\xe8",
        "out",
        "septanm",
        "okt\xf2b",
        "novanm",
        "desanm"
    ]
};
var $fecb82db95a4e259$var$dayValues = {
    narrow: [
        "D",
        "L",
        "M",
        "M",
        "J",
        "V",
        "S"
    ],
    short: [
        "di",
        "le",
        "ma",
        "m\xe8",
        "je",
        "va",
        "sa"
    ],
    abbreviated: [
        "dim.",
        "len.",
        "mad.",
        "m\xe8k.",
        "jed.",
        "van.",
        "sam."
    ],
    wide: [
        "dimanch",
        "lendi",
        "madi",
        "m\xe8kredi",
        "jedi",
        "vandredi",
        "samdi"
    ]
};
var $fecb82db95a4e259$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "minwit",
        noon: "midi",
        morning: "mat.",
        afternoon: "ap.m.",
        evening: "swa",
        night: "mat."
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "minwit",
        noon: "midi",
        morning: "maten",
        afternoon: "apr\xe8midi",
        evening: "swa",
        night: "maten"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "minwit",
        noon: "midi",
        morning: "nan maten",
        afternoon: "nan apr\xe8midi",
        evening: "nan asw\xe8",
        night: "nan maten"
    }
};
var $fecb82db95a4e259$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    if (number === 0) return String(number);
    var suffix = number === 1 ? "ye" : "y\xe8m";
    return number + suffix;
};
var $fecb82db95a4e259$var$localize = {
    ordinalNumber: $fecb82db95a4e259$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $fecb82db95a4e259$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $fecb82db95a4e259$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $fecb82db95a4e259$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $fecb82db95a4e259$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $fecb82db95a4e259$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};
var $fecb82db95a4e259$export$2e2bcd8739ae039 = $fecb82db95a4e259$var$localize;

});

parcelRegister("bFnoJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $87e5ac67931cc9eb$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $87e5ac67931cc9eb$var$matchOrdinalNumberPattern = /^(\d+)(ye|yèm)?/i;
var $87e5ac67931cc9eb$var$parseOrdinalNumberPattern = /\d+/i;
var $87e5ac67931cc9eb$var$matchEraPatterns = {
    narrow: /^(av\.J\.K|ap\.J\.K|ap\.J\.-K)/i,
    abbreviated: /^(av\.J\.-K|av\.J-K|apr\.J\.-K|apr\.J-K|ap\.J-K)/i,
    wide: /^(avan Jezi Kris|apre Jezi Kris)/i
};
var $87e5ac67931cc9eb$var$parseEraPatterns = {
    any: [
        /^av/i,
        /^ap/i
    ]
};
var $87e5ac67931cc9eb$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^t[1234]/i,
    wide: /^[1234](ye|yèm)? trimès/i
};
var $87e5ac67931cc9eb$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $87e5ac67931cc9eb$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv|fevr|mas|avr|me|jen|jiyè|out|sept|okt|nov|des)\.?/i,
    wide: /^(janvye|fevrye|mas|avril|me|jen|jiyè|out|septanm|oktòb|novanm|desanm)/i
};
var $87e5ac67931cc9eb$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^o/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^ma/i,
        /^av/i,
        /^me/i,
        /^je/i,
        /^ji/i,
        /^ou/i,
        /^s/i,
        /^ok/i,
        /^n/i,
        /^d/i
    ]
};
var $87e5ac67931cc9eb$var$matchDayPatterns = {
    narrow: /^[lmjvsd]/i,
    short: /^(di|le|ma|me|je|va|sa)/i,
    abbreviated: /^(dim|len|mad|mèk|jed|van|sam)\.?/i,
    wide: /^(dimanch|lendi|madi|mèkredi|jedi|vandredi|samdi)/i
};
var $87e5ac67931cc9eb$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^di/i,
        /^le/i,
        /^ma/i,
        /^mè/i,
        /^je/i,
        /^va/i,
        /^sa/i
    ]
};
var $87e5ac67931cc9eb$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|minwit|midi|mat\.?|ap\.?m\.?|swa)/i,
    any: /^([ap]\.?\s?m\.?|nan maten|nan aprèmidi|nan aswè)/i
};
var $87e5ac67931cc9eb$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^min/i,
        noon: /^mid/i,
        morning: /mat/i,
        afternoon: /ap/i,
        evening: /sw/i,
        night: /nwit/i
    }
};
var $87e5ac67931cc9eb$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $87e5ac67931cc9eb$var$matchOrdinalNumberPattern,
        parsePattern: $87e5ac67931cc9eb$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $87e5ac67931cc9eb$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $87e5ac67931cc9eb$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $87e5ac67931cc9eb$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $87e5ac67931cc9eb$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $87e5ac67931cc9eb$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $87e5ac67931cc9eb$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $87e5ac67931cc9eb$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $87e5ac67931cc9eb$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $87e5ac67931cc9eb$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $87e5ac67931cc9eb$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $87e5ac67931cc9eb$export$2e2bcd8739ae039 = $87e5ac67931cc9eb$var$match;

});


parcelRegister("8dm7T", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fb0b371eb8d801e$export$2e2bcd8739ae039);

var $drSoU = parcelRequire("drSoU");

var $eHd9v = parcelRequire("eHd9v");

var $hZKeH = parcelRequire("hZKeH");

var $8bYUV = parcelRequire("8bYUV");

var $czIrA = parcelRequire("czIrA");
/**
 * @type {Locale}
 * @category Locales
 * @summary Hungarian locale.
 * @language Hungarian
 * @iso-639-2 hun
 * @author Pavlo Shpak [@pshpak]{@link https://github.com/pshpak}
 * @author Eduardo Pardo [@eduardopsll]{@link https://github.com/eduardopsll}
 * @author Zoltan Szepesi [@twodcube]{@link https://github.com/twodcube}
 */ var $5fb0b371eb8d801e$var$locale = {
    code: "hu",
    formatDistance: (0, $drSoU.default),
    formatLong: (0, $eHd9v.default),
    formatRelative: (0, $hZKeH.default),
    localize: (0, $8bYUV.default),
    match: (0, $czIrA.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $5fb0b371eb8d801e$export$2e2bcd8739ae039 = $5fb0b371eb8d801e$var$locale;

});
parcelRegister("drSoU", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ca7fed5a97834ce$export$2e2bcd8739ae039);
var $9ca7fed5a97834ce$var$translations = {
    about: "k\xf6r\xfclbel\xfcl",
    over: "t\xf6bb mint",
    almost: "majdnem",
    lessthan: "kevesebb mint"
};
var $9ca7fed5a97834ce$var$withoutSuffixes = {
    xseconds: " m\xe1sodperc",
    halfaminute: "f\xe9l perc",
    xminutes: " perc",
    xhours: " \xf3ra",
    xdays: " nap",
    xweeks: " h\xe9t",
    xmonths: " h\xf3nap",
    xyears: " \xe9v"
};
var $9ca7fed5a97834ce$var$withSuffixes = {
    xseconds: {
        "-1": " m\xe1sodperccel ezel\u0151tt",
        "1": " m\xe1sodperc m\xfalva",
        "0": " m\xe1sodperce"
    },
    halfaminute: {
        "-1": "f\xe9l perccel ezel\u0151tt",
        "1": "f\xe9l perc m\xfalva",
        "0": "f\xe9l perce"
    },
    xminutes: {
        "-1": " perccel ezel\u0151tt",
        "1": " perc m\xfalva",
        "0": " perce"
    },
    xhours: {
        "-1": " \xf3r\xe1val ezel\u0151tt",
        "1": " \xf3ra m\xfalva",
        "0": " \xf3r\xe1ja"
    },
    xdays: {
        "-1": " nappal ezel\u0151tt",
        "1": " nap m\xfalva",
        "0": " napja"
    },
    xweeks: {
        "-1": " h\xe9ttel ezel\u0151tt",
        "1": " h\xe9t m\xfalva",
        "0": " hete"
    },
    xmonths: {
        "-1": " h\xf3nappal ezel\u0151tt",
        "1": " h\xf3nap m\xfalva",
        "0": " h\xf3napja"
    },
    xyears: {
        "-1": " \xe9vvel ezel\u0151tt",
        "1": " \xe9v m\xfalva",
        "0": " \xe9ve"
    }
};
var $9ca7fed5a97834ce$var$formatDistance = function formatDistance(token, count, options) {
    var adverb = token.match(/about|over|almost|lessthan/i);
    var unit = adverb ? token.replace(adverb[0], "") : token;
    var addSuffix = (options === null || options === void 0 ? void 0 : options.addSuffix) === true;
    var key = unit.toLowerCase();
    var comparison = (options === null || options === void 0 ? void 0 : options.comparison) || 0;
    var translated = addSuffix ? $9ca7fed5a97834ce$var$withSuffixes[key][comparison] : $9ca7fed5a97834ce$var$withoutSuffixes[key];
    var result = key === "halfaminute" ? translated : count + translated;
    if (adverb) {
        var adv = adverb[0].toLowerCase();
        result = $9ca7fed5a97834ce$var$translations[adv] + " " + result;
    }
    return result;
};
var $9ca7fed5a97834ce$export$2e2bcd8739ae039 = $9ca7fed5a97834ce$var$formatDistance;

});

parcelRegister("eHd9v", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab2f489bc0ef151e$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $ab2f489bc0ef151e$var$dateFormats = {
    full: "y. MMMM d., EEEE",
    long: "y. MMMM d.",
    medium: "y. MMM d.",
    short: "y. MM. dd."
};
var $ab2f489bc0ef151e$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
var $ab2f489bc0ef151e$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $ab2f489bc0ef151e$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $ab2f489bc0ef151e$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $ab2f489bc0ef151e$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $ab2f489bc0ef151e$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $ab2f489bc0ef151e$export$2e2bcd8739ae039 = $ab2f489bc0ef151e$var$formatLong;

});

parcelRegister("hZKeH", function(module, exports) {

$parcel$export(module.exports, "default", () => $d19bffac1dec8aa1$export$2e2bcd8739ae039);
var $d19bffac1dec8aa1$var$accusativeWeekdays = [
    "vas\xe1rnap",
    "h\xe9tf\u0151n",
    "kedden",
    "szerd\xe1n",
    "cs\xfct\xf6rt\xf6k\xf6n",
    "p\xe9nteken",
    "szombaton"
];
function $d19bffac1dec8aa1$var$week(isFuture) {
    return function(date) {
        var weekday = $d19bffac1dec8aa1$var$accusativeWeekdays[date.getUTCDay()];
        var prefix = isFuture ? "" : "'m\xfalt' ";
        return "".concat(prefix, "'").concat(weekday, "' p'-kor'");
    };
}
var $d19bffac1dec8aa1$var$formatRelativeLocale = {
    lastWeek: $d19bffac1dec8aa1$var$week(false),
    yesterday: "'tegnap' p'-kor'",
    today: "'ma' p'-kor'",
    tomorrow: "'holnap' p'-kor'",
    nextWeek: $d19bffac1dec8aa1$var$week(true),
    other: "P"
};
var $d19bffac1dec8aa1$var$formatRelative = function formatRelative(token, date) {
    var format = $d19bffac1dec8aa1$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
var $d19bffac1dec8aa1$export$2e2bcd8739ae039 = $d19bffac1dec8aa1$var$formatRelative;

});

parcelRegister("8bYUV", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f6e9aaf5497b4a7$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $5f6e9aaf5497b4a7$var$eraValues = {
    narrow: [
        "ie.",
        "isz."
    ],
    abbreviated: [
        "i. e.",
        "i. sz."
    ],
    wide: [
        "Krisztus el\u0151tt",
        "id\u0151sz\xe1m\xedt\xe1sunk szerint"
    ]
};
var $5f6e9aaf5497b4a7$var$quarterValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4."
    ],
    abbreviated: [
        "1. n.\xe9v",
        "2. n.\xe9v",
        "3. n.\xe9v",
        "4. n.\xe9v"
    ],
    wide: [
        "1. negyed\xe9v",
        "2. negyed\xe9v",
        "3. negyed\xe9v",
        "4. negyed\xe9v"
    ]
};
var $5f6e9aaf5497b4a7$var$formattingQuarterValues = {
    narrow: [
        "I.",
        "II.",
        "III.",
        "IV."
    ],
    abbreviated: [
        "I. n.\xe9v",
        "II. n.\xe9v",
        "III. n.\xe9v",
        "IV. n.\xe9v"
    ],
    wide: [
        "I. negyed\xe9v",
        "II. negyed\xe9v",
        "III. negyed\xe9v",
        "IV. negyed\xe9v"
    ]
};
var $5f6e9aaf5497b4a7$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "\xc1",
        "M",
        "J",
        "J",
        "A",
        "Sz",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jan.",
        "febr.",
        "m\xe1rc.",
        "\xe1pr.",
        "m\xe1j.",
        "j\xfan.",
        "j\xfal.",
        "aug.",
        "szept.",
        "okt.",
        "nov.",
        "dec."
    ],
    wide: [
        "janu\xe1r",
        "febru\xe1r",
        "m\xe1rcius",
        "\xe1prilis",
        "m\xe1jus",
        "j\xfanius",
        "j\xfalius",
        "augusztus",
        "szeptember",
        "okt\xf3ber",
        "november",
        "december"
    ]
};
var $5f6e9aaf5497b4a7$var$dayValues = {
    narrow: [
        "V",
        "H",
        "K",
        "Sz",
        "Cs",
        "P",
        "Sz"
    ],
    short: [
        "V",
        "H",
        "K",
        "Sze",
        "Cs",
        "P",
        "Szo"
    ],
    abbreviated: [
        "V",
        "H",
        "K",
        "Sze",
        "Cs",
        "P",
        "Szo"
    ],
    wide: [
        "vas\xe1rnap",
        "h\xe9tf\u0151",
        "kedd",
        "szerda",
        "cs\xfct\xf6rt\xf6k",
        "p\xe9ntek",
        "szombat"
    ]
};
var $5f6e9aaf5497b4a7$var$dayPeriodValues = {
    narrow: {
        am: "de.",
        pm: "du.",
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: "reggel",
        afternoon: "du.",
        evening: "este",
        night: "\xe9jjel"
    },
    abbreviated: {
        am: "de.",
        pm: "du.",
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: "reggel",
        afternoon: "du.",
        evening: "este",
        night: "\xe9jjel"
    },
    wide: {
        am: "de.",
        pm: "du.",
        midnight: "\xe9jf\xe9l",
        noon: "d\xe9l",
        morning: "reggel",
        afternoon: "d\xe9lut\xe1n",
        evening: "este",
        night: "\xe9jjel"
    }
};
var $5f6e9aaf5497b4a7$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + ".";
};
var $5f6e9aaf5497b4a7$var$localize = {
    ordinalNumber: $5f6e9aaf5497b4a7$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $5f6e9aaf5497b4a7$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $5f6e9aaf5497b4a7$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        },
        formattingValues: $5f6e9aaf5497b4a7$var$formattingQuarterValues,
        defaultFormattingWidth: "wide"
    }),
    month: (0, $kp3bq.default)({
        values: $5f6e9aaf5497b4a7$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $5f6e9aaf5497b4a7$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $5f6e9aaf5497b4a7$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};
var $5f6e9aaf5497b4a7$export$2e2bcd8739ae039 = $5f6e9aaf5497b4a7$var$localize;

});

parcelRegister("czIrA", function(module, exports) {

$parcel$export(module.exports, "default", () => $927b3a9196cb97ec$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $927b3a9196cb97ec$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
var $927b3a9196cb97ec$var$parseOrdinalNumberPattern = /\d+/i;
var $927b3a9196cb97ec$var$matchEraPatterns = {
    narrow: /^(ie\.|isz\.)/i,
    abbreviated: /^(i\.\s?e\.?|b?\s?c\s?e|i\.\s?sz\.?)/i,
    wide: /^(Krisztus előtt|időszámításunk előtt|időszámításunk szerint|i\. sz\.)/i
};
var $927b3a9196cb97ec$var$parseEraPatterns = {
    narrow: [
        /ie/i,
        /isz/i
    ],
    abbreviated: [
        /^(i\.?\s?e\.?|b\s?ce)/i,
        /^(i\.?\s?sz\.?|c\s?e)/i
    ],
    any: [
        /előtt/i,
        /(szerint|i. sz.)/i
    ]
};
var $927b3a9196cb97ec$var$matchQuarterPatterns = {
    narrow: /^[1234]\.?/i,
    abbreviated: /^[1234]?\.?\s?n\.év/i,
    wide: /^([1234]|I|II|III|IV)?\.?\s?negyedév/i
};
var $927b3a9196cb97ec$var$parseQuarterPatterns = {
    any: [
        /1|I$/i,
        /2|II$/i,
        /3|III/i,
        /4|IV/i
    ]
};
var $927b3a9196cb97ec$var$matchMonthPatterns = {
    narrow: /^[jfmaásond]|sz/i,
    abbreviated: /^(jan\.?|febr\.?|márc\.?|ápr\.?|máj\.?|jún\.?|júl\.?|aug\.?|szept\.?|okt\.?|nov\.?|dec\.?)/i,
    wide: /^(január|február|március|április|május|június|július|augusztus|szeptember|október|november|december)/i
};
var $927b3a9196cb97ec$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a|á/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s|sz/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^már/i,
        /^áp/i,
        /^máj/i,
        /^jún/i,
        /^júl/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $927b3a9196cb97ec$var$matchDayPatterns = {
    narrow: /^([vhkpc]|sz|cs|sz)/i,
    short: /^([vhkp]|sze|cs|szo)/i,
    abbreviated: /^([vhkp]|sze|cs|szo)/i,
    wide: /^(vasárnap|hétfő|kedd|szerda|csütörtök|péntek|szombat)/i
};
var $927b3a9196cb97ec$var$parseDayPatterns = {
    narrow: [
        /^v/i,
        /^h/i,
        /^k/i,
        /^sz/i,
        /^c/i,
        /^p/i,
        /^sz/i
    ],
    any: [
        /^v/i,
        /^h/i,
        /^k/i,
        /^sze/i,
        /^c/i,
        /^p/i,
        /^szo/i
    ]
};
var $927b3a9196cb97ec$var$matchDayPeriodPatterns = {
    any: /^((de|du)\.?|éjfél|délután|dél|reggel|este|éjjel)/i
};
var $927b3a9196cb97ec$var$parseDayPeriodPatterns = {
    any: {
        am: /^de\.?/i,
        pm: /^du\.?/i,
        midnight: /^éjf/i,
        noon: /^dé/i,
        morning: /reg/i,
        afternoon: /^délu\.?/i,
        evening: /es/i,
        night: /éjj/i
    }
};
var $927b3a9196cb97ec$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $927b3a9196cb97ec$var$matchOrdinalNumberPattern,
        parsePattern: $927b3a9196cb97ec$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $927b3a9196cb97ec$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $927b3a9196cb97ec$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $927b3a9196cb97ec$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $927b3a9196cb97ec$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $927b3a9196cb97ec$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $927b3a9196cb97ec$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $927b3a9196cb97ec$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $927b3a9196cb97ec$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $927b3a9196cb97ec$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $927b3a9196cb97ec$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $927b3a9196cb97ec$export$2e2bcd8739ae039 = $927b3a9196cb97ec$var$match;

});


parcelRegister("iHvZ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9d50da1b5132ba7$export$2e2bcd8739ae039);

var $czJHw = parcelRequire("czJHw");

var $7is5m = parcelRequire("7is5m");

var $4Ubcq = parcelRequire("4Ubcq");

var $gTJZ7 = parcelRequire("gTJZ7");

var $1i0AT = parcelRequire("1i0AT");
/**
 * @type {Locale}
 * @category Locales
 * @summary Armenian locale
 * @language Armenian
 * @iso-639-2 arm
 * @author Alex Igityan [@alexigityan]{@link https://github.com/alexigityan}
 */ var $d9d50da1b5132ba7$var$locale = {
    code: "hy",
    formatDistance: (0, $czJHw.default),
    formatLong: (0, $7is5m.default),
    formatRelative: (0, $4Ubcq.default),
    localize: (0, $gTJZ7.default),
    match: (0, $1i0AT.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $d9d50da1b5132ba7$export$2e2bcd8739ae039 = $d9d50da1b5132ba7$var$locale;

});
parcelRegister("czJHw", function(module, exports) {

$parcel$export(module.exports, "default", () => $927c34295c08cb1e$export$2e2bcd8739ae039);
var $927c34295c08cb1e$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 1 \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576",
        other: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 {{count}} \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576"
    },
    xSeconds: {
        one: "1 \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576",
        other: "{{count}} \u057E\u0561\u0575\u0580\u056F\u0575\u0561\u0576"
    },
    halfAMinute: "\u056F\u0565\u057D \u0580\u0578\u057A\u0565",
    lessThanXMinutes: {
        one: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 1 \u0580\u0578\u057A\u0565",
        other: "\u0561\u057E\u0565\u056C\u056B \u0584\u056B\u0579 \u0584\u0561\u0576 {{count}} \u0580\u0578\u057A\u0565"
    },
    xMinutes: {
        one: "1 \u0580\u0578\u057A\u0565",
        other: "{{count}} \u0580\u0578\u057A\u0565"
    },
    aboutXHours: {
        one: "\u0574\u0578\u057F 1 \u056A\u0561\u0574",
        other: "\u0574\u0578\u057F {{count}} \u056A\u0561\u0574"
    },
    xHours: {
        one: "1 \u056A\u0561\u0574",
        other: "{{count}} \u056A\u0561\u0574"
    },
    xDays: {
        one: "1 \u0585\u0580",
        other: "{{count}} \u0585\u0580"
    },
    aboutXWeeks: {
        one: "\u0574\u0578\u057F 1 \u0577\u0561\u0562\u0561\u0569",
        other: "\u0574\u0578\u057F {{count}} \u0577\u0561\u0562\u0561\u0569"
    },
    xWeeks: {
        one: "1 \u0577\u0561\u0562\u0561\u0569",
        other: "{{count}} \u0577\u0561\u0562\u0561\u0569"
    },
    aboutXMonths: {
        one: "\u0574\u0578\u057F 1 \u0561\u0574\u056B\u057D",
        other: "\u0574\u0578\u057F {{count}} \u0561\u0574\u056B\u057D"
    },
    xMonths: {
        one: "1 \u0561\u0574\u056B\u057D",
        other: "{{count}} \u0561\u0574\u056B\u057D"
    },
    aboutXYears: {
        one: "\u0574\u0578\u057F 1 \u057F\u0561\u0580\u056B",
        other: "\u0574\u0578\u057F {{count}} \u057F\u0561\u0580\u056B"
    },
    xYears: {
        one: "1 \u057F\u0561\u0580\u056B",
        other: "{{count}} \u057F\u0561\u0580\u056B"
    },
    overXYears: {
        one: "\u0561\u057E\u0565\u056C\u056B \u0584\u0561\u0576 1 \u057F\u0561\u0580\u056B",
        other: "\u0561\u057E\u0565\u056C\u056B \u0584\u0561\u0576 {{count}} \u057F\u0561\u0580\u056B"
    },
    almostXYears: {
        one: "\u0570\u0561\u0574\u0561\u0580\u0575\u0561 1 \u057F\u0561\u0580\u056B",
        other: "\u0570\u0561\u0574\u0561\u0580\u0575\u0561 {{count}} \u057F\u0561\u0580\u056B"
    }
};
var $927c34295c08cb1e$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $927c34295c08cb1e$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " \u0570\u0565\u057F\u0578";
        else return result + " \u0561\u057C\u0561\u057B";
    }
    return result;
};
var $927c34295c08cb1e$export$2e2bcd8739ae039 = $927c34295c08cb1e$var$formatDistance;

});

parcelRegister("7is5m", function(module, exports) {

$parcel$export(module.exports, "default", () => $5500000d57cb8463$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $5500000d57cb8463$var$dateFormats = {
    full: "d MMMM, y, EEEE",
    long: "d MMMM, y",
    medium: "d MMM, y",
    short: "dd.MM.yyyy"
};
var $5500000d57cb8463$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $5500000d57cb8463$var$dateTimeFormats = {
    full: "{{date}} '\u056A\u2024'{{time}}",
    long: "{{date}} '\u056A\u2024'{{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $5500000d57cb8463$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $5500000d57cb8463$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $5500000d57cb8463$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $5500000d57cb8463$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $5500000d57cb8463$export$2e2bcd8739ae039 = $5500000d57cb8463$var$formatLong;

});

parcelRegister("4Ubcq", function(module, exports) {

$parcel$export(module.exports, "default", () => $39251454f9e87811$export$2e2bcd8739ae039);
var $39251454f9e87811$var$formatRelativeLocale = {
    lastWeek: "'\u0576\u0561\u056D\u0578\u0580\u0564' eeee p'\u058A\u056B\u0576'",
    yesterday: "'\u0565\u0580\u0565\u056F' p'\u058A\u056B\u0576'",
    today: "'\u0561\u0575\u057D\u0585\u0580' p'\u058A\u056B\u0576'",
    tomorrow: "'\u057E\u0561\u0572\u0568' p'\u058A\u056B\u0576'",
    nextWeek: "'\u0570\u0561\u057B\u0578\u0580\u0564' eeee p'\u058A\u056B\u0576'",
    other: "P"
};
var $39251454f9e87811$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $39251454f9e87811$var$formatRelativeLocale[token];
};
var $39251454f9e87811$export$2e2bcd8739ae039 = $39251454f9e87811$var$formatRelative;

});

parcelRegister("gTJZ7", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4d57404a1ec9095$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $c4d57404a1ec9095$var$eraValues = {
    narrow: [
        "\u0554",
        "\u0544"
    ],
    abbreviated: [
        "\u0554\u0531",
        "\u0544\u0539"
    ],
    wide: [
        "\u0554\u0580\u056B\u057D\u057F\u0578\u057D\u056B\u0581 \u0561\u057C\u0561\u057B",
        "\u0544\u0565\u0580 \u0569\u057E\u0561\u0580\u056F\u0578\u0582\u0569\u0575\u0561\u0576"
    ]
};
var $c4d57404a1ec9095$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u05541",
        "\u05542",
        "\u05543",
        "\u05544"
    ],
    wide: [
        "1\u058A\u056B\u0576 \u0584\u0561\u057C\u0578\u0580\u0564",
        "2\u058A\u0580\u0564 \u0584\u0561\u057C\u0578\u0580\u0564",
        "3\u058A\u0580\u0564 \u0584\u0561\u057C\u0578\u0580\u0564",
        "4\u058A\u0580\u0564 \u0584\u0561\u057C\u0578\u0580\u0564"
    ]
};
var $c4d57404a1ec9095$var$monthValues = {
    narrow: [
        "\u0540",
        "\u0553",
        "\u0544",
        "\u0531",
        "\u0544",
        "\u0540",
        "\u0540",
        "\u0555",
        "\u054D",
        "\u0540",
        "\u0546",
        "\u0534"
    ],
    abbreviated: [
        "\u0570\u0578\u0582\u0576",
        "\u0583\u0565\u057F",
        "\u0574\u0561\u0580",
        "\u0561\u057A\u0580",
        "\u0574\u0561\u0575",
        "\u0570\u0578\u0582\u0576",
        "\u0570\u0578\u0582\u056C",
        "\u0585\u0563\u057D",
        "\u057D\u0565\u057A",
        "\u0570\u0578\u056F",
        "\u0576\u0578\u0575",
        "\u0564\u0565\u056F"
    ],
    wide: [
        "\u0570\u0578\u0582\u0576\u057E\u0561\u0580",
        "\u0583\u0565\u057F\u0580\u057E\u0561\u0580",
        "\u0574\u0561\u0580\u057F",
        "\u0561\u057A\u0580\u056B\u056C",
        "\u0574\u0561\u0575\u056B\u057D",
        "\u0570\u0578\u0582\u0576\u056B\u057D",
        "\u0570\u0578\u0582\u056C\u056B\u057D",
        "\u0585\u0563\u0578\u057D\u057F\u0578\u057D",
        "\u057D\u0565\u057A\u057F\u0565\u0574\u0562\u0565\u0580",
        "\u0570\u0578\u056F\u057F\u0565\u0574\u0562\u0565\u0580",
        "\u0576\u0578\u0575\u0565\u0574\u0562\u0565\u0580",
        "\u0564\u0565\u056F\u057F\u0565\u0574\u0562\u0565\u0580"
    ]
};
var $c4d57404a1ec9095$var$dayValues = {
    narrow: [
        "\u053F",
        "\u0535",
        "\u0535",
        "\u0549",
        "\u0540",
        "\u0548",
        "\u0547"
    ],
    short: [
        "\u056F\u0580",
        "\u0565\u0580",
        "\u0565\u0584",
        "\u0579\u0584",
        "\u0570\u0563",
        "\u0578\u0582\u0580",
        "\u0577\u0562"
    ],
    abbreviated: [
        "\u056F\u056B\u0580",
        "\u0565\u0580\u056F",
        "\u0565\u0580\u0584",
        "\u0579\u0578\u0580",
        "\u0570\u0576\u0563",
        "\u0578\u0582\u0580\u0562",
        "\u0577\u0561\u0562"
    ],
    wide: [
        "\u056F\u056B\u0580\u0561\u056F\u056B",
        "\u0565\u0580\u056F\u0578\u0582\u0577\u0561\u0562\u0569\u056B",
        "\u0565\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056B",
        "\u0579\u0578\u0580\u0565\u0584\u0577\u0561\u0562\u0569\u056B",
        "\u0570\u056B\u0576\u0563\u0577\u0561\u0562\u0569\u056B",
        "\u0578\u0582\u0580\u0562\u0561\u0569",
        "\u0577\u0561\u0562\u0561\u0569"
    ]
};
var $c4d57404a1ec9095$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "\u056F\u0565\u057D\u0563\u0577",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F",
        afternoon: "\u0581\u0565\u0580\u0565\u056F",
        evening: "\u0565\u0580\u0565\u056F\u0578",
        night: "\u0563\u056B\u0577\u0565\u0580"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F",
        afternoon: "\u0581\u0565\u0580\u0565\u056F",
        evening: "\u0565\u0580\u0565\u056F\u0578",
        night: "\u0563\u056B\u0577\u0565\u0580"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F",
        afternoon: "\u0581\u0565\u0580\u0565\u056F",
        evening: "\u0565\u0580\u0565\u056F\u0578",
        night: "\u0563\u056B\u0577\u0565\u0580"
    }
};
var $c4d57404a1ec9095$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "\u056F\u0565\u057D\u0563\u0577",
        noon: "\u056F\u0565\u057D\u0585\u0580",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F\u0568",
        afternoon: "\u0581\u0565\u0580\u0565\u056F\u0568",
        evening: "\u0565\u0580\u0565\u056F\u0578\u0575\u0561\u0576",
        night: "\u0563\u056B\u0577\u0565\u0580\u0568"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580\u056B\u0576",
        noon: "\u056F\u0565\u057D\u0585\u0580\u056B\u0576",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F\u0568",
        afternoon: "\u0581\u0565\u0580\u0565\u056F\u0568",
        evening: "\u0565\u0580\u0565\u056F\u0578\u0575\u0561\u0576",
        night: "\u0563\u056B\u0577\u0565\u0580\u0568"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "\u056F\u0565\u057D\u0563\u056B\u0577\u0565\u0580\u056B\u0576",
        noon: "\u056F\u0565\u057D\u0585\u0580\u056B\u0576",
        morning: "\u0561\u057C\u0561\u057E\u0578\u057F\u0568",
        afternoon: "\u0581\u0565\u0580\u0565\u056F\u0568",
        evening: "\u0565\u0580\u0565\u056F\u0578\u0575\u0561\u0576",
        night: "\u0563\u056B\u0577\u0565\u0580\u0568"
    }
};
var $c4d57404a1ec9095$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 < 10) {
        if (rem100 % 10 === 1) return number + "\u058A\u056B\u0576";
    }
    return number + "\u058A\u0580\u0564";
};
var $c4d57404a1ec9095$var$localize = {
    ordinalNumber: $c4d57404a1ec9095$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $c4d57404a1ec9095$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $c4d57404a1ec9095$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $c4d57404a1ec9095$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $c4d57404a1ec9095$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $c4d57404a1ec9095$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $c4d57404a1ec9095$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $c4d57404a1ec9095$export$2e2bcd8739ae039 = $c4d57404a1ec9095$var$localize;

});

parcelRegister("1i0AT", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f07eed502337f33$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $0f07eed502337f33$var$matchOrdinalNumberPattern = /^(\d+)((-|֊)?(ին|րդ))?/i;
var $0f07eed502337f33$var$parseOrdinalNumberPattern = /\d+/i;
var $0f07eed502337f33$var$matchEraPatterns = {
    narrow: /^(Ք|Մ)/i,
    abbreviated: /^(Ք\.?\s?Ա\.?|Մ\.?\s?Թ\.?\s?Ա\.?|Մ\.?\s?Թ\.?|Ք\.?\s?Հ\.?)/i,
    wide: /^(քրիստոսից առաջ|մեր թվարկությունից առաջ|մեր թվարկության|քրիստոսից հետո)/i
};
var $0f07eed502337f33$var$parseEraPatterns = {
    any: [
        /^ք/i,
        /^մ/i
    ]
};
var $0f07eed502337f33$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ք[1234]/i,
    wide: /^[1234]((-|֊)?(ին|րդ)) քառորդ/i
};
var $0f07eed502337f33$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $0f07eed502337f33$var$matchMonthPatterns = {
    narrow: /^[հփմաօսնդ]/i,
    abbreviated: /^(հուն|փետ|մար|ապր|մայ|հուն|հուլ|օգս|սեպ|հոկ|նոյ|դեկ)/i,
    wide: /^(հունվար|փետրվար|մարտ|ապրիլ|մայիս|հունիս|հուլիս|օգոստոս|սեպտեմբեր|հոկտեմբեր|նոյեմբեր|դեկտեմբեր)/i
};
var $0f07eed502337f33$var$parseMonthPatterns = {
    narrow: [
        /^հ/i,
        /^փ/i,
        /^մ/i,
        /^ա/i,
        /^մ/i,
        /^հ/i,
        /^հ/i,
        /^օ/i,
        /^ս/i,
        /^հ/i,
        /^ն/i,
        /^դ/i
    ],
    any: [
        /^հու/i,
        /^փ/i,
        /^մար/i,
        /^ա/i,
        /^մայ/i,
        /^հուն/i,
        /^հուլ/i,
        /^օ/i,
        /^ս/i,
        /^հոկ/i,
        /^ն/i,
        /^դ/i
    ]
};
var $0f07eed502337f33$var$matchDayPatterns = {
    narrow: /^[եչհոշկ]/i,
    short: /^(կր|եր|եք|չք|հգ|ուր|շբ)/i,
    abbreviated: /^(կիր|երկ|երք|չոր|հնգ|ուրբ|շաբ)/i,
    wide: /^(կիրակի|երկուշաբթի|երեքշաբթի|չորեքշաբթի|հինգշաբթի|ուրբաթ|շաբաթ)/i
};
var $0f07eed502337f33$var$parseDayPatterns = {
    narrow: [
        /^կ/i,
        /^ե/i,
        /^ե/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ],
    short: [
        /^կ/i,
        /^եր/i,
        /^եք/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ],
    abbreviated: [
        /^կ/i,
        /^երկ/i,
        /^երք/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ],
    wide: [
        /^կ/i,
        /^երկ/i,
        /^երե/i,
        /^չ/i,
        /^հ/i,
        /^(ո|Ո)/,
        /^շ/i
    ]
};
var $0f07eed502337f33$var$matchDayPeriodPatterns = {
    narrow: /^([ap]|կեսգշ|կեսօր|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i,
    any: /^([ap]\.?\s?m\.?|կեսգիշեր(ին)?|կեսօր(ին)?|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i
};
var $0f07eed502337f33$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /կեսգիշեր/i,
        noon: /կեսօր/i,
        morning: /առավոտ/i,
        afternoon: /ցերեկ/i,
        evening: /երեկո/i,
        night: /գիշեր/i
    }
};
var $0f07eed502337f33$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $0f07eed502337f33$var$matchOrdinalNumberPattern,
        parsePattern: $0f07eed502337f33$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $0f07eed502337f33$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $0f07eed502337f33$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $0f07eed502337f33$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $0f07eed502337f33$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $0f07eed502337f33$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $0f07eed502337f33$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $0f07eed502337f33$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $0f07eed502337f33$var$parseDayPatterns,
        defaultParseWidth: "wide"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $0f07eed502337f33$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $0f07eed502337f33$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $0f07eed502337f33$export$2e2bcd8739ae039 = $0f07eed502337f33$var$match;

});


parcelRegister("3WIYd", function(module, exports) {

$parcel$export(module.exports, "default", () => $2df9ac0c433da252$export$2e2bcd8739ae039);

var $9Z2sh = parcelRequire("9Z2sh");

var $3vWCQ = parcelRequire("3vWCQ");

var $4XMQn = parcelRequire("4XMQn");

var $cB6KK = parcelRequire("cB6KK");

var $eZyuL = parcelRequire("eZyuL");
/**
 * @type {Locale}
 * @category Locales
 * @summary Indonesian locale.
 * @language Indonesian
 * @iso-639-2 ind
 * @author Rahmat Budiharso [@rbudiharso]{@link https://github.com/rbudiharso}
 * @author Benget Nata [@bentinata]{@link https://github.com/bentinata}
 * @author Budi Irawan [@deerawan]{@link https://github.com/deerawan}
 * @author Try Ajitiono [@imballinst]{@link https://github.com/imballinst}
 */ var $2df9ac0c433da252$var$locale = {
    code: "id",
    formatDistance: (0, $9Z2sh.default),
    formatLong: (0, $3vWCQ.default),
    formatRelative: (0, $4XMQn.default),
    localize: (0, $cB6KK.default),
    match: (0, $eZyuL.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $2df9ac0c433da252$export$2e2bcd8739ae039 = $2df9ac0c433da252$var$locale;

});
parcelRegister("9Z2sh", function(module, exports) {

$parcel$export(module.exports, "default", () => $744bb71f3adb6fcc$export$2e2bcd8739ae039);
var $744bb71f3adb6fcc$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "kurang dari 1 detik",
        other: "kurang dari {{count}} detik"
    },
    xSeconds: {
        one: "1 detik",
        other: "{{count}} detik"
    },
    halfAMinute: "setengah menit",
    lessThanXMinutes: {
        one: "kurang dari 1 menit",
        other: "kurang dari {{count}} menit"
    },
    xMinutes: {
        one: "1 menit",
        other: "{{count}} menit"
    },
    aboutXHours: {
        one: "sekitar 1 jam",
        other: "sekitar {{count}} jam"
    },
    xHours: {
        one: "1 jam",
        other: "{{count}} jam"
    },
    xDays: {
        one: "1 hari",
        other: "{{count}} hari"
    },
    aboutXWeeks: {
        one: "sekitar 1 minggu",
        other: "sekitar {{count}} minggu"
    },
    xWeeks: {
        one: "1 minggu",
        other: "{{count}} minggu"
    },
    aboutXMonths: {
        one: "sekitar 1 bulan",
        other: "sekitar {{count}} bulan"
    },
    xMonths: {
        one: "1 bulan",
        other: "{{count}} bulan"
    },
    aboutXYears: {
        one: "sekitar 1 tahun",
        other: "sekitar {{count}} tahun"
    },
    xYears: {
        one: "1 tahun",
        other: "{{count}} tahun"
    },
    overXYears: {
        one: "lebih dari 1 tahun",
        other: "lebih dari {{count}} tahun"
    },
    almostXYears: {
        one: "hampir 1 tahun",
        other: "hampir {{count}} tahun"
    }
};
var $744bb71f3adb6fcc$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $744bb71f3adb6fcc$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "dalam waktu " + result;
        else return result + " yang lalu";
    }
    return result;
};
var $744bb71f3adb6fcc$export$2e2bcd8739ae039 = $744bb71f3adb6fcc$var$formatDistance;

});

parcelRegister("3vWCQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $28f1be2ba2602e6f$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $28f1be2ba2602e6f$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "d/M/yyyy"
};
var $28f1be2ba2602e6f$var$timeFormats = {
    full: "HH.mm.ss",
    long: "HH.mm.ss",
    medium: "HH.mm",
    short: "HH.mm"
};
var $28f1be2ba2602e6f$var$dateTimeFormats = {
    full: "{{date}} 'pukul' {{time}}",
    long: "{{date}} 'pukul' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $28f1be2ba2602e6f$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $28f1be2ba2602e6f$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $28f1be2ba2602e6f$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $28f1be2ba2602e6f$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $28f1be2ba2602e6f$export$2e2bcd8739ae039 = $28f1be2ba2602e6f$var$formatLong;

});

parcelRegister("4XMQn", function(module, exports) {

$parcel$export(module.exports, "default", () => $39d28f76875f1594$export$2e2bcd8739ae039);
var $39d28f76875f1594$var$formatRelativeLocale = {
    lastWeek: "eeee 'lalu pukul' p",
    yesterday: "'Kemarin pukul' p",
    today: "'Hari ini pukul' p",
    tomorrow: "'Besok pukul' p",
    nextWeek: "eeee 'pukul' p",
    other: "P"
};
var $39d28f76875f1594$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $39d28f76875f1594$var$formatRelativeLocale[token];
};
var $39d28f76875f1594$export$2e2bcd8739ae039 = $39d28f76875f1594$var$formatRelative;

});

parcelRegister("cB6KK", function(module, exports) {

$parcel$export(module.exports, "default", () => $92be2db93a60ce5a$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
// https://www.unicode.org/cldr/charts/32/summary/id.html
var $92be2db93a60ce5a$var$eraValues = {
    narrow: [
        "SM",
        "M"
    ],
    abbreviated: [
        "SM",
        "M"
    ],
    wide: [
        "Sebelum Masehi",
        "Masehi"
    ]
};
var $92be2db93a60ce5a$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "K1",
        "K2",
        "K3",
        "K4"
    ],
    wide: [
        "Kuartal ke-1",
        "Kuartal ke-2",
        "Kuartal ke-3",
        "Kuartal ke-4"
    ]
};
// Note: in Indonesian, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $92be2db93a60ce5a$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "Mei",
        "Jun",
        "Jul",
        "Agt",
        "Sep",
        "Okt",
        "Nov",
        "Des"
    ],
    wide: [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember"
    ]
};
var $92be2db93a60ce5a$var$dayValues = {
    narrow: [
        "M",
        "S",
        "S",
        "R",
        "K",
        "J",
        "S"
    ],
    short: [
        "Min",
        "Sen",
        "Sel",
        "Rab",
        "Kam",
        "Jum",
        "Sab"
    ],
    abbreviated: [
        "Min",
        "Sen",
        "Sel",
        "Rab",
        "Kam",
        "Jum",
        "Sab"
    ],
    wide: [
        "Minggu",
        "Senin",
        "Selasa",
        "Rabu",
        "Kamis",
        "Jumat",
        "Sabtu"
    ]
};
var $92be2db93a60ce5a$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "siang",
        evening: "sore",
        night: "malam"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "siang",
        evening: "sore",
        night: "malam"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "siang",
        evening: "sore",
        night: "malam"
    }
};
var $92be2db93a60ce5a$var$formattingDayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "siang",
        evening: "sore",
        night: "malam"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "siang",
        evening: "sore",
        night: "malam"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "siang",
        evening: "sore",
        night: "malam"
    }
};
var $92be2db93a60ce5a$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    // Can't use "pertama", "kedua" because can't be parsed
    return "ke-" + number;
};
var $92be2db93a60ce5a$var$localize = {
    ordinalNumber: $92be2db93a60ce5a$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $92be2db93a60ce5a$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $92be2db93a60ce5a$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $92be2db93a60ce5a$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $92be2db93a60ce5a$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $92be2db93a60ce5a$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $92be2db93a60ce5a$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $92be2db93a60ce5a$export$2e2bcd8739ae039 = $92be2db93a60ce5a$var$localize;

});

parcelRegister("eZyuL", function(module, exports) {

$parcel$export(module.exports, "default", () => $02d10e891583689d$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $02d10e891583689d$var$matchOrdinalNumberPattern = /^ke-(\d+)?/i;
var $02d10e891583689d$var$parseOrdinalNumberPattern = /\d+/i;
var $02d10e891583689d$var$matchEraPatterns = {
    narrow: /^(sm|m)/i,
    abbreviated: /^(s\.?\s?m\.?|s\.?\s?e\.?\s?u\.?|m\.?|e\.?\s?u\.?)/i,
    wide: /^(sebelum masehi|sebelum era umum|masehi|era umum)/i
};
var $02d10e891583689d$var$parseEraPatterns = {
    any: [
        /^s/i,
        /^(m|e)/i
    ]
};
var $02d10e891583689d$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K-?\s[1234]/i,
    wide: /^Kuartal ke-?\s?[1234]/i
};
var $02d10e891583689d$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $02d10e891583689d$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|mei|jun|jul|agt|sep|okt|nov|des)/i,
    wide: /^(januari|februari|maret|april|mei|juni|juli|agustus|september|oktober|november|desember)/i
};
var $02d10e891583689d$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^ma/i,
        /^ap/i,
        /^me/i,
        /^jun/i,
        /^jul/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $02d10e891583689d$var$matchDayPatterns = {
    narrow: /^[srkjm]/i,
    short: /^(min|sen|sel|rab|kam|jum|sab)/i,
    abbreviated: /^(min|sen|sel|rab|kam|jum|sab)/i,
    wide: /^(minggu|senin|selasa|rabu|kamis|jumat|sabtu)/i
};
var $02d10e891583689d$var$parseDayPatterns = {
    narrow: [
        /^m/i,
        /^s/i,
        /^s/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^s/i
    ],
    any: [
        /^m/i,
        /^sen/i,
        /^sel/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^sa/i
    ]
};
var $02d10e891583689d$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|tengah m|tengah h|(di(\swaktu)?) (pagi|siang|sore|malam))/i,
    any: /^([ap]\.?\s?m\.?|tengah malam|tengah hari|(di(\swaktu)?) (pagi|siang|sore|malam))/i
};
var $02d10e891583689d$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^pm/i,
        midnight: /^tengah m/i,
        noon: /^tengah h/i,
        morning: /pagi/i,
        afternoon: /siang/i,
        evening: /sore/i,
        night: /malam/i
    }
};
var $02d10e891583689d$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $02d10e891583689d$var$matchOrdinalNumberPattern,
        parsePattern: $02d10e891583689d$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $02d10e891583689d$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $02d10e891583689d$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $02d10e891583689d$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $02d10e891583689d$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $02d10e891583689d$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $02d10e891583689d$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $02d10e891583689d$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $02d10e891583689d$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $02d10e891583689d$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $02d10e891583689d$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $02d10e891583689d$export$2e2bcd8739ae039 = $02d10e891583689d$var$match;

});


parcelRegister("aHiNT", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c9c818c6f25e8e7$export$2e2bcd8739ae039);

var $hTwaJ = parcelRequire("hTwaJ");

var $7jYqJ = parcelRequire("7jYqJ");

var $gRLu2 = parcelRequire("gRLu2");

var $bpV2z = parcelRequire("bpV2z");

var $aLvAg = parcelRequire("aLvAg");
/**
 * @type {Locale}
 * @category Locales
 * @summary Icelandic locale.
 * @language Icelandic
 * @iso-639-2 isl
 * @author Derek Blank [@derekblank]{@link https://github.com/derekblank}
 * @author Arnór Ýmir [@lamayg]{@link https://github.com/lamayg}
 */ var $7c9c818c6f25e8e7$var$locale = {
    code: "is",
    formatDistance: (0, $hTwaJ.default),
    formatLong: (0, $7jYqJ.default),
    formatRelative: (0, $gRLu2.default),
    localize: (0, $bpV2z.default),
    match: (0, $aLvAg.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $7c9c818c6f25e8e7$export$2e2bcd8739ae039 = $7c9c818c6f25e8e7$var$locale;

});
parcelRegister("hTwaJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d070877488aebc08$export$2e2bcd8739ae039);
var $d070877488aebc08$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "minna en 1 sek\xfanda",
        other: "minna en {{count}} sek\xfandur"
    },
    xSeconds: {
        one: "1 sek\xfanda",
        other: "{{count}} sek\xfandur"
    },
    halfAMinute: "h\xe1lf m\xedn\xfata",
    lessThanXMinutes: {
        one: "minna en 1 m\xedn\xfata",
        other: "minna en {{count}} m\xedn\xfatur"
    },
    xMinutes: {
        one: "1 m\xedn\xfata",
        other: "{{count}} m\xedn\xfatur"
    },
    aboutXHours: {
        one: "u.\xfe.b. 1 klukkustund",
        other: "u.\xfe.b. {{count}} klukkustundir"
    },
    xHours: {
        one: "1 klukkustund",
        other: "{{count}} klukkustundir"
    },
    xDays: {
        one: "1 dagur",
        other: "{{count}} dagar"
    },
    aboutXWeeks: {
        one: "um viku",
        other: "um {{count}} vikur"
    },
    xWeeks: {
        one: "1 viku",
        other: "{{count}} vikur"
    },
    aboutXMonths: {
        one: "u.\xfe.b. 1 m\xe1nu\xf0ur",
        other: "u.\xfe.b. {{count}} m\xe1nu\xf0ir"
    },
    xMonths: {
        one: "1 m\xe1nu\xf0ur",
        other: "{{count}} m\xe1nu\xf0ir"
    },
    aboutXYears: {
        one: "u.\xfe.b. 1 \xe1r",
        other: "u.\xfe.b. {{count}} \xe1r"
    },
    xYears: {
        one: "1 \xe1r",
        other: "{{count}} \xe1r"
    },
    overXYears: {
        one: "meira en 1 \xe1r",
        other: "meira en {{count}} \xe1r"
    },
    almostXYears: {
        one: "n\xe6stum 1 \xe1r",
        other: "n\xe6stum {{count}} \xe1r"
    }
};
var $d070877488aebc08$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $d070877488aebc08$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\xed " + result;
        else return result + " s\xed\xf0an";
    }
    return result;
};
var $d070877488aebc08$export$2e2bcd8739ae039 = $d070877488aebc08$var$formatDistance;

});

parcelRegister("7jYqJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $55492ee98dae7bc5$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $55492ee98dae7bc5$var$dateFormats = {
    full: "EEEE, do MMMM y",
    long: "do MMMM y",
    medium: "do MMM y",
    short: "d.MM.y"
};
var $55492ee98dae7bc5$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $55492ee98dae7bc5$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $55492ee98dae7bc5$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $55492ee98dae7bc5$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $55492ee98dae7bc5$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $55492ee98dae7bc5$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $55492ee98dae7bc5$export$2e2bcd8739ae039 = $55492ee98dae7bc5$var$formatLong;

});

parcelRegister("gRLu2", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4766dd52149e531$export$2e2bcd8739ae039);
var $c4766dd52149e531$var$formatRelativeLocale = {
    lastWeek: "'s\xed\xf0asta' dddd 'kl.' p",
    yesterday: "'\xed g\xe6r kl.' p",
    today: "'\xed dag kl.' p",
    tomorrow: "'\xe1 morgun kl.' p",
    nextWeek: "dddd 'kl.' p",
    other: "P"
};
var $c4766dd52149e531$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $c4766dd52149e531$var$formatRelativeLocale[token];
};
var $c4766dd52149e531$export$2e2bcd8739ae039 = $c4766dd52149e531$var$formatRelative;

});

parcelRegister("bpV2z", function(module, exports) {

$parcel$export(module.exports, "default", () => $84fe46917b49ccda$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $84fe46917b49ccda$var$eraValues = {
    narrow: [
        "f.Kr.",
        "e.Kr."
    ],
    abbreviated: [
        "f.Kr.",
        "e.Kr."
    ],
    wide: [
        "fyrir Krist",
        "eftir Krist"
    ]
};
var $84fe46917b49ccda$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1F",
        "2F",
        "3F",
        "4F"
    ],
    wide: [
        "1. fj\xf3r\xf0ungur",
        "2. fj\xf3r\xf0ungur",
        "3. fj\xf3r\xf0ungur",
        "4. fj\xf3r\xf0ungur"
    ]
};
var $84fe46917b49ccda$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "\xc1",
        "S",
        "\xd3",
        "N",
        "D"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mars",
        "apr\xedl",
        "ma\xed",
        "j\xfan\xed",
        "j\xfal\xed",
        "\xe1g\xfast",
        "sept.",
        "okt.",
        "n\xf3v.",
        "des."
    ],
    wide: [
        "jan\xfaar",
        "febr\xfaar",
        "mars",
        "apr\xedl",
        "ma\xed",
        "j\xfan\xed",
        "j\xfal\xed",
        "\xe1g\xfast",
        "september",
        "okt\xf3ber",
        "n\xf3vember",
        "desember"
    ]
};
var $84fe46917b49ccda$var$dayValues = {
    narrow: [
        "S",
        "M",
        "\xde",
        "M",
        "F",
        "F",
        "L"
    ],
    short: [
        "Su",
        "M\xe1",
        "\xder",
        "Mi",
        "Fi",
        "F\xf6",
        "La"
    ],
    abbreviated: [
        "sun.",
        "m\xe1n.",
        "\xferi.",
        "mi\xf0.",
        "fim.",
        "f\xf6s.",
        "lau."
    ],
    wide: [
        "sunnudagur",
        "m\xe1nudagur",
        "\xferi\xf0judagur",
        "mi\xf0vikudagur",
        "fimmtudagur",
        "f\xf6studagur",
        "laugardagur"
    ]
};
var $84fe46917b49ccda$var$dayPeriodValues = {
    narrow: {
        am: "f",
        pm: "e",
        midnight: "mi\xf0n\xe6tti",
        noon: "h\xe1degi",
        morning: "morgunn",
        afternoon: "s\xed\xf0degi",
        evening: "kv\xf6ld",
        night: "n\xf3tt"
    },
    abbreviated: {
        am: "f.h.",
        pm: "e.h.",
        midnight: "mi\xf0n\xe6tti",
        noon: "h\xe1degi",
        morning: "morgunn",
        afternoon: "s\xed\xf0degi",
        evening: "kv\xf6ld",
        night: "n\xf3tt"
    },
    wide: {
        am: "fyrir h\xe1degi",
        pm: "eftir h\xe1degi",
        midnight: "mi\xf0n\xe6tti",
        noon: "h\xe1degi",
        morning: "morgunn",
        afternoon: "s\xed\xf0degi",
        evening: "kv\xf6ld",
        night: "n\xf3tt"
    }
};
var $84fe46917b49ccda$var$formattingDayPeriodValues = {
    narrow: {
        am: "f",
        pm: "e",
        midnight: "\xe1 mi\xf0n\xe6tti",
        noon: "\xe1 h\xe1degi",
        morning: "a\xf0 morgni",
        afternoon: "s\xed\xf0degis",
        evening: "um kv\xf6ld",
        night: "um n\xf3tt"
    },
    abbreviated: {
        am: "f.h.",
        pm: "e.h.",
        midnight: "\xe1 mi\xf0n\xe6tti",
        noon: "\xe1 h\xe1degi",
        morning: "a\xf0 morgni",
        afternoon: "s\xed\xf0degis",
        evening: "um kv\xf6ld",
        night: "um n\xf3tt"
    },
    wide: {
        am: "fyrir h\xe1degi",
        pm: "eftir h\xe1degi",
        midnight: "\xe1 mi\xf0n\xe6tti",
        noon: "\xe1 h\xe1degi",
        morning: "a\xf0 morgni",
        afternoon: "s\xed\xf0degis",
        evening: "um kv\xf6ld",
        night: "um n\xf3tt"
    }
};
var $84fe46917b49ccda$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + ".";
};
var $84fe46917b49ccda$var$localize = {
    ordinalNumber: $84fe46917b49ccda$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $84fe46917b49ccda$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $84fe46917b49ccda$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $84fe46917b49ccda$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $84fe46917b49ccda$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $84fe46917b49ccda$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $84fe46917b49ccda$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $84fe46917b49ccda$export$2e2bcd8739ae039 = $84fe46917b49ccda$var$localize;

});

parcelRegister("aLvAg", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d66cb0fcc0862c0$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $7d66cb0fcc0862c0$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var $7d66cb0fcc0862c0$var$parseOrdinalNumberPattern = /\d+(\.)?/i;
var $7d66cb0fcc0862c0$var$matchEraPatterns = {
    narrow: /^(f\.Kr\.|e\.Kr\.)/i,
    abbreviated: /^(f\.Kr\.|e\.Kr\.)/i,
    wide: /^(fyrir Krist|eftir Krist)/i
};
var $7d66cb0fcc0862c0$var$parseEraPatterns = {
    any: [
        /^(f\.Kr\.)/i,
        /^(e\.Kr\.)/i
    ]
};
var $7d66cb0fcc0862c0$var$matchQuarterPatterns = {
    narrow: /^[1234]\.?/i,
    abbreviated: /^q[1234]\.?/i,
    wide: /^[1234]\.? fjórðungur/i
};
var $7d66cb0fcc0862c0$var$parseQuarterPatterns = {
    any: [
        /1\.?/i,
        /2\.?/i,
        /3\.?/i,
        /4\.?/i
    ]
};
var $7d66cb0fcc0862c0$var$matchMonthPatterns = {
    narrow: /^[jfmásónd]/i,
    abbreviated: /^(jan\.|feb\.|mars\.|apríl\.|maí|júní|júlí|águst|sep\.|oct\.|nov\.|dec\.)/i,
    wide: /^(januar|febrúar|mars|apríl|maí|júní|júlí|águst|september|október|nóvember|desember)/i
};
var $7d66cb0fcc0862c0$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^á/i,
        /^s/i,
        /^ó/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maí/i,
        /^jún/i,
        /^júl/i,
        /^áu/i,
        /^s/i,
        /^ó/i,
        /^n/i,
        /^d/i
    ]
};
var $7d66cb0fcc0862c0$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|má|þr|mi|fi|fö|la)/i,
    abbreviated: /^(sun|mán|þri|mið|fim|fös|lau)\.?/i,
    wide: /^(sunnudagur|mánudagur|þriðjudagur|miðvikudagur|fimmtudagur|föstudagur|laugardagur)/i
};
var $7d66cb0fcc0862c0$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^þ/i,
        /^m/i,
        /^f/i,
        /^f/i,
        /^l/i
    ],
    any: [
        /^su/i,
        /^má/i,
        /^þr/i,
        /^mi/i,
        /^fi/i,
        /^fö/i,
        /^la/i
    ]
};
var $7d66cb0fcc0862c0$var$matchDayPeriodPatterns = {
    narrow: /^(f|e|síðdegis|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i,
    any: /^(fyrir hádegi|eftir hádegi|[ef]\.?h\.?|síðdegis|morgunn|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i
};
var $7d66cb0fcc0862c0$var$parseDayPeriodPatterns = {
    any: {
        am: /^f/i,
        pm: /^e/i,
        midnight: /^mi/i,
        noon: /^há/i,
        morning: /morgunn/i,
        afternoon: /síðdegi/i,
        evening: /kvöld/i,
        night: /nótt/i
    }
};
var $7d66cb0fcc0862c0$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $7d66cb0fcc0862c0$var$matchOrdinalNumberPattern,
        parsePattern: $7d66cb0fcc0862c0$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $7d66cb0fcc0862c0$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7d66cb0fcc0862c0$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $7d66cb0fcc0862c0$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7d66cb0fcc0862c0$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $7d66cb0fcc0862c0$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7d66cb0fcc0862c0$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $7d66cb0fcc0862c0$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7d66cb0fcc0862c0$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $7d66cb0fcc0862c0$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $7d66cb0fcc0862c0$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $7d66cb0fcc0862c0$export$2e2bcd8739ae039 = $7d66cb0fcc0862c0$var$match;

});


parcelRegister("7OT21", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b17e40c462da408$export$2e2bcd8739ae039);

var $l8Zzd = parcelRequire("l8Zzd");

var $18kQD = parcelRequire("18kQD");

var $45Kou = parcelRequire("45Kou");

var $bIqOX = parcelRequire("bIqOX");

var $jyQW3 = parcelRequire("jyQW3");
/**
 * @type {Locale}
 * @category Locales
 * @summary Italian locale.
 * @language Italian
 * @iso-639-2 ita
 * @author Alberto Restifo [@albertorestifo]{@link https://github.com/albertorestifo}
 * @author Giovanni Polimeni [@giofilo]{@link https://github.com/giofilo}
 * @author Vincenzo Carrese [@vin-car]{@link https://github.com/vin-car}
 */ var $5b17e40c462da408$var$locale = {
    code: "it",
    formatDistance: (0, $l8Zzd.default),
    formatLong: (0, $18kQD.default),
    formatRelative: (0, $45Kou.default),
    localize: (0, $bIqOX.default),
    match: (0, $jyQW3.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $5b17e40c462da408$export$2e2bcd8739ae039 = $5b17e40c462da408$var$locale;

});
parcelRegister("l8Zzd", function(module, exports) {

$parcel$export(module.exports, "default", () => $f64a1a440cadde1b$export$2e2bcd8739ae039);
var $f64a1a440cadde1b$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "meno di un secondo",
        other: "meno di {{count}} secondi"
    },
    xSeconds: {
        one: "un secondo",
        other: "{{count}} secondi"
    },
    halfAMinute: "alcuni secondi",
    lessThanXMinutes: {
        one: "meno di un minuto",
        other: "meno di {{count}} minuti"
    },
    xMinutes: {
        one: "un minuto",
        other: "{{count}} minuti"
    },
    aboutXHours: {
        one: "circa un'ora",
        other: "circa {{count}} ore"
    },
    xHours: {
        one: "un'ora",
        other: "{{count}} ore"
    },
    xDays: {
        one: "un giorno",
        other: "{{count}} giorni"
    },
    aboutXWeeks: {
        one: "circa una settimana",
        other: "circa {{count}} settimane"
    },
    xWeeks: {
        one: "una settimana",
        other: "{{count}} settimane"
    },
    aboutXMonths: {
        one: "circa un mese",
        other: "circa {{count}} mesi"
    },
    xMonths: {
        one: "un mese",
        other: "{{count}} mesi"
    },
    aboutXYears: {
        one: "circa un anno",
        other: "circa {{count}} anni"
    },
    xYears: {
        one: "un anno",
        other: "{{count}} anni"
    },
    overXYears: {
        one: "pi\xf9 di un anno",
        other: "pi\xf9 di {{count}} anni"
    },
    almostXYears: {
        one: "quasi un anno",
        other: "quasi {{count}} anni"
    }
};
var $f64a1a440cadde1b$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $f64a1a440cadde1b$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "tra " + result;
        else return result + " fa";
    }
    return result;
};
var $f64a1a440cadde1b$export$2e2bcd8739ae039 = $f64a1a440cadde1b$var$formatDistance;

});

parcelRegister("18kQD", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d36b5bf76941157$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $0d36b5bf76941157$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
var $0d36b5bf76941157$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $0d36b5bf76941157$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $0d36b5bf76941157$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $0d36b5bf76941157$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $0d36b5bf76941157$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $0d36b5bf76941157$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $0d36b5bf76941157$export$2e2bcd8739ae039 = $0d36b5bf76941157$var$formatLong;

});

parcelRegister("45Kou", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fab9ded60a2ad50$export$2e2bcd8739ae039);

var $6KZXu = parcelRequire("6KZXu");
var $2fab9ded60a2ad50$var$weekdays = [
    "domenica",
    "luned\xec",
    "marted\xec",
    "mercoled\xec",
    "gioved\xec",
    "venerd\xec",
    "sabato"
];
function $2fab9ded60a2ad50$var$_lastWeek(day) {
    switch(day){
        case 0:
            return "'domenica scorsa alle' p";
        default:
            return "'" + $2fab9ded60a2ad50$var$weekdays[day] + " scorso alle' p";
    }
}
function $2fab9ded60a2ad50$var$thisWeek(day) {
    return "'" + $2fab9ded60a2ad50$var$weekdays[day] + " alle' p";
}
function $2fab9ded60a2ad50$var$_nextWeek(day) {
    switch(day){
        case 0:
            return "'domenica prossima alle' p";
        default:
            return "'" + $2fab9ded60a2ad50$var$weekdays[day] + " prossimo alle' p";
    }
}
var $2fab9ded60a2ad50$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $6KZXu.default)(date, baseDate, options)) return $2fab9ded60a2ad50$var$thisWeek(day);
        else return $2fab9ded60a2ad50$var$_lastWeek(day);
    },
    yesterday: "'ieri alle' p",
    today: "'oggi alle' p",
    tomorrow: "'domani alle' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $6KZXu.default)(date, baseDate, options)) return $2fab9ded60a2ad50$var$thisWeek(day);
        else return $2fab9ded60a2ad50$var$_nextWeek(day);
    },
    other: "P"
};
var $2fab9ded60a2ad50$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $2fab9ded60a2ad50$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
var $2fab9ded60a2ad50$export$2e2bcd8739ae039 = $2fab9ded60a2ad50$var$formatRelative;

});

parcelRegister("bIqOX", function(module, exports) {

$parcel$export(module.exports, "default", () => $88789bd90a171065$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $88789bd90a171065$var$eraValues = {
    narrow: [
        "aC",
        "dC"
    ],
    abbreviated: [
        "a.C.",
        "d.C."
    ],
    wide: [
        "avanti Cristo",
        "dopo Cristo"
    ]
};
var $88789bd90a171065$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var $88789bd90a171065$var$monthValues = {
    narrow: [
        "G",
        "F",
        "M",
        "A",
        "M",
        "G",
        "L",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "gen",
        "feb",
        "mar",
        "apr",
        "mag",
        "giu",
        "lug",
        "ago",
        "set",
        "ott",
        "nov",
        "dic"
    ],
    wide: [
        "gennaio",
        "febbraio",
        "marzo",
        "aprile",
        "maggio",
        "giugno",
        "luglio",
        "agosto",
        "settembre",
        "ottobre",
        "novembre",
        "dicembre"
    ]
};
var $88789bd90a171065$var$dayValues = {
    narrow: [
        "D",
        "L",
        "M",
        "M",
        "G",
        "V",
        "S"
    ],
    short: [
        "dom",
        "lun",
        "mar",
        "mer",
        "gio",
        "ven",
        "sab"
    ],
    abbreviated: [
        "dom",
        "lun",
        "mar",
        "mer",
        "gio",
        "ven",
        "sab"
    ],
    wide: [
        "domenica",
        "luned\xec",
        "marted\xec",
        "mercoled\xec",
        "gioved\xec",
        "venerd\xec",
        "sabato"
    ]
};
var $88789bd90a171065$var$dayPeriodValues = {
    narrow: {
        am: "m.",
        pm: "p.",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "mattina",
        afternoon: "pomeriggio",
        evening: "sera",
        night: "notte"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "mattina",
        afternoon: "pomeriggio",
        evening: "sera",
        night: "notte"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "mattina",
        afternoon: "pomeriggio",
        evening: "sera",
        night: "notte"
    }
};
var $88789bd90a171065$var$formattingDayPeriodValues = {
    narrow: {
        am: "m.",
        pm: "p.",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "di mattina",
        afternoon: "del pomeriggio",
        evening: "di sera",
        night: "di notte"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "di mattina",
        afternoon: "del pomeriggio",
        evening: "di sera",
        night: "di notte"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "mezzanotte",
        noon: "mezzogiorno",
        morning: "di mattina",
        afternoon: "del pomeriggio",
        evening: "di sera",
        night: "di notte"
    }
};
var $88789bd90a171065$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return String(number);
};
var $88789bd90a171065$var$localize = {
    ordinalNumber: $88789bd90a171065$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $88789bd90a171065$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $88789bd90a171065$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $88789bd90a171065$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $88789bd90a171065$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $88789bd90a171065$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $88789bd90a171065$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $88789bd90a171065$export$2e2bcd8739ae039 = $88789bd90a171065$var$localize;

});

parcelRegister("jyQW3", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3da412cc40b6731$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $e3da412cc40b6731$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var $e3da412cc40b6731$var$parseOrdinalNumberPattern = /\d+/i;
var $e3da412cc40b6731$var$matchEraPatterns = {
    narrow: /^(aC|dC)/i,
    abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
    wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
};
var $e3da412cc40b6731$var$parseEraPatterns = {
    any: [
        /^a/i,
        /^(d|e)/i
    ]
};
var $e3da412cc40b6731$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^t[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var $e3da412cc40b6731$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $e3da412cc40b6731$var$matchMonthPatterns = {
    narrow: /^[gfmalsond]/i,
    abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
    wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
};
var $e3da412cc40b6731$var$parseMonthPatterns = {
    narrow: [
        /^g/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^g/i,
        /^l/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ge/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mag/i,
        /^gi/i,
        /^l/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $e3da412cc40b6731$var$matchDayPatterns = {
    narrow: /^[dlmgvs]/i,
    short: /^(do|lu|ma|me|gi|ve|sa)/i,
    abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
    wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
};
var $e3da412cc40b6731$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^g/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^ma/i,
        /^me/i,
        /^g/i,
        /^v/i,
        /^s/i
    ]
};
var $e3da412cc40b6731$var$matchDayPeriodPatterns = {
    narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
    any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
};
var $e3da412cc40b6731$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mezza/i,
        noon: /^mezzo/i,
        morning: /mattina/i,
        afternoon: /pomeriggio/i,
        evening: /sera/i,
        night: /notte/i
    }
};
var $e3da412cc40b6731$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $e3da412cc40b6731$var$matchOrdinalNumberPattern,
        parsePattern: $e3da412cc40b6731$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $e3da412cc40b6731$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e3da412cc40b6731$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $e3da412cc40b6731$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e3da412cc40b6731$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $e3da412cc40b6731$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e3da412cc40b6731$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $e3da412cc40b6731$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e3da412cc40b6731$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $e3da412cc40b6731$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $e3da412cc40b6731$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $e3da412cc40b6731$export$2e2bcd8739ae039 = $e3da412cc40b6731$var$match;

});


parcelRegister("2ykfi", function(module, exports) {

$parcel$export(module.exports, "default", () => $1dbe76227ac6893d$export$2e2bcd8739ae039);

var $l8Zzd = parcelRequire("l8Zzd");

var $45Kou = parcelRequire("45Kou");

var $bIqOX = parcelRequire("bIqOX");

var $jyQW3 = parcelRequire("jyQW3");

var $Serus = parcelRequire("Serus");
/**
 * @type {Locale}
 * @category Locales
 * @summary Italian locale (Switzerland).
 * @language Italian
 * @iso-639-2 ita
 * @author Mike Peyer [@maic66]{@link https://github.com/maic66}
 */ var $1dbe76227ac6893d$var$locale = {
    code: "it-CH",
    formatDistance: (0, $l8Zzd.default),
    formatLong: (0, $Serus.default),
    formatRelative: (0, $45Kou.default),
    localize: (0, $bIqOX.default),
    match: (0, $jyQW3.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $1dbe76227ac6893d$export$2e2bcd8739ae039 = $1dbe76227ac6893d$var$locale;

});
parcelRegister("Serus", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a303f3804dd3127$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $0a303f3804dd3127$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd.MM.y"
};
var $0a303f3804dd3127$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $0a303f3804dd3127$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $0a303f3804dd3127$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $0a303f3804dd3127$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $0a303f3804dd3127$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $0a303f3804dd3127$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $0a303f3804dd3127$export$2e2bcd8739ae039 = $0a303f3804dd3127$var$formatLong;

});


parcelRegister("htvDM", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb8db042b22fd6dd$export$2e2bcd8739ae039);

var $jaVFX = parcelRequire("jaVFX");

var $lpIPC = parcelRequire("lpIPC");

var $cR8GD = parcelRequire("cR8GD");

var $ccNUt = parcelRequire("ccNUt");

var $lOtf7 = parcelRequire("lOtf7");
/**
 * @type {Locale}
 * @category Locales
 * @summary Japanese locale.
 * @language Japanese
 * @iso-639-2 jpn
 * @author Thomas Eilmsteiner [@DeMuu]{@link https://github.com/DeMuu}
 * @author Yamagishi Kazutoshi [@ykzts]{@link https://github.com/ykzts}
 * @author Luca Ban [@mesqueeb]{@link https://github.com/mesqueeb}
 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
 * @author Taiki IKeda [@so99ynoodles]{@link https://github.com/so99ynoodles}
 */ var $cb8db042b22fd6dd$var$locale = {
    code: "ja",
    formatDistance: (0, $jaVFX.default),
    formatLong: (0, $lpIPC.default),
    formatRelative: (0, $cR8GD.default),
    localize: (0, $ccNUt.default),
    match: (0, $lOtf7.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $cb8db042b22fd6dd$export$2e2bcd8739ae039 = $cb8db042b22fd6dd$var$locale;

});
parcelRegister("jaVFX", function(module, exports) {

$parcel$export(module.exports, "default", () => $df5bb0adc4c2cc2a$export$2e2bcd8739ae039);
var $df5bb0adc4c2cc2a$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1\u79D2\u672A\u6E80",
        other: "{{count}}\u79D2\u672A\u6E80",
        oneWithSuffix: "\u7D041\u79D2",
        otherWithSuffix: "\u7D04{{count}}\u79D2"
    },
    xSeconds: {
        one: "1\u79D2",
        other: "{{count}}\u79D2"
    },
    halfAMinute: "30\u79D2",
    lessThanXMinutes: {
        one: "1\u5206\u672A\u6E80",
        other: "{{count}}\u5206\u672A\u6E80",
        oneWithSuffix: "\u7D041\u5206",
        otherWithSuffix: "\u7D04{{count}}\u5206"
    },
    xMinutes: {
        one: "1\u5206",
        other: "{{count}}\u5206"
    },
    aboutXHours: {
        one: "\u7D041\u6642\u9593",
        other: "\u7D04{{count}}\u6642\u9593"
    },
    xHours: {
        one: "1\u6642\u9593",
        other: "{{count}}\u6642\u9593"
    },
    xDays: {
        one: "1\u65E5",
        other: "{{count}}\u65E5"
    },
    aboutXWeeks: {
        one: "\u7D041\u9031\u9593",
        other: "\u7D04{{count}}\u9031\u9593"
    },
    xWeeks: {
        one: "1\u9031\u9593",
        other: "{{count}}\u9031\u9593"
    },
    aboutXMonths: {
        one: "\u7D041\u304B\u6708",
        other: "\u7D04{{count}}\u304B\u6708"
    },
    xMonths: {
        one: "1\u304B\u6708",
        other: "{{count}}\u304B\u6708"
    },
    aboutXYears: {
        one: "\u7D041\u5E74",
        other: "\u7D04{{count}}\u5E74"
    },
    xYears: {
        one: "1\u5E74",
        other: "{{count}}\u5E74"
    },
    overXYears: {
        one: "1\u5E74\u4EE5\u4E0A",
        other: "{{count}}\u5E74\u4EE5\u4E0A"
    },
    almostXYears: {
        one: "1\u5E74\u8FD1\u304F",
        other: "{{count}}\u5E74\u8FD1\u304F"
    }
};
var $df5bb0adc4c2cc2a$var$formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    var result;
    var tokenValue = $df5bb0adc4c2cc2a$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) {
        if (options.addSuffix && tokenValue.oneWithSuffix) result = tokenValue.oneWithSuffix;
        else result = tokenValue.one;
    } else if (options.addSuffix && tokenValue.otherWithSuffix) result = tokenValue.otherWithSuffix.replace("{{count}}", String(count));
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5F8C";
        else return result + "\u524D";
    }
    return result;
};
var $df5bb0adc4c2cc2a$export$2e2bcd8739ae039 = $df5bb0adc4c2cc2a$var$formatDistance;

});

parcelRegister("lpIPC", function(module, exports) {

$parcel$export(module.exports, "default", () => $f96eb5673e85b65e$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $f96eb5673e85b65e$var$dateFormats = {
    full: "y\u5E74M\u6708d\u65E5EEEE",
    long: "y\u5E74M\u6708d\u65E5",
    medium: "y/MM/dd",
    short: "y/MM/dd"
};
var $f96eb5673e85b65e$var$timeFormats = {
    full: "H\u6642mm\u5206ss\u79D2 zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
var $f96eb5673e85b65e$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $f96eb5673e85b65e$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $f96eb5673e85b65e$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $f96eb5673e85b65e$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $f96eb5673e85b65e$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $f96eb5673e85b65e$export$2e2bcd8739ae039 = $f96eb5673e85b65e$var$formatLong;

});

parcelRegister("cR8GD", function(module, exports) {

$parcel$export(module.exports, "default", () => $95c12c4391b49510$export$2e2bcd8739ae039);
var $95c12c4391b49510$var$formatRelativeLocale = {
    lastWeek: "\u5148\u9031\u306Eeeee\u306Ep",
    yesterday: "\u6628\u65E5\u306Ep",
    today: "\u4ECA\u65E5\u306Ep",
    tomorrow: "\u660E\u65E5\u306Ep",
    nextWeek: "\u7FCC\u9031\u306Eeeee\u306Ep",
    other: "P"
};
var $95c12c4391b49510$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $95c12c4391b49510$var$formatRelativeLocale[token];
};
var $95c12c4391b49510$export$2e2bcd8739ae039 = $95c12c4391b49510$var$formatRelative;

});

parcelRegister("ccNUt", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e2d5212be0935f7$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $8e2d5212be0935f7$var$eraValues = {
    narrow: [
        "BC",
        "AC"
    ],
    abbreviated: [
        "\u7D00\u5143\u524D",
        "\u897F\u66A6"
    ],
    wide: [
        "\u7D00\u5143\u524D",
        "\u897F\u66A6"
    ]
};
var $8e2d5212be0935f7$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "\u7B2C1\u56DB\u534A\u671F",
        "\u7B2C2\u56DB\u534A\u671F",
        "\u7B2C3\u56DB\u534A\u671F",
        "\u7B2C4\u56DB\u534A\u671F"
    ]
};
var $8e2d5212be0935f7$var$monthValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12"
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ]
};
var $8e2d5212be0935f7$var$dayValues = {
    narrow: [
        "\u65E5",
        "\u6708",
        "\u706B",
        "\u6C34",
        "\u6728",
        "\u91D1",
        "\u571F"
    ],
    short: [
        "\u65E5",
        "\u6708",
        "\u706B",
        "\u6C34",
        "\u6728",
        "\u91D1",
        "\u571F"
    ],
    abbreviated: [
        "\u65E5",
        "\u6708",
        "\u706B",
        "\u6C34",
        "\u6728",
        "\u91D1",
        "\u571F"
    ],
    wide: [
        "\u65E5\u66DC\u65E5",
        "\u6708\u66DC\u65E5",
        "\u706B\u66DC\u65E5",
        "\u6C34\u66DC\u65E5",
        "\u6728\u66DC\u65E5",
        "\u91D1\u66DC\u65E5",
        "\u571F\u66DC\u65E5"
    ]
};
var $8e2d5212be0935f7$var$dayPeriodValues = {
    narrow: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    abbreviated: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    wide: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    }
};
var $8e2d5212be0935f7$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    abbreviated: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    },
    wide: {
        am: "\u5348\u524D",
        pm: "\u5348\u5F8C",
        midnight: "\u6DF1\u591C",
        noon: "\u6B63\u5348",
        morning: "\u671D",
        afternoon: "\u5348\u5F8C",
        evening: "\u591C",
        night: "\u6DF1\u591C"
    }
};
var $8e2d5212be0935f7$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    switch(unit){
        case "year":
            return "".concat(number, "\u5E74");
        case "quarter":
            return "\u7B2C".concat(number, "\u56DB\u534A\u671F");
        case "month":
            return "".concat(number, "\u6708");
        case "week":
            return "\u7B2C".concat(number, "\u9031");
        case "date":
            return "".concat(number, "\u65E5");
        case "hour":
            return "".concat(number, "\u6642");
        case "minute":
            return "".concat(number, "\u5206");
        case "second":
            return "".concat(number, "\u79D2");
        default:
            return "".concat(number);
    }
};
var $8e2d5212be0935f7$var$localize = {
    ordinalNumber: $8e2d5212be0935f7$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $8e2d5212be0935f7$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $8e2d5212be0935f7$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $8e2d5212be0935f7$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $8e2d5212be0935f7$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $8e2d5212be0935f7$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $8e2d5212be0935f7$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $8e2d5212be0935f7$export$2e2bcd8739ae039 = $8e2d5212be0935f7$var$localize;

});

parcelRegister("lOtf7", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe14f37d2665866b$export$2e2bcd8739ae039);

var $7pOAB = parcelRequire("7pOAB");

var $gKbFl = parcelRequire("gKbFl");
var $fe14f37d2665866b$var$matchOrdinalNumberPattern = /^第?\d+(年|四半期|月|週|日|時|分|秒)?/i;
var $fe14f37d2665866b$var$parseOrdinalNumberPattern = /\d+/i;
var $fe14f37d2665866b$var$matchEraPatterns = {
    narrow: /^(B\.?C\.?|A\.?D\.?)/i,
    abbreviated: /^(紀元[前後]|西暦)/i,
    wide: /^(紀元[前後]|西暦)/i
};
var $fe14f37d2665866b$var$parseEraPatterns = {
    narrow: [
        /^B/i,
        /^A/i
    ],
    any: [
        /^(紀元前)/i,
        /^(西暦|紀元後)/i
    ]
};
var $fe14f37d2665866b$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^Q[1234]/i,
    wide: /^第[1234一二三四１２３４]四半期/i
};
var $fe14f37d2665866b$var$parseQuarterPatterns = {
    any: [
        /(1|一|１)/i,
        /(2|二|２)/i,
        /(3|三|３)/i,
        /(4|四|４)/i
    ]
};
var $fe14f37d2665866b$var$matchMonthPatterns = {
    narrow: /^([123456789]|1[012])/,
    abbreviated: /^([123456789]|1[012])月/i,
    wide: /^([123456789]|1[012])月/i
};
var $fe14f37d2665866b$var$parseMonthPatterns = {
    any: [
        /^1\D/,
        /^2/,
        /^3/,
        /^4/,
        /^5/,
        /^6/,
        /^7/,
        /^8/,
        /^9/,
        /^10/,
        /^11/,
        /^12/
    ]
};
var $fe14f37d2665866b$var$matchDayPatterns = {
    narrow: /^[日月火水木金土]/,
    short: /^[日月火水木金土]/,
    abbreviated: /^[日月火水木金土]/,
    wide: /^[日月火水木金土]曜日/
};
var $fe14f37d2665866b$var$parseDayPatterns = {
    any: [
        /^日/,
        /^月/,
        /^火/,
        /^水/,
        /^木/,
        /^金/,
        /^土/
    ]
};
var $fe14f37d2665866b$var$matchDayPeriodPatterns = {
    any: /^(AM|PM|午前|午後|正午|深夜|真夜中|夜|朝)/i
};
var $fe14f37d2665866b$var$parseDayPeriodPatterns = {
    any: {
        am: /^(A|午前)/i,
        pm: /^(P|午後)/i,
        midnight: /^深夜|真夜中/i,
        noon: /^正午/i,
        morning: /^朝/i,
        afternoon: /^午後/i,
        evening: /^夜/i,
        night: /^深夜/i
    }
};
var $fe14f37d2665866b$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $fe14f37d2665866b$var$matchOrdinalNumberPattern,
        parsePattern: $fe14f37d2665866b$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $fe14f37d2665866b$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fe14f37d2665866b$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $fe14f37d2665866b$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fe14f37d2665866b$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $fe14f37d2665866b$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fe14f37d2665866b$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $fe14f37d2665866b$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fe14f37d2665866b$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $fe14f37d2665866b$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $fe14f37d2665866b$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $fe14f37d2665866b$export$2e2bcd8739ae039 = $fe14f37d2665866b$var$match;

});


parcelRegister("9Zo2q", function(module, exports) {

$parcel$export(module.exports, "default", () => $745c750694f22a10$export$2e2bcd8739ae039);

var $4PbVC = parcelRequire("4PbVC");

var $kYu94 = parcelRequire("kYu94");

var $54DAU = parcelRequire("54DAU");

var $9OAPo = parcelRequire("9OAPo");

var $7MloH = parcelRequire("7MloH");
/**
 * @type {Locale}
 * @category Locales
 * @summary Japanese (Hiragana) locale.
 * @language Japanese (Hiragana)
 * @iso-639-2 jpn
 * @author Eri Hiramatsu [@Eritutteo]{@link https://github.com/Eritutteo}
 */ var $745c750694f22a10$var$locale = {
    code: "ja-Hira",
    formatDistance: (0, $4PbVC.default),
    formatLong: (0, $kYu94.default),
    formatRelative: (0, $54DAU.default),
    localize: (0, $9OAPo.default),
    match: (0, $7MloH.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $745c750694f22a10$export$2e2bcd8739ae039 = $745c750694f22a10$var$locale;

});
parcelRegister("4PbVC", function(module, exports) {

$parcel$export(module.exports, "default", () => $38352d91074c2077$export$2e2bcd8739ae039);
var $38352d91074c2077$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1\u3073\u3087\u3046\u307F\u307E\u3093",
        other: "{{count}}\u3073\u3087\u3046\u307F\u307E\u3093",
        oneWithSuffix: "\u3084\u304F1\u3073\u3087\u3046",
        otherWithSuffix: "\u3084\u304F{{count}}\u3073\u3087\u3046"
    },
    xSeconds: {
        one: "1\u3073\u3087\u3046",
        other: "{{count}}\u3073\u3087\u3046"
    },
    halfAMinute: "30\u3073\u3087\u3046",
    lessThanXMinutes: {
        one: "1\u3077\u3093\u307F\u307E\u3093",
        other: "{{count}}\u3075\u3093\u307F\u307E\u3093",
        oneWithSuffix: "\u3084\u304F1\u3077\u3093",
        otherWithSuffix: "\u3084\u304F{{count}}\u3075\u3093"
    },
    xMinutes: {
        one: "1\u3077\u3093",
        other: "{{count}}\u3075\u3093"
    },
    aboutXHours: {
        one: "\u3084\u304F1\u3058\u304B\u3093",
        other: "\u3084\u304F{{count}}\u3058\u304B\u3093"
    },
    xHours: {
        one: "1\u3058\u304B\u3093",
        other: "{{count}}\u3058\u304B\u3093"
    },
    xDays: {
        one: "1\u306B\u3061",
        other: "{{count}}\u306B\u3061"
    },
    aboutXWeeks: {
        one: "\u3084\u304F1\u3057\u3085\u3046\u304B\u3093",
        other: "\u3084\u304F{{count}}\u3057\u3085\u3046\u304B\u3093"
    },
    xWeeks: {
        one: "1\u3057\u3085\u3046\u304B\u3093",
        other: "{{count}}\u3057\u3085\u3046\u304B\u3093"
    },
    aboutXMonths: {
        one: "\u3084\u304F1\u304B\u3052\u3064",
        other: "\u3084\u304F{{count}}\u304B\u3052\u3064"
    },
    xMonths: {
        one: "1\u304B\u3052\u3064",
        other: "{{count}}\u304B\u3052\u3064"
    },
    aboutXYears: {
        one: "\u3084\u304F1\u306D\u3093",
        other: "\u3084\u304F{{count}}\u306D\u3093"
    },
    xYears: {
        one: "1\u306D\u3093",
        other: "{{count}}\u306D\u3093"
    },
    overXYears: {
        one: "1\u306D\u3093\u3044\u3058\u3087\u3046",
        other: "{{count}}\u306D\u3093\u3044\u3058\u3087\u3046"
    },
    almostXYears: {
        one: "1\u306D\u3093\u3061\u304B\u304F",
        other: "{{count}}\u306D\u3093\u3061\u304B\u304F"
    }
};
var $38352d91074c2077$var$formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    var result;
    var tokenValue = $38352d91074c2077$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) {
        if (options.addSuffix && tokenValue.oneWithSuffix) result = tokenValue.oneWithSuffix;
        else result = tokenValue.one;
    } else if (options.addSuffix && tokenValue.otherWithSuffix) result = tokenValue.otherWithSuffix.replace("{{count}}", String(count));
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u3042\u3068";
        else return result + "\u307E\u3048";
    }
    return result;
};
var $38352d91074c2077$export$2e2bcd8739ae039 = $38352d91074c2077$var$formatDistance;

});

parcelRegister("kYu94", function(module, exports) {

$parcel$export(module.exports, "default", () => $f450cb7ed45f0406$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $f450cb7ed45f0406$var$dateFormats = {
    full: "y\u306D\u3093M\u304C\u3064d\u306B\u3061EEEE",
    long: "y\u306D\u3093M\u304C\u3064d\u306B\u3061",
    medium: "y/MM/dd",
    short: "y/MM/dd"
};
var $f450cb7ed45f0406$var$timeFormats = {
    full: "H\u3058mm\u3075\u3093ss\u3073\u3087\u3046 zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
var $f450cb7ed45f0406$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $f450cb7ed45f0406$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $f450cb7ed45f0406$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $f450cb7ed45f0406$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $f450cb7ed45f0406$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $f450cb7ed45f0406$export$2e2bcd8739ae039 = $f450cb7ed45f0406$var$formatLong;

});

parcelRegister("54DAU", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b1c0a1860a45540$export$2e2bcd8739ae039);
var $3b1c0a1860a45540$var$formatRelativeLocale = {
    lastWeek: "\u305B\u3093\u3057\u3085\u3046\u306Eeeee\u306Ep",
    yesterday: "\u304D\u306E\u3046\u306Ep",
    today: "\u304D\u3087\u3046\u306Ep",
    tomorrow: "\u3042\u3057\u305F\u306Ep",
    nextWeek: "\u3088\u304F\u3057\u3085\u3046\u306Eeeee\u306Ep",
    other: "P"
};
var $3b1c0a1860a45540$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $3b1c0a1860a45540$var$formatRelativeLocale[token];
};
var $3b1c0a1860a45540$export$2e2bcd8739ae039 = $3b1c0a1860a45540$var$formatRelative;

});

parcelRegister("9OAPo", function(module, exports) {

$parcel$export(module.exports, "default", () => $725559d5dd84f496$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $725559d5dd84f496$var$eraValues = {
    narrow: [
        "BC",
        "AC"
    ],
    abbreviated: [
        "\u304D\u3052\u3093\u305C\u3093",
        "\u305B\u3044\u308C\u304D"
    ],
    wide: [
        "\u304D\u3052\u3093\u305C\u3093",
        "\u305B\u3044\u308C\u304D"
    ]
};
var $725559d5dd84f496$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "\u3060\u30441\u3057\u306F\u3093\u304D",
        "\u3060\u30442\u3057\u306F\u3093\u304D",
        "\u3060\u30443\u3057\u306F\u3093\u304D",
        "\u3060\u30444\u3057\u306F\u3093\u304D"
    ]
};
var $725559d5dd84f496$var$monthValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12"
    ],
    abbreviated: [
        "1\u304C\u3064",
        "2\u304C\u3064",
        "3\u304C\u3064",
        "4\u304C\u3064",
        "5\u304C\u3064",
        "6\u304C\u3064",
        "7\u304C\u3064",
        "8\u304C\u3064",
        "9\u304C\u3064",
        "10\u304C\u3064",
        "11\u304C\u3064",
        "12\u304C\u3064"
    ],
    wide: [
        "1\u304C\u3064",
        "2\u304C\u3064",
        "3\u304C\u3064",
        "4\u304C\u3064",
        "5\u304C\u3064",
        "6\u304C\u3064",
        "7\u304C\u3064",
        "8\u304C\u3064",
        "9\u304C\u3064",
        "10\u304C\u3064",
        "11\u304C\u3064",
        "12\u304C\u3064"
    ]
};
var $725559d5dd84f496$var$dayValues = {
    narrow: [
        "\u306B\u3061",
        "\u3052\u3064",
        "\u304B",
        "\u3059\u3044",
        "\u3082\u304F",
        "\u304D\u3093",
        "\u3069"
    ],
    short: [
        "\u306B\u3061",
        "\u3052\u3064",
        "\u304B",
        "\u3059\u3044",
        "\u3082\u304F",
        "\u304D\u3093",
        "\u3069"
    ],
    abbreviated: [
        "\u306B\u3061",
        "\u3052\u3064",
        "\u304B",
        "\u3059\u3044",
        "\u3082\u304F",
        "\u304D\u3093",
        "\u3069"
    ],
    wide: [
        "\u306B\u3061\u3088\u3046\u3073",
        "\u3052\u3064\u3088\u3046\u3073",
        "\u304B\u3088\u3046\u3073",
        "\u3059\u3044\u3088\u3046\u3073",
        "\u3082\u304F\u3088\u3046\u3073",
        "\u304D\u3093\u3088\u3046\u3073",
        "\u3069\u3088\u3046\u3073"
    ]
};
var $725559d5dd84f496$var$dayPeriodValues = {
    narrow: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    },
    abbreviated: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    },
    wide: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    }
};
var $725559d5dd84f496$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    },
    abbreviated: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    },
    wide: {
        am: "\u3054\u305C\u3093",
        pm: "\u3054\u3054",
        midnight: "\u3057\u3093\u3084",
        noon: "\u3057\u3087\u3046\u3054",
        morning: "\u3042\u3055",
        afternoon: "\u3054\u3054",
        evening: "\u3088\u308B",
        night: "\u3057\u3093\u3084"
    }
};
var $725559d5dd84f496$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    switch(unit){
        case "year":
            return "".concat(number, "\u306D\u3093");
        case "quarter":
            return "\u3060\u3044".concat(number, "\u3057\u306F\u3093\u304D");
        case "month":
            return "".concat(number, "\u304C\u3064");
        case "week":
            return "\u3060\u3044".concat(number, "\u3057\u3085\u3046");
        case "date":
            return "".concat(number, "\u306B\u3061");
        case "hour":
            return "".concat(number, "\u3058");
        case "minute":
            return "".concat(number, "\u3075\u3093");
        case "second":
            return "".concat(number, "\u3073\u3087\u3046");
        default:
            return "".concat(number);
    }
};
var $725559d5dd84f496$var$localize = {
    ordinalNumber: $725559d5dd84f496$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $725559d5dd84f496$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $725559d5dd84f496$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $725559d5dd84f496$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $725559d5dd84f496$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $725559d5dd84f496$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $725559d5dd84f496$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $725559d5dd84f496$export$2e2bcd8739ae039 = $725559d5dd84f496$var$localize;

});

parcelRegister("7MloH", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a9d9d26bcf84eec$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $5a9d9d26bcf84eec$var$matchOrdinalNumberPattern = /^だ?い?\d+(ねん|しはんき|がつ|しゅう|にち|じ|ふん|びょう)?/i;
var $5a9d9d26bcf84eec$var$parseOrdinalNumberPattern = /\d+/i;
var $5a9d9d26bcf84eec$var$matchEraPatterns = {
    narrow: /^(B\.?C\.?|A\.?D\.?)/i,
    abbreviated: /^(きげん[前後]|せいれき)/i,
    wide: /^(きげん[前後]|せいれき)/i
};
var $5a9d9d26bcf84eec$var$parseEraPatterns = {
    narrow: [
        /^B/i,
        /^A/i
    ],
    any: [
        /^(きげんぜん)/i,
        /^(せいれき|きげんご)/i
    ]
};
var $5a9d9d26bcf84eec$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^Q[1234]/i,
    wide: /^だい[1234一二三四１２３４]しはんき/i
};
var $5a9d9d26bcf84eec$var$parseQuarterPatterns = {
    any: [
        /(1|一|１)/i,
        /(2|二|２)/i,
        /(3|三|３)/i,
        /(4|四|４)/i
    ]
};
var $5a9d9d26bcf84eec$var$matchMonthPatterns = {
    narrow: /^([123456789]|1[012])/,
    abbreviated: /^([123456789]|1[012])がつ/i,
    wide: /^([123456789]|1[012])がつ/i
};
var $5a9d9d26bcf84eec$var$parseMonthPatterns = {
    any: [
        /^1\D/,
        /^2/,
        /^3/,
        /^4/,
        /^5/,
        /^6/,
        /^7/,
        /^8/,
        /^9/,
        /^10/,
        /^11/,
        /^12/
    ]
};
var $5a9d9d26bcf84eec$var$matchDayPatterns = {
    narrow: /^(にち|げつ|か|すい|もく|きん|ど)/,
    short: /^(にち|げつ|か|すい|もく|きん|ど)/,
    abbreviated: /^(にち|げつ|か|すい|もく|きん|ど)/,
    wide: /^(にち|げつ|か|すい|もく|きん|ど)ようび/
};
var $5a9d9d26bcf84eec$var$parseDayPatterns = {
    any: [
        /^にち/,
        /^げつ/,
        /^か/,
        /^すい/,
        /^もく/,
        /^きん/,
        /^ど/
    ]
};
var $5a9d9d26bcf84eec$var$matchDayPeriodPatterns = {
    any: /^(AM|PM|ごぜん|ごご|しょうご|しんや|まよなか|よる|あさ)/i
};
var $5a9d9d26bcf84eec$var$parseDayPeriodPatterns = {
    any: {
        am: /^(A|ごぜん)/i,
        pm: /^(P|ごご)/i,
        midnight: /^しんや|まよなか/i,
        noon: /^しょうご/i,
        morning: /^あさ/i,
        afternoon: /^ごご/i,
        evening: /^よる/i,
        night: /^しんや/i
    }
};
var $5a9d9d26bcf84eec$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $5a9d9d26bcf84eec$var$matchOrdinalNumberPattern,
        parsePattern: $5a9d9d26bcf84eec$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $5a9d9d26bcf84eec$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5a9d9d26bcf84eec$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $5a9d9d26bcf84eec$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5a9d9d26bcf84eec$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $5a9d9d26bcf84eec$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5a9d9d26bcf84eec$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $5a9d9d26bcf84eec$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5a9d9d26bcf84eec$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $5a9d9d26bcf84eec$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $5a9d9d26bcf84eec$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $5a9d9d26bcf84eec$export$2e2bcd8739ae039 = $5a9d9d26bcf84eec$var$match;

});


parcelRegister("fcYsM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b126e0c11698f1be$export$2e2bcd8739ae039);

var $4EU8T = parcelRequire("4EU8T");

var $1Awqj = parcelRequire("1Awqj");

var $3Sfp1 = parcelRequire("3Sfp1");

var $30TqN = parcelRequire("30TqN");

var $iGf8s = parcelRequire("iGf8s");
/**
 * @type {Locale}
 * @category Locales
 * @summary Georgian locale.
 * @language Georgian
 * @iso-639-2 geo
 * @author Lado Lomidze [@Landish]{@link https://github.com/Landish}
 * @author Nick Shvelidze [@shvelo]{@link https://github.com/shvelo}
 */ var $b126e0c11698f1be$var$locale = {
    code: "ka",
    formatDistance: (0, $4EU8T.default),
    formatLong: (0, $1Awqj.default),
    formatRelative: (0, $3Sfp1.default),
    localize: (0, $30TqN.default),
    match: (0, $iGf8s.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $b126e0c11698f1be$export$2e2bcd8739ae039 = $b126e0c11698f1be$var$locale;

});
parcelRegister("4EU8T", function(module, exports) {

$parcel$export(module.exports, "default", () => $3646728bede02b7e$export$2e2bcd8739ae039);
var $3646728bede02b7e$var$formatDistanceLocale = {
    lessThanXSeconds: {
        past: "{{count}} \u10EC\u10D0\u10DB\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D0\u10DB\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8",
        future: "{{count}} \u10EC\u10D0\u10DB\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10E8\u10D8"
    },
    xSeconds: {
        past: "{{count}} \u10EC\u10D0\u10DB\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D0\u10DB\u10D8",
        future: "{{count}} \u10EC\u10D0\u10DB\u10E8\u10D8"
    },
    halfAMinute: {
        past: "\u10DC\u10D0\u10EE\u10D4\u10D5\u10D0\u10E0\u10D8 \u10EC\u10E3\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10DC\u10D0\u10EE\u10D4\u10D5\u10D0\u10E0\u10D8 \u10EC\u10E3\u10D7\u10D8",
        future: "\u10DC\u10D0\u10EE\u10D4\u10D5\u10D0\u10E0\u10D8 \u10EC\u10E3\u10D7\u10E8\u10D8"
    },
    lessThanXMinutes: {
        past: "{{count}} \u10EC\u10E3\u10D7\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10E3\u10D7\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10D8",
        future: "{{count}} \u10EC\u10E3\u10D7\u10D6\u10D4 \u10DC\u10D0\u10D9\u10DA\u10D4\u10D1\u10E8\u10D8"
    },
    xMinutes: {
        past: "{{count}} \u10EC\u10E3\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10E3\u10D7\u10D8",
        future: "{{count}} \u10EC\u10E3\u10D7\u10E8\u10D8"
    },
    aboutXHours: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10E1\u10D0\u10D0\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10E1\u10D0\u10D0\u10D7\u10D8",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10E1\u10D0\u10D0\u10D7\u10E8\u10D8"
    },
    xHours: {
        past: "{{count}} \u10E1\u10D0\u10D0\u10D7\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10E1\u10D0\u10D0\u10D7\u10D8",
        future: "{{count}} \u10E1\u10D0\u10D0\u10D7\u10E8\u10D8"
    },
    xDays: {
        past: "{{count}} \u10D3\u10E6\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10D3\u10E6\u10D4",
        future: "{{count}} \u10D3\u10E6\u10D4\u10E8\u10D8"
    },
    aboutXWeeks: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D9\u10D5\u10D8\u10E0\u10D0",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E8\u10D8"
    },
    xWeeks: {
        past: "{{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E1 \u10D9\u10D5\u10D8\u10E0\u10D0",
        present: "{{count}} \u10D9\u10D5\u10D8\u10E0\u10D0",
        future: "{{count}} \u10D9\u10D5\u10D8\u10E0\u10D0\u10E8\u10D8"
    },
    aboutXMonths: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D7\u10D5\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D7\u10D5\u10D4",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10D7\u10D5\u10D4\u10E8\u10D8"
    },
    xMonths: {
        past: "{{count}} \u10D7\u10D5\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10D7\u10D5\u10D4",
        future: "{{count}} \u10D7\u10D5\u10D4\u10E8\u10D8"
    },
    aboutXYears: {
        past: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10EC\u10DA\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10EC\u10D4\u10DA\u10D8",
        future: "\u10D3\u10D0\u10D0\u10EE\u10DA\u10DD\u10D4\u10D1\u10D8\u10D7 {{count}} \u10EC\u10D4\u10DA\u10E8\u10D8"
    },
    xYears: {
        past: "{{count}} \u10EC\u10DA\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D4\u10DA\u10D8",
        future: "{{count}} \u10EC\u10D4\u10DA\u10E8\u10D8"
    },
    overXYears: {
        past: "{{count}} \u10EC\u10D4\u10DA\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "{{count}} \u10EC\u10D4\u10DA\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8",
        future: "{{count}} \u10EC\u10D4\u10DA\u10D6\u10D4 \u10DB\u10D4\u10E2\u10D8 \u10EE\u10DC\u10D8\u10E1 \u10E8\u10D4\u10DB\u10D3\u10D4\u10D2"
    },
    almostXYears: {
        past: "\u10D7\u10D8\u10D7\u10E5\u10DB\u10D8\u10E1 {{count}} \u10EC\u10DA\u10D8\u10E1 \u10EC\u10D8\u10DC",
        present: "\u10D7\u10D8\u10D7\u10E5\u10DB\u10D8\u10E1 {{count}} \u10EC\u10D4\u10DA\u10D8",
        future: "\u10D7\u10D8\u10D7\u10E5\u10DB\u10D8\u10E1 {{count}} \u10EC\u10D4\u10DA\u10E8\u10D8"
    }
};
var $3646728bede02b7e$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $3646728bede02b7e$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (options !== null && options !== void 0 && options.addSuffix && options.comparison && options.comparison > 0) result = tokenValue.future.replace("{{count}}", String(count));
    else if (options !== null && options !== void 0 && options.addSuffix) result = tokenValue.past.replace("{{count}}", String(count));
    else result = tokenValue.present.replace("{{count}}", String(count));
    return result;
};
var $3646728bede02b7e$export$2e2bcd8739ae039 = $3646728bede02b7e$var$formatDistance;

});

parcelRegister("1Awqj", function(module, exports) {

$parcel$export(module.exports, "default", () => $12824dddee17e341$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $12824dddee17e341$var$dateFormats = {
    full: "EEEE, do MMMM, y",
    long: "do, MMMM, y",
    medium: "d, MMM, y",
    short: "dd/MM/yyyy"
};
var $12824dddee17e341$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $12824dddee17e341$var$dateTimeFormats = {
    full: "{{date}} {{time}}'-\u10D6\u10D4'",
    long: "{{date}} {{time}}'-\u10D6\u10D4'",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $12824dddee17e341$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $12824dddee17e341$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $12824dddee17e341$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $12824dddee17e341$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $12824dddee17e341$export$2e2bcd8739ae039 = $12824dddee17e341$var$formatLong;

});

parcelRegister("3Sfp1", function(module, exports) {

$parcel$export(module.exports, "default", () => $2d225cd973837ba8$export$2e2bcd8739ae039);
var $2d225cd973837ba8$var$formatRelativeLocale = {
    lastWeek: "'\u10EC\u10D8\u10DC\u10D0' eeee p'-\u10D6\u10D4'",
    yesterday: "'\u10D2\u10E3\u10E8\u10D8\u10DC' p'-\u10D6\u10D4'",
    today: "'\u10D3\u10E6\u10D4\u10E1' p'-\u10D6\u10D4'",
    tomorrow: "'\u10EE\u10D5\u10D0\u10DA' p'-\u10D6\u10D4'",
    nextWeek: "'\u10E8\u10D4\u10DB\u10D3\u10D4\u10D2\u10D8' eeee p'-\u10D6\u10D4'",
    other: "P"
};
var $2d225cd973837ba8$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $2d225cd973837ba8$var$formatRelativeLocale[token];
};
var $2d225cd973837ba8$export$2e2bcd8739ae039 = $2d225cd973837ba8$var$formatRelative;

});

parcelRegister("30TqN", function(module, exports) {

$parcel$export(module.exports, "default", () => $231c5ea6438acc98$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $231c5ea6438acc98$var$eraValues = {
    narrow: [
        "\u10E9.\u10EC-\u10DB\u10D3\u10D4",
        "\u10E9.\u10EC"
    ],
    abbreviated: [
        "\u10E9\u10D5.\u10EC-\u10DB\u10D3\u10D4",
        "\u10E9\u10D5.\u10EC"
    ],
    wide: [
        "\u10E9\u10D5\u10D4\u10DC\u10E1 \u10EC\u10D4\u10DA\u10D7\u10D0\u10E6\u10E0\u10D8\u10EA\u10EE\u10D5\u10D0\u10DB\u10D3\u10D4",
        "\u10E9\u10D5\u10D4\u10DC\u10D8 \u10EC\u10D4\u10DA\u10D7\u10D0\u10E6\u10E0\u10D8\u10EA\u10EE\u10D5\u10D8\u10D7"
    ]
};
var $231c5ea6438acc98$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-\u10DA\u10D8 \u10D9\u10D5",
        "2-\u10D4 \u10D9\u10D5",
        "3-\u10D4 \u10D9\u10D5",
        "4-\u10D4 \u10D9\u10D5"
    ],
    wide: [
        "1-\u10DA\u10D8 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8",
        "2-\u10D4 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8",
        "3-\u10D4 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8",
        "4-\u10D4 \u10D9\u10D5\u10D0\u10E0\u10E2\u10D0\u10DA\u10D8"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $231c5ea6438acc98$var$monthValues = {
    narrow: [
        "\u10D8\u10D0",
        "\u10D7\u10D4",
        "\u10DB\u10D0",
        "\u10D0\u10DE",
        "\u10DB\u10E1",
        "\u10D5\u10DC",
        "\u10D5\u10DA",
        "\u10D0\u10D2",
        "\u10E1\u10D4",
        "\u10DD\u10E5",
        "\u10DC\u10DD",
        "\u10D3\u10D4"
    ],
    abbreviated: [
        "\u10D8\u10D0\u10DC",
        "\u10D7\u10D4\u10D1",
        "\u10DB\u10D0\u10E0",
        "\u10D0\u10DE\u10E0",
        "\u10DB\u10D0\u10D8",
        "\u10D8\u10D5\u10DC",
        "\u10D8\u10D5\u10DA",
        "\u10D0\u10D2\u10D5",
        "\u10E1\u10D4\u10E5",
        "\u10DD\u10E5\u10E2",
        "\u10DC\u10DD\u10D4",
        "\u10D3\u10D4\u10D9"
    ],
    wide: [
        "\u10D8\u10D0\u10DC\u10D5\u10D0\u10E0\u10D8",
        "\u10D7\u10D4\u10D1\u10D4\u10E0\u10D5\u10D0\u10DA\u10D8",
        "\u10DB\u10D0\u10E0\u10E2\u10D8",
        "\u10D0\u10DE\u10E0\u10D8\u10DA\u10D8",
        "\u10DB\u10D0\u10D8\u10E1\u10D8",
        "\u10D8\u10D5\u10DC\u10D8\u10E1\u10D8",
        "\u10D8\u10D5\u10DA\u10D8\u10E1\u10D8",
        "\u10D0\u10D2\u10D5\u10D8\u10E1\u10E2\u10DD",
        "\u10E1\u10D4\u10E5\u10E2\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8",
        "\u10DD\u10E5\u10E2\u10DD\u10DB\u10D1\u10D4\u10E0\u10D8",
        "\u10DC\u10DD\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8",
        "\u10D3\u10D4\u10D9\u10D4\u10DB\u10D1\u10D4\u10E0\u10D8"
    ]
};
var $231c5ea6438acc98$var$dayValues = {
    narrow: [
        "\u10D9\u10D5",
        "\u10DD\u10E0",
        "\u10E1\u10D0",
        "\u10DD\u10D7",
        "\u10EE\u10E3",
        "\u10DE\u10D0",
        "\u10E8\u10D0"
    ],
    short: [
        "\u10D9\u10D5\u10D8",
        "\u10DD\u10E0\u10E8",
        "\u10E1\u10D0\u10DB",
        "\u10DD\u10D7\u10EE",
        "\u10EE\u10E3\u10D7",
        "\u10DE\u10D0\u10E0",
        "\u10E8\u10D0\u10D1"
    ],
    abbreviated: [
        "\u10D9\u10D5\u10D8",
        "\u10DD\u10E0\u10E8",
        "\u10E1\u10D0\u10DB",
        "\u10DD\u10D7\u10EE",
        "\u10EE\u10E3\u10D7",
        "\u10DE\u10D0\u10E0",
        "\u10E8\u10D0\u10D1"
    ],
    wide: [
        "\u10D9\u10D5\u10D8\u10E0\u10D0",
        "\u10DD\u10E0\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        "\u10E1\u10D0\u10DB\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        "\u10DD\u10D7\u10EE\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        "\u10EE\u10E3\u10D7\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8",
        "\u10DE\u10D0\u10E0\u10D0\u10E1\u10D9\u10D4\u10D5\u10D8",
        "\u10E8\u10D0\u10D1\u10D0\u10D7\u10D8"
    ]
};
var $231c5ea6438acc98$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D4",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4",
        morning: "\u10D3\u10D8\u10DA\u10D0",
        afternoon: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        night: "\u10E6\u10D0\u10DB\u10D4"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D4",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4",
        morning: "\u10D3\u10D8\u10DA\u10D0",
        afternoon: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        night: "\u10E6\u10D0\u10DB\u10D4"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D4",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4",
        morning: "\u10D3\u10D8\u10DA\u10D0",
        afternoon: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD",
        night: "\u10E6\u10D0\u10DB\u10D4"
    }
};
var $231c5ea6438acc98$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D8\u10D7",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D8\u10E1\u10D0\u10E1",
        morning: "\u10D3\u10D8\u10DA\u10D8\u10D7",
        afternoon: "\u10DC\u10D0\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4\u10D5\u10E1",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD\u10E1",
        night: "\u10E6\u10D0\u10DB\u10D8\u10D7"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D8\u10D7",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D8\u10E1\u10D0\u10E1",
        morning: "\u10D3\u10D8\u10DA\u10D8\u10D7",
        afternoon: "\u10DC\u10D0\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4\u10D5\u10E1",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD\u10E1",
        night: "\u10E6\u10D0\u10DB\u10D8\u10D7"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "\u10E8\u10E3\u10D0\u10E6\u10D0\u10DB\u10D8\u10D7",
        noon: "\u10E8\u10E3\u10D0\u10D3\u10E6\u10D8\u10E1\u10D0\u10E1",
        morning: "\u10D3\u10D8\u10DA\u10D8\u10D7",
        afternoon: "\u10DC\u10D0\u10E8\u10E3\u10D0\u10D3\u10E6\u10D4\u10D5\u10E1",
        evening: "\u10E1\u10D0\u10E6\u10D0\u10DB\u10DD\u10E1",
        night: "\u10E6\u10D0\u10DB\u10D8\u10D7"
    }
};
var $231c5ea6438acc98$var$ordinalNumber = function ordinalNumber(dirtyNumber) {
    var number = Number(dirtyNumber);
    if (number === 1) return number + "-\u10DA\u10D8";
    return number + "-\u10D4";
};
var $231c5ea6438acc98$var$localize = {
    ordinalNumber: $231c5ea6438acc98$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $231c5ea6438acc98$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $231c5ea6438acc98$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $231c5ea6438acc98$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $231c5ea6438acc98$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $231c5ea6438acc98$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $231c5ea6438acc98$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $231c5ea6438acc98$export$2e2bcd8739ae039 = $231c5ea6438acc98$var$localize;

});

parcelRegister("iGf8s", function(module, exports) {

$parcel$export(module.exports, "default", () => $d997e3d6b20a922c$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $d997e3d6b20a922c$var$matchOrdinalNumberPattern = /^(\d+)(-ლი|-ე)?/i;
var $d997e3d6b20a922c$var$parseOrdinalNumberPattern = /\d+/i;
var $d997e3d6b20a922c$var$matchEraPatterns = {
    narrow: /^(ჩვ?\.წ)/i,
    abbreviated: /^(ჩვ?\.წ)/i,
    wide: /^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე|ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i
};
var $d997e3d6b20a922c$var$parseEraPatterns = {
    any: [
        /^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე)/i,
        /^(ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i
    ]
};
var $d997e3d6b20a922c$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]-(ლი|ე)? კვ/i,
    wide: /^[1234]-(ლი|ე)? კვარტალი/i
};
var $d997e3d6b20a922c$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $d997e3d6b20a922c$var$matchMonthPatterns = {
    any: /^(ია|თე|მა|აპ|მს|ვნ|ვლ|აგ|სე|ოქ|ნო|დე)/i
};
var $d997e3d6b20a922c$var$parseMonthPatterns = {
    any: [
        /^ია/i,
        /^თ/i,
        /^მარ/i,
        /^აპ/i,
        /^მაი/i,
        /^ი?ვნ/i,
        /^ი?ვლ/i,
        /^აგ/i,
        /^ს/i,
        /^ო/i,
        /^ნ/i,
        /^დ/i
    ]
};
var $d997e3d6b20a922c$var$matchDayPatterns = {
    narrow: /^(კვ|ორ|სა|ოთ|ხუ|პა|შა)/i,
    short: /^(კვი|ორშ|სამ|ოთხ|ხუთ|პარ|შაბ)/i,
    wide: /^(კვირა|ორშაბათი|სამშაბათი|ოთხშაბათი|ხუთშაბათი|პარასკევი|შაბათი)/i
};
var $d997e3d6b20a922c$var$parseDayPatterns = {
    any: [
        /^კვ/i,
        /^ორ/i,
        /^სა/i,
        /^ოთ/i,
        /^ხუ/i,
        /^პა/i,
        /^შა/i
    ]
};
var $d997e3d6b20a922c$var$matchDayPeriodPatterns = {
    any: /^([ap]\.?\s?m\.?|შუაღ|დილ)/i
};
var $d997e3d6b20a922c$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^შუაღ/i,
        noon: /^შუადღ/i,
        morning: /^დილ/i,
        afternoon: /ნაშუადღევს/i,
        evening: /საღამო/i,
        night: /ღამ/i
    }
};
var $d997e3d6b20a922c$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $d997e3d6b20a922c$var$matchOrdinalNumberPattern,
        parsePattern: $d997e3d6b20a922c$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $d997e3d6b20a922c$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d997e3d6b20a922c$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $d997e3d6b20a922c$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d997e3d6b20a922c$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $d997e3d6b20a922c$var$matchMonthPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $d997e3d6b20a922c$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $d997e3d6b20a922c$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d997e3d6b20a922c$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $d997e3d6b20a922c$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $d997e3d6b20a922c$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $d997e3d6b20a922c$export$2e2bcd8739ae039 = $d997e3d6b20a922c$var$match;

});


parcelRegister("9cYZI", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b448c3f57091f03$export$2e2bcd8739ae039);

var $1g0RK = parcelRequire("1g0RK");

var $6GZ4v = parcelRequire("6GZ4v");

var $6i4IN = parcelRequire("6i4IN");

var $gRBEA = parcelRequire("gRBEA");

var $iNAcG = parcelRequire("iNAcG");
/**
 * @type {Locale}
 * @category Locales
 * @summary Kazakh locale.
 * @language Kazakh
 * @iso-639-2 kaz
 * @author Nikita Bayev [@drugoi]{@link https://github.com/drugoi}
 */ var $6b448c3f57091f03$var$locale = {
    code: "kk",
    formatDistance: (0, $1g0RK.default),
    formatLong: (0, $6GZ4v.default),
    formatRelative: (0, $6i4IN.default),
    localize: (0, $gRBEA.default),
    match: (0, $iNAcG.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $6b448c3f57091f03$export$2e2bcd8739ae039 = $6b448c3f57091f03$var$locale;

});
parcelRegister("1g0RK", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ea7f50730b720c3$export$2e2bcd8739ae039);
var $0ea7f50730b720c3$var$formatDistanceLocale = {
    lessThanXSeconds: {
        regular: {
            one: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437",
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u0430\u0437"
        },
        future: {
            one: "\u0431\u0456\u0440 \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    xSeconds: {
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0431\u04B1\u0440\u044B\u043D",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0431\u04B1\u0440\u044B\u043D",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0431\u04B1\u0440\u044B\u043D"
        },
        future: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    halfAMinute: function halfAMinute(options) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) return "\u0436\u0430\u0440\u0442\u044B \u043C\u0438\u043D\u0443\u0442 \u0456\u0448\u0456\u043D\u0434\u0435";
            else return "\u0436\u0430\u0440\u0442\u044B \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D";
        }
        return "\u0436\u0430\u0440\u0442\u044B \u043C\u0438\u043D\u0443\u0442";
    },
    lessThanXMinutes: {
        regular: {
            one: "1 \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437",
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u0430\u0437"
        },
        future: {
            one: "\u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C ",
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u043C"
        }
    },
    xMinutes: {
        regular: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442"
        },
        past: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0431\u04B1\u0440\u044B\u043D"
        },
        future: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    aboutXHours: {
        regular: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442"
        },
        future: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0441\u0430\u0493\u0430\u0442\u0442\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    xHours: {
        regular: {
            singularNominative: "{{count}} \u0441\u0430\u0493\u0430\u0442",
            singularGenitive: "{{count}} \u0441\u0430\u0493\u0430\u0442",
            pluralGenitive: "{{count}} \u0441\u0430\u0493\u0430\u0442"
        }
    },
    xDays: {
        regular: {
            singularNominative: "{{count}} \u043A\u04AF\u043D",
            singularGenitive: "{{count}} \u043A\u04AF\u043D",
            pluralGenitive: "{{count}} \u043A\u04AF\u043D"
        },
        future: {
            singularNominative: "{{count}} \u043A\u04AF\u043D\u043D\u0435\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u043A\u04AF\u043D\u043D\u0435\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u043A\u04AF\u043D\u043D\u0435\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    aboutXWeeks: {
        type: "weeks",
        one: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D 1 \u0430\u043F\u0442\u0430",
        other: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u043F\u0442\u0430"
    },
    xWeeks: {
        type: "weeks",
        one: "1 \u0430\u043F\u0442\u0430",
        other: "{{count}} \u0430\u043F\u0442\u0430"
    },
    aboutXMonths: {
        regular: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439"
        },
        future: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0430\u0439\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    xMonths: {
        regular: {
            singularNominative: "{{count}} \u0430\u0439",
            singularGenitive: "{{count}} \u0430\u0439",
            pluralGenitive: "{{count}} \u0430\u0439"
        }
    },
    aboutXYears: {
        regular: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B"
        },
        future: {
            singularNominative: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "\u0448\u0430\u043C\u0430\u043C\u0435\u043D {{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    xYears: {
        regular: {
            singularNominative: "{{count}} \u0436\u044B\u043B",
            singularGenitive: "{{count}} \u0436\u044B\u043B",
            pluralGenitive: "{{count}} \u0436\u044B\u043B"
        },
        future: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    },
    overXYears: {
        regular: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C"
        },
        future: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u0430\u0441\u0442\u0430\u043C"
        }
    },
    almostXYears: {
        regular: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0493\u0430 \u0436\u0430\u049B\u044B\u043D",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0493\u0430 \u0436\u0430\u049B\u044B\u043D",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0493\u0430 \u0436\u0430\u049B\u044B\u043D"
        },
        future: {
            singularNominative: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            singularGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D",
            pluralGenitive: "{{count}} \u0436\u044B\u043B\u0434\u0430\u043D \u043A\u0435\u0439\u0456\u043D"
        }
    }
};
function $0ea7f50730b720c3$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace("{{count}}", String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace("{{count}}", String(count));
    else return scheme.pluralGenitive.replace("{{count}}", String(count));
}
var $0ea7f50730b720c3$var$formatDistance = function formatDistance(token, count, options) {
    var tokenValue = $0ea7f50730b720c3$var$formatDistanceLocale[token];
    if (typeof tokenValue === "function") return tokenValue(options);
    if (tokenValue.type === "weeks") return count === 1 ? tokenValue.one : tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
            if (tokenValue.future) return $0ea7f50730b720c3$var$declension(tokenValue.future, count);
            else return $0ea7f50730b720c3$var$declension(tokenValue.regular, count) + " \u043A\u0435\u0439\u0456\u043D";
        } else {
            if (tokenValue.past) return $0ea7f50730b720c3$var$declension(tokenValue.past, count);
            else return $0ea7f50730b720c3$var$declension(tokenValue.regular, count) + " \u0431\u04B1\u0440\u044B\u043D";
        }
    } else return $0ea7f50730b720c3$var$declension(tokenValue.regular, count);
};
var $0ea7f50730b720c3$export$2e2bcd8739ae039 = $0ea7f50730b720c3$var$formatDistance;

});

parcelRegister("6GZ4v", function(module, exports) {

$parcel$export(module.exports, "default", () => $4df609df50ccfabb$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $4df609df50ccfabb$var$dateFormats = {
    full: "EEEE, do MMMM y '\u0436.'",
    long: "do MMMM y '\u0436.'",
    medium: "d MMM y '\u0436.'",
    short: "dd.MM.yyyy"
};
var $4df609df50ccfabb$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
var $4df609df50ccfabb$var$dateTimeFormats = {
    any: "{{date}}, {{time}}"
};
var $4df609df50ccfabb$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $4df609df50ccfabb$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $4df609df50ccfabb$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $4df609df50ccfabb$var$dateTimeFormats,
        defaultWidth: "any"
    })
};
var $4df609df50ccfabb$export$2e2bcd8739ae039 = $4df609df50ccfabb$var$formatLong;

});

parcelRegister("6i4IN", function(module, exports) {

$parcel$export(module.exports, "default", () => $4948161e08006a4a$export$2e2bcd8739ae039);

var $6KZXu = parcelRequire("6KZXu");
var $4948161e08006a4a$var$accusativeWeekdays = [
    "\u0436\u0435\u043A\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0434\u04AF\u0439\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0441\u0435\u0439\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0441\u04D9\u0440\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0431\u0435\u0439\u0441\u0435\u043D\u0431\u0456\u0434\u0435",
    "\u0436\u04B1\u043C\u0430\u0434\u0430",
    "\u0441\u0435\u043D\u0431\u0456\u0434\u0435"
];
function $4948161e08006a4a$var$_lastWeek(day) {
    var weekday = $4948161e08006a4a$var$accusativeWeekdays[day];
    return "'\u04E9\u0442\u043A\u0435\u043D " + weekday + " \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'";
}
function $4948161e08006a4a$var$thisWeek(day) {
    var weekday = $4948161e08006a4a$var$accusativeWeekdays[day];
    return "'" + weekday + " \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'";
}
function $4948161e08006a4a$var$_nextWeek(day) {
    var weekday = $4948161e08006a4a$var$accusativeWeekdays[day];
    return "'\u043A\u0435\u043B\u0435\u0441\u0456 " + weekday + " \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'";
}
var $4948161e08006a4a$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $6KZXu.default)(date, baseDate, options)) return $4948161e08006a4a$var$thisWeek(day);
        else return $4948161e08006a4a$var$_lastWeek(day);
    },
    yesterday: "'\u043A\u0435\u0448\u0435 \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'",
    today: "'\u0431\u04AF\u0433\u0456\u043D \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'",
    tomorrow: "'\u0435\u0440\u0442\u0435\u04A3 \u0441\u0430\u0493\u0430\u0442' p'-\u0434\u0435'",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $6KZXu.default)(date, baseDate, options)) return $4948161e08006a4a$var$thisWeek(day);
        else return $4948161e08006a4a$var$_nextWeek(day);
    },
    other: "P"
};
var $4948161e08006a4a$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $4948161e08006a4a$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
var $4948161e08006a4a$export$2e2bcd8739ae039 = $4948161e08006a4a$var$formatRelative;

});

parcelRegister("gRBEA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c46ecdcc2f6d7504$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $c46ecdcc2f6d7504$var$eraValues = {
    narrow: [
        "\u0431.\u0437.\u0434.",
        "\u0431.\u0437."
    ],
    abbreviated: [
        "\u0431.\u0437.\u0434.",
        "\u0431.\u0437."
    ],
    wide: [
        "\u0431\u0456\u0437\u0434\u0456\u04A3 \u0437\u0430\u043C\u0430\u043D\u044B\u043C\u044B\u0437\u0493\u0430 \u0434\u0435\u0439\u0456\u043D",
        "\u0431\u0456\u0437\u0434\u0456\u04A3 \u0437\u0430\u043C\u0430\u043D\u044B\u043C\u044B\u0437"
    ]
};
var $c46ecdcc2f6d7504$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-\u0448\u0456 \u0442\u043E\u049B.",
        "2-\u0448\u0456 \u0442\u043E\u049B.",
        "3-\u0448\u0456 \u0442\u043E\u049B.",
        "4-\u0448\u0456 \u0442\u043E\u049B."
    ],
    wide: [
        "1-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D",
        "2-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D",
        "3-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D",
        "4-\u0448\u0456 \u0442\u043E\u049B\u0441\u0430\u043D"
    ]
};
var $c46ecdcc2f6d7504$var$monthValues = {
    narrow: [
        "\u049A",
        "\u0410",
        "\u041D",
        "\u0421",
        "\u041C",
        "\u041C",
        "\u0428",
        "\u0422",
        "\u049A",
        "\u049A",
        "\u049A",
        "\u0416"
    ],
    abbreviated: [
        "\u049B\u0430\u04A3",
        "\u0430\u049B\u043F",
        "\u043D\u0430\u0443",
        "\u0441\u04D9\u0443",
        "\u043C\u0430\u043C",
        "\u043C\u0430\u0443",
        "\u0448\u0456\u043B",
        "\u0442\u0430\u043C",
        "\u049B\u044B\u0440",
        "\u049B\u0430\u0437",
        "\u049B\u0430\u0440",
        "\u0436\u0435\u043B"
    ],
    wide: [
        "\u049B\u0430\u04A3\u0442\u0430\u0440",
        "\u0430\u049B\u043F\u0430\u043D",
        "\u043D\u0430\u0443\u0440\u044B\u0437",
        "\u0441\u04D9\u0443\u0456\u0440",
        "\u043C\u0430\u043C\u044B\u0440",
        "\u043C\u0430\u0443\u0441\u044B\u043C",
        "\u0448\u0456\u043B\u0434\u0435",
        "\u0442\u0430\u043C\u044B\u0437",
        "\u049B\u044B\u0440\u043A\u04AF\u0439\u0435\u043A",
        "\u049B\u0430\u0437\u0430\u043D",
        "\u049B\u0430\u0440\u0430\u0448\u0430",
        "\u0436\u0435\u043B\u0442\u043E\u049B\u0441\u0430\u043D"
    ]
};
var $c46ecdcc2f6d7504$var$formattingMonthValues = {
    narrow: [
        "\u049A",
        "\u0410",
        "\u041D",
        "\u0421",
        "\u041C",
        "\u041C",
        "\u0428",
        "\u0422",
        "\u049A",
        "\u049A",
        "\u049A",
        "\u0416"
    ],
    abbreviated: [
        "\u049B\u0430\u04A3",
        "\u0430\u049B\u043F",
        "\u043D\u0430\u0443",
        "\u0441\u04D9\u0443",
        "\u043C\u0430\u043C",
        "\u043C\u0430\u0443",
        "\u0448\u0456\u043B",
        "\u0442\u0430\u043C",
        "\u049B\u044B\u0440",
        "\u049B\u0430\u0437",
        "\u049B\u0430\u0440",
        "\u0436\u0435\u043B"
    ],
    wide: [
        "\u049B\u0430\u04A3\u0442\u0430\u0440",
        "\u0430\u049B\u043F\u0430\u043D",
        "\u043D\u0430\u0443\u0440\u044B\u0437",
        "\u0441\u04D9\u0443\u0456\u0440",
        "\u043C\u0430\u043C\u044B\u0440",
        "\u043C\u0430\u0443\u0441\u044B\u043C",
        "\u0448\u0456\u043B\u0434\u0435",
        "\u0442\u0430\u043C\u044B\u0437",
        "\u049B\u044B\u0440\u043A\u04AF\u0439\u0435\u043A",
        "\u049B\u0430\u0437\u0430\u043D",
        "\u049B\u0430\u0440\u0430\u0448\u0430",
        "\u0436\u0435\u043B\u0442\u043E\u049B\u0441\u0430\u043D"
    ]
};
var $c46ecdcc2f6d7504$var$dayValues = {
    narrow: [
        "\u0416",
        "\u0414",
        "\u0421",
        "\u0421",
        "\u0411",
        "\u0416",
        "\u0421"
    ],
    short: [
        "\u0436\u0441",
        "\u0434\u0441",
        "\u0441\u0441",
        "\u0441\u0440",
        "\u0431\u0441",
        "\u0436\u043C",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u0436\u0441",
        "\u0434\u0441",
        "\u0441\u0441",
        "\u0441\u0440",
        "\u0431\u0441",
        "\u0436\u043C",
        "\u0441\u0431"
    ],
    wide: [
        "\u0436\u0435\u043A\u0441\u0435\u043D\u0431\u0456",
        "\u0434\u04AF\u0439\u0441\u0435\u043D\u0431\u0456",
        "\u0441\u0435\u0439\u0441\u0435\u043D\u0431\u0456",
        "\u0441\u04D9\u0440\u0441\u0435\u043D\u0431\u0456",
        "\u0431\u0435\u0439\u0441\u0435\u043D\u0431\u0456",
        "\u0436\u04B1\u043C\u0430",
        "\u0441\u0435\u043D\u0431\u0456"
    ]
};
var $c46ecdcc2f6d7504$var$dayPeriodValues = {
    narrow: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B",
        noon: "\u0442\u04AF\u0441",
        morning: "\u0442\u0430\u04A3",
        afternoon: "\u043A\u04AF\u043D\u0434\u0456\u0437",
        evening: "\u043A\u0435\u0448",
        night: "\u0442\u04AF\u043D"
    },
    wide: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B",
        noon: "\u0442\u04AF\u0441",
        morning: "\u0442\u0430\u04A3",
        afternoon: "\u043A\u04AF\u043D\u0434\u0456\u0437",
        evening: "\u043A\u0435\u0448",
        night: "\u0442\u04AF\u043D"
    }
};
var $c46ecdcc2f6d7504$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B\u043D\u0434\u0430",
        noon: "\u0442\u04AF\u0441",
        morning: "\u0442\u0430\u04A3",
        afternoon: "\u043A\u04AF\u043D",
        evening: "\u043A\u0435\u0448",
        night: "\u0442\u04AF\u043D"
    },
    wide: {
        am: "\u0422\u0414",
        pm: "\u0422\u041A",
        midnight: "\u0442\u04AF\u043D \u043E\u0440\u0442\u0430\u0441\u044B\u043D\u0434\u0430",
        noon: "\u0442\u04AF\u0441\u0442\u0435",
        morning: "\u0442\u0430\u04A3\u0435\u0440\u0442\u0435\u04A3",
        afternoon: "\u043A\u04AF\u043D\u0434\u0456\u0437",
        evening: "\u043A\u0435\u0448\u0442\u0435",
        night: "\u0442\u04AF\u043D\u0434\u0435"
    }
};
var $c46ecdcc2f6d7504$var$suffixes = {
    0: "-\u0448\u0456",
    1: "-\u0448\u0456",
    2: "-\u0448\u0456",
    3: "-\u0448\u0456",
    4: "-\u0448\u0456",
    5: "-\u0448\u0456",
    6: "-\u0448\u044B",
    7: "-\u0448\u0456",
    8: "-\u0448\u0456",
    9: "-\u0448\u044B",
    10: "-\u0448\u044B",
    20: "-\u0448\u044B",
    30: "-\u0448\u044B",
    40: "-\u0448\u044B",
    50: "-\u0448\u0456",
    60: "-\u0448\u044B",
    70: "-\u0448\u0456",
    80: "-\u0448\u0456",
    90: "-\u0448\u044B",
    100: "-\u0448\u0456"
};
var $c46ecdcc2f6d7504$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var mod10 = number % 10;
    var b = number >= 100 ? 100 : null;
    var suffix = $c46ecdcc2f6d7504$var$suffixes[number] || $c46ecdcc2f6d7504$var$suffixes[mod10] || b && $c46ecdcc2f6d7504$var$suffixes[b] || "";
    return number + suffix;
};
var $c46ecdcc2f6d7504$var$localize = {
    ordinalNumber: $c46ecdcc2f6d7504$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $c46ecdcc2f6d7504$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $c46ecdcc2f6d7504$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $c46ecdcc2f6d7504$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $c46ecdcc2f6d7504$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $c46ecdcc2f6d7504$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $c46ecdcc2f6d7504$var$dayPeriodValues,
        defaultWidth: "any",
        formattingValues: $c46ecdcc2f6d7504$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $c46ecdcc2f6d7504$export$2e2bcd8739ae039 = $c46ecdcc2f6d7504$var$localize;

});

parcelRegister("iNAcG", function(module, exports) {

$parcel$export(module.exports, "default", () => $daf8e2dc447bac98$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $daf8e2dc447bac98$var$matchOrdinalNumberPattern = /^(\d+)(-?(ші|шы))?/i;
var $daf8e2dc447bac98$var$parseOrdinalNumberPattern = /\d+/i;
var $daf8e2dc447bac98$var$matchEraPatterns = {
    narrow: /^((б )?з\.?\s?д\.?)/i,
    abbreviated: /^((б )?з\.?\s?д\.?)/i,
    wide: /^(біздің заманымызға дейін|біздің заманымыз|біздің заманымыздан)/i
};
var $daf8e2dc447bac98$var$parseEraPatterns = {
    any: [
        /^б/i,
        /^з/i
    ]
};
var $daf8e2dc447bac98$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?ші)? тоқ.?/i,
    wide: /^[1234](-?ші)? тоқсан/i
};
var $daf8e2dc447bac98$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $daf8e2dc447bac98$var$matchMonthPatterns = {
    narrow: /^(қ|а|н|с|м|мау|ш|т|қыр|қаз|қар|ж)/i,
    abbreviated: /^(қаң|ақп|нау|сәу|мам|мау|шіл|там|қыр|қаз|қар|жел)/i,
    wide: /^(қаңтар|ақпан|наурыз|сәуір|мамыр|маусым|шілде|тамыз|қыркүйек|қазан|қараша|желтоқсан)/i
};
var $daf8e2dc447bac98$var$parseMonthPatterns = {
    narrow: [
        /^қ/i,
        /^а/i,
        /^н/i,
        /^с/i,
        /^м/i,
        /^м/i,
        /^ш/i,
        /^т/i,
        /^қ/i,
        /^қ/i,
        /^қ/i,
        /^ж/i
    ],
    abbreviated: [
        /^қаң/i,
        /^ақп/i,
        /^нау/i,
        /^сәу/i,
        /^мам/i,
        /^мау/i,
        /^шіл/i,
        /^там/i,
        /^қыр/i,
        /^қаз/i,
        /^қар/i,
        /^жел/i
    ],
    any: [
        /^қ/i,
        /^а/i,
        /^н/i,
        /^с/i,
        /^м/i,
        /^м/i,
        /^ш/i,
        /^т/i,
        /^қ/i,
        /^қ/i,
        /^қ/i,
        /^ж/i
    ]
};
var $daf8e2dc447bac98$var$matchDayPatterns = {
    narrow: /^(ж|д|с|с|б|ж|с)/i,
    short: /^(жс|дс|сс|ср|бс|жм|сб)/i,
    wide: /^(жексенбі|дүйсенбі|сейсенбі|сәрсенбі|бейсенбі|жұма|сенбі)/i
};
var $daf8e2dc447bac98$var$parseDayPatterns = {
    narrow: [
        /^ж/i,
        /^д/i,
        /^с/i,
        /^с/i,
        /^б/i,
        /^ж/i,
        /^с/i
    ],
    short: [
        /^жс/i,
        /^дс/i,
        /^сс/i,
        /^ср/i,
        /^бс/i,
        /^жм/i,
        /^сб/i
    ],
    any: [
        /^ж[ек]/i,
        /^д[үй]/i,
        /^сe[й]/i,
        /^сә[р]/i,
        /^б[ей]/i,
        /^ж[ұм]/i,
        /^се[н]/i
    ]
};
var $daf8e2dc447bac98$var$matchDayPeriodPatterns = {
    narrow: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
    wide: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
    any: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i
};
var $daf8e2dc447bac98$var$parseDayPeriodPatterns = {
    any: {
        am: /^ТД/i,
        pm: /^ТК/i,
        midnight: /^түн орта/i,
        noon: /^күндіз/i,
        morning: /таң/i,
        afternoon: /түс/i,
        evening: /кеш/i,
        night: /түн/i
    }
};
var $daf8e2dc447bac98$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $daf8e2dc447bac98$var$matchOrdinalNumberPattern,
        parsePattern: $daf8e2dc447bac98$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $daf8e2dc447bac98$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $daf8e2dc447bac98$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $daf8e2dc447bac98$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $daf8e2dc447bac98$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $daf8e2dc447bac98$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $daf8e2dc447bac98$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $daf8e2dc447bac98$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $daf8e2dc447bac98$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $daf8e2dc447bac98$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $daf8e2dc447bac98$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $daf8e2dc447bac98$export$2e2bcd8739ae039 = $daf8e2dc447bac98$var$match;

});


parcelRegister("ggnHB", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd7086bdec29440c$export$2e2bcd8739ae039);

var $jIzEL = parcelRequire("jIzEL");

var $lF8te = parcelRequire("lF8te");

var $3wjpp = parcelRequire("3wjpp");

var $50oBa = parcelRequire("50oBa");

var $940q8 = parcelRequire("940q8");
/**
 * @type {Locale}
 * @category Locales
 * @summary Khmer locale (Cambodian).
 * @language Khmer
 * @iso-639-2 khm
 * @author Seanghay Yath [@seanghay]{@link https://github.com/seanghay}
 */ var $bd7086bdec29440c$var$locale = {
    code: "km",
    formatDistance: (0, $jIzEL.default),
    formatLong: (0, $lF8te.default),
    formatRelative: (0, $3wjpp.default),
    localize: (0, $50oBa.default),
    match: (0, $940q8.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $bd7086bdec29440c$export$2e2bcd8739ae039 = $bd7086bdec29440c$var$locale;

});
parcelRegister("jIzEL", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5adc901179ec2fe$export$2e2bcd8739ae039);
var $e5adc901179ec2fe$var$formatDistanceLocale = {
    lessThanXSeconds: "\u178F\u17B7\u1785\u1787\u17B6\u1784 {{count}} \u179C\u17B7\u1793\u17B6\u1791\u17B8",
    xSeconds: "{{count}} \u179C\u17B7\u1793\u17B6\u1791\u17B8",
    halfAMinute: "\u1780\u1793\u17D2\u179B\u17C7\u1793\u17B6\u1791\u17B8",
    lessThanXMinutes: "\u178F\u17B7\u1785\u1787\u17B6\u1784 {{count}} \u1793\u17B6\u1791\u17B8",
    xMinutes: "{{count}} \u1793\u17B6\u1791\u17B8",
    aboutXHours: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u1798\u17C9\u17C4\u1784",
    xHours: "{{count}} \u1798\u17C9\u17C4\u1784",
    xDays: "{{count}} \u1790\u17D2\u1784\u17C3",
    aboutXWeeks: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u179F\u1794\u17D2\u178F\u17B6\u17A0\u17CD",
    xWeeks: "{{count}} \u179F\u1794\u17D2\u178F\u17B6\u17A0\u17CD",
    aboutXMonths: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u1781\u17C2",
    xMonths: "{{count}} \u1781\u17C2",
    aboutXYears: "\u1794\u17D2\u179A\u17A0\u17C2\u179B {{count}} \u1786\u17D2\u1793\u17B6\u17C6",
    xYears: "{{count}} \u1786\u17D2\u1793\u17B6\u17C6",
    overXYears: "\u1787\u17B6\u1784 {{count}} \u1786\u17D2\u1793\u17B6\u17C6",
    almostXYears: "\u1787\u17B7\u178F {{count}} \u1786\u17D2\u1793\u17B6\u17C6"
};
var $e5adc901179ec2fe$var$formatDistance = function formatDistance(token, count, options) {
    var tokenValue = $e5adc901179ec2fe$var$formatDistanceLocale[token];
    var result = tokenValue;
    if (typeof count === "number") result = result.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u1780\u17D2\u1793\u17BB\u1784\u179A\u1799\u17C8\u1796\u17C1\u179B " + result;
        else return result + "\u1798\u17BB\u1793";
    }
    return result;
};
var $e5adc901179ec2fe$export$2e2bcd8739ae039 = $e5adc901179ec2fe$var$formatDistance;

});

parcelRegister("lF8te", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc53ff63b5a70b86$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $fc53ff63b5a70b86$var$dateFormats = {
    full: "EEEE do MMMM y",
    long: "do MMMM y",
    medium: "d MMM y",
    short: "dd/MM/yyyy"
};
var $fc53ff63b5a70b86$var$timeFormats = {
    full: "h:mm:ss a",
    long: "h:mm:ss a",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $fc53ff63b5a70b86$var$dateTimeFormats = {
    full: "{{date}} '\u1798\u17C9\u17C4\u1784' {{time}}",
    long: "{{date}} '\u1798\u17C9\u17C4\u1784' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $fc53ff63b5a70b86$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $fc53ff63b5a70b86$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $fc53ff63b5a70b86$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $fc53ff63b5a70b86$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $fc53ff63b5a70b86$export$2e2bcd8739ae039 = $fc53ff63b5a70b86$var$formatLong;

});

parcelRegister("3wjpp", function(module, exports) {

$parcel$export(module.exports, "default", () => $29036a75e7720f4e$export$2e2bcd8739ae039);
var $29036a75e7720f4e$var$formatRelativeLocale = {
    lastWeek: "'\u1790\u17D2\u1784\u17C3'eeee'\u179F\u200B\u1794\u17D2\u178F\u17B6\u200B\u17A0\u17CD\u200B\u1798\u17BB\u1793\u1798\u17C9\u17C4\u1784' p",
    yesterday: "'\u1798\u17D2\u179F\u17B7\u179B\u1798\u17B7\u1789\u1793\u17C5\u1798\u17C9\u17C4\u1784' p",
    today: "'\u1790\u17D2\u1784\u17C3\u1793\u17C1\u17C7\u1798\u17C9\u17C4\u1784' p",
    tomorrow: "'\u1790\u17D2\u1784\u17C3\u179F\u17D2\u17A2\u17C2\u1780\u1798\u17C9\u17C4\u1784' p",
    nextWeek: "'\u1790\u17D2\u1784\u17C3'eeee'\u179F\u200B\u1794\u17D2\u178F\u17B6\u200B\u17A0\u17CD\u200B\u1780\u17D2\u179A\u17C4\u1799\u1798\u17C9\u17C4\u1784' p",
    other: "P"
};
var $29036a75e7720f4e$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $29036a75e7720f4e$var$formatRelativeLocale[token];
};
var $29036a75e7720f4e$export$2e2bcd8739ae039 = $29036a75e7720f4e$var$formatRelative;

});

parcelRegister("50oBa", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a500899cbaa9a39$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $3a500899cbaa9a39$var$eraValues = {
    narrow: [
        "\u1798.\u1782\u179F",
        "\u1782\u179F"
    ],
    abbreviated: [
        "\u1798\u17BB\u1793\u1782.\u179F",
        "\u1782.\u179F"
    ],
    wide: [
        "\u1798\u17BB\u1793\u1782\u17D2\u179A\u17B7\u179F\u17D2\u178F\u179F\u1780\u179A\u17B6\u1787",
        "\u1793\u17C3\u1782\u17D2\u179A\u17B7\u179F\u17D2\u178F\u179F\u1780\u179A\u17B6\u1787"
    ]
};
var $3a500899cbaa9a39$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 1",
        "\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 2",
        "\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 3",
        "\u178F\u17D2\u179A\u17B8\u1798\u17B6\u179F\u1791\u17B8 4"
    ]
};
var $3a500899cbaa9a39$var$monthValues = {
    narrow: [
        "\u1798.\u1780",
        "\u1780.\u1798",
        "\u1798\u17B7",
        "\u1798.\u179F",
        "\u17A7.\u179F",
        "\u1798.\u1790",
        "\u1780.\u178A",
        "\u179F\u17B8",
        "\u1780\u1789",
        "\u178F\u17BB",
        "\u179C\u17B7",
        "\u1792"
    ],
    abbreviated: [
        "\u1798\u1780\u179A\u17B6",
        "\u1780\u17BB\u1798\u17D2\u1797\u17C8",
        "\u1798\u17B8\u1793\u17B6",
        "\u1798\u17C1\u179F\u17B6",
        "\u17A7\u179F\u1797\u17B6",
        "\u1798\u17B7\u1790\u17BB\u1793\u17B6",
        "\u1780\u1780\u17D2\u1780\u178A\u17B6",
        "\u179F\u17B8\u17A0\u17B6",
        "\u1780\u1789\u17D2\u1789\u17B6",
        "\u178F\u17BB\u179B\u17B6",
        "\u179C\u17B7\u1785\u17D2\u1786\u17B7\u1780\u17B6",
        "\u1792\u17D2\u1793\u17BC"
    ],
    wide: [
        "\u1798\u1780\u179A\u17B6",
        "\u1780\u17BB\u1798\u17D2\u1797\u17C8",
        "\u1798\u17B8\u1793\u17B6",
        "\u1798\u17C1\u179F\u17B6",
        "\u17A7\u179F\u1797\u17B6",
        "\u1798\u17B7\u1790\u17BB\u1793\u17B6",
        "\u1780\u1780\u17D2\u1780\u178A\u17B6",
        "\u179F\u17B8\u17A0\u17B6",
        "\u1780\u1789\u17D2\u1789\u17B6",
        "\u178F\u17BB\u179B\u17B6",
        "\u179C\u17B7\u1785\u17D2\u1786\u17B7\u1780\u17B6",
        "\u1792\u17D2\u1793\u17BC"
    ]
};
var $3a500899cbaa9a39$var$dayValues = {
    narrow: [
        "\u17A2\u17B6",
        "\u1785",
        "\u17A2",
        "\u1796",
        "\u1796\u17D2\u179A",
        "\u179F\u17BB",
        "\u179F"
    ],
    short: [
        "\u17A2\u17B6",
        "\u1785",
        "\u17A2",
        "\u1796",
        "\u1796\u17D2\u179A",
        "\u179F\u17BB",
        "\u179F"
    ],
    abbreviated: [
        "\u17A2\u17B6",
        "\u1785",
        "\u17A2",
        "\u1796",
        "\u1796\u17D2\u179A",
        "\u179F\u17BB",
        "\u179F"
    ],
    wide: [
        "\u17A2\u17B6\u1791\u17B7\u178F\u17D2\u1799",
        "\u1785\u1793\u17D2\u1791",
        "\u17A2\u1784\u17D2\u1782\u17B6\u179A",
        "\u1796\u17BB\u1792",
        "\u1796\u17D2\u179A\u17A0\u179F\u17D2\u1794\u178F\u17B7\u17CD",
        "\u179F\u17BB\u1780\u17D2\u179A",
        "\u179F\u17C5\u179A\u17CD"
    ]
};
var $3a500899cbaa9a39$var$dayPeriodValues = {
    narrow: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    },
    abbreviated: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    },
    wide: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    }
};
var $3a500899cbaa9a39$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    },
    abbreviated: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    },
    wide: {
        am: "\u1796\u17D2\u179A\u17B9\u1780",
        pm: "\u179B\u17D2\u1784\u17B6\u1785",
        midnight: "\u200B\u1796\u17C1\u179B\u1780\u178E\u17D2\u178A\u17B6\u179B\u17A2\u1792\u17D2\u179A\u17B6\u178F\u17D2\u179A",
        noon: "\u1796\u17C1\u179B\u1790\u17D2\u1784\u17C3\u178F\u17D2\u179A\u1784\u17CB",
        morning: "\u1796\u17C1\u179B\u1796\u17D2\u179A\u17B9\u1780",
        afternoon: "\u1796\u17C1\u179B\u179A\u179F\u17C0\u179B",
        evening: "\u1796\u17C1\u179B\u179B\u17D2\u1784\u17B6\u1785",
        night: "\u1796\u17C1\u179B\u1799\u1794\u17CB"
    }
};
var $3a500899cbaa9a39$var$ordinalNumber = function ordinalNumber(dirtyNumber, _) {
    var number = Number(dirtyNumber);
    return number.toString();
};
var $3a500899cbaa9a39$var$localize = {
    ordinalNumber: $3a500899cbaa9a39$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $3a500899cbaa9a39$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $3a500899cbaa9a39$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $3a500899cbaa9a39$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $3a500899cbaa9a39$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $3a500899cbaa9a39$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $3a500899cbaa9a39$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $3a500899cbaa9a39$export$2e2bcd8739ae039 = $3a500899cbaa9a39$var$localize;

});

parcelRegister("940q8", function(module, exports) {

$parcel$export(module.exports, "default", () => $01b3f2d7f5c9194d$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $01b3f2d7f5c9194d$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $01b3f2d7f5c9194d$var$parseOrdinalNumberPattern = /\d+/i;
var $01b3f2d7f5c9194d$var$matchEraPatterns = {
    narrow: /^(ម\.)?គស/i,
    abbreviated: /^(មុន)?គ\.ស/i,
    wide: /^(មុន|នៃ)គ្រិស្តសករាជ/i
};
var $01b3f2d7f5c9194d$var$parseEraPatterns = {
    any: [
        /^(ម|មុន)គ\.?ស/i,
        /^(នៃ)?គ\.?ស/i
    ]
};
var $01b3f2d7f5c9194d$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^(ត្រីមាស)(ទី)?\s?[1234]/i
};
var $01b3f2d7f5c9194d$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $01b3f2d7f5c9194d$var$matchMonthPatterns = {
    narrow: /^(ម\.ក|ក\.ម|មិ|ម\.ស|ឧ\.ស|ម\.ថ|ក\.ដ|សី|កញ|តុ|វិ|ធ)/i,
    abbreviated: /^(មករា|កុម្ភៈ|មីនា|មេសា|ឧសភា|មិថុនា|កក្កដា|សីហា|កញ្ញា|តុលា|វិច្ឆិកា|ធ្នូ)/i,
    wide: /^(មករា|កុម្ភៈ|មីនា|មេសា|ឧសភា|មិថុនា|កក្កដា|សីហា|កញ្ញា|តុលា|វិច្ឆិកា|ធ្នូ)/i
};
var $01b3f2d7f5c9194d$var$parseMonthPatterns = {
    narrow: [
        /^ម\.ក/i,
        /^ក\.ម/i,
        /^មិ/i,
        /^ម\.ស/i,
        /^ឧ\.ស/i,
        /^ម\.ថ/i,
        /^ក\.ដ/i,
        /^សី/i,
        /^កញ/i,
        /^តុ/i,
        /^វិ/i,
        /^ធ/i
    ],
    any: [
        /^មក/i,
        /^កុ/i,
        /^មីន/i,
        /^មេ/i,
        /^ឧស/i,
        /^មិថ/i,
        /^កក/i,
        /^សី/i,
        /^កញ/i,
        /^តុ/i,
        /^វិច/i,
        /^ធ/i
    ]
};
var $01b3f2d7f5c9194d$var$matchDayPatterns = {
    narrow: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
    short: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
    abbreviated: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
    wide: /^(អាទិត្យ|ចន្ទ|អង្គារ|ពុធ|ព្រហស្បតិ៍|សុក្រ|សៅរ៍)/i
};
var $01b3f2d7f5c9194d$var$parseDayPatterns = {
    narrow: [
        /^អា/i,
        /^ច/i,
        /^អ/i,
        /^ព/i,
        /^ព្រ/i,
        /^សុ/i,
        /^ស/i
    ],
    any: [
        /^អា/i,
        /^ច/i,
        /^អ/i,
        /^ព/i,
        /^ព្រ/i,
        /^សុ/i,
        /^សៅ/i
    ]
};
var $01b3f2d7f5c9194d$var$matchDayPeriodPatterns = {
    narrow: /^(ព្រឹក|ល្ងាច|ពេលព្រឹក|ពេលថ្ងៃត្រង់|ពេលល្ងាច|ពេលរសៀល|ពេលយប់|ពេលកណ្ដាលអធ្រាត្រ)/i,
    any: /^(ព្រឹក|ល្ងាច|ពេលព្រឹក|ពេលថ្ងៃត្រង់|ពេលល្ងាច|ពេលរសៀល|ពេលយប់|ពេលកណ្ដាលអធ្រាត្រ)/i
};
var $01b3f2d7f5c9194d$var$parseDayPeriodPatterns = {
    any: {
        am: /^ព្រឹក/i,
        pm: /^ល្ងាច/i,
        midnight: /^ពេលកណ្ដាលអធ្រាត្រ/i,
        noon: /^ពេលថ្ងៃត្រង់/i,
        morning: /ពេលព្រឹក/i,
        afternoon: /ពេលរសៀល/i,
        evening: /ពេលល្ងាច/i,
        night: /ពេលយប់/i
    }
};
var $01b3f2d7f5c9194d$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $01b3f2d7f5c9194d$var$matchOrdinalNumberPattern,
        parsePattern: $01b3f2d7f5c9194d$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $01b3f2d7f5c9194d$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $01b3f2d7f5c9194d$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $01b3f2d7f5c9194d$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $01b3f2d7f5c9194d$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $01b3f2d7f5c9194d$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $01b3f2d7f5c9194d$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $01b3f2d7f5c9194d$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $01b3f2d7f5c9194d$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $01b3f2d7f5c9194d$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $01b3f2d7f5c9194d$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $01b3f2d7f5c9194d$export$2e2bcd8739ae039 = $01b3f2d7f5c9194d$var$match;

});


parcelRegister("eNTfn", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac707f39102d7e1d$export$2e2bcd8739ae039);

var $fRyAJ = parcelRequire("fRyAJ");

var $6kLga = parcelRequire("6kLga");

var $kaoue = parcelRequire("kaoue");

var $dalJo = parcelRequire("dalJo");

var $cIlMU = parcelRequire("cIlMU");
/**
 * @type {Locale}
 * @category Locales
 * @summary Kannada locale (India).
 * @language Kannada
 * @iso-639-2 kan
 * @author Manjunatha Gouli [@developergouli]{@link https://github.com/developergouli}
 */ var $ac707f39102d7e1d$var$locale = {
    code: "kn",
    formatDistance: (0, $fRyAJ.default),
    formatLong: (0, $6kLga.default),
    formatRelative: (0, $kaoue.default),
    localize: (0, $dalJo.default),
    match: (0, $cIlMU.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $ac707f39102d7e1d$export$2e2bcd8739ae039 = $ac707f39102d7e1d$var$locale;

});
parcelRegister("fRyAJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8c6a3672cda5e49$export$2e2bcd8739ae039);
// note: no implementation for weeks
var $b8c6a3672cda5e49$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            default: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        },
        other: {
            default: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        }
    },
    xSeconds: {
        one: {
            default: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD",
            future: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0CA8\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CC1\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD\u200C\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CB8\u0CC6\u0C95\u0CC6\u0C82\u0CA1\u0CCD \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    halfAMinute: {
        other: {
            default: "\u0C85\u0CB0\u0CCD\u0CA7 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7",
            future: "\u0C85\u0CB0\u0CCD\u0CA7 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0C85\u0CB0\u0CCD\u0CA7 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    lessThanXMinutes: {
        one: {
            default: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        },
        other: {
            default: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            future: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6",
            past: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C95\u0CCD\u0C95\u0CBF\u0C82\u0CA4 \u0C95\u0CA1\u0CBF\u0CAE\u0CC6"
        }
    },
    xMinutes: {
        one: {
            default: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7",
            future: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CA8\u0CBF\u0CAE\u0CBF\u0CB7\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    aboutXHours: {
        one: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0C97\u0C82\u0C9F\u0CC6",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0C97\u0C82\u0C9F\u0CC6\u0CAF\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0C97\u0C82\u0C9F\u0CC6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    xHours: {
        one: {
            default: "1 \u0C97\u0C82\u0C9F\u0CC6",
            future: "1 \u0C97\u0C82\u0C9F\u0CC6\u0CAF\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0C97\u0C82\u0C9F\u0CC6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0C97\u0C82\u0C9F\u0CC6\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    xDays: {
        one: {
            default: "1 \u0CA6\u0CBF\u0CA8",
            future: "1 \u0CA6\u0CBF\u0CA8\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CA6\u0CBF\u0CA8\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CA6\u0CBF\u0CA8\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CA6\u0CBF\u0CA8\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CA6\u0CBF\u0CA8\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    // TODO
    // aboutXWeeks: {},
    // TODO
    // xWeeks: {},
    aboutXMonths: {
        one: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    xMonths: {
        one: {
            default: "1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CA4\u0CBF\u0C82\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CA4\u0CBF\u0C82\u0C97\u0CB3\u0CC1\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    aboutXYears: {
        one: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CB5\u0CB0\u0CCD\u0CB7",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CC1",
            future: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CB8\u0CC1\u0CAE\u0CBE\u0CB0\u0CC1 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    xYears: {
        one: {
            default: "1 \u0CB5\u0CB0\u0CCD\u0CB7",
            future: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        },
        other: {
            default: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CC1",
            future: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CB9\u0CBF\u0C82\u0CA6\u0CC6"
        }
    },
    overXYears: {
        one: {
            default: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CAE\u0CC7\u0CB2\u0CC6",
            future: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CAE\u0CC7\u0CB2\u0CC6",
            past: "1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6 \u0CAE\u0CC7\u0CB2\u0CC6"
        },
        other: {
            default: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CAE\u0CC7\u0CB2\u0CC6",
            future: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CAE\u0CC7\u0CB2\u0CC6",
            past: "{{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3 \u0CAE\u0CC7\u0CB2\u0CC6"
        }
    },
    almostXYears: {
        one: {
            default: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            future: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 1 \u0CB5\u0CB0\u0CCD\u0CB7\u0CA6\u0CB2\u0CCD\u0CB2\u0CBF"
        },
        other: {
            default: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            future: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF",
            past: "\u0CAC\u0CB9\u0CC1\u0CA4\u0CC7\u0C95 {{count}} \u0CB5\u0CB0\u0CCD\u0CB7\u0C97\u0CB3\u0CB2\u0CCD\u0CB2\u0CBF"
        }
    }
};
function $b8c6a3672cda5e49$var$getResultByTense(parentToken, options) {
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return parentToken.future;
        else return parentToken.past;
    }
    return parentToken.default;
}
var $b8c6a3672cda5e49$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $b8c6a3672cda5e49$var$formatDistanceLocale[token];
    if (tokenValue.one && count === 1) result = $b8c6a3672cda5e49$var$getResultByTense(tokenValue.one, options);
    else result = $b8c6a3672cda5e49$var$getResultByTense(tokenValue.other, options);
    return result.replace("{{count}}", String(count));
};
var $b8c6a3672cda5e49$export$2e2bcd8739ae039 = $b8c6a3672cda5e49$var$formatDistance;

});

parcelRegister("6kLga", function(module, exports) {

$parcel$export(module.exports, "default", () => $49c945285ca668d5$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $49c945285ca668d5$var$dateFormats = {
    full: "EEEE, MMMM d, y",
    // CLDR 1816
    long: "MMMM d, y",
    // CLDR 1817
    medium: "MMM d, y",
    // CLDR 1818
    short: "d/M/yy" // CLDR 1819
};
var $49c945285ca668d5$var$timeFormats = {
    full: "hh:mm:ss a zzzz",
    // CLDR 1820
    long: "hh:mm:ss a z",
    // CLDR 1821
    medium: "hh:mm:ss a",
    // CLDR 1822
    short: "hh:mm a" // CLDR 1823
};
var $49c945285ca668d5$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    // CLDR 1824
    long: "{{date}} {{time}}",
    // CLDR 1825
    medium: "{{date}} {{time}}",
    // CLDR 1826
    short: "{{date}} {{time}}" // CLDR 1827
};
var $49c945285ca668d5$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $49c945285ca668d5$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $49c945285ca668d5$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $49c945285ca668d5$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $49c945285ca668d5$export$2e2bcd8739ae039 = $49c945285ca668d5$var$formatLong;

});

parcelRegister("kaoue", function(module, exports) {

$parcel$export(module.exports, "default", () => $eae7bc58ad1abbc8$export$2e2bcd8739ae039);
var $eae7bc58ad1abbc8$var$formatRelativeLocale = {
    lastWeek: "'\u0C95\u0CB3\u0CC6\u0CA6' eeee p '\u0C95\u0CCD\u0C95\u0CC6'",
    yesterday: "'\u0CA8\u0CBF\u0CA8\u0CCD\u0CA8\u0CC6' p '\u0C95\u0CCD\u0C95\u0CC6'",
    today: "'\u0C87\u0C82\u0CA6\u0CC1' p '\u0C95\u0CCD\u0C95\u0CC6'",
    tomorrow: "'\u0CA8\u0CBE\u0CB3\u0CC6' p '\u0C95\u0CCD\u0C95\u0CC6'",
    nextWeek: "eeee p '\u0C95\u0CCD\u0C95\u0CC6'",
    other: "P"
};
var $eae7bc58ad1abbc8$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $eae7bc58ad1abbc8$var$formatRelativeLocale[token];
};
var $eae7bc58ad1abbc8$export$2e2bcd8739ae039 = $eae7bc58ad1abbc8$var$formatRelative;

});

parcelRegister("dalJo", function(module, exports) {

$parcel$export(module.exports, "default", () => $995d10e602f25a7e$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $995d10e602f25a7e$var$eraValues = {
    narrow: [
        "\u0C95\u0CCD\u0CB0\u0CBF.\u0CAA\u0CC2",
        "\u0C95\u0CCD\u0CB0\u0CBF.\u0CB6"
    ],
    abbreviated: [
        "\u0C95\u0CCD\u0CB0\u0CBF.\u0CAA\u0CC2",
        "\u0C95\u0CCD\u0CB0\u0CBF.\u0CB6"
    ],
    // CLDR #1618, #1620
    wide: [
        "\u0C95\u0CCD\u0CB0\u0CBF\u0CB8\u0CCD\u0CA4 \u0CAA\u0CC2\u0CB0\u0CCD\u0CB5",
        "\u0C95\u0CCD\u0CB0\u0CBF\u0CB8\u0CCD\u0CA4 \u0CB6\u0C95"
    ] // CLDR #1614, #1616
};
var $995d10e602f25a7e$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u0CA4\u0CCD\u0CB0\u0CC8 1",
        "\u0CA4\u0CCD\u0CB0\u0CC8 2",
        "\u0CA4\u0CCD\u0CB0\u0CC8 3",
        "\u0CA4\u0CCD\u0CB0\u0CC8 4"
    ],
    // CLDR #1630 - #1638
    wide: [
        "1\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95",
        "2\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95",
        "3\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95",
        "4\u0CA8\u0CC7 \u0CA4\u0CCD\u0CB0\u0CC8\u0CAE\u0CBE\u0CB8\u0CBF\u0C95"
    ] // CLDR #1622 - #1629
};
// CLDR #1646 - #1717
var $995d10e602f25a7e$var$monthValues = {
    narrow: [
        "\u0C9C",
        "\u0CAB\u0CC6",
        "\u0CAE\u0CBE",
        "\u0C8F",
        "\u0CAE\u0CC7",
        "\u0C9C\u0CC2",
        "\u0C9C\u0CC1",
        "\u0C86",
        "\u0CB8\u0CC6",
        "\u0C85",
        "\u0CA8",
        "\u0CA1\u0CBF"
    ],
    abbreviated: [
        "\u0C9C\u0CA8",
        "\u0CAB\u0CC6\u0CAC\u0CCD\u0CB0",
        "\u0CAE\u0CBE\u0CB0\u0CCD\u0C9A\u0CCD",
        "\u0C8F\u0CAA\u0CCD\u0CB0\u0CBF",
        "\u0CAE\u0CC7",
        "\u0C9C\u0CC2\u0CA8\u0CCD",
        "\u0C9C\u0CC1\u0CB2\u0CC8",
        "\u0C86\u0C97",
        "\u0CB8\u0CC6\u0CAA\u0CCD\u0C9F\u0CC6\u0C82",
        "\u0C85\u0C95\u0CCD\u0C9F\u0CCB",
        "\u0CA8\u0CB5\u0CC6\u0C82",
        "\u0CA1\u0CBF\u0CB8\u0CC6\u0C82"
    ],
    wide: [
        "\u0C9C\u0CA8\u0CB5\u0CB0\u0CBF",
        "\u0CAB\u0CC6\u0CAC\u0CCD\u0CB0\u0CB5\u0CB0\u0CBF",
        "\u0CAE\u0CBE\u0CB0\u0CCD\u0C9A\u0CCD",
        "\u0C8F\u0CAA\u0CCD\u0CB0\u0CBF\u0CB2\u0CCD",
        "\u0CAE\u0CC7",
        "\u0C9C\u0CC2\u0CA8\u0CCD",
        "\u0C9C\u0CC1\u0CB2\u0CC8",
        "\u0C86\u0C97\u0CB8\u0CCD\u0C9F\u0CCD",
        "\u0CB8\u0CC6\u0CAA\u0CCD\u0C9F\u0CC6\u0C82\u0CAC\u0CB0\u0CCD",
        "\u0C85\u0C95\u0CCD\u0C9F\u0CCB\u0CAC\u0CB0\u0CCD",
        "\u0CA8\u0CB5\u0CC6\u0C82\u0CAC\u0CB0\u0CCD",
        "\u0CA1\u0CBF\u0CB8\u0CC6\u0C82\u0CAC\u0CB0\u0CCD"
    ]
};
// CLDR #1718 - #1773
var $995d10e602f25a7e$var$dayValues = {
    narrow: [
        "\u0CAD\u0CBE",
        "\u0CB8\u0CCB",
        "\u0CAE\u0C82",
        "\u0CAC\u0CC1",
        "\u0C97\u0CC1",
        "\u0CB6\u0CC1",
        "\u0CB6"
    ],
    short: [
        "\u0CAD\u0CBE\u0CA8\u0CC1",
        "\u0CB8\u0CCB\u0CAE",
        "\u0CAE\u0C82\u0C97\u0CB3",
        "\u0CAC\u0CC1\u0CA7",
        "\u0C97\u0CC1\u0CB0\u0CC1",
        "\u0CB6\u0CC1\u0C95\u0CCD\u0CB0",
        "\u0CB6\u0CA8\u0CBF"
    ],
    abbreviated: [
        "\u0CAD\u0CBE\u0CA8\u0CC1",
        "\u0CB8\u0CCB\u0CAE",
        "\u0CAE\u0C82\u0C97\u0CB3",
        "\u0CAC\u0CC1\u0CA7",
        "\u0C97\u0CC1\u0CB0\u0CC1",
        "\u0CB6\u0CC1\u0C95\u0CCD\u0CB0",
        "\u0CB6\u0CA8\u0CBF"
    ],
    wide: [
        "\u0CAD\u0CBE\u0CA8\u0CC1\u0CB5\u0CBE\u0CB0",
        "\u0CB8\u0CCB\u0CAE\u0CB5\u0CBE\u0CB0",
        "\u0CAE\u0C82\u0C97\u0CB3\u0CB5\u0CBE\u0CB0",
        "\u0CAC\u0CC1\u0CA7\u0CB5\u0CBE\u0CB0",
        "\u0C97\u0CC1\u0CB0\u0CC1\u0CB5\u0CBE\u0CB0",
        "\u0CB6\u0CC1\u0C95\u0CCD\u0CB0\u0CB5\u0CBE\u0CB0",
        "\u0CB6\u0CA8\u0CBF\u0CB5\u0CBE\u0CB0"
    ]
};
// CLDR #1774 - #1815
var $995d10e602f25a7e$var$dayPeriodValues = {
    narrow: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CB9\u0CCD\u0CA8",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CB9\u0CCD\u0CA8",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    },
    abbreviated: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    },
    wide: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    }
};
var $995d10e602f25a7e$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0CAA\u0CC2",
        pm: "\u0C85",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    },
    abbreviated: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF \u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    },
    wide: {
        am: "\u0CAA\u0CC2\u0CB0\u0CCD\u0CB5\u0CBE\u0CB9\u0CCD\u0CA8",
        pm: "\u0C85\u0CAA\u0CB0\u0CBE\u0CB9\u0CCD\u0CA8",
        midnight: "\u0CAE\u0CA7\u0CCD\u0CAF \u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF",
        noon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        morning: "\u0CAC\u0CC6\u0CB3\u0C97\u0CCD\u0C97\u0CC6",
        afternoon: "\u0CAE\u0CA7\u0CCD\u0CAF\u0CBE\u0CA8\u0CCD\u0CB9",
        evening: "\u0CB8\u0C82\u0C9C\u0CC6",
        night: "\u0CB0\u0CBE\u0CA4\u0CCD\u0CB0\u0CBF"
    }
};
var $995d10e602f25a7e$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\u0CA8\u0CC7";
};
var $995d10e602f25a7e$var$localize = {
    ordinalNumber: $995d10e602f25a7e$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $995d10e602f25a7e$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $995d10e602f25a7e$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $995d10e602f25a7e$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $995d10e602f25a7e$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $995d10e602f25a7e$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $995d10e602f25a7e$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $995d10e602f25a7e$export$2e2bcd8739ae039 = $995d10e602f25a7e$var$localize;

});

parcelRegister("cIlMU", function(module, exports) {

$parcel$export(module.exports, "default", () => $941a7eb3fdf91d90$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $941a7eb3fdf91d90$var$matchOrdinalNumberPattern = /^(\d+)(ನೇ|ನೆ)?/i;
var $941a7eb3fdf91d90$var$parseOrdinalNumberPattern = /\d+/i;
var $941a7eb3fdf91d90$var$matchEraPatterns = {
    narrow: /^(ಕ್ರಿ.ಪೂ|ಕ್ರಿ.ಶ)/i,
    abbreviated: /^(ಕ್ರಿ\.?\s?ಪೂ\.?|ಕ್ರಿ\.?\s?ಶ\.?|ಪ್ರ\.?\s?ಶ\.?)/i,
    wide: /^(ಕ್ರಿಸ್ತ ಪೂರ್ವ|ಕ್ರಿಸ್ತ ಶಕ|ಪ್ರಸಕ್ತ ಶಕ)/i
};
var $941a7eb3fdf91d90$var$parseEraPatterns = {
    any: [
        /^ಪೂ/i,
        /^(ಶ|ಪ್ರ)/i
    ]
};
var $941a7eb3fdf91d90$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^ತ್ರೈ[1234]|ತ್ರೈ [1234]| [1234]ತ್ರೈ/i,
    wide: /^[1234](ನೇ)? ತ್ರೈಮಾಸಿಕ/i
};
var $941a7eb3fdf91d90$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $941a7eb3fdf91d90$var$matchMonthPatterns = {
    narrow: /^(ಜೂ|ಜು|ಜ|ಫೆ|ಮಾ|ಏ|ಮೇ|ಆ|ಸೆ|ಅ|ನ|ಡಿ)/i,
    abbreviated: /^(ಜನ|ಫೆಬ್ರ|ಮಾರ್ಚ್|ಏಪ್ರಿ|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗ|ಸೆಪ್ಟೆಂ|ಅಕ್ಟೋ|ನವೆಂ|ಡಿಸೆಂ)/i,
    wide: /^(ಜನವರಿ|ಫೆಬ್ರವರಿ|ಮಾರ್ಚ್|ಏಪ್ರಿಲ್|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗಸ್ಟ್|ಸೆಪ್ಟೆಂಬರ್|ಅಕ್ಟೋಬರ್|ನವೆಂಬರ್|ಡಿಸೆಂಬರ್)/i
};
var $941a7eb3fdf91d90$var$parseMonthPatterns = {
    narrow: [
        /^ಜ$/i,
        /^ಫೆ/i,
        /^ಮಾ/i,
        /^ಏ/i,
        /^ಮೇ/i,
        /^ಜೂ/i,
        /^ಜು$/i,
        /^ಆ/i,
        /^ಸೆ/i,
        /^ಅ/i,
        /^ನ/i,
        /^ಡಿ/i
    ],
    any: [
        /^ಜನ/i,
        /^ಫೆ/i,
        /^ಮಾ/i,
        /^ಏ/i,
        /^ಮೇ/i,
        /^ಜೂನ್/i,
        /^ಜುಲೈ/i,
        /^ಆ/i,
        /^ಸೆ/i,
        /^ಅ/i,
        /^ನ/i,
        /^ಡಿ/i
    ]
};
var $941a7eb3fdf91d90$var$matchDayPatterns = {
    narrow: /^(ಭಾ|ಸೋ|ಮ|ಬು|ಗು|ಶು|ಶ)/i,
    short: /^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
    abbreviated: /^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
    wide: /^(ಭಾನುವಾರ|ಸೋಮವಾರ|ಮಂಗಳವಾರ|ಬುಧವಾರ|ಗುರುವಾರ|ಶುಕ್ರವಾರ|ಶನಿವಾರ)/i
};
var $941a7eb3fdf91d90$var$parseDayPatterns = {
    narrow: [
        /^ಭಾ/i,
        /^ಸೋ/i,
        /^ಮ/i,
        /^ಬು/i,
        /^ಗು/i,
        /^ಶು/i,
        /^ಶ/i
    ],
    any: [
        /^ಭಾ/i,
        /^ಸೋ/i,
        /^ಮ/i,
        /^ಬು/i,
        /^ಗು/i,
        /^ಶು/i,
        /^ಶ/i
    ]
};
var $941a7eb3fdf91d90$var$matchDayPeriodPatterns = {
    narrow: /^(ಪೂ|ಅ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i,
    any: /^(ಪೂರ್ವಾಹ್ನ|ಅಪರಾಹ್ನ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i
};
var $941a7eb3fdf91d90$var$parseDayPeriodPatterns = {
    any: {
        am: /^ಪೂ/i,
        pm: /^ಅ/i,
        midnight: /ಮಧ್ಯರಾತ್ರಿ/i,
        noon: /ಮಧ್ಯಾನ್ಹ/i,
        morning: /ಬೆಳಗ್ಗೆ/i,
        afternoon: /ಮಧ್ಯಾನ್ಹ/i,
        evening: /ಸಂಜೆ/i,
        night: /ರಾತ್ರಿ/i
    }
};
var $941a7eb3fdf91d90$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $941a7eb3fdf91d90$var$matchOrdinalNumberPattern,
        parsePattern: $941a7eb3fdf91d90$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $941a7eb3fdf91d90$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $941a7eb3fdf91d90$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $941a7eb3fdf91d90$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $941a7eb3fdf91d90$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $941a7eb3fdf91d90$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $941a7eb3fdf91d90$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $941a7eb3fdf91d90$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $941a7eb3fdf91d90$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $941a7eb3fdf91d90$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $941a7eb3fdf91d90$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $941a7eb3fdf91d90$export$2e2bcd8739ae039 = $941a7eb3fdf91d90$var$match;

});


parcelRegister("at6wq", function(module, exports) {

$parcel$export(module.exports, "default", () => $79f1abed42a704ec$export$2e2bcd8739ae039);

var $a8I2T = parcelRequire("a8I2T");

var $4ttRL = parcelRequire("4ttRL");

var $hVWJV = parcelRequire("hVWJV");

var $fb5Vh = parcelRequire("fb5Vh");

var $gttHN = parcelRequire("gttHN");
/**
 * @type {Locale}
 * @category Locales
 * @summary Korean locale.
 * @language Korean
 * @iso-639-2 kor
 * @author Hong Chulju [@angdev]{@link https://github.com/angdev}
 * @author Lee Seoyoen [@iamssen]{@link https://github.com/iamssen}
 * @author Taiki IKeda [@so99ynoodles]{@link https://github.com/so99ynoodles}
 */ var $79f1abed42a704ec$var$locale = {
    code: "ko",
    formatDistance: (0, $a8I2T.default),
    formatLong: (0, $4ttRL.default),
    formatRelative: (0, $hVWJV.default),
    localize: (0, $fb5Vh.default),
    match: (0, $gttHN.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $79f1abed42a704ec$export$2e2bcd8739ae039 = $79f1abed42a704ec$var$locale;

});
parcelRegister("a8I2T", function(module, exports) {

$parcel$export(module.exports, "default", () => $761cd1487d1bb5cb$export$2e2bcd8739ae039);
var $761cd1487d1bb5cb$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1\uCD08 \uBBF8\uB9CC",
        other: "{{count}}\uCD08 \uBBF8\uB9CC"
    },
    xSeconds: {
        one: "1\uCD08",
        other: "{{count}}\uCD08"
    },
    halfAMinute: "30\uCD08",
    lessThanXMinutes: {
        one: "1\uBD84 \uBBF8\uB9CC",
        other: "{{count}}\uBD84 \uBBF8\uB9CC"
    },
    xMinutes: {
        one: "1\uBD84",
        other: "{{count}}\uBD84"
    },
    aboutXHours: {
        one: "\uC57D 1\uC2DC\uAC04",
        other: "\uC57D {{count}}\uC2DC\uAC04"
    },
    xHours: {
        one: "1\uC2DC\uAC04",
        other: "{{count}}\uC2DC\uAC04"
    },
    xDays: {
        one: "1\uC77C",
        other: "{{count}}\uC77C"
    },
    aboutXWeeks: {
        one: "\uC57D 1\uC8FC",
        other: "\uC57D {{count}}\uC8FC"
    },
    xWeeks: {
        one: "1\uC8FC",
        other: "{{count}}\uC8FC"
    },
    aboutXMonths: {
        one: "\uC57D 1\uAC1C\uC6D4",
        other: "\uC57D {{count}}\uAC1C\uC6D4"
    },
    xMonths: {
        one: "1\uAC1C\uC6D4",
        other: "{{count}}\uAC1C\uC6D4"
    },
    aboutXYears: {
        one: "\uC57D 1\uB144",
        other: "\uC57D {{count}}\uB144"
    },
    xYears: {
        one: "1\uB144",
        other: "{{count}}\uB144"
    },
    overXYears: {
        one: "1\uB144 \uC774\uC0C1",
        other: "{{count}}\uB144 \uC774\uC0C1"
    },
    almostXYears: {
        one: "\uAC70\uC758 1\uB144",
        other: "\uAC70\uC758 {{count}}\uB144"
    }
};
var $761cd1487d1bb5cb$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $761cd1487d1bb5cb$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " \uD6C4";
        else return result + " \uC804";
    }
    return result;
};
var $761cd1487d1bb5cb$export$2e2bcd8739ae039 = $761cd1487d1bb5cb$var$formatDistance;

});

parcelRegister("4ttRL", function(module, exports) {

$parcel$export(module.exports, "default", () => $342109ab58addaab$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $342109ab58addaab$var$dateFormats = {
    full: "y\uB144 M\uC6D4 d\uC77C EEEE",
    long: "y\uB144 M\uC6D4 d\uC77C",
    medium: "y.MM.dd",
    short: "y.MM.dd"
};
var $342109ab58addaab$var$timeFormats = {
    full: "a H\uC2DC mm\uBD84 ss\uCD08 zzzz",
    long: "a H:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $342109ab58addaab$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $342109ab58addaab$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $342109ab58addaab$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $342109ab58addaab$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $342109ab58addaab$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $342109ab58addaab$export$2e2bcd8739ae039 = $342109ab58addaab$var$formatLong;

});

parcelRegister("hVWJV", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0e55304eb57cb8a$export$2e2bcd8739ae039);
var $d0e55304eb57cb8a$var$formatRelativeLocale = {
    lastWeek: "'\uC9C0\uB09C' eeee p",
    yesterday: "'\uC5B4\uC81C' p",
    today: "'\uC624\uB298' p",
    tomorrow: "'\uB0B4\uC77C' p",
    nextWeek: "'\uB2E4\uC74C' eeee p",
    other: "P"
};
var $d0e55304eb57cb8a$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $d0e55304eb57cb8a$var$formatRelativeLocale[token];
};
var $d0e55304eb57cb8a$export$2e2bcd8739ae039 = $d0e55304eb57cb8a$var$formatRelative;

});

parcelRegister("fb5Vh", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0cc7a3d7de7d19f$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $b0cc7a3d7de7d19f$var$eraValues = {
    narrow: [
        "BC",
        "AD"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "\uAE30\uC6D0\uC804",
        "\uC11C\uAE30"
    ]
};
var $b0cc7a3d7de7d19f$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1\uBD84\uAE30",
        "2\uBD84\uAE30",
        "3\uBD84\uAE30",
        "4\uBD84\uAE30"
    ]
};
var $b0cc7a3d7de7d19f$var$monthValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12"
    ],
    abbreviated: [
        "1\uC6D4",
        "2\uC6D4",
        "3\uC6D4",
        "4\uC6D4",
        "5\uC6D4",
        "6\uC6D4",
        "7\uC6D4",
        "8\uC6D4",
        "9\uC6D4",
        "10\uC6D4",
        "11\uC6D4",
        "12\uC6D4"
    ],
    wide: [
        "1\uC6D4",
        "2\uC6D4",
        "3\uC6D4",
        "4\uC6D4",
        "5\uC6D4",
        "6\uC6D4",
        "7\uC6D4",
        "8\uC6D4",
        "9\uC6D4",
        "10\uC6D4",
        "11\uC6D4",
        "12\uC6D4"
    ]
};
var $b0cc7a3d7de7d19f$var$dayValues = {
    narrow: [
        "\uC77C",
        "\uC6D4",
        "\uD654",
        "\uC218",
        "\uBAA9",
        "\uAE08",
        "\uD1A0"
    ],
    short: [
        "\uC77C",
        "\uC6D4",
        "\uD654",
        "\uC218",
        "\uBAA9",
        "\uAE08",
        "\uD1A0"
    ],
    abbreviated: [
        "\uC77C",
        "\uC6D4",
        "\uD654",
        "\uC218",
        "\uBAA9",
        "\uAE08",
        "\uD1A0"
    ],
    wide: [
        "\uC77C\uC694\uC77C",
        "\uC6D4\uC694\uC77C",
        "\uD654\uC694\uC77C",
        "\uC218\uC694\uC77C",
        "\uBAA9\uC694\uC77C",
        "\uAE08\uC694\uC77C",
        "\uD1A0\uC694\uC77C"
    ]
};
var $b0cc7a3d7de7d19f$var$dayPeriodValues = {
    narrow: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    abbreviated: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    wide: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    }
};
var $b0cc7a3d7de7d19f$var$formattingDayPeriodValues = {
    narrow: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    abbreviated: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    },
    wide: {
        am: "\uC624\uC804",
        pm: "\uC624\uD6C4",
        midnight: "\uC790\uC815",
        noon: "\uC815\uC624",
        morning: "\uC544\uCE68",
        afternoon: "\uC624\uD6C4",
        evening: "\uC800\uB141",
        night: "\uBC24"
    }
};
var $b0cc7a3d7de7d19f$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    switch(unit){
        case "minute":
        case "second":
            return String(number);
        case "date":
            return number + "\uC77C";
        default:
            return number + "\uBC88\uC9F8";
    }
};
var $b0cc7a3d7de7d19f$var$localize = {
    ordinalNumber: $b0cc7a3d7de7d19f$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $b0cc7a3d7de7d19f$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $b0cc7a3d7de7d19f$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $b0cc7a3d7de7d19f$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $b0cc7a3d7de7d19f$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $b0cc7a3d7de7d19f$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $b0cc7a3d7de7d19f$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $b0cc7a3d7de7d19f$export$2e2bcd8739ae039 = $b0cc7a3d7de7d19f$var$localize;

});

parcelRegister("gttHN", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfe665a776fe466e$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $bfe665a776fe466e$var$matchOrdinalNumberPattern = /^(\d+)(일|번째)?/i;
var $bfe665a776fe466e$var$parseOrdinalNumberPattern = /\d+/i;
var $bfe665a776fe466e$var$matchEraPatterns = {
    narrow: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(기원전|서기)/i
};
var $bfe665a776fe466e$var$parseEraPatterns = {
    any: [
        /^(bc|기원전)/i,
        /^(ad|서기)/i
    ]
};
var $bfe665a776fe466e$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]사?분기/i
};
var $bfe665a776fe466e$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $bfe665a776fe466e$var$matchMonthPatterns = {
    narrow: /^(1[012]|[123456789])/,
    abbreviated: /^(1[012]|[123456789])월/i,
    wide: /^(1[012]|[123456789])월/i
};
var $bfe665a776fe466e$var$parseMonthPatterns = {
    any: [
        /^1월?$/,
        /^2/,
        /^3/,
        /^4/,
        /^5/,
        /^6/,
        /^7/,
        /^8/,
        /^9/,
        /^10/,
        /^11/,
        /^12/
    ]
};
var $bfe665a776fe466e$var$matchDayPatterns = {
    narrow: /^[일월화수목금토]/,
    short: /^[일월화수목금토]/,
    abbreviated: /^[일월화수목금토]/,
    wide: /^[일월화수목금토]요일/
};
var $bfe665a776fe466e$var$parseDayPatterns = {
    any: [
        /^일/,
        /^월/,
        /^화/,
        /^수/,
        /^목/,
        /^금/,
        /^토/
    ]
};
var $bfe665a776fe466e$var$matchDayPeriodPatterns = {
    any: /^(am|pm|오전|오후|자정|정오|아침|저녁|밤)/i
};
var $bfe665a776fe466e$var$parseDayPeriodPatterns = {
    any: {
        am: /^(am|오전)/i,
        pm: /^(pm|오후)/i,
        midnight: /^자정/i,
        noon: /^정오/i,
        morning: /^아침/i,
        afternoon: /^오후/i,
        evening: /^저녁/i,
        night: /^밤/i
    }
};
var $bfe665a776fe466e$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $bfe665a776fe466e$var$matchOrdinalNumberPattern,
        parsePattern: $bfe665a776fe466e$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $bfe665a776fe466e$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bfe665a776fe466e$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $bfe665a776fe466e$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bfe665a776fe466e$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $bfe665a776fe466e$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bfe665a776fe466e$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $bfe665a776fe466e$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $bfe665a776fe466e$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $bfe665a776fe466e$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $bfe665a776fe466e$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $bfe665a776fe466e$export$2e2bcd8739ae039 = $bfe665a776fe466e$var$match;

});


parcelRegister("3Qi5Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cc443d0170f1767$export$2e2bcd8739ae039);

var $hAGqC = parcelRequire("hAGqC");

var $dlrhS = parcelRequire("dlrhS");

var $3hN1O = parcelRequire("3hN1O");

var $6TkeE = parcelRequire("6TkeE");

var $89PKe = parcelRequire("89PKe");
/**
 * @type {Locale}
 * @category Locales
 * @summary Luxembourgish locale.
 * @language Luxembourgish
 * @iso-639-2 ltz
 * @author Daniel Waxweiler [@dwaxweiler]{@link https://github.com/dwaxweiler}
 */ var $2cc443d0170f1767$var$locale = {
    code: "lb",
    formatDistance: (0, $hAGqC.default),
    formatLong: (0, $dlrhS.default),
    formatRelative: (0, $3hN1O.default),
    localize: (0, $6TkeE.default),
    match: (0, $89PKe.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $2cc443d0170f1767$export$2e2bcd8739ae039 = $2cc443d0170f1767$var$locale;

});
parcelRegister("hAGqC", function(module, exports) {

$parcel$export(module.exports, "default", () => $cce6b5de16ff62fc$export$2e2bcd8739ae039);
var $cce6b5de16ff62fc$var$formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: "manner w\xe9i eng Sekonn",
            other: "manner w\xe9i {{count}} Sekonnen"
        },
        withPreposition: {
            one: "manner w\xe9i enger Sekonn",
            other: "manner w\xe9i {{count}} Sekonnen"
        }
    },
    xSeconds: {
        standalone: {
            one: "eng Sekonn",
            other: "{{count}} Sekonnen"
        },
        withPreposition: {
            one: "enger Sekonn",
            other: "{{count}} Sekonnen"
        }
    },
    halfAMinute: {
        standalone: "eng hallef Minutt",
        withPreposition: "enger hallwer Minutt"
    },
    lessThanXMinutes: {
        standalone: {
            one: "manner w\xe9i eng Minutt",
            other: "manner w\xe9i {{count}} Minutten"
        },
        withPreposition: {
            one: "manner w\xe9i enger Minutt",
            other: "manner w\xe9i {{count}} Minutten"
        }
    },
    xMinutes: {
        standalone: {
            one: "eng Minutt",
            other: "{{count}} Minutten"
        },
        withPreposition: {
            one: "enger Minutt",
            other: "{{count}} Minutten"
        }
    },
    aboutXHours: {
        standalone: {
            one: "ongef\xe9ier eng Stonn",
            other: "ongef\xe9ier {{count}} Stonnen"
        },
        withPreposition: {
            one: "ongef\xe9ier enger Stonn",
            other: "ongef\xe9ier {{count}} Stonnen"
        }
    },
    xHours: {
        standalone: {
            one: "eng Stonn",
            other: "{{count}} Stonnen"
        },
        withPreposition: {
            one: "enger Stonn",
            other: "{{count}} Stonnen"
        }
    },
    xDays: {
        standalone: {
            one: "een Dag",
            other: "{{count}} Deeg"
        },
        withPreposition: {
            one: "engem Dag",
            other: "{{count}} Deeg"
        }
    },
    aboutXWeeks: {
        standalone: {
            one: "ongef\xe9ier eng Woch",
            other: "ongef\xe9ier {{count}} Wochen"
        },
        withPreposition: {
            one: "ongef\xe9ier enger Woche",
            other: "ongef\xe9ier {{count}} Wochen"
        }
    },
    xWeeks: {
        standalone: {
            one: "eng Woch",
            other: "{{count}} Wochen"
        },
        withPreposition: {
            one: "enger Woch",
            other: "{{count}} Wochen"
        }
    },
    aboutXMonths: {
        standalone: {
            one: "ongef\xe9ier ee Mount",
            other: "ongef\xe9ier {{count}} M\xe9int"
        },
        withPreposition: {
            one: "ongef\xe9ier engem Mount",
            other: "ongef\xe9ier {{count}} M\xe9int"
        }
    },
    xMonths: {
        standalone: {
            one: "ee Mount",
            other: "{{count}} M\xe9int"
        },
        withPreposition: {
            one: "engem Mount",
            other: "{{count}} M\xe9int"
        }
    },
    aboutXYears: {
        standalone: {
            one: "ongef\xe9ier ee Joer",
            other: "ongef\xe9ier {{count}} Joer"
        },
        withPreposition: {
            one: "ongef\xe9ier engem Joer",
            other: "ongef\xe9ier {{count}} Joer"
        }
    },
    xYears: {
        standalone: {
            one: "ee Joer",
            other: "{{count}} Joer"
        },
        withPreposition: {
            one: "engem Joer",
            other: "{{count}} Joer"
        }
    },
    overXYears: {
        standalone: {
            one: "m\xe9i w\xe9i ee Joer",
            other: "m\xe9i w\xe9i {{count}} Joer"
        },
        withPreposition: {
            one: "m\xe9i w\xe9i engem Joer",
            other: "m\xe9i w\xe9i {{count}} Joer"
        }
    },
    almostXYears: {
        standalone: {
            one: "bal ee Joer",
            other: "bal {{count}} Joer"
        },
        withPreposition: {
            one: "bal engem Joer",
            other: "bal {{count}} Joer"
        }
    }
};
var $cce6b5de16ff62fc$var$EXCEPTION_CONSONANTS = [
    "d",
    "h",
    "n",
    "t",
    "z"
];
var $cce6b5de16ff62fc$var$VOWELS = [
    "a,",
    "e",
    "i",
    "o",
    "u"
];
var $cce6b5de16ff62fc$var$DIGITS_SPOKEN_N_NEEDED = [
    0,
    1,
    2,
    3,
    8,
    9
];
var $cce6b5de16ff62fc$var$FIRST_TWO_DIGITS_SPOKEN_NO_N_NEEDED = [
    40,
    50,
    60,
    70
];
// Eifeler Regel
function $cce6b5de16ff62fc$var$isFinalNNeeded(nextWords) {
    var firstLetter = nextWords.charAt(0).toLowerCase();
    if ($cce6b5de16ff62fc$var$VOWELS.indexOf(firstLetter) != -1 || $cce6b5de16ff62fc$var$EXCEPTION_CONSONANTS.indexOf(firstLetter) != -1) return true;
    // Numbers would need to converted into words for checking.
    // Therefore, I have listed the digits that require a preceeding n with a few exceptions.
    var firstWord = nextWords.split(" ")[0];
    var number = parseInt(firstWord);
    if (!isNaN(number) && $cce6b5de16ff62fc$var$DIGITS_SPOKEN_N_NEEDED.indexOf(number % 10) != -1 && $cce6b5de16ff62fc$var$FIRST_TWO_DIGITS_SPOKEN_NO_N_NEEDED.indexOf(parseInt(firstWord.substring(0, 2))) == -1) return true;
    // Omit other checks as they are not expected here.
    return false;
}
var $cce6b5de16ff62fc$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $cce6b5de16ff62fc$var$formatDistanceLocale[token];
    var usageGroup = options !== null && options !== void 0 && options.addSuffix ? tokenValue.withPreposition : tokenValue.standalone;
    if (typeof usageGroup === "string") result = usageGroup;
    else if (count === 1) result = usageGroup.one;
    else result = usageGroup.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "a" + ($cce6b5de16ff62fc$var$isFinalNNeeded(result) ? "n" : "") + " " + result;
        else return "viru" + ($cce6b5de16ff62fc$var$isFinalNNeeded(result) ? "n" : "") + " " + result;
    }
    return result;
};
var $cce6b5de16ff62fc$export$2e2bcd8739ae039 = $cce6b5de16ff62fc$var$formatDistance;

});

parcelRegister("dlrhS", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b7267398654c8a8$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $9b7267398654c8a8$var$dateFormats = {
    full: "EEEE, do MMMM y",
    // Méindeg, 7. Januar 2018
    long: "do MMMM y",
    // 7. Januar 2018
    medium: "do MMM y",
    // 7. Jan 2018
    short: "dd.MM.yy" // 07.01.18
};
var $9b7267398654c8a8$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $9b7267398654c8a8$var$dateTimeFormats = {
    full: "{{date}} 'um' {{time}}",
    long: "{{date}} 'um' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $9b7267398654c8a8$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $9b7267398654c8a8$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $9b7267398654c8a8$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $9b7267398654c8a8$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $9b7267398654c8a8$export$2e2bcd8739ae039 = $9b7267398654c8a8$var$formatLong;

});

parcelRegister("3hN1O", function(module, exports) {

$parcel$export(module.exports, "default", () => $2648fda180c5ea0c$export$2e2bcd8739ae039);
var $2648fda180c5ea0c$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var day = date.getUTCDay();
        var result = "'l\xe4schte";
        if (day === 2 || day === 4) // Eifeler Regel: Add an n before the consonant d; Here "Dënschdeg" "and Donneschde".
        result += "n";
        result += "' eeee 'um' p";
        return result;
    },
    yesterday: "'g\xebschter um' p",
    today: "'haut um' p",
    tomorrow: "'moien um' p",
    nextWeek: "eeee 'um' p",
    other: "P"
};
var $2648fda180c5ea0c$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $2648fda180c5ea0c$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
var $2648fda180c5ea0c$export$2e2bcd8739ae039 = $2648fda180c5ea0c$var$formatRelative;

});

parcelRegister("6TkeE", function(module, exports) {

$parcel$export(module.exports, "default", () => $5047937727c3abdb$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $5047937727c3abdb$var$eraValues = {
    narrow: [
        "v.Chr.",
        "n.Chr."
    ],
    abbreviated: [
        "v.Chr.",
        "n.Chr."
    ],
    wide: [
        "viru Christus",
        "no Christus"
    ]
};
var $5047937727c3abdb$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1. Quartal",
        "2. Quartal",
        "3. Quartal",
        "4. Quartal"
    ]
};
var $5047937727c3abdb$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "M\xe4e",
        "Abr",
        "Mee",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Okt",
        "Nov",
        "Dez"
    ],
    wide: [
        "Januar",
        "Februar",
        "M\xe4erz",
        "Abr\xebll",
        "Mee",
        "Juni",
        "Juli",
        "August",
        "September",
        "Oktober",
        "November",
        "Dezember"
    ]
};
var $5047937727c3abdb$var$dayValues = {
    narrow: [
        "S",
        "M",
        "D",
        "M",
        "D",
        "F",
        "S"
    ],
    short: [
        "So",
        "M\xe9",
        "D\xeb",
        "M\xeb",
        "Do",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "So.",
        "M\xe9.",
        "D\xeb.",
        "M\xeb.",
        "Do.",
        "Fr.",
        "Sa."
    ],
    wide: [
        "Sonndeg",
        "M\xe9indeg",
        "D\xebnschdeg",
        "M\xebttwoch",
        "Donneschdeg",
        "Freideg",
        "Samschdeg"
    ]
};
var $5047937727c3abdb$var$dayPeriodValues = {
    narrow: {
        am: "mo.",
        pm: "nom\xeb.",
        midnight: "M\xebtternuecht",
        noon: "M\xebtteg",
        morning: "Moien",
        afternoon: "Nom\xebtteg",
        evening: "Owend",
        night: "Nuecht"
    },
    abbreviated: {
        am: "moies",
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "M\xebtteg",
        morning: "Moien",
        afternoon: "Nom\xebtteg",
        evening: "Owend",
        night: "Nuecht"
    },
    wide: {
        am: "moies",
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "M\xebtteg",
        morning: "Moien",
        afternoon: "Nom\xebtteg",
        evening: "Owend",
        night: "Nuecht"
    }
};
var $5047937727c3abdb$var$formattingDayPeriodValues = {
    narrow: {
        am: "mo.",
        pm: "nom.",
        midnight: "M\xebtternuecht",
        noon: "m\xebttes",
        morning: "moies",
        afternoon: "nom\xebttes",
        evening: "owes",
        night: "nuets"
    },
    abbreviated: {
        am: "moies",
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "m\xebttes",
        morning: "moies",
        afternoon: "nom\xebttes",
        evening: "owes",
        night: "nuets"
    },
    wide: {
        am: "moies",
        pm: "nom\xebttes",
        midnight: "M\xebtternuecht",
        noon: "m\xebttes",
        morning: "moies",
        afternoon: "nom\xebttes",
        evening: "owes",
        night: "nuets"
    }
};
var $5047937727c3abdb$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + ".";
};
var $5047937727c3abdb$var$localize = {
    ordinalNumber: $5047937727c3abdb$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $5047937727c3abdb$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $5047937727c3abdb$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $5047937727c3abdb$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $5047937727c3abdb$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $5047937727c3abdb$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $5047937727c3abdb$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $5047937727c3abdb$export$2e2bcd8739ae039 = $5047937727c3abdb$var$localize;

});

parcelRegister("89PKe", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f074d6c556bd828$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $5f074d6c556bd828$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var $5f074d6c556bd828$var$parseOrdinalNumberPattern = /\d+/i;
var $5f074d6c556bd828$var$matchEraPatterns = {
    narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
    wide: /^(viru Christus|virun eiser Zäitrechnung|no Christus|eiser Zäitrechnung)/i
};
var $5f074d6c556bd828$var$parseEraPatterns = {
    any: [
        /^v/i,
        /^n/i
    ]
};
var $5f074d6c556bd828$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? Quartal/i
};
var $5f074d6c556bd828$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $5f074d6c556bd828$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mäe|abr|mee|jun|jul|aug|sep|okt|nov|dez)/i,
    wide: /^(januar|februar|mäerz|abrëll|mee|juni|juli|august|september|oktober|november|dezember)/i
};
var $5f074d6c556bd828$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mä/i,
        /^ab/i,
        /^me/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $5f074d6c556bd828$var$matchDayPatterns = {
    narrow: /^[smdf]/i,
    short: /^(so|mé|dë|më|do|fr|sa)/i,
    abbreviated: /^(son?|méi?|dën?|mët?|don?|fre?|sam?)\.?/i,
    wide: /^(sonndeg|méindeg|dënschdeg|mëttwoch|donneschdeg|freideg|samschdeg)/i
};
var $5f074d6c556bd828$var$parseDayPatterns = {
    any: [
        /^so/i,
        /^mé/i,
        /^dë/i,
        /^më/i,
        /^do/i,
        /^f/i,
        /^sa/i
    ]
};
var $5f074d6c556bd828$var$matchDayPeriodPatterns = {
    narrow: /^(mo\.?|nomë\.?|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i,
    abbreviated: /^(moi\.?|nomët\.?|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i,
    wide: /^(moies|nomëttes|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i
};
var $5f074d6c556bd828$var$parseDayPeriodPatterns = {
    any: {
        am: /^m/i,
        pm: /^n/i,
        midnight: /^Mëtter/i,
        noon: /^mëttes/i,
        morning: /moies/i,
        afternoon: /nomëttes/i,
        // will never be matched. Afternoon is matched by `pm`
        evening: /owes/i,
        night: /nuets/i // will never be matched. Night is matched by `pm`
    }
};
var $5f074d6c556bd828$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $5f074d6c556bd828$var$matchOrdinalNumberPattern,
        parsePattern: $5f074d6c556bd828$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $5f074d6c556bd828$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5f074d6c556bd828$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $5f074d6c556bd828$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5f074d6c556bd828$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $5f074d6c556bd828$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5f074d6c556bd828$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $5f074d6c556bd828$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5f074d6c556bd828$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $5f074d6c556bd828$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $5f074d6c556bd828$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $5f074d6c556bd828$export$2e2bcd8739ae039 = $5f074d6c556bd828$var$match;

});


parcelRegister("jx56P", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3850ff614f0069b$export$2e2bcd8739ae039);

var $4ulO1 = parcelRequire("4ulO1");

var $agx5D = parcelRequire("agx5D");

var $eI05H = parcelRequire("eI05H");

var $3PeDx = parcelRequire("3PeDx");

var $jB3ky = parcelRequire("jB3ky");
/**
 * @type {Locale}
 * @category Locales
 * @summary Lithuanian locale.
 * @language Lithuanian
 * @iso-639-2 lit
 * @author Pavlo Shpak [@pshpak]{@link https://github.com/pshpak}
 * @author Eduardo Pardo [@eduardopsll]{@link https://github.com/eduardopsll}
 */ var $e3850ff614f0069b$var$locale = {
    code: "lt",
    formatDistance: (0, $4ulO1.default),
    formatLong: (0, $agx5D.default),
    formatRelative: (0, $eI05H.default),
    localize: (0, $3PeDx.default),
    match: (0, $jB3ky.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $e3850ff614f0069b$export$2e2bcd8739ae039 = $e3850ff614f0069b$var$locale;

});
parcelRegister("4ulO1", function(module, exports) {

$parcel$export(module.exports, "default", () => $344ae0f55c6e8e15$export$2e2bcd8739ae039);
var $344ae0f55c6e8e15$var$translations = {
    xseconds_other: "sekund\u0117_sekund\u017Ei\u0173_sekundes",
    xminutes_one: "minut\u0117_minut\u0117s_minut\u0119",
    xminutes_other: "minut\u0117s_minu\u010Di\u0173_minutes",
    xhours_one: "valanda_valandos_valand\u0105",
    xhours_other: "valandos_valand\u0173_valandas",
    xdays_one: "diena_dienos_dien\u0105",
    xdays_other: "dienos_dien\u0173_dienas",
    xweeks_one: "savait\u0117_savait\u0117s_savait\u0119",
    xweeks_other: "savait\u0117s_savai\u010Di\u0173_savaites",
    xmonths_one: "m\u0117nuo_m\u0117nesio_m\u0117nes\u012F",
    xmonths_other: "m\u0117nesiai_m\u0117nesi\u0173_m\u0117nesius",
    xyears_one: "metai_met\u0173_metus",
    xyears_other: "metai_met\u0173_metus",
    about: "apie",
    over: "daugiau nei",
    almost: "beveik",
    lessthan: "ma\u017Eiau nei"
};
var $344ae0f55c6e8e15$var$translateSeconds = function translateSeconds(_number, addSuffix, _key, isFuture) {
    if (!addSuffix) return "kelios sekund\u0117s";
    else return isFuture ? "keli\u0173 sekund\u017Ei\u0173" : "kelias sekundes";
};
var $344ae0f55c6e8e15$var$translateSingular = function translateSingular(_number, addSuffix, key, isFuture) {
    return !addSuffix ? $344ae0f55c6e8e15$var$forms(key)[0] : isFuture ? $344ae0f55c6e8e15$var$forms(key)[1] : $344ae0f55c6e8e15$var$forms(key)[2];
};
var $344ae0f55c6e8e15$var$translate = function translate(number, addSuffix, key, isFuture) {
    var result = number + " ";
    if (number === 1) return result + $344ae0f55c6e8e15$var$translateSingular(number, addSuffix, key, isFuture);
    else if (!addSuffix) return result + ($344ae0f55c6e8e15$var$special(number) ? $344ae0f55c6e8e15$var$forms(key)[1] : $344ae0f55c6e8e15$var$forms(key)[0]);
    else {
        if (isFuture) return result + $344ae0f55c6e8e15$var$forms(key)[1];
        else return result + ($344ae0f55c6e8e15$var$special(number) ? $344ae0f55c6e8e15$var$forms(key)[1] : $344ae0f55c6e8e15$var$forms(key)[2]);
    }
};
function $344ae0f55c6e8e15$var$special(number) {
    return number % 10 === 0 || number > 10 && number < 20;
}
function $344ae0f55c6e8e15$var$forms(key) {
    return $344ae0f55c6e8e15$var$translations[key].split("_");
}
var $344ae0f55c6e8e15$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: $344ae0f55c6e8e15$var$translateSeconds,
        other: $344ae0f55c6e8e15$var$translate
    },
    xSeconds: {
        one: $344ae0f55c6e8e15$var$translateSeconds,
        other: $344ae0f55c6e8e15$var$translate
    },
    halfAMinute: "pus\u0117 minut\u0117s",
    lessThanXMinutes: {
        one: $344ae0f55c6e8e15$var$translateSingular,
        other: $344ae0f55c6e8e15$var$translate
    },
    xMinutes: {
        one: $344ae0f55c6e8e15$var$translateSingular,
        other: $344ae0f55c6e8e15$var$translate
    },
    aboutXHours: {
        one: $344ae0f55c6e8e15$var$translateSingular,
        other: $344ae0f55c6e8e15$var$translate
    },
    xHours: {
        one: $344ae0f55c6e8e15$var$translateSingular,
        other: $344ae0f55c6e8e15$var$translate
    },
    xDays: {
        one: $344ae0f55c6e8e15$var$translateSingular,
        other: $344ae0f55c6e8e15$var$translate
    },
    aboutXWeeks: {
        one: $344ae0f55c6e8e15$var$translateSingular,
        other: $344ae0f55c6e8e15$var$translate
    },
    xWeeks: {
        one: $344ae0f55c6e8e15$var$translateSingular,
        other: $344ae0f55c6e8e15$var$translate
    },
    aboutXMonths: {
        one: $344ae0f55c6e8e15$var$translateSingular,
        other: $344ae0f55c6e8e15$var$translate
    },
    xMonths: {
        one: $344ae0f55c6e8e15$var$translateSingular,
        other: $344ae0f55c6e8e15$var$translate
    },
    aboutXYears: {
        one: $344ae0f55c6e8e15$var$translateSingular,
        other: $344ae0f55c6e8e15$var$translate
    },
    xYears: {
        one: $344ae0f55c6e8e15$var$translateSingular,
        other: $344ae0f55c6e8e15$var$translate
    },
    overXYears: {
        one: $344ae0f55c6e8e15$var$translateSingular,
        other: $344ae0f55c6e8e15$var$translate
    },
    almostXYears: {
        one: $344ae0f55c6e8e15$var$translateSingular,
        other: $344ae0f55c6e8e15$var$translate
    }
};
var $344ae0f55c6e8e15$var$formatDistance = function formatDistance(token, count, options) {
    var adverb = token.match(/about|over|almost|lessthan/i);
    var unit = adverb ? token.replace(adverb[0], "") : token;
    var isFuture = (options === null || options === void 0 ? void 0 : options.comparison) !== undefined && options.comparison > 0;
    var result;
    var tokenValue = $344ae0f55c6e8e15$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one(count, (options === null || options === void 0 ? void 0 : options.addSuffix) === true, unit.toLowerCase() + "_one", isFuture);
    else result = tokenValue.other(count, (options === null || options === void 0 ? void 0 : options.addSuffix) === true, unit.toLowerCase() + "_other", isFuture);
    if (adverb) {
        var _key2 = adverb[0].toLowerCase();
        result = $344ae0f55c6e8e15$var$translations[_key2] + " " + result;
    }
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "po " + result;
        else return "prie\u0161 " + result;
    }
    return result;
};
var $344ae0f55c6e8e15$export$2e2bcd8739ae039 = $344ae0f55c6e8e15$var$formatDistance;

});

parcelRegister("agx5D", function(module, exports) {

$parcel$export(module.exports, "default", () => $779510f175213904$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $779510f175213904$var$dateFormats = {
    full: "y 'm'. MMMM d 'd'., EEEE",
    long: "y 'm'. MMMM d 'd'.",
    medium: "y-MM-dd",
    short: "y-MM-dd"
};
var $779510f175213904$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $779510f175213904$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $779510f175213904$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $779510f175213904$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $779510f175213904$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $779510f175213904$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $779510f175213904$export$2e2bcd8739ae039 = $779510f175213904$var$formatLong;

});

parcelRegister("eI05H", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab553ed408a94d73$export$2e2bcd8739ae039);
var $ab553ed408a94d73$var$formatRelativeLocale = {
    lastWeek: "'Pra\u0117jus\u012F' eeee p",
    yesterday: "'Vakar' p",
    today: "'\u0160iandien' p",
    tomorrow: "'Rytoj' p",
    nextWeek: "eeee p",
    other: "P"
};
var $ab553ed408a94d73$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $ab553ed408a94d73$var$formatRelativeLocale[token];
};
var $ab553ed408a94d73$export$2e2bcd8739ae039 = $ab553ed408a94d73$var$formatRelative;

});

parcelRegister("3PeDx", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c917d0b702f41ca$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $2c917d0b702f41ca$var$eraValues = {
    narrow: [
        "pr. Kr.",
        "po Kr."
    ],
    abbreviated: [
        "pr. Kr.",
        "po Kr."
    ],
    wide: [
        "prie\u0161 Krist\u0173",
        "po Kristaus"
    ]
};
var $2c917d0b702f41ca$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "I ketv.",
        "II ketv.",
        "III ketv.",
        "IV ketv."
    ],
    wide: [
        "I ketvirtis",
        "II ketvirtis",
        "III ketvirtis",
        "IV ketvirtis"
    ]
};
var $2c917d0b702f41ca$var$formattingQuarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "I k.",
        "II k.",
        "III k.",
        "IV k."
    ],
    wide: [
        "I ketvirtis",
        "II ketvirtis",
        "III ketvirtis",
        "IV ketvirtis"
    ]
};
var $2c917d0b702f41ca$var$monthValues = {
    narrow: [
        "S",
        "V",
        "K",
        "B",
        "G",
        "B",
        "L",
        "R",
        "R",
        "S",
        "L",
        "G"
    ],
    abbreviated: [
        "saus.",
        "vas.",
        "kov.",
        "bal.",
        "geg.",
        "bir\u017E.",
        "liep.",
        "rugp.",
        "rugs.",
        "spal.",
        "lapkr.",
        "gruod."
    ],
    wide: [
        "sausis",
        "vasaris",
        "kovas",
        "balandis",
        "gegu\u017E\u0117",
        "bir\u017Eelis",
        "liepa",
        "rugpj\u016Btis",
        "rugs\u0117jis",
        "spalis",
        "lapkritis",
        "gruodis"
    ]
};
var $2c917d0b702f41ca$var$formattingMonthValues = {
    narrow: [
        "S",
        "V",
        "K",
        "B",
        "G",
        "B",
        "L",
        "R",
        "R",
        "S",
        "L",
        "G"
    ],
    abbreviated: [
        "saus.",
        "vas.",
        "kov.",
        "bal.",
        "geg.",
        "bir\u017E.",
        "liep.",
        "rugp.",
        "rugs.",
        "spal.",
        "lapkr.",
        "gruod."
    ],
    wide: [
        "sausio",
        "vasario",
        "kovo",
        "baland\u017Eio",
        "gegu\u017E\u0117s",
        "bir\u017Eelio",
        "liepos",
        "rugpj\u016B\u010Dio",
        "rugs\u0117jo",
        "spalio",
        "lapkri\u010Dio",
        "gruod\u017Eio"
    ]
};
var $2c917d0b702f41ca$var$dayValues = {
    narrow: [
        "S",
        "P",
        "A",
        "T",
        "K",
        "P",
        "\u0160"
    ],
    short: [
        "Sk",
        "Pr",
        "An",
        "Tr",
        "Kt",
        "Pn",
        "\u0160t"
    ],
    abbreviated: [
        "sk",
        "pr",
        "an",
        "tr",
        "kt",
        "pn",
        "\u0161t"
    ],
    wide: [
        "sekmadienis",
        "pirmadienis",
        "antradienis",
        "tre\u010Diadienis",
        "ketvirtadienis",
        "penktadienis",
        "\u0161e\u0161tadienis"
    ]
};
var $2c917d0b702f41ca$var$formattingDayValues = {
    narrow: [
        "S",
        "P",
        "A",
        "T",
        "K",
        "P",
        "\u0160"
    ],
    short: [
        "Sk",
        "Pr",
        "An",
        "Tr",
        "Kt",
        "Pn",
        "\u0160t"
    ],
    abbreviated: [
        "sk",
        "pr",
        "an",
        "tr",
        "kt",
        "pn",
        "\u0161t"
    ],
    wide: [
        "sekmadien\u012F",
        "pirmadien\u012F",
        "antradien\u012F",
        "tre\u010Diadien\u012F",
        "ketvirtadien\u012F",
        "penktadien\u012F",
        "\u0161e\u0161tadien\u012F"
    ]
};
var $2c917d0b702f41ca$var$dayPeriodValues = {
    narrow: {
        am: "pr. p.",
        pm: "pop.",
        midnight: "vidurnaktis",
        noon: "vidurdienis",
        morning: "rytas",
        afternoon: "diena",
        evening: "vakaras",
        night: "naktis"
    },
    abbreviated: {
        am: "prie\u0161piet",
        pm: "popiet",
        midnight: "vidurnaktis",
        noon: "vidurdienis",
        morning: "rytas",
        afternoon: "diena",
        evening: "vakaras",
        night: "naktis"
    },
    wide: {
        am: "prie\u0161piet",
        pm: "popiet",
        midnight: "vidurnaktis",
        noon: "vidurdienis",
        morning: "rytas",
        afternoon: "diena",
        evening: "vakaras",
        night: "naktis"
    }
};
var $2c917d0b702f41ca$var$formattingDayPeriodValues = {
    narrow: {
        am: "pr. p.",
        pm: "pop.",
        midnight: "vidurnaktis",
        noon: "perpiet",
        morning: "rytas",
        afternoon: "popiet\u0117",
        evening: "vakaras",
        night: "naktis"
    },
    abbreviated: {
        am: "prie\u0161piet",
        pm: "popiet",
        midnight: "vidurnaktis",
        noon: "perpiet",
        morning: "rytas",
        afternoon: "popiet\u0117",
        evening: "vakaras",
        night: "naktis"
    },
    wide: {
        am: "prie\u0161piet",
        pm: "popiet",
        midnight: "vidurnaktis",
        noon: "perpiet",
        morning: "rytas",
        afternoon: "popiet\u0117",
        evening: "vakaras",
        night: "naktis"
    }
};
var $2c917d0b702f41ca$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "-oji";
};
var $2c917d0b702f41ca$var$localize = {
    ordinalNumber: $2c917d0b702f41ca$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $2c917d0b702f41ca$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $2c917d0b702f41ca$var$quarterValues,
        defaultWidth: "wide",
        formattingValues: $2c917d0b702f41ca$var$formattingQuarterValues,
        defaultFormattingWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $2c917d0b702f41ca$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $2c917d0b702f41ca$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $2c917d0b702f41ca$var$dayValues,
        defaultWidth: "wide",
        formattingValues: $2c917d0b702f41ca$var$formattingDayValues,
        defaultFormattingWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $2c917d0b702f41ca$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $2c917d0b702f41ca$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $2c917d0b702f41ca$export$2e2bcd8739ae039 = $2c917d0b702f41ca$var$localize;

});

parcelRegister("jB3ky", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4440e5f25069ec2$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $e4440e5f25069ec2$var$matchOrdinalNumberPattern = /^(\d+)(-oji)?/i;
var $e4440e5f25069ec2$var$parseOrdinalNumberPattern = /\d+/i;
var $e4440e5f25069ec2$var$matchEraPatterns = {
    narrow: /^p(r|o)\.?\s?(kr\.?|me)/i,
    abbreviated: /^(pr\.\s?(kr\.|m\.\s?e\.)|po\s?kr\.|mūsų eroje)/i,
    wide: /^(prieš Kristų|prieš mūsų erą|po Kristaus|mūsų eroje)/i
};
var $e4440e5f25069ec2$var$parseEraPatterns = {
    wide: [
        /prieš/i,
        /(po|mūsų)/i
    ],
    any: [
        /^pr/i,
        /^(po|m)/i
    ]
};
var $e4440e5f25069ec2$var$matchQuarterPatterns = {
    narrow: /^([1234])/i,
    abbreviated: /^(I|II|III|IV)\s?ketv?\.?/i,
    wide: /^(I|II|III|IV)\s?ketvirtis/i
};
var $e4440e5f25069ec2$var$parseQuarterPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    any: [
        /I$/i,
        /II$/i,
        /III/i,
        /IV/i
    ]
};
var $e4440e5f25069ec2$var$matchMonthPatterns = {
    narrow: /^[svkbglr]/i,
    abbreviated: /^(saus\.|vas\.|kov\.|bal\.|geg\.|birž\.|liep\.|rugp\.|rugs\.|spal\.|lapkr\.|gruod\.)/i,
    wide: /^(sausi(s|o)|vasari(s|o)|kov(a|o)s|balandž?i(s|o)|gegužės?|birželi(s|o)|liep(a|os)|rugpjū(t|č)i(s|o)|rugsėj(is|o)|spali(s|o)|lapkri(t|č)i(s|o)|gruodž?i(s|o))/i
};
var $e4440e5f25069ec2$var$parseMonthPatterns = {
    narrow: [
        /^s/i,
        /^v/i,
        /^k/i,
        /^b/i,
        /^g/i,
        /^b/i,
        /^l/i,
        /^r/i,
        /^r/i,
        /^s/i,
        /^l/i,
        /^g/i
    ],
    any: [
        /^saus/i,
        /^vas/i,
        /^kov/i,
        /^bal/i,
        /^geg/i,
        /^birž/i,
        /^liep/i,
        /^rugp/i,
        /^rugs/i,
        /^spal/i,
        /^lapkr/i,
        /^gruod/i
    ]
};
var $e4440e5f25069ec2$var$matchDayPatterns = {
    narrow: /^[spatkš]/i,
    short: /^(sk|pr|an|tr|kt|pn|št)/i,
    abbreviated: /^(sk|pr|an|tr|kt|pn|št)/i,
    wide: /^(sekmadien(is|į)|pirmadien(is|į)|antradien(is|į)|trečiadien(is|į)|ketvirtadien(is|į)|penktadien(is|į)|šeštadien(is|į))/i
};
var $e4440e5f25069ec2$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^p/i,
        /^a/i,
        /^t/i,
        /^k/i,
        /^p/i,
        /^š/i
    ],
    wide: [
        /^se/i,
        /^pi/i,
        /^an/i,
        /^tr/i,
        /^ke/i,
        /^pe/i,
        /^še/i
    ],
    any: [
        /^sk/i,
        /^pr/i,
        /^an/i,
        /^tr/i,
        /^kt/i,
        /^pn/i,
        /^št/i
    ]
};
var $e4440e5f25069ec2$var$matchDayPeriodPatterns = {
    narrow: /^(pr.\s?p.|pop.|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i,
    any: /^(priešpiet|popiet$|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i
};
var $e4440e5f25069ec2$var$parseDayPeriodPatterns = {
    narrow: {
        am: /^pr/i,
        pm: /^pop./i,
        midnight: /^vidurnaktis/i,
        noon: /^(vidurdienis|perp)/i,
        morning: /rytas/i,
        afternoon: /(die|popietė)/i,
        evening: /vakaras/i,
        night: /naktis/i
    },
    any: {
        am: /^pr/i,
        pm: /^popiet$/i,
        midnight: /^vidurnaktis/i,
        noon: /^(vidurdienis|perp)/i,
        morning: /rytas/i,
        afternoon: /(die|popietė)/i,
        evening: /vakaras/i,
        night: /naktis/i
    }
};
var $e4440e5f25069ec2$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $e4440e5f25069ec2$var$matchOrdinalNumberPattern,
        parsePattern: $e4440e5f25069ec2$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $e4440e5f25069ec2$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e4440e5f25069ec2$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $e4440e5f25069ec2$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e4440e5f25069ec2$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $e4440e5f25069ec2$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e4440e5f25069ec2$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $e4440e5f25069ec2$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e4440e5f25069ec2$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $e4440e5f25069ec2$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $e4440e5f25069ec2$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $e4440e5f25069ec2$export$2e2bcd8739ae039 = $e4440e5f25069ec2$var$match;

});


parcelRegister("bODly", function(module, exports) {

$parcel$export(module.exports, "default", () => $89a2e2abd3d16f64$export$2e2bcd8739ae039);

var $9uD2s = parcelRequire("9uD2s");

var $ecGAU = parcelRequire("ecGAU");

var $fWTiR = parcelRequire("fWTiR");

var $gU2yZ = parcelRequire("gU2yZ");

var $kUSBs = parcelRequire("kUSBs");
/**
 * @type {Locale}
 * @category Locales
 * @summary Latvian locale (Latvia).
 * @language Latvian
 * @iso-639-2 lav
 * @author Rūdolfs Puķītis [@prudolfs]{@link https://github.com/prudolfs}
 */ var $89a2e2abd3d16f64$var$locale = {
    code: "lv",
    formatDistance: (0, $9uD2s.default),
    formatLong: (0, $ecGAU.default),
    formatRelative: (0, $fWTiR.default),
    localize: (0, $gU2yZ.default),
    match: (0, $kUSBs.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $89a2e2abd3d16f64$export$2e2bcd8739ae039 = $89a2e2abd3d16f64$var$locale;

});
parcelRegister("9uD2s", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e9532a5d82b9fca$export$2e2bcd8739ae039);
function $6e9532a5d82b9fca$var$buildLocalizeTokenFn(schema) {
    return function(count, options) {
        if (count === 1) {
            if (options !== null && options !== void 0 && options.addSuffix) return schema.one[0].replace("{{time}}", schema.one[2]);
            else return schema.one[0].replace("{{time}}", schema.one[1]);
        } else {
            var rem = count % 10 === 1 && count % 100 !== 11;
            if (options !== null && options !== void 0 && options.addSuffix) return schema.other[0].replace("{{time}}", rem ? schema.other[3] : schema.other[4]).replace("{{count}}", String(count));
            else return schema.other[0].replace("{{time}}", rem ? schema.other[1] : schema.other[2]).replace("{{count}}", String(count));
        }
    };
}
var $6e9532a5d82b9fca$var$formatDistanceLocale = {
    lessThanXSeconds: $6e9532a5d82b9fca$var$buildLocalizeTokenFn({
        one: [
            "maz\u0101k par {{time}}",
            "sekundi",
            "sekundi"
        ],
        other: [
            "maz\u0101k nek\u0101 {{count}} {{time}}",
            "sekunde",
            "sekundes",
            "sekundes",
            "sekund\u0113m"
        ]
    }),
    xSeconds: $6e9532a5d82b9fca$var$buildLocalizeTokenFn({
        one: [
            "1 {{time}}",
            "sekunde",
            "sekundes"
        ],
        other: [
            "{{count}} {{time}}",
            "sekunde",
            "sekundes",
            "sekundes",
            "sekund\u0113m"
        ]
    }),
    halfAMinute: function halfAMinute(_count, options) {
        if (options !== null && options !== void 0 && options.addSuffix) return "pusmin\u016Btes";
        else return "pusmin\u016Bte";
    },
    lessThanXMinutes: $6e9532a5d82b9fca$var$buildLocalizeTokenFn({
        one: [
            "maz\u0101k par {{time}}",
            "min\u016Bti",
            "min\u016Bti"
        ],
        other: [
            "maz\u0101k nek\u0101 {{count}} {{time}}",
            "min\u016Bte",
            "min\u016Btes",
            "min\u016Btes",
            "min\u016Bt\u0113m"
        ]
    }),
    xMinutes: $6e9532a5d82b9fca$var$buildLocalizeTokenFn({
        one: [
            "1 {{time}}",
            "min\u016Bte",
            "min\u016Btes"
        ],
        other: [
            "{{count}} {{time}}",
            "min\u016Bte",
            "min\u016Btes",
            "min\u016Btes",
            "min\u016Bt\u0113m"
        ]
    }),
    aboutXHours: $6e9532a5d82b9fca$var$buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            "stunda",
            "stundas"
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            "stunda",
            "stundas",
            "stundas",
            "stund\u0101m"
        ]
    }),
    xHours: $6e9532a5d82b9fca$var$buildLocalizeTokenFn({
        one: [
            "1 {{time}}",
            "stunda",
            "stundas"
        ],
        other: [
            "{{count}} {{time}}",
            "stunda",
            "stundas",
            "stundas",
            "stund\u0101m"
        ]
    }),
    xDays: $6e9532a5d82b9fca$var$buildLocalizeTokenFn({
        one: [
            "1 {{time}}",
            "diena",
            "dienas"
        ],
        other: [
            "{{count}} {{time}}",
            "diena",
            "dienas",
            "dienas",
            "dien\u0101m"
        ]
    }),
    aboutXWeeks: $6e9532a5d82b9fca$var$buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cas"
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cu",
            "ned\u0113\u013Cas",
            "ned\u0113\u013C\u0101m"
        ]
    }),
    xWeeks: $6e9532a5d82b9fca$var$buildLocalizeTokenFn({
        one: [
            "1 {{time}}",
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cas"
        ],
        other: [
            "{{count}} {{time}}",
            // TODO
            "ned\u0113\u013Ca",
            "ned\u0113\u013Cu",
            "ned\u0113\u013Cas",
            "ned\u0113\u013C\u0101m"
        ]
    }),
    aboutXMonths: $6e9532a5d82b9fca$var$buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            "m\u0113nesis",
            "m\u0113ne\u0161a"
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            "m\u0113nesis",
            "m\u0113ne\u0161i",
            "m\u0113ne\u0161a",
            "m\u0113ne\u0161iem"
        ]
    }),
    xMonths: $6e9532a5d82b9fca$var$buildLocalizeTokenFn({
        one: [
            "1 {{time}}",
            "m\u0113nesis",
            "m\u0113ne\u0161a"
        ],
        other: [
            "{{count}} {{time}}",
            "m\u0113nesis",
            "m\u0113ne\u0161i",
            "m\u0113ne\u0161a",
            "m\u0113ne\u0161iem"
        ]
    }),
    aboutXYears: $6e9532a5d82b9fca$var$buildLocalizeTokenFn({
        one: [
            "apm\u0113ram 1 {{time}}",
            "gads",
            "gada"
        ],
        other: [
            "apm\u0113ram {{count}} {{time}}",
            "gads",
            "gadi",
            "gada",
            "gadiem"
        ]
    }),
    xYears: $6e9532a5d82b9fca$var$buildLocalizeTokenFn({
        one: [
            "1 {{time}}",
            "gads",
            "gada"
        ],
        other: [
            "{{count}} {{time}}",
            "gads",
            "gadi",
            "gada",
            "gadiem"
        ]
    }),
    overXYears: $6e9532a5d82b9fca$var$buildLocalizeTokenFn({
        one: [
            "ilg\u0101k par 1 {{time}}",
            "gadu",
            "gadu"
        ],
        other: [
            "vair\u0101k nek\u0101 {{count}} {{time}}",
            "gads",
            "gadi",
            "gada",
            "gadiem"
        ]
    }),
    almostXYears: $6e9532a5d82b9fca$var$buildLocalizeTokenFn({
        one: [
            "gandr\u012Bz 1 {{time}}",
            "gads",
            "gada"
        ],
        other: [
            "vair\u0101k nek\u0101 {{count}} {{time}}",
            "gads",
            "gadi",
            "gada",
            "gadiem"
        ]
    })
};
var $6e9532a5d82b9fca$var$formatDistance = function formatDistance(token, count, options) {
    var result = $6e9532a5d82b9fca$var$formatDistanceLocale[token](count, options);
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "p\u0113c " + result;
        else return "pirms " + result;
    }
    return result;
};
var $6e9532a5d82b9fca$export$2e2bcd8739ae039 = $6e9532a5d82b9fca$var$formatDistance;

});

parcelRegister("ecGAU", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5733a06a7b243a5$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $a5733a06a7b243a5$var$dateFormats = {
    full: "EEEE, y. 'gada' d. MMMM",
    long: "y. 'gada' d. MMMM",
    medium: "dd.MM.y.",
    short: "dd.MM.y."
};
var $a5733a06a7b243a5$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $a5733a06a7b243a5$var$dateTimeFormats = {
    full: "{{date}} 'plkst.' {{time}}",
    long: "{{date}} 'plkst.' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $a5733a06a7b243a5$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $a5733a06a7b243a5$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $a5733a06a7b243a5$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $a5733a06a7b243a5$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $a5733a06a7b243a5$export$2e2bcd8739ae039 = $a5733a06a7b243a5$var$formatLong;

});

parcelRegister("fWTiR", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9c72bdd32604f91$export$2e2bcd8739ae039);

var $6KZXu = parcelRequire("6KZXu");
var $b9c72bdd32604f91$var$weekdays = [
    "sv\u0113tdien\u0101",
    "pirmdien\u0101",
    "otrdien\u0101",
    "tre\u0161dien\u0101",
    "ceturtdien\u0101",
    "piektdien\u0101",
    "sestdien\u0101"
];
var $b9c72bdd32604f91$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        if ((0, $6KZXu.default)(date, baseDate, options)) return "eeee 'plkst.' p";
        var weekday = $b9c72bdd32604f91$var$weekdays[date.getUTCDay()];
        return "'Pag\u0101ju\u0161\u0101 " + weekday + " plkst.' p";
    },
    yesterday: "'Vakar plkst.' p",
    today: "'\u0160odien plkst.' p",
    tomorrow: "'R\u012Bt plkst.' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        if ((0, $6KZXu.default)(date, baseDate, options)) return "eeee 'plkst.' p";
        var weekday = $b9c72bdd32604f91$var$weekdays[date.getUTCDay()];
        return "'N\u0101kamaj\u0101 " + weekday + " plkst.' p";
    },
    other: "P"
};
var $b9c72bdd32604f91$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $b9c72bdd32604f91$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
var $b9c72bdd32604f91$export$2e2bcd8739ae039 = $b9c72bdd32604f91$var$formatRelative;

});

parcelRegister("gU2yZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4e3dd507cc1d4e8$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $c4e3dd507cc1d4e8$var$eraValues = {
    narrow: [
        "p.m.\u0113",
        "m.\u0113"
    ],
    abbreviated: [
        "p. m. \u0113.",
        "m. \u0113."
    ],
    wide: [
        "pirms m\u016Bsu \u0113ras",
        "m\u016Bsu \u0113r\u0101"
    ]
};
var $c4e3dd507cc1d4e8$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1. cet.",
        "2. cet.",
        "3. cet.",
        "4. cet."
    ],
    wide: [
        "pirmais ceturksnis",
        "otrais ceturksnis",
        "tre\u0161ais ceturksnis",
        "ceturtais ceturksnis"
    ]
};
var $c4e3dd507cc1d4e8$var$formattingQuarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1. cet.",
        "2. cet.",
        "3. cet.",
        "4. cet."
    ],
    wide: [
        "pirmaj\u0101 ceturksn\u012B",
        "otraj\u0101 ceturksn\u012B",
        "tre\u0161aj\u0101 ceturksn\u012B",
        "ceturtaj\u0101 ceturksn\u012B"
    ]
};
var $c4e3dd507cc1d4e8$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "janv.",
        "febr.",
        "marts",
        "apr.",
        "maijs",
        "j\u016Bn.",
        "j\u016Bl.",
        "aug.",
        "sept.",
        "okt.",
        "nov.",
        "dec."
    ],
    wide: [
        "janv\u0101ris",
        "febru\u0101ris",
        "marts",
        "apr\u012Blis",
        "maijs",
        "j\u016Bnijs",
        "j\u016Blijs",
        "augusts",
        "septembris",
        "oktobris",
        "novembris",
        "decembris"
    ]
};
var $c4e3dd507cc1d4e8$var$formattingMonthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "janv.",
        "febr.",
        "mart\u0101",
        "apr.",
        "maijs",
        "j\u016Bn.",
        "j\u016Bl.",
        "aug.",
        "sept.",
        "okt.",
        "nov.",
        "dec."
    ],
    wide: [
        "janv\u0101r\u012B",
        "febru\u0101r\u012B",
        "mart\u0101",
        "apr\u012Bl\u012B",
        "maij\u0101",
        "j\u016Bnij\u0101",
        "j\u016Blij\u0101",
        "august\u0101",
        "septembr\u012B",
        "oktobr\u012B",
        "novembr\u012B",
        "decembr\u012B"
    ]
};
var $c4e3dd507cc1d4e8$var$dayValues = {
    narrow: [
        "S",
        "P",
        "O",
        "T",
        "C",
        "P",
        "S"
    ],
    short: [
        "Sv",
        "P",
        "O",
        "T",
        "C",
        "Pk",
        "S"
    ],
    abbreviated: [
        "sv\u0113td.",
        "pirmd.",
        "otrd.",
        "tre\u0161d.",
        "ceturtd.",
        "piektd.",
        "sestd."
    ],
    wide: [
        "sv\u0113tdiena",
        "pirmdiena",
        "otrdiena",
        "tre\u0161diena",
        "ceturtdiena",
        "piektdiena",
        "sestdiena"
    ]
};
var $c4e3dd507cc1d4e8$var$formattingDayValues = {
    narrow: [
        "S",
        "P",
        "O",
        "T",
        "C",
        "P",
        "S"
    ],
    short: [
        "Sv",
        "P",
        "O",
        "T",
        "C",
        "Pk",
        "S"
    ],
    abbreviated: [
        "sv\u0113td.",
        "pirmd.",
        "otrd.",
        "tre\u0161d.",
        "ceturtd.",
        "piektd.",
        "sestd."
    ],
    wide: [
        "sv\u0113tdien\u0101",
        "pirmdien\u0101",
        "otrdien\u0101",
        "tre\u0161dien\u0101",
        "ceturtdien\u0101",
        "piektdien\u0101",
        "sestdien\u0101"
    ]
};
var $c4e3dd507cc1d4e8$var$dayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "pusn.",
        noon: "pusd.",
        morning: "r\u012Bts",
        afternoon: "diena",
        evening: "vakars",
        night: "nakts"
    },
    abbreviated: {
        am: "am",
        pm: "pm",
        midnight: "pusn.",
        noon: "pusd.",
        morning: "r\u012Bts",
        afternoon: "p\u0113cpusd.",
        evening: "vakars",
        night: "nakts"
    },
    wide: {
        am: "am",
        pm: "pm",
        midnight: "pusnakts",
        noon: "pusdienlaiks",
        morning: "r\u012Bts",
        afternoon: "p\u0113cpusdiena",
        evening: "vakars",
        night: "nakts"
    }
};
var $c4e3dd507cc1d4e8$var$formattingDayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "pusn.",
        noon: "pusd.",
        morning: "r\u012Bt\u0101",
        afternoon: "dien\u0101",
        evening: "vakar\u0101",
        night: "nakt\u012B"
    },
    abbreviated: {
        am: "am",
        pm: "pm",
        midnight: "pusn.",
        noon: "pusd.",
        morning: "r\u012Bt\u0101",
        afternoon: "p\u0113cpusd.",
        evening: "vakar\u0101",
        night: "nakt\u012B"
    },
    wide: {
        am: "am",
        pm: "pm",
        midnight: "pusnakt\u012B",
        noon: "pusdienlaik\u0101",
        morning: "r\u012Bt\u0101",
        afternoon: "p\u0113cpusdien\u0101",
        evening: "vakar\u0101",
        night: "nakt\u012B"
    }
};
var $c4e3dd507cc1d4e8$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + ".";
};
var $c4e3dd507cc1d4e8$var$localize = {
    ordinalNumber: $c4e3dd507cc1d4e8$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $c4e3dd507cc1d4e8$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $c4e3dd507cc1d4e8$var$quarterValues,
        defaultWidth: "wide",
        formattingValues: $c4e3dd507cc1d4e8$var$formattingQuarterValues,
        defaultFormattingWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $c4e3dd507cc1d4e8$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $c4e3dd507cc1d4e8$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $c4e3dd507cc1d4e8$var$dayValues,
        defaultWidth: "wide",
        formattingValues: $c4e3dd507cc1d4e8$var$formattingDayValues,
        defaultFormattingWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $c4e3dd507cc1d4e8$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $c4e3dd507cc1d4e8$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $c4e3dd507cc1d4e8$export$2e2bcd8739ae039 = $c4e3dd507cc1d4e8$var$localize;

});

parcelRegister("kUSBs", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3a364a75491c91b$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $f3a364a75491c91b$var$matchOrdinalNumberPattern = /^(\d+)\./i;
var $f3a364a75491c91b$var$parseOrdinalNumberPattern = /\d+/i;
var $f3a364a75491c91b$var$matchEraPatterns = {
    narrow: /^(p\.m\.ē|m\.ē)/i,
    abbreviated: /^(p\. m\. ē\.|m\. ē\.)/i,
    wide: /^(pirms mūsu ēras|mūsu ērā)/i
};
var $f3a364a75491c91b$var$parseEraPatterns = {
    any: [
        /^p/i,
        /^m/i
    ]
};
var $f3a364a75491c91b$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](\. cet\.)/i,
    wide: /^(pirma(is|jā)|otra(is|jā)|treša(is|jā)|ceturta(is|jā)) ceturksn(is|ī)/i
};
var $f3a364a75491c91b$var$parseQuarterPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i
    ],
    abbreviated: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i
    ],
    wide: [
        /^p/i,
        /^o/i,
        /^t/i,
        /^c/i
    ]
};
var $f3a364a75491c91b$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(janv\.|febr\.|marts|apr\.|maijs|jūn\.|jūl\.|aug\.|sept\.|okt\.|nov\.|dec\.)/i,
    wide: /^(janvār(is|ī)|februār(is|ī)|mart[sā]|aprīl(is|ī)|maij[sā]|jūnij[sā]|jūlij[sā]|august[sā]|septembr(is|ī)|oktobr(is|ī)|novembr(is|ī)|decembr(is|ī))/i
};
var $f3a364a75491c91b$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^jūn/i,
        /^jūl/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $f3a364a75491c91b$var$matchDayPatterns = {
    narrow: /^[spotc]/i,
    short: /^(sv|pi|o|t|c|pk|s)/i,
    abbreviated: /^(svētd\.|pirmd\.|otrd.\|trešd\.|ceturtd\.|piektd\.|sestd\.)/i,
    wide: /^(svētdien(a|ā)|pirmdien(a|ā)|otrdien(a|ā)|trešdien(a|ā)|ceturtdien(a|ā)|piektdien(a|ā)|sestdien(a|ā))/i
};
var $f3a364a75491c91b$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^p/i,
        /^o/i,
        /^t/i,
        /^c/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^sv/i,
        /^pi/i,
        /^o/i,
        /^t/i,
        /^c/i,
        /^p/i,
        /^se/i
    ]
};
var $f3a364a75491c91b$var$matchDayPeriodPatterns = {
    narrow: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|dien(a|ā)|vakar(s|ā)|nakt(s|ī))/,
    abbreviated: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|pēcpusd\.|vakar(s|ā)|nakt(s|ī))/,
    wide: /^(am|pm|pusnakt(s|ī)|pusdienlaik(s|ā)|rīt(s|ā)|pēcpusdien(a|ā)|vakar(s|ā)|nakt(s|ī))/i
};
var $f3a364a75491c91b$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^pusn/i,
        noon: /^pusd/i,
        morning: /^r/i,
        afternoon: /^(d|pēc)/i,
        evening: /^v/i,
        night: /^n/i
    }
};
var $f3a364a75491c91b$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $f3a364a75491c91b$var$matchOrdinalNumberPattern,
        parsePattern: $f3a364a75491c91b$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $f3a364a75491c91b$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f3a364a75491c91b$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $f3a364a75491c91b$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f3a364a75491c91b$var$parseQuarterPatterns,
        defaultParseWidth: "wide",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $f3a364a75491c91b$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f3a364a75491c91b$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $f3a364a75491c91b$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f3a364a75491c91b$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $f3a364a75491c91b$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f3a364a75491c91b$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $f3a364a75491c91b$export$2e2bcd8739ae039 = $f3a364a75491c91b$var$match;

});


parcelRegister("h4pP7", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6d6d76bc0d22375$export$2e2bcd8739ae039);

var $74RQM = parcelRequire("74RQM");

var $kvjGj = parcelRequire("kvjGj");

var $9orsv = parcelRequire("9orsv");

var $kXR8W = parcelRequire("kXR8W");

var $1hkJt = parcelRequire("1hkJt");
/**
 * @type {Locale}
 * @category Locales
 * @summary Macedonian locale.
 * @language Macedonian
 * @iso-639-2 mkd
 * @author Petar Vlahu [@vlahupetar]{@link https://github.com/vlahupetar}
 * @author Altrim Beqiri [@altrim]{@link https://github.com/altrim}
 */ var $c6d6d76bc0d22375$var$locale = {
    code: "mk",
    formatDistance: (0, $74RQM.default),
    formatLong: (0, $kvjGj.default),
    formatRelative: (0, $9orsv.default),
    localize: (0, $kXR8W.default),
    match: (0, $1hkJt.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $c6d6d76bc0d22375$export$2e2bcd8739ae039 = $c6d6d76bc0d22375$var$locale;

});
parcelRegister("74RQM", function(module, exports) {

$parcel$export(module.exports, "default", () => $5272adae18daced8$export$2e2bcd8739ae039);
var $5272adae18daced8$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    xSeconds: {
        one: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    halfAMinute: "\u043F\u043E\u043B\u043E\u0432\u0438\u043D\u0430 \u043C\u0438\u043D\u0443\u0442\u0430",
    lessThanXMinutes: {
        one: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "\u043F\u043E\u043C\u0430\u043B\u043A\u0443 \u043E\u0434 {{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
    },
    xMinutes: {
        one: "1 \u043C\u0438\u043D\u0443\u0442\u0430",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0438"
    },
    aboutXHours: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u0447\u0430\u0441",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u0447\u0430\u0441\u0430"
    },
    xHours: {
        one: "1 \u0447\u0430\u0441",
        other: "{{count}} \u0447\u0430\u0441\u0430"
    },
    xDays: {
        one: "1 \u0434\u0435\u043D",
        other: "{{count}} \u0434\u0435\u043D\u0430"
    },
    aboutXWeeks: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u043D\u0435\u0434\u0435\u043B\u0430",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
    },
    xWeeks: {
        one: "1 \u043D\u0435\u0434\u0435\u043B\u0430",
        other: "{{count}} \u043D\u0435\u0434\u0435\u043B\u0438"
    },
    aboutXMonths: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u043C\u0435\u0441\u0435\u0446",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u043D\u0435\u0434\u0435\u043B\u0438"
    },
    xMonths: {
        one: "1 \u043C\u0435\u0441\u0435\u0446",
        other: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
    },
    aboutXYears: {
        one: "\u043E\u043A\u043E\u043B\u0443 1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043E\u043A\u043E\u043B\u0443 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    xYears: {
        one: "1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    overXYears: {
        one: "\u043F\u043E\u0432\u0435\u045C\u0435 \u043E\u0434 1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u043F\u043E\u0432\u0435\u045C\u0435 \u043E\u0434 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    },
    almostXYears: {
        one: "\u0431\u0435\u0437\u043C\u0430\u043B\u043A\u0443 1 \u0433\u043E\u0434\u0438\u043D\u0430",
        other: "\u0431\u0435\u0437\u043C\u0430\u043B\u043A\u0443 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438"
    }
};
var $5272adae18daced8$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $5272adae18daced8$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0437\u0430 " + result;
        else return "\u043F\u0440\u0435\u0434 " + result;
    }
    return result;
};
var $5272adae18daced8$export$2e2bcd8739ae039 = $5272adae18daced8$var$formatDistance;

});

parcelRegister("kvjGj", function(module, exports) {

$parcel$export(module.exports, "default", () => $eed5f83dd7f38174$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $eed5f83dd7f38174$var$dateFormats = {
    full: "EEEE, dd MMMM yyyy",
    long: "dd MMMM yyyy",
    medium: "dd MMM yyyy",
    short: "dd/MM/yyyy"
};
var $eed5f83dd7f38174$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "H:mm"
};
var $eed5f83dd7f38174$var$dateTimeFormats = {
    any: "{{date}} {{time}}"
};
var $eed5f83dd7f38174$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $eed5f83dd7f38174$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $eed5f83dd7f38174$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $eed5f83dd7f38174$var$dateTimeFormats,
        defaultWidth: "any"
    })
};
var $eed5f83dd7f38174$export$2e2bcd8739ae039 = $eed5f83dd7f38174$var$formatLong;

});

parcelRegister("9orsv", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d6ba7aab5a6d7cd$export$2e2bcd8739ae039);

var $6KZXu = parcelRequire("6KZXu");
var $6d6ba7aab5a6d7cd$var$weekdays = [
    "\u043D\u0435\u0434\u0435\u043B\u0430",
    "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
    "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
    "\u0441\u0440\u0435\u0434\u0430",
    "\u0447\u0435\u0442\u0432\u0440\u0442\u043E\u043A",
    "\u043F\u0435\u0442\u043E\u043A",
    "\u0441\u0430\u0431\u043E\u0442\u0430"
];
function $6d6ba7aab5a6d7cd$var$_lastWeek(day) {
    var weekday = $6d6ba7aab5a6d7cd$var$weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u043C\u0438\u043D\u0430\u0442\u0430\u0442\u0430 " + weekday + " \u0432\u043E' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u043C\u0438\u043D\u0430\u0442\u0438\u043E\u0442 " + weekday + " \u0432\u043E' p";
    }
}
function $6d6ba7aab5a6d7cd$var$thisWeek(day) {
    var weekday = $6d6ba7aab5a6d7cd$var$weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u043E\u0432\u0430 " + weekday + " \u0432o' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u043E\u0432\u043E\u0458 " + weekday + " \u0432o' p";
    }
}
function $6d6ba7aab5a6d7cd$var$_nextWeek(day) {
    var weekday = $6d6ba7aab5a6d7cd$var$weekdays[day];
    switch(day){
        case 0:
        case 3:
        case 6:
            return "'\u0441\u043B\u0435\u0434\u043D\u0430\u0442\u0430 " + weekday + " \u0432o' p";
        case 1:
        case 2:
        case 4:
        case 5:
            return "'\u0441\u043B\u0435\u0434\u043D\u0438\u043E\u0442 " + weekday + " \u0432o' p";
    }
}
var $6d6ba7aab5a6d7cd$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $6KZXu.default)(date, baseDate, options)) return $6d6ba7aab5a6d7cd$var$thisWeek(day);
        else return $6d6ba7aab5a6d7cd$var$_lastWeek(day);
    },
    yesterday: "'\u0432\u0447\u0435\u0440\u0430 \u0432\u043E' p",
    today: "'\u0434\u0435\u043D\u0435\u0441 \u0432\u043E' p",
    tomorrow: "'\u0443\u0442\u0440\u0435 \u0432\u043E' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $6KZXu.default)(date, baseDate, options)) return $6d6ba7aab5a6d7cd$var$thisWeek(day);
        else return $6d6ba7aab5a6d7cd$var$_nextWeek(day);
    },
    other: "P"
};
var $6d6ba7aab5a6d7cd$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $6d6ba7aab5a6d7cd$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
var $6d6ba7aab5a6d7cd$export$2e2bcd8739ae039 = $6d6ba7aab5a6d7cd$var$formatRelative;

});

parcelRegister("kXR8W", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4328a733b8ea63c$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $f4328a733b8ea63c$var$eraValues = {
    narrow: [
        "\u043F\u0440.\u043D.\u0435.",
        "\u043D.\u0435."
    ],
    abbreviated: [
        "\u043F\u0440\u0435\u0434 \u043D. \u0435.",
        "\u043D. \u0435."
    ],
    wide: [
        "\u043F\u0440\u0435\u0434 \u043D\u0430\u0448\u0430\u0442\u0430 \u0435\u0440\u0430",
        "\u043D\u0430\u0448\u0430\u0442\u0430 \u0435\u0440\u0430"
    ]
};
var $f4328a733b8ea63c$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-\u0432\u0438 \u043A\u0432.",
        "2-\u0440\u0438 \u043A\u0432.",
        "3-\u0442\u0438 \u043A\u0432.",
        "4-\u0442\u0438 \u043A\u0432."
    ],
    wide: [
        "1-\u0432\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0440\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0442\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u0442\u0438 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var $f4328a733b8ea63c$var$monthValues = {
    abbreviated: [
        "\u0458\u0430\u043D",
        "\u0444\u0435\u0432",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043F\u0442",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u0435\u043C",
        "\u0434\u0435\u043A"
    ],
    wide: [
        "\u0458\u0430\u043D\u0443\u0430\u0440\u0438",
        "\u0444\u0435\u0432\u0440\u0443\u0430\u0440\u0438",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0438\u043B",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D\u0438",
        "\u0458\u0443\u043B\u0438",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043F\u0442\u0435\u043C\u0432\u0440\u0438",
        "\u043E\u043A\u0442\u043E\u043C\u0432\u0440\u0438",
        "\u043D\u043E\u0435\u043C\u0432\u0440\u0438",
        "\u0434\u0435\u043A\u0435\u043C\u0432\u0440\u0438"
    ]
};
var $f4328a733b8ea63c$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0435",
        "\u043F\u043E",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0435",
        "\u043F\u0435",
        "\u0441\u0430"
    ],
    abbreviated: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0432\u0442\u043E",
        "\u0441\u0440\u0435",
        "\u0447\u0435\u0442",
        "\u043F\u0435\u0442",
        "\u0441\u0430\u0431"
    ],
    wide: [
        "\u043D\u0435\u0434\u0435\u043B\u0430",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u043D\u0438\u043A",
        "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
        "\u0441\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0440\u0442\u043E\u043A",
        "\u043F\u0435\u0442\u043E\u043A",
        "\u0441\u0430\u0431\u043E\u0442\u0430"
    ]
};
var $f4328a733b8ea63c$var$dayPeriodValues = {
    wide: {
        am: "\u043F\u0440\u0435\u0442\u043F\u043B\u0430\u0434\u043D\u0435",
        pm: "\u043F\u043E\u043F\u043B\u0430\u0434\u043D\u0435",
        midnight: "\u043F\u043E\u043B\u043D\u043E\u045C",
        noon: "\u043D\u0430\u043F\u043B\u0430\u0434\u043D\u0435",
        morning: "\u043D\u0430\u0443\u0442\u0440\u043E",
        afternoon: "\u043F\u043E\u043F\u043B\u0430\u0434\u043D\u0435",
        evening: "\u043D\u0430\u0432\u0435\u0447\u0435\u0440",
        night: "\u043D\u043E\u045C\u0435"
    }
};
var $f4328a733b8ea63c$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "-\u0432\u0438";
        case 2:
            return number + "-\u0440\u0438";
        case 7:
        case 8:
            return number + "-\u043C\u0438";
    }
    return number + "-\u0442\u0438";
};
var $f4328a733b8ea63c$var$localize = {
    ordinalNumber: $f4328a733b8ea63c$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $f4328a733b8ea63c$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $f4328a733b8ea63c$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $f4328a733b8ea63c$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $f4328a733b8ea63c$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $f4328a733b8ea63c$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};
var $f4328a733b8ea63c$export$2e2bcd8739ae039 = $f4328a733b8ea63c$var$localize;

});

parcelRegister("1hkJt", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ee775fd977a7f0b$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $0ee775fd977a7f0b$var$matchOrdinalNumberPattern = /^(\d+)(-?[врмт][и])?/i;
var $0ee775fd977a7f0b$var$parseOrdinalNumberPattern = /\d+/i;
var $0ee775fd977a7f0b$var$matchEraPatterns = {
    narrow: /^((пр)?н\.?\s?е\.?)/i,
    abbreviated: /^((пр)?н\.?\s?е\.?)/i,
    wide: /^(пред нашата ера|нашата ера)/i
};
var $0ee775fd977a7f0b$var$parseEraPatterns = {
    any: [
        /^п/i,
        /^н/i
    ]
};
var $0ee775fd977a7f0b$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[врт]?и?)? кв.?/i,
    wide: /^[1234](-?[врт]?и?)? квартал/i
};
var $0ee775fd977a7f0b$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $0ee775fd977a7f0b$var$matchDayPatterns = {
    narrow: /^[нпвсч]/i,
    short: /^(не|по|вт|ср|че|пе|са)/i,
    abbreviated: /^(нед|пон|вто|сре|чет|пет|саб)/i,
    wide: /^(недела|понеделник|вторник|среда|четврток|петок|сабота)/i
};
var $0ee775fd977a7f0b$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н[ед]/i,
        /^п[он]/i,
        /^вт/i,
        /^ср/i,
        /^ч[ет]/i,
        /^п[ет]/i,
        /^с[аб]/i
    ]
};
var $0ee775fd977a7f0b$var$matchMonthPatterns = {
    abbreviated: /^(јан|фев|мар|апр|мај|јун|јул|авг|сеп|окт|ноем|дек)/i,
    wide: /^(јануари|февруари|март|април|мај|јуни|јули|август|септември|октомври|ноември|декември)/i
};
var $0ee775fd977a7f0b$var$parseMonthPatterns = {
    any: [
        /^ја/i,
        /^Ф/i,
        /^мар/i,
        /^ап/i,
        /^мај/i,
        /^јун/i,
        /^јул/i,
        /^ав/i,
        /^се/i,
        /^окт/i,
        /^но/i,
        /^де/i
    ]
};
var $0ee775fd977a7f0b$var$matchDayPeriodPatterns = {
    any: /^(претп|попл|полноќ|утро|пладне|вечер|ноќ)/i
};
var $0ee775fd977a7f0b$var$parseDayPeriodPatterns = {
    any: {
        am: /претпладне/i,
        pm: /попладне/i,
        midnight: /полноќ/i,
        noon: /напладне/i,
        morning: /наутро/i,
        afternoon: /попладне/i,
        evening: /навечер/i,
        night: /ноќе/i
    }
};
var $0ee775fd977a7f0b$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $0ee775fd977a7f0b$var$matchOrdinalNumberPattern,
        parsePattern: $0ee775fd977a7f0b$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $0ee775fd977a7f0b$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $0ee775fd977a7f0b$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $0ee775fd977a7f0b$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $0ee775fd977a7f0b$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $0ee775fd977a7f0b$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $0ee775fd977a7f0b$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $0ee775fd977a7f0b$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $0ee775fd977a7f0b$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $0ee775fd977a7f0b$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $0ee775fd977a7f0b$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $0ee775fd977a7f0b$export$2e2bcd8739ae039 = $0ee775fd977a7f0b$var$match;

});


parcelRegister("lerBG", function(module, exports) {

$parcel$export(module.exports, "default", () => $f75051ed0d6808bb$export$2e2bcd8739ae039);

var $aCaIM = parcelRequire("aCaIM");

var $kd0Fl = parcelRequire("kd0Fl");

var $G3xsS = parcelRequire("G3xsS");

var $g71Fl = parcelRequire("g71Fl");

var $d5qcQ = parcelRequire("d5qcQ");
/**
 * @type {Locale}
 * @category Locales
 * @summary Mongolian locale.
 * @language Mongolian
 * @iso-639-2 mon
 * @author Bilguun Ochirbat [@bilguun0203]{@link https://github.com/bilguun0203}
 */ var $f75051ed0d6808bb$var$locale = {
    code: "mn",
    formatDistance: (0, $aCaIM.default),
    formatLong: (0, $kd0Fl.default),
    formatRelative: (0, $G3xsS.default),
    localize: (0, $g71Fl.default),
    match: (0, $d5qcQ.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $f75051ed0d6808bb$export$2e2bcd8739ae039 = $f75051ed0d6808bb$var$locale;

});
parcelRegister("aCaIM", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ba5c5096f3cd422$export$2e2bcd8739ae039);
var $7ba5c5096f3cd422$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0441\u0435\u043A\u0443\u043D\u0434 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439"
    },
    xSeconds: {
        one: "1 \u0441\u0435\u043A\u0443\u043D\u0434",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
    },
    halfAMinute: "\u0445\u0430\u0433\u0430\u0441 \u043C\u0438\u043D\u0443\u0442",
    lessThanXMinutes: {
        one: "\u043C\u0438\u043D\u0443\u0442 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439"
    },
    xMinutes: {
        one: "1 \u043C\u0438\u043D\u0443\u0442",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442"
    },
    aboutXHours: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0446\u0430\u0433",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0446\u0430\u0433"
    },
    xHours: {
        one: "1 \u0446\u0430\u0433",
        other: "{{count}} \u0446\u0430\u0433"
    },
    xDays: {
        one: "1 \u04E9\u0434\u04E9\u0440",
        other: "{{count}} \u04E9\u0434\u04E9\u0440"
    },
    aboutXWeeks: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433"
    },
    xWeeks: {
        one: "1 \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433",
        other: "{{count}} \u0434\u043E\u043B\u043E\u043E \u0445\u043E\u043D\u043E\u0433"
    },
    aboutXMonths: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0441\u0430\u0440",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0441\u0430\u0440"
    },
    xMonths: {
        one: "1 \u0441\u0430\u0440",
        other: "{{count}} \u0441\u0430\u0440"
    },
    aboutXYears: {
        one: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 1 \u0436\u0438\u043B",
        other: "\u043E\u0439\u0440\u043E\u043B\u0446\u043E\u043E\u0433\u043E\u043E\u0440 {{count}} \u0436\u0438\u043B"
    },
    xYears: {
        one: "1 \u0436\u0438\u043B",
        other: "{{count}} \u0436\u0438\u043B"
    },
    overXYears: {
        one: "1 \u0436\u0438\u043B \u0433\u0430\u0440\u0430\u043D",
        other: "{{count}} \u0436\u0438\u043B \u0433\u0430\u0440\u0430\u043D"
    },
    almostXYears: {
        one: "\u0431\u0430\u0440\u0430\u0433 1 \u0436\u0438\u043B",
        other: "\u0431\u0430\u0440\u0430\u0433 {{count}} \u0436\u0438\u043B"
    }
};
var $7ba5c5096f3cd422$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $7ba5c5096f3cd422$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        /**
     * Append genitive case
     */ var words = result.split(" ");
        var lastword = words.pop();
        result = words.join(" ");
        switch(lastword){
            case "\u0441\u0435\u043A\u0443\u043D\u0434":
                result += " \u0441\u0435\u043A\u0443\u043D\u0434\u0438\u0439\u043D";
                break;
            case "\u043C\u0438\u043D\u0443\u0442":
                result += " \u043C\u0438\u043D\u0443\u0442\u044B\u043D";
                break;
            case "\u0446\u0430\u0433":
                result += " \u0446\u0430\u0433\u0438\u0439\u043D";
                break;
            case "\u04E9\u0434\u04E9\u0440":
                result += " \u04E9\u0434\u0440\u0438\u0439\u043D";
                break;
            case "\u0441\u0430\u0440":
                result += " \u0441\u0430\u0440\u044B\u043D";
                break;
            case "\u0436\u0438\u043B":
                result += " \u0436\u0438\u043B\u0438\u0439\u043D";
                break;
            case "\u0445\u043E\u043D\u043E\u0433":
                result += " \u0445\u043E\u043D\u043E\u0433\u0438\u0439\u043D";
                break;
            case "\u0433\u0430\u0440\u0430\u043D":
                result += " \u0433\u0430\u0440\u0430\u043D\u044B";
                break;
            case "\u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439":
                result += " \u0445\u04AF\u0440\u044D\u0445\u0433\u04AF\u0439 \u0445\u0443\u0433\u0430\u0446\u0430\u0430\u043D\u044B";
                break;
            default:
                result += lastword + "-\u043D";
        }
        if (options.comparison && options.comparison > 0) return result + " \u0434\u0430\u0440\u0430\u0430";
        else return result + " \u04E9\u043C\u043D\u04E9";
    }
    return result;
};
var $7ba5c5096f3cd422$export$2e2bcd8739ae039 = $7ba5c5096f3cd422$var$formatDistance;

});

parcelRegister("kd0Fl", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb6589c64e8fc995$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $eb6589c64e8fc995$var$dateFormats = {
    full: "y '\u043E\u043D\u044B' MMMM'\u044B\u043D' d, EEEE '\u0433\u0430\u0440\u0430\u0433'",
    long: "y '\u043E\u043D\u044B' MMMM'\u044B\u043D' d",
    medium: "y '\u043E\u043D\u044B' MMM'\u044B\u043D' d",
    short: "y.MM.dd"
};
var $eb6589c64e8fc995$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
var $eb6589c64e8fc995$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $eb6589c64e8fc995$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $eb6589c64e8fc995$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $eb6589c64e8fc995$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $eb6589c64e8fc995$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $eb6589c64e8fc995$export$2e2bcd8739ae039 = $eb6589c64e8fc995$var$formatLong;

});

parcelRegister("G3xsS", function(module, exports) {

$parcel$export(module.exports, "default", () => $07e6ab14e3f40cba$export$2e2bcd8739ae039);
var $07e6ab14e3f40cba$var$formatRelativeLocale = {
    lastWeek: "'\u04E9\u043D\u0433\u04E9\u0440\u0441\u04E9\u043D' eeee '\u0433\u0430\u0440\u0430\u0433\u0438\u0439\u043D' p '\u0446\u0430\u0433\u0442'",
    yesterday: "'\u04E9\u0447\u0438\u0433\u0434\u04E9\u0440' p '\u0446\u0430\u0433\u0442'",
    today: "'\u04E9\u043D\u04E9\u04E9\u0434\u04E9\u0440' p '\u0446\u0430\u0433\u0442'",
    tomorrow: "'\u043C\u0430\u0440\u0433\u0430\u0430\u0448' p '\u0446\u0430\u0433\u0442'",
    nextWeek: "'\u0438\u0440\u044D\u0445' eeee '\u0433\u0430\u0440\u0430\u0433\u0438\u0439\u043D' p '\u0446\u0430\u0433\u0442'",
    other: "P"
};
var $07e6ab14e3f40cba$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $07e6ab14e3f40cba$var$formatRelativeLocale[token];
};
var $07e6ab14e3f40cba$export$2e2bcd8739ae039 = $07e6ab14e3f40cba$var$formatRelative;

});

parcelRegister("g71Fl", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbae9791827c95e8$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $bbae9791827c95e8$var$eraValues = {
    narrow: [
        "\u041D\u0422\u04E8",
        "\u041D\u0422"
    ],
    abbreviated: [
        "\u041D\u0422\u04E8",
        "\u041D\u0422"
    ],
    wide: [
        "\u043D\u0438\u0439\u0442\u0438\u0439\u043D \u0442\u043E\u043E\u043B\u043B\u044B\u043D \u04E9\u043C\u043D\u04E9\u0445",
        "\u043D\u0438\u0439\u0442\u0438\u0439\u043D \u0442\u043E\u043E\u043B\u043B\u044B\u043D"
    ]
};
var $bbae9791827c95e8$var$quarterValues = {
    narrow: [
        "I",
        "II",
        "III",
        "IV"
    ],
    abbreviated: [
        "I \u0443\u043B\u0438\u0440\u0430\u043B",
        "II \u0443\u043B\u0438\u0440\u0430\u043B",
        "III \u0443\u043B\u0438\u0440\u0430\u043B",
        "IV \u0443\u043B\u0438\u0440\u0430\u043B"
    ],
    wide: [
        "1-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B",
        "2-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B",
        "3-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B",
        "4-\u0440 \u0443\u043B\u0438\u0440\u0430\u043B"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $bbae9791827c95e8$var$monthValues = {
    narrow: [
        "I",
        "II",
        "III",
        "IV",
        "V",
        "VI",
        "VII",
        "VIII",
        "IX",
        "X",
        "XI",
        "XII"
    ],
    abbreviated: [
        "1-\u0440 \u0441\u0430\u0440",
        "2-\u0440 \u0441\u0430\u0440",
        "3-\u0440 \u0441\u0430\u0440",
        "4-\u0440 \u0441\u0430\u0440",
        "5-\u0440 \u0441\u0430\u0440",
        "6-\u0440 \u0441\u0430\u0440",
        "7-\u0440 \u0441\u0430\u0440",
        "8-\u0440 \u0441\u0430\u0440",
        "9-\u0440 \u0441\u0430\u0440",
        "10-\u0440 \u0441\u0430\u0440",
        "11-\u0440 \u0441\u0430\u0440",
        "12-\u0440 \u0441\u0430\u0440"
    ],
    wide: [
        "\u041D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0425\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0413\u0443\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0414\u04E9\u0440\u04E9\u0432\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0422\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0417\u0443\u0440\u0433\u0430\u0430\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0414\u043E\u043B\u043E\u043E\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u041D\u0430\u0439\u043C\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0415\u0441\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0410\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0410\u0440\u0432\u0430\u043D\u043D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0410\u0440\u0432\u0430\u043D \u0445\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440"
    ]
};
var $bbae9791827c95e8$var$formattingMonthValues = {
    narrow: [
        "I",
        "II",
        "III",
        "IV",
        "V",
        "VI",
        "VII",
        "VIII",
        "IX",
        "X",
        "XI",
        "XII"
    ],
    abbreviated: [
        "1-\u0440 \u0441\u0430\u0440",
        "2-\u0440 \u0441\u0430\u0440",
        "3-\u0440 \u0441\u0430\u0440",
        "4-\u0440 \u0441\u0430\u0440",
        "5-\u0440 \u0441\u0430\u0440",
        "6-\u0440 \u0441\u0430\u0440",
        "7-\u0440 \u0441\u0430\u0440",
        "8-\u0440 \u0441\u0430\u0440",
        "9-\u0440 \u0441\u0430\u0440",
        "10-\u0440 \u0441\u0430\u0440",
        "11-\u0440 \u0441\u0430\u0440",
        "12-\u0440 \u0441\u0430\u0440"
    ],
    wide: [
        "\u043D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0445\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0433\u0443\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0434\u04E9\u0440\u04E9\u0432\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0442\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0437\u0443\u0440\u0433\u0430\u0430\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0434\u043E\u043B\u043E\u043E\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u043D\u0430\u0439\u043C\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0435\u0441\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0430\u0440\u0430\u0432\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440",
        "\u0430\u0440\u0432\u0430\u043D\u043D\u044D\u0433\u0434\u04AF\u0433\u044D\u044D\u0440 \u0441\u0430\u0440",
        "\u0430\u0440\u0432\u0430\u043D \u0445\u043E\u0451\u0440\u0434\u0443\u0433\u0430\u0430\u0440 \u0441\u0430\u0440"
    ]
};
var $bbae9791827c95e8$var$dayValues = {
    narrow: [
        "\u041D",
        "\u0414",
        "\u041C",
        "\u041B",
        "\u041F",
        "\u0411",
        "\u0411"
    ],
    short: [
        "\u041D\u044F",
        "\u0414\u0430",
        "\u041C\u044F",
        "\u041B\u0445",
        "\u041F\u04AF",
        "\u0411\u0430",
        "\u0411\u044F"
    ],
    abbreviated: [
        "\u041D\u044F\u043C",
        "\u0414\u0430\u0432",
        "\u041C\u044F\u0433",
        "\u041B\u0445\u0430",
        "\u041F\u04AF\u0440",
        "\u0411\u0430\u0430",
        "\u0411\u044F\u043C"
    ],
    wide: [
        "\u041D\u044F\u043C",
        "\u0414\u0430\u0432\u0430\u0430",
        "\u041C\u044F\u0433\u043C\u0430\u0440",
        "\u041B\u0445\u0430\u0433\u0432\u0430",
        "\u041F\u04AF\u0440\u044D\u0432",
        "\u0411\u0430\u0430\u0441\u0430\u043D",
        "\u0411\u044F\u043C\u0431\u0430"
    ]
};
var $bbae9791827c95e8$var$formattingDayValues = {
    narrow: [
        "\u041D",
        "\u0414",
        "\u041C",
        "\u041B",
        "\u041F",
        "\u0411",
        "\u0411"
    ],
    short: [
        "\u041D\u044F",
        "\u0414\u0430",
        "\u041C\u044F",
        "\u041B\u0445",
        "\u041F\u04AF",
        "\u0411\u0430",
        "\u0411\u044F"
    ],
    abbreviated: [
        "\u041D\u044F\u043C",
        "\u0414\u0430\u0432",
        "\u041C\u044F\u0433",
        "\u041B\u0445\u0430",
        "\u041F\u04AF\u0440",
        "\u0411\u0430\u0430",
        "\u0411\u044F\u043C"
    ],
    wide: [
        "\u043D\u044F\u043C",
        "\u0434\u0430\u0432\u0430\u0430",
        "\u043C\u044F\u0433\u043C\u0430\u0440",
        "\u043B\u0445\u0430\u0433\u0432\u0430",
        "\u043F\u04AF\u0440\u044D\u0432",
        "\u0431\u0430\u0430\u0441\u0430\u043D",
        "\u0431\u044F\u043C\u0431\u0430"
    ]
};
var $bbae9791827c95e8$var$dayPeriodValues = {
    narrow: {
        am: "\u04AF.\u04E9.",
        pm: "\u04AF.\u0445.",
        midnight: "\u0448\u04E9\u043D\u04E9 \u0434\u0443\u043D\u0434",
        noon: "\u04AF\u0434 \u0434\u0443\u043D\u0434",
        morning: "\u04E9\u0433\u043B\u04E9\u04E9",
        afternoon: "\u04E9\u0434\u04E9\u0440",
        evening: "\u043E\u0440\u043E\u0439",
        night: "\u0448\u04E9\u043D\u04E9"
    },
    abbreviated: {
        am: "\u04AF.\u04E9.",
        pm: "\u04AF.\u0445.",
        midnight: "\u0448\u04E9\u043D\u04E9 \u0434\u0443\u043D\u0434",
        noon: "\u04AF\u0434 \u0434\u0443\u043D\u0434",
        morning: "\u04E9\u0433\u043B\u04E9\u04E9",
        afternoon: "\u04E9\u0434\u04E9\u0440",
        evening: "\u043E\u0440\u043E\u0439",
        night: "\u0448\u04E9\u043D\u04E9"
    },
    wide: {
        am: "\u04AF.\u04E9.",
        pm: "\u04AF.\u0445.",
        midnight: "\u0448\u04E9\u043D\u04E9 \u0434\u0443\u043D\u0434",
        noon: "\u04AF\u0434 \u0434\u0443\u043D\u0434",
        morning: "\u04E9\u0433\u043B\u04E9\u04E9",
        afternoon: "\u04E9\u0434\u04E9\u0440",
        evening: "\u043E\u0440\u043E\u0439",
        night: "\u0448\u04E9\u043D\u04E9"
    }
};
var $bbae9791827c95e8$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $bbae9791827c95e8$var$localize = {
    ordinalNumber: $bbae9791827c95e8$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $bbae9791827c95e8$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $bbae9791827c95e8$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $bbae9791827c95e8$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $bbae9791827c95e8$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $bbae9791827c95e8$var$dayValues,
        defaultWidth: "wide",
        formattingValues: $bbae9791827c95e8$var$formattingDayValues,
        defaultFormattingWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $bbae9791827c95e8$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};
var $bbae9791827c95e8$export$2e2bcd8739ae039 = $bbae9791827c95e8$var$localize;

});

parcelRegister("d5qcQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $987011f8c550d109$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $987011f8c550d109$var$matchOrdinalNumberPattern = /\d+/i;
var $987011f8c550d109$var$parseOrdinalNumberPattern = /\d+/i;
var $987011f8c550d109$var$matchEraPatterns = {
    narrow: /^(нтө|нт)/i,
    abbreviated: /^(нтө|нт)/i,
    wide: /^(нийтийн тооллын өмнө|нийтийн тооллын)/i
};
var $987011f8c550d109$var$parseEraPatterns = {
    any: [
        /^(нтө|нийтийн тооллын өмнө)/i,
        /^(нт|нийтийн тооллын)/i
    ]
};
var $987011f8c550d109$var$matchQuarterPatterns = {
    narrow: /^(iv|iii|ii|i)/i,
    abbreviated: /^(iv|iii|ii|i) улирал/i,
    wide: /^[1-4]-р улирал/i
};
var $987011f8c550d109$var$parseQuarterPatterns = {
    any: [
        /^(i(\s|$)|1)/i,
        /^(ii(\s|$)|2)/i,
        /^(iii(\s|$)|3)/i,
        /^(iv(\s|$)|4)/i
    ]
};
var $987011f8c550d109$var$matchMonthPatterns = {
    narrow: /^(xii|xi|x|ix|viii|vii|vi|v|iv|iii|ii|i)/i,
    abbreviated: /^(1-р сар|2-р сар|3-р сар|4-р сар|5-р сар|6-р сар|7-р сар|8-р сар|9-р сар|10-р сар|11-р сар|12-р сар)/i,
    wide: /^(нэгдүгээр сар|хоёрдугаар сар|гуравдугаар сар|дөрөвдүгээр сар|тавдугаар сар|зургаадугаар сар|долоодугаар сар|наймдугаар сар|есдүгээр сар|аравдугаар сар|арван нэгдүгээр сар|арван хоёрдугаар сар)/i
};
var $987011f8c550d109$var$parseMonthPatterns = {
    narrow: [
        /^i$/i,
        /^ii$/i,
        /^iii$/i,
        /^iv$/i,
        /^v$/i,
        /^vi$/i,
        /^vii$/i,
        /^viii$/i,
        /^ix$/i,
        /^x$/i,
        /^xi$/i,
        /^xii$/i
    ],
    any: [
        /^(1|нэгдүгээр)/i,
        /^(2|хоёрдугаар)/i,
        /^(3|гуравдугаар)/i,
        /^(4|дөрөвдүгээр)/i,
        /^(5|тавдугаар)/i,
        /^(6|зургаадугаар)/i,
        /^(7|долоодугаар)/i,
        /^(8|наймдугаар)/i,
        /^(9|есдүгээр)/i,
        /^(10|аравдугаар)/i,
        /^(11|арван нэгдүгээр)/i,
        /^(12|арван хоёрдугаар)/i
    ]
};
var $987011f8c550d109$var$matchDayPatterns = {
    narrow: /^[ндмлпбб]/i,
    short: /^(ня|да|мя|лх|пү|ба|бя)/i,
    abbreviated: /^(ням|дав|мяг|лха|пүр|баа|бям)/i,
    wide: /^(ням|даваа|мягмар|лхагва|пүрэв|баасан|бямба)/i
};
var $987011f8c550d109$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^д/i,
        /^м/i,
        /^л/i,
        /^п/i,
        /^б/i,
        /^б/i
    ],
    any: [
        /^ня/i,
        /^да/i,
        /^мя/i,
        /^лх/i,
        /^пү/i,
        /^ба/i,
        /^бя/i
    ]
};
var $987011f8c550d109$var$matchDayPeriodPatterns = {
    narrow: /^(ү\.ө\.|ү\.х\.|шөнө дунд|үд дунд|өглөө|өдөр|орой|шөнө)/i,
    any: /^(ү\.ө\.|ү\.х\.|шөнө дунд|үд дунд|өглөө|өдөр|орой|шөнө)/i
};
var $987011f8c550d109$var$parseDayPeriodPatterns = {
    any: {
        am: /^ү\.ө\./i,
        pm: /^ү\.х\./i,
        midnight: /^шөнө дунд/i,
        noon: /^үд дунд/i,
        morning: /өглөө/i,
        afternoon: /өдөр/i,
        evening: /орой/i,
        night: /шөнө/i
    }
};
var $987011f8c550d109$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $987011f8c550d109$var$matchOrdinalNumberPattern,
        parsePattern: $987011f8c550d109$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $987011f8c550d109$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $987011f8c550d109$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $987011f8c550d109$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $987011f8c550d109$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $987011f8c550d109$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $987011f8c550d109$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $987011f8c550d109$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $987011f8c550d109$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $987011f8c550d109$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $987011f8c550d109$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $987011f8c550d109$export$2e2bcd8739ae039 = $987011f8c550d109$var$match;

});


parcelRegister("7IG4W", function(module, exports) {

$parcel$export(module.exports, "default", () => $59ed486c03de10e2$export$2e2bcd8739ae039);

var $5fwDq = parcelRequire("5fwDq");

var $8CKYF = parcelRequire("8CKYF");

var $dwJbg = parcelRequire("dwJbg");

var $i0R13 = parcelRequire("i0R13");

var $hwUH8 = parcelRequire("hwUH8");
/**
 * @type {Locale}
 * @category Locales
 * @summary Malay locale.
 * @language Malay
 * @iso-639-2 msa
 * @author Ruban Selvarajah [@Zyten]{@link https://github.com/Zyten}
 */ var $59ed486c03de10e2$var$locale = {
    code: "ms",
    formatDistance: (0, $5fwDq.default),
    formatLong: (0, $8CKYF.default),
    formatRelative: (0, $dwJbg.default),
    localize: (0, $i0R13.default),
    match: (0, $hwUH8.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $59ed486c03de10e2$export$2e2bcd8739ae039 = $59ed486c03de10e2$var$locale;

});
parcelRegister("5fwDq", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d27ab0ccc7c5d9b$export$2e2bcd8739ae039);
var $3d27ab0ccc7c5d9b$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "kurang dari 1 saat",
        other: "kurang dari {{count}} saat"
    },
    xSeconds: {
        one: "1 saat",
        other: "{{count}} saat"
    },
    halfAMinute: "setengah minit",
    lessThanXMinutes: {
        one: "kurang dari 1 minit",
        other: "kurang dari {{count}} minit"
    },
    xMinutes: {
        one: "1 minit",
        other: "{{count}} minit"
    },
    aboutXHours: {
        one: "sekitar 1 jam",
        other: "sekitar {{count}} jam"
    },
    xHours: {
        one: "1 jam",
        other: "{{count}} jam"
    },
    xDays: {
        one: "1 hari",
        other: "{{count}} hari"
    },
    aboutXWeeks: {
        one: "sekitar 1 minggu",
        other: "sekitar {{count}} minggu"
    },
    xWeeks: {
        one: "1 minggu",
        other: "{{count}} minggu"
    },
    aboutXMonths: {
        one: "sekitar 1 bulan",
        other: "sekitar {{count}} bulan"
    },
    xMonths: {
        one: "1 bulan",
        other: "{{count}} bulan"
    },
    aboutXYears: {
        one: "sekitar 1 tahun",
        other: "sekitar {{count}} tahun"
    },
    xYears: {
        one: "1 tahun",
        other: "{{count}} tahun"
    },
    overXYears: {
        one: "lebih dari 1 tahun",
        other: "lebih dari {{count}} tahun"
    },
    almostXYears: {
        one: "hampir 1 tahun",
        other: "hampir {{count}} tahun"
    }
};
var $3d27ab0ccc7c5d9b$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $3d27ab0ccc7c5d9b$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "dalam masa " + result;
        else return result + " yang lalu";
    }
    return result;
};
var $3d27ab0ccc7c5d9b$export$2e2bcd8739ae039 = $3d27ab0ccc7c5d9b$var$formatDistance;

});

parcelRegister("8CKYF", function(module, exports) {

$parcel$export(module.exports, "default", () => $64765012bc1e9efd$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $64765012bc1e9efd$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "d/M/yyyy"
};
var $64765012bc1e9efd$var$timeFormats = {
    full: "HH.mm.ss",
    long: "HH.mm.ss",
    medium: "HH.mm",
    short: "HH.mm"
};
var $64765012bc1e9efd$var$dateTimeFormats = {
    full: "{{date}} 'pukul' {{time}}",
    long: "{{date}} 'pukul' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $64765012bc1e9efd$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $64765012bc1e9efd$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $64765012bc1e9efd$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $64765012bc1e9efd$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $64765012bc1e9efd$export$2e2bcd8739ae039 = $64765012bc1e9efd$var$formatLong;

});

parcelRegister("dwJbg", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d914f7a8a1bf668$export$2e2bcd8739ae039);
var $9d914f7a8a1bf668$var$formatRelativeLocale = {
    lastWeek: "eeee 'lepas pada jam' p",
    yesterday: "'Semalam pada jam' p",
    today: "'Hari ini pada jam' p",
    tomorrow: "'Esok pada jam' p",
    nextWeek: "eeee 'pada jam' p",
    other: "P"
};
var $9d914f7a8a1bf668$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $9d914f7a8a1bf668$var$formatRelativeLocale[token];
};
var $9d914f7a8a1bf668$export$2e2bcd8739ae039 = $9d914f7a8a1bf668$var$formatRelative;

});

parcelRegister("i0R13", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1d159f431cd0faa$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
// https://www.unicode.org/cldr/charts/32/summary/ms.html
var $d1d159f431cd0faa$var$eraValues = {
    narrow: [
        "SM",
        "M"
    ],
    abbreviated: [
        "SM",
        "M"
    ],
    wide: [
        "Sebelum Masihi",
        "Masihi"
    ]
};
var $d1d159f431cd0faa$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "S1",
        "S2",
        "S3",
        "S4"
    ],
    wide: [
        "Suku pertama",
        "Suku kedua",
        "Suku ketiga",
        "Suku keempat"
    ]
};
// Note: in Malay, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $d1d159f431cd0faa$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "O",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mac",
        "Apr",
        "Mei",
        "Jun",
        "Jul",
        "Ogo",
        "Sep",
        "Okt",
        "Nov",
        "Dis"
    ],
    wide: [
        "Januari",
        "Februari",
        "Mac",
        "April",
        "Mei",
        "Jun",
        "Julai",
        "Ogos",
        "September",
        "Oktober",
        "November",
        "Disember"
    ]
};
var $d1d159f431cd0faa$var$dayValues = {
    narrow: [
        "A",
        "I",
        "S",
        "R",
        "K",
        "J",
        "S"
    ],
    short: [
        "Ahd",
        "Isn",
        "Sel",
        "Rab",
        "Kha",
        "Jum",
        "Sab"
    ],
    abbreviated: [
        "Ahd",
        "Isn",
        "Sel",
        "Rab",
        "Kha",
        "Jum",
        "Sab"
    ],
    wide: [
        "Ahad",
        "Isnin",
        "Selasa",
        "Rabu",
        "Khamis",
        "Jumaat",
        "Sabtu"
    ]
};
var $d1d159f431cd0faa$var$dayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "tgh malam",
        noon: "tgh hari",
        morning: "pagi",
        afternoon: "tengah hari",
        evening: "petang",
        night: "malam"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "tengah hari",
        evening: "petang",
        night: "malam"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "tengah hari",
        evening: "petang",
        night: "malam"
    }
};
var $d1d159f431cd0faa$var$formattingDayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "tengah hari",
        evening: "petang",
        night: "malam"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "tengah hari",
        evening: "petang",
        night: "malam"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "tengah malam",
        noon: "tengah hari",
        morning: "pagi",
        afternoon: "tengah hari",
        evening: "petang",
        night: "malam"
    }
};
var $d1d159f431cd0faa$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    // Can't use "pertama", "kedua" because can't be parsed
    return "ke-" + Number(dirtyNumber);
};
var $d1d159f431cd0faa$var$localize = {
    ordinalNumber: $d1d159f431cd0faa$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $d1d159f431cd0faa$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $d1d159f431cd0faa$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $d1d159f431cd0faa$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $d1d159f431cd0faa$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $d1d159f431cd0faa$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $d1d159f431cd0faa$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $d1d159f431cd0faa$export$2e2bcd8739ae039 = $d1d159f431cd0faa$var$localize;

});

parcelRegister("hwUH8", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc316737c0cfd223$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $cc316737c0cfd223$var$matchOrdinalNumberPattern = /^ke-(\d+)?/i;
var $cc316737c0cfd223$var$parseOrdinalNumberPattern = /petama|\d+/i;
var $cc316737c0cfd223$var$matchEraPatterns = {
    narrow: /^(sm|m)/i,
    abbreviated: /^(s\.?\s?m\.?|m\.?)/i,
    wide: /^(sebelum masihi|masihi)/i
};
var $cc316737c0cfd223$var$parseEraPatterns = {
    any: [
        /^s/i,
        /^(m)/i
    ]
};
var $cc316737c0cfd223$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^S[1234]/i,
    wide: /Suku (pertama|kedua|ketiga|keempat)/i
};
var $cc316737c0cfd223$var$parseQuarterPatterns = {
    any: [
        /pertama|1/i,
        /kedua|2/i,
        /ketiga|3/i,
        /keempat|4/i
    ]
};
var $cc316737c0cfd223$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mac|apr|mei|jun|jul|ogo|sep|okt|nov|dis)/i,
    wide: /^(januari|februari|mac|april|mei|jun|julai|ogos|september|oktober|november|disember)/i
};
var $cc316737c0cfd223$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^o/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^ma/i,
        /^ap/i,
        /^me/i,
        /^jun/i,
        /^jul/i,
        /^og/i,
        /^s/i,
        /^ok/i,
        /^n/i,
        /^d/i
    ]
};
var $cc316737c0cfd223$var$matchDayPatterns = {
    narrow: /^[aisrkj]/i,
    short: /^(ahd|isn|sel|rab|kha|jum|sab)/i,
    abbreviated: /^(ahd|isn|sel|rab|kha|jum|sab)/i,
    wide: /^(ahad|isnin|selasa|rabu|khamis|jumaat|sabtu)/i
};
var $cc316737c0cfd223$var$parseDayPatterns = {
    narrow: [
        /^a/i,
        /^i/i,
        /^s/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^s/i
    ],
    any: [
        /^a/i,
        /^i/i,
        /^se/i,
        /^r/i,
        /^k/i,
        /^j/i,
        /^sa/i
    ]
};
var $cc316737c0cfd223$var$matchDayPeriodPatterns = {
    narrow: /^(am|pm|tengah malam|tengah hari|pagi|petang|malam)/i,
    any: /^([ap]\.?\s?m\.?|tengah malam|tengah hari|pagi|petang|malam)/i
};
var $cc316737c0cfd223$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^pm/i,
        midnight: /^tengah m/i,
        noon: /^tengah h/i,
        morning: /pa/i,
        afternoon: /tengah h/i,
        evening: /pe/i,
        night: /m/i
    }
};
var $cc316737c0cfd223$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $cc316737c0cfd223$var$matchOrdinalNumberPattern,
        parsePattern: $cc316737c0cfd223$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $cc316737c0cfd223$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cc316737c0cfd223$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $cc316737c0cfd223$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cc316737c0cfd223$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $cc316737c0cfd223$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cc316737c0cfd223$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $cc316737c0cfd223$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $cc316737c0cfd223$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $cc316737c0cfd223$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $cc316737c0cfd223$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $cc316737c0cfd223$export$2e2bcd8739ae039 = $cc316737c0cfd223$var$match;

});


parcelRegister("drgGi", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c8abc8751f3558a$export$2e2bcd8739ae039);

var $9Zcgu = parcelRequire("9Zcgu");

var $40dma = parcelRequire("40dma");

var $4YpjP = parcelRequire("4YpjP");

var $6y6eX = parcelRequire("6y6eX");

var $7oPmV = parcelRequire("7oPmV");
/**
 * @type {Locale}
 * @category Locales
 * @summary Maltese locale.
 * @language Maltese
 * @iso-639-2 mlt
 * @author Andras Matzon [@amatzon](@link https://github.com/amatzon)
 * @author Bryan Borg [@bryanMt](@link https://github.com/bryanMt)
 */ var $9c8abc8751f3558a$var$locale = {
    code: "mt",
    formatDistance: (0, $9Zcgu.default),
    formatLong: (0, $40dma.default),
    formatRelative: (0, $4YpjP.default),
    localize: (0, $6y6eX.default),
    match: (0, $7oPmV.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $9c8abc8751f3558a$export$2e2bcd8739ae039 = $9c8abc8751f3558a$var$locale;

});
parcelRegister("9Zcgu", function(module, exports) {

$parcel$export(module.exports, "default", () => $74535321e8425cbe$export$2e2bcd8739ae039);
var $74535321e8425cbe$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "inqas minn sekonda",
        other: "inqas minn {{count}} sekondi"
    },
    xSeconds: {
        one: "sekonda",
        other: "{{count}} sekondi"
    },
    halfAMinute: "nofs minuta",
    lessThanXMinutes: {
        one: "inqas minn minuta",
        other: "inqas minn {{count}} minuti"
    },
    xMinutes: {
        one: "minuta",
        other: "{{count}} minuti"
    },
    aboutXHours: {
        one: "madwar sieg\u0127a",
        other: "madwar {{count}} sieg\u0127at"
    },
    xHours: {
        one: "sieg\u0127a",
        other: "{{count}} sieg\u0127at"
    },
    xDays: {
        one: "\u0121urnata",
        other: "{{count}} \u0121ranet"
    },
    aboutXWeeks: {
        one: "madwar \u0121img\u0127a",
        other: "madwar {{count}} \u0121img\u0127at"
    },
    xWeeks: {
        one: "\u0121img\u0127a",
        other: "{{count}} \u0121img\u0127at"
    },
    aboutXMonths: {
        one: "madwar xahar",
        other: "madwar {{count}} xhur"
    },
    xMonths: {
        one: "xahar",
        other: "{{count}} xhur"
    },
    aboutXYears: {
        one: "madwar sena",
        two: "madwar sentejn",
        other: "madwar {{count}} snin"
    },
    xYears: {
        one: "sena",
        two: "sentejn",
        other: "{{count}} snin"
    },
    overXYears: {
        one: "aktar minn sena",
        two: "aktar minn sentejn",
        other: "aktar minn {{count}} snin"
    },
    almostXYears: {
        one: "kwa\u017Ci sena",
        two: "kwa\u017Ci sentejn",
        other: "kwa\u017Ci {{count}} snin"
    }
};
var $74535321e8425cbe$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $74535321e8425cbe$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (count === 2 && tokenValue.two) result = tokenValue.two;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "f'" + result;
        else return result + " ilu";
    }
    return result;
};
var $74535321e8425cbe$export$2e2bcd8739ae039 = $74535321e8425cbe$var$formatDistance;

});

parcelRegister("40dma", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ea185d5712c8277$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $2ea185d5712c8277$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd/MM/yyyy"
};
var $2ea185d5712c8277$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $2ea185d5712c8277$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $2ea185d5712c8277$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $2ea185d5712c8277$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $2ea185d5712c8277$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $2ea185d5712c8277$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $2ea185d5712c8277$export$2e2bcd8739ae039 = $2ea185d5712c8277$var$formatLong;

});

parcelRegister("4YpjP", function(module, exports) {

$parcel$export(module.exports, "default", () => $39f067cc96c306aa$export$2e2bcd8739ae039);
var $39f067cc96c306aa$var$formatRelativeLocale = {
    lastWeek: "eeee 'li g\u0127adda' 'fil-'p",
    yesterday: "'Il-biera\u0127 fil-'p",
    today: "'Illum fil-'p",
    tomorrow: "'G\u0127ada fil-'p",
    nextWeek: "eeee 'fil-'p",
    other: "P"
};
var $39f067cc96c306aa$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $39f067cc96c306aa$var$formatRelativeLocale[token];
};
var $39f067cc96c306aa$export$2e2bcd8739ae039 = $39f067cc96c306aa$var$formatRelative;

});

parcelRegister("6y6eX", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c4ac2399922f893$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $4c4ac2399922f893$var$eraValues = {
    narrow: [
        "Q",
        "W"
    ],
    abbreviated: [
        "QK",
        "WK"
    ],
    wide: [
        "qabel Kristu",
        "wara Kristu"
    ]
};
var $4c4ac2399922f893$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "K1",
        "K2",
        "K3",
        "K4"
    ],
    wide: [
        "1. kwart",
        "2. kwart",
        "3. kwart",
        "4. kwart"
    ]
};
var $4c4ac2399922f893$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "\u0120",
        "L",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Fra",
        "Mar",
        "Apr",
        "Mej",
        "\u0120un",
        "Lul",
        "Aww",
        "Set",
        "Ott",
        "Nov",
        "Di\u010B"
    ],
    wide: [
        "Jannar",
        "Frar",
        "Marzu",
        "April",
        "Mejju",
        "\u0120unju",
        "Lulju",
        "Awwissu",
        "Settembru",
        "Ottubru",
        "Novembru",
        "Di\u010Bembru"
    ]
};
var $4c4ac2399922f893$var$dayValues = {
    narrow: [
        "\u0126",
        "T",
        "T",
        "E",
        "\u0126",
        "\u0120",
        "S"
    ],
    short: [
        "\u0126a",
        "Tn",
        "Tl",
        "Er",
        "\u0126a",
        "\u0120i",
        "Si"
    ],
    abbreviated: [
        "\u0126ad",
        "Tne",
        "Tli",
        "Erb",
        "\u0126am",
        "\u0120im",
        "Sib"
    ],
    wide: [
        "Il-\u0126add",
        "It-Tnejn",
        "It-Tlieta",
        "L-Erbg\u0127a",
        "Il-\u0126amis",
        "Il-\u0120img\u0127a",
        "Is-Sibt"
    ]
};
var $4c4ac2399922f893$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "nofsillejl",
        noon: "nofsinhar",
        morning: "g\u0127odwa",
        afternoon: "wara nofsinhar",
        evening: "filg\u0127axija",
        night: "lejl"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "nofsillejl",
        noon: "nofsinhar",
        morning: "g\u0127odwa",
        afternoon: "wara nofsinhar",
        evening: "filg\u0127axija",
        night: "lejl"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "nofsillejl",
        noon: "nofsinhar",
        morning: "g\u0127odwa",
        afternoon: "wara nofsinhar",
        evening: "filg\u0127axija",
        night: "lejl"
    }
};
var $4c4ac2399922f893$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "f'nofsillejl",
        noon: "f'nofsinhar",
        morning: "filg\u0127odu",
        afternoon: "wara nofsinhar",
        evening: "filg\u0127axija",
        night: "billejl"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "f'nofsillejl",
        noon: "f'nofsinhar",
        morning: "filg\u0127odu",
        afternoon: "wara nofsinhar",
        evening: "filg\u0127axija",
        night: "billejl"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "f'nofsillejl",
        noon: "f'nofsinhar",
        morning: "filg\u0127odu",
        afternoon: "wara nofsinhar",
        evening: "filg\u0127axija",
        night: "billejl"
    }
};
var $4c4ac2399922f893$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\xba";
};
var $4c4ac2399922f893$var$localize = {
    ordinalNumber: $4c4ac2399922f893$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $4c4ac2399922f893$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $4c4ac2399922f893$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $4c4ac2399922f893$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $4c4ac2399922f893$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $4c4ac2399922f893$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $4c4ac2399922f893$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $4c4ac2399922f893$export$2e2bcd8739ae039 = $4c4ac2399922f893$var$localize;

});

parcelRegister("7oPmV", function(module, exports) {

$parcel$export(module.exports, "default", () => $56329f0e26e34568$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $56329f0e26e34568$var$matchOrdinalNumberPattern = /^(\d+)(º)?/i;
var $56329f0e26e34568$var$parseOrdinalNumberPattern = /\d+/i;
var $56329f0e26e34568$var$matchEraPatterns = {
    narrow: /^(q|w)/i,
    abbreviated: /^(q\.?\s?k\.?|b\.?\s?c\.?\s?e\.?|w\.?\s?k\.?)/i,
    wide: /^(qabel kristu|before common era|wara kristu|common era)/i
};
var $56329f0e26e34568$var$parseEraPatterns = {
    any: [
        /^(q|b)/i,
        /^(w|c)/i
    ]
};
var $56329f0e26e34568$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^k[1234]/i,
    wide: /^[1234](\.)? kwart/i
};
var $56329f0e26e34568$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $56329f0e26e34568$var$matchMonthPatterns = {
    narrow: /^[jfmaglsond]/i,
    abbreviated: /^(jan|fra|mar|apr|mej|ġun|lul|aww|set|ott|nov|diċ)/i,
    wide: /^(jannar|frar|marzu|april|mejju|ġunju|lulju|awwissu|settembru|ottubru|novembru|diċembru)/i
};
var $56329f0e26e34568$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^ġ/i,
        /^l/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mej/i,
        /^ġ/i,
        /^l/i,
        /^aw/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $56329f0e26e34568$var$matchDayPatterns = {
    narrow: /^[ħteġs]/i,
    short: /^(ħa|tn|tl|er|ħa|ġi|si)/i,
    abbreviated: /^(ħad|tne|tli|erb|ħam|ġim|sib)/i,
    wide: /^(il-ħadd|it-tnejn|it-tlieta|l-erbgħa|il-ħamis|il-ġimgħa|is-sibt)/i
};
var $56329f0e26e34568$var$parseDayPatterns = {
    narrow: [
        /^ħ/i,
        /^t/i,
        /^t/i,
        /^e/i,
        /^ħ/i,
        /^ġ/i,
        /^s/i
    ],
    any: [
        /^(il-)?ħad/i,
        /^(it-)?tn/i,
        /^(it-)?tl/i,
        /^(l-)?er/i,
        /^(il-)?ham/i,
        /^(il-)?ġi/i,
        /^(is-)?si/i
    ]
};
var $56329f0e26e34568$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|f'nofsillejl|f'nofsinhar|(ta') (għodwa|wara nofsinhar|filgħaxija|lejl))/i,
    any: /^([ap]\.?\s?m\.?|f'nofsillejl|f'nofsinhar|(ta') (għodwa|wara nofsinhar|filgħaxija|lejl))/i
};
var $56329f0e26e34568$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^f'nofsillejl/i,
        noon: /^f'nofsinhar/i,
        morning: /għodwa/i,
        afternoon: /wara(\s.*)nofsinhar/i,
        evening: /filgħaxija/i,
        night: /lejl/i
    }
};
var $56329f0e26e34568$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $56329f0e26e34568$var$matchOrdinalNumberPattern,
        parsePattern: $56329f0e26e34568$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $56329f0e26e34568$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $56329f0e26e34568$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $56329f0e26e34568$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $56329f0e26e34568$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $56329f0e26e34568$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $56329f0e26e34568$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $56329f0e26e34568$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $56329f0e26e34568$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $56329f0e26e34568$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $56329f0e26e34568$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $56329f0e26e34568$export$2e2bcd8739ae039 = $56329f0e26e34568$var$match;

});


parcelRegister("aDcxd", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bd7451021f62e49$export$2e2bcd8739ae039);

var $eQe7T = parcelRequire("eQe7T");

var $7UerD = parcelRequire("7UerD");

var $7TZKp = parcelRequire("7TZKp");

var $iFWRi = parcelRequire("iFWRi");

var $hB0S7 = parcelRequire("hB0S7");
/**
 * @type {Locale}
 * @category Locales
 * @summary Norwegian Bokmål locale.
 * @language Norwegian Bokmål
 * @iso-639-2 nob
 * @author Hans-Kristian Koren [@Hanse]{@link https://github.com/Hanse}
 * @author Mikolaj Grzyb [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Dag Stuan [@dagstuan]{@link https://github.com/dagstuan}
 */ var $7bd7451021f62e49$var$locale = {
    code: "nb",
    formatDistance: (0, $eQe7T.default),
    formatLong: (0, $7UerD.default),
    formatRelative: (0, $7TZKp.default),
    localize: (0, $iFWRi.default),
    match: (0, $hB0S7.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $7bd7451021f62e49$export$2e2bcd8739ae039 = $7bd7451021f62e49$var$locale;

});
parcelRegister("eQe7T", function(module, exports) {

$parcel$export(module.exports, "default", () => $ace0e132bfd0d621$export$2e2bcd8739ae039);
var $ace0e132bfd0d621$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mindre enn ett sekund",
        other: "mindre enn {{count}} sekunder"
    },
    xSeconds: {
        one: "ett sekund",
        other: "{{count}} sekunder"
    },
    halfAMinute: "et halvt minutt",
    lessThanXMinutes: {
        one: "mindre enn ett minutt",
        other: "mindre enn {{count}} minutter"
    },
    xMinutes: {
        one: "ett minutt",
        other: "{{count}} minutter"
    },
    aboutXHours: {
        one: "omtrent en time",
        other: "omtrent {{count}} timer"
    },
    xHours: {
        one: "en time",
        other: "{{count}} timer"
    },
    xDays: {
        one: "en dag",
        other: "{{count}} dager"
    },
    aboutXWeeks: {
        one: "omtrent en uke",
        other: "omtrent {{count}} uker"
    },
    xWeeks: {
        one: "en uke",
        other: "{{count}} uker"
    },
    aboutXMonths: {
        one: "omtrent en m\xe5ned",
        other: "omtrent {{count}} m\xe5neder"
    },
    xMonths: {
        one: "en m\xe5ned",
        other: "{{count}} m\xe5neder"
    },
    aboutXYears: {
        one: "omtrent ett \xe5r",
        other: "omtrent {{count}} \xe5r"
    },
    xYears: {
        one: "ett \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "over ett \xe5r",
        other: "over {{count}} \xe5r"
    },
    almostXYears: {
        one: "nesten ett \xe5r",
        other: "nesten {{count}} \xe5r"
    }
};
var $ace0e132bfd0d621$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $ace0e132bfd0d621$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "om " + result;
        else return result + " siden";
    }
    return result;
};
var $ace0e132bfd0d621$export$2e2bcd8739ae039 = $ace0e132bfd0d621$var$formatDistance;

});

parcelRegister("7UerD", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c18f7cdd848a841$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $5c18f7cdd848a841$var$dateFormats = {
    full: "EEEE d. MMMM y",
    long: "d. MMMM y",
    medium: "d. MMM y",
    short: "dd.MM.y"
};
var $5c18f7cdd848a841$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $5c18f7cdd848a841$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $5c18f7cdd848a841$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $5c18f7cdd848a841$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $5c18f7cdd848a841$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $5c18f7cdd848a841$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $5c18f7cdd848a841$export$2e2bcd8739ae039 = $5c18f7cdd848a841$var$formatLong;

});

parcelRegister("7TZKp", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c0d914020bb2b48$export$2e2bcd8739ae039);
var $5c0d914020bb2b48$var$formatRelativeLocale = {
    lastWeek: "'forrige' eeee 'kl.' p",
    yesterday: "'i g\xe5r kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgen kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: "P"
};
var $5c0d914020bb2b48$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $5c0d914020bb2b48$var$formatRelativeLocale[token];
};
var $5c0d914020bb2b48$export$2e2bcd8739ae039 = $5c0d914020bb2b48$var$formatRelative;

});

parcelRegister("iFWRi", function(module, exports) {

$parcel$export(module.exports, "default", () => $d989b672cc480e2e$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $d989b672cc480e2e$var$eraValues = {
    narrow: [
        "f.Kr.",
        "e.Kr."
    ],
    abbreviated: [
        "f.Kr.",
        "e.Kr."
    ],
    wide: [
        "f\xf8r Kristus",
        "etter Kristus"
    ]
};
var $d989b672cc480e2e$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1. kvartal",
        "2. kvartal",
        "3. kvartal",
        "4. kvartal"
    ]
};
var $d989b672cc480e2e$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mars",
        "apr.",
        "mai",
        "juni",
        "juli",
        "aug.",
        "sep.",
        "okt.",
        "nov.",
        "des."
    ],
    wide: [
        "januar",
        "februar",
        "mars",
        "april",
        "mai",
        "juni",
        "juli",
        "august",
        "september",
        "oktober",
        "november",
        "desember"
    ]
};
var $d989b672cc480e2e$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "O",
        "T",
        "F",
        "L"
    ],
    short: [
        "s\xf8",
        "ma",
        "ti",
        "on",
        "to",
        "fr",
        "l\xf8"
    ],
    abbreviated: [
        "s\xf8n",
        "man",
        "tir",
        "ons",
        "tor",
        "fre",
        "l\xf8r"
    ],
    wide: [
        "s\xf8ndag",
        "mandag",
        "tirsdag",
        "onsdag",
        "torsdag",
        "fredag",
        "l\xf8rdag"
    ]
};
var $d989b672cc480e2e$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    },
    abbreviated: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morgenen",
        afternoon: "p\xe5 ettermiddagen",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natten"
    }
};
var $d989b672cc480e2e$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + ".";
};
var $d989b672cc480e2e$var$localize = {
    ordinalNumber: $d989b672cc480e2e$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $d989b672cc480e2e$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $d989b672cc480e2e$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $d989b672cc480e2e$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $d989b672cc480e2e$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $d989b672cc480e2e$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};
var $d989b672cc480e2e$export$2e2bcd8739ae039 = $d989b672cc480e2e$var$localize;

});

parcelRegister("hB0S7", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccf691832f2988e5$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $ccf691832f2988e5$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
var $ccf691832f2988e5$var$parseOrdinalNumberPattern = /\d+/i;
var $ccf691832f2988e5$var$matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
};
var $ccf691832f2988e5$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^e/i
    ]
};
var $ccf691832f2988e5$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? kvartal/i
};
var $ccf691832f2988e5$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $ccf691832f2988e5$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
    wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
};
var $ccf691832f2988e5$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $ccf691832f2988e5$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(sø|ma|ti|on|to|fr|lø)/i,
    abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
    wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
};
var $ccf691832f2988e5$var$parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var $ccf691832f2988e5$var$matchDayPeriodPatterns = {
    narrow: /^(midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten)|[ap])/i,
    any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten))/i
};
var $ccf691832f2988e5$var$parseDayPeriodPatterns = {
    any: {
        am: /^a(\.?\s?m\.?)?$/i,
        pm: /^p(\.?\s?m\.?)?$/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgen/i,
        afternoon: /ettermiddag/i,
        evening: /kveld/i,
        night: /natt/i
    }
};
var $ccf691832f2988e5$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $ccf691832f2988e5$var$matchOrdinalNumberPattern,
        parsePattern: $ccf691832f2988e5$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $ccf691832f2988e5$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ccf691832f2988e5$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $ccf691832f2988e5$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ccf691832f2988e5$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $ccf691832f2988e5$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ccf691832f2988e5$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $ccf691832f2988e5$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ccf691832f2988e5$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $ccf691832f2988e5$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $ccf691832f2988e5$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $ccf691832f2988e5$export$2e2bcd8739ae039 = $ccf691832f2988e5$var$match;

});


parcelRegister("8zqwg", function(module, exports) {

$parcel$export(module.exports, "default", () => $63d629cf9356fdd6$export$2e2bcd8739ae039);

var $8OM4u = parcelRequire("8OM4u");

var $lEcTV = parcelRequire("lEcTV");

var $kjJor = parcelRequire("kjJor");

var $gWZYR = parcelRequire("gWZYR");

var $96WVb = parcelRequire("96WVb");
/**
 * @type {Locale}
 * @category Locales
 * @summary Dutch locale.
 * @language Dutch
 * @iso-639-2 nld
 * @author Jorik Tangelder [@jtangelder]{@link https://github.com/jtangelder}
 * @author Ruben Stolk [@rubenstolk]{@link https://github.com/rubenstolk}
 * @author Lode Vanhove [@bitcrumb]{@link https://github.com/bitcrumb}
 * @author Edo Rivai [@edorivai]{@link https://github.com/edorivai}
 * @author Niels Keurentjes [@curry684]{@link https://github.com/curry684}
 * @author Stefan Vermaas [@stefanvermaas]{@link https://github.com/stefanvermaas}
 */ var $63d629cf9356fdd6$var$locale = {
    code: "nl",
    formatDistance: (0, $8OM4u.default),
    formatLong: (0, $lEcTV.default),
    formatRelative: (0, $kjJor.default),
    localize: (0, $gWZYR.default),
    match: (0, $96WVb.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $63d629cf9356fdd6$export$2e2bcd8739ae039 = $63d629cf9356fdd6$var$locale;

});
parcelRegister("8OM4u", function(module, exports) {

$parcel$export(module.exports, "default", () => $66b8483e8b39189d$export$2e2bcd8739ae039);
var $66b8483e8b39189d$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "minder dan een seconde",
        other: "minder dan {{count}} seconden"
    },
    xSeconds: {
        one: "1 seconde",
        other: "{{count}} seconden"
    },
    halfAMinute: "een halve minuut",
    lessThanXMinutes: {
        one: "minder dan een minuut",
        other: "minder dan {{count}} minuten"
    },
    xMinutes: {
        one: "een minuut",
        other: "{{count}} minuten"
    },
    aboutXHours: {
        one: "ongeveer 1 uur",
        other: "ongeveer {{count}} uur"
    },
    xHours: {
        one: "1 uur",
        other: "{{count}} uur"
    },
    xDays: {
        one: "1 dag",
        other: "{{count}} dagen"
    },
    aboutXWeeks: {
        one: "ongeveer 1 week",
        other: "ongeveer {{count}} weken"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weken"
    },
    aboutXMonths: {
        one: "ongeveer 1 maand",
        other: "ongeveer {{count}} maanden"
    },
    xMonths: {
        one: "1 maand",
        other: "{{count}} maanden"
    },
    aboutXYears: {
        one: "ongeveer 1 jaar",
        other: "ongeveer {{count}} jaar"
    },
    xYears: {
        one: "1 jaar",
        other: "{{count}} jaar"
    },
    overXYears: {
        one: "meer dan 1 jaar",
        other: "meer dan {{count}} jaar"
    },
    almostXYears: {
        one: "bijna 1 jaar",
        other: "bijna {{count}} jaar"
    }
};
var $66b8483e8b39189d$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $66b8483e8b39189d$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "over " + result;
        else return result + " geleden";
    }
    return result;
};
var $66b8483e8b39189d$export$2e2bcd8739ae039 = $66b8483e8b39189d$var$formatDistance;

});

parcelRegister("lEcTV", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc275742262ced36$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $fc275742262ced36$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd-MM-y"
};
var $fc275742262ced36$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $fc275742262ced36$var$dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $fc275742262ced36$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $fc275742262ced36$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $fc275742262ced36$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $fc275742262ced36$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $fc275742262ced36$export$2e2bcd8739ae039 = $fc275742262ced36$var$formatLong;

});

parcelRegister("kjJor", function(module, exports) {

$parcel$export(module.exports, "default", () => $eca8cb266dfec196$export$2e2bcd8739ae039);
var $eca8cb266dfec196$var$formatRelativeLocale = {
    lastWeek: "'afgelopen' eeee 'om' p",
    yesterday: "'gisteren om' p",
    today: "'vandaag om' p",
    tomorrow: "'morgen om' p",
    nextWeek: "eeee 'om' p",
    other: "P"
};
var $eca8cb266dfec196$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $eca8cb266dfec196$var$formatRelativeLocale[token];
};
var $eca8cb266dfec196$export$2e2bcd8739ae039 = $eca8cb266dfec196$var$formatRelative;

});

parcelRegister("gWZYR", function(module, exports) {

$parcel$export(module.exports, "default", () => $c572242aacc7a33d$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $c572242aacc7a33d$var$eraValues = {
    narrow: [
        "v.C.",
        "n.C."
    ],
    abbreviated: [
        "v.Chr.",
        "n.Chr."
    ],
    wide: [
        "voor Christus",
        "na Christus"
    ]
};
var $c572242aacc7a33d$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "K1",
        "K2",
        "K3",
        "K4"
    ],
    wide: [
        "1e kwartaal",
        "2e kwartaal",
        "3e kwartaal",
        "4e kwartaal"
    ]
};
var $c572242aacc7a33d$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mrt.",
        "apr.",
        "mei",
        "jun.",
        "jul.",
        "aug.",
        "sep.",
        "okt.",
        "nov.",
        "dec."
    ],
    wide: [
        "januari",
        "februari",
        "maart",
        "april",
        "mei",
        "juni",
        "juli",
        "augustus",
        "september",
        "oktober",
        "november",
        "december"
    ]
};
var $c572242aacc7a33d$var$dayValues = {
    narrow: [
        "Z",
        "M",
        "D",
        "W",
        "D",
        "V",
        "Z"
    ],
    short: [
        "zo",
        "ma",
        "di",
        "wo",
        "do",
        "vr",
        "za"
    ],
    abbreviated: [
        "zon",
        "maa",
        "din",
        "woe",
        "don",
        "vri",
        "zat"
    ],
    wide: [
        "zondag",
        "maandag",
        "dinsdag",
        "woensdag",
        "donderdag",
        "vrijdag",
        "zaterdag"
    ]
};
var $c572242aacc7a33d$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "het middaguur",
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "het middaguur",
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "het middaguur",
        morning: "'s ochtends",
        afternoon: "'s middags",
        evening: "'s avonds",
        night: "'s nachts"
    }
};
var $c572242aacc7a33d$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "e";
};
var $c572242aacc7a33d$var$localize = {
    ordinalNumber: $c572242aacc7a33d$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $c572242aacc7a33d$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $c572242aacc7a33d$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $c572242aacc7a33d$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $c572242aacc7a33d$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $c572242aacc7a33d$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};
var $c572242aacc7a33d$export$2e2bcd8739ae039 = $c572242aacc7a33d$var$localize;

});

parcelRegister("96WVb", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a22611f5256260e$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $6a22611f5256260e$var$matchOrdinalNumberPattern = /^(\d+)e?/i;
var $6a22611f5256260e$var$parseOrdinalNumberPattern = /\d+/i;
var $6a22611f5256260e$var$matchEraPatterns = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?Chr\.?)/,
    wide: /^((voor|na) Christus)/
};
var $6a22611f5256260e$var$parseEraPatterns = {
    any: [
        /^v/,
        /^n/
    ]
};
var $6a22611f5256260e$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e kwartaal/i
};
var $6a22611f5256260e$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $6a22611f5256260e$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
};
var $6a22611f5256260e$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^jan/i,
        /^feb/i,
        /^m(r|a)/i,
        /^apr/i,
        /^mei/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^dec/i
    ]
};
var $6a22611f5256260e$var$matchDayPatterns = {
    narrow: /^[zmdwv]/i,
    short: /^(zo|ma|di|wo|do|vr|za)/i,
    abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
    wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
};
var $6a22611f5256260e$var$parseDayPatterns = {
    narrow: [
        /^z/i,
        /^m/i,
        /^d/i,
        /^w/i,
        /^d/i,
        /^v/i,
        /^z/i
    ],
    any: [
        /^zo/i,
        /^ma/i,
        /^di/i,
        /^wo/i,
        /^do/i,
        /^vr/i,
        /^za/i
    ]
};
var $6a22611f5256260e$var$matchDayPeriodPatterns = {
    any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
};
var $6a22611f5256260e$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^middernacht/i,
        noon: /^het middaguur/i,
        morning: /ochtend/i,
        afternoon: /middag/i,
        evening: /avond/i,
        night: /nacht/i
    }
};
var $6a22611f5256260e$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $6a22611f5256260e$var$matchOrdinalNumberPattern,
        parsePattern: $6a22611f5256260e$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $6a22611f5256260e$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6a22611f5256260e$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $6a22611f5256260e$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6a22611f5256260e$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $6a22611f5256260e$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6a22611f5256260e$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $6a22611f5256260e$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6a22611f5256260e$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $6a22611f5256260e$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $6a22611f5256260e$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $6a22611f5256260e$export$2e2bcd8739ae039 = $6a22611f5256260e$var$match;

});


parcelRegister("bM2BX", function(module, exports) {

$parcel$export(module.exports, "default", () => $892633f10b013209$export$2e2bcd8739ae039);

var $uEdI2 = parcelRequire("uEdI2");

var $b0O0e = parcelRequire("b0O0e");

var $5AWTI = parcelRequire("5AWTI");

var $3cyhx = parcelRequire("3cyhx");

var $lQA9p = parcelRequire("lQA9p");
/**
 * @type {Locale}
 * @category Locales
 * @summary Dutch locale.
 * @language Dutch
 * @iso-639-2 nld
 * @author Jorik Tangelder [@jtangelder]{@link https://github.com/jtangelder}
 * @author Ruben Stolk [@rubenstolk]{@link https://github.com/rubenstolk}
 * @author Lode Vanhove [@bitcrumb]{@link https://github.com/bitcrumb}
 * @author Alex Hoeing [@dcbn]{@link https://github.com/dcbn}
 */ var $892633f10b013209$var$locale = {
    code: "nl-BE",
    formatDistance: (0, $uEdI2.default),
    formatLong: (0, $b0O0e.default),
    formatRelative: (0, $5AWTI.default),
    localize: (0, $3cyhx.default),
    match: (0, $lQA9p.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $892633f10b013209$export$2e2bcd8739ae039 = $892633f10b013209$var$locale;

});
parcelRegister("uEdI2", function(module, exports) {

$parcel$export(module.exports, "default", () => $05c20055a799f805$export$2e2bcd8739ae039);
var $05c20055a799f805$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "minder dan een seconde",
        other: "minder dan {{count}} seconden"
    },
    xSeconds: {
        one: "1 seconde",
        other: "{{count}} seconden"
    },
    halfAMinute: "een halve minuut",
    lessThanXMinutes: {
        one: "minder dan een minuut",
        other: "minder dan {{count}} minuten"
    },
    xMinutes: {
        one: "een minuut",
        other: "{{count}} minuten"
    },
    aboutXHours: {
        one: "ongeveer 1 uur",
        other: "ongeveer {{count}} uur"
    },
    xHours: {
        one: "1 uur",
        other: "{{count}} uur"
    },
    xDays: {
        one: "1 dag",
        other: "{{count}} dagen"
    },
    aboutXWeeks: {
        one: "ongeveer 1 week",
        other: "ongeveer {{count}} weken"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weken"
    },
    aboutXMonths: {
        one: "ongeveer 1 maand",
        other: "ongeveer {{count}} maanden"
    },
    xMonths: {
        one: "1 maand",
        other: "{{count}} maanden"
    },
    aboutXYears: {
        one: "ongeveer 1 jaar",
        other: "ongeveer {{count}} jaar"
    },
    xYears: {
        one: "1 jaar",
        other: "{{count}} jaar"
    },
    overXYears: {
        one: "meer dan 1 jaar",
        other: "meer dan {{count}} jaar"
    },
    almostXYears: {
        one: "bijna 1 jaar",
        other: "bijna {{count}} jaar"
    }
};
var $05c20055a799f805$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $05c20055a799f805$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "over " + result;
        else return result + " geleden";
    }
    return result;
};
var $05c20055a799f805$export$2e2bcd8739ae039 = $05c20055a799f805$var$formatDistance;

});

parcelRegister("b0O0e", function(module, exports) {

$parcel$export(module.exports, "default", () => $80467b46c078db7b$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $80467b46c078db7b$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd.MM.y"
};
var $80467b46c078db7b$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $80467b46c078db7b$var$dateTimeFormats = {
    full: "{{date}} 'om' {{time}}",
    long: "{{date}} 'om' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $80467b46c078db7b$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $80467b46c078db7b$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $80467b46c078db7b$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $80467b46c078db7b$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $80467b46c078db7b$export$2e2bcd8739ae039 = $80467b46c078db7b$var$formatLong;

});

parcelRegister("5AWTI", function(module, exports) {

$parcel$export(module.exports, "default", () => $412e005d1dd03ccf$export$2e2bcd8739ae039);
var $412e005d1dd03ccf$var$formatRelativeLocale = {
    lastWeek: "'vorige' eeee 'om' p",
    yesterday: "'gisteren om' p",
    today: "'vandaag om' p",
    tomorrow: "'morgen om' p",
    nextWeek: "eeee 'om' p",
    other: "P"
};
var $412e005d1dd03ccf$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $412e005d1dd03ccf$var$formatRelativeLocale[token];
};
var $412e005d1dd03ccf$export$2e2bcd8739ae039 = $412e005d1dd03ccf$var$formatRelative;

});

parcelRegister("3cyhx", function(module, exports) {

$parcel$export(module.exports, "default", () => $254d15be89e1644c$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $254d15be89e1644c$var$eraValues = {
    narrow: [
        "v.C.",
        "n.C."
    ],
    abbreviated: [
        "v.Chr.",
        "n.Chr."
    ],
    wide: [
        "voor Christus",
        "na Christus"
    ]
};
var $254d15be89e1644c$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "K1",
        "K2",
        "K3",
        "K4"
    ],
    wide: [
        "1e kwartaal",
        "2e kwartaal",
        "3e kwartaal",
        "4e kwartaal"
    ]
};
var $254d15be89e1644c$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mrt.",
        "apr.",
        "mei",
        "jun.",
        "jul.",
        "aug.",
        "sep.",
        "okt.",
        "nov.",
        "dec."
    ],
    wide: [
        "januari",
        "februari",
        "maart",
        "april",
        "mei",
        "juni",
        "juli",
        "augustus",
        "september",
        "oktober",
        "november",
        "december"
    ]
};
var $254d15be89e1644c$var$dayValues = {
    narrow: [
        "Z",
        "M",
        "D",
        "W",
        "D",
        "V",
        "Z"
    ],
    short: [
        "zo",
        "ma",
        "di",
        "wo",
        "do",
        "vr",
        "za"
    ],
    abbreviated: [
        "zon",
        "maa",
        "din",
        "woe",
        "don",
        "vri",
        "zat"
    ],
    wide: [
        "zondag",
        "maandag",
        "dinsdag",
        "woensdag",
        "donderdag",
        "vrijdag",
        "zaterdag"
    ]
};
var $254d15be89e1644c$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "het middag",
        morning: "'s ochtends",
        afternoon: "'s namiddags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "het middag",
        morning: "'s ochtends",
        afternoon: "'s namiddags",
        evening: "'s avonds",
        night: "'s nachts"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "middernacht",
        noon: "het middag",
        morning: "'s ochtends",
        afternoon: "'s namiddags",
        evening: "'s avonds",
        night: "'s nachts"
    }
};
var $254d15be89e1644c$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "e";
};
var $254d15be89e1644c$var$localize = {
    ordinalNumber: $254d15be89e1644c$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $254d15be89e1644c$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $254d15be89e1644c$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $254d15be89e1644c$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $254d15be89e1644c$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $254d15be89e1644c$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};
var $254d15be89e1644c$export$2e2bcd8739ae039 = $254d15be89e1644c$var$localize;

});

parcelRegister("lQA9p", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe7a7f1cc89cbf05$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $fe7a7f1cc89cbf05$var$matchOrdinalNumberPattern = /^(\d+)e?/i;
var $fe7a7f1cc89cbf05$var$parseOrdinalNumberPattern = /\d+/i;
var $fe7a7f1cc89cbf05$var$matchEraPatterns = {
    narrow: /^([vn]\.? ?C\.?)/,
    abbreviated: /^([vn]\. ?Chr\.?)/,
    wide: /^((voor|na) Christus)/
};
var $fe7a7f1cc89cbf05$var$parseEraPatterns = {
    any: [
        /^v/,
        /^n/
    ]
};
var $fe7a7f1cc89cbf05$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^K[1234]/i,
    wide: /^[1234]e kwartaal/i
};
var $fe7a7f1cc89cbf05$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $fe7a7f1cc89cbf05$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
    wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
};
var $fe7a7f1cc89cbf05$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^jan/i,
        /^feb/i,
        /^m(r|a)/i,
        /^apr/i,
        /^mei/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^sep/i,
        /^okt/i,
        /^nov/i,
        /^dec/i
    ]
};
var $fe7a7f1cc89cbf05$var$matchDayPatterns = {
    narrow: /^[zmdwv]/i,
    short: /^(zo|ma|di|wo|do|vr|za)/i,
    abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
    wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
};
var $fe7a7f1cc89cbf05$var$parseDayPatterns = {
    narrow: [
        /^z/i,
        /^m/i,
        /^d/i,
        /^w/i,
        /^d/i,
        /^v/i,
        /^z/i
    ],
    any: [
        /^zo/i,
        /^ma/i,
        /^di/i,
        /^wo/i,
        /^do/i,
        /^vr/i,
        /^za/i
    ]
};
var $fe7a7f1cc89cbf05$var$matchDayPeriodPatterns = {
    any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
};
var $fe7a7f1cc89cbf05$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /^middernacht/i,
        noon: /^het middaguur/i,
        morning: /ochtend/i,
        afternoon: /middag/i,
        evening: /avond/i,
        night: /nacht/i
    }
};
var $fe7a7f1cc89cbf05$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $fe7a7f1cc89cbf05$var$matchOrdinalNumberPattern,
        parsePattern: $fe7a7f1cc89cbf05$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $fe7a7f1cc89cbf05$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fe7a7f1cc89cbf05$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $fe7a7f1cc89cbf05$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fe7a7f1cc89cbf05$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $fe7a7f1cc89cbf05$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fe7a7f1cc89cbf05$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $fe7a7f1cc89cbf05$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $fe7a7f1cc89cbf05$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $fe7a7f1cc89cbf05$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $fe7a7f1cc89cbf05$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $fe7a7f1cc89cbf05$export$2e2bcd8739ae039 = $fe7a7f1cc89cbf05$var$match;

});


parcelRegister("I8kQx", function(module, exports) {

$parcel$export(module.exports, "default", () => $084a936118e62677$export$2e2bcd8739ae039);

var $gZVZX = parcelRequire("gZVZX");

var $e8Cqb = parcelRequire("e8Cqb");

var $gYyMy = parcelRequire("gYyMy");

var $5g2vd = parcelRequire("5g2vd");

var $2OeX0 = parcelRequire("2OeX0");
/**
 * @type {Locale}
 * @category Locales
 * @summary Norwegian Nynorsk locale.
 * @language Norwegian Nynorsk
 * @iso-639-2 nno
 * @author Mats Byrkjeland [@draperunner]{@link https://github.com/draperunner}
 */ var $084a936118e62677$var$locale = {
    code: "nn",
    formatDistance: (0, $gZVZX.default),
    formatLong: (0, $e8Cqb.default),
    formatRelative: (0, $gYyMy.default),
    localize: (0, $5g2vd.default),
    match: (0, $2OeX0.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $084a936118e62677$export$2e2bcd8739ae039 = $084a936118e62677$var$locale;

});
parcelRegister("gZVZX", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5ff5517e0801feb$export$2e2bcd8739ae039);
var $c5ff5517e0801feb$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mindre enn eitt sekund",
        other: "mindre enn {{count}} sekund"
    },
    xSeconds: {
        one: "eitt sekund",
        other: "{{count}} sekund"
    },
    halfAMinute: "eit halvt minutt",
    lessThanXMinutes: {
        one: "mindre enn eitt minutt",
        other: "mindre enn {{count}} minutt"
    },
    xMinutes: {
        one: "eitt minutt",
        other: "{{count}} minutt"
    },
    aboutXHours: {
        one: "omtrent ein time",
        other: "omtrent {{count}} timar"
    },
    xHours: {
        one: "ein time",
        other: "{{count}} timar"
    },
    xDays: {
        one: "ein dag",
        other: "{{count}} dagar"
    },
    aboutXWeeks: {
        one: "omtrent ei veke",
        other: "omtrent {{count}} veker"
    },
    xWeeks: {
        one: "ei veke",
        other: "{{count}} veker"
    },
    aboutXMonths: {
        one: "omtrent ein m\xe5nad",
        other: "omtrent {{count}} m\xe5nader"
    },
    xMonths: {
        one: "ein m\xe5nad",
        other: "{{count}} m\xe5nader"
    },
    aboutXYears: {
        one: "omtrent eitt \xe5r",
        other: "omtrent {{count}} \xe5r"
    },
    xYears: {
        one: "eitt \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "over eitt \xe5r",
        other: "over {{count}} \xe5r"
    },
    almostXYears: {
        one: "nesten eitt \xe5r",
        other: "nesten {{count}} \xe5r"
    }
};
var $c5ff5517e0801feb$var$wordMapping = [
    "null",
    "ein",
    "to",
    "tre",
    "fire",
    "fem",
    "seks",
    "sju",
    "\xe5tte",
    "ni",
    "ti",
    "elleve",
    "tolv"
];
var $c5ff5517e0801feb$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $c5ff5517e0801feb$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (options && options.onlyNumeric) result = tokenValue.other.replace("{{count}}", String(count));
    else result = tokenValue.other.replace("{{count}}", count < 13 ? $c5ff5517e0801feb$var$wordMapping[count] : String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "om " + result;
        else return result + " sidan";
    }
    return result;
};
var $c5ff5517e0801feb$export$2e2bcd8739ae039 = $c5ff5517e0801feb$var$formatDistance;

});

parcelRegister("e8Cqb", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4af9db89606e2a9$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $a4af9db89606e2a9$var$dateFormats = {
    full: "EEEE d. MMMM y",
    long: "d. MMMM y",
    medium: "d. MMM y",
    short: "dd.MM.y"
};
var $a4af9db89606e2a9$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $a4af9db89606e2a9$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $a4af9db89606e2a9$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $a4af9db89606e2a9$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $a4af9db89606e2a9$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $a4af9db89606e2a9$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $a4af9db89606e2a9$export$2e2bcd8739ae039 = $a4af9db89606e2a9$var$formatLong;

});

parcelRegister("gYyMy", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5bd3af774844000$export$2e2bcd8739ae039);
var $c5bd3af774844000$var$formatRelativeLocale = {
    lastWeek: "'f\xf8rre' eeee 'kl.' p",
    yesterday: "'i g\xe5r kl.' p",
    today: "'i dag kl.' p",
    tomorrow: "'i morgon kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: "P"
};
var $c5bd3af774844000$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $c5bd3af774844000$var$formatRelativeLocale[token];
};
var $c5bd3af774844000$export$2e2bcd8739ae039 = $c5bd3af774844000$var$formatRelative;

});

parcelRegister("5g2vd", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d406355f138c67d$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $3d406355f138c67d$var$eraValues = {
    narrow: [
        "f.Kr.",
        "e.Kr."
    ],
    abbreviated: [
        "f.Kr.",
        "e.Kr."
    ],
    wide: [
        "f\xf8r Kristus",
        "etter Kristus"
    ]
};
var $3d406355f138c67d$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1. kvartal",
        "2. kvartal",
        "3. kvartal",
        "4. kvartal"
    ]
};
var $3d406355f138c67d$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mars",
        "apr.",
        "mai",
        "juni",
        "juli",
        "aug.",
        "sep.",
        "okt.",
        "nov.",
        "des."
    ],
    wide: [
        "januar",
        "februar",
        "mars",
        "april",
        "mai",
        "juni",
        "juli",
        "august",
        "september",
        "oktober",
        "november",
        "desember"
    ]
};
var $3d406355f138c67d$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "O",
        "T",
        "F",
        "L"
    ],
    short: [
        "su",
        "m\xe5",
        "ty",
        "on",
        "to",
        "fr",
        "lau"
    ],
    abbreviated: [
        "sun",
        "m\xe5n",
        "tys",
        "ons",
        "tor",
        "fre",
        "laur"
    ],
    wide: [
        "sundag",
        "m\xe5ndag",
        "tysdag",
        "onsdag",
        "torsdag",
        "fredag",
        "laurdag"
    ]
};
var $3d406355f138c67d$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natta"
    },
    abbreviated: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 etterm.",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natta"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morgonen",
        afternoon: "p\xe5 ettermiddagen",
        evening: "p\xe5 kvelden",
        night: "p\xe5 natta"
    }
};
var $3d406355f138c67d$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + ".";
};
var $3d406355f138c67d$var$localize = {
    ordinalNumber: $3d406355f138c67d$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $3d406355f138c67d$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $3d406355f138c67d$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $3d406355f138c67d$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $3d406355f138c67d$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $3d406355f138c67d$var$dayPeriodValues,
        defaultWidth: "wide"
    })
};
var $3d406355f138c67d$export$2e2bcd8739ae039 = $3d406355f138c67d$var$localize;

});

parcelRegister("2OeX0", function(module, exports) {

$parcel$export(module.exports, "default", () => $20bbd933bd9890fc$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $20bbd933bd9890fc$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
var $20bbd933bd9890fc$var$parseOrdinalNumberPattern = /\d+/i;
var $20bbd933bd9890fc$var$matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
    wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
};
var $20bbd933bd9890fc$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^e/i
    ]
};
var $20bbd933bd9890fc$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](\.)? kvartal/i
};
var $20bbd933bd9890fc$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $20bbd933bd9890fc$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
    wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
};
var $20bbd933bd9890fc$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^aug/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $20bbd933bd9890fc$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(su|må|ty|on|to|fr|la)/i,
    abbreviated: /^(sun|mån|tys|ons|tor|fre|laur)/i,
    wide: /^(sundag|måndag|tysdag|onsdag|torsdag|fredag|laurdag)/i
};
var $20bbd933bd9890fc$var$parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ty/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var $20bbd933bd9890fc$var$matchDayPeriodPatterns = {
    narrow: /^(midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta)|[ap])/i,
    any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta))/i
};
var $20bbd933bd9890fc$var$parseDayPeriodPatterns = {
    any: {
        am: /^a(\.?\s?m\.?)?$/i,
        pm: /^p(\.?\s?m\.?)?$/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgon/i,
        afternoon: /ettermiddag/i,
        evening: /kveld/i,
        night: /natt/i
    }
};
var $20bbd933bd9890fc$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $20bbd933bd9890fc$var$matchOrdinalNumberPattern,
        parsePattern: $20bbd933bd9890fc$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $20bbd933bd9890fc$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $20bbd933bd9890fc$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $20bbd933bd9890fc$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $20bbd933bd9890fc$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $20bbd933bd9890fc$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $20bbd933bd9890fc$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $20bbd933bd9890fc$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $20bbd933bd9890fc$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $20bbd933bd9890fc$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $20bbd933bd9890fc$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $20bbd933bd9890fc$export$2e2bcd8739ae039 = $20bbd933bd9890fc$var$match;

});


parcelRegister("4wyRd", function(module, exports) {

$parcel$export(module.exports, "default", () => $34b5308837751f97$export$2e2bcd8739ae039);

var $eZr9D = parcelRequire("eZr9D");

var $6uuL6 = parcelRequire("6uuL6");

var $aerCU = parcelRequire("aerCU");

var $aX3f2 = parcelRequire("aX3f2");

var $6ulX2 = parcelRequire("6ulX2");
/**
 * @type {Locale}
 * @category Locales
 * @summary Occitan locale.
 * @language Occitan
 * @iso-639-2 oci
 * @author Quentin PAGÈS
 */ var $34b5308837751f97$var$locale = {
    code: "oc",
    formatDistance: (0, $eZr9D.default),
    formatLong: (0, $6uuL6.default),
    formatRelative: (0, $aerCU.default),
    localize: (0, $aX3f2.default),
    match: (0, $6ulX2.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $34b5308837751f97$export$2e2bcd8739ae039 = $34b5308837751f97$var$locale;

});
parcelRegister("eZr9D", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae9bd37937423d54$export$2e2bcd8739ae039);
var $ae9bd37937423d54$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mens d\u2019una segonda",
        other: "mens de {{count}} segondas"
    },
    xSeconds: {
        one: "1 segonda",
        other: "{{count}} segondas"
    },
    halfAMinute: "30 segondas",
    lessThanXMinutes: {
        one: "mens d\u2019una minuta",
        other: "mens de {{count}} minutas"
    },
    xMinutes: {
        one: "1 minuta",
        other: "{{count}} minutas"
    },
    aboutXHours: {
        one: "environ 1 ora",
        other: "environ {{count}} oras"
    },
    xHours: {
        one: "1 ora",
        other: "{{count}} oras"
    },
    xDays: {
        one: "1 jorn",
        other: "{{count}} jorns"
    },
    aboutXWeeks: {
        one: "environ 1 setmana",
        other: "environ {{count}} setmanas"
    },
    xWeeks: {
        one: "1 setmana",
        other: "{{count}} setmanas"
    },
    aboutXMonths: {
        one: "environ 1 mes",
        other: "environ {{count}} meses"
    },
    xMonths: {
        one: "1 mes",
        other: "{{count}} meses"
    },
    aboutXYears: {
        one: "environ 1 an",
        other: "environ {{count}} ans"
    },
    xYears: {
        one: "1 an",
        other: "{{count}} ans"
    },
    overXYears: {
        one: "mai d\u2019un an",
        other: "mai de {{count}} ans"
    },
    almostXYears: {
        one: "gaireben un an",
        other: "gaireben {{count}} ans"
    }
};
var $ae9bd37937423d54$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $ae9bd37937423d54$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "d\u2019aqu\xed " + result;
        else return "fa " + result;
    }
    return result;
};
var $ae9bd37937423d54$export$2e2bcd8739ae039 = $ae9bd37937423d54$var$formatDistance;

});

parcelRegister("6uuL6", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b9d677672727bda$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $4b9d677672727bda$var$dateFormats = {
    full: "EEEE d 'de' MMMM y",
    long: "d 'de' MMMM y",
    medium: "d MMM y",
    short: "dd/MM/y"
};
var $4b9d677672727bda$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $4b9d677672727bda$var$dateTimeFormats = {
    full: "{{date}} 'a' {{time}}",
    long: "{{date}} 'a' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $4b9d677672727bda$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $4b9d677672727bda$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $4b9d677672727bda$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $4b9d677672727bda$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $4b9d677672727bda$export$2e2bcd8739ae039 = $4b9d677672727bda$var$formatLong;

});

parcelRegister("aerCU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7730a4466c0bc8aa$export$2e2bcd8739ae039);
var $7730a4466c0bc8aa$var$formatRelativeLocale = {
    lastWeek: "eeee 'passat a' p",
    yesterday: "'i\xe8r a' p",
    today: "'u\xe8i a' p",
    tomorrow: "'deman a' p",
    nextWeek: "eeee 'a' p",
    other: "P"
};
var $7730a4466c0bc8aa$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $7730a4466c0bc8aa$var$formatRelativeLocale[token];
};
var $7730a4466c0bc8aa$export$2e2bcd8739ae039 = $7730a4466c0bc8aa$var$formatRelative;

});

parcelRegister("aX3f2", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f91edc383333241$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $7f91edc383333241$var$eraValues = {
    narrow: [
        "ab. J.C.",
        "apr. J.C."
    ],
    abbreviated: [
        "ab. J.C.",
        "apr. J.C."
    ],
    wide: [
        "abans J\xe8sus-Crist",
        "apr\xe8s J\xe8sus-Crist"
    ]
};
var $7f91edc383333241$var$quarterValues = {
    narrow: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    abbreviated: [
        "1\xe8r trim.",
        "2nd trim.",
        "3en trim.",
        "4en trim."
    ],
    wide: [
        "1\xe8r trim\xe8stre",
        "2nd trim\xe8stre",
        "3en trim\xe8stre",
        "4en trim\xe8stre"
    ]
};
var $7f91edc383333241$var$monthValues = {
    narrow: [
        "GN",
        "FB",
        "M\xc7",
        "AB",
        "MA",
        "JN",
        "JL",
        "AG",
        "ST",
        "OC",
        "NV",
        "DC"
    ],
    abbreviated: [
        "gen.",
        "febr.",
        "mar\xe7",
        "abr.",
        "mai",
        "junh",
        "jul.",
        "ag.",
        "set.",
        "oct.",
        "nov.",
        "dec."
    ],
    wide: [
        "geni\xe8r",
        "febri\xe8r",
        "mar\xe7",
        "abril",
        "mai",
        "junh",
        "julhet",
        "agost",
        "setembre",
        "oct\xf2bre",
        "novembre",
        "decembre"
    ]
};
var $7f91edc383333241$var$dayValues = {
    narrow: [
        "dg.",
        "dl.",
        "dm.",
        "dc.",
        "dj.",
        "dv.",
        "ds."
    ],
    short: [
        "dg.",
        "dl.",
        "dm.",
        "dc.",
        "dj.",
        "dv.",
        "ds."
    ],
    abbreviated: [
        "dg.",
        "dl.",
        "dm.",
        "dc.",
        "dj.",
        "dv.",
        "ds."
    ],
    wide: [
        "dimenge",
        "diluns",
        "dimars",
        "dim\xe8cres",
        "dij\xf2us",
        "divendres",
        "dissabte"
    ]
};
var $7f91edc383333241$var$dayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: "matin",
        afternoon: "apr\xe8p-mi\xe8gjorn",
        evening: "v\xe8spre",
        night: "nu\xe8ch"
    },
    abbreviated: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: "matin",
        afternoon: "apr\xe8p-mi\xe8gjorn",
        evening: "v\xe8spre",
        night: "nu\xe8ch"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: "matin",
        afternoon: "apr\xe8p-mi\xe8gjorn",
        evening: "v\xe8spre",
        night: "nu\xe8ch"
    }
};
var $7f91edc383333241$var$formattingDayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: "del matin",
        afternoon: "de l\u2019apr\xe8p-mi\xe8gjorn",
        evening: "del ser",
        night: "de la nu\xe8ch"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: "del matin",
        afternoon: "de l\u2019apr\xe8p-mi\xe8gjorn",
        evening: "del ser",
        night: "de la nu\xe8ch"
    },
    wide: {
        am: "ante meridiem",
        pm: "post meridiem",
        midnight: "mi\xe8janu\xe8ch",
        noon: "mi\xe8gjorn",
        morning: "del matin",
        afternoon: "de l\u2019apr\xe8p-mi\xe8gjorn",
        evening: "del ser",
        night: "de la nu\xe8ch"
    }
};
var $7f91edc383333241$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    var ordinal;
    switch(number){
        case 1:
            ordinal = "\xe8r";
            break;
        case 2:
            ordinal = "nd";
            break;
        default:
            ordinal = "en";
    }
    // feminine for year, week, hour, minute, second
    if (unit === "year" || unit === "week" || unit === "hour" || unit === "minute" || unit === "second") ordinal += "a";
    return number + ordinal;
};
var $7f91edc383333241$var$localize = {
    ordinalNumber: $7f91edc383333241$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $7f91edc383333241$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $7f91edc383333241$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $7f91edc383333241$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $7f91edc383333241$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $7f91edc383333241$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $7f91edc383333241$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $7f91edc383333241$export$2e2bcd8739ae039 = $7f91edc383333241$var$localize;

});

parcelRegister("6ulX2", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b96927491277fa3$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $4b96927491277fa3$var$matchOrdinalNumberPattern = /^(\d+)(èr|nd|en)?[a]?/i;
var $4b96927491277fa3$var$parseOrdinalNumberPattern = /\d+/i;
var $4b96927491277fa3$var$matchEraPatterns = {
    narrow: /^(ab\.J\.C|apr\.J\.C|apr\.J\.-C)/i,
    abbreviated: /^(ab\.J\.-C|ab\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
    wide: /^(abans Jèsus-Crist|après Jèsus-Crist)/i
};
var $4b96927491277fa3$var$parseEraPatterns = {
    any: [
        /^ab/i,
        /^ap/i
    ]
};
var $4b96927491277fa3$var$matchQuarterPatterns = {
    narrow: /^T[1234]/i,
    abbreviated: /^[1234](èr|nd|en)? trim\.?/i,
    wide: /^[1234](èr|nd|en)? trimèstre/i
};
var $4b96927491277fa3$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $4b96927491277fa3$var$matchMonthPatterns = {
    narrow: /^(GN|FB|MÇ|AB|MA|JN|JL|AG|ST|OC|NV|DC)/i,
    abbreviated: /^(gen|febr|març|abr|mai|junh|jul|ag|set|oct|nov|dec)\.?/i,
    wide: /^(genièr|febrièr|març|abril|mai|junh|julhet|agost|setembre|octòbre|novembre|decembre)/i
};
var $4b96927491277fa3$var$parseMonthPatterns = {
    any: [
        /^g/i,
        /^f/i,
        /^ma[r?]|MÇ/i,
        /^ab/i,
        /^ma[i?]/i,
        /^ju[n?]|JN/i,
        /^ju[l?]|JL/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $4b96927491277fa3$var$matchDayPatterns = {
    narrow: /^d[glmcjvs]\.?/i,
    short: /^d[glmcjvs]\.?/i,
    abbreviated: /^d[glmcjvs]\.?/i,
    wide: /^(dimenge|diluns|dimars|dimècres|dijòus|divendres|dissabte)/i
};
var $4b96927491277fa3$var$parseDayPatterns = {
    narrow: [
        /^dg/i,
        /^dl/i,
        /^dm/i,
        /^dc/i,
        /^dj/i,
        /^dv/i,
        /^ds/i
    ],
    short: [
        /^dg/i,
        /^dl/i,
        /^dm/i,
        /^dc/i,
        /^dj/i,
        /^dv/i,
        /^ds/i
    ],
    abbreviated: [
        /^dg/i,
        /^dl/i,
        /^dm/i,
        /^dc/i,
        /^dj/i,
        /^dv/i,
        /^ds/i
    ],
    any: [
        /^dg|dime/i,
        /^dl|dil/i,
        /^dm|dima/i,
        /^dc|dimè/i,
        /^dj|dij/i,
        /^dv|div/i,
        /^ds|dis/i
    ]
};
var $4b96927491277fa3$var$matchDayPeriodPatterns = {
    any: /(^(a\.?m|p\.?m))|(ante meridiem|post meridiem)|((del |de la |de l’)(matin|aprèp-miègjorn|vèspre|ser|nuèch))/i
};
var $4b96927491277fa3$var$parseDayPeriodPatterns = {
    any: {
        am: /(^a)|ante meridiem/i,
        pm: /(^p)|post meridiem/i,
        midnight: /^mièj/i,
        noon: /^mièg/i,
        morning: /matin/i,
        afternoon: /aprèp-miègjorn/i,
        evening: /vèspre|ser/i,
        night: /nuèch/i
    }
};
var $4b96927491277fa3$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $4b96927491277fa3$var$matchOrdinalNumberPattern,
        parsePattern: $4b96927491277fa3$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $4b96927491277fa3$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4b96927491277fa3$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $4b96927491277fa3$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4b96927491277fa3$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $4b96927491277fa3$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4b96927491277fa3$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $4b96927491277fa3$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $4b96927491277fa3$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $4b96927491277fa3$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $4b96927491277fa3$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $4b96927491277fa3$export$2e2bcd8739ae039 = $4b96927491277fa3$var$match;

});


parcelRegister("8QtUC", function(module, exports) {

$parcel$export(module.exports, "default", () => $670a61fa5abd4401$export$2e2bcd8739ae039);

var $dPWq5 = parcelRequire("dPWq5");

var $dEtPI = parcelRequire("dEtPI");

var $4B9LP = parcelRequire("4B9LP");

var $lfdkn = parcelRequire("lfdkn");

var $dWSed = parcelRequire("dWSed");
/**
 * @type {Locale}
 * @category Locales
 * @summary Polish locale.
 * @language Polish
 * @iso-639-2 pol
 * @author Mateusz Derks [@ertrzyiks]{@link https://github.com/ertrzyiks}
 * @author Just RAG [@justrag]{@link https://github.com/justrag}
 * @author Mikolaj Grzyb [@mikolajgrzyb]{@link https://github.com/mikolajgrzyb}
 * @author Mateusz Tokarski [@mutisz]{@link https://github.com/mutisz}
 */ var $670a61fa5abd4401$var$locale = {
    code: "pl",
    formatDistance: (0, $dPWq5.default),
    formatLong: (0, $dEtPI.default),
    formatRelative: (0, $4B9LP.default),
    localize: (0, $lfdkn.default),
    match: (0, $dWSed.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $670a61fa5abd4401$export$2e2bcd8739ae039 = $670a61fa5abd4401$var$locale;

});
parcelRegister("dPWq5", function(module, exports) {

$parcel$export(module.exports, "default", () => $a12d5ab4e33fae78$export$2e2bcd8739ae039);
var $a12d5ab4e33fae78$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            regular: "mniej ni\u017C sekunda",
            past: "mniej ni\u017C sekund\u0119",
            future: "mniej ni\u017C sekund\u0119"
        },
        twoFour: "mniej ni\u017C {{count}} sekundy",
        other: "mniej ni\u017C {{count}} sekund"
    },
    xSeconds: {
        one: {
            regular: "sekunda",
            past: "sekund\u0119",
            future: "sekund\u0119"
        },
        twoFour: "{{count}} sekundy",
        other: "{{count}} sekund"
    },
    halfAMinute: {
        one: "p\xf3\u0142 minuty",
        twoFour: "p\xf3\u0142 minuty",
        other: "p\xf3\u0142 minuty"
    },
    lessThanXMinutes: {
        one: {
            regular: "mniej ni\u017C minuta",
            past: "mniej ni\u017C minut\u0119",
            future: "mniej ni\u017C minut\u0119"
        },
        twoFour: "mniej ni\u017C {{count}} minuty",
        other: "mniej ni\u017C {{count}} minut"
    },
    xMinutes: {
        one: {
            regular: "minuta",
            past: "minut\u0119",
            future: "minut\u0119"
        },
        twoFour: "{{count}} minuty",
        other: "{{count}} minut"
    },
    aboutXHours: {
        one: {
            regular: "oko\u0142o godziny",
            past: "oko\u0142o godziny",
            future: "oko\u0142o godzin\u0119"
        },
        twoFour: "oko\u0142o {{count}} godziny",
        other: "oko\u0142o {{count}} godzin"
    },
    xHours: {
        one: {
            regular: "godzina",
            past: "godzin\u0119",
            future: "godzin\u0119"
        },
        twoFour: "{{count}} godziny",
        other: "{{count}} godzin"
    },
    xDays: {
        one: {
            regular: "dzie\u0144",
            past: "dzie\u0144",
            future: "1 dzie\u0144"
        },
        twoFour: "{{count}} dni",
        other: "{{count}} dni"
    },
    aboutXWeeks: {
        one: "oko\u0142o tygodnia",
        twoFour: "oko\u0142o {{count}} tygodni",
        other: "oko\u0142o {{count}} tygodni"
    },
    xWeeks: {
        one: "tydzie\u0144",
        twoFour: "{{count}} tygodnie",
        other: "{{count}} tygodni"
    },
    aboutXMonths: {
        one: "oko\u0142o miesi\u0105c",
        twoFour: "oko\u0142o {{count}} miesi\u0105ce",
        other: "oko\u0142o {{count}} miesi\u0119cy"
    },
    xMonths: {
        one: "miesi\u0105c",
        twoFour: "{{count}} miesi\u0105ce",
        other: "{{count}} miesi\u0119cy"
    },
    aboutXYears: {
        one: "oko\u0142o rok",
        twoFour: "oko\u0142o {{count}} lata",
        other: "oko\u0142o {{count}} lat"
    },
    xYears: {
        one: "rok",
        twoFour: "{{count}} lata",
        other: "{{count}} lat"
    },
    overXYears: {
        one: "ponad rok",
        twoFour: "ponad {{count}} lata",
        other: "ponad {{count}} lat"
    },
    almostXYears: {
        one: "prawie rok",
        twoFour: "prawie {{count}} lata",
        other: "prawie {{count}} lat"
    }
};
function $a12d5ab4e33fae78$var$declensionGroup(scheme, count) {
    if (count === 1) return scheme.one;
    var rem100 = count % 100;
    // ends with 11-20
    if (rem100 <= 20 && rem100 > 10) return scheme.other;
    var rem10 = rem100 % 10;
    // ends with 2, 3, 4
    if (rem10 >= 2 && rem10 <= 4) return scheme.twoFour;
    return scheme.other;
}
function $a12d5ab4e33fae78$var$declension(scheme, count, time) {
    var group = $a12d5ab4e33fae78$var$declensionGroup(scheme, count);
    var finalText = typeof group === "string" ? group : group[time];
    return finalText.replace("{{count}}", String(count));
}
var $a12d5ab4e33fae78$var$formatDistance = function formatDistance(token, count, options) {
    var scheme = $a12d5ab4e33fae78$var$formatDistanceLocale[token];
    if (!(options !== null && options !== void 0 && options.addSuffix)) return $a12d5ab4e33fae78$var$declension(scheme, count, "regular");
    if (options.comparison && options.comparison > 0) return "za " + $a12d5ab4e33fae78$var$declension(scheme, count, "future");
    else return $a12d5ab4e33fae78$var$declension(scheme, count, "past") + " temu";
};
var $a12d5ab4e33fae78$export$2e2bcd8739ae039 = $a12d5ab4e33fae78$var$formatDistance;

});

parcelRegister("dEtPI", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f062704f6fd96be$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $9f062704f6fd96be$var$dateFormats = {
    full: "EEEE, do MMMM y",
    long: "do MMMM y",
    medium: "do MMM y",
    short: "dd.MM.y"
};
var $9f062704f6fd96be$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $9f062704f6fd96be$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $9f062704f6fd96be$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $9f062704f6fd96be$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $9f062704f6fd96be$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $9f062704f6fd96be$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $9f062704f6fd96be$export$2e2bcd8739ae039 = $9f062704f6fd96be$var$formatLong;

});

parcelRegister("4B9LP", function(module, exports) {

$parcel$export(module.exports, "default", () => $3592324e4a668a12$export$2e2bcd8739ae039);

var $6KZXu = parcelRequire("6KZXu");
var $3592324e4a668a12$var$adjectivesLastWeek = {
    masculine: "ostatni",
    feminine: "ostatnia"
};
var $3592324e4a668a12$var$adjectivesThisWeek = {
    masculine: "ten",
    feminine: "ta"
};
var $3592324e4a668a12$var$adjectivesNextWeek = {
    masculine: "nast\u0119pny",
    feminine: "nast\u0119pna"
};
var $3592324e4a668a12$var$dayGrammaticalGender = {
    0: "feminine",
    1: "masculine",
    2: "masculine",
    3: "feminine",
    4: "masculine",
    5: "masculine",
    6: "feminine"
};
function $3592324e4a668a12$var$dayAndTimeWithAdjective(token, date, baseDate, options) {
    var adjectives;
    if ((0, $6KZXu.default)(date, baseDate, options)) adjectives = $3592324e4a668a12$var$adjectivesThisWeek;
    else if (token === "lastWeek") adjectives = $3592324e4a668a12$var$adjectivesLastWeek;
    else if (token === "nextWeek") adjectives = $3592324e4a668a12$var$adjectivesNextWeek;
    else throw new Error("Cannot determine adjectives for token ".concat(token));
    var day = date.getUTCDay();
    var grammaticalGender = $3592324e4a668a12$var$dayGrammaticalGender[day];
    var adjective = adjectives[grammaticalGender];
    return "'".concat(adjective, "' eeee 'o' p");
}
var $3592324e4a668a12$var$formatRelativeLocale = {
    lastWeek: $3592324e4a668a12$var$dayAndTimeWithAdjective,
    yesterday: "'wczoraj o' p",
    today: "'dzisiaj o' p",
    tomorrow: "'jutro o' p",
    nextWeek: $3592324e4a668a12$var$dayAndTimeWithAdjective,
    other: "P"
};
var $3592324e4a668a12$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $3592324e4a668a12$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(token, date, baseDate, options);
    return format;
};
var $3592324e4a668a12$export$2e2bcd8739ae039 = $3592324e4a668a12$var$formatRelative;

});

parcelRegister("lfdkn", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7755647dcd1591b$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $f7755647dcd1591b$var$eraValues = {
    narrow: [
        "p.n.e.",
        "n.e."
    ],
    abbreviated: [
        "p.n.e.",
        "n.e."
    ],
    wide: [
        "przed nasz\u0105 er\u0105",
        "naszej ery"
    ]
};
var $f7755647dcd1591b$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "I kw.",
        "II kw.",
        "III kw.",
        "IV kw."
    ],
    wide: [
        "I kwarta\u0142",
        "II kwarta\u0142",
        "III kwarta\u0142",
        "IV kwarta\u0142"
    ]
};
var $f7755647dcd1591b$var$monthValues = {
    narrow: [
        "S",
        "L",
        "M",
        "K",
        "M",
        "C",
        "L",
        "S",
        "W",
        "P",
        "L",
        "G"
    ],
    abbreviated: [
        "sty",
        "lut",
        "mar",
        "kwi",
        "maj",
        "cze",
        "lip",
        "sie",
        "wrz",
        "pa\u017A",
        "lis",
        "gru"
    ],
    wide: [
        "stycze\u0144",
        "luty",
        "marzec",
        "kwiecie\u0144",
        "maj",
        "czerwiec",
        "lipiec",
        "sierpie\u0144",
        "wrzesie\u0144",
        "pa\u017Adziernik",
        "listopad",
        "grudzie\u0144"
    ]
};
var $f7755647dcd1591b$var$monthFormattingValues = {
    narrow: [
        "s",
        "l",
        "m",
        "k",
        "m",
        "c",
        "l",
        "s",
        "w",
        "p",
        "l",
        "g"
    ],
    abbreviated: [
        "sty",
        "lut",
        "mar",
        "kwi",
        "maj",
        "cze",
        "lip",
        "sie",
        "wrz",
        "pa\u017A",
        "lis",
        "gru"
    ],
    wide: [
        "stycznia",
        "lutego",
        "marca",
        "kwietnia",
        "maja",
        "czerwca",
        "lipca",
        "sierpnia",
        "wrze\u015Bnia",
        "pa\u017Adziernika",
        "listopada",
        "grudnia"
    ]
};
var $f7755647dcd1591b$var$dayValues = {
    narrow: [
        "N",
        "P",
        "W",
        "\u015A",
        "C",
        "P",
        "S"
    ],
    short: [
        "nie",
        "pon",
        "wto",
        "\u015Bro",
        "czw",
        "pi\u0105",
        "sob"
    ],
    abbreviated: [
        "niedz.",
        "pon.",
        "wt.",
        "\u015Br.",
        "czw.",
        "pt.",
        "sob."
    ],
    wide: [
        "niedziela",
        "poniedzia\u0142ek",
        "wtorek",
        "\u015Broda",
        "czwartek",
        "pi\u0105tek",
        "sobota"
    ]
};
var $f7755647dcd1591b$var$dayFormattingValues = {
    narrow: [
        "n",
        "p",
        "w",
        "\u015B",
        "c",
        "p",
        "s"
    ],
    short: [
        "nie",
        "pon",
        "wto",
        "\u015Bro",
        "czw",
        "pi\u0105",
        "sob"
    ],
    abbreviated: [
        "niedz.",
        "pon.",
        "wt.",
        "\u015Br.",
        "czw.",
        "pt.",
        "sob."
    ],
    wide: [
        "niedziela",
        "poniedzia\u0142ek",
        "wtorek",
        "\u015Broda",
        "czwartek",
        "pi\u0105tek",
        "sobota"
    ]
};
var $f7755647dcd1591b$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "p\xf3\u0142n.",
        noon: "po\u0142",
        morning: "rano",
        afternoon: "popo\u0142.",
        evening: "wiecz.",
        night: "noc"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "p\xf3\u0142noc",
        noon: "po\u0142udnie",
        morning: "rano",
        afternoon: "popo\u0142udnie",
        evening: "wiecz\xf3r",
        night: "noc"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "p\xf3\u0142noc",
        noon: "po\u0142udnie",
        morning: "rano",
        afternoon: "popo\u0142udnie",
        evening: "wiecz\xf3r",
        night: "noc"
    }
};
var $f7755647dcd1591b$var$dayPeriodFormattingValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "o p\xf3\u0142n.",
        noon: "w po\u0142.",
        morning: "rano",
        afternoon: "po po\u0142.",
        evening: "wiecz.",
        night: "w nocy"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "o p\xf3\u0142nocy",
        noon: "w po\u0142udnie",
        morning: "rano",
        afternoon: "po po\u0142udniu",
        evening: "wieczorem",
        night: "w nocy"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "o p\xf3\u0142nocy",
        noon: "w po\u0142udnie",
        morning: "rano",
        afternoon: "po po\u0142udniu",
        evening: "wieczorem",
        night: "w nocy"
    }
};
var $f7755647dcd1591b$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $f7755647dcd1591b$var$localize = {
    ordinalNumber: $f7755647dcd1591b$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $f7755647dcd1591b$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $f7755647dcd1591b$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $f7755647dcd1591b$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $f7755647dcd1591b$var$monthFormattingValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $f7755647dcd1591b$var$dayValues,
        defaultWidth: "wide",
        formattingValues: $f7755647dcd1591b$var$dayFormattingValues,
        defaultFormattingWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $f7755647dcd1591b$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $f7755647dcd1591b$var$dayPeriodFormattingValues,
        defaultFormattingWidth: "wide"
    })
};
var $f7755647dcd1591b$export$2e2bcd8739ae039 = $f7755647dcd1591b$var$localize;

});

parcelRegister("dWSed", function(module, exports) {

$parcel$export(module.exports, "default", () => $a27ac1bb209b3fc1$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $a27ac1bb209b3fc1$var$matchOrdinalNumberPattern = /^(\d+)?/i;
var $a27ac1bb209b3fc1$var$parseOrdinalNumberPattern = /\d+/i;
var $a27ac1bb209b3fc1$var$matchEraPatterns = {
    narrow: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
    abbreviated: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
    wide: /^(przed\s*nasz(ą|a)\s*er(ą|a)|naszej\s*ery)/i
};
var $a27ac1bb209b3fc1$var$parseEraPatterns = {
    any: [
        /^p/i,
        /^n/i
    ]
};
var $a27ac1bb209b3fc1$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^(I|II|III|IV)\s*kw\.?/i,
    wide: /^(I|II|III|IV)\s*kwarta(ł|l)/i
};
var $a27ac1bb209b3fc1$var$parseQuarterPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    any: [
        /^I kw/i,
        /^II kw/i,
        /^III kw/i,
        /^IV kw/i
    ]
};
var $a27ac1bb209b3fc1$var$matchMonthPatterns = {
    narrow: /^[slmkcwpg]/i,
    abbreviated: /^(sty|lut|mar|kwi|maj|cze|lip|sie|wrz|pa(ź|z)|lis|gru)/i,
    wide: /^(stycznia|stycze(ń|n)|lutego|luty|marca|marzec|kwietnia|kwiecie(ń|n)|maja|maj|czerwca|czerwiec|lipca|lipiec|sierpnia|sierpie(ń|n)|wrze(ś|s)nia|wrzesie(ń|n)|pa(ź|z)dziernika|pa(ź|z)dziernik|listopada|listopad|grudnia|grudzie(ń|n))/i
};
var $a27ac1bb209b3fc1$var$parseMonthPatterns = {
    narrow: [
        /^s/i,
        /^l/i,
        /^m/i,
        /^k/i,
        /^m/i,
        /^c/i,
        /^l/i,
        /^s/i,
        /^w/i,
        /^p/i,
        /^l/i,
        /^g/i
    ],
    any: [
        /^st/i,
        /^lu/i,
        /^mar/i,
        /^k/i,
        /^maj/i,
        /^c/i,
        /^lip/i,
        /^si/i,
        /^w/i,
        /^p/i,
        /^lis/i,
        /^g/i
    ]
};
var $a27ac1bb209b3fc1$var$matchDayPatterns = {
    narrow: /^[npwścs]/i,
    short: /^(nie|pon|wto|(ś|s)ro|czw|pi(ą|a)|sob)/i,
    abbreviated: /^(niedz|pon|wt|(ś|s)r|czw|pt|sob)\.?/i,
    wide: /^(niedziela|poniedzia(ł|l)ek|wtorek|(ś|s)roda|czwartek|pi(ą|a)tek|sobota)/i
};
var $a27ac1bb209b3fc1$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^w/i,
        /^ś/i,
        /^c/i,
        /^p/i,
        /^s/i
    ],
    abbreviated: [
        /^n/i,
        /^po/i,
        /^w/i,
        /^(ś|s)r/i,
        /^c/i,
        /^pt/i,
        /^so/i
    ],
    any: [
        /^n/i,
        /^po/i,
        /^w/i,
        /^(ś|s)r/i,
        /^c/i,
        /^pi/i,
        /^so/i
    ]
};
var $a27ac1bb209b3fc1$var$matchDayPeriodPatterns = {
    narrow: /^(^a$|^p$|pó(ł|l)n\.?|o\s*pó(ł|l)n\.?|po(ł|l)\.?|w\s*po(ł|l)\.?|po\s*po(ł|l)\.?|rano|wiecz\.?|noc|w\s*nocy)/i,
    any: /^(am|pm|pó(ł|l)noc|o\s*pó(ł|l)nocy|po(ł|l)udnie|w\s*po(ł|l)udnie|popo(ł|l)udnie|po\s*po(ł|l)udniu|rano|wieczór|wieczorem|noc|w\s*nocy)/i
};
var $a27ac1bb209b3fc1$var$parseDayPeriodPatterns = {
    narrow: {
        am: /^a$/i,
        pm: /^p$/i,
        midnight: /pó(ł|l)n/i,
        noon: /po(ł|l)/i,
        morning: /rano/i,
        afternoon: /po\s*po(ł|l)/i,
        evening: /wiecz/i,
        night: /noc/i
    },
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /pó(ł|l)n/i,
        noon: /po(ł|l)/i,
        morning: /rano/i,
        afternoon: /po\s*po(ł|l)/i,
        evening: /wiecz/i,
        night: /noc/i
    }
};
var $a27ac1bb209b3fc1$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $a27ac1bb209b3fc1$var$matchOrdinalNumberPattern,
        parsePattern: $a27ac1bb209b3fc1$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $a27ac1bb209b3fc1$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a27ac1bb209b3fc1$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $a27ac1bb209b3fc1$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a27ac1bb209b3fc1$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $a27ac1bb209b3fc1$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a27ac1bb209b3fc1$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $a27ac1bb209b3fc1$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $a27ac1bb209b3fc1$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $a27ac1bb209b3fc1$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $a27ac1bb209b3fc1$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $a27ac1bb209b3fc1$export$2e2bcd8739ae039 = $a27ac1bb209b3fc1$var$match;

});


parcelRegister("4Oal2", function(module, exports) {

$parcel$export(module.exports, "default", () => $3803d9ee1e7e94ce$export$2e2bcd8739ae039);

var $8j9KW = parcelRequire("8j9KW");

var $fekFQ = parcelRequire("fekFQ");

var $i934R = parcelRequire("i934R");

var $bvcAt = parcelRequire("bvcAt");

var $gJF9Q = parcelRequire("gJF9Q");
/**
 * @type {Locale}
 * @category Locales
 * @summary Portuguese locale.
 * @language Portuguese
 * @iso-639-2 por
 * @author Dário Freire [@dfreire]{@link https://github.com/dfreire}
 * @author Adrián de la Rosa [@adrm]{@link https://github.com/adrm}
 */ var $3803d9ee1e7e94ce$var$locale = {
    code: "pt",
    formatDistance: (0, $8j9KW.default),
    formatLong: (0, $fekFQ.default),
    formatRelative: (0, $i934R.default),
    localize: (0, $bvcAt.default),
    match: (0, $gJF9Q.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $3803d9ee1e7e94ce$export$2e2bcd8739ae039 = $3803d9ee1e7e94ce$var$locale;

});
parcelRegister("8j9KW", function(module, exports) {

$parcel$export(module.exports, "default", () => $60c7aa6ad01c72dd$export$2e2bcd8739ae039);
var $60c7aa6ad01c72dd$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "menos de um segundo",
        other: "menos de {{count}} segundos"
    },
    xSeconds: {
        one: "1 segundo",
        other: "{{count}} segundos"
    },
    halfAMinute: "meio minuto",
    lessThanXMinutes: {
        one: "menos de um minuto",
        other: "menos de {{count}} minutos"
    },
    xMinutes: {
        one: "1 minuto",
        other: "{{count}} minutos"
    },
    aboutXHours: {
        one: "aproximadamente 1 hora",
        other: "aproximadamente {{count}} horas"
    },
    xHours: {
        one: "1 hora",
        other: "{{count}} horas"
    },
    xDays: {
        one: "1 dia",
        other: "{{count}} dias"
    },
    aboutXWeeks: {
        one: "aproximadamente 1 semana",
        other: "aproximadamente {{count}} semanas"
    },
    xWeeks: {
        one: "1 semana",
        other: "{{count}} semanas"
    },
    aboutXMonths: {
        one: "aproximadamente 1 m\xeas",
        other: "aproximadamente {{count}} meses"
    },
    xMonths: {
        one: "1 m\xeas",
        other: "{{count}} meses"
    },
    aboutXYears: {
        one: "aproximadamente 1 ano",
        other: "aproximadamente {{count}} anos"
    },
    xYears: {
        one: "1 ano",
        other: "{{count}} anos"
    },
    overXYears: {
        one: "mais de 1 ano",
        other: "mais de {{count}} anos"
    },
    almostXYears: {
        one: "quase 1 ano",
        other: "quase {{count}} anos"
    }
};
var $60c7aa6ad01c72dd$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $60c7aa6ad01c72dd$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "daqui a " + result;
        else return "h\xe1 " + result;
    }
    return result;
};
var $60c7aa6ad01c72dd$export$2e2bcd8739ae039 = $60c7aa6ad01c72dd$var$formatDistance;

});

parcelRegister("fekFQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b168333ce4782c5a$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $b168333ce4782c5a$var$dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d 'de' MMM 'de' y",
    short: "dd/MM/y"
};
var $b168333ce4782c5a$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $b168333ce4782c5a$var$dateTimeFormats = {
    full: "{{date}} '\xe0s' {{time}}",
    long: "{{date}} '\xe0s' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $b168333ce4782c5a$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $b168333ce4782c5a$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $b168333ce4782c5a$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $b168333ce4782c5a$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $b168333ce4782c5a$export$2e2bcd8739ae039 = $b168333ce4782c5a$var$formatLong;

});

parcelRegister("i934R", function(module, exports) {

$parcel$export(module.exports, "default", () => $d35b745c5f653b74$export$2e2bcd8739ae039);
var $d35b745c5f653b74$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var weekday = date.getUTCDay();
        var last = weekday === 0 || weekday === 6 ? "\xfaltimo" : "\xfaltima";
        return "'" + last + "' eeee '\xe0s' p";
    },
    yesterday: "'ontem \xe0s' p",
    today: "'hoje \xe0s' p",
    tomorrow: "'amanh\xe3 \xe0s' p",
    nextWeek: "eeee '\xe0s' p",
    other: "P"
};
var $d35b745c5f653b74$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $d35b745c5f653b74$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
var $d35b745c5f653b74$export$2e2bcd8739ae039 = $d35b745c5f653b74$var$formatRelative;

});

parcelRegister("bvcAt", function(module, exports) {

$parcel$export(module.exports, "default", () => $85fc5a8e3787a2e3$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $85fc5a8e3787a2e3$var$eraValues = {
    narrow: [
        "aC",
        "dC"
    ],
    abbreviated: [
        "a.C.",
        "d.C."
    ],
    wide: [
        "antes de Cristo",
        "depois de Cristo"
    ]
};
var $85fc5a8e3787a2e3$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var $85fc5a8e3787a2e3$var$monthValues = {
    narrow: [
        "j",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "jan",
        "fev",
        "mar",
        "abr",
        "mai",
        "jun",
        "jul",
        "ago",
        "set",
        "out",
        "nov",
        "dez"
    ],
    wide: [
        "janeiro",
        "fevereiro",
        "mar\xe7o",
        "abril",
        "maio",
        "junho",
        "julho",
        "agosto",
        "setembro",
        "outubro",
        "novembro",
        "dezembro"
    ]
};
var $85fc5a8e3787a2e3$var$dayValues = {
    narrow: [
        "d",
        "s",
        "t",
        "q",
        "q",
        "s",
        "s"
    ],
    short: [
        "dom",
        "seg",
        "ter",
        "qua",
        "qui",
        "sex",
        "s\xe1b"
    ],
    abbreviated: [
        "dom",
        "seg",
        "ter",
        "qua",
        "qui",
        "sex",
        "s\xe1b"
    ],
    wide: [
        "domingo",
        "segunda-feira",
        "ter\xe7a-feira",
        "quarta-feira",
        "quinta-feira",
        "sexta-feira",
        "s\xe1bado"
    ]
};
var $85fc5a8e3787a2e3$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "manh\xe3",
        afternoon: "tarde",
        evening: "noite",
        night: "madrugada"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "manh\xe3",
        afternoon: "tarde",
        evening: "noite",
        night: "madrugada"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "manh\xe3",
        afternoon: "tarde",
        evening: "noite",
        night: "madrugada"
    }
};
var $85fc5a8e3787a2e3$var$formattingDayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "da manh\xe3",
        afternoon: "da tarde",
        evening: "da noite",
        night: "da madrugada"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "da manh\xe3",
        afternoon: "da tarde",
        evening: "da noite",
        night: "da madrugada"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "da manh\xe3",
        afternoon: "da tarde",
        evening: "da noite",
        night: "da madrugada"
    }
};
var $85fc5a8e3787a2e3$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\xba";
};
var $85fc5a8e3787a2e3$var$localize = {
    ordinalNumber: $85fc5a8e3787a2e3$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $85fc5a8e3787a2e3$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $85fc5a8e3787a2e3$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $85fc5a8e3787a2e3$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $85fc5a8e3787a2e3$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $85fc5a8e3787a2e3$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $85fc5a8e3787a2e3$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $85fc5a8e3787a2e3$export$2e2bcd8739ae039 = $85fc5a8e3787a2e3$var$localize;

});

parcelRegister("gJF9Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2f0c65eecc01149$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $c2f0c65eecc01149$var$matchOrdinalNumberPattern = /^(\d+)(º|ª)?/i;
var $c2f0c65eecc01149$var$parseOrdinalNumberPattern = /\d+/i;
var $c2f0c65eecc01149$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
    wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
};
var $c2f0c65eecc01149$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^(antes de cristo|antes da era comum)/i,
        /^(depois de cristo|era comum)/i
    ]
};
var $c2f0c65eecc01149$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º|ª)? trimestre/i
};
var $c2f0c65eecc01149$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $c2f0c65eecc01149$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
    wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
var $c2f0c65eecc01149$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ab/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^ag/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $c2f0c65eecc01149$var$matchDayPatterns = {
    narrow: /^[dstq]/i,
    short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
    wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
};
var $c2f0c65eecc01149$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^s/i,
        /^t/i,
        /^q/i,
        /^q/i,
        /^s/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^seg/i,
        /^t/i,
        /^qua/i,
        /^qui/i,
        /^sex/i,
        /^s[áa]/i
    ]
};
var $c2f0c65eecc01149$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
    any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
};
var $c2f0c65eecc01149$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^meia/i,
        noon: /^meio/i,
        morning: /manh[ãa]/i,
        afternoon: /tarde/i,
        evening: /noite/i,
        night: /madrugada/i
    }
};
var $c2f0c65eecc01149$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $c2f0c65eecc01149$var$matchOrdinalNumberPattern,
        parsePattern: $c2f0c65eecc01149$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $c2f0c65eecc01149$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c2f0c65eecc01149$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $c2f0c65eecc01149$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c2f0c65eecc01149$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $c2f0c65eecc01149$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c2f0c65eecc01149$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $c2f0c65eecc01149$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $c2f0c65eecc01149$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $c2f0c65eecc01149$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $c2f0c65eecc01149$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $c2f0c65eecc01149$export$2e2bcd8739ae039 = $c2f0c65eecc01149$var$match;

});


parcelRegister("d00ab", function(module, exports) {

$parcel$export(module.exports, "default", () => $976b66e28adfdbab$export$2e2bcd8739ae039);

var $5MRV6 = parcelRequire("5MRV6");

var $7sR8O = parcelRequire("7sR8O");

var $7Q722 = parcelRequire("7Q722");

var $9c7FG = parcelRequire("9c7FG");

var $aFCo3 = parcelRequire("aFCo3");
/**
 * @type {Locale}
 * @category Locales
 * @summary Portuguese locale (Brazil).
 * @language Portuguese
 * @iso-639-2 por
 * @author Lucas Duailibe [@duailibe]{@link https://github.com/duailibe}
 * @author Yago Carballo [@yagocarballo]{@link https://github.com/YagoCarballo}
 */ var $976b66e28adfdbab$var$locale = {
    code: "pt-BR",
    formatDistance: (0, $5MRV6.default),
    formatLong: (0, $7sR8O.default),
    formatRelative: (0, $7Q722.default),
    localize: (0, $9c7FG.default),
    match: (0, $aFCo3.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $976b66e28adfdbab$export$2e2bcd8739ae039 = $976b66e28adfdbab$var$locale;

});
parcelRegister("5MRV6", function(module, exports) {

$parcel$export(module.exports, "default", () => $436b42d2895e5c45$export$2e2bcd8739ae039);
var $436b42d2895e5c45$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "menos de um segundo",
        other: "menos de {{count}} segundos"
    },
    xSeconds: {
        one: "1 segundo",
        other: "{{count}} segundos"
    },
    halfAMinute: "meio minuto",
    lessThanXMinutes: {
        one: "menos de um minuto",
        other: "menos de {{count}} minutos"
    },
    xMinutes: {
        one: "1 minuto",
        other: "{{count}} minutos"
    },
    aboutXHours: {
        one: "cerca de 1 hora",
        other: "cerca de {{count}} horas"
    },
    xHours: {
        one: "1 hora",
        other: "{{count}} horas"
    },
    xDays: {
        one: "1 dia",
        other: "{{count}} dias"
    },
    aboutXWeeks: {
        one: "cerca de 1 semana",
        other: "cerca de {{count}} semanas"
    },
    xWeeks: {
        one: "1 semana",
        other: "{{count}} semanas"
    },
    aboutXMonths: {
        one: "cerca de 1 m\xeas",
        other: "cerca de {{count}} meses"
    },
    xMonths: {
        one: "1 m\xeas",
        other: "{{count}} meses"
    },
    aboutXYears: {
        one: "cerca de 1 ano",
        other: "cerca de {{count}} anos"
    },
    xYears: {
        one: "1 ano",
        other: "{{count}} anos"
    },
    overXYears: {
        one: "mais de 1 ano",
        other: "mais de {{count}} anos"
    },
    almostXYears: {
        one: "quase 1 ano",
        other: "quase {{count}} anos"
    }
};
var $436b42d2895e5c45$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $436b42d2895e5c45$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "em " + result;
        else return "h\xe1 " + result;
    }
    return result;
};
var $436b42d2895e5c45$export$2e2bcd8739ae039 = $436b42d2895e5c45$var$formatDistance;

});

parcelRegister("7sR8O", function(module, exports) {

$parcel$export(module.exports, "default", () => $56f45eacf23864a7$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $56f45eacf23864a7$var$dateFormats = {
    full: "EEEE, d 'de' MMMM 'de' y",
    long: "d 'de' MMMM 'de' y",
    medium: "d MMM y",
    short: "dd/MM/yyyy"
};
var $56f45eacf23864a7$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $56f45eacf23864a7$var$dateTimeFormats = {
    full: "{{date}} '\xe0s' {{time}}",
    long: "{{date}} '\xe0s' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $56f45eacf23864a7$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $56f45eacf23864a7$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $56f45eacf23864a7$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $56f45eacf23864a7$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $56f45eacf23864a7$export$2e2bcd8739ae039 = $56f45eacf23864a7$var$formatLong;

});

parcelRegister("7Q722", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b52d817802ee158$export$2e2bcd8739ae039);
var $5b52d817802ee158$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var weekday = date.getUTCDay();
        var last = weekday === 0 || weekday === 6 ? "\xfaltimo" : "\xfaltima";
        return "'" + last + "' eeee '\xe0s' p";
    },
    yesterday: "'ontem \xe0s' p",
    today: "'hoje \xe0s' p",
    tomorrow: "'amanh\xe3 \xe0s' p",
    nextWeek: "eeee '\xe0s' p",
    other: "P"
};
var $5b52d817802ee158$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $5b52d817802ee158$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
var $5b52d817802ee158$export$2e2bcd8739ae039 = $5b52d817802ee158$var$formatRelative;

});

parcelRegister("9c7FG", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b1b2f6bf355908b$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $6b1b2f6bf355908b$var$eraValues = {
    narrow: [
        "AC",
        "DC"
    ],
    abbreviated: [
        "AC",
        "DC"
    ],
    wide: [
        "antes de cristo",
        "depois de cristo"
    ]
};
var $6b1b2f6bf355908b$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    wide: [
        "1\xba trimestre",
        "2\xba trimestre",
        "3\xba trimestre",
        "4\xba trimestre"
    ]
};
var $6b1b2f6bf355908b$var$monthValues = {
    narrow: [
        "j",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "jan",
        "fev",
        "mar",
        "abr",
        "mai",
        "jun",
        "jul",
        "ago",
        "set",
        "out",
        "nov",
        "dez"
    ],
    wide: [
        "janeiro",
        "fevereiro",
        "mar\xe7o",
        "abril",
        "maio",
        "junho",
        "julho",
        "agosto",
        "setembro",
        "outubro",
        "novembro",
        "dezembro"
    ]
};
var $6b1b2f6bf355908b$var$dayValues = {
    narrow: [
        "D",
        "S",
        "T",
        "Q",
        "Q",
        "S",
        "S"
    ],
    short: [
        "dom",
        "seg",
        "ter",
        "qua",
        "qui",
        "sex",
        "sab"
    ],
    abbreviated: [
        "domingo",
        "segunda",
        "ter\xe7a",
        "quarta",
        "quinta",
        "sexta",
        "s\xe1bado"
    ],
    wide: [
        "domingo",
        "segunda-feira",
        "ter\xe7a-feira",
        "quarta-feira",
        "quinta-feira",
        "sexta-feira",
        "s\xe1bado"
    ]
};
var $6b1b2f6bf355908b$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "md",
        morning: "manh\xe3",
        afternoon: "tarde",
        evening: "tarde",
        night: "noite"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "manh\xe3",
        afternoon: "tarde",
        evening: "tarde",
        night: "noite"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "manh\xe3",
        afternoon: "tarde",
        evening: "tarde",
        night: "noite"
    }
};
var $6b1b2f6bf355908b$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "md",
        morning: "da manh\xe3",
        afternoon: "da tarde",
        evening: "da tarde",
        night: "da noite"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "da manh\xe3",
        afternoon: "da tarde",
        evening: "da tarde",
        night: "da noite"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "meia-noite",
        noon: "meio-dia",
        morning: "da manh\xe3",
        afternoon: "da tarde",
        evening: "da tarde",
        night: "da noite"
    }
};
var $6b1b2f6bf355908b$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    if ((options === null || options === void 0 ? void 0 : options.unit) === "week") return number + "\xaa";
    return number + "\xba";
};
var $6b1b2f6bf355908b$var$localize = {
    ordinalNumber: $6b1b2f6bf355908b$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $6b1b2f6bf355908b$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $6b1b2f6bf355908b$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $6b1b2f6bf355908b$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $6b1b2f6bf355908b$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $6b1b2f6bf355908b$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $6b1b2f6bf355908b$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $6b1b2f6bf355908b$export$2e2bcd8739ae039 = $6b1b2f6bf355908b$var$localize;

});

parcelRegister("aFCo3", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c4b828ea3e90cb9$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $7c4b828ea3e90cb9$var$matchOrdinalNumberPattern = /^(\d+)[ºªo]?/i;
var $7c4b828ea3e90cb9$var$parseOrdinalNumberPattern = /\d+/i;
var $7c4b828ea3e90cb9$var$matchEraPatterns = {
    narrow: /^(ac|dc|a|d)/i,
    abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
    wide: /^(antes de cristo|depois de cristo)/i
};
var $7c4b828ea3e90cb9$var$parseEraPatterns = {
    any: [
        /^ac/i,
        /^dc/i
    ],
    wide: [
        /^antes de cristo/i,
        /^depois de cristo/i
    ]
};
var $7c4b828ea3e90cb9$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^[1234](º)? trimestre/i
};
var $7c4b828ea3e90cb9$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $7c4b828ea3e90cb9$var$matchMonthPatterns = {
    narrow: /^[jfmajsond]/i,
    abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
    wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
var $7c4b828ea3e90cb9$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^fev/i,
        /^mar/i,
        /^abr/i,
        /^mai/i,
        /^jun/i,
        /^jul/i,
        /^ago/i,
        /^set/i,
        /^out/i,
        /^nov/i,
        /^dez/i
    ]
};
var $7c4b828ea3e90cb9$var$matchDayPatterns = {
    narrow: /^(dom|[23456]ª?|s[aá]b)/i,
    short: /^(dom|[23456]ª?|s[aá]b)/i,
    abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
    wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i
};
var $7c4b828ea3e90cb9$var$parseDayPatterns = {
    short: [
        /^d/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^s[aá]/i
    ],
    narrow: [
        /^d/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^s[aá]/i
    ],
    any: [
        /^d/i,
        /^seg/i,
        /^t/i,
        /^qua/i,
        /^qui/i,
        /^sex/i,
        /^s[aá]b/i
    ]
};
var $7c4b828ea3e90cb9$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
    any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i
};
var $7c4b828ea3e90cb9$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn|^meia[-\s]noite/i,
        noon: /^md|^meio[-\s]dia/i,
        morning: /manhã/i,
        afternoon: /tarde/i,
        evening: /tarde/i,
        night: /noite/i
    }
};
var $7c4b828ea3e90cb9$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $7c4b828ea3e90cb9$var$matchOrdinalNumberPattern,
        parsePattern: $7c4b828ea3e90cb9$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $7c4b828ea3e90cb9$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7c4b828ea3e90cb9$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $7c4b828ea3e90cb9$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7c4b828ea3e90cb9$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $7c4b828ea3e90cb9$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7c4b828ea3e90cb9$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $7c4b828ea3e90cb9$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $7c4b828ea3e90cb9$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $7c4b828ea3e90cb9$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $7c4b828ea3e90cb9$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $7c4b828ea3e90cb9$export$2e2bcd8739ae039 = $7c4b828ea3e90cb9$var$match;

});


parcelRegister("3Y8EW", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e3db13c7657e4b3$export$2e2bcd8739ae039);

var $0Df2G = parcelRequire("0Df2G");

var $8BLvh = parcelRequire("8BLvh");

var $6Ie4l = parcelRequire("6Ie4l");

var $cF7AR = parcelRequire("cF7AR");

var $cMekU = parcelRequire("cMekU");
/**
 * @type {Locale}
 * @category Locales
 * @summary Romanian locale.
 * @language Romanian
 * @iso-639-2 ron
 * @author Sergiu Munteanu [@jsergiu]{@link https://github.com/jsergiu}
 * @author Adrian Ocneanu [@aocneanu]{@link https://github.com/aocneanu}
 * @author Mihai Ocneanu [@gandesc]{@link https://github.com/gandesc}
 */ var $2e3db13c7657e4b3$var$locale = {
    code: "ro",
    formatDistance: (0, $0Df2G.default),
    formatLong: (0, $8BLvh.default),
    formatRelative: (0, $6Ie4l.default),
    localize: (0, $cF7AR.default),
    match: (0, $cMekU.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $2e3db13c7657e4b3$export$2e2bcd8739ae039 = $2e3db13c7657e4b3$var$locale;

});
parcelRegister("0Df2G", function(module, exports) {

$parcel$export(module.exports, "default", () => $001e70c513b40cc6$export$2e2bcd8739ae039);
var $001e70c513b40cc6$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mai pu\u021Bin de o secund\u0103",
        other: "mai pu\u021Bin de {{count}} secunde"
    },
    xSeconds: {
        one: "1 secund\u0103",
        other: "{{count}} secunde"
    },
    halfAMinute: "jum\u0103tate de minut",
    lessThanXMinutes: {
        one: "mai pu\u021Bin de un minut",
        other: "mai pu\u021Bin de {{count}} minute"
    },
    xMinutes: {
        one: "1 minut",
        other: "{{count}} minute"
    },
    aboutXHours: {
        one: "circa 1 or\u0103",
        other: "circa {{count}} ore"
    },
    xHours: {
        one: "1 or\u0103",
        other: "{{count}} ore"
    },
    xDays: {
        one: "1 zi",
        other: "{{count}} zile"
    },
    aboutXWeeks: {
        one: "circa o s\u0103pt\u0103m\xe2n\u0103",
        other: "circa {{count}} s\u0103pt\u0103m\xe2ni"
    },
    xWeeks: {
        one: "1 s\u0103pt\u0103m\xe2n\u0103",
        other: "{{count}} s\u0103pt\u0103m\xe2ni"
    },
    aboutXMonths: {
        one: "circa 1 lun\u0103",
        other: "circa {{count}} luni"
    },
    xMonths: {
        one: "1 lun\u0103",
        other: "{{count}} luni"
    },
    aboutXYears: {
        one: "circa 1 an",
        other: "circa {{count}} ani"
    },
    xYears: {
        one: "1 an",
        other: "{{count}} ani"
    },
    overXYears: {
        one: "peste 1 an",
        other: "peste {{count}} ani"
    },
    almostXYears: {
        one: "aproape 1 an",
        other: "aproape {{count}} ani"
    }
};
var $001e70c513b40cc6$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $001e70c513b40cc6$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\xeen " + result;
        else return result + " \xeen urm\u0103";
    }
    return result;
};
var $001e70c513b40cc6$export$2e2bcd8739ae039 = $001e70c513b40cc6$var$formatDistance;

});

parcelRegister("8BLvh", function(module, exports) {

$parcel$export(module.exports, "default", () => $019e0ad9580b3aef$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $019e0ad9580b3aef$var$dateFormats = {
    full: "EEEE, d MMMM yyyy",
    long: "d MMMM yyyy",
    medium: "d MMM yyyy",
    short: "dd.MM.yyyy"
};
var $019e0ad9580b3aef$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $019e0ad9580b3aef$var$dateTimeFormats = {
    full: "{{date}} 'la' {{time}}",
    long: "{{date}} 'la' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $019e0ad9580b3aef$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $019e0ad9580b3aef$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $019e0ad9580b3aef$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $019e0ad9580b3aef$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $019e0ad9580b3aef$export$2e2bcd8739ae039 = $019e0ad9580b3aef$var$formatLong;

});

parcelRegister("6Ie4l", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e31c3f234d7d932$export$2e2bcd8739ae039);
var $4e31c3f234d7d932$var$formatRelativeLocale = {
    lastWeek: "eeee 'trecut\u0103 la' p",
    yesterday: "'ieri la' p",
    today: "'ast\u0103zi la' p",
    tomorrow: "'m\xe2ine la' p",
    nextWeek: "eeee 'viitoare la' p",
    other: "P"
};
var $4e31c3f234d7d932$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $4e31c3f234d7d932$var$formatRelativeLocale[token];
};
var $4e31c3f234d7d932$export$2e2bcd8739ae039 = $4e31c3f234d7d932$var$formatRelative;

});

parcelRegister("cF7AR", function(module, exports) {

$parcel$export(module.exports, "default", () => $937f344cfe9fa797$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $937f344cfe9fa797$var$eraValues = {
    narrow: [
        "\xce",
        "D"
    ],
    abbreviated: [
        "\xce.d.C.",
        "D.C."
    ],
    wide: [
        "\xcenainte de Cristos",
        "Dup\u0103 Cristos"
    ]
};
var $937f344cfe9fa797$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "T1",
        "T2",
        "T3",
        "T4"
    ],
    wide: [
        "primul trimestru",
        "al doilea trimestru",
        "al treilea trimestru",
        "al patrulea trimestru"
    ]
};
var $937f344cfe9fa797$var$monthValues = {
    narrow: [
        "I",
        "F",
        "M",
        "A",
        "M",
        "I",
        "I",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "ian",
        "feb",
        "mar",
        "apr",
        "mai",
        "iun",
        "iul",
        "aug",
        "sep",
        "oct",
        "noi",
        "dec"
    ],
    wide: [
        "ianuarie",
        "februarie",
        "martie",
        "aprilie",
        "mai",
        "iunie",
        "iulie",
        "august",
        "septembrie",
        "octombrie",
        "noiembrie",
        "decembrie"
    ]
};
var $937f344cfe9fa797$var$dayValues = {
    narrow: [
        "d",
        "l",
        "m",
        "m",
        "j",
        "v",
        "s"
    ],
    short: [
        "du",
        "lu",
        "ma",
        "mi",
        "jo",
        "vi",
        "s\xe2"
    ],
    abbreviated: [
        "dum",
        "lun",
        "mar",
        "mie",
        "joi",
        "vin",
        "s\xe2m"
    ],
    wide: [
        "duminic\u0103",
        "luni",
        "mar\u021Bi",
        "miercuri",
        "joi",
        "vineri",
        "s\xe2mb\u0103t\u0103"
    ]
};
var $937f344cfe9fa797$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "ami",
        morning: "dim",
        afternoon: "da",
        evening: "s",
        night: "n"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: "noapte"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: "noapte"
    }
};
var $937f344cfe9fa797$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mn",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: "noapte"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: "noapte"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "miezul nop\u021Bii",
        noon: "amiaz\u0103",
        morning: "diminea\u021B\u0103",
        afternoon: "dup\u0103-amiaz\u0103",
        evening: "sear\u0103",
        night: "noapte"
    }
};
var $937f344cfe9fa797$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $937f344cfe9fa797$var$localize = {
    ordinalNumber: $937f344cfe9fa797$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $937f344cfe9fa797$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $937f344cfe9fa797$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $937f344cfe9fa797$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $937f344cfe9fa797$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $937f344cfe9fa797$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $937f344cfe9fa797$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $937f344cfe9fa797$export$2e2bcd8739ae039 = $937f344cfe9fa797$var$localize;

});

parcelRegister("cMekU", function(module, exports) {

$parcel$export(module.exports, "default", () => $94d5169be2091d07$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $94d5169be2091d07$var$matchOrdinalNumberPattern = /^(\d+)?/i;
var $94d5169be2091d07$var$parseOrdinalNumberPattern = /\d+/i;
var $94d5169be2091d07$var$matchEraPatterns = {
    narrow: /^(Î|D)/i,
    abbreviated: /^(Î\.?\s?d\.?\s?C\.?|Î\.?\s?e\.?\s?n\.?|D\.?\s?C\.?|e\.?\s?n\.?)/i,
    wide: /^(Înainte de Cristos|Înaintea erei noastre|După Cristos|Era noastră)/i
};
var $94d5169be2091d07$var$parseEraPatterns = {
    any: [
        /^ÎC/i,
        /^DC/i
    ],
    wide: [
        /^(Înainte de Cristos|Înaintea erei noastre)/i,
        /^(După Cristos|Era noastră)/i
    ]
};
var $94d5169be2091d07$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^T[1234]/i,
    wide: /^trimestrul [1234]/i
};
var $94d5169be2091d07$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $94d5169be2091d07$var$matchMonthPatterns = {
    narrow: /^[ifmaasond]/i,
    abbreviated: /^(ian|feb|mar|apr|mai|iun|iul|aug|sep|oct|noi|dec)/i,
    wide: /^(ianuarie|februarie|martie|aprilie|mai|iunie|iulie|august|septembrie|octombrie|noiembrie|decembrie)/i
};
var $94d5169be2091d07$var$parseMonthPatterns = {
    narrow: [
        /^i/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^i/i,
        /^i/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ia/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^mai/i,
        /^iun/i,
        /^iul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $94d5169be2091d07$var$matchDayPatterns = {
    narrow: /^[dlmjvs]/i,
    short: /^(d|l|ma|mi|j|v|s)/i,
    abbreviated: /^(dum|lun|mar|mie|jo|vi|sâ)/i,
    wide: /^(duminica|luni|marţi|miercuri|joi|vineri|sâmbătă)/i
};
var $94d5169be2091d07$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^l/i,
        /^m/i,
        /^m/i,
        /^j/i,
        /^v/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^l/i,
        /^ma/i,
        /^mi/i,
        /^j/i,
        /^v/i,
        /^s/i
    ]
};
var $94d5169be2091d07$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mn|a|(dimineaţa|după-amiaza|seara|noaptea))/i,
    any: /^([ap]\.?\s?m\.?|miezul nopții|amiaza|(dimineaţa|după-amiaza|seara|noaptea))/i
};
var $94d5169be2091d07$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mn/i,
        noon: /amiaza/i,
        morning: /dimineaţa/i,
        afternoon: /după-amiaza/i,
        evening: /seara/i,
        night: /noaptea/i
    }
};
var $94d5169be2091d07$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $94d5169be2091d07$var$matchOrdinalNumberPattern,
        parsePattern: $94d5169be2091d07$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $94d5169be2091d07$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $94d5169be2091d07$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $94d5169be2091d07$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $94d5169be2091d07$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $94d5169be2091d07$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $94d5169be2091d07$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $94d5169be2091d07$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $94d5169be2091d07$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $94d5169be2091d07$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $94d5169be2091d07$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $94d5169be2091d07$export$2e2bcd8739ae039 = $94d5169be2091d07$var$match;

});


parcelRegister("ePrM2", function(module, exports) {

$parcel$export(module.exports, "default", () => $acbb5f6b6b23043e$export$2e2bcd8739ae039);

var $hPvmg = parcelRequire("hPvmg");

var $01F7I = parcelRequire("01F7I");

var $3J9TZ = parcelRequire("3J9TZ");

var $g0gT1 = parcelRequire("g0gT1");

var $94LZl = parcelRequire("94LZl");
/**
 * @type {Locale}
 * @category Locales
 * @summary Russian locale.
 * @language Russian
 * @iso-639-2 rus
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $acbb5f6b6b23043e$var$locale = {
    code: "ru",
    formatDistance: (0, $hPvmg.default),
    formatLong: (0, $01F7I.default),
    formatRelative: (0, $3J9TZ.default),
    localize: (0, $g0gT1.default),
    match: (0, $94LZl.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $acbb5f6b6b23043e$export$2e2bcd8739ae039 = $acbb5f6b6b23043e$var$locale;

});
parcelRegister("hPvmg", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfaf86298b7fd2a2$export$2e2bcd8739ae039);
function $cfaf86298b7fd2a2$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace("{{count}}", String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace("{{count}}", String(count));
    else return scheme.pluralGenitive.replace("{{count}}", String(count));
}
function $cfaf86298b7fd2a2$var$buildLocalizeTokenFn(scheme) {
    return function(count, options) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return $cfaf86298b7fd2a2$var$declension(scheme.future, count);
                else return "\u0447\u0435\u0440\u0435\u0437 " + $cfaf86298b7fd2a2$var$declension(scheme.regular, count);
            } else {
                if (scheme.past) return $cfaf86298b7fd2a2$var$declension(scheme.past, count);
                else return $cfaf86298b7fd2a2$var$declension(scheme.regular, count) + " \u043D\u0430\u0437\u0430\u0434";
            }
        } else return $cfaf86298b7fd2a2$var$declension(scheme.regular, count);
    };
}
var $cfaf86298b7fd2a2$var$formatDistanceLocale = {
    lessThanXSeconds: $cfaf86298b7fd2a2$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435 \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: $cfaf86298b7fd2a2$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u043D\u0430\u0437\u0430\u0434",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B \u043D\u0430\u0437\u0430\u0434",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u043D\u0430\u0437\u0430\u0434"
        },
        future: {
            singularNominative: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u044B",
            pluralGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: function halfAMinute(_count, options) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) return "\u0447\u0435\u0440\u0435\u0437 \u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B";
            else return "\u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B \u043D\u0430\u0437\u0430\u0434";
        }
        return "\u043F\u043E\u043B\u043C\u0438\u043D\u0443\u0442\u044B";
    },
    lessThanXMinutes: $cfaf86298b7fd2a2$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435 \u043C\u0438\u043D\u0443\u0442\u044B",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435 {{count}} \u043C\u0438\u043D\u0443\u0442"
        },
        future: {
            one: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 \u043C\u0438\u043D\u0443\u0442\u0443",
            singularNominative: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u0443",
            singularGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "\u043C\u0435\u043D\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442"
        }
    }),
    xMinutes: $cfaf86298b7fd2a2$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0430",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442"
        },
        past: {
            singularNominative: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0443 \u043D\u0430\u0437\u0430\u0434",
            singularGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442\u044B \u043D\u0430\u0437\u0430\u0434",
            pluralGenitive: "{{count}} \u043C\u0438\u043D\u0443\u0442 \u043D\u0430\u0437\u0430\u0434"
        },
        future: {
            singularNominative: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u0443",
            singularGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442\u044B",
            pluralGenitive: "\u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0438\u043D\u0443\u0442"
        }
    }),
    aboutXHours: $cfaf86298b7fd2a2$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u043E\u0432",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0447\u0430\u0441\u043E\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0447\u0430\u0441\u043E\u0432"
        }
    }),
    xHours: $cfaf86298b7fd2a2$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0447\u0430\u0441",
            singularGenitive: "{{count}} \u0447\u0430\u0441\u0430",
            pluralGenitive: "{{count}} \u0447\u0430\u0441\u043E\u0432"
        }
    }),
    xDays: $cfaf86298b7fd2a2$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043D\u044F",
            pluralGenitive: "{{count}} \u0434\u043D\u0435\u0439"
        }
    }),
    aboutXWeeks: $cfaf86298b7fd2a2$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u044C",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u044E",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        }
    }),
    xWeeks: $cfaf86298b7fd2a2$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043D\u0435\u0434\u0435\u043B\u044F",
            singularGenitive: "{{count}} \u043D\u0435\u0434\u0435\u043B\u0438",
            pluralGenitive: "{{count}} \u043D\u0435\u0434\u0435\u043B\u044C"
        }
    }),
    aboutXMonths: $cfaf86298b7fd2a2$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        }
    }),
    xMonths: $cfaf86298b7fd2a2$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0435\u0441\u044F\u0446",
            singularGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0430",
            pluralGenitive: "{{count}} \u043C\u0435\u0441\u044F\u0446\u0435\u0432"
        }
    }),
    aboutXYears: $cfaf86298b7fd2a2$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043E\u043A\u043E\u043B\u043E {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043B\u0435\u0442",
            pluralGenitive: "\u043E\u043A\u043E\u043B\u043E {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    }),
    xYears: $cfaf86298b7fd2a2$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434",
            singularGenitive: "{{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "{{count}} \u043B\u0435\u0442"
        }
    }),
    overXYears: $cfaf86298b7fd2a2$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u0433\u043E\u0434\u0430",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u043B\u0435\u0442",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435 {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u0431\u043E\u043B\u044C\u0448\u0435, \u0447\u0435\u043C \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    }),
    almostXYears: $cfaf86298b7fd2a2$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u043E\u0447\u0442\u0438 {{count}} \u043B\u0435\u0442"
        },
        future: {
            singularNominative: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434",
            singularGenitive: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u0433\u043E\u0434\u0430",
            pluralGenitive: "\u043F\u043E\u0447\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 {{count}} \u043B\u0435\u0442"
        }
    })
};
var $cfaf86298b7fd2a2$var$formatDistance = function formatDistance(token, count, options) {
    return $cfaf86298b7fd2a2$var$formatDistanceLocale[token](count, options);
};
var $cfaf86298b7fd2a2$export$2e2bcd8739ae039 = $cfaf86298b7fd2a2$var$formatDistance;

});

parcelRegister("01F7I", function(module, exports) {

$parcel$export(module.exports, "default", () => $004ffe5a45ecc5ec$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $004ffe5a45ecc5ec$var$dateFormats = {
    full: "EEEE, d MMMM y '\u0433.'",
    long: "d MMMM y '\u0433.'",
    medium: "d MMM y '\u0433.'",
    short: "dd.MM.y"
};
var $004ffe5a45ecc5ec$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
var $004ffe5a45ecc5ec$var$dateTimeFormats = {
    any: "{{date}}, {{time}}"
};
var $004ffe5a45ecc5ec$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $004ffe5a45ecc5ec$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $004ffe5a45ecc5ec$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $004ffe5a45ecc5ec$var$dateTimeFormats,
        defaultWidth: "any"
    })
};
var $004ffe5a45ecc5ec$export$2e2bcd8739ae039 = $004ffe5a45ecc5ec$var$formatLong;

});

parcelRegister("3J9TZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b6d416ea83748ca$export$2e2bcd8739ae039);

var $6KZXu = parcelRequire("6KZXu");
var $2b6d416ea83748ca$var$accusativeWeekdays = [
    "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435",
    "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
    "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
    "\u0441\u0440\u0435\u0434\u0443",
    "\u0447\u0435\u0442\u0432\u0435\u0440\u0433",
    "\u043F\u044F\u0442\u043D\u0438\u0446\u0443",
    "\u0441\u0443\u0431\u0431\u043E\u0442\u0443"
];
function $2b6d416ea83748ca$var$_lastWeek(day) {
    var weekday = $2b6d416ea83748ca$var$accusativeWeekdays[day];
    switch(day){
        case 0:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u043E\u0435 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u044B\u0439 " + weekday + " \u0432' p";
        case 3:
        case 5:
        case 6:
            return "'\u0432 \u043F\u0440\u043E\u0448\u043B\u0443\u044E " + weekday + " \u0432' p";
    }
}
function $2b6d416ea83748ca$var$thisWeek(day) {
    var weekday = $2b6d416ea83748ca$var$accusativeWeekdays[day];
    if (day === 2 /* Tue */ ) return "'\u0432\u043E " + weekday + " \u0432' p";
    else return "'\u0432 " + weekday + " \u0432' p";
}
function $2b6d416ea83748ca$var$_nextWeek(day) {
    var weekday = $2b6d416ea83748ca$var$accusativeWeekdays[day];
    switch(day){
        case 0:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0435 " + weekday + " \u0432' p";
        case 1:
        case 2:
        case 4:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 " + weekday + " \u0432' p";
        case 3:
        case 5:
        case 6:
            return "'\u0432 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0443\u044E " + weekday + " \u0432' p";
    }
}
var $2b6d416ea83748ca$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $6KZXu.default)(date, baseDate, options)) return $2b6d416ea83748ca$var$thisWeek(day);
        else return $2b6d416ea83748ca$var$_lastWeek(day);
    },
    yesterday: "'\u0432\u0447\u0435\u0440\u0430 \u0432' p",
    today: "'\u0441\u0435\u0433\u043E\u0434\u043D\u044F \u0432' p",
    tomorrow: "'\u0437\u0430\u0432\u0442\u0440\u0430 \u0432' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $6KZXu.default)(date, baseDate, options)) return $2b6d416ea83748ca$var$thisWeek(day);
        else return $2b6d416ea83748ca$var$_nextWeek(day);
    },
    other: "P"
};
var $2b6d416ea83748ca$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $2b6d416ea83748ca$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
var $2b6d416ea83748ca$export$2e2bcd8739ae039 = $2b6d416ea83748ca$var$formatRelative;

});

parcelRegister("g0gT1", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba69beb5bdddc97d$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $ba69beb5bdddc97d$var$eraValues = {
    narrow: [
        "\u0434\u043E \u043D.\u044D.",
        "\u043D.\u044D."
    ],
    abbreviated: [
        "\u0434\u043E \u043D. \u044D.",
        "\u043D. \u044D."
    ],
    wide: [
        "\u0434\u043E \u043D\u0430\u0448\u0435\u0439 \u044D\u0440\u044B",
        "\u043D\u0430\u0448\u0435\u0439 \u044D\u0440\u044B"
    ]
};
var $ba69beb5bdddc97d$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-\u0439 \u043A\u0432.",
        "2-\u0439 \u043A\u0432.",
        "3-\u0439 \u043A\u0432.",
        "4-\u0439 \u043A\u0432."
    ],
    wide: [
        "1-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var $ba69beb5bdddc97d$var$monthValues = {
    narrow: [
        "\u042F",
        "\u0424",
        "\u041C",
        "\u0410",
        "\u041C",
        "\u0418",
        "\u0418",
        "\u0410",
        "\u0421",
        "\u041E",
        "\u041D",
        "\u0414"
    ],
    abbreviated: [
        "\u044F\u043D\u0432.",
        "\u0444\u0435\u0432.",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440.",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D\u044C",
        "\u0438\u044E\u043B\u044C",
        "\u0430\u0432\u0433.",
        "\u0441\u0435\u043D\u0442.",
        "\u043E\u043A\u0442.",
        "\u043D\u043E\u044F\u0431.",
        "\u0434\u0435\u043A."
    ],
    wide: [
        "\u044F\u043D\u0432\u0430\u0440\u044C",
        "\u0444\u0435\u0432\u0440\u0430\u043B\u044C",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0435\u043B\u044C",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D\u044C",
        "\u0438\u044E\u043B\u044C",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044C",
        "\u043E\u043A\u0442\u044F\u0431\u0440\u044C",
        "\u043D\u043E\u044F\u0431\u0440\u044C",
        "\u0434\u0435\u043A\u0430\u0431\u0440\u044C"
    ]
};
var $ba69beb5bdddc97d$var$formattingMonthValues = {
    narrow: [
        "\u042F",
        "\u0424",
        "\u041C",
        "\u0410",
        "\u041C",
        "\u0418",
        "\u0418",
        "\u0410",
        "\u0421",
        "\u041E",
        "\u041D",
        "\u0414"
    ],
    abbreviated: [
        "\u044F\u043D\u0432.",
        "\u0444\u0435\u0432.",
        "\u043C\u0430\u0440.",
        "\u0430\u043F\u0440.",
        "\u043C\u0430\u044F",
        "\u0438\u044E\u043D.",
        "\u0438\u044E\u043B.",
        "\u0430\u0432\u0433.",
        "\u0441\u0435\u043D\u0442.",
        "\u043E\u043A\u0442.",
        "\u043D\u043E\u044F\u0431.",
        "\u0434\u0435\u043A."
    ],
    wide: [
        "\u044F\u043D\u0432\u0430\u0440\u044F",
        "\u0444\u0435\u0432\u0440\u0430\u043B\u044F",
        "\u043C\u0430\u0440\u0442\u0430",
        "\u0430\u043F\u0440\u0435\u043B\u044F",
        "\u043C\u0430\u044F",
        "\u0438\u044E\u043D\u044F",
        "\u0438\u044E\u043B\u044F",
        "\u0430\u0432\u0433\u0443\u0441\u0442\u0430",
        "\u0441\u0435\u043D\u0442\u044F\u0431\u0440\u044F",
        "\u043E\u043A\u0442\u044F\u0431\u0440\u044F",
        "\u043D\u043E\u044F\u0431\u0440\u044F",
        "\u0434\u0435\u043A\u0430\u0431\u0440\u044F"
    ]
};
var $ba69beb5bdddc97d$var$dayValues = {
    narrow: [
        "\u0412",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u0432\u0441",
        "\u043F\u043D",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0442",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u0432\u0441\u043A",
        "\u043F\u043D\u0434",
        "\u0432\u0442\u0440",
        "\u0441\u0440\u0434",
        "\u0447\u0442\u0432",
        "\u043F\u0442\u043D",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u0432\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
        "\u0432\u0442\u043E\u0440\u043D\u0438\u043A",
        "\u0441\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0435\u0440\u0433",
        "\u043F\u044F\u0442\u043D\u0438\u0446\u0430",
        "\u0441\u0443\u0431\u0431\u043E\u0442\u0430"
    ]
};
var $ba69beb5bdddc97d$var$dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044C"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u044C"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D\u043E\u0447\u044C",
        noon: "\u043F\u043E\u043B\u0434\u0435\u043D\u044C",
        morning: "\u0443\u0442\u0440\u043E",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0435\u0440",
        night: "\u043D\u043E\u0447\u044C"
    }
};
var $ba69beb5bdddc97d$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0438"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D.",
        noon: "\u043F\u043E\u043B\u0434.",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0438"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u043E\u043B\u043D\u043E\u0447\u044C",
        noon: "\u043F\u043E\u043B\u0434\u0435\u043D\u044C",
        morning: "\u0443\u0442\u0440\u0430",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447\u0435\u0440\u0430",
        night: "\u043D\u043E\u0447\u0438"
    }
};
var $ba69beb5bdddc97d$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    var suffix;
    if (unit === "date") suffix = "-\u0435";
    else if (unit === "week" || unit === "minute" || unit === "second") suffix = "-\u044F";
    else suffix = "-\u0439";
    return number + suffix;
};
var $ba69beb5bdddc97d$var$localize = {
    ordinalNumber: $ba69beb5bdddc97d$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $ba69beb5bdddc97d$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $ba69beb5bdddc97d$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $ba69beb5bdddc97d$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $ba69beb5bdddc97d$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $ba69beb5bdddc97d$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $ba69beb5bdddc97d$var$dayPeriodValues,
        defaultWidth: "any",
        formattingValues: $ba69beb5bdddc97d$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $ba69beb5bdddc97d$export$2e2bcd8739ae039 = $ba69beb5bdddc97d$var$localize;

});

parcelRegister("94LZl", function(module, exports) {

$parcel$export(module.exports, "default", () => $69b9b64c3178cd0f$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $69b9b64c3178cd0f$var$matchOrdinalNumberPattern = /^(\d+)(-?(е|я|й|ое|ье|ая|ья|ый|ой|ий|ый))?/i;
var $69b9b64c3178cd0f$var$parseOrdinalNumberPattern = /\d+/i;
var $69b9b64c3178cd0f$var$matchEraPatterns = {
    narrow: /^((до )?н\.?\s?э\.?)/i,
    abbreviated: /^((до )?н\.?\s?э\.?)/i,
    wide: /^(до нашей эры|нашей эры|наша эра)/i
};
var $69b9b64c3178cd0f$var$parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
var $69b9b64c3178cd0f$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[ыои]?й?)? кв.?/i,
    wide: /^[1234](-?[ыои]?й?)? квартал/i
};
var $69b9b64c3178cd0f$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $69b9b64c3178cd0f$var$matchMonthPatterns = {
    narrow: /^[яфмаисонд]/i,
    abbreviated: /^(янв|фев|март?|апр|ма[йя]|июн[ья]?|июл[ья]?|авг|сент?|окт|нояб?|дек)\.?/i,
    wide: /^(январ[ья]|феврал[ья]|марта?|апрел[ья]|ма[йя]|июн[ья]|июл[ья]|августа?|сентябр[ья]|октябр[ья]|октябр[ья]|ноябр[ья]|декабр[ья])/i
};
var $69b9b64c3178cd0f$var$parseMonthPatterns = {
    narrow: [
        /^я/i,
        /^ф/i,
        /^м/i,
        /^а/i,
        /^м/i,
        /^и/i,
        /^и/i,
        /^а/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^я/i
    ],
    any: [
        /^я/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^ма[йя]/i,
        /^июн/i,
        /^июл/i,
        /^ав/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ]
};
var $69b9b64c3178cd0f$var$matchDayPatterns = {
    narrow: /^[впсч]/i,
    short: /^(вс|во|пн|по|вт|ср|чт|че|пт|пя|сб|су)\.?/i,
    abbreviated: /^(вск|вос|пнд|пон|втр|вто|срд|сре|чтв|чет|птн|пят|суб).?/i,
    wide: /^(воскресень[ея]|понедельника?|вторника?|сред[аы]|четверга?|пятниц[аы]|суббот[аы])/i
};
var $69b9b64c3178cd0f$var$parseDayPatterns = {
    narrow: [
        /^в/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^в[ос]/i,
        /^п[он]/i,
        /^в/i,
        /^ср/i,
        /^ч/i,
        /^п[ят]/i,
        /^с[уб]/i
    ]
};
var $69b9b64c3178cd0f$var$matchDayPeriodPatterns = {
    narrow: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
    abbreviated: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
    wide: /^([дп]п|полночь|полдень|утр[оа]|день|дня|вечера?|ноч[ьи])/i
};
var $69b9b64c3178cd0f$var$parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^полн/i,
        noon: /^полд/i,
        morning: /^у/i,
        afternoon: /^д[ен]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
var $69b9b64c3178cd0f$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $69b9b64c3178cd0f$var$matchOrdinalNumberPattern,
        parsePattern: $69b9b64c3178cd0f$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $69b9b64c3178cd0f$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $69b9b64c3178cd0f$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $69b9b64c3178cd0f$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $69b9b64c3178cd0f$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $69b9b64c3178cd0f$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $69b9b64c3178cd0f$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $69b9b64c3178cd0f$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $69b9b64c3178cd0f$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $69b9b64c3178cd0f$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $69b9b64c3178cd0f$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $69b9b64c3178cd0f$export$2e2bcd8739ae039 = $69b9b64c3178cd0f$var$match;

});


parcelRegister("fPRwQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8752420492f175e$export$2e2bcd8739ae039);

var $edRJt = parcelRequire("edRJt");

var $23tQF = parcelRequire("23tQF");

var $35Ja0 = parcelRequire("35Ja0");

var $3zgaj = parcelRequire("3zgaj");

var $3NPJA = parcelRequire("3NPJA");
/**
 * @type {Locale}
 * @category Locales
 * @summary Slovak locale.
 * @language Slovak
 * @iso-639-2 slk
 * @author Marek Suscak [@mareksuscak]{@link https://github.com/mareksuscak}
 */ var $b8752420492f175e$var$locale = {
    code: "sk",
    formatDistance: (0, $edRJt.default),
    formatLong: (0, $23tQF.default),
    formatRelative: (0, $35Ja0.default),
    localize: (0, $3zgaj.default),
    match: (0, $3NPJA.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $b8752420492f175e$export$2e2bcd8739ae039 = $b8752420492f175e$var$locale;

});
parcelRegister("edRJt", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5abf5b5bf2f65a4$export$2e2bcd8739ae039);
function $a5abf5b5bf2f65a4$var$declensionGroup(scheme, count) {
    if (count === 1 && scheme.one) return scheme.one;
    if (count >= 2 && count <= 4 && scheme.twoFour) return scheme.twoFour;
    // if count === null || count === 0 || count >= 5
    return scheme.other;
}
function $a5abf5b5bf2f65a4$var$declension(scheme, count, time) {
    var group = $a5abf5b5bf2f65a4$var$declensionGroup(scheme, count);
    var finalText = group[time];
    return finalText.replace("{{count}}", String(count));
}
function $a5abf5b5bf2f65a4$var$extractPreposition(token) {
    var result = [
        "lessThan",
        "about",
        "over",
        "almost"
    ].filter(function(preposition) {
        return !!token.match(new RegExp("^" + preposition));
    });
    return result[0];
}
function $a5abf5b5bf2f65a4$var$prefixPreposition(preposition) {
    var translation = "";
    if (preposition === "almost") translation = "takmer";
    if (preposition === "about") translation = "pribli\u017Ene";
    return translation.length > 0 ? translation + " " : "";
}
function $a5abf5b5bf2f65a4$var$suffixPreposition(preposition) {
    var translation = "";
    if (preposition === "lessThan") translation = "menej ne\u017E";
    if (preposition === "over") translation = "viac ne\u017E";
    return translation.length > 0 ? translation + " " : "";
}
function $a5abf5b5bf2f65a4$var$lowercaseFirstLetter(string) {
    return string.charAt(0).toLowerCase() + string.slice(1);
}
var $a5abf5b5bf2f65a4$var$formatDistanceLocale = {
    xSeconds: {
        one: {
            present: "sekunda",
            past: "sekundou",
            future: "sekundu"
        },
        twoFour: {
            present: "{{count}} sekundy",
            past: "{{count}} sekundami",
            future: "{{count}} sekundy"
        },
        other: {
            present: "{{count}} sek\xfand",
            past: "{{count}} sekundami",
            future: "{{count}} sek\xfand"
        }
    },
    halfAMinute: {
        other: {
            present: "pol min\xfaty",
            past: "pol min\xfatou",
            future: "pol min\xfaty"
        }
    },
    xMinutes: {
        one: {
            present: "min\xfata",
            past: "min\xfatou",
            future: "min\xfatu"
        },
        twoFour: {
            present: "{{count}} min\xfaty",
            past: "{{count}} min\xfatami",
            future: "{{count}} min\xfaty"
        },
        other: {
            present: "{{count}} min\xfat",
            past: "{{count}} min\xfatami",
            future: "{{count}} min\xfat"
        }
    },
    xHours: {
        one: {
            present: "hodina",
            past: "hodinou",
            future: "hodinu"
        },
        twoFour: {
            present: "{{count}} hodiny",
            past: "{{count}} hodinami",
            future: "{{count}} hodiny"
        },
        other: {
            present: "{{count}} hod\xedn",
            past: "{{count}} hodinami",
            future: "{{count}} hod\xedn"
        }
    },
    xDays: {
        one: {
            present: "de\u0148",
            past: "d\u0148om",
            future: "de\u0148"
        },
        twoFour: {
            present: "{{count}} dni",
            past: "{{count}} d\u0148ami",
            future: "{{count}} dni"
        },
        other: {
            present: "{{count}} dn\xed",
            past: "{{count}} d\u0148ami",
            future: "{{count}} dn\xed"
        }
    },
    xWeeks: {
        one: {
            present: "t\xfd\u017Ede\u0148",
            past: "t\xfd\u017Ed\u0148om",
            future: "t\xfd\u017Ede\u0148"
        },
        twoFour: {
            present: "{{count}} t\xfd\u017Edne",
            past: "{{count}} t\xfd\u017Ed\u0148ami",
            future: "{{count}} t\xfd\u017Edne"
        },
        other: {
            present: "{{count}} t\xfd\u017Ed\u0148ov",
            past: "{{count}} t\xfd\u017Ed\u0148ami",
            future: "{{count}} t\xfd\u017Ed\u0148ov"
        }
    },
    xMonths: {
        one: {
            present: "mesiac",
            past: "mesiacom",
            future: "mesiac"
        },
        twoFour: {
            present: "{{count}} mesiace",
            past: "{{count}} mesiacmi",
            future: "{{count}} mesiace"
        },
        other: {
            present: "{{count}} mesiacov",
            past: "{{count}} mesiacmi",
            future: "{{count}} mesiacov"
        }
    },
    xYears: {
        one: {
            present: "rok",
            past: "rokom",
            future: "rok"
        },
        twoFour: {
            present: "{{count}} roky",
            past: "{{count}} rokmi",
            future: "{{count}} roky"
        },
        other: {
            present: "{{count}} rokov",
            past: "{{count}} rokmi",
            future: "{{count}} rokov"
        }
    }
};
var $a5abf5b5bf2f65a4$var$formatDistance = function formatDistance(token, count, options) {
    var preposition = $a5abf5b5bf2f65a4$var$extractPreposition(token) || "";
    var key = $a5abf5b5bf2f65a4$var$lowercaseFirstLetter(token.substring(preposition.length));
    var scheme = $a5abf5b5bf2f65a4$var$formatDistanceLocale[key];
    if (!(options !== null && options !== void 0 && options.addSuffix)) return $a5abf5b5bf2f65a4$var$prefixPreposition(preposition) + $a5abf5b5bf2f65a4$var$suffixPreposition(preposition) + $a5abf5b5bf2f65a4$var$declension(scheme, count, "present");
    if (options.comparison && options.comparison > 0) return $a5abf5b5bf2f65a4$var$prefixPreposition(preposition) + "o " + $a5abf5b5bf2f65a4$var$suffixPreposition(preposition) + $a5abf5b5bf2f65a4$var$declension(scheme, count, "future");
    else return $a5abf5b5bf2f65a4$var$prefixPreposition(preposition) + "pred " + $a5abf5b5bf2f65a4$var$suffixPreposition(preposition) + $a5abf5b5bf2f65a4$var$declension(scheme, count, "past");
};
var $a5abf5b5bf2f65a4$export$2e2bcd8739ae039 = $a5abf5b5bf2f65a4$var$formatDistance;

});

parcelRegister("23tQF", function(module, exports) {

$parcel$export(module.exports, "default", () => $17f303d90f28e6b6$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $17f303d90f28e6b6$var$dateFormats = {
    full: "EEEE d. MMMM y",
    long: "d. MMMM y",
    medium: "d. M. y",
    short: "d. M. y"
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#2149
var $17f303d90f28e6b6$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1994
var $17f303d90f28e6b6$var$dateTimeFormats = {
    full: "{{date}}, {{time}}",
    long: "{{date}}, {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}} {{time}}"
};
var $17f303d90f28e6b6$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $17f303d90f28e6b6$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $17f303d90f28e6b6$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $17f303d90f28e6b6$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $17f303d90f28e6b6$export$2e2bcd8739ae039 = $17f303d90f28e6b6$var$formatLong;

});

parcelRegister("35Ja0", function(module, exports) {

$parcel$export(module.exports, "default", () => $2404dea182d22538$export$2e2bcd8739ae039);

var $6KZXu = parcelRequire("6KZXu");
// https://www.unicode.org/cldr/charts/32/summary/sk.html?hide#1308
var $2404dea182d22538$var$accusativeWeekdays = [
    "nede\u013Eu",
    "pondelok",
    "utorok",
    "stredu",
    "\u0161tvrtok",
    "piatok",
    "sobotu"
];
function $2404dea182d22538$var$_lastWeek(day) {
    var weekday = $2404dea182d22538$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        /* Sun */ case 3:
        /* Wed */ case 6 /* Sat */ :
            return "'minul\xfa " + weekday + " o' p";
        default:
            return "'minul\xfd' eeee 'o' p";
    }
}
function $2404dea182d22538$var$thisWeek(day) {
    var weekday = $2404dea182d22538$var$accusativeWeekdays[day];
    if (day === 4 /* Thu */ ) return "'vo' eeee 'o' p";
    else return "'v " + weekday + " o' p";
}
function $2404dea182d22538$var$_nextWeek(day) {
    var weekday = $2404dea182d22538$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        /* Sun */ case 4:
        /* Wed */ case 6 /* Sat */ :
            return "'bud\xfacu " + weekday + " o' p";
        default:
            return "'bud\xfaci' eeee 'o' p";
    }
}
var $2404dea182d22538$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $6KZXu.default)(date, baseDate, options)) return $2404dea182d22538$var$thisWeek(day);
        else return $2404dea182d22538$var$_lastWeek(day);
    },
    yesterday: "'v\u010Dera o' p",
    today: "'dnes o' p",
    tomorrow: "'zajtra o' p",
    nextWeek: function nextWeek(date, baseDate, options) {
        var day = date.getUTCDay();
        if ((0, $6KZXu.default)(date, baseDate, options)) return $2404dea182d22538$var$thisWeek(day);
        else return $2404dea182d22538$var$_nextWeek(day);
    },
    other: "P"
};
var $2404dea182d22538$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $2404dea182d22538$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
var $2404dea182d22538$export$2e2bcd8739ae039 = $2404dea182d22538$var$formatRelative;

});

parcelRegister("3zgaj", function(module, exports) {

$parcel$export(module.exports, "default", () => $29912e185fcc0eb4$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $29912e185fcc0eb4$var$eraValues = {
    narrow: [
        "pred Kr.",
        "po Kr."
    ],
    abbreviated: [
        "pred Kr.",
        "po Kr."
    ],
    wide: [
        "pred Kristom",
        "po Kristovi"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1780
var $29912e185fcc0eb4$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1. \u0161tvr\u0165rok",
        "2. \u0161tvr\u0165rok",
        "3. \u0161tvr\u0165rok",
        "4. \u0161tvr\u0165rok"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1804
var $29912e185fcc0eb4$var$monthValues = {
    narrow: [
        "j",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "jan",
        "feb",
        "mar",
        "apr",
        "m\xe1j",
        "j\xfan",
        "j\xfal",
        "aug",
        "sep",
        "okt",
        "nov",
        "dec"
    ],
    wide: [
        "janu\xe1r",
        "febru\xe1r",
        "marec",
        "apr\xedl",
        "m\xe1j",
        "j\xfan",
        "j\xfal",
        "august",
        "september",
        "okt\xf3ber",
        "november",
        "december"
    ]
};
var $29912e185fcc0eb4$var$formattingMonthValues = {
    narrow: [
        "j",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "jan",
        "feb",
        "mar",
        "apr",
        "m\xe1j",
        "j\xfan",
        "j\xfal",
        "aug",
        "sep",
        "okt",
        "nov",
        "dec"
    ],
    wide: [
        "janu\xe1ra",
        "febru\xe1ra",
        "marca",
        "apr\xedla",
        "m\xe1ja",
        "j\xfana",
        "j\xfala",
        "augusta",
        "septembra",
        "okt\xf3bra",
        "novembra",
        "decembra"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1876
var $29912e185fcc0eb4$var$dayValues = {
    narrow: [
        "n",
        "p",
        "u",
        "s",
        "\u0161",
        "p",
        "s"
    ],
    short: [
        "ne",
        "po",
        "ut",
        "st",
        "\u0161t",
        "pi",
        "so"
    ],
    abbreviated: [
        "ne",
        "po",
        "ut",
        "st",
        "\u0161t",
        "pi",
        "so"
    ],
    wide: [
        "nede\u013Ea",
        "pondelok",
        "utorok",
        "streda",
        "\u0161tvrtok",
        "piatok",
        "sobota"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sk.html#1932
var $29912e185fcc0eb4$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "poln.",
        noon: "pol.",
        morning: "r\xe1no",
        afternoon: "pop.",
        evening: "ve\u010D.",
        night: "noc"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "poln.",
        noon: "pol.",
        morning: "r\xe1no",
        afternoon: "popol.",
        evening: "ve\u010Der",
        night: "noc"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "polnoc",
        noon: "poludnie",
        morning: "r\xe1no",
        afternoon: "popoludnie",
        evening: "ve\u010Der",
        night: "noc"
    }
};
var $29912e185fcc0eb4$var$formattingDayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "o poln.",
        noon: "nap.",
        morning: "r\xe1no",
        afternoon: "pop.",
        evening: "ve\u010D.",
        night: "v n."
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "o poln.",
        noon: "napol.",
        morning: "r\xe1no",
        afternoon: "popol.",
        evening: "ve\u010Der",
        night: "v noci"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "o polnoci",
        noon: "napoludnie",
        morning: "r\xe1no",
        afternoon: "popoludn\xed",
        evening: "ve\u010Der",
        night: "v noci"
    }
};
var $29912e185fcc0eb4$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + ".";
};
var $29912e185fcc0eb4$var$localize = {
    ordinalNumber: $29912e185fcc0eb4$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $29912e185fcc0eb4$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $29912e185fcc0eb4$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $29912e185fcc0eb4$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $29912e185fcc0eb4$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $29912e185fcc0eb4$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $29912e185fcc0eb4$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $29912e185fcc0eb4$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $29912e185fcc0eb4$export$2e2bcd8739ae039 = $29912e185fcc0eb4$var$localize;

});

parcelRegister("3NPJA", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c4e140f610a82d3$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $2c4e140f610a82d3$var$matchOrdinalNumberPattern = /^(\d+)\.?/i;
var $2c4e140f610a82d3$var$parseOrdinalNumberPattern = /\d+/i;
var $2c4e140f610a82d3$var$matchEraPatterns = {
    narrow: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
    abbreviated: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
    wide: /^(pred Kristom|pred na[šs][íi]m letopo[čc]tom|po Kristovi|n[áa][šs]ho letopo[čc]tu)/i
};
var $2c4e140f610a82d3$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|n)/i
    ]
};
var $2c4e140f610a82d3$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]\. [šs]tvr[ťt]rok/i
};
var $2c4e140f610a82d3$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $2c4e140f610a82d3$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|m[áa]j|j[úu]n|j[úu]l|aug|sep|okt|nov|dec)/i,
    wide: /^(janu[áa]ra?|febru[áa]ra?|(marec|marca)|apr[íi]la?|m[áa]ja?|j[úu]na?|j[úu]la?|augusta?|(september|septembra)|(okt[óo]ber|okt[óo]bra)|(november|novembra)|(december|decembra))/i
};
var $2c4e140f610a82d3$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^m[áa]j/i,
        /^j[úu]n/i,
        /^j[úu]l/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $2c4e140f610a82d3$var$matchDayPatterns = {
    narrow: /^[npusšp]/i,
    short: /^(ne|po|ut|st|št|pi|so)/i,
    abbreviated: /^(ne|po|ut|st|št|pi|so)/i,
    wide: /^(nede[ľl]a|pondelok|utorok|streda|[šs]tvrtok|piatok|sobota])/i
};
var $2c4e140f610a82d3$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^u/i,
        /^s/i,
        /^š/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^n/i,
        /^po/i,
        /^u/i,
        /^st/i,
        /^(št|stv)/i,
        /^pi/i,
        /^so/i
    ]
};
var $2c4e140f610a82d3$var$matchDayPeriodPatterns = {
    narrow: /^(am|pm|(o )?poln\.?|(nap\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]\.?|(v n\.?|noc))/i,
    abbreviated: /^(am|pm|(o )?poln\.?|(napol\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]er|(v )?noci?)/i,
    any: /^(am|pm|(o )?polnoci?|(na)?poludnie|r[áa]no|popoludn(ie|í|i)|ve[čc]er|(v )?noci?)/i
};
var $2c4e140f610a82d3$var$parseDayPeriodPatterns = {
    any: {
        am: /^am/i,
        pm: /^pm/i,
        midnight: /poln/i,
        noon: /^(nap|(na)?pol(\.|u))/i,
        morning: /^r[áa]no/i,
        afternoon: /^pop/i,
        evening: /^ve[čc]/i,
        night: /^(noc|v n\.)/i
    }
};
var $2c4e140f610a82d3$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $2c4e140f610a82d3$var$matchOrdinalNumberPattern,
        parsePattern: $2c4e140f610a82d3$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $2c4e140f610a82d3$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2c4e140f610a82d3$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $2c4e140f610a82d3$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2c4e140f610a82d3$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $2c4e140f610a82d3$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2c4e140f610a82d3$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $2c4e140f610a82d3$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $2c4e140f610a82d3$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $2c4e140f610a82d3$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $2c4e140f610a82d3$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $2c4e140f610a82d3$export$2e2bcd8739ae039 = $2c4e140f610a82d3$var$match;

});


parcelRegister("fnMm5", function(module, exports) {

$parcel$export(module.exports, "default", () => $b32e8358342a2315$export$2e2bcd8739ae039);

var $04sCn = parcelRequire("04sCn");

var $4n4VJ = parcelRequire("4n4VJ");

var $gBz3f = parcelRequire("gBz3f");

var $3DjVB = parcelRequire("3DjVB");

var $hAuoD = parcelRequire("hAuoD");
/**
 * @type {Locale}
 * @category Locales
 * @summary Slovenian locale.
 * @language Slovenian
 * @iso-639-2 slv
 * @author Adam Stradovnik [@Neoglyph]{@link https://github.com/Neoglyph}
 * @author Mato Žgajner [@mzgajner]{@link https://github.com/mzgajner}
 */ var $b32e8358342a2315$var$locale = {
    code: "sl",
    formatDistance: (0, $04sCn.default),
    formatLong: (0, $4n4VJ.default),
    formatRelative: (0, $gBz3f.default),
    localize: (0, $3DjVB.default),
    match: (0, $hAuoD.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $b32e8358342a2315$export$2e2bcd8739ae039 = $b32e8358342a2315$var$locale;

});
parcelRegister("04sCn", function(module, exports) {

$parcel$export(module.exports, "default", () => $00d692bfb56d0f52$export$2e2bcd8739ae039);
function $00d692bfb56d0f52$var$isPluralType(val) {
    return val.one !== undefined;
}
var $00d692bfb56d0f52$var$formatDistanceLocale = {
    lessThanXSeconds: {
        present: {
            one: "manj kot {{count}} sekunda",
            two: "manj kot {{count}} sekundi",
            few: "manj kot {{count}} sekunde",
            other: "manj kot {{count}} sekund"
        },
        past: {
            one: "manj kot {{count}} sekundo",
            two: "manj kot {{count}} sekundama",
            few: "manj kot {{count}} sekundami",
            other: "manj kot {{count}} sekundami"
        },
        future: {
            one: "manj kot {{count}} sekundo",
            two: "manj kot {{count}} sekundi",
            few: "manj kot {{count}} sekunde",
            other: "manj kot {{count}} sekund"
        }
    },
    xSeconds: {
        present: {
            one: "{{count}} sekunda",
            two: "{{count}} sekundi",
            few: "{{count}} sekunde",
            other: "{{count}} sekund"
        },
        past: {
            one: "{{count}} sekundo",
            two: "{{count}} sekundama",
            few: "{{count}} sekundami",
            other: "{{count}} sekundami"
        },
        future: {
            one: "{{count}} sekundo",
            two: "{{count}} sekundi",
            few: "{{count}} sekunde",
            other: "{{count}} sekund"
        }
    },
    halfAMinute: "pol minute",
    lessThanXMinutes: {
        present: {
            one: "manj kot {{count}} minuta",
            two: "manj kot {{count}} minuti",
            few: "manj kot {{count}} minute",
            other: "manj kot {{count}} minut"
        },
        past: {
            one: "manj kot {{count}} minuto",
            two: "manj kot {{count}} minutama",
            few: "manj kot {{count}} minutami",
            other: "manj kot {{count}} minutami"
        },
        future: {
            one: "manj kot {{count}} minuto",
            two: "manj kot {{count}} minuti",
            few: "manj kot {{count}} minute",
            other: "manj kot {{count}} minut"
        }
    },
    xMinutes: {
        present: {
            one: "{{count}} minuta",
            two: "{{count}} minuti",
            few: "{{count}} minute",
            other: "{{count}} minut"
        },
        past: {
            one: "{{count}} minuto",
            two: "{{count}} minutama",
            few: "{{count}} minutami",
            other: "{{count}} minutami"
        },
        future: {
            one: "{{count}} minuto",
            two: "{{count}} minuti",
            few: "{{count}} minute",
            other: "{{count}} minut"
        }
    },
    aboutXHours: {
        present: {
            one: "pribli\u017Eno {{count}} ura",
            two: "pribli\u017Eno {{count}} uri",
            few: "pribli\u017Eno {{count}} ure",
            other: "pribli\u017Eno {{count}} ur"
        },
        past: {
            one: "pribli\u017Eno {{count}} uro",
            two: "pribli\u017Eno {{count}} urama",
            few: "pribli\u017Eno {{count}} urami",
            other: "pribli\u017Eno {{count}} urami"
        },
        future: {
            one: "pribli\u017Eno {{count}} uro",
            two: "pribli\u017Eno {{count}} uri",
            few: "pribli\u017Eno {{count}} ure",
            other: "pribli\u017Eno {{count}} ur"
        }
    },
    xHours: {
        present: {
            one: "{{count}} ura",
            two: "{{count}} uri",
            few: "{{count}} ure",
            other: "{{count}} ur"
        },
        past: {
            one: "{{count}} uro",
            two: "{{count}} urama",
            few: "{{count}} urami",
            other: "{{count}} urami"
        },
        future: {
            one: "{{count}} uro",
            two: "{{count}} uri",
            few: "{{count}} ure",
            other: "{{count}} ur"
        }
    },
    xDays: {
        present: {
            one: "{{count}} dan",
            two: "{{count}} dni",
            few: "{{count}} dni",
            other: "{{count}} dni"
        },
        past: {
            one: "{{count}} dnem",
            two: "{{count}} dnevoma",
            few: "{{count}} dnevi",
            other: "{{count}} dnevi"
        },
        future: {
            one: "{{count}} dan",
            two: "{{count}} dni",
            few: "{{count}} dni",
            other: "{{count}} dni"
        }
    },
    // no tenses for weeks?
    aboutXWeeks: {
        one: "pribli\u017Eno {{count}} teden",
        two: "pribli\u017Eno {{count}} tedna",
        few: "pribli\u017Eno {{count}} tedne",
        other: "pribli\u017Eno {{count}} tednov"
    },
    // no tenses for weeks?
    xWeeks: {
        one: "{{count}} teden",
        two: "{{count}} tedna",
        few: "{{count}} tedne",
        other: "{{count}} tednov"
    },
    aboutXMonths: {
        present: {
            one: "pribli\u017Eno {{count}} mesec",
            two: "pribli\u017Eno {{count}} meseca",
            few: "pribli\u017Eno {{count}} mesece",
            other: "pribli\u017Eno {{count}} mesecev"
        },
        past: {
            one: "pribli\u017Eno {{count}} mesecem",
            two: "pribli\u017Eno {{count}} mesecema",
            few: "pribli\u017Eno {{count}} meseci",
            other: "pribli\u017Eno {{count}} meseci"
        },
        future: {
            one: "pribli\u017Eno {{count}} mesec",
            two: "pribli\u017Eno {{count}} meseca",
            few: "pribli\u017Eno {{count}} mesece",
            other: "pribli\u017Eno {{count}} mesecev"
        }
    },
    xMonths: {
        present: {
            one: "{{count}} mesec",
            two: "{{count}} meseca",
            few: "{{count}} meseci",
            other: "{{count}} mesecev"
        },
        past: {
            one: "{{count}} mesecem",
            two: "{{count}} mesecema",
            few: "{{count}} meseci",
            other: "{{count}} meseci"
        },
        future: {
            one: "{{count}} mesec",
            two: "{{count}} meseca",
            few: "{{count}} mesece",
            other: "{{count}} mesecev"
        }
    },
    aboutXYears: {
        present: {
            one: "pribli\u017Eno {{count}} leto",
            two: "pribli\u017Eno {{count}} leti",
            few: "pribli\u017Eno {{count}} leta",
            other: "pribli\u017Eno {{count}} let"
        },
        past: {
            one: "pribli\u017Eno {{count}} letom",
            two: "pribli\u017Eno {{count}} letoma",
            few: "pribli\u017Eno {{count}} leti",
            other: "pribli\u017Eno {{count}} leti"
        },
        future: {
            one: "pribli\u017Eno {{count}} leto",
            two: "pribli\u017Eno {{count}} leti",
            few: "pribli\u017Eno {{count}} leta",
            other: "pribli\u017Eno {{count}} let"
        }
    },
    xYears: {
        present: {
            one: "{{count}} leto",
            two: "{{count}} leti",
            few: "{{count}} leta",
            other: "{{count}} let"
        },
        past: {
            one: "{{count}} letom",
            two: "{{count}} letoma",
            few: "{{count}} leti",
            other: "{{count}} leti"
        },
        future: {
            one: "{{count}} leto",
            two: "{{count}} leti",
            few: "{{count}} leta",
            other: "{{count}} let"
        }
    },
    overXYears: {
        present: {
            one: "ve\u010D kot {{count}} leto",
            two: "ve\u010D kot {{count}} leti",
            few: "ve\u010D kot {{count}} leta",
            other: "ve\u010D kot {{count}} let"
        },
        past: {
            one: "ve\u010D kot {{count}} letom",
            two: "ve\u010D kot {{count}} letoma",
            few: "ve\u010D kot {{count}} leti",
            other: "ve\u010D kot {{count}} leti"
        },
        future: {
            one: "ve\u010D kot {{count}} leto",
            two: "ve\u010D kot {{count}} leti",
            few: "ve\u010D kot {{count}} leta",
            other: "ve\u010D kot {{count}} let"
        }
    },
    almostXYears: {
        present: {
            one: "skoraj {{count}} leto",
            two: "skoraj {{count}} leti",
            few: "skoraj {{count}} leta",
            other: "skoraj {{count}} let"
        },
        past: {
            one: "skoraj {{count}} letom",
            two: "skoraj {{count}} letoma",
            few: "skoraj {{count}} leti",
            other: "skoraj {{count}} leti"
        },
        future: {
            one: "skoraj {{count}} leto",
            two: "skoraj {{count}} leti",
            few: "skoraj {{count}} leta",
            other: "skoraj {{count}} let"
        }
    }
};
function $00d692bfb56d0f52$var$getFormFromCount(count) {
    switch(count % 100){
        case 1:
            return "one";
        case 2:
            return "two";
        case 3:
        case 4:
            return "few";
        default:
            return "other";
    }
}
var $00d692bfb56d0f52$var$formatDistance = function formatDistance(token, count, options) {
    var result = "";
    var tense = "present";
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
            tense = "future";
            result = "\u010Dez ";
        } else {
            tense = "past";
            result = "pred ";
        }
    }
    var tokenValue = $00d692bfb56d0f52$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result += tokenValue;
    else {
        var form = $00d692bfb56d0f52$var$getFormFromCount(count);
        if ($00d692bfb56d0f52$var$isPluralType(tokenValue)) result += tokenValue[form].replace("{{count}}", String(count));
        else result += tokenValue[tense][form].replace("{{count}}", String(count));
    }
    return result;
};
var $00d692bfb56d0f52$export$2e2bcd8739ae039 = $00d692bfb56d0f52$var$formatDistance;

});

parcelRegister("4n4VJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $32ed22723ff8dd80$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $32ed22723ff8dd80$var$dateFormats = {
    full: "EEEE, dd. MMMM y",
    long: "dd. MMMM y",
    medium: "d. MMM y",
    short: "d. MM. yy"
};
var $32ed22723ff8dd80$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $32ed22723ff8dd80$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $32ed22723ff8dd80$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $32ed22723ff8dd80$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $32ed22723ff8dd80$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $32ed22723ff8dd80$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $32ed22723ff8dd80$export$2e2bcd8739ae039 = $32ed22723ff8dd80$var$formatLong;

});

parcelRegister("gBz3f", function(module, exports) {

$parcel$export(module.exports, "default", () => $c16b4a85000390ee$export$2e2bcd8739ae039);
var $c16b4a85000390ee$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var day = date.getUTCDay();
        switch(day){
            case 0:
                return "'prej\u0161njo nedeljo ob' p";
            case 3:
                return "'prej\u0161njo sredo ob' p";
            case 6:
                return "'prej\u0161njo soboto ob' p";
            default:
                return "'prej\u0161nji' EEEE 'ob' p";
        }
    },
    yesterday: "'v\u010Deraj ob' p",
    today: "'danes ob' p",
    tomorrow: "'jutri ob' p",
    nextWeek: function nextWeek(date) {
        var day = date.getUTCDay();
        switch(day){
            case 0:
                return "'naslednjo nedeljo ob' p";
            case 3:
                return "'naslednjo sredo ob' p";
            case 6:
                return "'naslednjo soboto ob' p";
            default:
                return "'naslednji' EEEE 'ob' p";
        }
    },
    other: "P"
};
var $c16b4a85000390ee$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $c16b4a85000390ee$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
var $c16b4a85000390ee$export$2e2bcd8739ae039 = $c16b4a85000390ee$var$formatRelative;

});

parcelRegister("3DjVB", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a5478ed5e8498c5$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $2a5478ed5e8498c5$var$eraValues = {
    narrow: [
        "pr. n. \u0161t.",
        "po n. \u0161t."
    ],
    abbreviated: [
        "pr. n. \u0161t.",
        "po n. \u0161t."
    ],
    wide: [
        "pred na\u0161im \u0161tetjem",
        "po na\u0161em \u0161tetju"
    ]
};
var $2a5478ed5e8498c5$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1. \u010Det.",
        "2. \u010Det.",
        "3. \u010Det.",
        "4. \u010Det."
    ],
    wide: [
        "1. \u010Detrtletje",
        "2. \u010Detrtletje",
        "3. \u010Detrtletje",
        "4. \u010Detrtletje"
    ]
};
var $2a5478ed5e8498c5$var$monthValues = {
    narrow: [
        "j",
        "f",
        "m",
        "a",
        "m",
        "j",
        "j",
        "a",
        "s",
        "o",
        "n",
        "d"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mar.",
        "apr.",
        "maj",
        "jun.",
        "jul.",
        "avg.",
        "sep.",
        "okt.",
        "nov.",
        "dec."
    ],
    wide: [
        "januar",
        "februar",
        "marec",
        "april",
        "maj",
        "junij",
        "julij",
        "avgust",
        "september",
        "oktober",
        "november",
        "december"
    ]
};
var $2a5478ed5e8498c5$var$dayValues = {
    narrow: [
        "n",
        "p",
        "t",
        "s",
        "\u010D",
        "p",
        "s"
    ],
    short: [
        "ned.",
        "pon.",
        "tor.",
        "sre.",
        "\u010Det.",
        "pet.",
        "sob."
    ],
    abbreviated: [
        "ned.",
        "pon.",
        "tor.",
        "sre.",
        "\u010Det.",
        "pet.",
        "sob."
    ],
    wide: [
        "nedelja",
        "ponedeljek",
        "torek",
        "sreda",
        "\u010Detrtek",
        "petek",
        "sobota"
    ]
};
var $2a5478ed5e8498c5$var$dayPeriodValues = {
    narrow: {
        am: "d",
        pm: "p",
        midnight: "24.00",
        noon: "12.00",
        morning: "j",
        afternoon: "p",
        evening: "v",
        night: "n"
    },
    abbreviated: {
        am: "dop.",
        pm: "pop.",
        midnight: "poln.",
        noon: "pold.",
        morning: "jut.",
        afternoon: "pop.",
        evening: "ve\u010D.",
        night: "no\u010D"
    },
    wide: {
        am: "dop.",
        pm: "pop.",
        midnight: "polno\u010D",
        noon: "poldne",
        morning: "jutro",
        afternoon: "popoldne",
        evening: "ve\u010Der",
        night: "no\u010D"
    }
};
var $2a5478ed5e8498c5$var$formattingDayPeriodValues = {
    narrow: {
        am: "d",
        pm: "p",
        midnight: "24.00",
        noon: "12.00",
        morning: "zj",
        afternoon: "p",
        evening: "zv",
        night: "po"
    },
    abbreviated: {
        am: "dop.",
        pm: "pop.",
        midnight: "opoln.",
        noon: "opold.",
        morning: "zjut.",
        afternoon: "pop.",
        evening: "zve\u010D.",
        night: "pono\u010Di"
    },
    wide: {
        am: "dop.",
        pm: "pop.",
        midnight: "opolno\u010Di",
        noon: "opoldne",
        morning: "zjutraj",
        afternoon: "popoldan",
        evening: "zve\u010Der",
        night: "pono\u010Di"
    }
};
var $2a5478ed5e8498c5$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + ".";
};
var $2a5478ed5e8498c5$var$localize = {
    ordinalNumber: $2a5478ed5e8498c5$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $2a5478ed5e8498c5$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $2a5478ed5e8498c5$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $2a5478ed5e8498c5$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $2a5478ed5e8498c5$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $2a5478ed5e8498c5$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $2a5478ed5e8498c5$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $2a5478ed5e8498c5$export$2e2bcd8739ae039 = $2a5478ed5e8498c5$var$localize;

});

parcelRegister("hAuoD", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccdd60878ef05b15$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $ccdd60878ef05b15$var$matchOrdinalNumberPattern = /^(\d+)\./i;
var $ccdd60878ef05b15$var$parseOrdinalNumberPattern = /\d+/i;
var $ccdd60878ef05b15$var$matchEraPatterns = {
    abbreviated: /^(pr\. n\. št\.|po n\. št\.)/i,
    wide: /^(pred Kristusom|pred na[sš]im [sš]tetjem|po Kristusu|po na[sš]em [sš]tetju|na[sš]ega [sš]tetja)/i
};
var $ccdd60878ef05b15$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|na[sš]em)/i
    ]
};
var $ccdd60878ef05b15$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?[čc]et\.?/i,
    wide: /^[1234]\. [čc]etrtletje/i
};
var $ccdd60878ef05b15$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $ccdd60878ef05b15$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan\.|feb\.|mar\.|apr\.|maj|jun\.|jul\.|avg\.|sep\.|okt\.|nov\.|dec\.)/i,
    wide: /^(januar|februar|marec|april|maj|junij|julij|avgust|september|oktober|november|december)/i
};
var $ccdd60878ef05b15$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    abbreviated: [
        /^ja/i,
        /^fe/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^av/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    wide: [
        /^ja/i,
        /^fe/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^av/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $ccdd60878ef05b15$var$matchDayPatterns = {
    narrow: /^[nptsčc]/i,
    short: /^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
    abbreviated: /^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
    wide: /^(nedelja|ponedeljek|torek|sreda|[cč]etrtek|petek|sobota)/i
};
var $ccdd60878ef05b15$var$parseDayPatterns = {
    narrow: [
        /^n/i,
        /^p/i,
        /^t/i,
        /^s/i,
        /^[cč]/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^n/i,
        /^po/i,
        /^t/i,
        /^sr/i,
        /^[cč]/i,
        /^pe/i,
        /^so/i
    ]
};
var $ccdd60878ef05b15$var$matchDayPeriodPatterns = {
    narrow: /^(d|po?|z?v|n|z?j|24\.00|12\.00)/i,
    any: /^(dop\.|pop\.|o?poln(\.|o[cč]i?)|o?pold(\.|ne)|z?ve[cč](\.|er)|(po)?no[cč]i?|popold(ne|an)|jut(\.|ro)|zjut(\.|raj))/i
};
var $ccdd60878ef05b15$var$parseDayPeriodPatterns = {
    narrow: {
        am: /^d/i,
        pm: /^p/i,
        midnight: /^24/i,
        noon: /^12/i,
        morning: /^(z?j)/i,
        afternoon: /^p/i,
        evening: /^(z?v)/i,
        night: /^(n|po)/i
    },
    any: {
        am: /^dop\./i,
        pm: /^pop\./i,
        midnight: /^o?poln/i,
        noon: /^o?pold/i,
        morning: /j/i,
        afternoon: /^pop\./i,
        evening: /^z?ve/i,
        night: /(po)?no/i
    }
};
var $ccdd60878ef05b15$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $ccdd60878ef05b15$var$matchOrdinalNumberPattern,
        parsePattern: $ccdd60878ef05b15$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $ccdd60878ef05b15$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ccdd60878ef05b15$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $ccdd60878ef05b15$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ccdd60878ef05b15$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $ccdd60878ef05b15$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ccdd60878ef05b15$var$parseMonthPatterns,
        defaultParseWidth: "wide"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $ccdd60878ef05b15$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $ccdd60878ef05b15$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $ccdd60878ef05b15$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $ccdd60878ef05b15$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $ccdd60878ef05b15$export$2e2bcd8739ae039 = $ccdd60878ef05b15$var$match;

});


parcelRegister("fO6Xu", function(module, exports) {

$parcel$export(module.exports, "default", () => $b820ec5a36047c53$export$2e2bcd8739ae039);

var $kDxz6 = parcelRequire("kDxz6");

var $klqu4 = parcelRequire("klqu4");

var $141Xo = parcelRequire("141Xo");

var $iEwnL = parcelRequire("iEwnL");

var $52t9X = parcelRequire("52t9X");
/**
 * @type {Locale}
 * @category Locales
 * @summary Albanian locale.
 * @language Shqip
 * @iso-639-2 sqi
 * @author Ardit Dine [@arditdine]{@link https://github.com/arditdine}
 */ var $b820ec5a36047c53$var$locale = {
    code: "sq",
    formatDistance: (0, $kDxz6.default),
    formatLong: (0, $klqu4.default),
    formatRelative: (0, $141Xo.default),
    localize: (0, $iEwnL.default),
    match: (0, $52t9X.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $b820ec5a36047c53$export$2e2bcd8739ae039 = $b820ec5a36047c53$var$locale;

});
parcelRegister("kDxz6", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0617c8869e597f8$export$2e2bcd8739ae039);
var $f0617c8869e597f8$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "m\xeb pak se nj\xeb sekond\xeb",
        other: "m\xeb pak se {{count}} sekonda"
    },
    xSeconds: {
        one: "1 sekond\xeb",
        other: "{{count}} sekonda"
    },
    halfAMinute: "gjys\xebm minuti",
    lessThanXMinutes: {
        one: "m\xeb pak se nj\xeb minute",
        other: "m\xeb pak se {{count}} minuta"
    },
    xMinutes: {
        one: "1 minut\xeb",
        other: "{{count}} minuta"
    },
    aboutXHours: {
        one: "rreth 1 or\xeb",
        other: "rreth {{count}} or\xeb"
    },
    xHours: {
        one: "1 or\xeb",
        other: "{{count}} or\xeb"
    },
    xDays: {
        one: "1 dit\xeb",
        other: "{{count}} dit\xeb"
    },
    aboutXWeeks: {
        one: "rreth 1 jav\xeb",
        other: "rreth {{count}} jav\xeb"
    },
    xWeeks: {
        one: "1 jav\xeb",
        other: "{{count}} jav\xeb"
    },
    aboutXMonths: {
        one: "rreth 1 muaj",
        other: "rreth {{count}} muaj"
    },
    xMonths: {
        one: "1 muaj",
        other: "{{count}} muaj"
    },
    aboutXYears: {
        one: "rreth 1 vit",
        other: "rreth {{count}} vite"
    },
    xYears: {
        one: "1 vit",
        other: "{{count}} vite"
    },
    overXYears: {
        one: "mbi 1 vit",
        other: "mbi {{count}} vite"
    },
    almostXYears: {
        one: "pothuajse 1 vit",
        other: "pothuajse {{count}} vite"
    }
};
var $f0617c8869e597f8$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $f0617c8869e597f8$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "n\xeb " + result;
        else return result + " m\xeb par\xeb";
    }
    return result;
};
var $f0617c8869e597f8$export$2e2bcd8739ae039 = $f0617c8869e597f8$var$formatDistance;

});

parcelRegister("klqu4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ecfa5001695520d8$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $ecfa5001695520d8$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $ecfa5001695520d8$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $ecfa5001695520d8$var$dateTimeFormats = {
    full: "{{date}} 'n\xeb' {{time}}",
    long: "{{date}} 'n\xeb' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $ecfa5001695520d8$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $ecfa5001695520d8$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $ecfa5001695520d8$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $ecfa5001695520d8$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $ecfa5001695520d8$export$2e2bcd8739ae039 = $ecfa5001695520d8$var$formatLong;

});

parcelRegister("141Xo", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c67aecb7915b19a$export$2e2bcd8739ae039);
var $0c67aecb7915b19a$var$formatRelativeLocale = {
    lastWeek: "'t\xeb' eeee 'e shkuar n\xeb' p",
    yesterday: "'dje n\xeb' p",
    today: "'sot n\xeb' p",
    tomorrow: "'nes\xebr n\xeb' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var $0c67aecb7915b19a$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $0c67aecb7915b19a$var$formatRelativeLocale[token];
};
var $0c67aecb7915b19a$export$2e2bcd8739ae039 = $0c67aecb7915b19a$var$formatRelative;

});

parcelRegister("iEwnL", function(module, exports) {

$parcel$export(module.exports, "default", () => $d94514e1f40b19ca$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $d94514e1f40b19ca$var$eraValues = {
    narrow: [
        "P",
        "M"
    ],
    abbreviated: [
        "PK",
        "MK"
    ],
    wide: [
        "Para Krishtit",
        "Mbas Krishtit"
    ]
};
var $d94514e1f40b19ca$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "4-mujori I",
        "4-mujori II",
        "4-mujori III",
        "4-mujori IV"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $d94514e1f40b19ca$var$monthValues = {
    narrow: [
        "J",
        "S",
        "M",
        "P",
        "M",
        "Q",
        "K",
        "G",
        "S",
        "T",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Shk",
        "Mar",
        "Pri",
        "Maj",
        "Qer",
        "Kor",
        "Gus",
        "Sht",
        "Tet",
        "N\xebn",
        "Dhj"
    ],
    wide: [
        "Janar",
        "Shkurt",
        "Mars",
        "Prill",
        "Maj",
        "Qershor",
        "Korrik",
        "Gusht",
        "Shtator",
        "Tetor",
        "N\xebntor",
        "Dhjetor"
    ]
};
var $d94514e1f40b19ca$var$dayValues = {
    narrow: [
        "D",
        "H",
        "M",
        "M",
        "E",
        "P",
        "S"
    ],
    short: [
        "Di",
        "H\xeb",
        "Ma",
        "M\xeb",
        "En",
        "Pr",
        "Sh"
    ],
    abbreviated: [
        "Die",
        "H\xebn",
        "Mar",
        "M\xebr",
        "Enj",
        "Pre",
        "Sht"
    ],
    wide: [
        "Diel\xeb",
        "H\xebn\xeb",
        "Mart\xeb",
        "M\xebrkur\xeb",
        "Enjte",
        "Premte",
        "Shtun\xeb"
    ]
};
var $d94514e1f40b19ca$var$dayPeriodValues = {
    narrow: {
        am: "p",
        pm: "m",
        midnight: "m",
        noon: "d",
        morning: "m\xebngjes",
        afternoon: "dite",
        evening: "mbr\xebmje",
        night: "nat\xeb"
    },
    abbreviated: {
        am: "PD",
        pm: "MD",
        midnight: "mesn\xebt\xeb",
        noon: "drek",
        morning: "m\xebngjes",
        afternoon: "mbasdite",
        evening: "mbr\xebmje",
        night: "nat\xeb"
    },
    wide: {
        am: "p.d.",
        pm: "m.d.",
        midnight: "mesn\xebt\xeb",
        noon: "drek",
        morning: "m\xebngjes",
        afternoon: "mbasdite",
        evening: "mbr\xebmje",
        night: "nat\xeb"
    }
};
var $d94514e1f40b19ca$var$formattingDayPeriodValues = {
    narrow: {
        am: "p",
        pm: "m",
        midnight: "m",
        noon: "d",
        morning: "n\xeb m\xebngjes",
        afternoon: "n\xeb mbasdite",
        evening: "n\xeb mbr\xebmje",
        night: "n\xeb mesnat\xeb"
    },
    abbreviated: {
        am: "PD",
        pm: "MD",
        midnight: "mesnat\xeb",
        noon: "drek",
        morning: "n\xeb m\xebngjes",
        afternoon: "n\xeb mbasdite",
        evening: "n\xeb mbr\xebmje",
        night: "n\xeb mesnat\xeb"
    },
    wide: {
        am: "p.d.",
        pm: "m.d.",
        midnight: "mesnat\xeb",
        noon: "drek",
        morning: "n\xeb m\xebngjes",
        afternoon: "n\xeb mbasdite",
        evening: "n\xeb mbr\xebmje",
        night: "n\xeb mesnat\xeb"
    }
};
var $d94514e1f40b19ca$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    if ((options === null || options === void 0 ? void 0 : options.unit) === "hour") return String(number);
    if (number === 1) return number + "-r\xeb";
    if (number === 4) return number + "t";
    return number + "-t\xeb";
};
var $d94514e1f40b19ca$var$localize = {
    ordinalNumber: $d94514e1f40b19ca$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $d94514e1f40b19ca$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $d94514e1f40b19ca$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $d94514e1f40b19ca$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $d94514e1f40b19ca$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $d94514e1f40b19ca$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $d94514e1f40b19ca$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $d94514e1f40b19ca$export$2e2bcd8739ae039 = $d94514e1f40b19ca$var$localize;

});

parcelRegister("52t9X", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ab3c22137e19d9a$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $3ab3c22137e19d9a$var$matchOrdinalNumberPattern = /^(\d+)(-rë|-të|t|)?/i;
var $3ab3c22137e19d9a$var$parseOrdinalNumberPattern = /\d+/i;
var $3ab3c22137e19d9a$var$matchEraPatterns = {
    narrow: /^(p|m)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(para krishtit|mbas krishtit)/i
};
var $3ab3c22137e19d9a$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(p|m)/i
    ]
};
var $3ab3c22137e19d9a$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234]-mujori (i{1,3}|iv)/i
};
var $3ab3c22137e19d9a$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $3ab3c22137e19d9a$var$matchMonthPatterns = {
    narrow: /^[jsmpqkftnd]/i,
    abbreviated: /^(jan|shk|mar|pri|maj|qer|kor|gus|sht|tet|nën|dhj)/i,
    wide: /^(janar|shkurt|mars|prill|maj|qershor|korrik|gusht|shtator|tetor|nëntor|dhjetor)/i
};
var $3ab3c22137e19d9a$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^s/i,
        /^m/i,
        /^p/i,
        /^m/i,
        /^q/i,
        /^k/i,
        /^g/i,
        /^s/i,
        /^t/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^shk/i,
        /^mar/i,
        /^pri/i,
        /^maj/i,
        /^qer/i,
        /^kor/i,
        /^gu/i,
        /^sht/i,
        /^tet/i,
        /^n/i,
        /^d/i
    ]
};
var $3ab3c22137e19d9a$var$matchDayPatterns = {
    narrow: /^[dhmeps]/i,
    short: /^(di|hë|ma|më|en|pr|sh)/i,
    abbreviated: /^(die|hën|mar|mër|enj|pre|sht)/i,
    wide: /^(dielë|hënë|martë|mërkurë|enjte|premte|shtunë)/i
};
var $3ab3c22137e19d9a$var$parseDayPatterns = {
    narrow: [
        /^d/i,
        /^h/i,
        /^m/i,
        /^m/i,
        /^e/i,
        /^p/i,
        /^s/i
    ],
    any: [
        /^d/i,
        /^h/i,
        /^ma/i,
        /^më/i,
        /^e/i,
        /^p/i,
        /^s/i
    ]
};
var $3ab3c22137e19d9a$var$matchDayPeriodPatterns = {
    narrow: /^(p|m|me|në (mëngjes|mbasdite|mbrëmje|mesnatë))/i,
    any: /^([pm]\.?\s?d\.?|drek|në (mëngjes|mbasdite|mbrëmje|mesnatë))/i
};
var $3ab3c22137e19d9a$var$parseDayPeriodPatterns = {
    any: {
        am: /^p/i,
        pm: /^m/i,
        midnight: /^me/i,
        noon: /^dr/i,
        morning: /mëngjes/i,
        afternoon: /mbasdite/i,
        evening: /mbrëmje/i,
        night: /natë/i
    }
};
var $3ab3c22137e19d9a$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $3ab3c22137e19d9a$var$matchOrdinalNumberPattern,
        parsePattern: $3ab3c22137e19d9a$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $3ab3c22137e19d9a$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3ab3c22137e19d9a$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $3ab3c22137e19d9a$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3ab3c22137e19d9a$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $3ab3c22137e19d9a$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3ab3c22137e19d9a$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $3ab3c22137e19d9a$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $3ab3c22137e19d9a$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $3ab3c22137e19d9a$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $3ab3c22137e19d9a$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $3ab3c22137e19d9a$export$2e2bcd8739ae039 = $3ab3c22137e19d9a$var$match;

});


parcelRegister("7PZ4Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b4cacf362a140e8$export$2e2bcd8739ae039);

var $7XXw3 = parcelRequire("7XXw3");

var $lyMI1 = parcelRequire("lyMI1");

var $g55HP = parcelRequire("g55HP");

var $dxDSn = parcelRequire("dxDSn");

var $fKXmf = parcelRequire("fKXmf");
/**
 * @type {Locale}
 * @category Locales
 * @summary Serbian cyrillic locale.
 * @language Serbian
 * @iso-639-2 srp
 * @author Igor Radivojević [@rogyvoje]{@link https://github.com/rogyvoje}
 */ var $5b4cacf362a140e8$var$locale = {
    code: "sr",
    formatDistance: (0, $7XXw3.default),
    formatLong: (0, $lyMI1.default),
    formatRelative: (0, $g55HP.default),
    localize: (0, $dxDSn.default),
    match: (0, $fKXmf.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $5b4cacf362a140e8$export$2e2bcd8739ae039 = $5b4cacf362a140e8$var$locale;

});
parcelRegister("7XXw3", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ccc35ba5dd82357$export$2e2bcd8739ae039);
var $5ccc35ba5dd82357$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
            withPrepositionAgo: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
            withPrepositionIn: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u0441\u0435\u043A\u0443\u043D\u0434\u0443"
        },
        dual: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
        other: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    xSeconds: {
        one: {
            standalone: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            withPrepositionAgo: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
            withPrepositionIn: "1 \u0441\u0435\u043A\u0443\u043D\u0434\u0443"
        },
        dual: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0435",
        other: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438"
    },
    halfAMinute: "\u043F\u043E\u043B\u0430 \u043C\u0438\u043D\u0443\u0442\u0435",
    lessThanXMinutes: {
        one: {
            standalone: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u043C\u0438\u043D\u0443\u0442\u0435",
            withPrepositionAgo: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u043C\u0438\u043D\u0443\u0442\u0435",
            withPrepositionIn: "\u043C\u0430\u045A\u0435 \u043E\u0434 1 \u043C\u0438\u043D\u0443\u0442\u0443"
        },
        dual: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u043C\u0438\u043D\u0443\u0442\u0435",
        other: "\u043C\u0430\u045A\u0435 \u043E\u0434 {{count}} \u043C\u0438\u043D\u0443\u0442\u0430"
    },
    xMinutes: {
        one: {
            standalone: "1 \u043C\u0438\u043D\u0443\u0442\u0430",
            withPrepositionAgo: "1 \u043C\u0438\u043D\u0443\u0442\u0435",
            withPrepositionIn: "1 \u043C\u0438\u043D\u0443\u0442\u0443"
        },
        dual: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0435",
        other: "{{count}} \u043C\u0438\u043D\u0443\u0442\u0430"
    },
    aboutXHours: {
        one: {
            standalone: "\u043E\u043A\u043E 1 \u0441\u0430\u0442",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u0441\u0430\u0442",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u0441\u0430\u0442"
        },
        dual: "\u043E\u043A\u043E {{count}} \u0441\u0430\u0442\u0430",
        other: "\u043E\u043A\u043E {{count}} \u0441\u0430\u0442\u0438"
    },
    xHours: {
        one: {
            standalone: "1 \u0441\u0430\u0442",
            withPrepositionAgo: "1 \u0441\u0430\u0442",
            withPrepositionIn: "1 \u0441\u0430\u0442"
        },
        dual: "{{count}} \u0441\u0430\u0442\u0430",
        other: "{{count}} \u0441\u0430\u0442\u0438"
    },
    xDays: {
        one: {
            standalone: "1 \u0434\u0430\u043D",
            withPrepositionAgo: "1 \u0434\u0430\u043D",
            withPrepositionIn: "1 \u0434\u0430\u043D"
        },
        dual: "{{count}} \u0434\u0430\u043D\u0430",
        other: "{{count}} \u0434\u0430\u043D\u0430"
    },
    aboutXWeeks: {
        one: {
            standalone: "\u043E\u043A\u043E 1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u043D\u0435\u0434\u0435\u0459\u0443"
        },
        dual: "\u043E\u043A\u043E {{count}} \u043D\u0435\u0434\u0435\u0459\u0435",
        other: "\u043E\u043A\u043E {{count}} \u043D\u0435\u0434\u0435\u0459\u0435"
    },
    xWeeks: {
        one: {
            standalone: "1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionAgo: "1 \u043D\u0435\u0434\u0435\u0459\u0443",
            withPrepositionIn: "1 \u043D\u0435\u0434\u0435\u0459\u0443"
        },
        dual: "{{count}} \u043D\u0435\u0434\u0435\u0459\u0435",
        other: "{{count}} \u043D\u0435\u0434\u0435\u0459\u0435"
    },
    aboutXMonths: {
        one: {
            standalone: "\u043E\u043A\u043E 1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u043C\u0435\u0441\u0435\u0446"
        },
        dual: "\u043E\u043A\u043E {{count}} \u043C\u0435\u0441\u0435\u0446\u0430",
        other: "\u043E\u043A\u043E {{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
    },
    xMonths: {
        one: {
            standalone: "1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionAgo: "1 \u043C\u0435\u0441\u0435\u0446",
            withPrepositionIn: "1 \u043C\u0435\u0441\u0435\u0446"
        },
        dual: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0430",
        other: "{{count}} \u043C\u0435\u0441\u0435\u0446\u0438"
    },
    aboutXYears: {
        one: {
            standalone: "\u043E\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionAgo: "\u043E\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionIn: "\u043E\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "\u043E\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "\u043E\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
    },
    xYears: {
        one: {
            standalone: "1 \u0433\u043E\u0434\u0438\u043D\u0430",
            withPrepositionAgo: "1 \u0433\u043E\u0434\u0438\u043D\u0435",
            withPrepositionIn: "1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
    },
    overXYears: {
        one: {
            standalone: "\u043F\u0440\u0435\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionAgo: "\u043F\u0440\u0435\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionIn: "\u043F\u0440\u0435\u043A\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "\u043F\u0440\u0435\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "\u043F\u0440\u0435\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
    },
    almostXYears: {
        one: {
            standalone: "\u0433\u043E\u0442\u043E\u0432\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionAgo: "\u0433\u043E\u0442\u043E\u0432\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443",
            withPrepositionIn: "\u0433\u043E\u0442\u043E\u0432\u043E 1 \u0433\u043E\u0434\u0438\u043D\u0443"
        },
        dual: "\u0433\u043E\u0442\u043E\u0432\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0435",
        other: "\u0433\u043E\u0442\u043E\u0432\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0430"
    }
};
var $5ccc35ba5dd82357$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $5ccc35ba5dd82357$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== "1" // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace("{{count}}", String(count));
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0437\u0430 " + result;
        else return "\u043F\u0440\u0435 " + result;
    }
    return result;
};
var $5ccc35ba5dd82357$export$2e2bcd8739ae039 = $5ccc35ba5dd82357$var$formatDistance;

});

parcelRegister("lyMI1", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb228e87c8c38429$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $fb228e87c8c38429$var$dateFormats = {
    full: "EEEE, d. MMMM yyyy.",
    long: "d. MMMM yyyy.",
    medium: "d. MMM yy.",
    short: "dd. MM. yy."
};
var $fb228e87c8c38429$var$timeFormats = {
    full: "HH:mm:ss (zzzz)",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $fb228e87c8c38429$var$dateTimeFormats = {
    full: "{{date}} '\u0443' {{time}}",
    long: "{{date}} '\u0443' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $fb228e87c8c38429$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $fb228e87c8c38429$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $fb228e87c8c38429$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $fb228e87c8c38429$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $fb228e87c8c38429$export$2e2bcd8739ae039 = $fb228e87c8c38429$var$formatLong;

});

parcelRegister("g55HP", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb518a054ac359a2$export$2e2bcd8739ae039);
var $bb518a054ac359a2$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        var day = date.getUTCDay();
        switch(day){
            case 0:
                return "'\u043F\u0440\u043E\u0448\u043B\u0435 \u043D\u0435\u0434\u0435\u0459\u0435 \u0443' p";
            case 3:
                return "'\u043F\u0440\u043E\u0448\u043B\u0435 \u0441\u0440\u0435\u0434\u0435 \u0443' p";
            case 6:
                return "'\u043F\u0440\u043E\u0448\u043B\u0435 \u0441\u0443\u0431\u043E\u0442\u0435 \u0443' p";
            default:
                return "'\u043F\u0440\u043E\u0448\u043B\u0438' EEEE '\u0443' p";
        }
    },
    yesterday: "'\u0458\u0443\u0447\u0435 \u0443' p",
    today: "'\u0434\u0430\u043D\u0430\u0441 \u0443' p",
    tomorrow: "'\u0441\u0443\u0442\u0440\u0430 \u0443' p",
    nextWeek: function nextWeek(date) {
        var day = date.getUTCDay();
        switch(day){
            case 0:
                return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0435 \u043D\u0435\u0434\u0435\u0459\u0435 \u0443' p";
            case 3:
                return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0443 \u0441\u0440\u0435\u0434\u0443 \u0443' p";
            case 6:
                return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0443 \u0441\u0443\u0431\u043E\u0442\u0443 \u0443' p";
            default:
                return "'\u0441\u043B\u0435\u0434\u0435\u045B\u0438' EEEE '\u0443' p";
        }
    },
    other: "P"
};
var $bb518a054ac359a2$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $bb518a054ac359a2$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
var $bb518a054ac359a2$export$2e2bcd8739ae039 = $bb518a054ac359a2$var$formatRelative;

});

parcelRegister("dxDSn", function(module, exports) {

$parcel$export(module.exports, "default", () => $9dbd49fa0eb4513b$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $9dbd49fa0eb4513b$var$eraValues = {
    narrow: [
        "\u043F\u0440.\u043D.\u0435.",
        "\u0410\u0414"
    ],
    abbreviated: [
        "\u043F\u0440. \u0425\u0440.",
        "\u043F\u043E. \u0425\u0440."
    ],
    wide: [
        "\u041F\u0440\u0435 \u0425\u0440\u0438\u0441\u0442\u0430",
        "\u041F\u043E\u0441\u043B\u0435 \u0425\u0440\u0438\u0441\u0442\u0430"
    ]
};
var $9dbd49fa0eb4513b$var$quarterValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4."
    ],
    abbreviated: [
        "1. \u043A\u0432.",
        "2. \u043A\u0432.",
        "3. \u043A\u0432.",
        "4. \u043A\u0432."
    ],
    wide: [
        "1. \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2. \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3. \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4. \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var $9dbd49fa0eb4513b$var$monthValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4.",
        "5.",
        "6.",
        "7.",
        "8.",
        "9.",
        "10.",
        "11.",
        "12."
    ],
    abbreviated: [
        "\u0458\u0430\u043D",
        "\u0444\u0435\u0431",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043F",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u0432",
        "\u0434\u0435\u0446"
    ],
    wide: [
        "\u0458\u0430\u043D\u0443\u0430\u0440",
        "\u0444\u0435\u0431\u0440\u0443\u0430\u0440",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0438\u043B",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043F\u0442\u0435\u043C\u0431\u0430\u0440",
        "\u043E\u043A\u0442\u043E\u0431\u0430\u0440",
        "\u043D\u043E\u0432\u0435\u043C\u0431\u0430\u0440",
        "\u0434\u0435\u0446\u0435\u043C\u0431\u0430\u0440"
    ]
};
var $9dbd49fa0eb4513b$var$formattingMonthValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4.",
        "5.",
        "6.",
        "7.",
        "8.",
        "9.",
        "10.",
        "11.",
        "12."
    ],
    abbreviated: [
        "\u0458\u0430\u043D",
        "\u0444\u0435\u0431",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043F",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u0432",
        "\u0434\u0435\u0446"
    ],
    wide: [
        "\u0458\u0430\u043D\u0443\u0430\u0440",
        "\u0444\u0435\u0431\u0440\u0443\u0430\u0440",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0438\u043B",
        "\u043C\u0430\u0458",
        "\u0458\u0443\u043D",
        "\u0458\u0443\u043B",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043F\u0442\u0435\u043C\u0431\u0430\u0440",
        "\u043E\u043A\u0442\u043E\u0431\u0430\u0440",
        "\u043D\u043E\u0432\u0435\u043C\u0431\u0430\u0440",
        "\u0434\u0435\u0446\u0435\u043C\u0431\u0430\u0440"
    ]
};
var $9dbd49fa0eb4513b$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0423",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0443\u0442\u043E",
        "\u0441\u0440\u0435",
        "\u0447\u0435\u0442",
        "\u043F\u0435\u0442",
        "\u0441\u0443\u0431"
    ],
    abbreviated: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0443\u0442\u043E",
        "\u0441\u0440\u0435",
        "\u0447\u0435\u0442",
        "\u043F\u0435\u0442",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u043D\u0435\u0434\u0435\u0459\u0430",
        "\u043F\u043E\u043D\u0435\u0434\u0435\u0459\u0430\u043A",
        "\u0443\u0442\u043E\u0440\u0430\u043A",
        "\u0441\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0440\u0442\u0430\u043A",
        "\u043F\u0435\u0442\u0430\u043A",
        "\u0441\u0443\u0431\u043E\u0442\u0430"
    ]
};
var $9dbd49fa0eb4513b$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0410\u041C",
        pm: "\u041F\u041C",
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    },
    abbreviated: {
        am: "\u0410\u041C",
        pm: "\u041F\u041C",
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    }
};
var $9dbd49fa0eb4513b$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "\u043F\u043E\u043D\u043E\u045B",
        noon: "\u043F\u043E\u0434\u043D\u0435",
        morning: "\u0443\u0458\u0443\u0442\u0440\u0443",
        afternoon: "\u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u0434\u043D\u0435",
        evening: "\u0443\u0432\u0435\u0447\u0435",
        night: "\u043D\u043E\u045B\u0443"
    }
};
var $9dbd49fa0eb4513b$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + ".";
};
var $9dbd49fa0eb4513b$var$localize = {
    ordinalNumber: $9dbd49fa0eb4513b$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $9dbd49fa0eb4513b$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $9dbd49fa0eb4513b$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $9dbd49fa0eb4513b$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $9dbd49fa0eb4513b$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $9dbd49fa0eb4513b$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $9dbd49fa0eb4513b$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $9dbd49fa0eb4513b$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $9dbd49fa0eb4513b$export$2e2bcd8739ae039 = $9dbd49fa0eb4513b$var$localize;

});

parcelRegister("fKXmf", function(module, exports) {

$parcel$export(module.exports, "default", () => $b789321ceb9a377b$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $b789321ceb9a377b$var$matchOrdinalNumberPattern = /^(\d+)\./i;
var $b789321ceb9a377b$var$parseOrdinalNumberPattern = /\d+/i;
var $b789321ceb9a377b$var$matchEraPatterns = {
    narrow: /^(пр\.н\.е\.|АД)/i,
    abbreviated: /^(пр\.\s?Хр\.|по\.\s?Хр\.)/i,
    wide: /^(Пре Христа|пре нове ере|После Христа|нова ера)/i
};
var $b789321ceb9a377b$var$parseEraPatterns = {
    any: [
        /^пр/i,
        /^(по|нова)/i
    ]
};
var $b789321ceb9a377b$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?кв\.?/i,
    wide: /^[1234]\. квартал/i
};
var $b789321ceb9a377b$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $b789321ceb9a377b$var$matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(јан|феб|мар|апр|мај|јун|јул|авг|сеп|окт|нов|дец)/i,
    wide: /^((јануар|јануара)|(фебруар|фебруара)|(март|марта)|(април|априла)|(мја|маја)|(јун|јуна)|(јул|јула)|(август|августа)|(септембар|септембра)|(октобар|октобра)|(новембар|новембра)|(децембар|децембра))/i
};
var $b789321ceb9a377b$var$parseMonthPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ја/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^мај/i,
        /^јун/i,
        /^јул/i,
        /^авг/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ]
};
var $b789321ceb9a377b$var$matchDayPatterns = {
    narrow: /^[пусчн]/i,
    short: /^(нед|пон|уто|сре|чет|пет|суб)/i,
    abbreviated: /^(нед|пон|уто|сре|чет|пет|суб)/i,
    wide: /^(недеља|понедељак|уторак|среда|четвртак|петак|субота)/i
};
var $b789321ceb9a377b$var$parseDayPatterns = {
    narrow: [
        /^п/i,
        /^у/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i,
        /^н/i
    ],
    any: [
        /^нед/i,
        /^пон/i,
        /^уто/i,
        /^сре/i,
        /^чет/i,
        /^пет/i,
        /^суб/i
    ]
};
var $b789321ceb9a377b$var$matchDayPeriodPatterns = {
    any: /^(ам|пм|поноћ|(по)?подне|увече|ноћу|после подне|ујутру)/i
};
var $b789321ceb9a377b$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^поно/i,
        noon: /^под/i,
        morning: /ујутру/i,
        afternoon: /(после\s|по)+подне/i,
        evening: /(увече)/i,
        night: /(ноћу)/i
    }
};
var $b789321ceb9a377b$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $b789321ceb9a377b$var$matchOrdinalNumberPattern,
        parsePattern: $b789321ceb9a377b$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $b789321ceb9a377b$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b789321ceb9a377b$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $b789321ceb9a377b$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b789321ceb9a377b$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $b789321ceb9a377b$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b789321ceb9a377b$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $b789321ceb9a377b$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b789321ceb9a377b$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $b789321ceb9a377b$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $b789321ceb9a377b$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $b789321ceb9a377b$export$2e2bcd8739ae039 = $b789321ceb9a377b$var$match;

});


parcelRegister("cpWED", function(module, exports) {

$parcel$export(module.exports, "default", () => $90a5515f712ec265$export$2e2bcd8739ae039);

var $6S2GU = parcelRequire("6S2GU");

var $8lWuX = parcelRequire("8lWuX");

var $gVHPA = parcelRequire("gVHPA");

var $eL7Gs = parcelRequire("eL7Gs");

var $hO6k8 = parcelRequire("hO6k8");
/**
 * @type {Locale}
 * @category Locales
 * @summary Serbian latin locale.
 * @language Serbian
 * @iso-639-2 srp
 * @author Igor Radivojević [@rogyvoje]{@link https://github.com/rogyvoje}
 */ var $90a5515f712ec265$var$locale = {
    code: "sr-Latn",
    formatDistance: (0, $6S2GU.default),
    formatLong: (0, $8lWuX.default),
    formatRelative: (0, $gVHPA.default),
    localize: (0, $eL7Gs.default),
    match: (0, $hO6k8.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $90a5515f712ec265$export$2e2bcd8739ae039 = $90a5515f712ec265$var$locale;

});
parcelRegister("6S2GU", function(module, exports) {

$parcel$export(module.exports, "default", () => $5009df9e05f199b0$export$2e2bcd8739ae039);
var $5009df9e05f199b0$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            standalone: "manje od 1 sekunde",
            withPrepositionAgo: "manje od 1 sekunde",
            withPrepositionIn: "manje od 1 sekundu"
        },
        dual: "manje od {{count}} sekunde",
        other: "manje od {{count}} sekundi"
    },
    xSeconds: {
        one: {
            standalone: "1 sekunda",
            withPrepositionAgo: "1 sekunde",
            withPrepositionIn: "1 sekundu"
        },
        dual: "{{count}} sekunde",
        other: "{{count}} sekundi"
    },
    halfAMinute: "pola minute",
    lessThanXMinutes: {
        one: {
            standalone: "manje od 1 minute",
            withPrepositionAgo: "manje od 1 minute",
            withPrepositionIn: "manje od 1 minutu"
        },
        dual: "manje od {{count}} minute",
        other: "manje od {{count}} minuta"
    },
    xMinutes: {
        one: {
            standalone: "1 minuta",
            withPrepositionAgo: "1 minute",
            withPrepositionIn: "1 minutu"
        },
        dual: "{{count}} minute",
        other: "{{count}} minuta"
    },
    aboutXHours: {
        one: {
            standalone: "oko 1 sat",
            withPrepositionAgo: "oko 1 sat",
            withPrepositionIn: "oko 1 sat"
        },
        dual: "oko {{count}} sata",
        other: "oko {{count}} sati"
    },
    xHours: {
        one: {
            standalone: "1 sat",
            withPrepositionAgo: "1 sat",
            withPrepositionIn: "1 sat"
        },
        dual: "{{count}} sata",
        other: "{{count}} sati"
    },
    xDays: {
        one: {
            standalone: "1 dan",
            withPrepositionAgo: "1 dan",
            withPrepositionIn: "1 dan"
        },
        dual: "{{count}} dana",
        other: "{{count}} dana"
    },
    aboutXWeeks: {
        one: {
            standalone: "oko 1 nedelju",
            withPrepositionAgo: "oko 1 nedelju",
            withPrepositionIn: "oko 1 nedelju"
        },
        dual: "oko {{count}} nedelje",
        other: "oko {{count}} nedelje"
    },
    xWeeks: {
        one: {
            standalone: "1 nedelju",
            withPrepositionAgo: "1 nedelju",
            withPrepositionIn: "1 nedelju"
        },
        dual: "{{count}} nedelje",
        other: "{{count}} nedelje"
    },
    aboutXMonths: {
        one: {
            standalone: "oko 1 mesec",
            withPrepositionAgo: "oko 1 mesec",
            withPrepositionIn: "oko 1 mesec"
        },
        dual: "oko {{count}} meseca",
        other: "oko {{count}} meseci"
    },
    xMonths: {
        one: {
            standalone: "1 mesec",
            withPrepositionAgo: "1 mesec",
            withPrepositionIn: "1 mesec"
        },
        dual: "{{count}} meseca",
        other: "{{count}} meseci"
    },
    aboutXYears: {
        one: {
            standalone: "oko 1 godinu",
            withPrepositionAgo: "oko 1 godinu",
            withPrepositionIn: "oko 1 godinu"
        },
        dual: "oko {{count}} godine",
        other: "oko {{count}} godina"
    },
    xYears: {
        one: {
            standalone: "1 godina",
            withPrepositionAgo: "1 godine",
            withPrepositionIn: "1 godinu"
        },
        dual: "{{count}} godine",
        other: "{{count}} godina"
    },
    overXYears: {
        one: {
            standalone: "preko 1 godinu",
            withPrepositionAgo: "preko 1 godinu",
            withPrepositionIn: "preko 1 godinu"
        },
        dual: "preko {{count}} godine",
        other: "preko {{count}} godina"
    },
    almostXYears: {
        one: {
            standalone: "gotovo 1 godinu",
            withPrepositionAgo: "gotovo 1 godinu",
            withPrepositionIn: "gotovo 1 godinu"
        },
        dual: "gotovo {{count}} godine",
        other: "gotovo {{count}} godina"
    }
};
var $5009df9e05f199b0$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $5009df9e05f199b0$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) {
        if (options !== null && options !== void 0 && options.addSuffix) {
            if (options.comparison && options.comparison > 0) result = tokenValue.one.withPrepositionIn;
            else result = tokenValue.one.withPrepositionAgo;
        } else result = tokenValue.one.standalone;
    } else if (count % 10 > 1 && count % 10 < 5 && // if last digit is between 2 and 4
    String(count).substr(-2, 1) !== "1" // unless the 2nd to last digit is "1"
    ) result = tokenValue.dual.replace("{{count}}", String(count));
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "za " + result;
        else return "pre " + result;
    }
    return result;
};
var $5009df9e05f199b0$export$2e2bcd8739ae039 = $5009df9e05f199b0$var$formatDistance;

});

parcelRegister("8lWuX", function(module, exports) {

$parcel$export(module.exports, "default", () => $614da96d60c3db7d$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $614da96d60c3db7d$var$dateFormats = {
    full: "EEEE, d. MMMM yyyy.",
    long: "d. MMMM yyyy.",
    medium: "d. MMM yy.",
    short: "dd. MM. yy."
};
var $614da96d60c3db7d$var$timeFormats = {
    full: "HH:mm:ss (zzzz)",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $614da96d60c3db7d$var$dateTimeFormats = {
    full: "{{date}} 'u' {{time}}",
    long: "{{date}} 'u' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $614da96d60c3db7d$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $614da96d60c3db7d$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $614da96d60c3db7d$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $614da96d60c3db7d$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $614da96d60c3db7d$export$2e2bcd8739ae039 = $614da96d60c3db7d$var$formatLong;

});

parcelRegister("gVHPA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c533f8216eeb2645$export$2e2bcd8739ae039);
var $c533f8216eeb2645$var$formatRelativeLocale = {
    lastWeek: function lastWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'pro\u0161le nedelje u' p";
            case 3:
                return "'pro\u0161le srede u' p";
            case 6:
                return "'pro\u0161le subote u' p";
            default:
                return "'pro\u0161li' EEEE 'u' p";
        }
    },
    yesterday: "'ju\u010De u' p",
    today: "'danas u' p",
    tomorrow: "'sutra u' p",
    nextWeek: function nextWeek(date) {
        switch(date.getUTCDay()){
            case 0:
                return "'slede\u0107e nedelje u' p";
            case 3:
                return "'slede\u0107u sredu u' p";
            case 6:
                return "'slede\u0107u subotu u' p";
            default:
                return "'slede\u0107i' EEEE 'u' p";
        }
    },
    other: "P"
};
var $c533f8216eeb2645$var$formatRelative = function formatRelative(token, date, _baseDate, _options) {
    var format = $c533f8216eeb2645$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date);
    return format;
};
var $c533f8216eeb2645$export$2e2bcd8739ae039 = $c533f8216eeb2645$var$formatRelative;

});

parcelRegister("eL7Gs", function(module, exports) {

$parcel$export(module.exports, "default", () => $abeb6a4fce86fafd$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $abeb6a4fce86fafd$var$eraValues = {
    narrow: [
        "pr.n.e.",
        "AD"
    ],
    abbreviated: [
        "pr. Hr.",
        "po. Hr."
    ],
    wide: [
        "Pre Hrista",
        "Posle Hrista"
    ]
};
var $abeb6a4fce86fafd$var$quarterValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4."
    ],
    abbreviated: [
        "1. kv.",
        "2. kv.",
        "3. kv.",
        "4. kv."
    ],
    wide: [
        "1. kvartal",
        "2. kvartal",
        "3. kvartal",
        "4. kvartal"
    ]
};
var $abeb6a4fce86fafd$var$monthValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4.",
        "5.",
        "6.",
        "7.",
        "8.",
        "9.",
        "10.",
        "11.",
        "12."
    ],
    abbreviated: [
        "jan",
        "feb",
        "mar",
        "apr",
        "maj",
        "jun",
        "jul",
        "avg",
        "sep",
        "okt",
        "nov",
        "dec"
    ],
    wide: [
        "januar",
        "februar",
        "mart",
        "april",
        "maj",
        "jun",
        "jul",
        "avgust",
        "septembar",
        "oktobar",
        "novembar",
        "decembar"
    ]
};
var $abeb6a4fce86fafd$var$formattingMonthValues = {
    narrow: [
        "1.",
        "2.",
        "3.",
        "4.",
        "5.",
        "6.",
        "7.",
        "8.",
        "9.",
        "10.",
        "11.",
        "12."
    ],
    abbreviated: [
        "jan",
        "feb",
        "mar",
        "apr",
        "maj",
        "jun",
        "jul",
        "avg",
        "sep",
        "okt",
        "nov",
        "dec"
    ],
    wide: [
        "januar",
        "februar",
        "mart",
        "april",
        "maj",
        "jun",
        "jul",
        "avgust",
        "septembar",
        "oktobar",
        "novembar",
        "decembar"
    ]
};
var $abeb6a4fce86fafd$var$dayValues = {
    narrow: [
        "N",
        "P",
        "U",
        "S",
        "\u010C",
        "P",
        "S"
    ],
    short: [
        "ned",
        "pon",
        "uto",
        "sre",
        "\u010Det",
        "pet",
        "sub"
    ],
    abbreviated: [
        "ned",
        "pon",
        "uto",
        "sre",
        "\u010Det",
        "pet",
        "sub"
    ],
    wide: [
        "nedelja",
        "ponedeljak",
        "utorak",
        "sreda",
        "\u010Detvrtak",
        "petak",
        "subota"
    ]
};
var $abeb6a4fce86fafd$var$formattingDayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "posle podne",
        evening: "uve\u010De",
        night: "no\u0107u"
    }
};
var $abeb6a4fce86fafd$var$dayPeriodValues = {
    narrow: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "popodne",
        evening: "uve\u010De",
        night: "no\u0107u"
    },
    wide: {
        am: "AM",
        pm: "PM",
        midnight: "pono\u0107",
        noon: "podne",
        morning: "ujutru",
        afternoon: "posle podne",
        evening: "uve\u010De",
        night: "no\u0107u"
    }
};
var $abeb6a4fce86fafd$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + ".";
};
var $abeb6a4fce86fafd$var$localize = {
    ordinalNumber: $abeb6a4fce86fafd$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $abeb6a4fce86fafd$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $abeb6a4fce86fafd$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $abeb6a4fce86fafd$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $abeb6a4fce86fafd$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $abeb6a4fce86fafd$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $abeb6a4fce86fafd$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $abeb6a4fce86fafd$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $abeb6a4fce86fafd$export$2e2bcd8739ae039 = $abeb6a4fce86fafd$var$localize;

});

parcelRegister("hO6k8", function(module, exports) {

$parcel$export(module.exports, "default", () => $035873a8fdc68aa9$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $035873a8fdc68aa9$var$matchOrdinalNumberPattern = /^(\d+)\./i;
var $035873a8fdc68aa9$var$parseOrdinalNumberPattern = /\d+/i;
var $035873a8fdc68aa9$var$matchEraPatterns = {
    narrow: /^(pr\.n\.e\.|AD)/i,
    abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
    wide: /^(Pre Hrista|pre nove ere|Posle Hrista|nova era)/i
};
var $035873a8fdc68aa9$var$parseEraPatterns = {
    any: [
        /^pr/i,
        /^(po|nova)/i
    ]
};
var $035873a8fdc68aa9$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]\.\s?kv\.?/i,
    wide: /^[1234]\. kvartal/i
};
var $035873a8fdc68aa9$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $035873a8fdc68aa9$var$matchMonthPatterns = {
    narrow: /^(10|11|12|[123456789])\./i,
    abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
    wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(jun|juna)|(jul|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
};
var $035873a8fdc68aa9$var$parseMonthPatterns = {
    narrow: [
        /^1/i,
        /^2/i,
        /^3/i,
        /^4/i,
        /^5/i,
        /^6/i,
        /^7/i,
        /^8/i,
        /^9/i,
        /^10/i,
        /^11/i,
        /^12/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^avg/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $035873a8fdc68aa9$var$matchDayPatterns = {
    narrow: /^[npusčc]/i,
    short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
    wide: /^(nedelja|ponedeljak|utorak|sreda|(četvrtak|cetvrtak)|petak|subota)/i
};
var $035873a8fdc68aa9$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $035873a8fdc68aa9$var$matchDayPeriodPatterns = {
    any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|posle podne|ujutru)/i
};
var $035873a8fdc68aa9$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^pono/i,
        noon: /^pod/i,
        morning: /jutro/i,
        afternoon: /(posle\s|po)+podne/i,
        evening: /(uvece|uveče)/i,
        night: /(nocu|noću)/i
    }
};
var $035873a8fdc68aa9$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $035873a8fdc68aa9$var$matchOrdinalNumberPattern,
        parsePattern: $035873a8fdc68aa9$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $035873a8fdc68aa9$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $035873a8fdc68aa9$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $035873a8fdc68aa9$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $035873a8fdc68aa9$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $035873a8fdc68aa9$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $035873a8fdc68aa9$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $035873a8fdc68aa9$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $035873a8fdc68aa9$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $035873a8fdc68aa9$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $035873a8fdc68aa9$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $035873a8fdc68aa9$export$2e2bcd8739ae039 = $035873a8fdc68aa9$var$match;

});


parcelRegister("eNpFC", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac598de4e5111296$export$2e2bcd8739ae039);

var $iQZAB = parcelRequire("iQZAB");

var $ckvPn = parcelRequire("ckvPn");

var $fHjDo = parcelRequire("fHjDo");

var $dn4TT = parcelRequire("dn4TT");

var $iQNlR = parcelRequire("iQNlR");
/**
 * @type {Locale}
 * @category Locales
 * @summary Swedish locale.
 * @language Swedish
 * @iso-639-2 swe
 * @author Johannes Ulén [@ejulen]{@link https://github.com/ejulen}
 * @author Alexander Nanberg [@alexandernanberg]{@link https://github.com/alexandernanberg}
 * @author Henrik Andersson [@limelights]{@link https://github.com/limelights}
 */ var $ac598de4e5111296$var$locale = {
    code: "sv",
    formatDistance: (0, $iQZAB.default),
    formatLong: (0, $ckvPn.default),
    formatRelative: (0, $fHjDo.default),
    localize: (0, $dn4TT.default),
    match: (0, $iQNlR.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $ac598de4e5111296$export$2e2bcd8739ae039 = $ac598de4e5111296$var$locale;

});
parcelRegister("iQZAB", function(module, exports) {

$parcel$export(module.exports, "default", () => $db9cdbb2940071b1$export$2e2bcd8739ae039);
var $db9cdbb2940071b1$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "mindre \xe4n en sekund",
        other: "mindre \xe4n {{count}} sekunder"
    },
    xSeconds: {
        one: "en sekund",
        other: "{{count}} sekunder"
    },
    halfAMinute: "en halv minut",
    lessThanXMinutes: {
        one: "mindre \xe4n en minut",
        other: "mindre \xe4n {{count}} minuter"
    },
    xMinutes: {
        one: "en minut",
        other: "{{count}} minuter"
    },
    aboutXHours: {
        one: "ungef\xe4r en timme",
        other: "ungef\xe4r {{count}} timmar"
    },
    xHours: {
        one: "en timme",
        other: "{{count}} timmar"
    },
    xDays: {
        one: "en dag",
        other: "{{count}} dagar"
    },
    aboutXWeeks: {
        one: "ungef\xe4r en vecka",
        other: "ungef\xe4r {{count}} vecka"
    },
    xWeeks: {
        one: "en vecka",
        other: "{{count}} vecka"
    },
    aboutXMonths: {
        one: "ungef\xe4r en m\xe5nad",
        other: "ungef\xe4r {{count}} m\xe5nader"
    },
    xMonths: {
        one: "en m\xe5nad",
        other: "{{count}} m\xe5nader"
    },
    aboutXYears: {
        one: "ungef\xe4r ett \xe5r",
        other: "ungef\xe4r {{count}} \xe5r"
    },
    xYears: {
        one: "ett \xe5r",
        other: "{{count}} \xe5r"
    },
    overXYears: {
        one: "\xf6ver ett \xe5r",
        other: "\xf6ver {{count}} \xe5r"
    },
    almostXYears: {
        one: "n\xe4stan ett \xe5r",
        other: "n\xe4stan {{count}} \xe5r"
    }
};
var $db9cdbb2940071b1$var$wordMapping = [
    "noll",
    "en",
    "tv\xe5",
    "tre",
    "fyra",
    "fem",
    "sex",
    "sju",
    "\xe5tta",
    "nio",
    "tio",
    "elva",
    "tolv"
];
var $db9cdbb2940071b1$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $db9cdbb2940071b1$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else if (options && options.onlyNumeric) result = tokenValue.other.replace("{{count}}", String(count));
    else result = tokenValue.other.replace("{{count}}", count < 13 ? $db9cdbb2940071b1$var$wordMapping[count] : String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "om " + result;
        else return result + " sedan";
    }
    return result;
};
var $db9cdbb2940071b1$export$2e2bcd8739ae039 = $db9cdbb2940071b1$var$formatDistance;

});

parcelRegister("ckvPn", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fa00a94c697a7a4$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $8fa00a94c697a7a4$var$dateFormats = {
    full: "EEEE d MMMM y",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "y-MM-dd"
};
var $8fa00a94c697a7a4$var$timeFormats = {
    full: "'kl'. HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $8fa00a94c697a7a4$var$dateTimeFormats = {
    full: "{{date}} 'kl.' {{time}}",
    long: "{{date}} 'kl.' {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $8fa00a94c697a7a4$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $8fa00a94c697a7a4$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $8fa00a94c697a7a4$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $8fa00a94c697a7a4$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $8fa00a94c697a7a4$export$2e2bcd8739ae039 = $8fa00a94c697a7a4$var$formatLong;

});

parcelRegister("fHjDo", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6da1a2670b34694$export$2e2bcd8739ae039);
var $b6da1a2670b34694$var$formatRelativeLocale = {
    lastWeek: "'i' EEEE's kl.' p",
    yesterday: "'ig\xe5r kl.' p",
    today: "'idag kl.' p",
    tomorrow: "'imorgon kl.' p",
    nextWeek: "EEEE 'kl.' p",
    other: "P"
};
var $b6da1a2670b34694$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $b6da1a2670b34694$var$formatRelativeLocale[token];
};
var $b6da1a2670b34694$export$2e2bcd8739ae039 = $b6da1a2670b34694$var$formatRelative;

});

parcelRegister("dn4TT", function(module, exports) {

$parcel$export(module.exports, "default", () => $9bc1397852980bb8$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $9bc1397852980bb8$var$eraValues = {
    narrow: [
        "f.Kr.",
        "e.Kr."
    ],
    abbreviated: [
        "f.Kr.",
        "e.Kr."
    ],
    wide: [
        "f\xf6re Kristus",
        "efter Kristus"
    ]
};
var $9bc1397852980bb8$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1:a kvartalet",
        "2:a kvartalet",
        "3:e kvartalet",
        "4:e kvartalet"
    ]
};
var $9bc1397852980bb8$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "jan.",
        "feb.",
        "mars",
        "apr.",
        "maj",
        "juni",
        "juli",
        "aug.",
        "sep.",
        "okt.",
        "nov.",
        "dec."
    ],
    wide: [
        "januari",
        "februari",
        "mars",
        "april",
        "maj",
        "juni",
        "juli",
        "augusti",
        "september",
        "oktober",
        "november",
        "december"
    ]
};
var $9bc1397852980bb8$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "O",
        "T",
        "F",
        "L"
    ],
    short: [
        "s\xf6",
        "m\xe5",
        "ti",
        "on",
        "to",
        "fr",
        "l\xf6"
    ],
    abbreviated: [
        "s\xf6n",
        "m\xe5n",
        "tis",
        "ons",
        "tors",
        "fre",
        "l\xf6r"
    ],
    wide: [
        "s\xf6ndag",
        "m\xe5ndag",
        "tisdag",
        "onsdag",
        "torsdag",
        "fredag",
        "l\xf6rdag"
    ]
};
// https://www.unicode.org/cldr/charts/32/summary/sv.html#1888
var $9bc1397852980bb8$var$dayPeriodValues = {
    narrow: {
        am: "fm",
        pm: "em",
        midnight: "midnatt",
        noon: "middag",
        morning: "morg.",
        afternoon: "efterm.",
        evening: "kv\xe4ll",
        night: "natt"
    },
    abbreviated: {
        am: "f.m.",
        pm: "e.m.",
        midnight: "midnatt",
        noon: "middag",
        morning: "morgon",
        afternoon: "efterm.",
        evening: "kv\xe4ll",
        night: "natt"
    },
    wide: {
        am: "f\xf6rmiddag",
        pm: "eftermiddag",
        midnight: "midnatt",
        noon: "middag",
        morning: "morgon",
        afternoon: "eftermiddag",
        evening: "kv\xe4ll",
        night: "natt"
    }
};
var $9bc1397852980bb8$var$formattingDayPeriodValues = {
    narrow: {
        am: "fm",
        pm: "em",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 efterm.",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    },
    abbreviated: {
        am: "fm",
        pm: "em",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morg.",
        afternoon: "p\xe5 efterm.",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    },
    wide: {
        am: "fm",
        pm: "em",
        midnight: "midnatt",
        noon: "middag",
        morning: "p\xe5 morgonen",
        afternoon: "p\xe5 eftermiddagen",
        evening: "p\xe5 kv\xe4llen",
        night: "p\xe5 natten"
    }
};
var $9bc1397852980bb8$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
        case 2:
            return number + ":a";
    }
    return number + ":e";
};
var $9bc1397852980bb8$var$localize = {
    ordinalNumber: $9bc1397852980bb8$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $9bc1397852980bb8$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $9bc1397852980bb8$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $9bc1397852980bb8$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $9bc1397852980bb8$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $9bc1397852980bb8$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $9bc1397852980bb8$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $9bc1397852980bb8$export$2e2bcd8739ae039 = $9bc1397852980bb8$var$localize;

});

parcelRegister("iQNlR", function(module, exports) {

$parcel$export(module.exports, "default", () => $db935d85f576fefb$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $db935d85f576fefb$var$matchOrdinalNumberPattern = /^(\d+)(:a|:e)?/i;
var $db935d85f576fefb$var$parseOrdinalNumberPattern = /\d+/i;
var $db935d85f576fefb$var$matchEraPatterns = {
    narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
    abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
    wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
};
var $db935d85f576fefb$var$parseEraPatterns = {
    any: [
        /^f/i,
        /^[ev]/i
    ]
};
var $db935d85f576fefb$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](:a|:e)? kvartalet/i
};
var $db935d85f576fefb$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $db935d85f576fefb$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar[s]?|apr|maj|jun[i]?|jul[i]?|aug|sep|okt|nov|dec)\.?/i,
    wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
};
var $db935d85f576fefb$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^maj/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $db935d85f576fefb$var$matchDayPatterns = {
    narrow: /^[smtofl]/i,
    short: /^(sö|må|ti|on|to|fr|lö)/i,
    abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
    wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
};
var $db935d85f576fefb$var$parseDayPatterns = {
    any: [
        /^s/i,
        /^m/i,
        /^ti/i,
        /^o/i,
        /^to/i,
        /^f/i,
        /^l/i
    ]
};
var $db935d85f576fefb$var$matchDayPeriodPatterns = {
    any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
};
var $db935d85f576fefb$var$parseDayPeriodPatterns = {
    any: {
        am: /^f/i,
        pm: /^e/i,
        midnight: /^midn/i,
        noon: /^midd/i,
        morning: /morgon/i,
        afternoon: /eftermiddag/i,
        evening: /kväll/i,
        night: /natt/i
    }
};
var $db935d85f576fefb$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $db935d85f576fefb$var$matchOrdinalNumberPattern,
        parsePattern: $db935d85f576fefb$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $db935d85f576fefb$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $db935d85f576fefb$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $db935d85f576fefb$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $db935d85f576fefb$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $db935d85f576fefb$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $db935d85f576fefb$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $db935d85f576fefb$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $db935d85f576fefb$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $db935d85f576fefb$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $db935d85f576fefb$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $db935d85f576fefb$export$2e2bcd8739ae039 = $db935d85f576fefb$var$match;

});


parcelRegister("ajvdM", function(module, exports) {

$parcel$export(module.exports, "default", () => $7823e59ae0d10780$export$2e2bcd8739ae039);

var $d0EPq = parcelRequire("d0EPq");

var $11Plt = parcelRequire("11Plt");

var $ktYE5 = parcelRequire("ktYE5");

var $5iOyy = parcelRequire("5iOyy");

var $8xuo1 = parcelRequire("8xuo1");
/**
 * @type {Locale}
 * @category Locales
 * @summary Tamil locale (India).
 * @language Tamil
 * @iso-639-2 tam
 * @author Sibiraj [@sibiraj-s]{@link https://github.com/sibiraj-s}
 */ var $7823e59ae0d10780$var$locale = {
    code: "ta",
    formatDistance: (0, $d0EPq.default),
    formatLong: (0, $11Plt.default),
    formatRelative: (0, $ktYE5.default),
    localize: (0, $5iOyy.default),
    match: (0, $8xuo1.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $7823e59ae0d10780$export$2e2bcd8739ae039 = $7823e59ae0d10780$var$locale;

});
parcelRegister("d0EPq", function(module, exports) {

$parcel$export(module.exports, "default", () => $978af22431b48559$export$2e2bcd8739ae039);
function $978af22431b48559$var$isPluralType(val) {
    return val.one !== undefined;
}
var $978af22431b48559$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: {
            default: "\u0B92\u0BB0\u0BC1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BC1 \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "\u0B92\u0BB0\u0BC1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "\u0B92\u0BB0\u0BC1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xSeconds: {
        one: {
            default: "1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF",
            in: "1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0BAF\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BB5\u0BBF\u0BA8\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BB5\u0BBF\u0BA9\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BB5\u0BBF\u0BA8\u0BBE\u0B9F\u0BBF\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    halfAMinute: {
        default: "\u0B85\u0BB0\u0BC8 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD",
        in: "\u0B85\u0BB0\u0BC8 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
        ago: "\u0B85\u0BB0\u0BC8 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
    },
    lessThanXMinutes: {
        one: {
            default: "\u0B92\u0BB0\u0BC1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "\u0B92\u0BB0\u0BC1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "\u0B92\u0BB0\u0BC1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0B95\u0BC1\u0BB1\u0BC8\u0BB5\u0BBE\u0B95",
            in: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BB3\u0BCD",
            ago: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xMinutes: {
        one: {
            default: "1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD",
            in: "1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BA8\u0BBF\u0BAE\u0BBF\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    aboutXHours: {
        one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD"
        }
    },
    xHours: {
        one: {
            default: "1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BAE\u0BCD",
            in: "{{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BAE\u0BA3\u0BBF \u0BA8\u0BC7\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xDays: {
        one: {
            default: "1 \u0BA8\u0BBE\u0BB3\u0BCD",
            in: "1 \u0BA8\u0BBE\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BA8\u0BBE\u0BB3\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    aboutXWeeks: {
        one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BBE\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xWeeks: {
        one: {
            default: "1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD",
            in: "1 \u0BB5\u0BBE\u0BB0\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BB5\u0BBE\u0BB0\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BB5\u0BBE\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    aboutXMonths: {
        one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BBE\u0BA4\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BBE\u0BA4\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BAE\u0BBE\u0BA4\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xMonths: {
        one: {
            default: "1 \u0BAE\u0BBE\u0BA4\u0BAE\u0BCD",
            in: "1 \u0BAE\u0BBE\u0BA4\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BAE\u0BBE\u0BA4\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0BAE\u0BBE\u0BA4\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    aboutXYears: {
        one: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0B86\u0BA3\u0BCD\u0B9F\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD",
            in: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B9A\u0BC1\u0BAE\u0BBE\u0BB0\u0BCD {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    xYears: {
        one: {
            default: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD",
            in: "1 \u0B86\u0BA3\u0BCD\u0B9F\u0BBF\u0BB2\u0BCD",
            ago: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD",
            in: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    overXYears: {
        one: {
            default: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1 \u0BAE\u0BC7\u0BB2\u0BCD",
            in: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BA4\u0BCD\u0BA4\u0BBF\u0BB1\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0BAE\u0BC7\u0BB2\u0BBE\u0B95",
            ago: "1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0BAE\u0BC7\u0BB2\u0BBE\u0B95",
            in: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "{{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    },
    almostXYears: {
        one: {
            default: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD",
            in: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F 1 \u0B86\u0BA3\u0BCD\u0B9F\u0BBF\u0BB2\u0BCD",
            ago: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F 1 \u0BB5\u0BB0\u0BC1\u0B9F\u0BAE\u0BCD \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        },
        other: {
            default: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BCD",
            in: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD",
            ago: "\u0B95\u0BBF\u0B9F\u0BCD\u0B9F\u0BA4\u0BCD\u0BA4\u0B9F\u0BCD\u0B9F {{count}} \u0B86\u0BA3\u0BCD\u0B9F\u0BC1\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1"
        }
    }
};
var $978af22431b48559$var$formatDistance = function formatDistance(token, count, options) {
    var tense = options !== null && options !== void 0 && options.addSuffix ? options.comparison && options.comparison > 0 ? "in" : "ago" : "default";
    var tokenValue = $978af22431b48559$var$formatDistanceLocale[token];
    if (!$978af22431b48559$var$isPluralType(tokenValue)) return tokenValue[tense];
    if (count === 1) return tokenValue.one[tense];
    else return tokenValue.other[tense].replace("{{count}}", String(count));
};
var $978af22431b48559$export$2e2bcd8739ae039 = $978af22431b48559$var$formatDistance;

});

parcelRegister("11Plt", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bfdb6932b8a93ca$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
// CLDR #1846 - #1849
var $0bfdb6932b8a93ca$var$dateFormats = {
    full: "EEEE, d MMMM, y",
    long: "d MMMM, y",
    medium: "d MMM, y",
    short: "d/M/yy"
};
// CLDR #1850 - #1853
var $0bfdb6932b8a93ca$var$timeFormats = {
    full: "a h:mm:ss zzzz",
    long: "a h:mm:ss z",
    medium: "a h:mm:ss",
    short: "a h:mm"
};
var $0bfdb6932b8a93ca$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $0bfdb6932b8a93ca$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $0bfdb6932b8a93ca$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $0bfdb6932b8a93ca$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $0bfdb6932b8a93ca$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $0bfdb6932b8a93ca$export$2e2bcd8739ae039 = $0bfdb6932b8a93ca$var$formatLong;

});

parcelRegister("ktYE5", function(module, exports) {

$parcel$export(module.exports, "default", () => $03d91f35d9eb3eff$export$2e2bcd8739ae039);
var $03d91f35d9eb3eff$var$formatRelativeLocale = {
    lastWeek: "'\u0B95\u0B9F\u0BA8\u0BCD\u0BA4' eeee p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    yesterday: "'\u0BA8\u0BC7\u0BB1\u0BCD\u0BB1\u0BC1 ' p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    today: "'\u0B87\u0BA9\u0BCD\u0BB1\u0BC1 ' p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    tomorrow: "'\u0BA8\u0BBE\u0BB3\u0BC8 ' p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    nextWeek: "eeee p '\u0BAE\u0BA3\u0BBF\u0B95\u0BCD\u0B95\u0BC1'",
    other: "P"
};
var $03d91f35d9eb3eff$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $03d91f35d9eb3eff$var$formatRelativeLocale[token];
};
var $03d91f35d9eb3eff$export$2e2bcd8739ae039 = $03d91f35d9eb3eff$var$formatRelative;

});

parcelRegister("5iOyy", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dc5d9a4974bafdc$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $3dc5d9a4974bafdc$var$eraValues = {
    narrow: [
        "\u0B95\u0BBF.\u0BAE\u0BC1.",
        "\u0B95\u0BBF.\u0BAA\u0BBF."
    ],
    abbreviated: [
        "\u0B95\u0BBF.\u0BAE\u0BC1.",
        "\u0B95\u0BBF.\u0BAA\u0BBF."
    ],
    // CLDR #1624, #1626
    wide: [
        "\u0B95\u0BBF\u0BB1\u0BBF\u0BB8\u0BCD\u0BA4\u0BC1\u0BB5\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD",
        "\u0B85\u0BA9\u0BCD\u0BA9\u0BCB \u0B9F\u0BCB\u0BAE\u0BBF\u0BA9\u0BBF"
    ] // CLDR #1620, #1622
};
var $3dc5d9a4974bafdc$var$quarterValues = {
    // CLDR #1644 - #1647
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    // CLDR #1636 - #1639
    abbreviated: [
        "\u0B95\u0BBE\u0BB2\u0BBE.1",
        "\u0B95\u0BBE\u0BB2\u0BBE.2",
        "\u0B95\u0BBE\u0BB2\u0BBE.3",
        "\u0B95\u0BBE\u0BB2\u0BBE.4"
    ],
    // CLDR #1628 - #1631
    wide: [
        "\u0B92\u0BA9\u0BCD\u0BB1\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1",
        "\u0B87\u0BB0\u0BA3\u0BCD\u0B9F\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1",
        "\u0BAE\u0BC2\u0BA9\u0BCD\u0BB1\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1",
        "\u0BA8\u0BBE\u0BA9\u0BCD\u0B95\u0BBE\u0BAE\u0BCD \u0B95\u0BBE\u0BB2\u0BBE\u0BA3\u0BCD\u0B9F\u0BC1"
    ]
};
var $3dc5d9a4974bafdc$var$monthValues = {
    // CLDR #700 - #711
    narrow: [
        "\u0B9C",
        "\u0BAA\u0BBF",
        "\u0BAE\u0BBE",
        "\u0B8F",
        "\u0BAE\u0BC7",
        "\u0B9C\u0BC2",
        "\u0B9C\u0BC2",
        "\u0B86",
        "\u0B9A\u0BC6",
        "\u0B85",
        "\u0BA8",
        "\u0B9F\u0BBF"
    ],
    // CLDR #1676 - #1687
    abbreviated: [
        "\u0B9C\u0BA9.",
        "\u0BAA\u0BBF\u0BAA\u0BCD.",
        "\u0BAE\u0BBE\u0BB0\u0BCD.",
        "\u0B8F\u0BAA\u0BCD.",
        "\u0BAE\u0BC7",
        "\u0B9C\u0BC2\u0BA9\u0BCD",
        "\u0B9C\u0BC2\u0BB2\u0BC8",
        "\u0B86\u0B95.",
        "\u0B9A\u0BC6\u0BAA\u0BCD.",
        "\u0B85\u0B95\u0BCD.",
        "\u0BA8\u0BB5.",
        "\u0B9F\u0BBF\u0B9A."
    ],
    // CLDR #1652 - #1663
    wide: [
        "\u0B9C\u0BA9\u0BB5\u0BB0\u0BBF",
        // January
        "\u0BAA\u0BBF\u0BAA\u0BCD\u0BB0\u0BB5\u0BB0\u0BBF",
        // February
        "\u0BAE\u0BBE\u0BB0\u0BCD\u0B9A\u0BCD",
        // March
        "\u0B8F\u0BAA\u0BCD\u0BB0\u0BB2\u0BCD",
        // April
        "\u0BAE\u0BC7",
        // May
        "\u0B9C\u0BC2\u0BA9\u0BCD",
        // June
        "\u0B9C\u0BC2\u0BB2\u0BC8",
        // July
        "\u0B86\u0B95\u0BB8\u0BCD\u0B9F\u0BCD",
        // August
        "\u0B9A\u0BC6\u0BAA\u0BCD\u0B9F\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD",
        // September
        "\u0B85\u0B95\u0BCD\u0B9F\u0BCB\u0BAA\u0BB0\u0BCD",
        // October
        "\u0BA8\u0BB5\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD",
        // November
        "\u0B9F\u0BBF\u0B9A\u0BAE\u0BCD\u0BAA\u0BB0\u0BCD" // December
    ]
};
var $3dc5d9a4974bafdc$var$dayValues = {
    // CLDR #1766 - #1772
    narrow: [
        "\u0B9E\u0BBE",
        "\u0BA4\u0BBF",
        "\u0B9A\u0BC6",
        "\u0BAA\u0BC1",
        "\u0BB5\u0BBF",
        "\u0BB5\u0BC6",
        "\u0B9A"
    ],
    // CLDR #1752 - #1758
    short: [
        "\u0B9E\u0BBE",
        "\u0BA4\u0BBF",
        "\u0B9A\u0BC6",
        "\u0BAA\u0BC1",
        "\u0BB5\u0BBF",
        "\u0BB5\u0BC6",
        "\u0B9A"
    ],
    // CLDR #1738 - #1744
    abbreviated: [
        "\u0B9E\u0BBE\u0BAF\u0BBF.",
        "\u0BA4\u0BBF\u0B99\u0BCD.",
        "\u0B9A\u0BC6\u0BB5\u0BCD.",
        "\u0BAA\u0BC1\u0BA4.",
        "\u0BB5\u0BBF\u0BAF\u0BBE.",
        "\u0BB5\u0BC6\u0BB3\u0BCD.",
        "\u0B9A\u0BA9\u0BBF"
    ],
    // CLDR #1724 - #1730
    wide: [
        "\u0B9E\u0BBE\u0BAF\u0BBF\u0BB1\u0BC1",
        // Sunday
        "\u0BA4\u0BBF\u0B99\u0BCD\u0B95\u0BB3\u0BCD",
        // Monday
        "\u0B9A\u0BC6\u0BB5\u0BCD\u0BB5\u0BBE\u0BAF\u0BCD",
        // Tuesday
        "\u0BAA\u0BC1\u0BA4\u0BA9\u0BCD",
        // Wednesday
        "\u0BB5\u0BBF\u0BAF\u0BBE\u0BB4\u0BA9\u0BCD",
        // Thursday
        "\u0BB5\u0BC6\u0BB3\u0BCD\u0BB3\u0BBF",
        // Friday
        "\u0B9A\u0BA9\u0BBF" // Saturday
    ]
};
// CLDR #1780 - #1845
var $3dc5d9a4974bafdc$var$dayPeriodValues = {
    narrow: {
        am: "\u0BAE\u0BC1.\u0BAA",
        pm: "\u0BAA\u0BBF.\u0BAA",
        midnight: "\u0BA8\u0BB3\u0BCD.",
        noon: "\u0BA8\u0BA3\u0BCD.",
        morning: "\u0B95\u0BBE.",
        afternoon: "\u0BAE\u0BA4\u0BBF.",
        evening: "\u0BAE\u0BBE.",
        night: "\u0B87\u0BB0."
    },
    abbreviated: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
    },
    wide: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
    }
};
// CLDR #1780 - #1845
var $3dc5d9a4974bafdc$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0BAE\u0BC1.\u0BAA",
        pm: "\u0BAA\u0BBF.\u0BAA",
        midnight: "\u0BA8\u0BB3\u0BCD.",
        noon: "\u0BA8\u0BA3\u0BCD.",
        morning: "\u0B95\u0BBE.",
        afternoon: "\u0BAE\u0BA4\u0BBF.",
        evening: "\u0BAE\u0BBE.",
        night: "\u0B87\u0BB0."
    },
    abbreviated: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
    },
    wide: {
        am: "\u0BAE\u0BC1\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        pm: "\u0BAA\u0BBF\u0BB1\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        midnight: "\u0BA8\u0BB3\u0BCD\u0BB3\u0BBF\u0BB0\u0BB5\u0BC1",
        noon: "\u0BA8\u0BA3\u0BCD\u0BAA\u0B95\u0BB2\u0BCD",
        morning: "\u0B95\u0BBE\u0BB2\u0BC8",
        afternoon: "\u0BAE\u0BA4\u0BBF\u0BAF\u0BAE\u0BCD",
        evening: "\u0BAE\u0BBE\u0BB2\u0BC8",
        night: "\u0B87\u0BB0\u0BB5\u0BC1"
    }
};
var $3dc5d9a4974bafdc$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $3dc5d9a4974bafdc$var$localize = {
    ordinalNumber: $3dc5d9a4974bafdc$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $3dc5d9a4974bafdc$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $3dc5d9a4974bafdc$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $3dc5d9a4974bafdc$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $3dc5d9a4974bafdc$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $3dc5d9a4974bafdc$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $3dc5d9a4974bafdc$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $3dc5d9a4974bafdc$export$2e2bcd8739ae039 = $3dc5d9a4974bafdc$var$localize;

});

parcelRegister("8xuo1", function(module, exports) {

$parcel$export(module.exports, "default", () => $6378f9eb3634bf1d$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $6378f9eb3634bf1d$var$matchOrdinalNumberPattern = /^(\d+)(வது)?/i;
var $6378f9eb3634bf1d$var$parseOrdinalNumberPattern = /\d+/i;
var $6378f9eb3634bf1d$var$matchEraPatterns = {
    narrow: /^(கி.மு.|கி.பி.)/i,
    abbreviated: /^(கி\.?\s?மு\.?|கி\.?\s?பி\.?)/,
    wide: /^(கிறிஸ்துவுக்கு\sமுன்|அன்னோ\sடோமினி)/i
};
var $6378f9eb3634bf1d$var$parseEraPatterns = {
    any: [
        /கி\.?\s?மு\.?/,
        /கி\.?\s?பி\.?/
    ]
};
var $6378f9eb3634bf1d$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^காலா.[1234]/i,
    wide: /^(ஒன்றாம்|இரண்டாம்|மூன்றாம்|நான்காம்) காலாண்டு/i
};
var $6378f9eb3634bf1d$var$parseQuarterPatterns = {
    narrow: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    any: [
        /(1|காலா.1|ஒன்றாம்)/i,
        /(2|காலா.2|இரண்டாம்)/i,
        /(3|காலா.3|மூன்றாம்)/i,
        /(4|காலா.4|நான்காம்)/i
    ]
};
var $6378f9eb3634bf1d$var$matchMonthPatterns = {
    narrow: /^(ஜ|பி|மா|ஏ|மே|ஜூ|ஆ|செ|அ|ந|டி)$/i,
    abbreviated: /^(ஜன.|பிப்.|மார்.|ஏப்.|மே|ஜூன்|ஜூலை|ஆக.|செப்.|அக்.|நவ.|டிச.)/i,
    wide: /^(ஜனவரி|பிப்ரவரி|மார்ச்|ஏப்ரல்|மே|ஜூன்|ஜூலை|ஆகஸ்ட்|செப்டம்பர்|அக்டோபர்|நவம்பர்|டிசம்பர்)/i
};
var $6378f9eb3634bf1d$var$parseMonthPatterns = {
    narrow: [
        /^ஜ$/i,
        /^பி/i,
        /^மா/i,
        /^ஏ/i,
        /^மே/i,
        /^ஜூ/i,
        /^ஜூ/i,
        /^ஆ/i,
        /^செ/i,
        /^அ/i,
        /^ந/i,
        /^டி/i
    ],
    any: [
        /^ஜன/i,
        /^பி/i,
        /^மா/i,
        /^ஏ/i,
        /^மே/i,
        /^ஜூன்/i,
        /^ஜூலை/i,
        /^ஆ/i,
        /^செ/i,
        /^அ/i,
        /^ந/i,
        /^டி/i
    ]
};
var $6378f9eb3634bf1d$var$matchDayPatterns = {
    narrow: /^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
    short: /^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
    abbreviated: /^(ஞாயி.|திங்.|செவ்.|புத.|வியா.|வெள்.|சனி)/i,
    wide: /^(ஞாயிறு|திங்கள்|செவ்வாய்|புதன்|வியாழன்|வெள்ளி|சனி)/i
};
var $6378f9eb3634bf1d$var$parseDayPatterns = {
    narrow: [
        /^ஞா/i,
        /^தி/i,
        /^செ/i,
        /^பு/i,
        /^வி/i,
        /^வெ/i,
        /^ச/i
    ],
    any: [
        /^ஞா/i,
        /^தி/i,
        /^செ/i,
        /^பு/i,
        /^வி/i,
        /^வெ/i,
        /^ச/i
    ]
};
var $6378f9eb3634bf1d$var$matchDayPeriodPatterns = {
    narrow: /^(மு.ப|பி.ப|நள்|நண்|காலை|மதியம்|மாலை|இரவு)/i,
    any: /^(மு.ப|பி.ப|முற்பகல்|பிற்பகல்|நள்ளிரவு|நண்பகல்|காலை|மதியம்|மாலை|இரவு)/i
};
var $6378f9eb3634bf1d$var$parseDayPeriodPatterns = {
    any: {
        am: /^மு/i,
        pm: /^பி/i,
        midnight: /^நள்/i,
        noon: /^நண்/i,
        morning: /காலை/i,
        afternoon: /மதியம்/i,
        evening: /மாலை/i,
        night: /இரவு/i
    }
};
var $6378f9eb3634bf1d$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $6378f9eb3634bf1d$var$matchOrdinalNumberPattern,
        parsePattern: $6378f9eb3634bf1d$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $6378f9eb3634bf1d$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6378f9eb3634bf1d$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $6378f9eb3634bf1d$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6378f9eb3634bf1d$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $6378f9eb3634bf1d$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6378f9eb3634bf1d$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $6378f9eb3634bf1d$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $6378f9eb3634bf1d$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $6378f9eb3634bf1d$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $6378f9eb3634bf1d$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $6378f9eb3634bf1d$export$2e2bcd8739ae039 = $6378f9eb3634bf1d$var$match;

});


parcelRegister("a83pb", function(module, exports) {

$parcel$export(module.exports, "default", () => $75fd4af151d756ca$export$2e2bcd8739ae039);

var $jJH5w = parcelRequire("jJH5w");

var $e4rpt = parcelRequire("e4rpt");

var $hPy1G = parcelRequire("hPy1G");

var $aE08g = parcelRequire("aE08g");

var $kPw48 = parcelRequire("kPw48");
/**
 * @type {Locale}
 * @category Locales
 * @summary Telugu locale
 * @language Telugu
 * @iso-639-2 tel
 * @author Kranthi Lakum [@kranthilakum]{@link https://github.com/kranthilakum}
 */ var $75fd4af151d756ca$var$locale = {
    code: "te",
    formatDistance: (0, $jJH5w.default),
    formatLong: (0, $e4rpt.default),
    formatRelative: (0, $hPy1G.default),
    localize: (0, $aE08g.default),
    match: (0, $kPw48.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $75fd4af151d756ca$export$2e2bcd8739ae039 = $75fd4af151d756ca$var$locale;

});
parcelRegister("jJH5w", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5e3a4ae1dbbd03c$export$2e2bcd8739ae039);
// Source: https://www.unicode.org/cldr/charts/32/summary/te.html
var $e5e3a4ae1dbbd03c$var$formatDistanceLocale = {
    lessThanXSeconds: {
        standalone: {
            one: "\u0C38\u0C46\u0C15\u0C28\u0C41 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35",
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35"
        },
        withPreposition: {
            one: "\u0C38\u0C46\u0C15\u0C28\u0C41",
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32"
        }
    },
    xSeconds: {
        standalone: {
            one: "\u0C12\u0C15 \u0C38\u0C46\u0C15\u0C28\u0C41",
            // CLDR #1314
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C38\u0C46\u0C15\u0C28\u0C41",
            other: "{{count}} \u0C38\u0C46\u0C15\u0C28\u0C4D\u0C32"
        }
    },
    halfAMinute: {
        standalone: "\u0C05\u0C30 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
        withPreposition: "\u0C05\u0C30 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02"
    },
    lessThanXMinutes: {
        standalone: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35",
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32 \u0C15\u0C28\u0C4D\u0C28\u0C3E \u0C24\u0C15\u0C4D\u0C15\u0C41\u0C35"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32"
        }
    },
    xMinutes: {
        standalone: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
            // CLDR #1311
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C02",
            // CLDR #1311
            other: "{{count}} \u0C28\u0C3F\u0C2E\u0C3F\u0C37\u0C3E\u0C32"
        }
    },
    aboutXHours: {
        standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C17\u0C02\u0C1F",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C17\u0C02\u0C1F\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C17\u0C02\u0C1F",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C17\u0C02\u0C1F\u0C32"
        }
    },
    xHours: {
        standalone: {
            one: "\u0C12\u0C15 \u0C17\u0C02\u0C1F",
            // CLDR #1308
            other: "{{count}} \u0C17\u0C02\u0C1F\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C17\u0C02\u0C1F",
            other: "{{count}} \u0C17\u0C02\u0C1F\u0C32"
        }
    },
    xDays: {
        standalone: {
            one: "\u0C12\u0C15 \u0C30\u0C4B\u0C1C\u0C41",
            // CLDR #1292
            other: "{{count}} \u0C30\u0C4B\u0C1C\u0C41\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C30\u0C4B\u0C1C\u0C41",
            other: "{{count}} \u0C30\u0C4B\u0C1C\u0C41\u0C32"
        }
    },
    aboutXWeeks: {
        standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C32"
        }
    },
    xWeeks: {
        standalone: {
            one: "\u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "{{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C35\u0C3E\u0C30\u0C02",
            other: "{{count}} \u0C35\u0C3E\u0C30\u0C3E\u0C32\u0C32"
        }
    },
    aboutXMonths: {
        standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C28\u0C46\u0C32",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C28\u0C46\u0C32\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C28\u0C46\u0C32",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C28\u0C46\u0C32\u0C32"
        }
    },
    xMonths: {
        standalone: {
            one: "\u0C12\u0C15 \u0C28\u0C46\u0C32",
            // CLDR #1281
            other: "{{count}} \u0C28\u0C46\u0C32\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C28\u0C46\u0C32",
            other: "{{count}} \u0C28\u0C46\u0C32\u0C32"
        }
    },
    aboutXYears: {
        standalone: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C38\u0C41\u0C2E\u0C3E\u0C30\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
    },
    xYears: {
        standalone: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            // CLDR #1275
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
    },
    overXYears: {
        standalone: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02 \u0C2A\u0C48\u0C17\u0C3E",
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C15\u0C41 \u0C2A\u0C48\u0C17\u0C3E"
        },
        withPreposition: {
            one: "\u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "{{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
    },
    almostXYears: {
        standalone: {
            one: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32\u0C41"
        },
        withPreposition: {
            one: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 \u0C12\u0C15 \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C02",
            other: "\u0C26\u0C3E\u0C26\u0C3E\u0C2A\u0C41 {{count}} \u0C38\u0C02\u0C35\u0C24\u0C4D\u0C38\u0C30\u0C3E\u0C32"
        }
    }
};
var $e5e3a4ae1dbbd03c$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = options !== null && options !== void 0 && options.addSuffix ? $e5e3a4ae1dbbd03c$var$formatDistanceLocale[token].withPreposition : $e5e3a4ae1dbbd03c$var$formatDistanceLocale[token].standalone;
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u0C32\u0C4B";
        else return result + " \u0C15\u0C4D\u0C30\u0C3F\u0C24\u0C02";
    }
    return result;
};
var $e5e3a4ae1dbbd03c$export$2e2bcd8739ae039 = $e5e3a4ae1dbbd03c$var$formatDistance;

});

parcelRegister("e4rpt", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3e6b374705053ed$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
// CLDR #1807 - #1811
var $a3e6b374705053ed$var$dateFormats = {
    full: "d, MMMM y, EEEE",
    long: "d MMMM, y",
    medium: "d MMM, y",
    short: "dd-MM-yy"
};
// CLDR #1807 - #1811
var $a3e6b374705053ed$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
// CLDR #1815 - #1818
var $a3e6b374705053ed$var$dateTimeFormats = {
    full: "{{date}} {{time}}'\u0C15\u0C3F'",
    long: "{{date}} {{time}}'\u0C15\u0C3F'",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $a3e6b374705053ed$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $a3e6b374705053ed$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $a3e6b374705053ed$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $a3e6b374705053ed$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $a3e6b374705053ed$export$2e2bcd8739ae039 = $a3e6b374705053ed$var$formatLong;

});

parcelRegister("hPy1G", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfb197faa92ac2d1$export$2e2bcd8739ae039);
// Source: https://www.unicode.org/cldr/charts/32/summary/te.html
var $cfb197faa92ac2d1$var$formatRelativeLocale = {
    lastWeek: "'\u0C17\u0C24' eeee p",
    // CLDR #1384
    yesterday: "'\u0C28\u0C3F\u0C28\u0C4D\u0C28' p",
    // CLDR #1393
    today: "'\u0C08 \u0C30\u0C4B\u0C1C\u0C41' p",
    // CLDR #1394
    tomorrow: "'\u0C30\u0C47\u0C2A\u0C41' p",
    // CLDR #1395
    nextWeek: "'\u0C24\u0C26\u0C41\u0C2A\u0C30\u0C3F' eeee p",
    // CLDR #1386
    other: "P"
};
var $cfb197faa92ac2d1$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $cfb197faa92ac2d1$var$formatRelativeLocale[token];
};
var $cfb197faa92ac2d1$export$2e2bcd8739ae039 = $cfb197faa92ac2d1$var$formatRelative;

});

parcelRegister("aE08g", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bfdbe19d0d450a7$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
// Source: https://dsal.uchicago.edu/dictionaries/brown/
// CLDR #1605 - #1608
var $7bfdbe19d0d450a7$var$eraValues = {
    narrow: [
        "\u0C15\u0C4D\u0C30\u0C40.\u0C2A\u0C42.",
        "\u0C15\u0C4D\u0C30\u0C40.\u0C36."
    ],
    abbreviated: [
        "\u0C15\u0C4D\u0C30\u0C40.\u0C2A\u0C42.",
        "\u0C15\u0C4D\u0C30\u0C40.\u0C36."
    ],
    wide: [
        "\u0C15\u0C4D\u0C30\u0C40\u0C38\u0C4D\u0C24\u0C41 \u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C02",
        "\u0C15\u0C4D\u0C30\u0C40\u0C38\u0C4D\u0C24\u0C41\u0C36\u0C15\u0C02"
    ]
};
// CLDR #1613 - #1628
var $7bfdbe19d0d450a7$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u0C24\u0C4D\u0C30\u0C481",
        "\u0C24\u0C4D\u0C30\u0C482",
        "\u0C24\u0C4D\u0C30\u0C483",
        "\u0C24\u0C4D\u0C30\u0C484"
    ],
    wide: [
        "1\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02",
        "2\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02",
        "3\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02",
        "4\u0C35 \u0C24\u0C4D\u0C30\u0C48\u0C2E\u0C3E\u0C38\u0C3F\u0C15\u0C02"
    ]
};
// CLDR #1637 - #1708
var $7bfdbe19d0d450a7$var$monthValues = {
    narrow: [
        "\u0C1C",
        "\u0C2B\u0C3F",
        "\u0C2E\u0C3E",
        "\u0C0F",
        "\u0C2E\u0C47",
        "\u0C1C\u0C42",
        "\u0C1C\u0C41",
        "\u0C06",
        "\u0C38\u0C46",
        "\u0C05",
        "\u0C28",
        "\u0C21\u0C3F"
    ],
    abbreviated: [
        "\u0C1C\u0C28",
        "\u0C2B\u0C3F\u0C2C\u0C4D\u0C30",
        "\u0C2E\u0C3E\u0C30\u0C4D\u0C1A\u0C3F",
        "\u0C0F\u0C2A\u0C4D\u0C30\u0C3F",
        "\u0C2E\u0C47",
        "\u0C1C\u0C42\u0C28\u0C4D",
        "\u0C1C\u0C41\u0C32\u0C48",
        "\u0C06\u0C17",
        "\u0C38\u0C46\u0C2A\u0C4D\u0C1F\u0C46\u0C02",
        "\u0C05\u0C15\u0C4D\u0C1F\u0C4B",
        "\u0C28\u0C35\u0C02",
        "\u0C21\u0C3F\u0C38\u0C46\u0C02"
    ],
    wide: [
        "\u0C1C\u0C28\u0C35\u0C30\u0C3F",
        "\u0C2B\u0C3F\u0C2C\u0C4D\u0C30\u0C35\u0C30\u0C3F",
        "\u0C2E\u0C3E\u0C30\u0C4D\u0C1A\u0C3F",
        "\u0C0F\u0C2A\u0C4D\u0C30\u0C3F\u0C32\u0C4D",
        "\u0C2E\u0C47",
        "\u0C1C\u0C42\u0C28\u0C4D",
        "\u0C1C\u0C41\u0C32\u0C48",
        "\u0C06\u0C17\u0C38\u0C4D\u0C1F\u0C41",
        "\u0C38\u0C46\u0C2A\u0C4D\u0C1F\u0C46\u0C02\u0C2C\u0C30\u0C4D",
        "\u0C05\u0C15\u0C4D\u0C1F\u0C4B\u0C2C\u0C30\u0C4D",
        "\u0C28\u0C35\u0C02\u0C2C\u0C30\u0C4D",
        "\u0C21\u0C3F\u0C38\u0C46\u0C02\u0C2C\u0C30\u0C4D"
    ]
};
// CLDR #1709 - #1764
var $7bfdbe19d0d450a7$var$dayValues = {
    narrow: [
        "\u0C06",
        "\u0C38\u0C4B",
        "\u0C2E",
        "\u0C2C\u0C41",
        "\u0C17\u0C41",
        "\u0C36\u0C41",
        "\u0C36"
    ],
    short: [
        "\u0C06\u0C26\u0C3F",
        "\u0C38\u0C4B\u0C2E",
        "\u0C2E\u0C02\u0C17\u0C33",
        "\u0C2C\u0C41\u0C27",
        "\u0C17\u0C41\u0C30\u0C41",
        "\u0C36\u0C41\u0C15\u0C4D\u0C30",
        "\u0C36\u0C28\u0C3F"
    ],
    abbreviated: [
        "\u0C06\u0C26\u0C3F",
        "\u0C38\u0C4B\u0C2E",
        "\u0C2E\u0C02\u0C17\u0C33",
        "\u0C2C\u0C41\u0C27",
        "\u0C17\u0C41\u0C30\u0C41",
        "\u0C36\u0C41\u0C15\u0C4D\u0C30",
        "\u0C36\u0C28\u0C3F"
    ],
    wide: [
        "\u0C06\u0C26\u0C3F\u0C35\u0C3E\u0C30\u0C02",
        "\u0C38\u0C4B\u0C2E\u0C35\u0C3E\u0C30\u0C02",
        "\u0C2E\u0C02\u0C17\u0C33\u0C35\u0C3E\u0C30\u0C02",
        "\u0C2C\u0C41\u0C27\u0C35\u0C3E\u0C30\u0C02",
        "\u0C17\u0C41\u0C30\u0C41\u0C35\u0C3E\u0C30\u0C02",
        "\u0C36\u0C41\u0C15\u0C4D\u0C30\u0C35\u0C3E\u0C30\u0C02",
        "\u0C36\u0C28\u0C3F\u0C35\u0C3E\u0C30\u0C02"
    ]
};
// CLDR #1767 - #1806
var $7bfdbe19d0d450a7$var$dayPeriodValues = {
    narrow: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    },
    abbreviated: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    },
    wide: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    }
};
var $7bfdbe19d0d450a7$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    },
    abbreviated: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    },
    wide: {
        am: "\u0C2A\u0C42\u0C30\u0C4D\u0C35\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        pm: "\u0C05\u0C2A\u0C30\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        midnight: "\u0C05\u0C30\u0C4D\u0C27\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F",
        noon: "\u0C2E\u0C3F\u0C1F\u0C4D\u0C1F\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        morning: "\u0C09\u0C26\u0C2F\u0C02",
        afternoon: "\u0C2E\u0C27\u0C4D\u0C2F\u0C3E\u0C39\u0C4D\u0C28\u0C02",
        evening: "\u0C38\u0C3E\u0C2F\u0C02\u0C24\u0C4D\u0C30\u0C02",
        night: "\u0C30\u0C3E\u0C24\u0C4D\u0C30\u0C3F"
    }
};
var $7bfdbe19d0d450a7$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + "\u0C35";
};
var $7bfdbe19d0d450a7$var$localize = {
    ordinalNumber: $7bfdbe19d0d450a7$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $7bfdbe19d0d450a7$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $7bfdbe19d0d450a7$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $7bfdbe19d0d450a7$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $7bfdbe19d0d450a7$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $7bfdbe19d0d450a7$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $7bfdbe19d0d450a7$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $7bfdbe19d0d450a7$export$2e2bcd8739ae039 = $7bfdbe19d0d450a7$var$localize;

});

parcelRegister("kPw48", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2a171a01569e88a$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $f2a171a01569e88a$var$matchOrdinalNumberPattern = /^(\d+)(వ)?/i;
var $f2a171a01569e88a$var$parseOrdinalNumberPattern = /\d+/i;
var $f2a171a01569e88a$var$matchEraPatterns = {
    narrow: /^(క్రీ\.పూ\.|క్రీ\.శ\.)/i,
    abbreviated: /^(క్రీ\.?\s?పూ\.?|ప్ర\.?\s?శ\.?\s?పూ\.?|క్రీ\.?\s?శ\.?|సా\.?\s?శ\.?)/i,
    wide: /^(క్రీస్తు పూర్వం|ప్రస్తుత శకానికి పూర్వం|క్రీస్తు శకం|ప్రస్తుత శకం)/i
};
var $f2a171a01569e88a$var$parseEraPatterns = {
    any: [
        /^(పూ|శ)/i,
        /^సా/i
    ]
};
var $f2a171a01569e88a$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^త్రై[1234]/i,
    wide: /^[1234](వ)? త్రైమాసికం/i
};
var $f2a171a01569e88a$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $f2a171a01569e88a$var$matchMonthPatterns = {
    narrow: /^(జూ|జు|జ|ఫి|మా|ఏ|మే|ఆ|సె|అ|న|డి)/i,
    abbreviated: /^(జన|ఫిబ్ర|మార్చి|ఏప్రి|మే|జూన్|జులై|ఆగ|సెప్|అక్టో|నవ|డిసె)/i,
    wide: /^(జనవరి|ఫిబ్రవరి|మార్చి|ఏప్రిల్|మే|జూన్|జులై|ఆగస్టు|సెప్టెంబర్|అక్టోబర్|నవంబర్|డిసెంబర్)/i
};
var $f2a171a01569e88a$var$parseMonthPatterns = {
    narrow: [
        /^జ/i,
        /^ఫి/i,
        /^మా/i,
        /^ఏ/i,
        /^మే/i,
        /^జూ/i,
        /^జు/i,
        /^ఆ/i,
        /^సె/i,
        /^అ/i,
        /^న/i,
        /^డి/i
    ],
    any: [
        /^జన/i,
        /^ఫి/i,
        /^మా/i,
        /^ఏ/i,
        /^మే/i,
        /^జూన్/i,
        /^జులై/i,
        /^ఆగ/i,
        /^సె/i,
        /^అ/i,
        /^న/i,
        /^డి/i
    ]
};
var $f2a171a01569e88a$var$matchDayPatterns = {
    narrow: /^(ఆ|సో|మ|బు|గు|శు|శ)/i,
    short: /^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
    abbreviated: /^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
    wide: /^(ఆదివారం|సోమవారం|మంగళవారం|బుధవారం|గురువారం|శుక్రవారం|శనివారం)/i
};
var $f2a171a01569e88a$var$parseDayPatterns = {
    narrow: [
        /^ఆ/i,
        /^సో/i,
        /^మ/i,
        /^బు/i,
        /^గు/i,
        /^శు/i,
        /^శ/i
    ],
    any: [
        /^ఆది/i,
        /^సోమ/i,
        /^మం/i,
        /^బుధ/i,
        /^గురు/i,
        /^శుక్ర/i,
        /^శని/i
    ]
};
var $f2a171a01569e88a$var$matchDayPeriodPatterns = {
    narrow: /^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i,
    any: /^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i
};
var $f2a171a01569e88a$var$parseDayPeriodPatterns = {
    any: {
        am: /^పూర్వాహ్నం/i,
        pm: /^అపరాహ్నం/i,
        midnight: /^అర్ధ/i,
        noon: /^మిట్ట/i,
        morning: /ఉదయం/i,
        afternoon: /మధ్యాహ్నం/i,
        evening: /సాయంత్రం/i,
        night: /రాత్రి/i
    }
};
var $f2a171a01569e88a$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $f2a171a01569e88a$var$matchOrdinalNumberPattern,
        parsePattern: $f2a171a01569e88a$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $f2a171a01569e88a$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f2a171a01569e88a$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $f2a171a01569e88a$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f2a171a01569e88a$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $f2a171a01569e88a$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f2a171a01569e88a$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $f2a171a01569e88a$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $f2a171a01569e88a$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $f2a171a01569e88a$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $f2a171a01569e88a$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $f2a171a01569e88a$export$2e2bcd8739ae039 = $f2a171a01569e88a$var$match;

});


parcelRegister("7bq3f", function(module, exports) {

$parcel$export(module.exports, "default", () => $53adc4bc466c8250$export$2e2bcd8739ae039);

var $289yB = parcelRequire("289yB");

var $dABtb = parcelRequire("dABtb");

var $gpXNY = parcelRequire("gpXNY");

var $0bvtp = parcelRequire("0bvtp");

var $fHe0C = parcelRequire("fHe0C");
/**
 * @type {Locale}
 * @category Locales
 * @summary Thai locale.
 * @language Thai
 * @iso-639-2 tha
 * @author Athiwat Hirunworawongkun [@athivvat]{@link https://github.com/athivvat}
 * @author [@hawkup]{@link https://github.com/hawkup}
 * @author  Jirawat I. [@nodtem66]{@link https://github.com/nodtem66}
 */ var $53adc4bc466c8250$var$locale = {
    code: "th",
    formatDistance: (0, $289yB.default),
    formatLong: (0, $dABtb.default),
    formatRelative: (0, $gpXNY.default),
    localize: (0, $0bvtp.default),
    match: (0, $fHe0C.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $53adc4bc466c8250$export$2e2bcd8739ae039 = $53adc4bc466c8250$var$locale;

});
parcelRegister("289yB", function(module, exports) {

$parcel$export(module.exports, "default", () => $18d3bdf296f2481f$export$2e2bcd8739ae039);
var $18d3bdf296f2481f$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 1 \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35",
        other: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 {{count}} \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35"
    },
    xSeconds: {
        one: "1 \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35",
        other: "{{count}} \u0E27\u0E34\u0E19\u0E32\u0E17\u0E35"
    },
    halfAMinute: "\u0E04\u0E23\u0E36\u0E48\u0E07\u0E19\u0E32\u0E17\u0E35",
    lessThanXMinutes: {
        one: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 1 \u0E19\u0E32\u0E17\u0E35",
        other: "\u0E19\u0E49\u0E2D\u0E22\u0E01\u0E27\u0E48\u0E32 {{count}} \u0E19\u0E32\u0E17\u0E35"
    },
    xMinutes: {
        one: "1 \u0E19\u0E32\u0E17\u0E35",
        other: "{{count}} \u0E19\u0E32\u0E17\u0E35"
    },
    aboutXHours: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07"
    },
    xHours: {
        one: "1 \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07",
        other: "{{count}} \u0E0A\u0E31\u0E48\u0E27\u0E42\u0E21\u0E07"
    },
    xDays: {
        one: "1 \u0E27\u0E31\u0E19",
        other: "{{count}} \u0E27\u0E31\u0E19"
    },
    aboutXWeeks: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C"
    },
    xWeeks: {
        one: "1 \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C",
        other: "{{count}} \u0E2A\u0E31\u0E1B\u0E14\u0E32\u0E2B\u0E4C"
    },
    aboutXMonths: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E40\u0E14\u0E37\u0E2D\u0E19",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E40\u0E14\u0E37\u0E2D\u0E19"
    },
    xMonths: {
        one: "1 \u0E40\u0E14\u0E37\u0E2D\u0E19",
        other: "{{count}} \u0E40\u0E14\u0E37\u0E2D\u0E19"
    },
    aboutXYears: {
        one: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 1 \u0E1B\u0E35",
        other: "\u0E1B\u0E23\u0E30\u0E21\u0E32\u0E13 {{count}} \u0E1B\u0E35"
    },
    xYears: {
        one: "1 \u0E1B\u0E35",
        other: "{{count}} \u0E1B\u0E35"
    },
    overXYears: {
        one: "\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 1 \u0E1B\u0E35",
        other: "\u0E21\u0E32\u0E01\u0E01\u0E27\u0E48\u0E32 {{count}} \u0E1B\u0E35"
    },
    almostXYears: {
        one: "\u0E40\u0E01\u0E37\u0E2D\u0E1A 1 \u0E1B\u0E35",
        other: "\u0E40\u0E01\u0E37\u0E2D\u0E1A {{count}} \u0E1B\u0E35"
    }
};
var $18d3bdf296f2481f$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $18d3bdf296f2481f$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) {
            if (token === "halfAMinute") return "\u0E43\u0E19" + result;
            else return "\u0E43\u0E19 " + result;
        } else return result + "\u0E17\u0E35\u0E48\u0E1C\u0E48\u0E32\u0E19\u0E21\u0E32";
    }
    return result;
};
var $18d3bdf296f2481f$export$2e2bcd8739ae039 = $18d3bdf296f2481f$var$formatDistance;

});

parcelRegister("dABtb", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e4bb3dffd44c6de$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $9e4bb3dffd44c6de$var$dateFormats = {
    full: "\u0E27\u0E31\u0E19EEEE\u0E17\u0E35\u0E48 do MMMM y",
    long: "do MMMM y",
    medium: "d MMM y",
    short: "dd/MM/yyyy"
};
var $9e4bb3dffd44c6de$var$timeFormats = {
    full: "H:mm:ss \u0E19. zzzz",
    long: "H:mm:ss \u0E19. z",
    medium: "H:mm:ss \u0E19.",
    short: "H:mm \u0E19."
};
var $9e4bb3dffd44c6de$var$dateTimeFormats = {
    full: "{{date}} '\u0E40\u0E27\u0E25\u0E32' {{time}}",
    long: "{{date}} '\u0E40\u0E27\u0E25\u0E32' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $9e4bb3dffd44c6de$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $9e4bb3dffd44c6de$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $9e4bb3dffd44c6de$var$timeFormats,
        defaultWidth: "medium"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $9e4bb3dffd44c6de$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $9e4bb3dffd44c6de$export$2e2bcd8739ae039 = $9e4bb3dffd44c6de$var$formatLong;

});

parcelRegister("gpXNY", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf3d5f3020f49c0d$export$2e2bcd8739ae039);
var $bf3d5f3020f49c0d$var$formatRelativeLocale = {
    lastWeek: "eeee'\u0E17\u0E35\u0E48\u0E41\u0E25\u0E49\u0E27\u0E40\u0E27\u0E25\u0E32' p",
    yesterday: "'\u0E40\u0E21\u0E37\u0E48\u0E2D\u0E27\u0E32\u0E19\u0E19\u0E35\u0E49\u0E40\u0E27\u0E25\u0E32' p",
    today: "'\u0E27\u0E31\u0E19\u0E19\u0E35\u0E49\u0E40\u0E27\u0E25\u0E32' p",
    tomorrow: "'\u0E1E\u0E23\u0E38\u0E48\u0E07\u0E19\u0E35\u0E49\u0E40\u0E27\u0E25\u0E32' p",
    nextWeek: "eeee '\u0E40\u0E27\u0E25\u0E32' p",
    other: "P"
};
var $bf3d5f3020f49c0d$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $bf3d5f3020f49c0d$var$formatRelativeLocale[token];
};
var $bf3d5f3020f49c0d$export$2e2bcd8739ae039 = $bf3d5f3020f49c0d$var$formatRelative;

});

parcelRegister("0bvtp", function(module, exports) {

$parcel$export(module.exports, "default", () => $0008ed2e01750631$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $0008ed2e01750631$var$eraValues = {
    narrow: [
        "B",
        "\u0E04\u0E28"
    ],
    abbreviated: [
        "BC",
        "\u0E04.\u0E28."
    ],
    wide: [
        "\u0E1B\u0E35\u0E01\u0E48\u0E2D\u0E19\u0E04\u0E23\u0E34\u0E2A\u0E15\u0E01\u0E32\u0E25",
        "\u0E04\u0E23\u0E34\u0E2A\u0E15\u0E4C\u0E28\u0E31\u0E01\u0E23\u0E32\u0E0A"
    ]
};
var $0008ed2e01750631$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E41\u0E23\u0E01",
        "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E2D\u0E07",
        "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E32\u0E21",
        "\u0E44\u0E15\u0E23\u0E21\u0E32\u0E2A\u0E17\u0E35\u0E48\u0E2A\u0E35\u0E48"
    ]
};
var $0008ed2e01750631$var$dayValues = {
    narrow: [
        "\u0E2D\u0E32.",
        "\u0E08.",
        "\u0E2D.",
        "\u0E1E.",
        "\u0E1E\u0E24.",
        "\u0E28.",
        "\u0E2A."
    ],
    short: [
        "\u0E2D\u0E32.",
        "\u0E08.",
        "\u0E2D.",
        "\u0E1E.",
        "\u0E1E\u0E24.",
        "\u0E28.",
        "\u0E2A."
    ],
    abbreviated: [
        "\u0E2D\u0E32.",
        "\u0E08.",
        "\u0E2D.",
        "\u0E1E.",
        "\u0E1E\u0E24.",
        "\u0E28.",
        "\u0E2A."
    ],
    wide: [
        "\u0E2D\u0E32\u0E17\u0E34\u0E15\u0E22\u0E4C",
        "\u0E08\u0E31\u0E19\u0E17\u0E23\u0E4C",
        "\u0E2D\u0E31\u0E07\u0E04\u0E32\u0E23",
        "\u0E1E\u0E38\u0E18",
        "\u0E1E\u0E24\u0E2B\u0E31\u0E2A\u0E1A\u0E14\u0E35",
        "\u0E28\u0E38\u0E01\u0E23\u0E4C",
        "\u0E40\u0E2A\u0E32\u0E23\u0E4C"
    ]
};
var $0008ed2e01750631$var$monthValues = {
    narrow: [
        "\u0E21.\u0E04.",
        "\u0E01.\u0E1E.",
        "\u0E21\u0E35.\u0E04.",
        "\u0E40\u0E21.\u0E22.",
        "\u0E1E.\u0E04.",
        "\u0E21\u0E34.\u0E22.",
        "\u0E01.\u0E04.",
        "\u0E2A.\u0E04.",
        "\u0E01.\u0E22.",
        "\u0E15.\u0E04.",
        "\u0E1E.\u0E22.",
        "\u0E18.\u0E04."
    ],
    abbreviated: [
        "\u0E21.\u0E04.",
        "\u0E01.\u0E1E.",
        "\u0E21\u0E35.\u0E04.",
        "\u0E40\u0E21.\u0E22.",
        "\u0E1E.\u0E04.",
        "\u0E21\u0E34.\u0E22.",
        "\u0E01.\u0E04.",
        "\u0E2A.\u0E04.",
        "\u0E01.\u0E22.",
        "\u0E15.\u0E04.",
        "\u0E1E.\u0E22.",
        "\u0E18.\u0E04."
    ],
    wide: [
        "\u0E21\u0E01\u0E23\u0E32\u0E04\u0E21",
        "\u0E01\u0E38\u0E21\u0E20\u0E32\u0E1E\u0E31\u0E19\u0E18\u0E4C",
        "\u0E21\u0E35\u0E19\u0E32\u0E04\u0E21",
        "\u0E40\u0E21\u0E29\u0E32\u0E22\u0E19",
        "\u0E1E\u0E24\u0E29\u0E20\u0E32\u0E04\u0E21",
        "\u0E21\u0E34\u0E16\u0E38\u0E19\u0E32\u0E22\u0E19",
        "\u0E01\u0E23\u0E01\u0E0E\u0E32\u0E04\u0E21",
        "\u0E2A\u0E34\u0E07\u0E2B\u0E32\u0E04\u0E21",
        "\u0E01\u0E31\u0E19\u0E22\u0E32\u0E22\u0E19",
        "\u0E15\u0E38\u0E25\u0E32\u0E04\u0E21",
        "\u0E1E\u0E24\u0E28\u0E08\u0E34\u0E01\u0E32\u0E22\u0E19",
        "\u0E18\u0E31\u0E19\u0E27\u0E32\u0E04\u0E21"
    ]
};
var $0008ed2e01750631$var$dayPeriodValues = {
    narrow: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E1A\u0E48\u0E32\u0E22",
        evening: "\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    },
    abbreviated: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E1A\u0E48\u0E32\u0E22",
        evening: "\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    },
    wide: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E1A\u0E48\u0E32\u0E22",
        evening: "\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    }
};
var $0008ed2e01750631$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E15\u0E2D\u0E19\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19",
        evening: "\u0E15\u0E2D\u0E19\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    },
    abbreviated: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E15\u0E2D\u0E19\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19",
        evening: "\u0E15\u0E2D\u0E19\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    },
    wide: {
        am: "\u0E01\u0E48\u0E2D\u0E19\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        pm: "\u0E2B\u0E25\u0E31\u0E07\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        midnight: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07\u0E04\u0E37\u0E19",
        noon: "\u0E40\u0E17\u0E35\u0E48\u0E22\u0E07",
        morning: "\u0E15\u0E2D\u0E19\u0E40\u0E0A\u0E49\u0E32",
        afternoon: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E27\u0E31\u0E19",
        evening: "\u0E15\u0E2D\u0E19\u0E40\u0E22\u0E47\u0E19",
        night: "\u0E15\u0E2D\u0E19\u0E01\u0E25\u0E32\u0E07\u0E04\u0E37\u0E19"
    }
};
var $0008ed2e01750631$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $0008ed2e01750631$var$localize = {
    ordinalNumber: $0008ed2e01750631$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $0008ed2e01750631$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $0008ed2e01750631$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $0008ed2e01750631$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $0008ed2e01750631$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $0008ed2e01750631$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $0008ed2e01750631$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $0008ed2e01750631$export$2e2bcd8739ae039 = $0008ed2e01750631$var$localize;

});

parcelRegister("fHe0C", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6d5bd112a60e41c$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $b6d5bd112a60e41c$var$matchOrdinalNumberPattern = /^\d+/i;
var $b6d5bd112a60e41c$var$parseOrdinalNumberPattern = /\d+/i;
var $b6d5bd112a60e41c$var$matchEraPatterns = {
    narrow: /^([bB]|[aA]|คศ)/i,
    abbreviated: /^([bB]\.?\s?[cC]\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?|ค\.?ศ\.?)/i,
    wide: /^(ก่อนคริสตกาล|คริสต์ศักราช|คริสตกาล)/i
};
var $b6d5bd112a60e41c$var$parseEraPatterns = {
    any: [
        /^[bB]/i,
        /^(^[aA]|ค\.?ศ\.?|คริสตกาล|คริสต์ศักราช|)/i
    ]
};
var $b6d5bd112a60e41c$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^ไตรมาส(ที่)? ?[1234]/i
};
var $b6d5bd112a60e41c$var$parseQuarterPatterns = {
    any: [
        /(1|แรก|หนึ่ง)/i,
        /(2|สอง)/i,
        /(3|สาม)/i,
        /(4|สี่)/i
    ]
};
var $b6d5bd112a60e41c$var$matchMonthPatterns = {
    narrow: /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?)/i,
    abbreviated: /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?')/i,
    wide: /^(มกราคม|กุมภาพันธ์|มีนาคม|เมษายน|พฤษภาคม|มิถุนายน|กรกฎาคม|สิงหาคม|กันยายน|ตุลาคม|พฤศจิกายน|ธันวาคม)/i
};
var $b6d5bd112a60e41c$var$parseMonthPatterns = {
    wide: [
        /^มก/i,
        /^กุม/i,
        /^มี/i,
        /^เม/i,
        /^พฤษ/i,
        /^มิ/i,
        /^กรก/i,
        /^ส/i,
        /^กัน/i,
        /^ต/i,
        /^พฤศ/i,
        /^ธ/i
    ],
    any: [
        /^ม\.?ค\.?/i,
        /^ก\.?พ\.?/i,
        /^มี\.?ค\.?/i,
        /^เม\.?ย\.?/i,
        /^พ\.?ค\.?/i,
        /^มิ\.?ย\.?/i,
        /^ก\.?ค\.?/i,
        /^ส\.?ค\.?/i,
        /^ก\.?ย\.?/i,
        /^ต\.?ค\.?/i,
        /^พ\.?ย\.?/i,
        /^ธ\.?ค\.?/i
    ]
};
var $b6d5bd112a60e41c$var$matchDayPatterns = {
    narrow: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
    short: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
    abbreviated: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
    wide: /^(อาทิตย์|จันทร์|อังคาร|พุธ|พฤหัสบดี|ศุกร์|เสาร์)/i
};
var $b6d5bd112a60e41c$var$parseDayPatterns = {
    wide: [
        /^อา/i,
        /^จั/i,
        /^อั/i,
        /^พุธ/i,
        /^พฤ/i,
        /^ศ/i,
        /^เส/i
    ],
    any: [
        /^อา/i,
        /^จ/i,
        /^อ/i,
        /^พ(?!ฤ)/i,
        /^พฤ/i,
        /^ศ/i,
        /^ส/i
    ]
};
var $b6d5bd112a60e41c$var$matchDayPeriodPatterns = {
    any: /^(ก่อนเที่ยง|หลังเที่ยง|เที่ยงคืน|เที่ยง|(ตอน.*?)?.*(เที่ยง|เช้า|บ่าย|เย็น|กลางคืน))/i
};
var $b6d5bd112a60e41c$var$parseDayPeriodPatterns = {
    any: {
        am: /^ก่อนเที่ยง/i,
        pm: /^หลังเที่ยง/i,
        midnight: /^เที่ยงคืน/i,
        noon: /^เที่ยง/i,
        morning: /เช้า/i,
        afternoon: /บ่าย/i,
        evening: /เย็น/i,
        night: /กลางคืน/i
    }
};
var $b6d5bd112a60e41c$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $b6d5bd112a60e41c$var$matchOrdinalNumberPattern,
        parsePattern: $b6d5bd112a60e41c$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $b6d5bd112a60e41c$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b6d5bd112a60e41c$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $b6d5bd112a60e41c$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b6d5bd112a60e41c$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $b6d5bd112a60e41c$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b6d5bd112a60e41c$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $b6d5bd112a60e41c$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b6d5bd112a60e41c$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $b6d5bd112a60e41c$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $b6d5bd112a60e41c$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $b6d5bd112a60e41c$export$2e2bcd8739ae039 = $b6d5bd112a60e41c$var$match;

});


parcelRegister("1wu2L", function(module, exports) {

$parcel$export(module.exports, "default", () => $11c015a852faf83a$export$2e2bcd8739ae039);

var $joO44 = parcelRequire("joO44");

var $kpT3q = parcelRequire("kpT3q");

var $eFCeO = parcelRequire("eFCeO");

var $iLT9P = parcelRequire("iLT9P");

var $ivvV0 = parcelRequire("ivvV0");
/**
 * @type {Locale}
 * @category Locales
 * @summary Turkish locale.
 * @language Turkish
 * @iso-639-2 tur
 * @author Alpcan Aydın [@alpcanaydin]{@link https://github.com/alpcanaydin}
 * @author Berkay Sargın [@berkaey]{@link https://github.com/berkaey}
 * @author Fatih Bulut [@bulutfatih]{@link https://github.com/bulutfatih}
 * @author Ismail Demirbilek [@dbtek]{@link https://github.com/dbtek}
 * @author İsmail Kayar [@ikayar]{@link https://github.com/ikayar}
 *
 *
 */ var $11c015a852faf83a$var$locale = {
    code: "tr",
    formatDistance: (0, $joO44.default),
    formatLong: (0, $kpT3q.default),
    formatRelative: (0, $eFCeO.default),
    localize: (0, $iLT9P.default),
    match: (0, $ivvV0.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $11c015a852faf83a$export$2e2bcd8739ae039 = $11c015a852faf83a$var$locale;

});
parcelRegister("joO44", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1f71803099daa29$export$2e2bcd8739ae039);
var $e1f71803099daa29$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "bir saniyeden az",
        other: "{{count}} saniyeden az"
    },
    xSeconds: {
        one: "1 saniye",
        other: "{{count}} saniye"
    },
    halfAMinute: "yar\u0131m dakika",
    lessThanXMinutes: {
        one: "bir dakikadan az",
        other: "{{count}} dakikadan az"
    },
    xMinutes: {
        one: "1 dakika",
        other: "{{count}} dakika"
    },
    aboutXHours: {
        one: "yakla\u015F\u0131k 1 saat",
        other: "yakla\u015F\u0131k {{count}} saat"
    },
    xHours: {
        one: "1 saat",
        other: "{{count}} saat"
    },
    xDays: {
        one: "1 g\xfcn",
        other: "{{count}} g\xfcn"
    },
    aboutXWeeks: {
        one: "yakla\u015F\u0131k 1 hafta",
        other: "yakla\u015F\u0131k {{count}} hafta"
    },
    xWeeks: {
        one: "1 hafta",
        other: "{{count}} hafta"
    },
    aboutXMonths: {
        one: "yakla\u015F\u0131k 1 ay",
        other: "yakla\u015F\u0131k {{count}} ay"
    },
    xMonths: {
        one: "1 ay",
        other: "{{count}} ay"
    },
    aboutXYears: {
        one: "yakla\u015F\u0131k 1 y\u0131l",
        other: "yakla\u015F\u0131k {{count}} y\u0131l"
    },
    xYears: {
        one: "1 y\u0131l",
        other: "{{count}} y\u0131l"
    },
    overXYears: {
        one: "1 y\u0131ldan fazla",
        other: "{{count}} y\u0131ldan fazla"
    },
    almostXYears: {
        one: "neredeyse 1 y\u0131l",
        other: "neredeyse {{count}} y\u0131l"
    }
};
var $e1f71803099daa29$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $e1f71803099daa29$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " sonra";
        else return result + " \xf6nce";
    }
    return result;
};
var $e1f71803099daa29$export$2e2bcd8739ae039 = $e1f71803099daa29$var$formatDistance;

});

parcelRegister("kpT3q", function(module, exports) {

$parcel$export(module.exports, "default", () => $edd0d90dd190fabf$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $edd0d90dd190fabf$var$dateFormats = {
    full: "d MMMM y EEEE",
    long: "d MMMM y",
    medium: "d MMM y",
    short: "dd.MM.yyyy"
};
var $edd0d90dd190fabf$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $edd0d90dd190fabf$var$dateTimeFormats = {
    full: "{{date}} 'saat' {{time}}",
    long: "{{date}} 'saat' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $edd0d90dd190fabf$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $edd0d90dd190fabf$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $edd0d90dd190fabf$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $edd0d90dd190fabf$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $edd0d90dd190fabf$export$2e2bcd8739ae039 = $edd0d90dd190fabf$var$formatLong;

});

parcelRegister("eFCeO", function(module, exports) {

$parcel$export(module.exports, "default", () => $aae28e4d4a364408$export$2e2bcd8739ae039);
var $aae28e4d4a364408$var$formatRelativeLocale = {
    lastWeek: "'ge\xe7en hafta' eeee 'saat' p",
    yesterday: "'d\xfcn saat' p",
    today: "'bug\xfcn saat' p",
    tomorrow: "'yar\u0131n saat' p",
    nextWeek: "eeee 'saat' p",
    other: "P"
};
var $aae28e4d4a364408$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $aae28e4d4a364408$var$formatRelativeLocale[token];
};
var $aae28e4d4a364408$export$2e2bcd8739ae039 = $aae28e4d4a364408$var$formatRelative;

});

parcelRegister("iLT9P", function(module, exports) {

$parcel$export(module.exports, "default", () => $daa766e9839cd810$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $daa766e9839cd810$var$eraValues = {
    narrow: [
        "M\xd6",
        "MS"
    ],
    abbreviated: [
        "M\xd6",
        "MS"
    ],
    wide: [
        "Milattan \xd6nce",
        "Milattan Sonra"
    ]
};
var $daa766e9839cd810$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1\xc7",
        "2\xc7",
        "3\xc7",
        "4\xc7"
    ],
    wide: [
        "\u0130lk \xe7eyrek",
        "\u0130kinci \xc7eyrek",
        "\xdc\xe7\xfcnc\xfc \xe7eyrek",
        "Son \xe7eyrek"
    ]
};
var $daa766e9839cd810$var$monthValues = {
    narrow: [
        "O",
        "\u015E",
        "M",
        "N",
        "M",
        "H",
        "T",
        "A",
        "E",
        "E",
        "K",
        "A"
    ],
    abbreviated: [
        "Oca",
        "\u015Eub",
        "Mar",
        "Nis",
        "May",
        "Haz",
        "Tem",
        "A\u011Fu",
        "Eyl",
        "Eki",
        "Kas",
        "Ara"
    ],
    wide: [
        "Ocak",
        "\u015Eubat",
        "Mart",
        "Nisan",
        "May\u0131s",
        "Haziran",
        "Temmuz",
        "A\u011Fustos",
        "Eyl\xfcl",
        "Ekim",
        "Kas\u0131m",
        "Aral\u0131k"
    ]
};
var $daa766e9839cd810$var$dayValues = {
    narrow: [
        "P",
        "P",
        "S",
        "\xc7",
        "P",
        "C",
        "C"
    ],
    short: [
        "Pz",
        "Pt",
        "Sa",
        "\xc7a",
        "Pe",
        "Cu",
        "Ct"
    ],
    abbreviated: [
        "Paz",
        "Pzt",
        "Sal",
        "\xc7ar",
        "Per",
        "Cum",
        "Cts"
    ],
    wide: [
        "Pazar",
        "Pazartesi",
        "Sal\u0131",
        "\xc7ar\u015Famba",
        "Per\u015Fembe",
        "Cuma",
        "Cumartesi"
    ]
};
var $daa766e9839cd810$var$dayPeriodValues = {
    narrow: {
        am: "\xf6\xf6",
        pm: "\xf6s",
        midnight: "gy",
        noon: "\xf6",
        morning: "sa",
        afternoon: "\xf6s",
        evening: "ak",
        night: "ge"
    },
    abbreviated: {
        am: "\xd6\xd6",
        pm: "\xd6S",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Fle",
        morning: "sabah",
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Fam",
        night: "gece"
    },
    wide: {
        am: "\xd6.\xd6.",
        pm: "\xd6.S.",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Fle",
        morning: "sabah",
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Fam",
        night: "gece"
    }
};
var $daa766e9839cd810$var$formattingDayPeriodValues = {
    narrow: {
        am: "\xf6\xf6",
        pm: "\xf6s",
        midnight: "gy",
        noon: "\xf6",
        morning: "sa",
        afternoon: "\xf6s",
        evening: "ak",
        night: "ge"
    },
    abbreviated: {
        am: "\xd6\xd6",
        pm: "\xd6S",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Flen",
        morning: "sabahleyin",
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Famleyin",
        night: "geceleyin"
    },
    wide: {
        am: "\xf6.\xf6.",
        pm: "\xf6.s.",
        midnight: "gece yar\u0131s\u0131",
        noon: "\xf6\u011Flen",
        morning: "sabahleyin",
        afternoon: "\xf6\u011Fleden sonra",
        evening: "ak\u015Famleyin",
        night: "geceleyin"
    }
};
var $daa766e9839cd810$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber);
    return number + ".";
};
var $daa766e9839cd810$var$localize = {
    ordinalNumber: $daa766e9839cd810$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $daa766e9839cd810$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $daa766e9839cd810$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return Number(quarter) - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $daa766e9839cd810$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $daa766e9839cd810$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $daa766e9839cd810$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $daa766e9839cd810$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $daa766e9839cd810$export$2e2bcd8739ae039 = $daa766e9839cd810$var$localize;

});

parcelRegister("ivvV0", function(module, exports) {

$parcel$export(module.exports, "default", () => $d793e19a03a44baf$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $d793e19a03a44baf$var$matchOrdinalNumberPattern = /^(\d+)(\.)?/i;
var $d793e19a03a44baf$var$parseOrdinalNumberPattern = /\d+/i;
var $d793e19a03a44baf$var$matchEraPatterns = {
    narrow: /^(mö|ms)/i,
    abbreviated: /^(mö|ms)/i,
    wide: /^(milattan önce|milattan sonra)/i
};
var $d793e19a03a44baf$var$parseEraPatterns = {
    any: [
        /(^mö|^milattan önce)/i,
        /(^ms|^milattan sonra)/i
    ]
};
var $d793e19a03a44baf$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]ç/i,
    wide: /^((i|İ)lk|(i|İ)kinci|üçüncü|son) çeyrek/i
};
var $d793e19a03a44baf$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ],
    abbreviated: [
        /1ç/i,
        /2ç/i,
        /3ç/i,
        /4ç/i
    ],
    wide: [
        /^(i|İ)lk çeyrek/i,
        /(i|İ)kinci çeyrek/i,
        /üçüncü çeyrek/i,
        /son çeyrek/i
    ]
};
var $d793e19a03a44baf$var$matchMonthPatterns = {
    narrow: /^[oşmnhtaek]/i,
    abbreviated: /^(oca|şub|mar|nis|may|haz|tem|ağu|eyl|eki|kas|ara)/i,
    wide: /^(ocak|şubat|mart|nisan|mayıs|haziran|temmuz|ağustos|eylül|ekim|kasım|aralık)/i
};
var $d793e19a03a44baf$var$parseMonthPatterns = {
    narrow: [
        /^o/i,
        /^ş/i,
        /^m/i,
        /^n/i,
        /^m/i,
        /^h/i,
        /^t/i,
        /^a/i,
        /^e/i,
        /^e/i,
        /^k/i,
        /^a/i
    ],
    any: [
        /^o/i,
        /^ş/i,
        /^mar/i,
        /^n/i,
        /^may/i,
        /^h/i,
        /^t/i,
        /^ağ/i,
        /^ey/i,
        /^ek/i,
        /^k/i,
        /^ar/i
    ]
};
var $d793e19a03a44baf$var$matchDayPatterns = {
    narrow: /^[psçc]/i,
    short: /^(pz|pt|sa|ça|pe|cu|ct)/i,
    abbreviated: /^(paz|pzt|sal|çar|per|cum|cts)/i,
    wide: /^(pazar(?!tesi)|pazartesi|salı|çarşamba|perşembe|cuma(?!rtesi)|cumartesi)/i
};
var $d793e19a03a44baf$var$parseDayPatterns = {
    narrow: [
        /^p/i,
        /^p/i,
        /^s/i,
        /^ç/i,
        /^p/i,
        /^c/i,
        /^c/i
    ],
    any: [
        /^pz/i,
        /^pt/i,
        /^sa/i,
        /^ça/i,
        /^pe/i,
        /^cu/i,
        /^ct/i
    ],
    wide: [
        /^pazar(?!tesi)/i,
        /^pazartesi/i,
        /^salı/i,
        /^çarşamba/i,
        /^perşembe/i,
        /^cuma(?!rtesi)/i,
        /^cumartesi/i
    ]
};
var $d793e19a03a44baf$var$matchDayPeriodPatterns = {
    narrow: /^(öö|ös|gy|ö|sa|ös|ak|ge)/i,
    any: /^(ö\.?\s?[ös]\.?|öğleden sonra|gece yarısı|öğle|(sabah|öğ|akşam|gece)(leyin))/i
};
var $d793e19a03a44baf$var$parseDayPeriodPatterns = {
    any: {
        am: /^ö\.?ö\.?/i,
        pm: /^ö\.?s\.?/i,
        midnight: /^(gy|gece yarısı)/i,
        noon: /^öğ/i,
        morning: /^sa/i,
        afternoon: /^öğleden sonra/i,
        evening: /^ak/i,
        night: /^ge/i
    }
};
var $d793e19a03a44baf$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $d793e19a03a44baf$var$matchOrdinalNumberPattern,
        parsePattern: $d793e19a03a44baf$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $d793e19a03a44baf$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d793e19a03a44baf$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $d793e19a03a44baf$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d793e19a03a44baf$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $d793e19a03a44baf$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d793e19a03a44baf$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $d793e19a03a44baf$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d793e19a03a44baf$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $d793e19a03a44baf$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $d793e19a03a44baf$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $d793e19a03a44baf$export$2e2bcd8739ae039 = $d793e19a03a44baf$var$match;

});


parcelRegister("jpXP0", function(module, exports) {

$parcel$export(module.exports, "default", () => $e22ec1711cb43ce1$export$2e2bcd8739ae039);

var $aooiz = parcelRequire("aooiz");

var $kjDOb = parcelRequire("kjDOb");

var $5YZHw = parcelRequire("5YZHw");

var $i5bRD = parcelRequire("i5bRD");

var $fv4nw = parcelRequire("fv4nw");
/**
 * @type {Locale}
 * @category Locales
 * @summary Uighur locale
 * @language Uighur
 * @iso-639-2 uig
 * @author Abduwaly M. [@abduwaly]{@link https://github.com/abduwaly}
 */ var $e22ec1711cb43ce1$var$locale = {
    code: "ug",
    formatDistance: (0, $aooiz.default),
    formatLong: (0, $kjDOb.default),
    formatRelative: (0, $5YZHw.default),
    localize: (0, $i5bRD.default),
    match: (0, $fv4nw.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $e22ec1711cb43ce1$export$2e2bcd8739ae039 = $e22ec1711cb43ce1$var$locale;

});
parcelRegister("aooiz", function(module, exports) {

$parcel$export(module.exports, "default", () => $790efe703a7954b6$export$2e2bcd8739ae039);
var $790efe703a7954b6$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u0628\u0649\u0631 \u0633\u0649\u0643\u06C7\u0646\u062A \u0626\u0649\u0686\u0649\u062F\u06D5",
        other: "\u0633\u0649\u0643\u06C7\u0646\u062A \u0626\u0649\u0686\u0649\u062F\u06D5 {{count}}"
    },
    xSeconds: {
        one: "\u0628\u0649\u0631 \u0633\u0649\u0643\u06C7\u0646\u062A",
        other: "\u0633\u0649\u0643\u06C7\u0646\u062A {{count}}"
    },
    halfAMinute: "\u064A\u0649\u0631\u0649\u0645 \u0645\u0649\u0646\u06C7\u062A",
    lessThanXMinutes: {
        one: "\u0628\u0649\u0631 \u0645\u0649\u0646\u06C7\u062A \u0626\u0649\u0686\u0649\u062F\u06D5",
        other: "\u0645\u0649\u0646\u06C7\u062A \u0626\u0649\u0686\u0649\u062F\u06D5 {{count}}"
    },
    xMinutes: {
        one: "\u0628\u0649\u0631 \u0645\u0649\u0646\u06C7\u062A",
        other: "\u0645\u0649\u0646\u06C7\u062A {{count}}"
    },
    aboutXHours: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631 \u0633\u0627\u0626\u06D5\u062A",
        other: "\u0633\u0627\u0626\u06D5\u062A {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
    },
    xHours: {
        one: "\u0628\u0649\u0631 \u0633\u0627\u0626\u06D5\u062A",
        other: "\u0633\u0627\u0626\u06D5\u062A {{count}}"
    },
    xDays: {
        one: "\u0628\u0649\u0631 \u0643\u06C8\u0646",
        other: "\u0643\u06C8\u0646 {{count}}"
    },
    aboutXWeeks: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631\u06BE\u06D5\u067E\u062A\u06D5",
        other: "\u06BE\u06D5\u067E\u062A\u06D5 {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
    },
    xWeeks: {
        one: "\u0628\u0649\u0631\u06BE\u06D5\u067E\u062A\u06D5",
        other: "\u06BE\u06D5\u067E\u062A\u06D5 {{count}}"
    },
    aboutXMonths: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631 \u0626\u0627\u064A",
        other: "\u0626\u0627\u064A {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
    },
    xMonths: {
        one: "\u0628\u0649\u0631 \u0626\u0627\u064A",
        other: "\u0626\u0627\u064A {{count}}"
    },
    aboutXYears: {
        one: "\u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646 \u0628\u0649\u0631 \u064A\u0649\u0644",
        other: "\u064A\u0649\u0644 {{count}} \u062A\u06D5\u062E\u0645\u0649\u0646\u06D5\u0646"
    },
    xYears: {
        one: "\u0628\u0649\u0631 \u064A\u0649\u0644",
        other: "\u064A\u0649\u0644 {{count}}"
    },
    overXYears: {
        one: "\u0628\u0649\u0631 \u064A\u0649\u0644\u062F\u0649\u0646 \u0626\u0627\u0631\u062A\u06C7\u0642",
        other: "\u064A\u0649\u0644\u062F\u0649\u0646 \u0626\u0627\u0631\u062A\u06C7\u0642 {{count}}"
    },
    almostXYears: {
        one: "\u0626\u0627\u0633\u0627\u0633\u06D5\u0646 \u0628\u0649\u0631 \u064A\u0649\u0644",
        other: "\u064A\u0649\u0644 {{count}} \u0626\u0627\u0633\u0627\u0633\u06D5\u0646"
    }
};
var $790efe703a7954b6$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $790efe703a7954b6$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result;
        else return result + " \u0628\u0648\u0644\u062F\u0649";
    }
    return result;
};
var $790efe703a7954b6$export$2e2bcd8739ae039 = $790efe703a7954b6$var$formatDistance;

});

parcelRegister("kjDOb", function(module, exports) {

$parcel$export(module.exports, "default", () => $eca4762403966f38$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $eca4762403966f38$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $eca4762403966f38$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $eca4762403966f38$var$dateTimeFormats = {
    full: "{{date}} '\u062F\u06D5' {{time}}",
    long: "{{date}} '\u062F\u06D5' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $eca4762403966f38$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $eca4762403966f38$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $eca4762403966f38$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $eca4762403966f38$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $eca4762403966f38$export$2e2bcd8739ae039 = $eca4762403966f38$var$formatLong;

});

parcelRegister("5YZHw", function(module, exports) {

$parcel$export(module.exports, "default", () => $45b26adc9211c989$export$2e2bcd8739ae039);
var $45b26adc9211c989$var$formatRelativeLocale = {
    lastWeek: "'\u0626\u200D\u06C6\u062A\u0643\u06D5\u0646' eeee '\u062F\u06D5' p",
    yesterday: "'\u062A\u06C8\u0646\u06C8\u06AF\u06C8\u0646 \u062F\u06D5' p",
    today: "'\u0628\u06C8\u06AF\u06C8\u0646 \u062F\u06D5' p",
    tomorrow: "'\u0626\u06D5\u062A\u06D5 \u062F\u06D5' p",
    nextWeek: "eeee '\u062F\u06D5' p",
    other: "P"
};
var $45b26adc9211c989$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $45b26adc9211c989$var$formatRelativeLocale[token];
};
var $45b26adc9211c989$export$2e2bcd8739ae039 = $45b26adc9211c989$var$formatRelative;

});

parcelRegister("i5bRD", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2a1e59059d74f57$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $d2a1e59059d74f57$var$eraValues = {
    narrow: [
        "\u0628",
        "\u0643"
    ],
    abbreviated: [
        "\u0628",
        "\u0643"
    ],
    wide: [
        "\u0645\u0649\u064A\u0644\u0627\u062F\u0649\u062F\u0649\u0646 \u0628\u06C7\u0631\u06C7\u0646",
        "\u0645\u0649\u064A\u0644\u0627\u062F\u0649\u062F\u0649\u0646 \u0643\u0649\u064A\u0649\u0646"
    ]
};
var $d2a1e59059d74f57$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1",
        "2",
        "3",
        "4"
    ],
    wide: [
        "\u0628\u0649\u0631\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643",
        "\u0626\u0649\u0643\u0643\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643",
        "\u0626\u06C8\u0686\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643",
        "\u062A\u06C6\u062A\u0649\u0646\u062C\u0649 \u0686\u0627\u0631\u06D5\u0643"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $d2a1e59059d74f57$var$monthValues = {
    narrow: [
        "\u064A",
        "\u0641",
        "\u0645",
        "\u0627",
        "\u0645",
        "\u0649",
        "\u0649",
        "\u0627",
        "\u0633",
        "\u06C6",
        "\u0646",
        "\u062F"
    ],
    abbreviated: [
        "\u064A\u0627\u0646\u06CB\u0627\u0631",
        "\u0641\u06D0\u06CB\u0649\u0631\u0627\u0644",
        "\u0645\u0627\u0631\u062A",
        "\u0626\u0627\u067E\u0631\u0649\u0644",
        "\u0645\u0627\u064A",
        "\u0626\u0649\u064A\u06C7\u0646",
        "\u0626\u0649\u064A\u0648\u0644",
        "\u0626\u0627\u06CB\u063A\u06C7\u0633\u062A",
        "\u0633\u0649\u0646\u062A\u06D5\u0628\u0649\u0631",
        "\u0626\u06C6\u0643\u062A\u06D5\u0628\u0649\u0631",
        "\u0646\u0648\u064A\u0627\u0628\u0649\u0631",
        "\u062F\u0649\u0643\u0627\u0628\u0649\u0631"
    ],
    wide: [
        "\u064A\u0627\u0646\u06CB\u0627\u0631",
        "\u0641\u06D0\u06CB\u0649\u0631\u0627\u0644",
        "\u0645\u0627\u0631\u062A",
        "\u0626\u0627\u067E\u0631\u0649\u0644",
        "\u0645\u0627\u064A",
        "\u0626\u0649\u064A\u06C7\u0646",
        "\u0626\u0649\u064A\u0648\u0644",
        "\u0626\u0627\u06CB\u063A\u06C7\u0633\u062A",
        "\u0633\u0649\u0646\u062A\u06D5\u0628\u0649\u0631",
        "\u0626\u06C6\u0643\u062A\u06D5\u0628\u0649\u0631",
        "\u0646\u0648\u064A\u0627\u0628\u0649\u0631",
        "\u062F\u0649\u0643\u0627\u0628\u0649\u0631"
    ]
};
var $d2a1e59059d74f57$var$dayValues = {
    narrow: [
        "\u064A",
        "\u062F",
        "\u0633",
        "\u0686",
        "\u067E",
        "\u062C",
        "\u0634"
    ],
    short: [
        "\u064A",
        "\u062F",
        "\u0633",
        "\u0686",
        "\u067E",
        "\u062C",
        "\u0634"
    ],
    abbreviated: [
        "\u064A\u06D5\u0643\u0634\u06D5\u0646\u0628\u06D5",
        "\u062F\u06C8\u0634\u06D5\u0646\u0628\u06D5",
        "\u0633\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
        "\u0686\u0627\u0631\u0634\u06D5\u0646\u0628\u06D5",
        "\u067E\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
        "\u062C\u06C8\u0645\u06D5",
        "\u0634\u06D5\u0646\u0628\u06D5"
    ],
    wide: [
        "\u064A\u06D5\u0643\u0634\u06D5\u0646\u0628\u06D5",
        "\u062F\u06C8\u0634\u06D5\u0646\u0628\u06D5",
        "\u0633\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
        "\u0686\u0627\u0631\u0634\u06D5\u0646\u0628\u06D5",
        "\u067E\u06D5\u064A\u0634\u06D5\u0646\u0628\u06D5",
        "\u062C\u06C8\u0645\u06D5",
        "\u0634\u06D5\u0646\u0628\u06D5"
    ]
};
var $d2a1e59059d74f57$var$dayPeriodValues = {
    narrow: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0649\u0645",
        night: "\u0643\u0649\u0686\u06D5"
    },
    abbreviated: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0649\u0645",
        night: "\u0643\u0649\u0686\u06D5"
    },
    wide: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0649\u0645",
        night: "\u0643\u0649\u0686\u06D5"
    }
};
var $d2a1e59059d74f57$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646\u062F\u06D5",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0627\u0645\u062F\u0627",
        night: "\u0643\u0649\u0686\u0649\u062F\u06D5"
    },
    abbreviated: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646\u062F\u06D5",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0627\u0645\u062F\u0627",
        night: "\u0643\u0649\u0686\u0649\u062F\u06D5"
    },
    wide: {
        am: "\u0626\u06D5",
        pm: "\u0686",
        midnight: "\u0643",
        noon: "\u0686",
        morning: "\u0626\u06D5\u062A\u0649\u06AF\u06D5\u0646\u062F\u06D5",
        afternoon: "\u0686\u06C8\u0634\u062A\u0649\u0646 \u0643\u0649\u064A\u0649\u0646",
        evening: "\u0626\u0627\u062E\u0634\u0627\u0645\u062F\u0627",
        night: "\u0643\u0649\u0686\u0649\u062F\u06D5"
    }
};
var $d2a1e59059d74f57$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $d2a1e59059d74f57$var$localize = {
    ordinalNumber: $d2a1e59059d74f57$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $d2a1e59059d74f57$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $d2a1e59059d74f57$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $d2a1e59059d74f57$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $d2a1e59059d74f57$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $d2a1e59059d74f57$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $d2a1e59059d74f57$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $d2a1e59059d74f57$export$2e2bcd8739ae039 = $d2a1e59059d74f57$var$localize;

});

parcelRegister("fv4nw", function(module, exports) {

$parcel$export(module.exports, "default", () => $b48d25b7488b0192$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $b48d25b7488b0192$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $b48d25b7488b0192$var$parseOrdinalNumberPattern = /\d+/i;
var $b48d25b7488b0192$var$matchEraPatterns = {
    narrow: /^(ب|ك)/i,
    wide: /^(مىيلادىدىن بۇرۇن|مىيلادىدىن كىيىن)/i
};
var $b48d25b7488b0192$var$parseEraPatterns = {
    any: [
        /^بۇرۇن/i,
        /^كىيىن/i
    ]
};
var $b48d25b7488b0192$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^چ[1234]/i,
    wide: /^چارەك [1234]/i
};
var $b48d25b7488b0192$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $b48d25b7488b0192$var$matchMonthPatterns = {
    // eslint-disable-next-line no-misleading-character-class
    narrow: /^[يفمئامئ‍ئاسۆند]/i,
    abbreviated: /^(يانۋار|فېۋىرال|مارت|ئاپرىل|ماي|ئىيۇن|ئىيول|ئاۋغۇست|سىنتەبىر|ئۆكتەبىر|نويابىر|دىكابىر)/i,
    wide: /^(يانۋار|فېۋىرال|مارت|ئاپرىل|ماي|ئىيۇن|ئىيول|ئاۋغۇست|سىنتەبىر|ئۆكتەبىر|نويابىر|دىكابىر)/i
};
var $b48d25b7488b0192$var$parseMonthPatterns = {
    narrow: [
        /^ي/i,
        /^ف/i,
        /^م/i,
        /^ا/i,
        /^م/i,
        /^ى‍/i,
        /^ى‍/i,
        /^ا‍/i,
        /^س/i,
        /^ۆ/i,
        /^ن/i,
        /^د/i
    ],
    any: [
        /^يان/i,
        /^فېۋ/i,
        /^مار/i,
        /^ئاپ/i,
        /^ماي/i,
        /^ئىيۇن/i,
        /^ئىيول/i,
        /^ئاۋ/i,
        /^سىن/i,
        /^ئۆك/i,
        /^نوي/i,
        /^دىك/i
    ]
};
var $b48d25b7488b0192$var$matchDayPatterns = {
    narrow: /^[دسچپجشي]/i,
    short: /^(يە|دۈ|سە|چا|پە|جۈ|شە)/i,
    abbreviated: /^(يە|دۈ|سە|چا|پە|جۈ|شە)/i,
    wide: /^(يەكشەنبە|دۈشەنبە|سەيشەنبە|چارشەنبە|پەيشەنبە|جۈمە|شەنبە)/i
};
var $b48d25b7488b0192$var$parseDayPatterns = {
    narrow: [
        /^ي/i,
        /^د/i,
        /^س/i,
        /^چ/i,
        /^پ/i,
        /^ج/i,
        /^ش/i
    ],
    any: [
        /^ي/i,
        /^د/i,
        /^س/i,
        /^چ/i,
        /^پ/i,
        /^ج/i,
        /^ش/i
    ]
};
var $b48d25b7488b0192$var$matchDayPeriodPatterns = {
    narrow: /^(ئە|چ|ك|چ|(دە|ئەتىگەن) ( ئە‍|چۈشتىن كىيىن|ئاخشىم|كىچە))/i,
    any: /^(ئە|چ|ك|چ|(دە|ئەتىگەن) ( ئە‍|چۈشتىن كىيىن|ئاخشىم|كىچە))/i
};
var $b48d25b7488b0192$var$parseDayPeriodPatterns = {
    any: {
        am: /^ئە/i,
        pm: /^چ/i,
        midnight: /^ك/i,
        noon: /^چ/i,
        morning: /ئەتىگەن/i,
        afternoon: /چۈشتىن كىيىن/i,
        evening: /ئاخشىم/i,
        night: /كىچە/i
    }
};
var $b48d25b7488b0192$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $b48d25b7488b0192$var$matchOrdinalNumberPattern,
        parsePattern: $b48d25b7488b0192$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $b48d25b7488b0192$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b48d25b7488b0192$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $b48d25b7488b0192$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b48d25b7488b0192$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $b48d25b7488b0192$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b48d25b7488b0192$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $b48d25b7488b0192$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $b48d25b7488b0192$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $b48d25b7488b0192$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $b48d25b7488b0192$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $b48d25b7488b0192$export$2e2bcd8739ae039 = $b48d25b7488b0192$var$match;

});


parcelRegister("8ODOt", function(module, exports) {

$parcel$export(module.exports, "default", () => $66b1e04f9be326d3$export$2e2bcd8739ae039);

var $h2K1y = parcelRequire("h2K1y");

var $8VXem = parcelRequire("8VXem");

var $bSfD0 = parcelRequire("bSfD0");

var $bvcNk = parcelRequire("bvcNk");

var $1xYQ7 = parcelRequire("1xYQ7");
/**
 * @type {Locale}
 * @category Locales
 * @summary Ukrainian locale.
 * @language Ukrainian
 * @iso-639-2 ukr
 * @author Andrii Korzh [@korzhyk]{@link https://github.com/korzhyk}
 * @author Andriy Shcherbyak [@shcherbyakdev]{@link https://github.com/shcherbyakdev}
 */ var $66b1e04f9be326d3$var$locale = {
    code: "uk",
    formatDistance: (0, $h2K1y.default),
    formatLong: (0, $8VXem.default),
    formatRelative: (0, $bSfD0.default),
    localize: (0, $bvcNk.default),
    match: (0, $1xYQ7.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $66b1e04f9be326d3$export$2e2bcd8739ae039 = $66b1e04f9be326d3$var$locale;

});
parcelRegister("h2K1y", function(module, exports) {

$parcel$export(module.exports, "default", () => $c68652fd966943e1$export$2e2bcd8739ae039);
function $c68652fd966943e1$var$declension(scheme, count) {
    // scheme for count=1 exists
    if (scheme.one !== undefined && count === 1) return scheme.one;
    var rem10 = count % 10;
    var rem100 = count % 100;
    // 1, 21, 31, ...
    if (rem10 === 1 && rem100 !== 11) return scheme.singularNominative.replace("{{count}}", String(count));
    else if (rem10 >= 2 && rem10 <= 4 && (rem100 < 10 || rem100 > 20)) return scheme.singularGenitive.replace("{{count}}", String(count));
    else return scheme.pluralGenitive.replace("{{count}}", String(count));
}
function $c68652fd966943e1$var$buildLocalizeTokenFn(scheme) {
    return function(count, options) {
        if (options && options.addSuffix) {
            if (options.comparison && options.comparison > 0) {
                if (scheme.future) return $c68652fd966943e1$var$declension(scheme.future, count);
                else return "\u0437\u0430 " + $c68652fd966943e1$var$declension(scheme.regular, count);
            } else {
                if (scheme.past) return $c68652fd966943e1$var$declension(scheme.past, count);
                else return $c68652fd966943e1$var$declension(scheme.regular, count) + " \u0442\u043E\u043C\u0443";
            }
        } else return $c68652fd966943e1$var$declension(scheme.regular, count);
    };
}
var $c68652fd966943e1$var$halfAtMinute = function halfAtMinute(_, options) {
    if (options && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "\u0437\u0430 \u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438";
        else return "\u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438 \u0442\u043E\u043C\u0443";
    }
    return "\u043F\u0456\u0432\u0445\u0432\u0438\u043B\u0438\u043D\u0438";
};
var $c68652fd966943e1$var$formatDistanceLocale = {
    lessThanXSeconds: $c68652fd966943e1$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448\u0435 \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    xSeconds: $c68652fd966943e1$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0430",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        },
        past: {
            singularNominative: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443 \u0442\u043E\u043C\u0443",
            singularGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438 \u0442\u043E\u043C\u0443",
            pluralGenitive: "{{count}} \u0441\u0435\u043A\u0443\u043D\u0434 \u0442\u043E\u043C\u0443"
        },
        future: {
            singularNominative: "\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0443",
            singularGenitive: "\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434\u0438",
            pluralGenitive: "\u0437\u0430 {{count}} \u0441\u0435\u043A\u0443\u043D\u0434"
        }
    }),
    halfAMinute: $c68652fd966943e1$var$halfAtMinute,
    lessThanXMinutes: $c68652fd966943e1$var$buildLocalizeTokenFn({
        regular: {
            one: "\u043C\u0435\u043D\u0448\u0435 \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        },
        future: {
            one: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
            singularNominative: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
            singularGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            pluralGenitive: "\u043C\u0435\u043D\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        }
    }),
    xMinutes: $c68652fd966943e1$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0430",
            singularGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            pluralGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        },
        past: {
            singularNominative: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443 \u0442\u043E\u043C\u0443",
            singularGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438 \u0442\u043E\u043C\u0443",
            pluralGenitive: "{{count}} \u0445\u0432\u0438\u043B\u0438\u043D \u0442\u043E\u043C\u0443"
        },
        future: {
            singularNominative: "\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0443",
            singularGenitive: "\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D\u0438",
            pluralGenitive: "\u0437\u0430 {{count}} \u0445\u0432\u0438\u043B\u0438\u043D"
        }
    }),
    aboutXHours: $c68652fd966943e1$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0433\u043E\u0434\u0438\u043D"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D\u0443",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0433\u043E\u0434\u0438\u043D"
        }
    }),
    xHours: $c68652fd966943e1$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0443",
            singularGenitive: "{{count}} \u0433\u043E\u0434\u0438\u043D\u0438",
            pluralGenitive: "{{count}} \u0433\u043E\u0434\u0438\u043D"
        }
    }),
    xDays: $c68652fd966943e1$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0434\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0434\u043Di",
            pluralGenitive: "{{count}} \u0434\u043D\u0456\u0432"
        }
    }),
    aboutXWeeks: $c68652fd966943e1$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u044F",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u0456\u0432",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0442\u0438\u0436\u043D\u0456\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u0434\u0435\u043D\u044C",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u043D\u0456",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0442\u0438\u0436\u043D\u0456\u0432"
        }
    }),
    xWeeks: $c68652fd966943e1$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0442\u0438\u0436\u0434\u0435\u043D\u044C",
            singularGenitive: "{{count}} \u0442\u0438\u0436\u043D\u0456",
            pluralGenitive: "{{count}} \u0442\u0438\u0436\u043D\u0456\u0432"
        }
    }),
    aboutXMonths: $c68652fd966943e1$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u044F",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u044C",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u0456",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
        }
    }),
    xMonths: $c68652fd966943e1$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u043C\u0456\u0441\u044F\u0446\u044C",
            singularGenitive: "{{count}} \u043C\u0456\u0441\u044F\u0446\u0456",
            pluralGenitive: "{{count}} \u043C\u0456\u0441\u044F\u0446\u0456\u0432"
        }
    }),
    aboutXYears: $c68652fd966943e1$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0443",
            singularGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0456\u0432",
            pluralGenitive: "\u0431\u043B\u0438\u0437\u044C\u043A\u043E {{count}} \u0440\u043E\u043A\u0456\u0432"
        },
        future: {
            singularNominative: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u043F\u0440\u0438\u0431\u043B\u0438\u0437\u043D\u043E \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    }),
    xYears: $c68652fd966943e1$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "{{count}} \u0440\u0456\u043A",
            singularGenitive: "{{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "{{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    }),
    overXYears: $c68652fd966943e1$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0443",
            singularGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432",
            pluralGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432"
        },
        future: {
            singularNominative: "\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u0431\u0456\u043B\u044C\u0448\u0435, \u043D\u0456\u0436 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    }),
    almostXYears: $c68652fd966943e1$var$buildLocalizeTokenFn({
        regular: {
            singularNominative: "\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u043C\u0430\u0439\u0436\u0435 {{count}} \u0440\u043E\u043A\u0456\u0432"
        },
        future: {
            singularNominative: "\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u0456\u043A",
            singularGenitive: "\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0438",
            pluralGenitive: "\u043C\u0430\u0439\u0436\u0435 \u0437\u0430 {{count}} \u0440\u043E\u043A\u0456\u0432"
        }
    })
};
var $c68652fd966943e1$var$formatDistance = function formatDistance(token, count, options) {
    options = options || {};
    return $c68652fd966943e1$var$formatDistanceLocale[token](count, options);
};
var $c68652fd966943e1$export$2e2bcd8739ae039 = $c68652fd966943e1$var$formatDistance;

});

parcelRegister("8VXem", function(module, exports) {

$parcel$export(module.exports, "default", () => $68119793dd66ed9a$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $68119793dd66ed9a$var$dateFormats = {
    full: "EEEE, do MMMM y '\u0440.'",
    long: "do MMMM y '\u0440.'",
    medium: "d MMM y '\u0440.'",
    short: "dd.MM.y"
};
var $68119793dd66ed9a$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
var $68119793dd66ed9a$var$dateTimeFormats = {
    full: "{{date}} '\u043E' {{time}}",
    long: "{{date}} '\u043E' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $68119793dd66ed9a$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $68119793dd66ed9a$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $68119793dd66ed9a$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $68119793dd66ed9a$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $68119793dd66ed9a$export$2e2bcd8739ae039 = $68119793dd66ed9a$var$formatLong;

});

parcelRegister("bSfD0", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a50dc4c965841c1$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $6KZXu = parcelRequire("6KZXu");
var $8a50dc4c965841c1$var$accusativeWeekdays = [
    "\u043D\u0435\u0434\u0456\u043B\u044E",
    "\u043F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A",
    "\u0432\u0456\u0432\u0442\u043E\u0440\u043E\u043A",
    "\u0441\u0435\u0440\u0435\u0434\u0443",
    "\u0447\u0435\u0442\u0432\u0435\u0440",
    "\u043F\u2019\u044F\u0442\u043D\u0438\u0446\u044E",
    "\u0441\u0443\u0431\u043E\u0442\u0443"
];
function $8a50dc4c965841c1$var$lastWeek(day) {
    var weekday = $8a50dc4c965841c1$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043C\u0438\u043D\u0443\u043B\u0443 " + weekday + " \u043E' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043C\u0438\u043D\u0443\u043B\u0438\u0439 " + weekday + " \u043E' p";
    }
}
function $8a50dc4c965841c1$var$thisWeek(day) {
    var weekday = $8a50dc4c965841c1$var$accusativeWeekdays[day];
    return "'\u0443 " + weekday + " \u043E' p";
}
function $8a50dc4c965841c1$var$nextWeek(day) {
    var weekday = $8a50dc4c965841c1$var$accusativeWeekdays[day];
    switch(day){
        case 0:
        case 3:
        case 5:
        case 6:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0443 " + weekday + " \u043E' p";
        case 1:
        case 2:
        case 4:
            return "'\u0443 \u043D\u0430\u0441\u0442\u0443\u043F\u043D\u0438\u0439 " + weekday + " \u043E' p";
    }
}
var $8a50dc4c965841c1$var$lastWeekFormat = function lastWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, $gdr0J.default)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $6KZXu.default)(date, baseDate, options)) return $8a50dc4c965841c1$var$thisWeek(day);
    else return $8a50dc4c965841c1$var$lastWeek(day);
};
var $8a50dc4c965841c1$var$nextWeekFormat = function nextWeekFormat(dirtyDate, baseDate, options) {
    var date = (0, $gdr0J.default)(dirtyDate);
    var day = date.getUTCDay();
    if ((0, $6KZXu.default)(date, baseDate, options)) return $8a50dc4c965841c1$var$thisWeek(day);
    else return $8a50dc4c965841c1$var$nextWeek(day);
};
var $8a50dc4c965841c1$var$formatRelativeLocale = {
    lastWeek: $8a50dc4c965841c1$var$lastWeekFormat,
    yesterday: "'\u0432\u0447\u043E\u0440\u0430 \u043E' p",
    today: "'\u0441\u044C\u043E\u0433\u043E\u0434\u043D\u0456 \u043E' p",
    tomorrow: "'\u0437\u0430\u0432\u0442\u0440\u0430 \u043E' p",
    nextWeek: $8a50dc4c965841c1$var$nextWeekFormat,
    other: "P"
};
var $8a50dc4c965841c1$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $8a50dc4c965841c1$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
var $8a50dc4c965841c1$export$2e2bcd8739ae039 = $8a50dc4c965841c1$var$formatRelative;

});

parcelRegister("bvcNk", function(module, exports) {

$parcel$export(module.exports, "default", () => $85fc83b0db9c71f9$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $85fc83b0db9c71f9$var$eraValues = {
    narrow: [
        "\u0434\u043E \u043D.\u0435.",
        "\u043D.\u0435."
    ],
    abbreviated: [
        "\u0434\u043E \u043D. \u0435.",
        "\u043D. \u0435."
    ],
    wide: [
        "\u0434\u043E \u043D\u0430\u0448\u043E\u0457 \u0435\u0440\u0438",
        "\u043D\u0430\u0448\u043E\u0457 \u0435\u0440\u0438"
    ]
};
var $85fc83b0db9c71f9$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-\u0439 \u043A\u0432.",
        "2-\u0439 \u043A\u0432.",
        "3-\u0439 \u043A\u0432.",
        "4-\u0439 \u043A\u0432."
    ],
    wide: [
        "1-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "2-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "3-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B",
        "4-\u0439 \u043A\u0432\u0430\u0440\u0442\u0430\u043B"
    ]
};
var $85fc83b0db9c71f9$var$monthValues = {
    // ДСТУ 3582:2013
    narrow: [
        "\u0421",
        "\u041B",
        "\u0411",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0421",
        "\u0412",
        "\u0416",
        "\u041B",
        "\u0413"
    ],
    abbreviated: [
        "\u0441\u0456\u0447.",
        "\u043B\u044E\u0442.",
        "\u0431\u0435\u0440\u0435\u0437.",
        "\u043A\u0432\u0456\u0442.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u0435\u0440\u0432.",
        "\u043B\u0438\u043F.",
        "\u0441\u0435\u0440\u043F.",
        "\u0432\u0435\u0440\u0435\u0441.",
        "\u0436\u043E\u0432\u0442.",
        "\u043B\u0438\u0441\u0442\u043E\u043F.",
        "\u0433\u0440\u0443\u0434."
    ],
    wide: [
        "\u0441\u0456\u0447\u0435\u043D\u044C",
        "\u043B\u044E\u0442\u0438\u0439",
        "\u0431\u0435\u0440\u0435\u0437\u0435\u043D\u044C",
        "\u043A\u0432\u0456\u0442\u0435\u043D\u044C",
        "\u0442\u0440\u0430\u0432\u0435\u043D\u044C",
        "\u0447\u0435\u0440\u0432\u0435\u043D\u044C",
        "\u043B\u0438\u043F\u0435\u043D\u044C",
        "\u0441\u0435\u0440\u043F\u0435\u043D\u044C",
        "\u0432\u0435\u0440\u0435\u0441\u0435\u043D\u044C",
        "\u0436\u043E\u0432\u0442\u0435\u043D\u044C",
        "\u043B\u0438\u0441\u0442\u043E\u043F\u0430\u0434",
        "\u0433\u0440\u0443\u0434\u0435\u043D\u044C"
    ]
};
var $85fc83b0db9c71f9$var$formattingMonthValues = {
    narrow: [
        "\u0421",
        "\u041B",
        "\u0411",
        "\u041A",
        "\u0422",
        "\u0427",
        "\u041B",
        "\u0421",
        "\u0412",
        "\u0416",
        "\u041B",
        "\u0413"
    ],
    abbreviated: [
        "\u0441\u0456\u0447.",
        "\u043B\u044E\u0442.",
        "\u0431\u0435\u0440\u0435\u0437.",
        "\u043A\u0432\u0456\u0442.",
        "\u0442\u0440\u0430\u0432.",
        "\u0447\u0435\u0440\u0432.",
        "\u043B\u0438\u043F.",
        "\u0441\u0435\u0440\u043F.",
        "\u0432\u0435\u0440\u0435\u0441.",
        "\u0436\u043E\u0432\u0442.",
        "\u043B\u0438\u0441\u0442\u043E\u043F.",
        "\u0433\u0440\u0443\u0434."
    ],
    wide: [
        "\u0441\u0456\u0447\u043D\u044F",
        "\u043B\u044E\u0442\u043E\u0433\u043E",
        "\u0431\u0435\u0440\u0435\u0437\u043D\u044F",
        "\u043A\u0432\u0456\u0442\u043D\u044F",
        "\u0442\u0440\u0430\u0432\u043D\u044F",
        "\u0447\u0435\u0440\u0432\u043D\u044F",
        "\u043B\u0438\u043F\u043D\u044F",
        "\u0441\u0435\u0440\u043F\u043D\u044F",
        "\u0432\u0435\u0440\u0435\u0441\u043D\u044F",
        "\u0436\u043E\u0432\u0442\u043D\u044F",
        "\u043B\u0438\u0441\u0442\u043E\u043F\u0430\u0434\u0430",
        "\u0433\u0440\u0443\u0434\u043D\u044F"
    ]
};
var $85fc83b0db9c71f9$var$dayValues = {
    narrow: [
        "\u041D",
        "\u041F",
        "\u0412",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0421"
    ],
    short: [
        "\u043D\u0434",
        "\u043F\u043D",
        "\u0432\u0442",
        "\u0441\u0440",
        "\u0447\u0442",
        "\u043F\u0442",
        "\u0441\u0431"
    ],
    abbreviated: [
        "\u043D\u0435\u0434",
        "\u043F\u043E\u043D",
        "\u0432\u0456\u0432",
        "\u0441\u0435\u0440",
        "\u0447\u0442\u0432",
        "\u043F\u0442\u043D",
        "\u0441\u0443\u0431"
    ],
    wide: [
        "\u043D\u0435\u0434\u0456\u043B\u044F",
        "\u043F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A",
        "\u0432\u0456\u0432\u0442\u043E\u0440\u043E\u043A",
        "\u0441\u0435\u0440\u0435\u0434\u0430",
        "\u0447\u0435\u0442\u0432\u0435\u0440",
        "\u043F\u2019\u044F\u0442\u043D\u0438\u0446\u044F",
        "\u0441\u0443\u0431\u043E\u0442\u0430"
    ]
};
var $85fc83b0db9c71f9$var$dayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043E\u043A",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u0456\u0447"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043E\u043A",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u0456\u0447"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D\u0456\u0447",
        noon: "\u043F\u043E\u043B\u0443\u0434\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u043E\u043A",
        afternoon: "\u0434\u0435\u043D\u044C",
        evening: "\u0432\u0435\u0447\u0456\u0440",
        night: "\u043D\u0456\u0447"
    }
};
var $85fc83b0db9c71f9$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043A\u0443",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0456"
    },
    abbreviated: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D.",
        noon: "\u043F\u043E\u043B.",
        morning: "\u0440\u0430\u043D\u043A\u0443",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0456"
    },
    wide: {
        am: "\u0414\u041F",
        pm: "\u041F\u041F",
        midnight: "\u043F\u0456\u0432\u043D\u0456\u0447",
        noon: "\u043F\u043E\u043B\u0443\u0434\u0435\u043D\u044C",
        morning: "\u0440\u0430\u043D\u043A\u0443",
        afternoon: "\u0434\u043D\u044F",
        evening: "\u0432\u0435\u0447.",
        night: "\u043D\u043E\u0447\u0456"
    }
};
var $85fc83b0db9c71f9$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var unit = String(options === null || options === void 0 ? void 0 : options.unit);
    var number = Number(dirtyNumber);
    var suffix;
    if (unit === "date") {
        if (number === 3 || number === 23) suffix = "-\u0454";
        else suffix = "-\u0435";
    } else if (unit === "minute" || unit === "second" || unit === "hour") suffix = "-\u0430";
    else suffix = "-\u0439";
    return number + suffix;
};
var $85fc83b0db9c71f9$var$localize = {
    ordinalNumber: $85fc83b0db9c71f9$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $85fc83b0db9c71f9$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $85fc83b0db9c71f9$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $85fc83b0db9c71f9$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $85fc83b0db9c71f9$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $85fc83b0db9c71f9$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $85fc83b0db9c71f9$var$dayPeriodValues,
        defaultWidth: "any",
        formattingValues: $85fc83b0db9c71f9$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $85fc83b0db9c71f9$export$2e2bcd8739ae039 = $85fc83b0db9c71f9$var$localize;

});

parcelRegister("1xYQ7", function(module, exports) {

$parcel$export(module.exports, "default", () => $120810fb01438ab2$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $120810fb01438ab2$var$matchOrdinalNumberPattern = /^(\d+)(-?(е|й|є|а|я))?/i;
var $120810fb01438ab2$var$parseOrdinalNumberPattern = /\d+/i;
var $120810fb01438ab2$var$matchEraPatterns = {
    narrow: /^((до )?н\.?\s?е\.?)/i,
    abbreviated: /^((до )?н\.?\s?е\.?)/i,
    wide: /^(до нашої ери|нашої ери|наша ера)/i
};
var $120810fb01438ab2$var$parseEraPatterns = {
    any: [
        /^д/i,
        /^н/i
    ]
};
var $120810fb01438ab2$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234](-?[иі]?й?)? кв.?/i,
    wide: /^[1234](-?[иі]?й?)? квартал/i
};
var $120810fb01438ab2$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $120810fb01438ab2$var$matchMonthPatterns = {
    narrow: /^[слбктчвжг]/i,
    abbreviated: /^(січ|лют|бер(ез)?|квіт|трав|черв|лип|серп|вер(ес)?|жовт|лис(топ)?|груд)\.?/i,
    wide: /^(січень|січня|лютий|лютого|березень|березня|квітень|квітня|травень|травня|червня|червень|липень|липня|серпень|серпня|вересень|вересня|жовтень|жовтня|листопад[а]?|грудень|грудня)/i
};
var $120810fb01438ab2$var$parseMonthPatterns = {
    narrow: [
        /^с/i,
        /^л/i,
        /^б/i,
        /^к/i,
        /^т/i,
        /^ч/i,
        /^л/i,
        /^с/i,
        /^в/i,
        /^ж/i,
        /^л/i,
        /^г/i
    ],
    any: [
        /^сі/i,
        /^лю/i,
        /^б/i,
        /^к/i,
        /^т/i,
        /^ч/i,
        /^лип/i,
        /^се/i,
        /^в/i,
        /^ж/i,
        /^лис/i,
        /^г/i
    ]
};
var $120810fb01438ab2$var$matchDayPatterns = {
    narrow: /^[нпвсч]/i,
    short: /^(нд|пн|вт|ср|чт|пт|сб)\.?/i,
    abbreviated: /^(нед|пон|вів|сер|че?тв|птн?|суб)\.?/i,
    wide: /^(неділ[яі]|понеділ[ок][ка]|вівтор[ок][ка]|серед[аи]|четвер(га)?|п\W*?ятниц[яі]|субот[аи])/i
};
var $120810fb01438ab2$var$parseDayPatterns = {
    narrow: [
        /^н/i,
        /^п/i,
        /^в/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^с/i
    ],
    any: [
        /^н/i,
        /^п[он]/i,
        /^в/i,
        /^с[ер]/i,
        /^ч/i,
        /^п\W*?[ят]/i,
        /^с[уб]/i
    ]
};
var $120810fb01438ab2$var$matchDayPeriodPatterns = {
    narrow: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
    abbreviated: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
    wide: /^([дп]п|північ|полудень|ранок|ранку|день|дня|вечір|вечора|ніч|ночі)/i
};
var $120810fb01438ab2$var$parseDayPeriodPatterns = {
    any: {
        am: /^дп/i,
        pm: /^пп/i,
        midnight: /^півн/i,
        noon: /^пол/i,
        morning: /^р/i,
        afternoon: /^д[ен]/i,
        evening: /^в/i,
        night: /^н/i
    }
};
var $120810fb01438ab2$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $120810fb01438ab2$var$matchOrdinalNumberPattern,
        parsePattern: $120810fb01438ab2$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $120810fb01438ab2$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $120810fb01438ab2$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $120810fb01438ab2$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $120810fb01438ab2$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $120810fb01438ab2$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $120810fb01438ab2$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $120810fb01438ab2$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $120810fb01438ab2$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $120810fb01438ab2$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $120810fb01438ab2$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $120810fb01438ab2$export$2e2bcd8739ae039 = $120810fb01438ab2$var$match;

});


parcelRegister("bvaKV", function(module, exports) {

$parcel$export(module.exports, "default", () => $85faeed9d0e091f8$export$2e2bcd8739ae039);

var $61TM8 = parcelRequire("61TM8");

var $8VUq4 = parcelRequire("8VUq4");

var $fm7Ei = parcelRequire("fm7Ei");

var $afhIU = parcelRequire("afhIU");

var $bSwBd = parcelRequire("bSwBd");
/**
 * @type {Locale}
 * @category Locales
 * @summary Uzbek locale.
 * @language Uzbek
 * @iso-639-2 uzb
 * @author Mukhammadali [@mukhammadali]{@link https://github.com/Mukhammadali}
 */ var $85faeed9d0e091f8$var$locale = {
    code: "uz",
    formatDistance: (0, $61TM8.default),
    formatLong: (0, $8VUq4.default),
    formatRelative: (0, $fm7Ei.default),
    localize: (0, $afhIU.default),
    match: (0, $bSwBd.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $85faeed9d0e091f8$export$2e2bcd8739ae039 = $85faeed9d0e091f8$var$locale;

});
parcelRegister("61TM8", function(module, exports) {

$parcel$export(module.exports, "default", () => $463e19e51fba0f61$export$2e2bcd8739ae039);
var $463e19e51fba0f61$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "sekunddan kam",
        other: "{{count}} sekunddan kam"
    },
    xSeconds: {
        one: "1 sekund",
        other: "{{count}} sekund"
    },
    halfAMinute: "yarim minut",
    lessThanXMinutes: {
        one: "bir minutdan kam",
        other: "{{count}} minutdan kam"
    },
    xMinutes: {
        one: "1 minut",
        other: "{{count}} minut"
    },
    aboutXHours: {
        one: "tahminan 1 soat",
        other: "tahminan {{count}} soat"
    },
    xHours: {
        one: "1 soat",
        other: "{{count}} soat"
    },
    xDays: {
        one: "1 kun",
        other: "{{count}} kun"
    },
    aboutXWeeks: {
        one: "tahminan 1 hafta",
        other: "tahminan {{count}} hafta"
    },
    xWeeks: {
        one: "1 hafta",
        other: "{{count}} hafta"
    },
    aboutXMonths: {
        one: "tahminan 1 oy",
        other: "tahminan {{count}} oy"
    },
    xMonths: {
        one: "1 oy",
        other: "{{count}} oy"
    },
    aboutXYears: {
        one: "tahminan 1 yil",
        other: "tahminan {{count}} yil"
    },
    xYears: {
        one: "1 yil",
        other: "{{count}} yil"
    },
    overXYears: {
        one: "1 yildan ko'p",
        other: "{{count}} yildan ko'p"
    },
    almostXYears: {
        one: "deyarli 1 yil",
        other: "deyarli {{count}} yil"
    }
};
var $463e19e51fba0f61$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $463e19e51fba0f61$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " dan keyin";
        else return result + " oldin";
    }
    return result;
};
var $463e19e51fba0f61$export$2e2bcd8739ae039 = $463e19e51fba0f61$var$formatDistance;

});

parcelRegister("8VUq4", function(module, exports) {

$parcel$export(module.exports, "default", () => $680f695010d339a3$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $680f695010d339a3$var$dateFormats = {
    full: "EEEE, do MMMM, y",
    long: "do MMMM, y",
    medium: "d MMM, y",
    short: "dd/MM/yyyy"
};
var $680f695010d339a3$var$timeFormats = {
    full: "h:mm:ss zzzz",
    long: "h:mm:ss z",
    medium: "h:mm:ss",
    short: "h:mm"
};
var $680f695010d339a3$var$dateTimeFormats = {
    any: "{{date}}, {{time}}"
};
var $680f695010d339a3$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $680f695010d339a3$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $680f695010d339a3$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $680f695010d339a3$var$dateTimeFormats,
        defaultWidth: "any"
    })
};
var $680f695010d339a3$export$2e2bcd8739ae039 = $680f695010d339a3$var$formatLong;

});

parcelRegister("fm7Ei", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2ded7fd7b89c980$export$2e2bcd8739ae039);
var $b2ded7fd7b89c980$var$formatRelativeLocale = {
    lastWeek: "'oldingi' eeee p 'da'",
    yesterday: "'kecha' p 'da'",
    today: "'bugun' p 'da'",
    tomorrow: "'ertaga' p 'da'",
    nextWeek: "eeee p 'da'",
    other: "P"
};
var $b2ded7fd7b89c980$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $b2ded7fd7b89c980$var$formatRelativeLocale[token];
};
var $b2ded7fd7b89c980$export$2e2bcd8739ae039 = $b2ded7fd7b89c980$var$formatRelative;

});

parcelRegister("afhIU", function(module, exports) {

$parcel$export(module.exports, "default", () => $77590d923bd47c5b$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $77590d923bd47c5b$var$eraValues = {
    narrow: [
        "M.A",
        "M."
    ],
    abbreviated: [
        "M.A",
        "M."
    ],
    wide: [
        "Miloddan Avvalgi",
        "Milodiy"
    ]
};
var $77590d923bd47c5b$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "CH.1",
        "CH.2",
        "CH.3",
        "CH.4"
    ],
    wide: [
        "1-chi chorak",
        "2-chi chorak",
        "3-chi chorak",
        "4-chi chorak"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $77590d923bd47c5b$var$monthValues = {
    narrow: [
        "Y",
        "F",
        "M",
        "A",
        "M",
        "I",
        "I",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Yan",
        "Fev",
        "Mar",
        "Apr",
        "May",
        "Iyun",
        "Iyul",
        "Avg",
        "Sen",
        "Okt",
        "Noy",
        "Dek"
    ],
    wide: [
        "Yanvar",
        "Fevral",
        "Mart",
        "Aprel",
        "May",
        "Iyun",
        "Iyul",
        "Avgust",
        "Sentabr",
        "Oktabr",
        "Noyabr",
        "Dekabr"
    ]
};
var $77590d923bd47c5b$var$dayValues = {
    narrow: [
        "Y",
        "D",
        "S",
        "CH",
        "P",
        "J",
        "SH"
    ],
    short: [
        "Ya",
        "Du",
        "Se",
        "Cho",
        "Pa",
        "Ju",
        "Sha"
    ],
    abbreviated: [
        "Yak",
        "Dush",
        "Sesh",
        "Chor",
        "Pay",
        "Jum",
        "Shan"
    ],
    wide: [
        "Yakshanba",
        "Dushanba",
        "Seshanba",
        "Chorshanba",
        "Payshanba",
        "Juma",
        "Shanba"
    ]
};
var $77590d923bd47c5b$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "y.t",
        noon: "p.",
        morning: "ertalab",
        afternoon: "tushdan keyin",
        evening: "kechqurun",
        night: "tun"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "yarim tun",
        noon: "peshin",
        morning: "ertalab",
        afternoon: "tushdan keyin",
        evening: "kechqurun",
        night: "tun"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "yarim tun",
        noon: "peshin",
        morning: "ertalab",
        afternoon: "tushdan keyin",
        evening: "kechqurun",
        night: "tun"
    }
};
var $77590d923bd47c5b$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "y.t",
        noon: "p.",
        morning: "ertalab",
        afternoon: "tushdan keyin",
        evening: "kechqurun",
        night: "tun"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "yarim tun",
        noon: "peshin",
        morning: "ertalab",
        afternoon: "tushdan keyin",
        evening: "kechqurun",
        night: "tun"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "yarim tun",
        noon: "peshin",
        morning: "ertalab",
        afternoon: "tushdan keyin",
        evening: "kechqurun",
        night: "tun"
    }
};
var $77590d923bd47c5b$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $77590d923bd47c5b$var$localize = {
    ordinalNumber: $77590d923bd47c5b$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $77590d923bd47c5b$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $77590d923bd47c5b$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $77590d923bd47c5b$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $77590d923bd47c5b$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $77590d923bd47c5b$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $77590d923bd47c5b$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $77590d923bd47c5b$export$2e2bcd8739ae039 = $77590d923bd47c5b$var$localize;

});

parcelRegister("bSwBd", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a5e065cf1d8b622$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $8a5e065cf1d8b622$var$matchOrdinalNumberPattern = /^(\d+)(chi)?/i;
var $8a5e065cf1d8b622$var$parseOrdinalNumberPattern = /\d+/i;
var $8a5e065cf1d8b622$var$matchEraPatterns = {
    narrow: /^(m\.a|m\.)/i,
    abbreviated: /^(m\.a\.?\s?m\.?)/i,
    wide: /^(miloddan avval|miloddan keyin)/i
};
var $8a5e065cf1d8b622$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $8a5e065cf1d8b622$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](chi)? chorak/i
};
var $8a5e065cf1d8b622$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $8a5e065cf1d8b622$var$matchMonthPatterns = {
    narrow: /^[yfmasond]/i,
    abbreviated: /^(yan|fev|mar|apr|may|iyun|iyul|avg|sen|okt|noy|dek)/i,
    wide: /^(yanvar|fevral|mart|aprel|may|iyun|iyul|avgust|sentabr|oktabr|noyabr|dekabr)/i
};
var $8a5e065cf1d8b622$var$parseMonthPatterns = {
    narrow: [
        /^y/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^i/i,
        /^i/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ya/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^iyun/i,
        /^iyul/i,
        /^av/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $8a5e065cf1d8b622$var$matchDayPatterns = {
    narrow: /^[ydschj]/i,
    short: /^(ya|du|se|cho|pa|ju|sha)/i,
    abbreviated: /^(yak|dush|sesh|chor|pay|jum|shan)/i,
    wide: /^(yakshanba|dushanba|seshanba|chorshanba|payshanba|juma|shanba)/i
};
var $8a5e065cf1d8b622$var$parseDayPatterns = {
    narrow: [
        /^y/i,
        /^d/i,
        /^s/i,
        /^ch/i,
        /^p/i,
        /^j/i,
        /^sh/i
    ],
    any: [
        /^ya/i,
        /^d/i,
        /^se/i,
        /^ch/i,
        /^p/i,
        /^j/i,
        /^sh/i
    ]
};
var $8a5e065cf1d8b622$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|y\.t|p| (ertalab|tushdan keyin|kechqurun|tun))/i,
    any: /^([ap]\.?\s?m\.?|yarim tun|peshin| (ertalab|tushdan keyin|kechqurun|tun))/i
};
var $8a5e065cf1d8b622$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^y\.t/i,
        noon: /^pe/i,
        morning: /ertalab/i,
        afternoon: /tushdan keyin/i,
        evening: /kechqurun/i,
        night: /tun/i
    }
};
var $8a5e065cf1d8b622$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $8a5e065cf1d8b622$var$matchOrdinalNumberPattern,
        parsePattern: $8a5e065cf1d8b622$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $8a5e065cf1d8b622$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8a5e065cf1d8b622$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $8a5e065cf1d8b622$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8a5e065cf1d8b622$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $8a5e065cf1d8b622$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8a5e065cf1d8b622$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $8a5e065cf1d8b622$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $8a5e065cf1d8b622$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $8a5e065cf1d8b622$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $8a5e065cf1d8b622$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $8a5e065cf1d8b622$export$2e2bcd8739ae039 = $8a5e065cf1d8b622$var$match;

});


parcelRegister("ee0r7", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5b2b62b601a68a3$export$2e2bcd8739ae039);

var $1l9Ig = parcelRequire("1l9Ig");

var $g7mam = parcelRequire("g7mam");

var $aTa6j = parcelRequire("aTa6j");

var $dwQpK = parcelRequire("dwQpK");

var $2IBNS = parcelRequire("2IBNS");
/**
 * @type {Locale}
 * @category Locales
 * @summary Uzbek Cyrillic locale.
 * @language Uzbek
 * @iso-639-2 uzb
 * @author Kamronbek Shodmonov [@kamronbek28]{@link https://github.com/kamronbek28}
 */ var $a5b2b62b601a68a3$var$locale = {
    code: "uz-Cyrl",
    formatDistance: (0, $1l9Ig.default),
    formatLong: (0, $g7mam.default),
    formatRelative: (0, $aTa6j.default),
    localize: (0, $dwQpK.default),
    match: (0, $2IBNS.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1
    }
};
var $a5b2b62b601a68a3$export$2e2bcd8739ae039 = $a5b2b62b601a68a3$var$locale;

});
parcelRegister("1l9Ig", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f9f49666451eb0f$export$2e2bcd8739ae039);
var $0f9f49666451eb0f$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "1 \u0441\u043E\u043D\u0438\u044F\u0434\u0430\u043D \u043A\u0430\u043C",
        other: "{{count}} \u0441\u043E\u043D\u0438\u044F\u0434\u0430\u043D \u043A\u0430\u043C"
    },
    xSeconds: {
        one: "1 \u0441\u043E\u043D\u0438\u044F",
        other: "{{count}} \u0441\u043E\u043D\u0438\u044F"
    },
    halfAMinute: "\u044F\u0440\u0438\u043C \u0434\u0430\u049B\u0438\u049B\u0430",
    lessThanXMinutes: {
        one: "1 \u0434\u0430\u049B\u0438\u049B\u0430\u0434\u0430\u043D \u043A\u0430\u043C",
        other: "{{count}} \u0434\u0430\u049B\u0438\u049B\u0430\u0434\u0430\u043D \u043A\u0430\u043C"
    },
    xMinutes: {
        one: "1 \u0434\u0430\u049B\u0438\u049B\u0430",
        other: "{{count}} \u0434\u0430\u049B\u0438\u049B\u0430"
    },
    aboutXHours: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u0441\u043E\u0430\u0442",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u0441\u043E\u0430\u0442"
    },
    xHours: {
        one: "1 \u0441\u043E\u0430\u0442",
        other: "{{count}} \u0441\u043E\u0430\u0442"
    },
    xDays: {
        one: "1 \u043A\u0443\u043D",
        other: "{{count}} \u043A\u0443\u043D"
    },
    aboutXWeeks: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u0445\u0430\u0444\u0442\u0430",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u0445\u0430\u0444\u0442\u0430"
    },
    xWeeks: {
        one: "1 \u0445\u0430\u0444\u0442\u0430",
        other: "{{count}} \u0445\u0430\u0444\u0442\u0430"
    },
    aboutXMonths: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u043E\u0439",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u043E\u0439"
    },
    xMonths: {
        one: "1 \u043E\u0439",
        other: "{{count}} \u043E\u0439"
    },
    aboutXYears: {
        one: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D 1 \u0439\u0438\u043B",
        other: "\u0442\u0430\u0445\u043C\u0438\u043D\u0430\u043D {{count}} \u0439\u0438\u043B"
    },
    xYears: {
        one: "1 \u0439\u0438\u043B",
        other: "{{count}} \u0439\u0438\u043B"
    },
    overXYears: {
        one: "1 \u0439\u0438\u043B\u0434\u0430\u043D \u043A\u045E\u043F",
        other: "{{count}} \u0439\u0438\u043B\u0434\u0430\u043D \u043A\u045E\u043F"
    },
    almostXYears: {
        one: "\u0434\u0435\u044F\u0440\u043B\u0438 1 \u0439\u0438\u043B",
        other: "\u0434\u0435\u044F\u0440\u043B\u0438 {{count}} \u0439\u0438\u043B"
    }
};
var $0f9f49666451eb0f$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $0f9f49666451eb0f$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u0434\u0430\u043D \u043A\u0435\u0439\u0438\u043D";
        else return result + " \u043E\u043B\u0434\u0438\u043D";
    }
    return result;
};
var $0f9f49666451eb0f$export$2e2bcd8739ae039 = $0f9f49666451eb0f$var$formatDistance;

});

parcelRegister("g7mam", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbbe7e817076bd44$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $bbbe7e817076bd44$var$dateFormats = {
    full: "EEEE, do MMMM, y",
    long: "do MMMM, y",
    medium: "d MMM, y",
    short: "dd/MM/yyyy"
};
var $bbbe7e817076bd44$var$timeFormats = {
    full: "H:mm:ss zzzz",
    long: "H:mm:ss z",
    medium: "H:mm:ss",
    short: "H:mm"
};
var $bbbe7e817076bd44$var$dateTimeFormats = {
    any: "{{date}}, {{time}}"
};
var $bbbe7e817076bd44$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $bbbe7e817076bd44$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $bbbe7e817076bd44$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $bbbe7e817076bd44$var$dateTimeFormats,
        defaultWidth: "any"
    })
};
var $bbbe7e817076bd44$export$2e2bcd8739ae039 = $bbbe7e817076bd44$var$formatLong;

});

parcelRegister("aTa6j", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ed6e042e9f329bb$export$2e2bcd8739ae039);
var $7ed6e042e9f329bb$var$formatRelativeLocale = {
    lastWeek: "'\u045E\u0442\u0433\u0430\u043D' eeee p '\u0434\u0430'",
    yesterday: "'\u043A\u0435\u0447\u0430' p '\u0434\u0430'",
    today: "'\u0431\u0443\u0433\u0443\u043D' p '\u0434\u0430'",
    tomorrow: "'\u044D\u0440\u0442\u0430\u0433\u0430' p '\u0434\u0430'",
    nextWeek: "eeee p '\u0434\u0430'",
    other: "P"
};
var $7ed6e042e9f329bb$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $7ed6e042e9f329bb$var$formatRelativeLocale[token];
};
var $7ed6e042e9f329bb$export$2e2bcd8739ae039 = $7ed6e042e9f329bb$var$formatRelative;

});

parcelRegister("dwQpK", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d96ebe2cd199508$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $9d96ebe2cd199508$var$eraValues = {
    narrow: [
        "\u041C.\u0410",
        "\u041C"
    ],
    abbreviated: [
        "\u041C.\u0410",
        "\u041C"
    ],
    wide: [
        "\u041C\u0438\u043B\u043E\u0434\u0434\u0430\u043D \u0410\u0432\u0432\u0430\u043B\u0433\u0438",
        "\u041C\u0438\u043B\u043E\u0434\u0438\u0439"
    ]
};
var $9d96ebe2cd199508$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "1-\u0447\u043E\u0440.",
        "2-\u0447\u043E\u0440.",
        "3-\u0447\u043E\u0440.",
        "4-\u0447\u043E\u0440."
    ],
    wide: [
        "1-\u0447\u043E\u0440\u0430\u043A",
        "2-\u0447\u043E\u0440\u0430\u043A",
        "3-\u0447\u043E\u0440\u0430\u043A",
        "4-\u0447\u043E\u0440\u0430\u043A"
    ]
};
var $9d96ebe2cd199508$var$monthValues = {
    narrow: [
        "\u042F",
        "\u0424",
        "\u041C",
        "\u0410",
        "\u041C",
        "\u0418",
        "\u0418",
        "\u0410",
        "\u0421",
        "\u041E",
        "\u041D",
        "\u0414"
    ],
    abbreviated: [
        "\u044F\u043D\u0432",
        "\u0444\u0435\u0432",
        "\u043C\u0430\u0440",
        "\u0430\u043F\u0440",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D",
        "\u0438\u044E\u043B",
        "\u0430\u0432\u0433",
        "\u0441\u0435\u043D",
        "\u043E\u043A\u0442",
        "\u043D\u043E\u044F",
        "\u0434\u0435\u043A"
    ],
    wide: [
        "\u044F\u043D\u0432\u0430\u0440",
        "\u0444\u0435\u0432\u0440\u0430\u043B",
        "\u043C\u0430\u0440\u0442",
        "\u0430\u043F\u0440\u0435\u043B",
        "\u043C\u0430\u0439",
        "\u0438\u044E\u043D",
        "\u0438\u044E\u043B",
        "\u0430\u0432\u0433\u0443\u0441\u0442",
        "\u0441\u0435\u043D\u0442\u0430\u0431\u0440",
        "\u043E\u043A\u0442\u0430\u0431\u0440",
        "\u043D\u043E\u044F\u0431\u0440",
        "\u0434\u0435\u043A\u0430\u0431\u0440"
    ]
};
var $9d96ebe2cd199508$var$dayValues = {
    narrow: [
        "\u042F",
        "\u0414",
        "\u0421",
        "\u0427",
        "\u041F",
        "\u0416",
        "\u0428"
    ],
    short: [
        "\u044F\u043A",
        "\u0434\u0443",
        "\u0441\u0435",
        "\u0447\u043E",
        "\u043F\u0430",
        "\u0436\u0443",
        "\u0448\u0430"
    ],
    abbreviated: [
        "\u044F\u043A\u0448",
        "\u0434\u0443\u0448",
        "\u0441\u0435\u0448",
        "\u0447\u043E\u0440",
        "\u043F\u0430\u0439",
        "\u0436\u0443\u043C",
        "\u0448\u0430\u043D"
    ],
    wide: [
        "\u044F\u043A\u0448\u0430\u043D\u0431\u0430",
        "\u0434\u0443\u0448\u0430\u043D\u0431\u0430",
        "\u0441\u0435\u0448\u0430\u043D\u0431\u0430",
        "\u0447\u043E\u0440\u0448\u0430\u043D\u0431\u0430",
        "\u043F\u0430\u0439\u0448\u0430\u043D\u0431\u0430",
        "\u0436\u0443\u043C\u0430",
        "\u0448\u0430\u043D\u0431\u0430"
    ]
};
var $9d96ebe2cd199508$var$dayPeriodValues = {
    any: {
        am: "\u041F.\u041E.",
        pm: "\u041F.\u041A.",
        midnight: "\u044F\u0440\u0438\u043C \u0442\u0443\u043D",
        noon: "\u043F\u0435\u0448\u0438\u043D",
        morning: "\u044D\u0440\u0442\u0430\u043B\u0430\u0431",
        afternoon: "\u043F\u0435\u0448\u0438\u043D\u0434\u0430\u043D \u043A\u0435\u0439\u0438\u043D",
        evening: "\u043A\u0435\u0447\u0430\u0441\u0438",
        night: "\u0442\u0443\u043D"
    }
};
var $9d96ebe2cd199508$var$formattingDayPeriodValues = {
    any: {
        am: "\u041F.\u041E.",
        pm: "\u041F.\u041A.",
        midnight: "\u044F\u0440\u0438\u043C \u0442\u0443\u043D",
        noon: "\u043F\u0435\u0448\u0438\u043D",
        morning: "\u044D\u0440\u0442\u0430\u043B\u0430\u0431",
        afternoon: "\u043F\u0435\u0448\u0438\u043D\u0434\u0430\u043D \u043A\u0435\u0439\u0438\u043D",
        evening: "\u043A\u0435\u0447\u0430\u0441\u0438",
        night: "\u0442\u0443\u043D"
    }
};
var $9d96ebe2cd199508$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    return String(dirtyNumber);
};
var $9d96ebe2cd199508$var$localize = {
    ordinalNumber: $9d96ebe2cd199508$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $9d96ebe2cd199508$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $9d96ebe2cd199508$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $9d96ebe2cd199508$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $9d96ebe2cd199508$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $9d96ebe2cd199508$var$dayPeriodValues,
        defaultWidth: "any",
        formattingValues: $9d96ebe2cd199508$var$formattingDayPeriodValues,
        defaultFormattingWidth: "any"
    })
};
var $9d96ebe2cd199508$export$2e2bcd8739ae039 = $9d96ebe2cd199508$var$localize;

});

parcelRegister("2IBNS", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fad03c9ea881775$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $1fad03c9ea881775$var$matchOrdinalNumberPattern = /^(\d+)(чи)?/i;
var $1fad03c9ea881775$var$parseOrdinalNumberPattern = /\d+/i;
var $1fad03c9ea881775$var$matchEraPatterns = {
    narrow: /^(м\.а|м\.)/i,
    abbreviated: /^(м\.а|м\.)/i,
    wide: /^(милоддан аввал|милоддан кейин)/i
};
var $1fad03c9ea881775$var$parseEraPatterns = {
    any: [
        /^м/i,
        /^а/i
    ]
};
var $1fad03c9ea881775$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^[1234]-чор./i,
    wide: /^[1234]-чорак/i
};
var $1fad03c9ea881775$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $1fad03c9ea881775$var$matchMonthPatterns = {
    narrow: /^[яфмамииасонд]/i,
    abbreviated: /^(янв|фев|мар|апр|май|июн|июл|авг|сен|окт|ноя|дек)/i,
    wide: /^(январ|феврал|март|апрел|май|июн|июл|август|сентабр|октабр|ноябр|декабр)/i
};
var $1fad03c9ea881775$var$parseMonthPatterns = {
    narrow: [
        /^я/i,
        /^ф/i,
        /^м/i,
        /^а/i,
        /^м/i,
        /^и/i,
        /^и/i,
        /^а/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ],
    any: [
        /^я/i,
        /^ф/i,
        /^мар/i,
        /^ап/i,
        /^май/i,
        /^июн/i,
        /^июл/i,
        /^ав/i,
        /^с/i,
        /^о/i,
        /^н/i,
        /^д/i
    ]
};
var $1fad03c9ea881775$var$matchDayPatterns = {
    narrow: /^[ядсчпжш]/i,
    short: /^(як|ду|се|чо|па|жу|ша)/i,
    abbreviated: /^(якш|душ|сеш|чор|пай|жум|шан)/i,
    wide: /^(якшанба|душанба|сешанба|чоршанба|пайшанба|жума|шанба)/i
};
var $1fad03c9ea881775$var$parseDayPatterns = {
    narrow: [
        /^я/i,
        /^д/i,
        /^с/i,
        /^ч/i,
        /^п/i,
        /^ж/i,
        /^ш/i
    ],
    any: [
        /^як/i,
        /^ду/i,
        /^се/i,
        /^чор/i,
        /^пай/i,
        /^жу/i,
        /^шан/i
    ]
};
var $1fad03c9ea881775$var$matchDayPeriodPatterns = {
    any: /^(п\.о\.|п\.к\.|ярим тун|пешиндан кейин|(эрталаб|пешиндан кейин|кечаси|тун))/i
};
var $1fad03c9ea881775$var$parseDayPeriodPatterns = {
    any: {
        am: /^п\.о\./i,
        pm: /^п\.к\./i,
        midnight: /^ярим тун/i,
        noon: /^пешиндан кейин/i,
        morning: /эрталаб/i,
        afternoon: /пешиндан кейин/i,
        evening: /кечаси/i,
        night: /тун/i
    }
};
var $1fad03c9ea881775$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $1fad03c9ea881775$var$matchOrdinalNumberPattern,
        parsePattern: $1fad03c9ea881775$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $1fad03c9ea881775$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $1fad03c9ea881775$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $1fad03c9ea881775$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $1fad03c9ea881775$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $1fad03c9ea881775$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $1fad03c9ea881775$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $1fad03c9ea881775$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $1fad03c9ea881775$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $1fad03c9ea881775$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $1fad03c9ea881775$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $1fad03c9ea881775$export$2e2bcd8739ae039 = $1fad03c9ea881775$var$match;

});


parcelRegister("h4ZUv", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6f2d57f5d1043a8$export$2e2bcd8739ae039);

var $7NTri = parcelRequire("7NTri");

var $1DZUc = parcelRequire("1DZUc");

var $bbC7j = parcelRequire("bbC7j");

var $8gEzQ = parcelRequire("8gEzQ");

var $k3ipF = parcelRequire("k3ipF");
/**
 * @type {Locale}
 * @category Locales
 * @summary Vietnamese locale (Vietnam).
 * @language Vietnamese
 * @iso-639-2 vie
 * @author Thanh Tran [@trongthanh]{@link https://github.com/trongthanh}
 * @author Leroy Hopson [@lihop]{@link https://github.com/lihop}
 */ var $c6f2d57f5d1043a8$var$locale = {
    code: "vi",
    formatDistance: (0, $7NTri.default),
    formatLong: (0, $1DZUc.default),
    formatRelative: (0, $bbC7j.default),
    localize: (0, $8gEzQ.default),
    match: (0, $k3ipF.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 1 /* First week of new year contains Jan 1st  */ 
    }
};
var $c6f2d57f5d1043a8$export$2e2bcd8739ae039 = $c6f2d57f5d1043a8$var$locale;

});
parcelRegister("7NTri", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ae81d19de32ce3a$export$2e2bcd8739ae039);
var $5ae81d19de32ce3a$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "d\u01B0\u1EDBi 1 gi\xe2y",
        other: "d\u01B0\u1EDBi {{count}} gi\xe2y"
    },
    xSeconds: {
        one: "1 gi\xe2y",
        other: "{{count}} gi\xe2y"
    },
    halfAMinute: "n\u1EEDa ph\xfat",
    lessThanXMinutes: {
        one: "d\u01B0\u1EDBi 1 ph\xfat",
        other: "d\u01B0\u1EDBi {{count}} ph\xfat"
    },
    xMinutes: {
        one: "1 ph\xfat",
        other: "{{count}} ph\xfat"
    },
    aboutXHours: {
        one: "kho\u1EA3ng 1 gi\u1EDD",
        other: "kho\u1EA3ng {{count}} gi\u1EDD"
    },
    xHours: {
        one: "1 gi\u1EDD",
        other: "{{count}} gi\u1EDD"
    },
    xDays: {
        one: "1 ng\xe0y",
        other: "{{count}} ng\xe0y"
    },
    aboutXWeeks: {
        one: "kho\u1EA3ng 1 tu\u1EA7n",
        other: "kho\u1EA3ng {{count}} tu\u1EA7n"
    },
    xWeeks: {
        one: "1 tu\u1EA7n",
        other: "{{count}} tu\u1EA7n"
    },
    aboutXMonths: {
        one: "kho\u1EA3ng 1 th\xe1ng",
        other: "kho\u1EA3ng {{count}} th\xe1ng"
    },
    xMonths: {
        one: "1 th\xe1ng",
        other: "{{count}} th\xe1ng"
    },
    aboutXYears: {
        one: "kho\u1EA3ng 1 n\u0103m",
        other: "kho\u1EA3ng {{count}} n\u0103m"
    },
    xYears: {
        one: "1 n\u0103m",
        other: "{{count}} n\u0103m"
    },
    overXYears: {
        one: "h\u01A1n 1 n\u0103m",
        other: "h\u01A1n {{count}} n\u0103m"
    },
    almostXYears: {
        one: "g\u1EA7n 1 n\u0103m",
        other: "g\u1EA7n {{count}} n\u0103m"
    }
};
var $5ae81d19de32ce3a$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $5ae81d19de32ce3a$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + " n\u1EEFa";
        else return result + " tr\u01B0\u1EDBc";
    }
    return result;
};
var $5ae81d19de32ce3a$export$2e2bcd8739ae039 = $5ae81d19de32ce3a$var$formatDistance;

});

parcelRegister("1DZUc", function(module, exports) {

$parcel$export(module.exports, "default", () => $132974165ba1ff0a$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $132974165ba1ff0a$var$dateFormats = {
    // thứ Sáu, ngày 25 tháng 08 năm 2017
    full: "EEEE, 'ng\xe0y' d MMMM 'n\u0103m' y",
    // ngày 25 tháng 08 năm 2017
    long: "'ng\xe0y' d MMMM 'n\u0103m' y",
    // 25 thg 08 năm 2017
    medium: "d MMM 'n\u0103m' y",
    // 25/08/2017
    short: "dd/MM/y"
};
var $132974165ba1ff0a$var$timeFormats = {
    full: "HH:mm:ss zzzz",
    long: "HH:mm:ss z",
    medium: "HH:mm:ss",
    short: "HH:mm"
};
var $132974165ba1ff0a$var$dateTimeFormats = {
    // thứ Sáu, ngày 25 tháng 08 năm 2017 23:25:59
    full: "{{date}} {{time}}",
    // ngày 25 tháng 08 năm 2017 23:25
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $132974165ba1ff0a$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $132974165ba1ff0a$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $132974165ba1ff0a$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $132974165ba1ff0a$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $132974165ba1ff0a$export$2e2bcd8739ae039 = $132974165ba1ff0a$var$formatLong;

});

parcelRegister("bbC7j", function(module, exports) {

$parcel$export(module.exports, "default", () => $824e4a0ac6c366ea$export$2e2bcd8739ae039);
var $824e4a0ac6c366ea$var$formatRelativeLocale = {
    lastWeek: "eeee 'tu\u1EA7n tr\u01B0\u1EDBc v\xe0o l\xfac' p",
    yesterday: "'h\xf4m qua v\xe0o l\xfac' p",
    today: "'h\xf4m nay v\xe0o l\xfac' p",
    tomorrow: "'ng\xe0y mai v\xe0o l\xfac' p",
    nextWeek: "eeee 't\u1EDBi v\xe0o l\xfac' p",
    other: "P"
};
var $824e4a0ac6c366ea$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $824e4a0ac6c366ea$var$formatRelativeLocale[token];
};
var $824e4a0ac6c366ea$export$2e2bcd8739ae039 = $824e4a0ac6c366ea$var$formatRelative;

});

parcelRegister("8gEzQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $604f4b265343f59b$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
// Capitalization reference: http://hcmup.edu.vn/index.php?option=com_content&view=article&id=4106%3Avit-hoa-trong-vn-bn-hanh-chinh&catid=2345%3Atham-kho&Itemid=4103&lang=vi&site=134
var $604f4b265343f59b$var$eraValues = {
    narrow: [
        "TCN",
        "SCN"
    ],
    abbreviated: [
        "tr\u01B0\u1EDBc CN",
        "sau CN"
    ],
    wide: [
        "tr\u01B0\u1EDBc C\xf4ng Nguy\xean",
        "sau C\xf4ng Nguy\xean"
    ]
};
var $604f4b265343f59b$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "Qu\xfd 1",
        "Qu\xfd 2",
        "Qu\xfd 3",
        "Qu\xfd 4"
    ]
};
var $604f4b265343f59b$var$formattingQuarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    // I notice many news outlet use this "quý II/2018"
    wide: [
        "qu\xfd I",
        "qu\xfd II",
        "qu\xfd III",
        "qu\xfd IV"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $604f4b265343f59b$var$monthValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12"
    ],
    abbreviated: [
        "Thg 1",
        "Thg 2",
        "Thg 3",
        "Thg 4",
        "Thg 5",
        "Thg 6",
        "Thg 7",
        "Thg 8",
        "Thg 9",
        "Thg 10",
        "Thg 11",
        "Thg 12"
    ],
    wide: [
        "Th\xe1ng M\u1ED9t",
        "Th\xe1ng Hai",
        "Th\xe1ng Ba",
        "Th\xe1ng T\u01B0",
        "Th\xe1ng N\u0103m",
        "Th\xe1ng S\xe1u",
        "Th\xe1ng B\u1EA3y",
        "Th\xe1ng T\xe1m",
        "Th\xe1ng Ch\xedn",
        "Th\xe1ng M\u01B0\u1EDDi",
        "Th\xe1ng M\u01B0\u1EDDi M\u1ED9t",
        "Th\xe1ng M\u01B0\u1EDDi Hai"
    ]
};
// In Vietnamese date formatting, month number less than 10 expected to have leading zero
var $604f4b265343f59b$var$formattingMonthValues = {
    narrow: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12"
    ],
    abbreviated: [
        "thg 1",
        "thg 2",
        "thg 3",
        "thg 4",
        "thg 5",
        "thg 6",
        "thg 7",
        "thg 8",
        "thg 9",
        "thg 10",
        "thg 11",
        "thg 12"
    ],
    wide: [
        "th\xe1ng 01",
        "th\xe1ng 02",
        "th\xe1ng 03",
        "th\xe1ng 04",
        "th\xe1ng 05",
        "th\xe1ng 06",
        "th\xe1ng 07",
        "th\xe1ng 08",
        "th\xe1ng 09",
        "th\xe1ng 10",
        "th\xe1ng 11",
        "th\xe1ng 12"
    ]
};
var $604f4b265343f59b$var$dayValues = {
    narrow: [
        "CN",
        "T2",
        "T3",
        "T4",
        "T5",
        "T6",
        "T7"
    ],
    short: [
        "CN",
        "Th 2",
        "Th 3",
        "Th 4",
        "Th 5",
        "Th 6",
        "Th 7"
    ],
    abbreviated: [
        "CN",
        "Th\u1EE9 2",
        "Th\u1EE9 3",
        "Th\u1EE9 4",
        "Th\u1EE9 5",
        "Th\u1EE9 6",
        "Th\u1EE9 7"
    ],
    wide: [
        "Ch\u1EE7 Nh\u1EADt",
        "Th\u1EE9 Hai",
        "Th\u1EE9 Ba",
        "Th\u1EE9 T\u01B0",
        "Th\u1EE9 N\u0103m",
        "Th\u1EE9 S\xe1u",
        "Th\u1EE9 B\u1EA3y"
    ]
};
// Vietnamese are used to AM/PM borrowing from English, hence `narrow` and
// `abbreviated` are just like English but I'm leaving the `wide`
// format being localized with abbreviations found in some systems (SÁng / CHiều);
// however, personally, I don't think `Chiều` sounds appropriate for `PM`
var $604f4b265343f59b$var$dayPeriodValues = {
    // narrow date period is extremely rare in Vietnamese
    // I used abbreviated form for noon, morning and afternoon
    // which are regconizable by Vietnamese, others cannot be any shorter
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "tr",
        morning: "sg",
        afternoon: "ch",
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "tr\u01B0a",
        morning: "s\xe1ng",
        afternoon: "chi\u1EC1u",
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    },
    wide: {
        am: "SA",
        pm: "CH",
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "tr\u01B0a",
        morning: "s\xe1ng",
        afternoon: "chi\u1EC1u",
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    }
};
var $604f4b265343f59b$var$formattingDayPeriodValues = {
    narrow: {
        am: "am",
        pm: "pm",
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "tr",
        morning: "sg",
        afternoon: "ch",
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "tr\u01B0a",
        morning: "s\xe1ng",
        afternoon: "chi\u1EC1u",
        evening: "t\u1ED1i",
        night: "\u0111\xeam"
    },
    wide: {
        am: "SA",
        pm: "CH",
        midnight: "n\u1EEDa \u0111\xeam",
        noon: "gi\u1EEFa tr\u01B0a",
        morning: "v\xe0o bu\u1ED5i s\xe1ng",
        afternoon: "v\xe0o bu\u1ED5i chi\u1EC1u",
        evening: "v\xe0o bu\u1ED5i t\u1ED1i",
        night: "v\xe0o ban \u0111\xeam"
    }
};
var $604f4b265343f59b$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    var unit = options === null || options === void 0 ? void 0 : options.unit;
    if (unit === "quarter") // many news outlets use "quý I"...
    switch(number){
        case 1:
            return "I";
        case 2:
            return "II";
        case 3:
            return "III";
        case 4:
            return "IV";
    }
    else if (unit === "day") // day of week in Vietnamese has ordinal number meaning,
    // so we should use them, else it'll sound weird
    switch(number){
        case 1:
            return "th\u1EE9 2";
        // meaning 2nd day but it's the first day of the week :D
        case 2:
            return "th\u1EE9 3";
        // meaning 3rd day
        case 3:
            return "th\u1EE9 4";
        // meaning 4th day and so on
        case 4:
            return "th\u1EE9 5";
        case 5:
            return "th\u1EE9 6";
        case 6:
            return "th\u1EE9 7";
        case 7:
            return "ch\u1EE7 nh\u1EADt";
    }
    else if (unit === "week") {
        if (number === 1) return "th\u1EE9 nh\u1EA5t";
        else return "th\u1EE9 " + number;
    } else if (unit === "dayOfYear") {
        if (number === 1) return "\u0111\u1EA7u ti\xean";
        else return "th\u1EE9 " + number;
    }
    // there are no different forms of ordinal numbers in Vietnamese
    return String(number);
};
var $604f4b265343f59b$var$localize = {
    ordinalNumber: $604f4b265343f59b$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $604f4b265343f59b$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $604f4b265343f59b$var$quarterValues,
        defaultWidth: "wide",
        formattingValues: $604f4b265343f59b$var$formattingQuarterValues,
        defaultFormattingWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $604f4b265343f59b$var$monthValues,
        defaultWidth: "wide",
        formattingValues: $604f4b265343f59b$var$formattingMonthValues,
        defaultFormattingWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $604f4b265343f59b$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $604f4b265343f59b$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $604f4b265343f59b$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $604f4b265343f59b$export$2e2bcd8739ae039 = $604f4b265343f59b$var$localize;

});

parcelRegister("k3ipF", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9925edf1fb91d42$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $e9925edf1fb91d42$var$matchOrdinalNumberPattern = /^(\d+)/i;
var $e9925edf1fb91d42$var$parseOrdinalNumberPattern = /\d+/i;
var $e9925edf1fb91d42$var$matchEraPatterns = {
    narrow: /^(tcn|scn)/i,
    abbreviated: /^(trước CN|sau CN)/i,
    wide: /^(trước Công Nguyên|sau Công Nguyên)/i
};
var $e9925edf1fb91d42$var$parseEraPatterns = {
    any: [
        /^t/i,
        /^s/i
    ]
};
var $e9925edf1fb91d42$var$matchQuarterPatterns = {
    narrow: /^([1234]|i{1,3}v?)/i,
    abbreviated: /^q([1234]|i{1,3}v?)/i,
    wide: /^quý ([1234]|i{1,3}v?)/i
};
var $e9925edf1fb91d42$var$parseQuarterPatterns = {
    any: [
        /(1|i)$/i,
        /(2|ii)$/i,
        /(3|iii)$/i,
        /(4|iv)$/i
    ]
};
var $e9925edf1fb91d42$var$matchMonthPatterns = {
    // month number may contain leading 0, 'thg' prefix may have space, underscore or empty before number
    // note the order of '1' since it is a sub-string of '10', so must be lower priority
    narrow: /^(0?[2-9]|10|11|12|0?1)/i,
    // note the order of 'thg 1' since it is sub-string of 'thg 10', so must be lower priority
    abbreviated: /^thg[ _]?(0?[1-9](?!\d)|10|11|12)/i,
    // note the order of 'Mười' since it is sub-string of Mười Một, so must be lower priority
    wide: /^tháng ?(Một|Hai|Ba|Tư|Năm|Sáu|Bảy|Tám|Chín|Mười|Mười ?Một|Mười ?Hai|0?[1-9](?!\d)|10|11|12)/i
};
var $e9925edf1fb91d42$var$parseMonthPatterns = {
    narrow: [
        /0?1$/i,
        /0?2/i,
        /3/,
        /4/,
        /5/,
        /6/,
        /7/,
        /8/,
        /9/,
        /10/,
        /11/,
        /12/
    ],
    abbreviated: [
        /^thg[ _]?0?1(?!\d)/i,
        /^thg[ _]?0?2/i,
        /^thg[ _]?0?3/i,
        /^thg[ _]?0?4/i,
        /^thg[ _]?0?5/i,
        /^thg[ _]?0?6/i,
        /^thg[ _]?0?7/i,
        /^thg[ _]?0?8/i,
        /^thg[ _]?0?9/i,
        /^thg[ _]?10/i,
        /^thg[ _]?11/i,
        /^thg[ _]?12/i
    ],
    wide: [
        /^tháng ?(Một|0?1(?!\d))/i,
        /^tháng ?(Hai|0?2)/i,
        /^tháng ?(Ba|0?3)/i,
        /^tháng ?(Tư|0?4)/i,
        /^tháng ?(Năm|0?5)/i,
        /^tháng ?(Sáu|0?6)/i,
        /^tháng ?(Bảy|0?7)/i,
        /^tháng ?(Tám|0?8)/i,
        /^tháng ?(Chín|0?9)/i,
        /^tháng ?(Mười|10)/i,
        /^tháng ?(Mười ?Một|11)/i,
        /^tháng ?(Mười ?Hai|12)/i
    ]
};
var $e9925edf1fb91d42$var$matchDayPatterns = {
    narrow: /^(CN|T2|T3|T4|T5|T6|T7)/i,
    short: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
    abbreviated: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
    wide: /^(Chủ ?Nhật|Chúa ?Nhật|thứ ?Hai|thứ ?Ba|thứ ?Tư|thứ ?Năm|thứ ?Sáu|thứ ?Bảy)/i
};
var $e9925edf1fb91d42$var$parseDayPatterns = {
    narrow: [
        /CN/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i
    ],
    short: [
        /CN/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i
    ],
    abbreviated: [
        /CN/i,
        /2/i,
        /3/i,
        /4/i,
        /5/i,
        /6/i,
        /7/i
    ],
    wide: [
        /(Chủ|Chúa) ?Nhật/i,
        /Hai/i,
        /Ba/i,
        /Tư/i,
        /Năm/i,
        /Sáu/i,
        /Bảy/i
    ]
};
var $e9925edf1fb91d42$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
    abbreviated: /^(am|pm|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
    wide: /^(ch[^i]*|sa|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i
};
var $e9925edf1fb91d42$var$parseDayPeriodPatterns = {
    any: {
        am: /^(a|sa)/i,
        pm: /^(p|ch[^i]*)/i,
        midnight: /nửa đêm/i,
        noon: /trưa/i,
        morning: /sáng/i,
        afternoon: /chiều/i,
        evening: /tối/i,
        night: /^đêm/i
    }
};
var $e9925edf1fb91d42$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $e9925edf1fb91d42$var$matchOrdinalNumberPattern,
        parsePattern: $e9925edf1fb91d42$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $e9925edf1fb91d42$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e9925edf1fb91d42$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $e9925edf1fb91d42$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e9925edf1fb91d42$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $e9925edf1fb91d42$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e9925edf1fb91d42$var$parseMonthPatterns,
        defaultParseWidth: "wide"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $e9925edf1fb91d42$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e9925edf1fb91d42$var$parseDayPatterns,
        defaultParseWidth: "wide"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $e9925edf1fb91d42$var$matchDayPeriodPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $e9925edf1fb91d42$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $e9925edf1fb91d42$export$2e2bcd8739ae039 = $e9925edf1fb91d42$var$match;

});


parcelRegister("61ZHO", function(module, exports) {

$parcel$export(module.exports, "default", () => $4642b38a6ced8d3a$export$2e2bcd8739ae039);

var $8PqZ1 = parcelRequire("8PqZ1");

var $521lH = parcelRequire("521lH");

var $29qVb = parcelRequire("29qVb");

var $dWZAc = parcelRequire("dWZAc");

var $9Tr4Z = parcelRequire("9Tr4Z");
/**
 * @type {Locale}
 * @category Locales
 * @summary Chinese Simplified locale.
 * @language Chinese Simplified
 * @iso-639-2 zho
 * @author Changyu Geng [@KingMario]{@link https://github.com/KingMario}
 * @author Song Shuoyun [@fnlctrl]{@link https://github.com/fnlctrl}
 * @author sabrinaM [@sabrinamiao]{@link https://github.com/sabrinamiao}
 * @author Carney Wu [@cubicwork]{@link https://github.com/cubicwork}
 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
 */ var $4642b38a6ced8d3a$var$locale = {
    code: "zh-CN",
    formatDistance: (0, $8PqZ1.default),
    formatLong: (0, $521lH.default),
    formatRelative: (0, $29qVb.default),
    localize: (0, $dWZAc.default),
    match: (0, $9Tr4Z.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $4642b38a6ced8d3a$export$2e2bcd8739ae039 = $4642b38a6ced8d3a$var$locale;

});
parcelRegister("8PqZ1", function(module, exports) {

$parcel$export(module.exports, "default", () => $66d80470362136b8$export$2e2bcd8739ae039);
var $66d80470362136b8$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u4E0D\u5230 1 \u79D2",
        other: "\u4E0D\u5230 {{count}} \u79D2"
    },
    xSeconds: {
        one: "1 \u79D2",
        other: "{{count}} \u79D2"
    },
    halfAMinute: "\u534A\u5206\u949F",
    lessThanXMinutes: {
        one: "\u4E0D\u5230 1 \u5206\u949F",
        other: "\u4E0D\u5230 {{count}} \u5206\u949F"
    },
    xMinutes: {
        one: "1 \u5206\u949F",
        other: "{{count}} \u5206\u949F"
    },
    xHours: {
        one: "1 \u5C0F\u65F6",
        other: "{{count}} \u5C0F\u65F6"
    },
    aboutXHours: {
        one: "\u5927\u7EA6 1 \u5C0F\u65F6",
        other: "\u5927\u7EA6 {{count}} \u5C0F\u65F6"
    },
    xDays: {
        one: "1 \u5929",
        other: "{{count}} \u5929"
    },
    aboutXWeeks: {
        one: "\u5927\u7EA6 1 \u4E2A\u661F\u671F",
        other: "\u5927\u7EA6 {{count}} \u4E2A\u661F\u671F"
    },
    xWeeks: {
        one: "1 \u4E2A\u661F\u671F",
        other: "{{count}} \u4E2A\u661F\u671F"
    },
    aboutXMonths: {
        one: "\u5927\u7EA6 1 \u4E2A\u6708",
        other: "\u5927\u7EA6 {{count}} \u4E2A\u6708"
    },
    xMonths: {
        one: "1 \u4E2A\u6708",
        other: "{{count}} \u4E2A\u6708"
    },
    aboutXYears: {
        one: "\u5927\u7EA6 1 \u5E74",
        other: "\u5927\u7EA6 {{count}} \u5E74"
    },
    xYears: {
        one: "1 \u5E74",
        other: "{{count}} \u5E74"
    },
    overXYears: {
        one: "\u8D85\u8FC7 1 \u5E74",
        other: "\u8D85\u8FC7 {{count}} \u5E74"
    },
    almostXYears: {
        one: "\u5C06\u8FD1 1 \u5E74",
        other: "\u5C06\u8FD1 {{count}} \u5E74"
    }
};
var $66d80470362136b8$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $66d80470362136b8$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5185";
        else return result + "\u524D";
    }
    return result;
};
var $66d80470362136b8$export$2e2bcd8739ae039 = $66d80470362136b8$var$formatDistance;

});

parcelRegister("521lH", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a9e2f897dcafcf4$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $3a9e2f897dcafcf4$var$dateFormats = {
    full: "y'\u5E74'M'\u6708'd'\u65E5' EEEE",
    long: "y'\u5E74'M'\u6708'd'\u65E5'",
    medium: "yyyy-MM-dd",
    short: "yy-MM-dd"
};
var $3a9e2f897dcafcf4$var$timeFormats = {
    full: "zzzz a h:mm:ss",
    long: "z a h:mm:ss",
    medium: "a h:mm:ss",
    short: "a h:mm"
};
var $3a9e2f897dcafcf4$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $3a9e2f897dcafcf4$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $3a9e2f897dcafcf4$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $3a9e2f897dcafcf4$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $3a9e2f897dcafcf4$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $3a9e2f897dcafcf4$export$2e2bcd8739ae039 = $3a9e2f897dcafcf4$var$formatLong;

});

parcelRegister("29qVb", function(module, exports) {

$parcel$export(module.exports, "default", () => $19114e07a56b1351$export$2e2bcd8739ae039);

var $6KZXu = parcelRequire("6KZXu");
function $19114e07a56b1351$var$checkWeek(date, baseDate, options) {
    var baseFormat = "eeee p";
    if ((0, $6KZXu.default)(date, baseDate, options)) return baseFormat; // in same week
    else if (date.getTime() > baseDate.getTime()) return "'\u4E0B\u4E2A'" + baseFormat; // in next week
    return "'\u4E0A\u4E2A'" + baseFormat; // in last week
}
var $19114e07a56b1351$var$formatRelativeLocale = {
    lastWeek: $19114e07a56b1351$var$checkWeek,
    // days before yesterday, maybe in this week or last week
    yesterday: "'\u6628\u5929' p",
    today: "'\u4ECA\u5929' p",
    tomorrow: "'\u660E\u5929' p",
    nextWeek: $19114e07a56b1351$var$checkWeek,
    // days after tomorrow, maybe in this week or next week
    other: "PP p"
};
var $19114e07a56b1351$var$formatRelative = function formatRelative(token, date, baseDate, options) {
    var format = $19114e07a56b1351$var$formatRelativeLocale[token];
    if (typeof format === "function") return format(date, baseDate, options);
    return format;
};
var $19114e07a56b1351$export$2e2bcd8739ae039 = $19114e07a56b1351$var$formatRelative;

});

parcelRegister("dWZAc", function(module, exports) {

$parcel$export(module.exports, "default", () => $a280763121a46eda$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $a280763121a46eda$var$eraValues = {
    narrow: [
        "\u524D",
        "\u516C\u5143"
    ],
    abbreviated: [
        "\u524D",
        "\u516C\u5143"
    ],
    wide: [
        "\u516C\u5143\u524D",
        "\u516C\u5143"
    ]
};
var $a280763121a46eda$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u7B2C\u4E00\u5B63",
        "\u7B2C\u4E8C\u5B63",
        "\u7B2C\u4E09\u5B63",
        "\u7B2C\u56DB\u5B63"
    ],
    wide: [
        "\u7B2C\u4E00\u5B63\u5EA6",
        "\u7B2C\u4E8C\u5B63\u5EA6",
        "\u7B2C\u4E09\u5B63\u5EA6",
        "\u7B2C\u56DB\u5B63\u5EA6"
    ]
};
var $a280763121a46eda$var$monthValues = {
    narrow: [
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D",
        "\u4E03",
        "\u516B",
        "\u4E5D",
        "\u5341",
        "\u5341\u4E00",
        "\u5341\u4E8C"
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "\u4E00\u6708",
        "\u4E8C\u6708",
        "\u4E09\u6708",
        "\u56DB\u6708",
        "\u4E94\u6708",
        "\u516D\u6708",
        "\u4E03\u6708",
        "\u516B\u6708",
        "\u4E5D\u6708",
        "\u5341\u6708",
        "\u5341\u4E00\u6708",
        "\u5341\u4E8C\u6708"
    ]
};
var $a280763121a46eda$var$dayValues = {
    narrow: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    short: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    abbreviated: [
        "\u5468\u65E5",
        "\u5468\u4E00",
        "\u5468\u4E8C",
        "\u5468\u4E09",
        "\u5468\u56DB",
        "\u5468\u4E94",
        "\u5468\u516D"
    ],
    wide: [
        "\u661F\u671F\u65E5",
        "\u661F\u671F\u4E00",
        "\u661F\u671F\u4E8C",
        "\u661F\u671F\u4E09",
        "\u661F\u671F\u56DB",
        "\u661F\u671F\u4E94",
        "\u661F\u671F\u516D"
    ]
};
var $a280763121a46eda$var$dayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    }
};
var $a280763121a46eda$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u95F4"
    }
};
var $a280763121a46eda$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    switch(options === null || options === void 0 ? void 0 : options.unit){
        case "date":
            return number.toString() + "\u65E5";
        case "hour":
            return number.toString() + "\u65F6";
        case "minute":
            return number.toString() + "\u5206";
        case "second":
            return number.toString() + "\u79D2";
        default:
            return "\u7B2C " + number.toString();
    }
};
var $a280763121a46eda$var$localize = {
    ordinalNumber: $a280763121a46eda$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $a280763121a46eda$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $a280763121a46eda$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $a280763121a46eda$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $a280763121a46eda$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $a280763121a46eda$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $a280763121a46eda$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $a280763121a46eda$export$2e2bcd8739ae039 = $a280763121a46eda$var$localize;

});

parcelRegister("9Tr4Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $733e4188dc908018$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $733e4188dc908018$var$matchOrdinalNumberPattern = /^(第\s*)?\d+(日|时|分|秒)?/i;
var $733e4188dc908018$var$parseOrdinalNumberPattern = /\d+/i;
var $733e4188dc908018$var$matchEraPatterns = {
    narrow: /^(前)/i,
    abbreviated: /^(前)/i,
    wide: /^(公元前|公元)/i
};
var $733e4188dc908018$var$parseEraPatterns = {
    any: [
        /^(前)/i,
        /^(公元)/i
    ]
};
var $733e4188dc908018$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^第[一二三四]刻/i,
    wide: /^第[一二三四]刻钟/i
};
var $733e4188dc908018$var$parseQuarterPatterns = {
    any: [
        /(1|一)/i,
        /(2|二)/i,
        /(3|三)/i,
        /(4|四)/i
    ]
};
var $733e4188dc908018$var$matchMonthPatterns = {
    narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
    abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
    wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
var $733e4188dc908018$var$parseMonthPatterns = {
    narrow: [
        /^一/i,
        /^二/i,
        /^三/i,
        /^四/i,
        /^五/i,
        /^六/i,
        /^七/i,
        /^八/i,
        /^九/i,
        /^十(?!(一|二))/i,
        /^十一/i,
        /^十二/i
    ],
    any: [
        /^一|1/i,
        /^二|2/i,
        /^三|3/i,
        /^四|4/i,
        /^五|5/i,
        /^六|6/i,
        /^七|7/i,
        /^八|8/i,
        /^九|9/i,
        /^十(?!(一|二))|10/i,
        /^十一|11/i,
        /^十二|12/i
    ]
};
var $733e4188dc908018$var$matchDayPatterns = {
    narrow: /^[一二三四五六日]/i,
    short: /^[一二三四五六日]/i,
    abbreviated: /^周[一二三四五六日]/i,
    wide: /^星期[一二三四五六日]/i
};
var $733e4188dc908018$var$parseDayPatterns = {
    any: [
        /日/i,
        /一/i,
        /二/i,
        /三/i,
        /四/i,
        /五/i,
        /六/i
    ]
};
var $733e4188dc908018$var$matchDayPeriodPatterns = {
    any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨|)/i
};
var $733e4188dc908018$var$parseDayPeriodPatterns = {
    any: {
        am: /^上午?/i,
        pm: /^下午?/i,
        midnight: /^午夜/i,
        noon: /^[中正]午/i,
        morning: /^早上/i,
        afternoon: /^下午/i,
        evening: /^晚上?/i,
        night: /^凌晨/i
    }
};
var $733e4188dc908018$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $733e4188dc908018$var$matchOrdinalNumberPattern,
        parsePattern: $733e4188dc908018$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $733e4188dc908018$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $733e4188dc908018$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $733e4188dc908018$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $733e4188dc908018$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $733e4188dc908018$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $733e4188dc908018$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $733e4188dc908018$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $733e4188dc908018$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $733e4188dc908018$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $733e4188dc908018$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $733e4188dc908018$export$2e2bcd8739ae039 = $733e4188dc908018$var$match;

});


parcelRegister("ezXpQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9d26c4d2b073c3e$export$2e2bcd8739ae039);

var $fcFfN = parcelRequire("fcFfN");

var $8UpT6 = parcelRequire("8UpT6");

var $6oJQX = parcelRequire("6oJQX");

var $fty2N = parcelRequire("fty2N");

var $8YZ35 = parcelRequire("8YZ35");
/**
 * @type {Locale}
 * @category Locales
 * @summary Chinese Traditional locale.
 * @language Chinese Traditional
 * @iso-639-2 zho
 * @author Gary Ip [@gaplo]{@link https://github.com/gaplo}
 */ var $a9d26c4d2b073c3e$var$locale = {
    code: "zh-HK",
    formatDistance: (0, $fcFfN.default),
    formatLong: (0, $8UpT6.default),
    formatRelative: (0, $6oJQX.default),
    localize: (0, $fty2N.default),
    match: (0, $8YZ35.default),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var $a9d26c4d2b073c3e$export$2e2bcd8739ae039 = $a9d26c4d2b073c3e$var$locale;

});
parcelRegister("fcFfN", function(module, exports) {

$parcel$export(module.exports, "default", () => $b117fa28b76a9e4a$export$2e2bcd8739ae039);
var $b117fa28b76a9e4a$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u5C11\u65BC 1 \u79D2",
        other: "\u5C11\u65BC {{count}} \u79D2"
    },
    xSeconds: {
        one: "1 \u79D2",
        other: "{{count}} \u79D2"
    },
    halfAMinute: "\u534A\u5206\u9418",
    lessThanXMinutes: {
        one: "\u5C11\u65BC 1 \u5206\u9418",
        other: "\u5C11\u65BC {{count}} \u5206\u9418"
    },
    xMinutes: {
        one: "1 \u5206\u9418",
        other: "{{count}} \u5206\u9418"
    },
    xHours: {
        one: "1 \u5C0F\u6642",
        other: "{{count}} \u5C0F\u6642"
    },
    aboutXHours: {
        one: "\u5927\u7D04 1 \u5C0F\u6642",
        other: "\u5927\u7D04 {{count}} \u5C0F\u6642"
    },
    xDays: {
        one: "1 \u5929",
        other: "{{count}} \u5929"
    },
    aboutXWeeks: {
        one: "\u5927\u7D04 1 \u500B\u661F\u671F",
        other: "\u5927\u7D04 {{count}} \u500B\u661F\u671F"
    },
    xWeeks: {
        one: "1 \u500B\u661F\u671F",
        other: "{{count}} \u500B\u661F\u671F"
    },
    aboutXMonths: {
        one: "\u5927\u7D04 1 \u500B\u6708",
        other: "\u5927\u7D04 {{count}} \u500B\u6708"
    },
    xMonths: {
        one: "1 \u500B\u6708",
        other: "{{count}} \u500B\u6708"
    },
    aboutXYears: {
        one: "\u5927\u7D04 1 \u5E74",
        other: "\u5927\u7D04 {{count}} \u5E74"
    },
    xYears: {
        one: "1 \u5E74",
        other: "{{count}} \u5E74"
    },
    overXYears: {
        one: "\u8D85\u904E 1 \u5E74",
        other: "\u8D85\u904E {{count}} \u5E74"
    },
    almostXYears: {
        one: "\u5C07\u8FD1 1 \u5E74",
        other: "\u5C07\u8FD1 {{count}} \u5E74"
    }
};
var $b117fa28b76a9e4a$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $b117fa28b76a9e4a$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5167";
        else return result + "\u524D";
    }
    return result;
};
var $b117fa28b76a9e4a$export$2e2bcd8739ae039 = $b117fa28b76a9e4a$var$formatDistance;

});

parcelRegister("8UpT6", function(module, exports) {

$parcel$export(module.exports, "default", () => $67c7a27342b1efa2$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $67c7a27342b1efa2$var$dateFormats = {
    full: "y'\u5E74'M'\u6708'd'\u65E5' EEEE",
    long: "y'\u5E74'M'\u6708'd'\u65E5'",
    medium: "yyyy-MM-dd",
    short: "yy-MM-dd"
};
var $67c7a27342b1efa2$var$timeFormats = {
    full: "zzzz a h:mm:ss",
    long: "z a h:mm:ss",
    medium: "a h:mm:ss",
    short: "a h:mm"
};
var $67c7a27342b1efa2$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $67c7a27342b1efa2$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $67c7a27342b1efa2$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $67c7a27342b1efa2$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $67c7a27342b1efa2$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $67c7a27342b1efa2$export$2e2bcd8739ae039 = $67c7a27342b1efa2$var$formatLong;

});

parcelRegister("6oJQX", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a888d715bf2d011$export$2e2bcd8739ae039);
var $4a888d715bf2d011$var$formatRelativeLocale = {
    lastWeek: "'\u4E0A\u500B'eeee p",
    yesterday: "'\u6628\u5929' p",
    today: "'\u4ECA\u5929' p",
    tomorrow: "'\u660E\u5929' p",
    nextWeek: "'\u4E0B\u500B'eeee p",
    other: "P"
};
var $4a888d715bf2d011$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $4a888d715bf2d011$var$formatRelativeLocale[token];
};
var $4a888d715bf2d011$export$2e2bcd8739ae039 = $4a888d715bf2d011$var$formatRelative;

});

parcelRegister("fty2N", function(module, exports) {

$parcel$export(module.exports, "default", () => $b443f8e0b39d052b$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $b443f8e0b39d052b$var$eraValues = {
    narrow: [
        "\u524D",
        "\u516C\u5143"
    ],
    abbreviated: [
        "\u524D",
        "\u516C\u5143"
    ],
    wide: [
        "\u516C\u5143\u524D",
        "\u516C\u5143"
    ]
};
var $b443f8e0b39d052b$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u7B2C\u4E00\u5B63",
        "\u7B2C\u4E8C\u5B63",
        "\u7B2C\u4E09\u5B63",
        "\u7B2C\u56DB\u5B63"
    ],
    wide: [
        "\u7B2C\u4E00\u5B63\u5EA6",
        "\u7B2C\u4E8C\u5B63\u5EA6",
        "\u7B2C\u4E09\u5B63\u5EA6",
        "\u7B2C\u56DB\u5B63\u5EA6"
    ]
};
var $b443f8e0b39d052b$var$monthValues = {
    narrow: [
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D",
        "\u4E03",
        "\u516B",
        "\u4E5D",
        "\u5341",
        "\u5341\u4E00",
        "\u5341\u4E8C"
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "\u4E00\u6708",
        "\u4E8C\u6708",
        "\u4E09\u6708",
        "\u56DB\u6708",
        "\u4E94\u6708",
        "\u516D\u6708",
        "\u4E03\u6708",
        "\u516B\u6708",
        "\u4E5D\u6708",
        "\u5341\u6708",
        "\u5341\u4E00\u6708",
        "\u5341\u4E8C\u6708"
    ]
};
var $b443f8e0b39d052b$var$dayValues = {
    narrow: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    short: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    abbreviated: [
        "\u9031\u65E5",
        "\u9031\u4E00",
        "\u9031\u4E8C",
        "\u9031\u4E09",
        "\u9031\u56DB",
        "\u9031\u4E94",
        "\u9031\u516D"
    ],
    wide: [
        "\u661F\u671F\u65E5",
        "\u661F\u671F\u4E00",
        "\u661F\u671F\u4E8C",
        "\u661F\u671F\u4E09",
        "\u661F\u671F\u56DB",
        "\u661F\u671F\u4E94",
        "\u661F\u671F\u516D"
    ]
};
var $b443f8e0b39d052b$var$dayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u5348\u591C",
        noon: "\u664C",
        morning: "\u65E9",
        afternoon: "\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
    }
};
var $b443f8e0b39d052b$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u5348\u591C",
        noon: "\u664C",
        morning: "\u65E9",
        afternoon: "\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u5348\u591C",
        noon: "\u4E2D\u5348",
        morning: "\u4E0A\u5348",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u665A"
    }
};
var $b443f8e0b39d052b$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    switch(options === null || options === void 0 ? void 0 : options.unit){
        case "date":
            return number + "\u65E5";
        case "hour":
            return number + "\u6642";
        case "minute":
            return number + "\u5206";
        case "second":
            return number + "\u79D2";
        default:
            return "\u7B2C " + number;
    }
};
var $b443f8e0b39d052b$var$localize = {
    ordinalNumber: $b443f8e0b39d052b$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $b443f8e0b39d052b$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $b443f8e0b39d052b$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $b443f8e0b39d052b$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $b443f8e0b39d052b$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $b443f8e0b39d052b$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $b443f8e0b39d052b$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $b443f8e0b39d052b$export$2e2bcd8739ae039 = $b443f8e0b39d052b$var$localize;

});

parcelRegister("8YZ35", function(module, exports) {

$parcel$export(module.exports, "default", () => $68a3485a52528b8b$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $68a3485a52528b8b$var$matchOrdinalNumberPattern = /^(第\s*)?\d+(日|時|分|秒)?/i;
var $68a3485a52528b8b$var$parseOrdinalNumberPattern = /\d+/i;
var $68a3485a52528b8b$var$matchEraPatterns = {
    narrow: /^(前)/i,
    abbreviated: /^(前)/i,
    wide: /^(公元前|公元)/i
};
var $68a3485a52528b8b$var$parseEraPatterns = {
    any: [
        /^(前)/i,
        /^(公元)/i
    ]
};
var $68a3485a52528b8b$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^第[一二三四]季/i,
    wide: /^第[一二三四]季度/i
};
var $68a3485a52528b8b$var$parseQuarterPatterns = {
    any: [
        /(1|一)/i,
        /(2|二)/i,
        /(3|三)/i,
        /(4|四)/i
    ]
};
var $68a3485a52528b8b$var$matchMonthPatterns = {
    narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
    abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
    wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
var $68a3485a52528b8b$var$parseMonthPatterns = {
    narrow: [
        /^一/i,
        /^二/i,
        /^三/i,
        /^四/i,
        /^五/i,
        /^六/i,
        /^七/i,
        /^八/i,
        /^九/i,
        /^十(?!(一|二))/i,
        /^十一/i,
        /^十二/i
    ],
    any: [
        /^一|1/i,
        /^二|2/i,
        /^三|3/i,
        /^四|4/i,
        /^五|5/i,
        /^六|6/i,
        /^七|7/i,
        /^八|8/i,
        /^九|9/i,
        /^十(?!(一|二))|10/i,
        /^十一|11/i,
        /^十二|12/i
    ]
};
var $68a3485a52528b8b$var$matchDayPatterns = {
    narrow: /^[一二三四五六日]/i,
    short: /^[一二三四五六日]/i,
    abbreviated: /^週[一二三四五六日]/i,
    wide: /^星期[一二三四五六日]/i
};
var $68a3485a52528b8b$var$parseDayPatterns = {
    any: [
        /日/i,
        /一/i,
        /二/i,
        /三/i,
        /四/i,
        /五/i,
        /六/i
    ]
};
var $68a3485a52528b8b$var$matchDayPeriodPatterns = {
    any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
};
var $68a3485a52528b8b$var$parseDayPeriodPatterns = {
    any: {
        am: /^上午?/i,
        pm: /^下午?/i,
        midnight: /^午夜/i,
        noon: /^[中正]午/i,
        morning: /^早上/i,
        afternoon: /^下午/i,
        evening: /^晚上?/i,
        night: /^凌晨/i
    }
};
var $68a3485a52528b8b$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $68a3485a52528b8b$var$matchOrdinalNumberPattern,
        parsePattern: $68a3485a52528b8b$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $68a3485a52528b8b$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $68a3485a52528b8b$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $68a3485a52528b8b$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $68a3485a52528b8b$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $68a3485a52528b8b$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $68a3485a52528b8b$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $68a3485a52528b8b$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $68a3485a52528b8b$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $68a3485a52528b8b$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $68a3485a52528b8b$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $68a3485a52528b8b$export$2e2bcd8739ae039 = $68a3485a52528b8b$var$match;

});


parcelRegister("JpbSs", function(module, exports) {

$parcel$export(module.exports, "default", () => $0887be67fbc3fb49$export$2e2bcd8739ae039);

var $5JSWs = parcelRequire("5JSWs");

var $jAHGE = parcelRequire("jAHGE");

var $cTJsc = parcelRequire("cTJsc");

var $5Q8wb = parcelRequire("5Q8wb");

var $3BfA8 = parcelRequire("3BfA8");
/**
 * @type {Locale}
 * @category Locales
 * @summary Chinese Traditional locale.
 * @language Chinese Traditional
 * @iso-639-2 zho
 * @author tonypai [@tpai]{@link https://github.com/tpai}
 * @author Jack Hsu [@jackhsu978]{@link https://github.com/jackhsu978}
 * @author Terrence Lam [@skyuplam]{@link https://github.com/skyuplam}
 */ var $0887be67fbc3fb49$var$locale = {
    code: "zh-TW",
    formatDistance: (0, $5JSWs.default),
    formatLong: (0, $jAHGE.default),
    formatRelative: (0, $cTJsc.default),
    localize: (0, $5Q8wb.default),
    match: (0, $3BfA8.default),
    options: {
        weekStartsOn: 1 /* Monday */ ,
        firstWeekContainsDate: 4
    }
};
var $0887be67fbc3fb49$export$2e2bcd8739ae039 = $0887be67fbc3fb49$var$locale;

});
parcelRegister("5JSWs", function(module, exports) {

$parcel$export(module.exports, "default", () => $42dbc6076a6b505e$export$2e2bcd8739ae039);
var $42dbc6076a6b505e$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "\u5C11\u65BC 1 \u79D2",
        other: "\u5C11\u65BC {{count}} \u79D2"
    },
    xSeconds: {
        one: "1 \u79D2",
        other: "{{count}} \u79D2"
    },
    halfAMinute: "\u534A\u5206\u9418",
    lessThanXMinutes: {
        one: "\u5C11\u65BC 1 \u5206\u9418",
        other: "\u5C11\u65BC {{count}} \u5206\u9418"
    },
    xMinutes: {
        one: "1 \u5206\u9418",
        other: "{{count}} \u5206\u9418"
    },
    xHours: {
        one: "1 \u5C0F\u6642",
        other: "{{count}} \u5C0F\u6642"
    },
    aboutXHours: {
        one: "\u5927\u7D04 1 \u5C0F\u6642",
        other: "\u5927\u7D04 {{count}} \u5C0F\u6642"
    },
    xDays: {
        one: "1 \u5929",
        other: "{{count}} \u5929"
    },
    aboutXWeeks: {
        one: "\u5927\u7D04 1 \u500B\u661F\u671F",
        other: "\u5927\u7D04 {{count}} \u500B\u661F\u671F"
    },
    xWeeks: {
        one: "1 \u500B\u661F\u671F",
        other: "{{count}} \u500B\u661F\u671F"
    },
    aboutXMonths: {
        one: "\u5927\u7D04 1 \u500B\u6708",
        other: "\u5927\u7D04 {{count}} \u500B\u6708"
    },
    xMonths: {
        one: "1 \u500B\u6708",
        other: "{{count}} \u500B\u6708"
    },
    aboutXYears: {
        one: "\u5927\u7D04 1 \u5E74",
        other: "\u5927\u7D04 {{count}} \u5E74"
    },
    xYears: {
        one: "1 \u5E74",
        other: "{{count}} \u5E74"
    },
    overXYears: {
        one: "\u8D85\u904E 1 \u5E74",
        other: "\u8D85\u904E {{count}} \u5E74"
    },
    almostXYears: {
        one: "\u5C07\u8FD1 1 \u5E74",
        other: "\u5C07\u8FD1 {{count}} \u5E74"
    }
};
var $42dbc6076a6b505e$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $42dbc6076a6b505e$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", String(count));
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return result + "\u5167";
        else return result + "\u524D";
    }
    return result;
};
var $42dbc6076a6b505e$export$2e2bcd8739ae039 = $42dbc6076a6b505e$var$formatDistance;

});

parcelRegister("jAHGE", function(module, exports) {

$parcel$export(module.exports, "default", () => $e433446c4ba432e5$export$2e2bcd8739ae039);

var $uq3Ff = parcelRequire("uq3Ff");
var $e433446c4ba432e5$var$dateFormats = {
    full: "y'\u5E74'M'\u6708'd'\u65E5' EEEE",
    long: "y'\u5E74'M'\u6708'd'\u65E5'",
    medium: "yyyy-MM-dd",
    short: "yy-MM-dd"
};
var $e433446c4ba432e5$var$timeFormats = {
    full: "zzzz a h:mm:ss",
    long: "z a h:mm:ss",
    medium: "a h:mm:ss",
    short: "a h:mm"
};
var $e433446c4ba432e5$var$dateTimeFormats = {
    full: "{{date}} {{time}}",
    long: "{{date}} {{time}}",
    medium: "{{date}} {{time}}",
    short: "{{date}} {{time}}"
};
var $e433446c4ba432e5$var$formatLong = {
    date: (0, $uq3Ff.default)({
        formats: $e433446c4ba432e5$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $uq3Ff.default)({
        formats: $e433446c4ba432e5$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $uq3Ff.default)({
        formats: $e433446c4ba432e5$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $e433446c4ba432e5$export$2e2bcd8739ae039 = $e433446c4ba432e5$var$formatLong;

});

parcelRegister("cTJsc", function(module, exports) {

$parcel$export(module.exports, "default", () => $963de14596812928$export$2e2bcd8739ae039);
var $963de14596812928$var$formatRelativeLocale = {
    lastWeek: "'\u4E0A\u500B'eeee p",
    yesterday: "'\u6628\u5929' p",
    today: "'\u4ECA\u5929' p",
    tomorrow: "'\u660E\u5929' p",
    nextWeek: "'\u4E0B\u500B'eeee p",
    other: "P"
};
var $963de14596812928$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $963de14596812928$var$formatRelativeLocale[token];
};
var $963de14596812928$export$2e2bcd8739ae039 = $963de14596812928$var$formatRelative;

});

parcelRegister("5Q8wb", function(module, exports) {

$parcel$export(module.exports, "default", () => $44086a9a632815c7$export$2e2bcd8739ae039);

var $kp3bq = parcelRequire("kp3bq");
var $44086a9a632815c7$var$eraValues = {
    narrow: [
        "\u524D",
        "\u516C\u5143"
    ],
    abbreviated: [
        "\u524D",
        "\u516C\u5143"
    ],
    wide: [
        "\u516C\u5143\u524D",
        "\u516C\u5143"
    ]
};
var $44086a9a632815c7$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "\u7B2C\u4E00\u523B",
        "\u7B2C\u4E8C\u523B",
        "\u7B2C\u4E09\u523B",
        "\u7B2C\u56DB\u523B"
    ],
    wide: [
        "\u7B2C\u4E00\u523B\u9418",
        "\u7B2C\u4E8C\u523B\u9418",
        "\u7B2C\u4E09\u523B\u9418",
        "\u7B2C\u56DB\u523B\u9418"
    ]
};
var $44086a9a632815c7$var$monthValues = {
    narrow: [
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D",
        "\u4E03",
        "\u516B",
        "\u4E5D",
        "\u5341",
        "\u5341\u4E00",
        "\u5341\u4E8C"
    ],
    abbreviated: [
        "1\u6708",
        "2\u6708",
        "3\u6708",
        "4\u6708",
        "5\u6708",
        "6\u6708",
        "7\u6708",
        "8\u6708",
        "9\u6708",
        "10\u6708",
        "11\u6708",
        "12\u6708"
    ],
    wide: [
        "\u4E00\u6708",
        "\u4E8C\u6708",
        "\u4E09\u6708",
        "\u56DB\u6708",
        "\u4E94\u6708",
        "\u516D\u6708",
        "\u4E03\u6708",
        "\u516B\u6708",
        "\u4E5D\u6708",
        "\u5341\u6708",
        "\u5341\u4E00\u6708",
        "\u5341\u4E8C\u6708"
    ]
};
var $44086a9a632815c7$var$dayValues = {
    narrow: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    short: [
        "\u65E5",
        "\u4E00",
        "\u4E8C",
        "\u4E09",
        "\u56DB",
        "\u4E94",
        "\u516D"
    ],
    abbreviated: [
        "\u9031\u65E5",
        "\u9031\u4E00",
        "\u9031\u4E8C",
        "\u9031\u4E09",
        "\u9031\u56DB",
        "\u9031\u4E94",
        "\u9031\u516D"
    ],
    wide: [
        "\u661F\u671F\u65E5",
        "\u661F\u671F\u4E00",
        "\u661F\u671F\u4E8C",
        "\u661F\u671F\u4E09",
        "\u661F\u671F\u56DB",
        "\u661F\u671F\u4E94",
        "\u661F\u671F\u516D"
    ]
};
var $44086a9a632815c7$var$dayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    }
};
var $44086a9a632815c7$var$formattingDayPeriodValues = {
    narrow: {
        am: "\u4E0A",
        pm: "\u4E0B",
        midnight: "\u51CC\u6668",
        noon: "\u5348",
        morning: "\u65E9",
        afternoon: "\u4E0B\u5348",
        evening: "\u665A",
        night: "\u591C"
    },
    abbreviated: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    },
    wide: {
        am: "\u4E0A\u5348",
        pm: "\u4E0B\u5348",
        midnight: "\u51CC\u6668",
        noon: "\u4E2D\u5348",
        morning: "\u65E9\u6668",
        afternoon: "\u4E2D\u5348",
        evening: "\u665A\u4E0A",
        night: "\u591C\u9593"
    }
};
var $44086a9a632815c7$var$ordinalNumber = function ordinalNumber(dirtyNumber, options) {
    var number = Number(dirtyNumber);
    switch(options === null || options === void 0 ? void 0 : options.unit){
        case "date":
            return number + "\u65E5";
        case "hour":
            return number + "\u6642";
        case "minute":
            return number + "\u5206";
        case "second":
            return number + "\u79D2";
        default:
            return "\u7B2C " + number;
    }
};
var $44086a9a632815c7$var$localize = {
    ordinalNumber: $44086a9a632815c7$var$ordinalNumber,
    era: (0, $kp3bq.default)({
        values: $44086a9a632815c7$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $kp3bq.default)({
        values: $44086a9a632815c7$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $kp3bq.default)({
        values: $44086a9a632815c7$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $kp3bq.default)({
        values: $44086a9a632815c7$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $kp3bq.default)({
        values: $44086a9a632815c7$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $44086a9a632815c7$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $44086a9a632815c7$export$2e2bcd8739ae039 = $44086a9a632815c7$var$localize;

});

parcelRegister("3BfA8", function(module, exports) {

$parcel$export(module.exports, "default", () => $29f0ea0c4d77f3aa$export$2e2bcd8739ae039);

var $gKbFl = parcelRequire("gKbFl");

var $7pOAB = parcelRequire("7pOAB");
var $29f0ea0c4d77f3aa$var$matchOrdinalNumberPattern = /^(第\s*)?\d+(日|時|分|秒)?/i;
var $29f0ea0c4d77f3aa$var$parseOrdinalNumberPattern = /\d+/i;
var $29f0ea0c4d77f3aa$var$matchEraPatterns = {
    narrow: /^(前)/i,
    abbreviated: /^(前)/i,
    wide: /^(公元前|公元)/i
};
var $29f0ea0c4d77f3aa$var$parseEraPatterns = {
    any: [
        /^(前)/i,
        /^(公元)/i
    ]
};
var $29f0ea0c4d77f3aa$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^第[一二三四]刻/i,
    wide: /^第[一二三四]刻鐘/i
};
var $29f0ea0c4d77f3aa$var$parseQuarterPatterns = {
    any: [
        /(1|一)/i,
        /(2|二)/i,
        /(3|三)/i,
        /(4|四)/i
    ]
};
var $29f0ea0c4d77f3aa$var$matchMonthPatterns = {
    narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
    abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
    wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
};
var $29f0ea0c4d77f3aa$var$parseMonthPatterns = {
    narrow: [
        /^一/i,
        /^二/i,
        /^三/i,
        /^四/i,
        /^五/i,
        /^六/i,
        /^七/i,
        /^八/i,
        /^九/i,
        /^十(?!(一|二))/i,
        /^十一/i,
        /^十二/i
    ],
    any: [
        /^一|1/i,
        /^二|2/i,
        /^三|3/i,
        /^四|4/i,
        /^五|5/i,
        /^六|6/i,
        /^七|7/i,
        /^八|8/i,
        /^九|9/i,
        /^十(?!(一|二))|10/i,
        /^十一|11/i,
        /^十二|12/i
    ]
};
var $29f0ea0c4d77f3aa$var$matchDayPatterns = {
    narrow: /^[一二三四五六日]/i,
    short: /^[一二三四五六日]/i,
    abbreviated: /^週[一二三四五六日]/i,
    wide: /^星期[一二三四五六日]/i
};
var $29f0ea0c4d77f3aa$var$parseDayPatterns = {
    any: [
        /日/i,
        /一/i,
        /二/i,
        /三/i,
        /四/i,
        /五/i,
        /六/i
    ]
};
var $29f0ea0c4d77f3aa$var$matchDayPeriodPatterns = {
    any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
};
var $29f0ea0c4d77f3aa$var$parseDayPeriodPatterns = {
    any: {
        am: /^上午?/i,
        pm: /^下午?/i,
        midnight: /^午夜/i,
        noon: /^[中正]午/i,
        morning: /^早上/i,
        afternoon: /^下午/i,
        evening: /^晚上?/i,
        night: /^凌晨/i
    }
};
var $29f0ea0c4d77f3aa$var$match = {
    ordinalNumber: (0, $7pOAB.default)({
        matchPattern: $29f0ea0c4d77f3aa$var$matchOrdinalNumberPattern,
        parsePattern: $29f0ea0c4d77f3aa$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $gKbFl.default)({
        matchPatterns: $29f0ea0c4d77f3aa$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $29f0ea0c4d77f3aa$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $gKbFl.default)({
        matchPatterns: $29f0ea0c4d77f3aa$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $29f0ea0c4d77f3aa$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $gKbFl.default)({
        matchPatterns: $29f0ea0c4d77f3aa$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $29f0ea0c4d77f3aa$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $gKbFl.default)({
        matchPatterns: $29f0ea0c4d77f3aa$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $29f0ea0c4d77f3aa$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $gKbFl.default)({
        matchPatterns: $29f0ea0c4d77f3aa$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $29f0ea0c4d77f3aa$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $29f0ea0c4d77f3aa$export$2e2bcd8739ae039 = $29f0ea0c4d77f3aa$var$match;

});



parcelRegister("9nVYw", function(module, exports) {































































!function(e, t) {
    t(module.exports, (parcelRequire("acw62")), (parcelRequire("c9Z8w")), (parcelRequire("8g1PZ")), (parcelRequire("9BdaM")), (parcelRequire("cFZfS")), (parcelRequire("6IhJz")), (parcelRequire("bTSG2")), (parcelRequire("kehhj")), (parcelRequire("6OX6Q")), (parcelRequire("2MTnF")), (parcelRequire("eqWMS")), (parcelRequire("k005h")), (parcelRequire("kbDwl")), (parcelRequire("4irF8")), (parcelRequire("lDduA")), (parcelRequire("lXe7Q")), (parcelRequire("6tQqS")), (parcelRequire("4UG1B")), (parcelRequire("6fhf3")), (parcelRequire("aABJG")), (parcelRequire("kjLiX")), (parcelRequire("34ylv")), (parcelRequire("eZOMj")), (parcelRequire("hbMru")), (parcelRequire("4UeRq")), (parcelRequire("3LPyO")), (parcelRequire("knAHj")), (parcelRequire("2SwgK")), (parcelRequire("d0W11")), (parcelRequire("6mdUF")), (parcelRequire("gpyWg")), (parcelRequire("cZ2kT")), (parcelRequire("fVhCa")), (parcelRequire("3lKFD")), (parcelRequire("8v9st")), (parcelRequire("6atcA")), (parcelRequire("lm2ga")), (parcelRequire("1Whvr")), (parcelRequire("jMhzE")), (parcelRequire("cJfMa")), (parcelRequire("7yBDJ")), (parcelRequire("5E40x")), (parcelRequire("gVPZO")), (parcelRequire("6eIgt")), (parcelRequire("6uyHy")), (parcelRequire("75XN4")), (parcelRequire("l2vHo")), (parcelRequire("7LBzP")), (parcelRequire("gd5RE")), (parcelRequire("hjw1k")), (parcelRequire("b27pX")), (parcelRequire("R4xmB")), (parcelRequire("kggGd")), (parcelRequire("baBa1")), (parcelRequire("4YTY5")), (parcelRequire("gDwFN")), (parcelRequire("gdr0J")), (parcelRequire("auRgN")), (parcelRequire("dpjX2")), (parcelRequire("hL3CS")), (parcelRequire("1u0KT")), (parcelRequire("03b0h")), (parcelRequire("3VkbS")));
}(module.exports, function(e, t, r, a, n, o, s, i, p, l, c, d, u, f, h, m, y, v, D, g, k, w, b, S, C, _, M, P, E, N, x, Y, O, I, T, R, L, F, A, W, q, K, B, Q, H, j, V, U, z, $, G, J, X, Z, ee, te, re, ae, ne, oe, se, ie, pe, le) {
    "use strict";
    function ce(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var de = ce(t), ue = ce(a), fe = ce(n), he = ce(o), me = ce(s), ye = ce(i), ve = ce(p), De = ce(l), ge = ce(c), ke = ce(d), we = ce(u), be = ce(f), Se = ce(h), Ce = ce(m), _e = ce(y), Me = ce(v), Pe = ce(D), Ee = ce(g), Ne = ce(k), xe = ce(w), Ye = ce(b), Oe = ce(S), Ie = ce(C), Te = ce(_), Re = ce(M), Le = ce(P), Fe = ce(E), Ae = ce(N), We = ce(x), qe = ce(Y), Ke = ce(O), Be = ce(I), Qe = ce(T), He = ce(R), je = ce(L), Ve = ce(F), Ue = ce(A), ze = ce(W), $e = ce(q), Ge = ce(K), Je = ce(B), Xe = ce(Q), Ze = ce(H), et = ce(j), tt = ce(U), rt = ce(z), at = ce($), nt = ce(G), ot = ce(J), st = ce(X), it = ce(Z), pt = ce(ee), lt = ce(te), ct = ce(re), dt = ce(ae), ut = ce(ne), ft = ce(oe), ht = ce(se), mt = ce(ie), yt = ce(le);
    function vt(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var a = Object.getOwnPropertySymbols(e);
            t && (a = a.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function Dt(e) {
        for(var t = 1; t < arguments.length; t++){
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? vt(Object(r), !0).forEach(function(t) {
                St(e, t, r[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : vt(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
            });
        }
        return e;
    }
    function gt(e) {
        return gt = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e;
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        }, gt(e);
    }
    function kt(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function wt(e, t) {
        for(var r = 0; r < t.length; r++){
            var a = t[r];
            a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, Ot(a.key), a);
        }
    }
    function bt(e, t, r) {
        return t && wt(e.prototype, t), r && wt(e, r), Object.defineProperty(e, "prototype", {
            writable: !1
        }), e;
    }
    function St(e, t, r) {
        return (t = Ot(t)) in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e;
    }
    function Ct() {
        return Ct = Object.assign ? Object.assign.bind() : function(e) {
            for(var t = 1; t < arguments.length; t++){
                var r = arguments[t];
                for(var a in r)Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
            }
            return e;
        }, Ct.apply(this, arguments);
    }
    function _t(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
            constructor: {
                value: e,
                writable: !0,
                configurable: !0
            }
        }), Object.defineProperty(e, "prototype", {
            writable: !1
        }), t && Pt(e, t);
    }
    function Mt(e) {
        return Mt = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
            return e.__proto__ || Object.getPrototypeOf(e);
        }, Mt(e);
    }
    function Pt(e, t) {
        return Pt = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
            return e.__proto__ = t, e;
        }, Pt(e, t);
    }
    function Et(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
    }
    function Nt(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = Mt(e);
            if (t) {
                var n = Mt(this).constructor;
                r = Reflect.construct(a, arguments, n);
            } else r = a.apply(this, arguments);
            return function(e, t) {
                if (t && ("object" == typeof t || "function" == typeof t)) return t;
                if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                return Et(e);
            }(this, r);
        };
    }
    function xt(e) {
        return function(e) {
            if (Array.isArray(e)) return Yt(e);
        }(e) || function(e) {
            if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
        }(e) || function(e, t) {
            if (!e) return;
            if ("string" == typeof e) return Yt(e, t);
            var r = Object.prototype.toString.call(e).slice(8, -1);
            "Object" === r && e.constructor && (r = e.constructor.name);
            if ("Map" === r || "Set" === r) return Array.from(e);
            if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Yt(e, t);
        }(e) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
    }
    function Yt(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for(var r = 0, a = new Array(t); r < t; r++)a[r] = e[r];
        return a;
    }
    function Ot(e) {
        var t = function(e, t) {
            if ("object" != typeof e || null === e) return e;
            var r = e[Symbol.toPrimitive];
            if (void 0 !== r) {
                var a = r.call(e, t || "default");
                if ("object" != typeof a) return a;
                throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === t ? String : Number)(e);
        }(e, "string");
        return "symbol" == typeof t ? t : String(t);
    }
    var It = function(e, t) {
        switch(e){
            case "P":
                return t.date({
                    width: "short"
                });
            case "PP":
                return t.date({
                    width: "medium"
                });
            case "PPP":
                return t.date({
                    width: "long"
                });
            default:
                return t.date({
                    width: "full"
                });
        }
    }, Tt = function(e, t) {
        switch(e){
            case "p":
                return t.time({
                    width: "short"
                });
            case "pp":
                return t.time({
                    width: "medium"
                });
            case "ppp":
                return t.time({
                    width: "long"
                });
            default:
                return t.time({
                    width: "full"
                });
        }
    }, Rt = {
        p: Tt,
        P: function(e, t) {
            var r, a = e.match(/(P+)(p+)?/) || [], n = a[1], o = a[2];
            if (!o) return It(e, t);
            switch(n){
                case "P":
                    r = t.dateTime({
                        width: "short"
                    });
                    break;
                case "PP":
                    r = t.dateTime({
                        width: "medium"
                    });
                    break;
                case "PPP":
                    r = t.dateTime({
                        width: "long"
                    });
                    break;
                default:
                    r = t.dateTime({
                        width: "full"
                    });
            }
            return r.replace("{{date}}", It(n, t)).replace("{{time}}", Tt(o, t));
        }
    }, Lt = 12, Ft = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
    function At(e) {
        var t = e ? "string" == typeof e || e instanceof String ? ft.default(e) : dt.default(e) : new Date;
        return Wt(t) ? t : null;
    }
    function Wt(e, t) {
        return t = t || new Date("1/1/1000"), he.default(e) && !lt.default(e, t);
    }
    function qt(e, t, r) {
        if ("en" === r) return me.default(e, t, {
            awareOfUnicodeTokens: !0
        });
        var a = tr(r);
        return r && !a && console.warn('A locale object was not found for the provided string ["'.concat(r, '"].')), !a && er() && tr(er()) && (a = tr(er())), me.default(e, t, {
            locale: a || null,
            awareOfUnicodeTokens: !0
        });
    }
    function Kt(e, t) {
        var r = t.dateFormat, a = t.locale;
        return e && qt(e, Array.isArray(r) ? r[0] : r, a) || "";
    }
    function Bt(e, t) {
        var r = t.hour, a = void 0 === r ? 0 : r, n = t.minute, o = void 0 === n ? 0 : n, s = t.second, i = void 0 === s ? 0 : s;
        return qe.default(We.default(Ae.default(e, i), o), a);
    }
    function Qt(e, t, r) {
        var a = tr(t || er());
        return Ge.default(e, {
            locale: a,
            weekStartsOn: r
        });
    }
    function Ht(e) {
        return Je.default(e);
    }
    function jt(e) {
        return Ze.default(e);
    }
    function Vt(e) {
        return Xe.default(e);
    }
    function Ut() {
        return $e.default(At());
    }
    function zt(e, t) {
        return e && t ? st.default(e, t) : !e && !t;
    }
    function $t(e, t) {
        return e && t ? ot.default(e, t) : !e && !t;
    }
    function Gt(e, t) {
        return e && t ? it.default(e, t) : !e && !t;
    }
    function Jt(e, t) {
        return e && t ? nt.default(e, t) : !e && !t;
    }
    function Xt(e, t) {
        return e && t ? at.default(e, t) : !e && !t;
    }
    function Zt(e, t, r) {
        var a, n = $e.default(t), o = et.default(r);
        try {
            a = ct.default(e, {
                start: n,
                end: o
            });
        } catch (e) {
            a = !1;
        }
        return a;
    }
    function er() {
        return ("undefined" != typeof window ? window : globalThis).__localeId__;
    }
    function tr(e) {
        if ("string" == typeof e) {
            var t = "undefined" != typeof window ? window : globalThis;
            return t.__localeData__ ? t.__localeData__[e] : null;
        }
        return e;
    }
    function rr(e, t) {
        return qt(Ke.default(At(), e), "LLLL", t);
    }
    function ar(e, t) {
        return qt(Ke.default(At(), e), "LLL", t);
    }
    function nr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.maxDate, n = t.excludeDates, o = t.excludeDateIntervals, s = t.includeDates, i = t.includeDateIntervals, p = t.filterDate;
        return ur(e, {
            minDate: r,
            maxDate: a
        }) || n && n.some(function(t) {
            return Jt(e, t);
        }) || o && o.some(function(t) {
            var r = t.start, a = t.end;
            return ct.default(e, {
                start: r,
                end: a
            });
        }) || s && !s.some(function(t) {
            return Jt(e, t);
        }) || i && !i.some(function(t) {
            var r = t.start, a = t.end;
            return ct.default(e, {
                start: r,
                end: a
            });
        }) || p && !p(At(e)) || !1;
    }
    function or(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.excludeDates, a = t.excludeDateIntervals;
        return a && a.length > 0 ? a.some(function(t) {
            var r = t.start, a = t.end;
            return ct.default(e, {
                start: r,
                end: a
            });
        }) : r && r.some(function(t) {
            return Jt(e, t);
        }) || !1;
    }
    function sr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.maxDate, n = t.excludeDates, o = t.includeDates, s = t.filterDate;
        return ur(e, {
            minDate: Je.default(r),
            maxDate: tt.default(a)
        }) || n && n.some(function(t) {
            return $t(e, t);
        }) || o && !o.some(function(t) {
            return $t(e, t);
        }) || s && !s(At(e)) || !1;
    }
    function ir(e, t, r, a) {
        var n = Le.default(e), o = Te.default(e), s = Le.default(t), i = Te.default(t), p = Le.default(a);
        return n === s && n === p ? o <= r && r <= i : n < s ? p === n && o <= r || p === s && i >= r || p < s && p > n : void 0;
    }
    function pr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.maxDate, n = t.excludeDates, o = t.includeDates, s = t.filterDate;
        return ur(e, {
            minDate: r,
            maxDate: a
        }) || n && n.some(function(t) {
            return Gt(e, t);
        }) || o && !o.some(function(t) {
            return Gt(e, t);
        }) || s && !s(At(e)) || !1;
    }
    function lr(e, t, r) {
        if (!he.default(t) || !he.default(r)) return !1;
        var a = Le.default(t), n = Le.default(r);
        return a <= e && n >= e;
    }
    function cr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.maxDate, n = t.excludeDates, o = t.includeDates, s = t.filterDate, i = new Date(e, 0, 1);
        return ur(i, {
            minDate: Ze.default(r),
            maxDate: rt.default(a)
        }) || n && n.some(function(e) {
            return zt(i, e);
        }) || o && !o.some(function(e) {
            return zt(i, e);
        }) || s && !s(At(i)) || !1;
    }
    function dr(e, t, r, a) {
        var n = Le.default(e), o = Re.default(e), s = Le.default(t), i = Re.default(t), p = Le.default(a);
        return n === s && n === p ? o <= r && r <= i : n < s ? p === n && o <= r || p === s && i >= r || p < s && p > n : void 0;
    }
    function ur(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.maxDate;
        return r && Ve.default(e, r) < 0 || a && Ve.default(e, a) > 0;
    }
    function fr(e, t) {
        return t.some(function(t) {
            return xe.default(t) === xe.default(e) && Ne.default(t) === Ne.default(e);
        });
    }
    function hr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.excludeTimes, a = t.includeTimes, n = t.filterTime;
        return r && fr(e, r) || a && !fr(e, a) || n && !n(e) || !1;
    }
    function mr(e, t) {
        var r = t.minTime, a = t.maxTime;
        if (!r || !a) throw new Error("Both minTime and maxTime props required");
        var n, o = At(), s = qe.default(We.default(o, Ne.default(e)), xe.default(e)), i = qe.default(We.default(o, Ne.default(r)), xe.default(r)), p = qe.default(We.default(o, Ne.default(a)), xe.default(a));
        try {
            n = !ct.default(s, {
                start: i,
                end: p
            });
        } catch (e) {
            n = !1;
        }
        return n;
    }
    function yr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.includeDates, n = _e.default(e, 1);
        return r && Ue.default(r, n) > 0 || a && a.every(function(e) {
            return Ue.default(e, n) > 0;
        }) || !1;
    }
    function vr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.maxDate, a = t.includeDates, n = ke.default(e, 1);
        return r && Ue.default(n, r) > 0 || a && a.every(function(e) {
            return Ue.default(n, e) > 0;
        }) || !1;
    }
    function Dr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.includeDates, n = Pe.default(e, 1);
        return r && ze.default(r, n) > 0 || a && a.every(function(e) {
            return ze.default(e, n) > 0;
        }) || !1;
    }
    function gr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.maxDate, a = t.includeDates, n = be.default(e, 1);
        return r && ze.default(n, r) > 0 || a && a.every(function(e) {
            return ze.default(n, e) > 0;
        }) || !1;
    }
    function kr(e) {
        var t = e.minDate, r = e.includeDates;
        if (r && t) {
            var a = r.filter(function(e) {
                return Ve.default(e, t) >= 0;
            });
            return He.default(a);
        }
        return r ? He.default(r) : t;
    }
    function wr(e) {
        var t = e.maxDate, r = e.includeDates;
        if (r && t) {
            var a = r.filter(function(e) {
                return Ve.default(e, t) <= 0;
            });
            return je.default(a);
        }
        return r ? je.default(r) : t;
    }
    function br() {
        for(var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "react-datepicker__day--highlighted", r = new Map, a = 0, n = e.length; a < n; a++){
            var o = e[a];
            if (fe.default(o)) {
                var s = qt(o, "MM.dd.yyyy"), i = r.get(s) || [];
                i.includes(t) || (i.push(t), r.set(s, i));
            } else if ("object" === gt(o)) {
                var p = Object.keys(o), l = p[0], c = o[p[0]];
                if ("string" == typeof l && c.constructor === Array) for(var d = 0, u = c.length; d < u; d++){
                    var f = qt(c[d], "MM.dd.yyyy"), h = r.get(f) || [];
                    h.includes(l) || (h.push(l), r.set(f, h));
                }
            }
        }
        return r;
    }
    function Sr() {
        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "react-datepicker__day--holidays", r = new Map;
        return e.forEach(function(e) {
            var a = e.date, n = e.holidayName;
            if (fe.default(a)) {
                var o = qt(a, "MM.dd.yyyy"), s = r.get(o) || {};
                if (!("className" in s) || s.className !== t || (i = s.holidayNames, p = [
                    n
                ], i.length !== p.length || !i.every(function(e, t) {
                    return e === p[t];
                }))) {
                    var i, p;
                    s.className = t;
                    var l = s.holidayNames;
                    s.holidayNames = l ? [].concat(xt(l), [
                        n
                    ]) : [
                        n
                    ], r.set(o, s);
                }
            }
        }), r;
    }
    function Cr(e, t, r, a, n) {
        for(var o = n.length, s = [], i = 0; i < o; i++){
            var p = ye.default(ve.default(e, xe.default(n[i])), Ne.default(n[i])), l = ye.default(e, (r + 1) * a);
            pt.default(p, t) && lt.default(p, l) && s.push(n[i]);
        }
        return s;
    }
    function _r(e) {
        return e < 10 ? "0".concat(e) : "".concat(e);
    }
    function Mr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Lt, r = Math.ceil(Le.default(e) / t) * t;
        return {
            startPeriod: r - (t - 1),
            endPeriod: r
        };
    }
    function Pr(e) {
        var t = e.getSeconds(), r = e.getMilliseconds();
        return dt.default(e.getTime() - 1e3 * t - r);
    }
    function Er(e, t, r, a) {
        for(var n = [], o = 0; o < 2 * t + 1; o++){
            var s = e + t - o, i = !0;
            r && (i = Le.default(r) <= s), a && i && (i = Le.default(a) >= s), i && n.push(s);
        }
        return n;
    }
    var Nr = function(e) {
        _t(a, e);
        var r = Nt(a);
        function a(e) {
            var n;
            kt(this, a), St(Et(n = r.call(this, e)), "renderOptions", function() {
                var e = n.props.year, t = n.state.yearsList.map(function(t) {
                    return de.default.createElement("div", {
                        className: e === t ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
                        key: t,
                        onClick: n.onChange.bind(Et(n), t),
                        "aria-selected": e === t ? "true" : void 0
                    }, e === t ? de.default.createElement("span", {
                        className: "react-datepicker__year-option--selected"
                    }, "\u2713") : "", t);
                }), r = n.props.minDate ? Le.default(n.props.minDate) : null, a = n.props.maxDate ? Le.default(n.props.maxDate) : null;
                return a && n.state.yearsList.find(function(e) {
                    return e === a;
                }) || t.unshift(de.default.createElement("div", {
                    className: "react-datepicker__year-option",
                    key: "upcoming",
                    onClick: n.incrementYears
                }, de.default.createElement("a", {
                    className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"
                }))), r && n.state.yearsList.find(function(e) {
                    return e === r;
                }) || t.push(de.default.createElement("div", {
                    className: "react-datepicker__year-option",
                    key: "previous",
                    onClick: n.decrementYears
                }, de.default.createElement("a", {
                    className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"
                }))), t;
            }), St(Et(n), "onChange", function(e) {
                n.props.onChange(e);
            }), St(Et(n), "handleClickOutside", function() {
                n.props.onCancel();
            }), St(Et(n), "shiftYears", function(e) {
                var t = n.state.yearsList.map(function(t) {
                    return t + e;
                });
                n.setState({
                    yearsList: t
                });
            }), St(Et(n), "incrementYears", function() {
                return n.shiftYears(1);
            }), St(Et(n), "decrementYears", function() {
                return n.shiftYears(-1);
            });
            var o = e.yearDropdownItemNumber, s = e.scrollableYearDropdown, i = o || (s ? 10 : 5);
            return n.state = {
                yearsList: Er(n.props.year, i, n.props.minDate, n.props.maxDate)
            }, n.dropdownRef = t.createRef(), n;
        }
        return bt(a, [
            {
                key: "componentDidMount",
                value: function() {
                    var e = this.dropdownRef.current;
                    if (e) {
                        var t = e.children ? Array.from(e.children) : null, r = t ? t.find(function(e) {
                            return e.ariaSelected;
                        }) : null;
                        e.scrollTop = r ? r.offsetTop + (r.clientHeight - e.clientHeight) / 2 : (e.scrollHeight - e.clientHeight) / 2;
                    }
                }
            },
            {
                key: "render",
                value: function() {
                    var e = ue.default({
                        "react-datepicker__year-dropdown": !0,
                        "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
                    });
                    return de.default.createElement("div", {
                        className: e,
                        ref: this.dropdownRef
                    }, this.renderOptions());
                }
            }
        ]), a;
    }(de.default.Component), xr = ht.default(Nr), Yr = function(e) {
        _t(r, e);
        var t = Nt(r);
        function r() {
            var e;
            kt(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return St(Et(e = t.call.apply(t, [
                this
            ].concat(n))), "state", {
                dropdownVisible: !1
            }), St(Et(e), "renderSelectOptions", function() {
                for(var t = e.props.minDate ? Le.default(e.props.minDate) : 1900, r = e.props.maxDate ? Le.default(e.props.maxDate) : 2100, a = [], n = t; n <= r; n++)a.push(de.default.createElement("option", {
                    key: n,
                    value: n
                }, n));
                return a;
            }), St(Et(e), "onSelectChange", function(t) {
                e.onChange(t.target.value);
            }), St(Et(e), "renderSelectMode", function() {
                return de.default.createElement("select", {
                    value: e.props.year,
                    className: "react-datepicker__year-select",
                    onChange: e.onSelectChange
                }, e.renderSelectOptions());
            }), St(Et(e), "renderReadView", function(t) {
                return de.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: t ? "visible" : "hidden"
                    },
                    className: "react-datepicker__year-read-view",
                    onClick: function(t) {
                        return e.toggleDropdown(t);
                    }
                }, de.default.createElement("span", {
                    className: "react-datepicker__year-read-view--down-arrow"
                }), de.default.createElement("span", {
                    className: "react-datepicker__year-read-view--selected-year"
                }, e.props.year));
            }), St(Et(e), "renderDropdown", function() {
                return de.default.createElement(xr, {
                    key: "dropdown",
                    year: e.props.year,
                    onChange: e.onChange,
                    onCancel: e.toggleDropdown,
                    minDate: e.props.minDate,
                    maxDate: e.props.maxDate,
                    scrollableYearDropdown: e.props.scrollableYearDropdown,
                    yearDropdownItemNumber: e.props.yearDropdownItemNumber
                });
            }), St(Et(e), "renderScrollMode", function() {
                var t = e.state.dropdownVisible, r = [
                    e.renderReadView(!t)
                ];
                return t && r.unshift(e.renderDropdown()), r;
            }), St(Et(e), "onChange", function(t) {
                e.toggleDropdown(), t !== e.props.year && e.props.onChange(t);
            }), St(Et(e), "toggleDropdown", function(t) {
                e.setState({
                    dropdownVisible: !e.state.dropdownVisible
                }, function() {
                    e.props.adjustDateOnChange && e.handleYearChange(e.props.date, t);
                });
            }), St(Et(e), "handleYearChange", function(t, r) {
                e.onSelect(t, r), e.setOpen();
            }), St(Et(e), "onSelect", function(t, r) {
                e.props.onSelect && e.props.onSelect(t, r);
            }), St(Et(e), "setOpen", function() {
                e.props.setOpen && e.props.setOpen(!0);
            }), e;
        }
        return bt(r, [
            {
                key: "render",
                value: function() {
                    var e;
                    switch(this.props.dropdownMode){
                        case "scroll":
                            e = this.renderScrollMode();
                            break;
                        case "select":
                            e = this.renderSelectMode();
                    }
                    return de.default.createElement("div", {
                        className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)
                    }, e);
                }
            }
        ]), r;
    }(de.default.Component), Or = function(e) {
        _t(r, e);
        var t = Nt(r);
        function r() {
            var e;
            kt(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return St(Et(e = t.call.apply(t, [
                this
            ].concat(n))), "isSelectedMonth", function(t) {
                return e.props.month === t;
            }), St(Et(e), "renderOptions", function() {
                return e.props.monthNames.map(function(t, r) {
                    return de.default.createElement("div", {
                        className: e.isSelectedMonth(r) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option",
                        key: t,
                        onClick: e.onChange.bind(Et(e), r),
                        "aria-selected": e.isSelectedMonth(r) ? "true" : void 0
                    }, e.isSelectedMonth(r) ? de.default.createElement("span", {
                        className: "react-datepicker__month-option--selected"
                    }, "\u2713") : "", t);
                });
            }), St(Et(e), "onChange", function(t) {
                return e.props.onChange(t);
            }), St(Et(e), "handleClickOutside", function() {
                return e.props.onCancel();
            }), e;
        }
        return bt(r, [
            {
                key: "render",
                value: function() {
                    return de.default.createElement("div", {
                        className: "react-datepicker__month-dropdown"
                    }, this.renderOptions());
                }
            }
        ]), r;
    }(de.default.Component), Ir = ht.default(Or), Tr = function(e) {
        _t(r, e);
        var t = Nt(r);
        function r() {
            var e;
            kt(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return St(Et(e = t.call.apply(t, [
                this
            ].concat(n))), "state", {
                dropdownVisible: !1
            }), St(Et(e), "renderSelectOptions", function(e) {
                return e.map(function(e, t) {
                    return de.default.createElement("option", {
                        key: t,
                        value: t
                    }, e);
                });
            }), St(Et(e), "renderSelectMode", function(t) {
                return de.default.createElement("select", {
                    value: e.props.month,
                    className: "react-datepicker__month-select",
                    onChange: function(t) {
                        return e.onChange(t.target.value);
                    }
                }, e.renderSelectOptions(t));
            }), St(Et(e), "renderReadView", function(t, r) {
                return de.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: t ? "visible" : "hidden"
                    },
                    className: "react-datepicker__month-read-view",
                    onClick: e.toggleDropdown
                }, de.default.createElement("span", {
                    className: "react-datepicker__month-read-view--down-arrow"
                }), de.default.createElement("span", {
                    className: "react-datepicker__month-read-view--selected-month"
                }, r[e.props.month]));
            }), St(Et(e), "renderDropdown", function(t) {
                return de.default.createElement(Ir, {
                    key: "dropdown",
                    month: e.props.month,
                    monthNames: t,
                    onChange: e.onChange,
                    onCancel: e.toggleDropdown
                });
            }), St(Et(e), "renderScrollMode", function(t) {
                var r = e.state.dropdownVisible, a = [
                    e.renderReadView(!r, t)
                ];
                return r && a.unshift(e.renderDropdown(t)), a;
            }), St(Et(e), "onChange", function(t) {
                e.toggleDropdown(), t !== e.props.month && e.props.onChange(t);
            }), St(Et(e), "toggleDropdown", function() {
                return e.setState({
                    dropdownVisible: !e.state.dropdownVisible
                });
            }), e;
        }
        return bt(r, [
            {
                key: "render",
                value: function() {
                    var e, t = this, r = [
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11
                    ].map(this.props.useShortMonthInDropdown ? function(e) {
                        return ar(e, t.props.locale);
                    } : function(e) {
                        return rr(e, t.props.locale);
                    });
                    switch(this.props.dropdownMode){
                        case "scroll":
                            e = this.renderScrollMode(r);
                            break;
                        case "select":
                            e = this.renderSelectMode(r);
                    }
                    return de.default.createElement("div", {
                        className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)
                    }, e);
                }
            }
        ]), r;
    }(de.default.Component);
    function Rr(e, t) {
        for(var r = [], a = Ht(e), n = Ht(t); !pt.default(a, n);)r.push(At(a)), a = ke.default(a, 1);
        return r;
    }
    var Lr = function(e) {
        _t(r, e);
        var t = Nt(r);
        function r(e) {
            var a;
            return kt(this, r), St(Et(a = t.call(this, e)), "renderOptions", function() {
                return a.state.monthYearsList.map(function(e) {
                    var t = Fe.default(e), r = zt(a.props.date, e) && $t(a.props.date, e);
                    return de.default.createElement("div", {
                        className: r ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option",
                        key: t,
                        onClick: a.onChange.bind(Et(a), t),
                        "aria-selected": r ? "true" : void 0
                    }, r ? de.default.createElement("span", {
                        className: "react-datepicker__month-year-option--selected"
                    }, "\u2713") : "", qt(e, a.props.dateFormat, a.props.locale));
                });
            }), St(Et(a), "onChange", function(e) {
                return a.props.onChange(e);
            }), St(Et(a), "handleClickOutside", function() {
                a.props.onCancel();
            }), a.state = {
                monthYearsList: Rr(a.props.minDate, a.props.maxDate)
            }, a;
        }
        return bt(r, [
            {
                key: "render",
                value: function() {
                    var e = ue.default({
                        "react-datepicker__month-year-dropdown": !0,
                        "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
                    });
                    return de.default.createElement("div", {
                        className: e
                    }, this.renderOptions());
                }
            }
        ]), r;
    }(de.default.Component), Fr = ht.default(Lr), Ar = function(e) {
        _t(r, e);
        var t = Nt(r);
        function r() {
            var e;
            kt(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return St(Et(e = t.call.apply(t, [
                this
            ].concat(n))), "state", {
                dropdownVisible: !1
            }), St(Et(e), "renderSelectOptions", function() {
                for(var t = Ht(e.props.minDate), r = Ht(e.props.maxDate), a = []; !pt.default(t, r);){
                    var n = Fe.default(t);
                    a.push(de.default.createElement("option", {
                        key: n,
                        value: n
                    }, qt(t, e.props.dateFormat, e.props.locale))), t = ke.default(t, 1);
                }
                return a;
            }), St(Et(e), "onSelectChange", function(t) {
                e.onChange(t.target.value);
            }), St(Et(e), "renderSelectMode", function() {
                return de.default.createElement("select", {
                    value: Fe.default(Ht(e.props.date)),
                    className: "react-datepicker__month-year-select",
                    onChange: e.onSelectChange
                }, e.renderSelectOptions());
            }), St(Et(e), "renderReadView", function(t) {
                var r = qt(e.props.date, e.props.dateFormat, e.props.locale);
                return de.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: t ? "visible" : "hidden"
                    },
                    className: "react-datepicker__month-year-read-view",
                    onClick: function(t) {
                        return e.toggleDropdown(t);
                    }
                }, de.default.createElement("span", {
                    className: "react-datepicker__month-year-read-view--down-arrow"
                }), de.default.createElement("span", {
                    className: "react-datepicker__month-year-read-view--selected-month-year"
                }, r));
            }), St(Et(e), "renderDropdown", function() {
                return de.default.createElement(Fr, {
                    key: "dropdown",
                    date: e.props.date,
                    dateFormat: e.props.dateFormat,
                    onChange: e.onChange,
                    onCancel: e.toggleDropdown,
                    minDate: e.props.minDate,
                    maxDate: e.props.maxDate,
                    scrollableMonthYearDropdown: e.props.scrollableMonthYearDropdown,
                    locale: e.props.locale
                });
            }), St(Et(e), "renderScrollMode", function() {
                var t = e.state.dropdownVisible, r = [
                    e.renderReadView(!t)
                ];
                return t && r.unshift(e.renderDropdown()), r;
            }), St(Et(e), "onChange", function(t) {
                e.toggleDropdown();
                var r = At(parseInt(t));
                zt(e.props.date, r) && $t(e.props.date, r) || e.props.onChange(r);
            }), St(Et(e), "toggleDropdown", function() {
                return e.setState({
                    dropdownVisible: !e.state.dropdownVisible
                });
            }), e;
        }
        return bt(r, [
            {
                key: "render",
                value: function() {
                    var e;
                    switch(this.props.dropdownMode){
                        case "scroll":
                            e = this.renderScrollMode();
                            break;
                        case "select":
                            e = this.renderSelectMode();
                    }
                    return de.default.createElement("div", {
                        className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)
                    }, e);
                }
            }
        ]), r;
    }(de.default.Component), Wr = function(e) {
        _t(r, e);
        var t = Nt(r);
        function r() {
            var e;
            kt(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return St(Et(e = t.call.apply(t, [
                this
            ].concat(n))), "dayEl", de.default.createRef()), St(Et(e), "handleClick", function(t) {
                !e.isDisabled() && e.props.onClick && e.props.onClick(t);
            }), St(Et(e), "handleMouseEnter", function(t) {
                !e.isDisabled() && e.props.onMouseEnter && e.props.onMouseEnter(t);
            }), St(Et(e), "handleOnKeyDown", function(t) {
                " " === t.key && (t.preventDefault(), t.key = "Enter"), e.props.handleOnKeyDown(t);
            }), St(Et(e), "isSameDay", function(t) {
                return Jt(e.props.day, t);
            }), St(Et(e), "isKeyboardSelected", function() {
                return !e.props.disabledKeyboardNavigation && !(e.isSameDay(e.props.selected) || e.isSameWeek(e.props.selected)) && (e.isSameDay(e.props.preSelection) || e.isSameWeek(e.props.preSelection));
            }), St(Et(e), "isDisabled", function() {
                return nr(e.props.day, e.props);
            }), St(Et(e), "isExcluded", function() {
                return or(e.props.day, e.props);
            }), St(Et(e), "isStartOfWeek", function() {
                return Jt(e.props.day, Qt(e.props.day, e.props.locale, e.props.calendarStartDay));
            }), St(Et(e), "isSameWeek", function(t) {
                return e.props.showWeekPicker && Jt(t, Qt(e.props.day, e.props.locale, e.props.calendarStartDay));
            }), St(Et(e), "getHighLightedClass", function() {
                var t = e.props, r = t.day, a = t.highlightDates;
                if (!a) return !1;
                var n = qt(r, "MM.dd.yyyy");
                return a.get(n);
            }), St(Et(e), "getHolidaysClass", function() {
                var t = e.props, r = t.day, a = t.holidays;
                if (!a) return !1;
                var n = qt(r, "MM.dd.yyyy");
                return a.has(n) ? [
                    a.get(n).className
                ] : void 0;
            }), St(Et(e), "isInRange", function() {
                var t = e.props, r = t.day, a = t.startDate, n = t.endDate;
                return !(!a || !n) && Zt(r, a, n);
            }), St(Et(e), "isInSelectingRange", function() {
                var t, r = e.props, a = r.day, n = r.selectsStart, o = r.selectsEnd, s = r.selectsRange, i = r.selectsDisabledDaysInRange, p = r.startDate, l = r.endDate, c = null !== (t = e.props.selectingDate) && void 0 !== t ? t : e.props.preSelection;
                return !(!(n || o || s) || !c || !i && e.isDisabled()) && (n && l && (lt.default(c, l) || Xt(c, l)) ? Zt(a, c, l) : (o && p && (pt.default(c, p) || Xt(c, p)) || !(!s || !p || l || !pt.default(c, p) && !Xt(c, p))) && Zt(a, p, c));
            }), St(Et(e), "isSelectingRangeStart", function() {
                var t;
                if (!e.isInSelectingRange()) return !1;
                var r = e.props, a = r.day, n = r.startDate, o = r.selectsStart, s = null !== (t = e.props.selectingDate) && void 0 !== t ? t : e.props.preSelection;
                return Jt(a, o ? s : n);
            }), St(Et(e), "isSelectingRangeEnd", function() {
                var t;
                if (!e.isInSelectingRange()) return !1;
                var r = e.props, a = r.day, n = r.endDate, o = r.selectsEnd, s = r.selectsRange, i = null !== (t = e.props.selectingDate) && void 0 !== t ? t : e.props.preSelection;
                return Jt(a, o || s ? i : n);
            }), St(Et(e), "isRangeStart", function() {
                var t = e.props, r = t.day, a = t.startDate, n = t.endDate;
                return !(!a || !n) && Jt(a, r);
            }), St(Et(e), "isRangeEnd", function() {
                var t = e.props, r = t.day, a = t.startDate, n = t.endDate;
                return !(!a || !n) && Jt(n, r);
            }), St(Et(e), "isWeekend", function() {
                var t = Ye.default(e.props.day);
                return 0 === t || 6 === t;
            }), St(Et(e), "isAfterMonth", function() {
                return void 0 !== e.props.month && (e.props.month + 1) % 12 === Te.default(e.props.day);
            }), St(Et(e), "isBeforeMonth", function() {
                return void 0 !== e.props.month && (Te.default(e.props.day) + 1) % 12 === e.props.month;
            }), St(Et(e), "isCurrentDay", function() {
                return e.isSameDay(At());
            }), St(Et(e), "isSelected", function() {
                return e.isSameDay(e.props.selected) || e.isSameWeek(e.props.selected);
            }), St(Et(e), "getClassNames", function(t) {
                var r, a = e.props.dayClassName ? e.props.dayClassName(t) : void 0;
                return ue.default("react-datepicker__day", a, "react-datepicker__day--" + qt(e.props.day, "ddd", r), {
                    "react-datepicker__day--disabled": e.isDisabled(),
                    "react-datepicker__day--excluded": e.isExcluded(),
                    "react-datepicker__day--selected": e.isSelected(),
                    "react-datepicker__day--keyboard-selected": e.isKeyboardSelected(),
                    "react-datepicker__day--range-start": e.isRangeStart(),
                    "react-datepicker__day--range-end": e.isRangeEnd(),
                    "react-datepicker__day--in-range": e.isInRange(),
                    "react-datepicker__day--in-selecting-range": e.isInSelectingRange(),
                    "react-datepicker__day--selecting-range-start": e.isSelectingRangeStart(),
                    "react-datepicker__day--selecting-range-end": e.isSelectingRangeEnd(),
                    "react-datepicker__day--today": e.isCurrentDay(),
                    "react-datepicker__day--weekend": e.isWeekend(),
                    "react-datepicker__day--outside-month": e.isAfterMonth() || e.isBeforeMonth()
                }, e.getHighLightedClass("react-datepicker__day--highlighted"), e.getHolidaysClass());
            }), St(Et(e), "getAriaLabel", function() {
                var t = e.props, r = t.day, a = t.ariaLabelPrefixWhenEnabled, n = void 0 === a ? "Choose" : a, o = t.ariaLabelPrefixWhenDisabled, s = void 0 === o ? "Not available" : o, i = e.isDisabled() || e.isExcluded() ? s : n;
                return "".concat(i, " ").concat(qt(r, "PPPP", e.props.locale));
            }), St(Et(e), "getTitle", function() {
                var t = e.props, r = t.day, a = t.holidays, n = void 0 === a ? new Map : a, o = qt(r, "MM.dd.yyyy");
                return n.has(o) && n.get(o).holidayNames.length > 0 ? n.get(o).holidayNames.join(", ") : "";
            }), St(Et(e), "getTabIndex", function(t, r) {
                var a = t || e.props.selected, n = r || e.props.preSelection;
                return (!e.props.showWeekPicker || !e.props.showWeekNumber && e.isStartOfWeek()) && (e.isKeyboardSelected() || e.isSameDay(a) && Jt(n, a)) ? 0 : -1;
            }), St(Et(e), "handleFocusDay", function() {
                var t, r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, a = !1;
                0 === e.getTabIndex() && !r.isInputFocused && e.isSameDay(e.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (a = !0), e.props.inline && !e.props.shouldFocusDayInline && (a = !1), e.props.containerRef && e.props.containerRef.current && e.props.containerRef.current.contains(document.activeElement) && document.activeElement.classList.contains("react-datepicker__day") && (a = !0), e.props.monthShowsDuplicateDaysEnd && e.isAfterMonth() && (a = !1), e.props.monthShowsDuplicateDaysStart && e.isBeforeMonth() && (a = !1)), a && (null === (t = e.dayEl.current) || void 0 === t || t.focus({
                    preventScroll: !0
                }));
            }), St(Et(e), "renderDayContents", function() {
                return e.props.monthShowsDuplicateDaysEnd && e.isAfterMonth() || e.props.monthShowsDuplicateDaysStart && e.isBeforeMonth() ? null : e.props.renderDayContents ? e.props.renderDayContents(Oe.default(e.props.day), e.props.day) : Oe.default(e.props.day);
            }), St(Et(e), "render", function() {
                return de.default.createElement("div", {
                    ref: e.dayEl,
                    className: e.getClassNames(e.props.day),
                    onKeyDown: e.handleOnKeyDown,
                    onClick: e.handleClick,
                    onMouseEnter: e.handleMouseEnter,
                    tabIndex: e.getTabIndex(),
                    "aria-label": e.getAriaLabel(),
                    role: "option",
                    title: e.getTitle(),
                    "aria-disabled": e.isDisabled(),
                    "aria-current": e.isCurrentDay() ? "date" : void 0,
                    "aria-selected": e.isSelected() || e.isInRange()
                }, e.renderDayContents(), "" !== e.getTitle() && de.default.createElement("span", {
                    className: "holiday-overlay"
                }, e.getTitle()));
            }), e;
        }
        return bt(r, [
            {
                key: "componentDidMount",
                value: function() {
                    this.handleFocusDay();
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e) {
                    this.handleFocusDay(e);
                }
            }
        ]), r;
    }(de.default.Component), qr = function(e) {
        _t(r, e);
        var t = Nt(r);
        function r() {
            var e;
            kt(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return St(Et(e = t.call.apply(t, [
                this
            ].concat(n))), "weekNumberEl", de.default.createRef()), St(Et(e), "handleClick", function(t) {
                e.props.onClick && e.props.onClick(t);
            }), St(Et(e), "handleOnKeyDown", function(t) {
                " " === t.key && (t.preventDefault(), t.key = "Enter"), e.props.handleOnKeyDown(t);
            }), St(Et(e), "isKeyboardSelected", function() {
                return !e.props.disabledKeyboardNavigation && !Jt(e.props.date, e.props.selected) && Jt(e.props.date, e.props.preSelection);
            }), St(Et(e), "getTabIndex", function() {
                return e.props.showWeekPicker && e.props.showWeekNumber && (e.isKeyboardSelected() || Jt(e.props.date, e.props.selected) && Jt(e.props.preSelection, e.props.selected)) ? 0 : -1;
            }), St(Et(e), "handleFocusWeekNumber", function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r = !1;
                0 === e.getTabIndex() && !t.isInputFocused && Jt(e.props.date, e.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (r = !0), e.props.inline && !e.props.shouldFocusDayInline && (r = !1), e.props.containerRef && e.props.containerRef.current && e.props.containerRef.current.contains(document.activeElement) && document.activeElement && document.activeElement.classList.contains("react-datepicker__week-number") && (r = !0)), r && e.weekNumberEl.current && e.weekNumberEl.current.focus({
                    preventScroll: !0
                });
            }), e;
        }
        return bt(r, [
            {
                key: "componentDidMount",
                value: function() {
                    this.handleFocusWeekNumber();
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e) {
                    this.handleFocusWeekNumber(e);
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.props, t = e.weekNumber, r = e.ariaLabelPrefix, a = void 0 === r ? "week " : r, n = {
                        "react-datepicker__week-number": !0,
                        "react-datepicker__week-number--clickable": !!e.onClick,
                        "react-datepicker__week-number--selected": Jt(this.props.date, this.props.selected),
                        "react-datepicker__week-number--keyboard-selected": this.isKeyboardSelected()
                    };
                    return de.default.createElement("div", {
                        ref: this.weekNumberEl,
                        className: ue.default(n),
                        "aria-label": "".concat(a, " ").concat(this.props.weekNumber),
                        onClick: this.handleClick,
                        onKeyDown: this.handleOnKeyDown,
                        tabIndex: this.getTabIndex()
                    }, t);
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        ariaLabelPrefix: "week "
                    };
                }
            }
        ]), r;
    }(de.default.Component), Kr = function(e) {
        _t(r, e);
        var t = Nt(r);
        function r() {
            var e;
            kt(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return St(Et(e = t.call.apply(t, [
                this
            ].concat(n))), "handleDayClick", function(t, r) {
                e.props.onDayClick && e.props.onDayClick(t, r);
            }), St(Et(e), "handleDayMouseEnter", function(t) {
                e.props.onDayMouseEnter && e.props.onDayMouseEnter(t);
            }), St(Et(e), "handleWeekClick", function(t, r, a) {
                if ("function" == typeof e.props.onWeekSelect && e.props.onWeekSelect(t, r, a), e.props.showWeekPicker) {
                    var n = Qt(t, e.props.locale, e.props.calendarStartDay);
                    e.handleDayClick(n, a);
                }
                e.props.shouldCloseOnSelect && e.props.setOpen(!1);
            }), St(Et(e), "formatWeekNumber", function(t) {
                return e.props.formatWeekNumber ? e.props.formatWeekNumber(t) : function(e, t) {
                    var r = t && tr(t) || er() && tr(er());
                    return Ie.default(e, r ? {
                        locale: r
                    } : null);
                }(t);
            }), St(Et(e), "renderDays", function() {
                var t = Qt(e.props.day, e.props.locale, e.props.calendarStartDay), r = [], a = e.formatWeekNumber(t);
                if (e.props.showWeekNumber) {
                    var n = e.props.onWeekSelect || e.props.showWeekPicker ? e.handleWeekClick.bind(Et(e), t, a) : void 0;
                    r.push(de.default.createElement(qr, {
                        key: "W",
                        weekNumber: a,
                        date: t,
                        onClick: n,
                        selected: e.props.selected,
                        preSelection: e.props.preSelection,
                        ariaLabelPrefix: e.props.ariaLabelPrefix,
                        showWeekPicker: e.props.showWeekPicker,
                        showWeekNumber: e.props.showWeekNumber,
                        disabledKeyboardNavigation: e.props.disabledKeyboardNavigation,
                        handleOnKeyDown: e.props.handleOnKeyDown,
                        isInputFocused: e.props.isInputFocused,
                        containerRef: e.props.containerRef
                    }));
                }
                return r.concat([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6
                ].map(function(r) {
                    var a = De.default(t, r);
                    return de.default.createElement(Wr, {
                        ariaLabelPrefixWhenEnabled: e.props.chooseDayAriaLabelPrefix,
                        ariaLabelPrefixWhenDisabled: e.props.disabledDayAriaLabelPrefix,
                        key: a.valueOf(),
                        day: a,
                        month: e.props.month,
                        onClick: e.handleDayClick.bind(Et(e), a),
                        onMouseEnter: e.handleDayMouseEnter.bind(Et(e), a),
                        minDate: e.props.minDate,
                        maxDate: e.props.maxDate,
                        excludeDates: e.props.excludeDates,
                        excludeDateIntervals: e.props.excludeDateIntervals,
                        includeDates: e.props.includeDates,
                        includeDateIntervals: e.props.includeDateIntervals,
                        highlightDates: e.props.highlightDates,
                        holidays: e.props.holidays,
                        selectingDate: e.props.selectingDate,
                        filterDate: e.props.filterDate,
                        preSelection: e.props.preSelection,
                        selected: e.props.selected,
                        selectsStart: e.props.selectsStart,
                        selectsEnd: e.props.selectsEnd,
                        selectsRange: e.props.selectsRange,
                        showWeekPicker: e.props.showWeekPicker,
                        showWeekNumber: e.props.showWeekNumber,
                        selectsDisabledDaysInRange: e.props.selectsDisabledDaysInRange,
                        startDate: e.props.startDate,
                        endDate: e.props.endDate,
                        dayClassName: e.props.dayClassName,
                        renderDayContents: e.props.renderDayContents,
                        disabledKeyboardNavigation: e.props.disabledKeyboardNavigation,
                        handleOnKeyDown: e.props.handleOnKeyDown,
                        isInputFocused: e.props.isInputFocused,
                        containerRef: e.props.containerRef,
                        inline: e.props.inline,
                        shouldFocusDayInline: e.props.shouldFocusDayInline,
                        monthShowsDuplicateDaysEnd: e.props.monthShowsDuplicateDaysEnd,
                        monthShowsDuplicateDaysStart: e.props.monthShowsDuplicateDaysStart,
                        locale: e.props.locale
                    });
                }));
            }), St(Et(e), "startOfWeek", function() {
                return Qt(e.props.day, e.props.locale, e.props.calendarStartDay);
            }), St(Et(e), "isKeyboardSelected", function() {
                return !e.props.disabledKeyboardNavigation && !Jt(e.startOfWeek(), e.props.selected) && Jt(e.startOfWeek(), e.props.preSelection);
            }), e;
        }
        return bt(r, [
            {
                key: "render",
                value: function() {
                    var e = {
                        "react-datepicker__week": !0,
                        "react-datepicker__week--selected": Jt(this.startOfWeek(), this.props.selected),
                        "react-datepicker__week--keyboard-selected": this.isKeyboardSelected()
                    };
                    return de.default.createElement("div", {
                        className: ue.default(e)
                    }, this.renderDays());
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        shouldCloseOnSelect: !0
                    };
                }
            }
        ]), r;
    }(de.default.Component), Br = "two_columns", Qr = "three_columns", Hr = "four_columns", jr = St(St(St({}, Br, {
        grid: [
            [
                0,
                1
            ],
            [
                2,
                3
            ],
            [
                4,
                5
            ],
            [
                6,
                7
            ],
            [
                8,
                9
            ],
            [
                10,
                11
            ]
        ],
        verticalNavigationOffset: 2
    }), Qr, {
        grid: [
            [
                0,
                1,
                2
            ],
            [
                3,
                4,
                5
            ],
            [
                6,
                7,
                8
            ],
            [
                9,
                10,
                11
            ]
        ],
        verticalNavigationOffset: 3
    }), Hr, {
        grid: [
            [
                0,
                1,
                2,
                3
            ],
            [
                4,
                5,
                6,
                7
            ],
            [
                8,
                9,
                10,
                11
            ]
        ],
        verticalNavigationOffset: 4
    });
    function Vr(e, t) {
        return e ? Hr : t ? Br : Qr;
    }
    var Ur = function(e) {
        _t(r, e);
        var t = Nt(r);
        function r() {
            var e;
            kt(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return St(Et(e = t.call.apply(t, [
                this
            ].concat(n))), "MONTH_REFS", xt(Array(12)).map(function() {
                return de.default.createRef();
            })), St(Et(e), "QUARTER_REFS", xt(Array(4)).map(function() {
                return de.default.createRef();
            })), St(Et(e), "isDisabled", function(t) {
                return nr(t, e.props);
            }), St(Et(e), "isExcluded", function(t) {
                return or(t, e.props);
            }), St(Et(e), "handleDayClick", function(t, r) {
                e.props.onDayClick && e.props.onDayClick(t, r, e.props.orderInDisplay);
            }), St(Et(e), "handleDayMouseEnter", function(t) {
                e.props.onDayMouseEnter && e.props.onDayMouseEnter(t);
            }), St(Et(e), "handleMouseLeave", function() {
                e.props.onMouseLeave && e.props.onMouseLeave();
            }), St(Et(e), "isRangeStartMonth", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate;
                return !(!n || !o) && $t(Ke.default(a, t), n);
            }), St(Et(e), "isRangeStartQuarter", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate;
                return !(!n || !o) && Gt(Be.default(a, t), n);
            }), St(Et(e), "isRangeEndMonth", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate;
                return !(!n || !o) && $t(Ke.default(a, t), o);
            }), St(Et(e), "isRangeEndQuarter", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate;
                return !(!n || !o) && Gt(Be.default(a, t), o);
            }), St(Et(e), "isInSelectingRangeMonth", function(t) {
                var r, a = e.props, n = a.day, o = a.selectsStart, s = a.selectsEnd, i = a.selectsRange, p = a.startDate, l = a.endDate, c = null !== (r = e.props.selectingDate) && void 0 !== r ? r : e.props.preSelection;
                return !(!(o || s || i) || !c) && (o && l ? ir(c, l, t, n) : (s && p || !(!i || !p || l)) && ir(p, c, t, n));
            }), St(Et(e), "isSelectingMonthRangeStart", function(t) {
                var r;
                if (!e.isInSelectingRangeMonth(t)) return !1;
                var a = e.props, n = a.day, o = a.startDate, s = a.selectsStart, i = Ke.default(n, t), p = null !== (r = e.props.selectingDate) && void 0 !== r ? r : e.props.preSelection;
                return $t(i, s ? p : o);
            }), St(Et(e), "isSelectingMonthRangeEnd", function(t) {
                var r;
                if (!e.isInSelectingRangeMonth(t)) return !1;
                var a = e.props, n = a.day, o = a.endDate, s = a.selectsEnd, i = a.selectsRange, p = Ke.default(n, t), l = null !== (r = e.props.selectingDate) && void 0 !== r ? r : e.props.preSelection;
                return $t(p, s || i ? l : o);
            }), St(Et(e), "isInSelectingRangeQuarter", function(t) {
                var r, a = e.props, n = a.day, o = a.selectsStart, s = a.selectsEnd, i = a.selectsRange, p = a.startDate, l = a.endDate, c = null !== (r = e.props.selectingDate) && void 0 !== r ? r : e.props.preSelection;
                return !(!(o || s || i) || !c) && (o && l ? dr(c, l, t, n) : (s && p || !(!i || !p || l)) && dr(p, c, t, n));
            }), St(Et(e), "isWeekInMonth", function(t) {
                var r = e.props.day, a = De.default(t, 6);
                return $t(t, r) || $t(a, r);
            }), St(Et(e), "isCurrentMonth", function(e, t) {
                return Le.default(e) === Le.default(At()) && t === Te.default(At());
            }), St(Et(e), "isCurrentQuarter", function(e, t) {
                return Le.default(e) === Le.default(At()) && t === Re.default(At());
            }), St(Et(e), "isSelectedMonth", function(e, t, r) {
                return Te.default(r) === t && Le.default(e) === Le.default(r);
            }), St(Et(e), "isSelectedQuarter", function(e, t, r) {
                return Re.default(e) === t && Le.default(e) === Le.default(r);
            }), St(Et(e), "renderWeeks", function() {
                for(var t = [], r = e.props.fixedHeight, a = 0, n = !1, o = Qt(Ht(e.props.day), e.props.locale, e.props.calendarStartDay); t.push(de.default.createElement(Kr, {
                    ariaLabelPrefix: e.props.weekAriaLabelPrefix,
                    chooseDayAriaLabelPrefix: e.props.chooseDayAriaLabelPrefix,
                    disabledDayAriaLabelPrefix: e.props.disabledDayAriaLabelPrefix,
                    key: a,
                    day: o,
                    month: Te.default(e.props.day),
                    onDayClick: e.handleDayClick,
                    onDayMouseEnter: e.handleDayMouseEnter,
                    onWeekSelect: e.props.onWeekSelect,
                    formatWeekNumber: e.props.formatWeekNumber,
                    locale: e.props.locale,
                    minDate: e.props.minDate,
                    maxDate: e.props.maxDate,
                    excludeDates: e.props.excludeDates,
                    excludeDateIntervals: e.props.excludeDateIntervals,
                    includeDates: e.props.includeDates,
                    includeDateIntervals: e.props.includeDateIntervals,
                    inline: e.props.inline,
                    shouldFocusDayInline: e.props.shouldFocusDayInline,
                    highlightDates: e.props.highlightDates,
                    holidays: e.props.holidays,
                    selectingDate: e.props.selectingDate,
                    filterDate: e.props.filterDate,
                    preSelection: e.props.preSelection,
                    selected: e.props.selected,
                    selectsStart: e.props.selectsStart,
                    selectsEnd: e.props.selectsEnd,
                    selectsRange: e.props.selectsRange,
                    selectsDisabledDaysInRange: e.props.selectsDisabledDaysInRange,
                    showWeekNumber: e.props.showWeekNumbers,
                    showWeekPicker: e.props.showWeekPicker,
                    startDate: e.props.startDate,
                    endDate: e.props.endDate,
                    dayClassName: e.props.dayClassName,
                    setOpen: e.props.setOpen,
                    shouldCloseOnSelect: e.props.shouldCloseOnSelect,
                    disabledKeyboardNavigation: e.props.disabledKeyboardNavigation,
                    renderDayContents: e.props.renderDayContents,
                    handleOnKeyDown: e.props.handleOnKeyDown,
                    isInputFocused: e.props.isInputFocused,
                    containerRef: e.props.containerRef,
                    calendarStartDay: e.props.calendarStartDay,
                    monthShowsDuplicateDaysEnd: e.props.monthShowsDuplicateDaysEnd,
                    monthShowsDuplicateDaysStart: e.props.monthShowsDuplicateDaysStart
                })), !n;){
                    a++, o = ge.default(o, 1);
                    var s = r && a >= 6, i = !r && !e.isWeekInMonth(o);
                    if (s || i) {
                        if (!e.props.peekNextMonth) break;
                        n = !0;
                    }
                }
                return t;
            }), St(Et(e), "onMonthClick", function(t, r) {
                e.handleDayClick(Ht(Ke.default(e.props.day, r)), t);
            }), St(Et(e), "onMonthMouseEnter", function(t) {
                e.handleDayMouseEnter(Ht(Ke.default(e.props.day, t)));
            }), St(Et(e), "handleMonthNavigation", function(t, r) {
                e.isDisabled(r) || e.isExcluded(r) || (e.props.setPreSelection(r), e.MONTH_REFS[t].current && e.MONTH_REFS[t].current.focus());
            }), St(Et(e), "onMonthKeyDown", function(t, r) {
                var a = e.props, n = a.selected, o = a.preSelection, s = a.disabledKeyboardNavigation, i = a.showTwoColumnMonthYearPicker, p = a.showFourColumnMonthYearPicker, l = a.setPreSelection, c = t.key;
                if ("Tab" !== c && t.preventDefault(), !s) {
                    var d = Vr(p, i), u = jr[d].verticalNavigationOffset, f = jr[d].grid;
                    switch(c){
                        case "Enter":
                            e.onMonthClick(t, r), l(n);
                            break;
                        case "ArrowRight":
                            e.handleMonthNavigation(11 === r ? 0 : r + 1, ke.default(o, 1));
                            break;
                        case "ArrowLeft":
                            e.handleMonthNavigation(0 === r ? 11 : r - 1, _e.default(o, 1));
                            break;
                        case "ArrowUp":
                            e.handleMonthNavigation(f[0].includes(r) ? r + 12 - u : r - u, _e.default(o, u));
                            break;
                        case "ArrowDown":
                            e.handleMonthNavigation(f[f.length - 1].includes(r) ? r - 12 + u : r + u, ke.default(o, u));
                    }
                }
            }), St(Et(e), "onQuarterClick", function(t, r) {
                e.handleDayClick(Vt(Be.default(e.props.day, r)), t);
            }), St(Et(e), "onQuarterMouseEnter", function(t) {
                e.handleDayMouseEnter(Vt(Be.default(e.props.day, t)));
            }), St(Et(e), "handleQuarterNavigation", function(t, r) {
                e.isDisabled(r) || e.isExcluded(r) || (e.props.setPreSelection(r), e.QUARTER_REFS[t - 1].current && e.QUARTER_REFS[t - 1].current.focus());
            }), St(Et(e), "onQuarterKeyDown", function(t, r) {
                var a = t.key;
                if (!e.props.disabledKeyboardNavigation) switch(a){
                    case "Enter":
                        e.onQuarterClick(t, r), e.props.setPreSelection(e.props.selected);
                        break;
                    case "ArrowRight":
                        e.handleQuarterNavigation(4 === r ? 1 : r + 1, we.default(e.props.preSelection, 1));
                        break;
                    case "ArrowLeft":
                        e.handleQuarterNavigation(1 === r ? 4 : r - 1, Me.default(e.props.preSelection, 1));
                }
            }), St(Et(e), "getMonthClassNames", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate, s = r.selected, i = r.minDate, p = r.maxDate, l = r.preSelection, c = r.monthClassName, d = r.excludeDates, u = r.includeDates, f = c ? c(Ke.default(a, t)) : void 0, h = Ke.default(a, t);
                return ue.default("react-datepicker__month-text", "react-datepicker__month-".concat(t), f, {
                    "react-datepicker__month-text--disabled": (i || p || d || u) && sr(h, e.props),
                    "react-datepicker__month-text--selected": e.isSelectedMonth(a, t, s),
                    "react-datepicker__month-text--keyboard-selected": !e.props.disabledKeyboardNavigation && Te.default(l) === t,
                    "react-datepicker__month-text--in-selecting-range": e.isInSelectingRangeMonth(t),
                    "react-datepicker__month-text--in-range": ir(n, o, t, a),
                    "react-datepicker__month-text--range-start": e.isRangeStartMonth(t),
                    "react-datepicker__month-text--range-end": e.isRangeEndMonth(t),
                    "react-datepicker__month-text--selecting-range-start": e.isSelectingMonthRangeStart(t),
                    "react-datepicker__month-text--selecting-range-end": e.isSelectingMonthRangeEnd(t),
                    "react-datepicker__month-text--today": e.isCurrentMonth(a, t)
                });
            }), St(Et(e), "getTabIndex", function(t) {
                var r = Te.default(e.props.preSelection);
                return e.props.disabledKeyboardNavigation || t !== r ? "-1" : "0";
            }), St(Et(e), "getQuarterTabIndex", function(t) {
                var r = Re.default(e.props.preSelection);
                return e.props.disabledKeyboardNavigation || t !== r ? "-1" : "0";
            }), St(Et(e), "getAriaLabel", function(t) {
                var r = e.props, a = r.chooseDayAriaLabelPrefix, n = void 0 === a ? "Choose" : a, o = r.disabledDayAriaLabelPrefix, s = void 0 === o ? "Not available" : o, i = r.day, p = Ke.default(i, t), l = e.isDisabled(p) || e.isExcluded(p) ? s : n;
                return "".concat(l, " ").concat(qt(p, "MMMM yyyy"));
            }), St(Et(e), "getQuarterClassNames", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate, s = r.selected, i = r.minDate, p = r.maxDate, l = r.preSelection, c = r.disabledKeyboardNavigation;
                return ue.default("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(t), {
                    "react-datepicker__quarter-text--disabled": (i || p) && pr(Be.default(a, t), e.props),
                    "react-datepicker__quarter-text--selected": e.isSelectedQuarter(a, t, s),
                    "react-datepicker__quarter-text--keyboard-selected": !c && Re.default(l) === t,
                    "react-datepicker__quarter-text--in-selecting-range": e.isInSelectingRangeQuarter(t),
                    "react-datepicker__quarter-text--in-range": dr(n, o, t, a),
                    "react-datepicker__quarter-text--range-start": e.isRangeStartQuarter(t),
                    "react-datepicker__quarter-text--range-end": e.isRangeEndQuarter(t)
                });
            }), St(Et(e), "getMonthContent", function(t) {
                var r = e.props, a = r.showFullMonthYearPicker, n = r.renderMonthContent, o = r.locale, s = r.day, i = ar(t, o), p = rr(t, o);
                return n ? n(t, i, p, s) : a ? p : i;
            }), St(Et(e), "getQuarterContent", function(t) {
                var r = e.props, a = r.renderQuarterContent, n = function(e, t) {
                    return qt(Be.default(At(), e), "QQQ", t);
                }(t, r.locale);
                return a ? a(t, n) : n;
            }), St(Et(e), "renderMonths", function() {
                var t = e.props, r = t.showTwoColumnMonthYearPicker, a = t.showFourColumnMonthYearPicker, n = t.day, o = t.selected;
                return jr[Vr(a, r)].grid.map(function(t, r) {
                    return de.default.createElement("div", {
                        className: "react-datepicker__month-wrapper",
                        key: r
                    }, t.map(function(t, r) {
                        return de.default.createElement("div", {
                            ref: e.MONTH_REFS[t],
                            key: r,
                            onClick: function(r) {
                                e.onMonthClick(r, t);
                            },
                            onKeyDown: function(r) {
                                e.onMonthKeyDown(r, t);
                            },
                            onMouseEnter: function() {
                                return e.onMonthMouseEnter(t);
                            },
                            tabIndex: e.getTabIndex(t),
                            className: e.getMonthClassNames(t),
                            role: "option",
                            "aria-label": e.getAriaLabel(t),
                            "aria-current": e.isCurrentMonth(n, t) ? "date" : void 0,
                            "aria-selected": e.isSelectedMonth(n, t, o)
                        }, e.getMonthContent(t));
                    }));
                });
            }), St(Et(e), "renderQuarters", function() {
                var t = e.props, r = t.day, a = t.selected;
                return de.default.createElement("div", {
                    className: "react-datepicker__quarter-wrapper"
                }, [
                    1,
                    2,
                    3,
                    4
                ].map(function(t, n) {
                    return de.default.createElement("div", {
                        key: n,
                        ref: e.QUARTER_REFS[n],
                        role: "option",
                        onClick: function(r) {
                            e.onQuarterClick(r, t);
                        },
                        onKeyDown: function(r) {
                            e.onQuarterKeyDown(r, t);
                        },
                        onMouseEnter: function() {
                            return e.onQuarterMouseEnter(t);
                        },
                        className: e.getQuarterClassNames(t),
                        "aria-selected": e.isSelectedQuarter(r, t, a),
                        tabIndex: e.getQuarterTabIndex(t),
                        "aria-current": e.isCurrentQuarter(r, t) ? "date" : void 0
                    }, e.getQuarterContent(t));
                }));
            }), St(Et(e), "getClassNames", function() {
                var t = e.props, r = t.selectingDate, a = t.selectsStart, n = t.selectsEnd, o = t.showMonthYearPicker, s = t.showQuarterYearPicker, i = t.showWeekPicker;
                return ue.default("react-datepicker__month", {
                    "react-datepicker__month--selecting-range": r && (a || n)
                }, {
                    "react-datepicker__monthPicker": o
                }, {
                    "react-datepicker__quarterPicker": s
                }, {
                    "react-datepicker__weekPicker": i
                });
            }), e;
        }
        return bt(r, [
            {
                key: "render",
                value: function() {
                    var e = this.props, t = e.showMonthYearPicker, r = e.showQuarterYearPicker, a = e.day, n = e.ariaLabelPrefix, o = void 0 === n ? "month " : n;
                    return de.default.createElement("div", {
                        className: this.getClassNames(),
                        onMouseLeave: this.handleMouseLeave,
                        "aria-label": "".concat(o, " ").concat(qt(a, "yyyy-MM")),
                        role: "listbox"
                    }, t ? this.renderMonths() : r ? this.renderQuarters() : this.renderWeeks());
                }
            }
        ]), r;
    }(de.default.Component), zr = function(e) {
        _t(r, e);
        var t = Nt(r);
        function r() {
            var e;
            kt(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return St(Et(e = t.call.apply(t, [
                this
            ].concat(n))), "state", {
                height: null
            }), St(Et(e), "scrollToTheSelectedTime", function() {
                requestAnimationFrame(function() {
                    e.list && (e.list.scrollTop = e.centerLi && r.calcCenterPosition(e.props.monthRef ? e.props.monthRef.clientHeight - e.header.clientHeight : e.list.clientHeight, e.centerLi));
                });
            }), St(Et(e), "handleClick", function(t) {
                (e.props.minTime || e.props.maxTime) && mr(t, e.props) || (e.props.excludeTimes || e.props.includeTimes || e.props.filterTime) && hr(t, e.props) || e.props.onChange(t);
            }), St(Et(e), "isSelectedTime", function(t) {
                var r, a;
                return e.props.selected && (r = e.props.selected, a = t, Pr(r).getTime() === Pr(a).getTime());
            }), St(Et(e), "isDisabledTime", function(t) {
                return (e.props.minTime || e.props.maxTime) && mr(t, e.props) || (e.props.excludeTimes || e.props.includeTimes || e.props.filterTime) && hr(t, e.props);
            }), St(Et(e), "liClasses", function(t) {
                var r = [
                    "react-datepicker__time-list-item",
                    e.props.timeClassName ? e.props.timeClassName(t) : void 0
                ];
                return e.isSelectedTime(t) && r.push("react-datepicker__time-list-item--selected"), e.isDisabledTime(t) && r.push("react-datepicker__time-list-item--disabled"), e.props.injectTimes && (60 * xe.default(t) + Ne.default(t)) % e.props.intervals != 0 && r.push("react-datepicker__time-list-item--injected"), r.join(" ");
            }), St(Et(e), "handleOnKeyDown", function(t, r) {
                " " === t.key && (t.preventDefault(), t.key = "Enter"), "ArrowUp" !== t.key && "ArrowLeft" !== t.key || !t.target.previousSibling || (t.preventDefault(), t.target.previousSibling.focus()), "ArrowDown" !== t.key && "ArrowRight" !== t.key || !t.target.nextSibling || (t.preventDefault(), t.target.nextSibling.focus()), "Enter" === t.key && e.handleClick(r), e.props.handleOnKeyDown(t);
            }), St(Et(e), "renderTimes", function() {
                for(var t, r = [], a = e.props.format ? e.props.format : "p", n = e.props.intervals, o = e.props.selected || e.props.openToDate || At(), s = (t = o, $e.default(t)), i = e.props.injectTimes && e.props.injectTimes.sort(function(e, t) {
                    return e - t;
                }), p = 60 * function(e) {
                    var t = new Date(e.getFullYear(), e.getMonth(), e.getDate()), r = new Date(e.getFullYear(), e.getMonth(), e.getDate(), 24);
                    return Math.round((+r - +t) / 36e5);
                }(o), l = p / n, c = 0; c < l; c++){
                    var d = ye.default(s, c * n);
                    if (r.push(d), i) {
                        var u = Cr(s, d, c, n, i);
                        r = r.concat(u);
                    }
                }
                var f = r.reduce(function(e, t) {
                    return t.getTime() <= o.getTime() ? t : e;
                }, r[0]);
                return r.map(function(t, r) {
                    return de.default.createElement("li", {
                        key: r,
                        onClick: e.handleClick.bind(Et(e), t),
                        className: e.liClasses(t),
                        ref: function(r) {
                            t === f && (e.centerLi = r);
                        },
                        onKeyDown: function(r) {
                            e.handleOnKeyDown(r, t);
                        },
                        tabIndex: t === f ? 0 : -1,
                        role: "option",
                        "aria-selected": e.isSelectedTime(t) ? "true" : void 0,
                        "aria-disabled": e.isDisabledTime(t) ? "true" : void 0
                    }, qt(t, a, e.props.locale));
                });
            }), e;
        }
        return bt(r, [
            {
                key: "componentDidMount",
                value: function() {
                    this.scrollToTheSelectedTime(), this.props.monthRef && this.header && this.setState({
                        height: this.props.monthRef.clientHeight - this.header.clientHeight
                    });
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this, t = this.state.height;
                    return de.default.createElement("div", {
                        className: "react-datepicker__time-container ".concat(this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "")
                    }, de.default.createElement("div", {
                        className: "react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""),
                        ref: function(t) {
                            e.header = t;
                        }
                    }, de.default.createElement("div", {
                        className: "react-datepicker-time__header"
                    }, this.props.timeCaption)), de.default.createElement("div", {
                        className: "react-datepicker__time"
                    }, de.default.createElement("div", {
                        className: "react-datepicker__time-box"
                    }, de.default.createElement("ul", {
                        className: "react-datepicker__time-list",
                        ref: function(t) {
                            e.list = t;
                        },
                        style: t ? {
                            height: t
                        } : {},
                        role: "listbox",
                        "aria-label": this.props.timeCaption
                    }, this.renderTimes()))));
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        intervals: 30,
                        onTimeChange: function() {},
                        todayButton: null,
                        timeCaption: "Time"
                    };
                }
            }
        ]), r;
    }(de.default.Component);
    St(zr, "calcCenterPosition", function(e, t) {
        return t.offsetTop - (e / 2 - t.clientHeight / 2);
    });
    var $r = function(e) {
        _t(r, e);
        var t = Nt(r);
        function r(e) {
            var a;
            return kt(this, r), St(Et(a = t.call(this, e)), "YEAR_REFS", xt(Array(a.props.yearItemNumber)).map(function() {
                return de.default.createRef();
            })), St(Et(a), "isDisabled", function(e) {
                return nr(e, a.props);
            }), St(Et(a), "isExcluded", function(e) {
                return or(e, a.props);
            }), St(Et(a), "selectingDate", function() {
                var e;
                return null !== (e = a.props.selectingDate) && void 0 !== e ? e : a.props.preSelection;
            }), St(Et(a), "updateFocusOnPaginate", function(e) {
                var t = (function() {
                    this.YEAR_REFS[e].current.focus();
                }).bind(Et(a));
                window.requestAnimationFrame(t);
            }), St(Et(a), "handleYearClick", function(e, t) {
                a.props.onDayClick && a.props.onDayClick(e, t);
            }), St(Et(a), "handleYearNavigation", function(e, t) {
                var r = a.props, n = r.date, o = r.yearItemNumber, s = Mr(n, o).startPeriod;
                a.isDisabled(t) || a.isExcluded(t) || (a.props.setPreSelection(t), e - s == -1 ? a.updateFocusOnPaginate(o - 1) : e - s === o ? a.updateFocusOnPaginate(0) : a.YEAR_REFS[e - s].current.focus());
            }), St(Et(a), "isSameDay", function(e, t) {
                return Jt(e, t);
            }), St(Et(a), "isCurrentYear", function(e) {
                return e === Le.default(At());
            }), St(Et(a), "isRangeStart", function(e) {
                return a.props.startDate && a.props.endDate && zt(Qe.default(At(), e), a.props.startDate);
            }), St(Et(a), "isRangeEnd", function(e) {
                return a.props.startDate && a.props.endDate && zt(Qe.default(At(), e), a.props.endDate);
            }), St(Et(a), "isInRange", function(e) {
                return lr(e, a.props.startDate, a.props.endDate);
            }), St(Et(a), "isInSelectingRange", function(e) {
                var t = a.props, r = t.selectsStart, n = t.selectsEnd, o = t.selectsRange, s = t.startDate, i = t.endDate;
                return !(!(r || n || o) || !a.selectingDate()) && (r && i ? lr(e, a.selectingDate(), i) : (n && s || !(!o || !s || i)) && lr(e, s, a.selectingDate()));
            }), St(Et(a), "isSelectingRangeStart", function(e) {
                if (!a.isInSelectingRange(e)) return !1;
                var t = a.props, r = t.startDate, n = t.selectsStart, o = Qe.default(At(), e);
                return zt(o, n ? a.selectingDate() : r);
            }), St(Et(a), "isSelectingRangeEnd", function(e) {
                if (!a.isInSelectingRange(e)) return !1;
                var t = a.props, r = t.endDate, n = t.selectsEnd, o = t.selectsRange, s = Qe.default(At(), e);
                return zt(s, n || o ? a.selectingDate() : r);
            }), St(Et(a), "isKeyboardSelected", function(e) {
                var t = jt(Qe.default(a.props.date, e));
                return !a.props.disabledKeyboardNavigation && !a.props.inline && !Jt(t, jt(a.props.selected)) && Jt(t, jt(a.props.preSelection));
            }), St(Et(a), "onYearClick", function(e, t) {
                var r = a.props.date;
                a.handleYearClick(jt(Qe.default(r, t)), e);
            }), St(Et(a), "onYearKeyDown", function(e, t) {
                var r = e.key;
                if (!a.props.disabledKeyboardNavigation) switch(r){
                    case "Enter":
                        a.onYearClick(e, t), a.props.setPreSelection(a.props.selected);
                        break;
                    case "ArrowRight":
                        a.handleYearNavigation(t + 1, be.default(a.props.preSelection, 1));
                        break;
                    case "ArrowLeft":
                        a.handleYearNavigation(t - 1, Pe.default(a.props.preSelection, 1));
                }
            }), St(Et(a), "getYearClassNames", function(e) {
                var t = a.props, r = t.minDate, n = t.maxDate, o = t.selected, s = t.excludeDates, i = t.includeDates, p = t.filterDate;
                return ue.default("react-datepicker__year-text", {
                    "react-datepicker__year-text--selected": e === Le.default(o),
                    "react-datepicker__year-text--disabled": (r || n || s || i || p) && cr(e, a.props),
                    "react-datepicker__year-text--keyboard-selected": a.isKeyboardSelected(e),
                    "react-datepicker__year-text--range-start": a.isRangeStart(e),
                    "react-datepicker__year-text--range-end": a.isRangeEnd(e),
                    "react-datepicker__year-text--in-range": a.isInRange(e),
                    "react-datepicker__year-text--in-selecting-range": a.isInSelectingRange(e),
                    "react-datepicker__year-text--selecting-range-start": a.isSelectingRangeStart(e),
                    "react-datepicker__year-text--selecting-range-end": a.isSelectingRangeEnd(e),
                    "react-datepicker__year-text--today": a.isCurrentYear(e)
                });
            }), St(Et(a), "getYearTabIndex", function(e) {
                return a.props.disabledKeyboardNavigation ? "-1" : e === Le.default(a.props.preSelection) ? "0" : "-1";
            }), St(Et(a), "getYearContainerClassNames", function() {
                var e = a.props, t = e.selectingDate, r = e.selectsStart, n = e.selectsEnd, o = e.selectsRange;
                return ue.default("react-datepicker__year", {
                    "react-datepicker__year--selecting-range": t && (r || n || o)
                });
            }), St(Et(a), "getYearContent", function(e) {
                return a.props.renderYearContent ? a.props.renderYearContent(e) : e;
            }), a;
        }
        return bt(r, [
            {
                key: "render",
                value: function() {
                    for(var e = this, t = [], r = this.props, a = r.date, n = r.yearItemNumber, o = r.onYearMouseEnter, s = r.onYearMouseLeave, i = Mr(a, n), p = i.startPeriod, l = i.endPeriod, c = function(r) {
                        t.push(de.default.createElement("div", {
                            ref: e.YEAR_REFS[r - p],
                            onClick: function(t) {
                                e.onYearClick(t, r);
                            },
                            onKeyDown: function(t) {
                                e.onYearKeyDown(t, r);
                            },
                            tabIndex: e.getYearTabIndex(r),
                            className: e.getYearClassNames(r),
                            onMouseEnter: function(e) {
                                return o(e, r);
                            },
                            onMouseLeave: function(e) {
                                return s(e, r);
                            },
                            key: r,
                            "aria-current": e.isCurrentYear(r) ? "date" : void 0
                        }, e.getYearContent(r)));
                    }, d = p; d <= l; d++)c(d);
                    return de.default.createElement("div", {
                        className: this.getYearContainerClassNames()
                    }, de.default.createElement("div", {
                        className: "react-datepicker__year-wrapper",
                        onMouseLeave: this.props.clearSelectingDate
                    }, t));
                }
            }
        ]), r;
    }(de.default.Component), Gr = function(e) {
        _t(r, e);
        var t = Nt(r);
        function r(e) {
            var a;
            return kt(this, r), St(Et(a = t.call(this, e)), "onTimeChange", function(e) {
                a.setState({
                    time: e
                });
                var t = a.props.date, r = t instanceof Date && !isNaN(t) ? t : new Date;
                r.setHours(e.split(":")[0]), r.setMinutes(e.split(":")[1]), a.props.onChange(r);
            }), St(Et(a), "renderTimeInput", function() {
                var e = a.state.time, t = a.props, r = t.date, n = t.timeString, o = t.customTimeInput;
                return o ? de.default.cloneElement(o, {
                    date: r,
                    value: e,
                    onChange: a.onTimeChange
                }) : de.default.createElement("input", {
                    type: "time",
                    className: "react-datepicker-time__input",
                    placeholder: "Time",
                    name: "time-input",
                    required: !0,
                    value: e,
                    onChange: function(e) {
                        a.onTimeChange(e.target.value || n);
                    }
                });
            }), a.state = {
                time: a.props.timeString
            }, a;
        }
        return bt(r, [
            {
                key: "render",
                value: function() {
                    return de.default.createElement("div", {
                        className: "react-datepicker__input-time-container"
                    }, de.default.createElement("div", {
                        className: "react-datepicker-time__caption"
                    }, this.props.timeInputLabel), de.default.createElement("div", {
                        className: "react-datepicker-time__input-container"
                    }, de.default.createElement("div", {
                        className: "react-datepicker-time__input"
                    }, this.renderTimeInput())));
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function(e, t) {
                    return e.timeString !== t.time ? {
                        time: e.timeString
                    } : null;
                }
            }
        ]), r;
    }(de.default.Component);
    function Jr(e) {
        var t = e.className, r = e.children, a = e.showPopperArrow, n = e.arrowProps, o = void 0 === n ? {} : n;
        return de.default.createElement("div", {
            className: t
        }, a && de.default.createElement("div", Ct({
            className: "react-datepicker__triangle"
        }, o)), r);
    }
    var Xr = [
        "react-datepicker__year-select",
        "react-datepicker__month-select",
        "react-datepicker__month-year-select"
    ], Zr = function(e) {
        _t(r, e);
        var t = Nt(r);
        function r(e) {
            var a;
            return kt(this, r), St(Et(a = t.call(this, e)), "handleClickOutside", function(e) {
                a.props.onClickOutside(e);
            }), St(Et(a), "setClickOutsideRef", function() {
                return a.containerRef.current;
            }), St(Et(a), "handleDropdownFocus", function(e) {
                (function() {
                    var e = ((arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).className || "").split(/\s+/);
                    return Xr.some(function(t) {
                        return e.indexOf(t) >= 0;
                    });
                })(e.target) && a.props.onDropdownFocus();
            }), St(Et(a), "getDateInView", function() {
                var e = a.props, t = e.preSelection, r = e.selected, n = e.openToDate, o = kr(a.props), s = wr(a.props), i = At(), p = n || r || t;
                return p || (o && lt.default(i, o) ? o : s && pt.default(i, s) ? s : i);
            }), St(Et(a), "increaseMonth", function() {
                a.setState(function(e) {
                    var t = e.date;
                    return {
                        date: ke.default(t, 1)
                    };
                }, function() {
                    return a.handleMonthChange(a.state.date);
                });
            }), St(Et(a), "decreaseMonth", function() {
                a.setState(function(e) {
                    var t = e.date;
                    return {
                        date: _e.default(t, 1)
                    };
                }, function() {
                    return a.handleMonthChange(a.state.date);
                });
            }), St(Et(a), "handleDayClick", function(e, t, r) {
                a.props.onSelect(e, t, r), a.props.setPreSelection && a.props.setPreSelection(e);
            }), St(Et(a), "handleDayMouseEnter", function(e) {
                a.setState({
                    selectingDate: e
                }), a.props.onDayMouseEnter && a.props.onDayMouseEnter(e);
            }), St(Et(a), "handleMonthMouseLeave", function() {
                a.setState({
                    selectingDate: null
                }), a.props.onMonthMouseLeave && a.props.onMonthMouseLeave();
            }), St(Et(a), "handleYearMouseEnter", function(e, t) {
                a.setState({
                    selectingDate: Qe.default(At(), t)
                }), a.props.onYearMouseEnter && a.props.onYearMouseEnter(e, t);
            }), St(Et(a), "handleYearMouseLeave", function(e, t) {
                a.props.onYearMouseLeave && a.props.onYearMouseLeave(e, t);
            }), St(Et(a), "handleYearChange", function(e) {
                a.props.onYearChange && (a.props.onYearChange(e), a.setState({
                    isRenderAriaLiveMessage: !0
                })), a.props.adjustDateOnChange && (a.props.onSelect && a.props.onSelect(e), a.props.setOpen && a.props.setOpen(!0)), a.props.setPreSelection && a.props.setPreSelection(e);
            }), St(Et(a), "handleMonthChange", function(e) {
                a.handleCustomMonthChange(e), a.props.adjustDateOnChange && (a.props.onSelect && a.props.onSelect(e), a.props.setOpen && a.props.setOpen(!0)), a.props.setPreSelection && a.props.setPreSelection(e);
            }), St(Et(a), "handleCustomMonthChange", function(e) {
                a.props.onMonthChange && (a.props.onMonthChange(e), a.setState({
                    isRenderAriaLiveMessage: !0
                }));
            }), St(Et(a), "handleMonthYearChange", function(e) {
                a.handleYearChange(e), a.handleMonthChange(e);
            }), St(Et(a), "changeYear", function(e) {
                a.setState(function(t) {
                    var r = t.date;
                    return {
                        date: Qe.default(r, e)
                    };
                }, function() {
                    return a.handleYearChange(a.state.date);
                });
            }), St(Et(a), "changeMonth", function(e) {
                a.setState(function(t) {
                    var r = t.date;
                    return {
                        date: Ke.default(r, e)
                    };
                }, function() {
                    return a.handleMonthChange(a.state.date);
                });
            }), St(Et(a), "changeMonthYear", function(e) {
                a.setState(function(t) {
                    var r = t.date;
                    return {
                        date: Qe.default(Ke.default(r, Te.default(e)), Le.default(e))
                    };
                }, function() {
                    return a.handleMonthYearChange(a.state.date);
                });
            }), St(Et(a), "header", function() {
                var e = Qt(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : a.state.date, a.props.locale, a.props.calendarStartDay), t = [];
                return a.props.showWeekNumbers && t.push(de.default.createElement("div", {
                    key: "W",
                    className: "react-datepicker__day-name"
                }, a.props.weekLabel || "#")), t.concat([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6
                ].map(function(t) {
                    var r = De.default(e, t), n = a.formatWeekday(r, a.props.locale), o = a.props.weekDayClassName ? a.props.weekDayClassName(r) : void 0;
                    return de.default.createElement("div", {
                        key: t,
                        className: ue.default("react-datepicker__day-name", o)
                    }, n);
                }));
            }), St(Et(a), "formatWeekday", function(e, t) {
                return a.props.formatWeekDay ? function(e, t, r) {
                    return t(qt(e, "EEEE", r));
                }(e, a.props.formatWeekDay, t) : a.props.useWeekdaysShort ? function(e, t) {
                    return qt(e, "EEE", t);
                }(e, t) : function(e, t) {
                    return qt(e, "EEEEEE", t);
                }(e, t);
            }), St(Et(a), "decreaseYear", function() {
                a.setState(function(e) {
                    var t = e.date;
                    return {
                        date: Pe.default(t, a.props.showYearPicker ? a.props.yearItemNumber : 1)
                    };
                }, function() {
                    return a.handleYearChange(a.state.date);
                });
            }), St(Et(a), "clearSelectingDate", function() {
                a.setState({
                    selectingDate: null
                });
            }), St(Et(a), "renderPreviousButton", function() {
                if (!a.props.renderCustomHeader) {
                    var e;
                    switch(!0){
                        case a.props.showMonthYearPicker:
                            e = Dr(a.state.date, a.props);
                            break;
                        case a.props.showYearPicker:
                            e = function(e) {
                                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.yearItemNumber, n = void 0 === a ? Lt : a, o = Mr(jt(Pe.default(e, n)), n).endPeriod, s = r && Le.default(r);
                                return s && s > o || !1;
                            }(a.state.date, a.props);
                            break;
                        default:
                            e = yr(a.state.date, a.props);
                    }
                    if ((a.props.forceShowMonthNavigation || a.props.showDisabledMonthNavigation || !e) && !a.props.showTimeSelectOnly) {
                        var t = [
                            "react-datepicker__navigation",
                            "react-datepicker__navigation--previous"
                        ], r = a.decreaseMonth;
                        (a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker) && (r = a.decreaseYear), e && a.props.showDisabledMonthNavigation && (t.push("react-datepicker__navigation--previous--disabled"), r = null);
                        var n = a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker, o = a.props, s = o.previousMonthButtonLabel, i = o.previousYearButtonLabel, p = a.props, l = p.previousMonthAriaLabel, c = void 0 === l ? "string" == typeof s ? s : "Previous Month" : l, d = p.previousYearAriaLabel, u = void 0 === d ? "string" == typeof i ? i : "Previous Year" : d;
                        return de.default.createElement("button", {
                            type: "button",
                            className: t.join(" "),
                            onClick: r,
                            onKeyDown: a.props.handleOnKeyDown,
                            "aria-label": n ? u : c
                        }, de.default.createElement("span", {
                            className: [
                                "react-datepicker__navigation-icon",
                                "react-datepicker__navigation-icon--previous"
                            ].join(" ")
                        }, n ? a.props.previousYearButtonLabel : a.props.previousMonthButtonLabel));
                    }
                }
            }), St(Et(a), "increaseYear", function() {
                a.setState(function(e) {
                    var t = e.date;
                    return {
                        date: be.default(t, a.props.showYearPicker ? a.props.yearItemNumber : 1)
                    };
                }, function() {
                    return a.handleYearChange(a.state.date);
                });
            }), St(Et(a), "renderNextButton", function() {
                if (!a.props.renderCustomHeader) {
                    var e;
                    switch(!0){
                        case a.props.showMonthYearPicker:
                            e = gr(a.state.date, a.props);
                            break;
                        case a.props.showYearPicker:
                            e = function(e) {
                                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.maxDate, a = t.yearItemNumber, n = void 0 === a ? Lt : a, o = Mr(be.default(e, n), n).startPeriod, s = r && Le.default(r);
                                return s && s < o || !1;
                            }(a.state.date, a.props);
                            break;
                        default:
                            e = vr(a.state.date, a.props);
                    }
                    if ((a.props.forceShowMonthNavigation || a.props.showDisabledMonthNavigation || !e) && !a.props.showTimeSelectOnly) {
                        var t = [
                            "react-datepicker__navigation",
                            "react-datepicker__navigation--next"
                        ];
                        a.props.showTimeSelect && t.push("react-datepicker__navigation--next--with-time"), a.props.todayButton && t.push("react-datepicker__navigation--next--with-today-button");
                        var r = a.increaseMonth;
                        (a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker) && (r = a.increaseYear), e && a.props.showDisabledMonthNavigation && (t.push("react-datepicker__navigation--next--disabled"), r = null);
                        var n = a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker, o = a.props, s = o.nextMonthButtonLabel, i = o.nextYearButtonLabel, p = a.props, l = p.nextMonthAriaLabel, c = void 0 === l ? "string" == typeof s ? s : "Next Month" : l, d = p.nextYearAriaLabel, u = void 0 === d ? "string" == typeof i ? i : "Next Year" : d;
                        return de.default.createElement("button", {
                            type: "button",
                            className: t.join(" "),
                            onClick: r,
                            onKeyDown: a.props.handleOnKeyDown,
                            "aria-label": n ? u : c
                        }, de.default.createElement("span", {
                            className: [
                                "react-datepicker__navigation-icon",
                                "react-datepicker__navigation-icon--next"
                            ].join(" ")
                        }, n ? a.props.nextYearButtonLabel : a.props.nextMonthButtonLabel));
                    }
                }
            }), St(Et(a), "renderCurrentMonth", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : a.state.date, t = [
                    "react-datepicker__current-month"
                ];
                return a.props.showYearDropdown && t.push("react-datepicker__current-month--hasYearDropdown"), a.props.showMonthDropdown && t.push("react-datepicker__current-month--hasMonthDropdown"), a.props.showMonthYearDropdown && t.push("react-datepicker__current-month--hasMonthYearDropdown"), de.default.createElement("div", {
                    className: t.join(" ")
                }, qt(e, a.props.dateFormat, a.props.locale));
            }), St(Et(a), "renderYearDropdown", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (a.props.showYearDropdown && !e) return de.default.createElement(Yr, {
                    adjustDateOnChange: a.props.adjustDateOnChange,
                    date: a.state.date,
                    onSelect: a.props.onSelect,
                    setOpen: a.props.setOpen,
                    dropdownMode: a.props.dropdownMode,
                    onChange: a.changeYear,
                    minDate: a.props.minDate,
                    maxDate: a.props.maxDate,
                    year: Le.default(a.state.date),
                    scrollableYearDropdown: a.props.scrollableYearDropdown,
                    yearDropdownItemNumber: a.props.yearDropdownItemNumber
                });
            }), St(Et(a), "renderMonthDropdown", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (a.props.showMonthDropdown && !e) return de.default.createElement(Tr, {
                    dropdownMode: a.props.dropdownMode,
                    locale: a.props.locale,
                    onChange: a.changeMonth,
                    month: Te.default(a.state.date),
                    useShortMonthInDropdown: a.props.useShortMonthInDropdown
                });
            }), St(Et(a), "renderMonthYearDropdown", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (a.props.showMonthYearDropdown && !e) return de.default.createElement(Ar, {
                    dropdownMode: a.props.dropdownMode,
                    locale: a.props.locale,
                    dateFormat: a.props.dateFormat,
                    onChange: a.changeMonthYear,
                    minDate: a.props.minDate,
                    maxDate: a.props.maxDate,
                    date: a.state.date,
                    scrollableMonthYearDropdown: a.props.scrollableMonthYearDropdown
                });
            }), St(Et(a), "handleTodayButtonClick", function(e) {
                a.props.onSelect(Ut(), e), a.props.setPreSelection && a.props.setPreSelection(Ut());
            }), St(Et(a), "renderTodayButton", function() {
                if (a.props.todayButton && !a.props.showTimeSelectOnly) return de.default.createElement("div", {
                    className: "react-datepicker__today-button",
                    onClick: function(e) {
                        return a.handleTodayButtonClick(e);
                    }
                }, a.props.todayButton);
            }), St(Et(a), "renderDefaultHeader", function(e) {
                var t = e.monthDate, r = e.i;
                return de.default.createElement("div", {
                    className: "react-datepicker__header ".concat(a.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "")
                }, a.renderCurrentMonth(t), de.default.createElement("div", {
                    className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(a.props.dropdownMode),
                    onFocus: a.handleDropdownFocus
                }, a.renderMonthDropdown(0 !== r), a.renderMonthYearDropdown(0 !== r), a.renderYearDropdown(0 !== r)), de.default.createElement("div", {
                    className: "react-datepicker__day-names"
                }, a.header(t)));
            }), St(Et(a), "renderCustomHeader", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = e.monthDate, r = e.i;
                if (a.props.showTimeSelect && !a.state.monthContainer || a.props.showTimeSelectOnly) return null;
                var n = yr(a.state.date, a.props), o = vr(a.state.date, a.props), s = Dr(a.state.date, a.props), i = gr(a.state.date, a.props), p = !a.props.showMonthYearPicker && !a.props.showQuarterYearPicker && !a.props.showYearPicker;
                return de.default.createElement("div", {
                    className: "react-datepicker__header react-datepicker__header--custom",
                    onFocus: a.props.onDropdownFocus
                }, a.props.renderCustomHeader(Dt(Dt({}, a.state), {}, {
                    customHeaderCount: r,
                    monthDate: t,
                    changeMonth: a.changeMonth,
                    changeYear: a.changeYear,
                    decreaseMonth: a.decreaseMonth,
                    increaseMonth: a.increaseMonth,
                    decreaseYear: a.decreaseYear,
                    increaseYear: a.increaseYear,
                    prevMonthButtonDisabled: n,
                    nextMonthButtonDisabled: o,
                    prevYearButtonDisabled: s,
                    nextYearButtonDisabled: i
                })), p && de.default.createElement("div", {
                    className: "react-datepicker__day-names"
                }, a.header(t)));
            }), St(Et(a), "renderYearHeader", function() {
                var e = a.state.date, t = a.props, r = t.showYearPicker, n = Mr(e, t.yearItemNumber), o = n.startPeriod, s = n.endPeriod;
                return de.default.createElement("div", {
                    className: "react-datepicker__header react-datepicker-year-header"
                }, r ? "".concat(o, " - ").concat(s) : Le.default(e));
            }), St(Et(a), "renderHeader", function(e) {
                switch(!0){
                    case void 0 !== a.props.renderCustomHeader:
                        return a.renderCustomHeader(e);
                    case a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker:
                        return a.renderYearHeader(e);
                    default:
                        return a.renderDefaultHeader(e);
                }
            }), St(Et(a), "renderMonths", function() {
                var e;
                if (!a.props.showTimeSelectOnly && !a.props.showYearPicker) {
                    for(var t = [], r = a.props.showPreviousMonths ? a.props.monthsShown - 1 : 0, n = _e.default(a.state.date, r), o = null !== (e = a.props.monthSelectedIn) && void 0 !== e ? e : r, s = 0; s < a.props.monthsShown; ++s){
                        var i = s - o + r, p = ke.default(n, i), l = "month-".concat(s), c = s < a.props.monthsShown - 1, d = s > 0;
                        t.push(de.default.createElement("div", {
                            key: l,
                            ref: function(e) {
                                a.monthContainer = e;
                            },
                            className: "react-datepicker__month-container"
                        }, a.renderHeader({
                            monthDate: p,
                            i: s
                        }), de.default.createElement(Ur, {
                            chooseDayAriaLabelPrefix: a.props.chooseDayAriaLabelPrefix,
                            disabledDayAriaLabelPrefix: a.props.disabledDayAriaLabelPrefix,
                            weekAriaLabelPrefix: a.props.weekAriaLabelPrefix,
                            ariaLabelPrefix: a.props.monthAriaLabelPrefix,
                            onChange: a.changeMonthYear,
                            day: p,
                            dayClassName: a.props.dayClassName,
                            calendarStartDay: a.props.calendarStartDay,
                            monthClassName: a.props.monthClassName,
                            onDayClick: a.handleDayClick,
                            handleOnKeyDown: a.props.handleOnDayKeyDown,
                            onDayMouseEnter: a.handleDayMouseEnter,
                            onMouseLeave: a.handleMonthMouseLeave,
                            onWeekSelect: a.props.onWeekSelect,
                            orderInDisplay: s,
                            formatWeekNumber: a.props.formatWeekNumber,
                            locale: a.props.locale,
                            minDate: a.props.minDate,
                            maxDate: a.props.maxDate,
                            excludeDates: a.props.excludeDates,
                            excludeDateIntervals: a.props.excludeDateIntervals,
                            highlightDates: a.props.highlightDates,
                            holidays: a.props.holidays,
                            selectingDate: a.state.selectingDate,
                            includeDates: a.props.includeDates,
                            includeDateIntervals: a.props.includeDateIntervals,
                            inline: a.props.inline,
                            shouldFocusDayInline: a.props.shouldFocusDayInline,
                            fixedHeight: a.props.fixedHeight,
                            filterDate: a.props.filterDate,
                            preSelection: a.props.preSelection,
                            setPreSelection: a.props.setPreSelection,
                            selected: a.props.selected,
                            selectsStart: a.props.selectsStart,
                            selectsEnd: a.props.selectsEnd,
                            selectsRange: a.props.selectsRange,
                            selectsDisabledDaysInRange: a.props.selectsDisabledDaysInRange,
                            showWeekNumbers: a.props.showWeekNumbers,
                            startDate: a.props.startDate,
                            endDate: a.props.endDate,
                            peekNextMonth: a.props.peekNextMonth,
                            setOpen: a.props.setOpen,
                            shouldCloseOnSelect: a.props.shouldCloseOnSelect,
                            renderDayContents: a.props.renderDayContents,
                            renderMonthContent: a.props.renderMonthContent,
                            renderQuarterContent: a.props.renderQuarterContent,
                            renderYearContent: a.props.renderYearContent,
                            disabledKeyboardNavigation: a.props.disabledKeyboardNavigation,
                            showMonthYearPicker: a.props.showMonthYearPicker,
                            showFullMonthYearPicker: a.props.showFullMonthYearPicker,
                            showTwoColumnMonthYearPicker: a.props.showTwoColumnMonthYearPicker,
                            showFourColumnMonthYearPicker: a.props.showFourColumnMonthYearPicker,
                            showYearPicker: a.props.showYearPicker,
                            showQuarterYearPicker: a.props.showQuarterYearPicker,
                            showWeekPicker: a.props.showWeekPicker,
                            isInputFocused: a.props.isInputFocused,
                            containerRef: a.containerRef,
                            monthShowsDuplicateDaysEnd: c,
                            monthShowsDuplicateDaysStart: d
                        })));
                    }
                    return t;
                }
            }), St(Et(a), "renderYears", function() {
                if (!a.props.showTimeSelectOnly) return a.props.showYearPicker ? de.default.createElement("div", {
                    className: "react-datepicker__year--container"
                }, a.renderHeader(), de.default.createElement($r, Ct({
                    onDayClick: a.handleDayClick,
                    selectingDate: a.state.selectingDate,
                    clearSelectingDate: a.clearSelectingDate,
                    date: a.state.date
                }, a.props, {
                    onYearMouseEnter: a.handleYearMouseEnter,
                    onYearMouseLeave: a.handleYearMouseLeave
                }))) : void 0;
            }), St(Et(a), "renderTimeSection", function() {
                if (a.props.showTimeSelect && (a.state.monthContainer || a.props.showTimeSelectOnly)) return de.default.createElement(zr, {
                    selected: a.props.selected,
                    openToDate: a.props.openToDate,
                    onChange: a.props.onTimeChange,
                    timeClassName: a.props.timeClassName,
                    format: a.props.timeFormat,
                    includeTimes: a.props.includeTimes,
                    intervals: a.props.timeIntervals,
                    minTime: a.props.minTime,
                    maxTime: a.props.maxTime,
                    excludeTimes: a.props.excludeTimes,
                    filterTime: a.props.filterTime,
                    timeCaption: a.props.timeCaption,
                    todayButton: a.props.todayButton,
                    showMonthDropdown: a.props.showMonthDropdown,
                    showMonthYearDropdown: a.props.showMonthYearDropdown,
                    showYearDropdown: a.props.showYearDropdown,
                    withPortal: a.props.withPortal,
                    monthRef: a.state.monthContainer,
                    injectTimes: a.props.injectTimes,
                    locale: a.props.locale,
                    handleOnKeyDown: a.props.handleOnKeyDown,
                    showTimeSelectOnly: a.props.showTimeSelectOnly
                });
            }), St(Et(a), "renderInputTimeSection", function() {
                var e = new Date(a.props.selected), t = Wt(e) && Boolean(a.props.selected) ? "".concat(_r(e.getHours()), ":").concat(_r(e.getMinutes())) : "";
                if (a.props.showTimeInput) return de.default.createElement(Gr, {
                    date: e,
                    timeString: t,
                    timeInputLabel: a.props.timeInputLabel,
                    onChange: a.props.onTimeChange,
                    customTimeInput: a.props.customTimeInput
                });
            }), St(Et(a), "renderAriaLiveRegion", function() {
                var e, t = Mr(a.state.date, a.props.yearItemNumber), r = t.startPeriod, n = t.endPeriod;
                return e = a.props.showYearPicker ? "".concat(r, " - ").concat(n) : a.props.showMonthYearPicker || a.props.showQuarterYearPicker ? Le.default(a.state.date) : "".concat(rr(Te.default(a.state.date), a.props.locale), " ").concat(Le.default(a.state.date)), de.default.createElement("span", {
                    role: "alert",
                    "aria-live": "polite",
                    className: "react-datepicker__aria-live"
                }, a.state.isRenderAriaLiveMessage && e);
            }), St(Et(a), "renderChildren", function() {
                if (a.props.children) return de.default.createElement("div", {
                    className: "react-datepicker__children-container"
                }, a.props.children);
            }), a.containerRef = de.default.createRef(), a.state = {
                date: a.getDateInView(),
                selectingDate: null,
                monthContainer: null,
                isRenderAriaLiveMessage: !1
            }, a;
        }
        return bt(r, [
            {
                key: "componentDidMount",
                value: function() {
                    var e = this;
                    this.props.showTimeSelect && (this.assignMonthContainer = void e.setState({
                        monthContainer: e.monthContainer
                    }));
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e) {
                    var t = this;
                    if (!this.props.preSelection || Jt(this.props.preSelection, e.preSelection) && this.props.monthSelectedIn === e.monthSelectedIn) this.props.openToDate && !Jt(this.props.openToDate, e.openToDate) && this.setState({
                        date: this.props.openToDate
                    });
                    else {
                        var r = !$t(this.state.date, this.props.preSelection);
                        this.setState({
                            date: this.props.preSelection
                        }, function() {
                            return r && t.handleCustomMonthChange(t.state.date);
                        });
                    }
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.props.container || Jr;
                    return de.default.createElement("div", {
                        style: {
                            display: "contents"
                        },
                        ref: this.containerRef
                    }, de.default.createElement(e, {
                        className: ue.default("react-datepicker", this.props.className, {
                            "react-datepicker--time-only": this.props.showTimeSelectOnly
                        }),
                        showPopperArrow: this.props.showPopperArrow,
                        arrowProps: this.props.arrowProps
                    }, this.renderAriaLiveRegion(), this.renderPreviousButton(), this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.renderChildren()));
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        onDropdownFocus: function() {},
                        monthsShown: 1,
                        forceShowMonthNavigation: !1,
                        timeCaption: "Time",
                        previousYearButtonLabel: "Previous Year",
                        nextYearButtonLabel: "Next Year",
                        previousMonthButtonLabel: "Previous Month",
                        nextMonthButtonLabel: "Next Month",
                        customTimeInput: null,
                        yearItemNumber: Lt
                    };
                }
            }
        ]), r;
    }(de.default.Component), ea = function(e) {
        var t = e.icon, r = e.className, a = void 0 === r ? "" : r, n = e.onClick, o = "react-datepicker__calendar-icon";
        return de.default.isValidElement(t) ? de.default.cloneElement(t, {
            className: "".concat(t.props.className || "", " ").concat(o, " ").concat(a),
            onClick: function(e) {
                "function" == typeof t.props.onClick && t.props.onClick(e), "function" == typeof n && n(e);
            }
        }) : "string" == typeof t ? de.default.createElement("i", {
            className: "".concat(o, " ").concat(t, " ").concat(a),
            "aria-hidden": "true",
            onClick: n
        }) : de.default.createElement("svg", {
            className: "".concat(o, " ").concat(a),
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 448 512",
            onClick: n
        }, de.default.createElement("path", {
            d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z"
        }));
    }, ta = function(e) {
        _t(r, e);
        var t = Nt(r);
        function r(e) {
            var a;
            return kt(this, r), (a = t.call(this, e)).el = document.createElement("div"), a;
        }
        return bt(r, [
            {
                key: "componentDidMount",
                value: function() {
                    this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId), this.portalRoot || (this.portalRoot = document.createElement("div"), this.portalRoot.setAttribute("id", this.props.portalId), (this.props.portalHost || document.body).appendChild(this.portalRoot)), this.portalRoot.appendChild(this.el);
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    this.portalRoot.removeChild(this.el);
                }
            },
            {
                key: "render",
                value: function() {
                    return mt.default.createPortal(this.props.children, this.el);
                }
            }
        ]), r;
    }(de.default.Component), ra = function(e) {
        return !e.disabled && -1 !== e.tabIndex;
    }, aa = function(e) {
        _t(r, e);
        var t = Nt(r);
        function r(e) {
            var a;
            return kt(this, r), St(Et(a = t.call(this, e)), "getTabChildren", function() {
                return Array.prototype.slice.call(a.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"), 1, -1).filter(ra);
            }), St(Et(a), "handleFocusStart", function() {
                var e = a.getTabChildren();
                e && e.length > 1 && e[e.length - 1].focus();
            }), St(Et(a), "handleFocusEnd", function() {
                var e = a.getTabChildren();
                e && e.length > 1 && e[0].focus();
            }), a.tabLoopRef = de.default.createRef(), a;
        }
        return bt(r, [
            {
                key: "render",
                value: function() {
                    return this.props.enableTabLoop ? de.default.createElement("div", {
                        className: "react-datepicker__tab-loop",
                        ref: this.tabLoopRef
                    }, de.default.createElement("div", {
                        className: "react-datepicker__tab-loop__start",
                        tabIndex: "0",
                        onFocus: this.handleFocusStart
                    }), this.props.children, de.default.createElement("div", {
                        className: "react-datepicker__tab-loop__end",
                        tabIndex: "0",
                        onFocus: this.handleFocusEnd
                    })) : this.props.children;
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        enableTabLoop: !0
                    };
                }
            }
        ]), r;
    }(de.default.Component), na = function(e) {
        _t(r, e);
        var t = Nt(r);
        function r() {
            return kt(this, r), t.apply(this, arguments);
        }
        return bt(r, [
            {
                key: "render",
                value: function() {
                    var e, t = this.props, r = t.className, a = t.wrapperClassName, n = t.hidePopper, o = t.popperComponent, s = t.popperModifiers, i = t.popperPlacement, p = t.popperProps, l = t.targetComponent, c = t.enableTabLoop, d = t.popperOnKeyDown, u = t.portalId, f = t.portalHost;
                    if (!n) {
                        var h = ue.default("react-datepicker-popper", r);
                        e = de.default.createElement(pe.Popper, Ct({
                            modifiers: s,
                            placement: i
                        }, p), function(e) {
                            var t = e.ref, r = e.style, a = e.placement, n = e.arrowProps;
                            return de.default.createElement(aa, {
                                enableTabLoop: c
                            }, de.default.createElement("div", {
                                ref: t,
                                style: r,
                                className: h,
                                "data-placement": a,
                                onKeyDown: d
                            }, de.default.cloneElement(o, {
                                arrowProps: n
                            })));
                        });
                    }
                    this.props.popperContainer && (e = de.default.createElement(this.props.popperContainer, {}, e)), u && !n && (e = de.default.createElement(ta, {
                        portalId: u,
                        portalHost: f
                    }, e));
                    var m = ue.default("react-datepicker-wrapper", a);
                    return de.default.createElement(pe.Manager, {
                        className: "react-datepicker-manager"
                    }, de.default.createElement(pe.Reference, null, function(e) {
                        var t = e.ref;
                        return de.default.createElement("div", {
                            ref: t,
                            className: m
                        }, l);
                    }), e);
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        hidePopper: !0,
                        popperModifiers: [],
                        popperProps: {},
                        popperPlacement: "bottom-start"
                    };
                }
            }
        ]), r;
    }(de.default.Component), oa = "react-datepicker-ignore-onclickoutside", sa = ht.default(Zr);
    var ia = "Date input not valid.", pa = function(e) {
        _t(r, e);
        var t = Nt(r);
        function r(e) {
            var a;
            return kt(this, r), St(Et(a = t.call(this, e)), "getPreSelection", function() {
                return a.props.openToDate ? a.props.openToDate : a.props.selectsEnd && a.props.startDate ? a.props.startDate : a.props.selectsStart && a.props.endDate ? a.props.endDate : At();
            }), St(Et(a), "modifyHolidays", function() {
                var e;
                return null === (e = a.props.holidays) || void 0 === e ? void 0 : e.reduce(function(e, t) {
                    var r = new Date(t.date);
                    return he.default(r) ? [].concat(xt(e), [
                        Dt(Dt({}, t), {}, {
                            date: r
                        })
                    ]) : e;
                }, []);
            }), St(Et(a), "calcInitialState", function() {
                var e, t = a.getPreSelection(), r = kr(a.props), n = wr(a.props), o = r && lt.default(t, $e.default(r)) ? r : n && pt.default(t, et.default(n)) ? n : t;
                return {
                    open: a.props.startOpen || !1,
                    preventFocus: !1,
                    preSelection: null !== (e = a.props.selectsRange ? a.props.startDate : a.props.selected) && void 0 !== e ? e : o,
                    highlightDates: br(a.props.highlightDates),
                    focused: !1,
                    shouldFocusDayInline: !1,
                    isRenderAriaLiveMessage: !1
                };
            }), St(Et(a), "clearPreventFocusTimeout", function() {
                a.preventFocusTimeout && clearTimeout(a.preventFocusTimeout);
            }), St(Et(a), "setFocus", function() {
                a.input && a.input.focus && a.input.focus({
                    preventScroll: !0
                });
            }), St(Et(a), "setBlur", function() {
                a.input && a.input.blur && a.input.blur(), a.cancelFocusInput();
            }), St(Et(a), "setOpen", function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                a.setState({
                    open: e,
                    preSelection: e && a.state.open ? a.state.preSelection : a.calcInitialState().preSelection,
                    lastPreSelectChange: ca
                }, function() {
                    e || a.setState(function(e) {
                        return {
                            focused: !!t && e.focused
                        };
                    }, function() {
                        !t && a.setBlur(), a.setState({
                            inputValue: null
                        });
                    });
                });
            }), St(Et(a), "inputOk", function() {
                return fe.default(a.state.preSelection);
            }), St(Et(a), "isCalendarOpen", function() {
                return void 0 === a.props.open ? a.state.open && !a.props.disabled && !a.props.readOnly : a.props.open;
            }), St(Et(a), "handleFocus", function(e) {
                a.state.preventFocus || (a.props.onFocus(e), a.props.preventOpenOnFocus || a.props.readOnly || a.setOpen(!0)), a.setState({
                    focused: !0
                });
            }), St(Et(a), "sendFocusBackToInput", function() {
                a.preventFocusTimeout && a.clearPreventFocusTimeout(), a.setState({
                    preventFocus: !0
                }, function() {
                    a.preventFocusTimeout = setTimeout(function() {
                        a.setFocus(), a.setState({
                            preventFocus: !1
                        });
                    });
                });
            }), St(Et(a), "cancelFocusInput", function() {
                clearTimeout(a.inputFocusTimeout), a.inputFocusTimeout = null;
            }), St(Et(a), "deferFocusInput", function() {
                a.cancelFocusInput(), a.inputFocusTimeout = setTimeout(function() {
                    return a.setFocus();
                }, 1);
            }), St(Et(a), "handleDropdownFocus", function() {
                a.cancelFocusInput();
            }), St(Et(a), "handleBlur", function(e) {
                (!a.state.open || a.props.withPortal || a.props.showTimeInput) && a.props.onBlur(e), a.setState({
                    focused: !1
                });
            }), St(Et(a), "handleCalendarClickOutside", function(e) {
                a.props.inline || a.setOpen(!1), a.props.onClickOutside(e), a.props.withPortal && e.preventDefault();
            }), St(Et(a), "handleChange", function() {
                for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                var n = t[0];
                if (!a.props.onChangeRaw || (a.props.onChangeRaw.apply(Et(a), t), "function" == typeof n.isDefaultPrevented && !n.isDefaultPrevented())) {
                    a.setState({
                        inputValue: n.target.value,
                        lastPreSelectChange: la
                    });
                    var o, s, i, p, l, c, d, u, f = (o = n.target.value, s = a.props.dateFormat, i = a.props.locale, p = a.props.strictParsing, l = a.props.minDate, c = null, d = tr(i) || tr(er()), u = !0, Array.isArray(s) ? (s.forEach(function(e) {
                        var t = ut.default(o, e, new Date, {
                            locale: d
                        });
                        p && (u = Wt(t, l) && o === qt(t, e, i)), Wt(t, l) && u && (c = t);
                    }), c) : (c = ut.default(o, s, new Date, {
                        locale: d
                    }), p ? u = Wt(c) && o === qt(c, s, i) : Wt(c) || (s = s.match(Ft).map(function(e) {
                        var t = e[0];
                        return "p" === t || "P" === t ? d ? (0, Rt[t])(e, d.formatLong) : t : e;
                    }).join(""), o.length > 0 && (c = ut.default(o, s.slice(0, o.length), new Date)), Wt(c) || (c = new Date(o))), Wt(c) && u ? c : null));
                    a.props.showTimeSelectOnly && a.props.selected && f && !Jt(f, a.props.selected) && (f = yt.default(a.props.selected, {
                        hours: xe.default(f),
                        minutes: Ne.default(f),
                        seconds: Ee.default(f)
                    })), !f && n.target.value || (a.props.showWeekPicker && (f = Qt(f, a.props.locale, a.props.calendarStartDay)), a.setSelected(f, n, !0));
                }
            }), St(Et(a), "handleSelect", function(e, t, r) {
                if (a.props.shouldCloseOnSelect && !a.props.showTimeSelect && a.sendFocusBackToInput(), a.props.onChangeRaw && a.props.onChangeRaw(t), a.props.showWeekPicker && (e = Qt(e, a.props.locale, a.props.calendarStartDay)), a.setSelected(e, t, !1, r), a.props.showDateSelect && a.setState({
                    isRenderAriaLiveMessage: !0
                }), !a.props.shouldCloseOnSelect || a.props.showTimeSelect) a.setPreSelection(e);
                else if (!a.props.inline) {
                    a.props.selectsRange || a.setOpen(!1);
                    var n = a.props, o = n.startDate, s = n.endDate;
                    !o || s || lt.default(e, o) || a.setOpen(!1);
                }
            }), St(Et(a), "setSelected", function(e, t, r, n) {
                var o = e;
                if (a.props.showYearPicker) {
                    if (null !== o && cr(Le.default(o), a.props)) return;
                } else if (a.props.showMonthYearPicker) {
                    if (null !== o && sr(o, a.props)) return;
                } else if (null !== o && nr(o, a.props)) return;
                var s = a.props, i = s.onChange, p = s.selectsRange, l = s.startDate, c = s.endDate;
                if (!Xt(a.props.selected, o) || a.props.allowSameDay || p) {
                    if (null !== o && (!a.props.selected || r && (a.props.showTimeSelect || a.props.showTimeSelectOnly || a.props.showTimeInput) || (o = Bt(o, {
                        hour: xe.default(a.props.selected),
                        minute: Ne.default(a.props.selected),
                        second: Ee.default(a.props.selected)
                    })), a.props.inline || a.setState({
                        preSelection: o
                    }), a.props.focusSelectedMonth || a.setState({
                        monthSelectedIn: n
                    })), p) {
                        var d = l && !c, u = l && c;
                        !l && !c ? i([
                            o,
                            null
                        ], t) : d && (lt.default(o, l) ? i([
                            o,
                            null
                        ], t) : i([
                            l,
                            o
                        ], t)), u && i([
                            o,
                            null
                        ], t);
                    } else i(o, t);
                }
                r || (a.props.onSelect(o, t), a.setState({
                    inputValue: null
                }));
            }), St(Et(a), "setPreSelection", function(e) {
                var t = void 0 !== a.props.minDate, r = void 0 !== a.props.maxDate, n = !0;
                if (e) {
                    a.props.showWeekPicker && (e = Qt(e, a.props.locale, a.props.calendarStartDay));
                    var o = $e.default(e);
                    if (t && r) n = Zt(e, a.props.minDate, a.props.maxDate);
                    else if (t) {
                        var s = $e.default(a.props.minDate);
                        n = pt.default(e, s) || Xt(o, s);
                    } else if (r) {
                        var i = et.default(a.props.maxDate);
                        n = lt.default(e, i) || Xt(o, i);
                    }
                }
                n && a.setState({
                    preSelection: e
                });
            }), St(Et(a), "toggleCalendar", function() {
                a.setOpen(!a.state.open);
            }), St(Et(a), "handleTimeChange", function(e) {
                var t = a.props.selected ? a.props.selected : a.getPreSelection(), r = a.props.selected ? e : Bt(t, {
                    hour: xe.default(e),
                    minute: Ne.default(e)
                });
                a.setState({
                    preSelection: r
                }), a.props.onChange(r), a.props.shouldCloseOnSelect && (a.sendFocusBackToInput(), a.setOpen(!1)), a.props.showTimeInput && a.setOpen(!0), (a.props.showTimeSelectOnly || a.props.showTimeSelect) && a.setState({
                    isRenderAriaLiveMessage: !0
                }), a.setState({
                    inputValue: null
                });
            }), St(Et(a), "onInputClick", function() {
                a.props.disabled || a.props.readOnly || a.setOpen(!0), a.props.onInputClick();
            }), St(Et(a), "onInputKeyDown", function(e) {
                a.props.onKeyDown(e);
                var t = e.key;
                if (a.state.open || a.props.inline || a.props.preventOpenOnFocus) {
                    if (a.state.open) {
                        if ("ArrowDown" === t || "ArrowUp" === t) {
                            e.preventDefault();
                            var r = a.props.showWeekPicker && a.props.showWeekNumbers ? '.react-datepicker__week-number[tabindex="0"]' : '.react-datepicker__day[tabindex="0"]', n = a.calendar.componentNode && a.calendar.componentNode.querySelector(r);
                            return void (n && n.focus({
                                preventScroll: !0
                            }));
                        }
                        var o = At(a.state.preSelection);
                        "Enter" === t ? (e.preventDefault(), a.inputOk() && a.state.lastPreSelectChange === ca ? (a.handleSelect(o, e), !a.props.shouldCloseOnSelect && a.setPreSelection(o)) : a.setOpen(!1)) : "Escape" === t ? (e.preventDefault(), a.sendFocusBackToInput(), a.setOpen(!1)) : "Tab" === t && a.setOpen(!1), a.inputOk() || a.props.onInputError({
                            code: 1,
                            msg: ia
                        });
                    }
                } else "ArrowDown" !== t && "ArrowUp" !== t && "Enter" !== t || a.onInputClick();
            }), St(Et(a), "onPortalKeyDown", function(e) {
                "Escape" === e.key && (e.preventDefault(), a.setState({
                    preventFocus: !0
                }, function() {
                    a.setOpen(!1), setTimeout(function() {
                        a.setFocus(), a.setState({
                            preventFocus: !1
                        });
                    });
                }));
            }), St(Et(a), "onDayKeyDown", function(e) {
                a.props.onKeyDown(e);
                var t = e.key, r = At(a.state.preSelection);
                if ("Enter" === t) e.preventDefault(), a.handleSelect(r, e), !a.props.shouldCloseOnSelect && a.setPreSelection(r);
                else if ("Escape" === t) e.preventDefault(), a.setOpen(!1), a.inputOk() || a.props.onInputError({
                    code: 1,
                    msg: ia
                });
                else if (!a.props.disabledKeyboardNavigation) {
                    var n;
                    switch(t){
                        case "ArrowLeft":
                            n = a.props.showWeekPicker ? Ce.default(r, 1) : Se.default(r, 1);
                            break;
                        case "ArrowRight":
                            n = a.props.showWeekPicker ? ge.default(r, 1) : De.default(r, 1);
                            break;
                        case "ArrowUp":
                            n = Ce.default(r, 1);
                            break;
                        case "ArrowDown":
                            n = ge.default(r, 1);
                            break;
                        case "PageUp":
                            n = _e.default(r, 1);
                            break;
                        case "PageDown":
                            n = ke.default(r, 1);
                            break;
                        case "Home":
                            n = Pe.default(r, 1);
                            break;
                        case "End":
                            n = be.default(r, 1);
                            break;
                        default:
                            n = null;
                    }
                    if (!n) return void (a.props.onInputError && a.props.onInputError({
                        code: 1,
                        msg: ia
                    }));
                    if (e.preventDefault(), a.setState({
                        lastPreSelectChange: ca
                    }), a.props.adjustDateOnChange && a.setSelected(n), a.setPreSelection(n), a.props.inline) {
                        var o = Te.default(r), s = Te.default(n), i = Le.default(r), p = Le.default(n);
                        o !== s || i !== p ? a.setState({
                            shouldFocusDayInline: !0
                        }) : a.setState({
                            shouldFocusDayInline: !1
                        });
                    }
                }
            }), St(Et(a), "onPopperKeyDown", function(e) {
                "Escape" === e.key && (e.preventDefault(), a.sendFocusBackToInput());
            }), St(Et(a), "onClearClick", function(e) {
                e && e.preventDefault && e.preventDefault(), a.sendFocusBackToInput(), a.props.selectsRange ? a.props.onChange([
                    null,
                    null
                ], e) : a.props.onChange(null, e), a.setState({
                    inputValue: null
                });
            }), St(Et(a), "clear", function() {
                a.onClearClick();
            }), St(Et(a), "onScroll", function(e) {
                "boolean" == typeof a.props.closeOnScroll && a.props.closeOnScroll ? e.target !== document && e.target !== document.documentElement && e.target !== document.body || a.setOpen(!1) : "function" == typeof a.props.closeOnScroll && a.props.closeOnScroll(e) && a.setOpen(!1);
            }), St(Et(a), "renderCalendar", function() {
                return a.props.inline || a.isCalendarOpen() ? de.default.createElement(sa, {
                    ref: function(e) {
                        a.calendar = e;
                    },
                    locale: a.props.locale,
                    calendarStartDay: a.props.calendarStartDay,
                    chooseDayAriaLabelPrefix: a.props.chooseDayAriaLabelPrefix,
                    disabledDayAriaLabelPrefix: a.props.disabledDayAriaLabelPrefix,
                    weekAriaLabelPrefix: a.props.weekAriaLabelPrefix,
                    monthAriaLabelPrefix: a.props.monthAriaLabelPrefix,
                    adjustDateOnChange: a.props.adjustDateOnChange,
                    setOpen: a.setOpen,
                    shouldCloseOnSelect: a.props.shouldCloseOnSelect,
                    dateFormat: a.props.dateFormatCalendar,
                    useWeekdaysShort: a.props.useWeekdaysShort,
                    formatWeekDay: a.props.formatWeekDay,
                    dropdownMode: a.props.dropdownMode,
                    selected: a.props.selected,
                    preSelection: a.state.preSelection,
                    onSelect: a.handleSelect,
                    onWeekSelect: a.props.onWeekSelect,
                    openToDate: a.props.openToDate,
                    minDate: a.props.minDate,
                    maxDate: a.props.maxDate,
                    selectsStart: a.props.selectsStart,
                    selectsEnd: a.props.selectsEnd,
                    selectsRange: a.props.selectsRange,
                    startDate: a.props.startDate,
                    endDate: a.props.endDate,
                    excludeDates: a.props.excludeDates,
                    excludeDateIntervals: a.props.excludeDateIntervals,
                    filterDate: a.props.filterDate,
                    onClickOutside: a.handleCalendarClickOutside,
                    formatWeekNumber: a.props.formatWeekNumber,
                    highlightDates: a.state.highlightDates,
                    holidays: Sr(a.modifyHolidays()),
                    includeDates: a.props.includeDates,
                    includeDateIntervals: a.props.includeDateIntervals,
                    includeTimes: a.props.includeTimes,
                    injectTimes: a.props.injectTimes,
                    inline: a.props.inline,
                    shouldFocusDayInline: a.state.shouldFocusDayInline,
                    peekNextMonth: a.props.peekNextMonth,
                    showMonthDropdown: a.props.showMonthDropdown,
                    showPreviousMonths: a.props.showPreviousMonths,
                    useShortMonthInDropdown: a.props.useShortMonthInDropdown,
                    showMonthYearDropdown: a.props.showMonthYearDropdown,
                    showWeekNumbers: a.props.showWeekNumbers,
                    showYearDropdown: a.props.showYearDropdown,
                    withPortal: a.props.withPortal,
                    forceShowMonthNavigation: a.props.forceShowMonthNavigation,
                    showDisabledMonthNavigation: a.props.showDisabledMonthNavigation,
                    scrollableYearDropdown: a.props.scrollableYearDropdown,
                    scrollableMonthYearDropdown: a.props.scrollableMonthYearDropdown,
                    todayButton: a.props.todayButton,
                    weekLabel: a.props.weekLabel,
                    outsideClickIgnoreClass: oa,
                    fixedHeight: a.props.fixedHeight,
                    monthsShown: a.props.monthsShown,
                    monthSelectedIn: a.state.monthSelectedIn,
                    onDropdownFocus: a.handleDropdownFocus,
                    onMonthChange: a.props.onMonthChange,
                    onYearChange: a.props.onYearChange,
                    dayClassName: a.props.dayClassName,
                    weekDayClassName: a.props.weekDayClassName,
                    monthClassName: a.props.monthClassName,
                    timeClassName: a.props.timeClassName,
                    showDateSelect: a.props.showDateSelect,
                    showTimeSelect: a.props.showTimeSelect,
                    showTimeSelectOnly: a.props.showTimeSelectOnly,
                    onTimeChange: a.handleTimeChange,
                    timeFormat: a.props.timeFormat,
                    timeIntervals: a.props.timeIntervals,
                    minTime: a.props.minTime,
                    maxTime: a.props.maxTime,
                    excludeTimes: a.props.excludeTimes,
                    filterTime: a.props.filterTime,
                    timeCaption: a.props.timeCaption,
                    className: a.props.calendarClassName,
                    container: a.props.calendarContainer,
                    yearItemNumber: a.props.yearItemNumber,
                    yearDropdownItemNumber: a.props.yearDropdownItemNumber,
                    previousMonthAriaLabel: a.props.previousMonthAriaLabel,
                    previousMonthButtonLabel: a.props.previousMonthButtonLabel,
                    nextMonthAriaLabel: a.props.nextMonthAriaLabel,
                    nextMonthButtonLabel: a.props.nextMonthButtonLabel,
                    previousYearAriaLabel: a.props.previousYearAriaLabel,
                    previousYearButtonLabel: a.props.previousYearButtonLabel,
                    nextYearAriaLabel: a.props.nextYearAriaLabel,
                    nextYearButtonLabel: a.props.nextYearButtonLabel,
                    timeInputLabel: a.props.timeInputLabel,
                    disabledKeyboardNavigation: a.props.disabledKeyboardNavigation,
                    renderCustomHeader: a.props.renderCustomHeader,
                    popperProps: a.props.popperProps,
                    renderDayContents: a.props.renderDayContents,
                    renderMonthContent: a.props.renderMonthContent,
                    renderQuarterContent: a.props.renderQuarterContent,
                    renderYearContent: a.props.renderYearContent,
                    onDayMouseEnter: a.props.onDayMouseEnter,
                    onMonthMouseLeave: a.props.onMonthMouseLeave,
                    onYearMouseEnter: a.props.onYearMouseEnter,
                    onYearMouseLeave: a.props.onYearMouseLeave,
                    selectsDisabledDaysInRange: a.props.selectsDisabledDaysInRange,
                    showTimeInput: a.props.showTimeInput,
                    showMonthYearPicker: a.props.showMonthYearPicker,
                    showFullMonthYearPicker: a.props.showFullMonthYearPicker,
                    showTwoColumnMonthYearPicker: a.props.showTwoColumnMonthYearPicker,
                    showFourColumnMonthYearPicker: a.props.showFourColumnMonthYearPicker,
                    showYearPicker: a.props.showYearPicker,
                    showQuarterYearPicker: a.props.showQuarterYearPicker,
                    showWeekPicker: a.props.showWeekPicker,
                    showPopperArrow: a.props.showPopperArrow,
                    excludeScrollbar: a.props.excludeScrollbar,
                    handleOnKeyDown: a.props.onKeyDown,
                    handleOnDayKeyDown: a.onDayKeyDown,
                    isInputFocused: a.state.focused,
                    customTimeInput: a.props.customTimeInput,
                    setPreSelection: a.setPreSelection
                }, a.props.children) : null;
            }), St(Et(a), "renderAriaLiveRegion", function() {
                var e, t = a.props, r = t.dateFormat, n = t.locale, o = a.props.showTimeInput || a.props.showTimeSelect ? "PPPPp" : "PPPP";
                return e = a.props.selectsRange ? "Selected start date: ".concat(Kt(a.props.startDate, {
                    dateFormat: o,
                    locale: n
                }), ". ").concat(a.props.endDate ? "End date: " + Kt(a.props.endDate, {
                    dateFormat: o,
                    locale: n
                }) : "") : a.props.showTimeSelectOnly ? "Selected time: ".concat(Kt(a.props.selected, {
                    dateFormat: r,
                    locale: n
                })) : a.props.showYearPicker ? "Selected year: ".concat(Kt(a.props.selected, {
                    dateFormat: "yyyy",
                    locale: n
                })) : a.props.showMonthYearPicker ? "Selected month: ".concat(Kt(a.props.selected, {
                    dateFormat: "MMMM yyyy",
                    locale: n
                })) : a.props.showQuarterYearPicker ? "Selected quarter: ".concat(Kt(a.props.selected, {
                    dateFormat: "yyyy, QQQ",
                    locale: n
                })) : "Selected date: ".concat(Kt(a.props.selected, {
                    dateFormat: o,
                    locale: n
                })), de.default.createElement("span", {
                    role: "alert",
                    "aria-live": "polite",
                    className: "react-datepicker__aria-live"
                }, e);
            }), St(Et(a), "renderDateInput", function() {
                var e, t = ue.default(a.props.className, St({}, oa, a.state.open)), r = a.props.customInput || de.default.createElement("input", {
                    type: "text"
                }), n = a.props.customInputRef || "ref", o = "string" == typeof a.props.value ? a.props.value : "string" == typeof a.state.inputValue ? a.state.inputValue : a.props.selectsRange ? function(e, t, r) {
                    if (!e) return "";
                    var a = Kt(e, r), n = t ? Kt(t, r) : "";
                    return "".concat(a, " - ").concat(n);
                }(a.props.startDate, a.props.endDate, a.props) : Kt(a.props.selected, a.props);
                return de.default.cloneElement(r, (St(St(St(St(St(St(St(St(St(St(e = {}, n, function(e) {
                    a.input = e;
                }), "value", o), "onBlur", a.handleBlur), "onChange", a.handleChange), "onClick", a.onInputClick), "onFocus", a.handleFocus), "onKeyDown", a.onInputKeyDown), "id", a.props.id), "name", a.props.name), "form", a.props.form), St(St(St(St(St(St(St(St(St(St(e, "autoFocus", a.props.autoFocus), "placeholder", a.props.placeholderText), "disabled", a.props.disabled), "autoComplete", a.props.autoComplete), "className", ue.default(r.props.className, t)), "title", a.props.title), "readOnly", a.props.readOnly), "required", a.props.required), "tabIndex", a.props.tabIndex), "aria-describedby", a.props.ariaDescribedBy), St(St(St(e, "aria-invalid", a.props.ariaInvalid), "aria-labelledby", a.props.ariaLabelledBy), "aria-required", a.props.ariaRequired)));
            }), St(Et(a), "renderClearButton", function() {
                var e = a.props, t = e.isClearable, r = e.disabled, n = e.selected, o = e.startDate, s = e.endDate, i = e.clearButtonTitle, p = e.clearButtonClassName, l = void 0 === p ? "" : p, c = e.ariaLabelClose, d = void 0 === c ? "Close" : c;
                return !t || null == n && null == o && null == s ? null : de.default.createElement("button", {
                    type: "button",
                    className: ue.default("react-datepicker__close-icon", l, {
                        "react-datepicker__close-icon--disabled": r
                    }),
                    disabled: r,
                    "aria-label": d,
                    onClick: a.onClearClick,
                    title: i,
                    tabIndex: -1
                });
            }), a.state = a.calcInitialState(), a.preventFocusTimeout = null, a;
        }
        return bt(r, [
            {
                key: "componentDidMount",
                value: function() {
                    window.addEventListener("scroll", this.onScroll, !0);
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e, t) {
                    var r, a;
                    e.inline && (r = e.selected, a = this.props.selected, r && a ? Te.default(r) !== Te.default(a) || Le.default(r) !== Le.default(a) : r !== a) && this.setPreSelection(this.props.selected), void 0 !== this.state.monthSelectedIn && e.monthsShown !== this.props.monthsShown && this.setState({
                        monthSelectedIn: 0
                    }), e.highlightDates !== this.props.highlightDates && this.setState({
                        highlightDates: br(this.props.highlightDates)
                    }), t.focused || Xt(e.selected, this.props.selected) || this.setState({
                        inputValue: null
                    }), t.open !== this.state.open && (!1 === t.open && !0 === this.state.open && this.props.onCalendarOpen(), !0 === t.open && !1 === this.state.open && this.props.onCalendarClose());
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    this.clearPreventFocusTimeout(), window.removeEventListener("scroll", this.onScroll, !0);
                }
            },
            {
                key: "renderInputContainer",
                value: function() {
                    var e = this.props, t = e.showIcon, r = e.icon, a = e.calendarIconClassname, n = e.toggleCalendarOnIconClick, o = this.state.open;
                    return de.default.createElement("div", {
                        className: "react-datepicker__input-container".concat(t ? " react-datepicker__view-calendar-icon" : "")
                    }, t && de.default.createElement(ea, Ct({
                        icon: r,
                        className: "".concat(a, " ").concat(o && "react-datepicker-ignore-onclickoutside")
                    }, n ? {
                        onClick: this.toggleCalendar
                    } : null)), this.state.isRenderAriaLiveMessage && this.renderAriaLiveRegion(), this.renderDateInput(), this.renderClearButton());
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.renderCalendar();
                    if (this.props.inline) return e;
                    if (this.props.withPortal) {
                        var t = this.state.open ? de.default.createElement(aa, {
                            enableTabLoop: this.props.enableTabLoop
                        }, de.default.createElement("div", {
                            className: "react-datepicker__portal",
                            tabIndex: -1,
                            onKeyDown: this.onPortalKeyDown
                        }, e)) : null;
                        return this.state.open && this.props.portalId && (t = de.default.createElement(ta, {
                            portalId: this.props.portalId,
                            portalHost: this.props.portalHost
                        }, t)), de.default.createElement("div", null, this.renderInputContainer(), t);
                    }
                    return de.default.createElement(na, {
                        className: this.props.popperClassName,
                        wrapperClassName: this.props.wrapperClassName,
                        hidePopper: !this.isCalendarOpen(),
                        portalId: this.props.portalId,
                        portalHost: this.props.portalHost,
                        popperModifiers: this.props.popperModifiers,
                        targetComponent: this.renderInputContainer(),
                        popperContainer: this.props.popperContainer,
                        popperComponent: e,
                        popperPlacement: this.props.popperPlacement,
                        popperProps: this.props.popperProps,
                        popperOnKeyDown: this.onPopperKeyDown,
                        enableTabLoop: this.props.enableTabLoop
                    });
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        allowSameDay: !1,
                        dateFormat: "MM/dd/yyyy",
                        dateFormatCalendar: "LLLL yyyy",
                        onChange: function() {},
                        disabled: !1,
                        disabledKeyboardNavigation: !1,
                        dropdownMode: "scroll",
                        onFocus: function() {},
                        onBlur: function() {},
                        onKeyDown: function() {},
                        onInputClick: function() {},
                        onSelect: function() {},
                        onClickOutside: function() {},
                        onMonthChange: function() {},
                        onCalendarOpen: function() {},
                        onCalendarClose: function() {},
                        preventOpenOnFocus: !1,
                        onYearChange: function() {},
                        onInputError: function() {},
                        monthsShown: 1,
                        readOnly: !1,
                        withPortal: !1,
                        selectsDisabledDaysInRange: !1,
                        shouldCloseOnSelect: !0,
                        showTimeSelect: !1,
                        showTimeInput: !1,
                        showPreviousMonths: !1,
                        showMonthYearPicker: !1,
                        showFullMonthYearPicker: !1,
                        showTwoColumnMonthYearPicker: !1,
                        showFourColumnMonthYearPicker: !1,
                        showYearPicker: !1,
                        showQuarterYearPicker: !1,
                        showWeekPicker: !1,
                        strictParsing: !1,
                        timeIntervals: 30,
                        timeCaption: "Time",
                        previousMonthAriaLabel: "Previous Month",
                        previousMonthButtonLabel: "Previous Month",
                        nextMonthAriaLabel: "Next Month",
                        nextMonthButtonLabel: "Next Month",
                        previousYearAriaLabel: "Previous Year",
                        previousYearButtonLabel: "Previous Year",
                        nextYearAriaLabel: "Next Year",
                        nextYearButtonLabel: "Next Year",
                        timeInputLabel: "Time",
                        enableTabLoop: !0,
                        yearItemNumber: Lt,
                        focusSelectedMonth: !1,
                        showPopperArrow: !0,
                        excludeScrollbar: !0,
                        customTimeInput: null,
                        calendarStartDay: void 0,
                        toggleCalendarOnIconClick: !1
                    };
                }
            }
        ]), r;
    }(de.default.Component), la = "input", ca = "navigate";
    e.CalendarContainer = Jr, e.default = pa, e.getDefaultLocale = er, e.registerLocale = function(e, t) {
        var r = "undefined" != typeof window ? window : globalThis;
        r.__localeData__ || (r.__localeData__ = {}), r.__localeData__[e] = t;
    }, e.setDefaultLocale = function(e) {
        ("undefined" != typeof window ? window : globalThis).__localeId__ = e;
    }, Object.defineProperty(e, "__esModule", {
        value: !0
    });
});

});
parcelRegister("bTSG2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $8a9f3e7be35784f5$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $8eaBc = parcelRequire("8eaBc");

var $4LmDH = parcelRequire("4LmDH");
var $8a9f3e7be35784f5$var$MILLISECONDS_IN_MINUTE = 60000;
function $8a9f3e7be35784f5$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $esGEx.default)(dirtyAmount);
    return (0, $8eaBc.default)(dirtyDate, amount * $8a9f3e7be35784f5$var$MILLISECONDS_IN_MINUTE);
}

});

parcelRegister("kehhj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $eba2848fce1475e9$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $8eaBc = parcelRequire("8eaBc");

var $4LmDH = parcelRequire("4LmDH");
var $eba2848fce1475e9$var$MILLISECONDS_IN_HOUR = 3600000;
function $eba2848fce1475e9$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $esGEx.default)(dirtyAmount);
    return (0, $8eaBc.default)(dirtyDate, amount * $eba2848fce1475e9$var$MILLISECONDS_IN_HOUR);
}

});

parcelRegister("6OX6Q", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4f754377033842c6$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $4f754377033842c6$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var amount = (0, $esGEx.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
    date.setDate(date.getDate() + amount);
    return date;
}

});

parcelRegister("2MTnF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $207b05f27970aaba$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $6OX6Q = parcelRequire("6OX6Q");

var $4LmDH = parcelRequire("4LmDH");
function $207b05f27970aaba$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $esGEx.default)(dirtyAmount);
    var days = amount * 7;
    return (0, $6OX6Q.default)(dirtyDate, days);
}

});

parcelRegister("eqWMS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a8211859f65764ad$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $a8211859f65764ad$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var amount = (0, $esGEx.default)(dirtyAmount);
    if (isNaN(amount)) return new Date(NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
    var dayOfMonth = date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    var endOfDesiredMonth = new Date(date.getTime());
    endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
    var daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return date;
    }
}

});

parcelRegister("k005h", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e8f3df7678d5e716$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $eqWMS = parcelRequire("eqWMS");

var $4LmDH = parcelRequire("4LmDH");
function $e8f3df7678d5e716$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $esGEx.default)(dirtyAmount);
    var months = amount * 3;
    return (0, $eqWMS.default)(dirtyDate, months);
}

});

parcelRegister("kbDwl", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $eb237db400049a40$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $eqWMS = parcelRequire("eqWMS");

var $4LmDH = parcelRequire("4LmDH");
function $eb237db400049a40$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $esGEx.default)(dirtyAmount);
    return (0, $eqWMS.default)(dirtyDate, amount * 12);
}

});

parcelRegister("4irF8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $320e4d083cefb0bc$export$2e2bcd8739ae039);

var $6OX6Q = parcelRequire("6OX6Q");

var $4LmDH = parcelRequire("4LmDH");

var $esGEx = parcelRequire("esGEx");
function $320e4d083cefb0bc$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $esGEx.default)(dirtyAmount);
    return (0, $6OX6Q.default)(dirtyDate, -amount);
}

});

parcelRegister("lDduA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $fbf7b4c4dab20b8b$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $2MTnF = parcelRequire("2MTnF");

var $4LmDH = parcelRequire("4LmDH");
function $fbf7b4c4dab20b8b$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $esGEx.default)(dirtyAmount);
    return (0, $2MTnF.default)(dirtyDate, -amount);
}

});

parcelRegister("lXe7Q", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ffba10b3e12d8879$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $eqWMS = parcelRequire("eqWMS");

var $4LmDH = parcelRequire("4LmDH");
function $ffba10b3e12d8879$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $esGEx.default)(dirtyAmount);
    return (0, $eqWMS.default)(dirtyDate, -amount);
}

});

parcelRegister("6tQqS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4b7e1f7e0738eb32$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $k005h = parcelRequire("k005h");

var $4LmDH = parcelRequire("4LmDH");
function $4b7e1f7e0738eb32$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $esGEx.default)(dirtyAmount);
    return (0, $k005h.default)(dirtyDate, -amount);
}

});

parcelRegister("4UG1B", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $393cfda53f7a350f$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $kbDwl = parcelRequire("kbDwl");

var $4LmDH = parcelRequire("4LmDH");
function $393cfda53f7a350f$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $esGEx.default)(dirtyAmount);
    return (0, $kbDwl.default)(dirtyDate, -amount);
}

});

parcelRegister("6fhf3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $48c184a62f8d0eb5$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $48c184a62f8d0eb5$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var seconds = date.getSeconds();
    return seconds;
}

});

parcelRegister("aABJG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7b5a89b8f9188b81$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $7b5a89b8f9188b81$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var minutes = date.getMinutes();
    return minutes;
}

});

parcelRegister("kjLiX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ecaa46b9ba4a249b$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $ecaa46b9ba4a249b$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var hours = date.getHours();
    return hours;
}

});

parcelRegister("34ylv", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $23cc632e101f8877$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $23cc632e101f8877$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var day = date.getDay();
    return day;
}

});

parcelRegister("eZOMj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $aeae26b52a87faed$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $aeae26b52a87faed$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var dayOfMonth = date.getDate();
    return dayOfMonth;
}

});

parcelRegister("hbMru", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c8390a6465ec9630$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $Ua0Sr = parcelRequire("Ua0Sr");

var $2HjQQ = parcelRequire("2HjQQ");

var $4LmDH = parcelRequire("4LmDH");
var $c8390a6465ec9630$var$MILLISECONDS_IN_WEEK = 604800000;
function $c8390a6465ec9630$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var diff = (0, $Ua0Sr.default)(date).getTime() - (0, $2HjQQ.default)(date).getTime();
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $c8390a6465ec9630$var$MILLISECONDS_IN_WEEK) + 1;
}

});
parcelRegister("Ua0Sr", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a8cff7ae633de9e$export$2e2bcd8739ae039);

var $7yBDJ = parcelRequire("7yBDJ");

var $4LmDH = parcelRequire("4LmDH");
function $0a8cff7ae633de9e$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    return (0, $7yBDJ.default)(dirtyDate, {
        weekStartsOn: 1
    });
}

});
parcelRegister("7yBDJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $5808e7e2a5fbbc4c$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $esGEx = parcelRequire("esGEx");

var $4LmDH = parcelRequire("4LmDH");

var $2GvpZ = parcelRequire("2GvpZ");
function $5808e7e2a5fbbc4c$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $4LmDH.default)(1, arguments);
    var defaultOptions = (0, $2GvpZ.getDefaultOptions)();
    var weekStartsOn = (0, $esGEx.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $gdr0J.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setDate(date.getDate() - diff);
    date.setHours(0, 0, 0, 0);
    return date;
}

});


parcelRegister("2HjQQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f6eff01db4e8676$export$2e2bcd8739ae039);

var $i0SQV = parcelRequire("i0SQV");

var $Ua0Sr = parcelRequire("Ua0Sr");

var $4LmDH = parcelRequire("4LmDH");
function $1f6eff01db4e8676$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var year = (0, $i0SQV.default)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    var date = (0, $Ua0Sr.default)(fourthOfJanuary);
    return date;
}

});
parcelRegister("i0SQV", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1d2c6aef0e5f696$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $Ua0Sr = parcelRequire("Ua0Sr");

var $4LmDH = parcelRequire("4LmDH");
function $d1d2c6aef0e5f696$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var year = date.getFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    var startOfNextYear = (0, $Ua0Sr.default)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    var startOfThisYear = (0, $Ua0Sr.default)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}

});



parcelRegister("4UeRq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3927eb6a31e1659f$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $3927eb6a31e1659f$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var month = date.getMonth();
    return month;
}

});

parcelRegister("3LPyO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $2bedc1b96ccf587f$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $2bedc1b96ccf587f$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var quarter = Math.floor(date.getMonth() / 3) + 1;
    return quarter;
}

});

parcelRegister("knAHj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ed626c0821295496$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $ed626c0821295496$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    return (0, $gdr0J.default)(dirtyDate).getFullYear();
}

});

parcelRegister("2SwgK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $2189a7e545f8ece8$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $2189a7e545f8ece8$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var timestamp = date.getTime();
    return timestamp;
}

});

parcelRegister("d0W11", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $979847221b6d59d4$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $979847221b6d59d4$export$2e2bcd8739ae039(dirtyDate, dirtySeconds) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var seconds = (0, $esGEx.default)(dirtySeconds);
    date.setSeconds(seconds);
    return date;
}

});

parcelRegister("6mdUF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4a0f96fdddaa35da$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $4a0f96fdddaa35da$export$2e2bcd8739ae039(dirtyDate, dirtyMinutes) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var minutes = (0, $esGEx.default)(dirtyMinutes);
    date.setMinutes(minutes);
    return date;
}

});

parcelRegister("gpyWg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $bf2a1543848c0a73$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $bf2a1543848c0a73$export$2e2bcd8739ae039(dirtyDate, dirtyHours) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var hours = (0, $esGEx.default)(dirtyHours);
    date.setHours(hours);
    return date;
}

});

parcelRegister("cZ2kT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $973cfe686ae8d1d7$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $gdr0J = parcelRequire("gdr0J");

var $cPszP = parcelRequire("cPszP");

var $4LmDH = parcelRequire("4LmDH");
function $973cfe686ae8d1d7$export$2e2bcd8739ae039(dirtyDate, dirtyMonth) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var month = (0, $esGEx.default)(dirtyMonth);
    var year = date.getFullYear();
    var day = date.getDate();
    var dateWithDesiredMonth = new Date(0);
    dateWithDesiredMonth.setFullYear(year, month, 15);
    dateWithDesiredMonth.setHours(0, 0, 0, 0);
    var daysInMonth = (0, $cPszP.default)(dateWithDesiredMonth);
    // Set the last day of the new month
    // if the original date was the last day of the longer month
    date.setMonth(month, Math.min(day, daysInMonth));
    return date;
}

});
parcelRegister("cPszP", function(module, exports) {

$parcel$export(module.exports, "default", () => $95706a37c0d7d1b0$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $95706a37c0d7d1b0$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var lastDayOfMonth = new Date(0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}

});


parcelRegister("fVhCa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $b979d7c80aa6a726$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $gdr0J = parcelRequire("gdr0J");

var $cZ2kT = parcelRequire("cZ2kT");

var $4LmDH = parcelRequire("4LmDH");
function $b979d7c80aa6a726$export$2e2bcd8739ae039(dirtyDate, dirtyQuarter) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var quarter = (0, $esGEx.default)(dirtyQuarter);
    var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
    var diff = quarter - oldQuarter;
    return (0, $cZ2kT.default)(date, date.getMonth() + diff * 3);
}

});

parcelRegister("3lKFD", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $2707890d0f47c3ba$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $2707890d0f47c3ba$export$2e2bcd8739ae039(dirtyDate, dirtyYear) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var year = (0, $esGEx.default)(dirtyYear);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(date.getTime())) return new Date(NaN);
    date.setFullYear(year);
    return date;
}

});

parcelRegister("8v9st", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $63088e2bf3abfc06$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $63088e2bf3abfc06$export$2e2bcd8739ae039(dirtyDatesArray) {
    (0, $4LmDH.default)(1, arguments);
    var datesArray;
    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === "function") datesArray = dirtyDatesArray;
    else if ((0, $fSwVM.default)(dirtyDatesArray) === "object" && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, $gdr0J.default)(dirtyDate);
        if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) result = currentDate;
    });
    return result || new Date(NaN);
}

});

parcelRegister("6atcA", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $47da542d3f4cabcc$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $47da542d3f4cabcc$export$2e2bcd8739ae039(dirtyDatesArray) {
    (0, $4LmDH.default)(1, arguments);
    var datesArray;
    // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
    if (dirtyDatesArray && typeof dirtyDatesArray.forEach === "function") datesArray = dirtyDatesArray;
    else if ((0, $fSwVM.default)(dirtyDatesArray) === "object" && dirtyDatesArray !== null) datesArray = Array.prototype.slice.call(dirtyDatesArray);
    else // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
    var result;
    datesArray.forEach(function(dirtyDate) {
        var currentDate = (0, $gdr0J.default)(dirtyDate);
        if (result === undefined || result < currentDate || isNaN(Number(currentDate))) result = currentDate;
    });
    return result || new Date(NaN);
}

});

parcelRegister("lm2ga", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f8bd67cac91ee19b$export$2e2bcd8739ae039);

var $9vfYB = parcelRequire("9vfYB");

var $cJfMa = parcelRequire("cJfMa");

var $4LmDH = parcelRequire("4LmDH");
var $f8bd67cac91ee19b$var$MILLISECONDS_IN_DAY = 86400000;
function $f8bd67cac91ee19b$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4LmDH.default)(2, arguments);
    var startOfDayLeft = (0, $cJfMa.default)(dirtyDateLeft);
    var startOfDayRight = (0, $cJfMa.default)(dirtyDateRight);
    var timestampLeft = startOfDayLeft.getTime() - (0, $9vfYB.default)(startOfDayLeft);
    var timestampRight = startOfDayRight.getTime() - (0, $9vfYB.default)(startOfDayRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a day is not constant
    // (e.g. it's different in the day of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $f8bd67cac91ee19b$var$MILLISECONDS_IN_DAY);
}

});
parcelRegister("cJfMa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $9445ecc5e7cfb647$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $9445ecc5e7cfb647$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    date.setHours(0, 0, 0, 0);
    return date;
}

});


parcelRegister("1Whvr", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $1698c992e2cb67cc$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $1698c992e2cb67cc$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4LmDH.default)(2, arguments);
    var dateLeft = (0, $gdr0J.default)(dirtyDateLeft);
    var dateRight = (0, $gdr0J.default)(dirtyDateRight);
    var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
    var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
    return yearDiff * 12 + monthDiff;
}

});

parcelRegister("jMhzE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e66021df2494c23e$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $e66021df2494c23e$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4LmDH.default)(2, arguments);
    var dateLeft = (0, $gdr0J.default)(dirtyDateLeft);
    var dateRight = (0, $gdr0J.default)(dirtyDateRight);
    return dateLeft.getFullYear() - dateRight.getFullYear();
}

});

parcelRegister("5E40x", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $41c3cc0836893904$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $41c3cc0836893904$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("gVPZO", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c53a4d8dd17910c2$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $c53a4d8dd17910c2$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var currentMonth = date.getMonth();
    var month = currentMonth - currentMonth % 3;
    date.setMonth(month, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("6eIgt", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $48a662f07bb27222$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $48a662f07bb27222$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var cleanDate = (0, $gdr0J.default)(dirtyDate);
    var date = new Date(0);
    date.setFullYear(cleanDate.getFullYear(), 0, 1);
    date.setHours(0, 0, 0, 0);
    return date;
}

});

parcelRegister("6uyHy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4ba07667a7282b10$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $4ba07667a7282b10$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("75XN4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $52a761315a8e3e9c$export$2e2bcd8739ae039);

var $2GvpZ = parcelRequire("2GvpZ");

var $gdr0J = parcelRequire("gdr0J");

var $esGEx = parcelRequire("esGEx");

var $4LmDH = parcelRequire("4LmDH");
function $52a761315a8e3e9c$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $4LmDH.default)(1, arguments);
    var defaultOptions = (0, $2GvpZ.getDefaultOptions)();
    var weekStartsOn = (0, $esGEx.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $gdr0J.default)(dirtyDate);
    var day = date.getDay();
    var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    date.setDate(date.getDate() + diff);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("l2vHo", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f5125f9e9edab43e$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $f5125f9e9edab43e$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var month = date.getMonth();
    date.setFullYear(date.getFullYear(), month + 1, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("7LBzP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $5a7a122bf592ddcb$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $5a7a122bf592ddcb$export$2e2bcd8739ae039(dirtyDate) {
    (0, $4LmDH.default)(1, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var year = date.getFullYear();
    date.setFullYear(year + 1, 0, 0);
    date.setHours(23, 59, 59, 999);
    return date;
}

});

parcelRegister("gd5RE", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $bcd268c28ce3da9c$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $bcd268c28ce3da9c$export$2e2bcd8739ae039(dirtyLeftDate, dirtyRightDate) {
    (0, $4LmDH.default)(2, arguments);
    var dateLeft = (0, $gdr0J.default)(dirtyLeftDate);
    var dateRight = (0, $gdr0J.default)(dirtyRightDate);
    return dateLeft.getTime() === dateRight.getTime();
}

});

parcelRegister("hjw1k", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c9ad0c9b51445ea3$export$2e2bcd8739ae039);

var $cJfMa = parcelRequire("cJfMa");

var $4LmDH = parcelRequire("4LmDH");
function $c9ad0c9b51445ea3$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4LmDH.default)(2, arguments);
    var dateLeftStartOfDay = (0, $cJfMa.default)(dirtyDateLeft);
    var dateRightStartOfDay = (0, $cJfMa.default)(dirtyDateRight);
    return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

});

parcelRegister("b27pX", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $8085a298e92e1718$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $8085a298e92e1718$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4LmDH.default)(2, arguments);
    var dateLeft = (0, $gdr0J.default)(dirtyDateLeft);
    var dateRight = (0, $gdr0J.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

});

parcelRegister("R4xmB", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $09f87854553a6255$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $09f87854553a6255$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4LmDH.default)(2, arguments);
    var dateLeft = (0, $gdr0J.default)(dirtyDateLeft);
    var dateRight = (0, $gdr0J.default)(dirtyDateRight);
    return dateLeft.getFullYear() === dateRight.getFullYear();
}

});

parcelRegister("kggGd", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $ec023d87d9d9e040$export$2e2bcd8739ae039);

var $gVPZO = parcelRequire("gVPZO");

var $4LmDH = parcelRequire("4LmDH");
function $ec023d87d9d9e040$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight) {
    (0, $4LmDH.default)(2, arguments);
    var dateLeftStartOfQuarter = (0, $gVPZO.default)(dirtyDateLeft);
    var dateRightStartOfQuarter = (0, $gVPZO.default)(dirtyDateRight);
    return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
}

});

parcelRegister("baBa1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $821d7431eba4c146$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $821d7431eba4c146$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var dateToCompare = (0, $gdr0J.default)(dirtyDateToCompare);
    return date.getTime() > dateToCompare.getTime();
}

});

parcelRegister("4YTY5", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3a082e1cb0a32433$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $3a082e1cb0a32433$export$2e2bcd8739ae039(dirtyDate, dirtyDateToCompare) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var dateToCompare = (0, $gdr0J.default)(dirtyDateToCompare);
    return date.getTime() < dateToCompare.getTime();
}

});

parcelRegister("gDwFN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $c1c9a216d559c39d$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $c1c9a216d559c39d$export$2e2bcd8739ae039(dirtyDate, interval) {
    (0, $4LmDH.default)(2, arguments);
    var time = (0, $gdr0J.default)(dirtyDate).getTime();
    var startTime = (0, $gdr0J.default)(interval.start).getTime();
    var endTime = (0, $gdr0J.default)(interval.end).getTime();
    // Throw an exception if start date is after end date or if any date is `Invalid Date`
    if (!(startTime <= endTime)) throw new RangeError("Invalid interval");
    return time >= startTime && time <= endTime;
}

});

parcelRegister("auRgN", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7a460707bf147158$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $6Z0ky = parcelRequire("6Z0ky");

var $d7Pru = parcelRequire("d7Pru");

var $8NlMJ = parcelRequire("8NlMJ");

var $gdr0J = parcelRequire("gdr0J");

var $6yoAC = parcelRequire("6yoAC");

var $6MGGE = parcelRequire("6MGGE");

var $9vfYB = parcelRequire("9vfYB");

var $ebrmh = parcelRequire("ebrmh");

var $esGEx = parcelRequire("esGEx");

var $4LmDH = parcelRequire("4LmDH");

var $d6B4A = parcelRequire("d6B4A");

var $gznWl = parcelRequire("gznWl");

var $2GvpZ = parcelRequire("2GvpZ");
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $7a460707bf147158$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $7a460707bf147158$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $7a460707bf147158$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $7a460707bf147158$var$doubleQuoteRegExp = /''/g;
var $7a460707bf147158$var$notWhitespaceRegExp = /\S/;
var $7a460707bf147158$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $7a460707bf147158$export$2e2bcd8739ae039(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $4LmDH.default)(3, arguments);
    var dateString = String(dirtyDateString);
    var formatString = String(dirtyFormatString);
    var defaultOptions = (0, $2GvpZ.getDefaultOptions)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $d7Pru.default);
    if (!locale.match) throw new RangeError("locale must contain match property");
    var firstWeekContainsDate = (0, $esGEx.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);
    // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, $esGEx.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (formatString === "") {
        if (dateString === "") return (0, $gdr0J.default)(dirtyReferenceDate);
        else return new Date(NaN);
    }
    var subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will be set to the system timezone
    var setters = [
        new (0, $d6B4A.DateToSystemTimezoneSetter)()
    ];
    var tokens = formatString.match($7a460707bf147158$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter in (0, $6MGGE.default)) {
            var longFormatter = (0, $6MGGE.default)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($7a460707bf147158$var$formattingTokensRegExp);
    var usedTokens = [];
    var _iterator = (0, $6Z0ky.default)(tokens), _step;
    try {
        var _loop = function _loop() {
            var token = _step.value;
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $ebrmh.isProtectedWeekYearToken)(token)) (0, $ebrmh.throwProtectedError)(token, formatString, dirtyDateString);
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $ebrmh.isProtectedDayOfYearToken)(token)) (0, $ebrmh.throwProtectedError)(token, formatString, dirtyDateString);
            var firstCharacter = token[0];
            var parser = (0, $gznWl.parsers)[firstCharacter];
            if (parser) {
                var incompatibleTokens = parser.incompatibleTokens;
                if (Array.isArray(incompatibleTokens)) {
                    var incompatibleToken = usedTokens.find(function(usedToken) {
                        return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
                    });
                    if (incompatibleToken) throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
                } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
                usedTokens.push({
                    token: firstCharacter,
                    fullToken: token
                });
                var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
                if (!parseResult) return {
                    v: new Date(NaN)
                };
                setters.push(parseResult.setter);
                dateString = parseResult.rest;
            } else {
                if (firstCharacter.match($7a460707bf147158$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
                // Replace two single quote characters with one single quote character
                if (token === "''") token = "'";
                else if (firstCharacter === "'") token = $7a460707bf147158$var$cleanEscapedString(token);
                // Cut token from string, or, if string doesn't match the token, return Invalid Date
                if (dateString.indexOf(token) === 0) dateString = dateString.slice(token.length);
                else return {
                    v: new Date(NaN)
                };
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _ret = _loop();
            if ((0, $fSwVM.default)(_ret) === "object") return _ret.v;
        }
    // Check if the remaining input contains something other than whitespace
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    if (dateString.length > 0 && $7a460707bf147158$var$notWhitespaceRegExp.test(dateString)) return new Date(NaN);
    var uniquePrioritySetters = setters.map(function(setter) {
        return setter.priority;
    }).sort(function(a, b) {
        return b - a;
    }).filter(function(priority, index, array) {
        return array.indexOf(priority) === index;
    }).map(function(priority) {
        return setters.filter(function(setter) {
            return setter.priority === priority;
        }).sort(function(a, b) {
            return b.subPriority - a.subPriority;
        });
    }).map(function(setterArray) {
        return setterArray[0];
    });
    var date = (0, $gdr0J.default)(dirtyReferenceDate);
    if (isNaN(date.getTime())) return new Date(NaN);
    // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    var utcDate = (0, $8NlMJ.default)(date, (0, $9vfYB.default)(date));
    var flags = {};
    var _iterator2 = (0, $6Z0ky.default)(uniquePrioritySetters), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var setter = _step2.value;
            if (!setter.validate(utcDate, subFnOptions)) return new Date(NaN);
            var result = setter.set(utcDate, flags, subFnOptions);
            // Result is tuple (date, flags)
            if (Array.isArray(result)) {
                utcDate = result[0];
                (0, $6yoAC.default)(flags, result[1]);
            // Result is date
            } else utcDate = result;
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
    return utcDate;
}
function $7a460707bf147158$var$cleanEscapedString(input) {
    return input.match($7a460707bf147158$var$escapedStringRegExp)[1].replace($7a460707bf147158$var$doubleQuoteRegExp, "'");
}

});
parcelRegister("6Z0ky", function(module, exports) {

$parcel$export(module.exports, "default", () => $5158b23d1f990d5e$export$2e2bcd8739ae039);

var $abLc2 = parcelRequire("abLc2");
function $5158b23d1f990d5e$export$2e2bcd8739ae039(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = (0, $abLc2.default)(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var _n = 0, F = function F() {};
            return {
                s: F,
                n: function n() {
                    return _n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[_n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var r = t.next();
            return a = r.done, r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t["return"] || t["return"]();
            } finally{
                if (u) throw o;
            }
        }
    };
}

});
parcelRegister("abLc2", function(module, exports) {

$parcel$export(module.exports, "default", () => $76af8a05551d5f25$export$2e2bcd8739ae039);

var $7K8zV = parcelRequire("7K8zV");
function $76af8a05551d5f25$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $7K8zV.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $7K8zV.default)(r, a) : void 0;
    }
}

});
parcelRegister("7K8zV", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a337bca9556bfe7$export$2e2bcd8739ae039);
function $5a337bca9556bfe7$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});



parcelRegister("6yoAC", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c58fe0eb0761e95$export$2e2bcd8739ae039);
function $4c58fe0eb0761e95$export$2e2bcd8739ae039(target, object) {
    if (target == null) throw new TypeError("assign requires that input parameter not be null or undefined");
    for(var property in object)if (Object.prototype.hasOwnProperty.call(object, property)) target[property] = object[property];
    return target;
}

});

parcelRegister("d6B4A", function(module, exports) {

$parcel$export(module.exports, "ValueSetter", () => $98a897cde0f0abfd$export$9a09e32dd4990fd5);
$parcel$export(module.exports, "DateToSystemTimezoneSetter", () => $98a897cde0f0abfd$export$5aaf7ff7f09ea4ee);

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $kSlfw = parcelRequire("kSlfw");
var $98a897cde0f0abfd$var$TIMEZONE_UNIT_PRIORITY = 10;
var $98a897cde0f0abfd$export$81d53e3678089a6 = /*#__PURE__*/ function() {
    function Setter() {
        (0, $6CZeq.default)(this, Setter);
        (0, $kSlfw.default)(this, "priority", void 0);
        (0, $kSlfw.default)(this, "subPriority", 0);
    }
    (0, $cHPF9.default)(Setter, [
        {
            key: "validate",
            value: function validate(_utcDate, _options) {
                return true;
            }
        }
    ]);
    return Setter;
}();
var $98a897cde0f0abfd$export$9a09e32dd4990fd5 = /*#__PURE__*/ function(_Setter) {
    (0, $1gYAD.default)(ValueSetter, _Setter);
    var _super = (0, $enfmq.default)(ValueSetter);
    function ValueSetter(value, validateValue, setValue, priority, subPriority) {
        var _this;
        (0, $6CZeq.default)(this, ValueSetter);
        _this = _super.call(this);
        _this.value = value;
        _this.validateValue = validateValue;
        _this.setValue = setValue;
        _this.priority = priority;
        if (subPriority) _this.subPriority = subPriority;
        return _this;
    }
    (0, $cHPF9.default)(ValueSetter, [
        {
            key: "validate",
            value: function validate(utcDate, options) {
                return this.validateValue(utcDate, this.value, options);
            }
        },
        {
            key: "set",
            value: function set(utcDate, flags, options) {
                return this.setValue(utcDate, flags, this.value, options);
            }
        }
    ]);
    return ValueSetter;
}($98a897cde0f0abfd$export$81d53e3678089a6);
var $98a897cde0f0abfd$export$5aaf7ff7f09ea4ee = /*#__PURE__*/ function(_Setter2) {
    (0, $1gYAD.default)(DateToSystemTimezoneSetter, _Setter2);
    var _super2 = (0, $enfmq.default)(DateToSystemTimezoneSetter);
    function DateToSystemTimezoneSetter() {
        var _this2;
        (0, $6CZeq.default)(this, DateToSystemTimezoneSetter);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this2), "priority", $98a897cde0f0abfd$var$TIMEZONE_UNIT_PRIORITY);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this2), "subPriority", -1);
        return _this2;
    }
    (0, $cHPF9.default)(DateToSystemTimezoneSetter, [
        {
            key: "set",
            value: function set(date, flags) {
                if (flags.timestampIsSet) return date;
                var convertedDate = new Date(0);
                convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
                convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
                return convertedDate;
            }
        }
    ]);
    return DateToSystemTimezoneSetter;
}($98a897cde0f0abfd$export$81d53e3678089a6);

});
parcelRegister("1gYAD", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ed648f7bbaf3aff$export$2e2bcd8739ae039);

var $VFVve = parcelRequire("VFVve");
function $0ed648f7bbaf3aff$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $VFVve.default)(t, e);
}

});

parcelRegister("enfmq", function(module, exports) {

$parcel$export(module.exports, "default", () => $a76f20fb39fa9d46$export$2e2bcd8739ae039);

var $jDKKo = parcelRequire("jDKKo");

var $fhGLX = parcelRequire("fhGLX");

var $9715X = parcelRequire("9715X");
function $a76f20fb39fa9d46$export$2e2bcd8739ae039(t) {
    var r = (0, $fhGLX.default)();
    return function() {
        var e, o = (0, $jDKKo.default)(t);
        if (r) {
            var s = (0, $jDKKo.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $9715X.default)(this, e);
    };
}

});
parcelRegister("jDKKo", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4c5ebe502337db0$export$2e2bcd8739ae039);
function $e4c5ebe502337db0$export$2e2bcd8739ae039(t) {
    return $e4c5ebe502337db0$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $e4c5ebe502337db0$export$2e2bcd8739ae039(t);
}

});

parcelRegister("fhGLX", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2099f49db83e2df$export$2e2bcd8739ae039);
function $b2099f49db83e2df$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($b2099f49db83e2df$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("9715X", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a259df8fa92dc4a$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $hDpcU = parcelRequire("hDpcU");
function $6a259df8fa92dc4a$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $fSwVM.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $hDpcU.default)(t);
}

});


parcelRegister("6CZeq", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d35ca0862055760$export$2e2bcd8739ae039);
function $4d35ca0862055760$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("cHPF9", function(module, exports) {

$parcel$export(module.exports, "default", () => $94019358ecbcf36b$export$2e2bcd8739ae039);

var $4ZreY = parcelRequire("4ZreY");
function $94019358ecbcf36b$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $4ZreY.default)(o.key), o);
    }
}
function $94019358ecbcf36b$export$2e2bcd8739ae039(e, r, t) {
    return r && $94019358ecbcf36b$var$_defineProperties(e.prototype, r), t && $94019358ecbcf36b$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});


parcelRegister("gznWl", function(module, exports) {

$parcel$export(module.exports, "parsers", () => $c1027c3b7f83f29d$export$19131010e7fd8373);

var $75WXJ = parcelRequire("75WXJ");

var $a8eKR = parcelRequire("a8eKR");

var $fj1li = parcelRequire("fj1li");

var $44HZq = parcelRequire("44HZq");

var $fwa91 = parcelRequire("fwa91");

var $dt2Qm = parcelRequire("dt2Qm");

var $dOVGV = parcelRequire("dOVGV");

var $7o7jr = parcelRequire("7o7jr");

var $8dk1W = parcelRequire("8dk1W");

var $hW0pX = parcelRequire("hW0pX");

var $anGh5 = parcelRequire("anGh5");

var $cjr07 = parcelRequire("cjr07");

var $mnuhN = parcelRequire("mnuhN");

var $gqUjS = parcelRequire("gqUjS");

var $eglEX = parcelRequire("eglEX");

var $7jfsL = parcelRequire("7jfsL");

var $7ANJo = parcelRequire("7ANJo");

var $bUyT3 = parcelRequire("bUyT3");

var $jYJCf = parcelRequire("jYJCf");

var $7q5qq = parcelRequire("7q5qq");

var $2ashg = parcelRequire("2ashg");

var $fGBwT = parcelRequire("fGBwT");

var $1ZCjh = parcelRequire("1ZCjh");

var $8I45K = parcelRequire("8I45K");

var $ajDAU = parcelRequire("ajDAU");

var $9fJ56 = parcelRequire("9fJ56");

var $1If4X = parcelRequire("1If4X");

var $cAns0 = parcelRequire("cAns0");

var $kuK4G = parcelRequire("kuK4G");

var $jhVfr = parcelRequire("jhVfr");

var $gDlDV = parcelRequire("gDlDV");
var $c1027c3b7f83f29d$export$19131010e7fd8373 = {
    G: new (0, $75WXJ.EraParser)(),
    y: new (0, $a8eKR.YearParser)(),
    Y: new (0, $fj1li.LocalWeekYearParser)(),
    R: new (0, $44HZq.ISOWeekYearParser)(),
    u: new (0, $fwa91.ExtendedYearParser)(),
    Q: new (0, $dt2Qm.QuarterParser)(),
    q: new (0, $dOVGV.StandAloneQuarterParser)(),
    M: new (0, $7o7jr.MonthParser)(),
    L: new (0, $8dk1W.StandAloneMonthParser)(),
    w: new (0, $hW0pX.LocalWeekParser)(),
    I: new (0, $anGh5.ISOWeekParser)(),
    d: new (0, $cjr07.DateParser)(),
    D: new (0, $mnuhN.DayOfYearParser)(),
    E: new (0, $gqUjS.DayParser)(),
    e: new (0, $eglEX.LocalDayParser)(),
    c: new (0, $7jfsL.StandAloneLocalDayParser)(),
    i: new (0, $7ANJo.ISODayParser)(),
    a: new (0, $bUyT3.AMPMParser)(),
    b: new (0, $jYJCf.AMPMMidnightParser)(),
    B: new (0, $7q5qq.DayPeriodParser)(),
    h: new (0, $2ashg.Hour1to12Parser)(),
    H: new (0, $fGBwT.Hour0to23Parser)(),
    K: new (0, $1ZCjh.Hour0To11Parser)(),
    k: new (0, $8I45K.Hour1To24Parser)(),
    m: new (0, $ajDAU.MinuteParser)(),
    s: new (0, $9fJ56.SecondParser)(),
    S: new (0, $1If4X.FractionOfSecondParser)(),
    X: new (0, $cAns0.ISOTimezoneWithZParser)(),
    x: new (0, $kuK4G.ISOTimezoneParser)(),
    t: new (0, $jhVfr.TimestampSecondsParser)(),
    T: new (0, $gDlDV.TimestampMillisecondsParser)()
};

});
parcelRegister("75WXJ", function(module, exports) {

$parcel$export(module.exports, "EraParser", () => $52a6bcb88b20d48f$export$8e5a1d3f85a9688);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");
var $52a6bcb88b20d48f$export$8e5a1d3f85a9688 = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(EraParser, _Parser);
    var _super = (0, $enfmq.default)(EraParser);
    function EraParser() {
        var _this;
        (0, $6CZeq.default)(this, EraParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 140);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "R",
            "u",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(EraParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // AD, BC
                    case "G":
                    case "GG":
                    case "GGG":
                        return match.era(dateString, {
                            width: "abbreviated"
                        }) || match.era(dateString, {
                            width: "narrow"
                        });
                    // A, B
                    case "GGGGG":
                        return match.era(dateString, {
                            width: "narrow"
                        });
                    // Anno Domini, Before Christ
                    case "GGGG":
                    default:
                        return match.era(dateString, {
                            width: "wide"
                        }) || match.era(dateString, {
                            width: "abbreviated"
                        }) || match.era(dateString, {
                            width: "narrow"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                flags.era = value;
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return EraParser;
}((0, $dVUCv.Parser));

});
parcelRegister("dVUCv", function(module, exports) {

$parcel$export(module.exports, "Parser", () => $a24c84ce3b2e818f$export$7acfa6ed01010e37);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $kSlfw = parcelRequire("kSlfw");

var $d6B4A = parcelRequire("d6B4A");
var $a24c84ce3b2e818f$export$7acfa6ed01010e37 = /*#__PURE__*/ function() {
    function Parser() {
        (0, $6CZeq.default)(this, Parser);
        (0, $kSlfw.default)(this, "incompatibleTokens", void 0);
        (0, $kSlfw.default)(this, "priority", void 0);
        (0, $kSlfw.default)(this, "subPriority", void 0);
    }
    (0, $cHPF9.default)(Parser, [
        {
            key: "run",
            value: function run(dateString, token, match, options) {
                var result = this.parse(dateString, token, match, options);
                if (!result) return null;
                return {
                    setter: new (0, $d6B4A.ValueSetter)(result.value, this.validate, this.set, this.priority, this.subPriority),
                    rest: result.rest
                };
            }
        },
        {
            key: "validate",
            value: function validate(_utcDate, _value, _options) {
                return true;
            }
        }
    ]);
    return Parser;
}();

});


parcelRegister("a8eKR", function(module, exports) {

$parcel$export(module.exports, "YearParser", () => $760618bd8dde9a2e$export$48d352de7cd4a988);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $XhBEN = parcelRequire("XhBEN");
var $760618bd8dde9a2e$export$48d352de7cd4a988 = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(YearParser, _Parser);
    var _super = (0, $enfmq.default)(YearParser);
    function YearParser() {
        var _this;
        (0, $6CZeq.default)(this, YearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 130);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "u",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(YearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === "yy"
                    };
                };
                switch(token){
                    case "y":
                        return (0, $XhBEN.mapValue)((0, $XhBEN.parseNDigits)(4, dateString), valueCallback);
                    case "yo":
                        return (0, $XhBEN.mapValue)(match.ordinalNumber(dateString, {
                            unit: "year"
                        }), valueCallback);
                    default:
                        return (0, $XhBEN.mapValue)((0, $XhBEN.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                var currentYear = date.getUTCFullYear();
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $XhBEN.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
                    date.setUTCHours(0, 0, 0, 0);
                    return date;
                }
                var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return YearParser;
}((0, $dVUCv.Parser));

});
parcelRegister("XhBEN", function(module, exports) {

$parcel$export(module.exports, "mapValue", () => $0b232b0fb2037abb$export$4f84e3a82c7b538);
$parcel$export(module.exports, "parseNumericPattern", () => $0b232b0fb2037abb$export$cc7cc9e2a3ff9388);
$parcel$export(module.exports, "parseTimezonePattern", () => $0b232b0fb2037abb$export$6497f4c0ecdfba8e);
$parcel$export(module.exports, "parseAnyDigitsSigned", () => $0b232b0fb2037abb$export$d931c43c4608a164);
$parcel$export(module.exports, "parseNDigits", () => $0b232b0fb2037abb$export$513bb01536146ab6);
$parcel$export(module.exports, "parseNDigitsSigned", () => $0b232b0fb2037abb$export$2c9307b2e29c533c);
$parcel$export(module.exports, "dayPeriodEnumToHours", () => $0b232b0fb2037abb$export$fb506d2676e7f207);
$parcel$export(module.exports, "normalizeTwoDigitYear", () => $0b232b0fb2037abb$export$29126f735cbf69f7);
$parcel$export(module.exports, "isLeapYearIndex", () => $0b232b0fb2037abb$export$3d50627710b84d75);

var $6Q3SV = parcelRequire("6Q3SV");

var $629aZ = parcelRequire("629aZ");
function $0b232b0fb2037abb$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $0b232b0fb2037abb$export$cc7cc9e2a3ff9388(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $0b232b0fb2037abb$export$6497f4c0ecdfba8e(pattern, dateString) {
    var matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    var sign = matchResult[1] === "+" ? 1 : -1;
    var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $6Q3SV.millisecondsInHour) + minutes * (0, $6Q3SV.millisecondsInMinute) + seconds * (0, $6Q3SV.millisecondsInSecond)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $0b232b0fb2037abb$export$d931c43c4608a164(dateString) {
    return $0b232b0fb2037abb$export$cc7cc9e2a3ff9388((0, $629aZ.numericPatterns).anyDigitsSigned, dateString);
}
function $0b232b0fb2037abb$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $0b232b0fb2037abb$export$cc7cc9e2a3ff9388((0, $629aZ.numericPatterns).singleDigit, dateString);
        case 2:
            return $0b232b0fb2037abb$export$cc7cc9e2a3ff9388((0, $629aZ.numericPatterns).twoDigits, dateString);
        case 3:
            return $0b232b0fb2037abb$export$cc7cc9e2a3ff9388((0, $629aZ.numericPatterns).threeDigits, dateString);
        case 4:
            return $0b232b0fb2037abb$export$cc7cc9e2a3ff9388((0, $629aZ.numericPatterns).fourDigits, dateString);
        default:
            return $0b232b0fb2037abb$export$cc7cc9e2a3ff9388(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function $0b232b0fb2037abb$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $0b232b0fb2037abb$export$cc7cc9e2a3ff9388((0, $629aZ.numericPatterns).singleDigitSigned, dateString);
        case 2:
            return $0b232b0fb2037abb$export$cc7cc9e2a3ff9388((0, $629aZ.numericPatterns).twoDigitsSigned, dateString);
        case 3:
            return $0b232b0fb2037abb$export$cc7cc9e2a3ff9388((0, $629aZ.numericPatterns).threeDigitsSigned, dateString);
        case 4:
            return $0b232b0fb2037abb$export$cc7cc9e2a3ff9388((0, $629aZ.numericPatterns).fourDigitsSigned, dateString);
        default:
            return $0b232b0fb2037abb$export$cc7cc9e2a3ff9388(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function $0b232b0fb2037abb$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function $0b232b0fb2037abb$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    var isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    var result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        var rangeEnd = absCurrentYear + 50;
        var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
        var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $0b232b0fb2037abb$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

});
parcelRegister("6Q3SV", function(module, exports) {

$parcel$export(module.exports, "millisecondsInMinute", () => $4faa9cd956e257dc$export$91246f0b9bd9beff);
$parcel$export(module.exports, "millisecondsInHour", () => $4faa9cd956e257dc$export$7f72910d6dfd237a);
$parcel$export(module.exports, "millisecondsInSecond", () => $4faa9cd956e257dc$export$397c2d5776aa9055);
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */ var $4faa9cd956e257dc$export$dfd9b671c89acc8e = 7;
var $4faa9cd956e257dc$export$3913210603d8e9ae = 365.2425;
var $4faa9cd956e257dc$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
var $4faa9cd956e257dc$export$91246f0b9bd9beff = 60000;
var $4faa9cd956e257dc$export$7f72910d6dfd237a = 3600000;
var $4faa9cd956e257dc$export$397c2d5776aa9055 = 1000;
var $4faa9cd956e257dc$export$4dec998e48f9c246 = -$4faa9cd956e257dc$export$81caae6e1cc7a622;
var $4faa9cd956e257dc$export$f2f5ae5a8e2d8f9f = 60;
var $4faa9cd956e257dc$export$3c58128db900d44e = 3;
var $4faa9cd956e257dc$export$80d7e435f744f319 = 12;
var $4faa9cd956e257dc$export$4db7641526e3241f = 4;
var $4faa9cd956e257dc$export$698aec755e92c695 = 3600;
var $4faa9cd956e257dc$export$a77c1a7ebebe2a5a = 60;
var $4faa9cd956e257dc$export$815a9362476d2fe3 = $4faa9cd956e257dc$export$698aec755e92c695 * 24;
var $4faa9cd956e257dc$export$34804a017b31e2fe = $4faa9cd956e257dc$export$815a9362476d2fe3 * 7;
var $4faa9cd956e257dc$export$7271e9e3478110d1 = $4faa9cd956e257dc$export$815a9362476d2fe3 * $4faa9cd956e257dc$export$3913210603d8e9ae;
var $4faa9cd956e257dc$export$8e6600bbdee7dabb = $4faa9cd956e257dc$export$7271e9e3478110d1 / 12;
var $4faa9cd956e257dc$export$be1dccf2de902d31 = $4faa9cd956e257dc$export$8e6600bbdee7dabb * 3;

});

parcelRegister("629aZ", function(module, exports) {

$parcel$export(module.exports, "numericPatterns", () => $464a0c2b40e7950e$export$c123ee06d9da8480);
$parcel$export(module.exports, "timezonePatterns", () => $464a0c2b40e7950e$export$a7ee192b982af9c1);
var $464a0c2b40e7950e$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    // 0 to 12
    date: /^(3[0-1]|[0-2]?\d)/,
    // 0 to 31
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    // 0 to 366
    week: /^(5[0-3]|[0-4]?\d)/,
    // 0 to 53
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    // 0 to 23
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    // 0 to 24
    hour11h: /^(1[0-1]|0?\d)/,
    // 0 to 11
    hour12h: /^(1[0-2]|0?\d)/,
    // 0 to 12
    minute: /^[0-5]?\d/,
    // 0 to 59
    second: /^[0-5]?\d/,
    // 0 to 59
    singleDigit: /^\d/,
    // 0 to 9
    twoDigits: /^\d{1,2}/,
    // 0 to 99
    threeDigits: /^\d{1,3}/,
    // 0 to 999
    fourDigits: /^\d{1,4}/,
    // 0 to 9999
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    // 0 to 9, -0 to -9
    twoDigitsSigned: /^-?\d{1,2}/,
    // 0 to 99, -0 to -99
    threeDigitsSigned: /^-?\d{1,3}/,
    // 0 to 999, -0 to -999
    fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};
var $464a0c2b40e7950e$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

});



parcelRegister("fj1li", function(module, exports) {

$parcel$export(module.exports, "LocalWeekYearParser", () => $b249abf1c76e715b$export$b8ef38dfcf05d5db);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $XhBEN = parcelRequire("XhBEN");

var $kB1VM = parcelRequire("kB1VM");

var $1cqVL = parcelRequire("1cqVL");
var $b249abf1c76e715b$export$b8ef38dfcf05d5db = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(LocalWeekYearParser, _Parser);
    var _super = (0, $enfmq.default)(LocalWeekYearParser);
    function LocalWeekYearParser() {
        var _this;
        (0, $6CZeq.default)(this, LocalWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 130);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(LocalWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(year) {
                    return {
                        year: year,
                        isTwoDigitYear: token === "YY"
                    };
                };
                switch(token){
                    case "Y":
                        return (0, $XhBEN.mapValue)((0, $XhBEN.parseNDigits)(4, dateString), valueCallback);
                    case "Yo":
                        return (0, $XhBEN.mapValue)(match.ordinalNumber(dateString, {
                            unit: "year"
                        }), valueCallback);
                    default:
                        return (0, $XhBEN.mapValue)((0, $XhBEN.parseNDigits)(token.length, dateString), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value.isTwoDigitYear || value.year > 0;
            }
        },
        {
            key: "set",
            value: function set(date, flags, value, options) {
                var currentYear = (0, $kB1VM.default)(date, options);
                if (value.isTwoDigitYear) {
                    var normalizedTwoDigitYear = (0, $XhBEN.normalizeTwoDigitYear)(value.year, currentYear);
                    date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
                    date.setUTCHours(0, 0, 0, 0);
                    return (0, $1cqVL.default)(date, options);
                }
                var year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
                date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
                date.setUTCHours(0, 0, 0, 0);
                return (0, $1cqVL.default)(date, options);
            }
        }
    ]);
    return LocalWeekYearParser;
}((0, $dVUCv.Parser));

});

parcelRegister("44HZq", function(module, exports) {

$parcel$export(module.exports, "ISOWeekYearParser", () => $2f79a8958a9b0819$export$951d1df011fde06f);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $XhBEN = parcelRequire("XhBEN");

var $bY8nB = parcelRequire("bY8nB");
var $2f79a8958a9b0819$export$951d1df011fde06f = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(ISOWeekYearParser, _Parser);
    var _super = (0, $enfmq.default)(ISOWeekYearParser);
    function ISOWeekYearParser() {
        var _this;
        (0, $6CZeq.default)(this, ISOWeekYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 130);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(ISOWeekYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === "R") return (0, $XhBEN.parseNDigitsSigned)(4, dateString);
                return (0, $XhBEN.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                var firstWeekOfYear = new Date(0);
                firstWeekOfYear.setUTCFullYear(value, 0, 4);
                firstWeekOfYear.setUTCHours(0, 0, 0, 0);
                return (0, $bY8nB.default)(firstWeekOfYear);
            }
        }
    ]);
    return ISOWeekYearParser;
}((0, $dVUCv.Parser));

});

parcelRegister("fwa91", function(module, exports) {

$parcel$export(module.exports, "ExtendedYearParser", () => $b4c1b6ab03bfe94f$export$bad9d2ea38e8f1a);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $XhBEN = parcelRequire("XhBEN");
var $b4c1b6ab03bfe94f$export$bad9d2ea38e8f1a = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(ExtendedYearParser, _Parser);
    var _super = (0, $enfmq.default)(ExtendedYearParser);
    function ExtendedYearParser() {
        var _this;
        (0, $6CZeq.default)(this, ExtendedYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 130);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "R",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(ExtendedYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                if (token === "u") return (0, $XhBEN.parseNDigitsSigned)(4, dateString);
                return (0, $XhBEN.parseNDigitsSigned)(token.length, dateString);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCFullYear(value, 0, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ExtendedYearParser;
}((0, $dVUCv.Parser));

});

parcelRegister("dt2Qm", function(module, exports) {

$parcel$export(module.exports, "QuarterParser", () => $9ce0307b40bcf431$export$5cb0f701186dde1d);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $XhBEN = parcelRequire("XhBEN");
var $9ce0307b40bcf431$export$5cb0f701186dde1d = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(QuarterParser, _Parser);
    var _super = (0, $enfmq.default)(QuarterParser);
    function QuarterParser() {
        var _this;
        (0, $6CZeq.default)(this, QuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 120);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(QuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case "Q":
                    case "QQ":
                        // 01, 02, 03, 04
                        return (0, $XhBEN.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case "Qo":
                        return match.ordinalNumber(dateString, {
                            unit: "quarter"
                        });
                    // Q1, Q2, Q3, Q4
                    case "QQQ":
                        return match.quarter(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case "QQQQQ":
                        return match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // 1st quarter, 2nd quarter, ...
                    case "QQQQ":
                    default:
                        return match.quarter(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return QuarterParser;
}((0, $dVUCv.Parser));

});

parcelRegister("dOVGV", function(module, exports) {

$parcel$export(module.exports, "StandAloneQuarterParser", () => $a0fcb22d028fbb12$export$300c0c2990e20e6d);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $XhBEN = parcelRequire("XhBEN");
var $a0fcb22d028fbb12$export$300c0c2990e20e6d = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(StandAloneQuarterParser, _Parser);
    var _super = (0, $enfmq.default)(StandAloneQuarterParser);
    function StandAloneQuarterParser() {
        var _this;
        (0, $6CZeq.default)(this, StandAloneQuarterParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 120);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(StandAloneQuarterParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // 1, 2, 3, 4
                    case "q":
                    case "qq":
                        // 01, 02, 03, 04
                        return (0, $XhBEN.parseNDigits)(token.length, dateString);
                    // 1st, 2nd, 3rd, 4th
                    case "qo":
                        return match.ordinalNumber(dateString, {
                            unit: "quarter"
                        });
                    // Q1, Q2, Q3, Q4
                    case "qqq":
                        return match.quarter(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // 1, 2, 3, 4 (narrow quarter; could be not numerical)
                    case "qqqqq":
                        return match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // 1st quarter, 2nd quarter, ...
                    case "qqqq":
                    default:
                        return match.quarter(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.quarter(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 4;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth((value - 1) * 3, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneQuarterParser;
}((0, $dVUCv.Parser));

});

parcelRegister("7o7jr", function(module, exports) {

$parcel$export(module.exports, "MonthParser", () => $5610726e2a84c5bb$export$400dd8b40ef138a3);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $XhBEN = parcelRequire("XhBEN");

var $dVUCv = parcelRequire("dVUCv");

var $629aZ = parcelRequire("629aZ");
var $5610726e2a84c5bb$export$400dd8b40ef138a3 = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(MonthParser, _Parser);
    var _super = (0, $enfmq.default)(MonthParser);
    function MonthParser() {
        var _this;
        (0, $6CZeq.default)(this, MonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "L",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 110);
        return _this;
    }
    (0, $cHPF9.default)(MonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case "M":
                        return (0, $XhBEN.mapValue)((0, $XhBEN.parseNumericPattern)((0, $629aZ.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case "MM":
                        return (0, $XhBEN.mapValue)((0, $XhBEN.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case "Mo":
                        return (0, $XhBEN.mapValue)(match.ordinalNumber(dateString, {
                            unit: "month"
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case "MMM":
                        return match.month(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // J, F, ..., D
                    case "MMMMM":
                        return match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // January, February, ..., December
                    case "MMMM":
                    default:
                        return match.month(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return MonthParser;
}((0, $dVUCv.Parser));

});

parcelRegister("8dk1W", function(module, exports) {

$parcel$export(module.exports, "StandAloneMonthParser", () => $5faf133932f8fa0d$export$1d7eaa53eaa5deba);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $629aZ = parcelRequire("629aZ");

var $XhBEN = parcelRequire("XhBEN");
var $5faf133932f8fa0d$export$1d7eaa53eaa5deba = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(StandAloneMonthParser, _Parser);
    var _super = (0, $enfmq.default)(StandAloneMonthParser);
    function StandAloneMonthParser() {
        var _this;
        (0, $6CZeq.default)(this, StandAloneMonthParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 110);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(StandAloneMonthParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    return value - 1;
                };
                switch(token){
                    // 1, 2, ..., 12
                    case "L":
                        return (0, $XhBEN.mapValue)((0, $XhBEN.parseNumericPattern)((0, $629aZ.numericPatterns).month, dateString), valueCallback);
                    // 01, 02, ..., 12
                    case "LL":
                        return (0, $XhBEN.mapValue)((0, $XhBEN.parseNDigits)(2, dateString), valueCallback);
                    // 1st, 2nd, ..., 12th
                    case "Lo":
                        return (0, $XhBEN.mapValue)(match.ordinalNumber(dateString, {
                            unit: "month"
                        }), valueCallback);
                    // Jan, Feb, ..., Dec
                    case "LLL":
                        return match.month(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // J, F, ..., D
                    case "LLLLL":
                        return match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // January, February, ..., December
                    case "LLLL":
                    default:
                        return match.month(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.month(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(value, 1);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneMonthParser;
}((0, $dVUCv.Parser));

});

parcelRegister("hW0pX", function(module, exports) {

$parcel$export(module.exports, "LocalWeekParser", () => $d0e82d5cf6f5412c$export$c4005ffc174e07c0);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $629aZ = parcelRequire("629aZ");

var $XhBEN = parcelRequire("XhBEN");

var $aj6ZU = parcelRequire("aj6ZU");

var $1cqVL = parcelRequire("1cqVL");
var $d0e82d5cf6f5412c$export$c4005ffc174e07c0 = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(LocalWeekParser, _Parser);
    var _super = (0, $enfmq.default)(LocalWeekParser);
    function LocalWeekParser() {
        var _this;
        (0, $6CZeq.default)(this, LocalWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 100);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(LocalWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "w":
                        return (0, $XhBEN.parseNumericPattern)((0, $629aZ.numericPatterns).week, dateString);
                    case "wo":
                        return match.ordinalNumber(dateString, {
                            unit: "week"
                        });
                    default:
                        return (0, $XhBEN.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                return (0, $1cqVL.default)((0, $aj6ZU.default)(date, value, options), options);
            }
        }
    ]);
    return LocalWeekParser;
}((0, $dVUCv.Parser));

});
parcelRegister("aj6ZU", function(module, exports) {

$parcel$export(module.exports, "default", () => $78111b508c05f859$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $gdr0J = parcelRequire("gdr0J");

var $gTlfB = parcelRequire("gTlfB");

var $4LmDH = parcelRequire("4LmDH");
function $78111b508c05f859$export$2e2bcd8739ae039(dirtyDate, dirtyWeek, options) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var week = (0, $esGEx.default)(dirtyWeek);
    var diff = (0, $gTlfB.default)(date, options) - week;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});


parcelRegister("anGh5", function(module, exports) {

$parcel$export(module.exports, "ISOWeekParser", () => $01f34dcf5c011194$export$6fc8dbedd560a6af);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $629aZ = parcelRequire("629aZ");

var $XhBEN = parcelRequire("XhBEN");

var $jIUvX = parcelRequire("jIUvX");

var $bY8nB = parcelRequire("bY8nB");
var $01f34dcf5c011194$export$6fc8dbedd560a6af = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(ISOWeekParser, _Parser);
    var _super = (0, $enfmq.default)(ISOWeekParser);
    function ISOWeekParser() {
        var _this;
        (0, $6CZeq.default)(this, ISOWeekParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 100);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(ISOWeekParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "I":
                        return (0, $XhBEN.parseNumericPattern)((0, $629aZ.numericPatterns).week, dateString);
                    case "Io":
                        return match.ordinalNumber(dateString, {
                            unit: "week"
                        });
                    default:
                        return (0, $XhBEN.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 53;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                return (0, $bY8nB.default)((0, $jIUvX.default)(date, value));
            }
        }
    ]);
    return ISOWeekParser;
}((0, $dVUCv.Parser));

});
parcelRegister("jIUvX", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5bdf6fda1ca18fd$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $gdr0J = parcelRequire("gdr0J");

var $jsJZZ = parcelRequire("jsJZZ");

var $4LmDH = parcelRequire("4LmDH");
function $e5bdf6fda1ca18fd$export$2e2bcd8739ae039(dirtyDate, dirtyISOWeek) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var isoWeek = (0, $esGEx.default)(dirtyISOWeek);
    var diff = (0, $jsJZZ.default)(date) - isoWeek;
    date.setUTCDate(date.getUTCDate() - diff * 7);
    return date;
}

});


parcelRegister("cjr07", function(module, exports) {

$parcel$export(module.exports, "DateParser", () => $8f6c3433250540ef$export$e8d4b28a20981dd2);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $XhBEN = parcelRequire("XhBEN");

var $dVUCv = parcelRequire("dVUCv");

var $629aZ = parcelRequire("629aZ");
var $8f6c3433250540ef$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $8f6c3433250540ef$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $8f6c3433250540ef$export$e8d4b28a20981dd2 = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(DateParser, _Parser);
    var _super = (0, $enfmq.default)(DateParser);
    function DateParser() {
        var _this;
        (0, $6CZeq.default)(this, DateParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 90);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "subPriority", 1);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(DateParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "d":
                        return (0, $XhBEN.parseNumericPattern)((0, $629aZ.numericPatterns).date, dateString);
                    case "do":
                        return match.ordinalNumber(dateString, {
                            unit: "date"
                        });
                    default:
                        return (0, $XhBEN.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $XhBEN.isLeapYearIndex)(year);
                var month = date.getUTCMonth();
                if (isLeapYear) return value >= 1 && value <= $8f6c3433250540ef$var$DAYS_IN_MONTH_LEAP_YEAR[month];
                else return value >= 1 && value <= $8f6c3433250540ef$var$DAYS_IN_MONTH[month];
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCDate(value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DateParser;
}((0, $dVUCv.Parser));

});

parcelRegister("mnuhN", function(module, exports) {

$parcel$export(module.exports, "DayOfYearParser", () => $0434465071b161c2$export$6cfe0d613455f615);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $629aZ = parcelRequire("629aZ");

var $XhBEN = parcelRequire("XhBEN");
var $0434465071b161c2$export$6cfe0d613455f615 = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(DayOfYearParser, _Parser);
    var _super = (0, $enfmq.default)(DayOfYearParser);
    function DayOfYearParser() {
        var _this;
        (0, $6CZeq.default)(this, DayOfYearParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 90);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "subpriority", 1);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "E",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(DayOfYearParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "D":
                    case "DD":
                        return (0, $XhBEN.parseNumericPattern)((0, $629aZ.numericPatterns).dayOfYear, dateString);
                    case "Do":
                        return match.ordinalNumber(dateString, {
                            unit: "date"
                        });
                    default:
                        return (0, $XhBEN.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(date, value) {
                var year = date.getUTCFullYear();
                var isLeapYear = (0, $XhBEN.isLeapYearIndex)(year);
                if (isLeapYear) return value >= 1 && value <= 366;
                else return value >= 1 && value <= 365;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMonth(0, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayOfYearParser;
}((0, $dVUCv.Parser));

});

parcelRegister("gqUjS", function(module, exports) {

$parcel$export(module.exports, "DayParser", () => $bf6ac2f87af55cf1$export$1b03c8b76262f7bd);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $hCHMu = parcelRequire("hCHMu");
var $bf6ac2f87af55cf1$export$1b03c8b76262f7bd = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(DayParser, _Parser);
    var _super = (0, $enfmq.default)(DayParser);
    function DayParser() {
        var _this;
        (0, $6CZeq.default)(this, DayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 90);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(DayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    // Tue
                    case "E":
                    case "EE":
                    case "EEE":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // T
                    case "EEEEE":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tu
                    case "EEEEEE":
                        return match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tuesday
                    case "EEEE":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $hCHMu.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayParser;
}((0, $dVUCv.Parser));

});
parcelRegister("hCHMu", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd47f247bdfd58ed$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");

var $esGEx = parcelRequire("esGEx");

var $2GvpZ = parcelRequire("2GvpZ");
function $cd47f247bdfd58ed$export$2e2bcd8739ae039(dirtyDate, dirtyDay, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $4LmDH.default)(2, arguments);
    var defaultOptions = (0, $2GvpZ.getDefaultOptions)();
    var weekStartsOn = (0, $esGEx.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);
    // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $gdr0J.default)(dirtyDate);
    var day = (0, $esGEx.default)(dirtyDay);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});


parcelRegister("eglEX", function(module, exports) {

$parcel$export(module.exports, "LocalDayParser", () => $a6235c79c7d2d223$export$44d1c127ab42c480);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $XhBEN = parcelRequire("XhBEN");

var $hCHMu = parcelRequire("hCHMu");
var $a6235c79c7d2d223$export$44d1c127ab42c480 = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(LocalDayParser, _Parser);
    var _super = (0, $enfmq.default)(LocalDayParser);
    function LocalDayParser() {
        var _this;
        (0, $6CZeq.default)(this, LocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 90);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(LocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case "e":
                    case "ee":
                        // 03
                        return (0, $XhBEN.mapValue)((0, $XhBEN.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case "eo":
                        return (0, $XhBEN.mapValue)(match.ordinalNumber(dateString, {
                            unit: "day"
                        }), valueCallback);
                    // Tue
                    case "eee":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // T
                    case "eeeee":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tu
                    case "eeeeee":
                        return match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    // Tuesday
                    case "eeee":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $hCHMu.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return LocalDayParser;
}((0, $dVUCv.Parser));

});

parcelRegister("7jfsL", function(module, exports) {

$parcel$export(module.exports, "StandAloneLocalDayParser", () => $55264d63d00b69b4$export$e447a647caaaec1d);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $XhBEN = parcelRequire("XhBEN");

var $hCHMu = parcelRequire("hCHMu");
var $55264d63d00b69b4$export$e447a647caaaec1d = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(StandAloneLocalDayParser, _Parser);
    var _super = (0, $enfmq.default)(StandAloneLocalDayParser);
    function StandAloneLocalDayParser() {
        var _this;
        (0, $6CZeq.default)(this, StandAloneLocalDayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 90);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "e",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(StandAloneLocalDayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match, options) {
                var valueCallback = function valueCallback(value) {
                    var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
                    return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
                };
                switch(token){
                    // 3
                    case "c":
                    case "cc":
                        // 03
                        return (0, $XhBEN.mapValue)((0, $XhBEN.parseNDigits)(token.length, dateString), valueCallback);
                    // 3rd
                    case "co":
                        return (0, $XhBEN.mapValue)(match.ordinalNumber(dateString, {
                            unit: "day"
                        }), valueCallback);
                    // Tue
                    case "ccc":
                        return match.day(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // T
                    case "ccccc":
                        return match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // Tu
                    case "cccccc":
                        return match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                    // Tuesday
                    case "cccc":
                    default:
                        return match.day(dateString, {
                            width: "wide",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "standalone"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "standalone"
                        });
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 6;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value, options) {
                date = (0, $hCHMu.default)(date, value, options);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return StandAloneLocalDayParser;
}((0, $dVUCv.Parser));

});

parcelRegister("7ANJo", function(module, exports) {

$parcel$export(module.exports, "ISODayParser", () => $587278c8279e961b$export$693fb1e525095b2a);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $XhBEN = parcelRequire("XhBEN");

var $ay6wS = parcelRequire("ay6wS");
var $587278c8279e961b$export$693fb1e525095b2a = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(ISODayParser, _Parser);
    var _super = (0, $enfmq.default)(ISODayParser);
    function ISODayParser() {
        var _this;
        (0, $6CZeq.default)(this, ISODayParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 90);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "E",
            "e",
            "c",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(ISODayParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                var valueCallback = function valueCallback(value) {
                    if (value === 0) return 7;
                    return value;
                };
                switch(token){
                    // 2
                    case "i":
                    case "ii":
                        // 02
                        return (0, $XhBEN.parseNDigits)(token.length, dateString);
                    // 2nd
                    case "io":
                        return match.ordinalNumber(dateString, {
                            unit: "day"
                        });
                    // Tue
                    case "iii":
                        return (0, $XhBEN.mapValue)(match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // T
                    case "iiiii":
                        return (0, $XhBEN.mapValue)(match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // Tu
                    case "iiiiii":
                        return (0, $XhBEN.mapValue)(match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                    // Tuesday
                    case "iiii":
                    default:
                        return (0, $XhBEN.mapValue)(match.day(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "short",
                            context: "formatting"
                        }) || match.day(dateString, {
                            width: "narrow",
                            context: "formatting"
                        }), valueCallback);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 7;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date = (0, $ay6wS.default)(date, value);
                date.setUTCHours(0, 0, 0, 0);
                return date;
            }
        }
    ]);
    return ISODayParser;
}((0, $dVUCv.Parser));

});
parcelRegister("ay6wS", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ae224ed93d5e7cb$export$2e2bcd8739ae039);

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");

var $esGEx = parcelRequire("esGEx");
function $7ae224ed93d5e7cb$export$2e2bcd8739ae039(dirtyDate, dirtyDay) {
    (0, $4LmDH.default)(2, arguments);
    var day = (0, $esGEx.default)(dirtyDay);
    if (day % 7 === 0) day = day - 7;
    var weekStartsOn = 1;
    var date = (0, $gdr0J.default)(dirtyDate);
    var currentDay = date.getUTCDay();
    var remainder = day % 7;
    var dayIndex = (remainder + 7) % 7;
    var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}

});


parcelRegister("bUyT3", function(module, exports) {

$parcel$export(module.exports, "AMPMParser", () => $8abffc7926620950$export$8d1e08492351df91);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $XhBEN = parcelRequire("XhBEN");
var $8abffc7926620950$export$8d1e08492351df91 = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(AMPMParser, _Parser);
    var _super = (0, $enfmq.default)(AMPMParser);
    function AMPMParser() {
        var _this;
        (0, $6CZeq.default)(this, AMPMParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 80);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "b",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(AMPMParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "a":
                    case "aa":
                    case "aaa":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "aaaaa":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "aaaa":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $XhBEN.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMParser;
}((0, $dVUCv.Parser));

});

parcelRegister("jYJCf", function(module, exports) {

$parcel$export(module.exports, "AMPMMidnightParser", () => $e8b7014308632edf$export$73ca2bd0a17d273);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $XhBEN = parcelRequire("XhBEN");
var $e8b7014308632edf$export$73ca2bd0a17d273 = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(AMPMMidnightParser, _Parser);
    var _super = (0, $enfmq.default)(AMPMMidnightParser);
    function AMPMMidnightParser() {
        var _this;
        (0, $6CZeq.default)(this, AMPMMidnightParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 80);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "a",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(AMPMMidnightParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "b":
                    case "bb":
                    case "bbb":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "bbbbb":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "bbbb":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $XhBEN.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return AMPMMidnightParser;
}((0, $dVUCv.Parser));

});

parcelRegister("7q5qq", function(module, exports) {

$parcel$export(module.exports, "DayPeriodParser", () => $566f2b76640556a4$export$bb9212adf05373db);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $XhBEN = parcelRequire("XhBEN");
var $566f2b76640556a4$export$bb9212adf05373db = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(DayPeriodParser, _Parser);
    var _super = (0, $enfmq.default)(DayPeriodParser);
    function DayPeriodParser() {
        var _this;
        (0, $6CZeq.default)(this, DayPeriodParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 80);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "a",
            "b",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(DayPeriodParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "B":
                    case "BB":
                    case "BBB":
                        return match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "BBBBB":
                        return match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                    case "BBBB":
                    default:
                        return match.dayPeriod(dateString, {
                            width: "wide",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "abbreviated",
                            context: "formatting"
                        }) || match.dayPeriod(dateString, {
                            width: "narrow",
                            context: "formatting"
                        });
                }
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours((0, $XhBEN.dayPeriodEnumToHours)(value), 0, 0, 0);
                return date;
            }
        }
    ]);
    return DayPeriodParser;
}((0, $dVUCv.Parser));

});

parcelRegister("2ashg", function(module, exports) {

$parcel$export(module.exports, "Hour1to12Parser", () => $1942733da4af1ace$export$8a04050a727a1756);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $629aZ = parcelRequire("629aZ");

var $XhBEN = parcelRequire("XhBEN");
var $1942733da4af1ace$export$8a04050a727a1756 = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(Hour1to12Parser, _Parser);
    var _super = (0, $enfmq.default)(Hour1to12Parser);
    function Hour1to12Parser() {
        var _this;
        (0, $6CZeq.default)(this, Hour1to12Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 70);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "H",
            "K",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(Hour1to12Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "h":
                        return (0, $XhBEN.parseNumericPattern)((0, $629aZ.numericPatterns).hour12h, dateString);
                    case "ho":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $XhBEN.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 12;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else if (!isPM && value === 12) date.setUTCHours(0, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1to12Parser;
}((0, $dVUCv.Parser));

});

parcelRegister("fGBwT", function(module, exports) {

$parcel$export(module.exports, "Hour0to23Parser", () => $b6b7e3dd27c7b193$export$e56f4dea2c3e56dd);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $629aZ = parcelRequire("629aZ");

var $XhBEN = parcelRequire("XhBEN");
var $b6b7e3dd27c7b193$export$e56f4dea2c3e56dd = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(Hour0to23Parser, _Parser);
    var _super = (0, $enfmq.default)(Hour0to23Parser);
    function Hour0to23Parser() {
        var _this;
        (0, $6CZeq.default)(this, Hour0to23Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 70);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "a",
            "b",
            "h",
            "K",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(Hour0to23Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "H":
                        return (0, $XhBEN.parseNumericPattern)((0, $629aZ.numericPatterns).hour23h, dateString);
                    case "Ho":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $XhBEN.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 23;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0to23Parser;
}((0, $dVUCv.Parser));

});

parcelRegister("1ZCjh", function(module, exports) {

$parcel$export(module.exports, "Hour0To11Parser", () => $1739347ee422fc25$export$cbbe855312f87d77);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $629aZ = parcelRequire("629aZ");

var $XhBEN = parcelRequire("XhBEN");
var $1739347ee422fc25$export$cbbe855312f87d77 = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(Hour0To11Parser, _Parser);
    var _super = (0, $enfmq.default)(Hour0To11Parser);
    function Hour0To11Parser() {
        var _this;
        (0, $6CZeq.default)(this, Hour0To11Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 70);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "h",
            "H",
            "k",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(Hour0To11Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "K":
                        return (0, $XhBEN.parseNumericPattern)((0, $629aZ.numericPatterns).hour11h, dateString);
                    case "Ko":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $XhBEN.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 11;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var isPM = date.getUTCHours() >= 12;
                if (isPM && value < 12) date.setUTCHours(value + 12, 0, 0, 0);
                else date.setUTCHours(value, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour0To11Parser;
}((0, $dVUCv.Parser));

});

parcelRegister("8I45K", function(module, exports) {

$parcel$export(module.exports, "Hour1To24Parser", () => $65759b4c9622f058$export$6008046d2b34b6a5);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $629aZ = parcelRequire("629aZ");

var $XhBEN = parcelRequire("XhBEN");
var $65759b4c9622f058$export$6008046d2b34b6a5 = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(Hour1To24Parser, _Parser);
    var _super = (0, $enfmq.default)(Hour1To24Parser);
    function Hour1To24Parser() {
        var _this;
        (0, $6CZeq.default)(this, Hour1To24Parser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 70);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "a",
            "b",
            "h",
            "H",
            "K",
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(Hour1To24Parser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "k":
                        return (0, $XhBEN.parseNumericPattern)((0, $629aZ.numericPatterns).hour24h, dateString);
                    case "ko":
                        return match.ordinalNumber(dateString, {
                            unit: "hour"
                        });
                    default:
                        return (0, $XhBEN.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 1 && value <= 24;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                var hours = value <= 24 ? value % 24 : value;
                date.setUTCHours(hours, 0, 0, 0);
                return date;
            }
        }
    ]);
    return Hour1To24Parser;
}((0, $dVUCv.Parser));

});

parcelRegister("ajDAU", function(module, exports) {

$parcel$export(module.exports, "MinuteParser", () => $782a6455ff67a7ae$export$2b52670d9e2be53);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $629aZ = parcelRequire("629aZ");

var $XhBEN = parcelRequire("XhBEN");
var $782a6455ff67a7ae$export$2b52670d9e2be53 = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(MinuteParser, _Parser);
    var _super = (0, $enfmq.default)(MinuteParser);
    function MinuteParser() {
        var _this;
        (0, $6CZeq.default)(this, MinuteParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 60);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(MinuteParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "m":
                        return (0, $XhBEN.parseNumericPattern)((0, $629aZ.numericPatterns).minute, dateString);
                    case "mo":
                        return match.ordinalNumber(dateString, {
                            unit: "minute"
                        });
                    default:
                        return (0, $XhBEN.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMinutes(value, 0, 0);
                return date;
            }
        }
    ]);
    return MinuteParser;
}((0, $dVUCv.Parser));

});

parcelRegister("9fJ56", function(module, exports) {

$parcel$export(module.exports, "SecondParser", () => $6bc87bf726e3a9ef$export$94d46d540cf1366a);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $629aZ = parcelRequire("629aZ");

var $XhBEN = parcelRequire("XhBEN");
var $6bc87bf726e3a9ef$export$94d46d540cf1366a = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(SecondParser, _Parser);
    var _super = (0, $enfmq.default)(SecondParser);
    function SecondParser() {
        var _this;
        (0, $6CZeq.default)(this, SecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 50);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(SecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token, match) {
                switch(token){
                    case "s":
                        return (0, $XhBEN.parseNumericPattern)((0, $629aZ.numericPatterns).second, dateString);
                    case "so":
                        return match.ordinalNumber(dateString, {
                            unit: "second"
                        });
                    default:
                        return (0, $XhBEN.parseNDigits)(token.length, dateString);
                }
            }
        },
        {
            key: "validate",
            value: function validate(_date, value) {
                return value >= 0 && value <= 59;
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCSeconds(value, 0);
                return date;
            }
        }
    ]);
    return SecondParser;
}((0, $dVUCv.Parser));

});

parcelRegister("1If4X", function(module, exports) {

$parcel$export(module.exports, "FractionOfSecondParser", () => $13f598d9d9f39eef$export$b8e6f8b2d70893b1);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $XhBEN = parcelRequire("XhBEN");
var $13f598d9d9f39eef$export$b8e6f8b2d70893b1 = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(FractionOfSecondParser, _Parser);
    var _super = (0, $enfmq.default)(FractionOfSecondParser);
    function FractionOfSecondParser() {
        var _this;
        (0, $6CZeq.default)(this, FractionOfSecondParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 30);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "t",
            "T"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(FractionOfSecondParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                var valueCallback = function valueCallback(value) {
                    return Math.floor(value * Math.pow(10, -token.length + 3));
                };
                return (0, $XhBEN.mapValue)((0, $XhBEN.parseNDigits)(token.length, dateString), valueCallback);
            }
        },
        {
            key: "set",
            value: function set(date, _flags, value) {
                date.setUTCMilliseconds(value);
                return date;
            }
        }
    ]);
    return FractionOfSecondParser;
}((0, $dVUCv.Parser));

});

parcelRegister("cAns0", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneWithZParser", () => $929b09a4780dfe0c$export$104d901d49fea29b);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $629aZ = parcelRequire("629aZ");

var $XhBEN = parcelRequire("XhBEN");
var $929b09a4780dfe0c$export$104d901d49fea29b = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(ISOTimezoneWithZParser, _Parser);
    var _super = (0, $enfmq.default)(ISOTimezoneWithZParser);
    function ISOTimezoneWithZParser() {
        var _this;
        (0, $6CZeq.default)(this, ISOTimezoneWithZParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 10);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "t",
            "T",
            "x"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(ISOTimezoneWithZParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case "X":
                        return (0, $XhBEN.parseTimezonePattern)((0, $629aZ.timezonePatterns).basicOptionalMinutes, dateString);
                    case "XX":
                        return (0, $XhBEN.parseTimezonePattern)((0, $629aZ.timezonePatterns).basic, dateString);
                    case "XXXX":
                        return (0, $XhBEN.parseTimezonePattern)((0, $629aZ.timezonePatterns).basicOptionalSeconds, dateString);
                    case "XXXXX":
                        return (0, $XhBEN.parseTimezonePattern)((0, $629aZ.timezonePatterns).extendedOptionalSeconds, dateString);
                    case "XXX":
                    default:
                        return (0, $XhBEN.parseTimezonePattern)((0, $629aZ.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneWithZParser;
}((0, $dVUCv.Parser));

});

parcelRegister("kuK4G", function(module, exports) {

$parcel$export(module.exports, "ISOTimezoneParser", () => $eeba5969587208af$export$12910e5204b52b9);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $629aZ = parcelRequire("629aZ");

var $XhBEN = parcelRequire("XhBEN");
var $eeba5969587208af$export$12910e5204b52b9 = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(ISOTimezoneParser, _Parser);
    var _super = (0, $enfmq.default)(ISOTimezoneParser);
    function ISOTimezoneParser() {
        var _this;
        (0, $6CZeq.default)(this, ISOTimezoneParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 10);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", [
            "t",
            "T",
            "X"
        ]);
        return _this;
    }
    (0, $cHPF9.default)(ISOTimezoneParser, [
        {
            key: "parse",
            value: function parse(dateString, token) {
                switch(token){
                    case "x":
                        return (0, $XhBEN.parseTimezonePattern)((0, $629aZ.timezonePatterns).basicOptionalMinutes, dateString);
                    case "xx":
                        return (0, $XhBEN.parseTimezonePattern)((0, $629aZ.timezonePatterns).basic, dateString);
                    case "xxxx":
                        return (0, $XhBEN.parseTimezonePattern)((0, $629aZ.timezonePatterns).basicOptionalSeconds, dateString);
                    case "xxxxx":
                        return (0, $XhBEN.parseTimezonePattern)((0, $629aZ.timezonePatterns).extendedOptionalSeconds, dateString);
                    case "xxx":
                    default:
                        return (0, $XhBEN.parseTimezonePattern)((0, $629aZ.timezonePatterns).extended, dateString);
                }
            }
        },
        {
            key: "set",
            value: function set(date, flags, value) {
                if (flags.timestampIsSet) return date;
                return new Date(date.getTime() - value);
            }
        }
    ]);
    return ISOTimezoneParser;
}((0, $dVUCv.Parser));

});

parcelRegister("jhVfr", function(module, exports) {

$parcel$export(module.exports, "TimestampSecondsParser", () => $e0ac031eec4beddf$export$2cd8bf877a05e96);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $XhBEN = parcelRequire("XhBEN");
var $e0ac031eec4beddf$export$2cd8bf877a05e96 = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(TimestampSecondsParser, _Parser);
    var _super = (0, $enfmq.default)(TimestampSecondsParser);
    function TimestampSecondsParser() {
        var _this;
        (0, $6CZeq.default)(this, TimestampSecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 40);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", "*");
        return _this;
    }
    (0, $cHPF9.default)(TimestampSecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $XhBEN.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value * 1000),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampSecondsParser;
}((0, $dVUCv.Parser));

});

parcelRegister("gDlDV", function(module, exports) {

$parcel$export(module.exports, "TimestampMillisecondsParser", () => $c1c113b2a9b78e15$export$6d8f69c6906d6368);

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $enfmq = parcelRequire("enfmq");

var $kSlfw = parcelRequire("kSlfw");

var $dVUCv = parcelRequire("dVUCv");

var $XhBEN = parcelRequire("XhBEN");
var $c1c113b2a9b78e15$export$6d8f69c6906d6368 = /*#__PURE__*/ function(_Parser) {
    (0, $1gYAD.default)(TimestampMillisecondsParser, _Parser);
    var _super = (0, $enfmq.default)(TimestampMillisecondsParser);
    function TimestampMillisecondsParser() {
        var _this;
        (0, $6CZeq.default)(this, TimestampMillisecondsParser);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "priority", 20);
        (0, $kSlfw.default)((0, $hDpcU.default)(_this), "incompatibleTokens", "*");
        return _this;
    }
    (0, $cHPF9.default)(TimestampMillisecondsParser, [
        {
            key: "parse",
            value: function parse(dateString) {
                return (0, $XhBEN.parseAnyDigitsSigned)(dateString);
            }
        },
        {
            key: "set",
            value: function set(_date, _flags, value) {
                return [
                    new Date(value),
                    {
                        timestampIsSet: true
                    }
                ];
            }
        }
    ]);
    return TimestampMillisecondsParser;
}((0, $dVUCv.Parser));

});



parcelRegister("dpjX2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $9c2d1611e11d9224$export$2e2bcd8739ae039);

var $6Q3SV = parcelRequire("6Q3SV");

var $4LmDH = parcelRequire("4LmDH");

var $esGEx = parcelRequire("esGEx");
function $9c2d1611e11d9224$export$2e2bcd8739ae039(argument, options) {
    var _options$additionalDi;
    (0, $4LmDH.default)(1, arguments);
    var additionalDigits = (0, $esGEx.default)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError("additionalDigits must be 0, 1 or 2");
    if (!(typeof argument === "string" || Object.prototype.toString.call(argument) === "[object String]")) return new Date(NaN);
    var dateStrings = $9c2d1611e11d9224$var$splitDateString(argument);
    var date;
    if (dateStrings.date) {
        var parseYearResult = $9c2d1611e11d9224$var$parseYear(dateStrings.date, additionalDigits);
        date = $9c2d1611e11d9224$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(date.getTime())) return new Date(NaN);
    var timestamp = date.getTime();
    var time = 0;
    var offset;
    if (dateStrings.time) {
        time = $9c2d1611e11d9224$var$parseTime(dateStrings.time);
        if (isNaN(time)) return new Date(NaN);
    }
    if (dateStrings.timezone) {
        offset = $9c2d1611e11d9224$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return new Date(NaN);
    } else {
        var dirtyDate = new Date(timestamp + time);
        // js parsed string assuming it's in UTC timezone
        // but we need it to be parsed in our timezone
        // so we use utc values to build date in our timezone.
        // Year values from 0 to 99 map to the years 1900 to 1999
        // so set year explicitly with setFullYear.
        var result = new Date(0);
        result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
        result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
        return result;
    }
    return new Date(timestamp + time + offset);
}
var $9c2d1611e11d9224$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
var $9c2d1611e11d9224$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var $9c2d1611e11d9224$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var $9c2d1611e11d9224$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $9c2d1611e11d9224$var$splitDateString(dateString) {
    var dateStrings = {};
    var array = dateString.split($9c2d1611e11d9224$var$patterns.dateTimeDelimiter);
    var timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($9c2d1611e11d9224$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($9c2d1611e11d9224$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        var token = $9c2d1611e11d9224$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $9c2d1611e11d9224$var$parseYear(dateString, additionalDigits) {
    var regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
    var captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ""
    };
    var year = captures[1] ? parseInt(captures[1]) : null;
    var century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $9c2d1611e11d9224$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    var captures = dateString.match($9c2d1611e11d9224$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    var isWeekDate = !!captures[4];
    var dayOfYear = $9c2d1611e11d9224$var$parseDateUnit(captures[1]);
    var month = $9c2d1611e11d9224$var$parseDateUnit(captures[2]) - 1;
    var day = $9c2d1611e11d9224$var$parseDateUnit(captures[3]);
    var week = $9c2d1611e11d9224$var$parseDateUnit(captures[4]);
    var dayOfWeek = $9c2d1611e11d9224$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$9c2d1611e11d9224$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $9c2d1611e11d9224$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        var date = new Date(0);
        if (!$9c2d1611e11d9224$var$validateDate(year, month, day) || !$9c2d1611e11d9224$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $9c2d1611e11d9224$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $9c2d1611e11d9224$var$parseTime(timeString) {
    var captures = timeString.match($9c2d1611e11d9224$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    var hours = $9c2d1611e11d9224$var$parseTimeUnit(captures[1]);
    var minutes = $9c2d1611e11d9224$var$parseTimeUnit(captures[2]);
    var seconds = $9c2d1611e11d9224$var$parseTimeUnit(captures[3]);
    if (!$9c2d1611e11d9224$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $6Q3SV.millisecondsInHour) + minutes * (0, $6Q3SV.millisecondsInMinute) + seconds * 1000;
}
function $9c2d1611e11d9224$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(",", ".")) || 0;
}
function $9c2d1611e11d9224$var$parseTimezone(timezoneString) {
    if (timezoneString === "Z") return 0;
    var captures = timezoneString.match($9c2d1611e11d9224$var$timezoneRegex);
    if (!captures) return 0;
    var sign = captures[1] === "+" ? -1 : 1;
    var hours = parseInt(captures[2]);
    var minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$9c2d1611e11d9224$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $6Q3SV.millisecondsInHour) + minutes * (0, $6Q3SV.millisecondsInMinute));
}
function $9c2d1611e11d9224$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    var date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    var fourthOfJanuaryDay = date.getUTCDay() || 7;
    var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
var $9c2d1611e11d9224$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $9c2d1611e11d9224$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $9c2d1611e11d9224$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($9c2d1611e11d9224$var$daysInMonths[month] || ($9c2d1611e11d9224$var$isLeapYearIndex(year) ? 29 : 28));
}
function $9c2d1611e11d9224$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($9c2d1611e11d9224$var$isLeapYearIndex(year) ? 366 : 365);
}
function $9c2d1611e11d9224$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $9c2d1611e11d9224$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $9c2d1611e11d9224$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}

});

parcelRegister("hL3CS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "IGNORE_CLASS_NAME", () => $ced9a37f3aaca250$export$e2911fc69bd3195e);
$parcel$export(module.exports, "default", () => $ced9a37f3aaca250$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $ced9a37f3aaca250$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $ced9a37f3aaca250$var$_setPrototypeOf(subClass, superClass);
}
function $ced9a37f3aaca250$var$_setPrototypeOf(o, p) {
    $ced9a37f3aaca250$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ced9a37f3aaca250$var$_setPrototypeOf(o, p);
}
function $ced9a37f3aaca250$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $ced9a37f3aaca250$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
} /**
 * Check whether some DOM node is our Component's node.
 */ 
function $ced9a37f3aaca250$var$isNodeFound(current, componentNode, ignoreClass) {
    if (current === componentNode) return true;
     // SVG <use/> elements do not technically reside in the rendered DOM, so
    // they do not have classList directly, but they offer a link to their
    // corresponding element, which can have classList. This extra check is for
    // that case.
    // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
    // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17
    if (current.correspondingElement) return current.correspondingElement.classList.contains(ignoreClass);
    return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */ function $ced9a37f3aaca250$var$findHighest(current, componentNode, ignoreClass) {
    if (current === componentNode) return true;
     // If source=local then this event came from 'somewhere'
    // inside and should be ignored. We could handle this with
    // a layered approach, too, but that requires going back to
    // thinking in terms of Dom node nesting, running counter
    // to React's 'you shouldn't care about the DOM' philosophy.
    // Also cover shadowRoot node by checking current.host
    while(current.parentNode || current.host){
        // Only check normal node without shadowRoot
        if (current.parentNode && $ced9a37f3aaca250$var$isNodeFound(current, componentNode, ignoreClass)) return true;
        current = current.parentNode || current.host;
    }
    return current;
}
/**
 * Check if the browser scrollbar was clicked
 */ function $ced9a37f3aaca250$var$clickedScrollbar(evt) {
    return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
} // ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var $ced9a37f3aaca250$var$testPassiveEventSupport = function testPassiveEventSupport() {
    if (typeof window === "undefined" || typeof window.addEventListener !== "function") return;
    var passive = false;
    var options = Object.defineProperty({}, "passive", {
        get: function get() {
            passive = true;
        }
    });
    var noop = function noop() {};
    window.addEventListener("testPassiveEventSupport", noop, options);
    window.removeEventListener("testPassiveEventSupport", noop, options);
    return passive;
};
function $ced9a37f3aaca250$var$autoInc(seed) {
    if (seed === void 0) seed = 0;
    return function() {
        return ++seed;
    };
}
var $ced9a37f3aaca250$var$uid = $ced9a37f3aaca250$var$autoInc();
var $ced9a37f3aaca250$var$passiveEventSupport;
var $ced9a37f3aaca250$var$handlersMap = {};
var $ced9a37f3aaca250$var$enabledInstances = {};
var $ced9a37f3aaca250$var$touchEvents = [
    "touchstart",
    "touchmove"
];
var $ced9a37f3aaca250$export$e2911fc69bd3195e = "ignore-react-onclickoutside";
/**
 * Options for addEventHandler and removeEventHandler
 */ function $ced9a37f3aaca250$var$getEventHandlerOptions(instance, eventName) {
    var handlerOptions = {};
    var isTouchEvent = $ced9a37f3aaca250$var$touchEvents.indexOf(eventName) !== -1;
    if (isTouchEvent && $ced9a37f3aaca250$var$passiveEventSupport) handlerOptions.passive = !instance.props.preventDefault;
    return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */ function $ced9a37f3aaca250$var$onClickOutsideHOC(WrappedComponent, config) {
    var _class, _temp;
    var componentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
    return _temp = _class = /*#__PURE__*/ function(_Component) {
        $ced9a37f3aaca250$var$_inheritsLoose(onClickOutside, _Component);
        function onClickOutside(props) {
            var _this;
            _this = _Component.call(this, props) || this;
            _this.__outsideClickHandler = function(event) {
                if (typeof _this.__clickOutsideHandlerProp === "function") {
                    _this.__clickOutsideHandlerProp(event);
                    return;
                }
                var instance = _this.getInstance();
                if (typeof instance.props.handleClickOutside === "function") {
                    instance.props.handleClickOutside(event);
                    return;
                }
                if (typeof instance.handleClickOutside === "function") {
                    instance.handleClickOutside(event);
                    return;
                }
                throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
            };
            _this.__getComponentNode = function() {
                var instance = _this.getInstance();
                if (config && typeof config.setClickOutsideRef === "function") return config.setClickOutsideRef()(instance);
                if (typeof instance.setClickOutsideRef === "function") return instance.setClickOutsideRef();
                return (0, $1u0KT.findDOMNode)(instance);
            };
            _this.enableOnClickOutside = function() {
                if (typeof document === "undefined" || $ced9a37f3aaca250$var$enabledInstances[_this._uid]) return;
                if (typeof $ced9a37f3aaca250$var$passiveEventSupport === "undefined") $ced9a37f3aaca250$var$passiveEventSupport = $ced9a37f3aaca250$var$testPassiveEventSupport();
                $ced9a37f3aaca250$var$enabledInstances[_this._uid] = true;
                var events = _this.props.eventTypes;
                if (!events.forEach) events = [
                    events
                ];
                $ced9a37f3aaca250$var$handlersMap[_this._uid] = function(event) {
                    if (_this.componentNode === null) return;
                    if (_this.props.preventDefault) event.preventDefault();
                    if (_this.props.stopPropagation) event.stopPropagation();
                    if (_this.props.excludeScrollbar && $ced9a37f3aaca250$var$clickedScrollbar(event)) return;
                    var current = event.composed && event.composedPath && event.composedPath().shift() || event.target;
                    if ($ced9a37f3aaca250$var$findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) return;
                    _this.__outsideClickHandler(event);
                };
                events.forEach(function(eventName) {
                    document.addEventListener(eventName, $ced9a37f3aaca250$var$handlersMap[_this._uid], $ced9a37f3aaca250$var$getEventHandlerOptions($ced9a37f3aaca250$var$_assertThisInitialized(_this), eventName));
                });
            };
            _this.disableOnClickOutside = function() {
                delete $ced9a37f3aaca250$var$enabledInstances[_this._uid];
                var fn = $ced9a37f3aaca250$var$handlersMap[_this._uid];
                if (fn && typeof document !== "undefined") {
                    var events = _this.props.eventTypes;
                    if (!events.forEach) events = [
                        events
                    ];
                    events.forEach(function(eventName) {
                        return document.removeEventListener(eventName, fn, $ced9a37f3aaca250$var$getEventHandlerOptions($ced9a37f3aaca250$var$_assertThisInitialized(_this), eventName));
                    });
                    delete $ced9a37f3aaca250$var$handlersMap[_this._uid];
                }
            };
            _this.getRef = function(ref) {
                return _this.instanceRef = ref;
            };
            _this._uid = $ced9a37f3aaca250$var$uid();
            return _this;
        }
        /**
     * Access the WrappedComponent's instance.
     */ var _proto = onClickOutside.prototype;
        _proto.getInstance = function getInstance() {
            if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) return this;
            var ref = this.instanceRef;
            return ref.getInstance ? ref.getInstance() : ref;
        };
        /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */ _proto.componentDidMount = function componentDidMount() {
            // If we are in an environment without a DOM such
            // as shallow rendering or snapshots then we exit
            // early to prevent any unhandled errors being thrown.
            if (typeof document === "undefined" || !document.createElement) return;
            var instance = this.getInstance();
            if (config && typeof config.handleClickOutside === "function") {
                this.__clickOutsideHandlerProp = config.handleClickOutside(instance);
                if (typeof this.__clickOutsideHandlerProp !== "function") throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
            }
            this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside
            if (this.props.disableOnClickOutside) return;
            this.enableOnClickOutside();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            this.componentNode = this.__getComponentNode();
        } /**
     * Remove all document's event listeners for this component
     */ ;
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.disableOnClickOutside();
        } /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */ ;
        /**
     * Pass-through render
     */ _proto.render = function render() {
            // eslint-disable-next-line no-unused-vars
            var _this$props = this.props;
            _this$props.excludeScrollbar;
            var props = $ced9a37f3aaca250$var$_objectWithoutPropertiesLoose(_this$props, [
                "excludeScrollbar"
            ]);
            if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) props.ref = this.getRef;
            else props.wrappedRef = this.getRef;
            props.disableOnClickOutside = this.disableOnClickOutside;
            props.enableOnClickOutside = this.enableOnClickOutside;
            return (0, $acw62.createElement)(WrappedComponent, props);
        };
        return onClickOutside;
    }((0, $acw62.Component)), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
        eventTypes: [
            "mousedown",
            "touchstart"
        ],
        excludeScrollbar: config && config.excludeScrollbar || false,
        outsideClickIgnoreClass: $ced9a37f3aaca250$export$e2911fc69bd3195e,
        preventDefault: false,
        stopPropagation: false
    }, _class.getClass = function() {
        return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
    }, _temp;
}
var $ced9a37f3aaca250$export$2e2bcd8739ae039 = $ced9a37f3aaca250$var$onClickOutsideHOC;

});

parcelRegister("03b0h", function(module, exports) {

$parcel$export(module.exports, "Popper", () => (parcelRequire("9IT9V")).Popper);
$parcel$export(module.exports, "Manager", () => (parcelRequire("12lqh")).Manager);
$parcel$export(module.exports, "Reference", () => (parcelRequire("ajOPb")).Reference);
$parcel$export(module.exports, "usePopper", () => (parcelRequire("48ul8")).usePopper);
// Public components

var $9IT9V = parcelRequire("9IT9V");

var $12lqh = parcelRequire("12lqh");

var $ajOPb = parcelRequire("ajOPb");

var $48ul8 = parcelRequire("48ul8");
 // Public types

});
parcelRegister("9IT9V", function(module, exports) {

$parcel$export(module.exports, "Popper", () => $7143028fa90e470c$export$badac9ada3a0bdf9);

var $acw62 = parcelRequire("acw62");

var $12lqh = parcelRequire("12lqh");

var $2w0Xg = parcelRequire("2w0Xg");

var $48ul8 = parcelRequire("48ul8");
var $7143028fa90e470c$var$NOOP = function NOOP() {
    return void 0;
};
var $7143028fa90e470c$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $7143028fa90e470c$var$EMPTY_MODIFIERS = [];
function $7143028fa90e470c$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom" : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "absolute" : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $7143028fa90e470c$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $acw62.useContext((0, $12lqh.ManagerReferenceNodeContext));
    var _React$useState = $acw62.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $acw62.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $acw62.useEffect(function() {
        (0, $2w0Xg.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $acw62.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: "arrow",
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $48ul8.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $acw62.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $7143028fa90e470c$var$NOOP,
            update: update || $7143028fa90e470c$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $2w0Xg.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("12lqh", function(module, exports) {

$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $0c16987f94a35690$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $0c16987f94a35690$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $0c16987f94a35690$export$d0d38e7dec7a1a61);

var $acw62 = parcelRequire("acw62");
var $0c16987f94a35690$export$3dbd3405086fec7b = $acw62.createContext();
var $0c16987f94a35690$export$cbabb21c2529b130 = $acw62.createContext();
function $0c16987f94a35690$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $acw62.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $acw62.useRef(false);
    $acw62.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $acw62.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $acw62.createElement($0c16987f94a35690$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $acw62.createElement($0c16987f94a35690$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("2w0Xg", function(module, exports) {

$parcel$export(module.exports, "unwrapArray", () => $1d4f4f9052f5ab52$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $1d4f4f9052f5ab52$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $1d4f4f9052f5ab52$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $1d4f4f9052f5ab52$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $1d4f4f9052f5ab52$export$700979bc83e7db82);

var $acw62 = parcelRequire("acw62");
var $1d4f4f9052f5ab52$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $1d4f4f9052f5ab52$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === "function") {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $1d4f4f9052f5ab52$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === "function") return $1d4f4f9052f5ab52$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $1d4f4f9052f5ab52$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $1d4f4f9052f5ab52$export$700979bc83e7db82 = typeof window !== "undefined" && window.document && window.document.createElement ? $acw62.useLayoutEffect : $acw62.useEffect;

});

parcelRegister("48ul8", function(module, exports) {

$parcel$export(module.exports, "usePopper", () => $302f71a5c5df2f4b$export$f4d5bf230a36dd6e);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $3tUi5 = parcelRequire("3tUi5");

var $ai2Pb = parcelRequire("ai2Pb");

var $2w0Xg = parcelRequire("2w0Xg");
var $302f71a5c5df2f4b$var$EMPTY_MODIFIERS = [];
var $302f71a5c5df2f4b$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $acw62.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || "bottom",
        strategy: options.strategy || "absolute",
        modifiers: options.modifiers || $302f71a5c5df2f4b$var$EMPTY_MODIFIERS
    };
    var _React$useState = $acw62.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: "0",
                top: "0"
            },
            arrow: {
                position: "absolute"
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $acw62.useMemo(function() {
        return {
            name: "updateState",
            enabled: true,
            phase: "write",
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $1u0KT.flushSync(function() {
                    setState({
                        styles: (0, $2w0Xg.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $2w0Xg.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                "computeStyles"
            ]
        };
    }, []);
    var popperOptions = $acw62.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: "applyStyles",
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $acw62.useRef();
    (0, $2w0Xg.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $2w0Xg.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $3tUi5.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});
parcelRegister("3tUi5", function(module, exports) {

$parcel$export(module.exports, "createPopper", () => $288fbeb449f53487$export$8f7491d57c8f97a9);

var $8iXfp = parcelRequire("8iXfp");

var $jU5vk = parcelRequire("jU5vk");

var $cePA2 = parcelRequire("cePA2");

var $5ZHwq = parcelRequire("5ZHwq");

var $aOl9t = parcelRequire("aOl9t");

var $lWzyf = parcelRequire("lWzyf");

var $hMqHB = parcelRequire("hMqHB");

var $bxdrS = parcelRequire("bxdrS");

var $kU5lB = parcelRequire("kU5lB");

var $95q7y = parcelRequire("95q7y");


var $288fbeb449f53487$export$d34966752335dd47 = [
    (0, $jU5vk.default),
    (0, $cePA2.default),
    (0, $5ZHwq.default),
    (0, $aOl9t.default),
    (0, $lWzyf.default),
    (0, $hMqHB.default),
    (0, $bxdrS.default),
    (0, $kU5lB.default),
    (0, $95q7y.default)
];
var $288fbeb449f53487$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $8iXfp.popperGenerator)({
    defaultModifiers: $288fbeb449f53487$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("8iXfp", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", () => $60bdf67e43f5dfcb$export$ed5e13716264f202);

var $gcqB4 = parcelRequire("gcqB4");

var $dElKO = parcelRequire("dElKO");

var $cqjGx = parcelRequire("cqjGx");

var $5KzeH = parcelRequire("5KzeH");

var $ahlk8 = parcelRequire("ahlk8");

var $dlelj = parcelRequire("dlelj");

var $l57aq = parcelRequire("l57aq");


var $93iQ7 = parcelRequire("93iQ7");
var $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $60bdf67e43f5dfcb$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $60bdf67e43f5dfcb$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $93iQ7.isElement)(reference) ? (0, $cqjGx.default)(reference) : reference.contextElement ? (0, $cqjGx.default)(reference.contextElement) : [],
                    popper: (0, $cqjGx.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $ahlk8.default)((0, $l57aq.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $gcqB4.default)(reference, (0, $5KzeH.default)(popper), state.options.strategy === "fixed"),
                    popper: (0, $dElKO.default)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $dlelj.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $60bdf67e43f5dfcb$export$8f7491d57c8f97a9 = /*#__PURE__*/ $60bdf67e43f5dfcb$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRegister("gcqB4", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcb265ed9201975a$export$2e2bcd8739ae039);

var $41Z5W = parcelRequire("41Z5W");

var $eOasn = parcelRequire("eOasn");

var $oKPBf = parcelRequire("oKPBf");

var $93iQ7 = parcelRequire("93iQ7");

var $8fnXo = parcelRequire("8fnXo");

var $17OuU = parcelRequire("17OuU");

var $1ADUj = parcelRequire("1ADUj");

var $4J8n1 = parcelRequire("4J8n1");
function $bcb265ed9201975a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $4J8n1.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $4J8n1.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $bcb265ed9201975a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $93iQ7.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $93iQ7.isHTMLElement)(offsetParent) && $bcb265ed9201975a$var$isElementScaled(offsetParent);
    var documentElement = (0, $17OuU.default)(offsetParent);
    var rect = (0, $41Z5W.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $oKPBf.default)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $1ADUj.default)(documentElement)) scroll = (0, $eOasn.default)(offsetParent);
        if ((0, $93iQ7.isHTMLElement)(offsetParent)) {
            offsets = (0, $41Z5W.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $8fnXo.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRegister("41Z5W", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ef6a598263dba8e$export$2e2bcd8739ae039);

var $93iQ7 = parcelRequire("93iQ7");

var $4J8n1 = parcelRequire("4J8n1");

var $93G53 = parcelRequire("93G53");

var $gotNd = parcelRequire("gotNd");
function $2ef6a598263dba8e$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $93iQ7.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $4J8n1.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $4J8n1.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $93iQ7.isElement)(element) ? (0, $93G53.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $gotNd.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRegister("93iQ7", function(module, exports) {

$parcel$export(module.exports, "isElement", () => $69730206aa270d41$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isHTMLElement", () => $69730206aa270d41$export$1b3bfaa9684536aa);
$parcel$export(module.exports, "isShadowRoot", () => $69730206aa270d41$export$af51f0f06c0f328a);

var $93G53 = parcelRequire("93G53");
function $69730206aa270d41$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $93G53.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $69730206aa270d41$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $93G53.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $69730206aa270d41$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $93G53.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRegister("93G53", function(module, exports) {

$parcel$export(module.exports, "default", () => $6985093033570817$export$2e2bcd8739ae039);
function $6985093033570817$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});


parcelRegister("4J8n1", function(module, exports) {

$parcel$export(module.exports, "max", () => $3711db8b00de96df$export$8960430cfd85939f);
$parcel$export(module.exports, "min", () => $3711db8b00de96df$export$96ec731ed4dcb222);
$parcel$export(module.exports, "round", () => $3711db8b00de96df$export$2077e0241d6afd3c);
var $3711db8b00de96df$export$8960430cfd85939f = Math.max;
var $3711db8b00de96df$export$96ec731ed4dcb222 = Math.min;
var $3711db8b00de96df$export$2077e0241d6afd3c = Math.round;

});

parcelRegister("gotNd", function(module, exports) {

$parcel$export(module.exports, "default", () => $bef5ff765617d084$export$2e2bcd8739ae039);

var $9r1ut = parcelRequire("9r1ut");
function $bef5ff765617d084$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $9r1ut.default)());
}

});
parcelRegister("9r1ut", function(module, exports) {

$parcel$export(module.exports, "default", () => $6de7caa8ee90d63c$export$2e2bcd8739ae039);
function $6de7caa8ee90d63c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}

});



parcelRegister("eOasn", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac7dd8aeabb81fe8$export$2e2bcd8739ae039);

var $4WW7r = parcelRequire("4WW7r");

var $93G53 = parcelRequire("93G53");

var $93iQ7 = parcelRequire("93iQ7");

var $ieX38 = parcelRequire("ieX38");
function $ac7dd8aeabb81fe8$export$2e2bcd8739ae039(node) {
    if (node === (0, $93G53.default)(node) || !(0, $93iQ7.isHTMLElement)(node)) return (0, $4WW7r.default)(node);
    else return (0, $ieX38.default)(node);
}

});
parcelRegister("4WW7r", function(module, exports) {

$parcel$export(module.exports, "default", () => $39a9a96b6f99add9$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");
function $39a9a96b6f99add9$export$2e2bcd8739ae039(node) {
    var win = (0, $93G53.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});

parcelRegister("ieX38", function(module, exports) {

$parcel$export(module.exports, "default", () => $d47756cb7a847081$export$2e2bcd8739ae039);
function $d47756cb7a847081$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});


parcelRegister("oKPBf", function(module, exports) {

$parcel$export(module.exports, "default", () => $04a691b7a330df44$export$2e2bcd8739ae039);
function $04a691b7a330df44$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}

});

parcelRegister("8fnXo", function(module, exports) {

$parcel$export(module.exports, "default", () => $60124eceeef28a28$export$2e2bcd8739ae039);

var $41Z5W = parcelRequire("41Z5W");

var $17OuU = parcelRequire("17OuU");

var $4WW7r = parcelRequire("4WW7r");
function $60124eceeef28a28$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $41Z5W.default)((0, $17OuU.default)(element)).left + (0, $4WW7r.default)(element).scrollLeft;
}

});
parcelRegister("17OuU", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d1d9daad62fa952$export$2e2bcd8739ae039);

var $93iQ7 = parcelRequire("93iQ7");
function $0d1d9daad62fa952$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $93iQ7.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});


parcelRegister("1ADUj", function(module, exports) {

$parcel$export(module.exports, "default", () => $12881c0013479a14$export$2e2bcd8739ae039);

var $huVQQ = parcelRequire("huVQQ");
function $12881c0013479a14$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $huVQQ.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});
parcelRegister("huVQQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbd21d1454570861$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");
function $cbd21d1454570861$export$2e2bcd8739ae039(element) {
    return (0, $93G53.default)(element).getComputedStyle(element);
}

});



parcelRegister("dElKO", function(module, exports) {

$parcel$export(module.exports, "default", () => $9effe2b32f662e4a$export$2e2bcd8739ae039);

var $41Z5W = parcelRequire("41Z5W");
function $9effe2b32f662e4a$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $41Z5W.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});

parcelRegister("cqjGx", function(module, exports) {

$parcel$export(module.exports, "default", () => $90b72ed15edfd54a$export$2e2bcd8739ae039);

var $3QP5e = parcelRequire("3QP5e");

var $aerap = parcelRequire("aerap");

var $93G53 = parcelRequire("93G53");

var $1ADUj = parcelRequire("1ADUj");
function $90b72ed15edfd54a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $3QP5e.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $93G53.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $1ADUj.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($90b72ed15edfd54a$export$2e2bcd8739ae039((0, $aerap.default)(target)));
}

});
parcelRegister("3QP5e", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cddda83e3357241$export$2e2bcd8739ae039);

var $aerap = parcelRequire("aerap");

var $1ADUj = parcelRequire("1ADUj");

var $oKPBf = parcelRequire("oKPBf");

var $93iQ7 = parcelRequire("93iQ7");
function $2cddda83e3357241$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $oKPBf.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $93iQ7.isHTMLElement)(node) && (0, $1ADUj.default)(node)) return node;
    return $2cddda83e3357241$export$2e2bcd8739ae039((0, $aerap.default)(node));
}

});
parcelRegister("aerap", function(module, exports) {

$parcel$export(module.exports, "default", () => $773048fc1d2aa7ee$export$2e2bcd8739ae039);

var $oKPBf = parcelRequire("oKPBf");

var $17OuU = parcelRequire("17OuU");

var $93iQ7 = parcelRequire("93iQ7");
function $773048fc1d2aa7ee$export$2e2bcd8739ae039(element) {
    if ((0, $oKPBf.default)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $93iQ7.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $17OuU.default)(element) // fallback
    );
}

});



parcelRegister("5KzeH", function(module, exports) {

$parcel$export(module.exports, "default", () => $42fc94c94931c781$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");

var $oKPBf = parcelRequire("oKPBf");

var $huVQQ = parcelRequire("huVQQ");

var $93iQ7 = parcelRequire("93iQ7");

var $lKbxe = parcelRequire("lKbxe");

var $aerap = parcelRequire("aerap");

var $9r1ut = parcelRequire("9r1ut");
function $42fc94c94931c781$var$getTrueOffsetParent(element) {
    if (!(0, $93iQ7.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $huVQQ.default)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $42fc94c94931c781$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $9r1ut.default)());
    var isIE = /Trident/i.test((0, $9r1ut.default)());
    if (isIE && (0, $93iQ7.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $huVQQ.default)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $aerap.default)(element);
    if ((0, $93iQ7.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $93iQ7.isHTMLElement)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $oKPBf.default)(currentNode)) < 0){
        var css = (0, $huVQQ.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $42fc94c94931c781$export$2e2bcd8739ae039(element) {
    var window = (0, $93G53.default)(element);
    var offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $lKbxe.default)(offsetParent) && (0, $huVQQ.default)(offsetParent).position === "static")offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $oKPBf.default)(offsetParent) === "html" || (0, $oKPBf.default)(offsetParent) === "body" && (0, $huVQQ.default)(offsetParent).position === "static")) return window;
    return offsetParent || $42fc94c94931c781$var$getContainingBlock(element) || window;
}

});
parcelRegister("lKbxe", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd46d779ec622be4$export$2e2bcd8739ae039);

var $oKPBf = parcelRequire("oKPBf");
function $fd46d779ec622be4$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $oKPBf.default)(element)) >= 0;
}

});


parcelRegister("ahlk8", function(module, exports) {

$parcel$export(module.exports, "default", () => $77bc085de34276f2$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");
function $77bc085de34276f2$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $77bc085de34276f2$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $77bc085de34276f2$var$order(modifiers); // order based on phase
    return (0, $1KQnQ.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});
parcelRegister("1KQnQ", function(module, exports) {

$parcel$export(module.exports, "top", () => $1472b89a65155de2$export$1e95b668f3b82d);
$parcel$export(module.exports, "bottom", () => $1472b89a65155de2$export$40e543e69a8b3fbb);
$parcel$export(module.exports, "right", () => $1472b89a65155de2$export$79ffe56a765070d2);
$parcel$export(module.exports, "left", () => $1472b89a65155de2$export$eabcd2c8791e7bf4);
$parcel$export(module.exports, "auto", () => $1472b89a65155de2$export$dfb5619354ba860);
$parcel$export(module.exports, "basePlacements", () => $1472b89a65155de2$export$aec2ce47c367b8c3);
$parcel$export(module.exports, "start", () => $1472b89a65155de2$export$b3571188c770cc5a);
$parcel$export(module.exports, "end", () => $1472b89a65155de2$export$bd5df0f255a350f8);
$parcel$export(module.exports, "clippingParents", () => $1472b89a65155de2$export$390fd549c5303b4d);
$parcel$export(module.exports, "viewport", () => $1472b89a65155de2$export$d7b7311ec04a3e8f);
$parcel$export(module.exports, "popper", () => $1472b89a65155de2$export$ae5ab1c730825774);
$parcel$export(module.exports, "reference", () => $1472b89a65155de2$export$ca50aac9f3ba507f);
$parcel$export(module.exports, "variationPlacements", () => $1472b89a65155de2$export$368f9a87e87fa4e1);
$parcel$export(module.exports, "placements", () => $1472b89a65155de2$export$803cd8101b6c182b);
$parcel$export(module.exports, "modifierPhases", () => $1472b89a65155de2$export$d087d3878fdf71d5);
var $1472b89a65155de2$export$1e95b668f3b82d = "top";
var $1472b89a65155de2$export$40e543e69a8b3fbb = "bottom";
var $1472b89a65155de2$export$79ffe56a765070d2 = "right";
var $1472b89a65155de2$export$eabcd2c8791e7bf4 = "left";
var $1472b89a65155de2$export$dfb5619354ba860 = "auto";
var $1472b89a65155de2$export$aec2ce47c367b8c3 = [
    $1472b89a65155de2$export$1e95b668f3b82d,
    $1472b89a65155de2$export$40e543e69a8b3fbb,
    $1472b89a65155de2$export$79ffe56a765070d2,
    $1472b89a65155de2$export$eabcd2c8791e7bf4
];
var $1472b89a65155de2$export$b3571188c770cc5a = "start";
var $1472b89a65155de2$export$bd5df0f255a350f8 = "end";
var $1472b89a65155de2$export$390fd549c5303b4d = "clippingParents";
var $1472b89a65155de2$export$d7b7311ec04a3e8f = "viewport";
var $1472b89a65155de2$export$ae5ab1c730825774 = "popper";
var $1472b89a65155de2$export$ca50aac9f3ba507f = "reference";
var $1472b89a65155de2$export$368f9a87e87fa4e1 = /*#__PURE__*/ $1472b89a65155de2$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []);
var $1472b89a65155de2$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($1472b89a65155de2$export$aec2ce47c367b8c3, [
    $1472b89a65155de2$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $1472b89a65155de2$export$421679a7c3d56e = "beforeRead";
var $1472b89a65155de2$export$aafa59e2e03f2942 = "read";
var $1472b89a65155de2$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $1472b89a65155de2$export$c65e99957a05207c = "beforeMain";
var $1472b89a65155de2$export$f22da7240b7add18 = "main";
var $1472b89a65155de2$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $1472b89a65155de2$export$8d4d2d70e7d46032 = "beforeWrite";
var $1472b89a65155de2$export$68d8715fc104d294 = "write";
var $1472b89a65155de2$export$70a6e5159acce2e6 = "afterWrite";
var $1472b89a65155de2$export$d087d3878fdf71d5 = [
    $1472b89a65155de2$export$421679a7c3d56e,
    $1472b89a65155de2$export$aafa59e2e03f2942,
    $1472b89a65155de2$export$6964f6c886723980,
    $1472b89a65155de2$export$c65e99957a05207c,
    $1472b89a65155de2$export$f22da7240b7add18,
    $1472b89a65155de2$export$bab79516f2d662fe,
    $1472b89a65155de2$export$8d4d2d70e7d46032,
    $1472b89a65155de2$export$68d8715fc104d294,
    $1472b89a65155de2$export$70a6e5159acce2e6
];

});


parcelRegister("dlelj", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b685cb08303911c$export$2e2bcd8739ae039);
function $9b685cb08303911c$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRegister("l57aq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f58f9fd4551b4b0f$export$2e2bcd8739ae039);
function $f58f9fd4551b4b0f$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRegister("jU5vk", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7d7845625089588$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");
var $e7d7845625089588$var$passive = {
    passive: true
};
function $e7d7845625089588$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $93G53.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $e7d7845625089588$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $e7d7845625089588$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $e7d7845625089588$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $e7d7845625089588$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $e7d7845625089588$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $e7d7845625089588$var$effect,
    data: {}
};

});

parcelRegister("cePA2", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e8ecd9a827a16d7$export$2e2bcd8739ae039);

var $dgDBP = parcelRequire("dgDBP");
function $8e8ecd9a827a16d7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $dgDBP.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8e8ecd9a827a16d7$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $8e8ecd9a827a16d7$var$popperOffsets,
    data: {}
};

});
parcelRegister("dgDBP", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a8b7e877fbba4f3$export$2e2bcd8739ae039);

var $h06jI = parcelRequire("h06jI");

var $7kchx = parcelRequire("7kchx");

var $g1hRA = parcelRequire("g1hRA");

var $1KQnQ = parcelRequire("1KQnQ");
function $9a8b7e877fbba4f3$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $h06jI.default)(placement) : null;
    var variation = placement ? (0, $7kchx.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $1KQnQ.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $1KQnQ.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $1KQnQ.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $1KQnQ.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $g1hRA.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $1KQnQ.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $1KQnQ.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});
parcelRegister("h06jI", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6075629d0814627$export$2e2bcd8739ae039);

function $c6075629d0814627$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}

});

parcelRegister("7kchx", function(module, exports) {

$parcel$export(module.exports, "default", () => $5553ed9c2ee225e3$export$2e2bcd8739ae039);
function $5553ed9c2ee225e3$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}

});

parcelRegister("g1hRA", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba9a98a4204389e3$export$2e2bcd8739ae039);
function $ba9a98a4204389e3$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}

});



parcelRegister("5ZHwq", function(module, exports) {

$parcel$export(module.exports, "default", () => $45d468ca92a1d24b$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $5KzeH = parcelRequire("5KzeH");

var $93G53 = parcelRequire("93G53");

var $17OuU = parcelRequire("17OuU");

var $huVQQ = parcelRequire("huVQQ");

var $h06jI = parcelRequire("h06jI");

var $7kchx = parcelRequire("7kchx");

var $4J8n1 = parcelRequire("4J8n1");
var $45d468ca92a1d24b$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $45d468ca92a1d24b$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $4J8n1.round)(x * dpr) / dpr || 0,
        y: (0, $4J8n1.round)(y * dpr) / dpr || 0
    };
}
function $45d468ca92a1d24b$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $1KQnQ.left);
    var sideY = (0, $1KQnQ.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $5KzeH.default)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $93G53.default)(popper)) {
            offsetParent = (0, $17OuU.default)(popper);
            if ((0, $huVQQ.default)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $1KQnQ.top) || (placement === (0, $1KQnQ.left) || placement === (0, $1KQnQ.right)) && variation === (0, $1KQnQ.end)) {
            sideY = (0, $1KQnQ.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $1KQnQ.left) || (placement === (0, $1KQnQ.top) || placement === (0, $1KQnQ.bottom)) && variation === (0, $1KQnQ.end)) {
            sideX = (0, $1KQnQ.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $45d468ca92a1d24b$var$unsetSides);
    var _ref4 = roundOffsets === true ? $45d468ca92a1d24b$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $93G53.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $45d468ca92a1d24b$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $h06jI.default)(state.placement),
        variation: (0, $7kchx.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $45d468ca92a1d24b$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $45d468ca92a1d24b$var$computeStyles,
    data: {}
};

});

parcelRegister("aOl9t", function(module, exports) {

$parcel$export(module.exports, "default", () => $7deefb3680d4558f$export$2e2bcd8739ae039);

var $oKPBf = parcelRequire("oKPBf");

var $93iQ7 = parcelRequire("93iQ7");
// and applies them to the HTMLElements such as popper and arrow
function $7deefb3680d4558f$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $93iQ7.isHTMLElement)(element) || !(0, $oKPBf.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $7deefb3680d4558f$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $93iQ7.isHTMLElement)(element) || !(0, $oKPBf.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $7deefb3680d4558f$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $7deefb3680d4558f$var$applyStyles,
    effect: $7deefb3680d4558f$var$effect,
    requires: [
        "computeStyles"
    ]
};

});

parcelRegister("lWzyf", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff9a9783c10adebd$export$2e2bcd8739ae039);

var $h06jI = parcelRequire("h06jI");

var $1KQnQ = parcelRequire("1KQnQ");
function $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $h06jI.default)(placement);
    var invertDistance = [
        (0, $1KQnQ.left),
        (0, $1KQnQ.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $1KQnQ.left),
        (0, $1KQnQ.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $ff9a9783c10adebd$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $1KQnQ.placements).reduce(function(acc, placement) {
        acc[placement] = $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ff9a9783c10adebd$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $ff9a9783c10adebd$var$offset
};

});

parcelRegister("hMqHB", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf1ba1dd94205465$export$2e2bcd8739ae039);

var $eFT7Y = parcelRequire("eFT7Y");

var $h06jI = parcelRequire("h06jI");

var $4NVvZ = parcelRequire("4NVvZ");

var $gGcga = parcelRequire("gGcga");

var $iN4T7 = parcelRequire("iN4T7");

var $1KQnQ = parcelRequire("1KQnQ");

var $7kchx = parcelRequire("7kchx");
function $cf1ba1dd94205465$var$getExpandedFallbackPlacements(placement) {
    if ((0, $h06jI.default)(placement) === (0, $1KQnQ.auto)) return [];
    var oppositePlacement = (0, $eFT7Y.default)(placement);
    return [
        (0, $4NVvZ.default)(placement),
        oppositePlacement,
        (0, $4NVvZ.default)(oppositePlacement)
    ];
}
function $cf1ba1dd94205465$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $h06jI.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $eFT7Y.default)(preferredPlacement)
    ] : $cf1ba1dd94205465$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $h06jI.default)(placement) === (0, $1KQnQ.auto) ? (0, $iN4T7.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $h06jI.default)(placement);
        var isStartVariation = (0, $7kchx.default)(placement) === (0, $1KQnQ.start);
        var isVertical = [
            (0, $1KQnQ.top),
            (0, $1KQnQ.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $gGcga.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $1KQnQ.right) : (0, $1KQnQ.left) : isStartVariation ? (0, $1KQnQ.bottom) : (0, $1KQnQ.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $eFT7Y.default)(mainVariationSide);
        var altVariationSide = (0, $eFT7Y.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $cf1ba1dd94205465$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $cf1ba1dd94205465$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};

});
parcelRegister("eFT7Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaefa8315f14c8e2$export$2e2bcd8739ae039);
var $aaefa8315f14c8e2$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $aaefa8315f14c8e2$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $aaefa8315f14c8e2$var$hash[matched];
    });
}

});

parcelRegister("4NVvZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $37f85a49ff946cb6$export$2e2bcd8739ae039);
var $37f85a49ff946cb6$var$hash = {
    start: "end",
    end: "start"
};
function $37f85a49ff946cb6$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $37f85a49ff946cb6$var$hash[matched];
    });
}

});

parcelRegister("gGcga", function(module, exports) {

$parcel$export(module.exports, "default", () => $c24a1421ba2f823c$export$2e2bcd8739ae039);

var $5T76m = parcelRequire("5T76m");

var $17OuU = parcelRequire("17OuU");

var $41Z5W = parcelRequire("41Z5W");

var $dgDBP = parcelRequire("dgDBP");

var $ik7Fq = parcelRequire("ik7Fq");

var $1KQnQ = parcelRequire("1KQnQ");

var $93iQ7 = parcelRequire("93iQ7");

var $3Os63 = parcelRequire("3Os63");

var $hdgde = parcelRequire("hdgde");
function $c24a1421ba2f823c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $1KQnQ.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $1KQnQ.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $1KQnQ.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $3Os63.default)(typeof padding !== "number" ? padding : (0, $hdgde.default)(padding, (0, $1KQnQ.basePlacements)));
    var altContext = elementContext === (0, $1KQnQ.popper) ? (0, $1KQnQ.reference) : (0, $1KQnQ.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $5T76m.default)((0, $93iQ7.isElement)(element) ? element : element.contextElement || (0, $17OuU.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $41Z5W.default)(state.elements.reference);
    var popperOffsets = (0, $dgDBP.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $ik7Fq.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $1KQnQ.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $1KQnQ.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $1KQnQ.right),
                (0, $1KQnQ.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $1KQnQ.top),
                (0, $1KQnQ.bottom)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRegister("5T76m", function(module, exports) {

$parcel$export(module.exports, "default", () => $449799046a13d100$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $e1yxe = parcelRequire("e1yxe");

var $ef4Kl = parcelRequire("ef4Kl");

var $cqjGx = parcelRequire("cqjGx");

var $5KzeH = parcelRequire("5KzeH");

var $17OuU = parcelRequire("17OuU");

var $huVQQ = parcelRequire("huVQQ");

var $93iQ7 = parcelRequire("93iQ7");

var $41Z5W = parcelRequire("41Z5W");

var $aerap = parcelRequire("aerap");

var $ciq1x = parcelRequire("ciq1x");

var $oKPBf = parcelRequire("oKPBf");

var $ik7Fq = parcelRequire("ik7Fq");

var $4J8n1 = parcelRequire("4J8n1");
function $449799046a13d100$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $41Z5W.default)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $1KQnQ.viewport) ? (0, $ik7Fq.default)((0, $e1yxe.default)(element, strategy)) : (0, $93iQ7.isElement)(clippingParent) ? $449799046a13d100$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $ik7Fq.default)((0, $ef4Kl.default)((0, $17OuU.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $449799046a13d100$var$getClippingParents(element) {
    var clippingParents = (0, $cqjGx.default)((0, $aerap.default)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $huVQQ.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $93iQ7.isHTMLElement)(element) ? (0, $5KzeH.default)(element) : element;
    if (!(0, $93iQ7.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $93iQ7.isElement)(clippingParent) && (0, $ciq1x.default)(clippingParent, clipperElement) && (0, $oKPBf.default)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $449799046a13d100$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $449799046a13d100$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $4J8n1.max)(rect.top, accRect.top);
        accRect.right = (0, $4J8n1.min)(rect.right, accRect.right);
        accRect.bottom = (0, $4J8n1.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $4J8n1.max)(rect.left, accRect.left);
        return accRect;
    }, $449799046a13d100$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRegister("e1yxe", function(module, exports) {

$parcel$export(module.exports, "default", () => $a35bf29d5fc5ab40$export$2e2bcd8739ae039);

var $93G53 = parcelRequire("93G53");

var $17OuU = parcelRequire("17OuU");

var $8fnXo = parcelRequire("8fnXo");

var $gotNd = parcelRequire("gotNd");
function $a35bf29d5fc5ab40$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $93G53.default)(element);
    var html = (0, $17OuU.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $gotNd.default)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $8fnXo.default)(element),
        y: y
    };
}

});

parcelRegister("ef4Kl", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5e625ef2dd801ec$export$2e2bcd8739ae039);

var $17OuU = parcelRequire("17OuU");

var $huVQQ = parcelRequire("huVQQ");

var $8fnXo = parcelRequire("8fnXo");

var $4WW7r = parcelRequire("4WW7r");

var $4J8n1 = parcelRequire("4J8n1");
function $a5e625ef2dd801ec$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $17OuU.default)(element);
    var winScroll = (0, $4WW7r.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $4J8n1.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $4J8n1.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $8fnXo.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $huVQQ.default)(body || html).direction === "rtl") x += (0, $4J8n1.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRegister("ciq1x", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f3b5a3db2e59cbc$export$2e2bcd8739ae039);

var $93iQ7 = parcelRequire("93iQ7");
function $8f3b5a3db2e59cbc$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $93iQ7.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRegister("ik7Fq", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5700acdd3ba9a3c$export$2e2bcd8739ae039);
function $d5700acdd3ba9a3c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRegister("3Os63", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c6bd604be4c867e$export$2e2bcd8739ae039);

var $gcu3h = parcelRequire("gcu3h");
function $2c6bd604be4c867e$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $gcu3h.default)(), paddingObject);
}

});
parcelRegister("gcu3h", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcb51404109b5184$export$2e2bcd8739ae039);
function $bcb51404109b5184$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRegister("hdgde", function(module, exports) {

$parcel$export(module.exports, "default", () => $c88039fe47959ef5$export$2e2bcd8739ae039);
function $c88039fe47959ef5$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRegister("iN4T7", function(module, exports) {

$parcel$export(module.exports, "default", () => $dae0983d65fbfc0b$export$2e2bcd8739ae039);

var $7kchx = parcelRequire("7kchx");

var $1KQnQ = parcelRequire("1KQnQ");

var $gGcga = parcelRequire("gGcga");

var $h06jI = parcelRequire("h06jI");
function $dae0983d65fbfc0b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $1KQnQ.placements) : _options$allowedAutoP;
    var variation = (0, $7kchx.default)(placement);
    var placements = variation ? flipVariations ? (0, $1KQnQ.variationPlacements) : (0, $1KQnQ.variationPlacements).filter(function(placement) {
        return (0, $7kchx.default)(placement) === variation;
    }) : (0, $1KQnQ.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $gGcga.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $h06jI.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRegister("bxdrS", function(module, exports) {

$parcel$export(module.exports, "default", () => $865d356b2ca960a5$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $h06jI = parcelRequire("h06jI");

var $g1hRA = parcelRequire("g1hRA");

var $8ptl2 = parcelRequire("8ptl2");

var $cOvrb = parcelRequire("cOvrb");

var $dElKO = parcelRequire("dElKO");

var $5KzeH = parcelRequire("5KzeH");

var $gGcga = parcelRequire("gGcga");

var $7kchx = parcelRequire("7kchx");

var $gcu3h = parcelRequire("gcu3h");

var $4J8n1 = parcelRequire("4J8n1");
function $865d356b2ca960a5$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $gGcga.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $h06jI.default)(state.placement);
    var variation = (0, $7kchx.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $g1hRA.default)(basePlacement);
    var altAxis = (0, $8ptl2.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $1KQnQ.top) : (0, $1KQnQ.left);
        var altSide = mainAxis === "y" ? (0, $1KQnQ.bottom) : (0, $1KQnQ.right);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $1KQnQ.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $1KQnQ.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $dElKO.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $gcu3h.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $cOvrb.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $5KzeH.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $cOvrb.within)(tether ? (0, $4J8n1.min)(min, tetherMin) : min, offset, tether ? (0, $4J8n1.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $1KQnQ.top) : (0, $1KQnQ.left);
        var _altSide = mainAxis === "x" ? (0, $1KQnQ.bottom) : (0, $1KQnQ.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $1KQnQ.top),
            (0, $1KQnQ.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $cOvrb.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $cOvrb.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $865d356b2ca960a5$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $865d356b2ca960a5$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};

});
parcelRegister("8ptl2", function(module, exports) {

$parcel$export(module.exports, "default", () => $61f76a8076c296c7$export$2e2bcd8739ae039);
function $61f76a8076c296c7$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}

});

parcelRegister("cOvrb", function(module, exports) {

$parcel$export(module.exports, "within", () => $95428a5e75015184$export$f28d906d67a997f3);
$parcel$export(module.exports, "withinMaxClamp", () => $95428a5e75015184$export$86c8af6d3ef0b4a);

var $4J8n1 = parcelRequire("4J8n1");
function $95428a5e75015184$export$f28d906d67a997f3(min, value, max) {
    return (0, $4J8n1.max)(min, (0, $4J8n1.min)(value, max));
}
function $95428a5e75015184$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $95428a5e75015184$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});


parcelRegister("kU5lB", function(module, exports) {

$parcel$export(module.exports, "default", () => $f37d2f7eaf2ad10e$export$2e2bcd8739ae039);

var $h06jI = parcelRequire("h06jI");

var $dElKO = parcelRequire("dElKO");

var $ciq1x = parcelRequire("ciq1x");

var $5KzeH = parcelRequire("5KzeH");

var $g1hRA = parcelRequire("g1hRA");

var $cOvrb = parcelRequire("cOvrb");

var $3Os63 = parcelRequire("3Os63");

var $hdgde = parcelRequire("hdgde");

var $1KQnQ = parcelRequire("1KQnQ");
var $f37d2f7eaf2ad10e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $3Os63.default)(typeof padding !== "number" ? padding : (0, $hdgde.default)(padding, (0, $1KQnQ.basePlacements)));
};
function $f37d2f7eaf2ad10e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $h06jI.default)(state.placement);
    var axis = (0, $g1hRA.default)(basePlacement);
    var isVertical = [
        (0, $1KQnQ.left),
        (0, $1KQnQ.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $f37d2f7eaf2ad10e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $dElKO.default)(arrowElement);
    var minProp = axis === "y" ? (0, $1KQnQ.top) : (0, $1KQnQ.left);
    var maxProp = axis === "y" ? (0, $1KQnQ.bottom) : (0, $1KQnQ.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $5KzeH.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $cOvrb.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $f37d2f7eaf2ad10e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $ciq1x.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $f37d2f7eaf2ad10e$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $f37d2f7eaf2ad10e$var$arrow,
    effect: $f37d2f7eaf2ad10e$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};

});

parcelRegister("95q7y", function(module, exports) {

$parcel$export(module.exports, "default", () => $69d8d7bda7717b01$export$2e2bcd8739ae039);

var $1KQnQ = parcelRequire("1KQnQ");

var $gGcga = parcelRequire("gGcga");
function $69d8d7bda7717b01$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $69d8d7bda7717b01$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $1KQnQ.top),
        (0, $1KQnQ.right),
        (0, $1KQnQ.bottom),
        (0, $1KQnQ.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $69d8d7bda7717b01$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $gGcga.default)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $gGcga.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $69d8d7bda7717b01$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $69d8d7bda7717b01$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $69d8d7bda7717b01$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $69d8d7bda7717b01$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $69d8d7bda7717b01$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $69d8d7bda7717b01$var$hide
};

});


parcelRegister("ai2Pb", function(module, exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $77ddc6be16b1d7de$var$hasElementType = typeof Element !== "undefined";
var $77ddc6be16b1d7de$var$hasMap = typeof Map === "function";
var $77ddc6be16b1d7de$var$hasSet = typeof Set === "function";
var $77ddc6be16b1d7de$var$hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $77ddc6be16b1d7de$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.1
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$77ddc6be16b1d7de$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($77ddc6be16b1d7de$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$77ddc6be16b1d7de$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($77ddc6be16b1d7de$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($77ddc6be16b1d7de$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($77ddc6be16b1d7de$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$77ddc6be16b1d7de$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return $77ddc6be16b1d7de$var$equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});



parcelRegister("ajOPb", function(module, exports) {

$parcel$export(module.exports, "Reference", () => $78331a6e34b5159b$export$e0be378c32fb70a7);

var $acw62 = parcelRequire("acw62");

var $kg9aN = parcelRequire("kg9aN");

var $12lqh = parcelRequire("12lqh");

var $2w0Xg = parcelRequire("2w0Xg");
function $78331a6e34b5159b$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $acw62.useContext((0, $12lqh.ManagerReferenceNodeSetterContext));
    var refHandler = $acw62.useCallback(function(node) {
        (0, $2w0Xg.setRef)(innerRef, node);
        (0, $2w0Xg.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $acw62.useEffect(function() {
        return function() {
            return (0, $2w0Xg.setRef)(innerRef, null);
        };
    }, []);
    $acw62.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($kg9aN)))(Boolean(setReferenceNode), "`Reference` should not be used outside of a `Manager` component.");
    }, [
        setReferenceNode
    ]);
    return (0, $2w0Xg.unwrapArray)(children)({
        ref: refHandler
    });
}

});


parcelRegister("3VkbS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $2db65b6b1e7798c8$export$2e2bcd8739ae039);

var $fSwVM = parcelRequire("fSwVM");

var $gdr0J = parcelRequire("gdr0J");

var $cZ2kT = parcelRequire("cZ2kT");

var $esGEx = parcelRequire("esGEx");

var $4LmDH = parcelRequire("4LmDH");
function $2db65b6b1e7798c8$export$2e2bcd8739ae039(dirtyDate, values) {
    (0, $4LmDH.default)(2, arguments);
    if ((0, $fSwVM.default)(values) !== "object" || values === null) throw new RangeError("values parameter must be an object");
    var date = (0, $gdr0J.default)(dirtyDate);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(date.getTime())) return new Date(NaN);
    if (values.year != null) date.setFullYear(values.year);
    if (values.month != null) date = (0, $cZ2kT.default)(date, values.month);
    if (values.date != null) date.setDate((0, $esGEx.default)(values.date));
    if (values.hours != null) date.setHours((0, $esGEx.default)(values.hours));
    if (values.minutes != null) date.setMinutes((0, $esGEx.default)(values.minutes));
    if (values.seconds != null) date.setSeconds((0, $esGEx.default)(values.seconds));
    if (values.milliseconds != null) date.setMilliseconds((0, $esGEx.default)(values.milliseconds));
    return date;
}

});


parcelRegister("8H68z", function(module, exports) {

!function(e, t) {
    module.exports = t((parcelRequire("acw62")));
}(module.exports, function(e) {
    return function(e) {
        function t(n) {
            if (r[n]) return r[n].exports;
            var o = r[n] = {
                exports: {},
                id: n,
                loaded: !1
            };
            return e[n].call(o.exports, o, o.exports, t), o.loaded = !0, o.exports;
        }
        var r = {};
        return t.m = e, t.c = r, t.p = "", t(0);
    }([
        function(e, t, r) {
            "use strict";
            function n(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            function o(e, t) {
                var r = {};
                for(var n in e)t.indexOf(n) >= 0 || Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
                return r;
            }
            function i(e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }
            function a(e, t) {
                if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return !t || "object" != typeof t && "function" != typeof t ? e : t;
            }
            function u(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        enumerable: !1,
                        writable: !0,
                        configurable: !0
                    }
                }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.conformToMask = void 0;
            var s = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r = arguments[t];
                    for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
                }
                return e;
            }, l = function() {
                function e(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                    }
                }
                return function(t, r, n) {
                    return r && e(t.prototype, r), n && e(t, n), t;
                };
            }(), f = r(3);
            Object.defineProperty(t, "conformToMask", {
                enumerable: !0,
                get: function() {
                    return n(f).default;
                }
            });
            var c = r(11), p = n(c), d = r(9), h = n(d), v = r(5), y = n(v), m = r(2), b = function(e) {
                function t() {
                    var e;
                    i(this, t);
                    for(var r = arguments.length, n = Array(r), o = 0; o < r; o++)n[o] = arguments[o];
                    var u = a(this, (e = t.__proto__ || Object.getPrototypeOf(t)).call.apply(e, [
                        this
                    ].concat(n)));
                    return u.setRef = u.setRef.bind(u), u.onBlur = u.onBlur.bind(u), u.onChange = u.onChange.bind(u), u;
                }
                return u(t, e), l(t, [
                    {
                        key: "setRef",
                        value: function(e) {
                            this.inputElement = e;
                        }
                    },
                    {
                        key: "initTextMask",
                        value: function() {
                            var e = this.props, t = this.props.value;
                            this.textMaskInputElement = (0, y.default)(s({
                                inputElement: this.inputElement
                            }, e)), this.textMaskInputElement.update(t);
                        }
                    },
                    {
                        key: "componentDidMount",
                        value: function() {
                            this.initTextMask();
                        }
                    },
                    {
                        key: "componentDidUpdate",
                        value: function(e) {
                            var t = this.props, r = t.value, n = t.pipe, o = t.mask, i = t.guide, a = t.placeholderChar, u = t.showMask, s = {
                                guide: i,
                                placeholderChar: a,
                                showMask: u
                            }, l = "function" == typeof n && "function" == typeof e.pipe ? n.toString() !== e.pipe.toString() : (0, m.isNil)(n) && !(0, m.isNil)(e.pipe) || !(0, m.isNil)(n) && (0, m.isNil)(e.pipe), f = o.toString() !== e.mask.toString(), c = Object.keys(s).some(function(t) {
                                return s[t] !== e[t];
                            }) || f || l, p = r !== this.inputElement.value;
                            (p || c) && this.initTextMask();
                        }
                    },
                    {
                        key: "render",
                        value: function e() {
                            var t = this.props, e = t.render, r = o(t, [
                                "render"
                            ]);
                            return delete r.mask, delete r.guide, delete r.pipe, delete r.placeholderChar, delete r.keepCharPositions, delete r.value, delete r.onBlur, delete r.onChange, delete r.showMask, e(this.setRef, s({
                                onBlur: this.onBlur,
                                onChange: this.onChange,
                                defaultValue: this.props.value
                            }, r));
                        }
                    },
                    {
                        key: "onChange",
                        value: function(e) {
                            this.textMaskInputElement.update(), "function" == typeof this.props.onChange && this.props.onChange(e);
                        }
                    },
                    {
                        key: "onBlur",
                        value: function(e) {
                            "function" == typeof this.props.onBlur && this.props.onBlur(e);
                        }
                    }
                ]), t;
            }(p.default.PureComponent);
            t.default = b, b.propTypes = {
                mask: h.default.oneOfType([
                    h.default.array,
                    h.default.func,
                    h.default.bool,
                    h.default.shape({
                        mask: h.default.oneOfType([
                            h.default.array,
                            h.default.func
                        ]),
                        pipe: h.default.func
                    })
                ]).isRequired,
                guide: h.default.bool,
                value: h.default.oneOfType([
                    h.default.string,
                    h.default.number
                ]),
                pipe: h.default.func,
                placeholderChar: h.default.string,
                keepCharPositions: h.default.bool,
                showMask: h.default.bool
            }, b.defaultProps = {
                render: function(e, t) {
                    return p.default.createElement("input", s({
                        ref: e
                    }, t));
                }
            };
        },
        function(e, t) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.placeholderChar = "_", t.strFunction = "function";
        },
        function(e, t, r) {
            "use strict";
            function n() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : f, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : l.placeholderChar;
                if (!o(e)) throw new Error("Text-mask:convertMaskToPlaceholder; The mask property must be an array.");
                if (e.indexOf(t) !== -1) throw new Error("Placeholder character must not be used as part of the mask. Please specify a character that is not present in your mask as your placeholder character.\n\n" + ("The placeholder character that was received is: " + JSON.stringify(t) + "\n\n") + ("The mask that was received is: " + JSON.stringify(e)));
                return e.map(function(e) {
                    return e instanceof RegExp ? t : e;
                }).join("");
            }
            function o(e) {
                return Array.isArray && Array.isArray(e) || e instanceof Array;
            }
            function i(e) {
                return "string" == typeof e || e instanceof String;
            }
            function a(e) {
                return "number" == typeof e && void 0 === e.length && !isNaN(e);
            }
            function u(e) {
                return "undefined" == typeof e || null === e;
            }
            function s(e) {
                for(var t = [], r = void 0; r = e.indexOf(c), r !== -1;)t.push(r), e.splice(r, 1);
                return {
                    maskWithoutCaretTraps: e,
                    indexes: t
                };
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.convertMaskToPlaceholder = n, t.isArray = o, t.isString = i, t.isNumber = a, t.isNil = u, t.processCaretTraps = s;
            var l = r(1), f = [], c = "[]";
        },
        function(e, t, r) {
            "use strict";
            function n() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : s, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : u, r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                if (!(0, i.isArray)(t)) {
                    if (("undefined" == typeof t ? "undefined" : o(t)) !== a.strFunction) throw new Error("Text-mask:conformToMask; The mask property must be an array.");
                    t = t(e, r), t = (0, i.processCaretTraps)(t).maskWithoutCaretTraps;
                }
                var n = r.guide, l = void 0 === n || n, f = r.previousConformedValue, c = void 0 === f ? s : f, p = r.placeholderChar, d = void 0 === p ? a.placeholderChar : p, h = r.placeholder, v = void 0 === h ? (0, i.convertMaskToPlaceholder)(t, d) : h, y = r.currentCaretPosition, m = r.keepCharPositions, b = l === !1 && void 0 !== c, g = e.length, k = c.length, C = v.length, O = t.length, T = g - k, P = T > 0, x = y + (P ? -T : 0), w = x + Math.abs(T);
                if (m === !0 && !P) {
                    for(var S = s, _ = x; _ < w; _++)v[_] === d && (S += d);
                    e = e.slice(0, x) + S + e.slice(x, g);
                }
                for(var M = e.split(s).map(function(e, t) {
                    return {
                        char: e,
                        isNew: t >= x && t < w
                    };
                }), j = g - 1; j >= 0; j--){
                    var E = M[j].char;
                    if (E !== d) {
                        var R = j >= x && k === O;
                        E === v[R ? j - T : j] && M.splice(j, 1);
                    }
                }
                var V = s, N = !1;
                e: for(var A = 0; A < C; A++){
                    var B = v[A];
                    if (B === d) {
                        if (M.length > 0) for(; M.length > 0;){
                            var I = M.shift(), F = I.char, q = I.isNew;
                            if (F === d && b !== !0) {
                                V += d;
                                continue e;
                            }
                            if (t[A].test(F)) {
                                if (m === !0 && q !== !1 && c !== s && l !== !1 && P) {
                                    for(var D = M.length, L = null, W = 0; W < D; W++){
                                        var J = M[W];
                                        if (J.char !== d && J.isNew === !1) break;
                                        if (J.char === d) {
                                            L = W;
                                            break;
                                        }
                                    }
                                    null !== L ? (V += F, M.splice(L, 1)) : A--;
                                } else V += F;
                                continue e;
                            }
                            N = !0;
                        }
                        b === !1 && (V += v.substr(A, C));
                        break;
                    }
                    V += B;
                }
                if (b && P === !1) {
                    for(var U = null, H = 0; H < V.length; H++)v[H] === d && (U = H);
                    V = null !== U ? V.substr(0, U + 1) : s;
                }
                return {
                    conformedValue: V,
                    meta: {
                        someCharsRejected: N
                    }
                };
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            };
            t.default = n;
            var i = r(2), a = r(1), u = [], s = "";
        },
        function(e, t) {
            "use strict";
            function r(e) {
                var t = e.previousConformedValue, r = void 0 === t ? o : t, i = e.previousPlaceholder, a = void 0 === i ? o : i, u = e.currentCaretPosition, s = void 0 === u ? 0 : u, l = e.conformedValue, f = e.rawValue, c = e.placeholderChar, p = e.placeholder, d = e.indexesOfPipedChars, h = void 0 === d ? n : d, v = e.caretTrapIndexes, y = void 0 === v ? n : v;
                if (0 === s || !f.length) return 0;
                var m = f.length, b = r.length, g = p.length, k = l.length, C = m - b, O = C > 0, T = 0 === b, P = C > 1 && !O && !T;
                if (P) return s;
                var x = O && (r === l || l === p), w = 0, S = void 0, _ = void 0;
                if (x) w = s - C;
                else {
                    var M = l.toLowerCase(), j = f.toLowerCase(), E = j.substr(0, s).split(o), R = E.filter(function(e) {
                        return M.indexOf(e) !== -1;
                    });
                    _ = R[R.length - 1];
                    var V = a.substr(0, R.length).split(o).filter(function(e) {
                        return e !== c;
                    }).length, N = p.substr(0, R.length).split(o).filter(function(e) {
                        return e !== c;
                    }).length, A = N !== V, B = void 0 !== a[R.length - 1] && void 0 !== p[R.length - 2] && a[R.length - 1] !== c && a[R.length - 1] !== p[R.length - 1] && a[R.length - 1] === p[R.length - 2];
                    !O && (A || B) && V > 0 && p.indexOf(_) > -1 && void 0 !== f[s] && (S = !0, _ = f[s]);
                    for(var I = h.map(function(e) {
                        return M[e];
                    }), F = I.filter(function(e) {
                        return e === _;
                    }).length, q = R.filter(function(e) {
                        return e === _;
                    }).length, D = p.substr(0, p.indexOf(c)).split(o).filter(function(e, t) {
                        return e === _ && f[t] !== e;
                    }).length, L = D + q + F + (S ? 1 : 0), W = 0, J = 0; J < k; J++){
                        var U = M[J];
                        if (w = J + 1, U === _ && W++, W >= L) break;
                    }
                }
                if (O) {
                    for(var H = w, Y = w; Y <= g; Y++)if (p[Y] === c && (H = Y), p[Y] === c || y.indexOf(Y) !== -1 || Y === g) return H;
                } else if (S) {
                    for(var z = w - 1; z >= 0; z--)if (l[z] === _ || y.indexOf(z) !== -1 || 0 === z) return z;
                } else for(var G = w; G >= 0; G--)if (p[G - 1] === c || y.indexOf(G) !== -1 || 0 === G) return G;
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.default = r;
            var n = [], o = "";
        },
        function(e, t, r) {
            "use strict";
            function n(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            function o(e) {
                var t = {
                    previousConformedValue: void 0,
                    previousPlaceholder: void 0
                };
                return {
                    state: t,
                    update: function(r) {
                        var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e, o = n.inputElement, l = n.mask, c = n.guide, y = n.pipe, b = n.placeholderChar, g = void 0 === b ? h.placeholderChar : b, k = n.keepCharPositions, C = void 0 !== k && k, O = n.showMask, T = void 0 !== O && O;
                        if ("undefined" == typeof r && (r = o.value), r !== t.previousConformedValue) {
                            ("undefined" == typeof l ? "undefined" : s(l)) === m && void 0 !== l.pipe && void 0 !== l.mask && (y = l.pipe, l = l.mask);
                            var P = void 0, x = void 0;
                            if (l instanceof Array && (P = (0, d.convertMaskToPlaceholder)(l, g)), l !== !1) {
                                var w = a(r), S = o.selectionEnd, _ = t.previousConformedValue, M = t.previousPlaceholder, j = void 0;
                                if (("undefined" == typeof l ? "undefined" : s(l)) === h.strFunction) {
                                    if (x = l(w, {
                                        currentCaretPosition: S,
                                        previousConformedValue: _,
                                        placeholderChar: g
                                    }), x === !1) return;
                                    var E = (0, d.processCaretTraps)(x), R = E.maskWithoutCaretTraps, V = E.indexes;
                                    x = R, j = V, P = (0, d.convertMaskToPlaceholder)(x, g);
                                } else x = l;
                                var N = {
                                    previousConformedValue: _,
                                    guide: c,
                                    placeholderChar: g,
                                    pipe: y,
                                    placeholder: P,
                                    currentCaretPosition: S,
                                    keepCharPositions: C
                                }, A = (0, p.default)(w, x, N), B = A.conformedValue, I = ("undefined" == typeof y ? "undefined" : s(y)) === h.strFunction, F = {};
                                I && (F = y(B, u({
                                    rawValue: w
                                }, N)), F === !1 ? F = {
                                    value: _,
                                    rejected: !0
                                } : (0, d.isString)(F) && (F = {
                                    value: F
                                }));
                                var q = I ? F.value : B, D = (0, f.default)({
                                    previousConformedValue: _,
                                    previousPlaceholder: M,
                                    conformedValue: q,
                                    placeholder: P,
                                    rawValue: w,
                                    currentCaretPosition: S,
                                    placeholderChar: g,
                                    indexesOfPipedChars: F.indexesOfPipedChars,
                                    caretTrapIndexes: j
                                }), L = q === P && 0 === D, W = T ? P : v, J = L ? W : q;
                                t.previousConformedValue = J, t.previousPlaceholder = P, o.value !== J && (o.value = J, i(o, D));
                            }
                        }
                    }
                };
            }
            function i(e, t) {
                document.activeElement === e && (b ? g(function() {
                    return e.setSelectionRange(t, t, y);
                }, 0) : e.setSelectionRange(t, t, y));
            }
            function a(e) {
                if ((0, d.isString)(e)) return e;
                if ((0, d.isNumber)(e)) return String(e);
                if (void 0 === e || null === e) return v;
                throw new Error("The 'value' provided to Text Mask needs to be a string or a number. The value received was:\n\n " + JSON.stringify(e));
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var u = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r = arguments[t];
                    for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
                }
                return e;
            }, s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            };
            t.default = o;
            var l = r(4), f = n(l), c = r(3), p = n(c), d = r(2), h = r(1), v = "", y = "none", m = "object", b = "undefined" != typeof navigator && /Android/i.test(navigator.userAgent), g = "undefined" != typeof requestAnimationFrame ? requestAnimationFrame : setTimeout;
        },
        function(e, t) {
            "use strict";
            function r(e) {
                return function() {
                    return e;
                };
            }
            var n = function() {};
            n.thatReturns = r, n.thatReturnsFalse = r(!1), n.thatReturnsTrue = r(!0), n.thatReturnsNull = r(null), n.thatReturnsThis = function() {
                return this;
            }, n.thatReturnsArgument = function(e) {
                return e;
            }, e.exports = n;
        },
        function(e, t, r) {
            "use strict";
            function n(e, t, r, n, i, a, u, s) {
                if (o(t), !e) {
                    var l;
                    if (void 0 === t) l = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
                    else {
                        var f = [
                            r,
                            n,
                            i,
                            a,
                            u,
                            s
                        ], c = 0;
                        l = new Error(t.replace(/%s/g, function() {
                            return f[c++];
                        })), l.name = "Invariant Violation";
                    }
                    throw l.framesToPop = 1, l;
                }
            }
            var o = function(e) {};
            e.exports = n;
        },
        function(e, t, r) {
            "use strict";
            var n = r(6), o = r(7), i = r(10);
            e.exports = function() {
                function e(e, t, r, n, a, u) {
                    u !== i && o(!1, "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                }
                function t() {
                    return e;
                }
                e.isRequired = e;
                var r = {
                    array: e,
                    bool: e,
                    func: e,
                    number: e,
                    object: e,
                    string: e,
                    symbol: e,
                    any: e,
                    arrayOf: t,
                    element: e,
                    instanceOf: t,
                    node: e,
                    objectOf: t,
                    oneOf: t,
                    oneOfType: t,
                    shape: t,
                    exact: t
                };
                return r.checkPropTypes = n, r.PropTypes = r, r;
            };
        },
        function(e, t, r) {
            "use strict";
            "function" == typeof Symbol && typeof Symbol.iterator, e.exports = r(8)();
        },
        function(e, t) {
            "use strict";
            var r = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
            e.exports = r;
        },
        function(t, r) {
            t.exports = e;
        }
    ]);
});

});

parcelRegister("4bj1a", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $30b6f111fa459d5a$export$1e511d4a378977f5, (v) => $30b6f111fa459d5a$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $30b6f111fa459d5a$export$2e2bcd8739ae039, (v) => $30b6f111fa459d5a$export$2e2bcd8739ae039 = v);
var $30b6f111fa459d5a$export$1e511d4a378977f5;
var $30b6f111fa459d5a$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$30b6f111fa459d5a$export$1e511d4a378977f5 = true;
$30b6f111fa459d5a$export$2e2bcd8739ae039 = void 0;

var $30b6f111fa459d5a$var$_inheritsLoose2 = $1jnue((parcelRequire("6r4zt")));

var $30b6f111fa459d5a$var$_react = $1jnue((parcelRequire("acw62")));

var $30b6f111fa459d5a$var$_reactDom = $1jnue((parcelRequire("1u0KT")));

var $30b6f111fa459d5a$var$_propTypes = $1jnue((parcelRequire("c9Z8w")));

var $gR6pc = parcelRequire("gR6pc");
var $30b6f111fa459d5a$var$propTypes = {
    children: $30b6f111fa459d5a$var$_propTypes.default.node.isRequired,
    node: $30b6f111fa459d5a$var$_propTypes.default.any
};
var $30b6f111fa459d5a$var$Portal = /*#__PURE__*/ function(_React$Component) {
    (0, $30b6f111fa459d5a$var$_inheritsLoose2.default)(Portal, _React$Component);
    function Portal() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Portal.prototype;
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.defaultNode) document.body.removeChild(this.defaultNode);
        this.defaultNode = null;
    };
    _proto.render = function render() {
        if (!$gR6pc.canUseDOM) return null;
        if (!this.props.node && !this.defaultNode) {
            this.defaultNode = document.createElement("div");
            document.body.appendChild(this.defaultNode);
        }
        return /*#__PURE__*/ $30b6f111fa459d5a$var$_reactDom.default.createPortal(this.props.children, this.props.node || this.defaultNode);
    };
    return Portal;
}($30b6f111fa459d5a$var$_react.default.Component);
$30b6f111fa459d5a$var$Portal.propTypes = $30b6f111fa459d5a$var$propTypes;
var $30b6f111fa459d5a$var$_default = $30b6f111fa459d5a$var$Portal;
$30b6f111fa459d5a$export$2e2bcd8739ae039 = $30b6f111fa459d5a$var$_default;

});
parcelRegister("gR6pc", function(module, exports) {

$parcel$export(module.exports, "canUseDOM", () => $c4569097306d9687$export$71594e8a50f746f4, (v) => $c4569097306d9687$export$71594e8a50f746f4 = v);
var $c4569097306d9687$export$1e511d4a378977f5;
var $c4569097306d9687$export$ace028f8da1a6300;
var $c4569097306d9687$export$525633cdbd0969b;
var $c4569097306d9687$export$31b5c8f1131a3a52;
var $c4569097306d9687$export$f6a6870365e84923;
var $c4569097306d9687$export$999f192bbd2b2d9e;
var $c4569097306d9687$export$e66f39a23d6009b0;
var $c4569097306d9687$export$30a9f098026c5d15;
var $c4569097306d9687$export$30a06c8d3562193f;
var $c4569097306d9687$export$357523c63a2253b9;
var $c4569097306d9687$export$5b28268982f175ba;
var $c4569097306d9687$export$cdd73fc4100a6ef4;
var $c4569097306d9687$export$97d587dc2049b818;
var $c4569097306d9687$export$e10d8bcaa14e0681;
var $c4569097306d9687$export$a0a81dc3380ce7d3;
var $c4569097306d9687$export$a6cdc56e425d0d0a;
var $c4569097306d9687$export$f6e2535fb5126e54;
var $c4569097306d9687$export$296b302fe9d56784;
var $c4569097306d9687$export$3aa3c75b371c352f;
var $c4569097306d9687$export$c22522a4dfa48e9c;
var $c4569097306d9687$export$544835a2f8292483;
var $c4569097306d9687$export$e2690578cac908dd;
var $c4569097306d9687$export$6723c67dee1450cf;
var $c4569097306d9687$export$71594e8a50f746f4;
var $c4569097306d9687$export$b8db120174e0a6fa;
var $c4569097306d9687$export$6d3e562ac77a9517;
var $c4569097306d9687$export$9f15c0603df35428;
var $c4569097306d9687$export$33d93b05441a6936;
var $c4569097306d9687$export$b725afd3e8acce35;
var $c4569097306d9687$export$ba0f6daf9558be46;
var $c4569097306d9687$export$41ef22d2f70c9575;
"use strict";

var $1jnue = parcelRequire("1jnue");
$c4569097306d9687$export$1e511d4a378977f5 = true;
$c4569097306d9687$export$ace028f8da1a6300 = $c4569097306d9687$var$getScrollbarWidth;
$c4569097306d9687$export$525633cdbd0969b = $c4569097306d9687$var$setScrollbarWidth;
$c4569097306d9687$export$31b5c8f1131a3a52 = $c4569097306d9687$var$isBodyOverflowing;
$c4569097306d9687$export$f6a6870365e84923 = $c4569097306d9687$var$getOriginalBodyPadding;
$c4569097306d9687$export$999f192bbd2b2d9e = $c4569097306d9687$var$conditionallyUpdateScrollbar;
$c4569097306d9687$export$e66f39a23d6009b0 = $c4569097306d9687$var$setGlobalCssModule;
$c4569097306d9687$export$30a9f098026c5d15 = $c4569097306d9687$var$mapToCssModules;
$c4569097306d9687$export$30a06c8d3562193f = $c4569097306d9687$var$omit;
$c4569097306d9687$export$357523c63a2253b9 = $c4569097306d9687$var$pick;
$c4569097306d9687$export$5b28268982f175ba = $c4569097306d9687$var$warnOnce;
$c4569097306d9687$export$cdd73fc4100a6ef4 = $c4569097306d9687$var$deprecated;
$c4569097306d9687$export$97d587dc2049b818 = $c4569097306d9687$var$DOMElement;
$c4569097306d9687$export$e10d8bcaa14e0681 = $c4569097306d9687$var$isReactRefObj;
$c4569097306d9687$export$a0a81dc3380ce7d3 = $c4569097306d9687$var$toNumber;
$c4569097306d9687$export$a6cdc56e425d0d0a = $c4569097306d9687$var$isObject;
$c4569097306d9687$export$f6e2535fb5126e54 = $c4569097306d9687$var$isFunction;
$c4569097306d9687$export$296b302fe9d56784 = $c4569097306d9687$var$findDOMElements;
$c4569097306d9687$export$3aa3c75b371c352f = $c4569097306d9687$var$isArrayOrNodeList;
$c4569097306d9687$export$c22522a4dfa48e9c = $c4569097306d9687$var$getTarget;
$c4569097306d9687$export$544835a2f8292483 = $c4569097306d9687$var$addMultipleEventListeners;
$c4569097306d9687$export$e2690578cac908dd = $c4569097306d9687$export$6723c67dee1450cf = $c4569097306d9687$export$71594e8a50f746f4 = $c4569097306d9687$export$b8db120174e0a6fa = $c4569097306d9687$export$6d3e562ac77a9517 = $c4569097306d9687$export$9f15c0603df35428 = $c4569097306d9687$export$33d93b05441a6936 = $c4569097306d9687$export$b725afd3e8acce35 = $c4569097306d9687$export$ba0f6daf9558be46 = $c4569097306d9687$export$41ef22d2f70c9575 = void 0;

var $c4569097306d9687$var$_propTypes = $1jnue((parcelRequire("c9Z8w")));
// https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/js/src/modal.js#L436-L443
function $c4569097306d9687$var$getScrollbarWidth() {
    var scrollDiv = document.createElement("div"); // .modal-scrollbar-measure styles // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/scss/_modal.scss#L106-L113
    scrollDiv.style.position = "absolute";
    scrollDiv.style.top = "-9999px";
    scrollDiv.style.width = "50px";
    scrollDiv.style.height = "50px";
    scrollDiv.style.overflow = "scroll";
    document.body.appendChild(scrollDiv);
    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollbarWidth;
}
function $c4569097306d9687$var$setScrollbarWidth(padding) {
    document.body.style.paddingRight = padding > 0 ? padding + "px" : null;
}
function $c4569097306d9687$var$isBodyOverflowing() {
    return document.body.clientWidth < window.innerWidth;
}
function $c4569097306d9687$var$getOriginalBodyPadding() {
    var style = window.getComputedStyle(document.body, null);
    return parseInt(style && style.getPropertyValue("padding-right") || 0, 10);
}
function $c4569097306d9687$var$conditionallyUpdateScrollbar() {
    var scrollbarWidth = $c4569097306d9687$var$getScrollbarWidth(); // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.6/js/src/modal.js#L433
    var fixedContent = document.querySelectorAll(".fixed-top, .fixed-bottom, .is-fixed, .sticky-top")[0];
    var bodyPadding = fixedContent ? parseInt(fixedContent.style.paddingRight || 0, 10) : 0;
    if ($c4569097306d9687$var$isBodyOverflowing()) $c4569097306d9687$var$setScrollbarWidth(bodyPadding + scrollbarWidth);
}
var $c4569097306d9687$var$globalCssModule;
function $c4569097306d9687$var$setGlobalCssModule(cssModule) {
    $c4569097306d9687$var$globalCssModule = cssModule;
}
function $c4569097306d9687$var$mapToCssModules(className, cssModule) {
    if (className === void 0) className = "";
    if (cssModule === void 0) cssModule = $c4569097306d9687$var$globalCssModule;
    if (!cssModule) return className;
    return className.split(" ").map(function(c) {
        return cssModule[c] || c;
    }).join(" ");
}
/**
 * Returns a new object with the key/value pairs from `obj` that are not in the array `omitKeys`.
 */ function $c4569097306d9687$var$omit(obj, omitKeys) {
    var result = {};
    Object.keys(obj).forEach(function(key) {
        if (omitKeys.indexOf(key) === -1) result[key] = obj[key];
    });
    return result;
}
/**
 * Returns a filtered copy of an object with only the specified keys.
 */ function $c4569097306d9687$var$pick(obj, keys) {
    var pickKeys = Array.isArray(keys) ? keys : [
        keys
    ];
    var length = pickKeys.length;
    var key;
    var result = {};
    while(length > 0){
        length -= 1;
        key = pickKeys[length];
        result[key] = obj[key];
    }
    return result;
}
var $c4569097306d9687$var$warned = {};
function $c4569097306d9687$var$warnOnce(message) {
    if (!$c4569097306d9687$var$warned[message]) {
        /* istanbul ignore else */ if (typeof console !== "undefined") console.error(message); // eslint-disable-line no-console
        $c4569097306d9687$var$warned[message] = true;
    }
}
function $c4569097306d9687$var$deprecated(propType, explanation) {
    return function validate(props, propName, componentName) {
        if (props[propName] !== null && typeof props[propName] !== "undefined") $c4569097306d9687$var$warnOnce('"' + propName + '" property of "' + componentName + '" has been deprecated.\n' + explanation);
        for(var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)rest[_key - 3] = arguments[_key];
        return propType.apply(void 0, [
            props,
            propName,
            componentName
        ].concat(rest));
    };
} // Shim Element if needed (e.g. in Node environment)
var $c4569097306d9687$var$Element = typeof window === "object" && window.Element || function() {};
function $c4569097306d9687$var$DOMElement(props, propName, componentName) {
    if (!(props[propName] instanceof $c4569097306d9687$var$Element)) return new Error("Invalid prop `" + propName + "` supplied to `" + componentName + "`. Expected prop to be an instance of Element. Validation failed.");
}
var $c4569097306d9687$var$targetPropType = $c4569097306d9687$var$_propTypes.default.oneOfType([
    $c4569097306d9687$var$_propTypes.default.string,
    $c4569097306d9687$var$_propTypes.default.func,
    $c4569097306d9687$var$DOMElement,
    $c4569097306d9687$var$_propTypes.default.shape({
        current: $c4569097306d9687$var$_propTypes.default.any
    })
]);
$c4569097306d9687$export$41ef22d2f70c9575 = $c4569097306d9687$var$targetPropType;
var $c4569097306d9687$var$tagPropType = $c4569097306d9687$var$_propTypes.default.oneOfType([
    $c4569097306d9687$var$_propTypes.default.func,
    $c4569097306d9687$var$_propTypes.default.string,
    $c4569097306d9687$var$_propTypes.default.shape({
        $$typeof: $c4569097306d9687$var$_propTypes.default.symbol,
        render: $c4569097306d9687$var$_propTypes.default.func
    }),
    $c4569097306d9687$var$_propTypes.default.arrayOf($c4569097306d9687$var$_propTypes.default.oneOfType([
        $c4569097306d9687$var$_propTypes.default.func,
        $c4569097306d9687$var$_propTypes.default.string,
        $c4569097306d9687$var$_propTypes.default.shape({
            $$typeof: $c4569097306d9687$var$_propTypes.default.symbol,
            render: $c4569097306d9687$var$_propTypes.default.func
        })
    ]))
]);
/* eslint key-spacing: ["error", { afterColon: true, align: "value" }] */ // These are all setup to match what is in the bootstrap _variables.scss
// https://github.com/twbs/bootstrap/blob/v4-dev/scss/_variables.scss
$c4569097306d9687$export$ba0f6daf9558be46 = $c4569097306d9687$var$tagPropType;
var $c4569097306d9687$var$TransitionTimeouts = {
    Fade: 150,
    // $transition-fade
    Collapse: 350,
    // $transition-collapse
    Modal: 300,
    // $modal-transition
    Carousel: 600 // $carousel-transition
}; // Duplicated Transition.propType keys to ensure that Reactstrap builds
// for distribution properly exclude these keys for nested child HTML attributes
// since `react-transition-group` removes propTypes in production builds.
$c4569097306d9687$export$b725afd3e8acce35 = $c4569097306d9687$var$TransitionTimeouts;
var $c4569097306d9687$var$TransitionPropTypeKeys = [
    "in",
    "mountOnEnter",
    "unmountOnExit",
    "appear",
    "enter",
    "exit",
    "timeout",
    "onEnter",
    "onEntering",
    "onEntered",
    "onExit",
    "onExiting",
    "onExited"
];
$c4569097306d9687$export$33d93b05441a6936 = $c4569097306d9687$var$TransitionPropTypeKeys;
var $c4569097306d9687$var$TransitionStatuses = {
    ENTERING: "entering",
    ENTERED: "entered",
    EXITING: "exiting",
    EXITED: "exited"
};
$c4569097306d9687$export$9f15c0603df35428 = $c4569097306d9687$var$TransitionStatuses;
var $c4569097306d9687$var$keyCodes = {
    esc: 27,
    space: 32,
    enter: 13,
    tab: 9,
    up: 38,
    down: 40,
    home: 36,
    end: 35,
    n: 78,
    p: 80
};
$c4569097306d9687$export$6d3e562ac77a9517 = $c4569097306d9687$var$keyCodes;
var $c4569097306d9687$var$PopperPlacements = [
    "auto-start",
    "auto",
    "auto-end",
    "top-start",
    "top",
    "top-end",
    "right-start",
    "right",
    "right-end",
    "bottom-end",
    "bottom",
    "bottom-start",
    "left-end",
    "left",
    "left-start"
];
$c4569097306d9687$export$b8db120174e0a6fa = $c4569097306d9687$var$PopperPlacements;
var $c4569097306d9687$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
$c4569097306d9687$export$71594e8a50f746f4 = $c4569097306d9687$var$canUseDOM;
function $c4569097306d9687$var$isReactRefObj(target) {
    if (target && typeof target === "object") return "current" in target;
    return false;
}
function $c4569097306d9687$var$getTag(value) {
    if (value == null) return value === undefined ? "[object Undefined]" : "[object Null]";
    return Object.prototype.toString.call(value);
}
function $c4569097306d9687$var$toNumber(value) {
    var type = typeof value;
    var NAN = 0 / 0;
    if (type === "number") return value;
    if (type === "symbol" || type === "object" && $c4569097306d9687$var$getTag(value) === "[object Symbol]") return NAN;
    if ($c4569097306d9687$var$isObject(value)) {
        var other = typeof value.valueOf === "function" ? value.valueOf() : value;
        value = $c4569097306d9687$var$isObject(other) ? "" + other : other;
    }
    if (type !== "string") return value === 0 ? value : +value;
    value = value.replace(/^\s+|\s+$/g, "");
    var isBinary = /^0b[01]+$/i.test(value);
    return isBinary || /^0o[0-7]+$/i.test(value) ? parseInt(value.slice(2), isBinary ? 2 : 8) : /^[-+]0x[0-9a-f]+$/i.test(value) ? NAN : +value;
}
function $c4569097306d9687$var$isObject(value) {
    var type = typeof value;
    return value != null && (type === "object" || type === "function");
}
function $c4569097306d9687$var$isFunction(value) {
    if (!$c4569097306d9687$var$isObject(value)) return false;
    var tag = $c4569097306d9687$var$getTag(value);
    return tag === "[object Function]" || tag === "[object AsyncFunction]" || tag === "[object GeneratorFunction]" || tag === "[object Proxy]";
}
function $c4569097306d9687$var$findDOMElements(target) {
    if ($c4569097306d9687$var$isReactRefObj(target)) return target.current;
    if ($c4569097306d9687$var$isFunction(target)) return target();
    if (typeof target === "string" && $c4569097306d9687$var$canUseDOM) {
        var selection = document.querySelectorAll(target);
        if (!selection.length) selection = document.querySelectorAll("#" + target);
        if (!selection.length) throw new Error("The target '" + target + "' could not be identified in the dom, tip: check spelling");
        return selection;
    }
    return target;
}
function $c4569097306d9687$var$isArrayOrNodeList(els) {
    if (els === null) return false;
    return Array.isArray(els) || $c4569097306d9687$var$canUseDOM && typeof els.length === "number";
}
function $c4569097306d9687$var$getTarget(target, allElements) {
    var els = $c4569097306d9687$var$findDOMElements(target);
    if (allElements) {
        if ($c4569097306d9687$var$isArrayOrNodeList(els)) return els;
        if (els === null) return [];
        return [
            els
        ];
    } else {
        if ($c4569097306d9687$var$isArrayOrNodeList(els)) return els[0];
        return els;
    }
}
var $c4569097306d9687$var$defaultToggleEvents = [
    "touchstart",
    "click"
];
$c4569097306d9687$export$6723c67dee1450cf = $c4569097306d9687$var$defaultToggleEvents;
function $c4569097306d9687$var$addMultipleEventListeners(_els, handler, _events, useCapture) {
    var els = _els;
    if (!$c4569097306d9687$var$isArrayOrNodeList(els)) els = [
        els
    ];
    var events = _events;
    if (typeof events === "string") events = events.split(/\s+/);
    if (!$c4569097306d9687$var$isArrayOrNodeList(els) || typeof handler !== "function" || !Array.isArray(events)) throw new Error("\n      The first argument of this function must be DOM node or an array on DOM nodes or NodeList.\n      The second must be a function.\n      The third is a string or an array of strings that represents DOM events\n    ");
    Array.prototype.forEach.call(events, function(event) {
        Array.prototype.forEach.call(els, function(el) {
            el.addEventListener(event, handler, useCapture);
        });
    });
    return function removeEvents() {
        Array.prototype.forEach.call(events, function(event) {
            Array.prototype.forEach.call(els, function(el) {
                el.removeEventListener(event, handler, useCapture);
            });
        });
    };
}
var $c4569097306d9687$var$focusableElements = [
    "a[href]",
    "area[href]",
    "input:not([disabled]):not([type=hidden])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "button:not([disabled])",
    "object",
    "embed",
    "[tabindex]:not(.modal)",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])'
];
$c4569097306d9687$export$e2690578cac908dd = $c4569097306d9687$var$focusableElements;

});





parcelRegister("cPy95", function(module, exports) {
"use strict";
var $9574bc0f9d80c531$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $9574bc0f9d80c531$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $9574bc0f9d80c531$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $9574bc0f9d80c531$var$__createBinding(result, mod, k);
    }
    $9574bc0f9d80c531$var$__setModuleDefault(result, mod);
    return result;
};
var $9574bc0f9d80c531$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $9574bc0f9d80c531$var$react_1 = $9574bc0f9d80c531$var$__importStar((parcelRequire("acw62")));

const $9574bc0f9d80c531$var$date_picker_1 = $9574bc0f9d80c531$var$__importDefault((parcelRequire("28fod")));
const $9574bc0f9d80c531$var$DatePickerEditor = $9574bc0f9d80c531$var$react_1.default.forwardRef((props, ref)=>{
    const [value, setValue] = (0, $9574bc0f9d80c531$var$react_1.useState)(props.value);
    const wrapperRef = (0, $9574bc0f9d80c531$var$react_1.useRef)(null);
    /* Component Editor Lifecycle methods */ (0, $9574bc0f9d80c531$var$react_1.useImperativeHandle)(ref, ()=>{
        return {
            // the final value to send to the grid, on completion of editing
            getValue () {
                // this simple editor doubles any value entered into the input
                return value;
            },
            // Gets called once before editing starts, to give editor a chance to
            // cancel the editing before it even starts.
            isCancelBeforeStart () {
                return false;
            },
            // Gets called once when editing is finished (eg if Enter is pressed).
            // If you return true, then the result of the edit will be ignored.
            isCancelAfterEnd () {
                return false;
            }
        };
    });
    const handleKeydown = (0, $9574bc0f9d80c531$var$react_1.useCallback)((e)=>{
        if (e.key === "Enter") // added to fix keyboard control issue when selecting a date with enter
        e.preventDefault();
    }, []);
    (0, $9574bc0f9d80c531$var$react_1.useEffect)(()=>{
        if (wrapperRef.current) {
            const wrapperElement = wrapperRef.current;
            wrapperElement.addEventListener("keydown", handleKeydown);
            return ()=>{
                wrapperElement.removeEventListener("keydown", handleKeydown);
            };
        }
    }, [
        wrapperRef,
        value,
        handleKeydown
    ]);
    return $9574bc0f9d80c531$var$react_1.default.createElement("div", {
        ref: wrapperRef
    }, $9574bc0f9d80c531$var$react_1.default.createElement($9574bc0f9d80c531$var$date_picker_1.default, {
        value: value,
        usePortal: true,
        displayFormat: props.displayFormat,
        backEndFormat: props.backEndFormat,
        placeholderText: props.placeholderText,
        onChange: (date)=>{
            setValue(date);
            if (date) setTimeout(()=>{
                props.stopEditing();
            }, 0);
        }
    }));
});
$9574bc0f9d80c531$var$DatePickerEditor.displayName = "DatePickerEditor";
module.exports.default = $9574bc0f9d80c531$var$DatePickerEditor;

});

parcelRegister("6aFEg", function(module, exports) {
"use strict";
var $47e3fbc72dfff354$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $47e3fbc72dfff354$var$react_1 = $47e3fbc72dfff354$var$__importDefault((parcelRequire("acw62")));

var $jLhnw = parcelRequire("jLhnw");
const $47e3fbc72dfff354$var$Container = (props)=>$47e3fbc72dfff354$var$react_1.default.createElement($jLhnw.default, {
        ...props,
        "data-lwt-id": props.dataLwtId
    });
module.exports.default = $47e3fbc72dfff354$var$Container;

});
parcelRegister("jLhnw", function(module, exports) {

$parcel$export(module.exports, "default", () => $e62fe3163db4a454$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $e9hDx = parcelRequire("e9hDx");
var $e62fe3163db4a454$var$propTypes = {
    tag: (0, $e9hDx.tagPropType),
    fluid: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $e62fe3163db4a454$var$defaultProps = {
    tag: "div"
};
var $e62fe3163db4a454$var$Container = function Container(props) {
    var className = props.className, cssModule = props.cssModule, fluid = props.fluid, Tag = props.tag, attributes = (0, $1En50.default)(props, [
        "className",
        "cssModule",
        "fluid",
        "tag"
    ]);
    var containerClass = "container";
    if (fluid === true) containerClass = "container-fluid";
    else if (fluid) containerClass = "container-" + fluid;
    var classes = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, containerClass), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({}, attributes, {
        className: classes
    }));
};
$e62fe3163db4a454$var$Container.propTypes = $e62fe3163db4a454$var$propTypes;
$e62fe3163db4a454$var$Container.defaultProps = $e62fe3163db4a454$var$defaultProps;
var $e62fe3163db4a454$export$2e2bcd8739ae039 = $e62fe3163db4a454$var$Container;

});


parcelRegister("41wKJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $2ee0a96fc9b711df$export$2e2bcd8739ae039);

var $fyA5c = parcelRequire("fyA5c");
var $2ee0a96fc9b711df$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($fyA5c)));

});
parcelRegister("fyA5c", function(module, exports) {
"use strict";
var $b5360549dc877a3f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $b5360549dc877a3f$var$react_1 = $b5360549dc877a3f$var$__importDefault((parcelRequire("acw62")));

var $itPGX = parcelRequire("itPGX");
var $hH6b2 = parcelRequire("hH6b2");

const $b5360549dc877a3f$var$anchor_1 = $b5360549dc877a3f$var$__importDefault((parcelRequire("8jay8")));

const $b5360549dc877a3f$var$icon_1 = $b5360549dc877a3f$var$__importDefault((parcelRequire("aTLkh")));
const $b5360549dc877a3f$var$Breadcrumb = (props)=>{
    const { layout: layout, currentIndex: currentIndex, iconName: iconName, hr: hr, dataLwtId: dataLwtId, ...rest } = props;
    return currentIndex >= 0 ? $b5360549dc877a3f$var$react_1.default.createElement("div", {
        "data-lwt-id": dataLwtId
    }, [
        "top",
        "both"
    ].includes(hr) && $b5360549dc877a3f$var$react_1.default.createElement("hr", {
        className: "my-1 pb-2"
    }), $b5360549dc877a3f$var$react_1.default.createElement($itPGX.default, {
        ...rest
    }, $b5360549dc877a3f$var$react_1.default.createElement($b5360549dc877a3f$var$icon_1.default, {
        dataLwtId: `${dataLwtId}-icon`,
        iconName: iconName
    }), layout && layout.map((item, index)=>currentIndex >= index ? $b5360549dc877a3f$var$react_1.default.createElement($hH6b2.default, {
            key: `bci_${index}`
        }, item.handleClick ? $b5360549dc877a3f$var$react_1.default.createElement($b5360549dc877a3f$var$anchor_1.default, {
            dataLwtId: `${dataLwtId}-anchor-${index}`,
            onClick: item.handleClick
        }, item.text) : item.text) : null)), [
        "bottom",
        "both"
    ].includes(hr) && $b5360549dc877a3f$var$react_1.default.createElement("hr", {
        className: "my-1"
    })) : null;
};
$b5360549dc877a3f$var$Breadcrumb.defaultProps = {
    currentIndex: Number.POSITIVE_INFINITY,
    iconName: "arrow_back",
    hr: "none"
};
module.exports.default = $b5360549dc877a3f$var$Breadcrumb;

});
parcelRegister("itPGX", function(module, exports) {

$parcel$export(module.exports, "default", () => $d743085d147e78d5$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $e9hDx = parcelRequire("e9hDx");
var $d743085d147e78d5$var$propTypes = {
    tag: (0, $e9hDx.tagPropType),
    listTag: (0, $e9hDx.tagPropType),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    listClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    "aria-label": (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};
var $d743085d147e78d5$var$defaultProps = {
    tag: "nav",
    listTag: "ol",
    "aria-label": "breadcrumb"
};
var $d743085d147e78d5$var$Breadcrumb = function Breadcrumb(props) {
    var className = props.className, listClassName = props.listClassName, cssModule = props.cssModule, children = props.children, Tag = props.tag, ListTag = props.listTag, label = props["aria-label"], attributes = (0, $1En50.default)(props, [
        "className",
        "listClassName",
        "cssModule",
        "children",
        "tag",
        "listTag",
        "aria-label"
    ]);
    var classes = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className), cssModule);
    var listClasses = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("breadcrumb", listClassName), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({}, attributes, {
        className: classes,
        "aria-label": label
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ListTag, {
        className: listClasses
    }, children));
};
$d743085d147e78d5$var$Breadcrumb.propTypes = $d743085d147e78d5$var$propTypes;
$d743085d147e78d5$var$Breadcrumb.defaultProps = $d743085d147e78d5$var$defaultProps;
var $d743085d147e78d5$export$2e2bcd8739ae039 = $d743085d147e78d5$var$Breadcrumb;

});

parcelRegister("hH6b2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce1b3e70fa9b212b$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $e9hDx = parcelRequire("e9hDx");
var $ce1b3e70fa9b212b$var$propTypes = {
    tag: (0, $e9hDx.tagPropType),
    active: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $ce1b3e70fa9b212b$var$defaultProps = {
    tag: "li"
};
var $ce1b3e70fa9b212b$var$BreadcrumbItem = function BreadcrumbItem(props) {
    var className = props.className, cssModule = props.cssModule, active = props.active, Tag = props.tag, attributes = (0, $1En50.default)(props, [
        "className",
        "cssModule",
        "active",
        "tag"
    ]);
    var classes = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, active ? "active" : false, "breadcrumb-item"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({}, attributes, {
        className: classes,
        "aria-current": active ? "page" : undefined
    }));
};
$ce1b3e70fa9b212b$var$BreadcrumbItem.propTypes = $ce1b3e70fa9b212b$var$propTypes;
$ce1b3e70fa9b212b$var$BreadcrumbItem.defaultProps = $ce1b3e70fa9b212b$var$defaultProps;
var $ce1b3e70fa9b212b$export$2e2bcd8739ae039 = $ce1b3e70fa9b212b$var$BreadcrumbItem;

});

parcelRegister("8jay8", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $60c847fe6b3f3431$export$2e2bcd8739ae039);

var $eE0eW = parcelRequire("eE0eW");
var $60c847fe6b3f3431$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($eE0eW)));

});
parcelRegister("eE0eW", function(module, exports) {
"use strict";
var $aa94fcc829f927fb$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $aa94fcc829f927fb$var$react_1 = $aa94fcc829f927fb$var$__importDefault((parcelRequire("acw62")));
const $aa94fcc829f927fb$var$Anchor = (props)=>$aa94fcc829f927fb$var$react_1.default.createElement("a", {
        ...props,
        tabIndex: 0,
        "data-lwt-id": props.dataLwtId,
        onKeyPress: props.onClick && ((e)=>{
            if (e.key === "Enter") props.onClick();
        }),
        children: props.children
    });
module.exports.default = $aa94fcc829f927fb$var$Anchor;

});


parcelRegister("aTLkh", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7ef3c06417f72a97$export$2e2bcd8739ae039);

var $byhBe = parcelRequire("byhBe");
var $7ef3c06417f72a97$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($byhBe)));

});
parcelRegister("byhBe", function(module, exports) {
"use strict";
var $86908599c7422da1$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $86908599c7422da1$var$react_1 = $86908599c7422da1$var$__importDefault((parcelRequire("acw62")));

const $86908599c7422da1$var$classnames_1 = $86908599c7422da1$var$__importDefault((parcelRequire("8g1PZ")));
const $86908599c7422da1$var$Icon = (props)=>{
    const { iconName: iconName, className: className, dataLwtId: dataLwtId, disabled: disabled } = props;
    const disabledIcon = disabled ? {
        "pointer-events": "none"
    } : {};
    // defining style as a spread operator to avoid compiler error:
    //     `Property 'style' does not exist on type 'IntrinsicAttributes & IconProps & { children?: ReactNode; }'`
    const iconProps = {
        style: disabledIcon
    };
    const classes = (0, $86908599c7422da1$var$classnames_1.default)("material-icons", className);
    return $86908599c7422da1$var$react_1.default.createElement("i", {
        className: classes,
        "aria-hidden": true,
        "data-lwt-id": dataLwtId,
        ...iconProps
    }, iconName);
};
$86908599c7422da1$var$Icon.defaultProps = {
    iconName: "person"
};
module.exports.default = $86908599c7422da1$var$Icon;

});




parcelRegister("6OSul", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $4f71addbc2d8d2ad$export$2e2bcd8739ae039);

var $fZnQN = parcelRequire("fZnQN");
var $4f71addbc2d8d2ad$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($fZnQN)));

});
parcelRegister("fZnQN", function(module, exports) {
"use strict";
var $ba3f0db9083505f9$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $ba3f0db9083505f9$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $ba3f0db9083505f9$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $ba3f0db9083505f9$var$__createBinding(result, mod, k);
    }
    $ba3f0db9083505f9$var$__setModuleDefault(result, mod);
    return result;
};
var $ba3f0db9083505f9$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $ba3f0db9083505f9$var$react_1 = $ba3f0db9083505f9$var$__importStar((parcelRequire("acw62")));

const $ba3f0db9083505f9$var$anchor_1 = $ba3f0db9083505f9$var$__importDefault((parcelRequire("8jay8")));
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");
const $ba3f0db9083505f9$var$SideMenu = (props)=>{
    const [globalActive, setGlobalActive] = (0, $ba3f0db9083505f9$var$react_1.useState)(false);
    const [globalActiveParentIndex, setGlobalActiveParentIndex] = (0, $ba3f0db9083505f9$var$react_1.useState)(null);
    const { layout: layout, activeSectionIndex: activeSectionIndex, global: global, title: title, dataLwtId: dataLwtId } = props;
    return $ba3f0db9083505f9$var$react_1.default.createElement("nav", {
        className: `side-menu${global ? " side-menu-global" : ""}`,
        "data-lwt-id": dataLwtId
    }, $ba3f0db9083505f9$var$react_1.default.createElement("span", {
        className: "nav-mainmenu--title",
        onClick: ()=>{
            globalActive && setGlobalActiveParentIndex(null);
            setGlobalActive(!globalActive);
        }
    }, $ba3f0db9083505f9$var$react_1.default.createElement($6thlO.default, {
        className: "btn btn-light btn-xs menu-icon d-inline-block",
        dataLwtId: `${dataLwtId}-button`,
        // @ts-ignore
        rel: "tooltip",
        "data-placement": "top",
        title: title || "Menu Title",
        "aria-label": title || "Menu Title",
        "aria-haspopup": "true",
        "aria-expanded": "false"
    }, $ba3f0db9083505f9$var$react_1.default.createElement("span", null, $ba3f0db9083505f9$var$react_1.default.createElement("span", {
        className: "s1"
    }), $ba3f0db9083505f9$var$react_1.default.createElement("span", {
        className: "s2"
    }), $ba3f0db9083505f9$var$react_1.default.createElement("span", {
        className: "s3"
    }))), $ba3f0db9083505f9$var$react_1.default.createElement("a", null, globalActiveParentIndex !== null && $ba3f0db9083505f9$var$react_1.default.createElement("span", {
        className: "text-primary",
        onClick: (e)=>{
            setGlobalActiveParentIndex(null);
            e.stopPropagation();
        }
    }, $ba3f0db9083505f9$var$react_1.default.createElement("i", {
        className: "material-icons"
    }, "arrow_back"), "Back / "), title || "")), $ba3f0db9083505f9$var$react_1.default.createElement("ul", {
        className: `nav nav-mainmenu${globalActive ? " active" : ""}`
    }, layout.sections && layout.sections.map((parentSection, parentIndex)=>$ba3f0db9083505f9$var$react_1.default.createElement("li", {
            className: (()=>{
                let classNames = [];
                if (activeSectionIndex.parent === parentIndex) classNames.push("current-parent");
                if (globalActiveParentIndex === parentIndex) classNames.push("active");
                return classNames.length !== 0 ? classNames.join(" ") : undefined;
            })(),
            key: parentSection.title
        }, $ba3f0db9083505f9$var$react_1.default.createElement($ba3f0db9083505f9$var$anchor_1.default, {
            dataLwtId: `${dataLwtId}-anchor-side-menu-parent-section`,
            role: "button",
            onClick: ()=>{
                !globalActive && parentSection.handleClick();
                globalActive && setGlobalActiveParentIndex(parentIndex);
            }
        }, parentSection.title), $ba3f0db9083505f9$var$react_1.default.createElement("ul", {
            className: "nav"
        }, parentSection.sections && parentSection.sections.map((childSection, childIndex)=>$ba3f0db9083505f9$var$react_1.default.createElement("li", {
                className: activeSectionIndex.parent === parentIndex && activeSectionIndex.child === childIndex ? "active" : undefined,
                key: `${parentSection.title}-${childSection.title}`
            }, $ba3f0db9083505f9$var$react_1.default.createElement($ba3f0db9083505f9$var$anchor_1.default, {
                onClick: childSection.handleClick,
                dataLwtId: `${dataLwtId}-anchor-side-menu-child-section`
            }, childSection.title), $ba3f0db9083505f9$var$react_1.default.createElement("ul", {
                className: "nav"
            }, childSection.sections && childSection.sections.map((grandchildSection)=>$ba3f0db9083505f9$var$react_1.default.createElement("li", {
                    /* tslint:disable-next-line:max-line-length */ key: `${parentSection.title}-${childSection.title}-${grandchildSection.title}`
                }, $ba3f0db9083505f9$var$react_1.default.createElement($ba3f0db9083505f9$var$anchor_1.default, {
                    onClick: grandchildSection.handleClick,
                    dataLwtId: `${dataLwtId}-anchor-side-menu-grandchild-section`
                }, grandchildSection.title)))))))))));
};
module.exports.default = $ba3f0db9083505f9$var$SideMenu;

});
parcelRegister("hUt4I", function(module, exports) {

$parcel$export(module.exports, "ButtonIcon", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("WvfhX")))));
$parcel$export(module.exports, "Button", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("6thlO")))));
$parcel$export(module.exports, "ButtonGroup", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("c5PmB")))));

var $aQDAW = parcelRequire("aQDAW");

var $WvfhX = parcelRequire("WvfhX");

var $85c4v = parcelRequire("85c4v");

var $6thlO = parcelRequire("6thlO");

var $c5PmB = parcelRequire("c5PmB");

});
parcelRegister("aQDAW", function(module, exports) {
"use strict";
var $7e5d796d200d5a6a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $7e5d796d200d5a6a$var$react_1 = $7e5d796d200d5a6a$var$__importDefault((parcelRequire("acw62")));

const $7e5d796d200d5a6a$var$classnames_1 = $7e5d796d200d5a6a$var$__importDefault((parcelRequire("8g1PZ")));

var $3j2Q3 = parcelRequire("3j2Q3");
const $7e5d796d200d5a6a$var$ButtonToolbar = (props)=>{
    const { className: className, title: title, border: border, children: children, dataLwtId: dataLwtId, ...restProps } = props;
    const classes = (0, $7e5d796d200d5a6a$var$classnames_1.default)(className, "btn-toolbar align-items-center", border ? "border-bottom mb-4 pb-3" : false);
    return $7e5d796d200d5a6a$var$react_1.default.createElement($3j2Q3.default, {
        "data-lwt-id": dataLwtId,
        className: classes,
        ...restProps
    }, $7e5d796d200d5a6a$var$react_1.default.createElement("h2", {
        className: "mb-0 mr-auto"
    }, title), children);
};
$7e5d796d200d5a6a$var$ButtonToolbar.defaultProps = {
    role: "toolbar",
    title: "Page Title"
};
module.exports.default = $7e5d796d200d5a6a$var$ButtonToolbar;

});

parcelRegister("WvfhX", function(module, exports) {
"use strict";
var $0afda79e2c0b2841$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $0afda79e2c0b2841$var$react_1 = $0afda79e2c0b2841$var$__importDefault((parcelRequire("acw62")));
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

const $0afda79e2c0b2841$var$icon_1 = $0afda79e2c0b2841$var$__importDefault((parcelRequire("aTLkh")));

const $0afda79e2c0b2841$var$tooltip_1 = $0afda79e2c0b2841$var$__importDefault((parcelRequire("rMeTm")));

var $bew0G = parcelRequire("bew0G");
const $0afda79e2c0b2841$var$ButtonIcon = (props)=>{
    const { id: id, iconClass: iconClass, iconName: iconName, disabled: disabled, children: children, label: label, dataLwtId: dataLwtId, ...restButton } = props;
    const uid = (0, $bew0G.useUID)();
    return $0afda79e2c0b2841$var$react_1.default.createElement($6thlO.default, {
        dataLwtId: dataLwtId,
        ...restButton,
        id: id || `button-icon-${uid}`,
        disabled: disabled
    }, $0afda79e2c0b2841$var$react_1.default.createElement($0afda79e2c0b2841$var$icon_1.default, {
        dataLwtId: `${dataLwtId}-icon`,
        disabled: disabled,
        className: iconClass,
        iconName: iconName || ""
    }, children), (label || iconName) && $0afda79e2c0b2841$var$react_1.default.createElement($0afda79e2c0b2841$var$tooltip_1.default, {
        target: id || `button-icon-${uid}`
    }, label || iconName));
};
module.exports.default = $0afda79e2c0b2841$var$ButtonIcon;

});
parcelRegister("rMeTm", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $0537f10794da620b$export$2e2bcd8739ae039);

var $i6RjO = parcelRequire("i6RjO");
var $0537f10794da620b$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($i6RjO)));

});
parcelRegister("i6RjO", function(module, exports) {
"use strict";
var $d2f2257cefe20e2d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $d2f2257cefe20e2d$var$react_1 = $d2f2257cefe20e2d$var$__importDefault((parcelRequire("acw62")));

var $8FVNB = parcelRequire("8FVNB");
var $dd1F2 = parcelRequire("dd1F2");
const $d2f2257cefe20e2d$var$Tooltip = (props)=>{
    return props.isOpen || props.toggle ? $d2f2257cefe20e2d$var$react_1.default.createElement($8FVNB.default, {
        ...props,
        "data-lwt-id": props.dataLwtId
    }) : $d2f2257cefe20e2d$var$react_1.default.createElement($dd1F2.default, {
        ...props,
        "data-lwt-id": props.dataLwtId
    });
};
module.exports.default = $d2f2257cefe20e2d$var$Tooltip;

});



parcelRegister("85c4v", function(module, exports) {
"use strict";
var $5e28278e736e9454$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5e28278e736e9454$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $5e28278e736e9454$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5e28278e736e9454$var$__createBinding(result, mod, k);
    }
    $5e28278e736e9454$var$__setModuleDefault(result, mod);
    return result;
};
var $5e28278e736e9454$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $5e28278e736e9454$var$react_1 = $5e28278e736e9454$var$__importStar((parcelRequire("acw62")));

const $5e28278e736e9454$var$icon_1 = $5e28278e736e9454$var$__importDefault((parcelRequire("aTLkh")));

const $5e28278e736e9454$var$Button_1 = $5e28278e736e9454$var$__importDefault((parcelRequire("6thlO")));
const $5e28278e736e9454$var$ButtonSelect = (props)=>{
    const { isSelected: isSelected, onClick: onClick, children: children, className: className, iconClass: iconClass, dataLwtId: dataLwtId, ...restButton } = props;
    return $5e28278e736e9454$var$react_1.default.createElement($5e28278e736e9454$var$react_1.Fragment, null, $5e28278e736e9454$var$react_1.default.createElement($5e28278e736e9454$var$Button_1.default, {
        dataLwtId: dataLwtId,
        ...restButton,
        className: className,
        onClick: onClick
    }, children, $5e28278e736e9454$var$react_1.default.createElement($5e28278e736e9454$var$icon_1.default, {
        dataLwtId: `${dataLwtId}-icon`,
        className: iconClass,
        iconName: "check_circle"
    })));
};
module.exports.default = $5e28278e736e9454$var$ButtonSelect;

});
parcelRegister("6thlO", function(module, exports) {
"use strict";
var $4b62e9016eda97cc$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $4b62e9016eda97cc$var$react_1 = $4b62e9016eda97cc$var$__importDefault((parcelRequire("acw62")));

const $4b62e9016eda97cc$var$classnames_1 = $4b62e9016eda97cc$var$__importDefault((parcelRequire("8g1PZ")));
const $4b62e9016eda97cc$var$Button = (props)=>{
    const { active: active, block: block, className: className, color: color, disabled: disabled, outline: outline, size: size, raised: raised, fab: fab, onClick: onClick, children: children, id: id, dataLwtId: dataLwtId, ...restProps } = props;
    const classes = (0, $4b62e9016eda97cc$var$classnames_1.default)("btn", `btn${outline ? "-outline" : ""}-${color}`, size ? `btn-${size}` : false, block ? "btn-block" : false, raised ? "btn-raised" : false, fab ? "btn-fab" : false, disabled, className, {
        "active": active
    });
    return $4b62e9016eda97cc$var$react_1.default.createElement("button", {
        className: classes,
        id: id,
        type: "button",
        disabled: disabled,
        "data-lwt-id": dataLwtId,
        onClick: !disabled ? onClick : undefined,
        ...restProps
    }, children);
};
$4b62e9016eda97cc$var$Button.defaultProps = {
    color: "secondary",
    tag: "button",
    children: "button"
};
module.exports.default = $4b62e9016eda97cc$var$Button;

});


parcelRegister("c5PmB", function(module, exports) {
"use strict";
var $8cddcb65bf2a2871$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $8cddcb65bf2a2871$var$react_1 = $8cddcb65bf2a2871$var$__importDefault((parcelRequire("acw62")));

var $8Y0sW = parcelRequire("8Y0sW");
const $8cddcb65bf2a2871$var$ButtonGroup = (props)=>{
    const { dataLwtId: dataLwtId } = props;
    return $8cddcb65bf2a2871$var$react_1.default.createElement($8Y0sW.default, {
        "data-lwt-id": dataLwtId,
        ...props
    });
};
module.exports.default = $8cddcb65bf2a2871$var$ButtonGroup;

});




parcelRegister("9FCZ6", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $70a62ee19026fd2f$export$2e2bcd8739ae039);

var $7FdNM = parcelRequire("7FdNM");
var $70a62ee19026fd2f$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($7FdNM)));

});
parcelRegister("7FdNM", function(module, exports) {
"use strict";
var $59471182ff833c38$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $59471182ff833c38$var$react_1 = $59471182ff833c38$var$__importDefault((parcelRequire("acw62")));
const $59471182ff833c38$var$Footer = ()=>$59471182ff833c38$var$react_1.default.createElement("footer", null, $59471182ff833c38$var$react_1.default.createElement("div", {
        className: "container"
    }, $59471182ff833c38$var$react_1.default.createElement("h4", null, $59471182ff833c38$var$react_1.default.createElement("a", {
        href: "https://www.lwolf.com/",
        target: "_blank",
        rel: "noopener noreferrer"
    }, "Lone Wolf Technologies")), $59471182ff833c38$var$react_1.default.createElement("p", {
        className: "small"
    }, "This product is part of the Lone Wolf family of real estate products. ", $59471182ff833c38$var$react_1.default.createElement("a", {
        href: "https://www.lwolf.com/contact",
        target: "_blank",
        rel: "noopener noreferrer"
    }, "Contact us "), `to learn more. \xa9 Lone Wolf Technologies ${new Date().getFullYear()}.`)));
module.exports.default = $59471182ff833c38$var$Footer;

});


parcelRegister("7tOHe", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $5722910b6ee983d8$export$2e2bcd8739ae039);

var $gziLW = parcelRequire("gziLW");
var $5722910b6ee983d8$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($gziLW)));

});
parcelRegister("gziLW", function(module, exports) {
"use strict";
var $c0fe7a00f3921ca8$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $c0fe7a00f3921ca8$var$react_1 = $c0fe7a00f3921ca8$var$__importDefault((parcelRequire("acw62")));
const $c0fe7a00f3921ca8$var$Loader = ()=>{
    return $c0fe7a00f3921ca8$var$react_1.default.createElement("div", {
        className: "d-flex justify-content-center align-items-center h-100"
    }, $c0fe7a00f3921ca8$var$react_1.default.createElement("div", {
        className: "loader loader-animate"
    }));
};
module.exports.default = $c0fe7a00f3921ca8$var$Loader;

});


parcelRegister("3XgFA", function(module, exports) {

var $fFLF8 = parcelRequire("fFLF8");
module.exports = $fFLF8("24vrV").then(()=>parcelRequire("i046o"));

});
parcelRegister("fFLF8", function(module, exports) {
"use strict";

function $b68fa81b3a6ebff4$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("fCemW")).resolve(id));
}
module.exports = $b68fa81b3a6ebff4$var$load;

});


parcelRegister("f61ig", function(module, exports) {

$parcel$export(module.exports, "default", () => $afd86b70a577fd52$export$2e2bcd8739ae039);

var $jvygG = parcelRequire("jvygG");
var $afd86b70a577fd52$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($jvygG)));

});
parcelRegister("jvygG", function(module, exports) {
"use strict";
var $e33b7e7c155372bf$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $e33b7e7c155372bf$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $e33b7e7c155372bf$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $e33b7e7c155372bf$var$__createBinding(result, mod, k);
    }
    $e33b7e7c155372bf$var$__setModuleDefault(result, mod);
    return result;
};
var $e33b7e7c155372bf$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $e33b7e7c155372bf$var$react_1 = $e33b7e7c155372bf$var$__importStar((parcelRequire("acw62")));

var $f3PMH = parcelRequire("f3PMH");
var $ey2gH = parcelRequire("ey2gH");
var $daMq2 = parcelRequire("daMq2");
var $e6QXn = parcelRequire("e6QXn");

const $e33b7e7c155372bf$var$classnames_1 = $e33b7e7c155372bf$var$__importDefault((parcelRequire("8g1PZ")));
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");
const $e33b7e7c155372bf$var$Modal = (props)=>{
    const [openingCompete, setOpeningComplete] = (0, $e33b7e7c155372bf$var$react_1.useState)(false);
    const { size: //
    size, show: show, title: title, children: children, buttons: buttons, showFooter: showFooter, footerClassName: footerClassName, dataLwtId: dataLwtId, onClose: onClose, onOpened: onOpened } = props;
    (0, $e33b7e7c155372bf$var$react_1.useEffect)(()=>{
        const handleKeyUp = (event)=>{
            if ((event.key === "escape" || event.keyCode === 27) && show && onClose) onClose();
        };
        window.addEventListener("keyup", handleKeyUp, false);
        return ()=>{
            window.removeEventListener("keyup", handleKeyUp, false);
            setOpeningComplete(false);
        };
    }, [
        show
    ]);
    const footerClasses = (0, $e33b7e7c155372bf$var$classnames_1.default)("modal-footer", footerClassName);
    const handleClose = ()=>{
        if (onClose) onClose();
    };
    const handleOpened = ()=>{
        if (onOpened) onOpened();
        setOpeningComplete(true);
    };
    const headerProps = {};
    if (onClose) headerProps.toggle = handleClose;
    return show ? $e33b7e7c155372bf$var$react_1.default.createElement("div", {
        "data-lwt-id": dataLwtId
    }, $e33b7e7c155372bf$var$react_1.default.createElement($f3PMH.default, {
        isOpen: show,
        onOpened: ()=>handleOpened(),
        className: "modal-" + size,
        style: openingCompete ? {
            transform: "none"
        } : {}
    }, title && $e33b7e7c155372bf$var$react_1.default.createElement($e6QXn.default, {
        ...headerProps
    }, title), $e33b7e7c155372bf$var$react_1.default.createElement($ey2gH.default, null, children), showFooter && $e33b7e7c155372bf$var$react_1.default.createElement($daMq2.default, {
        className: footerClasses
    }, !buttons && $e33b7e7c155372bf$var$react_1.default.createElement($6thlO.default, {
        dataLwtId: `${dataLwtId}-button`,
        onClick: onClose
    }, "Ok"), buttons))) : null;
};
$e33b7e7c155372bf$var$Modal.defaultProps = {
    size: "md",
    showFooter: true
};
module.exports.default = $e33b7e7c155372bf$var$Modal;

});
parcelRegister("f3PMH", function(module, exports) {

$parcel$export(module.exports, "default", () => $af6f4e230dd0d7c1$export$2e2bcd8739ae039);

var $kSlfw = parcelRequire("kSlfw");

var $8nd05 = parcelRequire("8nd05");

var $hDpcU = parcelRequire("hDpcU");

var $g7ajw = parcelRequire("g7ajw");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $kpNFl = parcelRequire("kpNFl");

var $1HWSx = parcelRequire("1HWSx");

var $e9hDx = parcelRequire("e9hDx");
function $af6f4e230dd0d7c1$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $af6f4e230dd0d7c1$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $af6f4e230dd0d7c1$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $kSlfw.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $af6f4e230dd0d7c1$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $af6f4e230dd0d7c1$var$noop() {}
var $af6f4e230dd0d7c1$var$FadePropTypes = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape((0, $1HWSx.default).propTypes);
var $af6f4e230dd0d7c1$var$propTypes = {
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    centered: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    scrollable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    toggle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    keyboard: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    role: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    labelledBy: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    backdrop: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "static"
        ])
    ]),
    onEnter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onExit: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onOpened: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onClosed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    wrapClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    modalClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    backdropClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    contentClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    external: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    fade: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    zIndex: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    backdropTransition: $af6f4e230dd0d7c1$var$FadePropTypes,
    modalTransition: $af6f4e230dd0d7c1$var$FadePropTypes,
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
    ]),
    unmountOnClose: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    returnFocusAfterClose: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    container: (0, $e9hDx.targetPropType),
    trapFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
var $af6f4e230dd0d7c1$var$propsToOmit = Object.keys($af6f4e230dd0d7c1$var$propTypes);
var $af6f4e230dd0d7c1$var$defaultProps = {
    isOpen: false,
    autoFocus: true,
    centered: false,
    scrollable: false,
    role: "dialog",
    backdrop: true,
    keyboard: true,
    zIndex: 1050,
    fade: true,
    onOpened: $af6f4e230dd0d7c1$var$noop,
    onClosed: $af6f4e230dd0d7c1$var$noop,
    modalTransition: {
        timeout: (0, $e9hDx.TransitionTimeouts).Modal
    },
    backdropTransition: {
        mountOnEnter: true,
        timeout: (0, $e9hDx.TransitionTimeouts).Fade // uses standard fade transition
    },
    unmountOnClose: true,
    returnFocusAfterClose: true,
    container: "body",
    trapFocus: false
};
var $af6f4e230dd0d7c1$var$Modal = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(Modal, _React$Component);
    function Modal(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this._element = null;
        _this._originalBodyPadding = null;
        _this.getFocusableChildren = _this.getFocusableChildren.bind((0, $hDpcU.default)(_this));
        _this.handleBackdropClick = _this.handleBackdropClick.bind((0, $hDpcU.default)(_this));
        _this.handleBackdropMouseDown = _this.handleBackdropMouseDown.bind((0, $hDpcU.default)(_this));
        _this.handleEscape = _this.handleEscape.bind((0, $hDpcU.default)(_this));
        _this.handleStaticBackdropAnimation = _this.handleStaticBackdropAnimation.bind((0, $hDpcU.default)(_this));
        _this.handleTab = _this.handleTab.bind((0, $hDpcU.default)(_this));
        _this.onOpened = _this.onOpened.bind((0, $hDpcU.default)(_this));
        _this.onClosed = _this.onClosed.bind((0, $hDpcU.default)(_this));
        _this.manageFocusAfterClose = _this.manageFocusAfterClose.bind((0, $hDpcU.default)(_this));
        _this.clearBackdropAnimationTimeout = _this.clearBackdropAnimationTimeout.bind((0, $hDpcU.default)(_this));
        _this.trapFocus = _this.trapFocus.bind((0, $hDpcU.default)(_this));
        _this.state = {
            isOpen: false,
            showStaticBackdropAnimation: false
        };
        return _this;
    }
    var _proto = Modal.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this$props = this.props, isOpen = _this$props.isOpen, autoFocus = _this$props.autoFocus, onEnter = _this$props.onEnter;
        if (isOpen) {
            this.init();
            this.setState({
                isOpen: true
            });
            if (autoFocus) this.setFocus();
        }
        if (onEnter) onEnter();
         // traps focus inside the Modal, even if the browser address bar is focused
        document.addEventListener("focus", this.trapFocus, true);
        this._isMounted = true;
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        if (this.props.isOpen && !prevProps.isOpen) {
            this.init();
            this.setState({
                isOpen: true
            }); // let render() renders Modal Dialog first
            return;
        } // now Modal Dialog is rendered and we can refer this._element and this._dialog
        if (this.props.autoFocus && this.state.isOpen && !prevState.isOpen) this.setFocus();
        if (this._element && prevProps.zIndex !== this.props.zIndex) this._element.style.zIndex = this.props.zIndex;
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.clearBackdropAnimationTimeout();
        if (this.props.onExit) this.props.onExit();
        if (this._element) {
            this.destroy();
            if (this.props.isOpen || this.state.isOpen) this.close();
        }
        document.removeEventListener("focus", this.trapFocus, true);
        this._isMounted = false;
    };
    _proto.trapFocus = function trapFocus(ev) {
        if (!this.props.trapFocus) return;
        if (!this._element) return;
        if (this._dialog && this._dialog.parentNode === ev.target) return;
        if (this.modalIndex < Modal.openCount - 1) return;
        var children = this.getFocusableChildren();
        for(var i = 0; i < children.length; i++){
            // focus is already inside the Modal
            if (children[i] === ev.target) return;
        }
        if (children.length > 0) {
            // otherwise focus the first focusable element in the Modal
            ev.preventDefault();
            ev.stopPropagation();
            children[0].focus();
        }
    };
    _proto.onOpened = function onOpened(node, isAppearing) {
        this.props.onOpened();
        (this.props.modalTransition.onEntered || $af6f4e230dd0d7c1$var$noop)(node, isAppearing);
    };
    _proto.onClosed = function onClosed(node) {
        var unmountOnClose = this.props.unmountOnClose; // so all methods get called before it is unmounted
        this.props.onClosed();
        (this.props.modalTransition.onExited || $af6f4e230dd0d7c1$var$noop)(node);
        if (unmountOnClose) this.destroy();
        this.close();
        if (this._isMounted) this.setState({
            isOpen: false
        });
    };
    _proto.setFocus = function setFocus() {
        if (this._dialog && this._dialog.parentNode && typeof this._dialog.parentNode.focus === "function") this._dialog.parentNode.focus();
    };
    _proto.getFocusableChildren = function getFocusableChildren() {
        return this._element.querySelectorAll((0, $e9hDx.focusableElements).join(", "));
    };
    _proto.getFocusedChild = function getFocusedChild() {
        var currentFocus;
        var focusableChildren = this.getFocusableChildren();
        try {
            currentFocus = document.activeElement;
        } catch (err) {
            currentFocus = focusableChildren[0];
        }
        return currentFocus;
    } // not mouseUp because scrollbar fires it, shouldn't close when user scrolls
    ;
    _proto.handleBackdropClick = function handleBackdropClick(e) {
        if (e.target === this._mouseDownElement) {
            e.stopPropagation();
            var backdrop = this._dialog ? this._dialog.parentNode : null;
            if (backdrop && e.target === backdrop && this.props.backdrop === "static") this.handleStaticBackdropAnimation();
            if (!this.props.isOpen || this.props.backdrop !== true) return;
            if (backdrop && e.target === backdrop && this.props.toggle) this.props.toggle(e);
        }
    };
    _proto.handleTab = function handleTab(e) {
        if (e.which !== 9) return;
        if (this.modalIndex < Modal.openCount - 1) return; // last opened modal
        var focusableChildren = this.getFocusableChildren();
        var totalFocusable = focusableChildren.length;
        if (totalFocusable === 0) return;
        var currentFocus = this.getFocusedChild();
        var focusedIndex = 0;
        for(var i = 0; i < totalFocusable; i += 1)if (focusableChildren[i] === currentFocus) {
            focusedIndex = i;
            break;
        }
        if (e.shiftKey && focusedIndex === 0) {
            e.preventDefault();
            focusableChildren[totalFocusable - 1].focus();
        } else if (!e.shiftKey && focusedIndex === totalFocusable - 1) {
            e.preventDefault();
            focusableChildren[0].focus();
        }
    };
    _proto.handleBackdropMouseDown = function handleBackdropMouseDown(e) {
        this._mouseDownElement = e.target;
    };
    _proto.handleEscape = function handleEscape(e) {
        if (this.props.isOpen && e.keyCode === (0, $e9hDx.keyCodes).esc && this.props.toggle) {
            if (this.props.keyboard) {
                e.preventDefault();
                e.stopPropagation();
                this.props.toggle(e);
            } else if (this.props.backdrop === "static") {
                e.preventDefault();
                e.stopPropagation();
                this.handleStaticBackdropAnimation();
            }
        }
    };
    _proto.handleStaticBackdropAnimation = function handleStaticBackdropAnimation() {
        var _this2 = this;
        this.clearBackdropAnimationTimeout();
        this.setState({
            showStaticBackdropAnimation: true
        });
        this._backdropAnimationTimeout = setTimeout(function() {
            _this2.setState({
                showStaticBackdropAnimation: false
            });
        }, 100);
    };
    _proto.init = function init() {
        try {
            this._triggeringElement = document.activeElement;
        } catch (err) {
            this._triggeringElement = null;
        }
        if (!this._element) {
            this._element = document.createElement("div");
            this._element.setAttribute("tabindex", "-1");
            this._element.style.position = "relative";
            this._element.style.zIndex = this.props.zIndex;
            this._mountContainer = (0, $e9hDx.getTarget)(this.props.container);
            this._mountContainer.appendChild(this._element);
        }
        this._originalBodyPadding = (0, $e9hDx.getOriginalBodyPadding)();
        (0, $e9hDx.conditionallyUpdateScrollbar)();
        if (Modal.openCount === 0) document.body.className = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(document.body.className, (0, $e9hDx.mapToCssModules)("modal-open", this.props.cssModule));
        this.modalIndex = Modal.openCount;
        Modal.openCount += 1;
    };
    _proto.destroy = function destroy() {
        if (this._element) {
            this._mountContainer.removeChild(this._element);
            this._element = null;
        }
        this.manageFocusAfterClose();
    };
    _proto.manageFocusAfterClose = function manageFocusAfterClose() {
        if (this._triggeringElement) {
            var returnFocusAfterClose = this.props.returnFocusAfterClose;
            if (this._triggeringElement.focus && returnFocusAfterClose) this._triggeringElement.focus();
            this._triggeringElement = null;
        }
    };
    _proto.close = function close() {
        if (Modal.openCount <= 1) {
            var modalOpenClassName = (0, $e9hDx.mapToCssModules)("modal-open", this.props.cssModule); // Use regex to prevent matching `modal-open` as part of a different class, e.g. `my-modal-opened`
            var modalOpenClassNameRegex = new RegExp("(^| )" + modalOpenClassName + "( |$)");
            document.body.className = document.body.className.replace(modalOpenClassNameRegex, " ").trim();
        }
        this.manageFocusAfterClose();
        Modal.openCount = Math.max(0, Modal.openCount - 1);
        (0, $e9hDx.setScrollbarWidth)(this._originalBodyPadding);
    };
    _proto.renderModalDialog = function renderModalDialog() {
        var _classNames, _this3 = this;
        var attributes = (0, $e9hDx.omit)(this.props, $af6f4e230dd0d7c1$var$propsToOmit);
        var dialogBaseClass = "modal-dialog";
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", (0, $8nd05.default)({}, attributes, {
            className: (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(dialogBaseClass, this.props.className, (_classNames = {}, _classNames["modal-" + this.props.size] = this.props.size, _classNames[dialogBaseClass + "-centered"] = this.props.centered, _classNames[dialogBaseClass + "-scrollable"] = this.props.scrollable, _classNames)), this.props.cssModule),
            role: "document",
            ref: function ref(c) {
                _this3._dialog = c;
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("modal-content", this.props.contentClassName), this.props.cssModule)
        }, this.props.children));
    };
    _proto.render = function render() {
        var unmountOnClose = this.props.unmountOnClose;
        if (!!this._element && (this.state.isOpen || !unmountOnClose)) {
            var isModalHidden = !!this._element && !this.state.isOpen && !unmountOnClose;
            this._element.style.display = isModalHidden ? "none" : "block";
            var _this$props2 = this.props, wrapClassName = _this$props2.wrapClassName, modalClassName = _this$props2.modalClassName, backdropClassName = _this$props2.backdropClassName, cssModule = _this$props2.cssModule, isOpen = _this$props2.isOpen, backdrop = _this$props2.backdrop, role = _this$props2.role, labelledBy = _this$props2.labelledBy, external = _this$props2.external, innerRef = _this$props2.innerRef;
            var modalAttributes = {
                onClick: this.handleBackdropClick,
                onMouseDown: this.handleBackdropMouseDown,
                onKeyUp: this.handleEscape,
                onKeyDown: this.handleTab,
                style: {
                    display: "block"
                },
                "aria-labelledby": labelledBy,
                role: role,
                tabIndex: "-1"
            };
            var hasTransition = this.props.fade;
            var modalTransition = $af6f4e230dd0d7c1$var$_objectSpread($af6f4e230dd0d7c1$var$_objectSpread($af6f4e230dd0d7c1$var$_objectSpread({}, (0, $1HWSx.default).defaultProps), this.props.modalTransition), {}, {
                baseClass: hasTransition ? this.props.modalTransition.baseClass : "",
                timeout: hasTransition ? this.props.modalTransition.timeout : 0
            });
            var backdropTransition = $af6f4e230dd0d7c1$var$_objectSpread($af6f4e230dd0d7c1$var$_objectSpread($af6f4e230dd0d7c1$var$_objectSpread({}, (0, $1HWSx.default).defaultProps), this.props.backdropTransition), {}, {
                baseClass: hasTransition ? this.props.backdropTransition.baseClass : "",
                timeout: hasTransition ? this.props.backdropTransition.timeout : 0
            });
            var Backdrop = backdrop && (hasTransition ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1HWSx.default), (0, $8nd05.default)({}, backdropTransition, {
                in: isOpen && !!backdrop,
                cssModule: cssModule,
                className: (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("modal-backdrop", backdropClassName), cssModule)
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("modal-backdrop", "show", backdropClassName), cssModule)
            }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kpNFl.default), {
                node: this._element
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: (0, $e9hDx.mapToCssModules)(wrapClassName)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1HWSx.default), (0, $8nd05.default)({}, modalAttributes, modalTransition, {
                in: isOpen,
                onEntered: this.onOpened,
                onExited: this.onClosed,
                cssModule: cssModule,
                className: (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("modal", modalClassName, this.state.showStaticBackdropAnimation && "modal-static"), cssModule),
                innerRef: innerRef
            }), external, this.renderModalDialog()), Backdrop));
        }
        return null;
    };
    _proto.clearBackdropAnimationTimeout = function clearBackdropAnimationTimeout() {
        if (this._backdropAnimationTimeout) {
            clearTimeout(this._backdropAnimationTimeout);
            this._backdropAnimationTimeout = undefined;
        }
    };
    return Modal;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$af6f4e230dd0d7c1$var$Modal.propTypes = $af6f4e230dd0d7c1$var$propTypes;
$af6f4e230dd0d7c1$var$Modal.defaultProps = $af6f4e230dd0d7c1$var$defaultProps;
$af6f4e230dd0d7c1$var$Modal.openCount = 0;
var $af6f4e230dd0d7c1$export$2e2bcd8739ae039 = $af6f4e230dd0d7c1$var$Modal;

});
parcelRegister("kpNFl", function(module, exports) {

$parcel$export(module.exports, "default", () => $edccab0ddea8c09c$export$2e2bcd8739ae039);

var $g7ajw = parcelRequire("g7ajw");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $c9Z8w = parcelRequire("c9Z8w");

var $e9hDx = parcelRequire("e9hDx");
var $edccab0ddea8c09c$var$propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node.isRequired,
    node: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any
};
var $edccab0ddea8c09c$var$Portal = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(Portal, _React$Component);
    function Portal() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Portal.prototype;
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.defaultNode) document.body.removeChild(this.defaultNode);
        this.defaultNode = null;
    };
    _proto.render = function render() {
        if (!(0, $e9hDx.canUseDOM)) return null;
        if (!this.props.node && !this.defaultNode) {
            this.defaultNode = document.createElement("div");
            document.body.appendChild(this.defaultNode);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).createPortal(this.props.children, this.props.node || this.defaultNode);
    };
    return Portal;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$edccab0ddea8c09c$var$Portal.propTypes = $edccab0ddea8c09c$var$propTypes;
var $edccab0ddea8c09c$export$2e2bcd8739ae039 = $edccab0ddea8c09c$var$Portal;

});


parcelRegister("ey2gH", function(module, exports) {

$parcel$export(module.exports, "default", () => $a976001a1957dc8f$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $e9hDx = parcelRequire("e9hDx");
var $a976001a1957dc8f$var$propTypes = {
    tag: (0, $e9hDx.tagPropType),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $a976001a1957dc8f$var$defaultProps = {
    tag: "div"
};
var $a976001a1957dc8f$var$ModalBody = function ModalBody(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, attributes = (0, $1En50.default)(props, [
        "className",
        "cssModule",
        "tag"
    ]);
    var classes = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, "modal-body"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({}, attributes, {
        className: classes
    }));
};
$a976001a1957dc8f$var$ModalBody.propTypes = $a976001a1957dc8f$var$propTypes;
$a976001a1957dc8f$var$ModalBody.defaultProps = $a976001a1957dc8f$var$defaultProps;
var $a976001a1957dc8f$export$2e2bcd8739ae039 = $a976001a1957dc8f$var$ModalBody;

});

parcelRegister("daMq2", function(module, exports) {

$parcel$export(module.exports, "default", () => $9971c48b6aa7fd41$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $e9hDx = parcelRequire("e9hDx");
var $9971c48b6aa7fd41$var$propTypes = {
    tag: (0, $e9hDx.tagPropType),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $9971c48b6aa7fd41$var$defaultProps = {
    tag: "div"
};
var $9971c48b6aa7fd41$var$ModalFooter = function ModalFooter(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, attributes = (0, $1En50.default)(props, [
        "className",
        "cssModule",
        "tag"
    ]);
    var classes = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, "modal-footer"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({}, attributes, {
        className: classes
    }));
};
$9971c48b6aa7fd41$var$ModalFooter.propTypes = $9971c48b6aa7fd41$var$propTypes;
$9971c48b6aa7fd41$var$ModalFooter.defaultProps = $9971c48b6aa7fd41$var$defaultProps;
var $9971c48b6aa7fd41$export$2e2bcd8739ae039 = $9971c48b6aa7fd41$var$ModalFooter;

});

parcelRegister("e6QXn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a45ab45772676571$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $e9hDx = parcelRequire("e9hDx");
var $a45ab45772676571$var$propTypes = {
    tag: (0, $e9hDx.tagPropType),
    wrapTag: (0, $e9hDx.tagPropType),
    toggle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    closeAriaLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    charCode: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
    ]),
    close: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $a45ab45772676571$var$defaultProps = {
    tag: "h5",
    wrapTag: "div",
    closeAriaLabel: "Close",
    charCode: 215
};
var $a45ab45772676571$var$ModalHeader = function ModalHeader(props) {
    var closeButton;
    var className = props.className, cssModule = props.cssModule, children = props.children, toggle = props.toggle, Tag = props.tag, WrapTag = props.wrapTag, closeAriaLabel = props.closeAriaLabel, charCode = props.charCode, close = props.close, attributes = (0, $1En50.default)(props, [
        "className",
        "cssModule",
        "children",
        "toggle",
        "tag",
        "wrapTag",
        "closeAriaLabel",
        "charCode",
        "close"
    ]);
    var classes = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, "modal-header"), cssModule);
    if (!close && toggle) {
        var closeIcon = typeof charCode === "number" ? String.fromCharCode(charCode) : charCode;
        closeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            type: "button",
            onClick: toggle,
            className: (0, $e9hDx.mapToCssModules)("close", cssModule),
            "aria-label": closeAriaLabel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-hidden": "true"
        }, closeIcon));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(WrapTag, (0, $8nd05.default)({}, attributes, {
        className: classes
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, {
        className: (0, $e9hDx.mapToCssModules)("modal-title", cssModule)
    }, children), close || closeButton);
};
$a45ab45772676571$var$ModalHeader.propTypes = $a45ab45772676571$var$propTypes;
$a45ab45772676571$var$ModalHeader.defaultProps = $a45ab45772676571$var$defaultProps;
var $a45ab45772676571$export$2e2bcd8739ae039 = $a45ab45772676571$var$ModalHeader;

});



parcelRegister("3lOdM", function(module, exports) {

$parcel$export(module.exports, "Row", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("e155p")))));
$parcel$export(module.exports, "Col", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("1iwUl")))));

var $e155p = parcelRequire("e155p");

var $1iwUl = parcelRequire("1iwUl");

});
parcelRegister("e155p", function(module, exports) {
"use strict";
var $a3451aaf75e7edb6$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $a3451aaf75e7edb6$var$react_1 = $a3451aaf75e7edb6$var$__importDefault((parcelRequire("acw62")));

var $2FwhD = parcelRequire("2FwhD");
const $a3451aaf75e7edb6$var$Row = (props)=>$a3451aaf75e7edb6$var$react_1.default.createElement($2FwhD.default, Object.assign({}, props));
module.exports.default = $a3451aaf75e7edb6$var$Row;

});
parcelRegister("2FwhD", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f1873e66125b2a6$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $e9hDx = parcelRequire("e9hDx");
var $1f1873e66125b2a6$var$rowColWidths = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
var $1f1873e66125b2a6$var$rowColsPropType = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
]);
var $1f1873e66125b2a6$var$propTypes = {
    tag: (0, $e9hDx.tagPropType),
    noGutters: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    form: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    xs: $1f1873e66125b2a6$var$rowColsPropType,
    sm: $1f1873e66125b2a6$var$rowColsPropType,
    md: $1f1873e66125b2a6$var$rowColsPropType,
    lg: $1f1873e66125b2a6$var$rowColsPropType,
    xl: $1f1873e66125b2a6$var$rowColsPropType
};
var $1f1873e66125b2a6$var$defaultProps = {
    tag: "div",
    widths: $1f1873e66125b2a6$var$rowColWidths
};
var $1f1873e66125b2a6$var$Row = function Row(props) {
    var className = props.className, cssModule = props.cssModule, noGutters = props.noGutters, Tag = props.tag, form = props.form, widths = props.widths, attributes = (0, $1En50.default)(props, [
        "className",
        "cssModule",
        "noGutters",
        "tag",
        "form",
        "widths"
    ]);
    var colClasses = [];
    widths.forEach(function(colWidth, i) {
        var colSize = props[colWidth];
        delete attributes[colWidth];
        if (!colSize) return;
        var isXs = !i;
        colClasses.push(isXs ? "row-cols-" + colSize : "row-cols-" + colWidth + "-" + colSize);
    });
    var classes = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, noGutters ? "no-gutters" : null, form ? "form-row" : "row", colClasses), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({}, attributes, {
        className: classes
    }));
};
$1f1873e66125b2a6$var$Row.propTypes = $1f1873e66125b2a6$var$propTypes;
$1f1873e66125b2a6$var$Row.defaultProps = $1f1873e66125b2a6$var$defaultProps;
var $1f1873e66125b2a6$export$2e2bcd8739ae039 = $1f1873e66125b2a6$var$Row;

});


parcelRegister("1iwUl", function(module, exports) {
"use strict";
var $0f20ffafe1cc0c13$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $0f20ffafe1cc0c13$var$react_1 = $0f20ffafe1cc0c13$var$__importDefault((parcelRequire("acw62")));

var $aKUQz = parcelRequire("aKUQz");
const $0f20ffafe1cc0c13$var$Col = (props)=>$0f20ffafe1cc0c13$var$react_1.default.createElement($aKUQz.default, Object.assign({}, props));
module.exports.default = $0f20ffafe1cc0c13$var$Col;

});
parcelRegister("aKUQz", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d4a4be0fe09d992$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $e9hDx = parcelRequire("e9hDx");
var $7d4a4be0fe09d992$var$colWidths = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
var $7d4a4be0fe09d992$var$stringOrNumberProp = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
]);
var $7d4a4be0fe09d992$var$columnProps = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        size: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
            (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
        ]),
        order: $7d4a4be0fe09d992$var$stringOrNumberProp,
        offset: $7d4a4be0fe09d992$var$stringOrNumberProp
    })
]);
var $7d4a4be0fe09d992$var$propTypes = {
    tag: (0, $e9hDx.tagPropType),
    xs: $7d4a4be0fe09d992$var$columnProps,
    sm: $7d4a4be0fe09d992$var$columnProps,
    md: $7d4a4be0fe09d992$var$columnProps,
    lg: $7d4a4be0fe09d992$var$columnProps,
    xl: $7d4a4be0fe09d992$var$columnProps,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    widths: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array
};
var $7d4a4be0fe09d992$var$defaultProps = {
    tag: "div",
    widths: $7d4a4be0fe09d992$var$colWidths
};
var $7d4a4be0fe09d992$var$getColumnSizeClass = function getColumnSizeClass(isXs, colWidth, colSize) {
    if (colSize === true || colSize === "") return isXs ? "col" : "col-" + colWidth;
    else if (colSize === "auto") return isXs ? "col-auto" : "col-" + colWidth + "-auto";
    return isXs ? "col-" + colSize : "col-" + colWidth + "-" + colSize;
};
var $7d4a4be0fe09d992$var$Col = function Col(props) {
    var className = props.className, cssModule = props.cssModule, widths = props.widths, Tag = props.tag, attributes = (0, $1En50.default)(props, [
        "className",
        "cssModule",
        "widths",
        "tag"
    ]);
    var colClasses = [];
    widths.forEach(function(colWidth, i) {
        var columnProp = props[colWidth];
        delete attributes[colWidth];
        if (!columnProp && columnProp !== "") return;
        var isXs = !i;
        if ((0, $e9hDx.isObject)(columnProp)) {
            var _classNames;
            var colSizeInterfix = isXs ? "-" : "-" + colWidth + "-";
            var colClass = $7d4a4be0fe09d992$var$getColumnSizeClass(isXs, colWidth, columnProp.size);
            colClasses.push((0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((_classNames = {}, _classNames[colClass] = columnProp.size || columnProp.size === "", _classNames["order" + colSizeInterfix + columnProp.order] = columnProp.order || columnProp.order === 0, _classNames["offset" + colSizeInterfix + columnProp.offset] = columnProp.offset || columnProp.offset === 0, _classNames)), cssModule));
        } else {
            var _colClass = $7d4a4be0fe09d992$var$getColumnSizeClass(isXs, colWidth, columnProp);
            colClasses.push(_colClass);
        }
    });
    if (!colClasses.length) colClasses.push("col");
    var classes = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, colClasses), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({}, attributes, {
        className: classes
    }));
};
$7d4a4be0fe09d992$var$Col.propTypes = $7d4a4be0fe09d992$var$propTypes;
$7d4a4be0fe09d992$var$Col.defaultProps = $7d4a4be0fe09d992$var$defaultProps;
var $7d4a4be0fe09d992$export$2e2bcd8739ae039 = $7d4a4be0fe09d992$var$Col;

});



parcelRegister("7hEbZ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $015e57f0b4b5589b$export$2e2bcd8739ae039);
$parcel$export(module.exports, "CardContainer", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("iDoBR")))));
$parcel$export(module.exports, "CardLink", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("74fmC")))));

var $04QQk = parcelRequire("04QQk");

var $iDoBR = parcelRequire("iDoBR");

var $74fmC = parcelRequire("74fmC");
var $015e57f0b4b5589b$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($04QQk)));

});
parcelRegister("04QQk", function(module, exports) {
"use strict";
var $00e95d56eab3570b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $00e95d56eab3570b$var$react_1 = $00e95d56eab3570b$var$__importDefault((parcelRequire("acw62")));

const $00e95d56eab3570b$var$classnames_1 = $00e95d56eab3570b$var$__importDefault((parcelRequire("8g1PZ")));

var $jNrfC = parcelRequire("jNrfC");
var $f0QE7 = parcelRequire("f0QE7");
var $2kvLT = parcelRequire("2kvLT");
var $dzhiy = parcelRequire("dzhiy");
var $kTCAc = parcelRequire("kTCAc");
var $8dIk9 = parcelRequire("8dIk9");
var $jGcDw = parcelRequire("jGcDw");
var $6965A = parcelRequire("6965A");
const $00e95d56eab3570b$var$Card = (props)=>{
    const { className: className, inverse: inverse, color: color, rounded: rounded, raised: raised, isSelected: isSelected, headerProps: headerProps, footerProps: footerProps, imgProps: imgProps, bodyProps: bodyProps, imgOverlayProps: imgOverlayProps, children: children, dataLwtId: dataLwtId, ...restProps } = props;
    const classes = (0, $00e95d56eab3570b$var$classnames_1.default)(isSelected ? "selected" : false, inverse ? "text-white" : false, raised ? "card-raised" : false, rounded ? "rounded" : false, color ? `bg-${color}` : false, className);
    // suppressing the unknown prop warning that occurs when trying to pass in the 
    //  'dataLwtId' into the `CardBody` component. 
    //  If more warnings occur, we may need to extend this solution to other components
    let bodyDataLwtId;
    if (bodyProps) {
        bodyDataLwtId = bodyProps.dataLwtId;
        delete bodyProps.dataLwtId;
    }
    return $00e95d56eab3570b$var$react_1.default.createElement($jNrfC.default, {
        className: classes,
        "data-lwt-id": dataLwtId,
        ...restProps
    }, headerProps && $00e95d56eab3570b$var$react_1.default.createElement($dzhiy.default, {
        "data-lwt-id": headerProps.dataLwtId,
        ...headerProps
    }, headerProps.children), imgProps && imgProps.top && $00e95d56eab3570b$var$react_1.default.createElement($kTCAc.default, {
        "data-lwt-id": imgProps.dataLwtId,
        ...imgProps
    }), bodyProps && $00e95d56eab3570b$var$react_1.default.createElement($00e95d56eab3570b$var$react_1.default.Fragment, null, $00e95d56eab3570b$var$react_1.default.createElement($f0QE7.default, {
        "data-lwt-id": bodyDataLwtId,
        ...bodyProps
    }, bodyProps.title && $00e95d56eab3570b$var$react_1.default.createElement($6965A.default, {
        "data-lwt-id": bodyProps.title.dataLwtId,
        ...bodyProps.title
    }, bodyProps.title), bodyProps.subtitle && $00e95d56eab3570b$var$react_1.default.createElement($jGcDw.default, {
        "data-lwt-id": bodyProps.subtitle.dataLwtId,
        ...bodyProps.subtitle
    }, bodyProps.subtitle), !bodyProps.noIndentOnChildren && $00e95d56eab3570b$var$react_1.default.createElement($00e95d56eab3570b$var$react_1.default.Fragment, null, bodyProps.children, children)), bodyProps.noIndentOnChildren && $00e95d56eab3570b$var$react_1.default.createElement($00e95d56eab3570b$var$react_1.default.Fragment, null, bodyProps.children, children)), !bodyProps && children, imgProps && imgProps.bottom && $00e95d56eab3570b$var$react_1.default.createElement($kTCAc.default, {
        "data-lwt-id": imgProps.dataLwtId,
        ...imgProps
    }), footerProps && $00e95d56eab3570b$var$react_1.default.createElement($2kvLT.default, {
        "data-lwt-id": footerProps.dataLwtId,
        ...footerProps
    }, footerProps.children), imgOverlayProps && $00e95d56eab3570b$var$react_1.default.createElement($8dIk9.default, {
        "data-lwt-id": imgOverlayProps.dataLwtId,
        ...imgOverlayProps
    }, imgOverlayProps.title && $00e95d56eab3570b$var$react_1.default.createElement($6965A.default, {
        "data-lwt-id": imgOverlayProps.title.dataLwtId,
        ...imgOverlayProps.title
    }, imgOverlayProps.title), imgOverlayProps.subtitle && $00e95d56eab3570b$var$react_1.default.createElement($jGcDw.default, {
        "data-lwt-id": imgOverlayProps.subtitle.dataLwtId,
        ...imgOverlayProps.subtitle
    }, imgOverlayProps.subtitle), imgOverlayProps.children));
};
module.exports.default = $00e95d56eab3570b$var$Card;

});
parcelRegister("jNrfC", function(module, exports) {

$parcel$export(module.exports, "default", () => $03b81fece0285061$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $e9hDx = parcelRequire("e9hDx");
var $03b81fece0285061$var$propTypes = {
    tag: (0, $e9hDx.tagPropType),
    inverse: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    body: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    outline: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
    ])
};
var $03b81fece0285061$var$defaultProps = {
    tag: "div"
};
var $03b81fece0285061$var$Card = function Card(props) {
    var className = props.className, cssModule = props.cssModule, color = props.color, body = props.body, inverse = props.inverse, outline = props.outline, Tag = props.tag, innerRef = props.innerRef, attributes = (0, $1En50.default)(props, [
        "className",
        "cssModule",
        "color",
        "body",
        "inverse",
        "outline",
        "tag",
        "innerRef"
    ]);
    var classes = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, "card", inverse ? "text-white" : false, body ? "card-body" : false, color ? (outline ? "border" : "bg") + "-" + color : false), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({}, attributes, {
        className: classes,
        ref: innerRef
    }));
};
$03b81fece0285061$var$Card.propTypes = $03b81fece0285061$var$propTypes;
$03b81fece0285061$var$Card.defaultProps = $03b81fece0285061$var$defaultProps;
var $03b81fece0285061$export$2e2bcd8739ae039 = $03b81fece0285061$var$Card;

});

parcelRegister("f0QE7", function(module, exports) {

$parcel$export(module.exports, "default", () => $aedfb1874b95f7be$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $e9hDx = parcelRequire("e9hDx");
var $aedfb1874b95f7be$var$propTypes = {
    tag: (0, $e9hDx.tagPropType),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
    ])
};
var $aedfb1874b95f7be$var$defaultProps = {
    tag: "div"
};
var $aedfb1874b95f7be$var$CardBody = function CardBody(props) {
    var className = props.className, cssModule = props.cssModule, innerRef = props.innerRef, Tag = props.tag, attributes = (0, $1En50.default)(props, [
        "className",
        "cssModule",
        "innerRef",
        "tag"
    ]);
    var classes = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, "card-body"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({}, attributes, {
        className: classes,
        ref: innerRef
    }));
};
$aedfb1874b95f7be$var$CardBody.propTypes = $aedfb1874b95f7be$var$propTypes;
$aedfb1874b95f7be$var$CardBody.defaultProps = $aedfb1874b95f7be$var$defaultProps;
var $aedfb1874b95f7be$export$2e2bcd8739ae039 = $aedfb1874b95f7be$var$CardBody;

});

parcelRegister("2kvLT", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b2618318436a6c9$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $e9hDx = parcelRequire("e9hDx");
var $1b2618318436a6c9$var$propTypes = {
    tag: (0, $e9hDx.tagPropType),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $1b2618318436a6c9$var$defaultProps = {
    tag: "div"
};
var $1b2618318436a6c9$var$CardFooter = function CardFooter(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, attributes = (0, $1En50.default)(props, [
        "className",
        "cssModule",
        "tag"
    ]);
    var classes = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, "card-footer"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({}, attributes, {
        className: classes
    }));
};
$1b2618318436a6c9$var$CardFooter.propTypes = $1b2618318436a6c9$var$propTypes;
$1b2618318436a6c9$var$CardFooter.defaultProps = $1b2618318436a6c9$var$defaultProps;
var $1b2618318436a6c9$export$2e2bcd8739ae039 = $1b2618318436a6c9$var$CardFooter;

});

parcelRegister("dzhiy", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e0bf651837f66f9$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $e9hDx = parcelRequire("e9hDx");
var $9e0bf651837f66f9$var$propTypes = {
    tag: (0, $e9hDx.tagPropType),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $9e0bf651837f66f9$var$defaultProps = {
    tag: "div"
};
var $9e0bf651837f66f9$var$CardHeader = function CardHeader(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, attributes = (0, $1En50.default)(props, [
        "className",
        "cssModule",
        "tag"
    ]);
    var classes = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, "card-header"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({}, attributes, {
        className: classes
    }));
};
$9e0bf651837f66f9$var$CardHeader.propTypes = $9e0bf651837f66f9$var$propTypes;
$9e0bf651837f66f9$var$CardHeader.defaultProps = $9e0bf651837f66f9$var$defaultProps;
var $9e0bf651837f66f9$export$2e2bcd8739ae039 = $9e0bf651837f66f9$var$CardHeader;

});

parcelRegister("kTCAc", function(module, exports) {

$parcel$export(module.exports, "default", () => $f366df71c7561d04$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $e9hDx = parcelRequire("e9hDx");
var $f366df71c7561d04$var$propTypes = {
    tag: (0, $e9hDx.tagPropType),
    top: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    bottom: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $f366df71c7561d04$var$defaultProps = {
    tag: "img"
};
var $f366df71c7561d04$var$CardImg = function CardImg(props) {
    var className = props.className, cssModule = props.cssModule, top = props.top, bottom = props.bottom, Tag = props.tag, attributes = (0, $1En50.default)(props, [
        "className",
        "cssModule",
        "top",
        "bottom",
        "tag"
    ]);
    var cardImgClassName = "card-img";
    if (top) cardImgClassName = "card-img-top";
    if (bottom) cardImgClassName = "card-img-bottom";
    var classes = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, cardImgClassName), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({}, attributes, {
        className: classes
    }));
};
$f366df71c7561d04$var$CardImg.propTypes = $f366df71c7561d04$var$propTypes;
$f366df71c7561d04$var$CardImg.defaultProps = $f366df71c7561d04$var$defaultProps;
var $f366df71c7561d04$export$2e2bcd8739ae039 = $f366df71c7561d04$var$CardImg;

});

parcelRegister("8dIk9", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fc1eb74c574a08a$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $e9hDx = parcelRequire("e9hDx");
var $5fc1eb74c574a08a$var$propTypes = {
    tag: (0, $e9hDx.tagPropType),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $5fc1eb74c574a08a$var$defaultProps = {
    tag: "div"
};
var $5fc1eb74c574a08a$var$CardImgOverlay = function CardImgOverlay(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, attributes = (0, $1En50.default)(props, [
        "className",
        "cssModule",
        "tag"
    ]);
    var classes = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, "card-img-overlay"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({}, attributes, {
        className: classes
    }));
};
$5fc1eb74c574a08a$var$CardImgOverlay.propTypes = $5fc1eb74c574a08a$var$propTypes;
$5fc1eb74c574a08a$var$CardImgOverlay.defaultProps = $5fc1eb74c574a08a$var$defaultProps;
var $5fc1eb74c574a08a$export$2e2bcd8739ae039 = $5fc1eb74c574a08a$var$CardImgOverlay;

});

parcelRegister("jGcDw", function(module, exports) {

$parcel$export(module.exports, "default", () => $e53bbde6ef3bb6e0$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $e9hDx = parcelRequire("e9hDx");
var $e53bbde6ef3bb6e0$var$propTypes = {
    tag: (0, $e9hDx.tagPropType),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $e53bbde6ef3bb6e0$var$defaultProps = {
    tag: "div"
};
var $e53bbde6ef3bb6e0$var$CardSubtitle = function CardSubtitle(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, attributes = (0, $1En50.default)(props, [
        "className",
        "cssModule",
        "tag"
    ]);
    var classes = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, "card-subtitle"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({}, attributes, {
        className: classes
    }));
};
$e53bbde6ef3bb6e0$var$CardSubtitle.propTypes = $e53bbde6ef3bb6e0$var$propTypes;
$e53bbde6ef3bb6e0$var$CardSubtitle.defaultProps = $e53bbde6ef3bb6e0$var$defaultProps;
var $e53bbde6ef3bb6e0$export$2e2bcd8739ae039 = $e53bbde6ef3bb6e0$var$CardSubtitle;

});

parcelRegister("6965A", function(module, exports) {

$parcel$export(module.exports, "default", () => $47984e7d0d016326$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $e9hDx = parcelRequire("e9hDx");
var $47984e7d0d016326$var$propTypes = {
    tag: (0, $e9hDx.tagPropType),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $47984e7d0d016326$var$defaultProps = {
    tag: "div"
};
var $47984e7d0d016326$var$CardTitle = function CardTitle(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, attributes = (0, $1En50.default)(props, [
        "className",
        "cssModule",
        "tag"
    ]);
    var classes = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, "card-title"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({}, attributes, {
        className: classes
    }));
};
$47984e7d0d016326$var$CardTitle.propTypes = $47984e7d0d016326$var$propTypes;
$47984e7d0d016326$var$CardTitle.defaultProps = $47984e7d0d016326$var$defaultProps;
var $47984e7d0d016326$export$2e2bcd8739ae039 = $47984e7d0d016326$var$CardTitle;

});


parcelRegister("iDoBR", function(module, exports) {
"use strict";
var $d90ef581048abf65$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $d90ef581048abf65$var$react_1 = $d90ef581048abf65$var$__importDefault((parcelRequire("acw62")));

var $l3UGE = parcelRequire("l3UGE");
var $2Z9ZS = parcelRequire("2Z9ZS");
var $1z99I = parcelRequire("1z99I");
const $d90ef581048abf65$var$CardContainer = (props)=>{
    const { type: type, cardGroupProps: cardGroupProps, cardDeckProps: cardDeckProps, cardColumnProps: cardColumnProps, children: children, className: className, dataLwtId: dataLwtId } = props;
    switch(type){
        case "columns":
            return $d90ef581048abf65$var$react_1.default.createElement($l3UGE.default, {
                className: className,
                "data-lwt-id": dataLwtId,
                ...cardColumnProps
            }, children);
        case "deck":
            return $d90ef581048abf65$var$react_1.default.createElement($2Z9ZS.default, {
                className: className,
                "data-lwt-id": dataLwtId,
                ...cardDeckProps
            }, children);
        case "group":
            return $d90ef581048abf65$var$react_1.default.createElement($1z99I.default, {
                className: className,
                "data-lwt-id": dataLwtId,
                ...cardGroupProps
            }, children);
        default:
            return $d90ef581048abf65$var$react_1.default.createElement("div", null, children);
    }
};
module.exports.default = $d90ef581048abf65$var$CardContainer;

});
parcelRegister("l3UGE", function(module, exports) {

$parcel$export(module.exports, "default", () => $f555d9a480397d78$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $e9hDx = parcelRequire("e9hDx");
var $f555d9a480397d78$var$propTypes = {
    tag: (0, $e9hDx.tagPropType),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $f555d9a480397d78$var$defaultProps = {
    tag: "div"
};
var $f555d9a480397d78$var$CardColumns = function CardColumns(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, attributes = (0, $1En50.default)(props, [
        "className",
        "cssModule",
        "tag"
    ]);
    var classes = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, "card-columns"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({}, attributes, {
        className: classes
    }));
};
$f555d9a480397d78$var$CardColumns.propTypes = $f555d9a480397d78$var$propTypes;
$f555d9a480397d78$var$CardColumns.defaultProps = $f555d9a480397d78$var$defaultProps;
var $f555d9a480397d78$export$2e2bcd8739ae039 = $f555d9a480397d78$var$CardColumns;

});

parcelRegister("2Z9ZS", function(module, exports) {

$parcel$export(module.exports, "default", () => $22c9087eb919ccea$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $e9hDx = parcelRequire("e9hDx");
var $22c9087eb919ccea$var$propTypes = {
    tag: (0, $e9hDx.tagPropType),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $22c9087eb919ccea$var$defaultProps = {
    tag: "div"
};
var $22c9087eb919ccea$var$CardDeck = function CardDeck(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, attributes = (0, $1En50.default)(props, [
        "className",
        "cssModule",
        "tag"
    ]);
    var classes = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, "card-deck"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({}, attributes, {
        className: classes
    }));
};
$22c9087eb919ccea$var$CardDeck.propTypes = $22c9087eb919ccea$var$propTypes;
$22c9087eb919ccea$var$CardDeck.defaultProps = $22c9087eb919ccea$var$defaultProps;
var $22c9087eb919ccea$export$2e2bcd8739ae039 = $22c9087eb919ccea$var$CardDeck;

});

parcelRegister("1z99I", function(module, exports) {

$parcel$export(module.exports, "default", () => $1240297650bb5d51$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $e9hDx = parcelRequire("e9hDx");
var $1240297650bb5d51$var$propTypes = {
    tag: (0, $e9hDx.tagPropType),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $1240297650bb5d51$var$defaultProps = {
    tag: "div"
};
var $1240297650bb5d51$var$CardGroup = function CardGroup(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, attributes = (0, $1En50.default)(props, [
        "className",
        "cssModule",
        "tag"
    ]);
    var classes = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, "card-group"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({}, attributes, {
        className: classes
    }));
};
$1240297650bb5d51$var$CardGroup.propTypes = $1240297650bb5d51$var$propTypes;
$1240297650bb5d51$var$CardGroup.defaultProps = $1240297650bb5d51$var$defaultProps;
var $1240297650bb5d51$export$2e2bcd8739ae039 = $1240297650bb5d51$var$CardGroup;

});


parcelRegister("74fmC", function(module, exports) {
"use strict";
var $0153f2e366945c90$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $0153f2e366945c90$var$react_1 = $0153f2e366945c90$var$__importDefault((parcelRequire("acw62")));

var $3pVem = parcelRequire("3pVem");
const $0153f2e366945c90$var$CardLink = (props)=>{
    return $0153f2e366945c90$var$react_1.default.createElement($3pVem.default, {
        "data-lwt-id": props.dataLwtId,
        ...props
    });
};
module.exports.default = $0153f2e366945c90$var$CardLink;

});
parcelRegister("3pVem", function(module, exports) {

$parcel$export(module.exports, "default", () => $27d019b2a443fae2$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $e9hDx = parcelRequire("e9hDx");
var $27d019b2a443fae2$var$propTypes = {
    tag: (0, $e9hDx.tagPropType),
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $27d019b2a443fae2$var$defaultProps = {
    tag: "a"
};
var $27d019b2a443fae2$var$CardLink = function CardLink(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, innerRef = props.innerRef, attributes = (0, $1En50.default)(props, [
        "className",
        "cssModule",
        "tag",
        "innerRef"
    ]);
    var classes = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, "card-link"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({}, attributes, {
        ref: innerRef,
        className: classes
    }));
};
$27d019b2a443fae2$var$CardLink.propTypes = $27d019b2a443fae2$var$propTypes;
$27d019b2a443fae2$var$CardLink.defaultProps = $27d019b2a443fae2$var$defaultProps;
var $27d019b2a443fae2$export$2e2bcd8739ae039 = $27d019b2a443fae2$var$CardLink;

});



parcelRegister("k27Ff", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $klEzJ = parcelRequire("klEzJ");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $bpXRA = parcelRequire("bpXRA");
function $e959f086e329e090$var$_interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        "default": e
    };
}
var $e959f086e329e090$var$React__default = /*#__PURE__*/ $e959f086e329e090$var$_interopDefaultLegacy($acw62);
var $e959f086e329e090$var$classNames__default = /*#__PURE__*/ $e959f086e329e090$var$_interopDefaultLegacy($8g1PZ);
const $e959f086e329e090$var$add_to_list = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "arrow-left-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 10C7.75 9.58579 8.08579 9.25 8.5 9.25H17C17.4142 9.25 17.75 9.58579 17.75 10C17.75 10.4142 17.4142 10.75 17 10.75H8.5C8.08579 10.75 7.75 10.4142 7.75 10Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 5C7.75 4.58579 8.08579 4.25 8.5 4.25L17 4.25C17.4142 4.25 17.75 4.58579 17.75 5C17.75 5.41421 17.4142 5.75 17 5.75H8.5C8.08579 5.75 7.75 5.41421 7.75 5Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 15C7.75 14.5858 8.08579 14.25 8.5 14.25H17C17.4142 14.25 17.75 14.5858 17.75 15C17.75 15.4142 17.4142 15.75 17 15.75H8.5C8.08579 15.75 7.75 15.4142 7.75 15Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.5 17.25C4.08579 17.25 3.75 16.9142 3.75 16.5L3.75 13.5C3.75 13.0858 4.08579 12.75 4.5 12.75C4.91421 12.75 5.25 13.0858 5.25 13.5L5.25 16.5C5.25 16.9142 4.91421 17.25 4.5 17.25Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.25 15C2.25 14.5858 2.58579 14.25 3 14.25H6C6.41421 14.25 6.75 14.5858 6.75 15C6.75 15.4142 6.41421 15.75 6 15.75H3C2.58579 15.75 2.25 15.4142 2.25 15Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M6 10C6 10.8284 5.32843 11.5 4.5 11.5C3.67157 11.5 3 10.8284 3 10C3 9.17157 3.67157 8.5 4.5 8.5C5.32843 8.5 6 9.17157 6 10Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M6 5C6 5.82843 5.32843 6.5 4.5 6.5C3.67157 6.5 3 5.82843 3 5C3 4.17157 3.67157 3.5 4.5 3.5C5.32843 3.5 6 4.17157 6 5Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$add_user = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "add-user-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M14.25 15.5566C14.25 15.033 14.0894 14.6192 13.8291 14.3428C13.5766 14.0746 13.1624 13.8624 12.502 13.8623H7.50488C6.7856 13.8623 6.42446 14.035 6.20703 14.2988C5.95759 14.6018 5.75 15.1967 5.75 16.3652L5.75293 17.25H14.25V15.5566ZM11.75 9.44531C11.75 8.91102 11.6049 8.50132 11.3584 8.23242C11.1231 7.97584 10.7064 7.75005 9.95215 7.75C9.19863 7.75 8.8165 7.97465 8.6084 8.21582C8.38286 8.47727 8.25 8.88733 8.25 9.44531C8.25012 10.3586 9.01547 11.1406 9.95215 11.1406C10.9264 11.1405 11.7499 10.3217 11.75 9.44531ZM13.25 9.44531C13.2499 10.7513 12.3996 11.8654 11.2588 12.3623H12.502C13.5067 12.3624 14.3417 12.6983 14.9219 13.3145C15.4942 13.9224 15.75 14.7309 15.75 15.5566V18.75H4.25879L4.25 16.3682V16.3652C4.25 15.0902 4.46243 14.058 5.04883 13.3457C5.66726 12.5947 6.55897 12.3623 7.50488 12.3623H8.6543C7.53157 11.8589 6.75009 10.7277 6.75 9.44531C6.75 8.67914 6.92932 7.86627 7.47266 7.23633C8.03378 6.58605 8.87875 6.25 9.95215 6.25C11.0243 6.25005 11.8819 6.5841 12.4639 7.21875C13.0346 7.8413 13.25 8.65518 13.25 9.44531Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M14.7857 3.78571V2.35714C14.7857 2.1599 14.9456 2 15.1429 2H15.8571C16.0544 2 16.2143 2.1599 16.2143 2.35714V3.78571H17.6429C17.8401 3.78571 18 3.94561 18 4.14286V4.85714C18 5.05439 17.8401 5.21429 17.6429 5.21429H16.2143V6.64286C16.2143 6.8401 16.0544 7 15.8571 7H15.1429C14.9456 7 14.7857 6.8401 14.7857 6.64286V5.21429H13.3571C13.1599 5.21429 13 5.05439 13 4.85714V4.14286C13 3.94561 13.1599 3.78571 13.3571 3.78571H14.7857Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$agent = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "agent-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.25 14C3.25 11.3766 5.37665 9.25 8 9.25H12C14.6234 9.25 16.75 11.3766 16.75 14V17C16.75 17.4142 16.4142 17.75 16 17.75H4C3.58579 17.75 3.25 17.4142 3.25 17V14ZM8 10.75C6.20507 10.75 4.75 12.2051 4.75 14V16.25H15.25V14C15.25 12.2051 13.7949 10.75 12 10.75H8Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.25 5C6.25 2.92893 7.92893 1.25 10 1.25C12.0711 1.25 13.75 2.92893 13.75 5V6C13.75 8.07107 12.0711 9.75 10 9.75C7.92893 9.75 6.25 8.07107 6.25 6V5ZM10 2.75C8.75736 2.75 7.75 3.75736 7.75 5V6C7.75 7.24264 8.75736 8.25 10 8.25C11.2426 8.25 12.25 7.24264 12.25 6V5C12.25 3.75736 11.2426 2.75 10 2.75Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M11 13.5C11 13.2239 11.2239 13 11.5 13H13.5C13.7761 13 14 13.2239 14 13.5C14 13.7761 13.7761 14 13.5 14H11.5C11.2239 14 11 13.7761 11 13.5Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$app_grid = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "app-grid", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.5 5C3.5 4.53406 3.5 4.30109 3.57612 4.11732C3.67761 3.87229 3.87229 3.67761 4.11732 3.57612C4.30109 3.5 4.53406 3.5 5 3.5C5.46594 3.5 5.69891 3.5 5.88268 3.57612C6.12771 3.67761 6.32239 3.87229 6.42388 4.11732C6.5 4.30109 6.5 4.53406 6.5 5C6.5 5.46594 6.5 5.69891 6.42388 5.88268C6.32239 6.12771 6.12771 6.32239 5.88268 6.42388C5.69891 6.5 5.46594 6.5 5 6.5C4.53406 6.5 4.30109 6.5 4.11732 6.42388C3.87229 6.32239 3.67761 6.12771 3.57612 5.88268C3.5 5.69891 3.5 5.46594 3.5 5ZM3.5 10C3.5 9.53406 3.5 9.30109 3.57612 9.11732C3.67761 8.87229 3.87229 8.67761 4.11732 8.57612C4.30109 8.5 4.53406 8.5 5 8.5C5.46594 8.5 5.69891 8.5 5.88268 8.57612C6.12771 8.67761 6.32239 8.87229 6.42388 9.11732C6.5 9.30109 6.5 9.53406 6.5 10C6.5 10.4659 6.5 10.6989 6.42388 10.8827C6.32239 11.1277 6.12771 11.3224 5.88268 11.4239C5.69891 11.5 5.46594 11.5 5 11.5C4.53406 11.5 4.30109 11.5 4.11732 11.4239C3.87229 11.3224 3.67761 11.1277 3.57612 10.8827C3.5 10.6989 3.5 10.4659 3.5 10ZM3.57612 14.1173C3.5 14.3011 3.5 14.5341 3.5 15C3.5 15.4659 3.5 15.6989 3.57612 15.8827C3.67761 16.1277 3.87229 16.3224 4.11732 16.4239C4.30109 16.5 4.53406 16.5 5 16.5C5.46594 16.5 5.69891 16.5 5.88268 16.4239C6.12771 16.3224 6.32239 16.1277 6.42388 15.8827C6.5 15.6989 6.5 15.4659 6.5 15C6.5 14.5341 6.5 14.3011 6.42388 14.1173C6.32239 13.8723 6.12771 13.6776 5.88268 13.5761C5.69891 13.5 5.46594 13.5 5 13.5C4.53406 13.5 4.30109 13.5 4.11732 13.5761C3.87229 13.6776 3.67761 13.8723 3.57612 14.1173ZM8.5 5C8.5 4.53406 8.5 4.30109 8.57612 4.11732C8.67761 3.87229 8.87229 3.67761 9.11732 3.57612C9.30109 3.5 9.53406 3.5 10 3.5C10.4659 3.5 10.6989 3.5 10.8827 3.57612C11.1277 3.67761 11.3224 3.87229 11.4239 4.11732C11.5 4.30109 11.5 4.53406 11.5 5C11.5 5.46594 11.5 5.69891 11.4239 5.88268C11.3224 6.12771 11.1277 6.32239 10.8827 6.42388C10.6989 6.5 10.4659 6.5 10 6.5C9.53406 6.5 9.30109 6.5 9.11732 6.42388C8.87229 6.32239 8.67761 6.12771 8.57612 5.88268C8.5 5.69891 8.5 5.46594 8.5 5ZM13.5761 4.11732C13.5 4.30109 13.5 4.53406 13.5 5C13.5 5.46594 13.5 5.69891 13.5761 5.88268C13.6776 6.12771 13.8723 6.32239 14.1173 6.42388C14.3011 6.5 14.5341 6.5 15 6.5C15.4659 6.5 15.6989 6.5 15.8827 6.42388C16.1277 6.32239 16.3224 6.12771 16.4239 5.88268C16.5 5.69891 16.5 5.46594 16.5 5C16.5 4.53406 16.5 4.30109 16.4239 4.11732C16.3224 3.87229 16.1277 3.67761 15.8827 3.57612C15.6989 3.5 15.4659 3.5 15 3.5C14.5341 3.5 14.3011 3.5 14.1173 3.57612C13.8723 3.67761 13.6776 3.87229 13.5761 4.11732ZM8.5 10C8.5 9.53406 8.5 9.30109 8.57612 9.11732C8.67761 8.87229 8.87229 8.67761 9.11732 8.57612C9.30109 8.5 9.53406 8.5 10 8.5C10.4659 8.5 10.6989 8.5 10.8827 8.57612C11.1277 8.67761 11.3224 8.87229 11.4239 9.11732C11.5 9.30109 11.5 9.53406 11.5 10C11.5 10.4659 11.5 10.6989 11.4239 10.8827C11.3224 11.1277 11.1277 11.3224 10.8827 11.4239C10.6989 11.5 10.4659 11.5 10 11.5C9.53406 11.5 9.30109 11.5 9.11732 11.4239C8.87229 11.3224 8.67761 11.1277 8.57612 10.8827C8.5 10.6989 8.5 10.4659 8.5 10ZM8.57612 14.1173C8.5 14.3011 8.5 14.5341 8.5 15C8.5 15.4659 8.5 15.6989 8.57612 15.8827C8.67761 16.1277 8.87229 16.3224 9.11732 16.4239C9.30109 16.5 9.53406 16.5 10 16.5C10.4659 16.5 10.6989 16.5 10.8827 16.4239C11.1277 16.3224 11.3224 16.1277 11.4239 15.8827C11.5 15.6989 11.5 15.4659 11.5 15C11.5 14.5341 11.5 14.3011 11.4239 14.1173C11.3224 13.8723 11.1277 13.6776 10.8827 13.5761C10.6989 13.5 10.4659 13.5 10 13.5C9.53406 13.5 9.30109 13.5 9.11732 13.5761C8.87229 13.6776 8.67761 13.8723 8.57612 14.1173ZM13.5 10C13.5 9.53406 13.5 9.30109 13.5761 9.11732C13.6776 8.87229 13.8723 8.67761 14.1173 8.57612C14.3011 8.5 14.5341 8.5 15 8.5C15.4659 8.5 15.6989 8.5 15.8827 8.57612C16.1277 8.67761 16.3224 8.87229 16.4239 9.11732C16.5 9.30109 16.5 9.53406 16.5 10C16.5 10.4659 16.5 10.6989 16.4239 10.8827C16.3224 11.1277 16.1277 11.3224 15.8827 11.4239C15.6989 11.5 15.4659 11.5 15 11.5C14.5341 11.5 14.3011 11.5 14.1173 11.4239C13.8723 11.3224 13.6776 11.1277 13.5761 10.8827C13.5 10.6989 13.5 10.4659 13.5 10ZM13.5761 14.1173C13.5 14.3011 13.5 14.5341 13.5 15C13.5 15.4659 13.5 15.6989 13.5761 15.8827C13.6776 16.1277 13.8723 16.3224 14.1173 16.4239C14.3011 16.5 14.5341 16.5 15 16.5C15.4659 16.5 15.6989 16.5 15.8827 16.4239C16.1277 16.3224 16.3224 16.1277 16.4239 15.8827C16.5 15.6989 16.5 15.4659 16.5 15C16.5 14.5341 16.5 14.3011 16.4239 14.1173C16.3224 13.8723 16.1277 13.6776 15.8827 13.5761C15.6989 13.5 15.4659 13.5 15 13.5C14.5341 13.5 14.3011 13.5 14.1173 13.5761C13.8723 13.6776 13.6776 13.8723 13.5761 14.1173Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$archive = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "archive-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.25 5.5C2.25 4.5335 3.0335 3.75 4 3.75H16C16.9665 3.75 17.75 4.5335 17.75 5.5V7.75H2.25V5.5ZM4 5.25C3.86193 5.25 3.75 5.36193 3.75 5.5V6.25H16.25V5.5C16.25 5.36193 16.1381 5.25 16 5.25H4ZM3.25 14.5V8.5H4.75V14.5C4.75 14.9142 5.08579 15.25 5.5 15.25H14.5C14.9142 15.25 15.25 14.9142 15.25 14.5V8.5H16.75V14.5C16.75 15.7426 15.7426 16.75 14.5 16.75H5.5C4.25736 16.75 3.25 15.7426 3.25 14.5ZM7.5 11.25C7.5 10.8358 7.83579 10.5 8.25 10.5H11.75C12.1642 10.5 12.5 10.8358 12.5 11.25C12.5 11.6642 12.1642 12 11.75 12H8.25C7.83579 12 7.5 11.6642 7.5 11.25Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$archive_restore = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "archive-restore-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.25 14.5V8.5H4.75V14.5C4.75 14.9142 5.08579 15.25 5.5 15.25H14.5C14.9142 15.25 15.25 14.9142 15.25 14.5V8.5H16.75V14.5C16.75 15.7426 15.7426 16.75 14.5 16.75H5.5C4.25736 16.75 3.25 15.7426 3.25 14.5Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.46967 12.0303C7.76256 12.3232 8.23744 12.3232 8.53033 12.0303L10 10.5607L11.4697 12.0303C11.7626 12.3232 12.2374 12.3232 12.5303 12.0303C12.8232 11.7374 12.8232 11.2626 12.5303 10.9697L10.5303 8.96967C10.2374 8.67678 9.76256 8.67678 9.46967 8.96967L7.46967 10.9697C7.17678 11.2626 7.17678 11.7374 7.46967 12.0303Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 14.25C10.4142 14.25 10.75 13.9142 10.75 13.5V10C10.75 9.58579 10.4142 9.25 10 9.25C9.58579 9.25 9.25 9.58579 9.25 10V13.5C9.25 13.9142 9.58579 14.25 10 14.25Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.25 5.5C2.25 4.5335 3.0335 3.75 4 3.75H16C16.9665 3.75 17.75 4.5335 17.75 5.5V7C17.75 7.41421 17.4142 7.75 17 7.75H3C2.58579 7.75 2.25 7.41421 2.25 7V5.5ZM4 5.25C3.86193 5.25 3.75 5.36193 3.75 5.5V6.25H16.25V5.5C16.25 5.36193 16.1381 5.25 16 5.25H4Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$arrow_chart_line = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "arrow-chart-line-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.5303 5.21967C17.8232 5.51256 17.8232 5.98744 17.5303 6.28033L11.0303 12.7803C10.7374 13.0732 10.2626 13.0732 9.96967 12.7803L8 10.8107L3.53033 15.2803C3.23744 15.5732 2.76256 15.5732 2.46967 15.2803C2.17678 14.9874 2.17678 14.5126 2.46967 14.2197L7.46967 9.21967C7.76256 8.92678 8.23744 8.92678 8.53033 9.21967L10.5 11.1893L16.4697 5.21967C16.7626 4.92678 17.2374 4.92678 17.5303 5.21967Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.25 5.75C12.25 5.33579 12.5858 5 13 5L17 5C17.4142 5 17.75 5.33579 17.75 5.75V9.75C17.75 10.1642 17.4142 10.5 17 10.5C16.5858 10.5 16.25 10.1642 16.25 9.75V6.5L13 6.5C12.5858 6.5 12.25 6.16421 12.25 5.75Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$arrow_chart_line_down = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "arrow-chart-line-down-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.5303 15.2803C17.8232 14.9874 17.8232 14.5126 17.5303 14.2197L11.0303 7.71967C10.7374 7.42678 10.2626 7.42678 9.96967 7.71967L8 9.68934L3.53033 5.21967C3.23744 4.92678 2.76256 4.92678 2.46967 5.21967C2.17678 5.51256 2.17678 5.98744 2.46967 6.28033L7.46967 11.2803C7.76256 11.5732 8.23744 11.5732 8.53033 11.2803L10.5 9.31066L16.4697 15.2803C16.7626 15.5732 17.2374 15.5732 17.5303 15.2803Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.25 14.75C12.25 15.1642 12.5858 15.5 13 15.5L17 15.5C17.4142 15.5 17.75 15.1642 17.75 14.75V10.75C17.75 10.3358 17.4142 10 17 10C16.5858 10 16.25 10.3358 16.25 10.75V14L13 14C12.5858 14 12.25 14.3358 12.25 14.75Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$arrow_down = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "arrow-down-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.5303 16.5303C10.2374 16.8232 9.76256 16.8232 9.46967 16.5303L4.6967 11.7574C4.4038 11.4645 4.4038 10.9896 4.6967 10.6967C4.98959 10.4038 5.46446 10.4038 5.75736 10.6967L9.25 14.1893L9.25 4C9.25 3.58579 9.58578 3.25 10 3.25C10.4142 3.25 10.75 3.58579 10.75 4L10.75 14.1893L14.2426 10.6967C14.5355 10.4038 15.0104 10.4038 15.3033 10.6967C15.5962 10.9896 15.5962 11.4645 15.3033 11.7574L10.5303 16.5303Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$arrow_left = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "arrow-left-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.841 6.53033C7.13389 6.23744 7.13389 5.76256 6.841 5.46967C6.54811 5.17678 6.07323 5.17678 5.78034 5.46967L1.78034 9.46967L1.25001 10L1.78034 10.5303L5.78034 14.5303C6.07323 14.8232 6.54811 14.8232 6.841 14.5303C7.13389 14.2374 7.13389 13.7626 6.841 13.4697L4.12133 10.75L18.3107 10.75C18.7249 10.75 19.0607 10.4142 19.0607 10C19.0607 9.58579 18.7249 9.25 18.3107 9.25L4.12133 9.25L6.841 6.53033Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$arrow_right = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "arrow-right-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.4697 13.4697C13.1768 13.7626 13.1768 14.2374 13.4697 14.5303C13.7626 14.8232 14.2374 14.8232 14.5303 14.5303L18.5303 10.5303L19.0607 10L18.5303 9.46967L14.5303 5.46967C14.2374 5.17678 13.7626 5.17678 13.4697 5.46967C13.1768 5.76256 13.1768 6.23744 13.4697 6.53033L16.1893 9.25H2C1.58579 9.25 1.25 9.58579 1.25 10C1.25 10.4142 1.58579 10.75 2 10.75H16.1893L13.4697 13.4697Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$arrow_up = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "arrow-up-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.46967 3.46967C9.76256 3.17678 10.2374 3.17678 10.5303 3.46967L15.3033 8.24264C15.5962 8.53553 15.5962 9.01041 15.3033 9.3033C15.0104 9.59619 14.5355 9.59619 14.2426 9.3033L10.75 5.81066V16C10.75 16.4142 10.4142 16.75 10 16.75C9.58579 16.75 9.25 16.4142 9.25 16V5.81066L5.75736 9.3033C5.46447 9.59619 4.98959 9.59619 4.6967 9.3033C4.4038 9.01041 4.4038 8.53553 4.6967 8.24264L9.46967 3.46967Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$arrows_left_right = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "arrows-left-right-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.53033 16.5304C7.82322 16.2375 7.82322 15.7626 7.53033 15.4697L5.06066 13L7.53033 10.5304C7.82322 10.2375 7.82322 9.76259 7.53033 9.4697C7.23744 9.1768 6.76256 9.1768 6.46967 9.4697L3.46967 12.4697C3.17678 12.7626 3.17678 13.2375 3.46967 13.5304L6.46967 16.5304C6.76256 16.8233 7.23744 16.8233 7.53033 16.5304Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.4697 3.46967C12.1768 3.76256 12.1768 4.23744 12.4697 4.53033L14.9393 7L12.4697 9.46967C12.1768 9.76256 12.1768 10.2374 12.4697 10.5303C12.7626 10.8232 13.2374 10.8232 13.5303 10.5303L16.5303 7.53033C16.8232 7.23744 16.8232 6.76256 16.5303 6.46967L13.5303 3.46967C13.2374 3.17678 12.7626 3.17678 12.4697 3.46967Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.25 7.00003C4.25 7.41424 4.58579 7.75003 5 7.75003H16C16.4142 7.75003 16.75 7.41424 16.75 7.00003C16.75 6.58581 16.4142 6.25003 16 6.25003H5C4.58579 6.25003 4.25 6.58581 4.25 7.00003Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.75 13C15.75 12.5858 15.4142 12.25 15 12.25H5C4.58579 12.25 4.25 12.5858 4.25 13C4.25 13.4142 4.58579 13.75 5 13.75H15C15.4142 13.75 15.75 13.4142 15.75 13Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$arrows_up_down = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "arrows-up-down-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.5304 12.4697C16.2375 12.1768 15.7626 12.1768 15.4697 12.4697L13 14.9393L10.5304 12.4697C10.2375 12.1768 9.76259 12.1768 9.4697 12.4697C9.1768 12.7626 9.1768 13.2374 9.4697 13.5303L12.4697 16.5303C12.7626 16.8232 13.2375 16.8232 13.5304 16.5303L16.5304 13.5303C16.8233 13.2374 16.8233 12.7626 16.5304 12.4697Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.46967 7.53033C3.76256 7.82323 4.23744 7.82323 4.53033 7.53033L7 5.06066L9.46967 7.53033C9.76256 7.82323 10.2374 7.82323 10.5303 7.53033C10.8232 7.23744 10.8232 6.76256 10.5303 6.46967L7.53033 3.46967C7.23744 3.17678 6.76256 3.17678 6.46967 3.46967L3.46967 6.46967C3.17678 6.76257 3.17678 7.23744 3.46967 7.53033Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.00003 15.75C7.41424 15.75 7.75003 15.4142 7.75003 15V4C7.75003 3.58579 7.41424 3.25 7.00003 3.25C6.58581 3.25 6.25003 3.58579 6.25003 4V15C6.25003 15.4142 6.58581 15.75 7.00003 15.75Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13 4.25C12.5858 4.25 12.25 4.58579 12.25 5V15C12.25 15.4142 12.5858 15.75 13 15.75C13.4142 15.75 13.75 15.4142 13.75 15V5C13.75 4.58579 13.4142 4.25 13 4.25Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$avg_bar_chart = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "avg_bar_chart", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M4.00001 6.9C4.00001 6.67909 4.1791 6.5 4.40001 6.5H6.60001C6.82093 6.5 7.00001 6.67909 7.00001 6.9V15.6266C7.00001 15.8475 6.82093 16.0266 6.60001 16.0266H4.40001C4.1791 16.0266 4.00001 15.8475 4.00001 15.6266V6.9Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M13.9463 4.4C13.9463 4.17909 14.1254 4 14.3463 4H16.5463C16.7672 4 16.9463 4.17909 16.9463 4.4V15.6C16.9463 15.8209 16.7672 16 16.5463 16H14.3463C14.1254 16 13.9463 15.8209 13.9463 15.6V4.4Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M8.90001 11.4C8.90001 11.1791 9.0791 11 9.30001 11H11.5C11.7209 11 11.9 11.1791 11.9 11.4V15.6266C11.9 15.8475 11.7209 16.0266 11.5 16.0266H9.30001C9.0791 16.0266 8.90001 15.8475 8.90001 15.6266V11.4Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.25 9C2.25 8.58579 2.58579 8.25 3 8.25H18C18.4142 8.25 18.75 8.58579 18.75 9C18.75 9.41421 18.4142 9.75 18 9.75H3C2.58579 9.75 2.25 9.41421 2.25 9Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$banking_reconciliation = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "banking_reconciliation-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4 2.25C3.0335 2.25 2.25 3.0335 2.25 4V13C2.25 13.9665 3.0335 14.75 4 14.75H5.25V16C5.25 16.9665 6.0335 17.75 7 17.75H16C16.9665 17.75 17.75 16.9665 17.75 16V7C17.75 6.0335 16.9665 5.25 16 5.25H14.75V4C14.75 3.0335 13.9665 2.25 13 2.25H4ZM13.25 5.25V4C13.25 3.86193 13.1381 3.75 13 3.75H4C3.86193 3.75 3.75 3.86193 3.75 4V13C3.75 13.1381 3.86193 13.25 4 13.25H5.25V6C5.25 5.58579 5.58579 5.25 6 5.25H13.25ZM6.75 14.75H14C14.4142 14.75 14.75 14.4142 14.75 14V6.75H16C16.1381 6.75 16.25 6.86193 16.25 7V16C16.25 16.1381 16.1381 16.25 16 16.25H7C6.86193 16.25 6.75 16.1381 6.75 16V14.75ZM12.5303 9.03033C12.8232 8.73744 12.8232 8.26256 12.5303 7.96967C12.2374 7.67678 11.7626 7.67678 11.4697 7.96967L9.5 9.93934L9.03033 9.46967C8.73744 9.17678 8.26256 9.17678 7.96967 9.46967C7.67678 9.76256 7.67678 10.2374 7.96967 10.5303L8.96967 11.5303C9.26256 11.8232 9.73744 11.8232 10.0303 11.5303L12.5303 9.03033Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$bathtub = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "bathtub-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.25 4.5C10.25 2.70507 11.7051 1.25 13.5 1.25C15.2949 1.25 16.75 2.70507 16.75 4.5V10.25H17C17.9665 10.25 18.75 11.0335 18.75 12V14.5C18.75 16.8472 16.8472 18.75 14.5 18.75H7C3.82436 18.75 1.25 16.1756 1.25 13V12C1.25 11.0335 2.0335 10.25 3 10.25H15.25V4.5C15.25 3.5335 14.4665 2.75 13.5 2.75C12.5335 2.75 11.75 3.5335 11.75 4.5V5.09451C13.0439 5.42755 14 6.60212 14 8H8C8 6.60212 8.95608 5.42755 10.25 5.09451V4.5ZM3 11.75H17C17.1381 11.75 17.25 11.8619 17.25 12V14.5C17.25 16.0188 16.0188 17.25 14.5 17.25H7C4.65279 17.25 2.75 15.3472 2.75 13V12C2.75 11.8619 2.86193 11.75 3 11.75Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$bed = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "bed-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.7461 3.67332C16.7077 3.29513 16.3883 3 16 3H4C3.58579 3 3.25 3.33579 3.25 3.75V10.0137C2.12501 10.1381 1.25 11.0919 1.25 12.25V15.75C1.25 16.1642 1.58579 16.5 2 16.5H3V18C3 18.4142 3.33579 18.75 3.75 18.75C4.16421 18.75 4.5 18.4142 4.5 18V16.5H15.5V18C15.5 18.4142 15.8358 18.75 16.25 18.75C16.6642 18.75 17 18.4142 17 18V16.5H18C18.4142 16.5 18.75 16.1642 18.75 15.75V12.25C18.75 11.0919 17.875 10.1381 16.75 10.0137V3.75C16.75 3.72411 16.7487 3.69853 16.7461 3.67332ZM15.25 4.5L4.75 4.5V8.7815C4.82991 8.76094 4.91368 8.75 5 8.75H7.5C8.24325 8.75 8.86024 9.29057 8.97926 10H11.0207C11.1398 9.29057 11.7568 8.75 12.5 8.75H15C15.0863 8.75 15.1701 8.76094 15.25 8.78151V4.5ZM3.5 11.5H16.5C16.9142 11.5 17.25 11.8358 17.25 12.25V15H2.75V12.25C2.75 11.8358 3.08579 11.5 3.5 11.5Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$book = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "book-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.5 4.05951C2.80964 4.05951 2.25 4.61915 2.25 5.30951V5.58478C1.9407 5.90041 1.75 6.3327 1.75 6.80952V15.0952C1.75 16.0617 2.5335 16.8452 3.5 16.8452H7.73676C7.7992 16.8452 7.85937 16.8686 7.90545 16.9107L8.81915 17.7461C9.48773 18.3574 10.5123 18.3574 11.1808 17.7461L12.0945 16.9107C12.1406 16.8686 12.2008 16.8452 12.2632 16.8452H16.5C17.4665 16.8452 18.25 16.0617 18.25 15.0952V6.80952C18.25 6.33269 18.0593 5.90041 17.75 5.58477V5.30951C17.75 4.61915 17.1904 4.05951 16.5 4.05951H12.1582C11.7003 4.05951 11.2607 4.23897 10.9336 4.55938L10 5.4739L9.06643 4.55938C8.73934 4.23897 8.29969 4.05951 7.84181 4.05951H3.5ZM3.75 14.3452V5.55951H7.84181C7.90722 5.55951 7.97003 5.58515 8.01676 5.63092L9.25 6.83899V15.0249L8.55614 14.3452H3.75ZM10.75 15.0249L11.4439 14.3452H16.25V5.55951H12.1582C12.0928 5.55951 12.03 5.58515 11.9832 5.63092L10.75 6.83899V15.0249Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$bell_notification = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "bell-notification-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.75 10.7536V10.8464C15.75 11.8153 16.0368 12.7627 16.5743 13.5689L17.624 15.1435C17.7775 15.3736 17.7918 15.6695 17.6613 15.9134C17.5307 16.1573 17.2766 16.3095 17 16.3095H12.7388C12.6125 17.7111 11.4345 18.8095 10 18.8095C8.56549 18.8095 7.38752 17.7111 7.26121 16.3095H3C2.7234 16.3095 2.46926 16.1573 2.33875 15.9134C2.20823 15.6695 2.22254 15.3736 2.37596 15.1435L3.42568 13.5689C3.96318 12.7627 4.25 11.8153 4.25 10.8464V9.55951C4.25 6.38387 6.82436 3.80951 10 3.80951C10.1378 3.80951 10.2744 3.81436 10.4098 3.82389C10.2092 4.28699 10.0766 4.78643 10.0247 5.30958C10.0165 5.30953 10.0082 5.30951 10 5.30951C7.65279 5.30951 5.75 7.2123 5.75 9.55951V10.8464C5.75 12.1115 5.37552 13.3483 4.67375 14.401L4.40139 14.8095H15.5986L15.3263 14.401C14.6245 13.3483 14.25 12.1115 14.25 10.8464V10.7536C14.4946 10.7904 14.7451 10.8095 15 10.8095C15.2549 10.8095 15.5054 10.7904 15.75 10.7536ZM10 17.3095C9.39526 17.3095 8.89082 16.8801 8.77501 16.3095H11.225C11.1092 16.8801 10.6047 17.3095 10 17.3095Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M19 5.80951C19 8.01865 17.2091 9.80951 15 9.80951C12.7909 9.80951 11 8.01865 11 5.80951C11 3.60037 12.7909 1.80951 15 1.80951C17.2091 1.80951 19 3.60037 19 5.80951Z",
        fill: "#B91C1C"
    }));
};
const $e959f086e329e090$var$bookmark = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "bookmark-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        // eslint-disable-next-line max-len
        d: "M15.25 3.25L4.75 3.25L4.75 16.5986L9.58398 13.376C9.8359 13.208 10.1641 13.208 10.416 13.376L15.25 16.5986V3.25ZM16.75 2.5V18C16.75 18.2766 16.5978 18.5307 16.3539 18.6613C16.11 18.7918 15.8141 18.7775 15.584 18.624L10 14.9014L4.41603 18.624C4.18588 18.7775 3.88997 18.7918 3.64611 18.6613C3.40224 18.5307 3.25 18.2766 3.25 18L3.25 2.5C3.25 2.08579 3.58579 1.75 4 1.75L16 1.75C16.4142 1.75 16.75 2.08579 16.75 2.5Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$box_size = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "box-size-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M4.5 3C4.5 3.41421 4.16421 3.75 3.75 3.75L3.5 3.75L3.5 16.5H16.75V16.25C16.75 15.8358 17.0858 15.5 17.5 15.5C17.9142 15.5 18.25 15.8358 18.25 16.25V18.25C18.25 18.6642 17.9142 19 17.5 19C17.0858 19 16.75 18.6642 16.75 18.25V18H2.75C2.33579 18 2 17.6642 2 17.25L2 3.75L1.75 3.75C1.33579 3.75 1 3.41421 1 3C1 2.58579 1.33579 2.25 1.75 2.25H3.75C4.16421 2.25 4.5 2.58579 4.5 3Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 2.25C6.58579 2.25 6.25 2.58579 6.25 3V13C6.25 13.4142 6.58579 13.75 7 13.75H17C17.4142 13.75 17.75 13.4142 17.75 13V3C17.75 2.58579 17.4142 2.25 17 2.25H7ZM7.75 12.25V3.75H16.25V12.25H7.75Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$briefcase = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "briefcase-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 2.25C12.9665 2.25 13.75 3.0335 13.75 4V5.25H17C17.9665 5.25 18.75 6.0335 18.75 7V16C18.75 16.9665 17.9665 17.75 17 17.75H3C2.0335 17.75 1.25 16.9665 1.25 16V7C1.25 6.0335 2.0335 5.25 3 5.25H6.25V4C6.25 3.0335 7.0335 2.25 8 2.25H12ZM3 6.75C2.86193 6.75 2.75 6.86193 2.75 7V7.5613L10 11.6394L17.25 7.5613V7C17.25 6.86193 17.1381 6.75 17 6.75H3ZM12.25 5.25H7.75V4C7.75 3.86193 7.86193 3.75 8 3.75H12C12.1381 3.75 12.25 3.86193 12.25 4V5.25ZM2.75 9.28232L9.61509 13.1439C9.65449 13.1674 9.69586 13.1872 9.73861 13.2031C9.82388 13.2349 9.91237 13.2502 10 13.2501C10.1354 13.25 10.2687 13.2132 10.3849 13.1439L17.25 9.28232V16C17.25 16.1381 17.1381 16.25 17 16.25H3C2.86193 16.25 2.75 16.1381 2.75 16V9.28232Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$browser = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "browser-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4 4.80951C2.89543 4.80951 2 5.70494 2 6.80951V15.8095C2 16.9141 2.89543 17.8095 4 17.8095H16C17.1046 17.8095 18 16.9141 18 15.8095V6.80951C18 5.70494 17.1046 4.80951 16 4.80951H4ZM3.5 15.8095V8.55951L16.5 8.55951V15.8095C16.5 16.0857 16.2761 16.3095 16 16.3095H4C3.72386 16.3095 3.5 16.0857 3.5 15.8095ZM4.25 6.05951C3.83579 6.05951 3.5 6.3953 3.5 6.80951C3.5 7.22372 3.83579 7.55951 4.25 7.55951C4.66421 7.55951 5 7.22372 5 6.80951C5 6.3953 4.66421 6.05951 4.25 6.05951ZM6.75 6.05951C6.33579 6.05951 6 6.3953 6 6.80951C6 7.22372 6.33579 7.55951 6.75 7.55951C7.16421 7.55951 7.5 7.22372 7.5 6.80951C7.5 6.3953 7.16421 6.05951 6.75 6.05951ZM8.5 6.80951C8.5 6.3953 8.83579 6.05951 9.25 6.05951C9.66421 6.05951 10 6.3953 10 6.80951C10 7.22372 9.66421 7.55951 9.25 7.55951C8.83579 7.55951 8.5 7.22372 8.5 6.80951Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$building_bank = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "building-bank-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1 17.25H19V18.75H1V17.25Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.4528 1.40208C10.185 1.19931 9.81503 1.19931 9.54725 1.40208L1.54725 7.45977C1.36001 7.60154 1.25 7.82284 1.25 8.05769V10C1.25 10.4142 1.58579 10.75 2 10.75H3V14.75H2V16.25H18V14.75H17V10.75H18C18.4142 10.75 18.75 10.4142 18.75 10V8.05769C18.75 7.82284 18.64 7.60154 18.4528 7.45977L10.4528 1.40208ZM15.5 10.75H13V14.75H15.5V10.75ZM11.5 10.75H8.5L8.5 14.75H11.5V10.75ZM7 10.75H4.5L4.5 14.75H7L7 10.75ZM2.75 9.25V8.43054L10 2.94076L17.25 8.43054V9.25H2.75Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M11 7C11 7.55228 10.5523 8 10 8C9.44771 8 9 7.55228 9 7C9 6.44772 9.44771 6 10 6C10.5523 6 11 6.44772 11 7Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$building_condo = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "building-condo-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M9 6.25V4.75C9 4.33579 8.66421 4 8.25 4H6.75C6.33579 4 6 4.33579 6 4.75V6.25C6 6.66421 6.33579 7 6.75 7H8.25C8.66421 7 9 6.66421 9 6.25Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M9 8.75V10.25C9 10.6642 8.66421 11 8.25 11H6.75C6.33579 11 6 10.6642 6 10.25V8.75C6 8.33579 6.33579 8 6.75 8H8.25C8.66421 8 9 8.33579 9 8.75Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M14 6.25V4.75C14 4.33579 13.6642 4 13.25 4H11.75C11.3358 4 11 4.33579 11 4.75V6.25C11 6.66421 11.3358 7 11.75 7H13.25C13.6642 7 14 6.66421 14 6.25Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M14 8.75V10.25C14 10.6642 13.6642 11 13.25 11H11.75C11.3358 11 11 10.6642 11 10.25V8.75C11 8.33579 11.3358 8 11.75 8H13.25C13.6642 8 14 8.33579 14 8.75Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 1.25C2.58579 1.25 2.25 1.58579 2.25 2V18C2.25 18.4142 2.58579 18.75 3 18.75H17C17.4142 18.75 17.75 18.4142 17.75 18V2C17.75 1.58579 17.4142 1.25 17 1.25H3ZM3.75 17.25V2.75H16.25V17.25H12.25V13C12.25 12.5858 11.9142 12.25 11.5 12.25H8.5C8.08579 12.25 7.75 12.5858 7.75 13V17.25H3.75ZM9.25 17.25H10.75V13.75H9.25V17.25Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$building_modern = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "building-modern-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.5058 2.44619C17.6614 2.58828 17.75 2.78928 17.75 3V17C17.75 17.4142 17.4142 17.75 17 17.75H3C2.58579 17.75 2.25 17.4142 2.25 17V4.27273C2.25 3.88483 2.54579 3.56093 2.9321 3.52581L16.9321 2.25308C17.142 2.23401 17.3502 2.30409 17.5058 2.44619ZM3.75 4.95764V16.25H7.75V12C7.75 11.5858 8.08579 11.25 8.5 11.25H11.5C11.9142 11.25 12.25 11.5858 12.25 12V16.25H16.25V3.82128L3.75 4.95764ZM10.75 16.25V12.75H9.25V16.25H10.75ZM7.75 8C7.75 7.58579 8.08579 7.25 8.5 7.25H11.5C11.9142 7.25 12.25 7.58579 12.25 8C12.25 8.41422 11.9142 8.75 11.5 8.75H8.5C8.08579 8.75 7.75 8.41422 7.75 8Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$buyer_demand = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "buyer_demand-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M12 7.45237L14.5 5.30951L17 7.45237V10.3095H12V7.45237Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M3 9.05951C3 8.36915 3.55965 7.80951 4.25 7.80951H6.75C7.44036 7.80951 8 8.36915 8 9.05951V9.47618C8 9.59473 8 9.7075 8 9.8096C8 10.0857 7.77614 10.3095 7.5 10.3095H3.50001C3.22386 10.3095 3 10.0857 3 9.80959C3 9.70749 3 9.59472 3 9.47618V9.05951Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M4.25 6.55951C4.25 5.86915 4.80965 5.30951 5.5 5.30951C6.19036 5.30951 6.75 5.86915 6.75 6.55951C6.75 7.24987 6.19036 7.80951 5.5 7.80951C4.80965 7.80951 4.25 7.24987 4.25 6.55951Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.25 11.8095C2.25 11.3953 2.58579 11.0595 3 11.0595H17C17.4142 11.0595 17.75 11.3953 17.75 11.8095C17.75 12.2237 17.4142 12.5595 17 12.5595H3C2.58579 12.5595 2.25 12.2237 2.25 11.8095Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M9.52309 12.8239C9.66998 12.3575 10.33 12.3575 10.4769 12.8239L11.7321 16.8095H8.26795L9.52309 12.8239Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$calculator = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "calculator-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.25 2C3.25 1.58579 3.58579 1.25 4 1.25H16C16.4142 1.25 16.75 1.58579 16.75 2V18C16.75 18.4142 16.4142 18.75 16 18.75H4C3.58579 18.75 3.25 18.4142 3.25 18V2ZM4.75 2.75V17.25H15.25V2.75H4.75Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 4.25H14V6.75H6V4.25Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M11 9C11 9.55229 10.5523 10 10 10C9.44772 10 9 9.55229 9 9C9 8.44772 9.44772 8 10 8C10.5523 8 11 8.44772 11 9Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M11 12C11 12.5523 10.5523 13 10 13C9.44772 13 9 12.5523 9 12C9 11.4477 9.44772 11 10 11C10.5523 11 11 11.4477 11 12Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M11 15C11 15.5523 10.5523 16 10 16C9.44772 16 9 15.5523 9 15C9 14.4477 9.44772 14 10 14C10.5523 14 11 14.4477 11 15Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M14 9C14 9.55229 13.5523 10 13 10C12.4477 10 12 9.55229 12 9C12 8.44772 12.4477 8 13 8C13.5523 8 14 8.44772 14 9Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M14 12C14 12.5523 13.5523 13 13 13C12.4477 13 12 12.5523 12 12C12 11.4477 12.4477 11 13 11C13.5523 11 14 11.4477 14 12Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M14 15C14 15.5523 13.5523 16 13 16C12.4477 16 12 15.5523 12 15C12 14.4477 12.4477 14 13 14C13.5523 14 14 14.4477 14 15Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M8 9C8 9.55229 7.55228 10 7 10C6.44772 10 6 9.55229 6 9C6 8.44772 6.44772 8 7 8C7.55228 8 8 8.44772 8 9Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M8 12C8 12.5523 7.55228 13 7 13C6.44772 13 6 12.5523 6 12C6 11.4477 6.44772 11 7 11C7.55228 11 8 11.4477 8 12Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M8 15C8 15.5523 7.55228 16 7 16C6.44772 16 6 15.5523 6 15C6 14.4477 6.44772 14 7 14C7.55228 14 8 14.4477 8 15Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$calendar = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "calendar-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 4.5H4C3.72386 4.5 3.5 4.72386 3.5 5V15C3.5 15.2761 3.72386 15.5 4 15.5H16C16.2761 15.5 16.5 15.2761 16.5 15V5C16.5 4.72386 16.2761 4.5 16 4.5ZM4 3C2.89543 3 2 3.89543 2 5V15C2 16.1046 2.89543 17 4 17H16C17.1046 17 18 16.1046 18 15V5C18 3.89543 17.1046 3 16 3H4Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 2C6.41421 2 6.75 2.33579 6.75 2.75V4.75C6.75 5.16421 6.41421 5.5 6 5.5C5.58579 5.5 5.25 5.16421 5.25 4.75V2.75C5.25 2.33579 5.58579 2 6 2Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14 2C14.4142 2 14.75 2.33579 14.75 2.75V4.75C14.75 5.16421 14.4142 5.5 14 5.5C13.5858 5.5 13.25 5.16421 13.25 4.75V2.75C13.25 2.33579 13.5858 2 14 2Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M5 8C5 7.44772 5.44772 7 6 7C6.55228 7 7 7.44772 7 8C7 8.55228 6.55228 9 6 9C5.44772 9 5 8.55228 5 8Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M5 12C5 11.4477 5.44772 11 6 11C6.55228 11 7 11.4477 7 12C7 12.5523 6.55228 13 6 13C5.44772 13 5 12.5523 5 12Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M9 8C9 7.44772 9.44772 7 10 7C10.5523 7 11 7.44772 11 8C11 8.55228 10.5523 9 10 9C9.44772 9 9 8.55228 9 8Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M9 12C9 11.4477 9.44772 11 10 11C10.5523 11 11 11.4477 11 12C11 12.5523 10.5523 13 10 13C9.44772 13 9 12.5523 9 12Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M13 8C13 7.44772 13.4477 7 14 7C14.5523 7 15 7.44772 15 8C15 8.55228 14.5523 9 14 9C13.4477 9 13 8.55228 13 8Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M13 12C13 11.4477 13.4477 11 14 11C14.5523 11 15 11.4477 15 12C15 12.5523 14.5523 13 14 13C13.4477 13 13 12.5523 13 12Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$calendar_check = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "calendar-check-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15 1.25C15.4142 1.25 15.75 1.58579 15.75 2V2.25H17C17.9665 2.25 18.75 3.0335 18.75 4V16C18.75 16.9665 17.9665 17.75 17 17.75H3C2.0335 17.75 1.25 16.9665 1.25 16V4C1.25 3.0335 2.0335 2.25 3 2.25H4.25V2C4.25 1.58579 4.58579 1.25 5 1.25C5.41421 1.25 5.75 1.58579 5.75 2V2.25H14.25V2C14.25 1.58579 14.5858 1.25 15 1.25ZM14.25 3.75H5.75V4C5.75 4.41421 5.41421 4.75 5 4.75C4.58579 4.75 4.25 4.41421 4.25 4V3.75H3C2.86193 3.75 2.75 3.86193 2.75 4V16C2.75 16.1381 2.86193 16.25 3 16.25H17C17.1381 16.25 17.25 16.1381 17.25 16V4C17.25 3.86193 17.1381 3.75 17 3.75H15.75V4C15.75 4.41421 15.4142 4.75 15 4.75C14.5858 4.75 14.25 4.41421 14.25 4V3.75ZM13.5777 7.54731C13.8706 7.8402 13.8706 8.31507 13.5777 8.60797L9.60797 12.5777C9.46732 12.7183 9.27655 12.7974 9.07764 12.7974C8.87872 12.7974 8.68796 12.7183 8.54731 12.5777L6.46967 10.5001C6.17678 10.2072 6.17678 9.73229 6.46967 9.4394C6.76256 9.1465 7.23744 9.1465 7.53033 9.4394L9.07764 10.9867L12.517 7.54731C12.8099 7.25441 13.2848 7.25441 13.5777 7.54731Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$calendar_hammer = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "calendar-hammer-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M10.8282 7.45711L13.6566 10.2855C14.0472 10.6761 14.0472 11.3092 13.6566 11.6997L12.9495 12.4069C12.559 12.7974 11.9258 12.7974 11.5353 12.4069L10.9142 11.7857L7.70726 14.9926C7.31673 15.3832 6.68357 15.3832 6.29304 14.9926C5.90252 14.6021 5.90252 13.9689 6.29304 13.5784L9.49996 10.3715L8.70688 9.57843C8.31636 9.1879 8.31636 8.55474 8.70688 8.16421L9.41399 7.45711C9.80451 7.06658 10.4377 7.06658 10.8282 7.45711Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.25 3H6.75V2.75C6.75 2.33579 6.41421 2 6 2C5.58579 2 5.25 2.33579 5.25 2.75V3H2C1.58579 3 1.25 3.33579 1.25 3.75V17.75C1.25 18.1642 1.58579 18.5 2 18.5H18C18.4142 18.5 18.75 18.1642 18.75 17.75V3.75C18.75 3.33579 18.4142 3 18 3H14.75V2.75C14.75 2.33579 14.4142 2 14 2C13.5858 2 13.25 2.33579 13.25 2.75V3ZM6.75 4.75V4.5H13.25V4.75C13.25 5.16421 13.5858 5.5 14 5.5C14.4142 5.5 14.75 5.16421 14.75 4.75V4.5H17.25V17H2.75V4.5H5.25V4.75C5.25 5.16421 5.58579 5.5 6 5.5C6.41421 5.5 6.75 5.16421 6.75 4.75Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$camera = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "camera-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.21967 3.21967C7.36032 3.07902 7.55109 3 7.75 3H11.75C11.9489 3 12.1397 3.07902 12.2803 3.21967L13.0607 4H14.75C16.2688 4 17.5 5.23122 17.5 6.75V14.75C17.5 16.2688 16.2688 17.5 14.75 17.5H4.75C3.23122 17.5 2 16.2688 2 14.75V6.75C2 5.23122 3.23122 4 4.75 4H6.43934L7.21967 3.21967ZM8.06066 4.5L7.28033 5.28033C7.13968 5.42098 6.94891 5.5 6.75 5.5H4.75C4.05964 5.5 3.5 6.05964 3.5 6.75V14.75C3.5 15.4404 4.05964 16 4.75 16H14.75C15.4404 16 16 15.4404 16 14.75V6.75C16 6.05964 15.4404 5.5 14.75 5.5H12.75C12.5511 5.5 12.3603 5.42098 12.2197 5.28033L11.4393 4.5H8.06066Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.75 8.5C8.50736 8.5 7.5 9.50736 7.5 10.75C7.5 11.9926 8.50736 13 9.75 13C10.9926 13 12 11.9926 12 10.75C12 9.50736 10.9926 8.5 9.75 8.5ZM6 10.75C6 8.67893 7.67893 7 9.75 7C11.8211 7 13.5 8.67893 13.5 10.75C13.5 12.8211 11.8211 14.5 9.75 14.5C7.67893 14.5 6 12.8211 6 10.75Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M15.25 7C15.25 7.41421 14.9142 7.75 14.5 7.75C14.0858 7.75 13.75 7.41421 13.75 7C13.75 6.58579 14.0858 6.25 14.5 6.25C14.9142 6.25 15.25 6.58579 15.25 7Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$camera_video = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "camera-video-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14 7.95794V6C14 4.89543 13.1046 4 12 4H3C1.89543 4 1 4.89543 1 6V14C1 15.1046 1.89543 16 3 16H12C13.1046 16 14 15.1046 14 14V12.0421L16.7322 14.5659C17.1699 14.9703 17.8054 15.0772 18.3514 14.8383C18.8973 14.5994 19.25 14.06 19.25 13.4641V6.5359C19.25 5.94 18.8973 5.40062 18.3514 5.16172C17.8054 4.92282 17.1699 5.02972 16.7322 5.43407L14 7.95794ZM3 5.5H12C12.2761 5.5 12.5 5.72386 12.5 6V14C12.5 14.2761 12.2761 14.5 12 14.5H3C2.72386 14.5 2.5 14.2761 2.5 14V6C2.5 5.72386 2.72386 5.5 3 5.5ZM14 10L17.75 13.4641V6.5359L14 10Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$car = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "car-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.46928 2.25C4.10544 2.25 2.10131 3.98816 1.76702 6.32825L1.25763 9.89393C1.24841 9.9585 1.2477 10.0223 1.25466 10.0843C1.25157 10.1324 1.25 10.1809 1.25 10.2297V13C1.25 13.4761 1.33872 13.9314 1.50052 14.3504C1.50017 14.357 1.5 14.3635 1.5 14.3702V18C1.5 18.5523 1.94772 19 2.5 19H3.5C4.05228 19 4.5 18.5523 4.5 18V16.717C4.66357 16.7388 4.83047 16.75 5 16.75H15C15.1695 16.75 15.3364 16.7388 15.5 16.717V18C15.5 18.5523 15.9477 19 16.5 19H17.5C18.0523 19 18.5 18.5523 18.5 18V14.3702C18.5 14.3662 18.4999 14.3623 18.4998 14.3585C18.4997 14.3558 18.4996 14.3531 18.4995 14.3504C18.6613 13.9314 18.75 13.4761 18.75 13V10.2297C18.75 10.1813 18.7485 10.1331 18.7454 10.0853C18.7525 10.0231 18.7518 9.95888 18.7426 9.89393L18.2332 6.32825C17.8989 3.98817 15.8948 2.25 13.5309 2.25H6.46928ZM16.9607 8.02737L16.7483 6.54038C16.5195 4.93927 15.1483 3.75 13.5309 3.75H6.46928C4.85191 3.75 3.48067 4.93927 3.25194 6.54038L3.03952 8.02733L3.05874 8.0234L5.97904 7.43934C6.60863 7.31342 7.24912 7.25 7.89118 7.25H12.1088C12.7509 7.25 13.3914 7.31342 14.021 7.43934L16.9413 8.0234L16.9607 8.02737ZM7.89118 8.75C7.3479 8.75 6.80594 8.80366 6.27322 8.91021L3.35291 9.49427C3.00234 9.56438 2.75 9.8722 2.75 10.2297V11.0315C2.82991 11.0109 2.91368 11 3 11H5.5C6.32843 11 7 11.6716 7 12.5C7 12.7761 6.77614 13 6.5 13H2.75C2.75 14.2426 3.75736 15.25 5 15.25H15C16.2426 15.25 17.25 14.2426 17.25 13H13.5C13.2239 13 13 12.7761 13 12.5C13 11.6716 13.6716 11 14.5 11H17C17.0863 11 17.1701 11.0109 17.25 11.0315V10.2297C17.25 9.8722 16.9977 9.56438 16.6471 9.49427L13.7268 8.91021C13.1941 8.80366 12.6521 8.75 12.1088 8.75H7.89118Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$cards = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "cards-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.5 4C10.5 3.17157 11.1716 2.5 12 2.5H16C16.8284 2.5 17.5 3.17157 17.5 4V8C17.5 8.82843 16.8284 9.5 16 9.5H12C11.1716 9.5 10.5 8.82843 10.5 8V4ZM2.5 4C2.5 3.17157 3.17157 2.5 4 2.5H8C8.82843 2.5 9.5 3.17157 9.5 4V8C9.5 8.82843 8.82843 9.5 8 9.5H4C3.17157 9.5 2.5 8.82843 2.5 8V4ZM10.5 12C10.5 11.1716 11.1716 10.5 12 10.5H16C16.8284 10.5 17.5 11.1716 17.5 12V16C17.5 16.8284 16.8284 17.5 16 17.5H12C11.1716 17.5 10.5 16.8284 10.5 16V12ZM2.5 12C2.5 11.1716 3.17157 10.5 4 10.5H8C8.82843 10.5 9.5 11.1716 9.5 12V16C9.5 16.8284 8.82843 17.5 8 17.5H4C3.17157 17.5 2.5 16.8284 2.5 16V12ZM4 4V8H8V4H4ZM12 4V8H16V4H12ZM16 12V16H12V12H16ZM4 12V16H8V12H4Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$caret_down = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "caret-down-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M9.31235 13.1874C9.71139 13.6522 10.4307 13.6522 10.8298 13.1874L14.7243 8.65143C15.2811 8.00292 14.8203 7.00001 13.9655 7.00001L6.17659 7.00001C5.32185 7.00001 4.86108 8.00292 5.41787 8.65143L9.31235 13.1874Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$caret_left = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "caret-left-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M6.81262 9.17021C6.34784 9.56926 6.34784 10.2886 6.81262 10.6876L11.3486 14.5821C11.9971 15.1389 13 14.6782 13 13.8234L13 6.03446C13 5.17971 11.9971 4.71894 11.3486 5.27574L6.81262 9.17021Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$caret_right = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "caret-right-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M13.1874 10.8298C13.6522 10.4307 13.6522 9.7114 13.1874 9.31235L8.65142 5.41787C8.00291 4.86108 7 5.32185 7 6.17659L7 13.9655C7 14.8203 8.00291 15.2811 8.65142 14.7243L13.1874 10.8298Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$caret_up = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "caret-up-outline", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M10.8298 6.88369C10.4307 6.41892 9.7114 6.41892 9.31235 6.88369L5.41787 11.4196C4.86108 12.0682 5.32185 13.0711 6.17659 13.0711L13.9655 13.0711C14.8203 13.0711 15.2811 12.0682 14.7243 11.4197L10.8298 6.88369Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$category = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "category-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M11 12C11 11.4477 11.4477 11 12 11H15C15.5523 11 16 11.4477 16 12V15C16 15.5523 15.5523 16 15 16H12C11.4477 16 11 15.5523 11 15V12Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.5 12.5V14.5H14.5V12.5H12.5ZM12 11C11.4477 11 11 11.4477 11 12V15C11 15.5523 11.4477 16 12 16H15C15.5523 16 16 15.5523 16 15V12C16 11.4477 15.5523 11 15 11H12Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.5 5.5V7.5H14.5V5.5H12.5ZM12 4C11.4477 4 11 4.44772 11 5V8C11 8.55228 11.4477 9 12 9H15C15.5523 9 16 8.55228 16 8V5C16 4.44772 15.5523 4 15 4H12Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.5 12.5V14.5H7.5V12.5H5.5ZM5 11C4.44772 11 4 11.4477 4 12V15C4 15.5523 4.44772 16 5 16H8C8.55228 16 9 15.5523 9 15V12C9 11.4477 8.55228 11 8 11H5Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.5 5.5V7.5H7.5V5.5H5.5ZM5 4C4.44772 4 4 4.44772 4 5V8C4 8.55228 4.44772 9 5 9H8C8.55228 9 9 8.55228 9 8V5C9 4.44772 8.55228 4 8 4H5Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$chart_dollar = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "chart-dollar-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M10.4082 13.7251V13.043C12.0894 12.9033 13.04 12.0547 13.04 10.6851C13.04 9.5249 12.3633 8.81055 10.9829 8.51514L10.4082 8.39697V6.48486C10.9722 6.56543 11.375 6.96826 11.3911 7.45703H12.8896C12.8682 6.21631 11.9014 5.34082 10.4082 5.20117V4.4707H9.65625V5.20117C8.05566 5.33008 7.11035 6.17871 7.11035 7.5C7.11035 8.62256 7.80322 9.36377 9.09229 9.66455L9.65625 9.79883V11.7969C8.98486 11.7271 8.52832 11.3296 8.49072 10.7979H6.95459C6.95996 12.1084 7.9751 12.957 9.65625 13.0537V13.7251H10.4082ZM11.5146 10.8677C11.5146 11.4102 11.1064 11.7593 10.4082 11.8022V9.93311C11.1602 10.0728 11.5146 10.3735 11.5146 10.8677ZM8.66797 7.34961C8.66797 6.87158 9.07617 6.51172 9.65625 6.47949V8.24121C9.00635 8.1123 8.66797 7.80078 8.66797 7.34961Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.75 4C4.16421 4 4.5 4.33579 4.5 4.75L4.5 16.25C4.5 16.6642 4.16421 17 3.75 17C3.33579 17 3 16.6642 3 16.25L3 4.75C3 4.33579 3.33579 4 3.75 4Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 16.25C3 15.8358 3.33579 15.5 3.75 15.5H15.25C15.6642 15.5 16 15.8358 16 16.25C16 16.6642 15.6642 17 15.25 17H3.75C3.33579 17 3 16.6642 3 16.25Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$chart_pie = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "chart-pie-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9 4.74998C5.54822 4.74998 2.75 7.5482 2.75 11C2.75 14.4518 5.54822 17.25 9 17.25C12.4518 17.25 15.25 14.4518 15.25 11H16.75C16.75 15.2802 13.2802 18.75 9 18.75C4.71979 18.75 1.25 15.2802 1.25 11C1.25 6.71977 4.71979 3.24998 9 3.24998V4.74998Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 2.24997C10 1.83575 10.3358 1.49997 10.75 1.49997C15.0302 1.49997 18.5 4.96976 18.5 9.24997C18.5 9.66418 18.1642 9.99997 17.75 9.99997H10.75C10.5511 9.99997 10.3603 9.92095 10.2197 9.7803C10.079 9.63965 10 9.44888 10 9.24997L10 2.24997Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$chart_pyramid = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "chart-pyramid-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 2C10.2801 2 10.5369 2.15609 10.6658 2.40476L13.1782 7.25H16.25C16.6642 7.25 17 7.58579 17 8C17 8.41421 16.6642 8.75 16.25 8.75H13.9559L17.6658 15.9048C17.7864 16.1373 17.7769 16.4158 17.6409 16.6396C17.5048 16.8634 17.2619 17 17 17H3C2.7381 17 2.49518 16.8634 2.35913 16.6396C2.22309 16.4158 2.21363 16.1373 2.33418 15.9048L6.04406 8.75H3.75C3.33579 8.75 3 8.41421 3 8C3 7.58579 3.33579 7.25 3.75 7.25H6.82184L9.33418 2.40476C9.46312 2.15609 9.71989 2 10 2ZM7.73372 8.75L4.23372 15.5H15.7663L12.2663 8.75H7.73372ZM11.4885 7.25H8.5115L10 4.37931L11.4885 7.25Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$checkmark = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "checkmark-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.9962 4.93762C16.3068 5.21167 16.3364 5.68562 16.0624 5.99621L8.56238 14.4962C8.4254 14.6515 8.23034 14.7432 8.0234 14.7496C7.81647 14.7561 7.61607 14.6767 7.46967 14.5303L3.96967 11.0303C3.67678 10.7374 3.67678 10.2626 3.96967 9.96966C4.26256 9.67677 4.73744 9.67677 5.03033 9.96966L7.96582 12.9052L14.9376 5.00378C15.2117 4.69318 15.6856 4.66356 15.9962 4.93762Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$chevron_down = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "chevron-down-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.5303 6.93336C16.2374 6.64047 15.7626 6.64047 15.4697 6.93336L10 12.403L4.53033 6.93336C4.23744 6.64047 3.76256 6.64047 3.46967 6.93336C3.17678 7.22626 3.17678 7.70113 3.46967 7.99402L10 14.5244L16.5303 7.99402C16.8232 7.70113 16.8232 7.22626 16.5303 6.93336Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$chevron_left = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "chevron-left-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "21",
        viewBox: "0 0 20 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.6857 4.08869C13.9785 4.38158 13.9785 4.85646 13.6857 5.14935L8.21599 10.619L13.6857 16.0887C13.9785 16.3816 13.9785 16.8565 13.6857 17.1493C13.3928 17.4422 12.9179 17.4422 12.625 17.1493L6.09467 10.619L12.625 4.08869C12.9179 3.7958 13.3928 3.7958 13.6857 4.08869Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$chevron_long_down = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "chevron-long-down-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.99999 13.6743L1.63229 8.96749C1.27128 8.76441 1.14324 8.30713 1.34631 7.94611C1.54938 7.58509 2.00667 7.45705 2.36769 7.66012L9.99999 11.9533L17.6323 7.66012C17.9933 7.45705 18.4506 7.58509 18.6537 7.94611C18.8567 8.30713 18.7287 8.76441 18.3677 8.96749L9.99999 13.6743Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$chevron_long_up = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "chevron-long-up-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 7.56372L18.3677 12.2705C18.7287 12.4736 18.8568 12.9309 18.6537 13.2919C18.4506 13.6529 17.9933 13.781 17.6323 13.5779L10 9.28474L2.36771 13.5779C2.00669 13.781 1.5494 13.6529 1.34633 13.2919C1.14326 12.9309 1.2713 12.4736 1.63232 12.2705L10 7.56372Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$chevron_right = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "chevron-right-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.31434 4.08869C6.02145 4.38158 6.02145 4.85646 6.31434 5.14935L11.784 10.619L6.31434 16.0887C6.02145 16.3816 6.02145 16.8565 6.31434 17.1493C6.60724 17.4422 7.08211 17.4422 7.375 17.1493L13.9053 10.619L7.375 4.08869C7.08211 3.7958 6.60724 3.7958 6.31434 4.08869Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$chevron_small_down = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "chevron-small-down-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.46967 8.08869C5.76256 7.7958 6.23744 7.7958 6.53033 8.08869L10 11.5584L13.4697 8.08869C13.7626 7.7958 14.2374 7.7958 14.5303 8.08869C14.8232 8.38158 14.8232 8.85646 14.5303 9.14935L10.5303 13.1493C10.3897 13.29 10.1989 13.369 10 13.369C9.80109 13.369 9.61032 13.29 9.46967 13.1493L5.46967 9.14935C5.17678 8.85646 5.17678 8.38158 5.46967 8.08869Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$chevron_small_left = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "chevron-small-left-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.5303 6.08869C12.8232 6.38158 12.8232 6.85646 12.5303 7.14935L9.06066 10.619L12.5303 14.0887C12.8232 14.3816 12.8232 14.8565 12.5303 15.1493C12.2374 15.4422 11.7626 15.4422 11.4697 15.1493L7.46967 11.1493C7.32902 11.0087 7.25 10.8179 7.25 10.619C7.25 10.4201 7.32902 10.2293 7.46967 10.0887L11.4697 6.08869C11.7626 5.7958 12.2374 5.7958 12.5303 6.08869Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$chevron_small_right = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "chevron-small-right-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.46967 15.1494C7.17678 14.8565 7.17678 14.3816 7.46967 14.0887L10.9393 10.6191L7.46967 7.14941C7.17678 6.85652 7.17678 6.38164 7.46967 6.08875C7.76256 5.79586 8.23744 5.79586 8.53033 6.08875L12.5303 10.0887C12.671 10.2294 12.75 10.4202 12.75 10.6191C12.75 10.818 12.671 11.0088 12.5303 11.1494L8.53033 15.1494C8.23744 15.4423 7.76256 15.4423 7.46967 15.1494Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$chevron_small_up = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "chevron-small-up-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.5303 13.1493C14.2374 13.4422 13.7626 13.4422 13.4697 13.1493L10 9.67968L6.53033 13.1493C6.23744 13.4422 5.76256 13.4422 5.46967 13.1493C5.17678 12.8565 5.17678 12.3816 5.46967 12.0887L9.46967 8.08869C9.61032 7.94804 9.80109 7.86902 10 7.86902C10.1989 7.86902 10.3897 7.94804 10.5303 8.08869L14.5303 12.0887C14.8232 12.3816 14.8232 12.8565 14.5303 13.1493Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$chevron_up = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "chevron-up-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.46967 14.3047C3.76256 14.5976 4.23744 14.5976 4.53033 14.3047L10 8.835L15.4697 14.3047C15.7626 14.5976 16.2374 14.5976 16.5303 14.3047C16.8232 14.0118 16.8232 13.5369 16.5303 13.244L10 6.71368L3.46967 13.244C3.17678 13.5369 3.17678 14.0118 3.46967 14.3047Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$circle_checkmark = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "circle-checkmark-solid", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 17.1191C13.5899 17.1191 16.5 14.2089 16.5 10.6191C16.5 7.02923 13.5898 4.11908 10 4.11908C6.41015 4.11908 3.5 7.02923 3.5 10.6191C3.5 14.2089 6.41015 17.1191 10 17.1191ZM10 18.6191C14.4183 18.6191 18 15.0374 18 10.6191C18 6.2008 14.4183 2.61908 10 2.61908C5.58172 2.61908 2 6.2008 2 10.6191C2 15.0374 5.58172 18.6191 10 18.6191Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M12.1875 7.909C12.5759 7.52198 13.2042 7.52251 13.5919 7.91018C13.98 8.29832 13.9801 8.92761 13.5919 9.31575L9.20125 13.7065C8.81106 14.0967 8.17842 14.0967 7.78823 13.7065C7.39757 13.3158 7.3981 12.6823 7.78942 12.2923L12.1875 7.909Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M6.28901 12.162C5.90275 11.7732 5.9038 11.1452 6.29134 10.7577C6.67979 10.3692 7.30959 10.3692 7.69805 10.7576L9.23799 12.2975C9.62788 12.6874 9.62788 13.3195 9.23801 13.7094C8.84722 14.1002 8.2133 14.0991 7.82381 13.7071L6.28901 12.162Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$circle_info = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "circle-info-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 3.75C6.54822 3.75 3.75 6.54822 3.75 10C3.75 13.4518 6.54822 16.25 10 16.25C13.4518 16.25 16.25 13.4518 16.25 10C16.25 6.54822 13.4518 3.75 10 3.75ZM2.25 10C2.25 5.71979 5.71979 2.25 10 2.25C14.2802 2.25 17.75 5.71979 17.75 10C17.75 14.2802 14.2802 17.75 10 17.75C5.71979 17.75 2.25 14.2802 2.25 10Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M10 6.73535C10.5332 6.73535 10.9502 6.3252 10.9502 5.8125C10.9502 5.29297 10.5332 4.88965 10 4.88965C9.47363 4.88965 9.05664 5.29297 9.05664 5.8125C9.05664 6.3252 9.47363 6.73535 10 6.73535ZM10 15.1367C10.5195 15.1367 10.8545 14.7949 10.8545 14.2412V8.5127C10.8545 7.95898 10.5195 7.61035 10 7.61035C9.48047 7.61035 9.15234 7.95898 9.15234 8.50586V14.2412C9.15234 14.7949 9.48047 15.1367 10 15.1367Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$circle_question = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "circle-question-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 3.75C6.54822 3.75 3.75 6.54822 3.75 10C3.75 13.4518 6.54822 16.25 10 16.25C13.4518 16.25 16.25 13.4518 16.25 10C16.25 6.54822 13.4518 3.75 10 3.75ZM2.25 10C2.25 5.71979 5.71979 2.25 10 2.25C14.2802 2.25 17.75 5.71979 17.75 10C17.75 14.2802 14.2802 17.75 10 17.75C5.71979 17.75 2.25 14.2802 2.25 10Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M9.68555 12.1699C10.1504 12.1699 10.3828 11.8896 10.4512 11.4385C10.5059 10.8164 10.7246 10.4883 11.6201 9.96875C12.5498 9.41504 13.0693 8.69727 13.0693 7.65137C13.0693 6.10645 11.7979 5.05371 9.94531 5.05371C8.53711 5.05371 7.4707 5.62793 7.04688 6.55762C6.91699 6.81738 6.85547 7.07031 6.85547 7.36426C6.85547 7.82227 7.13574 8.10938 7.60742 8.10938C7.9834 8.10938 8.23633 7.93848 8.38672 7.51465C8.60547 6.82422 9.11133 6.44824 9.87012 6.44824C10.7109 6.44824 11.292 6.96777 11.292 7.71289C11.292 8.36914 11.0049 8.74512 10.1572 9.25781C9.30273 9.76367 8.87891 10.3242 8.87891 11.1719V11.3018C8.87891 11.8008 9.16602 12.1699 9.68555 12.1699ZM9.69922 15.1367C10.2529 15.1367 10.6904 14.7061 10.6904 14.166C10.6904 13.626 10.2529 13.2021 9.69922 13.2021C9.14551 13.2021 8.70117 13.626 8.70117 14.166C8.70117 14.7061 9.14551 15.1367 9.69922 15.1367Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$clicks = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "clicks-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M10 3.86908C6.27208 3.86908 3.25 6.89116 3.25 10.6191C3.25 14.347 6.27208 17.3691 10 17.3691C10.2327 17.3691 10.4626 17.3573 10.6892 17.3343L10.3113 15.86C10.2083 15.866 10.1045 15.8691 10 15.8691C7.10051 15.8691 4.75 13.5186 4.75 10.6191C4.75 7.71958 7.10051 5.36908 10 5.36908C12.8995 5.36908 15.25 7.71958 15.25 10.6191C15.25 11.2035 15.1545 11.7656 14.9783 12.2907L16.3025 13.041C16.5916 12.2893 16.75 11.4727 16.75 10.6191C16.75 6.89116 13.7279 3.86908 10 3.86908Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M12.0407 18.5792L10 10.6191L11.9579 11.7285L13.2632 12.4682L14.5684 13.2078L15.8737 13.9474L17 14.5857L14.3955 15.5397L14.4877 15.6613L16.2252 17.9535L15.3986 18.6191L13.569 16.2053L12.0407 18.5792Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M13.6383 11.5313C13.7113 11.2393 13.75 10.9337 13.75 10.6191C13.75 8.54801 12.0711 6.86908 10 6.86908C7.92893 6.86908 6.25 8.54801 6.25 10.6191C6.25 12.6664 7.89063 14.3305 9.92888 14.3684L9.532 12.8203C8.51398 12.605 7.75 11.7012 7.75 10.6191C7.75 9.37644 8.75736 8.36908 10 8.36908C11.2426 8.36908 12.25 9.37644 12.25 10.6191C12.25 10.6606 12.2489 10.7018 12.2467 10.7428L13.6383 11.5313Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$clock = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "clock-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.75 4.36902C6.29822 4.36902 3.5 7.16724 3.5 10.619C3.5 14.0708 6.29822 16.869 9.75 16.869C13.2018 16.869 16 14.0708 16 10.619C16 7.16724 13.2018 4.36902 9.75 4.36902ZM2 10.619C2 6.33881 5.46979 2.86902 9.75 2.86902C14.0302 2.86902 17.5 6.33881 17.5 10.619C17.5 14.8992 14.0302 18.369 9.75 18.369C5.46979 18.369 2 14.8992 2 10.619ZM9.75 5.86902C10.1642 5.86902 10.5 6.2048 10.5 6.61902V10.2586L12.7185 12.0334C13.042 12.2921 13.0944 12.7641 12.8357 13.0875C12.5769 13.411 12.1049 13.4634 11.7815 13.2047L9.28148 11.2047C9.10357 11.0623 9 10.8469 9 10.619V6.61902C9 6.2048 9.33579 5.86902 9.75 5.86902Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$cog = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "cog-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.83593 2.90458C8.11426 2.83329 8.40926 2.87001 8.66162 3.00736C8.9125 3.14391 9.10274 3.36986 9.19461 3.64019C9.25281 3.8072 9.36145 3.95204 9.50552 4.05468C9.6502 4.15775 9.82341 4.21314 10.001 4.21314C10.1787 4.21314 10.3519 4.15775 10.4965 4.05468C10.6404 3.95219 10.7489 3.80763 10.8072 3.64092C10.8984 3.37089 11.0879 3.14496 11.3381 3.00818C11.5904 2.87028 11.8856 2.83325 12.1641 2.90456L12.1735 2.90697L12.1828 2.90963C12.795 3.0834 13.3842 3.32983 13.9379 3.64366L13.9456 3.64803L13.9532 3.65259C14.1879 3.79308 14.364 4.01362 14.4491 4.27363C14.5332 4.53085 14.5226 4.80957 14.4194 5.05955C14.3483 5.23856 14.3371 5.43581 14.3876 5.62176C14.4267 5.76495 14.5027 5.8954 14.6078 6.00013C14.7121 6.10392 14.8415 6.17886 14.9833 6.21765C15.194 6.27066 15.3844 6.25021 15.5443 6.18548C15.7948 6.08033 16.0747 6.06851 16.3332 6.15236C16.5945 6.23709 16.8161 6.41374 16.9569 6.64951L16.9609 6.65616L16.9647 6.6629C17.2827 7.22111 17.5319 7.81581 17.7067 8.43398L17.7093 8.44328L17.7117 8.45265C17.7829 8.73145 17.7456 9.02686 17.6074 9.27922C17.4704 9.52941 17.2443 9.71882 16.9742 9.80996C16.8074 9.86835 16.6627 9.97702 16.5602 10.1211C16.457 10.2659 16.4016 10.4394 16.4017 10.6172C16.4017 10.7951 16.4573 10.9685 16.5605 11.1133C16.6631 11.2572 16.8077 11.3657 16.9745 11.424C17.2482 11.5163 17.4718 11.7079 17.607 11.9552C17.7449 12.2075 17.7819 12.5027 17.7106 12.7812L17.7081 12.7908L17.7054 12.8004C17.5465 13.3588 17.329 13.892 17.0597 14.3932L17.055 14.4018L17.0502 14.4102C16.9064 14.6618 16.6718 14.8489 16.3944 14.9329C16.1207 15.0158 15.8259 14.9922 15.569 14.867C15.3336 14.7573 15.0054 14.7314 14.5984 15.0012L14.184 14.3761L14.6012 14.9994C14.5871 15.0088 14.575 15.0208 14.5654 15.0347C14.2893 15.4564 14.3258 15.7932 14.4493 16.0331C14.5852 16.2853 14.6203 16.58 14.5472 16.8573C14.4729 17.1387 14.293 17.3806 14.0448 17.5327L14.0376 17.5371L14.0303 17.5413C13.4488 17.8798 12.8267 18.1432 12.1789 18.3252C11.566 18.498 10.9916 18.1253 10.8086 17.5982L10.8072 17.5943L10.8072 17.5943C10.6905 17.2524 10.3723 17.0125 9.9999 17.0121C9.82166 17.0126 9.64802 17.0688 9.50326 17.1728C9.35912 17.2763 9.2508 17.4222 9.1933 17.5901C9.10332 17.8618 8.91359 18.0895 8.66227 18.2269C8.40894 18.3654 8.11221 18.4018 7.8329 18.3286L7.82057 18.3254L7.8206 18.3253C7.16443 18.1413 6.53465 17.8738 5.94675 17.5292L5.93884 17.5245L5.93105 17.5197C5.68542 17.3675 5.50735 17.1271 5.43338 16.8478C5.36038 16.5721 5.39423 16.2792 5.52787 16.0277C5.64865 15.7905 5.68427 15.4534 5.40834 15.0327C5.39915 15.0195 5.38761 15.008 5.37427 14.999C4.96872 14.7325 4.64211 14.7576 4.40907 14.8647L4.40751 14.8654C3.90671 15.094 3.23764 14.9495 2.93309 14.3816L2.93219 14.3799C2.66603 13.8806 2.44862 13.3491 2.29052 12.7918L2.28788 12.7825L2.28548 12.7732C2.21456 12.4962 2.25077 12.2027 2.38685 11.9513C2.52152 11.7025 2.74418 11.5131 3.01108 11.42C3.17527 11.3602 3.31722 11.2515 3.41778 11.1085C3.51907 10.9645 3.57344 10.7927 3.57344 10.6166C3.57344 10.4405 3.51907 10.2688 3.41778 10.1247C3.317 9.98146 3.17465 9.8726 3.01001 9.81288C2.74346 9.71908 2.52135 9.52926 2.38718 9.28039C2.252 9.02965 2.21595 8.73727 2.28619 8.4612L2.28855 8.45192L2.29115 8.44271C2.46531 7.82464 2.71372 7.22994 3.03094 6.67162L3.03488 6.66469L3.03896 6.65785C3.1789 6.4233 3.39873 6.24707 3.65812 6.16151C3.91493 6.0768 4.19346 6.08659 4.44356 6.18895C4.59976 6.25064 4.77062 6.2653 4.93509 6.23111C5.1007 6.19667 5.25249 6.11422 5.37153 5.99405C5.49056 5.87387 5.57156 5.7213 5.60442 5.55537C5.63727 5.38944 5.62052 5.21751 5.55626 5.06105L5.55495 5.05786L5.55496 5.05785C5.45324 4.80688 5.44519 4.52769 5.53231 4.27127C5.61942 4.01486 5.79588 3.79835 6.02944 3.66128L6.03732 3.65666L6.03735 3.6567C6.59126 3.34066 7.18781 3.0863 7.81934 2.90903L7.82761 2.90671L7.83593 2.90458ZM7.91456 4.44906C7.61647 4.54972 7.32782 4.67214 7.04996 4.81406C7.13437 5.1508 7.14382 5.50344 7.07585 5.84672C6.98576 6.30172 6.76364 6.7201 6.43723 7.04964C6.11082 7.37918 5.69457 7.60527 5.24045 7.6997C4.89241 7.77206 4.53395 7.76463 4.19157 7.67974C4.05053 7.95762 3.92982 8.24535 3.83038 8.54066C4.15298 8.71346 4.43234 8.95988 4.6447 9.2618C4.9237 9.65849 5.07344 10.1316 5.07344 10.6166C5.07344 11.1016 4.9237 11.5748 4.6447 11.9714C4.4323 12.2734 4.15287 12.5199 3.8302 12.6927C3.90998 12.9277 4.00304 13.1572 4.10827 13.3803C4.761 13.1908 5.50152 13.2864 6.20175 13.7479L6.20472 13.7499C6.38257 13.8683 6.53542 14.0205 6.65458 14.1979L6.65819 14.2032L6.65816 14.2032C7.14531 14.942 7.22448 15.7228 6.99639 16.3958C7.29081 16.5485 7.59658 16.6784 7.91098 16.7841C8.08064 16.4565 8.32572 16.1718 8.62799 15.9546C9.02715 15.6678 9.50605 15.5131 9.99757 15.5121L9.99904 15.5121C10.9134 15.5121 11.6967 16.0319 12.0875 16.7841C12.3946 16.6806 12.6935 16.5543 12.9817 16.406C12.75 15.732 12.826 14.9494 13.3145 14.2069L13.3177 14.202L13.3177 14.202C13.4366 14.0243 13.5892 13.8717 13.7669 13.7528L13.7696 13.751L13.7696 13.751C14.4794 13.2805 15.2299 13.1888 15.8878 13.3872C15.9925 13.166 16.0851 12.9378 16.1648 12.7035C15.8383 12.5327 15.555 12.2868 15.3392 11.9841C15.0548 11.5852 14.9018 11.1076 14.9017 10.6177C14.9015 10.1279 15.0541 9.65011 15.3383 9.25105C15.5545 8.94735 15.8387 8.70072 16.1663 8.52961C16.067 8.23635 15.9467 7.95061 15.8064 7.67462C15.4287 7.77097 15.0194 7.7753 14.607 7.66968L14.5987 7.66757L14.5987 7.66752C14.2022 7.56116 13.8405 7.35278 13.5495 7.06314C13.2586 6.77349 13.0486 6.41268 12.9405 6.01664L12.9403 6.01596C12.8321 5.61801 12.8291 5.20069 12.929 4.80427C12.6569 4.6666 12.3755 4.54832 12.0869 4.4503C11.9159 4.77701 11.6699 5.06053 11.3669 5.27637C10.9681 5.56046 10.4907 5.71314 10.001 5.71314C9.51141 5.71314 9.03396 5.56046 8.63518 5.27637C8.33184 5.06026 8.08549 4.77629 7.91456 4.44906ZM10 8.36902C8.75736 8.36902 7.75 9.37638 7.75 10.619C7.75 11.8617 8.75736 12.869 10 12.869C11.2426 12.869 12.25 11.8617 12.25 10.619C12.25 9.37638 11.2426 8.36902 10 8.36902ZM6.25 10.619C6.25 8.54795 7.92893 6.86902 10 6.86902C12.0711 6.86902 13.75 8.54795 13.75 10.619C13.75 12.6901 12.0711 14.369 10 14.369C7.92893 14.369 6.25 12.6901 6.25 10.619Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$cog_notification = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "cog-notification-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.4266 10.4121C15.9741 10.5467 15.4947 10.619 14.9985 10.619C14.9662 10.619 14.9339 10.6187 14.9017 10.6181C14.9019 11.1078 15.0548 11.5853 15.3392 11.9841C15.555 12.2868 15.8383 12.5327 16.1648 12.7035C16.0851 12.9378 15.9925 13.166 15.8878 13.3872C15.2299 13.1888 14.4794 13.2805 13.7696 13.751L13.7669 13.7528C13.5892 13.8717 13.4366 14.0243 13.3177 14.202L13.3145 14.2069C12.826 14.9494 12.75 15.732 12.9817 16.406C12.6935 16.5543 12.3946 16.6806 12.0875 16.7841C11.6967 16.0319 10.9134 15.5121 9.99904 15.5121L9.99757 15.5121C9.50605 15.5131 9.02715 15.6678 8.62799 15.9546C8.32572 16.1718 8.08064 16.4565 7.91098 16.7841C7.59658 16.6784 7.29081 16.5485 6.99639 16.3958C7.22448 15.7228 7.14531 14.942 6.65816 14.2032L6.65458 14.1979C6.53542 14.0205 6.38257 13.8683 6.20472 13.7499L6.20175 13.7479C5.50152 13.2864 4.761 13.1908 4.10827 13.3803C4.00304 13.1572 3.90998 12.9277 3.8302 12.6927C4.15287 12.5199 4.4323 12.2734 4.6447 11.9714C4.9237 11.5748 5.07344 11.1016 5.07344 10.6166C5.07344 10.1316 4.9237 9.65849 4.6447 9.2618C4.43234 8.95988 4.15298 8.71346 3.83038 8.54066C3.92982 8.24535 4.05053 7.95762 4.19157 7.67974C4.53395 7.76463 4.89241 7.77206 5.24045 7.6997C5.69457 7.60527 6.11082 7.37918 6.43723 7.04964C6.76364 6.7201 6.98576 6.30172 7.07585 5.84672C7.14382 5.50344 7.13437 5.1508 7.04996 4.81406C7.32782 4.67214 7.61647 4.54972 7.91456 4.44906C8.08549 4.77629 8.33184 5.06026 8.63518 5.27637C9.03351 5.56014 9.51032 5.71279 9.99937 5.71314C9.9988 5.68183 9.99851 5.65046 9.99851 5.61902C9.99851 5.12176 10.0711 4.64145 10.2063 4.18811C10.1395 4.20464 10.0706 4.21314 10.001 4.21314C9.82341 4.21314 9.6502 4.15775 9.50552 4.05468C9.36145 3.95204 9.25281 3.8072 9.19461 3.64019C9.10274 3.36986 8.9125 3.14391 8.66162 3.00736C8.40926 2.87001 8.11426 2.83329 7.83593 2.90458L7.82761 2.90671L7.81934 2.90903C7.18781 3.0863 6.59126 3.34066 6.03735 3.6567L6.02944 3.66128C5.79588 3.79835 5.61942 4.01486 5.53231 4.27127C5.44519 4.52769 5.45324 4.80688 5.55496 5.05785L5.55626 5.06105C5.62052 5.21751 5.63727 5.38944 5.60442 5.55537C5.57156 5.7213 5.49056 5.87387 5.37153 5.99405C5.25249 6.11422 5.1007 6.19667 4.93509 6.23111C4.77062 6.2653 4.59976 6.25064 4.44356 6.18895C4.19346 6.08659 3.91493 6.0768 3.65812 6.16151C3.39873 6.24707 3.1789 6.4233 3.03896 6.65785L3.03488 6.66469L3.03094 6.67162C2.71372 7.22994 2.46531 7.82464 2.29115 8.44271L2.28855 8.45192L2.28619 8.4612C2.21595 8.73727 2.252 9.02965 2.38718 9.28039C2.52135 9.52926 2.74346 9.71908 3.01001 9.81288C3.17465 9.8726 3.317 9.98146 3.41778 10.1247C3.51907 10.2688 3.57344 10.4405 3.57344 10.6166C3.57344 10.7927 3.51907 10.9645 3.41778 11.1085C3.31722 11.2515 3.17527 11.3602 3.01108 11.42C2.74418 11.5131 2.52152 11.7025 2.38685 11.9513C2.25077 12.2027 2.21456 12.4962 2.28548 12.7732L2.28788 12.7825L2.29052 12.7918C2.44862 13.3491 2.66603 13.8806 2.93219 14.3799L2.93309 14.3816C3.23764 14.9495 3.90671 15.094 4.40751 14.8654L4.40907 14.8647C4.64211 14.7576 4.96872 14.7325 5.37427 14.999C5.38761 15.008 5.39915 15.0195 5.40834 15.0327C5.68427 15.4534 5.64865 15.7905 5.52787 16.0277C5.39423 16.2792 5.36038 16.5721 5.43338 16.8478C5.50735 17.1271 5.68542 17.3675 5.93105 17.5197L5.93884 17.5245L5.94675 17.5292C6.53465 17.8738 7.16443 18.1413 7.8206 18.3253L7.8329 18.3286C8.11221 18.4018 8.40894 18.3654 8.66227 18.2269C8.91359 18.0895 9.10332 17.8618 9.1933 17.5901C9.2508 17.4222 9.35912 17.2763 9.50326 17.1728C9.64802 17.0688 9.82166 17.0126 9.9999 17.0121C10.3723 17.0125 10.6905 17.2524 10.8072 17.5943L10.8086 17.5982C10.9916 18.1253 11.566 18.498 12.1789 18.3252C12.8267 18.1432 13.4488 17.8798 14.0303 17.5413L14.0376 17.5371L14.0448 17.5327C14.293 17.3806 14.4729 17.1387 14.5472 16.8573C14.6203 16.58 14.5852 16.2853 14.4493 16.0331C14.3258 15.7932 14.2893 15.4564 14.5654 15.0347C14.5748 15.0211 14.5866 15.0093 14.6003 15C15.0064 14.7315 15.334 14.7575 15.569 14.867C15.8259 14.9922 16.1207 15.0158 16.3944 14.9329C16.6718 14.8489 16.9064 14.6618 17.0502 14.4102L17.055 14.4018L17.0597 14.3932C17.329 13.892 17.5465 13.3588 17.7054 12.8004L17.7081 12.7908L17.7106 12.7812C17.7819 12.5027 17.7449 12.2075 17.607 11.9552C17.4718 11.7079 17.2482 11.5163 16.9745 11.424C16.8077 11.3657 16.6631 11.2572 16.5605 11.1133C16.4573 10.9685 16.4017 10.7951 16.4017 10.6172C16.4017 10.5477 16.4101 10.4788 16.4266 10.4121ZM14.6003 15C14.6006 14.9998 14.6009 14.9996 14.6012 14.9994L14.184 14.3761L14.5984 15.0012C14.599 15.0008 14.5997 15.0004 14.6003 15Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M13.7467 10.461C13.7489 10.5134 13.75 10.5661 13.75 10.619C13.75 12.6901 12.0711 14.369 10 14.369C7.92893 14.369 6.25 12.6901 6.25 10.619C6.25 8.54795 7.92893 6.86902 10 6.86902C10.0525 6.86902 10.1048 6.8701 10.1569 6.87224C10.3195 7.50224 10.6018 8.08412 10.9781 8.59217C10.6824 8.44918 10.3505 8.36902 10 8.36902C8.75736 8.36902 7.75 9.37638 7.75 10.619C7.75 11.8617 8.75736 12.869 10 12.869C11.2426 12.869 12.25 11.8617 12.25 10.619C12.25 10.2682 12.1697 9.93622 12.0266 9.6403C12.5347 10.0165 13.1167 10.2986 13.7467 10.461Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M18.9985 5.61902C18.9985 7.82816 17.2076 9.61902 14.9985 9.61902C12.7894 9.61902 10.9985 7.82816 10.9985 5.61902C10.9985 3.40988 12.7894 1.61902 14.9985 1.61902C17.2076 1.61902 18.9985 3.40988 18.9985 5.61902Z",
        fill: "#B91C1C"
    }));
};
const $e959f086e329e090$var$coin = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "coin-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 16.5C13.5899 16.5 16.5 13.5899 16.5 10C16.5 6.41015 13.5899 3.5 10 3.5C6.41015 3.5 3.5 6.41015 3.5 10C3.5 13.5899 6.41015 16.5 10 16.5ZM10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M9.72607 14.7627H10.3438V13.9033C11.8691 13.8013 12.9595 12.9849 12.9595 11.6367C12.9595 10.4604 12.1914 9.86963 10.7251 9.53662L10.3438 9.45605V7.56006C10.9453 7.646 11.3481 7.979 11.4233 8.55908H12.8574C12.8037 7.2915 11.8369 6.45361 10.3438 6.34619V5.4707H9.72607V6.34082C8.24902 6.43213 7.19092 7.26465 7.19092 8.54834C7.19092 9.7085 7.96436 10.3369 9.36621 10.6538L9.72607 10.7397V12.7002C8.99561 12.6196 8.60889 12.2383 8.52295 11.6904H7.0835C7.12109 13.0332 8.2168 13.8228 9.72607 13.9087V14.7627ZM8.69482 8.40869C8.69482 7.979 9.04932 7.62988 9.72607 7.54932V9.31104C9.00098 9.11768 8.69482 8.83838 8.69482 8.40869ZM11.4609 11.8032C11.4609 12.292 11.0903 12.625 10.3438 12.7002V10.8794C11.1763 11.0889 11.4609 11.3306 11.4609 11.8032Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$collections = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "collections-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.25 4C3.25 3.58579 3.58579 3.25 4 3.25H7.59999C8.0142 3.25 8.34999 3.58579 8.34999 4V7.59999C8.34999 8.0142 8.0142 8.34999 7.59999 8.34999H4C3.58579 8.34999 3.25 8.0142 3.25 7.59999V4ZM4.75 4.75V6.84999H6.84999V4.75H4.75Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.25 11.2C3.25 10.7858 3.58579 10.45 4 10.45H8.79999C9.2142 10.45 9.54999 10.7858 9.54999 11.2V16C9.54999 16.4142 9.2142 16.75 8.79999 16.75H4C3.58579 16.75 3.25 16.4142 3.25 16V11.2ZM4.75 11.95V15.25H8.04999V11.95H4.75Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.6505 12.4C11.6505 11.9858 11.9863 11.65 12.4005 11.65H16.0005C16.4147 11.65 16.7505 11.9858 16.7505 12.4V16C16.7505 16.4142 16.4147 16.75 16.0005 16.75H12.4005C11.9863 16.75 11.6505 16.4142 11.6505 16V12.4ZM13.1505 13.15V15.25H15.2505V13.15H13.1505Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.4503 4C10.4503 3.58579 10.7861 3.25 11.2003 3.25H16.0002C16.4145 3.25 16.7502 3.58579 16.7502 4V8.79999C16.7502 9.2142 16.4145 9.54999 16.0002 9.54999H11.2003C10.7861 9.54999 10.4503 9.2142 10.4503 8.79999V4ZM11.9503 4.75V8.04999H15.2502V4.75H11.9503Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$columns = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "columns-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M3.49994 6.11908C3.49994 5.74698 3.49994 5.56092 3.5445 5.40917C3.64996 5.04999 3.93085 4.7691 4.29003 4.66364C4.44178 4.61908 4.62783 4.61908 4.99994 4.61908C5.37204 4.61908 5.55809 4.61908 5.70984 4.66364C6.06903 4.7691 6.34992 5.04999 6.45538 5.40917C6.49994 5.56092 6.49994 5.74698 6.49994 6.11908V15.1191C6.49994 15.4912 6.49994 15.6772 6.45538 15.829C6.34992 16.1882 6.06903 16.4691 5.70984 16.5745C5.55809 16.6191 5.37204 16.6191 4.99994 16.6191C4.62783 16.6191 4.44178 16.6191 4.29003 16.5745C3.93085 16.4691 3.64996 16.1882 3.5445 15.829C3.49994 15.6772 3.49994 15.4912 3.49994 15.1191V6.11908Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M8.49994 6.11908C8.49994 5.74698 8.49994 5.56092 8.5445 5.40917C8.64996 5.04999 8.93085 4.7691 9.29003 4.66364C9.44178 4.61908 9.62783 4.61908 9.99994 4.61908C10.372 4.61908 10.5581 4.61908 10.7098 4.66364C11.069 4.7691 11.3499 5.04999 11.4554 5.40917C11.4999 5.56092 11.4999 5.74698 11.4999 6.11908V15.1191C11.4999 15.4912 11.4999 15.6772 11.4554 15.829C11.3499 16.1882 11.069 16.4691 10.7098 16.5745C10.5581 16.6191 10.372 16.6191 9.99994 16.6191C9.62783 16.6191 9.44178 16.6191 9.29003 16.5745C8.93085 16.4691 8.64996 16.1882 8.5445 15.829C8.49994 15.6772 8.49994 15.4912 8.49994 15.1191V6.11908Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M13.4999 6.11908C13.4999 5.74698 13.4999 5.56092 13.5445 5.40917C13.65 5.04999 13.9309 4.7691 14.29 4.66364C14.4418 4.61908 14.6278 4.61908 14.9999 4.61908C15.372 4.61908 15.5581 4.61908 15.7098 4.66364C16.069 4.7691 16.3499 5.04999 16.4554 5.40917C16.4999 5.56092 16.4999 5.74698 16.4999 6.11908V15.1191C16.4999 15.4912 16.4999 15.6772 16.4554 15.829C16.3499 16.1882 16.069 16.4691 15.7098 16.5745C15.5581 16.6191 15.372 16.6191 14.9999 16.6191C14.6278 16.6191 14.4418 16.6191 14.29 16.5745C13.9309 16.4691 13.65 16.1882 13.5445 15.829C13.4999 15.6772 13.4999 15.4912 13.4999 15.1191V6.11908Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$command = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "command-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M7.87517 9.02261V10.9707L7.01859 10.9774C5.90305 10.9774 5 11.8551 5 12.9787C5 14.0957 5.90305 15 7.01859 15C8.12749 15 9.03718 14.0891 9.03718 12.9787V12.1277H10.9628V12.9787C10.9628 14.0891 11.8725 15 12.9814 15C14.0969 15 15 14.0957 15 12.9787C15 11.8551 14.0969 10.9774 12.9814 10.9774L12.1182 10.9707V9.02261H12.9814C14.0969 9.01596 15 8.14495 15 7.02128C15 5.90426 14.0969 5 12.9814 5C11.8725 5 10.9628 5.9109 10.9628 7.02128V7.87234H9.03718V7.02128C9.03718 5.9109 8.12749 5 7.01859 5C5.90305 5 5 5.90426 5 7.02128C5 8.14495 5.90305 9.01596 7.01859 9.02261H7.87517ZM7.04515 7.88564C6.55378 7.88564 6.16866 7.5 6.16866 7.02128C6.16866 6.5492 6.55378 6.17021 7.01859 6.17021C7.4834 6.17021 7.87517 6.55585 7.87517 7.04787V7.88564H7.04515ZM12.9548 7.88564H12.1248V7.04787C12.1248 6.55585 12.5166 6.17021 12.9814 6.17021C13.4462 6.17021 13.8313 6.5492 13.8313 7.02128C13.8313 7.5 13.4396 7.88564 12.9548 7.88564ZM9.03718 10.984V9.01596H10.9628V10.984H9.03718ZM7.04515 12.1144H7.87517V12.9455C7.87517 13.4375 7.4834 13.8298 7.01859 13.8298C6.55378 13.8298 6.16866 13.4441 6.16866 12.9721C6.16866 12.5 6.55378 12.1144 7.04515 12.1144ZM12.9548 12.1144C13.4396 12.1144 13.8313 12.5 13.8313 12.9721C13.8313 13.4441 13.4462 13.8298 12.9814 13.8298C12.5166 13.8298 12.1248 13.4375 12.1248 12.9455V12.1144H12.9548Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$comment = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "comment-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 3.75C6.54822 3.75 3.75 6.54822 3.75 10C3.75 13.4518 6.54822 16.25 10 16.25C11.2309 16.25 12.3766 15.8949 13.3429 15.2819C13.5333 15.1611 13.7679 15.1324 13.9818 15.2037L15.8144 15.8144L15.2037 13.9818C15.1324 13.7679 15.1611 13.5333 15.2819 13.3429C15.8949 12.3766 16.25 11.2309 16.25 10C16.25 6.54822 13.4518 3.75 10 3.75ZM2.25 10C2.25 5.71979 5.71979 2.25 10 2.25C14.2802 2.25 17.75 5.71979 17.75 10C17.75 11.394 17.3813 12.7038 16.7359 13.8352L17.7115 16.7629C17.8013 17.0324 17.7312 17.3295 17.5303 17.5303C17.3295 17.7312 17.0324 17.8013 16.7629 17.7115L13.8352 16.7359C12.7038 17.3813 11.394 17.75 10 17.75C5.71979 17.75 2.25 14.2802 2.25 10Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$comment_attention = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "comment-attention-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 4.36902C6.54822 4.36902 3.75 7.16724 3.75 10.619C3.75 14.0708 6.54822 16.869 10 16.869C11.2309 16.869 12.3766 16.5139 13.3429 15.9009C13.5333 15.7802 13.7679 15.7514 13.9818 15.8227L15.8144 16.4334L15.2037 14.6008C15.1324 14.3869 15.1611 14.1523 15.2819 13.9619C15.8949 12.9956 16.25 11.8499 16.25 10.619C16.25 7.16724 13.4518 4.36902 10 4.36902ZM2.25 10.619C2.25 6.33881 5.71979 2.86902 10 2.86902C14.2802 2.86902 17.75 6.33881 17.75 10.619C17.75 12.013 17.3813 13.3228 16.7359 14.4542L17.7115 17.3819C17.8013 17.6514 17.7312 17.9485 17.5303 18.1493C17.3295 18.3502 17.0324 18.4204 16.7629 18.3306L13.8352 17.3549C12.7038 18.0003 11.394 18.369 10 18.369C5.71979 18.369 2.25 14.8992 2.25 10.619Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M10.7273 11.4116C10.7025 11.7927 10.3862 12.0892 10.0043 12.0892C9.62236 12.0892 9.30603 11.7927 9.28129 11.4116L8.94645 7.06477C8.90902 6.48822 9.36658 6 9.94435 6H10.0643C10.6421 6 11.0996 6.48821 11.0622 7.06477L10.7273 11.4116ZM8.90527 14.1192C8.90527 13.8112 9.01261 13.5499 9.22727 13.3352C9.44194 13.1112 9.69861 12.9992 9.99727 12.9992C10.3053 12.9992 10.5666 13.1112 10.7813 13.3352C11.0053 13.5499 11.1173 13.8112 11.1173 14.1192C11.1173 14.4272 11.0053 14.6885 10.7813 14.9032C10.5666 15.1179 10.3053 15.2252 9.99727 15.2252C9.69861 15.2252 9.44194 15.1179 9.22727 14.9032C9.01261 14.6885 8.90527 14.4272 8.90527 14.1192Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$comment_notification = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "comment-notification-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M17.7095 9.82201C17.7363 10.0841 17.75 10.35 17.75 10.6191C17.75 12.0131 17.3813 13.3229 16.7359 14.4542L17.7115 17.382C17.8013 17.6515 17.7312 17.9486 17.5303 18.1494C17.3295 18.3503 17.0324 18.4204 16.7629 18.3306L13.8352 17.355C12.7038 18.0004 11.394 18.3691 10 18.3691C5.71979 18.3691 2.25 14.8993 2.25 10.6191C2.25 6.33887 5.71979 2.86908 10 2.86908C10.2691 2.86908 10.535 2.8828 10.7971 2.90957C10.5104 3.35337 10.2921 3.84549 10.157 4.37102C10.1048 4.36973 10.0525 4.36908 10 4.36908C6.54822 4.36908 3.75 7.1673 3.75 10.6191C3.75 14.0709 6.54822 16.8691 10 16.8691C11.2309 16.8691 12.3766 16.514 13.3429 15.901C13.5333 15.7802 13.7679 15.7515 13.9818 15.8228L15.8144 16.4334L15.2037 14.6009C15.1324 14.387 15.1611 14.1524 15.2819 13.962C15.8949 12.9957 16.25 11.85 16.25 10.6191C16.25 10.5666 16.2494 10.5142 16.2481 10.4621C16.7736 10.327 17.2657 10.1087 17.7095 9.82201Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M19.0001 5.61908C19.0001 7.82822 17.2092 9.61908 15.0001 9.61908C12.7909 9.61908 11.0001 7.82822 11.0001 5.61908C11.0001 3.40994 12.7909 1.61908 15.0001 1.61908C17.2092 1.61908 19.0001 3.40994 19.0001 5.61908Z",
        fill: "#B91C1C"
    }));
};
const $e959f086e329e090$var$copy = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "copy-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.5556 6.5H8.44444C7.87491 6.5 7.5 6.93379 7.5 7.36364V15.6364C7.5 16.0662 7.87491 16.5 8.44444 16.5H14.5556C15.1251 16.5 15.5 16.0662 15.5 15.6364V7.36364C15.5 6.93379 15.1251 6.5 14.5556 6.5ZM8.44444 5C7.09442 5 6 6.05824 6 7.36364V15.6364C6 16.9418 7.09441 18 8.44444 18H14.5556C15.9056 18 17 16.9418 17 15.6364V7.36364C17 6.05824 15.9056 5 14.5556 5H8.44444Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.21967 2.21967C3.36032 2.07902 3.55109 2 3.75001 2L10.7503 2.00009C11.1645 2.00009 11.5003 2.33588 11.5003 2.75009C11.5003 3.16431 11.1645 3.50009 10.7503 3.50009L4.50002 3.50001L4.5002 11.25C4.50021 11.6642 4.16443 12 3.75022 12C3.336 12 3.00021 11.6642 3.0002 11.25L3 2.75002C3 2.5511 3.07901 2.36033 3.21967 2.21967Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$cross_market_demand = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "cross-market-demand-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("svg", {
        width: "20",
        height: "21",
        viewBox: "0 0 20 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 3.86902C2.41421 3.86902 2.75 4.2048 2.75 4.61902V15.869H17.5C17.9142 15.869 18.25 16.2048 18.25 16.619C18.25 17.0332 17.9142 17.369 17.5 17.369H1.25V4.61902C1.25 4.2048 1.58579 3.86902 2 3.86902Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M2 6.86902C2 6.73095 2.11193 6.61902 2.25 6.61902H13.75C13.8881 6.61902 14 6.73095 14 6.86902V9.36902C14 9.50709 13.8881 9.61902 13.75 9.61902H2.25C2.11193 9.61902 2 9.50709 2 9.36902V6.86902Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M2 11.869C2 11.7309 2.11193 11.619 2.25 11.619H7.75C7.88807 11.619 8 11.7309 8 11.869V14.369C8 14.5071 7.88807 14.619 7.75 14.619H2.25C2.11193 14.619 2 14.5071 2 14.369V11.869Z",
        fill: "#4B5563"
    })));
};
const $e959f086e329e090$var$dash_indeterminate = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "dash-indeterminate-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M5 10.8096H15",
        stroke: "#4B5563",
        strokeWidth: "1.5",
        strokeLinecap: "round"
    }));
};
const $e959f086e329e090$var$date_range = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "date-range-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 4.5H4C3.72386 4.5 3.5 4.72386 3.5 5V15C3.5 15.2761 3.72386 15.5 4 15.5H16C16.2761 15.5 16.5 15.2761 16.5 15V5C16.5 4.72386 16.2761 4.5 16 4.5ZM4 3C2.89543 3 2 3.89543 2 5V15C2 16.1046 2.89543 17 4 17H16C17.1046 17 18 16.1046 18 15V5C18 3.89543 17.1046 3 16 3H4Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 2C6.41421 2 6.75 2.33579 6.75 2.75V4.75C6.75 5.16421 6.41421 5.5 6 5.5C5.58579 5.5 5.25 5.16421 5.25 4.75V2.75C5.25 2.33579 5.58579 2 6 2Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14 2C14.4142 2 14.75 2.33579 14.75 2.75V4.75C14.75 5.16421 14.4142 5.5 14 5.5C13.5858 5.5 13.25 5.16421 13.25 4.75V2.75C13.25 2.33579 13.5858 2 14 2Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M5 8C5 7.44772 5.44772 7 6 7C6.55228 7 7 7.44772 7 8C7 8.55228 6.55228 9 6 9C5.44772 9 5 8.55228 5 8Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M13 12C13 11.4477 13.4477 11 14 11C14.5523 11 15 11.4477 15 12C15 12.5523 14.5523 13 14 13C13.4477 13 13 12.5523 13 12Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M8 8C8 7.44772 8.44772 7 9 7H14C14.5523 7 15 7.44772 15 8C15 8.55228 14.5523 9 14 9H9C8.44772 9 8 8.55228 8 8Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M5 12C5 11.4477 5.44772 11 6 11H11C11.5523 11 12 11.4477 12 12C12 12.5523 11.5523 13 11 13H6C5.44772 13 5 12.5523 5 12Z",
        fill: "#4B5563"
    })));
};
const $e959f086e329e090$var$diamond_exclamation = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "diamond-exclamation-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.83515 2.79316C8.89269 1.73561 10.6073 1.73562 11.6649 2.79316L17.7068 8.83515C18.7644 9.89269 18.7644 11.6073 17.7068 12.6649L11.6648 18.7068C10.6073 19.7644 8.89269 19.7644 7.83515 18.7068L1.79316 12.6648C0.735613 11.6073 0.735615 9.89269 1.79316 8.83515L7.83515 2.79316ZM10.6042 3.85382C10.1324 3.38206 9.36757 3.38206 8.89581 3.85382L2.85382 9.89581C2.38206 10.3676 2.38206 11.1324 2.85382 11.6042L8.89581 17.6462C9.36757 18.1179 10.1324 18.1179 10.6042 17.6462L16.6462 11.6042C17.1179 11.1324 17.1179 10.3676 16.6462 9.89581L10.6042 3.85382Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M10.4802 11.9744C10.4554 12.3555 10.1391 12.652 9.7572 12.652C9.37529 12.652 9.05896 12.3555 9.03422 11.9744L8.69932 6.81477C8.66189 6.23822 9.11944 5.75 9.69722 5.75H9.81719C10.395 5.75 10.8525 6.23821 10.8151 6.81477L10.4802 11.9744ZM8.6582 14.682C8.6582 14.374 8.76554 14.1127 8.9802 13.898C9.19487 13.674 9.45154 13.562 9.7502 13.562C10.0582 13.562 10.3195 13.674 10.5342 13.898C10.7582 14.1127 10.8702 14.374 10.8702 14.682C10.8702 14.99 10.7582 15.2513 10.5342 15.466C10.3195 15.6807 10.0582 15.788 9.7502 15.788C9.45154 15.788 9.19487 15.6807 8.9802 15.466C8.76554 15.2513 8.6582 14.99 8.6582 14.682Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$doc = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "doc-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.5 2.25C2.5 1.83579 2.83579 1.5 3.25 1.5H14.25C14.4489 1.5 14.6397 1.57902 14.7803 1.71967L17.7803 4.71967C17.921 4.86032 18 5.05109 18 5.25V18.25C18 18.6642 17.6642 19 17.25 19H3.25C2.83579 19 2.5 18.6642 2.5 18.25V2.25ZM4 3V17.5H16.5V5.56066L13.9393 3H4Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.25 11.5C5.25 11.0858 5.58579 10.75 6 10.75H14.5C14.9142 10.75 15.25 11.0858 15.25 11.5C15.25 11.9142 14.9142 12.25 14.5 12.25H6C5.58579 12.25 5.25 11.9142 5.25 11.5Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.25 14.5C5.25 14.0858 5.58579 13.75 6 13.75H14.5C14.9142 13.75 15.25 14.0858 15.25 14.5C15.25 14.9142 14.9142 15.25 14.5 15.25H6C5.58579 15.25 5.25 14.9142 5.25 14.5Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.5 5.25C5.5 4.83579 5.83579 4.5 6.25 4.5H9.25C9.66421 4.5 10 4.83579 10 5.25V8.25C10 8.66421 9.66421 9 9.25 9H6.25C5.83579 9 5.5 8.66421 5.5 8.25V5.25ZM7 6V7.5H8.5V6H7Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$document_csv = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "document_csv-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.25 2C2.25 1.58579 2.58579 1.25 3 1.25H14C14.1989 1.25 14.3897 1.32902 14.5303 1.46967L17.5303 4.46967C17.671 4.61032 17.75 4.80109 17.75 5V8H18C18.5523 8 19 8.44772 19 9V15C19 15.5523 18.5523 16 18 16H17.75V18C17.75 18.4142 17.4142 18.75 17 18.75H3C2.58579 18.75 2.25 18.4142 2.25 18V16H2C1.44772 16 1 15.5523 1 15V9C1 8.44772 1.44772 8 2 8H2.25V2ZM16.25 5.31066V8H3.75V2.75H13.6893L16.25 5.31066ZM3.75 17.25V16H16.25V17.25H3.75ZM8.37988 12.8574C8.40332 13.4844 8.85742 14.0732 9.98828 14.0732C11.0664 14.0732 11.6318 13.54 11.6318 12.7812C11.6318 12.0518 11.1455 11.75 10.5361 11.6299L9.95605 11.5098C9.61621 11.4453 9.41992 11.3135 9.41992 11.0996C9.41992 10.8447 9.63086 10.6514 10.0176 10.6514C10.416 10.6514 10.6387 10.8682 10.6709 11.1055H11.5615C11.5381 10.4873 11.0195 9.9248 10.0205 9.9248C9.09473 9.9248 8.46191 10.4023 8.46191 11.1699C8.46191 11.832 8.88965 12.1748 9.52539 12.3066L10.0908 12.4297C10.4834 12.5146 10.6826 12.6289 10.6826 12.8779C10.6826 13.1416 10.4717 13.3379 10.0264 13.3379C9.58984 13.3379 9.3291 13.1211 9.29688 12.8574H8.37988ZM5.46191 11.7822C5.46191 11.1055 5.74316 10.7246 6.22363 10.7246C6.64258 10.7246 6.90332 11.0293 6.92383 11.4365H7.84082V11.3252C7.82031 10.4873 7.14648 9.93066 6.21777 9.93066C5.10449 9.93066 4.48047 10.6426 4.48047 11.7822V12.2275C4.48047 13.3643 5.09863 14.0732 6.21777 14.0732C7.14355 14.0732 7.82031 13.5225 7.84082 12.7021V12.5879H6.92383C6.90332 12.9863 6.64844 13.2764 6.22363 13.2764C5.74023 13.2764 5.46191 12.9043 5.46191 12.2305V11.7822ZM14.4766 14H13.2695L11.9951 10.001H13.1143L13.8789 12.9834H13.9229L14.6758 10.001H15.7363L14.4766 14Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$document_list = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "document-list-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.25 2C2.25 1.58579 2.58579 1.25 3 1.25H14C14.1989 1.25 14.3897 1.32902 14.5303 1.46967L17.5303 4.46967C17.671 4.61032 17.75 4.80109 17.75 5V18C17.75 18.4142 17.4142 18.75 17 18.75H3C2.58579 18.75 2.25 18.4142 2.25 18V2ZM3.75 2.75V17.25H16.25V5.31066L13.6893 2.75H3.75Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.5 7.25C8.5 6.83579 8.83579 6.5 9.25 6.5H13.75C14.1642 6.5 14.5 6.83579 14.5 7.25C14.5 7.66421 14.1642 8 13.75 8H9.25C8.83579 8 8.5 7.66421 8.5 7.25Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.5 10.25C8.5 9.83579 8.83579 9.5 9.25 9.5H12.75C13.1642 9.5 13.5 9.83579 13.5 10.25C13.5 10.6642 13.1642 11 12.75 11H9.25C8.83579 11 8.5 10.6642 8.5 10.25Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.5 13.25C8.5 12.8358 8.83579 12.5 9.25 12.5H13.75C14.1642 12.5 14.5 12.8358 14.5 13.25C14.5 13.6642 14.1642 14 13.75 14H9.25C8.83579 14 8.5 13.6642 8.5 13.25Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.5 10.25C5.5 9.83579 5.83579 9.5 6.25 9.5H6.75C7.16421 9.5 7.5 9.83579 7.5 10.25C7.5 10.6642 7.16421 11 6.75 11H6.25C5.83579 11 5.5 10.6642 5.5 10.25Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.5 7.25C5.5 6.83579 5.83579 6.5 6.25 6.5H6.75C7.16421 6.5 7.5 6.83579 7.5 7.25C7.5 7.66421 7.16421 8 6.75 8H6.25C5.83579 8 5.5 7.66421 5.5 7.25Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.5 13.25C5.5 12.8358 5.83579 12.5 6.25 12.5H6.75C7.16421 12.5 7.5 12.8358 7.5 13.25C7.5 13.6642 7.16421 14 6.75 14H6.25C5.83579 14 5.5 13.6642 5.5 13.25Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$document_pdf = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "document_pdf-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M6.97363 11.3867C6.97363 11.7998 6.72754 12.0342 6.3291 12.0342H5.82227V10.7393H6.3291C6.72754 10.7393 6.97363 10.9678 6.97363 11.3867Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M9.57227 10.7627H10.0234C10.7031 10.7627 10.9961 11.1846 10.9961 12.0078C10.9961 12.8281 10.7061 13.2354 10.0234 13.2354H9.57227V10.7627Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.25 2C2.25 1.58579 2.58579 1.25 3 1.25H14C14.1989 1.25 14.3897 1.32902 14.5303 1.46967L17.5303 4.46967C17.671 4.61032 17.75 4.80109 17.75 5V8H18C18.5523 8 19 8.44772 19 9V15C19 15.5523 18.5523 16 18 16H17.75V18C17.75 18.4142 17.4142 18.75 17 18.75H3C2.58579 18.75 2.25 18.4142 2.25 18V16H2C1.44772 16 1 15.5523 1 15V9C1 8.44772 1.44772 8 2 8H2.25V2ZM16.25 5.31066V8H3.75V2.75H13.6893L16.25 5.31066ZM3.75 17.25V16H16.25V17.25H3.75ZM6.55176 10.001H4.86426V14H5.8252V12.7578H6.54004C7.46289 12.7578 7.94922 12.1514 7.94922 11.3867C7.94922 10.6338 7.47168 10.001 6.55176 10.001ZM8.6084 10.001V14H10.1758C11.4092 14 11.9834 13.2324 11.9834 11.9844C11.9834 10.751 11.4238 10.001 10.1758 10.001H8.6084ZM13.6797 12.4912V14H12.7158V10.001H15.3789V10.7744H13.6797V11.7412H15.2236V12.4912H13.6797Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$document_question_mark = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "document-question-mark-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.25 2C2.25 1.58579 2.58579 1.25 3 1.25H14C14.1989 1.25 14.3897 1.32902 14.5303 1.46967L17.5303 4.46967C17.671 4.61032 17.75 4.80109 17.75 5V18C17.75 18.4142 17.4142 18.75 17 18.75H3C2.58579 18.75 2.25 18.4142 2.25 18V2ZM3.75 2.75V17.25H16.25V5.31066L13.6893 2.75H3.75Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M7 8.44922H8.58789C8.62305 7.78711 9.06836 7.35938 9.74219 7.35938C10.4102 7.35938 10.8555 7.76367 10.8555 8.32031C10.8555 8.87695 10.627 9.16406 9.87109 9.61523C9.0625 10.0898 8.74023 10.6172 8.81641 11.5371L8.82812 11.877H10.3809V11.5664C10.3809 10.9922 10.5977 10.7051 11.377 10.2539C12.2031 9.76758 12.6309 9.15234 12.6309 8.26758C12.6309 6.93164 11.5234 6 9.84766 6C8.04883 6 7.0293 7.00781 7 8.44922ZM9.66602 14.7012C10.3223 14.7012 10.7266 14.3262 10.7266 13.7227C10.7266 13.1133 10.3223 12.7383 9.66602 12.7383C9.00977 12.7383 8.59961 13.1133 8.59961 13.7227C8.59961 14.3262 9.00977 14.7012 9.66602 14.7012Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$document_signed = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "document-signed-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.25 2C2.25 1.58579 2.58579 1.25 3 1.25H14C14.1989 1.25 14.3897 1.32902 14.5303 1.46967L17.5303 4.46967C17.671 4.61032 17.75 4.80109 17.75 5V18C17.75 18.4142 17.4142 18.75 17 18.75H3C2.58579 18.75 2.25 18.4142 2.25 18V2ZM3.75 2.75V17.25H16.25V5.31066L13.6893 2.75H3.75ZM5 7.25C5 6.83579 5.33579 6.5 5.75 6.5L14.25 6.5C14.6642 6.5 15 6.83579 15 7.25C15 7.66421 14.6642 8 14.25 8L5.75 8C5.33579 8 5 7.66421 5 7.25ZM8.54752 12.2799C8.00025 12.7347 7.3748 13.0797 6.77439 13.4109C6.63757 13.4864 6.50205 13.5612 6.36906 13.6363C6.00846 13.8402 5.55091 13.7131 5.34709 13.3525C5.14326 12.9919 5.27035 12.5343 5.63094 12.3305C5.78752 12.242 5.93696 12.1588 6.07966 12.0794C6.94514 11.5977 7.56304 11.2537 8.02492 10.6945C8.1319 10.565 8.35305 10.3218 8.69471 10.2628C8.9002 10.2273 9.1069 10.2665 9.2825 10.3715C9.44087 10.4662 9.53685 10.5916 9.59108 10.6786C9.69268 10.8415 9.7379 11.0183 9.75886 11.106C9.77118 11.1576 9.78914 11.2462 9.79989 11.3L9.81203 11.3334C9.83147 11.3874 9.85792 11.4618 9.88567 11.5428C9.92277 11.6512 9.97854 11.8173 10.0147 11.9598C10.0187 11.9655 10.0233 11.9719 10.0285 11.979C10.0581 12.0193 10.0966 12.0665 10.1393 12.1141C10.315 12.021 10.4726 11.9546 10.5858 11.9068C10.6131 11.8953 10.6379 11.8849 10.6597 11.8754C10.5 12 10.857 11.7266 10.857 11.6258C10.857 11.6258 10.8823 11.5954 10.9399 11.5096C10.9545 11.4879 10.9731 11.4594 10.9944 11.4268C11.0531 11.337 11.1319 11.2164 11.2 11.1247C11.2516 11.0553 11.3194 10.9703 11.4012 10.8917C11.476 10.8198 11.6101 10.706 11.8008 10.6428C12.0267 10.568 12.295 10.5786 12.5365 10.7252C12.6556 10.7976 12.7442 10.8888 12.8099 10.9769C12.8562 10.9695 12.9177 10.9568 12.9971 10.9359C13.0764 10.9151 13.1571 10.8908 13.2463 10.8638L13.2595 10.8598C13.3396 10.8355 13.4337 10.807 13.521 10.7846C13.6044 10.7632 13.7364 10.7324 13.8756 10.7289C13.9732 10.7265 14.3533 10.7272 14.6046 11.0694C14.8497 11.4033 14.7777 11.8727 14.4439 12.1178C14.2669 12.2477 14.052 12.2886 13.8525 12.2486C13.8065 12.2614 13.7518 12.278 13.681 12.2994C13.5944 12.3256 13.4884 12.3577 13.3785 12.3866C13.1744 12.4403 12.8738 12.507 12.5698 12.4796C12.4404 12.468 12.2999 12.4374 12.1627 12.379C12.1239 12.4359 12.0791 12.4989 12.0306 12.5593C12.0243 12.567 12.0177 12.5752 12.0107 12.5836C11.9452 12.745 11.8413 12.8771 11.7245 12.9779C11.5659 13.1149 11.3781 13.1983 11.2728 13.2445C11.2291 13.2636 11.1873 13.2816 11.1469 13.2988C10.9472 13.3844 10.7833 13.4547 10.604 13.5869C10.3466 13.7768 10.0706 13.7627 9.91602 13.7302C9.76409 13.6982 9.64136 13.6332 9.56325 13.5858C9.40183 13.4879 9.25412 13.3551 9.14157 13.2417C9.02329 13.1225 8.91 12.9902 8.81929 12.8666C8.77417 12.8051 8.72788 12.7367 8.68796 12.6662C8.6584 12.614 8.59177 12.4923 8.56391 12.3405C8.56391 12.3405 8.55972 12.322 8.54752 12.2799Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$document_warning = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "document-warning-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.25 2C2.25 1.58579 2.58579 1.25 3 1.25H14C14.1989 1.25 14.3897 1.32902 14.5303 1.46967L17.5303 4.46967C17.671 4.61032 17.75 4.80109 17.75 5V18C17.75 18.4142 17.4142 18.75 17 18.75H3C2.58579 18.75 2.25 18.4142 2.25 18V2ZM3.75 2.75V17.25H16.25V5.31066L13.6893 2.75H3.75Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.0575 6.65381C10.6218 5.78207 9.37823 5.78206 8.94253 6.6538L6.12634 12.2883C5.73329 13.0747 6.30492 14 7.18382 14H12.8162C13.6951 14 14.2667 13.0747 13.8737 12.2883L11.0575 6.65381ZM9.64203 11.1122L9.47451 8.53239C9.4558 8.24411 9.68466 8 9.97365 8H10.0337C10.3227 8 10.5515 8.24411 10.5328 8.53239L10.3653 11.1122C10.3529 11.3028 10.1947 11.451 10.0037 11.451C9.81263 11.451 9.6544 11.3028 9.64203 11.1122ZM9.45395 12.466C9.45395 12.312 9.50764 12.1813 9.61501 12.074C9.72238 11.962 9.85077 11.906 10.0002 11.906C10.1542 11.906 10.2849 11.962 10.3923 12.074C10.5044 12.1813 10.5604 12.312 10.5604 12.466C10.5604 12.62 10.5044 12.7507 10.3923 12.858C10.2849 12.9653 10.1542 13.019 10.0002 13.019C9.85077 13.019 9.72238 12.9653 9.61501 12.858C9.50764 12.7507 9.45395 12.62 9.45395 12.466Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$dollar_bill = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "dollar-bill-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 15.75C1.58579 15.75 1.25 15.4142 1.25 15L1.25 5C1.25 4.58579 1.58579 4.25 2 4.25L18 4.25C18.4142 4.25 18.75 4.58579 18.75 5V15C18.75 15.4142 18.4142 15.75 18 15.75L2 15.75ZM2.75 14.25L17.25 14.25V5.75L2.75 5.75L2.75 14.25Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 10.75H13.5V9.25H16V10.75Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.5 10.75H4V9.25H6.5V10.75Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M9.80078 13.5547H10.25V12.9297C11.3594 12.8555 12.1523 12.2617 12.1523 11.2812C12.1523 10.4258 11.5937 9.99609 10.5273 9.75391L10.25 9.69531V8.31641C10.6875 8.37891 10.9805 8.62109 11.0352 9.04297H12.0781C12.0391 8.12109 11.3359 7.51172 10.25 7.43359V6.79687H9.80078V7.42969C8.72656 7.49609 7.95703 8.10156 7.95703 9.03516C7.95703 9.87891 8.51953 10.3359 9.53906 10.5664L9.80078 10.6289V12.0547C9.26953 11.9961 8.98828 11.7188 8.92578 11.3203H7.87891C7.90625 12.2969 8.70312 12.8711 9.80078 12.9336V13.5547ZM9.05078 8.93359C9.05078 8.62109 9.30859 8.36719 9.80078 8.30859V9.58984C9.27344 9.44922 9.05078 9.24609 9.05078 8.93359ZM11.0625 11.4023C11.0625 11.7578 10.793 12 10.25 12.0547V10.7305C10.8555 10.8828 11.0625 11.0586 11.0625 11.4023Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$dots = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "dots-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("circle", {
        cx: "7",
        cy: "10",
        r: "3",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("circle", {
        cx: "13",
        cy: "10",
        r: "3",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$drag_arrows = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "drag-arrows-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.97503 2.46434C9.26665 2.17855 9.7333 2.17855 10.0249 2.46434L12.6201 5.00755C12.9159 5.29746 12.9207 5.77231 12.6308 6.06815C12.3409 6.36399 11.866 6.36879 11.5702 6.07888L10.25 4.78508V9.75003L15.2149 9.75003L13.9211 8.4298C13.6312 8.13396 13.636 7.65911 13.9318 7.3692C14.2277 7.07928 14.7025 7.08408 14.9925 7.37992L17.5357 9.97509C17.8214 10.2667 17.8214 10.7333 17.5357 11.025L14.9925 13.6201C14.7025 13.916 14.2277 13.9208 13.9318 13.6309C13.636 13.3409 13.6312 12.8661 13.9211 12.5702L15.2149 11.25L10.25 11.25V16.2149L11.5702 14.9211C11.866 14.6312 12.3409 14.636 12.6308 14.9318C12.9207 15.2277 12.9159 15.7025 12.6201 15.9925L10.0249 18.5357C9.7333 18.8214 9.26665 18.8214 8.97503 18.5357L6.37987 15.9925C6.08403 15.7025 6.07923 15.2277 6.36914 14.9318C6.65906 14.636 7.13391 14.6312 7.42975 14.9211L8.74997 16.2149L8.74997 11.25H3.78508L5.07888 12.5702C5.36879 12.8661 5.36399 13.3409 5.06815 13.6309C4.77231 13.9208 4.29746 13.916 4.00755 13.6201L1.46434 11.025C1.17855 10.7333 1.17855 10.2667 1.46434 9.97508L4.00755 7.37992C4.29746 7.08408 4.77231 7.07928 5.06815 7.3692C5.36399 7.65911 5.36879 8.13396 5.07888 8.4298L3.78508 9.75002L8.74997 9.75002V4.78508L7.42975 6.07888C7.13391 6.36879 6.65906 6.36399 6.36914 6.06815C6.07923 5.77231 6.08403 5.29746 6.37987 5.00755L8.97503 2.46434Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$drag_handle = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "drag-handle", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 4C7 4.55 7.45 5 8 5C8.55 5 9 4.55 9 4C9 3.45 8.55 3 8 3C7.45 3 7 3.45 7 4Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11 4C11 4.55 11.45 5 12 5C12.55 5 13 4.55 13 4C13 3.45 12.55 3 12 3C11.45 3 11 3.45 11 4Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 12C7 12.55 7.45 13 8 13C8.55 13 9 12.55 9 12C9 11.45 8.55 11 8 11C7.45 11 7 11.45 7 12Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 8C7 8.55 7.45 9 8 9C8.55 9 9 8.55 9 8C9 7.45 8.55 7 8 7C7.45 7 7 7.45 7 8Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11 12C11 12.55 11.45 13 12 13C12.55 13 13 12.55 13 12C13 11.45 12.55 11 12 11C11.45 11 11 11.45 11 12Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11 8C11 8.55 11.45 9 12 9C12.55 9 13 8.55 13 8C13 7.45 12.55 7 12 7C11.45 7 11 7.45 11 8Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 16C7 16.55 7.45 17 8 17C8.55 17 9 16.55 9 16C9 15.45 8.55 15 8 15C7.45 15 7 15.45 7 16Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11 16C11 16.55 11.45 17 12 17C12.55 17 13 16.55 13 16C13 15.45 12.55 15 12 15C11.45 15 11 15.45 11 16Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$drawer_close = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "drawer-close-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M19.0607 14.25C19.0607 14.6642 18.7249 15 18.3107 15L9.81066 15C9.39645 15 9.06066 14.6642 9.06066 14.25C9.06066 13.8358 9.39645 13.5 9.81066 13.5L18.3107 13.5C18.7249 13.5 19.0607 13.8358 19.0607 14.25Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M6.59099 6.53033C6.88388 6.23744 6.88388 5.76256 6.59099 5.46967C6.2981 5.17678 5.82322 5.17678 5.53033 5.46967L1 10L5.53033 14.5303C5.82322 14.8232 6.2981 14.8232 6.59099 14.5303C6.88388 14.2374 6.88388 13.7626 6.59099 13.4697L3.87132 10.75L18.0607 10.75C18.4749 10.75 18.8107 10.4142 18.8107 10C18.8107 9.58579 18.4749 9.25 18.0607 9.25L3.87132 9.25L6.59099 6.53033Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M18.3107 6.5C18.7249 6.5 19.0607 6.16421 19.0607 5.75C19.0607 5.33579 18.7249 5 18.3107 5L9.81066 5C9.39645 5 9.06066 5.33579 9.06066 5.75C9.06066 6.16421 9.39645 6.5 9.81066 6.5L18.3107 6.5Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$drawer_open = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "drawer-open-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M1 5.75C1 5.33579 1.33579 5 1.75 5H10.25C10.6642 5 11 5.33579 11 5.75C11 6.16421 10.6642 6.5 10.25 6.5H1.75C1.33579 6.5 1 6.16421 1 5.75Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M13.4697 13.4697C13.1768 13.7626 13.1768 14.2374 13.4697 14.5303C13.7626 14.8232 14.2374 14.8232 14.5303 14.5303L19.0607 10L14.5303 5.46967C14.2374 5.17678 13.7626 5.17678 13.4697 5.46967C13.1768 5.76256 13.1768 6.23744 13.4697 6.53033L16.1893 9.25H2C1.58579 9.25 1.25 9.58579 1.25 10C1.25 10.4142 1.58579 10.75 2 10.75H16.1893L13.4697 13.4697Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M1.75 13.5C1.33579 13.5 1 13.8358 1 14.25C1 14.6642 1.33579 15 1.75 15H10.25C10.6642 15 11 14.6642 11 14.25C11 13.8358 10.6642 13.5 10.25 13.5H1.75Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$email = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "email-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        // eslint-disable-next-line max-len
        d: "M1.25 4C1.25 3.58579 1.58579 3.25 2 3.25H18C18.4142 3.25 18.75 3.58579 18.75 4V16C18.75 16.4142 18.4142 16.75 18 16.75H2C1.58579 16.75 1.25 16.4142 1.25 16V4ZM3.99609 4.75L10 10.0034L16.0039 4.75H3.99609ZM17.25 5.65283L10.4939 11.5644C10.2111 11.8119 9.78889 11.8119 9.50612 11.5644L2.75 5.65283V15.25H17.25V5.65283Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$export_icon = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "export-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.25 4.7381C3.25 4.04774 3.80964 3.4881 4.5 3.4881H8C8.41421 3.4881 8.75 3.82388 8.75 4.2381C8.75 4.65231 8.41421 4.9881 8 4.9881H4.75V15.4881H8C8.41421 15.4881 8.75 15.8239 8.75 16.2381C8.75 16.6523 8.41421 16.9881 8 16.9881H4.5C3.80964 16.9881 3.25 16.4285 3.25 15.7381V4.7381ZM13.0199 6.66193C13.3381 6.39676 13.811 6.43975 14.0762 6.75796L16.5762 9.75796C16.8079 10.0361 16.8079 10.4401 16.5762 10.7182L14.0762 13.7182C13.811 14.0364 13.3381 14.0794 13.0199 13.8143C12.7017 13.5491 12.6587 13.0762 12.9238 12.758L14.3987 10.9881H8C7.58579 10.9881 7.25 10.6523 7.25 10.2381C7.25 9.82388 7.58579 9.4881 8 9.4881H14.3987L12.9238 7.71824C12.6587 7.40003 12.7017 6.92711 13.0199 6.66193Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$eye = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "eye-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0.0619922 9.79209C1.62387 5.82872 5.48017 3.01714 9.99967 3.01714C14.5192 3.01714 18.3755 5.82872 19.9373 9.79209C20.007 9.9688 20.007 10.1653 19.9373 10.342C18.3755 14.3054 14.5192 17.117 9.99967 17.117C5.48017 17.117 1.62387 14.3054 0.0619922 10.342C-0.00764322 10.1653 -0.00764322 9.9688 0.0619922 9.79209ZM1.57109 10.0671C2.98213 13.3328 6.22435 15.617 9.99967 15.617C13.775 15.617 17.0172 13.3328 18.4282 10.0671C17.0172 6.80135 13.775 4.51714 9.99967 4.51714C6.22435 4.51714 2.98213 6.80135 1.57109 10.0671Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 7.74998C8.75736 7.74998 7.75 8.75734 7.75 9.99998C7.75 11.2426 8.75736 12.25 10 12.25C11.2426 12.25 12.25 11.2426 12.25 9.99998C12.25 8.75734 11.2426 7.74998 10 7.74998ZM6.25 9.99998C6.25 7.92892 7.92893 6.24998 10 6.24998C12.0711 6.24998 13.75 7.92892 13.75 9.99998C13.75 12.0711 12.0711 13.75 10 13.75C7.92893 13.75 6.25 12.0711 6.25 9.99998Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$eye_off = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "eye-off-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0.0522265 9.54209C1.6059 5.59954 5.20899 2.76714 9.74967 2.76714C14.2903 2.76714 17.8941 5.59948 19.4478 9.54209C19.5174 9.7188 19.5174 9.91534 19.4478 10.092C17.8941 14.0347 14.2903 16.867 9.74967 16.867C5.20899 16.867 1.6059 14.0346 0.0522265 10.092C-0.0174088 9.91534 -0.0174088 9.7188 0.0522265 9.54209ZM1.5608 9.81707C2.96742 13.1017 5.99435 15.367 9.74967 15.367C13.505 15.367 16.5326 13.1017 17.9392 9.81707C16.5326 6.53244 13.505 4.26714 9.74967 4.26714C5.99435 4.26714 2.96742 6.53239 1.5608 9.81707Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.75 7.5C8.50736 7.5 7.5 8.50736 7.5 9.75C7.5 10.9926 8.50736 12 9.75 12C10.9926 12 12 10.9926 12 9.75C12 8.50736 10.9926 7.5 9.75 7.5ZM6 9.75C6 7.67893 7.67893 6 9.75 6C11.8211 6 13.5 7.67893 13.5 9.75C13.5 11.8211 11.8211 13.5 9.75 13.5C7.67893 13.5 6 11.8211 6 9.75Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.21967 18.2803C0.926777 17.9874 0.926777 17.5126 1.21967 17.2197L17.2197 1.21967C17.5126 0.926777 17.9874 0.926777 18.2803 1.21967C18.5732 1.51256 18.5732 1.98744 18.2803 2.28033L2.28033 18.2803C1.98744 18.5732 1.51256 18.5732 1.21967 18.2803Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$filter = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "filter-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        // eslint-disable-next-line max-len
        d: "M1.25 6C1.25 5.58579 1.58579 5.25 2 5.25H18C18.4142 5.25 18.75 5.58579 18.75 6C18.75 6.41421 18.4142 6.75 18 6.75H2C1.58579 6.75 1.25 6.41421 1.25 6ZM4.25 10C4.25 9.58579 4.58579 9.25 5 9.25H15C15.4142 9.25 15.75 9.58579 15.75 10C15.75 10.4142 15.4142 10.75 15 10.75H5C4.58579 10.75 4.25 10.4142 4.25 10ZM7.25 14C7.25 13.5858 7.58579 13.25 8 13.25H12C12.4142 13.25 12.75 13.5858 12.75 14C12.75 14.4142 12.4142 14.75 12 14.75H8C7.58579 14.75 7.25 14.4142 7.25 14Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$finalized = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "finalized-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M9.43943 14.2481H7.49997V6.25002H12.832V7.80275H9.43943V9.72463H12.5273V11.2363H9.43943V14.2481Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M16.8397 10.0323C16.8396 9.78541 16.7116 9.52163 16.4256 9.12512C16.1831 8.78893 15.7631 8.28792 15.5486 7.76086C15.337 7.24066 15.2759 6.58749 15.2068 6.17297C15.1247 5.68042 15.0263 5.41006 14.867 5.25305C14.7026 5.09115 14.4181 4.99024 13.9217 4.9054C13.5059 4.83436 12.8539 4.77027 12.3494 4.5636C12.0738 4.45069 11.8245 4.29046 11.6092 4.13879C11.5003 4.0621 11.393 3.98225 11.2928 3.90735C11.1904 3.83078 11.0952 3.75997 10.9998 3.69153C10.599 3.40383 10.3275 3.27258 10.0799 3.27258C9.83297 3.27261 9.56914 3.40066 9.17267 3.68665C8.83648 3.92916 8.33546 4.3491 7.80841 4.5636C7.2882 4.77525 6.63505 4.83728 6.22052 4.90637C5.72813 4.98847 5.4576 5.086 5.3006 5.24524C5.13865 5.40971 5.03779 5.69489 4.95294 6.19153C4.88194 6.60732 4.81774 7.25849 4.61115 7.76282C4.49823 8.03845 4.33803 8.28774 4.18634 8.50305C4.10963 8.61193 4.02982 8.71923 3.9549 8.81946C3.87832 8.92189 3.80752 9.01708 3.73907 9.11243C3.45141 9.5132 3.32016 9.78478 3.32013 10.0323C3.32013 10.2793 3.44823 10.5431 3.73419 10.9396C3.97671 11.2758 4.39665 11.7768 4.61115 12.3038C4.82284 12.8241 4.88482 13.4772 4.95392 13.8917C5.03601 14.3841 5.13357 14.6546 5.29279 14.8116C5.45726 14.9736 5.74244 15.0744 6.23907 15.1593C6.65487 15.2303 7.30602 15.2955 7.81036 15.5021C8.08588 15.615 8.33536 15.7743 8.5506 15.9259C8.6595 16.0026 8.76676 16.0824 8.867 16.1573C8.9695 16.234 9.06456 16.3057 9.15997 16.3741C9.56059 16.6617 9.83238 16.7921 10.0799 16.7921C10.3268 16.7921 10.5906 16.6641 10.9871 16.3781C11.3233 16.1355 11.8243 15.7156 12.3514 15.5011C12.8716 15.2894 13.5247 15.2284 13.9393 15.1593C14.4318 15.0772 14.7022 14.9787 14.8592 14.8195C15.0211 14.655 15.122 14.3706 15.2068 13.8741C15.2779 13.4584 15.343 12.8064 15.5496 12.3019C15.6625 12.0264 15.8218 11.7768 15.9734 11.5616C16.0502 11.4528 16.13 11.3455 16.2049 11.2452C16.2815 11.1428 16.3532 11.0476 16.4217 10.9523C16.7092 10.5517 16.8397 10.2799 16.8397 10.0323ZM18.16 10.0323C18.16 10.7345 17.7912 11.3077 17.494 11.7218C17.4162 11.8301 17.3352 11.9377 17.2615 12.0363C17.1862 12.137 17.1173 12.2305 17.0526 12.3224C16.9211 12.5089 16.8274 12.6635 16.7703 12.8029C16.6371 13.1282 16.6065 13.5169 16.5076 14.0958C16.4225 14.5941 16.2784 15.2597 15.8006 15.7452C15.3176 16.2357 14.653 16.3782 14.1561 16.4611C13.5807 16.557 13.1882 16.5855 12.8484 16.7238C12.5156 16.8593 12.2308 17.1095 11.7596 17.4493C11.3487 17.7457 10.7827 18.1124 10.0799 18.1124C9.37773 18.1124 8.80459 17.7437 8.39044 17.4464C8.28217 17.3687 8.17458 17.2877 8.07599 17.214C7.97532 17.1387 7.88167 17.0697 7.78986 17.005C7.60335 16.8736 7.44872 16.7799 7.30939 16.7228C6.984 16.5896 6.59535 16.559 6.01642 16.4601C5.51812 16.3749 4.85251 16.2309 4.367 15.7531C3.87649 15.2701 3.73402 14.6055 3.65118 14.1085C3.55528 13.5331 3.52676 13.1407 3.38849 12.8009C3.25296 12.4681 3.00374 12.1832 2.66388 11.712C2.36746 11.3011 1.99982 10.7354 1.99982 10.0323C1.99984 9.33022 2.3686 8.75703 2.66583 8.3429C2.74355 8.23463 2.82455 8.12703 2.89825 8.02844C2.97353 7.92774 3.04254 7.83414 3.10724 7.74231C3.23866 7.55577 3.33238 7.40119 3.38947 7.26184C3.52265 6.93645 3.55325 6.54782 3.65216 5.96887C3.73729 5.4706 3.88136 4.80496 4.35919 4.31946C4.84211 3.82899 5.50676 3.68647 6.00372 3.60364C6.57913 3.50774 6.97159 3.47921 7.31134 3.34094C7.64417 3.20543 7.92907 2.9562 8.40021 2.61633C8.81112 2.31992 9.3769 1.9523 10.0799 1.95227C10.782 1.95227 11.3552 2.32105 11.7693 2.61829C11.8776 2.696 11.9852 2.77701 12.0838 2.85071C12.1845 2.926 12.2781 2.99499 12.3699 3.05969C12.5565 3.19112 12.711 3.28483 12.8504 3.34192C13.1758 3.47513 13.5644 3.50571 14.1434 3.60461C14.6416 3.68974 15.3073 3.83388 15.7928 4.31165C16.2832 4.79456 16.4258 5.45921 16.5086 5.95618C16.6045 6.53158 16.633 6.92405 16.7713 7.26379C16.9068 7.59668 17.1569 7.88142 17.4969 8.35266C17.7933 8.76355 18.1599 9.3295 18.16 10.0323Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$folder = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "folder-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 4.25C2.86193 4.25 2.75 4.36193 2.75 4.5V15C2.75 15.1381 2.86193 15.25 3 15.25H17C17.1381 15.25 17.25 15.1381 17.25 15V7C17.25 6.86193 17.1381 6.75 17 6.75H9.5C9.23655 6.75 8.99242 6.61178 8.85688 6.38587L7.57536 4.25H3ZM1.25 4.5C1.25 3.5335 2.0335 2.75 3 2.75H8C8.26345 2.75 8.50758 2.88822 8.64312 3.11413L9.92464 5.25H17C17.9665 5.25 18.75 6.0335 18.75 7V15C18.75 15.9665 17.9665 16.75 17 16.75H3C2.0335 16.75 1.25 15.9665 1.25 15V4.5Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$folders = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "folders-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4 4.79761C3.86193 4.79761 3.75 4.90954 3.75 5.04761V10.0476C3.75 10.1857 3.86193 10.2976 4 10.2976H12C12.1357 10.2976 12.2463 10.1893 12.2499 10.0548L12.25 10.0476V6.07488C12.25 5.93681 12.1381 5.82488 12 5.82488H8C7.79759 5.82488 7.60377 5.74307 7.46258 5.59803L6.68341 4.79761H4ZM2.25 5.04761C2.25 4.08111 3.0335 3.29761 4 3.29761H7C7.20241 3.29761 7.39623 3.37942 7.53742 3.52446L8.31659 4.32488H12C12.9665 4.32488 13.75 5.10838 13.75 6.07488V6.32488H14C14.9665 6.32488 15.75 7.10838 15.75 8.07488V9.32488H16C16.9665 9.32488 17.75 10.1084 17.75 11.0749V15.0476C17.75 16.0141 16.9665 16.7976 16 16.7976H8C7.0335 16.7976 6.25 16.0141 6.25 15.0476V14.2976H6C5.0335 14.2976 4.25 13.5141 4.25 12.5476V11.7976H4C3.0335 11.7976 2.25 11.0141 2.25 10.0476V5.04761ZM5.75 11.7976V12.5476C5.75 12.6857 5.86193 12.7976 6 12.7976H14C14.1381 12.7976 14.25 12.6857 14.25 12.5476V8.07488C14.25 7.93681 14.1381 7.82488 14 7.82488H13.75V10.0476C13.75 10.0634 13.7498 10.0792 13.7494 10.095C13.7241 11.0398 12.9507 11.7976 12 11.7976H5.75ZM7.75 14.2976V15.0476C7.75 15.1857 7.86193 15.2976 8 15.2976H16C16.1381 15.2976 16.25 15.1857 16.25 15.0476V11.0749C16.25 10.9368 16.1381 10.8249 16 10.8249H15.75V12.5476C15.75 13.5141 14.9665 14.2976 14 14.2976H7.75Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$for_rent = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "for-rent-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.69531 13.0547H5.42383V14H4.5957V11.1816H5.88672C6.58008 11.1816 6.98633 11.5352 6.98633 12.1387C6.98633 12.4707 6.82617 12.791 6.53125 12.9316L7.06641 14H6.14062L5.69531 13.0547ZM5.76758 11.793H5.42383V12.4883H5.76562C5.99805 12.4883 6.14062 12.3555 6.14062 12.1426C6.14062 11.9336 5.99023 11.793 5.76758 11.793Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M8.36523 13.3438H9.52539V14H7.53711V11.1816H9.52539V11.8379H8.36523V12.2949H9.45312V12.8887H8.36523V13.3438Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M10.9121 14V12.5801H10.9512L12.0215 14H12.6582V11.1816H11.877V12.5801H11.8379L10.7734 11.1816H10.1309V14H10.9121Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M14.7695 11.8379V14H13.9414V11.8379H13.1582V11.1816H15.5527V11.8379H14.7695Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.46973 1.46967C9.76262 1.17678 10.2375 1.17678 10.5304 1.46967L15.3107 6.25H18C18.4142 6.25 18.75 6.58579 18.75 7V18C18.75 18.4142 18.4142 18.75 18 18.75H2C1.58579 18.75 1.25 18.4142 1.25 18V7C1.25 6.58579 1.58579 6.25 2 6.25H4.6894L9.46973 1.46967ZM10.0001 3.06066L13.1894 6.25H6.81072L10.0001 3.06066ZM2.75 7.75V17.25H17.25V7.75H2.75Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$form_editor = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "form_editor", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M13.9048 1.50537H3.33792C2.86847 1.50537 2.48792 1.88593 2.48792 2.35537V18.1618C2.48792 18.6312 2.86848 19.0118 3.33792 19.0118H17.1692C17.6386 19.0118 18.0192 18.6312 18.0192 18.1618V5.16828L16.5192 6.67127V17.5118H3.98792V3.00537H12.4078L13.9048 1.50537Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M10.0689 5.34894H6.09915C5.6297 5.34894 5.24915 5.7295 5.24915 6.19894V11.9945C5.24915 12.464 5.6297 12.8445 6.09915 12.8445H14.5091C14.9785 12.8445 15.3591 12.464 15.3591 11.9945V7.83364L13.8591 9.33663V11.3445H6.74915V6.84894H8.64638C8.71195 6.734 8.79286 6.62748 8.8876 6.53255L10.0689 5.34894Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M18.314 2.74945C18.7296 2.31955 18.664 1.58179 18.1679 1.10218C17.6716 0.622337 16.9324 0.581692 16.517 1.01139L9.94932 7.59216L9.71973 9.62805L11.7467 9.32981L18.314 2.74945Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.24915 14.9485C5.24915 14.5342 5.58493 14.1985 5.99915 14.1985H14.7937C15.2079 14.1985 15.5437 14.5342 15.5437 14.9485C15.5437 15.3627 15.2079 15.6985 14.7937 15.6985H5.99915C5.58493 15.6985 5.24915 15.3627 5.24915 14.9485Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$format_strikethrough = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "title-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M8.64062 12.7618V15.4214H10.9702V12.7618H8.64062Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M8.64062 9.26178H10.9702V8.13434H13.6108V6.26178H6V8.13434H8.64062V9.26178Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 11.7618H4V10.2618H16V11.7618Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$gesture = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "gesture-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.89544 6.96841C6.18633 7.27232 5.16463 7.67905 4 7.67905V6.17905C4.83537 6.17905 5.61367 5.88579 6.30456 5.5897C6.36531 5.56366 6.42758 5.5366 6.49056 5.50922C6.75499 5.39429 7.03199 5.27389 7.26165 5.20137C7.40711 5.15543 7.59587 5.10718 7.79531 5.10718C8.00758 5.10718 8.29554 5.16394 8.53033 5.39872C8.69461 5.56301 8.76501 5.75513 8.79699 5.89576C8.82942 6.03831 8.8339 6.17767 8.82956 6.2947C8.82094 6.52751 8.77214 6.78369 8.71344 7.02691C8.59654 7.51118 8.4009 8.09809 8.21892 8.644L8.21151 8.66622C8.19209 8.7245 8.17282 8.78232 8.15377 8.83962C8.1549 8.83848 8.15604 8.83735 8.15717 8.83621C9.16455 7.82884 10.7194 6.67904 13 6.67904C13.4792 6.67904 13.8974 6.7165 14.2265 6.82169C14.5431 6.92287 14.9906 7.16482 15.0865 7.70388C15.1671 8.15636 14.9317 8.5347 14.7819 8.73836C14.6061 8.9775 14.3653 9.21548 14.1137 9.43942C13.6927 9.81418 13.1443 10.2331 12.6009 10.6483C12.4938 10.7301 12.3869 10.8118 12.2811 10.8929C11.6187 11.4016 10.991 11.8991 10.5303 12.3597C9.54203 13.348 8.74801 14.2965 8.37299 14.9616C8.35738 14.9893 8.34285 15.0159 8.32933 15.0414C8.50951 14.9835 8.74638 14.8839 9.05416 14.7294C9.36592 14.5729 9.68383 14.3967 10.0362 14.2015C10.3 14.0553 10.5832 13.8985 10.8975 13.7311C12.288 12.9908 14.053 12.179 16 12.179V13.679C14.447 13.679 12.962 14.3313 11.6025 15.0551C11.3421 15.1937 11.0742 15.3418 10.8112 15.4872C10.4269 15.6997 10.0528 15.9065 9.72709 16.0699C9.18575 16.3417 8.57225 16.6072 8 16.6072C7.74757 16.6072 7.45363 16.5642 7.19367 16.3979C6.90378 16.2124 6.74169 15.9285 6.69385 15.6264C6.65089 15.355 6.70213 15.0939 6.76926 14.8828C6.83887 14.6639 6.9442 14.4416 7.06635 14.2249C7.54488 13.3762 8.45797 12.3108 9.46967 11.299C10.009 10.7597 10.7113 10.2071 11.3676 9.7032C11.4819 9.61549 11.5945 9.52939 11.705 9.44493C12.2492 9.02898 12.7415 8.65268 13.1164 8.319C13.1696 8.27161 13.2185 8.22674 13.2633 8.18435C13.1852 8.18097 13.0977 8.17904 13 8.17904C11.2806 8.17904 10.0855 9.02925 9.21783 9.89687C8.91032 10.2044 8.67066 10.4844 8.4498 10.7424C8.34543 10.8643 8.24527 10.9813 8.14412 11.094C8.01188 11.2414 7.83453 11.4311 7.63996 11.555C7.53956 11.6188 7.36577 11.7109 7.14063 11.7213C6.87618 11.7336 6.63973 11.6294 6.46967 11.4594C6.30539 11.2951 6.23499 11.103 6.20301 10.9623C6.17058 10.8198 6.1661 10.6804 6.17044 10.5634C6.17906 10.3306 6.22786 10.0744 6.28656 9.83119C6.40346 9.34691 6.5991 8.76 6.78108 8.21408L6.78849 8.19188C6.95642 7.68809 7.11249 7.21843 7.21588 6.82997C7.18917 6.84152 7.1616 6.85347 7.13309 6.86583C7.06028 6.89739 6.98139 6.93158 6.89544 6.96841ZM13.6237 7.76994C13.624 7.76986 13.6227 7.77333 13.6188 7.78058C13.6214 7.77365 13.6233 7.77002 13.6237 7.76994ZM7.9347 15.1028C7.93471 15.1028 7.9352 15.1029 7.93612 15.1031Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$gift = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "gift-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.75 7.85718C1.75 6.89068 2.5335 6.10718 3.5 6.10718H16.5C17.4665 6.10718 18.25 6.89068 18.25 7.85718V10.6072C18.25 10.9773 18.0489 11.3005 17.75 11.4734V16.8572C17.75 17.8237 16.9665 18.6072 16 18.6072H4C3.0335 18.6072 2.25 17.8237 2.25 16.8572V11.4734C1.9511 11.3005 1.75 10.9773 1.75 10.6072V7.85718ZM3.5 7.60718C3.36193 7.60718 3.25 7.71911 3.25 7.85718V10.241C3.5489 10.4139 3.75 10.737 3.75 11.1072V16.8572C3.75 16.9952 3.86193 17.1072 4 17.1072H16C16.1381 17.1072 16.25 16.9952 16.25 16.8572V11.1072C16.25 10.737 16.4511 10.4139 16.75 10.241V7.85718C16.75 7.71911 16.6381 7.60718 16.5 7.60718H3.5Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 6.60718C10.4142 6.60718 10.75 6.94296 10.75 7.35718V17.8572C10.75 18.2714 10.4142 18.6072 10 18.6072C9.58579 18.6072 9.25 18.2714 9.25 17.8572V7.35718C9.25 6.94296 9.58579 6.60718 10 6.60718Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.00426 4.87234C5.82843 5.00401 5.75 5.16277 5.75 5.35717C5.75 5.52311 5.80958 5.69844 5.95336 5.83468C6.09345 5.96742 6.39088 6.13538 7.00001 6.13538H8.99392C8.92579 6.03114 8.85219 5.92468 8.77339 5.81868C8.2348 5.09402 7.61807 4.60718 7 4.60718C6.52594 4.60718 6.1958 4.72889 6.00426 4.87234ZM10.2507 6.88538C10.9439 6.59907 10.9437 6.59866 10.9437 6.59866L10.943 6.59699L10.9417 6.59378L10.9376 6.58412L10.9239 6.55218C10.9123 6.52549 10.8957 6.48816 10.8744 6.44172C10.8317 6.34895 10.7694 6.21916 10.6886 6.06459C10.5278 5.75731 10.2887 5.34288 9.97729 4.92389C9.39054 4.13445 8.38193 3.10719 7.00001 3.10718C6.28656 3.10717 5.61669 3.28858 5.10511 3.67169C4.57782 4.06658 4.25 4.65782 4.25 5.35717C4.25 5.87873 4.44042 6.46751 4.92164 6.9235C5.40655 7.38299 6.10912 7.63538 7.00001 7.63538H10.2502L10.2507 6.88538ZM10.2507 6.88538L10.2502 7.63538C10.5005 7.63538 10.7349 7.51046 10.8741 7.30237C11.0133 7.09429 11.0393 6.83005 10.9437 6.59866L10.2507 6.88538Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.2464 4.87234C14.4223 5.00401 14.5007 5.16277 14.5007 5.35717C14.5007 5.52311 14.4411 5.69844 14.2973 5.83468C14.1572 5.96742 13.8598 6.13538 13.2507 6.13538H11.2568C11.3249 6.03114 11.3985 5.92468 11.4773 5.81868C12.0159 5.09402 12.6326 4.60718 13.2507 4.60718C13.7247 4.60718 14.0549 4.72889 14.2464 4.87234ZM10 6.88538C9.3068 6.59907 9.30697 6.59866 9.30697 6.59866L9.30766 6.59699L9.309 6.59378L9.31307 6.58412L9.3268 6.55218C9.33841 6.52549 9.35496 6.48816 9.37633 6.44172C9.41902 6.34895 9.48125 6.21916 9.5621 6.06459C9.72284 5.75731 9.96198 5.34288 10.2734 4.92389C10.8601 4.13445 11.8688 3.10719 13.2507 3.10718C13.9641 3.10717 14.634 3.28858 15.1456 3.67169C15.6729 4.06658 16.0007 4.65782 16.0007 5.35717C16.0007 5.87873 15.8103 6.46751 15.3291 6.9235C14.8441 7.38299 14.1416 7.63538 13.2507 7.63538H10.0005L10 6.88538ZM10 6.88538L10.0005 7.63538C9.75015 7.63538 9.51581 7.51046 9.37661 7.30237C9.23742 7.09429 9.2114 6.83005 9.30697 6.59866L10 6.88538Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.25 10.8572C2.25 10.443 2.58579 10.1072 3 10.1072L17 10.1072C17.4142 10.1072 17.75 10.443 17.75 10.8572C17.75 11.2714 17.4142 11.6072 17 11.6072L3 11.6072C2.58579 11.6072 2.25 11.2714 2.25 10.8572Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$headphones = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "headphones-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 3.41669C7.1005 3.41669 4.75 5.76719 4.75 8.66669H3.25C3.25 4.93876 6.27208 1.91669 10 1.91669C13.7279 1.91669 16.75 4.93876 16.75 8.66669H15.25C15.25 5.76719 12.8995 3.41669 10 3.41669Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.25 10.6667C1.25 9.1479 2.48122 7.91669 4 7.91669H5C5.41421 7.91669 5.75 8.25247 5.75 8.66669V14.1667C5.75 14.5809 5.41421 14.9167 5 14.9167H4C2.48122 14.9167 1.25 13.6855 1.25 12.1667V10.6667ZM4 9.41669C3.30964 9.41669 2.75 9.97633 2.75 10.6667V12.1667C2.75 12.857 3.30964 13.4167 4 13.4167H4.25V9.41669H4Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.75 10.6667C18.75 9.1479 17.5188 7.91669 16 7.91669H15C14.5858 7.91669 14.25 8.25247 14.25 8.66669V14.1667C14.25 14.5809 14.5858 14.9167 15 14.9167H16C17.5188 14.9167 18.75 13.6855 18.75 12.1667V10.6667ZM16 9.41669C16.6904 9.41669 17.25 9.97633 17.25 10.6667V12.1667C17.25 12.857 16.6904 13.4167 16 13.4167H15.75V9.41669H16Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.25 15.6667V14.6667H4.75V15.6667C4.75 16.357 5.30964 16.9167 6 16.9167H10V18.4167H6C4.48122 18.4167 3.25 17.1855 3.25 15.6667Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M8 17.6667C8 16.8383 8.67157 16.1667 9.5 16.1667H11.5C12.3284 16.1667 13 16.8383 13 17.6667C13 18.4951 12.3284 19.1667 11.5 19.1667H9.5C8.67157 19.1667 8 18.4951 8 17.6667Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$heart = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "heart-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        // eslint-disable-next-line max-len
        d: "M6.625 3.75C4.73751 3.75 3.25 5.24457 3.25 7.19619C3.25 8.39394 3.77365 9.53901 4.84246 10.8692C5.92004 12.2103 7.47513 13.6485 9.42105 15.4455C9.42114 15.4456 9.42096 15.4454 9.42105 15.4455L10 15.9796L10.5787 15.4457C12.5247 13.6487 14.0799 12.2103 15.1575 10.8692C16.2264 9.53901 16.75 8.39394 16.75 7.19619C16.75 5.24457 15.2625 3.75 13.375 3.75C12.3017 3.75 11.2559 4.26208 10.5742 5.07326C10.4317 5.24283 10.2215 5.34074 10 5.34074C9.77851 5.34074 9.56834 5.24283 9.42583 5.07326C8.74412 4.26208 7.69827 3.75 6.625 3.75ZM1.75 7.19619C1.75 4.44044 3.88499 2.25 6.625 2.25C7.87932 2.25 9.08195 2.73227 10 3.52636C10.918 2.73227 12.1207 2.25 13.375 2.25C16.115 2.25 18.25 4.44044 18.25 7.19619C18.25 8.87854 17.4986 10.3504 16.3268 11.8087C15.1723 13.2455 13.5369 14.7558 11.6383 16.5089L11.5963 16.5477L10.5086 17.5512C10.2213 17.8163 9.7787 17.8163 9.49145 17.5512L8.36165 16.5089C6.4631 14.7558 4.82765 13.2455 3.67316 11.8087C2.50135 10.3504 1.75 8.87854 1.75 7.19619Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$home = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "home-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        // eslint-disable-next-line max-len
        d: "M9.50612 3.43557C9.78889 3.18814 10.2111 3.18814 10.4939 3.43557L16.4939 8.68557C16.6566 8.82798 16.75 9.03373 16.75 9.25V16C16.75 16.4142 16.4142 16.75 16 16.75H4C3.58579 16.75 3.25 16.4142 3.25 16V9.25C3.25 9.03373 3.34336 8.82798 3.50612 8.68557L9.50612 3.43557ZM4.75 9.59033V15.25H15.25V9.59033L10 4.99658L4.75 9.59033Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$home_chart = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "home-chart-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.50922 1.43287C9.79098 1.18904 10.209 1.18904 10.4908 1.43287L17.4908 7.49057C17.6554 7.63303 17.75 7.83999 17.75 8.05769V17C17.75 17.4142 17.4142 17.75 17 17.75H3C2.58579 17.75 2.25 17.4142 2.25 17V8.05769C2.25 7.83999 2.3446 7.63303 2.50922 7.49057L9.50922 1.43287ZM3.75 8.4005V16.25H16.25V8.4005L10 2.99184L3.75 8.4005Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.25 14L9.25 8H10.75V14H9.25Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.25 14V9H13.75V14H12.25Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.25 14V10H7.75V14H6.25Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$home_checkmark = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "home-checkmark-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("g", {
        clipPath: "url(#clip0_2_186)"
    }, $e959f086e329e090$var$React__default["default"].createElement("g", {
        filter: "url(#filter0_d_2_186)"
    }, $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.50922 1.43287C9.79098 1.18904 10.209 1.18904 10.4908 1.43287L17.4908 7.49057C17.6554 7.63303 17.75 7.83999 17.75 8.05769V17C17.75 17.4142 17.4142 17.75 17 17.75H3C2.58579 17.75 2.25 17.4142 2.25 17V8.05769C2.25 7.83999 2.3446 7.63303 2.50922 7.49057L9.50922 1.43287ZM3.75 8.4005V16.25H16.25V8.4005L10 2.99184L3.75 8.4005Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.5146 8.4544C13.8159 8.7386 13.8298 9.21328 13.5456 9.5146L9.77288 13.5146C9.49689 13.8072 9.03921 13.83 8.73551 13.5663L7.00823 12.0663C6.69549 11.7947 6.66213 11.321 6.93373 11.0082C7.20532 10.6955 7.67902 10.6621 7.99177 10.9337L9.17556 11.9618L12.4544 8.4854C12.7386 8.18407 13.2133 8.17019 13.5146 8.4544Z",
        fill: "#4B5563"
    }))), $e959f086e329e090$var$React__default["default"].createElement("defs", null, $e959f086e329e090$var$React__default["default"].createElement("filter", {
        id: "filter0_d_2_186",
        x: "-5.75",
        y: "-2.75",
        width: "31.5",
        height: "32.5",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, $e959f086e329e090$var$React__default["default"].createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), $e959f086e329e090$var$React__default["default"].createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), $e959f086e329e090$var$React__default["default"].createElement("feOffset", {
        dy: "4"
    }), $e959f086e329e090$var$React__default["default"].createElement("feGaussianBlur", {
        stdDeviation: "4"
    }), $e959f086e329e090$var$React__default["default"].createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
    }), $e959f086e329e090$var$React__default["default"].createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_2_186"
    }), $e959f086e329e090$var$React__default["default"].createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect1_dropShadow_2_186",
        result: "shape"
    })), $e959f086e329e090$var$React__default["default"].createElement("clipPath", {
        id: "clip0_2_186"
    }, $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M0 2C0 0.895431 0.895431 0 2 0H18C19.1046 0 20 0.895431 20 2V18C20 19.1046 19.1046 20 18 20H2C0.895431 20 0 19.1046 0 18V2Z",
        fill: "white"
    }))));
};
const $e959f086e329e090$var$home_dollar = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "home-dollar-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.2812 14.624H9.77588V13.9253C8.54102 13.855 7.64453 13.209 7.61377 12.1104H8.7915C8.86182 12.5586 9.17822 12.8706 9.77588 12.9365V11.3325L9.48145 11.2622C8.33447 11.0029 7.70166 10.4888 7.70166 9.53955C7.70166 8.48926 8.56738 7.80811 9.77588 7.7334V7.02148H10.2812V7.73779C11.5029 7.82568 12.2939 8.51123 12.3379 9.54834H11.1646C11.103 9.07373 10.7734 8.80127 10.2812 8.73096V10.2822L10.5933 10.3481C11.793 10.6206 12.4214 11.104 12.4214 12.0664C12.4214 13.1694 11.5293 13.8374 10.2812 13.9209V14.624ZM9.77588 8.72217C9.22217 8.78809 8.93213 9.07373 8.93213 9.42529C8.93213 9.77686 9.18262 10.0054 9.77588 10.1636V8.72217ZM10.2812 12.9365C10.8921 12.875 11.1953 12.6025 11.1953 12.2026C11.1953 11.8159 10.9624 11.6182 10.2812 11.4468V12.9365Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.4908 1.43287C10.209 1.18904 9.79098 1.18904 9.50922 1.43287L2.50922 7.49057C2.3446 7.63303 2.25 7.83999 2.25 8.05769V17C2.25 17.4142 2.58579 17.75 3 17.75H17C17.4142 17.75 17.75 17.4142 17.75 17V8.05769C17.75 7.83999 17.6554 7.63303 17.4908 7.49057L10.4908 1.43287ZM3.75 16.25V8.4005L10 2.99184L16.25 8.4005V16.25H3.75Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$home_heart = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "home-heart-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.50922 1.43287C9.79098 1.18904 10.209 1.18904 10.4908 1.43287L17.4908 7.49057C17.6554 7.63303 17.75 7.83999 17.75 8.05769V17C17.75 17.4142 17.4142 17.75 17 17.75H3C2.58579 17.75 2.25 17.4142 2.25 17V8.05769C2.25 7.83999 2.3446 7.63303 2.50922 7.49057L9.50922 1.43287ZM3.75 8.4005V16.25H16.25V8.4005L10 2.99184L3.75 8.4005Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 14L9.565 13.57C8.02 12.0414 7 11.0327 7 9.79836C7 8.78965 7.7245 8 8.65 8C9.172 8 9.673 8.26485 10 8.68174C10.327 8.26485 10.828 8 11.35 8C12.2755 8 13 8.78965 13 9.79836C13 11.0327 11.98 12.0414 10.435 13.57L10 14Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$home_multi = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "home-multi-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.4939 3.43557C10.2111 3.18814 9.78889 3.18814 9.50612 3.43557L3.50612 8.68557C3.34336 8.82798 3.25 9.03373 3.25 9.25V16C3.25 16.4142 3.58579 16.75 4 16.75H16C16.4142 16.75 16.75 16.4142 16.75 16V9.25C16.75 9.03373 16.6566 8.82798 16.4939 8.68557L10.4939 3.43557ZM4.75 15.25V9.59033L9.25 5.65283L9.25 15.25H4.75ZM10.75 15.25H15.25V9.59033L10.75 5.65283L10.75 15.25Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$home_percentage = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "home-percentage-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.50922 1.43287C9.79098 1.18904 10.209 1.18904 10.4908 1.43287L17.4908 7.49057C17.6554 7.63303 17.75 7.83999 17.75 8.05769V17C17.75 17.4142 17.4142 17.75 17 17.75H3C2.58579 17.75 2.25 17.4142 2.25 17V8.05769C2.25 7.83999 2.3446 7.63303 2.50922 7.49057L9.50922 1.43287ZM3.75 8.4005V16.25H16.25V8.4005L10 2.99184L3.75 8.4005Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M7.61816 10.7085C8.65967 10.7085 9.25732 10.1284 9.25732 9.11328C9.25732 8.12891 8.6377 7.53125 7.61816 7.53125C6.60742 7.53125 5.9834 8.1377 5.9834 9.11328C5.9834 10.1284 6.58545 10.7085 7.61816 10.7085ZM8.6377 14L12.6851 7.65869H11.3667L7.31934 14H8.6377ZM7.61816 9.75049C7.4248 9.75049 7.30615 9.52197 7.30615 9.11768C7.30615 8.73535 7.43359 8.48926 7.61816 8.48926C7.80713 8.48926 7.93018 8.73535 7.93018 9.11768C7.93018 9.51758 7.81592 9.75049 7.61816 9.75049ZM12.3818 14.0835C13.4233 14.0835 14.0166 13.5034 14.0166 12.4883C14.0166 11.5039 13.4014 10.9062 12.3818 10.9062C11.3711 10.9062 10.7471 11.5127 10.7471 12.4883C10.7471 13.5034 11.3447 14.0835 12.3818 14.0835ZM12.3818 13.1255C12.1841 13.1255 12.0698 12.897 12.0698 12.4927C12.0698 12.1104 12.1929 11.8643 12.3818 11.8643C12.5708 11.8643 12.6938 12.1104 12.6938 12.4927C12.6938 12.8926 12.5796 13.1255 12.3818 13.1255Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$import_icon = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "import-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.25 4.4762C11.25 4.06198 11.5858 3.7262 12 3.7262H15.5C16.1904 3.7262 16.75 4.28584 16.75 4.9762V15.9762C16.75 16.6666 16.1904 17.2262 15.5 17.2262H12C11.5858 17.2262 11.25 16.8904 11.25 16.4762C11.25 16.062 11.5858 15.7262 12 15.7262H15.25V5.2262H12C11.5858 5.2262 11.25 4.89041 11.25 4.4762ZM9.01986 6.90003C9.33807 6.63486 9.81099 6.67785 10.0762 6.99606L12.5762 9.99606C12.8079 10.2742 12.8079 10.6782 12.5762 10.9563L10.0762 13.9563C9.81099 14.2745 9.33807 14.3175 9.01986 14.0524C8.70165 13.7872 8.65866 13.3143 8.92383 12.9961L10.3987 11.2262H4C3.58579 11.2262 3.25 10.8904 3.25 10.4762C3.25 10.062 3.58579 9.7262 4 9.7262H10.3987L8.92383 7.95633C8.65866 7.63813 8.70165 7.1652 9.01986 6.90003Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$inbox = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "inbox-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 3C10.4142 3 10.75 3.33579 10.75 3.75L10.75 7.06967V11.3893L12.4697 9.66967C12.7626 9.37678 13.2374 9.37678 13.5303 9.66967C13.8232 9.96256 13.8232 10.4374 13.5303 10.7303L10 14.2607L6.46967 10.7303C6.17678 10.4374 6.17678 9.96256 6.46967 9.66967C6.76256 9.37678 7.23744 9.37678 7.53033 9.66967L9.25 11.3893L9.25 3.75C9.25 3.33579 9.58579 3 10 3ZM3 11C3.41421 11 3.75 11.3358 3.75 11.75V16H16.25V11.75C16.25 11.3358 16.5858 11 17 11C17.4142 11 17.75 11.3358 17.75 11.75V16.75C17.75 17.1643 17.4142 17.5 17 17.5H3C2.58579 17.5 2.25 17.1643 2.25 16.75V11.75C2.25 11.3358 2.58579 11 3 11Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$key = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "key-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.07949 2.49178C4.03718 2.72341 3.22316 3.53743 2.99153 4.57974L2.50579 6.76557C2.30183 7.68341 2.58092 8.64183 3.24576 9.30667L5.17653 11.2374C6.25047 12.3114 7.99168 12.3114 9.06562 11.2374L9.1212 11.1819L10.2626 12.3232C10.5258 12.5865 10.8795 12.7386 11.2506 12.7494C11.2614 13.1205 11.4135 13.4742 11.6768 13.7374L13.1768 15.2374C13.4677 15.5284 13.8506 15.7063 14.2571 15.7429C14.2937 16.1494 14.4716 16.5323 14.7626 16.8232L15.2556 17.3162C15.4999 17.5605 15.811 17.7271 16.1498 17.7948L17.1029 17.9854C18.2224 18.2093 19.2093 17.2224 18.9854 16.1029L18.7948 15.1498C18.7276 14.8135 18.5646 14.5039 18.3185 14.2578L12.1308 8.07012C12.7893 7.00937 12.6581 5.59773 11.7372 4.67678L9.80642 2.74601C9.14158 2.08117 8.18316 1.80208 7.26532 2.00604L5.07949 2.49178ZM4.45581 4.90513C4.5611 4.43136 4.93111 4.06135 5.40488 3.95606L7.59072 3.47032C8.00791 3.37761 8.44356 3.50447 8.74576 3.80667L10.6765 5.73744C11.1647 6.2256 11.1647 7.01705 10.6765 7.50521L8.00496 10.1768C7.5168 10.6649 6.72534 10.6649 6.23719 10.1768L4.30642 8.24601C4.00422 7.94381 3.87736 7.50817 3.97007 7.09097L4.45581 4.90513ZM11.1212 9.18186L10.1819 10.1212L11.3108 11.2501C12.1013 11.2596 12.7404 11.8987 12.7499 12.6892L14.2374 14.1768C14.2843 14.2237 14.3479 14.25 14.4142 14.25H15.75V15.5858C15.75 15.6521 15.7763 15.7157 15.8232 15.7626L16.3162 16.2556C16.3511 16.2905 16.3956 16.3143 16.444 16.3239L17.3971 16.5146C17.4669 16.5285 17.5285 16.4669 17.5146 16.3971L17.3239 15.444C17.3138 15.3931 17.291 15.3516 17.2578 15.3185L11.1212 9.18186Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M7.5 6C7.5 6.55228 7.05229 7 6.5 7C5.94772 7 5.5 6.55228 5.5 6C5.5 5.44771 5.94772 5 6.5 5C7.05229 5 7.5 5.44771 7.5 6Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$key_hand = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "key-hand-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.2738 12.0357C13.1738 12.0357 14.0371 12.3926 14.6745 13.0281L15.9597 14.3096C16.253 14.602 16.7279 14.6014 17.0204 14.308C17.3128 14.0147 17.3121 13.5398 17.0188 13.2474L15.7336 11.9659C14.8151 11.05 13.5709 10.5357 12.2738 10.5357H8.66972C8.13513 10.5357 7.64077 10.7787 7.33309 11.1804C7.01429 11.5966 6.90984 12.1738 7.16865 12.7253C7.65875 13.7697 8.6863 15.0357 10.4893 15.0357H12.2446C12.6588 15.0357 12.9946 14.6999 12.9946 14.2857C12.9946 13.8715 12.6588 13.5357 12.2446 13.5357H10.4893C9.52456 13.5357 8.90155 12.8867 8.52693 12.0888C8.54439 12.0691 8.59144 12.0357 8.66972 12.0357H12.2738Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.28104 10.6659C5.78682 10.254 5.16385 10.0285 4.52053 10.0285H4.24498C2.62171 10.0285 1.74598 11.9325 2.80239 13.165L5.9779 16.8697C6.88032 17.9226 8.19773 18.5285 9.58437 18.5285H16.2446C16.6588 18.5285 16.9946 18.1927 16.9946 17.7785C16.9946 17.3643 16.6588 17.0285 16.2446 17.0285H9.58437C8.63561 17.0285 7.73423 16.6139 7.11679 15.8935L3.94128 12.1888C3.71888 11.9293 3.90324 11.5285 4.24498 11.5285H4.52053C4.81295 11.5285 5.09612 11.631 5.32076 11.8182L8 14C8.31821 14.2652 8.79113 14.2222 9.0563 13.904C9.32148 13.5858 9.27848 13.1128 8.96028 12.8477L6.28104 10.6659Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M6.61785 5.06826C7.01027 5.45688 7.01336 6.09003 6.62474 6.48246C6.23613 6.87488 5.60297 6.87797 5.21055 6.48936C4.81812 6.10074 4.81503 5.46758 5.20365 5.07516C5.59227 4.68273 6.22542 4.67965 6.61785 5.06826Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.67703 4.03571C4.57481 4.03571 4.48288 4.09794 4.44491 4.19286L3.80777 5.78571L4.44491 7.37855C4.48288 7.47347 4.57481 7.53571 4.67703 7.53571H7.5C7.63807 7.53571 7.75 7.42378 7.75 7.28571C7.75 6.87149 8.08579 6.53571 8.5 6.53571C8.91421 6.53571 9.25 6.87149 9.25 7.28571C9.25 8.2522 8.4665 9.03571 7.5 9.03571H4.67703C3.96145 9.03571 3.31796 8.60004 3.0522 7.93564L2.30364 6.06425C2.23212 5.88544 2.23212 5.68597 2.30364 5.50716L3.0522 3.63577C3.31796 2.97137 3.96145 2.53571 4.67703 2.53571H7.5C8.4665 2.53571 9.25 3.31921 9.25 4.28571C9.25 4.69992 8.91421 5.03571 8.5 5.03571C8.08579 5.03571 7.75 4.69992 7.75 4.28571C7.75 4.14763 7.63807 4.03571 7.5 4.03571H4.67703Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 4.28571C7.75 3.87149 8.08579 3.53571 8.5 3.53571H16C16.2508 3.53571 16.4849 3.66103 16.624 3.86968L17.624 5.36968C17.8448 5.70088 17.7684 6.14688 17.45 6.38571L15.45 7.88571C15.1514 8.10965 14.7336 8.07995 14.4697 7.81604L14 7.34637L13.5303 7.81604C13.2374 8.10893 12.7626 8.10893 12.4697 7.81604L12 7.34637L11.5303 7.81604C11.3897 7.95669 11.1989 8.03571 11 8.03571H8.5C8.08579 8.03571 7.75 7.69992 7.75 7.28571C7.75 6.87149 8.08579 6.53571 8.5 6.53571H10.6893L11.4697 5.75538C11.7626 5.46248 12.2374 5.46248 12.5303 5.75538L13 6.22505L13.4697 5.75538C13.7626 5.46248 14.2374 5.46248 14.5303 5.75538L15.0704 6.29542L15.9824 5.6114L15.5986 5.03571H8.5C8.08579 5.03571 7.75 4.69992 7.75 4.28571Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$launch = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "launch-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 3.34521C16.4142 3.34521 16.75 3.681 16.75 4.09521V8.09521C16.75 8.50943 16.4142 8.84521 16 8.84521C15.5858 8.84521 15.25 8.50943 15.25 8.09521V5.90587L9.53033 11.6255C9.23744 11.9184 8.76256 11.9184 8.46967 11.6255C8.17678 11.3327 8.17678 10.8578 8.46967 10.5649L14.1893 4.84521L12 4.84521C11.5858 4.84521 11.25 4.50943 11.25 4.09521C11.25 3.681 11.5858 3.34521 12 3.34521H16Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.25 6.09521C3.25 5.681 3.58579 5.34521 4 5.34521H9C9.41421 5.34521 9.75 5.681 9.75 6.09521C9.75 6.50943 9.41421 6.84521 9 6.84521H4.75V15.3452H13.25V11.0952C13.25 10.681 13.5858 10.3452 14 10.3452C14.4142 10.3452 14.75 10.681 14.75 11.0952V16.0952C14.75 16.5094 14.4142 16.8452 14 16.8452H4C3.58579 16.8452 3.25 16.5094 3.25 16.0952V6.09521Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$lightbulb = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "lightbulb-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M7 15H13L12.6325 16.1026C12.2548 17.2357 11.1944 18 10 18C8.80562 18 7.74524 17.2357 7.36754 16.1026L7 15Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.9189 13.5L12.5096 11.7277C12.6276 11.3739 12.8262 11.0525 13.0899 10.7888L13.4345 10.4442C14.1167 9.76195 14.5 8.83665 14.5 7.87183C14.5 5.45734 12.5427 3.5 10.1282 3.5H9.87183C7.45734 3.5 5.5 5.45734 5.5 7.87183C5.5 8.83665 5.88327 9.76195 6.5655 10.4442L6.03517 10.9745L5.50484 11.5048C4.54131 10.5413 4 9.23448 4 7.87183C4 4.62891 6.62891 2 9.87183 2H10.1282C13.3711 2 16 4.62891 16 7.87183C16 9.23448 15.4587 10.5413 14.4952 11.5048L14.1506 11.8494C14.0516 11.9484 13.9769 12.0692 13.9327 12.202L13 15H7L6.06734 12.202C6.02305 12.0692 5.94845 11.9484 5.84942 11.8494L5.50484 11.5048L6.03517 10.9745L6.5655 10.4442L6.91009 10.7888C7.17377 11.0525 7.37244 11.3739 7.49036 11.7277L8.08114 13.5H11.9189Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$line_chart = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "line-chart-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.5 4.5V15.5H16.5V4.5H3.5ZM3 3C2.44772 3 2 3.44772 2 4V16C2 16.5523 2.44772 17 3 17H17C17.5523 17 18 16.5523 18 16V4C18 3.44772 17.5523 3 17 3H3Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M15.5 8.25C15.5 8.94036 14.9404 9.5 14.25 9.5C13.5596 9.5 13 8.94036 13 8.25C13 7.55964 13.5596 7 14.25 7C14.9404 7 15.5 7.55964 15.5 8.25Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M12.1362 9.02279L9.75 11.409L7.78033 9.43934C7.48744 9.14645 7.01257 9.14645 6.71967 9.43934L4.21967 11.9393C3.92678 12.2322 3.92678 12.7071 4.21967 13C4.51256 13.2929 4.98744 13.2929 5.28033 13L7.25 11.0303L9.21967 13C9.51257 13.2929 9.98744 13.2929 10.2803 13L13.0975 10.1828C12.6575 9.91987 12.3147 9.51089 12.1362 9.02279Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M13.0035 8.1555L13.2197 7.93934C13.5126 7.64645 13.9874 7.64645 14.2803 7.93934C14.5732 8.23223 14.5732 8.70711 14.2803 9L13.8468 9.43354C13.3543 9.2658 13 8.79927 13 8.25C13 8.21821 13.0012 8.18669 13.0035 8.1555Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$link = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "link-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.99238 13.6896L8.76256 13.9194C7.2981 15.3839 4.92373 15.3839 3.45926 13.9194C1.9948 12.455 1.9948 10.0806 3.45926 8.61612L6.28769 5.7877C7.57054 4.50485 9.55159 4.34575 11.0076 5.31041L11.2374 5.08059C12.7019 3.61612 15.0763 3.61612 16.5407 5.08059C18.0052 6.54505 18.0052 8.91942 16.5407 10.3839L13.7123 13.2123C12.4295 14.4952 10.4484 14.6543 8.99238 13.6896ZM9.47065 12.1526C10.3494 13.0303 11.7733 13.03 12.6516 12.1517L15.4801 9.32323C16.3588 8.44455 16.3588 7.01993 15.4801 6.14125C14.6014 5.26257 13.1768 5.26257 12.2981 6.14125L12.0683 6.37107C13.0329 7.82709 12.8738 9.80815 11.591 11.091L10.8839 11.7981C10.591 12.091 10.1161 12.091 9.82322 11.7981C9.53033 11.5052 9.53033 11.0303 9.82322 10.7374L10.5303 10.0303C11.409 9.15166 11.409 7.72704 10.5303 6.84836C10.5301 6.84812 10.5299 6.84789 10.5296 6.84766C9.6509 5.96968 8.2268 5.96991 7.34835 6.84836L4.51992 9.67678C3.64124 10.5555 3.64124 11.9801 4.51992 12.8588C5.3986 13.7374 6.82323 13.7374 7.7019 12.8588L7.93172 12.6289C6.96707 11.1729 7.12616 9.19186 8.40901 7.90902L9.11612 7.20191C9.40901 6.90902 9.88388 6.90902 10.1768 7.20191C10.4697 7.4948 10.4697 7.96968 10.1768 8.26257L9.46967 8.96968C8.59099 9.84835 8.59099 11.273 9.46967 12.1517C9.47 12.152 9.47033 12.1523 9.47065 12.1526Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$list = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "list-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.25 4C3.25 3.58579 3.58579 3.25 4 3.25H16.013C16.4272 3.25 16.763 3.58579 16.763 4C16.763 4.41421 16.4272 4.75 16.013 4.75H4C3.58579 4.75 3.25 4.41421 3.25 4ZM3.25 8C3.25 7.58579 3.58579 7.25 4 7.25H16.013C16.4272 7.25 16.763 7.58579 16.763 8C16.763 8.41421 16.4272 8.75 16.013 8.75H4C3.58579 8.75 3.25 8.41421 3.25 8ZM3.25 12C3.25 11.5858 3.58579 11.25 4 11.25H16.013C16.4272 11.25 16.763 11.5858 16.763 12C16.763 12.4142 16.4272 12.75 16.013 12.75H4C3.58579 12.75 3.25 12.4142 3.25 12ZM3.25 16C3.25 15.5858 3.58579 15.25 4 15.25H16.013C16.4272 15.25 16.763 15.5858 16.763 16C16.763 16.4142 16.4272 16.75 16.013 16.75H4C3.58579 16.75 3.25 16.4142 3.25 16Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$list_reorder = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "list-reorder-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.25 7.09521C3.25 6.681 3.58579 6.34521 4 6.34521H16.013C16.4272 6.34521 16.763 6.681 16.763 7.09521C16.763 7.50943 16.4272 7.84521 16.013 7.84521H4C3.58579 7.84521 3.25 7.50943 3.25 7.09521ZM3.25 10.0952C3.25 9.681 3.58579 9.34521 4 9.34521H16.013C16.4272 9.34521 16.763 9.681 16.763 10.0952C16.763 10.5094 16.4272 10.8452 16.013 10.8452H4C3.58579 10.8452 3.25 10.5094 3.25 10.0952ZM3.25 13.0952C3.25 12.681 3.58579 12.3452 4 12.3452H16.013C16.4272 12.3452 16.763 12.681 16.763 13.0952C16.763 13.5094 16.4272 13.8452 16.013 13.8452H4C3.58579 13.8452 3.25 13.5094 3.25 13.0952Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$location = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "location-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.23779 11.0124L10.0787 16.058L16.1755 4.07465L4.19215 10.1715L9.23779 11.0124ZM7.93434 12.3159L8.84894 17.8035C9.00757 18.7553 10.2891 18.9525 10.7266 18.0925L18.2088 3.38609C18.6478 2.52323 17.727 1.60236 16.8641 2.04136L2.15766 9.52358C1.29764 9.96113 1.49492 11.2426 2.44672 11.4013L7.93434 12.3159Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$lock = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "lock-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M11.5 12.5C11.5 13.3284 10.8284 14 10 14C9.17157 14 8.5 13.3284 8.5 12.5C8.5 11.6716 9.17157 11 10 11C10.8284 11 11.5 11.6716 11.5 12.5Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 8.75C6.30964 8.75 5.75 9.30964 5.75 10V15C5.75 15.6904 6.30964 16.25 7 16.25H13C13.6904 16.25 14.25 15.6904 14.25 15V10C14.25 9.30964 13.6904 8.75 13 8.75H7ZM4.25 10C4.25 8.48122 5.48122 7.25 7 7.25H13C14.5188 7.25 15.75 8.48122 15.75 10V15C15.75 16.5188 14.5188 17.75 13 17.75H7C5.48122 17.75 4.25 16.5188 4.25 15V10Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 3.75C8.75736 3.75 7.75 4.75736 7.75 6V8H6.25V6C6.25 3.92893 7.92893 2.25 10 2.25C12.0711 2.25 13.75 3.92893 13.75 6V8H12.25V6C12.25 4.75736 11.2426 3.75 10 3.75Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$lock_unlock = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "lock-unlock-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.75 10.4048C6.05964 10.4048 5.5 10.9644 5.5 11.6548V15.6548C5.5 16.3451 6.05964 16.9048 6.75 16.9048H12.75C13.4404 16.9048 14 16.3451 14 15.6548V11.6548C14 10.9644 13.4404 10.4048 12.75 10.4048H6.75ZM4 11.6548C4 10.136 5.23122 8.90479 6.75 8.90479H12.75C14.2688 8.90479 15.5 10.136 15.5 11.6548V15.6548C15.5 17.1736 14.2688 18.4048 12.75 18.4048H6.75C5.23122 18.4048 4 17.1736 4 15.6548V11.6548Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M7.5 5.65479C7.5 4.41214 8.50736 3.40479 9.75 3.40479C10.9926 3.40479 12 4.41214 12 5.65479V9.40479H13.5V5.65479C13.5 3.58372 11.8211 1.90479 9.75 1.90479C7.67893 1.90479 6 3.58372 6 5.65479V5.90479C6 6.18093 6.22386 6.40479 6.5 6.40479H7C7.27614 6.40479 7.5 6.18093 7.5 5.90479V5.65479Z",
        fill: "#4B5563"
    })));
};
const $e959f086e329e090$var$lockbox = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "lockbox-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M9 11C9 11.5523 8.55228 12 8 12C7.44772 12 7 11.5523 7 11C7 10.4477 7.44772 10 8 10C8.55228 10 9 10.4477 9 11Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M9 15C9 15.5523 8.55228 16 8 16C7.44772 16 7 15.5523 7 15C7 14.4477 7.44772 14 8 14C8.55228 14 9 14.4477 9 15Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M12 12C12.5523 12 13 11.5523 13 11C13 10.4477 12.5523 10 12 10C11.4477 10 11 10.4477 11 11C11 11.5523 11.4477 12 12 12Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M13 15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15C11 14.4477 11.4477 14 12 14C12.5523 14 13 14.4477 13 15Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.25 7.25V5C6.25 2.92893 7.92893 1.25 10 1.25C12.0711 1.25 13.75 2.92893 13.75 5V7.25H15C15.4142 7.25 15.75 7.58579 15.75 8V18C15.75 18.4142 15.4142 18.75 15 18.75H5C4.58579 18.75 4.25 18.4142 4.25 18V8C4.25 7.58579 4.58579 7.25 5 7.25H6.25ZM7.75 5C7.75 3.75736 8.75736 2.75 10 2.75C11.2426 2.75 12.25 3.75736 12.25 5V7.25H7.75V5ZM5.75 17.25V8.75H14.25V17.25H5.75Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$lot = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "lot-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17 17.75V2.25C17 1.83579 16.6642 1.5 16.25 1.5H4.25C3.83579 1.5 3.5 1.83579 3.5 2.25V17.75C3.5 18.1642 3.83579 18.5 4.25 18.5H16.25C16.4489 18.5 16.6397 18.421 16.7803 18.2803C16.921 18.1397 17 17.9489 17 17.75ZM13.1998 10.5785L5.62122 3L15.5 3V8.29688L13.1998 10.5785ZM5 4.5001L12.1391 11.6392L6.77829 17H5L5 4.5001ZM15.4852 17H15.5V16.9852L15.4852 17ZM13.4999 17L11.1998 14.6999L8.89961 17H13.4999ZM12.2604 13.6392L15.5 10.3996V16.8788L12.2604 13.6392Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$map = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "map-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        // eslint-disable-next-line max-len
        d: "M1.5523 2.39829C1.74251 2.25677 1.98843 2.21351 2.21551 2.28164L7.01807 3.72241L12.8181 2.2724C12.949 2.23968 13.0863 2.24287 13.2155 2.28164L18.2155 3.78164C18.5327 3.87681 18.75 4.1688 18.75 4.50001V17C18.75 17.2371 18.6379 17.4602 18.4477 17.6017C18.2575 17.7432 18.0116 17.7865 17.7845 17.7184L12.9819 16.2776L7.1819 17.7276C7.05101 17.7603 6.91372 17.7571 6.78449 17.7184L1.78449 16.2184C1.46725 16.1232 1.25 15.8312 1.25 15.5V3.00001C1.25 2.76293 1.36209 2.53981 1.5523 2.39829ZM13.75 14.942L17.25 15.992V5.05803L13.75 4.00803V14.942ZM12.25 3.96059V14.9144L7.75 16.0394V5.08559L12.25 3.96059ZM6.25 5.05803L2.75 4.00803V14.942L6.25 15.992V5.05803Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$map_area = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "map_area-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        // eslint-disable-next-line max-len
        d: "M3 2.75C2.86193 2.75 2.75 2.86193 2.75 3V17C2.75 17.1381 2.86193 17.25 3 17.25H17C17.1381 17.25 17.25 17.1381 17.25 17V3C17.25 2.86193 17.1381 2.75 17 2.75H3ZM1.25 3C1.25 2.0335 2.0335 1.25 3 1.25H17C17.9665 1.25 18.75 2.0335 18.75 3V17C18.75 17.9665 17.9665 18.75 17 18.75H3C2.0335 18.75 1.25 17.9665 1.25 17V3ZM8.364 4.6025C8.55637 4.29471 8.94154 4.16884 9.27854 4.30364L14.2785 6.30364C14.5633 6.41754 14.75 6.69332 14.75 7V12C14.75 12.1989 14.671 12.3897 14.5303 12.5303L11.5303 15.5303C11.3897 15.671 11.1989 15.75 11 15.75H6.5C6.08579 15.75 5.75 15.4142 5.75 15V9C5.75 8.85944 5.7895 8.7217 5.864 8.6025L8.364 4.6025ZM9.30366 5.92924L7.25 9.2151V14.25H10.6893L13.25 11.6893V7.50778L9.30366 5.92924Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$map_pin = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "map-pin-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        // eslint-disable-next-line max-len
        d: "M10 2.75C7.08793 2.75 4.75 5.06584 4.75 7.89474C4.75 10.1552 6.11054 12.5103 7.58803 14.3766C8.3139 15.2935 9.04155 16.0596 9.58812 16.5966C9.74138 16.7472 9.88005 16.8794 10 16.9914C10.12 16.8794 10.2586 16.7472 10.4119 16.5966C10.9584 16.0596 11.6861 15.2935 12.412 14.3766C13.8895 12.5103 15.25 10.1552 15.25 7.89474C15.25 5.06584 12.9121 2.75 10 2.75ZM10 18C9.5169 18.5737 9.51674 18.5735 9.51655 18.5734L9.51032 18.5681L9.49517 18.5552C9.48228 18.5442 9.46387 18.5283 9.44029 18.5078C9.39313 18.4668 9.32531 18.4071 9.23977 18.3299C9.06875 18.1756 8.82655 17.9512 8.53688 17.6666C7.95845 17.0983 7.1861 16.2855 6.41197 15.3076C4.88946 13.3845 3.25 10.6869 3.25 7.89474C3.25 4.21249 6.28465 1.25 10 1.25C13.7154 1.25 16.75 4.21249 16.75 7.89474C16.75 10.6869 15.1105 13.3845 13.588 15.3076C12.8139 16.2855 12.0416 17.0983 11.4631 17.6666C11.1734 17.9512 10.9313 18.1756 10.7602 18.3299C10.6747 18.4071 10.6069 18.4668 10.5597 18.5078C10.5361 18.5283 10.5177 18.5442 10.5048 18.5552L10.4897 18.5681L10.4839 18.573C10.4837 18.5731 10.4831 18.5737 10 18ZM10 18L10.4831 18.5737C10.2039 18.8088 9.79572 18.8085 9.51655 18.5734L10 18ZM10 6.75C9.30964 6.75 8.75 7.30964 8.75 8C8.75 8.69036 9.30964 9.25 10 9.25C10.6904 9.25 11.25 8.69036 11.25 8C11.25 7.30964 10.6904 6.75 10 6.75ZM7.25 8C7.25 6.48122 8.48122 5.25 10 5.25C11.5188 5.25 12.75 6.48122 12.75 8C12.75 9.51878 11.5188 10.75 10 10.75C8.48122 10.75 7.25 9.51878 7.25 8Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$matching_buyers = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "matching-buyers-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M11 17.4047C11 16.5763 11.6716 15.9047 12.5 15.9047H15.5C16.3284 15.9047 17 16.5763 17 17.4047V17.9047C17 18.0869 17 18.2578 17 18.4049C17 18.681 16.7761 18.9047 16.5 18.9047H11C11 18.9047 11 18.457 11 17.9047V17.4047Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M12.5 14.4047C12.5 13.5763 13.1716 12.9047 14 12.9047C14.8284 12.9047 15.5 13.5763 15.5 14.4047C15.5 15.2332 14.8284 15.9047 14 15.9047C13.1716 15.9047 12.5 15.2332 12.5 14.4047Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M7.00001 17.4047C7.00001 16.5763 7.67158 15.9047 8.50001 15.9047H11.5C12.3284 15.9047 13 16.5763 13 17.4047V17.9047C13 18.0869 13 18.2578 13 18.4049C13 18.681 12.7761 18.9047 12.5 18.9047H7C7 18.9047 7.00001 18.457 7.00001 17.9047V17.4047Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M8.50001 14.4047C8.50001 13.5763 9.17158 12.9047 10 12.9047C10.8284 12.9047 11.5 13.5763 11.5 14.4047C11.5 15.2332 10.8284 15.9047 10 15.9047C9.17158 15.9047 8.50001 15.2332 8.50001 14.4047Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M3 17.4047C3 16.5763 3.67157 15.9047 4.5 15.9047H7.5C8.32843 15.9047 9 16.5763 9 17.4047V17.9047C9 18.457 9 18.9047 9 18.9047H3.5C3.22386 18.9047 3 18.681 3 18.4049C3 18.2578 3 18.0869 3 17.9047V17.4047Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M4.5 14.4047C4.5 13.5763 5.17158 12.9047 6 12.9047C6.82843 12.9047 7.5 13.5763 7.5 14.4047C7.5 15.2332 6.82843 15.9047 6 15.9047C5.17158 15.9047 4.5 15.2332 4.5 14.4047Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.2646 5.10912C13.5659 5.39333 13.5798 5.868 13.2956 6.16933L9.52289 10.1693C9.2469 10.4619 8.78922 10.4847 8.48552 10.221L6.75825 8.721C6.4455 8.44941 6.41214 7.97571 6.68374 7.66296C6.95533 7.35022 7.42903 7.31686 7.74178 7.58845L8.92557 8.61648L12.2044 5.14012C12.4886 4.83879 12.9633 4.82491 13.2646 5.10912Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$megaphone = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "megaphone-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.3354 3.32918C15.5895 3.45623 15.75 3.71593 15.75 4V7.41841C16.3412 7.69928 16.75 8.30191 16.75 9V10C16.75 10.6981 16.3412 11.3007 15.75 11.5816V15C15.75 15.2841 15.5895 15.5438 15.3354 15.6708C15.0813 15.7979 14.7773 15.7705 14.55 15.6L10.75 12.75H9.58558L8.72761 16.1819C8.64414 16.5158 8.34415 16.75 8 16.75H7C6.76905 16.75 6.55098 16.6436 6.40885 16.4616C6.26672 16.2795 6.21638 16.0422 6.27239 15.8181L7.03942 12.75H6.5C4.70507 12.75 3.25 11.2949 3.25 9.5C3.25 7.70508 4.70507 6.25 6.5 6.25H10.75L14.55 3.4C14.7773 3.22956 15.0813 3.20214 15.3354 3.32918ZM11 11.25C11.1623 11.25 11.3202 11.3026 11.45 11.4L14.25 13.5V5.5L11.45 7.6C11.3202 7.69737 11.1623 7.75 11 7.75H6.5C5.5335 7.75 4.75 8.53351 4.75 9.5C4.75 10.4665 5.5335 11.25 6.5 11.25H11Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$menu = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "menu-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20 5H0V3H20V5ZM20 11H0V9H20V11ZM20 17H0V15H20V17Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$merge = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "merge-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("svg", {
        width: "20",
        height: "21",
        viewBox: "0 0 20 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.5 16.1547C8.63807 16.1547 8.75 16.0428 8.75 15.9047L8.75 5.90472C8.75 5.76665 8.63807 5.65472 8.5 5.65472L4 5.65472C3.58579 5.65472 3.25 5.31894 3.25 4.90472C3.25 4.49051 3.58579 4.15472 4 4.15472L8.5 4.15472C9.4665 4.15472 10.25 4.93822 10.25 5.90472L10.25 15.9047C10.25 16.8712 9.4665 17.6547 8.5 17.6547H4C3.58579 17.6547 3.25 17.3189 3.25 16.9047C3.25 16.4905 3.58579 16.1547 4 16.1547H8.5Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.25 10.9047C9.25 10.4905 9.58579 10.1547 10 10.1547H17V11.6547H10C9.58579 11.6547 9.25 11.3189 9.25 10.9047Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.5315 8.31907C15.8549 8.06032 16.3269 8.11276 16.5857 8.4362L18.1857 10.4362C18.4048 10.7101 18.4048 11.0993 18.1857 11.3732L16.5857 13.3732C16.3269 13.6967 15.8549 13.7491 15.5315 13.4904C15.208 13.2316 15.1556 12.7596 15.4143 12.4362L16.6395 10.9047L15.4143 9.37325C15.1556 9.0498 15.208 8.57783 15.5315 8.31907Z",
        fill: "#4B5563"
    })));
};
const $e959f086e329e090$var$message_new = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "message-new-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M17.8996 3.73379C18.4406 3.1928 18.4832 2.35822 17.9953 1.87029C17.5071 1.38214 16.673 1.42477 16.1323 1.96552L6.91073 11.1871L6.32595 13.5396L8.6785 12.9549L17.8996 3.73379Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M16.25 7.50467V13C16.25 14.7949 14.7949 16.25 13 16.25H7C5.20507 16.25 3.75 14.7949 3.75 13V6.99999C3.75 5.20507 5.20507 3.74999 7 3.74999H12.2265L13.7265 2.24999H7C4.37665 2.24999 2.25 4.37664 2.25 6.99999V13C2.25 15.6233 4.37665 17.75 7 17.75H13C15.6234 17.75 17.75 15.6233 17.75 13V6.00467L16.25 7.50467Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$minus = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "minus-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M2 9.75C2 9.33579 2.33579 9 2.75 9H17.25C17.6642 9 18 9.33579 18 9.75C18 10.1642 17.6642 10.5 17.25 10.5H2.75C2.33579 10.5 2 10.1642 2 9.75Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$more_horizontal = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "more-horizontal-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        // eslint-disable-next-line max-len
        d: "M3 8C1.9 8 1 8.9 1 10C1 11.1 1.9 12 3 12C4.1 12 5 11.1 5 10C5 8.9 4.1 8 3 8ZM17.0005 8C15.9005 8 15.0005 8.9 15.0005 10C15.0005 11.1 15.9005 12 17.0005 12C18.1005 12 19.0005 11.1 19.0005 10C19.0005 8.9 18.1005 8 17.0005 8ZM10.0001 8C8.90006 8 8.00006 8.9 8.00006 10C8.00006 11.1 8.90006 12 10.0001 12C11.1001 12 12.0001 11.1 12.0001 10C12.0001 8.9 11.1001 8 10.0001 8Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$more_vertical = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "more-vertical-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        // eslint-disable-next-line max-len
        d: "M8.00025 17.0002C8.00025 18.1003 8.90025 19.0002 10.0002 19.0002C11.1002 19.0002 12.0002 18.1003 12.0002 17.0002C12.0002 15.9002 11.1002 15.0002 10.0002 15.0002C8.90025 15.0002 8.00025 15.9002 8.00025 17.0002ZM8.00025 2.99976C8.00025 4.09976 8.90025 4.99976 10.0002 4.99976C11.1002 4.99976 12.0002 4.09976 12.0002 2.99976C12.0002 1.89976 11.1002 0.999756 10.0002 0.999756C8.90025 0.999756 8.00025 1.89976 8.00025 2.99976ZM8.00025 10.0002C8.00025 11.1002 8.90025 12.0002 10.0002 12.0002C11.1002 12.0002 12.0002 11.1002 12.0002 10.0002C12.0002 8.90019 11.1002 8.00019 10.0002 8.00019C8.90025 8.00019 8.00025 8.90019 8.00025 10.0002Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$number_range = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "number-range-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M12.3421 10.091L12.5 9.28072H11.6212L11.9411 7.71423H11.1305L10.8106 9.28072H9.73549L10.0555 7.71423H9.24915L8.92918 9.28072H8.05887L7.90102 10.091H8.77133L8.53242 11.2669H7.65785L7.5 12.0813H8.37031L8.03754 13.7142H8.84386L9.17235 12.0813H10.2517L9.91894 13.7142H10.7253L11.0623 12.0813H11.9411L12.0947 11.2669H11.2159L11.459 10.091H12.3421ZM9.54352 10.0369H10.7039L10.4394 11.3292H9.28328L9.54352 10.0369Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M3.75 7.71423C3.75 7.30002 3.41421 6.96423 3 6.96423C2.58579 6.96423 2.25 7.30002 2.25 7.71423V13.7142C2.25 14.1284 2.58579 14.4642 3 14.4642C3.41421 14.4642 3.75 14.1284 3.75 13.7142L3.75 7.71423Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M17.75 7.71423C17.75 7.30002 17.4142 6.96423 17 6.96423C16.5858 6.96423 16.25 7.30002 16.25 7.71423V13.7142C16.25 14.1284 16.5858 14.4642 17 14.4642C17.4142 14.4642 17.75 14.1284 17.75 13.7142V7.71423Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M6 9.96423H3C2.58579 9.96423 2.25 10.3 2.25 10.7142C2.25 11.1284 2.58579 11.4642 3 11.4642H6V9.96423Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M14 11.4642H17C17.4142 11.4642 17.75 11.1284 17.75 10.7142C17.75 10.3 17.4142 9.96423 17 9.96423H14V11.4642Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$origin = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "origin-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "21",
        viewBox: "0 0 20 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 2.52374C9.17157 2.52374 8.5 3.19532 8.5 4.02374C8.5 4.57895 8.80165 5.06371 9.25 5.32307V7.87726C9.04198 7.9361 8.84397 8.0188 8.65914 8.12222L6.94919 6.41228C6.98233 6.28836 7 6.15811 7 6.02374C7 5.19532 6.32843 4.52374 5.5 4.52374C4.67157 4.52374 4 5.19532 4 6.02374C4 6.85217 4.67157 7.52374 5.5 7.52374C5.63437 7.52374 5.76461 7.50608 5.88853 7.47294L7.59848 9.18288C7.50341 9.35278 7.42585 9.53381 7.36825 9.72351L4.76894 9.72351C4.5032 9.30301 4.03421 9.02374 3.5 9.02374C2.67157 9.02374 2 9.69532 2 10.5237C2 11.3522 2.67157 12.0237 3.5 12.0237C4.0757 12.0237 4.57565 11.6994 4.82711 11.2235L7.33983 11.2235C7.39281 11.4255 7.46819 11.6184 7.56316 11.7994L5.80733 13.5553C5.70813 13.5346 5.60533 13.5237 5.5 13.5237C4.67157 13.5237 4 14.1953 4 15.0237C4 15.8522 4.67157 16.5237 5.5 16.5237C6.32843 16.5237 7 15.8522 7 15.0237C7 14.861 6.9741 14.7044 6.9262 14.5577L8.59542 12.8885C8.79823 13.0092 9.01787 13.1046 9.25 13.1702V15.7244C8.80165 15.9838 8.5 16.4685 8.5 17.0237C8.5 17.8522 9.17157 18.5237 10 18.5237C10.8284 18.5237 11.5 17.8522 11.5 17.0237C11.5 16.4685 11.1984 15.9838 10.75 15.7244V13.1702C10.958 13.1114 11.156 13.0287 11.3409 12.9253L13.0508 14.6352C13.0177 14.7591 13 14.8894 13 15.0237C13 15.8522 13.6716 16.5237 14.5 16.5237C15.3284 16.5237 16 15.8522 16 15.0237C16 14.1953 15.3284 13.5237 14.5 13.5237C14.3656 13.5237 14.2354 13.5414 14.1115 13.5746L12.4015 11.8646C12.5132 11.6649 12.6008 11.4499 12.6602 11.2235L15.1729 11.2235C15.4243 11.6994 15.9243 12.0237 16.5 12.0237C17.3284 12.0237 18 11.3522 18 10.5237C18 9.69532 17.3284 9.02374 16.5 9.02374C15.9658 9.02374 15.4968 9.30301 15.2311 9.72351L12.6318 9.72351C12.5669 9.50989 12.4767 9.30728 12.3647 9.11917L14.034 7.44994C14.1807 7.49784 14.3373 7.52374 14.5 7.52374C15.3284 7.52374 16 6.85217 16 6.02374C16 5.19532 15.3284 4.52374 14.5 4.52374C13.6716 4.52374 13 5.19532 13 6.02374C13 6.12908 13.0109 6.23187 13.0315 6.33108L11.2757 8.0869C11.1097 7.99984 10.9338 7.92924 10.75 7.87726V5.32307C11.1984 5.06371 11.5 4.57895 11.5 4.02374C11.5 3.19532 10.8284 2.52374 10 2.52374ZM10 9.27374C10.6904 9.27374 11.25 9.83339 11.25 10.5237C11.25 11.2141 10.6904 11.7737 10 11.7737C9.30964 11.7737 8.75 11.2141 8.75 10.5237C8.75 9.83339 9.30964 9.27374 10 9.27374Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$outbox = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "outbox-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 11.25C3.41421 11.25 3.75 11.5858 3.75 12L3.75 16.25H16.25V12C16.25 11.5858 16.5858 11.25 17 11.25C17.4142 11.25 17.75 11.5858 17.75 12V17C17.75 17.4142 17.4142 17.75 17 17.75H3C2.58579 17.75 2.25 17.4142 2.25 17L2.25 12C2.25 11.5858 2.58579 11.25 3 11.25Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 1.93929L13.5303 5.46962C13.8232 5.76251 13.8232 6.23738 13.5303 6.53028C13.2374 6.82317 12.7626 6.82317 12.4697 6.53028L10.75 4.81061V13.4499C10.75 13.8642 10.4142 14.1999 10 14.1999C9.58579 14.1999 9.25 13.8642 9.25 13.4499V4.81061L7.53033 6.53028C7.23744 6.82317 6.76256 6.82317 6.46967 6.53028C6.17678 6.23738 6.17678 5.76251 6.46967 5.46962L10 1.93929Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$paperclip = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "paperclip-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        // eslint-disable-next-line max-len
        d: "M15.621 4.71227C15.0584 4.14985 14.2955 3.83391 13.5 3.83391C12.7045 3.83391 11.9416 4.14985 11.379 4.71227L4.37903 11.7123C3.83242 12.2779 3.52986 13.0357 3.5365 13.8223C3.54315 14.6089 3.85848 15.3614 4.41458 15.9177C4.97067 16.4741 5.72303 16.7898 6.50962 16.7968C7.29621 16.8038 8.05409 16.5016 8.62003 15.9553H8.62103L9.11803 15.4553C9.25901 15.3181 9.44824 15.2418 9.64493 15.2429C9.84163 15.2439 10.03 15.3221 10.1696 15.4608C10.3091 15.5994 10.3886 15.7873 10.391 15.984C10.3933 16.1807 10.3183 16.3704 10.182 16.5123L9.68403 17.0133L9.68203 17.0153C8.83811 17.8592 7.69351 18.3333 6.50003 18.3333C5.30655 18.3333 4.16195 17.8592 3.31803 17.0153C2.47411 16.1713 2 15.0267 2 13.8333C2 12.6398 2.47411 11.4952 3.31803 10.6513L10.318 3.65127C11.1614 2.80682 12.3057 2.33199 13.4992 2.33124C14.6927 2.33049 15.8376 2.80388 16.682 3.64727C17.5265 4.49065 18.0013 5.63496 18.0021 6.82844C18.0028 8.02192 17.5294 9.16682 16.686 10.0113L13.231 13.5643C12.9898 13.8187 12.7 14.0222 12.3789 14.1628C12.0577 14.3034 11.7116 14.3782 11.3611 14.3829C11.0105 14.3875 10.6626 14.3219 10.3378 14.1899C10.013 14.0579 9.71796 13.8621 9.47005 13.6142C9.22215 13.3663 9.02642 13.0713 8.89441 12.7465C8.7624 12.4217 8.69678 12.0738 8.70144 11.7232C8.7061 11.3726 8.78093 11.0266 8.92153 10.7054C9.06212 10.3842 9.26562 10.0945 9.52003 9.85327L12.97 6.40227C13.0392 6.3306 13.1219 6.27343 13.2134 6.23408C13.3049 6.19473 13.4033 6.17399 13.5029 6.17308C13.6025 6.17217 13.7012 6.1911 13.7934 6.22877C13.8856 6.26643 13.9694 6.32208 14.0398 6.39247C14.1103 6.46285 14.166 6.54657 14.2038 6.63872C14.2415 6.73088 14.2605 6.82963 14.2597 6.92921C14.2589 7.02879 14.2382 7.12722 14.199 7.21874C14.1597 7.31026 14.1026 7.39305 14.031 7.46227L10.581 10.9133C10.4763 11.0175 10.3931 11.1413 10.3362 11.2776C10.2794 11.414 10.2499 11.5602 10.2495 11.7079C10.2491 11.8557 10.2779 12.002 10.3341 12.1387C10.3903 12.2753 10.4728 12.3995 10.577 12.5043C10.6812 12.609 10.805 12.6922 10.9414 12.7491C11.0777 12.8059 11.224 12.8354 11.3717 12.8358C11.5194 12.8361 11.6658 12.8074 11.8024 12.7512C11.9391 12.695 12.0633 12.6125 12.168 12.5083L15.622 8.95527C16.1844 8.39268 16.5004 7.62976 16.5004 6.83427C16.5004 6.03877 16.1844 5.27585 15.622 4.71327L15.621 4.71227Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$pencil = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "pencil-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        // eslint-disable-next-line max-len
        d: "M16.921 3.64036C17.9952 4.71452 17.9943 6.45619 16.9206 7.52991L8.43575 16.0147C8.33105 16.1194 8.1977 16.1908 8.05251 16.2198L4.51697 16.9269C4.27108 16.9761 4.01687 16.8991 3.83956 16.7218C3.66224 16.5445 3.58527 16.2903 3.63445 16.0444L4.34156 12.5089C4.3706 12.3637 4.44196 12.2303 4.54666 12.1256L13.0319 3.64036C14.1059 2.56641 15.8471 2.56641 16.921 3.64036ZM15.8599 6.46925C16.3483 5.98086 16.3483 5.18895 15.8604 4.70102C15.3722 4.21286 14.5808 4.21286 14.0926 4.70102L5.76789 13.0257L5.32595 15.2354L7.53566 14.7935L15.8599 6.46925Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$percentage = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "percentage-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.5303 4.46965C15.8232 4.76255 15.8232 5.23742 15.5303 5.53032L5.59099 15.4697C5.2981 15.7625 4.82322 15.7625 4.53033 15.4697C4.23744 15.1768 4.23744 14.7019 4.53033 14.409L14.4697 4.46965C14.7626 4.17676 15.2374 4.17676 15.5303 4.46965Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.5 5.74998C6.08579 5.74998 5.75 6.08577 5.75 6.49998C5.75 6.9142 6.08579 7.24998 6.5 7.24998C6.91421 7.24998 7.25 6.9142 7.25 6.49998C7.25 6.08577 6.91421 5.74998 6.5 5.74998ZM4.25 6.49998C4.25 5.25734 5.25736 4.24998 6.5 4.24998C7.74264 4.24998 8.75 5.25734 8.75 6.49998C8.75 7.74263 7.74264 8.74998 6.5 8.74998C5.25736 8.74998 4.25 7.74263 4.25 6.49998ZM13.5 12.75C13.0858 12.75 12.75 13.0858 12.75 13.5C12.75 13.9142 13.0858 14.25 13.5 14.25C13.9142 14.25 14.25 13.9142 14.25 13.5C14.25 13.0858 13.9142 12.75 13.5 12.75ZM11.25 13.5C11.25 12.2573 12.2574 11.25 13.5 11.25C14.7426 11.25 15.75 12.2573 15.75 13.5C15.75 14.7426 14.7426 15.75 13.5 15.75C12.2574 15.75 11.25 14.7426 11.25 13.5Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$phone = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "phone-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M16.0934 13.3489C15.9073 12.8836 13.3014 12.1391 13.1153 12.046H12.9291C12.5569 12.2321 12.1846 12.5113 11.347 13.2559C10.4163 12.7905 9.20644 11.6737 8.55497 11.0223C7.9035 10.2777 7.15896 9.06785 6.87976 8.23025C7.81043 7.39264 8.1827 7.02038 8.1827 6.64811C8.1827 6.46197 7.71737 3.76302 7.25203 3.48382L7.15896 3.39075C6.87976 3.20462 6.50749 2.92542 5.94909 3.01849C5.85602 3.01849 5.76295 3.11155 5.57682 3.20462C5.29762 3.39075 4.46001 3.94916 4.08774 4.6937C3.90161 5.15903 3.71548 9.34706 6.87976 12.8836C9.95098 16.4202 13.8598 16.5132 14.4182 16.4202H14.5113C15.2558 16.141 15.9073 15.3964 16.1865 15.1172C16.6518 14.5588 16.2795 13.9073 16.1865 13.5351L16.0934 13.3489Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$photo = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "photo-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 2.25C2.0335 2.25 1.25 3.0335 1.25 4V16C1.25 16.9665 2.0335 17.75 3 17.75H17C17.9665 17.75 18.75 16.9665 18.75 16V4C18.75 3.0335 17.9665 2.25 17 2.25H3ZM2.75 4C2.75 3.86193 2.86193 3.75 3 3.75H17C17.1381 3.75 17.25 3.86193 17.25 4V10.7979L14.4881 8.43056C14.183 8.16902 13.7259 8.19447 13.4517 8.48826L6.45171 15.9883C6.37897 16.0662 6.32604 16.1555 6.29269 16.25H3C2.86193 16.25 2.75 16.1381 2.75 16V4ZM17.0119 12.5694C17.0843 12.6315 17.1652 12.6774 17.25 12.7073V16C17.25 16.1381 17.1381 16.25 17 16.25H8.25925L14.0578 10.0373L17.0119 12.5694ZM6.5 9C7.32843 9 8 8.32843 8 7.5C8 6.67157 7.32843 6 6.5 6C5.67157 6 5 6.67157 5 7.5C5 8.32843 5.67157 9 6.5 9Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$piggy = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "piggy-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M6 9C5.44772 9 5 8.55228 5 8C5 7.44772 5.44772 7 6 7C6.55228 7 7 7.44772 7 8C7 8.55228 6.55228 9 6 9Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.4265 2.14012C4.594 1.94136 4.85247 1.84349 5.10962 1.88148C5.98205 2.01036 6.67225 2.35568 7.20148 2.77505C8.22567 2.42219 9.35173 2.25 10.5 2.25C13.6604 2.25 16.2646 3.69127 17.6555 5.82912C17.9671 5.52857 18.2499 4.99194 18.2499 4H19.7499C19.7499 5.56754 19.1873 6.60768 18.3433 7.20057C18.6084 7.92382 18.75 8.69718 18.75 9.49997C18.75 12.1513 17.2234 14.5169 14.75 15.7787V17C14.75 17.4142 14.4142 17.75 14 17.75H12C11.5858 17.75 11.25 17.4142 11.25 17V16.7236C11.0041 16.7411 10.754 16.75 10.5 16.75L9.75 16.75V17C9.75 17.4142 9.41421 17.75 9 17.75H7C6.58579 17.75 6.25 17.4142 6.25 17V15.8682C4.93485 15.266 3.99402 14.4567 3.36694 13.7691C3.01671 13.385 2.76273 13.0372 2.59402 12.781L2.57374 12.75H2C1.58579 12.75 1.25 12.4142 1.25 12V7.99997C1.25 7.58576 1.58579 7.24997 2 7.24997H2.88468C3.19953 5.98139 3.85088 4.96501 4.72414 4.18864L4.28738 2.8572C4.20635 2.61022 4.25899 2.33889 4.4265 2.14012ZM10.5 3.75C7.19731 3.75 4.66438 5.28996 4.24172 8.1111C4.18671 8.4783 3.8713 8.74997 3.5 8.74997H2.75V11.25H3C3.2831 11.25 3.54199 11.4094 3.6695 11.662L3.67031 11.6636L3.67495 11.6723C3.68064 11.683 3.69066 11.7014 3.70516 11.7268C3.73418 11.7776 3.78102 11.8561 3.84681 11.956C3.97857 12.1561 4.18515 12.4402 4.47529 12.7584C5.05564 13.3948 5.96386 14.161 7.27334 14.6735C7.56083 14.786 7.75 15.0632 7.75 15.3719V16.25H8.25V16C8.25 15.5858 8.58578 15.25 8.99999 15.25L10.5 15.25C10.9823 15.25 11.4434 15.2128 11.8815 15.1427C12.0984 15.108 12.3196 15.1701 12.4867 15.3126C12.6538 15.4551 12.75 15.6637 12.75 15.8833V16.25H13.25V15.304C13.25 15.0058 13.4266 14.736 13.6999 14.6167C15.9384 13.6394 17.25 11.6614 17.25 9.49997C17.25 6.48824 14.5822 3.75 10.5 3.75Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$play = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "play-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.9767 10.3333L5.5 4.91803V15.7485L14.9767 10.3333ZM16.4806 11.2015C17.1524 10.8176 17.1524 9.84891 16.4806 9.46502L5.49614 3.1882C4.82948 2.80725 4 3.28862 4 4.05644V16.6101C4 17.3779 4.82948 17.8593 5.49614 17.4783L16.4806 11.2015Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$play_circle = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "play-circle-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 4.08325C6.54822 4.08325 3.75 6.88147 3.75 10.3333C3.75 13.785 6.54822 16.5833 10 16.5833C13.4518 16.5833 16.25 13.785 16.25 10.3333C16.25 6.88147 13.4518 4.08325 10 4.08325ZM2.25 10.3333C2.25 6.05305 5.71979 2.58325 10 2.58325C14.2802 2.58325 17.75 6.05305 17.75 10.3333C17.75 14.6135 14.2802 18.0833 10 18.0833C5.71979 18.0833 2.25 14.6135 2.25 10.3333Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.4767 10.3333L9 8.91802V11.7485L11.4767 10.3333ZM12.9806 11.2015C13.6524 10.8176 13.6524 9.8489 12.9806 9.46501L8.99614 7.18819C8.32948 6.80724 7.5 7.28861 7.5 8.05643V12.6101C7.5 13.3779 8.32948 13.8593 8.99614 13.4783L12.9806 11.2015Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$player_video = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "player-video-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.375 10.6495C14.6071 10.5155 14.75 10.2679 14.75 10C14.75 9.73205 14.6071 9.48446 14.375 9.35048L8.375 5.88638C8.14295 5.7524 7.85705 5.7524 7.625 5.88638C7.39295 6.02035 7.25 6.26795 7.25 6.5359V13.4641C7.25 13.7321 7.39295 13.9796 7.625 14.1136C7.85705 14.2476 8.14295 14.2476 8.375 14.1136L14.375 10.6495ZM8.75 12.1651V7.83494L12.5 10L8.75 12.1651Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 3.25C2.0335 3.25 1.25 4.0335 1.25 5V15C1.25 15.9665 2.0335 16.75 3 16.75H17C17.9665 16.75 18.75 15.9665 18.75 15V5C18.75 4.0335 17.9665 3.25 17 3.25H3ZM2.75 5C2.75 4.86193 2.86193 4.75 3 4.75H17C17.1381 4.75 17.25 4.86193 17.25 5V15C17.25 15.1381 17.1381 15.25 17 15.25H3C2.86193 15.25 2.75 15.1381 2.75 15V5Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$plug = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "plug-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.23221 2.30507C8.52511 2.01217 8.99998 2.01217 9.29287 2.30507L17.7782 10.7903C18.071 11.0832 18.071 11.5581 17.7782 11.851L13.5355 16.0936C12.3509 17.2783 10.8376 17.1045 9.807 16.761C9.28529 16.5871 8.8327 16.3549 8.51159 16.1678L6.818 17.8614C6.52511 18.1543 6.05023 18.1543 5.75734 17.8614L2.22181 14.3259C2.08115 14.1852 2.00214 13.9945 2.00214 13.7956C2.00214 13.5966 2.08115 13.4059 2.22181 13.2652L3.9154 11.5716C3.72835 11.2505 3.49616 10.7979 3.32225 10.2762C2.97873 9.24563 2.80495 7.73233 3.98957 6.54771L8.23221 2.30507ZM5.47374 11.2246C5.69737 11.5232 5.66759 11.9408 5.40379 12.2046L3.8128 13.7956L6.28767 16.2704L7.87866 14.6794C8.14223 14.4159 8.55929 14.3859 8.8578 14.6089C8.85778 14.6089 8.85782 14.6089 8.8578 14.6089L8.85861 14.6095C8.85849 14.6094 8.85874 14.6096 8.85861 14.6095L8.86037 14.6108L8.87712 14.6229C8.89325 14.6344 8.91908 14.6525 8.95367 14.6759C9.023 14.7227 9.12665 14.7898 9.25722 14.8662C9.52102 15.0205 9.88135 15.2046 10.2813 15.3379C11.1069 15.6131 11.8917 15.6161 12.4749 15.033L16.1872 11.3207L8.76254 3.89606L5.05023 7.60837C4.46709 8.19151 4.47009 8.97631 4.74528 9.80188C4.87861 10.2019 5.06271 10.5622 5.21701 10.826C5.29338 10.9566 5.36052 11.0602 5.40733 11.1295C5.43069 11.1641 5.44884 11.19 5.46036 11.2061L5.47246 11.2229L5.47374 11.2246C5.47383 11.2247 5.47365 11.2245 5.47374 11.2246Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.8891 1.95151C14.182 2.24441 14.182 2.71928 13.8891 3.01217L11.7677 5.13349C11.4749 5.42639 11 5.42639 10.7071 5.13349C10.4142 4.8406 10.4142 4.36573 10.7071 4.07283L12.8284 1.95151C13.1213 1.65862 13.5962 1.65862 13.8891 1.95151Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.1316 6.19424C18.4245 6.48713 18.4245 6.96201 18.1316 7.2549L16.0103 9.37622C15.7174 9.66911 15.2425 9.66911 14.9496 9.37622C14.6567 9.08333 14.6567 8.60845 14.9496 8.31556L17.071 6.19424C17.3639 5.90135 17.8387 5.90135 18.1316 6.19424Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$plus = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "plus-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        // eslint-disable-next-line max-len
        d: "M10.75 2.75C10.75 2.33579 10.4142 2 10 2C9.58579 2 9.25 2.33579 9.25 2.75V9.25H2.75C2.33579 9.25 2 9.58579 2 10C2 10.4142 2.33579 10.75 2.75 10.75H9.25V17.25C9.25 17.6642 9.58579 18 10 18C10.4142 18 10.75 17.6642 10.75 17.25V10.75H17.25C17.6642 10.75 18 10.4142 18 10C18 9.58579 17.6642 9.25 17.25 9.25H10.75V2.75Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$plus_small = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "plus-small_outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.75 5.33325C10.75 4.91904 10.4142 4.58325 10 4.58325C9.58579 4.58325 9.25 4.91904 9.25 5.33325V9.58325H5C4.58579 9.58325 4.25 9.91904 4.25 10.3333C4.25 10.7475 4.58579 11.0833 5 11.0833H9.25V15.3333C9.25 15.7475 9.58579 16.0833 10 16.0833C10.4142 16.0833 10.75 15.7475 10.75 15.3333V11.0833H15C15.4142 11.0833 15.75 10.7475 15.75 10.3333C15.75 9.91904 15.4142 9.58325 15 9.58325H10.75V5.33325Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$printer = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "printer-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.0803 8.11303C16.632 7.44196 15.8676 7 15 7H5C3.61929 7 2.5 8.11929 2.5 9.5V14.25H5V12C5 11.4477 5.44772 11 6 11H14C14.5523 11 15 11.4477 15 12V14.25H17.5V9.5C17.5 9.42274 17.4965 9.34627 17.4896 9.27077C17.4509 8.84539 17.3055 8.45036 17.0803 8.11303ZM6.5 17.5H13.5V12.5H6.5V17.5ZM16 5.62602C16.0638 5.64244 16.127 5.66039 16.1895 5.67983C17.8178 6.18628 19 7.70507 19 9.5V14.75C19 15.3023 18.5523 15.75 18 15.75H15V18C15 18.5523 14.5523 19 14 19H6C5.44772 19 5 18.5523 5 18V15.75H2C1.44772 15.75 1 15.3023 1 14.75V9.5C1 7.63616 2.27477 6.07006 4 5.62602V2C4 1.44772 4.44772 1 5 1H15C15.5523 1 16 1.44772 16 2V5.62602ZM5.5 2.5H14.5V5.5H5.5V2.5Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$priority_high = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "priority-high-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M8 7.73325C8 7.51234 8.17909 7.33325 8.4 7.33325H10.6C10.8209 7.33325 11 7.51234 11 7.73325V15.9333C11 16.1542 10.8209 16.3333 10.6 16.3333H8.4C8.17909 16.3333 8 16.1542 8 15.9333V7.73325Z",
        fill: "#DC2626"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M12.9463 4.70664C12.9463 4.48573 13.1254 4.30664 13.3463 4.30664H15.5463C15.7672 4.30664 15.9463 4.48573 15.9463 4.70664V15.9066C15.9463 16.1276 15.7672 16.3066 15.5463 16.3066H13.3463C13.1254 16.3066 12.9463 16.1276 12.9463 15.9066V4.70664Z",
        fill: "#DC2626"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M3 10.7333C3 10.5123 3.17909 10.3333 3.4 10.3333H5.6C5.82091 10.3333 6 10.5123 6 10.7333V15.9333C6 16.1542 5.82091 16.3333 5.6 16.3333H3.4C3.17909 16.3333 3 16.1542 3 15.9333V10.7333Z",
        fill: "#DC2626"
    }));
};
const $e959f086e329e090$var$priority_low = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "priority-low-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M8 7.73325C8 7.51234 8.17909 7.33325 8.4 7.33325H10.6C10.8209 7.33325 11 7.51234 11 7.73325V15.9333C11 16.1542 10.8209 16.3333 10.6 16.3333H8.4C8.17909 16.3333 8 16.1542 8 15.9333V7.73325Z",
        fill: "#D1D5DB"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M12.9463 4.70664C12.9463 4.48573 13.1254 4.30664 13.3463 4.30664H15.5463C15.7672 4.30664 15.9463 4.48573 15.9463 4.70664V15.9066C15.9463 16.1276 15.7672 16.3066 15.5463 16.3066H13.3463C13.1254 16.3066 12.9463 16.1276 12.9463 15.9066V4.70664Z",
        fill: "#D1D5DB"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M3 10.7333C3 10.5123 3.17909 10.3333 3.4 10.3333H5.6C5.82091 10.3333 6 10.5123 6 10.7333V15.9333C6 16.1542 5.82091 16.3333 5.6 16.3333H3.4C3.17909 16.3333 3 16.1542 3 15.9333V10.7333Z",
        fill: "#059669"
    }));
};
const $e959f086e329e090$var$priority_medium = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "priority-medium-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M8 7.73325C8 7.51234 8.17909 7.33325 8.4 7.33325H10.6C10.8209 7.33325 11 7.51234 11 7.73325V15.9333C11 16.1542 10.8209 16.3333 10.6 16.3333H8.4C8.17909 16.3333 8 16.1542 8 15.9333V7.73325Z",
        fill: "#D97706"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M12.9463 4.70664C12.9463 4.48573 13.1254 4.30664 13.3463 4.30664H15.5463C15.7672 4.30664 15.9463 4.48573 15.9463 4.70664V15.9066C15.9463 16.1276 15.7672 16.3066 15.5463 16.3066H13.3463C13.1254 16.3066 12.9463 16.1276 12.9463 15.9066V4.70664Z",
        fill: "#D1D5DB"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M3 10.7333C3 10.5123 3.17909 10.3333 3.4 10.3333H5.6C5.82091 10.3333 6 10.5123 6 10.7333V15.9333C6 16.1542 5.82091 16.3333 5.6 16.3333H3.4C3.17909 16.3333 3 16.1542 3 15.9333V10.7333Z",
        fill: "#D97706"
    }));
};
const $e959f086e329e090$var$priority_none = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "priority-none-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M8 7.73325C8 7.51234 8.17909 7.33325 8.4 7.33325H10.6C10.8209 7.33325 11 7.51234 11 7.73325V15.9333C11 16.1542 10.8209 16.3333 10.6 16.3333H8.4C8.17909 16.3333 8 16.1542 8 15.9333V7.73325Z",
        fill: "#D1D5DB"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M12.9463 4.70664C12.9463 4.48573 13.1254 4.30664 13.3463 4.30664H15.5463C15.7672 4.30664 15.9463 4.48573 15.9463 4.70664V15.9066C15.9463 16.1276 15.7672 16.3066 15.5463 16.3066H13.3463C13.1254 16.3066 12.9463 16.1276 12.9463 15.9066V4.70664Z",
        fill: "#D1D5DB"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M3 10.7333C3 10.5123 3.17909 10.3333 3.4 10.3333H5.6C5.82091 10.3333 6 10.5123 6 10.7333V15.9333C6 16.1542 5.82091 16.3333 5.6 16.3333H3.4C3.17909 16.3333 3 16.1542 3 15.9333V10.7333Z",
        fill: "#D1D5DB"
    }));
};
const $e959f086e329e090$var$reclaim = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "reclaim-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5 4C5.41421 4 5.75 4.33579 5.75 4.75V11.75C5.75 12.8496 6.07694 13.6413 6.59283 14.1572C7.10872 14.6731 7.90038 15 9 15H11C11.9507 15 12.7573 14.6829 13.321 14.1449C13.8793 13.6122 14.25 12.815 14.25 11.75C14.25 10.6718 13.8953 9.87356 13.3615 9.34585C12.8251 8.81558 12.0488 8.5 11.1 8.5H8.5C8.08579 8.5 7.75 8.16421 7.75 7.75C7.75 7.33579 8.08579 7 8.5 7H11.1C12.3879 7 13.5616 7.43442 14.4161 8.27915C15.2731 9.12644 15.75 10.3282 15.75 11.75C15.75 13.185 15.2391 14.3878 14.3566 15.2301C13.4795 16.0671 12.2861 16.5 11 16.5H9C7.59962 16.5 6.39128 16.0769 5.53217 15.2178C4.67306 14.3587 4.25 13.1504 4.25 11.75V4.75C4.25 4.33579 4.58579 4 5 4Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M10.0478 4.88429L7.32673 7.10598C6.89109 7.46166 6.89109 8.03834 7.32673 8.39402L10.0478 10.6157C10.3992 10.9026 11 10.6994 11 10.2937V5.2063C11 4.80059 10.3992 4.59741 10.0478 4.88429Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$refresh = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "refresh-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.3177 3.25C15.7319 3.25 16.0677 3.58579 16.0677 4L16.0677 7.98793C16.0677 8.18684 15.9887 8.37761 15.848 8.51826C15.7074 8.65892 15.5166 8.73793 15.3177 8.73793L11.3637 8.73791C10.9495 8.73791 10.6137 8.40212 10.6137 7.98791C10.6137 7.5737 10.9495 7.23791 11.3638 7.23791L13.5139 7.23792C12.8679 6.42918 11.9377 5.84378 10.8396 5.64757C8.43684 5.21825 6.14098 6.81806 5.71166 9.22083C5.28234 11.6236 6.88215 13.9195 9.28492 14.3488C10.7796 14.6158 12.2331 14.0984 13.2231 13.0878C13.552 12.752 13.8289 12.3624 14.0387 11.9299C14.2195 11.5572 14.6682 11.4016 15.0408 11.5824C15.4135 11.7631 15.5691 12.2118 15.3884 12.5845C15.1066 13.1655 14.7349 13.688 14.2947 14.1374C12.9724 15.4873 11.0246 16.1834 9.02108 15.8254C5.8028 15.2504 3.66002 12.1753 4.23505 8.957C4.81007 5.73871 7.88516 3.59593 11.1034 4.17096C12.509 4.42209 13.7096 5.15068 14.5677 6.15854L14.5677 4C14.5677 3.58579 14.9035 3.25 15.3177 3.25Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$resize_to_fit = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "resize-to-fit-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.53033 2.46967C2.82322 2.17678 3.2981 2.17678 3.59099 2.46967L6.75 5.62868V4C6.75 3.58579 7.08579 3.25 7.5 3.25C7.91421 3.25 8.25 3.58579 8.25 4V7.5C8.25 7.91421 7.91421 8.25 7.5 8.25H4C3.58579 8.25 3.25 7.91421 3.25 7.5C3.25 7.08579 3.58579 6.75 4 6.75H5.75L2.53033 3.53033C2.23744 3.23744 2.23744 2.76256 2.53033 2.46967ZM17.5303 2.53033C17.8232 2.82322 17.8232 3.2981 17.5303 3.59099L14.3713 6.75H16C16.4142 6.75 16.75 7.08579 16.75 7.5C16.75 7.91421 16.4142 8.25 16 8.25H12.5C12.0858 8.25 11.75 7.91421 11.75 7.5V4C11.75 3.58579 12.0858 3.25 12.5 3.25C12.9142 3.25 13.25 3.58579 13.25 4V5.75L16.4697 2.53033C16.7626 2.23744 17.2374 2.23744 17.5303 2.53033ZM3.25 12.5C3.25 12.0858 3.58579 11.75 4 11.75H7.5C7.91421 11.75 8.25 12.0858 8.25 12.5V16C8.25 16.4142 7.91421 16.75 7.5 16.75C7.08579 16.75 6.75 16.4142 6.75 16V14.25L3.53033 17.4697C3.23744 17.7626 2.76256 17.7626 2.46967 17.4697C2.17678 17.1768 2.17678 16.7019 2.46967 16.409L5.62868 13.25H4C3.58579 13.25 3.25 12.9142 3.25 12.5ZM11.75 12.5C11.75 12.0858 12.0858 11.75 12.5 11.75H16C16.4142 11.75 16.75 12.0858 16.75 12.5C16.75 12.9142 16.4142 13.25 16 13.25H14.25L17.4697 16.4697C17.7626 16.7626 17.7626 17.2374 17.4697 17.5303C17.1768 17.8232 16.7019 17.8232 16.409 17.5303L13.25 14.3713V16C13.25 16.4142 12.9142 16.75 12.5 16.75C12.0858 16.75 11.75 16.4142 11.75 16V12.5Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$return_icon = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "return-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.6 2.55C7.84853 2.88137 7.78137 3.35147 7.45 3.6L5.25 5.25L12.1683 5.25C13.9915 5.25 15.4094 5.96593 16.361 7.07381C17.2992 8.16602 17.75 9.59699 17.75 11C17.75 12.403 17.2992 13.834 16.361 14.9262C15.4094 16.0341 13.9915 16.75 12.1683 16.75L3 16.75C2.58579 16.75 2.25 16.4142 2.25 16C2.25 15.5858 2.58579 15.25 3 15.25L12.1683 15.25C13.5662 15.25 14.5642 14.7159 15.2232 13.9488C15.8955 13.166 16.25 12.097 16.25 11C16.25 9.90301 15.8955 8.83397 15.2232 8.05119C14.5642 7.28407 13.5662 6.75 12.1683 6.75L5.25 6.75L7.45 8.4C7.78137 8.64853 7.84853 9.11863 7.6 9.45C7.35147 9.78137 6.88137 9.84853 6.55 9.6L2.55 6.6C2.36115 6.45836 2.25 6.23607 2.25 6C2.25 5.76393 2.36115 5.54164 2.55 5.4L6.55 2.4C6.88137 2.15147 7.35147 2.21863 7.6 2.55Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$robot = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "robot-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.25 7C1.25 5.48122 2.48122 4.25 4 4.25H16C17.5188 4.25 18.75 5.48122 18.75 7V15C18.75 16.5188 17.5188 17.75 16 17.75H4C2.48122 17.75 1.25 16.5188 1.25 15V7ZM4 5.75C3.30964 5.75 2.75 6.30964 2.75 7V15C2.75 15.6904 3.30964 16.25 4 16.25H16C16.6904 16.25 17.25 15.6904 17.25 15V7C17.25 6.30964 16.6904 5.75 16 5.75H4Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 13.25C8 12.8358 8.33579 12.5 8.75 12.5H11.25C11.6642 12.5 12 12.8358 12 13.25C12 13.6642 11.6642 14 11.25 14H8.75C8.33579 14 8 13.6642 8 13.25Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M8 10C8 10.5523 7.55228 11 7 11C6.44772 11 6 10.5523 6 10C6 9.44772 6.44772 9 7 9C7.55228 9 8 9.44772 8 10Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M14 10C14 10.5523 13.5523 11 13 11C12.4477 11 12 10.5523 12 10C12 9.44772 12.4477 9 13 9C13.5523 9 14 9.44772 14 10Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M11.5 1.75C11.5 2.7165 10.7165 3.5 9.75 3.5C8.7835 3.5 8 2.7165 8 1.75C8 0.783502 8.7835 0 9.75 0C10.7165 0 11.5 0.783502 11.5 1.75Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M9 2H10.5V5H9V2Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$school = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "school-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.75 13.4523L3.75 10.3604C3.75 9.94617 4.08579 9.61038 4.5 9.61038C4.91421 9.61038 5.25 9.94617 5.25 10.3604L5.25 13.4523C5.25 13.8665 4.91421 14.2023 4.5 14.2023C4.08579 14.2023 3.75 13.8665 3.75 13.4523Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.75 13.4523C3.75 13.038 4.08579 12.7023 4.5 12.7023V13.4523C4.5 12.7023 4.50073 12.7023 4.50147 12.7023L4.50294 12.7023L4.50591 12.7023L4.51191 12.7023L4.52421 12.7026C4.53255 12.7029 4.54119 12.7033 4.55014 12.7038C4.56803 12.7048 4.58733 12.7065 4.60821 12.7088C4.64983 12.7134 4.69874 12.7209 4.75646 12.7324C4.87129 12.7554 5.02686 12.7956 5.23717 12.8657C5.65644 13.0055 6.31554 13.2715 7.33541 13.7814C8.37187 14.2997 9.15395 14.7965 9.68177 15.1681C9.9457 15.3539 10.1462 15.5085 10.2832 15.619C10.3517 15.6742 10.4044 15.7184 10.4412 15.75C10.4596 15.7657 10.4741 15.7784 10.4846 15.7876L10.4974 15.799L10.5015 15.8027L10.5031 15.8041L10.504 15.8049C10.5041 15.805 10.5042 15.8052 10 16.3604L10.504 15.8049C10.8106 16.0834 10.8337 16.558 10.5552 16.8646C10.277 17.171 9.80327 17.194 9.49661 16.9163C9.49641 16.9162 9.4968 16.9165 9.49661 16.9163L9.49198 16.9122C9.48685 16.9077 9.47788 16.8999 9.46504 16.8889C9.43937 16.8669 9.39829 16.8323 9.34181 16.7868C9.22884 16.6957 9.0543 16.5608 8.81823 16.3946C8.34605 16.0621 7.62813 15.6048 6.66459 15.1231C5.68446 14.633 5.09356 14.399 4.76283 14.2888C4.59814 14.2339 4.50371 14.2116 4.46229 14.2033C4.45551 14.202 4.45035 14.201 4.44671 14.2004C4.05736 14.1731 3.75 13.8486 3.75 13.4523Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.25 13.4523C16.25 13.038 15.9142 12.7023 15.5 12.7023V13.4523C15.5 12.7023 15.4993 12.7023 15.4985 12.7023L15.4971 12.7023L15.4941 12.7023L15.4881 12.7023L15.4758 12.7026C15.4674 12.7029 15.4588 12.7033 15.4499 12.7038C15.432 12.7048 15.4127 12.7065 15.3918 12.7088C15.3502 12.7134 15.3013 12.7209 15.2435 12.7324C15.1287 12.7554 14.9731 12.7956 14.7628 12.8657C14.3436 13.0055 13.6845 13.2715 12.6646 13.7814C11.6281 14.2997 10.846 14.7965 10.3182 15.1681C10.0543 15.3539 9.85384 15.5085 9.71681 15.619C9.64829 15.6742 9.59562 15.7184 9.55879 15.75C9.54038 15.7657 9.52592 15.7784 9.51542 15.7876L9.50264 15.799L9.49847 15.8027L9.49694 15.8041L9.49604 15.8049C9.49591 15.805 9.49579 15.8052 10 16.3604L9.49604 15.8049C9.1894 16.0834 9.16631 16.558 9.44478 16.8646C9.723 17.171 10.1967 17.194 10.5034 16.9163C10.5032 16.9165 10.5036 16.9162 10.5034 16.9163L10.508 16.9122C10.5131 16.9077 10.5221 16.8999 10.535 16.8889C10.5606 16.8669 10.6017 16.8323 10.6582 16.7868C10.7712 16.6957 10.9457 16.5608 11.1818 16.3946C11.654 16.0621 12.3719 15.6048 13.3354 15.1231C14.3155 14.633 14.9064 14.399 15.2372 14.2888C15.4019 14.2339 15.4963 14.2116 15.5377 14.2033C15.5445 14.202 15.5497 14.201 15.5533 14.2004C15.9426 14.1731 16.25 13.8486 16.25 13.4523Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.75 13.3604L14.75 10.3604C14.75 9.94617 15.0858 9.61038 15.5 9.61038C15.9142 9.61038 16.25 9.94617 16.25 10.3604L16.25 13.3604C16.25 13.7746 15.9142 14.1104 15.5 14.1104C15.0858 14.1104 14.75 13.7746 14.75 13.3604Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.75 8.95924C18.7473 9.24082 18.5872 9.4972 18.3353 9.62311L10.5173 13.5312C10.3104 13.6346 10.0674 13.6368 9.85872 13.5371L1.67674 9.62902C1.41822 9.50553 1.25263 9.24555 1.25003 8.95905C1.24743 8.67256 1.40828 8.40961 1.66453 8.28146L9.84651 4.18959C10.062 4.0818 10.3163 4.08414 10.5298 4.19589L18.3478 8.28777C18.5973 8.41834 18.7526 8.67766 18.75 8.95924ZM10.1742 5.70283L3.70771 8.93678L10.1745 12.0256L16.3533 8.93692L10.1742 5.70283Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.75 8.95226V14.9523H17.25V8.95226H18.75Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M19 14.9523C19 15.5045 18.5523 15.9523 18 15.9523C17.4477 15.9523 17 15.5045 17 14.9523C17 14.4 17.4477 13.9523 18 13.9523C18.5523 13.9523 19 14.4 19 14.9523Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$screen_line_chart = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "screen-line-chart-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.25 4.25226C2.2835 4.25226 1.5 5.03576 1.5 6.00226V16.0023C1.5 16.9688 2.2835 17.7523 3.25 17.7523H16.75C17.7165 17.7523 18.5 16.9688 18.5 16.0023V6.00226C18.5 5.03576 17.7165 4.25226 16.75 4.25226H3.25ZM3 6.00226C3 5.86419 3.11193 5.75226 3.25 5.75226H16.75C16.8881 5.75226 17 5.86419 17 6.00226V16.0023C17 16.1403 16.8881 16.2523 16.75 16.2523H3.25C3.11193 16.2523 3 16.1403 3 16.0023V6.00226Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 7.25239C12.3177 7.24651 12.6046 7.44142 12.7161 7.73892L14 11.2523H14.6662C15.0804 11.2523 15.5 11.588 15.5 12.0023C15.5 12.4165 15.1642 12.7523 14.75 12.7523H13.564C13.2514 12.7523 12.9716 12.5583 12.8618 12.2656L12 10.2492L10.6895 14.2601C10.59 14.5587 10.3146 14.7427 10 14.7519C9.6854 14.7612 9.3985 14.5523 9.28161 14.2601L7.98796 10.8315L7.17082 12.3377C7.04378 12.5918 6.78408 12.7523 6.5 12.7523H4.75C4.33579 12.7523 4 12.4165 4 12.0023C4 11.588 4.33579 11.2523 4.75 11.2523H6L7.28597 8.66685C7.41806 8.40268 7.69287 8.24063 7.98796 8.25291C8.28305 8.26518 8.54346 8.4495 8.65315 8.72372L10 11.8227L11.3024 7.76509C11.4028 7.46367 11.6823 7.25827 12 7.25239Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$search = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "search-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        // eslint-disable-next-line max-len
        d: "M9 3.75C6.10051 3.75 3.75 6.10051 3.75 9C3.75 11.8995 6.10051 14.25 9 14.25C11.8995 14.25 14.25 11.8995 14.25 9C14.25 6.10051 11.8995 3.75 9 3.75ZM2.25 9C2.25 5.27208 5.27208 2.25 9 2.25C12.7279 2.25 15.75 5.27208 15.75 9C15.75 10.5938 15.1976 12.0585 14.2739 13.2133L17.0303 15.9697C17.3232 16.2626 17.3232 16.7374 17.0303 17.0303C16.7374 17.3232 16.2626 17.3232 15.9697 17.0303L13.2133 14.2739C12.0585 15.1976 10.5938 15.75 9 15.75C5.27208 15.75 2.25 12.7279 2.25 9Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$search_user = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "search-user-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 4.75C7.10051 4.75 4.75 7.10051 4.75 10C4.75 12.8995 7.10051 15.25 10 15.25C12.8995 15.25 15.25 12.8995 15.25 10C15.25 7.10051 12.8995 4.75 10 4.75ZM3.25 10C3.25 6.27208 6.27208 3.25 10 3.25C13.7279 3.25 16.75 6.27208 16.75 10C16.75 11.5938 16.1976 13.0585 15.2739 14.2133L16.5303 15.4697C16.8232 15.7626 16.8232 16.2374 16.5303 16.5303C16.2374 16.8232 15.7626 16.8232 15.4697 16.5303L14.2133 15.2739C13.0585 16.1976 11.5938 16.75 10 16.75C6.27208 16.75 3.25 13.7279 3.25 10Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M7 11.5C7 10.6716 7.67157 10 8.5 10H11.5C12.3284 10 13 10.6716 13 11.5V12C13 12.5523 12.5523 13 12 13H8C7.44772 13 7 12.5523 7 12V11.5Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M8.5 8.5C8.5 7.67157 9.17157 7 10 7C10.8284 7 11.5 7.67157 11.5 8.5C11.5 9.32843 10.8284 10 10 10C9.17157 10 8.5 9.32843 8.5 8.5Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$send = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "send-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.3009 4.00458L4.18441 4.02803L9.03725 7.69412L15.3009 4.00458ZM8.28807 9.00808L1.50154 3.88116C1.24458 3.68703 1.14023 3.35053 1.24228 3.04507C1.34433 2.73962 1.63 2.53341 1.95205 2.53273L18.0601 2.49875C18.3318 2.49818 18.5767 2.64367 18.7091 2.86987C18.8425 3.09526 18.851 3.37984 18.7188 3.61702L10.8798 17.689C10.723 17.9703 10.4042 18.1202 10.0876 18.0614C9.77093 18.0026 9.52721 17.7481 9.482 17.4293L8.28807 9.00808ZM9.80049 8.98985L10.6542 15.0116L16.0641 5.3003L9.80049 8.98985Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$share = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "share-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "21",
        viewBox: "0 0 20 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 0.939331L13.5303 4.46966C13.8232 4.76255 13.8232 5.23743 13.5303 5.53032C13.2374 5.82321 12.7626 5.82321 12.4697 5.53032L10.75 3.81065V12.45C10.75 12.8642 10.4142 13.2 10 13.2C9.58579 13.2 9.25 12.8642 9.25 12.45V3.81065L7.53033 5.53032C7.23744 5.82321 6.76256 5.82321 6.46967 5.53032C6.17678 5.23743 6.17678 4.76255 6.46967 4.46966L10 0.939331ZM3.25 7.99999C3.25 7.58578 3.58579 7.24999 4 7.24999H7C7.41421 7.24999 7.75 7.58578 7.75 7.99999C7.75 8.41421 7.41421 8.74999 7 8.74999H4.75V18.25H15.25V8.74999H13C12.5858 8.74999 12.25 8.41421 12.25 7.99999C12.25 7.58578 12.5858 7.24999 13 7.24999H15.9996C16.4138 7.24999 16.75 7.58578 16.75 7.99999V19C16.75 19.4142 16.4142 19.75 16 19.75H4C3.58579 19.75 3.25 19.4142 3.25 19V7.99999Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$shared = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "shared-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "21",
        viewBox: "0 0 20 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.94922 3C9.07257 3 9.96441 3.35886 10.5654 4.0293C11.153 4.68495 11.375 5.5412 11.375 6.37598C11.3749 7.84529 10.3653 9.10449 9.04199 9.56445H10.627C11.6787 9.56454 12.5459 9.92397 13.1455 10.5752C13.7359 11.2164 14 12.0673 14 12.9385V15.5625C14 15.9767 13.6642 16.3125 13.25 16.3125H2.75586C2.34298 16.3123 2.00747 15.9783 2.00586 15.5654L2 13.8096V13.8066C2.00001 12.4439 2.22237 11.3553 2.8252 10.6064C3.46289 9.8143 4.38717 9.56445 5.37988 9.56445H6.86523C5.55337 9.09941 4.62512 7.81993 4.625 6.37598C4.625 5.56423 4.81099 4.70858 5.37012 4.0459C5.94871 3.36027 6.82486 3.00006 7.94922 3ZM5.37988 11.0645C4.62366 11.0645 4.2331 11.2488 3.99316 11.5469C3.71843 11.8882 3.50002 12.5456 3.5 13.8066L3.50293 14.8125H12.5V12.9385C12.5 12.3604 12.3261 11.8994 12.042 11.5908C11.7672 11.2925 11.3236 11.0645 10.627 11.0645H5.37988ZM7.94922 4.5C7.15624 4.50006 6.74571 4.74145 6.5166 5.0127C6.26803 5.3073 6.125 5.76547 6.125 6.37598C6.12515 7.403 6.96074 8.25081 7.94922 8.25098C8.97511 8.25098 9.87483 7.3658 9.875 6.37598C9.875 5.78876 9.71854 5.33186 9.44824 5.03027C9.19109 4.74342 8.74413 4.5 7.94922 4.5Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M14.4961 9.5625C15.5477 9.56258 16.4151 9.92212 17.0146 10.5732C17.6049 11.2143 17.8682 12.0655 17.8682 12.9365V16.3096H15V14.8096H16.3682V12.9365C16.3682 12.3586 16.1951 11.8973 15.9111 11.5889C15.6548 11.3106 15.2508 11.0961 14.6318 11.0684C14.4541 10.6498 14.2085 10.2523 13.8818 9.89746C13.7707 9.7768 13.6513 9.6668 13.5283 9.5625H14.4961Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M11.8193 3C12.9424 3.00002 13.8337 3.35807 14.4346 4.02832C15.0223 4.68388 15.2441 5.54024 15.2441 6.375C15.2441 7.69123 14.4326 8.83622 13.3125 9.3916C12.8709 9.06751 12.3673 8.83913 11.8193 8.70605V8.46484C11.8603 8.39241 11.8977 8.31802 11.9346 8.24316C12.9113 8.17994 13.7441 7.32729 13.7441 6.375C13.7441 5.78802 13.5876 5.33174 13.3174 5.03027C13.0832 4.76907 12.6919 4.54492 12.0234 4.50684C11.8576 4.10359 11.6259 3.71416 11.3096 3.36133C11.2164 3.2574 11.1175 3.16098 11.0156 3.06934C11.2665 3.02399 11.5345 3 11.8193 3Z",
        fill: "#4B5563"
    })));
};
const $e959f086e329e090$var$shield_home = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "shield-home-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M7 13V9.01923L10 7L13 9.01923V13H7Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.56407 1.3897C9.82484 1.20343 10.1752 1.20343 10.4359 1.3897L11.3564 2.04719C12.9535 3.18795 14.8013 3.92828 16.7442 4.20584L17.1061 4.25754C17.4756 4.31032 17.75 4.62676 17.75 5V10.7805C17.75 13.0429 16.7614 15.1923 15.0436 16.6647C12.1413 19.1524 7.85866 19.1524 4.95637 16.6647C3.23861 15.1923 2.25 13.0429 2.25 10.7805V5C2.25 4.62676 2.52445 4.31032 2.89393 4.25754L3.25583 4.20584C5.19874 3.92828 7.04652 3.18795 8.64358 2.04719L9.56407 1.3897ZM10 2.92168L9.51544 3.26779C7.80026 4.49292 5.82746 5.30658 3.75 5.64748V10.7805C3.75 12.605 4.54727 14.3384 5.93255 15.5258C8.27312 17.532 11.7269 17.532 14.0674 15.5258C15.4527 14.3384 16.25 12.605 16.25 10.7805V5.64748C14.1725 5.30658 12.1997 4.49292 10.4846 3.26779L10 2.92168Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$shield_key = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "shield-key-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.55001 1.13743C9.81919 0.954189 10.1808 0.954189 10.45 1.13743L11.4002 1.78425C13.0488 2.9065 14.9561 3.63481 16.9617 3.90787L17.3353 3.95873C17.7167 4.01065 18 4.32196 18 4.68914V10.3758C18 12.6015 16.9795 14.7161 15.2063 16.1645C12.2104 18.6118 7.78959 18.6118 4.79367 16.1645C3.0205 14.7161 2 12.6015 2 10.3758V4.68914C2 4.32196 2.2833 4.01065 2.66471 3.95873L3.03827 3.90787C5.04386 3.63481 6.95124 2.9065 8.59983 1.78425L9.55001 1.13743ZM10 2.64455L9.49981 2.98505C7.7293 4.19029 5.69286 4.99074 3.54839 5.32611V10.3758C3.54839 12.1707 4.37137 13.876 5.80135 15.0441C8.21741 17.0178 11.7826 17.0178 14.1987 15.0441C15.6286 13.876 16.4516 12.1707 16.4516 10.3758V5.32611C14.3071 4.99074 12.2707 4.19029 10.5002 2.98505L10 2.64455Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 7.5C10.2761 7.5 10.5 7.27614 10.5 7C10.5 6.72386 10.2761 6.5 10 6.5C9.72386 6.5 9.5 6.72386 9.5 7C9.5 7.27614 9.72386 7.5 10 7.5ZM10 9C11.1046 9 12 8.10457 12 7C12 5.89543 11.1046 5 10 5C8.89543 5 8 5.89543 8 7C8 8.10457 8.89543 9 10 9Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.25 14V8.5C9.25 8.08579 9.58579 7.75 10 7.75C10.4142 7.75 10.75 8.08579 10.75 8.5V14C10.75 14.4142 10.4142 14.75 10 14.75C9.58579 14.75 9.25 14.4142 9.25 14Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 11H10V14H12V13C11.7239 13 11.5 12.7761 11.5 12.5C11.5 12.2239 11.7239 12 12 12V11Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$shopping_cart = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "shopping-cart-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.19948 5.7023C3.83918 5.7023 4.37564 6.18526 4.44261 6.82144L5.15988 13.6355C5.25363 14.5262 6.00468 15.2023 6.90026 15.2023H15C15.4142 15.2023 15.75 14.8665 15.75 14.4523C15.75 14.0381 15.4142 13.7023 15 13.7023H6.90026C6.77232 13.7023 6.66503 13.6057 6.65164 13.4785L5.93437 6.66442C5.78704 5.26481 4.60681 4.2023 3.19948 4.2023H3V5.7023H3.19948Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M16 16.9523C16 17.5046 15.5523 17.9523 15 17.9523C14.4477 17.9523 14 17.5046 14 16.9523C14 16.4 14.4477 15.9523 15 15.9523C15.5523 15.9523 16 16.4 16 16.9523Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M7.5 16.9523C7.5 17.5046 7.05228 17.9523 6.5 17.9523C5.94772 17.9523 5.5 17.5046 5.5 16.9523C5.5 16.4 5.94772 15.9523 6.5 15.9523C7.05228 15.9523 7.5 16.4 7.5 16.9523Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.565 7.70228H5.5V6.20228H16.5C16.7275 6.20228 16.9427 6.30553 17.085 6.48299C17.2274 6.66044 17.2815 6.89291 17.2321 7.11498L16.2321 11.615C16.1622 11.9296 15.8991 12.1644 15.5785 12.1982L6.07851 13.1982L5.92149 11.7064L14.8849 10.7629L15.565 7.70228Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$shopping_cart_filled = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "shopping-cart-filled-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("svg", {
        width: "20",
        height: "21",
        viewBox: "0 0 20 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $e959f086e329e090$var$React__default["default"].createElement("g", {
        clipPath: "url(#clip0_13413_51408)"
    }, $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.19948 5.7023C3.83918 5.7023 4.37564 6.18526 4.44261 6.82144L5.15988 13.6355C5.25363 14.5262 6.00468 15.2023 6.90026 15.2023H15C15.4142 15.2023 15.75 14.8665 15.75 14.4523C15.75 14.0381 15.4142 13.7023 15 13.7023H6.90026C6.77232 13.7023 6.66503 13.6057 6.65164 13.4785L5.93437 6.66442C5.78704 5.26481 4.60681 4.2023 3.19948 4.2023H3V5.7023H3.19948Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M16 16.9523C16 17.5046 15.5523 17.9523 15 17.9523C14.4477 17.9523 14 17.5046 14 16.9523C14 16.4 14.4477 15.9523 15 15.9523C15.5523 15.9523 16 16.4 16 16.9523Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M7.5 16.9523C7.5 17.5046 7.05228 17.9523 6.5 17.9523C5.94772 17.9523 5.5 17.5046 5.5 16.9523C5.5 16.4 5.94772 15.9523 6.5 15.9523C7.05228 15.9523 7.5 16.4 7.5 16.9523Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.565 7.70228H5.5V6.20228H16.5C16.7275 6.20228 16.9427 6.30553 17.085 6.48299C17.2274 6.66044 17.2815 6.89291 17.2321 7.11498L16.2321 11.615C16.1622 11.9296 15.8991 12.1644 15.5785 12.1982L6.07851 13.1982L5.92149 11.7064L14.8849 10.7629L15.565 7.70228Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("g", {
        filter: "url(#filter0_dd_13413_51408)"
    }, $e959f086e329e090$var$React__default["default"].createElement("rect", {
        x: "8.5",
        y: "0.952271",
        width: "9",
        height: "9",
        rx: "4.5",
        fill: "#DC2626"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        opacity: "0.99",
        d: "M11.2715 3.33655C10.478 3.33655 9.92139 3.86877 9.92139 4.58899V4.59387C9.92139 5.26038 10.3828 5.74866 11.0688 5.74866C11.5571 5.74866 11.8501 5.50452 11.9771 5.23352H12.0259C12.0259 5.26038 12.0259 5.28723 12.0259 5.31165C11.999 5.95374 11.7744 6.45422 11.2642 6.45422C10.981 6.45422 10.7808 6.3053 10.6953 6.08557L10.688 6.0636H9.96533L9.97021 6.08557C10.0801 6.63733 10.5854 7.04016 11.2666 7.04016C12.1699 7.04016 12.7266 6.33948 12.7266 5.16028V5.1554C12.7266 3.9176 12.0869 3.33655 11.2715 3.33655ZM11.2715 5.20422C10.9028 5.20422 10.6343 4.93811 10.6343 4.56702V4.56213C10.6343 4.20325 10.9199 3.92249 11.2764 3.92249C11.6353 3.92249 11.916 4.20813 11.916 4.57678V4.58167C11.916 4.94543 11.6353 5.20422 11.2715 5.20422ZM13.332 5.8512H14.3867V6.87415H15.0288V5.8512H16.0859V5.20911H15.0288V4.18616H14.3867V5.20911H13.332V5.8512Z",
        fill: "white"
    }))), $e959f086e329e090$var$React__default["default"].createElement("defs", null, $e959f086e329e090$var$React__default["default"].createElement("filter", {
        id: "filter0_dd_13413_51408",
        x: "6.5",
        y: "-0.0477295",
        width: "13",
        height: "13",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, $e959f086e329e090$var$React__default["default"].createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), $e959f086e329e090$var$React__default["default"].createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), $e959f086e329e090$var$React__default["default"].createElement("feOffset", {
        dy: "1"
    }), $e959f086e329e090$var$React__default["default"].createElement("feGaussianBlur", {
        stdDeviation: "1"
    }), $e959f086e329e090$var$React__default["default"].createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
    }), $e959f086e329e090$var$React__default["default"].createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_13413_51408"
    }), $e959f086e329e090$var$React__default["default"].createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), $e959f086e329e090$var$React__default["default"].createElement("feOffset", null), $e959f086e329e090$var$React__default["default"].createElement("feGaussianBlur", {
        stdDeviation: "0.5"
    }), $e959f086e329e090$var$React__default["default"].createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
    }), $e959f086e329e090$var$React__default["default"].createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_13413_51408",
        result: "effect2_dropShadow_13413_51408"
    }), $e959f086e329e090$var$React__default["default"].createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_13413_51408",
        result: "shape"
    })), $e959f086e329e090$var$React__default["default"].createElement("clipPath", {
        id: "clip0_13413_51408"
    }, $e959f086e329e090$var$React__default["default"].createElement("rect", {
        y: "0.952271",
        width: "20",
        height: "20",
        rx: "2",
        fill: "white"
    })))));
};
const $e959f086e329e090$var$short_text = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "short-text-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 9.95227H4V8.45227H16V9.95227Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 12.9523H4V11.4523H12V12.9523Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$sign_for_sale = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "sign-for-sale-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M5.86719 14.0781C5.11914 14.0781 4.66016 13.7363 4.65625 13.1777H5.44141C5.45117 13.3535 5.63086 13.4668 5.89648 13.4668C6.12891 13.4668 6.2832 13.3633 6.2832 13.2051C6.2832 13.0742 6.17773 13.0117 5.875 12.957L5.50195 12.8906C4.98438 12.8008 4.70312 12.5039 4.70312 12.0488C4.70312 11.4746 5.1582 11.1035 5.86328 11.1035C6.55859 11.1035 7.0332 11.4707 7.03906 12.0117H6.28125C6.27539 11.8418 6.10156 11.7129 5.88086 11.7129C5.66602 11.7129 5.52539 11.8105 5.52539 11.9668C5.52539 12.1016 5.64062 12.1797 5.91016 12.2266L6.29492 12.293C6.84375 12.3887 7.09766 12.6484 7.09766 13.1055C7.09766 13.7148 6.63672 14.0781 5.86719 14.0781Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.3223 14H9.41602L9.27148 13.4395H8.41406L8.26367 14H7.44727L8.36523 11.1816H9.4043L10.3223 14ZM8.86914 11.873H8.83008L8.5625 12.8555H9.12695L8.86914 11.873Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M12.7676 13.3242H11.6191V11.1816H10.791V14H12.7676V13.3242Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M14.1074 13.3438H15.2676V14H13.2793V11.1816H15.2676V11.8379H14.1074V12.2949H15.1953V12.8887H14.1074V13.3438Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.5303 1.46967C10.2374 1.17678 9.76256 1.17678 9.46967 1.46967L4.68934 6.25H2C1.58579 6.25 1.25 6.58579 1.25 7V18C1.25 18.4142 1.58579 18.75 2 18.75H18C18.4142 18.75 18.75 18.4142 18.75 18V7C18.75 6.58579 18.4142 6.25 18 6.25H15.3107L10.5303 1.46967ZM10 3.06066L13.1893 6.25H6.81066L10 3.06066ZM2.75 17.25V7.75H17.25V17.25H2.75Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$sign_in_ground = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "sign-in-ground-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.25 2.25C5.66421 2.25 6 2.58579 6 3L6 17.5H4.5L4.5 3C4.5 2.58579 4.83579 2.25 5.25 2.25Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.5 5.25C2.5 4.83579 2.83579 4.5 3.25 4.5H16.75C17.1642 4.5 17.5 4.83579 17.5 5.25C17.5 5.66421 17.1642 6 16.75 6H3.25C2.83579 6 2.5 5.66421 2.5 5.25Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.25 12V7H15.75V12C15.75 12.9665 14.9665 13.75 14 13.75H7V12.25H14C14.1381 12.25 14.25 12.1381 14.25 12Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$sign_sold = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "sign-sold-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M4.39453 13.0742C4.39844 13.6328 4.85742 13.9746 5.60547 13.9746C6.375 13.9746 6.83594 13.6113 6.83594 13.002C6.83594 12.5449 6.58203 12.2852 6.0332 12.1895L5.64844 12.123C5.37891 12.0762 5.26367 11.998 5.26367 11.8633C5.26367 11.707 5.4043 11.6094 5.61914 11.6094C5.83984 11.6094 6.01367 11.7383 6.01953 11.9082H6.77734C6.77148 11.3672 6.29688 11 5.60156 11C4.89648 11 4.44141 11.3711 4.44141 11.9453C4.44141 12.4004 4.72266 12.6973 5.24023 12.7871L5.61328 12.8535C5.91602 12.9082 6.02148 12.9707 6.02148 13.1016C6.02148 13.2598 5.86719 13.3633 5.63477 13.3633C5.36914 13.3633 5.18945 13.25 5.17969 13.0742H4.39453Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M8.64453 11C7.7832 11 7.22461 11.5664 7.22461 12.4863C7.22461 13.4102 7.7793 13.9746 8.64453 13.9746C9.50586 13.9746 10.0625 13.4102 10.0625 12.4863C10.0625 11.5664 9.50586 11 8.64453 11ZM8.64453 11.6758C8.98438 11.6758 9.21875 11.9922 9.21875 12.4863C9.21875 12.9824 8.98438 13.2988 8.64453 13.2988C8.30273 13.2988 8.06836 12.9824 8.06836 12.4863C8.06836 11.9922 8.30273 11.6758 8.64453 11.6758Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M12.5488 13.2207H11.4004V11.0781H10.5723V13.8965H12.5488V13.2207Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M13.0605 11.0781V13.8965H14.3105C15.1621 13.8965 15.625 13.3887 15.625 12.4512C15.625 11.5703 15.1523 11.0781 14.3105 11.0781H13.0605ZM13.8887 11.7344H14.1484C14.5469 11.7344 14.7812 11.9922 14.7812 12.4668C14.7812 12.9863 14.5625 13.2402 14.1484 13.2402H13.8887V11.7344Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.5303 1.21967C10.2374 0.926777 9.76256 0.926777 9.46967 1.21967L4.68934 6H2C1.58579 6 1.25 6.33579 1.25 6.75V17.75C1.25 18.1642 1.58579 18.5 2 18.5H18C18.4142 18.5 18.75 18.1642 18.75 17.75V6.75C18.75 6.33579 18.4142 6 18 6H15.3107L10.5303 1.21967ZM13.1893 6L10 2.81066L6.81066 6H13.1893ZM2.75 17V7.5H17.25V17H2.75Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$skip_left = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "skip-left-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.5303 14.5303C13.8232 14.2374 13.8232 13.7626 13.5303 13.4697L10.0607 10L13.5303 6.53033C13.8232 6.23744 13.8232 5.76256 13.5303 5.46967C13.2374 5.17678 12.7626 5.17678 12.4697 5.46967L8.46967 9.46967C8.17678 9.76256 8.17678 10.2374 8.46967 10.5303L12.4697 14.5303C12.7626 14.8232 13.2374 14.8232 13.5303 14.5303Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.5 14.75C7.91421 14.75 8.25 14.4142 8.25 14L8.25 6C8.25 5.58579 7.91421 5.25 7.5 5.25C7.08579 5.25 6.75 5.58579 6.75 6L6.75 14C6.75 14.4142 7.08579 14.75 7.5 14.75Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$skip_right = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "skip-right-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.96967 5.46967C6.67678 5.76256 6.67678 6.23744 6.96967 6.53033L10.4393 10L6.96967 13.4697C6.67678 13.7626 6.67678 14.2374 6.96967 14.5303C7.26256 14.8232 7.73744 14.8232 8.03033 14.5303L12.0303 10.5303C12.3232 10.2374 12.3232 9.76256 12.0303 9.46967L8.03033 5.46967C7.73744 5.17678 7.26256 5.17678 6.96967 5.46967Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13 5.25C12.5858 5.25 12.25 5.58579 12.25 6L12.25 14C12.25 14.4142 12.5858 14.75 13 14.75C13.4142 14.75 13.75 14.4142 13.75 14L13.75 6C13.75 5.58579 13.4142 5.25 13 5.25Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$smiley_negative_one = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "smiley-negative-one-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 17.4523C13.5899 17.4523 16.5 14.5422 16.5 10.9523C16.5 7.36248 13.5898 4.45233 10 4.45233C6.41015 4.45233 3.5 7.36248 3.5 10.9523C3.5 14.5422 6.41015 17.4523 10 17.4523ZM10 18.9523C14.4183 18.9523 18 15.3706 18 10.9523C18 6.53405 14.4183 2.95233 10 2.95233C5.58172 2.95233 2 6.53405 2 10.9523C2 15.3706 5.58172 18.9523 10 18.9523Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M8 9.45221C8 10.0045 7.55228 10.4522 7 10.4522C6.44772 10.4522 6 10.0045 6 9.45221C6 8.89993 6.44772 8.45221 7 8.45221C7.55228 8.45221 8 8.89993 8 9.45221Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M14 9.45221C14 10.0045 13.5523 10.4522 13 10.4522C12.4477 10.4522 12 10.0045 12 9.45221C12 8.89993 12.4477 8.45221 13 8.45221C13.5523 8.45221 14 8.89993 14 9.45221Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.4534 14.5175C10.5385 14.06 9.46152 14.06 8.54655 14.5175L8.33541 14.6231C7.96493 14.8083 7.51442 14.6582 7.32918 14.2877C7.14394 13.9172 7.2941 13.4667 7.66459 13.2814L7.87573 13.1759C9.21299 12.5072 10.787 12.5072 12.1243 13.1759L12.3354 13.2814C12.7059 13.4667 12.8561 13.9172 12.6708 14.2877C12.4856 14.6582 12.0351 14.8083 11.6646 14.6231L11.4534 14.5175Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$smiley_negative_two = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "smiley-negative-two-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 17.4523C13.5899 17.4523 16.5 14.5422 16.5 10.9523C16.5 7.36248 13.5898 4.45233 10 4.45233C6.41015 4.45233 3.5 7.36248 3.5 10.9523C3.5 14.5422 6.41015 17.4523 10 17.4523ZM10 18.9523C14.4183 18.9523 18 15.3706 18 10.9523C18 6.53405 14.4183 2.95233 10 2.95233C5.58172 2.95233 2 6.53405 2 10.9523C2 15.3706 5.58172 18.9523 10 18.9523Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.11917 13.2377C8.6184 11.4387 11.3816 11.4386 12.8808 13.2377L13.0762 13.4721C13.2797 13.7164 13.3071 14.0625 13.1445 14.3358C12.9819 14.609 12.6647 14.7501 12.3529 14.6877L11.0296 14.423C10.3499 14.2871 9.65006 14.2871 8.97039 14.423L7.64709 14.6877C7.33528 14.7501 7.01805 14.609 6.85546 14.3358C6.69287 14.0625 6.72027 13.7164 6.92383 13.4721L7.11917 13.2377Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M8.5 8.95227C8.5 9.50455 8.05228 9.95227 7.5 9.95227C6.94771 9.95227 6.5 9.50455 6.5 8.95227C6.5 8.39998 6.94771 7.95227 7.5 7.95227C8.05228 7.95227 8.5 8.39998 8.5 8.95227Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M13.5 8.95227C13.5 9.50455 13.0523 9.95227 12.5 9.95227C11.9477 9.95227 11.5 9.50455 11.5 8.95227C11.5 8.39998 11.9477 7.95227 12.5 7.95227C13.0523 7.95227 13.5 8.39998 13.5 8.95227Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$smiley_neutral = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "smiley-neutral-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 17.4523C13.5899 17.4523 16.5 14.5422 16.5 10.9523C16.5 7.36248 13.5898 4.45233 10 4.45233C6.41015 4.45233 3.5 7.36248 3.5 10.9523C3.5 14.5422 6.41015 17.4523 10 17.4523ZM10 18.9523C14.4183 18.9523 18 15.3706 18 10.9523C18 6.53405 14.4183 2.95233 10 2.95233C5.58172 2.95233 2 6.53405 2 10.9523C2 15.3706 5.58172 18.9523 10 18.9523Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M8 9.45221C8 10.0045 7.55228 10.4522 7 10.4522C6.44772 10.4522 6 10.0045 6 9.45221C6 8.89993 6.44772 8.45221 7 8.45221C7.55228 8.45221 8 8.89993 8 9.45221Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M14 9.45221C14 10.0045 13.5523 10.4522 13 10.4522C12.4477 10.4522 12 10.0045 12 9.45221C12 8.89993 12.4477 8.45221 13 8.45221C13.5523 8.45221 14 8.89993 14 9.45221Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 13.4523C7.75 13.0381 8.08578 12.7023 8.5 12.7023H11.5C11.9142 12.7023 12.25 13.0381 12.25 13.4523C12.25 13.8665 11.9142 14.2023 11.5 14.2023H8.5C8.08578 14.2023 7.75 13.8665 7.75 13.4523Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$smiley_positive_one = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "smiley-positive-one-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 17.4523C13.5899 17.4523 16.5 14.5422 16.5 10.9523C16.5 7.36248 13.5898 4.45233 10 4.45233C6.41015 4.45233 3.5 7.36248 3.5 10.9523C3.5 14.5422 6.41015 17.4523 10 17.4523ZM10 18.9523C14.4183 18.9523 18 15.3706 18 10.9523C18 6.53405 14.4183 2.95233 10 2.95233C5.58172 2.95233 2 6.53405 2 10.9523C2 15.3706 5.58172 18.9523 10 18.9523Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.7285 12.7065C10.829 13.786 9.17104 13.786 8.2715 12.7065L8.07616 12.4721C7.81099 12.1539 7.33807 12.1109 7.01986 12.3761C6.70165 12.6413 6.65866 13.1142 6.92383 13.4324L7.11917 13.6668C8.6184 15.4659 11.3816 15.4659 12.8808 13.6668L13.0762 13.4324C13.3413 13.1142 13.2983 12.6413 12.9801 12.3761C12.6619 12.1109 12.189 12.1539 11.9238 12.4721L11.7285 12.7065Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M8.5 8.95227C8.5 9.50455 8.05228 9.45227 7.5 9.45227C6.94771 9.45227 6.5 9.50455 6.5 8.95227C6.5 8.39998 6.94771 7.95227 7.5 7.95227C8.05228 7.95227 8.5 8.39998 8.5 8.95227Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M13.5 8.95227C13.5 9.50455 13.0523 9.45227 12.5 9.45227C11.9477 9.45227 11.5 9.50455 11.5 8.95227C11.5 8.39998 11.9477 7.95227 12.5 7.95227C13.0523 7.95227 13.5 8.39998 13.5 8.95227Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$smiley_positive_two = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "smiley-positive-two-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 17.4523C13.5899 17.4523 16.5 14.5422 16.5 10.9523C16.5 7.36248 13.5898 4.45233 10 4.45233C6.41015 4.45233 3.5 7.36248 3.5 10.9523C3.5 14.5422 6.41015 17.4523 10 17.4523ZM10 18.9523C14.4183 18.9523 18 15.3706 18 10.9523C18 6.53405 14.4183 2.95233 10 2.95233C5.58172 2.95233 2 6.53405 2 10.9523C2 15.3706 5.58172 18.9523 10 18.9523Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.11917 13.6668C8.6184 15.4659 11.3816 15.4659 12.8808 13.6668L13.0762 13.4324C13.2625 13.2088 13.3026 12.8977 13.1792 12.6342C13.0558 12.3706 12.791 12.2023 12.5 12.2023H7.5C7.20899 12.2023 6.94424 12.3706 6.82081 12.6342C6.69737 12.8977 6.73753 13.2088 6.92383 13.4324L7.11917 13.6668Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M8.5 8.95227C8.5 9.50455 8.05228 9.45227 7.5 9.45227C6.94771 9.45227 6.5 9.50455 6.5 8.95227C6.5 8.39998 6.94771 7.95227 7.5 7.95227C8.05228 7.95227 8.5 8.39998 8.5 8.95227Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M13.5 8.95227C13.5 9.50455 13.0523 9.45227 12.5 9.45227C11.9477 9.45227 11.5 9.50455 11.5 8.95227C11.5 8.39998 11.9477 7.95227 12.5 7.95227C13.0523 7.95227 13.5 8.39998 13.5 8.95227Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$source = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "source-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "21",
        viewBox: "0 0 20 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 7.20227C10.4142 7.20227 10.75 7.53806 10.75 7.95227L10.75 14.9523C10.75 15.3665 10.4142 15.7023 10 15.7023C9.58579 15.7023 9.25 15.3665 9.25 14.9523L9.25 7.95227C9.25 7.53806 9.58579 7.20227 10 7.20227Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.75 10.9523C4.75 11.0903 4.86193 11.2023 5 11.2023L15 11.2023C15.1381 11.2023 15.25 11.0903 15.25 10.9523L15.25 7.95227C15.25 7.53806 15.5858 7.20227 16 7.20227C16.4142 7.20227 16.75 7.53806 16.75 7.95227L16.75 10.9523C16.75 11.9188 15.9665 12.7023 15 12.7023L5 12.7023C4.0335 12.7023 3.25 11.9188 3.25 10.9523L3.25 7.95227C3.25 7.53806 3.58579 7.20227 4 7.20227C4.41421 7.20227 4.75 7.53806 4.75 7.95227L4.75 10.9523Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 15.7023C9.58579 15.7023 9.25 16.0381 9.25 16.4523C9.25 16.8665 9.58579 17.2023 10 17.2023C10.4142 17.2023 10.75 16.8665 10.75 16.4523C10.75 16.0381 10.4142 15.7023 10 15.7023ZM7.75 16.4523C7.75 15.2096 8.75736 14.2023 10 14.2023C11.2426 14.2023 12.25 15.2096 12.25 16.4523C12.25 17.6949 11.2426 18.7023 10 18.7023C8.75736 18.7023 7.75 17.6949 7.75 16.4523Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M12 5.95227C12 7.05684 11.1046 7.95227 10 7.95227C8.89543 7.95227 8 7.05684 8 5.95227C8 4.8477 8.89543 3.95227 10 3.95227C11.1046 3.95227 12 4.8477 12 5.95227Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 6.45227C10.2761 6.45227 10.5 6.22841 10.5 5.95227C10.5 5.67613 10.2761 5.45227 10 5.45227C9.72386 5.45227 9.5 5.67613 9.5 5.95227C9.5 6.22841 9.72386 6.45227 10 6.45227ZM10 7.95227C11.1046 7.95227 12 7.05684 12 5.95227C12 4.8477 11.1046 3.95227 10 3.95227C8.89543 3.95227 8 4.8477 8 5.95227C8 7.05684 8.89543 7.95227 10 7.95227Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M6 5.95227C6 7.05684 5.10457 7.95227 4 7.95227C2.89543 7.95227 2 7.05684 2 5.95227C2 4.8477 2.89543 3.95227 4 3.95227C5.10457 3.95227 6 4.8477 6 5.95227Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4 6.45227C4.27614 6.45227 4.5 6.22841 4.5 5.95227C4.5 5.67613 4.27614 5.45227 4 5.45227C3.72386 5.45227 3.5 5.67613 3.5 5.95227C3.5 6.22841 3.72386 6.45227 4 6.45227ZM4 7.95227C5.10457 7.95227 6 7.05684 6 5.95227C6 4.8477 5.10457 3.95227 4 3.95227C2.89543 3.95227 2 4.8477 2 5.95227C2 7.05684 2.89543 7.95227 4 7.95227Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M18 5.95227C18 7.05684 17.1046 7.95227 16 7.95227C14.8954 7.95227 14 7.05684 14 5.95227C14 4.8477 14.8954 3.95227 16 3.95227C17.1046 3.95227 18 4.8477 18 5.95227Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 6.45227C16.2761 6.45227 16.5 6.22841 16.5 5.95227C16.5 5.67613 16.2761 5.45227 16 5.45227C15.7239 5.45227 15.5 5.67613 15.5 5.95227C15.5 6.22841 15.7239 6.45227 16 6.45227ZM16 7.95227C17.1046 7.95227 18 7.05684 18 5.95227C18 4.8477 17.1046 3.95227 16 3.95227C14.8954 3.95227 14 4.8477 14 5.95227C14 7.05684 14.8954 7.95227 16 7.95227Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$sparkle = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "sparkle-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M5.4762 9.73657C5.54456 9.73657 5.60608 9.68188 5.61292 9.55884C5.81116 7.3645 5.98889 7.07056 7.43127 6.89282C7.56116 6.87915 7.59534 6.81763 7.59534 6.74927C7.59534 6.6604 7.55432 6.60571 7.4176 6.58521C5.98206 6.40747 5.81116 6.09985 5.61292 4.13794C5.59924 4.01489 5.53772 3.97388 5.4762 3.97388C5.39417 3.97388 5.33264 4.01489 5.31897 4.14478C5.12073 6.10669 4.94983 6.40747 3.52112 6.58521C3.3844 6.60571 3.34338 6.6604 3.34338 6.74927C3.34338 6.81763 3.3844 6.87915 3.50745 6.89282C4.93616 7.07056 5.12073 7.35767 5.31897 9.55884C5.33264 9.68188 5.39417 9.73657 5.4762 9.73657ZM11.7379 16.3538C11.8268 16.3538 11.902 16.3059 11.9225 16.1624C12.4625 11.384 12.9547 10.8987 16.4342 10.3586C16.5778 10.3381 16.6393 10.2698 16.6393 10.1809C16.6393 10.0852 16.5778 10.0237 16.4274 10.0032C12.9547 9.47681 12.4625 8.97778 11.8883 4.65747C11.861 4.50024 11.8063 4.43872 11.7037 4.43872C11.6149 4.43872 11.5397 4.50024 11.526 4.6438C10.9928 8.97095 10.4596 9.46997 6.9801 10.0032C6.82971 10.0237 6.77502 10.0852 6.77502 10.1809C6.77502 10.2698 6.82971 10.3381 6.97327 10.3586C10.4596 10.8987 10.986 11.3772 11.5602 16.1624C11.5739 16.2991 11.649 16.3538 11.7379 16.3538ZM7.54065 17.0305C7.62268 17.0305 7.67053 16.9622 7.6842 16.8459C7.88245 14.6516 8.05334 14.3577 9.49573 14.1799C9.61877 14.1663 9.66663 14.1116 9.66663 14.0364C9.66663 13.9612 9.63245 13.8928 9.49573 13.8792C8.06702 13.6946 7.88245 13.4211 7.6842 11.425C7.67053 11.3088 7.60901 11.2678 7.54065 11.2678C7.45862 11.2678 7.40393 11.302 7.39026 11.4319C7.19202 13.4075 7.01428 13.6946 5.5719 13.8792C5.45569 13.8928 5.40784 13.9543 5.40784 14.0364C5.40784 14.1116 5.45569 14.1663 5.5719 14.1799C7.00745 14.3577 7.19202 14.6516 7.39026 16.8459C7.39709 16.969 7.45862 17.0305 7.54065 17.0305Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$spinner = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "spinner-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        // eslint-disable-next-line max-len
        d: "M10.7501 17C10.7501 17.4142 10.4143 17.75 10.0001 17.75C5.71987 17.75 2.25008 14.2802 2.25008 10C2.25008 5.71979 5.71987 2.25 10.0001 2.25C14.2803 2.25 17.7501 5.71979 17.7501 10C17.7501 10.4142 17.4143 10.75 17.0001 10.75C16.5859 10.75 16.2501 10.4142 16.2501 10C16.2501 6.54822 13.4519 3.75 10.0001 3.75C6.5483 3.75 3.75008 6.54822 3.75008 10C3.75008 13.4518 6.5483 16.25 10.0001 16.25C10.4143 16.25 10.7501 16.5858 10.7501 17Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$split = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "split-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.75 15.9523C16.75 16.3665 16.4142 16.7023 16 16.7023L10.5 16.7023C9.5335 16.7023 8.75 15.9188 8.75 14.9523L8.74999 6.95227C8.74999 5.98577 9.5335 5.20227 10.5 5.20227L16 5.20227C16.4142 5.20227 16.75 5.53806 16.75 5.95227C16.75 6.36648 16.4142 6.70227 16 6.70227L10.5 6.70227C10.3619 6.70227 10.25 6.8142 10.25 6.95227L10.25 14.9523C10.25 15.0903 10.3619 15.2023 10.5 15.2023L16 15.2023C16.4142 15.2023 16.75 15.5381 16.75 15.9523Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.5315 3.36662C14.8549 3.10786 15.3269 3.1603 15.5857 3.48375L17.1857 5.48375C17.4048 5.75766 17.4048 6.14687 17.1857 6.42079L15.5857 8.42079C15.3269 8.74424 14.8549 8.79668 14.5315 8.53792C14.208 8.27916 14.1556 7.80719 14.4143 7.48375L15.6395 5.95227L14.4143 4.42079C14.1556 4.09734 14.208 3.62537 14.5315 3.36662Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.5315 13.3666C14.8549 13.1079 15.3269 13.1603 15.5857 13.4837L17.1857 15.4837C17.4048 15.7577 17.4048 16.1469 17.1857 16.4208L15.5857 18.4208C15.3269 18.7442 14.8549 18.7967 14.5315 18.5379C14.208 18.2792 14.1556 17.8072 14.4143 17.4837L15.6395 15.9523L14.4143 14.4208C14.1556 14.0973 14.208 13.6254 14.5315 13.3666Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.25 10.9523C2.25 10.5381 2.58579 10.2023 3 10.2023H9C9.41421 10.2023 9.75 10.5381 9.75 10.9523C9.75 11.3665 9.41421 11.7023 9 11.7023H3C2.58579 11.7023 2.25 11.3665 2.25 10.9523Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$stamp = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "stamp-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.9593 10.0979C12.6818 9.19601 12.5713 8.24881 12.6355 7.30317L12.6671 6.83915C12.7702 5.32125 11.8905 3.90763 10.4832 3.32977L10.426 3.30628C8.20969 2.39629 5.67537 3.45523 4.76538 5.67149L4.74189 5.72869C4.16402 7.13608 4.55157 8.75533 5.70399 9.7486L6.05629 10.0522C6.77424 10.671 7.37049 11.4153 7.81711 12.2465L7.09121 12.5498C5.03493 13.409 4.33358 15.9718 5.66584 17.7583C6.03717 18.2563 6.64862 18.4932 7.24141 18.3982C7.24043 18.497 7.25905 18.5976 7.29955 18.6945C7.45925 19.0767 7.89853 19.257 8.28072 19.0973L17.5076 15.242C17.8898 15.0823 18.0702 14.643 17.9105 14.2608C17.87 14.1639 17.8115 14.0799 17.7406 14.0112C18.2247 13.6562 18.4858 13.0547 18.3925 12.4406C18.0577 10.2374 15.7415 8.93536 13.6852 9.79455L12.9593 10.0979ZM7.03558 8.91603C8.12005 9.85073 8.97201 11.0251 9.52398 12.3461C9.52398 12.3461 9.52398 12.3461 9.52398 12.3461C9.68368 12.7283 9.50331 13.1676 9.12112 13.3273L7.66951 13.9338C6.51365 14.4168 6.11941 15.8574 6.86829 16.8616C6.90721 16.9138 6.97663 16.9328 7.03669 16.9077L16.824 12.8182C16.8841 12.7931 16.9193 12.7303 16.9095 12.666C16.7213 11.4275 15.4194 10.6956 14.2635 11.1786L12.8119 11.7851C12.4297 11.9448 11.9904 11.7645 11.8307 11.3823C11.8307 11.3823 11.8307 11.3823 11.8307 11.3823C11.2787 10.0612 11.0419 8.62986 11.139 7.20146L11.1705 6.73744C11.2299 5.8637 10.7235 5.04999 9.91341 4.71735L9.85621 4.69387C8.4063 4.09854 6.7483 4.79131 6.15296 6.24123L6.12948 6.29843C5.79684 7.10855 6.01992 8.04064 6.68329 8.61239L7.03558 8.91603Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$star = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "star-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        // eslint-disable-next-line max-len
        d: "M10 1.75C10.2855 1.75 10.5462 1.91207 10.6726 2.16808L12.8492 6.57843L17.7163 7.28566C17.9988 7.32671 18.2335 7.52459 18.3217 7.7961C18.41 8.06761 18.3364 8.36566 18.132 8.56493L14.6101 11.9979L15.4415 16.8454C15.4897 17.1267 15.3741 17.4111 15.1431 17.5789C14.9122 17.7467 14.606 17.7688 14.3533 17.636L10 15.3473L5.64672 17.636C5.39403 17.7688 5.08784 17.7467 4.85688 17.5789C4.62592 17.4111 4.51025 17.1267 4.55851 16.8454L5.38991 11.9979L1.86804 8.56493C1.66361 8.36566 1.59004 8.06761 1.67825 7.7961C1.76647 7.52459 2.00118 7.32671 2.2837 7.28566L7.15081 6.57843L9.32745 2.16808C9.45379 1.91207 9.71452 1.75 10 1.75ZM10 4.19466L8.32141 7.59586C8.21216 7.81721 8.00099 7.97064 7.75671 8.00614L4.00327 8.55154L6.71928 11.199C6.89605 11.3713 6.97671 11.6196 6.93498 11.8629L6.29382 15.6011L9.65099 13.8362C9.86949 13.7213 10.1305 13.7213 10.349 13.8362L13.7062 15.6011L13.065 11.8629C13.0233 11.6196 13.104 11.3713 13.2807 11.199L15.9967 8.55154L12.2433 8.00614C11.999 7.97064 11.7878 7.81721 11.6786 7.59586L10 4.19466Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$star_rising = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "star-rising-solid", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M9.31242 3.02039C9.52885 2.32654 10.4712 2.32654 10.6876 3.02039L11.1362 4.45871C11.233 4.76901 11.5106 4.9791 11.8238 4.9791H13.2757C13.976 4.9791 14.2672 5.91267 13.7006 6.34149L12.5261 7.23042C12.2727 7.4222 12.1666 7.76213 12.2634 8.07243L12.7121 9.51075C12.9285 10.2046 12.1661 10.7816 11.5995 10.3528L10.425 9.46382C10.1716 9.27205 9.82845 9.27205 9.57506 9.46382L8.40051 10.3528C7.8339 10.7816 7.07154 10.2046 7.28797 9.51075L7.7366 8.07243C7.83339 7.76213 7.72736 7.4222 7.47397 7.23042L6.29942 6.34149C5.73281 5.91267 6.02401 4.9791 6.72437 4.9791H8.17619C8.48941 4.9791 8.767 4.76901 8.86378 4.45871L9.31242 3.02039Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.6646 11.8292C13.0351 11.6439 13.4856 11.7941 13.6708 12.1646L15.6708 16.1646C15.8561 16.5351 15.7059 16.9856 15.3354 17.1708C14.9649 17.3561 14.5144 17.2059 14.3292 16.8354L12.3292 12.8354C12.1439 12.4649 12.2941 12.0144 12.6646 11.8292Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.33542 11.8292C6.96494 11.6439 6.51443 11.7941 6.32919 12.1646L4.32919 16.1646C4.14395 16.5351 4.29412 16.9856 4.6646 17.1708C5.03509 17.3561 5.48559 17.2059 5.67083 16.8354L7.67083 12.8354C7.85607 12.4649 7.70591 12.0144 7.33542 11.8292Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 11.75C10.4142 11.75 10.75 12.0858 10.75 12.5V17C10.75 17.4142 10.4142 17.75 10 17.75C9.5858 17.75 9.25001 17.4142 9.25001 17V12.5C9.25001 12.0858 9.5858 11.75 10 11.75Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$status = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "status-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M10 6C11.3261 6 12.5979 6.52678 13.5355 7.46447C14.4732 8.40215 15 9.67392 15 11C15 12.3261 14.4732 13.5978 13.5355 14.5355C12.5979 15.4732 11.3261 16 10 16L10 6Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.5 11C18.5 15.6944 14.6944 19.5 10 19.5C5.30558 19.5 1.5 15.6944 1.5 11C1.5 6.30558 5.30558 2.5 10 2.5C14.6944 2.5 18.5 6.30558 18.5 11ZM10 18C13.866 18 17 14.866 17 11C17 7.13401 13.866 4 10 4C6.13401 4 3 7.13401 3 11C3 14.866 6.13401 18 10 18Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$sticky_note = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "sticky-note-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.75 5.70233V16.2023H11.25V12.9523C11.25 12.5381 11.5858 12.2023 12 12.2023H15.25V5.70227L4.75 5.70233ZM15.1893 13.7023H12.75V16.1416L15.1893 13.7023ZM4 4.20233L16 4.20227C16.1989 4.20227 16.3897 4.28129 16.5303 4.42194C16.671 4.56259 16.75 4.75336 16.75 4.95227V13.9523C16.75 14.1512 16.671 14.3419 16.5303 14.4826L13.5303 17.4826C13.3897 17.6233 13.1989 17.7023 13 17.7023H4C3.58579 17.7023 3.25 17.3665 3.25 16.9523V4.95233C3.25 4.53812 3.58578 4.20234 4 4.20233Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$string_range = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "string-range-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M7.5 8.99817L7.67578 7.95227H12.6035L12.4277 8.99817H10.5908L9.77051 13.9523H8.5166L9.33691 8.99817H7.5Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M3.5 7.95227C3.5 7.53806 3.16421 7.20227 2.75 7.20227C2.33579 7.20227 2 7.53806 2 7.95227V13.9523C2 14.3665 2.33579 14.7023 2.75 14.7023C3.16421 14.7023 3.5 14.3665 3.5 13.9523L3.5 7.95227Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M17.5 7.95227C17.5 7.53806 17.1642 7.20227 16.75 7.20227C16.3358 7.20227 16 7.53806 16 7.95227V13.9523C16 14.3665 16.3358 14.7023 16.75 14.7023C17.1642 14.7023 17.5 14.3665 17.5 13.9523V7.95227Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M6.75 10.2023H2.75C2.33579 10.2023 2 10.5381 2 10.9523C2 11.3665 2.33579 11.7023 2.75 11.7023H6.75V10.2023Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M12.75 11.7023H16.75C17.1642 11.7023 17.5 11.3665 17.5 10.9523C17.5 10.5381 17.1642 10.2023 16.75 10.2023H12.75V11.7023Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$tags = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "tags-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.65685 5.51178C9.59278 5.51178 9.52993 5.5374 9.48251 5.58526L4.82565 10.2851C4.72478 10.3869 4.72478 10.5547 4.82565 10.6565L9.06829 14.9383C9.16538 15.0363 9.3199 15.0363 9.41699 14.9383L9.42263 14.9326L14.1762 10.2366C14.2227 10.1887 14.25 10.1228 14.25 10.0528V5.771C14.25 5.62133 14.1316 5.51178 14 5.51178H9.65685ZM8.41699 4.52948C8.74464 4.19881 9.19049 4.01178 9.65685 4.01178H14C14.973 4.01178 15.75 4.80592 15.75 5.771V10.0528C15.75 10.5171 15.5673 10.9638 15.2399 11.2943L15.2342 11.3L10.4793 15.9973C9.79508 16.6843 8.68568 16.6833 8.00278 15.9941L3.76013 11.7123C3.07996 11.0259 3.07996 9.91573 3.76013 9.22928L8.41699 4.52948Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M12.7782 8.29728C12.3877 8.68781 11.7545 8.68781 11.364 8.29728C10.9734 7.90676 10.9734 7.2736 11.364 6.88307C11.7545 6.49255 12.3877 6.49255 12.7782 6.88307C13.1687 7.2736 13.1687 7.90676 12.7782 8.29728Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.25 7.771C15.25 7.62133 15.1316 7.51178 15 7.51178V6.01178C15.973 6.01178 16.75 6.80592 16.75 7.771V12.0528C16.75 12.5171 16.5673 12.9638 16.2399 13.2943L16.2342 13.3L11.4793 17.9974C10.795 18.6843 9.68566 18.6833 9.00278 17.9941L4.76013 13.7123C4.07996 13.0259 4.07996 11.9157 4.76013 11.2293L5.82565 12.2851C5.72478 12.3869 5.72478 12.5547 5.82565 12.6565L10.0683 16.9383C10.1654 17.0363 10.3199 17.0363 10.417 16.9383L10.4226 16.9326L15.1762 12.2366C15.2227 12.1887 15.25 12.1228 15.25 12.0528V7.771Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$tbd = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "title-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M7.32949 17.8788L8.26792 16.9404L4.55768 13.2302L5.90319 11.8847L5.12945 11.1109L1.5 14.7404L2.27374 15.5141L3.61925 14.1686L7.32949 17.8788Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M10.9123 14.296L12.4567 12.7516C12.7778 12.4305 13.0015 12.1032 13.1279 11.7697C13.2543 11.432 13.2843 11.1057 13.218 10.7908C13.1517 10.4718 12.9881 10.1818 12.727 9.92077L12.7208 9.91456C12.5302 9.72397 12.3127 9.59553 12.0683 9.52924C11.8259 9.46088 11.5783 9.4557 11.3256 9.5137C11.0749 9.56964 10.8429 9.68979 10.6296 9.87416L10.5736 9.81823C10.7041 9.64214 10.7849 9.44741 10.816 9.23404C10.8471 9.02066 10.8295 8.8104 10.7632 8.60324C10.6989 8.394 10.5881 8.21067 10.4307 8.05323L10.4245 8.04701C10.1945 7.81706 9.94074 7.67516 9.66315 7.6213C9.38555 7.56329 9.09864 7.59333 8.8024 7.71141C8.50616 7.82535 8.21199 8.02837 7.91989 8.32046L6.42834 9.81202L7.1244 10.5081L8.37668 9.25579C8.60042 9.03206 8.82518 8.91087 9.05099 8.89222C9.27679 8.86944 9.48085 8.94919 9.66315 9.13149L9.66936 9.13771C9.85374 9.32208 9.92935 9.53235 9.8962 9.76851C9.86306 10.0047 9.72012 10.2491 9.46738 10.5019L8.29278 11.6765L8.91116 12.2948L10.1945 11.0115C10.3789 10.8271 10.5591 10.6966 10.7352 10.6199C10.9113 10.5391 11.0791 10.5143 11.2386 10.5454C11.4002 10.5744 11.5504 10.6583 11.6892 10.7971L11.6954 10.8033C11.9088 11.0167 11.9999 11.2507 11.9688 11.5055C11.9398 11.7583 11.7896 12.0203 11.5183 12.2917L10.2132 13.5968L10.9123 14.296ZM10.4431 14.7652L11.3815 13.8268L6.89756 9.3428L5.95912 10.2812L10.4431 14.7652Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M14.8556 10.3527L16.6206 8.5877C17.0681 8.14023 17.3602 7.67205 17.4969 7.18315C17.6316 6.69218 17.6119 6.19603 17.4379 5.69471C17.2659 5.19131 16.9386 4.69827 16.4559 4.21558L16.4497 4.20937C15.9815 3.74119 15.4999 3.42527 15.0048 3.26161C14.5097 3.09795 14.0197 3.08656 13.535 3.22743C13.0481 3.36623 12.582 3.65832 12.1366 4.10372L10.3716 5.86872L14.8556 10.3527ZM15.0203 8.64052L12.0838 5.70403L12.7612 5.02661C13.0326 4.75523 13.3216 4.58018 13.6282 4.50146C13.9348 4.4186 14.2476 4.43517 14.5666 4.55118C14.8857 4.66305 15.1995 4.87332 15.5082 5.18198L15.5144 5.1882C15.8313 5.50515 16.0499 5.82522 16.17 6.14839C16.2902 6.46741 16.3109 6.78023 16.2322 7.08682C16.1535 7.39342 15.9753 7.68552 15.6977 7.96311L15.0203 8.64052Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$template_apply = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "template_apply-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M13.5 13.5V11.5C13.5 11.2239 13.7239 11 14 11H15C15.2761 11 15.5 11.2239 15.5 11.5V13.5H17.5C17.7761 13.5 18 13.7239 18 14V15C18 15.2761 17.7761 15.5 17.5 15.5H15.5V17.5C15.5 17.7761 15.2761 18 15 18H14C13.7239 18 13.5 17.7761 13.5 17.5V15.5H11.5C11.2239 15.5 11 15.2761 11 15V14C11 13.7239 11.2239 13.5 11.5 13.5H13.5Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.46967 16.0304C3.61032 16.171 3.80109 16.2501 4 16.2501H10.3386C10.131 16.0668 10 15.7987 10 15.5V14.7501H4.75L4.75 3.75017L11.25 3.75003L11.25 7C11.25 7.41421 11.5858 7.75 12 7.75H14.75V10H15.5C15.7987 10 16.0668 10.1309 16.25 10.3385V6C16.25 5.80109 16.171 5.61032 16.0303 5.46967L13.0303 2.46967C12.8897 2.32901 12.6989 2.25 12.5 2.25L3.99998 2.25019C3.58578 2.2502 3.25 2.58598 3.25 3.00019V15.5001C3.25 15.699 3.32902 15.8897 3.46967 16.0304ZM14.6893 6.25H12.75V4.31066L14.6893 6.25Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M10 6.75H6V5.25H10V6.75Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M6 9.75H10V8.25H6V9.75Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$template_remove = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "template-remove-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.5 3C12.6989 3 12.8896 3.07907 13.0303 3.21973L16.0303 6.21973C16.1709 6.36038 16.25 6.55109 16.25 6.75V10.5381H14.75V8.28809H12C11.5858 8.28809 11.25 7.9523 11.25 7.53809V4.5H4.75V15.5H15.5V17H4C3.58579 17 3.25 16.6642 3.25 16.25V3.75C3.25 3.33579 3.58579 3 4 3H12.5ZM12.75 6.78809H14.4775L12.75 5.06055V6.78809Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M10 10.5498H6V9.0498H10V10.5498Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M10 7.5498H6V6.0498H10V7.5498Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M19 12V14H12V12H19Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$text_message = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "text-message-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13 4.75C15.8995 4.75 18.25 7.10051 18.25 10C18.25 12.8995 15.8995 15.25 13 15.25H7C6.84029 15.25 6.68244 15.2429 6.52672 15.229C6.42415 15.2199 6.32079 15.2319 6.22309 15.2645L3.18562 16.2761L3.70866 14.7068C3.80316 14.4232 3.72027 14.1106 3.49767 13.9111C2.42388 12.9488 1.75 11.5536 1.75 10C1.75 7.10051 4.1005 4.75 7 4.75H13ZM19.75 10C19.75 6.27208 16.7279 3.25 13 3.25H7C3.27208 3.25 0.25 6.27208 0.25 10C0.25 11.8174 0.969021 13.4677 2.13631 14.6805L1.28848 17.2244C1.19867 17.4939 1.26879 17.791 1.46962 17.9918C1.67045 18.1927 1.96751 18.2629 2.237 18.1731L6.55348 16.7354C6.70117 16.7451 6.85007 16.75 7 16.75H13C16.7279 16.75 19.75 13.7279 19.75 10Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 11C6.55228 11 7 10.5523 7 10C7 9.44772 6.55228 9 6 9C5.44772 9 5 9.44772 5 10C5 10.5523 5.44772 11 6 11ZM10 11C10.5523 11 11 10.5523 11 10C11 9.44772 10.5523 9 10 9C9.44772 9 9 9.44772 9 10C9 10.5523 9.44772 11 10 11ZM15 10C15 10.5523 14.5523 11 14 11C13.4477 11 13 10.5523 13 10C13 9.44772 13.4477 9 14 9C14.5523 9 15 9.44772 15 10Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$thumb_down = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "thumb_down-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.2114 17.6262C9.95524 18.3093 9.30227 18.7618 8.5728 18.7618H8.2658C6.74701 18.7618 5.5158 17.5306 5.5158 16.0118V15.7821C5.5158 15.1778 5.6311 14.5791 5.85553 14.018L6.02088 13.6046C6.08657 13.4404 5.96563 13.2618 5.78876 13.2618H5.00033C3.3613 13.2618 2.08615 11.8371 2.26715 10.2081L2.77328 5.65288C2.95616 4.00697 4.34737 2.76178 6.0034 2.76178L10.2937 2.76178C10.7206 2.76178 11.1416 2.86118 11.5235 3.0521L13.4678 4.02424C13.7802 4.18045 14.1247 4.26178 14.474 4.26178L15.7658 4.26178C16.7323 4.26178 17.5158 5.04528 17.5158 6.01178L17.5158 10.5118C17.5158 11.4783 16.7323 12.2618 15.7658 12.2618L14.0765 12.2618L13.0762 13.262C12.855 13.4832 12.6125 13.682 12.3523 13.8555L11.3831 14.5016L10.2114 17.6262ZM8.5728 17.2618C8.67701 17.2618 8.77029 17.1971 8.80688 17.0996L10.0635 13.7484C10.1188 13.6012 10.2189 13.475 10.3498 13.3877L11.5202 12.6074C11.6983 12.4887 11.8642 12.3527 12.0155 12.2014L13.2355 10.9814C13.3761 10.8408 13.5669 10.7618 13.7658 10.7618H15.7658C15.9039 10.7618 16.0158 10.6499 16.0158 10.5118L16.0158 6.01178C16.0158 5.87371 15.9039 5.76178 15.7658 5.76178H14.474C13.8918 5.76178 13.3177 5.62624 12.7969 5.36588L10.8527 4.39375C10.6791 4.30696 10.4877 4.26178 10.2937 4.26178L6.0034 4.26178C5.11169 4.26178 4.36258 4.93227 4.26411 5.81852L3.75797 10.3737C3.6757 11.1142 4.25531 11.7618 5.00033 11.7618H5.78876C7.02683 11.7618 7.8734 13.0122 7.4136 14.1617L7.24825 14.5751C7.09469 14.959 7.0158 15.3686 7.0158 15.7821V16.0118C7.0158 16.7021 7.57544 17.2618 8.2658 17.2618H8.5728Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$thumb_up = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "thumb-up-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.55442 3.64731C9.81056 2.96428 10.4635 2.51178 11.193 2.51178H11.5C13.0188 2.51178 14.25 3.743 14.25 5.26178V5.49145C14.25 6.09574 14.1347 6.69448 13.9103 7.25556L13.7449 7.66893C13.6792 7.83315 13.8002 8.01178 13.977 8.01178H14.7655C16.4045 8.01178 17.6797 9.43646 17.4987 11.0655L16.9925 15.6207C16.8096 17.2666 15.4184 18.5118 13.7624 18.5118H9.47214C9.04521 18.5118 8.62415 18.4124 8.2423 18.2215L6.29803 17.2493C5.9856 17.0931 5.6411 17.0118 5.2918 17.0118H4C3.0335 17.0118 2.25 16.2283 2.25 15.2618V10.7618C2.25 9.79528 3.0335 9.01178 4 9.01178H5.68934L6.6896 8.01152C6.91078 7.79034 7.15327 7.59155 7.41353 7.41804L8.38269 6.77193L9.55442 3.64731ZM11.193 4.01178C11.0888 4.01178 10.9955 4.07642 10.9589 4.174L9.70225 7.52512C9.64702 7.67239 9.54689 7.79857 9.41603 7.88582L8.24558 8.66611C8.06751 8.78483 7.90159 8.92085 7.75026 9.07218L6.53033 10.2921C6.38968 10.4328 6.19891 10.5118 6 10.5118H4C3.86193 10.5118 3.75 10.6237 3.75 10.7618V15.2618C3.75 15.3999 3.86193 15.5118 4 15.5118H5.2918C5.87397 15.5118 6.44814 15.6473 6.96885 15.9077L8.91312 16.8798C9.08669 16.9666 9.27808 17.0118 9.47214 17.0118H13.7624C14.6541 17.0118 15.4032 16.3413 15.5017 15.455L16.0078 10.8998C16.0901 10.1594 15.5105 9.51178 14.7655 9.51178H13.977C12.739 9.51178 11.8924 8.26136 12.3522 7.11185L12.5175 6.69847C12.6711 6.31458 12.75 5.90491 12.75 5.49145V5.26178C12.75 4.57142 12.1904 4.01178 11.5 4.01178H11.193Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$title = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "title-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M8.64062 15.4214V8.13434H6V6.26178H13.6108V8.13434H10.9702V15.4214H8.64062Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$to_dos = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "to-dos-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.75 6.7618C17.75 7.17601 17.4142 7.5118 17 7.5118L12 7.5118C11.5858 7.5118 11.25 7.17601 11.25 6.7618C11.25 6.34758 11.5858 6.0118 12 6.0118H17C17.4142 6.0118 17.75 6.34758 17.75 6.7618Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.75 14.7618C17.75 15.176 17.4142 15.5118 17 15.5118H12C11.5858 15.5118 11.25 15.176 11.25 14.7618C11.25 14.3476 11.5858 14.0118 12 14.0118H17C17.4142 14.0118 17.75 14.3476 17.75 14.7618Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.5 16.7618C7.60457 16.7618 8.5 15.8664 8.5 14.7618C8.5 13.6572 7.60457 12.7618 6.5 12.7618C5.39543 12.7618 4.5 13.6572 4.5 14.7618C4.5 15.8664 5.39543 16.7618 6.5 16.7618ZM6.5 18.2618C8.433 18.2618 10 16.6948 10 14.7618C10 12.8288 8.433 11.2618 6.5 11.2618C4.567 11.2618 3 12.8288 3 14.7618C3 16.6948 4.567 18.2618 6.5 18.2618Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.5 10.2618C8.433 10.2618 10 8.69479 10 6.7618C10 4.8288 8.433 3.2618 6.5 3.2618C4.567 3.26179 3 4.8288 3 6.7618C3 8.69479 4.567 10.2618 6.5 10.2618ZM5.56952 8.21492C5.81303 8.44625 6.19583 8.44377 6.43631 8.20929L8.43631 6.25928C8.68346 6.01831 8.68847 5.62262 8.4475 5.37547C8.20653 5.12832 7.81083 5.12331 7.56369 5.36428L5.99437 6.89437L5.43047 6.35866C5.18022 6.12092 4.78462 6.13106 4.54688 6.38131C4.30913 6.63156 4.31928 7.02716 4.56953 7.2649L5.56952 8.21492Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$toolkit = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "toolkit-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.5 5.76178V5.26178H12.5V5.76178H14V4.76178C14 4.2095 13.5523 3.76178 13 3.76178H7C6.44772 3.76178 6 4.2095 6 4.76178V5.76178H7.5Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 7.26178H4C3.72386 7.26178 3.5 7.48564 3.5 7.76178V15.7618C3.5 16.0379 3.72386 16.2618 4 16.2618H16C16.2761 16.2618 16.5 16.0379 16.5 15.7618V7.76178C16.5 7.48564 16.2761 7.26178 16 7.26178ZM4 5.76178C2.89543 5.76178 2 6.65721 2 7.76178V15.7618C2 16.8663 2.89543 17.7618 4 17.7618H16C17.1046 17.7618 18 16.8663 18 15.7618V7.76178C18 6.65721 17.1046 5.76178 16 5.76178H4Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M7 9.01178C7.41421 9.01178 7.75 9.34757 7.75 9.76178V10.0118H12.25V9.76178C12.25 9.34757 12.5858 9.01178 13 9.01178C13.4142 9.01178 13.75 9.34757 13.75 9.76178V10.0118H18V11.5118H13.75V11.7618C13.75 12.176 13.4142 12.5118 13 12.5118C12.5858 12.5118 12.25 12.176 12.25 11.7618V11.5118H7.75V11.7618C7.75 12.176 7.41421 12.5118 7 12.5118C6.58579 12.5118 6.25 12.176 6.25 11.7618V11.5118H2.5V10.0118H6.25V9.76178C6.25 9.34757 6.58579 9.01178 7 9.01178Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$tour = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "tour-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.75 10C1.75 9.01534 2.47725 7.96621 4.00027 7.12008C5.49789 6.28808 7.61764 5.75 10 5.75C12.3824 5.75 14.5021 6.28808 15.9997 7.12008C17.5228 7.96621 18.25 9.01534 18.25 10C18.25 10.685 17.9066 11.3907 17.1747 12.054C16.4409 12.7189 15.3568 13.2987 14.0134 13.6964C13.6162 13.814 13.3896 14.2313 13.5071 14.6284C13.6247 15.0256 14.042 15.2523 14.4392 15.1347C15.9361 14.6916 17.2389 14.02 18.1819 13.1655C19.1267 12.3094 19.75 11.2278 19.75 10C19.75 8.22323 18.4625 6.77237 16.7282 5.80885C14.9684 4.83121 12.5882 4.25 10 4.25C7.4118 4.25 5.03155 4.83121 3.27181 5.80885C1.53747 6.77237 0.25 8.22323 0.25 10C0.25 11.7768 1.53747 13.2276 3.27181 14.1912C4.8073 15.0442 6.81523 15.5954 9.02152 15.7221L7.23253 17.4273C6.9327 17.7131 6.92133 18.1879 7.20712 18.4877C7.49291 18.7875 7.96765 18.7989 8.26748 18.5131L11.4254 15.503L11.9949 14.9601L11.4254 14.4172L8.26748 11.4071C7.96765 11.1213 7.49291 11.1327 7.20712 11.4325C6.92133 11.7324 6.9327 12.2071 7.23253 12.4929L9.04535 14.2209C7.05368 14.0985 5.29462 13.599 4.00027 12.8799C2.47725 12.0338 1.75 10.9847 1.75 10Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$trash_can = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "trash-can-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.25 4C6.25 3.0335 7.0335 2.25 8 2.25H12C12.9665 2.25 13.75 3.0335 13.75 4V4.75L16.5 4.75C16.9142 4.75 17.25 5.08579 17.25 5.5C17.25 5.83242 17.0337 6.11432 16.7342 6.2127L15.9002 15.7284L15.9001 15.7303C15.7804 17.1547 14.5893 18.25 13.1597 18.25H6.84027C5.41059 18.25 4.21949 17.1546 4.09991 15.7301L4.09977 15.7284L3.26577 6.2127C2.96626 6.11432 2.75 5.83242 2.75 5.5C2.75 5.08579 3.08579 4.75 3.5 4.75L6.25 4.75V4ZM7.75 4.75H12.25V4C12.25 3.86193 12.1381 3.75 12 3.75H8C7.86193 3.75 7.75 3.86193 7.75 4V4.75ZM4.77479 6.25L5.59459 15.6038C5.64857 16.2517 6.19016 16.75 6.84027 16.75H13.1597C13.8098 16.75 14.3514 16.2517 14.4054 15.6038L14.4057 15.6006L15.2252 6.25L4.77479 6.25ZM8.25 8C8.66421 8 9 8.33579 9 8.75V14.25C9 14.6642 8.66421 15 8.25 15C7.83579 15 7.5 14.6642 7.5 14.25V8.75C7.5 8.33579 7.83579 8 8.25 8ZM11.75 8C12.1642 8 12.5 8.33579 12.5 8.75V14.25C12.5 14.6642 12.1642 15 11.75 15C11.3358 15 11 14.6642 11 14.25V8.75C11 8.33579 11.3358 8 11.75 8Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$user = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "user-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.25 14C3.25 11.3766 5.37665 9.25 8 9.25H12C14.6234 9.25 16.75 11.3766 16.75 14V17C16.75 17.4142 16.4142 17.75 16 17.75H4C3.58579 17.75 3.25 17.4142 3.25 17V14ZM8 10.75C6.20507 10.75 4.75 12.2051 4.75 14V16.25H15.25V14C15.25 12.2051 13.7949 10.75 12 10.75H8Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.25 5C6.25 2.92893 7.92893 1.25 10 1.25C12.0711 1.25 13.75 2.92893 13.75 5V6C13.75 8.07107 12.0711 9.75 10 9.75C7.92893 9.75 6.25 8.07107 6.25 6V5ZM10 2.75C8.75736 2.75 7.75 3.75736 7.75 5V6C7.75 7.24264 8.75736 8.25 10 8.25C11.2426 8.25 12.25 7.24264 12.25 6V5C12.25 3.75736 11.2426 2.75 10 2.75Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$version_history = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "version-history-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M3.75 10.6667C3.75 14.1185 6.54822 16.9167 10 16.9167C13.4518 16.9167 16.25 14.1185 16.25 10.6667C16.25 7.21491 13.4518 4.41669 10 4.41669C7.78654 4.41669 5.84098 5.56662 4.72949 7.30536C4.61966 7.47719 4.5177 7.65494 4.4248 7.83759C4.23707 8.20659 3.78609 8.35413 3.41699 8.16669C3.04788 7.97896 2.90034 7.52705 3.08789 7.1579C3.20316 6.93125 3.32966 6.71077 3.46582 6.49774C4.84128 4.34596 7.25347 2.91669 10 2.91669C14.2802 2.91669 17.75 6.38648 17.75 10.6667C17.75 14.9469 14.2802 18.4167 10 18.4167C5.71979 18.4167 2.25 14.9469 2.25 10.6667H3.75Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.75 6.66669C10.1642 6.66669 10.5 7.00247 10.5 7.41669V11.0562L12.7185 12.831C13.042 13.0898 13.0944 13.5618 12.8357 13.8852C12.5769 14.2087 12.1049 14.2611 11.7815 14.0023L9.28148 12.0023C9.10357 11.86 9 11.6445 9 11.4167V7.41669C9 7.00247 9.33579 6.66669 9.75 6.66669Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M3 4.01669C3 3.60247 3.33579 3.26669 3.75 3.26669C4.16421 3.26669 4.5 3.60247 4.5 4.01669V6.76669H6.75C7.16421 6.76669 7.5 7.10247 7.5 7.51669C7.5 7.9309 7.16421 8.26669 6.75 8.26669H3.75C3.33579 8.26669 3 7.9309 3 7.51669V4.01669Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$video_library = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "video-library-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.75 2.33325C3.75 1.91904 4.08579 1.58325 4.5 1.58325H15C15.4142 1.58325 15.75 1.91904 15.75 2.33325C15.75 2.74747 15.4142 3.08325 15 3.08325H4.5C4.08579 3.08325 3.75 2.74747 3.75 2.33325Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.25 7.33325C1.25 5.81447 2.48122 4.58325 4 4.58325H16C17.5188 4.58325 18.75 5.81447 18.75 7.33325V15.3333C18.75 16.852 17.5188 18.0833 16 18.0833H4C2.48122 18.0833 1.25 16.852 1.25 15.3333V7.33325ZM4 6.08325C3.30964 6.08325 2.75 6.6429 2.75 7.33325V15.3333C2.75 16.0236 3.30964 16.5833 4 16.5833H16C16.6904 16.5833 17.25 16.0236 17.25 15.3333V7.33325C17.25 6.6429 16.6904 6.08325 16 6.08325H4Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.63048 7.6806C7.86561 7.54747 8.15417 7.55111 8.38587 7.69013L13.3859 10.6901C13.6118 10.8257 13.75 11.0698 13.75 11.3333C13.75 11.5967 13.6118 11.8408 13.3859 11.9764L8.38587 14.9764C8.15417 15.1154 7.86561 15.119 7.63048 14.9859C7.39534 14.8528 7.25 14.6035 7.25 14.3333V8.33325C7.25 8.06305 7.39534 7.81373 7.63048 7.6806ZM8.75 9.6579V13.0086L11.5423 11.3333L8.75 9.6579Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$user_edit = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "user-edit-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 5.75C6 3.67893 7.67893 2 9.75 2C11.8211 2 13.5 3.67893 13.5 5.75V6.75C13.5 8.13923 12.7446 9.35202 11.6221 10H11.75C12.308 10 12.8436 10.0962 13.3409 10.273L12.0957 11.5182C11.9821 11.5062 11.8668 11.5 11.75 11.5H7.75C5.95507 11.5 4.5 12.9551 4.5 14.75V17H7.15458L6.78171 18.5H3.75C3.33579 18.5 3 18.1642 3 17.75V14.75C3 12.1266 5.12665 10 7.75 10H7.87791C6.75543 9.35202 6 8.13923 6 6.75V5.75ZM14.2916 10.7365L13.1917 11.8364L8.23695 16.7911L8.18501 17L7.81214 18.5L7.75 18.75L8.75577 18.5L9.70897 18.2631L10.9721 17L14.6636 13.3085L15.7636 12.2085L17.3874 10.5848C17.8379 10.1343 17.8734 9.43937 17.4671 9.03308C17.0606 8.6266 16.3661 8.6621 15.9158 9.11237L14.2916 10.7365ZM10.8863 18.5L12.3863 17H15V14.75C15 14.6333 14.9938 14.518 14.9819 14.4045L16.2271 13.1593C16.4038 13.6566 16.5 14.1921 16.5 14.75V17.75C16.5 18.1642 16.1642 18.5 15.75 18.5H10.8863ZM9.75 3.5C8.50736 3.5 7.5 4.50736 7.5 5.75V6.75C7.5 7.99264 8.50736 9 9.75 9C10.9926 9 12 7.99264 12 6.75V5.75C12 4.50736 10.9926 3.5 9.75 3.5Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$warning = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "warning-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("svg", {
        width: "20",
        height: "21",
        viewBox: "0 0 20 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3995 15.6278L10.7692 4.35882C10.4508 3.72146 9.54309 3.72146 9.22465 4.35882L3.59444 15.6278C3.30607 16.205 3.72636 16.8808 4.36673 16.8808H15.6272C16.2675 16.8808 16.6878 16.205 16.3995 15.6278ZM12.1111 3.68841C11.24 1.94493 8.75388 1.94493 7.88281 3.68841L2.25259 14.9574C1.46678 16.5302 2.60961 18.3808 4.36673 18.3808H15.6272C17.3843 18.3808 18.5271 16.5302 17.7413 14.9574L12.1111 3.68841Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M10.7272 11.7924C10.7025 12.1735 10.3861 12.47 10.0042 12.47C9.6223 12.47 9.30597 12.1735 9.28123 11.7924L8.94639 7.44557C8.90896 6.86901 9.36652 6.3808 9.94429 6.3808H10.0643C10.642 6.3808 11.0996 6.86901 11.0622 7.44557L10.7272 11.7924ZM8.90521 14.5C8.90521 14.192 9.01255 13.9307 9.22721 13.716C9.44188 13.492 9.69855 13.38 9.99721 13.38C10.3052 13.38 10.5665 13.492 10.7812 13.716C11.0052 13.9307 11.1172 14.192 11.1172 14.5C11.1172 14.808 11.0052 15.0693 10.7812 15.284C10.5665 15.4987 10.3052 15.606 9.99721 15.606C9.69855 15.606 9.44188 15.4987 9.22721 15.284C9.01255 15.0693 8.90521 14.808 8.90521 14.5Z",
        fill: "#4B5563"
    })));
};
const $e959f086e329e090$var$wolfie = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "wolfie-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M6 2.3808C3.79086 2.3808 2 4.17166 2 6.3808V14.3808C2 15.9365 2.88817 17.2849 4.18511 17.9463C4.34274 17.8754 4.52081 17.7853 4.72713 17.6663C6.70172 16.4458 6.51011 15.5229 6.46333 15.4968C6.46333 15.4968 6.5092 15.5658 6.26002 15.8327C5.52956 16.6147 4.88546 16.6361 4.88546 16.6361C5.57903 16.4063 5.86122 15.3375 6.04325 14.6481C6.10062 14.4308 6.14804 14.2512 6.19525 14.1475C6.21718 14.1004 6.24022 14.053 6.26385 14.0044C6.38079 13.7637 6.51204 13.4936 6.59287 13.093C6.68372 12.6227 6.65404 12.2159 6.60906 11.9397C6.56408 12.2495 6.48582 12.6293 6.32749 13.0548C6.15567 13.5129 5.95236 13.8778 5.77334 14.1475C5.73016 11.8949 6.59377 9.53595 6.59377 9.53595C6.60276 9.49956 6.57128 9.4725 6.54069 9.4641L5.26058 9.36052C5.20211 9.35026 4.88726 9.22615 4.92954 9.18883C5.01326 9.11446 5.10937 9.02943 5.21344 8.93735C5.64612 8.55454 6.21657 8.04983 6.60816 7.68275C6.81326 7.49053 7.25226 7.34123 7.25226 7.34123C7.33682 7.31417 7.371 7.30017 7.43397 7.11728C7.49694 6.93438 7.6076 6.77295 7.75873 6.66004L7.76459 6.65485C7.78052 6.64073 7.79636 6.62669 7.8172 6.61339C8.12485 6.38757 8.64661 6.00965 9.29611 5.97699C9.49941 5.96579 9.70902 5.9546 9.91143 5.95926C10.3981 5.97606 10.8011 5.79223 11.1663 5.45817C11.4463 5.19973 11.6501 5.03624 11.8938 4.84061C12.0197 4.73958 12.1563 4.62993 12.3196 4.49425C12.8554 4.18676 13.1089 4.58518 13.2059 4.73764C13.2252 4.76792 13.2383 4.78851 13.2462 4.79192C13.2957 4.78352 13.3649 4.89269 13.4135 4.97014C13.5754 5.22209 13.6024 5.58321 13.4828 5.86315C13.471 5.88885 13.4492 5.93071 13.4224 5.9825C13.3282 6.16384 13.1709 6.46687 13.1562 6.62365C13.1229 6.97637 13.4558 7.0165 13.7257 6.8504C13.9955 6.6843 14.036 6.67777 14.099 6.75895C14.1952 6.88399 14.296 7.13501 14.2744 7.27591C14.2493 7.43321 14.1324 7.53761 14.0437 7.6169C14.0277 7.63122 14.0126 7.64472 13.9991 7.65756C13.8191 7.82482 13.5559 8.00293 13.2753 8.19283C12.8012 8.51358 12.2775 8.86799 12.0209 9.26068C11.4831 10.0839 11.5516 10.9167 11.5755 11.2065C11.5784 11.2419 11.5807 11.2692 11.581 11.2874C11.384 11.126 11.1358 10.8955 10.9001 10.5671C10.6482 10.2171 10.4962 9.87561 10.4008 9.6246C10.3243 9.80282 10.2317 10.0977 10.283 10.4308C10.3675 10.9907 10.6329 11.6504 11.5082 12.1179C12.0947 12.4315 13.4009 13.1593 13.4009 13.1593C13.3433 12.8644 12.6785 11.9537 12.6785 11.9537C13.1373 12.1478 14.2186 12.7916 14.6972 14.3892C15.0528 15.5785 15.022 16.6627 14.9496 18.2674L14.9328 18.2714C14.9039 18.1289 14.8799 17.9943 14.8569 17.8655C14.8099 17.6028 14.7673 17.3642 14.6972 17.1335C14.2318 15.5844 13.795 15.41 12.7211 14.9814C12.5621 14.9179 12.3891 14.8489 12.2 14.7689C12.214 14.7753 12.2292 14.782 12.2454 14.7891C12.6386 14.9623 13.6473 15.4067 14.2519 17.5749C14.3263 17.8414 14.3749 18.1051 14.4036 18.3607C14.3668 18.3644 14.3298 18.3676 14.2927 18.3703C16.3652 18.2204 18 16.4915 18 14.3808V6.3808C18 4.17166 16.2091 2.3808 14 2.3808H6Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M13.7594 18.3808C13.052 16.4994 11.2087 16.0157 10.0913 15.7338L10.578 16.289C10.578 16.289 12.2339 17.3465 12.749 18.3808H13.7594Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M9.16567 7.19006C9.20278 7.13044 9.23995 7.07046 9.27722 7.01032C9.38811 6.8314 9.49988 6.65104 9.61366 6.47435C9.76185 6.4465 9.91181 6.41711 10.0615 6.38778C10.1726 6.36602 10.2837 6.34424 10.3936 6.32318L9.90153 6.9857C9.58308 7.19939 9.27092 7.19846 9.16567 7.19006Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$x = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "x-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        // eslint-disable-next-line max-len
        d: "M2.53033 2.46967C2.82322 2.17678 3.2981 2.17678 3.59099 2.46967L10 8.87868L16.409 2.46967C16.7019 2.17678 17.1768 2.17678 17.4697 2.46967C17.7626 2.76256 17.7626 3.23744 17.4697 3.53033L11.0607 9.93934L17.5303 16.409C17.8232 16.7019 17.8232 17.1768 17.5303 17.4697C17.2374 17.7626 16.7626 17.7626 16.4697 17.4697L10 11L3.53033 17.4697C3.23744 17.7626 2.76256 17.7626 2.46967 17.4697C2.17678 17.1768 2.17678 16.7019 2.46967 16.409L8.93934 9.93934L2.53033 3.53033C2.23744 3.23744 2.23744 2.76256 2.53033 2.46967Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$x_small = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "x-small-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.46967 4.65998C4.76256 4.36708 5.23744 4.36708 5.53033 4.65998L10 9.12965L14.4697 4.65998C14.7626 4.36708 15.2374 4.36708 15.5303 4.65998C15.8232 4.95287 15.8232 5.42774 15.5303 5.72064L11.0607 10.1903L15.5303 14.66C15.8232 14.9529 15.8232 15.4277 15.5303 15.7206C15.2374 16.0135 14.7626 16.0135 14.4697 15.7206L10 11.251L5.53033 15.7206C5.23744 16.0135 4.76256 16.0135 4.46967 15.7206C4.17678 15.4277 4.17678 14.9529 4.46967 14.66L8.93934 10.1903L4.46967 5.72064C4.17678 5.42774 4.17678 4.95287 4.46967 4.65998Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$zillow = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "zillow-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M6.77554 15.8157C6.71722 15.8462 6.66972 15.8385 6.62281 15.7928L5.3174 14.2756C5.28252 14.2334 5.27831 14.2105 5.32522 14.146C6.33419 12.7051 8.39363 10.4595 9.70687 9.5106C9.73032 9.49535 9.7225 9.47599 9.69484 9.48772C8.32689 9.92229 4.4383 11.5538 3 12.3467V17.5H16.9964V12.5373C15.0891 12.8534 9.37495 14.512 6.77554 15.8157V15.8157ZM12.4662 6.54485C12.5366 6.5296 12.5678 6.55247 12.6105 6.59821C12.8529 6.86095 13.6273 7.78346 13.8378 8.03505C13.8769 8.0808 13.8498 8.13065 13.8185 8.15704C12.2552 9.34639 10.5156 11.0313 9.54632 12.2359C9.52708 12.2629 9.54271 12.2629 9.55835 12.2588C11.2468 11.5497 15.2135 10.4173 17 10.1012V7.8943L10.0081 2.5L3.00421 7.8902V10.3029C5.17309 9.04553 10.1915 7.09729 12.4662 6.54485V6.54485Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$zoom_in = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "zoom-in-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M9 5C9.41421 5 9.75 5.33579 9.75 5.75V8.25H12.25C12.6642 8.25 13 8.58579 13 9C13 9.41421 12.6642 9.75 12.25 9.75H9.75V12.25C9.75 12.6642 9.41421 13 9 13C8.58579 13 8.25 12.6642 8.25 12.25V9.75H5.75C5.33579 9.75 5 9.41421 5 9C5 8.58579 5.33579 8.25 5.75 8.25H8.25V5.75C8.25 5.33579 8.58579 5 9 5Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9 2.25C5.27208 2.25 2.25 5.27208 2.25 9C2.25 12.7279 5.27208 15.75 9 15.75C10.5938 15.75 12.0585 15.1976 13.2133 14.2739L15.9697 17.0303C16.2626 17.3232 16.7374 17.3232 17.0303 17.0303C17.3232 16.7374 17.3232 16.2626 17.0303 15.9697L14.2739 13.2133C15.1976 12.0585 15.75 10.5938 15.75 9C15.75 5.27208 12.7279 2.25 9 2.25ZM3.75 9C3.75 6.10051 6.10051 3.75 9 3.75C11.8995 3.75 14.25 6.10051 14.25 9C14.25 11.8995 11.8995 14.25 9 14.25C6.10051 14.25 3.75 11.8995 3.75 9Z",
        fill: "#4B5563"
    }));
};
const $e959f086e329e090$var$zoom_out = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $e959f086e329e090$var$classNames__default["default"]("helix-icon", "zoom-out-outlined", className);
    return $e959f086e329e090$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e959f086e329e090$var$React__default["default"].createElement("path", {
        d: "M5.75 8.25C5.33579 8.25 5 8.58579 5 9C5 9.41421 5.33579 9.75 5.75 9.75H12.25C12.6642 9.75 13 9.41421 13 9C13 8.58579 12.6642 8.25 12.25 8.25H5.75Z",
        fill: "#4B5563"
    }), $e959f086e329e090$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9 2.25C5.27208 2.25 2.25 5.27208 2.25 9C2.25 12.7279 5.27208 15.75 9 15.75C10.5938 15.75 12.0585 15.1976 13.2133 14.2739L15.9697 17.0303C16.2626 17.3232 16.7374 17.3232 17.0303 17.0303C17.3232 16.7374 17.3232 16.2626 17.0303 15.9697L14.2739 13.2133C15.1976 12.0585 15.75 10.5938 15.75 9C15.75 5.27208 12.7279 2.25 9 2.25ZM3.75 9C3.75 6.10051 6.10051 3.75 9 3.75C11.8995 3.75 14.25 6.10051 14.25 9C14.25 11.8995 11.8995 14.25 9 14.25C6.10051 14.25 3.75 11.8995 3.75 9Z",
        fill: "#4B5563"
    }));
};
module.exports.arrows_exchange = $bpXRA.arrows_exchange;
module.exports.bell = $bpXRA.bell;
module.exports.circle_user_checkmark = $bpXRA.circle_user_checkmark;
module.exports.cog_person = $bpXRA.cog_person;
module.exports.funnel_person = $bpXRA.funnel_person;
module.exports.home_compare = $bpXRA.home_compare;
module.exports.house_mobile = $bpXRA.house_mobile;
module.exports.line_chart_loop = $bpXRA.line_chart_loop;
module.exports.magnet = $bpXRA.magnet;
module.exports.open_door = $bpXRA.open_door;
module.exports.person_frame = $bpXRA.person_frame;
module.exports.rocket = $bpXRA.rocket;
module.exports.screen_bar_chart = $bpXRA.screen_bar_chart;
module.exports.screen_percentage = $bpXRA.screen_percentage;
module.exports.search_home = $bpXRA.search_home;
module.exports.signature = $bpXRA.signature;
module.exports.store = $bpXRA.store;
module.exports.transaction_workflow = $bpXRA.transaction_workflow;
module.exports.workspace = $bpXRA.workspace;
module.exports.add_to_list = $e959f086e329e090$var$add_to_list;
module.exports.add_user = $e959f086e329e090$var$add_user;
module.exports.agent = $e959f086e329e090$var$agent;
module.exports.app_grid = $e959f086e329e090$var$app_grid;
module.exports.archive = $e959f086e329e090$var$archive;
module.exports.archive_restore = $e959f086e329e090$var$archive_restore;
module.exports.arrow_chart_line = $e959f086e329e090$var$arrow_chart_line;
module.exports.arrow_chart_line_down = $e959f086e329e090$var$arrow_chart_line_down;
module.exports.arrow_down = $e959f086e329e090$var$arrow_down;
module.exports.arrow_left = $e959f086e329e090$var$arrow_left;
module.exports.arrow_right = $e959f086e329e090$var$arrow_right;
module.exports.arrow_up = $e959f086e329e090$var$arrow_up;
module.exports.arrows_left_right = $e959f086e329e090$var$arrows_left_right;
module.exports.arrows_up_down = $e959f086e329e090$var$arrows_up_down;
module.exports.avg_bar_chart = $e959f086e329e090$var$avg_bar_chart;
module.exports.banking_reconciliation = $e959f086e329e090$var$banking_reconciliation;
module.exports.bathtub = $e959f086e329e090$var$bathtub;
module.exports.bed = $e959f086e329e090$var$bed;
module.exports.bell_notification = $e959f086e329e090$var$bell_notification;
module.exports.book = $e959f086e329e090$var$book;
module.exports.bookmark = $e959f086e329e090$var$bookmark;
module.exports.box_size = $e959f086e329e090$var$box_size;
module.exports.briefcase = $e959f086e329e090$var$briefcase;
module.exports.browser = $e959f086e329e090$var$browser;
module.exports.building_bank = $e959f086e329e090$var$building_bank;
module.exports.building_condo = $e959f086e329e090$var$building_condo;
module.exports.building_modern = $e959f086e329e090$var$building_modern;
module.exports.buyer_demand = $e959f086e329e090$var$buyer_demand;
module.exports.calculator = $e959f086e329e090$var$calculator;
module.exports.calendar = $e959f086e329e090$var$calendar;
module.exports.calendar_check = $e959f086e329e090$var$calendar_check;
module.exports.calendar_hammer = $e959f086e329e090$var$calendar_hammer;
module.exports.camera = $e959f086e329e090$var$camera;
module.exports.camera_video = $e959f086e329e090$var$camera_video;
module.exports.car = $e959f086e329e090$var$car;
module.exports.cards = $e959f086e329e090$var$cards;
module.exports.caret_down = $e959f086e329e090$var$caret_down;
module.exports.caret_left = $e959f086e329e090$var$caret_left;
module.exports.caret_right = $e959f086e329e090$var$caret_right;
module.exports.caret_up = $e959f086e329e090$var$caret_up;
module.exports.category = $e959f086e329e090$var$category;
module.exports.chart_dollar = $e959f086e329e090$var$chart_dollar;
module.exports.chart_pie = $e959f086e329e090$var$chart_pie;
module.exports.chart_pyramid = $e959f086e329e090$var$chart_pyramid;
module.exports.checkmark = $e959f086e329e090$var$checkmark;
module.exports.chevron_down = $e959f086e329e090$var$chevron_down;
module.exports.chevron_left = $e959f086e329e090$var$chevron_left;
module.exports.chevron_long_down = $e959f086e329e090$var$chevron_long_down;
module.exports.chevron_long_up = $e959f086e329e090$var$chevron_long_up;
module.exports.chevron_right = $e959f086e329e090$var$chevron_right;
module.exports.chevron_small_down = $e959f086e329e090$var$chevron_small_down;
module.exports.chevron_small_left = $e959f086e329e090$var$chevron_small_left;
module.exports.chevron_small_right = $e959f086e329e090$var$chevron_small_right;
module.exports.chevron_small_up = $e959f086e329e090$var$chevron_small_up;
module.exports.chevron_up = $e959f086e329e090$var$chevron_up;
module.exports.circle_checkmark = $e959f086e329e090$var$circle_checkmark;
module.exports.circle_info = $e959f086e329e090$var$circle_info;
module.exports.circle_question = $e959f086e329e090$var$circle_question;
module.exports.clicks = $e959f086e329e090$var$clicks;
module.exports.clock = $e959f086e329e090$var$clock;
module.exports.cog = $e959f086e329e090$var$cog;
module.exports.cog_notification = $e959f086e329e090$var$cog_notification;
module.exports.coin = $e959f086e329e090$var$coin;
module.exports.collections = $e959f086e329e090$var$collections;
module.exports.columns = $e959f086e329e090$var$columns;
module.exports.command = $e959f086e329e090$var$command;
module.exports.comment = $e959f086e329e090$var$comment;
module.exports.comment_attention = $e959f086e329e090$var$comment_attention;
module.exports.comment_notification = $e959f086e329e090$var$comment_notification;
module.exports.copy = $e959f086e329e090$var$copy;
module.exports.cross_market_demand = $e959f086e329e090$var$cross_market_demand;
module.exports.dash_indeterminate = $e959f086e329e090$var$dash_indeterminate;
module.exports.date_range = $e959f086e329e090$var$date_range;
module.exports.diamond_exclamation = $e959f086e329e090$var$diamond_exclamation;
module.exports.doc = $e959f086e329e090$var$doc;
module.exports.document_csv = $e959f086e329e090$var$document_csv;
module.exports.document_list = $e959f086e329e090$var$document_list;
module.exports.document_pdf = $e959f086e329e090$var$document_pdf;
module.exports.document_question_mark = $e959f086e329e090$var$document_question_mark;
module.exports.document_signed = $e959f086e329e090$var$document_signed;
module.exports.document_warning = $e959f086e329e090$var$document_warning;
module.exports.dollar_bill = $e959f086e329e090$var$dollar_bill;
module.exports.dots = $e959f086e329e090$var$dots;
module.exports.drag_arrows = $e959f086e329e090$var$drag_arrows;
module.exports.drag_handle = $e959f086e329e090$var$drag_handle;
module.exports.drawer_close = $e959f086e329e090$var$drawer_close;
module.exports.drawer_open = $e959f086e329e090$var$drawer_open;
module.exports.email = $e959f086e329e090$var$email;
module.exports.export_icon = $e959f086e329e090$var$export_icon;
module.exports.eye = $e959f086e329e090$var$eye;
module.exports.eye_off = $e959f086e329e090$var$eye_off;
module.exports.filter = $e959f086e329e090$var$filter;
module.exports.finalized = $e959f086e329e090$var$finalized;
module.exports.folder = $e959f086e329e090$var$folder;
module.exports.folders = $e959f086e329e090$var$folders;
module.exports.for_rent = $e959f086e329e090$var$for_rent;
module.exports.form_editor = $e959f086e329e090$var$form_editor;
module.exports.format_strikethrough = $e959f086e329e090$var$format_strikethrough;
module.exports.gesture = $e959f086e329e090$var$gesture;
module.exports.gift = $e959f086e329e090$var$gift;
module.exports.headphones = $e959f086e329e090$var$headphones;
module.exports.heart = $e959f086e329e090$var$heart;
module.exports.home = $e959f086e329e090$var$home;
module.exports.home_chart = $e959f086e329e090$var$home_chart;
module.exports.home_checkmark = $e959f086e329e090$var$home_checkmark;
module.exports.home_dollar = $e959f086e329e090$var$home_dollar;
module.exports.home_heart = $e959f086e329e090$var$home_heart;
module.exports.home_multi = $e959f086e329e090$var$home_multi;
module.exports.home_percentage = $e959f086e329e090$var$home_percentage;
module.exports.import_icon = $e959f086e329e090$var$import_icon;
module.exports.inbox = $e959f086e329e090$var$inbox;
module.exports.key = $e959f086e329e090$var$key;
module.exports.key_hand = $e959f086e329e090$var$key_hand;
module.exports.launch = $e959f086e329e090$var$launch;
module.exports.lightbulb = $e959f086e329e090$var$lightbulb;
module.exports.line_chart = $e959f086e329e090$var$line_chart;
module.exports.link = $e959f086e329e090$var$link;
module.exports.list = $e959f086e329e090$var$list;
module.exports.list_reorder = $e959f086e329e090$var$list_reorder;
module.exports.location = $e959f086e329e090$var$location;
module.exports.lock = $e959f086e329e090$var$lock;
module.exports.lock_unlock = $e959f086e329e090$var$lock_unlock;
module.exports.lockbox = $e959f086e329e090$var$lockbox;
module.exports.lot = $e959f086e329e090$var$lot;
module.exports.map = $e959f086e329e090$var$map;
module.exports.map_area = $e959f086e329e090$var$map_area;
module.exports.map_pin = $e959f086e329e090$var$map_pin;
module.exports.matching_buyers = $e959f086e329e090$var$matching_buyers;
module.exports.megaphone = $e959f086e329e090$var$megaphone;
module.exports.menu = $e959f086e329e090$var$menu;
module.exports.merge = $e959f086e329e090$var$merge;
module.exports.message_new = $e959f086e329e090$var$message_new;
module.exports.minus = $e959f086e329e090$var$minus;
module.exports.more_horizontal = $e959f086e329e090$var$more_horizontal;
module.exports.more_vertical = $e959f086e329e090$var$more_vertical;
module.exports.number_range = $e959f086e329e090$var$number_range;
module.exports.origin = $e959f086e329e090$var$origin;
module.exports.outbox = $e959f086e329e090$var$outbox;
module.exports.paperclip = $e959f086e329e090$var$paperclip;
module.exports.pencil = $e959f086e329e090$var$pencil;
module.exports.percentage = $e959f086e329e090$var$percentage;
module.exports.phone = $e959f086e329e090$var$phone;
module.exports.photo = $e959f086e329e090$var$photo;
module.exports.piggy = $e959f086e329e090$var$piggy;
module.exports.play = $e959f086e329e090$var$play;
module.exports.play_circle = $e959f086e329e090$var$play_circle;
module.exports.player_video = $e959f086e329e090$var$player_video;
module.exports.plug = $e959f086e329e090$var$plug;
module.exports.plus = $e959f086e329e090$var$plus;
module.exports.plus_small = $e959f086e329e090$var$plus_small;
module.exports.printer = $e959f086e329e090$var$printer;
module.exports.priority_high = $e959f086e329e090$var$priority_high;
module.exports.priority_low = $e959f086e329e090$var$priority_low;
module.exports.priority_medium = $e959f086e329e090$var$priority_medium;
module.exports.priority_none = $e959f086e329e090$var$priority_none;
module.exports.reclaim = $e959f086e329e090$var$reclaim;
module.exports.refresh = $e959f086e329e090$var$refresh;
module.exports.resize_to_fit = $e959f086e329e090$var$resize_to_fit;
module.exports.return_icon = $e959f086e329e090$var$return_icon;
module.exports.robot = $e959f086e329e090$var$robot;
module.exports.school = $e959f086e329e090$var$school;
module.exports.screen_line_chart = $e959f086e329e090$var$screen_line_chart;
module.exports.search = $e959f086e329e090$var$search;
module.exports.search_user = $e959f086e329e090$var$search_user;
module.exports.send = $e959f086e329e090$var$send;
module.exports.share = $e959f086e329e090$var$share;
module.exports.shared = $e959f086e329e090$var$shared;
module.exports.shield_home = $e959f086e329e090$var$shield_home;
module.exports.shield_key = $e959f086e329e090$var$shield_key;
module.exports.shopping_cart = $e959f086e329e090$var$shopping_cart;
module.exports.shopping_cart_filled = $e959f086e329e090$var$shopping_cart_filled;
module.exports.short_text = $e959f086e329e090$var$short_text;
module.exports.sign_for_sale = $e959f086e329e090$var$sign_for_sale;
module.exports.sign_in_ground = $e959f086e329e090$var$sign_in_ground;
module.exports.sign_sold = $e959f086e329e090$var$sign_sold;
module.exports.skip_left = $e959f086e329e090$var$skip_left;
module.exports.skip_right = $e959f086e329e090$var$skip_right;
module.exports.smiley_negative_one = $e959f086e329e090$var$smiley_negative_one;
module.exports.smiley_negative_two = $e959f086e329e090$var$smiley_negative_two;
module.exports.smiley_neutral = $e959f086e329e090$var$smiley_neutral;
module.exports.smiley_positive_one = $e959f086e329e090$var$smiley_positive_one;
module.exports.smiley_positive_two = $e959f086e329e090$var$smiley_positive_two;
module.exports.source = $e959f086e329e090$var$source;
module.exports.sparkle = $e959f086e329e090$var$sparkle;
module.exports.spinner = $e959f086e329e090$var$spinner;
module.exports.split = $e959f086e329e090$var$split;
module.exports.stamp = $e959f086e329e090$var$stamp;
module.exports.star = $e959f086e329e090$var$star;
module.exports.star_rising = $e959f086e329e090$var$star_rising;
module.exports.status = $e959f086e329e090$var$status;
module.exports.sticky_note = $e959f086e329e090$var$sticky_note;
module.exports.string_range = $e959f086e329e090$var$string_range;
module.exports.tags = $e959f086e329e090$var$tags;
module.exports.tbd = $e959f086e329e090$var$tbd;
module.exports.template_apply = $e959f086e329e090$var$template_apply;
module.exports.template_remove = $e959f086e329e090$var$template_remove;
module.exports.text_message = $e959f086e329e090$var$text_message;
module.exports.thumb_down = $e959f086e329e090$var$thumb_down;
module.exports.thumb_up = $e959f086e329e090$var$thumb_up;
module.exports.title = $e959f086e329e090$var$title;
module.exports.to_dos = $e959f086e329e090$var$to_dos;
module.exports.toolkit = $e959f086e329e090$var$toolkit;
module.exports.tour = $e959f086e329e090$var$tour;
module.exports.trash_can = $e959f086e329e090$var$trash_can;
module.exports.user = $e959f086e329e090$var$user;
module.exports.user_edit = $e959f086e329e090$var$user_edit;
module.exports.version_history = $e959f086e329e090$var$version_history;
module.exports.video_library = $e959f086e329e090$var$video_library;
module.exports.warning = $e959f086e329e090$var$warning;
module.exports.wolfie = $e959f086e329e090$var$wolfie;
module.exports.x = $e959f086e329e090$var$x;
module.exports.x_small = $e959f086e329e090$var$x_small;
module.exports.zillow = $e959f086e329e090$var$zillow;
module.exports.zoom_in = $e959f086e329e090$var$zoom_in;
module.exports.zoom_out = $e959f086e329e090$var$zoom_out;

});
parcelRegister("klEzJ", function(module, exports) {

$parcel$export(module.exports, "__rest", () => $ed053e3a79d517bf$export$3c9a16f847548506, (v) => $ed053e3a79d517bf$export$3c9a16f847548506 = v);
var $ed053e3a79d517bf$export$3c9a16f847548506;
"use strict";
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $ed053e3a79d517bf$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
typeof SuppressedError === "function" && SuppressedError;
$ed053e3a79d517bf$export$3c9a16f847548506 = $ed053e3a79d517bf$var$__rest;

});

parcelRegister("bpXRA", function(module, exports) {

$parcel$export(module.exports, "arrows_exchange", () => $850077216abd752e$export$ce02a1f6e6ca19c4, (v) => $850077216abd752e$export$ce02a1f6e6ca19c4 = v);
$parcel$export(module.exports, "bell", () => $850077216abd752e$export$217fdd6335ecce6a, (v) => $850077216abd752e$export$217fdd6335ecce6a = v);
$parcel$export(module.exports, "circle_user_checkmark", () => $850077216abd752e$export$e7717cf17836740c, (v) => $850077216abd752e$export$e7717cf17836740c = v);
$parcel$export(module.exports, "cog_person", () => $850077216abd752e$export$114b5f004c59985a, (v) => $850077216abd752e$export$114b5f004c59985a = v);
$parcel$export(module.exports, "funnel_person", () => $850077216abd752e$export$d15357726965dff7, (v) => $850077216abd752e$export$d15357726965dff7 = v);
$parcel$export(module.exports, "home_compare", () => $850077216abd752e$export$79244f96c029f1f3, (v) => $850077216abd752e$export$79244f96c029f1f3 = v);
$parcel$export(module.exports, "house_mobile", () => $850077216abd752e$export$691cddcab9d098d, (v) => $850077216abd752e$export$691cddcab9d098d = v);
$parcel$export(module.exports, "line_chart_loop", () => $850077216abd752e$export$9aa65dd03156bd54, (v) => $850077216abd752e$export$9aa65dd03156bd54 = v);
$parcel$export(module.exports, "magnet", () => $850077216abd752e$export$fcc578ccc685d627, (v) => $850077216abd752e$export$fcc578ccc685d627 = v);
$parcel$export(module.exports, "open_door", () => $850077216abd752e$export$65504cc544439568, (v) => $850077216abd752e$export$65504cc544439568 = v);
$parcel$export(module.exports, "person_frame", () => $850077216abd752e$export$9a45756dd558ee0e, (v) => $850077216abd752e$export$9a45756dd558ee0e = v);
$parcel$export(module.exports, "rocket", () => $850077216abd752e$export$343c52c44ab28c8e, (v) => $850077216abd752e$export$343c52c44ab28c8e = v);
$parcel$export(module.exports, "screen_bar_chart", () => $850077216abd752e$export$34820eaa871a8135, (v) => $850077216abd752e$export$34820eaa871a8135 = v);
$parcel$export(module.exports, "screen_percentage", () => $850077216abd752e$export$70967e1ae0a94e22, (v) => $850077216abd752e$export$70967e1ae0a94e22 = v);
$parcel$export(module.exports, "search_home", () => $850077216abd752e$export$eb6b60d4d8f3380, (v) => $850077216abd752e$export$eb6b60d4d8f3380 = v);
$parcel$export(module.exports, "signature", () => $850077216abd752e$export$c9cd164b539ebb63, (v) => $850077216abd752e$export$c9cd164b539ebb63 = v);
$parcel$export(module.exports, "store", () => $850077216abd752e$export$6f57813fe9f31bf9, (v) => $850077216abd752e$export$6f57813fe9f31bf9 = v);
$parcel$export(module.exports, "transaction_workflow", () => $850077216abd752e$export$31b038c13ee11436, (v) => $850077216abd752e$export$31b038c13ee11436 = v);
$parcel$export(module.exports, "workspace", () => $850077216abd752e$export$ed275788a758bd76, (v) => $850077216abd752e$export$ed275788a758bd76 = v);
var $850077216abd752e$export$ce02a1f6e6ca19c4;
var $850077216abd752e$export$217fdd6335ecce6a;
var $850077216abd752e$export$e7717cf17836740c;
var $850077216abd752e$export$114b5f004c59985a;
var $850077216abd752e$export$d15357726965dff7;
var $850077216abd752e$export$79244f96c029f1f3;
var $850077216abd752e$export$691cddcab9d098d;
var $850077216abd752e$export$9aa65dd03156bd54;
var $850077216abd752e$export$fcc578ccc685d627;
var $850077216abd752e$export$65504cc544439568;
var $850077216abd752e$export$9a45756dd558ee0e;
var $850077216abd752e$export$343c52c44ab28c8e;
var $850077216abd752e$export$34820eaa871a8135;
var $850077216abd752e$export$70967e1ae0a94e22;
var $850077216abd752e$export$eb6b60d4d8f3380;
var $850077216abd752e$export$c9cd164b539ebb63;
var $850077216abd752e$export$6f57813fe9f31bf9;
var $850077216abd752e$export$31b038c13ee11436;
var $850077216abd752e$export$ed275788a758bd76;
"use strict";

var $klEzJ = parcelRequire("klEzJ");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");
function $850077216abd752e$var$_interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        "default": e
    };
}
var $850077216abd752e$var$React__default = /*#__PURE__*/ $850077216abd752e$var$_interopDefaultLegacy($acw62);
var $850077216abd752e$var$classNames__default = /*#__PURE__*/ $850077216abd752e$var$_interopDefaultLegacy($8g1PZ);
const $850077216abd752e$var$arrows_exchange = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $850077216abd752e$var$classNames__default["default"]("helix-icon", "arrows_exchange", className);
    return $850077216abd752e$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $850077216abd752e$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.25 8C4.25 8.41421 4.58579 8.75 5 8.75H16C16.3033 8.75 16.5768 8.56727 16.6929 8.28701C16.809 8.00676 16.7448 7.68417 16.5303 7.46967L12.5303 3.46967C12.2374 3.17678 11.7626 3.17678 11.4697 3.46967C11.1768 3.76256 11.1768 4.23744 11.4697 4.53033L14.1893 7.25H5C4.58579 7.25 4.25 7.58579 4.25 8Z",
        fill: "#4B5563"
    }), $850077216abd752e$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.81066 12.75L15 12.75C15.4142 12.75 15.75 12.4142 15.75 12C15.75 11.5858 15.4142 11.25 15 11.25L4 11.25C3.69665 11.25 3.42317 11.4327 3.30709 11.713C3.191 11.9932 3.25517 12.3158 3.46967 12.5303L7.46967 16.5303C7.76256 16.8232 8.23744 16.8232 8.53033 16.5303C8.82322 16.2374 8.82322 15.7626 8.53033 15.4697L5.81066 12.75Z",
        fill: "#4B5563"
    }));
};
const $850077216abd752e$var$bell = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $850077216abd752e$var$classNames__default["default"]("helix-icon", "bell-outlined", className);
    return $850077216abd752e$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $850077216abd752e$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.25 8.75C4.25 5.57436 6.82436 3 10 3C13.1756 3 15.75 5.57436 15.75 8.75V10.0368C15.75 11.0058 16.0368 11.9532 16.5743 12.7594L17.624 14.334C17.7775 14.5641 17.7918 14.86 17.6613 15.1039C17.5307 15.3478 17.2766 15.5 17 15.5H12.7388C12.6125 16.9016 11.4345 18 10 18C8.56549 18 7.38752 16.9016 7.26121 15.5H3C2.7234 15.5 2.46926 15.3478 2.33875 15.1039C2.20823 14.86 2.22254 14.5641 2.37596 14.334L3.42568 12.7594C3.96318 11.9532 4.25 11.0058 4.25 10.0368V8.75ZM8.77501 15.5C8.89082 16.0706 9.39526 16.5 10 16.5C10.6047 16.5 11.1092 16.0706 11.225 15.5H8.77501ZM10 4.5C7.65279 4.5 5.75 6.40279 5.75 8.75V10.0368C5.75 11.302 5.37552 12.5388 4.67375 13.5915L4.40139 14H15.5986L15.3263 13.5915C14.6245 12.5388 14.25 11.302 14.25 10.0368V8.75C14.25 6.40279 12.3472 4.5 10 4.5Z",
        fill: "#4B5563"
    }));
};
const $850077216abd752e$var$circle_user_checkmark = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $850077216abd752e$var$classNames__default["default"]("helix-icon", "circle_user_checkmark", className);
    return $850077216abd752e$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $850077216abd752e$var$React__default["default"].createElement("path", {
        d: "M8.5 8.5C8.5 9.32843 9.17157 10 10 10C10.8284 10 11.5 9.32843 11.5 8.5C11.5 7.67157 10.8284 7 10 7C9.17157 7 8.5 7.67157 8.5 8.5Z",
        fill: "#4B5563"
    }), $850077216abd752e$var$React__default["default"].createElement("path", {
        d: "M7 11.5V12C7 12.5523 7 13 8 13H11.126C11.3723 12.0431 11.9638 11.2247 12.7599 10.6856C12.4926 10.273 12.0282 10 11.5 10H10H8.5C7.67157 10 7 10.6716 7 11.5Z",
        fill: "#4B5563"
    }), $850077216abd752e$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 4.75C7.10051 4.75 4.75 7.10051 4.75 10C4.75 12.8995 7.10051 15.25 10 15.25C10.3984 15.25 10.7864 15.2056 11.1594 15.1216C11.3062 15.6253 11.5495 16.088 11.8679 16.4882C11.2747 16.6587 10.648 16.75 10 16.75C6.27208 16.75 3.25 13.7279 3.25 10C3.25 6.27208 6.27208 3.25 10 3.25C13.7279 3.25 16.75 6.27208 16.75 10C16.75 10.1331 16.7461 10.2653 16.7385 10.3966C16.2837 10.1767 15.7808 10.0404 15.25 10.0077L15.25 10C15.25 7.10051 12.8995 4.75 10 4.75ZM15 17C14.1667 17 13.4127 16.6602 12.8691 16.1117C12.5146 15.754 12.2496 15.3076 12.1103 14.8087C12.0384 14.5514 12 14.2802 12 14C12 13.6475 12.0608 13.3092 12.1725 12.9951C12.3423 12.5173 12.6297 12.0953 13 11.7639C13.03 11.737 13.0606 11.7107 13.0917 11.6851C13.6103 11.2571 14.2751 11 15 11C15.0517 11 15.1031 11.0013 15.1541 11.0039C15.6808 11.0305 16.1717 11.193 16.5923 11.457C17.4379 11.9876 18 12.9281 18 14C18 15.6569 16.6569 17 15 17ZM13.8536 13.6464L13.1464 14.3536L14.1313 15.3384L14.5 15.7071L16.8536 13.3536L16.1919 12.6919L16.1464 12.6464L14.5 14.2929L13.8536 13.6464Z",
        fill: "#4B5563"
    }));
};
const $850077216abd752e$var$cog_person = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $850077216abd752e$var$classNames__default["default"]("helix-icon", "cog-person-outlined", className);
    return $850077216abd752e$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $850077216abd752e$var$React__default["default"].createElement("path", {
        d: "M7 11.5C7 10.6716 7.67157 10 8.5 10H11.5C12.3284 10 13 10.6716 13 11.5V12C13 12.5523 12.5523 13 12 13H8C7.44772 13 7 12.5523 7 12V11.5Z",
        fill: "#4B5563"
    }), $850077216abd752e$var$React__default["default"].createElement("path", {
        d: "M8.5 8.5C8.5 7.67157 9.17157 7 10 7C10.8284 7 11.5 7.67157 11.5 8.5C11.5 9.32843 10.8284 10 10 10C9.17157 10 8.5 9.32843 8.5 8.5Z",
        fill: "#4B5563"
    }), $850077216abd752e$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.83593 2.28556C8.11426 2.21427 8.40926 2.25099 8.66162 2.38834C8.9125 2.52489 9.10274 2.75084 9.19461 3.02117C9.25281 3.18819 9.36145 3.33302 9.50552 3.43567C9.6502 3.53873 9.82341 3.59412 10.001 3.59412C10.1787 3.59412 10.3519 3.53873 10.4965 3.43567C10.6404 3.33317 10.7489 3.18861 10.8072 3.0219C10.8984 2.75187 11.0879 2.52594 11.3381 2.38916C11.5904 2.25127 11.8856 2.21424 12.1641 2.28555L12.1735 2.28796L12.1828 2.29061C12.795 2.46438 13.3842 2.71081 13.9379 3.02464L13.9456 3.02901L13.9532 3.03357C14.1879 3.17406 14.364 3.39461 14.4491 3.65461C14.5332 3.91183 14.5226 4.19055 14.4194 4.44053C14.3483 4.61954 14.3371 4.81679 14.3876 5.00274C14.4267 5.14593 14.5027 5.27638 14.6078 5.38111C14.7121 5.4849 14.8415 5.55984 14.9833 5.59863C15.194 5.65164 15.3844 5.6312 15.5443 5.56646C15.7948 5.46131 16.0747 5.4495 16.3332 5.53334C16.5945 5.61807 16.8161 5.79472 16.9569 6.03049L16.9609 6.03715L16.9647 6.04388C17.2827 6.60209 17.5319 7.19679 17.7067 7.81496L17.7093 7.82426L17.7117 7.83363C17.7829 8.11243 17.7456 8.40784 17.6074 8.6602C17.4704 8.91039 17.2443 9.0998 16.9742 9.19094C16.8074 9.24933 16.6627 9.358 16.5602 9.50203C16.457 9.64691 16.4016 9.82036 16.4017 9.99822C16.4017 10.1761 16.4573 10.3495 16.5605 10.4943C16.6631 10.6382 16.8077 10.7467 16.9745 10.805C17.2482 10.8972 17.4718 11.0889 17.607 11.3362C17.7449 11.5885 17.7819 11.8836 17.7106 12.1621L17.7081 12.1718L17.7054 12.1814C17.5465 12.7398 17.329 13.273 17.0597 13.7742L17.055 13.7828L17.0502 13.7912C16.9064 14.0428 16.6718 14.2298 16.3944 14.3139C16.1207 14.3968 15.8259 14.3732 15.569 14.248C15.3336 14.1383 15.0054 14.1124 14.5984 14.3822L14.6012 14.3804C14.5871 14.3898 14.575 14.4018 14.5654 14.4157C14.2893 14.8374 14.3258 15.1742 14.4493 15.4141C14.5852 15.6663 14.6203 15.9609 14.5472 16.2383C14.4729 16.5197 14.293 16.7616 14.0448 16.9136L14.0376 16.9181L14.0303 16.9223C13.4488 17.2608 12.8267 17.5241 12.1789 17.7061C11.566 17.8789 10.9916 17.5062 10.8086 16.9792L10.8072 16.9753C10.6905 16.6334 10.3723 16.3935 9.9999 16.3931C9.82166 16.3936 9.64802 16.4497 9.50326 16.5538C9.35912 16.6573 9.2508 16.8032 9.1933 16.971C9.10332 17.2428 8.91359 17.4704 8.66227 17.6079C8.40894 17.7464 8.11221 17.7828 7.8329 17.7096L7.82057 17.7064C7.1644 17.5224 6.53465 17.2548 5.94675 16.9101L5.93884 16.9055L5.93105 16.9007C5.68542 16.7485 5.50735 16.5081 5.43338 16.2288C5.36038 15.9531 5.39423 15.6602 5.52787 15.4086C5.64865 15.1715 5.68427 14.8344 5.40834 14.4137C5.39915 14.4004 5.38761 14.389 5.37427 14.38C4.96872 14.1135 4.64211 14.1386 4.40907 14.2457L4.40751 14.2464C3.90671 14.475 3.23764 14.3304 2.93309 13.7626L2.93219 13.7609C2.66603 13.2616 2.44862 12.7301 2.29052 12.1728L2.28788 12.1635L2.28548 12.1542C2.21456 11.8772 2.25077 11.5837 2.38685 11.3323C2.52152 11.0835 2.74418 10.8941 3.01108 10.801C3.17527 10.7412 3.31722 10.6325 3.41778 10.4895C3.51907 10.3455 3.57344 10.1737 3.57344 9.99761C3.57344 9.82153 3.51907 9.64975 3.41778 9.50573C3.317 9.36244 3.17465 9.25359 3.01001 9.19386C2.74346 9.10006 2.52135 8.91024 2.38718 8.66137C2.252 8.41063 2.21595 8.11825 2.28619 7.84219L2.28855 7.83291L2.29115 7.82369C2.46531 7.20562 2.71372 6.61092 3.03094 6.0526L3.03488 6.04568L3.03896 6.03883C3.1789 5.80428 3.39873 5.62805 3.65812 5.54249C3.91493 5.45778 4.19346 5.46757 4.44356 5.56993C4.59976 5.63162 4.77062 5.64629 4.93509 5.61209C5.1007 5.57765 5.25249 5.4952 5.37153 5.37503C5.49056 5.25485 5.57156 5.10228 5.60442 4.93635C5.63727 4.77042 5.62052 4.59849 5.55626 4.44203L5.55495 4.43884C5.45323 4.18787 5.44519 3.90867 5.53231 3.65225C5.61942 3.39584 5.79588 3.17933 6.02944 3.04226L6.03732 3.03764C6.59123 2.72159 7.18781 2.46729 7.81934 2.29001L7.82761 2.28769L7.83593 2.28556ZM7.91456 3.83004C7.61647 3.9307 7.32782 4.05312 7.04996 4.19504C7.13437 4.53178 7.14382 4.88442 7.07585 5.2277C6.98576 5.6827 6.76364 6.10108 6.43723 6.43062C6.11082 6.76016 5.69457 6.98625 5.24045 7.08068C4.89241 7.15304 4.53395 7.14561 4.19157 7.06072C4.05053 7.3386 3.92982 7.62633 3.83038 7.92165C4.15298 8.09444 4.43234 8.34086 4.6447 8.64278C4.9237 9.03947 5.07344 9.51263 5.07344 9.99761C5.07344 10.4826 4.9237 10.9557 4.6447 11.3524C4.4323 11.6544 4.15287 11.9009 3.8302 12.0737C3.90998 12.3087 4.00304 12.5382 4.10827 12.7613C4.761 12.5717 5.50152 12.6674 6.20175 13.1289L6.20472 13.1308C6.38257 13.2493 6.53542 13.4015 6.65458 13.5789L6.65819 13.5842C7.14533 14.323 7.22448 15.1038 6.99639 15.7768C7.29081 15.9295 7.59658 16.0593 7.91098 16.1651C8.08064 15.8375 8.32572 15.5528 8.62799 15.3356C9.02715 15.0488 9.50605 14.8941 9.99757 14.8931L9.99904 14.8931C10.9134 14.8931 11.6967 15.4128 12.0875 16.165C12.3946 16.0616 12.6935 15.9352 12.9817 15.787C12.75 15.1129 12.826 14.3304 13.3145 13.5879L13.3177 13.583C13.4366 13.4053 13.5892 13.2527 13.7669 13.1338L13.7696 13.132C14.4794 12.6615 15.2299 12.5698 15.8878 12.7682C15.9925 12.5469 16.0851 12.3188 16.1648 12.0845C15.8383 11.9137 15.555 11.6678 15.3392 11.3651C15.0548 10.9662 14.9018 10.4886 14.9017 9.99871C14.9015 9.50883 15.0541 9.0311 15.3383 8.63203C15.5545 8.32833 15.8387 8.0817 16.1663 7.91059C16.067 7.61733 15.9467 7.3316 15.8064 7.0556C15.4287 7.15195 15.0194 7.15628 14.607 7.05066L14.5987 7.04855C14.2022 6.94219 13.8405 6.73376 13.5495 6.44412C13.2586 6.15447 13.0486 5.79367 12.9405 5.39762C12.8323 4.99967 12.8291 4.58167 12.929 4.18525C12.6569 4.04758 12.3755 3.9293 12.0869 3.83129C11.9159 4.15799 11.6699 4.44152 11.3669 4.65735C10.9681 4.94144 10.4907 5.09412 10.001 5.09412C9.51141 5.09412 9.03396 4.94144 8.63518 4.65735C8.33184 4.44124 8.08549 4.15727 7.91456 3.83004Z",
        fill: "#4B5563"
    }));
};
const $850077216abd752e$var$funnel_person = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $850077216abd752e$var$classNames__default["default"]("helix-icon", "funned-person-outlined", className);
    return $850077216abd752e$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $850077216abd752e$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.2372 3.28851C17.6301 3.41949 17.8425 3.84423 17.7115 4.23719L13.7115 16.2372C13.5805 16.6301 13.1558 16.8425 12.7628 16.7115C12.3699 16.5805 12.1575 16.1558 12.2885 15.7628L16.2885 3.76285C16.4195 3.36989 16.8442 3.15752 17.2372 3.28851Z",
        fill: "#4B5563"
    }), $850077216abd752e$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.76285 3.28851C2.36989 3.41949 2.15752 3.84423 2.28851 4.23719L6.28851 16.2372C6.41949 16.6301 6.84423 16.8425 7.23719 16.7115C7.63015 16.5805 7.84252 16.1558 7.71153 15.7628L3.71153 3.76285C3.58055 3.36989 3.15581 3.15752 2.76285 3.28851Z",
        fill: "#4B5563"
    }), $850077216abd752e$var$React__default["default"].createElement("path", {
        d: "M7.00002 9.50002C7.00002 8.67159 7.67159 8.00002 8.50002 8.00002H11.5C12.3284 8.00002 13 8.67159 13 9.50002V10C13 10.5523 12.5523 11 12 11H8.00002C7.44774 11 7.00002 10.5523 7.00002 10V9.50002Z",
        fill: "#4B5563"
    }), $850077216abd752e$var$React__default["default"].createElement("path", {
        d: "M8.50002 6.50002C8.50002 5.67159 9.17159 5.00002 10 5.00002C10.8284 5.00002 11.5 5.67159 11.5 6.50002C11.5 7.32845 10.8284 8.00002 10 8.00002C9.17159 8.00002 8.50002 7.32845 8.50002 6.50002Z",
        fill: "#4B5563"
    }));
};
const $850077216abd752e$var$home_compare = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $850077216abd752e$var$classNames__default["default"]("helix-icon", "home-compare-outlined", className);
    return $850077216abd752e$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $850077216abd752e$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        // eslint-disable-next-line max-len
        d: "M4.09126 3.37117C4.33981 3.20961 4.66019 3.20961 4.90874 3.37117L8.40874 5.64617C8.62159 5.78452 8.75 6.02114 8.75 6.275V11C8.75 11.4142 8.41421 11.75 8 11.75H1C0.585786 11.75 0.25 11.4142 0.25 11V6.275C0.25 6.02114 0.378414 5.78452 0.591259 5.64617L4.09126 3.37117ZM15.0913 3.37117C15.3398 3.20961 15.6602 3.20961 15.9087 3.37117L19.4087 5.64617C19.6216 5.78452 19.75 6.02114 19.75 6.275V11C19.75 11.4142 19.4142 11.75 19 11.75H12C11.5858 11.75 11.25 11.4142 11.25 11V6.275C11.25 6.02114 11.3784 5.78452 11.5913 5.64617L15.0913 3.37117ZM1.75 6.68201V10.25H3.75V8.75C3.75 8.33579 4.08579 8 4.5 8C4.91421 8 5.25 8.33579 5.25 8.75V10.25H7.25V6.68201L4.5 4.89451L1.75 6.68201ZM12.75 6.68201V10.25H14.75V8.75C14.75 8.33579 15.0858 8 15.5 8C15.9142 8 16.25 8.33579 16.25 8.75V10.25H18.25V6.68201L15.5 4.89451L12.75 6.68201ZM2 15.25C2 14.8358 2.33579 14.5 2.75 14.5H6.25C6.66421 14.5 7 14.8358 7 15.25C7 15.6642 6.66421 16 6.25 16H2.75C2.33579 16 2 15.6642 2 15.25ZM13 15.25C13 14.8358 13.3358 14.5 13.75 14.5H17.25C17.6642 14.5 18 14.8358 18 15.25C18 15.6642 17.6642 16 17.25 16H13.75C13.3358 16 13 15.6642 13 15.25Z",
        fill: "#4B5563"
    }));
};
const $850077216abd752e$var$house_mobile = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $850077216abd752e$var$classNames__default["default"]("helix-icon", "house-mobile-outlined", className);
    return $850077216abd752e$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $850077216abd752e$var$React__default["default"].createElement("path", {
        d: "M8 9.34615V12H12V9.34615L10 8L8 9.34615Z",
        fill: "#4B5563"
    }), $850077216abd752e$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        // eslint-disable-next-line max-len
        d: "M5 4C5 3.44772 5.44772 3 6 3H14C14.5523 3 15 3.44772 15 4V16C15 16.5523 14.5523 17 14 17H6C5.44772 17 5 16.5523 5 16V4ZM6.5 15.5V4.5H13.5V15.5H6.5Z",
        fill: "#4B5563"
    }));
};
const $850077216abd752e$var$line_chart_loop = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $850077216abd752e$var$classNames__default["default"]("helix-icon", "line-chart-loop-outlined", className);
    return $850077216abd752e$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $850077216abd752e$var$React__default["default"].createElement("path", {
        d: "M17.1606 3.95081C17.357 3.58611 17.2205 3.13126 16.8558 2.93488C16.4911 2.73851 16.0362 2.87496 15.8399 3.23966L13.009 8.49707C13.5775 8.35285 14.1643 8.35306 14.7195 8.48426L17.1606 3.95081Z",
        fill: "#4B5563"
    }), $850077216abd752e$var$React__default["default"].createElement("path", {
        d: "M11.3164 9.47208L10.4952 8.65083L8.18671 13.8973C8.087 14.1239 7.88186 14.2867 7.63851 14.3324C7.39517 14.378 7.14497 14.3006 6.9699 14.1256L5.20569 12.3614L3.67105 15.4306C3.4858 15.8011 3.0353 15.9513 2.66482 15.7661C2.29433 15.5808 2.14416 15.1303 2.3294 14.7598L4.32941 10.7598C4.43722 10.5442 4.64212 10.3935 4.88009 10.3549C5.11806 10.3163 5.36008 10.3944 5.53056 10.5649L7.2553 12.2896L9.56374 7.04318C9.66345 6.81656 9.86859 6.65375 10.1119 6.6081C10.3553 6.56245 10.6055 6.63983 10.7806 6.81491L12.595 8.62933C12.4242 8.69556 12.2563 8.7757 12.0927 8.87013C11.8006 9.03877 11.5411 9.24217 11.3164 9.47208Z",
        fill: "#4B5563"
    }), $850077216abd752e$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.558 9.67617C11.2816 10.4131 10.8443 12.0452 11.5812 13.3215C12.1879 14.3724 13.4014 14.8545 14.5236 14.5808L15.6888 16.5989L16.9878 15.8489L15.8227 13.8307C16.6208 12.9958 16.81 11.7038 16.2033 10.6529C15.4664 9.37657 13.8343 8.93926 12.558 9.67617ZM12.8802 12.5715C12.5575 12.0126 12.749 11.2979 13.308 10.9752C13.8669 10.6525 14.5816 10.844 14.9043 11.4029C15.227 11.9619 15.0355 12.6765 14.4765 12.9992C13.9176 13.3219 13.2029 13.1304 12.8802 12.5715Z",
        fill: "#4B5563"
    }));
};
const $850077216abd752e$var$magnet = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $850077216abd752e$var$classNames__default["default"]("helix-icon", "magnet-outlined", className);
    return $850077216abd752e$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $850077216abd752e$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.96967 4.75013C6.53184 4.76647 3.75 7.5584 3.75 11.0001C3.75 14.4417 6.53185 17.2337 9.96968 17.25L14.5623 16.8673C14.9514 16.8348 15.25 16.5102 15.25 16.1205V15.5001H16.75V16.1205C16.75 17.2911 15.8526 18.2649 14.6869 18.3621L10.0312 18.7501H10C5.71979 18.7501 2.25 15.2803 2.25 11.0001C2.25 6.71986 5.71979 3.25006 10 3.25006L10.0312 3.25006L14.6869 3.63803C15.853 3.73521 16.75 4.71006 16.75 5.88026V7.00006L15.25 7.00006V5.88026C15.25 5.49019 14.951 5.16525 14.5623 5.13285L9.96967 4.75013Z",
        fill: "#4B5563"
    }), $850077216abd752e$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.75 7.00006V7.41766C16.75 8.43867 15.8795 9.24287 14.8617 9.16218L9.66545 8.75029C8.67701 8.76676 7.75 9.69088 7.75 11.0001C7.75 12.3092 8.67701 13.2334 9.66545 13.2498L14.8617 12.8379C15.8795 12.7573 16.75 13.5615 16.75 14.5825V15.5001H15.25V14.5825C15.25 14.4366 15.1256 14.3217 14.9802 14.3332L9.72199 14.7501H9.69231C7.7169 14.7501 6.25 12.9927 6.25 11.0001C6.25 9.00739 7.7169 7.25006 9.69231 7.25006H9.72198L14.9802 7.66687C15.1256 7.6784 15.25 7.56352 15.25 7.41766V7.00006L16.75 7.00006Z",
        fill: "#4B5563"
    }), $850077216abd752e$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 8.00006V4.00006L13.5 4.00006V8.00006H12Z",
        fill: "#4B5563"
    }), $850077216abd752e$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 18.0001V14.0001H13.5V18.0001H12Z",
        fill: "#4B5563"
    }));
};
const $850077216abd752e$var$open_door = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $850077216abd752e$var$classNames__default["default"]("helix-icon", "open-door-outlined", className);
    return $850077216abd752e$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $850077216abd752e$var$React__default["default"].createElement("path", {
        d: "M10 10.75C10 11.1642 9.66421 11.5 9.25 11.5C8.83579 11.5 8.5 11.1642 8.5 10.75C8.5 10.3357 8.83579 9.99995 9.25 9.99995C9.66421 9.99995 10 10.3357 10 10.75Z",
        fill: "#4B5563"
    }), $850077216abd752e$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.25 4.99994C4.25 4.03344 5.0335 3.24994 6 3.24994H13C13.9665 3.24994 14.75 4.03344 14.75 4.99994V16.2499H16C16.4142 16.2499 16.75 16.5857 16.75 16.9999C16.75 17.4142 16.4142 17.7499 16 17.7499H3C2.58579 17.7499 2.25 17.4142 2.25 16.9999C2.25 16.5857 2.58579 16.2499 3 16.2499H4.25V4.99994ZM5.75 16.2499H10.75V4.74994H6C5.86193 4.74994 5.75 4.86187 5.75 4.99994V16.2499ZM12.25 4.74994V16.2499H13.25V4.99994C13.25 4.86187 13.1381 4.74994 13 4.74994H12.25Z",
        fill: "#4B5563"
    }));
};
const $850077216abd752e$var$person_frame = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $850077216abd752e$var$classNames__default["default"]("helix-icon", "person-frame-outlined", className);
    return $850077216abd752e$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $850077216abd752e$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4 2H7V3.5H4C3.72386 3.5 3.5 3.72386 3.5 4V7H2V4C2 2.89543 2.89543 2 4 2ZM2 16V13H3.5V16C3.5 16.2761 3.72386 16.5 4 16.5H7V18H4C2.89543 18 2 17.1046 2 16ZM13 2H16C17.1046 2 18 2.89543 18 4V7H16.5V4C16.5 3.72386 16.2761 3.5 16 3.5H13V2ZM18 13V16C18 17.1046 17.1046 18 16 18H13V16.5H16C16.2761 16.5 16.5 16.2761 16.5 16V13H18ZM12 7C12 8.08333 11.0449 9 9.96153 9C8.87821 9 8 8.08333 8 7C8 5.91667 8.5 5 9.96153 5C11.4231 5 12 5.91667 12 7ZM6 12.6603C6 10.6615 6.67107 10 8.0036 10H12.0012C13.3337 10 14 10.8949 14 11.9988V13.9976H6.0048L6 12.6603Z",
        fill: "#4B5563"
    }));
};
const $850077216abd752e$var$rocket = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $850077216abd752e$var$classNames__default["default"]("helix-icon", "rocket-solid", className);
    return $850077216abd752e$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $850077216abd752e$var$React__default["default"].createElement("path", {
        d: "M10.7783 7.49128C11.1688 7.10076 11.8019 7.10076 12.1924 7.49128C12.5828 7.88181 12.5829 8.51485 12.1924 8.90534C11.8019 9.29579 11.1688 9.29575 10.7783 8.90534C10.3878 8.51483 10.3878 7.88181 10.7783 7.49128Z",
        fill: "#4B5563"
    }), $850077216abd752e$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.5576 2.503C16.4887 2.44651 17.2363 3.19497 17.1797 4.12605C17.0932 5.54427 16.5936 8.39283 14.1367 10.8497C13.8517 11.1347 13.5556 11.3947 13.2588 11.6348L12.5742 15.0626C12.5452 15.2078 12.4738 15.3417 12.3691 15.4464L10.6016 17.2139C10.461 17.3545 10.2701 17.4336 10.0713 17.4337C9.87248 17.4337 9.68165 17.3545 9.54102 17.2139L7.06641 14.7403C6.82893 14.8003 6.60607 14.8444 6.40918 14.8751C6.14321 14.9165 5.91576 14.9368 5.75293 14.9473C5.6714 14.9526 5.60478 14.9557 5.55762 14.9571C5.53408 14.9578 5.51485 14.9579 5.50098 14.9581H4.72461V14.1827C4.72481 14.1689 4.72586 14.1495 4.72656 14.126C4.72797 14.0789 4.73105 14.0123 4.73633 13.9307C4.74688 13.7679 4.76718 13.5405 4.80859 13.2745C4.83935 13.077 4.88116 12.8526 4.94141 12.6143L2.46973 10.1426C2.32908 10.002 2.25 9.81128 2.25 9.61238C2.25 9.41347 2.32908 9.22275 2.46973 9.0821L4.2373 7.31452C4.34201 7.20982 4.4759 7.13848 4.62109 7.10945L8.07129 6.41902C8.29733 6.12515 8.5493 5.83164 8.83398 5.54695C11.2908 3.0901 14.1394 2.58949 15.5576 2.503ZM11.2334 12.9444C10.7781 13.1685 10.3439 13.3349 9.96289 13.4376C9.74908 13.4952 9.51839 13.542 9.29297 13.5548C9.19377 13.6422 9.08547 13.7331 8.97754 13.8194C8.85333 13.9187 8.71026 14.0258 8.56934 14.1202L10.0713 15.6231L11.1484 14.546L11.4951 12.8087C11.4065 12.8557 11.3197 12.9019 11.2334 12.9444ZM6.93262 11.7774C6.83781 11.9032 6.76862 12.0027 6.73828 12.0606C6.51686 12.4838 6.39077 12.9585 6.31738 13.3663C6.72517 13.2929 7.19887 13.1658 7.62207 12.9444C7.67998 12.9141 7.78033 12.846 7.90625 12.751L6.93262 11.7774ZM15.6484 4.00007C14.4366 4.07399 11.9983 4.50376 9.89453 6.60749C8.52707 7.97498 8.03038 9.51737 7.74023 10.463L9.31934 12.0421C9.38309 12.0321 9.46773 12.0187 9.57324 11.9903C9.84178 11.9179 10.184 11.7894 10.5713 11.5987C11.3456 11.2175 12.2547 10.6106 13.0762 9.78913C15.1798 7.68555 15.6087 5.24719 15.6826 4.03523C15.6835 4.0198 15.6816 4.01154 15.6807 4.00886C15.6799 4.00685 15.6787 4.00495 15.6787 4.00495C15.6787 4.00495 15.6775 4.004 15.6748 4.003C15.6724 4.00211 15.6644 3.99911 15.6484 4.00007ZM5.1377 8.53523L4.06055 9.61238L5.5625 11.1143C5.65695 10.9732 5.76383 10.8295 5.86328 10.7051C5.981 10.5579 6.10905 10.4119 6.22363 10.2872C6.35675 9.85462 6.57281 9.06986 7.00586 8.1612L5.1377 8.53523Z",
        fill: "#4B5563"
    }));
};
const $850077216abd752e$var$screen_bar_chart = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $850077216abd752e$var$classNames__default["default"]("helix-icon", "screen-bar-chart-outlined", className);
    return $850077216abd752e$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $850077216abd752e$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.25 13L9.25 7H10.75V13H9.25Z",
        fill: "#4B5563"
    }), $850077216abd752e$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.25 13V8H13.75V13H12.25Z",
        fill: "#4B5563"
    }), $850077216abd752e$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.25 13V9H7.75V13H6.25Z",
        fill: "#4B5563"
    }), $850077216abd752e$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.5 4.5V15.5H16.5V4.5H3.5ZM3 3C2.44772 3 2 3.44772 2 4V16C2 16.5523 2.44772 17 3 17H17C17.5523 17 18 16.5523 18 16V4C18 3.44772 17.5523 3 17 3H3Z",
        fill: "#4B5563"
    }));
};
const $850077216abd752e$var$screen_percentage = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $850077216abd752e$var$classNames__default["default"]("helix-icon", "screen-percentage-outlined", className);
    return $850077216abd752e$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $850077216abd752e$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.5 4.5V15.5H16.5V4.5H3.5ZM3 3C2.44772 3 2 3.44772 2 4V16C2 16.5523 2.44772 17 3 17H17C17.5523 17 18 16.5523 18 16V4C18 3.44772 17.5523 3 17 3H3Z",
        fill: "#4B5563"
    }), $850077216abd752e$var$React__default["default"].createElement("path", {
        d: "M7.39844 10.5781C8.33203 10.5781 8.90625 9.94531 8.90625 8.92578V8.92188C8.90625 7.90234 8.33203 7.27344 7.39844 7.27344C6.46484 7.27344 5.88672 7.90234 5.88672 8.92188V8.92578C5.88672 9.94531 6.46484 10.5781 7.39844 10.5781ZM8.70703 13L12.4609 7.36328H11.2891L7.53516 13H8.70703ZM7.39844 9.79297C7.10547 9.79297 6.94531 9.49609 6.94531 8.92578V8.92188C6.94531 8.35156 7.10547 8.05859 7.39844 8.05859C7.69531 8.05859 7.85156 8.35156 7.85156 8.92188V8.92578C7.85156 9.49609 7.69531 9.79297 7.39844 9.79297ZM12.6016 13.0898C13.5352 13.0898 14.1094 12.457 14.1094 11.4375V11.4336C14.1094 10.4141 13.5352 9.78516 12.6016 9.78516C11.668 9.78516 11.0898 10.4141 11.0898 11.4336V11.4375C11.0898 12.457 11.668 13.0898 12.6016 13.0898ZM12.6016 12.3047C12.3086 12.3047 12.1484 12.0078 12.1484 11.4375V11.4336C12.1484 10.8633 12.3086 10.5703 12.6016 10.5703C12.8984 10.5703 13.0547 10.8633 13.0547 11.4336V11.4375C13.0547 12.0078 12.8984 12.3047 12.6016 12.3047Z",
        fill: "#4B5563"
    }));
};
const $850077216abd752e$var$search_home = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $850077216abd752e$var$classNames__default["default"]("helix-icon", "search-home-outlined", className);
    return $850077216abd752e$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $850077216abd752e$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9 3.75C6.10051 3.75 3.75 6.10051 3.75 9C3.75 11.8995 6.10051 14.25 9 14.25C11.8995 14.25 14.25 11.8995 14.25 9C14.25 6.10051 11.8995 3.75 9 3.75ZM2.25 9C2.25 5.27208 5.27208 2.25 9 2.25C12.7279 2.25 15.75 5.27208 15.75 9C15.75 10.5938 15.1976 12.0585 14.2739 13.2133L16.5 15.4393C16.7929 15.7322 16.7929 16.2071 16.5 16.5C16.2071 16.7929 15.7322 16.7929 15.4393 16.5L13.2133 14.2739C12.0585 15.1976 10.5938 15.75 9 15.75C5.27208 15.75 2.25 12.7279 2.25 9Z",
        fill: "#4B5563"
    }), $850077216abd752e$var$React__default["default"].createElement("path", {
        d: "M6.5 11V8.01923L9 6L11.5 8.01923V11H6.5Z",
        fill: "#4B5563"
    }));
};
const $850077216abd752e$var$signature = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $850077216abd752e$var$classNames__default["default"]("helix-icon", "signature-outlined", className);
    return $850077216abd752e$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $850077216abd752e$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.8652 4.04273C12.8651 4.04274 12.8646 4.04303 12.8634 4.04352L12.8652 4.04273ZM12.0174 3.26342C12.0176 3.26333 12.0168 3.26615 12.0145 3.27217C12.0161 3.26653 12.0173 3.26352 12.0174 3.26342ZM10.0511 6.30942C9.82384 6.71374 9.6125 7.12497 9.41258 7.54252C8.6895 9.05273 8.06202 10.6783 7.71661 12.3639C7.53269 13.2614 7.35181 14.2859 7.43963 15.319C7.47168 15.696 7.63179 16.0946 8.00647 16.3442C8.37023 16.5865 8.78834 16.5889 9.1327 16.504C9.70352 16.3633 10.091 15.9544 10.3181 15.6809C10.9162 14.9603 11.3332 14.1073 11.69 13.3771L11.6964 13.3641C12.0752 12.5891 12.1826 12.3921 12.3486 12.0876C12.3827 12.025 12.4193 11.9579 12.4612 11.8803C12.5046 12.1335 12.5571 12.4245 12.6318 12.7962C12.8661 13.9616 13.0457 14.7671 13.2134 15.2935C13.2962 15.5533 13.3916 15.7968 13.5175 15.9933C13.6458 16.1935 13.8656 16.436 14.2217 16.5101C14.8201 16.6346 15.2079 16.2044 15.3629 15.9931C15.5484 15.7401 15.6988 15.4082 15.8256 15.078C16.0711 14.4383 16.3089 13.5817 16.5432 12.7373C16.555 12.6948 16.5668 12.6523 16.5786 12.6098C16.8309 11.7015 17.0837 10.8042 17.3576 10.086C17.4944 9.72736 17.6272 9.43887 17.7543 9.228C17.8172 9.12367 17.8722 9.04941 17.9171 8.99918C17.9602 8.95105 17.9834 8.93689 17.9834 8.93684C17.9834 8.93684 17.9833 8.9369 17.9831 8.937C18.3451 8.73574 18.4755 8.27909 18.2742 7.91707C18.0729 7.55504 17.6163 7.42471 17.2543 7.62598C16.9041 7.82065 16.6526 8.1501 16.4697 8.45352C16.2775 8.77234 16.1081 9.1531 15.9561 9.55145C15.6526 10.3473 15.3815 11.3151 15.1333 12.2084L15.11 12.2926C14.8933 13.0729 14.6958 13.7841 14.5017 14.3327C14.3925 13.8987 14.2642 13.3053 14.1024 12.5005C14.0135 12.0583 13.9535 11.7026 13.8958 11.3605C13.8065 10.8315 13.7226 10.3348 13.5459 9.60024C13.528 9.52579 13.4798 9.36054 13.3353 9.21263C13.151 9.02398 12.8935 8.9479 12.6499 8.98876C12.4588 9.02081 12.3301 9.11498 12.2779 9.15647C12.2152 9.20633 12.1693 9.25699 12.1413 9.29007C12.0448 9.40427 11.9751 9.53703 11.965 9.55619L11.9644 9.55744L12.5158 9.84803L11.9644 9.55744C11.8885 9.70136 11.819 9.84559 11.7557 9.97731L11.7471 9.99509C11.6854 10.1235 11.6295 10.2399 11.5707 10.3534C11.3121 10.8526 11.1679 11.118 11.047 11.3406C10.865 11.6756 10.7358 11.9135 10.3487 12.7054C9.97737 13.4653 9.6321 14.1589 9.16393 14.7228C9.06696 14.8396 8.98649 14.9176 8.9205 14.9683C8.89226 14.2368 9.02074 13.4719 9.18608 12.665C9.49895 11.1381 10.0748 9.63282 10.7655 8.19029C11.176 7.33293 11.6274 6.5256 12.1627 5.76254C12.2423 5.64908 12.3302 5.52855 12.4224 5.40213C12.7112 5.00615 13.0421 4.55236 13.2919 4.07664C13.3266 4.01051 13.3696 3.92398 13.4061 3.83236C13.435 3.75947 13.4926 3.6056 13.4983 3.42844C13.5013 3.33695 13.4937 3.16596 13.3941 2.98744C13.2772 2.77782 13.0815 2.64331 12.8686 2.59492C12.6879 2.55382 12.5327 2.58228 12.4442 2.60529C12.3479 2.63033 12.2618 2.6674 12.1915 2.70233C11.4459 3.07296 10.8115 3.62158 10.276 4.0848C10.2506 4.10676 10.2254 4.12852 10.2005 4.15006L10.6907 4.71766L10.2005 4.15006C9.05653 5.13809 7.99439 6.19821 6.98042 7.29579C6.86644 7.41916 6.7606 7.54097 6.65578 7.6616C6.46279 7.8837 6.2733 8.10176 6.043 8.31815C5.68943 8.65036 5.43735 8.77392 5.27786 8.78325C5.25783 8.78442 5.23412 8.7863 5.21866 8.78753C5.21629 8.78772 5.21412 8.78789 5.21218 8.78805C5.20971 8.78824 5.20728 8.78843 5.20488 8.78862C5.04682 8.69579 4.85458 8.66034 4.66158 8.70348C4.25735 8.79385 4.0029 9.1948 4.09327 9.59904C4.17548 9.96681 4.45356 10.1402 4.61378 10.2068C4.76809 10.271 4.91702 10.2857 5.0018 10.2907C5.16691 10.3004 5.37197 10.2803 5.36542 10.2807C6.08408 10.2387 6.6712 9.78614 7.07012 9.41132C7.3535 9.14506 7.64222 8.81415 7.85973 8.56487C7.947 8.46484 8.02282 8.37795 8.08221 8.31365C8.72099 7.6222 9.37416 6.95175 10.0511 6.30942ZM5.08988 8.79328C5.08229 8.79284 5.08303 8.79239 5.09038 8.79331L5.08988 8.79328ZM8.72979 15.0551C8.72982 15.0551 8.73078 15.055 8.73259 15.0551C8.73067 15.0552 8.72977 15.0552 8.72979 15.0551ZM14.124 15.1416C14.124 15.1411 14.1275 15.137 14.1343 15.1305C14.1274 15.1388 14.124 15.1421 14.124 15.1416ZM5.2516 12.4293C5.56063 12.7052 5.58755 13.1793 5.31173 13.4883L4.47666 14.4239L5.35818 15.3144C5.64959 15.6087 5.64719 16.0836 5.35282 16.375C5.05845 16.6664 4.58359 16.664 4.29218 16.3697L3.47592 15.5451L2.70267 16.4115C2.42685 16.7205 1.95274 16.7474 1.64372 16.4716C1.33469 16.1958 1.30777 15.7217 1.58359 15.4126L2.41861 14.4771L1.53707 13.5866C1.24566 13.2922 1.24805 12.8174 1.54242 12.5259C1.83679 12.2345 2.31166 12.2369 2.60307 12.5313L3.41935 13.3559L4.19265 12.4895C4.46847 12.1804 4.94258 12.1535 5.2516 12.4293ZM1.34315 18.4427C1.34315 18.0285 1.67893 17.6927 2.09315 17.6927L17.8839 17.6927C18.2981 17.6927 18.6339 18.0285 18.6339 18.4427C18.6339 18.8569 18.2981 19.1927 17.8839 19.1927L2.09315 19.1927C1.67893 19.1927 1.34315 18.8569 1.34315 18.4427Z",
        fill: "#4B5563"
    }));
};
const $850077216abd752e$var$store = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $850077216abd752e$var$classNames__default["default"]("helix-icon", "store-outlined", className);
    return $850077216abd752e$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $850077216abd752e$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        // eslint-disable-next-line max-len
        d: "M5.0528 4.21738C5.34923 3.6245 5.95519 3.25 6.61804 3.25H13.382C14.0448 3.25 14.6508 3.6245 14.9472 4.21738L16.5623 7.44751C16.5895 7.50202 16.6107 7.5574 16.6262 7.61305C16.7045 7.73542 16.75 7.88092 16.75 8.03704V9.5C16.75 10.2801 16.353 10.9675 15.75 11.3711V15C15.75 15.9665 14.9665 16.75 14 16.75H6C5.0335 16.75 4.25 15.9665 4.25 15V11.3711C3.64701 10.9675 3.25 10.2801 3.25 9.5V8.03704C3.25 7.8809 3.29547 7.73538 3.37388 7.613C3.38933 7.55737 3.41048 7.502 3.43773 7.44751L5.0528 4.21738ZM13.75 8.75H15.25V9.5C15.25 9.91421 14.9142 10.25 14.5 10.25C14.0858 10.25 13.75 9.91421 13.75 9.5V8.75ZM14.25 11.7363C13.7723 11.6835 13.3397 11.4811 13 11.1771C12.6019 11.5334 12.0763 11.75 11.5 11.75C10.9237 11.75 10.3981 11.5334 10 11.1771C9.60193 11.5334 9.07627 11.75 8.5 11.75C7.92373 11.75 7.39807 11.5334 7 11.1771C6.66031 11.4811 6.22769 11.6835 5.75 11.7363V15C5.75 15.1381 5.86193 15.25 6 15.25H9V12.75C9 12.6119 9.11193 12.5 9.25 12.5H10.75C10.8881 12.5 11 12.6119 11 12.75V15.25H14C14.1381 15.25 14.25 15.1381 14.25 15V11.7363ZM9.25 8.75V9.5C9.25 9.91421 8.91421 10.25 8.5 10.25C8.08579 10.25 7.75 9.91421 7.75 9.5V8.75H9.25ZM5.21353 7.25L6.39444 4.8882C6.43678 4.8035 6.52335 4.75 6.61804 4.75H13.382C13.4767 4.75 13.5632 4.8035 13.6056 4.8882L14.7865 7.25H5.21353ZM11.5 10.25C11.0858 10.25 10.75 9.91421 10.75 9.5V8.75H12.25V9.5C12.25 9.91421 11.9142 10.25 11.5 10.25ZM6.25 8.75H4.75V9.5C4.75 9.91421 5.08579 10.25 5.5 10.25C5.91421 10.25 6.25 9.91421 6.25 9.5V8.75Z",
        fill: "#4B5563"
    }));
};
const $850077216abd752e$var$transaction_workflow = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $850077216abd752e$var$classNames__default["default"]("helix-icon", "transaction_workflow-outlined", className);
    return $850077216abd752e$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $850077216abd752e$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.75 11.2618C3.33579 11.2618 3 10.926 3 10.5118L3 9.01178C3 7.493 4.23122 6.26178 5.75 6.26178L14.75 6.26178C15.1642 6.26178 15.5 6.59757 15.5 7.01178C15.5 7.42599 15.1642 7.76178 14.75 7.76178L5.75 7.76178C5.05964 7.76178 4.5 8.32143 4.5 9.01178L4.5 10.5118C4.5 10.926 4.16421 11.2618 3.75 11.2618Z",
        fill: "#4B5563"
    }), $850077216abd752e$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.75 10.7618C16.1642 10.7618 16.5 11.0976 16.5 11.5118V13.0118C16.5 14.5306 15.2688 15.7618 13.75 15.7618L4.75 15.7618C4.33579 15.7618 4 15.426 4 15.0118C4 14.5976 4.33579 14.2618 4.75 14.2618L13.75 14.2618C14.4404 14.2618 15 13.7021 15 13.0118V11.5118C15 11.0976 15.3358 10.7618 15.75 10.7618Z",
        fill: "#4B5563"
    }), $850077216abd752e$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.2197 3.48145C11.5126 3.18856 11.9874 3.18856 12.2803 3.48145L15.2803 6.48145C15.5732 6.77434 15.5732 7.24922 15.2803 7.54211C14.9874 7.835 14.5126 7.835 14.2197 7.54211L11.2197 4.54211C10.9268 4.24922 10.9268 3.77434 11.2197 3.48145Z",
        fill: "#4B5563"
    }), $850077216abd752e$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.28033 18.5421C7.98744 18.835 7.51256 18.835 7.21967 18.5421L4.21967 15.5421C3.92678 15.2492 3.92678 14.7743 4.21967 14.4815C4.51256 14.1886 4.98744 14.1886 5.28033 14.4815L8.28033 17.4815C8.57322 17.7743 8.57322 18.2492 8.28033 18.5421Z",
        fill: "#4B5563"
    }));
};
const $850077216abd752e$var$workspace = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $850077216abd752e$var$classNames__default["default"]("helix-icon", "workspace-outlined", className);
    return $850077216abd752e$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $850077216abd752e$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.82324 5.82327C6.93679 5.57219 7 5.29348 7 5C7 3.89543 6.10457 3 5 3C3.89543 3 3 3.89543 3 5C3 6.10457 3.89543 7 5 7C5.26067 7 5.5097 6.95013 5.73806 6.85941L7.02846 8.1498C6.69353 8.68658 6.5 9.32069 6.5 10C6.5 11.3737 7.29136 12.5625 8.44306 13.1355L8.22043 14.026C7.5256 14.157 7 14.7671 7 15.5C7 16.3284 7.67157 17 8.5 17C9.32843 17 10 16.3284 10 15.5C10 15.1286 9.86501 14.7887 9.64141 14.5267L9.89845 13.4986C9.93219 13.4995 9.96604 13.5 10 13.5C11.933 13.5 13.5 11.933 13.5 10C13.5 9.42496 13.3613 8.88231 13.1156 8.40367L14.933 6.88914C15.1079 6.96061 15.2994 7 15.5 7C16.3284 7 17 6.32843 17 5.5C17 4.67157 16.3284 4 15.5 4C14.6716 4 14 4.67157 14 5.5C14 5.56877 14.0046 5.63646 14.0136 5.70278L12.161 7.24661C11.5659 6.77894 10.8155 6.5 10 6.5C9.28923 6.5 8.62795 6.71187 8.07586 7.07589L6.82324 5.82327ZM8 10C8 9.73932 8.04987 9.49029 8.14059 9.26193C8.33215 8.77975 8.70584 8.38972 9.17674 8.17676C9.42781 8.06321 9.70652 8 10 8C10.3486 8 10.6764 8.08919 10.9617 8.24599C11.4118 8.49326 11.7563 8.90868 11.9108 9.40764C11.9688 9.59483 12 9.79377 12 10C12 11.0103 11.2509 11.8456 10.2779 11.9809C10.1871 11.9935 10.0943 12 10 12C9.55989 12 9.15298 11.8578 8.82269 11.6169C8.32403 11.2532 8 10.6645 8 10Z",
        fill: "#4B5563"
    }));
};
$850077216abd752e$export$ce02a1f6e6ca19c4 = $850077216abd752e$var$arrows_exchange;
$850077216abd752e$export$217fdd6335ecce6a = $850077216abd752e$var$bell;
$850077216abd752e$export$e7717cf17836740c = $850077216abd752e$var$circle_user_checkmark;
$850077216abd752e$export$114b5f004c59985a = $850077216abd752e$var$cog_person;
$850077216abd752e$export$d15357726965dff7 = $850077216abd752e$var$funnel_person;
$850077216abd752e$export$79244f96c029f1f3 = $850077216abd752e$var$home_compare;
$850077216abd752e$export$691cddcab9d098d = $850077216abd752e$var$house_mobile;
$850077216abd752e$export$9aa65dd03156bd54 = $850077216abd752e$var$line_chart_loop;
$850077216abd752e$export$fcc578ccc685d627 = $850077216abd752e$var$magnet;
$850077216abd752e$export$65504cc544439568 = $850077216abd752e$var$open_door;
$850077216abd752e$export$9a45756dd558ee0e = $850077216abd752e$var$person_frame;
$850077216abd752e$export$343c52c44ab28c8e = $850077216abd752e$var$rocket;
$850077216abd752e$export$34820eaa871a8135 = $850077216abd752e$var$screen_bar_chart;
$850077216abd752e$export$70967e1ae0a94e22 = $850077216abd752e$var$screen_percentage;
$850077216abd752e$export$eb6b60d4d8f3380 = $850077216abd752e$var$search_home;
$850077216abd752e$export$c9cd164b539ebb63 = $850077216abd752e$var$signature;
$850077216abd752e$export$6f57813fe9f31bf9 = $850077216abd752e$var$store;
$850077216abd752e$export$31b038c13ee11436 = $850077216abd752e$var$transaction_workflow;
$850077216abd752e$export$ed275788a758bd76 = $850077216abd752e$var$workspace;

});


parcelRegister("6ST83", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $50328ca7c7d5787d$export$a7c73072b1a182ae, (v) => $50328ca7c7d5787d$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $50328ca7c7d5787d$export$9f27bc3417b4524d, (v) => $50328ca7c7d5787d$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $50328ca7c7d5787d$export$db77ccec0bb4ccac, (v) => $50328ca7c7d5787d$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $50328ca7c7d5787d$export$8392c0c9d3dcbd35, (v) => $50328ca7c7d5787d$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $50328ca7c7d5787d$export$ffb0004e005737fa, (v) => $50328ca7c7d5787d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $50328ca7c7d5787d$export$b624eff549462981, (v) => $50328ca7c7d5787d$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $50328ca7c7d5787d$export$7897aa7841a5380c, (v) => $50328ca7c7d5787d$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $50328ca7c7d5787d$export$602eac185826482c, (v) => $50328ca7c7d5787d$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $50328ca7c7d5787d$export$e2c29f18771995cb, (v) => $50328ca7c7d5787d$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $50328ca7c7d5787d$export$5f8d39834fd61797, (v) => $50328ca7c7d5787d$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $50328ca7c7d5787d$export$74bf444e3cd11ea5, (v) => $50328ca7c7d5787d$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $50328ca7c7d5787d$export$92387174baf9b227, (v) => $50328ca7c7d5787d$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $50328ca7c7d5787d$export$ec112efeb987d9c6, (v) => $50328ca7c7d5787d$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $50328ca7c7d5787d$export$b706b080d889d2c9, (v) => $50328ca7c7d5787d$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $50328ca7c7d5787d$export$5be5a87408f70ddc, (v) => $50328ca7c7d5787d$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $50328ca7c7d5787d$export$45a5e7f76e0caa8d, (v) => $50328ca7c7d5787d$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $50328ca7c7d5787d$export$455c2e768291efa6, (v) => $50328ca7c7d5787d$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $50328ca7c7d5787d$export$9522e17588c12572, (v) => $50328ca7c7d5787d$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $50328ca7c7d5787d$export$2110ac352bb060b9, (v) => $50328ca7c7d5787d$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $50328ca7c7d5787d$export$56885ab8b9c456ab, (v) => $50328ca7c7d5787d$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $50328ca7c7d5787d$export$d927fcb6adf8f9de, (v) => $50328ca7c7d5787d$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $50328ca7c7d5787d$export$b82d16f27459e05a, (v) => $50328ca7c7d5787d$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $50328ca7c7d5787d$export$522c17b4f5e123e8, (v) => $50328ca7c7d5787d$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $50328ca7c7d5787d$export$1aabd8a0274ecfd6, (v) => $50328ca7c7d5787d$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $50328ca7c7d5787d$export$9b621391a187a31a, (v) => $50328ca7c7d5787d$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $50328ca7c7d5787d$export$f5bbd400c2f4426f, (v) => $50328ca7c7d5787d$export$f5bbd400c2f4426f = v);
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $50328ca7c7d5787d$export$a7c73072b1a182ae;
var $50328ca7c7d5787d$export$9f27bc3417b4524d;
var $50328ca7c7d5787d$export$db77ccec0bb4ccac;
var $50328ca7c7d5787d$export$8392c0c9d3dcbd35;
var $50328ca7c7d5787d$export$ffb0004e005737fa;
var $50328ca7c7d5787d$export$b624eff549462981;
var $50328ca7c7d5787d$export$7897aa7841a5380c;
var $50328ca7c7d5787d$export$602eac185826482c;
var $50328ca7c7d5787d$export$e2c29f18771995cb;
var $50328ca7c7d5787d$export$5f8d39834fd61797;
var $50328ca7c7d5787d$export$74bf444e3cd11ea5;
var $50328ca7c7d5787d$export$92387174baf9b227;
var $50328ca7c7d5787d$export$ec112efeb987d9c6;
var $50328ca7c7d5787d$export$b706b080d889d2c9;
var $50328ca7c7d5787d$export$5be5a87408f70ddc;
var $50328ca7c7d5787d$export$45a5e7f76e0caa8d;
var $50328ca7c7d5787d$export$455c2e768291efa6;
var $50328ca7c7d5787d$export$9522e17588c12572;
var $50328ca7c7d5787d$export$2110ac352bb060b9;
var $50328ca7c7d5787d$export$56885ab8b9c456ab;
var $50328ca7c7d5787d$export$d927fcb6adf8f9de;
var $50328ca7c7d5787d$export$b82d16f27459e05a;
var $50328ca7c7d5787d$export$522c17b4f5e123e8;
var $50328ca7c7d5787d$export$1aabd8a0274ecfd6;
var $50328ca7c7d5787d$export$9b621391a187a31a;
var $50328ca7c7d5787d$export$f5bbd400c2f4426f;
"use strict";
var $50328ca7c7d5787d$var$b = 60103, $50328ca7c7d5787d$var$c = 60106, $50328ca7c7d5787d$var$d = 60107, $50328ca7c7d5787d$var$e = 60108, $50328ca7c7d5787d$var$f = 60114, $50328ca7c7d5787d$var$g = 60109, $50328ca7c7d5787d$var$h = 60110, $50328ca7c7d5787d$var$k = 60112, $50328ca7c7d5787d$var$l = 60113, $50328ca7c7d5787d$var$m = 60120, $50328ca7c7d5787d$var$n = 60115, $50328ca7c7d5787d$var$p = 60116, $50328ca7c7d5787d$var$q = 60121, $50328ca7c7d5787d$var$r = 60122, $50328ca7c7d5787d$var$u = 60117, $50328ca7c7d5787d$var$v = 60129, $50328ca7c7d5787d$var$w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $50328ca7c7d5787d$var$x = Symbol.for;
    $50328ca7c7d5787d$var$b = $50328ca7c7d5787d$var$x("react.element");
    $50328ca7c7d5787d$var$c = $50328ca7c7d5787d$var$x("react.portal");
    $50328ca7c7d5787d$var$d = $50328ca7c7d5787d$var$x("react.fragment");
    $50328ca7c7d5787d$var$e = $50328ca7c7d5787d$var$x("react.strict_mode");
    $50328ca7c7d5787d$var$f = $50328ca7c7d5787d$var$x("react.profiler");
    $50328ca7c7d5787d$var$g = $50328ca7c7d5787d$var$x("react.provider");
    $50328ca7c7d5787d$var$h = $50328ca7c7d5787d$var$x("react.context");
    $50328ca7c7d5787d$var$k = $50328ca7c7d5787d$var$x("react.forward_ref");
    $50328ca7c7d5787d$var$l = $50328ca7c7d5787d$var$x("react.suspense");
    $50328ca7c7d5787d$var$m = $50328ca7c7d5787d$var$x("react.suspense_list");
    $50328ca7c7d5787d$var$n = $50328ca7c7d5787d$var$x("react.memo");
    $50328ca7c7d5787d$var$p = $50328ca7c7d5787d$var$x("react.lazy");
    $50328ca7c7d5787d$var$q = $50328ca7c7d5787d$var$x("react.block");
    $50328ca7c7d5787d$var$r = $50328ca7c7d5787d$var$x("react.server.block");
    $50328ca7c7d5787d$var$u = $50328ca7c7d5787d$var$x("react.fundamental");
    $50328ca7c7d5787d$var$v = $50328ca7c7d5787d$var$x("react.debug_trace_mode");
    $50328ca7c7d5787d$var$w = $50328ca7c7d5787d$var$x("react.legacy_hidden");
}
function $50328ca7c7d5787d$var$y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case $50328ca7c7d5787d$var$b:
                switch(a = a.type, a){
                    case $50328ca7c7d5787d$var$d:
                    case $50328ca7c7d5787d$var$f:
                    case $50328ca7c7d5787d$var$e:
                    case $50328ca7c7d5787d$var$l:
                    case $50328ca7c7d5787d$var$m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $50328ca7c7d5787d$var$h:
                            case $50328ca7c7d5787d$var$k:
                            case $50328ca7c7d5787d$var$p:
                            case $50328ca7c7d5787d$var$n:
                            case $50328ca7c7d5787d$var$g:
                                return a;
                            default:
                                return t;
                        }
                }
            case $50328ca7c7d5787d$var$c:
                return t;
        }
    }
}
var $50328ca7c7d5787d$var$z = $50328ca7c7d5787d$var$g, $50328ca7c7d5787d$var$A = $50328ca7c7d5787d$var$b, $50328ca7c7d5787d$var$B = $50328ca7c7d5787d$var$k, $50328ca7c7d5787d$var$C = $50328ca7c7d5787d$var$d, $50328ca7c7d5787d$var$D = $50328ca7c7d5787d$var$p, $50328ca7c7d5787d$var$E = $50328ca7c7d5787d$var$n, $50328ca7c7d5787d$var$F = $50328ca7c7d5787d$var$c, $50328ca7c7d5787d$var$G = $50328ca7c7d5787d$var$f, $50328ca7c7d5787d$var$H = $50328ca7c7d5787d$var$e, $50328ca7c7d5787d$var$I = $50328ca7c7d5787d$var$l;
$50328ca7c7d5787d$export$a7c73072b1a182ae = $50328ca7c7d5787d$var$h;
$50328ca7c7d5787d$export$9f27bc3417b4524d = $50328ca7c7d5787d$var$z;
$50328ca7c7d5787d$export$db77ccec0bb4ccac = $50328ca7c7d5787d$var$A;
$50328ca7c7d5787d$export$8392c0c9d3dcbd35 = $50328ca7c7d5787d$var$B;
$50328ca7c7d5787d$export$ffb0004e005737fa = $50328ca7c7d5787d$var$C;
$50328ca7c7d5787d$export$b624eff549462981 = $50328ca7c7d5787d$var$D;
$50328ca7c7d5787d$export$7897aa7841a5380c = $50328ca7c7d5787d$var$E;
$50328ca7c7d5787d$export$602eac185826482c = $50328ca7c7d5787d$var$F;
$50328ca7c7d5787d$export$e2c29f18771995cb = $50328ca7c7d5787d$var$G;
$50328ca7c7d5787d$export$5f8d39834fd61797 = $50328ca7c7d5787d$var$H;
$50328ca7c7d5787d$export$74bf444e3cd11ea5 = $50328ca7c7d5787d$var$I;
$50328ca7c7d5787d$export$92387174baf9b227 = function() {
    return !1;
};
$50328ca7c7d5787d$export$ec112efeb987d9c6 = function() {
    return !1;
};
$50328ca7c7d5787d$export$b706b080d889d2c9 = function(a) {
    return $50328ca7c7d5787d$var$y(a) === $50328ca7c7d5787d$var$h;
};
$50328ca7c7d5787d$export$5be5a87408f70ddc = function(a) {
    return $50328ca7c7d5787d$var$y(a) === $50328ca7c7d5787d$var$g;
};
$50328ca7c7d5787d$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $50328ca7c7d5787d$var$b;
};
$50328ca7c7d5787d$export$455c2e768291efa6 = function(a) {
    return $50328ca7c7d5787d$var$y(a) === $50328ca7c7d5787d$var$k;
};
$50328ca7c7d5787d$export$9522e17588c12572 = function(a) {
    return $50328ca7c7d5787d$var$y(a) === $50328ca7c7d5787d$var$d;
};
$50328ca7c7d5787d$export$2110ac352bb060b9 = function(a) {
    return $50328ca7c7d5787d$var$y(a) === $50328ca7c7d5787d$var$p;
};
$50328ca7c7d5787d$export$56885ab8b9c456ab = function(a) {
    return $50328ca7c7d5787d$var$y(a) === $50328ca7c7d5787d$var$n;
};
$50328ca7c7d5787d$export$d927fcb6adf8f9de = function(a) {
    return $50328ca7c7d5787d$var$y(a) === $50328ca7c7d5787d$var$c;
};
$50328ca7c7d5787d$export$b82d16f27459e05a = function(a) {
    return $50328ca7c7d5787d$var$y(a) === $50328ca7c7d5787d$var$f;
};
$50328ca7c7d5787d$export$522c17b4f5e123e8 = function(a) {
    return $50328ca7c7d5787d$var$y(a) === $50328ca7c7d5787d$var$e;
};
$50328ca7c7d5787d$export$1aabd8a0274ecfd6 = function(a) {
    return $50328ca7c7d5787d$var$y(a) === $50328ca7c7d5787d$var$l;
};
$50328ca7c7d5787d$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $50328ca7c7d5787d$var$d || a === $50328ca7c7d5787d$var$f || a === $50328ca7c7d5787d$var$v || a === $50328ca7c7d5787d$var$e || a === $50328ca7c7d5787d$var$l || a === $50328ca7c7d5787d$var$m || a === $50328ca7c7d5787d$var$w || "object" === typeof a && null !== a && (a.$$typeof === $50328ca7c7d5787d$var$p || a.$$typeof === $50328ca7c7d5787d$var$n || a.$$typeof === $50328ca7c7d5787d$var$g || a.$$typeof === $50328ca7c7d5787d$var$h || a.$$typeof === $50328ca7c7d5787d$var$k || a.$$typeof === $50328ca7c7d5787d$var$u || a.$$typeof === $50328ca7c7d5787d$var$q || a[0] === $50328ca7c7d5787d$var$r) ? !0 : !1;
};
$50328ca7c7d5787d$export$f5bbd400c2f4426f = $50328ca7c7d5787d$var$y;

});

parcelRegister("30Ie1", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $2313ad640c2ad62d$export$306c0aa65ff9ec16, (v) => $2313ad640c2ad62d$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2313ad640c2ad62d$export$306c0aa65ff9ec16;
"use strict";

var $acw62 = parcelRequire("acw62");
function $2313ad640c2ad62d$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $2313ad640c2ad62d$var$k = "function" === typeof Object.is ? Object.is : $2313ad640c2ad62d$var$h, $2313ad640c2ad62d$var$l = $acw62.useState, $2313ad640c2ad62d$var$m = $acw62.useEffect, $2313ad640c2ad62d$var$n = $acw62.useLayoutEffect, $2313ad640c2ad62d$var$p = $acw62.useDebugValue;
function $2313ad640c2ad62d$var$q(a, b) {
    var d = b(), f = $2313ad640c2ad62d$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $2313ad640c2ad62d$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $2313ad640c2ad62d$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $2313ad640c2ad62d$var$m(function() {
        $2313ad640c2ad62d$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $2313ad640c2ad62d$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $2313ad640c2ad62d$var$p(d);
    return d;
}
function $2313ad640c2ad62d$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$2313ad640c2ad62d$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $2313ad640c2ad62d$var$t(a, b) {
    return b();
}
var $2313ad640c2ad62d$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $2313ad640c2ad62d$var$t : $2313ad640c2ad62d$var$q;
$2313ad640c2ad62d$export$306c0aa65ff9ec16 = void 0 !== $acw62.useSyncExternalStore ? $acw62.useSyncExternalStore : $2313ad640c2ad62d$var$u;

});

parcelRegister("jGr7B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $klEzJ = parcelRequire("klEzJ");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");
function $03b2b175198bdf3b$var$_interopDefaultLegacy(e) {
    return e && typeof e === "object" && "default" in e ? e : {
        "default": e
    };
}
var $03b2b175198bdf3b$var$React__default = /*#__PURE__*/ $03b2b175198bdf3b$var$_interopDefaultLegacy($acw62);
var $03b2b175198bdf3b$var$classNames__default = /*#__PURE__*/ $03b2b175198bdf3b$var$_interopDefaultLegacy($8g1PZ);
const $03b2b175198bdf3b$var$add = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $03b2b175198bdf3b$var$classNames__default["default"]("helix-icon", "add-solid", className);
    return $03b2b175198bdf3b$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $03b2b175198bdf3b$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 16C13.3137 16 16 13.3137 16 10C16 6.68629 13.3137 4 10 4C6.68629 4 4 6.68629 4 10C4 13.3137 6.68629 16 10 16ZM10.75 6.75C10.75 6.33579 10.4142 6 10 6C9.58579 6 9.25 6.33579 9.25 6.75V9.25H6.75C6.33579 9.25 6 9.58579 6 10C6 10.4142 6.33579 10.75 6.75 10.75H9.25V13.25C9.25 13.6642 9.58579 14 10 14C10.4142 14 10.75 13.6642 10.75 13.25V10.75H13.25C13.6642 10.75 14 10.4142 14 10C14 9.58579 13.6642 9.25 13.25 9.25H10.75V6.75Z",
        fill: "#4B5563"
    }));
};
const $03b2b175198bdf3b$var$arrow_sliding_down = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $03b2b175198bdf3b$var$classNames__default["default"]("helix-icon", "arrow-sliding-down-solid", className);
    return $03b2b175198bdf3b$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $03b2b175198bdf3b$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 6.75C3 6.33579 3.33579 6 3.75 6C8.15644 6 10.5977 7.17576 12.3203 8.76055C13.1154 9.49207 13.7404 10.2965 14.3102 11.0298C14.3392 11.0671 14.368 11.1042 14.3967 11.1411C15.0025 11.92 15.5508 12.6077 16.2301 13.1738C16.5483 13.439 16.5913 13.9119 16.3262 14.2301C16.061 14.5483 15.5881 14.5913 15.2699 14.3262C14.4492 13.6423 13.81 12.83 13.2127 12.062C13.1907 12.0337 13.1687 12.0054 13.1468 11.9772C12.5613 11.2241 12.0054 10.5091 11.3047 9.86445C9.90231 8.57424 7.84356 7.5 3.75 7.5C3.33579 7.5 3 7.16421 3 6.75Z",
        fill: "#4B5563"
    }), $03b2b175198bdf3b$var$React__default["default"].createElement("path", {
        d: "M12.5503 15H16C16.5523 15 17 14.5523 17 14V10.5503C17 10.1048 16.4614 9.88172 16.1464 10.1967L14.7701 11.5924L13.5924 12.7507L12.1967 14.1464C11.8817 14.4614 12.1048 15 12.5503 15Z",
        fill: "#4B5563"
    }));
};
const $03b2b175198bdf3b$var$camera_video = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $03b2b175198bdf3b$var$classNames__default["default"]("helix-icon", "camera-video-solid", className);
    return $03b2b175198bdf3b$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $03b2b175198bdf3b$var$React__default["default"].createElement("path", {
        d: "M3 4C1.89543 4 1 4.89543 1 6V14C1 15.1046 1.89543 16 3 16H12C13.1046 16 14 15.1046 14 14V11.7962L17.0818 14.564C17.7256 15.1421 18.75 14.6853 18.75 13.82V6.18002C18.75 5.31474 17.7256 4.85786 17.0818 5.43602L14 8.2038V6C14 4.89543 13.1046 4 12 4H3Z",
        fill: "#4B5563"
    }));
};
const $03b2b175198bdf3b$var$circle_arrow_right = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $03b2b175198bdf3b$var$classNames__default["default"]("helix-icon", "circle-arrow-right", className);
    return $03b2b175198bdf3b$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $03b2b175198bdf3b$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.99961 13.4001C8.69699 13.4001 10.3249 12.7258 11.5251 11.5256C12.7253 10.3253 13.3996 8.69748 13.3996 7.0001C13.3996 5.30271 12.7253 3.67485 11.5251 2.47461C10.3249 1.27438 8.69699 0.600098 6.99961 0.600098C5.30222 0.600098 3.67436 1.27438 2.47413 2.47461C1.27389 3.67485 0.599609 5.30271 0.599609 7.0001C0.599609 8.69748 1.27389 10.3253 2.47413 11.5256C3.67436 12.7258 5.30222 13.4001 6.99961 13.4001ZM4.39961 6.4001C4.24048 6.4001 4.08787 6.46331 3.97535 6.57583C3.86282 6.68836 3.79961 6.84097 3.79961 7.0001C3.79961 7.15923 3.86282 7.31184 3.97535 7.42436C4.08787 7.53688 4.24048 7.6001 4.39961 7.6001H8.07161L6.39161 9.1601C6.27491 9.26831 6.20598 9.41844 6.19998 9.57747C6.19398 9.7365 6.2514 9.8914 6.35961 10.0081C6.46782 10.1248 6.61795 10.1937 6.77698 10.1997C6.93601 10.2057 7.09091 10.1483 7.20761 10.0401L10.0076 7.4401C10.0682 7.38393 10.1165 7.31586 10.1496 7.24015C10.1826 7.16443 10.1997 7.08271 10.1997 7.0001C10.1997 6.91748 10.1826 6.83576 10.1496 6.76005C10.1165 6.68434 10.0682 6.61626 10.0076 6.5601L7.20761 3.9601C7.14983 3.90652 7.08206 3.86484 7.00817 3.83746C6.93428 3.81007 6.85573 3.7975 6.77698 3.80047C6.61795 3.80647 6.46782 3.8754 6.35961 3.9921C6.2514 4.10879 6.19398 4.26369 6.19998 4.42272C6.20598 4.58176 6.27491 4.73189 6.39161 4.8401L8.07161 6.4001H4.39961Z",
        fill: "#4B5563"
    }));
};
const $03b2b175198bdf3b$var$circle_checkmark = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $03b2b175198bdf3b$var$classNames__default["default"]("helix-icon", "circle-checkmark-solid", className);
    return $03b2b175198bdf3b$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $03b2b175198bdf3b$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58173 2 10C2 14.4183 5.58172 18 10 18ZM13.5919 7.2911C13.2042 6.90343 12.5759 6.9029 12.1875 7.28992L8.5123 10.9528L7.69805 10.1386C7.30959 9.75012 6.67979 9.75013 6.29134 10.1386C5.9038 10.5261 5.90275 11.1541 6.28901 11.543L7.64671 12.9097C7.68616 12.9728 7.73333 13.0325 7.78823 13.0874C7.96997 13.2692 8.20431 13.3663 8.44224 13.3787C8.72674 13.4043 9.02015 13.3082 9.23801 13.0903C9.29548 13.0328 9.34448 12.9701 9.38501 12.9037L13.5919 8.69667C13.9801 8.30853 13.98 7.67924 13.5919 7.2911Z",
        fill: "#4B5563"
    }));
};
const $03b2b175198bdf3b$var$circle_info = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $03b2b175198bdf3b$var$classNames__default["default"]("helix-icon", "circle-info-solid", className);
    return $03b2b175198bdf3b$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $03b2b175198bdf3b$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM10 7C10.5523 7 11 6.55228 11 6C11 5.44772 10.5523 5 10 5C9.44771 5 9 5.44772 9 6C9 6.55228 9.44771 7 10 7ZM10.0039 8C9.4557 8 9.01098 8.44385 9.00989 8.99207L9 13.999C8.99891 14.5515 9.4465 15 9.99901 15C10.5507 15 10.998 14.5527 10.998 14.001L10.998 8.99402C10.998 8.44504 10.5529 8 10.0039 8Z",
        fill: "#4B5563"
    }));
};
const $03b2b175198bdf3b$var$circle_small_x = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $03b2b175198bdf3b$var$classNames__default["default"]("helix-icon", "circle-small-x-solid", className);
    return $03b2b175198bdf3b$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $03b2b175198bdf3b$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 16C13.3137 16 16 13.3137 16 10C16 6.68629 13.3137 4 10 4C6.68629 4 4 6.68629 4 10C4 13.3137 6.68629 16 10 16ZM8.54881 7.47082C8.25656 7.17729 7.78168 7.17626 7.48815 7.46852C7.19463 7.76078 7.19359 8.23565 7.48585 8.52918L8.94164 9.9913L7.46852 11.4708C7.17626 11.7644 7.17729 12.2392 7.47082 12.5315C7.76435 12.8237 8.23922 12.8227 8.53148 12.5292L10 11.0543L11.4685 12.5292C11.7608 12.8227 12.2356 12.8237 12.5292 12.5315C12.8227 12.2392 12.8237 11.7644 12.5315 11.4708L11.0584 9.9913L12.5141 8.52918C12.8064 8.23565 12.8054 7.76078 12.5118 7.46852C12.2183 7.17626 11.7434 7.17729 11.4512 7.47082L10 8.92833L8.54881 7.47082Z",
        fill: "#4B5563"
    }));
};
const $03b2b175198bdf3b$var$circle_x = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $03b2b175198bdf3b$var$classNames__default["default"]("helix-icon", "circle-x-solid", className);
    return $03b2b175198bdf3b$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $03b2b175198bdf3b$var$React__default["default"].createElement("circle", {
        cx: "10",
        cy: "10",
        r: "8",
        fill: "#4B5563"
    }), $03b2b175198bdf3b$var$React__default["default"].createElement("path", {
        d: "M8 8L12 12M8 12L12 8",
        stroke: "white",
        strokeWidth: "1.5",
        strokeLinecap: "square"
    }));
};
const $03b2b175198bdf3b$var$clock = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $03b2b175198bdf3b$var$classNames__default["default"]("helix-icon", "clock-solid", className);
    return $03b2b175198bdf3b$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $03b2b175198bdf3b$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM10 5.25C10.4142 5.25 10.75 5.58579 10.75 6V9.63953L12.9685 11.4143C13.292 11.6731 13.3444 12.1451 13.0857 12.4685C12.8269 12.792 12.3549 12.8444 12.0315 12.5857L9.53148 10.5857C9.35357 10.4433 9.25 10.2278 9.25 10V6C9.25 5.58579 9.58579 5.25 10 5.25Z",
        fill: "#4B5563"
    }));
};
const $03b2b175198bdf3b$var$comment = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $03b2b175198bdf3b$var$classNames__default["default"]("helix-icon", "comment-solid", className);
    return $03b2b175198bdf3b$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $03b2b175198bdf3b$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.25 10C2.25 5.71979 5.71979 2.25 10 2.25C14.2802 2.25 17.75 5.71979 17.75 10C17.75 11.394 17.3813 12.7038 16.7359 13.8352L17.7115 16.7629C17.8013 17.0324 17.7312 17.3295 17.5303 17.5303C17.3295 17.7312 17.0324 17.8013 16.7629 17.7115L13.8352 16.7359C12.7038 17.3813 11.394 17.75 10 17.75C5.71979 17.75 2.25 14.2802 2.25 10Z",
        fill: "#4B5563"
    }));
};
const $03b2b175198bdf3b$var$crown = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $03b2b175198bdf3b$var$classNames__default["default"]("helix-icon", "crown-solid", className);
    return $03b2b175198bdf3b$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $03b2b175198bdf3b$var$React__default["default"].createElement("path", {
        d: "M3 6.80517C3 6.29806 3.66784 6.11308 3.92875 6.54792L6 10L9.58397 4.62405C9.78189 4.32718 10.2181 4.32718 10.416 4.62405L14 10L16.0713 6.54792C16.3322 6.11308 17 6.29806 17 6.80517V15C17 15.5523 16.5523 16 16 16H4C3.44772 16 3 15.5523 3 15V6.80517Z",
        fill: "#4B5563"
    }));
};
const $03b2b175198bdf3b$var$diamond_exclamation = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $03b2b175198bdf3b$var$classNames__default["default"]("helix-icon", "diamond_exclamation-solid", className);
    return $03b2b175198bdf3b$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $03b2b175198bdf3b$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.3845 2.57349C10.6199 1.80884 9.38013 1.80884 8.61548 2.57349L2.57349 8.61548C1.80884 9.38013 1.80884 10.6199 2.57349 11.3845L8.61548 17.4265C9.38013 18.1912 10.6199 18.1912 11.3845 17.4265L17.4265 11.3845C18.1912 10.6199 18.1912 9.38013 17.4265 8.61548L11.3845 2.57349ZM10.0072 11.902C10.3891 11.902 10.7054 11.6055 10.7302 11.2244L11.0651 6.06477C11.1025 5.48821 10.645 5 10.0672 5H9.94722C9.36945 5 8.91189 5.48822 8.94932 6.06477L9.28422 11.2244C9.30896 11.6055 9.62529 11.902 10.0072 11.902ZM9.2302 13.148C9.01554 13.3627 8.9082 13.624 8.9082 13.932C8.9082 14.24 9.01554 14.5013 9.2302 14.716C9.44487 14.9307 9.70154 15.038 10.0002 15.038C10.3082 15.038 10.5695 14.9307 10.7842 14.716C11.0082 14.5013 11.1202 14.24 11.1202 13.932C11.1202 13.624 11.0082 13.3627 10.7842 13.148C10.5695 12.924 10.3082 12.812 10.0002 12.812C9.70154 12.812 9.44487 12.924 9.2302 13.148Z",
        fill: "#4B5563"
    }));
};
const $03b2b175198bdf3b$var$dots = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $03b2b175198bdf3b$var$classNames__default["default"]("helix-icon", "dots-solid", className);
    return $03b2b175198bdf3b$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $03b2b175198bdf3b$var$React__default["default"].createElement("circle", {
        cx: "7",
        cy: "10",
        r: "3",
        fill: "#4B5563"
    }), $03b2b175198bdf3b$var$React__default["default"].createElement("circle", {
        cx: "13",
        cy: "10",
        r: "3",
        fill: "#4B5563"
    }));
};
const $03b2b175198bdf3b$var$flag = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $03b2b175198bdf3b$var$classNames__default["default"]("helix-icon", "flag-solid", className);
    return $03b2b175198bdf3b$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $03b2b175198bdf3b$var$React__default["default"].createElement("path", {
        d: "M5.125 4.5625C5.125 4.41332 5.06574 4.27024 4.96025 4.16475C4.85476 4.05926 4.71168 4 4.5625 4C4.41332 4 4.27024 4.05926 4.16475 4.16475C4.05926 4.27024 4 4.41332 4 4.5625V15.4375C4 15.5867 4.05926 15.7298 4.16475 15.8352C4.27024 15.9407 4.41332 16 4.5625 16C4.71168 16 4.85476 15.9407 4.96025 15.8352C5.06574 15.7298 5.125 15.5867 5.125 15.4375V12.1435L6.36775 11.8825C7.4531 11.654 8.58402 11.8054 9.571 12.3115C10.954 13.0207 12.5593 13.1617 14.0448 12.7045L15.6033 12.2245C15.7181 12.1891 15.8185 12.1179 15.8899 12.0212C15.9613 11.9246 15.9999 11.8076 16 11.6875V5.3125C16 5.22883 15.9813 5.14622 15.9454 5.07068C15.9094 4.99514 15.857 4.92857 15.7921 4.87583C15.7271 4.82309 15.6512 4.78551 15.5699 4.76582C15.4886 4.74612 15.4039 4.74482 15.322 4.762L13.537 5.13775C12.4866 5.35888 11.3942 5.26416 10.3975 4.8655L10.021 4.7155C8.81796 4.234 7.4993 4.11943 6.23125 4.38625L5.125 4.61875V4.5625Z",
        fill: "#4B5563"
    }));
};
const $03b2b175198bdf3b$var$heart = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $03b2b175198bdf3b$var$classNames__default["default"]("helix-icon", "heart-solid", className);
    return $03b2b175198bdf3b$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $03b2b175198bdf3b$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 17L8.9125 15.9967C5.05 12.43 2.5 10.0763 2.5 7.19619C2.5 4.84251 4.31125 3 6.625 3C7.93 3 9.1825 3.61798 10 4.59074C10.8175 3.61798 12.07 3 13.375 3C15.6888 3 17.5 4.84251 17.5 7.19619C17.5 10.0763 14.95 12.43 11.0875 15.9967L10 17Z",
        fill: "#4B5563",
        stroke: "#4B5563",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
};
const $03b2b175198bdf3b$var$marker = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $03b2b175198bdf3b$var$classNames__default["default"]("helix-icon", "marker-solid", className);
    return $03b2b175198bdf3b$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $03b2b175198bdf3b$var$React__default["default"].createElement("path", {
        d: "M13.1459 1.28932C13.5302 0.903538 14.1532 0.903565 14.5375 1.28938L18.7118 5.48016C19.0961 5.86602 19.0961 6.49162 18.7117 6.87745L9.66479 15.9587C9.28047 16.3444 8.65742 16.3444 8.27313 15.9586L4.0989 11.7678C3.71457 11.382 3.7146 10.7564 4.09896 10.3705L13.1459 1.28932Z",
        fill: "#4B5563"
    }), $03b2b175198bdf3b$var$React__default["default"].createElement("path", {
        d: "M2.24991 13.5534L6.42505 17.7451L2.8269 18.9493C2.47328 19.0676 2.08342 18.9752 1.81985 18.7106L1.28826 18.1769C1.02469 17.9123 0.932654 17.5209 1.05053 17.1659L2.24991 13.5534Z",
        fill: "#4B5563"
    }));
};
const $03b2b175198bdf3b$var$plug = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $03b2b175198bdf3b$var$classNames__default["default"]("helix-icon", "plug-solid", className);
    return $03b2b175198bdf3b$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $03b2b175198bdf3b$var$React__default["default"].createElement("path", {
        d: "M6.28868 16.9982L2.75315 13.4627L4.87447 11.3414C4.87447 11.3414 2.75315 8.51293 4.52091 6.74516L8.76355 2.50252L17.2488 10.9878L13.0062 15.2304C11.2384 16.9982 8.41 14.8769 8.41 14.8769L6.28868 16.9982Z",
        fill: "#4B5563"
    }), $03b2b175198bdf3b$var$React__default["default"].createElement("path", {
        d: "M2.75315 13.4627L2.22282 12.9323C2.08216 13.073 2.00315 13.2638 2.00315 13.4627C2.00315 13.6616 2.08216 13.8524 2.22282 13.993L2.75315 13.4627ZM6.28868 16.9982L5.75835 17.5285C6.05124 17.8214 6.52612 17.8214 6.81901 17.5285L6.28868 16.9982ZM8.41 14.8769L8.86 14.2769C8.56141 14.0529 8.14359 14.0826 7.87967 14.3466L8.41 14.8769ZM13.0062 15.2304L13.5365 15.7608H13.5365L13.0062 15.2304ZM17.2488 10.9878L17.7792 11.5181C18.0721 11.2252 18.0721 10.7504 17.7792 10.4575L17.2488 10.9878ZM8.76355 2.50252L9.29388 1.97219C9.15323 1.83154 8.96247 1.75252 8.76355 1.75252C8.56464 1.75252 8.37388 1.83154 8.23322 1.97219L8.76355 2.50252ZM4.52091 6.74516L3.99058 6.21483L4.52091 6.74516ZM4.87447 11.3414L5.4048 11.8717C5.66872 11.6078 5.69841 11.1899 5.47447 10.8914L4.87447 11.3414ZM13.8898 2.67916C14.1827 2.38627 14.1827 1.9114 13.8898 1.6185C13.5969 1.32561 13.122 1.32561 12.8292 1.6185L13.8898 2.67916ZM10.7078 3.73982C10.4149 4.03272 10.4149 4.50759 10.7078 4.80048C11.0007 5.09338 11.4756 5.09338 11.7685 4.80048L10.7078 3.73982ZM18.1325 6.9218C18.4253 6.62891 18.4253 6.15404 18.1325 5.86114C17.8396 5.56825 17.3647 5.56825 17.0718 5.86114L18.1325 6.9218ZM14.9505 7.98246C14.6576 8.27536 14.6576 8.75023 14.9505 9.04312C15.2434 9.33602 15.7182 9.33602 16.0111 9.04312L14.9505 7.98246ZM2.22282 13.993L5.75835 17.5285L6.81901 16.4679L3.28348 12.9323L2.22282 13.993ZM6.81901 17.5285L8.94033 15.4072L7.87967 14.3466L5.75835 16.4679L6.81901 17.5285ZM8.41 14.8769C7.96 15.4769 7.96022 15.477 7.96044 15.4772C7.96053 15.4773 7.96077 15.4775 7.96095 15.4776C7.96132 15.4779 7.96172 15.4782 7.96217 15.4785C7.96307 15.4792 7.96415 15.48 7.9654 15.4809C7.96789 15.4828 7.97109 15.4851 7.97496 15.488C7.98271 15.4936 7.99318 15.5012 8.00627 15.5106C8.03243 15.5293 8.06909 15.555 8.11529 15.5862C8.20755 15.6485 8.33868 15.7332 8.5009 15.8281C8.82267 16.0163 9.27993 16.2521 9.80801 16.4281C10.8386 16.7716 12.3519 16.9454 13.5365 15.7608L12.4759 14.7001C11.8927 15.2833 11.1079 15.2803 10.2824 15.0051C9.88236 14.8717 9.52203 14.6876 9.25823 14.5333C9.12766 14.457 9.02401 14.3898 8.95468 14.343C8.92009 14.3197 8.89426 14.3015 8.87813 14.29C8.87006 14.2842 8.86444 14.2801 8.86138 14.2779C8.85985 14.2768 8.85896 14.2761 8.85872 14.2759C8.8586 14.2758 8.85865 14.2759 8.85886 14.276C8.85897 14.2761 8.85912 14.2762 8.85931 14.2764C8.8594 14.2764 8.85957 14.2766 8.85962 14.2766C8.85981 14.2767 8.86 14.2769 8.41 14.8769ZM13.5365 15.7608L17.7792 11.5181L16.7185 10.4575L12.4759 14.7001L13.5365 15.7608ZM17.7792 10.4575L9.29388 1.97219L8.23322 3.03285L16.7185 11.5181L17.7792 10.4575ZM8.23322 1.97219L3.99058 6.21483L5.05124 7.27549L9.29388 3.03285L8.23322 1.97219ZM3.99058 6.21483C2.80596 7.39945 2.97974 8.91275 3.32327 9.94334C3.49929 10.4714 3.73504 10.9287 3.92324 11.2505C4.01813 11.4127 4.1029 11.5438 4.16519 11.6361C4.19639 11.6823 4.22209 11.7189 4.24078 11.7451C4.25012 11.7582 4.25773 11.7686 4.2634 11.7764C4.26624 11.7803 4.2686 11.7835 4.27045 11.786C4.27137 11.7872 4.27217 11.7883 4.27284 11.7892C4.27318 11.7896 4.27348 11.79 4.27375 11.7904C4.27389 11.7906 4.27407 11.7908 4.27413 11.7909C4.27431 11.7911 4.27447 11.7914 4.87447 11.3414C5.47447 10.8914 5.47461 10.8915 5.47475 10.8917C5.47479 10.8918 5.47492 10.892 5.47499 10.892C5.47513 10.8922 5.47524 10.8924 5.47532 10.8925C5.47548 10.8927 5.47551 10.8928 5.47543 10.8926C5.47525 10.8924 5.47459 10.8915 5.47347 10.89C5.47123 10.8869 5.46713 10.8813 5.46138 10.8732C5.44985 10.8571 5.4317 10.8313 5.40834 10.7967C5.36153 10.7273 5.29439 10.6237 5.21802 10.4931C5.06372 10.2293 4.87962 9.86899 4.74629 9.469C4.4711 8.64343 4.4681 7.85863 5.05124 7.27549L3.99058 6.21483ZM4.34414 10.811L2.22282 12.9323L3.28348 13.993L5.4048 11.8717L4.34414 10.811ZM12.8292 1.6185L10.7078 3.73982L11.7685 4.80048L13.8898 2.67916L12.8292 1.6185ZM17.0718 5.86114L14.9505 7.98246L16.0111 9.04312L18.1325 6.9218L17.0718 5.86114Z",
        fill: "#4B5563"
    }));
};
const $03b2b175198bdf3b$var$remove = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $03b2b175198bdf3b$var$classNames__default["default"]("helix-icon", "remove-solid", className);
    return $03b2b175198bdf3b$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $03b2b175198bdf3b$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 16C13.3137 16 16 13.3137 16 10C16 6.68629 13.3137 4 10 4C6.68629 4 4 6.68629 4 10C4 13.3137 6.68629 16 10 16ZM6.75 9.25C6.33579 9.25 6 9.58579 6 10C6 10.4142 6.33579 10.75 6.75 10.75H13.25C13.6642 10.75 14 10.4142 14 10C14 9.58579 13.6642 9.25 13.25 9.25H6.75Z",
        fill: "#4B5563"
    }));
};
const $03b2b175198bdf3b$var$required_circle = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $03b2b175198bdf3b$var$classNames__default["default"]("helix-icon", "required_circle-solid", className);
    return $03b2b175198bdf3b$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $03b2b175198bdf3b$var$React__default["default"].createElement("path", {
        d: "M8.92004 9.72754V7.24609H10.0157C10.8751 7.24609 11.38 7.70801 11.38 8.47607C11.38 9.26025 10.8644 9.72754 9.99963 9.72754H8.92004Z",
        fill: "#4B5563"
    }), $03b2b175198bdf3b$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM8.92004 10.8984H10.0265L11.3907 13.7505H13.1095L11.5573 10.646C12.4005 10.313 12.9323 9.4751 12.9323 8.4707C12.9323 6.93457 11.901 6 10.2145 6H7.40002V13.7505H8.92004V10.8984Z",
        fill: "#4B5563"
    }));
};
const $03b2b175198bdf3b$var$star = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $03b2b175198bdf3b$var$classNames__default["default"]("helix-icon", "star-solid", className);
    return $03b2b175198bdf3b$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $03b2b175198bdf3b$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 1.75C10.2855 1.75 10.5462 1.91207 10.6726 2.16808L12.8492 6.57843L17.7163 7.28566C17.9988 7.32671 18.2335 7.52459 18.3217 7.7961C18.41 8.06761 18.3364 8.36566 18.132 8.56493L14.6101 11.9979L15.4415 16.8454C15.4897 17.1267 15.3741 17.4111 15.1431 17.5789C14.9122 17.7467 14.606 17.7688 14.3533 17.636L10 15.3473L5.64672 17.636C5.39403 17.7688 5.08784 17.7467 4.85688 17.5789C4.62592 17.4111 4.51025 17.1267 4.55851 16.8454L5.38991 11.9979L1.86804 8.56493C1.66361 8.36566 1.59004 8.06761 1.67826 7.7961C1.76647 7.52459 2.00118 7.32671 2.2837 7.28566L7.15081 6.57843L9.32745 2.16808C9.45379 1.91207 9.71452 1.75 10 1.75Z",
        fill: "#4B5563"
    }));
};
const $03b2b175198bdf3b$var$thumb_down = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $03b2b175198bdf3b$var$classNames__default["default"]("helix-icon", "thumb_down-solid", className);
    return $03b2b175198bdf3b$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $03b2b175198bdf3b$var$React__default["default"].createElement("path", {
        d: "M8.32262 17.5C8.63525 17.5 8.91509 17.3061 9.02486 17.0133L10.2815 13.6622C10.2999 13.6131 10.3333 13.5711 10.3769 13.542L11.5474 12.7617C11.7462 12.6292 11.9319 12.4779 12.1019 12.3101L13.5546 11.1044C13.5665 11.0946 13.5779 11.0841 13.5888 11.0732C13.6357 11.0263 13.6993 11 13.7656 11L15.7656 11C16.1798 11 16.5156 10.6642 16.5156 10.25V5.75C16.5156 5.33579 16.1798 5 15.7656 5H14.4738C13.9693 5 13.4717 4.88253 13.0204 4.65689L11.0761 3.68475C10.8331 3.56325 10.5652 3.5 10.2935 3.5H6.00322C4.85674 3.5 3.89359 4.36206 3.76698 5.50153L3.26085 10.0567C3.14567 11.0934 3.95713 12 5.00014 12L5.64078 12C6.53693 12 6.77643 12.275 6.85469 12.462C6.96536 12.7264 6.91941 13.1637 6.69918 13.7142L6.53383 14.1276C6.35665 14.5706 6.26562 15.0433 6.26562 15.5203V15.75C6.26562 16.7165 7.04912 17.5 8.01562 17.5H8.32262Z",
        fill: "#4B5563"
    }));
};
const $03b2b175198bdf3b$var$thumb_up = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $03b2b175198bdf3b$var$classNames__default["default"]("helix-icon", "thumb-up-solid", className);
    return $03b2b175198bdf3b$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $03b2b175198bdf3b$var$React__default["default"].createElement("path", {
        d: "M11.443 2.75C11.1304 2.75 10.8505 2.94393 10.7408 3.23666L9.48408 6.58778C9.46567 6.63687 9.4323 6.67893 9.38867 6.70801L8.21823 7.48831C8.01942 7.62085 7.83375 7.77208 7.66374 7.93992L6.21101 9.14558C6.19912 9.15545 6.1877 9.16586 6.17678 9.17678C6.12989 9.22367 6.0663 9.25 6 9.25H4C3.58579 9.25 3.25 9.58579 3.25 10V14.5C3.25 14.9142 3.58579 15.25 4 15.25H5.2918C5.79634 15.25 6.29396 15.3675 6.74524 15.5931L8.68951 16.5653C8.93251 16.6868 9.20046 16.75 9.47214 16.75H13.7624C14.9089 16.75 15.872 15.8879 15.9986 14.7485L16.5048 10.1933C16.6199 9.15662 15.8085 8.25 14.7655 8.25L14.1248 8.25C13.2287 8.25 12.9892 7.975 12.9109 7.78803C12.8003 7.52365 12.8462 7.08634 13.0664 6.53576L13.2318 6.12239C13.409 5.67943 13.5 5.20674 13.5 4.72967V4.5C13.5 3.5335 12.7165 2.75 11.75 2.75H11.443Z",
        fill: "#4B5563"
    }));
};
const $03b2b175198bdf3b$var$toggle = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $03b2b175198bdf3b$var$classNames__default["default"]("helix-icon", "toggle-solid", className);
    return $03b2b175198bdf3b$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $03b2b175198bdf3b$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 4C2.68629 4 0 6.68629 0 10C0 13.3137 2.68629 16 6 16H14C17.3137 16 20 13.3137 20 10C20 6.68629 17.3137 4 14 4H6ZM14 14C16.2091 14 18 12.2091 18 10C18 7.79086 16.2091 6 14 6C11.7909 6 10 7.79086 10 10C10 12.2091 11.7909 14 14 14Z",
        fill: "#4B5563"
    }));
};
const $03b2b175198bdf3b$var$video_player = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $03b2b175198bdf3b$var$classNames__default["default"]("helix-icon", "video-player-solid", className);
    return $03b2b175198bdf3b$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $03b2b175198bdf3b$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 3C1.44772 3 1 3.44772 1 4V16C1 16.5523 1.44772 17 2 17H18C18.5523 17 19 16.5523 19 16V4C19 3.44772 18.5523 3 18 3H2ZM8 13.4641L14 10L8 6.5359V13.4641Z",
        fill: "#4B5563"
    }));
};
const $03b2b175198bdf3b$var$warning = (_a)=>{
    var { className: className } = _a, rest = $klEzJ.__rest(_a, [
        "className"
    ]);
    const classes = $03b2b175198bdf3b$var$classNames__default["default"]("helix-icon", "warning-solid", className);
    return $03b2b175198bdf3b$var$React__default["default"].createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $03b2b175198bdf3b$var$React__default["default"].createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.1111 3.30761C11.24 1.56413 8.75388 1.56413 7.88281 3.30761L2.25259 14.5766C1.46678 16.1494 2.60961 18 4.36673 18H15.6272C17.3843 18 18.5271 16.1495 17.7413 14.5766L12.1111 3.30761ZM10.0043 12.902C10.3862 12.902 10.7025 12.6055 10.7273 12.2244L11.0622 7.06477C11.0996 6.48821 10.642 6 10.0643 6H9.94429C9.36652 6 8.90896 6.48822 8.94639 7.06477L9.28129 12.2244C9.30603 12.6055 9.62236 12.902 10.0043 12.902ZM9.22727 14.148C9.01261 14.3627 8.90527 14.624 8.90527 14.932C8.90527 15.24 9.01261 15.5013 9.22727 15.716C9.44194 15.9307 9.69861 16.038 9.99727 16.038C10.3053 16.038 10.5666 15.9307 10.7813 15.716C11.0053 15.5013 11.1173 15.24 11.1173 14.932C11.1173 14.624 11.0053 14.3627 10.7813 14.148C10.5666 13.924 10.3053 13.812 9.99727 13.812C9.69861 13.812 9.44194 13.924 9.22727 14.148Z",
        fill: "#4B5563"
    }));
};
module.exports.add = $03b2b175198bdf3b$var$add;
module.exports.arrow_sliding_down = $03b2b175198bdf3b$var$arrow_sliding_down;
module.exports.camera_video = $03b2b175198bdf3b$var$camera_video;
module.exports.circle_arrow_right = $03b2b175198bdf3b$var$circle_arrow_right;
module.exports.circle_checkmark = $03b2b175198bdf3b$var$circle_checkmark;
module.exports.circle_info = $03b2b175198bdf3b$var$circle_info;
module.exports.circle_small_x = $03b2b175198bdf3b$var$circle_small_x;
module.exports.circle_x = $03b2b175198bdf3b$var$circle_x;
module.exports.clock = $03b2b175198bdf3b$var$clock;
module.exports.comment = $03b2b175198bdf3b$var$comment;
module.exports.crown = $03b2b175198bdf3b$var$crown;
module.exports.diamond_exclamation = $03b2b175198bdf3b$var$diamond_exclamation;
module.exports.dots = $03b2b175198bdf3b$var$dots;
module.exports.flag = $03b2b175198bdf3b$var$flag;
module.exports.heart = $03b2b175198bdf3b$var$heart;
module.exports.marker = $03b2b175198bdf3b$var$marker;
module.exports.plug = $03b2b175198bdf3b$var$plug;
module.exports.remove = $03b2b175198bdf3b$var$remove;
module.exports.required_circle = $03b2b175198bdf3b$var$required_circle;
module.exports.star = $03b2b175198bdf3b$var$star;
module.exports.thumb_down = $03b2b175198bdf3b$var$thumb_down;
module.exports.thumb_up = $03b2b175198bdf3b$var$thumb_up;
module.exports.toggle = $03b2b175198bdf3b$var$toggle;
module.exports.video_player = $03b2b175198bdf3b$var$video_player;
module.exports.warning = $03b2b175198bdf3b$var$warning;

});

parcelRegister("90ISC", function(module, exports) {

$parcel$export(module.exports, "useSearchStore", () => $68f6ed6174fa5191$export$8992e2c9f8b2a805);
$parcel$export(module.exports, "useSavedAgentsStore", () => $68f6ed6174fa5191$export$3b3fde3b03d2cd8b);
$parcel$export(module.exports, "useAgentProfileStore", () => $68f6ed6174fa5191$export$9c1182174864f5d5);
$parcel$export(module.exports, "useCommonStore", () => $68f6ed6174fa5191$export$abc224086152f714);

var $f4OIt = parcelRequire("f4OIt");

var $88tPr = parcelRequire("88tPr");

var $caGGw = parcelRequire("caGGw");

var $5NVz0 = parcelRequire("5NVz0");

var $9QNal = parcelRequire("9QNal");

var $lEGzp = parcelRequire("lEGzp");

var $cstaF = parcelRequire("cstaF");

var $24YIE = parcelRequire("24YIE");

var $cghEn = parcelRequire("cghEn");

var $f6CJ4 = parcelRequire("f6CJ4");

var $jpGV2 = parcelRequire("jpGV2");

var $dDBOF = parcelRequire("dDBOF");

var $bLQRh = parcelRequire("bLQRh");

var $cwutX = parcelRequire("cwutX");

var $bmWW5 = parcelRequire("bmWW5");

var $70q5f = parcelRequire("70q5f");

var $b6fBF = parcelRequire("b6fBF");

var $jKEVi = parcelRequire("jKEVi");

var $4fYAk = parcelRequire("4fYAk");

var $7JB23 = parcelRequire("7JB23");

var $ae040 = parcelRequire("ae040");

var $jenAg = parcelRequire("jenAg");

var $bA5Mi = parcelRequire("bA5Mi");

var $ekOct = parcelRequire("ekOct");

var $an08p = parcelRequire("an08p");

var $lxCva = parcelRequire("lxCva");

var $75U5M = parcelRequire("75U5M");

var $eHBjM = parcelRequire("eHBjM");

var $35weQ = parcelRequire("35weQ");

var $4tbBr = parcelRequire("4tbBr");

var $fPGDZ = parcelRequire("fPGDZ");
const $68f6ed6174fa5191$export$8992e2c9f8b2a805 = (0, $jKEVi.useSearchStore);
const $68f6ed6174fa5191$export$3b3fde3b03d2cd8b = (0, $jpGV2.useSavedAgentsStore);
let $68f6ed6174fa5191$var$agentProfileStore = (set)=>({
        areaList: undefined,
        selectedAgentId: undefined,
        selectedMlsId: undefined,
        selectedArea: undefined,
        areaType: undefined,
        tableType: undefined,
        intervalType: undefined,
        isUnits: undefined,
        agentCoverageListingTab: undefined,
        currentTab: undefined,
        displayMode: undefined,
        timePeriod: undefined,
        inventoryTableType: (0, $cstaF.agentProductionTerms).forSaleListing,
        setAreaList: (list)=>set({
                areaList: list
            }),
        setSelectedAgentId: (agentId)=>set({
                selectedAgentId: agentId
            }),
        setSelectedMlsId: (mlsId)=>set({
                selectedMlsId: mlsId
            }),
        setSelectedArea: (area)=>set({
                selectedArea: area
            }),
        setAreaType: (areaType)=>set({
                areaType: areaType
            }),
        setTableType: (tableType)=>set({
                tableType: tableType
            }),
        setIntervalType: (intervalType)=>set({
                intervalType: intervalType
            }),
        setIsUnits: (isUnits)=>set({
                isUnits: isUnits
            }),
        setAgentCoverageListingTab: (tab)=>set({
                agentCoverageListingTab: tab
            }),
        setCurrentTab: (tab)=>set({
                currentTab: tab
            }),
        setDisplayMode: (displayMode)=>set({
                displayMode: displayMode
            }),
        setInventoryTableType: (inventoryTableType)=>set({
                inventoryTableType: inventoryTableType
            }),
        setTimePeriod: (timePeriod)=>set({
                timePeriod: timePeriod
            })
    });
const $68f6ed6174fa5191$export$9c1182174864f5d5 = (0, $f4OIt.create)((0, $88tPr.devtools)((0, $88tPr.persist)($68f6ed6174fa5191$var$agentProfileStore, {
    name: "ap_state",
    storage: (0, $88tPr.createJSONStorage)(()=>localStorage)
})));
const $68f6ed6174fa5191$var$initialCommonState = {
    timeIntervals: undefined,
    selectedModule: undefined,
    membership: undefined,
    profile: undefined,
    mlsProviders: undefined,
    officeInfo: undefined,
    agentInfo: undefined,
    popoverIsOpen: false,
    apiError: undefined,
    menuIsOpen: undefined,
    isSideNavExpanded: true,
    privileges: undefined,
    marketAreaLists: undefined,
    officeLists: undefined,
    agentLists: undefined,
    accountInfo: undefined,
    userInfo: undefined,
    selectedBeginValue: undefined,
    selectedEndValue: undefined,
    agentListToUpdate: undefined,
    lastUpdatedAgentList: undefined,
    popoverDataForAddAgentList: {},
    mlsList: undefined,
    backNavbar: {
        title: undefined,
        backLinkTitle: undefined
    },
    getSearchResults: null,
    selectedRowsIds: [],
    agentDetailNavigation: undefined,
    propertyTypes: undefined
};
let $68f6ed6174fa5191$var$commonStore = (set, get)=>({
        ...$68f6ed6174fa5191$var$initialCommonState,
        ...(0, $an08p.actions)(set),
        getPrivileges: async (accountId, userId)=>{
            let response;
            try {
                response = await (0, $caGGw.getUserPrivileges)(accountId, userId);
                if (!response.error) set({
                    privileges: response
                });
            } catch (err) {
                set({
                    error: err.message
                });
            }
            return response;
        },
        getUserAndOfficeInfo: ()=>{
            const searchStore = $68f6ed6174fa5191$export$8992e2c9f8b2a805.getState();
            const selectedModule = searchStore.selectedModule;
            const selectedMls = searchStore[selectedModule]?.selectedMls || {
                mlsId: get().agentInfo?.[0]?.mlsAgentId.mlsId
            };
            const userInfo = get().userInfo;
            const tokenInfo = (0, $f6CJ4.useAuthStore).getState().tokenInfo;
            const officeInfo = get().officeInfo;
            const emailAddress = userInfo ? userInfo.email : tokenInfo.email;
            const associatedOffice = [
                ...officeInfo
            ]?.sort((a, b)=>a.name.toUpperCase().localeCompare(b.name.toUpperCase()))?.filter((o)=>o.isOfficeActive)?.find((o)=>o.mlsOfficeId?.mlsId === selectedMls?.mlsId);
            const { name: name = "", address: address = "", phoneList: phoneList = "" } = associatedOffice || {};
            const { street1: street1 = "", city: city = "", stateCode: stateCode = "", zipCode: zipCode = "" } = address || {};
            const phoneNumber = phoneList?.length > 0 ? phoneList[0].phoneNumber : (0, $cstaF.agentProductionTerms).notApplicableAbbrv;
            const officeId = get().agentInfo?.[0]?.office?.mlsOfficeId?.officeId;
            return {
                emailAddress: emailAddress,
                name: name,
                street1: street1,
                city: city,
                stateCode: stateCode,
                zipCode: zipCode,
                phoneNumber: phoneNumber,
                officeId: officeId
            };
        },
        getAssociatedBrokerageId: ()=>{
            const searchStore = $68f6ed6174fa5191$export$8992e2c9f8b2a805.getState();
            const selectedModule = searchStore.selectedModule;
            const officeInfo = get().officeInfo;
            const selectedMls = searchStore[selectedModule]?.selectedMls || {
                mlsId: get().agentInfo?.[0]?.mlsAgentId.mlsId
            };
            const associatedOffice = [
                ...officeInfo ?? []
            ].sort((a, b)=>a.name.toUpperCase().localeCompare(b.name.toUpperCase())).filter((o)=>o.isOfficeActive).find((o)=>o.mlsOfficeId?.mlsId === selectedMls?.mlsId);
            return associatedOffice?.mlsBrokerId?.brokerId;
        },
        addAgentListsCheckedValues: (listId)=>{
            const newCheckedValues = {
                ...get().agentListsCheckedValues
            };
            newCheckedValues[listId] = true;
            set({
                agentListsCheckedValues: newCheckedValues
            });
        },
        removeAgentListsCheckedValues: (listId)=>{
            const newCheckedValues = {
                ...get().agentListsCheckedValues
            };
            newCheckedValues[listId] = false;
            set({
                agentListsCheckedValues: newCheckedValues
            });
        },
        handleUpdateAgentNameSelectedList: async (listId, agentIdToAdd, listName, agentNameSearch, setListInSearchByAgentSearch)=>{
            const shouldUpdateAgentNameSelectedList = (moduleSearch)=>{
                const dataSourceId = moduleSearch?.search?.searchCriteria?.criteria?.realEstateDatasourceIdsWithFilters[0];
                const hasSearchCriteria = !!moduleSearch?.search?.searchCriteria;
                const hasSearchMlsId = !!moduleSearch?.search?.mlsId;
                const searchListId = dataSourceId?.idFiltering[0]?.listId;
                const searchListIdMatch = searchListId === listId;
                const idValues = dataSourceId?.idFiltering[0]?.idValues;
                const hasAgentId = idValues?.includes(agentIdToAdd);
                if (hasSearchCriteria && !!hasSearchMlsId && !!searchListId && searchListIdMatch && !!idValues.length) {
                    if (hasAgentId) {
                        const updatedIdValues = idValues.filter((id)=>id !== agentIdToAdd);
                        setListInSearchByAgentSearch(updatedIdValues, searchListId);
                    } else setListInSearchByAgentSearch([
                        ...idValues,
                        agentIdToAdd
                    ], searchListId);
                }
            };
            let modifiedAgentList = {};
            const selectedAgentList = get().agentLists.find((list)=>list.agentListId === listId);
            const updateAgentList = async (modifiedAgentList, listName, listId)=>{
                set({
                    agentListToUpdate: listName
                });
                const response = await (0, $24YIE.updateSavedAgentList)(modifiedAgentList);
                const updatedAgentLists = get().agentLists.map((list)=>list.agentListId === response.agentListId ? response : list);
                set({
                    agentLists: updatedAgentLists,
                    agentListToUpdate: "",
                    lastUpdatedAgentList: listId
                });
                const savedAgentsModule = (0, $cstaF.modules).proficiencyMetrics.savedAgents;
                const agentNameModule = (0, $cstaF.modules).proficiencyMetrics.agents;
                const savedAgentsSelectedListId = $68f6ed6174fa5191$export$3b3fde3b03d2cd8b.getState().selectedListByModule[savedAgentsModule]?.agentListId;
                const agentNameSelectedListId = $68f6ed6174fa5191$export$3b3fde3b03d2cd8b.getState().selectedListByModule[agentNameModule]?.agentListId;
                if (savedAgentsSelectedListId === listId) {
                    $68f6ed6174fa5191$export$3b3fde3b03d2cd8b.getState().setSelectedListByModule(savedAgentsModule, response);
                    $68f6ed6174fa5191$export$3b3fde3b03d2cd8b.getState().markListAsDirty(listId);
                }
                if (agentNameSelectedListId === listId) {
                    $68f6ed6174fa5191$export$3b3fde3b03d2cd8b.getState().setSelectedListByModule(agentNameModule, response);
                    $68f6ed6174fa5191$export$3b3fde3b03d2cd8b.getState().markListAsDirty(listId);
                }
            };
            // This is remove
            if (selectedAgentList.agentIds.includes(agentIdToAdd)) {
                modifiedAgentList = {
                    ...selectedAgentList,
                    agentIds: selectedAgentList.agentIds.filter((agentId)=>agentId !== agentIdToAdd)
                };
                get().removeAgentListsCheckedValues(listId);
                try {
                    await updateAgentList(modifiedAgentList, listName, listId);
                } catch (err) {
                    get().addAgentListsCheckedValues(listId);
                    set({
                        error: err.message
                    });
                }
            // This is add
            } else {
                modifiedAgentList = {
                    ...selectedAgentList,
                    agentIds: [
                        ...selectedAgentList.agentIds,
                        agentIdToAdd
                    ]
                };
                get().addAgentListsCheckedValues(listId);
                try {
                    await updateAgentList(modifiedAgentList, listName, listId);
                } catch (err) {
                    get().removeAgentListsCheckedValues(listId);
                    set({
                        error: err.message
                    });
                }
            }
            shouldUpdateAgentNameSelectedList(agentNameSearch);
        },
        createAgentsList: async (mlsId, listName, agentIds)=>{
            const tokenInfo = (0, $f6CJ4.useAuthStore).getState().tokenInfo;
            const tokenType = (0, $f6CJ4.useAuthStore).getState().tokenType;
            const ownerId = (0, $cghEn.getOwnerIdByTokenInfo)[tokenType](tokenInfo);
            const ownerType = (0, $cstaF.ownerTypes)[tokenType.toLowerCase()] || (0, $cstaF.ownerTypes).user;
            const resolvedAgentIds = Array.isArray(agentIds) ? [
                ...new Set(agentIds)
            ] : agentIds ? [
                agentIds
            ] : [];
            const newAgentList = {
                name: listName,
                application: (0, $dDBOF.runningApp),
                ownerType: ownerType,
                ownerId: ownerId,
                mlsId: mlsId,
                agentIds: resolvedAgentIds
            };
            try {
                const response = await (0, $24YIE.saveAgentSearchList)(newAgentList, true);
                await get().getAgentLists(ownerId);
                return response;
            } catch (err) {
                set({
                    error: err.message
                });
                throw err;
            }
        },
        toggleAgentListsPopover: ()=>{
            set({
                popoverDataForAddAgentList: (prevState)=>({
                        ...prevState.popoverDataForAddAgentList,
                        popoverIsOpen: !prevState.popoverDataForAddAgentList.popoverIsOpen
                    })
            });
        },
        clearAgentListPopover: ()=>set({
                popoverDataForAddAgentList: {}
            }),
        setMlsProviders: (mlsList)=>set({
                mlsProviders: mlsList
            }),
        setSelectedBeginValue: (selectedBeginValue)=>set({
                selectedBeginValue: selectedBeginValue
            }),
        setSelectedEndValue: (selectedEndValue)=>set({
                selectedEndValue: selectedEndValue
            }),
        getTimeIntervals: async ()=>{
            try {
                const response = await (0, $9QNal.retryEndpoint)({
                    fetchFunction: (0, $9QNal.getTimeIntervals)
                });
                const todaysDate = new Date();
                const newSuggestedAgentsLastXDayIntervals = [
                    60,
                    90
                ].map((days)=>(0, $75U5M.createLastXDaysInterval)(days, todaysDate));
                set({
                    timeIntervals: [
                        ...response,
                        ...newSuggestedAgentsLastXDayIntervals
                    ]
                });
            } catch (err) {
                set({
                    error: err.message
                });
            }
        },
        getUserProfile: async (username)=>{
            let response;
            try {
                response = await (0, $caGGw.getUserProfile)(username);
                set({
                    profile: response
                });
            } catch (err) {
                set({
                    error: err.message
                });
            }
            return response;
        },
        getMembership: async (mlsIdList)=>{
            try {
                const response = await (0, $5NVz0.getMlsMembership)(mlsIdList);
                set({
                    membership: Array.isArray(response) ? response : []
                });
            } catch (err) {
                set({
                    error: err.message
                });
            }
        },
        getOfficeInfo: async (officeList)=>{
            let response;
            try {
                response = await (0, $9QNal.retryEndpoint)({
                    fetchFunction: (0, $5NVz0.getOfficeInfo),
                    payload: officeList
                });
                set({
                    officeInfo: response
                });
            } catch (err) {
                set({
                    error: err.message
                });
            }
            return response;
        },
        getAgentInfo: async (agentList)=>{
            let response;
            try {
                response = await (0, $5NVz0.getAgentInfo)(agentList);
                set({
                    agentInfo: response
                });
            } catch (err) {
                set({
                    error: err.message
                });
            }
            return response;
        },
        getMarketAreaLists: async (userId)=>{
            try {
                set({
                    isLoading: true
                });
                const response = await (0, $lEGzp.getMarketAreaLists)(userId);
                set({
                    isLoading: false,
                    marketAreaLists: response?.areas
                });
            } catch (err) {
                set({
                    isLoading: false,
                    error: err.message
                });
            }
        },
        getOfficeLists: async (userId)=>{
            try {
                set({
                    isLoading: true
                });
                const response = await (0, $lEGzp.getOfficeLists)(userId);
                set({
                    isLoading: false,
                    officeLists: response?.list
                });
            } catch (err) {
                set({
                    isLoading: false,
                    error: err.message
                });
            }
        },
        getAgentLists: async (userId)=>{
            try {
                const response = await (0, $lEGzp.getAgentLists)(userId);
                const filtered = (response || []).filter((list)=>list?.name?.toLowerCase() !== (0, $eHBjM.favoriteAgentTerms).reservedListName.toLowerCase());
                set({
                    isLoading: false,
                    agentLists: filtered
                });
            } catch (err) {
                set({
                    error: err.message
                });
            }
        },
        toggleMenuIsOpen: (menuIsOpen)=>set({
                menuIsOpen: menuIsOpen
            }),
        setIsSideNavExpanded: (isSideNavExpanded)=>set({
                isSideNavExpanded: isSideNavExpanded
            }),
        resetStore: ()=>{
            set($68f6ed6174fa5191$var$initialCommonState);
        },
        setAccountInfo: (accountInfo)=>{
            set({
                accountInfo: accountInfo
            });
        },
        setUserInfo: (userInfo)=>{
            set({
                userInfo: userInfo
            });
        },
        captureChartImage: async ()=>{
            const overviewStatus = (0, $70q5f.useMarketDynamicsStore).getState()?.overviewStatus;
            const module = $68f6ed6174fa5191$export$8992e2c9f8b2a805.getState()?.selectedModule;
            const listingViewId = $68f6ed6174fa5191$export$8992e2c9f8b2a805.getState()[module]?.listingViewId;
            const isOverview = listingViewId === (0, $4fYAk.listingOptions).overview.value;
            const container = document.createElement("div");
            const chartArea = document.querySelector((0, $cwutX.getPdfClassname)(isOverview, overviewStatus.currentTab, true));
            const keyInfoArea = document.querySelector(".key-info-capture-area");
            container.style.position = "absolute";
            container.style.left = "-8000px";
            container.style.top = "-8000px";
            const clonedChartArea = chartArea?.cloneNode(true);
            const clonedKeyInfoArea = keyInfoArea?.cloneNode(true);
            if (clonedChartArea) {
                clonedChartArea.style.position = "static";
                clonedChartArea.style.left = "auto";
                clonedChartArea.style.top = "auto";
                container.appendChild(clonedChartArea);
            }
            if (clonedKeyInfoArea) {
                clonedKeyInfoArea.style.position = "static";
                clonedKeyInfoArea.style.left = "auto";
                clonedKeyInfoArea.style.top = "auto";
                container.appendChild(clonedKeyInfoArea);
            }
            document.body.appendChild(container);
            const options = {
                scale: 2
            };
            const canvas = await (0, (/*@__PURE__*/$parcel$interopDefault($7JB23)))(container, options);
            document.body.removeChild(container);
            return canvas.toDataURL("image/png");
        },
        captureDashboardImage: async ()=>{
            const container = document.createElement("div");
            const dashboardArea = document.querySelector(".dashboard-capture-area");
            container.style.position = "absolute";
            container.style.left = "-10000px";
            container.style.top = "-10000px";
            const clonedDashboardArea = dashboardArea?.cloneNode(true);
            if (clonedDashboardArea) {
                clonedDashboardArea.style.position = "static";
                clonedDashboardArea.style.left = "auto";
                clonedDashboardArea.style.top = "auto";
                container.appendChild(clonedDashboardArea);
            }
            document.body.appendChild(container);
            const options = {
                scale: 2
            };
            const canvas = await (0, (/*@__PURE__*/$parcel$interopDefault($7JB23)))(container, options);
            document.body.removeChild(container);
            return canvas.toDataURL("image/png");
        },
        handlePDFGeneration: async ({ renderProps: renderProps, module: module, listingView: listingView, shouldCaptureChart: shouldCaptureChart = false, shouldCaptureDashboard: shouldCaptureDashboard = false, exportDetails: exportDetails })=>{
            try {
                await new Promise((resolve)=>setTimeout(resolve, 600));
                const chartImage = shouldCaptureChart ? await get().captureChartImage() : null;
                const dashboardImage = shouldCaptureDashboard ? await get().captureDashboardImage() : null;
                const htmlDoc = (0, $cwutX.renderComponentToHtml)((0, $b6fBF.default), {
                    ...renderProps,
                    exportDetails: exportDetails,
                    chartImage: chartImage,
                    dashboardImage: dashboardImage
                });
                const streamResponse = new Response(await (0, $24YIE.getPDF)(htmlDoc, (0, $bmWW5.paginationConfig)));
                const { config: config } = renderProps;
                await (0, $cwutX.downloadPDF)(streamResponse, module, listingView, exportDetails, config);
            } catch (error) {
                console.error((0, $bLQRh.errorMessaging).convertToPdf, error);
            } finally{
                (0, $bA5Mi.usePDFStore).getState().setDownloadModalStatus({
                    isPDFLoading: false,
                    fileType: (0, $cstaF.downloadFileTypes).csv,
                    isOpen: false
                });
            }
        },
        handleMarketDynamicsPDF: (module, loadedSearchCriteria)=>{
            (0, $bA5Mi.usePDFStore).getState().setDownloadModalStatus({
                isPDFLoading: true,
                fileType: (0, $cstaF.downloadFileTypes).pdf
            });
            const searchResults = get().getSearchResults();
            const searchStore = $68f6ed6174fa5191$export$8992e2c9f8b2a805.getState();
            if (!searchResults) throw new Error("Invalid Parameter: getSearchResults should be set from the results page");
            const defaultBeginValue = searchResults ? searchResults[searchResults?.length - 1]?.timePeriodStart : "";
            const defaultEndValue = searchResults ? searchResults[0]?.timePeriodEnd : "";
            const tableView = (0, $70q5f.useMarketDynamicsStore).getState()?.tableView;
            const shouldShowChart = searchStore[module]?.shouldShowChart;
            const listingViewId = searchStore[module]?.listingViewId;
            const isOverview = listingViewId === (0, $4fYAk.listingOptions).overview.value;
            const marketIndicatorContent = isOverview && (0, $70q5f.useMarketDynamicsStore).getState()?.marketIndicatorContent;
            const config = (0, $cwutX.reportConfig)[module];
            const renderProps = {
                listingViewId: listingViewId,
                loadedSearchCriteria: loadedSearchCriteria,
                module: module,
                searchResults: searchResults,
                selectedBeginValue: isOverview ? defaultBeginValue : get().selectedBeginValue,
                selectedEndValue: isOverview ? defaultEndValue : get().selectedEndValue,
                selectedMls: searchStore[module]?.selectedMls,
                timeFrameTitle: searchStore[module]?.timeFrameTitle,
                tableView: tableView,
                marketIndicatorContent: marketIndicatorContent,
                config: config
            };
            get().handlePDFGeneration({
                renderProps: renderProps,
                module: module,
                listingView: listingViewId,
                shouldCaptureChart: shouldShowChart,
                shouldCaptureDashboard: isOverview
            });
        },
        handleMarketSharePDF: (module, loadedSearchCriteria)=>{
            (0, $bA5Mi.usePDFStore).getState().setDownloadModalStatus({
                isPDFLoading: true,
                fileType: (0, $cstaF.downloadFileTypes).pdf
            });
            const searchStore = $68f6ed6174fa5191$export$8992e2c9f8b2a805.getState();
            const pdfStore = (0, $bA5Mi.usePDFStore).getState();
            const bottomRowData = pdfStore[module].pinnedBottomRowData?.[0];
            const searchResults = [
                ...pdfStore[module].results,
                bottomRowData
            ];
            const tableView = (0, $cwutX.transformTableView)(pdfStore[module].columnDefs);
            const listingViewTitle = pdfStore[module].listingViewTitle;
            const listingTypeId = searchStore[module].listingType;
            const timeIntervals = $68f6ed6174fa5191$export$abc224086152f714.getState()?.timeIntervals;
            const period = loadedSearchCriteria.timePeriod.intervalType;
            const { from: from, to: to } = timeIntervals.find((interval)=>interval.intervalType === period)?.last ?? {
                from: `${loadedSearchCriteria.timePeriod?.startDate}${0, $cstaF.ISO_MIDNIGHT}`,
                to: `${loadedSearchCriteria.timePeriod?.endDate}${0, $cstaF.ISO_MIDNIGHT}`
            };
            const isComparisonSetView = (0, $ae040.useComparisonSetsStore).getState()?.isComparisonSetView;
            const mlsObjectId = loadedSearchCriteria.realEstateDatasourceIdsWithFilters[0].mlsObjectId;
            const selectedComparisonSet = (0, $ae040.useComparisonSetsStore).getState().comparisonSets?.list?.find((cs)=>cs.id === mlsObjectId);
            const areaTypeTitle = searchStore[module].areaTypeTitle.mainTitle.replace(`${(0, $cstaF.searchTerms).areaType}: `, "");
            const listingStatus = (0, $jenAg.getListingStatus)(module, loadedSearchCriteria);
            const selectedOfficeList = searchStore[module].selectedOfficeList;
            const officesTitle = searchStore[module].officesTitle;
            const officeListName = selectedOfficeList === officesTitle.mainTitle ? selectedOfficeList : (0, $cstaF.searchTerms).myOffices;
            const config = (0, $cwutX.reportConfig)[module];
            const shouldShowChart = searchStore[module]?.shouldShowChart;
            const renderProps = {
                listingViewTitle: listingViewTitle,
                loadedSearchCriteria: loadedSearchCriteria,
                module: module,
                searchResults: searchResults,
                selectedBeginValue: from,
                selectedEndValue: to,
                selectedMls: searchStore[module]?.selectedMls,
                timeFrameTitle: searchStore[module]?.timeFrameTitle,
                listingTypeId: listingTypeId,
                isComparisonSetView: isComparisonSetView,
                selectedComparisonSet: selectedComparisonSet,
                areaTypeTitle: areaTypeTitle,
                listingStatus: listingStatus,
                tableView: tableView,
                officeListName: officeListName,
                config: config
            };
            get().handlePDFGeneration({
                renderProps: renderProps,
                module: module,
                listingView: listingViewTitle,
                shouldCaptureChart: shouldShowChart
            });
        },
        handleAgentMovementPDF: (module, loadedSearchCriteria)=>{
            (0, $bA5Mi.usePDFStore).getState().setDownloadModalStatus({
                isPDFLoading: true,
                fileType: (0, $cstaF.downloadFileTypes).pdf
            });
            const searchStore = $68f6ed6174fa5191$export$8992e2c9f8b2a805.getState();
            const selectedOfficeList = searchStore[module].selectedOfficeList;
            const officesTitle = searchStore[module].officesTitle;
            const officeListName = selectedOfficeList === officesTitle.mainTitle ? selectedOfficeList : null;
            const timeIntervals = $68f6ed6174fa5191$export$abc224086152f714.getState()?.timeIntervals;
            const period = loadedSearchCriteria.timePeriod.intervalType;
            const { from: from, to: to } = timeIntervals.find((interval)=>interval.intervalType === period)?.last ?? {
                from: `${loadedSearchCriteria.timePeriod?.startDate}${0, $cstaF.ISO_MIDNIGHT}`,
                to: `${loadedSearchCriteria.timePeriod?.endDate}${0, $cstaF.ISO_MIDNIGHT}`
            };
            const pdfStore = (0, $bA5Mi.usePDFStore).getState();
            const bottomRowData = {
                ...searchStore[module].totals,
                officeName: (0, $cstaF.searchTerms).totals
            };
            const sortedResults = [
                ...pdfStore[module].results
            ].sort((a, b)=>b.agentsLost - a.agentsLost);
            const searchResults = [
                ...sortedResults,
                bottomRowData
            ];
            const tableView = (0, $cwutX.flattenTable)(pdfStore[module].columnDefs);
            const config = (0, $cwutX.reportConfig)[module];
            const renderProps = {
                module: module,
                selectedMls: searchStore[module]?.selectedMls,
                loadedSearchCriteria: loadedSearchCriteria,
                officeListName: officeListName,
                selectedBeginValue: from,
                selectedEndValue: to,
                searchResults: searchResults,
                tableView: tableView,
                config: config
            };
            get().handlePDFGeneration({
                renderProps: renderProps,
                module: module,
                shouldCaptureChart: true
            });
        },
        handleAgentDetailsPDF: (module, loadedSearchCriteria)=>{
            const pdfStore = (0, $bA5Mi.usePDFStore).getState();
            pdfStore?.setDownloadModalStatus({
                isPDFLoading: true,
                fileType: (0, $cstaF.downloadFileTypes).pdf
            });
            const searchStore = $68f6ed6174fa5191$export$8992e2c9f8b2a805.getState();
            const productionSummary = pdfStore?.productionSummary;
            const selectedTabName = (0, $eHBjM.agentProfileTabNamesByIndex)[pdfStore.agentProfileTabIndex];
            const exportDetails = pdfStore?.agentProfileExportDetails;
            const agentProfileTimePeriod = pdfStore?.agentProfileTimePeriod;
            const timeIntervals = $68f6ed6174fa5191$export$abc224086152f714.getState()?.timeIntervals;
            const { from: from, to: to } = timeIntervals.find((interval)=>interval.intervalType === agentProfileTimePeriod)?.last ?? {
                from: `${loadedSearchCriteria.timePeriod?.startDate}${0, $cstaF.ISO_MIDNIGHT}`,
                to: `${loadedSearchCriteria.timePeriod?.endDate}${0, $cstaF.ISO_MIDNIGHT}`
            };
            const selectedAgentProfileArea = pdfStore?.agentProfileArea;
            const reportType = (0, $cstaF.tabNameMap)[selectedTabName];
            const config = (0, $cwutX.agentDetailReportConfig)[reportType];
            const transactionCoverageData = pdfStore?.areasData.map((area, index)=>({
                    ...area,
                    rank: index + 1
                })).filter((area)=>area.checked === true);
            const excludedTransactionCoverageFields = [
                "rank",
                "area"
            ];
            const agentMetricsMlsId = $68f6ed6174fa5191$export$abc224086152f714.getState().agentInfo?.[0]?.mlsAgentId.mlsId;
            const agentMetricsShortDescription = $68f6ed6174fa5191$export$abc224086152f714.getState().membership?.find((m)=>m.mlsId === agentMetricsMlsId)?.shortDescription || "";
            const settingsByTab = {
                [(0, $eHBjM.agentProfileTabNamesByIndex)[0]]: {
                    searchResults: pdfStore?.agentProfileProductionTableData || [],
                    tableView: (0, $4tbBr.tableViews).agentDetailProduction
                },
                [(0, $eHBjM.agentProfileTabNamesByIndex)[1]]: {
                    searchResults: pdfStore?.agentProfileInventoryTableData || [],
                    tableView: (0, $35weQ.inventoryView)
                },
                [(0, $eHBjM.agentProfileTabNamesByIndex)[2]]: {
                    searchResults: (0, $fPGDZ.getDataWithTotalsRow)(transactionCoverageData, excludedTransactionCoverageFields) || [],
                    tableView: (0, $35weQ.createTransactionCoveragePDFView)(selectedAgentProfileArea)
                }
            };
            const renderProps = {
                module: module,
                selectedMls: searchStore[module]?.selectedMls || {
                    shortDescription: agentMetricsShortDescription
                },
                loadedSearchCriteria: loadedSearchCriteria,
                selectedTabName: selectedTabName,
                selectedBeginValue: from,
                selectedEndValue: to,
                config: config,
                selectedAgentProfileArea: selectedAgentProfileArea,
                searchResults: settingsByTab[selectedTabName]?.searchResults,
                tableView: settingsByTab[selectedTabName]?.tableView,
                productionSummary: productionSummary
            };
            get().handlePDFGeneration({
                renderProps: renderProps,
                module: module,
                shouldCaptureChart: true,
                exportDetails: exportDetails
            });
        },
        handleConvertToPDF: ()=>{
            const searchStore = $68f6ed6174fa5191$export$8992e2c9f8b2a805.getState();
            const module = searchStore?.selectedModule;
            const loadedSearchCriteria = searchStore[module]?.loadedSearchCriteria;
            if ((0, $cstaF.searchRoutes).agentDetail === window.location.pathname || module === (0, $cstaF.modules).agentProduction.agentProduction) {
                get().handleAgentDetailsPDF(module, loadedSearchCriteria);
                return;
            }
            if (module === (0, $cstaF.modules).marketDynamics.marketDynamics) get().handleMarketDynamicsPDF(module, loadedSearchCriteria);
            if (module === (0, $cstaF.modules).marketShare.totals || module === (0, $cstaF.modules).marketShare.coverage) get().handleMarketSharePDF(module, loadedSearchCriteria);
            if (module === (0, $cstaF.modules).proficiencyMetrics.agentMovement) get().handleAgentMovementPDF(module, loadedSearchCriteria);
        },
        handleBackNavigation: (route, history, altBackRoute)=>{
            const navigationAction = (0, $ekOct.backButtonConfig)[route];
            navigationAction?.(history, altBackRoute);
        },
        setPendoDataLayers: ({ tokenInfo: tokenInfo, selectedAccount: selectedAccount, isLegacyUser: isLegacyUser, runningApp: runningApp, productFlags: productFlags, userAccounts: userAccounts, ownerId: ownerId })=>{
            const pendoDataLayers = (0, $lxCva.getPendoDataLayers)({
                tokenInfo: tokenInfo,
                selectedAccount: selectedAccount,
                isLegacyUser: isLegacyUser,
                runningApp: runningApp,
                productFlags: productFlags,
                userAccounts: userAccounts,
                ownerId: ownerId
            });
            set({
                pendoDataLayers: pendoDataLayers
            });
        },
        setAgentDetailNavigation: (updates)=>{
            set((prevState)=>({
                    ...prevState,
                    agentDetailNavigation: {
                        ...prevState.agentDetailNavigation,
                        ...updates
                    }
                }));
        }
    });
const $68f6ed6174fa5191$export$abc224086152f714 = (0, $f4OIt.create)((0, $88tPr.devtools)((0, $88tPr.persist)($68f6ed6174fa5191$var$commonStore, {
    name: "common_state",
    storage: (0, $88tPr.createJSONStorage)(()=>sessionStorage)
})));

});
parcelRegister("f4OIt", function(module, exports) {
"use strict";

var $iNkrR = parcelRequire("iNkrR");

var $acw62 = parcelRequire("acw62");

var $9b0Yv = parcelRequire("9b0Yv");
var $af9e91ea6e32034a$var$useSyncExternalStoreWithSelector = $9b0Yv.useSyncExternalStoreWithSelector;
var $af9e91ea6e32034a$var$didWarnAboutEqualityFn = false;
function $af9e91ea6e32034a$var$useStore(api, selector, equalityFn) {
    if (selector === void 0) selector = api.getState;
    var slice = $af9e91ea6e32034a$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getState, selector, equalityFn);
    $acw62.useDebugValue(slice);
    return slice;
}
var $af9e91ea6e32034a$var$createImpl = function createImpl(createState) {
    var api = typeof createState === "function" ? $iNkrR.createStore(createState) : createState;
    var useBoundStore = function useBoundStore(selector, equalityFn) {
        return $af9e91ea6e32034a$var$useStore(api, selector, equalityFn);
    };
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
var $af9e91ea6e32034a$var$create = function create(createState) {
    return createState ? $af9e91ea6e32034a$var$createImpl(createState) : $af9e91ea6e32034a$var$createImpl;
};
var $af9e91ea6e32034a$var$react = function(createState) {
    return $af9e91ea6e32034a$var$create(createState);
};
module.exports.create = $af9e91ea6e32034a$var$create;
module.exports.default = $af9e91ea6e32034a$var$react;
module.exports.useStore = $af9e91ea6e32034a$var$useStore;
Object.keys($iNkrR).forEach(function(k) {
    if (k !== "default" && !Object.prototype.hasOwnProperty.call(module.exports, k)) Object.defineProperty(module.exports, k, {
        enumerable: true,
        get: function() {
            return $iNkrR[k];
        }
    });
});
module.exports = $af9e91ea6e32034a$var$react;
module.exports.create = $af9e91ea6e32034a$var$create;
module.exports.useStore = $af9e91ea6e32034a$var$useStore;
module.exports.createStore = $iNkrR.createStore;
module.exports.default = module.exports;

});
parcelRegister("iNkrR", function(module, exports) {
"use strict";
var $daecaa38e3584fd1$var$createStoreImpl = function createStoreImpl(createState) {
    var state;
    var listeners = new Set();
    var setState = function setState(partial, replace) {
        var nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            var _previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object") ? nextState : Object.assign({}, state, nextState);
            listeners.forEach(function(listener) {
                return listener(state, _previousState);
            });
        }
    };
    var getState = function getState() {
        return state;
    };
    var subscribe = function subscribe(listener) {
        listeners.add(listener);
        return function() {
            return listeners.delete(listener);
        };
    };
    var destroy = function destroy() {
        listeners.clear();
    };
    var api = {
        setState: setState,
        getState: getState,
        subscribe: subscribe,
        destroy: destroy
    };
    state = createState(setState, getState, api);
    return api;
};
var $daecaa38e3584fd1$var$createStore = function createStore(createState) {
    return createState ? $daecaa38e3584fd1$var$createStoreImpl(createState) : $daecaa38e3584fd1$var$createStoreImpl;
};
var $daecaa38e3584fd1$var$vanilla = function(createState) {
    return $daecaa38e3584fd1$var$createStore(createState);
};
module.exports.createStore = $daecaa38e3584fd1$var$createStore;
module.exports.default = $daecaa38e3584fd1$var$vanilla;
module.exports = $daecaa38e3584fd1$var$vanilla;
module.exports.createStore = $daecaa38e3584fd1$var$createStore;
module.exports.default = module.exports;

});

parcelRegister("9b0Yv", function(module, exports) {
"use strict";

module.exports = (parcelRequire("6VZtt"));

});
parcelRegister("6VZtt", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $50c7c0793ca9e0ff$export$bf730a2d8bf68b42, (v) => $50c7c0793ca9e0ff$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $50c7c0793ca9e0ff$export$bf730a2d8bf68b42;
"use strict";

var $acw62 = parcelRequire("acw62");

var $hfliI = parcelRequire("hfliI");
function $50c7c0793ca9e0ff$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $50c7c0793ca9e0ff$var$q = "function" === typeof Object.is ? Object.is : $50c7c0793ca9e0ff$var$p, $50c7c0793ca9e0ff$var$r = $hfliI.useSyncExternalStore, $50c7c0793ca9e0ff$var$t = $acw62.useRef, $50c7c0793ca9e0ff$var$u = $acw62.useEffect, $50c7c0793ca9e0ff$var$v = $acw62.useMemo, $50c7c0793ca9e0ff$var$w = $acw62.useDebugValue;
$50c7c0793ca9e0ff$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $50c7c0793ca9e0ff$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $50c7c0793ca9e0ff$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($50c7c0793ca9e0ff$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $50c7c0793ca9e0ff$var$r(a, c[0], c[1]);
    $50c7c0793ca9e0ff$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $50c7c0793ca9e0ff$var$w(d);
    return d;
};

});
parcelRegister("hfliI", function(module, exports) {
"use strict";

module.exports = (parcelRequire("30Ie1"));

});




parcelRegister("88tPr", function(module, exports) {

$parcel$export(module.exports, "createJSONStorage", () => $5ec635760157368f$export$95a3b7b12ab518f9, (v) => $5ec635760157368f$export$95a3b7b12ab518f9 = v);
$parcel$export(module.exports, "devtools", () => $5ec635760157368f$export$6922d3b3a607469e, (v) => $5ec635760157368f$export$6922d3b3a607469e = v);
$parcel$export(module.exports, "persist", () => $5ec635760157368f$export$9a6132153fba2e0, (v) => $5ec635760157368f$export$9a6132153fba2e0 = v);
var $5ec635760157368f$export$1be1fc439b849fdf;
var $5ec635760157368f$export$95a3b7b12ab518f9;
var $5ec635760157368f$export$6922d3b3a607469e;
var $5ec635760157368f$export$9a6132153fba2e0;
var $5ec635760157368f$export$4feba8a1bc8e9afd;
var $5ec635760157368f$export$5c593627aef9f076;
"use strict";
function $5ec635760157368f$var$_extends() {
    $5ec635760157368f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5ec635760157368f$var$_extends.apply(this, arguments);
}
function $5ec635760157368f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $5ec635760157368f$var$reduxImpl = function reduxImpl(reducer, initial) {
    return function(set, _get, api) {
        api.dispatch = function(action) {
            set(function(state) {
                return reducer(state, action);
            }, false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return $5ec635760157368f$var$_extends({
            dispatch: function dispatch() {
                var _ref;
                return (_ref = api).dispatch.apply(_ref, arguments);
            }
        }, initial);
    };
};
var $5ec635760157368f$var$redux = $5ec635760157368f$var$reduxImpl;
var $5ec635760157368f$var$_excluded = [
    "enabled",
    "anonymousActionType",
    "store"
], $5ec635760157368f$var$_excluded2 = [
    "connection"
];
var $5ec635760157368f$var$trackedConnections = new Map();
var $5ec635760157368f$var$getTrackedConnectionState = function getTrackedConnectionState(name) {
    var api = $5ec635760157368f$var$trackedConnections.get(name);
    if (!api) return {};
    return Object.fromEntries(Object.entries(api.stores).map(function(_ref) {
        var key = _ref[0], api = _ref[1];
        return [
            key,
            api.getState()
        ];
    }));
};
var $5ec635760157368f$var$extractConnectionInformation = function extractConnectionInformation(store, extensionConnector, options) {
    if (store === undefined) return {
        type: "untracked",
        connection: extensionConnector.connect(options)
    };
    var existingConnection = $5ec635760157368f$var$trackedConnections.get(options.name);
    if (existingConnection) return $5ec635760157368f$var$_extends({
        type: "tracked",
        store: store
    }, existingConnection);
    var newConnection = {
        connection: extensionConnector.connect(options),
        stores: {}
    };
    $5ec635760157368f$var$trackedConnections.set(options.name, newConnection);
    return $5ec635760157368f$var$_extends({
        type: "tracked",
        store: store
    }, newConnection);
};
var $5ec635760157368f$var$devtoolsImpl = function devtoolsImpl(fn, devtoolsOptions) {
    if (devtoolsOptions === void 0) devtoolsOptions = {};
    return function(set, get, api) {
        var _devtoolsOptions = devtoolsOptions, enabled = _devtoolsOptions.enabled, anonymousActionType = _devtoolsOptions.anonymousActionType, store = _devtoolsOptions.store, options = $5ec635760157368f$var$_objectWithoutPropertiesLoose(_devtoolsOptions, $5ec635760157368f$var$_excluded);
        var extensionConnector;
        try {
            extensionConnector = (enabled != null ? enabled : false) && window.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (e) {}
        if (!extensionConnector) return fn(set, get, api);
        var _extractConnectionInf = $5ec635760157368f$var$extractConnectionInformation(store, extensionConnector, options), connection = _extractConnectionInf.connection, connectionInformation = $5ec635760157368f$var$_objectWithoutPropertiesLoose(_extractConnectionInf, $5ec635760157368f$var$_excluded2);
        var isRecording = true;
        api.setState = function(state, replace, nameOrAction) {
            var _extends2;
            var r = set(state, replace);
            if (!isRecording) return r;
            var action = nameOrAction === undefined ? {
                type: anonymousActionType || "anonymous"
            } : typeof nameOrAction === "string" ? {
                type: nameOrAction
            } : nameOrAction;
            if (store === undefined) {
                connection == null || connection.send(action, get());
                return r;
            }
            connection == null || connection.send($5ec635760157368f$var$_extends({}, action, {
                type: store + "/" + action.type
            }), $5ec635760157368f$var$_extends({}, $5ec635760157368f$var$getTrackedConnectionState(options.name), (_extends2 = {}, _extends2[store] = api.getState(), _extends2)));
            return r;
        };
        var setStateFromDevtools = function setStateFromDevtools() {
            var originalIsRecording = isRecording;
            isRecording = false;
            set.apply(void 0, arguments);
            isRecording = originalIsRecording;
        };
        var initialState = fn(api.setState, get, api);
        if (connectionInformation.type === "untracked") connection == null || connection.init(initialState);
        else {
            connectionInformation.stores[connectionInformation.store] = api;
            connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(function(_ref2) {
                var key = _ref2[0], store = _ref2[1];
                return [
                    key,
                    key === connectionInformation.store ? initialState : store.getState()
                ];
            })));
        }
        if (api.dispatchFromDevtools && typeof api.dispatch === "function") {
            var didWarnAboutReservedActionType = false;
            var originalDispatch = api.dispatch;
            api.dispatch = function() {
                for(var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++)a[_key] = arguments[_key];
                originalDispatch.apply(void 0, a);
            };
        }
        connection.subscribe(function(message) {
            switch(message.type){
                case "ACTION":
                    if (typeof message.payload !== "string") {
                        console.error("[zustand devtools middleware] Unsupported action format");
                        return;
                    }
                    return $5ec635760157368f$var$parseJsonThen(message.payload, function(action) {
                        if (action.type === "__setState") {
                            if (store === undefined) {
                                setStateFromDevtools(action.state);
                                return;
                            }
                            if (Object.keys(action.state).length !== 1) console.error('\n                    [zustand devtools middleware] Unsupported __setState action format. \n                    When using \'store\' option in devtools(), the \'state\' should have only one key, which is a value of \'store\' that was passed in devtools(),\n                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }\n                    ');
                            var stateFromDevtools = action.state[store];
                            if (stateFromDevtools === undefined || stateFromDevtools === null) return;
                            if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                            return;
                        }
                        if (!api.dispatchFromDevtools) return;
                        if (typeof api.dispatch !== "function") return;
                        api.dispatch(action);
                    });
                case "DISPATCH":
                    switch(message.payload.type){
                        case "RESET":
                            setStateFromDevtools(initialState);
                            if (store === undefined) return connection == null ? void 0 : connection.init(api.getState());
                            return connection == null ? void 0 : connection.init($5ec635760157368f$var$getTrackedConnectionState(options.name));
                        case "COMMIT":
                            if (store === undefined) {
                                connection == null || connection.init(api.getState());
                                return;
                            }
                            return connection == null ? void 0 : connection.init($5ec635760157368f$var$getTrackedConnectionState(options.name));
                        case "ROLLBACK":
                            return $5ec635760157368f$var$parseJsonThen(message.state, function(state) {
                                if (store === undefined) {
                                    setStateFromDevtools(state);
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                setStateFromDevtools(state[store]);
                                connection == null || connection.init($5ec635760157368f$var$getTrackedConnectionState(options.name));
                            });
                        case "JUMP_TO_STATE":
                        case "JUMP_TO_ACTION":
                            return $5ec635760157368f$var$parseJsonThen(message.state, function(state) {
                                if (store === undefined) {
                                    setStateFromDevtools(state);
                                    return;
                                }
                                if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                            });
                        case "IMPORT_STATE":
                            var _nextLiftedState$comp;
                            var nextLiftedState = message.payload.nextLiftedState;
                            var lastComputedState = (_nextLiftedState$comp = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _nextLiftedState$comp.state;
                            if (!lastComputedState) return;
                            if (store === undefined) setStateFromDevtools(lastComputedState);
                            else setStateFromDevtools(lastComputedState[store]);
                            connection == null || connection.send(null, nextLiftedState);
                            return;
                        case "PAUSE_RECORDING":
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
};
var $5ec635760157368f$var$devtools = $5ec635760157368f$var$devtoolsImpl;
var $5ec635760157368f$var$parseJsonThen = function parseJsonThen(stringified, f) {
    var parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error("[zustand devtools middleware] Could not parse the received json", e);
    }
    if (parsed !== undefined) f(parsed);
};
var $5ec635760157368f$var$subscribeWithSelectorImpl = function subscribeWithSelectorImpl(fn) {
    return function(set, get, api) {
        var origSubscribe = api.subscribe;
        api.subscribe = function(selector, optListener, options) {
            var listener = selector;
            if (optListener) {
                var equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                var currentSlice = selector(api.getState());
                listener = function listener(state) {
                    var nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        var previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options != null && options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        var initialState = fn(set, get, api);
        return initialState;
    };
};
var $5ec635760157368f$var$subscribeWithSelector = $5ec635760157368f$var$subscribeWithSelectorImpl;
var $5ec635760157368f$var$combine = function combine(initialState, create) {
    return function() {
        return Object.assign({}, initialState, create.apply(void 0, arguments));
    };
};
function $5ec635760157368f$var$createJSONStorage(getStorage, options) {
    var storage;
    try {
        storage = getStorage();
    } catch (e) {
        return;
    }
    var persistStorage = {
        getItem: function getItem(name) {
            var _getItem;
            var parse = function parse(str) {
                if (str === null) return null;
                return JSON.parse(str, options == null ? void 0 : options.reviver);
            };
            var str = (_getItem = storage.getItem(name)) != null ? _getItem : null;
            if (str instanceof Promise) return str.then(parse);
            return parse(str);
        },
        setItem: function setItem(name, newValue) {
            return storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer));
        },
        removeItem: function removeItem(name) {
            return storage.removeItem(name);
        }
    };
    return persistStorage;
}
var $5ec635760157368f$var$toThenable = function toThenable(fn) {
    return function(input) {
        try {
            var result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then: function then(onFulfilled) {
                    return toThenable(onFulfilled)(result);
                },
                catch: function _catch(_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then: function then(_onFulfilled) {
                    return this;
                },
                catch: function _catch(onRejected) {
                    return toThenable(onRejected)(e);
                }
            };
        }
    };
};
var $5ec635760157368f$var$oldImpl = function oldImpl(config, baseOptions) {
    return function(set, get, api) {
        var options = $5ec635760157368f$var$_extends({
            getStorage: function getStorage() {
                return localStorage;
            },
            serialize: JSON.stringify,
            deserialize: JSON.parse,
            partialize: function partialize(state) {
                return state;
            },
            version: 0,
            merge: function merge(persistedState, currentState) {
                return $5ec635760157368f$var$_extends({}, currentState, persistedState);
            }
        }, baseOptions);
        var _hasHydrated = false;
        var hydrationListeners = new Set();
        var finishHydrationListeners = new Set();
        var storage;
        try {
            storage = options.getStorage();
        } catch (e) {}
        if (!storage) return config(function() {
            console.warn("[zustand persist middleware] Unable to update item '" + options.name + "', the given storage is currently unavailable.");
            set.apply(void 0, arguments);
        }, get, api);
        var thenableSerialize = $5ec635760157368f$var$toThenable(options.serialize);
        var setItem = function setItem() {
            var state = options.partialize($5ec635760157368f$var$_extends({}, get()));
            var errorInSync;
            var thenable = thenableSerialize({
                state: state,
                version: options.version
            }).then(function(serializedValue) {
                return storage.setItem(options.name, serializedValue);
            }).catch(function(e) {
                errorInSync = e;
            });
            if (errorInSync) throw errorInSync;
            return thenable;
        };
        var savedSetState = api.setState;
        api.setState = function(state, replace) {
            savedSetState(state, replace);
            setItem();
        };
        var configResult = config(function() {
            set.apply(void 0, arguments);
            setItem();
        }, get, api);
        var stateFromStorage;
        var hydrate = function hydrate() {
            if (!storage) return;
            _hasHydrated = false;
            hydrationListeners.forEach(function(cb) {
                return cb(get());
            });
            var postRehydrationCallback = (options.onRehydrateStorage == null ? void 0 : options.onRehydrateStorage(get())) || undefined;
            return $5ec635760157368f$var$toThenable(storage.getItem.bind(storage))(options.name).then(function(storageValue) {
                if (storageValue) return options.deserialize(storageValue);
            }).then(function(deserializedStorageValue) {
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error("State loaded from storage couldn't be migrated since no migrate function was provided");
                    } else return deserializedStorageValue.state;
                }
            }).then(function(migratedState) {
                var _get;
                stateFromStorage = options.merge(migratedState, (_get = get()) != null ? _get : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(function() {
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, undefined);
                _hasHydrated = true;
                finishHydrationListeners.forEach(function(cb) {
                    return cb(stateFromStorage);
                });
            }).catch(function(e) {
                postRehydrationCallback == null || postRehydrationCallback(undefined, e);
            });
        };
        api.persist = {
            setOptions: function setOptions(newOptions) {
                options = $5ec635760157368f$var$_extends({}, options, newOptions);
                if (newOptions.getStorage) storage = newOptions.getStorage();
            },
            clearStorage: function clearStorage() {
                var _storage;
                (_storage = storage) == null || _storage.removeItem(options.name);
            },
            getOptions: function getOptions() {
                return options;
            },
            rehydrate: function rehydrate() {
                return hydrate();
            },
            hasHydrated: function hasHydrated() {
                return _hasHydrated;
            },
            onHydrate: function onHydrate(cb) {
                hydrationListeners.add(cb);
                return function() {
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: function onFinishHydration(cb) {
                finishHydrationListeners.add(cb);
                return function() {
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        hydrate();
        return stateFromStorage || configResult;
    };
};
var $5ec635760157368f$var$newImpl = function newImpl(config, baseOptions) {
    return function(set, get, api) {
        var options = $5ec635760157368f$var$_extends({
            storage: $5ec635760157368f$var$createJSONStorage(function() {
                return localStorage;
            }),
            partialize: function partialize(state) {
                return state;
            },
            version: 0,
            merge: function merge(persistedState, currentState) {
                return $5ec635760157368f$var$_extends({}, currentState, persistedState);
            }
        }, baseOptions);
        var _hasHydrated2 = false;
        var hydrationListeners = new Set();
        var finishHydrationListeners = new Set();
        var storage = options.storage;
        if (!storage) return config(function() {
            console.warn("[zustand persist middleware] Unable to update item '" + options.name + "', the given storage is currently unavailable.");
            set.apply(void 0, arguments);
        }, get, api);
        var setItem = function setItem() {
            var state = options.partialize($5ec635760157368f$var$_extends({}, get()));
            return storage.setItem(options.name, {
                state: state,
                version: options.version
            });
        };
        var savedSetState = api.setState;
        api.setState = function(state, replace) {
            savedSetState(state, replace);
            setItem();
        };
        var configResult = config(function() {
            set.apply(void 0, arguments);
            setItem();
        }, get, api);
        var stateFromStorage;
        var hydrate = function hydrate() {
            var _get3;
            if (!storage) return;
            _hasHydrated2 = false;
            hydrationListeners.forEach(function(cb) {
                var _get2;
                return cb((_get2 = get()) != null ? _get2 : configResult);
            });
            var postRehydrationCallback = (options.onRehydrateStorage == null ? void 0 : options.onRehydrateStorage((_get3 = get()) != null ? _get3 : configResult)) || undefined;
            return $5ec635760157368f$var$toThenable(storage.getItem.bind(storage))(options.name).then(function(deserializedStorageValue) {
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) return options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                        console.error("State loaded from storage couldn't be migrated since no migrate function was provided");
                    } else return deserializedStorageValue.state;
                }
            }).then(function(migratedState) {
                var _get4;
                stateFromStorage = options.merge(migratedState, (_get4 = get()) != null ? _get4 : configResult);
                set(stateFromStorage, true);
                return setItem();
            }).then(function() {
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, undefined);
                stateFromStorage = get();
                _hasHydrated2 = true;
                finishHydrationListeners.forEach(function(cb) {
                    return cb(stateFromStorage);
                });
            }).catch(function(e) {
                postRehydrationCallback == null || postRehydrationCallback(undefined, e);
            });
        };
        api.persist = {
            setOptions: function setOptions(newOptions) {
                options = $5ec635760157368f$var$_extends({}, options, newOptions);
                if (newOptions.storage) storage = newOptions.storage;
            },
            clearStorage: function clearStorage() {
                var _storage2;
                (_storage2 = storage) == null || _storage2.removeItem(options.name);
            },
            getOptions: function getOptions() {
                return options;
            },
            rehydrate: function rehydrate() {
                return hydrate();
            },
            hasHydrated: function hasHydrated() {
                return _hasHydrated2;
            },
            onHydrate: function onHydrate(cb) {
                hydrationListeners.add(cb);
                return function() {
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: function onFinishHydration(cb) {
                finishHydrationListeners.add(cb);
                return function() {
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        if (!options.skipHydration) hydrate();
        return stateFromStorage || configResult;
    };
};
var $5ec635760157368f$var$persistImpl = function persistImpl(config, baseOptions) {
    if ("getStorage" in baseOptions || "serialize" in baseOptions || "deserialize" in baseOptions) return $5ec635760157368f$var$oldImpl(config, baseOptions);
    return $5ec635760157368f$var$newImpl(config, baseOptions);
};
var $5ec635760157368f$var$persist = $5ec635760157368f$var$persistImpl;
$5ec635760157368f$export$1be1fc439b849fdf = $5ec635760157368f$var$combine;
$5ec635760157368f$export$95a3b7b12ab518f9 = $5ec635760157368f$var$createJSONStorage;
$5ec635760157368f$export$6922d3b3a607469e = $5ec635760157368f$var$devtools;
$5ec635760157368f$export$9a6132153fba2e0 = $5ec635760157368f$var$persist;
$5ec635760157368f$export$4feba8a1bc8e9afd = $5ec635760157368f$var$redux;
$5ec635760157368f$export$5c593627aef9f076 = $5ec635760157368f$var$subscribeWithSelector;

});

parcelRegister("caGGw", function(module, exports) {

$parcel$export(module.exports, "getUserAccounts", () => $8dc7878cf861a95c$export$160a2ee907bcaf92);
$parcel$export(module.exports, "getUserAccountsById", () => $8dc7878cf861a95c$export$a120779973735cd1);
$parcel$export(module.exports, "getUserPrivileges", () => $8dc7878cf861a95c$export$ddd36a4f01d14a5a);
$parcel$export(module.exports, "getUserProfile", () => $8dc7878cf861a95c$export$cb01c83fc8789b9b);

var $24YIE = parcelRequire("24YIE");
const $8dc7878cf861a95c$export$160a2ee907bcaf92 = async (email, token)=>{
    return await (0, $24YIE.sendApiRequest)("profile_user_get_by_email", [
        {
            parameter: "email",
            value: `${email}`
        }
    ], undefined, token);
};
const $8dc7878cf861a95c$export$a120779973735cd1 = async (userId, lwaId, token)=>{
    return await (0, $24YIE.sendApiRequest)("profile_user_get_by_id_and_lwaid", [
        {
            parameter: "lwaId",
            value: `${lwaId}`
        },
        {
            parameter: "id",
            value: `${userId}`
        }
    ], undefined, token);
};
const $8dc7878cf861a95c$export$ddd36a4f01d14a5a = async (accountId, userId)=>{
    return await (0, $24YIE.sendApiRequest)("user_account_privileges", [
        {
            parameter: "accountId",
            value: `${accountId}`
        },
        {
            parameter: "userId",
            value: `${userId}`
        }
    ]);
};
const $8dc7878cf861a95c$export$cb01c83fc8789b9b = async (username)=>{
    return await (0, $24YIE.sendApiRequest)("User_profile", [
        {
            parameter: "userName",
            value: `${username}`
        }
    ]);
};

});
parcelRegister("24YIE", function(module, exports) {

$parcel$export(module.exports, "sendApiRequest", () => $183b0e146849fdd1$export$8130c18439618be8);
$parcel$export(module.exports, "newSendApiRequest", () => $183b0e146849fdd1$export$104c57227cf6bd47);
$parcel$export(module.exports, "getAgentInfoDetail", () => $183b0e146849fdd1$export$430ac00eaf19ea38);
$parcel$export(module.exports, "getOfficeInfoDetail", () => $183b0e146849fdd1$export$75007a2079d98eb0);
$parcel$export(module.exports, "saveSavedSearch", () => $183b0e146849fdd1$export$53cf91f62bf604e4);
$parcel$export(module.exports, "updateSavedSearch", () => $183b0e146849fdd1$export$fc4514833c85b065);
$parcel$export(module.exports, "deleteSavedSearch", () => $183b0e146849fdd1$export$9fe6283fbd417dd7);
$parcel$export(module.exports, "saveCustomArea", () => $183b0e146849fdd1$export$5acab0a1fdcca4d6);
$parcel$export(module.exports, "updateSavedMarketArea", () => $183b0e146849fdd1$export$6135ba515709aecb);
$parcel$export(module.exports, "getSearchesByAreaId", () => $183b0e146849fdd1$export$6aee022457f72b7e);
$parcel$export(module.exports, "deleteSavedMarketArea", () => $183b0e146849fdd1$export$f4426873afde5634);
$parcel$export(module.exports, "saveOfficeSearchList", () => $183b0e146849fdd1$export$ae666cf315395310);
$parcel$export(module.exports, "updateSavedOfficeList", () => $183b0e146849fdd1$export$1d8693f612fb248e);
$parcel$export(module.exports, "deleteSavedOfficeList", () => $183b0e146849fdd1$export$61f0f4d2e45006b5);
$parcel$export(module.exports, "getSearchesByOfficeListId", () => $183b0e146849fdd1$export$f540f4a44b8ef582);
$parcel$export(module.exports, "saveAgentSearchList", () => $183b0e146849fdd1$export$1039e07300dd2483);
$parcel$export(module.exports, "updateSavedAgentList", () => $183b0e146849fdd1$export$4ecd0322d06d57a2);
$parcel$export(module.exports, "getSearchesByAgentListId", () => $183b0e146849fdd1$export$a03e90ba0e85245e);
$parcel$export(module.exports, "getSearchesByAreaListId", () => $183b0e146849fdd1$export$445762f55d8099ce);
$parcel$export(module.exports, "deleteSavedAgentList", () => $183b0e146849fdd1$export$4ea927f332bc161e);
$parcel$export(module.exports, "recordAgentListLoad", () => $183b0e146849fdd1$export$6281ab72a0be0348);
$parcel$export(module.exports, "getCoverageOfficeBreakdownList", () => $183b0e146849fdd1$export$83e5ccc1a00729a7);
$parcel$export(module.exports, "getOfficeBreakdownList", () => $183b0e146849fdd1$export$7507410700e630d8);
$parcel$export(module.exports, "getCompSetOfficeBreakdownList", () => $183b0e146849fdd1$export$c041fd437aecf83f);
$parcel$export(module.exports, "getListingBreakdown", () => $183b0e146849fdd1$export$a866fbf037b4f509);
$parcel$export(module.exports, "getCoverageListingBreakdown", () => $183b0e146849fdd1$export$f50db61171addd30);
$parcel$export(module.exports, "getBreakdownOfficeDetails", () => $183b0e146849fdd1$export$3a5872b8464fa7f);
$parcel$export(module.exports, "getListingDetailRequest", () => $183b0e146849fdd1$export$a4fd827479fb094);
$parcel$export(module.exports, "getListingHistoryRequest", () => $183b0e146849fdd1$export$915194ca034b76);
$parcel$export(module.exports, "getAgentListingDetailDrillDown", () => $183b0e146849fdd1$export$e5dd40564325a127);
$parcel$export(module.exports, "getAgentHistory", () => $183b0e146849fdd1$export$6b27e700e469ba20);
$parcel$export(module.exports, "getAgentInventoryHistory", () => $183b0e146849fdd1$export$3300e6fb168913e6);
$parcel$export(module.exports, "getAgentTransactionCoverage", () => $183b0e146849fdd1$export$5fd48f5917b7d53b);
$parcel$export(module.exports, "getAgentTransactionCoverageDrillDown", () => $183b0e146849fdd1$export$70a9086d3f17d0b5);
$parcel$export(module.exports, "saveComparisonSet", () => $183b0e146849fdd1$export$898af2c0f00a8f6e);
$parcel$export(module.exports, "updateComparisonSet", () => $183b0e146849fdd1$export$df0b0b9cf0f670f7);
$parcel$export(module.exports, "deleteComparisonSet", () => $183b0e146849fdd1$export$3f5d8ce53e3d666c);
$parcel$export(module.exports, "getPDF", () => $183b0e146849fdd1$export$13a4bc40d14cebea);
$parcel$export(module.exports, "getAllMlsListInfo", () => $183b0e146849fdd1$export$bc74e06d429667ac);
$parcel$export(module.exports, "getTransactionVolume", () => $183b0e146849fdd1$export$75664b7a1a84c436);
$parcel$export(module.exports, "getMarketAverageVolume", () => $183b0e146849fdd1$export$64ee5a040fed43a3);
$parcel$export(module.exports, "getDashboardRecentActivity", () => $183b0e146849fdd1$export$fdd9e4a8b12f8039);
$parcel$export(module.exports, "getMonthlySupplyDemand", () => $183b0e146849fdd1$export$f1d30ec7de54c14);

var $chB0Q = parcelRequire("chB0Q");

var $7AubO = parcelRequire("7AubO");

var $gDxKE = parcelRequire("gDxKE");

var $f6CJ4 = parcelRequire("f6CJ4");

var $90ISC = parcelRequire("90ISC");

var $i1BZc = parcelRequire("i1BZc");

var $bA5Mi = parcelRequire("bA5Mi");
const $183b0e146849fdd1$var$defaultRequestTimeout = 10000;
const $183b0e146849fdd1$export$8130c18439618be8 = async (endpoint, inputParameters, requestTimeout, propsToken, customErrorMessage = null, suppressToast = false)=>{
    let response;
    const controller = new AbortController();
    const timeoutId = setTimeout(()=>controller.abort(), requestTimeout ?? $183b0e146849fdd1$var$defaultRequestTimeout);
    const authStore = (0, $f6CJ4.useAuthStore).getState();
    const token = propsToken || authStore.token;
    const activeClientId = authStore.activeClientId;
    if (token) {
        response = await fetch((0, $gDxKE.getPostRequestObj)(`${(0, $7AubO.getEndpoint)((0, $7AubO.SERVICE_GATEWAY))}/service/${endpoint}/data`, token, {
            inputParameters: inputParameters
        }, activeClientId), {
            signal: controller.signal
        }).then((response)=>{
            // This is expired keycloak token
            if (response.status === 403) {
                (0, $f6CJ4.useAuthStore).getState().handleExpiredToken();
                return {
                    error: response.status
                };
            }
            (0, $gDxKE.handleApiError)({
                response: response,
                endpoint: endpoint,
                customErrorMessage: customErrorMessage,
                suppressToast: suppressToast
            });
            return response.ok ? response.json() : {
                error: response.status
            };
        }).catch((error)=>{
            // When LWA token expires it doesn't provide a specific error code
            (0, $f6CJ4.useAuthStore).getState().handleExpiredToken();
            return {
                error: error
            };
        });
        clearTimeout(timeoutId);
    } else response = {
        error: "No token has been provided. Unable to process request."
    };
    return response;
};
const $183b0e146849fdd1$export$104c57227cf6bd47 = async (endpoint, inputParameters, requestTimeout, propsToken, isJsonResponse = true, propsActiveClientId, requestType = (0, $i1BZc.apiRequestTypes).post, queryString, isPlainResponse, customErrorMessage = null, suppressToast = false)=>{
    const controller = new AbortController();
    const timeoutId = setTimeout(()=>{
        controller.abort();
    }, requestTimeout ?? $183b0e146849fdd1$var$defaultRequestTimeout);
    const authStore = (0, $f6CJ4.useAuthStore).getState();
    const token = propsToken || authStore.token;
    const activeClientId = propsActiveClientId || authStore.activeClientId;
    if (!token) return {
        error: "No token has been provided. Unable to process request."
    };
    const url = `${(0, $7AubO.getEndpoint)((0, $7AubO.SERVICE_GATEWAY))}/service/${endpoint}/data`;
    try {
        const response = await fetch((0, $gDxKE.getRequestObjectByMethodType)({
            url: url,
            token: token,
            activeClientId: activeClientId,
            data: {
                inputParameters: inputParameters
            },
            queryString: queryString
        })[requestType], {
            signal: controller.signal
        });
        if (response.status === 403 || response.status == 401) {
            (0, $f6CJ4.useAuthStore).getState().handleExpiredToken();
            return {
                error: response.status
            };
        }
        (0, $gDxKE.handleApiError)({
            response: response,
            endpoint: endpoint,
            customErrorMessage: customErrorMessage,
            suppressToast: suppressToast
        });
        if (!response.ok) return response.status;
        if (isPlainResponse) return response;
        return isJsonResponse ? response.json() : response.body;
    } catch (error) {
        return {
            error: error
        };
    } finally{
        clearTimeout(timeoutId);
    }
};
const $183b0e146849fdd1$var$searchCriteriaData = (criteria, parameters = [])=>{
    const cleanCriteria = (0, $gDxKE.removeSearchAllMLSFlag)((0, $chB0Q.default)(criteria));
    return [
        {
            parameter: "aergo_search_criteria",
            value: JSON.stringify(cleanCriteria)
        },
        ...parameters
    ];
};
const $183b0e146849fdd1$export$430ac00eaf19ea38 = async (mlsId, agent)=>{
    return await $183b0e146849fdd1$export$8130c18439618be8("Agent_information", [
        {
            parameter: "mlsId",
            value: JSON.stringify(mlsId)
        },
        {
            parameter: "agentId",
            value: agent
        }
    ]);
};
const $183b0e146849fdd1$export$75007a2079d98eb0 = async (mlsId, office)=>{
    return await $183b0e146849fdd1$export$8130c18439618be8("Office_information_details", [
        {
            parameter: "mlsId",
            value: JSON.stringify(mlsId)
        },
        {
            parameter: "officeId",
            value: office
        }
    ]);
};
const $183b0e146849fdd1$export$53cf91f62bf604e4 = async (searchObj)=>{
    const id = (0, $90ISC.useCommonStore).getState()?.userInfo?.id;
    const modifiedSearchObj = !id ? searchObj : {
        ...searchObj,
        userId: id
    };
    return await $183b0e146849fdd1$export$8130c18439618be8("Save_Search", [
        {
            parameter: "saved_search",
            value: JSON.stringify(modifiedSearchObj)
        }
    ]);
};
const $183b0e146849fdd1$export$fc4514833c85b065 = async (searchObj)=>{
    const id = (0, $90ISC.useCommonStore).getState()?.userInfo?.id;
    const { savedSearch: savedSearch } = searchObj;
    const modifiedSearchObj = !id ? savedSearch : {
        ...savedSearch,
        userId: id
    };
    return await $183b0e146849fdd1$export$8130c18439618be8("Update_Search", [
        {
            parameter: "id",
            value: `${searchObj.id}`
        },
        {
            parameter: "saved_search",
            value: JSON.stringify(modifiedSearchObj)
        }
    ]);
};
const $183b0e146849fdd1$export$9fe6283fbd417dd7 = async (id)=>{
    return await $183b0e146849fdd1$export$8130c18439618be8("Delete_Search", [
        {
            parameter: "id",
            value: `${id}`
        }
    ]);
};
const $183b0e146849fdd1$export$5acab0a1fdcca4d6 = async (areaObj)=>{
    const id = (0, $90ISC.useCommonStore).getState()?.userInfo?.id;
    const modifiedAreaObj = !id ? areaObj : {
        ...areaObj,
        userId: id
    };
    return await $183b0e146849fdd1$export$8130c18439618be8("Save_Area", [
        {
            parameter: "saved_area",
            value: JSON.stringify(modifiedAreaObj)
        }
    ]);
};
const $183b0e146849fdd1$export$6135ba515709aecb = async (areaObj, savedSearches)=>{
    const id = (0, $90ISC.useCommonStore).getState()?.userInfo?.id;
    const modifiedAreaObj = !id ? areaObj : {
        ...areaObj,
        userId: id
    };
    const updateObj = {
        sa: modifiedAreaObj,
        ss: savedSearches ? savedSearches : []
    };
    return await $183b0e146849fdd1$export$8130c18439618be8("Areas_update", [
        {
            parameter: "id",
            value: `${areaObj.id}`
        },
        {
            parameter: "area_update",
            value: `${JSON.stringify(updateObj)}`
        }
    ]);
};
const $183b0e146849fdd1$export$6aee022457f72b7e = async (id)=>{
    return await $183b0e146849fdd1$export$8130c18439618be8("Searches_by_areaid", [
        {
            parameter: "id",
            value: `${id}`
        }
    ]);
};
const $183b0e146849fdd1$export$f4426873afde5634 = async (id, savedSearches)=>{
    const deleteObj = {
        ss: savedSearches
    };
    return await $183b0e146849fdd1$export$8130c18439618be8("Areas_delete", [
        {
            parameter: "id",
            value: `${id}`
        },
        {
            parameter: "ss",
            value: `${JSON.stringify(deleteObj)}`
        }
    ]);
};
const $183b0e146849fdd1$export$ae666cf315395310 = async (officeListObj)=>{
    const id = (0, $90ISC.useCommonStore).getState()?.userInfo?.id;
    const modifiedOfficeListObj = !id ? officeListObj : {
        ...officeListObj,
        userId: id
    };
    return await $183b0e146849fdd1$export$8130c18439618be8("Save_office_list", [
        {
            parameter: "mlsId",
            value: `${officeListObj.mlsId}`
        },
        {
            parameter: "office_list",
            value: `${JSON.stringify(modifiedOfficeListObj)}`
        }
    ], 20000);
};
const $183b0e146849fdd1$export$1d8693f612fb248e = async (officeListObj)=>{
    const id = (0, $90ISC.useCommonStore).getState()?.userInfo?.id;
    const modifiedOfficeListObj = !id ? officeListObj : {
        ...officeListObj,
        userId: id
    };
    return await $183b0e146849fdd1$export$8130c18439618be8("OfficeList_update", [
        {
            parameter: "officeList",
            value: `${JSON.stringify(modifiedOfficeListObj)}`
        }
    ]);
};
const $183b0e146849fdd1$export$61f0f4d2e45006b5 = async (listId)=>{
    return await $183b0e146849fdd1$export$8130c18439618be8("OfficeList_delete", [
        {
            parameter: "id",
            value: `${listId}`
        }
    ]);
};
const $183b0e146849fdd1$export$f540f4a44b8ef582 = async (listId)=>{
    return await $183b0e146849fdd1$export$8130c18439618be8("searches_by_office_list_id", [
        {
            parameter: "officeListId",
            value: `${listId}`
        }
    ]);
};
const $183b0e146849fdd1$export$1039e07300dd2483 = async (agentListObj, shouldSuppressToast)=>{
    const id = (0, $90ISC.useCommonStore).getState()?.userInfo?.id;
    const modifiedAgentListObj = !id ? agentListObj : {
        ...agentListObj,
        userId: id
    };
    return await $183b0e146849fdd1$export$8130c18439618be8("Save_agent_list", [
        {
            parameter: "mlsId",
            value: `${agentListObj.mlsId}`
        },
        {
            parameter: "agent_list",
            value: `${JSON.stringify(modifiedAgentListObj)}`
        }
    ], $183b0e146849fdd1$var$defaultRequestTimeout, null, null, shouldSuppressToast);
};
const $183b0e146849fdd1$export$4ecd0322d06d57a2 = async (agentListObj, shouldSuppressToast)=>{
    const id = (0, $90ISC.useCommonStore).getState()?.userInfo?.id;
    const modifiedAgentListObj = !id ? agentListObj : {
        ...agentListObj,
        userId: id
    };
    return await $183b0e146849fdd1$export$8130c18439618be8("AgentList_update", [
        {
            parameter: "agentList",
            value: `${JSON.stringify(modifiedAgentListObj)}`
        }
    ], $183b0e146849fdd1$var$defaultRequestTimeout, null, null, shouldSuppressToast);
};
const $183b0e146849fdd1$export$a03e90ba0e85245e = async (listId)=>{
    return await $183b0e146849fdd1$export$8130c18439618be8("searches_by_agent_list_id", [
        {
            parameter: "agentListId",
            value: `${listId}`
        }
    ]);
};
const $183b0e146849fdd1$export$445762f55d8099ce = async (listId)=>{
    return await $183b0e146849fdd1$export$8130c18439618be8("searches_by_agent_list_id", [
        {
            parameter: "agentListId",
            value: `${listId}`
        }
    ]);
};
const $183b0e146849fdd1$export$4ea927f332bc161e = async (listId)=>{
    return await $183b0e146849fdd1$export$8130c18439618be8("AgentList_delete", [
        {
            parameter: "id",
            value: `${listId}`
        }
    ]);
};
const $183b0e146849fdd1$export$6281ab72a0be0348 = async (listId)=>{
    await $183b0e146849fdd1$export$104c57227cf6bd47("AgentList_load", [
        {
            parameter: "id",
            value: `${listId}`
        }
    ]);
};
const $183b0e146849fdd1$export$83e5ccc1a00729a7 = async (areaId, searchCriteria)=>{
    if (!searchCriteria) return;
    const aergoSearchCriteria = {
        criteria: {
            ...searchCriteria,
            realEstateDatasourceIdsWithFilters: [
                {
                    ...searchCriteria.realEstateDatasourceIdsWithFilters[0],
                    searchFields: [
                        {
                            fieldName: searchCriteria.realEstateDatasourceIdsWithFilters[0].computedFields.find((f)=>f.fieldName === "areaType")?.fieldValues[0],
                            fieldValues: [
                                areaId
                            ]
                        },
                        {
                            fieldName: "propertyType",
                            fieldValues: searchCriteria.realEstateDatasourceIdsWithFilters[0].searchFields[0].fieldValues
                        }
                    ]
                }
            ]
        }
    };
    const inputParameters = [
        {
            parameter: "aergo_search_criteria",
            value: `${JSON.stringify(aergoSearchCriteria)}`
        }
    ];
    return await $183b0e146849fdd1$export$8130c18439618be8("Market_share_coverage_office_breakdown", inputParameters, 3000);
};
const $183b0e146849fdd1$export$7507410700e630d8 = async (brokerageId, searchCriteria)=>{
    if (!searchCriteria) return;
    const aergoSearchCriteria = {
        criteria: searchCriteria
    };
    const inputParameters = [
        {
            parameter: "aergo_search_criteria",
            value: `${JSON.stringify(aergoSearchCriteria)}`
        },
        {
            parameter: "brokerId",
            value: brokerageId
        }
    ];
    return await $183b0e146849fdd1$export$8130c18439618be8("Broker_office_breakdown", inputParameters, 3000);
};
const $183b0e146849fdd1$export$c041fd437aecf83f = async (officesIdList, searchCriteria, isAllOther)=>{
    if (!searchCriteria) return;
    const GET_ALL_OFFICES_NOT_COVERED_BY_OFFICE_GROUPS = "isAllOther";
    const { realEstateDatasourceIdsWithFilters: realEstateDatasourceIdsWithFilters, timePeriod: timePeriod } = searchCriteria;
    const { realEstateDatasourceId: realEstateDatasourceId, searchFields: searchFields, computedFields: computedFields } = realEstateDatasourceIdsWithFilters[0];
    const idFiltering = [
        {
            idType: "officeId",
            idValues: officesIdList
        }
    ];
    const modifiedAergoSearchCriteria = {
        criteria: {
            realEstateDatasourceIdsWithFilters: [
                {
                    realEstateDatasourceId: realEstateDatasourceId,
                    searchFields: [
                        searchFields[0]
                    ],
                    computedFields: [],
                    idFiltering: idFiltering
                }
            ],
            timePeriod: timePeriod
        }
    };
    const inputParameters = [
        {
            parameter: "aergo_search_criteria",
            value: JSON.stringify(modifiedAergoSearchCriteria)
        },
        {
            parameter: computedFields[0]?.fieldName,
            value: computedFields[0]?.fieldValues[0]
        }
    ];
    if (isAllOther) inputParameters.push({
        parameter: GET_ALL_OFFICES_NOT_COVERED_BY_OFFICE_GROUPS,
        value: isAllOther.toString()
    });
    return await $183b0e146849fdd1$export$104c57227cf6bd47("Comparison_set_office_breakdown", inputParameters, 20000);
};
const $183b0e146849fdd1$export$a866fbf037b4f509 = async (officeId, searchCriteria, transactionStatus)=>{
    if (!searchCriteria) return;
    const aergoSearchCriteria = {
        criteria: {
            realEstateDatasourceIdsWithFilters: [
                {
                    ...searchCriteria.realEstateDatasourceIdsWithFilters[0],
                    ...searchCriteria.realEstateDatasourceIdsWithFilters[0].searchFields,
                    computedFields: [
                        {
                            fieldName: "transactionStatus",
                            fieldValues: [
                                transactionStatus
                            ]
                        }
                    ]
                }
            ],
            timePeriod: searchCriteria.timePeriod
        }
    };
    const inputParameters = [
        {
            parameter: "aergo_search_criteria",
            value: `${JSON.stringify(aergoSearchCriteria)}`
        },
        {
            parameter: "officeId",
            value: officeId
        }
    ];
    return await $183b0e146849fdd1$export$8130c18439618be8("Office_listings", inputParameters, 20000);
};
const $183b0e146849fdd1$export$f50db61171addd30 = async (officeId, searchCriteria, transactionStatus, areaId)=>{
    if (!searchCriteria) return;
    const aergoSearchCriteria = {
        criteria: {
            ...searchCriteria,
            realEstateDatasourceIdsWithFilters: [
                {
                    ...searchCriteria.realEstateDatasourceIdsWithFilters[0],
                    searchFields: [
                        ...searchCriteria.realEstateDatasourceIdsWithFilters[0].searchFields,
                        {
                            fieldName: searchCriteria.realEstateDatasourceIdsWithFilters[0].computedFields.find((f)=>f.fieldName === "areaType")?.fieldValues[0],
                            fieldValues: [
                                areaId
                            ]
                        },
                        {
                            fieldName: "propertyType",
                            fieldValues: searchCriteria.realEstateDatasourceIdsWithFilters[0].searchFields[0].fieldValues
                        }
                    ],
                    idFiltering: [
                        {
                            idType: "officeId",
                            idValues: [
                                officeId
                            ]
                        }
                    ],
                    computedFields: [
                        {
                            fieldName: "transactionStatus",
                            fieldValues: [
                                transactionStatus
                            ]
                        }
                    ]
                }
            ]
        }
    };
    const inputParameters = [
        {
            parameter: "aergo_search_criteria",
            value: `${JSON.stringify(aergoSearchCriteria)}`
        }
    ];
    return await $183b0e146849fdd1$export$8130c18439618be8("Market_share_coverage_office_listings", inputParameters, 20000);
};
const $183b0e146849fdd1$export$3a5872b8464fa7f = async (mlsId, officeId)=>{
    return await $183b0e146849fdd1$export$8130c18439618be8("Office_information_details", [
        {
            parameter: "mlsId",
            value: `${mlsId}`
        },
        {
            parameter: "officeId",
            value: `${officeId}`
        }
    ]);
};
const $183b0e146849fdd1$export$a4fd827479fb094 = async (mlsNum, mlsId)=>{
    return await $183b0e146849fdd1$export$8130c18439618be8("Listing_information_detail", [
        {
            parameter: "mlsId",
            value: `${mlsId}`
        },
        {
            parameter: "mlsNum",
            value: `${mlsNum}`
        }
    ]);
};
const $183b0e146849fdd1$export$915194ca034b76 = async (mlsNum, mlsId)=>{
    return await $183b0e146849fdd1$export$8130c18439618be8("Listing_information_history", [
        {
            parameter: "mlsId",
            value: `${mlsId}`
        },
        {
            parameter: "mlsNum",
            value: `${mlsNum}`
        }
    ]);
};
const $183b0e146849fdd1$export$e5dd40564325a127 = async ({ agentId: agentId, realEstateDatasourceId: realEstateDatasourceId, intervalType: intervalType, listingType: listingType })=>{
    return await $183b0e146849fdd1$export$8130c18439618be8("Recruiting_agent_listing_detail_drilldown", [
        {
            parameter: "aergo_search_criteria",
            value: JSON.stringify({
                "criteria": {
                    "realEstateDatasourceIdsWithFilters": [
                        {
                            "realEstateDatasourceId": realEstateDatasourceId,
                            "searchFields": [],
                            "computedFields": []
                        }
                    ],
                    "timePeriod": {
                        "intervalType": `${intervalType}`
                    }
                },
                "offset": 0,
                "size": 0
            })
        },
        {
            parameter: "agentId",
            value: `${agentId}`
        },
        {
            parameter: "transactionStatus",
            value: `${listingType}`
        }
    ]);
};
const $183b0e146849fdd1$export$6b27e700e469ba20 = async ({ mlsId: mlsId, agentId: agentId })=>{
    return await $183b0e146849fdd1$export$8130c18439618be8("Recruiting_agent_production", [
        {
            parameter: "mlsId",
            value: `${mlsId}`
        },
        {
            parameter: "agentId",
            value: `${agentId}`
        }
    ]);
};
const $183b0e146849fdd1$export$3300e6fb168913e6 = async ({ agentId: agentId, mlsId: mlsId })=>{
    const res = await $183b0e146849fdd1$export$104c57227cf6bd47("Recruiting_agent_inventory", [
        {
            parameter: "mlsId",
            value: `${mlsId}`
        },
        {
            parameter: "agentId",
            value: `${agentId}`
        }
    ]);
    !res.error && (0, $bA5Mi.usePDFStore).getState().setAgentProfileInventoryTableData(res.inventoryItems);
    return res;
};
const $183b0e146849fdd1$export$5fd48f5917b7d53b = async (criteria, agentId, areaType, statusType, timeInterval)=>{
    let newCriteria = (0, $chB0Q.default)(criteria);
    newCriteria.realEstateDatasourceIdsWithFilters[0].searchFields = [];
    newCriteria.realEstateDatasourceIdsWithFilters[0].searchFields.push({
        "fieldName": `${areaType}`,
        "fieldValues": [
            ""
        ]
    });
    // Date interval is not considered for A or C deal status types
    newCriteria.timePeriod = {
        intervalType: timeInterval
    };
    return await $183b0e146849fdd1$export$8130c18439618be8("Recruiting_coverage", $183b0e146849fdd1$var$searchCriteriaData({
        criteria: newCriteria
    }, [
        {
            parameter: "agentId",
            value: `${agentId}`
        },
        {
            parameter: "statusCode",
            value: `${statusType}`
        }
    ]));
};
const $183b0e146849fdd1$export$70a9086d3f17d0b5 = async ({ criteria: criteria, agentId: agentId, areaType: areaType, areaName: areaName, statusCode: statusCode, intervalType: intervalType })=>{
    let newCriteria = (0, $chB0Q.default)(criteria);
    newCriteria.realEstateDatasourceIdsWithFilters[0].searchFields = [];
    newCriteria.realEstateDatasourceIdsWithFilters[0].searchFields.push({
        "fieldName": `${areaType}`,
        "fieldValues": [
            `${areaName}`
        ]
    });
    // Date interval is not considered for A or C deal status types
    newCriteria.timePeriod = {
        intervalType: intervalType
    };
    return await $183b0e146849fdd1$export$8130c18439618be8("Recruiting_agent_listing_detail_drilldown", $183b0e146849fdd1$var$searchCriteriaData({
        criteria: newCriteria
    }, [
        {
            parameter: "agentId",
            value: `${agentId}`
        },
        {
            parameter: "transactionStatus",
            value: `${statusCode}`
        }
    ]));
};
const $183b0e146849fdd1$export$898af2c0f00a8f6e = async (comparisonSetName, userId, mlsId)=>{
    return await $183b0e146849fdd1$export$8130c18439618be8("MlsObject_create", [
        {
            parameter: "ownerId",
            value: `${userId}`
        },
        {
            parameter: "ownerType",
            value: "userId"
        },
        {
            parameter: "objectType",
            value: "comparison_set"
        },
        {
            parameter: "mlsData",
            value: JSON.stringify({
                groups: [],
                mlsId: mlsId,
                name: comparisonSetName
            })
        }
    ]);
};
const $183b0e146849fdd1$export$df0b0b9cf0f670f7 = async (comparisonSet, groups)=>{
    return await $183b0e146849fdd1$export$8130c18439618be8("MlsObject_update", [
        {
            parameter: "mlsObjectId",
            value: `${comparisonSet.id}`
        },
        {
            parameter: "objectType",
            value: "comparison_set"
        },
        {
            parameter: "mlsData",
            value: JSON.stringify({
                groups: groups,
                mlsId: comparisonSet.mlsId,
                name: comparisonSet.name
            })
        }
    ]);
};
const $183b0e146849fdd1$export$3f5d8ce53e3d666c = async (comparisonSet)=>{
    return await $183b0e146849fdd1$export$8130c18439618be8("MlsObject_delete", [
        {
            parameter: "objectId",
            value: `${comparisonSet.id}`
        },
        {
            parameter: "objectType",
            value: "comparison_set"
        }
    ], 30000);
};
const $183b0e146849fdd1$export$13a4bc40d14cebea = async (htmlDoc, footer)=>{
    const jsonPayload = {
        htmlText: htmlDoc,
        orientation: "Landscape",
        footer: footer
    };
    return await $183b0e146849fdd1$export$104c57227cf6bd47("Documentconvert_pdf", [
        {
            parameter: "documentConvertBody",
            value: JSON.stringify(jsonPayload)
        }
    ], 120000, undefined, false);
};
const $183b0e146849fdd1$export$bc74e06d429667ac = async ()=>{
    const res = await $183b0e146849fdd1$export$104c57227cf6bd47("All_MLS_info", []);
    return res;
};
const $183b0e146849fdd1$export$75664b7a1a84c436 = async (mlsId, officeId, brokerId)=>{
    return await $183b0e146849fdd1$export$104c57227cf6bd47("dashboard_brokerage_volume", [
        {
            parameter: "mlsId",
            value: mlsId
        },
        ...officeId ? [
            {
                parameter: "officeId",
                value: officeId
            }
        ] : [],
        {
            parameter: "periodType",
            value: "ltm"
        },
        ...brokerId ? [
            {
                parameter: "brokerId",
                value: brokerId
            }
        ] : []
    ], 60000);
};
const $183b0e146849fdd1$export$64ee5a040fed43a3 = async (mlsId, officeId, brokerId)=>{
    return await $183b0e146849fdd1$export$104c57227cf6bd47("dashboard_market_average_volume", [
        {
            parameter: "mlsId",
            value: mlsId
        },
        ...officeId ? [
            {
                parameter: "officeId",
                value: officeId
            }
        ] : [],
        {
            parameter: "periodType",
            value: "ltm"
        },
        ...brokerId ? [
            {
                parameter: "brokerId",
                value: brokerId
            }
        ] : []
    ], 60000);
};
const $183b0e146849fdd1$export$fdd9e4a8b12f8039 = async (mlsId, timeInterval)=>{
    return await $183b0e146849fdd1$export$104c57227cf6bd47("Dashboard_recentActivity", [
        {
            parameter: "mlsId",
            value: mlsId
        },
        {
            parameter: "limit",
            value: "2000"
        },
        {
            parameter: "outputMode",
            value: "agent_summary"
        },
        ...timeInterval ? [
            {
                parameter: "startDate",
                value: timeInterval.from
            }
        ] : [],
        ...timeInterval ? [
            {
                parameter: "endDate",
                value: timeInterval.to
            }
        ] : []
    ], 60000);
};
const $183b0e146849fdd1$export$f1d30ec7de54c14 = async (mlsId)=>{
    return await $183b0e146849fdd1$export$104c57227cf6bd47("Dashboard_supplyDemand", [
        {
            parameter: "mlsId",
            value: mlsId
        }
    ], 60000);
};

});
parcelRegister("chB0Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $8f13c87c1500733f$export$2e2bcd8739ae039);

var $gbpSA = parcelRequire("gbpSA");
/** Used to compose bitmasks for cloning. */ var $8f13c87c1500733f$var$CLONE_DEEP_FLAG = 1, $8f13c87c1500733f$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $8f13c87c1500733f$var$cloneDeep(value) {
    return (0, $gbpSA.default)(value, $8f13c87c1500733f$var$CLONE_DEEP_FLAG | $8f13c87c1500733f$var$CLONE_SYMBOLS_FLAG);
}
var $8f13c87c1500733f$export$2e2bcd8739ae039 = $8f13c87c1500733f$var$cloneDeep;

});
parcelRegister("gbpSA", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc81bf84e8d65dab$export$2e2bcd8739ae039);

var $9WjpT = parcelRequire("9WjpT");

var $iDECW = parcelRequire("iDECW");

var $a6l6i = parcelRequire("a6l6i");

var $7FIi5 = parcelRequire("7FIi5");

var $3vFgL = parcelRequire("3vFgL");

var $gqoYg = parcelRequire("gqoYg");

var $jXStN = parcelRequire("jXStN");

var $8gRDv = parcelRequire("8gRDv");

var $7AKhX = parcelRequire("7AKhX");

var $oK0lo = parcelRequire("oK0lo");

var $7bulh = parcelRequire("7bulh");

var $4wkSQ = parcelRequire("4wkSQ");

var $9HyGp = parcelRequire("9HyGp");

var $iBTyS = parcelRequire("iBTyS");

var $7lgl7 = parcelRequire("7lgl7");

var $hf0C9 = parcelRequire("hf0C9");

var $f3ZL4 = parcelRequire("f3ZL4");

var $5HFwJ = parcelRequire("5HFwJ");

var $iYDsF = parcelRequire("iYDsF");

var $4X3Cn = parcelRequire("4X3Cn");

var $8krEv = parcelRequire("8krEv");

var $ceNjR = parcelRequire("ceNjR");
/** Used to compose bitmasks for cloning. */ var $bc81bf84e8d65dab$var$CLONE_DEEP_FLAG = 1, $bc81bf84e8d65dab$var$CLONE_FLAT_FLAG = 2, $bc81bf84e8d65dab$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $bc81bf84e8d65dab$var$argsTag = "[object Arguments]", $bc81bf84e8d65dab$var$arrayTag = "[object Array]", $bc81bf84e8d65dab$var$boolTag = "[object Boolean]", $bc81bf84e8d65dab$var$dateTag = "[object Date]", $bc81bf84e8d65dab$var$errorTag = "[object Error]", $bc81bf84e8d65dab$var$funcTag = "[object Function]", $bc81bf84e8d65dab$var$genTag = "[object GeneratorFunction]", $bc81bf84e8d65dab$var$mapTag = "[object Map]", $bc81bf84e8d65dab$var$numberTag = "[object Number]", $bc81bf84e8d65dab$var$objectTag = "[object Object]", $bc81bf84e8d65dab$var$regexpTag = "[object RegExp]", $bc81bf84e8d65dab$var$setTag = "[object Set]", $bc81bf84e8d65dab$var$stringTag = "[object String]", $bc81bf84e8d65dab$var$symbolTag = "[object Symbol]", $bc81bf84e8d65dab$var$weakMapTag = "[object WeakMap]";
var $bc81bf84e8d65dab$var$arrayBufferTag = "[object ArrayBuffer]", $bc81bf84e8d65dab$var$dataViewTag = "[object DataView]", $bc81bf84e8d65dab$var$float32Tag = "[object Float32Array]", $bc81bf84e8d65dab$var$float64Tag = "[object Float64Array]", $bc81bf84e8d65dab$var$int8Tag = "[object Int8Array]", $bc81bf84e8d65dab$var$int16Tag = "[object Int16Array]", $bc81bf84e8d65dab$var$int32Tag = "[object Int32Array]", $bc81bf84e8d65dab$var$uint8Tag = "[object Uint8Array]", $bc81bf84e8d65dab$var$uint8ClampedTag = "[object Uint8ClampedArray]", $bc81bf84e8d65dab$var$uint16Tag = "[object Uint16Array]", $bc81bf84e8d65dab$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $bc81bf84e8d65dab$var$cloneableTags = {};
$bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$argsTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$arrayTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$arrayBufferTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$dataViewTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$boolTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$dateTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$float32Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$float64Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$int8Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$int16Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$int32Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$mapTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$numberTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$objectTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$regexpTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$setTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$stringTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$symbolTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$uint8Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$uint8ClampedTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$uint16Tag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$uint32Tag] = true;
$bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$errorTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$funcTag] = $bc81bf84e8d65dab$var$cloneableTags[$bc81bf84e8d65dab$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $bc81bf84e8d65dab$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $bc81bf84e8d65dab$var$CLONE_DEEP_FLAG, isFlat = bitmask & $bc81bf84e8d65dab$var$CLONE_FLAT_FLAG, isFull = bitmask & $bc81bf84e8d65dab$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!(0, $iYDsF.default)(value)) return value;
    var isArr = (0, $hf0C9.default)(value);
    if (isArr) {
        result = (0, $9HyGp.default)(value);
        if (!isDeep) return (0, $jXStN.default)(value, result);
    } else {
        var tag = (0, $4wkSQ.default)(value), isFunc = tag == $bc81bf84e8d65dab$var$funcTag || tag == $bc81bf84e8d65dab$var$genTag;
        if ((0, $f3ZL4.default)(value)) return (0, $gqoYg.default)(value, isDeep);
        if (tag == $bc81bf84e8d65dab$var$objectTag || tag == $bc81bf84e8d65dab$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : (0, $7lgl7.default)(value);
            if (!isDeep) return isFlat ? (0, $7AKhX.default)(value, (0, $3vFgL.default)(result, value)) : (0, $8gRDv.default)(value, (0, $7FIi5.default)(result, value));
        } else {
            if (!$bc81bf84e8d65dab$var$cloneableTags[tag]) return object ? value : {};
            result = (0, $iBTyS.default)(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new (0, $9WjpT.default));
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ((0, $4X3Cn.default)(value)) value.forEach(function(subValue) {
        result.add($bc81bf84e8d65dab$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ((0, $5HFwJ.default)(value)) value.forEach(function(subValue, key) {
        result.set(key, $bc81bf84e8d65dab$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? (0, $7bulh.default) : (0, $oK0lo.default) : isFlat ? (0, $ceNjR.default) : (0, $8krEv.default);
    var props = isArr ? undefined : keysFunc(value);
    (0, $iDECW.default)(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        (0, $a6l6i.default)(result, key, $bc81bf84e8d65dab$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
var $bc81bf84e8d65dab$export$2e2bcd8739ae039 = $bc81bf84e8d65dab$var$baseClone;

});
parcelRegister("9WjpT", function(module, exports) {

$parcel$export(module.exports, "default", () => $73c8979051c99f66$export$2e2bcd8739ae039);

var $kVnfZ = parcelRequire("kVnfZ");

var $czhOX = parcelRequire("czhOX");

var $5QEPI = parcelRequire("5QEPI");

var $lwDUG = parcelRequire("lwDUG");

var $b5lTf = parcelRequire("b5lTf");

var $i8OSr = parcelRequire("i8OSr");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $73c8979051c99f66$var$Stack(entries) {
    var data = this.__data__ = new (0, $kVnfZ.default)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$73c8979051c99f66$var$Stack.prototype.clear = (0, $czhOX.default);
$73c8979051c99f66$var$Stack.prototype["delete"] = (0, $5QEPI.default);
$73c8979051c99f66$var$Stack.prototype.get = (0, $lwDUG.default);
$73c8979051c99f66$var$Stack.prototype.has = (0, $b5lTf.default);
$73c8979051c99f66$var$Stack.prototype.set = (0, $i8OSr.default);
var $73c8979051c99f66$export$2e2bcd8739ae039 = $73c8979051c99f66$var$Stack;

});
parcelRegister("kVnfZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3bb2bde4f3d2e10$export$2e2bcd8739ae039);

var $htx5f = parcelRequire("htx5f");

var $dEGYX = parcelRequire("dEGYX");

var $eiOY8 = parcelRequire("eiOY8");

var $5yv8I = parcelRequire("5yv8I");

var $67Adw = parcelRequire("67Adw");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $f3bb2bde4f3d2e10$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$f3bb2bde4f3d2e10$var$ListCache.prototype.clear = (0, $htx5f.default);
$f3bb2bde4f3d2e10$var$ListCache.prototype["delete"] = (0, $dEGYX.default);
$f3bb2bde4f3d2e10$var$ListCache.prototype.get = (0, $eiOY8.default);
$f3bb2bde4f3d2e10$var$ListCache.prototype.has = (0, $5yv8I.default);
$f3bb2bde4f3d2e10$var$ListCache.prototype.set = (0, $67Adw.default);
var $f3bb2bde4f3d2e10$export$2e2bcd8739ae039 = $f3bb2bde4f3d2e10$var$ListCache;

});
parcelRegister("htx5f", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb8ececfecd0309c$export$2e2bcd8739ae039);
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $cb8ececfecd0309c$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $cb8ececfecd0309c$export$2e2bcd8739ae039 = $cb8ececfecd0309c$var$listCacheClear;

});

parcelRegister("dEGYX", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f105a2cb198cf75$export$2e2bcd8739ae039);

var $eWSnX = parcelRequire("eWSnX");
/** Used for built-in method references. */ var $9f105a2cb198cf75$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $9f105a2cb198cf75$var$splice = $9f105a2cb198cf75$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $9f105a2cb198cf75$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $eWSnX.default)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $9f105a2cb198cf75$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $9f105a2cb198cf75$export$2e2bcd8739ae039 = $9f105a2cb198cf75$var$listCacheDelete;

});
parcelRegister("eWSnX", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae20ab4a6778d088$export$2e2bcd8739ae039);

var $lvgV1 = parcelRequire("lvgV1");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $ae20ab4a6778d088$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $lvgV1.default)(array[length][0], key)) return length;
    }
    return -1;
}
var $ae20ab4a6778d088$export$2e2bcd8739ae039 = $ae20ab4a6778d088$var$assocIndexOf;

});
parcelRegister("lvgV1", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa799df2e830873c$export$2e2bcd8739ae039);
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $fa799df2e830873c$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $fa799df2e830873c$export$2e2bcd8739ae039 = $fa799df2e830873c$var$eq;

});



parcelRegister("eiOY8", function(module, exports) {

$parcel$export(module.exports, "default", () => $a69a48810b4d495b$export$2e2bcd8739ae039);

var $eWSnX = parcelRequire("eWSnX");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $a69a48810b4d495b$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $eWSnX.default)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $a69a48810b4d495b$export$2e2bcd8739ae039 = $a69a48810b4d495b$var$listCacheGet;

});

parcelRegister("5yv8I", function(module, exports) {

$parcel$export(module.exports, "default", () => $40b84863e34edf18$export$2e2bcd8739ae039);

var $eWSnX = parcelRequire("eWSnX");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $40b84863e34edf18$var$listCacheHas(key) {
    return (0, $eWSnX.default)(this.__data__, key) > -1;
}
var $40b84863e34edf18$export$2e2bcd8739ae039 = $40b84863e34edf18$var$listCacheHas;

});

parcelRegister("67Adw", function(module, exports) {

$parcel$export(module.exports, "default", () => $474f7d7f66ed40d6$export$2e2bcd8739ae039);

var $eWSnX = parcelRequire("eWSnX");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $474f7d7f66ed40d6$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $eWSnX.default)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $474f7d7f66ed40d6$export$2e2bcd8739ae039 = $474f7d7f66ed40d6$var$listCacheSet;

});


parcelRegister("czhOX", function(module, exports) {

$parcel$export(module.exports, "default", () => $926693c1c5aa1b3b$export$2e2bcd8739ae039);

var $kVnfZ = parcelRequire("kVnfZ");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $926693c1c5aa1b3b$var$stackClear() {
    this.__data__ = new (0, $kVnfZ.default);
    this.size = 0;
}
var $926693c1c5aa1b3b$export$2e2bcd8739ae039 = $926693c1c5aa1b3b$var$stackClear;

});

parcelRegister("5QEPI", function(module, exports) {

$parcel$export(module.exports, "default", () => $44217bb0c3913906$export$2e2bcd8739ae039);
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $44217bb0c3913906$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
var $44217bb0c3913906$export$2e2bcd8739ae039 = $44217bb0c3913906$var$stackDelete;

});

parcelRegister("lwDUG", function(module, exports) {

$parcel$export(module.exports, "default", () => $fabb8c13d7ec2da0$export$2e2bcd8739ae039);
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $fabb8c13d7ec2da0$var$stackGet(key) {
    return this.__data__.get(key);
}
var $fabb8c13d7ec2da0$export$2e2bcd8739ae039 = $fabb8c13d7ec2da0$var$stackGet;

});

parcelRegister("b5lTf", function(module, exports) {

$parcel$export(module.exports, "default", () => $8121243fb2037ab0$export$2e2bcd8739ae039);
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $8121243fb2037ab0$var$stackHas(key) {
    return this.__data__.has(key);
}
var $8121243fb2037ab0$export$2e2bcd8739ae039 = $8121243fb2037ab0$var$stackHas;

});

parcelRegister("i8OSr", function(module, exports) {

$parcel$export(module.exports, "default", () => $d350707940985b27$export$2e2bcd8739ae039);

var $kVnfZ = parcelRequire("kVnfZ");

var $fs3H6 = parcelRequire("fs3H6");

var $7n3PR = parcelRequire("7n3PR");
/** Used as the size to enable large array optimizations. */ var $d350707940985b27$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $d350707940985b27$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $kVnfZ.default)) {
        var pairs = data.__data__;
        if (!(0, $fs3H6.default) || pairs.length < $d350707940985b27$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $7n3PR.default)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $d350707940985b27$export$2e2bcd8739ae039 = $d350707940985b27$var$stackSet;

});
parcelRegister("fs3H6", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3fc56271887eaf3$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");

var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $b3fc56271887eaf3$var$Map = (0, $jLT9P.default)((0, $2mpFt.default), "Map");
var $b3fc56271887eaf3$export$2e2bcd8739ae039 = $b3fc56271887eaf3$var$Map;

});
parcelRegister("jLT9P", function(module, exports) {

$parcel$export(module.exports, "default", () => $e64d313d457435ee$export$2e2bcd8739ae039);

var $hJ8AQ = parcelRequire("hJ8AQ");

var $b0QTV = parcelRequire("b0QTV");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $e64d313d457435ee$var$getNative(object, key) {
    var value = (0, $b0QTV.default)(object, key);
    return (0, $hJ8AQ.default)(value) ? value : undefined;
}
var $e64d313d457435ee$export$2e2bcd8739ae039 = $e64d313d457435ee$var$getNative;

});
parcelRegister("hJ8AQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce7d4e19db8c5f74$export$2e2bcd8739ae039);

var $4VY3C = parcelRequire("4VY3C");

var $fMWvx = parcelRequire("fMWvx");

var $iYDsF = parcelRequire("iYDsF");

var $5bfPQ = parcelRequire("5bfPQ");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $ce7d4e19db8c5f74$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $ce7d4e19db8c5f74$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $ce7d4e19db8c5f74$var$funcProto = Function.prototype, $ce7d4e19db8c5f74$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $ce7d4e19db8c5f74$var$funcToString = $ce7d4e19db8c5f74$var$funcProto.toString;
/** Used to check objects for own properties. */ var $ce7d4e19db8c5f74$var$hasOwnProperty = $ce7d4e19db8c5f74$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $ce7d4e19db8c5f74$var$reIsNative = RegExp("^" + $ce7d4e19db8c5f74$var$funcToString.call($ce7d4e19db8c5f74$var$hasOwnProperty).replace($ce7d4e19db8c5f74$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $ce7d4e19db8c5f74$var$baseIsNative(value) {
    if (!(0, $iYDsF.default)(value) || (0, $fMWvx.default)(value)) return false;
    var pattern = (0, $4VY3C.default)(value) ? $ce7d4e19db8c5f74$var$reIsNative : $ce7d4e19db8c5f74$var$reIsHostCtor;
    return pattern.test((0, $5bfPQ.default)(value));
}
var $ce7d4e19db8c5f74$export$2e2bcd8739ae039 = $ce7d4e19db8c5f74$var$baseIsNative;

});
parcelRegister("4VY3C", function(module, exports) {

$parcel$export(module.exports, "default", () => $397b12740d7995ef$export$2e2bcd8739ae039);

var $hArsG = parcelRequire("hArsG");

var $iYDsF = parcelRequire("iYDsF");
/** `Object#toString` result references. */ var $397b12740d7995ef$var$asyncTag = "[object AsyncFunction]", $397b12740d7995ef$var$funcTag = "[object Function]", $397b12740d7995ef$var$genTag = "[object GeneratorFunction]", $397b12740d7995ef$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $397b12740d7995ef$var$isFunction(value) {
    if (!(0, $iYDsF.default)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $hArsG.default)(value);
    return tag == $397b12740d7995ef$var$funcTag || tag == $397b12740d7995ef$var$genTag || tag == $397b12740d7995ef$var$asyncTag || tag == $397b12740d7995ef$var$proxyTag;
}
var $397b12740d7995ef$export$2e2bcd8739ae039 = $397b12740d7995ef$var$isFunction;

});
parcelRegister("hArsG", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccdb19c7f0a62300$export$2e2bcd8739ae039);

var $kRxPv = parcelRequire("kRxPv");

var $7IZ3R = parcelRequire("7IZ3R");

var $cIkDx = parcelRequire("cIkDx");
/** `Object#toString` result references. */ var $ccdb19c7f0a62300$var$nullTag = "[object Null]", $ccdb19c7f0a62300$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $ccdb19c7f0a62300$var$symToStringTag = (0, $kRxPv.default) ? (0, $kRxPv.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $ccdb19c7f0a62300$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $ccdb19c7f0a62300$var$undefinedTag : $ccdb19c7f0a62300$var$nullTag;
    return $ccdb19c7f0a62300$var$symToStringTag && $ccdb19c7f0a62300$var$symToStringTag in Object(value) ? (0, $7IZ3R.default)(value) : (0, $cIkDx.default)(value);
}
var $ccdb19c7f0a62300$export$2e2bcd8739ae039 = $ccdb19c7f0a62300$var$baseGetTag;

});
parcelRegister("kRxPv", function(module, exports) {

$parcel$export(module.exports, "default", () => $f302ffc9a48734c4$export$2e2bcd8739ae039);

var $2mpFt = parcelRequire("2mpFt");
/** Built-in value references. */ var $f302ffc9a48734c4$var$Symbol = (0, $2mpFt.default).Symbol;
var $f302ffc9a48734c4$export$2e2bcd8739ae039 = $f302ffc9a48734c4$var$Symbol;

});
parcelRegister("2mpFt", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b818bf49f333098$export$2e2bcd8739ae039);

var $4kWvg = parcelRequire("4kWvg");
/** Detect free variable `self`. */ var $1b818bf49f333098$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $1b818bf49f333098$var$root = (0, $4kWvg.default) || $1b818bf49f333098$var$freeSelf || Function("return this")();
var $1b818bf49f333098$export$2e2bcd8739ae039 = $1b818bf49f333098$var$root;

});
parcelRegister("4kWvg", function(module, exports) {

$parcel$export(module.exports, "default", () => $32866938ab70cc57$export$2e2bcd8739ae039);
/** Detect free variable `global` from Node.js. */ var $32866938ab70cc57$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $32866938ab70cc57$export$2e2bcd8739ae039 = $32866938ab70cc57$var$freeGlobal;

});



parcelRegister("7IZ3R", function(module, exports) {

$parcel$export(module.exports, "default", () => $59fc01f5e412f819$export$2e2bcd8739ae039);

var $kRxPv = parcelRequire("kRxPv");
/** Used for built-in method references. */ var $59fc01f5e412f819$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $59fc01f5e412f819$var$hasOwnProperty = $59fc01f5e412f819$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $59fc01f5e412f819$var$nativeObjectToString = $59fc01f5e412f819$var$objectProto.toString;
/** Built-in value references. */ var $59fc01f5e412f819$var$symToStringTag = (0, $kRxPv.default) ? (0, $kRxPv.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $59fc01f5e412f819$var$getRawTag(value) {
    var isOwn = $59fc01f5e412f819$var$hasOwnProperty.call(value, $59fc01f5e412f819$var$symToStringTag), tag = value[$59fc01f5e412f819$var$symToStringTag];
    try {
        value[$59fc01f5e412f819$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $59fc01f5e412f819$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$59fc01f5e412f819$var$symToStringTag] = tag;
        else delete value[$59fc01f5e412f819$var$symToStringTag];
    }
    return result;
}
var $59fc01f5e412f819$export$2e2bcd8739ae039 = $59fc01f5e412f819$var$getRawTag;

});

parcelRegister("cIkDx", function(module, exports) {

$parcel$export(module.exports, "default", () => $94199a1861e07064$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $94199a1861e07064$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $94199a1861e07064$var$nativeObjectToString = $94199a1861e07064$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $94199a1861e07064$var$objectToString(value) {
    return $94199a1861e07064$var$nativeObjectToString.call(value);
}
var $94199a1861e07064$export$2e2bcd8739ae039 = $94199a1861e07064$var$objectToString;

});


parcelRegister("iYDsF", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd0c70c8150db920$export$2e2bcd8739ae039);
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $dd0c70c8150db920$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
var $dd0c70c8150db920$export$2e2bcd8739ae039 = $dd0c70c8150db920$var$isObject;

});


parcelRegister("fMWvx", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7e8b9239f02cfcb$export$2e2bcd8739ae039);

var $gsGrt = parcelRequire("gsGrt");
/** Used to detect methods masquerading as native. */ var $b7e8b9239f02cfcb$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $gsGrt.default) && (0, $gsGrt.default).keys && (0, $gsGrt.default).keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $b7e8b9239f02cfcb$var$isMasked(func) {
    return !!$b7e8b9239f02cfcb$var$maskSrcKey && $b7e8b9239f02cfcb$var$maskSrcKey in func;
}
var $b7e8b9239f02cfcb$export$2e2bcd8739ae039 = $b7e8b9239f02cfcb$var$isMasked;

});
parcelRegister("gsGrt", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfc02efb2c4f5b86$export$2e2bcd8739ae039);

var $2mpFt = parcelRequire("2mpFt");
/** Used to detect overreaching core-js shims. */ var $bfc02efb2c4f5b86$var$coreJsData = (0, $2mpFt.default)["__core-js_shared__"];
var $bfc02efb2c4f5b86$export$2e2bcd8739ae039 = $bfc02efb2c4f5b86$var$coreJsData;

});


parcelRegister("5bfPQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c5a435f91273845$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $3c5a435f91273845$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $3c5a435f91273845$var$funcToString = $3c5a435f91273845$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $3c5a435f91273845$var$toSource(func) {
    if (func != null) {
        try {
            return $3c5a435f91273845$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
var $3c5a435f91273845$export$2e2bcd8739ae039 = $3c5a435f91273845$var$toSource;

});


parcelRegister("b0QTV", function(module, exports) {

$parcel$export(module.exports, "default", () => $8048bad1174acf1d$export$2e2bcd8739ae039);
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $8048bad1174acf1d$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $8048bad1174acf1d$export$2e2bcd8739ae039 = $8048bad1174acf1d$var$getValue;

});



parcelRegister("7n3PR", function(module, exports) {

$parcel$export(module.exports, "default", () => $55dda8022ba8f51a$export$2e2bcd8739ae039);

var $bAMUC = parcelRequire("bAMUC");

var $56mPM = parcelRequire("56mPM");

var $428kg = parcelRequire("428kg");

var $jYsb1 = parcelRequire("jYsb1");

var $5XP4x = parcelRequire("5XP4x");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $55dda8022ba8f51a$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$55dda8022ba8f51a$var$MapCache.prototype.clear = (0, $bAMUC.default);
$55dda8022ba8f51a$var$MapCache.prototype["delete"] = (0, $56mPM.default);
$55dda8022ba8f51a$var$MapCache.prototype.get = (0, $428kg.default);
$55dda8022ba8f51a$var$MapCache.prototype.has = (0, $jYsb1.default);
$55dda8022ba8f51a$var$MapCache.prototype.set = (0, $5XP4x.default);
var $55dda8022ba8f51a$export$2e2bcd8739ae039 = $55dda8022ba8f51a$var$MapCache;

});
parcelRegister("bAMUC", function(module, exports) {

$parcel$export(module.exports, "default", () => $8708ff73733b2f97$export$2e2bcd8739ae039);

var $lSo3Y = parcelRequire("lSo3Y");

var $kVnfZ = parcelRequire("kVnfZ");

var $fs3H6 = parcelRequire("fs3H6");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $8708ff73733b2f97$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new (0, $lSo3Y.default),
        "map": new ((0, $fs3H6.default) || (0, $kVnfZ.default)),
        "string": new (0, $lSo3Y.default)
    };
}
var $8708ff73733b2f97$export$2e2bcd8739ae039 = $8708ff73733b2f97$var$mapCacheClear;

});
parcelRegister("lSo3Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $fed14e894961a2f6$export$2e2bcd8739ae039);

var $kTYGm = parcelRequire("kTYGm");

var $3NrNW = parcelRequire("3NrNW");

var $lyGZN = parcelRequire("lyGZN");

var $lMA2G = parcelRequire("lMA2G");

var $aKknX = parcelRequire("aKknX");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $fed14e894961a2f6$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$fed14e894961a2f6$var$Hash.prototype.clear = (0, $kTYGm.default);
$fed14e894961a2f6$var$Hash.prototype["delete"] = (0, $3NrNW.default);
$fed14e894961a2f6$var$Hash.prototype.get = (0, $lyGZN.default);
$fed14e894961a2f6$var$Hash.prototype.has = (0, $lMA2G.default);
$fed14e894961a2f6$var$Hash.prototype.set = (0, $aKknX.default);
var $fed14e894961a2f6$export$2e2bcd8739ae039 = $fed14e894961a2f6$var$Hash;

});
parcelRegister("kTYGm", function(module, exports) {

$parcel$export(module.exports, "default", () => $f37803ed33a1d3d1$export$2e2bcd8739ae039);

var $cbYyv = parcelRequire("cbYyv");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $f37803ed33a1d3d1$var$hashClear() {
    this.__data__ = (0, $cbYyv.default) ? (0, $cbYyv.default)(null) : {};
    this.size = 0;
}
var $f37803ed33a1d3d1$export$2e2bcd8739ae039 = $f37803ed33a1d3d1$var$hashClear;

});
parcelRegister("cbYyv", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e057c2da47d85b2$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");
/* Built-in method references that are verified to be native. */ var $8e057c2da47d85b2$var$nativeCreate = (0, $jLT9P.default)(Object, "create");
var $8e057c2da47d85b2$export$2e2bcd8739ae039 = $8e057c2da47d85b2$var$nativeCreate;

});


parcelRegister("3NrNW", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c3b841be68d9967$export$2e2bcd8739ae039);
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $2c3b841be68d9967$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $2c3b841be68d9967$export$2e2bcd8739ae039 = $2c3b841be68d9967$var$hashDelete;

});

parcelRegister("lyGZN", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb1e2001932a20de$export$2e2bcd8739ae039);

var $cbYyv = parcelRequire("cbYyv");
/** Used to stand-in for `undefined` hash values. */ var $fb1e2001932a20de$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $fb1e2001932a20de$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $fb1e2001932a20de$var$hasOwnProperty = $fb1e2001932a20de$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $fb1e2001932a20de$var$hashGet(key) {
    var data = this.__data__;
    if (0, $cbYyv.default) {
        var result = data[key];
        return result === $fb1e2001932a20de$var$HASH_UNDEFINED ? undefined : result;
    }
    return $fb1e2001932a20de$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $fb1e2001932a20de$export$2e2bcd8739ae039 = $fb1e2001932a20de$var$hashGet;

});

parcelRegister("lMA2G", function(module, exports) {

$parcel$export(module.exports, "default", () => $fdba09ea24ad742a$export$2e2bcd8739ae039);

var $cbYyv = parcelRequire("cbYyv");
/** Used for built-in method references. */ var $fdba09ea24ad742a$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $fdba09ea24ad742a$var$hasOwnProperty = $fdba09ea24ad742a$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $fdba09ea24ad742a$var$hashHas(key) {
    var data = this.__data__;
    return (0, $cbYyv.default) ? data[key] !== undefined : $fdba09ea24ad742a$var$hasOwnProperty.call(data, key);
}
var $fdba09ea24ad742a$export$2e2bcd8739ae039 = $fdba09ea24ad742a$var$hashHas;

});

parcelRegister("aKknX", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d2e036616ad2fb6$export$2e2bcd8739ae039);

var $cbYyv = parcelRequire("cbYyv");
/** Used to stand-in for `undefined` hash values. */ var $7d2e036616ad2fb6$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $7d2e036616ad2fb6$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $cbYyv.default) && value === undefined ? $7d2e036616ad2fb6$var$HASH_UNDEFINED : value;
    return this;
}
var $7d2e036616ad2fb6$export$2e2bcd8739ae039 = $7d2e036616ad2fb6$var$hashSet;

});



parcelRegister("56mPM", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b6f39a956fe6a39$export$2e2bcd8739ae039);

var $9vBNU = parcelRequire("9vBNU");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $3b6f39a956fe6a39$var$mapCacheDelete(key) {
    var result = (0, $9vBNU.default)(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $3b6f39a956fe6a39$export$2e2bcd8739ae039 = $3b6f39a956fe6a39$var$mapCacheDelete;

});
parcelRegister("9vBNU", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ec4556484e81801$export$2e2bcd8739ae039);

var $4WJzL = parcelRequire("4WJzL");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $6ec4556484e81801$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $4WJzL.default)(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
var $6ec4556484e81801$export$2e2bcd8739ae039 = $6ec4556484e81801$var$getMapData;

});
parcelRegister("4WJzL", function(module, exports) {

$parcel$export(module.exports, "default", () => $399fee9a556f4b4d$export$2e2bcd8739ae039);
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $399fee9a556f4b4d$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
var $399fee9a556f4b4d$export$2e2bcd8739ae039 = $399fee9a556f4b4d$var$isKeyable;

});



parcelRegister("428kg", function(module, exports) {

$parcel$export(module.exports, "default", () => $2efdcea83805e55c$export$2e2bcd8739ae039);

var $9vBNU = parcelRequire("9vBNU");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $2efdcea83805e55c$var$mapCacheGet(key) {
    return (0, $9vBNU.default)(this, key).get(key);
}
var $2efdcea83805e55c$export$2e2bcd8739ae039 = $2efdcea83805e55c$var$mapCacheGet;

});

parcelRegister("jYsb1", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8a97a3ac9920cdd$export$2e2bcd8739ae039);

var $9vBNU = parcelRequire("9vBNU");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e8a97a3ac9920cdd$var$mapCacheHas(key) {
    return (0, $9vBNU.default)(this, key).has(key);
}
var $e8a97a3ac9920cdd$export$2e2bcd8739ae039 = $e8a97a3ac9920cdd$var$mapCacheHas;

});

parcelRegister("5XP4x", function(module, exports) {

$parcel$export(module.exports, "default", () => $457a144fcd79754e$export$2e2bcd8739ae039);

var $9vBNU = parcelRequire("9vBNU");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $457a144fcd79754e$var$mapCacheSet(key, value) {
    var data = (0, $9vBNU.default)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $457a144fcd79754e$export$2e2bcd8739ae039 = $457a144fcd79754e$var$mapCacheSet;

});




parcelRegister("iDECW", function(module, exports) {

$parcel$export(module.exports, "default", () => $d91b623631254979$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $d91b623631254979$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $d91b623631254979$export$2e2bcd8739ae039 = $d91b623631254979$var$arrayEach;

});

parcelRegister("a6l6i", function(module, exports) {

$parcel$export(module.exports, "default", () => $75aad50ec93ed496$export$2e2bcd8739ae039);

var $dLTlW = parcelRequire("dLTlW");

var $lvgV1 = parcelRequire("lvgV1");
/** Used for built-in method references. */ var $75aad50ec93ed496$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $75aad50ec93ed496$var$hasOwnProperty = $75aad50ec93ed496$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $75aad50ec93ed496$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($75aad50ec93ed496$var$hasOwnProperty.call(object, key) && (0, $lvgV1.default)(objValue, value)) || value === undefined && !(key in object)) (0, $dLTlW.default)(object, key, value);
}
var $75aad50ec93ed496$export$2e2bcd8739ae039 = $75aad50ec93ed496$var$assignValue;

});
parcelRegister("dLTlW", function(module, exports) {

$parcel$export(module.exports, "default", () => $a06a9a17329ff8a6$export$2e2bcd8739ae039);

var $1RMjB = parcelRequire("1RMjB");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $a06a9a17329ff8a6$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && (0, $1RMjB.default)) (0, $1RMjB.default)(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
var $a06a9a17329ff8a6$export$2e2bcd8739ae039 = $a06a9a17329ff8a6$var$baseAssignValue;

});
parcelRegister("1RMjB", function(module, exports) {

$parcel$export(module.exports, "default", () => $15c038100f8779dc$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");
var $15c038100f8779dc$var$defineProperty = function() {
    try {
        var func = (0, $jLT9P.default)(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
var $15c038100f8779dc$export$2e2bcd8739ae039 = $15c038100f8779dc$var$defineProperty;

});



parcelRegister("7FIi5", function(module, exports) {

$parcel$export(module.exports, "default", () => $595eb7f7a07807be$export$2e2bcd8739ae039);

var $3Wzdm = parcelRequire("3Wzdm");

var $8krEv = parcelRequire("8krEv");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $595eb7f7a07807be$var$baseAssign(object, source) {
    return object && (0, $3Wzdm.default)(source, (0, $8krEv.default)(source), object);
}
var $595eb7f7a07807be$export$2e2bcd8739ae039 = $595eb7f7a07807be$var$baseAssign;

});
parcelRegister("3Wzdm", function(module, exports) {

$parcel$export(module.exports, "default", () => $2df21abc8bda85fc$export$2e2bcd8739ae039);

var $a6l6i = parcelRequire("a6l6i");

var $dLTlW = parcelRequire("dLTlW");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $2df21abc8bda85fc$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $dLTlW.default)(object, key, newValue);
        else (0, $a6l6i.default)(object, key, newValue);
    }
    return object;
}
var $2df21abc8bda85fc$export$2e2bcd8739ae039 = $2df21abc8bda85fc$var$copyObject;

});

parcelRegister("8krEv", function(module, exports) {

$parcel$export(module.exports, "default", () => $6105a42c6332ca51$export$2e2bcd8739ae039);

var $OC2DR = parcelRequire("OC2DR");

var $lTyg4 = parcelRequire("lTyg4");

var $lAOUf = parcelRequire("lAOUf");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $6105a42c6332ca51$var$keys(object) {
    return (0, $lAOUf.default)(object) ? (0, $OC2DR.default)(object) : (0, $lTyg4.default)(object);
}
var $6105a42c6332ca51$export$2e2bcd8739ae039 = $6105a42c6332ca51$var$keys;

});
parcelRegister("OC2DR", function(module, exports) {

$parcel$export(module.exports, "default", () => $09822de5e5cf749f$export$2e2bcd8739ae039);

var $3f4I6 = parcelRequire("3f4I6");

var $5VdmZ = parcelRequire("5VdmZ");

var $hf0C9 = parcelRequire("hf0C9");

var $f3ZL4 = parcelRequire("f3ZL4");

var $cBYZY = parcelRequire("cBYZY");

var $cmTeE = parcelRequire("cmTeE");
/** Used for built-in method references. */ var $09822de5e5cf749f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $09822de5e5cf749f$var$hasOwnProperty = $09822de5e5cf749f$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $09822de5e5cf749f$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $hf0C9.default)(value), isArg = !isArr && (0, $5VdmZ.default)(value), isBuff = !isArr && !isArg && (0, $f3ZL4.default)(value), isType = !isArr && !isArg && !isBuff && (0, $cmTeE.default)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $3f4I6.default)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $09822de5e5cf749f$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    (0, $cBYZY.default)(key, length)))) result.push(key);
    return result;
}
var $09822de5e5cf749f$export$2e2bcd8739ae039 = $09822de5e5cf749f$var$arrayLikeKeys;

});
parcelRegister("3f4I6", function(module, exports) {

$parcel$export(module.exports, "default", () => $25c66d2c4e8fadd1$export$2e2bcd8739ae039);
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $25c66d2c4e8fadd1$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $25c66d2c4e8fadd1$export$2e2bcd8739ae039 = $25c66d2c4e8fadd1$var$baseTimes;

});

parcelRegister("5VdmZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $44fca59879666c41$export$2e2bcd8739ae039);

var $j2nBL = parcelRequire("j2nBL");

var $f2iog = parcelRequire("f2iog");
/** Used for built-in method references. */ var $44fca59879666c41$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $44fca59879666c41$var$hasOwnProperty = $44fca59879666c41$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $44fca59879666c41$var$propertyIsEnumerable = $44fca59879666c41$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $44fca59879666c41$var$isArguments = (0, $j2nBL.default)(function() {
    return arguments;
}()) ? (0, $j2nBL.default) : function(value) {
    return (0, $f2iog.default)(value) && $44fca59879666c41$var$hasOwnProperty.call(value, "callee") && !$44fca59879666c41$var$propertyIsEnumerable.call(value, "callee");
};
var $44fca59879666c41$export$2e2bcd8739ae039 = $44fca59879666c41$var$isArguments;

});
parcelRegister("j2nBL", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddc0844e7eecdb52$export$2e2bcd8739ae039);

var $hArsG = parcelRequire("hArsG");

var $f2iog = parcelRequire("f2iog");
/** `Object#toString` result references. */ var $ddc0844e7eecdb52$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $ddc0844e7eecdb52$var$baseIsArguments(value) {
    return (0, $f2iog.default)(value) && (0, $hArsG.default)(value) == $ddc0844e7eecdb52$var$argsTag;
}
var $ddc0844e7eecdb52$export$2e2bcd8739ae039 = $ddc0844e7eecdb52$var$baseIsArguments;

});
parcelRegister("f2iog", function(module, exports) {

$parcel$export(module.exports, "default", () => $af254ed7460d123e$export$2e2bcd8739ae039);
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $af254ed7460d123e$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
var $af254ed7460d123e$export$2e2bcd8739ae039 = $af254ed7460d123e$var$isObjectLike;

});



parcelRegister("hf0C9", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8d4506109b88831$export$2e2bcd8739ae039);
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $c8d4506109b88831$var$isArray = Array.isArray;
var $c8d4506109b88831$export$2e2bcd8739ae039 = $c8d4506109b88831$var$isArray;

});

parcelRegister("f3ZL4", function(module, exports) {

$parcel$export(module.exports, "default", () => $af770abdaf769dee$export$2e2bcd8739ae039);

var $2mpFt = parcelRequire("2mpFt");

var $kcGKx = parcelRequire("kcGKx");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $2mpFt.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $kcGKx.default);
var $af770abdaf769dee$export$2e2bcd8739ae039 = isBuffer;

});
parcelRegister("kcGKx", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb5616d4c933d058$export$2e2bcd8739ae039);
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $eb5616d4c933d058$var$stubFalse() {
    return false;
}
var $eb5616d4c933d058$export$2e2bcd8739ae039 = $eb5616d4c933d058$var$stubFalse;

});


parcelRegister("cBYZY", function(module, exports) {

$parcel$export(module.exports, "default", () => $92e841cef318fb91$export$2e2bcd8739ae039);
/** Used as references for various `Number` constants. */ var $92e841cef318fb91$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $92e841cef318fb91$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $92e841cef318fb91$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $92e841cef318fb91$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $92e841cef318fb91$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $92e841cef318fb91$export$2e2bcd8739ae039 = $92e841cef318fb91$var$isIndex;

});

parcelRegister("cmTeE", function(module, exports) {

$parcel$export(module.exports, "default", () => $901262b1d4441a58$export$2e2bcd8739ae039);

var $eaXgH = parcelRequire("eaXgH");

var $hb0cD = parcelRequire("hb0cD");

var $lFXqE = parcelRequire("lFXqE");
/* Node.js helper references. */ var $901262b1d4441a58$var$nodeIsTypedArray = (0, $lFXqE.default) && (0, $lFXqE.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $901262b1d4441a58$var$isTypedArray = $901262b1d4441a58$var$nodeIsTypedArray ? (0, $hb0cD.default)($901262b1d4441a58$var$nodeIsTypedArray) : (0, $eaXgH.default);
var $901262b1d4441a58$export$2e2bcd8739ae039 = $901262b1d4441a58$var$isTypedArray;

});
parcelRegister("eaXgH", function(module, exports) {

$parcel$export(module.exports, "default", () => $a51ff94e4fd33486$export$2e2bcd8739ae039);

var $hArsG = parcelRequire("hArsG");

var $idNmI = parcelRequire("idNmI");

var $f2iog = parcelRequire("f2iog");
/** `Object#toString` result references. */ var $a51ff94e4fd33486$var$argsTag = "[object Arguments]", $a51ff94e4fd33486$var$arrayTag = "[object Array]", $a51ff94e4fd33486$var$boolTag = "[object Boolean]", $a51ff94e4fd33486$var$dateTag = "[object Date]", $a51ff94e4fd33486$var$errorTag = "[object Error]", $a51ff94e4fd33486$var$funcTag = "[object Function]", $a51ff94e4fd33486$var$mapTag = "[object Map]", $a51ff94e4fd33486$var$numberTag = "[object Number]", $a51ff94e4fd33486$var$objectTag = "[object Object]", $a51ff94e4fd33486$var$regexpTag = "[object RegExp]", $a51ff94e4fd33486$var$setTag = "[object Set]", $a51ff94e4fd33486$var$stringTag = "[object String]", $a51ff94e4fd33486$var$weakMapTag = "[object WeakMap]";
var $a51ff94e4fd33486$var$arrayBufferTag = "[object ArrayBuffer]", $a51ff94e4fd33486$var$dataViewTag = "[object DataView]", $a51ff94e4fd33486$var$float32Tag = "[object Float32Array]", $a51ff94e4fd33486$var$float64Tag = "[object Float64Array]", $a51ff94e4fd33486$var$int8Tag = "[object Int8Array]", $a51ff94e4fd33486$var$int16Tag = "[object Int16Array]", $a51ff94e4fd33486$var$int32Tag = "[object Int32Array]", $a51ff94e4fd33486$var$uint8Tag = "[object Uint8Array]", $a51ff94e4fd33486$var$uint8ClampedTag = "[object Uint8ClampedArray]", $a51ff94e4fd33486$var$uint16Tag = "[object Uint16Array]", $a51ff94e4fd33486$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $a51ff94e4fd33486$var$typedArrayTags = {};
$a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$float32Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$float64Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$int8Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$int16Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$int32Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$uint8Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$uint8ClampedTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$uint16Tag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$uint32Tag] = true;
$a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$argsTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$arrayTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$arrayBufferTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$boolTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$dataViewTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$dateTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$errorTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$funcTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$mapTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$numberTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$objectTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$regexpTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$setTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$stringTag] = $a51ff94e4fd33486$var$typedArrayTags[$a51ff94e4fd33486$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $a51ff94e4fd33486$var$baseIsTypedArray(value) {
    return (0, $f2iog.default)(value) && (0, $idNmI.default)(value.length) && !!$a51ff94e4fd33486$var$typedArrayTags[(0, $hArsG.default)(value)];
}
var $a51ff94e4fd33486$export$2e2bcd8739ae039 = $a51ff94e4fd33486$var$baseIsTypedArray;

});
parcelRegister("idNmI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d43fbbcf5bc665de$export$2e2bcd8739ae039);
/** Used as references for various `Number` constants. */ var $d43fbbcf5bc665de$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $d43fbbcf5bc665de$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $d43fbbcf5bc665de$var$MAX_SAFE_INTEGER;
}
var $d43fbbcf5bc665de$export$2e2bcd8739ae039 = $d43fbbcf5bc665de$var$isLength;

});


parcelRegister("hb0cD", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8139f05a61e038a$export$2e2bcd8739ae039);
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $c8139f05a61e038a$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $c8139f05a61e038a$export$2e2bcd8739ae039 = $c8139f05a61e038a$var$baseUnary;

});

parcelRegister("lFXqE", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc7b86a02b9b077f$export$2e2bcd8739ae039);

var $4kWvg = parcelRequire("4kWvg");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $4kWvg.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
var $fc7b86a02b9b077f$export$2e2bcd8739ae039 = nodeUtil;

});



parcelRegister("lTyg4", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff094f04b4f9f6ca$export$2e2bcd8739ae039);

var $74QAJ = parcelRequire("74QAJ");

var $4lnKf = parcelRequire("4lnKf");
/** Used for built-in method references. */ var $ff094f04b4f9f6ca$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ff094f04b4f9f6ca$var$hasOwnProperty = $ff094f04b4f9f6ca$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $ff094f04b4f9f6ca$var$baseKeys(object) {
    if (!(0, $74QAJ.default)(object)) return (0, $4lnKf.default)(object);
    var result = [];
    for(var key in Object(object))if ($ff094f04b4f9f6ca$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
var $ff094f04b4f9f6ca$export$2e2bcd8739ae039 = $ff094f04b4f9f6ca$var$baseKeys;

});
parcelRegister("74QAJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5271b3ac6403835d$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $5271b3ac6403835d$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $5271b3ac6403835d$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $5271b3ac6403835d$var$objectProto;
    return value === proto;
}
var $5271b3ac6403835d$export$2e2bcd8739ae039 = $5271b3ac6403835d$var$isPrototype;

});

parcelRegister("4lnKf", function(module, exports) {

$parcel$export(module.exports, "default", () => $329b8ad85e05c8eb$export$2e2bcd8739ae039);

var $7N1cZ = parcelRequire("7N1cZ");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $329b8ad85e05c8eb$var$nativeKeys = (0, $7N1cZ.default)(Object.keys, Object);
var $329b8ad85e05c8eb$export$2e2bcd8739ae039 = $329b8ad85e05c8eb$var$nativeKeys;

});
parcelRegister("7N1cZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5abe0bf7e062106b$export$2e2bcd8739ae039);
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $5abe0bf7e062106b$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $5abe0bf7e062106b$export$2e2bcd8739ae039 = $5abe0bf7e062106b$var$overArg;

});



parcelRegister("lAOUf", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb8472aba17743fc$export$2e2bcd8739ae039);

var $4VY3C = parcelRequire("4VY3C");

var $idNmI = parcelRequire("idNmI");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $fb8472aba17743fc$var$isArrayLike(value) {
    return value != null && (0, $idNmI.default)(value.length) && !(0, $4VY3C.default)(value);
}
var $fb8472aba17743fc$export$2e2bcd8739ae039 = $fb8472aba17743fc$var$isArrayLike;

});



parcelRegister("3vFgL", function(module, exports) {

$parcel$export(module.exports, "default", () => $28e447985d6ff998$export$2e2bcd8739ae039);

var $3Wzdm = parcelRequire("3Wzdm");

var $ceNjR = parcelRequire("ceNjR");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $28e447985d6ff998$var$baseAssignIn(object, source) {
    return object && (0, $3Wzdm.default)(source, (0, $ceNjR.default)(source), object);
}
var $28e447985d6ff998$export$2e2bcd8739ae039 = $28e447985d6ff998$var$baseAssignIn;

});
parcelRegister("ceNjR", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e8d0ca4619e1205$export$2e2bcd8739ae039);

var $OC2DR = parcelRequire("OC2DR");

var $28fGX = parcelRequire("28fGX");

var $lAOUf = parcelRequire("lAOUf");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $8e8d0ca4619e1205$var$keysIn(object) {
    return (0, $lAOUf.default)(object) ? (0, $OC2DR.default)(object, true) : (0, $28fGX.default)(object);
}
var $8e8d0ca4619e1205$export$2e2bcd8739ae039 = $8e8d0ca4619e1205$var$keysIn;

});
parcelRegister("28fGX", function(module, exports) {

$parcel$export(module.exports, "default", () => $18d88030c379da98$export$2e2bcd8739ae039);

var $iYDsF = parcelRequire("iYDsF");

var $74QAJ = parcelRequire("74QAJ");

var $ab5U2 = parcelRequire("ab5U2");
/** Used for built-in method references. */ var $18d88030c379da98$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $18d88030c379da98$var$hasOwnProperty = $18d88030c379da98$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $18d88030c379da98$var$baseKeysIn(object) {
    if (!(0, $iYDsF.default)(object)) return (0, $ab5U2.default)(object);
    var isProto = (0, $74QAJ.default)(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$18d88030c379da98$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $18d88030c379da98$export$2e2bcd8739ae039 = $18d88030c379da98$var$baseKeysIn;

});
parcelRegister("ab5U2", function(module, exports) {

$parcel$export(module.exports, "default", () => $768f82a6c66c1e5e$export$2e2bcd8739ae039);
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $768f82a6c66c1e5e$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $768f82a6c66c1e5e$export$2e2bcd8739ae039 = $768f82a6c66c1e5e$var$nativeKeysIn;

});




parcelRegister("gqoYg", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf5271c040a1f410$export$2e2bcd8739ae039);

var $2mpFt = parcelRequire("2mpFt");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $2mpFt.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $bf5271c040a1f410$export$2e2bcd8739ae039 = cloneBuffer;

});

parcelRegister("jXStN", function(module, exports) {

$parcel$export(module.exports, "default", () => $e88dc98a9c0b5c36$export$2e2bcd8739ae039);
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $e88dc98a9c0b5c36$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $e88dc98a9c0b5c36$export$2e2bcd8739ae039 = $e88dc98a9c0b5c36$var$copyArray;

});

parcelRegister("8gRDv", function(module, exports) {

$parcel$export(module.exports, "default", () => $60596c5c5ae95246$export$2e2bcd8739ae039);

var $3Wzdm = parcelRequire("3Wzdm");

var $dKFRe = parcelRequire("dKFRe");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $60596c5c5ae95246$var$copySymbols(source, object) {
    return (0, $3Wzdm.default)(source, (0, $dKFRe.default)(source), object);
}
var $60596c5c5ae95246$export$2e2bcd8739ae039 = $60596c5c5ae95246$var$copySymbols;

});
parcelRegister("dKFRe", function(module, exports) {

$parcel$export(module.exports, "default", () => $02956b8552c88dad$export$2e2bcd8739ae039);

var $bpczR = parcelRequire("bpczR");

var $37AVt = parcelRequire("37AVt");
/** Used for built-in method references. */ var $02956b8552c88dad$var$objectProto = Object.prototype;
/** Built-in value references. */ var $02956b8552c88dad$var$propertyIsEnumerable = $02956b8552c88dad$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $02956b8552c88dad$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $02956b8552c88dad$var$getSymbols = !$02956b8552c88dad$var$nativeGetSymbols ? (0, $37AVt.default) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $bpczR.default)($02956b8552c88dad$var$nativeGetSymbols(object), function(symbol) {
        return $02956b8552c88dad$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $02956b8552c88dad$export$2e2bcd8739ae039 = $02956b8552c88dad$var$getSymbols;

});
parcelRegister("bpczR", function(module, exports) {

$parcel$export(module.exports, "default", () => $84dbc91852227c49$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $84dbc91852227c49$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $84dbc91852227c49$export$2e2bcd8739ae039 = $84dbc91852227c49$var$arrayFilter;

});

parcelRegister("37AVt", function(module, exports) {

$parcel$export(module.exports, "default", () => $245eab4238d1191b$export$2e2bcd8739ae039);
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $245eab4238d1191b$var$stubArray() {
    return [];
}
var $245eab4238d1191b$export$2e2bcd8739ae039 = $245eab4238d1191b$var$stubArray;

});



parcelRegister("7AKhX", function(module, exports) {

$parcel$export(module.exports, "default", () => $586fcd2cd99597f5$export$2e2bcd8739ae039);

var $3Wzdm = parcelRequire("3Wzdm");

var $hDzVK = parcelRequire("hDzVK");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $586fcd2cd99597f5$var$copySymbolsIn(source, object) {
    return (0, $3Wzdm.default)(source, (0, $hDzVK.default)(source), object);
}
var $586fcd2cd99597f5$export$2e2bcd8739ae039 = $586fcd2cd99597f5$var$copySymbolsIn;

});
parcelRegister("hDzVK", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd71f33290dd3540$export$2e2bcd8739ae039);

var $6JPqi = parcelRequire("6JPqi");

var $bzIQZ = parcelRequire("bzIQZ");

var $dKFRe = parcelRequire("dKFRe");

var $37AVt = parcelRequire("37AVt");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $cd71f33290dd3540$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $cd71f33290dd3540$var$getSymbolsIn = !$cd71f33290dd3540$var$nativeGetSymbols ? (0, $37AVt.default) : function(object) {
    var result = [];
    while(object){
        (0, $6JPqi.default)(result, (0, $dKFRe.default)(object));
        object = (0, $bzIQZ.default)(object);
    }
    return result;
};
var $cd71f33290dd3540$export$2e2bcd8739ae039 = $cd71f33290dd3540$var$getSymbolsIn;

});
parcelRegister("6JPqi", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e7ed5991d883ad6$export$2e2bcd8739ae039);
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $4e7ed5991d883ad6$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $4e7ed5991d883ad6$export$2e2bcd8739ae039 = $4e7ed5991d883ad6$var$arrayPush;

});

parcelRegister("bzIQZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $86d5c19d81d423c4$export$2e2bcd8739ae039);

var $7N1cZ = parcelRequire("7N1cZ");
/** Built-in value references. */ var $86d5c19d81d423c4$var$getPrototype = (0, $7N1cZ.default)(Object.getPrototypeOf, Object);
var $86d5c19d81d423c4$export$2e2bcd8739ae039 = $86d5c19d81d423c4$var$getPrototype;

});



parcelRegister("oK0lo", function(module, exports) {

$parcel$export(module.exports, "default", () => $04a5ed8d1a69f13e$export$2e2bcd8739ae039);

var $hNlD0 = parcelRequire("hNlD0");

var $dKFRe = parcelRequire("dKFRe");

var $8krEv = parcelRequire("8krEv");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $04a5ed8d1a69f13e$var$getAllKeys(object) {
    return (0, $hNlD0.default)(object, (0, $8krEv.default), (0, $dKFRe.default));
}
var $04a5ed8d1a69f13e$export$2e2bcd8739ae039 = $04a5ed8d1a69f13e$var$getAllKeys;

});
parcelRegister("hNlD0", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf47ca2fc3f4de6e$export$2e2bcd8739ae039);

var $6JPqi = parcelRequire("6JPqi");

var $hf0C9 = parcelRequire("hf0C9");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $cf47ca2fc3f4de6e$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $hf0C9.default)(object) ? result : (0, $6JPqi.default)(result, symbolsFunc(object));
}
var $cf47ca2fc3f4de6e$export$2e2bcd8739ae039 = $cf47ca2fc3f4de6e$var$baseGetAllKeys;

});


parcelRegister("7bulh", function(module, exports) {

$parcel$export(module.exports, "default", () => $53b118d05aedad9a$export$2e2bcd8739ae039);

var $hNlD0 = parcelRequire("hNlD0");

var $hDzVK = parcelRequire("hDzVK");

var $ceNjR = parcelRequire("ceNjR");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $53b118d05aedad9a$var$getAllKeysIn(object) {
    return (0, $hNlD0.default)(object, (0, $ceNjR.default), (0, $hDzVK.default));
}
var $53b118d05aedad9a$export$2e2bcd8739ae039 = $53b118d05aedad9a$var$getAllKeysIn;

});

parcelRegister("4wkSQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $34aa59a61c7ccccb$export$2e2bcd8739ae039);

var $dR5x6 = parcelRequire("dR5x6");

var $fs3H6 = parcelRequire("fs3H6");

var $ab1Hq = parcelRequire("ab1Hq");

var $iypSL = parcelRequire("iypSL");

var $1xFLT = parcelRequire("1xFLT");

var $hArsG = parcelRequire("hArsG");

var $5bfPQ = parcelRequire("5bfPQ");
/** `Object#toString` result references. */ var $34aa59a61c7ccccb$var$mapTag = "[object Map]", $34aa59a61c7ccccb$var$objectTag = "[object Object]", $34aa59a61c7ccccb$var$promiseTag = "[object Promise]", $34aa59a61c7ccccb$var$setTag = "[object Set]", $34aa59a61c7ccccb$var$weakMapTag = "[object WeakMap]";
var $34aa59a61c7ccccb$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $34aa59a61c7ccccb$var$dataViewCtorString = (0, $5bfPQ.default)((0, $dR5x6.default)), $34aa59a61c7ccccb$var$mapCtorString = (0, $5bfPQ.default)((0, $fs3H6.default)), $34aa59a61c7ccccb$var$promiseCtorString = (0, $5bfPQ.default)((0, $ab1Hq.default)), $34aa59a61c7ccccb$var$setCtorString = (0, $5bfPQ.default)((0, $iypSL.default)), $34aa59a61c7ccccb$var$weakMapCtorString = (0, $5bfPQ.default)((0, $1xFLT.default));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $34aa59a61c7ccccb$var$getTag = (0, $hArsG.default);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $dR5x6.default) && $34aa59a61c7ccccb$var$getTag(new (0, $dR5x6.default)(new ArrayBuffer(1))) != $34aa59a61c7ccccb$var$dataViewTag || (0, $fs3H6.default) && $34aa59a61c7ccccb$var$getTag(new (0, $fs3H6.default)) != $34aa59a61c7ccccb$var$mapTag || (0, $ab1Hq.default) && $34aa59a61c7ccccb$var$getTag((0, $ab1Hq.default).resolve()) != $34aa59a61c7ccccb$var$promiseTag || (0, $iypSL.default) && $34aa59a61c7ccccb$var$getTag(new (0, $iypSL.default)) != $34aa59a61c7ccccb$var$setTag || (0, $1xFLT.default) && $34aa59a61c7ccccb$var$getTag(new (0, $1xFLT.default)) != $34aa59a61c7ccccb$var$weakMapTag) $34aa59a61c7ccccb$var$getTag = function(value) {
    var result = (0, $hArsG.default)(value), Ctor = result == $34aa59a61c7ccccb$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $5bfPQ.default)(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $34aa59a61c7ccccb$var$dataViewCtorString:
            return $34aa59a61c7ccccb$var$dataViewTag;
        case $34aa59a61c7ccccb$var$mapCtorString:
            return $34aa59a61c7ccccb$var$mapTag;
        case $34aa59a61c7ccccb$var$promiseCtorString:
            return $34aa59a61c7ccccb$var$promiseTag;
        case $34aa59a61c7ccccb$var$setCtorString:
            return $34aa59a61c7ccccb$var$setTag;
        case $34aa59a61c7ccccb$var$weakMapCtorString:
            return $34aa59a61c7ccccb$var$weakMapTag;
    }
    return result;
};
var $34aa59a61c7ccccb$export$2e2bcd8739ae039 = $34aa59a61c7ccccb$var$getTag;

});
parcelRegister("dR5x6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1648453896f67d2$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");

var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $a1648453896f67d2$var$DataView = (0, $jLT9P.default)((0, $2mpFt.default), "DataView");
var $a1648453896f67d2$export$2e2bcd8739ae039 = $a1648453896f67d2$var$DataView;

});

parcelRegister("ab1Hq", function(module, exports) {

$parcel$export(module.exports, "default", () => $768c3ff3ee4df356$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");

var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $768c3ff3ee4df356$var$Promise = (0, $jLT9P.default)((0, $2mpFt.default), "Promise");
var $768c3ff3ee4df356$export$2e2bcd8739ae039 = $768c3ff3ee4df356$var$Promise;

});

parcelRegister("iypSL", function(module, exports) {

$parcel$export(module.exports, "default", () => $d81f7aa452e6e637$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");

var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $d81f7aa452e6e637$var$Set = (0, $jLT9P.default)((0, $2mpFt.default), "Set");
var $d81f7aa452e6e637$export$2e2bcd8739ae039 = $d81f7aa452e6e637$var$Set;

});

parcelRegister("1xFLT", function(module, exports) {

$parcel$export(module.exports, "default", () => $11f94673ff7d99d8$export$2e2bcd8739ae039);

var $jLT9P = parcelRequire("jLT9P");

var $2mpFt = parcelRequire("2mpFt");
/* Built-in method references that are verified to be native. */ var $11f94673ff7d99d8$var$WeakMap = (0, $jLT9P.default)((0, $2mpFt.default), "WeakMap");
var $11f94673ff7d99d8$export$2e2bcd8739ae039 = $11f94673ff7d99d8$var$WeakMap;

});


parcelRegister("9HyGp", function(module, exports) {

$parcel$export(module.exports, "default", () => $7103088c29fc4f0b$export$2e2bcd8739ae039);
/** Used for built-in method references. */ var $7103088c29fc4f0b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7103088c29fc4f0b$var$hasOwnProperty = $7103088c29fc4f0b$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $7103088c29fc4f0b$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == "string" && $7103088c29fc4f0b$var$hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
var $7103088c29fc4f0b$export$2e2bcd8739ae039 = $7103088c29fc4f0b$var$initCloneArray;

});

parcelRegister("iBTyS", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8c6c80dd3650253$export$2e2bcd8739ae039);

var $9tz5c = parcelRequire("9tz5c");

var $9sDYA = parcelRequire("9sDYA");

var $g8BP3 = parcelRequire("g8BP3");

var $lcI69 = parcelRequire("lcI69");

var $40E9j = parcelRequire("40E9j");
/** `Object#toString` result references. */ var $d8c6c80dd3650253$var$boolTag = "[object Boolean]", $d8c6c80dd3650253$var$dateTag = "[object Date]", $d8c6c80dd3650253$var$mapTag = "[object Map]", $d8c6c80dd3650253$var$numberTag = "[object Number]", $d8c6c80dd3650253$var$regexpTag = "[object RegExp]", $d8c6c80dd3650253$var$setTag = "[object Set]", $d8c6c80dd3650253$var$stringTag = "[object String]", $d8c6c80dd3650253$var$symbolTag = "[object Symbol]";
var $d8c6c80dd3650253$var$arrayBufferTag = "[object ArrayBuffer]", $d8c6c80dd3650253$var$dataViewTag = "[object DataView]", $d8c6c80dd3650253$var$float32Tag = "[object Float32Array]", $d8c6c80dd3650253$var$float64Tag = "[object Float64Array]", $d8c6c80dd3650253$var$int8Tag = "[object Int8Array]", $d8c6c80dd3650253$var$int16Tag = "[object Int16Array]", $d8c6c80dd3650253$var$int32Tag = "[object Int32Array]", $d8c6c80dd3650253$var$uint8Tag = "[object Uint8Array]", $d8c6c80dd3650253$var$uint8ClampedTag = "[object Uint8ClampedArray]", $d8c6c80dd3650253$var$uint16Tag = "[object Uint16Array]", $d8c6c80dd3650253$var$uint32Tag = "[object Uint32Array]";
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $d8c6c80dd3650253$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $d8c6c80dd3650253$var$arrayBufferTag:
            return (0, $9tz5c.default)(object);
        case $d8c6c80dd3650253$var$boolTag:
        case $d8c6c80dd3650253$var$dateTag:
            return new Ctor(+object);
        case $d8c6c80dd3650253$var$dataViewTag:
            return (0, $9sDYA.default)(object, isDeep);
        case $d8c6c80dd3650253$var$float32Tag:
        case $d8c6c80dd3650253$var$float64Tag:
        case $d8c6c80dd3650253$var$int8Tag:
        case $d8c6c80dd3650253$var$int16Tag:
        case $d8c6c80dd3650253$var$int32Tag:
        case $d8c6c80dd3650253$var$uint8Tag:
        case $d8c6c80dd3650253$var$uint8ClampedTag:
        case $d8c6c80dd3650253$var$uint16Tag:
        case $d8c6c80dd3650253$var$uint32Tag:
            return (0, $40E9j.default)(object, isDeep);
        case $d8c6c80dd3650253$var$mapTag:
            return new Ctor;
        case $d8c6c80dd3650253$var$numberTag:
        case $d8c6c80dd3650253$var$stringTag:
            return new Ctor(object);
        case $d8c6c80dd3650253$var$regexpTag:
            return (0, $g8BP3.default)(object);
        case $d8c6c80dd3650253$var$setTag:
            return new Ctor;
        case $d8c6c80dd3650253$var$symbolTag:
            return (0, $lcI69.default)(object);
    }
}
var $d8c6c80dd3650253$export$2e2bcd8739ae039 = $d8c6c80dd3650253$var$initCloneByTag;

});
parcelRegister("9tz5c", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e620930bc6a5ada$export$2e2bcd8739ae039);

var $dJVnF = parcelRequire("dJVnF");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $6e620930bc6a5ada$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $dJVnF.default)(result).set(new (0, $dJVnF.default)(arrayBuffer));
    return result;
}
var $6e620930bc6a5ada$export$2e2bcd8739ae039 = $6e620930bc6a5ada$var$cloneArrayBuffer;

});
parcelRegister("dJVnF", function(module, exports) {

$parcel$export(module.exports, "default", () => $a00bfcf041d47533$export$2e2bcd8739ae039);

var $2mpFt = parcelRequire("2mpFt");
/** Built-in value references. */ var $a00bfcf041d47533$var$Uint8Array = (0, $2mpFt.default).Uint8Array;
var $a00bfcf041d47533$export$2e2bcd8739ae039 = $a00bfcf041d47533$var$Uint8Array;

});


parcelRegister("9sDYA", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e35bd0ad6403ada$export$2e2bcd8739ae039);

var $9tz5c = parcelRequire("9tz5c");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $6e35bd0ad6403ada$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? (0, $9tz5c.default)(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
var $6e35bd0ad6403ada$export$2e2bcd8739ae039 = $6e35bd0ad6403ada$var$cloneDataView;

});

parcelRegister("g8BP3", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbfabb74c4bdb037$export$2e2bcd8739ae039);
/** Used to match `RegExp` flags from their coerced string values. */ var $bbfabb74c4bdb037$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $bbfabb74c4bdb037$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $bbfabb74c4bdb037$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
var $bbfabb74c4bdb037$export$2e2bcd8739ae039 = $bbfabb74c4bdb037$var$cloneRegExp;

});

parcelRegister("lcI69", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6fcecf8c6eee3b2$export$2e2bcd8739ae039);

var $kRxPv = parcelRequire("kRxPv");
/** Used to convert symbols to primitives and strings. */ var $f6fcecf8c6eee3b2$var$symbolProto = (0, $kRxPv.default) ? (0, $kRxPv.default).prototype : undefined, $f6fcecf8c6eee3b2$var$symbolValueOf = $f6fcecf8c6eee3b2$var$symbolProto ? $f6fcecf8c6eee3b2$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $f6fcecf8c6eee3b2$var$cloneSymbol(symbol) {
    return $f6fcecf8c6eee3b2$var$symbolValueOf ? Object($f6fcecf8c6eee3b2$var$symbolValueOf.call(symbol)) : {};
}
var $f6fcecf8c6eee3b2$export$2e2bcd8739ae039 = $f6fcecf8c6eee3b2$var$cloneSymbol;

});

parcelRegister("40E9j", function(module, exports) {

$parcel$export(module.exports, "default", () => $2eb64e5339c21018$export$2e2bcd8739ae039);

var $9tz5c = parcelRequire("9tz5c");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $2eb64e5339c21018$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $9tz5c.default)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $2eb64e5339c21018$export$2e2bcd8739ae039 = $2eb64e5339c21018$var$cloneTypedArray;

});


parcelRegister("7lgl7", function(module, exports) {

$parcel$export(module.exports, "default", () => $55872b451e11a8ad$export$2e2bcd8739ae039);

var $kgBRQ = parcelRequire("kgBRQ");

var $bzIQZ = parcelRequire("bzIQZ");

var $74QAJ = parcelRequire("74QAJ");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $55872b451e11a8ad$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !(0, $74QAJ.default)(object) ? (0, $kgBRQ.default)((0, $bzIQZ.default)(object)) : {};
}
var $55872b451e11a8ad$export$2e2bcd8739ae039 = $55872b451e11a8ad$var$initCloneObject;

});
parcelRegister("kgBRQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec12acf7896f0d70$export$2e2bcd8739ae039);

var $iYDsF = parcelRequire("iYDsF");
/** Built-in value references. */ var $ec12acf7896f0d70$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $ec12acf7896f0d70$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $iYDsF.default)(proto)) return {};
        if ($ec12acf7896f0d70$var$objectCreate) return $ec12acf7896f0d70$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $ec12acf7896f0d70$export$2e2bcd8739ae039 = $ec12acf7896f0d70$var$baseCreate;

});


parcelRegister("5HFwJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $42712e4fe0b60e59$export$2e2bcd8739ae039);

var $dp7sl = parcelRequire("dp7sl");

var $hb0cD = parcelRequire("hb0cD");

var $lFXqE = parcelRequire("lFXqE");
/* Node.js helper references. */ var $42712e4fe0b60e59$var$nodeIsMap = (0, $lFXqE.default) && (0, $lFXqE.default).isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $42712e4fe0b60e59$var$isMap = $42712e4fe0b60e59$var$nodeIsMap ? (0, $hb0cD.default)($42712e4fe0b60e59$var$nodeIsMap) : (0, $dp7sl.default);
var $42712e4fe0b60e59$export$2e2bcd8739ae039 = $42712e4fe0b60e59$var$isMap;

});
parcelRegister("dp7sl", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c2364d1ace94eb9$export$2e2bcd8739ae039);

var $4wkSQ = parcelRequire("4wkSQ");

var $f2iog = parcelRequire("f2iog");
/** `Object#toString` result references. */ var $9c2364d1ace94eb9$var$mapTag = "[object Map]";
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $9c2364d1ace94eb9$var$baseIsMap(value) {
    return (0, $f2iog.default)(value) && (0, $4wkSQ.default)(value) == $9c2364d1ace94eb9$var$mapTag;
}
var $9c2364d1ace94eb9$export$2e2bcd8739ae039 = $9c2364d1ace94eb9$var$baseIsMap;

});


parcelRegister("4X3Cn", function(module, exports) {

$parcel$export(module.exports, "default", () => $39af7a8fe30b5013$export$2e2bcd8739ae039);

var $4Mn6B = parcelRequire("4Mn6B");

var $hb0cD = parcelRequire("hb0cD");

var $lFXqE = parcelRequire("lFXqE");
/* Node.js helper references. */ var $39af7a8fe30b5013$var$nodeIsSet = (0, $lFXqE.default) && (0, $lFXqE.default).isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $39af7a8fe30b5013$var$isSet = $39af7a8fe30b5013$var$nodeIsSet ? (0, $hb0cD.default)($39af7a8fe30b5013$var$nodeIsSet) : (0, $4Mn6B.default);
var $39af7a8fe30b5013$export$2e2bcd8739ae039 = $39af7a8fe30b5013$var$isSet;

});
parcelRegister("4Mn6B", function(module, exports) {

$parcel$export(module.exports, "default", () => $37ad91635d9ff11e$export$2e2bcd8739ae039);

var $4wkSQ = parcelRequire("4wkSQ");

var $f2iog = parcelRequire("f2iog");
/** `Object#toString` result references. */ var $37ad91635d9ff11e$var$setTag = "[object Set]";
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $37ad91635d9ff11e$var$baseIsSet(value) {
    return (0, $f2iog.default)(value) && (0, $4wkSQ.default)(value) == $37ad91635d9ff11e$var$setTag;
}
var $37ad91635d9ff11e$export$2e2bcd8739ae039 = $37ad91635d9ff11e$var$baseIsSet;

});




parcelRegister("7AubO", function(module, exports) {

$parcel$export(module.exports, "ID_SITE", () => $586350328a975c03$export$114d27720a305bf7);
$parcel$export(module.exports, "SERVICE_GATEWAY", () => $586350328a975c03$export$4894fb60a79adf3b);
$parcel$export(module.exports, "BROKER_METRICS_API", () => $586350328a975c03$export$54784a9a461f3308);
$parcel$export(module.exports, "LWA_PLATFORM", () => $586350328a975c03$export$b334fa43b3dd432f);
$parcel$export(module.exports, "PROFILE_SERVICE", () => $586350328a975c03$export$c5dae97172a81099);
$parcel$export(module.exports, "PLATFORM_DOMAIN", () => $586350328a975c03$export$dbef25db5def4c9c);
$parcel$export(module.exports, "TALENT", () => $586350328a975c03$export$b843438ab762070);
$parcel$export(module.exports, "LOCAL_LAUNCH", () => $586350328a975c03$export$d77fc45c5daa6934);
$parcel$export(module.exports, "PLATFORM_LOCAL_LAUNCH", () => $586350328a975c03$export$6fc2e40a58314151);
$parcel$export(module.exports, "isLocal", () => $586350328a975c03$export$6dd1bbd39f571125);
$parcel$export(module.exports, "isDev", () => $586350328a975c03$export$40edfb7eeb78c4e8);
$parcel$export(module.exports, "runningEnv", () => $586350328a975c03$export$5547f49850b39c72);
$parcel$export(module.exports, "getEndpoint", () => $586350328a975c03$export$544dab20dbe3f2e7);

var $c7dF9 = parcelRequire("c7dF9");

var $cstaF = parcelRequire("cstaF");
const $586350328a975c03$var$hostname = window.location.host;
const $586350328a975c03$var$protocol = window.location.protocol;
const $586350328a975c03$export$2c4e825dc9120f87 = "api";
const $586350328a975c03$export$114d27720a305bf7 = "idSite";
const $586350328a975c03$export$5fee888a4dd6aa30 = "pix";
const $586350328a975c03$export$8609bfbcd3ddb39f = "searchServer";
const $586350328a975c03$export$78a94b7660ec0e3b = "auth";
const $586350328a975c03$export$4894fb60a79adf3b = "serviceGateway";
const $586350328a975c03$export$54784a9a461f3308 = "brokerMetricsApi";
const $586350328a975c03$export$b334fa43b3dd432f = "lwaPlatform";
const $586350328a975c03$export$c5dae97172a81099 = "profileService";
const $586350328a975c03$export$dbef25db5def4c9c = "platformDomain";
const $586350328a975c03$export$b843438ab762070 = "talent";
const $586350328a975c03$export$d77fc45c5daa6934 = "localLaunch";
const $586350328a975c03$export$6fc2e40a58314151 = "platformLocalLaunch";
const $586350328a975c03$export$92d6f8cd12988725 = `${$586350328a975c03$var$protocol}//${$586350328a975c03$var$hostname}${(0, $c7dF9.Routes).AUTH.BASE}`;
const $586350328a975c03$export$6dd1bbd39f571125 = $586350328a975c03$var$hostname.toLowerCase().indexOf("localhost") > -1 || $586350328a975c03$var$hostname.toLowerCase().indexOf("local") > -1;
const $586350328a975c03$export$40edfb7eeb78c4e8 = $586350328a975c03$var$hostname.toLowerCase().indexOf("dev") >= 0;
const $586350328a975c03$export$23da1d24a38b0bde = $586350328a975c03$var$hostname.toLowerCase().indexOf("stg") >= 0;
const $586350328a975c03$export$dca2de5cf95d907f = $586350328a975c03$var$hostname.toLowerCase().indexOf("pre") >= 0;
const $586350328a975c03$export$1cfdf9a01e3f7773 = !$586350328a975c03$export$40edfb7eeb78c4e8 && !$586350328a975c03$export$23da1d24a38b0bde && !$586350328a975c03$export$dca2de5cf95d907f && !$586350328a975c03$export$6dd1bbd39f571125;
const $586350328a975c03$export$859985dfc739b63c = {
    DEV: "DEV",
    STG: "STG",
    PRE: "PRE",
    PROD: "PROD"
};
const $586350328a975c03$var$getRunningEnv = ()=>{
    const envs = [
        {
            check: $586350328a975c03$export$40edfb7eeb78c4e8,
            name: $586350328a975c03$export$859985dfc739b63c.DEV
        },
        {
            check: $586350328a975c03$export$23da1d24a38b0bde,
            name: $586350328a975c03$export$859985dfc739b63c.STG
        },
        {
            check: $586350328a975c03$export$dca2de5cf95d907f,
            name: $586350328a975c03$export$859985dfc739b63c.PRE
        },
        {
            check: $586350328a975c03$export$1cfdf9a01e3f7773,
            name: $586350328a975c03$export$859985dfc739b63c.PROD
        }
    ];
    const env = envs.find((env)=>env.check);
    if (!env) {
        console.error((0, $cstaF.validationMessages).notValidEnvForHost);
        return;
    }
    return env.name;
};
const $586350328a975c03$export$5547f49850b39c72 = $586350328a975c03$var$getRunningEnv();
const $586350328a975c03$var$buildHost = (service, env, domain)=>`https://${service}${env}${domain}`;
const $586350328a975c03$var$serviceHosts = {
    ID_SITE: (env)=>$586350328a975c03$var$buildHost("xbm-id", env, "terradatum.com"),
    SERVICE_GATEWAY: (env)=>$586350328a975c03$var$buildHost("service-gateway", env, "terradatum.com"),
    BROKER_METRICS_API: (env)=>$586350328a975c03$var$buildHost("brokermetrics.api", env, "lwolf.com"),
    LWA_PLATFORM: (env)=>$586350328a975c03$var$buildHost("platform", env, "lwolf.com"),
    PROFILE_SERVICE: (env)=>$586350328a975c03$var$buildHost("profile-service", env, "terradatum.com"),
    PLATFORM_DOMAIN: (env)=>`${env}lwolf.com`,
    TALENT: (env)=>$586350328a975c03$var$buildHost("talent", env, "lwolf.com")
};
const $586350328a975c03$var$commonEndpoints = {
    [$586350328a975c03$export$2c4e825dc9120f87]: `${location.protocol}//api.${location.host.substring(location.host.indexOf(".") + 1)}`,
    [$586350328a975c03$export$5fee888a4dd6aa30]: `${location.protocol}//td-images-admin.${location.host.substring(location.host.indexOf(".") + 1)}`,
    [$586350328a975c03$export$8609bfbcd3ddb39f]: `${location.protocol}//aergo-search-server.${location.host.substring(location.host.indexOf(".") + 1)}`,
    [$586350328a975c03$export$78a94b7660ec0e3b]: `${location.protocol}//td-auth.${location.host.substring(location.host.indexOf(".") + 1)}`
};
const $586350328a975c03$var$generateEndpoints = (env, platformEnv = env)=>{
    const validEnvs = [
        "dev.",
        "stage.",
        "stg.",
        "pre.",
        ""
    ];
    const isValidEnv = validEnvs.includes(env);
    const isValidPlatformEnv = validEnvs.includes(platformEnv);
    if (!isValidEnv || !isValidPlatformEnv) throw new Error((0, $cstaF.validationMessages).validEnvs);
    return {
        ...$586350328a975c03$var$commonEndpoints,
        [$586350328a975c03$export$114d27720a305bf7]: $586350328a975c03$var$serviceHosts.ID_SITE(`${!$586350328a975c03$export$1cfdf9a01e3f7773 ? `.${env}` : "."}`),
        [$586350328a975c03$export$4894fb60a79adf3b]: $586350328a975c03$var$serviceHosts.SERVICE_GATEWAY(`${!$586350328a975c03$export$1cfdf9a01e3f7773 ? `.${env}` : "."}`),
        [$586350328a975c03$export$54784a9a461f3308]: $586350328a975c03$var$serviceHosts.BROKER_METRICS_API(`${!$586350328a975c03$export$1cfdf9a01e3f7773 ? `.${platformEnv}` : "."}`),
        [$586350328a975c03$export$b334fa43b3dd432f]: $586350328a975c03$var$serviceHosts.LWA_PLATFORM(`${!$586350328a975c03$export$1cfdf9a01e3f7773 ? `.${platformEnv}` : "."}`),
        [$586350328a975c03$export$c5dae97172a81099]: $586350328a975c03$var$serviceHosts.PROFILE_SERVICE(`${!$586350328a975c03$export$1cfdf9a01e3f7773 ? `.${env}` : "."}`),
        [$586350328a975c03$export$dbef25db5def4c9c]: $586350328a975c03$var$serviceHosts.PLATFORM_DOMAIN(`${!$586350328a975c03$export$1cfdf9a01e3f7773 ? `${platformEnv}` : ""}`),
        [$586350328a975c03$export$b843438ab762070]: $586350328a975c03$var$serviceHosts.TALENT(`${!$586350328a975c03$export$1cfdf9a01e3f7773 ? `.${platformEnv}` : "."}`),
        [$586350328a975c03$export$d77fc45c5daa6934]: $586350328a975c03$export$6dd1bbd39f571125 ? `&lu=${$586350328a975c03$export$92d6f8cd12988725}` : "",
        [$586350328a975c03$export$6fc2e40a58314151]: ""
    };
};
const $586350328a975c03$var$endpointsByEnv = Object.freeze({
    [$586350328a975c03$export$859985dfc739b63c.DEV]: $586350328a975c03$var$generateEndpoints("dev."),
    [$586350328a975c03$export$859985dfc739b63c.STG]: $586350328a975c03$var$generateEndpoints("stage.", "stg."),
    [$586350328a975c03$export$859985dfc739b63c.PRE]: $586350328a975c03$var$generateEndpoints("pre."),
    [$586350328a975c03$export$859985dfc739b63c.PROD]: $586350328a975c03$var$generateEndpoints("")
});
const $586350328a975c03$export$544dab20dbe3f2e7 = (name)=>$586350328a975c03$var$endpointsByEnv[$586350328a975c03$export$5547f49850b39c72]?.[name];

});
parcelRegister("c7dF9", function(module, exports) {

$parcel$export(module.exports, "Routes", () => $8d20bc9dd505c92c$export$3565eb3d00ca5a74);
$parcel$export(module.exports, "getPinnedRowRouteSettings", () => $8d20bc9dd505c92c$export$4cf1abda78a6f2b2);
$parcel$export(module.exports, "nonModuleRoutes", () => $8d20bc9dd505c92c$export$e178032c58ccda0d);
const $8d20bc9dd505c92c$export$3565eb3d00ca5a74 = Object.freeze({
    PROF_METRICS: {
        AGENTS: "/agent-name",
        AGENT_PROFILE: "/agent-detail",
        BASE: "/proficiency-metrics",
        COVERAGE_LISTING: "/agent-coverage-listing",
        LISTING_INFO: "/listing-info",
        OFFICE_NAME: "/office-name",
        PROD_LISTING: "/agent-production-listing",
        SAVED_AGENTS: "/saved-agents",
        SUGGESTED_AGENTS: "/suggested-agents",
        TRANSACTIONS: "/transactions",
        AGENT_MOVEMENT: "/agent-movement",
        AGENT_BREAKDOWN: "/agent-breakdown",
        AGENTS_GAINED: "/agent-breakdown",
        AGENTS_LOST: "/agent-lost",
        OFFICE_DETAILS: "/office-detail",
        OFFICE_LIST_BREAKDOWN: "/office-list-breakdown",
        ACTIVITY: "/activity",
        SETTINGS: "/settings"
    },
    MARKET_DYNAMICS: {
        BASE: "/market-dynamics",
        OFFICES_BREAKDOWN: "/office-breakdown",
        LISTINGS_BREAKDOWN: "/listings-breakdown",
        LISTING_INFO: "/listing-info",
        OFFICE_LISTING: "/office-listing"
    },
    MARKET_SHARE: {
        BASE: "/market-share",
        COVERAGE: "/coverage",
        LISTING_INFO: "/listing-info",
        OFFICES_BREAKDOWN: "/office-breakdown",
        OFFICE_LISTING: "/office-listing",
        TOTALS: "/totals"
    },
    MY_PROFILE: {
        BASE: "/my-profile",
        NOTIFICATIONS: "/notifications"
    },
    VALIDATION: {
        BASE: "/validation"
    },
    AUTH: {
        BASE: "/auth",
        LOG_IN: "/login",
        LOG_OUT: "/logout",
        CONNECT: "/connect",
        VERIFICATION_ERROR: "/verification-error"
    },
    HOME: {
        BASE: "/",
        DASHBOARD: "/dashboard"
    },
    AGENT_PRODUCTION: {
        BASE: "/agent-production"
    }
});
const $8d20bc9dd505c92c$export$4cf1abda78a6f2b2 = (route)=>{
    return route.includes($8d20bc9dd505c92c$export$3565eb3d00ca5a74.MARKET_SHARE.OFFICES_BREAKDOWN) ? "breakdown" : "total";
};
const $8d20bc9dd505c92c$export$e178032c58ccda0d = [
    $8d20bc9dd505c92c$export$3565eb3d00ca5a74.MY_PROFILE.BASE
];

});

parcelRegister("cstaF", function(module, exports) {

$parcel$export(module.exports, "searchTerms", () => $911eba4d16ebb469$export$c33fc47cb8e932e);
$parcel$export(module.exports, "searchTypeNames", () => $911eba4d16ebb469$export$26cf7f55410901fb);
$parcel$export(module.exports, "searchRoutes", () => $911eba4d16ebb469$export$a89ca33323f6f239);
$parcel$export(module.exports, "searchTypes", () => $911eba4d16ebb469$export$a9dcd9c91ec8ed8e);
$parcel$export(module.exports, "marketDynamicsTerms", () => $911eba4d16ebb469$export$d3c07f097457da9b);
$parcel$export(module.exports, "marketShareTerms", () => $911eba4d16ebb469$export$34912999f6279d4f);
$parcel$export(module.exports, "buttonTerms", () => $911eba4d16ebb469$export$c7d22d57aae71781);
$parcel$export(module.exports, "emails", () => $911eba4d16ebb469$export$3e4ea77b8bea417);
$parcel$export(module.exports, "validationMessages", () => $911eba4d16ebb469$export$2497dec627a30444);
$parcel$export(module.exports, "agentProductionTemplates", () => $911eba4d16ebb469$export$9a1d9eb0857440d3);
$parcel$export(module.exports, "listingStatus", () => $911eba4d16ebb469$export$9785edcc3744ff22);
$parcel$export(module.exports, "marketShareListingStatuses", () => $911eba4d16ebb469$export$4585e058e79220a9);
$parcel$export(module.exports, "marketShareListingStatusesCoverage", () => $911eba4d16ebb469$export$93453266d7d33157);
$parcel$export(module.exports, "agentProductionTerms", () => $911eba4d16ebb469$export$6b970ea150c039a6);
$parcel$export(module.exports, "modalTerms", () => $911eba4d16ebb469$export$51203442c7ccdfd9);
$parcel$export(module.exports, "SEARCH_VALUE_MAX_LENGTH", () => $911eba4d16ebb469$export$2cb63e8002c36ae6);
$parcel$export(module.exports, "agentFilter", () => $911eba4d16ebb469$export$6d4d60d3548ad3e2);
$parcel$export(module.exports, "ownerTypes", () => $911eba4d16ebb469$export$1b24ab711461207c);
$parcel$export(module.exports, "status", () => $911eba4d16ebb469$export$471f7ae5c4103ae1);
$parcel$export(module.exports, "statusMap", () => $911eba4d16ebb469$export$995d7ae0c0293bac);
$parcel$export(module.exports, "moduleNames", () => $911eba4d16ebb469$export$3830a599b40dbdfb);
$parcel$export(module.exports, "normalizedModuleNames", () => $911eba4d16ebb469$export$6187295c74fedf54);
$parcel$export(module.exports, "modules", () => $911eba4d16ebb469$export$cc2c248003684daa);
$parcel$export(module.exports, "defaultModules", () => $911eba4d16ebb469$export$c56e4a7b2e4d99a5);
$parcel$export(module.exports, "moduleRoutes", () => $911eba4d16ebb469$export$10a5f1252070f649);
$parcel$export(module.exports, "modulesByRouteAndNameAssociation", () => $911eba4d16ebb469$export$4302d2db97b000f5);
$parcel$export(module.exports, "drillDownRoutesByModule", () => $911eba4d16ebb469$export$898eed799e4bc165);
$parcel$export(module.exports, "toastMessages", () => $911eba4d16ebb469$export$40fb018dd4c59f8);
$parcel$export(module.exports, "agentFullName", () => $911eba4d16ebb469$export$5be02e19f9b79aec);
$parcel$export(module.exports, "TimePeriods", () => $911eba4d16ebb469$export$f372b14c42f90b79);
$parcel$export(module.exports, "marketDynamicsTimePeriods", () => $911eba4d16ebb469$export$ec3b1cfeb6b98ccc);
$parcel$export(module.exports, "searchStatuses", () => $911eba4d16ebb469$export$1566a4beeb3a5923);
$parcel$export(module.exports, "areaSearchTypes", () => $911eba4d16ebb469$export$3d14ea391decd4);
$parcel$export(module.exports, "lotSizeTypes", () => $911eba4d16ebb469$export$d122ad926d806868);
$parcel$export(module.exports, "areaRequestTypes", () => $911eba4d16ebb469$export$a21e10b0ff0fad26);
$parcel$export(module.exports, "modalTitles", () => $911eba4d16ebb469$export$d2aa288f27b9fa4a);
$parcel$export(module.exports, "loginTerms", () => $911eba4d16ebb469$export$1eafd33d9d555e0f);
$parcel$export(module.exports, "navTerms", () => $911eba4d16ebb469$export$8c1ffc600110d529);
$parcel$export(module.exports, "ACCOUNTS", () => $911eba4d16ebb469$export$4e2b959b815d8fe5);
$parcel$export(module.exports, "MLS_SID", () => $911eba4d16ebb469$export$362c30ac9d93aa05);
$parcel$export(module.exports, "MLS_PROPERTY_TYPE_CLASS_ID", () => $911eba4d16ebb469$export$c060504f7c3e8958);
$parcel$export(module.exports, "USER_ACTIVITY_TYPES", () => $911eba4d16ebb469$export$cc08d92e623d1bf1);
$parcel$export(module.exports, "sortingTerms", () => $911eba4d16ebb469$export$ddfd6edecdaaab7c);
$parcel$export(module.exports, "comparisonSetsModals", () => $911eba4d16ebb469$export$1c55f4e019ddfc47);
$parcel$export(module.exports, "pdfDisclaimer", () => $911eba4d16ebb469$export$7aa1b4ae03ddc9f4);
$parcel$export(module.exports, "trademark", () => $911eba4d16ebb469$export$a7f6cddfcb97ef08);
$parcel$export(module.exports, "downloadFileTypes", () => $911eba4d16ebb469$export$ca0b6bfb83bbd659);
$parcel$export(module.exports, "downloadModalTerms", () => $911eba4d16ebb469$export$6b42a5293495f5f6);
$parcel$export(module.exports, "mimeTypes", () => $911eba4d16ebb469$export$53cb456310d1907e);
$parcel$export(module.exports, "constructionTypeMap", () => $911eba4d16ebb469$export$76640677f56900c8);
$parcel$export(module.exports, "ISO_MIDNIGHT", () => $911eba4d16ebb469$export$124931c5cc419985);
$parcel$export(module.exports, "INTERNAL_EMAIL_DOMAIN", () => $911eba4d16ebb469$export$b76a977f306ef683);
$parcel$export(module.exports, "tabNameMap", () => $911eba4d16ebb469$export$c2cfcee2a1489f30);
$parcel$export(module.exports, "initialOptionalFilterTitles", () => $911eba4d16ebb469$export$2b2c8a045fa23000);

var $1ujWz = parcelRequire("1ujWz");

var $c7dF9 = parcelRequire("c7dF9");

var $6M53k = parcelRequire("6M53k");
const $911eba4d16ebb469$export$c33fc47cb8e932e = Object.freeze({
    all: "All",
    allResidential: "All Residential",
    mls: "MLS",
    mlsProvider: "MLS Provider",
    propertyType: "Property Type",
    propertyTypes: "Property Type(s)",
    propertyTypesSA: "Property Types",
    marketArea: "Market Area",
    areaTypePopover: "Display Coverage By:",
    areaType: "Area Type",
    selectedAreaTypeTitle: "Area Type: ",
    timeFrame: "Time Period",
    listingStatus: "Status",
    totalVolume: "$ Volume",
    savedSearches: "Saved Searches",
    soldPriceRange: "Sold Price Range",
    soldPrice: "Sold Price",
    priceRange: "Price Range",
    totalUnits: "# Units",
    fullBathrooms: "# Bathrooms",
    bedrooms: "# Bedrooms",
    required: "Required",
    optional: "Optional",
    saveSearchHeader: "Save Search",
    saveMarketAreaHeader: "New Market Area List",
    overwriteMarketAreaHeader: "Overwrite Market Area List",
    overwriteOfficeListHeader: "Overwrite Office List",
    overwriteSearchHeader: "Overwrite Search",
    nameYourSearch: "Name your custom search",
    nameYourList: "List Name",
    describeYourSearch: "Description",
    searchNamePlaceholder: "Enter a name for your search",
    searchNotesPlaceholder: "Enter a description about your search",
    searchName: "Search Name",
    searchDescription: "Description",
    confirmDelete: "Are you sure you want to delete this saved search permanently?",
    savedSearchFilter: "savedSearches",
    mlsFilter: "mls",
    propTypeFilter: "propertyType",
    timeFrameFilter: "timeFrame",
    marketAreaFilter: "marketArea",
    areaTypeFilter: "areaType",
    totalVolumeFilter: "totalVolume",
    soldPriceFilter: "soldPriceRange",
    priceRangeFilter: "priceRange",
    totalUnitsFilter: "totalUnits",
    fullBathroomsFilter: "fullBathrooms",
    bedroomsFilter: "bedrooms",
    squareFootageFilter: "squareFootage",
    squareFeetFilter: "squareFeet",
    lotSizeFilter: "lotSize",
    lotSizeAcresFilter: "lotSizeAcres",
    lotSquareFeetFilter: "lotSquareFeet",
    listingStatusFilter: "listingStatus",
    comparisonSetFilter: "comparisonSet",
    constructionTypeFilter: "constructionType",
    constructionType: "Construction Type",
    comparisonSet: "Comparison Set",
    getNotCreatedMessage: (type)=>`You have not created ${type === $911eba4d16ebb469$export$c33fc47cb8e932e.comparisonSet ? `a ${type}` : `an ${type}`} in this MLS.`,
    getCreateMessage: (type)=>`Please create ${type === $911eba4d16ebb469$export$c33fc47cb8e932e.comparisonSet ? `a ${type}` : `an ${type}`} to continue.`,
    createComparisonSets: "Create Comparison Set",
    createOfficeGroups: "Create Office Group",
    officesFilter: "offices",
    officeIdType: "officeId",
    agentsFilter: "agents",
    agentIdType: "agentId",
    transactionStatus: "transactionStatus",
    marketAreaFilterPlaceholder: "Search Lists",
    manageListsLinkText: "Manage Lists",
    dependentSavedSearches: "Dependent Saved Searches",
    transactionsIn: "Transactions In",
    transactions: "Transactions",
    searchBy: "Search By",
    newSearch: "New Search",
    editList: "Edit List",
    totals: "Totals",
    coverage: "Coverage",
    offices: "Offices",
    officeName: "Office Name",
    officeId: "Office Id",
    agents: "Agents",
    agentName: "Agent Name",
    savedAgentList: "Saved Agent List",
    myMarketLists: "My Market Lists",
    areaOptions: "Area Options",
    allMls: "ALL MLS",
    lowerAllMls: "All MLS",
    noneAdded: "None Added",
    none: "None",
    selectItemsFromLeft: (itemType)=>`Select ${itemType} from the list on the left to include them in your search.`,
    selectType: (type)=>`- Select ${type} - `,
    noOfficesAvailable: "The are no offices available at this time.",
    newOfficeList: "New Office List",
    newAgentList: "New Agent List",
    listName: "List Name",
    saveList: "Save List",
    saveAsList: "Save as List",
    userListGroup: "YOUR OFFICE LISTS",
    officeNotFound: "***Not Found***",
    inactiveOffice: "***Inactive***",
    savedOfficeList: "Saved Office List",
    searchMarketAreaLists: "Search Market Area Types/Lists",
    myOfficeLists: "My Office Lists",
    myAgentLists: "My Agent Lists",
    soldBothSides: "Total Sold List + Sell",
    soldListSide: "Sold List Side",
    soldSellSide: "Sold Sell Side",
    forSale: "For Sale",
    officeDetails: "Office Details",
    inactiveAgent: "***Inactive***",
    agentNotFound: "***Not Found***",
    mlsNotSupportMeasureType: (measureType)=>`${measureType} is not supported By MLS`,
    soldPriceChip: "SoldPrice",
    lastPriceChip: "LastPrice",
    searchOffice: "Search Office",
    searchActivity: "Search Activity",
    searchId: "Search ID",
    noMin: "No min",
    noMax: "No max",
    clearLotSize: "Clear Lot Size",
    clearBedrooms: "Clear Bedrooms",
    clearBathrooms: "Clear Bathrooms",
    clearAllSearchTitle: "Clear All Search Criteria",
    clearAllSearchMessage: "Are you sure you want to clear all search criteria? Doing so will require you to rebuild your search.",
    clearComparisonSets: "Clear Comparison Sets",
    clearConstructionType: "Clear Construction Type",
    lotSize: "Lot Size",
    squareFeet: "Square Feet",
    acres: "Acres",
    squareFootage: "Square Footage",
    unsaved: "Unsaved",
    noSearchesFound: "No searches found.",
    savedItemsFilterPlaceholder: "Search saved search name",
    searchAddress: "Search Address",
    noSavedAgentsLists: "You don\u2019t have any Saved Agents.",
    additionalInfo: "Additional Information",
    searchForItem: (item)=>`Search for your ${item}`,
    new: "New",
    resale: "Resale",
    newConstruction: "newConstruction",
    myOffices: "My Offices",
    increasePct: "Increase %",
    decreasePct: "Decrease %",
    agentMovement: "Agent Movement",
    officeList: "Office List"
});
const $911eba4d16ebb469$export$26cf7f55410901fb = {
    transactions: "transactions",
    offices: "offices",
    agents: "agents",
    totals: "totals",
    coverage: "coverage",
    marketDynamics: "dynamics",
    movement: "movement"
};
const $911eba4d16ebb469$export$a89ca33323f6f239 = Object.freeze({
    transactions: (0, $c7dF9.Routes).PROF_METRICS.BASE + (0, $c7dF9.Routes).PROF_METRICS.TRANSACTIONS,
    officeName: (0, $c7dF9.Routes).PROF_METRICS.BASE + (0, $c7dF9.Routes).PROF_METRICS.OFFICE_NAME,
    agentName: (0, $c7dF9.Routes).PROF_METRICS.BASE + (0, $c7dF9.Routes).PROF_METRICS.AGENTS,
    savedAgents: (0, $c7dF9.Routes).PROF_METRICS.BASE + (0, $c7dF9.Routes).PROF_METRICS.SAVED_AGENTS,
    suggestedAgents: (0, $c7dF9.Routes).PROF_METRICS.BASE + (0, $c7dF9.Routes).PROF_METRICS.SUGGESTED_AGENTS,
    totals: (0, $c7dF9.Routes).MARKET_SHARE.BASE + (0, $c7dF9.Routes).MARKET_SHARE.TOTALS,
    coverage: (0, $c7dF9.Routes).MARKET_SHARE.BASE + (0, $c7dF9.Routes).MARKET_SHARE.COVERAGE,
    officeBreakdown: (0, $c7dF9.Routes).MARKET_SHARE.BASE + (0, $c7dF9.Routes).MARKET_SHARE.TOTALS + (0, $c7dF9.Routes).MARKET_SHARE.OFFICES_BREAKDOWN,
    marketDynamicsOfficeBreakdown: (0, $c7dF9.Routes).MARKET_DYNAMICS.BASE + (0, $c7dF9.Routes).MARKET_DYNAMICS.OFFICES_BREAKDOWN,
    agentMovement: (0, $c7dF9.Routes).PROF_METRICS.BASE + (0, $c7dF9.Routes).PROF_METRICS.AGENT_MOVEMENT,
    agentsGainedBreakdown: (0, $c7dF9.Routes).PROF_METRICS.BASE + (0, $c7dF9.Routes).PROF_METRICS.AGENT_MOVEMENT + (0, $c7dF9.Routes).PROF_METRICS.AGENTS_GAINED,
    agentsLostBreakdown: (0, $c7dF9.Routes).PROF_METRICS.BASE + (0, $c7dF9.Routes).PROF_METRICS.AGENT_MOVEMENT + (0, $c7dF9.Routes).PROF_METRICS.AGENTS_LOST,
    officeDetails: (0, $c7dF9.Routes).PROF_METRICS.BASE + (0, $c7dF9.Routes).PROF_METRICS.AGENT_MOVEMENT + (0, $c7dF9.Routes).PROF_METRICS.OFFICE_DETAILS,
    agentBreakdown: (0, $c7dF9.Routes).PROF_METRICS.BASE + (0, $c7dF9.Routes).PROF_METRICS.AGENT_MOVEMENT + (0, $c7dF9.Routes).PROF_METRICS.AGENT_BREAKDOWN,
    officeListBreakdown: (0, $c7dF9.Routes).PROF_METRICS.BASE + (0, $c7dF9.Routes).PROF_METRICS.AGENT_MOVEMENT + (0, $c7dF9.Routes).PROF_METRICS.OFFICE_LIST_BREAKDOWN,
    agentDetail: (0, $c7dF9.Routes).PROF_METRICS.BASE + (0, $c7dF9.Routes).PROF_METRICS.AGENT_PROFILE,
    agentProduction: (0, $c7dF9.Routes).AGENT_PRODUCTION.BASE,
    savedAgentsActivity: (0, $c7dF9.Routes).PROF_METRICS.BASE + (0, $c7dF9.Routes).PROF_METRICS.SAVED_AGENTS + (0, $c7dF9.Routes).PROF_METRICS.ACTIVITY
});
const $911eba4d16ebb469$export$a9dcd9c91ec8ed8e = {
    [$911eba4d16ebb469$export$a89ca33323f6f239.transactions]: {
        type: $911eba4d16ebb469$export$26cf7f55410901fb.transactions,
        title: "Transactions"
    },
    [$911eba4d16ebb469$export$a89ca33323f6f239.officeName]: {
        type: $911eba4d16ebb469$export$26cf7f55410901fb.offices,
        title: "Office Name"
    },
    [$911eba4d16ebb469$export$a89ca33323f6f239.agentName]: {
        type: $911eba4d16ebb469$export$26cf7f55410901fb.agents,
        title: "Agent Name"
    },
    [$911eba4d16ebb469$export$a89ca33323f6f239.savedAgents]: {
        type: $911eba4d16ebb469$export$26cf7f55410901fb.agents,
        title: "Saved Agents"
    },
    [$911eba4d16ebb469$export$a89ca33323f6f239.suggestedAgents]: {
        type: $911eba4d16ebb469$export$26cf7f55410901fb.agents,
        title: "Suggested Agents"
    },
    [$911eba4d16ebb469$export$a89ca33323f6f239.totals]: {
        type: $911eba4d16ebb469$export$26cf7f55410901fb.totals,
        title: "Totals"
    },
    [$911eba4d16ebb469$export$a89ca33323f6f239.coverage]: {
        type: $911eba4d16ebb469$export$26cf7f55410901fb.coverage,
        title: "Coverage"
    },
    [(0, $c7dF9.Routes).MARKET_DYNAMICS.BASE]: {
        type: $911eba4d16ebb469$export$26cf7f55410901fb.marketDynamics,
        title: "Market Dynamics"
    },
    [$911eba4d16ebb469$export$a89ca33323f6f239.agentMovement]: {
        type: $911eba4d16ebb469$export$26cf7f55410901fb.movement,
        title: "Agent Movement"
    }
};
const $911eba4d16ebb469$export$d3c07f097457da9b = Object.freeze({
    marketDynamics: "Market Dynamics",
    marketDynamicsChart: "Market Dynamics Chart",
    marketDynamicsDashboard: "Market Dynamics Dashboard",
    searchFilterAdjust: "Please adjust your search filters to find the market information you're looking for",
    newSearch: "New Search",
    years3Quarterly: "3 Years (Quarterly)",
    years2Monthly: "2 Years (Monthly)",
    years1Monthly: "1 Year (Monthly)",
    months6Weekly: "6 Months (Weekly)",
    atLeastOneStatusMustBeSelected: "At least one status must be selected."
});
const $911eba4d16ebb469$export$34912999f6279d4f = Object.freeze({
    marketShare: "Market Share",
    noRowsSelected: "Please select a checkbox on the table below to view your chart data",
    comparisonSets: "Comparison Sets",
    manageComparisonSets: "Manage Comparison Sets",
    comparisonSetsDescription: "Create and compare market share for collections of one or more office groups.",
    addComparisonSetMessage: 'To add a comparison set, click "New Set"',
    editComparisonSet: "Edit Comparison Set",
    getDeleteComparisonSet: (comparisonSetName)=>`Are you sure you want to delete ${comparisonSetName}?`,
    getDeleteOfficeGroup: (officeGroupName)=>`Are you sure you want to delete ${officeGroupName}?`,
    deleteComparisonSetDescription: "Deleting this comparison set will delete all office groups associated with this comparison set and remove this comparison set from all associated saved searches.",
    noneAdded: "None added",
    addNewComparisonSet: "Add New Comparison Set",
    comparisonSetName: "Comparison Set Name",
    newComparisonSet: "New Comparison Set",
    addComparisonSetDescription: `Choose a name for the new comparison set (max ${(0, $1ujWz.NAME_MAX_LENGTH)} characters).`,
    editComparisonSetDescription: `Choose a new name for the comparison set (max ${(0, $1ujWz.NAME_MAX_LENGTH)} characters).`,
    addNewGroupDescription: `Choose a name for the new office group (max ${(0, $1ujWz.NAME_MAX_LENGTH)} characters).`,
    getCreatedComparisonSetMessage: (comparisonSetLabel)=>`${comparisonSetLabel} has been created.`,
    duplicateComparisonSetName: "There is already a Comparison Set with that name in the MLS. Please select a different name.",
    duplicateOfficeGroupName: "There is already an Office Group with that name in the Comparison Set. Please select a different name.",
    getGroupUpdatedMessage: (officeGroupName)=>`Success: ${officeGroupName} has been created.`,
    getGroupEditedMsg: (officeGroupName)=>`The office group named ${officeGroupName} has been updated successfully.`,
    getCompNameUpdatedMsg: (compSetName)=>`The comparison set named ${compSetName} has been updated successfully.`,
    getOfficeGroupDeletedMsg: (officeGroupName)=>`The office group named ${officeGroupName} has been deleted successfully.`,
    getOfficeGroupDeleteError: (officeGroupName)=>`The ${officeGroupName} office group could not be deleted. Please try again.`,
    getOfficeGroupEditError: (officeGroupName)=>`The ${officeGroupName} office group could not be updated. Please try again.`,
    createComparisonSetsError: "Error creating comparison sets",
    updateOfficeGroupError: "Error updating office groups",
    officeGroup: "Office Group",
    officeGroupName: "Office Group Name",
    addOfficeGroupMessage: 'To add an office group, click "New Group"',
    addNewOfficeGroup: "Add New Office Group",
    editOfficeGroup: "Edit Office Group",
    newOfficeGroup: "New Office Group",
    comparisonSetMlsIdField: "mlsId",
    getComparisonSetLabel: (csName, csDescription)=>`${csName} (${csDescription})`,
    getRemovedComparisonSetMessage: (comparisonSetName)=>`The comparison set named ${comparisonSetName} has been deleted successfully.`,
    errorUpdatingSavedSearches: "Error updating saved search criteria",
    getRemovedComparisonSetErrorMessage: (comparisonSetName)=>`The ${comparisonSetName} comparison set could not be deleted. Please try again.`
});
const $911eba4d16ebb469$export$c7d22d57aae71781 = {
    ok: "Ok",
    cancel: "Cancel",
    clearAll: "Clear All",
    connectMls: "Connect MLS",
    delete: "Delete",
    download: "Download",
    export: "Export",
    save: "Save",
    saveSearch: "Save Search",
    runSearch: "Run Search",
    volume: "Volume",
    units: "Units",
    addFilter: "Add Filter",
    done: "Done",
    selected: "Selected",
    all: "All",
    update: "Update",
    statuses: "Statuses",
    saveAsNew: "Save as New List",
    saveAsNewButtonId: "save-as-new-btn",
    updateButtonId: "update-btn",
    yes: "Yes",
    no: "No",
    linkLwa: "Link my Lone Wolf account",
    askLater: "Ask me later",
    newSet: "New Set",
    addList: "Add List",
    editCriteria: "Edit Criteria",
    display: "Display",
    newGroup: "New Group"
};
const $911eba4d16ebb469$export$3e4ea77b8bea417 = Object.freeze({
    lwolfSupport: "support@lwolf.com",
    terradatumSupport: "terradatum.support@lwolf.com"
});
const $911eba4d16ebb469$export$2497dec627a30444 = {
    propertyTypesNoSelectionError: "You must select at least one property type",
    missingTimePeriodType: "You must specify a time period type\n",
    missingStartDate: "You must specify a start date\n",
    invalidStartDateFormat: "Start date format must be MM/DD/YYYY\n",
    invalidStartDate: (start, end)=>`The Start date must be between ${start} and ${end}\n`,
    missingEndDate: "You must specify an end date\n",
    invalidEndDateFormat: "End date format must be MM/DD/YYYY\n",
    endDateTooEarly: "The Start date must be before the End date\n",
    invalidEndDate: (start, end)=>`The End date must be between ${start} and ${end}\n`,
    sameStartAndEnd: "The Start date cannot be the same as the End date\n",
    notNumeric: "You must specify a numeric value\n",
    maxLessThanMin: (term)=>`Maximum ${term} must be greater than or equal to minimum ${term}.\n`,
    greaterThanLimit: (term, limit)=>`${term} cannot be greater than ${limit}.\n`,
    isNegative: (term)=>`${term} cannot be less than 0.\n`,
    invalidEmail: "Your email is not valid.",
    requiredEmail: "Email is required.",
    invalidPassword: "Password must be between 8 and 100 characters long.",
    requiredPassword: "Password is required.",
    authenticationFailed: `The email and password you entered do not match our records. Please double-check and try again. If the issue persists, contact your administrator or ${$911eba4d16ebb469$export$3e4ea77b8bea417.lwolfSupport}.`,
    inactiveKeycloak: `You do not have permission to access this BrokerMetrics account. Please contact your administrator or email ${$911eba4d16ebb469$export$3e4ea77b8bea417.lwolfSupport}.`,
    invalidLogin: "Invalid login",
    invalidToken: "Invalid Token",
    connectionMismatch: (emailAddress)=>`The login credentials associated with ${emailAddress} have been set up incorrectly. Please contact your administrator or ${$911eba4d16ebb469$export$3e4ea77b8bea417.lwolfSupport}.`,
    connectionError: "Connection error, please try again.",
    unableToLink: "Unable to link account at this time.",
    unknownError: "Something went wrong. Try again later",
    unableToConnect: "This account could not be connected",
    accountAlreadyConnected: "This account is already connected to a Platform account",
    notValidEnvForHost: (hostname)=>`Couldn't find a valid environment for ${hostname}`,
    notValidEnv: (env, platformEnv)=>`${env} or ${platformEnv} are not valid environments. Valid envs are: dev, stage, stg, pre and empty string for prod`
};
const $911eba4d16ebb469$export$9a1d9eb0857440d3 = Object.freeze({
    exportFilenames: {
        production: "[AGENT_NAME]'s Production in [MLS_NAME] for [PERIOD_START] - [PERIOD_FINISH]",
        inventory: "[AGENT_NAME]'s Inventory in [SEARCH_AREA/MLS_NAME] on [DOWNLOAD_DATE]",
        transactionCoverage: "[AGENT_NAME]'s [DEAL_STATUS] Transaction Coverage in [SEARCH_AREA/MLS_NAME] on [DOWNLOAD_DATE]",
        transactionCoverageListings: "[AGENT_NAME]'s [DEAL_STATUS] Listings in [SEARCH_AREA/MLS_NAME] for [DOWNLOAD_DATE]",
        productionAgentListings: "[AGENT_NAME]'s Production Listings in [SEARCH_AREA/MLS_NAME] for [TIME_PERIOD]"
    },
    listingProfMetricsHeader: "List Side Transactions (ALL MLS) Last 12 Months ([12_MONTHS_AGO] - [LAST_MONTH])",
    headerListSideTransactions: "List Side Transactions (All MLS) [LAST_12_MONTHS] ([CURRENT_LAST_12_MONTHS_RANGE])"
});
const $911eba4d16ebb469$export$784b0b5579a17681 = Object.freeze({
    labels: {
        ytdPrevYearNum: "YTD [PREVIOUS_YEAR] #",
        ytdCurrentYearNum: "YTD [CURRENT_YEAR] #",
        ytdPrevYear$: "YTD [PREVIOUS_YEAR] $",
        ytdCurrentYear$: "YTD [CURRENT_YEAR] $"
    }
});
const $911eba4d16ebb469$export$9785edcc3744ff22 = Object.freeze({
    active: "Active",
    contingent: "Contingent",
    pending: "Pending",
    sold: "Sold"
});
const $911eba4d16ebb469$export$4585e058e79220a9 = Object.freeze({
    "SoldBothSides": "Total Sold (List + Sell)",
    "SoldListSide": "Sold (List Side)",
    "SoldSellSide": "Sold (Sell Side)",
    "UnderContract": "Under Contract",
    "ForSale": "For Sale",
    "New": "New Listings"
});
const $911eba4d16ebb469$export$93453266d7d33157 = Object.freeze({
    "SoldBothSides": "Total Sold (List + Sell)",
    "ForSale": "For Sale"
});
const $911eba4d16ebb469$export$6b970ea150c039a6 = Object.freeze({
    account: "Account",
    currently: "Currently",
    all: "all",
    noData: "No results found",
    noDataSuggestion: `Try adjusting your search filters to find what you're looking for.`,
    noSavedAgents: "No Saved Agents",
    noSavedAgentsSuggestion: "Save an agent for them to appear here.",
    initialLoad: `Please adjust your search filters to find agents you're looking for`,
    findAgents: "Find agents using the search bar above",
    officeInformation: "Office Information",
    officeId: "Office ID",
    officeName: "Office Name",
    office: "Office",
    officeAddress: "Office Address",
    officePhone: "Office Phone",
    officeEmail: "Office Email",
    broker: "Broker",
    brokerName: "Broker Name",
    totalSell: "Total Sell",
    totalList: "Total List",
    noPriceChangeListings: "No Price Change Listings",
    priceChangeListings: "Price Change Listings",
    showHideMetrics: "Show/Hide Metrics",
    contact: "Contact",
    exportData: "Export Data",
    export: "Export",
    month: "Month",
    listNumber: "List #",
    listDollars: "List $",
    sellNumber: "Sell #",
    sellDollars: "Sell $",
    totalNumber: "Total #",
    totalDollars: "Total $",
    totalNumberPct: "# Units %",
    totalDollarsPct: "$ Volume %",
    type: "Type",
    address: "Address",
    city: "City",
    zip: "Zip",
    county: "County",
    originalPrice: "Original Price",
    listPrice: "List Price",
    numPriceChanges: "# Price Changes",
    listDate: "List Date",
    ucDate: "UC Date",
    daysUnderContract: "Days Under Contract",
    cdom: "CDOM",
    status: "Status",
    bd: "BD",
    ba: "BA",
    sqft: "SQFT",
    dollarsPerSqft: "$/SQFT",
    lotSizeAcres: "Lot Size (Acres)",
    yearBuilt: "Year Built",
    mlsNumber: "MLS Number",
    propertyType: "Property Type",
    propertySubType: "Property Subtype",
    orgPriceListPrice: "Org. Price/List Price",
    listOffice: "List Office",
    coListOffice: "Co-List Office",
    domCdom: "DOM/CDOM",
    sellOffice: "Sell Office",
    taxId: "Tax ID",
    coSellOffice: "Co-Sell Office",
    coListAgent: "Co-List Agent",
    coSellAgent: "Co-Sell Agent",
    fullBaths: "Full Baths",
    bedrooms: "Bedrooms",
    mlsArea: "MLS Area",
    subdivision: "Subdivision",
    partialBaths: "Partial Baths",
    mapCode: "Map Code",
    squareFeet: "Square Feet",
    lotSize: "Lot Size",
    acres: "Acres",
    newConstruction: "New Construction",
    price: "Price",
    abbrY: "Y",
    abbrN: "N",
    spLp: "SP/LP",
    spOp: "SP/OP",
    changeDollar: "Change $",
    changeNum: "Change #",
    changeType: "Change Type",
    changeTypePct: "Change Type %",
    priceChange: "Price Change",
    priceChangePct: "Price Change %",
    days: "Days",
    date: "Date",
    mlsNum: "MLS #",
    share: "Share",
    downloadPdf: "Download PDF",
    copyShareableLink: "Copy Shareable Link",
    dollarVolumeListSide: "$ Volume - List Side",
    dollarVolumeSellSide: "$ Volume - Sell Side",
    totalDollarVolume: "Total $ Volume",
    dollarVolumePerMonth: "$ Volume Per Month",
    averagePrice: "Average Price",
    unitsChange: "Units Change",
    dollarChange: "$ Change",
    pctChange: "% Change",
    pctChangeNum: "% Change #",
    agentProfile: "Agent Profile",
    notApplicableAbbrv: "N/A",
    currentYear: "Current Year",
    previousYear: "Previous Year",
    volume: "Volume",
    units: "Units",
    numberUnits: "# Units",
    dollarVolume: "$ Volume",
    totalVolume: "Total Volume",
    totalUnits: "Total Units",
    numberUnitsListSide: "# Units - List Side",
    numberUnitsSellSide: "# Units - Sell Side",
    totalNumberUnits: "Total # Units",
    numberUnitsPerMonth: "# Units Per Month",
    previousMonth: "Previous Month",
    lastMonth: "Last Month",
    last6Months: "Last 6 Months",
    table: "Table",
    chart: "Chart",
    mlsWide: "MLS-Wide",
    allMls: "ALL MLS",
    metrics: "Metrics",
    searchTimePeriod: "Search Time Period",
    annually: "Annually",
    last12Months: "Last 12 Months",
    last24Months: "Last 24 Months",
    yearToDate: "Year to Date",
    previousMonthToDate: "Previous Month To Date",
    previousQuarterToDate: "Previous Quarter",
    previousYearToDate: "Previous Year To Date",
    previous6Months: "Previous 6 Months",
    previous12Months: "Previous 12 Months",
    dollarsInMillions: "$ in Millions",
    noDataForSelectedAgent: "No data for selected Agent",
    listSideSold: "List Side (Sold)",
    sellSideSold: "Sell Side (Sold)",
    searchReturnedNoResults: "Your search returned no results",
    MTD: "MTD",
    QTD: "QTD",
    YTD: "YTD",
    propertyInformation: "Property Information",
    pricingHistory: "Pricing History",
    agentProduction: "Agent Production",
    proficiencyMetrics: "Proficiency Metrics",
    overview: "Overview",
    contactInformation: "Contact Information",
    growthAnalysis: "Growth Analysis",
    listingProficiency: "Listing Proficiency",
    activity: "Activity",
    downloadData: "Download Data",
    production: "Production",
    inventory: "Inventory",
    transactionCoverage: "Transaction Coverage",
    officeHistory: "Office History",
    officeHistoryNoData: "No Office History Found",
    areaType: "Area Type",
    counties: "Counties",
    zipCode: "Zip Code",
    zipCodes: "Zip Codes",
    cities: "Cities",
    mlsAreas: "MLS Areas",
    subdivisions: "Subdivisions",
    allMlsTransactions: "ALL MLS Transactions",
    currentSearch: "Current Search",
    stNumber: "St #",
    street: "Street",
    bankProperty: "Bank Property",
    soldPrice: "Sold Price",
    priceChangeCnt: "# of Price Changes",
    spop: "SP/OP",
    spopPct: "SP/OP %",
    splp: "SP/LP",
    soldDate: "Sold Date",
    dom: "DOM",
    pcdom: "PC_DOM",
    lotSizeSqft: "Lot Size (SQFT)",
    listAgent: "List Agent",
    sellAgent: "Sell Agent",
    dbl: "DBL",
    area: "Area",
    marketAreaPct: "Market Area %",
    listings: "Listings",
    totalSoldListing: "Total Sold List + Sell",
    sellSoldListing: "Sold Sell-Side",
    listSoldListing: "Sold List-Side",
    underContractListing: "Under Contract",
    forSaleListing: "For Sale",
    viewOnlyMyAgentsNoData: "No agents found for this filter",
    findAgent: "Find Agent",
    agentsFields: "At least 1 character must be entered in one of these fields.",
    firstName: "firstName",
    lastName: "lastName",
    name: "Name",
    agentId: "Agent ID",
    agentContactInformation: "Agent Contact Information",
    officeDetail: "Office Detail",
    businessAddress: "Business Address",
    phoneNumbers: "Phone Number(s)",
    emailAddress: "Email Address",
    alternateAddress: "Alternate Address",
    alternatePhoneNumbers: "Alternate Phone Number(s)",
    brokerID: "Broker ID",
    mls: "MLS",
    mlsIDs: "MLS IDs",
    responsibleMember: "Responsible Member",
    producingAgents: "Producing Agents",
    memberType: "Member Type",
    constructionType: "Construction Type",
    agentsAddedSuccessfully: (isPlural, agentList)=>`${isPlural ? "Agents" : "Agent"} added successfully to ${agentList}`,
    unableToAddAgents: (agentList)=>`Unable to add agents${agentList ? ` to ${agentList}` : ""}. Something went wrong. Please try again.`,
    somethingWentWrongError: "Something went wrong. Please try again.",
    errorServer413: `The amount of data provided in the request exceeds the capacity limit.
                     Please refine your search and try again.`,
    errorServerNoResponse: `A technical problem prevented your information from being
                            displayed. Please try again. If that doesn't work,
                            contact `,
    totalSum: "Total",
    agent: "Agent",
    totalsAverages: "Totals / Averages",
    notSuppliedByMls: "Not Supplied By MLS",
    officeLookupPlaceholder: "Filter by office name, office ID, city, zip code, county",
    allMlsTransactionsLast12Months: "ALL MLS Transactions Last 12 Months",
    growth: "Growth",
    active: "Active",
    inactive: "Inactive",
    summary: "Summary",
    recentCoopTransactions: "Recent Co-op Transaction",
    currentTimePeriodSearch: "Current Time Period/Search",
    last90Days: "Last 90 Days",
    businessPhone: "Business Phone",
    agentDetails: "Agent Details",
    officeCounty: "Office County",
    close: "Close",
    settings: "Settings",
    profile: "Profile",
    filterBy: "Filter by"
});
const $911eba4d16ebb469$export$2d9f407612b7ad89 = Object.freeze({
    notifications: "Notifications",
    notificationsIntro: "Edit your notification settings",
    notificationsBrokerUpdates: "Broker Metrics Updates",
    savedAgents: "Saved Agents",
    notificationsSavedAgentsDescription: "While my campaign is active, send me a summary of the activity and engagement for Saved Agents.",
    receiveNotifications: "Receive Notifications",
    saveChanges: "Save Changes"
});
const $911eba4d16ebb469$export$56d059f7654fdbf5 = [
    {
        label: "Weekly",
        value: "weekly"
    },
    {
        label: "Every 2 weeks",
        value: "biweekly"
    },
    {
        label: "Monthly",
        value: "monthly"
    },
    {
        label: "Quarterly",
        value: "quarterly"
    },
    {
        label: "Never",
        value: "never"
    }
];
const $911eba4d16ebb469$export$51203442c7ccdfd9 = Object.freeze({
    overwriteTitle: (name)=>`${name} already exists!`,
    overwriteBody: "Do you want to overwrite?",
    linkLwaModalsubtitle: "Create and link your Lone Wolf account to BrokerMetrics",
    linkLwaModalBody1: "We are working to make it easier for you to access all your Lone Wolf applications in a secure manner.",
    linkLwaModalBody2: "To do this, we ask that you create a Lone Wolf account, and link it to your BrokerMetrics account. This gives you access to all your Lone Wolf applications from one place and lets you switch between applications with ease using a single login."
});
const $911eba4d16ebb469$export$2cb63e8002c36ae6 = 25;
const $911eba4d16ebb469$export$6d4d60d3548ad3e2 = [
    {
        label: "firstName",
        value: "First Name"
    },
    {
        label: "lastName",
        value: "Last Name"
    },
    {
        label: "agentId",
        value: "Agent ID"
    },
    {
        label: "city",
        value: "City"
    },
    {
        label: "county",
        value: "County"
    },
    {
        label: "zipCode",
        value: "Zip"
    }
];
const $911eba4d16ebb469$export$1b24ab711461207c = {
    user: "USER",
    lwa: "LWA_ID"
};
const $911eba4d16ebb469$export$471f7ae5c4103ae1 = {
    INACTIVE: "I",
    NOTFOUND: "Not found",
    ACTIVE: "A"
};
const $911eba4d16ebb469$export$995d7ae0c0293bac = {
    [$911eba4d16ebb469$export$471f7ae5c4103ae1.ACTIVE]: $911eba4d16ebb469$export$6b970ea150c039a6.active,
    [$911eba4d16ebb469$export$471f7ae5c4103ae1.INACTIVE]: $911eba4d16ebb469$export$6b970ea150c039a6.inactive
};
const $911eba4d16ebb469$export$3830a599b40dbdfb = Object.freeze({
    dashboard: "DASHBOARD",
    proficiencyMetrics: "PROFICIENCY_METRICS",
    marketShare: "MARKET_SHARE",
    marketDynamics: "MARKET_DYNAMICS",
    agentProduction: "AGENT_PRODUCTION"
});
const $911eba4d16ebb469$export$6187295c74fedf54 = {
    "PROFICIENCY_METRICS": "Proficiency Metrics",
    "MARKET_SHARE": "Market Share",
    "MARKET_DYNAMICS": "Market Dynamics",
    "MARKET_SHARE.TOTALS": "Totals",
    "MARKET_SHARE.COVERAGE": "Coverage",
    "PROFICIENCY_METRICS.AGENT_MOVEMENT": "Agent Movement"
};
const $911eba4d16ebb469$export$4a7a4a2059251137 = {
    internal: "Internal",
    broker: "Broker",
    mls: "MLS"
};
const $911eba4d16ebb469$export$cc2c248003684daa = {
    proficiencyMetrics: {
        transactions: "PROFICIENCY_METRICS.TRANSACTIONS",
        offices: "PROFICIENCY_METRICS.OFFICES",
        agents: "PROFICIENCY_METRICS.AGENTS",
        savedAgents: "PROFICIENCY_METRICS.SAVED_AGENTS",
        suggestedAgents: "PROFICIENCY_METRICS.SUGGESTED_AGENTS",
        agentMovement: "PROFICIENCY_METRICS.AGENT_MOVEMENT"
    },
    marketShare: {
        totals: "MARKET_SHARE.TOTALS",
        coverage: "MARKET_SHARE.COVERAGE"
    },
    marketDynamics: {
        marketDynamics: "MARKET_DYNAMICS"
    },
    agentProduction: {
        agentProduction: "AGENT_PRODUCTION"
    },
    savedAgents: {
        savedAgents: "SAVED_AGENTS"
    },
    dashboard: {
        dashboard: "DASHBOARD"
    }
};
const $911eba4d16ebb469$export$c56e4a7b2e4d99a5 = {
    [$911eba4d16ebb469$export$3830a599b40dbdfb.proficiencyMetrics]: $911eba4d16ebb469$export$cc2c248003684daa.proficiencyMetrics.transactions,
    [$911eba4d16ebb469$export$3830a599b40dbdfb.agentProduction]: $911eba4d16ebb469$export$cc2c248003684daa.agentProduction.agentProduction,
    [$911eba4d16ebb469$export$3830a599b40dbdfb.marketShare]: $911eba4d16ebb469$export$cc2c248003684daa.marketShare.totals,
    [$911eba4d16ebb469$export$3830a599b40dbdfb.marketDynamics]: $911eba4d16ebb469$export$cc2c248003684daa.marketDynamics.marketDynamics,
    [$911eba4d16ebb469$export$3830a599b40dbdfb.dashboard]: $911eba4d16ebb469$export$cc2c248003684daa.dashboard.dashboard
};
const $911eba4d16ebb469$export$10a5f1252070f649 = {
    [$911eba4d16ebb469$export$cc2c248003684daa.proficiencyMetrics.transactions]: $911eba4d16ebb469$export$a89ca33323f6f239.transactions,
    [$911eba4d16ebb469$export$cc2c248003684daa.proficiencyMetrics.offices]: $911eba4d16ebb469$export$a89ca33323f6f239.officeName,
    [$911eba4d16ebb469$export$cc2c248003684daa.proficiencyMetrics.agents]: $911eba4d16ebb469$export$a89ca33323f6f239.agentName,
    [$911eba4d16ebb469$export$cc2c248003684daa.proficiencyMetrics.savedAgents]: $911eba4d16ebb469$export$a89ca33323f6f239.savedAgents,
    [$911eba4d16ebb469$export$cc2c248003684daa.proficiencyMetrics.agentMovement]: $911eba4d16ebb469$export$a89ca33323f6f239.agentMovement,
    [$911eba4d16ebb469$export$cc2c248003684daa.proficiencyMetrics.suggestedAgents]: $911eba4d16ebb469$export$a89ca33323f6f239.suggestedAgents,
    [$911eba4d16ebb469$export$cc2c248003684daa.marketShare.totals]: $911eba4d16ebb469$export$a89ca33323f6f239.totals,
    [$911eba4d16ebb469$export$cc2c248003684daa.marketShare.coverage]: $911eba4d16ebb469$export$a89ca33323f6f239.coverage,
    [$911eba4d16ebb469$export$cc2c248003684daa.marketDynamics.marketDynamics]: (0, $c7dF9.Routes).MARKET_DYNAMICS.BASE,
    [$911eba4d16ebb469$export$cc2c248003684daa.agentProduction.agentProduction]: (0, $c7dF9.Routes).AGENT_PRODUCTION.BASE,
    [$911eba4d16ebb469$export$cc2c248003684daa.dashboard.dashboard]: (0, $c7dF9.Routes).HOME.DASHBOARD
};
const $911eba4d16ebb469$export$4302d2db97b000f5 = [
    {
        moduleName: $911eba4d16ebb469$export$3830a599b40dbdfb.proficiencyMetrics,
        module: $911eba4d16ebb469$export$cc2c248003684daa.proficiencyMetrics.transactions,
        route: $911eba4d16ebb469$export$a89ca33323f6f239.transactions
    },
    {
        moduleName: $911eba4d16ebb469$export$3830a599b40dbdfb.proficiencyMetrics,
        module: $911eba4d16ebb469$export$cc2c248003684daa.proficiencyMetrics.offices,
        route: $911eba4d16ebb469$export$a89ca33323f6f239.officeName
    },
    {
        moduleName: $911eba4d16ebb469$export$3830a599b40dbdfb.proficiencyMetrics,
        module: $911eba4d16ebb469$export$cc2c248003684daa.proficiencyMetrics.agents,
        route: $911eba4d16ebb469$export$a89ca33323f6f239.agentName
    },
    {
        moduleName: $911eba4d16ebb469$export$3830a599b40dbdfb.proficiencyMetrics,
        module: $911eba4d16ebb469$export$cc2c248003684daa.proficiencyMetrics.suggestedAgents,
        route: $911eba4d16ebb469$export$a89ca33323f6f239.suggestedAgents
    },
    {
        moduleName: $911eba4d16ebb469$export$3830a599b40dbdfb.proficiencyMetrics,
        module: $911eba4d16ebb469$export$cc2c248003684daa.proficiencyMetrics.savedAgents,
        route: $911eba4d16ebb469$export$a89ca33323f6f239.savedAgentsActivity
    },
    {
        moduleName: $911eba4d16ebb469$export$3830a599b40dbdfb.marketShare,
        module: $911eba4d16ebb469$export$cc2c248003684daa.marketShare.totals,
        route: $911eba4d16ebb469$export$a89ca33323f6f239.totals
    },
    {
        moduleName: $911eba4d16ebb469$export$3830a599b40dbdfb.marketShare,
        module: $911eba4d16ebb469$export$cc2c248003684daa.marketShare.coverage,
        route: $911eba4d16ebb469$export$a89ca33323f6f239.coverage
    },
    {
        moduleName: $911eba4d16ebb469$export$3830a599b40dbdfb.marketDynamics,
        module: $911eba4d16ebb469$export$cc2c248003684daa.marketDynamics.marketDynamics,
        route: (0, $c7dF9.Routes).MARKET_DYNAMICS.BASE
    },
    {
        moduleName: $911eba4d16ebb469$export$3830a599b40dbdfb.agentProduction,
        module: $911eba4d16ebb469$export$cc2c248003684daa.agentProduction.agentProduction,
        route: (0, $c7dF9.Routes).AGENT_PRODUCTION.BASE
    },
    {
        moduleName: $911eba4d16ebb469$export$3830a599b40dbdfb.dashboard,
        module: $911eba4d16ebb469$export$cc2c248003684daa.dashboard.dashboard,
        route: (0, $c7dF9.Routes).HOME.DASHBOARD
    }
];
const $911eba4d16ebb469$export$898eed799e4bc165 = {
    [$911eba4d16ebb469$export$3830a599b40dbdfb.marketDynamics]: {
        listingInfo: `${(0, $c7dF9.Routes).MARKET_DYNAMICS.BASE}${(0, $c7dF9.Routes).MARKET_DYNAMICS.LISTING_INFO}`
    },
    [$911eba4d16ebb469$export$3830a599b40dbdfb.marketShare]: {
        listingInfo: `${(0, $c7dF9.Routes).MARKET_SHARE.BASE}${(0, $c7dF9.Routes).MARKET_SHARE.LISTING_INFO}`
    }
};
const $911eba4d16ebb469$export$6fb9ef1b4c1af532 = {
    [$911eba4d16ebb469$export$cc2c248003684daa.proficiencyMetrics.transactions]: {
        hasPropertyTypes: true,
        hasOffices: false
    },
    [$911eba4d16ebb469$export$cc2c248003684daa.proficiencyMetrics.offices]: {
        hasPropertyTypes: false,
        hasOffices: true
    },
    [$911eba4d16ebb469$export$cc2c248003684daa.proficiencyMetrics.agents]: {
        hasPropertyTypes: true,
        hasOffices: false
    },
    [$911eba4d16ebb469$export$cc2c248003684daa.proficiencyMetrics.savedAgents]: {
        hasPropertyTypes: true,
        hasOffices: false
    },
    [$911eba4d16ebb469$export$cc2c248003684daa.marketShare.totals]: {
        hasPropertyTypes: true,
        hasOffices: false
    },
    [$911eba4d16ebb469$export$cc2c248003684daa.marketShare.coverage]: {
        hasPropertyTypes: true,
        hasOffices: true
    },
    [$911eba4d16ebb469$export$cc2c248003684daa.marketDynamics.marketDynamics]: {
        hasPropertyTypes: true,
        hasOffices: false
    },
    [$911eba4d16ebb469$export$cc2c248003684daa.agentProduction.agentProduction]: {
        hasPropertyTypes: true,
        hasOffices: false
    }
};
const $911eba4d16ebb469$export$f4892780ff65b8c8 = Object.freeze({
    agentProfile: {
        HEADER_CLASSES: "align-middle no-wrap"
    }
});
const $911eba4d16ebb469$export$40fb018dd4c59f8 = {
    error: {
        deleteSearch: "Unable to delete your search. Please try again later.",
        saveSearch: "Unable to save your search. Please try again later.",
        marketListExists: "A market area list with this name already exists. Please enter an unused name.",
        duplicatedOfficeList: "An office list with this name already exists. Please enter an unused name",
        duplicatedAgentList: "An agent list with this name already exists. Please enter an unused name",
        saveList: (listType)=>`Unable to save your ${listType} list. Please try again later`,
        deleteSavedList: (searchType)=>`Unable to delete your ${searchType} list. Please try again later`,
        tooManySelections: "You have selected too many options.",
        limitYourSelection: "Please limit your selection to 2000.",
        searchExceeded: (maxAgentsToReturn)=>`Your search result has exceeded ${maxAgentsToReturn} agents. Please adjust your search criteria and try again.`,
        agentNotValidated: "We couldn't verify your credentials. Please try again or reach out to support@lwolf.com for assistance.",
        emptyProducers: (isIncreasing)=>`Please enter a value for either the Minimum ${isIncreasing ? "Increase" : "Decrease"} % or the Maximum ${isIncreasing ? "Increase" : "Decrease"} % to update the search results.`,
        brandingLogo: "The logo upload failed. Please try again",
        brandingLogoDelete: "Failed to remove logo. Please try again.",
        saveFailed: "Save Failed!"
    },
    success: {
        searchSaved: "Success: Your search has been saved",
        savedListConfirmation: (listName)=>`Success: ${listName} list has been saved`,
        deletedListConfirmation: (listName)=>`${listName} list has been deleted`,
        agentValidated: "Your credentials have been successfully validated.",
        brandingLogo: "The logo has been successfully uploaded!",
        brandingLogoDelete: "The logo has been successfully removed!",
        successfullySaved: "Successfully Saved!"
    }
};
const $911eba4d16ebb469$export$5be02e19f9b79aec = (agent)=>`${agent.firstName} ${agent.lastName}`;
const $911eba4d16ebb469$export$f372b14c42f90b79 = {
    "MTD": "MTD",
    "QTD": "QTD",
    [$911eba4d16ebb469$export$6b970ea150c039a6.YTD]: "YTD",
    [$911eba4d16ebb469$export$6b970ea150c039a6.yearToDate]: "YTD",
    "Last Month": "Monthly",
    "Last 6 Months": "Last6Months",
    "Last 12 Months": "Annually",
    "Last 24 Months": "Last24Months",
    "Last Calendar Year": "LastCalendarYear",
    "Custom Date": "Custom",
    [$911eba4d16ebb469$export$6b970ea150c039a6.last90Days]: "Last90Days",
    "Last 60 Days": "Last60Days",
    [$911eba4d16ebb469$export$6b970ea150c039a6.annually]: "Annually",
    "Last 180 Days": "Last180Days",
    "Last 365 Days": "Last365Days"
};
const $911eba4d16ebb469$export$ec3b1cfeb6b98ccc = {
    [$911eba4d16ebb469$export$d3c07f097457da9b.years3Quarterly]: "Last13Quarters",
    [$911eba4d16ebb469$export$d3c07f097457da9b.years2Monthly]: "Last25Months",
    [$911eba4d16ebb469$export$d3c07f097457da9b.years1Monthly]: "Last13Months",
    [$911eba4d16ebb469$export$d3c07f097457da9b.months6Weekly]: "Last24Weeks"
};
const $911eba4d16ebb469$export$1566a4beeb3a5923 = {
    run: "begin-search",
    running: "fetching-search",
    ran: "search-completed"
};
const $911eba4d16ebb469$export$3d14ea391decd4 = [
    "city",
    "subdivision",
    "areaKey",
    "area2Key",
    "areaSub",
    "zip",
    "county",
    "mapCode",
    "state"
];
const $911eba4d16ebb469$export$d122ad926d806868 = [
    $911eba4d16ebb469$export$c33fc47cb8e932e.lotSizeAcresFilter,
    $911eba4d16ebb469$export$c33fc47cb8e932e.lotSquareFeetFilter
];
const $911eba4d16ebb469$export$8dbf236f06e16b9a = Object.freeze({
    "areaKey-suggest": "area_id",
    "area2Key-suggest": "area2_id",
    "areaSub-suggest": "area_sub_id",
    "city-suggest": "city",
    "county-suggest": "county",
    "subdivision-suggest": "subdivision",
    "zip-suggest": "zip_code",
    "mapCode-suggest": "map_code"
});
const $911eba4d16ebb469$export$a21e10b0ff0fad26 = Object.freeze({
    "zip_code": "zip",
    "city": "city",
    "county": "county",
    "subdivision": "subdivision",
    "area_sub_id": "areaSub",
    "area_id": "areaKey",
    "area2_id": "area2Key",
    "map_code": "mapCode",
    "state_code": "state"
});
const $911eba4d16ebb469$export$d2aa288f27b9fa4a = Object.freeze({
    tooManyResults: "Too many results found",
    tooManySelections: "Too many selections",
    linkLwaModal: "BrokerMetrics by Lone Wolf"
});
const $911eba4d16ebb469$export$1eafd33d9d555e0f = {
    allRightsReserved: "\xa92014 - 2025 Lone Wolf Inc. All rights reserved.",
    email: "Email",
    login: "Log in",
    password: "Password",
    privacyPolicy: "Privacy Policy",
    productSuite: (appLabel)=>`${appLabel} Product Suite`,
    signInBM: "Sign in to BrokerMetrics",
    signInAM: "Sign in to AgentMetrics",
    signInLWA: "Sign in with your Lone Wolf Account",
    termsOfUse: "Terms of Use",
    or: "or",
    lwaTooltip: "Use this option if you already connected your BrokerMetrics account to your Lone Wolf Account"
};
const $911eba4d16ebb469$export$8c1ffc600110d529 = {
    signOut: "Sign Out",
    myProfile: "My Profile"
};
const $911eba4d16ebb469$export$4e2b959b815d8fe5 = Object.freeze({
    LONE_WOLF_INTERNAL: {
        id: 2
    }
});
const $911eba4d16ebb469$export$362c30ac9d93aa05 = Object.freeze({
    MCRTC: 10
});
const $911eba4d16ebb469$export$c060504f7c3e8958 = Object.freeze({
    RESIDENTIAL: 0
});
const $911eba4d16ebb469$export$cc08d92e623d1bf1 = Object.freeze({
    LOGIN: "LOGIN",
    LOGOUT: "LOGOUT",
    PAGE_VIEW: "PAGE_VIEW",
    API_CALL: "API_CALL",
    SEARCH: "SEARCH"
});
const $911eba4d16ebb469$export$ddfd6edecdaaab7c = {
    recentLabel: "Recent",
    recentValue: "recent",
    alphaValue: "alpha",
    alphaLabel: "A to Z",
    updatedValue: "updated",
    updatedLabel: "Updated",
    soldCountValue: "soldCount",
    soldCountLabel: "Count",
    agentNameValue: "agentName",
    volumeLabel: "$ Volume",
    volumeValue: "volume",
    officeNameValue: "officeName"
};
const $911eba4d16ebb469$export$1c55f4e019ddfc47 = {
    SAVE: "save",
    OFFICE_GROUP: "office_group",
    EDIT: "edit",
    DELETE: "delete",
    DELETE_OFFICE_GROUP: "delete_office_group"
};
const $911eba4d16ebb469$export$7aa1b4ae03ddc9f4 = (selectedMls, appLabel)=>`\
Metrics and charts produced using ${appLabel} are based on information from ${selectedMls.shortDescription}. \
The user represents that they are properly subscribed to use the data from ${selectedMls.shortDescription}. \
Metrics are based on the timeframes and other criteria provided by the user and/or referenced in each report. \
All information deemed reliable but not guaranteed and should be independently verified. Lone Wolf is not responsible for any \
typographical errors, misinformation, misprints in the MLS data and the user agrees to hold Lone Wolf harmless \
for any claims arising from the same.`;
const $911eba4d16ebb469$export$a7f6cddfcb97ef08 = "\xae";
const $911eba4d16ebb469$export$ca0b6bfb83bbd659 = {
    csv: "csv",
    pdf: "pdf"
};
const $911eba4d16ebb469$export$6b42a5293495f5f6 = {
    choseType: "Choose a type:",
    csvDescription: "For easy import into spreadsheets or databases.",
    csvLabel: "CSV File",
    isOpen: "isOpen",
    fileType: "fileType",
    pdfDescription: "For easy viewing, printing, and sharing.",
    pdfLabel: "PDF Report",
    comingSoon: "Coming Soon - This feature is on the way.",
    coverageAreaDisclaimer: `PDF charts can display up to ${(0, $6M53k.COVERAGE_AREA_MAX_COUNT_SELECTIONS)} areas. Larger sets will be split.`,
    chooseCoverageArea: "Choose which coverage areas to include:",
    coverageAreas: "Coverage Areas",
    noCoverageAreasSelected: "Please select a Coverage Area to continue"
};
const $911eba4d16ebb469$export$53cb456310d1907e = {
    pdf: "application/pdf",
    json: "application/json"
};
const $911eba4d16ebb469$export$76640677f56900c8 = {
    [$911eba4d16ebb469$export$c33fc47cb8e932e.all]: "",
    [$911eba4d16ebb469$export$c33fc47cb8e932e.new]: $911eba4d16ebb469$export$6b970ea150c039a6.abbrY,
    [$911eba4d16ebb469$export$c33fc47cb8e932e.resale]: $911eba4d16ebb469$export$6b970ea150c039a6.abbrN
};
const $911eba4d16ebb469$export$124931c5cc419985 = "T00:00:00";
const $911eba4d16ebb469$export$b76a977f306ef683 = "@lwolf.com";
const $911eba4d16ebb469$export$c2cfcee2a1489f30 = {
    [$911eba4d16ebb469$export$6b970ea150c039a6.transactionCoverage]: "transactionCoverage",
    [$911eba4d16ebb469$export$6b970ea150c039a6.production]: "production",
    [$911eba4d16ebb469$export$6b970ea150c039a6.inventory]: "inventory"
};
const $911eba4d16ebb469$export$2b2c8a045fa23000 = {
    marketAreaTitle: {
        mainTitle: $911eba4d16ebb469$export$c33fc47cb8e932e.selectType($911eba4d16ebb469$export$c33fc47cb8e932e.marketArea)
    },
    propertyTypeTitle: {
        mainTitle: $911eba4d16ebb469$export$c33fc47cb8e932e.selectType($911eba4d16ebb469$export$c33fc47cb8e932e.propertyTypes)
    },
    timeFrameTitle: {
        mainTitle: $911eba4d16ebb469$export$c33fc47cb8e932e.selectType($911eba4d16ebb469$export$c33fc47cb8e932e.timeFrame)
    },
    totalVolumeTitle: {
        mainTitle: $911eba4d16ebb469$export$c33fc47cb8e932e.selectType($911eba4d16ebb469$export$c33fc47cb8e932e.totalVolume)
    },
    soldPriceRangeTitle: {
        mainTitle: $911eba4d16ebb469$export$c33fc47cb8e932e.selectType($911eba4d16ebb469$export$c33fc47cb8e932e.soldPriceRange)
    },
    totalUnitsTitle: {
        mainTitle: $911eba4d16ebb469$export$c33fc47cb8e932e.selectType($911eba4d16ebb469$export$c33fc47cb8e932e.totalUnits)
    },
    bedroomsTitle: {
        mainTitle: $911eba4d16ebb469$export$c33fc47cb8e932e.selectType($911eba4d16ebb469$export$c33fc47cb8e932e.bedrooms)
    },
    fullBathroomsTitle: {
        mainTitle: $911eba4d16ebb469$export$c33fc47cb8e932e.selectType($911eba4d16ebb469$export$c33fc47cb8e932e.fullBathrooms)
    }
};

});
parcelRegister("1ujWz", function(module, exports) {

$parcel$export(module.exports, "NAME_MAX_LENGTH", () => $1158102cc09132e3$export$4e57fecdd7a0462a);
$parcel$export(module.exports, "buildInitialAvailableOffices", () => $1158102cc09132e3$export$f8c56cc0f0220867);
$parcel$export(module.exports, "getComparisonSetParams", () => $1158102cc09132e3$export$dae893f23b735607);
$parcel$export(module.exports, "getCompSetsByMLsWithOfficeGroup", () => $1158102cc09132e3$export$78e1e3a8bb012b49);
$parcel$export(module.exports, "getMlsToSet", () => $1158102cc09132e3$export$50613c186286cb26);

var $7ROc5 = parcelRequire("7ROc5");

var $iCDWi = parcelRequire("iCDWi");

var $cstaF = parcelRequire("cstaF");
const $1158102cc09132e3$export$4e57fecdd7a0462a = 55;
const $1158102cc09132e3$export$f8c56cc0f0220867 = (selectedComparisonSet, selectedComparisonSetOfficesList)=>{
    const takenOfficeIds = selectedComparisonSet?.groups?.reduce((officeIds, group)=>{
        return [
            ...officeIds,
            ...group.offices.map((office)=>office.officeId)
        ];
    }, []);
    return selectedComparisonSetOfficesList?.filter((office)=>!takenOfficeIds.includes(office.officeId));
};
const $1158102cc09132e3$export$dae893f23b735607 = (receivedCriteria, selectedComparisonSet)=>{
    const criteria = receivedCriteria.realEstateDatasourceIdsWithFilters[0];
    const revisedSearchFields = (0, $iCDWi.filterItemByKeyfieldValue)(criteria.searchFields, "fieldName", (0, $cstaF.searchTerms).comparisonSetFilter);
    const groups = selectedComparisonSet?.groups;
    if (!groups) return [];
    const transactionStatus = criteria.computedFields[0].fieldValues[0];
    const searchCriteria = {
        criteria: {
            ...receivedCriteria,
            realEstateDatasourceIdsWithFilters: [
                {
                    ...receivedCriteria.realEstateDatasourceIdsWithFilters[0],
                    searchFields: revisedSearchFields
                }
            ]
        }
    };
    return {
        params: {
            comparisonSet: groups,
            search: searchCriteria
        },
        transactionStatus: transactionStatus
    };
};
const $1158102cc09132e3$export$78e1e3a8bb012b49 = (comparisonSets, selectedMls)=>{
    const comparisonSetsByMls = (0, $7ROc5.getFilteredListByKeyField)(comparisonSets, (0, $cstaF.marketShareTerms).comparisonSetMlsIdField, selectedMls?.mlsId);
    return comparisonSetsByMls?.filter((comparisonSet)=>comparisonSet?.groups.length > 0) ?? [];
};
const $1158102cc09132e3$export$50613c186286cb26 = (mlsList, selectedComparisonSet)=>{
    return mlsList?.filter((mls)=>mls?.mlsId === selectedComparisonSet?.mlsId).map((mls)=>({
            label: `(${mls?.shortDescription}) ${mls?.longDescription}`,
            value: mls
        }))[0];
};

});
parcelRegister("7ROc5", function(module, exports) {

$parcel$export(module.exports, "chipIconProps", () => $5ba46b1af93f6d35$export$1309f8f607aa6093);
$parcel$export(module.exports, "getFilteredListByKeyField", () => $5ba46b1af93f6d35$export$375b0f87e6de8c01);
$parcel$export(module.exports, "OFFICES_POPOVER_WIDTH", () => $5ba46b1af93f6d35$export$13f12af9f15dbf12);
$parcel$export(module.exports, "OFFICES_POPOVER_HORIZONTAL_INSET", () => $5ba46b1af93f6d35$export$9c53d7a2e673b777);
const $5ba46b1af93f6d35$export$1309f8f607aa6093 = {
    className: "align-top mr-1"
};
const $5ba46b1af93f6d35$export$375b0f87e6de8c01 = (list, keyField, valueToFilter)=>list?.filter((i)=>i[keyField] === valueToFilter);
const $5ba46b1af93f6d35$export$13f12af9f15dbf12 = "1525px";
const $5ba46b1af93f6d35$export$9c53d7a2e673b777 = "5.5px";

});

parcelRegister("iCDWi", function(module, exports) {

$parcel$export(module.exports, "removeDuplicates", () => $d8eac1b0434edf34$export$2e2262a44ac61957);
$parcel$export(module.exports, "msToDays", () => $d8eac1b0434edf34$export$3296db7413397191);
$parcel$export(module.exports, "filterItemByKeyfieldValue", () => $d8eac1b0434edf34$export$4760031d4ae51142);
$parcel$export(module.exports, "getCriteriaObject", () => $d8eac1b0434edf34$export$1fccb116913ca72f);
$parcel$export(module.exports, "getUpdatedObjectByKeyfield", () => $d8eac1b0434edf34$export$5a3ebe97bcd14190);
$parcel$export(module.exports, "reverseMap", () => $d8eac1b0434edf34$export$991a0d0425e18490);
$parcel$export(module.exports, "buildSearchCriteria", () => $d8eac1b0434edf34$export$df176fff878d521);
$parcel$export(module.exports, "getCurrentSearchDates", () => $d8eac1b0434edf34$export$62451ff460107b6b);
$parcel$export(module.exports, "getCurrentTabTimePeriod", () => $d8eac1b0434edf34$export$63a4b794e36c2e36);

var $dlZsJ = parcelRequire("dlZsJ");

var $cstaF = parcelRequire("cstaF");
const $d8eac1b0434edf34$export$2e2262a44ac61957 = (arr)=>{
    return arr.filter((item, index)=>{
        return index === arr.findIndex((obj)=>JSON.stringify(obj) === JSON.stringify(item));
    });
};
const $d8eac1b0434edf34$export$3296db7413397191 = (ms)=>ms / 86400000;
const $d8eac1b0434edf34$export$4760031d4ae51142 = (list, keyfield, keyfieldValueToRemove)=>{
    return list.filter((item)=>item[keyfield] !== keyfieldValueToRemove);
};
const $d8eac1b0434edf34$export$1fccb116913ca72f = (searchCriteria)=>searchCriteria?.criteria?.realEstateDatasourceIdsWithFilters?.[0];
const $d8eac1b0434edf34$export$19f4699d1d10b95b = (obj, keyfieldToUpdate, valueToUpdate)=>{
    for(let key in obj){
        if (key === keyfieldToUpdate) {
            obj[keyfieldToUpdate] = valueToUpdate;
            return;
        }
        if (Array.isArray(obj[key])) obj[key].forEach((nestedObj)=>{
            if (typeof obj[key] === "object" && obj[key] !== undefined) $d8eac1b0434edf34$export$19f4699d1d10b95b(nestedObj, keyfieldToUpdate, valueToUpdate);
        });
        if (typeof obj[key] === "object" && obj[key] !== undefined) $d8eac1b0434edf34$export$19f4699d1d10b95b(obj[key], keyfieldToUpdate, valueToUpdate);
    }
};
const $d8eac1b0434edf34$export$5a3ebe97bcd14190 = (object, keyfieldToUpdate, valueToUpdate)=>{
    const parsedObject = JSON.parse(JSON.stringify(object));
    $d8eac1b0434edf34$export$19f4699d1d10b95b(parsedObject, keyfieldToUpdate, valueToUpdate);
    return parsedObject;
};
const $d8eac1b0434edf34$export$991a0d0425e18490 = (mapObject)=>{
    return Object.fromEntries(Object.entries(mapObject).map(([key, value])=>[
            value,
            key
        ]));
};
const $d8eac1b0434edf34$export$184766475f04255e = (valueA, valueB)=>{
    return valueA / valueB * 100;
};
const $d8eac1b0434edf34$export$df176fff878d521 = ({ currentTabId: currentTabId, mlsId: mlsId, propertyTypeIds: propertyTypeIds, propertyTypeNames: propertyTypeNames, agentIds: agentIds, listId: listId, officeIds: officeIds, searchAllMLS: searchAllMLS = true, timePeriod: timePeriod })=>{
    const idFiltering = agentIds && listId ? [
        {
            idType: "agentId",
            idValues: agentIds,
            listId: listId
        }
    ] : [];
    const timePeriodCriteria = typeof timePeriod === "string" ? {
        intervalType: timePeriod
    } : timePeriod;
    return {
        criteria: {
            realEstateDatasourceIdsWithFilters: [
                {
                    realEstateDatasourceId: mlsId,
                    ...currentTabId === "coopAgents" && officeIds && officeIds.length ? {
                        idFiltering: [
                            {
                                "idType": "officeId",
                                "idValues": officeIds
                            }
                        ]
                    } : {
                        searchFields: [
                            {
                                fieldName: "propertyType",
                                fieldValues: propertyTypeIds || [],
                                fieldValueDescriptions: propertyTypeNames || []
                            }
                        ],
                        searchAllMLS: searchAllMLS,
                        computedFields: [],
                        idFiltering: idFiltering
                    }
                }
            ],
            timePeriod: {
                intervalType: timePeriodCriteria.intervalType,
                startDate: timePeriodCriteria.startDate || null,
                endDate: timePeriodCriteria.endDate || null
            }
        },
        offset: 0,
        size: 0
    };
};
const $d8eac1b0434edf34$export$62451ff460107b6b = (timeIntervals, selectedTimePeriod)=>{
    if (!timeIntervals?.length) return;
    const interval = timeIntervals?.find((i)=>i?.intervalType === selectedTimePeriod);
    if (!interval) return;
    const lastIntervalText = (0, $dlZsJ.getKeyByValue)((0, $cstaF.TimePeriods), selectedTimePeriod);
    const from = new Date(`${interval.last.from}Z`);
    const to = new Date(`${interval.last.to}Z`);
    return {
        lastIntervalText: lastIntervalText,
        from: from,
        to: to
    };
};
const $d8eac1b0434edf34$export$63a4b794e36c2e36 = (tabProducersState)=>tabProducersState?.newProd?.value || tabProducersState?.timeFrame?.value || tabProducersState?.timePeriod?.value || (0, $cstaF.agentProductionTerms).annually;

});
parcelRegister("dlZsJ", function(module, exports) {

$parcel$export(module.exports, "getKeyByValue", () => $9b8ce9ae6cfbcc4d$export$5afee16442bde5ee);
$parcel$export(module.exports, "getParentFromValue", () => $9b8ce9ae6cfbcc4d$export$b95c0ed747f23b19);
$parcel$export(module.exports, "getCommaSeparatedTextByKeyFields", () => $9b8ce9ae6cfbcc4d$export$f1e275b5bce1545);

var $cstaF = parcelRequire("cstaF");
const $9b8ce9ae6cfbcc4d$export$5afee16442bde5ee = (object, value)=>{
    return Object.keys(object).find((key)=>object[key] === value);
};
const $9b8ce9ae6cfbcc4d$export$b95c0ed747f23b19 = (object, value)=>{
    let parent;
    Object.keys(object).forEach((key)=>{
        if (Object.values(object[key]).find((childValue)=>childValue === value)) parent = (0, $cstaF.moduleNames)[key];
    });
    return parent;
};
const $9b8ce9ae6cfbcc4d$export$f1e275b5bce1545 = (object, keys)=>{
    return (keys || []).filter((key)=>object?.[key]).map((key)=>object[key]).join(", ");
};

});



parcelRegister("6M53k", function(module, exports) {

$parcel$export(module.exports, "MIN_COUNT_SELECTIONS", () => $9194c20ac6233afb$export$f775ddb0aa5f4a35);
$parcel$export(module.exports, "COVERAGE_AREA_MIN_COUNT_SELECTIONS", () => $9194c20ac6233afb$export$2b4e756a0af297ac);
$parcel$export(module.exports, "COVERAGE_AREA_MAX_COUNT_SELECTIONS", () => $9194c20ac6233afb$export$93d2f34567b163ef);
$parcel$export(module.exports, "getCountChecked", () => $9194c20ac6233afb$export$521d733a64b0b7d5);
$parcel$export(module.exports, "getRenderedStatusOptions", () => $9194c20ac6233afb$export$e427d694ad020422);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("fHiKR");
var $1BYDb = parcelRequire("1BYDb");

var $cstaF = parcelRequire("cstaF");

var $bQFqF = parcelRequire("bQFqF");

var $ikyhZ = parcelRequire("ikyhZ");
const $9194c20ac6233afb$export$927217ba1c534f9e = 3;
const $9194c20ac6233afb$export$f775ddb0aa5f4a35 = 1;
const $9194c20ac6233afb$export$2b4e756a0af297ac = 1;
const $9194c20ac6233afb$export$93d2f34567b163ef = 21;
const $9194c20ac6233afb$export$521d733a64b0b7d5 = (options)=>{
    return options?.filter((o)=>o.checked && !o.isRadio)?.length || (0, $cstaF.searchTerms).none.toLowerCase();
};
const $9194c20ac6233afb$export$e427d694ad020422 = (options, handleOptionClick, countChecked, maxCountSelections = $9194c20ac6233afb$export$927217ba1c534f9e)=>options?.map((option)=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $acw62.Fragment), {
            children: [
                option.isRadio ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1BYDb))), {
                    className: "status-item my-2",
                    dataLwtId: option.id,
                    type: "radio",
                    name: "statusOption",
                    id: option.id,
                    checked: option.checked,
                    value: option.id,
                    label: option.label,
                    onChange: handleOptionClick
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: `py-2 ${option.tooltip && "d-inline-flex status-row"}`,
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1BYDb))), {
                            className: "status-item",
                            disabled: !option.checked && countChecked >= maxCountSelections,
                            dataLwtId: option.id,
                            type: "checkbox",
                            id: option.id,
                            checked: option.checked,
                            value: option.id,
                            label: option.label,
                            onChange: handleOptionClick
                        }),
                        option.tooltip && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bQFqF.default), {
                            option: option
                        })
                    ]
                }, option.id),
                option.isRadio && option.id === (0, $ikyhZ.listingStatuses).sold.id ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "status-divider"
                }) : null
            ]
        }, option.id));

});
parcelRegister("fHiKR", function(module, exports) {

$parcel$export(module.exports, "Label", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("kN5vy")))));
$parcel$export(module.exports, "CustomInput", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("1BYDb")))));
$parcel$export(module.exports, "Input", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("5txPe")))));

var $kN5vy = parcelRequire("kN5vy");

var $1BYDb = parcelRequire("1BYDb");

var $5txPe = parcelRequire("5txPe");

});
parcelRegister("kN5vy", function(module, exports) {
"use strict";
var $f22ca801cc497d9b$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $f22ca801cc497d9b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $f22ca801cc497d9b$var$react_1 = $f22ca801cc497d9b$var$__importDefault((parcelRequire("acw62")));

var $e8lFn = parcelRequire("e8lFn");
const $f22ca801cc497d9b$var$Label = (props)=>{
    const { dataLwtId: dataLwtId } = props, restProps = $f22ca801cc497d9b$var$__rest(props, [
        "dataLwtId"
    ]);
    const optionalProps = {};
    if (dataLwtId) optionalProps["data-lwt-id"] = dataLwtId;
    return $f22ca801cc497d9b$var$react_1.default.createElement($e8lFn.default, Object.assign({}, optionalProps, restProps));
};
module.exports.default = $f22ca801cc497d9b$var$Label;

});
parcelRegister("e8lFn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4a29e8e98ff562a$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $e9hDx = parcelRequire("e9hDx");
var $a4a29e8e98ff562a$var$colWidths = [
    "xs",
    "sm",
    "md",
    "lg",
    "xl"
];
var $a4a29e8e98ff562a$var$stringOrNumberProp = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
]);
var $a4a29e8e98ff562a$var$columnProps = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        size: $a4a29e8e98ff562a$var$stringOrNumberProp,
        order: $a4a29e8e98ff562a$var$stringOrNumberProp,
        offset: $a4a29e8e98ff562a$var$stringOrNumberProp
    })
]);
var $a4a29e8e98ff562a$var$propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    hidden: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    check: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    for: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    tag: (0, $e9hDx.tagPropType),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    xs: $a4a29e8e98ff562a$var$columnProps,
    sm: $a4a29e8e98ff562a$var$columnProps,
    md: $a4a29e8e98ff562a$var$columnProps,
    lg: $a4a29e8e98ff562a$var$columnProps,
    xl: $a4a29e8e98ff562a$var$columnProps,
    widths: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array
};
var $a4a29e8e98ff562a$var$defaultProps = {
    tag: "label",
    widths: $a4a29e8e98ff562a$var$colWidths
};
var $a4a29e8e98ff562a$var$getColumnSizeClass = function getColumnSizeClass(isXs, colWidth, colSize) {
    if (colSize === true || colSize === "") return isXs ? "col" : "col-" + colWidth;
    else if (colSize === "auto") return isXs ? "col-auto" : "col-" + colWidth + "-auto";
    return isXs ? "col-" + colSize : "col-" + colWidth + "-" + colSize;
};
var $a4a29e8e98ff562a$var$Label = function Label(props) {
    var className = props.className, cssModule = props.cssModule, hidden = props.hidden, widths = props.widths, Tag = props.tag, check = props.check, size = props.size, htmlFor = props.for, attributes = (0, $1En50.default)(props, [
        "className",
        "cssModule",
        "hidden",
        "widths",
        "tag",
        "check",
        "size",
        "for"
    ]);
    var colClasses = [];
    widths.forEach(function(colWidth, i) {
        var columnProp = props[colWidth];
        delete attributes[colWidth];
        if (!columnProp && columnProp !== "") return;
        var isXs = !i;
        var colClass;
        if ((0, $e9hDx.isObject)(columnProp)) {
            var _classNames;
            var colSizeInterfix = isXs ? "-" : "-" + colWidth + "-";
            colClass = $a4a29e8e98ff562a$var$getColumnSizeClass(isXs, colWidth, columnProp.size);
            colClasses.push((0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))((_classNames = {}, _classNames[colClass] = columnProp.size || columnProp.size === "", _classNames["order" + colSizeInterfix + columnProp.order] = columnProp.order || columnProp.order === 0, _classNames["offset" + colSizeInterfix + columnProp.offset] = columnProp.offset || columnProp.offset === 0, _classNames))), cssModule);
        } else {
            colClass = $a4a29e8e98ff562a$var$getColumnSizeClass(isXs, colWidth, columnProp);
            colClasses.push(colClass);
        }
    });
    var classes = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, hidden ? "sr-only" : false, check ? "form-check-label" : false, size ? "col-form-label-" + size : false, colClasses, colClasses.length ? "col-form-label" : false), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({
        htmlFor: htmlFor
    }, attributes, {
        className: classes
    }));
};
$a4a29e8e98ff562a$var$Label.propTypes = $a4a29e8e98ff562a$var$propTypes;
$a4a29e8e98ff562a$var$Label.defaultProps = $a4a29e8e98ff562a$var$defaultProps;
var $a4a29e8e98ff562a$export$2e2bcd8739ae039 = $a4a29e8e98ff562a$var$Label;

});


parcelRegister("1BYDb", function(module, exports) {
"use strict";
var $12c8473022a7d30c$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $12c8473022a7d30c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $12c8473022a7d30c$var$react_1 = $12c8473022a7d30c$var$__importDefault((parcelRequire("acw62")));

var $awZuS = parcelRequire("awZuS");
const $12c8473022a7d30c$var$CustomInput = (props)=>{
    const { dataLwtId: dataLwtId } = props, restProps = $12c8473022a7d30c$var$__rest(props, [
        "dataLwtId"
    ]);
    const optionalProps = {};
    if (dataLwtId) optionalProps["data-lwt-id"] = dataLwtId;
    return $12c8473022a7d30c$var$react_1.default.createElement($awZuS.default, Object.assign({}, optionalProps, restProps));
};
module.exports.default = $12c8473022a7d30c$var$CustomInput;

});
parcelRegister("awZuS", function(module, exports) {

$parcel$export(module.exports, "default", () => $7aac9890b4995433$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $e9hDx = parcelRequire("e9hDx");

var $g4t9K = parcelRequire("g4t9K");
var $7aac9890b4995433$var$propTypes = {
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
    ]).isRequired,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    inline: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    valid: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    invalid: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    bsSize: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    htmlFor: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
    ]),
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
    ])
};
function $7aac9890b4995433$var$CustomInput(props) {
    var className = props.className, label = props.label, inline = props.inline, valid = props.valid, invalid = props.invalid, cssModule = props.cssModule, children = props.children, bsSize = props.bsSize, innerRef = props.innerRef, htmlFor = props.htmlFor, attributes = (0, $1En50.default)(props, [
        "className",
        "label",
        "inline",
        "valid",
        "invalid",
        "cssModule",
        "children",
        "bsSize",
        "innerRef",
        "htmlFor"
    ]);
    var type = attributes.type;
    var customClass = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, "custom-" + type, bsSize ? "custom-" + type + "-" + bsSize : false), cssModule);
    var validationClassNames = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(invalid && "is-invalid", valid && "is-valid"), cssModule);
    var labelHtmlFor = htmlFor || attributes.id;
    if (type === "select") {
        var _type = attributes.type, _rest = (0, $1En50.default)(attributes, [
            "type"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("select", (0, $8nd05.default)({}, _rest, {
            ref: innerRef,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(validationClassNames, customClass),
            "aria-invalid": invalid
        }), children);
    }
    if (type === "file") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $g4t9K.default), props);
    if (type !== "checkbox" && type !== "radio" && type !== "switch") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", (0, $8nd05.default)({}, attributes, {
        ref: innerRef,
        "aria-invalid": invalid,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(validationClassNames, customClass)
    }));
    var wrapperClasses = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(customClass, (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("custom-control", {
        "custom-control-inline": inline
    }), cssModule));
    var hidden = attributes.hidden, rest = (0, $1En50.default)(attributes, [
        "hidden"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: wrapperClasses,
        hidden: hidden || false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", (0, $8nd05.default)({}, rest, {
        type: type === "switch" ? "checkbox" : type,
        ref: innerRef,
        "aria-invalid": invalid,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(validationClassNames, (0, $e9hDx.mapToCssModules)("custom-control-input", cssModule))
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        className: (0, $e9hDx.mapToCssModules)("custom-control-label", cssModule),
        htmlFor: labelHtmlFor
    }, label), children);
}
$7aac9890b4995433$var$CustomInput.propTypes = $7aac9890b4995433$var$propTypes;
var $7aac9890b4995433$export$2e2bcd8739ae039 = $7aac9890b4995433$var$CustomInput;

});
parcelRegister("g4t9K", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb33a2e449bcc91e$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $hDpcU = parcelRequire("hDpcU");

var $g7ajw = parcelRequire("g7ajw");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $e9hDx = parcelRequire("e9hDx");
var $bb33a2e449bcc91e$var$propTypes = {
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number
    ]).isRequired,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    valid: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    invalid: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    bsSize: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    htmlFor: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
    ]),
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
    ])
};
var $bb33a2e449bcc91e$var$CustomFileInput = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(CustomFileInput, _React$Component);
    function CustomFileInput(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            files: null
        };
        _this.onChange = _this.onChange.bind((0, $hDpcU.default)(_this));
        return _this;
    }
    var _proto = CustomFileInput.prototype;
    _proto.onChange = function onChange(e) {
        var input = e.target;
        var onChange = this.props.onChange;
        var files = this.getSelectedFiles(input);
        if (typeof onChange === "function") onChange.apply(void 0, arguments);
        this.setState({
            files: files
        });
    };
    _proto.getSelectedFiles = function getSelectedFiles(input) {
        var multiple = this.props.multiple;
        if (multiple && input.files) {
            var files = [].slice.call(input.files);
            return files.map(function(file) {
                return file.name;
            }).join(", ");
        }
        if (input.value.indexOf("fakepath") !== -1) {
            var parts = input.value.split("\\");
            return parts[parts.length - 1];
        }
        return input.value;
    };
    _proto.render = function render() {
        var _this$props = this.props, className = _this$props.className, label = _this$props.label, valid = _this$props.valid, invalid = _this$props.invalid, cssModule = _this$props.cssModule, children = _this$props.children, bsSize = _this$props.bsSize, innerRef = _this$props.innerRef, htmlFor = _this$props.htmlFor, type = _this$props.type, onChange = _this$props.onChange, dataBrowse = _this$props.dataBrowse, hidden = _this$props.hidden, attributes = (0, $1En50.default)(_this$props, [
            "className",
            "label",
            "valid",
            "invalid",
            "cssModule",
            "children",
            "bsSize",
            "innerRef",
            "htmlFor",
            "type",
            "onChange",
            "dataBrowse",
            "hidden"
        ]);
        var customClass = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, "custom-file"), cssModule);
        var validationClassNames = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(invalid && "is-invalid", valid && "is-valid"), cssModule);
        var labelHtmlFor = htmlFor || attributes.id;
        var files = this.state.files;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: customClass,
            hidden: hidden || false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", (0, $8nd05.default)({
            type: "file"
        }, attributes, {
            ref: innerRef,
            "aria-invalid": invalid,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(validationClassNames, (0, $e9hDx.mapToCssModules)("custom-file-input", cssModule)),
            onChange: this.onChange
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
            className: (0, $e9hDx.mapToCssModules)("custom-file-label", cssModule),
            htmlFor: labelHtmlFor,
            "data-browse": dataBrowse
        }, files || label || "Choose file"), children);
    };
    return CustomFileInput;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$bb33a2e449bcc91e$var$CustomFileInput.propTypes = $bb33a2e449bcc91e$var$propTypes;
var $bb33a2e449bcc91e$export$2e2bcd8739ae039 = $bb33a2e449bcc91e$var$CustomFileInput;

});



parcelRegister("5txPe", function(module, exports) {
"use strict";
var $3fc9e63280dee277$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $3fc9e63280dee277$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $3fc9e63280dee277$var$react_1 = $3fc9e63280dee277$var$__importDefault((parcelRequire("acw62")));

var $giAV6 = parcelRequire("giAV6");
const $3fc9e63280dee277$var$numberFormat = new Intl.NumberFormat();
const $3fc9e63280dee277$var$Input = (props)=>{
    const { dataLwtId: dataLwtId, type: type, allowCommas: allowCommas = true, decimalLimit: decimalLimit } = props, rest = $3fc9e63280dee277$var$__rest(props, [
        "dataLwtId",
        "type",
        "allowCommas",
        "decimalLimit"
    ]);
    const checkCommas = allowCommas && type === "number";
    let internalType = type;
    const decimalDigits = decimalLimit !== undefined && decimalLimit >= 0 ? `{0,${decimalLimit}}` : "*";
    const reg = new RegExp(`^-?[\\d,]*\\.?\\d${decimalDigits}$`);
    if (checkCommas) {
        internalType = "text";
        if (!rest.step) rest.step = "any";
    }
    const onBlur = (e)=>{
        if (checkCommas) {
            const inputEvent = e.target;
            if (inputEvent.value === "-") return false;
            const value = inputEvent.value !== "" ? $3fc9e63280dee277$var$numberFormat.format(+inputEvent.value.split(",").join("")) : "";
            setNativeValue(inputEvent, value);
            inputEvent.dispatchEvent(new Event("input", {
                bubbles: true
            }));
        }
        if (props.onBlur) props.onBlur(e);
    };
    const onPaste = (e)=>{
        const inputEvent = e.target;
        if (checkCommas) {
            const value = inputEvent.value + e.clipboardData.getData("text/plain");
            if (!isValidNumericInput(value)) e.preventDefault();
        }
        if (!checkCommas && props.maxLength || props.type === "number" && props.maxLength) {
            const value = inputEvent.value + e.clipboardData.getData("text/plain");
            if (value.length > props.maxLength) e.preventDefault();
        }
        if (props.onPaste) props.onPaste(e);
    };
    const onKeyDown = (e)=>{
        const validKeys = [
            37,
            39,
            8,
            46,
            9 // tab
        ];
        if (checkCommas) {
            if (validKeys.some((k)=>k === e.keyCode)) return;
            const inputEvent = e.target;
            const index = +(inputEvent.selectionStart || 0);
            const value = inputEvent.value.substring(0, index) + e.key + inputEvent.value.substring(index);
            if (!isValidNumericInput(value) && !(e.ctrlKey || e.metaKey)) e.preventDefault();
        }
        if (!checkCommas && props.maxLength || props.type === "number" && props.maxLength) {
            if (validKeys.some((k)=>k === e.keyCode)) return;
            const inputEvent = e.target;
            if (!(e.ctrlKey || e.metaKey) && inputEvent.value.length >= props.maxLength) e.preventDefault();
        }
        if (props.onKeyDown) props.onKeyDown(e);
    };
    const isValidNumericInput = (value)=>reg.test(value);
    // facebook's suggestion on programmatically updating input element:
    // https://github.com/facebook/react/issues/10135#issuecomment-314441175
    const setNativeValue = (element, value)=>{
        var _a, _b;
        const valueSetter = (_a = Object.getOwnPropertyDescriptor(element, "value")) === null || _a === void 0 ? void 0 : _a.set;
        const prototype = Object.getPrototypeOf(element);
        const prototypeValueSetter = (_b = Object.getOwnPropertyDescriptor(prototype, "value")) === null || _b === void 0 ? void 0 : _b.set;
        if (valueSetter && prototypeValueSetter && valueSetter !== prototypeValueSetter) prototypeValueSetter.call(element, value);
        else if (valueSetter) valueSetter.call(element, value);
    };
    const optionalProps = {};
    if (dataLwtId) optionalProps["data-lwt-id"] = dataLwtId;
    return $3fc9e63280dee277$var$react_1.default.createElement($giAV6.default, Object.assign({
        type: internalType
    }, optionalProps, rest, {
        onPaste: onPaste,
        onBlur: onBlur,
        onKeyDown: onKeyDown
    }));
};
module.exports.default = $3fc9e63280dee277$var$Input;

});
parcelRegister("giAV6", function(module, exports) {

$parcel$export(module.exports, "default", () => $bddaf751eb4841f9$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $hDpcU = parcelRequire("hDpcU");

var $g7ajw = parcelRequire("g7ajw");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $e9hDx = parcelRequire("e9hDx");
var $bddaf751eb4841f9$var$propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    bsSize: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    valid: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    invalid: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    tag: (0, $e9hDx.tagPropType),
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    plaintext: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    addon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $bddaf751eb4841f9$var$defaultProps = {
    type: "text"
};
var $bddaf751eb4841f9$var$Input = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(Input, _React$Component);
    function Input(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.getRef = _this.getRef.bind((0, $hDpcU.default)(_this));
        _this.focus = _this.focus.bind((0, $hDpcU.default)(_this));
        return _this;
    }
    var _proto = Input.prototype;
    _proto.getRef = function getRef(ref) {
        if (this.props.innerRef) this.props.innerRef(ref);
        this.ref = ref;
    };
    _proto.focus = function focus() {
        if (this.ref) this.ref.focus();
    };
    _proto.render = function render() {
        var _this$props = this.props, className = _this$props.className, cssModule = _this$props.cssModule, type = _this$props.type, bsSize = _this$props.bsSize, valid = _this$props.valid, invalid = _this$props.invalid, tag = _this$props.tag, addon = _this$props.addon, plaintext = _this$props.plaintext, innerRef = _this$props.innerRef, attributes = (0, $1En50.default)(_this$props, [
            "className",
            "cssModule",
            "type",
            "bsSize",
            "valid",
            "invalid",
            "tag",
            "addon",
            "plaintext",
            "innerRef"
        ]);
        var checkInput = [
            "radio",
            "checkbox"
        ].indexOf(type) > -1;
        var isNotaNumber = new RegExp("\\D", "g");
        var fileInput = type === "file";
        var textareaInput = type === "textarea";
        var selectInput = type === "select";
        var rangeInput = type === "range";
        var Tag = tag || (selectInput || textareaInput ? type : "input");
        var formControlClass = "form-control";
        if (plaintext) {
            formControlClass = formControlClass + "-plaintext";
            Tag = tag || "input";
        } else if (fileInput) formControlClass = formControlClass + "-file";
        else if (rangeInput) formControlClass = formControlClass + "-range";
        else if (checkInput) {
            if (addon) formControlClass = null;
            else formControlClass = "form-check-input";
        }
        if (attributes.size && isNotaNumber.test(attributes.size)) {
            (0, $e9hDx.warnOnce)('Please use the prop "bsSize" instead of the "size" to bootstrap\'s input sizing.');
            bsSize = attributes.size;
            delete attributes.size;
        }
        var classes = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, invalid && "is-invalid", valid && "is-valid", bsSize ? "form-control-" + bsSize : false, formControlClass), cssModule);
        if (Tag === "input" || tag && typeof tag === "function") attributes.type = type;
        if (attributes.children && !(plaintext || type === "select" || typeof Tag !== "string" || Tag === "select")) {
            (0, $e9hDx.warnOnce)('Input with a type of "' + type + '" cannot have children. Please use "value"/"defaultValue" instead.');
            delete attributes.children;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({}, attributes, {
            ref: innerRef,
            className: classes,
            "aria-invalid": invalid
        }));
    };
    return Input;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$bddaf751eb4841f9$var$Input.propTypes = $bddaf751eb4841f9$var$propTypes;
$bddaf751eb4841f9$var$Input.defaultProps = $bddaf751eb4841f9$var$defaultProps;
var $bddaf751eb4841f9$export$2e2bcd8739ae039 = $bddaf751eb4841f9$var$Input;

});



parcelRegister("bQFqF", function(module, exports) {

$parcel$export(module.exports, "default", () => $380e4fd875b2e712$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $dI25G = parcelRequire("dI25G");

var $eOjgM = parcelRequire("eOjgM");

var $rMeTm = parcelRequire("rMeTm");
const $380e4fd875b2e712$var$StatusTooltip = (props)=>{
    const { option: option } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "status-icon",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                id: `${option.id}-icon`,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                    icon: (0, $eOjgM.circle_info),
                    title: "info icon"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $rMeTm.default), {
                    target: `${option.id}-icon`,
                    placement: "top",
                    innerClassName: "status-tooltip",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "helix-small",
                        children: option.tooltip
                    })
                })
            })
        ]
    });
};
var $380e4fd875b2e712$export$2e2bcd8739ae039 = $380e4fd875b2e712$var$StatusTooltip;

});
parcelRegister("dI25G", function(module, exports) {
"use strict";
var $9fb1019465481c47$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HelixIcon = void 0;

var $5x4i0 = parcelRequire("5x4i0");
Object.defineProperty(module.exports, "HelixIcon", {
    enumerable: true,
    get: function() {
        return $9fb1019465481c47$var$__importDefault($5x4i0).default;
    }
});

});
parcelRegister("5x4i0", function(module, exports) {
"use strict";
var $40735c9c2e455fea$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $40735c9c2e455fea$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $40735c9c2e455fea$var$react_1 = $40735c9c2e455fea$var$__importDefault((parcelRequire("acw62")));
const $40735c9c2e455fea$var$HelixIcon = (_a)=>{
    var { icon: icon, className: className } = _a, rest = $40735c9c2e455fea$var$__rest(_a, [
        "icon",
        "className"
    ]);
    return $40735c9c2e455fea$var$react_1.default.createElement($40735c9c2e455fea$var$react_1.default.Fragment, null, icon(Object.assign({
        className: className
    }, rest)));
};
module.exports.default = $40735c9c2e455fea$var$HelixIcon;

});


parcelRegister("eOjgM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.chevron_long_down = module.exports.chevron_left = module.exports.chevron_down = module.exports.checkmark = module.exports.chart_pyramid = module.exports.chart_pie = module.exports.chart_dollar = module.exports.category = module.exports.caret_up = module.exports.caret_right = module.exports.caret_left = module.exports.caret_down = module.exports.cards = module.exports.car = module.exports.camera_video = module.exports.camera = module.exports.calendar_hammer = module.exports.calendar_check = module.exports.calendar = module.exports.calculator = module.exports.buyer_demand = module.exports.building_modern = module.exports.building_condo = module.exports.building_bank = module.exports.browser = module.exports.briefcase = module.exports.box_size = module.exports.bookmark = module.exports.bell_notification = module.exports.book = module.exports.bell = module.exports.bed = module.exports.bathtub = module.exports.banking_reconciliation = module.exports.avg_bar_chart = module.exports.arrows_up_down = module.exports.arrows_left_right = module.exports.arrows_exchange = module.exports.arrow_up = module.exports.arrow_right = module.exports.arrow_left = module.exports.arrow_down = module.exports.arrow_chart_line_down = module.exports.arrow_chart_line = module.exports.archive_restore = module.exports.archive = module.exports.app_grid = module.exports.agent = module.exports.add_user = module.exports.add_to_list = void 0;
module.exports.form_editor = module.exports.for_rent = module.exports.folders = module.exports.folder = module.exports.filter = module.exports.eye_off = module.exports.eye = module.exports.export_icon = module.exports.email = module.exports.drawer_open = module.exports.drawer_close = module.exports.drag_handle = module.exports.drag_arrows = module.exports.dots = module.exports.dollar_bill = module.exports.document_warning = module.exports.document_signed = module.exports.document_question_mark = module.exports.document_pdf = module.exports.document_list = module.exports.document_csv = module.exports.doc = module.exports.diamond_exclamation = module.exports.date_range = module.exports.dash_indeterminate = module.exports.cross_market_demand = module.exports.copy = module.exports.comment_notification = module.exports.comment_attention = module.exports.comment = module.exports.command = module.exports.columns = module.exports.collections = module.exports.coin = module.exports.cog_person = module.exports.cog_notification = module.exports.cog = module.exports.clock = module.exports.clicks = module.exports.circle_user_checkmark = module.exports.circle_question = module.exports.circle_info = module.exports.circle_checkmark = module.exports.chevron_up = module.exports.chevron_small_up = module.exports.chevron_small_right = module.exports.chevron_small_left = module.exports.chevron_small_down = module.exports.chevron_right = module.exports.chevron_long_up = void 0;
module.exports.percentage = module.exports.pencil = module.exports.paperclip = module.exports.outbox = module.exports.origin = module.exports.open_door = module.exports.number_range = module.exports.more_vertical = module.exports.more_horizontal = module.exports.minus = module.exports.message_new = module.exports.merge = module.exports.menu = module.exports.megaphone = module.exports.matching_buyers = module.exports.map_pin = module.exports.map_area = module.exports.map = module.exports.magnet = module.exports.lot = module.exports.lockbox = module.exports.lock_unlock = module.exports.lock = module.exports.location = module.exports.list_reorder = module.exports.list = module.exports.link = module.exports.line_chart_loop = module.exports.line_chart = module.exports.lightbulb = module.exports.launch = module.exports.key_hand = module.exports.key = module.exports.inbox = module.exports.import_icon = module.exports.house_mobile = module.exports.home_percentage = module.exports.home_multi = module.exports.home_heart = module.exports.home_dollar = module.exports.home_compare = module.exports.home_checkmark = module.exports.home_chart = module.exports.home = module.exports.heart = module.exports.headphones = module.exports.gift = module.exports.gesture = module.exports.funnel_person = module.exports.format_strikethrough = void 0;
module.exports.spinner = module.exports.sparkle = module.exports.source = module.exports.smiley_positive_two = module.exports.smiley_positive_one = module.exports.smiley_neutral = module.exports.smiley_negative_two = module.exports.smiley_negative_one = module.exports.skip_right = module.exports.skip_left = module.exports.signature = module.exports.sign_sold = module.exports.sign_in_ground = module.exports.sign_for_sale = module.exports.short_text = module.exports.shopping_cart_filled = module.exports.shopping_cart = module.exports.shield_key = module.exports.shield_home = module.exports.shared = module.exports.share = module.exports.send = module.exports.search_user = module.exports.search_home = module.exports.search = module.exports.screen_percentage = module.exports.screen_line_chart = module.exports.screen_bar_chart = module.exports.school = module.exports.rocket = module.exports.robot = module.exports.return_icon = module.exports.resize_to_fit = module.exports.refresh = module.exports.reclaim = module.exports.priority_none = module.exports.priority_medium = module.exports.priority_low = module.exports.priority_high = module.exports.printer = module.exports.plus_small = module.exports.plus = module.exports.plug = module.exports.player_video = module.exports.play_circle = module.exports.play = module.exports.piggy = module.exports.photo = module.exports.phone = module.exports.person_frame = void 0;
module.exports.zoom_out = module.exports.zoom_in = module.exports.zillow = module.exports.x_small = module.exports.x = module.exports.workspace = module.exports.wolfie = module.exports.warning = module.exports.user_edit = module.exports.video_library = module.exports.version_history = module.exports.user = module.exports.trash_can = module.exports.transaction_workflow = module.exports.tour = module.exports.toolkit = module.exports.to_dos = module.exports.title = module.exports.thumb_up = module.exports.thumb_down = module.exports.text_message = module.exports.template_apply = module.exports.tbd = module.exports.tags = module.exports.string_range = module.exports.store = module.exports.sticky_note = module.exports.status = module.exports.star_rising = module.exports.star = module.exports.stamp = module.exports.split = void 0;

var $3EHnm = parcelRequire("3EHnm");
Object.defineProperty(module.exports, "add_to_list", {
    enumerable: true,
    get: function() {
        return $3EHnm.add_to_list;
    }
});

var $51hrN = parcelRequire("51hrN");
Object.defineProperty(module.exports, "add_user", {
    enumerable: true,
    get: function() {
        return $51hrN.add_user;
    }
});

var $6D38h = parcelRequire("6D38h");
Object.defineProperty(module.exports, "agent", {
    enumerable: true,
    get: function() {
        return $6D38h.agent;
    }
});

var $f56cH = parcelRequire("f56cH");
Object.defineProperty(module.exports, "app_grid", {
    enumerable: true,
    get: function() {
        return $f56cH.app_grid;
    }
});

var $iKYYs = parcelRequire("iKYYs");
Object.defineProperty(module.exports, "archive", {
    enumerable: true,
    get: function() {
        return $iKYYs.archive;
    }
});

var $eL8rR = parcelRequire("eL8rR");
Object.defineProperty(module.exports, "archive_restore", {
    enumerable: true,
    get: function() {
        return $eL8rR.archive_restore;
    }
});

var $fuVX7 = parcelRequire("fuVX7");
Object.defineProperty(module.exports, "arrow_chart_line", {
    enumerable: true,
    get: function() {
        return $fuVX7.arrow_chart_line;
    }
});

var $8ECmc = parcelRequire("8ECmc");
Object.defineProperty(module.exports, "arrow_chart_line_down", {
    enumerable: true,
    get: function() {
        return $8ECmc.arrow_chart_line_down;
    }
});

var $7Ag4v = parcelRequire("7Ag4v");
Object.defineProperty(module.exports, "arrow_down", {
    enumerable: true,
    get: function() {
        return $7Ag4v.arrow_down;
    }
});

var $do2Ov = parcelRequire("do2Ov");
Object.defineProperty(module.exports, "arrow_left", {
    enumerable: true,
    get: function() {
        return $do2Ov.arrow_left;
    }
});

var $i6Qfp = parcelRequire("i6Qfp");
Object.defineProperty(module.exports, "arrow_right", {
    enumerable: true,
    get: function() {
        return $i6Qfp.arrow_right;
    }
});

var $57XhL = parcelRequire("57XhL");
Object.defineProperty(module.exports, "arrow_up", {
    enumerable: true,
    get: function() {
        return $57XhL.arrow_up;
    }
});

var $gDUuz = parcelRequire("gDUuz");
Object.defineProperty(module.exports, "arrows_exchange", {
    enumerable: true,
    get: function() {
        return $gDUuz.arrows_exchange;
    }
});

var $cZvPy = parcelRequire("cZvPy");
Object.defineProperty(module.exports, "arrows_left_right", {
    enumerable: true,
    get: function() {
        return $cZvPy.arrows_left_right;
    }
});

var $7hkiq = parcelRequire("7hkiq");
Object.defineProperty(module.exports, "arrows_up_down", {
    enumerable: true,
    get: function() {
        return $7hkiq.arrows_up_down;
    }
});

var $1zcJ6 = parcelRequire("1zcJ6");
Object.defineProperty(module.exports, "avg_bar_chart", {
    enumerable: true,
    get: function() {
        return $1zcJ6.avg_bar_chart;
    }
});

var $JqtH9 = parcelRequire("JqtH9");
Object.defineProperty(module.exports, "banking_reconciliation", {
    enumerable: true,
    get: function() {
        return $JqtH9.banking_reconciliation;
    }
});

var $ldonF = parcelRequire("ldonF");
Object.defineProperty(module.exports, "bathtub", {
    enumerable: true,
    get: function() {
        return $ldonF.bathtub;
    }
});

var $cQrtJ = parcelRequire("cQrtJ");
Object.defineProperty(module.exports, "bed", {
    enumerable: true,
    get: function() {
        return $cQrtJ.bed;
    }
});

var $OAUZK = parcelRequire("OAUZK");
Object.defineProperty(module.exports, "bell", {
    enumerable: true,
    get: function() {
        return $OAUZK.bell;
    }
});

var $i1ose = parcelRequire("i1ose");
Object.defineProperty(module.exports, "book", {
    enumerable: true,
    get: function() {
        return $i1ose.book;
    }
});

var $gsJSN = parcelRequire("gsJSN");
Object.defineProperty(module.exports, "bell_notification", {
    enumerable: true,
    get: function() {
        return $gsJSN.bell_notification;
    }
});

var $hsYQH = parcelRequire("hsYQH");
Object.defineProperty(module.exports, "bookmark", {
    enumerable: true,
    get: function() {
        return $hsYQH.bookmark;
    }
});

var $lzjF5 = parcelRequire("lzjF5");
Object.defineProperty(module.exports, "box_size", {
    enumerable: true,
    get: function() {
        return $lzjF5.box_size;
    }
});

var $9a6vS = parcelRequire("9a6vS");
Object.defineProperty(module.exports, "briefcase", {
    enumerable: true,
    get: function() {
        return $9a6vS.briefcase;
    }
});

var $cZUuP = parcelRequire("cZUuP");
Object.defineProperty(module.exports, "browser", {
    enumerable: true,
    get: function() {
        return $cZUuP.browser;
    }
});

var $6uVnK = parcelRequire("6uVnK");
Object.defineProperty(module.exports, "building_bank", {
    enumerable: true,
    get: function() {
        return $6uVnK.building_bank;
    }
});

var $aJisf = parcelRequire("aJisf");
Object.defineProperty(module.exports, "building_condo", {
    enumerable: true,
    get: function() {
        return $aJisf.building_condo;
    }
});

var $fKnzg = parcelRequire("fKnzg");
Object.defineProperty(module.exports, "building_modern", {
    enumerable: true,
    get: function() {
        return $fKnzg.building_modern;
    }
});

var $cLxOW = parcelRequire("cLxOW");
Object.defineProperty(module.exports, "buyer_demand", {
    enumerable: true,
    get: function() {
        return $cLxOW.buyer_demand;
    }
});

var $bouKG = parcelRequire("bouKG");
Object.defineProperty(module.exports, "calculator", {
    enumerable: true,
    get: function() {
        return $bouKG.calculator;
    }
});

var $fGgvp = parcelRequire("fGgvp");
Object.defineProperty(module.exports, "calendar", {
    enumerable: true,
    get: function() {
        return $fGgvp.calendar;
    }
});

var $6kfPp = parcelRequire("6kfPp");
Object.defineProperty(module.exports, "calendar_check", {
    enumerable: true,
    get: function() {
        return $6kfPp.calendar_check;
    }
});

var $jnViB = parcelRequire("jnViB");
Object.defineProperty(module.exports, "calendar_hammer", {
    enumerable: true,
    get: function() {
        return $jnViB.calendar_hammer;
    }
});

var $jvGXB = parcelRequire("jvGXB");
Object.defineProperty(module.exports, "camera", {
    enumerable: true,
    get: function() {
        return $jvGXB.camera;
    }
});

var $7BgvG = parcelRequire("7BgvG");
Object.defineProperty(module.exports, "camera_video", {
    enumerable: true,
    get: function() {
        return $7BgvG.camera_video;
    }
});

var $lid8l = parcelRequire("lid8l");
Object.defineProperty(module.exports, "car", {
    enumerable: true,
    get: function() {
        return $lid8l.car;
    }
});

var $21Y0l = parcelRequire("21Y0l");
Object.defineProperty(module.exports, "cards", {
    enumerable: true,
    get: function() {
        return $21Y0l.cards;
    }
});

var $c3MA9 = parcelRequire("c3MA9");
Object.defineProperty(module.exports, "caret_down", {
    enumerable: true,
    get: function() {
        return $c3MA9.caret_down;
    }
});

var $9nLCC = parcelRequire("9nLCC");
Object.defineProperty(module.exports, "caret_left", {
    enumerable: true,
    get: function() {
        return $9nLCC.caret_left;
    }
});

var $fAIeF = parcelRequire("fAIeF");
Object.defineProperty(module.exports, "caret_right", {
    enumerable: true,
    get: function() {
        return $fAIeF.caret_right;
    }
});

var $ec9eb = parcelRequire("ec9eb");
Object.defineProperty(module.exports, "caret_up", {
    enumerable: true,
    get: function() {
        return $ec9eb.caret_up;
    }
});

var $NxXTz = parcelRequire("NxXTz");
Object.defineProperty(module.exports, "category", {
    enumerable: true,
    get: function() {
        return $NxXTz.category;
    }
});

var $dypZd = parcelRequire("dypZd");
Object.defineProperty(module.exports, "chart_dollar", {
    enumerable: true,
    get: function() {
        return $dypZd.chart_dollar;
    }
});

var $4eQUP = parcelRequire("4eQUP");
Object.defineProperty(module.exports, "chart_pie", {
    enumerable: true,
    get: function() {
        return $4eQUP.chart_pie;
    }
});

var $c01Xo = parcelRequire("c01Xo");
Object.defineProperty(module.exports, "chart_pyramid", {
    enumerable: true,
    get: function() {
        return $c01Xo.chart_pyramid;
    }
});

var $catHO = parcelRequire("catHO");
Object.defineProperty(module.exports, "checkmark", {
    enumerable: true,
    get: function() {
        return $catHO.checkmark;
    }
});

var $2XBoY = parcelRequire("2XBoY");
Object.defineProperty(module.exports, "chevron_down", {
    enumerable: true,
    get: function() {
        return $2XBoY.chevron_down;
    }
});

var $gr1E7 = parcelRequire("gr1E7");
Object.defineProperty(module.exports, "chevron_left", {
    enumerable: true,
    get: function() {
        return $gr1E7.chevron_left;
    }
});

var $3eoz5 = parcelRequire("3eoz5");
Object.defineProperty(module.exports, "chevron_long_down", {
    enumerable: true,
    get: function() {
        return $3eoz5.chevron_long_down;
    }
});

var $gQT4l = parcelRequire("gQT4l");
Object.defineProperty(module.exports, "chevron_long_up", {
    enumerable: true,
    get: function() {
        return $gQT4l.chevron_long_up;
    }
});

var $biIZb = parcelRequire("biIZb");
Object.defineProperty(module.exports, "chevron_right", {
    enumerable: true,
    get: function() {
        return $biIZb.chevron_right;
    }
});

var $g6Kf0 = parcelRequire("g6Kf0");
Object.defineProperty(module.exports, "chevron_small_down", {
    enumerable: true,
    get: function() {
        return $g6Kf0.chevron_small_down;
    }
});

var $jezI4 = parcelRequire("jezI4");
Object.defineProperty(module.exports, "chevron_small_left", {
    enumerable: true,
    get: function() {
        return $jezI4.chevron_small_left;
    }
});

var $cSbiy = parcelRequire("cSbiy");
Object.defineProperty(module.exports, "chevron_small_right", {
    enumerable: true,
    get: function() {
        return $cSbiy.chevron_small_right;
    }
});

var $87Xqq = parcelRequire("87Xqq");
Object.defineProperty(module.exports, "chevron_small_up", {
    enumerable: true,
    get: function() {
        return $87Xqq.chevron_small_up;
    }
});

var $iKTw2 = parcelRequire("iKTw2");
Object.defineProperty(module.exports, "chevron_up", {
    enumerable: true,
    get: function() {
        return $iKTw2.chevron_up;
    }
});

var $5rbvT = parcelRequire("5rbvT");
Object.defineProperty(module.exports, "circle_checkmark", {
    enumerable: true,
    get: function() {
        return $5rbvT.circle_checkmark;
    }
});

var $4M1nk = parcelRequire("4M1nk");
Object.defineProperty(module.exports, "circle_info", {
    enumerable: true,
    get: function() {
        return $4M1nk.circle_info;
    }
});

var $2rMdg = parcelRequire("2rMdg");
Object.defineProperty(module.exports, "circle_question", {
    enumerable: true,
    get: function() {
        return $2rMdg.circle_question;
    }
});

var $cQaew = parcelRequire("cQaew");
Object.defineProperty(module.exports, "circle_user_checkmark", {
    enumerable: true,
    get: function() {
        return $cQaew.circle_user_checkmark;
    }
});

var $1tN38 = parcelRequire("1tN38");
Object.defineProperty(module.exports, "clicks", {
    enumerable: true,
    get: function() {
        return $1tN38.clicks;
    }
});

var $cktHh = parcelRequire("cktHh");
Object.defineProperty(module.exports, "clock", {
    enumerable: true,
    get: function() {
        return $cktHh.clock;
    }
});

var $4kMug = parcelRequire("4kMug");
Object.defineProperty(module.exports, "cog", {
    enumerable: true,
    get: function() {
        return $4kMug.cog;
    }
});

var $hXAiX = parcelRequire("hXAiX");
Object.defineProperty(module.exports, "cog_notification", {
    enumerable: true,
    get: function() {
        return $hXAiX.cog_notification;
    }
});

var $chXFP = parcelRequire("chXFP");
Object.defineProperty(module.exports, "cog_person", {
    enumerable: true,
    get: function() {
        return $chXFP.cog_person;
    }
});

var $fbysB = parcelRequire("fbysB");
Object.defineProperty(module.exports, "coin", {
    enumerable: true,
    get: function() {
        return $fbysB.coin;
    }
});

var $6SO53 = parcelRequire("6SO53");
Object.defineProperty(module.exports, "collections", {
    enumerable: true,
    get: function() {
        return $6SO53.collections;
    }
});

var $4URSy = parcelRequire("4URSy");
Object.defineProperty(module.exports, "columns", {
    enumerable: true,
    get: function() {
        return $4URSy.columns;
    }
});

var $6bVQQ = parcelRequire("6bVQQ");
Object.defineProperty(module.exports, "command", {
    enumerable: true,
    get: function() {
        return $6bVQQ.command;
    }
});

var $ijyes = parcelRequire("ijyes");
Object.defineProperty(module.exports, "comment", {
    enumerable: true,
    get: function() {
        return $ijyes.comment;
    }
});

var $8KY4J = parcelRequire("8KY4J");
Object.defineProperty(module.exports, "comment_attention", {
    enumerable: true,
    get: function() {
        return $8KY4J.comment_attention;
    }
});

var $bMnfC = parcelRequire("bMnfC");
Object.defineProperty(module.exports, "comment_notification", {
    enumerable: true,
    get: function() {
        return $bMnfC.comment_notification;
    }
});

var $jlbwB = parcelRequire("jlbwB");
Object.defineProperty(module.exports, "copy", {
    enumerable: true,
    get: function() {
        return $jlbwB.copy;
    }
});

var $4FM1F = parcelRequire("4FM1F");
Object.defineProperty(module.exports, "cross_market_demand", {
    enumerable: true,
    get: function() {
        return $4FM1F.cross_market_demand;
    }
});

var $clCTl = parcelRequire("clCTl");
Object.defineProperty(module.exports, "dash_indeterminate", {
    enumerable: true,
    get: function() {
        return $clCTl.dash_indeterminate;
    }
});

var $8bh2K = parcelRequire("8bh2K");
Object.defineProperty(module.exports, "date_range", {
    enumerable: true,
    get: function() {
        return $8bh2K.date_range;
    }
});

var $aZLLg = parcelRequire("aZLLg");
Object.defineProperty(module.exports, "diamond_exclamation", {
    enumerable: true,
    get: function() {
        return $aZLLg.diamond_exclamation;
    }
});

var $aFfDO = parcelRequire("aFfDO");
Object.defineProperty(module.exports, "doc", {
    enumerable: true,
    get: function() {
        return $aFfDO.doc;
    }
});

var $gIts4 = parcelRequire("gIts4");
Object.defineProperty(module.exports, "document_csv", {
    enumerable: true,
    get: function() {
        return $gIts4.document_csv;
    }
});

var $9vHux = parcelRequire("9vHux");
Object.defineProperty(module.exports, "document_list", {
    enumerable: true,
    get: function() {
        return $9vHux.document_list;
    }
});

var $3UIJm = parcelRequire("3UIJm");
Object.defineProperty(module.exports, "document_pdf", {
    enumerable: true,
    get: function() {
        return $3UIJm.document_pdf;
    }
});

var $AYeFO = parcelRequire("AYeFO");
Object.defineProperty(module.exports, "document_question_mark", {
    enumerable: true,
    get: function() {
        return $AYeFO.document_question_mark;
    }
});

var $1exJo = parcelRequire("1exJo");
Object.defineProperty(module.exports, "document_signed", {
    enumerable: true,
    get: function() {
        return $1exJo.document_signed;
    }
});

var $2xnG6 = parcelRequire("2xnG6");
Object.defineProperty(module.exports, "document_warning", {
    enumerable: true,
    get: function() {
        return $2xnG6.document_warning;
    }
});

var $36dIM = parcelRequire("36dIM");
Object.defineProperty(module.exports, "dollar_bill", {
    enumerable: true,
    get: function() {
        return $36dIM.dollar_bill;
    }
});

var $iKJGH = parcelRequire("iKJGH");
Object.defineProperty(module.exports, "dots", {
    enumerable: true,
    get: function() {
        return $iKJGH.dots;
    }
});

var $gtD5m = parcelRequire("gtD5m");
Object.defineProperty(module.exports, "drag_arrows", {
    enumerable: true,
    get: function() {
        return $gtD5m.drag_arrows;
    }
});

var $5QmN3 = parcelRequire("5QmN3");
Object.defineProperty(module.exports, "drag_handle", {
    enumerable: true,
    get: function() {
        return $5QmN3.drag_handle;
    }
});

var $lSFVZ = parcelRequire("lSFVZ");
Object.defineProperty(module.exports, "drawer_close", {
    enumerable: true,
    get: function() {
        return $lSFVZ.drawer_close;
    }
});

var $evDsw = parcelRequire("evDsw");
Object.defineProperty(module.exports, "drawer_open", {
    enumerable: true,
    get: function() {
        return $evDsw.drawer_open;
    }
});

var $apMUT = parcelRequire("apMUT");
Object.defineProperty(module.exports, "email", {
    enumerable: true,
    get: function() {
        return $apMUT.email;
    }
});

var $1Dy8G = parcelRequire("1Dy8G");
Object.defineProperty(module.exports, "export_icon", {
    enumerable: true,
    get: function() {
        return $1Dy8G.export_icon;
    }
});

var $cZSNF = parcelRequire("cZSNF");
Object.defineProperty(module.exports, "eye", {
    enumerable: true,
    get: function() {
        return $cZSNF.eye;
    }
});

var $fbkEM = parcelRequire("fbkEM");
Object.defineProperty(module.exports, "eye_off", {
    enumerable: true,
    get: function() {
        return $fbkEM.eye_off;
    }
});

var $dJ7np = parcelRequire("dJ7np");
Object.defineProperty(module.exports, "filter", {
    enumerable: true,
    get: function() {
        return $dJ7np.filter;
    }
});

var $9h6PV = parcelRequire("9h6PV");
Object.defineProperty(module.exports, "folder", {
    enumerable: true,
    get: function() {
        return $9h6PV.folder;
    }
});

var $bqxkB = parcelRequire("bqxkB");
Object.defineProperty(module.exports, "folders", {
    enumerable: true,
    get: function() {
        return $bqxkB.folders;
    }
});

var $h940d = parcelRequire("h940d");
Object.defineProperty(module.exports, "for_rent", {
    enumerable: true,
    get: function() {
        return $h940d.for_rent;
    }
});

var $itakD = parcelRequire("itakD");
Object.defineProperty(module.exports, "form_editor", {
    enumerable: true,
    get: function() {
        return $itakD.form_editor;
    }
});

var $6jvDP = parcelRequire("6jvDP");
Object.defineProperty(module.exports, "format_strikethrough", {
    enumerable: true,
    get: function() {
        return $6jvDP.format_strikethrough;
    }
});

var $bpsJs = parcelRequire("bpsJs");
Object.defineProperty(module.exports, "funnel_person", {
    enumerable: true,
    get: function() {
        return $bpsJs.funnel_person;
    }
});

var $jBEgJ = parcelRequire("jBEgJ");
Object.defineProperty(module.exports, "gesture", {
    enumerable: true,
    get: function() {
        return $jBEgJ.gesture;
    }
});

var $64ayr = parcelRequire("64ayr");
Object.defineProperty(module.exports, "gift", {
    enumerable: true,
    get: function() {
        return $64ayr.gift;
    }
});

var $d1InZ = parcelRequire("d1InZ");
Object.defineProperty(module.exports, "headphones", {
    enumerable: true,
    get: function() {
        return $d1InZ.headphones;
    }
});

var $l0149 = parcelRequire("l0149");
Object.defineProperty(module.exports, "heart", {
    enumerable: true,
    get: function() {
        return $l0149.heart;
    }
});

var $3IuTb = parcelRequire("3IuTb");
Object.defineProperty(module.exports, "home", {
    enumerable: true,
    get: function() {
        return $3IuTb.home;
    }
});

var $jYj4a = parcelRequire("jYj4a");
Object.defineProperty(module.exports, "home_chart", {
    enumerable: true,
    get: function() {
        return $jYj4a.home_chart;
    }
});

var $eXgN2 = parcelRequire("eXgN2");
Object.defineProperty(module.exports, "home_checkmark", {
    enumerable: true,
    get: function() {
        return $eXgN2.home_checkmark;
    }
});

var $e9Yes = parcelRequire("e9Yes");
Object.defineProperty(module.exports, "home_compare", {
    enumerable: true,
    get: function() {
        return $e9Yes.home_compare;
    }
});

var $cOdlU = parcelRequire("cOdlU");
Object.defineProperty(module.exports, "home_dollar", {
    enumerable: true,
    get: function() {
        return $cOdlU.home_dollar;
    }
});

var $h6egG = parcelRequire("h6egG");
Object.defineProperty(module.exports, "home_heart", {
    enumerable: true,
    get: function() {
        return $h6egG.home_heart;
    }
});

var $e08mP = parcelRequire("e08mP");
Object.defineProperty(module.exports, "home_multi", {
    enumerable: true,
    get: function() {
        return $e08mP.home_multi;
    }
});

var $c1fXO = parcelRequire("c1fXO");
Object.defineProperty(module.exports, "home_percentage", {
    enumerable: true,
    get: function() {
        return $c1fXO.home_percentage;
    }
});

var $aBnAF = parcelRequire("aBnAF");
Object.defineProperty(module.exports, "house_mobile", {
    enumerable: true,
    get: function() {
        return $aBnAF.house_mobile;
    }
});

var $irMww = parcelRequire("irMww");
Object.defineProperty(module.exports, "import_icon", {
    enumerable: true,
    get: function() {
        return $irMww.import_icon;
    }
});

var $3NUQC = parcelRequire("3NUQC");
Object.defineProperty(module.exports, "inbox", {
    enumerable: true,
    get: function() {
        return $3NUQC.inbox;
    }
});

var $4R2Eq = parcelRequire("4R2Eq");
Object.defineProperty(module.exports, "key", {
    enumerable: true,
    get: function() {
        return $4R2Eq.key;
    }
});

var $7Ar53 = parcelRequire("7Ar53");
Object.defineProperty(module.exports, "key_hand", {
    enumerable: true,
    get: function() {
        return $7Ar53.key_hand;
    }
});

var $4tri9 = parcelRequire("4tri9");
Object.defineProperty(module.exports, "launch", {
    enumerable: true,
    get: function() {
        return $4tri9.launch;
    }
});

var $THfZM = parcelRequire("THfZM");
Object.defineProperty(module.exports, "lightbulb", {
    enumerable: true,
    get: function() {
        return $THfZM.lightbulb;
    }
});

var $dOzDc = parcelRequire("dOzDc");
Object.defineProperty(module.exports, "line_chart", {
    enumerable: true,
    get: function() {
        return $dOzDc.line_chart;
    }
});

var $ciFVb = parcelRequire("ciFVb");
Object.defineProperty(module.exports, "line_chart_loop", {
    enumerable: true,
    get: function() {
        return $ciFVb.line_chart_loop;
    }
});

var $gJc0v = parcelRequire("gJc0v");
Object.defineProperty(module.exports, "link", {
    enumerable: true,
    get: function() {
        return $gJc0v.link;
    }
});

var $9nL4t = parcelRequire("9nL4t");
Object.defineProperty(module.exports, "list", {
    enumerable: true,
    get: function() {
        return $9nL4t.list;
    }
});

var $go5PS = parcelRequire("go5PS");
Object.defineProperty(module.exports, "list_reorder", {
    enumerable: true,
    get: function() {
        return $go5PS.list_reorder;
    }
});

var $4DKx9 = parcelRequire("4DKx9");
Object.defineProperty(module.exports, "location", {
    enumerable: true,
    get: function() {
        return $4DKx9.location;
    }
});

var $3j79U = parcelRequire("3j79U");
Object.defineProperty(module.exports, "lock", {
    enumerable: true,
    get: function() {
        return $3j79U.lock;
    }
});

var $Gufh1 = parcelRequire("Gufh1");
Object.defineProperty(module.exports, "lock_unlock", {
    enumerable: true,
    get: function() {
        return $Gufh1.lock_unlock;
    }
});

var $llPjL = parcelRequire("llPjL");
Object.defineProperty(module.exports, "lockbox", {
    enumerable: true,
    get: function() {
        return $llPjL.lockbox;
    }
});

var $hmpDM = parcelRequire("hmpDM");
Object.defineProperty(module.exports, "lot", {
    enumerable: true,
    get: function() {
        return $hmpDM.lot;
    }
});

var $jWifa = parcelRequire("jWifa");
Object.defineProperty(module.exports, "magnet", {
    enumerable: true,
    get: function() {
        return $jWifa.magnet;
    }
});

var $gDslQ = parcelRequire("gDslQ");
Object.defineProperty(module.exports, "map", {
    enumerable: true,
    get: function() {
        return $gDslQ.map;
    }
});

var $lwNnv = parcelRequire("lwNnv");
Object.defineProperty(module.exports, "map_area", {
    enumerable: true,
    get: function() {
        return $lwNnv.map_area;
    }
});

var $28k1Y = parcelRequire("28k1Y");
Object.defineProperty(module.exports, "map_pin", {
    enumerable: true,
    get: function() {
        return $28k1Y.map_pin;
    }
});

var $7SlIE = parcelRequire("7SlIE");
Object.defineProperty(module.exports, "matching_buyers", {
    enumerable: true,
    get: function() {
        return $7SlIE.matching_buyers;
    }
});

var $hT3KA = parcelRequire("hT3KA");
Object.defineProperty(module.exports, "megaphone", {
    enumerable: true,
    get: function() {
        return $hT3KA.megaphone;
    }
});

var $iDqCu = parcelRequire("iDqCu");
Object.defineProperty(module.exports, "menu", {
    enumerable: true,
    get: function() {
        return $iDqCu.menu;
    }
});

var $2XxA1 = parcelRequire("2XxA1");
Object.defineProperty(module.exports, "merge", {
    enumerable: true,
    get: function() {
        return $2XxA1.merge;
    }
});

var $bvQE4 = parcelRequire("bvQE4");
Object.defineProperty(module.exports, "message_new", {
    enumerable: true,
    get: function() {
        return $bvQE4.message_new;
    }
});

var $koeiW = parcelRequire("koeiW");
Object.defineProperty(module.exports, "minus", {
    enumerable: true,
    get: function() {
        return $koeiW.minus;
    }
});

var $iUECL = parcelRequire("iUECL");
Object.defineProperty(module.exports, "more_horizontal", {
    enumerable: true,
    get: function() {
        return $iUECL.more_horizontal;
    }
});

var $6NGtK = parcelRequire("6NGtK");
Object.defineProperty(module.exports, "more_vertical", {
    enumerable: true,
    get: function() {
        return $6NGtK.more_vertical;
    }
});

var $6J0V7 = parcelRequire("6J0V7");
Object.defineProperty(module.exports, "number_range", {
    enumerable: true,
    get: function() {
        return $6J0V7.number_range;
    }
});

var $cKlEE = parcelRequire("cKlEE");
Object.defineProperty(module.exports, "open_door", {
    enumerable: true,
    get: function() {
        return $cKlEE.open_door;
    }
});

var $92t4f = parcelRequire("92t4f");
Object.defineProperty(module.exports, "origin", {
    enumerable: true,
    get: function() {
        return $92t4f.origin;
    }
});

var $aRal3 = parcelRequire("aRal3");
Object.defineProperty(module.exports, "outbox", {
    enumerable: true,
    get: function() {
        return $aRal3.outbox;
    }
});

var $18xEn = parcelRequire("18xEn");
Object.defineProperty(module.exports, "paperclip", {
    enumerable: true,
    get: function() {
        return $18xEn.paperclip;
    }
});

var $1jMRV = parcelRequire("1jMRV");
Object.defineProperty(module.exports, "pencil", {
    enumerable: true,
    get: function() {
        return $1jMRV.pencil;
    }
});

var $h0X8z = parcelRequire("h0X8z");
Object.defineProperty(module.exports, "percentage", {
    enumerable: true,
    get: function() {
        return $h0X8z.percentage;
    }
});

var $lmvsE = parcelRequire("lmvsE");
Object.defineProperty(module.exports, "person_frame", {
    enumerable: true,
    get: function() {
        return $lmvsE.person_frame;
    }
});

var $1luNL = parcelRequire("1luNL");
Object.defineProperty(module.exports, "phone", {
    enumerable: true,
    get: function() {
        return $1luNL.phone;
    }
});

var $h0Gfl = parcelRequire("h0Gfl");
Object.defineProperty(module.exports, "photo", {
    enumerable: true,
    get: function() {
        return $h0Gfl.photo;
    }
});

var $eUUGm = parcelRequire("eUUGm");
Object.defineProperty(module.exports, "piggy", {
    enumerable: true,
    get: function() {
        return $eUUGm.piggy;
    }
});

var $8nBmr = parcelRequire("8nBmr");
Object.defineProperty(module.exports, "play", {
    enumerable: true,
    get: function() {
        return $8nBmr.play;
    }
});

var $7XVsc = parcelRequire("7XVsc");
Object.defineProperty(module.exports, "play_circle", {
    enumerable: true,
    get: function() {
        return $7XVsc.play_circle;
    }
});

var $au8Wq = parcelRequire("au8Wq");
Object.defineProperty(module.exports, "player_video", {
    enumerable: true,
    get: function() {
        return $au8Wq.player_video;
    }
});

var $6XidV = parcelRequire("6XidV");
Object.defineProperty(module.exports, "plug", {
    enumerable: true,
    get: function() {
        return $6XidV.plug;
    }
});

var $aO9gR = parcelRequire("aO9gR");
Object.defineProperty(module.exports, "plus", {
    enumerable: true,
    get: function() {
        return $aO9gR.plus;
    }
});

var $gmMnR = parcelRequire("gmMnR");
Object.defineProperty(module.exports, "plus_small", {
    enumerable: true,
    get: function() {
        return $gmMnR.plus_small;
    }
});

var $9jZDc = parcelRequire("9jZDc");
Object.defineProperty(module.exports, "printer", {
    enumerable: true,
    get: function() {
        return $9jZDc.printer;
    }
});

var $alvyE = parcelRequire("alvyE");
Object.defineProperty(module.exports, "priority_high", {
    enumerable: true,
    get: function() {
        return $alvyE.priority_high;
    }
});

var $i7ieH = parcelRequire("i7ieH");
Object.defineProperty(module.exports, "priority_low", {
    enumerable: true,
    get: function() {
        return $i7ieH.priority_low;
    }
});

var $19JTN = parcelRequire("19JTN");
Object.defineProperty(module.exports, "priority_medium", {
    enumerable: true,
    get: function() {
        return $19JTN.priority_medium;
    }
});

var $hCKVh = parcelRequire("hCKVh");
Object.defineProperty(module.exports, "priority_none", {
    enumerable: true,
    get: function() {
        return $hCKVh.priority_none;
    }
});

var $3fv75 = parcelRequire("3fv75");
Object.defineProperty(module.exports, "reclaim", {
    enumerable: true,
    get: function() {
        return $3fv75.reclaim;
    }
});

var $6yxf0 = parcelRequire("6yxf0");
Object.defineProperty(module.exports, "refresh", {
    enumerable: true,
    get: function() {
        return $6yxf0.refresh;
    }
});

var $624Sz = parcelRequire("624Sz");
Object.defineProperty(module.exports, "resize_to_fit", {
    enumerable: true,
    get: function() {
        return $624Sz.resize_to_fit;
    }
});

var $kRjlz = parcelRequire("kRjlz");
Object.defineProperty(module.exports, "return_icon", {
    enumerable: true,
    get: function() {
        return $kRjlz.return_icon;
    }
});

var $aoZqk = parcelRequire("aoZqk");
Object.defineProperty(module.exports, "robot", {
    enumerable: true,
    get: function() {
        return $aoZqk.robot;
    }
});

var $4v4ez = parcelRequire("4v4ez");
Object.defineProperty(module.exports, "rocket", {
    enumerable: true,
    get: function() {
        return $4v4ez.rocket;
    }
});

var $g2LfV = parcelRequire("g2LfV");
Object.defineProperty(module.exports, "school", {
    enumerable: true,
    get: function() {
        return $g2LfV.school;
    }
});

var $joNl0 = parcelRequire("joNl0");
Object.defineProperty(module.exports, "screen_bar_chart", {
    enumerable: true,
    get: function() {
        return $joNl0.screen_bar_chart;
    }
});

var $1QG2B = parcelRequire("1QG2B");
Object.defineProperty(module.exports, "screen_line_chart", {
    enumerable: true,
    get: function() {
        return $1QG2B.screen_line_chart;
    }
});

var $a47qu = parcelRequire("a47qu");
Object.defineProperty(module.exports, "screen_percentage", {
    enumerable: true,
    get: function() {
        return $a47qu.screen_percentage;
    }
});

var $ajU2M = parcelRequire("ajU2M");
Object.defineProperty(module.exports, "search", {
    enumerable: true,
    get: function() {
        return $ajU2M.search;
    }
});

var $a6dbX = parcelRequire("a6dbX");
Object.defineProperty(module.exports, "search_home", {
    enumerable: true,
    get: function() {
        return $a6dbX.search_home;
    }
});

var $85EyZ = parcelRequire("85EyZ");
Object.defineProperty(module.exports, "search_user", {
    enumerable: true,
    get: function() {
        return $85EyZ.search_user;
    }
});

var $kxnBr = parcelRequire("kxnBr");
Object.defineProperty(module.exports, "send", {
    enumerable: true,
    get: function() {
        return $kxnBr.send;
    }
});

var $3nx1a = parcelRequire("3nx1a");
Object.defineProperty(module.exports, "share", {
    enumerable: true,
    get: function() {
        return $3nx1a.share;
    }
});

var $jCuzm = parcelRequire("jCuzm");
Object.defineProperty(module.exports, "shared", {
    enumerable: true,
    get: function() {
        return $jCuzm.shared;
    }
});

var $47Lu5 = parcelRequire("47Lu5");
Object.defineProperty(module.exports, "shield_home", {
    enumerable: true,
    get: function() {
        return $47Lu5.shield_home;
    }
});

var $jN4XK = parcelRequire("jN4XK");
Object.defineProperty(module.exports, "shield_key", {
    enumerable: true,
    get: function() {
        return $jN4XK.shield_key;
    }
});

var $8mfWi = parcelRequire("8mfWi");
Object.defineProperty(module.exports, "shopping_cart", {
    enumerable: true,
    get: function() {
        return $8mfWi.shopping_cart;
    }
});

var $esh5S = parcelRequire("esh5S");
Object.defineProperty(module.exports, "shopping_cart_filled", {
    enumerable: true,
    get: function() {
        return $esh5S.shopping_cart_filled;
    }
});

var $kqQ4e = parcelRequire("kqQ4e");
Object.defineProperty(module.exports, "short_text", {
    enumerable: true,
    get: function() {
        return $kqQ4e.short_text;
    }
});

var $9DSTk = parcelRequire("9DSTk");
Object.defineProperty(module.exports, "sign_for_sale", {
    enumerable: true,
    get: function() {
        return $9DSTk.sign_for_sale;
    }
});

var $2Ha6Q = parcelRequire("2Ha6Q");
Object.defineProperty(module.exports, "sign_in_ground", {
    enumerable: true,
    get: function() {
        return $2Ha6Q.sign_in_ground;
    }
});

var $5LQhS = parcelRequire("5LQhS");
Object.defineProperty(module.exports, "sign_sold", {
    enumerable: true,
    get: function() {
        return $5LQhS.sign_sold;
    }
});

var $fvC70 = parcelRequire("fvC70");
Object.defineProperty(module.exports, "signature", {
    enumerable: true,
    get: function() {
        return $fvC70.signature;
    }
});

var $boMbJ = parcelRequire("boMbJ");
Object.defineProperty(module.exports, "skip_left", {
    enumerable: true,
    get: function() {
        return $boMbJ.skip_left;
    }
});

var $ixX97 = parcelRequire("ixX97");
Object.defineProperty(module.exports, "skip_right", {
    enumerable: true,
    get: function() {
        return $ixX97.skip_right;
    }
});

var $1GVCE = parcelRequire("1GVCE");
Object.defineProperty(module.exports, "smiley_negative_one", {
    enumerable: true,
    get: function() {
        return $1GVCE.smiley_negative_one;
    }
});

var $hwxl8 = parcelRequire("hwxl8");
Object.defineProperty(module.exports, "smiley_negative_two", {
    enumerable: true,
    get: function() {
        return $hwxl8.smiley_negative_two;
    }
});

var $aWf08 = parcelRequire("aWf08");
Object.defineProperty(module.exports, "smiley_neutral", {
    enumerable: true,
    get: function() {
        return $aWf08.smiley_neutral;
    }
});

var $ah7Tz = parcelRequire("ah7Tz");
Object.defineProperty(module.exports, "smiley_positive_one", {
    enumerable: true,
    get: function() {
        return $ah7Tz.smiley_positive_one;
    }
});

var $5wNJG = parcelRequire("5wNJG");
Object.defineProperty(module.exports, "smiley_positive_two", {
    enumerable: true,
    get: function() {
        return $5wNJG.smiley_positive_two;
    }
});

var $6jFYP = parcelRequire("6jFYP");
Object.defineProperty(module.exports, "source", {
    enumerable: true,
    get: function() {
        return $6jFYP.source;
    }
});

var $hlhZO = parcelRequire("hlhZO");
Object.defineProperty(module.exports, "sparkle", {
    enumerable: true,
    get: function() {
        return $hlhZO.sparkle;
    }
});

var $7J7Wa = parcelRequire("7J7Wa");
Object.defineProperty(module.exports, "spinner", {
    enumerable: true,
    get: function() {
        return $7J7Wa.spinner;
    }
});

var $9oj5b = parcelRequire("9oj5b");
Object.defineProperty(module.exports, "split", {
    enumerable: true,
    get: function() {
        return $9oj5b.split;
    }
});

var $39yPo = parcelRequire("39yPo");
Object.defineProperty(module.exports, "stamp", {
    enumerable: true,
    get: function() {
        return $39yPo.stamp;
    }
});

var $fBXWV = parcelRequire("fBXWV");
Object.defineProperty(module.exports, "star", {
    enumerable: true,
    get: function() {
        return $fBXWV.star;
    }
});

var $peqr9 = parcelRequire("peqr9");
Object.defineProperty(module.exports, "star_rising", {
    enumerable: true,
    get: function() {
        return $peqr9.star_rising;
    }
});

var $BBebc = parcelRequire("BBebc");
Object.defineProperty(module.exports, "status", {
    enumerable: true,
    get: function() {
        return $BBebc.status;
    }
});

var $gI7A8 = parcelRequire("gI7A8");
Object.defineProperty(module.exports, "sticky_note", {
    enumerable: true,
    get: function() {
        return $gI7A8.sticky_note;
    }
});

var $jCNve = parcelRequire("jCNve");
Object.defineProperty(module.exports, "store", {
    enumerable: true,
    get: function() {
        return $jCNve.store;
    }
});

var $3xmho = parcelRequire("3xmho");
Object.defineProperty(module.exports, "string_range", {
    enumerable: true,
    get: function() {
        return $3xmho.string_range;
    }
});

var $1WLRK = parcelRequire("1WLRK");
Object.defineProperty(module.exports, "tags", {
    enumerable: true,
    get: function() {
        return $1WLRK.tags;
    }
});

var $2qIwW = parcelRequire("2qIwW");
Object.defineProperty(module.exports, "tbd", {
    enumerable: true,
    get: function() {
        return $2qIwW.tbd;
    }
});

var $jejxV = parcelRequire("jejxV");
Object.defineProperty(module.exports, "template_apply", {
    enumerable: true,
    get: function() {
        return $jejxV.template_apply;
    }
});

var $8tbck = parcelRequire("8tbck");
Object.defineProperty(module.exports, "text_message", {
    enumerable: true,
    get: function() {
        return $8tbck.text_message;
    }
});

var $cdT1D = parcelRequire("cdT1D");
Object.defineProperty(module.exports, "thumb_down", {
    enumerable: true,
    get: function() {
        return $cdT1D.thumb_down;
    }
});

var $fsK0o = parcelRequire("fsK0o");
Object.defineProperty(module.exports, "thumb_up", {
    enumerable: true,
    get: function() {
        return $fsK0o.thumb_up;
    }
});

var $eCOFn = parcelRequire("eCOFn");
Object.defineProperty(module.exports, "title", {
    enumerable: true,
    get: function() {
        return $eCOFn.title;
    }
});

var $ef610 = parcelRequire("ef610");
Object.defineProperty(module.exports, "to_dos", {
    enumerable: true,
    get: function() {
        return $ef610.to_dos;
    }
});

var $dFdoQ = parcelRequire("dFdoQ");
Object.defineProperty(module.exports, "toolkit", {
    enumerable: true,
    get: function() {
        return $dFdoQ.toolkit;
    }
});

var $9nYg5 = parcelRequire("9nYg5");
Object.defineProperty(module.exports, "tour", {
    enumerable: true,
    get: function() {
        return $9nYg5.tour;
    }
});

var $8kd71 = parcelRequire("8kd71");
Object.defineProperty(module.exports, "transaction_workflow", {
    enumerable: true,
    get: function() {
        return $8kd71.transaction_workflow;
    }
});

var $27YaX = parcelRequire("27YaX");
Object.defineProperty(module.exports, "trash_can", {
    enumerable: true,
    get: function() {
        return $27YaX.trash_can;
    }
});

var $9rGW6 = parcelRequire("9rGW6");
Object.defineProperty(module.exports, "user", {
    enumerable: true,
    get: function() {
        return $9rGW6.user;
    }
});

var $9oteB = parcelRequire("9oteB");
Object.defineProperty(module.exports, "version_history", {
    enumerable: true,
    get: function() {
        return $9oteB.version_history;
    }
});

var $ksSRu = parcelRequire("ksSRu");
Object.defineProperty(module.exports, "video_library", {
    enumerable: true,
    get: function() {
        return $ksSRu.video_library;
    }
});

var $exnNp = parcelRequire("exnNp");
Object.defineProperty(module.exports, "user_edit", {
    enumerable: true,
    get: function() {
        return $exnNp.user_edit;
    }
});

var $jvnZT = parcelRequire("jvnZT");
Object.defineProperty(module.exports, "warning", {
    enumerable: true,
    get: function() {
        return $jvnZT.warning;
    }
});

var $31YAT = parcelRequire("31YAT");
Object.defineProperty(module.exports, "wolfie", {
    enumerable: true,
    get: function() {
        return $31YAT.wolfie;
    }
});

var $leV5G = parcelRequire("leV5G");
Object.defineProperty(module.exports, "workspace", {
    enumerable: true,
    get: function() {
        return $leV5G.workspace;
    }
});

var $27kwO = parcelRequire("27kwO");
Object.defineProperty(module.exports, "x", {
    enumerable: true,
    get: function() {
        return $27kwO.x;
    }
});

var $4vh7q = parcelRequire("4vh7q");
Object.defineProperty(module.exports, "x_small", {
    enumerable: true,
    get: function() {
        return $4vh7q.x_small;
    }
});

var $1dGb2 = parcelRequire("1dGb2");
Object.defineProperty(module.exports, "zillow", {
    enumerable: true,
    get: function() {
        return $1dGb2.zillow;
    }
});

var $7P9zw = parcelRequire("7P9zw");
Object.defineProperty(module.exports, "zoom_in", {
    enumerable: true,
    get: function() {
        return $7P9zw.zoom_in;
    }
});

var $3Em02 = parcelRequire("3Em02");
Object.defineProperty(module.exports, "zoom_out", {
    enumerable: true,
    get: function() {
        return $3Em02.zoom_out;
    }
});

});
parcelRegister("3EHnm", function(module, exports) {
"use strict";
var $2a96c10b84db9416$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $2a96c10b84db9416$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.add_to_list = void 0;

/* eslint-disable max-len */ const $2a96c10b84db9416$var$react_1 = $2a96c10b84db9416$var$__importDefault((parcelRequire("acw62")));

const $2a96c10b84db9416$var$classnames_1 = $2a96c10b84db9416$var$__importDefault((parcelRequire("8g1PZ")));
const $2a96c10b84db9416$var$add_to_list = (_a)=>{
    var { className: className } = _a, rest = $2a96c10b84db9416$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $2a96c10b84db9416$var$classnames_1.default)("helix-icon", "arrow-left-outlined", className);
    return $2a96c10b84db9416$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, rest), $2a96c10b84db9416$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 10C7.75 9.58579 8.08579 9.25 8.5 9.25H17C17.4142 9.25 17.75 9.58579 17.75 10C17.75 10.4142 17.4142 10.75 17 10.75H8.5C8.08579 10.75 7.75 10.4142 7.75 10Z",
        fill: "#4B5563"
    }), $2a96c10b84db9416$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 5C7.75 4.58579 8.08579 4.25 8.5 4.25L17 4.25C17.4142 4.25 17.75 4.58579 17.75 5C17.75 5.41421 17.4142 5.75 17 5.75H8.5C8.08579 5.75 7.75 5.41421 7.75 5Z",
        fill: "#4B5563"
    }), $2a96c10b84db9416$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 15C7.75 14.5858 8.08579 14.25 8.5 14.25H17C17.4142 14.25 17.75 14.5858 17.75 15C17.75 15.4142 17.4142 15.75 17 15.75H8.5C8.08579 15.75 7.75 15.4142 7.75 15Z",
        fill: "#4B5563"
    }), $2a96c10b84db9416$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.5 17.25C4.08579 17.25 3.75 16.9142 3.75 16.5L3.75 13.5C3.75 13.0858 4.08579 12.75 4.5 12.75C4.91421 12.75 5.25 13.0858 5.25 13.5L5.25 16.5C5.25 16.9142 4.91421 17.25 4.5 17.25Z",
        fill: "#4B5563"
    }), $2a96c10b84db9416$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.25 15C2.25 14.5858 2.58579 14.25 3 14.25H6C6.41421 14.25 6.75 14.5858 6.75 15C6.75 15.4142 6.41421 15.75 6 15.75H3C2.58579 15.75 2.25 15.4142 2.25 15Z",
        fill: "#4B5563"
    }), $2a96c10b84db9416$var$react_1.default.createElement("path", {
        d: "M6 10C6 10.8284 5.32843 11.5 4.5 11.5C3.67157 11.5 3 10.8284 3 10C3 9.17157 3.67157 8.5 4.5 8.5C5.32843 8.5 6 9.17157 6 10Z",
        fill: "#4B5563"
    }), $2a96c10b84db9416$var$react_1.default.createElement("path", {
        d: "M6 5C6 5.82843 5.32843 6.5 4.5 6.5C3.67157 6.5 3 5.82843 3 5C3 4.17157 3.67157 3.5 4.5 3.5C5.32843 3.5 6 4.17157 6 5Z",
        fill: "#4B5563"
    }));
};
module.exports.add_to_list = $2a96c10b84db9416$var$add_to_list;

});

parcelRegister("51hrN", function(module, exports) {
"use strict";
var $3a7a9469ea453df9$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $3a7a9469ea453df9$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.add_user = void 0;

/* eslint-disable max-len */ const $3a7a9469ea453df9$var$classnames_1 = $3a7a9469ea453df9$var$__importDefault((parcelRequire("8g1PZ")));

const $3a7a9469ea453df9$var$react_1 = $3a7a9469ea453df9$var$__importDefault((parcelRequire("acw62")));
const $3a7a9469ea453df9$var$add_user = (_a)=>{
    var { className: className } = _a, rest = $3a7a9469ea453df9$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $3a7a9469ea453df9$var$classnames_1.default)("helix-icon", "add-user-outlined", className);
    return $3a7a9469ea453df9$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $3a7a9469ea453df9$var$react_1.default.createElement("path", {
        d: "M14.25 15.5566C14.25 15.033 14.0894 14.6192 13.8291 14.3428C13.5766 14.0746 13.1624 13.8624 12.502 13.8623H7.50488C6.7856 13.8623 6.42446 14.035 6.20703 14.2988C5.95759 14.6018 5.75 15.1967 5.75 16.3652L5.75293 17.25H14.25V15.5566ZM11.75 9.44531C11.75 8.91102 11.6049 8.50132 11.3584 8.23242C11.1231 7.97584 10.7064 7.75005 9.95215 7.75C9.19863 7.75 8.8165 7.97465 8.6084 8.21582C8.38286 8.47727 8.25 8.88733 8.25 9.44531C8.25012 10.3586 9.01547 11.1406 9.95215 11.1406C10.9264 11.1405 11.7499 10.3217 11.75 9.44531ZM13.25 9.44531C13.2499 10.7513 12.3996 11.8654 11.2588 12.3623H12.502C13.5067 12.3624 14.3417 12.6983 14.9219 13.3145C15.4942 13.9224 15.75 14.7309 15.75 15.5566V18.75H4.25879L4.25 16.3682V16.3652C4.25 15.0902 4.46243 14.058 5.04883 13.3457C5.66726 12.5947 6.55897 12.3623 7.50488 12.3623H8.6543C7.53157 11.8589 6.75009 10.7277 6.75 9.44531C6.75 8.67914 6.92932 7.86627 7.47266 7.23633C8.03378 6.58605 8.87875 6.25 9.95215 6.25C11.0243 6.25005 11.8819 6.5841 12.4639 7.21875C13.0346 7.8413 13.25 8.65518 13.25 9.44531Z",
        fill: "#4B5563"
    }), $3a7a9469ea453df9$var$react_1.default.createElement("path", {
        d: "M14.7857 3.78571V2.35714C14.7857 2.1599 14.9456 2 15.1429 2H15.8571C16.0544 2 16.2143 2.1599 16.2143 2.35714V3.78571H17.6429C17.8401 3.78571 18 3.94561 18 4.14286V4.85714C18 5.05439 17.8401 5.21429 17.6429 5.21429H16.2143V6.64286C16.2143 6.8401 16.0544 7 15.8571 7H15.1429C14.9456 7 14.7857 6.8401 14.7857 6.64286V5.21429H13.3571C13.1599 5.21429 13 5.05439 13 4.85714V4.14286C13 3.94561 13.1599 3.78571 13.3571 3.78571H14.7857Z",
        fill: "#4B5563"
    }));
};
module.exports.add_user = $3a7a9469ea453df9$var$add_user;

});

parcelRegister("6D38h", function(module, exports) {
"use strict";
var $4d38d0a14746b250$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $4d38d0a14746b250$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.agent = void 0;

/* eslint-disable max-len */ const $4d38d0a14746b250$var$classnames_1 = $4d38d0a14746b250$var$__importDefault((parcelRequire("8g1PZ")));

const $4d38d0a14746b250$var$react_1 = $4d38d0a14746b250$var$__importDefault((parcelRequire("acw62")));
const $4d38d0a14746b250$var$agent = (_a)=>{
    var { className: className } = _a, rest = $4d38d0a14746b250$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $4d38d0a14746b250$var$classnames_1.default)("helix-icon", "agent-outlined", className);
    return $4d38d0a14746b250$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $4d38d0a14746b250$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.25 14C3.25 11.3766 5.37665 9.25 8 9.25H12C14.6234 9.25 16.75 11.3766 16.75 14V17C16.75 17.4142 16.4142 17.75 16 17.75H4C3.58579 17.75 3.25 17.4142 3.25 17V14ZM8 10.75C6.20507 10.75 4.75 12.2051 4.75 14V16.25H15.25V14C15.25 12.2051 13.7949 10.75 12 10.75H8Z",
        fill: "#4B5563"
    }), $4d38d0a14746b250$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.25 5C6.25 2.92893 7.92893 1.25 10 1.25C12.0711 1.25 13.75 2.92893 13.75 5V6C13.75 8.07107 12.0711 9.75 10 9.75C7.92893 9.75 6.25 8.07107 6.25 6V5ZM10 2.75C8.75736 2.75 7.75 3.75736 7.75 5V6C7.75 7.24264 8.75736 8.25 10 8.25C11.2426 8.25 12.25 7.24264 12.25 6V5C12.25 3.75736 11.2426 2.75 10 2.75Z",
        fill: "#4B5563"
    }), $4d38d0a14746b250$var$react_1.default.createElement("path", {
        d: "M11 13.5C11 13.2239 11.2239 13 11.5 13H13.5C13.7761 13 14 13.2239 14 13.5C14 13.7761 13.7761 14 13.5 14H11.5C11.2239 14 11 13.7761 11 13.5Z",
        fill: "#4B5563"
    }));
};
module.exports.agent = $4d38d0a14746b250$var$agent;

});

parcelRegister("f56cH", function(module, exports) {
"use strict";
var $afac229500f23882$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $afac229500f23882$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.app_grid = void 0;

/* eslint-disable max-len */ const $afac229500f23882$var$classnames_1 = $afac229500f23882$var$__importDefault((parcelRequire("8g1PZ")));

const $afac229500f23882$var$react_1 = $afac229500f23882$var$__importDefault((parcelRequire("acw62")));
const $afac229500f23882$var$app_grid = (_a)=>{
    var { className: className } = _a, rest = $afac229500f23882$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $afac229500f23882$var$classnames_1.default)("helix-icon", "app-grid", className);
    return $afac229500f23882$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $afac229500f23882$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.5 5C3.5 4.53406 3.5 4.30109 3.57612 4.11732C3.67761 3.87229 3.87229 3.67761 4.11732 3.57612C4.30109 3.5 4.53406 3.5 5 3.5C5.46594 3.5 5.69891 3.5 5.88268 3.57612C6.12771 3.67761 6.32239 3.87229 6.42388 4.11732C6.5 4.30109 6.5 4.53406 6.5 5C6.5 5.46594 6.5 5.69891 6.42388 5.88268C6.32239 6.12771 6.12771 6.32239 5.88268 6.42388C5.69891 6.5 5.46594 6.5 5 6.5C4.53406 6.5 4.30109 6.5 4.11732 6.42388C3.87229 6.32239 3.67761 6.12771 3.57612 5.88268C3.5 5.69891 3.5 5.46594 3.5 5ZM3.5 10C3.5 9.53406 3.5 9.30109 3.57612 9.11732C3.67761 8.87229 3.87229 8.67761 4.11732 8.57612C4.30109 8.5 4.53406 8.5 5 8.5C5.46594 8.5 5.69891 8.5 5.88268 8.57612C6.12771 8.67761 6.32239 8.87229 6.42388 9.11732C6.5 9.30109 6.5 9.53406 6.5 10C6.5 10.4659 6.5 10.6989 6.42388 10.8827C6.32239 11.1277 6.12771 11.3224 5.88268 11.4239C5.69891 11.5 5.46594 11.5 5 11.5C4.53406 11.5 4.30109 11.5 4.11732 11.4239C3.87229 11.3224 3.67761 11.1277 3.57612 10.8827C3.5 10.6989 3.5 10.4659 3.5 10ZM3.57612 14.1173C3.5 14.3011 3.5 14.5341 3.5 15C3.5 15.4659 3.5 15.6989 3.57612 15.8827C3.67761 16.1277 3.87229 16.3224 4.11732 16.4239C4.30109 16.5 4.53406 16.5 5 16.5C5.46594 16.5 5.69891 16.5 5.88268 16.4239C6.12771 16.3224 6.32239 16.1277 6.42388 15.8827C6.5 15.6989 6.5 15.4659 6.5 15C6.5 14.5341 6.5 14.3011 6.42388 14.1173C6.32239 13.8723 6.12771 13.6776 5.88268 13.5761C5.69891 13.5 5.46594 13.5 5 13.5C4.53406 13.5 4.30109 13.5 4.11732 13.5761C3.87229 13.6776 3.67761 13.8723 3.57612 14.1173ZM8.5 5C8.5 4.53406 8.5 4.30109 8.57612 4.11732C8.67761 3.87229 8.87229 3.67761 9.11732 3.57612C9.30109 3.5 9.53406 3.5 10 3.5C10.4659 3.5 10.6989 3.5 10.8827 3.57612C11.1277 3.67761 11.3224 3.87229 11.4239 4.11732C11.5 4.30109 11.5 4.53406 11.5 5C11.5 5.46594 11.5 5.69891 11.4239 5.88268C11.3224 6.12771 11.1277 6.32239 10.8827 6.42388C10.6989 6.5 10.4659 6.5 10 6.5C9.53406 6.5 9.30109 6.5 9.11732 6.42388C8.87229 6.32239 8.67761 6.12771 8.57612 5.88268C8.5 5.69891 8.5 5.46594 8.5 5ZM13.5761 4.11732C13.5 4.30109 13.5 4.53406 13.5 5C13.5 5.46594 13.5 5.69891 13.5761 5.88268C13.6776 6.12771 13.8723 6.32239 14.1173 6.42388C14.3011 6.5 14.5341 6.5 15 6.5C15.4659 6.5 15.6989 6.5 15.8827 6.42388C16.1277 6.32239 16.3224 6.12771 16.4239 5.88268C16.5 5.69891 16.5 5.46594 16.5 5C16.5 4.53406 16.5 4.30109 16.4239 4.11732C16.3224 3.87229 16.1277 3.67761 15.8827 3.57612C15.6989 3.5 15.4659 3.5 15 3.5C14.5341 3.5 14.3011 3.5 14.1173 3.57612C13.8723 3.67761 13.6776 3.87229 13.5761 4.11732ZM8.5 10C8.5 9.53406 8.5 9.30109 8.57612 9.11732C8.67761 8.87229 8.87229 8.67761 9.11732 8.57612C9.30109 8.5 9.53406 8.5 10 8.5C10.4659 8.5 10.6989 8.5 10.8827 8.57612C11.1277 8.67761 11.3224 8.87229 11.4239 9.11732C11.5 9.30109 11.5 9.53406 11.5 10C11.5 10.4659 11.5 10.6989 11.4239 10.8827C11.3224 11.1277 11.1277 11.3224 10.8827 11.4239C10.6989 11.5 10.4659 11.5 10 11.5C9.53406 11.5 9.30109 11.5 9.11732 11.4239C8.87229 11.3224 8.67761 11.1277 8.57612 10.8827C8.5 10.6989 8.5 10.4659 8.5 10ZM8.57612 14.1173C8.5 14.3011 8.5 14.5341 8.5 15C8.5 15.4659 8.5 15.6989 8.57612 15.8827C8.67761 16.1277 8.87229 16.3224 9.11732 16.4239C9.30109 16.5 9.53406 16.5 10 16.5C10.4659 16.5 10.6989 16.5 10.8827 16.4239C11.1277 16.3224 11.3224 16.1277 11.4239 15.8827C11.5 15.6989 11.5 15.4659 11.5 15C11.5 14.5341 11.5 14.3011 11.4239 14.1173C11.3224 13.8723 11.1277 13.6776 10.8827 13.5761C10.6989 13.5 10.4659 13.5 10 13.5C9.53406 13.5 9.30109 13.5 9.11732 13.5761C8.87229 13.6776 8.67761 13.8723 8.57612 14.1173ZM13.5 10C13.5 9.53406 13.5 9.30109 13.5761 9.11732C13.6776 8.87229 13.8723 8.67761 14.1173 8.57612C14.3011 8.5 14.5341 8.5 15 8.5C15.4659 8.5 15.6989 8.5 15.8827 8.57612C16.1277 8.67761 16.3224 8.87229 16.4239 9.11732C16.5 9.30109 16.5 9.53406 16.5 10C16.5 10.4659 16.5 10.6989 16.4239 10.8827C16.3224 11.1277 16.1277 11.3224 15.8827 11.4239C15.6989 11.5 15.4659 11.5 15 11.5C14.5341 11.5 14.3011 11.5 14.1173 11.4239C13.8723 11.3224 13.6776 11.1277 13.5761 10.8827C13.5 10.6989 13.5 10.4659 13.5 10ZM13.5761 14.1173C13.5 14.3011 13.5 14.5341 13.5 15C13.5 15.4659 13.5 15.6989 13.5761 15.8827C13.6776 16.1277 13.8723 16.3224 14.1173 16.4239C14.3011 16.5 14.5341 16.5 15 16.5C15.4659 16.5 15.6989 16.5 15.8827 16.4239C16.1277 16.3224 16.3224 16.1277 16.4239 15.8827C16.5 15.6989 16.5 15.4659 16.5 15C16.5 14.5341 16.5 14.3011 16.4239 14.1173C16.3224 13.8723 16.1277 13.6776 15.8827 13.5761C15.6989 13.5 15.4659 13.5 15 13.5C14.5341 13.5 14.3011 13.5 14.1173 13.5761C13.8723 13.6776 13.6776 13.8723 13.5761 14.1173Z",
        fill: "#4B5563"
    }));
};
module.exports.app_grid = $afac229500f23882$var$app_grid;

});

parcelRegister("iKYYs", function(module, exports) {
"use strict";
var $da7bd210af5fdce7$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $da7bd210af5fdce7$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.archive = void 0;

/* eslint-disable max-len */ const $da7bd210af5fdce7$var$classnames_1 = $da7bd210af5fdce7$var$__importDefault((parcelRequire("8g1PZ")));

const $da7bd210af5fdce7$var$react_1 = $da7bd210af5fdce7$var$__importDefault((parcelRequire("acw62")));
const $da7bd210af5fdce7$var$archive = (_a)=>{
    var { className: className } = _a, rest = $da7bd210af5fdce7$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $da7bd210af5fdce7$var$classnames_1.default)("helix-icon", "archive-outlined", className);
    return $da7bd210af5fdce7$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $da7bd210af5fdce7$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.25 5.5C2.25 4.5335 3.0335 3.75 4 3.75H16C16.9665 3.75 17.75 4.5335 17.75 5.5V7.75H2.25V5.5ZM4 5.25C3.86193 5.25 3.75 5.36193 3.75 5.5V6.25H16.25V5.5C16.25 5.36193 16.1381 5.25 16 5.25H4ZM3.25 14.5V8.5H4.75V14.5C4.75 14.9142 5.08579 15.25 5.5 15.25H14.5C14.9142 15.25 15.25 14.9142 15.25 14.5V8.5H16.75V14.5C16.75 15.7426 15.7426 16.75 14.5 16.75H5.5C4.25736 16.75 3.25 15.7426 3.25 14.5ZM7.5 11.25C7.5 10.8358 7.83579 10.5 8.25 10.5H11.75C12.1642 10.5 12.5 10.8358 12.5 11.25C12.5 11.6642 12.1642 12 11.75 12H8.25C7.83579 12 7.5 11.6642 7.5 11.25Z",
        fill: "#4B5563"
    }));
};
module.exports.archive = $da7bd210af5fdce7$var$archive;

});

parcelRegister("eL8rR", function(module, exports) {
"use strict";
var $abec022350ae69ac$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $abec022350ae69ac$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.archive_restore = void 0;

/* eslint-disable max-len */ const $abec022350ae69ac$var$classnames_1 = $abec022350ae69ac$var$__importDefault((parcelRequire("8g1PZ")));

const $abec022350ae69ac$var$react_1 = $abec022350ae69ac$var$__importDefault((parcelRequire("acw62")));
const $abec022350ae69ac$var$archive_restore = (_a)=>{
    var { className: className } = _a, rest = $abec022350ae69ac$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $abec022350ae69ac$var$classnames_1.default)("helix-icon", "archive-restore-outlined", className);
    return $abec022350ae69ac$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $abec022350ae69ac$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.25 14.5V8.5H4.75V14.5C4.75 14.9142 5.08579 15.25 5.5 15.25H14.5C14.9142 15.25 15.25 14.9142 15.25 14.5V8.5H16.75V14.5C16.75 15.7426 15.7426 16.75 14.5 16.75H5.5C4.25736 16.75 3.25 15.7426 3.25 14.5Z",
        fill: "#4B5563"
    }), $abec022350ae69ac$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.46967 12.0303C7.76256 12.3232 8.23744 12.3232 8.53033 12.0303L10 10.5607L11.4697 12.0303C11.7626 12.3232 12.2374 12.3232 12.5303 12.0303C12.8232 11.7374 12.8232 11.2626 12.5303 10.9697L10.5303 8.96967C10.2374 8.67678 9.76256 8.67678 9.46967 8.96967L7.46967 10.9697C7.17678 11.2626 7.17678 11.7374 7.46967 12.0303Z",
        fill: "#4B5563"
    }), $abec022350ae69ac$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 14.25C10.4142 14.25 10.75 13.9142 10.75 13.5V10C10.75 9.58579 10.4142 9.25 10 9.25C9.58579 9.25 9.25 9.58579 9.25 10V13.5C9.25 13.9142 9.58579 14.25 10 14.25Z",
        fill: "#4B5563"
    }), $abec022350ae69ac$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.25 5.5C2.25 4.5335 3.0335 3.75 4 3.75H16C16.9665 3.75 17.75 4.5335 17.75 5.5V7C17.75 7.41421 17.4142 7.75 17 7.75H3C2.58579 7.75 2.25 7.41421 2.25 7V5.5ZM4 5.25C3.86193 5.25 3.75 5.36193 3.75 5.5V6.25H16.25V5.5C16.25 5.36193 16.1381 5.25 16 5.25H4Z",
        fill: "#4B5563"
    }));
};
module.exports.archive_restore = $abec022350ae69ac$var$archive_restore;

});

parcelRegister("fuVX7", function(module, exports) {
"use strict";
var $b4869c7f72f645ed$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $b4869c7f72f645ed$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.arrow_chart_line = void 0;

/* eslint-disable max-len */ const $b4869c7f72f645ed$var$react_1 = $b4869c7f72f645ed$var$__importDefault((parcelRequire("acw62")));

const $b4869c7f72f645ed$var$classnames_1 = $b4869c7f72f645ed$var$__importDefault((parcelRequire("8g1PZ")));
const $b4869c7f72f645ed$var$arrow_chart_line = (_a)=>{
    var { className: className } = _a, rest = $b4869c7f72f645ed$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $b4869c7f72f645ed$var$classnames_1.default)("helix-icon", "arrow-chart-line-outlined", className);
    return $b4869c7f72f645ed$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $b4869c7f72f645ed$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.5303 5.21967C17.8232 5.51256 17.8232 5.98744 17.5303 6.28033L11.0303 12.7803C10.7374 13.0732 10.2626 13.0732 9.96967 12.7803L8 10.8107L3.53033 15.2803C3.23744 15.5732 2.76256 15.5732 2.46967 15.2803C2.17678 14.9874 2.17678 14.5126 2.46967 14.2197L7.46967 9.21967C7.76256 8.92678 8.23744 8.92678 8.53033 9.21967L10.5 11.1893L16.4697 5.21967C16.7626 4.92678 17.2374 4.92678 17.5303 5.21967Z",
        fill: "#4B5563"
    }), $b4869c7f72f645ed$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.25 5.75C12.25 5.33579 12.5858 5 13 5L17 5C17.4142 5 17.75 5.33579 17.75 5.75V9.75C17.75 10.1642 17.4142 10.5 17 10.5C16.5858 10.5 16.25 10.1642 16.25 9.75V6.5L13 6.5C12.5858 6.5 12.25 6.16421 12.25 5.75Z",
        fill: "#4B5563"
    }));
};
module.exports.arrow_chart_line = $b4869c7f72f645ed$var$arrow_chart_line;

});

parcelRegister("8ECmc", function(module, exports) {
"use strict";
var $64cfd013d5479adc$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $64cfd013d5479adc$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.arrow_chart_line_down = void 0;

/* eslint-disable max-len */ const $64cfd013d5479adc$var$react_1 = $64cfd013d5479adc$var$__importDefault((parcelRequire("acw62")));

const $64cfd013d5479adc$var$classnames_1 = $64cfd013d5479adc$var$__importDefault((parcelRequire("8g1PZ")));
const $64cfd013d5479adc$var$arrow_chart_line_down = (_a)=>{
    var { className: className } = _a, rest = $64cfd013d5479adc$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $64cfd013d5479adc$var$classnames_1.default)("helix-icon", "arrow-chart-line-down-outlined", className);
    return $64cfd013d5479adc$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $64cfd013d5479adc$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.5303 15.2803C17.8232 14.9874 17.8232 14.5126 17.5303 14.2197L11.0303 7.71967C10.7374 7.42678 10.2626 7.42678 9.96967 7.71967L8 9.68934L3.53033 5.21967C3.23744 4.92678 2.76256 4.92678 2.46967 5.21967C2.17678 5.51256 2.17678 5.98744 2.46967 6.28033L7.46967 11.2803C7.76256 11.5732 8.23744 11.5732 8.53033 11.2803L10.5 9.31066L16.4697 15.2803C16.7626 15.5732 17.2374 15.5732 17.5303 15.2803Z",
        fill: "#4B5563"
    }), $64cfd013d5479adc$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.25 14.75C12.25 15.1642 12.5858 15.5 13 15.5L17 15.5C17.4142 15.5 17.75 15.1642 17.75 14.75V10.75C17.75 10.3358 17.4142 10 17 10C16.5858 10 16.25 10.3358 16.25 10.75V14L13 14C12.5858 14 12.25 14.3358 12.25 14.75Z",
        fill: "#4B5563"
    }));
};
module.exports.arrow_chart_line_down = $64cfd013d5479adc$var$arrow_chart_line_down;

});

parcelRegister("7Ag4v", function(module, exports) {
"use strict";
var $58585cb6785472a6$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $58585cb6785472a6$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.arrow_down = void 0;

/* eslint-disable max-len */ const $58585cb6785472a6$var$react_1 = $58585cb6785472a6$var$__importDefault((parcelRequire("acw62")));

const $58585cb6785472a6$var$classnames_1 = $58585cb6785472a6$var$__importDefault((parcelRequire("8g1PZ")));
const $58585cb6785472a6$var$arrow_down = (_a)=>{
    var { className: className } = _a, rest = $58585cb6785472a6$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $58585cb6785472a6$var$classnames_1.default)("helix-icon", "arrow-down-outlined", className);
    return $58585cb6785472a6$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $58585cb6785472a6$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.5303 16.5303C10.2374 16.8232 9.76256 16.8232 9.46967 16.5303L4.6967 11.7574C4.4038 11.4645 4.4038 10.9896 4.6967 10.6967C4.98959 10.4038 5.46446 10.4038 5.75736 10.6967L9.25 14.1893L9.25 4C9.25 3.58579 9.58578 3.25 10 3.25C10.4142 3.25 10.75 3.58579 10.75 4L10.75 14.1893L14.2426 10.6967C14.5355 10.4038 15.0104 10.4038 15.3033 10.6967C15.5962 10.9896 15.5962 11.4645 15.3033 11.7574L10.5303 16.5303Z",
        fill: "#4B5563"
    }));
};
module.exports.arrow_down = $58585cb6785472a6$var$arrow_down;

});

parcelRegister("do2Ov", function(module, exports) {
"use strict";
var $9befb2f43f6882d4$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $9befb2f43f6882d4$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.arrow_left = void 0;

/* eslint-disable max-len */ const $9befb2f43f6882d4$var$react_1 = $9befb2f43f6882d4$var$__importDefault((parcelRequire("acw62")));

const $9befb2f43f6882d4$var$classnames_1 = $9befb2f43f6882d4$var$__importDefault((parcelRequire("8g1PZ")));
const $9befb2f43f6882d4$var$arrow_left = (_a)=>{
    var { className: className } = _a, rest = $9befb2f43f6882d4$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $9befb2f43f6882d4$var$classnames_1.default)("helix-icon", "arrow-left-outlined", className);
    return $9befb2f43f6882d4$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $9befb2f43f6882d4$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.841 6.53033C7.13389 6.23744 7.13389 5.76256 6.841 5.46967C6.54811 5.17678 6.07323 5.17678 5.78034 5.46967L1.78034 9.46967L1.25001 10L1.78034 10.5303L5.78034 14.5303C6.07323 14.8232 6.54811 14.8232 6.841 14.5303C7.13389 14.2374 7.13389 13.7626 6.841 13.4697L4.12133 10.75L18.3107 10.75C18.7249 10.75 19.0607 10.4142 19.0607 10C19.0607 9.58579 18.7249 9.25 18.3107 9.25L4.12133 9.25L6.841 6.53033Z",
        fill: "#4B5563"
    }));
};
module.exports.arrow_left = $9befb2f43f6882d4$var$arrow_left;

});

parcelRegister("i6Qfp", function(module, exports) {
"use strict";
var $d2f150d26662265c$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d2f150d26662265c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.arrow_right = void 0;

/* eslint-disable max-len */ const $d2f150d26662265c$var$react_1 = $d2f150d26662265c$var$__importDefault((parcelRequire("acw62")));

const $d2f150d26662265c$var$classnames_1 = $d2f150d26662265c$var$__importDefault((parcelRequire("8g1PZ")));
const $d2f150d26662265c$var$arrow_right = (_a)=>{
    var { className: className } = _a, rest = $d2f150d26662265c$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $d2f150d26662265c$var$classnames_1.default)("helix-icon", "arrow-right-outlined", className);
    return $d2f150d26662265c$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $d2f150d26662265c$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.4697 13.4697C13.1768 13.7626 13.1768 14.2374 13.4697 14.5303C13.7626 14.8232 14.2374 14.8232 14.5303 14.5303L18.5303 10.5303L19.0607 10L18.5303 9.46967L14.5303 5.46967C14.2374 5.17678 13.7626 5.17678 13.4697 5.46967C13.1768 5.76256 13.1768 6.23744 13.4697 6.53033L16.1893 9.25H2C1.58579 9.25 1.25 9.58579 1.25 10C1.25 10.4142 1.58579 10.75 2 10.75H16.1893L13.4697 13.4697Z",
        fill: "#4B5563"
    }));
};
module.exports.arrow_right = $d2f150d26662265c$var$arrow_right;

});

parcelRegister("57XhL", function(module, exports) {
"use strict";
var $3bbb9812ab8ad072$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $3bbb9812ab8ad072$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.arrow_up = void 0;

/* eslint-disable max-len */ const $3bbb9812ab8ad072$var$react_1 = $3bbb9812ab8ad072$var$__importDefault((parcelRequire("acw62")));

const $3bbb9812ab8ad072$var$classnames_1 = $3bbb9812ab8ad072$var$__importDefault((parcelRequire("8g1PZ")));
const $3bbb9812ab8ad072$var$arrow_up = (_a)=>{
    var { className: className } = _a, rest = $3bbb9812ab8ad072$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $3bbb9812ab8ad072$var$classnames_1.default)("helix-icon", "arrow-up-outlined", className);
    return $3bbb9812ab8ad072$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $3bbb9812ab8ad072$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.46967 3.46967C9.76256 3.17678 10.2374 3.17678 10.5303 3.46967L15.3033 8.24264C15.5962 8.53553 15.5962 9.01041 15.3033 9.3033C15.0104 9.59619 14.5355 9.59619 14.2426 9.3033L10.75 5.81066V16C10.75 16.4142 10.4142 16.75 10 16.75C9.58579 16.75 9.25 16.4142 9.25 16V5.81066L5.75736 9.3033C5.46447 9.59619 4.98959 9.59619 4.6967 9.3033C4.4038 9.01041 4.4038 8.53553 4.6967 8.24264L9.46967 3.46967Z",
        fill: "#4B5563"
    }));
};
module.exports.arrow_up = $3bbb9812ab8ad072$var$arrow_up;

});

parcelRegister("gDUuz", function(module, exports) {
"use strict";
var $c1dc1bfee9edde73$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $c1dc1bfee9edde73$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.arrows_exchange = void 0;

/* eslint-disable max-len */ const $c1dc1bfee9edde73$var$react_1 = $c1dc1bfee9edde73$var$__importDefault((parcelRequire("acw62")));

const $c1dc1bfee9edde73$var$classnames_1 = $c1dc1bfee9edde73$var$__importDefault((parcelRequire("8g1PZ")));
const $c1dc1bfee9edde73$var$arrows_exchange = (_a)=>{
    var { className: className } = _a, rest = $c1dc1bfee9edde73$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $c1dc1bfee9edde73$var$classnames_1.default)("helix-icon", "arrows_exchange", className);
    return $c1dc1bfee9edde73$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $c1dc1bfee9edde73$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.25 8C4.25 8.41421 4.58579 8.75 5 8.75H16C16.3033 8.75 16.5768 8.56727 16.6929 8.28701C16.809 8.00676 16.7448 7.68417 16.5303 7.46967L12.5303 3.46967C12.2374 3.17678 11.7626 3.17678 11.4697 3.46967C11.1768 3.76256 11.1768 4.23744 11.4697 4.53033L14.1893 7.25H5C4.58579 7.25 4.25 7.58579 4.25 8Z",
        fill: "#4B5563"
    }), $c1dc1bfee9edde73$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.81066 12.75L15 12.75C15.4142 12.75 15.75 12.4142 15.75 12C15.75 11.5858 15.4142 11.25 15 11.25L4 11.25C3.69665 11.25 3.42317 11.4327 3.30709 11.713C3.191 11.9932 3.25517 12.3158 3.46967 12.5303L7.46967 16.5303C7.76256 16.8232 8.23744 16.8232 8.53033 16.5303C8.82322 16.2374 8.82322 15.7626 8.53033 15.4697L5.81066 12.75Z",
        fill: "#4B5563"
    }));
};
module.exports.arrows_exchange = $c1dc1bfee9edde73$var$arrows_exchange;

});

parcelRegister("cZvPy", function(module, exports) {
"use strict";
var $9753df6760e3b7fd$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $9753df6760e3b7fd$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.arrows_left_right = void 0;

/* eslint-disable max-len */ const $9753df6760e3b7fd$var$react_1 = $9753df6760e3b7fd$var$__importDefault((parcelRequire("acw62")));

const $9753df6760e3b7fd$var$classnames_1 = $9753df6760e3b7fd$var$__importDefault((parcelRequire("8g1PZ")));
const $9753df6760e3b7fd$var$arrows_left_right = (_a)=>{
    var { className: className } = _a, rest = $9753df6760e3b7fd$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $9753df6760e3b7fd$var$classnames_1.default)("helix-icon", "arrows-left-right-outlined", className);
    return $9753df6760e3b7fd$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $9753df6760e3b7fd$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.53033 16.5304C7.82322 16.2375 7.82322 15.7626 7.53033 15.4697L5.06066 13L7.53033 10.5304C7.82322 10.2375 7.82322 9.76259 7.53033 9.4697C7.23744 9.1768 6.76256 9.1768 6.46967 9.4697L3.46967 12.4697C3.17678 12.7626 3.17678 13.2375 3.46967 13.5304L6.46967 16.5304C6.76256 16.8233 7.23744 16.8233 7.53033 16.5304Z",
        fill: "#4B5563"
    }), $9753df6760e3b7fd$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.4697 3.46967C12.1768 3.76256 12.1768 4.23744 12.4697 4.53033L14.9393 7L12.4697 9.46967C12.1768 9.76256 12.1768 10.2374 12.4697 10.5303C12.7626 10.8232 13.2374 10.8232 13.5303 10.5303L16.5303 7.53033C16.8232 7.23744 16.8232 6.76256 16.5303 6.46967L13.5303 3.46967C13.2374 3.17678 12.7626 3.17678 12.4697 3.46967Z",
        fill: "#4B5563"
    }), $9753df6760e3b7fd$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.25 7.00003C4.25 7.41424 4.58579 7.75003 5 7.75003H16C16.4142 7.75003 16.75 7.41424 16.75 7.00003C16.75 6.58581 16.4142 6.25003 16 6.25003H5C4.58579 6.25003 4.25 6.58581 4.25 7.00003Z",
        fill: "#4B5563"
    }), $9753df6760e3b7fd$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.75 13C15.75 12.5858 15.4142 12.25 15 12.25H5C4.58579 12.25 4.25 12.5858 4.25 13C4.25 13.4142 4.58579 13.75 5 13.75H15C15.4142 13.75 15.75 13.4142 15.75 13Z",
        fill: "#4B5563"
    }));
};
module.exports.arrows_left_right = $9753df6760e3b7fd$var$arrows_left_right;

});

parcelRegister("7hkiq", function(module, exports) {
"use strict";
var $54c9dd59b88e7996$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $54c9dd59b88e7996$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.arrows_up_down = void 0;

/* eslint-disable max-len */ const $54c9dd59b88e7996$var$react_1 = $54c9dd59b88e7996$var$__importDefault((parcelRequire("acw62")));

const $54c9dd59b88e7996$var$classnames_1 = $54c9dd59b88e7996$var$__importDefault((parcelRequire("8g1PZ")));
const $54c9dd59b88e7996$var$arrows_up_down = (_a)=>{
    var { className: className } = _a, rest = $54c9dd59b88e7996$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $54c9dd59b88e7996$var$classnames_1.default)("helix-icon", "arrows-up-down-outlined", className);
    return $54c9dd59b88e7996$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $54c9dd59b88e7996$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.5304 12.4697C16.2375 12.1768 15.7626 12.1768 15.4697 12.4697L13 14.9393L10.5304 12.4697C10.2375 12.1768 9.76259 12.1768 9.4697 12.4697C9.1768 12.7626 9.1768 13.2374 9.4697 13.5303L12.4697 16.5303C12.7626 16.8232 13.2375 16.8232 13.5304 16.5303L16.5304 13.5303C16.8233 13.2374 16.8233 12.7626 16.5304 12.4697Z",
        fill: "#4B5563"
    }), $54c9dd59b88e7996$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.46967 7.53033C3.76256 7.82323 4.23744 7.82323 4.53033 7.53033L7 5.06066L9.46967 7.53033C9.76256 7.82323 10.2374 7.82323 10.5303 7.53033C10.8232 7.23744 10.8232 6.76256 10.5303 6.46967L7.53033 3.46967C7.23744 3.17678 6.76256 3.17678 6.46967 3.46967L3.46967 6.46967C3.17678 6.76257 3.17678 7.23744 3.46967 7.53033Z",
        fill: "#4B5563"
    }), $54c9dd59b88e7996$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.00003 15.75C7.41424 15.75 7.75003 15.4142 7.75003 15V4C7.75003 3.58579 7.41424 3.25 7.00003 3.25C6.58581 3.25 6.25003 3.58579 6.25003 4V15C6.25003 15.4142 6.58581 15.75 7.00003 15.75Z",
        fill: "#4B5563"
    }), $54c9dd59b88e7996$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13 4.25C12.5858 4.25 12.25 4.58579 12.25 5V15C12.25 15.4142 12.5858 15.75 13 15.75C13.4142 15.75 13.75 15.4142 13.75 15V5C13.75 4.58579 13.4142 4.25 13 4.25Z",
        fill: "#4B5563"
    }));
};
module.exports.arrows_up_down = $54c9dd59b88e7996$var$arrows_up_down;

});

parcelRegister("1zcJ6", function(module, exports) {
"use strict";
var $1242ee83e0b21d42$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $1242ee83e0b21d42$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.avg_bar_chart = void 0;

/* eslint-disable max-len */ const $1242ee83e0b21d42$var$classnames_1 = $1242ee83e0b21d42$var$__importDefault((parcelRequire("8g1PZ")));

const $1242ee83e0b21d42$var$react_1 = $1242ee83e0b21d42$var$__importDefault((parcelRequire("acw62")));
const $1242ee83e0b21d42$var$avg_bar_chart = (_a)=>{
    var { className: className } = _a, rest = $1242ee83e0b21d42$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $1242ee83e0b21d42$var$classnames_1.default)("helix-icon", "avg_bar_chart", className);
    return $1242ee83e0b21d42$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $1242ee83e0b21d42$var$react_1.default.createElement("path", {
        d: "M4.00001 6.9C4.00001 6.67909 4.1791 6.5 4.40001 6.5H6.60001C6.82093 6.5 7.00001 6.67909 7.00001 6.9V15.6266C7.00001 15.8475 6.82093 16.0266 6.60001 16.0266H4.40001C4.1791 16.0266 4.00001 15.8475 4.00001 15.6266V6.9Z",
        fill: "#4B5563"
    }), $1242ee83e0b21d42$var$react_1.default.createElement("path", {
        d: "M13.9463 4.4C13.9463 4.17909 14.1254 4 14.3463 4H16.5463C16.7672 4 16.9463 4.17909 16.9463 4.4V15.6C16.9463 15.8209 16.7672 16 16.5463 16H14.3463C14.1254 16 13.9463 15.8209 13.9463 15.6V4.4Z",
        fill: "#4B5563"
    }), $1242ee83e0b21d42$var$react_1.default.createElement("path", {
        d: "M8.90001 11.4C8.90001 11.1791 9.0791 11 9.30001 11H11.5C11.7209 11 11.9 11.1791 11.9 11.4V15.6266C11.9 15.8475 11.7209 16.0266 11.5 16.0266H9.30001C9.0791 16.0266 8.90001 15.8475 8.90001 15.6266V11.4Z",
        fill: "#4B5563"
    }), $1242ee83e0b21d42$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.25 9C2.25 8.58579 2.58579 8.25 3 8.25H18C18.4142 8.25 18.75 8.58579 18.75 9C18.75 9.41421 18.4142 9.75 18 9.75H3C2.58579 9.75 2.25 9.41421 2.25 9Z",
        fill: "#4B5563"
    }));
};
module.exports.avg_bar_chart = $1242ee83e0b21d42$var$avg_bar_chart;

});

parcelRegister("JqtH9", function(module, exports) {
"use strict";
var $0888be0dcfe4177f$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $0888be0dcfe4177f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.banking_reconciliation = void 0;

/* eslint-disable max-len */ const $0888be0dcfe4177f$var$react_1 = $0888be0dcfe4177f$var$__importDefault((parcelRequire("acw62")));

const $0888be0dcfe4177f$var$classnames_1 = $0888be0dcfe4177f$var$__importDefault((parcelRequire("8g1PZ")));
const $0888be0dcfe4177f$var$banking_reconciliation = (_a)=>{
    var { className: className } = _a, rest = $0888be0dcfe4177f$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $0888be0dcfe4177f$var$classnames_1.default)("helix-icon", "banking_reconciliation-outlined", className);
    return $0888be0dcfe4177f$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $0888be0dcfe4177f$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4 2.25C3.0335 2.25 2.25 3.0335 2.25 4V13C2.25 13.9665 3.0335 14.75 4 14.75H5.25V16C5.25 16.9665 6.0335 17.75 7 17.75H16C16.9665 17.75 17.75 16.9665 17.75 16V7C17.75 6.0335 16.9665 5.25 16 5.25H14.75V4C14.75 3.0335 13.9665 2.25 13 2.25H4ZM13.25 5.25V4C13.25 3.86193 13.1381 3.75 13 3.75H4C3.86193 3.75 3.75 3.86193 3.75 4V13C3.75 13.1381 3.86193 13.25 4 13.25H5.25V6C5.25 5.58579 5.58579 5.25 6 5.25H13.25ZM6.75 14.75H14C14.4142 14.75 14.75 14.4142 14.75 14V6.75H16C16.1381 6.75 16.25 6.86193 16.25 7V16C16.25 16.1381 16.1381 16.25 16 16.25H7C6.86193 16.25 6.75 16.1381 6.75 16V14.75ZM12.5303 9.03033C12.8232 8.73744 12.8232 8.26256 12.5303 7.96967C12.2374 7.67678 11.7626 7.67678 11.4697 7.96967L9.5 9.93934L9.03033 9.46967C8.73744 9.17678 8.26256 9.17678 7.96967 9.46967C7.67678 9.76256 7.67678 10.2374 7.96967 10.5303L8.96967 11.5303C9.26256 11.8232 9.73744 11.8232 10.0303 11.5303L12.5303 9.03033Z",
        fill: "#4B5563"
    }));
};
module.exports.banking_reconciliation = $0888be0dcfe4177f$var$banking_reconciliation;

});

parcelRegister("ldonF", function(module, exports) {
"use strict";
var $f71db9649b457630$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $f71db9649b457630$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bathtub = void 0;

/* eslint-disable max-len */ const $f71db9649b457630$var$react_1 = $f71db9649b457630$var$__importDefault((parcelRequire("acw62")));

const $f71db9649b457630$var$classnames_1 = $f71db9649b457630$var$__importDefault((parcelRequire("8g1PZ")));
const $f71db9649b457630$var$bathtub = (_a)=>{
    var { className: className } = _a, rest = $f71db9649b457630$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $f71db9649b457630$var$classnames_1.default)("helix-icon", "bathtub-outlined", className);
    return $f71db9649b457630$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $f71db9649b457630$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.25 4.5C10.25 2.70507 11.7051 1.25 13.5 1.25C15.2949 1.25 16.75 2.70507 16.75 4.5V10.25H17C17.9665 10.25 18.75 11.0335 18.75 12V14.5C18.75 16.8472 16.8472 18.75 14.5 18.75H7C3.82436 18.75 1.25 16.1756 1.25 13V12C1.25 11.0335 2.0335 10.25 3 10.25H15.25V4.5C15.25 3.5335 14.4665 2.75 13.5 2.75C12.5335 2.75 11.75 3.5335 11.75 4.5V5.09451C13.0439 5.42755 14 6.60212 14 8H8C8 6.60212 8.95608 5.42755 10.25 5.09451V4.5ZM3 11.75H17C17.1381 11.75 17.25 11.8619 17.25 12V14.5C17.25 16.0188 16.0188 17.25 14.5 17.25H7C4.65279 17.25 2.75 15.3472 2.75 13V12C2.75 11.8619 2.86193 11.75 3 11.75Z",
        fill: "#4B5563"
    }));
};
module.exports.bathtub = $f71db9649b457630$var$bathtub;

});

parcelRegister("cQrtJ", function(module, exports) {
"use strict";
var $959fa804316853ae$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $959fa804316853ae$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bed = void 0;

/* eslint-disable max-len */ const $959fa804316853ae$var$react_1 = $959fa804316853ae$var$__importDefault((parcelRequire("acw62")));

const $959fa804316853ae$var$classnames_1 = $959fa804316853ae$var$__importDefault((parcelRequire("8g1PZ")));
const $959fa804316853ae$var$bed = (_a)=>{
    var { className: className } = _a, rest = $959fa804316853ae$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $959fa804316853ae$var$classnames_1.default)("helix-icon", "bed-outlined", className);
    return $959fa804316853ae$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $959fa804316853ae$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.7461 3.67332C16.7077 3.29513 16.3883 3 16 3H4C3.58579 3 3.25 3.33579 3.25 3.75V10.0137C2.12501 10.1381 1.25 11.0919 1.25 12.25V15.75C1.25 16.1642 1.58579 16.5 2 16.5H3V18C3 18.4142 3.33579 18.75 3.75 18.75C4.16421 18.75 4.5 18.4142 4.5 18V16.5H15.5V18C15.5 18.4142 15.8358 18.75 16.25 18.75C16.6642 18.75 17 18.4142 17 18V16.5H18C18.4142 16.5 18.75 16.1642 18.75 15.75V12.25C18.75 11.0919 17.875 10.1381 16.75 10.0137V3.75C16.75 3.72411 16.7487 3.69853 16.7461 3.67332ZM15.25 4.5L4.75 4.5V8.7815C4.82991 8.76094 4.91368 8.75 5 8.75H7.5C8.24325 8.75 8.86024 9.29057 8.97926 10H11.0207C11.1398 9.29057 11.7568 8.75 12.5 8.75H15C15.0863 8.75 15.1701 8.76094 15.25 8.78151V4.5ZM3.5 11.5H16.5C16.9142 11.5 17.25 11.8358 17.25 12.25V15H2.75V12.25C2.75 11.8358 3.08579 11.5 3.5 11.5Z",
        fill: "#4B5563"
    }));
};
module.exports.bed = $959fa804316853ae$var$bed;

});

parcelRegister("OAUZK", function(module, exports) {
"use strict";
var $09814ed37f581c3d$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $09814ed37f581c3d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bell = void 0;

/* eslint-disable max-len */ const $09814ed37f581c3d$var$react_1 = $09814ed37f581c3d$var$__importDefault((parcelRequire("acw62")));

const $09814ed37f581c3d$var$classnames_1 = $09814ed37f581c3d$var$__importDefault((parcelRequire("8g1PZ")));
const $09814ed37f581c3d$var$bell = (_a)=>{
    var { className: className } = _a, rest = $09814ed37f581c3d$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $09814ed37f581c3d$var$classnames_1.default)("helix-icon", "bell-outlined", className);
    return $09814ed37f581c3d$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $09814ed37f581c3d$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.25 8.75C4.25 5.57436 6.82436 3 10 3C13.1756 3 15.75 5.57436 15.75 8.75V10.0368C15.75 11.0058 16.0368 11.9532 16.5743 12.7594L17.624 14.334C17.7775 14.5641 17.7918 14.86 17.6613 15.1039C17.5307 15.3478 17.2766 15.5 17 15.5H12.7388C12.6125 16.9016 11.4345 18 10 18C8.56549 18 7.38752 16.9016 7.26121 15.5H3C2.7234 15.5 2.46926 15.3478 2.33875 15.1039C2.20823 14.86 2.22254 14.5641 2.37596 14.334L3.42568 12.7594C3.96318 11.9532 4.25 11.0058 4.25 10.0368V8.75ZM8.77501 15.5C8.89082 16.0706 9.39526 16.5 10 16.5C10.6047 16.5 11.1092 16.0706 11.225 15.5H8.77501ZM10 4.5C7.65279 4.5 5.75 6.40279 5.75 8.75V10.0368C5.75 11.302 5.37552 12.5388 4.67375 13.5915L4.40139 14H15.5986L15.3263 13.5915C14.6245 12.5388 14.25 11.302 14.25 10.0368V8.75C14.25 6.40279 12.3472 4.5 10 4.5Z",
        fill: "#4B5563"
    }));
};
module.exports.bell = $09814ed37f581c3d$var$bell;

});

parcelRegister("i1ose", function(module, exports) {
"use strict";
var $d1eb4a1ccc4e94c9$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d1eb4a1ccc4e94c9$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.book = void 0;

/* eslint-disable max-len */ const $d1eb4a1ccc4e94c9$var$react_1 = $d1eb4a1ccc4e94c9$var$__importDefault((parcelRequire("acw62")));

const $d1eb4a1ccc4e94c9$var$classnames_1 = $d1eb4a1ccc4e94c9$var$__importDefault((parcelRequire("8g1PZ")));
const $d1eb4a1ccc4e94c9$var$book = (_a)=>{
    var { className: className } = _a, rest = $d1eb4a1ccc4e94c9$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $d1eb4a1ccc4e94c9$var$classnames_1.default)("helix-icon", "book-outlined", className);
    return $d1eb4a1ccc4e94c9$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, rest), $d1eb4a1ccc4e94c9$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.5 4.05951C2.80964 4.05951 2.25 4.61915 2.25 5.30951V5.58478C1.9407 5.90041 1.75 6.3327 1.75 6.80952V15.0952C1.75 16.0617 2.5335 16.8452 3.5 16.8452H7.73676C7.7992 16.8452 7.85937 16.8686 7.90545 16.9107L8.81915 17.7461C9.48773 18.3574 10.5123 18.3574 11.1808 17.7461L12.0945 16.9107C12.1406 16.8686 12.2008 16.8452 12.2632 16.8452H16.5C17.4665 16.8452 18.25 16.0617 18.25 15.0952V6.80952C18.25 6.33269 18.0593 5.90041 17.75 5.58477V5.30951C17.75 4.61915 17.1904 4.05951 16.5 4.05951H12.1582C11.7003 4.05951 11.2607 4.23897 10.9336 4.55938L10 5.4739L9.06643 4.55938C8.73934 4.23897 8.29969 4.05951 7.84181 4.05951H3.5ZM3.75 14.3452V5.55951H7.84181C7.90722 5.55951 7.97003 5.58515 8.01676 5.63092L9.25 6.83899V15.0249L8.55614 14.3452H3.75ZM10.75 15.0249L11.4439 14.3452H16.25V5.55951H12.1582C12.0928 5.55951 12.03 5.58515 11.9832 5.63092L10.75 6.83899V15.0249Z",
        fill: "#4B5563"
    }));
};
module.exports.book = $d1eb4a1ccc4e94c9$var$book;

});

parcelRegister("gsJSN", function(module, exports) {
"use strict";
var $bfc2da40ad4d5485$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $bfc2da40ad4d5485$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bell_notification = void 0;

/* eslint-disable max-len */ const $bfc2da40ad4d5485$var$react_1 = $bfc2da40ad4d5485$var$__importDefault((parcelRequire("acw62")));

const $bfc2da40ad4d5485$var$classnames_1 = $bfc2da40ad4d5485$var$__importDefault((parcelRequire("8g1PZ")));
const $bfc2da40ad4d5485$var$bell_notification = (_a)=>{
    var { className: className } = _a, rest = $bfc2da40ad4d5485$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $bfc2da40ad4d5485$var$classnames_1.default)("helix-icon", "bell-notification-outlined", className);
    return $bfc2da40ad4d5485$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $bfc2da40ad4d5485$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.75 10.7536V10.8464C15.75 11.8153 16.0368 12.7627 16.5743 13.5689L17.624 15.1435C17.7775 15.3736 17.7918 15.6695 17.6613 15.9134C17.5307 16.1573 17.2766 16.3095 17 16.3095H12.7388C12.6125 17.7111 11.4345 18.8095 10 18.8095C8.56549 18.8095 7.38752 17.7111 7.26121 16.3095H3C2.7234 16.3095 2.46926 16.1573 2.33875 15.9134C2.20823 15.6695 2.22254 15.3736 2.37596 15.1435L3.42568 13.5689C3.96318 12.7627 4.25 11.8153 4.25 10.8464V9.55951C4.25 6.38387 6.82436 3.80951 10 3.80951C10.1378 3.80951 10.2744 3.81436 10.4098 3.82389C10.2092 4.28699 10.0766 4.78643 10.0247 5.30958C10.0165 5.30953 10.0082 5.30951 10 5.30951C7.65279 5.30951 5.75 7.2123 5.75 9.55951V10.8464C5.75 12.1115 5.37552 13.3483 4.67375 14.401L4.40139 14.8095H15.5986L15.3263 14.401C14.6245 13.3483 14.25 12.1115 14.25 10.8464V10.7536C14.4946 10.7904 14.7451 10.8095 15 10.8095C15.2549 10.8095 15.5054 10.7904 15.75 10.7536ZM10 17.3095C9.39526 17.3095 8.89082 16.8801 8.77501 16.3095H11.225C11.1092 16.8801 10.6047 17.3095 10 17.3095Z",
        fill: "#4B5563"
    }), $bfc2da40ad4d5485$var$react_1.default.createElement("path", {
        d: "M19 5.80951C19 8.01865 17.2091 9.80951 15 9.80951C12.7909 9.80951 11 8.01865 11 5.80951C11 3.60037 12.7909 1.80951 15 1.80951C17.2091 1.80951 19 3.60037 19 5.80951Z",
        fill: "#B91C1C"
    }));
};
module.exports.bell_notification = $bfc2da40ad4d5485$var$bell_notification;

});

parcelRegister("hsYQH", function(module, exports) {
"use strict";
var $0348118eacbe2db0$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $0348118eacbe2db0$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bookmark = void 0;

const $0348118eacbe2db0$var$react_1 = $0348118eacbe2db0$var$__importDefault((parcelRequire("acw62")));

const $0348118eacbe2db0$var$classnames_1 = $0348118eacbe2db0$var$__importDefault((parcelRequire("8g1PZ")));
const $0348118eacbe2db0$var$bookmark = (_a)=>{
    var { className: className } = _a, rest = $0348118eacbe2db0$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $0348118eacbe2db0$var$classnames_1.default)("helix-icon", "bookmark-outlined", className);
    return $0348118eacbe2db0$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $0348118eacbe2db0$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        // eslint-disable-next-line max-len
        d: "M15.25 3.25L4.75 3.25L4.75 16.5986L9.58398 13.376C9.8359 13.208 10.1641 13.208 10.416 13.376L15.25 16.5986V3.25ZM16.75 2.5V18C16.75 18.2766 16.5978 18.5307 16.3539 18.6613C16.11 18.7918 15.8141 18.7775 15.584 18.624L10 14.9014L4.41603 18.624C4.18588 18.7775 3.88997 18.7918 3.64611 18.6613C3.40224 18.5307 3.25 18.2766 3.25 18L3.25 2.5C3.25 2.08579 3.58579 1.75 4 1.75L16 1.75C16.4142 1.75 16.75 2.08579 16.75 2.5Z",
        fill: "#4B5563"
    }));
};
module.exports.bookmark = $0348118eacbe2db0$var$bookmark;

});

parcelRegister("lzjF5", function(module, exports) {
"use strict";
var $fb3c1e42091f6e82$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $fb3c1e42091f6e82$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.box_size = void 0;

/* eslint-disable max-len */ const $fb3c1e42091f6e82$var$react_1 = $fb3c1e42091f6e82$var$__importDefault((parcelRequire("acw62")));

const $fb3c1e42091f6e82$var$classnames_1 = $fb3c1e42091f6e82$var$__importDefault((parcelRequire("8g1PZ")));
const $fb3c1e42091f6e82$var$box_size = (_a)=>{
    var { className: className } = _a, rest = $fb3c1e42091f6e82$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $fb3c1e42091f6e82$var$classnames_1.default)("helix-icon", "box-size-outlined", className);
    return $fb3c1e42091f6e82$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $fb3c1e42091f6e82$var$react_1.default.createElement("path", {
        d: "M4.5 3C4.5 3.41421 4.16421 3.75 3.75 3.75L3.5 3.75L3.5 16.5H16.75V16.25C16.75 15.8358 17.0858 15.5 17.5 15.5C17.9142 15.5 18.25 15.8358 18.25 16.25V18.25C18.25 18.6642 17.9142 19 17.5 19C17.0858 19 16.75 18.6642 16.75 18.25V18H2.75C2.33579 18 2 17.6642 2 17.25L2 3.75L1.75 3.75C1.33579 3.75 1 3.41421 1 3C1 2.58579 1.33579 2.25 1.75 2.25H3.75C4.16421 2.25 4.5 2.58579 4.5 3Z",
        fill: "#4B5563"
    }), $fb3c1e42091f6e82$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 2.25C6.58579 2.25 6.25 2.58579 6.25 3V13C6.25 13.4142 6.58579 13.75 7 13.75H17C17.4142 13.75 17.75 13.4142 17.75 13V3C17.75 2.58579 17.4142 2.25 17 2.25H7ZM7.75 12.25V3.75H16.25V12.25H7.75Z",
        fill: "#4B5563"
    }));
};
module.exports.box_size = $fb3c1e42091f6e82$var$box_size;

});

parcelRegister("9a6vS", function(module, exports) {
"use strict";
var $6aba199bc41e459e$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $6aba199bc41e459e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.briefcase = void 0;

/* eslint-disable max-len */ const $6aba199bc41e459e$var$react_1 = $6aba199bc41e459e$var$__importDefault((parcelRequire("acw62")));

const $6aba199bc41e459e$var$classnames_1 = $6aba199bc41e459e$var$__importDefault((parcelRequire("8g1PZ")));
const $6aba199bc41e459e$var$briefcase = (_a)=>{
    var { className: className } = _a, rest = $6aba199bc41e459e$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $6aba199bc41e459e$var$classnames_1.default)("helix-icon", "briefcase-outlined", className);
    return $6aba199bc41e459e$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $6aba199bc41e459e$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 2.25C12.9665 2.25 13.75 3.0335 13.75 4V5.25H17C17.9665 5.25 18.75 6.0335 18.75 7V16C18.75 16.9665 17.9665 17.75 17 17.75H3C2.0335 17.75 1.25 16.9665 1.25 16V7C1.25 6.0335 2.0335 5.25 3 5.25H6.25V4C6.25 3.0335 7.0335 2.25 8 2.25H12ZM3 6.75C2.86193 6.75 2.75 6.86193 2.75 7V7.5613L10 11.6394L17.25 7.5613V7C17.25 6.86193 17.1381 6.75 17 6.75H3ZM12.25 5.25H7.75V4C7.75 3.86193 7.86193 3.75 8 3.75H12C12.1381 3.75 12.25 3.86193 12.25 4V5.25ZM2.75 9.28232L9.61509 13.1439C9.65449 13.1674 9.69586 13.1872 9.73861 13.2031C9.82388 13.2349 9.91237 13.2502 10 13.2501C10.1354 13.25 10.2687 13.2132 10.3849 13.1439L17.25 9.28232V16C17.25 16.1381 17.1381 16.25 17 16.25H3C2.86193 16.25 2.75 16.1381 2.75 16V9.28232Z",
        fill: "#4B5563"
    }));
};
module.exports.briefcase = $6aba199bc41e459e$var$briefcase;

});

parcelRegister("cZUuP", function(module, exports) {
"use strict";
var $9767017f30c61567$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $9767017f30c61567$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.browser = void 0;

/* eslint-disable max-len */ const $9767017f30c61567$var$react_1 = $9767017f30c61567$var$__importDefault((parcelRequire("acw62")));

const $9767017f30c61567$var$classnames_1 = $9767017f30c61567$var$__importDefault((parcelRequire("8g1PZ")));
const $9767017f30c61567$var$browser = (_a)=>{
    var { className: className } = _a, rest = $9767017f30c61567$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $9767017f30c61567$var$classnames_1.default)("helix-icon", "browser-outlined", className);
    return $9767017f30c61567$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $9767017f30c61567$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4 4.80951C2.89543 4.80951 2 5.70494 2 6.80951V15.8095C2 16.9141 2.89543 17.8095 4 17.8095H16C17.1046 17.8095 18 16.9141 18 15.8095V6.80951C18 5.70494 17.1046 4.80951 16 4.80951H4ZM3.5 15.8095V8.55951L16.5 8.55951V15.8095C16.5 16.0857 16.2761 16.3095 16 16.3095H4C3.72386 16.3095 3.5 16.0857 3.5 15.8095ZM4.25 6.05951C3.83579 6.05951 3.5 6.3953 3.5 6.80951C3.5 7.22372 3.83579 7.55951 4.25 7.55951C4.66421 7.55951 5 7.22372 5 6.80951C5 6.3953 4.66421 6.05951 4.25 6.05951ZM6.75 6.05951C6.33579 6.05951 6 6.3953 6 6.80951C6 7.22372 6.33579 7.55951 6.75 7.55951C7.16421 7.55951 7.5 7.22372 7.5 6.80951C7.5 6.3953 7.16421 6.05951 6.75 6.05951ZM8.5 6.80951C8.5 6.3953 8.83579 6.05951 9.25 6.05951C9.66421 6.05951 10 6.3953 10 6.80951C10 7.22372 9.66421 7.55951 9.25 7.55951C8.83579 7.55951 8.5 7.22372 8.5 6.80951Z",
        fill: "#4B5563"
    }));
};
module.exports.browser = $9767017f30c61567$var$browser;

});

parcelRegister("6uVnK", function(module, exports) {
"use strict";
var $4bb20e4d5738bfef$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $4bb20e4d5738bfef$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.building_bank = void 0;

/* eslint-disable max-len */ const $4bb20e4d5738bfef$var$react_1 = $4bb20e4d5738bfef$var$__importDefault((parcelRequire("acw62")));

const $4bb20e4d5738bfef$var$classnames_1 = $4bb20e4d5738bfef$var$__importDefault((parcelRequire("8g1PZ")));
const $4bb20e4d5738bfef$var$building_bank = (_a)=>{
    var { className: className } = _a, rest = $4bb20e4d5738bfef$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $4bb20e4d5738bfef$var$classnames_1.default)("helix-icon", "building-bank-outlined", className);
    return $4bb20e4d5738bfef$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $4bb20e4d5738bfef$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1 17.25H19V18.75H1V17.25Z",
        fill: "#4B5563"
    }), $4bb20e4d5738bfef$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.4528 1.40208C10.185 1.19931 9.81503 1.19931 9.54725 1.40208L1.54725 7.45977C1.36001 7.60154 1.25 7.82284 1.25 8.05769V10C1.25 10.4142 1.58579 10.75 2 10.75H3V14.75H2V16.25H18V14.75H17V10.75H18C18.4142 10.75 18.75 10.4142 18.75 10V8.05769C18.75 7.82284 18.64 7.60154 18.4528 7.45977L10.4528 1.40208ZM15.5 10.75H13V14.75H15.5V10.75ZM11.5 10.75H8.5L8.5 14.75H11.5V10.75ZM7 10.75H4.5L4.5 14.75H7L7 10.75ZM2.75 9.25V8.43054L10 2.94076L17.25 8.43054V9.25H2.75Z",
        fill: "#4B5563"
    }), $4bb20e4d5738bfef$var$react_1.default.createElement("path", {
        d: "M11 7C11 7.55228 10.5523 8 10 8C9.44771 8 9 7.55228 9 7C9 6.44772 9.44771 6 10 6C10.5523 6 11 6.44772 11 7Z",
        fill: "#4B5563"
    }));
};
module.exports.building_bank = $4bb20e4d5738bfef$var$building_bank;

});

parcelRegister("aJisf", function(module, exports) {
"use strict";
var $7cfc6c13b9d4a540$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $7cfc6c13b9d4a540$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.building_condo = void 0;

/* eslint-disable max-len */ const $7cfc6c13b9d4a540$var$react_1 = $7cfc6c13b9d4a540$var$__importDefault((parcelRequire("acw62")));

const $7cfc6c13b9d4a540$var$classnames_1 = $7cfc6c13b9d4a540$var$__importDefault((parcelRequire("8g1PZ")));
const $7cfc6c13b9d4a540$var$building_condo = (_a)=>{
    var { className: className } = _a, rest = $7cfc6c13b9d4a540$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $7cfc6c13b9d4a540$var$classnames_1.default)("helix-icon", "building-condo-outlined", className);
    return $7cfc6c13b9d4a540$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $7cfc6c13b9d4a540$var$react_1.default.createElement("path", {
        d: "M9 6.25V4.75C9 4.33579 8.66421 4 8.25 4H6.75C6.33579 4 6 4.33579 6 4.75V6.25C6 6.66421 6.33579 7 6.75 7H8.25C8.66421 7 9 6.66421 9 6.25Z",
        fill: "#4B5563"
    }), $7cfc6c13b9d4a540$var$react_1.default.createElement("path", {
        d: "M9 8.75V10.25C9 10.6642 8.66421 11 8.25 11H6.75C6.33579 11 6 10.6642 6 10.25V8.75C6 8.33579 6.33579 8 6.75 8H8.25C8.66421 8 9 8.33579 9 8.75Z",
        fill: "#4B5563"
    }), $7cfc6c13b9d4a540$var$react_1.default.createElement("path", {
        d: "M14 6.25V4.75C14 4.33579 13.6642 4 13.25 4H11.75C11.3358 4 11 4.33579 11 4.75V6.25C11 6.66421 11.3358 7 11.75 7H13.25C13.6642 7 14 6.66421 14 6.25Z",
        fill: "#4B5563"
    }), $7cfc6c13b9d4a540$var$react_1.default.createElement("path", {
        d: "M14 8.75V10.25C14 10.6642 13.6642 11 13.25 11H11.75C11.3358 11 11 10.6642 11 10.25V8.75C11 8.33579 11.3358 8 11.75 8H13.25C13.6642 8 14 8.33579 14 8.75Z",
        fill: "#4B5563"
    }), $7cfc6c13b9d4a540$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 1.25C2.58579 1.25 2.25 1.58579 2.25 2V18C2.25 18.4142 2.58579 18.75 3 18.75H17C17.4142 18.75 17.75 18.4142 17.75 18V2C17.75 1.58579 17.4142 1.25 17 1.25H3ZM3.75 17.25V2.75H16.25V17.25H12.25V13C12.25 12.5858 11.9142 12.25 11.5 12.25H8.5C8.08579 12.25 7.75 12.5858 7.75 13V17.25H3.75ZM9.25 17.25H10.75V13.75H9.25V17.25Z",
        fill: "#4B5563"
    }));
};
module.exports.building_condo = $7cfc6c13b9d4a540$var$building_condo;

});

parcelRegister("fKnzg", function(module, exports) {
"use strict";
var $b76d6ef865de9778$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $b76d6ef865de9778$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.building_modern = void 0;

/* eslint-disable max-len */ const $b76d6ef865de9778$var$react_1 = $b76d6ef865de9778$var$__importDefault((parcelRequire("acw62")));

const $b76d6ef865de9778$var$classnames_1 = $b76d6ef865de9778$var$__importDefault((parcelRequire("8g1PZ")));
const $b76d6ef865de9778$var$building_modern = (_a)=>{
    var { className: className } = _a, rest = $b76d6ef865de9778$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $b76d6ef865de9778$var$classnames_1.default)("helix-icon", "building-modern-outlined", className);
    return $b76d6ef865de9778$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $b76d6ef865de9778$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.5058 2.44619C17.6614 2.58828 17.75 2.78928 17.75 3V17C17.75 17.4142 17.4142 17.75 17 17.75H3C2.58579 17.75 2.25 17.4142 2.25 17V4.27273C2.25 3.88483 2.54579 3.56093 2.9321 3.52581L16.9321 2.25308C17.142 2.23401 17.3502 2.30409 17.5058 2.44619ZM3.75 4.95764V16.25H7.75V12C7.75 11.5858 8.08579 11.25 8.5 11.25H11.5C11.9142 11.25 12.25 11.5858 12.25 12V16.25H16.25V3.82128L3.75 4.95764ZM10.75 16.25V12.75H9.25V16.25H10.75ZM7.75 8C7.75 7.58579 8.08579 7.25 8.5 7.25H11.5C11.9142 7.25 12.25 7.58579 12.25 8C12.25 8.41422 11.9142 8.75 11.5 8.75H8.5C8.08579 8.75 7.75 8.41422 7.75 8Z",
        fill: "#4B5563"
    }));
};
module.exports.building_modern = $b76d6ef865de9778$var$building_modern;

});

parcelRegister("cLxOW", function(module, exports) {
"use strict";
var $94b41be29a9bd93a$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $94b41be29a9bd93a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.buyer_demand = void 0;

/* eslint-disable max-len */ const $94b41be29a9bd93a$var$react_1 = $94b41be29a9bd93a$var$__importDefault((parcelRequire("acw62")));

const $94b41be29a9bd93a$var$classnames_1 = $94b41be29a9bd93a$var$__importDefault((parcelRequire("8g1PZ")));
const $94b41be29a9bd93a$var$buyer_demand = (_a)=>{
    var { className: className } = _a, rest = $94b41be29a9bd93a$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $94b41be29a9bd93a$var$classnames_1.default)("helix-icon", "buyer_demand-outlined", className);
    return $94b41be29a9bd93a$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $94b41be29a9bd93a$var$react_1.default.createElement("path", {
        d: "M12 7.45237L14.5 5.30951L17 7.45237V10.3095H12V7.45237Z",
        fill: "#4B5563"
    }), $94b41be29a9bd93a$var$react_1.default.createElement("path", {
        d: "M3 9.05951C3 8.36915 3.55965 7.80951 4.25 7.80951H6.75C7.44036 7.80951 8 8.36915 8 9.05951V9.47618C8 9.59473 8 9.7075 8 9.8096C8 10.0857 7.77614 10.3095 7.5 10.3095H3.50001C3.22386 10.3095 3 10.0857 3 9.80959C3 9.70749 3 9.59472 3 9.47618V9.05951Z",
        fill: "#4B5563"
    }), $94b41be29a9bd93a$var$react_1.default.createElement("path", {
        d: "M4.25 6.55951C4.25 5.86915 4.80965 5.30951 5.5 5.30951C6.19036 5.30951 6.75 5.86915 6.75 6.55951C6.75 7.24987 6.19036 7.80951 5.5 7.80951C4.80965 7.80951 4.25 7.24987 4.25 6.55951Z",
        fill: "#4B5563"
    }), $94b41be29a9bd93a$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.25 11.8095C2.25 11.3953 2.58579 11.0595 3 11.0595H17C17.4142 11.0595 17.75 11.3953 17.75 11.8095C17.75 12.2237 17.4142 12.5595 17 12.5595H3C2.58579 12.5595 2.25 12.2237 2.25 11.8095Z",
        fill: "#4B5563"
    }), $94b41be29a9bd93a$var$react_1.default.createElement("path", {
        d: "M9.52309 12.8239C9.66998 12.3575 10.33 12.3575 10.4769 12.8239L11.7321 16.8095H8.26795L9.52309 12.8239Z",
        fill: "#4B5563"
    }));
};
module.exports.buyer_demand = $94b41be29a9bd93a$var$buyer_demand;

});

parcelRegister("bouKG", function(module, exports) {
"use strict";
var $84b9ca5202b0d270$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $84b9ca5202b0d270$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calculator = void 0;

/* eslint-disable max-len */ const $84b9ca5202b0d270$var$react_1 = $84b9ca5202b0d270$var$__importDefault((parcelRequire("acw62")));

const $84b9ca5202b0d270$var$classnames_1 = $84b9ca5202b0d270$var$__importDefault((parcelRequire("8g1PZ")));
const $84b9ca5202b0d270$var$calculator = (_a)=>{
    var { className: className } = _a, rest = $84b9ca5202b0d270$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $84b9ca5202b0d270$var$classnames_1.default)("helix-icon", "calculator-outlined", className);
    return $84b9ca5202b0d270$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $84b9ca5202b0d270$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.25 2C3.25 1.58579 3.58579 1.25 4 1.25H16C16.4142 1.25 16.75 1.58579 16.75 2V18C16.75 18.4142 16.4142 18.75 16 18.75H4C3.58579 18.75 3.25 18.4142 3.25 18V2ZM4.75 2.75V17.25H15.25V2.75H4.75Z",
        fill: "#4B5563"
    }), $84b9ca5202b0d270$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 4.25H14V6.75H6V4.25Z",
        fill: "#4B5563"
    }), $84b9ca5202b0d270$var$react_1.default.createElement("path", {
        d: "M11 9C11 9.55229 10.5523 10 10 10C9.44772 10 9 9.55229 9 9C9 8.44772 9.44772 8 10 8C10.5523 8 11 8.44772 11 9Z",
        fill: "#4B5563"
    }), $84b9ca5202b0d270$var$react_1.default.createElement("path", {
        d: "M11 12C11 12.5523 10.5523 13 10 13C9.44772 13 9 12.5523 9 12C9 11.4477 9.44772 11 10 11C10.5523 11 11 11.4477 11 12Z",
        fill: "#4B5563"
    }), $84b9ca5202b0d270$var$react_1.default.createElement("path", {
        d: "M11 15C11 15.5523 10.5523 16 10 16C9.44772 16 9 15.5523 9 15C9 14.4477 9.44772 14 10 14C10.5523 14 11 14.4477 11 15Z",
        fill: "#4B5563"
    }), $84b9ca5202b0d270$var$react_1.default.createElement("path", {
        d: "M14 9C14 9.55229 13.5523 10 13 10C12.4477 10 12 9.55229 12 9C12 8.44772 12.4477 8 13 8C13.5523 8 14 8.44772 14 9Z",
        fill: "#4B5563"
    }), $84b9ca5202b0d270$var$react_1.default.createElement("path", {
        d: "M14 12C14 12.5523 13.5523 13 13 13C12.4477 13 12 12.5523 12 12C12 11.4477 12.4477 11 13 11C13.5523 11 14 11.4477 14 12Z",
        fill: "#4B5563"
    }), $84b9ca5202b0d270$var$react_1.default.createElement("path", {
        d: "M14 15C14 15.5523 13.5523 16 13 16C12.4477 16 12 15.5523 12 15C12 14.4477 12.4477 14 13 14C13.5523 14 14 14.4477 14 15Z",
        fill: "#4B5563"
    }), $84b9ca5202b0d270$var$react_1.default.createElement("path", {
        d: "M8 9C8 9.55229 7.55228 10 7 10C6.44772 10 6 9.55229 6 9C6 8.44772 6.44772 8 7 8C7.55228 8 8 8.44772 8 9Z",
        fill: "#4B5563"
    }), $84b9ca5202b0d270$var$react_1.default.createElement("path", {
        d: "M8 12C8 12.5523 7.55228 13 7 13C6.44772 13 6 12.5523 6 12C6 11.4477 6.44772 11 7 11C7.55228 11 8 11.4477 8 12Z",
        fill: "#4B5563"
    }), $84b9ca5202b0d270$var$react_1.default.createElement("path", {
        d: "M8 15C8 15.5523 7.55228 16 7 16C6.44772 16 6 15.5523 6 15C6 14.4477 6.44772 14 7 14C7.55228 14 8 14.4477 8 15Z",
        fill: "#4B5563"
    }));
};
module.exports.calculator = $84b9ca5202b0d270$var$calculator;

});

parcelRegister("fGgvp", function(module, exports) {
"use strict";
var $b6a794f0113a75dd$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $b6a794f0113a75dd$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calendar = void 0;

/* eslint-disable max-len */ const $b6a794f0113a75dd$var$react_1 = $b6a794f0113a75dd$var$__importDefault((parcelRequire("acw62")));

const $b6a794f0113a75dd$var$classnames_1 = $b6a794f0113a75dd$var$__importDefault((parcelRequire("8g1PZ")));
const $b6a794f0113a75dd$var$calendar = (_a)=>{
    var { className: className } = _a, rest = $b6a794f0113a75dd$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $b6a794f0113a75dd$var$classnames_1.default)("helix-icon", "calendar-outlined", className);
    return $b6a794f0113a75dd$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $b6a794f0113a75dd$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 4.5H4C3.72386 4.5 3.5 4.72386 3.5 5V15C3.5 15.2761 3.72386 15.5 4 15.5H16C16.2761 15.5 16.5 15.2761 16.5 15V5C16.5 4.72386 16.2761 4.5 16 4.5ZM4 3C2.89543 3 2 3.89543 2 5V15C2 16.1046 2.89543 17 4 17H16C17.1046 17 18 16.1046 18 15V5C18 3.89543 17.1046 3 16 3H4Z",
        fill: "#4B5563"
    }), $b6a794f0113a75dd$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 2C6.41421 2 6.75 2.33579 6.75 2.75V4.75C6.75 5.16421 6.41421 5.5 6 5.5C5.58579 5.5 5.25 5.16421 5.25 4.75V2.75C5.25 2.33579 5.58579 2 6 2Z",
        fill: "#4B5563"
    }), $b6a794f0113a75dd$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14 2C14.4142 2 14.75 2.33579 14.75 2.75V4.75C14.75 5.16421 14.4142 5.5 14 5.5C13.5858 5.5 13.25 5.16421 13.25 4.75V2.75C13.25 2.33579 13.5858 2 14 2Z",
        fill: "#4B5563"
    }), $b6a794f0113a75dd$var$react_1.default.createElement("path", {
        d: "M5 8C5 7.44772 5.44772 7 6 7C6.55228 7 7 7.44772 7 8C7 8.55228 6.55228 9 6 9C5.44772 9 5 8.55228 5 8Z",
        fill: "#4B5563"
    }), $b6a794f0113a75dd$var$react_1.default.createElement("path", {
        d: "M5 12C5 11.4477 5.44772 11 6 11C6.55228 11 7 11.4477 7 12C7 12.5523 6.55228 13 6 13C5.44772 13 5 12.5523 5 12Z",
        fill: "#4B5563"
    }), $b6a794f0113a75dd$var$react_1.default.createElement("path", {
        d: "M9 8C9 7.44772 9.44772 7 10 7C10.5523 7 11 7.44772 11 8C11 8.55228 10.5523 9 10 9C9.44772 9 9 8.55228 9 8Z",
        fill: "#4B5563"
    }), $b6a794f0113a75dd$var$react_1.default.createElement("path", {
        d: "M9 12C9 11.4477 9.44772 11 10 11C10.5523 11 11 11.4477 11 12C11 12.5523 10.5523 13 10 13C9.44772 13 9 12.5523 9 12Z",
        fill: "#4B5563"
    }), $b6a794f0113a75dd$var$react_1.default.createElement("path", {
        d: "M13 8C13 7.44772 13.4477 7 14 7C14.5523 7 15 7.44772 15 8C15 8.55228 14.5523 9 14 9C13.4477 9 13 8.55228 13 8Z",
        fill: "#4B5563"
    }), $b6a794f0113a75dd$var$react_1.default.createElement("path", {
        d: "M13 12C13 11.4477 13.4477 11 14 11C14.5523 11 15 11.4477 15 12C15 12.5523 14.5523 13 14 13C13.4477 13 13 12.5523 13 12Z",
        fill: "#4B5563"
    }));
};
module.exports.calendar = $b6a794f0113a75dd$var$calendar;

});

parcelRegister("6kfPp", function(module, exports) {
"use strict";
var $49b0e38053e08ef3$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $49b0e38053e08ef3$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calendar_check = void 0;

/* eslint-disable max-len */ const $49b0e38053e08ef3$var$react_1 = $49b0e38053e08ef3$var$__importDefault((parcelRequire("acw62")));

const $49b0e38053e08ef3$var$classnames_1 = $49b0e38053e08ef3$var$__importDefault((parcelRequire("8g1PZ")));
const $49b0e38053e08ef3$var$calendar_check = (_a)=>{
    var { className: className } = _a, rest = $49b0e38053e08ef3$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $49b0e38053e08ef3$var$classnames_1.default)("helix-icon", "calendar-check-outlined", className);
    return $49b0e38053e08ef3$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $49b0e38053e08ef3$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15 1.25C15.4142 1.25 15.75 1.58579 15.75 2V2.25H17C17.9665 2.25 18.75 3.0335 18.75 4V16C18.75 16.9665 17.9665 17.75 17 17.75H3C2.0335 17.75 1.25 16.9665 1.25 16V4C1.25 3.0335 2.0335 2.25 3 2.25H4.25V2C4.25 1.58579 4.58579 1.25 5 1.25C5.41421 1.25 5.75 1.58579 5.75 2V2.25H14.25V2C14.25 1.58579 14.5858 1.25 15 1.25ZM14.25 3.75H5.75V4C5.75 4.41421 5.41421 4.75 5 4.75C4.58579 4.75 4.25 4.41421 4.25 4V3.75H3C2.86193 3.75 2.75 3.86193 2.75 4V16C2.75 16.1381 2.86193 16.25 3 16.25H17C17.1381 16.25 17.25 16.1381 17.25 16V4C17.25 3.86193 17.1381 3.75 17 3.75H15.75V4C15.75 4.41421 15.4142 4.75 15 4.75C14.5858 4.75 14.25 4.41421 14.25 4V3.75ZM13.5777 7.54731C13.8706 7.8402 13.8706 8.31507 13.5777 8.60797L9.60797 12.5777C9.46732 12.7183 9.27655 12.7974 9.07764 12.7974C8.87872 12.7974 8.68796 12.7183 8.54731 12.5777L6.46967 10.5001C6.17678 10.2072 6.17678 9.73229 6.46967 9.4394C6.76256 9.1465 7.23744 9.1465 7.53033 9.4394L9.07764 10.9867L12.517 7.54731C12.8099 7.25441 13.2848 7.25441 13.5777 7.54731Z",
        fill: "#4B5563"
    }));
};
module.exports.calendar_check = $49b0e38053e08ef3$var$calendar_check;

});

parcelRegister("jnViB", function(module, exports) {
"use strict";
var $e1cc9cad434bc788$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $e1cc9cad434bc788$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calendar_hammer = void 0;

/* eslint-disable max-len */ const $e1cc9cad434bc788$var$react_1 = $e1cc9cad434bc788$var$__importDefault((parcelRequire("acw62")));

const $e1cc9cad434bc788$var$classnames_1 = $e1cc9cad434bc788$var$__importDefault((parcelRequire("8g1PZ")));
const $e1cc9cad434bc788$var$calendar_hammer = (_a)=>{
    var { className: className } = _a, rest = $e1cc9cad434bc788$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $e1cc9cad434bc788$var$classnames_1.default)("helix-icon", "calendar-hammer-outlined", className);
    return $e1cc9cad434bc788$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e1cc9cad434bc788$var$react_1.default.createElement("path", {
        d: "M10.8282 7.45711L13.6566 10.2855C14.0472 10.6761 14.0472 11.3092 13.6566 11.6997L12.9495 12.4069C12.559 12.7974 11.9258 12.7974 11.5353 12.4069L10.9142 11.7857L7.70726 14.9926C7.31673 15.3832 6.68357 15.3832 6.29304 14.9926C5.90252 14.6021 5.90252 13.9689 6.29304 13.5784L9.49996 10.3715L8.70688 9.57843C8.31636 9.1879 8.31636 8.55474 8.70688 8.16421L9.41399 7.45711C9.80451 7.06658 10.4377 7.06658 10.8282 7.45711Z",
        fill: "#4B5563"
    }), $e1cc9cad434bc788$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.25 3H6.75V2.75C6.75 2.33579 6.41421 2 6 2C5.58579 2 5.25 2.33579 5.25 2.75V3H2C1.58579 3 1.25 3.33579 1.25 3.75V17.75C1.25 18.1642 1.58579 18.5 2 18.5H18C18.4142 18.5 18.75 18.1642 18.75 17.75V3.75C18.75 3.33579 18.4142 3 18 3H14.75V2.75C14.75 2.33579 14.4142 2 14 2C13.5858 2 13.25 2.33579 13.25 2.75V3ZM6.75 4.75V4.5H13.25V4.75C13.25 5.16421 13.5858 5.5 14 5.5C14.4142 5.5 14.75 5.16421 14.75 4.75V4.5H17.25V17H2.75V4.5H5.25V4.75C5.25 5.16421 5.58579 5.5 6 5.5C6.41421 5.5 6.75 5.16421 6.75 4.75Z",
        fill: "#4B5563"
    }));
};
module.exports.calendar_hammer = $e1cc9cad434bc788$var$calendar_hammer;

});

parcelRegister("jvGXB", function(module, exports) {
"use strict";
var $e3423c9776870bdd$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $e3423c9776870bdd$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.camera = void 0;

/* eslint-disable max-len */ const $e3423c9776870bdd$var$react_1 = $e3423c9776870bdd$var$__importDefault((parcelRequire("acw62")));

const $e3423c9776870bdd$var$classnames_1 = $e3423c9776870bdd$var$__importDefault((parcelRequire("8g1PZ")));
const $e3423c9776870bdd$var$camera = (_a)=>{
    var { className: className } = _a, rest = $e3423c9776870bdd$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $e3423c9776870bdd$var$classnames_1.default)("helix-icon", "camera-outlined", className);
    return $e3423c9776870bdd$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e3423c9776870bdd$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.21967 3.21967C7.36032 3.07902 7.55109 3 7.75 3H11.75C11.9489 3 12.1397 3.07902 12.2803 3.21967L13.0607 4H14.75C16.2688 4 17.5 5.23122 17.5 6.75V14.75C17.5 16.2688 16.2688 17.5 14.75 17.5H4.75C3.23122 17.5 2 16.2688 2 14.75V6.75C2 5.23122 3.23122 4 4.75 4H6.43934L7.21967 3.21967ZM8.06066 4.5L7.28033 5.28033C7.13968 5.42098 6.94891 5.5 6.75 5.5H4.75C4.05964 5.5 3.5 6.05964 3.5 6.75V14.75C3.5 15.4404 4.05964 16 4.75 16H14.75C15.4404 16 16 15.4404 16 14.75V6.75C16 6.05964 15.4404 5.5 14.75 5.5H12.75C12.5511 5.5 12.3603 5.42098 12.2197 5.28033L11.4393 4.5H8.06066Z",
        fill: "#4B5563"
    }), $e3423c9776870bdd$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.75 8.5C8.50736 8.5 7.5 9.50736 7.5 10.75C7.5 11.9926 8.50736 13 9.75 13C10.9926 13 12 11.9926 12 10.75C12 9.50736 10.9926 8.5 9.75 8.5ZM6 10.75C6 8.67893 7.67893 7 9.75 7C11.8211 7 13.5 8.67893 13.5 10.75C13.5 12.8211 11.8211 14.5 9.75 14.5C7.67893 14.5 6 12.8211 6 10.75Z",
        fill: "#4B5563"
    }), $e3423c9776870bdd$var$react_1.default.createElement("path", {
        d: "M15.25 7C15.25 7.41421 14.9142 7.75 14.5 7.75C14.0858 7.75 13.75 7.41421 13.75 7C13.75 6.58579 14.0858 6.25 14.5 6.25C14.9142 6.25 15.25 6.58579 15.25 7Z",
        fill: "#4B5563"
    }));
};
module.exports.camera = $e3423c9776870bdd$var$camera;

});

parcelRegister("7BgvG", function(module, exports) {
"use strict";
var $5888cba62dd33c99$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $5888cba62dd33c99$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.camera_video = void 0;

/* eslint-disable max-len */ const $5888cba62dd33c99$var$react_1 = $5888cba62dd33c99$var$__importDefault((parcelRequire("acw62")));

const $5888cba62dd33c99$var$classnames_1 = $5888cba62dd33c99$var$__importDefault((parcelRequire("8g1PZ")));
const $5888cba62dd33c99$var$camera_video = (_a)=>{
    var { className: className } = _a, rest = $5888cba62dd33c99$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $5888cba62dd33c99$var$classnames_1.default)("helix-icon", "camera-video-outlined", className);
    return $5888cba62dd33c99$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $5888cba62dd33c99$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14 7.95794V6C14 4.89543 13.1046 4 12 4H3C1.89543 4 1 4.89543 1 6V14C1 15.1046 1.89543 16 3 16H12C13.1046 16 14 15.1046 14 14V12.0421L16.7322 14.5659C17.1699 14.9703 17.8054 15.0772 18.3514 14.8383C18.8973 14.5994 19.25 14.06 19.25 13.4641V6.5359C19.25 5.94 18.8973 5.40062 18.3514 5.16172C17.8054 4.92282 17.1699 5.02972 16.7322 5.43407L14 7.95794ZM3 5.5H12C12.2761 5.5 12.5 5.72386 12.5 6V14C12.5 14.2761 12.2761 14.5 12 14.5H3C2.72386 14.5 2.5 14.2761 2.5 14V6C2.5 5.72386 2.72386 5.5 3 5.5ZM14 10L17.75 13.4641V6.5359L14 10Z",
        fill: "#4B5563"
    }));
};
module.exports.camera_video = $5888cba62dd33c99$var$camera_video;

});

parcelRegister("lid8l", function(module, exports) {
"use strict";
var $f805777eb80dac82$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $f805777eb80dac82$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.car = void 0;

/* eslint-disable max-len */ const $f805777eb80dac82$var$react_1 = $f805777eb80dac82$var$__importDefault((parcelRequire("acw62")));

const $f805777eb80dac82$var$classnames_1 = $f805777eb80dac82$var$__importDefault((parcelRequire("8g1PZ")));
const $f805777eb80dac82$var$car = (_a)=>{
    var { className: className } = _a, rest = $f805777eb80dac82$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $f805777eb80dac82$var$classnames_1.default)("helix-icon", "car-outlined", className);
    return $f805777eb80dac82$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $f805777eb80dac82$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.46928 2.25C4.10544 2.25 2.10131 3.98816 1.76702 6.32825L1.25763 9.89393C1.24841 9.9585 1.2477 10.0223 1.25466 10.0843C1.25157 10.1324 1.25 10.1809 1.25 10.2297V13C1.25 13.4761 1.33872 13.9314 1.50052 14.3504C1.50017 14.357 1.5 14.3635 1.5 14.3702V18C1.5 18.5523 1.94772 19 2.5 19H3.5C4.05228 19 4.5 18.5523 4.5 18V16.717C4.66357 16.7388 4.83047 16.75 5 16.75H15C15.1695 16.75 15.3364 16.7388 15.5 16.717V18C15.5 18.5523 15.9477 19 16.5 19H17.5C18.0523 19 18.5 18.5523 18.5 18V14.3702C18.5 14.3662 18.4999 14.3623 18.4998 14.3585C18.4997 14.3558 18.4996 14.3531 18.4995 14.3504C18.6613 13.9314 18.75 13.4761 18.75 13V10.2297C18.75 10.1813 18.7485 10.1331 18.7454 10.0853C18.7525 10.0231 18.7518 9.95888 18.7426 9.89393L18.2332 6.32825C17.8989 3.98817 15.8948 2.25 13.5309 2.25H6.46928ZM16.9607 8.02737L16.7483 6.54038C16.5195 4.93927 15.1483 3.75 13.5309 3.75H6.46928C4.85191 3.75 3.48067 4.93927 3.25194 6.54038L3.03952 8.02733L3.05874 8.0234L5.97904 7.43934C6.60863 7.31342 7.24912 7.25 7.89118 7.25H12.1088C12.7509 7.25 13.3914 7.31342 14.021 7.43934L16.9413 8.0234L16.9607 8.02737ZM7.89118 8.75C7.3479 8.75 6.80594 8.80366 6.27322 8.91021L3.35291 9.49427C3.00234 9.56438 2.75 9.8722 2.75 10.2297V11.0315C2.82991 11.0109 2.91368 11 3 11H5.5C6.32843 11 7 11.6716 7 12.5C7 12.7761 6.77614 13 6.5 13H2.75C2.75 14.2426 3.75736 15.25 5 15.25H15C16.2426 15.25 17.25 14.2426 17.25 13H13.5C13.2239 13 13 12.7761 13 12.5C13 11.6716 13.6716 11 14.5 11H17C17.0863 11 17.1701 11.0109 17.25 11.0315V10.2297C17.25 9.8722 16.9977 9.56438 16.6471 9.49427L13.7268 8.91021C13.1941 8.80366 12.6521 8.75 12.1088 8.75H7.89118Z",
        fill: "#4B5563"
    }));
};
module.exports.car = $f805777eb80dac82$var$car;

});

parcelRegister("21Y0l", function(module, exports) {
"use strict";
var $17aa386ebe557f77$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $17aa386ebe557f77$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.cards = void 0;

/* eslint-disable max-len */ const $17aa386ebe557f77$var$react_1 = $17aa386ebe557f77$var$__importDefault((parcelRequire("acw62")));

const $17aa386ebe557f77$var$classnames_1 = $17aa386ebe557f77$var$__importDefault((parcelRequire("8g1PZ")));
const $17aa386ebe557f77$var$cards = (_a)=>{
    var { className: className } = _a, rest = $17aa386ebe557f77$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $17aa386ebe557f77$var$classnames_1.default)("helix-icon", "cards-outlined", className);
    return $17aa386ebe557f77$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $17aa386ebe557f77$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.5 4C10.5 3.17157 11.1716 2.5 12 2.5H16C16.8284 2.5 17.5 3.17157 17.5 4V8C17.5 8.82843 16.8284 9.5 16 9.5H12C11.1716 9.5 10.5 8.82843 10.5 8V4ZM2.5 4C2.5 3.17157 3.17157 2.5 4 2.5H8C8.82843 2.5 9.5 3.17157 9.5 4V8C9.5 8.82843 8.82843 9.5 8 9.5H4C3.17157 9.5 2.5 8.82843 2.5 8V4ZM10.5 12C10.5 11.1716 11.1716 10.5 12 10.5H16C16.8284 10.5 17.5 11.1716 17.5 12V16C17.5 16.8284 16.8284 17.5 16 17.5H12C11.1716 17.5 10.5 16.8284 10.5 16V12ZM2.5 12C2.5 11.1716 3.17157 10.5 4 10.5H8C8.82843 10.5 9.5 11.1716 9.5 12V16C9.5 16.8284 8.82843 17.5 8 17.5H4C3.17157 17.5 2.5 16.8284 2.5 16V12ZM4 4V8H8V4H4ZM12 4V8H16V4H12ZM16 12V16H12V12H16ZM4 12V16H8V12H4Z",
        fill: "#4B5563"
    }));
};
module.exports.cards = $17aa386ebe557f77$var$cards;

});

parcelRegister("c3MA9", function(module, exports) {
"use strict";
var $8c7b734312c58465$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $8c7b734312c58465$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.caret_down = void 0;

/* eslint-disable max-len */ const $8c7b734312c58465$var$react_1 = $8c7b734312c58465$var$__importDefault((parcelRequire("acw62")));

const $8c7b734312c58465$var$classnames_1 = $8c7b734312c58465$var$__importDefault((parcelRequire("8g1PZ")));
const $8c7b734312c58465$var$caret_down = (_a)=>{
    var { className: className } = _a, rest = $8c7b734312c58465$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $8c7b734312c58465$var$classnames_1.default)("helix-icon", "caret-down-outlined", className);
    return $8c7b734312c58465$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $8c7b734312c58465$var$react_1.default.createElement("path", {
        d: "M9.31235 13.1874C9.71139 13.6522 10.4307 13.6522 10.8298 13.1874L14.7243 8.65143C15.2811 8.00292 14.8203 7.00001 13.9655 7.00001L6.17659 7.00001C5.32185 7.00001 4.86108 8.00292 5.41787 8.65143L9.31235 13.1874Z",
        fill: "#4B5563"
    }));
};
module.exports.caret_down = $8c7b734312c58465$var$caret_down;

});

parcelRegister("9nLCC", function(module, exports) {
"use strict";
var $6d4b33bcae737caa$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $6d4b33bcae737caa$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.caret_left = void 0;

/* eslint-disable max-len */ const $6d4b33bcae737caa$var$react_1 = $6d4b33bcae737caa$var$__importDefault((parcelRequire("acw62")));

const $6d4b33bcae737caa$var$classnames_1 = $6d4b33bcae737caa$var$__importDefault((parcelRequire("8g1PZ")));
const $6d4b33bcae737caa$var$caret_left = (_a)=>{
    var { className: className } = _a, rest = $6d4b33bcae737caa$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $6d4b33bcae737caa$var$classnames_1.default)("helix-icon", "caret-left-outlined", className);
    return $6d4b33bcae737caa$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $6d4b33bcae737caa$var$react_1.default.createElement("path", {
        d: "M6.81262 9.17021C6.34784 9.56926 6.34784 10.2886 6.81262 10.6876L11.3486 14.5821C11.9971 15.1389 13 14.6782 13 13.8234L13 6.03446C13 5.17971 11.9971 4.71894 11.3486 5.27574L6.81262 9.17021Z",
        fill: "#4B5563"
    }));
};
module.exports.caret_left = $6d4b33bcae737caa$var$caret_left;

});

parcelRegister("fAIeF", function(module, exports) {
"use strict";
var $b59c8813c0de0989$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $b59c8813c0de0989$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.caret_right = void 0;

/* eslint-disable max-len */ const $b59c8813c0de0989$var$react_1 = $b59c8813c0de0989$var$__importDefault((parcelRequire("acw62")));

const $b59c8813c0de0989$var$classnames_1 = $b59c8813c0de0989$var$__importDefault((parcelRequire("8g1PZ")));
const $b59c8813c0de0989$var$caret_right = (_a)=>{
    var { className: className } = _a, rest = $b59c8813c0de0989$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $b59c8813c0de0989$var$classnames_1.default)("helix-icon", "caret-right-outlined", className);
    return $b59c8813c0de0989$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $b59c8813c0de0989$var$react_1.default.createElement("path", {
        d: "M13.1874 10.8298C13.6522 10.4307 13.6522 9.7114 13.1874 9.31235L8.65142 5.41787C8.00291 4.86108 7 5.32185 7 6.17659L7 13.9655C7 14.8203 8.00291 15.2811 8.65142 14.7243L13.1874 10.8298Z",
        fill: "#4B5563"
    }));
};
module.exports.caret_right = $b59c8813c0de0989$var$caret_right;

});

parcelRegister("ec9eb", function(module, exports) {
"use strict";
var $a5595824762b7eb0$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $a5595824762b7eb0$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.caret_up = void 0;

/* eslint-disable max-len */ const $a5595824762b7eb0$var$react_1 = $a5595824762b7eb0$var$__importDefault((parcelRequire("acw62")));

const $a5595824762b7eb0$var$classnames_1 = $a5595824762b7eb0$var$__importDefault((parcelRequire("8g1PZ")));
const $a5595824762b7eb0$var$caret_up = (_a)=>{
    var { className: className } = _a, rest = $a5595824762b7eb0$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $a5595824762b7eb0$var$classnames_1.default)("helix-icon", "caret-up-outline", className);
    return $a5595824762b7eb0$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $a5595824762b7eb0$var$react_1.default.createElement("path", {
        d: "M10.8298 6.88369C10.4307 6.41892 9.7114 6.41892 9.31235 6.88369L5.41787 11.4196C4.86108 12.0682 5.32185 13.0711 6.17659 13.0711L13.9655 13.0711C14.8203 13.0711 15.2811 12.0682 14.7243 11.4197L10.8298 6.88369Z",
        fill: "#4B5563"
    }));
};
module.exports.caret_up = $a5595824762b7eb0$var$caret_up;

});

parcelRegister("NxXTz", function(module, exports) {
"use strict";
var $094eec7846ccd905$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $094eec7846ccd905$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.category = void 0;

/* eslint-disable max-len */ const $094eec7846ccd905$var$react_1 = $094eec7846ccd905$var$__importDefault((parcelRequire("acw62")));

const $094eec7846ccd905$var$classnames_1 = $094eec7846ccd905$var$__importDefault((parcelRequire("8g1PZ")));
const $094eec7846ccd905$var$category = (_a)=>{
    var { className: className } = _a, rest = $094eec7846ccd905$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $094eec7846ccd905$var$classnames_1.default)("helix-icon", "category-outlined", className);
    return $094eec7846ccd905$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $094eec7846ccd905$var$react_1.default.createElement("path", {
        d: "M11 12C11 11.4477 11.4477 11 12 11H15C15.5523 11 16 11.4477 16 12V15C16 15.5523 15.5523 16 15 16H12C11.4477 16 11 15.5523 11 15V12Z",
        fill: "#4B5563"
    }), $094eec7846ccd905$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.5 12.5V14.5H14.5V12.5H12.5ZM12 11C11.4477 11 11 11.4477 11 12V15C11 15.5523 11.4477 16 12 16H15C15.5523 16 16 15.5523 16 15V12C16 11.4477 15.5523 11 15 11H12Z",
        fill: "#4B5563"
    }), $094eec7846ccd905$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.5 5.5V7.5H14.5V5.5H12.5ZM12 4C11.4477 4 11 4.44772 11 5V8C11 8.55228 11.4477 9 12 9H15C15.5523 9 16 8.55228 16 8V5C16 4.44772 15.5523 4 15 4H12Z",
        fill: "#4B5563"
    }), $094eec7846ccd905$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.5 12.5V14.5H7.5V12.5H5.5ZM5 11C4.44772 11 4 11.4477 4 12V15C4 15.5523 4.44772 16 5 16H8C8.55228 16 9 15.5523 9 15V12C9 11.4477 8.55228 11 8 11H5Z",
        fill: "#4B5563"
    }), $094eec7846ccd905$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.5 5.5V7.5H7.5V5.5H5.5ZM5 4C4.44772 4 4 4.44772 4 5V8C4 8.55228 4.44772 9 5 9H8C8.55228 9 9 8.55228 9 8V5C9 4.44772 8.55228 4 8 4H5Z",
        fill: "#4B5563"
    }));
};
module.exports.category = $094eec7846ccd905$var$category;

});

parcelRegister("dypZd", function(module, exports) {
"use strict";
var $9de29bad4ed7f30b$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $9de29bad4ed7f30b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.chart_dollar = void 0;

/* eslint-disable max-len */ const $9de29bad4ed7f30b$var$react_1 = $9de29bad4ed7f30b$var$__importDefault((parcelRequire("acw62")));

const $9de29bad4ed7f30b$var$classnames_1 = $9de29bad4ed7f30b$var$__importDefault((parcelRequire("8g1PZ")));
const $9de29bad4ed7f30b$var$chart_dollar = (_a)=>{
    var { className: className } = _a, rest = $9de29bad4ed7f30b$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $9de29bad4ed7f30b$var$classnames_1.default)("helix-icon", "chart-dollar-outlined", className);
    return $9de29bad4ed7f30b$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $9de29bad4ed7f30b$var$react_1.default.createElement("path", {
        d: "M10.4082 13.7251V13.043C12.0894 12.9033 13.04 12.0547 13.04 10.6851C13.04 9.5249 12.3633 8.81055 10.9829 8.51514L10.4082 8.39697V6.48486C10.9722 6.56543 11.375 6.96826 11.3911 7.45703H12.8896C12.8682 6.21631 11.9014 5.34082 10.4082 5.20117V4.4707H9.65625V5.20117C8.05566 5.33008 7.11035 6.17871 7.11035 7.5C7.11035 8.62256 7.80322 9.36377 9.09229 9.66455L9.65625 9.79883V11.7969C8.98486 11.7271 8.52832 11.3296 8.49072 10.7979H6.95459C6.95996 12.1084 7.9751 12.957 9.65625 13.0537V13.7251H10.4082ZM11.5146 10.8677C11.5146 11.4102 11.1064 11.7593 10.4082 11.8022V9.93311C11.1602 10.0728 11.5146 10.3735 11.5146 10.8677ZM8.66797 7.34961C8.66797 6.87158 9.07617 6.51172 9.65625 6.47949V8.24121C9.00635 8.1123 8.66797 7.80078 8.66797 7.34961Z",
        fill: "#4B5563"
    }), $9de29bad4ed7f30b$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.75 4C4.16421 4 4.5 4.33579 4.5 4.75L4.5 16.25C4.5 16.6642 4.16421 17 3.75 17C3.33579 17 3 16.6642 3 16.25L3 4.75C3 4.33579 3.33579 4 3.75 4Z",
        fill: "#4B5563"
    }), $9de29bad4ed7f30b$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 16.25C3 15.8358 3.33579 15.5 3.75 15.5H15.25C15.6642 15.5 16 15.8358 16 16.25C16 16.6642 15.6642 17 15.25 17H3.75C3.33579 17 3 16.6642 3 16.25Z",
        fill: "#4B5563"
    }));
};
module.exports.chart_dollar = $9de29bad4ed7f30b$var$chart_dollar;

});

parcelRegister("4eQUP", function(module, exports) {
"use strict";
var $3161842626d36987$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $3161842626d36987$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.chart_pie = void 0;

/* eslint-disable max-len */ const $3161842626d36987$var$react_1 = $3161842626d36987$var$__importDefault((parcelRequire("acw62")));

const $3161842626d36987$var$classnames_1 = $3161842626d36987$var$__importDefault((parcelRequire("8g1PZ")));
const $3161842626d36987$var$chart_pie = (_a)=>{
    var { className: className } = _a, rest = $3161842626d36987$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $3161842626d36987$var$classnames_1.default)("helix-icon", "chart-pie-outlined", className);
    return $3161842626d36987$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $3161842626d36987$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9 4.74998C5.54822 4.74998 2.75 7.5482 2.75 11C2.75 14.4518 5.54822 17.25 9 17.25C12.4518 17.25 15.25 14.4518 15.25 11H16.75C16.75 15.2802 13.2802 18.75 9 18.75C4.71979 18.75 1.25 15.2802 1.25 11C1.25 6.71977 4.71979 3.24998 9 3.24998V4.74998Z",
        fill: "#4B5563"
    }), $3161842626d36987$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 2.24997C10 1.83575 10.3358 1.49997 10.75 1.49997C15.0302 1.49997 18.5 4.96976 18.5 9.24997C18.5 9.66418 18.1642 9.99997 17.75 9.99997H10.75C10.5511 9.99997 10.3603 9.92095 10.2197 9.7803C10.079 9.63965 10 9.44888 10 9.24997L10 2.24997Z",
        fill: "#4B5563"
    }));
};
module.exports.chart_pie = $3161842626d36987$var$chart_pie;

});

parcelRegister("c01Xo", function(module, exports) {
"use strict";
var $8bc700bbd89368ac$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $8bc700bbd89368ac$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.chart_pyramid = void 0;

/* eslint-disable max-len */ const $8bc700bbd89368ac$var$react_1 = $8bc700bbd89368ac$var$__importDefault((parcelRequire("acw62")));

const $8bc700bbd89368ac$var$classnames_1 = $8bc700bbd89368ac$var$__importDefault((parcelRequire("8g1PZ")));
const $8bc700bbd89368ac$var$chart_pyramid = (_a)=>{
    var { className: className } = _a, rest = $8bc700bbd89368ac$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $8bc700bbd89368ac$var$classnames_1.default)("helix-icon", "chart-pyramid-outlined", className);
    return $8bc700bbd89368ac$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $8bc700bbd89368ac$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 2C10.2801 2 10.5369 2.15609 10.6658 2.40476L13.1782 7.25H16.25C16.6642 7.25 17 7.58579 17 8C17 8.41421 16.6642 8.75 16.25 8.75H13.9559L17.6658 15.9048C17.7864 16.1373 17.7769 16.4158 17.6409 16.6396C17.5048 16.8634 17.2619 17 17 17H3C2.7381 17 2.49518 16.8634 2.35913 16.6396C2.22309 16.4158 2.21363 16.1373 2.33418 15.9048L6.04406 8.75H3.75C3.33579 8.75 3 8.41421 3 8C3 7.58579 3.33579 7.25 3.75 7.25H6.82184L9.33418 2.40476C9.46312 2.15609 9.71989 2 10 2ZM7.73372 8.75L4.23372 15.5H15.7663L12.2663 8.75H7.73372ZM11.4885 7.25H8.5115L10 4.37931L11.4885 7.25Z",
        fill: "#4B5563"
    }));
};
module.exports.chart_pyramid = $8bc700bbd89368ac$var$chart_pyramid;

});

parcelRegister("catHO", function(module, exports) {
"use strict";
var $8dbd762787695c81$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $8dbd762787695c81$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkmark = void 0;

/* eslint-disable max-len */ const $8dbd762787695c81$var$react_1 = $8dbd762787695c81$var$__importDefault((parcelRequire("acw62")));

const $8dbd762787695c81$var$classnames_1 = $8dbd762787695c81$var$__importDefault((parcelRequire("8g1PZ")));
const $8dbd762787695c81$var$checkmark = (_a)=>{
    var { className: className } = _a, rest = $8dbd762787695c81$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $8dbd762787695c81$var$classnames_1.default)("helix-icon", "checkmark-outlined", className);
    return $8dbd762787695c81$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $8dbd762787695c81$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.9962 4.93762C16.3068 5.21167 16.3364 5.68562 16.0624 5.99621L8.56238 14.4962C8.4254 14.6515 8.23034 14.7432 8.0234 14.7496C7.81647 14.7561 7.61607 14.6767 7.46967 14.5303L3.96967 11.0303C3.67678 10.7374 3.67678 10.2626 3.96967 9.96966C4.26256 9.67677 4.73744 9.67677 5.03033 9.96966L7.96582 12.9052L14.9376 5.00378C15.2117 4.69318 15.6856 4.66356 15.9962 4.93762Z",
        fill: "#4B5563"
    }));
};
module.exports.checkmark = $8dbd762787695c81$var$checkmark;

});

parcelRegister("2XBoY", function(module, exports) {
"use strict";
var $227e1aabece910da$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $227e1aabece910da$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.chevron_down = void 0;

/* eslint-disable max-len */ const $227e1aabece910da$var$react_1 = $227e1aabece910da$var$__importDefault((parcelRequire("acw62")));

const $227e1aabece910da$var$classnames_1 = $227e1aabece910da$var$__importDefault((parcelRequire("8g1PZ")));
const $227e1aabece910da$var$chevron_down = (_a)=>{
    var { className: className } = _a, rest = $227e1aabece910da$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $227e1aabece910da$var$classnames_1.default)("helix-icon", "chevron-down-outlined", className);
    return $227e1aabece910da$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $227e1aabece910da$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.5303 6.93336C16.2374 6.64047 15.7626 6.64047 15.4697 6.93336L10 12.403L4.53033 6.93336C4.23744 6.64047 3.76256 6.64047 3.46967 6.93336C3.17678 7.22626 3.17678 7.70113 3.46967 7.99402L10 14.5244L16.5303 7.99402C16.8232 7.70113 16.8232 7.22626 16.5303 6.93336Z",
        fill: "#4B5563"
    }));
};
module.exports.chevron_down = $227e1aabece910da$var$chevron_down;

});

parcelRegister("gr1E7", function(module, exports) {
"use strict";
var $bf7071cfdd6e128d$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $bf7071cfdd6e128d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.chevron_left = void 0;

/* eslint-disable max-len */ const $bf7071cfdd6e128d$var$classnames_1 = $bf7071cfdd6e128d$var$__importDefault((parcelRequire("8g1PZ")));

const $bf7071cfdd6e128d$var$react_1 = $bf7071cfdd6e128d$var$__importDefault((parcelRequire("acw62")));
const $bf7071cfdd6e128d$var$chevron_left = (_a)=>{
    var { className: className } = _a, rest = $bf7071cfdd6e128d$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $bf7071cfdd6e128d$var$classnames_1.default)("helix-icon", "chevron-left-outlined", className);
    return $bf7071cfdd6e128d$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "21",
        viewBox: "0 0 20 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $bf7071cfdd6e128d$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.6857 4.08869C13.9785 4.38158 13.9785 4.85646 13.6857 5.14935L8.21599 10.619L13.6857 16.0887C13.9785 16.3816 13.9785 16.8565 13.6857 17.1493C13.3928 17.4422 12.9179 17.4422 12.625 17.1493L6.09467 10.619L12.625 4.08869C12.9179 3.7958 13.3928 3.7958 13.6857 4.08869Z",
        fill: "#4B5563"
    }));
};
module.exports.chevron_left = $bf7071cfdd6e128d$var$chevron_left;

});

parcelRegister("3eoz5", function(module, exports) {
"use strict";
var $25a5bc0086c02f4f$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $25a5bc0086c02f4f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.chevron_long_down = void 0;

/* eslint-disable max-len */ const $25a5bc0086c02f4f$var$react_1 = $25a5bc0086c02f4f$var$__importDefault((parcelRequire("acw62")));

const $25a5bc0086c02f4f$var$classnames_1 = $25a5bc0086c02f4f$var$__importDefault((parcelRequire("8g1PZ")));
const $25a5bc0086c02f4f$var$chevron_long_down = (_a)=>{
    var { className: className } = _a, rest = $25a5bc0086c02f4f$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $25a5bc0086c02f4f$var$classnames_1.default)("helix-icon", "chevron-long-down-outlined", className);
    return $25a5bc0086c02f4f$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $25a5bc0086c02f4f$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.99999 13.6743L1.63229 8.96749C1.27128 8.76441 1.14324 8.30713 1.34631 7.94611C1.54938 7.58509 2.00667 7.45705 2.36769 7.66012L9.99999 11.9533L17.6323 7.66012C17.9933 7.45705 18.4506 7.58509 18.6537 7.94611C18.8567 8.30713 18.7287 8.76441 18.3677 8.96749L9.99999 13.6743Z",
        fill: "#4B5563"
    }));
};
module.exports.chevron_long_down = $25a5bc0086c02f4f$var$chevron_long_down;

});

parcelRegister("gQT4l", function(module, exports) {
"use strict";
var $c44c3838c6306445$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $c44c3838c6306445$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.chevron_long_up = void 0;

/* eslint-disable max-len */ const $c44c3838c6306445$var$react_1 = $c44c3838c6306445$var$__importDefault((parcelRequire("acw62")));

const $c44c3838c6306445$var$classnames_1 = $c44c3838c6306445$var$__importDefault((parcelRequire("8g1PZ")));
const $c44c3838c6306445$var$chevron_long_up = (_a)=>{
    var { className: className } = _a, rest = $c44c3838c6306445$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $c44c3838c6306445$var$classnames_1.default)("helix-icon", "chevron-long-up-outlined", className);
    return $c44c3838c6306445$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $c44c3838c6306445$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 7.56372L18.3677 12.2705C18.7287 12.4736 18.8568 12.9309 18.6537 13.2919C18.4506 13.6529 17.9933 13.781 17.6323 13.5779L10 9.28474L2.36771 13.5779C2.00669 13.781 1.5494 13.6529 1.34633 13.2919C1.14326 12.9309 1.2713 12.4736 1.63232 12.2705L10 7.56372Z",
        fill: "#4B5563"
    }));
};
module.exports.chevron_long_up = $c44c3838c6306445$var$chevron_long_up;

});

parcelRegister("biIZb", function(module, exports) {
"use strict";
var $83a445651e131005$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $83a445651e131005$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.chevron_right = void 0;

/* eslint-disable max-len */ const $83a445651e131005$var$react_1 = $83a445651e131005$var$__importDefault((parcelRequire("acw62")));

const $83a445651e131005$var$classnames_1 = $83a445651e131005$var$__importDefault((parcelRequire("8g1PZ")));
const $83a445651e131005$var$chevron_right = (_a)=>{
    var { className: className } = _a, rest = $83a445651e131005$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $83a445651e131005$var$classnames_1.default)("helix-icon", "chevron-right-outlined", className);
    return $83a445651e131005$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $83a445651e131005$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.31434 4.08869C6.02145 4.38158 6.02145 4.85646 6.31434 5.14935L11.784 10.619L6.31434 16.0887C6.02145 16.3816 6.02145 16.8565 6.31434 17.1493C6.60724 17.4422 7.08211 17.4422 7.375 17.1493L13.9053 10.619L7.375 4.08869C7.08211 3.7958 6.60724 3.7958 6.31434 4.08869Z",
        fill: "#4B5563"
    }));
};
module.exports.chevron_right = $83a445651e131005$var$chevron_right;

});

parcelRegister("g6Kf0", function(module, exports) {
"use strict";
var $bba11368ce984666$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $bba11368ce984666$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.chevron_small_down = void 0;

/* eslint-disable max-len */ const $bba11368ce984666$var$react_1 = $bba11368ce984666$var$__importDefault((parcelRequire("acw62")));

const $bba11368ce984666$var$classnames_1 = $bba11368ce984666$var$__importDefault((parcelRequire("8g1PZ")));
const $bba11368ce984666$var$chevron_small_down = (_a)=>{
    var { className: className } = _a, rest = $bba11368ce984666$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $bba11368ce984666$var$classnames_1.default)("helix-icon", "chevron-small-down-outlined", className);
    return $bba11368ce984666$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $bba11368ce984666$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.46967 8.08869C5.76256 7.7958 6.23744 7.7958 6.53033 8.08869L10 11.5584L13.4697 8.08869C13.7626 7.7958 14.2374 7.7958 14.5303 8.08869C14.8232 8.38158 14.8232 8.85646 14.5303 9.14935L10.5303 13.1493C10.3897 13.29 10.1989 13.369 10 13.369C9.80109 13.369 9.61032 13.29 9.46967 13.1493L5.46967 9.14935C5.17678 8.85646 5.17678 8.38158 5.46967 8.08869Z",
        fill: "#4B5563"
    }));
};
module.exports.chevron_small_down = $bba11368ce984666$var$chevron_small_down;

});

parcelRegister("jezI4", function(module, exports) {
"use strict";
var $e00b065cbe8a800b$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $e00b065cbe8a800b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.chevron_small_left = void 0;

/* eslint-disable max-len */ const $e00b065cbe8a800b$var$react_1 = $e00b065cbe8a800b$var$__importDefault((parcelRequire("acw62")));

const $e00b065cbe8a800b$var$classnames_1 = $e00b065cbe8a800b$var$__importDefault((parcelRequire("8g1PZ")));
const $e00b065cbe8a800b$var$chevron_small_left = (_a)=>{
    var { className: className } = _a, rest = $e00b065cbe8a800b$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $e00b065cbe8a800b$var$classnames_1.default)("helix-icon", "chevron-small-left-outlined", className);
    return $e00b065cbe8a800b$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e00b065cbe8a800b$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.5303 6.08869C12.8232 6.38158 12.8232 6.85646 12.5303 7.14935L9.06066 10.619L12.5303 14.0887C12.8232 14.3816 12.8232 14.8565 12.5303 15.1493C12.2374 15.4422 11.7626 15.4422 11.4697 15.1493L7.46967 11.1493C7.32902 11.0087 7.25 10.8179 7.25 10.619C7.25 10.4201 7.32902 10.2293 7.46967 10.0887L11.4697 6.08869C11.7626 5.7958 12.2374 5.7958 12.5303 6.08869Z",
        fill: "#4B5563"
    }));
};
module.exports.chevron_small_left = $e00b065cbe8a800b$var$chevron_small_left;

});

parcelRegister("cSbiy", function(module, exports) {
"use strict";
var $95f34ac398b9358a$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $95f34ac398b9358a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.chevron_small_right = void 0;

/* eslint-disable max-len */ const $95f34ac398b9358a$var$react_1 = $95f34ac398b9358a$var$__importDefault((parcelRequire("acw62")));

const $95f34ac398b9358a$var$classnames_1 = $95f34ac398b9358a$var$__importDefault((parcelRequire("8g1PZ")));
const $95f34ac398b9358a$var$chevron_small_right = (_a)=>{
    var { className: className } = _a, rest = $95f34ac398b9358a$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $95f34ac398b9358a$var$classnames_1.default)("helix-icon", "chevron-small-right-outlined", className);
    return $95f34ac398b9358a$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $95f34ac398b9358a$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.46967 15.1494C7.17678 14.8565 7.17678 14.3816 7.46967 14.0887L10.9393 10.6191L7.46967 7.14941C7.17678 6.85652 7.17678 6.38164 7.46967 6.08875C7.76256 5.79586 8.23744 5.79586 8.53033 6.08875L12.5303 10.0887C12.671 10.2294 12.75 10.4202 12.75 10.6191C12.75 10.818 12.671 11.0088 12.5303 11.1494L8.53033 15.1494C8.23744 15.4423 7.76256 15.4423 7.46967 15.1494Z",
        fill: "#4B5563"
    }));
};
module.exports.chevron_small_right = $95f34ac398b9358a$var$chevron_small_right;

});

parcelRegister("87Xqq", function(module, exports) {
"use strict";
var $5ead12cb5ca0708d$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $5ead12cb5ca0708d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.chevron_small_up = void 0;

/* eslint-disable max-len */ const $5ead12cb5ca0708d$var$react_1 = $5ead12cb5ca0708d$var$__importDefault((parcelRequire("acw62")));

const $5ead12cb5ca0708d$var$classnames_1 = $5ead12cb5ca0708d$var$__importDefault((parcelRequire("8g1PZ")));
const $5ead12cb5ca0708d$var$chevron_small_up = (_a)=>{
    var { className: className } = _a, rest = $5ead12cb5ca0708d$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $5ead12cb5ca0708d$var$classnames_1.default)("helix-icon", "chevron-small-up-outlined", className);
    return $5ead12cb5ca0708d$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $5ead12cb5ca0708d$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.5303 13.1493C14.2374 13.4422 13.7626 13.4422 13.4697 13.1493L10 9.67968L6.53033 13.1493C6.23744 13.4422 5.76256 13.4422 5.46967 13.1493C5.17678 12.8565 5.17678 12.3816 5.46967 12.0887L9.46967 8.08869C9.61032 7.94804 9.80109 7.86902 10 7.86902C10.1989 7.86902 10.3897 7.94804 10.5303 8.08869L14.5303 12.0887C14.8232 12.3816 14.8232 12.8565 14.5303 13.1493Z",
        fill: "#4B5563"
    }));
};
module.exports.chevron_small_up = $5ead12cb5ca0708d$var$chevron_small_up;

});

parcelRegister("iKTw2", function(module, exports) {
"use strict";
var $da779621e591c6d5$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $da779621e591c6d5$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.chevron_up = void 0;

/* eslint-disable max-len */ const $da779621e591c6d5$var$react_1 = $da779621e591c6d5$var$__importDefault((parcelRequire("acw62")));

const $da779621e591c6d5$var$classnames_1 = $da779621e591c6d5$var$__importDefault((parcelRequire("8g1PZ")));
const $da779621e591c6d5$var$chevron_up = (_a)=>{
    var { className: className } = _a, rest = $da779621e591c6d5$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $da779621e591c6d5$var$classnames_1.default)("helix-icon", "chevron-up-outlined", className);
    return $da779621e591c6d5$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $da779621e591c6d5$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.46967 14.3047C3.76256 14.5976 4.23744 14.5976 4.53033 14.3047L10 8.835L15.4697 14.3047C15.7626 14.5976 16.2374 14.5976 16.5303 14.3047C16.8232 14.0118 16.8232 13.5369 16.5303 13.244L10 6.71368L3.46967 13.244C3.17678 13.5369 3.17678 14.0118 3.46967 14.3047Z",
        fill: "#4B5563"
    }));
};
module.exports.chevron_up = $da779621e591c6d5$var$chevron_up;

});

parcelRegister("5rbvT", function(module, exports) {
"use strict";
var $3f5867b6cfe8c39e$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $3f5867b6cfe8c39e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.circle_checkmark = void 0;

/* eslint-disable max-len */ const $3f5867b6cfe8c39e$var$react_1 = $3f5867b6cfe8c39e$var$__importDefault((parcelRequire("acw62")));

const $3f5867b6cfe8c39e$var$classnames_1 = $3f5867b6cfe8c39e$var$__importDefault((parcelRequire("8g1PZ")));
const $3f5867b6cfe8c39e$var$circle_checkmark = (_a)=>{
    var { className: className } = _a, rest = $3f5867b6cfe8c39e$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $3f5867b6cfe8c39e$var$classnames_1.default)("helix-icon", "circle-checkmark-solid", className);
    return $3f5867b6cfe8c39e$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $3f5867b6cfe8c39e$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 17.1191C13.5899 17.1191 16.5 14.2089 16.5 10.6191C16.5 7.02923 13.5898 4.11908 10 4.11908C6.41015 4.11908 3.5 7.02923 3.5 10.6191C3.5 14.2089 6.41015 17.1191 10 17.1191ZM10 18.6191C14.4183 18.6191 18 15.0374 18 10.6191C18 6.2008 14.4183 2.61908 10 2.61908C5.58172 2.61908 2 6.2008 2 10.6191C2 15.0374 5.58172 18.6191 10 18.6191Z",
        fill: "#4B5563"
    }), $3f5867b6cfe8c39e$var$react_1.default.createElement("path", {
        d: "M12.1875 7.909C12.5759 7.52198 13.2042 7.52251 13.5919 7.91018C13.98 8.29832 13.9801 8.92761 13.5919 9.31575L9.20125 13.7065C8.81106 14.0967 8.17842 14.0967 7.78823 13.7065C7.39757 13.3158 7.3981 12.6823 7.78942 12.2923L12.1875 7.909Z",
        fill: "#4B5563"
    }), $3f5867b6cfe8c39e$var$react_1.default.createElement("path", {
        d: "M6.28901 12.162C5.90275 11.7732 5.9038 11.1452 6.29134 10.7577C6.67979 10.3692 7.30959 10.3692 7.69805 10.7576L9.23799 12.2975C9.62788 12.6874 9.62788 13.3195 9.23801 13.7094C8.84722 14.1002 8.2133 14.0991 7.82381 13.7071L6.28901 12.162Z",
        fill: "#4B5563"
    }));
};
module.exports.circle_checkmark = $3f5867b6cfe8c39e$var$circle_checkmark;

});

parcelRegister("4M1nk", function(module, exports) {
"use strict";
var $379cb63713a91e3f$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $379cb63713a91e3f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.circle_info = void 0;

/* eslint-disable max-len */ const $379cb63713a91e3f$var$react_1 = $379cb63713a91e3f$var$__importDefault((parcelRequire("acw62")));

const $379cb63713a91e3f$var$classnames_1 = $379cb63713a91e3f$var$__importDefault((parcelRequire("8g1PZ")));
const $379cb63713a91e3f$var$circle_info = (_a)=>{
    var { className: className } = _a, rest = $379cb63713a91e3f$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $379cb63713a91e3f$var$classnames_1.default)("helix-icon", "circle-info-outlined", className);
    return $379cb63713a91e3f$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $379cb63713a91e3f$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 3.75C6.54822 3.75 3.75 6.54822 3.75 10C3.75 13.4518 6.54822 16.25 10 16.25C13.4518 16.25 16.25 13.4518 16.25 10C16.25 6.54822 13.4518 3.75 10 3.75ZM2.25 10C2.25 5.71979 5.71979 2.25 10 2.25C14.2802 2.25 17.75 5.71979 17.75 10C17.75 14.2802 14.2802 17.75 10 17.75C5.71979 17.75 2.25 14.2802 2.25 10Z",
        fill: "#4B5563"
    }), $379cb63713a91e3f$var$react_1.default.createElement("path", {
        d: "M10 6.73535C10.5332 6.73535 10.9502 6.3252 10.9502 5.8125C10.9502 5.29297 10.5332 4.88965 10 4.88965C9.47363 4.88965 9.05664 5.29297 9.05664 5.8125C9.05664 6.3252 9.47363 6.73535 10 6.73535ZM10 15.1367C10.5195 15.1367 10.8545 14.7949 10.8545 14.2412V8.5127C10.8545 7.95898 10.5195 7.61035 10 7.61035C9.48047 7.61035 9.15234 7.95898 9.15234 8.50586V14.2412C9.15234 14.7949 9.48047 15.1367 10 15.1367Z",
        fill: "#4B5563"
    }));
};
module.exports.circle_info = $379cb63713a91e3f$var$circle_info;

});

parcelRegister("2rMdg", function(module, exports) {
"use strict";
var $1c83807a7fd71c32$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $1c83807a7fd71c32$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.circle_question = void 0;

/* eslint-disable max-len */ const $1c83807a7fd71c32$var$react_1 = $1c83807a7fd71c32$var$__importDefault((parcelRequire("acw62")));

const $1c83807a7fd71c32$var$classnames_1 = $1c83807a7fd71c32$var$__importDefault((parcelRequire("8g1PZ")));
const $1c83807a7fd71c32$var$circle_question = (_a)=>{
    var { className: className } = _a, rest = $1c83807a7fd71c32$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $1c83807a7fd71c32$var$classnames_1.default)("helix-icon", "circle-question-outlined", className);
    return $1c83807a7fd71c32$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $1c83807a7fd71c32$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 3.75C6.54822 3.75 3.75 6.54822 3.75 10C3.75 13.4518 6.54822 16.25 10 16.25C13.4518 16.25 16.25 13.4518 16.25 10C16.25 6.54822 13.4518 3.75 10 3.75ZM2.25 10C2.25 5.71979 5.71979 2.25 10 2.25C14.2802 2.25 17.75 5.71979 17.75 10C17.75 14.2802 14.2802 17.75 10 17.75C5.71979 17.75 2.25 14.2802 2.25 10Z",
        fill: "#4B5563"
    }), $1c83807a7fd71c32$var$react_1.default.createElement("path", {
        d: "M9.68555 12.1699C10.1504 12.1699 10.3828 11.8896 10.4512 11.4385C10.5059 10.8164 10.7246 10.4883 11.6201 9.96875C12.5498 9.41504 13.0693 8.69727 13.0693 7.65137C13.0693 6.10645 11.7979 5.05371 9.94531 5.05371C8.53711 5.05371 7.4707 5.62793 7.04688 6.55762C6.91699 6.81738 6.85547 7.07031 6.85547 7.36426C6.85547 7.82227 7.13574 8.10938 7.60742 8.10938C7.9834 8.10938 8.23633 7.93848 8.38672 7.51465C8.60547 6.82422 9.11133 6.44824 9.87012 6.44824C10.7109 6.44824 11.292 6.96777 11.292 7.71289C11.292 8.36914 11.0049 8.74512 10.1572 9.25781C9.30273 9.76367 8.87891 10.3242 8.87891 11.1719V11.3018C8.87891 11.8008 9.16602 12.1699 9.68555 12.1699ZM9.69922 15.1367C10.2529 15.1367 10.6904 14.7061 10.6904 14.166C10.6904 13.626 10.2529 13.2021 9.69922 13.2021C9.14551 13.2021 8.70117 13.626 8.70117 14.166C8.70117 14.7061 9.14551 15.1367 9.69922 15.1367Z",
        fill: "#4B5563"
    }));
};
module.exports.circle_question = $1c83807a7fd71c32$var$circle_question;

});

parcelRegister("cQaew", function(module, exports) {
"use strict";
var $9592477d1983f45e$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $9592477d1983f45e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.circle_user_checkmark = void 0;

/* eslint-disable max-len */ const $9592477d1983f45e$var$react_1 = $9592477d1983f45e$var$__importDefault((parcelRequire("acw62")));

const $9592477d1983f45e$var$classnames_1 = $9592477d1983f45e$var$__importDefault((parcelRequire("8g1PZ")));
const $9592477d1983f45e$var$circle_user_checkmark = (_a)=>{
    var { className: className } = _a, rest = $9592477d1983f45e$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $9592477d1983f45e$var$classnames_1.default)("helix-icon", "circle_user_checkmark", className);
    return $9592477d1983f45e$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $9592477d1983f45e$var$react_1.default.createElement("path", {
        d: "M8.5 8.5C8.5 9.32843 9.17157 10 10 10C10.8284 10 11.5 9.32843 11.5 8.5C11.5 7.67157 10.8284 7 10 7C9.17157 7 8.5 7.67157 8.5 8.5Z",
        fill: "#4B5563"
    }), $9592477d1983f45e$var$react_1.default.createElement("path", {
        d: "M7 11.5V12C7 12.5523 7 13 8 13H11.126C11.3723 12.0431 11.9638 11.2247 12.7599 10.6856C12.4926 10.273 12.0282 10 11.5 10H10H8.5C7.67157 10 7 10.6716 7 11.5Z",
        fill: "#4B5563"
    }), $9592477d1983f45e$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 4.75C7.10051 4.75 4.75 7.10051 4.75 10C4.75 12.8995 7.10051 15.25 10 15.25C10.3984 15.25 10.7864 15.2056 11.1594 15.1216C11.3062 15.6253 11.5495 16.088 11.8679 16.4882C11.2747 16.6587 10.648 16.75 10 16.75C6.27208 16.75 3.25 13.7279 3.25 10C3.25 6.27208 6.27208 3.25 10 3.25C13.7279 3.25 16.75 6.27208 16.75 10C16.75 10.1331 16.7461 10.2653 16.7385 10.3966C16.2837 10.1767 15.7808 10.0404 15.25 10.0077L15.25 10C15.25 7.10051 12.8995 4.75 10 4.75ZM15 17C14.1667 17 13.4127 16.6602 12.8691 16.1117C12.5146 15.754 12.2496 15.3076 12.1103 14.8087C12.0384 14.5514 12 14.2802 12 14C12 13.6475 12.0608 13.3092 12.1725 12.9951C12.3423 12.5173 12.6297 12.0953 13 11.7639C13.03 11.737 13.0606 11.7107 13.0917 11.6851C13.6103 11.2571 14.2751 11 15 11C15.0517 11 15.1031 11.0013 15.1541 11.0039C15.6808 11.0305 16.1717 11.193 16.5923 11.457C17.4379 11.9876 18 12.9281 18 14C18 15.6569 16.6569 17 15 17ZM13.8536 13.6464L13.1464 14.3536L14.1313 15.3384L14.5 15.7071L16.8536 13.3536L16.1919 12.6919L16.1464 12.6464L14.5 14.2929L13.8536 13.6464Z",
        fill: "#4B5563"
    }));
};
module.exports.circle_user_checkmark = $9592477d1983f45e$var$circle_user_checkmark;

});

parcelRegister("1tN38", function(module, exports) {
"use strict";
var $113e8c1a05c99cfe$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $113e8c1a05c99cfe$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clicks = void 0;

/* eslint-disable max-len */ const $113e8c1a05c99cfe$var$react_1 = $113e8c1a05c99cfe$var$__importDefault((parcelRequire("acw62")));

const $113e8c1a05c99cfe$var$classnames_1 = $113e8c1a05c99cfe$var$__importDefault((parcelRequire("8g1PZ")));
const $113e8c1a05c99cfe$var$clicks = (_a)=>{
    var { className: className } = _a, rest = $113e8c1a05c99cfe$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $113e8c1a05c99cfe$var$classnames_1.default)("helix-icon", "clicks-outlined", className);
    return $113e8c1a05c99cfe$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $113e8c1a05c99cfe$var$react_1.default.createElement("path", {
        d: "M10 3.86908C6.27208 3.86908 3.25 6.89116 3.25 10.6191C3.25 14.347 6.27208 17.3691 10 17.3691C10.2327 17.3691 10.4626 17.3573 10.6892 17.3343L10.3113 15.86C10.2083 15.866 10.1045 15.8691 10 15.8691C7.10051 15.8691 4.75 13.5186 4.75 10.6191C4.75 7.71958 7.10051 5.36908 10 5.36908C12.8995 5.36908 15.25 7.71958 15.25 10.6191C15.25 11.2035 15.1545 11.7656 14.9783 12.2907L16.3025 13.041C16.5916 12.2893 16.75 11.4727 16.75 10.6191C16.75 6.89116 13.7279 3.86908 10 3.86908Z",
        fill: "#4B5563"
    }), $113e8c1a05c99cfe$var$react_1.default.createElement("path", {
        d: "M12.0407 18.5792L10 10.6191L11.9579 11.7285L13.2632 12.4682L14.5684 13.2078L15.8737 13.9474L17 14.5857L14.3955 15.5397L14.4877 15.6613L16.2252 17.9535L15.3986 18.6191L13.569 16.2053L12.0407 18.5792Z",
        fill: "#4B5563"
    }), $113e8c1a05c99cfe$var$react_1.default.createElement("path", {
        d: "M13.6383 11.5313C13.7113 11.2393 13.75 10.9337 13.75 10.6191C13.75 8.54801 12.0711 6.86908 10 6.86908C7.92893 6.86908 6.25 8.54801 6.25 10.6191C6.25 12.6664 7.89063 14.3305 9.92888 14.3684L9.532 12.8203C8.51398 12.605 7.75 11.7012 7.75 10.6191C7.75 9.37644 8.75736 8.36908 10 8.36908C11.2426 8.36908 12.25 9.37644 12.25 10.6191C12.25 10.6606 12.2489 10.7018 12.2467 10.7428L13.6383 11.5313Z",
        fill: "#4B5563"
    }));
};
module.exports.clicks = $113e8c1a05c99cfe$var$clicks;

});

parcelRegister("cktHh", function(module, exports) {
"use strict";
var $8f9e6385b1aea82f$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $8f9e6385b1aea82f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clock = void 0;

/* eslint-disable max-len */ const $8f9e6385b1aea82f$var$react_1 = $8f9e6385b1aea82f$var$__importDefault((parcelRequire("acw62")));

const $8f9e6385b1aea82f$var$classnames_1 = $8f9e6385b1aea82f$var$__importDefault((parcelRequire("8g1PZ")));
const $8f9e6385b1aea82f$var$clock = (_a)=>{
    var { className: className } = _a, rest = $8f9e6385b1aea82f$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $8f9e6385b1aea82f$var$classnames_1.default)("helix-icon", "clock-outlined", className);
    return $8f9e6385b1aea82f$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $8f9e6385b1aea82f$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.75 4.36902C6.29822 4.36902 3.5 7.16724 3.5 10.619C3.5 14.0708 6.29822 16.869 9.75 16.869C13.2018 16.869 16 14.0708 16 10.619C16 7.16724 13.2018 4.36902 9.75 4.36902ZM2 10.619C2 6.33881 5.46979 2.86902 9.75 2.86902C14.0302 2.86902 17.5 6.33881 17.5 10.619C17.5 14.8992 14.0302 18.369 9.75 18.369C5.46979 18.369 2 14.8992 2 10.619ZM9.75 5.86902C10.1642 5.86902 10.5 6.2048 10.5 6.61902V10.2586L12.7185 12.0334C13.042 12.2921 13.0944 12.7641 12.8357 13.0875C12.5769 13.411 12.1049 13.4634 11.7815 13.2047L9.28148 11.2047C9.10357 11.0623 9 10.8469 9 10.619V6.61902C9 6.2048 9.33579 5.86902 9.75 5.86902Z",
        fill: "#4B5563"
    }));
};
module.exports.clock = $8f9e6385b1aea82f$var$clock;

});

parcelRegister("4kMug", function(module, exports) {
"use strict";
var $327ea43b6ca4d21a$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $327ea43b6ca4d21a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.cog = void 0;

/* eslint-disable max-len */ const $327ea43b6ca4d21a$var$react_1 = $327ea43b6ca4d21a$var$__importDefault((parcelRequire("acw62")));

const $327ea43b6ca4d21a$var$classnames_1 = $327ea43b6ca4d21a$var$__importDefault((parcelRequire("8g1PZ")));
const $327ea43b6ca4d21a$var$cog = (_a)=>{
    var { className: className } = _a, rest = $327ea43b6ca4d21a$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $327ea43b6ca4d21a$var$classnames_1.default)("helix-icon", "cog-outlined", className);
    return $327ea43b6ca4d21a$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $327ea43b6ca4d21a$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.83593 2.90458C8.11426 2.83329 8.40926 2.87001 8.66162 3.00736C8.9125 3.14391 9.10274 3.36986 9.19461 3.64019C9.25281 3.8072 9.36145 3.95204 9.50552 4.05468C9.6502 4.15775 9.82341 4.21314 10.001 4.21314C10.1787 4.21314 10.3519 4.15775 10.4965 4.05468C10.6404 3.95219 10.7489 3.80763 10.8072 3.64092C10.8984 3.37089 11.0879 3.14496 11.3381 3.00818C11.5904 2.87028 11.8856 2.83325 12.1641 2.90456L12.1735 2.90697L12.1828 2.90963C12.795 3.0834 13.3842 3.32983 13.9379 3.64366L13.9456 3.64803L13.9532 3.65259C14.1879 3.79308 14.364 4.01362 14.4491 4.27363C14.5332 4.53085 14.5226 4.80957 14.4194 5.05955C14.3483 5.23856 14.3371 5.43581 14.3876 5.62176C14.4267 5.76495 14.5027 5.8954 14.6078 6.00013C14.7121 6.10392 14.8415 6.17886 14.9833 6.21765C15.194 6.27066 15.3844 6.25021 15.5443 6.18548C15.7948 6.08033 16.0747 6.06851 16.3332 6.15236C16.5945 6.23709 16.8161 6.41374 16.9569 6.64951L16.9609 6.65616L16.9647 6.6629C17.2827 7.22111 17.5319 7.81581 17.7067 8.43398L17.7093 8.44328L17.7117 8.45265C17.7829 8.73145 17.7456 9.02686 17.6074 9.27922C17.4704 9.52941 17.2443 9.71882 16.9742 9.80996C16.8074 9.86835 16.6627 9.97702 16.5602 10.1211C16.457 10.2659 16.4016 10.4394 16.4017 10.6172C16.4017 10.7951 16.4573 10.9685 16.5605 11.1133C16.6631 11.2572 16.8077 11.3657 16.9745 11.424C17.2482 11.5163 17.4718 11.7079 17.607 11.9552C17.7449 12.2075 17.7819 12.5027 17.7106 12.7812L17.7081 12.7908L17.7054 12.8004C17.5465 13.3588 17.329 13.892 17.0597 14.3932L17.055 14.4018L17.0502 14.4102C16.9064 14.6618 16.6718 14.8489 16.3944 14.9329C16.1207 15.0158 15.8259 14.9922 15.569 14.867C15.3336 14.7573 15.0054 14.7314 14.5984 15.0012L14.184 14.3761L14.6012 14.9994C14.5871 15.0088 14.575 15.0208 14.5654 15.0347C14.2893 15.4564 14.3258 15.7932 14.4493 16.0331C14.5852 16.2853 14.6203 16.58 14.5472 16.8573C14.4729 17.1387 14.293 17.3806 14.0448 17.5327L14.0376 17.5371L14.0303 17.5413C13.4488 17.8798 12.8267 18.1432 12.1789 18.3252C11.566 18.498 10.9916 18.1253 10.8086 17.5982L10.8072 17.5943L10.8072 17.5943C10.6905 17.2524 10.3723 17.0125 9.9999 17.0121C9.82166 17.0126 9.64802 17.0688 9.50326 17.1728C9.35912 17.2763 9.2508 17.4222 9.1933 17.5901C9.10332 17.8618 8.91359 18.0895 8.66227 18.2269C8.40894 18.3654 8.11221 18.4018 7.8329 18.3286L7.82057 18.3254L7.8206 18.3253C7.16443 18.1413 6.53465 17.8738 5.94675 17.5292L5.93884 17.5245L5.93105 17.5197C5.68542 17.3675 5.50735 17.1271 5.43338 16.8478C5.36038 16.5721 5.39423 16.2792 5.52787 16.0277C5.64865 15.7905 5.68427 15.4534 5.40834 15.0327C5.39915 15.0195 5.38761 15.008 5.37427 14.999C4.96872 14.7325 4.64211 14.7576 4.40907 14.8647L4.40751 14.8654C3.90671 15.094 3.23764 14.9495 2.93309 14.3816L2.93219 14.3799C2.66603 13.8806 2.44862 13.3491 2.29052 12.7918L2.28788 12.7825L2.28548 12.7732C2.21456 12.4962 2.25077 12.2027 2.38685 11.9513C2.52152 11.7025 2.74418 11.5131 3.01108 11.42C3.17527 11.3602 3.31722 11.2515 3.41778 11.1085C3.51907 10.9645 3.57344 10.7927 3.57344 10.6166C3.57344 10.4405 3.51907 10.2688 3.41778 10.1247C3.317 9.98146 3.17465 9.8726 3.01001 9.81288C2.74346 9.71908 2.52135 9.52926 2.38718 9.28039C2.252 9.02965 2.21595 8.73727 2.28619 8.4612L2.28855 8.45192L2.29115 8.44271C2.46531 7.82464 2.71372 7.22994 3.03094 6.67162L3.03488 6.66469L3.03896 6.65785C3.1789 6.4233 3.39873 6.24707 3.65812 6.16151C3.91493 6.0768 4.19346 6.08659 4.44356 6.18895C4.59976 6.25064 4.77062 6.2653 4.93509 6.23111C5.1007 6.19667 5.25249 6.11422 5.37153 5.99405C5.49056 5.87387 5.57156 5.7213 5.60442 5.55537C5.63727 5.38944 5.62052 5.21751 5.55626 5.06105L5.55495 5.05786L5.55496 5.05785C5.45324 4.80688 5.44519 4.52769 5.53231 4.27127C5.61942 4.01486 5.79588 3.79835 6.02944 3.66128L6.03732 3.65666L6.03735 3.6567C6.59126 3.34066 7.18781 3.0863 7.81934 2.90903L7.82761 2.90671L7.83593 2.90458ZM7.91456 4.44906C7.61647 4.54972 7.32782 4.67214 7.04996 4.81406C7.13437 5.1508 7.14382 5.50344 7.07585 5.84672C6.98576 6.30172 6.76364 6.7201 6.43723 7.04964C6.11082 7.37918 5.69457 7.60527 5.24045 7.6997C4.89241 7.77206 4.53395 7.76463 4.19157 7.67974C4.05053 7.95762 3.92982 8.24535 3.83038 8.54066C4.15298 8.71346 4.43234 8.95988 4.6447 9.2618C4.9237 9.65849 5.07344 10.1316 5.07344 10.6166C5.07344 11.1016 4.9237 11.5748 4.6447 11.9714C4.4323 12.2734 4.15287 12.5199 3.8302 12.6927C3.90998 12.9277 4.00304 13.1572 4.10827 13.3803C4.761 13.1908 5.50152 13.2864 6.20175 13.7479L6.20472 13.7499C6.38257 13.8683 6.53542 14.0205 6.65458 14.1979L6.65819 14.2032L6.65816 14.2032C7.14531 14.942 7.22448 15.7228 6.99639 16.3958C7.29081 16.5485 7.59658 16.6784 7.91098 16.7841C8.08064 16.4565 8.32572 16.1718 8.62799 15.9546C9.02715 15.6678 9.50605 15.5131 9.99757 15.5121L9.99904 15.5121C10.9134 15.5121 11.6967 16.0319 12.0875 16.7841C12.3946 16.6806 12.6935 16.5543 12.9817 16.406C12.75 15.732 12.826 14.9494 13.3145 14.2069L13.3177 14.202L13.3177 14.202C13.4366 14.0243 13.5892 13.8717 13.7669 13.7528L13.7696 13.751L13.7696 13.751C14.4794 13.2805 15.2299 13.1888 15.8878 13.3872C15.9925 13.166 16.0851 12.9378 16.1648 12.7035C15.8383 12.5327 15.555 12.2868 15.3392 11.9841C15.0548 11.5852 14.9018 11.1076 14.9017 10.6177C14.9015 10.1279 15.0541 9.65011 15.3383 9.25105C15.5545 8.94735 15.8387 8.70072 16.1663 8.52961C16.067 8.23635 15.9467 7.95061 15.8064 7.67462C15.4287 7.77097 15.0194 7.7753 14.607 7.66968L14.5987 7.66757L14.5987 7.66752C14.2022 7.56116 13.8405 7.35278 13.5495 7.06314C13.2586 6.77349 13.0486 6.41268 12.9405 6.01664L12.9403 6.01596C12.8321 5.61801 12.8291 5.20069 12.929 4.80427C12.6569 4.6666 12.3755 4.54832 12.0869 4.4503C11.9159 4.77701 11.6699 5.06053 11.3669 5.27637C10.9681 5.56046 10.4907 5.71314 10.001 5.71314C9.51141 5.71314 9.03396 5.56046 8.63518 5.27637C8.33184 5.06026 8.08549 4.77629 7.91456 4.44906ZM10 8.36902C8.75736 8.36902 7.75 9.37638 7.75 10.619C7.75 11.8617 8.75736 12.869 10 12.869C11.2426 12.869 12.25 11.8617 12.25 10.619C12.25 9.37638 11.2426 8.36902 10 8.36902ZM6.25 10.619C6.25 8.54795 7.92893 6.86902 10 6.86902C12.0711 6.86902 13.75 8.54795 13.75 10.619C13.75 12.6901 12.0711 14.369 10 14.369C7.92893 14.369 6.25 12.6901 6.25 10.619Z",
        fill: "#4B5563"
    }));
};
module.exports.cog = $327ea43b6ca4d21a$var$cog;

});

parcelRegister("hXAiX", function(module, exports) {
"use strict";
var $d1341bbbc315fbf9$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d1341bbbc315fbf9$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.cog_notification = void 0;

/* eslint-disable max-len */ const $d1341bbbc315fbf9$var$react_1 = $d1341bbbc315fbf9$var$__importDefault((parcelRequire("acw62")));

const $d1341bbbc315fbf9$var$classnames_1 = $d1341bbbc315fbf9$var$__importDefault((parcelRequire("8g1PZ")));
const $d1341bbbc315fbf9$var$cog_notification = (_a)=>{
    var { className: className } = _a, rest = $d1341bbbc315fbf9$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $d1341bbbc315fbf9$var$classnames_1.default)("helix-icon", "cog-notification-outlined", className);
    return $d1341bbbc315fbf9$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $d1341bbbc315fbf9$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.4266 10.4121C15.9741 10.5467 15.4947 10.619 14.9985 10.619C14.9662 10.619 14.9339 10.6187 14.9017 10.6181C14.9019 11.1078 15.0548 11.5853 15.3392 11.9841C15.555 12.2868 15.8383 12.5327 16.1648 12.7035C16.0851 12.9378 15.9925 13.166 15.8878 13.3872C15.2299 13.1888 14.4794 13.2805 13.7696 13.751L13.7669 13.7528C13.5892 13.8717 13.4366 14.0243 13.3177 14.202L13.3145 14.2069C12.826 14.9494 12.75 15.732 12.9817 16.406C12.6935 16.5543 12.3946 16.6806 12.0875 16.7841C11.6967 16.0319 10.9134 15.5121 9.99904 15.5121L9.99757 15.5121C9.50605 15.5131 9.02715 15.6678 8.62799 15.9546C8.32572 16.1718 8.08064 16.4565 7.91098 16.7841C7.59658 16.6784 7.29081 16.5485 6.99639 16.3958C7.22448 15.7228 7.14531 14.942 6.65816 14.2032L6.65458 14.1979C6.53542 14.0205 6.38257 13.8683 6.20472 13.7499L6.20175 13.7479C5.50152 13.2864 4.761 13.1908 4.10827 13.3803C4.00304 13.1572 3.90998 12.9277 3.8302 12.6927C4.15287 12.5199 4.4323 12.2734 4.6447 11.9714C4.9237 11.5748 5.07344 11.1016 5.07344 10.6166C5.07344 10.1316 4.9237 9.65849 4.6447 9.2618C4.43234 8.95988 4.15298 8.71346 3.83038 8.54066C3.92982 8.24535 4.05053 7.95762 4.19157 7.67974C4.53395 7.76463 4.89241 7.77206 5.24045 7.6997C5.69457 7.60527 6.11082 7.37918 6.43723 7.04964C6.76364 6.7201 6.98576 6.30172 7.07585 5.84672C7.14382 5.50344 7.13437 5.1508 7.04996 4.81406C7.32782 4.67214 7.61647 4.54972 7.91456 4.44906C8.08549 4.77629 8.33184 5.06026 8.63518 5.27637C9.03351 5.56014 9.51032 5.71279 9.99937 5.71314C9.9988 5.68183 9.99851 5.65046 9.99851 5.61902C9.99851 5.12176 10.0711 4.64145 10.2063 4.18811C10.1395 4.20464 10.0706 4.21314 10.001 4.21314C9.82341 4.21314 9.6502 4.15775 9.50552 4.05468C9.36145 3.95204 9.25281 3.8072 9.19461 3.64019C9.10274 3.36986 8.9125 3.14391 8.66162 3.00736C8.40926 2.87001 8.11426 2.83329 7.83593 2.90458L7.82761 2.90671L7.81934 2.90903C7.18781 3.0863 6.59126 3.34066 6.03735 3.6567L6.02944 3.66128C5.79588 3.79835 5.61942 4.01486 5.53231 4.27127C5.44519 4.52769 5.45324 4.80688 5.55496 5.05785L5.55626 5.06105C5.62052 5.21751 5.63727 5.38944 5.60442 5.55537C5.57156 5.7213 5.49056 5.87387 5.37153 5.99405C5.25249 6.11422 5.1007 6.19667 4.93509 6.23111C4.77062 6.2653 4.59976 6.25064 4.44356 6.18895C4.19346 6.08659 3.91493 6.0768 3.65812 6.16151C3.39873 6.24707 3.1789 6.4233 3.03896 6.65785L3.03488 6.66469L3.03094 6.67162C2.71372 7.22994 2.46531 7.82464 2.29115 8.44271L2.28855 8.45192L2.28619 8.4612C2.21595 8.73727 2.252 9.02965 2.38718 9.28039C2.52135 9.52926 2.74346 9.71908 3.01001 9.81288C3.17465 9.8726 3.317 9.98146 3.41778 10.1247C3.51907 10.2688 3.57344 10.4405 3.57344 10.6166C3.57344 10.7927 3.51907 10.9645 3.41778 11.1085C3.31722 11.2515 3.17527 11.3602 3.01108 11.42C2.74418 11.5131 2.52152 11.7025 2.38685 11.9513C2.25077 12.2027 2.21456 12.4962 2.28548 12.7732L2.28788 12.7825L2.29052 12.7918C2.44862 13.3491 2.66603 13.8806 2.93219 14.3799L2.93309 14.3816C3.23764 14.9495 3.90671 15.094 4.40751 14.8654L4.40907 14.8647C4.64211 14.7576 4.96872 14.7325 5.37427 14.999C5.38761 15.008 5.39915 15.0195 5.40834 15.0327C5.68427 15.4534 5.64865 15.7905 5.52787 16.0277C5.39423 16.2792 5.36038 16.5721 5.43338 16.8478C5.50735 17.1271 5.68542 17.3675 5.93105 17.5197L5.93884 17.5245L5.94675 17.5292C6.53465 17.8738 7.16443 18.1413 7.8206 18.3253L7.8329 18.3286C8.11221 18.4018 8.40894 18.3654 8.66227 18.2269C8.91359 18.0895 9.10332 17.8618 9.1933 17.5901C9.2508 17.4222 9.35912 17.2763 9.50326 17.1728C9.64802 17.0688 9.82166 17.0126 9.9999 17.0121C10.3723 17.0125 10.6905 17.2524 10.8072 17.5943L10.8086 17.5982C10.9916 18.1253 11.566 18.498 12.1789 18.3252C12.8267 18.1432 13.4488 17.8798 14.0303 17.5413L14.0376 17.5371L14.0448 17.5327C14.293 17.3806 14.4729 17.1387 14.5472 16.8573C14.6203 16.58 14.5852 16.2853 14.4493 16.0331C14.3258 15.7932 14.2893 15.4564 14.5654 15.0347C14.5748 15.0211 14.5866 15.0093 14.6003 15C15.0064 14.7315 15.334 14.7575 15.569 14.867C15.8259 14.9922 16.1207 15.0158 16.3944 14.9329C16.6718 14.8489 16.9064 14.6618 17.0502 14.4102L17.055 14.4018L17.0597 14.3932C17.329 13.892 17.5465 13.3588 17.7054 12.8004L17.7081 12.7908L17.7106 12.7812C17.7819 12.5027 17.7449 12.2075 17.607 11.9552C17.4718 11.7079 17.2482 11.5163 16.9745 11.424C16.8077 11.3657 16.6631 11.2572 16.5605 11.1133C16.4573 10.9685 16.4017 10.7951 16.4017 10.6172C16.4017 10.5477 16.4101 10.4788 16.4266 10.4121ZM14.6003 15C14.6006 14.9998 14.6009 14.9996 14.6012 14.9994L14.184 14.3761L14.5984 15.0012C14.599 15.0008 14.5997 15.0004 14.6003 15Z",
        fill: "#4B5563"
    }), $d1341bbbc315fbf9$var$react_1.default.createElement("path", {
        d: "M13.7467 10.461C13.7489 10.5134 13.75 10.5661 13.75 10.619C13.75 12.6901 12.0711 14.369 10 14.369C7.92893 14.369 6.25 12.6901 6.25 10.619C6.25 8.54795 7.92893 6.86902 10 6.86902C10.0525 6.86902 10.1048 6.8701 10.1569 6.87224C10.3195 7.50224 10.6018 8.08412 10.9781 8.59217C10.6824 8.44918 10.3505 8.36902 10 8.36902C8.75736 8.36902 7.75 9.37638 7.75 10.619C7.75 11.8617 8.75736 12.869 10 12.869C11.2426 12.869 12.25 11.8617 12.25 10.619C12.25 10.2682 12.1697 9.93622 12.0266 9.6403C12.5347 10.0165 13.1167 10.2986 13.7467 10.461Z",
        fill: "#4B5563"
    }), $d1341bbbc315fbf9$var$react_1.default.createElement("path", {
        d: "M18.9985 5.61902C18.9985 7.82816 17.2076 9.61902 14.9985 9.61902C12.7894 9.61902 10.9985 7.82816 10.9985 5.61902C10.9985 3.40988 12.7894 1.61902 14.9985 1.61902C17.2076 1.61902 18.9985 3.40988 18.9985 5.61902Z",
        fill: "#B91C1C"
    }));
};
module.exports.cog_notification = $d1341bbbc315fbf9$var$cog_notification;

});

parcelRegister("chXFP", function(module, exports) {
"use strict";
var $8f255c84151a4506$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $8f255c84151a4506$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.cog_person = void 0;

/* eslint-disable max-len */ const $8f255c84151a4506$var$react_1 = $8f255c84151a4506$var$__importDefault((parcelRequire("acw62")));

const $8f255c84151a4506$var$classnames_1 = $8f255c84151a4506$var$__importDefault((parcelRequire("8g1PZ")));
const $8f255c84151a4506$var$cog_person = (_a)=>{
    var { className: className } = _a, rest = $8f255c84151a4506$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $8f255c84151a4506$var$classnames_1.default)("helix-icon", "cog-person-outlined", className);
    return $8f255c84151a4506$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $8f255c84151a4506$var$react_1.default.createElement("path", {
        d: "M7 11.5C7 10.6716 7.67157 10 8.5 10H11.5C12.3284 10 13 10.6716 13 11.5V12C13 12.5523 12.5523 13 12 13H8C7.44772 13 7 12.5523 7 12V11.5Z",
        fill: "#4B5563"
    }), $8f255c84151a4506$var$react_1.default.createElement("path", {
        d: "M8.5 8.5C8.5 7.67157 9.17157 7 10 7C10.8284 7 11.5 7.67157 11.5 8.5C11.5 9.32843 10.8284 10 10 10C9.17157 10 8.5 9.32843 8.5 8.5Z",
        fill: "#4B5563"
    }), $8f255c84151a4506$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.83593 2.28556C8.11426 2.21427 8.40926 2.25099 8.66162 2.38834C8.9125 2.52489 9.10274 2.75084 9.19461 3.02117C9.25281 3.18819 9.36145 3.33302 9.50552 3.43567C9.6502 3.53873 9.82341 3.59412 10.001 3.59412C10.1787 3.59412 10.3519 3.53873 10.4965 3.43567C10.6404 3.33317 10.7489 3.18861 10.8072 3.0219C10.8984 2.75187 11.0879 2.52594 11.3381 2.38916C11.5904 2.25127 11.8856 2.21424 12.1641 2.28555L12.1735 2.28796L12.1828 2.29061C12.795 2.46438 13.3842 2.71081 13.9379 3.02464L13.9456 3.02901L13.9532 3.03357C14.1879 3.17406 14.364 3.39461 14.4491 3.65461C14.5332 3.91183 14.5226 4.19055 14.4194 4.44053C14.3483 4.61954 14.3371 4.81679 14.3876 5.00274C14.4267 5.14593 14.5027 5.27638 14.6078 5.38111C14.7121 5.4849 14.8415 5.55984 14.9833 5.59863C15.194 5.65164 15.3844 5.6312 15.5443 5.56646C15.7948 5.46131 16.0747 5.4495 16.3332 5.53334C16.5945 5.61807 16.8161 5.79472 16.9569 6.03049L16.9609 6.03715L16.9647 6.04388C17.2827 6.60209 17.5319 7.19679 17.7067 7.81496L17.7093 7.82426L17.7117 7.83363C17.7829 8.11243 17.7456 8.40784 17.6074 8.6602C17.4704 8.91039 17.2443 9.0998 16.9742 9.19094C16.8074 9.24933 16.6627 9.358 16.5602 9.50203C16.457 9.64691 16.4016 9.82036 16.4017 9.99822C16.4017 10.1761 16.4573 10.3495 16.5605 10.4943C16.6631 10.6382 16.8077 10.7467 16.9745 10.805C17.2482 10.8972 17.4718 11.0889 17.607 11.3362C17.7449 11.5885 17.7819 11.8836 17.7106 12.1621L17.7081 12.1718L17.7054 12.1814C17.5465 12.7398 17.329 13.273 17.0597 13.7742L17.055 13.7828L17.0502 13.7912C16.9064 14.0428 16.6718 14.2298 16.3944 14.3139C16.1207 14.3968 15.8259 14.3732 15.569 14.248C15.3336 14.1383 15.0054 14.1124 14.5984 14.3822L14.6012 14.3804C14.5871 14.3898 14.575 14.4018 14.5654 14.4157C14.2893 14.8374 14.3258 15.1742 14.4493 15.4141C14.5852 15.6663 14.6203 15.9609 14.5472 16.2383C14.4729 16.5197 14.293 16.7616 14.0448 16.9136L14.0376 16.9181L14.0303 16.9223C13.4488 17.2608 12.8267 17.5241 12.1789 17.7061C11.566 17.8789 10.9916 17.5062 10.8086 16.9792L10.8072 16.9753C10.6905 16.6334 10.3723 16.3935 9.9999 16.3931C9.82166 16.3936 9.64802 16.4497 9.50326 16.5538C9.35912 16.6573 9.2508 16.8032 9.1933 16.971C9.10332 17.2428 8.91359 17.4704 8.66227 17.6079C8.40894 17.7464 8.11221 17.7828 7.8329 17.7096L7.82057 17.7064C7.1644 17.5224 6.53465 17.2548 5.94675 16.9101L5.93884 16.9055L5.93105 16.9007C5.68542 16.7485 5.50735 16.5081 5.43338 16.2288C5.36038 15.9531 5.39423 15.6602 5.52787 15.4086C5.64865 15.1715 5.68427 14.8344 5.40834 14.4137C5.39915 14.4004 5.38761 14.389 5.37427 14.38C4.96872 14.1135 4.64211 14.1386 4.40907 14.2457L4.40751 14.2464C3.90671 14.475 3.23764 14.3304 2.93309 13.7626L2.93219 13.7609C2.66603 13.2616 2.44862 12.7301 2.29052 12.1728L2.28788 12.1635L2.28548 12.1542C2.21456 11.8772 2.25077 11.5837 2.38685 11.3323C2.52152 11.0835 2.74418 10.8941 3.01108 10.801C3.17527 10.7412 3.31722 10.6325 3.41778 10.4895C3.51907 10.3455 3.57344 10.1737 3.57344 9.99761C3.57344 9.82153 3.51907 9.64975 3.41778 9.50573C3.317 9.36244 3.17465 9.25359 3.01001 9.19386C2.74346 9.10006 2.52135 8.91024 2.38718 8.66137C2.252 8.41063 2.21595 8.11825 2.28619 7.84219L2.28855 7.83291L2.29115 7.82369C2.46531 7.20562 2.71372 6.61092 3.03094 6.0526L3.03488 6.04568L3.03896 6.03883C3.1789 5.80428 3.39873 5.62805 3.65812 5.54249C3.91493 5.45778 4.19346 5.46757 4.44356 5.56993C4.59976 5.63162 4.77062 5.64629 4.93509 5.61209C5.1007 5.57765 5.25249 5.4952 5.37153 5.37503C5.49056 5.25485 5.57156 5.10228 5.60442 4.93635C5.63727 4.77042 5.62052 4.59849 5.55626 4.44203L5.55495 4.43884C5.45323 4.18787 5.44519 3.90867 5.53231 3.65225C5.61942 3.39584 5.79588 3.17933 6.02944 3.04226L6.03732 3.03764C6.59123 2.72159 7.18781 2.46729 7.81934 2.29001L7.82761 2.28769L7.83593 2.28556ZM7.91456 3.83004C7.61647 3.9307 7.32782 4.05312 7.04996 4.19504C7.13437 4.53178 7.14382 4.88442 7.07585 5.2277C6.98576 5.6827 6.76364 6.10108 6.43723 6.43062C6.11082 6.76016 5.69457 6.98625 5.24045 7.08068C4.89241 7.15304 4.53395 7.14561 4.19157 7.06072C4.05053 7.3386 3.92982 7.62633 3.83038 7.92165C4.15298 8.09444 4.43234 8.34086 4.6447 8.64278C4.9237 9.03947 5.07344 9.51263 5.07344 9.99761C5.07344 10.4826 4.9237 10.9557 4.6447 11.3524C4.4323 11.6544 4.15287 11.9009 3.8302 12.0737C3.90998 12.3087 4.00304 12.5382 4.10827 12.7613C4.761 12.5717 5.50152 12.6674 6.20175 13.1289L6.20472 13.1308C6.38257 13.2493 6.53542 13.4015 6.65458 13.5789L6.65819 13.5842C7.14533 14.323 7.22448 15.1038 6.99639 15.7768C7.29081 15.9295 7.59658 16.0593 7.91098 16.1651C8.08064 15.8375 8.32572 15.5528 8.62799 15.3356C9.02715 15.0488 9.50605 14.8941 9.99757 14.8931L9.99904 14.8931C10.9134 14.8931 11.6967 15.4128 12.0875 16.165C12.3946 16.0616 12.6935 15.9352 12.9817 15.787C12.75 15.1129 12.826 14.3304 13.3145 13.5879L13.3177 13.583C13.4366 13.4053 13.5892 13.2527 13.7669 13.1338L13.7696 13.132C14.4794 12.6615 15.2299 12.5698 15.8878 12.7682C15.9925 12.5469 16.0851 12.3188 16.1648 12.0845C15.8383 11.9137 15.555 11.6678 15.3392 11.3651C15.0548 10.9662 14.9018 10.4886 14.9017 9.99871C14.9015 9.50883 15.0541 9.0311 15.3383 8.63203C15.5545 8.32833 15.8387 8.0817 16.1663 7.91059C16.067 7.61733 15.9467 7.3316 15.8064 7.0556C15.4287 7.15195 15.0194 7.15628 14.607 7.05066L14.5987 7.04855C14.2022 6.94219 13.8405 6.73376 13.5495 6.44412C13.2586 6.15447 13.0486 5.79367 12.9405 5.39762C12.8323 4.99967 12.8291 4.58167 12.929 4.18525C12.6569 4.04758 12.3755 3.9293 12.0869 3.83129C11.9159 4.15799 11.6699 4.44152 11.3669 4.65735C10.9681 4.94144 10.4907 5.09412 10.001 5.09412C9.51141 5.09412 9.03396 4.94144 8.63518 4.65735C8.33184 4.44124 8.08549 4.15727 7.91456 3.83004Z",
        fill: "#4B5563"
    }));
};
module.exports.cog_person = $8f255c84151a4506$var$cog_person;

});

parcelRegister("fbysB", function(module, exports) {
"use strict";
var $b0e29d36977feaa2$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $b0e29d36977feaa2$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.coin = void 0;

/* eslint-disable max-len */ const $b0e29d36977feaa2$var$react_1 = $b0e29d36977feaa2$var$__importDefault((parcelRequire("acw62")));

const $b0e29d36977feaa2$var$classnames_1 = $b0e29d36977feaa2$var$__importDefault((parcelRequire("8g1PZ")));
const $b0e29d36977feaa2$var$coin = (_a)=>{
    var { className: className } = _a, rest = $b0e29d36977feaa2$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $b0e29d36977feaa2$var$classnames_1.default)("helix-icon", "coin-outlined", className);
    return $b0e29d36977feaa2$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $b0e29d36977feaa2$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 16.5C13.5899 16.5 16.5 13.5899 16.5 10C16.5 6.41015 13.5899 3.5 10 3.5C6.41015 3.5 3.5 6.41015 3.5 10C3.5 13.5899 6.41015 16.5 10 16.5ZM10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z",
        fill: "#4B5563"
    }), $b0e29d36977feaa2$var$react_1.default.createElement("path", {
        d: "M9.72607 14.7627H10.3438V13.9033C11.8691 13.8013 12.9595 12.9849 12.9595 11.6367C12.9595 10.4604 12.1914 9.86963 10.7251 9.53662L10.3438 9.45605V7.56006C10.9453 7.646 11.3481 7.979 11.4233 8.55908H12.8574C12.8037 7.2915 11.8369 6.45361 10.3438 6.34619V5.4707H9.72607V6.34082C8.24902 6.43213 7.19092 7.26465 7.19092 8.54834C7.19092 9.7085 7.96436 10.3369 9.36621 10.6538L9.72607 10.7397V12.7002C8.99561 12.6196 8.60889 12.2383 8.52295 11.6904H7.0835C7.12109 13.0332 8.2168 13.8228 9.72607 13.9087V14.7627ZM8.69482 8.40869C8.69482 7.979 9.04932 7.62988 9.72607 7.54932V9.31104C9.00098 9.11768 8.69482 8.83838 8.69482 8.40869ZM11.4609 11.8032C11.4609 12.292 11.0903 12.625 10.3438 12.7002V10.8794C11.1763 11.0889 11.4609 11.3306 11.4609 11.8032Z",
        fill: "#4B5563"
    }));
};
module.exports.coin = $b0e29d36977feaa2$var$coin;

});

parcelRegister("6SO53", function(module, exports) {
"use strict";
var $502ea2281f01cab5$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $502ea2281f01cab5$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.collections = void 0;

/* eslint-disable max-len */ const $502ea2281f01cab5$var$react_1 = $502ea2281f01cab5$var$__importDefault((parcelRequire("acw62")));

const $502ea2281f01cab5$var$classnames_1 = $502ea2281f01cab5$var$__importDefault((parcelRequire("8g1PZ")));
const $502ea2281f01cab5$var$collections = (_a)=>{
    var { className: className } = _a, rest = $502ea2281f01cab5$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $502ea2281f01cab5$var$classnames_1.default)("helix-icon", "collections-outlined", className);
    return $502ea2281f01cab5$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $502ea2281f01cab5$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.25 4C3.25 3.58579 3.58579 3.25 4 3.25H7.59999C8.0142 3.25 8.34999 3.58579 8.34999 4V7.59999C8.34999 8.0142 8.0142 8.34999 7.59999 8.34999H4C3.58579 8.34999 3.25 8.0142 3.25 7.59999V4ZM4.75 4.75V6.84999H6.84999V4.75H4.75Z",
        fill: "#4B5563"
    }), $502ea2281f01cab5$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.25 11.2C3.25 10.7858 3.58579 10.45 4 10.45H8.79999C9.2142 10.45 9.54999 10.7858 9.54999 11.2V16C9.54999 16.4142 9.2142 16.75 8.79999 16.75H4C3.58579 16.75 3.25 16.4142 3.25 16V11.2ZM4.75 11.95V15.25H8.04999V11.95H4.75Z",
        fill: "#4B5563"
    }), $502ea2281f01cab5$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.6505 12.4C11.6505 11.9858 11.9863 11.65 12.4005 11.65H16.0005C16.4147 11.65 16.7505 11.9858 16.7505 12.4V16C16.7505 16.4142 16.4147 16.75 16.0005 16.75H12.4005C11.9863 16.75 11.6505 16.4142 11.6505 16V12.4ZM13.1505 13.15V15.25H15.2505V13.15H13.1505Z",
        fill: "#4B5563"
    }), $502ea2281f01cab5$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.4503 4C10.4503 3.58579 10.7861 3.25 11.2003 3.25H16.0002C16.4145 3.25 16.7502 3.58579 16.7502 4V8.79999C16.7502 9.2142 16.4145 9.54999 16.0002 9.54999H11.2003C10.7861 9.54999 10.4503 9.2142 10.4503 8.79999V4ZM11.9503 4.75V8.04999H15.2502V4.75H11.9503Z",
        fill: "#4B5563"
    }));
};
module.exports.collections = $502ea2281f01cab5$var$collections;

});

parcelRegister("4URSy", function(module, exports) {
"use strict";
var $39462f9ce16af945$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $39462f9ce16af945$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.columns = void 0;

const $39462f9ce16af945$var$react_1 = $39462f9ce16af945$var$__importDefault((parcelRequire("acw62")));

const $39462f9ce16af945$var$classnames_1 = $39462f9ce16af945$var$__importDefault((parcelRequire("8g1PZ")));
const $39462f9ce16af945$var$columns = (_a)=>{
    var { className: className } = _a, rest = $39462f9ce16af945$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $39462f9ce16af945$var$classnames_1.default)("helix-icon", "columns-outlined", className);
    return $39462f9ce16af945$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $39462f9ce16af945$var$react_1.default.createElement("path", {
        d: "M3.49994 6.11908C3.49994 5.74698 3.49994 5.56092 3.5445 5.40917C3.64996 5.04999 3.93085 4.7691 4.29003 4.66364C4.44178 4.61908 4.62783 4.61908 4.99994 4.61908C5.37204 4.61908 5.55809 4.61908 5.70984 4.66364C6.06903 4.7691 6.34992 5.04999 6.45538 5.40917C6.49994 5.56092 6.49994 5.74698 6.49994 6.11908V15.1191C6.49994 15.4912 6.49994 15.6772 6.45538 15.829C6.34992 16.1882 6.06903 16.4691 5.70984 16.5745C5.55809 16.6191 5.37204 16.6191 4.99994 16.6191C4.62783 16.6191 4.44178 16.6191 4.29003 16.5745C3.93085 16.4691 3.64996 16.1882 3.5445 15.829C3.49994 15.6772 3.49994 15.4912 3.49994 15.1191V6.11908Z",
        fill: "#4B5563"
    }), $39462f9ce16af945$var$react_1.default.createElement("path", {
        d: "M8.49994 6.11908C8.49994 5.74698 8.49994 5.56092 8.5445 5.40917C8.64996 5.04999 8.93085 4.7691 9.29003 4.66364C9.44178 4.61908 9.62783 4.61908 9.99994 4.61908C10.372 4.61908 10.5581 4.61908 10.7098 4.66364C11.069 4.7691 11.3499 5.04999 11.4554 5.40917C11.4999 5.56092 11.4999 5.74698 11.4999 6.11908V15.1191C11.4999 15.4912 11.4999 15.6772 11.4554 15.829C11.3499 16.1882 11.069 16.4691 10.7098 16.5745C10.5581 16.6191 10.372 16.6191 9.99994 16.6191C9.62783 16.6191 9.44178 16.6191 9.29003 16.5745C8.93085 16.4691 8.64996 16.1882 8.5445 15.829C8.49994 15.6772 8.49994 15.4912 8.49994 15.1191V6.11908Z",
        fill: "#4B5563"
    }), $39462f9ce16af945$var$react_1.default.createElement("path", {
        d: "M13.4999 6.11908C13.4999 5.74698 13.4999 5.56092 13.5445 5.40917C13.65 5.04999 13.9309 4.7691 14.29 4.66364C14.4418 4.61908 14.6278 4.61908 14.9999 4.61908C15.372 4.61908 15.5581 4.61908 15.7098 4.66364C16.069 4.7691 16.3499 5.04999 16.4554 5.40917C16.4999 5.56092 16.4999 5.74698 16.4999 6.11908V15.1191C16.4999 15.4912 16.4999 15.6772 16.4554 15.829C16.3499 16.1882 16.069 16.4691 15.7098 16.5745C15.5581 16.6191 15.372 16.6191 14.9999 16.6191C14.6278 16.6191 14.4418 16.6191 14.29 16.5745C13.9309 16.4691 13.65 16.1882 13.5445 15.829C13.4999 15.6772 13.4999 15.4912 13.4999 15.1191V6.11908Z",
        fill: "#4B5563"
    }));
};
module.exports.columns = $39462f9ce16af945$var$columns;

});

parcelRegister("6bVQQ", function(module, exports) {
"use strict";
var $4820a5340e874d34$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $4820a5340e874d34$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.command = void 0;

/* eslint-disable max-len */ const $4820a5340e874d34$var$react_1 = $4820a5340e874d34$var$__importDefault((parcelRequire("acw62")));

const $4820a5340e874d34$var$classnames_1 = $4820a5340e874d34$var$__importDefault((parcelRequire("8g1PZ")));
const $4820a5340e874d34$var$command = (_a)=>{
    var { className: className } = _a, rest = $4820a5340e874d34$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $4820a5340e874d34$var$classnames_1.default)("helix-icon", "command-outlined", className);
    return $4820a5340e874d34$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $4820a5340e874d34$var$react_1.default.createElement("path", {
        d: "M7.87517 9.02261V10.9707L7.01859 10.9774C5.90305 10.9774 5 11.8551 5 12.9787C5 14.0957 5.90305 15 7.01859 15C8.12749 15 9.03718 14.0891 9.03718 12.9787V12.1277H10.9628V12.9787C10.9628 14.0891 11.8725 15 12.9814 15C14.0969 15 15 14.0957 15 12.9787C15 11.8551 14.0969 10.9774 12.9814 10.9774L12.1182 10.9707V9.02261H12.9814C14.0969 9.01596 15 8.14495 15 7.02128C15 5.90426 14.0969 5 12.9814 5C11.8725 5 10.9628 5.9109 10.9628 7.02128V7.87234H9.03718V7.02128C9.03718 5.9109 8.12749 5 7.01859 5C5.90305 5 5 5.90426 5 7.02128C5 8.14495 5.90305 9.01596 7.01859 9.02261H7.87517ZM7.04515 7.88564C6.55378 7.88564 6.16866 7.5 6.16866 7.02128C6.16866 6.5492 6.55378 6.17021 7.01859 6.17021C7.4834 6.17021 7.87517 6.55585 7.87517 7.04787V7.88564H7.04515ZM12.9548 7.88564H12.1248V7.04787C12.1248 6.55585 12.5166 6.17021 12.9814 6.17021C13.4462 6.17021 13.8313 6.5492 13.8313 7.02128C13.8313 7.5 13.4396 7.88564 12.9548 7.88564ZM9.03718 10.984V9.01596H10.9628V10.984H9.03718ZM7.04515 12.1144H7.87517V12.9455C7.87517 13.4375 7.4834 13.8298 7.01859 13.8298C6.55378 13.8298 6.16866 13.4441 6.16866 12.9721C6.16866 12.5 6.55378 12.1144 7.04515 12.1144ZM12.9548 12.1144C13.4396 12.1144 13.8313 12.5 13.8313 12.9721C13.8313 13.4441 13.4462 13.8298 12.9814 13.8298C12.5166 13.8298 12.1248 13.4375 12.1248 12.9455V12.1144H12.9548Z",
        fill: "#4B5563"
    }));
};
module.exports.command = $4820a5340e874d34$var$command;

});

parcelRegister("ijyes", function(module, exports) {
"use strict";
var $d5548e2252afbe55$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d5548e2252afbe55$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.comment = void 0;

/* eslint-disable max-len */ const $d5548e2252afbe55$var$react_1 = $d5548e2252afbe55$var$__importDefault((parcelRequire("acw62")));

const $d5548e2252afbe55$var$classnames_1 = $d5548e2252afbe55$var$__importDefault((parcelRequire("8g1PZ")));
const $d5548e2252afbe55$var$comment = (_a)=>{
    var { className: className } = _a, rest = $d5548e2252afbe55$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $d5548e2252afbe55$var$classnames_1.default)("helix-icon", "comment-outlined", className);
    return $d5548e2252afbe55$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $d5548e2252afbe55$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 3.75C6.54822 3.75 3.75 6.54822 3.75 10C3.75 13.4518 6.54822 16.25 10 16.25C11.2309 16.25 12.3766 15.8949 13.3429 15.2819C13.5333 15.1611 13.7679 15.1324 13.9818 15.2037L15.8144 15.8144L15.2037 13.9818C15.1324 13.7679 15.1611 13.5333 15.2819 13.3429C15.8949 12.3766 16.25 11.2309 16.25 10C16.25 6.54822 13.4518 3.75 10 3.75ZM2.25 10C2.25 5.71979 5.71979 2.25 10 2.25C14.2802 2.25 17.75 5.71979 17.75 10C17.75 11.394 17.3813 12.7038 16.7359 13.8352L17.7115 16.7629C17.8013 17.0324 17.7312 17.3295 17.5303 17.5303C17.3295 17.7312 17.0324 17.8013 16.7629 17.7115L13.8352 16.7359C12.7038 17.3813 11.394 17.75 10 17.75C5.71979 17.75 2.25 14.2802 2.25 10Z",
        fill: "#4B5563"
    }));
};
module.exports.comment = $d5548e2252afbe55$var$comment;

});

parcelRegister("8KY4J", function(module, exports) {
"use strict";
var $660138568718af30$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $660138568718af30$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.comment_attention = void 0;

/* eslint-disable max-len */ const $660138568718af30$var$react_1 = $660138568718af30$var$__importDefault((parcelRequire("acw62")));

const $660138568718af30$var$classnames_1 = $660138568718af30$var$__importDefault((parcelRequire("8g1PZ")));
const $660138568718af30$var$comment_attention = (_a)=>{
    var { className: className } = _a, rest = $660138568718af30$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $660138568718af30$var$classnames_1.default)("helix-icon", "comment-attention-outlined", className);
    return $660138568718af30$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $660138568718af30$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 4.36902C6.54822 4.36902 3.75 7.16724 3.75 10.619C3.75 14.0708 6.54822 16.869 10 16.869C11.2309 16.869 12.3766 16.5139 13.3429 15.9009C13.5333 15.7802 13.7679 15.7514 13.9818 15.8227L15.8144 16.4334L15.2037 14.6008C15.1324 14.3869 15.1611 14.1523 15.2819 13.9619C15.8949 12.9956 16.25 11.8499 16.25 10.619C16.25 7.16724 13.4518 4.36902 10 4.36902ZM2.25 10.619C2.25 6.33881 5.71979 2.86902 10 2.86902C14.2802 2.86902 17.75 6.33881 17.75 10.619C17.75 12.013 17.3813 13.3228 16.7359 14.4542L17.7115 17.3819C17.8013 17.6514 17.7312 17.9485 17.5303 18.1493C17.3295 18.3502 17.0324 18.4204 16.7629 18.3306L13.8352 17.3549C12.7038 18.0003 11.394 18.369 10 18.369C5.71979 18.369 2.25 14.8992 2.25 10.619Z",
        fill: "#4B5563"
    }), $660138568718af30$var$react_1.default.createElement("path", {
        d: "M10.7273 11.4116C10.7025 11.7927 10.3862 12.0892 10.0043 12.0892C9.62236 12.0892 9.30603 11.7927 9.28129 11.4116L8.94645 7.06477C8.90902 6.48822 9.36658 6 9.94435 6H10.0643C10.6421 6 11.0996 6.48821 11.0622 7.06477L10.7273 11.4116ZM8.90527 14.1192C8.90527 13.8112 9.01261 13.5499 9.22727 13.3352C9.44194 13.1112 9.69861 12.9992 9.99727 12.9992C10.3053 12.9992 10.5666 13.1112 10.7813 13.3352C11.0053 13.5499 11.1173 13.8112 11.1173 14.1192C11.1173 14.4272 11.0053 14.6885 10.7813 14.9032C10.5666 15.1179 10.3053 15.2252 9.99727 15.2252C9.69861 15.2252 9.44194 15.1179 9.22727 14.9032C9.01261 14.6885 8.90527 14.4272 8.90527 14.1192Z",
        fill: "#4B5563"
    }));
};
module.exports.comment_attention = $660138568718af30$var$comment_attention;

});

parcelRegister("bMnfC", function(module, exports) {
"use strict";
var $8936368a3d3b940e$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $8936368a3d3b940e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.comment_notification = void 0;

/* eslint-disable max-len */ const $8936368a3d3b940e$var$react_1 = $8936368a3d3b940e$var$__importDefault((parcelRequire("acw62")));

const $8936368a3d3b940e$var$classnames_1 = $8936368a3d3b940e$var$__importDefault((parcelRequire("8g1PZ")));
const $8936368a3d3b940e$var$comment_notification = (_a)=>{
    var { className: className } = _a, rest = $8936368a3d3b940e$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $8936368a3d3b940e$var$classnames_1.default)("helix-icon", "comment-notification-outlined", className);
    return $8936368a3d3b940e$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $8936368a3d3b940e$var$react_1.default.createElement("path", {
        d: "M17.7095 9.82201C17.7363 10.0841 17.75 10.35 17.75 10.6191C17.75 12.0131 17.3813 13.3229 16.7359 14.4542L17.7115 17.382C17.8013 17.6515 17.7312 17.9486 17.5303 18.1494C17.3295 18.3503 17.0324 18.4204 16.7629 18.3306L13.8352 17.355C12.7038 18.0004 11.394 18.3691 10 18.3691C5.71979 18.3691 2.25 14.8993 2.25 10.6191C2.25 6.33887 5.71979 2.86908 10 2.86908C10.2691 2.86908 10.535 2.8828 10.7971 2.90957C10.5104 3.35337 10.2921 3.84549 10.157 4.37102C10.1048 4.36973 10.0525 4.36908 10 4.36908C6.54822 4.36908 3.75 7.1673 3.75 10.6191C3.75 14.0709 6.54822 16.8691 10 16.8691C11.2309 16.8691 12.3766 16.514 13.3429 15.901C13.5333 15.7802 13.7679 15.7515 13.9818 15.8228L15.8144 16.4334L15.2037 14.6009C15.1324 14.387 15.1611 14.1524 15.2819 13.962C15.8949 12.9957 16.25 11.85 16.25 10.6191C16.25 10.5666 16.2494 10.5142 16.2481 10.4621C16.7736 10.327 17.2657 10.1087 17.7095 9.82201Z",
        fill: "#4B5563"
    }), $8936368a3d3b940e$var$react_1.default.createElement("path", {
        d: "M19.0001 5.61908C19.0001 7.82822 17.2092 9.61908 15.0001 9.61908C12.7909 9.61908 11.0001 7.82822 11.0001 5.61908C11.0001 3.40994 12.7909 1.61908 15.0001 1.61908C17.2092 1.61908 19.0001 3.40994 19.0001 5.61908Z",
        fill: "#B91C1C"
    }));
};
module.exports.comment_notification = $8936368a3d3b940e$var$comment_notification;

});

parcelRegister("jlbwB", function(module, exports) {
"use strict";
var $e148eb151e38de93$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $e148eb151e38de93$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = void 0;

/* eslint-disable max-len */ const $e148eb151e38de93$var$react_1 = $e148eb151e38de93$var$__importDefault((parcelRequire("acw62")));

const $e148eb151e38de93$var$classnames_1 = $e148eb151e38de93$var$__importDefault((parcelRequire("8g1PZ")));
const $e148eb151e38de93$var$copy = (_a)=>{
    var { className: className } = _a, rest = $e148eb151e38de93$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $e148eb151e38de93$var$classnames_1.default)("helix-icon", "copy-outlined", className);
    return $e148eb151e38de93$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e148eb151e38de93$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.5556 6.5H8.44444C7.87491 6.5 7.5 6.93379 7.5 7.36364V15.6364C7.5 16.0662 7.87491 16.5 8.44444 16.5H14.5556C15.1251 16.5 15.5 16.0662 15.5 15.6364V7.36364C15.5 6.93379 15.1251 6.5 14.5556 6.5ZM8.44444 5C7.09442 5 6 6.05824 6 7.36364V15.6364C6 16.9418 7.09441 18 8.44444 18H14.5556C15.9056 18 17 16.9418 17 15.6364V7.36364C17 6.05824 15.9056 5 14.5556 5H8.44444Z",
        fill: "#4B5563"
    }), $e148eb151e38de93$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.21967 2.21967C3.36032 2.07902 3.55109 2 3.75001 2L10.7503 2.00009C11.1645 2.00009 11.5003 2.33588 11.5003 2.75009C11.5003 3.16431 11.1645 3.50009 10.7503 3.50009L4.50002 3.50001L4.5002 11.25C4.50021 11.6642 4.16443 12 3.75022 12C3.336 12 3.00021 11.6642 3.0002 11.25L3 2.75002C3 2.5511 3.07901 2.36033 3.21967 2.21967Z",
        fill: "#4B5563"
    }));
};
module.exports.copy = $e148eb151e38de93$var$copy;

});

parcelRegister("4FM1F", function(module, exports) {
"use strict";
var $36703eadc44d03d2$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $36703eadc44d03d2$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.cross_market_demand = void 0;

/* eslint-disable max-len */ const $36703eadc44d03d2$var$react_1 = $36703eadc44d03d2$var$__importDefault((parcelRequire("acw62")));

const $36703eadc44d03d2$var$classnames_1 = $36703eadc44d03d2$var$__importDefault((parcelRequire("8g1PZ")));
const $36703eadc44d03d2$var$cross_market_demand = (_a)=>{
    var { className: className } = _a, rest = $36703eadc44d03d2$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $36703eadc44d03d2$var$classnames_1.default)("helix-icon", "cross-market-demand-outlined", className);
    return $36703eadc44d03d2$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $36703eadc44d03d2$var$react_1.default.createElement("svg", {
        width: "20",
        height: "21",
        viewBox: "0 0 20 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $36703eadc44d03d2$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 3.86902C2.41421 3.86902 2.75 4.2048 2.75 4.61902V15.869H17.5C17.9142 15.869 18.25 16.2048 18.25 16.619C18.25 17.0332 17.9142 17.369 17.5 17.369H1.25V4.61902C1.25 4.2048 1.58579 3.86902 2 3.86902Z",
        fill: "#4B5563"
    }), $36703eadc44d03d2$var$react_1.default.createElement("path", {
        d: "M2 6.86902C2 6.73095 2.11193 6.61902 2.25 6.61902H13.75C13.8881 6.61902 14 6.73095 14 6.86902V9.36902C14 9.50709 13.8881 9.61902 13.75 9.61902H2.25C2.11193 9.61902 2 9.50709 2 9.36902V6.86902Z",
        fill: "#4B5563"
    }), $36703eadc44d03d2$var$react_1.default.createElement("path", {
        d: "M2 11.869C2 11.7309 2.11193 11.619 2.25 11.619H7.75C7.88807 11.619 8 11.7309 8 11.869V14.369C8 14.5071 7.88807 14.619 7.75 14.619H2.25C2.11193 14.619 2 14.5071 2 14.369V11.869Z",
        fill: "#4B5563"
    })));
};
module.exports.cross_market_demand = $36703eadc44d03d2$var$cross_market_demand;

});

parcelRegister("clCTl", function(module, exports) {
"use strict";
var $8fd59d4b42ed171b$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $8fd59d4b42ed171b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dash_indeterminate = void 0;

/* eslint-disable max-len */ const $8fd59d4b42ed171b$var$react_1 = $8fd59d4b42ed171b$var$__importDefault((parcelRequire("acw62")));

const $8fd59d4b42ed171b$var$classnames_1 = $8fd59d4b42ed171b$var$__importDefault((parcelRequire("8g1PZ")));
const $8fd59d4b42ed171b$var$dash_indeterminate = (_a)=>{
    var { className: className } = _a, rest = $8fd59d4b42ed171b$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $8fd59d4b42ed171b$var$classnames_1.default)("helix-icon", "dash-indeterminate-outlined", className);
    return $8fd59d4b42ed171b$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, rest), $8fd59d4b42ed171b$var$react_1.default.createElement("path", {
        d: "M5 10.8096H15",
        stroke: "#4B5563",
        strokeWidth: "1.5",
        strokeLinecap: "round"
    }));
};
module.exports.dash_indeterminate = $8fd59d4b42ed171b$var$dash_indeterminate;

});

parcelRegister("8bh2K", function(module, exports) {
"use strict";
var $01897e3af22035d4$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $01897e3af22035d4$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.date_range = void 0;

/* eslint-disable max-len */ const $01897e3af22035d4$var$react_1 = $01897e3af22035d4$var$__importDefault((parcelRequire("acw62")));

const $01897e3af22035d4$var$classnames_1 = $01897e3af22035d4$var$__importDefault((parcelRequire("8g1PZ")));
const $01897e3af22035d4$var$date_range = (_a)=>{
    var { className: className } = _a, rest = $01897e3af22035d4$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $01897e3af22035d4$var$classnames_1.default)("helix-icon", "date-range-outlined", className);
    return $01897e3af22035d4$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $01897e3af22035d4$var$react_1.default.createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $01897e3af22035d4$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 4.5H4C3.72386 4.5 3.5 4.72386 3.5 5V15C3.5 15.2761 3.72386 15.5 4 15.5H16C16.2761 15.5 16.5 15.2761 16.5 15V5C16.5 4.72386 16.2761 4.5 16 4.5ZM4 3C2.89543 3 2 3.89543 2 5V15C2 16.1046 2.89543 17 4 17H16C17.1046 17 18 16.1046 18 15V5C18 3.89543 17.1046 3 16 3H4Z",
        fill: "#4B5563"
    }), $01897e3af22035d4$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 2C6.41421 2 6.75 2.33579 6.75 2.75V4.75C6.75 5.16421 6.41421 5.5 6 5.5C5.58579 5.5 5.25 5.16421 5.25 4.75V2.75C5.25 2.33579 5.58579 2 6 2Z",
        fill: "#4B5563"
    }), $01897e3af22035d4$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14 2C14.4142 2 14.75 2.33579 14.75 2.75V4.75C14.75 5.16421 14.4142 5.5 14 5.5C13.5858 5.5 13.25 5.16421 13.25 4.75V2.75C13.25 2.33579 13.5858 2 14 2Z",
        fill: "#4B5563"
    }), $01897e3af22035d4$var$react_1.default.createElement("path", {
        d: "M5 8C5 7.44772 5.44772 7 6 7C6.55228 7 7 7.44772 7 8C7 8.55228 6.55228 9 6 9C5.44772 9 5 8.55228 5 8Z",
        fill: "#4B5563"
    }), $01897e3af22035d4$var$react_1.default.createElement("path", {
        d: "M13 12C13 11.4477 13.4477 11 14 11C14.5523 11 15 11.4477 15 12C15 12.5523 14.5523 13 14 13C13.4477 13 13 12.5523 13 12Z",
        fill: "#4B5563"
    }), $01897e3af22035d4$var$react_1.default.createElement("path", {
        d: "M8 8C8 7.44772 8.44772 7 9 7H14C14.5523 7 15 7.44772 15 8C15 8.55228 14.5523 9 14 9H9C8.44772 9 8 8.55228 8 8Z",
        fill: "#4B5563"
    }), $01897e3af22035d4$var$react_1.default.createElement("path", {
        d: "M5 12C5 11.4477 5.44772 11 6 11H11C11.5523 11 12 11.4477 12 12C12 12.5523 11.5523 13 11 13H6C5.44772 13 5 12.5523 5 12Z",
        fill: "#4B5563"
    })));
};
module.exports.date_range = $01897e3af22035d4$var$date_range;

});

parcelRegister("aZLLg", function(module, exports) {
"use strict";
var $8014a64dfcc94a95$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $8014a64dfcc94a95$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.diamond_exclamation = void 0;

/* eslint-disable max-len */ const $8014a64dfcc94a95$var$react_1 = $8014a64dfcc94a95$var$__importDefault((parcelRequire("acw62")));

const $8014a64dfcc94a95$var$classnames_1 = $8014a64dfcc94a95$var$__importDefault((parcelRequire("8g1PZ")));
const $8014a64dfcc94a95$var$diamond_exclamation = (_a)=>{
    var { className: className } = _a, rest = $8014a64dfcc94a95$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $8014a64dfcc94a95$var$classnames_1.default)("helix-icon", "diamond-exclamation-outlined", className);
    return $8014a64dfcc94a95$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $8014a64dfcc94a95$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.83515 2.79316C8.89269 1.73561 10.6073 1.73562 11.6649 2.79316L17.7068 8.83515C18.7644 9.89269 18.7644 11.6073 17.7068 12.6649L11.6648 18.7068C10.6073 19.7644 8.89269 19.7644 7.83515 18.7068L1.79316 12.6648C0.735613 11.6073 0.735615 9.89269 1.79316 8.83515L7.83515 2.79316ZM10.6042 3.85382C10.1324 3.38206 9.36757 3.38206 8.89581 3.85382L2.85382 9.89581C2.38206 10.3676 2.38206 11.1324 2.85382 11.6042L8.89581 17.6462C9.36757 18.1179 10.1324 18.1179 10.6042 17.6462L16.6462 11.6042C17.1179 11.1324 17.1179 10.3676 16.6462 9.89581L10.6042 3.85382Z",
        fill: "#4B5563"
    }), $8014a64dfcc94a95$var$react_1.default.createElement("path", {
        d: "M10.4802 11.9744C10.4554 12.3555 10.1391 12.652 9.7572 12.652C9.37529 12.652 9.05896 12.3555 9.03422 11.9744L8.69932 6.81477C8.66189 6.23822 9.11944 5.75 9.69722 5.75H9.81719C10.395 5.75 10.8525 6.23821 10.8151 6.81477L10.4802 11.9744ZM8.6582 14.682C8.6582 14.374 8.76554 14.1127 8.9802 13.898C9.19487 13.674 9.45154 13.562 9.7502 13.562C10.0582 13.562 10.3195 13.674 10.5342 13.898C10.7582 14.1127 10.8702 14.374 10.8702 14.682C10.8702 14.99 10.7582 15.2513 10.5342 15.466C10.3195 15.6807 10.0582 15.788 9.7502 15.788C9.45154 15.788 9.19487 15.6807 8.9802 15.466C8.76554 15.2513 8.6582 14.99 8.6582 14.682Z",
        fill: "#4B5563"
    }));
};
module.exports.diamond_exclamation = $8014a64dfcc94a95$var$diamond_exclamation;

});

parcelRegister("aFfDO", function(module, exports) {
"use strict";
var $7c39ddb4503abf84$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $7c39ddb4503abf84$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.doc = void 0;

/* eslint-disable max-len */ const $7c39ddb4503abf84$var$react_1 = $7c39ddb4503abf84$var$__importDefault((parcelRequire("acw62")));

const $7c39ddb4503abf84$var$classnames_1 = $7c39ddb4503abf84$var$__importDefault((parcelRequire("8g1PZ")));
const $7c39ddb4503abf84$var$doc = (_a)=>{
    var { className: className } = _a, rest = $7c39ddb4503abf84$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $7c39ddb4503abf84$var$classnames_1.default)("helix-icon", "doc-outlined", className);
    return $7c39ddb4503abf84$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $7c39ddb4503abf84$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.5 2.25C2.5 1.83579 2.83579 1.5 3.25 1.5H14.25C14.4489 1.5 14.6397 1.57902 14.7803 1.71967L17.7803 4.71967C17.921 4.86032 18 5.05109 18 5.25V18.25C18 18.6642 17.6642 19 17.25 19H3.25C2.83579 19 2.5 18.6642 2.5 18.25V2.25ZM4 3V17.5H16.5V5.56066L13.9393 3H4Z",
        fill: "#4B5563"
    }), $7c39ddb4503abf84$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.25 11.5C5.25 11.0858 5.58579 10.75 6 10.75H14.5C14.9142 10.75 15.25 11.0858 15.25 11.5C15.25 11.9142 14.9142 12.25 14.5 12.25H6C5.58579 12.25 5.25 11.9142 5.25 11.5Z",
        fill: "#4B5563"
    }), $7c39ddb4503abf84$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.25 14.5C5.25 14.0858 5.58579 13.75 6 13.75H14.5C14.9142 13.75 15.25 14.0858 15.25 14.5C15.25 14.9142 14.9142 15.25 14.5 15.25H6C5.58579 15.25 5.25 14.9142 5.25 14.5Z",
        fill: "#4B5563"
    }), $7c39ddb4503abf84$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.5 5.25C5.5 4.83579 5.83579 4.5 6.25 4.5H9.25C9.66421 4.5 10 4.83579 10 5.25V8.25C10 8.66421 9.66421 9 9.25 9H6.25C5.83579 9 5.5 8.66421 5.5 8.25V5.25ZM7 6V7.5H8.5V6H7Z",
        fill: "#4B5563"
    }));
};
module.exports.doc = $7c39ddb4503abf84$var$doc;

});

parcelRegister("gIts4", function(module, exports) {
"use strict";
var $c2b799e91ffbf47d$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $c2b799e91ffbf47d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.document_csv = void 0;

/* eslint-disable max-len */ const $c2b799e91ffbf47d$var$react_1 = $c2b799e91ffbf47d$var$__importDefault((parcelRequire("acw62")));

const $c2b799e91ffbf47d$var$classnames_1 = $c2b799e91ffbf47d$var$__importDefault((parcelRequire("8g1PZ")));
const $c2b799e91ffbf47d$var$document_csv = (_a)=>{
    var { className: className } = _a, rest = $c2b799e91ffbf47d$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $c2b799e91ffbf47d$var$classnames_1.default)("helix-icon", "document_csv-outlined", className);
    return $c2b799e91ffbf47d$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $c2b799e91ffbf47d$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.25 2C2.25 1.58579 2.58579 1.25 3 1.25H14C14.1989 1.25 14.3897 1.32902 14.5303 1.46967L17.5303 4.46967C17.671 4.61032 17.75 4.80109 17.75 5V8H18C18.5523 8 19 8.44772 19 9V15C19 15.5523 18.5523 16 18 16H17.75V18C17.75 18.4142 17.4142 18.75 17 18.75H3C2.58579 18.75 2.25 18.4142 2.25 18V16H2C1.44772 16 1 15.5523 1 15V9C1 8.44772 1.44772 8 2 8H2.25V2ZM16.25 5.31066V8H3.75V2.75H13.6893L16.25 5.31066ZM3.75 17.25V16H16.25V17.25H3.75ZM8.37988 12.8574C8.40332 13.4844 8.85742 14.0732 9.98828 14.0732C11.0664 14.0732 11.6318 13.54 11.6318 12.7812C11.6318 12.0518 11.1455 11.75 10.5361 11.6299L9.95605 11.5098C9.61621 11.4453 9.41992 11.3135 9.41992 11.0996C9.41992 10.8447 9.63086 10.6514 10.0176 10.6514C10.416 10.6514 10.6387 10.8682 10.6709 11.1055H11.5615C11.5381 10.4873 11.0195 9.9248 10.0205 9.9248C9.09473 9.9248 8.46191 10.4023 8.46191 11.1699C8.46191 11.832 8.88965 12.1748 9.52539 12.3066L10.0908 12.4297C10.4834 12.5146 10.6826 12.6289 10.6826 12.8779C10.6826 13.1416 10.4717 13.3379 10.0264 13.3379C9.58984 13.3379 9.3291 13.1211 9.29688 12.8574H8.37988ZM5.46191 11.7822C5.46191 11.1055 5.74316 10.7246 6.22363 10.7246C6.64258 10.7246 6.90332 11.0293 6.92383 11.4365H7.84082V11.3252C7.82031 10.4873 7.14648 9.93066 6.21777 9.93066C5.10449 9.93066 4.48047 10.6426 4.48047 11.7822V12.2275C4.48047 13.3643 5.09863 14.0732 6.21777 14.0732C7.14355 14.0732 7.82031 13.5225 7.84082 12.7021V12.5879H6.92383C6.90332 12.9863 6.64844 13.2764 6.22363 13.2764C5.74023 13.2764 5.46191 12.9043 5.46191 12.2305V11.7822ZM14.4766 14H13.2695L11.9951 10.001H13.1143L13.8789 12.9834H13.9229L14.6758 10.001H15.7363L14.4766 14Z",
        fill: "#4B5563"
    }));
};
module.exports.document_csv = $c2b799e91ffbf47d$var$document_csv;

});

parcelRegister("9vHux", function(module, exports) {
"use strict";
var $6ec8becc8a49f25a$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $6ec8becc8a49f25a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.document_list = void 0;

/* eslint-disable max-len */ const $6ec8becc8a49f25a$var$react_1 = $6ec8becc8a49f25a$var$__importDefault((parcelRequire("acw62")));

const $6ec8becc8a49f25a$var$classnames_1 = $6ec8becc8a49f25a$var$__importDefault((parcelRequire("8g1PZ")));
const $6ec8becc8a49f25a$var$document_list = (_a)=>{
    var { className: className } = _a, rest = $6ec8becc8a49f25a$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $6ec8becc8a49f25a$var$classnames_1.default)("helix-icon", "document-list-outlined", className);
    return $6ec8becc8a49f25a$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $6ec8becc8a49f25a$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.25 2C2.25 1.58579 2.58579 1.25 3 1.25H14C14.1989 1.25 14.3897 1.32902 14.5303 1.46967L17.5303 4.46967C17.671 4.61032 17.75 4.80109 17.75 5V18C17.75 18.4142 17.4142 18.75 17 18.75H3C2.58579 18.75 2.25 18.4142 2.25 18V2ZM3.75 2.75V17.25H16.25V5.31066L13.6893 2.75H3.75Z",
        fill: "#4B5563"
    }), $6ec8becc8a49f25a$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.5 7.25C8.5 6.83579 8.83579 6.5 9.25 6.5H13.75C14.1642 6.5 14.5 6.83579 14.5 7.25C14.5 7.66421 14.1642 8 13.75 8H9.25C8.83579 8 8.5 7.66421 8.5 7.25Z",
        fill: "#4B5563"
    }), $6ec8becc8a49f25a$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.5 10.25C8.5 9.83579 8.83579 9.5 9.25 9.5H12.75C13.1642 9.5 13.5 9.83579 13.5 10.25C13.5 10.6642 13.1642 11 12.75 11H9.25C8.83579 11 8.5 10.6642 8.5 10.25Z",
        fill: "#4B5563"
    }), $6ec8becc8a49f25a$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.5 13.25C8.5 12.8358 8.83579 12.5 9.25 12.5H13.75C14.1642 12.5 14.5 12.8358 14.5 13.25C14.5 13.6642 14.1642 14 13.75 14H9.25C8.83579 14 8.5 13.6642 8.5 13.25Z",
        fill: "#4B5563"
    }), $6ec8becc8a49f25a$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.5 10.25C5.5 9.83579 5.83579 9.5 6.25 9.5H6.75C7.16421 9.5 7.5 9.83579 7.5 10.25C7.5 10.6642 7.16421 11 6.75 11H6.25C5.83579 11 5.5 10.6642 5.5 10.25Z",
        fill: "#4B5563"
    }), $6ec8becc8a49f25a$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.5 7.25C5.5 6.83579 5.83579 6.5 6.25 6.5H6.75C7.16421 6.5 7.5 6.83579 7.5 7.25C7.5 7.66421 7.16421 8 6.75 8H6.25C5.83579 8 5.5 7.66421 5.5 7.25Z",
        fill: "#4B5563"
    }), $6ec8becc8a49f25a$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.5 13.25C5.5 12.8358 5.83579 12.5 6.25 12.5H6.75C7.16421 12.5 7.5 12.8358 7.5 13.25C7.5 13.6642 7.16421 14 6.75 14H6.25C5.83579 14 5.5 13.6642 5.5 13.25Z",
        fill: "#4B5563"
    }));
};
module.exports.document_list = $6ec8becc8a49f25a$var$document_list;

});

parcelRegister("3UIJm", function(module, exports) {
"use strict";
var $2d994ca14f712552$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $2d994ca14f712552$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.document_pdf = void 0;

/* eslint-disable max-len */ const $2d994ca14f712552$var$react_1 = $2d994ca14f712552$var$__importDefault((parcelRequire("acw62")));

const $2d994ca14f712552$var$classnames_1 = $2d994ca14f712552$var$__importDefault((parcelRequire("8g1PZ")));
const $2d994ca14f712552$var$document_pdf = (_a)=>{
    var { className: className } = _a, rest = $2d994ca14f712552$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $2d994ca14f712552$var$classnames_1.default)("helix-icon", "document_pdf-outlined", className);
    return $2d994ca14f712552$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $2d994ca14f712552$var$react_1.default.createElement("path", {
        d: "M6.97363 11.3867C6.97363 11.7998 6.72754 12.0342 6.3291 12.0342H5.82227V10.7393H6.3291C6.72754 10.7393 6.97363 10.9678 6.97363 11.3867Z",
        fill: "#4B5563"
    }), $2d994ca14f712552$var$react_1.default.createElement("path", {
        d: "M9.57227 10.7627H10.0234C10.7031 10.7627 10.9961 11.1846 10.9961 12.0078C10.9961 12.8281 10.7061 13.2354 10.0234 13.2354H9.57227V10.7627Z",
        fill: "#4B5563"
    }), $2d994ca14f712552$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.25 2C2.25 1.58579 2.58579 1.25 3 1.25H14C14.1989 1.25 14.3897 1.32902 14.5303 1.46967L17.5303 4.46967C17.671 4.61032 17.75 4.80109 17.75 5V8H18C18.5523 8 19 8.44772 19 9V15C19 15.5523 18.5523 16 18 16H17.75V18C17.75 18.4142 17.4142 18.75 17 18.75H3C2.58579 18.75 2.25 18.4142 2.25 18V16H2C1.44772 16 1 15.5523 1 15V9C1 8.44772 1.44772 8 2 8H2.25V2ZM16.25 5.31066V8H3.75V2.75H13.6893L16.25 5.31066ZM3.75 17.25V16H16.25V17.25H3.75ZM6.55176 10.001H4.86426V14H5.8252V12.7578H6.54004C7.46289 12.7578 7.94922 12.1514 7.94922 11.3867C7.94922 10.6338 7.47168 10.001 6.55176 10.001ZM8.6084 10.001V14H10.1758C11.4092 14 11.9834 13.2324 11.9834 11.9844C11.9834 10.751 11.4238 10.001 10.1758 10.001H8.6084ZM13.6797 12.4912V14H12.7158V10.001H15.3789V10.7744H13.6797V11.7412H15.2236V12.4912H13.6797Z",
        fill: "#4B5563"
    }));
};
module.exports.document_pdf = $2d994ca14f712552$var$document_pdf;

});

parcelRegister("AYeFO", function(module, exports) {
"use strict";
var $06f21674c537ace1$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $06f21674c537ace1$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.document_question_mark = void 0;

/* eslint-disable max-len */ const $06f21674c537ace1$var$react_1 = $06f21674c537ace1$var$__importDefault((parcelRequire("acw62")));

const $06f21674c537ace1$var$classnames_1 = $06f21674c537ace1$var$__importDefault((parcelRequire("8g1PZ")));
const $06f21674c537ace1$var$document_question_mark = (_a)=>{
    var { className: className } = _a, rest = $06f21674c537ace1$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $06f21674c537ace1$var$classnames_1.default)("helix-icon", "document-question-mark-outlined", className);
    return $06f21674c537ace1$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $06f21674c537ace1$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.25 2C2.25 1.58579 2.58579 1.25 3 1.25H14C14.1989 1.25 14.3897 1.32902 14.5303 1.46967L17.5303 4.46967C17.671 4.61032 17.75 4.80109 17.75 5V18C17.75 18.4142 17.4142 18.75 17 18.75H3C2.58579 18.75 2.25 18.4142 2.25 18V2ZM3.75 2.75V17.25H16.25V5.31066L13.6893 2.75H3.75Z",
        fill: "#4B5563"
    }), $06f21674c537ace1$var$react_1.default.createElement("path", {
        d: "M7 8.44922H8.58789C8.62305 7.78711 9.06836 7.35938 9.74219 7.35938C10.4102 7.35938 10.8555 7.76367 10.8555 8.32031C10.8555 8.87695 10.627 9.16406 9.87109 9.61523C9.0625 10.0898 8.74023 10.6172 8.81641 11.5371L8.82812 11.877H10.3809V11.5664C10.3809 10.9922 10.5977 10.7051 11.377 10.2539C12.2031 9.76758 12.6309 9.15234 12.6309 8.26758C12.6309 6.93164 11.5234 6 9.84766 6C8.04883 6 7.0293 7.00781 7 8.44922ZM9.66602 14.7012C10.3223 14.7012 10.7266 14.3262 10.7266 13.7227C10.7266 13.1133 10.3223 12.7383 9.66602 12.7383C9.00977 12.7383 8.59961 13.1133 8.59961 13.7227C8.59961 14.3262 9.00977 14.7012 9.66602 14.7012Z",
        fill: "#4B5563"
    }));
};
module.exports.document_question_mark = $06f21674c537ace1$var$document_question_mark;

});

parcelRegister("1exJo", function(module, exports) {
"use strict";
var $0e6143884e740869$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $0e6143884e740869$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.document_signed = void 0;

/* eslint-disable max-len */ const $0e6143884e740869$var$react_1 = $0e6143884e740869$var$__importDefault((parcelRequire("acw62")));

const $0e6143884e740869$var$classnames_1 = $0e6143884e740869$var$__importDefault((parcelRequire("8g1PZ")));
const $0e6143884e740869$var$document_signed = (_a)=>{
    var { className: className } = _a, rest = $0e6143884e740869$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $0e6143884e740869$var$classnames_1.default)("helix-icon", "document-signed-outlined", className);
    return $0e6143884e740869$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $0e6143884e740869$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.25 2C2.25 1.58579 2.58579 1.25 3 1.25H14C14.1989 1.25 14.3897 1.32902 14.5303 1.46967L17.5303 4.46967C17.671 4.61032 17.75 4.80109 17.75 5V18C17.75 18.4142 17.4142 18.75 17 18.75H3C2.58579 18.75 2.25 18.4142 2.25 18V2ZM3.75 2.75V17.25H16.25V5.31066L13.6893 2.75H3.75ZM5 7.25C5 6.83579 5.33579 6.5 5.75 6.5L14.25 6.5C14.6642 6.5 15 6.83579 15 7.25C15 7.66421 14.6642 8 14.25 8L5.75 8C5.33579 8 5 7.66421 5 7.25ZM8.54752 12.2799C8.00025 12.7347 7.3748 13.0797 6.77439 13.4109C6.63757 13.4864 6.50205 13.5612 6.36906 13.6363C6.00846 13.8402 5.55091 13.7131 5.34709 13.3525C5.14326 12.9919 5.27035 12.5343 5.63094 12.3305C5.78752 12.242 5.93696 12.1588 6.07966 12.0794C6.94514 11.5977 7.56304 11.2537 8.02492 10.6945C8.1319 10.565 8.35305 10.3218 8.69471 10.2628C8.9002 10.2273 9.1069 10.2665 9.2825 10.3715C9.44087 10.4662 9.53685 10.5916 9.59108 10.6786C9.69268 10.8415 9.7379 11.0183 9.75886 11.106C9.77118 11.1576 9.78914 11.2462 9.79989 11.3L9.81203 11.3334C9.83147 11.3874 9.85792 11.4618 9.88567 11.5428C9.92277 11.6512 9.97854 11.8173 10.0147 11.9598C10.0187 11.9655 10.0233 11.9719 10.0285 11.979C10.0581 12.0193 10.0966 12.0665 10.1393 12.1141C10.315 12.021 10.4726 11.9546 10.5858 11.9068C10.6131 11.8953 10.6379 11.8849 10.6597 11.8754C10.5 12 10.857 11.7266 10.857 11.6258C10.857 11.6258 10.8823 11.5954 10.9399 11.5096C10.9545 11.4879 10.9731 11.4594 10.9944 11.4268C11.0531 11.337 11.1319 11.2164 11.2 11.1247C11.2516 11.0553 11.3194 10.9703 11.4012 10.8917C11.476 10.8198 11.6101 10.706 11.8008 10.6428C12.0267 10.568 12.295 10.5786 12.5365 10.7252C12.6556 10.7976 12.7442 10.8888 12.8099 10.9769C12.8562 10.9695 12.9177 10.9568 12.9971 10.9359C13.0764 10.9151 13.1571 10.8908 13.2463 10.8638L13.2595 10.8598C13.3396 10.8355 13.4337 10.807 13.521 10.7846C13.6044 10.7632 13.7364 10.7324 13.8756 10.7289C13.9732 10.7265 14.3533 10.7272 14.6046 11.0694C14.8497 11.4033 14.7777 11.8727 14.4439 12.1178C14.2669 12.2477 14.052 12.2886 13.8525 12.2486C13.8065 12.2614 13.7518 12.278 13.681 12.2994C13.5944 12.3256 13.4884 12.3577 13.3785 12.3866C13.1744 12.4403 12.8738 12.507 12.5698 12.4796C12.4404 12.468 12.2999 12.4374 12.1627 12.379C12.1239 12.4359 12.0791 12.4989 12.0306 12.5593C12.0243 12.567 12.0177 12.5752 12.0107 12.5836C11.9452 12.745 11.8413 12.8771 11.7245 12.9779C11.5659 13.1149 11.3781 13.1983 11.2728 13.2445C11.2291 13.2636 11.1873 13.2816 11.1469 13.2988C10.9472 13.3844 10.7833 13.4547 10.604 13.5869C10.3466 13.7768 10.0706 13.7627 9.91602 13.7302C9.76409 13.6982 9.64136 13.6332 9.56325 13.5858C9.40183 13.4879 9.25412 13.3551 9.14157 13.2417C9.02329 13.1225 8.91 12.9902 8.81929 12.8666C8.77417 12.8051 8.72788 12.7367 8.68796 12.6662C8.6584 12.614 8.59177 12.4923 8.56391 12.3405C8.56391 12.3405 8.55972 12.322 8.54752 12.2799Z",
        fill: "#4B5563"
    }));
};
module.exports.document_signed = $0e6143884e740869$var$document_signed;

});

parcelRegister("2xnG6", function(module, exports) {
"use strict";
var $1d9107ca50506063$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $1d9107ca50506063$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.document_warning = void 0;

/* eslint-disable max-len */ const $1d9107ca50506063$var$react_1 = $1d9107ca50506063$var$__importDefault((parcelRequire("acw62")));

const $1d9107ca50506063$var$classnames_1 = $1d9107ca50506063$var$__importDefault((parcelRequire("8g1PZ")));
const $1d9107ca50506063$var$document_warning = (_a)=>{
    var { className: className } = _a, rest = $1d9107ca50506063$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $1d9107ca50506063$var$classnames_1.default)("helix-icon", "document-warning-outlined", className);
    return $1d9107ca50506063$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $1d9107ca50506063$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.25 2C2.25 1.58579 2.58579 1.25 3 1.25H14C14.1989 1.25 14.3897 1.32902 14.5303 1.46967L17.5303 4.46967C17.671 4.61032 17.75 4.80109 17.75 5V18C17.75 18.4142 17.4142 18.75 17 18.75H3C2.58579 18.75 2.25 18.4142 2.25 18V2ZM3.75 2.75V17.25H16.25V5.31066L13.6893 2.75H3.75Z",
        fill: "#4B5563"
    }), $1d9107ca50506063$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.0575 6.65381C10.6218 5.78207 9.37823 5.78206 8.94253 6.6538L6.12634 12.2883C5.73329 13.0747 6.30492 14 7.18382 14H12.8162C13.6951 14 14.2667 13.0747 13.8737 12.2883L11.0575 6.65381ZM9.64203 11.1122L9.47451 8.53239C9.4558 8.24411 9.68466 8 9.97365 8H10.0337C10.3227 8 10.5515 8.24411 10.5328 8.53239L10.3653 11.1122C10.3529 11.3028 10.1947 11.451 10.0037 11.451C9.81263 11.451 9.6544 11.3028 9.64203 11.1122ZM9.45395 12.466C9.45395 12.312 9.50764 12.1813 9.61501 12.074C9.72238 11.962 9.85077 11.906 10.0002 11.906C10.1542 11.906 10.2849 11.962 10.3923 12.074C10.5044 12.1813 10.5604 12.312 10.5604 12.466C10.5604 12.62 10.5044 12.7507 10.3923 12.858C10.2849 12.9653 10.1542 13.019 10.0002 13.019C9.85077 13.019 9.72238 12.9653 9.61501 12.858C9.50764 12.7507 9.45395 12.62 9.45395 12.466Z",
        fill: "#4B5563"
    }));
};
module.exports.document_warning = $1d9107ca50506063$var$document_warning;

});

parcelRegister("36dIM", function(module, exports) {
"use strict";
var $241c93638140b112$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $241c93638140b112$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dollar_bill = void 0;

/* eslint-disable max-len */ const $241c93638140b112$var$react_1 = $241c93638140b112$var$__importDefault((parcelRequire("acw62")));

const $241c93638140b112$var$classnames_1 = $241c93638140b112$var$__importDefault((parcelRequire("8g1PZ")));
const $241c93638140b112$var$dollar_bill = (_a)=>{
    var { className: className } = _a, rest = $241c93638140b112$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $241c93638140b112$var$classnames_1.default)("helix-icon", "dollar-bill-outlined", className);
    return $241c93638140b112$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $241c93638140b112$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 15.75C1.58579 15.75 1.25 15.4142 1.25 15L1.25 5C1.25 4.58579 1.58579 4.25 2 4.25L18 4.25C18.4142 4.25 18.75 4.58579 18.75 5V15C18.75 15.4142 18.4142 15.75 18 15.75L2 15.75ZM2.75 14.25L17.25 14.25V5.75L2.75 5.75L2.75 14.25Z",
        fill: "#4B5563"
    }), $241c93638140b112$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 10.75H13.5V9.25H16V10.75Z",
        fill: "#4B5563"
    }), $241c93638140b112$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.5 10.75H4V9.25H6.5V10.75Z",
        fill: "#4B5563"
    }), $241c93638140b112$var$react_1.default.createElement("path", {
        d: "M9.80078 13.5547H10.25V12.9297C11.3594 12.8555 12.1523 12.2617 12.1523 11.2812C12.1523 10.4258 11.5937 9.99609 10.5273 9.75391L10.25 9.69531V8.31641C10.6875 8.37891 10.9805 8.62109 11.0352 9.04297H12.0781C12.0391 8.12109 11.3359 7.51172 10.25 7.43359V6.79687H9.80078V7.42969C8.72656 7.49609 7.95703 8.10156 7.95703 9.03516C7.95703 9.87891 8.51953 10.3359 9.53906 10.5664L9.80078 10.6289V12.0547C9.26953 11.9961 8.98828 11.7188 8.92578 11.3203H7.87891C7.90625 12.2969 8.70312 12.8711 9.80078 12.9336V13.5547ZM9.05078 8.93359C9.05078 8.62109 9.30859 8.36719 9.80078 8.30859V9.58984C9.27344 9.44922 9.05078 9.24609 9.05078 8.93359ZM11.0625 11.4023C11.0625 11.7578 10.793 12 10.25 12.0547V10.7305C10.8555 10.8828 11.0625 11.0586 11.0625 11.4023Z",
        fill: "#4B5563"
    }));
};
module.exports.dollar_bill = $241c93638140b112$var$dollar_bill;

});

parcelRegister("iKJGH", function(module, exports) {
"use strict";
var $da6ff67f824c85c0$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $da6ff67f824c85c0$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dots = void 0;

/* eslint-disable max-len */ const $da6ff67f824c85c0$var$react_1 = $da6ff67f824c85c0$var$__importDefault((parcelRequire("acw62")));

const $da6ff67f824c85c0$var$classnames_1 = $da6ff67f824c85c0$var$__importDefault((parcelRequire("8g1PZ")));
const $da6ff67f824c85c0$var$dots = (_a)=>{
    var { className: className } = _a, rest = $da6ff67f824c85c0$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $da6ff67f824c85c0$var$classnames_1.default)("helix-icon", "dots-outlined", className);
    return $da6ff67f824c85c0$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $da6ff67f824c85c0$var$react_1.default.createElement("circle", {
        cx: "7",
        cy: "10",
        r: "3",
        fill: "#4B5563"
    }), $da6ff67f824c85c0$var$react_1.default.createElement("circle", {
        cx: "13",
        cy: "10",
        r: "3",
        fill: "#4B5563"
    }));
};
module.exports.dots = $da6ff67f824c85c0$var$dots;

});

parcelRegister("gtD5m", function(module, exports) {
"use strict";
var $bfedac5b868870ac$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $bfedac5b868870ac$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.drag_arrows = void 0;

/* eslint-disable max-len */ const $bfedac5b868870ac$var$react_1 = $bfedac5b868870ac$var$__importDefault((parcelRequire("acw62")));

const $bfedac5b868870ac$var$classnames_1 = $bfedac5b868870ac$var$__importDefault((parcelRequire("8g1PZ")));
const $bfedac5b868870ac$var$drag_arrows = (_a)=>{
    var { className: className } = _a, rest = $bfedac5b868870ac$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $bfedac5b868870ac$var$classnames_1.default)("helix-icon", "drag-arrows-outlined", className);
    return $bfedac5b868870ac$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $bfedac5b868870ac$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.97503 2.46434C9.26665 2.17855 9.7333 2.17855 10.0249 2.46434L12.6201 5.00755C12.9159 5.29746 12.9207 5.77231 12.6308 6.06815C12.3409 6.36399 11.866 6.36879 11.5702 6.07888L10.25 4.78508V9.75003L15.2149 9.75003L13.9211 8.4298C13.6312 8.13396 13.636 7.65911 13.9318 7.3692C14.2277 7.07928 14.7025 7.08408 14.9925 7.37992L17.5357 9.97509C17.8214 10.2667 17.8214 10.7333 17.5357 11.025L14.9925 13.6201C14.7025 13.916 14.2277 13.9208 13.9318 13.6309C13.636 13.3409 13.6312 12.8661 13.9211 12.5702L15.2149 11.25L10.25 11.25V16.2149L11.5702 14.9211C11.866 14.6312 12.3409 14.636 12.6308 14.9318C12.9207 15.2277 12.9159 15.7025 12.6201 15.9925L10.0249 18.5357C9.7333 18.8214 9.26665 18.8214 8.97503 18.5357L6.37987 15.9925C6.08403 15.7025 6.07923 15.2277 6.36914 14.9318C6.65906 14.636 7.13391 14.6312 7.42975 14.9211L8.74997 16.2149L8.74997 11.25H3.78508L5.07888 12.5702C5.36879 12.8661 5.36399 13.3409 5.06815 13.6309C4.77231 13.9208 4.29746 13.916 4.00755 13.6201L1.46434 11.025C1.17855 10.7333 1.17855 10.2667 1.46434 9.97508L4.00755 7.37992C4.29746 7.08408 4.77231 7.07928 5.06815 7.3692C5.36399 7.65911 5.36879 8.13396 5.07888 8.4298L3.78508 9.75002L8.74997 9.75002V4.78508L7.42975 6.07888C7.13391 6.36879 6.65906 6.36399 6.36914 6.06815C6.07923 5.77231 6.08403 5.29746 6.37987 5.00755L8.97503 2.46434Z",
        fill: "#4B5563"
    }));
};
module.exports.drag_arrows = $bfedac5b868870ac$var$drag_arrows;

});

parcelRegister("5QmN3", function(module, exports) {
"use strict";
var $44137cbf21282ed8$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $44137cbf21282ed8$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.drag_handle = void 0;

/* eslint-disable max-len */ const $44137cbf21282ed8$var$react_1 = $44137cbf21282ed8$var$__importDefault((parcelRequire("acw62")));

const $44137cbf21282ed8$var$classnames_1 = $44137cbf21282ed8$var$__importDefault((parcelRequire("8g1PZ")));
const $44137cbf21282ed8$var$drag_handle = (_a)=>{
    var { className: className } = _a, rest = $44137cbf21282ed8$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $44137cbf21282ed8$var$classnames_1.default)("helix-icon", "drag-handle", className);
    return $44137cbf21282ed8$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $44137cbf21282ed8$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 4C7 4.55 7.45 5 8 5C8.55 5 9 4.55 9 4C9 3.45 8.55 3 8 3C7.45 3 7 3.45 7 4Z",
        fill: "#4B5563"
    }), $44137cbf21282ed8$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11 4C11 4.55 11.45 5 12 5C12.55 5 13 4.55 13 4C13 3.45 12.55 3 12 3C11.45 3 11 3.45 11 4Z",
        fill: "#4B5563"
    }), $44137cbf21282ed8$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 12C7 12.55 7.45 13 8 13C8.55 13 9 12.55 9 12C9 11.45 8.55 11 8 11C7.45 11 7 11.45 7 12Z",
        fill: "#4B5563"
    }), $44137cbf21282ed8$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 8C7 8.55 7.45 9 8 9C8.55 9 9 8.55 9 8C9 7.45 8.55 7 8 7C7.45 7 7 7.45 7 8Z",
        fill: "#4B5563"
    }), $44137cbf21282ed8$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11 12C11 12.55 11.45 13 12 13C12.55 13 13 12.55 13 12C13 11.45 12.55 11 12 11C11.45 11 11 11.45 11 12Z",
        fill: "#4B5563"
    }), $44137cbf21282ed8$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11 8C11 8.55 11.45 9 12 9C12.55 9 13 8.55 13 8C13 7.45 12.55 7 12 7C11.45 7 11 7.45 11 8Z",
        fill: "#4B5563"
    }), $44137cbf21282ed8$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 16C7 16.55 7.45 17 8 17C8.55 17 9 16.55 9 16C9 15.45 8.55 15 8 15C7.45 15 7 15.45 7 16Z",
        fill: "#4B5563"
    }), $44137cbf21282ed8$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11 16C11 16.55 11.45 17 12 17C12.55 17 13 16.55 13 16C13 15.45 12.55 15 12 15C11.45 15 11 15.45 11 16Z",
        fill: "#4B5563"
    }));
};
module.exports.drag_handle = $44137cbf21282ed8$var$drag_handle;

});

parcelRegister("lSFVZ", function(module, exports) {
"use strict";
var $fedf2b6d0401ad10$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $fedf2b6d0401ad10$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.drawer_close = void 0;

/* eslint-disable max-len */ const $fedf2b6d0401ad10$var$react_1 = $fedf2b6d0401ad10$var$__importDefault((parcelRequire("acw62")));

const $fedf2b6d0401ad10$var$classnames_1 = $fedf2b6d0401ad10$var$__importDefault((parcelRequire("8g1PZ")));
const $fedf2b6d0401ad10$var$drawer_close = (_a)=>{
    var { className: className } = _a, rest = $fedf2b6d0401ad10$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $fedf2b6d0401ad10$var$classnames_1.default)("helix-icon", "drawer-close-outlined", className);
    return $fedf2b6d0401ad10$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $fedf2b6d0401ad10$var$react_1.default.createElement("path", {
        d: "M19.0607 14.25C19.0607 14.6642 18.7249 15 18.3107 15L9.81066 15C9.39645 15 9.06066 14.6642 9.06066 14.25C9.06066 13.8358 9.39645 13.5 9.81066 13.5L18.3107 13.5C18.7249 13.5 19.0607 13.8358 19.0607 14.25Z",
        fill: "#4B5563"
    }), $fedf2b6d0401ad10$var$react_1.default.createElement("path", {
        d: "M6.59099 6.53033C6.88388 6.23744 6.88388 5.76256 6.59099 5.46967C6.2981 5.17678 5.82322 5.17678 5.53033 5.46967L1 10L5.53033 14.5303C5.82322 14.8232 6.2981 14.8232 6.59099 14.5303C6.88388 14.2374 6.88388 13.7626 6.59099 13.4697L3.87132 10.75L18.0607 10.75C18.4749 10.75 18.8107 10.4142 18.8107 10C18.8107 9.58579 18.4749 9.25 18.0607 9.25L3.87132 9.25L6.59099 6.53033Z",
        fill: "#4B5563"
    }), $fedf2b6d0401ad10$var$react_1.default.createElement("path", {
        d: "M18.3107 6.5C18.7249 6.5 19.0607 6.16421 19.0607 5.75C19.0607 5.33579 18.7249 5 18.3107 5L9.81066 5C9.39645 5 9.06066 5.33579 9.06066 5.75C9.06066 6.16421 9.39645 6.5 9.81066 6.5L18.3107 6.5Z",
        fill: "#4B5563"
    }));
};
module.exports.drawer_close = $fedf2b6d0401ad10$var$drawer_close;

});

parcelRegister("evDsw", function(module, exports) {
"use strict";
var $a90291b297fcefaa$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $a90291b297fcefaa$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.drawer_open = void 0;

/* eslint-disable max-len */ const $a90291b297fcefaa$var$react_1 = $a90291b297fcefaa$var$__importDefault((parcelRequire("acw62")));

const $a90291b297fcefaa$var$classnames_1 = $a90291b297fcefaa$var$__importDefault((parcelRequire("8g1PZ")));
const $a90291b297fcefaa$var$drawer_open = (_a)=>{
    var { className: className } = _a, rest = $a90291b297fcefaa$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $a90291b297fcefaa$var$classnames_1.default)("helix-icon", "drawer-open-outlined", className);
    return $a90291b297fcefaa$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $a90291b297fcefaa$var$react_1.default.createElement("path", {
        d: "M1 5.75C1 5.33579 1.33579 5 1.75 5H10.25C10.6642 5 11 5.33579 11 5.75C11 6.16421 10.6642 6.5 10.25 6.5H1.75C1.33579 6.5 1 6.16421 1 5.75Z",
        fill: "#4B5563"
    }), $a90291b297fcefaa$var$react_1.default.createElement("path", {
        d: "M13.4697 13.4697C13.1768 13.7626 13.1768 14.2374 13.4697 14.5303C13.7626 14.8232 14.2374 14.8232 14.5303 14.5303L19.0607 10L14.5303 5.46967C14.2374 5.17678 13.7626 5.17678 13.4697 5.46967C13.1768 5.76256 13.1768 6.23744 13.4697 6.53033L16.1893 9.25H2C1.58579 9.25 1.25 9.58579 1.25 10C1.25 10.4142 1.58579 10.75 2 10.75H16.1893L13.4697 13.4697Z",
        fill: "#4B5563"
    }), $a90291b297fcefaa$var$react_1.default.createElement("path", {
        d: "M1.75 13.5C1.33579 13.5 1 13.8358 1 14.25C1 14.6642 1.33579 15 1.75 15H10.25C10.6642 15 11 14.6642 11 14.25C11 13.8358 10.6642 13.5 10.25 13.5H1.75Z",
        fill: "#4B5563"
    }));
};
module.exports.drawer_open = $a90291b297fcefaa$var$drawer_open;

});

parcelRegister("apMUT", function(module, exports) {
"use strict";
var $79522f03e435d1b7$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $79522f03e435d1b7$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.email = void 0;

const $79522f03e435d1b7$var$react_1 = $79522f03e435d1b7$var$__importDefault((parcelRequire("acw62")));

const $79522f03e435d1b7$var$classnames_1 = $79522f03e435d1b7$var$__importDefault((parcelRequire("8g1PZ")));
const $79522f03e435d1b7$var$email = (_a)=>{
    var { className: className } = _a, rest = $79522f03e435d1b7$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $79522f03e435d1b7$var$classnames_1.default)("helix-icon", "email-outlined", className);
    return $79522f03e435d1b7$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $79522f03e435d1b7$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        // eslint-disable-next-line max-len
        d: "M1.25 4C1.25 3.58579 1.58579 3.25 2 3.25H18C18.4142 3.25 18.75 3.58579 18.75 4V16C18.75 16.4142 18.4142 16.75 18 16.75H2C1.58579 16.75 1.25 16.4142 1.25 16V4ZM3.99609 4.75L10 10.0034L16.0039 4.75H3.99609ZM17.25 5.65283L10.4939 11.5644C10.2111 11.8119 9.78889 11.8119 9.50612 11.5644L2.75 5.65283V15.25H17.25V5.65283Z",
        fill: "#4B5563"
    }));
};
module.exports.email = $79522f03e435d1b7$var$email;

});

parcelRegister("1Dy8G", function(module, exports) {
"use strict";
var $1313ea3e26130643$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $1313ea3e26130643$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.export_icon = void 0;

/* eslint-disable max-len */ const $1313ea3e26130643$var$react_1 = $1313ea3e26130643$var$__importDefault((parcelRequire("acw62")));

const $1313ea3e26130643$var$classnames_1 = $1313ea3e26130643$var$__importDefault((parcelRequire("8g1PZ")));
const $1313ea3e26130643$var$export_icon = (_a)=>{
    var { className: className } = _a, rest = $1313ea3e26130643$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $1313ea3e26130643$var$classnames_1.default)("helix-icon", "export-outlined", className);
    return $1313ea3e26130643$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $1313ea3e26130643$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.25 4.7381C3.25 4.04774 3.80964 3.4881 4.5 3.4881H8C8.41421 3.4881 8.75 3.82388 8.75 4.2381C8.75 4.65231 8.41421 4.9881 8 4.9881H4.75V15.4881H8C8.41421 15.4881 8.75 15.8239 8.75 16.2381C8.75 16.6523 8.41421 16.9881 8 16.9881H4.5C3.80964 16.9881 3.25 16.4285 3.25 15.7381V4.7381ZM13.0199 6.66193C13.3381 6.39676 13.811 6.43975 14.0762 6.75796L16.5762 9.75796C16.8079 10.0361 16.8079 10.4401 16.5762 10.7182L14.0762 13.7182C13.811 14.0364 13.3381 14.0794 13.0199 13.8143C12.7017 13.5491 12.6587 13.0762 12.9238 12.758L14.3987 10.9881H8C7.58579 10.9881 7.25 10.6523 7.25 10.2381C7.25 9.82388 7.58579 9.4881 8 9.4881H14.3987L12.9238 7.71824C12.6587 7.40003 12.7017 6.92711 13.0199 6.66193Z",
        fill: "#4B5563"
    }));
};
module.exports.export_icon = $1313ea3e26130643$var$export_icon;

});

parcelRegister("cZSNF", function(module, exports) {
"use strict";
var $9765b0ad255a2527$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $9765b0ad255a2527$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.eye = void 0;

/* eslint-disable max-len */ const $9765b0ad255a2527$var$react_1 = $9765b0ad255a2527$var$__importDefault((parcelRequire("acw62")));

const $9765b0ad255a2527$var$classnames_1 = $9765b0ad255a2527$var$__importDefault((parcelRequire("8g1PZ")));
const $9765b0ad255a2527$var$eye = (_a)=>{
    var { className: className } = _a, rest = $9765b0ad255a2527$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $9765b0ad255a2527$var$classnames_1.default)("helix-icon", "eye-outlined", className);
    return $9765b0ad255a2527$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $9765b0ad255a2527$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0.0619922 9.79209C1.62387 5.82872 5.48017 3.01714 9.99967 3.01714C14.5192 3.01714 18.3755 5.82872 19.9373 9.79209C20.007 9.9688 20.007 10.1653 19.9373 10.342C18.3755 14.3054 14.5192 17.117 9.99967 17.117C5.48017 17.117 1.62387 14.3054 0.0619922 10.342C-0.00764322 10.1653 -0.00764322 9.9688 0.0619922 9.79209ZM1.57109 10.0671C2.98213 13.3328 6.22435 15.617 9.99967 15.617C13.775 15.617 17.0172 13.3328 18.4282 10.0671C17.0172 6.80135 13.775 4.51714 9.99967 4.51714C6.22435 4.51714 2.98213 6.80135 1.57109 10.0671Z",
        fill: "#4B5563"
    }), $9765b0ad255a2527$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 7.74998C8.75736 7.74998 7.75 8.75734 7.75 9.99998C7.75 11.2426 8.75736 12.25 10 12.25C11.2426 12.25 12.25 11.2426 12.25 9.99998C12.25 8.75734 11.2426 7.74998 10 7.74998ZM6.25 9.99998C6.25 7.92892 7.92893 6.24998 10 6.24998C12.0711 6.24998 13.75 7.92892 13.75 9.99998C13.75 12.0711 12.0711 13.75 10 13.75C7.92893 13.75 6.25 12.0711 6.25 9.99998Z",
        fill: "#4B5563"
    }));
};
module.exports.eye = $9765b0ad255a2527$var$eye;

});

parcelRegister("fbkEM", function(module, exports) {
"use strict";
var $b0d7e819f7436f5d$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $b0d7e819f7436f5d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.eye_off = void 0;

/* eslint-disable max-len */ const $b0d7e819f7436f5d$var$react_1 = $b0d7e819f7436f5d$var$__importDefault((parcelRequire("acw62")));

const $b0d7e819f7436f5d$var$classnames_1 = $b0d7e819f7436f5d$var$__importDefault((parcelRequire("8g1PZ")));
const $b0d7e819f7436f5d$var$eye_off = (_a)=>{
    var { className: className } = _a, rest = $b0d7e819f7436f5d$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $b0d7e819f7436f5d$var$classnames_1.default)("helix-icon", "eye-off-outlined", className);
    return $b0d7e819f7436f5d$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $b0d7e819f7436f5d$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0.0522265 9.54209C1.6059 5.59954 5.20899 2.76714 9.74967 2.76714C14.2903 2.76714 17.8941 5.59948 19.4478 9.54209C19.5174 9.7188 19.5174 9.91534 19.4478 10.092C17.8941 14.0347 14.2903 16.867 9.74967 16.867C5.20899 16.867 1.6059 14.0346 0.0522265 10.092C-0.0174088 9.91534 -0.0174088 9.7188 0.0522265 9.54209ZM1.5608 9.81707C2.96742 13.1017 5.99435 15.367 9.74967 15.367C13.505 15.367 16.5326 13.1017 17.9392 9.81707C16.5326 6.53244 13.505 4.26714 9.74967 4.26714C5.99435 4.26714 2.96742 6.53239 1.5608 9.81707Z",
        fill: "#4B5563"
    }), $b0d7e819f7436f5d$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.75 7.5C8.50736 7.5 7.5 8.50736 7.5 9.75C7.5 10.9926 8.50736 12 9.75 12C10.9926 12 12 10.9926 12 9.75C12 8.50736 10.9926 7.5 9.75 7.5ZM6 9.75C6 7.67893 7.67893 6 9.75 6C11.8211 6 13.5 7.67893 13.5 9.75C13.5 11.8211 11.8211 13.5 9.75 13.5C7.67893 13.5 6 11.8211 6 9.75Z",
        fill: "#4B5563"
    }), $b0d7e819f7436f5d$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.21967 18.2803C0.926777 17.9874 0.926777 17.5126 1.21967 17.2197L17.2197 1.21967C17.5126 0.926777 17.9874 0.926777 18.2803 1.21967C18.5732 1.51256 18.5732 1.98744 18.2803 2.28033L2.28033 18.2803C1.98744 18.5732 1.51256 18.5732 1.21967 18.2803Z",
        fill: "#4B5563"
    }));
};
module.exports.eye_off = $b0d7e819f7436f5d$var$eye_off;

});

parcelRegister("dJ7np", function(module, exports) {
"use strict";
var $9fe53329322b4e00$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $9fe53329322b4e00$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.filter = void 0;

const $9fe53329322b4e00$var$react_1 = $9fe53329322b4e00$var$__importDefault((parcelRequire("acw62")));

const $9fe53329322b4e00$var$classnames_1 = $9fe53329322b4e00$var$__importDefault((parcelRequire("8g1PZ")));
const $9fe53329322b4e00$var$filter = (_a)=>{
    var { className: className } = _a, rest = $9fe53329322b4e00$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $9fe53329322b4e00$var$classnames_1.default)("helix-icon", "filter-outlined", className);
    return $9fe53329322b4e00$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $9fe53329322b4e00$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        // eslint-disable-next-line max-len
        d: "M1.25 6C1.25 5.58579 1.58579 5.25 2 5.25H18C18.4142 5.25 18.75 5.58579 18.75 6C18.75 6.41421 18.4142 6.75 18 6.75H2C1.58579 6.75 1.25 6.41421 1.25 6ZM4.25 10C4.25 9.58579 4.58579 9.25 5 9.25H15C15.4142 9.25 15.75 9.58579 15.75 10C15.75 10.4142 15.4142 10.75 15 10.75H5C4.58579 10.75 4.25 10.4142 4.25 10ZM7.25 14C7.25 13.5858 7.58579 13.25 8 13.25H12C12.4142 13.25 12.75 13.5858 12.75 14C12.75 14.4142 12.4142 14.75 12 14.75H8C7.58579 14.75 7.25 14.4142 7.25 14Z",
        fill: "#4B5563"
    }));
};
module.exports.filter = $9fe53329322b4e00$var$filter;

});

parcelRegister("9h6PV", function(module, exports) {
"use strict";
var $6c0b013058ac4459$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $6c0b013058ac4459$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.folder = void 0;

/* eslint-disable max-len */ const $6c0b013058ac4459$var$react_1 = $6c0b013058ac4459$var$__importDefault((parcelRequire("acw62")));

const $6c0b013058ac4459$var$classnames_1 = $6c0b013058ac4459$var$__importDefault((parcelRequire("8g1PZ")));
const $6c0b013058ac4459$var$folder = (_a)=>{
    var { className: className } = _a, rest = $6c0b013058ac4459$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $6c0b013058ac4459$var$classnames_1.default)("helix-icon", "folder-outlined", className);
    return $6c0b013058ac4459$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $6c0b013058ac4459$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 4.25C2.86193 4.25 2.75 4.36193 2.75 4.5V15C2.75 15.1381 2.86193 15.25 3 15.25H17C17.1381 15.25 17.25 15.1381 17.25 15V7C17.25 6.86193 17.1381 6.75 17 6.75H9.5C9.23655 6.75 8.99242 6.61178 8.85688 6.38587L7.57536 4.25H3ZM1.25 4.5C1.25 3.5335 2.0335 2.75 3 2.75H8C8.26345 2.75 8.50758 2.88822 8.64312 3.11413L9.92464 5.25H17C17.9665 5.25 18.75 6.0335 18.75 7V15C18.75 15.9665 17.9665 16.75 17 16.75H3C2.0335 16.75 1.25 15.9665 1.25 15V4.5Z",
        fill: "#4B5563"
    }));
};
module.exports.folder = $6c0b013058ac4459$var$folder;

});

parcelRegister("bqxkB", function(module, exports) {
"use strict";
var $851bfa4cb4619e95$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $851bfa4cb4619e95$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.folders = void 0;

/* eslint-disable max-len */ const $851bfa4cb4619e95$var$react_1 = $851bfa4cb4619e95$var$__importDefault((parcelRequire("acw62")));

const $851bfa4cb4619e95$var$classnames_1 = $851bfa4cb4619e95$var$__importDefault((parcelRequire("8g1PZ")));
const $851bfa4cb4619e95$var$folders = (_a)=>{
    var { className: className } = _a, rest = $851bfa4cb4619e95$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $851bfa4cb4619e95$var$classnames_1.default)("helix-icon", "folders-outlined", className);
    return $851bfa4cb4619e95$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $851bfa4cb4619e95$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4 4.79761C3.86193 4.79761 3.75 4.90954 3.75 5.04761V10.0476C3.75 10.1857 3.86193 10.2976 4 10.2976H12C12.1357 10.2976 12.2463 10.1893 12.2499 10.0548L12.25 10.0476V6.07488C12.25 5.93681 12.1381 5.82488 12 5.82488H8C7.79759 5.82488 7.60377 5.74307 7.46258 5.59803L6.68341 4.79761H4ZM2.25 5.04761C2.25 4.08111 3.0335 3.29761 4 3.29761H7C7.20241 3.29761 7.39623 3.37942 7.53742 3.52446L8.31659 4.32488H12C12.9665 4.32488 13.75 5.10838 13.75 6.07488V6.32488H14C14.9665 6.32488 15.75 7.10838 15.75 8.07488V9.32488H16C16.9665 9.32488 17.75 10.1084 17.75 11.0749V15.0476C17.75 16.0141 16.9665 16.7976 16 16.7976H8C7.0335 16.7976 6.25 16.0141 6.25 15.0476V14.2976H6C5.0335 14.2976 4.25 13.5141 4.25 12.5476V11.7976H4C3.0335 11.7976 2.25 11.0141 2.25 10.0476V5.04761ZM5.75 11.7976V12.5476C5.75 12.6857 5.86193 12.7976 6 12.7976H14C14.1381 12.7976 14.25 12.6857 14.25 12.5476V8.07488C14.25 7.93681 14.1381 7.82488 14 7.82488H13.75V10.0476C13.75 10.0634 13.7498 10.0792 13.7494 10.095C13.7241 11.0398 12.9507 11.7976 12 11.7976H5.75ZM7.75 14.2976V15.0476C7.75 15.1857 7.86193 15.2976 8 15.2976H16C16.1381 15.2976 16.25 15.1857 16.25 15.0476V11.0749C16.25 10.9368 16.1381 10.8249 16 10.8249H15.75V12.5476C15.75 13.5141 14.9665 14.2976 14 14.2976H7.75Z",
        fill: "#4B5563"
    }));
};
module.exports.folders = $851bfa4cb4619e95$var$folders;

});

parcelRegister("h940d", function(module, exports) {
"use strict";
var $c7b661bb563b0591$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $c7b661bb563b0591$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.for_rent = void 0;

/* eslint-disable max-len */ const $c7b661bb563b0591$var$react_1 = $c7b661bb563b0591$var$__importDefault((parcelRequire("acw62")));

const $c7b661bb563b0591$var$classnames_1 = $c7b661bb563b0591$var$__importDefault((parcelRequire("8g1PZ")));
const $c7b661bb563b0591$var$for_rent = (_a)=>{
    var { className: className } = _a, rest = $c7b661bb563b0591$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $c7b661bb563b0591$var$classnames_1.default)("helix-icon", "for-rent-outlined", className);
    return $c7b661bb563b0591$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $c7b661bb563b0591$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.69531 13.0547H5.42383V14H4.5957V11.1816H5.88672C6.58008 11.1816 6.98633 11.5352 6.98633 12.1387C6.98633 12.4707 6.82617 12.791 6.53125 12.9316L7.06641 14H6.14062L5.69531 13.0547ZM5.76758 11.793H5.42383V12.4883H5.76562C5.99805 12.4883 6.14062 12.3555 6.14062 12.1426C6.14062 11.9336 5.99023 11.793 5.76758 11.793Z",
        fill: "#4B5563"
    }), $c7b661bb563b0591$var$react_1.default.createElement("path", {
        d: "M8.36523 13.3438H9.52539V14H7.53711V11.1816H9.52539V11.8379H8.36523V12.2949H9.45312V12.8887H8.36523V13.3438Z",
        fill: "#4B5563"
    }), $c7b661bb563b0591$var$react_1.default.createElement("path", {
        d: "M10.9121 14V12.5801H10.9512L12.0215 14H12.6582V11.1816H11.877V12.5801H11.8379L10.7734 11.1816H10.1309V14H10.9121Z",
        fill: "#4B5563"
    }), $c7b661bb563b0591$var$react_1.default.createElement("path", {
        d: "M14.7695 11.8379V14H13.9414V11.8379H13.1582V11.1816H15.5527V11.8379H14.7695Z",
        fill: "#4B5563"
    }), $c7b661bb563b0591$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.46973 1.46967C9.76262 1.17678 10.2375 1.17678 10.5304 1.46967L15.3107 6.25H18C18.4142 6.25 18.75 6.58579 18.75 7V18C18.75 18.4142 18.4142 18.75 18 18.75H2C1.58579 18.75 1.25 18.4142 1.25 18V7C1.25 6.58579 1.58579 6.25 2 6.25H4.6894L9.46973 1.46967ZM10.0001 3.06066L13.1894 6.25H6.81072L10.0001 3.06066ZM2.75 7.75V17.25H17.25V7.75H2.75Z",
        fill: "#4B5563"
    }));
};
module.exports.for_rent = $c7b661bb563b0591$var$for_rent;

});

parcelRegister("itakD", function(module, exports) {
"use strict";
var $d722f3217d44ecd1$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d722f3217d44ecd1$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.form_editor = void 0;

/* eslint-disable max-len */ const $d722f3217d44ecd1$var$react_1 = $d722f3217d44ecd1$var$__importDefault((parcelRequire("acw62")));

const $d722f3217d44ecd1$var$classnames_1 = $d722f3217d44ecd1$var$__importDefault((parcelRequire("8g1PZ")));
const $d722f3217d44ecd1$var$form_editor = (_a)=>{
    var { className: className } = _a, rest = $d722f3217d44ecd1$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $d722f3217d44ecd1$var$classnames_1.default)("helix-icon", "form_editor", className);
    return $d722f3217d44ecd1$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $d722f3217d44ecd1$var$react_1.default.createElement("path", {
        d: "M13.9048 1.50537H3.33792C2.86847 1.50537 2.48792 1.88593 2.48792 2.35537V18.1618C2.48792 18.6312 2.86848 19.0118 3.33792 19.0118H17.1692C17.6386 19.0118 18.0192 18.6312 18.0192 18.1618V5.16828L16.5192 6.67127V17.5118H3.98792V3.00537H12.4078L13.9048 1.50537Z",
        fill: "#4B5563"
    }), $d722f3217d44ecd1$var$react_1.default.createElement("path", {
        d: "M10.0689 5.34894H6.09915C5.6297 5.34894 5.24915 5.7295 5.24915 6.19894V11.9945C5.24915 12.464 5.6297 12.8445 6.09915 12.8445H14.5091C14.9785 12.8445 15.3591 12.464 15.3591 11.9945V7.83364L13.8591 9.33663V11.3445H6.74915V6.84894H8.64638C8.71195 6.734 8.79286 6.62748 8.8876 6.53255L10.0689 5.34894Z",
        fill: "#4B5563"
    }), $d722f3217d44ecd1$var$react_1.default.createElement("path", {
        d: "M18.314 2.74945C18.7296 2.31955 18.664 1.58179 18.1679 1.10218C17.6716 0.622337 16.9324 0.581692 16.517 1.01139L9.94932 7.59216L9.71973 9.62805L11.7467 9.32981L18.314 2.74945Z",
        fill: "#4B5563"
    }), $d722f3217d44ecd1$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.24915 14.9485C5.24915 14.5342 5.58493 14.1985 5.99915 14.1985H14.7937C15.2079 14.1985 15.5437 14.5342 15.5437 14.9485C15.5437 15.3627 15.2079 15.6985 14.7937 15.6985H5.99915C5.58493 15.6985 5.24915 15.3627 5.24915 14.9485Z",
        fill: "#4B5563"
    }));
};
module.exports.form_editor = $d722f3217d44ecd1$var$form_editor;

});

parcelRegister("6jvDP", function(module, exports) {
"use strict";
var $498d0fc252318671$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $498d0fc252318671$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.format_strikethrough = void 0;

const $498d0fc252318671$var$react_1 = $498d0fc252318671$var$__importDefault((parcelRequire("acw62")));

const $498d0fc252318671$var$classnames_1 = $498d0fc252318671$var$__importDefault((parcelRequire("8g1PZ")));
const $498d0fc252318671$var$format_strikethrough = (_a)=>{
    var { className: className } = _a, rest = $498d0fc252318671$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $498d0fc252318671$var$classnames_1.default)("helix-icon", "title-outlined", className);
    return $498d0fc252318671$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $498d0fc252318671$var$react_1.default.createElement("path", {
        d: "M8.64062 12.7618V15.4214H10.9702V12.7618H8.64062Z",
        fill: "#4B5563"
    }), $498d0fc252318671$var$react_1.default.createElement("path", {
        d: "M8.64062 9.26178H10.9702V8.13434H13.6108V6.26178H6V8.13434H8.64062V9.26178Z",
        fill: "#4B5563"
    }), $498d0fc252318671$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 11.7618H4V10.2618H16V11.7618Z",
        fill: "#4B5563"
    }));
};
module.exports.format_strikethrough = $498d0fc252318671$var$format_strikethrough;

});

parcelRegister("bpsJs", function(module, exports) {
"use strict";
var $84e85120a6996576$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $84e85120a6996576$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.funnel_person = void 0;

/* eslint-disable max-len */ const $84e85120a6996576$var$react_1 = $84e85120a6996576$var$__importDefault((parcelRequire("acw62")));

const $84e85120a6996576$var$classnames_1 = $84e85120a6996576$var$__importDefault((parcelRequire("8g1PZ")));
const $84e85120a6996576$var$funnel_person = (_a)=>{
    var { className: className } = _a, rest = $84e85120a6996576$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $84e85120a6996576$var$classnames_1.default)("helix-icon", "funned-person-outlined", className);
    return $84e85120a6996576$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $84e85120a6996576$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.2372 3.28851C17.6301 3.41949 17.8425 3.84423 17.7115 4.23719L13.7115 16.2372C13.5805 16.6301 13.1558 16.8425 12.7628 16.7115C12.3699 16.5805 12.1575 16.1558 12.2885 15.7628L16.2885 3.76285C16.4195 3.36989 16.8442 3.15752 17.2372 3.28851Z",
        fill: "#4B5563"
    }), $84e85120a6996576$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.76285 3.28851C2.36989 3.41949 2.15752 3.84423 2.28851 4.23719L6.28851 16.2372C6.41949 16.6301 6.84423 16.8425 7.23719 16.7115C7.63015 16.5805 7.84252 16.1558 7.71153 15.7628L3.71153 3.76285C3.58055 3.36989 3.15581 3.15752 2.76285 3.28851Z",
        fill: "#4B5563"
    }), $84e85120a6996576$var$react_1.default.createElement("path", {
        d: "M7.00002 9.50002C7.00002 8.67159 7.67159 8.00002 8.50002 8.00002H11.5C12.3284 8.00002 13 8.67159 13 9.50002V10C13 10.5523 12.5523 11 12 11H8.00002C7.44774 11 7.00002 10.5523 7.00002 10V9.50002Z",
        fill: "#4B5563"
    }), $84e85120a6996576$var$react_1.default.createElement("path", {
        d: "M8.50002 6.50002C8.50002 5.67159 9.17159 5.00002 10 5.00002C10.8284 5.00002 11.5 5.67159 11.5 6.50002C11.5 7.32845 10.8284 8.00002 10 8.00002C9.17159 8.00002 8.50002 7.32845 8.50002 6.50002Z",
        fill: "#4B5563"
    }));
};
module.exports.funnel_person = $84e85120a6996576$var$funnel_person;

});

parcelRegister("jBEgJ", function(module, exports) {
"use strict";
var $e460b5964bbbbe48$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $e460b5964bbbbe48$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.gesture = void 0;

/* eslint-disable max-len */ const $e460b5964bbbbe48$var$react_1 = $e460b5964bbbbe48$var$__importDefault((parcelRequire("acw62")));

const $e460b5964bbbbe48$var$classnames_1 = $e460b5964bbbbe48$var$__importDefault((parcelRequire("8g1PZ")));
const $e460b5964bbbbe48$var$gesture = (_a)=>{
    var { className: className } = _a, rest = $e460b5964bbbbe48$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $e460b5964bbbbe48$var$classnames_1.default)("helix-icon", "gesture-outlined", className);
    return $e460b5964bbbbe48$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e460b5964bbbbe48$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.89544 6.96841C6.18633 7.27232 5.16463 7.67905 4 7.67905V6.17905C4.83537 6.17905 5.61367 5.88579 6.30456 5.5897C6.36531 5.56366 6.42758 5.5366 6.49056 5.50922C6.75499 5.39429 7.03199 5.27389 7.26165 5.20137C7.40711 5.15543 7.59587 5.10718 7.79531 5.10718C8.00758 5.10718 8.29554 5.16394 8.53033 5.39872C8.69461 5.56301 8.76501 5.75513 8.79699 5.89576C8.82942 6.03831 8.8339 6.17767 8.82956 6.2947C8.82094 6.52751 8.77214 6.78369 8.71344 7.02691C8.59654 7.51118 8.4009 8.09809 8.21892 8.644L8.21151 8.66622C8.19209 8.7245 8.17282 8.78232 8.15377 8.83962C8.1549 8.83848 8.15604 8.83735 8.15717 8.83621C9.16455 7.82884 10.7194 6.67904 13 6.67904C13.4792 6.67904 13.8974 6.7165 14.2265 6.82169C14.5431 6.92287 14.9906 7.16482 15.0865 7.70388C15.1671 8.15636 14.9317 8.5347 14.7819 8.73836C14.6061 8.9775 14.3653 9.21548 14.1137 9.43942C13.6927 9.81418 13.1443 10.2331 12.6009 10.6483C12.4938 10.7301 12.3869 10.8118 12.2811 10.8929C11.6187 11.4016 10.991 11.8991 10.5303 12.3597C9.54203 13.348 8.74801 14.2965 8.37299 14.9616C8.35738 14.9893 8.34285 15.0159 8.32933 15.0414C8.50951 14.9835 8.74638 14.8839 9.05416 14.7294C9.36592 14.5729 9.68383 14.3967 10.0362 14.2015C10.3 14.0553 10.5832 13.8985 10.8975 13.7311C12.288 12.9908 14.053 12.179 16 12.179V13.679C14.447 13.679 12.962 14.3313 11.6025 15.0551C11.3421 15.1937 11.0742 15.3418 10.8112 15.4872C10.4269 15.6997 10.0528 15.9065 9.72709 16.0699C9.18575 16.3417 8.57225 16.6072 8 16.6072C7.74757 16.6072 7.45363 16.5642 7.19367 16.3979C6.90378 16.2124 6.74169 15.9285 6.69385 15.6264C6.65089 15.355 6.70213 15.0939 6.76926 14.8828C6.83887 14.6639 6.9442 14.4416 7.06635 14.2249C7.54488 13.3762 8.45797 12.3108 9.46967 11.299C10.009 10.7597 10.7113 10.2071 11.3676 9.7032C11.4819 9.61549 11.5945 9.52939 11.705 9.44493C12.2492 9.02898 12.7415 8.65268 13.1164 8.319C13.1696 8.27161 13.2185 8.22674 13.2633 8.18435C13.1852 8.18097 13.0977 8.17904 13 8.17904C11.2806 8.17904 10.0855 9.02925 9.21783 9.89687C8.91032 10.2044 8.67066 10.4844 8.4498 10.7424C8.34543 10.8643 8.24527 10.9813 8.14412 11.094C8.01188 11.2414 7.83453 11.4311 7.63996 11.555C7.53956 11.6188 7.36577 11.7109 7.14063 11.7213C6.87618 11.7336 6.63973 11.6294 6.46967 11.4594C6.30539 11.2951 6.23499 11.103 6.20301 10.9623C6.17058 10.8198 6.1661 10.6804 6.17044 10.5634C6.17906 10.3306 6.22786 10.0744 6.28656 9.83119C6.40346 9.34691 6.5991 8.76 6.78108 8.21408L6.78849 8.19188C6.95642 7.68809 7.11249 7.21843 7.21588 6.82997C7.18917 6.84152 7.1616 6.85347 7.13309 6.86583C7.06028 6.89739 6.98139 6.93158 6.89544 6.96841ZM13.6237 7.76994C13.624 7.76986 13.6227 7.77333 13.6188 7.78058C13.6214 7.77365 13.6233 7.77002 13.6237 7.76994ZM7.9347 15.1028C7.93471 15.1028 7.9352 15.1029 7.93612 15.1031Z",
        fill: "#4B5563"
    }));
};
module.exports.gesture = $e460b5964bbbbe48$var$gesture;

});

parcelRegister("64ayr", function(module, exports) {
"use strict";
var $46ab4db7a284b7b3$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $46ab4db7a284b7b3$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.gift = void 0;

/* eslint-disable max-len */ const $46ab4db7a284b7b3$var$react_1 = $46ab4db7a284b7b3$var$__importDefault((parcelRequire("acw62")));

const $46ab4db7a284b7b3$var$classnames_1 = $46ab4db7a284b7b3$var$__importDefault((parcelRequire("8g1PZ")));
const $46ab4db7a284b7b3$var$gift = (_a)=>{
    var { className: className } = _a, rest = $46ab4db7a284b7b3$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $46ab4db7a284b7b3$var$classnames_1.default)("helix-icon", "gift-outlined", className);
    return $46ab4db7a284b7b3$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $46ab4db7a284b7b3$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.75 7.85718C1.75 6.89068 2.5335 6.10718 3.5 6.10718H16.5C17.4665 6.10718 18.25 6.89068 18.25 7.85718V10.6072C18.25 10.9773 18.0489 11.3005 17.75 11.4734V16.8572C17.75 17.8237 16.9665 18.6072 16 18.6072H4C3.0335 18.6072 2.25 17.8237 2.25 16.8572V11.4734C1.9511 11.3005 1.75 10.9773 1.75 10.6072V7.85718ZM3.5 7.60718C3.36193 7.60718 3.25 7.71911 3.25 7.85718V10.241C3.5489 10.4139 3.75 10.737 3.75 11.1072V16.8572C3.75 16.9952 3.86193 17.1072 4 17.1072H16C16.1381 17.1072 16.25 16.9952 16.25 16.8572V11.1072C16.25 10.737 16.4511 10.4139 16.75 10.241V7.85718C16.75 7.71911 16.6381 7.60718 16.5 7.60718H3.5Z",
        fill: "#4B5563"
    }), $46ab4db7a284b7b3$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 6.60718C10.4142 6.60718 10.75 6.94296 10.75 7.35718V17.8572C10.75 18.2714 10.4142 18.6072 10 18.6072C9.58579 18.6072 9.25 18.2714 9.25 17.8572V7.35718C9.25 6.94296 9.58579 6.60718 10 6.60718Z",
        fill: "#4B5563"
    }), $46ab4db7a284b7b3$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.00426 4.87234C5.82843 5.00401 5.75 5.16277 5.75 5.35717C5.75 5.52311 5.80958 5.69844 5.95336 5.83468C6.09345 5.96742 6.39088 6.13538 7.00001 6.13538H8.99392C8.92579 6.03114 8.85219 5.92468 8.77339 5.81868C8.2348 5.09402 7.61807 4.60718 7 4.60718C6.52594 4.60718 6.1958 4.72889 6.00426 4.87234ZM10.2507 6.88538C10.9439 6.59907 10.9437 6.59866 10.9437 6.59866L10.943 6.59699L10.9417 6.59378L10.9376 6.58412L10.9239 6.55218C10.9123 6.52549 10.8957 6.48816 10.8744 6.44172C10.8317 6.34895 10.7694 6.21916 10.6886 6.06459C10.5278 5.75731 10.2887 5.34288 9.97729 4.92389C9.39054 4.13445 8.38193 3.10719 7.00001 3.10718C6.28656 3.10717 5.61669 3.28858 5.10511 3.67169C4.57782 4.06658 4.25 4.65782 4.25 5.35717C4.25 5.87873 4.44042 6.46751 4.92164 6.9235C5.40655 7.38299 6.10912 7.63538 7.00001 7.63538H10.2502L10.2507 6.88538ZM10.2507 6.88538L10.2502 7.63538C10.5005 7.63538 10.7349 7.51046 10.8741 7.30237C11.0133 7.09429 11.0393 6.83005 10.9437 6.59866L10.2507 6.88538Z",
        fill: "#4B5563"
    }), $46ab4db7a284b7b3$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.2464 4.87234C14.4223 5.00401 14.5007 5.16277 14.5007 5.35717C14.5007 5.52311 14.4411 5.69844 14.2973 5.83468C14.1572 5.96742 13.8598 6.13538 13.2507 6.13538H11.2568C11.3249 6.03114 11.3985 5.92468 11.4773 5.81868C12.0159 5.09402 12.6326 4.60718 13.2507 4.60718C13.7247 4.60718 14.0549 4.72889 14.2464 4.87234ZM10 6.88538C9.3068 6.59907 9.30697 6.59866 9.30697 6.59866L9.30766 6.59699L9.309 6.59378L9.31307 6.58412L9.3268 6.55218C9.33841 6.52549 9.35496 6.48816 9.37633 6.44172C9.41902 6.34895 9.48125 6.21916 9.5621 6.06459C9.72284 5.75731 9.96198 5.34288 10.2734 4.92389C10.8601 4.13445 11.8688 3.10719 13.2507 3.10718C13.9641 3.10717 14.634 3.28858 15.1456 3.67169C15.6729 4.06658 16.0007 4.65782 16.0007 5.35717C16.0007 5.87873 15.8103 6.46751 15.3291 6.9235C14.8441 7.38299 14.1416 7.63538 13.2507 7.63538H10.0005L10 6.88538ZM10 6.88538L10.0005 7.63538C9.75015 7.63538 9.51581 7.51046 9.37661 7.30237C9.23742 7.09429 9.2114 6.83005 9.30697 6.59866L10 6.88538Z",
        fill: "#4B5563"
    }), $46ab4db7a284b7b3$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.25 10.8572C2.25 10.443 2.58579 10.1072 3 10.1072L17 10.1072C17.4142 10.1072 17.75 10.443 17.75 10.8572C17.75 11.2714 17.4142 11.6072 17 11.6072L3 11.6072C2.58579 11.6072 2.25 11.2714 2.25 10.8572Z",
        fill: "#4B5563"
    }));
};
module.exports.gift = $46ab4db7a284b7b3$var$gift;

});

parcelRegister("d1InZ", function(module, exports) {
"use strict";
var $97bdcc7fca1a5314$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $97bdcc7fca1a5314$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.headphones = void 0;

/* eslint-disable max-len */ const $97bdcc7fca1a5314$var$react_1 = $97bdcc7fca1a5314$var$__importDefault((parcelRequire("acw62")));

const $97bdcc7fca1a5314$var$classnames_1 = $97bdcc7fca1a5314$var$__importDefault((parcelRequire("8g1PZ")));
const $97bdcc7fca1a5314$var$headphones = (_a)=>{
    var { className: className } = _a, rest = $97bdcc7fca1a5314$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $97bdcc7fca1a5314$var$classnames_1.default)("helix-icon", "headphones-outlined", className);
    return $97bdcc7fca1a5314$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, rest), $97bdcc7fca1a5314$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 3.41669C7.1005 3.41669 4.75 5.76719 4.75 8.66669H3.25C3.25 4.93876 6.27208 1.91669 10 1.91669C13.7279 1.91669 16.75 4.93876 16.75 8.66669H15.25C15.25 5.76719 12.8995 3.41669 10 3.41669Z",
        fill: "#4B5563"
    }), $97bdcc7fca1a5314$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.25 10.6667C1.25 9.1479 2.48122 7.91669 4 7.91669H5C5.41421 7.91669 5.75 8.25247 5.75 8.66669V14.1667C5.75 14.5809 5.41421 14.9167 5 14.9167H4C2.48122 14.9167 1.25 13.6855 1.25 12.1667V10.6667ZM4 9.41669C3.30964 9.41669 2.75 9.97633 2.75 10.6667V12.1667C2.75 12.857 3.30964 13.4167 4 13.4167H4.25V9.41669H4Z",
        fill: "#4B5563"
    }), $97bdcc7fca1a5314$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.75 10.6667C18.75 9.1479 17.5188 7.91669 16 7.91669H15C14.5858 7.91669 14.25 8.25247 14.25 8.66669V14.1667C14.25 14.5809 14.5858 14.9167 15 14.9167H16C17.5188 14.9167 18.75 13.6855 18.75 12.1667V10.6667ZM16 9.41669C16.6904 9.41669 17.25 9.97633 17.25 10.6667V12.1667C17.25 12.857 16.6904 13.4167 16 13.4167H15.75V9.41669H16Z",
        fill: "#4B5563"
    }), $97bdcc7fca1a5314$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.25 15.6667V14.6667H4.75V15.6667C4.75 16.357 5.30964 16.9167 6 16.9167H10V18.4167H6C4.48122 18.4167 3.25 17.1855 3.25 15.6667Z",
        fill: "#4B5563"
    }), $97bdcc7fca1a5314$var$react_1.default.createElement("path", {
        d: "M8 17.6667C8 16.8383 8.67157 16.1667 9.5 16.1667H11.5C12.3284 16.1667 13 16.8383 13 17.6667C13 18.4951 12.3284 19.1667 11.5 19.1667H9.5C8.67157 19.1667 8 18.4951 8 17.6667Z",
        fill: "#4B5563"
    }));
};
module.exports.headphones = $97bdcc7fca1a5314$var$headphones;

});

parcelRegister("l0149", function(module, exports) {
"use strict";
var $f49a6cba8c4e3ebf$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $f49a6cba8c4e3ebf$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.heart = void 0;

const $f49a6cba8c4e3ebf$var$react_1 = $f49a6cba8c4e3ebf$var$__importDefault((parcelRequire("acw62")));

const $f49a6cba8c4e3ebf$var$classnames_1 = $f49a6cba8c4e3ebf$var$__importDefault((parcelRequire("8g1PZ")));
const $f49a6cba8c4e3ebf$var$heart = (_a)=>{
    var { className: className } = _a, rest = $f49a6cba8c4e3ebf$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $f49a6cba8c4e3ebf$var$classnames_1.default)("helix-icon", "heart-outlined", className);
    return $f49a6cba8c4e3ebf$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $f49a6cba8c4e3ebf$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        // eslint-disable-next-line max-len
        d: "M6.625 3.75C4.73751 3.75 3.25 5.24457 3.25 7.19619C3.25 8.39394 3.77365 9.53901 4.84246 10.8692C5.92004 12.2103 7.47513 13.6485 9.42105 15.4455C9.42114 15.4456 9.42096 15.4454 9.42105 15.4455L10 15.9796L10.5787 15.4457C12.5247 13.6487 14.0799 12.2103 15.1575 10.8692C16.2264 9.53901 16.75 8.39394 16.75 7.19619C16.75 5.24457 15.2625 3.75 13.375 3.75C12.3017 3.75 11.2559 4.26208 10.5742 5.07326C10.4317 5.24283 10.2215 5.34074 10 5.34074C9.77851 5.34074 9.56834 5.24283 9.42583 5.07326C8.74412 4.26208 7.69827 3.75 6.625 3.75ZM1.75 7.19619C1.75 4.44044 3.88499 2.25 6.625 2.25C7.87932 2.25 9.08195 2.73227 10 3.52636C10.918 2.73227 12.1207 2.25 13.375 2.25C16.115 2.25 18.25 4.44044 18.25 7.19619C18.25 8.87854 17.4986 10.3504 16.3268 11.8087C15.1723 13.2455 13.5369 14.7558 11.6383 16.5089L11.5963 16.5477L10.5086 17.5512C10.2213 17.8163 9.7787 17.8163 9.49145 17.5512L8.36165 16.5089C6.4631 14.7558 4.82765 13.2455 3.67316 11.8087C2.50135 10.3504 1.75 8.87854 1.75 7.19619Z",
        fill: "#4B5563"
    }));
};
module.exports.heart = $f49a6cba8c4e3ebf$var$heart;

});

parcelRegister("3IuTb", function(module, exports) {
"use strict";
var $2b4d711a88337f01$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $2b4d711a88337f01$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.home = void 0;

const $2b4d711a88337f01$var$react_1 = $2b4d711a88337f01$var$__importDefault((parcelRequire("acw62")));

const $2b4d711a88337f01$var$classnames_1 = $2b4d711a88337f01$var$__importDefault((parcelRequire("8g1PZ")));
const $2b4d711a88337f01$var$home = (_a)=>{
    var { className: className } = _a, rest = $2b4d711a88337f01$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $2b4d711a88337f01$var$classnames_1.default)("helix-icon", "home-outlined", className);
    return $2b4d711a88337f01$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $2b4d711a88337f01$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        // eslint-disable-next-line max-len
        d: "M9.50612 3.43557C9.78889 3.18814 10.2111 3.18814 10.4939 3.43557L16.4939 8.68557C16.6566 8.82798 16.75 9.03373 16.75 9.25V16C16.75 16.4142 16.4142 16.75 16 16.75H4C3.58579 16.75 3.25 16.4142 3.25 16V9.25C3.25 9.03373 3.34336 8.82798 3.50612 8.68557L9.50612 3.43557ZM4.75 9.59033V15.25H15.25V9.59033L10 4.99658L4.75 9.59033Z",
        fill: "#4B5563"
    }));
};
module.exports.home = $2b4d711a88337f01$var$home;

});

parcelRegister("jYj4a", function(module, exports) {
"use strict";
var $e8a26913887c4373$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $e8a26913887c4373$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.home_chart = void 0;

/* eslint-disable max-len */ const $e8a26913887c4373$var$react_1 = $e8a26913887c4373$var$__importDefault((parcelRequire("acw62")));

const $e8a26913887c4373$var$classnames_1 = $e8a26913887c4373$var$__importDefault((parcelRequire("8g1PZ")));
const $e8a26913887c4373$var$home_chart = (_a)=>{
    var { className: className } = _a, rest = $e8a26913887c4373$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $e8a26913887c4373$var$classnames_1.default)("helix-icon", "home-chart-outlined", className);
    return $e8a26913887c4373$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e8a26913887c4373$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.50922 1.43287C9.79098 1.18904 10.209 1.18904 10.4908 1.43287L17.4908 7.49057C17.6554 7.63303 17.75 7.83999 17.75 8.05769V17C17.75 17.4142 17.4142 17.75 17 17.75H3C2.58579 17.75 2.25 17.4142 2.25 17V8.05769C2.25 7.83999 2.3446 7.63303 2.50922 7.49057L9.50922 1.43287ZM3.75 8.4005V16.25H16.25V8.4005L10 2.99184L3.75 8.4005Z",
        fill: "#4B5563"
    }), $e8a26913887c4373$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.25 14L9.25 8H10.75V14H9.25Z",
        fill: "#4B5563"
    }), $e8a26913887c4373$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.25 14V9H13.75V14H12.25Z",
        fill: "#4B5563"
    }), $e8a26913887c4373$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.25 14V10H7.75V14H6.25Z",
        fill: "#4B5563"
    }));
};
module.exports.home_chart = $e8a26913887c4373$var$home_chart;

});

parcelRegister("eXgN2", function(module, exports) {
"use strict";
var $ae33998882d918b7$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $ae33998882d918b7$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.home_checkmark = void 0;

/* eslint-disable max-len */ const $ae33998882d918b7$var$react_1 = $ae33998882d918b7$var$__importDefault((parcelRequire("acw62")));

const $ae33998882d918b7$var$classnames_1 = $ae33998882d918b7$var$__importDefault((parcelRequire("8g1PZ")));
const $ae33998882d918b7$var$home_checkmark = (_a)=>{
    var { className: className } = _a, rest = $ae33998882d918b7$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $ae33998882d918b7$var$classnames_1.default)("helix-icon", "home-checkmark-outlined", className);
    return $ae33998882d918b7$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $ae33998882d918b7$var$react_1.default.createElement("g", {
        clipPath: "url(#clip0_2_186)"
    }, $ae33998882d918b7$var$react_1.default.createElement("g", {
        filter: "url(#filter0_d_2_186)"
    }, $ae33998882d918b7$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.50922 1.43287C9.79098 1.18904 10.209 1.18904 10.4908 1.43287L17.4908 7.49057C17.6554 7.63303 17.75 7.83999 17.75 8.05769V17C17.75 17.4142 17.4142 17.75 17 17.75H3C2.58579 17.75 2.25 17.4142 2.25 17V8.05769C2.25 7.83999 2.3446 7.63303 2.50922 7.49057L9.50922 1.43287ZM3.75 8.4005V16.25H16.25V8.4005L10 2.99184L3.75 8.4005Z",
        fill: "#4B5563"
    }), $ae33998882d918b7$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.5146 8.4544C13.8159 8.7386 13.8298 9.21328 13.5456 9.5146L9.77288 13.5146C9.49689 13.8072 9.03921 13.83 8.73551 13.5663L7.00823 12.0663C6.69549 11.7947 6.66213 11.321 6.93373 11.0082C7.20532 10.6955 7.67902 10.6621 7.99177 10.9337L9.17556 11.9618L12.4544 8.4854C12.7386 8.18407 13.2133 8.17019 13.5146 8.4544Z",
        fill: "#4B5563"
    }))), $ae33998882d918b7$var$react_1.default.createElement("defs", null, $ae33998882d918b7$var$react_1.default.createElement("filter", {
        id: "filter0_d_2_186",
        x: "-5.75",
        y: "-2.75",
        width: "31.5",
        height: "32.5",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, $ae33998882d918b7$var$react_1.default.createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), $ae33998882d918b7$var$react_1.default.createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), $ae33998882d918b7$var$react_1.default.createElement("feOffset", {
        dy: "4"
    }), $ae33998882d918b7$var$react_1.default.createElement("feGaussianBlur", {
        stdDeviation: "4"
    }), $ae33998882d918b7$var$react_1.default.createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
    }), $ae33998882d918b7$var$react_1.default.createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_2_186"
    }), $ae33998882d918b7$var$react_1.default.createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect1_dropShadow_2_186",
        result: "shape"
    })), $ae33998882d918b7$var$react_1.default.createElement("clipPath", {
        id: "clip0_2_186"
    }, $ae33998882d918b7$var$react_1.default.createElement("path", {
        d: "M0 2C0 0.895431 0.895431 0 2 0H18C19.1046 0 20 0.895431 20 2V18C20 19.1046 19.1046 20 18 20H2C0.895431 20 0 19.1046 0 18V2Z",
        fill: "white"
    }))));
};
module.exports.home_checkmark = $ae33998882d918b7$var$home_checkmark;

});

parcelRegister("e9Yes", function(module, exports) {
"use strict";
var $a4f0a0ca7346926a$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $a4f0a0ca7346926a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.home_compare = void 0;

const $a4f0a0ca7346926a$var$react_1 = $a4f0a0ca7346926a$var$__importDefault((parcelRequire("acw62")));

const $a4f0a0ca7346926a$var$classnames_1 = $a4f0a0ca7346926a$var$__importDefault((parcelRequire("8g1PZ")));
const $a4f0a0ca7346926a$var$home_compare = (_a)=>{
    var { className: className } = _a, rest = $a4f0a0ca7346926a$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $a4f0a0ca7346926a$var$classnames_1.default)("helix-icon", "home-compare-outlined", className);
    return $a4f0a0ca7346926a$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $a4f0a0ca7346926a$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        // eslint-disable-next-line max-len
        d: "M4.09126 3.37117C4.33981 3.20961 4.66019 3.20961 4.90874 3.37117L8.40874 5.64617C8.62159 5.78452 8.75 6.02114 8.75 6.275V11C8.75 11.4142 8.41421 11.75 8 11.75H1C0.585786 11.75 0.25 11.4142 0.25 11V6.275C0.25 6.02114 0.378414 5.78452 0.591259 5.64617L4.09126 3.37117ZM15.0913 3.37117C15.3398 3.20961 15.6602 3.20961 15.9087 3.37117L19.4087 5.64617C19.6216 5.78452 19.75 6.02114 19.75 6.275V11C19.75 11.4142 19.4142 11.75 19 11.75H12C11.5858 11.75 11.25 11.4142 11.25 11V6.275C11.25 6.02114 11.3784 5.78452 11.5913 5.64617L15.0913 3.37117ZM1.75 6.68201V10.25H3.75V8.75C3.75 8.33579 4.08579 8 4.5 8C4.91421 8 5.25 8.33579 5.25 8.75V10.25H7.25V6.68201L4.5 4.89451L1.75 6.68201ZM12.75 6.68201V10.25H14.75V8.75C14.75 8.33579 15.0858 8 15.5 8C15.9142 8 16.25 8.33579 16.25 8.75V10.25H18.25V6.68201L15.5 4.89451L12.75 6.68201ZM2 15.25C2 14.8358 2.33579 14.5 2.75 14.5H6.25C6.66421 14.5 7 14.8358 7 15.25C7 15.6642 6.66421 16 6.25 16H2.75C2.33579 16 2 15.6642 2 15.25ZM13 15.25C13 14.8358 13.3358 14.5 13.75 14.5H17.25C17.6642 14.5 18 14.8358 18 15.25C18 15.6642 17.6642 16 17.25 16H13.75C13.3358 16 13 15.6642 13 15.25Z",
        fill: "#4B5563"
    }));
};
module.exports.home_compare = $a4f0a0ca7346926a$var$home_compare;

});

parcelRegister("cOdlU", function(module, exports) {
"use strict";
var $953483066da9070e$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $953483066da9070e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.home_dollar = void 0;

/* eslint-disable max-len */ const $953483066da9070e$var$react_1 = $953483066da9070e$var$__importDefault((parcelRequire("acw62")));

const $953483066da9070e$var$classnames_1 = $953483066da9070e$var$__importDefault((parcelRequire("8g1PZ")));
const $953483066da9070e$var$home_dollar = (_a)=>{
    var { className: className } = _a, rest = $953483066da9070e$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $953483066da9070e$var$classnames_1.default)("helix-icon", "home-dollar-outlined", className);
    return $953483066da9070e$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $953483066da9070e$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.2812 14.624H9.77588V13.9253C8.54102 13.855 7.64453 13.209 7.61377 12.1104H8.7915C8.86182 12.5586 9.17822 12.8706 9.77588 12.9365V11.3325L9.48145 11.2622C8.33447 11.0029 7.70166 10.4888 7.70166 9.53955C7.70166 8.48926 8.56738 7.80811 9.77588 7.7334V7.02148H10.2812V7.73779C11.5029 7.82568 12.2939 8.51123 12.3379 9.54834H11.1646C11.103 9.07373 10.7734 8.80127 10.2812 8.73096V10.2822L10.5933 10.3481C11.793 10.6206 12.4214 11.104 12.4214 12.0664C12.4214 13.1694 11.5293 13.8374 10.2812 13.9209V14.624ZM9.77588 8.72217C9.22217 8.78809 8.93213 9.07373 8.93213 9.42529C8.93213 9.77686 9.18262 10.0054 9.77588 10.1636V8.72217ZM10.2812 12.9365C10.8921 12.875 11.1953 12.6025 11.1953 12.2026C11.1953 11.8159 10.9624 11.6182 10.2812 11.4468V12.9365Z",
        fill: "#4B5563"
    }), $953483066da9070e$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.4908 1.43287C10.209 1.18904 9.79098 1.18904 9.50922 1.43287L2.50922 7.49057C2.3446 7.63303 2.25 7.83999 2.25 8.05769V17C2.25 17.4142 2.58579 17.75 3 17.75H17C17.4142 17.75 17.75 17.4142 17.75 17V8.05769C17.75 7.83999 17.6554 7.63303 17.4908 7.49057L10.4908 1.43287ZM3.75 16.25V8.4005L10 2.99184L16.25 8.4005V16.25H3.75Z",
        fill: "#4B5563"
    }));
};
module.exports.home_dollar = $953483066da9070e$var$home_dollar;

});

parcelRegister("h6egG", function(module, exports) {
"use strict";
var $c72e1089c69d0ed4$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $c72e1089c69d0ed4$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.home_heart = void 0;

/* eslint-disable max-len */ const $c72e1089c69d0ed4$var$react_1 = $c72e1089c69d0ed4$var$__importDefault((parcelRequire("acw62")));

const $c72e1089c69d0ed4$var$classnames_1 = $c72e1089c69d0ed4$var$__importDefault((parcelRequire("8g1PZ")));
const $c72e1089c69d0ed4$var$home_heart = (_a)=>{
    var { className: className } = _a, rest = $c72e1089c69d0ed4$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $c72e1089c69d0ed4$var$classnames_1.default)("helix-icon", "home-heart-outlined", className);
    return $c72e1089c69d0ed4$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $c72e1089c69d0ed4$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.50922 1.43287C9.79098 1.18904 10.209 1.18904 10.4908 1.43287L17.4908 7.49057C17.6554 7.63303 17.75 7.83999 17.75 8.05769V17C17.75 17.4142 17.4142 17.75 17 17.75H3C2.58579 17.75 2.25 17.4142 2.25 17V8.05769C2.25 7.83999 2.3446 7.63303 2.50922 7.49057L9.50922 1.43287ZM3.75 8.4005V16.25H16.25V8.4005L10 2.99184L3.75 8.4005Z",
        fill: "#4B5563"
    }), $c72e1089c69d0ed4$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 14L9.565 13.57C8.02 12.0414 7 11.0327 7 9.79836C7 8.78965 7.7245 8 8.65 8C9.172 8 9.673 8.26485 10 8.68174C10.327 8.26485 10.828 8 11.35 8C12.2755 8 13 8.78965 13 9.79836C13 11.0327 11.98 12.0414 10.435 13.57L10 14Z",
        fill: "#4B5563"
    }));
};
module.exports.home_heart = $c72e1089c69d0ed4$var$home_heart;

});

parcelRegister("e08mP", function(module, exports) {
"use strict";
var $a3178e4e3eed23cb$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $a3178e4e3eed23cb$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.home_multi = void 0;

/* eslint-disable max-len */ const $a3178e4e3eed23cb$var$react_1 = $a3178e4e3eed23cb$var$__importDefault((parcelRequire("acw62")));

const $a3178e4e3eed23cb$var$classnames_1 = $a3178e4e3eed23cb$var$__importDefault((parcelRequire("8g1PZ")));
const $a3178e4e3eed23cb$var$home_multi = (_a)=>{
    var { className: className } = _a, rest = $a3178e4e3eed23cb$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $a3178e4e3eed23cb$var$classnames_1.default)("helix-icon", "home-multi-outlined", className);
    return $a3178e4e3eed23cb$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $a3178e4e3eed23cb$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.4939 3.43557C10.2111 3.18814 9.78889 3.18814 9.50612 3.43557L3.50612 8.68557C3.34336 8.82798 3.25 9.03373 3.25 9.25V16C3.25 16.4142 3.58579 16.75 4 16.75H16C16.4142 16.75 16.75 16.4142 16.75 16V9.25C16.75 9.03373 16.6566 8.82798 16.4939 8.68557L10.4939 3.43557ZM4.75 15.25V9.59033L9.25 5.65283L9.25 15.25H4.75ZM10.75 15.25H15.25V9.59033L10.75 5.65283L10.75 15.25Z",
        fill: "#4B5563"
    }));
};
module.exports.home_multi = $a3178e4e3eed23cb$var$home_multi;

});

parcelRegister("c1fXO", function(module, exports) {
"use strict";
var $8c01f614fd21d588$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $8c01f614fd21d588$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.home_percentage = void 0;

/* eslint-disable max-len */ const $8c01f614fd21d588$var$react_1 = $8c01f614fd21d588$var$__importDefault((parcelRequire("acw62")));

const $8c01f614fd21d588$var$classnames_1 = $8c01f614fd21d588$var$__importDefault((parcelRequire("8g1PZ")));
const $8c01f614fd21d588$var$home_percentage = (_a)=>{
    var { className: className } = _a, rest = $8c01f614fd21d588$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $8c01f614fd21d588$var$classnames_1.default)("helix-icon", "home-percentage-outlined", className);
    return $8c01f614fd21d588$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $8c01f614fd21d588$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.50922 1.43287C9.79098 1.18904 10.209 1.18904 10.4908 1.43287L17.4908 7.49057C17.6554 7.63303 17.75 7.83999 17.75 8.05769V17C17.75 17.4142 17.4142 17.75 17 17.75H3C2.58579 17.75 2.25 17.4142 2.25 17V8.05769C2.25 7.83999 2.3446 7.63303 2.50922 7.49057L9.50922 1.43287ZM3.75 8.4005V16.25H16.25V8.4005L10 2.99184L3.75 8.4005Z",
        fill: "#4B5563"
    }), $8c01f614fd21d588$var$react_1.default.createElement("path", {
        d: "M7.61816 10.7085C8.65967 10.7085 9.25732 10.1284 9.25732 9.11328C9.25732 8.12891 8.6377 7.53125 7.61816 7.53125C6.60742 7.53125 5.9834 8.1377 5.9834 9.11328C5.9834 10.1284 6.58545 10.7085 7.61816 10.7085ZM8.6377 14L12.6851 7.65869H11.3667L7.31934 14H8.6377ZM7.61816 9.75049C7.4248 9.75049 7.30615 9.52197 7.30615 9.11768C7.30615 8.73535 7.43359 8.48926 7.61816 8.48926C7.80713 8.48926 7.93018 8.73535 7.93018 9.11768C7.93018 9.51758 7.81592 9.75049 7.61816 9.75049ZM12.3818 14.0835C13.4233 14.0835 14.0166 13.5034 14.0166 12.4883C14.0166 11.5039 13.4014 10.9062 12.3818 10.9062C11.3711 10.9062 10.7471 11.5127 10.7471 12.4883C10.7471 13.5034 11.3447 14.0835 12.3818 14.0835ZM12.3818 13.1255C12.1841 13.1255 12.0698 12.897 12.0698 12.4927C12.0698 12.1104 12.1929 11.8643 12.3818 11.8643C12.5708 11.8643 12.6938 12.1104 12.6938 12.4927C12.6938 12.8926 12.5796 13.1255 12.3818 13.1255Z",
        fill: "#4B5563"
    }));
};
module.exports.home_percentage = $8c01f614fd21d588$var$home_percentage;

});

parcelRegister("aBnAF", function(module, exports) {
"use strict";
var $7b7fa8ab8deb2a8e$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $7b7fa8ab8deb2a8e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.house_mobile = void 0;

const $7b7fa8ab8deb2a8e$var$react_1 = $7b7fa8ab8deb2a8e$var$__importDefault((parcelRequire("acw62")));

const $7b7fa8ab8deb2a8e$var$classnames_1 = $7b7fa8ab8deb2a8e$var$__importDefault((parcelRequire("8g1PZ")));
const $7b7fa8ab8deb2a8e$var$house_mobile = (_a)=>{
    var { className: className } = _a, rest = $7b7fa8ab8deb2a8e$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $7b7fa8ab8deb2a8e$var$classnames_1.default)("helix-icon", "house-mobile-outlined", className);
    return $7b7fa8ab8deb2a8e$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $7b7fa8ab8deb2a8e$var$react_1.default.createElement("path", {
        d: "M8 9.34615V12H12V9.34615L10 8L8 9.34615Z",
        fill: "#4B5563"
    }), $7b7fa8ab8deb2a8e$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        // eslint-disable-next-line max-len
        d: "M5 4C5 3.44772 5.44772 3 6 3H14C14.5523 3 15 3.44772 15 4V16C15 16.5523 14.5523 17 14 17H6C5.44772 17 5 16.5523 5 16V4ZM6.5 15.5V4.5H13.5V15.5H6.5Z",
        fill: "#4B5563"
    }));
};
module.exports.house_mobile = $7b7fa8ab8deb2a8e$var$house_mobile;

});

parcelRegister("irMww", function(module, exports) {
"use strict";
var $d6e06362b8ba9833$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d6e06362b8ba9833$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.import_icon = void 0;

/* eslint-disable max-len */ const $d6e06362b8ba9833$var$react_1 = $d6e06362b8ba9833$var$__importDefault((parcelRequire("acw62")));

const $d6e06362b8ba9833$var$classnames_1 = $d6e06362b8ba9833$var$__importDefault((parcelRequire("8g1PZ")));
const $d6e06362b8ba9833$var$import_icon = (_a)=>{
    var { className: className } = _a, rest = $d6e06362b8ba9833$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $d6e06362b8ba9833$var$classnames_1.default)("helix-icon", "import-outlined", className);
    return $d6e06362b8ba9833$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $d6e06362b8ba9833$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.25 4.4762C11.25 4.06198 11.5858 3.7262 12 3.7262H15.5C16.1904 3.7262 16.75 4.28584 16.75 4.9762V15.9762C16.75 16.6666 16.1904 17.2262 15.5 17.2262H12C11.5858 17.2262 11.25 16.8904 11.25 16.4762C11.25 16.062 11.5858 15.7262 12 15.7262H15.25V5.2262H12C11.5858 5.2262 11.25 4.89041 11.25 4.4762ZM9.01986 6.90003C9.33807 6.63486 9.81099 6.67785 10.0762 6.99606L12.5762 9.99606C12.8079 10.2742 12.8079 10.6782 12.5762 10.9563L10.0762 13.9563C9.81099 14.2745 9.33807 14.3175 9.01986 14.0524C8.70165 13.7872 8.65866 13.3143 8.92383 12.9961L10.3987 11.2262H4C3.58579 11.2262 3.25 10.8904 3.25 10.4762C3.25 10.062 3.58579 9.7262 4 9.7262H10.3987L8.92383 7.95633C8.65866 7.63813 8.70165 7.1652 9.01986 6.90003Z",
        fill: "#4B5563"
    }));
};
module.exports.import_icon = $d6e06362b8ba9833$var$import_icon;

});

parcelRegister("3NUQC", function(module, exports) {
"use strict";
var $2c520b7c45292eef$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $2c520b7c45292eef$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.inbox = void 0;

/* eslint-disable max-len */ const $2c520b7c45292eef$var$react_1 = $2c520b7c45292eef$var$__importDefault((parcelRequire("acw62")));

const $2c520b7c45292eef$var$classnames_1 = $2c520b7c45292eef$var$__importDefault((parcelRequire("8g1PZ")));
const $2c520b7c45292eef$var$inbox = (_a)=>{
    var { className: className } = _a, rest = $2c520b7c45292eef$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $2c520b7c45292eef$var$classnames_1.default)("helix-icon", "inbox-outlined", className);
    return $2c520b7c45292eef$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $2c520b7c45292eef$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 3C10.4142 3 10.75 3.33579 10.75 3.75L10.75 7.06967V11.3893L12.4697 9.66967C12.7626 9.37678 13.2374 9.37678 13.5303 9.66967C13.8232 9.96256 13.8232 10.4374 13.5303 10.7303L10 14.2607L6.46967 10.7303C6.17678 10.4374 6.17678 9.96256 6.46967 9.66967C6.76256 9.37678 7.23744 9.37678 7.53033 9.66967L9.25 11.3893L9.25 3.75C9.25 3.33579 9.58579 3 10 3ZM3 11C3.41421 11 3.75 11.3358 3.75 11.75V16H16.25V11.75C16.25 11.3358 16.5858 11 17 11C17.4142 11 17.75 11.3358 17.75 11.75V16.75C17.75 17.1643 17.4142 17.5 17 17.5H3C2.58579 17.5 2.25 17.1643 2.25 16.75V11.75C2.25 11.3358 2.58579 11 3 11Z",
        fill: "#4B5563"
    }));
};
module.exports.inbox = $2c520b7c45292eef$var$inbox;

});

parcelRegister("4R2Eq", function(module, exports) {
"use strict";
var $388e2b13f3516525$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $388e2b13f3516525$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.key = void 0;

/* eslint-disable max-len */ const $388e2b13f3516525$var$react_1 = $388e2b13f3516525$var$__importDefault((parcelRequire("acw62")));

const $388e2b13f3516525$var$classnames_1 = $388e2b13f3516525$var$__importDefault((parcelRequire("8g1PZ")));
const $388e2b13f3516525$var$key = (_a)=>{
    var { className: className } = _a, rest = $388e2b13f3516525$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $388e2b13f3516525$var$classnames_1.default)("helix-icon", "key-outlined", className);
    return $388e2b13f3516525$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $388e2b13f3516525$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.07949 2.49178C4.03718 2.72341 3.22316 3.53743 2.99153 4.57974L2.50579 6.76557C2.30183 7.68341 2.58092 8.64183 3.24576 9.30667L5.17653 11.2374C6.25047 12.3114 7.99168 12.3114 9.06562 11.2374L9.1212 11.1819L10.2626 12.3232C10.5258 12.5865 10.8795 12.7386 11.2506 12.7494C11.2614 13.1205 11.4135 13.4742 11.6768 13.7374L13.1768 15.2374C13.4677 15.5284 13.8506 15.7063 14.2571 15.7429C14.2937 16.1494 14.4716 16.5323 14.7626 16.8232L15.2556 17.3162C15.4999 17.5605 15.811 17.7271 16.1498 17.7948L17.1029 17.9854C18.2224 18.2093 19.2093 17.2224 18.9854 16.1029L18.7948 15.1498C18.7276 14.8135 18.5646 14.5039 18.3185 14.2578L12.1308 8.07012C12.7893 7.00937 12.6581 5.59773 11.7372 4.67678L9.80642 2.74601C9.14158 2.08117 8.18316 1.80208 7.26532 2.00604L5.07949 2.49178ZM4.45581 4.90513C4.5611 4.43136 4.93111 4.06135 5.40488 3.95606L7.59072 3.47032C8.00791 3.37761 8.44356 3.50447 8.74576 3.80667L10.6765 5.73744C11.1647 6.2256 11.1647 7.01705 10.6765 7.50521L8.00496 10.1768C7.5168 10.6649 6.72534 10.6649 6.23719 10.1768L4.30642 8.24601C4.00422 7.94381 3.87736 7.50817 3.97007 7.09097L4.45581 4.90513ZM11.1212 9.18186L10.1819 10.1212L11.3108 11.2501C12.1013 11.2596 12.7404 11.8987 12.7499 12.6892L14.2374 14.1768C14.2843 14.2237 14.3479 14.25 14.4142 14.25H15.75V15.5858C15.75 15.6521 15.7763 15.7157 15.8232 15.7626L16.3162 16.2556C16.3511 16.2905 16.3956 16.3143 16.444 16.3239L17.3971 16.5146C17.4669 16.5285 17.5285 16.4669 17.5146 16.3971L17.3239 15.444C17.3138 15.3931 17.291 15.3516 17.2578 15.3185L11.1212 9.18186Z",
        fill: "#4B5563"
    }), $388e2b13f3516525$var$react_1.default.createElement("path", {
        d: "M7.5 6C7.5 6.55228 7.05229 7 6.5 7C5.94772 7 5.5 6.55228 5.5 6C5.5 5.44771 5.94772 5 6.5 5C7.05229 5 7.5 5.44771 7.5 6Z",
        fill: "#4B5563"
    }));
};
module.exports.key = $388e2b13f3516525$var$key;

});

parcelRegister("7Ar53", function(module, exports) {
"use strict";
var $5860e6ce19d0537f$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $5860e6ce19d0537f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.key_hand = void 0;

/* eslint-disable max-len */ const $5860e6ce19d0537f$var$react_1 = $5860e6ce19d0537f$var$__importDefault((parcelRequire("acw62")));

const $5860e6ce19d0537f$var$classnames_1 = $5860e6ce19d0537f$var$__importDefault((parcelRequire("8g1PZ")));
const $5860e6ce19d0537f$var$key_hand = (_a)=>{
    var { className: className } = _a, rest = $5860e6ce19d0537f$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $5860e6ce19d0537f$var$classnames_1.default)("helix-icon", "key-hand-outlined", className);
    return $5860e6ce19d0537f$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $5860e6ce19d0537f$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.2738 12.0357C13.1738 12.0357 14.0371 12.3926 14.6745 13.0281L15.9597 14.3096C16.253 14.602 16.7279 14.6014 17.0204 14.308C17.3128 14.0147 17.3121 13.5398 17.0188 13.2474L15.7336 11.9659C14.8151 11.05 13.5709 10.5357 12.2738 10.5357H8.66972C8.13513 10.5357 7.64077 10.7787 7.33309 11.1804C7.01429 11.5966 6.90984 12.1738 7.16865 12.7253C7.65875 13.7697 8.6863 15.0357 10.4893 15.0357H12.2446C12.6588 15.0357 12.9946 14.6999 12.9946 14.2857C12.9946 13.8715 12.6588 13.5357 12.2446 13.5357H10.4893C9.52456 13.5357 8.90155 12.8867 8.52693 12.0888C8.54439 12.0691 8.59144 12.0357 8.66972 12.0357H12.2738Z",
        fill: "#4B5563"
    }), $5860e6ce19d0537f$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.28104 10.6659C5.78682 10.254 5.16385 10.0285 4.52053 10.0285H4.24498C2.62171 10.0285 1.74598 11.9325 2.80239 13.165L5.9779 16.8697C6.88032 17.9226 8.19773 18.5285 9.58437 18.5285H16.2446C16.6588 18.5285 16.9946 18.1927 16.9946 17.7785C16.9946 17.3643 16.6588 17.0285 16.2446 17.0285H9.58437C8.63561 17.0285 7.73423 16.6139 7.11679 15.8935L3.94128 12.1888C3.71888 11.9293 3.90324 11.5285 4.24498 11.5285H4.52053C4.81295 11.5285 5.09612 11.631 5.32076 11.8182L8 14C8.31821 14.2652 8.79113 14.2222 9.0563 13.904C9.32148 13.5858 9.27848 13.1128 8.96028 12.8477L6.28104 10.6659Z",
        fill: "#4B5563"
    }), $5860e6ce19d0537f$var$react_1.default.createElement("path", {
        d: "M6.61785 5.06826C7.01027 5.45688 7.01336 6.09003 6.62474 6.48246C6.23613 6.87488 5.60297 6.87797 5.21055 6.48936C4.81812 6.10074 4.81503 5.46758 5.20365 5.07516C5.59227 4.68273 6.22542 4.67965 6.61785 5.06826Z",
        fill: "#4B5563"
    }), $5860e6ce19d0537f$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.67703 4.03571C4.57481 4.03571 4.48288 4.09794 4.44491 4.19286L3.80777 5.78571L4.44491 7.37855C4.48288 7.47347 4.57481 7.53571 4.67703 7.53571H7.5C7.63807 7.53571 7.75 7.42378 7.75 7.28571C7.75 6.87149 8.08579 6.53571 8.5 6.53571C8.91421 6.53571 9.25 6.87149 9.25 7.28571C9.25 8.2522 8.4665 9.03571 7.5 9.03571H4.67703C3.96145 9.03571 3.31796 8.60004 3.0522 7.93564L2.30364 6.06425C2.23212 5.88544 2.23212 5.68597 2.30364 5.50716L3.0522 3.63577C3.31796 2.97137 3.96145 2.53571 4.67703 2.53571H7.5C8.4665 2.53571 9.25 3.31921 9.25 4.28571C9.25 4.69992 8.91421 5.03571 8.5 5.03571C8.08579 5.03571 7.75 4.69992 7.75 4.28571C7.75 4.14763 7.63807 4.03571 7.5 4.03571H4.67703Z",
        fill: "#4B5563"
    }), $5860e6ce19d0537f$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 4.28571C7.75 3.87149 8.08579 3.53571 8.5 3.53571H16C16.2508 3.53571 16.4849 3.66103 16.624 3.86968L17.624 5.36968C17.8448 5.70088 17.7684 6.14688 17.45 6.38571L15.45 7.88571C15.1514 8.10965 14.7336 8.07995 14.4697 7.81604L14 7.34637L13.5303 7.81604C13.2374 8.10893 12.7626 8.10893 12.4697 7.81604L12 7.34637L11.5303 7.81604C11.3897 7.95669 11.1989 8.03571 11 8.03571H8.5C8.08579 8.03571 7.75 7.69992 7.75 7.28571C7.75 6.87149 8.08579 6.53571 8.5 6.53571H10.6893L11.4697 5.75538C11.7626 5.46248 12.2374 5.46248 12.5303 5.75538L13 6.22505L13.4697 5.75538C13.7626 5.46248 14.2374 5.46248 14.5303 5.75538L15.0704 6.29542L15.9824 5.6114L15.5986 5.03571H8.5C8.08579 5.03571 7.75 4.69992 7.75 4.28571Z",
        fill: "#4B5563"
    }));
};
module.exports.key_hand = $5860e6ce19d0537f$var$key_hand;

});

parcelRegister("4tri9", function(module, exports) {
"use strict";
var $341f0a6f5e450765$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $341f0a6f5e450765$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.launch = void 0;

/* eslint-disable max-len */ const $341f0a6f5e450765$var$react_1 = $341f0a6f5e450765$var$__importDefault((parcelRequire("acw62")));

const $341f0a6f5e450765$var$classnames_1 = $341f0a6f5e450765$var$__importDefault((parcelRequire("8g1PZ")));
const $341f0a6f5e450765$var$launch = (_a)=>{
    var { className: className } = _a, rest = $341f0a6f5e450765$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $341f0a6f5e450765$var$classnames_1.default)("helix-icon", "launch-outlined", className);
    return $341f0a6f5e450765$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $341f0a6f5e450765$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 3.34521C16.4142 3.34521 16.75 3.681 16.75 4.09521V8.09521C16.75 8.50943 16.4142 8.84521 16 8.84521C15.5858 8.84521 15.25 8.50943 15.25 8.09521V5.90587L9.53033 11.6255C9.23744 11.9184 8.76256 11.9184 8.46967 11.6255C8.17678 11.3327 8.17678 10.8578 8.46967 10.5649L14.1893 4.84521L12 4.84521C11.5858 4.84521 11.25 4.50943 11.25 4.09521C11.25 3.681 11.5858 3.34521 12 3.34521H16Z",
        fill: "#4B5563"
    }), $341f0a6f5e450765$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.25 6.09521C3.25 5.681 3.58579 5.34521 4 5.34521H9C9.41421 5.34521 9.75 5.681 9.75 6.09521C9.75 6.50943 9.41421 6.84521 9 6.84521H4.75V15.3452H13.25V11.0952C13.25 10.681 13.5858 10.3452 14 10.3452C14.4142 10.3452 14.75 10.681 14.75 11.0952V16.0952C14.75 16.5094 14.4142 16.8452 14 16.8452H4C3.58579 16.8452 3.25 16.5094 3.25 16.0952V6.09521Z",
        fill: "#4B5563"
    }));
};
module.exports.launch = $341f0a6f5e450765$var$launch;

});

parcelRegister("THfZM", function(module, exports) {
"use strict";
var $0a76b11b463a37e8$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $0a76b11b463a37e8$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.lightbulb = void 0;

/* eslint-disable max-len */ const $0a76b11b463a37e8$var$react_1 = $0a76b11b463a37e8$var$__importDefault((parcelRequire("acw62")));

const $0a76b11b463a37e8$var$classnames_1 = $0a76b11b463a37e8$var$__importDefault((parcelRequire("8g1PZ")));
const $0a76b11b463a37e8$var$lightbulb = (_a)=>{
    var { className: className } = _a, rest = $0a76b11b463a37e8$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $0a76b11b463a37e8$var$classnames_1.default)("helix-icon", "lightbulb-outlined", className);
    return $0a76b11b463a37e8$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $0a76b11b463a37e8$var$react_1.default.createElement("path", {
        d: "M7 15H13L12.6325 16.1026C12.2548 17.2357 11.1944 18 10 18C8.80562 18 7.74524 17.2357 7.36754 16.1026L7 15Z",
        fill: "#4B5563"
    }), $0a76b11b463a37e8$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.9189 13.5L12.5096 11.7277C12.6276 11.3739 12.8262 11.0525 13.0899 10.7888L13.4345 10.4442C14.1167 9.76195 14.5 8.83665 14.5 7.87183C14.5 5.45734 12.5427 3.5 10.1282 3.5H9.87183C7.45734 3.5 5.5 5.45734 5.5 7.87183C5.5 8.83665 5.88327 9.76195 6.5655 10.4442L6.03517 10.9745L5.50484 11.5048C4.54131 10.5413 4 9.23448 4 7.87183C4 4.62891 6.62891 2 9.87183 2H10.1282C13.3711 2 16 4.62891 16 7.87183C16 9.23448 15.4587 10.5413 14.4952 11.5048L14.1506 11.8494C14.0516 11.9484 13.9769 12.0692 13.9327 12.202L13 15H7L6.06734 12.202C6.02305 12.0692 5.94845 11.9484 5.84942 11.8494L5.50484 11.5048L6.03517 10.9745L6.5655 10.4442L6.91009 10.7888C7.17377 11.0525 7.37244 11.3739 7.49036 11.7277L8.08114 13.5H11.9189Z",
        fill: "#4B5563"
    }));
};
module.exports.lightbulb = $0a76b11b463a37e8$var$lightbulb;

});

parcelRegister("dOzDc", function(module, exports) {
"use strict";
var $a0eb9585b8214f2a$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $a0eb9585b8214f2a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.line_chart = void 0;

/* eslint-disable max-len */ const $a0eb9585b8214f2a$var$react_1 = $a0eb9585b8214f2a$var$__importDefault((parcelRequire("acw62")));

const $a0eb9585b8214f2a$var$classnames_1 = $a0eb9585b8214f2a$var$__importDefault((parcelRequire("8g1PZ")));
const $a0eb9585b8214f2a$var$line_chart = (_a)=>{
    var { className: className } = _a, rest = $a0eb9585b8214f2a$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $a0eb9585b8214f2a$var$classnames_1.default)("helix-icon", "line-chart-outlined", className);
    return $a0eb9585b8214f2a$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $a0eb9585b8214f2a$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.5 4.5V15.5H16.5V4.5H3.5ZM3 3C2.44772 3 2 3.44772 2 4V16C2 16.5523 2.44772 17 3 17H17C17.5523 17 18 16.5523 18 16V4C18 3.44772 17.5523 3 17 3H3Z",
        fill: "#4B5563"
    }), $a0eb9585b8214f2a$var$react_1.default.createElement("path", {
        d: "M15.5 8.25C15.5 8.94036 14.9404 9.5 14.25 9.5C13.5596 9.5 13 8.94036 13 8.25C13 7.55964 13.5596 7 14.25 7C14.9404 7 15.5 7.55964 15.5 8.25Z",
        fill: "#4B5563"
    }), $a0eb9585b8214f2a$var$react_1.default.createElement("path", {
        d: "M12.1362 9.02279L9.75 11.409L7.78033 9.43934C7.48744 9.14645 7.01257 9.14645 6.71967 9.43934L4.21967 11.9393C3.92678 12.2322 3.92678 12.7071 4.21967 13C4.51256 13.2929 4.98744 13.2929 5.28033 13L7.25 11.0303L9.21967 13C9.51257 13.2929 9.98744 13.2929 10.2803 13L13.0975 10.1828C12.6575 9.91987 12.3147 9.51089 12.1362 9.02279Z",
        fill: "#4B5563"
    }), $a0eb9585b8214f2a$var$react_1.default.createElement("path", {
        d: "M13.0035 8.1555L13.2197 7.93934C13.5126 7.64645 13.9874 7.64645 14.2803 7.93934C14.5732 8.23223 14.5732 8.70711 14.2803 9L13.8468 9.43354C13.3543 9.2658 13 8.79927 13 8.25C13 8.21821 13.0012 8.18669 13.0035 8.1555Z",
        fill: "#4B5563"
    }));
};
module.exports.line_chart = $a0eb9585b8214f2a$var$line_chart;

});

parcelRegister("ciFVb", function(module, exports) {
"use strict";
var $8f47af27205c1df3$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $8f47af27205c1df3$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.line_chart_loop = void 0;

/* eslint-disable max-len */ const $8f47af27205c1df3$var$react_1 = $8f47af27205c1df3$var$__importDefault((parcelRequire("acw62")));

const $8f47af27205c1df3$var$classnames_1 = $8f47af27205c1df3$var$__importDefault((parcelRequire("8g1PZ")));
const $8f47af27205c1df3$var$line_chart_loop = (_a)=>{
    var { className: className } = _a, rest = $8f47af27205c1df3$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $8f47af27205c1df3$var$classnames_1.default)("helix-icon", "line-chart-loop-outlined", className);
    return $8f47af27205c1df3$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $8f47af27205c1df3$var$react_1.default.createElement("path", {
        d: "M17.1606 3.95081C17.357 3.58611 17.2205 3.13126 16.8558 2.93488C16.4911 2.73851 16.0362 2.87496 15.8399 3.23966L13.009 8.49707C13.5775 8.35285 14.1643 8.35306 14.7195 8.48426L17.1606 3.95081Z",
        fill: "#4B5563"
    }), $8f47af27205c1df3$var$react_1.default.createElement("path", {
        d: "M11.3164 9.47208L10.4952 8.65083L8.18671 13.8973C8.087 14.1239 7.88186 14.2867 7.63851 14.3324C7.39517 14.378 7.14497 14.3006 6.9699 14.1256L5.20569 12.3614L3.67105 15.4306C3.4858 15.8011 3.0353 15.9513 2.66482 15.7661C2.29433 15.5808 2.14416 15.1303 2.3294 14.7598L4.32941 10.7598C4.43722 10.5442 4.64212 10.3935 4.88009 10.3549C5.11806 10.3163 5.36008 10.3944 5.53056 10.5649L7.2553 12.2896L9.56374 7.04318C9.66345 6.81656 9.86859 6.65375 10.1119 6.6081C10.3553 6.56245 10.6055 6.63983 10.7806 6.81491L12.595 8.62933C12.4242 8.69556 12.2563 8.7757 12.0927 8.87013C11.8006 9.03877 11.5411 9.24217 11.3164 9.47208Z",
        fill: "#4B5563"
    }), $8f47af27205c1df3$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.558 9.67617C11.2816 10.4131 10.8443 12.0452 11.5812 13.3215C12.1879 14.3724 13.4014 14.8545 14.5236 14.5808L15.6888 16.5989L16.9878 15.8489L15.8227 13.8307C16.6208 12.9958 16.81 11.7038 16.2033 10.6529C15.4664 9.37657 13.8343 8.93926 12.558 9.67617ZM12.8802 12.5715C12.5575 12.0126 12.749 11.2979 13.308 10.9752C13.8669 10.6525 14.5816 10.844 14.9043 11.4029C15.227 11.9619 15.0355 12.6765 14.4765 12.9992C13.9176 13.3219 13.2029 13.1304 12.8802 12.5715Z",
        fill: "#4B5563"
    }));
};
module.exports.line_chart_loop = $8f47af27205c1df3$var$line_chart_loop;

});

parcelRegister("gJc0v", function(module, exports) {
"use strict";
var $c2da29b366d22e0e$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $c2da29b366d22e0e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.link = void 0;

/* eslint-disable max-len */ const $c2da29b366d22e0e$var$react_1 = $c2da29b366d22e0e$var$__importDefault((parcelRequire("acw62")));

const $c2da29b366d22e0e$var$classnames_1 = $c2da29b366d22e0e$var$__importDefault((parcelRequire("8g1PZ")));
const $c2da29b366d22e0e$var$link = (_a)=>{
    var { className: className } = _a, rest = $c2da29b366d22e0e$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $c2da29b366d22e0e$var$classnames_1.default)("helix-icon", "link-outlined", className);
    return $c2da29b366d22e0e$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $c2da29b366d22e0e$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.99238 13.6896L8.76256 13.9194C7.2981 15.3839 4.92373 15.3839 3.45926 13.9194C1.9948 12.455 1.9948 10.0806 3.45926 8.61612L6.28769 5.7877C7.57054 4.50485 9.55159 4.34575 11.0076 5.31041L11.2374 5.08059C12.7019 3.61612 15.0763 3.61612 16.5407 5.08059C18.0052 6.54505 18.0052 8.91942 16.5407 10.3839L13.7123 13.2123C12.4295 14.4952 10.4484 14.6543 8.99238 13.6896ZM9.47065 12.1526C10.3494 13.0303 11.7733 13.03 12.6516 12.1517L15.4801 9.32323C16.3588 8.44455 16.3588 7.01993 15.4801 6.14125C14.6014 5.26257 13.1768 5.26257 12.2981 6.14125L12.0683 6.37107C13.0329 7.82709 12.8738 9.80815 11.591 11.091L10.8839 11.7981C10.591 12.091 10.1161 12.091 9.82322 11.7981C9.53033 11.5052 9.53033 11.0303 9.82322 10.7374L10.5303 10.0303C11.409 9.15166 11.409 7.72704 10.5303 6.84836C10.5301 6.84812 10.5299 6.84789 10.5296 6.84766C9.6509 5.96968 8.2268 5.96991 7.34835 6.84836L4.51992 9.67678C3.64124 10.5555 3.64124 11.9801 4.51992 12.8588C5.3986 13.7374 6.82323 13.7374 7.7019 12.8588L7.93172 12.6289C6.96707 11.1729 7.12616 9.19186 8.40901 7.90902L9.11612 7.20191C9.40901 6.90902 9.88388 6.90902 10.1768 7.20191C10.4697 7.4948 10.4697 7.96968 10.1768 8.26257L9.46967 8.96968C8.59099 9.84835 8.59099 11.273 9.46967 12.1517C9.47 12.152 9.47033 12.1523 9.47065 12.1526Z",
        fill: "#4B5563"
    }));
};
module.exports.link = $c2da29b366d22e0e$var$link;

});

parcelRegister("9nL4t", function(module, exports) {
"use strict";
var $6d4ac661d9329885$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $6d4ac661d9329885$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.list = void 0;

/* eslint-disable max-len */ const $6d4ac661d9329885$var$react_1 = $6d4ac661d9329885$var$__importDefault((parcelRequire("acw62")));

const $6d4ac661d9329885$var$classnames_1 = $6d4ac661d9329885$var$__importDefault((parcelRequire("8g1PZ")));
const $6d4ac661d9329885$var$list = (_a)=>{
    var { className: className } = _a, rest = $6d4ac661d9329885$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $6d4ac661d9329885$var$classnames_1.default)("helix-icon", "list-outlined", className);
    return $6d4ac661d9329885$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $6d4ac661d9329885$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.25 4C3.25 3.58579 3.58579 3.25 4 3.25H16.013C16.4272 3.25 16.763 3.58579 16.763 4C16.763 4.41421 16.4272 4.75 16.013 4.75H4C3.58579 4.75 3.25 4.41421 3.25 4ZM3.25 8C3.25 7.58579 3.58579 7.25 4 7.25H16.013C16.4272 7.25 16.763 7.58579 16.763 8C16.763 8.41421 16.4272 8.75 16.013 8.75H4C3.58579 8.75 3.25 8.41421 3.25 8ZM3.25 12C3.25 11.5858 3.58579 11.25 4 11.25H16.013C16.4272 11.25 16.763 11.5858 16.763 12C16.763 12.4142 16.4272 12.75 16.013 12.75H4C3.58579 12.75 3.25 12.4142 3.25 12ZM3.25 16C3.25 15.5858 3.58579 15.25 4 15.25H16.013C16.4272 15.25 16.763 15.5858 16.763 16C16.763 16.4142 16.4272 16.75 16.013 16.75H4C3.58579 16.75 3.25 16.4142 3.25 16Z",
        fill: "#4B5563"
    }));
};
module.exports.list = $6d4ac661d9329885$var$list;

});

parcelRegister("go5PS", function(module, exports) {
"use strict";
var $bee36a12069e79ad$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $bee36a12069e79ad$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.list_reorder = void 0;

/* eslint-disable max-len */ const $bee36a12069e79ad$var$react_1 = $bee36a12069e79ad$var$__importDefault((parcelRequire("acw62")));

const $bee36a12069e79ad$var$classnames_1 = $bee36a12069e79ad$var$__importDefault((parcelRequire("8g1PZ")));
const $bee36a12069e79ad$var$list_reorder = (_a)=>{
    var { className: className } = _a, rest = $bee36a12069e79ad$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $bee36a12069e79ad$var$classnames_1.default)("helix-icon", "list-reorder-outlined", className);
    return $bee36a12069e79ad$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $bee36a12069e79ad$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.25 7.09521C3.25 6.681 3.58579 6.34521 4 6.34521H16.013C16.4272 6.34521 16.763 6.681 16.763 7.09521C16.763 7.50943 16.4272 7.84521 16.013 7.84521H4C3.58579 7.84521 3.25 7.50943 3.25 7.09521ZM3.25 10.0952C3.25 9.681 3.58579 9.34521 4 9.34521H16.013C16.4272 9.34521 16.763 9.681 16.763 10.0952C16.763 10.5094 16.4272 10.8452 16.013 10.8452H4C3.58579 10.8452 3.25 10.5094 3.25 10.0952ZM3.25 13.0952C3.25 12.681 3.58579 12.3452 4 12.3452H16.013C16.4272 12.3452 16.763 12.681 16.763 13.0952C16.763 13.5094 16.4272 13.8452 16.013 13.8452H4C3.58579 13.8452 3.25 13.5094 3.25 13.0952Z",
        fill: "#4B5563"
    }));
};
module.exports.list_reorder = $bee36a12069e79ad$var$list_reorder;

});

parcelRegister("4DKx9", function(module, exports) {
"use strict";
var $360ee68ded083cdc$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $360ee68ded083cdc$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.location = void 0;

/* eslint-disable max-len */ const $360ee68ded083cdc$var$react_1 = $360ee68ded083cdc$var$__importDefault((parcelRequire("acw62")));

const $360ee68ded083cdc$var$classnames_1 = $360ee68ded083cdc$var$__importDefault((parcelRequire("8g1PZ")));
const $360ee68ded083cdc$var$location = (_a)=>{
    var { className: className } = _a, rest = $360ee68ded083cdc$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $360ee68ded083cdc$var$classnames_1.default)("helix-icon", "location-outlined", className);
    return $360ee68ded083cdc$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $360ee68ded083cdc$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.23779 11.0124L10.0787 16.058L16.1755 4.07465L4.19215 10.1715L9.23779 11.0124ZM7.93434 12.3159L8.84894 17.8035C9.00757 18.7553 10.2891 18.9525 10.7266 18.0925L18.2088 3.38609C18.6478 2.52323 17.727 1.60236 16.8641 2.04136L2.15766 9.52358C1.29764 9.96113 1.49492 11.2426 2.44672 11.4013L7.93434 12.3159Z",
        fill: "#4B5563"
    }));
};
module.exports.location = $360ee68ded083cdc$var$location;

});

parcelRegister("3j79U", function(module, exports) {
"use strict";
var $2688b306a48a3a45$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $2688b306a48a3a45$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.lock = void 0;

/* eslint-disable max-len */ const $2688b306a48a3a45$var$react_1 = $2688b306a48a3a45$var$__importDefault((parcelRequire("acw62")));

const $2688b306a48a3a45$var$classnames_1 = $2688b306a48a3a45$var$__importDefault((parcelRequire("8g1PZ")));
const $2688b306a48a3a45$var$lock = (_a)=>{
    var { className: className } = _a, rest = $2688b306a48a3a45$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $2688b306a48a3a45$var$classnames_1.default)("helix-icon", "lock-outlined", className);
    return $2688b306a48a3a45$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $2688b306a48a3a45$var$react_1.default.createElement("path", {
        d: "M11.5 12.5C11.5 13.3284 10.8284 14 10 14C9.17157 14 8.5 13.3284 8.5 12.5C8.5 11.6716 9.17157 11 10 11C10.8284 11 11.5 11.6716 11.5 12.5Z",
        fill: "#4B5563"
    }), $2688b306a48a3a45$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7 8.75C6.30964 8.75 5.75 9.30964 5.75 10V15C5.75 15.6904 6.30964 16.25 7 16.25H13C13.6904 16.25 14.25 15.6904 14.25 15V10C14.25 9.30964 13.6904 8.75 13 8.75H7ZM4.25 10C4.25 8.48122 5.48122 7.25 7 7.25H13C14.5188 7.25 15.75 8.48122 15.75 10V15C15.75 16.5188 14.5188 17.75 13 17.75H7C5.48122 17.75 4.25 16.5188 4.25 15V10Z",
        fill: "#4B5563"
    }), $2688b306a48a3a45$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 3.75C8.75736 3.75 7.75 4.75736 7.75 6V8H6.25V6C6.25 3.92893 7.92893 2.25 10 2.25C12.0711 2.25 13.75 3.92893 13.75 6V8H12.25V6C12.25 4.75736 11.2426 3.75 10 3.75Z",
        fill: "#4B5563"
    }));
};
module.exports.lock = $2688b306a48a3a45$var$lock;

});

parcelRegister("Gufh1", function(module, exports) {
"use strict";
var $07fb62745756d996$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $07fb62745756d996$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.lock_unlock = void 0;

/* eslint-disable max-len */ const $07fb62745756d996$var$react_1 = $07fb62745756d996$var$__importDefault((parcelRequire("acw62")));

const $07fb62745756d996$var$classnames_1 = $07fb62745756d996$var$__importDefault((parcelRequire("8g1PZ")));
const $07fb62745756d996$var$lock_unlock = (_a)=>{
    var { className: className } = _a, rest = $07fb62745756d996$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $07fb62745756d996$var$classnames_1.default)("helix-icon", "lock-unlock-outlined", className);
    return $07fb62745756d996$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $07fb62745756d996$var$react_1.default.createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $07fb62745756d996$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.75 10.4048C6.05964 10.4048 5.5 10.9644 5.5 11.6548V15.6548C5.5 16.3451 6.05964 16.9048 6.75 16.9048H12.75C13.4404 16.9048 14 16.3451 14 15.6548V11.6548C14 10.9644 13.4404 10.4048 12.75 10.4048H6.75ZM4 11.6548C4 10.136 5.23122 8.90479 6.75 8.90479H12.75C14.2688 8.90479 15.5 10.136 15.5 11.6548V15.6548C15.5 17.1736 14.2688 18.4048 12.75 18.4048H6.75C5.23122 18.4048 4 17.1736 4 15.6548V11.6548Z",
        fill: "#4B5563"
    }), $07fb62745756d996$var$react_1.default.createElement("path", {
        d: "M7.5 5.65479C7.5 4.41214 8.50736 3.40479 9.75 3.40479C10.9926 3.40479 12 4.41214 12 5.65479V9.40479H13.5V5.65479C13.5 3.58372 11.8211 1.90479 9.75 1.90479C7.67893 1.90479 6 3.58372 6 5.65479V5.90479C6 6.18093 6.22386 6.40479 6.5 6.40479H7C7.27614 6.40479 7.5 6.18093 7.5 5.90479V5.65479Z",
        fill: "#4B5563"
    })));
};
module.exports.lock_unlock = $07fb62745756d996$var$lock_unlock;

});

parcelRegister("llPjL", function(module, exports) {
"use strict";
var $f8b35dc75ddf7b83$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $f8b35dc75ddf7b83$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.lockbox = void 0;

/* eslint-disable max-len */ const $f8b35dc75ddf7b83$var$react_1 = $f8b35dc75ddf7b83$var$__importDefault((parcelRequire("acw62")));

const $f8b35dc75ddf7b83$var$classnames_1 = $f8b35dc75ddf7b83$var$__importDefault((parcelRequire("8g1PZ")));
const $f8b35dc75ddf7b83$var$lockbox = (_a)=>{
    var { className: className } = _a, rest = $f8b35dc75ddf7b83$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $f8b35dc75ddf7b83$var$classnames_1.default)("helix-icon", "lockbox-outlined", className);
    return $f8b35dc75ddf7b83$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $f8b35dc75ddf7b83$var$react_1.default.createElement("path", {
        d: "M9 11C9 11.5523 8.55228 12 8 12C7.44772 12 7 11.5523 7 11C7 10.4477 7.44772 10 8 10C8.55228 10 9 10.4477 9 11Z",
        fill: "#4B5563"
    }), $f8b35dc75ddf7b83$var$react_1.default.createElement("path", {
        d: "M9 15C9 15.5523 8.55228 16 8 16C7.44772 16 7 15.5523 7 15C7 14.4477 7.44772 14 8 14C8.55228 14 9 14.4477 9 15Z",
        fill: "#4B5563"
    }), $f8b35dc75ddf7b83$var$react_1.default.createElement("path", {
        d: "M12 12C12.5523 12 13 11.5523 13 11C13 10.4477 12.5523 10 12 10C11.4477 10 11 10.4477 11 11C11 11.5523 11.4477 12 12 12Z",
        fill: "#4B5563"
    }), $f8b35dc75ddf7b83$var$react_1.default.createElement("path", {
        d: "M13 15C13 15.5523 12.5523 16 12 16C11.4477 16 11 15.5523 11 15C11 14.4477 11.4477 14 12 14C12.5523 14 13 14.4477 13 15Z",
        fill: "#4B5563"
    }), $f8b35dc75ddf7b83$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.25 7.25V5C6.25 2.92893 7.92893 1.25 10 1.25C12.0711 1.25 13.75 2.92893 13.75 5V7.25H15C15.4142 7.25 15.75 7.58579 15.75 8V18C15.75 18.4142 15.4142 18.75 15 18.75H5C4.58579 18.75 4.25 18.4142 4.25 18V8C4.25 7.58579 4.58579 7.25 5 7.25H6.25ZM7.75 5C7.75 3.75736 8.75736 2.75 10 2.75C11.2426 2.75 12.25 3.75736 12.25 5V7.25H7.75V5ZM5.75 17.25V8.75H14.25V17.25H5.75Z",
        fill: "#4B5563"
    }));
};
module.exports.lockbox = $f8b35dc75ddf7b83$var$lockbox;

});

parcelRegister("hmpDM", function(module, exports) {
"use strict";
var $ca38616b8a6c2307$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $ca38616b8a6c2307$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.lot = void 0;

/* eslint-disable max-len */ const $ca38616b8a6c2307$var$react_1 = $ca38616b8a6c2307$var$__importDefault((parcelRequire("acw62")));

const $ca38616b8a6c2307$var$classnames_1 = $ca38616b8a6c2307$var$__importDefault((parcelRequire("8g1PZ")));
const $ca38616b8a6c2307$var$lot = (_a)=>{
    var { className: className } = _a, rest = $ca38616b8a6c2307$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $ca38616b8a6c2307$var$classnames_1.default)("helix-icon", "lot-outlined", className);
    return $ca38616b8a6c2307$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $ca38616b8a6c2307$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17 17.75V2.25C17 1.83579 16.6642 1.5 16.25 1.5H4.25C3.83579 1.5 3.5 1.83579 3.5 2.25V17.75C3.5 18.1642 3.83579 18.5 4.25 18.5H16.25C16.4489 18.5 16.6397 18.421 16.7803 18.2803C16.921 18.1397 17 17.9489 17 17.75ZM13.1998 10.5785L5.62122 3L15.5 3V8.29688L13.1998 10.5785ZM5 4.5001L12.1391 11.6392L6.77829 17H5L5 4.5001ZM15.4852 17H15.5V16.9852L15.4852 17ZM13.4999 17L11.1998 14.6999L8.89961 17H13.4999ZM12.2604 13.6392L15.5 10.3996V16.8788L12.2604 13.6392Z",
        fill: "#4B5563"
    }));
};
module.exports.lot = $ca38616b8a6c2307$var$lot;

});

parcelRegister("jWifa", function(module, exports) {
"use strict";
var $e84195ed66322cdb$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $e84195ed66322cdb$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.magnet = void 0;

/* eslint-disable max-len */ const $e84195ed66322cdb$var$react_1 = $e84195ed66322cdb$var$__importDefault((parcelRequire("acw62")));

const $e84195ed66322cdb$var$classnames_1 = $e84195ed66322cdb$var$__importDefault((parcelRequire("8g1PZ")));
const $e84195ed66322cdb$var$magnet = (_a)=>{
    var { className: className } = _a, rest = $e84195ed66322cdb$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $e84195ed66322cdb$var$classnames_1.default)("helix-icon", "magnet-outlined", className);
    return $e84195ed66322cdb$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e84195ed66322cdb$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.96967 4.75013C6.53184 4.76647 3.75 7.5584 3.75 11.0001C3.75 14.4417 6.53185 17.2337 9.96968 17.25L14.5623 16.8673C14.9514 16.8348 15.25 16.5102 15.25 16.1205V15.5001H16.75V16.1205C16.75 17.2911 15.8526 18.2649 14.6869 18.3621L10.0312 18.7501H10C5.71979 18.7501 2.25 15.2803 2.25 11.0001C2.25 6.71986 5.71979 3.25006 10 3.25006L10.0312 3.25006L14.6869 3.63803C15.853 3.73521 16.75 4.71006 16.75 5.88026V7.00006L15.25 7.00006V5.88026C15.25 5.49019 14.951 5.16525 14.5623 5.13285L9.96967 4.75013Z",
        fill: "#4B5563"
    }), $e84195ed66322cdb$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.75 7.00006V7.41766C16.75 8.43867 15.8795 9.24287 14.8617 9.16218L9.66545 8.75029C8.67701 8.76676 7.75 9.69088 7.75 11.0001C7.75 12.3092 8.67701 13.2334 9.66545 13.2498L14.8617 12.8379C15.8795 12.7573 16.75 13.5615 16.75 14.5825V15.5001H15.25V14.5825C15.25 14.4366 15.1256 14.3217 14.9802 14.3332L9.72199 14.7501H9.69231C7.7169 14.7501 6.25 12.9927 6.25 11.0001C6.25 9.00739 7.7169 7.25006 9.69231 7.25006H9.72198L14.9802 7.66687C15.1256 7.6784 15.25 7.56352 15.25 7.41766V7.00006L16.75 7.00006Z",
        fill: "#4B5563"
    }), $e84195ed66322cdb$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 8.00006V4.00006L13.5 4.00006V8.00006H12Z",
        fill: "#4B5563"
    }), $e84195ed66322cdb$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 18.0001V14.0001H13.5V18.0001H12Z",
        fill: "#4B5563"
    }));
};
module.exports.magnet = $e84195ed66322cdb$var$magnet;

});

parcelRegister("gDslQ", function(module, exports) {
"use strict";
var $c1c647d48f41daee$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $c1c647d48f41daee$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.map = void 0;

const $c1c647d48f41daee$var$react_1 = $c1c647d48f41daee$var$__importDefault((parcelRequire("acw62")));

const $c1c647d48f41daee$var$classnames_1 = $c1c647d48f41daee$var$__importDefault((parcelRequire("8g1PZ")));
const $c1c647d48f41daee$var$map = (_a)=>{
    var { className: className } = _a, rest = $c1c647d48f41daee$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $c1c647d48f41daee$var$classnames_1.default)("helix-icon", "map-outlined", className);
    return $c1c647d48f41daee$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $c1c647d48f41daee$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        // eslint-disable-next-line max-len
        d: "M1.5523 2.39829C1.74251 2.25677 1.98843 2.21351 2.21551 2.28164L7.01807 3.72241L12.8181 2.2724C12.949 2.23968 13.0863 2.24287 13.2155 2.28164L18.2155 3.78164C18.5327 3.87681 18.75 4.1688 18.75 4.50001V17C18.75 17.2371 18.6379 17.4602 18.4477 17.6017C18.2575 17.7432 18.0116 17.7865 17.7845 17.7184L12.9819 16.2776L7.1819 17.7276C7.05101 17.7603 6.91372 17.7571 6.78449 17.7184L1.78449 16.2184C1.46725 16.1232 1.25 15.8312 1.25 15.5V3.00001C1.25 2.76293 1.36209 2.53981 1.5523 2.39829ZM13.75 14.942L17.25 15.992V5.05803L13.75 4.00803V14.942ZM12.25 3.96059V14.9144L7.75 16.0394V5.08559L12.25 3.96059ZM6.25 5.05803L2.75 4.00803V14.942L6.25 15.992V5.05803Z",
        fill: "#4B5563"
    }));
};
module.exports.map = $c1c647d48f41daee$var$map;

});

parcelRegister("lwNnv", function(module, exports) {
"use strict";
var $fac2e39ad55c5cd2$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $fac2e39ad55c5cd2$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.map_area = void 0;

const $fac2e39ad55c5cd2$var$classnames_1 = $fac2e39ad55c5cd2$var$__importDefault((parcelRequire("8g1PZ")));

const $fac2e39ad55c5cd2$var$react_1 = $fac2e39ad55c5cd2$var$__importDefault((parcelRequire("acw62")));
const $fac2e39ad55c5cd2$var$map_area = (_a)=>{
    var { className: className } = _a, rest = $fac2e39ad55c5cd2$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $fac2e39ad55c5cd2$var$classnames_1.default)("helix-icon", "map_area-outlined", className);
    return $fac2e39ad55c5cd2$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $fac2e39ad55c5cd2$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        // eslint-disable-next-line max-len
        d: "M3 2.75C2.86193 2.75 2.75 2.86193 2.75 3V17C2.75 17.1381 2.86193 17.25 3 17.25H17C17.1381 17.25 17.25 17.1381 17.25 17V3C17.25 2.86193 17.1381 2.75 17 2.75H3ZM1.25 3C1.25 2.0335 2.0335 1.25 3 1.25H17C17.9665 1.25 18.75 2.0335 18.75 3V17C18.75 17.9665 17.9665 18.75 17 18.75H3C2.0335 18.75 1.25 17.9665 1.25 17V3ZM8.364 4.6025C8.55637 4.29471 8.94154 4.16884 9.27854 4.30364L14.2785 6.30364C14.5633 6.41754 14.75 6.69332 14.75 7V12C14.75 12.1989 14.671 12.3897 14.5303 12.5303L11.5303 15.5303C11.3897 15.671 11.1989 15.75 11 15.75H6.5C6.08579 15.75 5.75 15.4142 5.75 15V9C5.75 8.85944 5.7895 8.7217 5.864 8.6025L8.364 4.6025ZM9.30366 5.92924L7.25 9.2151V14.25H10.6893L13.25 11.6893V7.50778L9.30366 5.92924Z",
        fill: "#4B5563"
    }));
};
module.exports.map_area = $fac2e39ad55c5cd2$var$map_area;

});

parcelRegister("28k1Y", function(module, exports) {
"use strict";
var $18dbddd02e96052a$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $18dbddd02e96052a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.map_pin = void 0;

const $18dbddd02e96052a$var$react_1 = $18dbddd02e96052a$var$__importDefault((parcelRequire("acw62")));

const $18dbddd02e96052a$var$classnames_1 = $18dbddd02e96052a$var$__importDefault((parcelRequire("8g1PZ")));
const $18dbddd02e96052a$var$map_pin = (_a)=>{
    var { className: className } = _a, rest = $18dbddd02e96052a$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $18dbddd02e96052a$var$classnames_1.default)("helix-icon", "map-pin-outlined", className);
    return $18dbddd02e96052a$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $18dbddd02e96052a$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        // eslint-disable-next-line max-len
        d: "M10 2.75C7.08793 2.75 4.75 5.06584 4.75 7.89474C4.75 10.1552 6.11054 12.5103 7.58803 14.3766C8.3139 15.2935 9.04155 16.0596 9.58812 16.5966C9.74138 16.7472 9.88005 16.8794 10 16.9914C10.12 16.8794 10.2586 16.7472 10.4119 16.5966C10.9584 16.0596 11.6861 15.2935 12.412 14.3766C13.8895 12.5103 15.25 10.1552 15.25 7.89474C15.25 5.06584 12.9121 2.75 10 2.75ZM10 18C9.5169 18.5737 9.51674 18.5735 9.51655 18.5734L9.51032 18.5681L9.49517 18.5552C9.48228 18.5442 9.46387 18.5283 9.44029 18.5078C9.39313 18.4668 9.32531 18.4071 9.23977 18.3299C9.06875 18.1756 8.82655 17.9512 8.53688 17.6666C7.95845 17.0983 7.1861 16.2855 6.41197 15.3076C4.88946 13.3845 3.25 10.6869 3.25 7.89474C3.25 4.21249 6.28465 1.25 10 1.25C13.7154 1.25 16.75 4.21249 16.75 7.89474C16.75 10.6869 15.1105 13.3845 13.588 15.3076C12.8139 16.2855 12.0416 17.0983 11.4631 17.6666C11.1734 17.9512 10.9313 18.1756 10.7602 18.3299C10.6747 18.4071 10.6069 18.4668 10.5597 18.5078C10.5361 18.5283 10.5177 18.5442 10.5048 18.5552L10.4897 18.5681L10.4839 18.573C10.4837 18.5731 10.4831 18.5737 10 18ZM10 18L10.4831 18.5737C10.2039 18.8088 9.79572 18.8085 9.51655 18.5734L10 18ZM10 6.75C9.30964 6.75 8.75 7.30964 8.75 8C8.75 8.69036 9.30964 9.25 10 9.25C10.6904 9.25 11.25 8.69036 11.25 8C11.25 7.30964 10.6904 6.75 10 6.75ZM7.25 8C7.25 6.48122 8.48122 5.25 10 5.25C11.5188 5.25 12.75 6.48122 12.75 8C12.75 9.51878 11.5188 10.75 10 10.75C8.48122 10.75 7.25 9.51878 7.25 8Z",
        fill: "#4B5563"
    }));
};
module.exports.map_pin = $18dbddd02e96052a$var$map_pin;

});

parcelRegister("7SlIE", function(module, exports) {
"use strict";
var $5bbe6c8d14932859$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $5bbe6c8d14932859$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.matching_buyers = void 0;

/* eslint-disable max-len */ const $5bbe6c8d14932859$var$react_1 = $5bbe6c8d14932859$var$__importDefault((parcelRequire("acw62")));

const $5bbe6c8d14932859$var$classnames_1 = $5bbe6c8d14932859$var$__importDefault((parcelRequire("8g1PZ")));
const $5bbe6c8d14932859$var$matching_buyers = (_a)=>{
    var { className: className } = _a, rest = $5bbe6c8d14932859$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $5bbe6c8d14932859$var$classnames_1.default)("helix-icon", "matching-buyers-outlined", className);
    return $5bbe6c8d14932859$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $5bbe6c8d14932859$var$react_1.default.createElement("path", {
        d: "M11 17.4047C11 16.5763 11.6716 15.9047 12.5 15.9047H15.5C16.3284 15.9047 17 16.5763 17 17.4047V17.9047C17 18.0869 17 18.2578 17 18.4049C17 18.681 16.7761 18.9047 16.5 18.9047H11C11 18.9047 11 18.457 11 17.9047V17.4047Z",
        fill: "#4B5563"
    }), $5bbe6c8d14932859$var$react_1.default.createElement("path", {
        d: "M12.5 14.4047C12.5 13.5763 13.1716 12.9047 14 12.9047C14.8284 12.9047 15.5 13.5763 15.5 14.4047C15.5 15.2332 14.8284 15.9047 14 15.9047C13.1716 15.9047 12.5 15.2332 12.5 14.4047Z",
        fill: "#4B5563"
    }), $5bbe6c8d14932859$var$react_1.default.createElement("path", {
        d: "M7.00001 17.4047C7.00001 16.5763 7.67158 15.9047 8.50001 15.9047H11.5C12.3284 15.9047 13 16.5763 13 17.4047V17.9047C13 18.0869 13 18.2578 13 18.4049C13 18.681 12.7761 18.9047 12.5 18.9047H7C7 18.9047 7.00001 18.457 7.00001 17.9047V17.4047Z",
        fill: "#4B5563"
    }), $5bbe6c8d14932859$var$react_1.default.createElement("path", {
        d: "M8.50001 14.4047C8.50001 13.5763 9.17158 12.9047 10 12.9047C10.8284 12.9047 11.5 13.5763 11.5 14.4047C11.5 15.2332 10.8284 15.9047 10 15.9047C9.17158 15.9047 8.50001 15.2332 8.50001 14.4047Z",
        fill: "#4B5563"
    }), $5bbe6c8d14932859$var$react_1.default.createElement("path", {
        d: "M3 17.4047C3 16.5763 3.67157 15.9047 4.5 15.9047H7.5C8.32843 15.9047 9 16.5763 9 17.4047V17.9047C9 18.457 9 18.9047 9 18.9047H3.5C3.22386 18.9047 3 18.681 3 18.4049C3 18.2578 3 18.0869 3 17.9047V17.4047Z",
        fill: "#4B5563"
    }), $5bbe6c8d14932859$var$react_1.default.createElement("path", {
        d: "M4.5 14.4047C4.5 13.5763 5.17158 12.9047 6 12.9047C6.82843 12.9047 7.5 13.5763 7.5 14.4047C7.5 15.2332 6.82843 15.9047 6 15.9047C5.17158 15.9047 4.5 15.2332 4.5 14.4047Z",
        fill: "#4B5563"
    }), $5bbe6c8d14932859$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.2646 5.10912C13.5659 5.39333 13.5798 5.868 13.2956 6.16933L9.52289 10.1693C9.2469 10.4619 8.78922 10.4847 8.48552 10.221L6.75825 8.721C6.4455 8.44941 6.41214 7.97571 6.68374 7.66296C6.95533 7.35022 7.42903 7.31686 7.74178 7.58845L8.92557 8.61648L12.2044 5.14012C12.4886 4.83879 12.9633 4.82491 13.2646 5.10912Z",
        fill: "#4B5563"
    }));
};
module.exports.matching_buyers = $5bbe6c8d14932859$var$matching_buyers;

});

parcelRegister("hT3KA", function(module, exports) {
"use strict";
var $d05a7b749c5266ca$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d05a7b749c5266ca$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.megaphone = void 0;

/* eslint-disable max-len */ const $d05a7b749c5266ca$var$react_1 = $d05a7b749c5266ca$var$__importDefault((parcelRequire("acw62")));

const $d05a7b749c5266ca$var$classnames_1 = $d05a7b749c5266ca$var$__importDefault((parcelRequire("8g1PZ")));
const $d05a7b749c5266ca$var$megaphone = (_a)=>{
    var { className: className } = _a, rest = $d05a7b749c5266ca$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $d05a7b749c5266ca$var$classnames_1.default)("helix-icon", "megaphone-outlined", className);
    return $d05a7b749c5266ca$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $d05a7b749c5266ca$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.3354 3.32918C15.5895 3.45623 15.75 3.71593 15.75 4V7.41841C16.3412 7.69928 16.75 8.30191 16.75 9V10C16.75 10.6981 16.3412 11.3007 15.75 11.5816V15C15.75 15.2841 15.5895 15.5438 15.3354 15.6708C15.0813 15.7979 14.7773 15.7705 14.55 15.6L10.75 12.75H9.58558L8.72761 16.1819C8.64414 16.5158 8.34415 16.75 8 16.75H7C6.76905 16.75 6.55098 16.6436 6.40885 16.4616C6.26672 16.2795 6.21638 16.0422 6.27239 15.8181L7.03942 12.75H6.5C4.70507 12.75 3.25 11.2949 3.25 9.5C3.25 7.70508 4.70507 6.25 6.5 6.25H10.75L14.55 3.4C14.7773 3.22956 15.0813 3.20214 15.3354 3.32918ZM11 11.25C11.1623 11.25 11.3202 11.3026 11.45 11.4L14.25 13.5V5.5L11.45 7.6C11.3202 7.69737 11.1623 7.75 11 7.75H6.5C5.5335 7.75 4.75 8.53351 4.75 9.5C4.75 10.4665 5.5335 11.25 6.5 11.25H11Z",
        fill: "#4B5563"
    }));
};
module.exports.megaphone = $d05a7b749c5266ca$var$megaphone;

});

parcelRegister("iDqCu", function(module, exports) {
"use strict";
var $d91084a3bf2e0437$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d91084a3bf2e0437$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.menu = void 0;

/* eslint-disable max-len */ const $d91084a3bf2e0437$var$react_1 = $d91084a3bf2e0437$var$__importDefault((parcelRequire("acw62")));

const $d91084a3bf2e0437$var$classnames_1 = $d91084a3bf2e0437$var$__importDefault((parcelRequire("8g1PZ")));
const $d91084a3bf2e0437$var$menu = (_a)=>{
    var { className: className } = _a, rest = $d91084a3bf2e0437$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $d91084a3bf2e0437$var$classnames_1.default)("helix-icon", "menu-outlined", className);
    return $d91084a3bf2e0437$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $d91084a3bf2e0437$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20 5H0V3H20V5ZM20 11H0V9H20V11ZM20 17H0V15H20V17Z",
        fill: "#4B5563"
    }));
};
module.exports.menu = $d91084a3bf2e0437$var$menu;

});

parcelRegister("2XxA1", function(module, exports) {
"use strict";
var $227b23bed0ada04c$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $227b23bed0ada04c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.merge = void 0;

/* eslint-disable max-len */ const $227b23bed0ada04c$var$react_1 = $227b23bed0ada04c$var$__importDefault((parcelRequire("acw62")));

const $227b23bed0ada04c$var$classnames_1 = $227b23bed0ada04c$var$__importDefault((parcelRequire("8g1PZ")));
const $227b23bed0ada04c$var$merge = (_a)=>{
    var { className: className } = _a, rest = $227b23bed0ada04c$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $227b23bed0ada04c$var$classnames_1.default)("helix-icon", "merge-outlined", className);
    return $227b23bed0ada04c$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $227b23bed0ada04c$var$react_1.default.createElement("svg", {
        width: "20",
        height: "21",
        viewBox: "0 0 20 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $227b23bed0ada04c$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.5 16.1547C8.63807 16.1547 8.75 16.0428 8.75 15.9047L8.75 5.90472C8.75 5.76665 8.63807 5.65472 8.5 5.65472L4 5.65472C3.58579 5.65472 3.25 5.31894 3.25 4.90472C3.25 4.49051 3.58579 4.15472 4 4.15472L8.5 4.15472C9.4665 4.15472 10.25 4.93822 10.25 5.90472L10.25 15.9047C10.25 16.8712 9.4665 17.6547 8.5 17.6547H4C3.58579 17.6547 3.25 17.3189 3.25 16.9047C3.25 16.4905 3.58579 16.1547 4 16.1547H8.5Z",
        fill: "#4B5563"
    }), $227b23bed0ada04c$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.25 10.9047C9.25 10.4905 9.58579 10.1547 10 10.1547H17V11.6547H10C9.58579 11.6547 9.25 11.3189 9.25 10.9047Z",
        fill: "#4B5563"
    }), $227b23bed0ada04c$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.5315 8.31907C15.8549 8.06032 16.3269 8.11276 16.5857 8.4362L18.1857 10.4362C18.4048 10.7101 18.4048 11.0993 18.1857 11.3732L16.5857 13.3732C16.3269 13.6967 15.8549 13.7491 15.5315 13.4904C15.208 13.2316 15.1556 12.7596 15.4143 12.4362L16.6395 10.9047L15.4143 9.37325C15.1556 9.0498 15.208 8.57783 15.5315 8.31907Z",
        fill: "#4B5563"
    })));
};
module.exports.merge = $227b23bed0ada04c$var$merge;

});

parcelRegister("bvQE4", function(module, exports) {
"use strict";
var $861b6d3ea932bccf$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $861b6d3ea932bccf$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.message_new = void 0;

/* eslint-disable max-len */ const $861b6d3ea932bccf$var$react_1 = $861b6d3ea932bccf$var$__importDefault((parcelRequire("acw62")));

const $861b6d3ea932bccf$var$classnames_1 = $861b6d3ea932bccf$var$__importDefault((parcelRequire("8g1PZ")));
const $861b6d3ea932bccf$var$message_new = (_a)=>{
    var { className: className } = _a, rest = $861b6d3ea932bccf$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $861b6d3ea932bccf$var$classnames_1.default)("helix-icon", "message-new-outlined", className);
    return $861b6d3ea932bccf$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $861b6d3ea932bccf$var$react_1.default.createElement("path", {
        d: "M17.8996 3.73379C18.4406 3.1928 18.4832 2.35822 17.9953 1.87029C17.5071 1.38214 16.673 1.42477 16.1323 1.96552L6.91073 11.1871L6.32595 13.5396L8.6785 12.9549L17.8996 3.73379Z",
        fill: "#4B5563"
    }), $861b6d3ea932bccf$var$react_1.default.createElement("path", {
        d: "M16.25 7.50467V13C16.25 14.7949 14.7949 16.25 13 16.25H7C5.20507 16.25 3.75 14.7949 3.75 13V6.99999C3.75 5.20507 5.20507 3.74999 7 3.74999H12.2265L13.7265 2.24999H7C4.37665 2.24999 2.25 4.37664 2.25 6.99999V13C2.25 15.6233 4.37665 17.75 7 17.75H13C15.6234 17.75 17.75 15.6233 17.75 13V6.00467L16.25 7.50467Z",
        fill: "#4B5563"
    }));
};
module.exports.message_new = $861b6d3ea932bccf$var$message_new;

});

parcelRegister("koeiW", function(module, exports) {
"use strict";
var $ed812517d895613e$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $ed812517d895613e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.minus = void 0;

/* eslint-disable max-len */ const $ed812517d895613e$var$react_1 = $ed812517d895613e$var$__importDefault((parcelRequire("acw62")));

const $ed812517d895613e$var$classnames_1 = $ed812517d895613e$var$__importDefault((parcelRequire("8g1PZ")));
const $ed812517d895613e$var$minus = (_a)=>{
    var { className: className } = _a, rest = $ed812517d895613e$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $ed812517d895613e$var$classnames_1.default)("helix-icon", "minus-outlined", className);
    return $ed812517d895613e$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $ed812517d895613e$var$react_1.default.createElement("path", {
        d: "M2 9.75C2 9.33579 2.33579 9 2.75 9H17.25C17.6642 9 18 9.33579 18 9.75C18 10.1642 17.6642 10.5 17.25 10.5H2.75C2.33579 10.5 2 10.1642 2 9.75Z",
        fill: "#4B5563"
    }));
};
module.exports.minus = $ed812517d895613e$var$minus;

});

parcelRegister("iUECL", function(module, exports) {
"use strict";
var $dc4cf810c188b8a3$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $dc4cf810c188b8a3$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.more_horizontal = void 0;

const $dc4cf810c188b8a3$var$react_1 = $dc4cf810c188b8a3$var$__importDefault((parcelRequire("acw62")));

const $dc4cf810c188b8a3$var$classnames_1 = $dc4cf810c188b8a3$var$__importDefault((parcelRequire("8g1PZ")));
const $dc4cf810c188b8a3$var$more_horizontal = (_a)=>{
    var { className: className } = _a, rest = $dc4cf810c188b8a3$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $dc4cf810c188b8a3$var$classnames_1.default)("helix-icon", "more-horizontal-outlined", className);
    return $dc4cf810c188b8a3$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $dc4cf810c188b8a3$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        // eslint-disable-next-line max-len
        d: "M3 8C1.9 8 1 8.9 1 10C1 11.1 1.9 12 3 12C4.1 12 5 11.1 5 10C5 8.9 4.1 8 3 8ZM17.0005 8C15.9005 8 15.0005 8.9 15.0005 10C15.0005 11.1 15.9005 12 17.0005 12C18.1005 12 19.0005 11.1 19.0005 10C19.0005 8.9 18.1005 8 17.0005 8ZM10.0001 8C8.90006 8 8.00006 8.9 8.00006 10C8.00006 11.1 8.90006 12 10.0001 12C11.1001 12 12.0001 11.1 12.0001 10C12.0001 8.9 11.1001 8 10.0001 8Z",
        fill: "#4B5563"
    }));
};
module.exports.more_horizontal = $dc4cf810c188b8a3$var$more_horizontal;

});

parcelRegister("6NGtK", function(module, exports) {
"use strict";
var $4f38451bb26c8827$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $4f38451bb26c8827$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.more_vertical = void 0;

const $4f38451bb26c8827$var$react_1 = $4f38451bb26c8827$var$__importDefault((parcelRequire("acw62")));

const $4f38451bb26c8827$var$classnames_1 = $4f38451bb26c8827$var$__importDefault((parcelRequire("8g1PZ")));
const $4f38451bb26c8827$var$more_vertical = (_a)=>{
    var { className: className } = _a, rest = $4f38451bb26c8827$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $4f38451bb26c8827$var$classnames_1.default)("helix-icon", "more-vertical-outlined", className);
    return $4f38451bb26c8827$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $4f38451bb26c8827$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        // eslint-disable-next-line max-len
        d: "M8.00025 17.0002C8.00025 18.1003 8.90025 19.0002 10.0002 19.0002C11.1002 19.0002 12.0002 18.1003 12.0002 17.0002C12.0002 15.9002 11.1002 15.0002 10.0002 15.0002C8.90025 15.0002 8.00025 15.9002 8.00025 17.0002ZM8.00025 2.99976C8.00025 4.09976 8.90025 4.99976 10.0002 4.99976C11.1002 4.99976 12.0002 4.09976 12.0002 2.99976C12.0002 1.89976 11.1002 0.999756 10.0002 0.999756C8.90025 0.999756 8.00025 1.89976 8.00025 2.99976ZM8.00025 10.0002C8.00025 11.1002 8.90025 12.0002 10.0002 12.0002C11.1002 12.0002 12.0002 11.1002 12.0002 10.0002C12.0002 8.90019 11.1002 8.00019 10.0002 8.00019C8.90025 8.00019 8.00025 8.90019 8.00025 10.0002Z",
        fill: "#4B5563"
    }));
};
module.exports.more_vertical = $4f38451bb26c8827$var$more_vertical;

});

parcelRegister("6J0V7", function(module, exports) {
"use strict";
var $4e57a8cff12d9b3d$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $4e57a8cff12d9b3d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.number_range = void 0;

/* eslint-disable max-len */ const $4e57a8cff12d9b3d$var$react_1 = $4e57a8cff12d9b3d$var$__importDefault((parcelRequire("acw62")));

const $4e57a8cff12d9b3d$var$classnames_1 = $4e57a8cff12d9b3d$var$__importDefault((parcelRequire("8g1PZ")));
const $4e57a8cff12d9b3d$var$number_range = (_a)=>{
    var { className: className } = _a, rest = $4e57a8cff12d9b3d$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $4e57a8cff12d9b3d$var$classnames_1.default)("helix-icon", "number-range-outlined", className);
    return $4e57a8cff12d9b3d$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $4e57a8cff12d9b3d$var$react_1.default.createElement("path", {
        d: "M12.3421 10.091L12.5 9.28072H11.6212L11.9411 7.71423H11.1305L10.8106 9.28072H9.73549L10.0555 7.71423H9.24915L8.92918 9.28072H8.05887L7.90102 10.091H8.77133L8.53242 11.2669H7.65785L7.5 12.0813H8.37031L8.03754 13.7142H8.84386L9.17235 12.0813H10.2517L9.91894 13.7142H10.7253L11.0623 12.0813H11.9411L12.0947 11.2669H11.2159L11.459 10.091H12.3421ZM9.54352 10.0369H10.7039L10.4394 11.3292H9.28328L9.54352 10.0369Z",
        fill: "#4B5563"
    }), $4e57a8cff12d9b3d$var$react_1.default.createElement("path", {
        d: "M3.75 7.71423C3.75 7.30002 3.41421 6.96423 3 6.96423C2.58579 6.96423 2.25 7.30002 2.25 7.71423V13.7142C2.25 14.1284 2.58579 14.4642 3 14.4642C3.41421 14.4642 3.75 14.1284 3.75 13.7142L3.75 7.71423Z",
        fill: "#4B5563"
    }), $4e57a8cff12d9b3d$var$react_1.default.createElement("path", {
        d: "M17.75 7.71423C17.75 7.30002 17.4142 6.96423 17 6.96423C16.5858 6.96423 16.25 7.30002 16.25 7.71423V13.7142C16.25 14.1284 16.5858 14.4642 17 14.4642C17.4142 14.4642 17.75 14.1284 17.75 13.7142V7.71423Z",
        fill: "#4B5563"
    }), $4e57a8cff12d9b3d$var$react_1.default.createElement("path", {
        d: "M6 9.96423H3C2.58579 9.96423 2.25 10.3 2.25 10.7142C2.25 11.1284 2.58579 11.4642 3 11.4642H6V9.96423Z",
        fill: "#4B5563"
    }), $4e57a8cff12d9b3d$var$react_1.default.createElement("path", {
        d: "M14 11.4642H17C17.4142 11.4642 17.75 11.1284 17.75 10.7142C17.75 10.3 17.4142 9.96423 17 9.96423H14V11.4642Z",
        fill: "#4B5563"
    }));
};
module.exports.number_range = $4e57a8cff12d9b3d$var$number_range;

});

parcelRegister("cKlEE", function(module, exports) {
"use strict";
var $947a941a6ba807cc$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $947a941a6ba807cc$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.open_door = void 0;

/* eslint-disable max-len */ const $947a941a6ba807cc$var$react_1 = $947a941a6ba807cc$var$__importDefault((parcelRequire("acw62")));

const $947a941a6ba807cc$var$classnames_1 = $947a941a6ba807cc$var$__importDefault((parcelRequire("8g1PZ")));
const $947a941a6ba807cc$var$open_door = (_a)=>{
    var { className: className } = _a, rest = $947a941a6ba807cc$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $947a941a6ba807cc$var$classnames_1.default)("helix-icon", "open-door-outlined", className);
    return $947a941a6ba807cc$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $947a941a6ba807cc$var$react_1.default.createElement("path", {
        d: "M10 10.75C10 11.1642 9.66421 11.5 9.25 11.5C8.83579 11.5 8.5 11.1642 8.5 10.75C8.5 10.3357 8.83579 9.99995 9.25 9.99995C9.66421 9.99995 10 10.3357 10 10.75Z",
        fill: "#4B5563"
    }), $947a941a6ba807cc$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.25 4.99994C4.25 4.03344 5.0335 3.24994 6 3.24994H13C13.9665 3.24994 14.75 4.03344 14.75 4.99994V16.2499H16C16.4142 16.2499 16.75 16.5857 16.75 16.9999C16.75 17.4142 16.4142 17.7499 16 17.7499H3C2.58579 17.7499 2.25 17.4142 2.25 16.9999C2.25 16.5857 2.58579 16.2499 3 16.2499H4.25V4.99994ZM5.75 16.2499H10.75V4.74994H6C5.86193 4.74994 5.75 4.86187 5.75 4.99994V16.2499ZM12.25 4.74994V16.2499H13.25V4.99994C13.25 4.86187 13.1381 4.74994 13 4.74994H12.25Z",
        fill: "#4B5563"
    }));
};
module.exports.open_door = $947a941a6ba807cc$var$open_door;

});

parcelRegister("92t4f", function(module, exports) {
"use strict";
var $01b2c1701da54611$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $01b2c1701da54611$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.origin = void 0;

/* eslint-disable max-len */ const $01b2c1701da54611$var$classnames_1 = $01b2c1701da54611$var$__importDefault((parcelRequire("8g1PZ")));

const $01b2c1701da54611$var$react_1 = $01b2c1701da54611$var$__importDefault((parcelRequire("acw62")));
const $01b2c1701da54611$var$origin = (_a)=>{
    var { className: className } = _a, rest = $01b2c1701da54611$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $01b2c1701da54611$var$classnames_1.default)("helix-icon", "origin-outlined", className);
    return $01b2c1701da54611$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "21",
        viewBox: "0 0 20 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $01b2c1701da54611$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 2.52374C9.17157 2.52374 8.5 3.19532 8.5 4.02374C8.5 4.57895 8.80165 5.06371 9.25 5.32307V7.87726C9.04198 7.9361 8.84397 8.0188 8.65914 8.12222L6.94919 6.41228C6.98233 6.28836 7 6.15811 7 6.02374C7 5.19532 6.32843 4.52374 5.5 4.52374C4.67157 4.52374 4 5.19532 4 6.02374C4 6.85217 4.67157 7.52374 5.5 7.52374C5.63437 7.52374 5.76461 7.50608 5.88853 7.47294L7.59848 9.18288C7.50341 9.35278 7.42585 9.53381 7.36825 9.72351L4.76894 9.72351C4.5032 9.30301 4.03421 9.02374 3.5 9.02374C2.67157 9.02374 2 9.69532 2 10.5237C2 11.3522 2.67157 12.0237 3.5 12.0237C4.0757 12.0237 4.57565 11.6994 4.82711 11.2235L7.33983 11.2235C7.39281 11.4255 7.46819 11.6184 7.56316 11.7994L5.80733 13.5553C5.70813 13.5346 5.60533 13.5237 5.5 13.5237C4.67157 13.5237 4 14.1953 4 15.0237C4 15.8522 4.67157 16.5237 5.5 16.5237C6.32843 16.5237 7 15.8522 7 15.0237C7 14.861 6.9741 14.7044 6.9262 14.5577L8.59542 12.8885C8.79823 13.0092 9.01787 13.1046 9.25 13.1702V15.7244C8.80165 15.9838 8.5 16.4685 8.5 17.0237C8.5 17.8522 9.17157 18.5237 10 18.5237C10.8284 18.5237 11.5 17.8522 11.5 17.0237C11.5 16.4685 11.1984 15.9838 10.75 15.7244V13.1702C10.958 13.1114 11.156 13.0287 11.3409 12.9253L13.0508 14.6352C13.0177 14.7591 13 14.8894 13 15.0237C13 15.8522 13.6716 16.5237 14.5 16.5237C15.3284 16.5237 16 15.8522 16 15.0237C16 14.1953 15.3284 13.5237 14.5 13.5237C14.3656 13.5237 14.2354 13.5414 14.1115 13.5746L12.4015 11.8646C12.5132 11.6649 12.6008 11.4499 12.6602 11.2235L15.1729 11.2235C15.4243 11.6994 15.9243 12.0237 16.5 12.0237C17.3284 12.0237 18 11.3522 18 10.5237C18 9.69532 17.3284 9.02374 16.5 9.02374C15.9658 9.02374 15.4968 9.30301 15.2311 9.72351L12.6318 9.72351C12.5669 9.50989 12.4767 9.30728 12.3647 9.11917L14.034 7.44994C14.1807 7.49784 14.3373 7.52374 14.5 7.52374C15.3284 7.52374 16 6.85217 16 6.02374C16 5.19532 15.3284 4.52374 14.5 4.52374C13.6716 4.52374 13 5.19532 13 6.02374C13 6.12908 13.0109 6.23187 13.0315 6.33108L11.2757 8.0869C11.1097 7.99984 10.9338 7.92924 10.75 7.87726V5.32307C11.1984 5.06371 11.5 4.57895 11.5 4.02374C11.5 3.19532 10.8284 2.52374 10 2.52374ZM10 9.27374C10.6904 9.27374 11.25 9.83339 11.25 10.5237C11.25 11.2141 10.6904 11.7737 10 11.7737C9.30964 11.7737 8.75 11.2141 8.75 10.5237C8.75 9.83339 9.30964 9.27374 10 9.27374Z",
        fill: "#4B5563"
    }));
};
module.exports.origin = $01b2c1701da54611$var$origin;

});

parcelRegister("aRal3", function(module, exports) {
"use strict";
var $7e76dfa8f197b5ba$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $7e76dfa8f197b5ba$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.outbox = void 0;

/* eslint-disable max-len */ const $7e76dfa8f197b5ba$var$react_1 = $7e76dfa8f197b5ba$var$__importDefault((parcelRequire("acw62")));

const $7e76dfa8f197b5ba$var$classnames_1 = $7e76dfa8f197b5ba$var$__importDefault((parcelRequire("8g1PZ")));
const $7e76dfa8f197b5ba$var$outbox = (_a)=>{
    var { className: className } = _a, rest = $7e76dfa8f197b5ba$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $7e76dfa8f197b5ba$var$classnames_1.default)("helix-icon", "outbox-outlined", className);
    return $7e76dfa8f197b5ba$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $7e76dfa8f197b5ba$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 11.25C3.41421 11.25 3.75 11.5858 3.75 12L3.75 16.25H16.25V12C16.25 11.5858 16.5858 11.25 17 11.25C17.4142 11.25 17.75 11.5858 17.75 12V17C17.75 17.4142 17.4142 17.75 17 17.75H3C2.58579 17.75 2.25 17.4142 2.25 17L2.25 12C2.25 11.5858 2.58579 11.25 3 11.25Z",
        fill: "#4B5563"
    }), $7e76dfa8f197b5ba$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 1.93929L13.5303 5.46962C13.8232 5.76251 13.8232 6.23738 13.5303 6.53028C13.2374 6.82317 12.7626 6.82317 12.4697 6.53028L10.75 4.81061V13.4499C10.75 13.8642 10.4142 14.1999 10 14.1999C9.58579 14.1999 9.25 13.8642 9.25 13.4499V4.81061L7.53033 6.53028C7.23744 6.82317 6.76256 6.82317 6.46967 6.53028C6.17678 6.23738 6.17678 5.76251 6.46967 5.46962L10 1.93929Z",
        fill: "#4B5563"
    }));
};
module.exports.outbox = $7e76dfa8f197b5ba$var$outbox;

});

parcelRegister("18xEn", function(module, exports) {
"use strict";
var $0d40a40f119a4ca7$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $0d40a40f119a4ca7$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.paperclip = void 0;

const $0d40a40f119a4ca7$var$react_1 = $0d40a40f119a4ca7$var$__importDefault((parcelRequire("acw62")));

const $0d40a40f119a4ca7$var$classnames_1 = $0d40a40f119a4ca7$var$__importDefault((parcelRequire("8g1PZ")));
const $0d40a40f119a4ca7$var$paperclip = (_a)=>{
    var { className: className } = _a, rest = $0d40a40f119a4ca7$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $0d40a40f119a4ca7$var$classnames_1.default)("helix-icon", "paperclip-outlined", className);
    return $0d40a40f119a4ca7$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $0d40a40f119a4ca7$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        // eslint-disable-next-line max-len
        d: "M15.621 4.71227C15.0584 4.14985 14.2955 3.83391 13.5 3.83391C12.7045 3.83391 11.9416 4.14985 11.379 4.71227L4.37903 11.7123C3.83242 12.2779 3.52986 13.0357 3.5365 13.8223C3.54315 14.6089 3.85848 15.3614 4.41458 15.9177C4.97067 16.4741 5.72303 16.7898 6.50962 16.7968C7.29621 16.8038 8.05409 16.5016 8.62003 15.9553H8.62103L9.11803 15.4553C9.25901 15.3181 9.44824 15.2418 9.64493 15.2429C9.84163 15.2439 10.03 15.3221 10.1696 15.4608C10.3091 15.5994 10.3886 15.7873 10.391 15.984C10.3933 16.1807 10.3183 16.3704 10.182 16.5123L9.68403 17.0133L9.68203 17.0153C8.83811 17.8592 7.69351 18.3333 6.50003 18.3333C5.30655 18.3333 4.16195 17.8592 3.31803 17.0153C2.47411 16.1713 2 15.0267 2 13.8333C2 12.6398 2.47411 11.4952 3.31803 10.6513L10.318 3.65127C11.1614 2.80682 12.3057 2.33199 13.4992 2.33124C14.6927 2.33049 15.8376 2.80388 16.682 3.64727C17.5265 4.49065 18.0013 5.63496 18.0021 6.82844C18.0028 8.02192 17.5294 9.16682 16.686 10.0113L13.231 13.5643C12.9898 13.8187 12.7 14.0222 12.3789 14.1628C12.0577 14.3034 11.7116 14.3782 11.3611 14.3829C11.0105 14.3875 10.6626 14.3219 10.3378 14.1899C10.013 14.0579 9.71796 13.8621 9.47005 13.6142C9.22215 13.3663 9.02642 13.0713 8.89441 12.7465C8.7624 12.4217 8.69678 12.0738 8.70144 11.7232C8.7061 11.3726 8.78093 11.0266 8.92153 10.7054C9.06212 10.3842 9.26562 10.0945 9.52003 9.85327L12.97 6.40227C13.0392 6.3306 13.1219 6.27343 13.2134 6.23408C13.3049 6.19473 13.4033 6.17399 13.5029 6.17308C13.6025 6.17217 13.7012 6.1911 13.7934 6.22877C13.8856 6.26643 13.9694 6.32208 14.0398 6.39247C14.1103 6.46285 14.166 6.54657 14.2038 6.63872C14.2415 6.73088 14.2605 6.82963 14.2597 6.92921C14.2589 7.02879 14.2382 7.12722 14.199 7.21874C14.1597 7.31026 14.1026 7.39305 14.031 7.46227L10.581 10.9133C10.4763 11.0175 10.3931 11.1413 10.3362 11.2776C10.2794 11.414 10.2499 11.5602 10.2495 11.7079C10.2491 11.8557 10.2779 12.002 10.3341 12.1387C10.3903 12.2753 10.4728 12.3995 10.577 12.5043C10.6812 12.609 10.805 12.6922 10.9414 12.7491C11.0777 12.8059 11.224 12.8354 11.3717 12.8358C11.5194 12.8361 11.6658 12.8074 11.8024 12.7512C11.9391 12.695 12.0633 12.6125 12.168 12.5083L15.622 8.95527C16.1844 8.39268 16.5004 7.62976 16.5004 6.83427C16.5004 6.03877 16.1844 5.27585 15.622 4.71327L15.621 4.71227Z",
        fill: "#4B5563"
    }));
};
module.exports.paperclip = $0d40a40f119a4ca7$var$paperclip;

});

parcelRegister("1jMRV", function(module, exports) {
"use strict";
var $0f5d7919162eef54$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $0f5d7919162eef54$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.pencil = void 0;

const $0f5d7919162eef54$var$react_1 = $0f5d7919162eef54$var$__importDefault((parcelRequire("acw62")));

const $0f5d7919162eef54$var$classnames_1 = $0f5d7919162eef54$var$__importDefault((parcelRequire("8g1PZ")));
const $0f5d7919162eef54$var$pencil = (_a)=>{
    var { className: className } = _a, rest = $0f5d7919162eef54$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $0f5d7919162eef54$var$classnames_1.default)("helix-icon", "pencil-outlined", className);
    return $0f5d7919162eef54$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $0f5d7919162eef54$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        // eslint-disable-next-line max-len
        d: "M16.921 3.64036C17.9952 4.71452 17.9943 6.45619 16.9206 7.52991L8.43575 16.0147C8.33105 16.1194 8.1977 16.1908 8.05251 16.2198L4.51697 16.9269C4.27108 16.9761 4.01687 16.8991 3.83956 16.7218C3.66224 16.5445 3.58527 16.2903 3.63445 16.0444L4.34156 12.5089C4.3706 12.3637 4.44196 12.2303 4.54666 12.1256L13.0319 3.64036C14.1059 2.56641 15.8471 2.56641 16.921 3.64036ZM15.8599 6.46925C16.3483 5.98086 16.3483 5.18895 15.8604 4.70102C15.3722 4.21286 14.5808 4.21286 14.0926 4.70102L5.76789 13.0257L5.32595 15.2354L7.53566 14.7935L15.8599 6.46925Z",
        fill: "#4B5563"
    }));
};
module.exports.pencil = $0f5d7919162eef54$var$pencil;

});

parcelRegister("h0X8z", function(module, exports) {
"use strict";
var $c6304f2b4a966296$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $c6304f2b4a966296$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.percentage = void 0;

/* eslint-disable max-len */ const $c6304f2b4a966296$var$react_1 = $c6304f2b4a966296$var$__importDefault((parcelRequire("acw62")));

const $c6304f2b4a966296$var$classnames_1 = $c6304f2b4a966296$var$__importDefault((parcelRequire("8g1PZ")));
const $c6304f2b4a966296$var$percentage = (_a)=>{
    var { className: className } = _a, rest = $c6304f2b4a966296$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $c6304f2b4a966296$var$classnames_1.default)("helix-icon", "percentage-outlined", className);
    return $c6304f2b4a966296$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $c6304f2b4a966296$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.5303 4.46965C15.8232 4.76255 15.8232 5.23742 15.5303 5.53032L5.59099 15.4697C5.2981 15.7625 4.82322 15.7625 4.53033 15.4697C4.23744 15.1768 4.23744 14.7019 4.53033 14.409L14.4697 4.46965C14.7626 4.17676 15.2374 4.17676 15.5303 4.46965Z",
        fill: "#4B5563"
    }), $c6304f2b4a966296$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.5 5.74998C6.08579 5.74998 5.75 6.08577 5.75 6.49998C5.75 6.9142 6.08579 7.24998 6.5 7.24998C6.91421 7.24998 7.25 6.9142 7.25 6.49998C7.25 6.08577 6.91421 5.74998 6.5 5.74998ZM4.25 6.49998C4.25 5.25734 5.25736 4.24998 6.5 4.24998C7.74264 4.24998 8.75 5.25734 8.75 6.49998C8.75 7.74263 7.74264 8.74998 6.5 8.74998C5.25736 8.74998 4.25 7.74263 4.25 6.49998ZM13.5 12.75C13.0858 12.75 12.75 13.0858 12.75 13.5C12.75 13.9142 13.0858 14.25 13.5 14.25C13.9142 14.25 14.25 13.9142 14.25 13.5C14.25 13.0858 13.9142 12.75 13.5 12.75ZM11.25 13.5C11.25 12.2573 12.2574 11.25 13.5 11.25C14.7426 11.25 15.75 12.2573 15.75 13.5C15.75 14.7426 14.7426 15.75 13.5 15.75C12.2574 15.75 11.25 14.7426 11.25 13.5Z",
        fill: "#4B5563"
    }));
};
module.exports.percentage = $c6304f2b4a966296$var$percentage;

});

parcelRegister("lmvsE", function(module, exports) {
"use strict";
var $f8d40e8ff7439924$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $f8d40e8ff7439924$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.person_frame = void 0;

/* eslint-disable max-len */ const $f8d40e8ff7439924$var$react_1 = $f8d40e8ff7439924$var$__importDefault((parcelRequire("acw62")));

const $f8d40e8ff7439924$var$classnames_1 = $f8d40e8ff7439924$var$__importDefault((parcelRequire("8g1PZ")));
const $f8d40e8ff7439924$var$person_frame = (_a)=>{
    var { className: className } = _a, rest = $f8d40e8ff7439924$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $f8d40e8ff7439924$var$classnames_1.default)("helix-icon", "person-frame-outlined", className);
    return $f8d40e8ff7439924$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $f8d40e8ff7439924$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4 2H7V3.5H4C3.72386 3.5 3.5 3.72386 3.5 4V7H2V4C2 2.89543 2.89543 2 4 2ZM2 16V13H3.5V16C3.5 16.2761 3.72386 16.5 4 16.5H7V18H4C2.89543 18 2 17.1046 2 16ZM13 2H16C17.1046 2 18 2.89543 18 4V7H16.5V4C16.5 3.72386 16.2761 3.5 16 3.5H13V2ZM18 13V16C18 17.1046 17.1046 18 16 18H13V16.5H16C16.2761 16.5 16.5 16.2761 16.5 16V13H18ZM12 7C12 8.08333 11.0449 9 9.96153 9C8.87821 9 8 8.08333 8 7C8 5.91667 8.5 5 9.96153 5C11.4231 5 12 5.91667 12 7ZM6 12.6603C6 10.6615 6.67107 10 8.0036 10H12.0012C13.3337 10 14 10.8949 14 11.9988V13.9976H6.0048L6 12.6603Z",
        fill: "#4B5563"
    }));
};
module.exports.person_frame = $f8d40e8ff7439924$var$person_frame;

});

parcelRegister("1luNL", function(module, exports) {
"use strict";
var $0fafa530461060e9$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $0fafa530461060e9$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.phone = void 0;

/* eslint-disable max-len */ const $0fafa530461060e9$var$react_1 = $0fafa530461060e9$var$__importDefault((parcelRequire("acw62")));

const $0fafa530461060e9$var$classnames_1 = $0fafa530461060e9$var$__importDefault((parcelRequire("8g1PZ")));
const $0fafa530461060e9$var$phone = (_a)=>{
    var { className: className } = _a, rest = $0fafa530461060e9$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $0fafa530461060e9$var$classnames_1.default)("helix-icon", "phone-outlined", className);
    return $0fafa530461060e9$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $0fafa530461060e9$var$react_1.default.createElement("path", {
        d: "M16.0934 13.3489C15.9073 12.8836 13.3014 12.1391 13.1153 12.046H12.9291C12.5569 12.2321 12.1846 12.5113 11.347 13.2559C10.4163 12.7905 9.20644 11.6737 8.55497 11.0223C7.9035 10.2777 7.15896 9.06785 6.87976 8.23025C7.81043 7.39264 8.1827 7.02038 8.1827 6.64811C8.1827 6.46197 7.71737 3.76302 7.25203 3.48382L7.15896 3.39075C6.87976 3.20462 6.50749 2.92542 5.94909 3.01849C5.85602 3.01849 5.76295 3.11155 5.57682 3.20462C5.29762 3.39075 4.46001 3.94916 4.08774 4.6937C3.90161 5.15903 3.71548 9.34706 6.87976 12.8836C9.95098 16.4202 13.8598 16.5132 14.4182 16.4202H14.5113C15.2558 16.141 15.9073 15.3964 16.1865 15.1172C16.6518 14.5588 16.2795 13.9073 16.1865 13.5351L16.0934 13.3489Z",
        fill: "#4B5563"
    }));
};
module.exports.phone = $0fafa530461060e9$var$phone;

});

parcelRegister("h0Gfl", function(module, exports) {
"use strict";
var $c6233508c5234cd1$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $c6233508c5234cd1$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.photo = void 0;

/* eslint-disable max-len */ const $c6233508c5234cd1$var$react_1 = $c6233508c5234cd1$var$__importDefault((parcelRequire("acw62")));

const $c6233508c5234cd1$var$classnames_1 = $c6233508c5234cd1$var$__importDefault((parcelRequire("8g1PZ")));
const $c6233508c5234cd1$var$photo = (_a)=>{
    var { className: className } = _a, rest = $c6233508c5234cd1$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $c6233508c5234cd1$var$classnames_1.default)("helix-icon", "photo-outlined", className);
    return $c6233508c5234cd1$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $c6233508c5234cd1$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 2.25C2.0335 2.25 1.25 3.0335 1.25 4V16C1.25 16.9665 2.0335 17.75 3 17.75H17C17.9665 17.75 18.75 16.9665 18.75 16V4C18.75 3.0335 17.9665 2.25 17 2.25H3ZM2.75 4C2.75 3.86193 2.86193 3.75 3 3.75H17C17.1381 3.75 17.25 3.86193 17.25 4V10.7979L14.4881 8.43056C14.183 8.16902 13.7259 8.19447 13.4517 8.48826L6.45171 15.9883C6.37897 16.0662 6.32604 16.1555 6.29269 16.25H3C2.86193 16.25 2.75 16.1381 2.75 16V4ZM17.0119 12.5694C17.0843 12.6315 17.1652 12.6774 17.25 12.7073V16C17.25 16.1381 17.1381 16.25 17 16.25H8.25925L14.0578 10.0373L17.0119 12.5694ZM6.5 9C7.32843 9 8 8.32843 8 7.5C8 6.67157 7.32843 6 6.5 6C5.67157 6 5 6.67157 5 7.5C5 8.32843 5.67157 9 6.5 9Z",
        fill: "#4B5563"
    }));
};
module.exports.photo = $c6233508c5234cd1$var$photo;

});

parcelRegister("eUUGm", function(module, exports) {
"use strict";
var $adc24394c657ef3a$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $adc24394c657ef3a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.piggy = void 0;

/* eslint-disable max-len */ const $adc24394c657ef3a$var$react_1 = $adc24394c657ef3a$var$__importDefault((parcelRequire("acw62")));

const $adc24394c657ef3a$var$classnames_1 = $adc24394c657ef3a$var$__importDefault((parcelRequire("8g1PZ")));
const $adc24394c657ef3a$var$piggy = (_a)=>{
    var { className: className } = _a, rest = $adc24394c657ef3a$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $adc24394c657ef3a$var$classnames_1.default)("helix-icon", "piggy-outlined", className);
    return $adc24394c657ef3a$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $adc24394c657ef3a$var$react_1.default.createElement("path", {
        d: "M6 9C5.44772 9 5 8.55228 5 8C5 7.44772 5.44772 7 6 7C6.55228 7 7 7.44772 7 8C7 8.55228 6.55228 9 6 9Z",
        fill: "#4B5563"
    }), $adc24394c657ef3a$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.4265 2.14012C4.594 1.94136 4.85247 1.84349 5.10962 1.88148C5.98205 2.01036 6.67225 2.35568 7.20148 2.77505C8.22567 2.42219 9.35173 2.25 10.5 2.25C13.6604 2.25 16.2646 3.69127 17.6555 5.82912C17.9671 5.52857 18.2499 4.99194 18.2499 4H19.7499C19.7499 5.56754 19.1873 6.60768 18.3433 7.20057C18.6084 7.92382 18.75 8.69718 18.75 9.49997C18.75 12.1513 17.2234 14.5169 14.75 15.7787V17C14.75 17.4142 14.4142 17.75 14 17.75H12C11.5858 17.75 11.25 17.4142 11.25 17V16.7236C11.0041 16.7411 10.754 16.75 10.5 16.75L9.75 16.75V17C9.75 17.4142 9.41421 17.75 9 17.75H7C6.58579 17.75 6.25 17.4142 6.25 17V15.8682C4.93485 15.266 3.99402 14.4567 3.36694 13.7691C3.01671 13.385 2.76273 13.0372 2.59402 12.781L2.57374 12.75H2C1.58579 12.75 1.25 12.4142 1.25 12V7.99997C1.25 7.58576 1.58579 7.24997 2 7.24997H2.88468C3.19953 5.98139 3.85088 4.96501 4.72414 4.18864L4.28738 2.8572C4.20635 2.61022 4.25899 2.33889 4.4265 2.14012ZM10.5 3.75C7.19731 3.75 4.66438 5.28996 4.24172 8.1111C4.18671 8.4783 3.8713 8.74997 3.5 8.74997H2.75V11.25H3C3.2831 11.25 3.54199 11.4094 3.6695 11.662L3.67031 11.6636L3.67495 11.6723C3.68064 11.683 3.69066 11.7014 3.70516 11.7268C3.73418 11.7776 3.78102 11.8561 3.84681 11.956C3.97857 12.1561 4.18515 12.4402 4.47529 12.7584C5.05564 13.3948 5.96386 14.161 7.27334 14.6735C7.56083 14.786 7.75 15.0632 7.75 15.3719V16.25H8.25V16C8.25 15.5858 8.58578 15.25 8.99999 15.25L10.5 15.25C10.9823 15.25 11.4434 15.2128 11.8815 15.1427C12.0984 15.108 12.3196 15.1701 12.4867 15.3126C12.6538 15.4551 12.75 15.6637 12.75 15.8833V16.25H13.25V15.304C13.25 15.0058 13.4266 14.736 13.6999 14.6167C15.9384 13.6394 17.25 11.6614 17.25 9.49997C17.25 6.48824 14.5822 3.75 10.5 3.75Z",
        fill: "#4B5563"
    }));
};
module.exports.piggy = $adc24394c657ef3a$var$piggy;

});

parcelRegister("8nBmr", function(module, exports) {
"use strict";
var $619d73d571b29693$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $619d73d571b29693$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.play = void 0;

/* eslint-disable max-len */ const $619d73d571b29693$var$react_1 = $619d73d571b29693$var$__importDefault((parcelRequire("acw62")));

const $619d73d571b29693$var$classnames_1 = $619d73d571b29693$var$__importDefault((parcelRequire("8g1PZ")));
const $619d73d571b29693$var$play = (_a)=>{
    var { className: className } = _a, rest = $619d73d571b29693$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $619d73d571b29693$var$classnames_1.default)("helix-icon", "play-outlined", className);
    return $619d73d571b29693$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $619d73d571b29693$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.9767 10.3333L5.5 4.91803V15.7485L14.9767 10.3333ZM16.4806 11.2015C17.1524 10.8176 17.1524 9.84891 16.4806 9.46502L5.49614 3.1882C4.82948 2.80725 4 3.28862 4 4.05644V16.6101C4 17.3779 4.82948 17.8593 5.49614 17.4783L16.4806 11.2015Z",
        fill: "#4B5563"
    }));
};
module.exports.play = $619d73d571b29693$var$play;

});

parcelRegister("7XVsc", function(module, exports) {
"use strict";
var $5cca9c344bef88c8$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $5cca9c344bef88c8$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.play_circle = void 0;

/* eslint-disable max-len */ const $5cca9c344bef88c8$var$react_1 = $5cca9c344bef88c8$var$__importDefault((parcelRequire("acw62")));

const $5cca9c344bef88c8$var$classnames_1 = $5cca9c344bef88c8$var$__importDefault((parcelRequire("8g1PZ")));
const $5cca9c344bef88c8$var$play_circle = (_a)=>{
    var { className: className } = _a, rest = $5cca9c344bef88c8$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $5cca9c344bef88c8$var$classnames_1.default)("helix-icon", "play-circle-outlined", className);
    return $5cca9c344bef88c8$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $5cca9c344bef88c8$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 4.08325C6.54822 4.08325 3.75 6.88147 3.75 10.3333C3.75 13.785 6.54822 16.5833 10 16.5833C13.4518 16.5833 16.25 13.785 16.25 10.3333C16.25 6.88147 13.4518 4.08325 10 4.08325ZM2.25 10.3333C2.25 6.05305 5.71979 2.58325 10 2.58325C14.2802 2.58325 17.75 6.05305 17.75 10.3333C17.75 14.6135 14.2802 18.0833 10 18.0833C5.71979 18.0833 2.25 14.6135 2.25 10.3333Z",
        fill: "#4B5563"
    }), $5cca9c344bef88c8$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.4767 10.3333L9 8.91802V11.7485L11.4767 10.3333ZM12.9806 11.2015C13.6524 10.8176 13.6524 9.8489 12.9806 9.46501L8.99614 7.18819C8.32948 6.80724 7.5 7.28861 7.5 8.05643V12.6101C7.5 13.3779 8.32948 13.8593 8.99614 13.4783L12.9806 11.2015Z",
        fill: "#4B5563"
    }));
};
module.exports.play_circle = $5cca9c344bef88c8$var$play_circle;

});

parcelRegister("au8Wq", function(module, exports) {
"use strict";
var $7a23a44ba57c5202$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $7a23a44ba57c5202$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.player_video = void 0;

/* eslint-disable max-len */ const $7a23a44ba57c5202$var$react_1 = $7a23a44ba57c5202$var$__importDefault((parcelRequire("acw62")));

const $7a23a44ba57c5202$var$classnames_1 = $7a23a44ba57c5202$var$__importDefault((parcelRequire("8g1PZ")));
const $7a23a44ba57c5202$var$player_video = (_a)=>{
    var { className: className } = _a, rest = $7a23a44ba57c5202$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $7a23a44ba57c5202$var$classnames_1.default)("helix-icon", "player-video-outlined", className);
    return $7a23a44ba57c5202$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $7a23a44ba57c5202$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.375 10.6495C14.6071 10.5155 14.75 10.2679 14.75 10C14.75 9.73205 14.6071 9.48446 14.375 9.35048L8.375 5.88638C8.14295 5.7524 7.85705 5.7524 7.625 5.88638C7.39295 6.02035 7.25 6.26795 7.25 6.5359V13.4641C7.25 13.7321 7.39295 13.9796 7.625 14.1136C7.85705 14.2476 8.14295 14.2476 8.375 14.1136L14.375 10.6495ZM8.75 12.1651V7.83494L12.5 10L8.75 12.1651Z",
        fill: "#4B5563"
    }), $7a23a44ba57c5202$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 3.25C2.0335 3.25 1.25 4.0335 1.25 5V15C1.25 15.9665 2.0335 16.75 3 16.75H17C17.9665 16.75 18.75 15.9665 18.75 15V5C18.75 4.0335 17.9665 3.25 17 3.25H3ZM2.75 5C2.75 4.86193 2.86193 4.75 3 4.75H17C17.1381 4.75 17.25 4.86193 17.25 5V15C17.25 15.1381 17.1381 15.25 17 15.25H3C2.86193 15.25 2.75 15.1381 2.75 15V5Z",
        fill: "#4B5563"
    }));
};
module.exports.player_video = $7a23a44ba57c5202$var$player_video;

});

parcelRegister("6XidV", function(module, exports) {
"use strict";
var $51066395aace82b2$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $51066395aace82b2$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.plug = void 0;

/* eslint-disable max-len */ const $51066395aace82b2$var$react_1 = $51066395aace82b2$var$__importDefault((parcelRequire("acw62")));

const $51066395aace82b2$var$classnames_1 = $51066395aace82b2$var$__importDefault((parcelRequire("8g1PZ")));
const $51066395aace82b2$var$plug = (_a)=>{
    var { className: className } = _a, rest = $51066395aace82b2$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $51066395aace82b2$var$classnames_1.default)("helix-icon", "plug-outlined", className);
    return $51066395aace82b2$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $51066395aace82b2$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.23221 2.30507C8.52511 2.01217 8.99998 2.01217 9.29287 2.30507L17.7782 10.7903C18.071 11.0832 18.071 11.5581 17.7782 11.851L13.5355 16.0936C12.3509 17.2783 10.8376 17.1045 9.807 16.761C9.28529 16.5871 8.8327 16.3549 8.51159 16.1678L6.818 17.8614C6.52511 18.1543 6.05023 18.1543 5.75734 17.8614L2.22181 14.3259C2.08115 14.1852 2.00214 13.9945 2.00214 13.7956C2.00214 13.5966 2.08115 13.4059 2.22181 13.2652L3.9154 11.5716C3.72835 11.2505 3.49616 10.7979 3.32225 10.2762C2.97873 9.24563 2.80495 7.73233 3.98957 6.54771L8.23221 2.30507ZM5.47374 11.2246C5.69737 11.5232 5.66759 11.9408 5.40379 12.2046L3.8128 13.7956L6.28767 16.2704L7.87866 14.6794C8.14223 14.4159 8.55929 14.3859 8.8578 14.6089C8.85778 14.6089 8.85782 14.6089 8.8578 14.6089L8.85861 14.6095C8.85849 14.6094 8.85874 14.6096 8.85861 14.6095L8.86037 14.6108L8.87712 14.6229C8.89325 14.6344 8.91908 14.6525 8.95367 14.6759C9.023 14.7227 9.12665 14.7898 9.25722 14.8662C9.52102 15.0205 9.88135 15.2046 10.2813 15.3379C11.1069 15.6131 11.8917 15.6161 12.4749 15.033L16.1872 11.3207L8.76254 3.89606L5.05023 7.60837C4.46709 8.19151 4.47009 8.97631 4.74528 9.80188C4.87861 10.2019 5.06271 10.5622 5.21701 10.826C5.29338 10.9566 5.36052 11.0602 5.40733 11.1295C5.43069 11.1641 5.44884 11.19 5.46036 11.2061L5.47246 11.2229L5.47374 11.2246C5.47383 11.2247 5.47365 11.2245 5.47374 11.2246Z",
        fill: "#4B5563"
    }), $51066395aace82b2$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.8891 1.95151C14.182 2.24441 14.182 2.71928 13.8891 3.01217L11.7677 5.13349C11.4749 5.42639 11 5.42639 10.7071 5.13349C10.4142 4.8406 10.4142 4.36573 10.7071 4.07283L12.8284 1.95151C13.1213 1.65862 13.5962 1.65862 13.8891 1.95151Z",
        fill: "#4B5563"
    }), $51066395aace82b2$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.1316 6.19424C18.4245 6.48713 18.4245 6.96201 18.1316 7.2549L16.0103 9.37622C15.7174 9.66911 15.2425 9.66911 14.9496 9.37622C14.6567 9.08333 14.6567 8.60845 14.9496 8.31556L17.071 6.19424C17.3639 5.90135 17.8387 5.90135 18.1316 6.19424Z",
        fill: "#4B5563"
    }));
};
module.exports.plug = $51066395aace82b2$var$plug;

});

parcelRegister("aO9gR", function(module, exports) {
"use strict";
var $7de5c3eb532c8978$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $7de5c3eb532c8978$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.plus = void 0;

const $7de5c3eb532c8978$var$react_1 = $7de5c3eb532c8978$var$__importDefault((parcelRequire("acw62")));

const $7de5c3eb532c8978$var$classnames_1 = $7de5c3eb532c8978$var$__importDefault((parcelRequire("8g1PZ")));
const $7de5c3eb532c8978$var$plus = (_a)=>{
    var { className: className } = _a, rest = $7de5c3eb532c8978$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $7de5c3eb532c8978$var$classnames_1.default)("helix-icon", "plus-outlined", className);
    return $7de5c3eb532c8978$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $7de5c3eb532c8978$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        // eslint-disable-next-line max-len
        d: "M10.75 2.75C10.75 2.33579 10.4142 2 10 2C9.58579 2 9.25 2.33579 9.25 2.75V9.25H2.75C2.33579 9.25 2 9.58579 2 10C2 10.4142 2.33579 10.75 2.75 10.75H9.25V17.25C9.25 17.6642 9.58579 18 10 18C10.4142 18 10.75 17.6642 10.75 17.25V10.75H17.25C17.6642 10.75 18 10.4142 18 10C18 9.58579 17.6642 9.25 17.25 9.25H10.75V2.75Z",
        fill: "#4B5563"
    }));
};
module.exports.plus = $7de5c3eb532c8978$var$plus;

});

parcelRegister("gmMnR", function(module, exports) {
"use strict";
var $bea43b6bb85864b8$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $bea43b6bb85864b8$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.plus_small = void 0;

/* eslint-disable max-len */ const $bea43b6bb85864b8$var$react_1 = $bea43b6bb85864b8$var$__importDefault((parcelRequire("acw62")));

const $bea43b6bb85864b8$var$classnames_1 = $bea43b6bb85864b8$var$__importDefault((parcelRequire("8g1PZ")));
const $bea43b6bb85864b8$var$plus_small = (_a)=>{
    var { className: className } = _a, rest = $bea43b6bb85864b8$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $bea43b6bb85864b8$var$classnames_1.default)("helix-icon", "plus-small_outlined", className);
    return $bea43b6bb85864b8$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $bea43b6bb85864b8$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.75 5.33325C10.75 4.91904 10.4142 4.58325 10 4.58325C9.58579 4.58325 9.25 4.91904 9.25 5.33325V9.58325H5C4.58579 9.58325 4.25 9.91904 4.25 10.3333C4.25 10.7475 4.58579 11.0833 5 11.0833H9.25V15.3333C9.25 15.7475 9.58579 16.0833 10 16.0833C10.4142 16.0833 10.75 15.7475 10.75 15.3333V11.0833H15C15.4142 11.0833 15.75 10.7475 15.75 10.3333C15.75 9.91904 15.4142 9.58325 15 9.58325H10.75V5.33325Z",
        fill: "#4B5563"
    }));
};
module.exports.plus_small = $bea43b6bb85864b8$var$plus_small;

});

parcelRegister("9jZDc", function(module, exports) {
"use strict";
var $6c95b2111d1640df$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $6c95b2111d1640df$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.printer = void 0;

/* eslint-disable max-len */ const $6c95b2111d1640df$var$react_1 = $6c95b2111d1640df$var$__importDefault((parcelRequire("acw62")));

const $6c95b2111d1640df$var$classnames_1 = $6c95b2111d1640df$var$__importDefault((parcelRequire("8g1PZ")));
const $6c95b2111d1640df$var$printer = (_a)=>{
    var { className: className } = _a, rest = $6c95b2111d1640df$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $6c95b2111d1640df$var$classnames_1.default)("helix-icon", "printer-outlined", className);
    return $6c95b2111d1640df$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $6c95b2111d1640df$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.0803 8.11303C16.632 7.44196 15.8676 7 15 7H5C3.61929 7 2.5 8.11929 2.5 9.5V14.25H5V12C5 11.4477 5.44772 11 6 11H14C14.5523 11 15 11.4477 15 12V14.25H17.5V9.5C17.5 9.42274 17.4965 9.34627 17.4896 9.27077C17.4509 8.84539 17.3055 8.45036 17.0803 8.11303ZM6.5 17.5H13.5V12.5H6.5V17.5ZM16 5.62602C16.0638 5.64244 16.127 5.66039 16.1895 5.67983C17.8178 6.18628 19 7.70507 19 9.5V14.75C19 15.3023 18.5523 15.75 18 15.75H15V18C15 18.5523 14.5523 19 14 19H6C5.44772 19 5 18.5523 5 18V15.75H2C1.44772 15.75 1 15.3023 1 14.75V9.5C1 7.63616 2.27477 6.07006 4 5.62602V2C4 1.44772 4.44772 1 5 1H15C15.5523 1 16 1.44772 16 2V5.62602ZM5.5 2.5H14.5V5.5H5.5V2.5Z",
        fill: "#4B5563"
    }));
};
module.exports.printer = $6c95b2111d1640df$var$printer;

});

parcelRegister("alvyE", function(module, exports) {
"use strict";
var $7884584ef80c2012$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $7884584ef80c2012$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.priority_high = void 0;

/* eslint-disable max-len */ const $7884584ef80c2012$var$react_1 = $7884584ef80c2012$var$__importDefault((parcelRequire("acw62")));

const $7884584ef80c2012$var$classnames_1 = $7884584ef80c2012$var$__importDefault((parcelRequire("8g1PZ")));
const $7884584ef80c2012$var$priority_high = (_a)=>{
    var { className: className } = _a, rest = $7884584ef80c2012$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $7884584ef80c2012$var$classnames_1.default)("helix-icon", "priority-high-outlined", className);
    return $7884584ef80c2012$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $7884584ef80c2012$var$react_1.default.createElement("path", {
        d: "M8 7.73325C8 7.51234 8.17909 7.33325 8.4 7.33325H10.6C10.8209 7.33325 11 7.51234 11 7.73325V15.9333C11 16.1542 10.8209 16.3333 10.6 16.3333H8.4C8.17909 16.3333 8 16.1542 8 15.9333V7.73325Z",
        fill: "#DC2626"
    }), $7884584ef80c2012$var$react_1.default.createElement("path", {
        d: "M12.9463 4.70664C12.9463 4.48573 13.1254 4.30664 13.3463 4.30664H15.5463C15.7672 4.30664 15.9463 4.48573 15.9463 4.70664V15.9066C15.9463 16.1276 15.7672 16.3066 15.5463 16.3066H13.3463C13.1254 16.3066 12.9463 16.1276 12.9463 15.9066V4.70664Z",
        fill: "#DC2626"
    }), $7884584ef80c2012$var$react_1.default.createElement("path", {
        d: "M3 10.7333C3 10.5123 3.17909 10.3333 3.4 10.3333H5.6C5.82091 10.3333 6 10.5123 6 10.7333V15.9333C6 16.1542 5.82091 16.3333 5.6 16.3333H3.4C3.17909 16.3333 3 16.1542 3 15.9333V10.7333Z",
        fill: "#DC2626"
    }));
};
module.exports.priority_high = $7884584ef80c2012$var$priority_high;

});

parcelRegister("i7ieH", function(module, exports) {
"use strict";
var $d30706c4ad9c808a$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d30706c4ad9c808a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.priority_low = void 0;

/* eslint-disable max-len */ const $d30706c4ad9c808a$var$react_1 = $d30706c4ad9c808a$var$__importDefault((parcelRequire("acw62")));

const $d30706c4ad9c808a$var$classnames_1 = $d30706c4ad9c808a$var$__importDefault((parcelRequire("8g1PZ")));
const $d30706c4ad9c808a$var$priority_low = (_a)=>{
    var { className: className } = _a, rest = $d30706c4ad9c808a$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $d30706c4ad9c808a$var$classnames_1.default)("helix-icon", "priority-low-outlined", className);
    return $d30706c4ad9c808a$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $d30706c4ad9c808a$var$react_1.default.createElement("path", {
        d: "M8 7.73325C8 7.51234 8.17909 7.33325 8.4 7.33325H10.6C10.8209 7.33325 11 7.51234 11 7.73325V15.9333C11 16.1542 10.8209 16.3333 10.6 16.3333H8.4C8.17909 16.3333 8 16.1542 8 15.9333V7.73325Z",
        fill: "#D1D5DB"
    }), $d30706c4ad9c808a$var$react_1.default.createElement("path", {
        d: "M12.9463 4.70664C12.9463 4.48573 13.1254 4.30664 13.3463 4.30664H15.5463C15.7672 4.30664 15.9463 4.48573 15.9463 4.70664V15.9066C15.9463 16.1276 15.7672 16.3066 15.5463 16.3066H13.3463C13.1254 16.3066 12.9463 16.1276 12.9463 15.9066V4.70664Z",
        fill: "#D1D5DB"
    }), $d30706c4ad9c808a$var$react_1.default.createElement("path", {
        d: "M3 10.7333C3 10.5123 3.17909 10.3333 3.4 10.3333H5.6C5.82091 10.3333 6 10.5123 6 10.7333V15.9333C6 16.1542 5.82091 16.3333 5.6 16.3333H3.4C3.17909 16.3333 3 16.1542 3 15.9333V10.7333Z",
        fill: "#059669"
    }));
};
module.exports.priority_low = $d30706c4ad9c808a$var$priority_low;

});

parcelRegister("19JTN", function(module, exports) {
"use strict";
var $0d7a3c444cfe02b2$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $0d7a3c444cfe02b2$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.priority_medium = void 0;

/* eslint-disable max-len */ const $0d7a3c444cfe02b2$var$react_1 = $0d7a3c444cfe02b2$var$__importDefault((parcelRequire("acw62")));

const $0d7a3c444cfe02b2$var$classnames_1 = $0d7a3c444cfe02b2$var$__importDefault((parcelRequire("8g1PZ")));
const $0d7a3c444cfe02b2$var$priority_medium = (_a)=>{
    var { className: className } = _a, rest = $0d7a3c444cfe02b2$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $0d7a3c444cfe02b2$var$classnames_1.default)("helix-icon", "priority-medium-outlined", className);
    return $0d7a3c444cfe02b2$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $0d7a3c444cfe02b2$var$react_1.default.createElement("path", {
        d: "M8 7.73325C8 7.51234 8.17909 7.33325 8.4 7.33325H10.6C10.8209 7.33325 11 7.51234 11 7.73325V15.9333C11 16.1542 10.8209 16.3333 10.6 16.3333H8.4C8.17909 16.3333 8 16.1542 8 15.9333V7.73325Z",
        fill: "#D97706"
    }), $0d7a3c444cfe02b2$var$react_1.default.createElement("path", {
        d: "M12.9463 4.70664C12.9463 4.48573 13.1254 4.30664 13.3463 4.30664H15.5463C15.7672 4.30664 15.9463 4.48573 15.9463 4.70664V15.9066C15.9463 16.1276 15.7672 16.3066 15.5463 16.3066H13.3463C13.1254 16.3066 12.9463 16.1276 12.9463 15.9066V4.70664Z",
        fill: "#D1D5DB"
    }), $0d7a3c444cfe02b2$var$react_1.default.createElement("path", {
        d: "M3 10.7333C3 10.5123 3.17909 10.3333 3.4 10.3333H5.6C5.82091 10.3333 6 10.5123 6 10.7333V15.9333C6 16.1542 5.82091 16.3333 5.6 16.3333H3.4C3.17909 16.3333 3 16.1542 3 15.9333V10.7333Z",
        fill: "#D97706"
    }));
};
module.exports.priority_medium = $0d7a3c444cfe02b2$var$priority_medium;

});

parcelRegister("hCKVh", function(module, exports) {
"use strict";
var $cd4a6231bb115ae9$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $cd4a6231bb115ae9$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.priority_none = void 0;

/* eslint-disable max-len */ const $cd4a6231bb115ae9$var$react_1 = $cd4a6231bb115ae9$var$__importDefault((parcelRequire("acw62")));

const $cd4a6231bb115ae9$var$classnames_1 = $cd4a6231bb115ae9$var$__importDefault((parcelRequire("8g1PZ")));
const $cd4a6231bb115ae9$var$priority_none = (_a)=>{
    var { className: className } = _a, rest = $cd4a6231bb115ae9$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $cd4a6231bb115ae9$var$classnames_1.default)("helix-icon", "priority-none-outlined", className);
    return $cd4a6231bb115ae9$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $cd4a6231bb115ae9$var$react_1.default.createElement("path", {
        d: "M8 7.73325C8 7.51234 8.17909 7.33325 8.4 7.33325H10.6C10.8209 7.33325 11 7.51234 11 7.73325V15.9333C11 16.1542 10.8209 16.3333 10.6 16.3333H8.4C8.17909 16.3333 8 16.1542 8 15.9333V7.73325Z",
        fill: "#D1D5DB"
    }), $cd4a6231bb115ae9$var$react_1.default.createElement("path", {
        d: "M12.9463 4.70664C12.9463 4.48573 13.1254 4.30664 13.3463 4.30664H15.5463C15.7672 4.30664 15.9463 4.48573 15.9463 4.70664V15.9066C15.9463 16.1276 15.7672 16.3066 15.5463 16.3066H13.3463C13.1254 16.3066 12.9463 16.1276 12.9463 15.9066V4.70664Z",
        fill: "#D1D5DB"
    }), $cd4a6231bb115ae9$var$react_1.default.createElement("path", {
        d: "M3 10.7333C3 10.5123 3.17909 10.3333 3.4 10.3333H5.6C5.82091 10.3333 6 10.5123 6 10.7333V15.9333C6 16.1542 5.82091 16.3333 5.6 16.3333H3.4C3.17909 16.3333 3 16.1542 3 15.9333V10.7333Z",
        fill: "#D1D5DB"
    }));
};
module.exports.priority_none = $cd4a6231bb115ae9$var$priority_none;

});

parcelRegister("3fv75", function(module, exports) {
"use strict";
var $25dae8473f00f436$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $25dae8473f00f436$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.reclaim = void 0;

/* eslint-disable max-len */ const $25dae8473f00f436$var$react_1 = $25dae8473f00f436$var$__importDefault((parcelRequire("acw62")));

const $25dae8473f00f436$var$classnames_1 = $25dae8473f00f436$var$__importDefault((parcelRequire("8g1PZ")));
const $25dae8473f00f436$var$reclaim = (_a)=>{
    var { className: className } = _a, rest = $25dae8473f00f436$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $25dae8473f00f436$var$classnames_1.default)("helix-icon", "reclaim-outlined", className);
    return $25dae8473f00f436$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $25dae8473f00f436$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5 4C5.41421 4 5.75 4.33579 5.75 4.75V11.75C5.75 12.8496 6.07694 13.6413 6.59283 14.1572C7.10872 14.6731 7.90038 15 9 15H11C11.9507 15 12.7573 14.6829 13.321 14.1449C13.8793 13.6122 14.25 12.815 14.25 11.75C14.25 10.6718 13.8953 9.87356 13.3615 9.34585C12.8251 8.81558 12.0488 8.5 11.1 8.5H8.5C8.08579 8.5 7.75 8.16421 7.75 7.75C7.75 7.33579 8.08579 7 8.5 7H11.1C12.3879 7 13.5616 7.43442 14.4161 8.27915C15.2731 9.12644 15.75 10.3282 15.75 11.75C15.75 13.185 15.2391 14.3878 14.3566 15.2301C13.4795 16.0671 12.2861 16.5 11 16.5H9C7.59962 16.5 6.39128 16.0769 5.53217 15.2178C4.67306 14.3587 4.25 13.1504 4.25 11.75V4.75C4.25 4.33579 4.58579 4 5 4Z",
        fill: "#4B5563"
    }), $25dae8473f00f436$var$react_1.default.createElement("path", {
        d: "M10.0478 4.88429L7.32673 7.10598C6.89109 7.46166 6.89109 8.03834 7.32673 8.39402L10.0478 10.6157C10.3992 10.9026 11 10.6994 11 10.2937V5.2063C11 4.80059 10.3992 4.59741 10.0478 4.88429Z",
        fill: "#4B5563"
    }));
};
module.exports.reclaim = $25dae8473f00f436$var$reclaim;

});

parcelRegister("6yxf0", function(module, exports) {
"use strict";
var $4c5fb407399b63a2$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $4c5fb407399b63a2$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.refresh = void 0;

/* eslint-disable max-len */ const $4c5fb407399b63a2$var$react_1 = $4c5fb407399b63a2$var$__importDefault((parcelRequire("acw62")));

const $4c5fb407399b63a2$var$classnames_1 = $4c5fb407399b63a2$var$__importDefault((parcelRequire("8g1PZ")));
const $4c5fb407399b63a2$var$refresh = (_a)=>{
    var { className: className } = _a, rest = $4c5fb407399b63a2$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $4c5fb407399b63a2$var$classnames_1.default)("helix-icon", "refresh-outlined", className);
    return $4c5fb407399b63a2$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $4c5fb407399b63a2$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.3177 3.25C15.7319 3.25 16.0677 3.58579 16.0677 4L16.0677 7.98793C16.0677 8.18684 15.9887 8.37761 15.848 8.51826C15.7074 8.65892 15.5166 8.73793 15.3177 8.73793L11.3637 8.73791C10.9495 8.73791 10.6137 8.40212 10.6137 7.98791C10.6137 7.5737 10.9495 7.23791 11.3638 7.23791L13.5139 7.23792C12.8679 6.42918 11.9377 5.84378 10.8396 5.64757C8.43684 5.21825 6.14098 6.81806 5.71166 9.22083C5.28234 11.6236 6.88215 13.9195 9.28492 14.3488C10.7796 14.6158 12.2331 14.0984 13.2231 13.0878C13.552 12.752 13.8289 12.3624 14.0387 11.9299C14.2195 11.5572 14.6682 11.4016 15.0408 11.5824C15.4135 11.7631 15.5691 12.2118 15.3884 12.5845C15.1066 13.1655 14.7349 13.688 14.2947 14.1374C12.9724 15.4873 11.0246 16.1834 9.02108 15.8254C5.8028 15.2504 3.66002 12.1753 4.23505 8.957C4.81007 5.73871 7.88516 3.59593 11.1034 4.17096C12.509 4.42209 13.7096 5.15068 14.5677 6.15854L14.5677 4C14.5677 3.58579 14.9035 3.25 15.3177 3.25Z",
        fill: "#4B5563"
    }));
};
module.exports.refresh = $4c5fb407399b63a2$var$refresh;

});

parcelRegister("624Sz", function(module, exports) {
"use strict";
var $4646b6e0296c8976$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $4646b6e0296c8976$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resize_to_fit = void 0;

/* eslint-disable max-len */ const $4646b6e0296c8976$var$react_1 = $4646b6e0296c8976$var$__importDefault((parcelRequire("acw62")));

const $4646b6e0296c8976$var$classnames_1 = $4646b6e0296c8976$var$__importDefault((parcelRequire("8g1PZ")));
const $4646b6e0296c8976$var$resize_to_fit = (_a)=>{
    var { className: className } = _a, rest = $4646b6e0296c8976$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $4646b6e0296c8976$var$classnames_1.default)("helix-icon", "resize-to-fit-outlined", className);
    return $4646b6e0296c8976$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $4646b6e0296c8976$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.53033 2.46967C2.82322 2.17678 3.2981 2.17678 3.59099 2.46967L6.75 5.62868V4C6.75 3.58579 7.08579 3.25 7.5 3.25C7.91421 3.25 8.25 3.58579 8.25 4V7.5C8.25 7.91421 7.91421 8.25 7.5 8.25H4C3.58579 8.25 3.25 7.91421 3.25 7.5C3.25 7.08579 3.58579 6.75 4 6.75H5.75L2.53033 3.53033C2.23744 3.23744 2.23744 2.76256 2.53033 2.46967ZM17.5303 2.53033C17.8232 2.82322 17.8232 3.2981 17.5303 3.59099L14.3713 6.75H16C16.4142 6.75 16.75 7.08579 16.75 7.5C16.75 7.91421 16.4142 8.25 16 8.25H12.5C12.0858 8.25 11.75 7.91421 11.75 7.5V4C11.75 3.58579 12.0858 3.25 12.5 3.25C12.9142 3.25 13.25 3.58579 13.25 4V5.75L16.4697 2.53033C16.7626 2.23744 17.2374 2.23744 17.5303 2.53033ZM3.25 12.5C3.25 12.0858 3.58579 11.75 4 11.75H7.5C7.91421 11.75 8.25 12.0858 8.25 12.5V16C8.25 16.4142 7.91421 16.75 7.5 16.75C7.08579 16.75 6.75 16.4142 6.75 16V14.25L3.53033 17.4697C3.23744 17.7626 2.76256 17.7626 2.46967 17.4697C2.17678 17.1768 2.17678 16.7019 2.46967 16.409L5.62868 13.25H4C3.58579 13.25 3.25 12.9142 3.25 12.5ZM11.75 12.5C11.75 12.0858 12.0858 11.75 12.5 11.75H16C16.4142 11.75 16.75 12.0858 16.75 12.5C16.75 12.9142 16.4142 13.25 16 13.25H14.25L17.4697 16.4697C17.7626 16.7626 17.7626 17.2374 17.4697 17.5303C17.1768 17.8232 16.7019 17.8232 16.409 17.5303L13.25 14.3713V16C13.25 16.4142 12.9142 16.75 12.5 16.75C12.0858 16.75 11.75 16.4142 11.75 16V12.5Z",
        fill: "#4B5563"
    }));
};
module.exports.resize_to_fit = $4646b6e0296c8976$var$resize_to_fit;

});

parcelRegister("kRjlz", function(module, exports) {
"use strict";
var $f2f7c3cc573717c6$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $f2f7c3cc573717c6$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.return_icon = void 0;

/* eslint-disable max-len */ const $f2f7c3cc573717c6$var$react_1 = $f2f7c3cc573717c6$var$__importDefault((parcelRequire("acw62")));

const $f2f7c3cc573717c6$var$classnames_1 = $f2f7c3cc573717c6$var$__importDefault((parcelRequire("8g1PZ")));
const $f2f7c3cc573717c6$var$return_icon = (_a)=>{
    var { className: className } = _a, rest = $f2f7c3cc573717c6$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $f2f7c3cc573717c6$var$classnames_1.default)("helix-icon", "return-outlined", className);
    return $f2f7c3cc573717c6$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $f2f7c3cc573717c6$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.6 2.55C7.84853 2.88137 7.78137 3.35147 7.45 3.6L5.25 5.25L12.1683 5.25C13.9915 5.25 15.4094 5.96593 16.361 7.07381C17.2992 8.16602 17.75 9.59699 17.75 11C17.75 12.403 17.2992 13.834 16.361 14.9262C15.4094 16.0341 13.9915 16.75 12.1683 16.75L3 16.75C2.58579 16.75 2.25 16.4142 2.25 16C2.25 15.5858 2.58579 15.25 3 15.25L12.1683 15.25C13.5662 15.25 14.5642 14.7159 15.2232 13.9488C15.8955 13.166 16.25 12.097 16.25 11C16.25 9.90301 15.8955 8.83397 15.2232 8.05119C14.5642 7.28407 13.5662 6.75 12.1683 6.75L5.25 6.75L7.45 8.4C7.78137 8.64853 7.84853 9.11863 7.6 9.45C7.35147 9.78137 6.88137 9.84853 6.55 9.6L2.55 6.6C2.36115 6.45836 2.25 6.23607 2.25 6C2.25 5.76393 2.36115 5.54164 2.55 5.4L6.55 2.4C6.88137 2.15147 7.35147 2.21863 7.6 2.55Z",
        fill: "#4B5563"
    }));
};
module.exports.return_icon = $f2f7c3cc573717c6$var$return_icon;

});

parcelRegister("aoZqk", function(module, exports) {
"use strict";
var $792bcaba1537034e$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $792bcaba1537034e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.robot = void 0;

/* eslint-disable max-len */ const $792bcaba1537034e$var$react_1 = $792bcaba1537034e$var$__importDefault((parcelRequire("acw62")));

const $792bcaba1537034e$var$classnames_1 = $792bcaba1537034e$var$__importDefault((parcelRequire("8g1PZ")));
const $792bcaba1537034e$var$robot = (_a)=>{
    var { className: className } = _a, rest = $792bcaba1537034e$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $792bcaba1537034e$var$classnames_1.default)("helix-icon", "robot-outlined", className);
    return $792bcaba1537034e$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $792bcaba1537034e$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.25 7C1.25 5.48122 2.48122 4.25 4 4.25H16C17.5188 4.25 18.75 5.48122 18.75 7V15C18.75 16.5188 17.5188 17.75 16 17.75H4C2.48122 17.75 1.25 16.5188 1.25 15V7ZM4 5.75C3.30964 5.75 2.75 6.30964 2.75 7V15C2.75 15.6904 3.30964 16.25 4 16.25H16C16.6904 16.25 17.25 15.6904 17.25 15V7C17.25 6.30964 16.6904 5.75 16 5.75H4Z",
        fill: "#4B5563"
    }), $792bcaba1537034e$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8 13.25C8 12.8358 8.33579 12.5 8.75 12.5H11.25C11.6642 12.5 12 12.8358 12 13.25C12 13.6642 11.6642 14 11.25 14H8.75C8.33579 14 8 13.6642 8 13.25Z",
        fill: "#4B5563"
    }), $792bcaba1537034e$var$react_1.default.createElement("path", {
        d: "M8 10C8 10.5523 7.55228 11 7 11C6.44772 11 6 10.5523 6 10C6 9.44772 6.44772 9 7 9C7.55228 9 8 9.44772 8 10Z",
        fill: "#4B5563"
    }), $792bcaba1537034e$var$react_1.default.createElement("path", {
        d: "M14 10C14 10.5523 13.5523 11 13 11C12.4477 11 12 10.5523 12 10C12 9.44772 12.4477 9 13 9C13.5523 9 14 9.44772 14 10Z",
        fill: "#4B5563"
    }), $792bcaba1537034e$var$react_1.default.createElement("path", {
        d: "M11.5 1.75C11.5 2.7165 10.7165 3.5 9.75 3.5C8.7835 3.5 8 2.7165 8 1.75C8 0.783502 8.7835 0 9.75 0C10.7165 0 11.5 0.783502 11.5 1.75Z",
        fill: "#4B5563"
    }), $792bcaba1537034e$var$react_1.default.createElement("path", {
        d: "M9 2H10.5V5H9V2Z",
        fill: "#4B5563"
    }));
};
module.exports.robot = $792bcaba1537034e$var$robot;

});

parcelRegister("4v4ez", function(module, exports) {
"use strict";
var $346d577197b7d84d$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $346d577197b7d84d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rocket = void 0;

/* eslint-disable max-len */ const $346d577197b7d84d$var$react_1 = $346d577197b7d84d$var$__importDefault((parcelRequire("acw62")));

const $346d577197b7d84d$var$classnames_1 = $346d577197b7d84d$var$__importDefault((parcelRequire("8g1PZ")));
const $346d577197b7d84d$var$rocket = (_a)=>{
    var { className: className } = _a, rest = $346d577197b7d84d$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $346d577197b7d84d$var$classnames_1.default)("helix-icon", "rocket-solid", className);
    return $346d577197b7d84d$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $346d577197b7d84d$var$react_1.default.createElement("path", {
        d: "M10.7783 7.49128C11.1688 7.10076 11.8019 7.10076 12.1924 7.49128C12.5828 7.88181 12.5829 8.51485 12.1924 8.90534C11.8019 9.29579 11.1688 9.29575 10.7783 8.90534C10.3878 8.51483 10.3878 7.88181 10.7783 7.49128Z",
        fill: "#4B5563"
    }), $346d577197b7d84d$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.5576 2.503C16.4887 2.44651 17.2363 3.19497 17.1797 4.12605C17.0932 5.54427 16.5936 8.39283 14.1367 10.8497C13.8517 11.1347 13.5556 11.3947 13.2588 11.6348L12.5742 15.0626C12.5452 15.2078 12.4738 15.3417 12.3691 15.4464L10.6016 17.2139C10.461 17.3545 10.2701 17.4336 10.0713 17.4337C9.87248 17.4337 9.68165 17.3545 9.54102 17.2139L7.06641 14.7403C6.82893 14.8003 6.60607 14.8444 6.40918 14.8751C6.14321 14.9165 5.91576 14.9368 5.75293 14.9473C5.6714 14.9526 5.60478 14.9557 5.55762 14.9571C5.53408 14.9578 5.51485 14.9579 5.50098 14.9581H4.72461V14.1827C4.72481 14.1689 4.72586 14.1495 4.72656 14.126C4.72797 14.0789 4.73105 14.0123 4.73633 13.9307C4.74688 13.7679 4.76718 13.5405 4.80859 13.2745C4.83935 13.077 4.88116 12.8526 4.94141 12.6143L2.46973 10.1426C2.32908 10.002 2.25 9.81128 2.25 9.61238C2.25 9.41347 2.32908 9.22275 2.46973 9.0821L4.2373 7.31452C4.34201 7.20982 4.4759 7.13848 4.62109 7.10945L8.07129 6.41902C8.29733 6.12515 8.5493 5.83164 8.83398 5.54695C11.2908 3.0901 14.1394 2.58949 15.5576 2.503ZM11.2334 12.9444C10.7781 13.1685 10.3439 13.3349 9.96289 13.4376C9.74908 13.4952 9.51839 13.542 9.29297 13.5548C9.19377 13.6422 9.08547 13.7331 8.97754 13.8194C8.85333 13.9187 8.71026 14.0258 8.56934 14.1202L10.0713 15.6231L11.1484 14.546L11.4951 12.8087C11.4065 12.8557 11.3197 12.9019 11.2334 12.9444ZM6.93262 11.7774C6.83781 11.9032 6.76862 12.0027 6.73828 12.0606C6.51686 12.4838 6.39077 12.9585 6.31738 13.3663C6.72517 13.2929 7.19887 13.1658 7.62207 12.9444C7.67998 12.9141 7.78033 12.846 7.90625 12.751L6.93262 11.7774ZM15.6484 4.00007C14.4366 4.07399 11.9983 4.50376 9.89453 6.60749C8.52707 7.97498 8.03038 9.51737 7.74023 10.463L9.31934 12.0421C9.38309 12.0321 9.46773 12.0187 9.57324 11.9903C9.84178 11.9179 10.184 11.7894 10.5713 11.5987C11.3456 11.2175 12.2547 10.6106 13.0762 9.78913C15.1798 7.68555 15.6087 5.24719 15.6826 4.03523C15.6835 4.0198 15.6816 4.01154 15.6807 4.00886C15.6799 4.00685 15.6787 4.00495 15.6787 4.00495C15.6787 4.00495 15.6775 4.004 15.6748 4.003C15.6724 4.00211 15.6644 3.99911 15.6484 4.00007ZM5.1377 8.53523L4.06055 9.61238L5.5625 11.1143C5.65695 10.9732 5.76383 10.8295 5.86328 10.7051C5.981 10.5579 6.10905 10.4119 6.22363 10.2872C6.35675 9.85462 6.57281 9.06986 7.00586 8.1612L5.1377 8.53523Z",
        fill: "#4B5563"
    }));
};
module.exports.rocket = $346d577197b7d84d$var$rocket;

});

parcelRegister("g2LfV", function(module, exports) {
"use strict";
var $bae17d48bfec0030$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $bae17d48bfec0030$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.school = void 0;

/* eslint-disable max-len */ const $bae17d48bfec0030$var$react_1 = $bae17d48bfec0030$var$__importDefault((parcelRequire("acw62")));

const $bae17d48bfec0030$var$classnames_1 = $bae17d48bfec0030$var$__importDefault((parcelRequire("8g1PZ")));
const $bae17d48bfec0030$var$school = (_a)=>{
    var { className: className } = _a, rest = $bae17d48bfec0030$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $bae17d48bfec0030$var$classnames_1.default)("helix-icon", "school-outlined", className);
    return $bae17d48bfec0030$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $bae17d48bfec0030$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.75 13.4523L3.75 10.3604C3.75 9.94617 4.08579 9.61038 4.5 9.61038C4.91421 9.61038 5.25 9.94617 5.25 10.3604L5.25 13.4523C5.25 13.8665 4.91421 14.2023 4.5 14.2023C4.08579 14.2023 3.75 13.8665 3.75 13.4523Z",
        fill: "#4B5563"
    }), $bae17d48bfec0030$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.75 13.4523C3.75 13.038 4.08579 12.7023 4.5 12.7023V13.4523C4.5 12.7023 4.50073 12.7023 4.50147 12.7023L4.50294 12.7023L4.50591 12.7023L4.51191 12.7023L4.52421 12.7026C4.53255 12.7029 4.54119 12.7033 4.55014 12.7038C4.56803 12.7048 4.58733 12.7065 4.60821 12.7088C4.64983 12.7134 4.69874 12.7209 4.75646 12.7324C4.87129 12.7554 5.02686 12.7956 5.23717 12.8657C5.65644 13.0055 6.31554 13.2715 7.33541 13.7814C8.37187 14.2997 9.15395 14.7965 9.68177 15.1681C9.9457 15.3539 10.1462 15.5085 10.2832 15.619C10.3517 15.6742 10.4044 15.7184 10.4412 15.75C10.4596 15.7657 10.4741 15.7784 10.4846 15.7876L10.4974 15.799L10.5015 15.8027L10.5031 15.8041L10.504 15.8049C10.5041 15.805 10.5042 15.8052 10 16.3604L10.504 15.8049C10.8106 16.0834 10.8337 16.558 10.5552 16.8646C10.277 17.171 9.80327 17.194 9.49661 16.9163C9.49641 16.9162 9.4968 16.9165 9.49661 16.9163L9.49198 16.9122C9.48685 16.9077 9.47788 16.8999 9.46504 16.8889C9.43937 16.8669 9.39829 16.8323 9.34181 16.7868C9.22884 16.6957 9.0543 16.5608 8.81823 16.3946C8.34605 16.0621 7.62813 15.6048 6.66459 15.1231C5.68446 14.633 5.09356 14.399 4.76283 14.2888C4.59814 14.2339 4.50371 14.2116 4.46229 14.2033C4.45551 14.202 4.45035 14.201 4.44671 14.2004C4.05736 14.1731 3.75 13.8486 3.75 13.4523Z",
        fill: "#4B5563"
    }), $bae17d48bfec0030$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.25 13.4523C16.25 13.038 15.9142 12.7023 15.5 12.7023V13.4523C15.5 12.7023 15.4993 12.7023 15.4985 12.7023L15.4971 12.7023L15.4941 12.7023L15.4881 12.7023L15.4758 12.7026C15.4674 12.7029 15.4588 12.7033 15.4499 12.7038C15.432 12.7048 15.4127 12.7065 15.3918 12.7088C15.3502 12.7134 15.3013 12.7209 15.2435 12.7324C15.1287 12.7554 14.9731 12.7956 14.7628 12.8657C14.3436 13.0055 13.6845 13.2715 12.6646 13.7814C11.6281 14.2997 10.846 14.7965 10.3182 15.1681C10.0543 15.3539 9.85384 15.5085 9.71681 15.619C9.64829 15.6742 9.59562 15.7184 9.55879 15.75C9.54038 15.7657 9.52592 15.7784 9.51542 15.7876L9.50264 15.799L9.49847 15.8027L9.49694 15.8041L9.49604 15.8049C9.49591 15.805 9.49579 15.8052 10 16.3604L9.49604 15.8049C9.1894 16.0834 9.16631 16.558 9.44478 16.8646C9.723 17.171 10.1967 17.194 10.5034 16.9163C10.5032 16.9165 10.5036 16.9162 10.5034 16.9163L10.508 16.9122C10.5131 16.9077 10.5221 16.8999 10.535 16.8889C10.5606 16.8669 10.6017 16.8323 10.6582 16.7868C10.7712 16.6957 10.9457 16.5608 11.1818 16.3946C11.654 16.0621 12.3719 15.6048 13.3354 15.1231C14.3155 14.633 14.9064 14.399 15.2372 14.2888C15.4019 14.2339 15.4963 14.2116 15.5377 14.2033C15.5445 14.202 15.5497 14.201 15.5533 14.2004C15.9426 14.1731 16.25 13.8486 16.25 13.4523Z",
        fill: "#4B5563"
    }), $bae17d48bfec0030$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.75 13.3604L14.75 10.3604C14.75 9.94617 15.0858 9.61038 15.5 9.61038C15.9142 9.61038 16.25 9.94617 16.25 10.3604L16.25 13.3604C16.25 13.7746 15.9142 14.1104 15.5 14.1104C15.0858 14.1104 14.75 13.7746 14.75 13.3604Z",
        fill: "#4B5563"
    }), $bae17d48bfec0030$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.75 8.95924C18.7473 9.24082 18.5872 9.4972 18.3353 9.62311L10.5173 13.5312C10.3104 13.6346 10.0674 13.6368 9.85872 13.5371L1.67674 9.62902C1.41822 9.50553 1.25263 9.24555 1.25003 8.95905C1.24743 8.67256 1.40828 8.40961 1.66453 8.28146L9.84651 4.18959C10.062 4.0818 10.3163 4.08414 10.5298 4.19589L18.3478 8.28777C18.5973 8.41834 18.7526 8.67766 18.75 8.95924ZM10.1742 5.70283L3.70771 8.93678L10.1745 12.0256L16.3533 8.93692L10.1742 5.70283Z",
        fill: "#4B5563"
    }), $bae17d48bfec0030$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.75 8.95226V14.9523H17.25V8.95226H18.75Z",
        fill: "#4B5563"
    }), $bae17d48bfec0030$var$react_1.default.createElement("path", {
        d: "M19 14.9523C19 15.5045 18.5523 15.9523 18 15.9523C17.4477 15.9523 17 15.5045 17 14.9523C17 14.4 17.4477 13.9523 18 13.9523C18.5523 13.9523 19 14.4 19 14.9523Z",
        fill: "#4B5563"
    }));
};
module.exports.school = $bae17d48bfec0030$var$school;

});

parcelRegister("joNl0", function(module, exports) {
"use strict";
var $e1f687a5a547b743$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $e1f687a5a547b743$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.screen_bar_chart = void 0;

/* eslint-disable max-len */ const $e1f687a5a547b743$var$react_1 = $e1f687a5a547b743$var$__importDefault((parcelRequire("acw62")));

const $e1f687a5a547b743$var$classnames_1 = $e1f687a5a547b743$var$__importDefault((parcelRequire("8g1PZ")));
const $e1f687a5a547b743$var$screen_bar_chart = (_a)=>{
    var { className: className } = _a, rest = $e1f687a5a547b743$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $e1f687a5a547b743$var$classnames_1.default)("helix-icon", "screen-bar-chart-outlined", className);
    return $e1f687a5a547b743$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e1f687a5a547b743$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.25 13L9.25 7H10.75V13H9.25Z",
        fill: "#4B5563"
    }), $e1f687a5a547b743$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.25 13V8H13.75V13H12.25Z",
        fill: "#4B5563"
    }), $e1f687a5a547b743$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.25 13V9H7.75V13H6.25Z",
        fill: "#4B5563"
    }), $e1f687a5a547b743$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.5 4.5V15.5H16.5V4.5H3.5ZM3 3C2.44772 3 2 3.44772 2 4V16C2 16.5523 2.44772 17 3 17H17C17.5523 17 18 16.5523 18 16V4C18 3.44772 17.5523 3 17 3H3Z",
        fill: "#4B5563"
    }));
};
module.exports.screen_bar_chart = $e1f687a5a547b743$var$screen_bar_chart;

});

parcelRegister("1QG2B", function(module, exports) {
"use strict";
var $158b42376da41f10$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $158b42376da41f10$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.screen_line_chart = void 0;

/* eslint-disable max-len */ const $158b42376da41f10$var$react_1 = $158b42376da41f10$var$__importDefault((parcelRequire("acw62")));

const $158b42376da41f10$var$classnames_1 = $158b42376da41f10$var$__importDefault((parcelRequire("8g1PZ")));
const $158b42376da41f10$var$screen_line_chart = (_a)=>{
    var { className: className } = _a, rest = $158b42376da41f10$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $158b42376da41f10$var$classnames_1.default)("helix-icon", "screen-line-chart-outlined", className);
    return $158b42376da41f10$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, rest), $158b42376da41f10$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.25 4.25226C2.2835 4.25226 1.5 5.03576 1.5 6.00226V16.0023C1.5 16.9688 2.2835 17.7523 3.25 17.7523H16.75C17.7165 17.7523 18.5 16.9688 18.5 16.0023V6.00226C18.5 5.03576 17.7165 4.25226 16.75 4.25226H3.25ZM3 6.00226C3 5.86419 3.11193 5.75226 3.25 5.75226H16.75C16.8881 5.75226 17 5.86419 17 6.00226V16.0023C17 16.1403 16.8881 16.2523 16.75 16.2523H3.25C3.11193 16.2523 3 16.1403 3 16.0023V6.00226Z",
        fill: "#4B5563"
    }), $158b42376da41f10$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 7.25239C12.3177 7.24651 12.6046 7.44142 12.7161 7.73892L14 11.2523H14.6662C15.0804 11.2523 15.5 11.588 15.5 12.0023C15.5 12.4165 15.1642 12.7523 14.75 12.7523H13.564C13.2514 12.7523 12.9716 12.5583 12.8618 12.2656L12 10.2492L10.6895 14.2601C10.59 14.5587 10.3146 14.7427 10 14.7519C9.6854 14.7612 9.3985 14.5523 9.28161 14.2601L7.98796 10.8315L7.17082 12.3377C7.04378 12.5918 6.78408 12.7523 6.5 12.7523H4.75C4.33579 12.7523 4 12.4165 4 12.0023C4 11.588 4.33579 11.2523 4.75 11.2523H6L7.28597 8.66685C7.41806 8.40268 7.69287 8.24063 7.98796 8.25291C8.28305 8.26518 8.54346 8.4495 8.65315 8.72372L10 11.8227L11.3024 7.76509C11.4028 7.46367 11.6823 7.25827 12 7.25239Z",
        fill: "#4B5563"
    }));
};
module.exports.screen_line_chart = $158b42376da41f10$var$screen_line_chart;

});

parcelRegister("a47qu", function(module, exports) {
"use strict";
var $754009c782f321c4$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $754009c782f321c4$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.screen_percentage = void 0;

/* eslint-disable max-len */ const $754009c782f321c4$var$react_1 = $754009c782f321c4$var$__importDefault((parcelRequire("acw62")));

const $754009c782f321c4$var$classnames_1 = $754009c782f321c4$var$__importDefault((parcelRequire("8g1PZ")));
const $754009c782f321c4$var$screen_percentage = (_a)=>{
    var { className: className } = _a, rest = $754009c782f321c4$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $754009c782f321c4$var$classnames_1.default)("helix-icon", "screen-percentage-outlined", className);
    return $754009c782f321c4$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $754009c782f321c4$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.5 4.5V15.5H16.5V4.5H3.5ZM3 3C2.44772 3 2 3.44772 2 4V16C2 16.5523 2.44772 17 3 17H17C17.5523 17 18 16.5523 18 16V4C18 3.44772 17.5523 3 17 3H3Z",
        fill: "#4B5563"
    }), $754009c782f321c4$var$react_1.default.createElement("path", {
        d: "M7.39844 10.5781C8.33203 10.5781 8.90625 9.94531 8.90625 8.92578V8.92188C8.90625 7.90234 8.33203 7.27344 7.39844 7.27344C6.46484 7.27344 5.88672 7.90234 5.88672 8.92188V8.92578C5.88672 9.94531 6.46484 10.5781 7.39844 10.5781ZM8.70703 13L12.4609 7.36328H11.2891L7.53516 13H8.70703ZM7.39844 9.79297C7.10547 9.79297 6.94531 9.49609 6.94531 8.92578V8.92188C6.94531 8.35156 7.10547 8.05859 7.39844 8.05859C7.69531 8.05859 7.85156 8.35156 7.85156 8.92188V8.92578C7.85156 9.49609 7.69531 9.79297 7.39844 9.79297ZM12.6016 13.0898C13.5352 13.0898 14.1094 12.457 14.1094 11.4375V11.4336C14.1094 10.4141 13.5352 9.78516 12.6016 9.78516C11.668 9.78516 11.0898 10.4141 11.0898 11.4336V11.4375C11.0898 12.457 11.668 13.0898 12.6016 13.0898ZM12.6016 12.3047C12.3086 12.3047 12.1484 12.0078 12.1484 11.4375V11.4336C12.1484 10.8633 12.3086 10.5703 12.6016 10.5703C12.8984 10.5703 13.0547 10.8633 13.0547 11.4336V11.4375C13.0547 12.0078 12.8984 12.3047 12.6016 12.3047Z",
        fill: "#4B5563"
    }));
};
module.exports.screen_percentage = $754009c782f321c4$var$screen_percentage;

});

parcelRegister("ajU2M", function(module, exports) {
"use strict";
var $783726e2dc4642ee$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $783726e2dc4642ee$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.search = void 0;

const $783726e2dc4642ee$var$react_1 = $783726e2dc4642ee$var$__importDefault((parcelRequire("acw62")));

const $783726e2dc4642ee$var$classnames_1 = $783726e2dc4642ee$var$__importDefault((parcelRequire("8g1PZ")));
const $783726e2dc4642ee$var$search = (_a)=>{
    var { className: className } = _a, rest = $783726e2dc4642ee$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $783726e2dc4642ee$var$classnames_1.default)("helix-icon", "search-outlined", className);
    return $783726e2dc4642ee$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $783726e2dc4642ee$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        // eslint-disable-next-line max-len
        d: "M9 3.75C6.10051 3.75 3.75 6.10051 3.75 9C3.75 11.8995 6.10051 14.25 9 14.25C11.8995 14.25 14.25 11.8995 14.25 9C14.25 6.10051 11.8995 3.75 9 3.75ZM2.25 9C2.25 5.27208 5.27208 2.25 9 2.25C12.7279 2.25 15.75 5.27208 15.75 9C15.75 10.5938 15.1976 12.0585 14.2739 13.2133L17.0303 15.9697C17.3232 16.2626 17.3232 16.7374 17.0303 17.0303C16.7374 17.3232 16.2626 17.3232 15.9697 17.0303L13.2133 14.2739C12.0585 15.1976 10.5938 15.75 9 15.75C5.27208 15.75 2.25 12.7279 2.25 9Z",
        fill: "#4B5563"
    }));
};
module.exports.search = $783726e2dc4642ee$var$search;

});

parcelRegister("a6dbX", function(module, exports) {
"use strict";
var $75a4b28847a92dff$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $75a4b28847a92dff$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.search_home = void 0;

/* eslint-disable max-len */ const $75a4b28847a92dff$var$react_1 = $75a4b28847a92dff$var$__importDefault((parcelRequire("acw62")));

const $75a4b28847a92dff$var$classnames_1 = $75a4b28847a92dff$var$__importDefault((parcelRequire("8g1PZ")));
const $75a4b28847a92dff$var$search_home = (_a)=>{
    var { className: className } = _a, rest = $75a4b28847a92dff$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $75a4b28847a92dff$var$classnames_1.default)("helix-icon", "search-home-outlined", className);
    return $75a4b28847a92dff$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $75a4b28847a92dff$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9 3.75C6.10051 3.75 3.75 6.10051 3.75 9C3.75 11.8995 6.10051 14.25 9 14.25C11.8995 14.25 14.25 11.8995 14.25 9C14.25 6.10051 11.8995 3.75 9 3.75ZM2.25 9C2.25 5.27208 5.27208 2.25 9 2.25C12.7279 2.25 15.75 5.27208 15.75 9C15.75 10.5938 15.1976 12.0585 14.2739 13.2133L16.5 15.4393C16.7929 15.7322 16.7929 16.2071 16.5 16.5C16.2071 16.7929 15.7322 16.7929 15.4393 16.5L13.2133 14.2739C12.0585 15.1976 10.5938 15.75 9 15.75C5.27208 15.75 2.25 12.7279 2.25 9Z",
        fill: "#4B5563"
    }), $75a4b28847a92dff$var$react_1.default.createElement("path", {
        d: "M6.5 11V8.01923L9 6L11.5 8.01923V11H6.5Z",
        fill: "#4B5563"
    }));
};
module.exports.search_home = $75a4b28847a92dff$var$search_home;

});

parcelRegister("85EyZ", function(module, exports) {
"use strict";
var $5e3e4164aa97286f$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $5e3e4164aa97286f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.search_user = void 0;

/* eslint-disable max-len */ const $5e3e4164aa97286f$var$react_1 = $5e3e4164aa97286f$var$__importDefault((parcelRequire("acw62")));

const $5e3e4164aa97286f$var$classnames_1 = $5e3e4164aa97286f$var$__importDefault((parcelRequire("8g1PZ")));
const $5e3e4164aa97286f$var$search_user = (_a)=>{
    var { className: className } = _a, rest = $5e3e4164aa97286f$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $5e3e4164aa97286f$var$classnames_1.default)("helix-icon", "search-user-outlined", className);
    return $5e3e4164aa97286f$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $5e3e4164aa97286f$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 4.75C7.10051 4.75 4.75 7.10051 4.75 10C4.75 12.8995 7.10051 15.25 10 15.25C12.8995 15.25 15.25 12.8995 15.25 10C15.25 7.10051 12.8995 4.75 10 4.75ZM3.25 10C3.25 6.27208 6.27208 3.25 10 3.25C13.7279 3.25 16.75 6.27208 16.75 10C16.75 11.5938 16.1976 13.0585 15.2739 14.2133L16.5303 15.4697C16.8232 15.7626 16.8232 16.2374 16.5303 16.5303C16.2374 16.8232 15.7626 16.8232 15.4697 16.5303L14.2133 15.2739C13.0585 16.1976 11.5938 16.75 10 16.75C6.27208 16.75 3.25 13.7279 3.25 10Z",
        fill: "#4B5563"
    }), $5e3e4164aa97286f$var$react_1.default.createElement("path", {
        d: "M7 11.5C7 10.6716 7.67157 10 8.5 10H11.5C12.3284 10 13 10.6716 13 11.5V12C13 12.5523 12.5523 13 12 13H8C7.44772 13 7 12.5523 7 12V11.5Z",
        fill: "#4B5563"
    }), $5e3e4164aa97286f$var$react_1.default.createElement("path", {
        d: "M8.5 8.5C8.5 7.67157 9.17157 7 10 7C10.8284 7 11.5 7.67157 11.5 8.5C11.5 9.32843 10.8284 10 10 10C9.17157 10 8.5 9.32843 8.5 8.5Z",
        fill: "#4B5563"
    }));
};
module.exports.search_user = $5e3e4164aa97286f$var$search_user;

});

parcelRegister("kxnBr", function(module, exports) {
"use strict";
var $ef3932c49ba499f5$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $ef3932c49ba499f5$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.send = void 0;

/* eslint-disable max-len */ const $ef3932c49ba499f5$var$react_1 = $ef3932c49ba499f5$var$__importDefault((parcelRequire("acw62")));

const $ef3932c49ba499f5$var$classnames_1 = $ef3932c49ba499f5$var$__importDefault((parcelRequire("8g1PZ")));
const $ef3932c49ba499f5$var$send = (_a)=>{
    var { className: className } = _a, rest = $ef3932c49ba499f5$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $ef3932c49ba499f5$var$classnames_1.default)("helix-icon", "send-outlined", className);
    return $ef3932c49ba499f5$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $ef3932c49ba499f5$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.3009 4.00458L4.18441 4.02803L9.03725 7.69412L15.3009 4.00458ZM8.28807 9.00808L1.50154 3.88116C1.24458 3.68703 1.14023 3.35053 1.24228 3.04507C1.34433 2.73962 1.63 2.53341 1.95205 2.53273L18.0601 2.49875C18.3318 2.49818 18.5767 2.64367 18.7091 2.86987C18.8425 3.09526 18.851 3.37984 18.7188 3.61702L10.8798 17.689C10.723 17.9703 10.4042 18.1202 10.0876 18.0614C9.77093 18.0026 9.52721 17.7481 9.482 17.4293L8.28807 9.00808ZM9.80049 8.98985L10.6542 15.0116L16.0641 5.3003L9.80049 8.98985Z",
        fill: "#4B5563"
    }));
};
module.exports.send = $ef3932c49ba499f5$var$send;

});

parcelRegister("3nx1a", function(module, exports) {
"use strict";
var $275d21bdbc09f4be$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $275d21bdbc09f4be$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.share = void 0;

/* eslint-disable max-len */ const $275d21bdbc09f4be$var$react_1 = $275d21bdbc09f4be$var$__importDefault((parcelRequire("acw62")));

const $275d21bdbc09f4be$var$classnames_1 = $275d21bdbc09f4be$var$__importDefault((parcelRequire("8g1PZ")));
const $275d21bdbc09f4be$var$share = (_a)=>{
    var { className: className } = _a, rest = $275d21bdbc09f4be$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $275d21bdbc09f4be$var$classnames_1.default)("helix-icon", "share-outlined", className);
    return $275d21bdbc09f4be$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "21",
        viewBox: "0 0 20 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $275d21bdbc09f4be$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 0.939331L13.5303 4.46966C13.8232 4.76255 13.8232 5.23743 13.5303 5.53032C13.2374 5.82321 12.7626 5.82321 12.4697 5.53032L10.75 3.81065V12.45C10.75 12.8642 10.4142 13.2 10 13.2C9.58579 13.2 9.25 12.8642 9.25 12.45V3.81065L7.53033 5.53032C7.23744 5.82321 6.76256 5.82321 6.46967 5.53032C6.17678 5.23743 6.17678 4.76255 6.46967 4.46966L10 0.939331ZM3.25 7.99999C3.25 7.58578 3.58579 7.24999 4 7.24999H7C7.41421 7.24999 7.75 7.58578 7.75 7.99999C7.75 8.41421 7.41421 8.74999 7 8.74999H4.75V18.25H15.25V8.74999H13C12.5858 8.74999 12.25 8.41421 12.25 7.99999C12.25 7.58578 12.5858 7.24999 13 7.24999H15.9996C16.4138 7.24999 16.75 7.58578 16.75 7.99999V19C16.75 19.4142 16.4142 19.75 16 19.75H4C3.58579 19.75 3.25 19.4142 3.25 19V7.99999Z",
        fill: "#4B5563"
    }));
};
module.exports.share = $275d21bdbc09f4be$var$share;

});

parcelRegister("jCuzm", function(module, exports) {
"use strict";
var $e489475fe4c325ee$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $e489475fe4c325ee$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.shared = void 0;

/* eslint-disable max-len */ const $e489475fe4c325ee$var$react_1 = $e489475fe4c325ee$var$__importDefault((parcelRequire("acw62")));

const $e489475fe4c325ee$var$classnames_1 = $e489475fe4c325ee$var$__importDefault((parcelRequire("8g1PZ")));
const $e489475fe4c325ee$var$shared = (_a)=>{
    var { className: className } = _a, rest = $e489475fe4c325ee$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $e489475fe4c325ee$var$classnames_1.default)("helix-icon", "shared-outlined", className);
    return $e489475fe4c325ee$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "21",
        viewBox: "0 0 20 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e489475fe4c325ee$var$react_1.default.createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $e489475fe4c325ee$var$react_1.default.createElement("path", {
        d: "M15.6182 14.1865C15.6182 13.6086 15.4451 13.1473 15.1611 12.8389C14.8865 12.5407 14.4425 12.3126 13.7461 12.3125H8.5V10.8125H11.0693V9.5C12.095 9.49994 12.9941 8.6146 12.9941 7.625C12.9941 7.03802 12.8376 6.58174 12.5674 6.28027C12.3103 5.99353 11.864 5.75002 11.0693 5.75C10.1704 5.75 9.75307 6.05782 9.53418 6.40234L8.26855 5.59766C8.81835 4.73249 9.77046 4.25 11.0693 4.25C12.1924 4.25002 13.0837 4.60807 13.6846 5.27832C14.2723 5.93388 14.4941 6.79024 14.4941 7.625C14.4941 9.09358 13.4855 10.3521 12.1631 10.8125H13.7461C14.7977 10.8126 15.6651 11.1721 16.2646 11.8232C16.8549 12.4643 17.1182 13.3155 17.1182 14.1865V17.5596H13.7461V16.0596H15.6182V14.1865Z",
        fill: "#4B5563"
    }), $e489475fe4c325ee$var$react_1.default.createElement("path", {
        d: "M10.75 14.1885C10.75 13.8061 10.6366 13.6054 10.5566 13.5186C10.4985 13.4554 10.3371 13.3145 9.87695 13.3145H4.62988C4.32786 13.3145 4.16618 13.3531 4.0918 13.3809C4.03853 13.4007 4.0314 13.4127 4.02246 13.4238C3.96639 13.4935 3.75002 13.8632 3.75 15.0566V15.0625H10.75V14.1885ZM8.125 7.62598C8.125 7.20379 8.01185 7.01278 7.95312 6.94727C7.92424 6.91507 7.77259 6.75 7.19922 6.75C6.90083 6.75003 6.73155 6.79717 6.64844 6.83105C6.57373 6.86154 6.54572 6.8899 6.53027 6.9082C6.48861 6.95772 6.375 7.15024 6.375 7.62598C6.37515 8.1263 6.78826 8.5008 7.19922 8.50098C7.69726 8.50098 8.12481 8.03942 8.125 7.62598ZM11.625 7.62598C11.6249 8.47192 11.3717 9.2581 10.9443 9.9248C11.796 10.1069 12.5492 10.5147 13.1318 11.1475C13.9263 12.0104 14.25 13.1219 14.25 14.1885V18.5625H0.262695L0.25 15.0635V15.0566C0.250014 13.6262 0.474493 12.25 1.2959 11.2295C1.91562 10.4596 2.713 10.0784 3.52441 9.91602C3.11201 9.24189 2.87505 8.4537 2.875 7.62598C2.875 6.68013 3.08942 5.55941 3.85547 4.65137C4.6671 3.68941 5.8541 3.25006 7.19922 3.25C8.5415 3.25 9.72931 3.68522 10.5596 4.61133C11.359 5.50311 11.625 6.62591 11.625 7.62598Z",
        fill: "#F3F4F6"
    }), $e489475fe4c325ee$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.875 7.6257C9.875 9.04795 8.62138 10.2514 7.19951 10.2514C5.77765 10.2514 4.625 9.04795 4.625 7.6257C4.625 6.20346 5.28125 5 7.19951 5C9.11778 5 9.875 6.20346 9.875 7.6257ZM2 15.0568C2 12.4327 2.88078 11.5643 4.62973 11.5643H9.87658C11.6255 11.5643 12.5 12.7391 12.5 14.1884V16.8125H2.00631L2 15.0568Z",
        fill: "#F3F4F6"
    }), $e489475fe4c325ee$var$react_1.default.createElement("path", {
        d: "M11.75 14.1885C11.75 13.6104 11.5761 13.1494 11.292 12.8408C11.0172 12.5425 10.5736 12.3145 9.87695 12.3145H4.62988C3.87366 12.3145 3.4831 12.4988 3.24316 12.7969C2.96843 13.1382 2.75002 13.7956 2.75 15.0566L2.75293 16.0625H11.75V14.1885ZM9.125 7.62598C9.125 7.03876 8.96854 6.58186 8.69824 6.28027C8.44109 5.99342 7.99413 5.75 7.19922 5.75C6.40624 5.75006 5.99571 5.99145 5.7666 6.2627C5.51803 6.5573 5.375 7.01547 5.375 7.62598C5.37515 8.653 6.21074 9.50081 7.19922 9.50098C8.22511 9.50098 9.12483 8.6158 9.125 7.62598ZM10.625 7.62598C10.6249 9.09529 9.61531 10.3545 8.29199 10.8145H9.87695C10.9287 10.8145 11.7959 11.174 12.3955 11.8252C12.9859 12.4664 13.25 13.3173 13.25 14.1885V16.8125C13.25 17.2267 12.9142 17.5625 12.5 17.5625H2.00586C1.59298 17.5623 1.25747 17.2283 1.25586 16.8154L1.25 15.0596V15.0566C1.25001 13.6939 1.47237 12.6053 2.0752 11.8564C2.71289 11.0643 3.63717 10.8145 4.62988 10.8145H6.11523C4.80337 10.3494 3.87512 9.06993 3.875 7.62598C3.875 6.81423 4.06099 5.95858 4.62012 5.2959C5.19871 4.61027 6.07486 4.25006 7.19922 4.25C8.32257 4.25 9.21441 4.60886 9.81543 5.2793C10.403 5.93495 10.625 6.7912 10.625 7.62598Z",
        fill: "#4B5563"
    })));
};
module.exports.shared = $e489475fe4c325ee$var$shared;

});

parcelRegister("47Lu5", function(module, exports) {
"use strict";
var $300ca643d8fa9b88$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $300ca643d8fa9b88$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.shield_home = void 0;

/* eslint-disable max-len */ const $300ca643d8fa9b88$var$react_1 = $300ca643d8fa9b88$var$__importDefault((parcelRequire("acw62")));

const $300ca643d8fa9b88$var$classnames_1 = $300ca643d8fa9b88$var$__importDefault((parcelRequire("8g1PZ")));
const $300ca643d8fa9b88$var$shield_home = (_a)=>{
    var { className: className } = _a, rest = $300ca643d8fa9b88$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $300ca643d8fa9b88$var$classnames_1.default)("helix-icon", "shield-home-outlined", className);
    return $300ca643d8fa9b88$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $300ca643d8fa9b88$var$react_1.default.createElement("path", {
        d: "M7 13V9.01923L10 7L13 9.01923V13H7Z",
        fill: "#4B5563"
    }), $300ca643d8fa9b88$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.56407 1.3897C9.82484 1.20343 10.1752 1.20343 10.4359 1.3897L11.3564 2.04719C12.9535 3.18795 14.8013 3.92828 16.7442 4.20584L17.1061 4.25754C17.4756 4.31032 17.75 4.62676 17.75 5V10.7805C17.75 13.0429 16.7614 15.1923 15.0436 16.6647C12.1413 19.1524 7.85866 19.1524 4.95637 16.6647C3.23861 15.1923 2.25 13.0429 2.25 10.7805V5C2.25 4.62676 2.52445 4.31032 2.89393 4.25754L3.25583 4.20584C5.19874 3.92828 7.04652 3.18795 8.64358 2.04719L9.56407 1.3897ZM10 2.92168L9.51544 3.26779C7.80026 4.49292 5.82746 5.30658 3.75 5.64748V10.7805C3.75 12.605 4.54727 14.3384 5.93255 15.5258C8.27312 17.532 11.7269 17.532 14.0674 15.5258C15.4527 14.3384 16.25 12.605 16.25 10.7805V5.64748C14.1725 5.30658 12.1997 4.49292 10.4846 3.26779L10 2.92168Z",
        fill: "#4B5563"
    }));
};
module.exports.shield_home = $300ca643d8fa9b88$var$shield_home;

});

parcelRegister("jN4XK", function(module, exports) {
"use strict";
var $e686716a02e169f2$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $e686716a02e169f2$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.shield_key = void 0;

/* eslint-disable max-len */ const $e686716a02e169f2$var$react_1 = $e686716a02e169f2$var$__importDefault((parcelRequire("acw62")));

const $e686716a02e169f2$var$classnames_1 = $e686716a02e169f2$var$__importDefault((parcelRequire("8g1PZ")));
const $e686716a02e169f2$var$shield_key = (_a)=>{
    var { className: className } = _a, rest = $e686716a02e169f2$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $e686716a02e169f2$var$classnames_1.default)("helix-icon", "shield-key-outlined", className);
    return $e686716a02e169f2$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e686716a02e169f2$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.55001 1.13743C9.81919 0.954189 10.1808 0.954189 10.45 1.13743L11.4002 1.78425C13.0488 2.9065 14.9561 3.63481 16.9617 3.90787L17.3353 3.95873C17.7167 4.01065 18 4.32196 18 4.68914V10.3758C18 12.6015 16.9795 14.7161 15.2063 16.1645C12.2104 18.6118 7.78959 18.6118 4.79367 16.1645C3.0205 14.7161 2 12.6015 2 10.3758V4.68914C2 4.32196 2.2833 4.01065 2.66471 3.95873L3.03827 3.90787C5.04386 3.63481 6.95124 2.9065 8.59983 1.78425L9.55001 1.13743ZM10 2.64455L9.49981 2.98505C7.7293 4.19029 5.69286 4.99074 3.54839 5.32611V10.3758C3.54839 12.1707 4.37137 13.876 5.80135 15.0441C8.21741 17.0178 11.7826 17.0178 14.1987 15.0441C15.6286 13.876 16.4516 12.1707 16.4516 10.3758V5.32611C14.3071 4.99074 12.2707 4.19029 10.5002 2.98505L10 2.64455Z",
        fill: "#4B5563"
    }), $e686716a02e169f2$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 7.5C10.2761 7.5 10.5 7.27614 10.5 7C10.5 6.72386 10.2761 6.5 10 6.5C9.72386 6.5 9.5 6.72386 9.5 7C9.5 7.27614 9.72386 7.5 10 7.5ZM10 9C11.1046 9 12 8.10457 12 7C12 5.89543 11.1046 5 10 5C8.89543 5 8 5.89543 8 7C8 8.10457 8.89543 9 10 9Z",
        fill: "#4B5563"
    }), $e686716a02e169f2$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.25 14V8.5C9.25 8.08579 9.58579 7.75 10 7.75C10.4142 7.75 10.75 8.08579 10.75 8.5V14C10.75 14.4142 10.4142 14.75 10 14.75C9.58579 14.75 9.25 14.4142 9.25 14Z",
        fill: "#4B5563"
    }), $e686716a02e169f2$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 11H10V14H12V13C11.7239 13 11.5 12.7761 11.5 12.5C11.5 12.2239 11.7239 12 12 12V11Z",
        fill: "#4B5563"
    }));
};
module.exports.shield_key = $e686716a02e169f2$var$shield_key;

});

parcelRegister("8mfWi", function(module, exports) {
"use strict";
var $615cbe07f44a4d35$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $615cbe07f44a4d35$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.shopping_cart = void 0;

/* eslint-disable max-len */ const $615cbe07f44a4d35$var$react_1 = $615cbe07f44a4d35$var$__importDefault((parcelRequire("acw62")));

const $615cbe07f44a4d35$var$classnames_1 = $615cbe07f44a4d35$var$__importDefault((parcelRequire("8g1PZ")));
const $615cbe07f44a4d35$var$shopping_cart = (_a)=>{
    var { className: className } = _a, rest = $615cbe07f44a4d35$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $615cbe07f44a4d35$var$classnames_1.default)("helix-icon", "shopping-cart-outlined", className);
    return $615cbe07f44a4d35$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $615cbe07f44a4d35$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.19948 5.7023C3.83918 5.7023 4.37564 6.18526 4.44261 6.82144L5.15988 13.6355C5.25363 14.5262 6.00468 15.2023 6.90026 15.2023H15C15.4142 15.2023 15.75 14.8665 15.75 14.4523C15.75 14.0381 15.4142 13.7023 15 13.7023H6.90026C6.77232 13.7023 6.66503 13.6057 6.65164 13.4785L5.93437 6.66442C5.78704 5.26481 4.60681 4.2023 3.19948 4.2023H3V5.7023H3.19948Z",
        fill: "#4B5563"
    }), $615cbe07f44a4d35$var$react_1.default.createElement("path", {
        d: "M16 16.9523C16 17.5046 15.5523 17.9523 15 17.9523C14.4477 17.9523 14 17.5046 14 16.9523C14 16.4 14.4477 15.9523 15 15.9523C15.5523 15.9523 16 16.4 16 16.9523Z",
        fill: "#4B5563"
    }), $615cbe07f44a4d35$var$react_1.default.createElement("path", {
        d: "M7.5 16.9523C7.5 17.5046 7.05228 17.9523 6.5 17.9523C5.94772 17.9523 5.5 17.5046 5.5 16.9523C5.5 16.4 5.94772 15.9523 6.5 15.9523C7.05228 15.9523 7.5 16.4 7.5 16.9523Z",
        fill: "#4B5563"
    }), $615cbe07f44a4d35$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.565 7.70228H5.5V6.20228H16.5C16.7275 6.20228 16.9427 6.30553 17.085 6.48299C17.2274 6.66044 17.2815 6.89291 17.2321 7.11498L16.2321 11.615C16.1622 11.9296 15.8991 12.1644 15.5785 12.1982L6.07851 13.1982L5.92149 11.7064L14.8849 10.7629L15.565 7.70228Z",
        fill: "#4B5563"
    }));
};
module.exports.shopping_cart = $615cbe07f44a4d35$var$shopping_cart;

});

parcelRegister("esh5S", function(module, exports) {
"use strict";
var $a860f0a8d1c96b7f$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $a860f0a8d1c96b7f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.shopping_cart_filled = void 0;

/* eslint-disable max-len */ const $a860f0a8d1c96b7f$var$react_1 = $a860f0a8d1c96b7f$var$__importDefault((parcelRequire("acw62")));

const $a860f0a8d1c96b7f$var$classnames_1 = $a860f0a8d1c96b7f$var$__importDefault((parcelRequire("8g1PZ")));
const $a860f0a8d1c96b7f$var$shopping_cart_filled = (_a)=>{
    var { className: className } = _a, rest = $a860f0a8d1c96b7f$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $a860f0a8d1c96b7f$var$classnames_1.default)("helix-icon", "shopping-cart-filled-outlined", className);
    return $a860f0a8d1c96b7f$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $a860f0a8d1c96b7f$var$react_1.default.createElement("svg", {
        width: "20",
        height: "21",
        viewBox: "0 0 20 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $a860f0a8d1c96b7f$var$react_1.default.createElement("g", {
        clipPath: "url(#clip0_13413_51408)"
    }, $a860f0a8d1c96b7f$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.19948 5.7023C3.83918 5.7023 4.37564 6.18526 4.44261 6.82144L5.15988 13.6355C5.25363 14.5262 6.00468 15.2023 6.90026 15.2023H15C15.4142 15.2023 15.75 14.8665 15.75 14.4523C15.75 14.0381 15.4142 13.7023 15 13.7023H6.90026C6.77232 13.7023 6.66503 13.6057 6.65164 13.4785L5.93437 6.66442C5.78704 5.26481 4.60681 4.2023 3.19948 4.2023H3V5.7023H3.19948Z",
        fill: "#4B5563"
    }), $a860f0a8d1c96b7f$var$react_1.default.createElement("path", {
        d: "M16 16.9523C16 17.5046 15.5523 17.9523 15 17.9523C14.4477 17.9523 14 17.5046 14 16.9523C14 16.4 14.4477 15.9523 15 15.9523C15.5523 15.9523 16 16.4 16 16.9523Z",
        fill: "#4B5563"
    }), $a860f0a8d1c96b7f$var$react_1.default.createElement("path", {
        d: "M7.5 16.9523C7.5 17.5046 7.05228 17.9523 6.5 17.9523C5.94772 17.9523 5.5 17.5046 5.5 16.9523C5.5 16.4 5.94772 15.9523 6.5 15.9523C7.05228 15.9523 7.5 16.4 7.5 16.9523Z",
        fill: "#4B5563"
    }), $a860f0a8d1c96b7f$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.565 7.70228H5.5V6.20228H16.5C16.7275 6.20228 16.9427 6.30553 17.085 6.48299C17.2274 6.66044 17.2815 6.89291 17.2321 7.11498L16.2321 11.615C16.1622 11.9296 15.8991 12.1644 15.5785 12.1982L6.07851 13.1982L5.92149 11.7064L14.8849 10.7629L15.565 7.70228Z",
        fill: "#4B5563"
    }), $a860f0a8d1c96b7f$var$react_1.default.createElement("g", {
        filter: "url(#filter0_dd_13413_51408)"
    }, $a860f0a8d1c96b7f$var$react_1.default.createElement("rect", {
        x: "8.5",
        y: "0.952271",
        width: "9",
        height: "9",
        rx: "4.5",
        fill: "#DC2626"
    }), $a860f0a8d1c96b7f$var$react_1.default.createElement("path", {
        opacity: "0.99",
        d: "M11.2715 3.33655C10.478 3.33655 9.92139 3.86877 9.92139 4.58899V4.59387C9.92139 5.26038 10.3828 5.74866 11.0688 5.74866C11.5571 5.74866 11.8501 5.50452 11.9771 5.23352H12.0259C12.0259 5.26038 12.0259 5.28723 12.0259 5.31165C11.999 5.95374 11.7744 6.45422 11.2642 6.45422C10.981 6.45422 10.7808 6.3053 10.6953 6.08557L10.688 6.0636H9.96533L9.97021 6.08557C10.0801 6.63733 10.5854 7.04016 11.2666 7.04016C12.1699 7.04016 12.7266 6.33948 12.7266 5.16028V5.1554C12.7266 3.9176 12.0869 3.33655 11.2715 3.33655ZM11.2715 5.20422C10.9028 5.20422 10.6343 4.93811 10.6343 4.56702V4.56213C10.6343 4.20325 10.9199 3.92249 11.2764 3.92249C11.6353 3.92249 11.916 4.20813 11.916 4.57678V4.58167C11.916 4.94543 11.6353 5.20422 11.2715 5.20422ZM13.332 5.8512H14.3867V6.87415H15.0288V5.8512H16.0859V5.20911H15.0288V4.18616H14.3867V5.20911H13.332V5.8512Z",
        fill: "white"
    }))), $a860f0a8d1c96b7f$var$react_1.default.createElement("defs", null, $a860f0a8d1c96b7f$var$react_1.default.createElement("filter", {
        id: "filter0_dd_13413_51408",
        x: "6.5",
        y: "-0.0477295",
        width: "13",
        height: "13",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB"
    }, $a860f0a8d1c96b7f$var$react_1.default.createElement("feFlood", {
        floodOpacity: "0",
        result: "BackgroundImageFix"
    }), $a860f0a8d1c96b7f$var$react_1.default.createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), $a860f0a8d1c96b7f$var$react_1.default.createElement("feOffset", {
        dy: "1"
    }), $a860f0a8d1c96b7f$var$react_1.default.createElement("feGaussianBlur", {
        stdDeviation: "1"
    }), $a860f0a8d1c96b7f$var$react_1.default.createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
    }), $a860f0a8d1c96b7f$var$react_1.default.createElement("feBlend", {
        mode: "normal",
        in2: "BackgroundImageFix",
        result: "effect1_dropShadow_13413_51408"
    }), $a860f0a8d1c96b7f$var$react_1.default.createElement("feColorMatrix", {
        in: "SourceAlpha",
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
        result: "hardAlpha"
    }), $a860f0a8d1c96b7f$var$react_1.default.createElement("feOffset", null), $a860f0a8d1c96b7f$var$react_1.default.createElement("feGaussianBlur", {
        stdDeviation: "0.5"
    }), $a860f0a8d1c96b7f$var$react_1.default.createElement("feColorMatrix", {
        type: "matrix",
        values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
    }), $a860f0a8d1c96b7f$var$react_1.default.createElement("feBlend", {
        mode: "normal",
        in2: "effect1_dropShadow_13413_51408",
        result: "effect2_dropShadow_13413_51408"
    }), $a860f0a8d1c96b7f$var$react_1.default.createElement("feBlend", {
        mode: "normal",
        in: "SourceGraphic",
        in2: "effect2_dropShadow_13413_51408",
        result: "shape"
    })), $a860f0a8d1c96b7f$var$react_1.default.createElement("clipPath", {
        id: "clip0_13413_51408"
    }, $a860f0a8d1c96b7f$var$react_1.default.createElement("rect", {
        y: "0.952271",
        width: "20",
        height: "20",
        rx: "2",
        fill: "white"
    })))));
};
module.exports.shopping_cart_filled = $a860f0a8d1c96b7f$var$shopping_cart_filled;

});

parcelRegister("kqQ4e", function(module, exports) {
"use strict";
var $edfe9fcf5870d9bf$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $edfe9fcf5870d9bf$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.short_text = void 0;

const $edfe9fcf5870d9bf$var$react_1 = $edfe9fcf5870d9bf$var$__importDefault((parcelRequire("acw62")));

const $edfe9fcf5870d9bf$var$classnames_1 = $edfe9fcf5870d9bf$var$__importDefault((parcelRequire("8g1PZ")));
const $edfe9fcf5870d9bf$var$short_text = (_a)=>{
    var { className: className } = _a, rest = $edfe9fcf5870d9bf$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $edfe9fcf5870d9bf$var$classnames_1.default)("helix-icon", "short-text-outlined", className);
    return $edfe9fcf5870d9bf$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $edfe9fcf5870d9bf$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 9.95227H4V8.45227H16V9.95227Z",
        fill: "#4B5563"
    }), $edfe9fcf5870d9bf$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12 12.9523H4V11.4523H12V12.9523Z",
        fill: "#4B5563"
    }));
};
module.exports.short_text = $edfe9fcf5870d9bf$var$short_text;

});

parcelRegister("9DSTk", function(module, exports) {
"use strict";
var $705255d7f8756e02$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $705255d7f8756e02$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sign_for_sale = void 0;

/* eslint-disable max-len */ const $705255d7f8756e02$var$react_1 = $705255d7f8756e02$var$__importDefault((parcelRequire("acw62")));

const $705255d7f8756e02$var$classnames_1 = $705255d7f8756e02$var$__importDefault((parcelRequire("8g1PZ")));
const $705255d7f8756e02$var$sign_for_sale = (_a)=>{
    var { className: className } = _a, rest = $705255d7f8756e02$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $705255d7f8756e02$var$classnames_1.default)("helix-icon", "sign-for-sale-outlined", className);
    return $705255d7f8756e02$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $705255d7f8756e02$var$react_1.default.createElement("path", {
        d: "M5.86719 14.0781C5.11914 14.0781 4.66016 13.7363 4.65625 13.1777H5.44141C5.45117 13.3535 5.63086 13.4668 5.89648 13.4668C6.12891 13.4668 6.2832 13.3633 6.2832 13.2051C6.2832 13.0742 6.17773 13.0117 5.875 12.957L5.50195 12.8906C4.98438 12.8008 4.70312 12.5039 4.70312 12.0488C4.70312 11.4746 5.1582 11.1035 5.86328 11.1035C6.55859 11.1035 7.0332 11.4707 7.03906 12.0117H6.28125C6.27539 11.8418 6.10156 11.7129 5.88086 11.7129C5.66602 11.7129 5.52539 11.8105 5.52539 11.9668C5.52539 12.1016 5.64062 12.1797 5.91016 12.2266L6.29492 12.293C6.84375 12.3887 7.09766 12.6484 7.09766 13.1055C7.09766 13.7148 6.63672 14.0781 5.86719 14.0781Z",
        fill: "#4B5563"
    }), $705255d7f8756e02$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.3223 14H9.41602L9.27148 13.4395H8.41406L8.26367 14H7.44727L8.36523 11.1816H9.4043L10.3223 14ZM8.86914 11.873H8.83008L8.5625 12.8555H9.12695L8.86914 11.873Z",
        fill: "#4B5563"
    }), $705255d7f8756e02$var$react_1.default.createElement("path", {
        d: "M12.7676 13.3242H11.6191V11.1816H10.791V14H12.7676V13.3242Z",
        fill: "#4B5563"
    }), $705255d7f8756e02$var$react_1.default.createElement("path", {
        d: "M14.1074 13.3438H15.2676V14H13.2793V11.1816H15.2676V11.8379H14.1074V12.2949H15.1953V12.8887H14.1074V13.3438Z",
        fill: "#4B5563"
    }), $705255d7f8756e02$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.5303 1.46967C10.2374 1.17678 9.76256 1.17678 9.46967 1.46967L4.68934 6.25H2C1.58579 6.25 1.25 6.58579 1.25 7V18C1.25 18.4142 1.58579 18.75 2 18.75H18C18.4142 18.75 18.75 18.4142 18.75 18V7C18.75 6.58579 18.4142 6.25 18 6.25H15.3107L10.5303 1.46967ZM10 3.06066L13.1893 6.25H6.81066L10 3.06066ZM2.75 17.25V7.75H17.25V17.25H2.75Z",
        fill: "#4B5563"
    }));
};
module.exports.sign_for_sale = $705255d7f8756e02$var$sign_for_sale;

});

parcelRegister("2Ha6Q", function(module, exports) {
"use strict";
var $1f677075857892c6$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $1f677075857892c6$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sign_in_ground = void 0;

/* eslint-disable max-len */ const $1f677075857892c6$var$react_1 = $1f677075857892c6$var$__importDefault((parcelRequire("acw62")));

const $1f677075857892c6$var$classnames_1 = $1f677075857892c6$var$__importDefault((parcelRequire("8g1PZ")));
const $1f677075857892c6$var$sign_in_ground = (_a)=>{
    var { className: className } = _a, rest = $1f677075857892c6$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $1f677075857892c6$var$classnames_1.default)("helix-icon", "sign-in-ground-outlined", className);
    return $1f677075857892c6$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $1f677075857892c6$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.25 2.25C5.66421 2.25 6 2.58579 6 3L6 17.5H4.5L4.5 3C4.5 2.58579 4.83579 2.25 5.25 2.25Z",
        fill: "#4B5563"
    }), $1f677075857892c6$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.5 5.25C2.5 4.83579 2.83579 4.5 3.25 4.5H16.75C17.1642 4.5 17.5 4.83579 17.5 5.25C17.5 5.66421 17.1642 6 16.75 6H3.25C2.83579 6 2.5 5.66421 2.5 5.25Z",
        fill: "#4B5563"
    }), $1f677075857892c6$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.25 12V7H15.75V12C15.75 12.9665 14.9665 13.75 14 13.75H7V12.25H14C14.1381 12.25 14.25 12.1381 14.25 12Z",
        fill: "#4B5563"
    }));
};
module.exports.sign_in_ground = $1f677075857892c6$var$sign_in_ground;

});

parcelRegister("5LQhS", function(module, exports) {
"use strict";
var $4339e6b27babc726$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $4339e6b27babc726$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sign_sold = void 0;

/* eslint-disable max-len */ const $4339e6b27babc726$var$react_1 = $4339e6b27babc726$var$__importDefault((parcelRequire("acw62")));

const $4339e6b27babc726$var$classnames_1 = $4339e6b27babc726$var$__importDefault((parcelRequire("8g1PZ")));
const $4339e6b27babc726$var$sign_sold = (_a)=>{
    var { className: className } = _a, rest = $4339e6b27babc726$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $4339e6b27babc726$var$classnames_1.default)("helix-icon", "sign-sold-outlined", className);
    return $4339e6b27babc726$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $4339e6b27babc726$var$react_1.default.createElement("path", {
        d: "M4.39453 13.0742C4.39844 13.6328 4.85742 13.9746 5.60547 13.9746C6.375 13.9746 6.83594 13.6113 6.83594 13.002C6.83594 12.5449 6.58203 12.2852 6.0332 12.1895L5.64844 12.123C5.37891 12.0762 5.26367 11.998 5.26367 11.8633C5.26367 11.707 5.4043 11.6094 5.61914 11.6094C5.83984 11.6094 6.01367 11.7383 6.01953 11.9082H6.77734C6.77148 11.3672 6.29688 11 5.60156 11C4.89648 11 4.44141 11.3711 4.44141 11.9453C4.44141 12.4004 4.72266 12.6973 5.24023 12.7871L5.61328 12.8535C5.91602 12.9082 6.02148 12.9707 6.02148 13.1016C6.02148 13.2598 5.86719 13.3633 5.63477 13.3633C5.36914 13.3633 5.18945 13.25 5.17969 13.0742H4.39453Z",
        fill: "#4B5563"
    }), $4339e6b27babc726$var$react_1.default.createElement("path", {
        d: "M8.64453 11C7.7832 11 7.22461 11.5664 7.22461 12.4863C7.22461 13.4102 7.7793 13.9746 8.64453 13.9746C9.50586 13.9746 10.0625 13.4102 10.0625 12.4863C10.0625 11.5664 9.50586 11 8.64453 11ZM8.64453 11.6758C8.98438 11.6758 9.21875 11.9922 9.21875 12.4863C9.21875 12.9824 8.98438 13.2988 8.64453 13.2988C8.30273 13.2988 8.06836 12.9824 8.06836 12.4863C8.06836 11.9922 8.30273 11.6758 8.64453 11.6758Z",
        fill: "#4B5563"
    }), $4339e6b27babc726$var$react_1.default.createElement("path", {
        d: "M12.5488 13.2207H11.4004V11.0781H10.5723V13.8965H12.5488V13.2207Z",
        fill: "#4B5563"
    }), $4339e6b27babc726$var$react_1.default.createElement("path", {
        d: "M13.0605 11.0781V13.8965H14.3105C15.1621 13.8965 15.625 13.3887 15.625 12.4512C15.625 11.5703 15.1523 11.0781 14.3105 11.0781H13.0605ZM13.8887 11.7344H14.1484C14.5469 11.7344 14.7812 11.9922 14.7812 12.4668C14.7812 12.9863 14.5625 13.2402 14.1484 13.2402H13.8887V11.7344Z",
        fill: "#4B5563"
    }), $4339e6b27babc726$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.5303 1.21967C10.2374 0.926777 9.76256 0.926777 9.46967 1.21967L4.68934 6H2C1.58579 6 1.25 6.33579 1.25 6.75V17.75C1.25 18.1642 1.58579 18.5 2 18.5H18C18.4142 18.5 18.75 18.1642 18.75 17.75V6.75C18.75 6.33579 18.4142 6 18 6H15.3107L10.5303 1.21967ZM13.1893 6L10 2.81066L6.81066 6H13.1893ZM2.75 17V7.5H17.25V17H2.75Z",
        fill: "#4B5563"
    }));
};
module.exports.sign_sold = $4339e6b27babc726$var$sign_sold;

});

parcelRegister("fvC70", function(module, exports) {
"use strict";
var $b4a750850674cca9$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $b4a750850674cca9$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.signature = void 0;

/* eslint-disable max-len */ const $b4a750850674cca9$var$react_1 = $b4a750850674cca9$var$__importDefault((parcelRequire("acw62")));

const $b4a750850674cca9$var$classnames_1 = $b4a750850674cca9$var$__importDefault((parcelRequire("8g1PZ")));
const $b4a750850674cca9$var$signature = (_a)=>{
    var { className: className } = _a, rest = $b4a750850674cca9$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $b4a750850674cca9$var$classnames_1.default)("helix-icon", "signature-outlined", className);
    return $b4a750850674cca9$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $b4a750850674cca9$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.8652 4.04273C12.8651 4.04274 12.8646 4.04303 12.8634 4.04352L12.8652 4.04273ZM12.0174 3.26342C12.0176 3.26333 12.0168 3.26615 12.0145 3.27217C12.0161 3.26653 12.0173 3.26352 12.0174 3.26342ZM10.0511 6.30942C9.82384 6.71374 9.6125 7.12497 9.41258 7.54252C8.6895 9.05273 8.06202 10.6783 7.71661 12.3639C7.53269 13.2614 7.35181 14.2859 7.43963 15.319C7.47168 15.696 7.63179 16.0946 8.00647 16.3442C8.37023 16.5865 8.78834 16.5889 9.1327 16.504C9.70352 16.3633 10.091 15.9544 10.3181 15.6809C10.9162 14.9603 11.3332 14.1073 11.69 13.3771L11.6964 13.3641C12.0752 12.5891 12.1826 12.3921 12.3486 12.0876C12.3827 12.025 12.4193 11.9579 12.4612 11.8803C12.5046 12.1335 12.5571 12.4245 12.6318 12.7962C12.8661 13.9616 13.0457 14.7671 13.2134 15.2935C13.2962 15.5533 13.3916 15.7968 13.5175 15.9933C13.6458 16.1935 13.8656 16.436 14.2217 16.5101C14.8201 16.6346 15.2079 16.2044 15.3629 15.9931C15.5484 15.7401 15.6988 15.4082 15.8256 15.078C16.0711 14.4383 16.3089 13.5817 16.5432 12.7373C16.555 12.6948 16.5668 12.6523 16.5786 12.6098C16.8309 11.7015 17.0837 10.8042 17.3576 10.086C17.4944 9.72736 17.6272 9.43887 17.7543 9.228C17.8172 9.12367 17.8722 9.04941 17.9171 8.99918C17.9602 8.95105 17.9834 8.93689 17.9834 8.93684C17.9834 8.93684 17.9833 8.9369 17.9831 8.937C18.3451 8.73574 18.4755 8.27909 18.2742 7.91707C18.0729 7.55504 17.6163 7.42471 17.2543 7.62598C16.9041 7.82065 16.6526 8.1501 16.4697 8.45352C16.2775 8.77234 16.1081 9.1531 15.9561 9.55145C15.6526 10.3473 15.3815 11.3151 15.1333 12.2084L15.11 12.2926C14.8933 13.0729 14.6958 13.7841 14.5017 14.3327C14.3925 13.8987 14.2642 13.3053 14.1024 12.5005C14.0135 12.0583 13.9535 11.7026 13.8958 11.3605C13.8065 10.8315 13.7226 10.3348 13.5459 9.60024C13.528 9.52579 13.4798 9.36054 13.3353 9.21263C13.151 9.02398 12.8935 8.9479 12.6499 8.98876C12.4588 9.02081 12.3301 9.11498 12.2779 9.15647C12.2152 9.20633 12.1693 9.25699 12.1413 9.29007C12.0448 9.40427 11.9751 9.53703 11.965 9.55619L11.9644 9.55744L12.5158 9.84803L11.9644 9.55744C11.8885 9.70136 11.819 9.84559 11.7557 9.97731L11.7471 9.99509C11.6854 10.1235 11.6295 10.2399 11.5707 10.3534C11.3121 10.8526 11.1679 11.118 11.047 11.3406C10.865 11.6756 10.7358 11.9135 10.3487 12.7054C9.97737 13.4653 9.6321 14.1589 9.16393 14.7228C9.06696 14.8396 8.98649 14.9176 8.9205 14.9683C8.89226 14.2368 9.02074 13.4719 9.18608 12.665C9.49895 11.1381 10.0748 9.63282 10.7655 8.19029C11.176 7.33293 11.6274 6.5256 12.1627 5.76254C12.2423 5.64908 12.3302 5.52855 12.4224 5.40213C12.7112 5.00615 13.0421 4.55236 13.2919 4.07664C13.3266 4.01051 13.3696 3.92398 13.4061 3.83236C13.435 3.75947 13.4926 3.6056 13.4983 3.42844C13.5013 3.33695 13.4937 3.16596 13.3941 2.98744C13.2772 2.77782 13.0815 2.64331 12.8686 2.59492C12.6879 2.55382 12.5327 2.58228 12.4442 2.60529C12.3479 2.63033 12.2618 2.6674 12.1915 2.70233C11.4459 3.07296 10.8115 3.62158 10.276 4.0848C10.2506 4.10676 10.2254 4.12852 10.2005 4.15006L10.6907 4.71766L10.2005 4.15006C9.05653 5.13809 7.99439 6.19821 6.98042 7.29579C6.86644 7.41916 6.7606 7.54097 6.65578 7.6616C6.46279 7.8837 6.2733 8.10176 6.043 8.31815C5.68943 8.65036 5.43735 8.77392 5.27786 8.78325C5.25783 8.78442 5.23412 8.7863 5.21866 8.78753C5.21629 8.78772 5.21412 8.78789 5.21218 8.78805C5.20971 8.78824 5.20728 8.78843 5.20488 8.78862C5.04682 8.69579 4.85458 8.66034 4.66158 8.70348C4.25735 8.79385 4.0029 9.1948 4.09327 9.59904C4.17548 9.96681 4.45356 10.1402 4.61378 10.2068C4.76809 10.271 4.91702 10.2857 5.0018 10.2907C5.16691 10.3004 5.37197 10.2803 5.36542 10.2807C6.08408 10.2387 6.6712 9.78614 7.07012 9.41132C7.3535 9.14506 7.64222 8.81415 7.85973 8.56487C7.947 8.46484 8.02282 8.37795 8.08221 8.31365C8.72099 7.6222 9.37416 6.95175 10.0511 6.30942ZM5.08988 8.79328C5.08229 8.79284 5.08303 8.79239 5.09038 8.79331L5.08988 8.79328ZM8.72979 15.0551C8.72982 15.0551 8.73078 15.055 8.73259 15.0551C8.73067 15.0552 8.72977 15.0552 8.72979 15.0551ZM14.124 15.1416C14.124 15.1411 14.1275 15.137 14.1343 15.1305C14.1274 15.1388 14.124 15.1421 14.124 15.1416ZM5.2516 12.4293C5.56063 12.7052 5.58755 13.1793 5.31173 13.4883L4.47666 14.4239L5.35818 15.3144C5.64959 15.6087 5.64719 16.0836 5.35282 16.375C5.05845 16.6664 4.58359 16.664 4.29218 16.3697L3.47592 15.5451L2.70267 16.4115C2.42685 16.7205 1.95274 16.7474 1.64372 16.4716C1.33469 16.1958 1.30777 15.7217 1.58359 15.4126L2.41861 14.4771L1.53707 13.5866C1.24566 13.2922 1.24805 12.8174 1.54242 12.5259C1.83679 12.2345 2.31166 12.2369 2.60307 12.5313L3.41935 13.3559L4.19265 12.4895C4.46847 12.1804 4.94258 12.1535 5.2516 12.4293ZM1.34315 18.4427C1.34315 18.0285 1.67893 17.6927 2.09315 17.6927L17.8839 17.6927C18.2981 17.6927 18.6339 18.0285 18.6339 18.4427C18.6339 18.8569 18.2981 19.1927 17.8839 19.1927L2.09315 19.1927C1.67893 19.1927 1.34315 18.8569 1.34315 18.4427Z",
        fill: "#4B5563"
    }));
};
module.exports.signature = $b4a750850674cca9$var$signature;

});

parcelRegister("boMbJ", function(module, exports) {
"use strict";
var $84c750c1d68ab518$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $84c750c1d68ab518$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.skip_left = void 0;

/* eslint-disable max-len */ const $84c750c1d68ab518$var$react_1 = $84c750c1d68ab518$var$__importDefault((parcelRequire("acw62")));

const $84c750c1d68ab518$var$classnames_1 = $84c750c1d68ab518$var$__importDefault((parcelRequire("8g1PZ")));
const $84c750c1d68ab518$var$skip_left = (_a)=>{
    var { className: className } = _a, rest = $84c750c1d68ab518$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $84c750c1d68ab518$var$classnames_1.default)("helix-icon", "skip-left-outlined", className);
    return $84c750c1d68ab518$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $84c750c1d68ab518$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13.5303 14.5303C13.8232 14.2374 13.8232 13.7626 13.5303 13.4697L10.0607 10L13.5303 6.53033C13.8232 6.23744 13.8232 5.76256 13.5303 5.46967C13.2374 5.17678 12.7626 5.17678 12.4697 5.46967L8.46967 9.46967C8.17678 9.76256 8.17678 10.2374 8.46967 10.5303L12.4697 14.5303C12.7626 14.8232 13.2374 14.8232 13.5303 14.5303Z",
        fill: "#4B5563"
    }), $84c750c1d68ab518$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.5 14.75C7.91421 14.75 8.25 14.4142 8.25 14L8.25 6C8.25 5.58579 7.91421 5.25 7.5 5.25C7.08579 5.25 6.75 5.58579 6.75 6L6.75 14C6.75 14.4142 7.08579 14.75 7.5 14.75Z",
        fill: "#4B5563"
    }));
};
module.exports.skip_left = $84c750c1d68ab518$var$skip_left;

});

parcelRegister("ixX97", function(module, exports) {
"use strict";
var $d809303b659e9b6c$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d809303b659e9b6c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.skip_right = void 0;

/* eslint-disable max-len */ const $d809303b659e9b6c$var$react_1 = $d809303b659e9b6c$var$__importDefault((parcelRequire("acw62")));

const $d809303b659e9b6c$var$classnames_1 = $d809303b659e9b6c$var$__importDefault((parcelRequire("8g1PZ")));
const $d809303b659e9b6c$var$skip_right = (_a)=>{
    var { className: className } = _a, rest = $d809303b659e9b6c$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $d809303b659e9b6c$var$classnames_1.default)("helix-icon", "skip-right-outlined", className);
    return $d809303b659e9b6c$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $d809303b659e9b6c$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.96967 5.46967C6.67678 5.76256 6.67678 6.23744 6.96967 6.53033L10.4393 10L6.96967 13.4697C6.67678 13.7626 6.67678 14.2374 6.96967 14.5303C7.26256 14.8232 7.73744 14.8232 8.03033 14.5303L12.0303 10.5303C12.3232 10.2374 12.3232 9.76256 12.0303 9.46967L8.03033 5.46967C7.73744 5.17678 7.26256 5.17678 6.96967 5.46967Z",
        fill: "#4B5563"
    }), $d809303b659e9b6c$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13 5.25C12.5858 5.25 12.25 5.58579 12.25 6L12.25 14C12.25 14.4142 12.5858 14.75 13 14.75C13.4142 14.75 13.75 14.4142 13.75 14L13.75 6C13.75 5.58579 13.4142 5.25 13 5.25Z",
        fill: "#4B5563"
    }));
};
module.exports.skip_right = $d809303b659e9b6c$var$skip_right;

});

parcelRegister("1GVCE", function(module, exports) {
"use strict";
var $13b66946f023c598$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $13b66946f023c598$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.smiley_negative_one = void 0;

/* eslint-disable max-len */ const $13b66946f023c598$var$react_1 = $13b66946f023c598$var$__importDefault((parcelRequire("acw62")));

const $13b66946f023c598$var$classnames_1 = $13b66946f023c598$var$__importDefault((parcelRequire("8g1PZ")));
const $13b66946f023c598$var$smiley_negative_one = (_a)=>{
    var { className: className } = _a, rest = $13b66946f023c598$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $13b66946f023c598$var$classnames_1.default)("helix-icon", "smiley-negative-one-outlined", className);
    return $13b66946f023c598$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $13b66946f023c598$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 17.4523C13.5899 17.4523 16.5 14.5422 16.5 10.9523C16.5 7.36248 13.5898 4.45233 10 4.45233C6.41015 4.45233 3.5 7.36248 3.5 10.9523C3.5 14.5422 6.41015 17.4523 10 17.4523ZM10 18.9523C14.4183 18.9523 18 15.3706 18 10.9523C18 6.53405 14.4183 2.95233 10 2.95233C5.58172 2.95233 2 6.53405 2 10.9523C2 15.3706 5.58172 18.9523 10 18.9523Z",
        fill: "#4B5563"
    }), $13b66946f023c598$var$react_1.default.createElement("path", {
        d: "M8 9.45221C8 10.0045 7.55228 10.4522 7 10.4522C6.44772 10.4522 6 10.0045 6 9.45221C6 8.89993 6.44772 8.45221 7 8.45221C7.55228 8.45221 8 8.89993 8 9.45221Z",
        fill: "#4B5563"
    }), $13b66946f023c598$var$react_1.default.createElement("path", {
        d: "M14 9.45221C14 10.0045 13.5523 10.4522 13 10.4522C12.4477 10.4522 12 10.0045 12 9.45221C12 8.89993 12.4477 8.45221 13 8.45221C13.5523 8.45221 14 8.89993 14 9.45221Z",
        fill: "#4B5563"
    }), $13b66946f023c598$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.4534 14.5175C10.5385 14.06 9.46152 14.06 8.54655 14.5175L8.33541 14.6231C7.96493 14.8083 7.51442 14.6582 7.32918 14.2877C7.14394 13.9172 7.2941 13.4667 7.66459 13.2814L7.87573 13.1759C9.21299 12.5072 10.787 12.5072 12.1243 13.1759L12.3354 13.2814C12.7059 13.4667 12.8561 13.9172 12.6708 14.2877C12.4856 14.6582 12.0351 14.8083 11.6646 14.6231L11.4534 14.5175Z",
        fill: "#4B5563"
    }));
};
module.exports.smiley_negative_one = $13b66946f023c598$var$smiley_negative_one;

});

parcelRegister("hwxl8", function(module, exports) {
"use strict";
var $cc1f496bb5051fa7$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $cc1f496bb5051fa7$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.smiley_negative_two = void 0;

/* eslint-disable max-len */ const $cc1f496bb5051fa7$var$react_1 = $cc1f496bb5051fa7$var$__importDefault((parcelRequire("acw62")));

const $cc1f496bb5051fa7$var$classnames_1 = $cc1f496bb5051fa7$var$__importDefault((parcelRequire("8g1PZ")));
const $cc1f496bb5051fa7$var$smiley_negative_two = (_a)=>{
    var { className: className } = _a, rest = $cc1f496bb5051fa7$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $cc1f496bb5051fa7$var$classnames_1.default)("helix-icon", "smiley-negative-two-outlined", className);
    return $cc1f496bb5051fa7$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $cc1f496bb5051fa7$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 17.4523C13.5899 17.4523 16.5 14.5422 16.5 10.9523C16.5 7.36248 13.5898 4.45233 10 4.45233C6.41015 4.45233 3.5 7.36248 3.5 10.9523C3.5 14.5422 6.41015 17.4523 10 17.4523ZM10 18.9523C14.4183 18.9523 18 15.3706 18 10.9523C18 6.53405 14.4183 2.95233 10 2.95233C5.58172 2.95233 2 6.53405 2 10.9523C2 15.3706 5.58172 18.9523 10 18.9523Z",
        fill: "#4B5563"
    }), $cc1f496bb5051fa7$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.11917 13.2377C8.6184 11.4387 11.3816 11.4386 12.8808 13.2377L13.0762 13.4721C13.2797 13.7164 13.3071 14.0625 13.1445 14.3358C12.9819 14.609 12.6647 14.7501 12.3529 14.6877L11.0296 14.423C10.3499 14.2871 9.65006 14.2871 8.97039 14.423L7.64709 14.6877C7.33528 14.7501 7.01805 14.609 6.85546 14.3358C6.69287 14.0625 6.72027 13.7164 6.92383 13.4721L7.11917 13.2377Z",
        fill: "#4B5563"
    }), $cc1f496bb5051fa7$var$react_1.default.createElement("path", {
        d: "M8.5 8.95227C8.5 9.50455 8.05228 9.95227 7.5 9.95227C6.94771 9.95227 6.5 9.50455 6.5 8.95227C6.5 8.39998 6.94771 7.95227 7.5 7.95227C8.05228 7.95227 8.5 8.39998 8.5 8.95227Z",
        fill: "#4B5563"
    }), $cc1f496bb5051fa7$var$react_1.default.createElement("path", {
        d: "M13.5 8.95227C13.5 9.50455 13.0523 9.95227 12.5 9.95227C11.9477 9.95227 11.5 9.50455 11.5 8.95227C11.5 8.39998 11.9477 7.95227 12.5 7.95227C13.0523 7.95227 13.5 8.39998 13.5 8.95227Z",
        fill: "#4B5563"
    }));
};
module.exports.smiley_negative_two = $cc1f496bb5051fa7$var$smiley_negative_two;

});

parcelRegister("aWf08", function(module, exports) {
"use strict";
var $7f6af51936d336e0$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $7f6af51936d336e0$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.smiley_neutral = void 0;

/* eslint-disable max-len */ const $7f6af51936d336e0$var$react_1 = $7f6af51936d336e0$var$__importDefault((parcelRequire("acw62")));

const $7f6af51936d336e0$var$classnames_1 = $7f6af51936d336e0$var$__importDefault((parcelRequire("8g1PZ")));
const $7f6af51936d336e0$var$smiley_neutral = (_a)=>{
    var { className: className } = _a, rest = $7f6af51936d336e0$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $7f6af51936d336e0$var$classnames_1.default)("helix-icon", "smiley-neutral-outlined", className);
    return $7f6af51936d336e0$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $7f6af51936d336e0$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 17.4523C13.5899 17.4523 16.5 14.5422 16.5 10.9523C16.5 7.36248 13.5898 4.45233 10 4.45233C6.41015 4.45233 3.5 7.36248 3.5 10.9523C3.5 14.5422 6.41015 17.4523 10 17.4523ZM10 18.9523C14.4183 18.9523 18 15.3706 18 10.9523C18 6.53405 14.4183 2.95233 10 2.95233C5.58172 2.95233 2 6.53405 2 10.9523C2 15.3706 5.58172 18.9523 10 18.9523Z",
        fill: "#4B5563"
    }), $7f6af51936d336e0$var$react_1.default.createElement("path", {
        d: "M8 9.45221C8 10.0045 7.55228 10.4522 7 10.4522C6.44772 10.4522 6 10.0045 6 9.45221C6 8.89993 6.44772 8.45221 7 8.45221C7.55228 8.45221 8 8.89993 8 9.45221Z",
        fill: "#4B5563"
    }), $7f6af51936d336e0$var$react_1.default.createElement("path", {
        d: "M14 9.45221C14 10.0045 13.5523 10.4522 13 10.4522C12.4477 10.4522 12 10.0045 12 9.45221C12 8.89993 12.4477 8.45221 13 8.45221C13.5523 8.45221 14 8.89993 14 9.45221Z",
        fill: "#4B5563"
    }), $7f6af51936d336e0$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.75 13.4523C7.75 13.0381 8.08578 12.7023 8.5 12.7023H11.5C11.9142 12.7023 12.25 13.0381 12.25 13.4523C12.25 13.8665 11.9142 14.2023 11.5 14.2023H8.5C8.08578 14.2023 7.75 13.8665 7.75 13.4523Z",
        fill: "#4B5563"
    }));
};
module.exports.smiley_neutral = $7f6af51936d336e0$var$smiley_neutral;

});

parcelRegister("ah7Tz", function(module, exports) {
"use strict";
var $77b19dc4606aebc4$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $77b19dc4606aebc4$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.smiley_positive_one = void 0;

/* eslint-disable max-len */ const $77b19dc4606aebc4$var$react_1 = $77b19dc4606aebc4$var$__importDefault((parcelRequire("acw62")));

const $77b19dc4606aebc4$var$classnames_1 = $77b19dc4606aebc4$var$__importDefault((parcelRequire("8g1PZ")));
const $77b19dc4606aebc4$var$smiley_positive_one = (_a)=>{
    var { className: className } = _a, rest = $77b19dc4606aebc4$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $77b19dc4606aebc4$var$classnames_1.default)("helix-icon", "smiley-positive-one-outlined", className);
    return $77b19dc4606aebc4$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $77b19dc4606aebc4$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 17.4523C13.5899 17.4523 16.5 14.5422 16.5 10.9523C16.5 7.36248 13.5898 4.45233 10 4.45233C6.41015 4.45233 3.5 7.36248 3.5 10.9523C3.5 14.5422 6.41015 17.4523 10 17.4523ZM10 18.9523C14.4183 18.9523 18 15.3706 18 10.9523C18 6.53405 14.4183 2.95233 10 2.95233C5.58172 2.95233 2 6.53405 2 10.9523C2 15.3706 5.58172 18.9523 10 18.9523Z",
        fill: "#4B5563"
    }), $77b19dc4606aebc4$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.7285 12.7065C10.829 13.786 9.17104 13.786 8.2715 12.7065L8.07616 12.4721C7.81099 12.1539 7.33807 12.1109 7.01986 12.3761C6.70165 12.6413 6.65866 13.1142 6.92383 13.4324L7.11917 13.6668C8.6184 15.4659 11.3816 15.4659 12.8808 13.6668L13.0762 13.4324C13.3413 13.1142 13.2983 12.6413 12.9801 12.3761C12.6619 12.1109 12.189 12.1539 11.9238 12.4721L11.7285 12.7065Z",
        fill: "#4B5563"
    }), $77b19dc4606aebc4$var$react_1.default.createElement("path", {
        d: "M8.5 8.95227C8.5 9.50455 8.05228 9.45227 7.5 9.45227C6.94771 9.45227 6.5 9.50455 6.5 8.95227C6.5 8.39998 6.94771 7.95227 7.5 7.95227C8.05228 7.95227 8.5 8.39998 8.5 8.95227Z",
        fill: "#4B5563"
    }), $77b19dc4606aebc4$var$react_1.default.createElement("path", {
        d: "M13.5 8.95227C13.5 9.50455 13.0523 9.45227 12.5 9.45227C11.9477 9.45227 11.5 9.50455 11.5 8.95227C11.5 8.39998 11.9477 7.95227 12.5 7.95227C13.0523 7.95227 13.5 8.39998 13.5 8.95227Z",
        fill: "#4B5563"
    }));
};
module.exports.smiley_positive_one = $77b19dc4606aebc4$var$smiley_positive_one;

});

parcelRegister("5wNJG", function(module, exports) {
"use strict";
var $4066856ce2da4258$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $4066856ce2da4258$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.smiley_positive_two = void 0;

/* eslint-disable max-len */ const $4066856ce2da4258$var$react_1 = $4066856ce2da4258$var$__importDefault((parcelRequire("acw62")));

const $4066856ce2da4258$var$classnames_1 = $4066856ce2da4258$var$__importDefault((parcelRequire("8g1PZ")));
const $4066856ce2da4258$var$smiley_positive_two = (_a)=>{
    var { className: className } = _a, rest = $4066856ce2da4258$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $4066856ce2da4258$var$classnames_1.default)("helix-icon", "smiley-positive-two-outlined", className);
    return $4066856ce2da4258$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $4066856ce2da4258$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 17.4523C13.5899 17.4523 16.5 14.5422 16.5 10.9523C16.5 7.36248 13.5898 4.45233 10 4.45233C6.41015 4.45233 3.5 7.36248 3.5 10.9523C3.5 14.5422 6.41015 17.4523 10 17.4523ZM10 18.9523C14.4183 18.9523 18 15.3706 18 10.9523C18 6.53405 14.4183 2.95233 10 2.95233C5.58172 2.95233 2 6.53405 2 10.9523C2 15.3706 5.58172 18.9523 10 18.9523Z",
        fill: "#4B5563"
    }), $4066856ce2da4258$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.11917 13.6668C8.6184 15.4659 11.3816 15.4659 12.8808 13.6668L13.0762 13.4324C13.2625 13.2088 13.3026 12.8977 13.1792 12.6342C13.0558 12.3706 12.791 12.2023 12.5 12.2023H7.5C7.20899 12.2023 6.94424 12.3706 6.82081 12.6342C6.69737 12.8977 6.73753 13.2088 6.92383 13.4324L7.11917 13.6668Z",
        fill: "#4B5563"
    }), $4066856ce2da4258$var$react_1.default.createElement("path", {
        d: "M8.5 8.95227C8.5 9.50455 8.05228 9.45227 7.5 9.45227C6.94771 9.45227 6.5 9.50455 6.5 8.95227C6.5 8.39998 6.94771 7.95227 7.5 7.95227C8.05228 7.95227 8.5 8.39998 8.5 8.95227Z",
        fill: "#4B5563"
    }), $4066856ce2da4258$var$react_1.default.createElement("path", {
        d: "M13.5 8.95227C13.5 9.50455 13.0523 9.45227 12.5 9.45227C11.9477 9.45227 11.5 9.50455 11.5 8.95227C11.5 8.39998 11.9477 7.95227 12.5 7.95227C13.0523 7.95227 13.5 8.39998 13.5 8.95227Z",
        fill: "#4B5563"
    }));
};
module.exports.smiley_positive_two = $4066856ce2da4258$var$smiley_positive_two;

});

parcelRegister("6jFYP", function(module, exports) {
"use strict";
var $499514cb6b6f99ec$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $499514cb6b6f99ec$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.source = void 0;

/* eslint-disable max-len */ const $499514cb6b6f99ec$var$classnames_1 = $499514cb6b6f99ec$var$__importDefault((parcelRequire("8g1PZ")));

const $499514cb6b6f99ec$var$react_1 = $499514cb6b6f99ec$var$__importDefault((parcelRequire("acw62")));
const $499514cb6b6f99ec$var$source = (_a)=>{
    var { className: className } = _a, rest = $499514cb6b6f99ec$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $499514cb6b6f99ec$var$classnames_1.default)("helix-icon", "source-outlined", className);
    return $499514cb6b6f99ec$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "21",
        viewBox: "0 0 20 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, rest), $499514cb6b6f99ec$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 7.20227C10.4142 7.20227 10.75 7.53806 10.75 7.95227L10.75 14.9523C10.75 15.3665 10.4142 15.7023 10 15.7023C9.58579 15.7023 9.25 15.3665 9.25 14.9523L9.25 7.95227C9.25 7.53806 9.58579 7.20227 10 7.20227Z",
        fill: "#4B5563"
    }), $499514cb6b6f99ec$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.75 10.9523C4.75 11.0903 4.86193 11.2023 5 11.2023L15 11.2023C15.1381 11.2023 15.25 11.0903 15.25 10.9523L15.25 7.95227C15.25 7.53806 15.5858 7.20227 16 7.20227C16.4142 7.20227 16.75 7.53806 16.75 7.95227L16.75 10.9523C16.75 11.9188 15.9665 12.7023 15 12.7023L5 12.7023C4.0335 12.7023 3.25 11.9188 3.25 10.9523L3.25 7.95227C3.25 7.53806 3.58579 7.20227 4 7.20227C4.41421 7.20227 4.75 7.53806 4.75 7.95227L4.75 10.9523Z",
        fill: "#4B5563"
    }), $499514cb6b6f99ec$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 15.7023C9.58579 15.7023 9.25 16.0381 9.25 16.4523C9.25 16.8665 9.58579 17.2023 10 17.2023C10.4142 17.2023 10.75 16.8665 10.75 16.4523C10.75 16.0381 10.4142 15.7023 10 15.7023ZM7.75 16.4523C7.75 15.2096 8.75736 14.2023 10 14.2023C11.2426 14.2023 12.25 15.2096 12.25 16.4523C12.25 17.6949 11.2426 18.7023 10 18.7023C8.75736 18.7023 7.75 17.6949 7.75 16.4523Z",
        fill: "#4B5563"
    }), $499514cb6b6f99ec$var$react_1.default.createElement("path", {
        d: "M12 5.95227C12 7.05684 11.1046 7.95227 10 7.95227C8.89543 7.95227 8 7.05684 8 5.95227C8 4.8477 8.89543 3.95227 10 3.95227C11.1046 3.95227 12 4.8477 12 5.95227Z",
        fill: "#4B5563"
    }), $499514cb6b6f99ec$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 6.45227C10.2761 6.45227 10.5 6.22841 10.5 5.95227C10.5 5.67613 10.2761 5.45227 10 5.45227C9.72386 5.45227 9.5 5.67613 9.5 5.95227C9.5 6.22841 9.72386 6.45227 10 6.45227ZM10 7.95227C11.1046 7.95227 12 7.05684 12 5.95227C12 4.8477 11.1046 3.95227 10 3.95227C8.89543 3.95227 8 4.8477 8 5.95227C8 7.05684 8.89543 7.95227 10 7.95227Z",
        fill: "#4B5563"
    }), $499514cb6b6f99ec$var$react_1.default.createElement("path", {
        d: "M6 5.95227C6 7.05684 5.10457 7.95227 4 7.95227C2.89543 7.95227 2 7.05684 2 5.95227C2 4.8477 2.89543 3.95227 4 3.95227C5.10457 3.95227 6 4.8477 6 5.95227Z",
        fill: "#4B5563"
    }), $499514cb6b6f99ec$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4 6.45227C4.27614 6.45227 4.5 6.22841 4.5 5.95227C4.5 5.67613 4.27614 5.45227 4 5.45227C3.72386 5.45227 3.5 5.67613 3.5 5.95227C3.5 6.22841 3.72386 6.45227 4 6.45227ZM4 7.95227C5.10457 7.95227 6 7.05684 6 5.95227C6 4.8477 5.10457 3.95227 4 3.95227C2.89543 3.95227 2 4.8477 2 5.95227C2 7.05684 2.89543 7.95227 4 7.95227Z",
        fill: "#4B5563"
    }), $499514cb6b6f99ec$var$react_1.default.createElement("path", {
        d: "M18 5.95227C18 7.05684 17.1046 7.95227 16 7.95227C14.8954 7.95227 14 7.05684 14 5.95227C14 4.8477 14.8954 3.95227 16 3.95227C17.1046 3.95227 18 4.8477 18 5.95227Z",
        fill: "#4B5563"
    }), $499514cb6b6f99ec$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 6.45227C16.2761 6.45227 16.5 6.22841 16.5 5.95227C16.5 5.67613 16.2761 5.45227 16 5.45227C15.7239 5.45227 15.5 5.67613 15.5 5.95227C15.5 6.22841 15.7239 6.45227 16 6.45227ZM16 7.95227C17.1046 7.95227 18 7.05684 18 5.95227C18 4.8477 17.1046 3.95227 16 3.95227C14.8954 3.95227 14 4.8477 14 5.95227C14 7.05684 14.8954 7.95227 16 7.95227Z",
        fill: "#4B5563"
    }));
};
module.exports.source = $499514cb6b6f99ec$var$source;

});

parcelRegister("hlhZO", function(module, exports) {
"use strict";
var $ca025b76da289a56$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $ca025b76da289a56$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sparkle = void 0;

/* eslint-disable max-len */ const $ca025b76da289a56$var$react_1 = $ca025b76da289a56$var$__importDefault((parcelRequire("acw62")));

const $ca025b76da289a56$var$classnames_1 = $ca025b76da289a56$var$__importDefault((parcelRequire("8g1PZ")));
const $ca025b76da289a56$var$sparkle = (_a)=>{
    var { className: className } = _a, rest = $ca025b76da289a56$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $ca025b76da289a56$var$classnames_1.default)("helix-icon", "sparkle-outlined", className);
    return $ca025b76da289a56$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $ca025b76da289a56$var$react_1.default.createElement("path", {
        d: "M5.4762 9.73657C5.54456 9.73657 5.60608 9.68188 5.61292 9.55884C5.81116 7.3645 5.98889 7.07056 7.43127 6.89282C7.56116 6.87915 7.59534 6.81763 7.59534 6.74927C7.59534 6.6604 7.55432 6.60571 7.4176 6.58521C5.98206 6.40747 5.81116 6.09985 5.61292 4.13794C5.59924 4.01489 5.53772 3.97388 5.4762 3.97388C5.39417 3.97388 5.33264 4.01489 5.31897 4.14478C5.12073 6.10669 4.94983 6.40747 3.52112 6.58521C3.3844 6.60571 3.34338 6.6604 3.34338 6.74927C3.34338 6.81763 3.3844 6.87915 3.50745 6.89282C4.93616 7.07056 5.12073 7.35767 5.31897 9.55884C5.33264 9.68188 5.39417 9.73657 5.4762 9.73657ZM11.7379 16.3538C11.8268 16.3538 11.902 16.3059 11.9225 16.1624C12.4625 11.384 12.9547 10.8987 16.4342 10.3586C16.5778 10.3381 16.6393 10.2698 16.6393 10.1809C16.6393 10.0852 16.5778 10.0237 16.4274 10.0032C12.9547 9.47681 12.4625 8.97778 11.8883 4.65747C11.861 4.50024 11.8063 4.43872 11.7037 4.43872C11.6149 4.43872 11.5397 4.50024 11.526 4.6438C10.9928 8.97095 10.4596 9.46997 6.9801 10.0032C6.82971 10.0237 6.77502 10.0852 6.77502 10.1809C6.77502 10.2698 6.82971 10.3381 6.97327 10.3586C10.4596 10.8987 10.986 11.3772 11.5602 16.1624C11.5739 16.2991 11.649 16.3538 11.7379 16.3538ZM7.54065 17.0305C7.62268 17.0305 7.67053 16.9622 7.6842 16.8459C7.88245 14.6516 8.05334 14.3577 9.49573 14.1799C9.61877 14.1663 9.66663 14.1116 9.66663 14.0364C9.66663 13.9612 9.63245 13.8928 9.49573 13.8792C8.06702 13.6946 7.88245 13.4211 7.6842 11.425C7.67053 11.3088 7.60901 11.2678 7.54065 11.2678C7.45862 11.2678 7.40393 11.302 7.39026 11.4319C7.19202 13.4075 7.01428 13.6946 5.5719 13.8792C5.45569 13.8928 5.40784 13.9543 5.40784 14.0364C5.40784 14.1116 5.45569 14.1663 5.5719 14.1799C7.00745 14.3577 7.19202 14.6516 7.39026 16.8459C7.39709 16.969 7.45862 17.0305 7.54065 17.0305Z",
        fill: "#4B5563"
    }));
};
module.exports.sparkle = $ca025b76da289a56$var$sparkle;

});

parcelRegister("7J7Wa", function(module, exports) {
"use strict";
var $5a02e48542d82fc7$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $5a02e48542d82fc7$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.spinner = void 0;

const $5a02e48542d82fc7$var$react_1 = $5a02e48542d82fc7$var$__importDefault((parcelRequire("acw62")));

const $5a02e48542d82fc7$var$classnames_1 = $5a02e48542d82fc7$var$__importDefault((parcelRequire("8g1PZ")));
const $5a02e48542d82fc7$var$spinner = (_a)=>{
    var { className: className } = _a, rest = $5a02e48542d82fc7$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $5a02e48542d82fc7$var$classnames_1.default)("helix-icon", "spinner-outlined", className);
    return $5a02e48542d82fc7$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $5a02e48542d82fc7$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        // eslint-disable-next-line max-len
        d: "M10.7501 17C10.7501 17.4142 10.4143 17.75 10.0001 17.75C5.71987 17.75 2.25008 14.2802 2.25008 10C2.25008 5.71979 5.71987 2.25 10.0001 2.25C14.2803 2.25 17.7501 5.71979 17.7501 10C17.7501 10.4142 17.4143 10.75 17.0001 10.75C16.5859 10.75 16.2501 10.4142 16.2501 10C16.2501 6.54822 13.4519 3.75 10.0001 3.75C6.5483 3.75 3.75008 6.54822 3.75008 10C3.75008 13.4518 6.5483 16.25 10.0001 16.25C10.4143 16.25 10.7501 16.5858 10.7501 17Z",
        fill: "#4B5563"
    }));
};
module.exports.spinner = $5a02e48542d82fc7$var$spinner;

});

parcelRegister("9oj5b", function(module, exports) {
"use strict";
var $6d652854c7db93aa$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $6d652854c7db93aa$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.split = void 0;

/* eslint-disable max-len */ const $6d652854c7db93aa$var$react_1 = $6d652854c7db93aa$var$__importDefault((parcelRequire("acw62")));

const $6d652854c7db93aa$var$classnames_1 = $6d652854c7db93aa$var$__importDefault((parcelRequire("8g1PZ")));
const $6d652854c7db93aa$var$split = (_a)=>{
    var { className: className } = _a, rest = $6d652854c7db93aa$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $6d652854c7db93aa$var$classnames_1.default)("helix-icon", "split-outlined", className);
    return $6d652854c7db93aa$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $6d652854c7db93aa$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.75 15.9523C16.75 16.3665 16.4142 16.7023 16 16.7023L10.5 16.7023C9.5335 16.7023 8.75 15.9188 8.75 14.9523L8.74999 6.95227C8.74999 5.98577 9.5335 5.20227 10.5 5.20227L16 5.20227C16.4142 5.20227 16.75 5.53806 16.75 5.95227C16.75 6.36648 16.4142 6.70227 16 6.70227L10.5 6.70227C10.3619 6.70227 10.25 6.8142 10.25 6.95227L10.25 14.9523C10.25 15.0903 10.3619 15.2023 10.5 15.2023L16 15.2023C16.4142 15.2023 16.75 15.5381 16.75 15.9523Z",
        fill: "#4B5563"
    }), $6d652854c7db93aa$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.5315 3.36662C14.8549 3.10786 15.3269 3.1603 15.5857 3.48375L17.1857 5.48375C17.4048 5.75766 17.4048 6.14687 17.1857 6.42079L15.5857 8.42079C15.3269 8.74424 14.8549 8.79668 14.5315 8.53792C14.208 8.27916 14.1556 7.80719 14.4143 7.48375L15.6395 5.95227L14.4143 4.42079C14.1556 4.09734 14.208 3.62537 14.5315 3.36662Z",
        fill: "#4B5563"
    }), $6d652854c7db93aa$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.5315 13.3666C14.8549 13.1079 15.3269 13.1603 15.5857 13.4837L17.1857 15.4837C17.4048 15.7577 17.4048 16.1469 17.1857 16.4208L15.5857 18.4208C15.3269 18.7442 14.8549 18.7967 14.5315 18.5379C14.208 18.2792 14.1556 17.8072 14.4143 17.4837L15.6395 15.9523L14.4143 14.4208C14.1556 14.0973 14.208 13.6254 14.5315 13.3666Z",
        fill: "#4B5563"
    }), $6d652854c7db93aa$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.25 10.9523C2.25 10.5381 2.58579 10.2023 3 10.2023H9C9.41421 10.2023 9.75 10.5381 9.75 10.9523C9.75 11.3665 9.41421 11.7023 9 11.7023H3C2.58579 11.7023 2.25 11.3665 2.25 10.9523Z",
        fill: "#4B5563"
    }));
};
module.exports.split = $6d652854c7db93aa$var$split;

});

parcelRegister("39yPo", function(module, exports) {
"use strict";
var $24bd3a75c14f7ba6$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $24bd3a75c14f7ba6$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.stamp = void 0;

/* eslint-disable max-len */ const $24bd3a75c14f7ba6$var$react_1 = $24bd3a75c14f7ba6$var$__importDefault((parcelRequire("acw62")));

const $24bd3a75c14f7ba6$var$classnames_1 = $24bd3a75c14f7ba6$var$__importDefault((parcelRequire("8g1PZ")));
const $24bd3a75c14f7ba6$var$stamp = (_a)=>{
    var { className: className } = _a, rest = $24bd3a75c14f7ba6$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $24bd3a75c14f7ba6$var$classnames_1.default)("helix-icon", "stamp-outlined", className);
    return $24bd3a75c14f7ba6$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $24bd3a75c14f7ba6$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.9593 10.0979C12.6818 9.19601 12.5713 8.24881 12.6355 7.30317L12.6671 6.83915C12.7702 5.32125 11.8905 3.90763 10.4832 3.32977L10.426 3.30628C8.20969 2.39629 5.67537 3.45523 4.76538 5.67149L4.74189 5.72869C4.16402 7.13608 4.55157 8.75533 5.70399 9.7486L6.05629 10.0522C6.77424 10.671 7.37049 11.4153 7.81711 12.2465L7.09121 12.5498C5.03493 13.409 4.33358 15.9718 5.66584 17.7583C6.03717 18.2563 6.64862 18.4932 7.24141 18.3982C7.24043 18.497 7.25905 18.5976 7.29955 18.6945C7.45925 19.0767 7.89853 19.257 8.28072 19.0973L17.5076 15.242C17.8898 15.0823 18.0702 14.643 17.9105 14.2608C17.87 14.1639 17.8115 14.0799 17.7406 14.0112C18.2247 13.6562 18.4858 13.0547 18.3925 12.4406C18.0577 10.2374 15.7415 8.93536 13.6852 9.79455L12.9593 10.0979ZM7.03558 8.91603C8.12005 9.85073 8.97201 11.0251 9.52398 12.3461C9.52398 12.3461 9.52398 12.3461 9.52398 12.3461C9.68368 12.7283 9.50331 13.1676 9.12112 13.3273L7.66951 13.9338C6.51365 14.4168 6.11941 15.8574 6.86829 16.8616C6.90721 16.9138 6.97663 16.9328 7.03669 16.9077L16.824 12.8182C16.8841 12.7931 16.9193 12.7303 16.9095 12.666C16.7213 11.4275 15.4194 10.6956 14.2635 11.1786L12.8119 11.7851C12.4297 11.9448 11.9904 11.7645 11.8307 11.3823C11.8307 11.3823 11.8307 11.3823 11.8307 11.3823C11.2787 10.0612 11.0419 8.62986 11.139 7.20146L11.1705 6.73744C11.2299 5.8637 10.7235 5.04999 9.91341 4.71735L9.85621 4.69387C8.4063 4.09854 6.7483 4.79131 6.15296 6.24123L6.12948 6.29843C5.79684 7.10855 6.01992 8.04064 6.68329 8.61239L7.03558 8.91603Z",
        fill: "#4B5563"
    }));
};
module.exports.stamp = $24bd3a75c14f7ba6$var$stamp;

});

parcelRegister("fBXWV", function(module, exports) {
"use strict";
var $b5d8d06c004cce10$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $b5d8d06c004cce10$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.star = void 0;

const $b5d8d06c004cce10$var$react_1 = $b5d8d06c004cce10$var$__importDefault((parcelRequire("acw62")));

const $b5d8d06c004cce10$var$classnames_1 = $b5d8d06c004cce10$var$__importDefault((parcelRequire("8g1PZ")));
const $b5d8d06c004cce10$var$star = (_a)=>{
    var { className: className } = _a, rest = $b5d8d06c004cce10$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $b5d8d06c004cce10$var$classnames_1.default)("helix-icon", "star-outlined", className);
    return $b5d8d06c004cce10$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $b5d8d06c004cce10$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        // eslint-disable-next-line max-len
        d: "M10 1.75C10.2855 1.75 10.5462 1.91207 10.6726 2.16808L12.8492 6.57843L17.7163 7.28566C17.9988 7.32671 18.2335 7.52459 18.3217 7.7961C18.41 8.06761 18.3364 8.36566 18.132 8.56493L14.6101 11.9979L15.4415 16.8454C15.4897 17.1267 15.3741 17.4111 15.1431 17.5789C14.9122 17.7467 14.606 17.7688 14.3533 17.636L10 15.3473L5.64672 17.636C5.39403 17.7688 5.08784 17.7467 4.85688 17.5789C4.62592 17.4111 4.51025 17.1267 4.55851 16.8454L5.38991 11.9979L1.86804 8.56493C1.66361 8.36566 1.59004 8.06761 1.67825 7.7961C1.76647 7.52459 2.00118 7.32671 2.2837 7.28566L7.15081 6.57843L9.32745 2.16808C9.45379 1.91207 9.71452 1.75 10 1.75ZM10 4.19466L8.32141 7.59586C8.21216 7.81721 8.00099 7.97064 7.75671 8.00614L4.00327 8.55154L6.71928 11.199C6.89605 11.3713 6.97671 11.6196 6.93498 11.8629L6.29382 15.6011L9.65099 13.8362C9.86949 13.7213 10.1305 13.7213 10.349 13.8362L13.7062 15.6011L13.065 11.8629C13.0233 11.6196 13.104 11.3713 13.2807 11.199L15.9967 8.55154L12.2433 8.00614C11.999 7.97064 11.7878 7.81721 11.6786 7.59586L10 4.19466Z",
        fill: "#4B5563"
    }));
};
module.exports.star = $b5d8d06c004cce10$var$star;

});

parcelRegister("peqr9", function(module, exports) {
"use strict";
var $04bd867f979c6a3f$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $04bd867f979c6a3f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.star_rising = void 0;

/* eslint-disable max-len */ const $04bd867f979c6a3f$var$react_1 = $04bd867f979c6a3f$var$__importDefault((parcelRequire("acw62")));

const $04bd867f979c6a3f$var$classnames_1 = $04bd867f979c6a3f$var$__importDefault((parcelRequire("8g1PZ")));
const $04bd867f979c6a3f$var$star_rising = (_a)=>{
    var { className: className } = _a, rest = $04bd867f979c6a3f$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $04bd867f979c6a3f$var$classnames_1.default)("helix-icon", "star-rising-solid", className);
    return $04bd867f979c6a3f$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $04bd867f979c6a3f$var$react_1.default.createElement("path", {
        d: "M9.31242 3.02039C9.52885 2.32654 10.4712 2.32654 10.6876 3.02039L11.1362 4.45871C11.233 4.76901 11.5106 4.9791 11.8238 4.9791H13.2757C13.976 4.9791 14.2672 5.91267 13.7006 6.34149L12.5261 7.23042C12.2727 7.4222 12.1666 7.76213 12.2634 8.07243L12.7121 9.51075C12.9285 10.2046 12.1661 10.7816 11.5995 10.3528L10.425 9.46382C10.1716 9.27205 9.82845 9.27205 9.57506 9.46382L8.40051 10.3528C7.8339 10.7816 7.07154 10.2046 7.28797 9.51075L7.7366 8.07243C7.83339 7.76213 7.72736 7.4222 7.47397 7.23042L6.29942 6.34149C5.73281 5.91267 6.02401 4.9791 6.72437 4.9791H8.17619C8.48941 4.9791 8.767 4.76901 8.86378 4.45871L9.31242 3.02039Z",
        fill: "#4B5563"
    }), $04bd867f979c6a3f$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.6646 11.8292C13.0351 11.6439 13.4856 11.7941 13.6708 12.1646L15.6708 16.1646C15.8561 16.5351 15.7059 16.9856 15.3354 17.1708C14.9649 17.3561 14.5144 17.2059 14.3292 16.8354L12.3292 12.8354C12.1439 12.4649 12.2941 12.0144 12.6646 11.8292Z",
        fill: "#4B5563"
    }), $04bd867f979c6a3f$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.33542 11.8292C6.96494 11.6439 6.51443 11.7941 6.32919 12.1646L4.32919 16.1646C4.14395 16.5351 4.29412 16.9856 4.6646 17.1708C5.03509 17.3561 5.48559 17.2059 5.67083 16.8354L7.67083 12.8354C7.85607 12.4649 7.70591 12.0144 7.33542 11.8292Z",
        fill: "#4B5563"
    }), $04bd867f979c6a3f$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 11.75C10.4142 11.75 10.75 12.0858 10.75 12.5V17C10.75 17.4142 10.4142 17.75 10 17.75C9.5858 17.75 9.25001 17.4142 9.25001 17V12.5C9.25001 12.0858 9.5858 11.75 10 11.75Z",
        fill: "#4B5563"
    }));
};
module.exports.star_rising = $04bd867f979c6a3f$var$star_rising;

});

parcelRegister("BBebc", function(module, exports) {
"use strict";
var $07105576538e01a4$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $07105576538e01a4$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.status = void 0;

/* eslint-disable max-len */ const $07105576538e01a4$var$react_1 = $07105576538e01a4$var$__importDefault((parcelRequire("acw62")));

const $07105576538e01a4$var$classnames_1 = $07105576538e01a4$var$__importDefault((parcelRequire("8g1PZ")));
const $07105576538e01a4$var$status = (_a)=>{
    var { className: className } = _a, rest = $07105576538e01a4$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $07105576538e01a4$var$classnames_1.default)("helix-icon", "status-outlined", className);
    return $07105576538e01a4$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $07105576538e01a4$var$react_1.default.createElement("path", {
        d: "M10 6C11.3261 6 12.5979 6.52678 13.5355 7.46447C14.4732 8.40215 15 9.67392 15 11C15 12.3261 14.4732 13.5978 13.5355 14.5355C12.5979 15.4732 11.3261 16 10 16L10 6Z",
        fill: "#4B5563"
    }), $07105576538e01a4$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.5 11C18.5 15.6944 14.6944 19.5 10 19.5C5.30558 19.5 1.5 15.6944 1.5 11C1.5 6.30558 5.30558 2.5 10 2.5C14.6944 2.5 18.5 6.30558 18.5 11ZM10 18C13.866 18 17 14.866 17 11C17 7.13401 13.866 4 10 4C6.13401 4 3 7.13401 3 11C3 14.866 6.13401 18 10 18Z",
        fill: "#4B5563"
    }));
};
module.exports.status = $07105576538e01a4$var$status;

});

parcelRegister("gI7A8", function(module, exports) {
"use strict";
var $c2a6a2fa881d5547$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $c2a6a2fa881d5547$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sticky_note = void 0;

/* eslint-disable max-len */ const $c2a6a2fa881d5547$var$react_1 = $c2a6a2fa881d5547$var$__importDefault((parcelRequire("acw62")));

const $c2a6a2fa881d5547$var$classnames_1 = $c2a6a2fa881d5547$var$__importDefault((parcelRequire("8g1PZ")));
const $c2a6a2fa881d5547$var$sticky_note = (_a)=>{
    var { className: className } = _a, rest = $c2a6a2fa881d5547$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $c2a6a2fa881d5547$var$classnames_1.default)("helix-icon", "sticky-note-outlined", className);
    return $c2a6a2fa881d5547$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $c2a6a2fa881d5547$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.75 5.70233V16.2023H11.25V12.9523C11.25 12.5381 11.5858 12.2023 12 12.2023H15.25V5.70227L4.75 5.70233ZM15.1893 13.7023H12.75V16.1416L15.1893 13.7023ZM4 4.20233L16 4.20227C16.1989 4.20227 16.3897 4.28129 16.5303 4.42194C16.671 4.56259 16.75 4.75336 16.75 4.95227V13.9523C16.75 14.1512 16.671 14.3419 16.5303 14.4826L13.5303 17.4826C13.3897 17.6233 13.1989 17.7023 13 17.7023H4C3.58579 17.7023 3.25 17.3665 3.25 16.9523V4.95233C3.25 4.53812 3.58578 4.20234 4 4.20233Z",
        fill: "#4B5563"
    }));
};
module.exports.sticky_note = $c2a6a2fa881d5547$var$sticky_note;

});

parcelRegister("jCNve", function(module, exports) {
"use strict";
var $e497f721e6ef1c42$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $e497f721e6ef1c42$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.store = void 0;

const $e497f721e6ef1c42$var$react_1 = $e497f721e6ef1c42$var$__importDefault((parcelRequire("acw62")));

const $e497f721e6ef1c42$var$classnames_1 = $e497f721e6ef1c42$var$__importDefault((parcelRequire("8g1PZ")));
const $e497f721e6ef1c42$var$store = (_a)=>{
    var { className: className } = _a, rest = $e497f721e6ef1c42$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $e497f721e6ef1c42$var$classnames_1.default)("helix-icon", "store-outlined", className);
    return $e497f721e6ef1c42$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e497f721e6ef1c42$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        // eslint-disable-next-line max-len
        d: "M5.0528 4.21738C5.34923 3.6245 5.95519 3.25 6.61804 3.25H13.382C14.0448 3.25 14.6508 3.6245 14.9472 4.21738L16.5623 7.44751C16.5895 7.50202 16.6107 7.5574 16.6262 7.61305C16.7045 7.73542 16.75 7.88092 16.75 8.03704V9.5C16.75 10.2801 16.353 10.9675 15.75 11.3711V15C15.75 15.9665 14.9665 16.75 14 16.75H6C5.0335 16.75 4.25 15.9665 4.25 15V11.3711C3.64701 10.9675 3.25 10.2801 3.25 9.5V8.03704C3.25 7.8809 3.29547 7.73538 3.37388 7.613C3.38933 7.55737 3.41048 7.502 3.43773 7.44751L5.0528 4.21738ZM13.75 8.75H15.25V9.5C15.25 9.91421 14.9142 10.25 14.5 10.25C14.0858 10.25 13.75 9.91421 13.75 9.5V8.75ZM14.25 11.7363C13.7723 11.6835 13.3397 11.4811 13 11.1771C12.6019 11.5334 12.0763 11.75 11.5 11.75C10.9237 11.75 10.3981 11.5334 10 11.1771C9.60193 11.5334 9.07627 11.75 8.5 11.75C7.92373 11.75 7.39807 11.5334 7 11.1771C6.66031 11.4811 6.22769 11.6835 5.75 11.7363V15C5.75 15.1381 5.86193 15.25 6 15.25H9V12.75C9 12.6119 9.11193 12.5 9.25 12.5H10.75C10.8881 12.5 11 12.6119 11 12.75V15.25H14C14.1381 15.25 14.25 15.1381 14.25 15V11.7363ZM9.25 8.75V9.5C9.25 9.91421 8.91421 10.25 8.5 10.25C8.08579 10.25 7.75 9.91421 7.75 9.5V8.75H9.25ZM5.21353 7.25L6.39444 4.8882C6.43678 4.8035 6.52335 4.75 6.61804 4.75H13.382C13.4767 4.75 13.5632 4.8035 13.6056 4.8882L14.7865 7.25H5.21353ZM11.5 10.25C11.0858 10.25 10.75 9.91421 10.75 9.5V8.75H12.25V9.5C12.25 9.91421 11.9142 10.25 11.5 10.25ZM6.25 8.75H4.75V9.5C4.75 9.91421 5.08579 10.25 5.5 10.25C5.91421 10.25 6.25 9.91421 6.25 9.5V8.75Z",
        fill: "#4B5563"
    }));
};
module.exports.store = $e497f721e6ef1c42$var$store;

});

parcelRegister("3xmho", function(module, exports) {
"use strict";
var $2935bc68091ce89a$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $2935bc68091ce89a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.string_range = void 0;

/* eslint-disable max-len */ const $2935bc68091ce89a$var$react_1 = $2935bc68091ce89a$var$__importDefault((parcelRequire("acw62")));

const $2935bc68091ce89a$var$classnames_1 = $2935bc68091ce89a$var$__importDefault((parcelRequire("8g1PZ")));
const $2935bc68091ce89a$var$string_range = (_a)=>{
    var { className: className } = _a, rest = $2935bc68091ce89a$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $2935bc68091ce89a$var$classnames_1.default)("helix-icon", "string-range-outlined", className);
    return $2935bc68091ce89a$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $2935bc68091ce89a$var$react_1.default.createElement("path", {
        d: "M7.5 8.99817L7.67578 7.95227H12.6035L12.4277 8.99817H10.5908L9.77051 13.9523H8.5166L9.33691 8.99817H7.5Z",
        fill: "#4B5563"
    }), $2935bc68091ce89a$var$react_1.default.createElement("path", {
        d: "M3.5 7.95227C3.5 7.53806 3.16421 7.20227 2.75 7.20227C2.33579 7.20227 2 7.53806 2 7.95227V13.9523C2 14.3665 2.33579 14.7023 2.75 14.7023C3.16421 14.7023 3.5 14.3665 3.5 13.9523L3.5 7.95227Z",
        fill: "#4B5563"
    }), $2935bc68091ce89a$var$react_1.default.createElement("path", {
        d: "M17.5 7.95227C17.5 7.53806 17.1642 7.20227 16.75 7.20227C16.3358 7.20227 16 7.53806 16 7.95227V13.9523C16 14.3665 16.3358 14.7023 16.75 14.7023C17.1642 14.7023 17.5 14.3665 17.5 13.9523V7.95227Z",
        fill: "#4B5563"
    }), $2935bc68091ce89a$var$react_1.default.createElement("path", {
        d: "M6.75 10.2023H2.75C2.33579 10.2023 2 10.5381 2 10.9523C2 11.3665 2.33579 11.7023 2.75 11.7023H6.75V10.2023Z",
        fill: "#4B5563"
    }), $2935bc68091ce89a$var$react_1.default.createElement("path", {
        d: "M12.75 11.7023H16.75C17.1642 11.7023 17.5 11.3665 17.5 10.9523C17.5 10.5381 17.1642 10.2023 16.75 10.2023H12.75V11.7023Z",
        fill: "#4B5563"
    }));
};
module.exports.string_range = $2935bc68091ce89a$var$string_range;

});

parcelRegister("1WLRK", function(module, exports) {
"use strict";
var $16b0566bc296fb58$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $16b0566bc296fb58$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.tags = void 0;

/* eslint-disable max-len */ const $16b0566bc296fb58$var$classnames_1 = $16b0566bc296fb58$var$__importDefault((parcelRequire("8g1PZ")));

const $16b0566bc296fb58$var$react_1 = $16b0566bc296fb58$var$__importDefault((parcelRequire("acw62")));
const $16b0566bc296fb58$var$tags = (_a)=>{
    var { className: className } = _a, rest = $16b0566bc296fb58$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $16b0566bc296fb58$var$classnames_1.default)("helix-icon", "tags-outlined", className);
    return $16b0566bc296fb58$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $16b0566bc296fb58$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.65685 5.51178C9.59278 5.51178 9.52993 5.5374 9.48251 5.58526L4.82565 10.2851C4.72478 10.3869 4.72478 10.5547 4.82565 10.6565L9.06829 14.9383C9.16538 15.0363 9.3199 15.0363 9.41699 14.9383L9.42263 14.9326L14.1762 10.2366C14.2227 10.1887 14.25 10.1228 14.25 10.0528V5.771C14.25 5.62133 14.1316 5.51178 14 5.51178H9.65685ZM8.41699 4.52948C8.74464 4.19881 9.19049 4.01178 9.65685 4.01178H14C14.973 4.01178 15.75 4.80592 15.75 5.771V10.0528C15.75 10.5171 15.5673 10.9638 15.2399 11.2943L15.2342 11.3L10.4793 15.9973C9.79508 16.6843 8.68568 16.6833 8.00278 15.9941L3.76013 11.7123C3.07996 11.0259 3.07996 9.91573 3.76013 9.22928L8.41699 4.52948Z",
        fill: "#4B5563"
    }), $16b0566bc296fb58$var$react_1.default.createElement("path", {
        d: "M12.7782 8.29728C12.3877 8.68781 11.7545 8.68781 11.364 8.29728C10.9734 7.90676 10.9734 7.2736 11.364 6.88307C11.7545 6.49255 12.3877 6.49255 12.7782 6.88307C13.1687 7.2736 13.1687 7.90676 12.7782 8.29728Z",
        fill: "#4B5563"
    }), $16b0566bc296fb58$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.25 7.771C15.25 7.62133 15.1316 7.51178 15 7.51178V6.01178C15.973 6.01178 16.75 6.80592 16.75 7.771V12.0528C16.75 12.5171 16.5673 12.9638 16.2399 13.2943L16.2342 13.3L11.4793 17.9974C10.795 18.6843 9.68566 18.6833 9.00278 17.9941L4.76013 13.7123C4.07996 13.0259 4.07996 11.9157 4.76013 11.2293L5.82565 12.2851C5.72478 12.3869 5.72478 12.5547 5.82565 12.6565L10.0683 16.9383C10.1654 17.0363 10.3199 17.0363 10.417 16.9383L10.4226 16.9326L15.1762 12.2366C15.2227 12.1887 15.25 12.1228 15.25 12.0528V7.771Z",
        fill: "#4B5563"
    }));
};
module.exports.tags = $16b0566bc296fb58$var$tags;

});

parcelRegister("2qIwW", function(module, exports) {
"use strict";
var $1c508d4a0b9f795b$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $1c508d4a0b9f795b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.tbd = void 0;

/* eslint-disable max-len */ const $1c508d4a0b9f795b$var$react_1 = $1c508d4a0b9f795b$var$__importDefault((parcelRequire("acw62")));

const $1c508d4a0b9f795b$var$classnames_1 = $1c508d4a0b9f795b$var$__importDefault((parcelRequire("8g1PZ")));
const $1c508d4a0b9f795b$var$tbd = (_a)=>{
    var { className: className } = _a, rest = $1c508d4a0b9f795b$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $1c508d4a0b9f795b$var$classnames_1.default)("helix-icon", "title-outlined", className);
    return $1c508d4a0b9f795b$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $1c508d4a0b9f795b$var$react_1.default.createElement("path", {
        d: "M7.32949 17.8788L8.26792 16.9404L4.55768 13.2302L5.90319 11.8847L5.12945 11.1109L1.5 14.7404L2.27374 15.5141L3.61925 14.1686L7.32949 17.8788Z",
        fill: "#4B5563"
    }), $1c508d4a0b9f795b$var$react_1.default.createElement("path", {
        d: "M10.9123 14.296L12.4567 12.7516C12.7778 12.4305 13.0015 12.1032 13.1279 11.7697C13.2543 11.432 13.2843 11.1057 13.218 10.7908C13.1517 10.4718 12.9881 10.1818 12.727 9.92077L12.7208 9.91456C12.5302 9.72397 12.3127 9.59553 12.0683 9.52924C11.8259 9.46088 11.5783 9.4557 11.3256 9.5137C11.0749 9.56964 10.8429 9.68979 10.6296 9.87416L10.5736 9.81823C10.7041 9.64214 10.7849 9.44741 10.816 9.23404C10.8471 9.02066 10.8295 8.8104 10.7632 8.60324C10.6989 8.394 10.5881 8.21067 10.4307 8.05323L10.4245 8.04701C10.1945 7.81706 9.94074 7.67516 9.66315 7.6213C9.38555 7.56329 9.09864 7.59333 8.8024 7.71141C8.50616 7.82535 8.21199 8.02837 7.91989 8.32046L6.42834 9.81202L7.1244 10.5081L8.37668 9.25579C8.60042 9.03206 8.82518 8.91087 9.05099 8.89222C9.27679 8.86944 9.48085 8.94919 9.66315 9.13149L9.66936 9.13771C9.85374 9.32208 9.92935 9.53235 9.8962 9.76851C9.86306 10.0047 9.72012 10.2491 9.46738 10.5019L8.29278 11.6765L8.91116 12.2948L10.1945 11.0115C10.3789 10.8271 10.5591 10.6966 10.7352 10.6199C10.9113 10.5391 11.0791 10.5143 11.2386 10.5454C11.4002 10.5744 11.5504 10.6583 11.6892 10.7971L11.6954 10.8033C11.9088 11.0167 11.9999 11.2507 11.9688 11.5055C11.9398 11.7583 11.7896 12.0203 11.5183 12.2917L10.2132 13.5968L10.9123 14.296ZM10.4431 14.7652L11.3815 13.8268L6.89756 9.3428L5.95912 10.2812L10.4431 14.7652Z",
        fill: "#4B5563"
    }), $1c508d4a0b9f795b$var$react_1.default.createElement("path", {
        d: "M14.8556 10.3527L16.6206 8.5877C17.0681 8.14023 17.3602 7.67205 17.4969 7.18315C17.6316 6.69218 17.6119 6.19603 17.4379 5.69471C17.2659 5.19131 16.9386 4.69827 16.4559 4.21558L16.4497 4.20937C15.9815 3.74119 15.4999 3.42527 15.0048 3.26161C14.5097 3.09795 14.0197 3.08656 13.535 3.22743C13.0481 3.36623 12.582 3.65832 12.1366 4.10372L10.3716 5.86872L14.8556 10.3527ZM15.0203 8.64052L12.0838 5.70403L12.7612 5.02661C13.0326 4.75523 13.3216 4.58018 13.6282 4.50146C13.9348 4.4186 14.2476 4.43517 14.5666 4.55118C14.8857 4.66305 15.1995 4.87332 15.5082 5.18198L15.5144 5.1882C15.8313 5.50515 16.0499 5.82522 16.17 6.14839C16.2902 6.46741 16.3109 6.78023 16.2322 7.08682C16.1535 7.39342 15.9753 7.68552 15.6977 7.96311L15.0203 8.64052Z",
        fill: "#4B5563"
    }));
};
module.exports.tbd = $1c508d4a0b9f795b$var$tbd;

});

parcelRegister("jejxV", function(module, exports) {
"use strict";
var $dffe7c99046d1f61$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $dffe7c99046d1f61$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.template_apply = void 0;

/* eslint-disable max-len */ const $dffe7c99046d1f61$var$react_1 = $dffe7c99046d1f61$var$__importDefault((parcelRequire("acw62")));

const $dffe7c99046d1f61$var$classnames_1 = $dffe7c99046d1f61$var$__importDefault((parcelRequire("8g1PZ")));
const $dffe7c99046d1f61$var$template_apply = (_a)=>{
    var { className: className } = _a, rest = $dffe7c99046d1f61$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $dffe7c99046d1f61$var$classnames_1.default)("helix-icon", "template_apply-outlined", className);
    return $dffe7c99046d1f61$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $dffe7c99046d1f61$var$react_1.default.createElement("path", {
        d: "M13.5 13.5V11.5C13.5 11.2239 13.7239 11 14 11H15C15.2761 11 15.5 11.2239 15.5 11.5V13.5H17.5C17.7761 13.5 18 13.7239 18 14V15C18 15.2761 17.7761 15.5 17.5 15.5H15.5V17.5C15.5 17.7761 15.2761 18 15 18H14C13.7239 18 13.5 17.7761 13.5 17.5V15.5H11.5C11.2239 15.5 11 15.2761 11 15V14C11 13.7239 11.2239 13.5 11.5 13.5H13.5Z",
        fill: "#4B5563"
    }), $dffe7c99046d1f61$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.46967 16.0304C3.61032 16.171 3.80109 16.2501 4 16.2501H10.3386C10.131 16.0668 10 15.7987 10 15.5V14.7501H4.75L4.75 3.75017L11.25 3.75003L11.25 7C11.25 7.41421 11.5858 7.75 12 7.75H14.75V10H15.5C15.7987 10 16.0668 10.1309 16.25 10.3385V6C16.25 5.80109 16.171 5.61032 16.0303 5.46967L13.0303 2.46967C12.8897 2.32901 12.6989 2.25 12.5 2.25L3.99998 2.25019C3.58578 2.2502 3.25 2.58598 3.25 3.00019V15.5001C3.25 15.699 3.32902 15.8897 3.46967 16.0304ZM14.6893 6.25H12.75V4.31066L14.6893 6.25Z",
        fill: "#4B5563"
    }), $dffe7c99046d1f61$var$react_1.default.createElement("path", {
        d: "M10 6.75H6V5.25H10V6.75Z",
        fill: "#4B5563"
    }), $dffe7c99046d1f61$var$react_1.default.createElement("path", {
        d: "M6 9.75H10V8.25H6V9.75Z",
        fill: "#4B5563"
    }));
};
module.exports.template_apply = $dffe7c99046d1f61$var$template_apply;

});

parcelRegister("8tbck", function(module, exports) {
"use strict";
var $62a9b7d2262e1f7a$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $62a9b7d2262e1f7a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.text_message = void 0;

/* eslint-disable max-len */ const $62a9b7d2262e1f7a$var$react_1 = $62a9b7d2262e1f7a$var$__importDefault((parcelRequire("acw62")));

const $62a9b7d2262e1f7a$var$classnames_1 = $62a9b7d2262e1f7a$var$__importDefault((parcelRequire("8g1PZ")));
const $62a9b7d2262e1f7a$var$text_message = (_a)=>{
    var { className: className } = _a, rest = $62a9b7d2262e1f7a$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $62a9b7d2262e1f7a$var$classnames_1.default)("helix-icon", "text-message-outlined", className);
    return $62a9b7d2262e1f7a$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $62a9b7d2262e1f7a$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M13 4.75C15.8995 4.75 18.25 7.10051 18.25 10C18.25 12.8995 15.8995 15.25 13 15.25H7C6.84029 15.25 6.68244 15.2429 6.52672 15.229C6.42415 15.2199 6.32079 15.2319 6.22309 15.2645L3.18562 16.2761L3.70866 14.7068C3.80316 14.4232 3.72027 14.1106 3.49767 13.9111C2.42388 12.9488 1.75 11.5536 1.75 10C1.75 7.10051 4.1005 4.75 7 4.75H13ZM19.75 10C19.75 6.27208 16.7279 3.25 13 3.25H7C3.27208 3.25 0.25 6.27208 0.25 10C0.25 11.8174 0.969021 13.4677 2.13631 14.6805L1.28848 17.2244C1.19867 17.4939 1.26879 17.791 1.46962 17.9918C1.67045 18.1927 1.96751 18.2629 2.237 18.1731L6.55348 16.7354C6.70117 16.7451 6.85007 16.75 7 16.75H13C16.7279 16.75 19.75 13.7279 19.75 10Z",
        fill: "#4B5563"
    }), $62a9b7d2262e1f7a$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 11C6.55228 11 7 10.5523 7 10C7 9.44772 6.55228 9 6 9C5.44772 9 5 9.44772 5 10C5 10.5523 5.44772 11 6 11ZM10 11C10.5523 11 11 10.5523 11 10C11 9.44772 10.5523 9 10 9C9.44772 9 9 9.44772 9 10C9 10.5523 9.44772 11 10 11ZM15 10C15 10.5523 14.5523 11 14 11C13.4477 11 13 10.5523 13 10C13 9.44772 13.4477 9 14 9C14.5523 9 15 9.44772 15 10Z",
        fill: "#4B5563"
    }));
};
module.exports.text_message = $62a9b7d2262e1f7a$var$text_message;

});

parcelRegister("cdT1D", function(module, exports) {
"use strict";
var $8e6161cfee7ac9fc$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $8e6161cfee7ac9fc$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.thumb_down = void 0;

/* eslint-disable max-len */ const $8e6161cfee7ac9fc$var$react_1 = $8e6161cfee7ac9fc$var$__importDefault((parcelRequire("acw62")));

const $8e6161cfee7ac9fc$var$classnames_1 = $8e6161cfee7ac9fc$var$__importDefault((parcelRequire("8g1PZ")));
const $8e6161cfee7ac9fc$var$thumb_down = (_a)=>{
    var { className: className } = _a, rest = $8e6161cfee7ac9fc$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $8e6161cfee7ac9fc$var$classnames_1.default)("helix-icon", "thumb_down-outlined", className);
    return $8e6161cfee7ac9fc$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $8e6161cfee7ac9fc$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.2114 17.6262C9.95524 18.3093 9.30227 18.7618 8.5728 18.7618H8.2658C6.74701 18.7618 5.5158 17.5306 5.5158 16.0118V15.7821C5.5158 15.1778 5.6311 14.5791 5.85553 14.018L6.02088 13.6046C6.08657 13.4404 5.96563 13.2618 5.78876 13.2618H5.00033C3.3613 13.2618 2.08615 11.8371 2.26715 10.2081L2.77328 5.65288C2.95616 4.00697 4.34737 2.76178 6.0034 2.76178L10.2937 2.76178C10.7206 2.76178 11.1416 2.86118 11.5235 3.0521L13.4678 4.02424C13.7802 4.18045 14.1247 4.26178 14.474 4.26178L15.7658 4.26178C16.7323 4.26178 17.5158 5.04528 17.5158 6.01178L17.5158 10.5118C17.5158 11.4783 16.7323 12.2618 15.7658 12.2618L14.0765 12.2618L13.0762 13.262C12.855 13.4832 12.6125 13.682 12.3523 13.8555L11.3831 14.5016L10.2114 17.6262ZM8.5728 17.2618C8.67701 17.2618 8.77029 17.1971 8.80688 17.0996L10.0635 13.7484C10.1188 13.6012 10.2189 13.475 10.3498 13.3877L11.5202 12.6074C11.6983 12.4887 11.8642 12.3527 12.0155 12.2014L13.2355 10.9814C13.3761 10.8408 13.5669 10.7618 13.7658 10.7618H15.7658C15.9039 10.7618 16.0158 10.6499 16.0158 10.5118L16.0158 6.01178C16.0158 5.87371 15.9039 5.76178 15.7658 5.76178H14.474C13.8918 5.76178 13.3177 5.62624 12.7969 5.36588L10.8527 4.39375C10.6791 4.30696 10.4877 4.26178 10.2937 4.26178L6.0034 4.26178C5.11169 4.26178 4.36258 4.93227 4.26411 5.81852L3.75797 10.3737C3.6757 11.1142 4.25531 11.7618 5.00033 11.7618H5.78876C7.02683 11.7618 7.8734 13.0122 7.4136 14.1617L7.24825 14.5751C7.09469 14.959 7.0158 15.3686 7.0158 15.7821V16.0118C7.0158 16.7021 7.57544 17.2618 8.2658 17.2618H8.5728Z",
        fill: "#4B5563"
    }));
};
module.exports.thumb_down = $8e6161cfee7ac9fc$var$thumb_down;

});

parcelRegister("fsK0o", function(module, exports) {
"use strict";
var $b41d283f68791fb6$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $b41d283f68791fb6$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.thumb_up = void 0;

/* eslint-disable max-len */ const $b41d283f68791fb6$var$react_1 = $b41d283f68791fb6$var$__importDefault((parcelRequire("acw62")));

const $b41d283f68791fb6$var$classnames_1 = $b41d283f68791fb6$var$__importDefault((parcelRequire("8g1PZ")));
const $b41d283f68791fb6$var$thumb_up = (_a)=>{
    var { className: className } = _a, rest = $b41d283f68791fb6$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $b41d283f68791fb6$var$classnames_1.default)("helix-icon", "thumb-up-outlined", className);
    return $b41d283f68791fb6$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $b41d283f68791fb6$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.55442 3.64731C9.81056 2.96428 10.4635 2.51178 11.193 2.51178H11.5C13.0188 2.51178 14.25 3.743 14.25 5.26178V5.49145C14.25 6.09574 14.1347 6.69448 13.9103 7.25556L13.7449 7.66893C13.6792 7.83315 13.8002 8.01178 13.977 8.01178H14.7655C16.4045 8.01178 17.6797 9.43646 17.4987 11.0655L16.9925 15.6207C16.8096 17.2666 15.4184 18.5118 13.7624 18.5118H9.47214C9.04521 18.5118 8.62415 18.4124 8.2423 18.2215L6.29803 17.2493C5.9856 17.0931 5.6411 17.0118 5.2918 17.0118H4C3.0335 17.0118 2.25 16.2283 2.25 15.2618V10.7618C2.25 9.79528 3.0335 9.01178 4 9.01178H5.68934L6.6896 8.01152C6.91078 7.79034 7.15327 7.59155 7.41353 7.41804L8.38269 6.77193L9.55442 3.64731ZM11.193 4.01178C11.0888 4.01178 10.9955 4.07642 10.9589 4.174L9.70225 7.52512C9.64702 7.67239 9.54689 7.79857 9.41603 7.88582L8.24558 8.66611C8.06751 8.78483 7.90159 8.92085 7.75026 9.07218L6.53033 10.2921C6.38968 10.4328 6.19891 10.5118 6 10.5118H4C3.86193 10.5118 3.75 10.6237 3.75 10.7618V15.2618C3.75 15.3999 3.86193 15.5118 4 15.5118H5.2918C5.87397 15.5118 6.44814 15.6473 6.96885 15.9077L8.91312 16.8798C9.08669 16.9666 9.27808 17.0118 9.47214 17.0118H13.7624C14.6541 17.0118 15.4032 16.3413 15.5017 15.455L16.0078 10.8998C16.0901 10.1594 15.5105 9.51178 14.7655 9.51178H13.977C12.739 9.51178 11.8924 8.26136 12.3522 7.11185L12.5175 6.69847C12.6711 6.31458 12.75 5.90491 12.75 5.49145V5.26178C12.75 4.57142 12.1904 4.01178 11.5 4.01178H11.193Z",
        fill: "#4B5563"
    }));
};
module.exports.thumb_up = $b41d283f68791fb6$var$thumb_up;

});

parcelRegister("eCOFn", function(module, exports) {
"use strict";
var $aa5bea909fde59f8$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $aa5bea909fde59f8$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.title = void 0;

/* eslint-disable max-len */ const $aa5bea909fde59f8$var$react_1 = $aa5bea909fde59f8$var$__importDefault((parcelRequire("acw62")));

const $aa5bea909fde59f8$var$classnames_1 = $aa5bea909fde59f8$var$__importDefault((parcelRequire("8g1PZ")));
const $aa5bea909fde59f8$var$title = (_a)=>{
    var { className: className } = _a, rest = $aa5bea909fde59f8$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $aa5bea909fde59f8$var$classnames_1.default)("helix-icon", "title-outlined", className);
    return $aa5bea909fde59f8$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $aa5bea909fde59f8$var$react_1.default.createElement("path", {
        d: "M8.64062 15.4214V8.13434H6V6.26178H13.6108V8.13434H10.9702V15.4214H8.64062Z",
        fill: "#4B5563"
    }));
};
module.exports.title = $aa5bea909fde59f8$var$title;

});

parcelRegister("ef610", function(module, exports) {
"use strict";
var $a5e721e884698389$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $a5e721e884698389$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.to_dos = void 0;

/* eslint-disable max-len */ const $a5e721e884698389$var$react_1 = $a5e721e884698389$var$__importDefault((parcelRequire("acw62")));

const $a5e721e884698389$var$classnames_1 = $a5e721e884698389$var$__importDefault((parcelRequire("8g1PZ")));
const $a5e721e884698389$var$to_dos = (_a)=>{
    var { className: className } = _a, rest = $a5e721e884698389$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $a5e721e884698389$var$classnames_1.default)("helix-icon", "to-dos-outlined", className);
    return $a5e721e884698389$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $a5e721e884698389$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.75 6.7618C17.75 7.17601 17.4142 7.5118 17 7.5118L12 7.5118C11.5858 7.5118 11.25 7.17601 11.25 6.7618C11.25 6.34758 11.5858 6.0118 12 6.0118H17C17.4142 6.0118 17.75 6.34758 17.75 6.7618Z",
        fill: "#4B5563"
    }), $a5e721e884698389$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M17.75 14.7618C17.75 15.176 17.4142 15.5118 17 15.5118H12C11.5858 15.5118 11.25 15.176 11.25 14.7618C11.25 14.3476 11.5858 14.0118 12 14.0118H17C17.4142 14.0118 17.75 14.3476 17.75 14.7618Z",
        fill: "#4B5563"
    }), $a5e721e884698389$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.5 16.7618C7.60457 16.7618 8.5 15.8664 8.5 14.7618C8.5 13.6572 7.60457 12.7618 6.5 12.7618C5.39543 12.7618 4.5 13.6572 4.5 14.7618C4.5 15.8664 5.39543 16.7618 6.5 16.7618ZM6.5 18.2618C8.433 18.2618 10 16.6948 10 14.7618C10 12.8288 8.433 11.2618 6.5 11.2618C4.567 11.2618 3 12.8288 3 14.7618C3 16.6948 4.567 18.2618 6.5 18.2618Z",
        fill: "#4B5563"
    }), $a5e721e884698389$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.5 10.2618C8.433 10.2618 10 8.69479 10 6.7618C10 4.8288 8.433 3.2618 6.5 3.2618C4.567 3.26179 3 4.8288 3 6.7618C3 8.69479 4.567 10.2618 6.5 10.2618ZM5.56952 8.21492C5.81303 8.44625 6.19583 8.44377 6.43631 8.20929L8.43631 6.25928C8.68346 6.01831 8.68847 5.62262 8.4475 5.37547C8.20653 5.12832 7.81083 5.12331 7.56369 5.36428L5.99437 6.89437L5.43047 6.35866C5.18022 6.12092 4.78462 6.13106 4.54688 6.38131C4.30913 6.63156 4.31928 7.02716 4.56953 7.2649L5.56952 8.21492Z",
        fill: "#4B5563"
    }));
};
module.exports.to_dos = $a5e721e884698389$var$to_dos;

});

parcelRegister("dFdoQ", function(module, exports) {
"use strict";
var $9f297f9b8aa3450b$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $9f297f9b8aa3450b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toolkit = void 0;

/* eslint-disable max-len */ const $9f297f9b8aa3450b$var$react_1 = $9f297f9b8aa3450b$var$__importDefault((parcelRequire("acw62")));

const $9f297f9b8aa3450b$var$classnames_1 = $9f297f9b8aa3450b$var$__importDefault((parcelRequire("8g1PZ")));
const $9f297f9b8aa3450b$var$toolkit = (_a)=>{
    var { className: className } = _a, rest = $9f297f9b8aa3450b$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $9f297f9b8aa3450b$var$classnames_1.default)("helix-icon", "toolkit-outlined", className);
    return $9f297f9b8aa3450b$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $9f297f9b8aa3450b$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.5 5.76178V5.26178H12.5V5.76178H14V4.76178C14 4.2095 13.5523 3.76178 13 3.76178H7C6.44772 3.76178 6 4.2095 6 4.76178V5.76178H7.5Z",
        fill: "#4B5563"
    }), $9f297f9b8aa3450b$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16 7.26178H4C3.72386 7.26178 3.5 7.48564 3.5 7.76178V15.7618C3.5 16.0379 3.72386 16.2618 4 16.2618H16C16.2761 16.2618 16.5 16.0379 16.5 15.7618V7.76178C16.5 7.48564 16.2761 7.26178 16 7.26178ZM4 5.76178C2.89543 5.76178 2 6.65721 2 7.76178V15.7618C2 16.8663 2.89543 17.7618 4 17.7618H16C17.1046 17.7618 18 16.8663 18 15.7618V7.76178C18 6.65721 17.1046 5.76178 16 5.76178H4Z",
        fill: "#4B5563"
    }), $9f297f9b8aa3450b$var$react_1.default.createElement("path", {
        d: "M7 9.01178C7.41421 9.01178 7.75 9.34757 7.75 9.76178V10.0118H12.25V9.76178C12.25 9.34757 12.5858 9.01178 13 9.01178C13.4142 9.01178 13.75 9.34757 13.75 9.76178V10.0118H18V11.5118H13.75V11.7618C13.75 12.176 13.4142 12.5118 13 12.5118C12.5858 12.5118 12.25 12.176 12.25 11.7618V11.5118H7.75V11.7618C7.75 12.176 7.41421 12.5118 7 12.5118C6.58579 12.5118 6.25 12.176 6.25 11.7618V11.5118H2.5V10.0118H6.25V9.76178C6.25 9.34757 6.58579 9.01178 7 9.01178Z",
        fill: "#4B5563"
    }));
};
module.exports.toolkit = $9f297f9b8aa3450b$var$toolkit;

});

parcelRegister("9nYg5", function(module, exports) {
"use strict";
var $6d550123227e3c2e$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $6d550123227e3c2e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.tour = void 0;

/* eslint-disable max-len */ const $6d550123227e3c2e$var$react_1 = $6d550123227e3c2e$var$__importDefault((parcelRequire("acw62")));

const $6d550123227e3c2e$var$classnames_1 = $6d550123227e3c2e$var$__importDefault((parcelRequire("8g1PZ")));
const $6d550123227e3c2e$var$tour = (_a)=>{
    var { className: className } = _a, rest = $6d550123227e3c2e$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $6d550123227e3c2e$var$classnames_1.default)("helix-icon", "tour-outlined", className);
    return $6d550123227e3c2e$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $6d550123227e3c2e$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.75 10C1.75 9.01534 2.47725 7.96621 4.00027 7.12008C5.49789 6.28808 7.61764 5.75 10 5.75C12.3824 5.75 14.5021 6.28808 15.9997 7.12008C17.5228 7.96621 18.25 9.01534 18.25 10C18.25 10.685 17.9066 11.3907 17.1747 12.054C16.4409 12.7189 15.3568 13.2987 14.0134 13.6964C13.6162 13.814 13.3896 14.2313 13.5071 14.6284C13.6247 15.0256 14.042 15.2523 14.4392 15.1347C15.9361 14.6916 17.2389 14.02 18.1819 13.1655C19.1267 12.3094 19.75 11.2278 19.75 10C19.75 8.22323 18.4625 6.77237 16.7282 5.80885C14.9684 4.83121 12.5882 4.25 10 4.25C7.4118 4.25 5.03155 4.83121 3.27181 5.80885C1.53747 6.77237 0.25 8.22323 0.25 10C0.25 11.7768 1.53747 13.2276 3.27181 14.1912C4.8073 15.0442 6.81523 15.5954 9.02152 15.7221L7.23253 17.4273C6.9327 17.7131 6.92133 18.1879 7.20712 18.4877C7.49291 18.7875 7.96765 18.7989 8.26748 18.5131L11.4254 15.503L11.9949 14.9601L11.4254 14.4172L8.26748 11.4071C7.96765 11.1213 7.49291 11.1327 7.20712 11.4325C6.92133 11.7324 6.9327 12.2071 7.23253 12.4929L9.04535 14.2209C7.05368 14.0985 5.29462 13.599 4.00027 12.8799C2.47725 12.0338 1.75 10.9847 1.75 10Z",
        fill: "#4B5563"
    }));
};
module.exports.tour = $6d550123227e3c2e$var$tour;

});

parcelRegister("8kd71", function(module, exports) {
"use strict";
var $60fa5ccc6dd93cf4$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $60fa5ccc6dd93cf4$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.transaction_workflow = void 0;

/* eslint-disable max-len */ const $60fa5ccc6dd93cf4$var$react_1 = $60fa5ccc6dd93cf4$var$__importDefault((parcelRequire("acw62")));

const $60fa5ccc6dd93cf4$var$classnames_1 = $60fa5ccc6dd93cf4$var$__importDefault((parcelRequire("8g1PZ")));
const $60fa5ccc6dd93cf4$var$transaction_workflow = (_a)=>{
    var { className: className } = _a, rest = $60fa5ccc6dd93cf4$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $60fa5ccc6dd93cf4$var$classnames_1.default)("helix-icon", "transaction_workflow-outlined", className);
    return $60fa5ccc6dd93cf4$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $60fa5ccc6dd93cf4$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.75 11.2618C3.33579 11.2618 3 10.926 3 10.5118L3 9.01178C3 7.493 4.23122 6.26178 5.75 6.26178L14.75 6.26178C15.1642 6.26178 15.5 6.59757 15.5 7.01178C15.5 7.42599 15.1642 7.76178 14.75 7.76178L5.75 7.76178C5.05964 7.76178 4.5 8.32143 4.5 9.01178L4.5 10.5118C4.5 10.926 4.16421 11.2618 3.75 11.2618Z",
        fill: "#4B5563"
    }), $60fa5ccc6dd93cf4$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M15.75 10.7618C16.1642 10.7618 16.5 11.0976 16.5 11.5118V13.0118C16.5 14.5306 15.2688 15.7618 13.75 15.7618L4.75 15.7618C4.33579 15.7618 4 15.426 4 15.0118C4 14.5976 4.33579 14.2618 4.75 14.2618L13.75 14.2618C14.4404 14.2618 15 13.7021 15 13.0118V11.5118C15 11.0976 15.3358 10.7618 15.75 10.7618Z",
        fill: "#4B5563"
    }), $60fa5ccc6dd93cf4$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.2197 3.48145C11.5126 3.18856 11.9874 3.18856 12.2803 3.48145L15.2803 6.48145C15.5732 6.77434 15.5732 7.24922 15.2803 7.54211C14.9874 7.835 14.5126 7.835 14.2197 7.54211L11.2197 4.54211C10.9268 4.24922 10.9268 3.77434 11.2197 3.48145Z",
        fill: "#4B5563"
    }), $60fa5ccc6dd93cf4$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M8.28033 18.5421C7.98744 18.835 7.51256 18.835 7.21967 18.5421L4.21967 15.5421C3.92678 15.2492 3.92678 14.7743 4.21967 14.4815C4.51256 14.1886 4.98744 14.1886 5.28033 14.4815L8.28033 17.4815C8.57322 17.7743 8.57322 18.2492 8.28033 18.5421Z",
        fill: "#4B5563"
    }));
};
module.exports.transaction_workflow = $60fa5ccc6dd93cf4$var$transaction_workflow;

});

parcelRegister("27YaX", function(module, exports) {
"use strict";
var $18cae9e0c91eed5b$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $18cae9e0c91eed5b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.trash_can = void 0;

/* eslint-disable max-len */ const $18cae9e0c91eed5b$var$react_1 = $18cae9e0c91eed5b$var$__importDefault((parcelRequire("acw62")));

const $18cae9e0c91eed5b$var$classnames_1 = $18cae9e0c91eed5b$var$__importDefault((parcelRequire("8g1PZ")));
const $18cae9e0c91eed5b$var$trash_can = (_a)=>{
    var { className: className } = _a, rest = $18cae9e0c91eed5b$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $18cae9e0c91eed5b$var$classnames_1.default)("helix-icon", "trash-can-outlined", className);
    return $18cae9e0c91eed5b$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $18cae9e0c91eed5b$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.25 4C6.25 3.0335 7.0335 2.25 8 2.25H12C12.9665 2.25 13.75 3.0335 13.75 4V4.75L16.5 4.75C16.9142 4.75 17.25 5.08579 17.25 5.5C17.25 5.83242 17.0337 6.11432 16.7342 6.2127L15.9002 15.7284L15.9001 15.7303C15.7804 17.1547 14.5893 18.25 13.1597 18.25H6.84027C5.41059 18.25 4.21949 17.1546 4.09991 15.7301L4.09977 15.7284L3.26577 6.2127C2.96626 6.11432 2.75 5.83242 2.75 5.5C2.75 5.08579 3.08579 4.75 3.5 4.75L6.25 4.75V4ZM7.75 4.75H12.25V4C12.25 3.86193 12.1381 3.75 12 3.75H8C7.86193 3.75 7.75 3.86193 7.75 4V4.75ZM4.77479 6.25L5.59459 15.6038C5.64857 16.2517 6.19016 16.75 6.84027 16.75H13.1597C13.8098 16.75 14.3514 16.2517 14.4054 15.6038L14.4057 15.6006L15.2252 6.25L4.77479 6.25ZM8.25 8C8.66421 8 9 8.33579 9 8.75V14.25C9 14.6642 8.66421 15 8.25 15C7.83579 15 7.5 14.6642 7.5 14.25V8.75C7.5 8.33579 7.83579 8 8.25 8ZM11.75 8C12.1642 8 12.5 8.33579 12.5 8.75V14.25C12.5 14.6642 12.1642 15 11.75 15C11.3358 15 11 14.6642 11 14.25V8.75C11 8.33579 11.3358 8 11.75 8Z",
        fill: "#4B5563"
    }));
};
module.exports.trash_can = $18cae9e0c91eed5b$var$trash_can;

});

parcelRegister("9rGW6", function(module, exports) {
"use strict";
var $6e07f0e21f2df4d9$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $6e07f0e21f2df4d9$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.user = void 0;

/* eslint-disable max-len */ const $6e07f0e21f2df4d9$var$react_1 = $6e07f0e21f2df4d9$var$__importDefault((parcelRequire("acw62")));

const $6e07f0e21f2df4d9$var$classnames_1 = $6e07f0e21f2df4d9$var$__importDefault((parcelRequire("8g1PZ")));
const $6e07f0e21f2df4d9$var$user = (_a)=>{
    var { className: className } = _a, rest = $6e07f0e21f2df4d9$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $6e07f0e21f2df4d9$var$classnames_1.default)("helix-icon", "user-outlined", className);
    return $6e07f0e21f2df4d9$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $6e07f0e21f2df4d9$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.25 14C3.25 11.3766 5.37665 9.25 8 9.25H12C14.6234 9.25 16.75 11.3766 16.75 14V17C16.75 17.4142 16.4142 17.75 16 17.75H4C3.58579 17.75 3.25 17.4142 3.25 17V14ZM8 10.75C6.20507 10.75 4.75 12.2051 4.75 14V16.25H15.25V14C15.25 12.2051 13.7949 10.75 12 10.75H8Z",
        fill: "#4B5563"
    }), $6e07f0e21f2df4d9$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.25 5C6.25 2.92893 7.92893 1.25 10 1.25C12.0711 1.25 13.75 2.92893 13.75 5V6C13.75 8.07107 12.0711 9.75 10 9.75C7.92893 9.75 6.25 8.07107 6.25 6V5ZM10 2.75C8.75736 2.75 7.75 3.75736 7.75 5V6C7.75 7.24264 8.75736 8.25 10 8.25C11.2426 8.25 12.25 7.24264 12.25 6V5C12.25 3.75736 11.2426 2.75 10 2.75Z",
        fill: "#4B5563"
    }));
};
module.exports.user = $6e07f0e21f2df4d9$var$user;

});

parcelRegister("9oteB", function(module, exports) {
"use strict";
var $6d6d085187067fe2$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $6d6d085187067fe2$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.version_history = void 0;

/* eslint-disable max-len */ const $6d6d085187067fe2$var$react_1 = $6d6d085187067fe2$var$__importDefault((parcelRequire("acw62")));

const $6d6d085187067fe2$var$classnames_1 = $6d6d085187067fe2$var$__importDefault((parcelRequire("8g1PZ")));
const $6d6d085187067fe2$var$version_history = (_a)=>{
    var { className: className } = _a, rest = $6d6d085187067fe2$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $6d6d085187067fe2$var$classnames_1.default)("helix-icon", "version-history-outlined", className);
    return $6d6d085187067fe2$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $6d6d085187067fe2$var$react_1.default.createElement("path", {
        d: "M3.75 10.6667C3.75 14.1185 6.54822 16.9167 10 16.9167C13.4518 16.9167 16.25 14.1185 16.25 10.6667C16.25 7.21491 13.4518 4.41669 10 4.41669C7.78654 4.41669 5.84098 5.56662 4.72949 7.30536C4.61966 7.47719 4.5177 7.65494 4.4248 7.83759C4.23707 8.20659 3.78609 8.35413 3.41699 8.16669C3.04788 7.97896 2.90034 7.52705 3.08789 7.1579C3.20316 6.93125 3.32966 6.71077 3.46582 6.49774C4.84128 4.34596 7.25347 2.91669 10 2.91669C14.2802 2.91669 17.75 6.38648 17.75 10.6667C17.75 14.9469 14.2802 18.4167 10 18.4167C5.71979 18.4167 2.25 14.9469 2.25 10.6667H3.75Z",
        fill: "#4B5563"
    }), $6d6d085187067fe2$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.75 6.66669C10.1642 6.66669 10.5 7.00247 10.5 7.41669V11.0562L12.7185 12.831C13.042 13.0898 13.0944 13.5618 12.8357 13.8852C12.5769 14.2087 12.1049 14.2611 11.7815 14.0023L9.28148 12.0023C9.10357 11.86 9 11.6445 9 11.4167V7.41669C9 7.00247 9.33579 6.66669 9.75 6.66669Z",
        fill: "#4B5563"
    }), $6d6d085187067fe2$var$react_1.default.createElement("path", {
        d: "M3 4.01669C3 3.60247 3.33579 3.26669 3.75 3.26669C4.16421 3.26669 4.5 3.60247 4.5 4.01669V6.76669H6.75C7.16421 6.76669 7.5 7.10247 7.5 7.51669C7.5 7.9309 7.16421 8.26669 6.75 8.26669H3.75C3.33579 8.26669 3 7.9309 3 7.51669V4.01669Z",
        fill: "#4B5563"
    }));
};
module.exports.version_history = $6d6d085187067fe2$var$version_history;

});

parcelRegister("ksSRu", function(module, exports) {
"use strict";
var $ee60fa934df991cb$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $ee60fa934df991cb$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.video_library = void 0;

/* eslint-disable max-len */ const $ee60fa934df991cb$var$react_1 = $ee60fa934df991cb$var$__importDefault((parcelRequire("acw62")));

const $ee60fa934df991cb$var$classnames_1 = $ee60fa934df991cb$var$__importDefault((parcelRequire("8g1PZ")));
const $ee60fa934df991cb$var$video_library = (_a)=>{
    var { className: className } = _a, rest = $ee60fa934df991cb$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $ee60fa934df991cb$var$classnames_1.default)("helix-icon", "video-library-outlined", className);
    return $ee60fa934df991cb$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, rest), $ee60fa934df991cb$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.75 2.33325C3.75 1.91904 4.08579 1.58325 4.5 1.58325H15C15.4142 1.58325 15.75 1.91904 15.75 2.33325C15.75 2.74747 15.4142 3.08325 15 3.08325H4.5C4.08579 3.08325 3.75 2.74747 3.75 2.33325Z",
        fill: "#4B5563"
    }), $ee60fa934df991cb$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M1.25 7.33325C1.25 5.81447 2.48122 4.58325 4 4.58325H16C17.5188 4.58325 18.75 5.81447 18.75 7.33325V15.3333C18.75 16.852 17.5188 18.0833 16 18.0833H4C2.48122 18.0833 1.25 16.852 1.25 15.3333V7.33325ZM4 6.08325C3.30964 6.08325 2.75 6.6429 2.75 7.33325V15.3333C2.75 16.0236 3.30964 16.5833 4 16.5833H16C16.6904 16.5833 17.25 16.0236 17.25 15.3333V7.33325C17.25 6.6429 16.6904 6.08325 16 6.08325H4Z",
        fill: "#4B5563"
    }), $ee60fa934df991cb$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M7.63048 7.6806C7.86561 7.54747 8.15417 7.55111 8.38587 7.69013L13.3859 10.6901C13.6118 10.8257 13.75 11.0698 13.75 11.3333C13.75 11.5967 13.6118 11.8408 13.3859 11.9764L8.38587 14.9764C8.15417 15.1154 7.86561 15.119 7.63048 14.9859C7.39534 14.8528 7.25 14.6035 7.25 14.3333V8.33325C7.25 8.06305 7.39534 7.81373 7.63048 7.6806ZM8.75 9.6579V13.0086L11.5423 11.3333L8.75 9.6579Z",
        fill: "#4B5563"
    }));
};
module.exports.video_library = $ee60fa934df991cb$var$video_library;

});

parcelRegister("exnNp", function(module, exports) {
"use strict";
var $a9569b26daeb7d47$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $a9569b26daeb7d47$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.user_edit = void 0;

/* eslint-disable max-len */ const $a9569b26daeb7d47$var$react_1 = $a9569b26daeb7d47$var$__importDefault((parcelRequire("acw62")));

const $a9569b26daeb7d47$var$classnames_1 = $a9569b26daeb7d47$var$__importDefault((parcelRequire("8g1PZ")));
const $a9569b26daeb7d47$var$user_edit = (_a)=>{
    var { className: className } = _a, rest = $a9569b26daeb7d47$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $a9569b26daeb7d47$var$classnames_1.default)("helix-icon", "user-edit-outlined", className);
    return $a9569b26daeb7d47$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $a9569b26daeb7d47$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 5.75C6 3.67893 7.67893 2 9.75 2C11.8211 2 13.5 3.67893 13.5 5.75V6.75C13.5 8.13923 12.7446 9.35202 11.6221 10H11.75C12.308 10 12.8436 10.0962 13.3409 10.273L12.0957 11.5182C11.9821 11.5062 11.8668 11.5 11.75 11.5H7.75C5.95507 11.5 4.5 12.9551 4.5 14.75V17H7.15458L6.78171 18.5H3.75C3.33579 18.5 3 18.1642 3 17.75V14.75C3 12.1266 5.12665 10 7.75 10H7.87791C6.75543 9.35202 6 8.13923 6 6.75V5.75ZM14.2916 10.7365L13.1917 11.8364L8.23695 16.7911L8.18501 17L7.81214 18.5L7.75 18.75L8.75577 18.5L9.70897 18.2631L10.9721 17L14.6636 13.3085L15.7636 12.2085L17.3874 10.5848C17.8379 10.1343 17.8734 9.43937 17.4671 9.03308C17.0606 8.6266 16.3661 8.6621 15.9158 9.11237L14.2916 10.7365ZM10.8863 18.5L12.3863 17H15V14.75C15 14.6333 14.9938 14.518 14.9819 14.4045L16.2271 13.1593C16.4038 13.6566 16.5 14.1921 16.5 14.75V17.75C16.5 18.1642 16.1642 18.5 15.75 18.5H10.8863ZM9.75 3.5C8.50736 3.5 7.5 4.50736 7.5 5.75V6.75C7.5 7.99264 8.50736 9 9.75 9C10.9926 9 12 7.99264 12 6.75V5.75C12 4.50736 10.9926 3.5 9.75 3.5Z",
        fill: "#4B5563"
    }));
};
module.exports.user_edit = $a9569b26daeb7d47$var$user_edit;

});

parcelRegister("jvnZT", function(module, exports) {
"use strict";
var $e33386ef4237c286$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $e33386ef4237c286$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.warning = void 0;

/* eslint-disable max-len */ const $e33386ef4237c286$var$react_1 = $e33386ef4237c286$var$__importDefault((parcelRequire("acw62")));

const $e33386ef4237c286$var$classnames_1 = $e33386ef4237c286$var$__importDefault((parcelRequire("8g1PZ")));
const $e33386ef4237c286$var$warning = (_a)=>{
    var { className: className } = _a, rest = $e33386ef4237c286$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $e33386ef4237c286$var$classnames_1.default)("helix-icon", "warning-outlined", className);
    return $e33386ef4237c286$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e33386ef4237c286$var$react_1.default.createElement("svg", {
        width: "20",
        height: "21",
        viewBox: "0 0 20 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, $e33386ef4237c286$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.3995 15.6278L10.7692 4.35882C10.4508 3.72146 9.54309 3.72146 9.22465 4.35882L3.59444 15.6278C3.30607 16.205 3.72636 16.8808 4.36673 16.8808H15.6272C16.2675 16.8808 16.6878 16.205 16.3995 15.6278ZM12.1111 3.68841C11.24 1.94493 8.75388 1.94493 7.88281 3.68841L2.25259 14.9574C1.46678 16.5302 2.60961 18.3808 4.36673 18.3808H15.6272C17.3843 18.3808 18.5271 16.5302 17.7413 14.9574L12.1111 3.68841Z",
        fill: "#4B5563"
    }), $e33386ef4237c286$var$react_1.default.createElement("path", {
        d: "M10.7272 11.7924C10.7025 12.1735 10.3861 12.47 10.0042 12.47C9.6223 12.47 9.30597 12.1735 9.28123 11.7924L8.94639 7.44557C8.90896 6.86901 9.36652 6.3808 9.94429 6.3808H10.0643C10.642 6.3808 11.0996 6.86901 11.0622 7.44557L10.7272 11.7924ZM8.90521 14.5C8.90521 14.192 9.01255 13.9307 9.22721 13.716C9.44188 13.492 9.69855 13.38 9.99721 13.38C10.3052 13.38 10.5665 13.492 10.7812 13.716C11.0052 13.9307 11.1172 14.192 11.1172 14.5C11.1172 14.808 11.0052 15.0693 10.7812 15.284C10.5665 15.4987 10.3052 15.606 9.99721 15.606C9.69855 15.606 9.44188 15.4987 9.22721 15.284C9.01255 15.0693 8.90521 14.808 8.90521 14.5Z",
        fill: "#4B5563"
    })));
};
module.exports.warning = $e33386ef4237c286$var$warning;

});

parcelRegister("31YAT", function(module, exports) {
"use strict";
var $235077d43e8e0d80$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $235077d43e8e0d80$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.wolfie = void 0;

/* eslint-disable max-len */ const $235077d43e8e0d80$var$react_1 = $235077d43e8e0d80$var$__importDefault((parcelRequire("acw62")));

const $235077d43e8e0d80$var$classnames_1 = $235077d43e8e0d80$var$__importDefault((parcelRequire("8g1PZ")));
const $235077d43e8e0d80$var$wolfie = (_a)=>{
    var { className: className } = _a, rest = $235077d43e8e0d80$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $235077d43e8e0d80$var$classnames_1.default)("helix-icon", "wolfie-outlined", className);
    return $235077d43e8e0d80$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $235077d43e8e0d80$var$react_1.default.createElement("path", {
        d: "M6 2.3808C3.79086 2.3808 2 4.17166 2 6.3808V14.3808C2 15.9365 2.88817 17.2849 4.18511 17.9463C4.34274 17.8754 4.52081 17.7853 4.72713 17.6663C6.70172 16.4458 6.51011 15.5229 6.46333 15.4968C6.46333 15.4968 6.5092 15.5658 6.26002 15.8327C5.52956 16.6147 4.88546 16.6361 4.88546 16.6361C5.57903 16.4063 5.86122 15.3375 6.04325 14.6481C6.10062 14.4308 6.14804 14.2512 6.19525 14.1475C6.21718 14.1004 6.24022 14.053 6.26385 14.0044C6.38079 13.7637 6.51204 13.4936 6.59287 13.093C6.68372 12.6227 6.65404 12.2159 6.60906 11.9397C6.56408 12.2495 6.48582 12.6293 6.32749 13.0548C6.15567 13.5129 5.95236 13.8778 5.77334 14.1475C5.73016 11.8949 6.59377 9.53595 6.59377 9.53595C6.60276 9.49956 6.57128 9.4725 6.54069 9.4641L5.26058 9.36052C5.20211 9.35026 4.88726 9.22615 4.92954 9.18883C5.01326 9.11446 5.10937 9.02943 5.21344 8.93735C5.64612 8.55454 6.21657 8.04983 6.60816 7.68275C6.81326 7.49053 7.25226 7.34123 7.25226 7.34123C7.33682 7.31417 7.371 7.30017 7.43397 7.11728C7.49694 6.93438 7.6076 6.77295 7.75873 6.66004L7.76459 6.65485C7.78052 6.64073 7.79636 6.62669 7.8172 6.61339C8.12485 6.38757 8.64661 6.00965 9.29611 5.97699C9.49941 5.96579 9.70902 5.9546 9.91143 5.95926C10.3981 5.97606 10.8011 5.79223 11.1663 5.45817C11.4463 5.19973 11.6501 5.03624 11.8938 4.84061C12.0197 4.73958 12.1563 4.62993 12.3196 4.49425C12.8554 4.18676 13.1089 4.58518 13.2059 4.73764C13.2252 4.76792 13.2383 4.78851 13.2462 4.79192C13.2957 4.78352 13.3649 4.89269 13.4135 4.97014C13.5754 5.22209 13.6024 5.58321 13.4828 5.86315C13.471 5.88885 13.4492 5.93071 13.4224 5.9825C13.3282 6.16384 13.1709 6.46687 13.1562 6.62365C13.1229 6.97637 13.4558 7.0165 13.7257 6.8504C13.9955 6.6843 14.036 6.67777 14.099 6.75895C14.1952 6.88399 14.296 7.13501 14.2744 7.27591C14.2493 7.43321 14.1324 7.53761 14.0437 7.6169C14.0277 7.63122 14.0126 7.64472 13.9991 7.65756C13.8191 7.82482 13.5559 8.00293 13.2753 8.19283C12.8012 8.51358 12.2775 8.86799 12.0209 9.26068C11.4831 10.0839 11.5516 10.9167 11.5755 11.2065C11.5784 11.2419 11.5807 11.2692 11.581 11.2874C11.384 11.126 11.1358 10.8955 10.9001 10.5671C10.6482 10.2171 10.4962 9.87561 10.4008 9.6246C10.3243 9.80282 10.2317 10.0977 10.283 10.4308C10.3675 10.9907 10.6329 11.6504 11.5082 12.1179C12.0947 12.4315 13.4009 13.1593 13.4009 13.1593C13.3433 12.8644 12.6785 11.9537 12.6785 11.9537C13.1373 12.1478 14.2186 12.7916 14.6972 14.3892C15.0528 15.5785 15.022 16.6627 14.9496 18.2674L14.9328 18.2714C14.9039 18.1289 14.8799 17.9943 14.8569 17.8655C14.8099 17.6028 14.7673 17.3642 14.6972 17.1335C14.2318 15.5844 13.795 15.41 12.7211 14.9814C12.5621 14.9179 12.3891 14.8489 12.2 14.7689C12.214 14.7753 12.2292 14.782 12.2454 14.7891C12.6386 14.9623 13.6473 15.4067 14.2519 17.5749C14.3263 17.8414 14.3749 18.1051 14.4036 18.3607C14.3668 18.3644 14.3298 18.3676 14.2927 18.3703C16.3652 18.2204 18 16.4915 18 14.3808V6.3808C18 4.17166 16.2091 2.3808 14 2.3808H6Z",
        fill: "#4B5563"
    }), $235077d43e8e0d80$var$react_1.default.createElement("path", {
        d: "M13.7594 18.3808C13.052 16.4994 11.2087 16.0157 10.0913 15.7338L10.578 16.289C10.578 16.289 12.2339 17.3465 12.749 18.3808H13.7594Z",
        fill: "#4B5563"
    }), $235077d43e8e0d80$var$react_1.default.createElement("path", {
        d: "M9.16567 7.19006C9.20278 7.13044 9.23995 7.07046 9.27722 7.01032C9.38811 6.8314 9.49988 6.65104 9.61366 6.47435C9.76185 6.4465 9.91181 6.41711 10.0615 6.38778C10.1726 6.36602 10.2837 6.34424 10.3936 6.32318L9.90153 6.9857C9.58308 7.19939 9.27092 7.19846 9.16567 7.19006Z",
        fill: "#4B5563"
    }));
};
module.exports.wolfie = $235077d43e8e0d80$var$wolfie;

});

parcelRegister("leV5G", function(module, exports) {
"use strict";
var $f76730cc32f1481c$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $f76730cc32f1481c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.workspace = void 0;

/* eslint-disable max-len */ const $f76730cc32f1481c$var$react_1 = $f76730cc32f1481c$var$__importDefault((parcelRequire("acw62")));

const $f76730cc32f1481c$var$classnames_1 = $f76730cc32f1481c$var$__importDefault((parcelRequire("8g1PZ")));
const $f76730cc32f1481c$var$workspace = (_a)=>{
    var { className: className } = _a, rest = $f76730cc32f1481c$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $f76730cc32f1481c$var$classnames_1.default)("helix-icon", "workspace-outlined", className);
    return $f76730cc32f1481c$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $f76730cc32f1481c$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.82324 5.82327C6.93679 5.57219 7 5.29348 7 5C7 3.89543 6.10457 3 5 3C3.89543 3 3 3.89543 3 5C3 6.10457 3.89543 7 5 7C5.26067 7 5.5097 6.95013 5.73806 6.85941L7.02846 8.1498C6.69353 8.68658 6.5 9.32069 6.5 10C6.5 11.3737 7.29136 12.5625 8.44306 13.1355L8.22043 14.026C7.5256 14.157 7 14.7671 7 15.5C7 16.3284 7.67157 17 8.5 17C9.32843 17 10 16.3284 10 15.5C10 15.1286 9.86501 14.7887 9.64141 14.5267L9.89845 13.4986C9.93219 13.4995 9.96604 13.5 10 13.5C11.933 13.5 13.5 11.933 13.5 10C13.5 9.42496 13.3613 8.88231 13.1156 8.40367L14.933 6.88914C15.1079 6.96061 15.2994 7 15.5 7C16.3284 7 17 6.32843 17 5.5C17 4.67157 16.3284 4 15.5 4C14.6716 4 14 4.67157 14 5.5C14 5.56877 14.0046 5.63646 14.0136 5.70278L12.161 7.24661C11.5659 6.77894 10.8155 6.5 10 6.5C9.28923 6.5 8.62795 6.71187 8.07586 7.07589L6.82324 5.82327ZM8 10C8 9.73932 8.04987 9.49029 8.14059 9.26193C8.33215 8.77975 8.70584 8.38972 9.17674 8.17676C9.42781 8.06321 9.70652 8 10 8C10.3486 8 10.6764 8.08919 10.9617 8.24599C11.4118 8.49326 11.7563 8.90868 11.9108 9.40764C11.9688 9.59483 12 9.79377 12 10C12 11.0103 11.2509 11.8456 10.2779 11.9809C10.1871 11.9935 10.0943 12 10 12C9.55989 12 9.15298 11.8578 8.82269 11.6169C8.32403 11.2532 8 10.6645 8 10Z",
        fill: "#4B5563"
    }));
};
module.exports.workspace = $f76730cc32f1481c$var$workspace;

});

parcelRegister("27kwO", function(module, exports) {
"use strict";
var $18ac28b7ec36da2f$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $18ac28b7ec36da2f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.x = void 0;

/* eslint-disable max-len */ const $18ac28b7ec36da2f$var$react_1 = $18ac28b7ec36da2f$var$__importDefault((parcelRequire("acw62")));

const $18ac28b7ec36da2f$var$classnames_1 = $18ac28b7ec36da2f$var$__importDefault((parcelRequire("8g1PZ")));
const $18ac28b7ec36da2f$var$x = (_a)=>{
    var { className: className } = _a, rest = $18ac28b7ec36da2f$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $18ac28b7ec36da2f$var$classnames_1.default)("helix-icon", "x-outlined", className);
    return $18ac28b7ec36da2f$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $18ac28b7ec36da2f$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        // eslint-disable-next-line max-len
        d: "M2.53033 2.46967C2.82322 2.17678 3.2981 2.17678 3.59099 2.46967L10 8.87868L16.409 2.46967C16.7019 2.17678 17.1768 2.17678 17.4697 2.46967C17.7626 2.76256 17.7626 3.23744 17.4697 3.53033L11.0607 9.93934L17.5303 16.409C17.8232 16.7019 17.8232 17.1768 17.5303 17.4697C17.2374 17.7626 16.7626 17.7626 16.4697 17.4697L10 11L3.53033 17.4697C3.23744 17.7626 2.76256 17.7626 2.46967 17.4697C2.17678 17.1768 2.17678 16.7019 2.46967 16.409L8.93934 9.93934L2.53033 3.53033C2.23744 3.23744 2.23744 2.76256 2.53033 2.46967Z",
        fill: "#4B5563"
    }));
};
module.exports.x = $18ac28b7ec36da2f$var$x;

});

parcelRegister("4vh7q", function(module, exports) {
"use strict";
var $3477561e1ff523dd$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $3477561e1ff523dd$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.x_small = void 0;

/* eslint-disable max-len */ const $3477561e1ff523dd$var$react_1 = $3477561e1ff523dd$var$__importDefault((parcelRequire("acw62")));

const $3477561e1ff523dd$var$classnames_1 = $3477561e1ff523dd$var$__importDefault((parcelRequire("8g1PZ")));
const $3477561e1ff523dd$var$x_small = (_a)=>{
    var { className: className } = _a, rest = $3477561e1ff523dd$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $3477561e1ff523dd$var$classnames_1.default)("helix-icon", "x-small-outlined", className);
    return $3477561e1ff523dd$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $3477561e1ff523dd$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.46967 4.65998C4.76256 4.36708 5.23744 4.36708 5.53033 4.65998L10 9.12965L14.4697 4.65998C14.7626 4.36708 15.2374 4.36708 15.5303 4.65998C15.8232 4.95287 15.8232 5.42774 15.5303 5.72064L11.0607 10.1903L15.5303 14.66C15.8232 14.9529 15.8232 15.4277 15.5303 15.7206C15.2374 16.0135 14.7626 16.0135 14.4697 15.7206L10 11.251L5.53033 15.7206C5.23744 16.0135 4.76256 16.0135 4.46967 15.7206C4.17678 15.4277 4.17678 14.9529 4.46967 14.66L8.93934 10.1903L4.46967 5.72064C4.17678 5.42774 4.17678 4.95287 4.46967 4.65998Z",
        fill: "#4B5563"
    }));
};
module.exports.x_small = $3477561e1ff523dd$var$x_small;

});

parcelRegister("1dGb2", function(module, exports) {
"use strict";
var $0e37b8d5b380d7f4$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $0e37b8d5b380d7f4$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.zillow = void 0;

/* eslint-disable max-len */ const $0e37b8d5b380d7f4$var$react_1 = $0e37b8d5b380d7f4$var$__importDefault((parcelRequire("acw62")));

const $0e37b8d5b380d7f4$var$classnames_1 = $0e37b8d5b380d7f4$var$__importDefault((parcelRequire("8g1PZ")));
const $0e37b8d5b380d7f4$var$zillow = (_a)=>{
    var { className: className } = _a, rest = $0e37b8d5b380d7f4$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $0e37b8d5b380d7f4$var$classnames_1.default)("helix-icon", "zillow-outlined", className);
    return $0e37b8d5b380d7f4$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $0e37b8d5b380d7f4$var$react_1.default.createElement("path", {
        d: "M6.77554 15.8157C6.71722 15.8462 6.66972 15.8385 6.62281 15.7928L5.3174 14.2756C5.28252 14.2334 5.27831 14.2105 5.32522 14.146C6.33419 12.7051 8.39363 10.4595 9.70687 9.5106C9.73032 9.49535 9.7225 9.47599 9.69484 9.48772C8.32689 9.92229 4.4383 11.5538 3 12.3467V17.5H16.9964V12.5373C15.0891 12.8534 9.37495 14.512 6.77554 15.8157V15.8157ZM12.4662 6.54485C12.5366 6.5296 12.5678 6.55247 12.6105 6.59821C12.8529 6.86095 13.6273 7.78346 13.8378 8.03505C13.8769 8.0808 13.8498 8.13065 13.8185 8.15704C12.2552 9.34639 10.5156 11.0313 9.54632 12.2359C9.52708 12.2629 9.54271 12.2629 9.55835 12.2588C11.2468 11.5497 15.2135 10.4173 17 10.1012V7.8943L10.0081 2.5L3.00421 7.8902V10.3029C5.17309 9.04553 10.1915 7.09729 12.4662 6.54485V6.54485Z",
        fill: "#4B5563"
    }));
};
module.exports.zillow = $0e37b8d5b380d7f4$var$zillow;

});

parcelRegister("7P9zw", function(module, exports) {
"use strict";
var $5b24b8a2eab344ba$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $5b24b8a2eab344ba$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.zoom_in = void 0;

/* eslint-disable max-len */ const $5b24b8a2eab344ba$var$react_1 = $5b24b8a2eab344ba$var$__importDefault((parcelRequire("acw62")));

const $5b24b8a2eab344ba$var$classnames_1 = $5b24b8a2eab344ba$var$__importDefault((parcelRequire("8g1PZ")));
const $5b24b8a2eab344ba$var$zoom_in = (_a)=>{
    var { className: className } = _a, rest = $5b24b8a2eab344ba$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $5b24b8a2eab344ba$var$classnames_1.default)("helix-icon", "zoom-in-outlined", className);
    return $5b24b8a2eab344ba$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $5b24b8a2eab344ba$var$react_1.default.createElement("path", {
        d: "M9 5C9.41421 5 9.75 5.33579 9.75 5.75V8.25H12.25C12.6642 8.25 13 8.58579 13 9C13 9.41421 12.6642 9.75 12.25 9.75H9.75V12.25C9.75 12.6642 9.41421 13 9 13C8.58579 13 8.25 12.6642 8.25 12.25V9.75H5.75C5.33579 9.75 5 9.41421 5 9C5 8.58579 5.33579 8.25 5.75 8.25H8.25V5.75C8.25 5.33579 8.58579 5 9 5Z",
        fill: "#4B5563"
    }), $5b24b8a2eab344ba$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9 2.25C5.27208 2.25 2.25 5.27208 2.25 9C2.25 12.7279 5.27208 15.75 9 15.75C10.5938 15.75 12.0585 15.1976 13.2133 14.2739L15.9697 17.0303C16.2626 17.3232 16.7374 17.3232 17.0303 17.0303C17.3232 16.7374 17.3232 16.2626 17.0303 15.9697L14.2739 13.2133C15.1976 12.0585 15.75 10.5938 15.75 9C15.75 5.27208 12.7279 2.25 9 2.25ZM3.75 9C3.75 6.10051 6.10051 3.75 9 3.75C11.8995 3.75 14.25 6.10051 14.25 9C14.25 11.8995 11.8995 14.25 9 14.25C6.10051 14.25 3.75 11.8995 3.75 9Z",
        fill: "#4B5563"
    }));
};
module.exports.zoom_in = $5b24b8a2eab344ba$var$zoom_in;

});

parcelRegister("3Em02", function(module, exports) {
"use strict";
var $2a862c32720c1c33$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $2a862c32720c1c33$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.zoom_out = void 0;

/* eslint-disable max-len */ const $2a862c32720c1c33$var$react_1 = $2a862c32720c1c33$var$__importDefault((parcelRequire("acw62")));

const $2a862c32720c1c33$var$classnames_1 = $2a862c32720c1c33$var$__importDefault((parcelRequire("8g1PZ")));
const $2a862c32720c1c33$var$zoom_out = (_a)=>{
    var { className: className } = _a, rest = $2a862c32720c1c33$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $2a862c32720c1c33$var$classnames_1.default)("helix-icon", "zoom-out-outlined", className);
    return $2a862c32720c1c33$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $2a862c32720c1c33$var$react_1.default.createElement("path", {
        d: "M5.75 8.25C5.33579 8.25 5 8.58579 5 9C5 9.41421 5.33579 9.75 5.75 9.75H12.25C12.6642 9.75 13 9.41421 13 9C13 8.58579 12.6642 8.25 12.25 8.25H5.75Z",
        fill: "#4B5563"
    }), $2a862c32720c1c33$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9 2.25C5.27208 2.25 2.25 5.27208 2.25 9C2.25 12.7279 5.27208 15.75 9 15.75C10.5938 15.75 12.0585 15.1976 13.2133 14.2739L15.9697 17.0303C16.2626 17.3232 16.7374 17.3232 17.0303 17.0303C17.3232 16.7374 17.3232 16.2626 17.0303 15.9697L14.2739 13.2133C15.1976 12.0585 15.75 10.5938 15.75 9C15.75 5.27208 12.7279 2.25 9 2.25ZM3.75 9C3.75 6.10051 6.10051 3.75 9 3.75C11.8995 3.75 14.25 6.10051 14.25 9C14.25 11.8995 11.8995 14.25 9 14.25C6.10051 14.25 3.75 11.8995 3.75 9Z",
        fill: "#4B5563"
    }));
};
module.exports.zoom_out = $2a862c32720c1c33$var$zoom_out;

});



parcelRegister("ikyhZ", function(module, exports) {

$parcel$export(module.exports, "listingStatuses", () => $d584b15e3571e2a5$export$88b4894c2b970899);

var $bLQRh = parcelRequire("bLQRh");
const $d584b15e3571e2a5$export$88b4894c2b970899 = Object.freeze({
    units0To90: {
        label: (0, $bLQRh.terms).units0To90,
        id: "units0To90"
    },
    units91To180: {
        label: (0, $bLQRh.terms).units91To180,
        id: "units91To180"
    },
    unitsOver180: {
        label: (0, $bLQRh.terms).unitsOver180,
        id: "unitsOver180"
    },
    averageCdom: {
        label: (0, $bLQRh.terms).avgCdom,
        id: "averageCdom"
    },
    averageDom: {
        label: (0, $bLQRh.terms).avgDom,
        id: "averageDom"
    },
    averagePrice: {
        label: (0, $bLQRh.terms).avgPrice,
        id: "averagePrice"
    },
    expired: {
        label: (0, $bLQRh.terms).expired,
        id: "expired"
    },
    forSale: {
        label: (0, $bLQRh.terms).forSale,
        id: "forSale"
    },
    forSaleLdm: {
        label: (0, $bLQRh.terms).forSaleLdm,
        id: "forSaleLdm"
    },
    medianPrice: {
        label: (0, $bLQRh.terms).medianPrice,
        id: "medianPrice"
    },
    newListings: {
        label: (0, $bLQRh.terms).newListings,
        id: "newListings"
    },
    sold: {
        label: (0, $bLQRh.terms).sold,
        id: "sold"
    },
    spLpNoPriceChanges: {
        label: (0, $bLQRh.terms).spLpNoPriceChanges,
        id: "spLpNoPriceChanges"
    },
    spLpPriceChanges: {
        label: (0, $bLQRh.terms).spLpPriceChanges,
        id: "spLpPriceChanges"
    },
    spOp: {
        label: (0, $bLQRh.terms).spOp,
        id: "spOp"
    },
    spOpNoPriceChanges: {
        label: (0, $bLQRh.terms).spOpNoPriceChanges,
        id: "spOpNoPriceChanges"
    },
    spOpPriceChanges: {
        label: (0, $bLQRh.terms).spOpPriceChanges,
        id: "spOpPriceChanges"
    },
    underContract: {
        label: (0, $bLQRh.terms).underContract,
        id: "underContract"
    },
    underContractUc: {
        label: (0, $bLQRh.terms).underContractUc,
        id: "underContractUc"
    },
    underContractMsi: {
        label: (0, $bLQRh.terms).underContractMsi,
        id: "underContractMsi"
    },
    msiSold: {
        label: (0, $bLQRh.terms).msiSold,
        id: "msiSold"
    }
});

});
parcelRegister("bLQRh", function(module, exports) {

$parcel$export(module.exports, "terms", () => $891d1612283a2a1d$export$8a21ba990ca4a7cb);
$parcel$export(module.exports, "errorMessaging", () => $891d1612283a2a1d$export$1cf0a3bed8c3e470);
$parcel$export(module.exports, "periodKeys", () => $891d1612283a2a1d$export$3b856bb366a307a1);
$parcel$export(module.exports, "measureTypeKeys", () => $891d1612283a2a1d$export$3cc7a9c972f30cb5);
$parcel$export(module.exports, "measureTypeByConfigKey", () => $891d1612283a2a1d$export$9448ec04b45c1497);
$parcel$export(module.exports, "barChartColors", () => $891d1612283a2a1d$export$8d867164a52c6903);
$parcel$export(module.exports, "marketDynamicsColors", () => $891d1612283a2a1d$export$222f5740fc8c55c7);
$parcel$export(module.exports, "chartFontFamily", () => $891d1612283a2a1d$export$9c252c65d90245da);
$parcel$export(module.exports, "chartLabelStyles", () => $891d1612283a2a1d$export$1d423f02b5c404d7);
$parcel$export(module.exports, "getYAxisTitle", () => $891d1612283a2a1d$export$c269478bdea0507e);
$parcel$export(module.exports, "measureTypes", () => $891d1612283a2a1d$export$7487417b3b220601);
$parcel$export(module.exports, "officeBreakdownTab", () => $891d1612283a2a1d$export$99612e80acd36cef);
$parcel$export(module.exports, "marketTypes", () => $891d1612283a2a1d$export$4f4a3b7e312b03a1);
$parcel$export(module.exports, "marketDynamicsTableViewNames", () => $891d1612283a2a1d$export$f976225db22cdf1e);

var $cstaF = parcelRequire("cstaF");

var $jUjGS = parcelRequire("jUjGS");
const $891d1612283a2a1d$export$8a21ba990ca4a7cb = Object.freeze({
    activeForSale: "Active (For Sale)",
    dom: "DOM",
    avgCdom: "Average CDOM",
    avgDom: "Average DOM",
    avgDomCdom: "Average DOM-CDOM",
    avgPrice: "Average Price",
    avgPriceSqft: "Average $/SQFT",
    avgPricePerSqft: "per SQFT",
    avgPriceSqftLabel: (status)=>`${status} $/SQFT`,
    avgSpLpComparison: "Average SP/LP Comparison",
    avgSpOp: "Avg SP/OP",
    avgSpOpAllComparison: "Average SP/OP Comparison",
    avgSpOpAllProperties: "Average SP/OP All Properties",
    avgSpOpComparison: "Average SP/OP Comparison",
    bathrooms: "Bathrooms",
    begin: "begin",
    beginVsEndMonthLabel: "Begin vs. End Month",
    beginPeriod: (selectedBeginValue)=>`Begin: ${selectedBeginValue}`,
    cdomBreakout: "CDOM Breakout",
    cdom: "CDOM",
    change: "Change",
    change$: "$ Change",
    changePct: "% Change",
    custom: "custom",
    days: "Days",
    daysChange: "Days Change",
    end: "end",
    endPeriod: (selectedEndValue)=>`End: ${selectedEndValue}`,
    expAvgDom: "Expired Avg Dom",
    expAvgPricePerSqft: "Expired $/Sqft",
    expAvgSqft: "Avg Sqft Expired",
    expAvgVolume: "Avg Expired $",
    expired: "Expired",
    expMedianVolume: "Expired Median $",
    expUnits: "# Expired",
    forSale: "For Sale",
    forSaleAvgDom: "For Sale Avg Dom",
    forSaleAvgPricePerSqft: "For Sale $/Sqft",
    forSaleAvgSqft: "Avg Sqft For Sale",
    forSaleAvgVolume: "Avg For Sale $",
    forSaleLastDayUnits: "# For Sale Last Day of Month",
    forSaleLastDayUnitsTip: "The number of listings that were for sale on the last day of the month",
    forSaleMedianVolume: "For Sale Median $",
    forSaleUnits: "# For Sale",
    forSaleUnitsParens: "For Sale (Units)",
    forSaleVolumeParens: "For Sale (Volume)",
    forSaleVsFsldm: "For Sale vs. FSLDM",
    forSaleLdm: "For Sale Last Day of the Month",
    fsldm: "FSLDM",
    forSaleLastDayChangeVolume: "# For Sale - # For Sale Last Day Difference",
    forSaleLastDayChangeVolumeTip: "Difference between the number of listings that were for sale during the month and the number of listings that were for sale on the last day of the month",
    percentDifference: "% Difference",
    percentDifferenceTip: "Difference between the number of listings that were for sale during the month and the number of listings that were for sale on the last day of the month as a percentage of the number of listings for sale during the month",
    itemTypeCount: (itemType, countOfItems)=>`${itemType} (${countOfItems})`,
    lastWeeksAvg: "Last 12 weeks avg",
    lastWeeksAvgTip: "The average for the last 12 weeks",
    listingViews: "Listing Views",
    medianPrice: "Median Price",
    medianPriceChange: "Median price change",
    medianPriceSold: "Median Price (Sold)",
    month: "Month",
    monthly: "Monthly",
    monthlySupplyOfInventory: "Monthly Supply of Inventory",
    months: "Months",
    monthsSupply: "Months Supply",
    msiChange: "MSI Change",
    msiSold: "MSI-Sold",
    newAvgPricePerSqft: "New $/Sqft",
    newAvgSqft: "Avg Sqft New",
    newAvgVolume: "Avg New $",
    newListings: "New Listings",
    newMedianVolume: "New Listing Median $",
    newUnits: "# New Listed",
    offMarketDate: "Off Market Date",
    orgPrice: "Org. Price",
    overview: "Overview",
    pdf: "PDF",
    percentage: "Percentage",
    periodChange: (period)=>`${period} Change`,
    periodPercentChange: (period)=>`${period} % Change`,
    previousWeeksAvg: "Prev 12 weeks avg",
    previousWeeksAvgTip: "The average for the previous 12 weeks",
    price: "Price",
    pricePerSqft: "$/SQFT",
    quarter: "Quarter",
    quarterly: "Quarterly",
    salesAbsorption: "Sales Absorption",
    salesPriceOriginalPrice: "Sales Price / Original Price",
    salesRate: "Sales Rate",
    sold: "Sold",
    soldAvgDom: "Sold Avg Dom",
    soldAvgDomWithoutPriceChanges: "Avg DOM - No Price Changes",
    soldAvgDomWithPriceChanges: "Avg DOM - 1+ Price Changes",
    soldAvgPricePerSqft: "Sold $/Sqft",
    soldAvgSqft: "Avg Sqft Sold",
    soldAvgVolume: "Avg Sold $",
    soldAvgVsMedianPrice: "Sold Average vs. Median Price",
    soldChangeVolume: "Average $ - Median $",
    soldGrowthVolumePct: "Median $ as % of Average $",
    soldMedianVolume: "Sold Median $",
    soldPercentage: "% Sold",
    soldUnits: "# Sold",
    soldUnitsParens: "Sold (Units)",
    soldUnitsWithoutPriceChanges: "# Sold - No Price Changes",
    soldUnitsWithPriceChanges: "# Sold - 1+ Price Changes",
    soldVolumeParens: "Sold (Volume)",
    spLp: "SP/LP",
    spLpNoPriceChanges: "SP/LP No Price Changes",
    spLpPriceChanges: "SP/LP 1+ Price Changes",
    spLpRatioWithoutPriceChanges: "Avg SP/LP - No Price Changes",
    spLpRatioWithPriceChanges: "Avg SP/LP - 1+ Price Changes",
    spOp: "SP/OP",
    spOpNoPriceChanges: "SP/OP No Price Changes",
    spOpPriceChanges: "SP/OP 1+ Price Changes",
    spOpRatioWithoutPriceChanges: "Avg SP/OP - No Price Changes",
    spOpRatioWithPriceChanges: "Avg SP/OP - 1+ Price Changes",
    status: "status",
    sqFt: "Sq Ft",
    supplyAmpDemand: "Supply & Demand",
    supplyAmpDemandNumUnits: "Supply & Demand - # Units",
    timePeriodStart: "Period",
    totalChange: "Total Change",
    totalPercentChange: "Total % Change",
    ucAvgDom: "Under Contract Avg Dom",
    ucAvgPricePerSqft: "Under Contract $/Sqft",
    ucAvgSqft: "Avg Sqft Under Contract",
    ucAvgVolume: "Avg Under Contract $",
    ucMedianVolume: "Under Contract Median $",
    ucPercentage: "% Under Contract",
    ucUnits: "# Under Contract",
    ucUnitsParens: "Under Contract (Units)",
    ucVolumeParens: "Under Contract (Volume)",
    underContract: "Under Contract",
    underContractMsi: "MSI-Under Contract",
    underContractUc: "Under Contract (UC)",
    units: "Units",
    units0To90: "0 - 90",
    units0To90Cdom: "0 - 90 CDOM",
    units0To90CdomPct: "0 - 90 CDOM %",
    units91To180: "91 - 180",
    units91To180Cdom: "91 - 180 CDOM",
    units91To180CdomPct: "91 - 180 CDOM %",
    unitsChangeNum: "# Units Change",
    unitsNum: "# Units",
    unitsOver180: "181+",
    unitsOver180Cdom: "181+ CDOM",
    unitsOver180CdomPct: "181+ CDOM %",
    weekLabel: (week)=>`W${week}`,
    week: "Week",
    weekly: "Weekly",
    weekOf: "Week Of",
    wholeTimePeriodLabel: "Whole Time Period",
    yAxisDollarChartTitle: "Dollars in Thousands",
    msi: "MSI",
    loneWolfMarketDynamics: "Lone Wolf Market Dynamics",
    report: "Report",
    monthlySupplyOfInventoryMSI: "Monthly Supply of Inventory (MSI)",
    totalInventoryVolume: "Total Inventory ($)",
    totalInventoryUnit: "Total Inventory (#)",
    increase: "Increase",
    decrease: "Decrease",
    sellers: "Seller's",
    buyers: "Buyer's",
    neutral: "Neutral",
    getMarketTypeText: (marketType)=>`It's a ${marketType} Market!`,
    getListingTitle: (title)=>`${(0, $cstaF.agentProductionTerms).listings} (${title})`,
    buyersMarketDescription: "Homes are typically on the market for more than 6 months before selling, which suggests buyers may face less competition, and sellers might be more flexible on terms and conditions.",
    neutralMarketDescription: "Homes are typically selling within 4 to 6 months, indicating a stable market.",
    sellersMarketDescription: "Homes are typically selling in under 4 months. This means buyers may face more competition for properties they love and should consider making more competitive offers.",
    loneWolfMarketShare: "Lone Wolf Market Share",
    loneWolfProficiencyMetrics: "Lone Wolf Proficiency Metrics",
    getBySearchTypeTitle: (searchType)=>`By ${searchType}`,
    loneWolfAgentProduction: "Lone Wolf Agent Production"
});
const $891d1612283a2a1d$export$1cf0a3bed8c3e470 = Object.freeze({
    cannotBeEmptyObject: "Invalid parameter: cannot be an empty object.",
    convertToPdf: "Error converting to PDF:",
    fetchOffices: "Error fetching offices",
    getFetchErrorMsg: (fetchItem)=>`Error fetching ${fetchItem}`
});
const $891d1612283a2a1d$export$3b856bb366a307a1 = Object.freeze({
    beginPeriodValue: "beginPeriodValue",
    endPeriodValue: "endPeriodValue",
    beginVsEndMonth: "beginVsEndMonth",
    wholeTimePeriod: "wholeTimePeriod"
});
const $891d1612283a2a1d$export$3cc7a9c972f30cb5 = Object.freeze({
    percent: "percent",
    unit: "unit",
    volume: "volume"
});
const $891d1612283a2a1d$export$9448ec04b45c1497 = Object.freeze({
    headerTooltipPercentType: $891d1612283a2a1d$export$3cc7a9c972f30cb5.percent,
    headerTooltipUnitType: $891d1612283a2a1d$export$3cc7a9c972f30cb5.unit
});
const $891d1612283a2a1d$export$8d867164a52c6903 = Object.freeze({
    first: (0, $jUjGS.COLOR_PRIMARY_GREEN),
    second: (0, $jUjGS.COLOR_SECONDARY_GREEN),
    third: (0, $jUjGS.COLOR_TERTIARY_GREEN),
    firstTransparency: "rgba(35, 104, 71, 0.2)",
    secondTransparency: "rgba(101, 150, 127, 0.2)",
    thirdTransparency: "rgba(167, 195, 181, 0.2)",
    pureWhite: "#fff"
});
const $891d1612283a2a1d$export$222f5740fc8c55c7 = {
    bars: [
        $891d1612283a2a1d$export$8d867164a52c6903.first,
        $891d1612283a2a1d$export$8d867164a52c6903.second,
        $891d1612283a2a1d$export$8d867164a52c6903.third
    ],
    barsTransparency: [
        $891d1612283a2a1d$export$8d867164a52c6903.firstTransparency,
        $891d1612283a2a1d$export$8d867164a52c6903.secondTransparency,
        $891d1612283a2a1d$export$8d867164a52c6903.thirdTransparency
    ]
};
const $891d1612283a2a1d$export$9c252c65d90245da = '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"';
const $891d1612283a2a1d$export$1d423f02b5c404d7 = {
    colors: [
        "#111827"
    ],
    fontFamily: $891d1612283a2a1d$export$9c252c65d90245da,
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "16px"
};
const $891d1612283a2a1d$export$c269478bdea0507e = (title)=>({
        text: title,
        style: {
            ...$891d1612283a2a1d$export$1d423f02b5c404d7,
            fontWeight: 600,
            colors: [
                "#6B7280"
            ]
        }
    });
const $891d1612283a2a1d$export$7487417b3b220601 = Object.freeze({
    units: "units"
});
const $891d1612283a2a1d$export$99612e80acd36cef = 0;
const $891d1612283a2a1d$export$4f4a3b7e312b03a1 = Object.freeze({
    sellers: "sellers",
    buyers: "buyers",
    neutral: "neutral"
});
const $891d1612283a2a1d$export$f976225db22cdf1e = Object.freeze({
    avgPriceSqft: "avgPriceSqft",
    avgDomCdom: "avgDomCdom",
    avgSpLpComparison: "avgSpLpComparison",
    avgSpOpAllProperties: "avgSpOpAllProperties",
    avgSpOpComparison: "avgSpOpComparison",
    cdomBreakout: "cdomBreakout",
    forSaleVsFsldm: "forSaleVsFsldm",
    medianPrice: "medianPrice",
    monthlySupplyOfInventory: "monthlySupplyOfInventory",
    salesAbsorption: "salesAbsorption",
    soldAvgVsMedianPrice: "soldAvgVsMedianPrice",
    supplyAmpDemandNumUnits: "supplyAmpDemandNumUnits",
    underContractUc: "underContractUc",
    newListings: "newListings",
    forSale: "forSale",
    forSaleLdm: "forSaleLdm",
    underContract: "underContract",
    sold: "sold",
    expired: "expired"
});

});
parcelRegister("jUjGS", function(module, exports) {

$parcel$export(module.exports, "COLOR_PRIMARY_GREEN", () => $e7e28569f075fdf7$export$fe0f60531efc9071);
$parcel$export(module.exports, "COLOR_SECONDARY_GREEN", () => $e7e28569f075fdf7$export$45d3034f40e54a84);
$parcel$export(module.exports, "COLOR_TERTIARY_GREEN", () => $e7e28569f075fdf7$export$e731390f306792b5);
const $e7e28569f075fdf7$export$fe0f60531efc9071 = "rgba(35, 104, 71, 1)";
const $e7e28569f075fdf7$export$45d3034f40e54a84 = "rgba(101, 150, 127, 1)";
const $e7e28569f075fdf7$export$e731390f306792b5 = "rgba(167, 195, 181, 1)";

});






parcelRegister("gDxKE", function(module, exports) {

$parcel$export(module.exports, "removeSearchAllMLSFlag", () => $c1ca78371467548b$export$d54108121abfa8df);
$parcel$export(module.exports, "getPostRequestObj", () => $c1ca78371467548b$export$1a76746432614d9c);
$parcel$export(module.exports, "getPostRequestObjNoToken", () => $c1ca78371467548b$export$f7d33cb6e4a6e3d6);
$parcel$export(module.exports, "getRequestObjectByMethodType", () => $c1ca78371467548b$export$c6ff9b5298d43487);
$parcel$export(module.exports, "handleApiError", () => $c1ca78371467548b$export$bd98d6b2b559620a);

var $i1BZc = parcelRequire("i1BZc");

var $ddjPx = parcelRequire("ddjPx");
const $c1ca78371467548b$export$d54108121abfa8df = (criteriaObj)=>{
    criteriaObj.criteria?.realEstateDatasourceIdsWithFilters?.forEach((mls)=>{
        delete mls.searchAllMLS;
    });
    return criteriaObj;
};
const $c1ca78371467548b$export$1a76746432614d9c = (url, token, data, activeClientId)=>{
    const activeClientIdHeader = activeClientId ? {
        "Lwt-Active-Client-Id": activeClientId
    } : {};
    return new Request(url, {
        method: (0, $i1BZc.apiRequestTypes).post,
        headers: new Headers({
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
            ...activeClientIdHeader
        }),
        mode: "cors",
        cache: "default",
        body: data ? JSON.stringify(data) : ""
    });
};
const $c1ca78371467548b$export$2526e1221a081e91 = (url, token, queryString, activeClientId)=>{
    const requestUrl = queryString ? `${url}?${queryString}` : url;
    const activeClientIdHeader = activeClientId ? {
        "Lwt-Active-Client-Id": activeClientId
    } : {};
    return new Request(requestUrl, {
        method: (0, $i1BZc.apiRequestTypes).get,
        headers: new Headers({
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
            ...activeClientIdHeader
        }),
        mode: "cors",
        cache: "no-store"
    });
};
const $c1ca78371467548b$export$93ba2279cf8214c9 = (url, token, queryString)=>{
    const requestUrl = queryString ? `${url}?${queryString}` : url;
    return new Request(requestUrl, {
        method: (0, $i1BZc.apiRequestTypes).delete,
        headers: new Headers({
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        }),
        mode: "cors"
    });
};
const $c1ca78371467548b$export$72a73ebc0d5be08e = (url, token, data)=>{
    return new Request(url, {
        method: (0, $i1BZc.apiRequestTypes).put,
        headers: new Headers({
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        }),
        mode: "cors",
        body: JSON.stringify(data)
    });
};
const $c1ca78371467548b$export$f7d33cb6e4a6e3d6 = (url, data)=>{
    return new Request(url, {
        method: (0, $i1BZc.apiRequestTypes).post,
        headers: new Headers({
            "Content-Type": "application/x-www-form-urlencoded"
        }),
        mode: "cors",
        cache: "default",
        body: data
    });
};
const $c1ca78371467548b$export$c6ff9b5298d43487 = ({ url: url, token: token, activeClientId: activeClientId, data: data, queryString: queryString })=>Object.freeze({
        [(0, $i1BZc.apiRequestTypes).post]: $c1ca78371467548b$export$1a76746432614d9c(url, token, data, activeClientId),
        [(0, $i1BZc.apiRequestTypes).get]: $c1ca78371467548b$export$2526e1221a081e91(url, token, queryString, activeClientId)
    });
const $c1ca78371467548b$export$bd98d6b2b559620a = ({ response: response, endpoint: endpoint, customErrorMessage: customErrorMessage = null, suppressToast: suppressToast = false })=>{
    if ((response.status === 400 || response.status === 500) && !suppressToast) {
        const message = customErrorMessage || (0, $i1BZc.API_ERROR_MESSAGES)[response.status];
        (0, $ddjPx.useToastStore).getState().showToast(message, "error");
        console.error("[API Error]", {
            endpoint: endpoint,
            status: response.status,
            statusText: response.statusText,
            timestamp: new Date().toISOString()
        });
    }
};

});
parcelRegister("i1BZc", function(module, exports) {

$parcel$export(module.exports, "urlKeycloakToken", () => $d1f5c93a6d6cef8f$export$85c142121c284c64);
$parcel$export(module.exports, "urlPlatformLaunch", () => $d1f5c93a6d6cef8f$export$7cfe85d8e021b9b0);
$parcel$export(module.exports, "urlPlatformConnection", () => $d1f5c93a6d6cef8f$export$5600a6b52d8be01d);
$parcel$export(module.exports, "urlPlatformAuth", () => $d1f5c93a6d6cef8f$export$2d4617f88609488f);
$parcel$export(module.exports, "urlPlatformHome", () => $d1f5c93a6d6cef8f$export$622dc700dae21780);
$parcel$export(module.exports, "MAX_ENDPOINT_RETRIES", () => $d1f5c93a6d6cef8f$export$53f94cf0a743f5b9);
$parcel$export(module.exports, "CANCELED_ENDPOINT_CODE", () => $d1f5c93a6d6cef8f$export$29d4103011448dbc);
$parcel$export(module.exports, "responseKeys", () => $d1f5c93a6d6cef8f$export$d5e7aed3caab5530);
$parcel$export(module.exports, "HTTP_RESPONSES", () => $d1f5c93a6d6cef8f$export$da846e1f3d5567fe);
$parcel$export(module.exports, "API_ERROR_MESSAGES", () => $d1f5c93a6d6cef8f$export$cfb35c486fe958b9);
$parcel$export(module.exports, "apiRequestTypes", () => $d1f5c93a6d6cef8f$export$1d9bcbcf29f38a94);

var $7AubO = parcelRequire("7AubO");

var $dDBOF = parcelRequire("dDBOF");
const $d1f5c93a6d6cef8f$var$getLwaRoutes = (params)=>({
        CONFIRM_CONNECTION: `/product/confirm-connection${params || ""}`,
        LAUNCH_PRODUCT: `/product/launch${params || ""}`,
        AUTH: `/authenticate${params || ""}`
    });
const $d1f5c93a6d6cef8f$var$buildAuthParams = (authParams)=>{
    const paramsArray = [
        `${authParams?.email ? `e=${encodeURIComponent(authParams?.email)}` : ""}`,
        `${authParams?.mode ? `&sc=${authParams?.mode}` : ""}`,
        `${authParams?.redirectUrl ? `&r=${encodeURIComponent(authParams?.redirectUrl)}` : ""}`
    ];
    return paramsArray.join("");
};
const $d1f5c93a6d6cef8f$var$getLwaRouteParams = ({ lwid: lwid, authParams: authParams } = {})=>({
        APP: `?a=${(0, $dDBOF.appIdByAppName)[0, $dDBOF.runningApp]}`,
        LWID: `?i=${lwid}`,
        AUTH: `?${$d1f5c93a6d6cef8f$var$buildAuthParams(authParams)}`
    });
const $d1f5c93a6d6cef8f$export$85c142121c284c64 = `${(0, $7AubO.getEndpoint)((0, $7AubO.ID_SITE))}/auth/realms/terradatum/protocol/openid-connect/token`;
const $d1f5c93a6d6cef8f$export$7cfe85d8e021b9b0 = `${(0, $7AubO.getEndpoint)((0, $7AubO.LWA_PLATFORM))}${$d1f5c93a6d6cef8f$var$getLwaRoutes($d1f5c93a6d6cef8f$var$getLwaRouteParams().APP).LAUNCH_PRODUCT}${(0, $7AubO.getEndpoint)((0, $7AubO.LOCAL_LAUNCH))}`;
const $d1f5c93a6d6cef8f$export$5600a6b52d8be01d = (lwid)=>`${(0, $7AubO.getEndpoint)((0, $7AubO.LWA_PLATFORM))}${$d1f5c93a6d6cef8f$var$getLwaRoutes($d1f5c93a6d6cef8f$var$getLwaRouteParams({
        lwid: lwid
    }).LWID).CONFIRM_CONNECTION}`;
const $d1f5c93a6d6cef8f$export$2d4617f88609488f = (authParams)=>`${(0, $7AubO.getEndpoint)((0, $7AubO.LWA_PLATFORM))}${$d1f5c93a6d6cef8f$var$getLwaRoutes($d1f5c93a6d6cef8f$var$getLwaRouteParams({
        authParams: authParams
    }).AUTH).AUTH}`;
const $d1f5c93a6d6cef8f$export$622dc700dae21780 = (0, $7AubO.getEndpoint)((0, $7AubO.LWA_PLATFORM));
const $d1f5c93a6d6cef8f$export$53f94cf0a743f5b9 = 5;
const $d1f5c93a6d6cef8f$export$29d4103011448dbc = 20;
const $d1f5c93a6d6cef8f$export$d5e7aed3caab5530 = {
    recruitingSoldTotals: "recruitingSoldTotals",
    results: "results",
    totals: "totals"
};
const $d1f5c93a6d6cef8f$export$da846e1f3d5567fe = Object.freeze({
    badRequest: 400,
    unauthorized: 401,
    forbidden: 403,
    notFound: 404,
    conflict: 409,
    payloadTooLarge: 413
});
const $d1f5c93a6d6cef8f$export$cfb35c486fe958b9 = Object.freeze({
    400: "Unable to update the item. Please review any dependencies and try again.",
    500: "Oops! Something went wrong with our server. Please try again in a bit."
});
const $d1f5c93a6d6cef8f$export$1d9bcbcf29f38a94 = Object.freeze({
    post: "POST",
    get: "GET",
    delete: "DELETE",
    put: "PUT"
});

});
parcelRegister("dDBOF", function(module, exports) {

$parcel$export(module.exports, "appIds", () => $9edc406817ed13ca$export$201da43cfe4f90a6);
$parcel$export(module.exports, "appNames", () => $9edc406817ed13ca$export$f6cff281e71e2797);
$parcel$export(module.exports, "appLabels", () => $9edc406817ed13ca$export$78e92b0faae2ef7a);
$parcel$export(module.exports, "appIdByAppName", () => $9edc406817ed13ca$export$19c4d280fbe28c64);
$parcel$export(module.exports, "runningApp", () => $9edc406817ed13ca$export$761dc8ff81ee3287);
$parcel$export(module.exports, "isAgentMetrics", () => $9edc406817ed13ca$export$271349ca0945b158);
$parcel$export(module.exports, "getIsLoginPage", () => $9edc406817ed13ca$export$744848fcfa7c0d33);
$parcel$export(module.exports, "getDocumentTitle", () => $9edc406817ed13ca$export$a7094bd2502cf2ff);

var $cstaF = parcelRequire("cstaF");
const $9edc406817ed13ca$export$201da43cfe4f90a6 = {
    xam: "xam",
    xbm: "xbm"
};
const $9edc406817ed13ca$export$f6cff281e71e2797 = {
    XAM: "AGENT_METRICS",
    XBM: "BROKER_METRICS"
};
const $9edc406817ed13ca$export$78e92b0faae2ef7a = {
    [$9edc406817ed13ca$export$f6cff281e71e2797.XAM]: "AgentMetrics",
    [$9edc406817ed13ca$export$f6cff281e71e2797.XBM]: "BrokerMetrics"
};
const $9edc406817ed13ca$export$19c4d280fbe28c64 = {
    [$9edc406817ed13ca$export$f6cff281e71e2797.XAM]: $9edc406817ed13ca$export$201da43cfe4f90a6.xam,
    [$9edc406817ed13ca$export$f6cff281e71e2797.XBM]: $9edc406817ed13ca$export$201da43cfe4f90a6.xbm
};
const $9edc406817ed13ca$var$getIsAgentMetrics = (hostname)=>hostname.toLowerCase().indexOf("agentmetrics") >= 0;
const $9edc406817ed13ca$export$f085fd26677360cf = (hostname)=>$9edc406817ed13ca$var$getIsAgentMetrics(hostname) ? $9edc406817ed13ca$export$f6cff281e71e2797.XAM : $9edc406817ed13ca$export$f6cff281e71e2797.XBM;
const $9edc406817ed13ca$export$761dc8ff81ee3287 = $9edc406817ed13ca$export$f085fd26677360cf(window.location.host);
const $9edc406817ed13ca$export$271349ca0945b158 = $9edc406817ed13ca$export$761dc8ff81ee3287 === $9edc406817ed13ca$export$f6cff281e71e2797.XAM;
const $9edc406817ed13ca$export$744848fcfa7c0d33 = (pathname)=>pathname.toLowerCase().indexOf("login") >= 0;
const $9edc406817ed13ca$export$a7094bd2502cf2ff = ({ appLabel: appLabel, softwareVersion: softwareVersion, isLoginPage: isLoginPage })=>{
    if (isLoginPage) return (0, $cstaF.loginTerms).productSuite(appLabel);
    return `${appLabel} ${softwareVersion}`;
};

});


parcelRegister("ddjPx", function(module, exports) {

$parcel$export(module.exports, "useToastStore", () => $99ebdf1fb0b15c5d$export$7ddf4f33a29dd219);

var $f4OIt = parcelRequire("f4OIt");
const $99ebdf1fb0b15c5d$export$7ddf4f33a29dd219 = (0, $f4OIt.create)((set)=>({
        toastProps: null,
        showToast: (message, type = "error")=>{
            const toastProps = {
                id: Date.now(),
                message: message,
                color: type === "error" ? "danger" : "warning",
                icon: "error_outline_icon",
                border: "left",
                dismissTime: 5000
            };
            set({
                toastProps: toastProps
            });
        },
        clearToast: ()=>set({
                toastProps: null
            })
    }));

});


parcelRegister("f6CJ4", function(module, exports) {

$parcel$export(module.exports, "initialAuthState", () => $aff574b4584c80ac$export$a87928eef029cbb4);
$parcel$export(module.exports, "useAuthStore", () => $aff574b4584c80ac$export$650ce9f0b4df82fd);

var $9phu9 = parcelRequire("9phu9");

var $88tPr = parcelRequire("88tPr");

var $dEFf3 = parcelRequire("dEFf3");

var $c7dF9 = parcelRequire("c7dF9");
const $aff574b4584c80ac$export$a87928eef029cbb4 = {
    askMeLaterAttempts: 0,
    authErrorByRoute: {
        [(0, $c7dF9.Routes).AUTH.CONNECT]: undefined,
        [(0, $c7dF9.Routes).AUTH.LOG_IN]: undefined
    },
    errorLinkingLwa: undefined,
    isLegacyUser: undefined,
    isLoadingLinkLwa: false,
    lastAskMeLaterAt: undefined,
    platformServiceClient: undefined,
    shouldShowLinkLwaModal: false,
    token: undefined,
    tokenInfo: undefined,
    tokenType: undefined,
    ownerType: undefined,
    ownerId: undefined,
    isLoadingByRoute: {
        [(0, $c7dF9.Routes).AUTH.CONNECT]: false,
        [(0, $c7dF9.Routes).AUTH.LOG_IN]: false
    },
    activeClientId: undefined,
    isXamUserValidated: false
};
const $aff574b4584c80ac$var$authStore = (set, get)=>({
        ...$aff574b4584c80ac$export$a87928eef029cbb4,
        ...(0, $dEFf3.actions)(set, get)
    });
const $aff574b4584c80ac$export$650ce9f0b4df82fd = (0, $9phu9.createWithEqualityFn)((0, $88tPr.devtools)((0, $88tPr.persist)($aff574b4584c80ac$var$authStore, {
    name: "auth_state",
    storage: (0, $88tPr.createJSONStorage)(()=>localStorage)
})));

});
parcelRegister("9phu9", function(module, exports) {

$parcel$export(module.exports, "createWithEqualityFn", () => $6d940318c7b48507$export$c883e057baa24e24, (v) => $6d940318c7b48507$export$c883e057baa24e24 = v);
var $6d940318c7b48507$export$c883e057baa24e24;
var $6d940318c7b48507$export$2951cba41945c0c8;
"use strict";

var $acw62 = parcelRequire("acw62");

var $9b0Yv = parcelRequire("9b0Yv");

var $iNkrR = parcelRequire("iNkrR");
var $6d940318c7b48507$var$useSyncExternalStoreWithSelector = $9b0Yv.useSyncExternalStoreWithSelector;
function $6d940318c7b48507$var$useStoreWithEqualityFn(api, selector, equalityFn) {
    if (selector === void 0) selector = api.getState;
    var slice = $6d940318c7b48507$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getState, selector, equalityFn);
    $acw62.useDebugValue(slice);
    return slice;
}
var $6d940318c7b48507$var$createWithEqualityFnImpl = function createWithEqualityFnImpl(createState, defaultEqualityFn) {
    var api = $iNkrR.createStore(createState);
    var useBoundStoreWithEqualityFn = function useBoundStoreWithEqualityFn(selector, equalityFn) {
        if (equalityFn === void 0) equalityFn = defaultEqualityFn;
        return $6d940318c7b48507$var$useStoreWithEqualityFn(api, selector, equalityFn);
    };
    Object.assign(useBoundStoreWithEqualityFn, api);
    return useBoundStoreWithEqualityFn;
};
var $6d940318c7b48507$var$createWithEqualityFn = function createWithEqualityFn(createState, defaultEqualityFn) {
    return createState ? $6d940318c7b48507$var$createWithEqualityFnImpl(createState, defaultEqualityFn) : $6d940318c7b48507$var$createWithEqualityFnImpl;
};
$6d940318c7b48507$export$c883e057baa24e24 = $6d940318c7b48507$var$createWithEqualityFn;
$6d940318c7b48507$export$2951cba41945c0c8 = $6d940318c7b48507$var$useStoreWithEqualityFn;

});

parcelRegister("dEFf3", function(module, exports) {

$parcel$export(module.exports, "actions", () => $9f0f0093cb25c37c$export$e324594224ef24da);

var $2Eznr = parcelRequire("2Eznr");

var $b9LXY = parcelRequire("b9LXY");

var $6g8wQ = parcelRequire("6g8wQ");

var $2iCCW = parcelRequire("2iCCW");

var $caGGw = parcelRequire("caGGw");

var $f6CJ4 = parcelRequire("f6CJ4");

var $cghEn = parcelRequire("cghEn");

var $iCDWi = parcelRequire("iCDWi");

var $i1BZc = parcelRequire("i1BZc");

var $7D4kr = parcelRequire("7D4kr");

var $7AubO = parcelRequire("7AubO");

var $c7dF9 = parcelRequire("c7dF9");

var $lp3u9 = parcelRequire("lp3u9");

var $90ISC = parcelRequire("90ISC");

var $cstaF = parcelRequire("cstaF");

var $8cYiI = parcelRequire("8cYiI");

var $dDBOF = parcelRequire("dDBOF");

var $bBJbW = parcelRequire("bBJbW");

var $dFPJJ = parcelRequire("dFPJJ");

var $ivaD7 = parcelRequire("ivaD7");

var $lxCva = parcelRequire("lxCva");

var $3T9wI = parcelRequire("3T9wI");

var $9QNal = parcelRequire("9QNal");

var $8U25g = parcelRequire("8U25g");

var $gl8f4 = parcelRequire("gl8f4");
const $9f0f0093cb25c37c$export$e324594224ef24da = (set, get)=>({
        ...$9f0f0093cb25c37c$var$loginActions(set, get),
        incrementAskMeLaterAttempt: ()=>{
            if (get().isLoadingLinkLwa) return;
            const now = new Date();
            const currentAttempts = get().askMeLaterAttempts;
            set({
                askMeLaterAttempts: currentAttempts + 1,
                lastAskMeLaterAt: now,
                shouldShowLinkLwaModal: false
            });
        },
        handleShouldShowLinkLwaModal: (hasLwaId)=>{
            // This is temporary until we integrate Unified platform with Agent Metrics
            if (0, $dDBOF.isAgentMetrics) return;
            const lastAskedAt = new Date(get().lastAskMeLaterAt);
            const now = new Date();
            const dateDiffInDays = (0, $iCDWi.msToDays)(now - lastAskedAt);
            const shouldShowByDateDiff = isNaN(dateDiffInDays) || dateDiffInDays > 1;
            if (shouldShowByDateDiff && !hasLwaId) set({
                shouldShowLinkLwaModal: true
            });
        },
        sendLwaInvitation: async (user, token)=>{
            const userLWAinfo = await (0, $lp3u9.sendUserInvitation)(user, token);
            return userLWAinfo?.id;
        },
        handleLinkLwa: async (user)=>{
            if (get().isLoadingLinkLwa) return;
            try {
                set({
                    isLoadingLinkLwa: true
                });
                const lwid = await get().sendLwaInvitation(user);
                if (!lwid) {
                    get().setInvitationError();
                    return;
                }
                set({
                    isLoadingLinkLwa: false,
                    shouldShowLinkLwaModal: false
                });
                const redirectUrl = (0, $i1BZc.urlPlatformConnection)(lwid);
                const authParams = {
                    email: user.email,
                    redirectUrl: redirectUrl,
                    mode: (0, $cghEn.SIGN_UP_MODE)
                };
                (0, $7D4kr.navigateToPlatformAuth)(authParams);
            } catch (error) {
                get().setInvitationError();
            }
        },
        setInvitationError: ()=>{
            set({
                isLoadingLinkLwa: true,
                errorLinkingLwa: (0, $cstaF.validationMessages).unableToLink
            });
            setTimeout(()=>{
                set({
                    isLoadingLinkLwa: false,
                    shouldShowLinkLwaModal: false,
                    errorLinkingLwa: undefined
                });
            }, 3000);
        },
        authLwaUser: async (token, platformServiceClient)=>{
            const tokenInfo = (0, $2Eznr.default)(token);
            const ownerId = (0, $6g8wQ.getLwaIdFromTokenInfo)(tokenInfo).toLowerCase();
            set({
                error: undefined,
                platformServiceClient: platformServiceClient,
                token: token,
                tokenInfo: {
                    ...tokenInfo,
                    [(0, $cghEn.LWA_TOKEN_OBJECT_IDENTIFIER)]: {
                        ...tokenInfo[0, $cghEn.LWA_TOKEN_OBJECT_IDENTIFIER],
                        uid: ownerId
                    }
                },
                tokenType: (0, $cghEn.tokenTypes).LWA,
                ownerType: (0, $cstaF.ownerTypes).lwa,
                ownerId: ownerId
            });
            await (0, $gl8f4.recordLoginActivity)(token);
        },
        authKeycloakUser: async (state, setState, history1, redirectPath)=>{
            try {
                (0, $90ISC.useCommonStore).setState({
                    isLoading: true
                });
                setState((prev)=>({
                        ...prev,
                        isLoading: true
                    }));
                const updateUserType = (userType)=>{
                    (0, $90ISC.useCommonStore).setState({
                        isLoading: false
                    });
                    setState((prev)=>({
                            ...prev,
                            userType: userType,
                            isLoading: false
                        }));
                };
                const loginUser = async (token, isLegacy)=>{
                    await (0, $gl8f4.recordLoginActivity)(token);
                    get().setKeycloakToken(token, isLegacy);
                    if (isLegacy && redirectPath) {
                        history1.replace(redirectPath);
                        window.location.reload();
                        return;
                    }
                    (0, $7D4kr.navigateToHomeAndReload)(history1);
                };
                const token = await (0, $2iCCW.getKeycloakToken)((0, $i1BZc.urlKeycloakToken), state.emailValue, encodeURIComponent(state.passwordValue));
                if (token.error) {
                    updateUserType((0, $cghEn.getUserTypeByError)[token.error_description] || (0, $cghEn.userTypes).invalid);
                    return;
                }
                const accessToken = token.access_token;
                const decodedToken = (0, $2Eznr.default)(accessToken);
                const userAccounts = await (0, $caGGw.getUserAccounts)(decodedToken.email, accessToken);
                // This checks when service-gateway is down
                if (userAccounts.error === 503) {
                    get().setAuthError((0, $cstaF.validationMessages).connectionError, history1);
                    return;
                }
                const isLegacyUser = userAccounts?.error === 404;
                if (isLegacyUser) {
                    await loginUser(accessToken, true);
                    return;
                }
                const hasLwaId = userAccounts?.user?.lwaId;
                if (hasLwaId) {
                    const authParams = {
                        email: state.emailValue,
                        redirectUrl: (0, $i1BZc.urlPlatformLaunch)
                    };
                    (0, $7D4kr.navigateToPlatformAuth)(authParams);
                    return;
                }
                //TODO: add account selector logic here, right now select the first option
                const selectedAccount = userAccounts.accounts[0];
                const isInactiveXbmUser = !selectedAccount.accountActive || !selectedAccount.userActive;
                if (isInactiveXbmUser) return updateUserType((0, $cghEn.userTypes).inactiveXbm);
                (0, $90ISC.useCommonStore).setState({
                    isLoading: false
                });
                setState((prev)=>({
                        ...prev,
                        userType: undefined,
                        isLoading: false
                    }));
                loginUser(accessToken);
            } catch (error) {
                console.log({
                    error: error
                });
                (0, $90ISC.useCommonStore).setState({
                    isLoading: false
                });
                setState((prev)=>({
                        ...prev,
                        isLoading: false
                    }));
                set({
                    authError: (0, $cstaF.validationMessages).unknownError,
                    token: undefined,
                    tokenInfo: undefined,
                    tokenType: undefined,
                    platformServiceClient: undefined
                });
            }
        },
        getXamInternalUserPrivileges: async ({ history: history1 })=>{
            const userPrivileges = await (0, $9QNal.retryEndpoint)({
                fetchFunction: (0, $bBJbW.getXamInternalUserPrivileges)
            });
            const officeInfoPayload = userPrivileges.flatMap(({ mlsId: mlsId, officeId: officeId })=>officeId.map((id)=>({
                        mlsId: mlsId,
                        officeId: id
                    })));
            const mlsIds = userPrivileges.map(({ mlsId: mlsId })=>mlsId);
            const activeOffices = await (0, $90ISC.useCommonStore).getState().getOfficeInfo(officeInfoPayload);
            if (!mlsIds?.length || mlsIds?.length === 0 || !activeOffices?.length || activeOffices?.length === 0) {
                (0, $7D4kr.navigateToVerificationError)(history1);
                return {
                    isValidUser: false
                };
            }
            const agentInfo = (0, $90ISC.useCommonStore).getState().agentInfo;
            if (!agentInfo) {
                const defaultAgentProductionAgent = [
                    {
                        agentId: (0, $8U25g.topPerformerAgents)[0].agentId,
                        mlsId: (0, $8U25g.topPerformerAgents)[0].mlsId
                    }
                ];
                await (0, $90ISC.useCommonStore).getState().getAgentInfo(defaultAgentProductionAgent);
            }
            return {
                isValidUser: true,
                mlsIds: mlsIds,
                activeOffices: activeOffices
            };
        },
        getXamExternalUserPrivileges: async ({ history: history1, platformToken: platformToken, activeClientId: activeClientId })=>{
            let activeAgents, activeOffices, mlsIds, userMls;
            userMls = await (platformToken && activeClientId ? (0, $bBJbW.getXamUserMls)(platformToken, activeClientId) : (0, $bBJbW.getXamUserMls)());
            if (userMls?.error || !userMls) {
                (0, $7D4kr.navigateToPlatformHome)();
                return {
                    isValidUser: false
                };
            }
            if (userMls?.list.length === 0) {
                (0, $7D4kr.navigateToValidation)(history1);
                return {
                    isValidUser: true
                };
            }
            const mlsAgents = userMls.list.map(({ agentId: agentId, mlsId: mlsId })=>({
                    agentId: agentId,
                    mlsId: mlsId
                }));
            const agentInfo = await (0, $90ISC.useCommonStore).getState().getAgentInfo(mlsAgents);
            activeAgents = agentInfo.length > 0 && agentInfo.filter((agent)=>agent.isAgentActive);
            if (!activeAgents?.length || activeAgents?.length === 0) {
                (0, $7D4kr.navigateToVerificationError)(history1);
                return {
                    isValidUser: false
                };
            }
            activeOffices = activeAgents.map((agent)=>agent.office);
            mlsIds = activeAgents.map((agentOffice)=>agentOffice.mlsAgentId.mlsId);
            return {
                isValidUser: true,
                mlsIds: mlsIds,
                activeOffices: activeOffices
            };
        },
        getXamUserPrivileges: async ({ isInternalUser: isInternalUser, history: history1, activeClientId: activeClientId, platformToken: platformToken })=>{
            return isInternalUser ? await get().getXamInternalUserPrivileges({
                history: history1
            }) : await get().getXamExternalUserPrivileges({
                history: history1,
                activeClientId: activeClientId,
                platformToken: platformToken
            });
        },
        verifyAgentMetricsUser: async ({ platformToken: platformToken, activeClientId: activeClientId, history: history1, isInternalUser: isInternalUser })=>{
            if (!activeClientId) return {
                isValidUser: false
            };
            get().setActiveClientId(activeClientId);
            set({
                token: platformToken
            });
            try {
                const { isValidUser: isValidUser } = await get().getXamUserPrivileges({
                    isInternalUser: isInternalUser,
                    history: history1,
                    activeClientId: activeClientId,
                    platformToken: platformToken
                });
                return {
                    isValidUser: isValidUser
                };
            } catch (error) {
                console.error(error);
                (0, $7D4kr.navigateToPlatformHome)();
                return {
                    isValidUser: false
                };
            }
        },
        verifyBrokerMetricsUser: async ({ platformToken: platformToken, platformTokenInfo: platformTokenInfo, incomingLwid: incomingLwid, history: history1 })=>{
            const xbmUserIdFromToken = platformTokenInfo[0, $cghEn.LWA_TOKEN_OBJECT_IDENTIFIER]?.apps?.xbm?.uid;
            if (!xbmUserIdFromToken) {
                (0, $7D4kr.navigateToPlatformUI)();
                return false;
            }
            const userAccounts = await (0, $caGGw.getUserAccountsById)(xbmUserIdFromToken, incomingLwid, platformToken);
            const isLwaUser = userAccounts?.user?.lwaId;
            if ((0, $90ISC.useCommonStore).getState()?.userInfo?.id === xbmUserIdFromToken) {
                (0, $7D4kr.navigateToHomeAndReload)(history1);
                return false;
            }
            if (!isLwaUser) {
                get().setAuthErrorByRoute((0, $cstaF.validationMessages).connectionMismatch(platformTokenInfo.email), (0, $c7dF9.Routes).AUTH.LOG_IN, history1);
                return false;
            }
            return true;
        },
        setKeycloakToken: (token, isLegacyUser = false)=>{
            const tokenInfo = (0, $2Eznr.default)(token);
            const ownerId = tokenInfo?.sub;
            set({
                token: token,
                isLegacyUser: isLegacyUser,
                tokenInfo: (0, $2Eznr.default)(token),
                tokenType: (0, $cghEn.tokenTypes).KEYCLOAK,
                ownerType: (0, $cstaF.ownerTypes).user,
                ownerId: ownerId
            });
        },
        clearToken: ()=>set({
                token: undefined,
                tokenInfo: undefined,
                tokenTypes: undefined
            }),
        initPlatform: async ({ history: history1, activeClientId: activeClientId, redirectPath: redirectPath })=>{
            try {
                const previousOwnerId = get().ownerId;
                set({
                    authError: undefined
                });
                get().resetStore();
                (0, $90ISC.useCommonStore).getState().resetStore();
                const platformService = await (0, (/*@__PURE__*/$parcel$interopDefault($b9LXY))).initialize({
                    lwDomain: (0, $7AubO.getEndpoint)((0, $7AubO.PLATFORM_DOMAIN)),
                    appId: (0, $dDBOF.appIdByAppName)[0, $dDBOF.runningApp],
                    lwaOnly: true,
                    luParamSupplier: ()=>(0, $7AubO.getEndpoint)((0, $7AubO.PLATFORM_LOCAL_LAUNCH))
                });
                const platformToken = platformService.validateAndGetToken();
                const platformTokenInfo = (0, $2Eznr.default)(platformToken);
                const incomingLwid = platformTokenInfo?.[0, $cghEn.LWA_TOKEN_OBJECT_IDENTIFIER]?.uid.toLowerCase();
                const isInternalUser = (0, $3T9wI.getIsInternalEmailAddress)(platformTokenInfo?.email);
                const isSameUser = !!previousOwnerId && previousOwnerId === incomingLwid;
                (0, $90ISC.useCommonStore).getState().resetStore();
                if (!isSameUser) (0, $90ISC.useSearchStore).getState().resetStore();
                let isValidUser, shouldGoToValidation;
                if ((0, $dDBOF.runningApp) === (0, $dDBOF.appNames).XBM) isValidUser = await get().verifyBrokerMetricsUser({
                    platformToken: platformToken,
                    platformTokenInfo: platformTokenInfo,
                    incomingLwid: incomingLwid,
                    history: history1
                });
                if ((0, $dDBOF.runningApp) === (0, $dDBOF.appNames).XAM) {
                    const agentMetricsVerification = await get().verifyAgentMetricsUser({
                        platformToken: platformToken,
                        activeClientId: activeClientId,
                        history: history1,
                        isInternalUser: isInternalUser
                    });
                    isValidUser = agentMetricsVerification.isValidUser;
                }
                if (!isValidUser) return;
                get().authLwaUser(platformToken, platformService);
                if (shouldGoToValidation) (0, $7D4kr.navigateToValidation)(history1);
                if (redirectPath) {
                    history1.replace(redirectPath);
                    return;
                }
                (0, $7D4kr.navigateToHomeAndReload)(history1);
            } catch (error) {
                console.log({
                    error: error
                });
                (0, $7D4kr.navigateToPlatformUI)();
            }
        },
        initAgentMetricsApp: async ({ setState: setState, setPendoDataLayers: setPendoDataLayers, tokenInfo: tokenInfo, getUserLists: getUserLists, history: history1, isLegacyUser: isLegacyUser, runningApp: runningApp, ownerId: ownerId, isAgentProductionEnabled: isAgentProductionEnabled })=>{
            const userProducts = (0, $dFPJJ.getUserProducts)({
                isAgentMetricsUser: true,
                isAgentProductionEnabled: isAgentProductionEnabled
            });
            (0, $ivaD7.setStateData)("allowedModules", userProducts, setState);
            const productFlags = (0, $lxCva.getProductFlags)(userProducts);
            setPendoDataLayers({
                tokenInfo: tokenInfo,
                userProducts: userProducts,
                productFlags: productFlags,
                isLegacyUser: isLegacyUser,
                runningApp: runningApp,
                ownerId: ownerId
            });
            const commonStore = (0, $90ISC.useCommonStore).getState();
            const isInternalUser = (0, $3T9wI.getIsInternalEmailAddress)(tokenInfo.email);
            const { isValidUser: isValidUser, mlsIds: mlsIds, activeOffices: activeOffices } = await get().getXamUserPrivileges({
                isInternalUser: isInternalUser,
                history: history1
            });
            if (!isValidUser) return;
            (0, $90ISC.useCommonStore).setState({
                officeInfo: activeOffices
            });
            await commonStore.getMembership(mlsIds);
            await commonStore.getTimeIntervals();
            await getUserLists(ownerId);
        },
        setAuthErrorByRoute: (errorMessage, route, history1)=>{
            set((0, $8cYiI.produce)((state)=>{
                state.authErrorByRoute[route] = errorMessage;
                state.token = undefined;
                state.tokenInfo = undefined;
                state.platformServiceClient = undefined;
            }));
            history1 && history1.replace((0, $c7dF9.Routes).AUTH.LOG_IN);
        },
        logout: (history1)=>{
            (0, $90ISC.useCommonStore).getState().resetStore();
            (0, $90ISC.useSearchStore).getState().resetStore();
            (0, $90ISC.useSavedAgentsStore).getState().resetStore();
            get().resetStore();
            history1.replace((0, $c7dF9.Routes).AUTH.LOG_IN);
            window.location.reload();
        },
        handleExpiredToken: ()=>{
            const tokenInfo = get().tokenInfo;
            const tokenType = get().tokenType;
            const isTokenExpired = (0, $6g8wQ.getIsTokenExpired)(tokenInfo);
            if (!isTokenExpired) return;
            (0, $6g8wQ.expiredTokenActionByToken)[tokenType]();
        },
        setActiveClientId: (activeClientId)=>set({
                activeClientId: activeClientId
            }),
        resetStore: ()=>{
            const askMeLaterAttempts = get().askMeLaterAttempts;
            const lastAskMeLaterAt = get().lastAskMeLaterAt;
            set({
                ...(0, $f6CJ4.initialAuthState),
                askMeLaterAttempts: askMeLaterAttempts,
                lastAskMeLaterAt: lastAskMeLaterAt
            });
        }
    });
const $9f0f0093cb25c37c$var$loginActions = (set, get)=>({
        setIsLoadingByRoute: (route, isLoading)=>{
            set((0, $8cYiI.produce)((state)=>{
                state.isLoadingByRoute[route] = isLoading;
            }));
        },
        getUserByEmail: async (state, setState, currentRoute)=>{
            try {
                const token = await (0, $2iCCW.getKeycloakToken)((0, $i1BZc.urlKeycloakToken), state.emailValue, encodeURIComponent(state.passwordValue));
                if (token.error) {
                    get().updateUserType((0, $cghEn.getUserTypeByError)[token.error_description] || (0, $cghEn.userTypes).invalidLogin, setState);
                    return;
                }
                const accessToken = token.access_token;
                const decodedToken = (0, $2Eznr.default)(accessToken);
                const userAccounts = await (0, $caGGw.getUserAccounts)(decodedToken.email, accessToken);
                // This checks when service-gateway is down
                if (userAccounts.error === 503) {
                    get().authErrorByRoute((0, $cstaF.validationMessages).connectionError, currentRoute, history);
                    return;
                }
                return {
                    accessToken: accessToken,
                    userAccounts: userAccounts
                };
            } catch (error) {
                console.error(error);
            } finally{
                get().setIsLoadingByRoute(currentRoute, false);
            }
        },
        updateUserType: (userType, setState)=>{
            setState((prev)=>({
                    ...prev,
                    userType: userType
                }));
        },
        loginUser: async (token, history1)=>{
            get().setKeycloakToken(token);
            await (0, $gl8f4.recordLoginActivity)(token);
            (0, $7D4kr.navigateToHomeAndReload)(history1);
        },
        setKeycloakToken: (token)=>set({
                token: token,
                tokenInfo: (0, $2Eznr.default)(token),
                tokenType: (0, $cghEn.tokenTypes).KEYCLOAK
            }),
        authKeycloakUser: async (state, setState, history1)=>{
            const currentRoute = (0, $c7dF9.Routes).AUTH.LOG_IN;
            const setIsLoading = (isLoading)=>{
                get().setIsLoadingByRoute(currentRoute, isLoading);
            };
            try {
                setIsLoading(true);
                const { accessToken: accessToken, userAccounts: userAccounts } = await get().getUserByEmail(state, setState, currentRoute);
                const isLegacyUser = userAccounts?.error === 404;
                if (isLegacyUser) {
                    get().loginUser(accessToken, history1);
                    return;
                }
                const hasLwaId = userAccounts?.user?.lwaId;
                if (hasLwaId) {
                    const authParams = {
                        email: state.emailValue,
                        redirectUrl: (0, $i1BZc.urlPlatformLaunch)
                    };
                    (0, $7D4kr.navigateToPlatformAuth)(authParams);
                    return;
                }
                //TODO: add account selector logic here, right now select the first option
                const selectedAccount = userAccounts.accounts[0];
                const isInactiveXbmUser = !selectedAccount.accountActive || !selectedAccount.userActive;
                if (isInactiveXbmUser) {
                    get().updateUserType((0, $cghEn.userTypes).inactiveXbm, setState);
                    setIsLoading(false);
                    return;
                }
                setState((prev)=>({
                        ...prev,
                        userType: undefined
                    }));
                get().loginUser(accessToken, history1);
            } catch (error) {
                console.log({
                    error: error
                });
                get().setAuthErrorByRoute((0, $cstaF.validationMessages).unknownError, currentRoute);
            } finally{
                setIsLoading(false);
            }
        },
        connectKeycloakUser: async (state, setState)=>{
            const currentRoute = (0, $c7dF9.Routes).AUTH.CONNECT;
            if (get().isLoadingByRoute[currentRoute]) return;
            const setIsLoading = (isLoading)=>{
                get().setIsLoadingByRoute(currentRoute, isLoading);
            };
            const setAuthError = (errorMessage)=>{
                get().setAuthErrorByRoute(errorMessage, currentRoute);
            };
            try {
                setIsLoading(true);
                const { accessToken: accessToken, userAccounts: userAccounts } = await get().getUserByEmail(state, setState, currentRoute);
                if (!userAccounts) return;
                const isLegacyUser = userAccounts?.error === 404;
                if (isLegacyUser) {
                    setAuthError((0, $cstaF.validationMessages).unableToConnect);
                    setIsLoading(false);
                    return;
                }
                //TODO: add account selector logic here, right now select the first option
                const selectedAccount = userAccounts.accounts[0];
                const isInactiveXbmUser = !selectedAccount.accountActive || !selectedAccount.userActive;
                if (isInactiveXbmUser) {
                    get().updateUserType((0, $cghEn.userTypes).inactiveXbm, setState);
                    setIsLoading(false);
                    return;
                }
                const hasLwaId = userAccounts?.user?.lwaId;
                if (hasLwaId) {
                    setAuthError((0, $cstaF.validationMessages).accountAlreadyConnected);
                    setIsLoading(false);
                    return;
                }
                const userInfo = userAccounts.user;
                const lwaId = await get().sendLwaInvitation(userInfo, accessToken);
                if (!lwaId) {
                    setAuthError((0, $cstaF.validationMessages).unableToLink);
                    setIsLoading(false);
                    return;
                }
                (0, $7D4kr.navigateToPlatformConnection)(lwaId);
                get().updateUserType(undefined, setState);
            } catch (error) {
                console.error(error);
                setAuthError((0, $cstaF.validationMessages).unknownError);
                setIsLoading(false);
            }
        },
        setIsXamUserValidated: (isValidated)=>set({
                isXamUserValidated: isValidated
            })
    });

});
parcelRegister("2Eznr", function(module, exports) {

$parcel$export(module.exports, "default", () => $1eeac253570f845a$export$2e2bcd8739ae039);
function $1eeac253570f845a$var$e(e) {
    this.message = e;
}
$1eeac253570f845a$var$e.prototype = new Error, $1eeac253570f845a$var$e.prototype.name = "InvalidCharacterError";
var $1eeac253570f845a$var$r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r) {
    var t = String(r).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new $1eeac253570f845a$var$e("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var n, o, a = 0, i = 0, c = ""; o = t.charAt(i++); ~o && (n = a % 4 ? 64 * n + o : o, a++ % 4) && (c += String.fromCharCode(255 & n >> (-2 * a & 6))))o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);
    return c;
};
function $1eeac253570f845a$var$t(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    switch(t.length % 4){
        case 0:
            break;
        case 2:
            t += "==";
            break;
        case 3:
            t += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return function(e) {
            return decodeURIComponent($1eeac253570f845a$var$r(e).replace(/(.)/g, function(e, r) {
                var t = r.charCodeAt(0).toString(16).toUpperCase();
                return t.length < 2 && (t = "0" + t), "%" + t;
            }));
        }(t);
    } catch (e) {
        return $1eeac253570f845a$var$r(t);
    }
}
function $1eeac253570f845a$export$b9721ef022f71a68(e) {
    this.message = e;
}
function $1eeac253570f845a$var$o(e, r) {
    if ("string" != typeof e) throw new $1eeac253570f845a$export$b9721ef022f71a68("Invalid token specified");
    var o = !0 === (r = r || {}).header ? 0 : 1;
    try {
        return JSON.parse($1eeac253570f845a$var$t(e.split(".")[o]));
    } catch (e) {
        throw new $1eeac253570f845a$export$b9721ef022f71a68("Invalid token specified: " + e.message);
    }
}
$1eeac253570f845a$export$b9721ef022f71a68.prototype = new Error, $1eeac253570f845a$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
var $1eeac253570f845a$export$2e2bcd8739ae039 = $1eeac253570f845a$var$o;

});

parcelRegister("b9LXY", function(module, exports) {
"use strict";
var $81f5be1abf5b3cba$var$__assign = module.exports && module.exports.__assign || function() {
    $81f5be1abf5b3cba$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $81f5be1abf5b3cba$var$__assign.apply(this, arguments);
};
var $81f5be1abf5b3cba$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $81f5be1abf5b3cba$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $81f5be1abf5b3cba$var$__spreadArray = module.exports && module.exports.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $81f5be1abf5b3cba$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $81f5be1abf5b3cba$var$Authentication_1 = $81f5be1abf5b3cba$var$__importDefault((parcelRequire("2EHer")));

var $81f5be1abf5b3cba$var$logrocket_1 = $81f5be1abf5b3cba$var$__importDefault((parcelRequire("gnWRQ")));

var $12tws = parcelRequire("12tws");

var $bMEyZ = parcelRequire("bMEyZ");

var $g15fX = parcelRequire("g15fX");

var $81f5be1abf5b3cba$var$TokenMonitor_1 = $81f5be1abf5b3cba$var$__importDefault((parcelRequire("ghmcX")));

var $81f5be1abf5b3cba$var$ImpersonationSessionMonitor_1 = $81f5be1abf5b3cba$var$__importDefault((parcelRequire("5dWRn")));

var $lsuk0 = parcelRequire("lsuk0");

var $81f5be1abf5b3cba$var$SessionMonitor_1 = $81f5be1abf5b3cba$var$__importDefault((parcelRequire("5jiIc")));
var $81f5be1abf5b3cba$var$APP_ID_PLATFORM_UI = "pfm";
var $81f5be1abf5b3cba$var$APP_ID_FOUNDATION = "fdn";
var $81f5be1abf5b3cba$var$SESSION_CHECK_KEY_NAME = "lwaSessionCheck";
var $81f5be1abf5b3cba$var$ACTIVE_CLIENT_ID_KEY_NAME = "ac";
var $81f5be1abf5b3cba$var$LWA_CLIENTS_CACHE_KEY_SUFFIX = "lwa_clients";
var $81f5be1abf5b3cba$var$APP_DATA_CACHE_KEY_SUFFIX = "app_data";
var $81f5be1abf5b3cba$var$AUTHENTICATED_IDPS_CACHE_KEY_SUFFIX = "authenticated_idps";
var $81f5be1abf5b3cba$var$CLIENTS_SUMMARY_CACHE_KEY_SUFFIX = "clients_summary";
var $81f5be1abf5b3cba$var$CONNECTIONS_CACHE_KEY_SUFFIX = "connections";
var $81f5be1abf5b3cba$var$LWA_CLIENT_APPS_CACHE_KEY_SUFFIX = "lwa_client_apps";
var $81f5be1abf5b3cba$var$USER_PERMISSIONS_CACHE_KEY_SUFFIX = "user_permissions";
var $81f5be1abf5b3cba$var$ADMIN_PERMISSIONS_CACHE_KEY_SUFFIX = "admin_permissions";
var $81f5be1abf5b3cba$var$LWA_USER_CACHE_KEY_SUFFIX = "lwa_user";
// Bump this whenever the shape of any cached response type changes, so entries written by an
// older version of this package are treated as absent instead of being replayed into code that
// no longer expects that shape.
var $81f5be1abf5b3cba$var$LOCAL_STORAGE_CACHE_SCHEMA_VERSION = 1;
// Hard ceiling on how old data served from the localStorage outage-fallback cache (see
// getFromLocalStorage's markServed param) can be. Without this, a single outage can cause
// arbitrarily old data to be re-served and re-stamped as "just served" indefinitely, across
// later outages and even across deploys, until a user manually clears their browser storage.
var $81f5be1abf5b3cba$var$MAX_LOCAL_STORAGE_CACHE_AGE_MILLIS = 86400000;
var $81f5be1abf5b3cba$var$buildUrl = function(lwDomain, prefix) {
    return "https://".concat(prefix, ".").concat(lwDomain);
};
var $81f5be1abf5b3cba$var$buildProductLaunchUrl = function(domain, connection, luParamValue, redirectUri) {
    var url;
    if (connection.platformClient && connection.clientId === null) {
        var platformClientConnection = connection;
        url = "".concat(domain, "/product/launch?a=").concat(platformClientConnection.appId);
    } else if (connection.platformClient) {
        var platformClientConnection = connection;
        url = "".concat(domain, "/product/launch?a=").concat(platformClientConnection.appId, "&ac=").concat(platformClientConnection.clientId);
    } else if (connection.clientId != null) {
        var clientConnection = connection;
        url = "".concat(domain, "/product/launch?a=").concat(clientConnection.appId, "&c=").concat(clientConnection.clientId, "&m=").concat(clientConnection.memberId);
    } else if (connection.userId != null) {
        var userConnection = connection;
        url = "".concat(domain, "/product/launch?a=").concat(userConnection.appId, "&u=").concat(userConnection.userId);
    } else url = "".concat(domain, "/product/launch?a=").concat(connection.appId);
    if (luParamValue) url = "".concat(url, "&lu=").concat(luParamValue);
    if (redirectUri && redirectUri !== encodeURIComponent("/")) url = "".concat(url, "&r=").concat(redirectUri);
    return url;
};
var $81f5be1abf5b3cba$var$isPlatformUiAppId = function(appId) {
    return appId === $81f5be1abf5b3cba$var$APP_ID_PLATFORM_UI;
};
var $81f5be1abf5b3cba$var$isPlatformOrFoundationApp = function(appId) {
    return $81f5be1abf5b3cba$var$isPlatformUiAppId(appId) || appId === $81f5be1abf5b3cba$var$APP_ID_FOUNDATION;
};
var $81f5be1abf5b3cba$var$getStoredToken = function(lwDomain, appId) {
    var _a, _b;
    var token = (_a = sessionStorage.getItem($g15fX.TOKEN_KEY_NAME)) !== null && _a !== void 0 ? _a : undefined;
    if (!token) {
        if ((0, $lsuk0.isLwolfDomain)(lwDomain)) token = (0, $lsuk0.getTokenFromCookie)(lwDomain);
        else token = (_b = localStorage.getItem($g15fX.TOKEN_KEY_NAME)) !== null && _b !== void 0 ? _b : undefined;
        if (token) $81f5be1abf5b3cba$var$storeToken(lwDomain, token, appId);
    }
    return token;
};
var $81f5be1abf5b3cba$var$storeToken = function(lwDomain, token, appId) {
    var _a, _b, _c, _d;
    if (token) {
        var parsedToken = $81f5be1abf5b3cba$var$Authentication_1.default.parseToken(token);
        // If the current application uses connections (not clients) from the LWA, set the token in session storage.
        if ((0, $lsuk0.isLegacyConnection)(parsedToken, appId)) sessionStorage.setItem($g15fX.TOKEN_KEY_NAME, token);
        if ((0, $lsuk0.isLwolfDomain)(lwDomain)) {
            var existingSessionId = (_b = (_a = $81f5be1abf5b3cba$var$Authentication_1.default.parseToken((0, $lsuk0.getTokenFromCookie)(lwDomain))) === null || _a === void 0 ? void 0 : _a.getLwtClaim()) === null || _b === void 0 ? void 0 : _b.getSessionId();
            var newSessionId = (_c = parsedToken === null || parsedToken === void 0 ? void 0 : parsedToken.getLwtClaim()) === null || _c === void 0 ? void 0 : _c.getSessionId();
            if (existingSessionId && newSessionId && existingSessionId !== newSessionId) // Before writing the token cookie, compare their session ids. If it's not the same session,
            // do a delete first (see SessionMonitor, which relies on this cookie deletion to detect a
            // sign-in from a different user in another tab).
            document.cookie = "".concat((0, $lsuk0.getTokenCookieName)(lwDomain), "=;Domain=.").concat(lwDomain, ";Expires=Thu, 01 Jan 1970 00:00:00 UTC;Path=/");
            var tokenExpirationTime = (_d = parsedToken === null || parsedToken === void 0 ? void 0 : parsedToken.getExpirationTime()) !== null && _d !== void 0 ? _d : 0;
            var tokenExpires = new Date(tokenExpirationTime * 1000).toUTCString();
            document.cookie = "".concat((0, $lsuk0.getTokenCookieName)(lwDomain), "=").concat(token, ";Domain=.").concat(lwDomain, ";Secure;SameSite=Strict;Expires=").concat(tokenExpires, ";Path=/");
        } else localStorage.setItem($g15fX.TOKEN_KEY_NAME, token);
    } else {
        sessionStorage.removeItem($g15fX.TOKEN_KEY_NAME);
        if ((0, $lsuk0.isLwolfDomain)(lwDomain)) document.cookie = "".concat((0, $lsuk0.getTokenCookieName)(lwDomain), "=;Domain=.").concat(lwDomain, ";Expires=Thu, 01 Jan 1970 00:00:00 UTC;Path=/");
        localStorage.removeItem($g15fX.TOKEN_KEY_NAME);
        // We have left this in to clear unneeded data from local-storage for users already having sessions open in the browser.
        // We can remove this code later.
        localStorage.removeItem($81f5be1abf5b3cba$var$SESSION_CHECK_KEY_NAME);
        localStorage.removeItem("lwaSessionCheckExpires");
    }
};
var $81f5be1abf5b3cba$var$storeAndVerifyToken = function(lwDomain, token, appId) {
    var _a, _b;
    $81f5be1abf5b3cba$var$storeToken(lwDomain, token, appId);
    // Only verify storage succeeded when we were actually asked to store a token. When token is undefined,
    // storeToken is clearing the session on purpose (see setToken(undefined) from a sign-out flow), so
    // getStoredToken correctly returning nothing here isn't a failure.
    if (token && !$81f5be1abf5b3cba$var$getStoredToken(lwDomain, appId)) {
        var lng = ((_b = (_a = $81f5be1abf5b3cba$var$Authentication_1.default.parseToken(token)) === null || _a === void 0 ? void 0 : _a.getLwtClaim()) === null || _b === void 0 ? void 0 : _b.getLanguageCode()) || "en-US";
        throw new Error($bMEyZ.strings.getStrings(lng).tokenStorageFailed);
    }
};
var $81f5be1abf5b3cba$var$isTokenExpired = function(token) {
    var _a, _b;
    var tokenExpirationTime = (_b = (_a = $81f5be1abf5b3cba$var$Authentication_1.default.parseToken(token)) === null || _a === void 0 ? void 0 : _a.getExpirationTime()) !== null && _b !== void 0 ? _b : 0;
    return tokenExpirationTime * 1000 < Date.now();
};
var $81f5be1abf5b3cba$var$getCompareFunction = function(field, options) {
    if (options === void 0) options = {};
    return function(a, b) {
        var aV = a[field];
        var bV = b[field];
        if (typeof aV !== typeof bV) throw "Type mismatch when doing comparison.";
        var ignoreCase = options.ignoreCase;
        if (typeof aV === "string" && typeof bV === "string") {
            var string1 = aV;
            var string2 = bV;
            if (ignoreCase) {
                string1 = string1.toLowerCase();
                string2 = string2.toLowerCase();
            }
            return string1.localeCompare(string2);
        }
        if (aV === bV) return 0;
        else return aV < bV ? -1 : 1;
    };
};
var $81f5be1abf5b3cba$var$isServerError = function(status) {
    return status >= 500 && status <= 599;
};
var $81f5be1abf5b3cba$var$makeFetchCall = function(url, token, additionalHeaders) {
    var _a, _b;
    var languageCode = ((_b = (_a = $81f5be1abf5b3cba$var$Authentication_1.default.parseToken(token)) === null || _a === void 0 ? void 0 : _a.getLwtClaim()) === null || _b === void 0 ? void 0 : _b.getLanguageCode()) || "en-US";
    return fetch("".concat(url), {
        headers: $81f5be1abf5b3cba$var$__assign({
            Authorization: "Bearer ".concat(token),
            "Accept-Language": languageCode
        }, additionalHeaders ? additionalHeaders : {})
    });
};
var $81f5be1abf5b3cba$var$isActiveConnection = function(connection) {
    var inactiveDate = connection.inactiveDate;
    if (!inactiveDate) return true;
    var date = new Date(inactiveDate);
    if (isNaN(date.getTime())) return true;
    return date > new Date();
};
var $81f5be1abf5b3cba$var$PlatformService = /** @class */ function() {
    function PlatformService(lwDomain, platformUrlOverride, foundationUrlOverride, token, appId, activeClientId, lwaOnly, includeOriginInRedirects, enablePopups, beforeSignOutCallback, luParamSupplier, useRedirectParam, onImpersonationSessionWarning, onTokenChange) {
        var _this = this;
        this.lwaClientAppsEndpointDisabled = false;
        this.cachedClients = {};
        this.getJsonResponseFromFetch = function(url, token, appId, tryRelaunch, fallbackOn5xx, keySuffix) {
            return $81f5be1abf5b3cba$var$__awaiter(_this, void 0, void 0, function() {
                var cachedData, response, _a, cachedData, cachedData, data;
                return $81f5be1abf5b3cba$var$__generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            // Use cached data if it is still within the valid time window
                            if (this.isWithinCacheTime(keySuffix)) {
                                cachedData = this.getFromLocalStorage(keySuffix);
                                if (cachedData) return [
                                    2 /*return*/ ,
                                    cachedData
                                ];
                            }
                            _b.label = 1;
                        case 1:
                            _b.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4 /*yield*/ ,
                                $81f5be1abf5b3cba$var$makeFetchCall(url, token)
                            ];
                        case 2:
                            response = _b.sent();
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 3:
                            _a = _b.sent();
                            cachedData = this.getFromLocalStorage(keySuffix, true);
                            if (cachedData) return [
                                2 /*return*/ ,
                                cachedData
                            ];
                            return [
                                2 /*return*/ ,
                                fallbackOn5xx
                            ];
                        case 4:
                            if (!response.ok) {
                                if (response.status === 401) {
                                    if (!$81f5be1abf5b3cba$var$isPlatformUiAppId(appId)) tryRelaunch();
                                    return [
                                        2 /*return*/ ,
                                        fallbackOn5xx
                                    ];
                                }
                                if ($81f5be1abf5b3cba$var$isServerError(response.status)) {
                                    cachedData = this.getFromLocalStorage(keySuffix, true);
                                    if (cachedData) return [
                                        2 /*return*/ ,
                                        cachedData
                                    ];
                                    return [
                                        2 /*return*/ ,
                                        fallbackOn5xx
                                    ];
                                }
                                throw new Error("Invalid response from platform API (".concat(response.status, ")"));
                            }
                            return [
                                4 /*yield*/ ,
                                response.json()
                            ];
                        case 5:
                            data = _b.sent();
                            if (data) this.saveToLocalStorage(keySuffix, data);
                            return [
                                2 /*return*/ ,
                                data
                            ];
                    }
                });
            });
        };
        this.fetchWithCache = function(_a) {
            return $81f5be1abf5b3cba$var$__awaiter(_this, [
                _a
            ], void 0, function(_b) {
                var getSafeCacheValue, token, memoryCache, storageData, response, _c, storageData, storageData, fetchError, json, data;
                var url = _b.url, cacheKey = _b.cacheKey, getMemoryCache = _b.getMemoryCache, setMemoryCache = _b.setMemoryCache, mapResponse = _b.mapResponse, fallback = _b.fallback, _d = _b.useCache, useCache = _d === void 0 ? true : _d;
                return $81f5be1abf5b3cba$var$__generator(this, function(_e) {
                    switch(_e.label){
                        case 0:
                            getSafeCacheValue = function(data) {
                                return Array.isArray(data) ? $81f5be1abf5b3cba$var$__spreadArray([], data, true) : data;
                            };
                            token = this.validateAndGetToken();
                            if (!token) return [
                                2 /*return*/ ,
                                Promise.resolve(fallback)
                            ];
                            // Memory cache
                            if (useCache) {
                                memoryCache = getMemoryCache();
                                if (memoryCache) return [
                                    2 /*return*/ ,
                                    Promise.resolve(getSafeCacheValue(memoryCache))
                                ];
                            }
                            // Local Storage cache
                            if (this.isWithinCacheTime(cacheKey)) {
                                storageData = this.getFromLocalStorage(cacheKey);
                                if (storageData) {
                                    setMemoryCache(storageData);
                                    return [
                                        2 /*return*/ ,
                                        Promise.resolve(getSafeCacheValue(storageData))
                                    ];
                                }
                            }
                            _e.label = 1;
                        case 1:
                            _e.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4 /*yield*/ ,
                                $81f5be1abf5b3cba$var$makeFetchCall(url, token)
                            ];
                        case 2:
                            response = _e.sent();
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 3:
                            _c = _e.sent();
                            storageData = this.getFromLocalStorage(cacheKey, true);
                            if (storageData) {
                                setMemoryCache(storageData);
                                return [
                                    2 /*return*/ ,
                                    getSafeCacheValue(storageData)
                                ];
                            }
                            return [
                                2 /*return*/ ,
                                fallback
                            ];
                        case 4:
                            if (!response.ok) {
                                if (response.status === 401) {
                                    if (!$81f5be1abf5b3cba$var$isPlatformUiAppId(this.appId)) this.tryRelaunch();
                                    return [
                                        2 /*return*/ ,
                                        fallback
                                    ];
                                } else if ($81f5be1abf5b3cba$var$isServerError(response.status)) {
                                    storageData = this.getFromLocalStorage(cacheKey, true);
                                    if (storageData) {
                                        setMemoryCache(storageData);
                                        return [
                                            2 /*return*/ ,
                                            getSafeCacheValue(storageData)
                                        ];
                                    }
                                    return [
                                        2 /*return*/ ,
                                        fallback
                                    ];
                                }
                                fetchError = new Error("Invalid response (".concat(response.status, ")"));
                                fetchError.status = response.status;
                                throw fetchError;
                            }
                            return [
                                4 /*yield*/ ,
                                response.json()
                            ];
                        case 5:
                            json = _e.sent();
                            data = mapResponse ? mapResponse(json) : json;
                            setMemoryCache(data);
                            this.saveToLocalStorage(cacheKey, data);
                            return [
                                2 /*return*/ ,
                                data
                            ];
                    }
                });
            });
        };
        this.getClientSummary = function(clientId_1, fallback_1) {
            var args_1 = [];
            for(var _i = 2; _i < arguments.length; _i++)args_1[_i - 2] = arguments[_i];
            return $81f5be1abf5b3cba$var$__awaiter(_this, $81f5be1abf5b3cba$var$__spreadArray([
                clientId_1,
                fallback_1
            ], args_1, true), void 0, function(clientId, fallback, useCache) {
                var clientCacheKey;
                var _this = this;
                if (useCache === void 0) useCache = true;
                return $81f5be1abf5b3cba$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            clientCacheKey = "".concat($81f5be1abf5b3cba$var$CLIENTS_SUMMARY_CACHE_KEY_SUFFIX, "_").concat(clientId);
                            return [
                                4 /*yield*/ ,
                                this.fetchWithCache({
                                    url: "".concat(this.getPlatformApiUrl(), "/v1/clients/").concat(clientId, "/summary"),
                                    cacheKey: clientCacheKey,
                                    getMemoryCache: function() {
                                        return _this.cachedClients[clientId];
                                    },
                                    setMemoryCache: function(data) {
                                        if (!data) return;
                                        _this.cachedClients[clientId] = data;
                                    },
                                    fallback: fallback,
                                    useCache: useCache
                                })
                            ];
                        case 1:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        this.mapToClientSummary = function(client) {
            return {
                id: client.id,
                name: client.name,
                type: client.type,
                externalSystemId: client.externalSystemId,
                identityProviderId: client.identityProviderId
            };
        };
        this.getLocalStorageKey = function(suffix) {
            var _a, _b;
            var userId = (_b = (_a = _this.tokenPayload) === null || _a === void 0 ? void 0 : _a.getLwtClaim()) === null || _b === void 0 ? void 0 : _b.getUserId();
            if (!userId) return undefined;
            return "".concat(userId, "_").concat(suffix);
        };
        this.isWithinCacheTime = function(suffix) {
            var key = _this.getLocalStorageKey(suffix);
            if (!key) return false;
            var item = localStorage.getItem(key);
            if (!item) return false;
            try {
                var parsed = JSON.parse(item);
                if ((parsed === null || parsed === void 0 ? void 0 : parsed.version) !== $81f5be1abf5b3cba$var$LOCAL_STORAGE_CACHE_SCHEMA_VERSION) return false;
                if (!parsed.savedAt) return false;
                if (parsed.lastServedAt === undefined) return false;
                var now = Date.now();
                if (now - parsed.savedAt >= $81f5be1abf5b3cba$var$MAX_LOCAL_STORAGE_CACHE_AGE_MILLIS) return false;
                var fiveMinutes = 300000;
                return now - parsed.lastServedAt < fiveMinutes;
            } catch (_a) {
                return false;
            }
        };
        this.getFromLocalStorage = function(suffix, markServed) {
            if (markServed === void 0) markServed = false;
            var key = _this.getLocalStorageKey(suffix);
            if (!key) return undefined;
            var item = localStorage.getItem(key);
            if (!item) return undefined;
            try {
                var parsed = JSON.parse(item);
                if (!(parsed === null || parsed === void 0 ? void 0 : parsed.data)) return undefined;
                if (parsed.version !== $81f5be1abf5b3cba$var$LOCAL_STORAGE_CACHE_SCHEMA_VERSION) return undefined;
                if (markServed) {
                    var now = Date.now();
                    // Data older than the ceiling is not safe to serve as an outage fallback,
                    // regardless of how recently it was last served.
                    if (!parsed.savedAt || now - parsed.savedAt >= $81f5be1abf5b3cba$var$MAX_LOCAL_STORAGE_CACHE_AGE_MILLIS) return undefined;
                    var updated = $81f5be1abf5b3cba$var$__assign($81f5be1abf5b3cba$var$__assign({}, parsed), {
                        lastServedAt: now
                    });
                    localStorage.setItem(key, JSON.stringify(updated));
                }
                return parsed.data;
            } catch (e) {
                return undefined;
            }
        };
        this.saveToLocalStorage = function(suffix, data) {
            var key = _this.getLocalStorageKey(suffix);
            if (key) localStorage.setItem(key, JSON.stringify({
                data: data,
                version: $81f5be1abf5b3cba$var$LOCAL_STORAGE_CACHE_SCHEMA_VERSION,
                savedAt: Date.now()
            }));
        };
        this.lwDomain = lwDomain;
        this.platformUrlOverride = platformUrlOverride;
        this.foundationUrlOverride = foundationUrlOverride;
        this.token = token;
        this.tokenPayload = $81f5be1abf5b3cba$var$Authentication_1.default.parseToken(token);
        this.onTokenChangeCallback = onTokenChange;
        this.appId = appId;
        if (this.isValidClient(activeClientId)) {
            this.activeClientId = activeClientId;
            // If the current application uses connections (not clients) from the LWA, don't set the activeClientId in session storage.
            if (!(0, $lsuk0.isLegacyConnection)(this.tokenPayload, appId)) sessionStorage.setItem($81f5be1abf5b3cba$var$ACTIVE_CLIENT_ID_KEY_NAME, activeClientId);
            else sessionStorage.removeItem($81f5be1abf5b3cba$var$ACTIVE_CLIENT_ID_KEY_NAME);
        }
        this.lwaOnly = lwaOnly;
        this.includeOriginInRedirects = includeOriginInRedirects;
        this.beforeSignOutCallback = beforeSignOutCallback;
        this.luParamSupplier = luParamSupplier;
        this.cachedClients = {};
        this.enablePopups = enablePopups;
        this.useRedirectParam = useRedirectParam;
        this.logRocketInitialized = false;
        this.baseLogRocketTraits = {};
        this.impersonationSessionMonitor = new $81f5be1abf5b3cba$var$ImpersonationSessionMonitor_1.default(this.lwDomain, function(reason, expiresAt) {
            return onImpersonationSessionWarning === null || onImpersonationSessionWarning === void 0 ? void 0 : onImpersonationSessionWarning(reason, expiresAt);
        }, function() {
            return _this.logout();
        });
        this.tokenMonitor = new $81f5be1abf5b3cba$var$TokenMonitor_1.default(this.lwDomain, function() {
            return _this.token;
        }, function() {
            return _this.tokenPayload;
        }, function(token) {
            _this.applyToken(token);
            _this.impersonationSessionMonitor.reconcile(_this.tokenPayload);
            _this.sessionMonitor.reconcile();
        }, function() {
            return _this.applyToken($81f5be1abf5b3cba$var$getStoredToken(_this.lwDomain, _this.appId));
        }, function(options) {
            return _this.refreshToken(options);
        });
        this.impersonationSessionMonitor.reconcile(this.tokenPayload);
        this.sessionMonitor = new $81f5be1abf5b3cba$var$SessionMonitor_1.default(this.lwDomain, (0, $lsuk0.supportsCookieStore)(), "".concat(this.getAuthenticationApiUrl(), "/v1/check-session"), function() {
            return _this.tokenPayload;
        }, function() {
            return _this.validateAndGetToken();
        }, this.appId, function() {
            return _this.tryRelaunch();
        });
        if ((0, $lsuk0.isLowerEnv)(this.lwDomain)) console.log("PS - v".concat($12tws.version));
    }
    PlatformService.initialize = function(_a) {
        return $81f5be1abf5b3cba$var$__awaiter(this, arguments, void 0, function(_b) {
            var searchParams, platformService, doLwaSessionCheck, authenticationApiUrl, sessionStatusResponse, isAuthenticated, connectionToValidate, appData, userCanAccess;
            var _c, _d, _e;
            var lwDomain = _b.lwDomain, platformUrlOverride = _b.platformUrlOverride, foundationUrlOverride = _b.foundationUrlOverride, token = _b.token, appId = _b.appId, activeClientId = _b.activeClientId, platformClientId = _b.platformClientId, forceEndLwaSession = _b.forceEndLwaSession, beforeSignOutCallback = _b.beforeSignOutCallback, luParamSupplier = _b.luParamSupplier, _f = _b.lwaOnly, lwaOnly = _f === void 0 ? false : _f, _g = _b.includeOriginInRedirects, includeOriginInRedirects = _g === void 0 ? false : _g, _h = _b.enablePopups, enablePopups = _h === void 0 ? false : _h, _j = _b.useRedirectParam, useRedirectParam = _j === void 0 ? true : _j, _k = _b.skipSessionCheck, skipSessionCheck = _k === void 0 ? false : _k, logRocket = _b.logRocket, onImpersonationSessionWarning = _b.onImpersonationSessionWarning, onTokenChange = _b.onTokenChange;
            return $81f5be1abf5b3cba$var$__generator(this, function(_l) {
                switch(_l.label){
                    case 0:
                        if (!lwDomain) throw Error("lwDomain is required.");
                        if (forceEndLwaSession) {
                            if (lwaOnly) throw Error("forceEndLwaSession cannot be true for lwaOnly mode.");
                            token = undefined;
                            $81f5be1abf5b3cba$var$storeToken(lwDomain, token, appId);
                        }
                        if (token) // If a token is passed in, save it to our storage chain.
                        $81f5be1abf5b3cba$var$storeAndVerifyToken(lwDomain, token, appId);
                        else // If a token is NOT passed in, try reading it from the storage chain.
                        token = $81f5be1abf5b3cba$var$getStoredToken(lwDomain, appId);
                        // If activeClientId is not specified, look for the older platformClientId property.
                        if (!activeClientId) activeClientId = platformClientId;
                        // If that is not specified either, read the ac query parameter.
                        if (!activeClientId) {
                            searchParams = new URLSearchParams(window.location.search);
                            if (searchParams.get($81f5be1abf5b3cba$var$ACTIVE_CLIENT_ID_KEY_NAME)) activeClientId = (_c = searchParams.get($81f5be1abf5b3cba$var$ACTIVE_CLIENT_ID_KEY_NAME)) !== null && _c !== void 0 ? _c : undefined;
                        }
                        platformService = new PlatformService(lwDomain, platformUrlOverride, foundationUrlOverride, token, appId, activeClientId, lwaOnly, includeOriginInRedirects, enablePopups, beforeSignOutCallback, luParamSupplier, useRedirectParam, onImpersonationSessionWarning, onTokenChange);
                        platformService.initLogRocket(logRocket);
                        platformService.sessionMonitor.start();
                        doLwaSessionCheck = !!token || lwaOnly;
                        if (!(doLwaSessionCheck && !$81f5be1abf5b3cba$var$isPlatformUiAppId(appId))) return [
                            3 /*break*/ ,
                            11
                        ];
                        if (!(!token || $81f5be1abf5b3cba$var$isTokenExpired(token))) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            platformService.refreshToken()
                        ];
                    case 1:
                        _l.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 2:
                        if (!!skipSessionCheck) return [
                            3 /*break*/ ,
                            5
                        ];
                        authenticationApiUrl = platformService.getAuthenticationApiUrl();
                        return [
                            4 /*yield*/ ,
                            $81f5be1abf5b3cba$var$makeFetchCall("".concat(authenticationApiUrl, "/v1/check-session"), token)
                        ];
                    case 3:
                        sessionStatusResponse = _l.sent();
                        isAuthenticated = sessionStatusResponse.ok || sessionStatusResponse.status !== 403;
                        if (!!isAuthenticated) return [
                            3 /*break*/ ,
                            5
                        ];
                        return [
                            4 /*yield*/ ,
                            platformService.refreshToken()
                        ];
                    case 4:
                        _l.sent();
                        _l.label = 5;
                    case 5:
                        connectionToValidate = undefined;
                        if (!!$81f5be1abf5b3cba$var$isPlatformOrFoundationApp(appId)) return [
                            3 /*break*/ ,
                            8
                        ];
                        if (!activeClientId) return [
                            3 /*break*/ ,
                            6
                        ];
                        connectionToValidate = {
                            appId: appId,
                            platformClient: true,
                            clientId: activeClientId
                        };
                        return [
                            3 /*break*/ ,
                            8
                        ];
                    case 6:
                        return [
                            4 /*yield*/ ,
                            platformService.getAppData()
                        ];
                    case 7:
                        appData = (_d = _l.sent()) === null || _d === void 0 ? void 0 : _d.find(function(appData) {
                            return appData.id === appId;
                        });
                        // Otherwise, if it is a promotional app, we validate it as such.
                        if ((_e = appData === null || appData === void 0 ? void 0 : appData.config.promotion) === null || _e === void 0 ? void 0 : _e.url) connectionToValidate = {
                            name: "",
                            appId: appId,
                            pseudoPromotionalConnection: true
                        };
                        else if ((appData === null || appData === void 0 ? void 0 : appData.config.hidden) || (appData === null || appData === void 0 ? void 0 : appData.config.collapseItems)) connectionToValidate = {
                            appId: appId,
                            platformClient: true
                        };
                        _l.label = 8;
                    case 8:
                        if (!connectionToValidate) return [
                            3 /*break*/ ,
                            10
                        ];
                        return [
                            4 /*yield*/ ,
                            platformService.userCanAccess(connectionToValidate)
                        ];
                    case 9:
                        userCanAccess = _l.sent();
                        if (!userCanAccess) platformService.tryRelaunch();
                        _l.label = 10;
                    case 10:
                        platformService.tokenMonitor.start();
                        _l.label = 11;
                    case 11:
                        return [
                            2 /*return*/ ,
                            platformService
                        ];
                }
            });
        });
    };
    PlatformService.prototype.getPlatformUrl = function() {
        var _a;
        return (_a = this.platformUrlOverride) !== null && _a !== void 0 ? _a : $81f5be1abf5b3cba$var$buildUrl(this.lwDomain, "platform");
    };
    PlatformService.prototype.getFoundationUrl = function() {
        var _a;
        return (_a = this.foundationUrlOverride) !== null && _a !== void 0 ? _a : $81f5be1abf5b3cba$var$buildUrl(this.lwDomain, "foundation");
    };
    PlatformService.prototype.getAuthenticationApiUrl = function() {
        return $81f5be1abf5b3cba$var$buildUrl(this.lwDomain, "authentication.api");
    };
    PlatformService.prototype.getPlatformApiUrl = function() {
        return $81f5be1abf5b3cba$var$buildUrl(this.lwDomain, "platform.api");
    };
    PlatformService.prototype.getEcommerceUrl = function() {
        return $81f5be1abf5b3cba$var$buildUrl(this.lwDomain, "ecommerce");
    };
    PlatformService.prototype.logout = function() {
        this.tryRelaunch(true);
    };
    PlatformService.prototype.tryRelaunch = function(forceLogout) {
        var _a, _b, _c, _d;
        if (forceLogout === void 0) forceLogout = false;
        (0, $lsuk0.setSignOutInProgress)();
        this.tokenMonitor.stop();
        this.impersonationSessionMonitor.stop();
        this.sessionMonitor.stop();
        $81f5be1abf5b3cba$var$storeToken(this.lwDomain, undefined, this.appId);
        if (this.beforeSignOutCallback) try {
            this.beforeSignOutCallback();
        } catch (error) {
            console.error("beforeSignOutCallback threw during sign-out:", error);
        }
        var url;
        if (forceLogout) url = "".concat(this.getPlatformUrl(), "/logout");
        else if (this.appId && !$81f5be1abf5b3cba$var$isPlatformUiAppId(this.appId)) {
            var userUrlEncoded = encodeURIComponent(this.includeOriginInRedirects ? window.location.href : window.location.pathname + window.location.search);
            url = "".concat(this.getPlatformUrl(), "/product/launch?a=").concat(this.appId);
            if (userUrlEncoded && userUrlEncoded !== encodeURIComponent("/")) url = "".concat(url, "&r=").concat(userUrlEncoded);
            if (this.activeClientId) {
                // If the current application uses connections (not clients) from the LWA, do NOT include
                // active client id in the re-launch URL.
                var appsClaimRecord = (_c = (_b = (_a = this.tokenPayload) === null || _a === void 0 ? void 0 : _a.getLwtClaim()) === null || _b === void 0 ? void 0 : _b.getAppsClaim()) !== null && _c !== void 0 ? _c : {};
                if (!appsClaimRecord[(_d = this.appId) !== null && _d !== void 0 ? _d : ""]) url = "".concat(url, "&ac=").concat(this.activeClientId);
            }
            if (this.luParamSupplier) {
                var luParamValue = this.luParamSupplier();
                if (luParamValue) url = "".concat(url, "&lu=").concat(luParamValue);
            }
        } else url = "".concat(this.getPlatformUrl());
        window.location.assign(url);
    };
    PlatformService.prototype.getAuthenticatedIdPs = function(useCache) {
        var _this = this;
        if (useCache === void 0) useCache = true;
        return this.fetchWithCache({
            url: "".concat(this.getAuthenticationApiUrl(), "/v1/authenticated-identity-providers"),
            cacheKey: $81f5be1abf5b3cba$var$AUTHENTICATED_IDPS_CACHE_KEY_SUFFIX,
            getMemoryCache: function() {
                return _this.cachedAuthenticatedIdPs;
            },
            setMemoryCache: function(data) {
                _this.cachedAuthenticatedIdPs = $81f5be1abf5b3cba$var$__spreadArray([], data, true);
            },
            fallback: [],
            useCache: useCache
        });
    };
    PlatformService.prototype.getAppData = function(useCache) {
        var _this = this;
        if (useCache === void 0) useCache = true;
        return this.fetchWithCache({
            url: "".concat(this.getPlatformApiUrl(), "/v1/unified-login-configs"),
            cacheKey: $81f5be1abf5b3cba$var$APP_DATA_CACHE_KEY_SUFFIX,
            getMemoryCache: function() {
                return _this.cachedAppData;
            },
            setMemoryCache: function(data) {
                var _a;
                _this.cachedAppData = $81f5be1abf5b3cba$var$__spreadArray([], data, true);
                var currentAppConfig = (_a = data.find(function(c) {
                    return c.id === _this.appId;
                })) === null || _a === void 0 ? void 0 : _a.config;
                _this.appName = currentAppConfig === null || currentAppConfig === void 0 ? void 0 : currentAppConfig.name;
            },
            fallback: [],
            useCache: useCache
        });
    };
    PlatformService.prototype.getLwaClients = function(useCache) {
        var _this = this;
        var _a, _b;
        if (useCache === void 0) useCache = true;
        var userId = (_b = (_a = this.tokenPayload) === null || _a === void 0 ? void 0 : _a.getLwtClaim()) === null || _b === void 0 ? void 0 : _b.getUserId();
        return this.fetchWithCache({
            url: "".concat(this.getAuthenticationApiUrl(), "/v1/users/").concat(userId, "/clients"),
            cacheKey: $81f5be1abf5b3cba$var$LWA_CLIENTS_CACHE_KEY_SUFFIX,
            getMemoryCache: function() {
                return _this.cachedLwaClients;
            },
            setMemoryCache: function(data) {
                _this.cachedLwaClients = $81f5be1abf5b3cba$var$__spreadArray([], data, true);
            },
            fallback: [],
            useCache: useCache
        });
    };
    /**
     * @deprecated since version 3.12.0
     *
     * This function is deprecated and will be removed at some point in the future. Use the {@link PlatformService#getClientsInToken} function instead.
     */ PlatformService.prototype.getClients = function() {
        return this.getClientsInToken();
    };
    PlatformService.prototype.getClientsInToken = function() {
        var _a, _b, _c;
        var token = this.validateAndGetToken();
        if (!token) return Promise.resolve([]);
        var clients = (_c = (_b = (_a = this.tokenPayload) === null || _a === void 0 ? void 0 : _a.getLwtClaim()) === null || _b === void 0 ? void 0 : _b.getClients()) !== null && _c !== void 0 ? _c : [];
        return Promise.resolve(clients);
    };
    PlatformService.prototype.getClientsSummary = function(useCache) {
        var _this = this;
        if (useCache === void 0) useCache = true;
        var doGetClientsSummary = function() {
            return $81f5be1abf5b3cba$var$__awaiter(_this, void 0, void 0, function() {
                var lwaClients, clients, _i, lwaClients_1, lwaClient, client, clientSummary;
                var _a;
                return $81f5be1abf5b3cba$var$__generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.getLwaClients(useCache)
                            ];
                        case 1:
                            lwaClients = _b.sent();
                            clients = [];
                            _i = 0, lwaClients_1 = lwaClients;
                            _b.label = 2;
                        case 2:
                            if (!(_i < lwaClients_1.length)) return [
                                3 /*break*/ ,
                                5
                            ];
                            lwaClient = lwaClients_1[_i];
                            return [
                                4 /*yield*/ ,
                                this.getClientSummary(lwaClient.clientId, {
                                    id: lwaClient.clientId,
                                    name: lwaClient.clientId,
                                    type: (_a = lwaClient.clientType) !== null && _a !== void 0 ? _a : "Unknown",
                                    externalSystemId: undefined,
                                    identityProviderId: undefined
                                }, useCache)
                            ];
                        case 3:
                            client = _b.sent();
                            if (client) {
                                clientSummary = this.mapToClientSummary(client);
                                clients.push(clientSummary);
                            }
                            _b.label = 4;
                        case 4:
                            _i++;
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case 5:
                            return [
                                2 /*return*/ ,
                                clients
                            ];
                    }
                });
            });
        };
        return doGetClientsSummary();
    };
    PlatformService.prototype.getClientsAsConnections = function() {
        return $81f5be1abf5b3cba$var$__awaiter(this, arguments, void 0, function(useCache) {
            var legacyConnections, response;
            if (useCache === void 0) useCache = true;
            return $81f5be1abf5b3cba$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.buildLegacyConnections(useCache)
                        ];
                    case 1:
                        legacyConnections = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.tryGetLwaClientApps(useCache)
                        ];
                    case 2:
                        response = _a.sent();
                        if (!response) return [
                            2 /*return*/ ,
                            legacyConnections
                        ];
                        return [
                            2 /*return*/ ,
                            this.filterByEndpointVisibility(legacyConnections, response)
                        ];
                }
            });
        });
    };
    PlatformService.prototype.filterByEndpointVisibility = function(connections, response) {
        var visiblePairs = new Set();
        var visibleAppCodes = new Set();
        for(var _i = 0, _a = response.clients; _i < _a.length; _i++){
            var client = _a[_i];
            for(var _b = 0, _c = client.applications; _b < _c.length; _b++){
                var app = _c[_b];
                visiblePairs.add("".concat(client.id, "::").concat(app.id));
                visibleAppCodes.add(app.id);
            }
        }
        return connections.filter(function(conn) {
            var clientId = conn.clientId;
            if (clientId === null || clientId === undefined) return visibleAppCodes.has(conn.appId);
            return visiblePairs.has("".concat(clientId, "::").concat(conn.appId));
        });
    };
    PlatformService.prototype.buildLegacyConnections = function(useCache) {
        var _this = this;
        if (useCache === void 0) useCache = true;
        var mapClients = function() {
            return $81f5be1abf5b3cba$var$__awaiter(_this, void 0, void 0, function() {
                var clients, connections, _loop_1, this_1, _i, clients_1, client, twConnections, twNonUserConnections, twUserConnection, userTypeClient, userTypeClientExternalSystems_1, removeTwUserConnection, _loop_2, _a, twNonUserConnections_1, twNonUserConnection, state_1, getClientType, twBlConnections, twBeConnections, removeTwBlConnectionIds_1, _loop_3, _b, twBlConnections_1, twBlConn;
                var _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
                return $81f5be1abf5b3cba$var$__generator(this, function(_q) {
                    switch(_q.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.getLwaClients(useCache)
                            ];
                        case 1:
                            clients = _q.sent();
                            connections = [];
                            _loop_1 = function(client) {
                                var platformClient, _loop_4, _r, _s, application;
                                return $81f5be1abf5b3cba$var$__generator(this, function(_t) {
                                    switch(_t.label){
                                        case 0:
                                            return [
                                                4 /*yield*/ ,
                                                this_1.getClientSummary(client.clientId, {
                                                    id: client.clientId,
                                                    name: client.clientId,
                                                    type: (_c = client.clientType) !== null && _c !== void 0 ? _c : "Unknown",
                                                    externalSystemId: undefined,
                                                    branding: undefined
                                                }, useCache)
                                            ];
                                        case 1:
                                            platformClient = _t.sent();
                                            if (!platformClient) return [
                                                2 /*return*/ ,
                                                "continue"
                                            ];
                                            _loop_4 = function(application) {
                                                var applicationCode, appData, collapseItems, appExist, modules, connection, appName, brandedOwnerCount_1, ownerClientSummaries, _u, _v, ownerClient, ownerClientSummary;
                                                return $81f5be1abf5b3cba$var$__generator(this, function(_w) {
                                                    switch(_w.label){
                                                        case 0:
                                                            applicationCode = application.code;
                                                            return [
                                                                4 /*yield*/ ,
                                                                this_1.getAppData()
                                                            ];
                                                        case 1:
                                                            appData = _w.sent().find(function(config) {
                                                                return config.id === applicationCode;
                                                            });
                                                            collapseItems = (_e = appData === null || appData === void 0 ? void 0 : appData.config.collapseItems) !== null && _e !== void 0 ? _e : false;
                                                            appExist = connections.find(function(connection) {
                                                                return connection.appId === applicationCode;
                                                            });
                                                            modules = (_f = application.modules) === null || _f === void 0 ? void 0 : _f.map(function(module) {
                                                                return "".concat(application.code, "-").concat(module.code);
                                                            });
                                                            if (collapseItems && appExist) return [
                                                                2 /*return*/ ,
                                                                "continue"
                                                            ];
                                                            connection = {
                                                                appId: applicationCode,
                                                                name: platformClient.name,
                                                                clientId: !collapseItems ? client.clientId : null,
                                                                platformClient: true,
                                                                modules: modules
                                                            };
                                                            if (!(platformClient.branding && (appData === null || appData === void 0 ? void 0 : appData.supportsBranding))) return [
                                                                3 /*break*/ ,
                                                                2
                                                            ];
                                                            connection.branding = {};
                                                            if (platformClient.branding.logoUrl) connection.branding.logoUrl = platformClient.branding.logoUrl;
                                                            if (platformClient.branding.applications) {
                                                                appName = (_g = platformClient.branding.applications[applicationCode]) === null || _g === void 0 ? void 0 : _g.name;
                                                                if (appName && appName !== ((_h = appData === null || appData === void 0 ? void 0 : appData.config) === null || _h === void 0 ? void 0 : _h.name)) connection.branding.appName = appName;
                                                            }
                                                            return [
                                                                3 /*break*/ ,
                                                                7
                                                            ];
                                                        case 2:
                                                            if (!(client.clientId === ((_l = (_k = (_j = $81f5be1abf5b3cba$var$Authentication_1.default.parseToken(this_1.validateAndGetToken())) === null || _j === void 0 ? void 0 : _j.getLwtClaim()) === null || _k === void 0 ? void 0 : _k.getPersonalClient()) === null || _l === void 0 ? void 0 : _l.getId()) && (appData === null || appData === void 0 ? void 0 : appData.supportsBranding) && ((_m = application === null || application === void 0 ? void 0 : application.ownerClients) === null || _m === void 0 ? void 0 : _m.length))) return [
                                                                3 /*break*/ ,
                                                                7
                                                            ];
                                                            brandedOwnerCount_1 = 0;
                                                            ownerClientSummaries = [];
                                                            _u = 0, _v = application.ownerClients;
                                                            _w.label = 3;
                                                        case 3:
                                                            if (!(_u < _v.length)) return [
                                                                3 /*break*/ ,
                                                                6
                                                            ];
                                                            ownerClient = _v[_u];
                                                            return [
                                                                4 /*yield*/ ,
                                                                this_1.getClientSummary(ownerClient.id, undefined, useCache)
                                                            ];
                                                        case 4:
                                                            ownerClientSummary = _w.sent();
                                                            if (ownerClientSummary) ownerClientSummaries.push(ownerClientSummary);
                                                            _w.label = 5;
                                                        case 5:
                                                            _u++;
                                                            return [
                                                                3 /*break*/ ,
                                                                3
                                                            ];
                                                        case 6:
                                                            ownerClientSummaries.forEach(function(oc) {
                                                                var _a, _b;
                                                                if (oc.branding) {
                                                                    var ownerConnection = {
                                                                        appId: applicationCode,
                                                                        name: platformClient.name,
                                                                        clientId: !collapseItems ? client.clientId : null,
                                                                        platformClient: true,
                                                                        modules: modules
                                                                    };
                                                                    ownerConnection.branding = {};
                                                                    if (oc.branding.logoUrl) ownerConnection.branding.logoUrl = oc.branding.logoUrl;
                                                                    if (oc.branding.applications) {
                                                                        var appName = (_a = oc.branding.applications[applicationCode]) === null || _a === void 0 ? void 0 : _a.name;
                                                                        if (appName && appName !== ((_b = appData === null || appData === void 0 ? void 0 : appData.config) === null || _b === void 0 ? void 0 : _b.name)) ownerConnection.branding.appName = appName;
                                                                    }
                                                                    connections.push(ownerConnection);
                                                                    brandedOwnerCount_1++;
                                                                }
                                                            });
                                                            if (brandedOwnerCount_1 == ownerClientSummaries.length) return [
                                                                2 /*return*/ ,
                                                                "continue"
                                                            ];
                                                            _w.label = 7;
                                                        case 7:
                                                            connections.push(connection);
                                                            return [
                                                                2 /*return*/ 
                                                            ];
                                                    }
                                                });
                                            };
                                            _r = 0, _s = (_d = client.applications) !== null && _d !== void 0 ? _d : [];
                                            _t.label = 2;
                                        case 2:
                                            if (!(_r < _s.length)) return [
                                                3 /*break*/ ,
                                                5
                                            ];
                                            application = _s[_r];
                                            return [
                                                5 /*yield**/ ,
                                                _loop_4(application)
                                            ];
                                        case 3:
                                            _t.sent();
                                            _t.label = 4;
                                        case 4:
                                            _r++;
                                            return [
                                                3 /*break*/ ,
                                                2
                                            ];
                                        case 5:
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, clients_1 = clients;
                            _q.label = 2;
                        case 2:
                            if (!(_i < clients_1.length)) return [
                                3 /*break*/ ,
                                5
                            ];
                            client = clients_1[_i];
                            return [
                                5 /*yield**/ ,
                                _loop_1(client)
                            ];
                        case 3:
                            _q.sent();
                            _q.label = 4;
                        case 4:
                            _i++;
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case 5:
                            twConnections = connections.filter(function(c) {
                                return c.appId === "tw";
                            });
                            twNonUserConnections = twConnections.filter(function(conn) {
                                var client = clients.find(function(c) {
                                    return c.clientId === conn.clientId;
                                });
                                return (client === null || client === void 0 ? void 0 : client.clientType) !== "User";
                            });
                            twUserConnection = twConnections.find(function(conn) {
                                var client = clients.find(function(c) {
                                    return c.clientId === conn.clientId;
                                });
                                return (client === null || client === void 0 ? void 0 : client.clientType) === "User";
                            });
                            if (twUserConnection) {
                                userTypeClient = clients.find(function(c) {
                                    return c.clientId === twUserConnection.clientId;
                                });
                                userTypeClientExternalSystems_1 = userTypeClient.externalSystems;
                                if (userTypeClientExternalSystems_1 && userTypeClientExternalSystems_1.length > 0 && twNonUserConnections.length > 0) {
                                    removeTwUserConnection = false;
                                    _loop_2 = function(twNonUserConnection) {
                                        if (removeTwUserConnection) return "break";
                                        var client = clients.filter(function(c) {
                                            return c.clientId === twNonUserConnection.clientId;
                                        })[0];
                                        var userExternalSystems = client.externalSystems;
                                        var _loop_5 = function(userTypeClientExternalSystem) {
                                            var matchingExternalSystemInfoFound = userExternalSystems ? userExternalSystems.some(function(ues) {
                                                var _a;
                                                return ues.code === userTypeClientExternalSystem.code && ues.number === ((_a = userTypeClientExternalSystems_1.find(function(ex) {
                                                    return ex.code === userTypeClientExternalSystem.code;
                                                })) === null || _a === void 0 ? void 0 : _a.number);
                                            }) : false;
                                            if (matchingExternalSystemInfoFound) {
                                                removeTwUserConnection = true;
                                                return "break";
                                            }
                                        };
                                        for(var _x = 0, userTypeClientExternalSystems_2 = userTypeClientExternalSystems_1; _x < userTypeClientExternalSystems_2.length; _x++){
                                            var userTypeClientExternalSystem = userTypeClientExternalSystems_2[_x];
                                            var state_2 = _loop_5(userTypeClientExternalSystem);
                                            if (state_2 === "break") break;
                                        }
                                    };
                                    for(_a = 0, twNonUserConnections_1 = twNonUserConnections; _a < twNonUserConnections_1.length; _a++){
                                        twNonUserConnection = twNonUserConnections_1[_a];
                                        state_1 = _loop_2(twNonUserConnection);
                                        if (state_1 === "break") break;
                                    }
                                    if (removeTwUserConnection) connections = connections.filter(function(conn) {
                                        return conn.appId !== "tw" || conn.clientId !== twUserConnection.clientId;
                                    });
                                }
                            }
                            getClientType = function(connection) {
                                var _a;
                                return (_a = clients.find(function(client) {
                                    return client.clientId === connection.clientId;
                                })) === null || _a === void 0 ? void 0 : _a.clientType;
                            };
                            twBlConnections = connections.filter(function(c) {
                                var _a, _b;
                                var clientType = (_a = getClientType(c)) !== null && _a !== void 0 ? _a : "";
                                return ((_b = c.modules) === null || _b === void 0 ? void 0 : _b.includes("tw-bl")) && [
                                    "MLS",
                                    "Association"
                                ].some(function(type) {
                                    return clientType.toLowerCase().includes(type.toLowerCase());
                                });
                            });
                            twBeConnections = connections.filter(function(c) {
                                var _a;
                                return ((_a = c.modules) === null || _a === void 0 ? void 0 : _a.includes("tw-be")) && getClientType(c) === "Brokerage";
                            });
                            if (twBlConnections.length > 0 && twBeConnections.length > 0) {
                                removeTwBlConnectionIds_1 = [];
                                _loop_3 = function(twBlConn) {
                                    var blExternalSystems = (_o = clients.find(function(c) {
                                        return c.clientId === twBlConn.clientId;
                                    })) === null || _o === void 0 ? void 0 : _o.externalSystems;
                                    if (!(blExternalSystems === null || blExternalSystems === void 0 ? void 0 : blExternalSystems.length)) return "continue";
                                    var _loop_6 = function(twBeConn) {
                                        var beExternalSystems = (_p = clients.find(function(c) {
                                            return c.clientId === twBeConn.clientId;
                                        })) === null || _p === void 0 ? void 0 : _p.externalSystems;
                                        if (!(beExternalSystems === null || beExternalSystems === void 0 ? void 0 : beExternalSystems.length)) return "continue";
                                        var matchingExternalSystemInfoFound = blExternalSystems.some(function(blEs) {
                                            return beExternalSystems.some(function(beEs) {
                                                return beEs.code === blEs.code && beEs.number === blEs.number;
                                            });
                                        });
                                        if (matchingExternalSystemInfoFound) {
                                            removeTwBlConnectionIds_1.push(twBlConn.clientId);
                                            return "break";
                                        }
                                    };
                                    for(var _y = 0, twBeConnections_1 = twBeConnections; _y < twBeConnections_1.length; _y++){
                                        var twBeConn = twBeConnections_1[_y];
                                        var state_3 = _loop_6(twBeConn);
                                        if (state_3 === "break") break;
                                    }
                                };
                                for(_b = 0, twBlConnections_1 = twBlConnections; _b < twBlConnections_1.length; _b++){
                                    twBlConn = twBlConnections_1[_b];
                                    _loop_3(twBlConn);
                                }
                                if (removeTwBlConnectionIds_1.length > 0) connections = connections.filter(function(conn) {
                                    var _a;
                                    return !(((_a = conn.modules) === null || _a === void 0 ? void 0 : _a.includes("tw-bl")) && removeTwBlConnectionIds_1.includes(conn.clientId));
                                });
                            }
                            return [
                                2 /*return*/ ,
                                Promise.resolve(connections)
                            ];
                    }
                });
            });
        };
        return mapClients();
    };
    PlatformService.prototype.getLwaClientApps = function() {
        return $81f5be1abf5b3cba$var$__awaiter(this, arguments, void 0, function(useCache) {
            var response;
            if (useCache === void 0) useCache = true;
            return $81f5be1abf5b3cba$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.tryGetLwaClientApps(useCache)
                        ];
                    case 1:
                        response = _a.sent();
                        return [
                            2 /*return*/ ,
                            response !== null && response !== void 0 ? response : {
                                clients: []
                            }
                        ];
                }
            });
        });
    };
    PlatformService.prototype.tryGetLwaClientApps = function() {
        return $81f5be1abf5b3cba$var$__awaiter(this, arguments, void 0, function(useCache) {
            var err_1, status_1;
            var _this = this;
            if (useCache === void 0) useCache = true;
            return $81f5be1abf5b3cba$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.lwaClientAppsEndpointDisabled) return [
                            2 /*return*/ ,
                            undefined
                        ];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.fetchWithCache({
                                url: "".concat(this.getPlatformApiUrl(), "/v1/lwa-client-apps"),
                                cacheKey: $81f5be1abf5b3cba$var$LWA_CLIENT_APPS_CACHE_KEY_SUFFIX,
                                getMemoryCache: function() {
                                    return _this.cachedLwaClientApps;
                                },
                                setMemoryCache: function(data) {
                                    _this.cachedLwaClientApps = data;
                                },
                                fallback: {
                                    clients: []
                                },
                                useCache: useCache
                            })
                        ];
                    case 2:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                    case 3:
                        err_1 = _a.sent();
                        status_1 = err_1.status;
                        // TypeError covers CORS-blocked 405s where the browser hides the status from JS.
                        if (status_1 === 405 || err_1 instanceof TypeError) {
                            this.lwaClientAppsEndpointDisabled = true;
                            return [
                                2 /*return*/ ,
                                undefined
                            ];
                        }
                        throw err_1;
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    PlatformService.prototype.getConnections = function() {
        return $81f5be1abf5b3cba$var$__awaiter(this, arguments, void 0, function(useCache, includePlatformClients) {
            var userId, connections, clients;
            var _this = this;
            var _a, _b;
            if (useCache === void 0) useCache = true;
            if (includePlatformClients === void 0) includePlatformClients = true;
            return $81f5be1abf5b3cba$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        userId = (_b = (_a = this.tokenPayload) === null || _a === void 0 ? void 0 : _a.getLwtClaim()) === null || _b === void 0 ? void 0 : _b.getUserId();
                        return [
                            4 /*yield*/ ,
                            this.fetchWithCache({
                                url: "".concat(this.getAuthenticationApiUrl(), "/v1/users/").concat(userId, "/connections"),
                                cacheKey: $81f5be1abf5b3cba$var$CONNECTIONS_CACHE_KEY_SUFFIX,
                                getMemoryCache: function() {
                                    return _this.cachedConnections;
                                },
                                setMemoryCache: function(data) {
                                    _this.cachedConnections = data;
                                },
                                mapResponse: function(json) {
                                    return json.filter($81f5be1abf5b3cba$var$isActiveConnection);
                                },
                                fallback: [],
                                useCache: useCache
                            })
                        ];
                    case 1:
                        connections = _c.sent();
                        if (!includePlatformClients) return [
                            2 /*return*/ ,
                            connections
                        ];
                        return [
                            4 /*yield*/ ,
                            this.getClientsAsConnections(useCache)
                        ];
                    case 2:
                        clients = _c.sent();
                        return [
                            2 /*return*/ ,
                            $81f5be1abf5b3cba$var$__spreadArray($81f5be1abf5b3cba$var$__spreadArray([], connections, true), clients, true)
                        ];
                }
            });
        });
    };
    PlatformService.prototype.getAppSections = function(useCache) {
        var _this = this;
        if (useCache === void 0) useCache = true;
        return this.getConnections(useCache, true).then(function(connections) {
            return $81f5be1abf5b3cba$var$__awaiter(_this, void 0, void 0, function() {
                var appData, sectionItems, appMap, namesMap, _loop_7, this_2, _i, _a, connection, _b, sectionItems_1, sectionItem;
                var _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
                return $81f5be1abf5b3cba$var$__generator(this, function(_p) {
                    switch(_p.label){
                        case 0:
                            return [
                                4 /*yield*/ ,
                                this.getAppData(useCache)
                            ];
                        case 1:
                            appData = _p.sent();
                            sectionItems = [];
                            appMap = new Map();
                            namesMap = new Map();
                            _loop_7 = function(connection) {
                                var data = void 0;
                                data = appData.find(function(config) {
                                    return config.id === connection.appId;
                                });
                                if (!data || data.config.hidden === true) return "continue";
                                var app = void 0;
                                // Create a new SectionItem if one doesn't already exist
                                // OR if there is custom branding
                                if (!appMap.has(connection.appId) || ((_c = connection.branding) === null || _c === void 0 ? void 0 : _c.logoUrl) || ((_d = connection.branding) === null || _d === void 0 ? void 0 : _d.appName)) {
                                    app = $81f5be1abf5b3cba$var$__assign({
                                        description: data.config.description,
                                        label: ((_e = connection.branding) === null || _e === void 0 ? void 0 : _e.appName) || data.config.name,
                                        selected: this_2.appId === connection.appId
                                    }, this_2.getLaunchAppProp(connection));
                                    if ((_f = connection.branding) === null || _f === void 0 ? void 0 : _f.logoUrl) app.iconUrl = connection.branding.logoUrl;
                                    else app.icon = data.config.icon;
                                    // IF there is no custom branding, push to appMap for future AppInstances to be added to this SectionItem
                                    if (!((_g = connection.branding) === null || _g === void 0 ? void 0 : _g.logoUrl) && !((_h = connection.branding) === null || _h === void 0 ? void 0 : _h.appName)) appMap.set(connection.appId, app);
                                    sectionItems.push(app);
                                } else app = appMap.get(connection.appId);
                                // add the connection name to the list
                                var names = void 0;
                                if (!namesMap.has(connection.appId) || ((_j = connection.branding) === null || _j === void 0 ? void 0 : _j.logoUrl) || ((_k = connection.branding) === null || _k === void 0 ? void 0 : _k.appName)) {
                                    names = [
                                        $81f5be1abf5b3cba$var$__assign({
                                            label: connection.name
                                        }, this_2.getLaunchAppProp(connection))
                                    ];
                                    // IF there is no custom branding, push to namesMap for future AppInstances to be added
                                    if (!((_l = connection.branding) === null || _l === void 0 ? void 0 : _l.logoUrl) && !((_m = connection.branding) === null || _m === void 0 ? void 0 : _m.appName)) namesMap.set(connection.appId, names);
                                } else {
                                    names = namesMap.get(connection.appId);
                                    names.push($81f5be1abf5b3cba$var$__assign({
                                        label: connection.name
                                    }, this_2.getLaunchAppProp(connection)));
                                    app.appInstances = names;
                                }
                            };
                            this_2 = this;
                            for(_i = 0, _a = connections !== null && connections !== void 0 ? connections : []; _i < _a.length; _i++){
                                connection = _a[_i];
                                _loop_7(connection);
                            }
                            // finally, sort the arrays
                            sectionItems.sort($81f5be1abf5b3cba$var$getCompareFunction("label", {
                                ignoreCase: true
                            }));
                            for(_b = 0, sectionItems_1 = sectionItems; _b < sectionItems_1.length; _b++){
                                sectionItem = sectionItems_1[_b];
                                (_o = sectionItem.appInstances) === null || _o === void 0 || _o.sort($81f5be1abf5b3cba$var$getCompareFunction("label", {
                                    ignoreCase: true
                                }));
                                if (sectionItem.appInstances) sectionItem.url = sectionItem.appInstances[0].url;
                            }
                            return [
                                2 /*return*/ ,
                                [
                                    {
                                        sectionItems: sectionItems
                                    }
                                ]
                            ];
                    }
                });
            });
        });
    };
    PlatformService.prototype.getAdminMenuItems = function() {
        return $81f5be1abf5b3cba$var$__awaiter(this, void 0, void 0, function() {
            var token, appId, clients, userPermissions, adminPermissions, adminPermissionsIds, menuItems;
            var _this = this;
            return $81f5be1abf5b3cba$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        token = this.validateAndGetToken();
                        appId = this.appId;
                        if (!token) return [
                            2 /*return*/ ,
                            Promise.resolve([])
                        ];
                        return [
                            4 /*yield*/ ,
                            this.getClientsSummary(true)
                        ];
                    case 1:
                        clients = _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.getJsonResponseFromFetch("".concat(this.getPlatformApiUrl(), "/v1/user-permissions"), token, appId, function() {
                                return _this.tryRelaunch();
                            }, [], $81f5be1abf5b3cba$var$USER_PERMISSIONS_CACHE_KEY_SUFFIX)
                        ];
                    case 2:
                        userPermissions = _a.sent();
                        if (!(userPermissions === null || userPermissions === void 0 ? void 0 : userPermissions.length)) return [
                            2 /*return*/ ,
                            []
                        ];
                        return [
                            4 /*yield*/ ,
                            this.getJsonResponseFromFetch("".concat(this.getPlatformApiUrl(), "/v1/permissions"), token, appId, function() {
                                return _this.tryRelaunch();
                            }, [], $81f5be1abf5b3cba$var$ADMIN_PERMISSIONS_CACHE_KEY_SUFFIX)
                        ];
                    case 3:
                        adminPermissions = _a.sent();
                        adminPermissionsIds = adminPermissions === null || adminPermissions === void 0 ? void 0 : adminPermissions.map(function(p) {
                            return p.id;
                        });
                        menuItems = [];
                        clients === null || clients === void 0 || clients.filter(function(client) {
                            return client.type !== "User";
                        }).forEach(function(client) {
                            var _a;
                            var clientPermissions = (_a = userPermissions.find(function(p) {
                                return p.clientId === client.id;
                            })) === null || _a === void 0 ? void 0 : _a.permissions;
                            var hasAdminPermissions = function(permissions) {
                                return adminPermissionsIds.some(function(perm) {
                                    return Object.hasOwnProperty.call(permissions, perm);
                                });
                            };
                            if (clientPermissions && hasAdminPermissions(clientPermissions)) {
                                menuItems.push({
                                    label: client.name,
                                    onClick: function() {
                                        return _this.redirectAfterPfmAuth("".concat(_this.getFoundationUrl(), "/manage/admin/").concat(client.id), true);
                                    }
                                });
                                return client;
                            }
                            return undefined;
                        });
                        if (menuItems[0]) return [
                            2 /*return*/ ,
                            $81f5be1abf5b3cba$var$__spreadArray([
                                {
                                    label: "",
                                    url: "",
                                    divider: true
                                },
                                {
                                    label: this.texts.adminMenu,
                                    header: true
                                }
                            ], menuItems, true)
                        ];
                        return [
                            2 /*return*/ ,
                            menuItems
                        ];
                }
            });
        });
    };
    PlatformService.prototype.getUserMenuProps = function(userMenuProps, applicationSignOutUrl) {
        // NOTE: Any changes made here might also require corresponding updates in 'getNavbarUserMenuProps' to maintain consistency.
        var _this = this;
        var _a, _b, _c;
        var menuItems = [];
        var user;
        var token = this.validateAndGetToken();
        var accountURL = new URL("".concat(this.getFoundationUrl(), "/manage/profile"));
        if (this.activeClientId) accountURL.searchParams.set("ac", this.activeClientId);
        var accountManageUrl = accountURL.toString();
        if (token) {
            menuItems.push($81f5be1abf5b3cba$var$__assign($81f5be1abf5b3cba$var$__assign({}, this.enablePopups ? {
                onClick: function() {
                    return _this.redirectAfterPfmAuth(accountManageUrl, true);
                }
            } : {
                url: accountManageUrl
            }), {
                label: this.texts.manageAccount
            }));
            var jwtPayload = this.tokenPayload;
            user = {
                name: (jwtPayload === null || jwtPayload === void 0 ? void 0 : jwtPayload.getFirstName()) + " " + (jwtPayload === null || jwtPayload === void 0 ? void 0 : jwtPayload.getLastName()),
                email: (_a = jwtPayload === null || jwtPayload === void 0 ? void 0 : jwtPayload.getEmail()) !== null && _a !== void 0 ? _a : "",
                avatarURL: (_b = jwtPayload === null || jwtPayload === void 0 ? void 0 : jwtPayload.getPicture()) !== null && _b !== void 0 ? _b : ""
            };
        } else user = userMenuProps === null || userMenuProps === void 0 ? void 0 : userMenuProps.user;
        if (token || applicationSignOutUrl) {
            var menuItem = {
                label: this.texts.signOut
            };
            if (token) menuItem.onClick = function(ignore) {
                /* We MUST pass forceLogout as true here because we need to redirect to /logout to ensure that
                    a logout happens. */ _this.tryRelaunch(true);
            };
            else menuItem.url = applicationSignOutUrl;
            menuItems.push(menuItem);
        }
        ((_c = userMenuProps === null || userMenuProps === void 0 ? void 0 : userMenuProps.menuItems) !== null && _c !== void 0 ? _c : []).forEach(function(item) {
            menuItems.push(item);
        });
        var signOutElement = menuItems.find(function(element) {
            return element.label === "Sign Out";
        });
        if (signOutElement) {
            var signOutElementIndex = menuItems === null || menuItems === void 0 ? void 0 : menuItems.indexOf(signOutElement);
            if (signOutElementIndex !== menuItems.length - 1) {
                var divider = {
                    url: "",
                    label: "",
                    divider: true
                };
                menuItems.splice(signOutElementIndex + 1, 0, divider);
            }
        }
        return {
            menuItems: menuItems,
            user: user
        };
    };
    PlatformService.prototype.getNavbarUserMenuProps = function(userMenuProps, applicationSignOutUrl) {
        return $81f5be1abf5b3cba$var$__awaiter(this, void 0, void 0, function() {
            var menuItems, user, token, accountURL, accountManageUrl, jwtPayload, menuItem, adminMenuItems;
            var _this = this;
            var _a, _b, _c;
            return $81f5be1abf5b3cba$var$__generator(this, function(_d) {
                switch(_d.label){
                    case 0:
                        menuItems = [];
                        token = this.validateAndGetToken();
                        accountURL = new URL("".concat(this.getFoundationUrl(), "/manage/profile"));
                        if (this.activeClientId) accountURL.searchParams.set("ac", this.activeClientId);
                        accountManageUrl = accountURL.toString();
                        if (token) {
                            menuItems.push($81f5be1abf5b3cba$var$__assign($81f5be1abf5b3cba$var$__assign({}, this.enablePopups ? {
                                onClick: function() {
                                    return _this.redirectAfterPfmAuth(accountManageUrl, true);
                                }
                            } : {
                                url: accountManageUrl
                            }), {
                                label: this.texts.manageAccount
                            }));
                            if ($81f5be1abf5b3cba$var$isPlatformOrFoundationApp(this.appId)) menuItems.push({
                                onClick: function() {
                                    return _this.redirectAfterPfmAuth(_this.getEcommerceUrl() + "/billing", true);
                                },
                                label: this.texts.billing
                            });
                            jwtPayload = this.tokenPayload;
                            user = {
                                name: (jwtPayload === null || jwtPayload === void 0 ? void 0 : jwtPayload.getFirstName()) + " " + (jwtPayload === null || jwtPayload === void 0 ? void 0 : jwtPayload.getLastName()),
                                email: (_a = jwtPayload === null || jwtPayload === void 0 ? void 0 : jwtPayload.getEmail()) !== null && _a !== void 0 ? _a : "",
                                avatarURL: (_b = jwtPayload === null || jwtPayload === void 0 ? void 0 : jwtPayload.getPicture()) !== null && _b !== void 0 ? _b : ""
                            };
                        } else user = userMenuProps === null || userMenuProps === void 0 ? void 0 : userMenuProps.user;
                        if (token || applicationSignOutUrl) {
                            menuItem = {
                                label: this.texts.signOut
                            };
                            if (token) menuItem.onClick = function() {
                                /* We MUST pass forceLogout as true here because we need to redirect to /logout to ensure that
                                    a logout happens. */ _this.tryRelaunch(true);
                            };
                            else menuItem.url = applicationSignOutUrl;
                            menuItems.push(menuItem);
                        }
                        if (!$81f5be1abf5b3cba$var$isPlatformOrFoundationApp(this.appId)) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.getAdminMenuItems()
                        ];
                    case 1:
                        adminMenuItems = _d.sent();
                        menuItems.push.apply(menuItems, adminMenuItems);
                        _d.label = 2;
                    case 2:
                        if ((_c = userMenuProps === null || userMenuProps === void 0 ? void 0 : userMenuProps.menuItems) === null || _c === void 0 ? void 0 : _c.length) menuItems.push.apply(menuItems, $81f5be1abf5b3cba$var$__spreadArray([
                            {
                                url: "",
                                label: "",
                                divider: true
                            }
                        ], userMenuProps.menuItems || [], false));
                        return [
                            2 /*return*/ ,
                            {
                                menuItems: menuItems,
                                user: user
                            }
                        ];
                }
            });
        });
    };
    PlatformService.prototype.validateAndGetToken = function() {
        if (!this.token) {
            this.applyToken($81f5be1abf5b3cba$var$getStoredToken(this.lwDomain, this.appId));
            this.impersonationSessionMonitor.reconcile(this.tokenPayload);
            this.sessionMonitor.reconcile();
        }
        if (this.token && $81f5be1abf5b3cba$var$isTokenExpired(this.token) || !this.token && this.lwaOnly) {
            if (!$81f5be1abf5b3cba$var$isPlatformUiAppId(this.appId)) this.refreshToken();
            return undefined;
        }
        return this.token;
    };
    PlatformService.prototype.applyToken = function(token) {
        var _a;
        if (token === this.token) return;
        this.token = token;
        this.tokenPayload = $81f5be1abf5b3cba$var$Authentication_1.default.parseToken(token);
        (_a = this.onTokenChangeCallback) === null || _a === void 0 || _a.call(this, token);
    };
    PlatformService.prototype.setToken = function(token) {
        if (!$81f5be1abf5b3cba$var$isPlatformUiAppId(this.appId) && !token) throw new Error("Cannot set token to undefined.");
        $81f5be1abf5b3cba$var$storeAndVerifyToken(this.lwDomain, token, this.appId);
        this.applyToken(token);
        this.impersonationSessionMonitor.reconcile(this.tokenPayload);
        this.sessionMonitor.reconcile();
    };
    PlatformService.prototype.isValidClient = function(clientId) {
        var _a, _b, _c;
        if (!clientId) return false;
        if (!this.tokenPayload) this.tokenPayload = $81f5be1abf5b3cba$var$Authentication_1.default.parseToken(this.token);
        return ((_c = (_b = (_a = this.tokenPayload) === null || _a === void 0 ? void 0 : _a.getLwtClaim()) === null || _b === void 0 ? void 0 : _b.getClients()) === null || _c === void 0 ? void 0 : _c.some(function(c) {
            return c.getId() === clientId;
        })) === true;
    };
    PlatformService.prototype.getActiveClientId = function() {
        return $81f5be1abf5b3cba$var$__awaiter(this, void 0, void 0, function() {
            var useSessionStoredClientId, token, userId, lastActiveClientId, personalClientId;
            var _this = this;
            var _a, _b, _c, _d, _e, _f;
            return $81f5be1abf5b3cba$var$__generator(this, function(_g) {
                switch(_g.label){
                    case 0:
                        useSessionStoredClientId = !(0, $lsuk0.isLegacyConnection)(this.tokenPayload, this.appId);
                        // If the instance does not have it set, fetch from the session storage.
                        if (!this.isValidClient(this.activeClientId)) {
                            if (useSessionStoredClientId) this.activeClientId = (_a = sessionStorage.getItem($81f5be1abf5b3cba$var$ACTIVE_CLIENT_ID_KEY_NAME)) !== null && _a !== void 0 ? _a : undefined;
                            else {
                                sessionStorage.removeItem($81f5be1abf5b3cba$var$ACTIVE_CLIENT_ID_KEY_NAME);
                                this.activeClientId = undefined;
                            }
                        }
                        if (!!this.isValidClient(this.activeClientId)) return [
                            3 /*break*/ ,
                            2
                        ];
                        token = this.validateAndGetToken();
                        if (!token) return [
                            3 /*break*/ ,
                            2
                        ];
                        userId = (_c = (_b = this.tokenPayload) === null || _b === void 0 ? void 0 : _b.getLwtClaim()) === null || _c === void 0 ? void 0 : _c.getUserId();
                        return [
                            4 /*yield*/ ,
                            this.getJsonResponseFromFetch("".concat(this.getAuthenticationApiUrl(), "/v1/users/").concat(userId), token, this.appId, function() {
                                return _this.tryRelaunch();
                            }, {
                                id: userId
                            }, $81f5be1abf5b3cba$var$LWA_USER_CACHE_KEY_SUFFIX)
                        ];
                    case 1:
                        lastActiveClientId = _g.sent().lastActiveClientId;
                        if (this.isValidClient(lastActiveClientId)) {
                            if (useSessionStoredClientId) sessionStorage.setItem($81f5be1abf5b3cba$var$ACTIVE_CLIENT_ID_KEY_NAME, lastActiveClientId);
                            else sessionStorage.removeItem($81f5be1abf5b3cba$var$ACTIVE_CLIENT_ID_KEY_NAME);
                            this.activeClientId = lastActiveClientId;
                        }
                        _g.label = 2;
                    case 2:
                        if (!!this.isValidClient(this.activeClientId)) return [
                            3 /*break*/ ,
                            4
                        ];
                        personalClientId = (_f = (_e = (_d = this.tokenPayload) === null || _d === void 0 ? void 0 : _d.getLwtClaim()) === null || _e === void 0 ? void 0 : _e.getPersonalClient()) === null || _f === void 0 ? void 0 : _f.getId();
                        if (!personalClientId) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            this.setLastActiveClientId(personalClientId)
                        ];
                    case 3:
                        _g.sent();
                        if (useSessionStoredClientId) sessionStorage.setItem($81f5be1abf5b3cba$var$ACTIVE_CLIENT_ID_KEY_NAME, personalClientId);
                        else sessionStorage.removeItem($81f5be1abf5b3cba$var$ACTIVE_CLIENT_ID_KEY_NAME);
                        this.activeClientId = personalClientId;
                        _g.label = 4;
                    case 4:
                        return [
                            2 /*return*/ ,
                            this.activeClientId
                        ];
                }
            });
        });
    };
    PlatformService.prototype.setLastActiveClientId = function(clientId) {
        return $81f5be1abf5b3cba$var$__awaiter(this, void 0, void 0, function() {
            var token, userId;
            var _this = this;
            var _a, _b;
            return $81f5be1abf5b3cba$var$__generator(this, function(_c) {
                this.cachedLwaClientApps = undefined;
                token = this.validateAndGetToken();
                if (token) {
                    userId = (_b = (_a = this.tokenPayload) === null || _a === void 0 ? void 0 : _a.getLwtClaim()) === null || _b === void 0 ? void 0 : _b.getUserId();
                    return [
                        2 /*return*/ ,
                        fetch("".concat(this.getAuthenticationApiUrl(), "/v1/users/").concat(userId), {
                            method: "PATCH",
                            headers: {
                                Authorization: "Bearer ".concat(token),
                                "Content-Type": "application/json"
                            },
                            body: JSON.stringify({
                                lastActiveClientId: clientId
                            })
                        }).then(function(response) {
                            if (!response.ok) {
                                // 401 shouldn't really happen because validateAndGetToken() should already re-launch the app if the token is expired.
                                if (response.status === 401) {
                                    if (!$81f5be1abf5b3cba$var$isPlatformUiAppId(_this.appId)) _this.tryRelaunch();
                                    else window.location.reload();
                                } else if ($81f5be1abf5b3cba$var$isServerError(response.status)) console.log("Failed to save active client id to the server. Response status: (".concat(response.status, ")"));
                                else throw new Error("Invalid response from platform API (".concat(response.status, ")"));
                            }
                        })
                    ];
                }
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    PlatformService.prototype.refreshToken = function(options) {
        var _this = this;
        if (options === void 0) options = {};
        // Reuses one in-flight promise so concurrent callers share a single iframe instead of
        // each spawning their own — previously N callers during an expired token meant N
        // simultaneous silent-authenticate iframes.
        if (!this.refreshTokenPromise) this.refreshTokenPromise = this.performRefreshToken(options).finally(function() {
            _this.refreshTokenPromise = undefined;
        });
        return this.refreshTokenPromise;
    };
    PlatformService.prototype.performRefreshToken = function(_a) {
        var _this = this;
        var _b = _a.relaunchUponError, relaunchUponError = _b === void 0 ? true : _b, authorizationParams = _a.authorizationParams;
        if ((0, $lsuk0.isLegacyConnection)(this.tokenPayload, this.appId)) {
            this.tryRelaunch();
            return Promise.resolve(undefined);
        }
        var TIMEOUT_MILLIS = 20000;
        return new Promise(function(resolve, reject) {
            var iframe = document.createElement("iframe");
            iframe.style.display = "none";
            iframe.hidden = true;
            var authenticateUrl = "".concat(_this.getPlatformUrl(), "/silent-authenticate");
            if (authorizationParams && Object.keys(authorizationParams).length > 0) {
                var searchParams_1 = new URLSearchParams();
                Object.entries(authorizationParams).forEach(function(_a) {
                    var key = _a[0], value = _a[1];
                    if (value !== undefined && value !== null && value !== "") searchParams_1.append(key, value);
                });
                var queryString = searchParams_1.toString();
                if (queryString) authenticateUrl = "".concat(authenticateUrl, "?").concat(queryString);
            }
            iframe.src = authenticateUrl;
            document.body.appendChild(iframe);
            var timeout = setTimeout(function() {
                clearResources();
                if ((0, $lsuk0.isSignOutInProgress)()) resolve(undefined);
                else if (relaunchUponError) _this.tryRelaunch();
                else reject("Attempt to refresh token timed out.");
            }, TIMEOUT_MILLIS);
            var onMessage = function(event) {
                if (event.origin !== _this.getPlatformUrl()) return;
                var message = event.data;
                if (message.type !== "SILENT_REFRESH_TOKEN") return;
                clearResources();
                if ((0, $lsuk0.isSignOutInProgress)()) resolve(undefined);
                else if (message.success) {
                    _this.token = undefined;
                    _this.tokenPayload = undefined;
                    resolve(_this.validateAndGetToken());
                } else if (!message.success && message.reason === "no_session") _this.tryRelaunch();
                else if (relaunchUponError) _this.tryRelaunch();
                else reject(message.reason);
            };
            var clearResources = function() {
                document.body.removeChild(iframe);
                window.removeEventListener("message", onMessage);
                clearTimeout(timeout);
            };
            window.addEventListener("message", onMessage);
        });
    };
    /**
     * @deprecated since version 3.25.0
     *
     * This function is deprecated and will be removed at some point in the future. Use the {@link PlatformService#getProductApplicationName} function instead.
     */ PlatformService.prototype.getProductName = function() {
        return this.appName;
    };
    PlatformService.prototype.getProductApplicationName = function(platformClientId) {
        return $81f5be1abf5b3cba$var$__awaiter(this, void 0, void 0, function() {
            var _this = this;
            return $81f5be1abf5b3cba$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.cachedAppData) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.getAppData()
                        ];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!platformClientId) return [
                            2 /*return*/ ,
                            this.appName
                        ];
                        else return [
                            2 /*return*/ ,
                            this.getProductBranding(platformClientId).then(function(branding) {
                                var _a;
                                return (_a = branding === null || branding === void 0 ? void 0 : branding.applicationName) !== null && _a !== void 0 ? _a : _this.appName;
                            })
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    PlatformService.prototype.getProductBranding = function(platformClientId_1) {
        return $81f5be1abf5b3cba$var$__awaiter(this, arguments, void 0, function(platformClientId, useCache) {
            var client, productBranding, appName;
            var _a, _b;
            if (useCache === void 0) useCache = true;
            return $81f5be1abf5b3cba$var$__generator(this, function(_c) {
                switch(_c.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.getClientSummary(platformClientId, undefined, useCache)
                        ];
                    case 1:
                        client = _c.sent();
                        if (client === null || client === void 0 ? void 0 : client.branding) {
                            productBranding = {
                                id: client.id
                            };
                            if (client.branding.logoUrl) productBranding.clientLogoUrl = client.branding.logoUrl;
                            if (client.branding.applications) {
                                appName = (_b = client.branding.applications[(_a = this.appId) !== null && _a !== void 0 ? _a : ""]) === null || _b === void 0 ? void 0 : _b.name;
                                if (appName) productBranding.applicationName = appName;
                            }
                        }
                        return [
                            2 /*return*/ ,
                            productBranding && Object.keys(productBranding).length > 1 ? productBranding : undefined
                        ];
                }
            });
        });
    };
    PlatformService.prototype.validateSession = function(url, auth) {
        var _this = this;
        var INTERVAL_MILLIS = 1000;
        var TIMEOUT_MILLIS = 3600000;
        var width = 500;
        var height = 500;
        var left = window.screenX + (window.innerWidth - width) / 2;
        var top = window.screenY + (window.innerHeight - height) / 2;
        var authPopup;
        return new Promise(function(resolve, reject) {
            var iframe = document.createElement("iframe");
            iframe.onload = function() {
                authPopup = window.open(auth ? "".concat(_this.getPlatformUrl(), "/auth") : url, "auth0:authorize:popup", "left=".concat(left, ",top=").concat(top, ",width=").concat(width, ",height=").concat(height, ",resizable,scrollbars=yes,location=0"));
                if (!authPopup) {
                    var authMode = "password";
                    window.location.href = "".concat(url, "&authMode=").concat(authMode);
                }
            };
            var overlay = document.createElement("div");
            overlay.style.cssText = "position: fixed; top: 0; left: 0; width: 100vw; height: 100%; background: rgba(0, 0, 0, 0.1); display: flex; justify-content: center; align-items: center; z-index: 9999";
            document.body.appendChild(overlay);
            document.body.appendChild(iframe);
            var timeout = setTimeout(function() {
                clearResources();
                resolve(false);
            }, TIMEOUT_MILLIS);
            window.addEventListener("message", function(event) {
                if (event.origin === _this.getPlatformUrl()) {
                    if (event.data.type === "PFM_AUTH_COMPLETED" || event.data.type === "IDP_APPROVED") {
                        resolve(true);
                        clearResources();
                    }
                }
            });
            var checkPopup = setInterval(function() {
                try {
                    if (!authPopup || authPopup.closed) {
                        clearResources();
                        resolve(false);
                    }
                } catch (e) {
                    clearResources();
                    reject(e);
                }
            }, INTERVAL_MILLIS);
            function clearResources() {
                clearInterval(checkPopup);
                clearTimeout(timeout);
                document.body.removeChild(overlay);
                document.body.removeChild(iframe);
                authPopup === null || authPopup === void 0 || authPopup.close();
            }
        });
    };
    PlatformService.prototype.redirectAfterPfmAuth = function(url, auth, connection) {
        return $81f5be1abf5b3cba$var$__awaiter(this, void 0, void 0, function() {
            var token, allowed, clientIdToCheck, suspended, pfmAuth;
            var _a, _b, _c;
            return $81f5be1abf5b3cba$var$__generator(this, function(_d) {
                switch(_d.label){
                    case 0:
                        token = this.tryGetToken();
                        if (!token) {
                            window.location.href = url;
                            return [
                                2 /*return*/ 
                            ];
                        }
                        if (!connection) return [
                            3 /*break*/ ,
                            5
                        ];
                        return [
                            4 /*yield*/ ,
                            this.userCanAccess(connection)
                        ];
                    case 1:
                        allowed = _d.sent();
                        if (!!allowed) return [
                            3 /*break*/ ,
                            5
                        ];
                        if (!connection.platformClient) return [
                            3 /*break*/ ,
                            3
                        ];
                        clientIdToCheck = (_a = connection.clientId) !== null && _a !== void 0 ? _a : undefined;
                        return [
                            4 /*yield*/ ,
                            this.validateSuspendedProduct(connection.appId, clientIdToCheck)
                        ];
                    case 2:
                        suspended = _d.sent();
                        if (suspended && suspended.isSuspendedProduct) {
                            window.location.href = "".concat(this.getPlatformUrl(), "/product/locked?product=").concat(suspended.product);
                            return [
                                2 /*return*/ 
                            ];
                        }
                        _d.label = 3;
                    case 3:
                        if (this.lwaClientAppsEndpointDisabled) return [
                            2 /*return*/ ,
                            this.validateSession(url, auth).then(function(res) {
                                if (res) window.location.href = url;
                            })
                        ];
                        return [
                            4 /*yield*/ ,
                            this.handleHiddenLaunch(connection, url)
                        ];
                    case 4:
                        _d.sent();
                        return [
                            2 /*return*/ 
                        ];
                    case 5:
                        pfmAuth = (_c = (_b = this.tokenPayload) === null || _b === void 0 ? void 0 : _b.getLwtClaim()) === null || _c === void 0 ? void 0 : _c.getPfmAuth();
                        if (pfmAuth || !auth) {
                            window.location.href = url;
                            return [
                                2 /*return*/ 
                            ];
                        }
                        return [
                            2 /*return*/ ,
                            this.validateSession(url, auth).then(function(res) {
                                if (res) window.location.href = url;
                            })
                        ];
                }
            });
        });
    };
    PlatformService.prototype.handleHiddenLaunch = function(connection, fallbackUrl) {
        return $81f5be1abf5b3cba$var$__awaiter(this, void 0, void 0, function() {
            var response, originalClientId, allowedClient, redirectConnection, launchUrl;
            return $81f5be1abf5b3cba$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.getLwaClientApps(true)
                        ];
                    case 1:
                        response = _a.sent();
                        originalClientId = connection.clientId;
                        allowedClient = response.clients.find(function(c) {
                            return c.id !== originalClientId && c.applications.some(function(a) {
                                return a.id === connection.appId;
                            });
                        });
                        if (!allowedClient) {
                            window.location.href = fallbackUrl;
                            return [
                                2 /*return*/ 
                            ];
                        }
                        redirectConnection = $81f5be1abf5b3cba$var$__assign($81f5be1abf5b3cba$var$__assign({}, connection), {
                            clientId: allowedClient.id,
                            name: allowedClient.name
                        });
                        launchUrl = $81f5be1abf5b3cba$var$buildProductLaunchUrl(this.getPlatformUrl(), redirectConnection, this.appId === connection.appId && this.luParamSupplier ? this.luParamSupplier() : undefined, this.appId === connection.appId && this.useRedirectParam ? encodeURIComponent(this.includeOriginInRedirects ? window.location.href : window.location.pathname + window.location.search) : undefined);
                        if (this.enablePopups) window.location.href = launchUrl;
                        else window.open(launchUrl, "_self");
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    PlatformService.prototype.userCanAccess = function(connection) {
        return $81f5be1abf5b3cba$var$__awaiter(this, void 0, void 0, function() {
            var lwtClaim, canAccess, appData, clientIdToCheck_1, appData, tokenAllows, response, target, idPs;
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            return $81f5be1abf5b3cba$var$__generator(this, function(_k) {
                switch(_k.label){
                    case 0:
                        lwtClaim = (_a = $81f5be1abf5b3cba$var$Authentication_1.default.parseToken(this.validateAndGetToken())) === null || _a === void 0 ? void 0 : _a.getLwtClaim();
                        if ((lwtClaim === null || lwtClaim === void 0 ? void 0 : lwtClaim.getPfmAuth()) && (connection.pseudoPromotionalConnection || !connection.platformClient || this.lwaClientAppsEndpointDisabled)) return [
                            2 /*return*/ ,
                            true
                        ];
                        canAccess = false;
                        if (!connection.pseudoPromotionalConnection) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.getAppData()
                        ];
                    case 1:
                        appData = (_b = _k.sent()) === null || _b === void 0 ? void 0 : _b.find(function(appData) {
                            return appData.id === connection.appId;
                        });
                        canAccess = !!((_c = appData === null || appData === void 0 ? void 0 : appData.config.promotion) === null || _c === void 0 ? void 0 : _c.skipPfmAuth);
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 2:
                        if (!connection.platformClient) return [
                            3 /*break*/ ,
                            8
                        ];
                        clientIdToCheck_1 = (_d = connection.clientId) !== null && _d !== void 0 ? _d : undefined;
                        if (!!clientIdToCheck_1) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            this.getAppData()
                        ];
                    case 3:
                        appData = (_e = _k.sent()) === null || _e === void 0 ? void 0 : _e.find(function(appData) {
                            return appData.id === connection.appId;
                        });
                        if (((_f = appData === null || appData === void 0 ? void 0 : appData.config) === null || _f === void 0 ? void 0 : _f.collapseItems) || ((_g = appData === null || appData === void 0 ? void 0 : appData.config) === null || _g === void 0 ? void 0 : _g.hidden)) clientIdToCheck_1 = (_h = lwtClaim === null || lwtClaim === void 0 ? void 0 : lwtClaim.getPersonalClient()) === null || _h === void 0 ? void 0 : _h.getId();
                        _k.label = 4;
                    case 4:
                        tokenAllows = !!((_j = lwtClaim === null || lwtClaim === void 0 ? void 0 : lwtClaim.getClients()) === null || _j === void 0 ? void 0 : _j.some(function(c) {
                            var _a, _b;
                            return (!clientIdToCheck_1 || c.getId() === clientIdToCheck_1) && ((_b = (_a = c.getApplications()) === null || _a === void 0 ? void 0 : _a.getCodes()) === null || _b === void 0 ? void 0 : _b.some(function(code) {
                                return code === connection.appId;
                            }));
                        }));
                        if (!!tokenAllows) return [
                            3 /*break*/ ,
                            5
                        ];
                        canAccess = false;
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 5:
                        return [
                            4 /*yield*/ ,
                            this.tryGetLwaClientApps(true)
                        ];
                    case 6:
                        response = _k.sent();
                        if (!response) canAccess = true;
                        else if (clientIdToCheck_1) {
                            target = response.clients.find(function(c) {
                                return c.id === clientIdToCheck_1;
                            });
                            canAccess = !!(target === null || target === void 0 ? void 0 : target.applications.some(function(a) {
                                return a.id === connection.appId;
                            }));
                        } else canAccess = response.clients.some(function(c) {
                            return c.applications.some(function(a) {
                                return a.id === connection.appId;
                            });
                        });
                        _k.label = 7;
                    case 7:
                        return [
                            3 /*break*/ ,
                            10
                        ];
                    case 8:
                        if (!connection.identityProviderId) return [
                            3 /*break*/ ,
                            10
                        ];
                        return [
                            4 /*yield*/ ,
                            this.getAuthenticatedIdPs()
                        ];
                    case 9:
                        idPs = _k.sent();
                        canAccess = idPs.includes(connection.identityProviderId);
                        _k.label = 10;
                    case 10:
                        return [
                            2 /*return*/ ,
                            canAccess
                        ];
                }
            });
        });
    };
    PlatformService.prototype.canUserAccess = function(args) {
        return $81f5be1abf5b3cba$var$__awaiter(this, void 0, void 0, function() {
            return $81f5be1abf5b3cba$var$__generator(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.userCanAccess({
                        appId: args.appId,
                        platformClient: true,
                        clientId: args.clientId
                    })
                ];
            });
        });
    };
    PlatformService.prototype.validateSuspendedProduct = function(appId, activeClientId) {
        return $81f5be1abf5b3cba$var$__awaiter(this, void 0, void 0, function() {
            var isSuspendedProduct, appData, lwaClients, client, clientsWithCurrentProduct;
            var _a, _b, _c;
            return $81f5be1abf5b3cba$var$__generator(this, function(_d) {
                switch(_d.label){
                    case 0:
                        isSuspendedProduct = false;
                        return [
                            4 /*yield*/ ,
                            this.getAppData()
                        ];
                    case 1:
                        appData = (_a = _d.sent()) === null || _a === void 0 ? void 0 : _a.find(function(appData) {
                            return appData.id === appId;
                        });
                        return [
                            4 /*yield*/ ,
                            this === null || this === void 0 ? void 0 : this.getLwaClients()
                        ];
                    case 2:
                        lwaClients = _d.sent();
                        if (activeClientId) {
                            client = lwaClients === null || lwaClients === void 0 ? void 0 : lwaClients.find(function(client) {
                                return client.clientId === activeClientId;
                            });
                            isSuspendedProduct = !!((_b = client === null || client === void 0 ? void 0 : client.applications) === null || _b === void 0 ? void 0 : _b.some(function(app) {
                                return app.code === appData.id && app.statusCode === "S";
                            }));
                        }
                        if ((_c = appData === null || appData === void 0 ? void 0 : appData.config) === null || _c === void 0 ? void 0 : _c.collapseItems) {
                            clientsWithCurrentProduct = lwaClients === null || lwaClients === void 0 ? void 0 : lwaClients.filter(function(client) {
                                var _a;
                                return (_a = client.applications) === null || _a === void 0 ? void 0 : _a.some(function(app) {
                                    return app.code === (appData === null || appData === void 0 ? void 0 : appData.id);
                                });
                            });
                            isSuspendedProduct = !!(clientsWithCurrentProduct === null || clientsWithCurrentProduct === void 0 ? void 0 : clientsWithCurrentProduct.every(function(client) {
                                var _a;
                                return (_a = client.applications) === null || _a === void 0 ? void 0 : _a.some(function(app) {
                                    return app.code === (appData === null || appData === void 0 ? void 0 : appData.id) && app.statusCode === "S";
                                });
                            }));
                        }
                        return [
                            2 /*return*/ ,
                            {
                                isSuspendedProduct: isSuspendedProduct,
                                product: appData === null || appData === void 0 ? void 0 : appData.config.name
                            }
                        ];
                }
            });
        });
    };
    PlatformService.prototype.launchApp = function(connection) {
        this.launchAppAsync(connection);
    };
    PlatformService.prototype.launchAppAsync = function(connection) {
        return $81f5be1abf5b3cba$var$__awaiter(this, void 0, void 0, function() {
            var launchUrl, allowed;
            return $81f5be1abf5b3cba$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        launchUrl = $81f5be1abf5b3cba$var$buildProductLaunchUrl(this.getPlatformUrl(), connection, this.appId === connection.appId && this.luParamSupplier ? this.luParamSupplier() : undefined, this.appId === connection.appId && this.useRedirectParam ? encodeURIComponent(this.includeOriginInRedirects ? window.location.href : window.location.pathname + window.location.search) : undefined);
                        if (!!this.lwaClientAppsEndpointDisabled) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.userCanAccess(connection)
                        ];
                    case 1:
                        allowed = _a.sent();
                        if (!!allowed) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.handleHiddenLaunch(connection, launchUrl)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                    case 3:
                        if (!this.enablePopups) return [
                            3 /*break*/ ,
                            5
                        ];
                        return [
                            4 /*yield*/ ,
                            this.redirectAfterPfmAuth(launchUrl, false, connection)
                        ];
                    case 4:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            6
                        ];
                    case 5:
                        window.open(launchUrl, "_self");
                        _a.label = 6;
                    case 6:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    PlatformService.prototype.getLaunchAppProp = function(connection) {
        var _this = this;
        var launchUrl = $81f5be1abf5b3cba$var$buildProductLaunchUrl(this.getPlatformUrl(), connection, this.appId === connection.appId && this.luParamSupplier ? this.luParamSupplier() : undefined);
        if (this.enablePopups) return {
            onClick: function() {
                return $81f5be1abf5b3cba$var$__awaiter(_this, void 0, void 0, function() {
                    return $81f5be1abf5b3cba$var$__generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                return [
                                    4 /*yield*/ ,
                                    this.redirectAfterPfmAuth(launchUrl, false, connection)
                                ];
                            case 1:
                                return [
                                    2 /*return*/ ,
                                    _a.sent()
                                ];
                        }
                    });
                });
            }
        };
        else return {
            url: launchUrl
        };
    };
    PlatformService.prototype.tryGetToken = function() {
        if (!this.token) this.applyToken($81f5be1abf5b3cba$var$getStoredToken(this.lwDomain, this.appId));
        if (this.token && $81f5be1abf5b3cba$var$isTokenExpired(this.token)) return undefined;
        return this.token;
    };
    PlatformService.prototype.getSortedAppIds = function(appData, connections, promotionAppIds) {
        var connectedAppIds = connections.reduce(function(current, next) {
            if (!current.includes(next.appId)) current.push(next.appId);
            return current;
        }, []);
        // Add static promoted products if no connection exists
        promotionAppIds.forEach(function(id) {
            if (!connectedAppIds.includes(id)) connectedAppIds.push(id);
        });
        return connectedAppIds.sort(function(a, b) {
            var _a, _b;
            var nameA = ((_a = appData.find(function(app) {
                return app.id === a;
            })) === null || _a === void 0 ? void 0 : _a.config.name.toLowerCase()) || "";
            var nameB = ((_b = appData.find(function(app) {
                return app.id === b;
            })) === null || _b === void 0 ? void 0 : _b.config.name.toLowerCase()) || "";
            return nameA.localeCompare(nameB);
        });
    };
    PlatformService.prototype.prepareConnectionData = function(getConnections, getAppData, useCache) {
        return $81f5be1abf5b3cba$var$__awaiter(this, void 0, void 0, function() {
            var connections, appData, promotionAppIds, productAppIds, filteredConnections, sortedAppIds;
            return $81f5be1abf5b3cba$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            getConnections(useCache)
                        ];
                    case 1:
                        connections = _a.sent();
                        return [
                            4 /*yield*/ ,
                            getAppData()
                        ];
                    case 2:
                        appData = _a.sent();
                        promotionAppIds = appData.filter(function(app) {
                            return app.config.promotion;
                        }).map(function(app) {
                            return app.id;
                        });
                        productAppIds = appData.map(function(app) {
                            return app.id;
                        });
                        filteredConnections = connections.filter(function(conn) {
                            return productAppIds.includes(conn.appId);
                        });
                        sortedAppIds = this.getSortedAppIds(appData, filteredConnections, promotionAppIds);
                        return [
                            2 /*return*/ ,
                            {
                                appData: appData,
                                filteredConnections: filteredConnections,
                                promotionAppIds: promotionAppIds,
                                sortedAppIds: sortedAppIds
                            }
                        ];
                }
            });
        });
    };
    PlatformService.prototype.getGroupedAppConnections = function(useCache) {
        return $81f5be1abf5b3cba$var$__awaiter(this, void 0, void 0, function() {
            var _a, promotionAppIds, filteredConnections, sortedAppIds, mappedAppConnections, _loop_8, _i, sortedAppIds_1, appId;
            return $81f5be1abf5b3cba$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.prepareConnectionData(this.getConnections.bind(this), this.getAppData.bind(this), useCache)
                        ];
                    case 1:
                        _a = _b.sent(), promotionAppIds = _a.promotionAppIds, filteredConnections = _a.filteredConnections, sortedAppIds = _a.sortedAppIds;
                        mappedAppConnections = [];
                        _loop_8 = function(appId) {
                            var group = filteredConnections.filter(function(conn) {
                                return conn.appId === appId;
                            });
                            group.sort(function(a, b) {
                                var _a;
                                return ((_a = a.name) === null || _a === void 0 ? void 0 : _a.localeCompare(b.name || "")) || 0;
                            });
                            if (group.length) mappedAppConnections.push(group);
                            else if (promotionAppIds.includes(appId)) mappedAppConnections.push([
                                {
                                    appId: appId,
                                    name: "",
                                    pseudoPromotionalConnection: true
                                }
                            ]);
                        };
                        for(_i = 0, sortedAppIds_1 = sortedAppIds; _i < sortedAppIds_1.length; _i++){
                            appId = sortedAppIds_1[_i];
                            _loop_8(appId);
                        }
                        return [
                            2 /*return*/ ,
                            mappedAppConnections
                        ];
                }
            });
        });
    };
    PlatformService.prototype.getConnectionTiles = function(useCache, activeClientId) {
        return $81f5be1abf5b3cba$var$__awaiter(this, void 0, void 0, function() {
            var _a, appData, promotionAppIds, filteredConnections, sortedAppIds, mappedAppConnections, _loop_9, this_3, _i, sortedAppIds_2, appId;
            var _this = this;
            var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            return $81f5be1abf5b3cba$var$__generator(this, function(_o) {
                switch(_o.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.prepareConnectionData(this.getConnections.bind(this), this.getAppData.bind(this), useCache)
                        ];
                    case 1:
                        _a = _o.sent(), appData = _a.appData, promotionAppIds = _a.promotionAppIds, filteredConnections = _a.filteredConnections, sortedAppIds = _a.sortedAppIds;
                        mappedAppConnections = [];
                        _loop_9 = function(appId) {
                            var app = appData.find(function(a) {
                                return a.id === appId;
                            });
                            var brandingConnections = [];
                            var unbrandedConnections = [];
                            if (app === null || app === void 0 ? void 0 : app.config.hidden) return "continue";
                            var group = filteredConnections.filter(function(conn) {
                                return conn.appId === appId;
                            });
                            var unbrandedOptions = [];
                            var baseTileData = {
                                appId: appId,
                                appName: (_b = app === null || app === void 0 ? void 0 : app.config.name) !== null && _b !== void 0 ? _b : "",
                                description: (_c = app === null || app === void 0 ? void 0 : app.config.description) !== null && _c !== void 0 ? _c : "",
                                icon: app === null || app === void 0 ? void 0 : app.config.icon
                            };
                            var _loop_10 = function(conn) {
                                // If an activeClientId is specified, exclude all client-specific apps for other clients.
                                if (activeClientId && conn.platformClient && !!conn.clientId && conn.clientId !== activeClientId) return "continue";
                                var launchUrl = $81f5be1abf5b3cba$var$buildProductLaunchUrl(this_3.getPlatformUrl(), conn, this_3.appId === conn.appId && this_3.luParamSupplier ? this_3.luParamSupplier() : undefined);
                                var tile = $81f5be1abf5b3cba$var$__assign({
                                    appId: conn.appId,
                                    appName: (_f = (_e = (_d = conn.branding) === null || _d === void 0 ? void 0 : _d.appName) !== null && _e !== void 0 ? _e : app === null || app === void 0 ? void 0 : app.config.name) !== null && _f !== void 0 ? _f : "",
                                    description: (_g = app === null || app === void 0 ? void 0 : app.config.description) !== null && _g !== void 0 ? _g : ""
                                }, ((_h = conn.branding) === null || _h === void 0 ? void 0 : _h.logoUrl) ? {
                                    logoUrl: conn.branding.logoUrl
                                } : {
                                    icon: app === null || app === void 0 ? void 0 : app.config.icon
                                });
                                var option = {
                                    name: conn.name,
                                    onClick: function() {
                                        return _this.redirectAfterPfmAuth(launchUrl, false, conn);
                                    }
                                };
                                if (((_j = conn.branding) === null || _j === void 0 ? void 0 : _j.appName) || ((_k = conn.branding) === null || _k === void 0 ? void 0 : _k.logoUrl)) brandingConnections.push($81f5be1abf5b3cba$var$__assign($81f5be1abf5b3cba$var$__assign({}, tile), {
                                    options: [
                                        option
                                    ]
                                }));
                                else {
                                    unbrandedOptions.push(option);
                                    baseTileData = $81f5be1abf5b3cba$var$__assign({}, tile);
                                }
                            };
                            for(var _p = 0, group_1 = group; _p < group_1.length; _p++){
                                var conn = group_1[_p];
                                _loop_10(conn);
                            }
                            if (unbrandedOptions.length) unbrandedConnections.push($81f5be1abf5b3cba$var$__assign($81f5be1abf5b3cba$var$__assign({}, baseTileData), {
                                options: unbrandedOptions.sort(function(a, b) {
                                    return 0 - ((a === null || a === void 0 ? void 0 : a.name) && (b === null || b === void 0 ? void 0 : b.name) && (a === null || a === void 0 ? void 0 : a.name.toLowerCase()) > (b === null || b === void 0 ? void 0 : b.name.toLowerCase()) ? -1 : 1);
                                })
                            }));
                            if (unbrandedConnections.length) mappedAppConnections.push(unbrandedConnections);
                            if (brandingConnections.length) mappedAppConnections.push(brandingConnections);
                            if (!group.length && promotionAppIds.includes(appId)) {
                                var conn_1 = {
                                    appId: appId,
                                    name: "",
                                    pseudoPromotionalConnection: true
                                };
                                var launchUrl_1 = $81f5be1abf5b3cba$var$buildProductLaunchUrl(this_3.getPlatformUrl(), conn_1, this_3.appId === conn_1.appId && this_3.luParamSupplier ? this_3.luParamSupplier() : undefined);
                                mappedAppConnections.push([
                                    {
                                        appId: appId,
                                        appName: (_l = app === null || app === void 0 ? void 0 : app.config.name) !== null && _l !== void 0 ? _l : "",
                                        description: (_m = app === null || app === void 0 ? void 0 : app.config.description) !== null && _m !== void 0 ? _m : "",
                                        icon: app === null || app === void 0 ? void 0 : app.config.icon,
                                        options: [
                                            {
                                                name: conn_1.name,
                                                onClick: function() {
                                                    return _this.redirectAfterPfmAuth(launchUrl_1, false, conn_1);
                                                }
                                            }
                                        ]
                                    }
                                ]);
                            }
                        };
                        this_3 = this;
                        for(_i = 0, sortedAppIds_2 = sortedAppIds; _i < sortedAppIds_2.length; _i++){
                            appId = sortedAppIds_2[_i];
                            _loop_9(appId);
                        }
                        return [
                            2 /*return*/ ,
                            mappedAppConnections.flat()
                        ];
                }
            });
        });
    };
    Object.defineProperty(PlatformService.prototype, "texts", {
        get: function() {
            var _a, _b;
            var lng = ((_b = (_a = $81f5be1abf5b3cba$var$Authentication_1.default.parseToken(this.token)) === null || _a === void 0 ? void 0 : _a.getLwtClaim()) === null || _b === void 0 ? void 0 : _b.getLanguageCode()) || "en-US";
            return $bMEyZ.strings.getStrings(lng);
        },
        enumerable: false,
        configurable: true
    });
    PlatformService.prototype.initLogRocket = function(config) {
        var _a, _b, _c, _d, _e, _f, _g;
        if (!config || this.logRocketInitialized) return;
        var enabled = (_a = config.enabled) !== null && _a !== void 0 ? _a : true;
        if (!enabled) return;
        var suppressInternalUsers = (_b = config.suppressInternalUsers) !== null && _b !== void 0 ? _b : true;
        if (suppressInternalUsers && ((_c = this.tokenPayload) === null || _c === void 0 ? void 0 : _c.getEmail()) && (0, $lsuk0.isInternalUser)(this.tokenPayload.getEmail())) return;
        var appId = $g15fX.LOG_ROCKET_APP_IDS[(0, $lsuk0.getEnvironment)(this.lwDomain)];
        $81f5be1abf5b3cba$var$logrocket_1.default.init(appId, {
            rootHostname: ".lwolf.com",
            release: config.release
        });
        this.baseLogRocketTraits = $81f5be1abf5b3cba$var$__assign({
            name: (_d = this.tokenPayload) === null || _d === void 0 ? void 0 : _d.getName(),
            email: (_e = this.tokenPayload) === null || _e === void 0 ? void 0 : _e.getEmail()
        }, config.traits);
        $81f5be1abf5b3cba$var$logrocket_1.default.identify((_g = (_f = this.tokenPayload) === null || _f === void 0 ? void 0 : _f.getLwtClaim()) === null || _g === void 0 ? void 0 : _g.getUserId(), this.baseLogRocketTraits);
        this.logRocketInitialized = true;
    };
    PlatformService.prototype.identifyLogRocket = function(traits) {
        var _a;
        if (!this.logRocketInitialized) return;
        if (!this.tokenPayload) return;
        this.baseLogRocketTraits = $81f5be1abf5b3cba$var$__assign($81f5be1abf5b3cba$var$__assign({}, this.baseLogRocketTraits), traits);
        $81f5be1abf5b3cba$var$logrocket_1.default.identify((_a = this.tokenPayload.getLwtClaim()) === null || _a === void 0 ? void 0 : _a.getUserId(), this.baseLogRocketTraits);
    };
    PlatformService.prototype.getLogRocketSessionUrl = function(callback) {
        if (!this.logRocketInitialized) {
            callback === null || callback === void 0 || callback(undefined);
            return Promise.resolve(undefined);
        }
        return new Promise(function(resolve) {
            $81f5be1abf5b3cba$var$logrocket_1.default.getSessionURL(function(sessionURL) {
                callback === null || callback === void 0 || callback(sessionURL);
                resolve(sessionURL);
            });
        });
    };
    return PlatformService;
}();
module.exports.default = $81f5be1abf5b3cba$var$PlatformService;

});
parcelRegister("2EHer", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6ZWSX = parcelRequire("6ZWSX");

var $bQyVR = parcelRequire("bQyVR");
var $1ef0da2d46ad0b89$var$Authentication = /** @class */ function() {
    function Authentication() {
        this.parseToken = function(token) {
            var _a, _b;
            var jwtPayload;
            var base64 = (_b = (_a = token === null || token === void 0 ? void 0 : token.split(".")[1]) === null || _a === void 0 ? void 0 : _a.replace(/-/g, "+")) === null || _b === void 0 ? void 0 : _b.replace(/_/g, "/");
            if (base64) {
                var parsedClaims = JSON.parse($6ZWSX.Buffer.from(base64, "base64").toString());
                jwtPayload = new $bQyVR.JwtPayload();
                jwtPayload.populate(parsedClaims);
            }
            return jwtPayload;
        };
    }
    return Authentication;
}();
module.exports.default = new $1ef0da2d46ad0b89$var$Authentication();

});
parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a, (v) => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $51861dfc7ca9d588$export$599f31c3813fae4d, (v) => $51861dfc7ca9d588$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$51861dfc7ca9d588$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("bQyVR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.JwtPayload = void 0;

var $b2waw = parcelRequire("b2waw");
var $89ffa5d7374221f9$var$JwtPayload = /** @class */ function() {
    function JwtPayload() {}
    JwtPayload.prototype.populate = function(parsedClaims) {
        if (parsedClaims["http://lwt"]) {
            this.lwt = new $b2waw.LwtClaim();
            this.lwt.populate(parsedClaims["http://lwt"]);
            delete parsedClaims["http://lwt"];
        }
        Object.assign(this, parsedClaims);
    };
    JwtPayload.prototype.getIssuer = function() {
        return this.iss;
    };
    JwtPayload.prototype.getSubject = function() {
        return this.sub;
    };
    JwtPayload.prototype.getAudience = function() {
        return this.aud;
    };
    JwtPayload.prototype.getFirstName = function() {
        return this.given_name;
    };
    JwtPayload.prototype.getLastName = function() {
        return this.family_name;
    };
    JwtPayload.prototype.getNickname = function() {
        return this.nickname;
    };
    JwtPayload.prototype.getName = function() {
        return this.name;
    };
    JwtPayload.prototype.getEmail = function() {
        return this.email;
    };
    JwtPayload.prototype.getIssuedAtTime = function() {
        return this.iat;
    };
    JwtPayload.prototype.getExpirationTime = function() {
        return this.exp;
    };
    JwtPayload.prototype.getPicture = function() {
        return this.picture;
    };
    JwtPayload.prototype.getLwtClaim = function() {
        return this.lwt;
    };
    JwtPayload.prototype.getEmailVerified = function() {
        return this.email_verified;
    };
    JwtPayload.prototype.getZoneInfo = function() {
        return this.zoneinfo;
    };
    JwtPayload.prototype.isImpersonationToken = function() {
        var _a;
        var actClaim = (_a = this.lwt) === null || _a === void 0 ? void 0 : _a.getActClaim();
        return !!actClaim && !!actClaim.getUserId();
    };
    return JwtPayload;
}();
module.exports.JwtPayload = $89ffa5d7374221f9$var$JwtPayload;

});
parcelRegister("b2waw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LwtClaim = void 0;

var $i061l = parcelRequire("i061l");

var $a9Xrj = parcelRequire("a9Xrj");

var $k0ap7 = parcelRequire("k0ap7");

var $13gD4 = parcelRequire("13gD4");
var $8098d5aadf5741b5$var$LwtUserType;
(function(LwtUserType) {
    LwtUserType["INTERNAL"] = "I";
    LwtUserType["CLIENT"] = "C";
    LwtUserType["APP"] = "A";
    LwtUserType["SERVICE"] = "S";
})($8098d5aadf5741b5$var$LwtUserType || ($8098d5aadf5741b5$var$LwtUserType = {}));
var $8098d5aadf5741b5$var$LwtClaim = /** @class */ function() {
    function LwtClaim() {
        this.utp = $8098d5aadf5741b5$var$LwtUserType.CLIENT;
        this.pfmAuth = false;
        this.lng = "en-US";
    }
    LwtClaim.prototype.populate = function(lwtClaimObject) {
        var _this = this;
        if (lwtClaimObject.pfm) {
            this.pfm = [];
            lwtClaimObject.pfm.forEach(function(pfmClient) {
                var _a;
                var platformClient = new $k0ap7.ClientClaim();
                platformClient.populate(pfmClient);
                (_a = _this.pfm) === null || _a === void 0 || _a.push(platformClient);
            });
            delete lwtClaimObject.pfm;
        }
        if (lwtClaimObject.apps) {
            this.apps = new $i061l.AppsClaim();
            this.apps.populate(lwtClaimObject.apps);
            delete lwtClaimObject.apps;
        }
        if (lwtClaimObject.idps) {
            this.idps = new $a9Xrj.IdentityProvidersClaim();
            this.idps.populate(lwtClaimObject.idps);
            delete lwtClaimObject.idps;
        }
        if (lwtClaimObject.act) {
            this.act = new $13gD4.ActClaim();
            this.act.populate(lwtClaimObject.act);
            delete lwtClaimObject.act;
        }
        Object.assign(this, lwtClaimObject);
    };
    LwtClaim.prototype.isInternalToken = function() {
        return this.utp === $8098d5aadf5741b5$var$LwtUserType.INTERNAL;
    };
    LwtClaim.prototype.isClientToken = function() {
        return this.utp === $8098d5aadf5741b5$var$LwtUserType.CLIENT;
    };
    LwtClaim.prototype.isAppToken = function() {
        return this.utp === $8098d5aadf5741b5$var$LwtUserType.APP;
    };
    LwtClaim.prototype.isServiceToken = function() {
        return this.utp === $8098d5aadf5741b5$var$LwtUserType.SERVICE;
    };
    LwtClaim.prototype.getUserId = function() {
        return this.uid;
    };
    LwtClaim.prototype.getUserType = function() {
        return this.utp;
    };
    LwtClaim.prototype.getSessionId = function() {
        return this.sid;
    };
    LwtClaim.prototype.getGroups = function() {
        return this.groups;
    };
    LwtClaim.prototype.getClients = function() {
        return this.pfm;
    };
    LwtClaim.prototype.getAppsClaim = function() {
        return this.apps;
    };
    LwtClaim.prototype.getIdentityProvidersClaim = function() {
        return this.idps;
    };
    LwtClaim.prototype.getActClaim = function() {
        return this.act;
    };
    LwtClaim.prototype.getPersonalClient = function() {
        var _a;
        return (_a = this.pfm) === null || _a === void 0 ? void 0 : _a.find(function(client) {
            return client.getType() === "User";
        });
    };
    LwtClaim.prototype.getPfmAuth = function() {
        return this.pfmAuth;
    };
    LwtClaim.prototype.getLanguageCode = function() {
        return this.lng;
    };
    return LwtClaim;
}();
module.exports.LwtClaim = $8098d5aadf5741b5$var$LwtClaim;

});
parcelRegister("i061l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AppsClaim = void 0;

var $eEFoU = parcelRequire("eEFoU");

var $7QcaV = parcelRequire("7QcaV");

var $gAWQb = parcelRequire("gAWQb");

var $9yXdW = parcelRequire("9yXdW");

var $jNzQ2 = parcelRequire("jNzQ2");

var $iQ2a3 = parcelRequire("iQ2a3");

var $aWT3t = parcelRequire("aWT3t");

var $66w9Y = parcelRequire("66w9Y");

var $75uwV = parcelRequire("75uwV");

var $3a5dA = parcelRequire("3a5dA");

var $8Exen = parcelRequire("8Exen");

var $fcYA3 = parcelRequire("fcYA3");

var $2ZcIZ = parcelRequire("2ZcIZ");

var $7K2a0 = parcelRequire("7K2a0");

var $kP6YC = parcelRequire("kP6YC");

var $b8K1v = parcelRequire("b8K1v");

var $bUyW4 = parcelRequire("bUyW4");

var $6WMHE = parcelRequire("6WMHE");

var $28k3r = parcelRequire("28k3r");

var $9X2d4 = parcelRequire("9X2d4");

var $tnprI = parcelRequire("tnprI");

var $cI5s5 = parcelRequire("cI5s5");

var $3w5ek = parcelRequire("3w5ek");

var $9S5AF = parcelRequire("9S5AF");

var $4gO8M = parcelRequire("4gO8M");
var $d1ace5a87a0906a0$var$AppsClaim = /** @class */ function() {
    function AppsClaim() {}
    AppsClaim.prototype.populate = function(appsClaimObject) {
        this.as = this.createApplicationClaim($28k3r.AuthentisignClaim, appsClaimObject, "as");
        this.bo = this.createApplicationClaim($eEFoU.BackOfficeClaim, appsClaimObject, "bo");
        this.bov = this.createApplicationClaim($9X2d4.BackOfficeV4Claim, appsClaimObject, "bov");
        this.cas = this.createApplicationClaim($7QcaV.CloudAgentSuiteClaim, appsClaimObject, "cas");
        this.ca = this.createApplicationClaim($tnprI.CloudAttractClaim, appsClaimObject, "ca");
        this.cc = this.createApplicationClaim($cI5s5.CloudCMAClaim, appsClaimObject, "cc");
        this.cm = this.createApplicationClaim($3w5ek.CloudMLXClaim, appsClaimObject, "cm");
        this.cs = this.createApplicationClaim($9S5AF.CloudStreamsClaim, appsClaimObject, "cs");
        this.hsb = this.createApplicationClaim($gAWQb.HomeSpotterBoostClaim, appsClaimObject, "hsb");
        this.hsc = this.createApplicationClaim($9yXdW.HomeSpotterConnectClaim, appsClaimObject, "hsc");
        this.hss = this.createApplicationClaim($jNzQ2.HomeSpotterSpacioClaim, appsClaimObject, "hss");
        this.ld = this.createApplicationClaim($iQ2a3.LionDeskClaim, appsClaimObject, "ld");
        this.pbb = this.createApplicationClaim($aWT3t.PropertybaseBackOfficeClaim, appsClaimObject, "pbb");
        this.pbl = this.createApplicationClaim($66w9Y.PropertybaseBoldLeadsClaim, appsClaimObject, "pbl");
        this.pbg = this.createApplicationClaim($75uwV.PropertybaseGoClaim, appsClaimObject, "pbg");
        this.sf = this.createApplicationClaim($3a5dA.SalesforceClaim, appsClaimObject, "sf");
        this.tra = this.createApplicationClaim($fcYA3.TerradatumAergoClaim, appsClaimObject, "tra");
        this.trr = this.createApplicationClaim($2ZcIZ.TerradatumAgentMetricsClaim, appsClaimObject, "trr");
        this.trl = this.createApplicationClaim($kP6YC.TerradatumListingHomeRunClaim, appsClaimObject, "trl");
        this.td = this.createApplicationClaim($8Exen.TransactionDeskClaim, appsClaimObject, "td");
        this.tw = this.createApplicationClaim($4gO8M.TransactWorkflowClaim, appsClaimObject, "tw");
        this.trv = this.createApplicationClaim($b8K1v.TerradatumVScreenClaim, appsClaimObject, "trv");
        this.wc = this.createApplicationClaim($bUyW4.WolfConnectClaim, appsClaimObject, "wc");
        this.xbm = this.createApplicationClaim($7K2a0.XBrokerMetricsClaim, appsClaimObject, "xbm");
        this.zfp = this.createApplicationClaim($6WMHE.ZipFormPlusClaim, appsClaimObject, "zfp");
    };
    AppsClaim.prototype.createApplicationClaim = function(claimType, appsClaimObject, claimPropertyName) {
        var claimObject;
        if (appsClaimObject[claimPropertyName]) {
            claimObject = new claimType();
            Object.assign(claimObject, appsClaimObject[claimPropertyName]);
        }
        return claimObject;
    };
    AppsClaim.prototype.getAuthentisignClaim = function() {
        return this.as;
    };
    AppsClaim.prototype.getBackOfficeClaim = function() {
        return this.bo;
    };
    AppsClaim.prototype.getBackOfficeV4Claim = function() {
        return this.bov;
    };
    AppsClaim.prototype.getCloudAgentSuiteClaim = function() {
        return this.cas;
    };
    AppsClaim.prototype.getCloudAttractClaim = function() {
        return this.ca;
    };
    AppsClaim.prototype.getCloudCMAClaim = function() {
        return this.cc;
    };
    AppsClaim.prototype.getCloudMLXClaim = function() {
        return this.cm;
    };
    AppsClaim.prototype.getCloudStreamsClaim = function() {
        return this.cs;
    };
    AppsClaim.prototype.getHomeSpotterBoostClaim = function() {
        return this.hsb;
    };
    AppsClaim.prototype.getHomeSpotterConnectClaim = function() {
        return this.hsc;
    };
    AppsClaim.prototype.getHomeSpotterSpacioClaim = function() {
        return this.hss;
    };
    AppsClaim.prototype.getLionDeskClaim = function() {
        return this.ld;
    };
    AppsClaim.prototype.getPropertybaseBackOfficeClaim = function() {
        return this.pbb;
    };
    AppsClaim.prototype.getPropertybaseBoldLeadsClaim = function() {
        return this.pbl;
    };
    AppsClaim.prototype.getPropertybaseGoClaim = function() {
        return this.pbg;
    };
    AppsClaim.prototype.getSalesforceClaim = function() {
        return this.sf;
    };
    AppsClaim.prototype.getTerradatumAergoClaim = function() {
        return this.tra;
    };
    AppsClaim.prototype.getTerradatumAgentMetricsClaim = function() {
        return this.trr;
    };
    AppsClaim.prototype.getTerradatumListingHomeRunClaim = function() {
        return this.trl;
    };
    AppsClaim.prototype.getTerradatumVScreenClaim = function() {
        return this.trv;
    };
    AppsClaim.prototype.getTransactionDeskClaim = function() {
        return this.td;
    };
    AppsClaim.prototype.getTransactWorkflowClaim = function() {
        return this.tw;
    };
    AppsClaim.prototype.getWolfConnectClaim = function() {
        return this.wc;
    };
    AppsClaim.prototype.getXBrokerMetricsClaim = function() {
        return this.xbm;
    };
    AppsClaim.prototype.getZipFormPlusClaim = function() {
        return this.zfp;
    };
    return AppsClaim;
}();
module.exports.AppsClaim = $d1ace5a87a0906a0$var$AppsClaim;

});
parcelRegister("eEFoU", function(module, exports) {
"use strict";
var $aab4ea6d96b8ab1c$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BackOfficeClaim = void 0;

var $1sPdh = parcelRequire("1sPdh");
var $aab4ea6d96b8ab1c$var$BackOfficeClaim = /** @class */ function(_super) {
    $aab4ea6d96b8ab1c$var$__extends(BackOfficeClaim, _super);
    function BackOfficeClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BackOfficeClaim.prototype.getMemberId = function() {
        return this.mid;
    };
    BackOfficeClaim.prototype.getOfficeId = function() {
        return this.oid;
    };
    return BackOfficeClaim;
}($1sPdh.ClaimWithClientId);
module.exports.BackOfficeClaim = $aab4ea6d96b8ab1c$var$BackOfficeClaim;

});
parcelRegister("1sPdh", function(module, exports) {
"use strict";
var $111021db79a41440$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ClaimWithClientId = void 0;

var $9190n = parcelRequire("9190n");
var $111021db79a41440$var$ClaimWithClientId = /** @class */ function(_super) {
    $111021db79a41440$var$__extends(ClaimWithClientId, _super);
    function ClaimWithClientId() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClaimWithClientId.prototype.getClientId = function() {
        return this.cid;
    };
    return ClaimWithClientId;
}($9190n.ClaimBase);
module.exports.ClaimWithClientId = $111021db79a41440$var$ClaimWithClientId;

});
parcelRegister("9190n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ClaimBase = void 0;
var $690b314a702bb518$var$ClaimBase = /** @class */ function() {
    function ClaimBase() {}
    return ClaimBase;
}();
module.exports.ClaimBase = $690b314a702bb518$var$ClaimBase;

});



parcelRegister("7QcaV", function(module, exports) {
"use strict";
var $5b56d5743849a594$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CloudAgentSuiteClaim = void 0;

var $jUIFx = parcelRequire("jUIFx");
var $5b56d5743849a594$var$CloudAgentSuiteClaim = /** @class */ function(_super) {
    $5b56d5743849a594$var$__extends(CloudAgentSuiteClaim, _super);
    function CloudAgentSuiteClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CloudAgentSuiteClaim;
}($jUIFx.ClaimWithIntegerUserId);
module.exports.CloudAgentSuiteClaim = $5b56d5743849a594$var$CloudAgentSuiteClaim;

});
parcelRegister("jUIFx", function(module, exports) {
"use strict";
var $e7f5e59755f1a785$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ClaimWithIntegerUserId = void 0;

var $9190n = parcelRequire("9190n");
var $e7f5e59755f1a785$var$ClaimWithIntegerUserId = /** @class */ function(_super) {
    $e7f5e59755f1a785$var$__extends(ClaimWithIntegerUserId, _super);
    function ClaimWithIntegerUserId() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ClaimWithIntegerUserId.prototype, "userId", {
        get: function() {
            return this.uid;
        },
        enumerable: false,
        configurable: true
    });
    return ClaimWithIntegerUserId;
}($9190n.ClaimBase);
module.exports.ClaimWithIntegerUserId = $e7f5e59755f1a785$var$ClaimWithIntegerUserId;

});


parcelRegister("gAWQb", function(module, exports) {
"use strict";
var $c14da6a440f5c41e$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HomeSpotterBoostClaim = void 0;

var $jUIFx = parcelRequire("jUIFx");
var $c14da6a440f5c41e$var$HomeSpotterBoostClaim = /** @class */ function(_super) {
    $c14da6a440f5c41e$var$__extends(HomeSpotterBoostClaim, _super);
    function HomeSpotterBoostClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return HomeSpotterBoostClaim;
}($jUIFx.ClaimWithIntegerUserId);
module.exports.HomeSpotterBoostClaim = $c14da6a440f5c41e$var$HomeSpotterBoostClaim;

});

parcelRegister("9yXdW", function(module, exports) {
"use strict";
var $6f653aaced570983$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HomeSpotterConnectClaim = void 0;

var $jUIFx = parcelRequire("jUIFx");
var $6f653aaced570983$var$HomeSpotterConnectClaim = /** @class */ function(_super) {
    $6f653aaced570983$var$__extends(HomeSpotterConnectClaim, _super);
    function HomeSpotterConnectClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return HomeSpotterConnectClaim;
}($jUIFx.ClaimWithIntegerUserId);
module.exports.HomeSpotterConnectClaim = $6f653aaced570983$var$HomeSpotterConnectClaim;

});

parcelRegister("jNzQ2", function(module, exports) {
"use strict";
var $e69e64a8cd8cdf89$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HomeSpotterSpacioClaim = void 0;

var $aqYRc = parcelRequire("aqYRc");
var $e69e64a8cd8cdf89$var$HomeSpotterSpacioClaim = /** @class */ function(_super) {
    $e69e64a8cd8cdf89$var$__extends(HomeSpotterSpacioClaim, _super);
    function HomeSpotterSpacioClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return HomeSpotterSpacioClaim;
}($aqYRc.ClaimWithStringUserId);
module.exports.HomeSpotterSpacioClaim = $e69e64a8cd8cdf89$var$HomeSpotterSpacioClaim;

});
parcelRegister("aqYRc", function(module, exports) {
"use strict";
var $798b8a04a4baf803$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ClaimWithStringUserId = void 0;

var $9190n = parcelRequire("9190n");
var $798b8a04a4baf803$var$ClaimWithStringUserId = /** @class */ function(_super) {
    $798b8a04a4baf803$var$__extends(ClaimWithStringUserId, _super);
    function ClaimWithStringUserId() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ClaimWithStringUserId.prototype, "userId", {
        get: function() {
            return this.uid;
        },
        enumerable: false,
        configurable: true
    });
    return ClaimWithStringUserId;
}($9190n.ClaimBase);
module.exports.ClaimWithStringUserId = $798b8a04a4baf803$var$ClaimWithStringUserId;

});


parcelRegister("iQ2a3", function(module, exports) {
"use strict";
var $db6ec276c410963a$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LionDeskClaim = void 0;

var $jUIFx = parcelRequire("jUIFx");
var $db6ec276c410963a$var$LionDeskClaim = /** @class */ function(_super) {
    $db6ec276c410963a$var$__extends(LionDeskClaim, _super);
    function LionDeskClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return LionDeskClaim;
}($jUIFx.ClaimWithIntegerUserId);
module.exports.LionDeskClaim = $db6ec276c410963a$var$LionDeskClaim;

});

parcelRegister("aWT3t", function(module, exports) {
"use strict";
var $7f8a06f366e4bed4$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PropertybaseBackOfficeClaim = void 0;

var $1sPdh = parcelRequire("1sPdh");
var $7f8a06f366e4bed4$var$PropertybaseBackOfficeClaim = /** @class */ function(_super) {
    $7f8a06f366e4bed4$var$__extends(PropertybaseBackOfficeClaim, _super);
    function PropertybaseBackOfficeClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertybaseBackOfficeClaim.prototype.getMemberId = function() {
        return this.mid;
    };
    return PropertybaseBackOfficeClaim;
}($1sPdh.ClaimWithClientId);
module.exports.PropertybaseBackOfficeClaim = $7f8a06f366e4bed4$var$PropertybaseBackOfficeClaim;

});

parcelRegister("66w9Y", function(module, exports) {
"use strict";
var $471c3fe35c50d134$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PropertybaseBoldLeadsClaim = void 0;

var $jUIFx = parcelRequire("jUIFx");
var $471c3fe35c50d134$var$PropertybaseBoldLeadsClaim = /** @class */ function(_super) {
    $471c3fe35c50d134$var$__extends(PropertybaseBoldLeadsClaim, _super);
    function PropertybaseBoldLeadsClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PropertybaseBoldLeadsClaim;
}($jUIFx.ClaimWithIntegerUserId);
module.exports.PropertybaseBoldLeadsClaim = $471c3fe35c50d134$var$PropertybaseBoldLeadsClaim;

});

parcelRegister("75uwV", function(module, exports) {
"use strict";
var $5290aeb0dfd6e340$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PropertybaseGoClaim = void 0;

var $jUIFx = parcelRequire("jUIFx");
var $5290aeb0dfd6e340$var$PropertybaseGoClaim = /** @class */ function(_super) {
    $5290aeb0dfd6e340$var$__extends(PropertybaseGoClaim, _super);
    function PropertybaseGoClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PropertybaseGoClaim;
}($jUIFx.ClaimWithIntegerUserId);
module.exports.PropertybaseGoClaim = $5290aeb0dfd6e340$var$PropertybaseGoClaim;

});

parcelRegister("3a5dA", function(module, exports) {
"use strict";
var $24d65a81c5591b7c$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SalesforceClaim = void 0;

var $1sPdh = parcelRequire("1sPdh");
var $24d65a81c5591b7c$var$SalesforceClaim = /** @class */ function(_super) {
    $24d65a81c5591b7c$var$__extends(SalesforceClaim, _super);
    function SalesforceClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SalesforceClaim.prototype.getMemberId = function() {
        return this.mid;
    };
    return SalesforceClaim;
}($1sPdh.ClaimWithClientId);
module.exports.SalesforceClaim = $24d65a81c5591b7c$var$SalesforceClaim;

});

parcelRegister("8Exen", function(module, exports) {
"use strict";
var $64cbd61a52dca252$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TransactionDeskClaim = void 0;

var $aqYRc = parcelRequire("aqYRc");
var $64cbd61a52dca252$var$TransactionDeskClaim = /** @class */ function(_super) {
    $64cbd61a52dca252$var$__extends(TransactionDeskClaim, _super);
    function TransactionDeskClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TransactionDeskClaim;
}($aqYRc.ClaimWithStringUserId);
module.exports.TransactionDeskClaim = $64cbd61a52dca252$var$TransactionDeskClaim;

});

parcelRegister("fcYA3", function(module, exports) {
"use strict";
var $b126f80266dd8f0d$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TerradatumAergoClaim = void 0;

var $aqYRc = parcelRequire("aqYRc");
var $b126f80266dd8f0d$var$TerradatumAergoClaim = /** @class */ function(_super) {
    $b126f80266dd8f0d$var$__extends(TerradatumAergoClaim, _super);
    function TerradatumAergoClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TerradatumAergoClaim;
}($aqYRc.ClaimWithStringUserId);
module.exports.TerradatumAergoClaim = $b126f80266dd8f0d$var$TerradatumAergoClaim;

});

parcelRegister("2ZcIZ", function(module, exports) {
"use strict";
var $22cb2625b61e4d2c$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TerradatumAgentMetricsClaim = void 0;

var $aqYRc = parcelRequire("aqYRc");
var $22cb2625b61e4d2c$var$TerradatumAgentMetricsClaim = /** @class */ function(_super) {
    $22cb2625b61e4d2c$var$__extends(TerradatumAgentMetricsClaim, _super);
    function TerradatumAgentMetricsClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TerradatumAgentMetricsClaim;
}($aqYRc.ClaimWithStringUserId);
module.exports.TerradatumAgentMetricsClaim = $22cb2625b61e4d2c$var$TerradatumAgentMetricsClaim;

});

parcelRegister("7K2a0", function(module, exports) {
"use strict";
var $5a2e81438934c192$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.XBrokerMetricsClaim = void 0;

var $aqYRc = parcelRequire("aqYRc");
var $5a2e81438934c192$var$XBrokerMetricsClaim = /** @class */ function(_super) {
    $5a2e81438934c192$var$__extends(XBrokerMetricsClaim, _super);
    function XBrokerMetricsClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return XBrokerMetricsClaim;
}($aqYRc.ClaimWithStringUserId);
module.exports.XBrokerMetricsClaim = $5a2e81438934c192$var$XBrokerMetricsClaim;

});

parcelRegister("kP6YC", function(module, exports) {
"use strict";
var $f28dfb7fdab325e8$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TerradatumListingHomeRunClaim = void 0;

var $aqYRc = parcelRequire("aqYRc");
var $f28dfb7fdab325e8$var$TerradatumListingHomeRunClaim = /** @class */ function(_super) {
    $f28dfb7fdab325e8$var$__extends(TerradatumListingHomeRunClaim, _super);
    function TerradatumListingHomeRunClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TerradatumListingHomeRunClaim;
}($aqYRc.ClaimWithStringUserId);
module.exports.TerradatumListingHomeRunClaim = $f28dfb7fdab325e8$var$TerradatumListingHomeRunClaim;

});

parcelRegister("b8K1v", function(module, exports) {
"use strict";
var $81c4245236491770$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TerradatumVScreenClaim = void 0;

var $aqYRc = parcelRequire("aqYRc");
var $81c4245236491770$var$TerradatumVScreenClaim = /** @class */ function(_super) {
    $81c4245236491770$var$__extends(TerradatumVScreenClaim, _super);
    function TerradatumVScreenClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TerradatumVScreenClaim;
}($aqYRc.ClaimWithStringUserId);
module.exports.TerradatumVScreenClaim = $81c4245236491770$var$TerradatumVScreenClaim;

});

parcelRegister("bUyW4", function(module, exports) {
"use strict";
var $8ac00624b2719c06$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.WolfConnectClaim = void 0;

var $1sPdh = parcelRequire("1sPdh");
var $8ac00624b2719c06$var$WolfConnectClaim = /** @class */ function(_super) {
    $8ac00624b2719c06$var$__extends(WolfConnectClaim, _super);
    function WolfConnectClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WolfConnectClaim.prototype.getMemberId = function() {
        return this.mid;
    };
    return WolfConnectClaim;
}($1sPdh.ClaimWithClientId);
module.exports.WolfConnectClaim = $8ac00624b2719c06$var$WolfConnectClaim;

});

parcelRegister("6WMHE", function(module, exports) {
"use strict";
var $50edf043e40e4e72$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ZipFormPlusClaim = void 0;

var $aqYRc = parcelRequire("aqYRc");
var $50edf043e40e4e72$var$ZipFormPlusClaim = /** @class */ function(_super) {
    $50edf043e40e4e72$var$__extends(ZipFormPlusClaim, _super);
    function ZipFormPlusClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ZipFormPlusClaim;
}($aqYRc.ClaimWithStringUserId);
module.exports.ZipFormPlusClaim = $50edf043e40e4e72$var$ZipFormPlusClaim;

});

parcelRegister("28k3r", function(module, exports) {
"use strict";
var $18dbe288d1a0f627$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AuthentisignClaim = void 0;

var $aqYRc = parcelRequire("aqYRc");
var $18dbe288d1a0f627$var$AuthentisignClaim = /** @class */ function(_super) {
    $18dbe288d1a0f627$var$__extends(AuthentisignClaim, _super);
    function AuthentisignClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AuthentisignClaim;
}($aqYRc.ClaimWithStringUserId);
module.exports.AuthentisignClaim = $18dbe288d1a0f627$var$AuthentisignClaim;

});

parcelRegister("9X2d4", function(module, exports) {
"use strict";
var $73eb568ebe516834$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BackOfficeV4Claim = void 0;

var $1sPdh = parcelRequire("1sPdh");
var $73eb568ebe516834$var$BackOfficeV4Claim = /** @class */ function(_super) {
    $73eb568ebe516834$var$__extends(BackOfficeV4Claim, _super);
    function BackOfficeV4Claim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BackOfficeV4Claim.prototype.getMemberId = function() {
        return this.mid;
    };
    BackOfficeV4Claim.prototype.getOfficeId = function() {
        return this.oid;
    };
    return BackOfficeV4Claim;
}($1sPdh.ClaimWithClientId);
module.exports.BackOfficeV4Claim = $73eb568ebe516834$var$BackOfficeV4Claim;

});

parcelRegister("tnprI", function(module, exports) {
"use strict";
var $0584de2bc2c2a8e6$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CloudAttractClaim = void 0;

var $jUIFx = parcelRequire("jUIFx");
var $0584de2bc2c2a8e6$var$CloudAttractClaim = /** @class */ function(_super) {
    $0584de2bc2c2a8e6$var$__extends(CloudAttractClaim, _super);
    function CloudAttractClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CloudAttractClaim;
}($jUIFx.ClaimWithIntegerUserId);
module.exports.CloudAttractClaim = $0584de2bc2c2a8e6$var$CloudAttractClaim;

});

parcelRegister("cI5s5", function(module, exports) {
"use strict";
var $940dd2c38908f1ea$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CloudCMAClaim = void 0;

var $jUIFx = parcelRequire("jUIFx");
var $940dd2c38908f1ea$var$CloudCMAClaim = /** @class */ function(_super) {
    $940dd2c38908f1ea$var$__extends(CloudCMAClaim, _super);
    function CloudCMAClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CloudCMAClaim;
}($jUIFx.ClaimWithIntegerUserId);
module.exports.CloudCMAClaim = $940dd2c38908f1ea$var$CloudCMAClaim;

});

parcelRegister("3w5ek", function(module, exports) {
"use strict";
var $28f86ad5c413086c$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CloudMLXClaim = void 0;

var $jUIFx = parcelRequire("jUIFx");
var $28f86ad5c413086c$var$CloudMLXClaim = /** @class */ function(_super) {
    $28f86ad5c413086c$var$__extends(CloudMLXClaim, _super);
    function CloudMLXClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CloudMLXClaim;
}($jUIFx.ClaimWithIntegerUserId);
module.exports.CloudMLXClaim = $28f86ad5c413086c$var$CloudMLXClaim;

});

parcelRegister("9S5AF", function(module, exports) {
"use strict";
var $72fd7e5cf8ffbf04$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CloudStreamsClaim = void 0;

var $jUIFx = parcelRequire("jUIFx");
var $72fd7e5cf8ffbf04$var$CloudStreamsClaim = /** @class */ function(_super) {
    $72fd7e5cf8ffbf04$var$__extends(CloudStreamsClaim, _super);
    function CloudStreamsClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CloudStreamsClaim;
}($jUIFx.ClaimWithIntegerUserId);
module.exports.CloudStreamsClaim = $72fd7e5cf8ffbf04$var$CloudStreamsClaim;

});

parcelRegister("4gO8M", function(module, exports) {
"use strict";
var $31bf8ceaefd07757$var$__extends = module.exports && module.exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.TransactWorkflowClaim = void 0;

var $aqYRc = parcelRequire("aqYRc");
var $31bf8ceaefd07757$var$TransactWorkflowClaim = /** @class */ function(_super) {
    $31bf8ceaefd07757$var$__extends(TransactWorkflowClaim, _super);
    function TransactWorkflowClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TransactWorkflowClaim;
}($aqYRc.ClaimWithStringUserId);
module.exports.TransactWorkflowClaim = $31bf8ceaefd07757$var$TransactWorkflowClaim;

});


parcelRegister("a9Xrj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IdentityProvidersClaim = void 0;

var $katuo = parcelRequire("katuo");
var $7658da137edac406$var$IdentityProvidersClaim = /** @class */ function() {
    function IdentityProvidersClaim() {}
    IdentityProvidersClaim.prototype.populate = function(idpsClaimObject) {
        var _this = this;
        Object.keys(idpsClaimObject).forEach(function(idp) {
            _this[idp] = new $katuo.IdentityProviderClaim();
            Object.assign(_this[idp], idpsClaimObject[idp]);
        });
    };
    IdentityProvidersClaim.prototype.get = function(idp) {
        return this[idp];
    };
    return IdentityProvidersClaim;
}();
module.exports.IdentityProvidersClaim = $7658da137edac406$var$IdentityProvidersClaim;

});
parcelRegister("katuo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.IdentityProviderClaim = void 0;
var $eaeb9dc601fd0b83$var$IdentityProviderClaim = /** @class */ function() {
    function IdentityProviderClaim() {}
    IdentityProviderClaim.prototype.getIssuedAtTime = function() {
        return this.iat;
    };
    IdentityProviderClaim.prototype.getExpirationTime = function() {
        return this.exp;
    };
    return IdentityProviderClaim;
}();
module.exports.IdentityProviderClaim = $eaeb9dc601fd0b83$var$IdentityProviderClaim;

});


parcelRegister("k0ap7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ClientClaim = void 0;

var $4KnYW = parcelRequire("4KnYW");

var $8Fbo2 = parcelRequire("8Fbo2");
var $e8fbe0c29d8dd2cb$var$ClientClaim = /** @class */ function() {
    function ClientClaim() {}
    ClientClaim.prototype.populate = function(platformClientObject) {
        if (platformClientObject.apps) {
            this.apps = new $4KnYW.ApplicationsClaim();
            this.apps.populate(platformClientObject.apps);
            delete platformClientObject.apps;
        }
        if (platformClientObject.ext) {
            this.ext = new $8Fbo2.ExternalSystemsClaim();
            this.ext.populate(platformClientObject.ext);
            delete platformClientObject.ext;
        }
        Object.assign(this, platformClientObject);
    };
    ClientClaim.prototype.getId = function() {
        return this.cid;
    };
    ClientClaim.prototype.getType = function() {
        return this.ctp;
    };
    ClientClaim.prototype.getRoleId = function() {
        return this.rid;
    };
    ClientClaim.prototype.getOfficeId = function() {
        return this.oid;
    };
    ClientClaim.prototype.getBrokerageId = function() {
        return this.bid;
    };
    ClientClaim.prototype.getUserId = function() {
        return this.uid;
    };
    ClientClaim.prototype.getApplications = function() {
        return this.apps;
    };
    ClientClaim.prototype.getExternalSystems = function() {
        return this.ext;
    };
    ClientClaim.prototype.isUserClient = function() {
        return this.ctp === ClientClaim.CLIENT_TYPE_USER;
    };
    ClientClaim.CLIENT_TYPE_USER = "User";
    return ClientClaim;
}();
module.exports.ClientClaim = $e8fbe0c29d8dd2cb$var$ClientClaim;

});
parcelRegister("4KnYW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ApplicationsClaim = void 0;
var $374e0f9b05ec2c9a$var$ApplicationsClaim = /** @class */ function() {
    function ApplicationsClaim() {}
    ApplicationsClaim.prototype.populate = function(pfmAppsClaimObject) {
        var _this = this;
        Object.keys(pfmAppsClaimObject).forEach(function(code) {
            _this[code] = pfmAppsClaimObject[code];
        });
    };
    ApplicationsClaim.prototype.getCodes = function() {
        return Object.keys(this);
    };
    ApplicationsClaim.prototype.getModuleCodes = function(code) {
        return this[code];
    };
    return ApplicationsClaim;
}();
module.exports.ApplicationsClaim = $374e0f9b05ec2c9a$var$ApplicationsClaim;

});

parcelRegister("8Fbo2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExternalSystemsClaim = void 0;

var $8BhCc = parcelRequire("8BhCc");
var $64eafc3c36ddaf0d$var$ExternalSystemsClaim = /** @class */ function() {
    function ExternalSystemsClaim() {}
    ExternalSystemsClaim.prototype.populate = function(pfmExtClaimObject) {
        var _this = this;
        Object.keys(pfmExtClaimObject).forEach(function(code) {
            _this[code] = new $8BhCc.ExternalSystemClaim();
            Object.assign(_this[code], pfmExtClaimObject[code]);
        });
    };
    ExternalSystemsClaim.prototype.getCodes = function() {
        return Object.keys(this);
    };
    ExternalSystemsClaim.prototype.getExternalSystem = function(code) {
        return this[code];
    };
    return ExternalSystemsClaim;
}();
module.exports.ExternalSystemsClaim = $64eafc3c36ddaf0d$var$ExternalSystemsClaim;

});
parcelRegister("8BhCc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ExternalSystemClaim = void 0;
var $642f716a4cc4bb17$var$ExternalSystemClaim = /** @class */ function() {
    function ExternalSystemClaim() {}
    ExternalSystemClaim.prototype.getNumber = function() {
        return this.num;
    };
    return ExternalSystemClaim;
}();
module.exports.ExternalSystemClaim = $642f716a4cc4bb17$var$ExternalSystemClaim;

});



parcelRegister("13gD4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ActClaim = void 0;
var $0c42f872b9d72a88$var$ActClaim = /** @class */ function() {
    function ActClaim() {}
    ActClaim.prototype.populate = function(actClaimObject) {
        Object.assign(this, actClaimObject);
    };
    ActClaim.prototype.getUserId = function() {
        return this.uid;
    };
    ActClaim.prototype.getName = function() {
        return this.name;
    };
    ActClaim.prototype.getEmail = function() {
        return this.email;
    };
    return ActClaim;
}();
module.exports.ActClaim = $0c42f872b9d72a88$var$ActClaim;

});




parcelRegister("gnWRQ", function(module, exports) {
(function webpackUniversalModuleDefinition(root, factory) {
    var a, i;
    module.exports = factory();
})(module.exports, function() {
    return /******/ function() {
        /******/ var __webpack_modules__ = {
            /***/ "./packages/@logrocket/console/src/index.ts": /*!**************************************************!*\
  !*** ./packages/@logrocket/console/src/index.ts ***!
  \**************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = void 0;
                var _registerConsole = _interopRequireDefault(__webpack_require__(/*! ./registerConsole */ "./packages/@logrocket/console/src/registerConsole.js"));
                var _default = exports["default"] = _registerConsole.default;
            /***/ },
            /***/ "./packages/@logrocket/console/src/registerConsole.js": /*!************************************************************!*\
  !*** ./packages/@logrocket/console/src/registerConsole.js ***!
  \************************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = registerConsole;
                var _enhanceFunc = _interopRequireDefault(__webpack_require__(/*! @logrocket/utils/src/enhanceFunc */ "./packages/@logrocket/utils/src/enhanceFunc.ts"));
                var _exceptions = __webpack_require__(/*! @logrocket/exceptions */ "./packages/@logrocket/exceptions/src/index.ts");
                function registerConsole(logger) {
                    const unsubFunctions = [];
                    const methods = [
                        "log",
                        "warn",
                        "info",
                        "error",
                        "debug"
                    ];
                    methods.forEach((method)=>{
                        unsubFunctions.push((0, _enhanceFunc.default)(console, method, function() {
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                            logger.addEvent("lr.core.LogEvent", function() {
                                let consoleOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                                const isEnabled = consoleOptions.isEnabled;
                                if (typeof isEnabled === "object" && isEnabled[method] === false || isEnabled === false) return null;
                                if (method === "error" && consoleOptions.shouldAggregateConsoleErrors) {
                                    // some customers have loggers that add the log level as the first arg
                                    if (!!args && args.length >= 2 && args[0] === "ERROR") {
                                        let secondArg = "";
                                        try {
                                            secondArg = " ".concat(args[1]);
                                        } catch (_unused) {} // eslint-disable-line no-empty
                                        _exceptions.Capture.captureMessage(logger, "".concat(args[0]).concat(secondArg), args, {}, true);
                                    } else _exceptions.Capture.captureMessage(logger, args[0], args, {}, true);
                                }
                                return {
                                    logLevel: method.toUpperCase(),
                                    args: args
                                };
                            });
                        }));
                    });
                    return ()=>{
                        unsubFunctions.forEach((unsubFunction)=>unsubFunction());
                    };
                }
            /***/ },
            /***/ "./packages/@logrocket/custom-element-states/src/index.ts": /*!****************************************************************!*\
  !*** ./packages/@logrocket/custom-element-states/src/index.ts ***!
  \****************************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = void 0;
                var _registerCustomStates = _interopRequireDefault(__webpack_require__(/*! ./registerCustomStates */ "./packages/@logrocket/custom-element-states/src/registerCustomStates.ts"));
                var _default = exports["default"] = _registerCustomStates.default;
            /***/ },
            /***/ "./packages/@logrocket/custom-element-states/src/registerCustomStates.ts": /*!*******************************************************************************!*\
  !*** ./packages/@logrocket/custom-element-states/src/registerCustomStates.ts ***!
  \*******************************************************************************/ /***/ function(__unused_webpack_module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = registerCustomStates;
                function wrapCustomStateSet(element, stateSet, stateChangeCallback) {
                    const saved = stateSet.__lr_originals;
                    const originalAdd = saved ? saved.add : stateSet.add.bind(stateSet);
                    const originalDelete = saved ? saved.delete : stateSet.delete.bind(stateSet);
                    const originalClear = saved ? saved.clear : stateSet.clear.bind(stateSet);
                    if (!saved) stateSet.__lr_originals = {
                        add: originalAdd,
                        delete: originalDelete,
                        clear: originalClear
                    };
                    stateSet.add = function(value) {
                        const result = originalAdd(value);
                        stateChangeCallback({
                            timestamp: Date.now(),
                            element: element,
                            states: new Set(stateSet)
                        });
                        return result;
                    };
                    stateSet.delete = function(value) {
                        const result = originalDelete(value);
                        stateChangeCallback({
                            timestamp: Date.now(),
                            element: element,
                            states: new Set(stateSet)
                        });
                        return result;
                    };
                    stateSet.clear = function() {
                        originalClear();
                        stateChangeCallback({
                            timestamp: Date.now(),
                            element: element,
                            states: new Set()
                        });
                    };
                }
                function unwrapCustomStateSet(stateSet) {
                    const saved = stateSet.__lr_originals;
                    if (saved) {
                        stateSet.add = saved.add;
                        stateSet.delete = saved.delete;
                        stateSet.clear = saved.clear;
                    }
                }
                function registerCustomStates() {
                    if (typeof HTMLElement === "undefined" || typeof HTMLElement.prototype.attachInternals !== "function") return {
                        customStatesManager: undefined,
                        unsub: ()=>{}
                    };
                    const trackedElements = new WeakMap();
                    const trackedElementRefs = [];
                    const originalAttachInternalsDescriptor = Object.getOwnPropertyDescriptor(HTMLElement.prototype, "attachInternals");
                    let stateChangeCallback = undefined;
                    let stateChangeBuffer = [];
                    const MAX_STATE_BUFFER_SIZE = 200;
                    const runCallbacks = (event)=>{
                        stateChangeBuffer.push(event);
                        if (stateChangeBuffer.length > MAX_STATE_BUFFER_SIZE) stateChangeBuffer = stateChangeBuffer.slice(-MAX_STATE_BUFFER_SIZE);
                        if (stateChangeCallback != undefined) {
                            stateChangeBuffer.forEach((changeEvent)=>stateChangeCallback(changeEvent));
                            stateChangeBuffer = [];
                        }
                    };
                    Object.defineProperty(HTMLElement.prototype, "attachInternals", {
                        value: function() {
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                            const internals = originalAttachInternalsDescriptor.value.apply(this, args);
                            if (internals.states) {
                                const stateSet = internals.states;
                                wrapCustomStateSet(this, stateSet, runCallbacks);
                                trackedElements.set(this, stateSet);
                                trackedElementRefs.push(new WeakRef(this));
                            }
                            return internals;
                        },
                        enumerable: true,
                        writable: true,
                        configurable: true
                    });
                    const customStatesManager = {
                        onStateChange (callback) {
                            stateChangeCallback = callback;
                        },
                        clearStateChangeCallback () {
                            stateChangeCallback = undefined;
                        },
                        getStatesForElement (element) {
                            return trackedElements.has(element) ? new Set(trackedElements.get(element)) : new Set();
                        },
                        originalAttachInternalsDescriptor: originalAttachInternalsDescriptor,
                        cleanup () {
                            Object.defineProperty(HTMLElement.prototype, "attachInternals", originalAttachInternalsDescriptor);
                            for (const ref of trackedElementRefs){
                                const el = ref.deref();
                                if (el) {
                                    const stateSet = trackedElements.get(el);
                                    if (stateSet) unwrapCustomStateSet(stateSet);
                                }
                            }
                            trackedElementRefs.length = 0;
                        }
                    };
                    return {
                        customStatesManager: customStatesManager,
                        unsub: ()=>{
                            customStatesManager.cleanup();
                        }
                    };
                }
            /***/ },
            /***/ "./packages/@logrocket/exceptions/src/Capture.js": /*!*******************************************************!*\
  !*** ./packages/@logrocket/exceptions/src/Capture.js ***!
  \*******************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.captureException = captureException;
                exports.captureMessage = captureMessage;
                var _scrubException = __webpack_require__(/*! @logrocket/utils/src/scrubException */ "./packages/@logrocket/utils/src/scrubException.ts");
                var _TraceKit = _interopRequireDefault(__webpack_require__(/*! @logrocket/utils/src/TraceKit */ "./packages/@logrocket/utils/src/TraceKit.js"));
                var _stackTraceFromError = _interopRequireDefault(__webpack_require__(/*! ./stackTraceFromError */ "./packages/@logrocket/exceptions/src/stackTraceFromError.js"));
                function captureMessage(logger, message, messageArgs) {
                    let options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                    let isConsole = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
                    const data = {
                        exceptionType: isConsole ? "CONSOLE" : "MESSAGE",
                        message: message,
                        messageArgs: messageArgs,
                        browserHref: window.location ? window.location.href : ""
                    };
                    (0, _scrubException.scrubException)(data, options);
                    logger.addEvent("lr.core.Exception", ()=>data);
                }
                function captureException(logger, exception) {
                    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                    let preppedTrace = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
                    let exceptionType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "WINDOW";
                    const trace = preppedTrace || _TraceKit.default.computeStackTrace(exception);
                    const data = {
                        exceptionType: exceptionType,
                        errorType: trace.name,
                        message: trace.message,
                        browserHref: window.location ? window.location.href : ""
                    };
                    (0, _scrubException.scrubException)(data, options);
                    const addEventOptions = {
                        _stackTrace: (0, _stackTraceFromError.default)(trace)
                    };
                    logger.addEvent("lr.core.Exception", ()=>data, addEventOptions);
                }
            /***/ },
            /***/ "./packages/@logrocket/exceptions/src/index.ts": /*!*****************************************************!*\
  !*** ./packages/@logrocket/exceptions/src/index.ts ***!
  \*****************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Capture = void 0;
                Object.defineProperty(exports, "registerExceptions", {
                    enumerable: true,
                    get: function() {
                        return _registerExceptions.default;
                    }
                });
                var _registerExceptions = _interopRequireDefault(__webpack_require__(/*! ./registerExceptions */ "./packages/@logrocket/exceptions/src/registerExceptions.js"));
                var Capture = _interopRequireWildcard(__webpack_require__(/*! ./Capture */ "./packages/@logrocket/exceptions/src/Capture.js"));
                exports.Capture = Capture;
                function _interopRequireWildcard(e, t) {
                    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
                    return (_interopRequireWildcard = function(e, t) {
                        if (!t && e && e.__esModule) return e;
                        var o, i, f = {
                            __proto__: null,
                            default: e
                        };
                        if (null === e || "object" != typeof e && "function" != typeof e) return f;
                        if (o = t ? n : r) {
                            if (o.has(e)) return o.get(e);
                            o.set(e, f);
                        }
                        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
                        return f;
                    })(e, t);
                }
            /***/ },
            /***/ "./packages/@logrocket/exceptions/src/raven/FunctionPropertyMirror.js": /*!****************************************************************************!*\
  !*** ./packages/@logrocket/exceptions/src/raven/FunctionPropertyMirror.js ***!
  \****************************************************************************/ /***/ function(__unused_webpack_module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = void 0;
                const DEFAULT_RESERVED_PROPS = new Set([
                    "prototype",
                    "length",
                    "name",
                    "arguments",
                    "caller",
                    "__lr__",
                    "__lr_wrapper__",
                    "__inner__",
                    "__refreshMirroredProps__"
                ]);
                function isSymbol(prop) {
                    return typeof prop === "symbol";
                }
                class FunctionPropertyMirror {
                    constructor(source, target){
                        let { hasKey: hasKey, reservedProps: reservedProps = DEFAULT_RESERVED_PROPS, includeSymbols: includeSymbols = true } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                        this.source = source;
                        this.target = target;
                        this.hasKey = hasKey || (()=>false);
                        this.reservedProps = reservedProps;
                        this.includeSymbols = includeSymbols;
                        this.mirroredProps = Object.create(null);
                        this.descriptorCache = Object.create(null);
                    }
                    isReserved(prop) {
                        if (prop === null || prop === undefined) return true;
                        if (isSymbol(prop)) return !this.includeSymbols;
                        return this.reservedProps.has(prop);
                    }
                    remember(prop) {
                        this.mirroredProps[prop] = true;
                    }
                    forget(prop) {
                        delete this.mirroredProps[prop];
                        if (Object.prototype.hasOwnProperty.call(this.descriptorCache, prop)) delete this.descriptorCache[prop];
                    }
                    hasMirrored(prop) {
                        return Object.prototype.hasOwnProperty.call(this.mirroredProps, prop);
                    }
                    getDescriptor(prop) {
                        if (Object.prototype.hasOwnProperty.call(this.descriptorCache, prop)) return this.descriptorCache[prop] || undefined;
                        let descriptor;
                        try {
                            descriptor = Object.getOwnPropertyDescriptor(this.source, prop);
                        } catch (err) {
                            descriptor = undefined;
                        }
                        this.descriptorCache[prop] = descriptor || null;
                        return descriptor;
                    }
                    defineMirroredDescriptor(prop, descriptor) {
                        const configurable = Object.prototype.hasOwnProperty.call(descriptor, "configurable") ? descriptor.configurable : true;
                        const enumerable = Object.prototype.hasOwnProperty.call(descriptor, "enumerable") ? descriptor.enumerable : true;
                        if (descriptor.get || descriptor.set) {
                            Object.defineProperty(this.target, prop, {
                                configurable: configurable,
                                enumerable: enumerable,
                                get: descriptor.get ? ()=>descriptor.get.call(this.source) : undefined,
                                set: descriptor.set ? (value)=>descriptor.set.call(this.source, value) : undefined
                            });
                            return;
                        }
                        const writable = Object.prototype.hasOwnProperty.call(descriptor, "writable") ? descriptor.writable : true;
                        Object.defineProperty(this.target, prop, {
                            configurable: configurable,
                            enumerable: enumerable,
                            get: ()=>this.source[prop],
                            set: writable === false ? undefined : (value)=>{
                                this.source[prop] = value;
                            }
                        });
                    }
                    mirrorProperty(prop) {
                        if (this.isReserved(prop) || this.hasMirrored(prop)) return false;
                        if (!this.hasKey(this.source, prop)) return false;
                        const descriptor = this.getDescriptor(prop);
                        if (!descriptor) return false;
                        try {
                            this.defineMirroredDescriptor(prop, descriptor);
                            this.remember(prop);
                            return true;
                        } catch (err) {
                            try {
                                this.target[prop] = this.source[prop];
                                this.remember(prop);
                                return true;
                            } catch (e) {
                                return false;
                            }
                        }
                    }
                    mirrorProperties(props) {
                        if (!props) return;
                        const list = Array.isArray(props) ? props : [
                            props
                        ];
                        for(let i = 0; i < list.length; i += 1)this.mirrorProperty(list[i]);
                    }
                    syncAll() {
                        try {
                            this.mirrorProperties(Object.getOwnPropertyNames(this.source));
                            if (this.includeSymbols && typeof Object.getOwnPropertySymbols === "function") this.mirrorProperties(Object.getOwnPropertySymbols(this.source));
                        } catch (err) {
                        // Accessing some meta properties (e.g., 'caller') can throw in strict mode environments.
                        }
                    }
                    syncProperty(prop) {
                        if (this.isReserved(prop)) return;
                        this.forget(prop);
                        this.mirrorProperty(prop);
                    }
                    attachManualRefreshHook() {
                        if (this.isReserved("__refreshMirroredProps__")) Object.defineProperty(this.target, "__refreshMirroredProps__", {
                            configurable: true,
                            enumerable: false,
                            writable: false,
                            value: ()=>{
                                this.syncAll();
                                return this.target;
                            }
                        });
                    }
                }
                exports["default"] = FunctionPropertyMirror;
            /***/ },
            /***/ "./packages/@logrocket/exceptions/src/raven/raven.js": /*!***********************************************************!*\
  !*** ./packages/@logrocket/exceptions/src/raven/raven.js ***!
  \***********************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = void 0;
                var _TraceKit = _interopRequireDefault(__webpack_require__(/*! @logrocket/utils/src/TraceKit */ "./packages/@logrocket/utils/src/TraceKit.js"));
                var _FunctionPropertyMirror = _interopRequireDefault(__webpack_require__(/*! ./FunctionPropertyMirror */ "./packages/@logrocket/exceptions/src/raven/FunctionPropertyMirror.js"));
                /* eslint-disable */ /*
Some contents of this file were originaly from raven-js, BSD-2 Clause

Copyright (c) 2018 Sentry (https://sentry.io) and individual contributors.
All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:

* Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
* Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/ var objectPrototype = Object.prototype;
                function isUndefined(what) {
                    return what === void 0;
                }
                function isFunction(what) {
                    return typeof what === "function";
                }
                function each(obj, callback) {
                    var i, j;
                    if (isUndefined(obj.length)) {
                        for(i in obj)if (hasKey(obj, i)) callback.call(null, i, obj[i]);
                    } else {
                        j = obj.length;
                        if (j) for(i = 0; i < j; i++)callback.call(null, i, obj[i]);
                    }
                }
                /**
 * hasKey, a better form of hasOwnProperty
 * Example: hasKey(MainHostObject, property) === true/false
 *
 * @param {Object} host object to check property
 * @param {string} key to check
 */ function hasKey(object, key) {
                    return objectPrototype.hasOwnProperty.call(object, key);
                }
                /**
 * Polyfill a method
 * @param obj object e.g. `document`
 * @param name method name present on object e.g. `addEventListener`
 * @param replacement replacement function
 * @param track {optional} record instrumentation to an array
 */ function fill(obj, name, replacement, track) {
                    var orig = obj[name];
                    obj[name] = replacement(orig);
                    if (track) track.push([
                        obj,
                        name,
                        orig
                    ]);
                }
                var _window = typeof window !== "undefined" ? window : typeof __webpack_require__.g !== "undefined" ? __webpack_require__.g : typeof self !== "undefined" ? self : {};
                var _document = _window.document;
                class Handler {
                    constructor(_ref){
                        let { captureException: captureException } = _ref;
                        this._errorHandler = this._errorHandler.bind(this);
                        this._ignoreOnError = 0;
                        this._wrappedBuiltIns = [];
                        this.captureException = captureException;
                        _TraceKit.default.report.subscribe(this._errorHandler);
                        this._instrumentTryCatch();
                    }
                    uninstall() {
                        _TraceKit.default.report.unsubscribe(this._errorHandler);
                        // restore any wrapped builtins
                        var builtin;
                        while(this._wrappedBuiltIns.length){
                            builtin = this._wrappedBuiltIns.shift();
                            var obj = builtin[0], name = builtin[1], orig = builtin[2];
                            obj[name] = orig;
                        }
                    }
                    _errorHandler(report) {
                        if (!this._ignoreOnError) this.captureException(report);
                    }
                    _ignoreNextOnError() {
                        this._ignoreOnError += 1;
                        setTimeout(()=>{
                            // onerror should trigger before setTimeout
                            this._ignoreOnError -= 1;
                        });
                    }
                    /*
   * Wrap code within a context so Handler can capture errors
   * reliably across domains that is executed immediately.
   *
   * @param {object} options A specific set of options for this context [optional]
   * @param {function} func The callback to be immediately executed within the context
   * @param {array} args An array of arguments to be called with the callback [optional]
   */ context(options, func, args) {
                        if (isFunction(options)) {
                            args = func || [];
                            func = options;
                            options = undefined;
                        }
                        return this.wrap(options, func).apply(this, args);
                    }
                    /*
   * Wrap code within a context and returns back a new function to be executed
   *
   * @param {object} options A specific set of options for this context [optional]
   * @param {function} func The function to be wrapped in a new context
   * @param {function} func A function to call before the try/catch wrapper [optional, private]
   * @return {function} The newly wrapped functions with a context
   */ wrap(options, func, _before) {
                        var self1 = this;
                        // 1 argument has been passed, and it's not a function
                        // so just return it
                        if (isUndefined(func) && !isFunction(options)) return options;
                        // options is optional
                        if (isFunction(options)) {
                            func = options;
                            options = undefined;
                        }
                        // At this point, we've passed along 2 arguments, and the second one
                        // is not a function either, so we'll just return the second argument.
                        if (!isFunction(func)) return func;
                        // We don't wanna wrap it twice!
                        try {
                            if (func.__lr__) return func;
                            // If this has already been wrapped in the past, return that
                            if (func.__lr_wrapper__) return func.__lr_wrapper__;
                            // If func is not extensible, return the function as-is to prevent TypeErrors
                            // when trying to add new props & to assure immutable funcs aren't changed
                            if (!Object.isExtensible(func)) return func;
                        } catch (e) {
                            // Just accessing custom props in some Selenium environments
                            // can cause a "Permission denied" exception (see lr-js#495).
                            // Bail on wrapping and return the function as-is (defers to window.onerror).
                            return func;
                        }
                        function wrapped() {
                            var args = [], i = arguments.length, deep = !options || options && options.deep !== false;
                            if (_before && isFunction(_before)) _before.apply(this, arguments);
                            // Recursively wrap all of a function's arguments that are
                            // functions themselves.
                            while(i--)args[i] = deep ? self1.wrap(options, arguments[i]) : arguments[i];
                            try {
                                // Attempt to invoke user-land function. This is part of the LogRocket SDK.
                                // If you're seeing this frame in a stack trace, it means that LogRocket caught
                                // an unhandled error thrown by your application code, reported it, then bubbled
                                // it up. This is expected behavior and is not a bug with LogRocket.
                                return func.apply(this, args);
                            } catch (e) {
                                self1._ignoreNextOnError();
                                self1.captureException(_TraceKit.default.computeStackTrace(e), options);
                                throw e;
                            }
                        }
                        var reflect = typeof Reflect === "object" ? Reflect : undefined;
                        var propertyMirror = new _FunctionPropertyMirror.default(func, wrapped, {
                            hasKey: hasKey,
                            includeSymbols: true
                        });
                        propertyMirror.syncAll();
                        propertyMirror.attachManualRefreshHook();
                        wrapped.prototype = func.prototype;
                        try {
                            if (typeof Object.setPrototypeOf === "function") Object.setPrototypeOf(wrapped, func);
                            else if (!isUndefined(wrapped.__proto__)) wrapped.__proto__ = func;
                        } catch (prototypeError) {
                        // Ignore failures from prototype adjustments (e.g., non-extensible functions).
                        }
                        var returnWrapper = wrapped;
                        if (typeof Proxy === "function") {
                            var proxy = new Proxy(wrapped, {
                                apply (target, thisArg, argArray) {
                                    propertyMirror.syncAll();
                                    return target.apply(thisArg, argArray);
                                },
                                construct (target, argArray, newTarget) {
                                    propertyMirror.syncAll();
                                    if (reflect && reflect.construct) return reflect.construct(target, argArray, newTarget);
                                    var BoundTarget = Function.bind.apply(target, [
                                        null
                                    ].concat(argArray || []));
                                    return new BoundTarget();
                                },
                                get (target, prop, receiver) {
                                    if (prop === "__inner__") return func;
                                    propertyMirror.mirrorProperty(prop);
                                    if (reflect && reflect.get) return reflect.get(target, prop, receiver);
                                    return target[prop];
                                },
                                set (target, prop, value, receiver) {
                                    if (prop === "__lr__" || prop === "__lr_wrapper__" || prop === "__inner__") {
                                        if (reflect && reflect.set) return reflect.set(target, prop, value, receiver);
                                        target[prop] = value;
                                        return true;
                                    }
                                    propertyMirror.mirrorProperty(prop);
                                    var result;
                                    if (reflect && reflect.set) result = reflect.set(target, prop, value, receiver);
                                    else {
                                        target[prop] = value;
                                        result = true;
                                    }
                                    try {
                                        func[prop] = value;
                                        propertyMirror.syncProperty(prop);
                                    } catch (err) {
                                    // ignore failures syncing to the inner function
                                    }
                                    return result;
                                },
                                has (target, prop) {
                                    propertyMirror.mirrorProperty(prop);
                                    if (reflect && reflect.has) {
                                        if (reflect.has(target, prop)) return true;
                                    } else if (prop in target) return true;
                                    return prop in func;
                                },
                                ownKeys (target) {
                                    propertyMirror.syncAll();
                                    if (reflect && reflect.ownKeys) return reflect.ownKeys(target);
                                    return Object.getOwnPropertyNames(target);
                                },
                                getOwnPropertyDescriptor (target, prop) {
                                    propertyMirror.mirrorProperty(prop);
                                    if (reflect && reflect.getOwnPropertyDescriptor) return reflect.getOwnPropertyDescriptor(target, prop);
                                    return Object.getOwnPropertyDescriptor(target, prop);
                                },
                                defineProperty (target, prop, descriptor) {
                                    var defineResult;
                                    if (reflect && reflect.defineProperty) defineResult = reflect.defineProperty(target, prop, descriptor);
                                    else {
                                        Object.defineProperty(target, prop, descriptor);
                                        defineResult = true;
                                    }
                                    if (prop === "__lr__" || prop === "__lr_wrapper__" || prop === "__inner__") return defineResult;
                                    try {
                                        Object.defineProperty(func, prop, descriptor);
                                    } catch (err) {
                                    // ignore sync failure on inner function
                                    }
                                    propertyMirror.syncProperty(prop);
                                    return defineResult;
                                },
                                deleteProperty (target, prop) {
                                    if (prop === "__lr__" || prop === "__lr_wrapper__" || prop === "__inner__") {
                                        if (reflect && reflect.deleteProperty) return reflect.deleteProperty(target, prop);
                                        return delete target[prop];
                                    }
                                    propertyMirror.forget(prop);
                                    try {
                                        delete func[prop];
                                    } catch (err) {
                                    // ignore failures removing from inner function
                                    }
                                    if (reflect && reflect.deleteProperty) return reflect.deleteProperty(target, prop);
                                    return delete target[prop];
                                }
                            });
                            returnWrapper = proxy;
                        }
                        func.__lr_wrapper__ = returnWrapper;
                        // Signal that this function has been wrapped already
                        // for both debugging and to prevent it to being wrapped twice
                        wrapped.__lr__ = true;
                        wrapped.__inner__ = func;
                        if (returnWrapper !== wrapped) {
                            returnWrapper.__lr__ = true;
                            returnWrapper.__inner__ = func;
                        }
                        return returnWrapper;
                    }
                    /**
   * Install any queued plugins
   */ _instrumentTryCatch() {
                        var self1 = this;
                        var wrappedBuiltIns = self1._wrappedBuiltIns;
                        function wrapTimeFn(orig) {
                            return function(fn, t) {
                                // preserve arity
                                // Make a copy of the arguments to prevent deoptimization
                                // https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
                                var args = new Array(arguments.length);
                                for(var i = 0; i < args.length; ++i)args[i] = arguments[i];
                                var originalCallback = args[0];
                                if (isFunction(originalCallback)) args[0] = self1.wrap(originalCallback);
                                // IE < 9 doesn't support .call/.apply on setInterval/setTimeout, but it
                                // also supports only two arguments and doesn't care what this is, so we
                                // can just call the original function directly.
                                if (orig.apply) return orig.apply(this, args);
                                else return orig(args[0], args[1]);
                            };
                        }
                        function wrapEventTarget(global) {
                            var proto = _window[global] && _window[global].prototype;
                            if (proto && proto.hasOwnProperty && proto.hasOwnProperty("addEventListener")) {
                                fill(proto, "addEventListener", function(orig) {
                                    return function(evtName, fn, capture, secure) {
                                        // preserve arity
                                        try {
                                            if (fn && fn.handleEvent) fn.handleEvent = self1.wrap(fn.handleEvent);
                                        } catch (err) {
                                        // can sometimes get 'Permission denied to access property "handle Event'
                                        }
                                        // More breadcrumb DOM capture ... done here and not in `_instrumentBreadcrumbs`
                                        // so that we don't have more than one wrapper function
                                        var before;
                                        return orig.call(this, evtName, self1.wrap(fn, undefined, before), capture, secure);
                                    };
                                }, wrappedBuiltIns);
                                fill(proto, "removeEventListener", function(orig) {
                                    return function(evt, fn, capture, secure) {
                                        /**
             * There are 3 scenararios to consider when removing an event listener
             *
             * 1. 'addEventListener' was called when the LR SDK was uninitialized.
             * In this case, the event handler has not been wrapped, so this behaves
             * as a passthrough and just removes the original handler.
             *
             * 2. 'addEventListener' was called while the LR SDK was initialized, which means
             * our wrapped 'addEventListener' was called. In this case, the tracked event handler
             * is also wrapped, so we need to remove that wrapped version of the handler.
             *
             * 3. 'addEventListener' was called both before and after the LR SDK was initialized
             * for the same event handler. In this case, we have to remove both of them.
             * If we'd remove only the wrapped one, the initial handler would stick around forever.
             */ try {
                                            const wrappedFn = fn === null || fn === void 0 ? void 0 : fn.__lr_wrapper__;
                                            if (wrappedFn) orig.call(this, evt, wrappedFn, capture, secure);
                                        } catch (e) {
                                        // ignore, accessing __lr_wrapper__ will throw in some Selenium environments
                                        }
                                        return orig.call(this, evt, fn, capture, secure);
                                    };
                                }, // undefined is provided here to skip tracking for uninstall.
                                // Once our removeEventListener is installed, it can't be uninstalled.
                                // We always need to support removing logrocket wrapped event handlers (event
                                // handlers added when logrocket was installed) even after SDK shutdown.
                                undefined);
                            }
                        }
                        fill(_window, "setTimeout", wrapTimeFn, wrappedBuiltIns);
                        fill(_window, "setInterval", wrapTimeFn, wrappedBuiltIns);
                        if (_window.requestAnimationFrame) fill(_window, "requestAnimationFrame", function(orig) {
                            return function(cb) {
                                return orig(self1.wrap(cb));
                            };
                        }, wrappedBuiltIns);
                        // event targets borrowed from bugsnag-js:
                        // https://github.com/bugsnag/bugsnag-js/blob/master/src/bugsnag.js#L666
                        var eventTargets = [
                            "EventTarget",
                            "Window",
                            "Node",
                            "ApplicationCache",
                            "AudioTrackList",
                            "ChannelMergerNode",
                            "CryptoOperation",
                            "EventSource",
                            "FileReader",
                            "HTMLUnknownElement",
                            "IDBDatabase",
                            "IDBRequest",
                            "IDBTransaction",
                            "KeyOperation",
                            "MediaController",
                            "MessagePort",
                            "ModalWindow",
                            "Notification",
                            "SVGElementInstance",
                            "Screen",
                            "TextTrack",
                            "TextTrackCue",
                            "TextTrackList",
                            "WebSocket",
                            "WebSocketWorker",
                            "Worker",
                            "XMLHttpRequest",
                            "XMLHttpRequestEventTarget",
                            "XMLHttpRequestUpload"
                        ];
                        for(var i = 0; i < eventTargets.length; i++)wrapEventTarget(eventTargets[i]);
                        var $ = _window.jQuery || _window.$;
                        if ($ && $.fn && $.fn.ready) fill($.fn, "ready", function(orig) {
                            return function(fn) {
                                return orig.call(this, self1.wrap(fn));
                            };
                        }, wrappedBuiltIns);
                    }
                }
                exports["default"] = Handler;
            /***/ },
            /***/ "./packages/@logrocket/exceptions/src/registerExceptions.js": /*!******************************************************************!*\
  !*** ./packages/@logrocket/exceptions/src/registerExceptions.js ***!
  \******************************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = registerCore;
                var _raven = _interopRequireDefault(__webpack_require__(/*! ./raven/raven */ "./packages/@logrocket/exceptions/src/raven/raven.js"));
                var Capture = _interopRequireWildcard(__webpack_require__(/*! ./Capture */ "./packages/@logrocket/exceptions/src/Capture.js"));
                function _interopRequireWildcard(e, t) {
                    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
                    return (_interopRequireWildcard = function(e, t) {
                        if (!t && e && e.__esModule) return e;
                        var o, i, f = {
                            __proto__: null,
                            default: e
                        };
                        if (null === e || "object" != typeof e && "function" != typeof e) return f;
                        if (o = t ? n : r) {
                            if (o.has(e)) return o.get(e);
                            o.set(e, f);
                        }
                        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
                        return f;
                    })(e, t);
                }
                function registerCore(logger) {
                    const raven = new _raven.default({
                        captureException (errorReport) {
                            Capture.captureException(logger, null, null, errorReport);
                        }
                    });
                    const rejectionHandler = (evt)=>{
                        // http://2ality.com/2016/04/unhandled-rejections.html
                        if (evt.reason instanceof Error) Capture.captureException(logger, evt.reason, null, null, "UNHANDLED_REJECTION");
                        else logger.addEvent("lr.core.Exception", ()=>({
                                exceptionType: "UNHANDLED_REJECTION",
                                message: evt.reason || "Unhandled Promise rejection"
                            }));
                    };
                    window.addEventListener("unhandledrejection", rejectionHandler);
                    return ()=>{
                        window.removeEventListener("unhandledrejection", rejectionHandler);
                        raven.uninstall();
                    };
                }
            /***/ },
            /***/ "./packages/@logrocket/exceptions/src/stackTraceFromError.js": /*!*******************************************************************!*\
  !*** ./packages/@logrocket/exceptions/src/stackTraceFromError.js ***!
  \*******************************************************************/ /***/ function(__unused_webpack_module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = stackTraceFromError;
                function stackTraceFromError(errorReport) {
                    function makeNotNull(val) {
                        return val === null ? undefined : val;
                    }
                    return errorReport.stack ? errorReport.stack.map((frame)=>({
                            lineNumber: makeNotNull(frame.line),
                            columnNumber: makeNotNull(frame.column),
                            fileName: makeNotNull(frame.url),
                            functionName: makeNotNull(frame.func)
                        })) : undefined;
                }
            /***/ },
            /***/ "./packages/@logrocket/network/src/fetchIntercept.js": /*!***********************************************************!*\
  !*** ./packages/@logrocket/network/src/fetchIntercept.js ***!
  \***********************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = void 0;
                var _registerXHR = __webpack_require__(/*! ./registerXHR */ "./packages/@logrocket/network/src/registerXHR.js");
                /* eslint-disable @typescript-eslint/no-shadow */ let interceptors = [];
                function makeInterceptor(fetch1, fetchId) {
                    const reversedInterceptors = interceptors.reduce((array, interceptor)=>[
                            interceptor
                        ].concat(array), []);
                    // if a browser supports fetch, it supports promise
                    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
                    let promise = Promise.resolve(args);
                    // Register request interceptors
                    reversedInterceptors.forEach((_ref)=>{
                        let { request: request, requestError: requestError } = _ref;
                        if (request || requestError) promise = promise.then((args)=>request(fetchId, ...args), (args)=>requestError(fetchId, ...args));
                    });
                    promise = promise.then((args)=>{
                        (0, _registerXHR.setActive)(false);
                        let res;
                        let err;
                        try {
                            res = fetch1(...args);
                        } catch (_err) {
                            err = _err;
                        }
                        (0, _registerXHR.setActive)(true);
                        if (err) throw err;
                        return res;
                    });
                    reversedInterceptors.forEach((_ref2)=>{
                        let { response: response, responseError: responseError } = _ref2;
                        if (response || responseError) promise = promise.then((res)=>response(fetchId, res), (err)=>responseError && responseError(fetchId, err));
                    });
                    return promise;
                }
                function attach(env) {
                    if (!env.fetch || !env.Promise) // Make sure fetch is available in the given environment. If it's not, then
                    // default to using XHR intercept.
                    return;
                    const isPolyfill = env.fetch.polyfill;
                    env.fetch = ((fetch1)=>{
                        let fetchId = 0;
                        return function() {
                            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                            return makeInterceptor(fetch1, fetchId++, ...args);
                        };
                    })(env.fetch);
                    // Forward the polyfill properly from fetch (set by github/whatwg-fetch).
                    if (isPolyfill) env.fetch.polyfill = isPolyfill;
                }
                // TODO: React Native
                //   attach(global);
                let didAttach = false;
                var _default = exports["default"] = {
                    register (interceptor) {
                        if (!didAttach) {
                            didAttach = true;
                            attach(window);
                        }
                        interceptors.push(interceptor);
                        return ()=>{
                            const index = interceptors.indexOf(interceptor);
                            if (index >= 0) interceptors.splice(index, 1);
                        };
                    },
                    clear () {
                        interceptors = [];
                    }
                };
            /***/ },
            /***/ "./packages/@logrocket/network/src/index.js": /*!**************************************************!*\
  !*** ./packages/@logrocket/network/src/index.js ***!
  \**************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = registerNetwork;
                var _defineProperty2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/defineProperty.js"));
                var _registerFetch = _interopRequireDefault(__webpack_require__(/*! ./registerFetch */ "./packages/@logrocket/network/src/registerFetch.js"));
                var _registerIonic = __webpack_require__(/*! ./registerIonic */ "./packages/@logrocket/network/src/registerIonic.ts");
                var _registerNetworkInformation = _interopRequireDefault(__webpack_require__(/*! ./registerNetworkInformation */ "./packages/@logrocket/network/src/registerNetworkInformation.js"));
                var _registerXHR = _interopRequireDefault(__webpack_require__(/*! ./registerXHR */ "./packages/@logrocket/network/src/registerXHR.js"));
                var _mapValues = _interopRequireDefault(__webpack_require__(/*! @logrocket/utils/src/mapValues */ "./packages/@logrocket/utils/src/mapValues.ts"));
                function ownKeys(e, r) {
                    var t = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var o = Object.getOwnPropertySymbols(e);
                        r && (o = o.filter(function(r) {
                            return Object.getOwnPropertyDescriptor(e, r).enumerable;
                        })), t.push.apply(t, o);
                    }
                    return t;
                }
                function _objectSpread(e) {
                    for(var r = 1; r < arguments.length; r++){
                        var t = null != arguments[r] ? arguments[r] : {};
                        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
                            (0, _defineProperty2.default)(e, r, t[r]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
                            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
                        });
                    }
                    return e;
                }
                function registerNetwork(logger) {
                    let config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                        isReactNative: false,
                        isDisabled: false
                    };
                    if ((config === null || config === void 0 ? void 0 : config.isDisabled) === true) return ()=>{};
                    const { isReactNative: isReactNative, shouldAugmentNPS: shouldAugmentNPS, shouldParseXHRBlob: shouldParseXHRBlob } = config;
                    const ignoredNetwork = {};
                    // truncate if > 4MB in size
                    const truncate = (data)=>{
                        const limit = 4096000;
                        let str = data;
                        if (typeof data === "object" && data != null) {
                            const proto = Object.getPrototypeOf(data);
                            if (proto === Object.prototype || proto === null) // plain object - jsonify for the size check
                            str = JSON.stringify(data);
                        }
                        if (str && str.length && str.length > limit && typeof str === "string") {
                            const beginning = str.substring(0, 1000);
                            return "".concat(beginning, " ... LogRocket truncating to first 1000 characters.\n      Keep data under 4MB to prevent truncation. https://docs.logrocket.com/reference/network");
                        }
                        return data;
                    };
                    const addRequest = (reqId, request)=>{
                        const method = request.method;
                        logger.addEvent("lr.network.RequestEvent", function() {
                            let { isEnabled: isEnabled = true, requestSanitizer: requestSanitizer = (f)=>f } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                            if (!isEnabled) return null;
                            let sanitized = null;
                            try {
                                // only try catch user defined functions
                                sanitized = requestSanitizer(_objectSpread(_objectSpread({}, request), {}, {
                                    reqId: reqId
                                }));
                            } catch (err) {
                                console.error(err);
                            }
                            if (sanitized) {
                                let url = sanitized.url;
                                if (typeof document !== "undefined" && typeof document.createElement === "function") {
                                    // Writing and then reading from an a tag turns a relative
                                    // url into an absolute one.
                                    const a = document.createElement("a");
                                    a.href = sanitized.url;
                                    url = a.href;
                                }
                                return {
                                    reqId: reqId,
                                    url: // default
                                    url,
                                    // sanitized
                                    headers: (0, _mapValues.default)(sanitized.headers, (headerValue)=>{
                                        // sanitized
                                        return "".concat(headerValue);
                                    }),
                                    body: truncate(sanitized.body),
                                    method: // sanitized
                                    method,
                                    // default
                                    referrer: sanitized.referrer || undefined,
                                    // sanitized
                                    mode: sanitized.mode || undefined,
                                    // sanitized
                                    credentials: sanitized.credentials || undefined,
                                    // sanitized
                                    initiatorType: sanitized.initiatorType || "UNKNOWN"
                                };
                            }
                            ignoredNetwork[reqId] = true;
                            return null;
                        });
                    };
                    const addResponse = (reqId, response)=>{
                        const { method: method, status: status, responseType: responseType } = response;
                        logger.addEvent("lr.network.ResponseEvent", function() {
                            let { isEnabled: isEnabled = true, responseSanitizer: responseSanitizer = (f)=>f } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                            if (!isEnabled) return null;
                            else if (ignoredNetwork[reqId]) {
                                delete ignoredNetwork[reqId];
                                return null;
                            }
                            let sanitized = null;
                            try {
                                // only try catch user defined functions
                                sanitized = responseSanitizer(_objectSpread(_objectSpread({}, response), {}, {
                                    reqId: reqId
                                }));
                            } catch (err) {
                                console.error(err);
                            // fall through to redacted log
                            }
                            if (sanitized) return {
                                reqId: reqId,
                                responseType: // default
                                responseType,
                                status: sanitized.status,
                                // sanitized
                                headers: (0, _mapValues.default)(sanitized.headers, (headerValue)=>{
                                    // sanitized
                                    return "".concat(headerValue);
                                }),
                                body: truncate(sanitized.body),
                                method: // sanitized
                                method // default
                            };
                            return {
                                reqId: reqId,
                                responseType: // default
                                responseType,
                                status: status,
                                // default
                                headers: {},
                                // redacted
                                body: null,
                                method: // redacted
                                method // default
                            };
                        });
                    };
                    const isIgnored = (reqId)=>logger.isDisabled || ignoredNetwork[reqId] === true;
                    const unsubFetch = (0, _registerFetch.default)({
                        addRequest: addRequest,
                        addResponse: addResponse,
                        isIgnored: isIgnored
                    });
                    const unsubXHR = (0, _registerXHR.default)({
                        addRequest: addRequest,
                        addResponse: addResponse,
                        isIgnored: isIgnored,
                        logger: logger,
                        shouldAugmentNPS: shouldAugmentNPS,
                        shouldParseXHRBlob: shouldParseXHRBlob
                    });
                    const unsubIonic = (0, _registerIonic.registerIonic)({
                        addRequest: addRequest,
                        addResponse: addResponse,
                        isIgnored: isIgnored
                    });
                    const unsubNetworkInformation = isReactNative ? ()=>{} : (0, _registerNetworkInformation.default)(logger);
                    return ()=>{
                        unsubNetworkInformation();
                        unsubFetch();
                        unsubXHR();
                        unsubIonic();
                    };
                }
            /***/ },
            /***/ "./packages/@logrocket/network/src/registerFetch.js": /*!**********************************************************!*\
  !*** ./packages/@logrocket/network/src/registerFetch.js ***!
  \**********************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = registerFetch;
                var _defineProperty2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/defineProperty.js"));
                var _mapValues = _interopRequireDefault(__webpack_require__(/*! @logrocket/utils/src/mapValues */ "./packages/@logrocket/utils/src/mapValues.ts"));
                var _fetchIntercept = _interopRequireDefault(__webpack_require__(/*! ./fetchIntercept */ "./packages/@logrocket/network/src/fetchIntercept.js"));
                function ownKeys(e, r) {
                    var t = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var o = Object.getOwnPropertySymbols(e);
                        r && (o = o.filter(function(r) {
                            return Object.getOwnPropertyDescriptor(e, r).enumerable;
                        })), t.push.apply(t, o);
                    }
                    return t;
                }
                function _objectSpread(e) {
                    for(var r = 1; r < arguments.length; r++){
                        var t = null != arguments[r] ? arguments[r] : {};
                        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
                            (0, _defineProperty2.default)(e, r, t[r]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
                            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
                        });
                    }
                    return e;
                }
                function makeObjectFromHeaders(headers) {
                    if (typeof headers === "undefined") return {};
                    // If using real fetch, we must stringify the Headers object.
                    if (headers == null || typeof headers.forEach !== "function") return headers;
                    const result = {};
                    headers.forEach((value, key)=>{
                        if (result[key]) result[key] = "".concat(result[key], ",").concat(value);
                        else result[key] = "".concat(value);
                    });
                    return result;
                }
                // XHR specification is unclear of what types to allow in value so using toString method for now
                const stringifyHeaders = (headers)=>(0, _mapValues.default)(makeObjectFromHeaders(headers), (value)=>{
                        return "".concat(value);
                    });
                function pluckFetchFields() {
                    let arg = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                    return {
                        url: arg.url,
                        headers: stringifyHeaders(arg.headers),
                        method: arg.method && arg.method.toUpperCase(),
                        referrer: arg.referrer || undefined,
                        mode: arg.mode || undefined,
                        credentials: arg.credentials || undefined
                    };
                }
                function contentTypeIsBinary(contentType) {
                    if (typeof contentType !== "string") return false;
                    if (contentType.startsWith("image/") && contentType !== "image/svg+xml") return true;
                    else if (contentType.startsWith("video/")) return true;
                    else if (contentType === "application/octet-stream") return true;
                    return false;
                }
                function registerFetch(_ref) {
                    let { addRequest: addRequest, addResponse: addResponse, isIgnored: isIgnored } = _ref;
                    const LOGROCKET_FETCH_LABEL = "fetch-";
                    const fetchMethodMap = {};
                    const unregister = _fetchIntercept.default.register({
                        request (fetchId) {
                            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                            let p;
                            if (typeof Request !== "undefined" && args[0] instanceof Request) {
                                let clonedText;
                                // Request.clone() and Request.text() may throw in Safari (e.g., when
                                // request body contains FormData)
                                try {
                                    clonedText = args[0].clone().text();
                                } catch (err) {
                                    // if a browser supports fetch, it supports promise
                                    clonedText = Promise.resolve("LogRocket fetch error: ".concat(err.message));
                                }
                                p = clonedText.then((body)=>{
                                    return _objectSpread(_objectSpread({}, pluckFetchFields(args[0])), {}, {
                                        body: body
                                    });
                                }, (err)=>{
                                    return _objectSpread(_objectSpread({}, pluckFetchFields(args[0])), {}, {
                                        body: "LogRocket fetch error: ".concat(err.message)
                                    });
                                });
                            } else // if a browser supports fetch, it supports promise
                            p = Promise.resolve(_objectSpread(_objectSpread({}, pluckFetchFields(args[1])), {}, {
                                url: "".concat(args[0]),
                                body: (args[1] || {}).body
                            }));
                            return p.then((req)=>{
                                fetchMethodMap[fetchId] = req.method;
                                req.initiatorType = "FETCH";
                                addRequest("".concat(LOGROCKET_FETCH_LABEL).concat(fetchId), req);
                                return args;
                            });
                        },
                        requestError (fetchId, error) {
                            // if a browser supports fetch, it supports promise
                            return Promise.reject(error);
                        },
                        response (fetchId, response) {
                            var _response$headers, _response$headers2;
                            let responseClone;
                            let responseTextPromise;
                            if (isIgnored("".concat(LOGROCKET_FETCH_LABEL).concat(fetchId))) // Don't even try to read ignored requests
                            return response;
                            // event-streams are meant to remain open and be consumed over time by the sender. Attempting to capture the body
                            // of these requests will cause us to "stall" here, and prevents the users of our SDK from using event-streams
                            // unless they have explicitly ignored the request.
                            if (((_response$headers = response.headers) === null || _response$headers === void 0 ? void 0 : _response$headers.get("content-type")) === "text/event-stream") responseTextPromise = Promise.resolve("LogRocket skipped consuming an event-stream body.");
                            else if (contentTypeIsBinary((_response$headers2 = response.headers) === null || _response$headers2 === void 0 ? void 0 : _response$headers2.get("content-type"))) responseTextPromise = Promise.resolve("LogRocket skipped consuming a binary body.");
                            else {
                                try {
                                    // TODO: enhance function on original response and future clones for:
                                    // text(), json(), blob(), formdata(), arraybuffer()
                                    responseClone = response.clone();
                                } catch (err) {
                                    var _response$type;
                                    // safari has a bug where cloning can fail
                                    const responseHash = {
                                        url: response.url,
                                        responseType: (_response$type = response.type) === null || _response$type === void 0 ? void 0 : _response$type.toUpperCase(),
                                        status: response.status,
                                        headers: stringifyHeaders(response.headers),
                                        body: "LogRocket fetch error: ".concat(err.message),
                                        method: fetchMethodMap[fetchId]
                                    };
                                    delete fetchMethodMap[fetchId];
                                    addResponse("".concat(LOGROCKET_FETCH_LABEL).concat(fetchId), responseHash);
                                    return response;
                                }
                                try {
                                    if (window.TextDecoder && responseClone.body) {
                                        // use a reader to manually read the response body rather than calling response.text()
                                        // response.text() was timing out for some responses, in some cases because Apollo sends
                                        //   an abort signal or because the stream wasn't getting terminated cleanly
                                        // using a reader allows us to capture what we can from response bodies before the
                                        //   response receives an abort signal
                                        const reader = responseClone.body.getReader();
                                        // response bodies always decode with UTF-8
                                        // https://developer.mozilla.org/en-US/docs/Web/API/Response/text
                                        const utf8Decoder = new window.TextDecoder("utf-8");
                                        let bodyContents = "";
                                        responseTextPromise = reader.read().then(function readResponseBody(_ref2) {
                                            let { done: done, value: value } = _ref2;
                                            if (done) return bodyContents;
                                            const chunk = value ? utf8Decoder.decode(value, {
                                                stream: true
                                            }) : "";
                                            bodyContents += chunk;
                                            return reader.read().then(readResponseBody);
                                        });
                                    } else // TextDecoder doesn't have support across all browsers that LR supports, so if there's
                                    //  no TextDecoder, fall back to the old approach
                                    responseTextPromise = responseClone.text();
                                } catch (error) {
                                    responseTextPromise = Promise.resolve("LogRocket error reading body: ".concat(error.message));
                                }
                            }
                            responseTextPromise.catch((error)=>{
                                // don't drop request & log to console when the request is aborted,
                                // as it may have already completed
                                // https://github.com/LogRocket/logrocket/issues/34
                                if (error.name === "AbortError" && error instanceof DOMException) return;
                                return "LogRocket error reading body: ".concat(error.message);
                            }).then((data)=>{
                                var _response$type2;
                                const responseHash = {
                                    url: response.url,
                                    responseType: (_response$type2 = response.type) === null || _response$type2 === void 0 ? void 0 : _response$type2.toUpperCase(),
                                    status: response.status,
                                    headers: stringifyHeaders(response.headers),
                                    body: data,
                                    method: fetchMethodMap[fetchId]
                                };
                                delete fetchMethodMap[fetchId];
                                addResponse("".concat(LOGROCKET_FETCH_LABEL).concat(fetchId), responseHash);
                            });
                            return response;
                        },
                        responseError (fetchId, error) {
                            const response = {
                                url: undefined,
                                status: 0,
                                headers: {},
                                body: "".concat(error)
                            };
                            addResponse("".concat(LOGROCKET_FETCH_LABEL).concat(fetchId), response);
                            // if a browser supports fetch, it supports promise
                            return Promise.reject(error);
                        }
                    });
                    return unregister;
                }
            /***/ },
            /***/ "./packages/@logrocket/network/src/registerIonic.ts": /*!**********************************************************!*\
  !*** ./packages/@logrocket/network/src/registerIonic.ts ***!
  \**********************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.appendQueryParamsString = appendQueryParamsString;
                exports.mergeHeaders = mergeHeaders;
                exports.processData = processData;
                exports.registerIonic = registerIonic;
                exports.serializeQueryParams = serializeQueryParams;
                var _defineProperty2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/defineProperty.js"));
                var _protectFunc = _interopRequireDefault(__webpack_require__(/*! @logrocket/utils/src/protectFunc */ "./packages/@logrocket/utils/src/protectFunc.ts"));
                function ownKeys(e, r) {
                    var t = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var o = Object.getOwnPropertySymbols(e);
                        r && (o = o.filter(function(r) {
                            return Object.getOwnPropertyDescriptor(e, r).enumerable;
                        })), t.push.apply(t, o);
                    }
                    return t;
                }
                function _objectSpread(e) {
                    for(var r = 1; r < arguments.length; r++){
                        var t = null != arguments[r] ? arguments[r] : {};
                        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
                            (0, _defineProperty2.default)(e, r, t[r]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
                            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
                        });
                    }
                    return e;
                }
                const VALID_HTTP_METHODS = new Set([
                    "get",
                    "put",
                    "post",
                    "patch",
                    "head",
                    "delete",
                    "options",
                    "upload",
                    "download"
                ]);
                const VALID_SERIALIZERS = new Set([
                    "urlencoded",
                    "json",
                    "utf8"
                ]);
                const UNSUPPORTED_SERIALIZERS = new Set([
                    "raw",
                    "multipart"
                ]);
                const LOGROCKET_IONIC_LABEL = "ionic-";
                const UNSUPPORTED_PLATFORMS = new Set([
                    "desktop",
                    "mobileweb",
                    "pwa"
                ]);
                const FORM_DATA = new Set([
                    "FormData"
                ]);
                const EMPTY_SET = new Set();
                const STRING_SET = new Set([
                    "string"
                ]);
                const STRING_ARRAY_SET = new Set([
                    "string",
                    "array"
                ]);
                const ALLOWED_DATA_TYPES = {
                    utf8: STRING_SET,
                    urlencoded: new Set([
                        "object"
                    ]),
                    json: new Set([
                        "array",
                        "object"
                    ]),
                    raw: new Set([
                        "Uint8Array",
                        "ArrayBuffer"
                    ]),
                    default: EMPTY_SET
                };
                // Used in intercepting Ionic pugin requests found here https://www.npmjs.com/package/@ionic-native/http
                // based on https://github.com/silkimen/cordova-plugin-advanced-http/blob/master/www/public-interface.js
                // The @ionic-native/http plugin declares that the path to the plugin is `cordova.plugin.http`, but the Cordova type
                // (provided by @types/cordova in the sample app) does _not_ expose a `plugin` field. This is used to coerce and
                // correct the typing below.
                function checkForValidStringValue(list, value, fieldName) {
                    if (typeof value !== "string") throw new Error("".concat(fieldName, " must be one of: ").concat([
                        ...list
                    ].join(", ")));
                    value = value.trim().toLowerCase();
                    if (!list.has(value)) throw new Error("".concat(fieldName, " must be one of: ").concat([
                        ...list
                    ].join(", ")));
                    return value;
                }
                function checkKeyValuePairObject(obj, allowedChildren, onInvalidValueMessage) {
                    if (typeof obj !== "object") throw new Error(onInvalidValueMessage);
                    for (const key of Object.keys(obj)){
                        if (!allowedChildren.has(typeof obj[key])) throw new Error(onInvalidValueMessage);
                    }
                    return obj;
                }
                function getMatchingHostHeaders(url, ionicHttp) {
                    const { host: host } = new URL(url);
                    return ionicHttp.getHeaders(host) || null;
                }
                function mergeHeaders(defaultHeaders, headers) {
                    return _objectSpread(_objectSpread({}, defaultHeaders), headers);
                }
                function getMergedHeaders(url, requestHeaders, ionicHttp) {
                    // get global headers via public method
                    const globalHeaders = ionicHttp.getHeaders("*") || {};
                    const hostHeaders = getMatchingHostHeaders(url, ionicHttp) || {};
                    return mergeHeaders(mergeHeaders(globalHeaders, hostHeaders), requestHeaders);
                }
                function serializeValue(value, encode) {
                    if (encode) return encodeURIComponent(value);
                    else return value;
                }
                function serializeIdentifier(parentKey, key, encode) {
                    if (!parentKey.length) return encode ? encodeURIComponent(key) : key;
                    if (encode) return "".concat(encodeURIComponent(parentKey), "[").concat(encodeURIComponent(key), "]");
                    else return "".concat(parentKey, "[").concat(key, "]");
                }
                function serializeArray(parentKey, array, encode) {
                    const parts = [];
                    for (const e of array){
                        if (Array.isArray(e)) {
                            parts.push(serializeArray("".concat(parentKey, "[]"), e, encode));
                            continue;
                        } else if (typeof e === "object") {
                            /* This replicates what appears to be a bug in the Ionic code in order to capture everything identically
         parts.push(serializeObject(`${parentKey}[]${array[i]}`, encode));
         https://github.com/silkimen/cordova-plugin-advanced-http/blob/master/www/url-util.js#L73
      */ // eslint-disable-next-line @typescript-eslint/no-use-before-define
                            parts.push(serializeObject("".concat(parentKey, "[]").concat(e), encode, undefined));
                            continue;
                        }
                        parts.push("".concat(serializeIdentifier(parentKey, "", encode), "=").concat(serializeValue(e, encode)));
                    }
                    return parts.join("&");
                }
                function serializeObject(parentKey, object, encode) {
                    const parts = [];
                    for(const key in object){
                        if (!object.hasOwnProperty(key)) continue;
                        const identifier = parentKey.length ? "".concat(parentKey, "[").concat(key, "]") : key;
                        if (Array.isArray(object[key])) {
                            parts.push(serializeArray(identifier, object[key], encode));
                            continue;
                        } else if (typeof object[key] === "object" && object[key] !== null) {
                            parts.push(serializeObject(identifier, object[key], encode));
                            continue;
                        }
                        parts.push("".concat(serializeIdentifier(parentKey, key, encode), "=").concat(serializeValue(object[key], encode)));
                    }
                    return parts.join("&");
                }
                function serializeQueryParams(params, encode) {
                    return serializeObject("", params, encode);
                }
                function appendQueryParamsString(url, params) {
                    if (!url.length || !params.length) return url;
                    const { host: host, pathname: pathname, search: search, hash: hash, protocol: protocol } = new URL(url);
                    return "".concat(protocol, "//").concat(host).concat(pathname).concat(search.length ? "".concat(search, "&").concat(params) : "?".concat(params)).concat(hash);
                }
                function getAllowedDataTypes(dataSerializer) {
                    return ALLOWED_DATA_TYPES[dataSerializer] || ALLOWED_DATA_TYPES.default;
                }
                function getAllowedInstanceTypes(dataSerializer) {
                    return dataSerializer === "multipart" ? FORM_DATA : EMPTY_SET;
                }
                function processData(data, dataSerializer) {
                    const currentDataType = typeof data;
                    const allowedDataTypes = getAllowedDataTypes(dataSerializer);
                    const allowedInstanceTypes = getAllowedInstanceTypes(dataSerializer);
                    if (allowedInstanceTypes.size > 0) {
                        let isCorrectInstanceType = false;
                        allowedInstanceTypes.forEach((type)=>{
                            if (__webpack_require__.g[type] && data instanceof __webpack_require__.g[type]) isCorrectInstanceType = true;
                        });
                        if (!isCorrectInstanceType) throw new Error("INSTANCE_TYPE_MISMATCH_DATA ".concat([
                            ...allowedInstanceTypes
                        ].join(", ")));
                    }
                    if (allowedInstanceTypes.size === 0 && !allowedDataTypes.has(currentDataType)) throw new Error("TYPE_MISMATCH_DATA ".concat([
                        ...allowedDataTypes
                    ].join(", ")));
                    switch(dataSerializer){
                        case "utf8":
                            // already a string
                            return data;
                        default:
                            // object of some sort (urlencoded or json)
                            return JSON.stringify(data, undefined, 2);
                    }
                }
                function handleMissingOptions(options, ionicHttp) {
                    options = options || {};
                    let serializer;
                    let data = options.data;
                    try {
                        // need to check special case if data type is not handled by LR but otherwise valid
                        serializer = checkForValidStringValue(VALID_SERIALIZERS, options.serializer || ionicHttp.getDataSerializer(), "serializer / data payload type");
                    } catch (_unused) {
                        // if this fails it's of entirely invalid type, let it fail
                        serializer = checkForValidStringValue(UNSUPPORTED_SERIALIZERS, options.serializer || ionicHttp.getDataSerializer(), "serializer / data payload type");
                        // is of a valid but unsupported to LR type, set data to empty
                        data = {};
                    }
                    return {
                        data: data,
                        filePath: options.filePath,
                        followRedirect: options.followRedirect,
                        headers: checkKeyValuePairObject(options.headers || {}, STRING_SET, "Invalid header type, must be string"),
                        method: checkForValidStringValue(VALID_HTTP_METHODS, options.method || VALID_HTTP_METHODS[0], "method"),
                        name: options.name,
                        params: checkKeyValuePairObject(options.params || {}, STRING_ARRAY_SET, "Invalid param, must be of type string or array"),
                        responseType: options.responseType,
                        serializer: serializer,
                        connectTimeout: options.connectTimeout,
                        readTimeout: options.readTimeout,
                        timeout: options.timeout
                    };
                }
                let ionicIdCounter = 0;
                function registerIonic(_ref) {
                    var _cordova, _window$ionic;
                    let { addRequest: addRequest, addResponse: addResponse, isIgnored: isIgnored } = _ref;
                    const ionicHttp = (_cordova = window.cordova) === null || _cordova === void 0 || (_cordova = _cordova.plugin) === null || _cordova === void 0 ? void 0 : _cordova.http;
                    let ionicMap = {};
                    let unsubscribedFromIonic = false;
                    if (typeof ionicHttp === "undefined") // Plugin does not exist! Empty uninstall hook.
                    return ()=>{};
                    const platforms = (_window$ionic = window.ionic) === null || _window$ionic === void 0 ? void 0 : _window$ionic.platforms;
                    if (typeof platforms !== "undefined" && typeof platforms.some === "function" && platforms.some((e)=>UNSUPPORTED_PLATFORMS.has(e))) // We appear to be running in a web browser, do not hook and let XHR wrap instead.
                    return ()=>{};
                    const originalSendRequest = ionicHttp.sendRequest;
                    const handleResponse = (0, _protectFunc.default)((response, isSuccess, ionicReqId)=>{
                        if (!isIgnored("".concat(LOGROCKET_IONIC_LABEL).concat(ionicReqId))) try {
                            const responseHash = {
                                url: response.url || "",
                                status: response.status < 600 && response.status >= 100 ? response.status : 0,
                                headers: response.headers || {},
                                body: isSuccess ? response.data : response.error,
                                method: ionicMap[ionicReqId].toUpperCase()
                            };
                            addResponse("".concat(LOGROCKET_IONIC_LABEL).concat(ionicReqId), responseHash);
                        } catch (err) {
                            const responseHash = {
                                url: response.url || "",
                                status: response.status < 600 && response.status >= 100 ? response.status : 0,
                                headers: response.headers || {},
                                body: "LogRocket fetch error: ".concat(err.message),
                                method: ionicMap[ionicReqId].toUpperCase()
                            };
                            addResponse("".concat(LOGROCKET_IONIC_LABEL).concat(ionicReqId), responseHash);
                        }
                         // Otherwise, don't even try to read ignored / unsubscribed requests
                    });
                    ionicHttp.sendRequest = (url, options, success, failure)=>{
                        const currentId = ++ionicIdCounter;
                        const ourSuccessHandler = (response)=>{
                            if (!unsubscribedFromIonic) {
                                handleResponse(response, true, currentId);
                                delete ionicMap[currentId];
                            }
                            success(response);
                        };
                        const ourFailureHandler = (response)=>{
                            if (!unsubscribedFromIonic) {
                                handleResponse(response, false, currentId);
                                delete ionicMap[currentId];
                            }
                            failure(response);
                        };
                        if (!unsubscribedFromIonic) try {
                            // will throw just like identical ionic code if input is invalid
                            const modifiedOptions = handleMissingOptions(options, ionicHttp);
                            const modifiedUrl = appendQueryParamsString(url, serializeObject("", modifiedOptions.params, true));
                            // need to minic behavior of Ionic API by adding global headers
                            const mergedHeaders = getMergedHeaders(url, modifiedOptions.headers, ionicHttp);
                            // ionic APIs default to get method
                            const method = modifiedOptions.method || "get";
                            ionicMap[currentId] = method;
                            const requestHash = {
                                url: modifiedUrl,
                                method: method.toUpperCase(),
                                headers: mergedHeaders || {},
                                // only applicable on post, put or patch methods
                                body: processData(modifiedOptions.data || {}, modifiedOptions.serializer),
                                initiatorType: "IONIC"
                            };
                            addRequest("".concat(LOGROCKET_IONIC_LABEL).concat(currentId), requestHash);
                        } catch (err) {
                            const requestHash = {
                                url: url,
                                method: (options.method || "get").toUpperCase(),
                                headers: {},
                                body: "LogRocket fetch error: ".concat(err.message),
                                initiatorType: "IONIC"
                            };
                            addRequest("".concat(LOGROCKET_IONIC_LABEL).concat(currentId), requestHash);
                        }
                        return originalSendRequest(url, options, ourSuccessHandler, ourFailureHandler);
                    };
                    return ()=>{
                        unsubscribedFromIonic = true;
                        ionicHttp.sendRequest = originalSendRequest;
                        ionicMap = {};
                    };
                }
            /***/ },
            /***/ "./packages/@logrocket/network/src/registerNetworkInformation.js": /*!***********************************************************************!*\
  !*** ./packages/@logrocket/network/src/registerNetworkInformation.js ***!
  \***********************************************************************/ /***/ function(__unused_webpack_module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = registerNetworkInformation;
                const EFFECTIVE_TYPE_VALS = {
                    "slow-2g": "SLOW2G",
                    "2g": "TWOG",
                    "3g": "THREEG",
                    "4g": "FOURG"
                };
                function registerNetworkInformation(logger) {
                    let lastStatus = undefined;
                    function sendNetworkInformation() {
                        const newStatus = {
                            online: window.navigator.onLine,
                            effectiveType: "UNKOWN"
                        };
                        if (!window.navigator.onLine) newStatus.effectiveType = "NONE";
                        else if (window.navigator.connection && window.navigator.connection.effectiveType) newStatus.effectiveType = EFFECTIVE_TYPE_VALS[window.navigator.connection.effectiveType] || "UNKNOWN";
                        if (lastStatus && newStatus.online === lastStatus.online && newStatus.effectiveType === lastStatus.effectiveType) return;
                        lastStatus = newStatus;
                        logger.addEvent("lr.network.NetworkStatusEvent", function() {
                            let { isEnabled: isEnabled = true } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                            if (!isEnabled) return null;
                            return newStatus;
                        });
                    }
                    setTimeout(sendNetworkInformation);
                    if (window.navigator.connection && typeof window.navigator.connection.addEventListener === "function") window.navigator.connection.addEventListener("change", sendNetworkInformation);
                    window.addEventListener("online", sendNetworkInformation);
                    window.addEventListener("offline", sendNetworkInformation);
                    return ()=>{
                        window.removeEventListener("offline", sendNetworkInformation);
                        window.removeEventListener("online", sendNetworkInformation);
                        if (window.navigator.connection && typeof window.navigator.connection.removeEventListener === "function") window.navigator.connection.removeEventListener("change", sendNetworkInformation);
                    };
                }
            /***/ },
            /***/ "./packages/@logrocket/network/src/registerXHR.js": /*!********************************************************!*\
  !*** ./packages/@logrocket/network/src/registerXHR.js ***!
  \********************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = registerXHR;
                exports.setActive = setActive;
                var _mapValues = _interopRequireDefault(__webpack_require__(/*! @logrocket/utils/src/mapValues */ "./packages/@logrocket/utils/src/mapValues.ts"));
                var _enhanceFunc = _interopRequireDefault(__webpack_require__(/*! @logrocket/utils/src/enhanceFunc */ "./packages/@logrocket/utils/src/enhanceFunc.ts"));
                var _protectFunc = _interopRequireDefault(__webpack_require__(/*! @logrocket/utils/src/protectFunc */ "./packages/@logrocket/utils/src/protectFunc.ts"));
                var _nps = __webpack_require__(/*! @logrocket/utils/src/constants/nps */ "./packages/@logrocket/utils/src/constants/nps.js");
                var _statusCodes = __webpack_require__(/*! @logrocket/utils/src/constants/statusCodes */ "./packages/@logrocket/utils/src/constants/statusCodes.ts");
                var _parseRawHeaders = __webpack_require__(/*! @logrocket/utils/src/parseRawHeaders */ "./packages/@logrocket/utils/src/parseRawHeaders.ts");
                let isActive = true;
                function setActive(shouldBeActive) {
                    isActive = shouldBeActive;
                }
                let currentXHRId = 0;
                function registerXHR(_ref) {
                    let { addRequest: addRequest, addResponse: addResponse, isIgnored: isIgnored, logger: logger, shouldAugmentNPS: shouldAugmentNPS = true, shouldParseXHRBlob: shouldParseXHRBlob = false } = _ref;
                    const _XHR = XMLHttpRequest;
                    const xhrMap = new WeakMap();
                    let unsubscribedFromXhr = false;
                    const LOGROCKET_XHR_LABEL = "xhr-";
                    window._lrXMLHttpRequest = XMLHttpRequest;
                    XMLHttpRequest = function XMLHttpRequest1(mozAnon, mozSystem) {
                        const xhrObject = new _XHR(mozAnon, mozSystem);
                        if (!isActive) return xhrObject;
                        xhrMap.set(xhrObject, {
                            xhrId: ++currentXHRId,
                            requestHeaders: {},
                            sent: false,
                            done: false
                        });
                        const openOriginal = xhrObject.open;
                        function openShim() {
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                            try {
                                const url = args[1];
                                if (window.URL && typeof window.URL === "function" && url.search(_nps.WOOTRIC_RESPONSES_REGEX) === 0) {
                                    const logrocketSessionURL = new window.URL(logger.recordingURL);
                                    logrocketSessionURL.searchParams.set("nps", "wootric");
                                    const urlObj = new window.URL(url);
                                    const responseText = urlObj.searchParams.get("response[text]");
                                    const feedback = responseText ? "".concat(responseText, "\n\n") : "";
                                    urlObj.searchParams.set("response[text]", "".concat(feedback, "<").concat(logrocketSessionURL.href, "|View LogRocket session>"));
                                    args[1] = urlObj.href;
                                }
                            } catch (e) {
                            /* do nothing */ }
                            return openOriginal.apply(this, args);
                        }
                        const sendOriginal = xhrObject.send;
                        function sendShim() {
                            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                            try {
                                const currentXHR = xhrMap.get(xhrObject);
                                if (window.URL && typeof window.URL === "function" && currentXHR && currentXHR.url && currentXHR.url.search(_nps.DELIGHTED_RESPONSES_REGEX) === 0 && args.length && args[0].indexOf(_nps.DELIGHTED_FEEDBACK_PREFIX) !== -1) {
                                    const recordingURL = new window.URL(logger.recordingURL);
                                    recordingURL.searchParams.set("nps", "delighted");
                                    const logrocketSessionURL = encodeURIComponent(recordingURL.href);
                                    const data = args[0].split("&").map((dataString)=>{
                                        if (dataString.startsWith(_nps.DELIGHTED_FEEDBACK_PREFIX)) {
                                            const isEmpty = dataString === _nps.DELIGHTED_FEEDBACK_PREFIX;
                                            return "".concat(dataString).concat(isEmpty ? "" : "\n\n", "<").concat(logrocketSessionURL, "|View LogRocket session>");
                                        }
                                        return dataString;
                                    }).join("&");
                                    args[0] = data;
                                }
                            } catch (e) {
                            /* do nothing */ }
                            return sendOriginal.apply(this, args);
                        }
                        if (shouldAugmentNPS) {
                            xhrObject.open = openShim;
                            xhrObject.send = sendShim;
                        }
                        const captureResponse = ()=>{
                            var _window$navigator;
                            if (unsubscribedFromXhr) return;
                            const currentXHR = xhrMap.get(xhrObject);
                            if (!currentXHR || isIgnored("".concat(LOGROCKET_XHR_LABEL).concat(currentXHR.xhrId))) return;
                            if (!currentXHR.sent || !currentXHR.done) // Don't capture the response if we haven't yet captured the request, or if we haven't received the response.
                            // The flow of events is different for async and sync requests.
                            // Async requests:
                            //   1. open
                            //   2. original send
                            //   3. our send enhancer (captures request)
                            //   4. loadstart
                            //   5. readyStateChange(readyState: 4)
                            //   6. load, abort, error, or timeout
                            //   7. loadend (captures response)
                            // Sync requests:
                            //   1. open
                            //   2. original send
                            //   3. loadstart
                            //   4. readyStateChange(readyState: 4)
                            //   5. load, abort, error, or timeout
                            //   6. loadend
                            //   7. our send enhancer (captures request and response)
                            return;
                            let status = currentXHR.status || _statusCodes.XHR_CUSTOM_STATUS_CODES.error;
                            if (status === _statusCodes.XHR_CUSTOM_STATUS_CODES.error && ((_window$navigator = window.navigator) === null || _window$navigator === void 0 ? void 0 : _window$navigator.onLine) === false) // requests to localhost can still succeed when offline
                            status = _statusCodes.XHR_CUSTOM_STATUS_CODES.offline;
                            const response = {
                                url: currentXHR.url,
                                status: status,
                                headers: currentXHR.responseHeaders,
                                body: currentXHR.responseBody,
                                method: (currentXHR.method || "").toUpperCase()
                            };
                            if (shouldParseXHRBlob && response.body instanceof Blob) {
                                const blobReader = new FileReader();
                                blobReader.readAsText(response.body);
                                blobReader.onload = function() {
                                    try {
                                        response.body = JSON.parse(blobReader.result);
                                    } catch (_unused) {} // eslint-disable-line no-empty
                                    addResponse("".concat(LOGROCKET_XHR_LABEL).concat(currentXHR.xhrId), response);
                                };
                            } else addResponse("".concat(LOGROCKET_XHR_LABEL).concat(currentXHR.xhrId), response);
                        };
                        // ..., 'open', (method, url, async, username, password) => {
                        (0, _enhanceFunc.default)(xhrObject, "open", (0, _protectFunc.default)((method, url)=>{
                            if (unsubscribedFromXhr) return;
                            const currentXHR = xhrMap.get(xhrObject);
                            currentXHR.method = method;
                            currentXHR.url = url;
                        }));
                        (0, _enhanceFunc.default)(xhrObject, "send", (0, _protectFunc.default)((data)=>{
                            if (unsubscribedFromXhr) return;
                            const currentXHR = xhrMap.get(xhrObject);
                            if (!currentXHR) return;
                            const request = {
                                url: currentXHR.url,
                                method: currentXHR.method && currentXHR.method.toUpperCase(),
                                headers: (0, _mapValues.default)(currentXHR.requestHeaders || {}, (headerValues)=>{
                                    return headerValues.join(", ");
                                }),
                                body: data,
                                initiatorType: "XHR"
                            };
                            addRequest("".concat(LOGROCKET_XHR_LABEL).concat(currentXHR.xhrId), request);
                            currentXHR.sent = true;
                            // Attempt to capture the response event for synchronous requests
                            captureResponse();
                        }));
                        (0, _enhanceFunc.default)(xhrObject, "setRequestHeader", (0, _protectFunc.default)((header, value)=>{
                            if (unsubscribedFromXhr) return;
                            const currentXHR = xhrMap.get(xhrObject);
                            if (!currentXHR) return;
                            currentXHR.requestHeaders = currentXHR.requestHeaders || {};
                            currentXHR.requestHeaders[header] = currentXHR.requestHeaders[header] || [];
                            currentXHR.requestHeaders[header].push(value);
                        }));
                        const xhrListeners = {
                            readystatechange: (0, _protectFunc.default)(()=>{
                                if (unsubscribedFromXhr) return;
                                if (xhrObject.readyState === 4) {
                                    const currentXHR = xhrMap.get(xhrObject);
                                    if (!currentXHR) return;
                                    // Do not read ignored requests at all.
                                    if (isIgnored("".concat(LOGROCKET_XHR_LABEL).concat(currentXHR.xhrId))) return;
                                    const headerString = xhrObject.getAllResponseHeaders() || "";
                                    currentXHR.responseHeaders = (0, _parseRawHeaders.parseRawHeaders)(headerString);
                                    let body;
                                    try {
                                        switch(xhrObject.responseType){
                                            case "json":
                                                body = logger._shouldCloneResponse ? JSON.parse(JSON.stringify(xhrObject.response)) : xhrObject.response;
                                                break;
                                            case "arraybuffer":
                                            case "blob":
                                                if (shouldParseXHRBlob) body = xhrObject.response;
                                                else body = "LogRocket skipped consuming a binary body.";
                                                break;
                                            case "document":
                                                body = xhrObject.responseXML;
                                                break;
                                            case "text":
                                            case "":
                                                body = xhrObject.responseText;
                                                break;
                                            default:
                                                body = "";
                                        }
                                    } catch (err) {
                                        body = "LogRocket: Error accessing response.";
                                    }
                                    currentXHR.responseBody = body;
                                    currentXHR.status = xhrObject.status;
                                    currentXHR.done = true;
                                }
                            }),
                            abort: (0, _protectFunc.default)(()=>{
                                const currentXHR = xhrMap.get(xhrObject);
                                if (currentXHR) currentXHR.status = _statusCodes.XHR_CUSTOM_STATUS_CODES.aborted;
                            }),
                            timeout: (0, _protectFunc.default)(()=>{
                                const currentXHR = xhrMap.get(xhrObject);
                                if (currentXHR) currentXHR.status = _statusCodes.XHR_CUSTOM_STATUS_CODES.timeout;
                            }),
                            loadend: (0, _protectFunc.default)(()=>{
                                captureResponse();
                            })
                        };
                        Object.keys(xhrListeners).forEach((key)=>{
                            xhrObject.addEventListener(key, xhrListeners[key]);
                        });
                        return xhrObject;
                    };
                    // this allows "instanceof XMLHttpRequest" to work
                    XMLHttpRequest.prototype = _XHR.prototype;
                    // Persist the static variables.
                    [
                        "UNSENT",
                        "OPENED",
                        "HEADERS_RECEIVED",
                        "LOADING",
                        "DONE"
                    ].forEach((variable)=>{
                        XMLHttpRequest[variable] = _XHR[variable];
                    });
                    return ()=>{
                        unsubscribedFromXhr = true;
                        XMLHttpRequest = _XHR;
                    };
                }
            /***/ },
            /***/ "./packages/@logrocket/now/src/index.ts": /*!**********************************************!*\
  !*** ./packages/@logrocket/now/src/index.ts ***!
  \**********************************************/ /***/ function(__unused_webpack_module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = void 0;
                const dateNow = Date.now.bind(Date);
                const loadTime = dateNow();
                var _default = exports["default"] = typeof performance !== "undefined" && performance.now ? performance.now.bind(performance) : ()=>dateNow() - loadTime;
            /***/ },
            /***/ "./packages/@logrocket/redux/src/createEnhancer.js": /*!*********************************************************!*\
  !*** ./packages/@logrocket/redux/src/createEnhancer.js ***!
  \*********************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = createEnhancer;
                var _defineProperty2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/defineProperty.js"));
                var _now = _interopRequireDefault(__webpack_require__(/*! @logrocket/now */ "./packages/@logrocket/now/src/index.ts"));
                function ownKeys(e, r) {
                    var t = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var o = Object.getOwnPropertySymbols(e);
                        r && (o = o.filter(function(r) {
                            return Object.getOwnPropertyDescriptor(e, r).enumerable;
                        })), t.push.apply(t, o);
                    }
                    return t;
                }
                function _objectSpread(e) {
                    for(var r = 1; r < arguments.length; r++){
                        var t = null != arguments[r] ? arguments[r] : {};
                        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
                            (0, _defineProperty2.default)(e, r, t[r]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
                            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
                        });
                    }
                    return e;
                }
                let storeIdCounter = 0;
                function createEnhancer(logger) {
                    let { stateSanitizer: stateSanitizer = (f)=>f, actionSanitizer: actionSanitizer = (f)=>f } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    // an enhancer is a function that returns a Store
                    return (createStore)=>(reducer, initialState, enhancer)=>{
                            const store = createStore(reducer, initialState, enhancer);
                            const originalDispatch = store.dispatch;
                            const storeId = storeIdCounter++;
                            logger.addEvent("lr.redux.InitialState", ()=>{
                                let sanitizedState;
                                try {
                                    // only try catch user defined functions
                                    sanitizedState = stateSanitizer(store.getState());
                                } catch (err) {
                                    console.error(err.toString());
                                }
                                return {
                                    state: sanitizedState,
                                    storeId: storeId
                                };
                            });
                            const dispatch = (action)=>{
                                const start = (0, _now.default)();
                                let err;
                                let res;
                                try {
                                    res = originalDispatch(action);
                                } catch (_err) {
                                    err = _err;
                                } finally{
                                    const duration = (0, _now.default)() - start;
                                    logger.addEvent("lr.redux.ReduxAction", ()=>{
                                        let sanitizedState = null;
                                        let sanitizedAction = null;
                                        try {
                                            // only try catch user defined functions
                                            sanitizedState = stateSanitizer(store.getState());
                                            sanitizedAction = actionSanitizer(action);
                                        // eslint-disable-next-line @typescript-eslint/no-shadow
                                        } catch (err) {
                                            console.error(err.toString());
                                        }
                                        if (sanitizedState && sanitizedAction) return {
                                            storeId: storeId,
                                            action: sanitizedAction,
                                            duration: duration,
                                            stateDelta: sanitizedState
                                        };
                                        return null;
                                    });
                                }
                                if (err) throw err;
                                return res;
                            };
                            return _objectSpread(_objectSpread({}, store), {}, {
                                dispatch: dispatch
                            });
                        };
                }
            /***/ },
            /***/ "./packages/@logrocket/redux/src/createMiddleware.js": /*!***********************************************************!*\
  !*** ./packages/@logrocket/redux/src/createMiddleware.js ***!
  \***********************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = createMiddleware;
                var _now = _interopRequireDefault(__webpack_require__(/*! @logrocket/now */ "./packages/@logrocket/now/src/index.ts"));
                let storeIdCounter = 0;
                function createMiddleware(logger) {
                    let { stateSanitizer: stateSanitizer = (f)=>f, actionSanitizer: actionSanitizer = (f)=>f } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    return (store)=>{
                        const storeId = storeIdCounter++;
                        logger.addEvent("lr.redux.InitialState", ()=>{
                            let sanitizedState;
                            try {
                                // only try catch user defined functions
                                sanitizedState = stateSanitizer(store.getState());
                            } catch (err) {
                                console.error(err.toString());
                            }
                            return {
                                state: sanitizedState,
                                storeId: storeId
                            };
                        });
                        return (next)=>(action)=>{
                                const start = (0, _now.default)();
                                let err;
                                let res;
                                try {
                                    res = next(action);
                                } catch (_err) {
                                    err = _err;
                                } finally{
                                    const duration = (0, _now.default)() - start;
                                    logger.addEvent("lr.redux.ReduxAction", ()=>{
                                        let sanitizedState = null;
                                        let sanitizedAction = null;
                                        try {
                                            // only try catch user defined functions
                                            sanitizedState = stateSanitizer(store.getState());
                                            sanitizedAction = actionSanitizer(action);
                                        // eslint-disable-next-line @typescript-eslint/no-shadow
                                        } catch (err) {
                                            console.error(err.toString());
                                        }
                                        if (sanitizedState && sanitizedAction) return {
                                            storeId: storeId,
                                            action: sanitizedAction,
                                            duration: duration,
                                            stateDelta: sanitizedState
                                        };
                                        return null;
                                    });
                                }
                                if (err) throw err;
                                return res;
                            };
                    };
                }
            /***/ },
            /***/ "./packages/@logrocket/redux/src/index.ts": /*!************************************************!*\
  !*** ./packages/@logrocket/redux/src/index.ts ***!
  \************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                Object.defineProperty(exports, "createEnhancer", {
                    enumerable: true,
                    get: function() {
                        return _createEnhancer.default;
                    }
                });
                Object.defineProperty(exports, "createMiddleware", {
                    enumerable: true,
                    get: function() {
                        return _createMiddleware.default;
                    }
                });
                var _createEnhancer = _interopRequireDefault(__webpack_require__(/*! ./createEnhancer */ "./packages/@logrocket/redux/src/createEnhancer.js"));
                var _createMiddleware = _interopRequireDefault(__webpack_require__(/*! ./createMiddleware */ "./packages/@logrocket/redux/src/createMiddleware.js"));
            /***/ },
            /***/ "./packages/@logrocket/utils/src/TraceKit.js": /*!***************************************************!*\
  !*** ./packages/@logrocket/utils/src/TraceKit.js ***!
  \***************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                /* eslint-disable */ /*
 TraceKit - Cross browser stack traces - github.com/occ/TraceKit

 This was originally forked from github.com/occ/TraceKit, but has since been
 largely re-written and is now maintained as part of raven-js.  Tests for
 this are in test/vendor.

 MIT license
*/ Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = void 0;
                var TraceKit = {
                    collectWindowErrors: true,
                    debug: false
                };
                // This is to be defensive in environments where window does not exist (see https://github.com/getsentry/raven-js/pull/785)
                var _window = typeof window !== "undefined" ? window : typeof __webpack_require__.g !== "undefined" ? __webpack_require__.g : typeof self !== "undefined" ? self : {};
                // global reference to slice
                var _slice = [].slice;
                var UNKNOWN_FUNCTION = "?";
                // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Error_types
                var ERROR_TYPES_RE = /^(?:Uncaught (?:exception: )?)?((?:Eval|Internal|Range|Reference|Syntax|Type|URI)Error): ?(.*)$/;
                function getLocationHref() {
                    if (typeof document === "undefined" || typeof document.location === "undefined") return "";
                    return document.location.href;
                }
                /**
 * TraceKit.report: cross-browser processing of unhandled exceptions
 *
 * Syntax:
 *   TraceKit.report.subscribe(function(stackInfo) { ... })
 *   TraceKit.report.unsubscribe(function(stackInfo) { ... })
 *   TraceKit.report(exception)
 *   try { ...code... } catch(ex) { TraceKit.report(ex); }
 *
 * Supports:
 *   - Firefox: full stack trace with line numbers, plus column number
 *              on top frame; column number is not guaranteed
 *   - Opera:   full stack trace with line and column numbers
 *   - Chrome:  full stack trace with line and column numbers
 *   - Safari:  line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *   - IE:      line and column number for the top frame only; some frames
 *              may be missing, and column number is not guaranteed
 *
 * In theory, TraceKit should work on all of the following versions:
 *   - IE5.5+ (only 8.0 tested)
 *   - Firefox 0.9+ (only 3.5+ tested)
 *   - Opera 7+ (only 10.50 tested; versions 9 and earlier may require
 *     Exceptions Have Stacktrace to be enabled in opera:config)
 *   - Safari 3+ (only 4+ tested)
 *   - Chrome 1+ (only 5+ tested)
 *   - Konqueror 3.5+ (untested)
 *
 * Requires TraceKit.computeStackTrace.
 *
 * Tries to catch all unhandled exceptions and report them to the
 * subscribed handlers. Please note that TraceKit.report will rethrow the
 * exception. This is REQUIRED in order to get a useful stack trace in IE.
 * If the exception does not reach the top of the browser, you will only
 * get a stack trace from the point where TraceKit.report was called.
 *
 * Handlers receive a stackInfo object as described in the
 * TraceKit.computeStackTrace docs.
 */ TraceKit.report = function reportModuleWrapper() {
                    var handlers = [], lastArgs = null, lastException = null, lastExceptionStack = null;
                    /**
   * Add a crash handler.
   * @param {Function} handler
   */ function subscribe(handler) {
                        installGlobalHandler();
                        handlers.push(handler);
                    }
                    /**
   * Remove a crash handler.
   * @param {Function} handler
   */ function unsubscribe(handler) {
                        for(var i = handlers.length - 1; i >= 0; --i)if (handlers[i] === handler) handlers.splice(i, 1);
                    }
                    /**
   * Remove all crash handlers.
   */ function unsubscribeAll() {
                        uninstallGlobalHandler();
                        handlers = [];
                    }
                    /**
   * Dispatch stack information to all handlers.
   * @param {Object.<string, *>} stack
   */ function notifyHandlers(stack, isWindowError) {
                        var exception = null;
                        if (isWindowError && !TraceKit.collectWindowErrors) return;
                        for(var i in handlers){
                            if (handlers.hasOwnProperty(i)) try {
                                handlers[i].apply(null, [
                                    stack
                                ].concat(_slice.call(arguments, 2)));
                            } catch (inner) {
                                exception = inner;
                            }
                        }
                        if (exception) throw exception;
                    }
                    var _oldOnerrorHandler, _onErrorHandlerInstalled;
                    /**
   * Ensures all global unhandled exceptions are recorded.
   * Supported by Gecko and IE.
   * @param {string} message Error message.
   * @param {string} url URL of script that generated the exception.
   * @param {(number|string)} lineNo The line number at which the error
   * occurred.
   * @param {?(number|string)} colNo The column number at which the error
   * occurred.
   * @param {?Error} ex The actual Error object.
   */ function traceKitWindowOnError(message, url, lineNo, colNo, ex) {
                        var stack = null;
                        if (lastExceptionStack) {
                            TraceKit.computeStackTrace.augmentStackTraceWithInitialElement(lastExceptionStack, url, lineNo, message);
                            processLastException();
                        } else if (ex) {
                            // New chrome and blink send along a real error object
                            // Let's just report that like a normal error.
                            // See: https://mikewest.org/2013/08/debugging-runtime-errors-with-window-onerror
                            stack = TraceKit.computeStackTrace(ex);
                            notifyHandlers(stack, true);
                        } else {
                            var location1 = {
                                url: url,
                                line: lineNo,
                                column: colNo
                            };
                            var name = undefined;
                            var msg = message; // must be new var or will modify original `arguments`
                            var groups;
                            if (({}).toString.call(message) === "[object String]") {
                                var groups = message.match(ERROR_TYPES_RE);
                                if (groups) {
                                    name = groups[1];
                                    msg = groups[2];
                                }
                            }
                            location1.func = UNKNOWN_FUNCTION;
                            stack = {
                                name: name,
                                message: msg,
                                url: getLocationHref(),
                                stack: [
                                    location1
                                ]
                            };
                            notifyHandlers(stack, true);
                        }
                        if (_oldOnerrorHandler) return _oldOnerrorHandler.apply(this, arguments);
                        return false;
                    }
                    function installGlobalHandler() {
                        if (_onErrorHandlerInstalled) return;
                        _oldOnerrorHandler = _window.onerror;
                        _window.onerror = traceKitWindowOnError;
                        _onErrorHandlerInstalled = true;
                    }
                    function uninstallGlobalHandler() {
                        if (!_onErrorHandlerInstalled) return;
                        _window.onerror = _oldOnerrorHandler;
                        _onErrorHandlerInstalled = false;
                        _oldOnerrorHandler = undefined;
                    }
                    function processLastException() {
                        var _lastExceptionStack = lastExceptionStack, _lastArgs = lastArgs;
                        lastArgs = null;
                        lastExceptionStack = null;
                        lastException = null;
                        notifyHandlers.apply(null, [
                            _lastExceptionStack,
                            false
                        ].concat(_lastArgs));
                    }
                    /**
   * Reports an unhandled Error to TraceKit.
   * @param {Error} ex
   * @param {?boolean} rethrow If false, do not re-throw the exception.
   * Only used for window.onerror to not cause an infinite loop of
   * rethrowing.
   */ function report(ex, rethrow) {
                        var args = _slice.call(arguments, 1);
                        if (lastExceptionStack) {
                            if (lastException === ex) return; // already caught by an inner catch block, ignore
                            else processLastException();
                        }
                        var stack = TraceKit.computeStackTrace(ex);
                        lastExceptionStack = stack;
                        lastException = ex;
                        lastArgs = args;
                        // If the stack trace is incomplete, wait for 2 seconds for
                        // slow slow IE to see if onerror occurs or not before reporting
                        // this exception; otherwise, we will end up with an incomplete
                        // stack trace
                        setTimeout(function() {
                            if (lastException === ex) processLastException();
                        }, stack.incomplete ? 2000 : 0);
                        if (rethrow !== false) throw ex; // re-throw to propagate to the top level (and cause window.onerror)
                    }
                    report.subscribe = subscribe;
                    report.unsubscribe = unsubscribe;
                    report.uninstall = unsubscribeAll;
                    return report;
                }();
                /**
 * TraceKit.computeStackTrace: cross-browser stack traces in JavaScript
 *
 * Syntax:
 *   s = TraceKit.computeStackTrace(exception) // consider using TraceKit.report instead (see below)
 * Returns:
 *   s.name              - exception name
 *   s.message           - exception message
 *   s.stack[i].url      - JavaScript or HTML file URL
 *   s.stack[i].func     - function name, or empty for anonymous functions (if guessing did not work)
 *   s.stack[i].args     - arguments passed to the function, if known
 *   s.stack[i].line     - line number, if known
 *   s.stack[i].column   - column number, if known
 *
 * Supports:
 *   - Firefox:  full stack trace with line numbers and unreliable column
 *               number on top frame
 *   - Opera 10: full stack trace with line and column numbers
 *   - Opera 9-: full stack trace with line numbers
 *   - Chrome:   full stack trace with line and column numbers
 *   - Safari:   line and column number for the topmost stacktrace element
 *               only
 *   - IE:       no line numbers whatsoever
 *
 * Tries to guess names of anonymous functions by looking for assignments
 * in the source code. In IE and Safari, we have to guess source file names
 * by searching for function bodies inside all page scripts. This will not
 * work for scripts that are loaded cross-domain.
 * Here be dragons: some function names may be guessed incorrectly, and
 * duplicate functions may be mismatched.
 *
 * TraceKit.computeStackTrace should only be used for tracing purposes.
 * Logging of unhandled exceptions should be done with TraceKit.report,
 * which builds on top of TraceKit.computeStackTrace and provides better
 * IE support by utilizing the window.onerror event to retrieve information
 * about the top of the stack.
 *
 * Note: In IE and Safari, no stack trace is recorded on the Error object,
 * so computeStackTrace instead walks its *own* chain of callers.
 * This means that:
 *  * in Safari, some methods may be missing from the stack trace;
 *  * in IE, the topmost function in the stack trace will always be the
 *    caller of computeStackTrace.
 *
 * This is okay for tracing (because you are likely to be calling
 * computeStackTrace from the function you want to be the topmost element
 * of the stack trace anyway), but not okay for logging unhandled
 * exceptions (because your catch block will likely be far away from the
 * inner function that actually caused the exception).
 *
 */ TraceKit.computeStackTrace = function computeStackTraceWrapper() {
                    /**
   * Escapes special characters, except for whitespace, in a string to be
   * used inside a regular expression as a string literal.
   * @param {string} text The string.
   * @return {string} The escaped string literal.
   */ function escapeRegExp(text) {
                        return text.replace(/[\-\[\]{}()*+?.,\\\^$|#]/g, "\\$&");
                    }
                    /**
   * Escapes special characters in a string to be used inside a regular
   * expression as a string literal. Also ensures that HTML entities will
   * be matched the same as their literal friends.
   * @param {string} body The string.
   * @return {string} The escaped string.
   */ function escapeCodeAsRegExpForMatchingInsideHTML(body) {
                        return escapeRegExp(body).replace("<", "(?:<|&lt;)").replace(">", "(?:>|&gt;)").replace("&", "(?:&|&amp;)").replace('"', '(?:"|&quot;)').replace(/\s+/g, "\\s+");
                    }
                    // Contents of Exception in various browsers.
                    //
                    // SAFARI:
                    // ex.message = Can't find variable: qq
                    // ex.line = 59
                    // ex.sourceId = 580238192
                    // ex.sourceURL = http://...
                    // ex.expressionBeginOffset = 96
                    // ex.expressionCaretOffset = 98
                    // ex.expressionEndOffset = 98
                    // ex.name = ReferenceError
                    //
                    // FIREFOX:
                    // ex.message = qq is not defined
                    // ex.fileName = http://...
                    // ex.lineNumber = 59
                    // ex.columnNumber = 69
                    // ex.stack = ...stack trace... (see the example below)
                    // ex.name = ReferenceError
                    //
                    // CHROME:
                    // ex.message = qq is not defined
                    // ex.name = ReferenceError
                    // ex.type = not_defined
                    // ex.arguments = ['aa']
                    // ex.stack = ...stack trace...
                    //
                    // INTERNET EXPLORER:
                    // ex.message = ...
                    // ex.name = ReferenceError
                    //
                    // OPERA:
                    // ex.message = ...message... (see the example below)
                    // ex.name = ReferenceError
                    // ex.opera#sourceloc = 11  (pretty much useless, duplicates the info in ex.message)
                    // ex.stacktrace = n/a; see 'opera:config#UserPrefs|Exceptions Have Stacktrace'
                    /**
   * Computes stack trace information from the stack property.
   * Chrome and Gecko use this property.
   * @param {Error} ex
   * @return {?Object.<string, *>} Stack trace information.
   */ function computeStackTraceFromStackProp(ex) {
                        if (typeof ex.stack === "undefined" || !ex.stack) return;
                        var chrome = /^\s*at (.*?) ?\(((?:file|https?|blob|chrome-extension|native|eval|<anonymous>).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i, gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)((?:file|https?|blob|chrome|resource|\[native).*?)(?::(\d+))?(?::(\d+))?\s*$/i, winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i, lines = ex.stack.split("\n"), stack = [], parts, element, reference = /^(.*) is undefined$/.exec(ex.message);
                        for(var i = 0, j = lines.length; i < j; ++i){
                            if (parts = chrome.exec(lines[i])) {
                                var isNative = parts[2] && parts[2].indexOf("native") !== -1;
                                element = {
                                    url: !isNative ? parts[2] : null,
                                    func: parts[1] || UNKNOWN_FUNCTION,
                                    args: isNative ? [
                                        parts[2]
                                    ] : [],
                                    line: parts[3] ? +parts[3] : null,
                                    column: parts[4] ? +parts[4] : null
                                };
                            } else if (parts = winjs.exec(lines[i])) element = {
                                url: parts[2],
                                func: parts[1] || UNKNOWN_FUNCTION,
                                args: [],
                                line: +parts[3],
                                column: parts[4] ? +parts[4] : null
                            };
                            else if (parts = gecko.exec(lines[i])) element = {
                                url: parts[3],
                                func: parts[1] || UNKNOWN_FUNCTION,
                                args: parts[2] ? parts[2].split(",") : [],
                                line: parts[4] ? +parts[4] : null,
                                column: parts[5] ? +parts[5] : null
                            };
                            else continue;
                            if (!element.func && element.line) element.func = UNKNOWN_FUNCTION;
                            stack.push(element);
                        }
                        if (!stack.length) return null;
                        if (!stack[0].column && typeof ex.columnNumber !== "undefined") // FireFox uses this awesome columnNumber property for its top frame
                        // Also note, Firefox's column number is 0-based and everything else expects 1-based,
                        // so adding 1
                        stack[0].column = ex.columnNumber + 1;
                        return {
                            name: ex.name,
                            message: ex.message,
                            url: getLocationHref(),
                            stack: stack
                        };
                    }
                    /**
   * Adds information about the first frame to incomplete stack traces.
   * Safari and IE require this to get complete data on the first frame.
   * @param {Object.<string, *>} stackInfo Stack trace information from
   * one of the compute* methods.
   * @param {string} url The URL of the script that caused an error.
   * @param {(number|string)} lineNo The line number of the script that
   * caused an error.
   * @param {string=} message The error generated by the browser, which
   * hopefully contains the name of the object that caused the error.
   * @return {boolean} Whether or not the stack information was
   * augmented.
   */ function augmentStackTraceWithInitialElement(stackInfo, url, lineNo, message) {
                        var initial = {
                            url: url,
                            line: lineNo
                        };
                        if (initial.url && initial.line) {
                            stackInfo.incomplete = false;
                            if (!initial.func) initial.func = UNKNOWN_FUNCTION;
                            if (stackInfo.stack.length > 0) {
                                if (stackInfo.stack[0].url === initial.url) {
                                    if (stackInfo.stack[0].line === initial.line) return false; // already in stack trace
                                    else if (!stackInfo.stack[0].line && stackInfo.stack[0].func === initial.func) {
                                        stackInfo.stack[0].line = initial.line;
                                        return false;
                                    }
                                }
                            }
                            stackInfo.stack.unshift(initial);
                            stackInfo.partial = true;
                            return true;
                        } else stackInfo.incomplete = true;
                        return false;
                    }
                    /**
   * Computes stack trace information by walking the arguments.caller
   * chain at the time the exception occurred. This will cause earlier
   * frames to be missed but is the only way to get any stack trace in
   * Safari and IE. The top frame is restored by
   * {@link augmentStackTraceWithInitialElement}.
   * @param {Error} ex
   * @return {?Object.<string, *>} Stack trace information.
   */ function computeStackTraceByWalkingCallerChain(ex, depth) {
                        var functionName = /function\s+([_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*)?\s*\(/i, stack = [], funcs = {}, recursion = false, parts, item, source;
                        for(var curr = computeStackTraceByWalkingCallerChain.caller; curr && !recursion; curr = curr.caller){
                            if (curr === computeStackTrace || curr === TraceKit.report) continue;
                            item = {
                                url: null,
                                func: UNKNOWN_FUNCTION,
                                line: null,
                                column: null
                            };
                            if (curr.name) item.func = curr.name;
                            else if (parts = functionName.exec(curr.toString())) item.func = parts[1];
                            if (typeof item.func === "undefined") try {
                                item.func = parts.input.substring(0, parts.input.indexOf("{"));
                            } catch (e) {}
                            if (funcs["" + curr]) recursion = true;
                            else funcs["" + curr] = true;
                            stack.push(item);
                        }
                        if (depth) // console.log('depth is ' + depth);
                        // console.log('stack is ' + stack.length);
                        stack.splice(0, depth);
                        var result = {
                            name: ex.name,
                            message: ex.message,
                            url: getLocationHref(),
                            stack: stack
                        };
                        augmentStackTraceWithInitialElement(result, ex.sourceURL || ex.fileName, ex.line || ex.lineNumber, ex.message || ex.description);
                        return result;
                    }
                    /**
   * Computes a stack trace for an exception.
   * @param {Error} ex
   * @param {(string|number)=} depth
   */ function computeStackTrace(ex, depth) {
                        var stack = null;
                        depth = depth == null ? 0 : +depth;
                        try {
                            stack = computeStackTraceFromStackProp(ex);
                            if (stack) return stack;
                        } catch (e) {
                            if (TraceKit.debug) throw e;
                        }
                        try {
                            stack = computeStackTraceByWalkingCallerChain(ex, depth + 1);
                            if (stack) return stack;
                        } catch (e) {
                            if (TraceKit.debug) throw e;
                        }
                        return {
                            name: ex.name,
                            message: ex.message,
                            url: getLocationHref()
                        };
                    }
                    computeStackTrace.augmentStackTraceWithInitialElement = augmentStackTraceWithInitialElement;
                    computeStackTrace.computeStackTraceFromStackProp = computeStackTraceFromStackProp;
                    return computeStackTrace;
                }();
                var _default = exports["default"] = TraceKit;
            /***/ },
            /***/ "./packages/@logrocket/utils/src/constants/nps.js": /*!********************************************************!*\
  !*** ./packages/@logrocket/utils/src/constants/nps.js ***!
  \********************************************************/ /***/ function(__unused_webpack_module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.WOOTRIC_RESPONSES_REGEX = exports.DELIGHTED_RESPONSES_REGEX = exports.DELIGHTED_FEEDBACK_PREFIX = void 0;
                const WOOTRIC_RESPONSES_REGEX = exports.WOOTRIC_RESPONSES_REGEX = /^https:\/\/production.wootric.com\/responses/;
                const DELIGHTED_RESPONSES_REGEX = exports.DELIGHTED_RESPONSES_REGEX = /^https:\/\/web.delighted.com\/e\/[a-zA-Z-]*\/c/;
                const DELIGHTED_FEEDBACK_PREFIX = exports.DELIGHTED_FEEDBACK_PREFIX = "comment=";
            /***/ },
            /***/ "./packages/@logrocket/utils/src/constants/statusCodes.ts": /*!****************************************************************!*\
  !*** ./packages/@logrocket/utils/src/constants/statusCodes.ts ***!
  \****************************************************************/ /***/ function(__unused_webpack_module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.XHR_CUSTOM_STATUS_CODES = exports.XHR_CUSTOM_FAILURE_STATUSES = exports.STATUS_CODES = void 0;
                exports.getStatusText = getStatusText;
                // status codes via https://developer.mozilla.org/en-US/docs/Web/HTTP/Status
                const STATUS_CODES = exports.STATUS_CODES = {
                    0: "",
                    100: "Continue",
                    101: "Switching Protocol",
                    102: "Processing",
                    103: "Early Hints",
                    200: "OK",
                    201: "Created",
                    202: "Accepted",
                    203: "Non-Authoritative Information",
                    204: "No Content",
                    205: "Reset Content",
                    206: "Partial Content",
                    207: "Multi-Status",
                    208: "Already Reported",
                    226: "IM Used",
                    300: "Multiple Choices",
                    301: "Moved Permanently",
                    302: "Found",
                    303: "See Other",
                    304: "Not Modified",
                    305: "Use Proxy",
                    306: "unused",
                    307: "Temporary Redirect",
                    308: "Permanent Redirect",
                    400: "Bad Request",
                    401: "Unauthorized",
                    402: "Payment Required",
                    403: "Forbidden",
                    404: "Not Found",
                    405: "Method Not Allowed",
                    406: "Not Acceptable",
                    407: "Proxy Authentication Required",
                    408: "Request Timeout",
                    409: "Conflict",
                    410: "Gone",
                    411: "Length Required",
                    412: "Precondition Failed",
                    413: "Payload Too Large",
                    414: "URI Too Long",
                    415: "Unsupported Media Type",
                    416: "Range Not Satisfiable",
                    417: "Expectation Failed",
                    418: "I'm a teapot",
                    421: "Misdirected Request",
                    422: "Unprocessable Entity",
                    423: "Locked",
                    424: "Failed Dependency",
                    425: "Too Early",
                    426: "Upgrade Required",
                    428: "Precondition Required",
                    429: "Too Many Requests",
                    431: "Request Header Fields Too Large",
                    451: "Unavailable For Legal Reasons",
                    500: "Internal Server Error",
                    501: "Not Implemented",
                    502: "Bad Gateway",
                    503: "Service Unavailable",
                    504: "Gateway Timeout",
                    505: "HTTP Version Not Supported",
                    506: "Variant Also Negotiates",
                    507: "Insufficient Storage",
                    508: "Loop Detected",
                    510: "Not Extended",
                    511: "Network Authentication Required"
                };
                const XHR_CUSTOM_STATUS_CODES = exports.XHR_CUSTOM_STATUS_CODES = {
                    error: 0,
                    timeout: 444,
                    aborted: 499,
                    offline: 1001
                };
                const XHR_CUSTOM_FAILURE_STATUSES = exports.XHR_CUSTOM_FAILURE_STATUSES = {
                    [XHR_CUSTOM_STATUS_CODES.error]: "Error",
                    [XHR_CUSTOM_STATUS_CODES.timeout]: "Timeout",
                    [XHR_CUSTOM_STATUS_CODES.aborted]: "Aborted",
                    [XHR_CUSTOM_STATUS_CODES.offline]: "Offline"
                };
                function getStatusText(statusCode) {
                    return STATUS_CODES[String(statusCode)];
                }
            /***/ },
            /***/ "./packages/@logrocket/utils/src/createUnsubListener.ts": /*!**************************************************************!*\
  !*** ./packages/@logrocket/utils/src/createUnsubListener.ts ***!
  \**************************************************************/ /***/ function(__unused_webpack_module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Handler = void 0;
                exports.createUnsubListener = createUnsubListener;
                class Handler {
                    constructor(value){
                        this._value = value;
                    }
                    get() {
                        return this._value;
                    }
                    clear() {
                        this._value = undefined;
                    }
                }
                /*
 * This approach ensures the unsub function never keeps a reference to the event listener's target element.
 * This is not a concern in Chrome or Firefox, but Safari will hold the entire context of a function's parent function
 * in scope of that child function. This means that creating the unsub function inside 'addListener' could cause the
 * target element (the 'obj' argument) to be held in scope of the unsub function even though it is never referenced
 * in the unsub function itself. This would lead to a memory leak after the target element is removed from the DOM.
 *
 * This function is in a separate file to prevent the Terser minifier from inline-ing the function into 'addListener'.
 */ exports.Handler = Handler;
                function createUnsubListener(handler) {
                    return ()=>{
                        handler.clear();
                    };
                }
            /***/ },
            /***/ "./packages/@logrocket/utils/src/enhanceFunc.ts": /*!******************************************************!*\
  !*** ./packages/@logrocket/utils/src/enhanceFunc.ts ***!
  \******************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = enhanceFunc;
                var _createUnsubListener = __webpack_require__(/*! ./createUnsubListener */ "./packages/@logrocket/utils/src/createUnsubListener.ts");
                const NO_OP_UNREGISTER = ()=>{};
                function enhanceFunc(obj, method, handler) {
                    if (typeof obj[method] !== "function") return NO_OP_UNREGISTER;
                    try {
                        const original = obj[method];
                        const h = new _createUnsubListener.Handler(handler);
                        function shim() {
                            var _h$get;
                            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                            const res = original.apply(this, args);
                            (_h$get = h.get()) === null || _h$get === void 0 || _h$get.apply(this, args);
                            return res;
                        }
                        obj[method] = shim;
                        return ()=>{
                            // Disable our shim from running, and if the method hasn't been re-shimmed
                            // since our shim was applied, safely reset the method to its prior state
                            h.clear();
                            if (obj[method] === shim) obj[method] = original;
                        };
                    } catch (_error) {
                        return NO_OP_UNREGISTER;
                    }
                }
            /***/ },
            /***/ "./packages/@logrocket/utils/src/logError.js": /*!***************************************************!*\
  !*** ./packages/@logrocket/utils/src/logError.js ***!
  \***************************************************/ /***/ function(__unused_webpack_module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = void 0;
                const canBind = typeof console !== "undefined" && console.error && console.error.bind;
                const logError = canBind ? console.error.bind(console) : ()=>{};
                var _default = exports["default"] = logError;
            /***/ },
            /***/ "./packages/@logrocket/utils/src/mapValues.ts": /*!****************************************************!*\
  !*** ./packages/@logrocket/utils/src/mapValues.ts ***!
  \****************************************************/ /***/ function(__unused_webpack_module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = mapValues;
                function mapValues(obj, f) {
                    if (obj == null) return {};
                    const res = {};
                    Object.keys(obj).forEach((key)=>{
                        res[key] = f(obj[key]);
                    });
                    return res;
                }
            /***/ },
            /***/ "./packages/@logrocket/utils/src/parseRawHeaders.ts": /*!**********************************************************!*\
  !*** ./packages/@logrocket/utils/src/parseRawHeaders.ts ***!
  \**********************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.parseRawHeaders = void 0;
                var _defineProperty2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/defineProperty.js"));
                function ownKeys(e, r) {
                    var t = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var o = Object.getOwnPropertySymbols(e);
                        r && (o = o.filter(function(r) {
                            return Object.getOwnPropertyDescriptor(e, r).enumerable;
                        })), t.push.apply(t, o);
                    }
                    return t;
                }
                function _objectSpread(e) {
                    for(var r = 1; r < arguments.length; r++){
                        var t = null != arguments[r] ? arguments[r] : {};
                        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
                            (0, _defineProperty2.default)(e, r, t[r]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
                            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
                        });
                    }
                    return e;
                }
                /**
 * Parses a string of raw HTTP Headers into key-value pairs. Can optionally lower-case keys (for consistent access).
 */ const parseRawHeaders = function(raw) {
                    let config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                    return raw.split(/[\r\n]+/).reduce((headers, entry)=>{
                        const idx = entry.indexOf(":");
                        const key = entry.substring(0, idx);
                        const value = entry.substring(idx + 1).trim();
                        const name = config.lowerCaseKeys ? key.toLowerCase() : key;
                        return _objectSpread(_objectSpread({}, headers), {}, {
                            [name]: typeof headers[key] === "string" ? "".concat(headers[key], ", ").concat(value) : value
                        });
                    }, {});
                };
                exports.parseRawHeaders = parseRawHeaders;
            /***/ },
            /***/ "./packages/@logrocket/utils/src/protectFunc.ts": /*!******************************************************!*\
  !*** ./packages/@logrocket/utils/src/protectFunc.ts ***!
  \******************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = protectFunc;
                var _sendTelemetryData = _interopRequireDefault(__webpack_require__(/*! ./sendTelemetryData */ "./packages/@logrocket/utils/src/sendTelemetryData.js"));
                var _logError = _interopRequireDefault(__webpack_require__(/*! ./logError */ "./packages/@logrocket/utils/src/logError.js"));
                function protectFunc(f) {
                    let onFail = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ()=>{};
                    return function() {
                        let result;
                        try {
                            result = f(...arguments);
                        } catch (err) {
                            if (typeof window !== "undefined" && window._lrdebug) throw err;
                            const payload = onFail(err);
                            (0, _logError.default)("LogRocket", err);
                            (0, _sendTelemetryData.default)(err, payload);
                        }
                        return result;
                    };
                }
            /***/ },
            /***/ "./packages/@logrocket/utils/src/scrubException.ts": /*!*********************************************************!*\
  !*** ./packages/@logrocket/utils/src/scrubException.ts ***!
  \*********************************************************/ /***/ function(__unused_webpack_module, exports) {
                "use strict";
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.scrubException = scrubException;
                function isScalar(value) {
                    return /boolean|number|string/.test(typeof value);
                }
                const optionalScalars = [
                    // Valid values for 'level' are 'fatal', 'error', 'warning', 'info',
                    // and 'debug'. Defaults to 'error'.
                    "level",
                    "logger"
                ];
                const optionalMaps = [
                    "tags",
                    "extra"
                ];
                function scrubException(data, options) {
                    if (options) {
                        for (const field of optionalScalars){
                            const value = options[field];
                            if (isScalar(value)) data[field] = value.toString();
                        }
                        for (const field of optionalMaps){
                            const dirty = options[field] || {};
                            const scrubbed = {};
                            for (const key of Object.keys(dirty)){
                                const value = dirty[key];
                                if (isScalar(value)) scrubbed[key.toString()] = value.toString();
                            }
                            data[field] = scrubbed;
                        }
                    }
                }
            /***/ },
            /***/ "./packages/@logrocket/utils/src/sendTelemetryData.js": /*!************************************************************!*\
  !*** ./packages/@logrocket/utils/src/sendTelemetryData.js ***!
  \************************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = sendErrorTelemetry;
                exports.sendTelemetry = sendTelemetry;
                var _defineProperty2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/defineProperty.js"));
                var _logError = _interopRequireDefault(__webpack_require__(/*! ./logError */ "./packages/@logrocket/utils/src/logError.js"));
                var _TraceKit = _interopRequireDefault(__webpack_require__(/*! ./TraceKit */ "./packages/@logrocket/utils/src/TraceKit.js"));
                function ownKeys(e, r) {
                    var t = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var o = Object.getOwnPropertySymbols(e);
                        r && (o = o.filter(function(r) {
                            return Object.getOwnPropertyDescriptor(e, r).enumerable;
                        })), t.push.apply(t, o);
                    }
                    return t;
                }
                function _objectSpread(e) {
                    for(var r = 1; r < arguments.length; r++){
                        var t = null != arguments[r] ? arguments[r] : {};
                        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
                            (0, _defineProperty2.default)(e, r, t[r]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
                            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
                        });
                    }
                    return e;
                } /* eslint-disable @typescript-eslint/no-shadow */ 
                const SCRIPT_VERSION = "196f4bb78c336889fd143e4b02dd55e3531141ef";
                function _sendToSentry(data) {
                    try {
                        var _window$__SDKCONFIG__, _window$__SDKCONFIG__2;
                        const message = data.message;
                        const url = "https://e.logrocket.com/api/3/store/?sentry_version=7&sentry_client=http%2F3.8.0&sentry_key=b64162b4187a4c5caae8a68a7e291793";
                        const body = JSON.stringify(_objectSpread({
                            message: message,
                            logger: "javascript",
                            platform: "javascript",
                            request: {
                                headers: {
                                    "User-Agent": typeof navigator !== "undefined" && navigator.userAgent
                                },
                                url: typeof location !== "undefined" && location.href
                            },
                            release: SCRIPT_VERSION,
                            environment: typeof window !== "undefined" ? (_window$__SDKCONFIG__ = (_window$__SDKCONFIG__2 = window.__SDKCONFIG__) === null || _window$__SDKCONFIG__2 === void 0 ? void 0 : _window$__SDKCONFIG__2.scriptEnv) !== null && _window$__SDKCONFIG__ !== void 0 ? _window$__SDKCONFIG__ : "prod" : "prod"
                        }, data));
                        if (typeof window !== "undefined") {
                            const XHR = window._lrXMLHttpRequest || XMLHttpRequest;
                            const req = new XHR();
                            req.open("POST", url);
                            req.send(body);
                        } else if (typeof fetch !== "undefined") // NOTE: fetch is intended only to be used in a web worker context where the main web SDK hasn't be initialized
                        //       (ex. Shopify SDK). Otherwise this fetch call would get captured by LogRocket and we don't want to record
                        //       network requests to LogRocket. Eventually this potential issue will be resolved by SSDK-2149.
                        fetch(url, {
                            method: "POST",
                            body: body
                        }).catch((rejectReason)=>{
                            (0, _logError.default)("Failed to send via fetch", rejectReason);
                        });
                    } catch (err) {
                        (0, _logError.default)("Failed to send", err);
                    }
                }
                function sendTelemetry(message, more) {
                    if (typeof window !== "undefined" && window._lrdebug) return void (0, _logError.default)(message);
                    if (more && more.extra && more.extra.appID && typeof more.extra.appID.indexOf === "function" && more.extra.appID.indexOf("au2drp/") === 0 && Math.random() >= 0.25) return;
                    _sendToSentry(_objectSpread({
                        message: message
                    }, more));
                }
                function sendErrorTelemetry(err, payload) {
                    try {
                        const message = err.message;
                        let stringPayload;
                        try {
                            stringPayload = JSON.stringify(payload).slice(0, 1000);
                        } catch (err) {
                            try {
                                stringPayload = "Could not stringify payload: ".concat(Object.prototype.toString.call(payload));
                            } catch (err) {
                            /* nada */ }
                        }
                        let stack;
                        try {
                            stack = _TraceKit.default.computeStackTrace(err).stack.map((frame)=>({
                                    filename: frame.url,
                                    lineno: frame.line,
                                    colno: frame.column,
                                    function: frame.func || "?"
                                }));
                        } catch (err) {
                        /* nada */ }
                        _sendToSentry({
                            message: message,
                            extra: {
                                stringPayload: stringPayload
                            },
                            exception: {
                                values: [
                                    {
                                        type: err.type,
                                        value: message,
                                        stacktrace: {
                                            frames: stack
                                        }
                                    }
                                ]
                            }
                        });
                    } catch (err) {
                        (0, _logError.default)("Failed to send", err);
                    }
                }
            /***/ },
            /***/ "./packages/logrocket/src/LogRocket.js": /*!*********************************************!*\
  !*** ./packages/logrocket/src/LogRocket.js ***!
  \*********************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = exports.MAX_QUEUE_SIZE = void 0;
                var _defineProperty2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/defineProperty.js"));
                var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/objectWithoutProperties */ "./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/objectWithoutProperties.js"));
                var _network = _interopRequireDefault(__webpack_require__(/*! @logrocket/network */ "./packages/@logrocket/network/src/index.js"));
                var _exceptions = __webpack_require__(/*! @logrocket/exceptions */ "./packages/@logrocket/exceptions/src/index.ts");
                var _console = _interopRequireDefault(__webpack_require__(/*! @logrocket/console */ "./packages/@logrocket/console/src/index.ts"));
                var _customElementStates = _interopRequireDefault(__webpack_require__(/*! @logrocket/custom-element-states */ "./packages/@logrocket/custom-element-states/src/index.ts"));
                var _redux = __webpack_require__(/*! @logrocket/redux */ "./packages/@logrocket/redux/src/index.ts");
                var _sendTelemetryData = _interopRequireDefault(__webpack_require__(/*! @logrocket/utils/src/sendTelemetryData */ "./packages/@logrocket/utils/src/sendTelemetryData.js"));
                const _excluded = [
                    "ingestServer"
                ];
                function ownKeys(e, r) {
                    var t = Object.keys(e);
                    if (Object.getOwnPropertySymbols) {
                        var o = Object.getOwnPropertySymbols(e);
                        r && (o = o.filter(function(r) {
                            return Object.getOwnPropertyDescriptor(e, r).enumerable;
                        })), t.push.apply(t, o);
                    }
                    return t;
                }
                function _objectSpread(e) {
                    for(var r = 1; r < arguments.length; r++){
                        var t = null != arguments[r] ? arguments[r] : {};
                        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
                            (0, _defineProperty2.default)(e, r, t[r]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
                            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
                        });
                    }
                    return e;
                }
                const MAX_QUEUE_SIZE = exports.MAX_QUEUE_SIZE = 1000;
                const considerIngestServerOption = function() {
                    let _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, { ingestServer: ingestServer } = _ref, options = (0, _objectWithoutProperties2.default)(_ref, _excluded);
                    if (ingestServer) return _objectSpread({
                        serverURL: "".concat(ingestServer, "/i"),
                        statsURL: "".concat(ingestServer, "/s")
                    }, options);
                    return options;
                };
                class LogRocket {
                    constructor(){
                        var _this = this;
                        this._buffer = [];
                        // TODO: tests for these exposed methods.
                        [
                            "log",
                            "info",
                            "warn",
                            "error",
                            "debug"
                        ].forEach((method)=>{
                            this[method] = function() {
                                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                                _this.addEvent("lr.core.LogEvent", function() {
                                    let consoleOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                                    if (method === "error" && consoleOptions.shouldAggregateConsoleErrors) _exceptions.Capture.captureMessage(_this, args[0], args, {}, true);
                                    return {
                                        logLevel: method.toUpperCase(),
                                        args: args
                                    };
                                }, {
                                    shouldCaptureStackTrace: true
                                });
                            };
                        });
                        this._isInitialized = false;
                        this._installed = [];
                        // expose a callback to get the session URL from the global context
                        window._lr_surl_cb = this.getSessionURL.bind(this);
                    }
                    addEvent(type, getMessage) {
                        let opts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                        const time = Date.now();
                        this._run((logger)=>{
                            logger.addEvent(type, getMessage, _objectSpread(_objectSpread({}, opts), {}, {
                                timeOverride: time
                            }));
                        });
                    }
                    onLogger(logger) {
                        this._logger = logger;
                        while(this._buffer.length > 0){
                            const f = this._buffer.shift();
                            f(this._logger);
                        }
                    }
                    _run(f) {
                        if (this._isDisabled) return;
                        if (this._logger) f(this._logger);
                        else {
                            if (this._buffer.length >= MAX_QUEUE_SIZE) {
                                this._isDisabled = true;
                                console.warn("LogRocket: script did not load. Check that you have a valid network connection.");
                                this.uninstall();
                                return;
                            }
                            this._buffer.push(f.bind(this));
                        }
                    }
                    _initInternal(appID, opts) {
                        if (!this._isInitialized) {
                            var _opts$network;
                            const { shouldAugmentNPS: shouldAugmentNPS = true, shouldParseXHRBlob: shouldParseXHRBlob = false, shouldDetectExceptions: shouldDetectExceptions = true } = opts;
                            if (shouldDetectExceptions) this._installed.push((0, _exceptions.registerExceptions)(this));
                            this._installed.push((0, _network.default)(this, {
                                shouldAugmentNPS: !!shouldAugmentNPS,
                                shouldParseXHRBlob: !!shouldParseXHRBlob,
                                isDisabled: (opts === null || opts === void 0 || (_opts$network = opts.network) === null || _opts$network === void 0 ? void 0 : _opts$network.isEnabled) === false
                            }));
                            this._installed.push((0, _console.default)(this));
                            const { customStatesManager: customStatesManager, unsub: unsub } = (0, _customElementStates.default)();
                            this._installed.push(unsub);
                            this._isInitialized = true;
                            this._run((logger)=>{
                                logger.init(appID, _objectSpread(_objectSpread({}, considerIngestServerOption(opts)), {}, {
                                    customStatesManager: customStatesManager
                                }));
                            });
                        }
                    }
                    init(appID) {
                        var _window, _window2;
                        let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                        // If inside an Angular Zone, escape the Zone to avoid interacting with Angular's change detection.
                        const parentZone = ((_window = window) === null || _window === void 0 || (_window = _window.Zone) === null || _window === void 0 ? void 0 : _window.root) || ((_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.Zone) === null || _window2 === void 0 || (_window2 = _window2.current) === null || _window2 === void 0 ? void 0 : _window2._parent);
                        if (parentZone && typeof parentZone.run === "function") try {
                            parentZone.run(()=>{
                                this._initInternal(appID, opts);
                            });
                            return;
                        } catch (e) {
                            // If we fail to escape the Zone, just init directly.
                            console.warn("LogRocket: init failed to escape Angular Zone", e);
                            (0, _sendTelemetryData.default)(e);
                        }
                        this._initInternal(appID, opts);
                    }
                    start() {
                        this._run((logger)=>{
                            logger.start();
                        });
                    }
                    uninstall() {
                        this._installed.forEach((f)=>f());
                        this._buffer = [];
                        this._run((logger)=>{
                            logger.uninstall();
                        });
                    }
                    identify(id, opts) {
                        this._run((logger)=>{
                            logger.identify(id, opts);
                        });
                    }
                    startNewSession() {
                        this._run((logger)=>{
                            logger.startNewSession();
                        });
                    }
                    track(customEventName, eventProperties) {
                        this._run((logger)=>{
                            logger.track(customEventName, eventProperties);
                        });
                    }
                    getSessionURL(cb) {
                        if (typeof cb !== "function") throw new Error("LogRocket: must pass callback to getSessionURL()");
                        this._run((logger)=>{
                            if (logger.getSessionURL) logger.getSessionURL(cb);
                            else cb(logger.recordingURL);
                        });
                    }
                    trackScrollEvent(target) {
                        // Only reigster the event if the core logger is available,
                        //  otherwise we won't yet have captured the target element:
                        if (this._logger) this._logger.trackScrollEvent(target);
                    }
                    getVersion(cb) {
                        this._run((logger)=>{
                            cb(logger.version);
                        });
                    }
                    captureMessage(message) {
                        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                        _exceptions.Capture.captureMessage(this, message, [
                            message
                        ], options);
                    }
                    captureException(exception) {
                        let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                        _exceptions.Capture.captureException(this, exception, options);
                    }
                    get version() {
                        return this._logger && this._logger.version;
                    }
                    get sessionURL() {
                        return this._logger && this._logger.recordingURL;
                    }
                    get recordingURL() {
                        return this._logger && this._logger.recordingURL;
                    }
                    get recordingID() {
                        return this._logger && this._logger.recordingID;
                    }
                    get threadID() {
                        return this._logger && this._logger.threadID;
                    }
                    get tabID() {
                        return this._logger && this._logger.tabID;
                    }
                    reduxEnhancer() {
                        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                        return (0, _redux.createEnhancer)(this, options);
                    }
                    reduxMiddleware() {
                        let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                        return (0, _redux.createMiddleware)(this, options);
                    }
                    get isDisabled() {
                        return !!(this._isDisabled || this._logger && this._logger._isDisabled);
                    }
                }
                exports["default"] = LogRocket;
            /***/ },
            /***/ "./packages/logrocket/src/makeLogRocket.js": /*!*************************************************!*\
  !*** ./packages/logrocket/src/makeLogRocket.js ***!
  \*************************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = makeLogRocket;
                var _LogRocket = _interopRequireDefault(__webpack_require__(/*! ./LogRocket */ "./packages/logrocket/src/LogRocket.js"));
                const REACT_NATIVE_NOTICE = "LogRocket on React Native requires the LogRocket React Native specific SDK. See setup guide here https://docs.logrocket.com/reference/react-native.";
                const makeNoopPolyfill = ()=>({
                        init () {},
                        uninstall () {},
                        log () {},
                        info () {},
                        warn () {},
                        error () {},
                        debug () {},
                        addEvent () {},
                        identify () {},
                        start () {},
                        get threadID () {
                            return null;
                        },
                        get recordingID () {
                            return null;
                        },
                        get recordingURL () {
                            return null;
                        },
                        reduxEnhancer () {
                            return (store)=>function() {
                                    return store(...arguments);
                                };
                        },
                        reduxMiddleware () {
                            return ()=>(next)=>(action)=>next(action);
                        },
                        track () {},
                        getSessionURL () {},
                        getVersion () {},
                        startNewSession () {},
                        onLogger () {},
                        setClock () {},
                        captureMessage () {},
                        captureException () {}
                    });
                function isUnsupportedLegacyBrowser() {
                    return !window.MutationObserver || !window.WeakMap || typeof Symbol === "undefined" || typeof HTMLScriptElement.supports !== "function";
                }
                function makeLogRocket() {
                    let getLogger = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ()=>{};
                    let getNoopPolyfill = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : makeNoopPolyfill;
                    let getInstance = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ()=>new _LogRocket.default();
                    if (typeof navigator !== "undefined" && navigator.product === "ReactNative") throw new Error(REACT_NATIVE_NOTICE);
                    if (typeof window !== "undefined") {
                        if (window._disableLogRocket || isUnsupportedLegacyBrowser()) return getNoopPolyfill();
                        // Save window globals that we rely on.
                        window._lrMutationObserver = window.MutationObserver;
                        const instance = getInstance();
                        getLogger(instance);
                        return instance;
                    }
                    return makeNoopPolyfill();
                }
            /***/ },
            /***/ "./packages/logrocket/src/setup.js": /*!*****************************************!*\
  !*** ./packages/logrocket/src/setup.js ***!
  \*****************************************/ /***/ function(__unused_webpack_module, exports, __webpack_require__) {
                "use strict";
                var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports["default"] = setup;
                exports.getDomainsAndEnv = getDomainsAndEnv;
                exports.setupBaseSDKCONFIG = setupBaseSDKCONFIG;
                var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(/*! @babel/runtime/helpers/objectWithoutProperties */ "./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/objectWithoutProperties.js"));
                var _makeLogRocket = _interopRequireDefault(__webpack_require__(/*! ./makeLogRocket */ "./packages/logrocket/src/makeLogRocket.js"));
                const _excluded = [
                    "enterpriseServer",
                    "sdkVersion"
                ];
                const CDN_SERVER_MAP = {
                    "cdn.logrocket.com": "https://r.logrocket.io",
                    "cdn.logrocket.io": "https://r.logrocket.io",
                    "cdn.lr-ingest.io": "https://r.lr-ingest.io",
                    "cdn.lr-in.com": "https://r.lr-in.com",
                    "cdn.lr-in-prod.com": "https://r.lr-in-prod.com",
                    "cdn.lr-ingest.com": "https://r.lr-ingest.com",
                    "cdn.ingest-lr.com": "https://r.ingest-lr.com",
                    "cdn.lr-intake.com": "https://r.lr-intake.com",
                    "cdn.intake-lr.com": "https://r.intake-lr.com",
                    "cdn.logr-ingest.com": "https://r.logr-ingest.com",
                    "cdn.lrkt-in.com": "https://r.lrkt-in.com",
                    "cdn.lgrckt-in.com": "https://r.lgrckt-in.com",
                    "cdn.logr-in.com": "https://r.logr-in.com",
                    "cdn-staging.logrocket.io": "https://staging-i.logrocket.io",
                    "cdn-staging.lr-ingest.io": "https://staging-i.lr-ingest.io",
                    "cdn-staging.lr-in.com": "https://staging-i.lr-in.com",
                    "cdn-staging.lr-in-prod.com": "https://staging-i.lr-in-prod.com",
                    "cdn-staging.lr-ingest.com": "https://staging-i.lr-ingest.com",
                    "cdn-staging.ingest-lr.com": "https://staging-i.ingest-lr.com",
                    "cdn-staging.lr-intake.com": "https://staging-i.lr-intake.com",
                    "cdn-staging.intake-lr.com": "https://staging-i.intake-lr.com",
                    "cdn-staging.logr-ingest.com": "https://staging-i.logr-ingest.com",
                    "cdn-staging.lrkt-in.com": "https://staging-i.lrkt-in.com",
                    "cdn-staging.lgrckt-in.com": "https://staging-i.lgrckt-in.com",
                    "cdn-staging.logr-in.com": "https://staging-i.logr-in.com"
                };
                function envFromHostname(hostname) {
                    if (hostname.startsWith("cdn-staging")) return "staging";
                    else if (hostname.startsWith("localhost")) return "development";
                    else return "prod";
                }
                function getDomainsAndEnv(sdkVersion) {
                    if (sdkVersion === "script" || sdkVersion === "shopify-pixel") {
                        // We cannot rely on the DEPLOY_ENV config for script tag usage: we deploy the script built for staging to prod to
                        // improve deployment times, so the DEPLOY_ENV is always 'staging' for script usage! Instead we default to 'prod'
                        // and inspect the script's URL to determine if the environment should instead be staging or development.
                        try {
                            const scriptTag = document.currentScript;
                            const matches = scriptTag.src.match(/^(https?:\/\/([^\\]+))\/.+$/);
                            const scriptHostname = matches && matches[2];
                            if (scriptHostname && CDN_SERVER_MAP[scriptHostname]) return {
                                scriptEnv: envFromHostname(scriptHostname),
                                scriptOrigin: matches && matches[1],
                                scriptIngest: CDN_SERVER_MAP[scriptHostname]
                            };
                        } catch (_) {
                        /* no-op */ }
                        // If we cannot determine the env based on the script's URL we default to prod.
                        return {
                            scriptEnv: "prod",
                            scriptOrigin: "https://cdn.logrocket.io"
                        };
                    } else // NPM package
                    return {
                        scriptEnv: undefined,
                        scriptOrigin: "https://cdn.logr-in.com",
                        scriptIngest: "https://r.logr-in.com"
                    };
                }
                function setupBaseSDKCONFIG(ingestServer) {
                    if (typeof window.__SDKCONFIG__ === "undefined") window.__SDKCONFIG__ = {};
                    window.__SDKCONFIG__.serverURL = "".concat(ingestServer, "/i");
                    window.__SDKCONFIG__.statsURL = "".concat(ingestServer, "/s");
                }
                function setup() {
                    let _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, { enterpriseServer: enterpriseServer, sdkVersion: sdkVersion = "12.1.1" } = _ref, opts = (0, _objectWithoutProperties2.default)(_ref, _excluded);
                    const { scriptEnv: scriptEnv, scriptOrigin: scriptOrigin, scriptIngest: scriptIngest } = getDomainsAndEnv(sdkVersion);
                    const sdkServer = opts.sdkServer || enterpriseServer;
                    const ingestServer = opts.ingestServer || enterpriseServer || scriptIngest;
                    const instance = (0, _makeLogRocket.default)(()=>{
                        const script = document.createElement("script");
                        if (ingestServer) {
                            setupBaseSDKCONFIG(ingestServer);
                            window.__SDKCONFIG__.scriptEnv = scriptEnv;
                        }
                        if (sdkServer) script.src = "".concat(sdkServer, "/logger.min.js");
                        else if (window.__SDKCONFIG__ && window.__SDKCONFIG__.loggerURL) script.src = window.__SDKCONFIG__.loggerURL;
                        else if (window._lrAsyncScript) script.src = window._lrAsyncScript;
                        else script.src = "".concat(scriptOrigin, "/logger-1.min.js");
                        script.async = true;
                        document.head.appendChild(script);
                        script.onload = ()=>{
                            // Brave browser: Advertises its user-agent as Chrome ##.##... then
                            // loads logger.min.js, but blocks the execution of the script
                            // causing _LRlogger to be undefined.  Let's make sure its there first.
                            if (typeof window._LRLogger === "function") setTimeout(()=>{
                                instance.onLogger(new window._LRLogger({
                                    sdkVersion: sdkVersion
                                }));
                            });
                            else {
                                console.warn("LogRocket: script execution has been blocked by a product or service.");
                                instance.uninstall();
                            }
                        };
                        script.onerror = ()=>{
                            console.warn("LogRocket: script could not load. Check that you have a valid network connection.");
                            instance.uninstall();
                        };
                    });
                    return instance;
                }
            /***/ },
            /***/ "./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/defineProperty.js": /*!********************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/defineProperty.js ***!
  \********************************************************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var toPropertyKey = __webpack_require__(/*! ./toPropertyKey.js */ "./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/toPropertyKey.js");
                function _defineProperty(e, r, t) {
                    return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
                        value: t,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e[r] = t, e;
                }
                module1.exports = _defineProperty, module1.exports.__esModule = true, module1.exports["default"] = module1.exports;
            /***/ },
            /***/ "./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/interopRequireDefault.js": /*!***************************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/interopRequireDefault.js ***!
  \***************************************************************************************************************/ /***/ function(module1) {
                function _interopRequireDefault(e) {
                    return e && e.__esModule ? e : {
                        "default": e
                    };
                }
                module1.exports = _interopRequireDefault, module1.exports.__esModule = true, module1.exports["default"] = module1.exports;
            /***/ },
            /***/ "./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/objectWithoutProperties.js": /*!*****************************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/objectWithoutProperties.js ***!
  \*****************************************************************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var objectWithoutPropertiesLoose = __webpack_require__(/*! ./objectWithoutPropertiesLoose.js */ "./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/objectWithoutPropertiesLoose.js");
                function _objectWithoutProperties(e, t) {
                    if (null == e) return {};
                    var o, r, i = objectWithoutPropertiesLoose(e, t);
                    if (Object.getOwnPropertySymbols) {
                        var n = Object.getOwnPropertySymbols(e);
                        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
                    }
                    return i;
                }
                module1.exports = _objectWithoutProperties, module1.exports.__esModule = true, module1.exports["default"] = module1.exports;
            /***/ },
            /***/ "./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/objectWithoutPropertiesLoose.js": /*!**********************************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/objectWithoutPropertiesLoose.js ***!
  \**********************************************************************************************************************/ /***/ function(module1) {
                function _objectWithoutPropertiesLoose(r, e) {
                    if (null == r) return {};
                    var t = {};
                    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
                        if (-1 !== e.indexOf(n)) continue;
                        t[n] = r[n];
                    }
                    return t;
                }
                module1.exports = _objectWithoutPropertiesLoose, module1.exports.__esModule = true, module1.exports["default"] = module1.exports;
            /***/ },
            /***/ "./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/toPrimitive.js": /*!*****************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/toPrimitive.js ***!
  \*****************************************************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var _typeof = __webpack_require__(/*! ./typeof.js */ "./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/typeof.js")["default"];
                function toPrimitive(t, r) {
                    if ("object" != _typeof(t) || !t) return t;
                    var e = t[Symbol.toPrimitive];
                    if (void 0 !== e) {
                        var i = e.call(t, r || "default");
                        if ("object" != _typeof(i)) return i;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return ("string" === r ? String : Number)(t);
                }
                module1.exports = toPrimitive, module1.exports.__esModule = true, module1.exports["default"] = module1.exports;
            /***/ },
            /***/ "./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/toPropertyKey.js": /*!*******************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/toPropertyKey.js ***!
  \*******************************************************************************************************/ /***/ function(module1, __unused_webpack_exports, __webpack_require__) {
                var _typeof = __webpack_require__(/*! ./typeof.js */ "./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/typeof.js")["default"];
                var toPrimitive = __webpack_require__(/*! ./toPrimitive.js */ "./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/toPrimitive.js");
                function toPropertyKey(t) {
                    var i = toPrimitive(t, "string");
                    return "symbol" == _typeof(i) ? i : i + "";
                }
                module1.exports = toPropertyKey, module1.exports.__esModule = true, module1.exports["default"] = module1.exports;
            /***/ },
            /***/ "./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/typeof.js": /*!************************************************************************************************!*\
  !*** ./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/typeof.js ***!
  \************************************************************************************************/ /***/ function(module1) {
                function _typeof(o) {
                    "@babel/helpers - typeof";
                    return module1.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
                        return typeof o;
                    } : function(o) {
                        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
                    }, module1.exports.__esModule = true, module1.exports["default"] = module1.exports, _typeof(o);
                }
                module1.exports = _typeof, module1.exports.__esModule = true, module1.exports["default"] = module1.exports;
            /***/ }
        };
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId](module1, module1.exports, __webpack_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ /******/ /* webpack/runtime/global */ /******/ !function() {
            /******/ __webpack_require__.g = function() {
                /******/ if (typeof globalThis === "object") return globalThis;
                /******/ try {
                    /******/ return this || new Function("return this")();
                /******/ } catch (e) {
                    /******/ if (typeof window === "object") return window;
                /******/ }
            /******/ }();
        /******/ }();
        /******/ /************************************************************************/ var __webpack_exports__ = {};
        // This entry need to be wrapped in an IIFE because it need to be in strict mode.
        !function() {
            "use strict";
            var exports = __webpack_exports__;
            /*!**********************************************!*\
  !*** ./packages/logrocket/src/module-npm.js ***!
  \**********************************************/ var _interopRequireDefault = __webpack_require__(/*! @babel/runtime/helpers/interopRequireDefault */ "./node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            exports["default"] = void 0;
            var _setup = _interopRequireDefault(__webpack_require__(/*! ./setup */ "./packages/logrocket/src/setup.js"));
            /** @type {import('./types').LR.LogRocket} */ const instance = (0, _setup.default)();
            var _default = exports["default"] = instance;
        }();
        __webpack_exports__ = __webpack_exports__["default"];
        /******/ return __webpack_exports__;
    /******/ }();
});

});

parcelRegister("12tws", function(module, exports) {
module.exports = JSON.parse('{"name":"@lwolf-common/platform-service","main":"./build/index.js","version":"3.42.10","license":"UNLICENSED","author":"Lone Wolf Technologies, Inc.","publishConfig":{"registry":"https://npm-repo.lab.lwolf.com"},"dependencies":{"@lwt-common/authentication":"^1.8.1","logrocket":"^12.1.1"},"files":["build"],"types":"./build/index.d.ts","scripts":{"build":"rm -rf ./build && tsc","prepack":"npm run build"}}');

});

parcelRegister("bMEyZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.strings = module.exports.Strings = void 0;
var $8943a477400e88e3$var$Strings = /** @class */ function() {
    function Strings() {
        var _a;
        this.languages = (_a = {}, _a["en-US"] = {
            adminMenu: "Admin",
            manageAccount: "Manage Account",
            billing: "Billing",
            signOut: "Sign Out",
            tokenStorageFailed: "Failed: Token could not be stored."
        }, _a["fr-CA"] = {
            //TODO: needs to be updated once the strings are translated, using AI translation for now
            adminMenu: "Administration",
            manageAccount: "G\xe9rer le compte",
            billing: "Facturation",
            signOut: "Fermer la session",
            tokenStorageFailed: "\xc9chec: Le jeton n'a pas pu \xeatre stock\xe9."
        }, _a);
    }
    Strings.prototype.getStrings = function(languageCode) {
        return this.languages[languageCode] || this.languages["en-US"];
    };
    return Strings;
}();
module.exports.Strings = $8943a477400e88e3$var$Strings;
var $8943a477400e88e3$var$strings = new $8943a477400e88e3$var$Strings();
module.exports.strings = $8943a477400e88e3$var$strings;

});

parcelRegister("g15fX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SIGN_OUT_MARKER_TTL_MS = module.exports.SIGN_OUT_STORAGE_KEY = module.exports.TOKEN_KEY_NAME = module.exports.SESSION_CHECK_POLL_INTERVAL_MS = module.exports.DEFAULT_IMPERSONATION_WARNING_LEAD_TIME_MS = module.exports.DEFAULT_IMPERSONATION_MAX_SESSION_MS = module.exports.DEFAULT_IMPERSONATION_IDLE_TIMEOUT_MS = module.exports.IMPERSONATION_STORAGE_KEYS = module.exports.TOKEN_REFRESH_STORAGE_KEYS = module.exports.LOG_ROCKET_APP_IDS = void 0;
module.exports.LOG_ROCKET_APP_IDS = {
    dev: "clvl2o/platform-dev-eexlj",
    stg: "clvl2o/platform-stg",
    pre: "clvl2o/platform-pre",
    prod: "clvl2o/platform-prod-rxzfx"
};
module.exports.TOKEN_REFRESH_STORAGE_KEYS = {
    LOCK_PREFIX: "lwaRefreshLock_",
    REFRESHED_PREFIX: "lwaTokenRefreshed_"
};
module.exports.IMPERSONATION_STORAGE_KEYS = {
    SESSION_START_PREFIX: "lwaImpersonationSessionStart_",
    LAST_ACTIVITY_PREFIX: "lwaImpersonationLastActivity_"
};
module.exports.DEFAULT_IMPERSONATION_IDLE_TIMEOUT_MS = 1800000;
module.exports.DEFAULT_IMPERSONATION_MAX_SESSION_MS = 3600000;
module.exports.DEFAULT_IMPERSONATION_WARNING_LEAD_TIME_MS = 60000;
module.exports.SESSION_CHECK_POLL_INTERVAL_MS = 120000;
module.exports.TOKEN_KEY_NAME = "lwaToken";
module.exports.SIGN_OUT_STORAGE_KEY = "lwaSignOut";
module.exports.SIGN_OUT_MARKER_TTL_MS = 5000;

});

parcelRegister("ghmcX", function(module, exports) {
"use strict";
var $bd9f75e53e00dd0a$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $bd9f75e53e00dd0a$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $g15fX = parcelRequire("g15fX");
var $bd9f75e53e00dd0a$var$TokenMonitor = /** @class */ function() {
    function TokenMonitor(lwDomain, getToken, getTokenPayload, setTokenState, reloadTokenFromStorage, refreshToken) {
        this.lwDomain = lwDomain;
        this.getToken = getToken;
        this.getTokenPayload = getTokenPayload;
        this.setTokenState = setTokenState;
        this.reloadTokenFromStorage = reloadTokenFromStorage;
        this.refreshToken = refreshToken;
    }
    TokenMonitor.prototype.start = function() {
        var _this = this;
        this.boundVisibilityHandler = function() {
            if (document.visibilityState === "hidden") {
                clearTimeout(_this.tokenMonitorTimer);
                _this.tokenMonitorTimer = undefined;
            } else _this.scheduleRefreshTimer();
        };
        this.boundStorageHandler = function(event) {
            var broadcastKey = "".concat($g15fX.TOKEN_REFRESH_STORAGE_KEYS.REFRESHED_PREFIX).concat(_this.lwDomain);
            if (event.key !== broadcastKey) return;
            _this.reloadTokenFromStorage();
            _this.scheduleRefreshTimer();
        };
        document.addEventListener("visibilitychange", this.boundVisibilityHandler);
        window.addEventListener("storage", this.boundStorageHandler);
        this.scheduleRefreshTimer();
    };
    TokenMonitor.prototype.stop = function() {
        clearTimeout(this.tokenMonitorTimer);
        this.tokenMonitorTimer = undefined;
        if (this.boundVisibilityHandler) {
            document.removeEventListener("visibilitychange", this.boundVisibilityHandler);
            this.boundVisibilityHandler = undefined;
        }
        if (this.boundStorageHandler) {
            window.removeEventListener("storage", this.boundStorageHandler);
            this.boundStorageHandler = undefined;
        }
    };
    TokenMonitor.prototype.scheduleRefreshTimer = function() {
        var _this = this;
        var _a;
        var tokenPayload = this.getTokenPayload();
        if (!this.getToken() || !tokenPayload) return;
        var expiresAtMs = ((_a = tokenPayload.getExpirationTime()) !== null && _a !== void 0 ? _a : 0) * 1000;
        var delay = expiresAtMs - Date.now() - 60000;
        if (delay <= 0) this.doRefresh();
        else this.tokenMonitorTimer = setTimeout(function() {
            return _this.doRefresh();
        }, delay);
    };
    TokenMonitor.prototype.doRefresh = function() {
        return $bd9f75e53e00dd0a$var$__awaiter(this, void 0, void 0, function() {
            var lockKey, broadcastKey, existingLock, acquiredAt, newToken, _a;
            return $bd9f75e53e00dd0a$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (document.visibilityState === "hidden") return [
                            2 /*return*/ 
                        ];
                        lockKey = "".concat($g15fX.TOKEN_REFRESH_STORAGE_KEYS.LOCK_PREFIX).concat(this.lwDomain);
                        broadcastKey = "".concat($g15fX.TOKEN_REFRESH_STORAGE_KEYS.REFRESHED_PREFIX).concat(this.lwDomain);
                        existingLock = localStorage.getItem(lockKey);
                        if (existingLock) {
                            acquiredAt = JSON.parse(existingLock).acquiredAt;
                            if (Date.now() - acquiredAt < 15000) return [
                                2 /*return*/ 
                            ];
                        }
                        localStorage.setItem(lockKey, JSON.stringify({
                            acquiredAt: Date.now()
                        }));
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.refreshToken()
                        ];
                    case 2:
                        newToken = _b.sent();
                        if (newToken) {
                            this.setTokenState(newToken);
                            localStorage.setItem(broadcastKey, JSON.stringify({
                                refreshedAt: Date.now()
                            }));
                            this.scheduleRefreshTimer();
                        }
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        _a = _b.sent();
                        this.stop();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        localStorage.removeItem(lockKey);
                        return [
                            7 /*endfinally*/ 
                        ];
                    case 5:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return TokenMonitor;
}();
module.exports.default = $bd9f75e53e00dd0a$var$TokenMonitor;

});

parcelRegister("5dWRn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $g15fX = parcelRequire("g15fX");
var $3cdbd303c70b13bb$var$ACTIVITY_EVENTS = [
    "mousedown",
    "keydown",
    "scroll",
    "touchstart"
];
var $3cdbd303c70b13bb$var$ACTIVITY_WRITE_THROTTLE_MS = 5000;
var $3cdbd303c70b13bb$var$ImpersonationSessionMonitor = /** @class */ function() {
    function ImpersonationSessionMonitor(lwDomain, onWarning, onExpire, idleTimeoutMs, maxSessionMs, warningLeadTimeMs) {
        if (idleTimeoutMs === void 0) idleTimeoutMs = $g15fX.DEFAULT_IMPERSONATION_IDLE_TIMEOUT_MS;
        if (maxSessionMs === void 0) maxSessionMs = $g15fX.DEFAULT_IMPERSONATION_MAX_SESSION_MS;
        if (warningLeadTimeMs === void 0) warningLeadTimeMs = $g15fX.DEFAULT_IMPERSONATION_WARNING_LEAD_TIME_MS;
        this.lwDomain = lwDomain;
        this.onWarning = onWarning;
        this.onExpire = onExpire;
        this.idleTimeoutMs = idleTimeoutMs;
        this.maxSessionMs = maxSessionMs;
        this.warningLeadTimeMs = warningLeadTimeMs;
        this.lastActivityWriteAt = 0;
    }
    /** Call whenever the current token payload changes. Arms/disarms/re-keys the monitor as needed. */ ImpersonationSessionMonitor.prototype.reconcile = function(tokenPayload) {
        var _a, _b;
        this.sweepOrphanedEntries();
        var isImpersonating = !!(tokenPayload === null || tokenPayload === void 0 ? void 0 : tokenPayload.isImpersonationToken());
        if (isImpersonating) {
            var keySuffix = (_b = (_a = tokenPayload === null || tokenPayload === void 0 ? void 0 : tokenPayload.getLwtClaim()) === null || _a === void 0 ? void 0 : _a.getSessionId()) !== null && _b !== void 0 ? _b : this.lwDomain;
            if (this.armedKeySuffix !== keySuffix) {
                this.disarm();
                this.arm(keySuffix);
            }
        } else if (this.armedKeySuffix) this.disarm();
    };
    ImpersonationSessionMonitor.prototype.stop = function() {
        this.disarm();
    };
    ImpersonationSessionMonitor.prototype.arm = function(keySuffix) {
        var _this = this;
        var _a, _b;
        this.armedKeySuffix = keySuffix;
        var sessionStartKey = "".concat($g15fX.IMPERSONATION_STORAGE_KEYS.SESSION_START_PREFIX).concat(keySuffix);
        var lastActivityKey = "".concat($g15fX.IMPERSONATION_STORAGE_KEYS.LAST_ACTIVITY_PREFIX).concat(keySuffix);
        var now = Date.now();
        this.sessionStart = (_a = this.readTimestamp(sessionStartKey)) !== null && _a !== void 0 ? _a : now;
        localStorage.setItem(sessionStartKey, String(this.sessionStart));
        this.lastActivity = (_b = this.readTimestamp(lastActivityKey)) !== null && _b !== void 0 ? _b : now;
        localStorage.setItem(lastActivityKey, String(this.lastActivity));
        this.boundActivityHandler = function() {
            return _this.recordActivity(lastActivityKey);
        };
        this.boundStorageHandler = function(event) {
            if (event.key === lastActivityKey && event.newValue) {
                _this.lastActivity = Number(event.newValue);
                _this.scheduleIdleTimers();
            }
        };
        this.boundVisibilityHandler = function() {
            if (document.visibilityState === "visible") _this.reviewClocks(sessionStartKey, lastActivityKey);
        };
        $3cdbd303c70b13bb$var$ACTIVITY_EVENTS.forEach(function(eventName) {
            return document.addEventListener(eventName, _this.boundActivityHandler, {
                passive: true
            });
        });
        window.addEventListener("storage", this.boundStorageHandler);
        document.addEventListener("visibilitychange", this.boundVisibilityHandler);
        this.scheduleIdleTimers();
        this.scheduleMaxSessionTimers();
    };
    ImpersonationSessionMonitor.prototype.disarm = function() {
        var _this = this;
        if (!this.armedKeySuffix) return;
        var keySuffix = this.armedKeySuffix;
        this.clearTimers();
        if (this.boundActivityHandler) {
            $3cdbd303c70b13bb$var$ACTIVITY_EVENTS.forEach(function(eventName) {
                return document.removeEventListener(eventName, _this.boundActivityHandler);
            });
            this.boundActivityHandler = undefined;
        }
        if (this.boundStorageHandler) {
            window.removeEventListener("storage", this.boundStorageHandler);
            this.boundStorageHandler = undefined;
        }
        if (this.boundVisibilityHandler) {
            document.removeEventListener("visibilitychange", this.boundVisibilityHandler);
            this.boundVisibilityHandler = undefined;
        }
        localStorage.removeItem("".concat($g15fX.IMPERSONATION_STORAGE_KEYS.SESSION_START_PREFIX).concat(keySuffix));
        localStorage.removeItem("".concat($g15fX.IMPERSONATION_STORAGE_KEYS.LAST_ACTIVITY_PREFIX).concat(keySuffix));
        this.armedKeySuffix = undefined;
        this.sessionStart = undefined;
        this.lastActivity = undefined;
    };
    ImpersonationSessionMonitor.prototype.recordActivity = function(lastActivityKey) {
        var now = Date.now();
        this.lastActivity = now;
        this.scheduleIdleTimers();
        if (now - this.lastActivityWriteAt >= $3cdbd303c70b13bb$var$ACTIVITY_WRITE_THROTTLE_MS) {
            this.lastActivityWriteAt = now;
            localStorage.setItem(lastActivityKey, String(now));
        }
    };
    /** Re-derives both clocks from storage. Covers the case where setTimeout didn't fire because the tab/machine was suspended. */ ImpersonationSessionMonitor.prototype.reviewClocks = function(sessionStartKey, lastActivityKey) {
        var _a, _b;
        this.sessionStart = (_a = this.readTimestamp(sessionStartKey)) !== null && _a !== void 0 ? _a : this.sessionStart;
        this.lastActivity = (_b = this.readTimestamp(lastActivityKey)) !== null && _b !== void 0 ? _b : this.lastActivity;
        var now = Date.now();
        if (this.sessionStart !== undefined && now - this.sessionStart >= this.maxSessionMs) {
            this.terminate();
            return;
        }
        if (this.lastActivity !== undefined && now - this.lastActivity >= this.idleTimeoutMs) {
            this.terminate();
            return;
        }
        this.scheduleIdleTimers();
        this.scheduleMaxSessionTimers();
    };
    ImpersonationSessionMonitor.prototype.scheduleIdleTimers = function() {
        var _this = this;
        clearTimeout(this.idleWarningTimer);
        clearTimeout(this.idleExpiryTimer);
        if (this.lastActivity === undefined) return;
        var expiresAt = this.lastActivity + this.idleTimeoutMs;
        var warningAt = expiresAt - this.warningLeadTimeMs;
        var now = Date.now();
        if (warningAt > now) this.idleWarningTimer = setTimeout(function() {
            return _this.onWarning("idle", expiresAt);
        }, warningAt - now);
        if (expiresAt > now) this.idleExpiryTimer = setTimeout(function() {
            return _this.terminate();
        }, expiresAt - now);
        else this.terminate();
    };
    ImpersonationSessionMonitor.prototype.scheduleMaxSessionTimers = function() {
        var _this = this;
        clearTimeout(this.maxSessionWarningTimer);
        clearTimeout(this.maxSessionExpiryTimer);
        if (this.sessionStart === undefined) return;
        var expiresAt = this.sessionStart + this.maxSessionMs;
        var warningAt = expiresAt - this.warningLeadTimeMs;
        var now = Date.now();
        if (warningAt > now) this.maxSessionWarningTimer = setTimeout(function() {
            return _this.onWarning("max-session", expiresAt);
        }, warningAt - now);
        if (expiresAt > now) this.maxSessionExpiryTimer = setTimeout(function() {
            return _this.terminate();
        }, expiresAt - now);
        else this.terminate();
    };
    ImpersonationSessionMonitor.prototype.terminate = function() {
        this.disarm();
        this.onExpire();
    };
    ImpersonationSessionMonitor.prototype.clearTimers = function() {
        clearTimeout(this.idleWarningTimer);
        clearTimeout(this.idleExpiryTimer);
        clearTimeout(this.maxSessionWarningTimer);
        clearTimeout(this.maxSessionExpiryTimer);
        this.idleWarningTimer = undefined;
        this.idleExpiryTimer = undefined;
        this.maxSessionWarningTimer = undefined;
        this.maxSessionExpiryTimer = undefined;
    };
    /**
     * Removes leftover session-start/last-activity entries from storage that are older than this
     * session's own timeout bounds could ever allow. These accumulate when a tab is closed,
     * refreshed, or reloaded (e.g. during local dev) before its own idle/max-session timer fires,
     * since that tab's disarm() never runs. Entries for the currently armed key, or ones still
     * within bounds (e.g. a genuinely live session in another tab), are left alone.
     */ ImpersonationSessionMonitor.prototype.sweepOrphanedEntries = function() {
        var now = Date.now();
        for(var i = localStorage.length - 1; i >= 0; i--){
            var key = localStorage.key(i);
            if (!key) continue;
            var keySuffix = void 0;
            var maxAge = void 0;
            if (key.startsWith($g15fX.IMPERSONATION_STORAGE_KEYS.SESSION_START_PREFIX)) {
                keySuffix = key.slice($g15fX.IMPERSONATION_STORAGE_KEYS.SESSION_START_PREFIX.length);
                maxAge = this.maxSessionMs;
            } else if (key.startsWith($g15fX.IMPERSONATION_STORAGE_KEYS.LAST_ACTIVITY_PREFIX)) {
                keySuffix = key.slice($g15fX.IMPERSONATION_STORAGE_KEYS.LAST_ACTIVITY_PREFIX.length);
                maxAge = this.idleTimeoutMs;
            } else continue;
            if (keySuffix === this.armedKeySuffix) continue;
            var timestamp = this.readTimestamp(key);
            if (timestamp === undefined || now - timestamp >= maxAge) localStorage.removeItem(key);
        }
    };
    ImpersonationSessionMonitor.prototype.readTimestamp = function(key) {
        var raw = localStorage.getItem(key);
        if (!raw) return undefined;
        var parsed = Number(raw);
        return Number.isFinite(parsed) ? parsed : undefined;
    };
    return ImpersonationSessionMonitor;
}();
module.exports.default = $3cdbd303c70b13bb$var$ImpersonationSessionMonitor;

});

parcelRegister("lsuk0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setSignOutInProgress = module.exports.isSignOutInProgress = module.exports.isLegacyConnection = module.exports.getTokenFromCookie = module.exports.isLwolfDomain = module.exports.supportsCookieStore = module.exports.getTokenCookieName = module.exports.getOldTokenCookieName = module.exports.isInternalUser = module.exports.isLowerEnv = module.exports.getEnvironment = void 0;

var $g15fX = parcelRequire("g15fX");
var $f9f3bbc3582f492c$var$getEnvironment = function(lwDomain) {
    if (lwDomain.startsWith("dev.")) return "dev";
    if (lwDomain.startsWith("pre.")) return "pre";
    if (lwDomain.startsWith("stg.")) return "stg";
    return "prod";
};
module.exports.getEnvironment = $f9f3bbc3582f492c$var$getEnvironment;
var $f9f3bbc3582f492c$var$isLowerEnv = function(lwDomain) {
    return (0, module.exports.getEnvironment)(lwDomain) !== "prod";
};
module.exports.isLowerEnv = $f9f3bbc3582f492c$var$isLowerEnv;
var $f9f3bbc3582f492c$var$isInternalUser = function(email) {
    return email.endsWith("@lwolf.com");
};
module.exports.isInternalUser = $f9f3bbc3582f492c$var$isInternalUser;
var $f9f3bbc3582f492c$var$getOldTokenCookieName = function(lwDomain) {
    return "".concat($g15fX.TOKEN_KEY_NAME, "@@").concat(lwDomain);
};
module.exports.getOldTokenCookieName = $f9f3bbc3582f492c$var$getOldTokenCookieName;
var $f9f3bbc3582f492c$var$getTokenCookieName = function(lwDomain) {
    return "".concat($g15fX.TOKEN_KEY_NAME, "_").concat(lwDomain);
};
module.exports.getTokenCookieName = $f9f3bbc3582f492c$var$getTokenCookieName;
var $f9f3bbc3582f492c$var$supportsCookieStore = function() {
    return typeof window !== "undefined" && !!window.cookieStore;
};
module.exports.supportsCookieStore = $f9f3bbc3582f492c$var$supportsCookieStore;
var $f9f3bbc3582f492c$var$isLwolfDomain = function(lwDomain) {
    return window.location.hostname.includes(lwDomain);
};
module.exports.isLwolfDomain = $f9f3bbc3582f492c$var$isLwolfDomain;
var $f9f3bbc3582f492c$var$getTokenFromCookie = function(lwDomain) {
    var _a, _b;
    var tokenCookie = (_a = document.cookie.split("; ").find(function(row) {
        return row.startsWith("".concat((0, module.exports.getTokenCookieName)(lwDomain), "="));
    })) === null || _a === void 0 ? void 0 : _a.split("=")[1];
    if (!tokenCookie) tokenCookie = (_b = document.cookie.split("; ").find(function(row) {
        return row.startsWith("".concat((0, module.exports.getOldTokenCookieName)(lwDomain), "="));
    })) === null || _b === void 0 ? void 0 : _b.split("=")[1];
    return tokenCookie;
};
module.exports.getTokenFromCookie = $f9f3bbc3582f492c$var$getTokenFromCookie;
var $f9f3bbc3582f492c$var$isLegacyConnection = function(parsedToken, appId) {
    var _a, _b;
    var appsClaim = (_b = (_a = parsedToken === null || parsedToken === void 0 ? void 0 : parsedToken.getLwtClaim()) === null || _a === void 0 ? void 0 : _a.getAppsClaim()) !== null && _b !== void 0 ? _b : {};
    var appsClaimRecord = appsClaim;
    return !!appsClaimRecord[appId !== null && appId !== void 0 ? appId : ""];
};
module.exports.isLegacyConnection = $f9f3bbc3582f492c$var$isLegacyConnection;
// Lets every PlatformService/SessionMonitor instance on the same tab know a sign-out is underway,
// so a stale monitor still watching the shared token cookie doesn't race the intended /logout
// navigation with a reload()/tryRelaunch() of its own.
var $f9f3bbc3582f492c$var$isSignOutInProgress = function() {
    var markedAt = Number(sessionStorage.getItem($g15fX.SIGN_OUT_STORAGE_KEY));
    return markedAt > 0 && Date.now() - markedAt < $g15fX.SIGN_OUT_MARKER_TTL_MS;
};
module.exports.isSignOutInProgress = $f9f3bbc3582f492c$var$isSignOutInProgress;
var $f9f3bbc3582f492c$var$setSignOutInProgress = function() {
    sessionStorage.setItem($g15fX.SIGN_OUT_STORAGE_KEY, String(Date.now()));
};
module.exports.setSignOutInProgress = $f9f3bbc3582f492c$var$setSignOutInProgress;

});

parcelRegister("5jiIc", function(module, exports) {
"use strict";
var $3ddd3ddebe599fb7$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $3ddd3ddebe599fb7$var$__generator = module.exports && module.exports.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $3ddd3ddebe599fb7$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3ddd3ddebe599fb7$var$Authentication_1 = $3ddd3ddebe599fb7$var$__importDefault((parcelRequire("2EHer")));

var $g15fX = parcelRequire("g15fX");

var $lsuk0 = parcelRequire("lsuk0");
var $3ddd3ddebe599fb7$var$SessionMonitor = /** @class */ function() {
    function SessionMonitor(lwDomain, cookieStoreSupported, checkSessionUrl, getTokenPayload, validateAndGetToken, appId, validateSession) {
        this.lwDomain = lwDomain;
        this.cookieStoreSupported = cookieStoreSupported;
        this.checkSessionUrl = checkSessionUrl;
        this.getTokenPayload = getTokenPayload;
        this.validateAndGetToken = validateAndGetToken;
        this.appId = appId;
        this.validateSession = validateSession;
    }
    SessionMonitor.prototype.start = function() {
        if ((0, $lsuk0.isLegacyConnection)(this.getTokenPayload(), this.appId)) this.startPolling();
        else if ((0, $lsuk0.isLwolfDomain)(this.lwDomain) && this.cookieStoreSupported) this.startCookieWatch();
        else this.startPolling();
    };
    /** Call whenever the current token payload changes. Validates if was stated with cookie listener and should be polling listener. */ SessionMonitor.prototype.reconcile = function() {
        if (this.cookieChangeHandler && (0, $lsuk0.isLegacyConnection)(this.getTokenPayload(), this.appId)) {
            this.stop();
            this.startPolling();
        }
    };
    SessionMonitor.prototype.stop = function() {
        var _a;
        if (this.cookieChangeHandler) {
            (_a = window.cookieStore) === null || _a === void 0 || _a.removeEventListener("change", this.cookieChangeHandler);
            this.cookieChangeHandler = undefined;
        }
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = undefined;
        }
        if (this.pollVisibilityHandler) {
            document.removeEventListener("visibilitychange", this.pollVisibilityHandler);
            this.pollVisibilityHandler = undefined;
        }
    };
    SessionMonitor.prototype.startCookieWatch = function() {
        var _this = this;
        var tokenCookieName = (0, $lsuk0.getTokenCookieName)(this.lwDomain);
        var handler = function(event) {
            var _a, _b, _c, _d;
            if (_this.cookieChangeHandler !== handler) return;
            if ((0, $lsuk0.isSignOutInProgress)()) return;
            var tokenCookieWasDeleted = event.deleted.some(function(cookie) {
                return cookie.name === tokenCookieName;
            });
            if (!tokenCookieWasDeleted) return;
            var newSessionId = (_b = (_a = $3ddd3ddebe599fb7$var$Authentication_1.default.parseToken((0, $lsuk0.getTokenFromCookie)(_this.lwDomain))) === null || _a === void 0 ? void 0 : _a.getLwtClaim()) === null || _b === void 0 ? void 0 : _b.getSessionId();
            var currentSessionId = (_d = (_c = _this.getTokenPayload()) === null || _c === void 0 ? void 0 : _c.getLwtClaim()) === null || _d === void 0 ? void 0 : _d.getSessionId();
            if (newSessionId && newSessionId === currentSessionId) return;
            window.location.reload();
        };
        this.cookieChangeHandler = handler;
        window.cookieStore.addEventListener("change", handler);
    };
    SessionMonitor.prototype.startPolling = function() {
        var _this = this;
        this.pollVisibilityHandler = function() {
            if (document.visibilityState === "hidden") {
                clearInterval(_this.pollTimer);
                _this.pollTimer = undefined;
            } else {
                _this.checkSession();
                _this.pollTimer = setInterval(function() {
                    return _this.checkSession();
                }, $g15fX.SESSION_CHECK_POLL_INTERVAL_MS);
            }
        };
        document.addEventListener("visibilitychange", this.pollVisibilityHandler);
        if (document.visibilityState !== "hidden") this.pollTimer = setInterval(function() {
            return _this.checkSession();
        }, $g15fX.SESSION_CHECK_POLL_INTERVAL_MS);
    };
    SessionMonitor.prototype.checkSession = function() {
        return $3ddd3ddebe599fb7$var$__awaiter(this, void 0, void 0, function() {
            var token, response, isAuthenticated, _a;
            return $3ddd3ddebe599fb7$var$__generator(this, function(_b) {
                switch(_b.label){
                    case 0:
                        token = this.validateAndGetToken();
                        if (!token) return [
                            2 /*return*/ 
                        ];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4 /*yield*/ ,
                            fetch(this.checkSessionUrl, {
                                headers: {
                                    Authorization: "Bearer ".concat(token)
                                }
                            })
                        ];
                    case 2:
                        response = _b.sent();
                        isAuthenticated = response.ok || response.status !== 401;
                        if (!isAuthenticated && !(0, $lsuk0.isSignOutInProgress)()) this.validateSession();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 3:
                        _a = _b.sent();
                        if (!(0, $lsuk0.isSignOutInProgress)()) this.validateSession();
                        return [
                            3 /*break*/ ,
                            4
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    return SessionMonitor;
}();
module.exports.default = $3ddd3ddebe599fb7$var$SessionMonitor;

});


parcelRegister("6g8wQ", function(module, exports) {

$parcel$export(module.exports, "getIsTokenExpired", () => $48eada4f1b24c255$export$9ae9e0aa50b7f11d);
$parcel$export(module.exports, "expiredTokenActionByToken", () => $48eada4f1b24c255$export$8ade2094f019a218);
$parcel$export(module.exports, "getLwaIdFromTokenInfo", () => $48eada4f1b24c255$export$36611407b237dfdf);

var $cghEn = parcelRequire("cghEn");

var $7D4kr = parcelRequire("7D4kr");
const $48eada4f1b24c255$export$9ae9e0aa50b7f11d = (tokenInfo)=>{
    if (!tokenInfo) return;
    const tokenExpireDate = new Date(tokenInfo.exp * 1000);
    const now = new Date();
    return now > tokenExpireDate;
};
const $48eada4f1b24c255$export$8ade2094f019a218 = {
    [(0, $cghEn.tokenTypes).KEYCLOAK]: ()=>(0, $7D4kr.navigateToLogout)(),
    [(0, $cghEn.tokenTypes).LWA]: ()=>(0, $7D4kr.navigateToPlatformUI)()
};
const $48eada4f1b24c255$export$36611407b237dfdf = (tokenInfo)=>tokenInfo?.[0, $cghEn.LWA_TOKEN_OBJECT_IDENTIFIER]?.uid ?? "";

});
parcelRegister("cghEn", function(module, exports) {

$parcel$export(module.exports, "userTypes", () => $8ed4aba538889ec2$export$e51812ac97ee7106);
$parcel$export(module.exports, "unprotectedRoutes", () => $8ed4aba538889ec2$export$dfabd2abe0b55eb5);
$parcel$export(module.exports, "tokenTypes", () => $8ed4aba538889ec2$export$a60b91545d7e19fc);
$parcel$export(module.exports, "userNameByTokenType", () => $8ed4aba538889ec2$export$e2f22dd282758dd);
$parcel$export(module.exports, "LWA_TOKEN_OBJECT_IDENTIFIER", () => $8ed4aba538889ec2$export$c167671413d5826);
$parcel$export(module.exports, "BMT_APP_KEY", () => $8ed4aba538889ec2$export$7bc3ed09af58a468);
$parcel$export(module.exports, "getOwnerIdByTokenInfo", () => $8ed4aba538889ec2$export$951730e014c90c57);
$parcel$export(module.exports, "getUserTypeByError", () => $8ed4aba538889ec2$export$8dcbaf1f7c9c5122);
$parcel$export(module.exports, "ASK_ME_LATER_MAX_ATTEMPTS", () => $8ed4aba538889ec2$export$a4ff10b83468ecbd);
$parcel$export(module.exports, "PASSWORD_MAX_LENGTH", () => $8ed4aba538889ec2$export$2d4f0c4e32746c31);
$parcel$export(module.exports, "PASSWORD_MIN_LENGTH", () => $8ed4aba538889ec2$export$ef0e3321eda40cbd);
$parcel$export(module.exports, "SIGN_UP_MODE", () => $8ed4aba538889ec2$export$f7c3a28a925c785b);
$parcel$export(module.exports, "ownerTypeByTokenType", () => $8ed4aba538889ec2$export$b5fa2cda0aed45b2);
$parcel$export(module.exports, "getLoginInputs", () => $8ed4aba538889ec2$export$47f7e55da26889e8);

var $cstaF = parcelRequire("cstaF");

var $6g8wQ = parcelRequire("6g8wQ");

var $c7dF9 = parcelRequire("c7dF9");
const $8ed4aba538889ec2$export$e51812ac97ee7106 = Object.freeze({
    invalid: "invalid",
    inactiveKeycloak: "inactiveKeycloak",
    inactiveXbm: "inactiveXbm"
});
const $8ed4aba538889ec2$export$dfabd2abe0b55eb5 = [
    (0, $c7dF9.Routes).AUTH.BASE,
    (0, $c7dF9.Routes).AUTH.LOG_IN,
    (0, $c7dF9.Routes).AUTH.CONNECT
];
const $8ed4aba538889ec2$export$a60b91545d7e19fc = Object.freeze({
    LWA: "LWA",
    KEYCLOAK: "KEYCLOAK"
});
const $8ed4aba538889ec2$export$e2f22dd282758dd = (tokenInfo)=>({
        [$8ed4aba538889ec2$export$a60b91545d7e19fc.KEYCLOAK]: tokenInfo.preferred_username,
        [$8ed4aba538889ec2$export$a60b91545d7e19fc.LWA]: tokenInfo.nickname
    });
const $8ed4aba538889ec2$export$c167671413d5826 = "http://lwt";
const $8ed4aba538889ec2$export$7bc3ed09af58a468 = "bmt";
const $8ed4aba538889ec2$export$951730e014c90c57 = {
    [$8ed4aba538889ec2$export$a60b91545d7e19fc.KEYCLOAK]: (tokenInfo)=>tokenInfo?.sub,
    [$8ed4aba538889ec2$export$a60b91545d7e19fc.LWA]: (tokenInfo)=>(0, $6g8wQ.getLwaIdFromTokenInfo)(tokenInfo)
};
const $8ed4aba538889ec2$export$badcc35798b7caf5 = Object.freeze({
    accountDisabled: "Account disabled",
    invalidUser: "Invalid user credentials"
});
const $8ed4aba538889ec2$export$8dcbaf1f7c9c5122 = {
    [$8ed4aba538889ec2$export$badcc35798b7caf5.accountDisabled]: $8ed4aba538889ec2$export$e51812ac97ee7106.inactiveKeycloak,
    [$8ed4aba538889ec2$export$badcc35798b7caf5.invalidUser]: $8ed4aba538889ec2$export$e51812ac97ee7106.invalid
};
const $8ed4aba538889ec2$export$a4ff10b83468ecbd = 0;
const $8ed4aba538889ec2$export$2d4f0c4e32746c31 = 100;
const $8ed4aba538889ec2$export$ef0e3321eda40cbd = 8;
const $8ed4aba538889ec2$export$f7c3a28a925c785b = "signup";
const $8ed4aba538889ec2$export$b5fa2cda0aed45b2 = {
    [$8ed4aba538889ec2$export$a60b91545d7e19fc.KEYCLOAK]: (0, $cstaF.ownerTypes).user,
    [$8ed4aba538889ec2$export$a60b91545d7e19fc.LWA]: (0, $cstaF.ownerTypes).lwa
};
const $8ed4aba538889ec2$export$47f7e55da26889e8 = (state)=>[
        {
            id: "userName",
            name: "username",
            placeholder: (0, $cstaF.loginTerms).email,
            type: "email",
            errorMessage: state.emailValidationMsg
        },
        {
            id: "password",
            name: "password",
            placeholder: (0, $cstaF.loginTerms).password,
            type: "password",
            errorMessage: state.passwordValidationMsg
        }
    ];

});

parcelRegister("7D4kr", function(module, exports) {

$parcel$export(module.exports, "navigateToPlatformConnection", () => $58df888399335ec9$export$963c65ac77d435b5);
$parcel$export(module.exports, "navigateToPlatformUI", () => $58df888399335ec9$export$70f96b50723cbf2f);
$parcel$export(module.exports, "navigateToPlatformHome", () => $58df888399335ec9$export$f217e1276e2a1895);
$parcel$export(module.exports, "navigateToLogin", () => $58df888399335ec9$export$da68592ae29909da);
$parcel$export(module.exports, "navigateToLogout", () => $58df888399335ec9$export$d0ce6653ad7f31cc);
$parcel$export(module.exports, "navigateToAuth", () => $58df888399335ec9$export$789f05239a83581f);
$parcel$export(module.exports, "navigateToPlatformAuth", () => $58df888399335ec9$export$d64b17324c13f23);
$parcel$export(module.exports, "navigateToHome", () => $58df888399335ec9$export$e2cd6ab3608f2976);
$parcel$export(module.exports, "navigateToHomeAndReload", () => $58df888399335ec9$export$1a2884f56323225);
$parcel$export(module.exports, "routesToShowBackNavBar", () => $58df888399335ec9$export$240c71385f0a5a38);
$parcel$export(module.exports, "constant", () => $58df888399335ec9$export$c983f826f44ff86);
$parcel$export(module.exports, "createNavConfig", () => $58df888399335ec9$export$a02f545aac79ea0c);
$parcel$export(module.exports, "formatPeriodTitle", () => $58df888399335ec9$export$576b1b54eae3a4f9);
$parcel$export(module.exports, "navigateToValidation", () => $58df888399335ec9$export$567e53f4634e4814);
$parcel$export(module.exports, "navigateToVerificationError", () => $58df888399335ec9$export$6e2ed6f594104924);
$parcel$export(module.exports, "routesToHideNavBar", () => $58df888399335ec9$export$8c2d353f532c9f86);
$parcel$export(module.exports, "helpItemLabels", () => $58df888399335ec9$export$bf68670862df0c10);
$parcel$export(module.exports, "talentTerms", () => $58df888399335ec9$export$78c3deceef59fb6d);
$parcel$export(module.exports, "TALENT_MARKETING_URL", () => $58df888399335ec9$export$9afe9c8e9be73860);

var $cstaF = parcelRequire("cstaF");

var $c7dF9 = parcelRequire("c7dF9");

var $g7mFm = parcelRequire("g7mFm");

var $i1BZc = parcelRequire("i1BZc");
const $58df888399335ec9$export$963c65ac77d435b5 = (lwid)=>window.location.replace((0, $i1BZc.urlPlatformConnection)(lwid));
const $58df888399335ec9$export$70f96b50723cbf2f = ()=>window.location.replace((0, $i1BZc.urlPlatformLaunch));
const $58df888399335ec9$export$f217e1276e2a1895 = ()=>window.location.replace((0, $i1BZc.urlPlatformHome));
const $58df888399335ec9$export$da68592ae29909da = ()=>window.location.replace((0, $c7dF9.Routes).AUTH.LOG_IN);
const $58df888399335ec9$export$d0ce6653ad7f31cc = ()=>window.location.replace((0, $c7dF9.Routes).AUTH.LOG_OUT);
const $58df888399335ec9$export$789f05239a83581f = ()=>window.location.replace((0, $c7dF9.Routes).AUTH.BASE);
const $58df888399335ec9$export$d64b17324c13f23 = (authParams)=>window.location.replace((0, $i1BZc.urlPlatformAuth)(authParams));
const $58df888399335ec9$export$e2cd6ab3608f2976 = ()=>window.location.replace((0, $c7dF9.Routes).HOME.BASE);
const $58df888399335ec9$export$1a2884f56323225 = (history)=>{
    history.replace((0, $c7dF9.Routes).HOME.BASE);
    location.reload();
};
const $58df888399335ec9$export$240c71385f0a5a38 = [
    (0, $g7mFm.officeBreakdownRoute),
    (0, $g7mFm.listingsBreakdownRoute),
    (0, $g7mFm.officeListingsRoute),
    (0, $cstaF.searchRoutes).agentsGainedBreakdown,
    (0, $cstaF.searchRoutes).officeListBreakdown
];
const $58df888399335ec9$export$c983f826f44ff86 = (title)=>()=>title;
const $58df888399335ec9$export$a02f545aac79ea0c = (backLinkTitle, constant)=>({
        backLinkTitle: backLinkTitle,
        getBackNavbarTitle: constant
    });
const $58df888399335ec9$export$576b1b54eae3a4f9 = (period, valueFormatter)=>{
    return valueFormatter(period);
};
const $58df888399335ec9$export$567e53f4634e4814 = (history)=>history.replace((0, $c7dF9.Routes).VALIDATION.BASE);
const $58df888399335ec9$export$6e2ed6f594104924 = (history)=>history.replace((0, $c7dF9.Routes).AUTH.VERIFICATION_ERROR);
const $58df888399335ec9$export$8c2d353f532c9f86 = [
    (0, $c7dF9.Routes).VALIDATION.BASE,
    (0, $c7dF9.Routes).AUTH.VERIFICATION_ERROR
];
const $58df888399335ec9$export$bf68670862df0c10 = Object.freeze({
    WEBINARS_TRAINING: "Webinars/Training",
    VIDEO_LIBRARY: "Video Library",
    HELP_GUIDES_FAQS: "Help Guides/FAQs"
});
const $58df888399335ec9$export$78c3deceef59fb6d = Object.freeze({
    tryTalent: "Try Talent",
    talent: "Talent"
});
const $58df888399335ec9$export$9afe9c8e9be73860 = "https://get.lwolf.com/brokermetrics-vip";

});
parcelRegister("g7mFm", function(module, exports) {

$parcel$export(module.exports, "baseRoute", () => $bbbee1cd6e6ac78d$export$97344130af3f9456);
$parcel$export(module.exports, "officeBreakdownRoute", () => $bbbee1cd6e6ac78d$export$a4ca2af36ccc54dd);
$parcel$export(module.exports, "listingsBreakdownRoute", () => $bbbee1cd6e6ac78d$export$3589a3eef0a89ffa);
$parcel$export(module.exports, "officeListingsRoute", () => $bbbee1cd6e6ac78d$export$37a1aca4db8f20d7);
$parcel$export(module.exports, "getBreakdownRoute", () => $bbbee1cd6e6ac78d$export$dbea935d64a75b4c);

var $bLQRh = parcelRequire("bLQRh");

var $c7dF9 = parcelRequire("c7dF9");
const $bbbee1cd6e6ac78d$export$97344130af3f9456 = `${(0, $c7dF9.Routes).MARKET_DYNAMICS.BASE}`;
const $bbbee1cd6e6ac78d$export$a4ca2af36ccc54dd = `${$bbbee1cd6e6ac78d$export$97344130af3f9456}${(0, $c7dF9.Routes).MARKET_DYNAMICS.OFFICES_BREAKDOWN}`;
const $bbbee1cd6e6ac78d$export$3589a3eef0a89ffa = `${$bbbee1cd6e6ac78d$export$97344130af3f9456}${(0, $c7dF9.Routes).MARKET_DYNAMICS.LISTINGS_BREAKDOWN}`;
const $bbbee1cd6e6ac78d$export$37a1aca4db8f20d7 = `${$bbbee1cd6e6ac78d$export$97344130af3f9456}${(0, $c7dF9.Routes).MARKET_DYNAMICS.OFFICE_LISTING}`;
const $bbbee1cd6e6ac78d$export$dbea935d64a75b4c = (currentTab)=>{
    if (currentTab === (0, $bLQRh.officeBreakdownTab)) return $bbbee1cd6e6ac78d$export$a4ca2af36ccc54dd;
    return $bbbee1cd6e6ac78d$export$3589a3eef0a89ffa;
};

});



parcelRegister("2iCCW", function(module, exports) {

$parcel$export(module.exports, "getKeycloakToken", () => $1acb39b9a37a4683$export$4042261ac061e98c);

var $gDxKE = parcelRequire("gDxKE");
const $1acb39b9a37a4683$export$4042261ac061e98c = async (url, email, password)=>{
    try {
        const response = await fetch((0, $gDxKE.getPostRequestObjNoToken)(url, `username=${encodeURIComponent(email)}&password=${password}&client_id=aergo&grant_type=password`));
        return await response.json();
    } catch (error) {
        return {
            error: error
        };
    }
};

});

parcelRegister("lp3u9", function(module, exports) {

$parcel$export(module.exports, "sendUserInvitation", () => $f94ea2de9e1a8838$export$6acbb046598df2d);

var $dDBOF = parcelRequire("dDBOF");

var $i1BZc = parcelRequire("i1BZc");

var $4w5cK = parcelRequire("4w5cK");
const $f94ea2de9e1a8838$export$6acbb046598df2d = async (user, token)=>{
    const { email: emailAddress, firstName: firstName, lastName: lastName, id: userId } = user;
    const data = {
        firstName: firstName,
        lastName: lastName,
        emailAddress: emailAddress,
        sendEmail: false,
        connections: [
            {
                appId: (0, $dDBOF.appIds).xbm,
                name: `${firstName} ${lastName}`,
                userId: userId
            }
        ]
    };
    const invitationEndpoint = "admin/invitations";
    return await (0, $4w5cK.sendProfileServiceRequest)({
        endpoint: invitationEndpoint,
        data: data,
        propsToken: token,
        requesType: (0, $i1BZc.apiRequestTypes).post
    });
};

});
parcelRegister("4w5cK", function(module, exports) {

$parcel$export(module.exports, "sendProfileServiceRequest", () => $349e3021c03a7026$export$93b5c5b30ec12ef);

var $7AubO = parcelRequire("7AubO");

var $gDxKE = parcelRequire("gDxKE");

var $f6CJ4 = parcelRequire("f6CJ4");
const $349e3021c03a7026$export$93b5c5b30ec12ef = async ({ endpoint: endpoint, data: data, propsToken: propsToken, propsActiveClientId: propsActiveClientId, requesType: requesType, queryString: queryString, customErrorMessage: customErrorMessage = null, suppressToast: suppressToast = false })=>{
    const authStore = (0, $f6CJ4.useAuthStore).getState();
    const token = propsToken || authStore.token;
    const activeClientId = propsActiveClientId || authStore.activeClientId;
    const url = `${(0, $7AubO.getEndpoint)((0, $7AubO.PROFILE_SERVICE))}/${endpoint}`;
    try {
        const response = await fetch((0, $gDxKE.getRequestObjectByMethodType)({
            url: url,
            token: token,
            data: data,
            activeClientId: activeClientId,
            queryString: queryString
        })[requesType]);
        (0, $gDxKE.handleApiError)({
            response: response,
            endpoint: endpoint,
            customErrorMessage: customErrorMessage,
            suppressToast: suppressToast
        });
        return await response.json();
    } catch (error) {
        console.error(error);
        return {
            error: error
        };
    }
};

});


parcelRegister("8cYiI", function(module, exports) {

$parcel$export(module.exports, "produce", () => $5f9e38360d79f95a$export$b46cabe22e78bc00);
var $5f9e38360d79f95a$var$__defProp = Object.defineProperty;
var $5f9e38360d79f95a$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $5f9e38360d79f95a$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $5f9e38360d79f95a$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $5f9e38360d79f95a$var$__defNormalProp = (obj, key, value)=>key in obj ? $5f9e38360d79f95a$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $5f9e38360d79f95a$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($5f9e38360d79f95a$var$__hasOwnProp.call(b, prop)) $5f9e38360d79f95a$var$__defNormalProp(a, prop, b[prop]);
    if ($5f9e38360d79f95a$var$__getOwnPropSymbols) {
        for (var prop of $5f9e38360d79f95a$var$__getOwnPropSymbols(b))if ($5f9e38360d79f95a$var$__propIsEnum.call(b, prop)) $5f9e38360d79f95a$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var $5f9e38360d79f95a$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $5f9e38360d79f95a$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $5f9e38360d79f95a$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $5f9e38360d79f95a$var$errors = [];
function $5f9e38360d79f95a$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $5f9e38360d79f95a$var$getPrototypeOf = Object.getPrototypeOf;
function $5f9e38360d79f95a$export$541ac630993a4c84(value) {
    return !!value && !!value[$5f9e38360d79f95a$var$DRAFT_STATE];
}
function $5f9e38360d79f95a$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $5f9e38360d79f95a$var$isPlainObject(value) || Array.isArray(value) || !!value[$5f9e38360d79f95a$export$6ee2082928bcb0ee] || !!((_a = value.constructor) == null ? void 0 : _a[$5f9e38360d79f95a$export$6ee2082928bcb0ee]) || $5f9e38360d79f95a$var$isMap(value) || $5f9e38360d79f95a$var$isSet(value);
}
var $5f9e38360d79f95a$var$objectCtorString = Object.prototype.constructor.toString();
function $5f9e38360d79f95a$var$isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    const proto = $5f9e38360d79f95a$var$getPrototypeOf(value);
    if (proto === null) return true;
    const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === $5f9e38360d79f95a$var$objectCtorString;
}
function $5f9e38360d79f95a$export$22e8af3f75a010e3(value) {
    if (!$5f9e38360d79f95a$export$541ac630993a4c84(value)) $5f9e38360d79f95a$var$die(15, value);
    return value[$5f9e38360d79f95a$var$DRAFT_STATE].base_;
}
function $5f9e38360d79f95a$var$each(obj, iter) {
    if ($5f9e38360d79f95a$var$getArchtype(obj) === 0 /* Object */ ) Object.entries(obj).forEach(([key, value])=>{
        iter(key, value, obj);
    });
    else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $5f9e38360d79f95a$var$getArchtype(thing) {
    const state = thing[$5f9e38360d79f95a$var$DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : $5f9e38360d79f95a$var$isMap(thing) ? 2 /* Map */  : $5f9e38360d79f95a$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function $5f9e38360d79f95a$var$has(thing, prop) {
    return $5f9e38360d79f95a$var$getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function $5f9e38360d79f95a$var$get(thing, prop) {
    return $5f9e38360d79f95a$var$getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function $5f9e38360d79f95a$var$set(thing, propOrOldValue, value) {
    const t = $5f9e38360d79f95a$var$getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function $5f9e38360d79f95a$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $5f9e38360d79f95a$var$isMap(target) {
    return target instanceof Map;
}
function $5f9e38360d79f95a$var$isSet(target) {
    return target instanceof Set;
}
function $5f9e38360d79f95a$var$latest(state) {
    return state.copy_ || state.base_;
}
function $5f9e38360d79f95a$var$shallowCopy(base, strict) {
    if ($5f9e38360d79f95a$var$isMap(base)) return new Map(base);
    if ($5f9e38360d79f95a$var$isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    if (!strict && $5f9e38360d79f95a$var$isPlainObject(base)) {
        if (!$5f9e38360d79f95a$var$getPrototypeOf(base)) {
            const obj = /* @__PURE__ */ Object.create(null);
            return Object.assign(obj, base);
        }
        return $5f9e38360d79f95a$var$__spreadValues({}, base);
    }
    const descriptors = Object.getOwnPropertyDescriptors(base);
    delete descriptors[$5f9e38360d79f95a$var$DRAFT_STATE];
    let keys = Reflect.ownKeys(descriptors);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const desc = descriptors[key];
        if (desc.writable === false) {
            desc.writable = true;
            desc.configurable = true;
        }
        if (desc.get || desc.set) descriptors[key] = {
            configurable: true,
            writable: true,
            // could live with !!desc.set as well here...
            enumerable: desc.enumerable,
            value: base[key]
        };
    }
    return Object.create($5f9e38360d79f95a$var$getPrototypeOf(base), descriptors);
}
function $5f9e38360d79f95a$export$792f3d81ea979f55(obj, deep = false) {
    if ($5f9e38360d79f95a$var$isFrozen(obj) || $5f9e38360d79f95a$export$541ac630993a4c84(obj) || !$5f9e38360d79f95a$export$16e3aed3edb85946(obj)) return obj;
    if ($5f9e38360d79f95a$var$getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj.delete = $5f9e38360d79f95a$var$dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) $5f9e38360d79f95a$var$each(obj, (_key, value)=>$5f9e38360d79f95a$export$792f3d81ea979f55(value, true), true);
    return obj;
}
function $5f9e38360d79f95a$var$dontMutateFrozenCollections() {
    $5f9e38360d79f95a$var$die(2);
}
function $5f9e38360d79f95a$var$isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var $5f9e38360d79f95a$var$plugins = {};
function $5f9e38360d79f95a$var$getPlugin(pluginKey) {
    const plugin = $5f9e38360d79f95a$var$plugins[pluginKey];
    if (!plugin) $5f9e38360d79f95a$var$die(0, pluginKey);
    return plugin;
}
function $5f9e38360d79f95a$var$loadPlugin(pluginKey, implementation) {
    if (!$5f9e38360d79f95a$var$plugins[pluginKey]) $5f9e38360d79f95a$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $5f9e38360d79f95a$var$currentScope;
function $5f9e38360d79f95a$var$getCurrentScope() {
    return $5f9e38360d79f95a$var$currentScope;
}
function $5f9e38360d79f95a$var$createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function $5f9e38360d79f95a$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        $5f9e38360d79f95a$var$getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $5f9e38360d79f95a$var$revokeScope(scope) {
    $5f9e38360d79f95a$var$leaveScope(scope);
    scope.drafts_.forEach($5f9e38360d79f95a$var$revokeDraft);
    scope.drafts_ = null;
}
function $5f9e38360d79f95a$var$leaveScope(scope) {
    if (scope === $5f9e38360d79f95a$var$currentScope) $5f9e38360d79f95a$var$currentScope = scope.parent_;
}
function $5f9e38360d79f95a$var$enterScope(immer2) {
    return $5f9e38360d79f95a$var$currentScope = $5f9e38360d79f95a$var$createScope($5f9e38360d79f95a$var$currentScope, immer2);
}
function $5f9e38360d79f95a$var$revokeDraft(draft) {
    const state = draft[$5f9e38360d79f95a$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $5f9e38360d79f95a$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$5f9e38360d79f95a$var$DRAFT_STATE].modified_) {
            $5f9e38360d79f95a$var$revokeScope(scope);
            $5f9e38360d79f95a$var$die(4);
        }
        if ($5f9e38360d79f95a$export$16e3aed3edb85946(result)) {
            result = $5f9e38360d79f95a$var$finalize(scope, result);
            if (!scope.parent_) $5f9e38360d79f95a$var$maybeFreeze(scope, result);
        }
        if (scope.patches_) $5f9e38360d79f95a$var$getPlugin("Patches").generateReplacementPatches_(baseDraft[$5f9e38360d79f95a$var$DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = $5f9e38360d79f95a$var$finalize(scope, baseDraft, []);
    $5f9e38360d79f95a$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $5f9e38360d79f95a$export$45b790e32b2810ee ? result : void 0;
}
function $5f9e38360d79f95a$var$finalize(rootScope, value, path) {
    if ($5f9e38360d79f95a$var$isFrozen(value)) return value;
    const state = value[$5f9e38360d79f95a$var$DRAFT_STATE];
    if (!state) {
        $5f9e38360d79f95a$var$each(value, (key, childValue)=>$5f9e38360d79f95a$var$finalizeProperty(rootScope, state, value, key, childValue, path), true);
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        $5f9e38360d79f95a$var$maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        const result = state.copy_;
        let resultEach = result;
        let isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        $5f9e38360d79f95a$var$each(resultEach, (key, childValue)=>$5f9e38360d79f95a$var$finalizeProperty(rootScope, state, result, key, childValue, path, isSet2));
        $5f9e38360d79f95a$var$maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) $5f9e38360d79f95a$var$getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function $5f9e38360d79f95a$var$finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if ($5f9e38360d79f95a$export$541ac630993a4c84(childValue)) {
        const path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !$5f9e38360d79f95a$var$has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        const res = $5f9e38360d79f95a$var$finalize(rootScope, childValue, path);
        $5f9e38360d79f95a$var$set(targetObject, prop, res);
        if ($5f9e38360d79f95a$export$541ac630993a4c84(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if ($5f9e38360d79f95a$export$16e3aed3edb85946(childValue) && !$5f9e38360d79f95a$var$isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        $5f9e38360d79f95a$var$finalize(rootScope, childValue);
        if (!parentState || !parentState.scope_.parent_) $5f9e38360d79f95a$var$maybeFreeze(rootScope, childValue);
    }
}
function $5f9e38360d79f95a$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $5f9e38360d79f95a$export$792f3d81ea979f55(value, deep);
}
// src/core/proxy.ts
function $5f9e38360d79f95a$var$createProxyProxy(base, parent) {
    const isArray = Array.isArray(base);
    const state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $5f9e38360d79f95a$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    let target = state;
    let traps = $5f9e38360d79f95a$var$objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = $5f9e38360d79f95a$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var $5f9e38360d79f95a$var$objectTraps = {
    get (state, prop) {
        if (prop === $5f9e38360d79f95a$var$DRAFT_STATE) return state;
        const source = $5f9e38360d79f95a$var$latest(state);
        if (!$5f9e38360d79f95a$var$has(source, prop)) return $5f9e38360d79f95a$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$5f9e38360d79f95a$export$16e3aed3edb85946(value)) return value;
        if (value === $5f9e38360d79f95a$var$peek(state.base_, prop)) {
            $5f9e38360d79f95a$var$prepareCopy(state);
            return state.copy_[prop] = $5f9e38360d79f95a$var$createProxy(value, state);
        }
        return value;
    },
    has (state, prop) {
        return prop in $5f9e38360d79f95a$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($5f9e38360d79f95a$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $5f9e38360d79f95a$var$getDescriptorFromProto($5f9e38360d79f95a$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $5f9e38360d79f95a$var$peek($5f9e38360d79f95a$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$5f9e38360d79f95a$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if ($5f9e38360d79f95a$var$is(value, current2) && (value !== void 0 || $5f9e38360d79f95a$var$has(state.base_, prop))) return true;
            $5f9e38360d79f95a$var$prepareCopy(state);
            $5f9e38360d79f95a$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty (state, prop) {
        if ($5f9e38360d79f95a$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            $5f9e38360d79f95a$var$prepareCopy(state);
            $5f9e38360d79f95a$var$markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $5f9e38360d79f95a$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty () {
        $5f9e38360d79f95a$var$die(11);
    },
    getPrototypeOf (state) {
        return $5f9e38360d79f95a$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $5f9e38360d79f95a$var$die(12);
    }
};
var $5f9e38360d79f95a$var$arrayTraps = {};
$5f9e38360d79f95a$var$each($5f9e38360d79f95a$var$objectTraps, (key, fn)=>{
    $5f9e38360d79f95a$var$arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
$5f9e38360d79f95a$var$arrayTraps.deleteProperty = function(state, prop) {
    return $5f9e38360d79f95a$var$arrayTraps.set.call(this, state, prop, void 0);
};
$5f9e38360d79f95a$var$arrayTraps.set = function(state, prop, value) {
    return $5f9e38360d79f95a$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $5f9e38360d79f95a$var$peek(draft, prop) {
    const state = draft[$5f9e38360d79f95a$var$DRAFT_STATE];
    const source = state ? $5f9e38360d79f95a$var$latest(state) : draft;
    return source[prop];
}
function $5f9e38360d79f95a$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $5f9e38360d79f95a$var$getDescriptorFromProto(source, prop);
    return desc ? `value` in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $5f9e38360d79f95a$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $5f9e38360d79f95a$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $5f9e38360d79f95a$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $5f9e38360d79f95a$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $5f9e38360d79f95a$var$markChanged(state.parent_);
    }
}
function $5f9e38360d79f95a$var$prepareCopy(state) {
    if (!state.copy_) state.copy_ = $5f9e38360d79f95a$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var $5f9e38360d79f95a$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if (typeof base === "function" && typeof recipe !== "function") {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (typeof recipe !== "function") $5f9e38360d79f95a$var$die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") $5f9e38360d79f95a$var$die(7);
            let result;
            if ($5f9e38360d79f95a$export$16e3aed3edb85946(base)) {
                const scope = $5f9e38360d79f95a$var$enterScope(this);
                const proxy = $5f9e38360d79f95a$var$createProxy(base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $5f9e38360d79f95a$var$revokeScope(scope);
                    else $5f9e38360d79f95a$var$leaveScope(scope);
                }
                $5f9e38360d79f95a$var$usePatchesInScope(scope, patchListener);
                return $5f9e38360d79f95a$var$processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $5f9e38360d79f95a$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $5f9e38360d79f95a$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $5f9e38360d79f95a$var$getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else $5f9e38360d79f95a$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if (typeof base === "function") return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
    createDraft(base) {
        if (!$5f9e38360d79f95a$export$16e3aed3edb85946(base)) $5f9e38360d79f95a$var$die(8);
        if ($5f9e38360d79f95a$export$541ac630993a4c84(base)) base = $5f9e38360d79f95a$export$97aac956da55dae9(base);
        const scope = $5f9e38360d79f95a$var$enterScope(this);
        const proxy = $5f9e38360d79f95a$var$createProxy(base, void 0);
        proxy[$5f9e38360d79f95a$var$DRAFT_STATE].isManual_ = true;
        $5f9e38360d79f95a$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$5f9e38360d79f95a$var$DRAFT_STATE];
        if (!state || !state.isManual_) $5f9e38360d79f95a$var$die(9);
        const { scope_: scope } = state;
        $5f9e38360d79f95a$var$usePatchesInScope(scope, patchListener);
        return $5f9e38360d79f95a$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $5f9e38360d79f95a$var$getPlugin("Patches").applyPatches_;
        if ($5f9e38360d79f95a$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $5f9e38360d79f95a$var$createProxy(value, parent) {
    const draft = $5f9e38360d79f95a$var$isMap(value) ? $5f9e38360d79f95a$var$getPlugin("MapSet").proxyMap_(value, parent) : $5f9e38360d79f95a$var$isSet(value) ? $5f9e38360d79f95a$var$getPlugin("MapSet").proxySet_(value, parent) : $5f9e38360d79f95a$var$createProxyProxy(value, parent);
    const scope = parent ? parent.scope_ : $5f9e38360d79f95a$var$getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function $5f9e38360d79f95a$export$97aac956da55dae9(value) {
    if (!$5f9e38360d79f95a$export$541ac630993a4c84(value)) $5f9e38360d79f95a$var$die(10, value);
    return $5f9e38360d79f95a$var$currentImpl(value);
}
function $5f9e38360d79f95a$var$currentImpl(value) {
    if (!$5f9e38360d79f95a$export$16e3aed3edb85946(value) || $5f9e38360d79f95a$var$isFrozen(value)) return value;
    const state = value[$5f9e38360d79f95a$var$DRAFT_STATE];
    let copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $5f9e38360d79f95a$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = $5f9e38360d79f95a$var$shallowCopy(value, true);
    $5f9e38360d79f95a$var$each(copy, (key, childValue)=>{
        $5f9e38360d79f95a$var$set(copy, key, $5f9e38360d79f95a$var$currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $5f9e38360d79f95a$export$d3a6659991a0696c() {
    const errorOffset = 16;
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        for(let i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_ } = state;
        $5f9e38360d79f95a$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $5f9e38360d79f95a$var$get(base_, key);
            const value = $5f9e38360d79f95a$var$get(copy_, key);
            const op = !assignedValue ? REMOVE : $5f9e38360d79f95a$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === $5f9e38360d79f95a$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $5f9e38360d79f95a$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) $5f9e38360d79f95a$var$die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") $5f9e38360d79f95a$var$die(errorOffset + 3);
                base = $5f9e38360d79f95a$var$get(base, p);
                if (typeof base !== "object") $5f9e38360d79f95a$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $5f9e38360d79f95a$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $5f9e38360d79f95a$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $5f9e38360d79f95a$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$5f9e38360d79f95a$export$16e3aed3edb85946(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if ($5f9e38360d79f95a$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($5f9e38360d79f95a$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($5f9e38360d79f95a$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($5f9e38360d79f95a$var$has(obj, $5f9e38360d79f95a$export$6ee2082928bcb0ee)) cloned[$5f9e38360d79f95a$export$6ee2082928bcb0ee] = obj[$5f9e38360d79f95a$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($5f9e38360d79f95a$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $5f9e38360d79f95a$var$loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function $5f9e38360d79f95a$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$5f9e38360d79f95a$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $5f9e38360d79f95a$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false
            };
        }
        get size() {
            return $5f9e38360d79f95a$var$latest(this[$5f9e38360d79f95a$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $5f9e38360d79f95a$var$latest(this[$5f9e38360d79f95a$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$5f9e38360d79f95a$var$latest(state).has(key) || $5f9e38360d79f95a$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $5f9e38360d79f95a$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($5f9e38360d79f95a$var$latest(state).size) {
                prepareMapCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $5f9e38360d79f95a$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            $5f9e38360d79f95a$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $5f9e38360d79f95a$var$latest(state).get(key);
            if (state.finalized_ || !$5f9e38360d79f95a$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $5f9e38360d79f95a$var$createProxy(value, state);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $5f9e38360d79f95a$var$latest(this[$5f9e38360d79f95a$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($5f9e38360d79f95a$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$5f9e38360d79f95a$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $5f9e38360d79f95a$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
        }
        get size() {
            return $5f9e38360d79f95a$var$latest(this[$5f9e38360d79f95a$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.copy_.add(value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $5f9e38360d79f95a$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($5f9e38360d79f95a$var$latest(state).size) {
                prepareSetCopy(state);
                $5f9e38360d79f95a$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$5f9e38360d79f95a$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($5f9e38360d79f95a$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($5f9e38360d79f95a$export$16e3aed3edb85946(value)) {
                    const draft = $5f9e38360d79f95a$var$createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $5f9e38360d79f95a$var$die(3, JSON.stringify($5f9e38360d79f95a$var$latest(state)));
    }
    $5f9e38360d79f95a$var$loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var $5f9e38360d79f95a$var$immer = new $5f9e38360d79f95a$export$aaadc6ff0f822719();
var $5f9e38360d79f95a$export$b46cabe22e78bc00 = $5f9e38360d79f95a$var$immer.produce;
var $5f9e38360d79f95a$export$4da66d41c9492c78 = $5f9e38360d79f95a$var$immer.produceWithPatches.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$573f26f60825c493 = $5f9e38360d79f95a$var$immer.setAutoFreeze.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$333ce65961cbe047 = $5f9e38360d79f95a$var$immer.setUseStrictShallowCopy.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$a8b8e03e6bbe5473 = $5f9e38360d79f95a$var$immer.applyPatches.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$3c3214997190395f = $5f9e38360d79f95a$var$immer.createDraft.bind($5f9e38360d79f95a$var$immer);
var $5f9e38360d79f95a$export$c60f5e69c521b528 = $5f9e38360d79f95a$var$immer.finishDraft.bind($5f9e38360d79f95a$var$immer);
function $5f9e38360d79f95a$export$c05b21e3257751e5(value) {
    return value;
}
function $5f9e38360d79f95a$export$20f911b3f8cf0b74(value) {
    return value;
}

});

parcelRegister("bBJbW", function(module, exports) {

$parcel$export(module.exports, "getXamUserMls", () => $873634846d705b87$export$cdf1f5b519cee5c4);
$parcel$export(module.exports, "createAgent", () => $873634846d705b87$export$613ce55b88e64a58);
$parcel$export(module.exports, "getXamInternalUserPrivileges", () => $873634846d705b87$export$57dd645cc57353fb);

var $cstaF = parcelRequire("cstaF");

var $i1BZc = parcelRequire("i1BZc");

var $4w5cK = parcelRequire("4w5cK");

var $24YIE = parcelRequire("24YIE");
const $873634846d705b87$export$a3d6fc5e6d309d6a = async (token, activeClientId)=>await (0, $4w5cK.sendProfileServiceRequest)({
        endpoint: "xamuser",
        propsToken: token,
        propsActiveClientId: activeClientId,
        requesType: (0, $i1BZc.apiRequestTypes).get
    });
const $873634846d705b87$export$cdf1f5b519cee5c4 = async (token, activeClientId)=>await (0, $24YIE.newSendApiRequest)("XamUserMls_read", [], undefined, token, true, activeClientId, (0, $i1BZc.apiRequestTypes).post);
const $873634846d705b87$export$613ce55b88e64a58 = async (agentId, mlsId)=>{
    return await (0, $24YIE.newSendApiRequest)("XamUserMls_create", [
        {
            parameter: "mlsId",
            value: mlsId
        },
        {
            parameter: "agentId",
            value: agentId
        }
    ]);
};
const $873634846d705b87$export$57dd645cc57353fb = async ()=>{
    return await (0, $24YIE.newSendApiRequest)("internal_account_privileges", [
        {
            parameter: "accountId",
            value: String((0, $cstaF.ACCOUNTS).LONE_WOLF_INTERNAL.id)
        }
    ]);
};

});

parcelRegister("dFPJJ", function(module, exports) {

$parcel$export(module.exports, "getUserProducts", () => $9f473c8857c05e9c$export$a8a5f909a0dbb4b4);

var $cstaF = parcelRequire("cstaF");
const $9f473c8857c05e9c$export$a8a5f909a0dbb4b4 = ({ isLegacyUser: isLegacyUser, privileges: privileges, isAgentMetricsUser: isAgentMetricsUser, isAgentProductionEnabled: isAgentProductionEnabled })=>{
    if (isLegacyUser) return [
        (0, $cstaF.moduleNames).proficiencyMetrics
    ];
    if (isAgentMetricsUser) {
        const amProducts = [];
        if (isAgentProductionEnabled) amProducts.push((0, $cstaF.moduleNames).agentProduction);
        amProducts.push((0, $cstaF.moduleNames).marketShare, (0, $cstaF.moduleNames).marketDynamics);
        return amProducts;
    }
    return privileges?.userProducts || [];
};

});

parcelRegister("ivaD7", function(module, exports) {

$parcel$export(module.exports, "setStateData", () => $d7835e26b1a09c8b$export$4db1d5627fec77d5);
const $d7835e26b1a09c8b$export$4db1d5627fec77d5 = (statePropName, data, setState)=>{
    setState((prevState)=>({
            ...prevState,
            [statePropName]: data
        }));
};

});

parcelRegister("lxCva", function(module, exports) {

$parcel$export(module.exports, "getProductFlags", () => $faea8ba9cf2272d4$export$31e379c1739410cb);
$parcel$export(module.exports, "getPendoDataLayers", () => $faea8ba9cf2272d4$export$1b32083f3396385e);

var $cstaF = parcelRequire("cstaF");

var $dDBOF = parcelRequire("dDBOF");
const $faea8ba9cf2272d4$export$31e379c1739410cb = (userProducts)=>{
    const values = userProducts || [];
    return {
        has_proficiency_metrics: values.includes((0, $cstaF.moduleNames).proficiencyMetrics),
        has_market_share: values.includes((0, $cstaF.moduleNames).marketShare),
        has_market_dynamics: values.includes((0, $cstaF.moduleNames).marketDynamics)
    };
};
const $faea8ba9cf2272d4$export$1b32083f3396385e = ({ tokenInfo: tokenInfo, selectedAccount: selectedAccount, isLegacyUser: isLegacyUser, runningApp: runningApp, productFlags: productFlags, ownerId: ownerId })=>{
    // This function creates anonymous visitor IDs in Pendo unless you change the visitor id field to use your app's values
    // This function uses the placeholder 'LEGACY-USER' or 'AGENT-METRICS-USER' values for account ID unless you change the account id field to use your app's values
    // Call initializePendo function from App.js and use this function to get your Pendo Data Layers in your authentication promise handler or callback when your visitor and account id values are available
    // Please use Strings, Numbers, or Bools for value types.
    const userWithoutAccountId = isLegacyUser ? "LEGACY-USER" : (0, $dDBOF.isAgentMetrics) || runningApp === (0, $dDBOF.appNames).XAM ? "AGENT-METRICS-USER" : null;
    const hasAssociatedAccount = !(0, $dDBOF.isAgentMetrics) && !isLegacyUser && runningApp !== (0, $dDBOF.appNames).XAM;
    return {
        visitor: {
            ...productFlags,
            id: tokenInfo.email,
            email: tokenInfo.email,
            full_name: tokenInfo.name,
            ...selectedAccount ? {
                accountId: selectedAccount.id
            } : {},
            ...selectedAccount ? {
                accountName: selectedAccount.name
            } : {},
            legacy: !!isLegacyUser,
            // role:         // Optional
            // You can add any additional visitor level key-values here,
            // as long as it's not one of the above reserved names.
            ...tokenInfo?.auth_time && {
                auth_time: tokenInfo.auth_time
            },
            sub: ownerId,
            session_state: tokenInfo.session_state,
            roles: tokenInfo?.resource_access?.account.roles,
            scope: tokenInfo.scope,
            name: tokenInfo.name,
            preferred_username: tokenInfo.preferred_username,
            given_name: tokenInfo.given_name,
            family_name: tokenInfo.family_name,
            app: runningApp
        },
        account: {
            id: hasAssociatedAccount ? selectedAccount?.id : userWithoutAccountId,
            ...hasAssociatedAccount && selectedAccount ? {
                name: selectedAccount?.name
            } : {}
        }
    };
};

});

parcelRegister("3T9wI", function(module, exports) {

$parcel$export(module.exports, "ENVIROS_WHERE_TREND_ANALYSIS_IS_HIDDEN", () => $2d4de5efe15df24f$export$24b8c34454350386);
$parcel$export(module.exports, "ENVIROS_WHERE_CONNECT_MLS_IS_HIDDEN", () => $2d4de5efe15df24f$export$7f090624c2f9cb6e);
$parcel$export(module.exports, "getIsTrendAnalysisDebugEnabled", () => $2d4de5efe15df24f$export$6f512d7a73088d58);
$parcel$export(module.exports, "getIsInternalEmailAddress", () => $2d4de5efe15df24f$export$9b772a7143f6193c);
$parcel$export(module.exports, "getIsConnectMlsEnabled", () => $2d4de5efe15df24f$export$f7bf8a1bdc1ec93f);
$parcel$export(module.exports, "isComparisonSetsEnabled", () => $2d4de5efe15df24f$export$b1544d0d122e7d83);
$parcel$export(module.exports, "getIsInternalAccount", () => $2d4de5efe15df24f$export$6378a2322da29eb4);
$parcel$export(module.exports, "getIsNotificationsEnabled", () => $2d4de5efe15df24f$export$ad4b8a8b40d2c3b1);
$parcel$export(module.exports, "getIsDashboardEnabled", () => $2d4de5efe15df24f$export$d16a9b5a398dc008);
$parcel$export(module.exports, "pdfUnderConstructionModules", () => $2d4de5efe15df24f$export$7d22f6ced92141e1);
$parcel$export(module.exports, "pdfDisabledRoutes", () => $2d4de5efe15df24f$export$5d9726e3c3eb03e8);
$parcel$export(module.exports, "IS_TALENT_LINK_ENABLED", () => $2d4de5efe15df24f$export$78b836c6ab6d1826);

var $dDBOF = parcelRequire("dDBOF");

var $laUAN = parcelRequire("laUAN");

var $cstaF = parcelRequire("cstaF");
const $2d4de5efe15df24f$export$24b8c34454350386 = [
    (0, $laUAN.environments).PRD
];
const $2d4de5efe15df24f$export$7f090624c2f9cb6e = [
    (0, $laUAN.environments).PRD,
    (0, $laUAN.environments).PRE
];
const $2d4de5efe15df24f$export$6f512d7a73088d58 = (hostname, envirosWhereTrendAnalysisIsHidden)=>{
    const currentEnvironment = (0, $laUAN.getEnvironment)(hostname);
    return !envirosWhereTrendAnalysisIsHidden?.find((enviro)=>enviro === currentEnvironment);
};
const $2d4de5efe15df24f$export$9b772a7143f6193c = (email = "")=>email?.toLowerCase().endsWith((0, $cstaF.INTERNAL_EMAIL_DOMAIN).toLowerCase());
const $2d4de5efe15df24f$export$f7bf8a1bdc1ec93f = ({ isAgentMetrics: isAgentMetrics, email: email, hostname: hostname, envirosWhereIsHidden: envirosWhereIsHidden })=>{
    if (!isAgentMetrics) return false;
    if (!hostname) return false;
    const currentEnviro = (0, $laUAN.getEnvironment)(hostname);
    if (envirosWhereIsHidden?.find((enviro)=>enviro === currentEnviro)) return false;
    if ($2d4de5efe15df24f$export$9b772a7143f6193c(email)) return false;
    return true;
};
const $2d4de5efe15df24f$export$89d0ff9f1ec9abd2 = ()=>(0, $dDBOF.runningApp) !== (0, $dDBOF.appNames).XAM;
const $2d4de5efe15df24f$export$b1544d0d122e7d83 = $2d4de5efe15df24f$export$89d0ff9f1ec9abd2();
const $2d4de5efe15df24f$export$6378a2322da29eb4 = (accountId)=>accountId === (0, $cstaF.ACCOUNTS).LONE_WOLF_INTERNAL.id;
const $2d4de5efe15df24f$export$d2ec92fdd8a14963 = (email)=>(0, $dDBOF.isAgentMetrics) && email.endsWith((0, $cstaF.INTERNAL_EMAIL_DOMAIN));
const $2d4de5efe15df24f$export$ad4b8a8b40d2c3b1 = (isAgentMetrics)=>!isAgentMetrics;
const $2d4de5efe15df24f$export$d16a9b5a398dc008 = (isAgentMetrics)=>{
    return !isAgentMetrics;
};
const $2d4de5efe15df24f$export$7d22f6ced92141e1 = [];
const $2d4de5efe15df24f$export$5d9726e3c3eb03e8 = [];
const $2d4de5efe15df24f$export$78b836c6ab6d1826 = true;

});
parcelRegister("laUAN", function(module, exports) {

$parcel$export(module.exports, "environments", () => $f6a66e3e7fe0b203$export$c67cb6e08c9d0d95);
$parcel$export(module.exports, "getEnvironment", () => $f6a66e3e7fe0b203$export$57570b1603cf6adb);
const $f6a66e3e7fe0b203$export$c67cb6e08c9d0d95 = Object.freeze({
    PRD: "production",
    PRE: "pre",
    STG: "stg",
    DEV: "dev",
    LOCALHOST: "localhost"
});
const $f6a66e3e7fe0b203$export$57570b1603cf6adb = (hostname)=>{
    const host = hostname.toLowerCase();
    if (host.indexOf("dev") > -1) return $f6a66e3e7fe0b203$export$c67cb6e08c9d0d95.DEV;
    if (host.indexOf("stg") > -1) return $f6a66e3e7fe0b203$export$c67cb6e08c9d0d95.STG;
    if (host.indexOf("pre") > -1) return $f6a66e3e7fe0b203$export$c67cb6e08c9d0d95.PRE;
    if (host.indexOf("localhost") > -1) return $f6a66e3e7fe0b203$export$c67cb6e08c9d0d95.LOCALHOST;
    return $f6a66e3e7fe0b203$export$c67cb6e08c9d0d95.PRD;
};

});


parcelRegister("9QNal", function(module, exports) {

$parcel$export(module.exports, "getTimeIntervals", () => $72bf1bb7a907d7e5$export$2a7c2c98bec8f077);
$parcel$export(module.exports, "retryEndpoint", () => $72bf1bb7a907d7e5$export$5f36f9782f39737e);

var $24YIE = parcelRequire("24YIE");

var $cstaF = parcelRequire("cstaF");

var $i1BZc = parcelRequire("i1BZc");
const $72bf1bb7a907d7e5$export$2a7c2c98bec8f077 = async ()=>{
    return await (0, $24YIE.newSendApiRequest)("Time_interval_descriptions", [
        {
            parameter: "intervals_request",
            value: JSON.stringify({
                intervalTypes: Object.values((0, $cstaF.TimePeriods)).filter((p)=>p !== (0, $cstaF.TimePeriods)["Custom Date"])
            })
        }
    ]);
};
const $72bf1bb7a907d7e5$export$5f36f9782f39737e = async ({ retries: retries = (0, $i1BZc.MAX_ENDPOINT_RETRIES), fetchFunction: fetchFunction, payload: payload })=>{
    try {
        const response = await fetchFunction(payload);
        if (response.ok) return response.json();
        if (response?.error?.code === (0, $i1BZc.CANCELED_ENDPOINT_CODE) && retries > 0) return await $72bf1bb7a907d7e5$export$5f36f9782f39737e({
            retries: retries - 1,
            fetchFunction: fetchFunction,
            payload: payload
        });
        return response;
    } catch (error) {
        return {
            error: error
        };
    }
};

});

parcelRegister("8U25g", function(module, exports) {

$parcel$export(module.exports, "terms", () => $67b52b893166c0e4$export$8a21ba990ca4a7cb);
$parcel$export(module.exports, "topPerformerAgents", () => $67b52b893166c0e4$export$c2a14ff153290800);
$parcel$export(module.exports, "topPerformerAgentsOptions", () => $67b52b893166c0e4$export$3782cfdae7337e11);

var $cstaF = parcelRequire("cstaF");
const $67b52b893166c0e4$export$8a21ba990ca4a7cb = Object.freeze({
    connectYourMls: "Connect your MLS",
    thankYou: "Thank You!",
    welcomeMessage: "Welcome to AgentMetrics!  Let's get started by connecting your MLS with the system to power the data.",
    yourMLSassociation: "Your MLS Association",
    mlsAgentId: "MLS Agent ID",
    saveAndContinue: "Save & Continue",
    enterYourMlsAgentId: "Enter your MLS Agent ID",
    selectYourMls: "Select your MLS",
    verificationErrorP1: `We couldn't verify your credentials.`,
    verificationErrorP2: `Please try again or reach out to ${(0, $cstaF.emails).lwolfSupport} for assitance.`,
    goToLoneWolfHome: "Go to Lone Wolf Home"
});
const $67b52b893166c0e4$export$c2a14ff153290800 = [
    {
        agentId: "23_261",
        mlsId: 268,
        mlsName: "ACV",
        name: "Nicholas Politi",
        officeName: "Merrill L. Thomas, Inc."
    },
    {
        agentId: "203024816250737",
        mlsId: 181,
        mlsName: "AKMLS",
        name: "Marc Dunne",
        officeName: "Jack White Commercial"
    },
    {
        agentId: "R11804",
        mlsId: 43,
        mlsName: "BACMLS",
        name: "Jim Allen",
        officeName: "Coldwell Banker Hpw"
    }
];
const $67b52b893166c0e4$export$3782cfdae7337e11 = $67b52b893166c0e4$export$c2a14ff153290800.map((agent)=>({
        label: `${agent.mlsName} - ${agent.name} (Agent ID: ${agent.agentId})`,
        value: agent.agentId,
        mlsId: agent.mlsId,
        agentId: agent.agentId,
        agentName: agent.name,
        officeName: agent.officeName
    }));

});

parcelRegister("gl8f4", function(module, exports) {

$parcel$export(module.exports, "recordLoginActivity", () => $be5500382b18b07d$export$f2335da94e12aee7);

var $24YIE = parcelRequire("24YIE");

var $cstaF = parcelRequire("cstaF");
const $be5500382b18b07d$export$9e99466506d66daa = async (token, activityType, activityDetails)=>{
    try {
        const userActivity = {
            activityType: activityType
        };
        if (activityDetails) userActivity.activityDetails = typeof activityDetails === "string" ? activityDetails : JSON.stringify(activityDetails);
        return await (0, $24YIE.newSendApiRequest)("UserActivity_log", [
            {
                parameter: "user_activity",
                value: JSON.stringify(userActivity)
            }
        ], 10000, token);
    } catch (error) {
        console.error(error);
    }
};
const $be5500382b18b07d$export$f2335da94e12aee7 = async (token)=>{
    const activityDetails = {
        page: "/dashboard",
        user_agent: typeof navigator !== "undefined" ? navigator.userAgent : "Unknown"
    };
    return await $be5500382b18b07d$export$9e99466506d66daa(token, (0, $cstaF.USER_ACTIVITY_TYPES).LOGIN, activityDetails);
};

});



parcelRegister("bA5Mi", function(module, exports) {

$parcel$export(module.exports, "usePDFStore", () => $86e789e16baad9fc$export$2f48675438c6bf3);

var $9phu9 = parcelRequire("9phu9");

var $evnWE = parcelRequire("evnWE");

var $88tPr = parcelRequire("88tPr");

var $cstaF = parcelRequire("cstaF");
const $86e789e16baad9fc$export$1848f3e9d1fbc0e4 = {
    [(0, $cstaF.modules).proficiencyMetrics.transactions]: {},
    [(0, $cstaF.modules).proficiencyMetrics.offices]: {},
    [(0, $cstaF.modules).proficiencyMetrics.agents]: {},
    [(0, $cstaF.modules).proficiencyMetrics.savedAgents]: {},
    [(0, $cstaF.modules).proficiencyMetrics.agentMovement]: {},
    [(0, $cstaF.modules).proficiencyMetrics.suggestedAgents]: {},
    [(0, $cstaF.modules).agentProduction.agentProduction]: {},
    [(0, $cstaF.modules).marketShare.totals]: {},
    [(0, $cstaF.modules).marketShare.coverage]: {},
    [(0, $cstaF.modules).marketDynamics.marketDynamics]: {},
    downloadModalStatus: {
        isOpen: false,
        isPDFLoading: false,
        fileType: "csv",
        fileName: null,
        clickAction: null
    },
    agentProfileTabIndex: 0,
    agentProfileExportDetails: {},
    agentProfileTimePeriod: "",
    areasData: [],
    productionSummary: null,
    agentProfileProductionTableData: [],
    agentProfileInventoryTableData: [],
    logoSrc: undefined
};
const $86e789e16baad9fc$export$9fb23f0c1310ee90 = (set, get)=>({
        ...$86e789e16baad9fc$export$1848f3e9d1fbc0e4,
        ...(0, $evnWE.actions)(set, get)
    });
const $86e789e16baad9fc$export$2f48675438c6bf3 = (0, $9phu9.createWithEqualityFn)((0, $88tPr.devtools)($86e789e16baad9fc$export$9fb23f0c1310ee90, {
    name: "pdf_state"
}));

});
parcelRegister("evnWE", function(module, exports) {

$parcel$export(module.exports, "actions", () => $a8f688eb155e45d2$export$e324594224ef24da);

var $8cYiI = parcelRequire("8cYiI");

var $90ISC = parcelRequire("90ISC");

var $6M53k = parcelRequire("6M53k");

var $gdi0Z = parcelRequire("gdi0Z");
const $a8f688eb155e45d2$export$e324594224ef24da = (set, get)=>({
        setListingViewTitle: (listingViewTitle)=>set((0, $8cYiI.produce)((state)=>{
                const selectedModule = (0, $90ISC.useSearchStore).getState().selectedModule;
                const moduleState = state[selectedModule];
                moduleState.listingViewTitle = listingViewTitle;
            }), false, "setListingViewTitle"),
        setResults: (results)=>set((0, $8cYiI.produce)((state)=>{
                const selectedModule = (0, $90ISC.useSearchStore).getState().selectedModule;
                const moduleState = state[selectedModule];
                moduleState.results = results;
            }), false, "setResults"),
        setTransactionCoverageResults: (results)=>set((0, $8cYiI.produce)((state)=>{
                state.transactionCoverageResults = results;
            }), false, "setTransactionCoverageResults"),
        setColumnDefs: (columnDefs)=>set((0, $8cYiI.produce)((state)=>{
                const selectedModule = (0, $90ISC.useSearchStore).getState().selectedModule;
                const moduleState = state[selectedModule];
                moduleState.columnDefs = columnDefs;
            }), false, "setColumnDefs"),
        setPinnedBottomRowData: (pinnedBottomRowData)=>set((0, $8cYiI.produce)((state)=>{
                const selectedModule = (0, $90ISC.useSearchStore).getState().selectedModule;
                const moduleState = state[selectedModule];
                moduleState.pinnedBottomRowData = pinnedBottomRowData;
            }), false, "setPinnedBottomRowData"),
        setDownloadModalStatus: (status)=>set((state)=>({
                    downloadModalStatus: {
                        ...state.downloadModalStatus,
                        ...status
                    }
                }), false, "setDownloadModalStatus"),
        setAgentProfileTabIndex: (selectedTabIndex)=>{
            set((0, $8cYiI.produce)((state)=>{
                state.agentProfileTabIndex = selectedTabIndex;
            }), false, "setAgentProfileTabIndex");
        },
        setAgentProfileTimePeriod: (timePeriod)=>{
            set((0, $8cYiI.produce)((state)=>{
                state.agentProfileTimePeriod = timePeriod;
            }), false, "setAgentProfileTimePeriod");
        },
        setAgentProfileExportDetails: (exportDetails)=>{
            set((0, $8cYiI.produce)((state)=>{
                state.agentProfileExportDetails = exportDetails;
            }), false, "setAgentProfileExportDetails");
        },
        setProductionSummary: (summaryDetails)=>{
            set((0, $8cYiI.produce)((state)=>{
                state.productionSummary = summaryDetails;
            }), false, "setProductionSummary");
        },
        setAreasData: (areasData)=>{
            set((0, $8cYiI.produce)((state)=>{
                if (!state.areasData) return;
                state.areasData = areasData.map((area, index)=>{
                    const checked = index < (0, $6M53k.COVERAGE_AREA_MAX_COUNT_SELECTIONS);
                    return {
                        id: area.areaId,
                        label: area.area,
                        checked: checked,
                        ...area
                    };
                });
            }), false, "setAreasData");
        },
        handleCheckArea: (areaId, checked)=>{
            set((0, $8cYiI.produce)((state)=>{
                state.areasData = state.areasData.map((area)=>{
                    if (area.id === areaId) return {
                        ...area,
                        checked: checked
                    };
                    return area;
                });
            }), false, "handleCheckArea");
        },
        setAgentProfileArea: (selectedArea)=>{
            set((0, $8cYiI.produce)((state)=>{
                state.agentProfileArea = selectedArea;
            }), false, "setAgentProfileArea");
        },
        setAgentProfileProductionTableData: (productionTableData)=>{
            set((0, $8cYiI.produce)((state)=>{
                state.agentProfileProductionTableData = productionTableData;
            }), false, "setAgentProfileProductionTableData");
        },
        setAgentProfileInventoryTableData: (inventoryTableData)=>{
            set((0, $8cYiI.produce)((state)=>{
                state.agentProfileInventoryTableData = inventoryTableData;
            }), false, "setAgentProfileInventoryTableData");
        },
        setLogoSrc: (logoSrc)=>set((0, $8cYiI.produce)((state)=>{
                state.logoSrc = logoSrc;
            }), false, "setLogoSrc"),
        fetchLogo: async ()=>{
            const res = await (0, $gdi0Z.getLogo)();
            if (res === 404) set((0, $8cYiI.produce)((state)=>{
                state.logoSrc = undefined;
            }), false, "setLogoSrc");
            if (res === 404 || res.error || !res.blob) return;
            const blob = await res.blob();
            // Important: Convert blob to base64 data URL for PDF compatibility.
            const reader = new FileReader();
            reader.onloadend = ()=>{
                set((0, $8cYiI.produce)((state)=>{
                    state.logoSrc = reader.result;
                }), false, "setLogoSrc");
            };
            reader.readAsDataURL(blob);
        }
    });

});
parcelRegister("gdi0Z", function(module, exports) {

$parcel$export(module.exports, "uploadLogo", () => $bcdbd59e8c988fc1$export$fb69568dc4717be9);
$parcel$export(module.exports, "getLogo", () => $bcdbd59e8c988fc1$export$53f918f2b7d40673);
$parcel$export(module.exports, "deleteLogo", () => $bcdbd59e8c988fc1$export$bba5eb83f5a3091e);

var $24YIE = parcelRequire("24YIE");
const $bcdbd59e8c988fc1$export$fb69568dc4717be9 = async (base64FileStr)=>{
    return await (0, $24YIE.newSendApiRequest)("ProfileImage_save", [
        {
            parameter: "imageFile",
            value: base64FileStr
        }
    ]);
};
const $bcdbd59e8c988fc1$export$53f918f2b7d40673 = async ()=>{
    return await (0, $24YIE.newSendApiRequest)("ProfileImage_read", [], undefined, undefined, false, undefined, undefined, undefined, true);
};
const $bcdbd59e8c988fc1$export$bba5eb83f5a3091e = async ()=>{
    return await (0, $24YIE.newSendApiRequest)("ProfileImage_delete", []);
};

});





parcelRegister("5NVz0", function(module, exports) {

$parcel$export(module.exports, "getAgentInfo", () => $439e2e5017460c6d$export$a64477c6147abcfa);
$parcel$export(module.exports, "getOfficeInfo", () => $439e2e5017460c6d$export$4060ef1126e39f2b);
$parcel$export(module.exports, "getMlsMembership", () => $439e2e5017460c6d$export$2acc9b565a8dad31);
$parcel$export(module.exports, "getPropertyTypes", () => $439e2e5017460c6d$export$94cd26a0013805d4);
$parcel$export(module.exports, "getAreasMap", () => $439e2e5017460c6d$export$19c7292dc8177b96);
$parcel$export(module.exports, "getOffices", () => $439e2e5017460c6d$export$e0c30a747a54207d);
$parcel$export(module.exports, "getCoverageOffices", () => $439e2e5017460c6d$export$db271839e1ec6767);
$parcel$export(module.exports, "getMlsAgents", () => $439e2e5017460c6d$export$6d4a9de8e7b3bd5f);
$parcel$export(module.exports, "getMlsAgentsByIds", () => $439e2e5017460c6d$export$b6d50a81210bd4ff);

var $24YIE = parcelRequire("24YIE");

var $cstaF = parcelRequire("cstaF");
const $439e2e5017460c6d$export$a64477c6147abcfa = async (agentList)=>{
    return await (0, $24YIE.newSendApiRequest)("Agent_info", [
        {
            parameter: "agentList",
            value: JSON.stringify(agentList)
        }
    ]);
};
const $439e2e5017460c6d$export$4060ef1126e39f2b = async (officeList)=>{
    return await (0, $24YIE.sendApiRequest)("Office_info", [
        {
            parameter: "officeList",
            value: JSON.stringify(officeList)
        }
    ], 5000);
};
const $439e2e5017460c6d$export$2acc9b565a8dad31 = async (mlsIdList)=>{
    return await (0, $24YIE.sendApiRequest)("Multiple_MLS_info", [
        {
            parameter: "mlsId_list",
            value: `[${mlsIdList}]`
        }
    ]);
};
const $439e2e5017460c6d$export$94cd26a0013805d4 = async (mlsId)=>{
    return await (0, $24YIE.sendApiRequest)("Mls_property_types", [
        {
            parameter: "mlsId",
            value: `${mlsId}`
        }
    ], 5000);
};
const $439e2e5017460c6d$export$d89a8ee2653864ea = (mappedAreas)=>{
    const viewNameCounts = {};
    Object.values(mappedAreas).forEach(({ viewName: viewName })=>{
        viewNameCounts[viewName] = (viewNameCounts[viewName] || 0) + 1;
    });
    const viewNameOccurrences = {};
    return Object.fromEntries(Object.entries(mappedAreas).map(([key, mappedArea])=>{
        const { viewName: viewName } = mappedArea;
        if (viewNameCounts[viewName] <= 1) return [
            key,
            mappedArea
        ];
        viewNameOccurrences[viewName] = (viewNameOccurrences[viewName] || 0) + 1;
        return [
            key,
            {
                ...mappedArea,
                viewName: `${viewName} (${viewNameOccurrences[viewName]})`
            }
        ];
    }));
};
const $439e2e5017460c6d$export$19c7292dc8177b96 = async (mlsId)=>{
    const response = await (0, $24YIE.sendApiRequest)("MLS_areas_map", [
        {
            parameter: "mlsId",
            value: `${mlsId}`
        }
    ], 5000);
    if (response.error) return response;
    let mappedAreas = {};
    //TODO: implement combinedServices call here
    await Promise.all(response.map(async (mappedArea)=>{
        const areasByType = await $439e2e5017460c6d$export$69a790e90f6b70f5(mlsId, (0, $cstaF.areaRequestTypes)[mappedArea.columnName]);
        if (!areasByType.error) mappedAreas[(0, $cstaF.areaRequestTypes)[mappedArea.columnName]] = {
            ...mappedArea,
            mappedAreas: areasByType
        };
    }));
    return $439e2e5017460c6d$export$d89a8ee2653864ea(mappedAreas);
};
const $439e2e5017460c6d$export$69a790e90f6b70f5 = async (mlsId, areaType)=>{
    return await (0, $24YIE.sendApiRequest)("MLS_areas", [
        {
            parameter: "mlsId",
            value: `${mlsId}`
        },
        {
            parameter: "areaType",
            value: `${areaType}`
        }
    ]);
};
const $439e2e5017460c6d$export$e0c30a747a54207d = async (mlsId)=>{
    return await (0, $24YIE.newSendApiRequest)("Get_mls_offices", [
        {
            parameter: "mlsId",
            value: `${mlsId}`
        }
    ], 120000);
};
const $439e2e5017460c6d$export$db271839e1ec6767 = async (mlsId)=>{
    return await (0, $24YIE.newSendApiRequest)("Get_coverage_offices", [
        {
            parameter: "mlsId",
            value: `${mlsId}`
        }
    ], 60000);
};
const $439e2e5017460c6d$export$6d4a9de8e7b3bd5f = async (mlsId, searchFields)=>{
    return await (0, $24YIE.sendApiRequest)("Get_mls_agents", [
        {
            parameter: "mlsId",
            value: `${mlsId}`
        },
        {
            parameter: "searchFields",
            value: `${JSON.stringify(searchFields)}`
        }
    ], 20000);
};
const $439e2e5017460c6d$export$b6d50a81210bd4ff = async (mlsId, agentIds)=>{
    return await (0, $24YIE.sendApiRequest)("Get_mls_agents_by_ids", [
        {
            parameter: "mlsId",
            value: `${mlsId}`
        },
        {
            parameter: "agentIds",
            value: `${JSON.stringify(agentIds)}`
        }
    ], 10000);
};

});

parcelRegister("lEGzp", function(module, exports) {

$parcel$export(module.exports, "getUserSavedSearches", () => $fc3e5af0f993c6f7$export$25c1c504ccf7b546);
$parcel$export(module.exports, "getMarketAreaLists", () => $fc3e5af0f993c6f7$export$728a253212c82895);
$parcel$export(module.exports, "getOfficeLists", () => $fc3e5af0f993c6f7$export$122fb05dc9d10580);
$parcel$export(module.exports, "getAgentLists", () => $fc3e5af0f993c6f7$export$53b2a71dc27b08c);
$parcel$export(module.exports, "getComparisonSetsByUser", () => $fc3e5af0f993c6f7$export$cfafb3e3a1142509);

var $24YIE = parcelRequire("24YIE");

var $f6CJ4 = parcelRequire("f6CJ4");

var $90ISC = parcelRequire("90ISC");

var $cghEn = parcelRequire("cghEn");

var $dDBOF = parcelRequire("dDBOF");

var $6k7XE = parcelRequire("6k7XE");
const $fc3e5af0f993c6f7$export$50fc97751c7c9868 = (userId)=>({
        parameter: (0, $6k7XE.parameters).userId,
        value: `${userId}`
    });
const $fc3e5af0f993c6f7$export$ecf541e09a511845 = (name, value)=>({
        parameter: name,
        value: value
    });
const $fc3e5af0f993c6f7$export$ec161d740909e39d = ({ ownerId: ownerId, userId: userId, tokenType: tokenType })=>{
    const applicationParam = $fc3e5af0f993c6f7$export$ecf541e09a511845((0, $6k7XE.parameters).application, (0, $dDBOF.runningApp));
    const params = [
        applicationParam
    ];
    const isLegacyUser = !userId;
    if (isLegacyUser) {
        params.push($fc3e5af0f993c6f7$export$ecf541e09a511845((0, $6k7XE.parameters).ownerId, `${ownerId}`));
        params.push($fc3e5af0f993c6f7$export$ecf541e09a511845((0, $6k7XE.parameters).ownerType, (0, $cghEn.ownerTypeByTokenType)[tokenType]));
        return params;
    }
    return [
        ...params,
        $fc3e5af0f993c6f7$export$50fc97751c7c9868(userId)
    ];
};
const $fc3e5af0f993c6f7$export$1b2709b250a17de6 = (ownerId)=>{
    const tokenType = (0, $f6CJ4.useAuthStore).getState()?.tokenType;
    const userId = (0, $90ISC.useCommonStore).getState()?.userInfo?.id;
    return $fc3e5af0f993c6f7$export$ec161d740909e39d({
        ownerId: ownerId,
        userId: userId,
        tokenType: tokenType
    });
};
const $fc3e5af0f993c6f7$export$25c1c504ccf7b546 = async (ownerId, module, searchType)=>{
    const userParams = $fc3e5af0f993c6f7$export$1b2709b250a17de6(ownerId);
    const params = [
        ...userParams,
        $fc3e5af0f993c6f7$export$ecf541e09a511845((0, $6k7XE.parameters).module, module),
        $fc3e5af0f993c6f7$export$ecf541e09a511845((0, $6k7XE.parameters).searchType, searchType)
    ];
    return await (0, $24YIE.newSendApiRequest)((0, $6k7XE.endpoints).savedSearchList, params);
};
const $fc3e5af0f993c6f7$export$728a253212c82895 = async (ownerId)=>await (0, $24YIE.newSendApiRequest)((0, $6k7XE.endpoints).marketAreaList, $fc3e5af0f993c6f7$export$1b2709b250a17de6(ownerId));
const $fc3e5af0f993c6f7$export$122fb05dc9d10580 = async (ownerId)=>await (0, $24YIE.newSendApiRequest)((0, $6k7XE.endpoints).officeList, $fc3e5af0f993c6f7$export$1b2709b250a17de6(ownerId));
const $fc3e5af0f993c6f7$export$53b2a71dc27b08c = async (ownerId)=>await (0, $24YIE.newSendApiRequest)((0, $6k7XE.endpoints).agentList, $fc3e5af0f993c6f7$export$1b2709b250a17de6(ownerId));
const $fc3e5af0f993c6f7$export$cfafb3e3a1142509 = async (userId)=>{
    return await (0, $24YIE.newSendApiRequest)((0, $6k7XE.endpoints).mlsObjectList, [
        {
            parameter: (0, $6k7XE.parameters).ownerId,
            value: `${userId}`
        },
        {
            parameter: (0, $6k7XE.parameters).ownerType,
            value: (0, $6k7XE.values).userId
        },
        {
            parameter: (0, $6k7XE.parameters).objectType,
            value: (0, $6k7XE.values).comparisonSet
        }
    ]);
};

});
parcelRegister("6k7XE", function(module, exports) {

$parcel$export(module.exports, "parameters", () => $49aac93941d24d20$export$283c7b7b2d0a1841);
$parcel$export(module.exports, "values", () => $49aac93941d24d20$export$68c286be0e7e55b7);
$parcel$export(module.exports, "endpoints", () => $49aac93941d24d20$export$3a2536d80ecc00e7);
const $49aac93941d24d20$export$283c7b7b2d0a1841 = {
    application: "application",
    module: "module",
    objectType: "objectType",
    ownerId: "ownerId",
    ownerType: "ownerType",
    searchType: "searchType",
    userId: "userId"
};
const $49aac93941d24d20$export$68c286be0e7e55b7 = {
    userId: "userId",
    comparisonSet: "comparison_set"
};
const $49aac93941d24d20$export$3a2536d80ecc00e7 = {
    savedSearchList: "Searches_MLS_Member",
    marketAreaList: "Areas_filter",
    officeList: "OfficeList_get",
    agentList: "Agent_lists",
    mlsObjectList: "MlsObjects_by_user"
};

});


parcelRegister("jpGV2", function(module, exports) {

$parcel$export(module.exports, "intialPersistedSavedAgentsView", () => $e221a4e908432dc6$export$37cb608d69165a49);
$parcel$export(module.exports, "initialSavedAgentStore", () => $e221a4e908432dc6$export$7d5ba1bf5e0116db);
$parcel$export(module.exports, "useSavedAgentsStore", () => $e221a4e908432dc6$export$3b3fde3b03d2cd8b);

var $88tPr = parcelRequire("88tPr");

var $9phu9 = parcelRequire("9phu9");

var $994ap = parcelRequire("994ap");

var $cstaF = parcelRequire("cstaF");

var $aypMh = parcelRequire("aypMh");
const $e221a4e908432dc6$export$37cb608d69165a49 = Object.freeze({
    selectedView: (0, $aypMh.viewOptions)[1]
});
const $e221a4e908432dc6$export$7d5ba1bf5e0116db = {
    ...$e221a4e908432dc6$export$37cb608d69165a49,
    selectedListByModule: {
        [(0, $cstaF.modules).proficiencyMetrics.agents]: undefined,
        [(0, $cstaF.modules).proficiencyMetrics.savedAgents]: undefined
    },
    agentList: undefined,
    propertyTypeNames: [],
    isLoading: false,
    agentListsCheckedValues: {},
    globalSavedAgentListId: undefined,
    popoverDataForAddAgentList: {},
    manualSearchData: null,
    activities: null,
    isLoadingActivities: false,
    dirtyListIds: {}
};
const $e221a4e908432dc6$var$savedAgentsStore = (set, get)=>({
        ...$e221a4e908432dc6$export$7d5ba1bf5e0116db,
        ...(0, $994ap.actions)(set, get)
    });
const $e221a4e908432dc6$export$3b3fde3b03d2cd8b = (0, $9phu9.createWithEqualityFn)((0, $88tPr.devtools)((0, $88tPr.persist)($e221a4e908432dc6$var$savedAgentsStore, {
    name: "saved_agents_state",
    storage: (0, $88tPr.createJSONStorage)(()=>localStorage)
})));

});
parcelRegister("994ap", function(module, exports) {

$parcel$export(module.exports, "actions", () => $6a882fcc369f4b25$export$e324594224ef24da);

var $bnHw5 = parcelRequire("bnHw5");

var $aypMh = parcelRequire("aypMh");

var $fPGDZ = parcelRequire("fPGDZ");

var $ivaD7 = parcelRequire("ivaD7");

var $cstaF = parcelRequire("cstaF");

var $i1BZc = parcelRequire("i1BZc");

var $5NVz0 = parcelRequire("5NVz0");

var $8QuU9 = parcelRequire("8QuU9");

var $90ISC = parcelRequire("90ISC");

var $enZF7 = parcelRequire("enZF7");

var $24YIE = parcelRequire("24YIE");

var $jpGV2 = parcelRequire("jpGV2");

var $iCDWi = parcelRequire("iCDWi");

var $eickZ = parcelRequire("eickZ");

var $f6CJ4 = parcelRequire("f6CJ4");

var $cghEn = parcelRequire("cghEn");

var $jeANf = parcelRequire("jeANf");
const $6a882fcc369f4b25$export$e324594224ef24da = (set, get)=>({
        ...(0, $enZF7.agentListsEditModalActions)(set, get),
        runSelectedList: async (setState, setModuleAgentData, forceRefetch = false)=>{
            const savedAgentsModule = (0, $cstaF.modules).proficiencyMetrics.savedAgents;
            const selectedList = get().selectedListByModule[savedAgentsModule];
            const mlsId = selectedList?.mlsId;
            const agentIds = selectedList?.agentIds;
            const agentListId = selectedList?.agentListId;
            if (!selectedList || !mlsId) return;
            const currentSearchResults = (0, $eickZ.useSearchResultsStore).getState()[savedAgentsModule]?.searchResults;
            const isSameMls = currentSearchResults?.[0]?.mlsSid === mlsId;
            const isCacheValid = currentSearchResults?.length === 0 && agentIds?.length === 0;
            const shouldUseCache = !forceRefetch && Array.isArray(currentSearchResults) && (isSameMls || isCacheValid);
            if (shouldUseCache) {
                const rankedCacheResults = (0, $fPGDZ.getRowDataSortedAndRanked)(currentSearchResults);
                (0, $ivaD7.setStateData)("agentData", currentSearchResults, setState);
                setModuleAgentData(currentSearchResults);
                (0, $ivaD7.setStateData)("rowData", rankedCacheResults, setState);
                (0, $ivaD7.setStateData)("prevSelectedList", selectedList, setState);
                (0, $eickZ.useSearchResultsStore).getState().setSavedAgentsSearchResults(rankedCacheResults);
                return;
            }
            try {
                set({
                    isLoading: true
                });
                const currentActivitiesMlsId = get().activitiesMlsId;
                const mlsIdString = mlsId?.toString();
                const mlsHasChanged = currentActivitiesMlsId !== mlsIdString;
                if (mlsHasChanged || forceRefetch) {
                    set({
                        activities: null,
                        isLoadingActivities: false,
                        activitiesMlsId: mlsHasChanged ? null : currentActivitiesMlsId,
                        activitiesFetchKey: null
                    });
                    (0, $ivaD7.setStateData)("activityRowData", [], setState);
                }
                (0, $ivaD7.setStateData)("selectedAgentsView", (0, $aypMh.types).SHOW_ALL_AGENTS, setState);
                const propertyTypes = await (0, $5NVz0.getPropertyTypes)(mlsId);
                propertyTypes && (0, $90ISC.useCommonStore).setState({
                    propertyTypes: propertyTypes
                });
                const searchCriteriaPropertyTypes = (0, $bnHw5.getSearchCriteriaPropertyTypes)(propertyTypes);
                const propertyTypeIds = (0, $bnHw5.getPropertyTypeValues)(searchCriteriaPropertyTypes, "typeId");
                const propertyTypeNames = (0, $bnHw5.getPropertyTypeValues)(searchCriteriaPropertyTypes, "longName");
                const restrictedMlsSettings = (0, $fPGDZ.getMlsRestrictionSettings)(mlsId);
                set({
                    propertyTypeNames: propertyTypeNames
                });
                const savedTimePeriod = (0, $90ISC.useSearchStore).getState()[savedAgentsModule]?.loadedSearchCriteria?.timePeriod;
                const timePeriod = {
                    intervalType: savedTimePeriod?.intervalType ?? (0, $cstaF.TimePeriods)[(0, $cstaF.agentProductionTerms).last12Months],
                    startDate: savedTimePeriod?.startDate ?? null,
                    endDate: savedTimePeriod?.endDate ?? null
                };
                const searchCriteria = (0, $iCDWi.buildSearchCriteria)({
                    mlsId: mlsId,
                    propertyTypeIds: propertyTypeIds,
                    propertyTypeNames: propertyTypeNames,
                    agentIds: agentIds,
                    listId: agentListId,
                    timePeriod: timePeriod
                });
                setState((prevState)=>({
                        ...prevState,
                        searchCriteria: searchCriteria,
                        contactInfoColumns: (0, $fPGDZ.getDefaultContactInfoColumns)(restrictedMlsSettings)
                    }));
                const { recruitingSoldResponse: recruitingSoldResponse, recruitingSoldTotals: recruitingSoldTotals } = await (0, $8QuU9.getProficiencyMetrics)(searchCriteria);
                if (typeof agentListId === "number") (0, $24YIE.recordAgentListLoad)(agentListId).catch(()=>{});
                const rankedResponse = (0, $fPGDZ.getRowDataSortedAndRanked)(recruitingSoldResponse);
                (0, $ivaD7.setStateData)("agentData", recruitingSoldResponse, setState);
                get().setManualSearchData(recruitingSoldResponse);
                setModuleAgentData(recruitingSoldResponse);
                (0, $ivaD7.setStateData)("rowData", rankedResponse, setState);
                get().setSavedAgentSearch(searchCriteria);
                (0, $ivaD7.setStateData)("prevSelectedList", selectedList, setState);
                (0, $eickZ.useSearchResultsStore).getState().setSavedAgentsSearchResults(rankedResponse || []);
                (0, $90ISC.useSearchStore).getState().setTotalsRowData(recruitingSoldTotals, (0, $i1BZc.responseKeys).recruitingSoldTotals);
                const selectedView = get().selectedView;
                (0, $90ISC.useSearchStore).getState().setSummaryPinnedData(selectedView.value, (0, $i1BZc.responseKeys).recruitingSoldTotals);
            } catch (error) {
                console.log({
                    error: error
                });
            } finally{
                set({
                    isLoading: false
                });
                get().clearListDirtyFlag(agentListId);
            }
        },
        setSavedAgentSearch: (searchCriteria)=>{
            const selectedModule = (0, $90ISC.useSearchStore).getState().selectedModule;
            const selectedList = get().selectedListByModule[selectedModule];
            const membership = (0, $90ISC.useCommonStore).getState().membership;
            if (selectedModule !== (0, $cstaF.modules).proficiencyMetrics.savedAgents) return;
            (0, $90ISC.useSearchStore).setState({
                isLoading: true
            });
            try {
                (0, $90ISC.useSearchStore).setState((state)=>({
                        [selectedModule]: {
                            ...state[selectedModule],
                            search: {
                                ...selectedList,
                                searchCriteria: {
                                    ...searchCriteria
                                }
                            },
                            loadedSearchCriteria: searchCriteria.criteria,
                            selectedMls: membership.find((mls)=>mls.mlsId === selectedList?.mlsId)
                        }
                    }));
                (0, $90ISC.useSearchStore).setState({
                    isLoading: false
                });
            } catch (error) {
                console.log(error);
            }
        },
        resetStore: ()=>{
            set((0, $jpGV2.initialSavedAgentStore));
        },
        getMlsName: ()=>{
            const selectedModule = (0, $90ISC.useSearchStore).getState().selectedModule;
            const selectedList = get().selectedListByModule[selectedModule];
            const mlsId = selectedList?.mlsId;
            const membership = (0, $90ISC.useCommonStore).getState().membership;
            return membership.find((p)=>p?.mlsId === mlsId)?.shortDescription;
        },
        setManualSearchData: (recruitingSoldResponse)=>{
            set({
                manualSearchData: recruitingSoldResponse
            });
        },
        setSelectedListByModule: (module, list)=>{
            const prevState = get().selectedListByModule;
            set({
                selectedListByModule: {
                    ...prevState,
                    [module]: list
                }
            });
        },
        clearSelectedAgentList: ()=>{
            const prevState = get().selectedListByModule;
            set({
                selectedListByModule: {
                    ...prevState,
                    [(0, $cstaF.modules).proficiencyMetrics.agents]: undefined
                }
            });
        },
        setGlobalSavedAgentListId: (globalSavedAgentListId)=>{
            set({
                globalSavedAgentListId: globalSavedAgentListId
            });
        },
        getAgentListSelectedValue: (optionGroups)=>{
            if (!optionGroups) return undefined;
            const selectedList = get().selectedListByModule[(0, $cstaF.modules).proficiencyMetrics.agents];
            const titleOption = optionGroups?.[0].options[0];
            if (!selectedList) return titleOption;
            return optionGroups?.[1].options.find((option)=>selectedList.agentListId === option.value);
        },
        getSavedAgentsActivities: async (mlsId, timeInterval)=>{
            if (!mlsId) return undefined;
            const fetchKey = `${mlsId}-${timeInterval.from}-${timeInterval.to}`;
            const currentFetchKey = get().activitiesFetchKey;
            if (currentFetchKey === fetchKey && get().activities !== null) return;
            set({
                isLoadingActivities: true
            });
            try {
                const response = await (0, $24YIE.getDashboardRecentActivity)(mlsId, timeInterval);
                set({
                    activities: response?.activities ?? [],
                    activitiesFetchKey: fetchKey,
                    activitiesMlsId: mlsId?.toString()
                });
            } catch (error) {
                console.log(error);
            } finally{
                set({
                    isLoadingActivities: false
                });
            }
        },
        findAgentListById: ()=>{
            const searchStore = (0, $90ISC.useSearchStore).getState();
            const commonStore = (0, $90ISC.useCommonStore).getState();
            const selectedModule = searchStore.selectedModule;
            const selectedAgentListId = searchStore[selectedModule]?.search?.searchCriteria?.criteria?.realEstateDatasourceIdsWithFilters?.[0]?.idFiltering?.[0]?.listId;
            const agentsList = commonStore?.agentLists;
            if (!selectedAgentListId || !agentsList?.length) return;
            return agentsList.find((agentList)=>agentList.agentListId === selectedAgentListId);
        },
        setSelectedView: (selectedView)=>set({
                selectedView: selectedView
            }),
        setSavedAgentList: async ({ savedAgentListIds: savedAgentListIds, selectedCount: selectedCount, selectedAgentIds: selectedAgentIds, setToastProps: setToastProps })=>{
            try {
                const { agentLists: agentLists, getAgentLists: getAgentLists } = (0, $90ISC.useCommonStore).getState();
                const requests = savedAgentListIds.map((id)=>{
                    const agentList = agentLists.find((l)=>l.agentListId === parseInt(id));
                    const revisedAgentList = {
                        ...agentList,
                        agentIds: [
                            ...new Set([
                                ...agentList.agentIds,
                                ...selectedAgentIds
                            ])
                        ]
                    };
                    (0, $jpGV2.useSavedAgentsStore).getState().setSelectedListByModule(revisedAgentList);
                    return {
                        promise: (0, $24YIE.updateSavedAgentList)(revisedAgentList, true),
                        agentList: agentList
                    };
                });
                const results = await Promise.all(requests.map((r)=>r.promise));
                results.forEach((res, index)=>{
                    const { agentList: agentList } = requests[index];
                    const hasError = !res || res.error >= 400;
                    if (hasError) (0, $jeANf.showToast)((0, $jeANf.toastTypes).error, (0, $cstaF.agentProductionTerms).unableToAddAgents(agentList?.name), setToastProps);
                    else (0, $jeANf.showToast)((0, $jeANf.toastTypes).success, (0, $cstaF.agentProductionTerms).agentsAddedSuccessfully(selectedCount > 1, agentList?.name), setToastProps);
                });
                // Code block to sync agents in Agent Name module when search results are displayed
                const agentNameModule = (0, $cstaF.modules).proficiencyMetrics.agents;
                const agentNameSearch = (0, $90ISC.useSearchStore).getState()[agentNameModule];
                const agentNameListId = agentNameSearch?.search?.searchCriteria?.criteria?.realEstateDatasourceIdsWithFilters?.[0]?.idFiltering?.[0]?.listId;
                if (agentNameListId) results.forEach((res, index)=>{
                    const hasError = !res || res.error >= 400;
                    if (hasError) return;
                    const { agentList: agentList } = requests[index];
                    if (agentList.agentListId === agentNameListId) {
                        const updatedAgentIds = [
                            ...new Set([
                                ...agentList.agentIds,
                                ...selectedAgentIds
                            ])
                        ];
                        (0, $90ISC.useSearchStore).getState().setListInSearchByAgentSearch(updatedAgentIds, agentNameListId);
                    }
                });
                const { tokenType: tokenType, tokenInfo: tokenInfo } = (0, $f6CJ4.useAuthStore).getState();
                const ownerId = tokenType && (0, $cghEn.getOwnerIdByTokenInfo)[tokenType](tokenInfo);
                getAgentLists(ownerId);
            } catch (err) {
                console.error(err);
                (0, $jeANf.showToast)((0, $jeANf.toastTypes).error, (0, $cstaF.agentProductionTerms).unableToAddAgents(), setToastProps);
            }
        },
        resetPersistedData: ()=>set((state)=>({
                    ...state,
                    ...(0, $jpGV2.intialPersistedSavedAgentsView)
                })),
        markListAsDirty: (listId)=>{
            set({
                dirtyListIds: {
                    ...get().dirtyListIds,
                    [listId]: true
                }
            });
        },
        clearListDirtyFlag: (listId)=>{
            const updated = {
                ...get().dirtyListIds
            };
            delete updated[listId];
            set({
                dirtyListIds: updated
            });
        }
    });

});
parcelRegister("bnHw5", function(module, exports) {

$parcel$export(module.exports, "getPropertyTypeValues", () => $849399286ba163df$export$9381383eb8b4ae80);
$parcel$export(module.exports, "getSearchCriteriaPropertyTypes", () => $849399286ba163df$export$3add08d2bc4b50b9);
$parcel$export(module.exports, "popoverIds", () => $849399286ba163df$export$51ce7345482f4fda);
$parcel$export(module.exports, "recentSortFunction", () => $849399286ba163df$export$d9bb5295caaef40);
$parcel$export(module.exports, "getSelectedAgentList", () => $849399286ba163df$export$8c0cbc46c66f89ef);
$parcel$export(module.exports, "getFooterLabels", () => $849399286ba163df$export$a616f35f3d8847f5);

var $cstaF = parcelRequire("cstaF");

var $eHBjM = parcelRequire("eHBjM");

var $fVDYX = parcelRequire("fVDYX");
const $849399286ba163df$export$9381383eb8b4ae80 = (propertyTypes, keyToMap)=>{
    if (!propertyTypes.length) return;
    let revisedPropertyTypes = [];
    for (let obj of propertyTypes){
        const properties = obj?.types.filter((obj)=>keyToMap in obj).map((obj)=>String(obj[keyToMap]));
        revisedPropertyTypes = [
            ...revisedPropertyTypes,
            ...properties
        ];
    }
    return Array.from(new Set(revisedPropertyTypes));
};
const $849399286ba163df$export$3add08d2bc4b50b9 = (propertyTypes)=>{
    const propertyTypeCategories = (0, $cstaF.MLS_PROPERTY_TYPE_CLASS_ID)["RESIDENTIAL"];
    return propertyTypes.filter((obj)=>obj.classId === propertyTypeCategories);
};
const $849399286ba163df$export$51ce7345482f4fda = Object.freeze({
    display: "display-dropdown",
    metrics: "metrics-dropdown"
});
const $849399286ba163df$export$d9bb5295caaef40 = (selectedId)=>(a, b)=>{
        if (a.agentListId === selectedId) return -1;
        if (b.agentListId === selectedId) return 1;
        const getDate = (obj)=>new Date(obj?.lastLoadTs);
        return getDate(b) - getDate(a);
    };
const $849399286ba163df$export$8c0cbc46c66f89ef = (agentLists, selectedSavedAgentListId)=>{
    if (!selectedSavedAgentListId) return [
        ...agentLists
    ].sort($849399286ba163df$export$d9bb5295caaef40())[0];
    const isAllListsSelected = selectedSavedAgentListId?.toString()?.includes("all-lists");
    if (isAllListsSelected) {
        const mlsId = parseInt(selectedSavedAgentListId.split("-")[2], 10);
        const agentIds = agentLists.filter((agent)=>agent.mlsId === mlsId).flatMap((agent)=>agent.agentIds);
        return {
            agentListId: selectedSavedAgentListId,
            name: (0, $eHBjM.favoriteAgentTerms).reservedListName,
            mlsId: mlsId,
            agentIds: [
                ...new Set(agentIds)
            ]
        };
    }
    return agentLists.find((list)=>list.agentListId === selectedSavedAgentListId);
};
const $849399286ba163df$export$a616f35f3d8847f5 = ({ loadedSearchFields: loadedSearchFields, selectedTimePeriod: selectedTimePeriod, propertyTypes: propertyTypes })=>{
    const selectedArea = loadedSearchFields && loadedSearchFields?.searchFields?.find((sf)=>sf.fieldName !== "propertyType");
    const areaLabel = loadedSearchFields && loadedSearchFields?.searchAllMLS ? (0, $cstaF.agentProductionTerms).allMls : `${selectedArea?.fieldTypeName}: ${selectedArea?.fieldValues?.join(", ")}`;
    const getFormattedDates = (selectedTimePeriod)=>{
        if (!selectedTimePeriod) return;
        return {
            from: new Date(selectedTimePeriod?.last?.from),
            to: new Date(selectedTimePeriod?.last?.to)
        };
    };
    const timePeriodTitle = (0, $fVDYX.getFooterTimePeriodValue)(getFormattedDates(selectedTimePeriod));
    const getSelectedPropertyTypesLabel = (propertyClasses, searchFields)=>{
        if (!searchFields || !propertyClasses) return "";
        const selectedIds = searchFields.flatMap((field)=>field.fieldValues.map(Number));
        const classNames = [];
        const revisedPropertyTypes = [];
        for (const selectedId of selectedIds)for (const propertyClass of propertyClasses){
            const type = propertyClass.types.find((pt)=>pt.typeId === selectedId);
            if (!type) continue;
            if (!classNames.includes(propertyClass.longName)) classNames.push(propertyClass.longName);
            revisedPropertyTypes.push(type.longName);
            break;
        }
        return `${classNames.join(", ")}: ${revisedPropertyTypes.join(", ")}`;
    };
    const propertyTypeFooterLabel = getSelectedPropertyTypesLabel(propertyTypes, loadedSearchFields?.searchFields);
    return {
        areaLabel: areaLabel,
        timePeriodTitle: timePeriodTitle,
        propertyTypeFooterLabel: propertyTypeFooterLabel
    };
};

});
parcelRegister("eHBjM", function(module, exports) {

$parcel$export(module.exports, "agentProfileRoute", () => $ab420772d827bb15$export$4aa854293c7e2eba);
$parcel$export(module.exports, "productionListingRoute", () => $ab420772d827bb15$export$b070dce6177a2480);
$parcel$export(module.exports, "agentProductionListingRoute", () => $ab420772d827bb15$export$71e7673cdfc791dd);
$parcel$export(module.exports, "agentListingInfoRoute", () => $ab420772d827bb15$export$623b9de617436deb);
$parcel$export(module.exports, "coverageListingRoute", () => $ab420772d827bb15$export$819b5c6f408b717e);
$parcel$export(module.exports, "viewHideAgentsDropdownLabels", () => $ab420772d827bb15$export$88b7c356a43367ae);
$parcel$export(module.exports, "tableViewNames", () => $ab420772d827bb15$export$476fa77889653444);
$parcel$export(module.exports, "superHeaders", () => $ab420772d827bb15$export$99b56b957836427);
$parcel$export(module.exports, "agentsColumns", () => $ab420772d827bb15$export$290e990ef234d58d);
$parcel$export(module.exports, "tabModes", () => $ab420772d827bb15$export$c4fefec0b0e3d8a5);
$parcel$export(module.exports, "agentCoverageListingTabs", () => $ab420772d827bb15$export$35a0dd6df300876c);
$parcel$export(module.exports, "agentProfileTabs", () => $ab420772d827bb15$export$a9394c482144912c);
$parcel$export(module.exports, "inventoryTables", () => $ab420772d827bb15$export$a6af8f8ffca8ca7a);
$parcel$export(module.exports, "agentProfileTabNamesByIndex", () => $ab420772d827bb15$export$4d227e2da3d6dc19);
$parcel$export(module.exports, "dealStatusCodes", () => $ab420772d827bb15$export$da12459e9e994233);
$parcel$export(module.exports, "listingOptions", () => $ab420772d827bb15$export$d4758f7de7da0463);
$parcel$export(module.exports, "productionOptions", () => $ab420772d827bb15$export$42ff02d7de9a2e8a);
$parcel$export(module.exports, "transactionCoverageOptions", () => $ab420772d827bb15$export$3e3df960e2b906d7);
$parcel$export(module.exports, "mlsAreaTypes", () => $ab420772d827bb15$export$f8b455c4c89b3ea6);
$parcel$export(module.exports, "additionalOfficeAddressColumns", () => $ab420772d827bb15$export$e99aaa9a8aadc99a);
$parcel$export(module.exports, "transactionCoverageSoldColumns", () => $ab420772d827bb15$export$8ae681fac1096e94);
$parcel$export(module.exports, "transactionCoverageUcColumns", () => $ab420772d827bb15$export$25d368e1d586d0be);
$parcel$export(module.exports, "transactionCoverageForSaleColumns", () => $ab420772d827bb15$export$80f0d9d593bac063);
$parcel$export(module.exports, "transactionCoverageTableTypes", () => $ab420772d827bb15$export$47af531ee468dcb6);
$parcel$export(module.exports, "agentProfileButtons", () => $ab420772d827bb15$export$63bfa7109e75d47e);
$parcel$export(module.exports, "productionChartTabToolTips", () => $ab420772d827bb15$export$ad32f8c43df6be25);
$parcel$export(module.exports, "productionTableTabToolTips", () => $ab420772d827bb15$export$925c2aa97e52e400);
$parcel$export(module.exports, "inventoryTableTooltips", () => $ab420772d827bb15$export$7daad41a599eb587);
$parcel$export(module.exports, "currentlyUCTooltips", () => $ab420772d827bb15$export$d20c5ea5af06242a);
$parcel$export(module.exports, "currentlyFSTooltips", () => $ab420772d827bb15$export$ecc31078313012e8);
$parcel$export(module.exports, "coverageChartTooltips", () => $ab420772d827bb15$export$41ad0c5a50c3c227);
$parcel$export(module.exports, "coverTableSoldTooltips", () => $ab420772d827bb15$export$3aaaf363d99b232f);
$parcel$export(module.exports, "coverTableUcTooltips", () => $ab420772d827bb15$export$831c4f31e5ccab84);
$parcel$export(module.exports, "coverTableForSaleTooltips", () => $ab420772d827bb15$export$f2e671ab2c5e5e2f);
$parcel$export(module.exports, "overviewToolTips", () => $ab420772d827bb15$export$9866cc3252996bc4);
$parcel$export(module.exports, "contactToolTips", () => $ab420772d827bb15$export$9ef800376351bd07);
$parcel$export(module.exports, "contactToolTipsSA", () => $ab420772d827bb15$export$fc1a5a962b878c37);
$parcel$export(module.exports, "overviewToolTipsSA", () => $ab420772d827bb15$export$edfe74661fed48af);
$parcel$export(module.exports, "activityToolTips", () => $ab420772d827bb15$export$57d4c0b0ab25d58b);
$parcel$export(module.exports, "growthAnalysisTooltips", () => $ab420772d827bb15$export$1f68bac5d85032d3);
$parcel$export(module.exports, "growthAnalysisTooltipsL90d", () => $ab420772d827bb15$export$a1429db100c1098b);
$parcel$export(module.exports, "incDecLtmGrowthAnalysisTooltips", () => $ab420772d827bb15$export$940c698cf6212611);
$parcel$export(module.exports, "incDecYtdGrowthAnalysisTooltips", () => $ab420772d827bb15$export$6b1268a6a5495172);
$parcel$export(module.exports, "listingProficiencyColTitles", () => $ab420772d827bb15$export$6064337aeedc035f);
$parcel$export(module.exports, "listingProficiencyTooltips", () => $ab420772d827bb15$export$18c017579417a58);
$parcel$export(module.exports, "listingProficiencyTooltipsSA", () => $ab420772d827bb15$export$4fcb2154ac6197e7);
$parcel$export(module.exports, "officeHistoryTooltips", () => $ab420772d827bb15$export$bbda0b45e6747154);
$parcel$export(module.exports, "productionListingsTooltips", () => $ab420772d827bb15$export$5cfb32d4bd86a1b1);
$parcel$export(module.exports, "coverageListingsTooltips", () => $ab420772d827bb15$export$6751f178d0127cda);
$parcel$export(module.exports, "pricingHistoryTooltips", () => $ab420772d827bb15$export$5482b997bb0ea53a);
$parcel$export(module.exports, "availableAgentsTooltips", () => $ab420772d827bb15$export$f1d71ecb22c54c48);
$parcel$export(module.exports, "addedAgentsTooltips", () => $ab420772d827bb15$export$f3cb48e74e28c392);
$parcel$export(module.exports, "availableOfficesTooltips", () => $ab420772d827bb15$export$6a5dc8a672d29538);
$parcel$export(module.exports, "additionalTableHeaders", () => $ab420772d827bb15$export$e5b8f80f89782c65);
$parcel$export(module.exports, "favoriteAgentTerms", () => $ab420772d827bb15$export$3cec44e1103dfb75);
$parcel$export(module.exports, "popoverTerms", () => $ab420772d827bb15$export$f66e80ecd091dbdb);

var $cstaF = parcelRequire("cstaF");

var $c7dF9 = parcelRequire("c7dF9");

var $dDBOF = parcelRequire("dDBOF");
const $ab420772d827bb15$export$a2b8c5c0af14b22d = (0, $dDBOF.isAgentMetrics) ? (0, $c7dF9.Routes).AGENT_PRODUCTION.BASE : (0, $c7dF9.Routes).PROF_METRICS.BASE;
const $ab420772d827bb15$export$4aa854293c7e2eba = `${$ab420772d827bb15$export$a2b8c5c0af14b22d}${(0, $dDBOF.isAgentMetrics) ? "" : (0, $c7dF9.Routes).PROF_METRICS.AGENT_PROFILE}`;
const $ab420772d827bb15$export$b070dce6177a2480 = `${$ab420772d827bb15$export$a2b8c5c0af14b22d}${(0, $c7dF9.Routes).PROF_METRICS.PROD_LISTING}`;
const $ab420772d827bb15$export$71e7673cdfc791dd = `${$ab420772d827bb15$export$a2b8c5c0af14b22d}${(0, $c7dF9.Routes).PROF_METRICS.PROD_LISTING}`;
const $ab420772d827bb15$export$623b9de617436deb = `${$ab420772d827bb15$export$a2b8c5c0af14b22d}${(0, $c7dF9.Routes).PROF_METRICS.LISTING_INFO}`;
const $ab420772d827bb15$export$819b5c6f408b717e = `${$ab420772d827bb15$export$a2b8c5c0af14b22d}${(0, $c7dF9.Routes).PROF_METRICS.COVERAGE_LISTING}`;
const $ab420772d827bb15$export$88b7c356a43367ae = Object.freeze({
    viewHideAgents: "View/Hide Agents",
    viewOnlyMyAgents: "View Only My Agents",
    hideMyAgents: "Hide My Agents"
});
const $ab420772d827bb15$export$476fa77889653444 = Object.freeze({
    availableOffices: "availableOffices",
    addedOffices: "addedOffices",
    overview: "overview",
    activity: "activity",
    overviewCoopAgents: "overviewCoopAgents",
    pricingHistory: "pricingHistory",
    growthAnalysisLtm: "growthAnalysisLtm",
    growthAnalysisYtd: "growthAnalysisYtd",
    inventory: "inventory",
    forSale: "forSale",
    underContract: "underContract",
    agentDetailProduction: "agentDetailProduction",
    contactInformation: "contactInformation",
    transactionCoverageSold: "transactionCoverageSold",
    transactionCoverageUc: "transactionCoverageUc",
    transactionCoverageForSale: "transactionCoverageForSale",
    transactionCoveragePDF: "transactionCoveragePDF",
    listingProficiency: "listingProficiency",
    availableAgents: "availableAgents",
    addedAgents: "addedAgents",
    officeHistory: "officeHistory",
    agentCoverageListingForSale: "agentCoverageListingForSale",
    agentCoverageListingSold: "agentCoverageListingSold",
    agentCoverageListingUc: "agentCoverageListingUc",
    agentProductionListingTotalSold: "agentProductionListingTotalSold",
    agentProductionListingListSide: "agentProductionListingListSide",
    agentProductionListingSellSide: "agentProductionListingSellSide",
    agentMovement: "agentMovement",
    incDecGrowthAnalysisLtm: "incDecGrowthAnalysisLtm",
    incDecGrowthAnalysisYtd: "incDecGrowthAnalysisYtd",
    growthAnalysisL90: "growthAnalysisL90",
    incDecOverview: "incDecOverview",
    agentsGainedBreakdown: "agentsGainedBreakdown",
    lostAgentsBreakdown: "lostAgentsBreakdown",
    officeBreakdown: "officeBreakdown"
});
const $ab420772d827bb15$export$99b56b957836427 = {
    transactionCoverageSold: [
        {
            column1: {
                title: ""
            },
            column2: {
                title: "LIST SIDE"
            },
            column3: {
                title: "SELL SIDE"
            },
            column4: {
                title: "TOTAL"
            }
        }
    ],
    transactionCoverageUc: [
        {
            column1: {
                title: ""
            },
            column2: {
                title: "Currently Under Contract"
            }
        }
    ],
    transactionCoverageForSale: [
        {
            column1: {
                title: ""
            },
            column2: {
                title: "Currently For Sale"
            }
        }
    ]
};
const $ab420772d827bb15$export$290e990ef234d58d = Object.freeze({
    rank: {
        id: "rank",
        label: "Rank"
    },
    agentName: {
        id: "agentName",
        label: "Agent Name"
    },
    agentId: {
        id: "agentId",
        label: "Agent ID"
    },
    county: {
        id: "county",
        label: "County"
    },
    officeName: {
        id: "officeName",
        label: "Office Name"
    },
    officeId: {
        id: "officeId",
        label: "Office ID"
    },
    officeAddress: {
        id: "officeAddress",
        label: "Office Address"
    },
    officeCity: {
        id: "officeCity",
        label: "City",
        parentColumnId: "officeAddress"
    },
    officeZipCode: {
        id: "officeZipCode",
        label: "Zip",
        parentColumnId: "officeAddress"
    },
    officeCounty: {
        id: "officeCounty",
        label: "County",
        parentColumnId: "officeAddress"
    },
    agentPhone1: {
        id: "agentPhone1",
        label: "Phone 1"
    },
    agentPhone2: {
        id: "agentPhone2",
        label: "Phone 2"
    },
    agentPhone3: {
        id: "agentPhone3",
        label: "Phone 3"
    },
    agentPhoneType1: {
        id: "agentPhoneType1",
        label: "Phone Type 1"
    },
    agentPhoneType2: {
        id: "agentPhoneType2",
        label: "Phone Type 2"
    },
    agentPhoneType3: {
        id: "agentPhoneType3",
        label: "Phone Type 3"
    },
    agentEmail: {
        id: "agentEmail",
        label: "Email"
    },
    agentAddress: {
        id: "agentAddress",
        label: "Alternate Address"
    },
    area: {
        id: "area",
        label: "Area"
    },
    listVolume: {
        id: "listVolume",
        label: "List Side ($)"
    },
    sellVolume: {
        id: "sellVolume",
        label: "Sell Side ($)"
    },
    totalVolume: {
        id: "totalVolume",
        label: "Total ($)"
    },
    listUnits: {
        id: "listUnits",
        label: "List Side (#)"
    },
    sellUnits: {
        id: "sellUnits",
        label: "Sell Side (#)"
    },
    totalUnits: {
        id: "totalUnits",
        label: "Total (#)"
    },
    totalUnitsGrowth: {
        id: "totalUnitsGrowth",
        label: "% Change"
    },
    totalUnitsPct: {
        id: "totalUnitsPct",
        label: "% Change"
    },
    totalUnitsChange: {
        id: "totalUnitsChange",
        label: "Growth (#)"
    },
    totalVolumeGrowth: {
        id: "totalVolumeGrowth",
        label: "% Change"
    },
    totalVolumePct: {
        id: "totalVolumePct",
        label: "% Change"
    },
    totalVolumeChange: {
        id: "totalVolumeChange",
        label: "$ Change"
    },
    ciTotalVolumeChange: {
        id: "totalVolumeChange",
        label: "$ Change"
    },
    totalSell: {
        id: "totalSell",
        label: "Total Sell"
    },
    totalList: {
        id: "totalList",
        label: "Total List"
    },
    noPriceChangeListings: {
        id: "noPriceChangeListings",
        label: "No Price Change Listings"
    },
    priceChangeListings: {
        id: "priceChangeListings",
        label: "Price Change Listings"
    },
    totalDollarVolume: {
        id: "totalDollarVolume",
        label: "Volume ($)"
    },
    ptmTotalVolume: {
        id: "ptmTotalVolume",
        label: "Previous 12 Months Total Volume"
    },
    ptmTotalUnits: {
        id: "ptmTotalUnits",
        label: "Previous 12 Months Total Units"
    },
    ptmNum: {
        id: "ptmNum",
        label: "Previous 12 Months #"
    },
    ltmNum: {
        id: "ltmNum",
        label: "Last 12 Months #"
    },
    ptm$: {
        id: "ptm$",
        label: "Previous 12 Months $"
    },
    ltm$: {
        id: "ltm$",
        label: "Last 12 Months $"
    },
    averagePrice: {
        id: "averagePrice",
        label: "Avg. Price"
    },
    last12Spop: {
        id: "last12Spop",
        label: "SP/OP"
    },
    last12AvgDom: {
        id: "last12AvgDom",
        label: "Avg. DOM"
    },
    last12ListVolume: {
        id: "last12ListVolume",
        label: "List Side ($)"
    },
    last12SellVolume: {
        id: "last12SellVolume",
        label: "Sell Side ($)"
    },
    last12TotalVolume: {
        id: "last12TotalVolume",
        label: "Total ($)"
    },
    last12ListUnits: {
        id: "last12ListUnits",
        label: "List Side (#)"
    },
    ltmListUnits: {
        id: "last12ListUnits",
        label: "List Side (#)"
    },
    last12SellUnits: {
        id: "last12SellUnits",
        label: "Sell Side (#)"
    },
    last12TotalUnits: {
        id: "last12TotalUnits",
        label: "Total (#)"
    },
    ltmTotalUnitsChange: {
        id: "ltmTotalUnitsChange",
        label: "Change #"
    },
    ltmTotalUnitsGrowth: {
        id: "ltmTotalUnitsGrowth",
        label: "% Change #"
    },
    ltmTotalVolumeChange: {
        id: "ltmTotalVolumeChange",
        label: "Change $"
    },
    ltmTotalVolumeGrowth: {
        id: "ltmTotalVolumeGrowth",
        label: "% Change $"
    },
    ltmTotalSideUnits: {
        id: "ltmTotalSideUnits",
        label: "Units (#)"
    },
    ltmTotalDollarVolume: {
        id: "ltmTotalDollarVolume",
        label: "Volume ($)"
    },
    ytdPrevYearNum: {
        id: "ytdPrevYearNum",
        label: "YTD Previous Year #"
    },
    ytdCurrentYearNum: {
        id: "ytdCurrentYearNum",
        label: "YTD Current Year #"
    },
    changeNum: {
        id: "changeNum",
        label: "Change #"
    },
    pctChangeNum: {
        id: "pctChangeNum",
        label: "% Change #"
    },
    ytdPrevYear$: {
        id: "ytdPrevYear$",
        label: "YTD Previous Year $"
    },
    ytdCurrentYear$: {
        id: "ytdCurrentYear$",
        label: "YTD Current Year $"
    },
    change$: {
        id: "change$",
        label: "Change $"
    },
    pctChange$: {
        id: "pctChange$",
        label: "% Change $"
    },
    pytdTotalVolume: {
        id: "pytdTotalVolume",
        label: "Previous YTD Total Volume"
    },
    pytdTotalUnits: {
        id: "pytdTotalUnits",
        label: "Previous YTD Total Units"
    },
    lytdTotalVolume: {
        id: "lytdTotalVolume",
        label: "Last Year to Date Total Volume"
    },
    lytdPytdTotalVolumeChange: {
        id: "lytdPytdTotalVolumeChange",
        label: "Change $"
    },
    lytdPytdTotalVolumeGrowth: {
        id: "lytdPytdTotalVolumeGrowth",
        label: "% Change $"
    },
    lytdTotalUnits: {
        id: "lytdTotalUnits",
        label: "Last Year to Date Total Units"
    },
    lytdPytdTotalUnitsChange: {
        id: "lytdPytdTotalUnitsChange",
        label: "Year to Year Total Units Change"
    },
    lytdPytdTotalUnitsGrowth: {
        id: "lytdPytdTotalUnitsGrowth",
        label: "Year to Year Unit Growth"
    },
    noPcLast12ListUnits: {
        id: "noPcLast12ListUnits",
        label: "# Units"
    },
    noPcLast12ListUnitsPct: {
        id: "noPcLast12ListUnitsPct",
        label: "% of Total (#)"
    },
    noPcLast12ListVolume: {
        id: "noPcLast12ListVolume",
        label: "$ Volume"
    },
    noPcLast12ListVolumePct: {
        id: "noPcLast12ListVolumePct",
        label: "% of Total ($)"
    },
    noPcLast12ListDom: {
        id: "noPcLast12ListDom",
        label: "DOM"
    },
    noPcLast12ListCdom: {
        id: "noPcLast12ListCdom",
        label: "CDOM"
    },
    noPcLast12SpOp: {
        id: "noPcLast12SpOp",
        label: "SP/OP"
    },
    pcLast12ListUnits: {
        id: "pcLast12ListUnits",
        label: "# Units"
    },
    pcLast12ListUnitsPct: {
        id: "pcLast12ListUnitsPct",
        label: "% of Total (#)"
    },
    pcLast12ListVolume: {
        id: "pcLast12ListVolume",
        label: "$ Volume"
    },
    pcLast12ListVolumePct: {
        id: "pcLast12ListVolumePct",
        label: "% of Total ($)"
    },
    pcLast12ListDom: {
        id: "pcLast12ListDom",
        label: "DOM"
    },
    pcLast12ListCdom: {
        id: "pcLast12ListCdom",
        label: "CDOM"
    },
    pcLast12ListPcDom: {
        id: "pcLast12ListPcDom",
        label: "PC DOM"
    },
    pcLast12ListSpOp: {
        id: "pcLast12ListSpOp",
        label: "SP/OP"
    },
    pcLast12ListSpLp: {
        id: "pcLast12ListSpLp",
        label: "SP/LP"
    },
    pcLast12ListAvgNumPc: {
        id: "pcLast12ListAvgNumPc",
        label: "Avg # PC"
    },
    listingLast12ListUnits: {
        id: "listingLast12ListUnits",
        label: "# Units"
    },
    agProdMonth: {
        id: "month",
        label: "Month"
    },
    inventoryTotalUnits: {
        id: "totalUnits",
        label: "Units (#)"
    },
    inventoryPriceVolume: {
        id: "listPriceVolume",
        label: "Volume ($)"
    },
    inventoryAvgPrice: {
        id: "avgPrice",
        label: "Avg. Price ($)"
    },
    status: {
        id: "status",
        label: " "
    },
    pcUnits: {
        id: "pcUnits",
        label: "Units (#)"
    },
    lpop: {
        id: "lpop",
        label: "LP/OP (%)"
    },
    cdomTier1: {
        id: "cdomTier1",
        label: "0 - 30"
    },
    cdomTier2: {
        id: "cdomTier2",
        label: "31 - 90"
    },
    cdomTier3: {
        id: "cdomTier3",
        label: "91 - 180"
    },
    cdomTier4: {
        id: "cdomTier4",
        label: "181 - 360"
    },
    cdomTier5: {
        id: "cdomTier5",
        label: "360+"
    },
    typeName: {
        id: "typeName",
        label: "Type"
    },
    address: {
        id: "address",
        label: "Address"
    },
    city: {
        id: "city",
        label: "City"
    },
    zipCode: {
        id: "zipCode",
        label: "Zip"
    },
    orgPrice: {
        id: "orgPrice",
        label: "Original Price"
    },
    listPrice: {
        id: "listPrice",
        label: "List Price"
    },
    priceChangeCnt: {
        id: "priceChangeCnt",
        label: "# Price Changes"
    },
    dateList: {
        id: "dateList",
        label: "List Date"
    },
    cdom: {
        id: "cdom",
        label: "CDOM"
    },
    bedrooms: {
        id: "bedrooms",
        label: "BD"
    },
    fullBaths: {
        id: "fullBaths",
        label: "BA"
    },
    squareFt: {
        id: "squareFt",
        label: "SQFT"
    },
    dollarPerSquareFt: {
        id: "dollarPerSquareFt",
        label: "$/SQFT"
    },
    lotSizeSquareFt: {
        id: "lotSizeSquareFt",
        label: "Lot Size (SQFT)"
    },
    yearBuilt: {
        id: "yearBuilt",
        label: "Year Built"
    },
    mlsNum: {
        id: "mlsNum",
        label: "MLS #"
    },
    dateCont: {
        id: "dateCont",
        label: "UC Date"
    },
    duc: {
        id: "duc",
        label: "DUC"
    },
    statusCode: {
        id: "statusCode",
        label: "Status"
    },
    ciTotalUnits: {
        id: "totalUnits",
        label: "# Units"
    },
    ciTotalVolume: {
        id: "totalVolume",
        label: "# Volume"
    },
    favoriteAgents: {
        id: "favoriteAgents",
        label: "Favorite Agents"
    },
    producingAgentCount: {
        id: "producingAgentCount",
        label: "PA."
    },
    volume: {
        id: "volume",
        label: "Volume"
    },
    streetName: {
        id: "streetName",
        label: "Address"
    },
    listingClosedDate: {
        id: "listingClosedDate",
        label: "Close Date"
    },
    listingAddress: {
        id: "listingAddress",
        label: "Co-op Address"
    },
    listingCity: {
        id: "listingCity",
        label: "Co-op City",
        parentColumnId: "listingAddress"
    },
    listingZipCode: {
        id: "listingZipCode",
        label: "Co-op Zip",
        parentColumnId: "listingAddress"
    },
    listingCounty: {
        id: "listingCounty",
        label: "Co-op County",
        parentColumnId: "listingAddress"
    },
    listingSalePrice: {
        id: "listingSalePrice",
        label: "Sold Price"
    },
    coopSide: {
        id: "coopSide",
        label: "Side"
    },
    myAgentName: {
        id: "myAgentName",
        label: "My Office Agent"
    },
    previousPeriodTotalUnits: {
        id: "previousPeriodTotalUnits",
        label: "Last 90 Days Previous Year #"
    },
    previousPeriodTotalVolume: {
        id: "previousPeriodTotalVolume",
        label: "Last 90 Days Previous Year $"
    },
    days: {
        id: "dom",
        label: "Days"
    },
    contract: {
        id: "duc",
        label: "UC DOM"
    },
    isSelected: {
        id: "isSelected",
        label: "checked"
    },
    activity: {
        id: "activity",
        label: "Activity"
    },
    side: {
        id: "side",
        label: "Side"
    },
    date: {
        id: "date",
        label: "Date"
    }
});
const $ab420772d827bb15$export$c4fefec0b0e3d8a5 = Object.freeze({
    UNASSIGNED: "unassigned",
    ACTIVITY: "activity",
    OVERVIEW: "overview",
    GROWTH_ANALYSIS: "growthAnalysis",
    CONTACT_INFORMATION: "contactInformation",
    LISTING_PROFICIENCY: "listingProficiency",
    AGENT_DETAIL_PRODUCTION: "agentDetailProduction"
});
const $ab420772d827bb15$export$35a0dd6df300876c = Object.freeze({
    TOTAL_SOLD: 0,
    LIST_SIDE: 1,
    SELL_SIDE: 2
});
const $ab420772d827bb15$export$a9394c482144912c = Object.freeze({
    PRODUCTION: 0,
    INVENTORY: 1,
    TRANSACTION_COVERAGE: 2,
    OFFICE_HISTORY: 3
});
const $ab420772d827bb15$export$a6af8f8ffca8ca7a = Object.freeze({
    UNDER_CONTRACT: "Currently Under Contract",
    FOR_SALE: "Currently For Sale"
});
const $ab420772d827bb15$export$4d227e2da3d6dc19 = Object.freeze({
    0: (0, $cstaF.agentProductionTerms).production,
    1: (0, $cstaF.agentProductionTerms).inventory,
    2: (0, $cstaF.agentProductionTerms).transactionCoverage,
    3: (0, $cstaF.agentProductionTerms).officeHistory
});
const $ab420772d827bb15$export$da12459e9e994233 = Object.freeze({
    SOLD: {
        label: "Sold",
        value: "S"
    },
    ACTIVE: {
        label: "For Sale",
        value: "A"
    },
    UNDER_CONTRACT: {
        label: "Under Contract",
        value: "C"
    }
});
const $ab420772d827bb15$export$d4758f7de7da0463 = Object.freeze({
    totalSold: "Total Sold",
    listSide: "List-Side",
    sellSide: "Sell-Side"
});
const $ab420772d827bb15$export$42ff02d7de9a2e8a = Object.freeze([
    {
        label: (0, $cstaF.agentProductionTerms).last6Months,
        value: (0, $cstaF.TimePeriods)[(0, $cstaF.agentProductionTerms).last6Months]
    },
    {
        label: (0, $cstaF.agentProductionTerms).last12Months,
        value: (0, $cstaF.TimePeriods)[(0, $cstaF.agentProductionTerms).last12Months]
    },
    {
        label: (0, $cstaF.agentProductionTerms).last24Months,
        value: (0, $cstaF.TimePeriods)[(0, $cstaF.agentProductionTerms).last24Months]
    }
]);
const $ab420772d827bb15$export$3e3df960e2b906d7 = Object.freeze([
    {
        label: (0, $cstaF.TimePeriods)["YTD"],
        value: (0, $cstaF.TimePeriods)["YTD"]
    },
    {
        label: (0, $cstaF.TimePeriods)["QTD"],
        value: (0, $cstaF.TimePeriods)["QTD"]
    },
    {
        label: (0, $cstaF.TimePeriods)["MTD"],
        value: (0, $cstaF.TimePeriods)["MTD"]
    },
    {
        label: (0, $cstaF.agentProductionTerms).last6Months,
        value: (0, $cstaF.TimePeriods)[(0, $cstaF.agentProductionTerms).last6Months]
    },
    {
        label: [
            (0, $cstaF.agentProductionTerms).last12Months
        ],
        value: (0, $cstaF.TimePeriods)[(0, $cstaF.agentProductionTerms).last12Months]
    },
    {
        label: (0, $cstaF.agentProductionTerms).last24Months,
        value: (0, $cstaF.TimePeriods)[(0, $cstaF.agentProductionTerms).last24Months]
    }
]);
const $ab420772d827bb15$export$f8b455c4c89b3ea6 = Object.freeze({
    AREA_SUB: "area_sub_id",
    AREA2: "area2_id",
    CITY: "city",
    COUNTY: "county",
    MAP_CODE: "map_code",
    MLS_AREAS: "area_id",
    STATE_CODE: "state_code",
    SUBDIVISION: "subdivision",
    ZIP: "zip_code"
});
const $ab420772d827bb15$export$e99aaa9a8aadc99a = Object.freeze([
    $ab420772d827bb15$export$290e990ef234d58d.officeCity,
    $ab420772d827bb15$export$290e990ef234d58d.officeZipCode,
    $ab420772d827bb15$export$290e990ef234d58d.officeCounty
]);
const $ab420772d827bb15$export$8ae681fac1096e94 = Object.freeze({
    area: $ab420772d827bb15$export$290e990ef234d58d.area,
    listUnits: $ab420772d827bb15$export$290e990ef234d58d.listUnits,
    listVolume: $ab420772d827bb15$export$290e990ef234d58d.listVolume,
    sellUnits: $ab420772d827bb15$export$290e990ef234d58d.sellUnits,
    sellVolume: $ab420772d827bb15$export$290e990ef234d58d.sellVolume,
    totalUnits: $ab420772d827bb15$export$290e990ef234d58d.totalUnits,
    totalVolume: $ab420772d827bb15$export$290e990ef234d58d.totalVolume,
    totalUnitsPct: $ab420772d827bb15$export$290e990ef234d58d.totalUnitsPct,
    totalVolumePct: $ab420772d827bb15$export$290e990ef234d58d.totalVolumePct
});
const $ab420772d827bb15$export$25d368e1d586d0be = Object.freeze({
    area: {
        ...$ab420772d827bb15$export$290e990ef234d58d.area
    },
    listUnits: {
        ...$ab420772d827bb15$export$290e990ef234d58d.listUnits,
        label: "# Units"
    },
    listVolume: {
        ...$ab420772d827bb15$export$290e990ef234d58d.listVolume,
        label: "$ Volume"
    },
    totalUnitsPct: {
        ...$ab420772d827bb15$export$290e990ef234d58d.totalUnitsPct,
        label: "# Units %"
    },
    totalVolumePct: {
        ...$ab420772d827bb15$export$290e990ef234d58d.totalVolumePct,
        label: "$ Volume %"
    }
});
const $ab420772d827bb15$export$80f0d9d593bac063 = Object.freeze({
    area: {
        ...$ab420772d827bb15$export$290e990ef234d58d.area
    },
    listUnits: {
        ...$ab420772d827bb15$export$290e990ef234d58d.listUnits,
        label: "# Units"
    },
    listVolume: {
        ...$ab420772d827bb15$export$290e990ef234d58d.listVolume,
        label: "$ Volume"
    },
    totalUnitsPct: {
        ...$ab420772d827bb15$export$290e990ef234d58d.totalUnitsPct,
        label: "# Units %"
    },
    totalVolumePct: {
        ...$ab420772d827bb15$export$290e990ef234d58d.totalVolumePct,
        label: "$ Volume %"
    }
});
const $ab420772d827bb15$export$47af531ee468dcb6 = Object.freeze({
    soldView: "S",
    underContract: "C",
    forSale: "A"
});
const $ab420772d827bb15$export$63bfa7109e75d47e = Object.freeze({
    unitsBtn: {
        id: "unitsBtn",
        label: "Units",
        tip: "The number of transaction sides (list + sell) by month"
    },
    volumeBtn: {
        id: "volumeBtn",
        label: "Volume",
        tip: "The dollar volume of transaction sides (list + sell) by month"
    }
});
const $ab420772d827bb15$export$ad32f8c43df6be25 = Object.freeze({
    unitsBtn: {
        label: "Units",
        tip: "The number of transaction sides (list + sell) by month",
        id: "unitsBtn"
    },
    volumeBtn: {
        label: "Volume",
        tip: "The dollar volume of transaction sides (list + sell) by month",
        id: "volumeBtn"
    },
    summaryVolListSide: {
        label: "$ Volume - List Side",
        tip: "The dollar volume of list-side transactions",
        id: "summaryVolListSide"
    },
    summaryVolSellSide: {
        label: "$ Volume - Sell Side",
        tip: "The dollar volume of sell-side transactions",
        id: "summaryVolSellSide"
    },
    summaryTotalVolume: {
        label: "Total $ Volume",
        tip: "The dollar volume of transaction sides (list + sell)",
        id: "summaryTotalVolume"
    },
    summaryVolPerMonth: {
        label: "$ Volume Per Month",
        tip: "The average dollar volume of transaction sides (list + sell) per month",
        id: "summaryVolPerMonth"
    },
    summaryUnitsListSide: {
        label: "# Units - List Side",
        tip: "The number of list-side transactions",
        id: "summaryUnitsListSide"
    },
    summaryUnitsSellSide: {
        label: "# Units - Sell Side",
        tip: "The number of sell-side transactions",
        id: "summaryUnitsSellSide"
    },
    summaryTotalUnits: {
        label: "Total # Units",
        tip: "The total number of transaction sides (list + sell)",
        id: "summaryTotalUnits"
    },
    summaryUnitsPerMonth: {
        label: "# Units Per Month",
        tip: "The average number of units sold (list+sell) per month",
        id: "summaryUnitsPerMonth"
    },
    summaryAvgPrice: {
        label: "Average Price",
        tip: "The average price of listings closed by the agent",
        id: "summaryAvgPrice"
    }
});
const $ab420772d827bb15$export$925c2aa97e52e400 = Object.freeze({
    unitsCheckBox: {
        id: "unitsCheckBox",
        label: "# Units",
        tip: "The monthly sold number of units (list + sell)"
    },
    volumeCheckBox: {
        id: "volumeCheckBox",
        label: "$ Volume",
        tip: "The monthly sold dollar volume (list + sell)"
    },
    month: {
        id: "month",
        label: "Month",
        tip: "The month and year - the format is (Mmm - YYYY) e.g. Jul - 2022"
    },
    listUnits: {
        id: "listUnits",
        label: "List Side (#)",
        tip: "The total number of list-side transactions for the month"
    },
    sellUnits: {
        id: "sellUnits",
        label: "Sell Side (#)",
        tip: "The total number of sell-side transactions for the month"
    },
    totalUnits: {
        id: "totalUnits",
        label: "Total (#)",
        tip: "The total number of transaction sides for the month"
    },
    listVolume: {
        id: "listVolume",
        label: "List Side ($)",
        tip: "The dollar volume of list-side transactions for the month"
    },
    sellVolume: {
        id: "sellVolume",
        label: "Sell Side ($)",
        tip: "The dollar volume of sell-side transactions for the month"
    },
    totalVolume: {
        id: "totalVolume",
        label: "Total ($)",
        tip: "The dollar volume of transaction sides for the month",
        isLastColumn: true
    },
    summaryListSide: {
        id: "summaryListSide",
        label: "List Side",
        tip: "The dollar volume of list-side transactions, and the total number of list-side transactions over the [Time Period]"
    },
    summarySellSide: {
        id: "summarySellSide",
        label: "Sell Side",
        tip: "The dollar volume of sell-side transactions, and the total number of sell-side transactions over the [Time Period]"
    },
    summaryTotal: {
        id: "summaryTotal",
        label: "Total",
        tip: "The dollar volume of transaction sides (list + sell), and the total number of transaction sides (list + sell) over the [Time Period]"
    }
});
const $ab420772d827bb15$export$7daad41a599eb587 = Object.freeze({
    totalUnits: {
        id: "totalUnits",
        label: "Units (#)",
        tip: "Total number of listings",
        table: "inventory"
    },
    listPriceVolume: {
        id: "listPriceVolume",
        label: "Volume ($)",
        tip: "Total dollar volume",
        table: "inventory"
    },
    avgPrice: {
        id: "avgPrice",
        label: "Avg. Price ($)",
        tip: "Average price of listings closed by the agent",
        table: "inventory"
    },
    pcUnits: {
        id: "pcUnits",
        label: "Units (#)",
        tip: "Number of listings that have had one or more price changes",
        table: "inventory"
    },
    lpop: {
        id: "lpop",
        label: "LP/OP (%)",
        tip: "The ratio of the list price to the original price as a percentage for listings that have had one or more price changes",
        table: "inventory"
    },
    cdomTier1: {
        id: "cdomTier1",
        label: "0 - 30",
        tip: "Number of listings that were for sale during the month for which the CDOM was 30 or less",
        table: "inventory"
    },
    cdomTier2: {
        id: "cdomTier2",
        label: "31 - 90",
        tip: "Number of listings that were for sale for which the CDOM was 31 - 90",
        table: "inventory"
    },
    cdomTier3: {
        id: "cdomTier3",
        label: "91 - 180",
        tip: "Number of listings that were for sale for which the CDOM was 91 - 180",
        table: "inventory"
    },
    cdomTier4: {
        id: "cdomTier4",
        label: "181 - 360",
        tip: "Number of listings that were for sale for which the CDOM was 181 - 360",
        table: "inventory"
    },
    cdomTier5: {
        id: "cdomTier5",
        label: "360+",
        tip: "Number of listings that were for sale for which the CDOM was 360 or more",
        table: "inventory",
        isLastColumn: true
    },
    status: {
        id: "status",
        label: "Currently",
        tip: "",
        table: "inventory"
    }
});
const $ab420772d827bb15$export$d20c5ea5af06242a = Object.freeze({
    typeName: {
        id: "typeName",
        label: "Type",
        tip: "Property Type, i.e., DE, AT."
    },
    address: {
        id: "address",
        label: "Address",
        tip: "The street address"
    },
    city: {
        id: "city",
        label: "City",
        tip: "City name"
    },
    zipCode: {
        id: "zipCode",
        label: "Zip",
        tip: "Zip Code"
    },
    orgPrice: {
        id: "orgPrice",
        label: "Original Price",
        tip: "The original list price"
    },
    listPrice: {
        id: "listPrice",
        label: "List Price",
        tip: "Current list price"
    },
    priceChangeCnt: {
        id: "priceChangeCnt",
        label: "# Price Changes",
        tip: "Number of price changes the listing has experienced"
    },
    dateList: {
        id: "dateList",
        label: "List Date",
        tip: "List Date"
    },
    dateCont: {
        id: "dateCont",
        label: "UC Date",
        tip: "UC Date"
    },
    cdom: {
        id: "cdom",
        label: "CDOM",
        tip: "The Continuous Days on Market associated with the property record\u2019s MLS history"
    },
    duc: {
        id: "duc",
        label: "DUC",
        tip: "The number of days that the listing has been under contract"
    },
    statusCode: {
        id: "statusCode",
        label: "Status",
        tip: "The listings Under Contract status (Contingent or Pending)"
    },
    bedrooms: {
        id: "bedrooms",
        label: "BD",
        tip: "The number of bedrooms"
    },
    fullBaths: {
        id: "fullBaths",
        label: "BA",
        tip: "The number of full baths"
    },
    squareFt: {
        id: "squareFt",
        label: "SQFT",
        tip: "The square footage"
    },
    dollarPerSquareFt: {
        id: "dollarPerSquareFt",
        label: "$/SQFT",
        tip: "The cost per square foot"
    },
    lotSizeSquareFt: {
        id: "lotSizeSquareFt",
        label: "Lot Size (SQFT)",
        tip: "The lot size (square feet)"
    },
    yearBuilt: {
        id: "yearBuilt",
        label: "Year Built",
        tip: "Year Built"
    },
    mlsNum: {
        id: "mlsNum",
        label: "MLS #",
        tip: "Unique MLS number"
    }
});
const $ab420772d827bb15$export$ecc31078313012e8 = Object.freeze({
    typeName: {
        id: "typeName",
        label: "Type",
        tip: "Property Type, i.e., DE, AT."
    },
    address: {
        id: "address",
        label: "Address",
        tip: "The street address"
    },
    city: {
        id: "city",
        label: "City",
        tip: "City name"
    },
    zipCode: {
        id: "zipCode",
        label: "Zip",
        tip: "Zip Code"
    },
    orgPrice: {
        id: "orgPrice",
        label: "Original Price",
        tip: "The original list price"
    },
    listPrice: {
        id: "listPrice",
        label: "List Price",
        tip: "Current list price"
    },
    priceChangeCnt: {
        id: "priceChangeCnt",
        label: "# Price Changes",
        tip: "Number of price changes the listing has experienced"
    },
    dateList: {
        id: "dateList",
        label: "List Date",
        tip: "List Date"
    },
    cdom: {
        id: "cdom",
        label: "CDOM",
        tip: "The Continuous Days on Market associated with the property record\u2019s MLS history"
    },
    bedrooms: {
        id: "bedrooms",
        label: "BD",
        tip: "The number of bedrooms"
    },
    fullBaths: {
        id: "fullBaths",
        label: "BA",
        tip: "The number of full baths"
    },
    squareFt: {
        id: "squareFt",
        label: "SQFT",
        tip: "The square footage"
    },
    dollarPerSquareFt: {
        id: "dollarPerSquareFt",
        label: "$/SQFT",
        tip: "The cost per square foot"
    },
    lotSizeSquareFt: {
        id: "lotSizeSquareFt",
        label: "Lot Size (SQFT)",
        tip: "The lot size (square feet)"
    },
    yearBuilt: {
        id: "yearBuilt",
        label: "Year Built",
        tip: "Year Built"
    },
    mlsNum: {
        id: "mlsNum",
        label: "MLS #",
        tip: "Unique MLS number"
    }
});
const $ab420772d827bb15$export$41ad0c5a50c3c227 = Object.freeze({
    volumeBtn: {
        id: "coverageVolumeBtn",
        label: "Volume",
        tip: "The dollar volume of transaction sides (list + sell) by area"
    },
    unitsBtn: {
        id: "coverageUnitsBtn",
        label: "Units",
        tip: "The number of transaction sides (list + sell) by area"
    },
    forSaleBtn: {
        id: "forSaleBtn",
        label: "For Sale",
        tip: "Listings that are available for a first postion offer"
    },
    underContractBtn: {
        id: "underContractBtn",
        label: "Under Contract",
        tip: 'Listings where the status has changed from active to one indicating that the seller has accepted a "first position" offer'
    },
    soldBtn: {
        id: "soldBtn",
        label: "Sold",
        tip: "Listings that have successfully sold and closed escrow"
    },
    marketAreaCheck: {
        id: "marketAreaCheck",
        label: "Market Area %",
        tip: "The volume of business conducted in each area as a percentage of the total"
    }
});
const $ab420772d827bb15$var$covTableTips = Object.freeze({
    area: "The code the MLS uses to define an area",
    listUnitsSold: "The (#) of list-side transactions",
    listUnitsForSale: "The number of listings that are currently for sale",
    listUnitsUc: "The number of listings that are currently under contract",
    listVolumeSold: "The ($) volume of list-side transactions",
    listVolumeForSale: "The dollar volume of listings that are currently for sale",
    listVolumeUc: "The dollar volume of listings that are currently under contract",
    sellUnits: "The (#) of sell-side transactions",
    sellVolume: "The ($) volume of sell-side transactions",
    totalUnits: "The total number of transaction sides (list + sell)",
    totalUnitsPctForSale: "The number of listings that are currently for sale for the area as a percentage of the total number of listings that are currently for sale",
    totalUnitsPctSold: "The number of transaction sides (list + sell) for the area as a percentage of the total number of transaction sides (list + sell)",
    totalUnitsPctUc: "The number of listings that are currently under contract for the area as a percentage of the total number of listings that are currently under contract",
    totalVolume: "The total dollar volume of transaction sides (list + sell)",
    totalVolumePctForSale: "The dollar volume of listings that are currently for sale for the area as a percentage of the total dollar volume of listings that are currently for sale",
    totalVolumePctSold: "The dollar volume of transaction sides (list + sell) for the area as a percentage of the total dollar volume of transaction sides (list + sell)",
    totalVolumePctUc: "The dollar volume of listings that are currently under contract for the area as a percentage of the total dollar volume of listings that are currently under contract"
});
const $ab420772d827bb15$export$3aaaf363d99b232f = Object.freeze({
    area: {
        id: "area",
        label: "Area",
        tip: $ab420772d827bb15$var$covTableTips.area
    },
    listUnits: {
        id: "listUnits",
        label: "List #",
        tip: $ab420772d827bb15$var$covTableTips.listUnitsSold
    },
    listVolume: {
        id: "listVolume",
        label: "List $",
        tip: $ab420772d827bb15$var$covTableTips.listVolumeSold
    },
    sellUnits: {
        id: "sellUnits",
        label: "Sell #",
        tip: $ab420772d827bb15$var$covTableTips.sellUnits
    },
    sellVolume: {
        id: "sellVolume",
        label: "Sell $",
        tip: $ab420772d827bb15$var$covTableTips.sellVolume
    },
    totalUnits: {
        id: "totalUnits",
        label: "# Units",
        tip: $ab420772d827bb15$var$covTableTips.totalUnits
    },
    totalUnitsPct: {
        id: "totalUnitsPct",
        label: "# Units %",
        tip: $ab420772d827bb15$var$covTableTips.totalUnitsPctSold
    },
    totalVolume: {
        id: "totalVolume",
        label: "$ Volume",
        tip: $ab420772d827bb15$var$covTableTips.totalVolume
    },
    totalVolumePct: {
        id: "totalVolumePct",
        label: "$ Volume %",
        tip: $ab420772d827bb15$var$covTableTips.totalVolumePctSold
    }
});
const $ab420772d827bb15$export$831c4f31e5ccab84 = Object.freeze({
    area: {
        ...$ab420772d827bb15$export$3aaaf363d99b232f.area
    },
    listUnits: {
        ...$ab420772d827bb15$export$3aaaf363d99b232f.listUnits,
        label: "# Units",
        tip: $ab420772d827bb15$var$covTableTips.listUnitsUc
    },
    listVolume: {
        ...$ab420772d827bb15$export$3aaaf363d99b232f.listVolume,
        label: "$ Volume",
        tip: $ab420772d827bb15$var$covTableTips.listVolumeUc
    },
    totalUnitsPct: {
        ...$ab420772d827bb15$export$3aaaf363d99b232f.totalUnitsPct,
        tip: $ab420772d827bb15$var$covTableTips.totalUnitsPctUc
    },
    totalVolumePct: {
        ...$ab420772d827bb15$export$3aaaf363d99b232f.totalVolumePct,
        tip: $ab420772d827bb15$var$covTableTips.totalVolumePctUc
    }
});
const $ab420772d827bb15$export$f2e671ab2c5e5e2f = Object.freeze({
    area: {
        ...$ab420772d827bb15$export$831c4f31e5ccab84.area
    },
    listUnits: {
        ...$ab420772d827bb15$export$831c4f31e5ccab84.listUnits,
        tip: $ab420772d827bb15$var$covTableTips.listUnitsForSale
    },
    listVolume: {
        ...$ab420772d827bb15$export$831c4f31e5ccab84.listVolume,
        tip: $ab420772d827bb15$var$covTableTips.listVolumeForSale
    },
    totalUnitsPct: {
        ...$ab420772d827bb15$export$831c4f31e5ccab84.totalUnitsPct,
        tip: $ab420772d827bb15$var$covTableTips.totalUnitsPctForSale
    },
    totalVolumePct: {
        ...$ab420772d827bb15$export$831c4f31e5ccab84.totalVolumePct,
        tip: $ab420772d827bb15$var$covTableTips.totalVolumePctForSale
    }
});
const $ab420772d827bb15$export$9866cc3252996bc4 = Object.freeze({
    isSelected: {
        id: "isSelected",
        label: "",
        tip: ""
    },
    rank: {
        label: "Rank",
        tip: "Rank based on Total $ Volume of the current search"
    },
    agentName: {
        label: "Agent Name",
        tip: "Name of the Agent"
    },
    agentId: {
        label: "Agent ID",
        tip: "ID code assigned by MLS"
    },
    officeName: {
        label: "Office Name",
        tip: "Office Name as supplied by the MLS"
    },
    officeId: {
        label: "Office ID",
        tip: "ID code assigned by MLS"
    },
    officeAddress: {
        label: "Office Address",
        tip: "The office's physical and/or mailing address as reflected in the MLS data"
    },
    officeCity: {
        label: "City",
        tip: "City where office resides"
    },
    officeZipCode: {
        label: "Zip",
        tip: "The USPS zip code associated with the office as reflected in the MLS data"
    },
    officeCounty: {
        label: "County",
        tip: "The county associated with the office as reflected in the MLS data"
    },
    listVolume: {
        label: "List Side ($)",
        tip: "The ($) volume of list side transactions"
    },
    sellVolume: {
        label: "Sell Side ($)",
        tip: "The ($) volume of sell side transactions"
    },
    totalVolume: {
        label: "Total ($)",
        tip: "The total ($) volume of transaction sides (list + sell)"
    },
    listUnits: {
        label: "List Side (#)",
        tip: "The (#) of list side transactions"
    },
    sellUnits: {
        label: "Sell Side (#)",
        tip: "The (#) of sell side transactions"
    },
    totalUnits: {
        label: "Total (#)",
        tip: "The total (#) of transaction sides (list + sell)"
    },
    averagePrice: {
        label: "Avg. Price",
        tip: "Average price of the listings closed by the agent over the Last 12 Months [last12Months]",
        hasDate: true
    },
    last12Spop: {
        label: "SP/OP",
        tip: "The average ratio of the sold price (closed price) to the original list price as a percentage for listings closed by the agent over the Last 12 Months [last12Months]",
        hasDate: true
    },
    last12AvgDom: {
        label: "Avg. DOM",
        tip: "The average DOM of listings closed by the agent over the Last 12 Months [last12Months]",
        hasDate: true
    },
    totalUnitsChange: {
        label: "Growth (#)",
        tip: "Difference in the number of units sold between the Last 12 Months [last12Months] and the Previous 12 Months [previous12Months]",
        hasDate: true
    },
    totalVolumeChange: {
        label: "Growth ($)",
        tip: "Difference in the dollar volume sold between the Last 12 Months [last12Months] and the Previous 12 Months [previous12Months]",
        hasDate: true
    },
    last12ListVolume: {
        label: "List Side ($)",
        tip: "The ($) volume of list side transactions over the Last 12 Months [last12Months]",
        hasDate: true
    },
    last12SellVolume: {
        label: "Sell Side ($)",
        tip: "The ($) volume of sell side transactions over the Last 12 Months [last12Months]",
        hasDate: true
    },
    last12TotalVolume: {
        label: "Total ($)",
        tip: "The total ($) volume of transaction sides (list + sell) over the Last 12 Months [last12Months]",
        hasDate: true
    },
    last12ListUnits: {
        label: "List Side (#)",
        tip: "The (#) of list side transactions over the Last 12 Months [last12Months]",
        hasDate: true
    },
    last12SellUnits: {
        label: "Sell Side (#)",
        tip: "The (#) of sell side transactions over the Last 12 Months [last12Months]",
        hasDate: true
    },
    last12TotalUnits: {
        label: "Total (#)",
        tip: "The total (#) of transaction sides (list + sell) over the Last 12 Months [last12Months]",
        hasDate: true
    },
    favoriteAgents: {
        label: "",
        tip: ""
    },
    listingClosedDate: {
        label: "Close Date",
        tip: "The date the co-op transaction was closed"
    },
    listingAddress: {
        label: "Co-op Address",
        tip: "The listing address for the transaction"
    },
    listingCity: {
        label: "Co-op City",
        tip: "The listing city for the transaction"
    },
    listingZipCode: {
        label: "Co-op Zip",
        tip: "The listing zip for the transaction"
    },
    listingCounty: {
        label: "Co-op County",
        tip: "The listing county for the transaction"
    },
    listingSalePrice: {
        label: "Sold Price",
        tip: "The sold price for the co-op transaction"
    },
    coopSide: {
        label: "Side",
        tip: "The co-op agent side, i.e Buyer, Seller"
    },
    myAgentName: {
        label: "My Office Agent",
        tip: "My agent on the other side of the transaction"
    },
    ltmTotalUnitsChange: {
        label: "Change #",
        tip: "Difference in the number of units sold between the Last 12 Months [last12Months] and the Previous 12 Months [previous12Months]",
        hasDate: true
    },
    ltmTotalVolumeChange: {
        label: "Change $",
        tip: "Difference in the dollar volume sold between the Last 12 Months [last12Months] and the Previous 12 Months [previous12Months]",
        hasDate: true
    }
});
const $ab420772d827bb15$export$9ef800376351bd07 = Object.freeze({
    isSelected: {
        id: "isSelected",
        label: "",
        tip: ""
    },
    rank: {
        label: "Rank",
        tip: "Rank based on Total $ Volume of the current search"
    },
    agentName: {
        label: "Agent Name",
        tip: "Name of the Agent"
    },
    agentId: {
        label: "Agent ID",
        tip: "ID code assigned by MLS"
    },
    officeName: {
        label: "Office Name",
        tip: "Office Name as supplied by the MLS"
    },
    officeId: {
        label: "Office ID",
        tip: "ID code assigned by MLS"
    },
    officeAddress: {
        label: "Office Address",
        tip: "The office's physical and/or mailing address as reflected in the MLS data"
    },
    officeCity: {
        label: "City",
        tip: "City where office resides"
    },
    officeZipCode: {
        label: "Zip",
        tip: "The USPS zip code associated with the office as reflected in the MLS data"
    },
    officeCounty: {
        label: "County",
        tip: "The county associated with the office as reflected in the MLS data"
    },
    agentPhone1: {
        label: "Phone 1",
        tip: "A telephone number for the agent as reflected in the MLS data"
    },
    agentPhone2: {
        label: "Phone 2",
        tip: "A telephone number for the agent as reflected in the MLS data"
    },
    agentPhone3: {
        label: "Phone 3",
        tip: "A telephone number for the agent as reflected in the MLS data"
    },
    agentPhoneType1: {
        label: "Phone Type 1",
        tip: "Phone Type"
    },
    agentPhoneType2: {
        label: "Phone Type 2",
        tip: "Phone Type"
    },
    agentPhoneType3: {
        label: "Phone Type 3",
        tip: "Phone Type"
    },
    agentEmail: {
        label: "Email",
        tip: "The agent's email address as reflected in the MLS data"
    },
    agentAddress: {
        label: "Alternate Address",
        tip: "The agent's alternate physical and/or mailing address as reflected in the MLS data"
    },
    totalUnits: {
        label: "# Units",
        tip: "The total number of transaction sides (list + sell)"
    },
    totalVolume: {
        label: "$ Volume",
        tip: "The total dollar volume of transaction sides (list + sell)"
    },
    last12TotalUnits: {
        label: "# Units",
        tip: "The total number of transaction sides (list + sell) over the Last 12 Months [last12Months]",
        hasDate: true
    },
    last12TotalVolume: {
        label: "$ Volume",
        tip: "The total dollar volume of transaction sides (list + sell) over the Last 12 Months [last12Months]",
        hasDate: true
    },
    totalVolumeChange: {
        label: "$ Change",
        tip: "Difference in the dollar volume sold between the Last 12 Months [last12Months] and the Previous 12 Months [previous12Months]",
        hasDate: true
    },
    totalVolumeGrowth: {
        label: "% Change",
        tip: "Percentage difference in the dollar volume sold between the Last 12 Months [last12Months] and the Previous 12 Months [previous12Months]",
        hasDate: true
    },
    favoriteAgents: {
        ...$ab420772d827bb15$export$9866cc3252996bc4.favoriteAgents
    }
});
const $ab420772d827bb15$var$rankTooltipSA = {
    label: "Rank",
    tip: "Rank"
};
const $ab420772d827bb15$export$fc1a5a962b878c37 = Object.freeze({
    ...$ab420772d827bb15$export$9ef800376351bd07,
    rank: $ab420772d827bb15$var$rankTooltipSA
});
const $ab420772d827bb15$export$edfe74661fed48af = Object.freeze({
    ...$ab420772d827bb15$export$9866cc3252996bc4,
    rank: $ab420772d827bb15$var$rankTooltipSA
});
const $ab420772d827bb15$export$57d4c0b0ab25d58b = {
    rank: {
        label: "Rank",
        tip: "Represents the agent's rank within the Current Search period based on the total number of recorded recruiting activities."
    },
    favoriteAgents: {
        ...$ab420772d827bb15$export$9866cc3252996bc4.favoriteAgents
    },
    agentName: {
        label: "Agent Name",
        tip: "Displays the full name of the agent."
    },
    officeName: {
        label: "Office Name",
        tip: "Shows the name of the MLS office associated with the agent."
    },
    activity: {
        label: "Activity",
        tip: "Displays the type of recruiting activity logged for the agent during the selected time period."
    },
    side: {
        label: "Side",
        tip: "Indicates the side of the transaction for the recorded activity, i.e. List or Sell."
    },
    date: {
        label: "Date",
        tip: "Shows the exact date of the recorded recruiting activity within the selected search period."
    },
    listVolume: {
        label: "List Side ($)",
        tip: "Represents the total list-side production volume the agent generated in the Last 12 Months."
    },
    sellVolume: {
        label: "Sell Side ($)",
        tip: "Represents the total sell-side production volume the agent generated in the Last 12 Months."
    },
    totalVolume: {
        label: "Total ($)",
        tip: "Shows the agent's combined production volume from both listing and selling activities in the Last 12 Months."
    }
};
const $ab420772d827bb15$export$1f68bac5d85032d3 = Object.freeze({
    isSelected: {
        id: "isSelected",
        label: "",
        tip: ""
    },
    rank: {
        label: "Rank",
        tip: "Rank based on Total $ Volume of the current search"
    },
    agentName: {
        label: "Agent Name",
        tip: "Name of the Agent"
    },
    officeName: {
        label: "Office Name",
        tip: "Office Name as supplied by the MLS"
    },
    officeId: {
        label: "Office ID",
        tip: "ID code assigned by MLS"
    },
    officeAddress: {
        label: "Office Address",
        tip: "The office's physical and/or mailing address as reflected in the MLS data"
    },
    officeCity: {
        label: "City",
        tip: "City where office resides"
    },
    officeZipCode: {
        label: "Zip",
        tip: "The USPS zip code associated with the office as reflected in the MLS data"
    },
    officeCounty: {
        label: "County",
        tip: "The county associated with the office as reflected in the MLS data"
    },
    ptmTotalUnits: {
        label: "Previous 12 Months #",
        tip: "The total number of transaction sides (list + sell) over the Previous 12 Months [previous12Months]",
        hasDate: true
    },
    ptmNum: {
        label: "Previous 12 Months #",
        tip: "The total number of transaction sides (list + sell) over the Previous 12 Months [previous12Months]",
        hasDate: true
    },
    ltmNum: {
        label: "Last 12 Months #",
        tip: "The total number of transaction sides (list + sell) over the Last 12 Months [last12Months]",
        hasDate: true
    },
    changeNum: {
        label: "Change #",
        tip: "Difference in the number of units sold between the Last 12 Months [last12Months] and the Previous 12 Months [previous12Months]",
        hasDate: true
    },
    totalUnitsChange: {
        label: "Change #",
        tip: "Difference in the number of units sold between the Last 12 Months [last12Months] and the Previous 12 Months [previous12Months]",
        hasDate: true
    },
    pctChangeNum: {
        label: "% Change #",
        tip: "Percentage difference in the number of units sold between the Last 12 Months [last12Months] and the Previous 12 Months [previous12Months]",
        hasDate: true
    },
    totalUnitsGrowth: {
        label: "% Change #",
        tip: "Percentage difference in the number of units sold between the Last 12 Months [last12Months] and the Previous 12 Months [previous12Months]",
        hasDate: true
    },
    pytdTotalUnits: {
        label: "YTD [previousYearNumber] #",
        tip: "The total number of transaction sides (list + sell) for the Year to Date (YTD) [previousYear]",
        hasDate: true
    },
    lytdTotalUnits: {
        label: "YTD [currentYearNumber] #",
        tip: "The total number of transaction sides (list + sell) for the Year to Date (YTD) [currentYear]",
        hasDate: true
    },
    lytdPytdTotalUnitsChange: {
        label: "Change #",
        tip: "Difference in the number of units sold between the Year to Date (YTD) [currentYear] and YTD [previousYear]",
        hasDate: true
    },
    lytdPytdTotalUnitsGrowth: {
        label: "% Change #",
        tip: "Percentage difference in the number of units sold between the Year to Date (YTD) [currentYear] and YTD [previousYear]",
        hasDate: true
    },
    ptmTotalVolume: {
        label: "Previous 12 Months $",
        tip: "The total dollar volume of transaction sides (list + sell) over the Previous 12 Months [previous12Months]",
        hasDate: true
    },
    last12TotalUnits: {
        label: "Last 12 Months #",
        tip: "The total number of transaction sides (list + sell) over the Last 12 Months [last12Months]",
        hasDate: true
    },
    last12TotalVolume: {
        label: "Last 12 Months $",
        tip: "The total dollar volume of transaction sides (list + sell) over the Last 12 Months [last12Months]",
        hasDate: true
    },
    totalVolumeChange: {
        label: "Change $",
        tip: "Difference in the dollar volume sold between the Last 12 Months [last12Months] and the Previous 12 Months [previous12Months]",
        hasDate: true
    },
    totalVolumeGrowth: {
        label: "% Change $",
        tip: "Percentage difference in the dollar volume sold between the Last 12 Months [last12Months] and the Previous 12 Months [previous12Months]",
        hasDate: true
    },
    pytdTotalVolume: {
        label: "YTD [previousYearNumber] $",
        tip: "The total dollar volume of transaction sides (list + sell) for the Year to Date (YTD) [previousYear]",
        hasDate: true
    },
    lytdTotalVolume: {
        label: "YTD [currentYearNumber] $",
        tip: "The total dollar volume of transaction sides (list + sell) for the Year to Date (YTD) [currentYear]",
        hasDate: true
    },
    lytdPytdTotalVolumeChange: {
        label: "Change $",
        tip: "Difference in the dollar volume sold between the Year to Date (YTD) [currentYear] and YTD [previousYear]",
        hasDate: true
    },
    lytdPytdTotalVolumeGrowth: {
        label: "% Change $",
        tip: "Percentage difference in the dollar volume sold between the Year to Date [currentYear] and YTD [previousYear]",
        hasDate: true
    },
    ytdPrevYearNum: {
        label: "YTD [previousYearNumber] #",
        tip: "The total number of transaction sides (list + sell) for the Year to Date (YTD) [previousYear]",
        hasDate: true
    },
    ytdCurrentYearNum: {
        label: "YTD [currentYearNumber] #",
        tip: "The total number of transaction sides (list + sell) for the Year to Date (YTD) [currentYear]",
        hasDate: true
    },
    ptm$: {
        label: "Previous 12 Months $",
        tip: "The total dollar volume of transaction sides (list + sell) over the Previous 12 Months [previous12Months]",
        hasDate: true
    },
    ltm$: {
        label: "Last 12 Months $",
        tip: "The total dollar volume of transaction sides (list + sell) over the Last 12 Months [last12Months]",
        hasDate: true
    },
    ytdPrevYear$: {
        label: "YTD [previousYearNumber] $",
        tip: "The total dollar volume of transaction sides (list + sell) for the Year to Date (YTD) [previousYear]",
        hasDate: true
    },
    ytdCurrentYear$: {
        label: "YTD [currentYearNumber] $",
        tip: "The total dollar volume of transaction sides (list + sell) for the Year to Date (YTD) [currentYear]",
        hasDate: true
    },
    change$: {
        label: "Change $",
        tip: "Difference in the dollar volume sold between the Year to Date (YTD) [currentYear] and YTD [previousYear]",
        hasDate: true
    },
    pctChange$: {
        label: "% Change $",
        tip: "Percentage difference in the dollar volume sold between the Year to Date (YTD) [currentYear] and YTD [previousYear]",
        hasDate: true
    },
    favoriteAgents: {
        ...$ab420772d827bb15$export$9866cc3252996bc4.favoriteAgents
    },
    ltmTotalUnitsChange: {
        label: "Change #",
        tip: "Difference in the number of units sold between the Last 12 Months [last12Months] and the Previous 12 Months [previous12Months]",
        hasDate: true
    },
    ltmTotalUnitsGrowth: {
        label: "% Change #",
        tip: "Percentage difference in the number of units sold between the Last 12 Months [last12Months] and the Previous 12 Months [previous12Months]",
        hasDate: true
    },
    ltmTotalVolumeChange: {
        label: "Change $",
        tip: "Difference in the dollar volume sold between the Last 12 Months [last12Months] and the Previous 12 Months [previous12Months]",
        hasDate: true
    },
    ltmTotalVolumeGrowth: {
        label: "% Change $",
        tip: "Percentage difference in the dollar volume sold between the Last 12 Months [last12Months] and the Previous 12 Months [previous12Months]",
        hasDate: true
    }
});
const $ab420772d827bb15$export$bb64cdc4505d49ed = Object.freeze({
    ...$ab420772d827bb15$export$1f68bac5d85032d3,
    rank: $ab420772d827bb15$var$rankTooltipSA
});
const $ab420772d827bb15$export$a1429db100c1098b = {
    ...$ab420772d827bb15$export$bb64cdc4505d49ed,
    totalUnitsGrowth: {
        label: "% Change #",
        tip: "Percentage difference in the number of units sold between the last 90 days [last90days] and the last 90 days previous year [previous90days]",
        hasDate: true
    },
    totalUnitsChange: {
        label: "Change #",
        tip: "Difference in the number of units sold between the last 90 days [last90days] and the last 90 days previous year [previous90days]",
        hasDate: true
    },
    totalVolumeChange: {
        label: "Change $",
        tip: "Difference in the dollar volume sold between the last 90 days [last90days] and the last 90 days previous year [previous90days]",
        hasDate: true
    },
    totalVolumeGrowth: {
        label: "% Change $",
        tip: "Percentage difference in the dollar volume sold between the last 90 days [last90days] and the last 90 days previous year [previous90days]",
        hasDate: true
    },
    totalUnits: {
        label: "Last 90 Days #",
        tip: "The total number of transaction sides (list + sell) over the last 90 days [last90days]",
        hasDate: true
    },
    totalVolume: {
        label: "Last 90 Days $",
        tip: "The total dollar volume of transaction sides (list + sell) over the last 90 days [last90days]",
        hasDate: true
    },
    previousPeriodTotalUnits: {
        label: "Last 90 Days Previous Year #",
        tip: "The total number of transaction sides (list + sell) over the last 90 days previous year [previous90days]",
        hasDate: true
    },
    previousPeriodTotalVolume: {
        label: "Last 90 Days Previous Year $",
        tip: "The total dollar volume of transaction sides (list + sell) over the last 90 days previous year [previous90days]",
        hasDate: true
    }
};
const $ab420772d827bb15$export$940c698cf6212611 = Object.freeze({
    ...$ab420772d827bb15$export$bb64cdc4505d49ed,
    previousPeriodTotalUnits: {
        label: "Previous 12 Months #",
        tip: "The total number of transaction sides (list + sell) over the Previous 12 Months [previous12Months]",
        hasDate: true
    },
    previousPeriodTotalVolume: {
        label: "Previous 12 Months $",
        tip: "The total dollar volume of transaction sides (list + sell) over the Previous 12 Months [previous12Months]",
        hasDate: true
    },
    totalVolume: {
        label: "Last 12 Months $",
        tip: "The total dollar volume of transaction sides (list + sell) over the Last 12 Months [last12Months]",
        hasDate: true
    },
    totalVolumeChange: {
        label: "Change $",
        tip: "Difference in the dollar volume sold between the Last 12 Months [last12Months] and the Previous 12 Months [previous12Months]",
        hasDate: true
    },
    totalVolumeGrowth: {
        label: "% Change $",
        tip: "Percentage difference in the dollar volume sold between the Last 12 Months [last12Months] and the Previous 12 Months [previous12Months]",
        hasDate: true
    },
    totalUnits: {
        label: "Last 12 Months #",
        tip: "The total number of transaction sides (list + sell) over the Last 12 Months [last12Months]",
        hasDate: true
    },
    totalUnitsChange: {
        label: "Change #",
        tip: "Difference in the number of units sold between the Last 12 Months [last12Months] and the Previous 12 Months [previous12Months]",
        hasDate: true
    },
    totalUnitsGrowth: {
        label: "% Change #",
        tip: "Percentage difference in the number of units sold between the Last 12 Months [last12Months] and the Previous 12 Months [previous12Months]",
        hasDate: true
    }
});
const $ab420772d827bb15$export$6b1268a6a5495172 = Object.freeze({
    ...$ab420772d827bb15$export$bb64cdc4505d49ed,
    previousPeriodTotalUnits: {
        label: "YTD [previousYearNumber] #",
        tip: "The total number of transaction sides (list + sell) for the Year to Date (YTD) [previousYear]",
        hasDate: true
    },
    previousPeriodTotalVolume: {
        label: "YTD [previousYearNumber] $",
        tip: "The total dollar volume of transaction sides (list + sell) for the Year to Date (YTD) [previousYear]",
        hasDate: true
    },
    totalVolume: {
        label: "YTD [currentYearNumber] $",
        tip: "The total dollar volume of transaction sides (list + sell) for the Year to Date (YTD) [currentYear]",
        hasDate: true
    },
    totalVolumeChange: {
        label: "Change $",
        tip: "Difference in the dollar volume sold between the Year to Date (YTD) [currentYear] and YTD [previousYear]",
        hasDate: true
    },
    totalVolumeGrowth: {
        label: "% Change $",
        tip: "Percentage difference in the dollar volume sold between the Year to Date [currentYear] and YTD [previousYear]",
        hasDate: true
    },
    totalUnits: {
        label: "YTD [currentYearNumber] #",
        tip: "The total number of transaction sides (list + sell) for the Year to Date (YTD) [currentYear]",
        hasDate: true
    },
    totalUnitsChange: {
        label: "Change #",
        tip: "Difference in the number of units sold between the Year to Date (YTD) [currentYear] and YTD [previousYear]",
        hasDate: true
    },
    totalUnitsGrowth: {
        label: "% Change #",
        tip: "Percentage difference in the number of units sold between the Year to Date (YTD) [currentYear] and YTD [previousYear]",
        hasDate: true
    }
});
const $ab420772d827bb15$export$6064337aeedc035f = Object.freeze({
    officeInformation: "Office Information",
    totalSell: "Total Sell",
    totalList: "Total List",
    noPriceChangeListings: "No Price Change Listings",
    priceChangeListings: "Price Change Listings",
    emptyString: "",
    agents: "Agents",
    potentialImpact: "Potential Impact",
    agentInformation: "Agent Information",
    beforeMove: "Before Move",
    afterMove: "After Move"
});
const $ab420772d827bb15$export$18c017579417a58 = Object.freeze({
    isSelected: {
        id: "isSelected",
        label: "",
        tip: ""
    },
    rank: {
        label: "Rank",
        tip: "Rank based on Total $ Volume of the current search"
    },
    agentName: {
        label: "Agent Name",
        tip: "Name of the Agent"
    },
    officeName: {
        label: "Office Name",
        tip: "Office Name as supplied by the MLS"
    },
    officeId: {
        label: "Office ID",
        tip: "ID code assigned by MLS"
    },
    officeAddress: {
        label: "Office Address",
        tip: "The office's physical and/or mailing address as reflected in the MLS data"
    },
    officeCity: {
        label: "City",
        tip: "City where office resides"
    },
    officeZipCode: {
        label: "Zip",
        tip: "The USPS zip code associated with the office as reflected in the MLS data"
    },
    officeCounty: {
        label: "County",
        tip: "The county associated with the office as reflected in the MLS data"
    },
    last12SellUnits: {
        label: "# Units",
        tip: "The number of sell-side transactions"
    },
    last12SellVolume: {
        label: "$ Volume",
        tip: "The $ volume of sell-side transactions"
    },
    last12ListUnits: {
        label: "# Units",
        tip: "The number of list-side transactions"
    },
    last12ListVolume: {
        label: "$ Volume",
        tip: "The $ volume of list-side transactions"
    },
    area: {
        label: "Area",
        tip: "The area name as reflected in the MLS data"
    },
    agentId: {
        label: "Agent ID",
        tip: "ID code assigned by MLS"
    },
    listVolume: {
        label: "$ Volume",
        tip: "The $ volume of list-side transactions"
    },
    sellVolume: {
        label: "$ Volume",
        tip: "The $ volume of sell-side transactions"
    },
    totalVolume: {
        label: "$ Volume",
        tip: "The $ volume of all transactions"
    },
    listUnits: {
        label: "# Units",
        tip: "The number of list-side transactions"
    },
    sellUnits: {
        label: "# Units",
        tip: "The number of sell-side transactions"
    },
    averagePrice: {
        label: "Average Price",
        tip: "The average price of all transactions"
    },
    last12Spop: {
        label: "SP/OP",
        tip: "The average SP/OP ratio for all transactions"
    },
    last12AvgDom: {
        label: "DOM",
        tip: "The average DOM for all transactions"
    },
    totalUnitsChange: {
        label: "Change #",
        tip: "Difference in the number of all transactions between the Last 12 Months [last12Months] and the Previous 12 Months [previous12Months]"
    },
    last12TotalVolume: {
        label: "$ Volume",
        tip: "The $ volume of all transactions"
    },
    last12TotalUnits: {
        label: "# Units",
        tip: "The number of all transactions"
    },
    totalVolumeChange: {
        label: "Change $",
        tip: "Difference in the dollar volume of all transactions between the Last 12 Months [last12Months] and the Previous 12 Months [previous12Months]"
    },
    totalUnits: {
        label: "# Units",
        tip: "The number of all transactions"
    },
    noPcLast12ListUnits: {
        label: "# Units",
        tip: "The number of list-side transactions that had no price changes"
    },
    noPcLast12ListUnitsPct: {
        label: "% of Total (#)",
        tip: "The number of list-side transactions that had no price changes as a percentage of the total number of list-side transactions"
    },
    noPcLast12ListVolume: {
        label: "$ Volume",
        tip: "The $ volume of list-side transactions that had no price changes"
    },
    noPcLast12ListVolumePct: {
        label: "% of Total ($)",
        tip: "The $ volume of list-side transactions that had no price changes as a percentage of the total $ volume of list-side transactions"
    },
    noPcLast12ListDom: {
        label: "DOM",
        tip: "The average DOM for listings that had no price changes"
    },
    noPcLast12ListCdom: {
        label: "CDOM",
        tip: "The average CDOM for listings that had no price changes"
    },
    noPcLast12SpOp: {
        label: "SP/OP",
        tip: "The average ratio of the sold price (closed price) to the original list price as a percentage for listings that had no price changes"
    },
    pcLast12ListUnits: {
        label: "# Units",
        tip: "The number of list-side transactions that had one or more price changes"
    },
    pcLast12ListUnitsPct: {
        label: "% of Total (#)",
        tip: "The number of list-side transactions that had one or more price changes as a percentage of the total number of list-side transactions"
    },
    pcLast12ListVolume: {
        label: "$ Volume",
        tip: "The $ volume of list-side transactions that had one or more price changes"
    },
    pcLast12ListVolumePct: {
        label: "% of Total ($)",
        tip: "The $ volume of list-side transactions that had one or more price changes as a percentage of the total $ volume of list-side transactions"
    },
    pcLast12ListDom: {
        label: "DOM",
        tip: "The average DOM for listings that had one or more price changes"
    },
    pcLast12ListCdom: {
        label: "CDOM",
        tip: "The average CDOM for listings that had one or more price changes"
    },
    pcLast12ListPcDom: {
        label: "PC DOM",
        tip: "The average number of days from the date of the last price change to the date the listing went under contract"
    },
    pcLast12ListSpOp: {
        label: "SP/OP",
        tip: "The average ratio of the sold price (closed price) to the original list price as a percentage for listings that had one or more price changes"
    },
    pcLast12ListSpLp: {
        label: "SP/LP",
        tip: "The average ratio of the sold price (closed price) to the list price (the price that drew the offer) as a percentage for listings that had one or more price changes"
    },
    pcLast12ListAvgNumPc: {
        label: "Avg # PC",
        tip: "The average number of price changes"
    },
    favoriteAgents: {
        ...$ab420772d827bb15$export$9866cc3252996bc4.favoriteAgents
    }
});
const $ab420772d827bb15$export$4fcb2154ac6197e7 = Object.freeze({
    ...$ab420772d827bb15$export$18c017579417a58,
    rank: $ab420772d827bb15$var$rankTooltipSA
});
const $ab420772d827bb15$export$bbda0b45e6747154 = Object.freeze({
    officeId: {
        id: "officeId",
        label: "MLS Office ID",
        tip: "MLS Office ID"
    },
    officeName: {
        id: "officeName",
        label: "Office Name",
        tip: "Office Name"
    },
    moveDate: {
        id: "moveDate",
        label: "Date Left",
        tip: "Date Left"
    }
});
const $ab420772d827bb15$export$5cfb32d4bd86a1b1 = Object.freeze({
    mlsNum: {
        id: "mlsNum",
        label: "MLS #",
        tip: "Unique MLS number"
    },
    typeName: {
        id: "typeName",
        label: "Type",
        tip: "Property Type, i.e., DE, AT."
    },
    address: {
        id: "address",
        label: "Address",
        tip: "The street address"
    },
    city: {
        id: "city",
        label: "City",
        tip: "City name"
    },
    zip: {
        id: "zip",
        keyField: "zipCode",
        label: "Zip",
        tip: "Zip Code"
    },
    area: {
        id: "area",
        keyField: "areaId",
        label: "Area",
        tip: "The code the MLS uses to define an area"
    },
    bankProperty: {
        id: "bankProperty",
        keyField: "bankStatus",
        label: "Bank Property",
        tip: "A 'Y' indicates that the property is distressed (in foreclosure; or in foreclosure and subject to short sale; or owned/REO); an 'N' indicates the property is free of any bank mediation"
    },
    orgPrice: {
        id: "orgPrice",
        label: "Original Price",
        tip: "The original list price"
    },
    listPrice: {
        id: "listPrice",
        label: "List Price",
        tip: "Price that drew the offer"
    },
    lastPrice: {
        id: "lastPrice",
        label: "Sold Price",
        tip: "Sold Price"
    },
    priceChangeCnt: {
        id: "priceChangeCnt",
        label: "# of Price Changes",
        tip: "The number (#) of price changes"
    },
    spop: {
        id: "spop",
        label: "SP/OP",
        tip: "The ratio of Sales Price to Original Price"
    },
    splp: {
        id: "splp",
        label: "SP/LP",
        tip: "Ratio of the sold price (closed price) to the list price (the price that drew the offer)"
    },
    soldDate: {
        id: "soldDate",
        keyField: "dateLast",
        label: "Sold Date",
        tip: "Sold Date"
    },
    dom: {
        id: "dom",
        label: "DOM",
        tip: "The Days on Market associated with the property record's current MLS number"
    },
    cdom: {
        id: "cdom",
        label: "CDOM",
        tip: "The Continuous Days on Market associated with the property record's MLS history"
    },
    pcDom: {
        id: "pcDom",
        label: "PC DOM",
        tip: "The average number of days from the date of the last price change to the date the listing went under contract"
    },
    bedrooms: {
        id: "bedrooms",
        label: "BD",
        tip: "The number of bedrooms"
    },
    bathrooms: {
        id: "bathrooms",
        label: "BA",
        tip: "The number of full baths"
    },
    squareFt: {
        id: "squareFt",
        label: "SQFT",
        tip: "The square footage"
    },
    pricePerSquareFt: {
        id: "pricePerSquareFt",
        label: "$/SQFT",
        tip: "The cost per square foot"
    },
    lotSizeSquareFt: {
        id: "lotSizeSquareFt",
        label: "Lot Size (SQFT)",
        tip: "The lot size (square feet)"
    },
    yearBuilt: {
        id: "yearBuilt",
        label: "Year Built",
        tip: "Year Built"
    },
    listAgent: {
        id: "listAgent",
        label: "List Agent",
        tip: "Agent(s) representing the list side of the transaction"
    },
    sellAgent: {
        id: "sellAgent",
        label: "Sell Agent",
        tip: "Agent(s) representing the sell side of the transaction"
    },
    doubleSided: {
        id: "doubleSided",
        label: "DBL",
        tip: "Agent(s) representing both sides of the transaction"
    }
});
const $ab420772d827bb15$export$6751f178d0127cda = Object.freeze({
    officeId: {
        id: "officeId",
        label: "Office Id",
        tip: "ID code assigned by MLS"
    },
    officeName: {
        id: "officeName",
        label: "Office Name",
        tip: "Name of Office"
    },
    mlsNum: {
        id: "mlsNum",
        label: "MLS #",
        tip: "Unique MLS number"
    },
    typeName: {
        id: "typeName",
        label: "Type",
        tip: "Property Type, i.e., DE, AT."
    },
    address: {
        id: "address",
        label: "Address",
        tip: "The street address"
    },
    city: {
        id: "city",
        label: "City",
        tip: "City name"
    },
    zipCode: {
        id: "zipCode",
        label: "Zip",
        tip: "Zip Code"
    },
    areaId: {
        id: "areaId",
        label: "Area",
        tip: "The code the MLS uses to define an area"
    },
    orgPrice: {
        id: "orgPrice",
        label: "Original Price",
        tip: "The original list price"
    },
    listPrice: {
        id: "listPrice",
        label: "List Price",
        tip: "List Price"
    },
    lastPrice: {
        id: "lastPrice",
        label: "Sold Price",
        tip: "Sold Price"
    },
    dateLastUC: {
        id: "dateLastUC",
        keyField: "dateLast",
        label: "UC Date",
        tip: "UC Date"
    },
    dateLastForSale: {
        id: "dateLastForSale",
        keyField: "dateLast",
        label: "List Date",
        tip: "List Date"
    },
    dateLastSold: {
        id: "dateLastSold",
        keyField: "dateLast",
        label: "Sold Date",
        tip: "Sold Date"
    },
    dom: {
        id: "dom",
        label: "DOM",
        tip: "The Days on Market associated with the property record's current MLS number"
    },
    cdom: {
        id: "cdom",
        label: "CDOM",
        tip: "The Continuous Days on Market associated with the property record's MLS history"
    },
    pcDom: {
        id: "pcDom",
        label: "PC DOM",
        tip: "The average number of days from the date of the last price change to the date the listing went under contract"
    },
    bankStatus: {
        id: "bankStatus",
        label: "Bank Property",
        tip: "A 'Y' indicates that the property is distressed (in foreclosure; or in foreclosure and subject to short sale; or owned/REO); an 'N' indicates the property is free of any bank mediation"
    },
    priceChangeCnt: {
        id: "priceChangeCnt",
        label: "# of Price Changes",
        tip: "The number (#) of price changes"
    },
    bedrooms: {
        id: "bedrooms",
        label: "BD",
        tip: "The number of bedrooms"
    },
    fullBaths: {
        id: "fullBaths",
        label: "BA",
        tip: "The number of full baths"
    },
    squareFt: {
        id: "squareFt",
        label: "SQFT",
        tip: "The square footage"
    },
    pricePerSquareFt: {
        id: "pricePerSquareFt",
        label: "$/SQFT",
        tip: "The cost per square foot"
    },
    lotSizeSquareFt: {
        id: "lotSizeSquareFt",
        label: "Lot Size (SQFT)",
        tip: "The lot size (square feet)"
    },
    yearBuilt: {
        id: "yearBuilt",
        label: "Year Built",
        tip: "Year Built"
    },
    listAgent: {
        id: "listAgent",
        label: "List Agent",
        tip: "Agent(s) representing the list side of the transaction"
    },
    spop: {
        id: "spop",
        label: "SP/OP",
        tip: "The ratio of Sales Price to Original Price"
    },
    splp: {
        id: "splp",
        label: "SP/LP",
        tip: "Ratio of the sold price (closed price) to the list price (the price that drew the offer)"
    },
    sellAgent: {
        id: "sellAgent",
        label: "Sell Agent",
        tip: "Agent(s) representing the sell side of the transaction"
    },
    doubleSided: {
        id: "doubleSided",
        label: "DBL",
        tip: "Agent(s) representing both sides of the transaction"
    }
});
const $ab420772d827bb15$export$5482b997bb0ea53a = Object.freeze({
    date: {
        id: "date",
        label: "Date",
        tip: "Date of historical event"
    },
    status: {
        id: "status",
        label: "Status",
        tip: "Status"
    },
    price: {
        id: "price",
        label: "Price",
        tip: "Price if sold the sale price otherwise the list price"
    },
    priceChange: {
        id: "priceChange",
        label: "Price Change",
        tip: "Price Change"
    },
    priceChangePct: {
        id: "priceChangePct",
        label: "Price Change %",
        tip: "Price Change Percentage"
    },
    days: {
        id: "days",
        label: "Days",
        tip: "The number (#) of days this status is recorded in MLS"
    },
    changeType: {
        id: "changeType",
        label: "Change Type",
        tip: "Change Type"
    },
    spop: {
        id: "spop",
        label: "SP/OP",
        tip: "Sales Price to Original Price ratio"
    },
    splp: {
        id: "splp",
        label: "SP/LP",
        tip: "Ratio of the sold price (closed price) to the list price (the price that drew the offer)"
    }
});
const $ab420772d827bb15$export$70f3b69c858c385c = Object.freeze({
    producingAgents: {
        id: "producingAgents",
        label: "PA.",
        tip: "Producing Agents"
    },
    volume: {
        id: "volume",
        label: "Volume",
        tip: "Total $ volume of transaction sides (list + sell) for the last 12 months PLUS the current month to date"
    }
});
const $ab420772d827bb15$export$f1d71ecb22c54c48 = Object.freeze({
    agentName: {
        id: "agentName",
        label: "Agent Name",
        tip: "Agent Name"
    },
    agentId: {
        id: "agentId",
        label: "Agent Id",
        tip: "Agent Id"
    },
    officeName: {
        id: "officeName",
        label: "Office",
        tip: "Office Name"
    },
    officeCity: {
        id: "officeCity",
        label: "City",
        tip: "Office City"
    },
    officeZipCode: {
        id: "officeZipCode",
        label: "Zip",
        tip: "Office City"
    },
    officeCounty: {
        id: "officeCounty",
        label: "County",
        tip: "Office County"
    },
    agentStatus: {
        id: "agentStatus",
        label: "Status",
        tip: "Agent's Status"
    },
    volume: {
        id: "volume",
        label: "Volume",
        tip: "Volume"
    }
});
const $ab420772d827bb15$export$f3cb48e74e28c392 = Object.freeze({
    agentName: {
        id: "agentName",
        label: "Agent Name",
        tip: "Agent Name"
    },
    agentId: {
        id: "agentId",
        label: "Agent Id",
        tip: "Agent Id"
    },
    officeName: {
        id: "officeName",
        label: "Office",
        tip: "Office Name"
    },
    officeCity: {
        id: "officeCity",
        label: "City",
        tip: "Office City"
    },
    officeZipCode: {
        id: "officeZipCode",
        label: "Zip",
        tip: "Office City"
    },
    officeCounty: {
        id: "officeCounty",
        label: "County",
        tip: "Office County"
    }
});
const $ab420772d827bb15$export$6a5dc8a672d29538 = Object.freeze({
    isSelected: {
        id: "isSelected",
        label: "",
        tip: ""
    },
    officeName: {
        id: "officeName",
        label: "Office Name",
        tip: "Office Name"
    },
    officeId: {
        id: "officeId",
        label: "Office ID",
        tip: "MLS Office ID"
    },
    streetName: {
        id: "streetName",
        label: "Address",
        tip: "Address"
    },
    city: {
        id: "city",
        label: "City",
        tip: "City"
    },
    zipCode: {
        id: "zipCode",
        label: "Zip",
        tip: "Zip Coode"
    },
    county: {
        id: "county",
        label: "County",
        tip: "County"
    },
    producingAgentCount: {
        id: "producingAgentCount",
        label: "PA.",
        tip: "Producing Agents"
    },
    totalVolume: {
        id: "totalVolume",
        label: "Volume",
        tip: "Total $ volume of transaction sides (list + sell) for the last 12 months PLUS the current month to date"
    }
});
const $ab420772d827bb15$export$2bb9e92fef1fa7d3 = Object.freeze({
    agentProfile: `${(0, $c7dF9.Routes).PROF_METRICS.BASE}${(0, $c7dF9.Routes).PROF_METRICS.AGENT_PROFILE}`
});
const $ab420772d827bb15$export$e5b8f80f89782c65 = Object.freeze({
    column1: "column1",
    column2: "column2",
    column3: "column3",
    column4: "column4",
    column5: "column5",
    column6: "column6",
    column7: "column7",
    contact: "contact",
    search: "search",
    mls: "mls",
    growth: "growth"
});
const $ab420772d827bb15$export$3cec44e1103dfb75 = {
    addAgentList: "Add Agent List",
    agentListCreated: (AgentListName)=>`Success: ${AgentListName} has been created.`,
    unableToCreateList: "Error: Unable to create list. Please try again.",
    chooseAName55Char: "Choose a name for the new agent list (max 55 characters)",
    chooseDifferentName: `The name you have entered already exists. Please choose a different name.`,
    enterListName: "Enter list name",
    listName: "list name",
    savedAgentLists: "saved agent lists",
    reservedListName: "All Lists",
    reservedListWarning: "\u201DAll Lists\u201D is reserved by the system. Please enter a different name.",
    savedAgentListsTitle: "Saved Agent Lists",
    newList: "New List",
    createSavedAgentList: "Create a Saved Agent List",
    emptyListDescription: "Create a custom list where you can save and organize selected agents for easy access and follow-up.",
    addingContactsTo: (count)=>({
            prefix: "You are adding",
            countWithLabel: `${count} ${count === 1 ? "Agent" : "Agents"}`,
            suffix: "to:"
        }),
    addToList: "Add To List",
    download: "Download",
    savedAgentsLimitsToAddMssg: "Each list can hold up to 2,000 agents. Create multiple lists to organize more.",
    typeNewList: "Type new list name",
    selectedAgentsSavedNewList: "The selected agents will be added to a newly created saved agent list.",
    createList: "Create list",
    duplicatedName: "The name you have entered already exists. Please choose a different name.",
    successCreateNewList: (listName)=>`Success: ${listName} has been created and selected agents added to the list.`,
    chooseNameNewList: "Choose a name for the new agent list (max 55 characters)."
};
const $ab420772d827bb15$export$f66e80ecd091dbdb = {
    addList: "add list",
    agentRemovedFromList: "Agent removed from the list",
    agentAddedToList: "Agent added to the list",
    auto: "auto",
    bottom: "bottom",
    bottomStart: "bottom-start",
    bottomEnd: "bottom-end",
    checkbox: "checkbox",
    click: "click",
    favoriteAgentPopover: "favorite-agent-popover",
    legacy: "legacy",
    starIcon: (tableId, rowIndex, tabId)=>`starIcon-${tableId}${!!tabId && `-${tabId}`}-${rowIndex}`,
    currentList: "current list",
    savedAgentLists: "saved agent lists",
    atLeastOneAgentInList: "A saved agent list must have at least one agent in it."
};

});

parcelRegister("fVDYX", function(module, exports) {

$parcel$export(module.exports, "getCurrentTabTimePeriod", () => $b98b3187e85738a6$export$63a4b794e36c2e36);
$parcel$export(module.exports, "getTabFilters", () => $b98b3187e85738a6$export$8bcbcb8e74e1f59b);
$parcel$export(module.exports, "getCurrentTabState", () => $b98b3187e85738a6$export$391416b5ef5d90a7);
$parcel$export(module.exports, "getTabDescription", () => $b98b3187e85738a6$export$9fbb4815fbca4cfc);
$parcel$export(module.exports, "getFooterTimePeriodValue", () => $b98b3187e85738a6$export$7def349e847515fa);
$parcel$export(module.exports, "getFooterIncDecProducerValue", () => $b98b3187e85738a6$export$2ff5f6f4527e079f);
$parcel$export(module.exports, "toNegativeString", () => $b98b3187e85738a6$export$76058e9c048689a5);
$parcel$export(module.exports, "getValidationSettings", () => $b98b3187e85738a6$export$912bdb168c32a725);
$parcel$export(module.exports, "getChangeWord", () => $b98b3187e85738a6$export$681ef44c163fa1b5);
$parcel$export(module.exports, "getIncDecProducerTitle", () => $b98b3187e85738a6$export$bc7f5d114ce58141);
$parcel$export(module.exports, "getHasResults", () => $b98b3187e85738a6$export$bb62027feb8aa6a6);
$parcel$export(module.exports, "getOptionValue", () => $b98b3187e85738a6$export$40be908210c5a79c);
$parcel$export(module.exports, "validateGrowthFields", () => $b98b3187e85738a6$export$5f9556702956eea7);
$parcel$export(module.exports, "resolveTabDescription", () => $b98b3187e85738a6$export$94adcefa6746c021);
$parcel$export(module.exports, "getMlsToUpdate", () => $b98b3187e85738a6$export$d761efa24f052678);

var $9QX0f = parcelRequire("9QX0f");

var $cstaF = parcelRequire("cstaF");

var $75U5M = parcelRequire("75U5M");

var $bLQRh = parcelRequire("bLQRh");

var $9S3rS = parcelRequire("9S3rS");
const $b98b3187e85738a6$export$63a4b794e36c2e36 = (producers, isGrowthAnalysisView)=>producers?.newProd || (isGrowthAnalysisView ? producers?.growthTimeFrame : producers?.timeFrame) || producers?.timePeriod || null;
const $b98b3187e85738a6$export$8bcbcb8e74e1f59b = (rowData, currentTabProducers)=>({
        topProducers: rowData.slice(0, parseInt(currentTabProducers?.lowPos?.label))
    });
const $b98b3187e85738a6$export$391416b5ef5d90a7 = (currentModule, state)=>{
    if (currentModule !== (0, $cstaF.modules).proficiencyMetrics.suggestedAgents) return;
    const currentTabId = state[currentModule].currentTabId;
    const tabState = state[currentModule].searchOptions[currentTabId];
    return tabState;
};
const $b98b3187e85738a6$export$9fbb4815fbca4cfc = (currentTabId, args)=>{
    const getTabDescription = (0, $9QX0f.tabs)[currentTabId]?.description;
    return getTabDescription && (0, $9QX0f.tabs)[currentTabId]?.description(args);
};
const $b98b3187e85738a6$export$7def349e847515fa = (currentSearchDates, currentTabId)=>{
    const getPreviousYearDate = (date)=>{
        if (!date) return;
        return new Date(date).setFullYear(new Date(date).getFullYear() - 1).toLocaleString();
    };
    const previousFromDate = getPreviousYearDate(currentSearchDates?.from);
    const previousToDate = getPreviousYearDate(currentSearchDates?.to);
    if (!currentSearchDates?.from || !currentSearchDates?.to) return "";
    if ([
        (0, $9QX0f.tabs).incProducers.id,
        (0, $9QX0f.tabs).decProducers.id
    ].includes(currentTabId)) return `${(0, $75U5M.formatShortDate)(currentSearchDates?.from)} - ${(0, $75U5M.formatShortDate)(currentSearchDates?.to)} vs.
            ${(0, $75U5M.formatShortDate)(new Date(Number(previousFromDate.replace(/,/g, ""))))} -
                ${(0, $75U5M.formatShortDate)(new Date(Number(previousToDate.replace(/,/g, ""))))}`;
    return `${(0, $75U5M.formatShortDate)(currentSearchDates?.from)} - ${(0, $75U5M.formatShortDate)(currentSearchDates?.to)}`;
};
const $b98b3187e85738a6$export$2ff5f6f4527e079f = ({ minGrowth: minGrowth, maxGrowth: maxGrowth, currentTabId: currentTabId, timeFrame: timeFrame, inactivityPeriod: inactivityPeriod })=>{
    const incDecLabels = {
        [(0, $9QX0f.tabs).decProducers.id]: (0, $bLQRh.terms).decrease.toLocaleLowerCase(),
        [(0, $9QX0f.tabs).incProducers.id]: (0, $bLQRh.terms).increase.toLocaleLowerCase()
    };
    if (currentTabId === (0, $9QX0f.tabs).newProducers.id) return `${timeFrame}, ${inactivityPeriod} ${(0, $9QX0f.terms).inactivity}`;
    if (!minGrowth && !maxGrowth) return;
    if (!!minGrowth && !maxGrowth) return `>= ${minGrowth}% ${incDecLabels[currentTabId] || ""}`;
    if (!minGrowth && !!maxGrowth) return `<= ${maxGrowth}% ${incDecLabels[currentTabId] || ""}`;
    return `${minGrowth}% - ${maxGrowth}% ${incDecLabels[currentTabId] || ""}`;
};
const $b98b3187e85738a6$export$76058e9c048689a5 = (positiveString)=>{
    return "-" + positiveString;
};
const $b98b3187e85738a6$export$912bdb168c32a725 = ({ minGrowth: minGrowth, maxGrowth: maxGrowth, currentTabId: currentTabId })=>{
    const termValidationByKeyField = {
        decProducers: "decreasePct",
        incProducers: "increasePct"
    };
    return (0, $9S3rS.validateRange)(termValidationByKeyField[currentTabId], {
        min: parseInt(minGrowth),
        max: parseInt(maxGrowth)
    });
};
const $b98b3187e85738a6$export$681ef44c163fa1b5 = (isIncreasing)=>isIncreasing ? (0, $9QX0f.terms).increase : (0, $9QX0f.terms).decrease;
const $b98b3187e85738a6$export$bc7f5d114ce58141 = (isIncreasingProducers, timePeriod, minGrowth = "", maxGrowth = "")=>{
    let rangeText = "";
    if (minGrowth !== "" && maxGrowth !== "") rangeText = (0, $9QX0f.terms).incDecBetween(minGrowth, maxGrowth);
    if (minGrowth !== "" && maxGrowth === "") rangeText = (0, $9QX0f.terms).incDecMinOnly(minGrowth);
    if (minGrowth === "" && maxGrowth !== "") rangeText = (0, $9QX0f.terms).incDecMaxOnly(maxGrowth);
    return (0, $9QX0f.terms).incDecTitle(isIncreasingProducers, rangeText, timePeriod.toLowerCase());
};
const $b98b3187e85738a6$export$bb62027feb8aa6a6 = (agentData)=>agentData?.results?.length > 0;
const $b98b3187e85738a6$export$40be908210c5a79c = (option, stateId)=>{
    const isGrowthField = stateId === (0, $9QX0f.searchfilterStateId).minGrowth || stateId === (0, $9QX0f.searchfilterStateId).maxGrowth;
    if (isGrowthField) return option.replace(/\D/g, "");
    if (option?.value !== undefined) return option;
    if (option?.[stateId] !== undefined) return option[stateId];
    return option;
};
const $b98b3187e85738a6$export$5f9556702956eea7 = (selectedTabState, currentTabId)=>{
    const isIncOrDecProducersTab = currentTabId === (0, $9QX0f.tabs).incProducers.id || currentTabId === (0, $9QX0f.tabs).decProducers.id;
    const isMissingGrowth = !selectedTabState[currentTabId]?.minGrowth && !selectedTabState[currentTabId]?.maxGrowth;
    return isIncOrDecProducersTab && isMissingGrowth;
};
const $b98b3187e85738a6$export$94adcefa6746c021 = ({ selectedTabState: selectedTabState, currentTabId: currentTabId, currentInactivityPeriod: currentInactivityPeriod, currentTabTimePeriod: currentTabTimePeriod, selectedLowPos: selectedLowPos })=>{
    if (currentTabId === (0, $9QX0f.tabs).topProducers.id) {
        const highProducingAgents = selectedTabState.topProducers?.lowPos?.label || selectedLowPos?.label;
        return $b98b3187e85738a6$export$9fbb4815fbca4cfc(currentTabId, {
            highProducingAgents: highProducingAgents
        });
    }
    return $b98b3187e85738a6$export$9fbb4815fbca4cfc(currentTabId, {
        inactivityPeriod: currentInactivityPeriod,
        timePeriod: currentTabTimePeriod?.label,
        minGrowth: selectedTabState?.[currentTabId]?.minGrowth,
        maxGrowth: selectedTabState?.[currentTabId]?.maxGrowth
    });
};
const $b98b3187e85738a6$export$d761efa24f052678 = ({ selectedTabState: selectedTabState, currentTabId: currentTabId, mlsProviders: mlsProviders })=>{
    const localMlsSelection = selectedTabState?.[currentTabId]?.mls;
    if (!localMlsSelection) return;
    return mlsProviders.find((mls)=>mls.mlsId === localMlsSelection?.value);
};

});
parcelRegister("9QX0f", function(module, exports) {

$parcel$export(module.exports, "terms", () => $72c6bd28fe8212b9$export$8a21ba990ca4a7cb);
$parcel$export(module.exports, "todaysPicksTerms", () => $72c6bd28fe8212b9$export$c4f1920801226fe);
$parcel$export(module.exports, "editCriteriaTerms", () => $72c6bd28fe8212b9$export$88d83a21142f63ee);
$parcel$export(module.exports, "areaSelectDropdown", () => $72c6bd28fe8212b9$export$28fc5ffd78e63822);
$parcel$export(module.exports, "popoverIds", () => $72c6bd28fe8212b9$export$51ce7345482f4fda);
$parcel$export(module.exports, "popoverTerms", () => $72c6bd28fe8212b9$export$f66e80ecd091dbdb);
$parcel$export(module.exports, "filterIds", () => $72c6bd28fe8212b9$export$691234149d9c7e3b);
$parcel$export(module.exports, "tabs", () => $72c6bd28fe8212b9$export$39f5674517ec0000);
$parcel$export(module.exports, "searchfilterStateId", () => $72c6bd28fe8212b9$export$d18435dc7c9279f9);
$parcel$export(module.exports, "producerOptions", () => $72c6bd28fe8212b9$export$801ab54cd4c88d1a);
$parcel$export(module.exports, "growthAnalysisIncDecTimeFrame", () => $72c6bd28fe8212b9$export$b12a817e544cf331);
$parcel$export(module.exports, "searchConfigFallback", () => $72c6bd28fe8212b9$export$82a1e9854ae8f258);
$parcel$export(module.exports, "searchConfigByTabId", () => $72c6bd28fe8212b9$export$67735b74eed019ff);
$parcel$export(module.exports, "tableSettingsByTab", () => $72c6bd28fe8212b9$export$1cfbc6822077bc4a);
$parcel$export(module.exports, "allViewOptions", () => $72c6bd28fe8212b9$export$47b8d22fd39bffc);
$parcel$export(module.exports, "viewOptionsByTab", () => $72c6bd28fe8212b9$export$19d5216b8fe43604);
$parcel$export(module.exports, "timeFrameToGrowthPeriod", () => $72c6bd28fe8212b9$export$d671c5a7c842df63);
$parcel$export(module.exports, "headerParentIndexesToRemoveByTabAndView", () => $72c6bd28fe8212b9$export$aedd13e91d7a2357);

var $8QuU9 = parcelRequire("8QuU9");

var $cstaF = parcelRequire("cstaF");

var $aypMh = parcelRequire("aypMh");

var $fVDYX = parcelRequire("fVDYX");

var $htzEo = parcelRequire("htzEo");
const $72c6bd28fe8212b9$export$8a21ba990ca4a7cb = Object.freeze({
    adjustFilters: "Adjust filters or check back again soon.",
    afterAnInactivityPeriodOf: "After an inactivity period of",
    agentsWhoClosedATransaction: (timePeriod)=>`Agents who have closed a transaction with your office in the ${timePeriod}`,
    agentsWhoHaveNewProduction: (timePeriod, inactivityPeriod)=>`Agents who have new production over the ${timePeriod} after an inactivity period of ${inactivityPeriod}`,
    coopAgents: "Cooperating Agents",
    decProducers: "Decreasing Producers",
    getLastXDaysLabel: (days)=>`Last ${days} Days`,
    hasNewProductionOver: "Has new production over",
    inactivity: "inactivity",
    incProducers: "Increasing Producers",
    l12m: "Last 12 months",
    l12mVsPrev12Monts: "Last 12 months vs. previous 12 months",
    l60d: "Last 60 days",
    l90d: "Last 90 days",
    l90dVsSameLastYear: "Last 90 days vs. same time last year",
    l180d: "Last 180 days",
    lowestPosition: "Lowest Position",
    maxIncrease: "Maximum Increase",
    minIncrease: "Minimum Increase",
    maxDecrease: "Maximum Decrease",
    minDecrease: "Minimum Decrease",
    newProducers: "New Producers",
    noTabResultsFound: (tabTitle)=>`No ${tabTitle} Found`,
    oneYear: "1 year",
    refreshSearch: "Refresh Search",
    suggestedAgents: "Suggested Agents",
    timeFrame: "Time Frame",
    timePeriod: "Time Period",
    topProducers: "Top Producers",
    twoYears: "2 years",
    ytdVsPrevYtd: "Year to date vs. previous year to date",
    highestProducingAgents: (producingAgentsAmount)=>`The ${producingAgentsAmount} highest producing agents.`,
    production: "Production",
    increase: "increase",
    decrease: "decrease",
    incDecTitle: (isIncreasingProducers, rangeText, timePeriod)=>`Agents with a production ${(0, $fVDYX.getChangeWord)(isIncreasingProducers)} ${rangeText} over the ${timePeriod}.`,
    incDecBetween: (minGrowth, maxGrowth)=>`between ${minGrowth}% and ${maxGrowth}%`,
    incDecMinOnly: (minGrowth)=>`of ${minGrowth}% or more`,
    incDecMaxOnly: (maxGrowth)=>`of up to ${maxGrowth}%`
});
const $72c6bd28fe8212b9$export$c4f1920801226fe = Object.freeze({
    todaysPicks: "Today's Picks",
    todaysPicksDescription: "Top agent recommendations based on likelihood of movement.",
    failedLoad: "Failed to load Today's Picks",
    noTodaysPicksTitle: "No Todays Picks Found",
    noTodaysPicksBody: "Check back again soon for new recommendations.",
    likelihoodChartTitle: "Likelihood of Movement",
    volume: "Volume",
    units: "Units",
    projected: "Projected",
    low: "Low",
    medium: "Medium",
    high: "High",
    eoyPerformanceProjections: "EOY PERFORMANCE PROJECTIONS",
    projectedRange: (projectedVolumeMin, projectedVolumeMax)=>`${(0, $htzEo.getCompactDollars)(projectedVolumeMin)} to ${(0, $htzEo.getCompactDollars)(projectedVolumeMax)}`,
    projectedUnitsRange: (projectedUnitsMin, projectedUnitsMax)=>`${projectedUnitsMin} to ${projectedUnitsMax} Units`
});
const $72c6bd28fe8212b9$export$88d83a21142f63ee = Object.freeze({
    editCriteria: "Edit Criteria",
    mls: "MLS",
    timePeriod: "Time Period",
    volume: "Volume",
    units: "Units",
    propertyTypes: "Property Types",
    cancel: "Cancel",
    save: "Save",
    selectMls: "Select MLS",
    selectTimePeriod: "Select Time Period",
    selectVolume: "Select Volume",
    selectUnits: "Select Units",
    selectPropertyTypes: "Select Property Types",
    mlsKey: "mls",
    timePeriodKey: "timePeriod",
    volumeKey: "volume",
    unitsKey: "units",
    propertyTypesKey: "propertyTypes",
    allPropertyTypes: "All property types",
    propertyTypesLabel: "Property Type(s)",
    marketArea: "Market Area (Transaction count)",
    areaKey: "area"
});
const $72c6bd28fe8212b9$export$28fc5ffd78e63822 = Object.freeze({
    itemHeight: 35,
    maxMenuHeight: 300,
    defaultAreaType: "city"
});
const $72c6bd28fe8212b9$export$51ce7345482f4fda = Object.freeze({
    display: "display-dropdown",
    metrics: "metrics-dropdown",
    producers: "producers-dropdown",
    growthAnalysisPeriod: "growth-analysis-period"
});
const $72c6bd28fe8212b9$export$f66e80ecd091dbdb = Object.freeze({
    bottomEnd: "bottom-end",
    showDisplayPopover: "showDisplayPopover",
    showProducersPopover: "showProducersPopover"
});
const $72c6bd28fe8212b9$export$691234149d9c7e3b = Object.freeze({
    display: "display",
    metrics: "metrics",
    producers: "producers",
    growthAnalysisPeriod: "growthAnalysisPeriod"
});
const $72c6bd28fe8212b9$export$39f5674517ec0000 = Object.freeze({
    todaysPicks: {
        id: "todaysPicks",
        label: $72c6bd28fe8212b9$export$c4f1920801226fe.todaysPicks,
        index: 0,
        description: $72c6bd28fe8212b9$export$c4f1920801226fe.todaysPicksDescription,
        hasRefreshSearchBtn: false,
        badgeCount: 8
    },
    topProducers: {
        id: "topProducers",
        label: $72c6bd28fe8212b9$export$8a21ba990ca4a7cb.topProducers,
        index: 1,
        description: ({ highProducingAgents: highProducingAgents })=>$72c6bd28fe8212b9$export$8a21ba990ca4a7cb.highestProducingAgents(highProducingAgents),
        hasRefreshSearchBtn: false
    },
    incProducers: {
        id: "incProducers",
        label: $72c6bd28fe8212b9$export$8a21ba990ca4a7cb.incProducers,
        index: 2,
        description: ({ timePeriod: timePeriod, minGrowth: minGrowth, maxGrowth: maxGrowth })=>(0, $fVDYX.getIncDecProducerTitle)(true, timePeriod, minGrowth, maxGrowth),
        hasRefreshSearchBtn: true,
        inputMaxLength: 3
    },
    decProducers: {
        id: "decProducers",
        label: $72c6bd28fe8212b9$export$8a21ba990ca4a7cb.decProducers,
        index: 3,
        description: ({ timePeriod: timePeriod, minGrowth: minGrowth, maxGrowth: maxGrowth })=>(0, $fVDYX.getIncDecProducerTitle)(false, timePeriod, minGrowth, maxGrowth),
        hasRefreshSearchBtn: true,
        inputMaxLength: 3
    },
    newProducers: {
        id: "newProducers",
        label: $72c6bd28fe8212b9$export$8a21ba990ca4a7cb.newProducers,
        index: 4,
        description: ({ timePeriod: timePeriod, inactivityPeriod: inactivityPeriod })=>$72c6bd28fe8212b9$export$8a21ba990ca4a7cb.agentsWhoHaveNewProduction(timePeriod, inactivityPeriod),
        hasRefreshSearchBtn: true
    },
    coopAgents: {
        id: "coopAgents",
        label: $72c6bd28fe8212b9$export$8a21ba990ca4a7cb.coopAgents,
        index: 5,
        description: ({ timePeriod: timePeriod })=>$72c6bd28fe8212b9$export$8a21ba990ca4a7cb.agentsWhoClosedATransaction(timePeriod),
        hasRefreshSearchBtn: true
    }
});
const $72c6bd28fe8212b9$export$d18435dc7c9279f9 = Object.freeze({
    inactivity: "inactivity",
    lowPos: "lowPos",
    mls: "mls",
    minGrowth: "minGrowth",
    maxGrowth: "maxGrowth",
    newProd: "newProd",
    selectedAgentsView: "selectedAgentsView",
    selectedView: "selectedView",
    timeFrame: "timeFrame",
    timePeriod: "timePeriod",
    value: "value",
    growthTimeFrame: "growthTimeFrame"
});
const $72c6bd28fe8212b9$export$801ab54cd4c88d1a = Object.freeze({
    lowPos: [
        {
            value: "lowPos25",
            label: "25"
        },
        {
            value: "lowPos50",
            label: "50"
        },
        {
            value: "lowPos75",
            label: "75"
        },
        {
            value: "lowPos100",
            label: "100"
        }
    ],
    inactivity: [
        {
            value: "12",
            label: $72c6bd28fe8212b9$export$8a21ba990ca4a7cb.oneYear
        },
        {
            value: "24",
            label: $72c6bd28fe8212b9$export$8a21ba990ca4a7cb.twoYears
        }
    ],
    newProd: [
        {
            value: "Last60Days",
            label: $72c6bd28fe8212b9$export$8a21ba990ca4a7cb.l60d
        },
        {
            value: "Last90Days",
            label: $72c6bd28fe8212b9$export$8a21ba990ca4a7cb.l90d
        },
        {
            value: "Annually",
            label: $72c6bd28fe8212b9$export$8a21ba990ca4a7cb.l12m
        }
    ],
    timeFrame: [
        {
            value: (0, $cstaF.TimePeriods)[(0, $cstaF.agentProductionTerms).annually],
            label: $72c6bd28fe8212b9$export$8a21ba990ca4a7cb.l12mVsPrev12Monts
        },
        {
            value: (0, $cstaF.TimePeriods)[(0, $cstaF.agentProductionTerms).YTD],
            label: $72c6bd28fe8212b9$export$8a21ba990ca4a7cb.ytdVsPrevYtd
        }
    ],
    timePeriod: [
        {
            value: "Last90Days",
            label: $72c6bd28fe8212b9$export$8a21ba990ca4a7cb.l90d
        },
        {
            value: "Last180Days",
            label: $72c6bd28fe8212b9$export$8a21ba990ca4a7cb.l180d
        },
        {
            value: "Annually",
            label: $72c6bd28fe8212b9$export$8a21ba990ca4a7cb.l12m
        }
    ]
});
const $72c6bd28fe8212b9$export$b12a817e544cf331 = [
    {
        value: (0, $cstaF.TimePeriods)[(0, $cstaF.agentProductionTerms).last90Days],
        label: $72c6bd28fe8212b9$export$8a21ba990ca4a7cb.l90dVsSameLastYear
    },
    ...$72c6bd28fe8212b9$export$801ab54cd4c88d1a.timeFrame
];
const $72c6bd28fe8212b9$export$82a1e9854ae8f258 = {
    getApiService: ()=>({
            recruitingSoldResponse: [],
            recruitingSoldTotals: {}
        }),
    getProducerValues: ()=>({}),
    getParameters: ()=>[]
};
const $72c6bd28fe8212b9$var$incDecProducersConfig = {
    getProducerValues: (producerOptions, isGrowthAnalysis)=>({
            timePeriod: isGrowthAnalysis ? producerOptions?.growthTimeFrame?.value : producerOptions?.timeFrame?.value,
            minGrowth: producerOptions?.minGrowth,
            maxGrowth: producerOptions?.maxGrowth
        })
};
const $72c6bd28fe8212b9$var$incDecProducersTableSettings = {
    shouldExcludeZeroGrowthAgents: true
};
const $72c6bd28fe8212b9$export$67735b74eed019ff = {
    [$72c6bd28fe8212b9$export$39f5674517ec0000.topProducers.id]: {
        getApiService: (0, $8QuU9.getProficiencyMetrics),
        getProducerValues: (producerOptions)=>({
                lowPos: producerOptions?.lowPos?.value
            }),
        getParameters: ()=>[
                {
                    parameter: "limit",
                    value: "100"
                }
            ]
    },
    [$72c6bd28fe8212b9$export$39f5674517ec0000.newProducers.id]: {
        getApiService: (0, $8QuU9.getNewProducers),
        getProducerValues: (producerOptions)=>({
                newProd: producerOptions?.newProd?.value,
                inactivity: producerOptions?.inactivity?.value
            }),
        getParameters: ({ inactivity: inactivity })=>[
                {
                    parameter: "monthsInactive",
                    value: inactivity
                }
            ]
    },
    [$72c6bd28fe8212b9$export$39f5674517ec0000.coopAgents.id]: {
        getApiService: (0, $8QuU9.getCoopAgents),
        getProducerValues: (producerOptions)=>({
                timePeriod: producerOptions?.timePeriod?.value
            })
    },
    [$72c6bd28fe8212b9$export$39f5674517ec0000.incProducers.id]: {
        getApiService: (0, $8QuU9.getIncreasingProducers),
        ...$72c6bd28fe8212b9$var$incDecProducersConfig,
        getParameters: ({ minGrowth: minGrowth, maxGrowth: maxGrowth })=>{
            const parameters = [];
            parameters.push({
                parameter: $72c6bd28fe8212b9$export$d18435dc7c9279f9.minGrowth,
                value: minGrowth || "0"
            });
            if (maxGrowth) parameters.push({
                parameter: $72c6bd28fe8212b9$export$d18435dc7c9279f9.maxGrowth,
                value: maxGrowth
            });
            return parameters;
        }
    },
    [$72c6bd28fe8212b9$export$39f5674517ec0000.decProducers.id]: {
        getApiService: (0, $8QuU9.getDecreasingProducers),
        ...$72c6bd28fe8212b9$var$incDecProducersConfig,
        getParameters: ({ minGrowth: minGrowth, maxGrowth: maxGrowth })=>{
            // For decreasing producers, Maximum Decrease % is minGrowth parameter
            // Minimum Decrease % is maxGrowth parameter
            const parameters = [];
            if (minGrowth) parameters.push({
                parameter: $72c6bd28fe8212b9$export$d18435dc7c9279f9.maxGrowth,
                value: (0, $fVDYX.toNegativeString)(minGrowth)
            });
            if (maxGrowth) parameters.push({
                parameter: $72c6bd28fe8212b9$export$d18435dc7c9279f9.minGrowth,
                value: (0, $fVDYX.toNegativeString)(maxGrowth)
            });
            return parameters;
        }
    }
};
const $72c6bd28fe8212b9$export$1cfbc6822077bc4a = {
    [$72c6bd28fe8212b9$export$39f5674517ec0000.incProducers.id]: $72c6bd28fe8212b9$var$incDecProducersTableSettings,
    [$72c6bd28fe8212b9$export$39f5674517ec0000.decProducers.id]: $72c6bd28fe8212b9$var$incDecProducersTableSettings
};
const $72c6bd28fe8212b9$export$47b8d22fd39bffc = [
    {
        value: (0, $aypMh.views).overview,
        label: (0, $cstaF.agentProductionTerms).overview
    },
    {
        value: (0, $aypMh.views).contactInformation,
        label: (0, $cstaF.agentProductionTerms).contactInformation
    },
    {
        value: (0, $aypMh.views).growthAnalysis,
        label: (0, $cstaF.agentProductionTerms).growthAnalysis
    },
    {
        value: (0, $aypMh.views).listingProficiency,
        label: (0, $cstaF.agentProductionTerms).listingProficiency
    }
];
const $72c6bd28fe8212b9$export$19d5216b8fe43604 = Object.freeze({
    [$72c6bd28fe8212b9$export$39f5674517ec0000.topProducers.id]: $72c6bd28fe8212b9$export$47b8d22fd39bffc,
    [$72c6bd28fe8212b9$export$39f5674517ec0000.incProducers.id]: $72c6bd28fe8212b9$export$47b8d22fd39bffc,
    [$72c6bd28fe8212b9$export$39f5674517ec0000.decProducers.id]: $72c6bd28fe8212b9$export$47b8d22fd39bffc,
    [$72c6bd28fe8212b9$export$39f5674517ec0000.newProducers.id]: [
        {
            value: (0, $aypMh.views).overview,
            label: (0, $cstaF.agentProductionTerms).overview
        },
        {
            value: (0, $aypMh.views).contactInformation,
            label: (0, $cstaF.agentProductionTerms).contactInformation
        },
        {
            value: (0, $aypMh.views).listingProficiency,
            label: (0, $cstaF.agentProductionTerms).listingProficiency
        }
    ],
    [$72c6bd28fe8212b9$export$39f5674517ec0000.coopAgents.id]: $72c6bd28fe8212b9$export$47b8d22fd39bffc
});
const $72c6bd28fe8212b9$export$d671c5a7c842df63 = {
    [(0, $cstaF.TimePeriods)[(0, $cstaF.agentProductionTerms).last90Days]]: (0, $cstaF.agentProductionTerms).last90Days,
    [(0, $cstaF.TimePeriods)[(0, $cstaF.agentProductionTerms).annually]]: (0, $cstaF.agentProductionTerms).last12Months,
    [(0, $cstaF.TimePeriods)[(0, $cstaF.agentProductionTerms).YTD]]: (0, $cstaF.agentProductionTerms).yearToDate
};
const $72c6bd28fe8212b9$export$b6b5eb376426440b = Object.freeze({
    [(0, $aypMh.views).overview]: {
        currentSearch: 0,
        allMlsTransactionsLast12Months: 1
    },
    [(0, $aypMh.views).contactInformation]: {
        contact: 0,
        currentSearch: 1,
        allMlsTransactionsLast12Months: 2,
        growth: 3
    },
    [(0, $aypMh.views).growthAnalysis]: {
        officeInformation: 0,
        units: 1,
        volumne: 2
    },
    [(0, $aypMh.views).listingProficiency]: {
        officeInformation: 0,
        totalList: 1,
        noPriceChangesListings: 2,
        priceChangesListings: 3
    }
});
const $72c6bd28fe8212b9$var$overviewHeaderParentIndexes = $72c6bd28fe8212b9$export$b6b5eb376426440b[(0, $aypMh.views).overview];
const $72c6bd28fe8212b9$var$contactInfoHeaderParentIndexes = $72c6bd28fe8212b9$export$b6b5eb376426440b[(0, $aypMh.views).contactInformation];
const $72c6bd28fe8212b9$export$aedd13e91d7a2357 = Object.freeze({
    [$72c6bd28fe8212b9$export$39f5674517ec0000.newProducers.id]: {
        [(0, $aypMh.views).overview]: [
            $72c6bd28fe8212b9$var$overviewHeaderParentIndexes.allMlsTransactionsLast12Months
        ],
        [(0, $aypMh.views).contactInformation]: [
            $72c6bd28fe8212b9$var$contactInfoHeaderParentIndexes.allMlsTransactionsLast12Months,
            $72c6bd28fe8212b9$var$contactInfoHeaderParentIndexes.growth
        ]
    }
});

});
parcelRegister("8QuU9", function(module, exports) {

$parcel$export(module.exports, "getProficiencyMetrics", () => $670b271811d34063$export$abea8829bcfc6a17);
$parcel$export(module.exports, "getNewProducers", () => $670b271811d34063$export$beb6402dac9e03b2);
$parcel$export(module.exports, "getCoopAgents", () => $670b271811d34063$export$5c36292e7fa85c9a);
$parcel$export(module.exports, "getAgentMovement", () => $670b271811d34063$export$8e24002657677643);
$parcel$export(module.exports, "getAgentMovementOfficeBreakdown", () => $670b271811d34063$export$7d2db59d6e099f66);
$parcel$export(module.exports, "getAgentBreakdown", () => $670b271811d34063$export$7364c43d0f31555f);
$parcel$export(module.exports, "getDecreasingProducers", () => $670b271811d34063$export$c69200557d75d003);
$parcel$export(module.exports, "getIncreasingProducers", () => $670b271811d34063$export$128dafcc4dd5eed9);
$parcel$export(module.exports, "getTodaysPicks", () => $670b271811d34063$export$a0111625ace2045d);

var $chB0Q = parcelRequire("chB0Q");

var $24YIE = parcelRequire("24YIE");

var $gDxKE = parcelRequire("gDxKE");
const $670b271811d34063$var$searchCriteriaData = (criteria, parameters = [])=>{
    const cleanCriteria = (0, $gDxKE.removeSearchAllMLSFlag)((0, $chB0Q.default)(criteria));
    return [
        {
            parameter: "aergo_search_criteria",
            value: JSON.stringify(cleanCriteria)
        },
        ...parameters
    ];
};
const $670b271811d34063$export$abea8829bcfc6a17 = async (criteria, parameters)=>{
    const response = await (0, $24YIE.newSendApiRequest)("Recruiting_agent_sold", $670b271811d34063$var$searchCriteriaData(criteria, parameters), 240000);
    return {
        recruitingSoldResponse: response?.results,
        recruitingSoldTotals: response?.totals,
        error: response?.error
    };
};
const $670b271811d34063$export$beb6402dac9e03b2 = async (criteria, parameters)=>{
    const response = await (0, $24YIE.newSendApiRequest)("Recruiting_agent_sold_new_producers", $670b271811d34063$var$searchCriteriaData(criteria, parameters), 300000);
    return {
        recruitingSoldResponse: response?.results,
        recruitingSoldTotals: response?.totals,
        error: response?.error
    };
};
const $670b271811d34063$export$5c36292e7fa85c9a = async (criteria, parameters)=>{
    const response = await (0, $24YIE.newSendApiRequest)("Recruiting_agent_sold_coop_agents", $670b271811d34063$var$searchCriteriaData(criteria, parameters), 300000);
    return {
        recruitingSoldResponse: response?.results,
        recruitingSoldTotals: response?.totals,
        error: response?.error
    };
};
const $670b271811d34063$export$8e24002657677643 = async (criteria)=>{
    const response = await (0, $24YIE.newSendApiRequest)("Agent_movement", $670b271811d34063$var$searchCriteriaData(criteria), 120000);
    return {
        results: {
            results: response?.results ?? [],
            agentsPerMonth: response?.agentsPerMonth ?? []
        },
        totals: response?.totals ?? {},
        error: response?.error
    };
};
const $670b271811d34063$export$7d2db59d6e099f66 = async (criteria)=>{
    const response = await (0, $24YIE.newSendApiRequest)("Agent_movement_office_breakdown", $670b271811d34063$var$searchCriteriaData(criteria), 120000);
    return {
        results: response?.results ?? [],
        summary: response?.summary ?? {},
        error: response?.error
    };
};
const $670b271811d34063$export$7364c43d0f31555f = async (criteria, params)=>{
    const response = await (0, $24YIE.newSendApiRequest)("Agent_breakdown", $670b271811d34063$var$searchCriteriaData(criteria, params), 120000);
    return {
        results: response?.results ?? [],
        totals: response?.totals ?? {},
        error: response?.error
    };
};
const $670b271811d34063$export$c69200557d75d003 = async (criteria, parameters)=>{
    const response = await (0, $24YIE.newSendApiRequest)("Decreasing_producers", $670b271811d34063$var$searchCriteriaData(criteria, parameters), 120000);
    return {
        recruitingSoldResponse: response?.results,
        recruitingSoldTotals: response?.totals,
        error: response?.error
    };
};
const $670b271811d34063$export$128dafcc4dd5eed9 = async (criteria, parameters)=>{
    const response = await (0, $24YIE.newSendApiRequest)("Increasing_producers", $670b271811d34063$var$searchCriteriaData(criteria, parameters), 120000);
    return {
        recruitingSoldResponse: response?.results,
        recruitingSoldTotals: response?.totals,
        error: response?.error
    };
};
/**
 * Mock data for Today's Picks Tab.
 * TODO: Remove when API endpoint is ready.
 */ const $670b271811d34063$var$mockTodaysPicksData = [
    {
        agentId: "agent-001",
        firstName: "Sarah",
        lastName: "Johnson",
        officeName: "Premier Realty Group",
        volume: 2450000,
        units: 12,
        projectedVolumeMin: 2800000,
        projectedVolumeMax: 3200000,
        projectedUnitsMin: 14,
        projectedUnitsMax: 18,
        likelihoodOfMovement: "high"
    },
    {
        agentId: "agent-002",
        firstName: "Michael",
        lastName: "Chen",
        officeName: "Coastal Properties",
        volume: 1875000,
        units: 8,
        projectedVolumeMin: 2100000,
        projectedVolumeMax: 2500000,
        projectedUnitsMin: 10,
        projectedUnitsMax: 13,
        likelihoodOfMovement: "medium"
    },
    {
        agentId: "agent-003",
        firstName: "Emily",
        lastName: "Rodriguez",
        officeName: "Summit Real Estate",
        volume: 3200000,
        units: 15,
        projectedVolumeMin: 3500000,
        projectedVolumeMax: 4000000,
        projectedUnitsMin: 17,
        projectedUnitsMax: 22,
        likelihoodOfMovement: "high"
    },
    {
        agentId: "agent-004",
        firstName: "David",
        lastName: "Thompson",
        officeName: "Metro Homes LLC",
        volume: 1250000,
        units: 6,
        projectedVolumeMin: 1400000,
        projectedVolumeMax: 1800000,
        projectedUnitsMin: 7,
        projectedUnitsMax: 10,
        likelihoodOfMovement: "low"
    },
    {
        agentId: "agent-005",
        firstName: "Jessica",
        lastName: "Williams",
        officeName: "Elite Property Advisors",
        volume: 2890000,
        units: 11,
        projectedVolumeMin: 3100000,
        projectedVolumeMax: 3600000,
        projectedUnitsMin: 13,
        projectedUnitsMax: 16,
        likelihoodOfMovement: "high"
    },
    {
        agentId: "agent-006",
        firstName: "Robert",
        lastName: "Martinez",
        officeName: "Urban Living Realty",
        volume: 1650000,
        units: 7,
        projectedVolumeMin: 1900000,
        projectedVolumeMax: 2200000,
        projectedUnitsMin: 9,
        projectedUnitsMax: 12,
        likelihoodOfMovement: "medium"
    },
    {
        agentId: "agent-007",
        firstName: "Amanda",
        lastName: "Davis",
        officeName: "Sunrise Properties",
        volume: 2100000,
        units: 9,
        projectedVolumeMin: 2400000,
        projectedVolumeMax: 2800000,
        projectedUnitsMin: 11,
        projectedUnitsMax: 14,
        likelihoodOfMovement: "medium"
    },
    {
        agentId: "agent-008",
        firstName: "Christopher",
        lastName: "Brown",
        officeName: "Landmark Realty Services",
        volume: 1980000,
        units: 10,
        projectedVolumeMin: 2200000,
        projectedVolumeMax: 2600000,
        projectedUnitsMin: 12,
        projectedUnitsMax: 15,
        likelihoodOfMovement: "low"
    }
];
const $670b271811d34063$export$a0111625ace2045d = async ()=>{
    await new Promise((resolve)=>setTimeout(resolve, 300));
    return {
        results: $670b271811d34063$var$mockTodaysPicksData,
        total: $670b271811d34063$var$mockTodaysPicksData.length,
        error: null
    };
};

});

parcelRegister("aypMh", function(module, exports) {

$parcel$export(module.exports, "terms", () => $7af113406a1045ae$export$8a21ba990ca4a7cb);
$parcel$export(module.exports, "types", () => $7af113406a1045ae$export$b14ad400b1d09e0f);
$parcel$export(module.exports, "views", () => $7af113406a1045ae$export$d0079916fe6800ac);
$parcel$export(module.exports, "viewOptions", () => $7af113406a1045ae$export$10d60cedcb640ed2);
$parcel$export(module.exports, "showOptions", () => $7af113406a1045ae$export$672567cab6e3e453);

var $cstaF = parcelRequire("cstaF");
const $7af113406a1045ae$export$8a21ba990ca4a7cb = {
    agentLists: "saved agent lists",
    savedAgents: "saved agents",
    agents: "agents",
    view: "view",
    showAllAgents: "Show all agents",
    onlyShowMyAgents: "Only show my agents",
    hideMyAgents: "Hide my agents"
};
const $7af113406a1045ae$export$b14ad400b1d09e0f = {
    SHOW_ALL_AGENTS: "show_all_agents",
    ONLY_SHOW_MY_AGENTS: "only_show_my_agents",
    HIDE_MY_AGENTS: "hide_my_agents"
};
const $7af113406a1045ae$export$d0079916fe6800ac = {
    activity: "activity",
    overview: "overview",
    contactInformation: "contactInformation",
    growthAnalysis: "growthAnalysis",
    listingProficiency: "listingProficiency"
};
const $7af113406a1045ae$export$10d60cedcb640ed2 = [
    {
        value: $7af113406a1045ae$export$d0079916fe6800ac.activity,
        label: (0, $cstaF.agentProductionTerms).activity
    },
    {
        value: $7af113406a1045ae$export$d0079916fe6800ac.overview,
        label: (0, $cstaF.agentProductionTerms).overview
    },
    {
        value: $7af113406a1045ae$export$d0079916fe6800ac.contactInformation,
        label: (0, $cstaF.agentProductionTerms).contactInformation
    },
    {
        value: $7af113406a1045ae$export$d0079916fe6800ac.growthAnalysis,
        label: (0, $cstaF.agentProductionTerms).growthAnalysis
    },
    {
        value: $7af113406a1045ae$export$d0079916fe6800ac.listingProficiency,
        label: (0, $cstaF.agentProductionTerms).listingProficiency
    }
];
const $7af113406a1045ae$export$672567cab6e3e453 = [
    {
        value: $7af113406a1045ae$export$b14ad400b1d09e0f.SHOW_ALL_AGENTS,
        label: $7af113406a1045ae$export$8a21ba990ca4a7cb.showAllAgents
    },
    {
        value: $7af113406a1045ae$export$b14ad400b1d09e0f.ONLY_SHOW_MY_AGENTS,
        label: $7af113406a1045ae$export$8a21ba990ca4a7cb.onlyShowMyAgents
    },
    {
        value: $7af113406a1045ae$export$b14ad400b1d09e0f.HIDE_MY_AGENTS,
        label: $7af113406a1045ae$export$8a21ba990ca4a7cb.hideMyAgents
    }
];

});

parcelRegister("htzEo", function(module, exports) {

$parcel$export(module.exports, "hasNoLength", () => $cb90cc9013eaa8ad$export$d36606e65eaa13d5);
$parcel$export(module.exports, "getCurrencyFormat", () => $cb90cc9013eaa8ad$export$136e7f5e435a87be);
$parcel$export(module.exports, "getFullNumbers", () => $cb90cc9013eaa8ad$export$48a53f8e653680da);
$parcel$export(module.exports, "getIntegerFormat", () => $cb90cc9013eaa8ad$export$a74c793511279df);
$parcel$export(module.exports, "getFormattedDate", () => $cb90cc9013eaa8ad$export$92521769c5df59ad);
$parcel$export(module.exports, "getNumberWithComas", () => $cb90cc9013eaa8ad$export$854f0d47d6a5359);
$parcel$export(module.exports, "getUngroupedMax2Decimals", () => $cb90cc9013eaa8ad$export$b4f67067e3b57bb5);
$parcel$export(module.exports, "getUngroupedNoDecimals", () => $cb90cc9013eaa8ad$export$9b9e1663f4f858e4);
$parcel$export(module.exports, "getUngrouped2Decimals", () => $cb90cc9013eaa8ad$export$6dd6e38bd0baa438);
$parcel$export(module.exports, "getUngroupedMax1Decimals", () => $cb90cc9013eaa8ad$export$9b09f5f63bd52e40);
$parcel$export(module.exports, "getCompactDollars", () => $cb90cc9013eaa8ad$export$d542b9e34a2e5a4d);
$parcel$export(module.exports, "getDecimalNumber", () => $cb90cc9013eaa8ad$export$792546efc974ae54);
$parcel$export(module.exports, "percentChangeFormatter", () => $cb90cc9013eaa8ad$export$8452f7cdc2675943);
$parcel$export(module.exports, "formatVolumeOrDays", () => $cb90cc9013eaa8ad$export$2d572610e31e3f61);
$parcel$export(module.exports, "formatGroupedInteger", () => $cb90cc9013eaa8ad$export$f98b0ff674293520);
$parcel$export(module.exports, "getListingStatus", () => $cb90cc9013eaa8ad$export$8224da3637449c0b);
$parcel$export(module.exports, "formatDecimal", () => $cb90cc9013eaa8ad$export$845857f28dc08744);
$parcel$export(module.exports, "maxTwoDecimals", () => $cb90cc9013eaa8ad$export$2a8e621a8db04d67);
$parcel$export(module.exports, "maxThreeDecimals", () => $cb90cc9013eaa8ad$export$cbd03f4da614e30e);
$parcel$export(module.exports, "boolToShortString", () => $cb90cc9013eaa8ad$export$dfb900a57a54518f);
$parcel$export(module.exports, "formatUnitOrPercentage", () => $cb90cc9013eaa8ad$export$8ca97a2cf7fbe9e7);
$parcel$export(module.exports, "formatPercent", () => $cb90cc9013eaa8ad$export$32e6b1ae352e94d6);
$parcel$export(module.exports, "formatStandardPct", () => $cb90cc9013eaa8ad$export$b40897d3bace347c);
$parcel$export(module.exports, "formatPercentage", () => $cb90cc9013eaa8ad$export$3e1eee59f5dc52be);
$parcel$export(module.exports, "formatClr", () => $cb90cc9013eaa8ad$export$415fe3461e34263a);
$parcel$export(module.exports, "blankEmptyFormatPercentage", () => $cb90cc9013eaa8ad$export$2fa9ad70131c0e55);
$parcel$export(module.exports, "centupleDecimalFormatter", () => $cb90cc9013eaa8ad$export$f258c728ca498112);
$parcel$export(module.exports, "formatVolume", () => $cb90cc9013eaa8ad$export$e707b726ec359642);
$parcel$export(module.exports, "formatBlankEmptyInteger", () => $cb90cc9013eaa8ad$export$edf38e8a7874e212);
$parcel$export(module.exports, "formatBlankEmptyVolume", () => $cb90cc9013eaa8ad$export$eced0cc61212f8b);
$parcel$export(module.exports, "formatBlankEmptyUnit", () => $cb90cc9013eaa8ad$export$a4a4faea0b88becf);
$parcel$export(module.exports, "formatInteger", () => $cb90cc9013eaa8ad$export$1e3549dc395d8540);
$parcel$export(module.exports, "formatUnits", () => $cb90cc9013eaa8ad$export$bd39b96f71da1885);
$parcel$export(module.exports, "formatPercentageWithMultiplier", () => $cb90cc9013eaa8ad$export$bd1aa2da9e2e3def);
$parcel$export(module.exports, "blankEmptyFormatPercentageWithMultiplier", () => $cb90cc9013eaa8ad$export$a148ad3284e44a0b);
$parcel$export(module.exports, "formatOneDecimalPercentageWithMultiplier", () => $cb90cc9013eaa8ad$export$3374251e0350cad4);
$parcel$export(module.exports, "mapIdToTableData", () => $cb90cc9013eaa8ad$export$ef85659f0f49ffc5);
$parcel$export(module.exports, "roundIfNumber", () => $cb90cc9013eaa8ad$export$55fca5427323f77b);
$parcel$export(module.exports, "addPctSymbol", () => $cb90cc9013eaa8ad$export$9e167ae521aded44);
$parcel$export(module.exports, "addPctFormatted", () => $cb90cc9013eaa8ad$export$af8754b1e1eb9bb1);
$parcel$export(module.exports, "longDateFormat", () => $cb90cc9013eaa8ad$export$7bc415832e79e22c);
$parcel$export(module.exports, "longDateTwoDigitsFormat", () => $cb90cc9013eaa8ad$export$e3b077e34fb929f0);
$parcel$export(module.exports, "shortDateFormatWithSlashes", () => $cb90cc9013eaa8ad$export$d97f3341603721f0);
$parcel$export(module.exports, "monthAndYearFormat", () => $cb90cc9013eaa8ad$export$86b43c35439e9dfe);
$parcel$export(module.exports, "yearFormat", () => $cb90cc9013eaa8ad$export$89f7e689d5f86271);
$parcel$export(module.exports, "csvExportDateFormat", () => $cb90cc9013eaa8ad$export$50b9a82caada57ac);
$parcel$export(module.exports, "quarterNumYearFormat", () => $cb90cc9013eaa8ad$export$51d97c6a54347c36);
$parcel$export(module.exports, "shortDateFormat", () => $cb90cc9013eaa8ad$export$1a445e44d9863af);
$parcel$export(module.exports, "yearMonthDayDashDateFormat", () => $cb90cc9013eaa8ad$export$a82ba6894821f33d);
$parcel$export(module.exports, "shortMonthAndYearFormat", () => $cb90cc9013eaa8ad$export$e23ceaed5da1f988);
$parcel$export(module.exports, "shortMonthAndShortYearFormat", () => $cb90cc9013eaa8ad$export$1c4f13c7f0fc6b02);
$parcel$export(module.exports, "dayFirstDateFormat", () => $cb90cc9013eaa8ad$export$d70d30f13b6a6052);
$parcel$export(module.exports, "shortMonthYearAndDayFormat", () => $cb90cc9013eaa8ad$export$2380b8f363a0ea2);
$parcel$export(module.exports, "monthWithDayAndYearArray", () => $cb90cc9013eaa8ad$export$2906b1910376c6a3);
$parcel$export(module.exports, "getQuarterFormatted", () => $cb90cc9013eaa8ad$export$8a7e7104520d7be);
$parcel$export(module.exports, "longQuarterNumberAndYear", () => $cb90cc9013eaa8ad$export$c4ac60b0c1f64a9a);
$parcel$export(module.exports, "quarterNumberAndYear", () => $cb90cc9013eaa8ad$export$4af0d23c7117ec35);
$parcel$export(module.exports, "formattedQuarterWithYear", () => $cb90cc9013eaa8ad$export$66e594d61a2193e1);
$parcel$export(module.exports, "formattedWeekWithMonthAndYear", () => $cb90cc9013eaa8ad$export$9cdc37b3ba05d44);
$parcel$export(module.exports, "quarterNumber", () => $cb90cc9013eaa8ad$export$7df2c12eca876526);
$parcel$export(module.exports, "getWeeklyFormatted", () => $cb90cc9013eaa8ad$export$5bd72e9aaf06c22e);
$parcel$export(module.exports, "getTwoDigitDayOfMonth", () => $cb90cc9013eaa8ad$export$6ad60aa89353365c);
$parcel$export(module.exports, "getMonthlyFormatted", () => $cb90cc9013eaa8ad$export$9fc33c00ac277dd1);
$parcel$export(module.exports, "popOverDataFormatters", () => $cb90cc9013eaa8ad$export$33a066dd874a8d);
$parcel$export(module.exports, "getBlankZeroFormatter", () => $cb90cc9013eaa8ad$export$e815a07347576171);
$parcel$export(module.exports, "getDashboardIndicators", () => $cb90cc9013eaa8ad$export$2a7990ddac4ca040);

var $6IhJz = parcelRequire("6IhJz");
var $cFZfS = parcelRequire("cFZfS");
var $auRgN = parcelRequire("auRgN");

var $cstaF = parcelRequire("cstaF");

var $bLQRh = parcelRequire("bLQRh");
const $cb90cc9013eaa8ad$var$currencyFormatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
});
const $cb90cc9013eaa8ad$var$fullNumberFormatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0
});
const $cb90cc9013eaa8ad$var$volumeOrDaysFormatter = new Intl.NumberFormat("en-US", {
    style: "decimal",
    roundingMode: "halfEven",
    maximumFractionDigits: 0
});
const $cb90cc9013eaa8ad$var$unitOrPercentFormatter = new Intl.NumberFormat("en-US", {
    style: "decimal",
    minimumFractionDigits: 1,
    maximumFractionDigits: 1
});
const $cb90cc9013eaa8ad$var$maxTwoDecimalsUngrouped = new Intl.NumberFormat("en-US", {
    style: "decimal",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
});
const $cb90cc9013eaa8ad$var$maxThreeDecimalsUngrouped = new Intl.NumberFormat("en-US", {
    style: "decimal",
    minimumFractionDigits: 0,
    maximumFractionDigits: 3
});
const $cb90cc9013eaa8ad$var$twoDecimalsPercentFormatter = new Intl.NumberFormat("en-US", {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
});
const $cb90cc9013eaa8ad$var$oneDecimalPercentFormatter = new Intl.NumberFormat("en-US", {
    style: "percent",
    minimumFractionDigits: 1,
    maximumFractionDigits: 1
});
const $cb90cc9013eaa8ad$var$integerFormatter = new Intl.NumberFormat("en-US", {
    style: "decimal",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
});
const $cb90cc9013eaa8ad$var$twoDecimalsPercentFormatterWithMultiplier = new Intl.NumberFormat("en-US", {
    style: "percent",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
});
const $cb90cc9013eaa8ad$var$oneDecimalsPercentFormatterWithMultiplier = new Intl.NumberFormat("en-US", {
    style: "percent",
    minimumFractionDigits: 1,
    maximumFractionDigits: 1
});
const $cb90cc9013eaa8ad$var$percentFormatter = (countDecimalPlaces = 0)=>new Intl.NumberFormat("en-US", {
        style: "percent",
        minimumFractionDigits: countDecimalPlaces,
        maximumFractionDigits: countDecimalPlaces
    });
const $cb90cc9013eaa8ad$var$csvVolumeOrDaysFormatter = new Intl.NumberFormat("en-US", {
    style: "decimal",
    maximumFractionDigits: 0,
    useGrouping: false
});
const $cb90cc9013eaa8ad$var$groupedIntegerFormatter = new Intl.NumberFormat("en-US", {
    style: "decimal",
    roundingMode: "halfEven",
    maximumFractionDigits: 0,
    useGrouping: true
});
const $cb90cc9013eaa8ad$var$twoDecimalsUngroupedPercentFormatter = new Intl.NumberFormat("en-US", {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: false
});
const $cb90cc9013eaa8ad$var$csvUnitOrPercentFormatter = new Intl.NumberFormat("en-US", {
    style: "decimal",
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
    useGrouping: false
});
const $cb90cc9013eaa8ad$var$groupedDecimalFormatter = new Intl.NumberFormat("en-US", {
    style: "decimal",
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
    useGrouping: true
});
const $cb90cc9013eaa8ad$var$ungroupedMax2Decimals = new Intl.NumberFormat("en-US", {
    style: "decimal",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
    useGrouping: false
});
const $cb90cc9013eaa8ad$var$ungroupedMax1Decimals = new Intl.NumberFormat("en-US", {
    style: "decimal",
    minimumFractionDigits: 0,
    maximumFractionDigits: 1,
    useGrouping: false
});
const $cb90cc9013eaa8ad$var$numberWithComas = new Intl.NumberFormat("en-Us", {
    style: "decimal",
    maximumFractionDigits: 0
});
const $cb90cc9013eaa8ad$export$f253cc18a7d6f396 = (countDecimalPlaces)=>new Intl.NumberFormat("en-US", {
        style: "currency",
        notation: "compact",
        currency: "USD",
        minimumFractionDigits: countDecimalPlaces,
        maximumFractionDigits: countDecimalPlaces
    });
const $cb90cc9013eaa8ad$export$d36606e65eaa13d5 = (value)=>((value ?? "") + "").length === 0;
const $cb90cc9013eaa8ad$export$136e7f5e435a87be = (value)=>`${$cb90cc9013eaa8ad$var$currencyFormatter.format(value)}`;
const $cb90cc9013eaa8ad$export$48a53f8e653680da = (value)=>$cb90cc9013eaa8ad$var$fullNumberFormatter.format(value).replace("$", "");
const $cb90cc9013eaa8ad$export$a74c793511279df = (value)=>$cb90cc9013eaa8ad$var$integerFormatter.format(value);
const $cb90cc9013eaa8ad$export$92521769c5df59ad = (value, dateFormat)=>value ? (0, $6IhJz.default)(new Date(value), dateFormat) : null;
const $cb90cc9013eaa8ad$export$854f0d47d6a5359 = (value)=>$cb90cc9013eaa8ad$var$numberWithComas.format(value);
const $cb90cc9013eaa8ad$export$b4f67067e3b57bb5 = (value)=>value || value === 0 ? $cb90cc9013eaa8ad$var$ungroupedMax2Decimals.format(value) : "";
const $cb90cc9013eaa8ad$export$9b9e1663f4f858e4 = (value)=>$cb90cc9013eaa8ad$var$csvVolumeOrDaysFormatter.format(value);
const $cb90cc9013eaa8ad$export$6dd6e38bd0baa438 = (value)=>$cb90cc9013eaa8ad$var$twoDecimalsUngroupedPercentFormatter.format(value);
const $cb90cc9013eaa8ad$export$9b09f5f63bd52e40 = (value)=>$cb90cc9013eaa8ad$var$ungroupedMax1Decimals.format(value);
const $cb90cc9013eaa8ad$var$getTransformedCompact = (value)=>value.replace("K", "k");
const $cb90cc9013eaa8ad$export$d542b9e34a2e5a4d = (value)=>{
    const countDecimalPlaces = value < 1000000 ? 0 : 1;
    return $cb90cc9013eaa8ad$var$getTransformedCompact($cb90cc9013eaa8ad$export$f253cc18a7d6f396(countDecimalPlaces).format(value));
};
const $cb90cc9013eaa8ad$export$792546efc974ae54 = (value)=>$cb90cc9013eaa8ad$var$groupedDecimalFormatter.format(value);
const $cb90cc9013eaa8ad$export$8452f7cdc2675943 = (value)=>{
    if (isNaN(value)) return "0%";
    if (value === Infinity) return (0, $cstaF.agentProductionTerms).notApplicableAbbrv;
    return `${$cb90cc9013eaa8ad$var$unitOrPercentFormatter.format(value)}%`;
};
const $cb90cc9013eaa8ad$export$2d572610e31e3f61 = (value, isCsvExport = false)=>{
    if (isNaN(value) || value == null) return "";
    return isCsvExport ? $cb90cc9013eaa8ad$var$csvVolumeOrDaysFormatter.format(value) : $cb90cc9013eaa8ad$var$volumeOrDaysFormatter.format(value);
};
const $cb90cc9013eaa8ad$export$f98b0ff674293520 = (value)=>{
    if (isNaN(value) || value == null) return "";
    return $cb90cc9013eaa8ad$var$groupedIntegerFormatter.format(value);
};
const $cb90cc9013eaa8ad$var$decimalFormatterPlaces = (countDecimalPlaces = 0)=>new Intl.NumberFormat("en-US", {
        style: "decimal",
        minimumFractionDigits: countDecimalPlaces,
        maximumFractionDigits: countDecimalPlaces
    });
const $cb90cc9013eaa8ad$export$8224da3637449c0b = (value)=>(0, $cstaF.marketShareListingStatuses)[value];
const $cb90cc9013eaa8ad$export$845857f28dc08744 = (value)=>{
    return $cb90cc9013eaa8ad$var$checkNullValue(value) ? $cb90cc9013eaa8ad$var$percentFormatter(value).format(0) : $cb90cc9013eaa8ad$var$percentFormatter(value).format(value / 100);
};
const $cb90cc9013eaa8ad$export$f5fab19e69d01642 = (value, decimals = 0)=>{
    return $cb90cc9013eaa8ad$var$percentFormatter(decimals).format(value / 100);
};
const $cb90cc9013eaa8ad$export$d0c6234bfa245004 = (value, countDecimals)=>{
    return $cb90cc9013eaa8ad$var$checkNullValue(value) ? $cb90cc9013eaa8ad$var$decimalFormatterPlaces(value).format(0) : $cb90cc9013eaa8ad$var$decimalFormatterPlaces(value, countDecimals).format(value);
};
const $cb90cc9013eaa8ad$export$2a8e621a8db04d67 = (value)=>$cb90cc9013eaa8ad$var$maxTwoDecimalsUngrouped.format(value);
const $cb90cc9013eaa8ad$export$cbd03f4da614e30e = (value)=>$cb90cc9013eaa8ad$var$maxThreeDecimalsUngrouped.format(value);
const $cb90cc9013eaa8ad$export$dfb900a57a54518f = (value)=>value === true ? (0, $cstaF.agentProductionTerms).abbrY : (0, $cstaF.agentProductionTerms).abbrN;
const $cb90cc9013eaa8ad$export$8ca97a2cf7fbe9e7 = (value, isCsvExport = false, decimals = false)=>{
    if (isNaN(value) || value == null) return $cb90cc9013eaa8ad$var$unitOrPercentFormatter.format(0);
    return isCsvExport ? $cb90cc9013eaa8ad$var$csvUnitOrPercentFormatter.format(value) : decimals ? $cb90cc9013eaa8ad$var$twoDecimalsPercentFormatter.format(value) : $cb90cc9013eaa8ad$var$unitOrPercentFormatter.format(value);
};
const $cb90cc9013eaa8ad$var$checkNullValue = (value)=>isNaN(value) || value == null;
const $cb90cc9013eaa8ad$export$32e6b1ae352e94d6 = (percentValue, countDecimalPlaces = 0)=>{
    return $cb90cc9013eaa8ad$var$checkNullValue(percentValue) ? $cb90cc9013eaa8ad$var$percentFormatter(countDecimalPlaces).format(0) : $cb90cc9013eaa8ad$var$percentFormatter(countDecimalPlaces).format(percentValue / 100);
};
const $cb90cc9013eaa8ad$export$b40897d3bace347c = (value)=>$cb90cc9013eaa8ad$export$32e6b1ae352e94d6(value, 2);
const $cb90cc9013eaa8ad$var$convertToNumber = (value)=>{
    if (value === null || value === undefined) return null;
    if (typeof value === "number") return value;
    if (typeof value === "string") {
        const numericValue = parseFloat(value);
        return !isNaN(numericValue) ? numericValue : null;
    }
    return null;
};
const $cb90cc9013eaa8ad$export$3e1eee59f5dc52be = (value)=>{
    const convertedNumber = $cb90cc9013eaa8ad$var$convertToNumber(value);
    if ($cb90cc9013eaa8ad$var$checkNullValue(convertedNumber)) return $cb90cc9013eaa8ad$var$oneDecimalPercentFormatter.format(0);
    return $cb90cc9013eaa8ad$var$oneDecimalPercentFormatter.format(convertedNumber / 100);
};
const $cb90cc9013eaa8ad$export$415fe3461e34263a = (value)=>{
    if (!value) return "";
    return $cb90cc9013eaa8ad$var$oneDecimalPercentFormatter.format(value);
};
const $cb90cc9013eaa8ad$export$2fa9ad70131c0e55 = (value)=>{
    if ($cb90cc9013eaa8ad$var$checkNullValue(value)) return null;
    return $cb90cc9013eaa8ad$var$oneDecimalPercentFormatter.format(value / 100);
};
const $cb90cc9013eaa8ad$export$f258c728ca498112 = (value)=>{
    if ($cb90cc9013eaa8ad$var$checkNullValue(value)) return 0;
    return $cb90cc9013eaa8ad$var$groupedDecimalFormatter.format(value * 100);
};
const $cb90cc9013eaa8ad$export$e707b726ec359642 = (value)=>{
    if ($cb90cc9013eaa8ad$var$checkNullValue(value)) return $cb90cc9013eaa8ad$export$136e7f5e435a87be(0);
    return $cb90cc9013eaa8ad$export$136e7f5e435a87be(value);
};
const $cb90cc9013eaa8ad$export$edf38e8a7874e212 = (value)=>{
    if ($cb90cc9013eaa8ad$var$checkNullValue(value)) return null;
    return $cb90cc9013eaa8ad$export$a74c793511279df(value);
};
const $cb90cc9013eaa8ad$export$eced0cc61212f8b = (value)=>{
    if ($cb90cc9013eaa8ad$var$checkNullValue(value)) return null;
    return $cb90cc9013eaa8ad$export$136e7f5e435a87be(value);
};
const $cb90cc9013eaa8ad$export$a4a4faea0b88becf = (value)=>{
    if ($cb90cc9013eaa8ad$var$checkNullValue(value)) return null;
    return $cb90cc9013eaa8ad$export$792546efc974ae54(value);
};
const $cb90cc9013eaa8ad$export$1e3549dc395d8540 = (value)=>{
    if ($cb90cc9013eaa8ad$var$checkNullValue(value)) return 0;
    return $cb90cc9013eaa8ad$export$a74c793511279df(value);
};
const $cb90cc9013eaa8ad$export$5890a28ce6a35690 = (value)=>$cb90cc9013eaa8ad$export$e707b726ec359642(Math.trunc(value));
const $cb90cc9013eaa8ad$export$bd39b96f71da1885 = (value)=>{
    if ($cb90cc9013eaa8ad$var$checkNullValue(value)) return $cb90cc9013eaa8ad$var$unitOrPercentFormatter.format(0);
    return $cb90cc9013eaa8ad$var$unitOrPercentFormatter.format(value);
};
const $cb90cc9013eaa8ad$export$bd1aa2da9e2e3def = (value)=>{
    if ($cb90cc9013eaa8ad$var$checkNullValue(value)) return $cb90cc9013eaa8ad$var$unitOrPercentFormatter.format(0);
    return $cb90cc9013eaa8ad$var$twoDecimalsPercentFormatterWithMultiplier.format(value);
};
const $cb90cc9013eaa8ad$export$a148ad3284e44a0b = (value)=>{
    if ($cb90cc9013eaa8ad$var$checkNullValue(value)) return null;
    return $cb90cc9013eaa8ad$var$twoDecimalsPercentFormatterWithMultiplier.format(value);
};
const $cb90cc9013eaa8ad$export$3374251e0350cad4 = (value)=>{
    if ($cb90cc9013eaa8ad$var$checkNullValue(value)) return $cb90cc9013eaa8ad$var$oneDecimalsPercentFormatterWithMultiplier.format(0);
    if (!isFinite(value)) return null;
    return $cb90cc9013eaa8ad$var$oneDecimalsPercentFormatterWithMultiplier.format(value);
};
const $cb90cc9013eaa8ad$export$ef85659f0f49ffc5 = (data)=>{
    const revisedData = [];
    Array.isArray(data) > 0 && data?.forEach((d)=>revisedData.push({
            ...d,
            id: d.agentId
        }));
    return revisedData;
};
const $cb90cc9013eaa8ad$export$55fca5427323f77b = (input)=>{
    return !isNaN(parseInt(input)) ? Math.round(input) : input;
};
const $cb90cc9013eaa8ad$export$9e167ae521aded44 = (value)=>`${value} %`;
const $cb90cc9013eaa8ad$export$af8754b1e1eb9bb1 = (value)=>$cb90cc9013eaa8ad$export$9e167ae521aded44($cb90cc9013eaa8ad$export$8ca97a2cf7fbe9e7(value, true));
const $cb90cc9013eaa8ad$export$9a41a3a19877c3aa = (value)=>/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(value); // '2023-06-01 00:00:00'
const $cb90cc9013eaa8ad$export$1f48e41350a37852 = (value)=>/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}\.\d{3}$/.test(value); // '2023-06-01 00:00:00.999'
const $cb90cc9013eaa8ad$export$9e8726a538ef9b83 = (value)=>/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/.test(value); // '2023-06-01T00:00:00.000Z'
const $cb90cc9013eaa8ad$export$6d10fd3be6f67e69 = (value)=>{
    const parsed = (0, $auRgN.default)(value, "MMM - yyyy", new Date());
    return (0, $cFZfS.default)(parsed);
}; // 'Aug - 2022'
const $cb90cc9013eaa8ad$export$638144e58f549d8 = (value)=>/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/.test(value); // 2023-07-01T00:00:00
const $cb90cc9013eaa8ad$export$7bc415832e79e22c = (value)=>(0, $6IhJz.default)(new Date(value), "MMM d, yyyy"); // Aug 2, 2022
const $cb90cc9013eaa8ad$export$e3b077e34fb929f0 = (value)=>(0, $6IhJz.default)(new Date(value), "MMM. dd, yyyy"); // Aug 02, 2022
const $cb90cc9013eaa8ad$export$d97f3341603721f0 = (value)=>value?.length ? (0, $6IhJz.default)(new Date(value), "MM/dd/yyyy") : ""; // 08/02/2022
const $cb90cc9013eaa8ad$export$86b43c35439e9dfe = (value)=>{
    if (!value) return "";
    const validDateFormats = [
        $cb90cc9013eaa8ad$export$9e8726a538ef9b83,
        $cb90cc9013eaa8ad$export$9a41a3a19877c3aa,
        $cb90cc9013eaa8ad$export$1f48e41350a37852,
        $cb90cc9013eaa8ad$export$6d10fd3be6f67e69,
        $cb90cc9013eaa8ad$export$638144e58f549d8
    ];
    try {
        if (!validDateFormats.some((isValid)=>isValid(value))) return "";
        let date;
        if ($cb90cc9013eaa8ad$export$6d10fd3be6f67e69(value)) date = (0, $auRgN.default)(value, "MMM - yyyy", new Date());
        else date = new Date(value);
        if (isNaN(date)) return "";
        return (0, $6IhJz.default)(date, "MMMM yyyy");
    } catch (e) {
        console.error("Date parsing error:", e);
        return "";
    }
}; // August 2022
const $cb90cc9013eaa8ad$export$89f7e689d5f86271 = (value)=>(0, $6IhJz.default)(new Date(value), "yyyy"); // 2022
const $cb90cc9013eaa8ad$export$50b9a82caada57ac = ()=>(0, $6IhJz.default)(new Date(), "yyyyMMddHHmmSS"); // 20230131201451
const $cb90cc9013eaa8ad$export$51d97c6a54347c36 = (value)=>`Q${Math.floor(new Date(value).getMonth() / 3 + 1)} ${new Date(value).getFullYear()}`; // Q3 2023
const $cb90cc9013eaa8ad$export$1a445e44d9863af = (value)=>(0, $6IhJz.default)(new Date(value), "MM-dd-yyyy"); // 08-02-2022
const $cb90cc9013eaa8ad$export$a82ba6894821f33d = (value)=>(0, $6IhJz.default)(new Date(value), "yyyy-MM-dd"); // 2022-08-02
const $cb90cc9013eaa8ad$export$e23ceaed5da1f988 = (value)=>(0, $6IhJz.default)(new Date(value), "MMM yyyy"); // Aug 2022
const $cb90cc9013eaa8ad$export$1c4f13c7f0fc6b02 = (value)=>(0, $6IhJz.default)(new Date(value), "MMM-yy"); // Aug-22
const $cb90cc9013eaa8ad$export$d70d30f13b6a6052 = (value)=>(0, $6IhJz.default)(new Date(value), "dd MMM yyyy"); // 02 Aug 2022
const $cb90cc9013eaa8ad$export$2380b8f363a0ea2 = (value)=>(0, $6IhJz.default)(new Date(value), "MMM dd yyyy"); // Aug 7 2022
const $cb90cc9013eaa8ad$export$2906b1910376c6a3 = (value)=>{
    if (!value) return [];
    const [month, day, year] = value.split(" ");
    if (!month || !day || !year) return [
        value
    ];
    return [
        `${month} ${day}`,
        year
    ];
} // ['Aug 7', '2022']
;
const $cb90cc9013eaa8ad$export$8a7e7104520d7be = (date, getFormattedDate)=>{
    const dateValue = new Date(date);
    const month = dateValue.getMonth();
    const quarter = Math.ceil((month + 1) / 3);
    const year = dateValue.getFullYear();
    return getFormattedDate(quarter, year);
};
const $cb90cc9013eaa8ad$export$c4ac60b0c1f64a9a = (quarter, year)=>`${(0, $bLQRh.terms).quarter} ${quarter} ${year}`; // Quarter ## YYYY
const $cb90cc9013eaa8ad$export$4af0d23c7117ec35 = (quarter, year)=>`Q${quarter} ${year}`; // Q## YYYY
const $cb90cc9013eaa8ad$export$dee99f2974846d15 = (quarter)=>`Q${quarter}`; // Q## 
const $cb90cc9013eaa8ad$export$66e594d61a2193e1 = (quarter, year)=>[
        $cb90cc9013eaa8ad$export$dee99f2974846d15(quarter),
        `'${year?.toString().slice(-2)}`
    ]; // [Q##, 'YY].
const $cb90cc9013eaa8ad$export$9cdc37b3ba05d44 = ({ dayOfMonth: dayOfMonth, formattedMonth: formattedMonth, formattedYear: formattedYear }, shouldShowYear)=>[
        `${dayOfMonth}`,
        formattedMonth,
        shouldShowYear ? `'${formattedYear}` : ""
    ];
const $cb90cc9013eaa8ad$export$7df2c12eca876526 = (quarter, year)=>quarter === 1 ? $cb90cc9013eaa8ad$export$66e594d61a2193e1(quarter, year) : $cb90cc9013eaa8ad$export$dee99f2974846d15(quarter);
const $cb90cc9013eaa8ad$export$5bd72e9aaf06c22e = (date)=>{
    return $cb90cc9013eaa8ad$export$6ad60aa89353365c(date);
};
const $cb90cc9013eaa8ad$export$9fc33c00ac277dd1 = (date, shouldRenderYear = false)=>{
    const month = (0, $6IhJz.default)(date, "MMM");
    const year = (0, $6IhJz.default)(date, "yy");
    const formattedYear = `'${year}`;
    return shouldRenderYear ? [
        month,
        formattedYear
    ] : month;
};
const $cb90cc9013eaa8ad$export$6ad60aa89353365c = (date)=>date.getDate().toString().padStart(2, "0");
const $cb90cc9013eaa8ad$export$33a066dd874a8d = {
    volume: $cb90cc9013eaa8ad$export$136e7f5e435a87be,
    units: $cb90cc9013eaa8ad$export$9b09f5f63bd52e40,
    roundedUnits: $cb90cc9013eaa8ad$export$a74c793511279df
};
const $cb90cc9013eaa8ad$export$e815a07347576171 = (value, defaultValueFormatter)=>{
    if (!value) return "";
    if (!defaultValueFormatter) return value;
    return defaultValueFormatter({
        value: value
    });
};
const $cb90cc9013eaa8ad$export$2a7990ddac4ca040 = (totals, tooltipSettingsByKeyName)=>{
    return Object.entries(totals ?? {}).filter(([key])=>tooltipSettingsByKeyName[key]).map(([key, value])=>({
            key: key,
            label: tooltipSettingsByKeyName[key].label,
            tooltip: tooltipSettingsByKeyName[key].tooltip,
            value: value,
            isCurrency: [
                "otherVolumeGained",
                "otherVolumeLost"
            ].includes(key)
        })).sort((a, b)=>a.key.localeCompare(b.key));
};

});


parcelRegister("75U5M", function(module, exports) {

$parcel$export(module.exports, "formatMediumDate", () => $52a482c631aa0f48$export$6a69ecff42d52689);
$parcel$export(module.exports, "formatShortDate", () => $52a482c631aa0f48$export$62a922abef97e45e);
$parcel$export(module.exports, "validateTimeFrame", () => $52a482c631aa0f48$export$9fd5272c288bf8e1);
$parcel$export(module.exports, "createLastXDaysInterval", () => $52a482c631aa0f48$export$ca83c22e8ad1b0a);
$parcel$export(module.exports, "getDateRangeFromRecurrence", () => $52a482c631aa0f48$export$966f45d8dcaddfcd);

var $6uyHy = parcelRequire("6uyHy");
var $l2vHo = parcelRequire("l2vHo");
var $6IhJz = parcelRequire("6IhJz");
var $baBa1 = parcelRequire("baBa1");
var $4YTY5 = parcelRequire("4YTY5");
var $cFZfS = parcelRequire("cFZfS");
var $cJfMa = parcelRequire("cJfMa");
var $5E40x = parcelRequire("5E40x");
var $6eIgt = parcelRequire("6eIgt");
var $4irF8 = parcelRequire("4irF8");
var $lXe7Q = parcelRequire("lXe7Q");
var $4UG1B = parcelRequire("4UG1B");

var $cstaF = parcelRequire("cstaF");

var $9QX0f = parcelRequire("9QX0f");

var $5FKEE = parcelRequire("5FKEE");
const $52a482c631aa0f48$var$getMinTimePeriodDate = ()=>{
    let dateMin = new Date();
    dateMin.setMonth(dateMin.getMonth() - 39);
    dateMin.setDate(0);
    return dateMin;
};
const $52a482c631aa0f48$export$83f2ec687ebaf292 = (date, formatString)=>{
    const transformedDate = new Date(date.toISOString().slice(0, -1));
    return (0, $6IhJz.default)(transformedDate, formatString);
};
const $52a482c631aa0f48$export$b4d08e36bb89d96f = (date)=>{
    return (0, $6IhJz.default)(date, "MMM dd, yyyy");
};
const $52a482c631aa0f48$export$6a69ecff42d52689 = (date)=>{
    return $52a482c631aa0f48$export$83f2ec687ebaf292(date, "MMM dd, yyyy");
};
const $52a482c631aa0f48$export$62a922abef97e45e = (date)=>{
    return $52a482c631aa0f48$export$83f2ec687ebaf292(date, "MM/dd/yyyy");
};
const $52a482c631aa0f48$var$hasValidYear = (date)=>{
    return date.getFullYear().toString().length === 4;
};
const $52a482c631aa0f48$export$9fd5272c288bf8e1 = (timeFrame, today = new Date())=>{
    let validationMessage = "";
    let isValid = true;
    let startDateInvalid = false;
    let endDateInvalid = false;
    const dateMin = $52a482c631aa0f48$var$getMinTimePeriodDate();
    if (!timeFrame.type) {
        isValid = false;
        validationMessage += (0, $cstaF.validationMessages).missingTimePeriodType;
    }
    if (timeFrame.type === (0, $cstaF.TimePeriods)["Custom Date"]) {
        let startDate, endDate;
        if (!timeFrame.startDate) {
            validationMessage += (0, $cstaF.validationMessages).missingStartDate;
            isValid = false;
            startDateInvalid = true;
        } else {
            startDate = new Date(new Date(timeFrame.startDate).toISOString().slice(0, -1));
            if (!(0, $cFZfS.default)(startDate) || !$52a482c631aa0f48$var$hasValidYear(startDate)) {
                validationMessage += (0, $cstaF.validationMessages).invalidStartDateFormat;
                isValid = false;
                startDateInvalid = true;
            } else if ((0, $4YTY5.default)(startDate, (0, $cJfMa.default)(new Date(dateMin.toISOString()))) || (0, $baBa1.default)((0, $6uyHy.default)(startDate), today)) {
                validationMessage += (0, $cstaF.validationMessages).invalidStartDate($52a482c631aa0f48$export$b4d08e36bb89d96f(dateMin), $52a482c631aa0f48$export$b4d08e36bb89d96f(today));
                isValid = false;
                startDateInvalid = true;
            }
        }
        if (!timeFrame.endDate) {
            validationMessage += (0, $cstaF.validationMessages).missingEndDate;
            isValid = false;
            endDateInvalid = true;
        } else {
            endDate = new Date(new Date(timeFrame.endDate).toISOString().slice(0, -1));
            if (!(0, $cFZfS.default)(endDate) || !$52a482c631aa0f48$var$hasValidYear(endDate)) {
                validationMessage += (0, $cstaF.validationMessages).invalidEndDateFormat;
                isValid = false;
                endDateInvalid = true;
            } else {
                if ((0, $4YTY5.default)(endDate, startDate)) {
                    validationMessage += (0, $cstaF.validationMessages).endDateTooEarly;
                    isValid = false;
                    startDateInvalid = true;
                }
                if ((0, $baBa1.default)(endDate, (0, $6uyHy.default)(today))) {
                    validationMessage += (0, $cstaF.validationMessages).invalidEndDate($52a482c631aa0f48$export$b4d08e36bb89d96f(dateMin), $52a482c631aa0f48$export$b4d08e36bb89d96f(today));
                    isValid = false;
                    endDateInvalid = true;
                }
            }
        }
        if (timeFrame.startDate === timeFrame.endDate) {
            validationMessage += (0, $cstaF.validationMessages).sameStartAndEnd;
            isValid = false;
            startDateInvalid = true;
            endDateInvalid = true;
        }
    }
    return {
        isValid: isValid,
        validationMessage: validationMessage,
        startDateInvalid: startDateInvalid,
        endDateInvalid: endDateInvalid
    };
};
const $52a482c631aa0f48$export$ca83c22e8ad1b0a = (days, initialDate)=>{
    initialDate.setHours(0, 0, 0, 0);
    const lastFrom = new Date(initialDate);
    lastFrom.setDate(lastFrom.getDate() - (days - 1));
    const lastYearFrom = new Date(lastFrom);
    lastYearFrom.setFullYear(lastYearFrom.getFullYear() - 1);
    const lastYearTo = new Date(initialDate);
    lastYearTo.setFullYear(lastYearTo.getFullYear() - 1);
    const previousFrom = new Date(lastFrom);
    previousFrom.setDate(previousFrom.getDate() - days);
    const previousTo = new Date(lastFrom);
    previousTo.setDate(previousTo.getDate() - 1);
    return {
        intervalType: `Last${days}Days`,
        lastIntervalText: (0, $9QX0f.terms).getLastXDaysLabel(days),
        last: {
            from: lastFrom.toISOString().split("T")[0] + "T00:00:00",
            to: initialDate.toISOString().split("T")[0] + "T00:00:00"
        },
        lastYear: {
            from: lastYearFrom.toISOString().split("T")[0] + "T00:00:00",
            to: lastYearTo.toISOString().split("T")[0] + "T00:00:00"
        },
        previous: {
            from: previousFrom.toISOString().split("T")[0] + "T00:00:00",
            to: previousTo.toISOString().split("T")[0] + "T00:00:00"
        }
    };
};
function $52a482c631aa0f48$export$966f45d8dcaddfcd(recurrence) {
    const today = new Date();
    const recurrenceConfig = {
        [(0, $5FKEE.recurrences).lastThirtyDays]: {
            startDate: (0, $4irF8.default)((0, $cJfMa.default)(today), 30),
            endDate: (0, $6uyHy.default)(today),
            previousStartDate: (0, $4irF8.default)((0, $cJfMa.default)(today), 60),
            previousEndDate: (0, $4irF8.default)((0, $6uyHy.default)(today), 30)
        },
        [(0, $5FKEE.recurrences).yearToDate]: {
            startDate: (0, $6eIgt.default)((0, $cJfMa.default)(today)),
            endDate: (0, $6uyHy.default)(today),
            previousStartDate: (0, $6eIgt.default)((0, $4UG1B.default)((0, $cJfMa.default)(today), 1)),
            previousEndDate: (0, $4UG1B.default)((0, $6uyHy.default)(today), 1)
        },
        [(0, $5FKEE.recurrences).lastTwelveMonths]: {
            startDate: (0, $4UG1B.default)((0, $5E40x.default)((0, $cJfMa.default)(today)), 1),
            endDate: (0, $l2vHo.default)((0, $lXe7Q.default)((0, $5E40x.default)((0, $6uyHy.default)(today)), 1)),
            previousStartDate: (0, $4UG1B.default)((0, $5E40x.default)((0, $4UG1B.default)((0, $cJfMa.default)(today), 1)), 1),
            previousEndDate: (0, $l2vHo.default)((0, $lXe7Q.default)((0, $5E40x.default)((0, $4UG1B.default)((0, $6uyHy.default)(today), 1)), 1))
        }
    };
    return recurrenceConfig[recurrence];
}

});
parcelRegister("5FKEE", function(module, exports) {

$parcel$export(module.exports, "recurrences", () => $4214f8c075f7c367$export$75c3daeb35d7b45);
$parcel$export(module.exports, "periods", () => $4214f8c075f7c367$export$3ed2605ffb92c326);
const $4214f8c075f7c367$export$75c3daeb35d7b45 = {
    lastThirtyDays: "last-thirty-days",
    yearToDate: "year-to-date",
    lastTwelveMonths: "last-twelve-months"
};
const $4214f8c075f7c367$export$3ed2605ffb92c326 = {
    current: "current_prior",
    yearToDate: "ytd_pytd",
    lastTwelveMonths: "ltm_ptm"
};

});


parcelRegister("9S3rS", function(module, exports) {

$parcel$export(module.exports, "validateRange", () => $72fbd5082d07e1f6$export$96e07d0f1fd0f1e3);
$parcel$export(module.exports, "validateEmail", () => $72fbd5082d07e1f6$export$18148d12c805c5b0);
$parcel$export(module.exports, "getHasDuplicatedText", () => $72fbd5082d07e1f6$export$bf03c2bed26e4570);

var $htzEo = parcelRequire("htzEo");

var $cstaF = parcelRequire("cstaF");
const $72fbd5082d07e1f6$var$limits = {
    totalVolume: {
        limit: 999999000,
        formatter: (0, $htzEo.getCurrencyFormat)
    },
    soldPriceRange: {
        limit: 999999000,
        formatter: (0, $htzEo.getCurrencyFormat)
    },
    lotSize: {
        limit: 999999,
        formatter: (0, $htzEo.getIntegerFormat)
    },
    squareFootage: {
        limit: 999999,
        formatter: (0, $htzEo.getIntegerFormat)
    }
};
const $72fbd5082d07e1f6$export$96e07d0f1fd0f1e3 = (searchTerm, range)=>{
    let validationMessage = "";
    let isValid = true;
    let minInvalid = false;
    let maxInvalid = false;
    if (range?.max || range?.min) {
        if (range.min && isNaN(range.min) || range.max && isNaN(range.max)) {
            isValid = false;
            validationMessage += (0, $cstaF.validationMessages).notNumeric;
            minInvalid = isNaN(range.min);
            maxInvalid = isNaN(range.max);
        }
        if (range.min && range.max && range.max < range.min) {
            isValid = false;
            validationMessage += (0, $cstaF.validationMessages).maxLessThanMin((0, $cstaF.searchTerms)[searchTerm]);
            maxInvalid = true;
        }
        if ($72fbd5082d07e1f6$var$limits[searchTerm]) {
            if (range.min > $72fbd5082d07e1f6$var$limits[searchTerm].limit || range.max > $72fbd5082d07e1f6$var$limits[searchTerm].limit) {
                isValid = false;
                validationMessage += (0, $cstaF.validationMessages).greaterThanLimit((0, $cstaF.searchTerms)[searchTerm], $72fbd5082d07e1f6$var$limits[searchTerm].formatter($72fbd5082d07e1f6$var$limits[searchTerm].limit));
                minInvalid = minInvalid || range.min > $72fbd5082d07e1f6$var$limits[searchTerm].limit;
                maxInvalid = maxInvalid || range.max > $72fbd5082d07e1f6$var$limits[searchTerm].limit;
            }
        }
        if (range.min < 0 || range.max < 0) {
            isValid = false;
            validationMessage += (0, $cstaF.validationMessages).isNegative((0, $cstaF.searchTerms)[searchTerm]);
            minInvalid = minInvalid || range.min < 0;
            maxInvalid = maxInvalid || range.max < 0;
        }
    }
    return {
        isValid: isValid,
        validationMessage: validationMessage,
        minInvalid: minInvalid,
        maxInvalid: maxInvalid
    };
};
const $72fbd5082d07e1f6$export$18148d12c805c5b0 = (email)=>{
    const regex = /^[\w\-\.\+]+@([\w-]+\.)+[\w-]{2,}$/;
    return regex.test(email);
};
const $72fbd5082d07e1f6$export$7c2714a5250b9239 = (text)=>{
    return text.toLowerCase().trim().replace(/\s+/g, " ");
};
const $72fbd5082d07e1f6$export$bf03c2bed26e4570 = (array, textFieldKey, searchTerm)=>{
    return !!array?.find((item)=>$72fbd5082d07e1f6$export$7c2714a5250b9239(item[textFieldKey]) === $72fbd5082d07e1f6$export$7c2714a5250b9239(searchTerm));
};

});



parcelRegister("fPGDZ", function(module, exports) {

$parcel$export(module.exports, "COLUMN_GROUP_CONTACT", () => $b86cb2a650829868$export$a119b89ce17f6a32);
$parcel$export(module.exports, "COLUMN_GROUP_SEARCH", () => $b86cb2a650829868$export$2a44cfb3c7defef9);
$parcel$export(module.exports, "COLUMN_GROUP_MLS", () => $b86cb2a650829868$export$f6e253ef102416e0);
$parcel$export(module.exports, "COLUMN_GROUP_GROWTH", () => $b86cb2a650829868$export$e28a9c04417ce75f);
$parcel$export(module.exports, "COLUMN_GROUP_VOLUME", () => $b86cb2a650829868$export$4e6dbd4640e41165);
$parcel$export(module.exports, "COLUMN_GROUP_UNITS", () => $b86cb2a650829868$export$ab790aaf5337c7a1);
$parcel$export(module.exports, "tabIndexes", () => $b86cb2a650829868$export$c41c0037dd869b05);
$parcel$export(module.exports, "tabIndexedViews", () => $b86cb2a650829868$export$ec801e34de37f83e);
$parcel$export(module.exports, "displayAllButSelected", () => $b86cb2a650829868$export$590c88e68a9eb854);
$parcel$export(module.exports, "getSearchDateYearDetails", () => $b86cb2a650829868$export$3df7a9eacd8b9293);
$parcel$export(module.exports, "getDefaultOverviewColumns", () => $b86cb2a650829868$export$497056754bce936d);
$parcel$export(module.exports, "getMlsRestrictionSettings", () => $b86cb2a650829868$export$31f9a936853c5421);
$parcel$export(module.exports, "getOptionsByMlsRestriction", () => $b86cb2a650829868$export$25e7e1260851e8a0);
$parcel$export(module.exports, "getDefaultContactInfoColumns", () => $b86cb2a650829868$export$6f79fbe416ae99f);
$parcel$export(module.exports, "getDefaultActivityColumns", () => $b86cb2a650829868$export$67adff24bb1b1e50);
$parcel$export(module.exports, "isHiddenColumn", () => $b86cb2a650829868$export$79679f40eda4c5f9);
$parcel$export(module.exports, "getOverviewCsvHeaders", () => $b86cb2a650829868$export$b0cd97ccce203219);
$parcel$export(module.exports, "getContactInfoCsvHeaders", () => $b86cb2a650829868$export$7c2e4aacca43a9b2);
$parcel$export(module.exports, "getActivityCsvHeaders", () => $b86cb2a650829868$export$c6d636b170e4e9a0);
$parcel$export(module.exports, "csvFileNameFormatter", () => $b86cb2a650829868$export$d9a65bad2f258653);
$parcel$export(module.exports, "getRowDataSortedAndRanked", () => $b86cb2a650829868$export$589f79a8b4547514);
$parcel$export(module.exports, "getTableViewConfig", () => $b86cb2a650829868$export$59d3129ea7311aa8);
$parcel$export(module.exports, "getNonZeroData", () => $b86cb2a650829868$export$99928460806cfaa8);
$parcel$export(module.exports, "getAmSearchCriteria", () => $b86cb2a650829868$export$9e1cd9a967bb3332);
$parcel$export(module.exports, "getDataWithTotalsRow", () => $b86cb2a650829868$export$a27427cd3f5ef3d4);
$parcel$export(module.exports, "getEffectiveTabMode", () => $b86cb2a650829868$export$7a4ac4f91d529f67);
$parcel$export(module.exports, "persistedMetricsModules", () => $b86cb2a650829868$export$42101fc841beb047);

var $6IhJz = parcelRequire("6IhJz");

var $eHBjM = parcelRequire("eHBjM");

var $75U5M = parcelRequire("75U5M");

var $cstaF = parcelRequire("cstaF");

var $aypMh = parcelRequire("aypMh");

var $htzEo = parcelRequire("htzEo");

var $94cVo = parcelRequire("94cVo");

var $9QX0f = parcelRequire("9QX0f");

var $dqgmD = parcelRequire("dqgmD");
const $b86cb2a650829868$export$a119b89ce17f6a32 = "contact";
const $b86cb2a650829868$export$2a44cfb3c7defef9 = "search";
const $b86cb2a650829868$export$f6e253ef102416e0 = "mls";
const $b86cb2a650829868$export$e28a9c04417ce75f = "growth";
const $b86cb2a650829868$export$4e6dbd4640e41165 = "volume";
const $b86cb2a650829868$export$ab790aaf5337c7a1 = "units";
const $b86cb2a650829868$export$c41c0037dd869b05 = Object.freeze({
    OVERVIEW: 0,
    CONTACT_INFORMATION: 1,
    GROWTH_ANALYSIS: 2,
    LISTING_PROFICIENCY: 3,
    ACTIVITY: 4
});
const $b86cb2a650829868$export$ec801e34de37f83e = Object.freeze({
    [$b86cb2a650829868$export$c41c0037dd869b05.ACTIVITY]: (0, $aypMh.views).activity,
    [$b86cb2a650829868$export$c41c0037dd869b05.OVERVIEW]: (0, $aypMh.views).overview,
    [$b86cb2a650829868$export$c41c0037dd869b05.CONTACT_INFORMATION]: (0, $aypMh.views).contactInformation,
    [$b86cb2a650829868$export$c41c0037dd869b05.GROWTH_ANALYSIS]: (0, $aypMh.views).growthAnalysis,
    [$b86cb2a650829868$export$c41c0037dd869b05.LISTING_PROFICIENCY]: (0, $aypMh.views).listingProficiency
});
const $b86cb2a650829868$export$590c88e68a9eb854 = (columns, columnsToHide)=>{
    return columns.map((column)=>{
        return {
            ...column,
            isDisplayed: !columnsToHide.find((columnToHide)=>columnToHide.id === column.id)
        };
    });
};
const $b86cb2a650829868$var$getGrowthAnalysisYtdYears = (dateTo)=>{
    return {
        currentYear: dateTo.getFullYear(),
        previousYear: dateTo.getFullYear() - 1
    };
};
const $b86cb2a650829868$export$3df7a9eacd8b9293 = (searchDates, tabIndex)=>{
    const yearDetails = {
        previous: searchDates?.from?.getFullYear() || "",
        last: searchDates?.to?.getFullYear() || ""
    };
    if (tabIndex === $b86cb2a650829868$export$c41c0037dd869b05.GROWTH_ANALYSIS && searchDates?.to) {
        const years = $b86cb2a650829868$var$getGrowthAnalysisYtdYears(searchDates.to);
        yearDetails.last = years.currentYear;
        yearDetails.previous = years.previousYear;
    }
    return yearDetails;
};
const $b86cb2a650829868$export$497056754bce936d = (isNewProducers, isIncDecProducers, isCoopAgents)=>{
    const overviewColumns = [
        (0, $eHBjM.agentsColumns).agentId,
        (0, $eHBjM.agentsColumns).officeId,
        (0, $eHBjM.agentsColumns).officeAddress,
        (0, $eHBjM.agentsColumns).officeCity,
        (0, $eHBjM.agentsColumns).officeZipCode,
        (0, $eHBjM.agentsColumns).officeCounty,
        (0, $eHBjM.agentsColumns).listVolume,
        (0, $eHBjM.agentsColumns).sellVolume,
        (0, $eHBjM.agentsColumns).totalVolume,
        (0, $eHBjM.agentsColumns).listUnits,
        (0, $eHBjM.agentsColumns).sellUnits,
        (0, $eHBjM.agentsColumns).totalUnits,
        ...!isNewProducers ? [
            (0, $eHBjM.agentsColumns).averagePrice,
            (0, $eHBjM.agentsColumns).last12Spop,
            (0, $eHBjM.agentsColumns).last12AvgDom,
            ...isIncDecProducers ? [
                (0, $eHBjM.agentsColumns).ltmTotalUnitsChange
            ] : [
                (0, $eHBjM.agentsColumns).totalUnitsChange
            ],
            ...isIncDecProducers ? [
                (0, $eHBjM.agentsColumns).ltmTotalVolumeChange
            ] : [
                (0, $eHBjM.agentsColumns).totalVolumeChange
            ],
            (0, $eHBjM.agentsColumns).last12ListVolume,
            (0, $eHBjM.agentsColumns).last12ListUnits,
            (0, $eHBjM.agentsColumns).last12SellVolume,
            (0, $eHBjM.agentsColumns).last12SellUnits,
            (0, $eHBjM.agentsColumns).last12TotalVolume,
            (0, $eHBjM.agentsColumns).last12TotalUnits,
            ...isCoopAgents ? [
                (0, $eHBjM.agentsColumns).listingAddress,
                (0, $eHBjM.agentsColumns).listingCity,
                (0, $eHBjM.agentsColumns).listingZipCode,
                (0, $eHBjM.agentsColumns).listingCounty,
                (0, $eHBjM.agentsColumns).listingClosedDate,
                (0, $eHBjM.agentsColumns).listingSalePrice,
                (0, $eHBjM.agentsColumns).coopSide,
                (0, $eHBjM.agentsColumns).myAgentName
            ] : []
        ] : []
    ];
    const currentAreaColumns = [
        (0, $eHBjM.agentsColumns).agentId,
        (0, $eHBjM.agentsColumns).officeId,
        (0, $eHBjM.agentsColumns).officeAddress,
        (0, $eHBjM.agentsColumns).officeCity,
        (0, $eHBjM.agentsColumns).officeZipCode,
        (0, $eHBjM.agentsColumns).officeCounty,
        (0, $eHBjM.agentsColumns).listVolume,
        (0, $eHBjM.agentsColumns).sellVolume,
        (0, $eHBjM.agentsColumns).totalVolume,
        (0, $eHBjM.agentsColumns).listUnits,
        (0, $eHBjM.agentsColumns).sellUnits,
        (0, $eHBjM.agentsColumns).totalUnits
    ];
    const mlsColumns = [
        (0, $eHBjM.agentsColumns).averagePrice,
        (0, $eHBjM.agentsColumns).last12Spop,
        (0, $eHBjM.agentsColumns).last12AvgDom,
        (0, $eHBjM.agentsColumns).totalUnitsChange,
        (0, $eHBjM.agentsColumns).totalVolumeChange,
        (0, $eHBjM.agentsColumns).last12ListVolume,
        (0, $eHBjM.agentsColumns).last12ListUnits,
        (0, $eHBjM.agentsColumns).last12SellVolume,
        (0, $eHBjM.agentsColumns).last12SellUnits,
        (0, $eHBjM.agentsColumns).last12TotalVolume,
        (0, $eHBjM.agentsColumns).last12TotalUnits
    ];
    const columnsToDisplay = [
        ...!isCoopAgents ? [
            (0, $eHBjM.agentsColumns).listVolume,
            (0, $eHBjM.agentsColumns).sellVolume,
            (0, $eHBjM.agentsColumns).listUnits,
            (0, $eHBjM.agentsColumns).sellUnits
        ] : [],
        (0, $eHBjM.agentsColumns).totalVolume,
        (0, $eHBjM.agentsColumns).totalUnits,
        (0, $eHBjM.agentsColumns).last12ListVolume,
        (0, $eHBjM.agentsColumns).last12SellVolume,
        (0, $eHBjM.agentsColumns).last12TotalVolume,
        (0, $eHBjM.agentsColumns).last12ListUnits,
        (0, $eHBjM.agentsColumns).last12SellUnits,
        (0, $eHBjM.agentsColumns).last12TotalUnits,
        (0, $eHBjM.agentsColumns).listingAddress,
        (0, $eHBjM.agentsColumns).listingCity,
        (0, $eHBjM.agentsColumns).listingZipCode,
        (0, $eHBjM.agentsColumns).listingCounty,
        (0, $eHBjM.agentsColumns).listingClosedDate,
        (0, $eHBjM.agentsColumns).listingSalePrice,
        (0, $eHBjM.agentsColumns).coopSide,
        (0, $eHBjM.agentsColumns).myAgentName
    ];
    return overviewColumns.map((column)=>{
        return {
            id: column.id,
            label: column.label,
            hasBorder: overviewColumns.find((columnToDisplay, index)=>columnToDisplay.headerPlacement === "area" && overviewColumns[index + 1].isDisplayed === false) !== undefined,
            parentColumnId: column.parentColumnId,
            isDisplayed: columnsToDisplay.find((columnToDisplay)=>columnToDisplay.id === column.id) !== undefined,
            ...currentAreaColumns.find((areaColumn)=>areaColumn.id === column.id) ? {
                headerPlacement: "area"
            } : {},
            ...mlsColumns.find((mlsColumn)=>mlsColumn.id === column.id) ? {
                headerPlacement: "mls"
            } : {}
        };
    });
};
const $b86cb2a650829868$var$mlsRestrictionSettings = [
    {
        mlsId: (0, $cstaF.MLS_SID).MCRTC,
        columns: [
            (0, $eHBjM.agentsColumns).agentEmail
        ],
        view: (0, $eHBjM.tableViewNames).contactInformation
    }
];
const $b86cb2a650829868$export$31f9a936853c5421 = (selectedMlsId)=>{
    return $b86cb2a650829868$var$mlsRestrictionSettings.find((mls)=>mls.mlsId === selectedMlsId);
};
const $b86cb2a650829868$export$25e7e1260851e8a0 = (options, restrictedMlsSettings)=>options.filter((col)=>!restrictedMlsSettings?.columns.map((rc)=>rc.label).includes(col.label));
const $b86cb2a650829868$export$6f79fbe416ae99f = (restrictedMlsSettings, isNewProducers)=>{
    const tableViewName = (0, $eHBjM.tableViewNames).contactInformation;
    const contactInfoColumns = [
        {
            ...(0, $eHBjM.agentsColumns).agentId,
            headerPlacement: $b86cb2a650829868$export$a119b89ce17f6a32
        },
        {
            ...(0, $eHBjM.agentsColumns).officeId,
            headerPlacement: $b86cb2a650829868$export$a119b89ce17f6a32
        },
        {
            ...(0, $eHBjM.agentsColumns).officeAddress,
            headerPlacement: $b86cb2a650829868$export$a119b89ce17f6a32
        },
        {
            ...(0, $eHBjM.agentsColumns).officeCity,
            headerPlacement: $b86cb2a650829868$export$a119b89ce17f6a32
        },
        {
            ...(0, $eHBjM.agentsColumns).officeZipCode,
            headerPlacement: $b86cb2a650829868$export$a119b89ce17f6a32
        },
        {
            ...(0, $eHBjM.agentsColumns).officeCounty,
            headerPlacement: $b86cb2a650829868$export$a119b89ce17f6a32
        },
        {
            ...(0, $eHBjM.agentsColumns).agentPhoneType1,
            headerPlacement: $b86cb2a650829868$export$a119b89ce17f6a32
        },
        {
            ...(0, $eHBjM.agentsColumns).agentPhone1,
            headerPlacement: $b86cb2a650829868$export$a119b89ce17f6a32
        },
        {
            ...(0, $eHBjM.agentsColumns).agentPhoneType2,
            headerPlacement: $b86cb2a650829868$export$a119b89ce17f6a32
        },
        {
            ...(0, $eHBjM.agentsColumns).agentPhone2,
            headerPlacement: $b86cb2a650829868$export$a119b89ce17f6a32
        },
        {
            ...(0, $eHBjM.agentsColumns).agentPhoneType3,
            headerPlacement: $b86cb2a650829868$export$a119b89ce17f6a32
        },
        {
            ...(0, $eHBjM.agentsColumns).agentPhone3,
            headerPlacement: $b86cb2a650829868$export$a119b89ce17f6a32
        },
        {
            ...(0, $eHBjM.agentsColumns).agentEmail,
            headerPlacement: $b86cb2a650829868$export$a119b89ce17f6a32
        },
        {
            ...(0, $eHBjM.agentsColumns).agentAddress,
            headerPlacement: $b86cb2a650829868$export$a119b89ce17f6a32
        },
        {
            ...(0, $eHBjM.agentsColumns).totalUnits,
            headerPlacement: $b86cb2a650829868$export$2a44cfb3c7defef9
        },
        {
            ...(0, $eHBjM.agentsColumns).totalVolume,
            headerPlacement: $b86cb2a650829868$export$2a44cfb3c7defef9
        },
        ...!isNewProducers ? [
            {
                ...(0, $eHBjM.agentsColumns).last12TotalUnits,
                headerPlacement: $b86cb2a650829868$export$f6e253ef102416e0
            },
            {
                ...(0, $eHBjM.agentsColumns).last12TotalVolume,
                headerPlacement: $b86cb2a650829868$export$f6e253ef102416e0
            }
        ] : [],
        ...!isNewProducers ? [
            {
                ...(0, $eHBjM.agentsColumns).ciTotalVolumeChange,
                headerPlacement: $b86cb2a650829868$export$e28a9c04417ce75f
            },
            {
                ...(0, $eHBjM.agentsColumns).totalVolumeGrowth,
                headerPlacement: $b86cb2a650829868$export$e28a9c04417ce75f
            }
        ] : []
    ];
    return contactInfoColumns.map((c)=>{
        const shouldHideColumn = restrictedMlsSettings?.columns.map((rc)=>rc.id)?.includes(c.id) && restrictedMlsSettings?.view === tableViewName;
        return {
            ...c,
            isDisplayed: !shouldHideColumn
        };
    });
};
const $b86cb2a650829868$export$67adff24bb1b1e50 = ()=>{
    const activityColumns = [
        {
            ...(0, $eHBjM.agentsColumns).rank,
            headerPlacement: $b86cb2a650829868$export$2a44cfb3c7defef9
        },
        {
            ...(0, $eHBjM.agentsColumns).agentName,
            headerPlacement: $b86cb2a650829868$export$2a44cfb3c7defef9
        },
        {
            ...(0, $eHBjM.agentsColumns).officeName,
            headerPlacement: $b86cb2a650829868$export$2a44cfb3c7defef9
        },
        {
            ...(0, $eHBjM.agentsColumns).activity,
            headerPlacement: $b86cb2a650829868$export$2a44cfb3c7defef9
        },
        {
            ...(0, $eHBjM.agentsColumns).side,
            headerPlacement: $b86cb2a650829868$export$2a44cfb3c7defef9
        },
        {
            ...(0, $eHBjM.agentsColumns).date,
            headerPlacement: $b86cb2a650829868$export$2a44cfb3c7defef9
        },
        {
            ...(0, $eHBjM.agentsColumns).listVolume,
            headerPlacement: $b86cb2a650829868$export$f6e253ef102416e0
        },
        {
            ...(0, $eHBjM.agentsColumns).sellVolume,
            headerPlacement: $b86cb2a650829868$export$f6e253ef102416e0
        },
        {
            ...(0, $eHBjM.agentsColumns).totalVolume,
            headerPlacement: $b86cb2a650829868$export$f6e253ef102416e0
        }
    ];
    return activityColumns.map((columns)=>{
        return {
            ...columns,
            isDisplayed: true
        };
    });
};
const $b86cb2a650829868$export$6c3d104ee03c0ea1 = (columnId, columns)=>{
    const areaCols = columns.filter((column)=>column.headerPlacement === "area" && column.isDisplayed === true);
    const lastAreaColElement = areaCols.pop();
    columns.forEach((column)=>{
        column.hasBorder = lastAreaColElement && column.id === lastAreaColElement.id;
    });
    const borderedCol = columns.find((column)=>column.id === columnId && column.isDisplayed && column.hasBorder);
    return borderedCol && columns.filter((column)=>column.headerPlacement === "mls" && column.isDisplayed === true).length > 0;
};
const $b86cb2a650829868$export$79679f40eda4c5f9 = (columnId, columns)=>{
    if (!columns) return true;
    return !columns.find((column)=>column.id === columnId && column.isDisplayed);
};
const $b86cb2a650829868$export$b0cd97ccce203219 = (selectedColumnIds, dates, currentTabId)=>{
    let headers = [];
    if (!selectedColumnIds) return headers;
    const fromDate = (0, $75U5M.formatShortDate)(dates.from);
    const toDate = (0, $75U5M.formatShortDate)(dates.to);
    const isCoopAgents = currentTabId === (0, $9QX0f.tabs).coopAgents.id;
    selectedColumnIds.includes((0, $eHBjM.agentsColumns).agentId.id) && headers.push({
        label: "Agent ID",
        key: (0, $eHBjM.agentsColumns).agentId.id
    });
    headers.push({
        label: "First Name",
        key: "firstName"
    });
    headers.push({
        label: "Last Name",
        key: "lastName"
    });
    selectedColumnIds.includes((0, $eHBjM.agentsColumns).officeId.id) && headers.push({
        label: "Office ID",
        key: (0, $eHBjM.agentsColumns).officeId.id
    });
    headers.push({
        label: "Office Name",
        key: (0, $eHBjM.agentsColumns).officeName.id
    });
    isCoopAgents ? selectedColumnIds.includes((0, $eHBjM.agentsColumns).listingAddress.id) && headers.push({
        label: (0, $eHBjM.agentsColumns).listingAddress.label,
        key: (0, $eHBjM.agentsColumns).listingAddress.id
    }, {
        label: (0, $eHBjM.agentsColumns).listingCity.label,
        key: (0, $eHBjM.agentsColumns).listingCity.id
    }, {
        label: (0, $eHBjM.agentsColumns).listingZipCode.label,
        key: (0, $eHBjM.agentsColumns).listingZipCode.id
    }, {
        label: (0, $eHBjM.agentsColumns).listingCounty.label,
        key: (0, $eHBjM.agentsColumns).listingCounty.id
    }) : selectedColumnIds.includes((0, $eHBjM.agentsColumns).officeAddress.id) && headers.push({
        label: "Office Address",
        key: (0, $eHBjM.agentsColumns).officeAddress.id
    }, {
        label: "Office City",
        key: (0, $eHBjM.agentsColumns).officeCity.id
    }, {
        label: "Office Zip",
        key: (0, $eHBjM.agentsColumns).officeZipCode.id
    }, {
        label: "Office County",
        key: (0, $eHBjM.agentsColumns).officeCounty.id
    });
    isCoopAgents && selectedColumnIds.includes((0, $eHBjM.agentsColumns).listingClosedDate.id) && headers.push({
        label: (0, $eHBjM.agentsColumns).listingClosedDate.label,
        key: (0, $eHBjM.agentsColumns).listingClosedDate.id
    });
    isCoopAgents && selectedColumnIds.includes((0, $eHBjM.agentsColumns).listingSalePrice.id) && headers.push({
        label: (0, $eHBjM.agentsColumns).listingSalePrice.label,
        key: (0, $eHBjM.agentsColumns).listingSalePrice.id
    });
    isCoopAgents && selectedColumnIds.includes((0, $eHBjM.agentsColumns).coopSide.id) && headers.push({
        label: (0, $eHBjM.agentsColumns).coopSide.label,
        key: (0, $eHBjM.agentsColumns).coopSide.id
    });
    !isCoopAgents && selectedColumnIds.includes((0, $eHBjM.agentsColumns).listVolume.id) && headers.push({
        label: "List $",
        key: (0, $eHBjM.agentsColumns).listVolume.id
    });
    !isCoopAgents && selectedColumnIds.includes((0, $eHBjM.agentsColumns).sellVolume.id) && headers.push({
        label: "Sell $",
        key: (0, $eHBjM.agentsColumns).sellVolume.id
    });
    selectedColumnIds.includes((0, $eHBjM.agentsColumns).totalVolume.id) && headers.push({
        label: `Total $ (${fromDate} - ${toDate})`,
        key: (0, $eHBjM.agentsColumns).totalVolume.id
    });
    !isCoopAgents && selectedColumnIds.includes((0, $eHBjM.agentsColumns).listUnits.id) && headers.push({
        label: "List #",
        key: (0, $eHBjM.agentsColumns).listUnits.id
    });
    !isCoopAgents && selectedColumnIds.includes((0, $eHBjM.agentsColumns).sellUnits.id) && headers.push({
        label: "Sell #",
        key: (0, $eHBjM.agentsColumns).sellUnits.id
    });
    selectedColumnIds.includes((0, $eHBjM.agentsColumns).totalUnits.id) && headers.push({
        label: `Total # (${fromDate} - ${toDate})`,
        key: (0, $eHBjM.agentsColumns).totalUnits.id
    });
    isCoopAgents && selectedColumnIds.includes((0, $eHBjM.agentsColumns).myAgentName.id) && headers.push({
        label: (0, $eHBjM.agentsColumns).myAgentName.label,
        key: (0, $eHBjM.agentsColumns).myAgentName.id
    });
    selectedColumnIds.includes((0, $eHBjM.agentsColumns).averagePrice.id) && headers.push({
        label: "Avg $ LTM",
        key: (0, $eHBjM.agentsColumns).averagePrice.id
    });
    selectedColumnIds.includes((0, $eHBjM.agentsColumns).last12Spop.id) && headers.push({
        label: "SP/OP",
        key: (0, $eHBjM.agentsColumns).last12Spop.id
    });
    selectedColumnIds.includes((0, $eHBjM.agentsColumns).last12AvgDom.id) && headers.push({
        label: "Avg DOM",
        key: (0, $eHBjM.agentsColumns).last12AvgDom.id
    });
    selectedColumnIds.includes((0, $eHBjM.agentsColumns).totalUnitsChange.id) && headers.push({
        label: "Growth # Units",
        key: (0, $eHBjM.agentsColumns).totalUnitsChange.id
    });
    selectedColumnIds.includes((0, $eHBjM.agentsColumns).totalVolumeChange.id) && headers.push({
        label: "Growth $ Volume",
        key: (0, $eHBjM.agentsColumns).totalVolumeChange.id
    });
    selectedColumnIds.includes((0, $eHBjM.agentsColumns).last12ListVolume.id) && headers.push({
        label: "List $ (LTM)",
        key: (0, $eHBjM.agentsColumns).last12ListVolume.id
    });
    selectedColumnIds.includes((0, $eHBjM.agentsColumns).last12SellVolume.id) && headers.push({
        label: "Sell $ (LTM)",
        key: (0, $eHBjM.agentsColumns).last12SellVolume.id
    });
    selectedColumnIds.includes((0, $eHBjM.agentsColumns).last12TotalVolume.id) && headers.push({
        label: "Total $ (LTM)",
        key: (0, $eHBjM.agentsColumns).last12TotalVolume.id
    });
    selectedColumnIds.includes((0, $eHBjM.agentsColumns).last12ListUnits.id) && headers.push({
        label: "List # (LTM)",
        key: (0, $eHBjM.agentsColumns).last12ListUnits.id
    });
    selectedColumnIds.includes((0, $eHBjM.agentsColumns).last12SellUnits.id) && headers.push({
        label: "Sell # (LTM)",
        key: (0, $eHBjM.agentsColumns).last12SellUnits.id
    });
    selectedColumnIds.includes((0, $eHBjM.agentsColumns).last12TotalUnits.id) && headers.push({
        label: "Total # (LTM)",
        key: (0, $eHBjM.agentsColumns).last12TotalUnits.id
    });
    return headers;
};
const $b86cb2a650829868$export$7c2e4aacca43a9b2 = (selectedColumnIds, dates)=>{
    let headers = [];
    if (!selectedColumnIds) return headers;
    const fromDate = (0, $75U5M.formatShortDate)(dates.from);
    const toDate = (0, $75U5M.formatShortDate)(dates.to);
    selectedColumnIds.includes((0, $eHBjM.agentsColumns).agentId.id) && headers.push({
        label: "Agent ID",
        key: (0, $eHBjM.agentsColumns).agentId.id
    });
    headers.push({
        label: "First Name",
        key: "firstName"
    });
    headers.push({
        label: "Last Name",
        key: "lastName"
    });
    selectedColumnIds.includes((0, $eHBjM.agentsColumns).officeId.id) && headers.push({
        label: "Office ID",
        key: (0, $eHBjM.agentsColumns).officeId.id
    });
    headers.push({
        label: "Office Name",
        key: (0, $eHBjM.agentsColumns).officeName.id
    });
    selectedColumnIds.includes((0, $eHBjM.agentsColumns).officeAddress.id) && headers.push({
        label: "Office Address",
        key: (0, $eHBjM.agentsColumns).officeAddress.id
    }, {
        label: "Office City",
        key: (0, $eHBjM.agentsColumns).officeCity.id
    }, {
        label: "Office Zip",
        key: (0, $eHBjM.agentsColumns).officeZipCode.id
    }, {
        label: "Office County",
        key: (0, $eHBjM.agentsColumns).officeCounty.id
    });
    selectedColumnIds.includes((0, $eHBjM.agentsColumns).agentPhone1.id) && headers.push({
        label: "Phone 1",
        key: (0, $eHBjM.agentsColumns).agentPhone1.id
    });
    selectedColumnIds.includes((0, $eHBjM.agentsColumns).agentPhoneType1.id) && headers.push({
        label: "Phone Type 1",
        key: (0, $eHBjM.agentsColumns).agentPhoneType1.id
    });
    selectedColumnIds.includes((0, $eHBjM.agentsColumns).agentPhone2.id) && headers.push({
        label: "Phone 2",
        key: (0, $eHBjM.agentsColumns).agentPhone2.id
    });
    selectedColumnIds.includes((0, $eHBjM.agentsColumns).agentPhoneType2.id) && headers.push({
        label: "Phone Type 2",
        key: (0, $eHBjM.agentsColumns).agentPhoneType2.id
    });
    selectedColumnIds.includes((0, $eHBjM.agentsColumns).agentPhone3.id) && headers.push({
        label: "Phone 3",
        key: (0, $eHBjM.agentsColumns).agentPhone3.id
    });
    selectedColumnIds.includes((0, $eHBjM.agentsColumns).agentPhoneType3.id) && headers.push({
        label: "Phone Type 3",
        key: (0, $eHBjM.agentsColumns).agentPhoneType3.id
    });
    selectedColumnIds.includes((0, $eHBjM.agentsColumns).agentEmail.id) && headers.push({
        label: "Email",
        key: (0, $eHBjM.agentsColumns).agentEmail.id
    });
    selectedColumnIds.includes((0, $eHBjM.agentsColumns).agentAddress.id) && headers.push({
        label: "Alternate Address",
        key: (0, $eHBjM.agentsColumns).agentAddress.id
    }, {
        label: "Alternate City",
        key: "agentCity"
    }, {
        label: "Alternate Zip",
        key: "agentZipcode"
    });
    selectedColumnIds.includes((0, $eHBjM.agentsColumns).totalUnits.id) && headers.push({
        label: `Total # (${fromDate} - ${toDate})`,
        key: (0, $eHBjM.agentsColumns).totalUnits.id
    });
    selectedColumnIds.includes((0, $eHBjM.agentsColumns).totalVolume.id) && headers.push({
        label: `Total $ (${fromDate} - ${toDate})`,
        key: (0, $eHBjM.agentsColumns).totalVolume.id
    });
    selectedColumnIds.includes((0, $eHBjM.agentsColumns).last12TotalUnits.id) && headers.push({
        label: "Total # (LTM)",
        key: (0, $eHBjM.agentsColumns).last12TotalUnits.id
    });
    selectedColumnIds.includes((0, $eHBjM.agentsColumns).last12TotalVolume.id) && headers.push({
        label: "Total $ (LTM)",
        key: (0, $eHBjM.agentsColumns).last12TotalVolume.id
    });
    selectedColumnIds.includes((0, $eHBjM.agentsColumns).ciTotalVolumeChange.id) && headers.push({
        label: "$ Change",
        key: (0, $eHBjM.agentsColumns).ciTotalVolumeChange.id
    });
    selectedColumnIds.includes((0, $eHBjM.agentsColumns).totalVolumeGrowth.id) && headers.push({
        label: "% Change",
        key: (0, $eHBjM.agentsColumns).totalVolumeGrowth.id
    });
    return headers;
};
const $b86cb2a650829868$export$c6d636b170e4e9a0 = (selectedColumnsIds)=>[
        {
            label: "Agent Name",
            key: (0, $eHBjM.agentsColumns).agentName.id
        },
        {
            label: "Office Name",
            key: (0, $eHBjM.agentsColumns).officeName.id
        },
        {
            label: "Activity",
            key: (0, $eHBjM.agentsColumns).activity.id
        },
        {
            label: "Side",
            key: (0, $eHBjM.agentsColumns).side.id
        },
        {
            label: "Date",
            key: (0, $eHBjM.agentsColumns).date.id
        },
        {
            label: "List $",
            key: (0, $eHBjM.agentsColumns).listVolume.id
        },
        {
            label: "Sell $",
            key: (0, $eHBjM.agentsColumns).sellVolume.id
        },
        {
            label: "Total $",
            key: (0, $eHBjM.agentsColumns).totalVolume.id
        }
    ].filter((header)=>selectedColumnsIds.includes(header.key));
const $b86cb2a650829868$export$d9a65bad2f258653 = (tabMode)=>{
    const formattedDateTime = `${(0, $6IhJz.default)(new Date(), "yyyyMMddHHmmss")}`;
    return ({
        [(0, $eHBjM.tabModes).OVERVIEW.toUpperCase()]: `Agent Production Overview Export - ${formattedDateTime}.csv`,
        [(0, $eHBjM.tabModes).CONTACT_INFORMATION.toUpperCase()]: `Agent Production Contact Information Export - ${formattedDateTime}.csv`,
        [(0, $eHBjM.tabModes).GROWTH_ANALYSIS.toUpperCase()]: `Agent Production Growth Analysis Export - ${formattedDateTime}.csv`,
        [(0, $eHBjM.tabModes).LISTING_PROFICIENCY.toUpperCase()]: `Agent Production Listing Proficiency Export - ${formattedDateTime}.csv`,
        [(0, $eHBjM.tabModes).ACTIVITY.toUpperCase()]: `Saved Agent List - Activity Export - ${formattedDateTime}.csv`
    })[tabMode.toUpperCase()];
};
const $b86cb2a650829868$export$44c75bf809481b1 = (agentData)=>{
    const headers = [
        {
            label: "First Name",
            key: "firstName"
        },
        {
            label: "Last Name",
            key: "lastName"
        },
        {
            label: "Office Name",
            key: (0, $eHBjM.agentsColumns).officeName.id
        },
        {
            label: "Office ID",
            key: (0, $eHBjM.agentsColumns).officeId.id
        },
        {
            label: "Office Address",
            key: (0, $eHBjM.agentsColumns).officeAddress.id
        },
        {
            label: "Office City",
            key: (0, $eHBjM.agentsColumns).officeCity.id
        },
        {
            label: "Office Zip",
            key: (0, $eHBjM.agentsColumns).officeZipCode.id
        },
        {
            label: "Office County",
            key: (0, $eHBjM.agentsColumns).officeCounty.id
        },
        {
            label: "Total Sell # Units",
            key: (0, $eHBjM.agentsColumns).last12SellUnits.id
        },
        {
            label: "Total Sell $ Volume",
            key: (0, $eHBjM.agentsColumns).last12SellVolume.id
        },
        {
            label: "Total List # Units",
            key: (0, $eHBjM.agentsColumns).last12ListUnits.id
        },
        {
            label: "Total List $ Volume",
            key: (0, $eHBjM.agentsColumns).last12ListVolume.id
        },
        {
            label: "No PC # Units",
            key: (0, $eHBjM.agentsColumns).noPcLast12ListUnits.id
        },
        {
            label: "No PC % of Total Units",
            key: (0, $eHBjM.agentsColumns).noPcLast12ListUnitsPct.id
        },
        {
            label: "No PC $ Volume",
            key: (0, $eHBjM.agentsColumns).noPcLast12ListVolume.id
        },
        {
            label: "No PC % of Total Volume",
            key: (0, $eHBjM.agentsColumns).noPcLast12ListVolumePct.id
        },
        {
            label: "No PC DOM",
            key: (0, $eHBjM.agentsColumns).noPcLast12ListDom.id
        },
        {
            label: "No PC CDOM",
            key: (0, $eHBjM.agentsColumns).noPcLast12ListCdom.id
        },
        {
            label: "No PC SP/OP",
            key: (0, $eHBjM.agentsColumns).noPcLast12SpOp.id
        },
        {
            label: "PC # Units",
            key: (0, $eHBjM.agentsColumns).pcLast12ListUnits.id
        },
        {
            label: "PC % of Total Units",
            key: (0, $eHBjM.agentsColumns).pcLast12ListUnitsPct.id
        },
        {
            label: "PC $ Volume",
            key: (0, $eHBjM.agentsColumns).pcLast12ListVolume.id
        },
        {
            label: "PC % of Total Volume",
            key: (0, $eHBjM.agentsColumns).pcLast12ListVolumePct.id
        },
        {
            label: "PC Avg DOM",
            key: (0, $eHBjM.agentsColumns).pcLast12ListDom.id
        },
        {
            label: "PC CDOM",
            key: (0, $eHBjM.agentsColumns).pcLast12ListCdom.id
        },
        {
            label: "PC DOM",
            key: (0, $eHBjM.agentsColumns).pcLast12ListPcDom.id
        },
        {
            label: "PC SP/OP",
            key: (0, $eHBjM.agentsColumns).pcLast12ListSpOp.id
        },
        {
            label: "PC SP/LP",
            key: (0, $eHBjM.agentsColumns).pcLast12ListSpLp.id
        },
        {
            label: "Avg # PC",
            key: (0, $eHBjM.agentsColumns).pcLast12ListAvgNumPc.id
        }
    ];
    const data = (agentData.length > 0 && agentData.map((a)=>{
        const names = a?.agentName.split(" ") ?? [];
        const firstName = names[0];
        const lastName = names[names.length - 1];
        return {
            ...a,
            firstName: firstName,
            lastName: lastName,
            [(0, $eHBjM.agentsColumns).sellVolume.id]: (0, $htzEo.formatVolumeOrDays)(a?.sellVolume, true),
            [(0, $eHBjM.agentsColumns).last12ListVolume.id]: (0, $htzEo.formatVolumeOrDays)(a?.last12ListVolume, true),
            [(0, $eHBjM.agentsColumns).noPcLast12ListDom.id]: (0, $htzEo.formatVolumeOrDays)(a?.noPcLast12ListDom, true),
            [(0, $eHBjM.agentsColumns).noPcLast12ListCdom.id]: (0, $htzEo.formatVolumeOrDays)(a?.noPcLast12ListCdom, true),
            [(0, $eHBjM.agentsColumns).pcLast12ListPcDom.id]: (0, $htzEo.formatVolumeOrDays)(a?.pcLast12ListPcDom, true),
            [(0, $eHBjM.agentsColumns).pcLast12ListCdom.id]: (0, $htzEo.formatVolumeOrDays)(a?.pcLast12ListCdom, true),
            [(0, $eHBjM.agentsColumns).pcLast12ListDom.id]: (0, $htzEo.formatVolumeOrDays)(a?.pcLast12ListDom, true),
            [(0, $eHBjM.agentsColumns).sellUnits.id]: (0, $htzEo.formatUnitOrPercentage)(a?.sellUnits, true),
            [(0, $eHBjM.agentsColumns).last12ListUnits.id]: (0, $htzEo.formatUnitOrPercentage)(a?.last12ListUnits, true),
            [(0, $eHBjM.agentsColumns).noPcLast12ListUnits.id]: (0, $htzEo.formatUnitOrPercentage)(a?.noPcLast12ListUnits, true),
            [(0, $eHBjM.agentsColumns).noPcLast12ListUnitsPct.id]: (0, $htzEo.formatUnitOrPercentage)(a?.noPcLast12ListUnitsPct, true),
            [(0, $eHBjM.agentsColumns).noPcLast12SpOp.id]: (0, $htzEo.formatUnitOrPercentage)(a?.noPcLast12SpOp, true),
            [(0, $eHBjM.agentsColumns).pcLast12ListUnits.id]: (0, $htzEo.formatUnitOrPercentage)(a?.pcLast12ListUnits, true),
            [(0, $eHBjM.agentsColumns).pcLast12ListUnitsPct.id]: (0, $htzEo.formatUnitOrPercentage)(a?.pcLast12ListUnitsPct, true),
            [(0, $eHBjM.agentsColumns).pcLast12ListSpOp.id]: (0, $htzEo.formatUnitOrPercentage)(a?.pcLast12ListSpOp, true),
            [(0, $eHBjM.agentsColumns).pcLast12ListSpLp.id]: (0, $htzEo.formatUnitOrPercentage)(a?.pcLast12ListSpLp, true),
            [(0, $eHBjM.agentsColumns).pcLast12ListAvgNumPc.id]: (0, $htzEo.formatUnitOrPercentage)(a?.pcLast12ListAvgNumPc, true)
        };
    })) ?? [
        {}
    ];
    return {
        headers: headers,
        data: data
    };
};
const $b86cb2a650829868$export$589f79a8b4547514 = (data, shouldNotRank = false, isCoopAgentsOverview)=>{
    const sortedData = isCoopAgentsOverview ? (0, $94cVo.getSortedObjectsByDateKey)(data, (0, $eHBjM.agentsColumns).listingClosedDate.id) : (0, $94cVo.getSortedObjectsNumeric)(data, (0, $eHBjM.agentsColumns).totalVolume.id);
    return !shouldNotRank ? (0, $dqgmD.getRankedData)(sortedData) : sortedData;
};
const $b86cb2a650829868$export$59d3129ea7311aa8 = (tableView, parentIndexesToRemove)=>({
        ...tableView,
        tables: tableView.tables.map((table)=>({
                ...table
            })).filter((_, i)=>!parentIndexesToRemove?.includes(i))
    });
const $b86cb2a650829868$export$99928460806cfaa8 = (data, keyField)=>{
    const filteredData = data.filter((agent)=>agent[keyField] !== 0);
    return (0, $dqgmD.getRankedData)(filteredData);
};
const $b86cb2a650829868$export$9e1cd9a967bb3332 = (mlsId)=>({
        realEstateDatasourceIdsWithFilters: [
            {
                computedFields: [],
                idFiltering: [],
                realEstateDatasourceId: mlsId,
                searchAllMLS: true,
                searchFields: []
            }
        ],
        timePeriod: {
            intervalType: (0, $cstaF.agentProductionTerms).annually
        }
    });
const $b86cb2a650829868$export$a27427cd3f5ef3d4 = (rowData, excludedKeyfields = [])=>{
    let totalsRowData = {
        month: (0, $cstaF.searchTerms).totals,
        rank: (0, $cstaF.searchTerms).totals
    };
    for (const row of rowData){
        const rowKeyFields = Object.keys(row).filter((keyfield)=>!excludedKeyfields.includes(keyfield));
        for (const keyField of rowKeyFields)if (!isNaN(row[keyField])) totalsRowData = {
            ...totalsRowData,
            [keyField]: (totalsRowData?.[keyField] || 0) + row[keyField]
        };
    }
    return [
        ...rowData,
        totalsRowData
    ];
};
const $b86cb2a650829868$export$7a4ac4f91d529f67 = (tabMode, isPeriodLast12Months)=>{
    if (tabMode === (0, $eHBjM.tabModes).GROWTH_ANALYSIS) return isPeriodLast12Months ? (0, $eHBjM.tableViewNames).growthAnalysisLtm : (0, $eHBjM.tableViewNames).growthAnalysisYtd;
    return tabMode;
};
const $b86cb2a650829868$export$42101fc841beb047 = [
    (0, $cstaF.modules).proficiencyMetrics.transactions,
    (0, $cstaF.modules).proficiencyMetrics.offices,
    (0, $cstaF.modules).proficiencyMetrics.agents
];

});
parcelRegister("94cVo", function(module, exports) {

$parcel$export(module.exports, "getListingTypes", () => $f6bc8c28eb916db9$export$7bc90296e5c7d581);
$parcel$export(module.exports, "getSum", () => $f6bc8c28eb916db9$export$c8f40307c786ebfa);
$parcel$export(module.exports, "getSortedObjectByProp", () => $f6bc8c28eb916db9$export$14de6d8dc8c84c82);
$parcel$export(module.exports, "getSortedObjectsNumeric", () => $f6bc8c28eb916db9$export$89d82643f9989b02);
$parcel$export(module.exports, "getSortedObjectsByDateKey", () => $f6bc8c28eb916db9$export$e7f57cc20daa1764);
$parcel$export(module.exports, "MAX_COUNT_SELECTED_ROWS", () => $f6bc8c28eb916db9$export$26196eb6f77e998a);
$parcel$export(module.exports, "transformData", () => $f6bc8c28eb916db9$export$3ceb62baab058c6b);
$parcel$export(module.exports, "getRowCount", () => $f6bc8c28eb916db9$export$cdf8664fc0d26ff4);
$parcel$export(module.exports, "getDataStats", () => $f6bc8c28eb916db9$export$d9e0a2de8800ca2d);
$parcel$export(module.exports, "getCoverageDataStats", () => $f6bc8c28eb916db9$export$da02eacfee505b7a);
$parcel$export(module.exports, "getRevisedColumns", () => $f6bc8c28eb916db9$export$64afc4106c1740a3);
$parcel$export(module.exports, "getSortedColumns", () => $f6bc8c28eb916db9$export$7409f0a922d6f7d2);
$parcel$export(module.exports, "getRevisedCoverageColumns", () => $f6bc8c28eb916db9$export$e205b7b928b9b46);
$parcel$export(module.exports, "getSearchType", () => $f6bc8c28eb916db9$export$d52771ec6fbcb6d4);
$parcel$export(module.exports, "getChart", () => $f6bc8c28eb916db9$export$6f51bedc4efb925e);
$parcel$export(module.exports, "getCoverageChart", () => $f6bc8c28eb916db9$export$337808980099db39);
$parcel$export(module.exports, "uriEncode", () => $f6bc8c28eb916db9$export$1ea6cdab375898b5);
$parcel$export(module.exports, "useURIDecoder", () => $f6bc8c28eb916db9$export$c82a25c335ebe92f);
$parcel$export(module.exports, "getTooltipContent", () => $f6bc8c28eb916db9$export$89e31ef8e83a0330);
$parcel$export(module.exports, "getShowHideKey", () => $f6bc8c28eb916db9$export$15fd82f62d1efe95);
$parcel$export(module.exports, "getEffectiveListingType", () => $f6bc8c28eb916db9$export$5dcf6e961ac38ca4);

var $acw62 = parcelRequire("acw62");

var $bq4QZ = parcelRequire("bq4QZ");

var $cstaF = parcelRequire("cstaF");

var $3etjB = parcelRequire("3etjB");

var $c3iqc = parcelRequire("c3iqc");

var $4UTP7 = parcelRequire("4UTP7");
const $f6bc8c28eb916db9$export$7bc90296e5c7d581 = (listingTypes, defaultType)=>{
    const revisedListingTypes = [];
    for(const key in listingTypes){
        const listingType = listingTypes[key];
        revisedListingTypes.push({
            label: listingType.label,
            id: listingType.id,
            isDefault: listingType.id === defaultType.id
        });
    }
    return revisedListingTypes;
};
const $f6bc8c28eb916db9$export$c8f40307c786ebfa = (objects, fieldToSum)=>{
    if (!objects) return 0;
    const result = objects?.reduce((sum, row)=>{
        if (!row[fieldToSum]) return sum;
        return sum + row[fieldToSum];
    }, 0);
    return result;
};
const $f6bc8c28eb916db9$export$aa8cda05b863d51 = (objects, propertyToSort)=>{
    return [
        ...objects
    ].sort((a, b)=>b[propertyToSort] > a[propertyToSort] ? 1 : -1);
};
const $f6bc8c28eb916db9$export$14de6d8dc8c84c82 = (object, propertyToSort, order = "ASC")=>{
    return [
        ...object
    ].sort((a, b)=>{
        if (order === "ASC") return a[propertyToSort] > b[propertyToSort] ? 1 : a[propertyToSort] < b[propertyToSort] ? -1 : 0;
        else if (order === "DESC") return a[propertyToSort] < b[propertyToSort] ? 1 : a[propertyToSort] > b[propertyToSort] ? -1 : 0;
    });
};
const $f6bc8c28eb916db9$export$89d82643f9989b02 = (objects, propertyToSort)=>{
    if (!Array.isArray(objects) || objects.length === 0) return [];
    return [
        ...objects
    ].sort((a, b)=>{
        let aValue = a[propertyToSort], bValue = b[propertyToSort];
        const LARGE_NEGATIVE_INTEGER = -99999999999;
        const LARGER_NEGATIVE_INTEGER = -999999999999;
        if (aValue === undefined) aValue = LARGER_NEGATIVE_INTEGER;
        if (bValue === undefined) bValue = LARGER_NEGATIVE_INTEGER;
        if (aValue === null) aValue = LARGE_NEGATIVE_INTEGER;
        if (bValue === null) bValue = LARGE_NEGATIVE_INTEGER;
        return bValue - aValue;
    });
};
const $f6bc8c28eb916db9$export$e7f57cc20daa1764 = (data, keyToSort)=>{
    return [
        ...data
    ].sort((a, b)=>new Date(b[keyToSort]) - new Date(a[keyToSort]));
};
const $f6bc8c28eb916db9$export$26196eb6f77e998a = 10;
const $f6bc8c28eb916db9$var$calculateClr = (isCoverageSearch, row)=>{
    if (isCoverageSearch) {
        if (row?.listed === 0) return null;
        return row?.listUnits / row?.listed;
    }
    return row?.clr ? row?.clr : row?.listUnits / row?.listedUnits;
};
const $f6bc8c28eb916db9$export$3ceb62baab058c6b = (rows, stats, columnToRankBy, isCoverageSearch)=>{
    const sumOfColumnRows = stats.sumOfColumn;
    if (!sumOfColumnRows || !rows) return rows;
    const revisedRows = $f6bc8c28eb916db9$export$89d82643f9989b02(rows, columnToRankBy);
    for(let i = 0; i < revisedRows.length; i++){
        const row = revisedRows[i];
        const marketSharePct = row[columnToRankBy] / sumOfColumnRows * 100;
        const rank = i + 1;
        const isSelected = rank <= $f6bc8c28eb916db9$export$26196eb6f77e998a && !(0, $3etjB.EXCLUDED_ROWS).includes(row.groupName);
        if (isCoverageSearch) {
            row.listSpop = row?.listSpop ? row.listSpop * 100 : row?.listVolume / row?.listOrgPrice * 100;
            row.sellSpop = row?.sellSpop ? row.sellSpop * 100 : row?.sellVolume / row?.sellOrgPrice * 100;
            row.unitSharePct = row[(0, $c3iqc.marketShareColumns).forSaleUnits.id] / stats?.sumOfUnitsColumn * 100;
            row.volumeSharePct = row[(0, $c3iqc.marketShareColumns).forSaleVolume.id] / stats?.sumOfVolumeColumn * 100;
            row.area = row?.area || (0, $cstaF.agentProductionTerms).notSuppliedByMls;
        }
        row.clr = $f6bc8c28eb916db9$var$calculateClr(isCoverageSearch, row);
        row.marketSharePct = marketSharePct;
        row.isSelected = isSelected;
        row.rank = rank;
    }
    return revisedRows;
};
const $f6bc8c28eb916db9$export$cdf8664fc0d26ff4 = (rows)=>rows?.length || 0;
const $f6bc8c28eb916db9$export$d9e0a2de8800ca2d = (data, listingType, listingView)=>{
    const dataRows = data[listingType.collectionKey];
    const rowCount = $f6bc8c28eb916db9$export$cdf8664fc0d26ff4(dataRows);
    const sumOfColumn = $f6bc8c28eb916db9$export$c8f40307c786ebfa(dataRows, listingView.keyField);
    return {
        rowCount: rowCount,
        sumOfColumn: sumOfColumn
    };
};
const $f6bc8c28eb916db9$export$da02eacfee505b7a = (data, listingView)=>{
    const rowCount = $f6bc8c28eb916db9$export$cdf8664fc0d26ff4(data);
    const sumOfColumn = $f6bc8c28eb916db9$export$c8f40307c786ebfa(data, listingView.keyField);
    let sumOfUnitsColumn = 0;
    let sumOfVolumeColumn = 0;
    if (listingView.id === (0, $4UTP7.listingViews).forSale$Volume.id) sumOfUnitsColumn = $f6bc8c28eb916db9$export$c8f40307c786ebfa(data, (0, $c3iqc.marketShareColumns).forSaleUnits.id);
    if (listingView.id === (0, $4UTP7.listingViews).forSaleNumUnits.id) sumOfVolumeColumn = $f6bc8c28eb916db9$export$c8f40307c786ebfa(data, (0, $c3iqc.marketShareColumns).forSaleVolume.id);
    return {
        rowCount: rowCount,
        sumOfColumn: sumOfColumn,
        sumOfUnitsColumn: sumOfUnitsColumn,
        sumOfVolumeColumn: sumOfVolumeColumn
    };
};
const $f6bc8c28eb916db9$export$64afc4106c1740a3 = (listingView, listingType)=>{
    return listingView.settings[listingType.id].columns.map((column)=>{
        return {
            ...column,
            sort: column.field === listingView.keyField ? "desc" : ""
        };
    });
};
const $f6bc8c28eb916db9$export$7409f0a922d6f7d2 = (columns, listingViewId, sortDirection)=>{
    return columns?.map((column)=>{
        return {
            ...column,
            sort: column.field === listingViewId ? sortDirection || "desc" : ""
        };
    });
};
const $f6bc8c28eb916db9$export$e205b7b928b9b46 = (listingView)=>{
    return listingView.settings.columns.map((column)=>{
        return {
            ...column,
            sort: column.field === listingView.keyField ? "desc" : ""
        };
    });
};
const $f6bc8c28eb916db9$export$d52771ec6fbcb6d4 = (module)=>module === (0, $cstaF.modules).marketShare.totals ? (0, $3etjB.marketShareTerms).totals : (0, $3etjB.marketShareTerms).coverage;
const $f6bc8c28eb916db9$export$6f51bedc4efb925e = (listingType, listingViews, listingView)=>{
    return {
        yAxisLabelMapper: listingType.yAxisLabelMapper,
        dataPointGroups: listingViews.find((lv)=>lv.id === listingView.id)?.dataPointGroups,
        xAxisLabelFormatter: listingView.xAxisLabelFormatter,
        popOverDataFormatter: listingView.popOverDataFormatter,
        popOverLabels: listingView.popOverLabels
    };
};
const $f6bc8c28eb916db9$export$a0e3f227f23cec1b = (value)=>{
    const ref = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $f6bc8c28eb916db9$export$337808980099db39 = (listingViews, listingView)=>{
    return {
        yAxisLabelMapper: (d)=>d["area"],
        dataPointGroups: listingViews.find((lv)=>lv.id === listingView.id)?.dataPointGroups,
        xAxisLabelFormatter: listingView.xAxisLabelFormatter,
        popOverDataFormatter: listingView.popOverDataFormatter,
        popOverLabels: listingView.popOverLabels
    };
};
const $f6bc8c28eb916db9$export$1ea6cdab375898b5 = (value)=>encodeURIComponent(value);
const $f6bc8c28eb916db9$export$c82a25c335ebe92f = (paramName)=>{
    const query = (0, $bq4QZ.useQuery)();
    const value = query.get(paramName);
    return value === "null" ? "" : decodeURIComponent(value?.replace(/%(?![0-9][0-9a-fA-F]+)/g, "%25"));
};
const $f6bc8c28eb916db9$export$89e31ef8e83a0330 = (series, dataPointIndex, graphInfo, barColors, config)=>{
    const tooltipHeader = graphInfo.globals.labels[dataPointIndex];
    if (series.length > 1) {
        const series1 = series[0][dataPointIndex];
        const series2 = series[1][dataPointIndex];
        return `<div class='arrow_box volume-chart-tooltip'>
        <div class='header'>
            ${tooltipHeader}
        </div>
        <div class='body'>
            <div class='items'>
                <span class='bullet' style='background-color: ${barColors[0]}'></span>
                    ${config?.popOverLabels[0]}: ${config?.popOverDataFormatter(series1)} <br />
                    <span class='bullet' style='background-color: ${barColors[1]}'></span>
                    ${config?.popOverLabels[1]}: ${config?.popOverDataFormatter(series2)}
            </div>
            <div class='total font-weight-bold'>
                ${(0, $cstaF.agentProductionTerms).totalSum}: ${config?.popOverDataFormatter(series2 + series1)}</div>
            </div>
        </div>`;
    }
    const series1 = series[0][dataPointIndex];
    return `<div class='arrow_box volume-chart-tooltip'>
    <div class='header'>
        ${tooltipHeader}
    </div>
    <div class='body'>
        <div class='items'>
            <span class='bullet' style='background-color: ${barColors[0]}'></span>
                ${config?.popOverLabels[0]}: ${config?.popOverDataFormatter(series1)} <br />
        </div>
        </div>
    </div>`;
};
const $f6bc8c28eb916db9$export$15fd82f62d1efe95 = (listingType, listingView)=>`${listingType}_${listingView}`;
const $f6bc8c28eb916db9$export$5dcf6e961ac38ca4 = (isCoverageSearch, isComparisonSetView, listingType)=>{
    if (isCoverageSearch) return (0, $cstaF.searchTypeNames).coverage;
    if (isComparisonSetView) return (0, $3etjB.listingTypes).comparisonSet.id;
    return listingType;
};

});
parcelRegister("bq4QZ", function(module, exports) {

$parcel$export(module.exports, "useQuery", () => $8505e345027a1b10$export$dd0a697e1782aedd);

var $acw62 = parcelRequire("acw62");

var $kfZjc = parcelRequire("kfZjc");
const $8505e345027a1b10$export$dd0a697e1782aedd = ()=>{
    const { search: search } = (0, $kfZjc.useLocation)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>new URLSearchParams(search), [
        search
    ]);
};

});
parcelRegister("kfZjc", function(module, exports) {

$parcel$export(module.exports, "__RouterContext", () => $ebf4c3fe5600f7ed$export$63baa8ccbe60bb07);
$parcel$export(module.exports, "Router", () => $ebf4c3fe5600f7ed$export$55185c17a0fcbe46);
$parcel$export(module.exports, "MemoryRouter", () => $ebf4c3fe5600f7ed$export$ae46f04cfaffe093);
$parcel$export(module.exports, "Prompt", () => $ebf4c3fe5600f7ed$export$83716a4aa1642908);
$parcel$export(module.exports, "generatePath", () => $ebf4c3fe5600f7ed$export$82476f982757e71e);
$parcel$export(module.exports, "Redirect", () => $ebf4c3fe5600f7ed$export$2d8d895a0a0f636e);
$parcel$export(module.exports, "matchPath", () => $ebf4c3fe5600f7ed$export$81336c211d5ff295);
$parcel$export(module.exports, "Route", () => $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6);
$parcel$export(module.exports, "StaticRouter", () => $ebf4c3fe5600f7ed$export$cac06da4d76d935b);
$parcel$export(module.exports, "Switch", () => $ebf4c3fe5600f7ed$export$b5d5cf8927ab7262);
$parcel$export(module.exports, "withRouter", () => $ebf4c3fe5600f7ed$export$369b6b2b30582e8e);
$parcel$export(module.exports, "useHistory", () => $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c);
$parcel$export(module.exports, "useLocation", () => $ebf4c3fe5600f7ed$export$45d76561a5302f2b);
$parcel$export(module.exports, "useParams", () => $ebf4c3fe5600f7ed$export$99eaa27ddbbb95ef);
$parcel$export(module.exports, "useRouteMatch", () => $ebf4c3fe5600f7ed$export$632be4bb944c1bc7);

var $g7ajw = parcelRequire("g7ajw");

var $acw62 = parcelRequire("acw62");


var $3np4r = parcelRequire("3np4r");


var $82FDD = parcelRequire("82FDD");

var $bv4qN = parcelRequire("bv4qN");

var $8nd05 = parcelRequire("8nd05");

var $8ugx5 = parcelRequire("8ugx5");
parcelRequire("4jPKB");

var $1En50 = parcelRequire("1En50");

var $9ORqK = parcelRequire("9ORqK");
// TODO: Replace with React.createContext once we can assume React 16+
var $ebf4c3fe5600f7ed$var$createNamedContext = function createNamedContext(name) {
    var context = (0, $82FDD.default)();
    context.displayName = name;
    return context;
};
var $ebf4c3fe5600f7ed$export$c213558b66925821 = /*#__PURE__*/ $ebf4c3fe5600f7ed$var$createNamedContext("Router-History");
var $ebf4c3fe5600f7ed$export$63baa8ccbe60bb07 = /*#__PURE__*/ $ebf4c3fe5600f7ed$var$createNamedContext("Router");
/**
 * The public API for putting history on context.
 */ var $ebf4c3fe5600f7ed$export$55185c17a0fcbe46 = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(Router, _React$Component);
    Router.computeRootMatch = function computeRootMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    function Router(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            location: props.history.location
        }; // This is a bit of a hack. We have to start listening for location
        // changes here in the constructor in case there are any <Redirect>s
        // on the initial render. If there are, they will replace/push when
        // they mount and since cDM fires in children before parents, we may
        // get a new location before the <Router> is mounted.
        _this._isMounted = false;
        _this._pendingLocation = null;
        if (!props.staticContext) _this.unlisten = props.history.listen(function(location) {
            if (_this._isMounted) _this.setState({
                location: location
            });
            else _this._pendingLocation = location;
        });
        return _this;
    }
    var _proto = Router.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this._isMounted = true;
        if (this._pendingLocation) this.setState({
            location: this._pendingLocation
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.unlisten) {
            this.unlisten();
            this._isMounted = false;
            this._pendingLocation = null;
        }
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Provider, {
            value: {
                history: this.props.history,
                location: this.state.location,
                match: Router.computeRootMatch(this.state.location.pathname),
                staticContext: this.props.staticContext
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$c213558b66925821.Provider, {
            children: this.props.children || null,
            value: this.props.history
        }));
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
/**
 * The public API for a <Router> that stores location in memory.
 */ var $ebf4c3fe5600f7ed$export$ae46f04cfaffe093 = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(MemoryRouter, _React$Component);
    function MemoryRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $3np4r.createMemoryHistory)(_this.props);
        return _this;
    }
    var _proto = MemoryRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$55185c17a0fcbe46, {
            history: this.history,
            children: this.props.children
        });
    };
    return MemoryRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
var $ebf4c3fe5600f7ed$var$Lifecycle = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(Lifecycle, _React$Component);
    function Lifecycle() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Lifecycle.prototype;
    _proto.componentDidMount = function componentDidMount() {
        if (this.props.onMount) this.props.onMount.call(this, this);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.props.onUnmount) this.props.onUnmount.call(this, this);
    };
    _proto.render = function render() {
        return null;
    };
    return Lifecycle;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
/**
 * The public API for prompting the user before navigating away from a screen.
 */ function $ebf4c3fe5600f7ed$export$83716a4aa1642908(_ref) {
    var message = _ref.message, _ref$when = _ref.when, when = _ref$when === void 0 ? true : _ref$when;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $bv4qN.default)(false);
        if (!when || context.staticContext) return null;
        var method = context.history.block;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$var$Lifecycle, {
            onMount: function onMount(self) {
                self.release = method(message);
            },
            onUpdate: function onUpdate(self, prevProps) {
                if (prevProps.message !== message) {
                    self.release();
                    self.release = method(message);
                }
            },
            onUnmount: function onUnmount(self) {
                self.release();
            },
            message: message
        });
    });
}
var $ebf4c3fe5600f7ed$var$messageType;
var $ebf4c3fe5600f7ed$var$cache = {};
var $ebf4c3fe5600f7ed$var$cacheLimit = 10000;
var $ebf4c3fe5600f7ed$var$cacheCount = 0;
function $ebf4c3fe5600f7ed$var$compilePath(path) {
    if ($ebf4c3fe5600f7ed$var$cache[path]) return $ebf4c3fe5600f7ed$var$cache[path];
    var generator = (0, (/*@__PURE__*/$parcel$interopDefault($8ugx5))).compile(path);
    if ($ebf4c3fe5600f7ed$var$cacheCount < $ebf4c3fe5600f7ed$var$cacheLimit) {
        $ebf4c3fe5600f7ed$var$cache[path] = generator;
        $ebf4c3fe5600f7ed$var$cacheCount++;
    }
    return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */ function $ebf4c3fe5600f7ed$export$82476f982757e71e(path, params) {
    if (path === void 0) path = "/";
    if (params === void 0) params = {};
    return path === "/" ? path : $ebf4c3fe5600f7ed$var$compilePath(path)(params, {
        pretty: true
    });
}
/**
 * The public API for navigating programmatically with a component.
 */ function $ebf4c3fe5600f7ed$export$2d8d895a0a0f636e(_ref) {
    var computedMatch = _ref.computedMatch, to = _ref.to, _ref$push = _ref.push, push = _ref$push === void 0 ? false : _ref$push;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Consumer, null, function(context) {
        !context && (0, $bv4qN.default)(false);
        var history = context.history, staticContext = context.staticContext;
        var method = push ? history.push : history.replace;
        var location = (0, $3np4r.createLocation)(computedMatch ? typeof to === "string" ? $ebf4c3fe5600f7ed$export$82476f982757e71e(to, computedMatch.params) : (0, $8nd05.default)({}, to, {
            pathname: $ebf4c3fe5600f7ed$export$82476f982757e71e(to.pathname, computedMatch.params)
        }) : to); // When rendering in a static context,
        // set the new location immediately.
        if (staticContext) {
            method(location);
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$var$Lifecycle, {
            onMount: function onMount() {
                method(location);
            },
            onUpdate: function onUpdate(self, prevProps) {
                var prevLocation = (0, $3np4r.createLocation)(prevProps.to);
                if (!(0, $3np4r.locationsAreEqual)(prevLocation, (0, $8nd05.default)({}, location, {
                    key: prevLocation.key
                }))) method(location);
            },
            to: to
        });
    });
}
var $ebf4c3fe5600f7ed$var$cache$1 = {};
var $ebf4c3fe5600f7ed$var$cacheLimit$1 = 10000;
var $ebf4c3fe5600f7ed$var$cacheCount$1 = 0;
function $ebf4c3fe5600f7ed$var$compilePath$1(path, options) {
    var cacheKey = "" + options.end + options.strict + options.sensitive;
    var pathCache = $ebf4c3fe5600f7ed$var$cache$1[cacheKey] || ($ebf4c3fe5600f7ed$var$cache$1[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    var keys = [];
    var regexp = (0, (/*@__PURE__*/$parcel$interopDefault($8ugx5)))(path, keys, options);
    var result = {
        regexp: regexp,
        keys: keys
    };
    if ($ebf4c3fe5600f7ed$var$cacheCount$1 < $ebf4c3fe5600f7ed$var$cacheLimit$1) {
        pathCache[path] = result;
        $ebf4c3fe5600f7ed$var$cacheCount$1++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */ function $ebf4c3fe5600f7ed$export$81336c211d5ff295(pathname, options) {
    if (options === void 0) options = {};
    if (typeof options === "string" || Array.isArray(options)) options = {
        path: options
    };
    var _options = options, path = _options.path, _options$exact = _options.exact, exact = _options$exact === void 0 ? false : _options$exact, _options$strict = _options.strict, strict = _options$strict === void 0 ? false : _options$strict, _options$sensitive = _options.sensitive, sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
    var paths = [].concat(path);
    return paths.reduce(function(matched, path) {
        if (!path && path !== "") return null;
        if (matched) return matched;
        var _compilePath = $ebf4c3fe5600f7ed$var$compilePath$1(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        }), regexp = _compilePath.regexp, keys = _compilePath.keys;
        var match = regexp.exec(pathname);
        if (!match) return null;
        var url = match[0], values = match.slice(1);
        var isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === "/" && url === "" ? "/" : url,
            // the matched portion of the URL
            isExact: isExact,
            // whether or not we matched exactly
            params: keys.reduce(function(memo, key, index) {
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
function $ebf4c3fe5600f7ed$var$isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.count(children) === 0;
}
function $ebf4c3fe5600f7ed$var$evalChildrenDev(children, props, path) {
    var value = children(props);
    return value || null;
}
/**
 * The public API for matching a single path and rendering.
 */ var $ebf4c3fe5600f7ed$export$e7b0ac011bb776c6 = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(Route, _React$Component);
    function Route() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Route.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Consumer, null, function(context$1) {
            !context$1 && (0, $bv4qN.default)(false);
            var location = _this.props.location || context$1.location;
            var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
             : _this.props.path ? $ebf4c3fe5600f7ed$export$81336c211d5ff295(location.pathname, _this.props) : context$1.match;
            var props = (0, $8nd05.default)({}, context$1, {
                location: location,
                match: match
            });
            var _this$props = _this.props, children = _this$props.children, component = _this$props.component, render = _this$props.render; // Preact uses an empty array as children by
            // default, so use null if that's the case.
            if (Array.isArray(children) && $ebf4c3fe5600f7ed$var$isEmptyChildren(children)) children = null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Provider, {
                value: props
            }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
        });
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
function $ebf4c3fe5600f7ed$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $ebf4c3fe5600f7ed$var$addBasename(basename, location) {
    if (!basename) return location;
    return (0, $8nd05.default)({}, location, {
        pathname: $ebf4c3fe5600f7ed$var$addLeadingSlash(basename) + location.pathname
    });
}
function $ebf4c3fe5600f7ed$var$stripBasename(basename, location) {
    if (!basename) return location;
    var base = $ebf4c3fe5600f7ed$var$addLeadingSlash(basename);
    if (location.pathname.indexOf(base) !== 0) return location;
    return (0, $8nd05.default)({}, location, {
        pathname: location.pathname.substr(base.length)
    });
}
function $ebf4c3fe5600f7ed$var$createURL(location) {
    return typeof location === "string" ? location : (0, $3np4r.createPath)(location);
}
function $ebf4c3fe5600f7ed$var$staticHandler(methodName) {
    return function() {
        (0, $bv4qN.default)(false);
    };
}
function $ebf4c3fe5600f7ed$var$noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */ var $ebf4c3fe5600f7ed$export$cac06da4d76d935b = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(StaticRouter, _React$Component);
    function StaticRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.handlePush = function(location) {
            return _this.navigateTo(location, "PUSH");
        };
        _this.handleReplace = function(location) {
            return _this.navigateTo(location, "REPLACE");
        };
        _this.handleListen = function() {
            return $ebf4c3fe5600f7ed$var$noop;
        };
        _this.handleBlock = function() {
            return $ebf4c3fe5600f7ed$var$noop;
        };
        return _this;
    }
    var _proto = StaticRouter.prototype;
    _proto.navigateTo = function navigateTo(location, action) {
        var _this$props = this.props, _this$props$basename = _this$props.basename, basename = _this$props$basename === void 0 ? "" : _this$props$basename, _this$props$context = _this$props.context, context = _this$props$context === void 0 ? {} : _this$props$context;
        context.action = action;
        context.location = $ebf4c3fe5600f7ed$var$addBasename(basename, (0, $3np4r.createLocation)(location));
        context.url = $ebf4c3fe5600f7ed$var$createURL(context.location);
    };
    _proto.render = function render() {
        var _this$props2 = this.props, _this$props2$basename = _this$props2.basename, basename = _this$props2$basename === void 0 ? "" : _this$props2$basename, _this$props2$context = _this$props2.context, context = _this$props2$context === void 0 ? {} : _this$props2$context, _this$props2$location = _this$props2.location, location = _this$props2$location === void 0 ? "/" : _this$props2$location, rest = (0, $1En50.default)(_this$props2, [
            "basename",
            "context",
            "location"
        ]);
        var history = {
            createHref: function createHref(path) {
                return $ebf4c3fe5600f7ed$var$addLeadingSlash(basename + $ebf4c3fe5600f7ed$var$createURL(path));
            },
            action: "POP",
            location: $ebf4c3fe5600f7ed$var$stripBasename(basename, (0, $3np4r.createLocation)(location)),
            push: this.handlePush,
            replace: this.handleReplace,
            go: $ebf4c3fe5600f7ed$var$staticHandler("go"),
            goBack: $ebf4c3fe5600f7ed$var$staticHandler("goBack"),
            goForward: $ebf4c3fe5600f7ed$var$staticHandler("goForward"),
            listen: this.handleListen,
            block: this.handleBlock
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$55185c17a0fcbe46, (0, $8nd05.default)({}, rest, {
            history: history,
            staticContext: context
        }));
    };
    return StaticRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
/**
 * The public API for rendering the first <Route> that matches.
 */ var $ebf4c3fe5600f7ed$export$b5d5cf8927ab7262 = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(Switch, _React$Component);
    function Switch() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Switch.prototype;
    _proto.render = function render() {
        var _this = this;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $bv4qN.default)(false);
            var location = _this.props.location || context.location;
            var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
            // here because toArray adds keys to all child elements and we do not want
            // to trigger an unmount/remount for two <Route>s that render the same
            // component at different URLs.
            (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(_this.props.children, function(child) {
                if (match == null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(child)) {
                    element = child;
                    var path = child.props.path || child.props.from;
                    match = path ? $ebf4c3fe5600f7ed$export$81336c211d5ff295(location.pathname, (0, $8nd05.default)({}, child.props, {
                        path: path
                    })) : context.match;
                }
            });
            return match ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(element, {
                location: location,
                computedMatch: match
            }) : null;
        });
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
/**
 * A public higher-order component to access the imperative API
 */ function $ebf4c3fe5600f7ed$export$369b6b2b30582e8e(Component) {
    var displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
    var C = function C(props) {
        var wrappedComponentRef = props.wrappedComponentRef, remainingProps = (0, $1En50.default)(props, [
            "wrappedComponentRef"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07.Consumer, null, function(context) {
            !context && (0, $bv4qN.default)(false);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, (0, $8nd05.default)({}, remainingProps, context, {
                ref: wrappedComponentRef
            }));
        });
    };
    C.displayName = displayName;
    C.WrappedComponent = Component;
    return (0, (/*@__PURE__*/$parcel$interopDefault($9ORqK)))(C, Component);
}
var $ebf4c3fe5600f7ed$var$useContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext;
function $ebf4c3fe5600f7ed$export$3420e1dc2c4a518c() {
    return $ebf4c3fe5600f7ed$var$useContext($ebf4c3fe5600f7ed$export$c213558b66925821);
}
function $ebf4c3fe5600f7ed$export$45d76561a5302f2b() {
    return $ebf4c3fe5600f7ed$var$useContext($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07).location;
}
function $ebf4c3fe5600f7ed$export$99eaa27ddbbb95ef() {
    var match = $ebf4c3fe5600f7ed$var$useContext($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07).match;
    return match ? match.params : {};
}
function $ebf4c3fe5600f7ed$export$632be4bb944c1bc7(path) {
    var location = $ebf4c3fe5600f7ed$export$45d76561a5302f2b();
    var match = $ebf4c3fe5600f7ed$var$useContext($ebf4c3fe5600f7ed$export$63baa8ccbe60bb07).match;
    return path ? $ebf4c3fe5600f7ed$export$81336c211d5ff295(location.pathname, path) : match;
}
var $ebf4c3fe5600f7ed$var$global, $ebf4c3fe5600f7ed$var$key, $ebf4c3fe5600f7ed$var$buildNames, $ebf4c3fe5600f7ed$var$initialBuildName, $ebf4c3fe5600f7ed$var$secondaryBuildName;

});
parcelRegister("3np4r", function(module, exports) {

$parcel$export(module.exports, "createPath", () => $2756f79476f0245f$export$fe53371bee54353d);
$parcel$export(module.exports, "createLocation", () => $2756f79476f0245f$export$90c043f1c57770b8);
$parcel$export(module.exports, "locationsAreEqual", () => $2756f79476f0245f$export$c3e8bb440bd55b18);
$parcel$export(module.exports, "createBrowserHistory", () => $2756f79476f0245f$export$719fc203c4e16dee);
$parcel$export(module.exports, "createHashHistory", () => $2756f79476f0245f$export$b71fdd3798280242);
$parcel$export(module.exports, "createMemoryHistory", () => $2756f79476f0245f$export$2b76ad033c6e6d08);

var $8nd05 = parcelRequire("8nd05");

var $WYl7Q = parcelRequire("WYl7Q");

var $9t72y = parcelRequire("9t72y");


var $bv4qN = parcelRequire("bv4qN");
function $2756f79476f0245f$var$addLeadingSlash(path) {
    return path.charAt(0) === "/" ? path : "/" + path;
}
function $2756f79476f0245f$var$stripLeadingSlash(path) {
    return path.charAt(0) === "/" ? path.substr(1) : path;
}
function $2756f79476f0245f$var$hasBasename(path, prefix) {
    return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && "/?#".indexOf(path.charAt(prefix.length)) !== -1;
}
function $2756f79476f0245f$var$stripBasename(path, prefix) {
    return $2756f79476f0245f$var$hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function $2756f79476f0245f$var$stripTrailingSlash(path) {
    return path.charAt(path.length - 1) === "/" ? path.slice(0, -1) : path;
}
function $2756f79476f0245f$export$8ccf933b0513f8d0(path) {
    var pathname = path || "/";
    var search = "";
    var hash = "";
    var hashIndex = pathname.indexOf("#");
    if (hashIndex !== -1) {
        hash = pathname.substr(hashIndex);
        pathname = pathname.substr(0, hashIndex);
    }
    var searchIndex = pathname.indexOf("?");
    if (searchIndex !== -1) {
        search = pathname.substr(searchIndex);
        pathname = pathname.substr(0, searchIndex);
    }
    return {
        pathname: pathname,
        search: search === "?" ? "" : search,
        hash: hash === "#" ? "" : hash
    };
}
function $2756f79476f0245f$export$fe53371bee54353d(location) {
    var pathname = location.pathname, search = location.search, hash = location.hash;
    var path = pathname || "/";
    if (search && search !== "?") path += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") path += hash.charAt(0) === "#" ? hash : "#" + hash;
    return path;
}
function $2756f79476f0245f$export$90c043f1c57770b8(path, state, key, currentLocation) {
    var location;
    if (typeof path === "string") {
        // Two-arg form: push(path, state)
        location = $2756f79476f0245f$export$8ccf933b0513f8d0(path);
        location.state = state;
    } else {
        // One-arg form: push(location)
        location = (0, $8nd05.default)({}, path);
        if (location.pathname === undefined) location.pathname = "";
        if (location.search) {
            if (location.search.charAt(0) !== "?") location.search = "?" + location.search;
        } else location.search = "";
        if (location.hash) {
            if (location.hash.charAt(0) !== "#") location.hash = "#" + location.hash;
        } else location.hash = "";
        if (state !== undefined && location.state === undefined) location.state = state;
    }
    try {
        location.pathname = decodeURI(location.pathname);
    } catch (e) {
        if (e instanceof URIError) throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + "This is likely caused by an invalid percent-encoding.");
        else throw e;
    }
    if (key) location.key = key;
    if (currentLocation) {
        // Resolve incomplete/relative pathname relative to current location.
        if (!location.pathname) location.pathname = currentLocation.pathname;
        else if (location.pathname.charAt(0) !== "/") location.pathname = (0, $WYl7Q.default)(location.pathname, currentLocation.pathname);
    } else // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) location.pathname = "/";
    return location;
}
function $2756f79476f0245f$export$c3e8bb440bd55b18(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, $9t72y.default)(a.state, b.state);
}
function $2756f79476f0245f$var$createTransitionManager() {
    var prompt = null;
    function setPrompt(nextPrompt) {
        prompt = nextPrompt;
        return function() {
            if (prompt === nextPrompt) prompt = null;
        };
    }
    function confirmTransitionTo(location, action, getUserConfirmation, callback) {
        // TODO: If another transition starts while we're still confirming
        // the previous one, we may end up in a weird state. Figure out the
        // best way to handle this.
        if (prompt != null) {
            var result = typeof prompt === "function" ? prompt(location, action) : prompt;
            if (typeof result === "string") {
                if (typeof getUserConfirmation === "function") getUserConfirmation(result, callback);
                else callback(true);
            } else // Return false from a transition hook to cancel the transition.
            callback(result !== false);
        } else callback(true);
    }
    var listeners = [];
    function appendListener(fn) {
        var isActive = true;
        function listener() {
            if (isActive) fn.apply(void 0, arguments);
        }
        listeners.push(listener);
        return function() {
            isActive = false;
            listeners = listeners.filter(function(item) {
                return item !== listener;
            });
        };
    }
    function notifyListeners() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        listeners.forEach(function(listener) {
            return listener.apply(void 0, args);
        });
    }
    return {
        setPrompt: setPrompt,
        confirmTransitionTo: confirmTransitionTo,
        appendListener: appendListener,
        notifyListeners: notifyListeners
    };
}
var $2756f79476f0245f$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $2756f79476f0245f$var$getConfirmation(message, callback) {
    callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */ function $2756f79476f0245f$var$supportsHistory() {
    var ua = window.navigator.userAgent;
    if ((ua.indexOf("Android 2.") !== -1 || ua.indexOf("Android 4.0") !== -1) && ua.indexOf("Mobile Safari") !== -1 && ua.indexOf("Chrome") === -1 && ua.indexOf("Windows Phone") === -1) return false;
    return window.history && "pushState" in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */ function $2756f79476f0245f$var$supportsPopStateOnHashChange() {
    return window.navigator.userAgent.indexOf("Trident") === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */ function $2756f79476f0245f$var$supportsGoWithoutReloadUsingHash() {
    return window.navigator.userAgent.indexOf("Firefox") === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */ function $2756f79476f0245f$var$isExtraneousPopstateEvent(event) {
    return event.state === undefined && navigator.userAgent.indexOf("CriOS") === -1;
}
var $2756f79476f0245f$var$PopStateEvent = "popstate";
var $2756f79476f0245f$var$HashChangeEvent = "hashchange";
function $2756f79476f0245f$var$getHistoryState() {
    try {
        return window.history.state || {};
    } catch (e) {
        // IE 11 sometimes throws when accessing window.history.state
        // See https://github.com/ReactTraining/history/pull/289
        return {};
    }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */ function $2756f79476f0245f$export$719fc203c4e16dee(props) {
    if (props === void 0) props = {};
    !$2756f79476f0245f$var$canUseDOM && (0, $bv4qN.default)(false);
    var globalHistory = window.history;
    var canUseHistory = $2756f79476f0245f$var$supportsHistory();
    var needsHashChangeListener = !$2756f79476f0245f$var$supportsPopStateOnHashChange();
    var _props = props, _props$forceRefresh = _props.forceRefresh, forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $2756f79476f0245f$var$getConfirmation : _props$getUserConfirm, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var basename = props.basename ? $2756f79476f0245f$var$stripTrailingSlash($2756f79476f0245f$var$addLeadingSlash(props.basename)) : "";
    function getDOMLocation(historyState) {
        var _ref = historyState || {}, key = _ref.key, state = _ref.state;
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var path = pathname + search + hash;
        if (basename) path = $2756f79476f0245f$var$stripBasename(path, basename);
        return $2756f79476f0245f$export$90c043f1c57770b8(path, state, key);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var transitionManager = $2756f79476f0245f$var$createTransitionManager();
    function setState(nextState) {
        (0, $8nd05.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function handlePopState(event) {
        // Ignore extraneous popstate events in WebKit.
        if ($2756f79476f0245f$var$isExtraneousPopstateEvent(event)) return;
        handlePop(getDOMLocation(event.state));
    }
    function handleHashChange() {
        handlePop(getDOMLocation($2756f79476f0245f$var$getHistoryState()));
    }
    var forceNextPop = false;
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of keys we've seen in sessionStorage.
        // Instead, we just default to 0 for keys we don't know.
        var toIndex = allKeys.indexOf(toLocation.key);
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allKeys.indexOf(fromLocation.key);
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    }
    var initialLocation = getDOMLocation($2756f79476f0245f$var$getHistoryState());
    var allKeys = [
        initialLocation.key
    ]; // Public interface
    function createHref(location) {
        return basename + $2756f79476f0245f$export$fe53371bee54353d(location);
    }
    function push(path, state) {
        var action = "PUSH";
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.pushState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.href = href;
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    var nextKeys = allKeys.slice(0, prevIndex + 1);
                    nextKeys.push(location.key);
                    allKeys = nextKeys;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.href = href;
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var href = createHref(location);
            var key = location.key, state = location.state;
            if (canUseHistory) {
                globalHistory.replaceState({
                    key: key,
                    state: state
                }, null, href);
                if (forceRefresh) window.location.replace(href);
                else {
                    var prevIndex = allKeys.indexOf(history.location.key);
                    if (prevIndex !== -1) allKeys[prevIndex] = location.key;
                    setState({
                        action: action,
                        location: location
                    });
                }
            } else window.location.replace(href);
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) {
            window.addEventListener($2756f79476f0245f$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.addEventListener($2756f79476f0245f$var$HashChangeEvent, handleHashChange);
        } else if (listenerCount === 0) {
            window.removeEventListener($2756f79476f0245f$var$PopStateEvent, handlePopState);
            if (needsHashChangeListener) window.removeEventListener($2756f79476f0245f$var$HashChangeEvent, handleHashChange);
        }
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
var $2756f79476f0245f$var$HashChangeEvent$1 = "hashchange";
var $2756f79476f0245f$var$HashPathCoders = {
    hashbang: {
        encodePath: function encodePath(path) {
            return path.charAt(0) === "!" ? path : "!/" + $2756f79476f0245f$var$stripLeadingSlash(path);
        },
        decodePath: function decodePath(path) {
            return path.charAt(0) === "!" ? path.substr(1) : path;
        }
    },
    noslash: {
        encodePath: $2756f79476f0245f$var$stripLeadingSlash,
        decodePath: $2756f79476f0245f$var$addLeadingSlash
    },
    slash: {
        encodePath: $2756f79476f0245f$var$addLeadingSlash,
        decodePath: $2756f79476f0245f$var$addLeadingSlash
    }
};
function $2756f79476f0245f$var$stripHash(url) {
    var hashIndex = url.indexOf("#");
    return hashIndex === -1 ? url : url.slice(0, hashIndex);
}
function $2756f79476f0245f$var$getHashPath() {
    // We can't use window.location.hash here because it's not
    // consistent across browsers - Firefox will pre-decode it!
    var href = window.location.href;
    var hashIndex = href.indexOf("#");
    return hashIndex === -1 ? "" : href.substring(hashIndex + 1);
}
function $2756f79476f0245f$var$pushHashPath(path) {
    window.location.hash = path;
}
function $2756f79476f0245f$var$replaceHashPath(path) {
    window.location.replace($2756f79476f0245f$var$stripHash(window.location.href) + "#" + path);
}
function $2756f79476f0245f$export$b71fdd3798280242(props) {
    if (props === void 0) props = {};
    !$2756f79476f0245f$var$canUseDOM && (0, $bv4qN.default)(false);
    var globalHistory = window.history;
    var canGoWithoutReload = $2756f79476f0245f$var$supportsGoWithoutReloadUsingHash();
    var _props = props, _props$getUserConfirm = _props.getUserConfirmation, getUserConfirmation = _props$getUserConfirm === void 0 ? $2756f79476f0245f$var$getConfirmation : _props$getUserConfirm, _props$hashType = _props.hashType, hashType = _props$hashType === void 0 ? "slash" : _props$hashType;
    var basename = props.basename ? $2756f79476f0245f$var$stripTrailingSlash($2756f79476f0245f$var$addLeadingSlash(props.basename)) : "";
    var _HashPathCoders$hashT = $2756f79476f0245f$var$HashPathCoders[hashType], encodePath = _HashPathCoders$hashT.encodePath, decodePath = _HashPathCoders$hashT.decodePath;
    function getDOMLocation() {
        var path = decodePath($2756f79476f0245f$var$getHashPath());
        if (basename) path = $2756f79476f0245f$var$stripBasename(path, basename);
        return $2756f79476f0245f$export$90c043f1c57770b8(path);
    }
    var transitionManager = $2756f79476f0245f$var$createTransitionManager();
    function setState(nextState) {
        (0, $8nd05.default)(history, nextState);
        history.length = globalHistory.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    var forceNextPop = false;
    var ignorePath = null;
    function locationsAreEqual$$1(a, b) {
        return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
    }
    function handleHashChange() {
        var path = $2756f79476f0245f$var$getHashPath();
        var encodedPath = encodePath(path);
        if (path !== encodedPath) // Ensure we always have a properly-encoded hash.
        $2756f79476f0245f$var$replaceHashPath(encodedPath);
        else {
            var location = getDOMLocation();
            var prevLocation = history.location;
            if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.
            if (ignorePath === $2756f79476f0245f$export$fe53371bee54353d(location)) return; // Ignore this change; we already setState in push/replace.
            ignorePath = null;
            handlePop(location);
        }
    }
    function handlePop(location) {
        if (forceNextPop) {
            forceNextPop = false;
            setState();
        } else {
            var action = "POP";
            transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
                if (ok) setState({
                    action: action,
                    location: location
                });
                else revertPop(location);
            });
        }
    }
    function revertPop(fromLocation) {
        var toLocation = history.location; // TODO: We could probably make this more reliable by
        // keeping a list of paths we've seen in sessionStorage.
        // Instead, we just default to 0 for paths we don't know.
        var toIndex = allPaths.lastIndexOf($2756f79476f0245f$export$fe53371bee54353d(toLocation));
        if (toIndex === -1) toIndex = 0;
        var fromIndex = allPaths.lastIndexOf($2756f79476f0245f$export$fe53371bee54353d(fromLocation));
        if (fromIndex === -1) fromIndex = 0;
        var delta = toIndex - fromIndex;
        if (delta) {
            forceNextPop = true;
            go(delta);
        }
    } // Ensure the hash is encoded properly before doing anything else.
    var path = $2756f79476f0245f$var$getHashPath();
    var encodedPath = encodePath(path);
    if (path !== encodedPath) $2756f79476f0245f$var$replaceHashPath(encodedPath);
    var initialLocation = getDOMLocation();
    var allPaths = [
        $2756f79476f0245f$export$fe53371bee54353d(initialLocation)
    ]; // Public interface
    function createHref(location) {
        var baseTag = document.querySelector("base");
        var href = "";
        if (baseTag && baseTag.getAttribute("href")) href = $2756f79476f0245f$var$stripHash(window.location.href);
        return href + "#" + encodePath(basename + $2756f79476f0245f$export$fe53371bee54353d(location));
    }
    function push(path, state) {
        var action = "PUSH";
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $2756f79476f0245f$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $2756f79476f0245f$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a PUSH, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $2756f79476f0245f$var$pushHashPath(encodedPath);
                var prevIndex = allPaths.lastIndexOf($2756f79476f0245f$export$fe53371bee54353d(history.location));
                var nextPaths = allPaths.slice(0, prevIndex + 1);
                nextPaths.push(path);
                allPaths = nextPaths;
                setState({
                    action: action,
                    location: location
                });
            } else setState();
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, undefined, undefined, history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var path = $2756f79476f0245f$export$fe53371bee54353d(location);
            var encodedPath = encodePath(basename + path);
            var hashChanged = $2756f79476f0245f$var$getHashPath() !== encodedPath;
            if (hashChanged) {
                // We cannot tell if a hashchange was caused by a REPLACE, so we'd
                // rather setState here and ignore the hashchange. The caveat here
                // is that other hash histories in the page will consider it a POP.
                ignorePath = path;
                $2756f79476f0245f$var$replaceHashPath(encodedPath);
            }
            var prevIndex = allPaths.indexOf($2756f79476f0245f$export$fe53371bee54353d(history.location));
            if (prevIndex !== -1) allPaths[prevIndex] = path;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        globalHistory.go(n);
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    var listenerCount = 0;
    function checkDOMListeners(delta) {
        listenerCount += delta;
        if (listenerCount === 1 && delta === 1) window.addEventListener($2756f79476f0245f$var$HashChangeEvent$1, handleHashChange);
        else if (listenerCount === 0) window.removeEventListener($2756f79476f0245f$var$HashChangeEvent$1, handleHashChange);
    }
    var isBlocked = false;
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        var unblock = transitionManager.setPrompt(prompt);
        if (!isBlocked) {
            checkDOMListeners(1);
            isBlocked = true;
        }
        return function() {
            if (isBlocked) {
                isBlocked = false;
                checkDOMListeners(-1);
            }
            return unblock();
        };
    }
    function listen(listener) {
        var unlisten = transitionManager.appendListener(listener);
        checkDOMListeners(1);
        return function() {
            checkDOMListeners(-1);
            unlisten();
        };
    }
    var history = {
        length: globalHistory.length,
        action: "POP",
        location: initialLocation,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        block: block,
        listen: listen
    };
    return history;
}
function $2756f79476f0245f$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */ function $2756f79476f0245f$export$2b76ad033c6e6d08(props) {
    if (props === void 0) props = {};
    var _props = props, getUserConfirmation = _props.getUserConfirmation, _props$initialEntries = _props.initialEntries, initialEntries = _props$initialEntries === void 0 ? [
        "/"
    ] : _props$initialEntries, _props$initialIndex = _props.initialIndex, initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex, _props$keyLength = _props.keyLength, keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
    var transitionManager = $2756f79476f0245f$var$createTransitionManager();
    function setState(nextState) {
        (0, $8nd05.default)(history, nextState);
        history.length = history.entries.length;
        transitionManager.notifyListeners(history.location, history.action);
    }
    function createKey() {
        return Math.random().toString(36).substr(2, keyLength);
    }
    var index = $2756f79476f0245f$var$clamp(initialIndex, 0, initialEntries.length - 1);
    var entries = initialEntries.map(function(entry) {
        return typeof entry === "string" ? $2756f79476f0245f$export$90c043f1c57770b8(entry, undefined, createKey()) : $2756f79476f0245f$export$90c043f1c57770b8(entry, undefined, entry.key || createKey());
    }); // Public interface
    var createHref = $2756f79476f0245f$export$fe53371bee54353d;
    function push(path, state) {
        var action = "PUSH";
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            var prevIndex = history.index;
            var nextIndex = prevIndex + 1;
            var nextEntries = history.entries.slice(0);
            if (nextEntries.length > nextIndex) nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
            else nextEntries.push(location);
            setState({
                action: action,
                location: location,
                index: nextIndex,
                entries: nextEntries
            });
        });
    }
    function replace(path, state) {
        var action = "REPLACE";
        var location = $2756f79476f0245f$export$90c043f1c57770b8(path, state, createKey(), history.location);
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (!ok) return;
            history.entries[history.index] = location;
            setState({
                action: action,
                location: location
            });
        });
    }
    function go(n) {
        var nextIndex = $2756f79476f0245f$var$clamp(history.index + n, 0, history.entries.length - 1);
        var action = "POP";
        var location = history.entries[nextIndex];
        transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function(ok) {
            if (ok) setState({
                action: action,
                location: location,
                index: nextIndex
            });
            else // Mimic the behavior of DOM histories by
            // causing a render after a cancelled POP.
            setState();
        });
    }
    function goBack() {
        go(-1);
    }
    function goForward() {
        go(1);
    }
    function canGo(n) {
        var nextIndex = history.index + n;
        return nextIndex >= 0 && nextIndex < history.entries.length;
    }
    function block(prompt) {
        if (prompt === void 0) prompt = false;
        return transitionManager.setPrompt(prompt);
    }
    function listen(listener) {
        return transitionManager.appendListener(listener);
    }
    var history = {
        length: entries.length,
        action: "POP",
        location: entries[index],
        index: index,
        entries: entries,
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        goBack: goBack,
        goForward: goForward,
        canGo: canGo,
        block: block,
        listen: listen
    };
    return history;
}

});
parcelRegister("WYl7Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b14391bdc5d7d11$export$2e2bcd8739ae039);
function $0b14391bdc5d7d11$var$isAbsolute(pathname) {
    return pathname.charAt(0) === "/";
}
// About 1.5x faster than the two-arg version of Array#splice()
function $0b14391bdc5d7d11$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $0b14391bdc5d7d11$var$resolvePathname(to, from) {
    if (from === undefined) from = "";
    var toParts = to && to.split("/") || [];
    var fromParts = from && from.split("/") || [];
    var isToAbs = to && $0b14391bdc5d7d11$var$isAbsolute(to);
    var isFromAbs = from && $0b14391bdc5d7d11$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $0b14391bdc5d7d11$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return "/";
    var hasTrailingSlash;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === "." || last === ".." || last === "";
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === ".") $0b14391bdc5d7d11$var$spliceOne(fromParts, i);
        else if (part === "..") {
            $0b14391bdc5d7d11$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $0b14391bdc5d7d11$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift("..");
    if (mustEndAbs && fromParts[0] !== "" && (!fromParts[0] || !$0b14391bdc5d7d11$var$isAbsolute(fromParts[0]))) fromParts.unshift("");
    var result = fromParts.join("/");
    if (hasTrailingSlash && result.substr(-1) !== "/") result += "/";
    return result;
}
var $0b14391bdc5d7d11$export$2e2bcd8739ae039 = $0b14391bdc5d7d11$var$resolvePathname;

});

parcelRegister("9t72y", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e4c488965e5c6e8$export$2e2bcd8739ae039);
function $6e4c488965e5c6e8$var$valueOf(obj) {
    return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}
function $6e4c488965e5c6e8$var$valueEqual(a, b) {
    // Test for strict equality first.
    if (a === b) return true;
    // Otherwise, if either of them == null they are not equal.
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $6e4c488965e5c6e8$var$valueEqual(item, b[index]);
    });
    if (typeof a === "object" || typeof b === "object") {
        var aValue = $6e4c488965e5c6e8$var$valueOf(a);
        var bValue = $6e4c488965e5c6e8$var$valueOf(b);
        if (aValue !== a || bValue !== b) return $6e4c488965e5c6e8$var$valueEqual(aValue, bValue);
        return Object.keys(Object.assign({}, a, b)).every(function(key) {
            return $6e4c488965e5c6e8$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $6e4c488965e5c6e8$export$2e2bcd8739ae039 = $6e4c488965e5c6e8$var$valueEqual;

});


parcelRegister("82FDD", function(module, exports) {

$parcel$export(module.exports, "default", () => $5daecf22ac820441$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $g7ajw = parcelRequire("g7ajw");

var $c9Z8w = parcelRequire("c9Z8w");

var $5daecf22ac820441$var$MAX_SIGNED_31_BIT_INT = 1073741823;
var $5daecf22ac820441$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {};
function $5daecf22ac820441$var$getUniqueId() {
    var key = "__global_unique_id__";
    return $5daecf22ac820441$var$commonjsGlobal[key] = ($5daecf22ac820441$var$commonjsGlobal[key] || 0) + 1;
}
function $5daecf22ac820441$var$objectIs(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $5daecf22ac820441$var$createEventEmitter(value) {
    var handlers = [];
    return {
        on: function on(handler) {
            handlers.push(handler);
        },
        off: function off(handler) {
            handlers = handlers.filter(function(h) {
                return h !== handler;
            });
        },
        get: function get() {
            return value;
        },
        set: function set(newValue, changedBits) {
            value = newValue;
            handlers.forEach(function(handler) {
                return handler(value, changedBits);
            });
        }
    };
}
function $5daecf22ac820441$var$onlyChild(children) {
    return Array.isArray(children) ? children[0] : children;
}
function $5daecf22ac820441$var$createReactContext(defaultValue, calculateChangedBits) {
    var _Provider$childContex, _Consumer$contextType;
    var contextProp = "__create-react-context-" + $5daecf22ac820441$var$getUniqueId() + "__";
    var Provider = /*#__PURE__*/ function(_Component) {
        (0, $g7ajw.default)(Provider, _Component);
        function Provider() {
            var _this;
            _this = _Component.apply(this, arguments) || this;
            _this.emitter = $5daecf22ac820441$var$createEventEmitter(_this.props.value);
            return _this;
        }
        var _proto = Provider.prototype;
        _proto.getChildContext = function getChildContext() {
            var _ref;
            return _ref = {}, _ref[contextProp] = this.emitter, _ref;
        };
        _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            if (this.props.value !== nextProps.value) {
                var oldValue = this.props.value;
                var newValue = nextProps.value;
                var changedBits;
                if ($5daecf22ac820441$var$objectIs(oldValue, newValue)) changedBits = 0;
                else {
                    changedBits = typeof calculateChangedBits === "function" ? calculateChangedBits(oldValue, newValue) : $5daecf22ac820441$var$MAX_SIGNED_31_BIT_INT;
                    changedBits |= 0;
                    if (changedBits !== 0) this.emitter.set(nextProps.value, changedBits);
                }
            }
        };
        _proto.render = function render() {
            return this.props.children;
        };
        return Provider;
    }((0, $acw62.Component));
    Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object.isRequired, _Provider$childContex);
    var Consumer = /*#__PURE__*/ function(_Component2) {
        (0, $g7ajw.default)(Consumer, _Component2);
        function Consumer() {
            var _this2;
            _this2 = _Component2.apply(this, arguments) || this;
            _this2.state = {
                value: _this2.getValue()
            };
            _this2.onUpdate = function(newValue, changedBits) {
                var observedBits = _this2.observedBits | 0;
                if ((observedBits & changedBits) !== 0) _this2.setState({
                    value: _this2.getValue()
                });
            };
            return _this2;
        }
        var _proto2 = Consumer.prototype;
        _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var observedBits = nextProps.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $5daecf22ac820441$var$MAX_SIGNED_31_BIT_INT : observedBits;
        };
        _proto2.componentDidMount = function componentDidMount() {
            if (this.context[contextProp]) this.context[contextProp].on(this.onUpdate);
            var observedBits = this.props.observedBits;
            this.observedBits = observedBits === undefined || observedBits === null ? $5daecf22ac820441$var$MAX_SIGNED_31_BIT_INT : observedBits;
        };
        _proto2.componentWillUnmount = function componentWillUnmount() {
            if (this.context[contextProp]) this.context[contextProp].off(this.onUpdate);
        };
        _proto2.getValue = function getValue() {
            if (this.context[contextProp]) return this.context[contextProp].get();
            else return defaultValue;
        };
        _proto2.render = function render() {
            return $5daecf22ac820441$var$onlyChild(this.props.children)(this.state.value);
        };
        return Consumer;
    }((0, $acw62.Component));
    Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object, _Consumer$contextType);
    return {
        Provider: Provider,
        Consumer: Consumer
    };
}
var $5daecf22ac820441$var$index = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext || $5daecf22ac820441$var$createReactContext;
var $5daecf22ac820441$export$2e2bcd8739ae039 = $5daecf22ac820441$var$index;

});

parcelRegister("8ugx5", function(module, exports) {

var $a0lxx = parcelRequire("a0lxx");
/**
 * Expose `pathToRegexp`.
 */ module.exports = $62ddf3174d9df941$var$pathToRegexp;
module.exports.parse = $62ddf3174d9df941$var$parse;
module.exports.compile = $62ddf3174d9df941$var$compile;
module.exports.tokensToFunction = $62ddf3174d9df941$var$tokensToFunction;
module.exports.tokensToRegExp = $62ddf3174d9df941$var$tokensToRegExp;
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $62ddf3174d9df941$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    "(\\\\.)",
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
    // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
    // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
    "([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))"
].join("|"), "g");
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $62ddf3174d9df941$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = "";
    var defaultDelimiter = options && options.delimiter || "/";
    var res;
    while((res = $62ddf3174d9df941$var$PATH_REGEXP.exec(str)) != null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            continue;
        }
        var next = str[index];
        var prefix = res[2];
        var name = res[3];
        var capture = res[4];
        var group = res[5];
        var modifier = res[6];
        var asterisk = res[7];
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = "";
        }
        var partial = prefix != null && next != null && next !== prefix;
        var repeat = modifier === "+" || modifier === "*";
        var optional = modifier === "?" || modifier === "*";
        var delimiter = res[2] || defaultDelimiter;
        var pattern = capture || group;
        tokens.push({
            name: name || key++,
            prefix: prefix || "",
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            partial: partial,
            asterisk: !!asterisk,
            pattern: pattern ? $62ddf3174d9df941$var$escapeGroup(pattern) : asterisk ? ".*" : "[^" + $62ddf3174d9df941$var$escapeString(delimiter) + "]+?"
        });
    }
    // Match any characters still remaining.
    if (index < str.length) path += str.substr(index);
    // If the path exists, push it onto the end.
    if (path) tokens.push(path);
    return tokens;
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $62ddf3174d9df941$var$compile(str, options) {
    return $62ddf3174d9df941$var$tokensToFunction($62ddf3174d9df941$var$parse(str, options), options);
}
/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */ function $62ddf3174d9df941$var$encodeURIComponentPretty(str) {
    return encodeURI(str).replace(/[\/?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */ function $62ddf3174d9df941$var$encodeAsterisk(str) {
    return encodeURI(str).replace(/[?#]/g, function(c) {
        return "%" + c.charCodeAt(0).toString(16).toUpperCase();
    });
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $62ddf3174d9df941$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === "object") matches[i] = new RegExp("^(?:" + tokens[i].pattern + ")$", $62ddf3174d9df941$var$flags(options));
    return function(obj, opts) {
        var path = "";
        var data = obj || {};
        var options = opts || {};
        var encode = options.pretty ? $62ddf3174d9df941$var$encodeURIComponentPretty : encodeURIComponent;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data[token.name];
            var segment;
            if (value == null) {
                if (token.optional) {
                    // Prepend partial segment prefixes.
                    if (token.partial) path += token.prefix;
                    continue;
                } else throw new TypeError('Expected "' + token.name + '" to be defined');
            }
            if ($a0lxx(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + "`");
                if (value.length === 0) {
                    if (token.optional) continue;
                    else throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j]);
                    if (!matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + "`");
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            segment = token.asterisk ? $62ddf3174d9df941$var$encodeAsterisk(value) : encode(value);
            if (!matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
            path += token.prefix + segment;
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $62ddf3174d9df941$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, "\\$1");
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $62ddf3174d9df941$var$escapeGroup(group) {
    return group.replace(/([=!:$\/()])/g, "\\$1");
}
/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$attachKeys(re, keys) {
    re.keys = keys;
    return re;
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $62ddf3174d9df941$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$regexpToRegexp(path, keys) {
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
    });
    return $62ddf3174d9df941$var$attachKeys(path, keys);
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($62ddf3174d9df941$var$pathToRegexp(path[i], keys, options).source);
    var regexp = new RegExp("(?:" + parts.join("|") + ")", $62ddf3174d9df941$var$flags(options));
    return $62ddf3174d9df941$var$attachKeys(regexp, keys);
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$stringToRegexp(path, keys, options) {
    return $62ddf3174d9df941$var$tokensToRegExp($62ddf3174d9df941$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$tokensToRegExp(tokens, keys, options) {
    if (!$a0lxx(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    var strict = options.strict;
    var end = options.end !== false;
    var route = "";
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === "string") route += $62ddf3174d9df941$var$escapeString(token);
        else {
            var prefix = $62ddf3174d9df941$var$escapeString(token.prefix);
            var capture = "(?:" + token.pattern + ")";
            keys.push(token);
            if (token.repeat) capture += "(?:" + prefix + capture + ")*";
            if (token.optional) {
                if (!token.partial) capture = "(?:" + prefix + "(" + capture + "))?";
                else capture = prefix + "(" + capture + ")?";
            } else capture = prefix + "(" + capture + ")";
            route += capture;
        }
    }
    var delimiter = $62ddf3174d9df941$var$escapeString(options.delimiter || "/");
    var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;
    // In non-strict mode we allow a slash at the end of match. If the path to
    // match already ends with a slash, we remove it for consistency. The slash
    // is valid at the end of a path match, not in the middle. This is important
    // in non-ending mode, where "/test/" shouldn't match "/test//route".
    if (!strict) route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + "(?:" + delimiter + "(?=$))?";
    if (end) route += "$";
    else // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? "" : "(?=" + delimiter + "|$)";
    return $62ddf3174d9df941$var$attachKeys(new RegExp("^" + route, $62ddf3174d9df941$var$flags(options)), keys);
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $62ddf3174d9df941$var$pathToRegexp(path, keys, options) {
    if (!$a0lxx(keys)) {
        options = /** @type {!Object} */ keys || options;
        keys = [];
    }
    options = options || {};
    if (path instanceof RegExp) return $62ddf3174d9df941$var$regexpToRegexp(path, /** @type {!Array} */ keys);
    if ($a0lxx(path)) return $62ddf3174d9df941$var$arrayToRegexp(/** @type {!Array} */ path, /** @type {!Array} */ keys, options);
    return $62ddf3174d9df941$var$stringToRegexp(/** @type {string} */ path, /** @type {!Array} */ keys, options);
}

});
parcelRegister("a0lxx", function(module, exports) {
module.exports = Array.isArray || function(arr) {
    return Object.prototype.toString.call(arr) == "[object Array]";
};

});




parcelRegister("3etjB", function(module, exports) {

$parcel$export(module.exports, "marketShareTerms", () => $25a96b4e97f399d4$export$34912999f6279d4f);
$parcel$export(module.exports, "EXCLUDED_ROWS", () => $25a96b4e97f399d4$export$5f294f6487fe20df);
$parcel$export(module.exports, "listingsBreakdownKeys", () => $25a96b4e97f399d4$export$149f3b85c1d947ce);
$parcel$export(module.exports, "showHideTypes", () => $25a96b4e97f399d4$export$b1f10292eb48f55d);
$parcel$export(module.exports, "searchTypes", () => $25a96b4e97f399d4$export$a9dcd9c91ec8ed8e);
$parcel$export(module.exports, "listingTypes", () => $25a96b4e97f399d4$export$af4579fe640a0414);
$parcel$export(module.exports, "coverageTransforms", () => $25a96b4e97f399d4$export$3a17583b2df696b8);
$parcel$export(module.exports, "dataPoints", () => $25a96b4e97f399d4$export$8076301b701f81a5);
$parcel$export(module.exports, "gridGroups", () => $25a96b4e97f399d4$export$c42bcaef2446752e);
$parcel$export(module.exports, "msTableViewNames", () => $25a96b4e97f399d4$export$9a61b57545fced0c);
$parcel$export(module.exports, "exportFilenameTemplates", () => $25a96b4e97f399d4$export$b02d86cbb3d565d5);


var $cstaF = parcelRequire("cstaF");

var $94cVo = parcelRequire("94cVo");

var $i95vK = parcelRequire("i95vK");

var $jUjGS = parcelRequire("jUjGS");
const $25a96b4e97f399d4$export$34912999f6279d4f = Object.freeze({
    maxReached: "Maximum number of rows has been reached.",
    MAX_ROWS_ARE_SELECTED: "MAX_ROWS_ARE_SELECTED",
    totals: "Totals",
    coverage: "Coverage",
    byOffice: "By Office",
    byBrokerage: "By Brokerage",
    byComparisonSet: "By Comparison Set",
    rankedBy: "Ranked by",
    total$Volume: "Total $ Volume",
    totalNumUnits: "Total # Units",
    listSide$Volume: "List Side $ Volume",
    listSideNumUnits: "List Side # Units",
    sellSide$Volume: "Sell Side $ Volume",
    sellSideNumUnits: "Sell Side # Units",
    underContract$: "Under Contract ($)",
    underContractVolume: "Under Contract $",
    underContractNum: "Under Contract (#)",
    underContractUnits: "Under Contract #",
    underContract$Volume: "Total $ Under Contract",
    underContractNumUnits: "Total # Under Contract",
    newListing$Volume: "Total $ New Listings",
    newListingNumUnits: "Total # New Listings",
    newListing$: "New ($)",
    newListingNum: "New (#)",
    newListingVolume: "New Listings $",
    newListingUnits: "New Listings #",
    forSale$Volume: "Total $ For Sale",
    forSaleNumUnits: "Total # For Sale",
    coverageForSale$Volume: "$ Volume For Sale",
    coverageForSaleNumUnits: "# Units For Sale",
    forSale$: "For Sale ($)",
    forSaleNum: "For Sale (#)",
    forSaleVolume: "For Sale $",
    forSaleUnits: "For Sale #",
    mlsIds: "MLS IDs",
    type: "Type",
    status: "Status",
    onlyShowSelectedOffices: "Only Show Selected Offices",
    onlyShowSelectedBrokerages: "Only Show Selected Brokerages",
    onlyShowSelectedAreas: "Only Show Selected Areas",
    onlyShowSelectedGroups: "Only Show Selected Groups",
    chart: "Chart",
    additionalInfo: "Additional Information",
    state: "State",
    phone: "Phone",
    address: "Address",
    marketSharePct: "Market Share %",
    mkt: "Mkt",
    marketShare: "Market Share",
    noRowsSelected: "Please select a checkbox on the table below to view your chart data",
    dom: "DOM",
    averagePrice: "Average Price",
    avgPrice: "Avg Price",
    unitsPerProducingAgent: "Units per Producing Agent",
    volumePerProducingAgent: "Volume per Producing Agent",
    producingAgents: "Producing Agents",
    numOfOffices: "# of Offices",
    metrics: "Metrics",
    spOp: "SP/OP",
    spOpPct: "SP/OP %",
    spLp: "SP/LP %",
    closedToList: "Closed-to-List",
    clr: "C/L",
    clrPct: "C/L %",
    getSearchSubtitle: (title)=>`${title}`,
    noListingRowsToShow: (listing)=>`No ${listing} Listings Found`,
    area: "Area",
    list$: "List ($)",
    listSideVolume: "List Side $ Volume",
    list$Volume: "List $ Volume",
    listNum: "List (#)",
    listSideUnit: "List Side # Unit",
    listNumUnits: "List # Units",
    sell$: "Sell ($)",
    sellSideVolume: "Sell Side $ Volume",
    sell$Volume: "Sell $ Volume",
    sellNum: "Sell (#)",
    sellSideUnit: "Sell Side # Unit",
    sellNumUnits: "Sell # Units",
    side: "Side",
    total$: "Total ($)",
    totalNum: "Total (#)",
    total: "Total",
    mktPct: "Mkt %",
    unitPct: "Units %",
    volumePct: "$ Volume %",
    avg$: "Avg $",
    prodAgentUnits: "# PPA",
    prodAgentVolume: "$ PPA",
    prodAgentCount: "P.Agts",
    prodAgents: "Prod Agents",
    prodAgentsCurrentSearch: "Prod Agents (Current Search)",
    rank: "Rank",
    isSelected: "Is Selected",
    office: "Office",
    officeId: "Office ID",
    officeName: "Office Name",
    listingView: "Listing View",
    listingType: "Listing Type",
    listingBreakdown: "Listing Breakdown",
    officeBreakdown: "Office Breakdown",
    searchFilterAdjust: "Please adjust your search filters to find offices/brokerages you're looking for",
    searchFilterAdjustCoverage: "Please adjust your search filters to find the Area Coverage you're looking for",
    listOfficeId: "List Office ID",
    sellOfficeId: "Sell Office ID",
    group: "Group",
    allOther: "All Other"
});
const $25a96b4e97f399d4$export$5f294f6487fe20df = [
    $25a96b4e97f399d4$export$34912999f6279d4f.allOther
];
const $25a96b4e97f399d4$export$d06807ea653a3b0a = {
    soldBothSides: "Total Sold List + Sell",
    soldListSide: "Sold List Side",
    soldSellSide: "Sold Sell Side",
    officeDetails: "Office Details"
};
const $25a96b4e97f399d4$export$149f3b85c1d947ce = {
    officeDetails: "officeDetails",
    newListings: "newListings"
};
const $25a96b4e97f399d4$export$b1f10292eb48f55d = Object.freeze({
    onlyShowSelectedOffices: {
        id: "onlyShowSelectedOffices",
        label: (0, $25a96b4e97f399d4$export$34912999f6279d4f).onlyShowSelectedOffices
    },
    onlyShowSelectedBrokerages: {
        id: "onlyShowSelectedBrokerages",
        label: (0, $25a96b4e97f399d4$export$34912999f6279d4f).onlyShowSelectedBrokerages
    },
    onlyShowSelectedAreas: {
        id: "onlyShowSelectedAreas",
        label: (0, $25a96b4e97f399d4$export$34912999f6279d4f).onlyShowSelectedAreas
    },
    onlyShowSelectedGroups: {
        id: "onlyShowSelectedGroups",
        label: (0, $25a96b4e97f399d4$export$34912999f6279d4f).onlyShowSelectedGroups
    },
    chart: {
        id: "chart",
        label: (0, $25a96b4e97f399d4$export$34912999f6279d4f).chart
    }
});
const $25a96b4e97f399d4$export$a9dcd9c91ec8ed8e = Object.freeze({
    soldBothSides: "SoldBothSides",
    soldListSide: "SoldListSide",
    soldSellSide: "SoldSellSide",
    forSale: "ForSale",
    underContract: "UnderContract",
    newListings: "New"
});
const $25a96b4e97f399d4$export$af4579fe640a0414 = Object.freeze({
    byOffice: {
        id: "byOffice",
        label: (0, $25a96b4e97f399d4$export$34912999f6279d4f).byOffice,
        collectionKey: "offices",
        yAxisLabelMapper: (d)=>d["officeName"],
        getTransformData: (stats, sortField)=>{
            return ({ offices: offices })=>(0, $94cVo.transformData)(offices, stats, sortField, false);
        },
        defaultShowHideOptions: [
            {
                ...$25a96b4e97f399d4$export$b1f10292eb48f55d.onlyShowSelectedOffices,
                hide: true
            },
            {
                ...$25a96b4e97f399d4$export$b1f10292eb48f55d.chart,
                isDefault: true
            }
        ]
    },
    byBrokerage: {
        id: "byBrokerage",
        label: (0, $25a96b4e97f399d4$export$34912999f6279d4f).byBrokerage,
        collectionKey: "brokers",
        yAxisLabelMapper: (d)=>d["brokerName"],
        getTransformData: (stats, sortField)=>{
            return ({ brokers: brokers })=>(0, $94cVo.transformData)(brokers, stats, sortField, false);
        },
        defaultShowHideOptions: [
            {
                ...$25a96b4e97f399d4$export$b1f10292eb48f55d.onlyShowSelectedBrokerages,
                hide: true
            },
            {
                ...$25a96b4e97f399d4$export$b1f10292eb48f55d.chart,
                isDefault: true
            }
        ]
    },
    comparisonSet: {
        id: "comparisonSet",
        label: (0, $cstaF.searchTerms).comparisonSet,
        collectionKey: "comparisonSetData",
        yAxisLabelMapper: (d)=>d["groupName"],
        getTransformData: (stats, sortField)=>{
            return ({ comparisonSetData: comparisonSetData })=>(0, $94cVo.transformData)(comparisonSetData, stats, sortField, false);
        },
        defaultShowHideOptions: [
            {
                ...$25a96b4e97f399d4$export$b1f10292eb48f55d.onlyShowSelectedGroups,
                hide: true
            },
            {
                ...$25a96b4e97f399d4$export$b1f10292eb48f55d.chart,
                isDefault: true
            }
        ]
    }
});
const $25a96b4e97f399d4$export$3a17583b2df696b8 = Object.freeze({
    getTransformData: (sumOfColumn, sortField)=>{
        return ({ data: data })=>(0, $94cVo.transformData)(data, sumOfColumn, sortField, true);
    }
});
const $25a96b4e97f399d4$export$8076301b701f81a5 = {
    FOR_SALE_VOLUME: {
        dataMapper: (d)=>d.actVolume,
        color: (0, $jUjGS.COLOR_PRIMARY_GREEN),
        label: (0, $cstaF.marketShareListingStatuses).ForSale
    },
    FOR_SALE_UNITS: {
        dataMapper: (d)=>d.actUnits,
        color: (0, $jUjGS.COLOR_PRIMARY_GREEN),
        label: (0, $cstaF.marketShareListingStatuses).ForSale
    },
    UNDER_CONTRACT_VOLUME: {
        dataMapper: (d)=>d.ucVolume,
        color: (0, $jUjGS.COLOR_PRIMARY_GREEN),
        label: (0, $cstaF.marketShareListingStatuses).UnderContract
    },
    UNDER_CONTRACT_UNITS: {
        dataMapper: (d)=>d.ucUnits,
        color: (0, $jUjGS.COLOR_PRIMARY_GREEN),
        label: (0, $cstaF.marketShareListingStatuses).UnderContract
    },
    SOLD_LIST_SIDE_VOLUME: {
        dataMapper: (d)=>d.listVolume,
        color: (0, $jUjGS.COLOR_PRIMARY_GREEN),
        label: (0, $cstaF.marketShareListingStatuses).SoldListSide
    },
    SOLD_SELL_SIDE_VOLUME: {
        dataMapper: (d)=>d.sellVolume,
        color: (0, $jUjGS.COLOR_PRIMARY_GREEN),
        label: (0, $cstaF.marketShareListingStatuses).SoldSellSide
    },
    TOTAL_SOLD_SELL_SIDE_VOLUME: {
        dataMapper: (d)=>d.sellVolume,
        color: (0, $jUjGS.COLOR_SECONDARY_GREEN),
        label: (0, $cstaF.marketShareListingStatuses).SoldSellSide
    },
    NEW_LISTING_VOLUME: {
        dataMapper: (d)=>d.newListVolume,
        color: (0, $jUjGS.COLOR_PRIMARY_GREEN),
        label: (0, $cstaF.marketShareListingStatuses).New
    },
    NEW_LISTING_UNITS: {
        dataMapper: (d)=>d.newListUnits,
        color: (0, $jUjGS.COLOR_PRIMARY_GREEN),
        label: (0, $cstaF.marketShareListingStatuses).New
    },
    SOLD_LIST_SIDE_UNITS: {
        dataMapper: (d)=>d.listUnits,
        color: (0, $jUjGS.COLOR_PRIMARY_GREEN),
        label: (0, $cstaF.marketShareListingStatuses).SoldListSide
    },
    SOLD_SELL_SIDE_UNITS: {
        dataMapper: (d)=>d.sellUnits,
        color: (0, $jUjGS.COLOR_PRIMARY_GREEN),
        label: (0, $cstaF.marketShareListingStatuses).SoldSellSide
    },
    TOTAL_SOLD_SELL_SIDE_UNITS: {
        dataMapper: (d)=>d.sellUnits,
        color: (0, $jUjGS.COLOR_SECONDARY_GREEN),
        label: (0, $cstaF.marketShareListingStatuses).SoldSellSide
    }
};
const $25a96b4e97f399d4$export$c42bcaef2446752e = Object.freeze({
    ADDRESS: "address"
});
const $25a96b4e97f399d4$export$9a61b57545fced0c = Object.freeze({
    totals: "marketShareTotals",
    toverage: "marketShareCoverage"
});
const $25a96b4e97f399d4$export$b02d86cbb3d565d5 = {
    officeBreakdown: `${(0, $i95vK.fieldMarkers).OWNER}'s ${(0, $i95vK.fieldMarkers).LISTING_TYPE} Office Breakdown`,
    listingBreakdown: `${(0, $i95vK.fieldMarkers).OWNER}'s ${(0, $i95vK.fieldMarkers).LISTING_TYPE} Listings Breakdown`,
    totals: `Market Share's ${(0, $i95vK.fieldMarkers).SEARCH_TYPE} for ${(0, $i95vK.fieldMarkers).LISTING_STATUS_FILTER} - ${(0, $i95vK.fieldMarkers).LISTING_TYPE} Export - ${(0, $i95vK.fieldMarkers).DATE}`,
    coverage: `Market Share's ${(0, $i95vK.fieldMarkers).SEARCH_TYPE} for ${(0, $i95vK.fieldMarkers).LISTING_STATUS_FILTER} Export - ${(0, $i95vK.fieldMarkers).DATE}`,
    marketDynamicsSearch: `Market Dynamics ${(0, $i95vK.fieldMarkers).LISTING_VIEW} - Export - ${(0, $i95vK.fieldMarkers).DATE}`,
    marketDynamicsOfficeBreakdown: `Market Dynamics Office Breakdown for ${(0, $i95vK.fieldMarkers).LISTING_TYPE} - ${(0, $i95vK.fieldMarkers).DATE}`,
    agentDetails: `${(0, $i95vK.fieldMarkers).AGENT_NAME} ${(0, $i95vK.fieldMarkers).TAB_LABEL} in ${(0, $i95vK.fieldMarkers).MLS_NAME} for ${(0, $i95vK.fieldMarkers).PERIOD}`
};

});
parcelRegister("i95vK", function(module, exports) {

$parcel$export(module.exports, "fieldMarkers", () => $d35d579ebdc8d690$export$1dbe2092be842ff2);
$parcel$export(module.exports, "exportButtonTypes", () => $d35d579ebdc8d690$export$1d1cd8146caf7a70);
const $d35d579ebdc8d690$export$1dbe2092be842ff2 = Object.freeze({
    SEARCH_TYPE: "SEARCH_TYPE",
    LISTING_STATUS_FILTER: "LISTING_STATUS_FILTER",
    LISTING_TYPE: "LISTING_TYPE",
    DATE: "DATE",
    OWNER: "OWNER",
    OFFICE: "OFFICE",
    AM_BREAKDOWN_TAB: "BREAKDOWN_TAB",
    FROM_OR_TO: "FROM_OR_TO",
    AGENT_NAME: "AGENT_NAME",
    TAB_LABEL: "TAB_LABEL",
    PERIOD: "PERIOD",
    MLS_NAME: "MLS_NAME"
});
const $d35d579ebdc8d690$export$1d1cd8146caf7a70 = {
    primary: "primary",
    secondary: "secondary"
};

});


parcelRegister("c3iqc", function(module, exports) {

$parcel$export(module.exports, "marketShareColumns", () => $ee56b6c07fd4e61f$export$d81c93ea219bd8b8);

var $cstaF = parcelRequire("cstaF");

var $3etjB = parcelRequire("3etjB");
const $ee56b6c07fd4e61f$export$d81c93ea219bd8b8 = Object.freeze({
    officeId: {
        id: "officeId",
        label: (0, $cstaF.agentProductionTerms).officeId
    },
    officeName: {
        id: "officeName",
        label: (0, $3etjB.marketShareTerms).office
    },
    address: {
        id: "address",
        label: (0, $cstaF.agentProductionTerms).address
    },
    underContractVolume: {
        id: "ucVolume",
        label: (0, $3etjB.marketShareTerms).underContract$Volume
    },
    ucVolumeAlt: {
        id: "ucVolumeAlt",
        label: (0, $3etjB.marketShareTerms).underContract$Volume,
        keyField: "volume"
    },
    underContractUnits: {
        id: "ucUnits",
        label: (0, $3etjB.marketShareTerms).underContractNumUnits
    },
    ucUnitsAlt: {
        id: "ucUnitsAlt",
        label: (0, $3etjB.marketShareTerms).underContractNumUnits,
        keyField: "units"
    },
    streetName1: {
        id: "streetName1",
        label: (0, $cstaF.agentProductionTerms).address
    },
    streetName: {
        id: "streetName",
        label: (0, $cstaF.agentProductionTerms).street
    },
    streetNum: {
        id: "streetNum",
        label: (0, $cstaF.agentProductionTerms).stNumber
    },
    newListingVolume: {
        id: "newListVolume",
        label: (0, $3etjB.marketShareTerms).newListing$
    },
    newVolume: {
        id: "newVolume",
        label: (0, $3etjB.marketShareTerms).newListing$,
        keyField: "volume"
    },
    newListingUnits: {
        id: "newListUnits",
        label: (0, $3etjB.marketShareTerms).newListingNum
    },
    newUnits: {
        id: "newUnits",
        label: (0, $3etjB.marketShareTerms).newListingNum,
        keyField: "units"
    },
    forSaleVolume: {
        id: "actVolume",
        label: (0, $3etjB.marketShareTerms).forSale$
    },
    fsVolume: {
        id: "fsVolume",
        label: (0, $3etjB.marketShareTerms).forSale$,
        keyField: "volume"
    },
    forSaleUnits: {
        id: "actUnits",
        label: (0, $3etjB.marketShareTerms).forSaleNum,
        keyField: "volume"
    },
    fsUnits: {
        id: "fsUnits",
        label: (0, $3etjB.marketShareTerms).forSaleNum,
        keyField: "units"
    },
    averagePrice: {
        id: "averagePrice",
        label: (0, $3etjB.marketShareTerms).averagePrice
    },
    avgPrice: {
        id: "avgPrice",
        label: (0, $3etjB.marketShareTerms).averagePrice
    },
    averageDom: {
        id: "averageDom",
        label: (0, $3etjB.marketShareTerms).dom
    },
    avgDom: {
        id: "avgDom",
        label: (0, $3etjB.marketShareTerms).dom
    },
    avgListDom: {
        id: "avgListDom",
        label: (0, $3etjB.marketShareTerms).dom
    },
    dom: {
        id: "dom",
        label: (0, $3etjB.marketShareTerms).dom
    },
    cdom: {
        id: "cdom",
        label: (0, $cstaF.agentProductionTerms).cdom
    },
    agentCount: {
        id: "agentCount",
        label: (0, $3etjB.marketShareTerms).mlsIds
    },
    mlsAgentCount: {
        id: "mlsAgentCount",
        label: (0, $3etjB.marketShareTerms).mlsIds
    },
    city: {
        id: "city",
        label: (0, $cstaF.agentProductionTerms).city
    },
    stateCode: {
        id: "stateCode",
        label: (0, $3etjB.marketShareTerms).state
    },
    zipCode: {
        id: "zipCode",
        label: (0, $cstaF.agentProductionTerms).zip
    },
    zipcode: {
        id: "zipcode",
        label: (0, $cstaF.agentProductionTerms).zip
    },
    county: {
        id: "county",
        label: (0, $cstaF.agentProductionTerms).county
    },
    phoneNumber: {
        id: "phoneNumber",
        label: (0, $3etjB.marketShareTerms).phone
    },
    office: {
        id: "office",
        label: (0, $cstaF.agentProductionTerms).office
    },
    brokerName: {
        id: "brokerName",
        label: (0, $cstaF.agentProductionTerms).broker
    },
    listVolume: {
        id: "listVolume",
        label: (0, $3etjB.marketShareTerms).list$
    },
    listUnits: {
        id: "listUnits",
        label: (0, $3etjB.marketShareTerms).listNum
    },
    listOfficeId: {
        id: "listOfficeId",
        label: (0, $3etjB.marketShareTerms).listOfficeId
    },
    listOfficeName: {
        id: "listOfficeName",
        label: (0, $cstaF.agentProductionTerms).listOffice
    },
    sellOfficeId: {
        id: "sellOfficeId",
        label: (0, $3etjB.marketShareTerms).sellOfficeId
    },
    sellOfficeName: {
        id: "sellOfficeName",
        label: (0, $cstaF.agentProductionTerms).sellOffice
    },
    spOp: {
        id: "spOp",
        label: (0, $3etjB.marketShareTerms).spOp
    },
    spLp: {
        id: "spLp",
        label: (0, $3etjB.marketShareTerms).spLp
    },
    spop: {
        id: "spop",
        label: (0, $cstaF.agentProductionTerms).spOp
    },
    splp: {
        id: "splp",
        label: (0, $cstaF.agentProductionTerms).splp
    },
    listSpop: {
        id: "listSpop",
        label: (0, $3etjB.marketShareTerms).spOp
    },
    sellSpop: {
        id: "sellSpop",
        label: (0, $3etjB.marketShareTerms).spOp
    },
    clr: {
        id: "clr",
        label: (0, $3etjB.marketShareTerms).closedToList
    },
    closeListRatio: {
        id: "closeListRatio",
        label: (0, $3etjB.marketShareTerms).closedToList
    },
    sellVolume: {
        id: "sellVolume",
        label: (0, $3etjB.marketShareTerms).sell$
    },
    sellUnits: {
        id: "sellUnits",
        label: (0, $3etjB.marketShareTerms).sellNum
    },
    totalVolume: {
        id: "totalVolume",
        label: (0, $3etjB.marketShareTerms).total
    },
    totalUnits: {
        id: "totalUnits",
        label: (0, $3etjB.marketShareTerms).totalNum
    },
    totalAverageDom: {
        id: "totalAverageDom",
        label: (0, $3etjB.marketShareTerms).dom
    },
    listAverageDom: {
        id: "listAverageDom",
        label: (0, $3etjB.marketShareTerms).dom
    },
    avgSellDom: {
        id: "avgSellDom",
        label: (0, $3etjB.marketShareTerms).dom
    },
    totalAvgPrice: {
        id: "totalAvgPrice",
        label: (0, $3etjB.marketShareTerms).averagePrice
    },
    totalAveragePrice: {
        id: "totalAveragePrice",
        label: (0, $3etjB.marketShareTerms).averagePrice
    },
    sellAvgPrice: {
        id: "sellAvgPrice",
        label: (0, $3etjB.marketShareTerms).averagePrice
    },
    sellAveragePrice: {
        id: "sellAveragePrice",
        label: (0, $3etjB.marketShareTerms).averagePrice
    },
    listAvgPrice: {
        id: "listAvgPrice",
        label: (0, $3etjB.marketShareTerms).averagePrice
    },
    listAveragePrice: {
        id: "listAveragePrice",
        label: (0, $3etjB.marketShareTerms).averagePrice
    },
    prodAgentTotalUnits: {
        id: "prodAgentTotalUnits",
        label: (0, $3etjB.marketShareTerms).unitsPerProducingAgent
    },
    prodAgentTotalVolume: {
        id: "prodAgentTotalVolume",
        label: (0, $3etjB.marketShareTerms).volumePerProducingAgent
    },
    prodAgentSellVolume: {
        id: "prodAgentSellVolume",
        label: (0, $3etjB.marketShareTerms).volumePerProducingAgent
    },
    prodAgentSellUnits: {
        id: "prodAgentSellUnits",
        label: (0, $3etjB.marketShareTerms).unitsPerProducingAgent
    },
    prodAgentListUnits: {
        id: "prodAgentListUnits",
        label: (0, $3etjB.marketShareTerms).unitsPerProducingAgent
    },
    prodAgentListVolume: {
        id: "prodAgentListVolume",
        label: (0, $3etjB.marketShareTerms).volumePerProducingAgent
    },
    prodAgentVolume: {
        id: "prodAgentVolume",
        label: (0, $3etjB.marketShareTerms).volumePerProducingAgent
    },
    prodAgentUnits: {
        id: "prodAgentUnits",
        label: (0, $3etjB.marketShareTerms).unitsPerProducingAgent
    },
    orgPrice: {
        id: "orgPrice",
        label: (0, $cstaF.agentProductionTerms).originalPrice
    },
    listPrice: {
        id: "listPrice",
        label: (0, $cstaF.agentProductionTerms).listPrice
    },
    price: {
        id: "price",
        label: (0, $cstaF.agentProductionTerms).soldPrice
    },
    soldPrice: {
        id: "soldPrice",
        label: (0, $cstaF.agentProductionTerms).soldPrice
    },
    date: {
        id: "date",
        label: (0, $cstaF.agentProductionTerms).soldDate
    },
    priceChangeCnt: {
        id: "priceChangeCnt",
        label: (0, $cstaF.agentProductionTerms).priceChangeCnt
    },
    avgTotalDom: {
        id: "avgTotalDom",
        label: (0, $3etjB.marketShareTerms).dom
    },
    marketSharePct: {
        id: "marketSharePct",
        label: (0, $3etjB.marketShareTerms).marketSharePct
    },
    unitSharePct: {
        id: "unitSharePct",
        label: (0, $3etjB.marketShareTerms).unitPct
    },
    volumeSharePct: {
        id: "volumeSharePct",
        label: (0, $3etjB.marketShareTerms).volumePct
    },
    prodAgentCount: {
        id: "prodAgentCount",
        label: (0, $3etjB.marketShareTerms).producingAgents
    },
    prodAgentSearchCount: {
        id: "prodAgentSearchCount",
        label: (0, $3etjB.marketShareTerms).producingAgents
    },
    listProdAgentSearchCount: {
        id: "listProdAgentSearchCount",
        label: (0, $3etjB.marketShareTerms).producingAgents
    },
    sellProdAgentSearchCount: {
        id: "sellProdAgentSearchCount",
        label: (0, $3etjB.marketShareTerms).producingAgents
    },
    totalProdAgentSearchCount: {
        id: "totalProdAgentSearchCount",
        label: (0, $3etjB.marketShareTerms).producingAgents
    },
    officeCount: {
        id: "officeCount",
        label: (0, $3etjB.marketShareTerms).numOfOffices
    },
    mlsOfficeCount: {
        id: "mlsOfficeCount",
        label: (0, $3etjB.marketShareTerms).numOfOffices
    },
    area: {
        id: "area",
        label: (0, $3etjB.marketShareTerms).area
    },
    mlsArea: {
        id: "mlsArea",
        label: (0, $3etjB.marketShareTerms).area
    },
    rank: {
        id: "rank",
        label: (0, $3etjB.marketShareTerms).rank
    },
    isSelected: {
        id: "isSelected",
        label: (0, $3etjB.marketShareTerms).isSelected
    },
    areaId: {
        id: "areaId",
        label: (0, $cstaF.agentProductionTerms).area
    },
    mlsId: {
        id: "mlsId",
        label: (0, $3etjB.marketShareTerms).mlsIds
    },
    listingStatus: {
        id: "listingStatus",
        field: "status",
        label: (0, $3etjB.marketShareTerms).status
    },
    typeName: {
        id: "typeName",
        label: (0, $cstaF.agentProductionTerms).type
    },
    mlsNum: {
        id: "mlsNum",
        label: (0, $cstaF.agentProductionTerms).mlsNum
    },
    bankProperty: {
        id: "bankProperty",
        label: (0, $cstaF.agentProductionTerms).bankProperty
    },
    bedrooms: {
        id: "bedrooms",
        label: (0, $cstaF.agentProductionTerms).bd
    },
    fullBaths: {
        id: "fullBaths",
        label: (0, $cstaF.agentProductionTerms).ba
    },
    squareFt: {
        id: "squareFt",
        label: (0, $cstaF.agentProductionTerms).sqft
    },
    costPerSqft: {
        id: "costPerSqft",
        label: (0, $cstaF.agentProductionTerms).dollarsPerSqft
    },
    lotSizeSquareFt: {
        id: "lotSizeSquareFt",
        label: (0, $cstaF.agentProductionTerms).lotSizeSqft
    },
    lotSizeAcres: {
        id: "lotSizeAcres",
        label: (0, $cstaF.agentProductionTerms).lotSizeAcres
    },
    yearBuilt: {
        id: "yearBuilt",
        label: (0, $cstaF.agentProductionTerms).yearBuilt
    },
    listAgent: {
        id: "listAgent",
        label: (0, $cstaF.agentProductionTerms).listAgent
    },
    sellAgent: {
        id: "sellAgent",
        label: (0, $cstaF.agentProductionTerms).sellAgent
    },
    doubleSided: {
        id: "doubleSided",
        label: (0, $cstaF.agentProductionTerms).dbl
    },
    bankStatus: {
        id: "bankStatus",
        label: (0, $cstaF.agentProductionTerms).bankProperty
    },
    groupName: {
        id: "groupName",
        label: (0, $3etjB.marketShareTerms).group
    }
});

});

parcelRegister("4UTP7", function(module, exports) {

$parcel$export(module.exports, "listingViews", () => $3947b1c4768bc1a8$export$c69b2be925a17897);
$parcel$export(module.exports, "getCurrentListingView", () => $3947b1c4768bc1a8$export$9e4fb200713872a2);

var $3etjB = parcelRequire("3etjB");

var $c3iqc = parcelRequire("c3iqc");

var $7fq2m = parcelRequire("7fq2m");

var $htzEo = parcelRequire("htzEo");

var $cstaF = parcelRequire("cstaF");
const $3947b1c4768bc1a8$export$75e2b31dabf1b229 = {
    volume: (0, $htzEo.getCompactDollars),
    units: (value)=>Number.isInteger(value) ? value : value.toFixed(1)
};
const $3947b1c4768bc1a8$var$getComparisonSetColumns = (columns)=>{
    return columns.map((col)=>{
        if (col.field === (0, $7fq2m.gridColumnDefinitions).brokerName.field) return (0, $7fq2m.gridColumnDefinitions).groupName;
        return col;
    });
};
const $3947b1c4768bc1a8$var$showHideTotalVolumeUnitsCols = [
    {
        ...(0, $7fq2m.gridColumnDefinitions).marketSharePct,
        hide: false
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).avgListDom,
        hide: false
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).totalAvgPrice,
        hide: false
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).prodAgentTotalUnits,
        hide: false
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).prodAgentTotalVolume,
        hide: false
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).prodAgentSearchCount,
        hide: false
    }
];
const $3947b1c4768bc1a8$var$showHideSellSideCols = [
    {
        ...(0, $7fq2m.gridColumnDefinitions).marketSharePct,
        hide: false
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).sellAvgPrice,
        hide: false
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).sellSpop,
        hide: false
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).prodAgentSellUnits,
        hide: false
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).prodAgentSellVolume,
        hide: false
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).prodAgentSearchCount,
        hide: false
    }
];
const $3947b1c4768bc1a8$var$showHideListSideCols = [
    {
        ...(0, $7fq2m.gridColumnDefinitions).marketSharePct,
        hide: false
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).clr,
        hide: false
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).avgListDom,
        hide: false
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).listAvgPrice,
        hide: false
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).listSpop,
        hide: false
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).prodAgentListUnits,
        hide: false
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).prodAgentListVolume,
        hide: false
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).prodAgentSearchCount,
        hide: false
    }
];
const $3947b1c4768bc1a8$var$showHideUnderContractForSaleCols = [
    {
        ...(0, $7fq2m.gridColumnDefinitions).marketSharePct,
        hide: false
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).avgDom,
        hide: false
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).avgPrice,
        hide: false
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).agentCount,
        hide: false
    }
];
const $3947b1c4768bc1a8$var$showHideNewListingCols = [
    {
        ...(0, $7fq2m.gridColumnDefinitions).marketSharePct,
        hide: false
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).avgPrice,
        hide: false
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).agentCount,
        hide: false
    }
];
const $3947b1c4768bc1a8$var$settingsTotalVolumeUnitsByBrokerage = {
    showHideOptions: {
        options: (0, $3etjB.listingTypes).byBrokerage.defaultShowHideOptions,
        columns: [
            {
                ...(0, $c3iqc.marketShareColumns).marketSharePct,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).avgListDom,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).totalAvgPrice,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).prodAgentTotalUnits,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).prodAgentTotalVolume,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).prodAgentSearchCount,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).officeCount,
                isDefault: true,
                hide: false
            }
        ]
    },
    columns: [
        (0, $7fq2m.gridColumnDefinitions).isSelected,
        (0, $7fq2m.gridColumnDefinitions).rank,
        (0, $7fq2m.gridColumnDefinitions).brokerName,
        (0, $7fq2m.gridColumnDefinitions).listVolume,
        (0, $7fq2m.gridColumnDefinitions).listUnits,
        (0, $7fq2m.gridColumnDefinitions).sellVolume,
        (0, $7fq2m.gridColumnDefinitions).sellUnits,
        (0, $7fq2m.gridColumnDefinitions).totalVolume,
        (0, $7fq2m.gridColumnDefinitions).totalUnits,
        ...$3947b1c4768bc1a8$var$showHideTotalVolumeUnitsCols,
        {
            ...(0, $7fq2m.gridColumnDefinitions).officeCount,
            hide: false
        }
    ]
};
const $3947b1c4768bc1a8$var$settingsSellSideByBrokerage = {
    showHideOptions: {
        options: (0, $3etjB.listingTypes).byBrokerage.defaultShowHideOptions,
        columns: [
            {
                ...(0, $c3iqc.marketShareColumns).marketSharePct,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).sellAvgPrice,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).sellSpop,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).prodAgentSellUnits,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).prodAgentSellVolume,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).prodAgentSearchCount,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).officeCount,
                isDefault: true,
                hide: false
            }
        ]
    },
    columns: [
        (0, $7fq2m.gridColumnDefinitions).isSelected,
        (0, $7fq2m.gridColumnDefinitions).rank,
        (0, $7fq2m.gridColumnDefinitions).brokerName,
        (0, $7fq2m.gridColumnDefinitions).sellVolume,
        (0, $7fq2m.gridColumnDefinitions).sellUnits,
        ...$3947b1c4768bc1a8$var$showHideSellSideCols,
        {
            ...(0, $7fq2m.gridColumnDefinitions).officeCount,
            hide: false
        }
    ]
};
const $3947b1c4768bc1a8$var$settingsForSaleByBrokerage = {
    showHideOptions: {
        options: (0, $3etjB.listingTypes).byBrokerage.defaultShowHideOptions,
        columns: [
            {
                ...(0, $c3iqc.marketShareColumns).marketSharePct,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).avgDom,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).avgPrice,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).agentCount,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).officeCount,
                isDefault: true,
                hide: false
            }
        ]
    },
    columns: [
        (0, $7fq2m.gridColumnDefinitions).isSelected,
        (0, $7fq2m.gridColumnDefinitions).rank,
        (0, $7fq2m.gridColumnDefinitions).brokerName,
        (0, $7fq2m.gridColumnDefinitions).actVolume,
        (0, $7fq2m.gridColumnDefinitions).actUnits,
        ...$3947b1c4768bc1a8$var$showHideUnderContractForSaleCols,
        {
            ...(0, $7fq2m.gridColumnDefinitions).officeCount,
            hide: false
        }
    ]
};
const $3947b1c4768bc1a8$var$settingsNewListingByBrokerage = {
    showHideOptions: {
        options: (0, $3etjB.listingTypes).byBrokerage.defaultShowHideOptions,
        columns: [
            {
                ...(0, $c3iqc.marketShareColumns).marketSharePct,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).avgPrice,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).agentCount,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).officeCount,
                isDefault: true,
                hide: false
            }
        ]
    },
    columns: [
        (0, $7fq2m.gridColumnDefinitions).isSelected,
        (0, $7fq2m.gridColumnDefinitions).rank,
        (0, $7fq2m.gridColumnDefinitions).brokerName,
        (0, $7fq2m.gridColumnDefinitions).newListVolume,
        (0, $7fq2m.gridColumnDefinitions).newListUnits,
        ...$3947b1c4768bc1a8$var$showHideNewListingCols,
        {
            ...(0, $7fq2m.gridColumnDefinitions).officeCount,
            hide: false
        }
    ]
};
const $3947b1c4768bc1a8$var$settingsTotalVolumeUnits = {
    [(0, $3etjB.listingTypes).byOffice.id]: {
        showHideOptions: {
            options: (0, $3etjB.listingTypes).byOffice.defaultShowHideOptions,
            columns: [
                {
                    ...(0, $c3iqc.marketShareColumns).address,
                    isDefault: false,
                    hide: true,
                    groupId: (0, $3etjB.gridGroups).ADDRESS
                },
                {
                    ...(0, $c3iqc.marketShareColumns).marketSharePct,
                    isDefault: true,
                    hide: false
                },
                {
                    ...(0, $c3iqc.marketShareColumns).avgListDom,
                    isDefault: true,
                    hide: false
                },
                {
                    ...(0, $c3iqc.marketShareColumns).totalAvgPrice,
                    isDefault: true,
                    hide: false
                },
                {
                    ...(0, $c3iqc.marketShareColumns).prodAgentTotalUnits,
                    isDefault: true,
                    hide: false
                },
                {
                    ...(0, $c3iqc.marketShareColumns).prodAgentTotalVolume,
                    isDefault: true,
                    hide: false
                },
                {
                    ...(0, $c3iqc.marketShareColumns).prodAgentSearchCount,
                    isDefault: true,
                    hide: false
                }
            ]
        },
        columns: [
            (0, $7fq2m.gridColumnDefinitions).isSelected,
            (0, $7fq2m.gridColumnDefinitions).rank,
            {
                ...(0, $7fq2m.gridColumnDefinitions).officeId,
                groupId: (0, $3etjB.gridGroups).ADDRESS,
                hide: true
            },
            (0, $7fq2m.gridColumnDefinitions).officeName,
            {
                ...(0, $7fq2m.gridColumnDefinitions).streetName1,
                groupId: (0, $3etjB.gridGroups).ADDRESS,
                hide: true
            },
            {
                ...(0, $7fq2m.gridColumnDefinitions).city,
                groupId: (0, $3etjB.gridGroups).ADDRESS,
                hide: true
            },
            {
                ...(0, $7fq2m.gridColumnDefinitions).stateCode,
                groupId: (0, $3etjB.gridGroups).ADDRESS,
                hide: true
            },
            {
                ...(0, $7fq2m.gridColumnDefinitions).zipCode,
                groupId: (0, $3etjB.gridGroups).ADDRESS,
                hide: true
            },
            {
                ...(0, $7fq2m.gridColumnDefinitions).county,
                groupId: (0, $3etjB.gridGroups).ADDRESS,
                hide: true
            },
            {
                ...(0, $7fq2m.gridColumnDefinitions).phoneNumber,
                groupId: (0, $3etjB.gridGroups).ADDRESS,
                hide: true
            },
            (0, $7fq2m.gridColumnDefinitions).listVolume,
            (0, $7fq2m.gridColumnDefinitions).listUnits,
            (0, $7fq2m.gridColumnDefinitions).sellVolume,
            (0, $7fq2m.gridColumnDefinitions).sellUnits,
            (0, $7fq2m.gridColumnDefinitions).totalVolume,
            (0, $7fq2m.gridColumnDefinitions).totalUnits,
            ...$3947b1c4768bc1a8$var$showHideTotalVolumeUnitsCols
        ]
    },
    [(0, $3etjB.listingTypes).byBrokerage.id]: $3947b1c4768bc1a8$var$settingsTotalVolumeUnitsByBrokerage,
    [(0, $3etjB.listingTypes).comparisonSet.id]: {
        ...$3947b1c4768bc1a8$var$settingsTotalVolumeUnitsByBrokerage,
        showHideOptions: {
            ...$3947b1c4768bc1a8$var$settingsTotalVolumeUnitsByBrokerage.showHideOptions,
            options: (0, $3etjB.listingTypes).comparisonSet.defaultShowHideOptions
        },
        columns: $3947b1c4768bc1a8$var$getComparisonSetColumns($3947b1c4768bc1a8$var$settingsTotalVolumeUnitsByBrokerage.columns)
    }
};
const $3947b1c4768bc1a8$var$settingsUnderContractByBrokerage = {
    showHideOptions: {
        options: (0, $3etjB.listingTypes).byBrokerage.defaultShowHideOptions,
        columns: [
            {
                ...(0, $c3iqc.marketShareColumns).marketSharePct,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).avgDom,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).avgPrice,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).agentCount,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).officeCount,
                isDefault: true,
                hide: false
            }
        ]
    },
    columns: [
        (0, $7fq2m.gridColumnDefinitions).isSelected,
        (0, $7fq2m.gridColumnDefinitions).rank,
        (0, $7fq2m.gridColumnDefinitions).brokerName,
        (0, $7fq2m.gridColumnDefinitions).ucVolume,
        (0, $7fq2m.gridColumnDefinitions).ucUnits,
        ...$3947b1c4768bc1a8$var$showHideUnderContractForSaleCols,
        {
            ...(0, $7fq2m.gridColumnDefinitions).officeCount,
            hide: false
        }
    ]
};
const $3947b1c4768bc1a8$var$settingsUnderContract = {
    [(0, $3etjB.listingTypes).byOffice.id]: {
        showHideOptions: {
            options: (0, $3etjB.listingTypes).byOffice.defaultShowHideOptions,
            columns: [
                {
                    ...(0, $c3iqc.marketShareColumns).address,
                    isDefault: false,
                    hide: true,
                    groupId: (0, $3etjB.gridGroups).ADDRESS
                },
                {
                    ...(0, $c3iqc.marketShareColumns).marketSharePct,
                    isDefault: true,
                    hide: false
                },
                {
                    ...(0, $c3iqc.marketShareColumns).avgDom,
                    isDefault: true,
                    hide: false
                },
                {
                    ...(0, $c3iqc.marketShareColumns).avgPrice,
                    isDefault: true,
                    hide: false
                },
                {
                    ...(0, $c3iqc.marketShareColumns).agentCount,
                    isDefault: true,
                    hide: false
                }
            ]
        },
        columns: [
            (0, $7fq2m.gridColumnDefinitions).isSelected,
            (0, $7fq2m.gridColumnDefinitions).rank,
            {
                ...(0, $7fq2m.gridColumnDefinitions).officeId,
                groupId: (0, $3etjB.gridGroups).ADDRESS,
                hide: true
            },
            (0, $7fq2m.gridColumnDefinitions).officeName,
            {
                ...(0, $7fq2m.gridColumnDefinitions).streetName,
                groupId: (0, $3etjB.gridGroups).ADDRESS,
                hide: true,
                headerName: (0, $3etjB.marketShareTerms).address
            },
            {
                ...(0, $7fq2m.gridColumnDefinitions).city,
                groupId: (0, $3etjB.gridGroups).ADDRESS,
                hide: true
            },
            {
                ...(0, $7fq2m.gridColumnDefinitions).stateCode,
                groupId: (0, $3etjB.gridGroups).ADDRESS,
                hide: true
            },
            {
                ...(0, $7fq2m.gridColumnDefinitions).zipCode,
                groupId: (0, $3etjB.gridGroups).ADDRESS,
                hide: true
            },
            {
                ...(0, $7fq2m.gridColumnDefinitions).county,
                groupId: (0, $3etjB.gridGroups).ADDRESS,
                hide: true
            },
            {
                ...(0, $7fq2m.gridColumnDefinitions).phoneNumber,
                groupId: (0, $3etjB.gridGroups).ADDRESS,
                hide: true
            },
            (0, $7fq2m.gridColumnDefinitions).ucVolume,
            (0, $7fq2m.gridColumnDefinitions).ucUnits,
            ...$3947b1c4768bc1a8$var$showHideUnderContractForSaleCols
        ]
    },
    [(0, $3etjB.listingTypes).byBrokerage.id]: $3947b1c4768bc1a8$var$settingsUnderContractByBrokerage,
    [(0, $3etjB.listingTypes).comparisonSet.id]: {
        ...$3947b1c4768bc1a8$var$settingsUnderContractByBrokerage,
        showHideOptions: {
            ...$3947b1c4768bc1a8$var$settingsUnderContractByBrokerage.showHideOptions,
            options: (0, $3etjB.listingTypes).comparisonSet.defaultShowHideOptions
        },
        columns: $3947b1c4768bc1a8$var$getComparisonSetColumns($3947b1c4768bc1a8$var$settingsUnderContractByBrokerage.columns)
    }
};
const $3947b1c4768bc1a8$var$settingsNewListing = {
    [(0, $3etjB.listingTypes).byOffice.id]: {
        showHideOptions: {
            options: (0, $3etjB.listingTypes).byOffice.defaultShowHideOptions,
            columns: [
                {
                    ...(0, $c3iqc.marketShareColumns).address,
                    isDefault: false,
                    hide: true,
                    groupId: (0, $3etjB.gridGroups).ADDRESS
                },
                {
                    ...(0, $c3iqc.marketShareColumns).marketSharePct,
                    isDefault: true,
                    hide: false
                },
                {
                    ...(0, $c3iqc.marketShareColumns).avgPrice,
                    isDefault: true,
                    hide: false
                },
                {
                    ...(0, $c3iqc.marketShareColumns).agentCount,
                    isDefault: true,
                    hide: false
                }
            ]
        },
        columns: [
            (0, $7fq2m.gridColumnDefinitions).isSelected,
            (0, $7fq2m.gridColumnDefinitions).rank,
            {
                ...(0, $7fq2m.gridColumnDefinitions).officeId,
                groupId: (0, $3etjB.gridGroups).ADDRESS,
                hide: true
            },
            (0, $7fq2m.gridColumnDefinitions).officeName,
            {
                ...(0, $7fq2m.gridColumnDefinitions).streetName,
                groupId: (0, $3etjB.gridGroups).ADDRESS,
                hide: true,
                headerName: (0, $3etjB.marketShareTerms).address
            },
            {
                ...(0, $7fq2m.gridColumnDefinitions).city,
                groupId: (0, $3etjB.gridGroups).ADDRESS,
                hide: true
            },
            {
                ...(0, $7fq2m.gridColumnDefinitions).stateCode,
                groupId: (0, $3etjB.gridGroups).ADDRESS,
                hide: true
            },
            {
                ...(0, $7fq2m.gridColumnDefinitions).zipCode,
                groupId: (0, $3etjB.gridGroups).ADDRESS,
                hide: true
            },
            {
                ...(0, $7fq2m.gridColumnDefinitions).county,
                groupId: (0, $3etjB.gridGroups).ADDRESS,
                hide: true
            },
            {
                ...(0, $7fq2m.gridColumnDefinitions).phoneNumber,
                groupId: (0, $3etjB.gridGroups).ADDRESS,
                hide: true
            },
            (0, $7fq2m.gridColumnDefinitions).newListVolume,
            (0, $7fq2m.gridColumnDefinitions).newListUnits,
            ...$3947b1c4768bc1a8$var$showHideNewListingCols
        ]
    },
    [(0, $3etjB.listingTypes).byBrokerage.id]: $3947b1c4768bc1a8$var$settingsNewListingByBrokerage,
    [(0, $3etjB.listingTypes).comparisonSet.id]: {
        ...$3947b1c4768bc1a8$var$settingsNewListingByBrokerage,
        showHideOptions: {
            ...$3947b1c4768bc1a8$var$settingsNewListingByBrokerage.showHideOptions,
            options: (0, $3etjB.listingTypes).comparisonSet.defaultShowHideOptions
        },
        columns: $3947b1c4768bc1a8$var$getComparisonSetColumns($3947b1c4768bc1a8$var$settingsNewListingByBrokerage.columns)
    }
};
const $3947b1c4768bc1a8$var$settingsForSale = {
    [(0, $3etjB.listingTypes).byOffice.id]: {
        showHideOptions: {
            options: (0, $3etjB.listingTypes).byOffice.defaultShowHideOptions,
            columns: [
                {
                    ...(0, $c3iqc.marketShareColumns).address,
                    isDefault: false,
                    hide: true,
                    groupId: (0, $3etjB.gridGroups).ADDRESS
                },
                {
                    ...(0, $c3iqc.marketShareColumns).marketSharePct,
                    isDefault: true,
                    hide: false
                },
                {
                    ...(0, $c3iqc.marketShareColumns).avgDom,
                    isDefault: true,
                    hide: false
                },
                {
                    ...(0, $c3iqc.marketShareColumns).avgPrice,
                    isDefault: true,
                    hide: false
                },
                {
                    ...(0, $c3iqc.marketShareColumns).agentCount,
                    isDefault: true,
                    hide: false
                }
            ]
        },
        columns: [
            (0, $7fq2m.gridColumnDefinitions).isSelected,
            (0, $7fq2m.gridColumnDefinitions).rank,
            {
                ...(0, $7fq2m.gridColumnDefinitions).officeId,
                groupId: (0, $3etjB.gridGroups).ADDRESS,
                hide: true
            },
            (0, $7fq2m.gridColumnDefinitions).officeName,
            {
                ...(0, $7fq2m.gridColumnDefinitions).streetName,
                groupId: (0, $3etjB.gridGroups).ADDRESS,
                hide: true,
                headerName: (0, $3etjB.marketShareTerms).address
            },
            {
                ...(0, $7fq2m.gridColumnDefinitions).city,
                groupId: (0, $3etjB.gridGroups).ADDRESS,
                hide: true
            },
            {
                ...(0, $7fq2m.gridColumnDefinitions).stateCode,
                groupId: (0, $3etjB.gridGroups).ADDRESS,
                hide: true
            },
            {
                ...(0, $7fq2m.gridColumnDefinitions).zipCode,
                groupId: (0, $3etjB.gridGroups).ADDRESS,
                hide: true
            },
            {
                ...(0, $7fq2m.gridColumnDefinitions).county,
                groupId: (0, $3etjB.gridGroups).ADDRESS,
                hide: true
            },
            {
                ...(0, $7fq2m.gridColumnDefinitions).phoneNumber,
                groupId: (0, $3etjB.gridGroups).ADDRESS,
                hide: true
            },
            (0, $7fq2m.gridColumnDefinitions).actVolume,
            (0, $7fq2m.gridColumnDefinitions).actUnits,
            ...$3947b1c4768bc1a8$var$showHideUnderContractForSaleCols
        ]
    },
    [(0, $3etjB.listingTypes).byBrokerage.id]: $3947b1c4768bc1a8$var$settingsForSaleByBrokerage,
    [(0, $3etjB.listingTypes).comparisonSet.id]: {
        ...$3947b1c4768bc1a8$var$settingsForSaleByBrokerage,
        showHideOptions: {
            ...$3947b1c4768bc1a8$var$settingsForSaleByBrokerage.showHideOptions,
            options: (0, $3etjB.listingTypes).comparisonSet.defaultShowHideOptions
        },
        columns: $3947b1c4768bc1a8$var$getComparisonSetColumns($3947b1c4768bc1a8$var$settingsForSaleByBrokerage.columns)
    }
};
const $3947b1c4768bc1a8$var$settingsSellSide = {
    [(0, $3etjB.listingTypes).byOffice.id]: {
        showHideOptions: {
            options: (0, $3etjB.listingTypes).byOffice.defaultShowHideOptions,
            columns: [
                {
                    ...(0, $c3iqc.marketShareColumns).address,
                    isDefault: false,
                    hide: true,
                    groupId: (0, $3etjB.gridGroups).ADDRESS
                },
                {
                    ...(0, $c3iqc.marketShareColumns).marketSharePct,
                    isDefault: true,
                    hide: false
                },
                {
                    ...(0, $c3iqc.marketShareColumns).sellAvgPrice,
                    isDefault: true,
                    hide: false
                },
                {
                    ...(0, $c3iqc.marketShareColumns).sellSpop,
                    isDefault: true,
                    hide: false
                },
                {
                    ...(0, $c3iqc.marketShareColumns).prodAgentSellUnits,
                    isDefault: true,
                    hide: false
                },
                {
                    ...(0, $c3iqc.marketShareColumns).prodAgentSellVolume,
                    isDefault: true,
                    hide: false
                },
                {
                    ...(0, $c3iqc.marketShareColumns).prodAgentSearchCount,
                    isDefault: true,
                    hide: false
                }
            ]
        },
        columns: [
            (0, $7fq2m.gridColumnDefinitions).isSelected,
            (0, $7fq2m.gridColumnDefinitions).rank,
            {
                ...(0, $7fq2m.gridColumnDefinitions).officeId,
                groupId: (0, $3etjB.gridGroups).ADDRESS,
                hide: true
            },
            (0, $7fq2m.gridColumnDefinitions).officeName,
            {
                ...(0, $7fq2m.gridColumnDefinitions).streetName1,
                groupId: (0, $3etjB.gridGroups).ADDRESS,
                hide: true
            },
            {
                ...(0, $7fq2m.gridColumnDefinitions).city,
                groupId: (0, $3etjB.gridGroups).ADDRESS,
                hide: true
            },
            {
                ...(0, $7fq2m.gridColumnDefinitions).stateCode,
                groupId: (0, $3etjB.gridGroups).ADDRESS,
                hide: true
            },
            {
                ...(0, $7fq2m.gridColumnDefinitions).zipCode,
                groupId: (0, $3etjB.gridGroups).ADDRESS,
                hide: true
            },
            {
                ...(0, $7fq2m.gridColumnDefinitions).county,
                groupId: (0, $3etjB.gridGroups).ADDRESS,
                hide: true
            },
            {
                ...(0, $7fq2m.gridColumnDefinitions).phoneNumber,
                groupId: (0, $3etjB.gridGroups).ADDRESS,
                hide: true
            },
            (0, $7fq2m.gridColumnDefinitions).sellVolume,
            (0, $7fq2m.gridColumnDefinitions).sellUnits,
            ...$3947b1c4768bc1a8$var$showHideSellSideCols
        ]
    },
    [(0, $3etjB.listingTypes).byBrokerage.id]: $3947b1c4768bc1a8$var$settingsSellSideByBrokerage,
    [(0, $3etjB.listingTypes).comparisonSet.id]: {
        ...$3947b1c4768bc1a8$var$settingsSellSideByBrokerage,
        showHideOptions: {
            ...$3947b1c4768bc1a8$var$settingsSellSideByBrokerage.showHideOptions,
            options: (0, $3etjB.listingTypes).comparisonSet.defaultShowHideOptions
        },
        columns: $3947b1c4768bc1a8$var$getComparisonSetColumns($3947b1c4768bc1a8$var$settingsSellSideByBrokerage.columns)
    }
};
const $3947b1c4768bc1a8$var$settingsColumnsOfficeListSide = [
    (0, $7fq2m.gridColumnDefinitions).isSelected,
    (0, $7fq2m.gridColumnDefinitions).rank,
    {
        ...(0, $7fq2m.gridColumnDefinitions).officeId,
        groupId: (0, $3etjB.gridGroups).ADDRESS,
        hide: true
    },
    (0, $7fq2m.gridColumnDefinitions).officeName,
    {
        ...(0, $7fq2m.gridColumnDefinitions).streetName1,
        groupId: (0, $3etjB.gridGroups).ADDRESS,
        hide: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).city,
        groupId: (0, $3etjB.gridGroups).ADDRESS,
        hide: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).stateCode,
        groupId: (0, $3etjB.gridGroups).ADDRESS,
        hide: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).zipCode,
        groupId: (0, $3etjB.gridGroups).ADDRESS,
        hide: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).county,
        groupId: (0, $3etjB.gridGroups).ADDRESS,
        hide: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).phoneNumber,
        groupId: (0, $3etjB.gridGroups).ADDRESS,
        hide: true
    },
    (0, $7fq2m.gridColumnDefinitions).listVolume,
    (0, $7fq2m.gridColumnDefinitions).listUnits,
    ...$3947b1c4768bc1a8$var$showHideListSideCols
];
const $3947b1c4768bc1a8$var$settingsListSideUnitsByBrokerage = {
    showHideOptions: {
        options: (0, $3etjB.listingTypes).byBrokerage.defaultShowHideOptions,
        columns: [
            {
                ...(0, $c3iqc.marketShareColumns).marketSharePct,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).avgListDom,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).listAvgPrice,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).listSpop,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).prodAgentListUnits,
                label: (0, $3etjB.marketShareTerms).unitsPerProducingAgent,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).prodAgentListVolume,
                label: (0, $3etjB.marketShareTerms).volumePerProducingAgent,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).clr,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).prodAgentSearchCount,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).officeCount,
                isDefault: true,
                hide: false
            }
        ]
    },
    columns: [
        (0, $7fq2m.gridColumnDefinitions).isSelected,
        (0, $7fq2m.gridColumnDefinitions).rank,
        (0, $7fq2m.gridColumnDefinitions).brokerName,
        (0, $7fq2m.gridColumnDefinitions).listVolume,
        (0, $7fq2m.gridColumnDefinitions).listUnits,
        ...$3947b1c4768bc1a8$var$showHideListSideCols,
        {
            ...(0, $7fq2m.gridColumnDefinitions).officeCount,
            hide: false
        }
    ]
};
const $3947b1c4768bc1a8$var$settingsListSideVolumeByBrokerage = {
    showHideOptions: {
        options: (0, $3etjB.listingTypes).byBrokerage.defaultShowHideOptions,
        columns: [
            {
                ...(0, $c3iqc.marketShareColumns).marketSharePct,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).avgListDom,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).listAvgPrice,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).listSpop,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).prodAgentListUnits,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).prodAgentListVolume,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).clr,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).prodAgentSearchCount,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).officeCount,
                isDefault: true,
                hide: false
            }
        ]
    },
    columns: [
        (0, $7fq2m.gridColumnDefinitions).isSelected,
        (0, $7fq2m.gridColumnDefinitions).rank,
        (0, $7fq2m.gridColumnDefinitions).brokerName,
        (0, $7fq2m.gridColumnDefinitions).listVolume,
        (0, $7fq2m.gridColumnDefinitions).listUnits,
        ...$3947b1c4768bc1a8$var$showHideListSideCols,
        {
            ...(0, $7fq2m.gridColumnDefinitions).officeCount,
            hide: false
        }
    ]
};
const $3947b1c4768bc1a8$export$c69b2be925a17897 = Object.freeze({
    newListing$Volume: {
        id: "newListing$Volume",
        label: (0, $3etjB.marketShareTerms).newListing$Volume,
        dataPointGroups: [
            (0, $3etjB.dataPoints).NEW_LISTING_VOLUME
        ],
        xAxisLabelFormatter: $3947b1c4768bc1a8$export$75e2b31dabf1b229.volume,
        popOverDataFormatter: (0, $htzEo.popOverDataFormatters).volume,
        popOverLabels: [
            (0, $cstaF.marketShareListingStatuses)["New"]
        ],
        keyField: (0, $c3iqc.marketShareColumns).newListingVolume.id,
        settings: $3947b1c4768bc1a8$var$settingsNewListing
    },
    newListingNumUnits: {
        id: "newListingNumUnits",
        label: (0, $3etjB.marketShareTerms).newListingNumUnits,
        dataPointGroups: [
            (0, $3etjB.dataPoints).NEW_LISTING_UNITS
        ],
        xAxisLabelFormatter: $3947b1c4768bc1a8$export$75e2b31dabf1b229.units,
        popOverDataFormatter: (0, $htzEo.popOverDataFormatters).units,
        popOverLabels: [
            (0, $cstaF.marketShareListingStatuses)["New"]
        ],
        keyField: (0, $c3iqc.marketShareColumns).newListingUnits.id,
        settings: $3947b1c4768bc1a8$var$settingsNewListing
    },
    total$Volume: {
        id: "total$Volume",
        label: (0, $3etjB.marketShareTerms).total$Volume,
        dataPointGroups: [
            (0, $3etjB.dataPoints).SOLD_LIST_SIDE_VOLUME,
            (0, $3etjB.dataPoints).TOTAL_SOLD_SELL_SIDE_VOLUME
        ],
        xAxisLabelFormatter: $3947b1c4768bc1a8$export$75e2b31dabf1b229.volume,
        popOverDataFormatter: (0, $htzEo.popOverDataFormatters).volume,
        popOverLabels: [
            (0, $cstaF.marketShareListingStatuses)["SoldListSide"],
            (0, $cstaF.marketShareListingStatuses)["SoldSellSide"]
        ],
        keyField: (0, $c3iqc.marketShareColumns).totalVolume.id,
        settings: $3947b1c4768bc1a8$var$settingsTotalVolumeUnits
    },
    totalNumUnits: {
        id: "totalNumUnits",
        label: (0, $3etjB.marketShareTerms).totalNumUnits,
        dataPointGroups: [
            (0, $3etjB.dataPoints).SOLD_LIST_SIDE_UNITS,
            (0, $3etjB.dataPoints).TOTAL_SOLD_SELL_SIDE_UNITS
        ],
        keyField: (0, $c3iqc.marketShareColumns).totalUnits.id,
        xAxisLabelFormatter: $3947b1c4768bc1a8$export$75e2b31dabf1b229.units,
        popOverDataFormatter: (0, $htzEo.popOverDataFormatters).units,
        popOverLabels: [
            (0, $cstaF.marketShareListingStatuses)["SoldListSide"],
            (0, $cstaF.marketShareListingStatuses)["SoldSellSide"]
        ],
        settings: $3947b1c4768bc1a8$var$settingsTotalVolumeUnits
    },
    forSale$Volume: {
        id: "forSale$Volume",
        label: (0, $3etjB.marketShareTerms).forSale$Volume,
        dataPointGroups: [
            (0, $3etjB.dataPoints).FOR_SALE_VOLUME
        ],
        xAxisLabelFormatter: $3947b1c4768bc1a8$export$75e2b31dabf1b229.volume,
        popOverDataFormatter: (0, $htzEo.popOverDataFormatters).volume,
        popOverLabels: [
            (0, $cstaF.marketShareListingStatuses)["ForSale"]
        ],
        keyField: (0, $c3iqc.marketShareColumns).forSaleVolume.id,
        settings: $3947b1c4768bc1a8$var$settingsForSale
    },
    forSaleNumUnits: {
        id: "forSaleNumUnits",
        label: (0, $3etjB.marketShareTerms).forSaleNumUnits,
        dataPointGroups: [
            (0, $3etjB.dataPoints).FOR_SALE_UNITS
        ],
        xAxisLabelFormatter: $3947b1c4768bc1a8$export$75e2b31dabf1b229.units,
        popOverDataFormatter: (0, $htzEo.popOverDataFormatters).roundedUnits,
        popOverLabels: [
            (0, $cstaF.marketShareListingStatuses)["ForSale"]
        ],
        keyField: (0, $c3iqc.marketShareColumns).forSaleUnits.id,
        settings: $3947b1c4768bc1a8$var$settingsForSale
    },
    listSide$Volume: {
        id: "listSide$Volume",
        label: (0, $3etjB.marketShareTerms).listSide$Volume,
        dataPointGroups: [
            (0, $3etjB.dataPoints).SOLD_LIST_SIDE_VOLUME
        ],
        xAxisLabelFormatter: $3947b1c4768bc1a8$export$75e2b31dabf1b229.volume,
        popOverDataFormatter: (0, $htzEo.popOverDataFormatters).volume,
        popOverLabels: [
            (0, $cstaF.marketShareListingStatuses)["SoldListSide"]
        ],
        keyField: (0, $c3iqc.marketShareColumns).listVolume.id,
        settings: {
            [(0, $3etjB.listingTypes).byOffice.id]: {
                showHideOptions: {
                    options: (0, $3etjB.listingTypes).byOffice.defaultShowHideOptions,
                    columns: [
                        {
                            ...(0, $c3iqc.marketShareColumns).address,
                            isDefault: false,
                            hide: true,
                            groupId: (0, $3etjB.gridGroups).ADDRESS
                        },
                        {
                            ...(0, $c3iqc.marketShareColumns).marketSharePct,
                            isDefault: true,
                            hide: false
                        },
                        {
                            ...(0, $c3iqc.marketShareColumns).avgListDom,
                            isDefault: true,
                            hide: false
                        },
                        {
                            ...(0, $c3iqc.marketShareColumns).listAvgPrice,
                            isDefault: true,
                            hide: false
                        },
                        {
                            ...(0, $c3iqc.marketShareColumns).listSpop,
                            isDefault: true,
                            hide: false
                        },
                        {
                            ...(0, $c3iqc.marketShareColumns).prodAgentListUnits,
                            isDefault: true,
                            hide: false
                        },
                        {
                            ...(0, $c3iqc.marketShareColumns).prodAgentListVolume,
                            isDefault: true,
                            hide: false
                        },
                        {
                            ...(0, $c3iqc.marketShareColumns).clr,
                            isDefault: true,
                            hide: false
                        },
                        {
                            ...(0, $c3iqc.marketShareColumns).prodAgentSearchCount,
                            isDefault: true,
                            hide: false
                        }
                    ]
                },
                columns: $3947b1c4768bc1a8$var$settingsColumnsOfficeListSide
            },
            [(0, $3etjB.listingTypes).byBrokerage.id]: $3947b1c4768bc1a8$var$settingsListSideVolumeByBrokerage,
            [(0, $3etjB.listingTypes).comparisonSet.id]: {
                ...$3947b1c4768bc1a8$var$settingsListSideVolumeByBrokerage,
                showHideOptions: {
                    ...$3947b1c4768bc1a8$var$settingsListSideVolumeByBrokerage.showHideOptions,
                    options: (0, $3etjB.listingTypes).comparisonSet.defaultShowHideOptions
                },
                columns: $3947b1c4768bc1a8$var$getComparisonSetColumns($3947b1c4768bc1a8$var$settingsListSideVolumeByBrokerage.columns)
            }
        }
    },
    listSideNumUnits: {
        id: "listSideNumUnits",
        label: (0, $3etjB.marketShareTerms).listSideNumUnits,
        dataPointGroups: [
            (0, $3etjB.dataPoints).SOLD_LIST_SIDE_UNITS
        ],
        xAxisLabelFormatter: $3947b1c4768bc1a8$export$75e2b31dabf1b229.units,
        popOverDataFormatter: (0, $htzEo.popOverDataFormatters).units,
        popOverLabels: [
            (0, $cstaF.marketShareListingStatuses)["SoldListSide"]
        ],
        keyField: (0, $c3iqc.marketShareColumns).listUnits.id,
        settings: {
            [(0, $3etjB.listingTypes).byOffice.id]: {
                showHideOptions: {
                    options: (0, $3etjB.listingTypes).byOffice.defaultShowHideOptions,
                    columns: [
                        {
                            ...(0, $c3iqc.marketShareColumns).address,
                            isDefault: false,
                            hide: true,
                            groupId: (0, $3etjB.gridGroups).ADDRESS
                        },
                        {
                            ...(0, $c3iqc.marketShareColumns).marketSharePct,
                            isDefault: true,
                            hide: false
                        },
                        {
                            ...(0, $c3iqc.marketShareColumns).avgListDom,
                            isDefault: true,
                            hide: false
                        },
                        {
                            ...(0, $c3iqc.marketShareColumns).listAvgPrice,
                            isDefault: true,
                            hide: false
                        },
                        {
                            ...(0, $c3iqc.marketShareColumns).listSpop,
                            isDefault: true,
                            hide: false
                        },
                        {
                            ...(0, $c3iqc.marketShareColumns).prodAgentListUnits,
                            label: (0, $3etjB.marketShareTerms).unitsPerProducingAgent,
                            isDefault: true,
                            hide: false
                        },
                        {
                            ...(0, $c3iqc.marketShareColumns).prodAgentListVolume,
                            label: (0, $3etjB.marketShareTerms).volumePerProducingAgent,
                            isDefault: true,
                            hide: false
                        },
                        {
                            ...(0, $c3iqc.marketShareColumns).clr,
                            isDefault: true,
                            hide: false
                        },
                        {
                            ...(0, $c3iqc.marketShareColumns).prodAgentSearchCount,
                            isDefault: true,
                            hide: false
                        }
                    ]
                },
                columns: $3947b1c4768bc1a8$var$settingsColumnsOfficeListSide
            },
            [(0, $3etjB.listingTypes).byBrokerage.id]: $3947b1c4768bc1a8$var$settingsListSideUnitsByBrokerage,
            [(0, $3etjB.listingTypes).comparisonSet.id]: {
                ...$3947b1c4768bc1a8$var$settingsListSideUnitsByBrokerage,
                showHideOptions: {
                    ...$3947b1c4768bc1a8$var$settingsListSideUnitsByBrokerage.showHideOptions,
                    options: (0, $3etjB.listingTypes).comparisonSet.defaultShowHideOptions
                },
                columns: $3947b1c4768bc1a8$var$getComparisonSetColumns($3947b1c4768bc1a8$var$settingsListSideUnitsByBrokerage.columns)
            }
        }
    },
    underContract$Volume: {
        id: "underContract$Volume",
        label: (0, $3etjB.marketShareTerms).underContract$Volume,
        dataPointGroups: [
            (0, $3etjB.dataPoints).UNDER_CONTRACT_VOLUME
        ],
        xAxisLabelFormatter: $3947b1c4768bc1a8$export$75e2b31dabf1b229.volume,
        popOverDataFormatter: (0, $htzEo.popOverDataFormatters).volume,
        popOverLabels: [
            (0, $cstaF.marketShareListingStatuses)["UnderContract"]
        ],
        keyField: (0, $c3iqc.marketShareColumns).underContractVolume.id,
        settings: $3947b1c4768bc1a8$var$settingsUnderContract
    },
    underContractNumUnits: {
        id: "underContractNumUnits",
        label: (0, $3etjB.marketShareTerms).underContractNumUnits,
        dataPointGroups: [
            (0, $3etjB.dataPoints).UNDER_CONTRACT_UNITS
        ],
        xAxisLabelFormatter: $3947b1c4768bc1a8$export$75e2b31dabf1b229.units,
        popOverDataFormatter: (0, $htzEo.popOverDataFormatters).units,
        popOverLabels: [
            (0, $cstaF.marketShareListingStatuses)["UnderContract"]
        ],
        keyField: (0, $c3iqc.marketShareColumns).underContractUnits.id,
        settings: $3947b1c4768bc1a8$var$settingsUnderContract
    },
    sellSide$Volume: {
        id: "sellSide$Volume",
        label: (0, $3etjB.marketShareTerms).sellSide$Volume,
        dataPointGroups: [
            (0, $3etjB.dataPoints).SOLD_SELL_SIDE_VOLUME
        ],
        xAxisLabelFormatter: $3947b1c4768bc1a8$export$75e2b31dabf1b229.volume,
        popOverDataFormatter: (0, $htzEo.popOverDataFormatters).volume,
        popOverLabels: [
            (0, $cstaF.marketShareListingStatuses)["SoldSellSide"]
        ],
        keyField: (0, $c3iqc.marketShareColumns).sellVolume.id,
        settings: $3947b1c4768bc1a8$var$settingsSellSide
    },
    sellSideNumUnits: {
        id: "sellSideNumUnits",
        label: (0, $3etjB.marketShareTerms).sellSideNumUnits,
        dataPointGroups: [
            (0, $3etjB.dataPoints).SOLD_SELL_SIDE_UNITS
        ],
        xAxisLabelFormatter: $3947b1c4768bc1a8$export$75e2b31dabf1b229.units,
        popOverDataFormatter: (0, $htzEo.popOverDataFormatters).units,
        popOverLabels: [
            (0, $cstaF.marketShareListingStatuses)["SoldSellSide"]
        ],
        keyField: (0, $c3iqc.marketShareColumns).sellUnits.id,
        settings: $3947b1c4768bc1a8$var$settingsSellSide
    }
});
const $3947b1c4768bc1a8$export$9e4fb200713872a2 = (listingViewId, views)=>{
    return views.find((v)=>v.id === listingViewId) || views.find((v)=>v.keyField === listingViewId) || views.find((v)=>v.isDefault);
};

});
parcelRegister("7fq2m", function(module, exports) {

$parcel$export(module.exports, "agGridComponents", () => $e125323d45c1aae8$export$9ded470040dfd071);
$parcel$export(module.exports, "gridClasses", () => $e125323d45c1aae8$export$2100d54e36406477);
$parcel$export(module.exports, "gridColumnDefinitions", () => $e125323d45c1aae8$export$c0f6db12d479e12e);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4fGPb = parcelRequire("4fGPb");

var $htzEo = parcelRequire("htzEo");

var $c7dF9 = parcelRequire("c7dF9");

var $2oki8 = parcelRequire("2oki8");

var $jLmfc = parcelRequire("jLmfc");

var $3etjB = parcelRequire("3etjB");

var $c3iqc = parcelRequire("c3iqc");

var $2AfFv = parcelRequire("2AfFv");

var $dqgmD = parcelRequire("dqgmD");

var $cstaF = parcelRequire("cstaF");

var $98ROn = parcelRequire("98ROn");

var $2Wf8L = parcelRequire("2Wf8L");

var $2rG3e = parcelRequire("2rG3e");

var $93Pvi = parcelRequire("93Pvi");

var $kWnaD = parcelRequire("kWnaD");
const $e125323d45c1aae8$export$78a826b629503924 = {
    pagination: true,
    paginationPageSize: 10
};
const $e125323d45c1aae8$export$e76aea5d4e14d73c = {
    sortable: true,
    resizable: true,
    minWidth: 120,
    flex: 1
};
const $e125323d45c1aae8$export$9ded470040dfd071 = {
    agColumnHeader: (0, $2oki8.default)
};
const $e125323d45c1aae8$export$d4ddd0efd00905f2 = {
    cellClass: "",
    sortable: true,
    headerClass: "font-weight-bold",
    sortingOrder: [
        "asc",
        "desc"
    ],
    suppressHeaderMenuButton: true,
    cellRendererSelector: (0, $2AfFv.getCustomPinnedRow)
};
const $e125323d45c1aae8$var$colWidthDefaults = {
    flex: 1,
    minWidth: 120
};
const $e125323d45c1aae8$var$colHighlightRules = {
    cellClassRules: {
        "highlighted-column": (params)=>params.column.isSorting()
    }
};
const $e125323d45c1aae8$export$2100d54e36406477 = {
    cellNumber: "td-num",
    headerNumber: "header-number"
};
const $e125323d45c1aae8$export$94bae3b389ffa7 = {
    cellClass: $e125323d45c1aae8$export$2100d54e36406477.cellNumber,
    headerClass: `align-top no-wrap ${$e125323d45c1aae8$export$2100d54e36406477.headerNumber}`,
    sortable: true,
    width: (0, $98ROn.unitWidth).compact,
    sortingOrder: [
        "asc",
        "desc"
    ],
    suppressHeaderMenuButton: true,
    resizable: true,
    cellRendererSelector: (0, $2AfFv.getCustomPinnedRow)
};
const $e125323d45c1aae8$export$9983de2472d26634 = {
    decimalNumber: {
        valueFormatter: (v)=>(0, $htzEo.getDecimalNumber)(v.value)
    },
    percentage: {
        valueFormatter: (v)=>(0, $htzEo.formatPercentage)(v.value)
    },
    centuplePercentage: {
        valueFormatter: (v)=>(0, $htzEo.formatPercent)(v.value, 2)
    },
    volume: {
        valueFormatter: (v)=>(0, $htzEo.formatVolume)(v.value)
    },
    integer: {
        valueFormatter: (v)=>(0, $htzEo.formatInteger)(v.value)
    },
    clrFormatter: {
        valueFormatter: (v)=>(0, $htzEo.formatClr)(v.value)
    },
    dateFormat: {
        valueFormatter: (v)=>(0, $htzEo.shortDateFormatWithSlashes)(v.value)
    },
    bankStatus: {
        valueFormatter: (v)=>(0, $htzEo.boolToShortString)(v.value)
    }
};
const $e125323d45c1aae8$var$caseInsensitiveComparator = (a, b)=>a.toLowerCase().localeCompare(b.toLowerCase());
const $e125323d45c1aae8$export$4427de623c1aadc8 = {
    ...$e125323d45c1aae8$export$d4ddd0efd00905f2,
    floatingFilter: true,
    comparator: $e125323d45c1aae8$var$caseInsensitiveComparator,
    filter: "agTextColumnFilter"
};
const $e125323d45c1aae8$export$121fce8123c3ff88 = {
    ...$e125323d45c1aae8$export$94bae3b389ffa7,
    ...$e125323d45c1aae8$export$9983de2472d26634.volume,
    minWidth: 180
};
const $e125323d45c1aae8$var$pinnedRowSettingsCalculatedPct = {
    totalsSearch: {
        getFieldValue: (0, $dqgmD.getCalculatedPct)
    },
    coverageSearch: {
        getFieldValue: (0, $dqgmD.getPinnedCellValue)
    }
};
const $e125323d45c1aae8$var$pinnedRowSettingsEmptyCell = {
    cellValue: (0, $dqgmD.getEncodedCellValue)("")
};
const $e125323d45c1aae8$export$c0f6db12d479e12e = Object.freeze({
    [(0, $c3iqc.marketShareColumns).officeId.id]: {
        field: (0, $c3iqc.marketShareColumns).officeId.id,
        minWidth: 140,
        headerName: (0, $3etjB.marketShareTerms).officeId,
        ...$e125323d45c1aae8$export$d4ddd0efd00905f2,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules
    },
    [(0, $c3iqc.marketShareColumns).officeName.id]: {
        field: (0, $c3iqc.marketShareColumns).officeName.id,
        minWidth: (0, $98ROn.unitWidth).large,
        headerName: (0, $c3iqc.marketShareColumns).officeName.label,
        exportHeaderLabel: (0, $3etjB.marketShareTerms).officeName,
        ...$e125323d45c1aae8$export$4427de623c1aadc8,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        cellRenderer: (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2rG3e.OfficeName), {
                ...props
            }),
        floatingFilterComponent: (0, $kWnaD.default),
        floatingFilterComponentParams: {
            placeholder: ""
        },
        pinnedRowSettings: {
            "default": {
                cellValue: (0, $cstaF.agentProductionTerms).totalsAverages
            }
        }
    },
    [(0, $c3iqc.marketShareColumns).office.id]: {
        field: (0, $c3iqc.marketShareColumns).officeName.id,
        minWidth: 320,
        headerName: (0, $c3iqc.marketShareColumns).office.label,
        ...$e125323d45c1aae8$export$4427de623c1aadc8,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules
    },
    /* Address Group */ [(0, $c3iqc.marketShareColumns).streetName1.id]: {
        field: (0, $c3iqc.marketShareColumns).streetName1.id,
        minWidth: 260,
        headerName: (0, $c3iqc.marketShareColumns).streetName1.label,
        ...$e125323d45c1aae8$export$d4ddd0efd00905f2,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules
    },
    [(0, $c3iqc.marketShareColumns).streetName.id]: {
        field: (0, $c3iqc.marketShareColumns).streetName.id,
        minWidth: 260,
        headerName: (0, $c3iqc.marketShareColumns).streetName.label,
        ...$e125323d45c1aae8$export$d4ddd0efd00905f2,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules
    },
    [(0, $c3iqc.marketShareColumns).streetNum.id]: {
        field: (0, $c3iqc.marketShareColumns).streetNum.id,
        headerName: (0, $c3iqc.marketShareColumns).streetNum.label,
        ...$e125323d45c1aae8$export$d4ddd0efd00905f2,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules
    },
    [(0, $c3iqc.marketShareColumns).address.id]: {
        field: (0, $c3iqc.marketShareColumns).address.id,
        minWidth: 230,
        headerName: (0, $c3iqc.marketShareColumns).address.label,
        ...$e125323d45c1aae8$export$d4ddd0efd00905f2,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        cellRenderer: (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $jLmfc.AddressLink), {
                ...props,
                pathname: `${(0, $cstaF.drillDownRoutesByModule)[(0, $cstaF.moduleNames).marketShare].listingInfo}`
            })
    },
    [(0, $c3iqc.marketShareColumns).listOfficeId.id]: {
        field: (0, $c3iqc.marketShareColumns).listOfficeId.id,
        headerName: (0, $c3iqc.marketShareColumns).listOfficeId.label,
        ...$e125323d45c1aae8$export$4427de623c1aadc8,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        minWidth: (0, $98ROn.unitWidth).moderate
    },
    [(0, $c3iqc.marketShareColumns).listOfficeName.id]: {
        field: (0, $c3iqc.marketShareColumns).listOfficeName.id,
        headerName: (0, $c3iqc.marketShareColumns).listOfficeName.label,
        ...$e125323d45c1aae8$export$4427de623c1aadc8,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        minWidth: 200
    },
    [(0, $c3iqc.marketShareColumns).sellOfficeId.id]: {
        field: (0, $c3iqc.marketShareColumns).sellOfficeId.id,
        headerName: (0, $c3iqc.marketShareColumns).sellOfficeId.label,
        ...$e125323d45c1aae8$export$4427de623c1aadc8,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        minWidth: (0, $98ROn.unitWidth).moderate
    },
    [(0, $c3iqc.marketShareColumns).sellOfficeName.id]: {
        field: (0, $c3iqc.marketShareColumns).sellOfficeName.id,
        headerName: (0, $c3iqc.marketShareColumns).sellOfficeName.label,
        ...$e125323d45c1aae8$export$4427de623c1aadc8,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        minWidth: 200
    },
    [(0, $c3iqc.marketShareColumns).averageDom.id]: {
        field: (0, $c3iqc.marketShareColumns).averageDom.id,
        headerName: (0, $c3iqc.marketShareColumns).averageDom.label,
        minWidth: (0, $98ROn.unitWidth).dom,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.integer,
        exportFormatter: (0, $dqgmD.csvFormats).integer.format,
        width: (0, $98ROn.unitWidth).small,
        pinnedRowSettings: {
            "default": {
                keyField: (0, $c3iqc.marketShareColumns).avgDom.id
            }
        }
    },
    [(0, $c3iqc.marketShareColumns).avgDom.id]: {
        field: (0, $c3iqc.marketShareColumns).avgDom.id,
        headerName: (0, $c3iqc.marketShareColumns).averageDom.label,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.integer,
        exportFormatter: (0, $dqgmD.csvFormats).integer.format,
        minWidth: (0, $98ROn.unitWidth).dom
    },
    [(0, $c3iqc.marketShareColumns).underContractVolume.id]: {
        field: (0, $c3iqc.marketShareColumns).underContractVolume.id,
        headerName: (0, $3etjB.marketShareTerms).underContract$,
        exportHeaderLabel: (0, $3etjB.marketShareTerms).underContractVolume,
        minWidth: 200,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.volume,
        exportFormatter: (0, $dqgmD.csvFormats).volume.format
    },
    [(0, $c3iqc.marketShareColumns).ucVolumeAlt.id]: {
        field: (0, $c3iqc.marketShareColumns).ucVolumeAlt.keyField,
        headerName: (0, $3etjB.marketShareTerms).underContract$,
        exportHeaderLabel: (0, $3etjB.marketShareTerms).underContractVolume,
        minWidth: 200,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.volume,
        exportFormatter: (0, $dqgmD.csvFormats).volume.format
    },
    [(0, $c3iqc.marketShareColumns).underContractUnits.id]: {
        field: (0, $c3iqc.marketShareColumns).underContractUnits.id,
        headerName: (0, $3etjB.marketShareTerms).underContractNum,
        exportHeaderLabel: (0, $3etjB.marketShareTerms).underContractUnits,
        minWidth: 200,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.integer,
        exportFormatter: (0, $dqgmD.csvFormats).decimal.format
    },
    [(0, $c3iqc.marketShareColumns).ucUnitsAlt.id]: {
        field: (0, $c3iqc.marketShareColumns).ucUnitsAlt.keyField,
        headerName: (0, $3etjB.marketShareTerms).underContractNum,
        exportHeaderLabel: (0, $3etjB.marketShareTerms).underContractUnits,
        minWidth: 200,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.integer,
        exportFormatter: (0, $dqgmD.csvFormats).decimal.format
    },
    [(0, $c3iqc.marketShareColumns).newListingVolume.id]: {
        field: (0, $c3iqc.marketShareColumns).newListingVolume.id,
        headerName: (0, $3etjB.marketShareTerms).newListing$,
        exportHeaderLabel: (0, $3etjB.marketShareTerms).newListingVolume,
        ...$e125323d45c1aae8$export$121fce8123c3ff88,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        exportFormatter: (0, $dqgmD.csvFormats).volume.format
    },
    [(0, $c3iqc.marketShareColumns).newVolume.id]: {
        field: (0, $c3iqc.marketShareColumns).newVolume.keyField,
        headerName: (0, $3etjB.marketShareTerms).newListing$,
        exportHeaderLabel: (0, $3etjB.marketShareTerms).newListingVolume,
        ...$e125323d45c1aae8$export$121fce8123c3ff88,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        exportFormatter: (0, $dqgmD.csvFormats).volume.format
    },
    [(0, $c3iqc.marketShareColumns).newListingUnits.id]: {
        field: (0, $c3iqc.marketShareColumns).newListingUnits.id,
        headerName: (0, $3etjB.marketShareTerms).newListingNum,
        exportHeaderLabel: (0, $3etjB.marketShareTerms).newListingUnits,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.integer,
        exportFormatter: (0, $dqgmD.csvFormats).decimal.format,
        width: (0, $98ROn.unitWidth).small
    },
    [(0, $c3iqc.marketShareColumns).newUnits.id]: {
        field: (0, $c3iqc.marketShareColumns).newUnits.keyField,
        headerName: (0, $3etjB.marketShareTerms).newListingNum,
        exportHeaderLabel: (0, $3etjB.marketShareTerms).newListingUnits,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.integer,
        exportFormatter: (0, $dqgmD.csvFormats).decimal.format,
        width: (0, $98ROn.unitWidth).small
    },
    [(0, $c3iqc.marketShareColumns).forSaleVolume.id]: {
        field: (0, $c3iqc.marketShareColumns).forSaleVolume.id,
        headerName: (0, $3etjB.marketShareTerms).forSale$,
        ...$e125323d45c1aae8$export$121fce8123c3ff88,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        exportFormatter: (0, $dqgmD.csvFormats).volume.format
    },
    [(0, $c3iqc.marketShareColumns).fsVolume.id]: {
        field: (0, $c3iqc.marketShareColumns).fsVolume.keyField,
        headerName: (0, $3etjB.marketShareTerms).forSale$,
        ...$e125323d45c1aae8$export$121fce8123c3ff88,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        exportFormatter: (0, $dqgmD.csvFormats).volume.format
    },
    [(0, $c3iqc.marketShareColumns).forSaleUnits.id]: {
        field: (0, $c3iqc.marketShareColumns).forSaleUnits.id,
        headerName: (0, $3etjB.marketShareTerms).forSaleNum,
        minWidth: 190,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.integer,
        exportFormatter: (0, $dqgmD.csvFormats).decimal.format,
        width: (0, $98ROn.unitWidth).small
    },
    [(0, $c3iqc.marketShareColumns).fsUnits.id]: {
        field: (0, $c3iqc.marketShareColumns).fsUnits.keyField,
        headerName: (0, $3etjB.marketShareTerms).forSaleNum,
        minWidth: 140,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.integer,
        exportFormatter: (0, $dqgmD.csvFormats).decimal.format
    },
    [(0, $c3iqc.marketShareColumns).averagePrice.id]: {
        field: (0, $c3iqc.marketShareColumns).averagePrice.id,
        headerName: (0, $3etjB.marketShareTerms).avg$,
        exportHeaderLabel: (0, $3etjB.marketShareTerms).avgPrice,
        minWidth: (0, $98ROn.unitWidth).compact,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.volume,
        exportFormatter: (0, $dqgmD.csvFormats).volume.format,
        pinnedRowSettings: {
            totalsSearch: {
                keyField: (0, $c3iqc.marketShareColumns).avgPrice.id
            },
            coverageSearch: {
                keyField: (0, $c3iqc.marketShareColumns).avgPrice.id
            }
        }
    },
    [(0, $c3iqc.marketShareColumns).avgPrice.id]: {
        field: (0, $c3iqc.marketShareColumns).avgPrice.id,
        headerName: (0, $3etjB.marketShareTerms).avg$,
        exportHeaderLabel: (0, $3etjB.marketShareTerms).avgPrice,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.volume,
        minWidth: (0, $98ROn.unitWidth).compact,
        exportFormatter: (0, $dqgmD.csvFormats).volume.format
    },
    [(0, $c3iqc.marketShareColumns).agentCount.id]: {
        field: (0, $c3iqc.marketShareColumns).agentCount.id,
        headerName: (0, $c3iqc.marketShareColumns).agentCount.label,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        exportFormatter: (0, $dqgmD.csvFormats).integer.format,
        ...$e125323d45c1aae8$export$9983de2472d26634.integer,
        width: (0, $98ROn.unitWidth).small
    },
    [(0, $c3iqc.marketShareColumns).mlsAgentCount.id]: {
        field: (0, $c3iqc.marketShareColumns).mlsAgentCount.id,
        headerName: (0, $c3iqc.marketShareColumns).agentCount.label,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.integer,
        width: (0, $98ROn.unitWidth).small,
        pinnedRowSettings: {
            "default": $e125323d45c1aae8$var$pinnedRowSettingsEmptyCell
        }
    },
    [(0, $c3iqc.marketShareColumns).city.id]: {
        field: (0, $c3iqc.marketShareColumns).city.id,
        headerName: (0, $c3iqc.marketShareColumns).city.label,
        minWidth: 190,
        ...$e125323d45c1aae8$export$d4ddd0efd00905f2,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules
    },
    [(0, $c3iqc.marketShareColumns).stateCode.id]: {
        field: (0, $c3iqc.marketShareColumns).stateCode.id,
        minWidth: 73,
        headerName: (0, $c3iqc.marketShareColumns).stateCode.label,
        ...$e125323d45c1aae8$export$d4ddd0efd00905f2,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules
    },
    [(0, $c3iqc.marketShareColumns).zipCode.id]: {
        field: (0, $c3iqc.marketShareColumns).zipCode.id,
        minWidth: 93,
        headerName: (0, $c3iqc.marketShareColumns).zipCode.label,
        ...$e125323d45c1aae8$export$d4ddd0efd00905f2,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules
    },
    [(0, $c3iqc.marketShareColumns).zipcode.id]: {
        field: (0, $c3iqc.marketShareColumns).zipcode.id,
        minWidth: 93,
        headerName: (0, $c3iqc.marketShareColumns).zipcode.label,
        ...$e125323d45c1aae8$export$d4ddd0efd00905f2,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules
    },
    [(0, $c3iqc.marketShareColumns).county.id]: {
        field: (0, $c3iqc.marketShareColumns).county.id,
        minWidth: (0, $98ROn.unitWidth).regular,
        headerName: (0, $c3iqc.marketShareColumns).county.label,
        ...$e125323d45c1aae8$export$d4ddd0efd00905f2,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules
    },
    [(0, $c3iqc.marketShareColumns).phoneNumber.id]: {
        field: (0, $c3iqc.marketShareColumns).phoneNumber.id,
        minWidth: 150,
        headerName: (0, $c3iqc.marketShareColumns).phoneNumber.label,
        ...$e125323d45c1aae8$export$d4ddd0efd00905f2,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules
    },
    [(0, $c3iqc.marketShareColumns).brokerName.id]: {
        field: (0, $c3iqc.marketShareColumns).brokerName.id,
        headerName: (0, $c3iqc.marketShareColumns).brokerName.label,
        minWidth: (0, $98ROn.unitWidth).large,
        ...$e125323d45c1aae8$export$4427de623c1aadc8,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        cellRenderer: (props)=>{
            const brokerageParam = encodeURIComponent(props.data.brokerName);
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fGPb.Link), {
                to: {
                    pathname: `${(0, $c7dF9.Routes).MARKET_SHARE.BASE}${(0, $c7dF9.Routes).MARKET_SHARE.TOTALS}${(0, $c7dF9.Routes).MARKET_SHARE.OFFICES_BREAKDOWN}`,
                    search: `?brokerage=${brokerageParam}&id=${props.data.brokerId}&view=${props.data.listingViewId}`,
                    state: {
                        brokerage: brokerageParam,
                        id: props.data.brokerId,
                        type: props.data.listingTypeId,
                        sumOfColumn: props.data.sumOfColumn,
                        rowCount: props.data.rowCount
                    }
                },
                children: props.value
            });
        },
        pinnedRowSettings: {
            "default": {
                cellValue: (0, $cstaF.agentProductionTerms).totalsAverages
            }
        }
    },
    [(0, $c3iqc.marketShareColumns).listVolume.id]: {
        field: (0, $c3iqc.marketShareColumns).listVolume.id,
        headerName: (0, $c3iqc.marketShareColumns).listVolume.label,
        exportHeaderLabel: (0, $3etjB.marketShareTerms).listSideVolume,
        ...$e125323d45c1aae8$export$121fce8123c3ff88,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        exportFormatter: (0, $dqgmD.csvFormats).volume.format
    },
    [(0, $c3iqc.marketShareColumns).listUnits.id]: {
        field: (0, $c3iqc.marketShareColumns).listUnits.id,
        headerName: (0, $c3iqc.marketShareColumns).listUnits.label,
        exportHeaderLabel: (0, $3etjB.marketShareTerms).listSideUnit,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.decimalNumber,
        exportFormatter: (0, $dqgmD.csvFormats).decimal.format,
        width: (0, $98ROn.unitWidth).small
    },
    [(0, $c3iqc.marketShareColumns).sellVolume.id]: {
        field: (0, $c3iqc.marketShareColumns).sellVolume.id,
        headerName: (0, $c3iqc.marketShareColumns).sellVolume.label,
        exportHeaderLabel: (0, $3etjB.marketShareTerms).sellSideVolume,
        ...$e125323d45c1aae8$export$121fce8123c3ff88,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        exportFormatter: (0, $dqgmD.csvFormats).volume.format,
        cellClassRules: {
            "highlighted-column": (params)=>params.column.isSorting()
        }
    },
    [(0, $c3iqc.marketShareColumns).sellUnits.id]: {
        field: (0, $c3iqc.marketShareColumns).sellUnits.id,
        headerName: (0, $c3iqc.marketShareColumns).sellUnits.label,
        exportHeaderLabel: (0, $3etjB.marketShareTerms).sellSideUnit,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.decimalNumber,
        exportFormatter: (0, $dqgmD.csvFormats).decimal.format,
        width: (0, $98ROn.unitWidth).small,
        cellClassRules: {
            "highlighted-column": (params)=>params.column.isSorting()
        }
    },
    [(0, $c3iqc.marketShareColumns).totalVolume.id]: {
        field: (0, $c3iqc.marketShareColumns).totalVolume.id,
        headerName: (0, $3etjB.marketShareTerms).total$,
        ...$e125323d45c1aae8$export$121fce8123c3ff88,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        exportFormatter: (0, $dqgmD.csvFormats).volume.format,
        cellClassRules: {
            "highlighted-column": (params)=>params.column.isSorting()
        }
    },
    [(0, $c3iqc.marketShareColumns).totalUnits.id]: {
        field: (0, $c3iqc.marketShareColumns).totalUnits.id,
        headerName: (0, $c3iqc.marketShareColumns).totalUnits.label,
        minWidth: 140,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.decimalNumber,
        exportFormatter: (0, $dqgmD.csvFormats).decimal.format,
        width: 110,
        cellClassRules: {
            "highlighted-column": (params)=>params.column.isSorting()
        }
    },
    [(0, $c3iqc.marketShareColumns).totalAverageDom.id]: {
        field: (0, $c3iqc.marketShareColumns).totalAverageDom.id,
        headerName: (0, $c3iqc.marketShareColumns).totalAverageDom.label,
        minWidth: (0, $98ROn.unitWidth).dom,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.integer,
        exportFormatter: (0, $dqgmD.csvFormats).integer.format,
        width: (0, $98ROn.unitWidth).small
    },
    [(0, $c3iqc.marketShareColumns).officeCount.id]: {
        field: (0, $c3iqc.marketShareColumns).officeCount.id,
        headerName: (0, $c3iqc.marketShareColumns).officeCount.label,
        minWidth: (0, $98ROn.unitWidth).compact,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules
    },
    [(0, $c3iqc.marketShareColumns).mlsOfficeCount.id]: {
        field: (0, $c3iqc.marketShareColumns).mlsOfficeCount.id,
        headerName: (0, $c3iqc.marketShareColumns).officeCount.label,
        minWidth: (0, $98ROn.unitWidth).compact,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        pinnedRowSettings: {
            "default": $e125323d45c1aae8$var$pinnedRowSettingsEmptyCell
        }
    },
    [(0, $c3iqc.marketShareColumns).avgListDom.id]: {
        field: (0, $c3iqc.marketShareColumns).avgListDom.id,
        headerName: (0, $c3iqc.marketShareColumns).avgListDom.label,
        maxWidth: (0, $98ROn.unitWidth).dom,
        minWidth: (0, $98ROn.unitWidth).dom,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.integer,
        exportFormatter: (0, $dqgmD.csvFormats).integer.format,
        pinnedRowSettings: {
            coverageSearch: {
                keyField: (0, $c3iqc.marketShareColumns).avgDom.id
            }
        }
    },
    [(0, $c3iqc.marketShareColumns).listAverageDom.id]: {
        field: (0, $c3iqc.marketShareColumns).listAverageDom.id,
        headerName: (0, $c3iqc.marketShareColumns).avgListDom.label,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.integer,
        minWidth: (0, $98ROn.unitWidth).dom,
        exportFormatter: (0, $dqgmD.csvFormats).integer.format,
        pinnedRowSettings: {
            "default": {
                keyField: "listAvgDom"
            }
        }
    },
    [(0, $c3iqc.marketShareColumns).avgSellDom.id]: {
        field: (0, $c3iqc.marketShareColumns).avgSellDom.id,
        headerName: (0, $c3iqc.marketShareColumns).avgSellDom.label,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.integer,
        exportFormatter: (0, $dqgmD.csvFormats).integer.format,
        width: (0, $98ROn.unitWidth).small
    },
    [(0, $c3iqc.marketShareColumns).listAvgPrice.id]: {
        field: (0, $c3iqc.marketShareColumns).listAvgPrice.id,
        headerName: (0, $3etjB.marketShareTerms).avg$,
        exportHeaderLabel: (0, $3etjB.marketShareTerms).avgPrice,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.volume,
        minWidth: (0, $98ROn.unitWidth).compact,
        exportFormatter: (0, $dqgmD.csvFormats).volume.format
    },
    [(0, $c3iqc.marketShareColumns).listAveragePrice.id]: {
        field: (0, $c3iqc.marketShareColumns).listAveragePrice.id,
        headerName: (0, $3etjB.marketShareTerms).avg$,
        exportHeaderLabel: (0, $3etjB.marketShareTerms).avgPrice,
        minWidth: (0, $98ROn.unitWidth).compact,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.volume,
        exportFormatter: (0, $dqgmD.csvFormats).volume.format,
        pinnedRowSettings: {
            totalsSearch: {
                keyField: (0, $c3iqc.marketShareColumns).listAvgPrice.id
            },
            coverageSearch: {
                keyField: (0, $c3iqc.marketShareColumns).listAvgPrice.id
            }
        }
    },
    [(0, $c3iqc.marketShareColumns).sellAveragePrice.id]: {
        field: (0, $c3iqc.marketShareColumns).sellAveragePrice.id,
        headerName: (0, $3etjB.marketShareTerms).avg$,
        exportHeaderLabel: (0, $3etjB.marketShareTerms).avgPrice,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.volume,
        minWidth: (0, $98ROn.unitWidth).compact,
        exportFormatter: (0, $dqgmD.csvFormats).volume.format,
        pinnedRowSettings: {
            totalsSearch: {
                keyField: (0, $c3iqc.marketShareColumns).sellAvgPrice.id
            },
            coverageSearch: {
                keyField: (0, $c3iqc.marketShareColumns).sellAvgPrice.id
            }
        }
    },
    [(0, $c3iqc.marketShareColumns).totalAvgPrice.id]: {
        field: (0, $c3iqc.marketShareColumns).totalAvgPrice.id,
        headerName: (0, $3etjB.marketShareTerms).avg$,
        exportHeaderLabel: (0, $3etjB.marketShareTerms).avgPrice,
        minWidth: (0, $98ROn.unitWidth).compact,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.volume,
        exportFormatter: (0, $dqgmD.csvFormats).volume.format,
        pinnedRowSettings: {
            coverageSearch: {
                altKeyField: "actAvgPrice"
            }
        }
    },
    [(0, $c3iqc.marketShareColumns).totalAveragePrice.id]: {
        field: (0, $c3iqc.marketShareColumns).totalAveragePrice.id,
        headerName: (0, $3etjB.marketShareTerms).avg$,
        exportHeaderLabel: (0, $3etjB.marketShareTerms).avgPrice,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.volume,
        exportFormatter: (0, $dqgmD.csvFormats).volume.format,
        minWidth: (0, $98ROn.unitWidth).compact,
        pinnedRowSettings: {
            totalsSearch: {
                keyField: (0, $c3iqc.marketShareColumns).totalAvgPrice.id
            },
            coverageSearch: {
                keyField: (0, $c3iqc.marketShareColumns).totalAvgPrice.id
            }
        }
    },
    [(0, $c3iqc.marketShareColumns).listAvgPrice.id]: {
        field: (0, $c3iqc.marketShareColumns).listAvgPrice.id,
        headerName: (0, $3etjB.marketShareTerms).avg$,
        exportHeaderLabel: (0, $3etjB.marketShareTerms).avgPrice,
        minWidth: (0, $98ROn.unitWidth).compact,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.volume,
        exportFormatter: (0, $dqgmD.csvFormats).volume.format
    },
    [(0, $c3iqc.marketShareColumns).sellAvgPrice.id]: {
        field: (0, $c3iqc.marketShareColumns).sellAvgPrice.id,
        headerName: (0, $3etjB.marketShareTerms).avg$,
        exportHeaderLabel: (0, $3etjB.marketShareTerms).avgPrice,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.volume,
        exportFormatter: (0, $dqgmD.csvFormats).volume.format
    },
    [(0, $c3iqc.marketShareColumns).spOp.id]: {
        field: (0, $c3iqc.marketShareColumns).spOp.id,
        headerName: (0, $c3iqc.marketShareColumns).spOp.label,
        exportHeaderLabel: (0, $3etjB.marketShareTerms).spOpPct,
        minWidth: 100,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.percentage,
        exportFormatter: (0, $dqgmD.csvFormats).percentage.format
    },
    [(0, $c3iqc.marketShareColumns).spop.id]: {
        field: (0, $c3iqc.marketShareColumns).spop.id,
        headerName: (0, $c3iqc.marketShareColumns).spop.label,
        exportHeaderLabel: (0, $3etjB.marketShareTerms).spOpPct,
        exportFormatter: (0, $dqgmD.csvFormats).percent2Decimals.format,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.centuplePercentage
    },
    [(0, $c3iqc.marketShareColumns).splp.id]: {
        field: (0, $c3iqc.marketShareColumns).splp.id,
        headerName: (0, $c3iqc.marketShareColumns).splp.label,
        exportHeaderLabel: (0, $c3iqc.marketShareColumns).spLp.label,
        exportFormatter: (0, $dqgmD.csvFormats).percent2Decimals.format,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.centuplePercentage
    },
    [(0, $c3iqc.marketShareColumns).listSpop.id]: {
        field: (0, $c3iqc.marketShareColumns).listSpop.id,
        headerName: (0, $c3iqc.marketShareColumns).listSpop.label,
        exportHeaderLabel: (0, $3etjB.marketShareTerms).spOpPct,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.percentage,
        exportFormatter: (0, $dqgmD.csvFormats).percent2Decimals.format,
        pinnedRowSettings: {
            totalsSearch: {
                total: {
                    keyField: (0, $c3iqc.marketShareColumns).listSpop.id,
                    getFieldValue: (0, $dqgmD.getCalculatedPct)
                },
                breakdown: {
                    keyField: (0, $c3iqc.marketShareColumns).listSpop.id,
                    getFieldValue: (0, $dqgmD.getPinnedCellValue)
                }
            },
            coverageSearch: {
                total: {
                    keyField: (0, $c3iqc.marketShareColumns).listSpop.id,
                    getFieldValue: (0, $dqgmD.getCalculatedPct)
                },
                breakdown: {
                    keyField: (0, $c3iqc.marketShareColumns).listSpop.id,
                    getFieldValue: (0, $dqgmD.getPinnedCellValue)
                }
            }
        }
    },
    [(0, $c3iqc.marketShareColumns).sellSpop.id]: {
        field: (0, $c3iqc.marketShareColumns).sellSpop.id,
        headerName: (0, $c3iqc.marketShareColumns).sellSpop.label,
        exportHeaderLabel: (0, $3etjB.marketShareTerms).spOpPct,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.percentage,
        exportFormatter: (0, $dqgmD.csvFormats).percent2Decimals.format,
        pinnedRowSettings: {
            totalsSearch: {
                total: {
                    keyField: (0, $c3iqc.marketShareColumns).sellSpop.id,
                    getFieldValue: (0, $dqgmD.getCalculatedPct)
                },
                breakdown: {
                    keyField: (0, $c3iqc.marketShareColumns).sellSpop.id,
                    getFieldValue: (0, $dqgmD.getPinnedCellValue)
                }
            },
            coverageSearch: {
                total: {
                    keyField: (0, $c3iqc.marketShareColumns).sellSpop.id,
                    getFieldValue: (0, $dqgmD.getCalculatedPct)
                },
                breakdown: {
                    keyField: (0, $c3iqc.marketShareColumns).sellSpop.id,
                    getFieldValue: (0, $dqgmD.getPinnedCellValue)
                }
            }
        }
    },
    [(0, $c3iqc.marketShareColumns).prodAgentTotalUnits.id]: {
        field: (0, $c3iqc.marketShareColumns).prodAgentTotalUnits.id,
        headerName: (0, $3etjB.marketShareTerms).prodAgentUnits,
        minWidth: 100,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.decimalNumber,
        exportFormatter: (0, $dqgmD.csvFormats).decimal.format,
        width: (0, $98ROn.unitWidth).small,
        pinnedRowSettings: {
            "default": $e125323d45c1aae8$var$pinnedRowSettingsEmptyCell
        }
    },
    [(0, $c3iqc.marketShareColumns).prodAgentSellUnits.id]: {
        field: (0, $c3iqc.marketShareColumns).prodAgentSellUnits.id,
        headerName: (0, $3etjB.marketShareTerms).prodAgentUnits,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.decimalNumber,
        exportFormatter: (0, $dqgmD.csvFormats).decimal.format,
        width: (0, $98ROn.unitWidth).small,
        pinnedRowSettings: {
            totalsSearch: $e125323d45c1aae8$var$pinnedRowSettingsEmptyCell
        }
    },
    [(0, $c3iqc.marketShareColumns).prodAgentTotalVolume.id]: {
        field: (0, $c3iqc.marketShareColumns).prodAgentTotalVolume.id,
        headerName: (0, $3etjB.marketShareTerms).prodAgentVolume,
        minWidth: 140,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.volume,
        exportFormatter: (0, $dqgmD.csvFormats).volume.format,
        pinnedRowSettings: {
            totalsSearch: $e125323d45c1aae8$var$pinnedRowSettingsEmptyCell
        }
    },
    [(0, $c3iqc.marketShareColumns).prodAgentVolume.id]: {
        field: (0, $c3iqc.marketShareColumns).prodAgentVolume.id,
        headerName: (0, $3etjB.marketShareTerms).prodAgentVolume,
        minWidth: 140,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.volume,
        exportFormatter: (0, $dqgmD.csvFormats).volume.format,
        pinnedRowSettings: {
            totalsSearch: $e125323d45c1aae8$var$pinnedRowSettingsEmptyCell
        }
    },
    [(0, $c3iqc.marketShareColumns).prodAgentUnits.id]: {
        field: (0, $c3iqc.marketShareColumns).prodAgentUnits.id,
        headerName: (0, $3etjB.marketShareTerms).prodAgentUnits,
        minWidth: 100,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.decimalNumber,
        exportFormatter: (0, $dqgmD.csvFormats).decimal.format,
        width: (0, $98ROn.unitWidth).small,
        pinnedRowSettings: {
            "default": $e125323d45c1aae8$var$pinnedRowSettingsEmptyCell
        }
    },
    [(0, $c3iqc.marketShareColumns).prodAgentSellVolume.id]: {
        field: (0, $c3iqc.marketShareColumns).prodAgentSellVolume.id,
        headerName: (0, $3etjB.marketShareTerms).prodAgentVolume,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.volume,
        minWidth: (0, $98ROn.unitWidth).compact,
        exportFormatter: (0, $dqgmD.csvFormats).volume.format,
        pinnedRowSettings: {
            totalsSearch: $e125323d45c1aae8$var$pinnedRowSettingsEmptyCell
        }
    },
    [(0, $c3iqc.marketShareColumns).prodAgentListUnits.id]: {
        field: (0, $c3iqc.marketShareColumns).prodAgentListUnits.id,
        headerName: (0, $3etjB.marketShareTerms).prodAgentUnits,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.decimalNumber,
        exportFormatter: (0, $dqgmD.csvFormats).decimal.format,
        pinnedRowSettings: {
            totalsSearch: $e125323d45c1aae8$var$pinnedRowSettingsEmptyCell
        }
    },
    [(0, $c3iqc.marketShareColumns).prodAgentListVolume.id]: {
        field: (0, $c3iqc.marketShareColumns).prodAgentListVolume.id,
        headerName: (0, $3etjB.marketShareTerms).prodAgentVolume,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.volume,
        minWidth: (0, $98ROn.unitWidth).compact,
        exportFormatter: (0, $dqgmD.csvFormats).volume.format,
        pinnedRowSettings: {
            totalsSearch: $e125323d45c1aae8$var$pinnedRowSettingsEmptyCell
        }
    },
    [(0, $c3iqc.marketShareColumns).clr.id]: {
        field: (0, $c3iqc.marketShareColumns).clr.id,
        headerName: (0, $3etjB.marketShareTerms).clrPct,
        minWidth: 100,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.clrFormatter,
        width: (0, $98ROn.unitWidth).small,
        exportFormatter: (0, $dqgmD.csvFormats).percentageEmptyCell.format,
        pinnedRowSettings: {
            totalsSearch: {
                total: {
                    keyField: (0, $c3iqc.marketShareColumns).clr.id,
                    getFieldValue: (0, $dqgmD.getPinnedCellValue)
                },
                breakdown: {
                    keyField: (0, $c3iqc.marketShareColumns).closeListRatio.id,
                    getFieldValue: (0, $dqgmD.getPinnedCellValue)
                }
            },
            coverageSearch: {
                total: {
                    keyField: (0, $c3iqc.marketShareColumns).closeListRatio.id,
                    getFieldValue: (0, $dqgmD.getPinnedCellValue)
                }
            }
        }
    },
    [(0, $c3iqc.marketShareColumns).closeListRatio.id]: {
        field: (0, $c3iqc.marketShareColumns).closeListRatio.id,
        headerName: (0, $3etjB.marketShareTerms).clrPct,
        minWidth: 100,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.percentage,
        exportFormatter: (0, $dqgmD.csvFormats).percent2Decimals.format,
        width: (0, $98ROn.unitWidth).small,
        pinnedRowSettings: {
            coverageSearch: {
                total: {
                    keyField: (0, $c3iqc.marketShareColumns).clr.id,
                    getFieldValue: (0, $dqgmD.getPinnedCellValue)
                },
                breakdown: {
                    keyField: (0, $c3iqc.marketShareColumns).closeListRatio.id,
                    getFieldValue: (0, $dqgmD.getPinnedCellValue)
                }
            }
        }
    },
    [(0, $c3iqc.marketShareColumns).marketSharePct.id]: {
        field: (0, $c3iqc.marketShareColumns).marketSharePct.id,
        headerName: (0, $3etjB.marketShareTerms).mktPct,
        minWidth: 100,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.percentage,
        exportFormatter: (0, $dqgmD.csvFormats).percent2Decimals.format,
        width: (0, $98ROn.unitWidth).small,
        pinnedRowSettings: {
            "default": {
                getFieldValue: (0, $dqgmD.getColumnSum)
            }
        }
    },
    [(0, $c3iqc.marketShareColumns).unitSharePct.id]: {
        field: (0, $c3iqc.marketShareColumns).unitSharePct.id,
        headerName: (0, $3etjB.marketShareTerms).unitPct,
        minWidth: 110,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.percentage,
        exportFormatter: (0, $dqgmD.csvFormats).percentage.format,
        width: (0, $98ROn.unitWidth).small,
        pinnedRowSettings: {
            coverageSearch: {
                getFieldValue: (0, $dqgmD.getColumnSum)
            }
        }
    },
    [(0, $c3iqc.marketShareColumns).volumeSharePct.id]: {
        field: (0, $c3iqc.marketShareColumns).volumeSharePct.id,
        headerName: (0, $3etjB.marketShareTerms).volumePct,
        minWidth: (0, $98ROn.unitWidth).compact,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.percentage,
        exportFormatter: (0, $dqgmD.csvFormats).percentage.format,
        pinnedRowSettings: {
            coverageSearch: {
                getFieldValue: (0, $dqgmD.getColumnSum)
            }
        }
    },
    [(0, $c3iqc.marketShareColumns).prodAgentCount.id]: {
        field: (0, $c3iqc.marketShareColumns).prodAgentCount.id,
        headerName: (0, $3etjB.marketShareTerms).prodAgentCount,
        exportHeaderLabel: (0, $3etjB.marketShareTerms).prodAgents,
        minWidth: (0, $98ROn.unitWidth).small,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.integer,
        width: (0, $98ROn.unitWidth).small,
        pinnedRowSettings: {
            totalsSearch: {
                keyField: (0, $c3iqc.marketShareColumns).prodAgentCount.id
            }
        }
    },
    [(0, $c3iqc.marketShareColumns).prodAgentSearchCount.id]: {
        field: (0, $c3iqc.marketShareColumns).prodAgentSearchCount.id,
        headerName: (0, $3etjB.marketShareTerms).prodAgentCount,
        exportHeaderLabel: (0, $3etjB.marketShareTerms).prodAgents,
        minWidth: (0, $98ROn.unitWidth).small,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.integer,
        pinnedRowSettings: {
            "default": {
                getFieldValue: (0, $dqgmD.getColumnSum)
            }
        }
    },
    [(0, $c3iqc.marketShareColumns).listProdAgentSearchCount.id]: {
        field: (0, $c3iqc.marketShareColumns).listProdAgentSearchCount.id,
        headerName: (0, $3etjB.marketShareTerms).prodAgentCount,
        exportHeaderLabel: (0, $3etjB.marketShareTerms).prodAgents,
        minWidth: (0, $98ROn.unitWidth).small,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.integer,
        pinnedRowSettings: {
            totalsSearch: {
                keyField: (0, $c3iqc.marketShareColumns).prodAgentCount.id
            },
            coverageSearch: $e125323d45c1aae8$var$pinnedRowSettingsEmptyCell
        }
    },
    [(0, $c3iqc.marketShareColumns).sellProdAgentSearchCount.id]: {
        field: (0, $c3iqc.marketShareColumns).sellProdAgentSearchCount.id,
        headerName: (0, $3etjB.marketShareTerms).prodAgentCount,
        exportHeaderLabel: (0, $3etjB.marketShareTerms).prodAgents,
        minWidth: (0, $98ROn.unitWidth).small,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.integer,
        pinnedRowSettings: {
            "default": $e125323d45c1aae8$var$pinnedRowSettingsEmptyCell
        }
    },
    [(0, $c3iqc.marketShareColumns).totalProdAgentSearchCount.id]: {
        field: (0, $c3iqc.marketShareColumns).totalProdAgentSearchCount.id,
        headerName: (0, $3etjB.marketShareTerms).prodAgentCount,
        exportHeaderLabel: (0, $3etjB.marketShareTerms).prodAgents,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.integer,
        width: (0, $98ROn.unitWidth).small,
        pinnedRowSettings: {
            totalsSearch: {
                keyField: (0, $c3iqc.marketShareColumns).prodAgentCount.id
            },
            coverageSearch: $e125323d45c1aae8$var$pinnedRowSettingsEmptyCell
        }
    },
    [(0, $c3iqc.marketShareColumns).area.id]: {
        field: (0, $c3iqc.marketShareColumns).area.id,
        headerName: (0, $c3iqc.marketShareColumns).area.label,
        minWidth: (0, $98ROn.unitWidth).large,
        ...$e125323d45c1aae8$export$d4ddd0efd00905f2,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        cellRenderer: (props)=>{
            if (!props.data?.areaId) return props.data?.area;
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fGPb.Link), {
                to: {
                    pathname: `${(0, $c7dF9.Routes).MARKET_SHARE.BASE}${(0, $c7dF9.Routes).MARKET_SHARE.COVERAGE}${(0, $c7dF9.Routes).MARKET_SHARE.OFFICES_BREAKDOWN}`,
                    search: `?areaId=${encodeURIComponent(props.data.areaId)}&view=${props.data.listingViewId}`,
                    state: {
                        id: props.data.areaId,
                        area: props.data.area,
                        type: props.data.listingTypeId,
                        sumOfColumn: props.data.sumOfColumn,
                        rowCount: props.data.rowCount
                    }
                },
                children: props.value
            });
        },
        pinnedRowSettings: {
            totalsSearch: {
                cellValue: (0, $cstaF.agentProductionTerms).totalsAverages
            },
            coverageSearch: {
                cellValue: (0, $cstaF.agentProductionTerms).totalsAverages
            }
        }
    },
    [(0, $c3iqc.marketShareColumns).mlsArea.id]: {
        field: (0, $c3iqc.marketShareColumns).mlsArea.id,
        headerName: (0, $c3iqc.marketShareColumns).area.label,
        ...$e125323d45c1aae8$export$d4ddd0efd00905f2,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        width: (0, $98ROn.unitWidth).small
    },
    [(0, $c3iqc.marketShareColumns).rank.id]: {
        field: (0, $c3iqc.marketShareColumns).rank.id,
        headerName: (0, $c3iqc.marketShareColumns).rank.label,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        maxWidth: 83,
        minWidth: 83
    },
    [(0, $c3iqc.marketShareColumns).isSelected.id]: {
        field: (0, $c3iqc.marketShareColumns).isSelected.id,
        headerName: "",
        ...$e125323d45c1aae8$export$d4ddd0efd00905f2,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        cellRenderer: (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $93Pvi.CustomCheckbox), {
                ...props
            }),
        shouldExport: false,
        maxWidth: 45,
        minWidth: 45
    },
    [(0, $c3iqc.marketShareColumns).mlsId.id]: {
        field: (0, $c3iqc.marketShareColumns).mlsId.id,
        headerName: (0, $c3iqc.marketShareColumns).mlsId.label,
        minWidth: 85,
        maxWidth: 85,
        ...$e125323d45c1aae8$export$d4ddd0efd00905f2,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        width: (0, $98ROn.unitWidth).small
    },
    [(0, $c3iqc.marketShareColumns).orgPrice.id]: {
        field: (0, $c3iqc.marketShareColumns).orgPrice.id,
        headerName: (0, $c3iqc.marketShareColumns).orgPrice.label,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.volume,
        minWidth: (0, $98ROn.unitWidth).regular
    },
    [(0, $c3iqc.marketShareColumns).listPrice.id]: {
        field: (0, $c3iqc.marketShareColumns).listPrice.id,
        headerName: (0, $c3iqc.marketShareColumns).listPrice.label,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.volume,
        minWidth: (0, $98ROn.unitWidth).compact
    },
    [(0, $c3iqc.marketShareColumns).price.id]: {
        field: (0, $c3iqc.marketShareColumns).price.id,
        headerName: (0, $c3iqc.marketShareColumns).price.label,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.volume,
        minWidth: (0, $98ROn.unitWidth).compact
    },
    [(0, $c3iqc.marketShareColumns).soldPrice.id]: {
        field: (0, $c3iqc.marketShareColumns).soldPrice.id,
        headerName: (0, $c3iqc.marketShareColumns).price.label,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.volume,
        minWidth: (0, $98ROn.unitWidth).compact
    },
    [(0, $c3iqc.marketShareColumns).date.id]: {
        field: (0, $c3iqc.marketShareColumns).date.id,
        headerName: (0, $c3iqc.marketShareColumns).date.label,
        ...$e125323d45c1aae8$export$d4ddd0efd00905f2,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        exportFormatter: (0, $dqgmD.csvFormats).date.format,
        ...$e125323d45c1aae8$export$9983de2472d26634.dateFormat,
        minWidth: 130
    },
    [(0, $c3iqc.marketShareColumns).listingStatus.id]: {
        field: (0, $c3iqc.marketShareColumns).listingStatus.field,
        headerName: (0, $c3iqc.marketShareColumns).listingStatus.label,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        exportFormatter: (0, $dqgmD.csvFormats).listingStatus.format
    },
    [(0, $c3iqc.marketShareColumns).typeName.id]: {
        field: (0, $c3iqc.marketShareColumns).typeName.id,
        headerName: (0, $c3iqc.marketShareColumns).typeName.label,
        ...$e125323d45c1aae8$export$d4ddd0efd00905f2,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        width: (0, $98ROn.unitWidth).small
    },
    [(0, $c3iqc.marketShareColumns).mlsNum.id]: {
        field: (0, $c3iqc.marketShareColumns).mlsNum.id,
        headerName: (0, $c3iqc.marketShareColumns).mlsNum.label,
        ...$e125323d45c1aae8$export$d4ddd0efd00905f2,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        minWidth: 130
    },
    [(0, $c3iqc.marketShareColumns).areaId.id]: {
        field: (0, $c3iqc.marketShareColumns).areaId.id,
        headerName: (0, $c3iqc.marketShareColumns).areaId.label,
        ...$e125323d45c1aae8$export$d4ddd0efd00905f2,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        width: (0, $98ROn.unitWidth).small
    },
    [(0, $c3iqc.marketShareColumns).dom.id]: {
        field: (0, $c3iqc.marketShareColumns).dom.id,
        headerName: (0, $c3iqc.marketShareColumns).dom.label,
        minWidth: (0, $98ROn.unitWidth).dom,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.integer
    },
    [(0, $c3iqc.marketShareColumns).cdom.id]: {
        field: (0, $c3iqc.marketShareColumns).cdom.id,
        headerName: (0, $c3iqc.marketShareColumns).cdom.label,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.integer,
        width: (0, $98ROn.unitWidth).small
    },
    [(0, $c3iqc.marketShareColumns).bankProperty.id]: {
        field: (0, $c3iqc.marketShareColumns).bankProperty.id,
        headerName: (0, $c3iqc.marketShareColumns).bankProperty.label,
        ...$e125323d45c1aae8$export$d4ddd0efd00905f2,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules
    },
    [(0, $c3iqc.marketShareColumns).bankStatus.id]: {
        field: (0, $c3iqc.marketShareColumns).bankStatus.id,
        headerName: (0, $c3iqc.marketShareColumns).bankStatus.label,
        ...$e125323d45c1aae8$export$d4ddd0efd00905f2,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        exportFormatter: (0, $dqgmD.csvFormats).booleanShort.format,
        ...$e125323d45c1aae8$export$9983de2472d26634.bankStatus,
        minWidth: (0, $98ROn.unitWidth).regular
    },
    [(0, $c3iqc.marketShareColumns).priceChangeCnt.id]: {
        field: (0, $c3iqc.marketShareColumns).priceChangeCnt.id,
        headerName: (0, $c3iqc.marketShareColumns).priceChangeCnt.label,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.integer,
        minWidth: 195
    },
    [(0, $c3iqc.marketShareColumns).bedrooms.id]: {
        field: (0, $c3iqc.marketShareColumns).bedrooms.id,
        headerName: (0, $c3iqc.marketShareColumns).bedrooms.label,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.integer,
        exportFormatter: (0, $dqgmD.csvFormats).integer.format,
        width: (0, $98ROn.unitWidth).small
    },
    [(0, $c3iqc.marketShareColumns).fullBaths.id]: {
        field: (0, $c3iqc.marketShareColumns).fullBaths.id,
        headerName: (0, $c3iqc.marketShareColumns).fullBaths.label,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.integer,
        exportFormatter: (0, $dqgmD.csvFormats).integer.format,
        width: (0, $98ROn.unitWidth).small
    },
    [(0, $c3iqc.marketShareColumns).squareFt.id]: {
        field: (0, $c3iqc.marketShareColumns).squareFt.id,
        headerName: (0, $c3iqc.marketShareColumns).squareFt.label,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        exportFormatter: (0, $dqgmD.csvFormats).integer.format,
        ...$e125323d45c1aae8$export$9983de2472d26634.integer
    },
    [(0, $c3iqc.marketShareColumns).costPerSqft.id]: {
        field: (0, $c3iqc.marketShareColumns).costPerSqft.id,
        headerName: (0, $c3iqc.marketShareColumns).costPerSqft.label,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        exportFormatter: (0, $dqgmD.csvFormats).integer.format,
        ...$e125323d45c1aae8$export$9983de2472d26634.volume
    },
    [(0, $c3iqc.marketShareColumns).lotSizeSquareFt.id]: {
        field: (0, $c3iqc.marketShareColumns).lotSizeSquareFt.id,
        headerName: (0, $c3iqc.marketShareColumns).lotSizeSquareFt.label,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        ...$e125323d45c1aae8$export$9983de2472d26634.integer,
        exportFormatter: (0, $dqgmD.csvFormats).integer.format,
        minWidth: (0, $98ROn.unitWidth).moderate
    },
    [(0, $c3iqc.marketShareColumns).lotSizeAcres.id]: {
        field: (0, $c3iqc.marketShareColumns).lotSizeAcres.id,
        headerName: (0, $c3iqc.marketShareColumns).lotSizeAcres.label,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        exportFormatter: (0, $dqgmD.csvFormats).decimal.format,
        ...$e125323d45c1aae8$export$9983de2472d26634.decimalNumber
    },
    [(0, $c3iqc.marketShareColumns).yearBuilt.id]: {
        field: (0, $c3iqc.marketShareColumns).yearBuilt.id,
        headerName: (0, $c3iqc.marketShareColumns).yearBuilt.label,
        ...$e125323d45c1aae8$export$94bae3b389ffa7,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        minWidth: 130
    },
    [(0, $c3iqc.marketShareColumns).listAgent.id]: {
        field: (0, $c3iqc.marketShareColumns).listAgent.id,
        headerName: (0, $c3iqc.marketShareColumns).listAgent.label,
        minWidth: 200,
        ...$e125323d45c1aae8$export$4427de623c1aadc8,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules
    },
    [(0, $c3iqc.marketShareColumns).sellAgent.id]: {
        field: (0, $c3iqc.marketShareColumns).sellAgent.id,
        headerName: (0, $c3iqc.marketShareColumns).sellAgent.label,
        minWidth: 200,
        ...$e125323d45c1aae8$export$4427de623c1aadc8,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules
    },
    [(0, $c3iqc.marketShareColumns).doubleSided.id]: {
        field: (0, $c3iqc.marketShareColumns).doubleSided.id,
        headerName: (0, $c3iqc.marketShareColumns).doubleSided.label,
        minWidth: 200,
        ...$e125323d45c1aae8$export$d4ddd0efd00905f2,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules
    },
    [(0, $c3iqc.marketShareColumns).groupName.id]: {
        field: (0, $c3iqc.marketShareColumns).groupName.id,
        headerName: (0, $c3iqc.marketShareColumns).groupName.label,
        minWidth: (0, $98ROn.unitWidth).large,
        ...$e125323d45c1aae8$export$4427de623c1aadc8,
        ...$e125323d45c1aae8$var$colWidthDefaults,
        ...$e125323d45c1aae8$var$colHighlightRules,
        pinnedRowSettings: {
            "default": {
                cellValue: (0, $cstaF.agentProductionTerms).totalsAverages
            }
        },
        cellRenderer: (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2Wf8L.OfficeGroupName), {
                ...props
            })
    }
});

});
parcelRegister("4fGPb", function(module, exports) {

$parcel$export(module.exports, "BrowserRouter", () => $3189c83282a9a1c6$export$9ba4e89fdfa1fc54);
$parcel$export(module.exports, "Link", () => $3189c83282a9a1c6$export$a6c7ac8248d6e38a);

var $kfZjc = parcelRequire("kfZjc");

var $g7ajw = parcelRequire("g7ajw");

var $acw62 = parcelRequire("acw62");

var $3np4r = parcelRequire("3np4r");



var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $bv4qN = parcelRequire("bv4qN");
/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $3189c83282a9a1c6$export$9ba4e89fdfa1fc54 = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $3np4r.createBrowserHistory)(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kfZjc.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $3189c83282a9a1c6$export$7221d69dcfc8e36b = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = (0, $3np4r.createHashHistory)(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kfZjc.Router), {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
var $3189c83282a9a1c6$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $3189c83282a9a1c6$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? (0, $3np4r.createLocation)(to, null, null, currentLocation) : to;
};
var $3189c83282a9a1c6$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $3189c83282a9a1c6$var$forwardRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef;
if (typeof $3189c83282a9a1c6$var$forwardRef === "undefined") $3189c83282a9a1c6$var$forwardRef = $3189c83282a9a1c6$var$forwardRefShim;
function $3189c83282a9a1c6$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $3189c83282a9a1c6$var$LinkAnchor = $3189c83282a9a1c6$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = (0, $1En50.default)(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = (0, $8nd05.default)({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$3189c83282a9a1c6$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($3189c83282a9a1c6$var$forwardRefShim !== $3189c83282a9a1c6$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */ var $3189c83282a9a1c6$export$a6c7ac8248d6e38a = $3189c83282a9a1c6$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $3189c83282a9a1c6$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = (0, $1En50.default)(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kfZjc.__RouterContext).Consumer, null, function(context) {
        !context && (0, $bv4qN.default)(false);
        var history = context.history;
        var location = $3189c83282a9a1c6$var$normalizeToLocation($3189c83282a9a1c6$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history.createHref(location) : "";
        var props = (0, $8nd05.default)({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $3189c83282a9a1c6$var$resolveToLocation(to, context.location);
                var isDuplicateNavigation = (0, $3np4r.createPath)(context.location) === (0, $3np4r.createPath)($3189c83282a9a1c6$var$normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history.replace : history.push;
                method(location);
            }
        }); // React 15 compat
        if ($3189c83282a9a1c6$var$forwardRefShim !== $3189c83282a9a1c6$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(component, props);
    });
});
var $3189c83282a9a1c6$var$toType, $3189c83282a9a1c6$var$refType;
var $3189c83282a9a1c6$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $3189c83282a9a1c6$var$forwardRef$1 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef;
if (typeof $3189c83282a9a1c6$var$forwardRef$1 === "undefined") $3189c83282a9a1c6$var$forwardRef$1 = $3189c83282a9a1c6$var$forwardRefShim$1;
function $3189c83282a9a1c6$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $3189c83282a9a1c6$export$b0d92dbee9b5b60d = $3189c83282a9a1c6$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = (0, $1En50.default)(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $kfZjc.__RouterContext).Consumer, null, function(context) {
        !context && (0, $bv4qN.default)(false);
        var currentLocation = locationProp || context.location;
        var toLocation = $3189c83282a9a1c6$var$normalizeToLocation($3189c83282a9a1c6$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? (0, $kfZjc.matchPath)(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = $3189c83282a9a1c6$var$joinClassnames(className, activeClassName);
            style = (0, $8nd05.default)({}, style, activeStyle);
        }
        var props = (0, $8nd05.default)({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($3189c83282a9a1c6$var$forwardRefShim$1 !== $3189c83282a9a1c6$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($3189c83282a9a1c6$export$a6c7ac8248d6e38a, props);
    });
});
var $3189c83282a9a1c6$var$ariaCurrentType;

});

parcelRegister("2oki8", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3eb794778bf9cfe$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $rMeTm = parcelRequire("rMeTm");

var $c9Z8w = parcelRequire("c9Z8w");

var $4zwYe = parcelRequire("4zwYe");

var $aTLkh = parcelRequire("aTLkh");

var $ivaD7 = parcelRequire("ivaD7");

var $7fq2m = parcelRequire("7fq2m");
const $c3eb794778bf9cfe$var$CustomGridHeader = (props)=>{
    const { column: column, displayName: displayName, setSort: setSort, enableSorting: enableSorting, context: context } = props;
    const { listingStatus: listingStatus, listingView: listingView, hasHeaderTooltips: hasHeaderTooltips } = context;
    const isNumericColumn = column.colDef.headerClass.includes((0, $7fq2m.gridClasses).headerNumber);
    const wrapperClassName = `w-100 ${isNumericColumn ? (0, $7fq2m.gridClasses).headerNumber : ""}`;
    const tipTextObject = {
        columnId: column.colId,
        listingStatus: listingStatus,
        listingView: listingView,
        areaType: props.displayName,
        isCoverage: column.colDef.isCoverage,
        tooltip: column.colDef.tooltip
    };
    const [state, setState] = (0, $acw62.useState)({
        ascSort: "d-none",
        descSort: "d-none",
        isSortDescending: false
    });
    const onSortChanged = ()=>{
        setState((prevState)=>{
            return {
                ...prevState,
                ascSort: column.isSortDescending() ? "d-block" : "d-none",
                descSort: column.isSortAscending() ? "d-block" : "d-none"
            };
        });
    };
    const onSortRequested = (order, event)=>{
        setSort(order, event.shiftKey);
    };
    (0, $acw62.useEffect)(()=>{
        column.addEventListener("sortChanged", onSortChanged);
        onSortChanged();
    }, []);
    let sort = null;
    const handleSort = (event)=>{
        onSortRequested(`${state.isSortDescending ? "asc" : "desc"}`, event);
        (0, $ivaD7.setStateData)("isSortDescending", !state.isSortDescending, setState);
    };
    if (enableSorting) sort = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "d-inline-block",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: `m0 float-right ${state.ascSort}`,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aTLkh.default), {
                    dataLwtId: "icon",
                    iconName: "arrow_drop_down"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: `m0 float-right ${state.descSort}`,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aTLkh.default), {
                    dataLwtId: "icon",
                    iconName: "arrow_drop_up"
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: wrapperClassName,
        onClick: (event)=>handleSort(event),
        onTouchEnd: (event)=>handleSort(event),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "ag-header-cell-text",
                id: `${column.colId}-tooltip`,
                children: displayName
            }),
            sort,
            hasHeaderTooltips && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $rMeTm.default), {
                target: `${column.colId}-tooltip`,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "helix-small",
                    children: (0, $4zwYe.getTipText)(tipTextObject)
                })
            })
        ]
    });
};
$c3eb794778bf9cfe$var$CustomGridHeader.propTypes = {
    column: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    listingStatus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    displayName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    setSort: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    enableSorting: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
var $c3eb794778bf9cfe$export$2e2bcd8739ae039 = $c3eb794778bf9cfe$var$CustomGridHeader;

});
parcelRegister("4zwYe", function(module, exports) {

$parcel$export(module.exports, "getTipText", () => $c597d6e9c3dc2277$export$af86beb39d8ab8a8);
$parcel$export(module.exports, "transformListingView", () => $c597d6e9c3dc2277$export$370bc908697dc929);
$parcel$export(module.exports, "transformListingStatus", () => $c597d6e9c3dc2277$export$42cb9d80ce8e0e6a);
$parcel$export(module.exports, "transformAreaType", () => $c597d6e9c3dc2277$export$9d6b479545737a62);
$parcel$export(module.exports, "marketSharePctTip", () => $c597d6e9c3dc2277$export$b717d275b4e11057);
$parcel$export(module.exports, "transformByModule", () => $c597d6e9c3dc2277$export$335822198be8afa2);
$parcel$export(module.exports, "totalAvgPriceTip", () => $c597d6e9c3dc2277$export$54016dcccbd613b5);

var $cstaF = parcelRequire("cstaF");

var $jrJS7 = parcelRequire("jrJS7");

var $3etjB = parcelRequire("3etjB");
const $c597d6e9c3dc2277$export$af86beb39d8ab8a8 = (props)=>{
    const { areaType: areaType, columnId: columnId, isCoverage: isCoverage, listingStatus: listingStatus, listingView: listingView, tooltip: tooltip } = props;
    if (tooltip) return (0, $jrJS7.columnTips)[tooltip]?.tip;
    if ((0, $jrJS7.columnTips)[columnId]?.transform) {
        const text = {
            tip: (0, $jrJS7.columnTips)[columnId].tip,
            listingView: listingView,
            listingStatus: listingStatus,
            areaType: areaType,
            isCoverage: isCoverage
        };
        return (0, $jrJS7.columnTips)[columnId].transform(text);
    }
    return (0, $jrJS7.columnTips)[columnId]?.tip;
};
const $c597d6e9c3dc2277$export$370bc908697dc929 = (value)=>{
    return value.tip.replace((0, $jrJS7.tipReplacements).listingView, value.listingView);
};
const $c597d6e9c3dc2277$export$42cb9d80ce8e0e6a = (value)=>{
    if ((0, $cstaF.marketShareListingStatuses).New === value.listingStatus) return value.tip.replace((0, $jrJS7.tipReplacements).listingStatus, value.listingStatus);
    return value.tip.replace((0, $jrJS7.tipReplacements).listingStatus, value.listingStatus + " listings");
};
const $c597d6e9c3dc2277$export$9d6b479545737a62 = (tipDetails)=>{
    return tipDetails.tip.replace((0, $jrJS7.tipReplacements).areaType, tipDetails.areaType);
};
const $c597d6e9c3dc2277$export$b717d275b4e11057 = (tipDetails)=>{
    if (tipDetails.isCoverage) {
        const isListSide = tipDetails.listingView === (0, $3etjB.marketShareTerms).listSide$Volume || tipDetails.listingView === (0, $3etjB.marketShareTerms).listSideNumUnits;
        const isSellSide = tipDetails.listingView === (0, $3etjB.marketShareTerms).sellSide$Volume || tipDetails.listingView === (0, $3etjB.marketShareTerms).sellSideNumUnits;
        const listingView = tipDetails.listingView.replace(`${(0, $3etjB.marketShareTerms).side} `, "");
        const listingTotal = tipDetails.listingView.replace(`${(0, $3etjB.marketShareTerms).total} `, "");
        if (isListSide || isSellSide) return tipDetails.tip.coverage.replace((0, $jrJS7.tipReplacements).listingView, listingView).replace((0, $jrJS7.tipReplacements).listingView, `${(0, $3etjB.marketShareTerms).total.toLocaleLowerCase()} of ${listingView}`);
        else return tipDetails.tip.coverage.replace((0, $jrJS7.tipReplacements).listingView, listingTotal).replace((0, $jrJS7.tipReplacements).listingView, listingView);
    } else return tipDetails.tip.totals;
};
const $c597d6e9c3dc2277$export$335822198be8afa2 = (value)=>{
    return value.isCoverage ? value.tip.coverage : value.tip.totals;
};
const $c597d6e9c3dc2277$export$54016dcccbd613b5 = (value)=>{
    return !value.isCoverage ? value.tip.totals : value.listingStatus === (0, $cstaF.marketShareListingStatusesCoverage).ForSale ? value.tip.coverage.forSale : value.tip.coverage.sold;
};

});
parcelRegister("jrJS7", function(module, exports) {

$parcel$export(module.exports, "tipReplacements", () => $e2841f25a848e4c4$export$c4bb072716038018);
$parcel$export(module.exports, "columnTips", () => $e2841f25a848e4c4$export$5bc134c69e26cc6a);

var $4zwYe = parcelRequire("4zwYe");
const $e2841f25a848e4c4$export$c4bb072716038018 = {
    areaType: "[area type]",
    listingSide: "[listing side]",
    listingStatus: "[listing status]",
    listingView: "[listing view]"
};
const $e2841f25a848e4c4$export$5bc134c69e26cc6a = {
    rank: {
        id: "rank",
        tip: `Rank based on ${$e2841f25a848e4c4$export$c4bb072716038018.listingView}`,
        transform: (t)=>(0, $4zwYe.transformListingView)(t)
    },
    officeId: {
        id: "officeId",
        tip: "ID code assigned by MLS"
    },
    officeName: {
        id: "officeName",
        tip: "Office Name - derived from MLS records"
    },
    brokerName: {
        id: "brokerName",
        tip: "Broker Name - derived from MLS records"
    },
    streetName1: {
        id: "streetName1",
        tip: "Office Address from MLS records"
    },
    streetName: {
        id: "streetName",
        tip: "Office Address from MLS records"
    },
    city: {
        id: "city",
        tip: "Office City"
    },
    stateCode: {
        id: "stateCode",
        tip: "Office State"
    },
    zipCode: {
        id: "zipCode",
        tip: "Zip Code"
    },
    zipcode: {
        id: "zipcode",
        tip: "Zip Code"
    },
    county: {
        id: "county",
        tip: "Office County"
    },
    phoneNumber: {
        id: "phoneNumber",
        tip: "Office telephone number"
    },
    ucVolume: {
        id: "ucVolume",
        tip: "The ($) volume of listings that went under contract in the given time period"
    },
    ucUnits: {
        id: "ucUnits",
        tip: "The (#) of listings that went under contract in the given time period"
    },
    newListingVolume: {
        id: "newListVolume",
        tip: "The ($) volume of new listings in the given time period"
    },
    newListingUnits: {
        id: "newListUnits",
        tip: "The (#) of new listings in the given time period"
    },
    newListVolume: {
        id: "newListVolume",
        tip: "The ($) volume of new listings in the given time period"
    },
    newListUnits: {
        id: "newListUnits",
        tip: "The (#) of new listings in the given time period"
    },
    forSaleVolume: {
        id: "actVolume",
        tip: "The ($) volume of current listings with status = Active"
    },
    forSaleUnits: {
        id: "actUnits",
        tip: "The (#) of current listings with status = Active"
    },
    officeCount: {
        id: "officeCount",
        tip: "Number of offices associated with the underlying broker code"
    },
    averageDom: {
        id: "averageDom",
        tip: "Average number of Days on Market for list-side transactions only"
    },
    avgDom: {
        id: "avgDom",
        tip: "Average number of Days on Market for list-side transactions only"
    },
    mlsId: {
        id: "mlsId",
        tip: "Number of Active MLS Members reported by the MLS"
    },
    agentCount: {
        id: "agentCount",
        tip: "Number of Active MLS Members reported by the MLS"
    },
    avgPrice: {
        id: "avgPrice",
        tip: `Average price of all ${$e2841f25a848e4c4$export$c4bb072716038018.listingStatus}`,
        transform: (t)=>(0, $4zwYe.transformListingStatus)(t)
    },
    averagePrice: {
        id: "averagePrice",
        tip: `Average price of all ${$e2841f25a848e4c4$export$c4bb072716038018.listingStatus}`,
        transform: (t)=>(0, $4zwYe.transformListingStatus)(t)
    },
    listVolume: {
        id: "listVolume",
        tip: "The ($) volume of list-side transactions"
    },
    listUnits: {
        id: "listUnits",
        tip: "The (#) of list-side transactions"
    },
    sellVolume: {
        id: "sellVolume",
        tip: "The ($) volume of sell-side transactions"
    },
    sellUnits: {
        id: "sellUnits",
        tip: "The (#) of sell-side transactions"
    },
    totalVolume: {
        id: "totalVolume",
        tip: "The total ($) volume of transaction sides (list + sell)"
    },
    totalUnits: {
        id: "totalUnits",
        tip: "The total (#) number of transaction sides (list + sell)"
    },
    dom: {
        id: "dom",
        tip: "Average number of Days on Market for list-side transactions only"
    },
    avgListDom: {
        id: "avgListDom",
        tip: "Average number of Days on Market for list-side transactions only"
    },
    spOp: {
        id: "spOp",
        tip: "Ratio of Sold prices to Original prices"
    },
    listSpop: {
        id: "listSpop",
        tip: "Ratio of Sold prices to Original prices"
    },
    sellSpop: {
        id: "sellSpop",
        tip: "Ratio of Sold prices to Original prices"
    },
    prodAgentTotalUnits: {
        id: "prodAgentTotalUnits",
        tip: "Average number of listings sold per Producing Agent"
    },
    prodAgentTotalVolume: {
        id: "prodAgentTotalVolume",
        tip: "Average ($) volume per Producing Agent"
    },
    prodAgentSellVolume: {
        id: "prodAgentSellVolume",
        tip: "Average ($) volume per Producing Agent"
    },
    prodAgentSellUnits: {
        id: "prodAgentSellUnits",
        tip: "Average number of listings sold per Producing Agent"
    },
    prodAgentListUnits: {
        id: "prodAgentListUnits",
        tip: "Average number of listings sold per Producing Agent"
    },
    prodAgentListVolume: {
        id: "prodAgentListVolume",
        tip: "Average ($) volume per Producing Agent"
    },
    prodAgentCount: {
        id: "prodAgentCount",
        tip: "Number of members with at least one transaction side that meets the search criteria"
    },
    sellAvgPrice: {
        id: "sellAvgPrice",
        tip: "Average price of all sell-side transactions"
    },
    listAvgPrice: {
        id: "listAvgPrice",
        tip: "Average price of all list-side transactions"
    },
    prodAgentSearchCount: {
        id: "prodAgentSearchCount",
        tip: "Number of members with at least one transaction side that meets the search criteria"
    },
    totalProdAgentSearchCount: {
        id: "totalProdAgentSearchCount",
        tip: "Number of members with at least one transaction side in the area in the last 12 months"
    },
    listProdAgentSearchCount: {
        id: "listProdAgentSearchCount",
        tip: "Number of members with at least one transaction side in the area in the last 12 months"
    },
    mlsOfficeCount: {
        id: "mlsOfficeCount",
        tip: "Number of offices that had at least one transaction side (list or sell) in the area in the last 12 months"
    },
    totalProdAgentCount: {
        id: "totalProdAgentCount",
        tip: "Number of members with at least one transaction side in the area in the last 12 months"
    },
    listProdAgentCount: {
        id: "listProdAgentCount",
        tip: "Number of members with at least one transaction side in the area in the last 12 months"
    },
    sellProdAgentSearchCount: {
        id: "sellProdAgentSearchCount",
        tip: "Number of members with at least one transaction side in the area in the last 12 months"
    },
    mlsAgentCount: {
        id: "mlsAgentCount",
        tip: "Number of Active members reported by the MLS for the offices that had at least one transaction side (list or sell) in the area in the last 12 months"
    },
    area: {
        id: "area",
        tip: ` ${$e2841f25a848e4c4$export$c4bb072716038018.areaType}`,
        transform: (t)=>(0, $4zwYe.transformAreaType)(t)
    },
    unitSharePct: {
        id: "unitSharePct",
        tip: "Number of For Sale listings for the area as a percentage of the total"
    },
    volumeSharePct: {
        id: "unitSharePct",
        tip: "($) Volume of For Sale listings for the area as a percentage of the total"
    },
    clr: {
        id: "clr",
        tip: {
            totals: "Closed-to-List Ratio",
            coverage: "Number of closed transactions compared to the number of listings taken in the last 12 months as a ratio. There is not a one-to-one correspondence, i.e. a closed listing could have a list date before the 12-month time period started; a listing taken on the last day of the 12 month period would be counted, etc."
        },
        transform: (t)=>(0, $4zwYe.transformByModule)(t)
    },
    totalAvgPrice: {
        id: "totalAvgPrice",
        tip: {
            totals: "Average price of Active listings",
            coverage: {
                sold: "Average price of all transactions (list + sell)",
                forSale: "Average price of For Sale listings"
            }
        },
        transform: (t)=>(0, $4zwYe.totalAvgPriceTip)(t)
    },
    marketSharePct: {
        id: "marketSharePct",
        tip: {
            totals: "Market Percent",
            coverage: `${$e2841f25a848e4c4$export$c4bb072716038018.listingView} for the area as a percentage of the ${$e2841f25a848e4c4$export$c4bb072716038018.listingView}`
        },
        transform: (t)=>(0, $4zwYe.marketSharePctTip)(t)
    },
    actVolume: {
        id: "actVolume",
        tip: {
            totals: "The ($) volume of current listings with status = Active",
            coverage: "($) Volume of For Sale listings"
        },
        transform: (t)=>(0, $4zwYe.transformByModule)(t)
    },
    actUnits: {
        id: "actUnits",
        tip: {
            totals: "The (#) of current listings with status = Active",
            coverage: "Number of For Sale listings"
        },
        transform: (t)=>(0, $4zwYe.transformByModule)(t)
    },
    groupName: {
        id: "groupName",
        tip: "Office group name"
    }
};

});



parcelRegister("jLmfc", function(module, exports) {

$parcel$export(module.exports, "AddressLink", () => $8ee04295993bdf3f$export$9fca741d0593e19e);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4fGPb = parcelRequire("4fGPb");

var $94cVo = parcelRequire("94cVo");

var $c9Z8w = parcelRequire("c9Z8w");
const $8ee04295993bdf3f$export$9fca741d0593e19e = (props)=>{
    const { data: data, pathname: pathname, value: value } = props;
    const { mlsNum: mlsNum, address: address, areaId: areaId, listingTypeId: listingTypeId } = data;
    const addressParam = (0, $94cVo.uriEncode)(address);
    const search = new URLSearchParams({
        mlsNum: mlsNum,
        address: addressParam,
        id: areaId
    }).toString();
    const state = {
        id: areaId,
        office: addressParam,
        listingTypeId: listingTypeId
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fGPb.Link), {
        to: {
            pathname: pathname,
            search: search,
            state: state
        },
        children: value
    });
};
$8ee04295993bdf3f$export$9fca741d0593e19e.propTypes = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object.isRequired,
    pathname: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired
};

});

parcelRegister("2AfFv", function(module, exports) {

$parcel$export(module.exports, "getCustomPinnedRow", () => $1e1b18fbae17930e$export$3fbc2839f06b5ab6);

var $a2xy0 = parcelRequire("a2xy0");
const $1e1b18fbae17930e$export$3fbc2839f06b5ab6 = (params)=>{
    if (params.node.rowPinned) return {
        component: (0, $a2xy0.CustomPinnedRow)
    };
    return undefined;
};

});
parcelRegister("a2xy0", function(module, exports) {

$parcel$export(module.exports, "CustomPinnedRow", () => $21b7aa305165b1f9$export$df01c291d3cb0673);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $dqgmD = parcelRequire("dqgmD");
const $21b7aa305165b1f9$export$df01c291d3cb0673 = (props)=>{
    const valueToDisplay = (0, $dqgmD.isEncodedCellValue)(props.value?.toString() || "") ? (0, $dqgmD.getDecodedCellValue)(props.value.toString()) : props.valueFormatted || props.value;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
        className: "font-weight-bold",
        children: [
            " ",
            valueToDisplay,
            " "
        ]
    });
};

});
parcelRegister("dqgmD", function(module, exports) {

$parcel$export(module.exports, "handleSortedHighlight", () => $9c5a65a49d98fcb7$export$aacaf45217cb68d3);
$parcel$export(module.exports, "csvFormats", () => $9c5a65a49d98fcb7$export$f4beaec329e96f2);
$parcel$export(module.exports, "getScrubbedFilenameForExport", () => $9c5a65a49d98fcb7$export$d564bb60b0b17c38);
$parcel$export(module.exports, "shouldExportColumn", () => $9c5a65a49d98fcb7$export$25fbc64d484d490d);
$parcel$export(module.exports, "getExportCellValue", () => $9c5a65a49d98fcb7$export$f7be0cb454ead2e0);
$parcel$export(module.exports, "isEncodedCellValue", () => $9c5a65a49d98fcb7$export$7ef0a69c92eb56ab);
$parcel$export(module.exports, "getDecodedCellValue", () => $9c5a65a49d98fcb7$export$f11edb22ccc7d971);
$parcel$export(module.exports, "getExportHeaderText", () => $9c5a65a49d98fcb7$export$4aa7a373bd206c61);
$parcel$export(module.exports, "getCalculatedPct", () => $9c5a65a49d98fcb7$export$d341600c99421b04);
$parcel$export(module.exports, "getPinnedCellValue", () => $9c5a65a49d98fcb7$export$e51d15ff88f01024);
$parcel$export(module.exports, "getColumnSum", () => $9c5a65a49d98fcb7$export$93ffca7b17ee039);
$parcel$export(module.exports, "getEncodedCellValue", () => $9c5a65a49d98fcb7$export$8c5e027791aaddab);
$parcel$export(module.exports, "removeRowByKey", () => $9c5a65a49d98fcb7$export$2135745f0011185);
$parcel$export(module.exports, "getRowIdParam", () => $9c5a65a49d98fcb7$export$fea46f06b264671f);
$parcel$export(module.exports, "getRankedData", () => $9c5a65a49d98fcb7$export$5526142bc0670f41);
$parcel$export(module.exports, "setAgGridSort", () => $9c5a65a49d98fcb7$export$1db97829a835063b);
$parcel$export(module.exports, "setAgGridFloatingFilter", () => $9c5a65a49d98fcb7$export$836ee5a1ac4ae57e);
$parcel$export(module.exports, "applyPersistedSelection", () => $9c5a65a49d98fcb7$export$d338a0b8ae7a62b7);

var $5GRJ8 = parcelRequire("5GRJ8");

var $eHBjM = parcelRequire("eHBjM");

var $htzEo = parcelRequire("htzEo");

var $cstaF = parcelRequire("cstaF");

var $94cVo = parcelRequire("94cVo");
const $9c5a65a49d98fcb7$export$aacaf45217cb68d3 = async (e)=>{
    const columns = e.api.getColumns();
    const sortedColumn = columns?.find((column)=>column.isSorting());
    const columnIndex = e.api.getColumns()?.indexOf(sortedColumn) + 1;
    const CLASS_HIGHLIGHT = "highlighted-column";
    const ATTR_COLUMN_INDEX = "aria-colindex";
    document.querySelectorAll(".ag-header-cell").forEach((columnHeaderCell)=>{
        columnHeaderCell.classList.remove(CLASS_HIGHLIGHT);
    });
    document.querySelectorAll(".ag-floating-filter.ag-header-cell").forEach((columnHeaderCell)=>{
        columnHeaderCell.classList.remove(CLASS_HIGHLIGHT);
    });
    const sortedColumnHeaderCell = document.querySelector(`.ag-header-cell[${ATTR_COLUMN_INDEX}="${columnIndex}"]`);
    const sortedFloatingFilterCell = document.querySelector(`.ag-floating-filter.ag-header-cell[${ATTR_COLUMN_INDEX}="${columnIndex}"]`);
    if (sortedColumnHeaderCell) sortedColumnHeaderCell.classList.add(CLASS_HIGHLIGHT);
    if (sortedFloatingFilterCell) sortedFloatingFilterCell.classList.add(CLASS_HIGHLIGHT);
    e.api.refreshCells({
        force: true
    });
};
const $9c5a65a49d98fcb7$export$1246b1043814b8a0 = ({ value: value, defaultValue: defaultValue, getFormattedValue: getFormattedValue })=>(0, $htzEo.hasNoLength)(value) ? defaultValue : getFormattedValue(value);
const $9c5a65a49d98fcb7$export$f4beaec329e96f2 = {
    integer: {
        format: (value)=>$9c5a65a49d98fcb7$export$1246b1043814b8a0({
                value: value,
                defaultValue: "0",
                getFormattedValue: (0, $htzEo.getIntegerFormat)
            })
    },
    volume: {
        format: (value)=>(0, $htzEo.getUngroupedNoDecimals)(value)
    },
    date: {
        format: (value)=>(0, $htzEo.shortDateFormatWithSlashes)(value)
    },
    oneDecimal: {
        format: (value)=>(0, $htzEo.formatDecimal)(value, 1)
    },
    booleanShort: {
        format: (value)=>(0, $htzEo.boolToShortString)(value)
    },
    listingStatus: {
        format: (value)=>(0, $htzEo.getListingStatus)(value)
    },
    decimal: {
        format: (value)=>$9c5a65a49d98fcb7$export$1246b1043814b8a0({
                value: value,
                defaultValue: "0",
                getFormattedValue: (0, $htzEo.getDecimalNumber)
            })
    },
    percentage: {
        format: (value)=>(0, $htzEo.formatPercent)(value, 1)
    },
    percent2Decimals: {
        format: (value)=>(0, $htzEo.formatPercent)(value, 2)
    },
    centuplePercentage: {
        format: (value)=>(0, $htzEo.formatPercent)((value || 0) * 100, 2)
    },
    average: {
        format: (value)=>(0, $htzEo.centupleDecimalFormatter)(value)
    },
    percentageEmptyCell: {
        format: (value)=>(0, $htzEo.formatClr)(value)
    }
};
const $9c5a65a49d98fcb7$export$3f8f5e9e7e017115 = {
    input: function(value) {
        this.value = value;
        return this;
    },
    replaceDots: function() {
        // AG Grid will not add a filename suffix (eg. '.csv') if the filename contains a dot, so remove all dots
        this.value = this.value.replaceAll(".", "");
        return this;
    },
    fixApostrophes: function() {
        // REMAX's's becomes REMAX's
        this.value = this.value.replaceAll("'s's", "'s");
        // Properties's becomes Properties'
        this.value = this.value.replaceAll("s's", "s'");
        // REALTORS's becomes REALTORS'
        this.value = this.value.replaceAll("S's", "S'");
        return this;
    },
    removeRepeats: function() {
        this.value = this.value.replaceAll("Listings Listings", "Listings");
        return this;
    },
    output: function() {
        return this.value;
    }
};
const $9c5a65a49d98fcb7$export$d564bb60b0b17c38 = (filename)=>{
    return $9c5a65a49d98fcb7$export$3f8f5e9e7e017115.input(filename).replaceDots().fixApostrophes().removeRepeats().output();
};
const $9c5a65a49d98fcb7$export$25fbc64d484d490d = (column)=>column?.visible ?? column?.shouldExport ?? !column?.hide;
const $9c5a65a49d98fcb7$export$f7be0cb454ead2e0 = (cell)=>{
    if ($9c5a65a49d98fcb7$export$7ef0a69c92eb56ab(cell?.value)) return $9c5a65a49d98fcb7$export$f11edb22ccc7d971(cell?.value);
    if (cell?.column?.colDef?.exportFormatter) return cell?.column?.colDef?.exportFormatter(cell?.value);
    if (cell?.column?.colDef?.valueFormatter) return cell?.column?.colDef?.valueFormatter(cell);
    if (cell?.column?.colId === (0, $eHBjM.agentsColumns).officeName.id && cell?.value === undefined) return (0, $cstaF.searchTerms).totals;
    if (cell?.column?.colId === (0, $eHBjM.agentsColumns).agProdMonth.id) return (0, $5GRJ8.getDateForTable)(new Date(cell.value));
    return cell?.value;
};
const $9c5a65a49d98fcb7$export$4aa7a373bd206c61 = (header)=>{
    const exportHeaderLabel = header?.column?.colDef?.exportHeaderLabel ?? header?.column?.colDef?.headerComponentParams?.titleWithTooltip?.props?.headerDetails?.label;
    return exportHeaderLabel !== undefined ? exportHeaderLabel : header?.column?.colDef?.headerName;
};
const $9c5a65a49d98fcb7$export$d341600c99421b04 = ({ colDef: colDef, pinnedRowData: pinnedRowData, keyField: keyField })=>{
    return pinnedRowData?.[keyField || colDef.field] * 100;
};
const $9c5a65a49d98fcb7$export$e51d15ff88f01024 = ({ pinnedRowData: pinnedRowData, keyField: keyField })=>{
    return pinnedRowData?.[keyField];
};
const $9c5a65a49d98fcb7$export$93ffca7b17ee039 = ({ rowData: rowData, colDef: colDef })=>{
    return (0, $94cVo.getSum)(rowData, colDef.field);
};
const $9c5a65a49d98fcb7$export$e5abc9cd8d1d4db6 = "*****-USE-CELL-VALUE-*****";
const $9c5a65a49d98fcb7$export$8c5e027791aaddab = (value)=>value + $9c5a65a49d98fcb7$export$e5abc9cd8d1d4db6;
const $9c5a65a49d98fcb7$export$f11edb22ccc7d971 = (value)=>value?.replace($9c5a65a49d98fcb7$export$e5abc9cd8d1d4db6, "");
const $9c5a65a49d98fcb7$export$7ef0a69c92eb56ab = (value)=>value?.toString().indexOf($9c5a65a49d98fcb7$export$e5abc9cd8d1d4db6) >= 0;
const $9c5a65a49d98fcb7$export$2135745f0011185 = (gridRef, key, value)=>{
    gridRef.current.api.forEachNode((node)=>{
        if (node.data[key] === value) gridRef.current.api.applyTransaction({
            remove: [
                node.data
            ]
        });
    });
};
const $9c5a65a49d98fcb7$export$fea46f06b264671f = (tableViewId)=>{
    const isRankedTable = [
        (0, $eHBjM.tableViewNames).overview,
        (0, $eHBjM.tableViewNames).contactInformation,
        (0, $eHBjM.tableViewNames).growthAnalysisLtm,
        (0, $eHBjM.tableViewNames).growthAnalysisYtd,
        (0, $eHBjM.tableViewNames).listingProficiency
    ].includes(tableViewId);
    return isRankedTable ? {
        getRowId: (params)=>`${params.context.tableViewId}-agent-${params.data?.agentId}`
    } : {};
};
const $9c5a65a49d98fcb7$export$5526142bc0670f41 = (data, keyFieldToRank)=>{
    if (!keyFieldToRank) return data.map((obj, i)=>({
            ...obj,
            rank: i + 1
        }));
    let rank = 1;
    let prevValue = data[0]?.[keyFieldToRank];
    return data.map((obj, i)=>{
        const currentValue = obj?.[keyFieldToRank];
        if (i === 0 || currentValue === prevValue) return {
            ...obj,
            rank: rank
        };
        if (currentValue !== prevValue) rank = i + 1;
        prevValue = currentValue;
        return {
            ...obj,
            rank: rank
        };
    });
};
const $9c5a65a49d98fcb7$export$1db97829a835063b = ({ api: api, sortState: sortState })=>{
    if (!api || !sortState) return;
    const currentColumnState = api.getColumnState();
    const isGridSortApplied = currentColumnState.some((col)=>col.colId === sortState.colId && col.sort === sortState.sort);
    if (!isGridSortApplied) api.applyColumnState({
        state: [
            {
                colId: sortState.colId,
                sort: sortState.sort
            }
        ],
        defaultState: {
            sort: null
        }
    });
};
const $9c5a65a49d98fcb7$export$836ee5a1ac4ae57e = ({ api: api, filterState: filterState })=>{
    if (!api || !filterState) return;
    const filterModel = {};
    Object.entries(filterState).forEach(([colName, value])=>{
        filterModel[colName] = {
            type: "contains",
            filter: value
        };
    });
    api.setFilterModel(filterModel);
};
const $9c5a65a49d98fcb7$export$d338a0b8ae7a62b7 = (api, selectedAgentIds, enabled)=>{
    if (!enabled || !api) return;
    const selectedIds = new Set(selectedAgentIds || []);
    const toSelect = [], toDeselect = [];
    api.forEachNode((node)=>{
        const shouldBeSelected = selectedIds.has(node.data?.agentId);
        if (node.isSelected() !== shouldBeSelected) (shouldBeSelected ? toSelect : toDeselect).push(node);
    });
    if (toSelect.length) api.setNodesSelected({
        nodes: toSelect,
        newValue: true,
        source: "api"
    });
    if (toDeselect.length) api.setNodesSelected({
        nodes: toDeselect,
        newValue: false,
        source: "api"
    });
};

});
parcelRegister("5GRJ8", function(module, exports) {

$parcel$export(module.exports, "getParsedDate", () => $a77883eb5098860e$export$78bf1f6ce20a7708);
$parcel$export(module.exports, "getDateForFilename", () => $a77883eb5098860e$export$eab87c30506aae2);
$parcel$export(module.exports, "getDateForAgentProductionFilename", () => $a77883eb5098860e$export$2eaf2de202fb3e3c);
$parcel$export(module.exports, "getDateForTable", () => $a77883eb5098860e$export$50ff70fda4c1cf42);
$parcel$export(module.exports, "monthTextYearFormatter", () => $a77883eb5098860e$export$5b063a4f35e340c8);
$parcel$export(module.exports, "maskNullDate", () => $a77883eb5098860e$export$359332ed097aee16);

var $6IhJz = parcelRequire("6IhJz");
var $auRgN = parcelRequire("auRgN");
const $a77883eb5098860e$export$78bf1f6ce20a7708 = (toParse)=>{
    // expected format for incoming date is yyyy-MM-ddThh:mm:ss
    const partsDateTime = toParse.split("T");
    return (0, $auRgN.default)(partsDateTime[0], "yyyy-MM-dd", new Date());
};
const $a77883eb5098860e$export$eab87c30506aae2 = (date)=>(0, $6IhJz.default)(date, "MMMM d, yyyy");
const $a77883eb5098860e$export$2eaf2de202fb3e3c = (date)=>(0, $6IhJz.default)(date, "MMMM yyyy");
const $a77883eb5098860e$export$50ff70fda4c1cf42 = (date)=>(0, $6IhJz.default)(date, "MMM - yyyy");
const $a77883eb5098860e$export$5b063a4f35e340c8 = (date)=>$a77883eb5098860e$export$50ff70fda4c1cf42(new Date(date));
const $a77883eb5098860e$var$formatDateForExport = (date)=>new Date(date).toLocaleDateString("en-US");
const $a77883eb5098860e$export$359332ed097aee16 = (date)=>date ? $a77883eb5098860e$var$formatDateForExport(date) : null;

});




parcelRegister("98ROn", function(module, exports) {

$parcel$export(module.exports, "unitWidth", () => $6a7e9a47eafa04db$export$8672af16f94157f0);
$parcel$export(module.exports, "defaultColumnDef", () => $6a7e9a47eafa04db$export$e76aea5d4e14d73c);
$parcel$export(module.exports, "dividerClassNames", () => $6a7e9a47eafa04db$export$423b66acf854747e);
$parcel$export(module.exports, "colSettings", () => $6a7e9a47eafa04db$export$5c16fb70bafb71b6);

var $htzEo = parcelRequire("htzEo");
const $6a7e9a47eafa04db$export$8672af16f94157f0 = Object.freeze({
    icon: 40,
    dom: 80,
    tiny: 92,
    small: 100,
    compact: 120,
    regular: 155,
    moderate: 180,
    medium: 230,
    mediumLarge: 275,
    large: 330,
    extraLarge: 520
});
const $6a7e9a47eafa04db$export$e76aea5d4e14d73c = {
    flex: 1,
    sortingOrder: [
        "desc",
        "asc"
    ],
    suppressHeaderMenuButton: true,
    sortable: true
};
const $6a7e9a47eafa04db$var$iconDefaults = {
    cellClass: "d-flex justify-content-center align-items-center pr-0",
    minWidth: $6a7e9a47eafa04db$export$8672af16f94157f0.icon,
    resizable: false
};
const $6a7e9a47eafa04db$var$textDefaults = {
    headerClass: "font-weight-bold",
    minWidth: $6a7e9a47eafa04db$export$8672af16f94157f0.regular,
    resizable: true
};
const $6a7e9a47eafa04db$var$textDefaultsRightAlign = {
    headerClass: "align-top no-wrap td-num d-flex justify-content-end",
    cellClass: "td-num",
    minWidth: $6a7e9a47eafa04db$export$8672af16f94157f0.regular,
    resizable: true
};
const $6a7e9a47eafa04db$var$numberDefaults = {
    cellClass: "td-num",
    headerClass: "align-top no-wrap td-num d-flex justify-content-end",
    minWidth: $6a7e9a47eafa04db$export$8672af16f94157f0.regular,
    resizable: true
};
const $6a7e9a47eafa04db$var$checkboxRightAlign = {
    cellClass: "checkbox-right-align",
    headerClass: "font-weight-bold",
    maxWidth: 34,
    resizable: false
};
const $6a7e9a47eafa04db$export$423b66acf854747e = {
    dividerCol: "divider-col",
    leftDividerCol: "left-divider-col",
    transparentResizeIcon: "transparent-resize-icon"
};
const $6a7e9a47eafa04db$export$5c16fb70bafb71b6 = {
    textTinyRightAlign: {
        ...$6a7e9a47eafa04db$var$textDefaultsRightAlign,
        minWidth: 55
    },
    icon: {
        ...$6a7e9a47eafa04db$var$iconDefaults
    },
    textTiny: {
        ...$6a7e9a47eafa04db$var$textDefaults,
        minWidth: 55
    },
    textXs: {
        ...$6a7e9a47eafa04db$var$textDefaults,
        minWidth: $6a7e9a47eafa04db$export$8672af16f94157f0.tiny
    },
    textXsRightAlign: {
        ...$6a7e9a47eafa04db$var$textDefaultsRightAlign,
        minWidth: $6a7e9a47eafa04db$export$8672af16f94157f0.tiny
    },
    textSmall: {
        ...$6a7e9a47eafa04db$var$textDefaults,
        minWidth: $6a7e9a47eafa04db$export$8672af16f94157f0.compact
    },
    textSmRightAlign: {
        ...$6a7e9a47eafa04db$var$textDefaultsRightAlign,
        minWidth: $6a7e9a47eafa04db$export$8672af16f94157f0.compact
    },
    textSm: {
        ...$6a7e9a47eafa04db$var$textDefaults
    },
    textMd: {
        ...$6a7e9a47eafa04db$var$textDefaults,
        minWidth: $6a7e9a47eafa04db$export$8672af16f94157f0.medium
    },
    textLg: {
        ...$6a7e9a47eafa04db$var$textDefaults,
        minWidth: $6a7e9a47eafa04db$export$8672af16f94157f0.large
    },
    textXl: {
        ...$6a7e9a47eafa04db$var$textDefaults,
        minWidth: $6a7e9a47eafa04db$export$8672af16f94157f0.extraLarge
    },
    numberXsInteger: {
        ...$6a7e9a47eafa04db$var$numberDefaults,
        minWidth: $6a7e9a47eafa04db$export$8672af16f94157f0.tiny,
        valueFormatter: (v)=>(0, $htzEo.formatInteger)(v.value)
    },
    numberSmRightAlign: {
        ...$6a7e9a47eafa04db$var$numberDefaults
    },
    numberSmTiny: {
        ...$6a7e9a47eafa04db$var$numberDefaults,
        minWidth: 55,
        maxWidth: 55,
        valueFormatter: (v)=>(0, $htzEo.formatInteger)(v.value)
    },
    numberSmInteger: {
        ...$6a7e9a47eafa04db$var$numberDefaults,
        valueFormatter: (v)=>(0, $htzEo.formatInteger)(v.value)
    },
    numberMdInteger: {
        ...$6a7e9a47eafa04db$var$numberDefaults,
        minWidth: $6a7e9a47eafa04db$export$8672af16f94157f0.moderate,
        valueFormatter: (v)=>(0, $htzEo.formatInteger)(v.value)
    },
    numberLgInteger: {
        ...$6a7e9a47eafa04db$var$numberDefaults,
        minWidth: $6a7e9a47eafa04db$export$8672af16f94157f0.medium,
        valueFormatter: (v)=>(0, $htzEo.formatInteger)(v.value)
    },
    numberMdLgInteger: {
        ...$6a7e9a47eafa04db$var$numberDefaults,
        minWidth: $6a7e9a47eafa04db$export$8672af16f94157f0.mediumLarge,
        valueFormatter: (v)=>(0, $htzEo.formatInteger)(v.value)
    },
    numberXsPercentage: {
        ...$6a7e9a47eafa04db$var$numberDefaults,
        minWidth: $6a7e9a47eafa04db$export$8672af16f94157f0.small,
        valueFormatter: (v)=>(0, $htzEo.formatPercentage)(v.value)
    },
    numberSmPercentage: {
        ...$6a7e9a47eafa04db$var$numberDefaults,
        valueFormatter: (v)=>(0, $htzEo.formatPercentage)(v.value)
    },
    numberSmPercentageMultiplier: {
        ...$6a7e9a47eafa04db$var$numberDefaults,
        valueFormatter: (v)=>(0, $htzEo.formatOneDecimalPercentageWithMultiplier)(v.value)
    },
    numberMdPercentage: {
        ...$6a7e9a47eafa04db$var$numberDefaults,
        minWidth: $6a7e9a47eafa04db$export$8672af16f94157f0.moderate,
        valueFormatter: (v)=>(0, $htzEo.formatPercentage)(v.value)
    },
    numberSmGroupedInteger: {
        ...$6a7e9a47eafa04db$var$numberDefaults,
        valueFormatter: (v)=>(0, $htzEo.formatGroupedInteger)(v.value)
    },
    blankEmptyNumberSmPercentage: {
        ...$6a7e9a47eafa04db$var$numberDefaults,
        valueFormatter: (v)=>(0, $htzEo.blankEmptyFormatPercentage)(v.value)
    },
    numberSmCentuplePercentage: {
        ...$6a7e9a47eafa04db$var$numberDefaults,
        valueFormatter: (v)=>(0, $htzEo.centupleDecimalFormatter)(v.value)
    },
    blankEmptyNumberSmPercentageWithMultiplier: {
        ...$6a7e9a47eafa04db$var$numberDefaults,
        valueFormatter: (v)=>(0, $htzEo.blankEmptyFormatPercentageWithMultiplier)(v.value)
    },
    numberXsVolume: {
        ...$6a7e9a47eafa04db$var$numberDefaults,
        minWidth: $6a7e9a47eafa04db$export$8672af16f94157f0.tiny,
        valueFormatter: (v)=>(0, $htzEo.formatVolume)(v.value)
    },
    numberSmVolume: {
        ...$6a7e9a47eafa04db$var$numberDefaults,
        valueFormatter: (v)=>(0, $htzEo.formatVolume)(v.value)
    },
    numberMdVolume: {
        ...$6a7e9a47eafa04db$var$numberDefaults,
        minWidth: $6a7e9a47eafa04db$export$8672af16f94157f0.moderate,
        valueFormatter: (v)=>(0, $htzEo.formatVolume)(v.value)
    },
    numberLgVolume: {
        ...$6a7e9a47eafa04db$var$numberDefaults,
        minWidth: $6a7e9a47eafa04db$export$8672af16f94157f0.medium,
        valueFormatter: (v)=>(0, $htzEo.formatVolume)(v.value)
    },
    blankEmptyTinyVolume: {
        ...$6a7e9a47eafa04db$var$numberDefaults,
        minWidth: $6a7e9a47eafa04db$export$8672af16f94157f0.tiny,
        valueFormatter: (v)=>(0, $htzEo.formatBlankEmptyVolume)(v.value)
    },
    blankEmptyXsInteger: {
        ...$6a7e9a47eafa04db$var$numberDefaults,
        minWidth: 104,
        valueFormatter: (v)=>(0, $htzEo.formatBlankEmptyInteger)(v.value)
    },
    blankEmptyXsVolume: {
        ...$6a7e9a47eafa04db$var$numberDefaults,
        minWidth: 104,
        valueFormatter: (v)=>(0, $htzEo.formatBlankEmptyVolume)(v.value)
    },
    blankEmptyXsUnit: {
        ...$6a7e9a47eafa04db$var$numberDefaults,
        minWidth: 104,
        valueFormatter: (v)=>(0, $htzEo.formatBlankEmptyUnit)(v.value)
    },
    numberMdLgVolume: {
        ...$6a7e9a47eafa04db$var$numberDefaults,
        minWidth: $6a7e9a47eafa04db$export$8672af16f94157f0.mediumLarge,
        valueFormatter: (v)=>(0, $htzEo.formatVolume)(v.value)
    },
    numberExLgVolume: {
        ...$6a7e9a47eafa04db$var$numberDefaults,
        minWidth: $6a7e9a47eafa04db$export$8672af16f94157f0.large,
        valueFormatter: (v)=>(0, $htzEo.formatVolume)(v.value)
    },
    blankEmptySmVolume: {
        ...$6a7e9a47eafa04db$var$numberDefaults,
        valueFormatter: (v)=>(0, $htzEo.formatBlankEmptyVolume)(v.value)
    },
    numberSmUnits: {
        ...$6a7e9a47eafa04db$var$numberDefaults,
        valueFormatter: (v)=>(0, $htzEo.getDecimalNumber)(v.value)
    },
    numberMdUnits: {
        ...$6a7e9a47eafa04db$var$numberDefaults,
        minWidth: $6a7e9a47eafa04db$export$8672af16f94157f0.medium,
        valueFormatter: (v)=>(0, $htzEo.getDecimalNumber)(v.value)
    },
    numberMdLgUnits: {
        ...$6a7e9a47eafa04db$var$numberDefaults,
        minWidth: $6a7e9a47eafa04db$export$8672af16f94157f0.mediumLarge,
        valueFormatter: (v)=>(0, $htzEo.getDecimalNumber)(v.value)
    },
    numberLgUnits: {
        ...$6a7e9a47eafa04db$var$numberDefaults,
        minWidth: $6a7e9a47eafa04db$export$8672af16f94157f0.large,
        valueFormatter: (v)=>(0, $htzEo.getDecimalNumber)(v.value)
    },
    dateSm: {
        ...$6a7e9a47eafa04db$var$textDefaults,
        valueFormatter: (v)=>(0, $htzEo.getFormattedDate)(v.value, "yyyy-MM-dd")
    },
    dateMd: {
        ...$6a7e9a47eafa04db$var$textDefaults,
        minWidth: $6a7e9a47eafa04db$export$8672af16f94157f0.moderate,
        valueFormatter: (v)=>(0, $htzEo.getFormattedDate)(v.value, "yyyy-MM-dd")
    },
    numberLgPercentageOneDecimal: {
        ...$6a7e9a47eafa04db$var$numberDefaults,
        minWidth: $6a7e9a47eafa04db$export$8672af16f94157f0.medium,
        valueFormatter: (v)=>(0, $htzEo.formatOneDecimalPercentageWithMultiplier)(v.value)
    },
    bankStatus: {
        ...$6a7e9a47eafa04db$var$textDefaults,
        minWidth: $6a7e9a47eafa04db$export$8672af16f94157f0.moderate,
        valueFormatter: (v)=>(0, $htzEo.boolToShortString)(v.value)
    },
    numberTwoDecimalsPercentage: {
        ...$6a7e9a47eafa04db$var$numberDefaults,
        valueFormatter: (v)=>(0, $htzEo.formatStandardPct)(v.value)
    },
    checkboxSmall: {
        maxWidth: 34,
        resizable: false
    },
    checkboxMedium: {
        maxWidth: 50,
        resizable: false
    },
    checkboxSmallRight: {
        ...$6a7e9a47eafa04db$var$checkboxRightAlign,
        maxWidth: 34
    }
};

});

parcelRegister("2Wf8L", function(module, exports) {

$parcel$export(module.exports, "OfficeGroupName", () => $460c3de11b55f35a$export$b1da699aa198ed68);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4fGPb = parcelRequire("4fGPb");

var $c7dF9 = parcelRequire("c7dF9");

var $94cVo = parcelRequire("94cVo");

var $c9Z8w = parcelRequire("c9Z8w");
const $460c3de11b55f35a$export$b1da699aa198ed68 = (props)=>{
    const groupParam = (0, $94cVo.uriEncode)(props.data.groupName);
    const searchTypeRoute = props.data.isCoverageSearch ? (0, $c7dF9.Routes).MARKET_SHARE.COVERAGE : (0, $c7dF9.Routes).MARKET_SHARE.TOTALS;
    const pathname = `${(0, $c7dF9.Routes).MARKET_SHARE.BASE}${searchTypeRoute}${(0, $c7dF9.Routes).MARKET_SHARE.OFFICES_BREAKDOWN}`;
    const search = `?officeGroupName=${groupParam}&view=${props.data.supplementalData.listingViewId}`;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: props.data?.isClickable ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fGPb.Link), {
            to: {
                pathname: pathname,
                search: search,
                state: {
                    area: props.data?.areaId,
                    id: props.data.officeId,
                    group: groupParam,
                    listingViewId: props.data.supplementalData.listingViewId,
                    type: props.data.supplementalData.listingTypeId,
                    listingTypeId: props.data.supplementalData.listingTypeId,
                    rowCount: props.data.supplementalData.rowCount,
                    sumOfColumn: props.data.supplementalData.sumOfColumn
                }
            },
            children: props.value
        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            children: props.value
        })
    });
};
$460c3de11b55f35a$export$b1da699aa198ed68.PropTypes = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};

});

parcelRegister("2rG3e", function(module, exports) {

$parcel$export(module.exports, "OfficeName", () => $534a417acf53dcac$export$14eebd2e872f1aff);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4fGPb = parcelRequire("4fGPb");

var $c7dF9 = parcelRequire("c7dF9");

var $94cVo = parcelRequire("94cVo");

var $c9Z8w = parcelRequire("c9Z8w");
const $534a417acf53dcac$export$14eebd2e872f1aff = (props)=>{
    const officeParam = (0, $94cVo.uriEncode)(props.data.officeName);
    const searchTypeRoute = props.data.isCoverageSearch ? (0, $c7dF9.Routes).MARKET_SHARE.COVERAGE : (0, $c7dF9.Routes).MARKET_SHARE.TOTALS;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fGPb.Link), {
        to: {
            pathname: `${(0, $c7dF9.Routes).MARKET_SHARE.BASE}${searchTypeRoute}${(0, $c7dF9.Routes).MARKET_SHARE.OFFICE_LISTING}`,
            search: `?office=${officeParam}&id=${props.data.officeId}`,
            state: {
                area: props.data?.areaId,
                id: props.data.officeId,
                office: officeParam,
                listingTypeId: props.data.listingTypeId,
                view: props.data.listingViewId
            }
        },
        children: props.value
    });
};
$534a417acf53dcac$export$14eebd2e872f1aff.propTypes = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};

});

parcelRegister("93Pvi", function(module, exports) {

$parcel$export(module.exports, "CustomCheckbox", () => $ab54d6da1b99a38d$export$1cd78ad38541e100);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $3etjB = parcelRequire("3etjB");

var $90ISC = parcelRequire("90ISC");
const $ab54d6da1b99a38d$export$1cd78ad38541e100 = (props)=>{
    const { context: context, data: data, node: node } = props;
    const { maxRows: maxRows, setSelectedRowsIds: setSelectedRowsIds, showToast: showToast } = context;
    const selectedRowsIds = (0, $90ISC.useCommonStore)((state)=>state.selectedRowsIds);
    const [isSelected, setSelected] = (0, $acw62.useState)(data.isSelected);
    const currentRowId = data.officeId || data.brokerId || data.areaId || data.groupId;
    const rowIndex = node?.rowIndex;
    const handleSelection = async (e)=>{
        e.stopPropagation();
        let filteredRows;
        if (!isSelected && selectedRowsIds.length >= maxRows) {
            showToast((0, $3etjB.marketShareTerms).MAX_ROWS_ARE_SELECTED);
            return;
        }
        filteredRows = !isSelected ? [
            ...selectedRowsIds,
            currentRowId
        ] : selectedRowsIds.filter((id)=>id !== currentRowId);
        setSelectedRowsIds(filteredRows);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        id: `row-${node?.rowIndex}`,
        className: "d-flex justify-content-center align-items-center",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
            id: rowIndex,
            type: "checkbox",
            className: "custom-checkbox",
            checked: isSelected,
            onChange: handleSelection
        })
    });
};
$ab54d6da1b99a38d$export$1cd78ad38541e100.proptypes = {
    api: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    context: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    data: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    node: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};

});

parcelRegister("kWnaD", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3eb329d09eca1e1$export$2e2bcd8739ae039);

var $dPIJZ = parcelRequire("dPIJZ");
class $f3eb329d09eca1e1$export$2e2bcd8739ae039 {
    init(params) {
        this.eGui = document.createElement("div");
        this.eGui.className = `${params.classNames?.join(" ")} w-100 p-1`;
        this.eGui.innerHTML = '<input type="text" class="d-inline-block form-control ag-custom-float-filter" />';
        this.eFilterInput = this.eGui.querySelector("input");
        this.eFilterInput.placeholder = params.placeholder;
        const onInputBoxChanged = ()=>{
            if (this.eFilterInput.value === "") {
                // clear the filter
                params.parentFilterInstance((instance)=>{
                    instance.onFloatingFilterChanged(null, null);
                });
                return;
            }
            params.parentFilterInstance((instance)=>{
                instance.onFloatingFilterChanged("contains", this.eFilterInput.value);
            });
        };
        this.eFilterInput.addEventListener("input", (0, $dPIJZ.default)(onInputBoxChanged, 500));
    }
    onParentModelChanged(parentModel) {
        // When the filter is empty we will receive a null message here
        if (!parentModel) this.eFilterInput.value = "";
        else this.eFilterInput.value = parentModel.filter ?? "";
    }
    getGui() {
        return this.eGui;
    }
}

});
parcelRegister("dPIJZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a122be60491e8d4a$export$2e2bcd8739ae039);

var $iYDsF = parcelRequire("iYDsF");

var $2OtHx = parcelRequire("2OtHx");

var $1fkDi = parcelRequire("1fkDi");
/** Error message constants. */ var $a122be60491e8d4a$var$FUNC_ERROR_TEXT = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var $a122be60491e8d4a$var$nativeMax = Math.max, $a122be60491e8d4a$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $a122be60491e8d4a$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($a122be60491e8d4a$var$FUNC_ERROR_TEXT);
    wait = (0, $1fkDi.default)(wait) || 0;
    if ((0, $iYDsF.default)(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $a122be60491e8d4a$var$nativeMax((0, $1fkDi.default)(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $a122be60491e8d4a$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = (0, $2OtHx.default)();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge((0, $2OtHx.default)());
    }
    function debounced() {
        var time = (0, $2OtHx.default)(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
var $a122be60491e8d4a$export$2e2bcd8739ae039 = $a122be60491e8d4a$var$debounce;

});
parcelRegister("2OtHx", function(module, exports) {

$parcel$export(module.exports, "default", () => $20c74a585cb2c860$export$2e2bcd8739ae039);

var $2mpFt = parcelRequire("2mpFt");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $20c74a585cb2c860$var$now = function() {
    return (0, $2mpFt.default).Date.now();
};
var $20c74a585cb2c860$export$2e2bcd8739ae039 = $20c74a585cb2c860$var$now;

});

parcelRegister("1fkDi", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e87326299eb9bb7$export$2e2bcd8739ae039);

var $8N45u = parcelRequire("8N45u");

var $iYDsF = parcelRequire("iYDsF");

var $1WN0o = parcelRequire("1WN0o");
/** Used as references for various `Number` constants. */ var $0e87326299eb9bb7$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $0e87326299eb9bb7$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $0e87326299eb9bb7$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $0e87326299eb9bb7$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $0e87326299eb9bb7$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $0e87326299eb9bb7$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ((0, $1WN0o.default)(value)) return $0e87326299eb9bb7$var$NAN;
    if ((0, $iYDsF.default)(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = (0, $iYDsF.default)(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = (0, $8N45u.default)(value);
    var isBinary = $0e87326299eb9bb7$var$reIsBinary.test(value);
    return isBinary || $0e87326299eb9bb7$var$reIsOctal.test(value) ? $0e87326299eb9bb7$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $0e87326299eb9bb7$var$reIsBadHex.test(value) ? $0e87326299eb9bb7$var$NAN : +value;
}
var $0e87326299eb9bb7$export$2e2bcd8739ae039 = $0e87326299eb9bb7$var$toNumber;

});
parcelRegister("8N45u", function(module, exports) {

$parcel$export(module.exports, "default", () => $66661208b19b5b1b$export$2e2bcd8739ae039);

var $iu14O = parcelRequire("iu14O");
/** Used to match leading whitespace. */ var $66661208b19b5b1b$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $66661208b19b5b1b$var$baseTrim(string) {
    return string ? string.slice(0, (0, $iu14O.default)(string) + 1).replace($66661208b19b5b1b$var$reTrimStart, "") : string;
}
var $66661208b19b5b1b$export$2e2bcd8739ae039 = $66661208b19b5b1b$var$baseTrim;

});
parcelRegister("iu14O", function(module, exports) {

$parcel$export(module.exports, "default", () => $d74bdd257728cf90$export$2e2bcd8739ae039);
/** Used to match a single whitespace character. */ var $d74bdd257728cf90$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $d74bdd257728cf90$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $d74bdd257728cf90$var$reWhitespace.test(string.charAt(index)));
    return index;
}
var $d74bdd257728cf90$export$2e2bcd8739ae039 = $d74bdd257728cf90$var$trimmedEndIndex;

});


parcelRegister("1WN0o", function(module, exports) {

$parcel$export(module.exports, "default", () => $16b138b0231026b6$export$2e2bcd8739ae039);

var $hArsG = parcelRequire("hArsG");

var $f2iog = parcelRequire("f2iog");
/** `Object#toString` result references. */ var $16b138b0231026b6$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $16b138b0231026b6$var$isSymbol(value) {
    return typeof value == "symbol" || (0, $f2iog.default)(value) && (0, $hArsG.default)(value) == $16b138b0231026b6$var$symbolTag;
}
var $16b138b0231026b6$export$2e2bcd8739ae039 = $16b138b0231026b6$var$isSymbol;

});








parcelRegister("enZF7", function(module, exports) {

$parcel$export(module.exports, "agentListsEditModalActions", () => $a7930b82ffda6764$export$553adfa4e918dbe5);

var $24YIE = parcelRequire("24YIE");

var $cstaF = parcelRequire("cstaF");

var $3eK9g = parcelRequire("3eK9g");

var $ivaD7 = parcelRequire("ivaD7");

var $90ISC = parcelRequire("90ISC");

var $f6CJ4 = parcelRequire("f6CJ4");

var $dDBOF = parcelRequire("dDBOF");
const $a7930b82ffda6764$export$553adfa4e918dbe5 = (set, get)=>({
        closeEditModal: (setState, toggleListModal)=>{
            setState((prevState)=>({
                    ...prevState,
                    showEditModal: {
                        [(0, $3eK9g.modalKeys).dropdown]: false,
                        [(0, $3eK9g.modalKeys).transfer]: false
                    },
                    listIsDirty: false
                }));
            setTimeout(()=>toggleListModal(), 500);
        },
        closePopover: (setState)=>{
            setState((prevState)=>({
                    ...prevState,
                    showErrorModal: false,
                    isListModalOpen: false,
                    isPopoverOpen: false,
                    filteredAgents: undefined
                }));
        },
        selectAgentList: (agentList, selectedSavedSearch)=>{
            (0, $90ISC.useSearchStore).getState().setSelectedAgentList(agentList, selectedSavedSearch);
        },
        updateAgentList: async (agentList, state, setState, userId, selectedSavedSearch, showToast, toggleListModal)=>{
            const savedAgentsModule = (0, $cstaF.modules).proficiencyMetrics.savedAgents;
            const agentsNameModule = (0, $cstaF.modules).proficiencyMetrics.agents;
            const savedAgentsSelectedList = get().selectedListByModule[savedAgentsModule];
            const response = await (0, $24YIE.updateSavedAgentList)(agentList);
            if (response.error) {
                showToast("error", (0, $cstaF.toastMessages).error.saveList((0, $cstaF.agentProductionTerms).agent));
                return;
            }
            let updatedList = {
                ...response
            };
            if (state.overwriteAffectedSavedSearches && state.editAgentList) {
                await (0, $24YIE.deleteSavedAgentList)(state.editAgentList.agentListId);
                (0, $ivaD7.setStateData)("overwriteAffectedSavedSearches", false, setState);
            }
            await (0, $90ISC.useCommonStore).getState().getAgentLists(userId);
            selectedSavedSearch && get().selectAgentList(updatedList, selectedSavedSearch);
            setState((prevState)=>({
                    ...prevState,
                    initialSelectedList: updatedList
                }));
            get().setSelectedListByModule(agentsNameModule, updatedList);
            savedAgentsSelectedList?.agentListId === updatedList.agentListId && get().setSelectedListByModule(savedAgentsModule, updatedList);
            get().closeEditModal(setState, toggleListModal);
            showToast("success", (0, $cstaF.toastMessages).success.savedListConfirmation(updatedList.name));
        },
        updateAgentListWithSavedSearch: async (list, savedList, state, setState, toggleListModal, userId, selectedSavedSearch, showToast)=>{
            const response = await (0, $24YIE.getSearchesByAgentListId)(list.agentListId);
            if (!response.error) {
                if (response.savedSearches.length === 0) await get().updateAgentList({
                    ...savedList
                }, state, setState, userId, selectedSavedSearch, showToast, toggleListModal);
                else setState((prevState)=>({
                        ...prevState,
                        affectedSavedSearches: response.savedSearches,
                        savedSearchesUpdatePrompt: "save",
                        selectedAgentList: savedList,
                        showAffectedSavedSearchesModal: true
                    }));
            } else {
                showToast("error", (0, $cstaF.toastMessages).error.saveList((0, $cstaF.agentProductionTerms).agent));
                get().closeEditModal(setState, toggleListModal);
            }
        },
        saveAgentList: async (agentList, setState, toggleListModal, userId, selectedSavedSearch, showToast)=>{
            const response = await (0, $24YIE.saveAgentSearchList)(agentList);
            if (!response.error) {
                const agentsNameModule = (0, $cstaF.modules).proficiencyMetrics.agents;
                const selectedModule = (0, $90ISC.useSearchStore).getState().selectedModule;
                await (0, $90ISC.useCommonStore).getState().getAgentLists(userId);
                // if SelectedSavedSearch means Prof.metrics search criteria, When in Saved Agents should be false.
                (!!selectedSavedSearch || selectedModule === agentsNameModule) && get().selectAgentList({
                    ...response
                }, selectedSavedSearch);
                get().closeEditModal(setState, toggleListModal);
                get().closePopover(setState);
                showToast("success", (0, $cstaF.toastMessages).success.savedListConfirmation(response.name));
                return response;
            } else showToast("error", (0, $cstaF.toastMessages).error.saveList((0, $cstaF.agentProductionTerms).agent));
        },
        updateAgentChipTitle: (list)=>{
            const selectedModule = (0, $90ISC.useSearchStore).getState().selectedModule;
            const agentsNameModule = (0, $cstaF.modules).proficiencyMetrics.agents;
            const agentsNameSelectedList = get().selectedListByModule[agentsNameModule];
            const createdListId = list.agentListId;
            const agentsNameSelectedListId = agentsNameSelectedList?.agentListId;
            const listIsSelectedInAgentsName = createdListId === agentsNameSelectedListId;
            const isAgentsNameModuleSelected = selectedModule === agentsNameModule;
            const shouldSelectListInAgentsName = listIsSelectedInAgentsName || isAgentsNameModuleSelected;
            shouldSelectListInAgentsName && get().setSelectedListByModule(agentsNameModule, list);
        },
        validateAgentListNameAndSave: async (args)=>{
            const { event: event, list: list, newName: newName, mlsId: mlsId, selectedAgentCriteria: selectedAgentCriteria, state: state, setState: setState, toggleListModal: toggleListModal, userId: userId, selectedSavedSearch: selectedSavedSearch, showToast: showToast, closePopover: closePopover } = args;
            // if name is not changed, ignore overwrite prompt
            const agentLists = (0, $90ISC.useCommonStore).getState().agentLists;
            let newList;
            const found = agentLists && agentLists.find((l)=>l.mlsId === mlsId && l.ownerId === userId && l.name.toLowerCase() === list.name.toLowerCase());
            const savedList = {
                ...list,
                application: (0, $dDBOF.runningApp),
                ownerType: (0, $f6CJ4.useAuthStore).getState().ownerType,
                ownerId: userId,
                mlsId: mlsId,
                agentIds: selectedAgentCriteria ? [
                    ...selectedAgentCriteria.idValues
                ] : state.editAgentList.agentIds
            };
            const shouldOverwrite = newName && found;
            const isExistingListWithNewName = list.agentListId && newName;
            const isSaveAsNewListPressed = event.id === (0, $cstaF.buttonTerms).saveAsNewButtonId;
            const isUpdatePressed = event.id === (0, $cstaF.buttonTerms).updateButtonId;
            const hasAgentsChanged = list.agentListId && list.agentIds !== savedList.agentIds;
            if (shouldOverwrite) setState((prevState)=>({
                    ...prevState,
                    editAgentList: savedList,
                    showOverwriteModal: true,
                    overwriteAgentList: found
                }));
            else {
                if (isExistingListWithNewName) {
                    if (isSaveAsNewListPressed) newList = await get().saveAgentList({
                        ...savedList
                    }, setState, toggleListModal, userId, selectedSavedSearch, showToast);
                    else if (isUpdatePressed) await get().updateAgentListWithSavedSearch(list, savedList, state, setState, toggleListModal, userId, selectedSavedSearch, showToast);
                } else if (hasAgentsChanged) {
                    if (isUpdatePressed) await get().updateAgentListWithSavedSearch(list, savedList, state, setState, toggleListModal, userId, selectedSavedSearch, showToast);
                } else newList = await get().saveAgentList(savedList, setState, toggleListModal, userId, selectedSavedSearch, showToast);
            }
            const shouldUpdateAgentChipTitle = !(isExistingListWithNewName && isSaveAsNewListPressed);
            if (!shouldOverwrite) get().closePopover(setState);
            if (!shouldUpdateAgentChipTitle) return;
            get().updateAgentChipTitle(newList ?? savedList);
        },
        deleteAgentList: async (agentList, userId, resetSelectedAgentListTitle, state, setState, showToast, toggleListModal)=>{
            const response = await (0, $24YIE.deleteSavedAgentList)(agentList.agentListId);
            if (!response.error) {
                await (0, $90ISC.useCommonStore).getState().getAgentLists(userId);
                // we're passing this prop only when resetAgentListTitle is needed.
                !!resetSelectedAgentListTitle && resetSelectedAgentListTitle(agentList, state.addedAgents);
                (0, $ivaD7.setStateData)("selectedAgentList", undefined, setState);
                showToast("success", (0, $cstaF.toastMessages).success.deletedListConfirmation(response.name));
            } else showToast("error", (0, $cstaF.toastMessages).error.deleteSavedList((0, $cstaF.agentProductionTerms).agent));
            get().closeEditModal(setState, toggleListModal);
        },
        validateSavedSearchAndDelete: async (agentList, state, setState, userId, showToast, toggleListModal, resetSelectedAgentListTitle)=>{
            const response = await (0, $24YIE.getSearchesByAreaListId)(agentList.agentListId);
            if (!response.error) {
                if (response.savedSearches.length === 0) {
                    await get().deleteAgentList(agentList, userId, resetSelectedAgentListTitle, state, setState, showToast, toggleListModal);
                    get().setNextSelectedList(agentList);
                } else setState((prevState)=>({
                        ...prevState,
                        affectedSavedSearches: response.savedSearches,
                        savedSearchesUpdatePrompt: "delete",
                        selectedAgentList: agentList,
                        showAffectedSavedSearchesModal: true
                    }));
            } else {
                showToast("error", (0, $cstaF.toastMessages).error.deleteSavedList((0, $cstaF.agentProductionTerms).agent));
                get().closeEditModal(setState, toggleListModal);
            }
        },
        toggleOverwriteModal: (state, setState)=>{
            (0, $ivaD7.setStateData)("showOverwriteModal", !state.showOverwriteModal, setState);
        },
        continueWithSavedSearchesUpdate: async (selectedAgentList, userId, selectedSavedSearch, resetSelectedAgentList, state, setState, showToast, toggleListModal)=>{
            if (state.savedSearchesUpdatePrompt === "save") {
                await get().updateAgentList(selectedAgentList, state, setState, userId, selectedSavedSearch, showToast, toggleListModal);
                get().toggleOverwriteModal(state, setState);
            } else if (state.savedSearchesUpdatePrompt === "delete") {
                await get().deleteAgentList(selectedAgentList, userId, resetSelectedAgentList, state, setState, showToast, toggleListModal);
                get().setNextSelectedList(selectedAgentList);
            }
            (0, $ivaD7.setStateData)("showAffectedSavedSearchesModal", false, setState);
        },
        setNextSelectedList: (deletedList)=>{
            const savedAgentsModule = (0, $cstaF.modules).proficiencyMetrics.savedAgents;
            const agentsNameModule = (0, $cstaF.modules).proficiencyMetrics.agents;
            const savedAgentsSelectedList = get().selectedListByModule[savedAgentsModule];
            const agentsNameSelectedList = get().selectedListByModule[agentsNameModule];
            const { agentListId: agentListId } = deletedList ?? {};
            const agentLists = (0, $90ISC.useCommonStore).getState().agentLists;
            if (agentListId === savedAgentsSelectedList?.agentListId) {
                const agentList = agentLists.length > 0 ? agentLists[0] : undefined;
                get().setSelectedListByModule(savedAgentsModule, agentList);
            }
            if (agentListId === agentsNameSelectedList?.agentListId) get().setSelectedListByModule(agentsNameModule, undefined);
        }
    });

});
parcelRegister("3eK9g", function(module, exports) {

$parcel$export(module.exports, "modalKeys", () => $25b67a02d4060d60$export$72e4090e6cfc34b2);
const $25b67a02d4060d60$export$72e4090e6cfc34b2 = {
    dropdown: "dropdown-edit-list",
    transfer: "transfer-edit-list"
};

});


parcelRegister("eickZ", function(module, exports) {

$parcel$export(module.exports, "useSearchResultsStore", () => $a67c511822542cdf$export$830ed1b87b4bf813);

var $f4OIt = parcelRequire("f4OIt");

var $88tPr = parcelRequire("88tPr");

var $cstaF = parcelRequire("cstaF");

var $8cYiI = parcelRequire("8cYiI");

var $90ISC = parcelRequire("90ISC");
const $a67c511822542cdf$var$initialState = {
    searchResults: [],
    prevSelectedMls: null
};
let $a67c511822542cdf$var$searchResultsStore = (set)=>({
        [(0, $cstaF.modules).proficiencyMetrics.suggestedAgents]: $a67c511822542cdf$var$initialState,
        [(0, $cstaF.modules).proficiencyMetrics.agentMovement]: $a67c511822542cdf$var$initialState,
        [(0, $cstaF.modules).proficiencyMetrics.savedAgents]: $a67c511822542cdf$var$initialState,
        setSearchResults: (data)=>set((0, $8cYiI.produce)((state)=>{
                const selectedModule = (0, $90ISC.useSearchStore).getState().selectedModule;
                state[selectedModule].searchResults = data;
            })),
        setSavedAgentsSearchResults: (data)=>set((0, $8cYiI.produce)((state)=>{
                const selectedModule = (0, $90ISC.useSearchStore).getState().selectedModule;
                state[selectedModule].searchResults = data;
            })),
        setPrevSelectedMls: (mlsId)=>set((0, $8cYiI.produce)((state)=>{
                const selectedModule = (0, $90ISC.useSearchStore).getState().selectedModule;
                state[selectedModule].prevSelectedMls = mlsId;
            })),
        resetSavedAgentsSearchResults: ()=>set((0, $8cYiI.produce)((state)=>{
                const selectedModule = (0, $90ISC.useSearchStore).getState().selectedModule;
                state[selectedModule].searchResults = [];
            }))
    });
const $a67c511822542cdf$export$830ed1b87b4bf813 = (0, $f4OIt.create)((0, $88tPr.devtools)($a67c511822542cdf$var$searchResultsStore, {
    name: "search_results_state"
}));

});

parcelRegister("jeANf", function(module, exports) {

$parcel$export(module.exports, "toastTypes", () => $e00bdd7f5b7376f8$export$f81cef4bc2c186c5);
$parcel$export(module.exports, "showToast", () => $e00bdd7f5b7376f8$export$f6cef6fcf9ca4e17);

var $ivaD7 = parcelRequire("ivaD7");
const $e00bdd7f5b7376f8$export$f81cef4bc2c186c5 = Object.freeze({
    success: "success",
    error: "error"
});
const $e00bdd7f5b7376f8$export$f6cef6fcf9ca4e17 = (type, message, setState)=>{
    let toastProps;
    switch(type){
        case $e00bdd7f5b7376f8$export$f81cef4bc2c186c5.success:
            toastProps = {
                id: Math.floor(Math.random() * 100 + 1),
                message: message || "Success",
                color: "success",
                icon: "check_icon",
                border: "left",
                className: "search-toast"
            };
            break;
        case $e00bdd7f5b7376f8$export$f81cef4bc2c186c5.error:
            toastProps = {
                id: Math.floor(Math.random() * 100 + 1),
                message: message || "Error",
                color: "danger",
                icon: "error_outline_icon",
                border: "left",
                className: "search-toast"
            };
            break;
    }
    (0, $ivaD7.setStateData)("toastProps", toastProps, setState);
};

});



parcelRegister("cwutX", function(module, exports) {

$parcel$export(module.exports, "renderComponentToHtml", () => $a4c8dc0c1a91ecd6$export$3e0bc741e1662505);
$parcel$export(module.exports, "getFieldValues", () => $a4c8dc0c1a91ecd6$export$54119e4fbb06537c);
$parcel$export(module.exports, "getSelectedAreaInfo", () => $a4c8dc0c1a91ecd6$export$38d9b8e132d5f3bb);
$parcel$export(module.exports, "truncateLine", () => $a4c8dc0c1a91ecd6$export$526fd53fd620dd4e);
$parcel$export(module.exports, "downloadPDF", () => $a4c8dc0c1a91ecd6$export$3c4ee5ffa62bdd4b);
$parcel$export(module.exports, "getTimeFrame", () => $a4c8dc0c1a91ecd6$export$915d3d25106a35a3);
$parcel$export(module.exports, "getPdfClassname", () => $a4c8dc0c1a91ecd6$export$e20c3bc24a39a1b1);
$parcel$export(module.exports, "agentDetailReportConfig", () => $a4c8dc0c1a91ecd6$export$46e635f728411a9b);
$parcel$export(module.exports, "reportConfig", () => $a4c8dc0c1a91ecd6$export$5ad1d52cc7c327cb);
$parcel$export(module.exports, "flattenTable", () => $a4c8dc0c1a91ecd6$export$25ea53db08a5b00);
$parcel$export(module.exports, "transformTableView", () => $a4c8dc0c1a91ecd6$export$31cb707dbbd45143);
$parcel$export(module.exports, "normalizePhoneNumber", () => $a4c8dc0c1a91ecd6$export$eeb94ade8d38f116);
$parcel$export(module.exports, "agentDetailFullAddress", () => $a4c8dc0c1a91ecd6$export$ece5098578757a4a);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $cstaF = parcelRequire("cstaF");

var $htzEo = parcelRequire("htzEo");

var $bLQRh = parcelRequire("bLQRh");

var $3etjB = parcelRequire("3etjB");

var $iCDWi = parcelRequire("iCDWi");

var $bmWW5 = parcelRequire("bmWW5");

var $jD9CM = parcelRequire("jD9CM");
const $a4c8dc0c1a91ecd6$export$3e0bc741e1662505 = (Component, props = {})=>{
    const tempContainer = document.createElement("div");
    (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).render(/*#__PURE__*/ (0, $ayMG0.jsx)(Component, {
        ...props
    }), tempContainer);
    const html = tempContainer.innerHTML;
    (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).unmountComponentAtNode(tempContainer);
    return html;
};
const $a4c8dc0c1a91ecd6$export$54119e4fbb06537c = (loadedSearchCriteria, fieldName)=>{
    const field = loadedSearchCriteria?.realEstateDatasourceIdsWithFilters[0].searchFields.find((f)=>f.fieldName === fieldName);
    if (!field) return (0, $cstaF.searchTerms).all;
    if (fieldName === (0, $cstaF.searchTerms).newConstruction) return (0, $iCDWi.reverseMap)((0, $cstaF.constructionTypeMap))[field.fieldValues[0]];
    if (field.fieldValueDescriptions) return field.fieldValueDescriptions.join(", ");
    if (field.fieldMinValue !== undefined && field.fieldMaxValue !== undefined) return `${field.fieldMinValue}-${field.fieldMaxValue}`;
    if (field.fieldMinValue !== undefined) return `${field.fieldMinValue}+`;
    if (field.fieldMaxValue !== undefined) return `0-${field.fieldMaxValue}`;
    return (0, $cstaF.searchTerms).all;
};
const $a4c8dc0c1a91ecd6$export$38d9b8e132d5f3bb = (loadedSearchCriteria, module, areaTypeTitle)=>{
    if (module === (0, $cstaF.modules).agentProduction.agentProduction) return {
        selectedAreaType: (0, $cstaF.searchTerms).lowerAllMls,
        selectedArea: ""
    };
    if (module === (0, $cstaF.modules).marketShare.coverage) return {
        selectedAreaType: areaTypeTitle + ":",
        selectedArea: (0, $cstaF.searchTerms).all
    };
    if (loadedSearchCriteria?.realEstateDatasourceIdsWithFilters[0].searchAllMLS) return {
        selectedAreaType: (0, $cstaF.searchTerms).lowerAllMls,
        selectedArea: ""
    };
    const areaField = loadedSearchCriteria?.realEstateDatasourceIdsWithFilters[0].searchFields.find((f)=>f.fieldTypeName);
    if (areaField) return {
        selectedAreaType: areaField.fieldTypeName + ":",
        selectedArea: areaField.fieldValues.join(", ")
    };
    return {
        selectedAreaType: "",
        selectedArea: ""
    };
};
const $a4c8dc0c1a91ecd6$export$526fd53fd620dd4e = (text, maxLength)=>{
    const ellipsis = "...";
    if (text.length <= maxLength) return text;
    let truncated = text.substr(0, maxLength);
    let lastSpaceIndex = truncated.lastIndexOf(" ");
    if (lastSpaceIndex === -1) return truncated.replace(/,$/, "") + ellipsis;
    let cleanedText = truncated.substr(0, lastSpaceIndex).replace(/,$/, "");
    return cleanedText + ellipsis;
};
const $a4c8dc0c1a91ecd6$export$3c4ee5ffa62bdd4b = async (streamResponse, module, listingViewId, exportDetails, config)=>{
    const pdfBlob = await streamResponse.blob().then((blob)=>new Blob([
            blob
        ], {
            type: (0, $cstaF.mimeTypes).pdf
        }));
    const pdfUrl = URL.createObjectURL(pdfBlob);
    const downloadLink = document.createElement("a");
    downloadLink.href = pdfUrl;
    downloadLink.download = config.getPdfFileName(listingViewId, exportDetails);
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
    URL.revokeObjectURL(pdfUrl);
};
const $a4c8dc0c1a91ecd6$export$8eb8ad35c47be0db = (searchResults)=>{
    const lastTimePeriod = searchResults[searchResults.length - 1].timePeriodStart;
    const firstTimePeriod = searchResults[0].timePeriodEnd;
    return `${(0, $htzEo.shortDateFormatWithSlashes)(lastTimePeriod)}-${(0, $htzEo.shortDateFormatWithSlashes)(firstTimePeriod)}`;
};
const $a4c8dc0c1a91ecd6$export$915d3d25106a35a3 = (searchResults, timeFrameTitle, selectedBeginValue, selectedEndValue)=>{
    const is6MonthsWeekly = timeFrameTitle?.mainTitle === (0, $cstaF.marketDynamicsTerms).months6Weekly;
    const timeFrame = is6MonthsWeekly ? $a4c8dc0c1a91ecd6$export$8eb8ad35c47be0db(searchResults) : `${(0, $htzEo.shortDateFormatWithSlashes)(selectedBeginValue)}-${(0, $htzEo.shortDateFormatWithSlashes)(selectedEndValue)}`;
    return timeFrame;
};
const $a4c8dc0c1a91ecd6$export$e20c3bc24a39a1b1 = (isOverview, index, isSelector = false)=>{
    if (isSelector) return isOverview ? `.chart-capture-area-${index}` : ".chart-capture-area";
    return isOverview ? `chart-capture-area-${index}` : "chart-capture-area";
};
const $a4c8dc0c1a91ecd6$export$a68f81111632e1d = (listingViewId, module)=>{
    return `${(0, $cstaF.normalizedModuleNames)[(0, $cstaF.moduleNames).marketShare]}'s 
            ${(0, $cstaF.normalizedModuleNames)[module]} ${listingViewId} 
            ${(0, $bLQRh.terms).report} - ${(0, $htzEo.csvExportDateFormat)(new Date())}.pdf`.replace(/\s+/g, " ");
};
const $a4c8dc0c1a91ecd6$var$getAgentMovementFileName = ()=>{
    return `${(0, $cstaF.normalizedModuleNames)[(0, $cstaF.modules).proficiencyMetrics.agentMovement]} 
    ${(0, $bLQRh.terms).report} - ${(0, $bLQRh.terms).pdf} - 
    ${(0, $htzEo.csvExportDateFormat)()}.pdf`.replace(/\s+/g, " ");
};
const $a4c8dc0c1a91ecd6$var$getDefaultDetailFields = ({ selectedMls: selectedMls, timeFrame: timeFrame, loadedSearchCriteria: loadedSearchCriteria, listingTypeId: listingTypeId, isComparisonSetView: isComparisonSetView, listingStatus: listingStatus })=>{
    return [
        {
            label: (0, $cstaF.searchTerms).mls,
            value: selectedMls.shortDescription
        },
        {
            label: (0, $cstaF.searchTerms).timeFrame,
            value: timeFrame
        },
        ...listingTypeId ? [
            {
                label: (0, $3etjB.marketShareTerms).type,
                value: isComparisonSetView ? (0, $3etjB.marketShareTerms).byComparisonSet : (0, $3etjB.marketShareTerms)[listingTypeId]
            }
        ] : [],
        ...listingStatus ? [
            {
                label: (0, $3etjB.marketShareTerms).status,
                value: listingStatus
            }
        ] : [],
        {
            label: (0, $bLQRh.terms).price,
            value: $a4c8dc0c1a91ecd6$export$54119e4fbb06537c(loadedSearchCriteria, "lastPrice")
        },
        {
            label: (0, $cstaF.searchTerms).constructionType,
            value: $a4c8dc0c1a91ecd6$export$54119e4fbb06537c(loadedSearchCriteria, "newConstruction")
        },
        {
            label: (0, $cstaF.agentProductionTerms).bedrooms,
            value: $a4c8dc0c1a91ecd6$export$54119e4fbb06537c(loadedSearchCriteria, "bedrooms")
        },
        {
            label: (0, $bLQRh.terms).bathrooms,
            value: $a4c8dc0c1a91ecd6$export$54119e4fbb06537c(loadedSearchCriteria, "fullBathrooms")
        },
        {
            label: (0, $cstaF.searchTerms).lotSize,
            value: $a4c8dc0c1a91ecd6$export$54119e4fbb06537c(loadedSearchCriteria, "lotSizeAcres")
        },
        {
            label: (0, $bLQRh.terms).sqFt,
            value: $a4c8dc0c1a91ecd6$export$54119e4fbb06537c(loadedSearchCriteria, "squareFeet")
        }
    ];
};
const $a4c8dc0c1a91ecd6$var$getAMDetailFields = ({ selectedMls: selectedMls, timeFrame: timeFrame })=>{
    return [
        {
            label: (0, $cstaF.searchTerms).mls,
            value: selectedMls.shortDescription
        },
        {
            label: (0, $cstaF.searchTerms).timeFrame,
            value: timeFrame
        }
    ];
};
const $a4c8dc0c1a91ecd6$var$getADDetailFields = ({ selectedMls: selectedMls, timeFrame: timeFrame, loadedSearchCriteria: loadedSearchCriteria })=>{
    return [
        {
            label: (0, $cstaF.searchTerms).mls,
            value: selectedMls.shortDescription
        },
        {
            label: (0, $cstaF.searchTerms).timeFrame,
            value: timeFrame
        },
        {
            label: (0, $cstaF.agentProductionTerms).bedrooms,
            value: $a4c8dc0c1a91ecd6$export$54119e4fbb06537c(loadedSearchCriteria, "bedrooms")
        },
        {
            label: (0, $bLQRh.terms).bathrooms,
            value: $a4c8dc0c1a91ecd6$export$54119e4fbb06537c(loadedSearchCriteria, "fullBathrooms")
        },
        {
            label: (0, $cstaF.searchTerms).constructionType,
            value: $a4c8dc0c1a91ecd6$export$54119e4fbb06537c(loadedSearchCriteria, "newConstruction")
        }
    ];
};
const $a4c8dc0c1a91ecd6$var$baseAgentDetailsConfig = {
    getBrandName: (isAgentMetrics)=>isAgentMetrics ? (0, $bLQRh.terms).loneWolfAgentProduction : (0, $bLQRh.terms).loneWolfProficiencyMetrics,
    getHeaderTitle: (_, { isAgentMetrics: isAgentMetrics })=>isAgentMetrics ? (0, $cstaF.agentProductionTerms).agentProduction : (0, $cstaF.agentProductionTerms).agentDetails,
    hasTempBody: true,
    hasTable: false,
    getPdfFileName: (_, exportDetails)=>(0, $bmWW5.getAgentDetailsFileName)(exportDetails),
    moduleTitle: (selectedTabName)=>selectedTabName,
    shouldShowOfficeListFooter: true,
    shouldShowPropertyTypes: true,
    getDetailFields: $a4c8dc0c1a91ecd6$var$getADDetailFields,
    hasAgentDetailHeader: true
};
const $a4c8dc0c1a91ecd6$var$renderChartDefault = ({ chartImage: chartImage })=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "chart-container",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
            src: chartImage,
            alt: (0, $cstaF.agentProductionTerms).chart
        })
    });
const $a4c8dc0c1a91ecd6$export$46e635f728411a9b = {
    production: {
        ...$a4c8dc0c1a91ecd6$var$baseAgentDetailsConfig,
        renderChart: ({ chartImage: chartImage, productionSummary: productionSummary })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "agent-profile-chart-container",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $jD9CM.default), {
                        ...productionSummary
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: chartImage,
                        alt: (0, $cstaF.agentProductionTerms).chart
                    })
                ]
            }),
        hasTable: true,
        hasSummaryTable: true,
        hasTempBody: false,
        rowsPerTable: 20,
        hasTotalsRow: true,
        hasBoldTotalsLabel: true
    },
    transactionCoverage: {
        ...$a4c8dc0c1a91ecd6$var$baseAgentDetailsConfig,
        renderChart: ({ chartImage: chartImage, selectedAgentProfileArea: selectedAgentProfileArea })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "chart-wrapper",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "area-header",
                        children: [
                            (0, $cstaF.agentProductionTerms).areaType,
                            ": ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                children: selectedAgentProfileArea
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "chart-container",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                            src: chartImage,
                            alt: (0, $cstaF.agentProductionTerms).chart
                        })
                    })
                ]
            }),
        hasTable: true,
        rowsPerTable: 23,
        hasTempBody: false,
        hasTotalsRow: true,
        hasBoldTotalsLabel: true
    },
    inventory: {
        ...$a4c8dc0c1a91ecd6$var$baseAgentDetailsConfig,
        renderChart: ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {}),
        hasTable: true,
        hasTempBody: false,
        rowsPerTable: 23
    }
};
const $a4c8dc0c1a91ecd6$export$5ad1d52cc7c327cb = {
    [(0, $cstaF.modules).marketDynamics.marketDynamics]: {
        getBrandName: ()=>(0, $bLQRh.terms).loneWolfMarketDynamics,
        getHeaderTitle: (timeFrameTitle, { headerOverviewTabName: headerOverviewTabName })=>`${headerOverviewTabName}- ${timeFrameTitle.mainTitle}`,
        shouldShowOfficeListHeader: false,
        hasTempBody: false,
        hasTable: true,
        getPdfFileName: (listingViewId)=>`${(0, $cstaF.normalizedModuleNames)[(0, $cstaF.modules).marketDynamics.marketDynamics]}' ${(0, $bLQRh.terms)[listingViewId]} ${(0, $bLQRh.terms).report} - ${(0, $htzEo.csvExportDateFormat)(new Date())}.pdf`,
        hasTotalsRow: false,
        moduleTitle: ()=>(0, $cstaF.normalizedModuleNames)[(0, $cstaF.moduleNames).marketDynamics],
        shouldShowPropertyTypes: true,
        getDetailFields: $a4c8dc0c1a91ecd6$var$getDefaultDetailFields,
        shouldShowOfficeListFooter: false,
        rowsPerTable: 25,
        hasTruncation: false,
        renderChart: ({ chartImage: chartImage, isOverview: isOverview })=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: `chart-container ${isOverview ? "overview-report" : ""}`,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: chartImage,
                    alt: (0, $cstaF.agentProductionTerms).chart
                })
            })
    },
    [(0, $cstaF.modules).marketShare.coverage]: {
        getBrandName: ()=>(0, $bLQRh.terms).loneWolfMarketShare,
        getHeaderTitle: (_, { areaTypeTitle: areaTypeTitle })=>`(${(0, $bLQRh.terms).getBySearchTypeTitle(areaTypeTitle)})`,
        shouldShowOfficeListHeader: true,
        hasTempBody: false,
        hasTable: true,
        getPdfFileName: (listingViewId)=>$a4c8dc0c1a91ecd6$export$a68f81111632e1d(listingViewId, (0, $cstaF.modules).marketShare.coverage),
        hasTotalsRow: true,
        moduleTitle: ()=>(0, $cstaF.normalizedModuleNames)[(0, $cstaF.modules).marketShare.coverage],
        shouldShowPropertyTypes: true,
        getDetailFields: $a4c8dc0c1a91ecd6$var$getDefaultDetailFields,
        shouldShowOfficeListFooter: false,
        rowsPerTable: 25,
        renderChart: $a4c8dc0c1a91ecd6$var$renderChartDefault,
        hasTruncation: false
    },
    [(0, $cstaF.modules).marketShare.totals]: {
        getBrandName: ()=>(0, $bLQRh.terms).loneWolfMarketShare,
        getHeaderTitle: (_, { isComparisonSetView: isComparisonSetView, selectedComparisonSet: selectedComparisonSet, listingTypeId: listingTypeId })=>`(${isComparisonSetView ? (0, $bLQRh.terms).getBySearchTypeTitle(selectedComparisonSet?.name) : (0, $3etjB.marketShareTerms)[listingTypeId]})`,
        shouldShowOfficeListHeader: false,
        hasTempBody: false,
        hasTable: true,
        getPdfFileName: (listingViewId)=>$a4c8dc0c1a91ecd6$export$a68f81111632e1d(listingViewId, (0, $cstaF.modules).marketShare.totals),
        hasTotalsRow: true,
        moduleTitle: ()=>(0, $cstaF.normalizedModuleNames)[(0, $cstaF.modules).marketShare.totals],
        shouldShowPropertyTypes: true,
        getDetailFields: $a4c8dc0c1a91ecd6$var$getDefaultDetailFields,
        shouldShowOfficeListFooter: false,
        rowsPerTable: 25,
        renderChart: $a4c8dc0c1a91ecd6$var$renderChartDefault,
        hasTruncation: false
    },
    [(0, $cstaF.modules).proficiencyMetrics.agentMovement]: {
        getBrandName: ()=>(0, $bLQRh.terms).loneWolfProficiencyMetrics,
        getHeaderTitle: ()=>(0, $cstaF.normalizedModuleNames)[(0, $cstaF.modules).proficiencyMetrics.agentMovement],
        hasTempBody: false,
        hasTable: true,
        getPdfFileName: ()=>$a4c8dc0c1a91ecd6$var$getAgentMovementFileName(),
        hasTotalsRow: true,
        moduleTitle: ()=>(0, $cstaF.normalizedModuleNames)[(0, $cstaF.moduleNames).proficiencyMetrics],
        shouldShowOfficeListFooter: true,
        shouldShowOfficeListHeader: false,
        shouldShowPropertyTypes: false,
        getDetailFields: $a4c8dc0c1a91ecd6$var$getAMDetailFields,
        rowsPerTable: 26,
        renderChart: $a4c8dc0c1a91ecd6$var$renderChartDefault,
        hasTruncation: true
    },
    [(0, $cstaF.modules).proficiencyMetrics.transactions]: $a4c8dc0c1a91ecd6$export$46e635f728411a9b,
    [(0, $cstaF.modules).proficiencyMetrics.savedAgents]: $a4c8dc0c1a91ecd6$export$46e635f728411a9b,
    [(0, $cstaF.modules).proficiencyMetrics.agents]: $a4c8dc0c1a91ecd6$export$46e635f728411a9b,
    [(0, $cstaF.modules).proficiencyMetrics.suggestedAgents]: $a4c8dc0c1a91ecd6$export$46e635f728411a9b,
    [(0, $cstaF.modules).proficiencyMetrics.offices]: $a4c8dc0c1a91ecd6$export$46e635f728411a9b,
    [(0, $cstaF.modules).agentProduction.agentProduction]: $a4c8dc0c1a91ecd6$export$46e635f728411a9b
};
const $a4c8dc0c1a91ecd6$export$25ea53db08a5b00 = (tableView)=>{
    if (!Array.isArray(tableView) || !tableView[0]?.children) return;
    const flatTables = [];
    tableView.forEach((table)=>{
        table.children.forEach((child)=>{
            flatTables.push({
                col: {
                    id: child.col.id,
                    label: child.col.label,
                    keyField: child.col.id
                },
                colDef: {
                    label: child.col.label,
                    cellClass: child.colDef.cellClass || "",
                    headerClass: child.colDef.headerClass || "",
                    valueFormatter: child.colDef.valueFormatter || (({ value: value })=>value)
                }
            });
        });
    });
    return {
        tables: flatTables
    };
};
const $a4c8dc0c1a91ecd6$export$31cb707dbbd45143 = (tableView)=>{
    if (!tableView) return {
        tables: []
    };
    if (Array.isArray(tableView?.tables)) return tableView;
    const filteredTableView = tableView.filter((colDef)=>!(0, $bmWW5.fieldsToExclude).includes(colDef.field) && !colDef.hide);
    return {
        tables: filteredTableView.map((colDef)=>({
                col: {
                    id: colDef.field || colDef.id,
                    label: colDef.headerName || colDef.label,
                    keyField: colDef.field || colDef.id
                },
                colDef: {
                    label: colDef.headerName || colDef.label,
                    cellClass: colDef.cellClass || "",
                    headerClass: colDef.headerClass || "",
                    valueFormatter: colDef.valueFormatter || (({ value: value })=>value)
                }
            }))
    };
};
const $a4c8dc0c1a91ecd6$export$eeb94ade8d38f116 = (phoneNumber)=>{
    const nums = [];
    if (!phoneNumber?.length) return (0, $cstaF.agentProductionTerms).notApplicableAbbrv;
    for (const char of phoneNumber)if (!isNaN(parseInt(char))) nums.push(char);
    return `(${nums[0]}${nums[1]}${nums[2]})-${nums[3]}${nums[4]}${nums[5]}-${nums[6]}${nums[7]}${nums[8]}${nums[9]}`;
};
const $a4c8dc0c1a91ecd6$export$ece5098578757a4a = ({ officeAddress: officeAddress, officeCity: officeCity, officeState: officeState, officeZipCode: officeZipCode })=>[
        (officeAddress || "").trim(),
        (officeCity || "").trim(),
        (officeState || "").trim(),
        (officeZipCode || "").trim()
    ].filter((ad)=>!!ad).join(", ");

});
parcelRegister("bmWW5", function(module, exports) {

$parcel$export(module.exports, "MAX_LINE_LENGTH", () => $846f773c1e5b28d4$export$c72b616c931953da);
$parcel$export(module.exports, "paginationConfig", () => $846f773c1e5b28d4$export$fd6fe683958acfde);
$parcel$export(module.exports, "styles", () => $846f773c1e5b28d4$export$9dd6ff9ea0189349);
$parcel$export(module.exports, "fieldsToExclude", () => $846f773c1e5b28d4$export$35eb1b21d92fd4f1);
$parcel$export(module.exports, "pdfChartLabelStyles", () => $846f773c1e5b28d4$export$9ab35794f3d5468d);
$parcel$export(module.exports, "pdfChartTitleStyles", () => $846f773c1e5b28d4$export$63c547d044f7c5e0);
$parcel$export(module.exports, "getAgentDetailsFileName", () => $846f773c1e5b28d4$export$ca6935f3dd0ca660);

var $c3iqc = parcelRequire("c3iqc");

var $bLQRh = parcelRequire("bLQRh");
const $846f773c1e5b28d4$export$c72b616c931953da = 220;
const $846f773c1e5b28d4$export$1a55c053cba14458 = 16;
const $846f773c1e5b28d4$export$58f5d5ee0e8dda80 = "3in";
const $846f773c1e5b28d4$export$fd6fe683958acfde = {
    "useDividerLine": false,
    "height": 10,
    "pagination": {
        "template": "Page {0} of {1}",
        "enabled": true,
        "font": {
            "size": 7,
            "family": "Helvetica",
            "style": "Regular",
            "hexColor": "#6B7280"
        },
        "coordinates": {
            "xPosition": 780,
            "yPosition": -20
        }
    }
};
const $846f773c1e5b28d4$export$9dd6ff9ea0189349 = `body {
    font-family: 'SF Pro Text', 'Helvetica Neue', Arial, sans-serif;
    line-height: 1.4;
}

.market-indicator-text {
    font-size: 50px;
    font-weight: bold;
    text-align: center;
}

.column-container-centered {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.agent-detail-page-section {
    padding-top: 375px;
}

.page-section {
    margin-top: 245px;
}

.table {
    page-break-before: always;
    page-break-inside: avoid;
    font-size: 28px;
    border-collapse: collapse;
    width: calc(100% - 56px);  
    margin-left: 25px;
    margin-right: 30px; 
}

.totals-row {
    border-top: 1px solid #D1D5DB;
}

.table tr {
    text-wrap: nowrap;
}

.table th {
    text-transform: uppercase;
    padding: 4px 4px;  
    border-bottom: 1px solid #D1D5DB;
    border-right: 1px solid #D1D5DB;
    border-left: 1px solid #D1D5DB;
    text-align: left;
    color: #6B7280;
    font-size: 24px;
    font-weight: 600;
    letter-spacing: 0.04em;
    text-wrap: wrap;
}

.table td {
    padding: 10px 4px;
    border-right: 1px solid #D1D5DB;
    border-left: 1px solid #D1D5DB;
    text-align: left;
}
.table tr:nth-child(even) {
    background-color: #F9FAFB;
}
.table th.right,
.table td.right {
    text-align: right;
}
.table td.totals-row-title {
    font-weight: bold;
}
.table.agent-detail-table {
    border-top: 1px solid #D1D5DB;
}

.table.agent-detail-table th {
    padding-top: 20px;
    padding-bottom: 20px;
    border-left: none;
    border-right: none;
}
.table.agent-detail-table td {
    border-left: none;
    border-right: none;
}
.header {
    position: fixed;
    top: 20px;
    left: 30px;
    right: 30px;
}
.contact-info {
   font-size: 25px;
}
.contact-item {
    display: inline-block;
    margin-right: 15px;
}
.office-name, .agent-name, .summary-table-title,
.summary-table-cards-container div>p {
    font-size: 30px;
}
.address, .agent-id {
    font-size: 25px;
}
.header-divider {
    border-top: 1px solid #D1D5DB;
    margin-bottom: 5px;
    margin-top: 0;
    margin-left: -30px;
    margin-right: -30px;
}
.footer-divider {
    border-top: 1px solid #D1D5DB;
    margin-bottom: 5px;
    margin-left: -30px;
    margin-right: -30px;
}
.header-title-separator {
    display: inline-block;
    width: 1px;
    height: 50px;
    background-color: #D1D5DB;
    margin: 0 10px;
    vertical-align: middle;
}
.header-title-container {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    margin-top: 10px;
    width: 100%;
}
.header-title {
    font-size: 40px;
    font-weight: bold;
    text-transform: capitalize;
}
.header-subtitle {
    font-size: 30px;
    color: #4B5563;
    margin-right: 10px;
}
.footer {
    position: fixed;
    bottom: 30px;
    left: 30px;
    right: 30px;
    font-size: 20px;
    color: #6B7280;
}
.footer-content {
    display: flex;
    flex-direction: column;
}
.agent-profile-chart-container {
    margin-left: 30px;
    margin-right: 30px;
    margin-top: 4in;
}
.agent-profile-chart-container img {
    max-width: 100%;
    height: auto;
    margin-top: 40px;
}
.market-dynamics-chart-container img {
    max-width: 100%;
    height: auto;
    margin-top: 4in;
}
.chart-container,
.market-dynamics-chart-container {
    margin-left: 30px;
    margin-right: 30px;
}
.chart-container img {
    max-width: 100%;
    height: auto;
    margin-top: 4in;
}
.overview-report img {
    margin-top: 3in;
}

.chart-wrapper {
    margin-top: 4in;
}

.chart-wrapper .area-header,
.chart-wrapper .chart-container {
    margin-left: 30px;
    margin-right: 30px;
    margin-bottom: 10px; 
    font-size: 30px;
    text-align: center;
}

.chart-wrapper .area-header {
    margin-bottom: 10px; 
    font-size: 30px;
    text-align: center;
}

.chart-wrapper .chart-container img {
    max-width: 100%;
    height: auto;
    margin-top: 0;
}

.dashboard-container {
    margin: auto;
    height: 700px;
    width: 100%;
    justify-content: center;
}    
.dashboard-container img {
    max-width: 100%;
    max-height: 100%;
}
.summary-table-container {
    border: solid 1px #D1D5DB;
    width: 100%;
    font-size: 25px;
}
.summary-table-title {
    font-weight: bold;
    text-align: center;
    text-transform: capitalize;
    border: solid 1px #D1D5DB;
    border-top: none;
}
.summary-table-cards-container {
    display: flex;
}
.summary-table-card {
    width: 20%;
    text-align: center;
    border: solid 1px #D1D5DB;
    border-top: none;
    border-right: none;
    padding: 10px;
}
.summary-table-card > p {
    font-weight: bold;
    margin: 0 0 10px 0;
}
.page-content {
    page-break-after: always;
}
.page-content:last-child {
    page-break-after: avoid;
}
.disclaimer {
    padding-top: 17px;
    font-size: 20px;
    color: #6B7280;
    max-width: 80%;
}
.contact-icon {
  width: 25px;
  height: 25px;
  vertical-align: middle;
  margin-right: 4px;
}
.contact-item {
   font-size: 25px;
}
.contact-icon path {
  fill: currentColor;
}
.blank-row {
    page-break-before: always;
}
.report-details {
    display: flex;
    flex-wrap: wrap;
    gap: 10px 0;
}
.detail-line {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 0 15px;
}
.detail-item {
    display: inline-block;
    white-space: nowrap;
}
.office-list-footer {
    text-transform: capitalize;
}    
.full-width {
    width: 100%;
}
.date {
   position: fixed;
   bottom: 66px;
   right: 215px;
   font-size: 22px;
}
.description-text {
   font-size: 25px;
}
.agent-info-container {
    display: flex;
    justify-content: space-between;
    margin-top: 50px;
}
.additional-agent-info {
    display: flex;
    justify-content: space-between;
    font-size: 25px;
}
.additional-agent-info > * {
    text-align: right;
    margin-left: 30px;
}
.logo-pdf {
    position: fixed;
    top: 45px;
    right: 40px;
    height: auto;
    width: auto;
}
.office-name-padded {
    display: block;
    padding-bottom: 48px;
}`;
const $846f773c1e5b28d4$export$35eb1b21d92fd4f1 = [
    (0, $c3iqc.marketShareColumns).isSelected.id,
    (0, $c3iqc.marketShareColumns).rank.id,
    (0, $c3iqc.marketShareColumns).streetName1.id,
    (0, $c3iqc.marketShareColumns).city.id,
    (0, $c3iqc.marketShareColumns).stateCode.id,
    (0, $c3iqc.marketShareColumns).zipCode.id,
    (0, $c3iqc.marketShareColumns).county.id,
    (0, $c3iqc.marketShareColumns).phoneNumber.id
];
const $846f773c1e5b28d4$export$9ab35794f3d5468d = {
    colors: [
        "#000000"
    ],
    fontFamily: (0, $bLQRh.chartFontFamily),
    fontSize: "20px",
    fontWeight: 500,
    lineHeight: "16px"
};
const $846f773c1e5b28d4$export$63c547d044f7c5e0 = {
    color: "#000000",
    fontFamily: (0, $bLQRh.chartFontFamily),
    fontSize: "20px",
    fontWeight: 500,
    lineHeight: "16px"
};
const $846f773c1e5b28d4$export$ca6935f3dd0ca660 = ({ agentName: agentName, mlsName: mlsName, periods: periods, selectedTabLabel: selectedTabLabel })=>{
    return `${agentName}\u{2019}s ${selectedTabLabel} in ${mlsName}${periods ? ` for ${periods}` : ""}.pdf`.replace(/\s+/g, " ");
};

});

parcelRegister("jD9CM", function(module, exports) {

$parcel$export(module.exports, "default", () => $e599302ed679dabd$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $eHBjM = parcelRequire("eHBjM");

var $c9Z8w = parcelRequire("c9Z8w");
const $e599302ed679dabd$var$SummaryTable = ({ title: title, cardData: cardData })=>{
    const cards = cardData?.map((card, key)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "summary-table-card",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    children: cardData.find((cardData)=>cardData.id === card.id)?.value
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    children: (0, $eHBjM.productionChartTabToolTips)[card.id]?.label
                })
            ]
        }, `card-${key}-${card.id}`);
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "summary-table-container",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "summary-table-title",
                children: title
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "summary-table-cards-container",
                children: cards
            })
        ]
    });
};
$e599302ed679dabd$var$SummaryTable.propTypes = {
    cardData: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};
var $e599302ed679dabd$export$2e2bcd8739ae039 = $e599302ed679dabd$var$SummaryTable;

});


parcelRegister("70q5f", function(module, exports) {

$parcel$export(module.exports, "useMarketDynamicsStore", () => $519cc42cd88f8a4f$export$ee80a57a0fcd8649);

var $88tPr = parcelRequire("88tPr");

var $9phu9 = parcelRequire("9phu9");

var $iQCDZ = parcelRequire("iQCDZ");
const $519cc42cd88f8a4f$export$aecf8c9ef8bae7a6 = {
    tableView: {},
    selectedBreakdownPeriod: undefined,
    checkedStatusOptions: [],
    selectedListingView: "",
    selectedBreakdownTab: 0,
    shouldShowChart: true,
    listingViewId: undefined,
    overviewStatus: {
        currentTab: 0,
        chartSettings: {
            default: {},
            inventory: {},
            prices: {},
            activity: {}
        }
    },
    marketIndicatorContent: {
        title: "",
        description: ""
    }
};
/**
 * @deprecated This store needs to be moved to search store.
 */ const $519cc42cd88f8a4f$var$marketDynamicsStoreDeprecated = (set, get)=>({
        ...$519cc42cd88f8a4f$export$aecf8c9ef8bae7a6,
        ...(0, $iQCDZ.actionsDeprecated)(set, get)
    });
const $519cc42cd88f8a4f$export$ee80a57a0fcd8649 = (0, $9phu9.createWithEqualityFn)((0, $88tPr.devtools)((0, $88tPr.persist)($519cc42cd88f8a4f$var$marketDynamicsStoreDeprecated, {
    name: "market_dynamics_state_deprecated",
    storage: (0, $88tPr.createJSONStorage)(()=>localStorage)
})));

});
parcelRegister("iQCDZ", function(module, exports) {

$parcel$export(module.exports, "actionsDeprecated", () => $db8b0f39aea7d382$export$82b4049b7fd8fab8);

var $bLQRh = parcelRequire("bLQRh");

var $kTDHQ = parcelRequire("kTDHQ");
const $db8b0f39aea7d382$export$82b4049b7fd8fab8 = (set, get)=>({
        setTableView: ({ tableView: tableView })=>{
            set({
                tableView: tableView
            });
        },
        setSelectedBreakdownPeriod: (selectedBreakdownPeriod)=>{
            set({
                selectedBreakdownPeriod: selectedBreakdownPeriod
            });
        },
        getOfficesBreakdown: async (searchCriteria)=>{
            try {
                const offices = await (0, $kTDHQ.getMarketDynamicsOfficeBreakdown)(searchCriteria);
                if (offices.error) throw new Error((0, $bLQRh.errorMessaging).getFetchErrorMsg("offices"));
                return offices;
            } catch (e) {
                console.error(e);
            }
        },
        getListingsBreakdown: async (searchCriteria, status, isOfficeListing, officeId)=>{
            try {
                const getListings = async ()=>{
                    if (isOfficeListing && officeId) return await (0, $kTDHQ.getListingsBreakdownByOffice)(searchCriteria, status, officeId);
                    return await (0, $kTDHQ.getOfficeListingsBreakdown)(searchCriteria, status);
                };
                const listings = await getListings();
                if (listings?.error) {
                    console.error(`${(0, $bLQRh.errorMessaging).getFetchErrorMsg("listings")}`);
                    return [];
                }
                return listings;
            } catch (e) {
                console.error(e);
            }
        },
        setCheckedStatusOptions: (options)=>set({
                checkedStatusOptions: [
                    ...options
                ]
            }),
        runMarketDynamicsSearch: async (criteria)=>{
            try {
                const { results: results, totals: totals, error: error } = await (0, $kTDHQ.getMarketDynamicsSearch)(criteria);
                if (error) throw new Error(error);
                return {
                    results: results,
                    totals: totals
                };
            } catch (e) {
                throw new Error(e?.message ?? e);
            }
        },
        setListingViewId: (listingViewId)=>set({
                listingViewId: listingViewId
            }, false, "setListingViewId"),
        setOverviewStatusKey: (key, value)=>{
            const { overviewStatus: overviewStatus } = get();
            if (!(key in overviewStatus)) console.error(`Key "${key}" does not exist in overviewStatus.`);
            set((state)=>({
                    overviewStatus: {
                        ...state.overviewStatus,
                        [key]: value
                    }
                }), false, "setOverviewStatusKey");
        },
        setMarketIndicatorContent: (marketIndicatorContent)=>set({
                marketIndicatorContent: marketIndicatorContent
            }, false, "setMarketIndicatorContent")
    });

});
parcelRegister("kTDHQ", function(module, exports) {

$parcel$export(module.exports, "getMarketDynamicsSearch", () => $f367be804f279d1c$export$62f2c85cd75af7e6);
$parcel$export(module.exports, "getMarketDynamicsOfficeBreakdown", () => $f367be804f279d1c$export$26b7ee46c1bd4b1b);
$parcel$export(module.exports, "getOfficeListingsBreakdown", () => $f367be804f279d1c$export$a592423613b8f2f9);
$parcel$export(module.exports, "getListingsBreakdownByOffice", () => $f367be804f279d1c$export$b20b6433c0bb7972);

var $chB0Q = parcelRequire("chB0Q");

var $gDxKE = parcelRequire("gDxKE");

var $24YIE = parcelRequire("24YIE");
const $f367be804f279d1c$var$searchCriteriaData = (criteria, parameters = [])=>{
    const cleanCriteria = (0, $gDxKE.removeSearchAllMLSFlag)((0, $chB0Q.default)(criteria));
    return [
        {
            parameter: "aergo_search_criteria",
            value: JSON.stringify(cleanCriteria)
        },
        ...parameters
    ];
};
const $f367be804f279d1c$export$62f2c85cd75af7e6 = async (criteria)=>{
    return await (0, $24YIE.newSendApiRequest)("Market_dynamics", $f367be804f279d1c$var$searchCriteriaData(criteria), 90000);
};
const $f367be804f279d1c$export$26b7ee46c1bd4b1b = async (searchCriteria)=>{
    return await (0, $24YIE.newSendApiRequest)("Market_dynamics_office_breakdown", [
        {
            parameter: "aergo_search_criteria",
            value: `${JSON.stringify(searchCriteria)}`
        }
    ], 120000);
};
const $f367be804f279d1c$export$a592423613b8f2f9 = async (searchCriteria, status)=>{
    return await (0, $24YIE.newSendApiRequest)("Market_dynamics_listings", [
        {
            parameter: "aergo_search_criteria",
            value: `${JSON.stringify(searchCriteria)}`
        },
        {
            parameter: "transactionStatus",
            value: status
        },
        {
            parameter: "queryLimit",
            value: "10000"
        }
    ], 120000);
};
const $f367be804f279d1c$export$b20b6433c0bb7972 = async (searchCriteria, status, officeId)=>{
    return await (0, $24YIE.newSendApiRequest)("Market_dynamics_office_listings", [
        {
            parameter: "aergo_search_criteria",
            value: `${JSON.stringify(searchCriteria)}`
        },
        {
            parameter: "transactionStatus",
            value: status
        },
        {
            parameter: "queryLimit",
            value: "10000"
        },
        {
            parameter: "officeId",
            value: officeId
        }
    ], 120000);
};

});



parcelRegister("b6fBF", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6247346b6a60f54$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $efTZL = parcelRequire("efTZL");

var $f4YyF = parcelRequire("f4YyF");

var $ir77C = parcelRequire("ir77C");

var $c9Z8w = parcelRequire("c9Z8w");

var $bmWW5 = parcelRequire("bmWW5");

var $cstaF = parcelRequire("cstaF");

var $4fYAk = parcelRequire("4fYAk");
const $f6247346b6a60f54$var$Report = ({ chartImage: chartImage, selectedMls: selectedMls, listingViewId: listingViewId, timeFrameTitle: timeFrameTitle, loadedSearchCriteria: loadedSearchCriteria, selectedBeginValue: selectedBeginValue, selectedEndValue: selectedEndValue, module: module, searchResults: searchResults, tableView: tableView, marketIndicatorContent: marketIndicatorContent, dashboardImage: dashboardImage, listingViewTitle: listingViewTitle, listingTypeId: listingTypeId, isComparisonSetView: isComparisonSetView, selectedComparisonSet: selectedComparisonSet, areaTypeTitle: areaTypeTitle, listingStatus: listingStatus, officeListName: officeListName, selectedTabName: selectedTabName, exportDetails: exportDetails, config: config, selectedAgentProfileArea: selectedAgentProfileArea, productionSummary: productionSummary })=>{
    const isOverview = listingViewId === (0, $4fYAk.listingOptions).overview.value;
    const getTempBody = ()=>{
        const spacers = [];
        for(let i = 0; i < 10; i++)spacers.push(/*#__PURE__*/ (0, $ayMG0.jsx)("p", {
            style: {
                height: "200px",
                margin: "0",
                padding: "0"
            },
            children: "\xa0"
        }, `spacer-${i}`));
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "spacer-container",
            children: spacers
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("style", {
                children: (0, $bmWW5.styles)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $efTZL.default), {
                listingViewId: listingViewId,
                timeFrameTitle: timeFrameTitle,
                module: module,
                listingViewTitle: listingViewTitle,
                listingTypeId: listingTypeId,
                isComparisonSetView: isComparisonSetView,
                selectedComparisonSet: selectedComparisonSet,
                areaTypeTitle: areaTypeTitle,
                officeListName: officeListName,
                config: config,
                isOverview: isOverview,
                selectedTabName: selectedTabName,
                agentData: exportDetails?.agentData
            }),
            chartImage && config?.renderChart({
                chartImage: chartImage,
                isOverview: isOverview,
                selectedAgentProfileArea: selectedAgentProfileArea,
                productionSummary: productionSummary
            }),
            isOverview && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "column-container-centered",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "market-indicator-text",
                        children: marketIndicatorContent.title
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "description-text",
                        children: marketIndicatorContent.description
                    })
                ]
            }),
            config?.hasTempBody && getTempBody(),
            dashboardImage && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "dashboard-container",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    src: dashboardImage,
                    alt: (0, $cstaF.marketDynamicsTerms).marketDynamicsDashboard
                })
            }),
            !isOverview && config?.hasTable && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ir77C.default), {
                searchResults: searchResults,
                tableView: tableView,
                config: config
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f4YyF.default), {
                loadedSearchCriteria: loadedSearchCriteria,
                selectedBeginValue: selectedBeginValue,
                selectedEndValue: selectedEndValue,
                selectedMls: selectedMls,
                searchResults: searchResults,
                timeFrameTitle: timeFrameTitle,
                listingTypeId: listingTypeId,
                isComparisonSetView: isComparisonSetView,
                listingStatus: listingStatus,
                areaTypeTitle: areaTypeTitle,
                module: module,
                config: config,
                officeListName: officeListName
            })
        ]
    });
};
$f6247346b6a60f54$var$Report.propTypes = {
    chartImage: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    module: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    selectedMls: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    listingViewId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    timeFrameTitle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    loadedSearchCriteria: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    selectedBeginValue: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    selectedEndValue: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    searchResults: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    tableView: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    marketIndicatorContent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    dashboardImage: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    listingViewTitle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    listingTypeId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    isComparisonSetView: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    selectedComparisonSet: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    areaTypeTitle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    listingStatus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    officeListName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    config: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    selectedAgentProfileArea: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    selectedTabName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    exportDetails: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $f6247346b6a60f54$export$2e2bcd8739ae039 = $f6247346b6a60f54$var$Report;

});
parcelRegister("efTZL", function(module, exports) {

$parcel$export(module.exports, "default", () => $9268665603631aa2$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $bLQRh = parcelRequire("bLQRh");

var $eOjgM = parcelRequire("eOjgM");

var $cstaF = parcelRequire("cstaF");

var $90ISC = parcelRequire("90ISC");

var $dlZsJ = parcelRequire("dlZsJ");

var $70q5f = parcelRequire("70q5f");

var $bA5Mi = parcelRequire("bA5Mi");

var $fCBgX = parcelRequire("fCBgX");

var $cwutX = parcelRequire("cwutX");

var $dDBOF = parcelRequire("dDBOF");
const $9268665603631aa2$var$Header = ({ listingViewId: listingViewId, timeFrameTitle: timeFrameTitle, listingViewTitle: listingViewTitle, listingTypeId: listingTypeId, isComparisonSetView: isComparisonSetView, selectedComparisonSet: selectedComparisonSet, areaTypeTitle: areaTypeTitle, officeListName: officeListName, config: config, isOverview: isOverview, selectedTabName: selectedTabName, agentData: agentData })=>{
    const overviewStatus = (0, $70q5f.useMarketDynamicsStore)((state)=>state.overviewStatus);
    const logoSrc = (0, $bA5Mi.usePDFStore)((state)=>state.logoSrc);
    const viewTitle = (0, $bLQRh.terms)[listingViewId] ?? listingViewTitle;
    const headerOverviewTabName = isOverview ? `- ${Object.keys((0, $fCBgX.settingsByTab))[overviewStatus.currentTab]} ` : "";
    const headerTitle = config.getHeaderTitle(timeFrameTitle, {
        areaTypeTitle: areaTypeTitle,
        isComparisonSetView: isComparisonSetView,
        selectedComparisonSet: selectedComparisonSet,
        listingTypeId: listingTypeId,
        headerOverviewTabName: headerOverviewTabName,
        isAgentMetrics: $dDBOF.isAgentMetrics
    });
    const moduleTitle = config.moduleTitle(selectedTabName);
    const officeList = config.shouldShowOfficeListHeader ? `(${officeListName})` : "";
    const { getUserAndOfficeInfo: getUserAndOfficeInfo } = (0, $90ISC.useCommonStore)((state)=>({
            getUserAndOfficeInfo: state.getUserAndOfficeInfo
        }));
    const userAndOfficeInfo = getUserAndOfficeInfo();
    const { name: name, phoneNumber: phoneNumber, emailAddress: emailAddress, officeId: officeId } = userAndOfficeInfo;
    const addressHeaderText = (0, $dlZsJ.getCommaSeparatedTextByKeyFields)(userAndOfficeInfo, [
        "street1",
        "city",
        "stateCode",
        "zipCode"
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "header",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "flex justify-between",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                className: `office-name ${(0, $dDBOF.isAgentMetrics) && config.hasAgentDetailHeader ? "office-name-padded" : ""}`,
                                children: name
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            !((0, $dDBOF.isAgentMetrics) && config.hasAgentDetailHeader) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "address",
                                        children: addressHeaderText
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "contact-item",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "icon",
                                                children: (0, $eOjgM.phone)({
                                                    className: "contact-icon"
                                                })
                                            }),
                                            phoneNumber
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        className: "contact-item",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "icon",
                                                children: (0, $eOjgM.email)({
                                                    className: "contact-icon"
                                                })
                                            }),
                                            emailAddress
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    logoSrc && /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        src: logoSrc,
                        className: "logo-pdf"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "header-divider"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "header-title-container",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "header-title",
                        children: [
                            moduleTitle,
                            " ",
                            officeList,
                            " ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "header-title-separator"
                            }),
                            " ",
                            viewTitle,
                            " ",
                            headerTitle
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "header-subtitle",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("strong", {
                            children: [
                                config.getBrandName((0, $dDBOF.isAgentMetrics)),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("sup", {
                                    children: (0, $cstaF.trademark)
                                }),
                                " ",
                                (0, $bLQRh.terms).report
                            ]
                        })
                    })
                ]
            }),
            config?.hasAgentDetailHeader && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "agent-info-container",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("b", {
                                className: "agent-name",
                                children: agentData?.agentName
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                className: "agent-id",
                                children: [
                                    (0, $cstaF.agentProductionTerms).agentId,
                                    ": ",
                                    agentData.agentId
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "additional-agent-info",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        children: [
                                            agentData?.officeName,
                                            " (",
                                            agentData?.officeId || officeId,
                                            ")"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: (0, $cwutX.agentDetailFullAddress)(agentData)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        children: agentData?.agentEmail
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    !(0, $dDBOF.isAgentMetrics) && /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        children: [
                                            (0, $cstaF.agentProductionTerms).officeCounty,
                                            ": ",
                                            agentData?.officeCounty
                                        ]
                                    })
                                ]
                            }),
                            !(0, $dDBOF.isAgentMetrics) && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        children: [
                                            "Bus: ",
                                            (0, $cwutX.normalizePhoneNumber)(agentData?.agentPhone1)
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                        children: [
                                            "C: ",
                                            (0, $cwutX.normalizePhoneNumber)(agentData?.agentPhone2)
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
$9268665603631aa2$var$Header.propTypes = {
    module: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    listingViewId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    timeFrameTitle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    listingViewTitle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    isComparisonSetView: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    listingTypeId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    selectedComparisonSet: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    areaTypeTitle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    officeListName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    config: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    isOverview: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    selectedTabName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    agentData: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $9268665603631aa2$export$2e2bcd8739ae039 = $9268665603631aa2$var$Header;

});
parcelRegister("fCBgX", function(module, exports) {

$parcel$export(module.exports, "settingsByTab", () => $b5f7512a7f6df7c1$export$295067d1d3bf9763);
$parcel$export(module.exports, "getIsValidTimePeriod", () => $b5f7512a7f6df7c1$export$854444a059433c72);
$parcel$export(module.exports, "getMarketIndicatorContent", () => $b5f7512a7f6df7c1$export$9d97ddcbe08e8484);

var $bLQRh = parcelRequire("bLQRh");

var $5s7HV = parcelRequire("5s7HV");

var $a3q5k = parcelRequire("a3q5k");

var $bD9i3 = parcelRequire("bD9i3");

var $4fYAk = parcelRequire("4fYAk");
const $b5f7512a7f6df7c1$export$295067d1d3bf9763 = {
    [(0, $4fYAk.tabNames).inventory]: (0, $a3q5k.cardSettings),
    [(0, $4fYAk.tabNames).prices]: (0, $bD9i3.cardSettings),
    [(0, $4fYAk.tabNames).activity]: (0, $5s7HV.cardSettings)
};
const $b5f7512a7f6df7c1$export$854444a059433c72 = (currentTimePeriod, validTimePeriods)=>{
    return validTimePeriods.includes(currentTimePeriod);
};
const $b5f7512a7f6df7c1$export$d3338150b87a8fb = (countDaysOnMarket)=>{
    if (isNaN(countDaysOnMarket)) return;
    const monthsOnMarket = Math.floor(countDaysOnMarket) / 30;
    if (monthsOnMarket < 4) return (0, $bLQRh.marketTypes).sellers;
    if (monthsOnMarket >= 4 && monthsOnMarket <= 6) return (0, $bLQRh.marketTypes).neutral;
    return (0, $bLQRh.marketTypes).buyers;
};
const $b5f7512a7f6df7c1$export$9d97ddcbe08e8484 = (countDaysOnMarket)=>{
    const marketType = $b5f7512a7f6df7c1$export$d3338150b87a8fb(countDaysOnMarket);
    return {
        title: (0, $bLQRh.terms).getMarketTypeText((0, $bLQRh.terms)[marketType]),
        description: (0, $bLQRh.terms)[`${marketType}MarketDescription`]
    };
};

});
parcelRegister("5s7HV", function(module, exports) {

$parcel$export(module.exports, "cardSettings", () => $3f858bd3fab6f826$export$3524f474819ad369);

var $htzEo = parcelRequire("htzEo");

var $bLQRh = parcelRequire("bLQRh");

var $2DB2D = parcelRequire("2DB2D");
const $3f858bd3fab6f826$export$3524f474819ad369 = {
    gridClass: "grid-3",
    cards: [
        {
            formatter: (0, $htzEo.getCompactDollars),
            keyField: (0, $2DB2D.cardFields).soldVolume,
            title: (0, $bLQRh.terms).soldVolumeParens
        },
        {
            formatter: (0, $htzEo.getCompactDollars),
            keyField: (0, $2DB2D.cardFields).ucVolume,
            title: (0, $bLQRh.terms).ucVolumeParens
        },
        {
            formatter: (0, $htzEo.getCompactDollars),
            keyField: (0, $2DB2D.cardFields).forSaleVolume,
            title: (0, $bLQRh.terms).forSaleVolumeParens
        },
        {
            formatter: (0, $htzEo.formatUnits),
            keyField: (0, $2DB2D.cardFields).soldUnits,
            title: (0, $bLQRh.terms).soldUnitsParens
        },
        {
            formatter: (0, $htzEo.formatUnits),
            keyField: (0, $2DB2D.cardFields).ucUnits,
            title: (0, $bLQRh.terms).ucUnitsParens
        },
        {
            formatter: (0, $htzEo.formatUnits),
            keyField: (0, $2DB2D.cardFields).forSaleUnits,
            title: (0, $bLQRh.terms).forSaleUnitsParens
        }
    ]
};

});
parcelRegister("2DB2D", function(module, exports) {

$parcel$export(module.exports, "cardFields", () => $1ebbf4f4e5be0b4e$export$7d576a40358207c0);
$parcel$export(module.exports, "cardKeyFactors", () => $1ebbf4f4e5be0b4e$export$fb8613a72d6e2e67);
$parcel$export(module.exports, "formatterByTimePeriod", () => $1ebbf4f4e5be0b4e$export$3cd8bb7ccb9860b2);
$parcel$export(module.exports, "displayInfo", () => $1ebbf4f4e5be0b4e$export$7b1762f2253f172b);

var $htzEo = parcelRequire("htzEo");

var $cstaF = parcelRequire("cstaF");
const $1ebbf4f4e5be0b4e$export$7d576a40358207c0 = Object.freeze({
    avgSpOp: "spOpRatioAllProperties",
    ucMsi: "ucMsi",
    ucAvgDom: "ucAvgDom",
    forSaleMedianVolume: "forSaleMedianVolume",
    forSaleUnits: "forSaleUnits",
    forSaleVolume: "forSaleVolume",
    spOpRatioAllProperties: "spOpRatioAllProperties",
    soldAvgPricePerSqft: "soldAvgPricePerSqft",
    soldMedianVolume: "soldMedianVolume",
    soldUnits: "soldUnits",
    soldVolume: "soldVolume",
    ucUnits: "ucUnits",
    ucVolume: "ucVolume"
});
const $1ebbf4f4e5be0b4e$export$fb8613a72d6e2e67 = Object.freeze({
    [$1ebbf4f4e5be0b4e$export$7d576a40358207c0.ucMsi]: 0.9,
    [$1ebbf4f4e5be0b4e$export$7d576a40358207c0.ucAvgDom]: 0.88,
    [$1ebbf4f4e5be0b4e$export$7d576a40358207c0.forSaleMedianVolume]: 1.08,
    [$1ebbf4f4e5be0b4e$export$7d576a40358207c0.soldMedianVolume]: 1.08,
    [$1ebbf4f4e5be0b4e$export$7d576a40358207c0.avgSpOp]: 1,
    [$1ebbf4f4e5be0b4e$export$7d576a40358207c0.soldAvgPricePerSqft]: 0.9,
    [$1ebbf4f4e5be0b4e$export$7d576a40358207c0.soldVolume]: 1.27,
    [$1ebbf4f4e5be0b4e$export$7d576a40358207c0.ucVolume]: 1.27,
    [$1ebbf4f4e5be0b4e$export$7d576a40358207c0.forSaleVolume]: 1.33,
    [$1ebbf4f4e5be0b4e$export$7d576a40358207c0.soldUnits]: 0.96,
    [$1ebbf4f4e5be0b4e$export$7d576a40358207c0.ucUnits]: 0.96,
    [$1ebbf4f4e5be0b4e$export$7d576a40358207c0.forSaleUnits]: 0.96
});
const $1ebbf4f4e5be0b4e$export$3cd8bb7ccb9860b2 = Object.freeze({
    [(0, $cstaF.marketDynamicsTimePeriods)[(0, $cstaF.marketDynamicsTerms).years3Quarterly]]: (value)=>(0, $htzEo.quarterNumYearFormat)(value),
    [(0, $cstaF.marketDynamicsTimePeriods)[(0, $cstaF.marketDynamicsTerms).years2Monthly]]: (value)=>(0, $htzEo.shortMonthAndYearFormat)(value),
    [(0, $cstaF.marketDynamicsTimePeriods)[(0, $cstaF.marketDynamicsTerms).years1Monthly]]: (value)=>(0, $htzEo.shortMonthAndYearFormat)(value),
    [(0, $cstaF.marketDynamicsTimePeriods)[(0, $cstaF.marketDynamicsTerms).months6Weekly]]: (value)=>(0, $htzEo.shortDateFormat)(value)
});
const $1ebbf4f4e5be0b4e$export$7b1762f2253f172b = Object.freeze({
    noDataToDisplayMessage: "There was no activity during one or more periods of your search, making it impossible to calculate an accurate percentage change. Please refer to the chart or table for the exact data.",
    noDataToDisplayTitle: "No Data to Display"
});

});


parcelRegister("a3q5k", function(module, exports) {

$parcel$export(module.exports, "cardSettings", () => $751e6b1b32b4ab61$export$3524f474819ad369);

var $htzEo = parcelRequire("htzEo");

var $bLQRh = parcelRequire("bLQRh");

var $cstaF = parcelRequire("cstaF");

var $2DB2D = parcelRequire("2DB2D");
const $751e6b1b32b4ab61$export$3524f474819ad369 = {
    gridClass: "grid-3",
    cards: [
        {
            formatter: (0, $htzEo.getDecimalNumber),
            chartDataFormatter: (0, $htzEo.getDecimalNumber),
            keyField: (0, $2DB2D.cardFields).ucMsi,
            labelUnitType: (0, $bLQRh.terms).months,
            title: (0, $bLQRh.terms).monthlySupplyOfInventory,
            unitType: (0, $bLQRh.terms).months,
            timePeriods: [
                (0, $cstaF.marketDynamicsTimePeriods)[(0, $cstaF.marketDynamicsTerms).years1Monthly],
                (0, $cstaF.marketDynamicsTimePeriods)[(0, $cstaF.marketDynamicsTerms).years2Monthly]
            ]
        },
        {
            formatter: (0, $htzEo.formatInteger),
            chartDataFormatter: (0, $htzEo.formatInteger),
            keyField: (0, $2DB2D.cardFields).ucAvgDom,
            labelUnitType: (0, $bLQRh.terms).days,
            title: (0, $bLQRh.terms).avgDom,
            unitType: (0, $bLQRh.terms).days,
            timePeriods: [
                (0, $cstaF.marketDynamicsTimePeriods)[(0, $cstaF.marketDynamicsTerms).months6Weekly],
                (0, $cstaF.marketDynamicsTimePeriods)[(0, $cstaF.marketDynamicsTerms).years3Quarterly]
            ]
        },
        {
            formatter: (0, $htzEo.getCompactDollars),
            chartFormatter: (0, $htzEo.getCompactDollars),
            keyField: (0, $2DB2D.cardFields).forSaleVolume,
            title: (0, $bLQRh.terms).totalInventoryVolume
        },
        {
            formatter: (0, $htzEo.formatUnits),
            chartFormatter: (0, $htzEo.formatUnits),
            keyField: (0, $2DB2D.cardFields).forSaleUnits,
            title: (0, $bLQRh.terms).totalInventoryUnit,
            labelUnitType: (0, $bLQRh.terms).units,
            chartUnitType: ""
        }
    ]
};

});

parcelRegister("bD9i3", function(module, exports) {

$parcel$export(module.exports, "cardSettings", () => $877a8b0fefc99614$export$3524f474819ad369);

var $htzEo = parcelRequire("htzEo");

var $bLQRh = parcelRequire("bLQRh");

var $2DB2D = parcelRequire("2DB2D");
const $877a8b0fefc99614$export$3524f474819ad369 = {
    gridClass: "grid-2",
    cards: [
        {
            formatter: (0, $htzEo.formatVolume),
            keyField: (0, $2DB2D.cardFields).forSaleMedianVolume,
            title: (0, $bLQRh.terms).activeForSale,
            chartFormatter: (0, $htzEo.getCompactDollars)
        },
        {
            formatter: (0, $htzEo.formatVolume),
            keyField: (0, $2DB2D.cardFields).soldMedianVolume,
            title: (0, $bLQRh.terms).medianPriceSold,
            chartFormatter: (0, $htzEo.getCompactDollars)
        },
        {
            formatter: (0, $htzEo.formatOneDecimalPercentageWithMultiplier),
            keyField: (0, $2DB2D.cardFields).spOpRatioAllProperties,
            title: (0, $bLQRh.terms).salesPriceOriginalPrice,
            chartDataFormatter: (0, $htzEo.maxThreeDecimals),
            changeFormatter: (0, $htzEo.blankEmptyFormatPercentage)
        },
        {
            formatter: (0, $htzEo.formatVolume),
            keyField: (0, $2DB2D.cardFields).soldAvgPricePerSqft,
            title: (0, $bLQRh.terms).avgPriceSqft,
            labelUnitType: (0, $bLQRh.terms).avgPricePerSqft,
            chartFormatter: (0, $htzEo.getCompactDollars),
            chartUnitType: ""
        }
    ]
};

});

parcelRegister("4fYAk", function(module, exports) {

$parcel$export(module.exports, "overviewStatusKeys", () => $31978f0f10b4d977$export$84d01635218041d6);
$parcel$export(module.exports, "tabIndex", () => $31978f0f10b4d977$export$9a625f9de50bf0b7);
$parcel$export(module.exports, "tabNames", () => $31978f0f10b4d977$export$7bd33291bfa3261b);
$parcel$export(module.exports, "listingOptions", () => $31978f0f10b4d977$export$d4758f7de7da0463);
$parcel$export(module.exports, "listingIds", () => $31978f0f10b4d977$export$81bc3826a51d9279);
$parcel$export(module.exports, "chartLegends", () => $31978f0f10b4d977$export$e75e9c52acf9fe0e);
$parcel$export(module.exports, "optionLabels", () => $31978f0f10b4d977$export$938355954b3d67e4);
$parcel$export(module.exports, "labels", () => $31978f0f10b4d977$export$a238cb463698c900);
$parcel$export(module.exports, "overviewPeriods", () => $31978f0f10b4d977$export$35a00427897c932);

var $bLQRh = parcelRequire("bLQRh");

var $jUjGS = parcelRequire("jUjGS");
const $31978f0f10b4d977$var$LOW_HEX_COLOR = (0, $jUjGS.COLOR_PRIMARY_GREEN);
const $31978f0f10b4d977$var$HIGH_HEX_COLOR = (0, $jUjGS.COLOR_SECONDARY_GREEN);
const $31978f0f10b4d977$var$AUX_HEX_COLOR = (0, $jUjGS.COLOR_TERTIARY_GREEN);
const $31978f0f10b4d977$export$84d01635218041d6 = {
    currentTab: "currentTab",
    chartSettings: "chartSettings",
    activity: "activity",
    inventory: "inventory",
    prices: "prices"
};
const $31978f0f10b4d977$export$9a625f9de50bf0b7 = {
    inventory: 0,
    prices: 1,
    activity: 2
};
const $31978f0f10b4d977$export$7bd33291bfa3261b = {
    activity: "Activity",
    inventory: "Inventory",
    prices: "Prices"
};
const $31978f0f10b4d977$var$listingOption = {
    overview: "overview"
};
const $31978f0f10b4d977$export$d4758f7de7da0463 = {
    overview: {
        label: (0, $bLQRh.terms).overview,
        value: $31978f0f10b4d977$var$listingOption.overview
    }
};
const $31978f0f10b4d977$export$81bc3826a51d9279 = {
    Last13Months: "monthlySupplyOfInventory",
    Last25Months: "monthlySupplyOfInventory",
    Last13Quarters: "avgDomCdom",
    Last24Weeks: "underContractUc"
};
const $31978f0f10b4d977$export$e75e9c52acf9fe0e = {
    forSale: "FOR SALE",
    fortyFiveDaysOrLess: "45 DAYS OR LESS",
    fourMonthsOrLess: "4 MONTHS OR LESS",
    medianList: "MEDIAN (LIST)",
    medianSold: "MEDIAN (SOLD)",
    moreThanFourMonths: "MORE THAN 4 MONTHS",
    moreThanFortyFiveDays: "MORE THAN 45 DAYS",
    sold: "SOLD",
    underContract: "UNDER CONTRACT"
};
const $31978f0f10b4d977$export$938355954b3d67e4 = {
    forSale: "For Sale",
    sold: "Sold"
};
const $31978f0f10b4d977$export$a238cb463698c900 = {
    medianList: "Median (List)",
    medianSold: "Median (Sold)"
};
const $31978f0f10b4d977$var$overviewGroup = {
    averageDom: "averageDom"
};
const $31978f0f10b4d977$export$35a00427897c932 = {
    monthly: {
        value: "monthly",
        lowHexColor: $31978f0f10b4d977$var$LOW_HEX_COLOR,
        highHexColor: $31978f0f10b4d977$var$HIGH_HEX_COLOR,
        auxHexColor: $31978f0f10b4d977$var$AUX_HEX_COLOR,
        statusGroup: (0, $bLQRh.terms).monthsSupply,
        threshold: 4,
        xAxisLegends: [
            $31978f0f10b4d977$export$e75e9c52acf9fe0e.fourMonthsOrLess,
            $31978f0f10b4d977$export$e75e9c52acf9fe0e.moreThanFourMonths
        ],
        yAxisText: (0, $bLQRh.terms).monthsSupply
    },
    other: {
        value: "other",
        lowHexColor: $31978f0f10b4d977$var$LOW_HEX_COLOR,
        highHexColor: $31978f0f10b4d977$var$HIGH_HEX_COLOR,
        auxHexColor: $31978f0f10b4d977$var$AUX_HEX_COLOR,
        statusGroup: $31978f0f10b4d977$var$overviewGroup.averageDom,
        threshold: 45,
        xAxisLegends: [
            $31978f0f10b4d977$export$e75e9c52acf9fe0e.fortyFiveDaysOrLess,
            $31978f0f10b4d977$export$e75e9c52acf9fe0e.moreThanFortyFiveDays
        ],
        yAxisText: (0, $bLQRh.terms).avgDom
    }
};

});



parcelRegister("f4YyF", function(module, exports) {

$parcel$export(module.exports, "default", () => $b81d07b612f62b4e$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $htzEo = parcelRequire("htzEo");

var $cwutX = parcelRequire("cwutX");

var $cstaF = parcelRequire("cstaF");

var $bmWW5 = parcelRequire("bmWW5");

var $dDBOF = parcelRequire("dDBOF");
const $b81d07b612f62b4e$var$Footer = ({ loadedSearchCriteria: loadedSearchCriteria, selectedBeginValue: selectedBeginValue, selectedEndValue: selectedEndValue, selectedMls: selectedMls, searchResults: searchResults, timeFrameTitle: timeFrameTitle, listingTypeId: listingTypeId, isComparisonSetView: isComparisonSetView, listingStatus: listingStatus, areaTypeTitle: areaTypeTitle, module: module, config: config, officeListName: officeListName })=>{
    const timeFrame = (0, $cwutX.getTimeFrame)(searchResults, timeFrameTitle, selectedBeginValue, selectedEndValue);
    const { selectedAreaType: selectedAreaType, selectedArea: selectedArea } = (0, $cwutX.getSelectedAreaInfo)(loadedSearchCriteria, module, areaTypeTitle);
    const propertyTypes = config.shouldShowPropertyTypes ? (0, $cwutX.getFieldValues)(loadedSearchCriteria, "propertyType") : "";
    const buildDetailItem = (label, value)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "detail-item",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("strong", {
                    children: [
                        label,
                        ":"
                    ]
                }),
                " ",
                value
            ]
        }, label);
    const detailFields = config?.getDetailFields({
        selectedMls: selectedMls,
        timeFrame: timeFrame,
        loadedSearchCriteria: loadedSearchCriteria,
        listingTypeId: listingTypeId,
        isComparisonSetView: isComparisonSetView,
        listingStatus: listingStatus
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "footer",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "footer-divider"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "footer-content",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "report-details",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "detail-line",
                                    children: detailFields.map(({ label: label, value: value })=>buildDetailItem(label, value))
                                }),
                                propertyTypes && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "detail-item full-width",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("strong", {
                                            children: [
                                                (0, $cstaF.searchTerms).propertyTypesSA,
                                                ":"
                                            ]
                                        }),
                                        " ",
                                        (0, $cwutX.truncateLine)(propertyTypes, (0, $bmWW5.MAX_LINE_LENGTH) - `${(0, $cstaF.searchTerms).propertyTypesSA}: `.length)
                                    ]
                                }),
                                config.shouldShowOfficeListFooter && officeListName && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "detail-item full-width office-list-footer",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("strong", {
                                            children: [
                                                (0, $cstaF.searchTerms).officeList,
                                                ":"
                                            ]
                                        }),
                                        " ",
                                        officeListName
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "detail-item full-width",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("strong", {
                                            children: selectedAreaType
                                        }),
                                        " ",
                                        (0, $cwutX.truncateLine)(selectedArea, (0, $bmWW5.MAX_LINE_LENGTH) - (selectedAreaType + " ").length)
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "disclaimer",
                        children: (0, $cstaF.pdfDisclaimer)(selectedMls, (0, $dDBOF.appLabels)[0, $dDBOF.runningApp])
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "date",
                        children: (0, $htzEo.shortDateFormatWithSlashes)(new Date().toISOString())
                    })
                ]
            })
        ]
    });
};
$b81d07b612f62b4e$var$Footer.propTypes = {
    selectedMls: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    loadedSearchCriteria: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    selectedBeginValue: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    selectedEndValue: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    searchResults: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    timeFrameTitle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    listingTypeId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    isComparisonSetView: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    listingStatus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    module: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    areaTypeTitle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};
var $b81d07b612f62b4e$export$2e2bcd8739ae039 = $b81d07b612f62b4e$var$Footer;

});

parcelRegister("ir77C", function(module, exports) {

$parcel$export(module.exports, "default", () => $710c3dab09b43f08$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $dqgmD = parcelRequire("dqgmD");

var $c9Z8w = parcelRequire("c9Z8w");

var $eHBjM = parcelRequire("eHBjM");

var $cwutX = parcelRequire("cwutX");

var $cstaF = parcelRequire("cstaF");
const $710c3dab09b43f08$var$Table = ({ searchResults: searchResults, tableView: tableView, config: config })=>{
    const totalRows = searchResults.length;
    const DEFAULT_ROWS_PER_TABLE = 25;
    const rowsPerTable = config.rowsPerTable ?? DEFAULT_ROWS_PER_TABLE;
    const numberOfTables = Math.ceil(totalRows / rowsPerTable);
    const MAX_OFFICE_NAME_LENGTH = 57;
    const TableSection = ({ searchResults: searchResults, tableView: tableView, startIndex: startIndex, endIndex: endIndex })=>{
        const createTableRows = ()=>{
            return searchResults.slice(startIndex, endIndex).map((row, i)=>{
                const isLastRow = i + startIndex === searchResults.length - 1;
                return /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                    className: config.hasTotalsRow && isLastRow ? "totals-row" : "",
                    children: tableView.tables.map((table, index)=>{
                        const value = row[table.col.keyField ?? table.col.id];
                        const isBoldTotalsLabel = config.hasBoldTotalsLabel && value === (0, $cstaF.searchTerms).totals;
                        const displayValue = config.hasTruncation && table.col.id === (0, $eHBjM.agentsColumns).officeName.id ? (0, $cwutX.truncateLine)(value, MAX_OFFICE_NAME_LENGTH) : value;
                        return /*#__PURE__*/ (0, $ayMG0.jsx)("td", {
                            className: `${table.colDef.cellClass?.includes("td-num") ? "right" : "left"} ${isBoldTotalsLabel ? "totals-row-title" : ""}`,
                            children: !(0, $dqgmD.isEncodedCellValue)(value) && (table.colDef?.valueFormatter?.({
                                value: displayValue
                            }) ?? displayValue)
                        }, index);
                    })
                }, `content-${startIndex + i}`);
            });
        };
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: config.hasAgentDetailHeader ? "agent-detail-page-section" : "page-section",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("table", {
                className: `table ${config.hasAgentDetailHeader ? "agent-detail-table" : ""}`,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("thead", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("tr", {
                            children: tableView.tables.map((table, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("th", {
                                    className: table.colDef?.headerClass?.includes("align-top") ? "right" : "left",
                                    children: table.col.label || table.colDef.label
                                }, index))
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("tbody", {
                        children: createTableRows()
                    })
                ]
            })
        });
    };
    const tableSections = Array.from({
        length: numberOfTables
    }, (_, index)=>{
        const startIndex = index * rowsPerTable;
        const endIndex = Math.min(startIndex + rowsPerTable, totalRows);
        return /*#__PURE__*/ (0, $ayMG0.jsx)(TableSection, {
            searchResults: searchResults,
            tableView: tableView,
            startIndex: startIndex,
            endIndex: endIndex
        }, `table-section-${index}`);
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: tableSections
    });
};
$710c3dab09b43f08$var$Table.propTypes = {
    searchResults: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    tableView: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    config: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $710c3dab09b43f08$export$2e2bcd8739ae039 = $710c3dab09b43f08$var$Table;

});


parcelRegister("jKEVi", function(module, exports) {

$parcel$export(module.exports, "initialView", () => $e6120eb05bf04cc5$export$dc91ed08935ae99d);
$parcel$export(module.exports, "initialSearchState", () => $e6120eb05bf04cc5$export$1cc24d2453c74039);
$parcel$export(module.exports, "useSearchStore", () => $e6120eb05bf04cc5$export$8992e2c9f8b2a805);

var $9phu9 = parcelRequire("9phu9");

var $88tPr = parcelRequire("88tPr");

var $cstaF = parcelRequire("cstaF");

var $9u5KN = parcelRequire("9u5KN");

var $gzAOa = parcelRequire("gzAOa");

var $1G8OF = parcelRequire("1G8OF");

var $5lFnP = parcelRequire("5lFnP");

var $g6VQn = parcelRequire("g6VQn");

var $k0fob = parcelRequire("k0fob");

var $1b2v3 = parcelRequire("1b2v3");

var $iIoxY = parcelRequire("iIoxY");

var $6mw4P = parcelRequire("6mw4P");

var $hJEGM = parcelRequire("hJEGM");

var $4DJah = parcelRequire("4DJah");

var $3X7wA = parcelRequire("3X7wA");

var $385ED = parcelRequire("385ED");
const $e6120eb05bf04cc5$export$dc91ed08935ae99d = {
    id: undefined,
    search: {
        ownerId: undefined,
        mlsId: undefined,
        searchCriteria: undefined,
        representationCriteria: undefined,
        selectedOfficeListSearch: undefined
    },
    loadedSearchCriteria: undefined,
    selectedMls: undefined,
    savedSearchList: undefined,
    selectedSavedSearch: undefined,
    timeFrameTitle: {
        mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).timeFrame)
    },
    searchStatus: undefined,
    recruitingSoldTotals: undefined,
    summaryPinnedData: undefined,
    totals: undefined,
    retainedSortByModule: {},
    retainedFloatingFilterByModule: {},
    shouldShowChart: true
};
const $e6120eb05bf04cc5$export$1cc24d2453c74039 = (initialView)=>({
        selectedModule: undefined,
        isLoading: false,
        isLoadingSearchData: false,
        listIsDirty: false,
        shouldCloseChips: false,
        shouldAgentNameRerunOnLoad: false,
        isManualSearch: false,
        [(0, $cstaF.modules).proficiencyMetrics.transactions]: {
            ...(0, $5lFnP.transactionsSearchView)({
                ...initialView
            })
        },
        [(0, $cstaF.modules).proficiencyMetrics.offices]: {
            ...(0, $5lFnP.officeSearchView)({
                ...initialView
            })
        },
        [(0, $cstaF.modules).proficiencyMetrics.agents]: {
            ...(0, $5lFnP.agentSearchView)({
                ...initialView
            })
        },
        [(0, $cstaF.modules).proficiencyMetrics.suggestedAgents]: {
            ...(0, $5lFnP.suggestedAgentsSearchView)({
                ...initialView
            })
        },
        [(0, $cstaF.modules).proficiencyMetrics.agentMovement]: {
            ...(0, $5lFnP.agentMovementSearchView)({
                ...initialView
            })
        },
        [(0, $cstaF.modules).marketShare.totals]: {
            ...(0, $1G8OF.marketTotalsView)({
                ...initialView
            })
        },
        [(0, $cstaF.modules).marketShare.coverage]: {
            ...(0, $1G8OF.marketCoverageView)({
                ...initialView
            })
        },
        [(0, $cstaF.modules).marketDynamics.marketDynamics]: {
            ...(0, $gzAOa.marketDynamicsView)({
                ...initialView
            })
        },
        [(0, $cstaF.modules).proficiencyMetrics.savedAgents]: {
            ...(0, $5lFnP.savedAgentsSearchView)({
                ...initialView
            })
        },
        [(0, $cstaF.modules).dashboard.dashboard]: {
            ...(0, $385ED.dashboardView)({
                ...initialView
            })
        },
        [(0, $cstaF.modules).agentProduction.agentProduction]: {
            ...initialView
        }
    });
let $e6120eb05bf04cc5$var$searchStore = (set, get)=>({
        ...$e6120eb05bf04cc5$export$1cc24d2453c74039($e6120eb05bf04cc5$export$dc91ed08935ae99d),
        ...(0, $9u5KN.actions)(set, get),
        ...(0, $g6VQn.actions)(set, get),
        ...(0, $k0fob.actions)(set, get),
        ...(0, $1b2v3.actions)(set, get),
        ...(0, $6mw4P.actions)(set, get),
        ...(0, $iIoxY.actions)(),
        ...(0, $hJEGM.actions)(set, get),
        ...(0, $3X7wA.tableRetainActions)(set, get),
        ...(0, $4DJah.actions)(set, get)
    });
const $e6120eb05bf04cc5$export$8992e2c9f8b2a805 = (0, $9phu9.createWithEqualityFn)((0, $88tPr.devtools)((0, $88tPr.persist)($e6120eb05bf04cc5$var$searchStore, {
    name: "search_state",
    storage: (0, $88tPr.createJSONStorage)(()=>localStorage)
})));

});
parcelRegister("9u5KN", function(module, exports) {

$parcel$export(module.exports, "actions", () => $6e7b60f5d853bd16$export$e324594224ef24da);

var $5ILgR = parcelRequire("5ILgR");
var $fpekr = parcelRequire("fpekr");
var $3kePu = parcelRequire("3kePu");
var $69p3P = parcelRequire("69p3P");

var $cstaF = parcelRequire("cstaF");

var $5NVz0 = parcelRequire("5NVz0");

var $8cYiI = parcelRequire("8cYiI");

var $kmjbt = parcelRequire("kmjbt");

var $5269x = parcelRequire("5269x");

var $lEGzp = parcelRequire("lEGzp");

var $dlZsJ = parcelRequire("dlZsJ");

var $3FMCA = parcelRequire("3FMCA");

var $90ISC = parcelRequire("90ISC");

var $3T9wI = parcelRequire("3T9wI");

var $luxkV = parcelRequire("luxkV");

var $ae040 = parcelRequire("ae040");

var $bxSLe = parcelRequire("bxSLe");

var $4ZFhI = parcelRequire("4ZFhI");

var $jilhO = parcelRequire("jilhO");

var $i1BZc = parcelRequire("i1BZc");

var $iCDWi = parcelRequire("iCDWi");

var $jKEVi = parcelRequire("jKEVi");

var $jpGV2 = parcelRequire("jpGV2");
const $6e7b60f5d853bd16$var$wrapCriteria = (criteria)=>({
        criteria: criteria,
        offset: 0,
        size: 0
    });
const $6e7b60f5d853bd16$var$getCriteria = (realEstateDatasourceId, initialCriteria = {})=>$6e7b60f5d853bd16$var$wrapCriteria(realEstateDatasourceId && {
        ...initialCriteria,
        realEstateDatasourceIdsWithFilters: [
            {
                ...initialCriteria?.realEstateDatasourceId?.[0],
                realEstateDatasourceId: realEstateDatasourceId || -1,
                searchFields: [],
                searchAllMLS: false,
                computedFields: [],
                idFiltering: []
            }
        ]
    });
const $6e7b60f5d853bd16$var$resetSelectedSavedSearch = (state)=>{
    if (state?.selectedSavedSearch) {
        state.selectedSavedSearch = undefined;
        state.search = $69p3P.default(state.search, [
            "isDefault",
            "application",
            "searchName",
            "notes",
            "module",
            "ownerId",
            "ownerType",
            "representationCriteria"
        ]);
    }
};
const $6e7b60f5d853bd16$var$setDefaultTitles = (module)=>({
        propertyTypeTitle: (0, $3FMCA.defaultTitles).propertyTypeTitle,
        timeFrameTitle: (0, $3FMCA.defaultTitles).timeFrameTitle,
        totalVolumeTitle: (0, $3FMCA.defaultTitles).totalVolumeTitle,
        soldPriceRangeTitle: (0, $3FMCA.defaultTitles).soldPriceRangeTitle,
        priceRangeTitle: (0, $3FMCA.defaultTitles).priceRangeTitle,
        totalUnitsTitle: (0, $3FMCA.defaultTitles).totalUnitsTitle,
        bedroomsTitle: (0, $3FMCA.defaultTitles).bedroomsTitle,
        fullBathroomsTitle: (0, $3FMCA.defaultTitles).fullBathroomsTitle,
        marketAreaTitle: (0, $3FMCA.defaultTitles).marketAreaTitle(module),
        areaTypeTitle: (0, $3FMCA.defaultTitles).areaTypeTitle,
        listingStatusTitle: (0, $3FMCA.defaultTitles).listingStatusTitle,
        officesTitle: (0, $3FMCA.defaultTitles).officesTitle,
        agentsTitle: (0, $3FMCA.defaultTitles).agentsTitle,
        lotSizeTitle: (0, $3FMCA.defaultTitles).lotSizeTitle,
        squareFootageTitle: (0, $3FMCA.defaultTitles).squareFootageTitle,
        comparisonSetTitle: (0, $3FMCA.defaultTitles).comparisonSetTitle,
        constructionTypeTitle: (0, $3FMCA.defaultTitles).constructionTypeTitle
    });
const $6e7b60f5d853bd16$var$setOfficeDefaultTimeframe = (selectedModule, timeIntervals, mls, set)=>{
    set((0, $8cYiI.produce)((state)=>{
        if (selectedModule === (0, $cstaF.modules).proficiencyMetrics.offices) {
            const newTimePeriodCriteria = {
                intervalType: (0, $cstaF.TimePeriods)[(0, $cstaF.agentProductionTerms).last12Months]
            };
            const criteria = $6e7b60f5d853bd16$var$getCriteria(mls.mlsId);
            criteria.criteria.timePeriod = newTimePeriodCriteria;
            state[selectedModule] = {
                ...state[selectedModule],
                selectedMls: mls,
                search: {
                    searchCriteria: {
                        ...criteria
                    },
                    mlsId: mls.mlsId
                },
                timeFrameTitle: (0, $5269x.getTimeFrameTitle)(newTimePeriodCriteria, timeIntervals, selectedModule),
                selectedSavedSearch: undefined
            };
        }
    }), false, "setOfficeDefaultTimeFrame");
};
const $6e7b60f5d853bd16$var$getAgentCriteriaIds = (search)=>{
    return search.savedSearch.searchCriteria.criteria.realEstateDatasourceIdsWithFilters.find((i)=>i.realEstateDatasourceId === search.savedSearch.mlsId)?.idFiltering?.find((o)=>o.idType.toLowerCase() === (0, $cstaF.searchTerms).agentIdType.toLowerCase())?.idValues;
};
const $6e7b60f5d853bd16$var$setMls = (selectedModule, mls, timeIntervals, set, get, isSuggestedAgents, currentTabId)=>{
    const isMultipleMlsUser = (0, $90ISC.useCommonStore).getState()?.mlsProviders?.length > 1;
    const isMlsSelected = !!get()[selectedModule]?.selectedMls;
    const initialModuleState = (0, $jKEVi.initialSearchState)((0, $jKEVi.initialView))[selectedModule];
    const initialModuleCriteria = initialModuleState?.search?.searchCriteria?.criteria;
    if (isSuggestedAgents) {
        set((0, $8cYiI.produce)((state)=>{
            state[selectedModule] = {
                ...state[selectedModule],
                searchOptions: {
                    ...state[selectedModule]?.searchOptions,
                    [currentTabId]: {
                        ...state[selectedModule]?.searchOptions?.[currentTabId],
                        producers: {
                            ...state[selectedModule]?.searchOptions?.[currentTabId]?.producers,
                            mls: mls
                        }
                    }
                },
                ...$6e7b60f5d853bd16$var$setDefaultTitles(selectedModule)
            };
        }), false, "setMls");
        return;
    }
    if (isMultipleMlsUser || !isMultipleMlsUser && !isMlsSelected) set((0, $8cYiI.produce)((state)=>{
        state[selectedModule] = {
            ...state[selectedModule],
            selectedMls: mls,
            search: {
                searchCriteria: $6e7b60f5d853bd16$var$getCriteria(mls.mlsId, initialModuleCriteria),
                mlsId: mls.mlsId
            },
            searchFilters: (state[selectedModule]?.searchFilters || []).filter((filterName)=>!(0, $kmjbt.getFiltersByGroupTitle)((0, $4ZFhI.allFilterGroups), (0, $cstaF.searchTerms).optional).includes(filterName)),
            selectedSavedSearch: undefined,
            agents: undefined,
            ...$6e7b60f5d853bd16$var$setDefaultTitles(selectedModule)
        };
    }), false, "setMls");
    timeIntervals && $6e7b60f5d853bd16$var$setOfficeDefaultTimeframe(selectedModule, timeIntervals, mls, set);
};
const $6e7b60f5d853bd16$export$e324594224ef24da = (set, get)=>({
        setSelectedModule: async (selectedModule)=>{
            selectedModule && set({
                selectedModule: selectedModule
            }, false, "setSelectedModule");
        },
        setIsLoading: (isLoading)=>set({
                isLoading: isLoading
            }, false, "setisLoading"),
        setSelectedMls: async (mls, selectedModule, timeIntervals)=>{
            if (selectedModule) $6e7b60f5d853bd16$var$setMls(selectedModule, mls, timeIntervals, set, get);
            else $fpekr.default((0, $cstaF.modulesByRouteAndNameAssociation).map((assoc)=>assoc.module), (module)=>{
                $6e7b60f5d853bd16$var$setMls(module, mls, timeIntervals, set, get);
            });
        },
        setSuggestedAgentsMlsByTab: async (mls, selectedModule, currentTabId)=>{
            if (selectedModule) $6e7b60f5d853bd16$var$setMls(selectedModule, mls, null, set, get, true, currentTabId);
        },
        setSelectedSavedSearch: async ({ search: search, accountId: accountId, selectedMls: selectedMls, timeIntervals: timeIntervals, marketAreaLists: marketAreaLists, officeLists: officeLists })=>{
            const selectedModule = get().selectedModule;
            const searchMlsId = search?.savedSearch.mlsId;
            let searchFilters = [
                "savedSearches"
            ];
            const mappedAreas = await (0, $5NVz0.getAreasMap)(searchMlsId);
            let propTypes = selectedModule !== (0, $cstaF.modules).proficiencyMetrics.offices && await (0, $5NVz0.getPropertyTypes)(searchMlsId);
            const offices = [
                (0, $cstaF.modules).proficiencyMetrics.offices,
                (0, $cstaF.modules).marketShare.coverage,
                (0, $cstaF.modules).proficiencyMetrics.agentMovement
            ].includes(selectedModule) && await (0, $bxSLe.getOfficesByModule)(searchMlsId)[selectedModule]();
            const selectedAgents = selectedModule === (0, $cstaF.modules).proficiencyMetrics.agents && $6e7b60f5d853bd16$var$getAgentCriteriaIds(search) && await (0, $5NVz0.getMlsAgentsByIds)(search.savedSearch.mlsId, $6e7b60f5d853bd16$var$getAgentCriteriaIds(search));
            set((0, $8cYiI.produce)((state)=>{
                let module = {
                    ...state[selectedModule],
                    ...$6e7b60f5d853bd16$var$setDefaultTitles(selectedModule)
                };
                module.recruiting = {};
                module.marketShare = {};
                module.selectedMls = selectedMls;
                module.search = search.savedSearch;
                module.selectedSavedSearch = search;
                const mls = $5ILgR.default(search.savedSearch.searchCriteria.criteria.realEstateDatasourceIdsWithFilters, (i)=>i.realEstateDatasourceId === search.savedSearch.mlsId);
                const filterGroups = (0, $kmjbt.getFilterGroups)({
                    isComparisonSetsEnabled: $3T9wI.isComparisonSetsEnabled
                });
                $fpekr.default(filterGroups, (g)=>{
                    $fpekr.default(g.filters, async (f)=>{
                        let addFilter;
                        switch(f.id){
                            case (0, $cstaF.searchTerms).mlsFilter:
                                addFilter = true;
                                break;
                            case (0, $cstaF.searchTerms).areaTypeFilter:
                                addFilter = true;
                                const areaType = search.savedSearch.searchCriteria.criteria.realEstateDatasourceIdsWithFilters[0].computedFields.find((field)=>field.fieldName === "areaType")?.fieldValues[0];
                                if (areaType) {
                                    let columnName;
                                    for (const [key, value] of Object.entries((0, $cstaF.areaRequestTypes)))if (value === areaType) columnName = key;
                                    const viewName = !mappedAreas.error && Object.values(mappedAreas).find((area)=>area.columnName === columnName).viewName;
                                    module.areaTypeTitle = {
                                        mainTitle: `${(0, $cstaF.searchTerms).areaType}: ${viewName}`
                                    };
                                }
                                break;
                            case (0, $cstaF.searchTerms).propTypeFilter:
                                addFilter = true;
                                if (!propTypes?.error) {
                                    const propTypeField = mls?.searchFields.find((searchField)=>searchField.fieldName === "propertyType");
                                    if (propTypeField) module.propertyTypeTitle = (0, $5269x.getPropertyTypeTitle)(propTypes, propTypeField.fieldValues);
                                }
                                break;
                            case (0, $cstaF.searchTerms).timeFrameFilter:
                                addFilter = true;
                                if (timeIntervals) {
                                    const timePeriod = search.savedSearch.searchCriteria?.criteria?.timePeriod;
                                    if (timePeriod) module.timeFrameTitle = (0, $5269x.getTimeFrameTitle)(timePeriod, timeIntervals, selectedModule);
                                }
                                break;
                            case (0, $cstaF.searchTerms).marketAreaFilter:
                                addFilter = true;
                                const selectedAreas = mls?.searchFields?.filter((f)=>(0, $cstaF.areaSearchTypes).includes(f.fieldName));
                                if (selectedAreas?.length > 0) {
                                    const marketAreaListField = selectedAreas.find((area)=>area.savedAreaId);
                                    module.marketAreaTitle = !marketAreaListField?.savedAreaId ? (0, $5269x.getMarketAreaTitle)({
                                        selectedAreas: selectedAreas,
                                        searchAllMls: false,
                                        module: selectedModule
                                    }) : (0, $5269x.getMarketAreaListTitle)(marketAreaLists?.find((l)=>l.id === marketAreaListField.savedAreaId)?.name, marketAreaListField.fieldTypeName);
                                } else if (mls?.searchAllMLS) module.marketAreaTitle = (0, $5269x.getMarketAreaTitle)({
                                    selectedAreas: null,
                                    searchAllMls: true,
                                    module: selectedModule
                                });
                                break;
                            case (0, $cstaF.searchTerms).listingStatusFilter:
                                addFilter = true;
                                const selectedStatus = mls?.computedFields?.find((f)=>f.fieldName === (0, $cstaF.searchTerms).transactionStatus);
                                if (selectedStatus && !!selectedStatus.fieldValues?.length) module.listingStatusTitle = {
                                    mainTitle: (0, $cstaF.marketShareListingStatuses)[selectedStatus.fieldValues[0]]
                                };
                                break;
                            case (0, $cstaF.searchTerms).officesFilter:
                                addFilter = true;
                                const officeCriteria = mls?.idFiltering?.find((o)=>o.idType.toLowerCase() === (0, $cstaF.searchTerms).officeIdType.toLowerCase());
                                if (!officeCriteria) break;
                                if (officeCriteria.listId) {
                                    const officeList = officeLists?.find((list)=>list.officeListId === officeCriteria.listId);
                                    module.selectedOfficeList = officeList?.name;
                                    module.officesTitle = (0, $5269x.getOfficeListTitle)(officeList?.name);
                                } else if (officeCriteria.idValues?.length) module.officesTitle = (0, $5269x.getOfficesTitle)(officeCriteria.idValues, offices);
                                break;
                            case (0, $cstaF.searchTerms).agentsFilter:
                                addFilter = true;
                                if (!selectedAgents?.error) module.agents = selectedAgents;
                                module.agentsTitle = (0, $5269x.getAgentsTitle)(selectedAgents);
                                break;
                            case (0, $cstaF.searchTerms).constructionTypeFilter:
                                {
                                    const constructionTypeField = mls?.searchFields?.find((field)=>field.fieldName === (0, $cstaF.searchTerms).newConstruction);
                                    if (constructionTypeField) addFilter = true;
                                    const constructionType = constructionTypeField?.fieldValues[0];
                                    module.constructionTypeTitle = {
                                        mainTitle: (0, $cstaF.searchTerms).constructionType,
                                        subTitle: (0, $iCDWi.reverseMap)((0, $cstaF.constructionTypeMap))[constructionType]
                                    };
                                    break;
                                }
                            case (0, $cstaF.searchTerms).comparisonSetFilter:
                                if (mls?.mlsObjectId) {
                                    const selectedComparisonSet = (0, $ae040.useComparisonSetsStore).getState().comparisonSets?.list.find((cs)=>cs.id === mls.mlsObjectId);
                                    module.selectedComparisonSetSearch = selectedComparisonSet;
                                    module.comparisonSetTitle = {
                                        mainTitle: selectedComparisonSet.name
                                    };
                                    addFilter = true;
                                }
                                break;
                            default:
                                if (f.id) {
                                    const path = f.path.split("/");
                                    const searchField = f.id === (0, $cstaF.searchTerms).lotSizeFilter ? mls && mls[path[0]]?.find((f)=>f.fieldName === (0, $cstaF.searchTerms).lotSizeAcresFilter || f.fieldName === (0, $cstaF.searchTerms).lotSquareFeetFilter) : mls && mls[path[0]]?.find((f)=>f.fieldName === path[1]);
                                    addFilter = !!searchField?.fieldValues?.length || !!searchField?.fieldMinValue || !!searchField?.fieldMaxValue;
                                    if (addFilter) module[`${f.id}Title`] = (0, $5269x.getRangeTitle)((0, $cstaF.searchTerms)[f.id], {
                                        min: searchField.fieldMinValue,
                                        max: searchField.fieldMaxValue
                                    }, (0, $5269x.currencyFields).includes(searchField.fieldName));
                                }
                                break;
                        }
                        if (addFilter) searchFilters.push(f.id);
                    });
                });
                module.searchFilters = searchFilters;
                state[selectedModule] = module;
            }), false, "setSelectedSavedSearch");
        },
        resetSearchCriteria: ()=>{
            set((0, $8cYiI.produce)((state)=>{
                const selectedModule = get().selectedModule;
                const module = state[selectedModule];
                module.loadedSearchCriteria = undefined;
                if (selectedModule === (0, $cstaF.modules).proficiencyMetrics.savedAgents) {
                    const savedAgentsDefaultFilters = [
                        "savedSearches",
                        "mls",
                        "marketArea",
                        "propertyType",
                        "timeFrame"
                    ];
                    module.searchFilters = module.searchFilters.filter((filter)=>savedAgentsDefaultFilters.includes(filter));
                }
                $6e7b60f5d853bd16$var$resetSelectedSavedSearch(module);
            }), false, "resetSearchCriteria");
        },
        clearSavedAgentsSearch: ()=>{
            set((0, $8cYiI.produce)((state)=>{
                const selectedModule = get().selectedModule;
                const savedAgentsDefaultFilters = [
                    "savedSearches",
                    "mls",
                    "marketArea",
                    "propertyType",
                    "timeFrame"
                ];
                if (selectedModule === (0, $cstaF.modules).proficiencyMetrics.savedAgents) {
                    const module = state[selectedModule];
                    const searchCriteria = module.search?.searchCriteria;
                    const criteria = searchCriteria?.criteria;
                    const realEstateDatasourceIdsWithFilters = criteria?.realEstateDatasourceIdsWithFilters;
                    if (realEstateDatasourceIdsWithFilters) criteria.realEstateDatasourceIdsWithFilters = realEstateDatasourceIdsWithFilters.map((filter)=>({
                            ...filter,
                            searchFields: filter.searchFields?.filter((field)=>savedAgentsDefaultFilters.includes(field.fieldName)) || [],
                            computedFields: [],
                            idFiltering: filter.idFiltering?.filter((idFilter)=>idFilter.idType.toLowerCase() === (0, $cstaF.searchTerms).agentIdType.toLowerCase()) || []
                        }));
                }
            }), false, "clearSavedAgentsSearch");
        },
        clearSavedAgentsOptionalFilterTitles: ()=>{
            set((0, $8cYiI.produce)((state)=>{
                let savedAgentsModule = state[(0, $cstaF.modules).proficiencyMetrics.savedAgents];
                if (savedAgentsModule) savedAgentsModule = {
                    ...savedAgentsModule,
                    totalVolumeTitle: (0, $cstaF.initialOptionalFilterTitles).totalVolumeTitle,
                    soldPriceRangeTitle: (0, $cstaF.initialOptionalFilterTitles).soldPriceRangeTitle,
                    totalUnitsTitle: (0, $cstaF.initialOptionalFilterTitles).totalUnitsTitle,
                    bedroomsTitle: (0, $cstaF.initialOptionalFilterTitles).bedroomsTitle,
                    fullBathroomsTitle: (0, $cstaF.initialOptionalFilterTitles).fullBathroomsTitle
                };
                state[(0, $cstaF.modules).proficiencyMetrics.savedAgents] = savedAgentsModule;
            }), false, "clearSavedAgentsOptionalFilterTitles");
        },
        getSavedSearchList: async (userId)=>{
            try {
                const response = await (0, $lEGzp.getUserSavedSearches)(userId, (0, $dlZsJ.getParentFromValue)((0, $cstaF.modules), get().selectedModule), (0, $cstaF.searchTypes)[(0, $cstaF.moduleRoutes)[get().selectedModule]].type);
                if (!response.error) set((0, $8cYiI.produce)((state)=>{
                    const module = state[get().selectedModule];
                    module.savedSearchList = response?.savedSearches;
                }), false, "getSavedSearchList");
            } catch (err) {
                set({
                    isLoading: false,
                    error: err.message
                });
            }
        },
        setMarketAreaType: (mappedArea)=>{
            set((0, $8cYiI.produce)((state)=>{
                const module = state[get().selectedModule];
                const search = module.search;
                const mls = $5ILgR.default(search.searchCriteria.criteria.realEstateDatasourceIdsWithFilters, (i)=>i.realEstateDatasourceId === search.mlsId);
                // clear existing area selections
                mls.searchFields = mls.searchFields.filter((sf)=>!(0, $cstaF.areaSearchTypes).includes(sf.fieldName));
                mls.searchAllMLS = false;
                mls.searchFields.push({
                    fieldName: (0, $cstaF.areaRequestTypes)[mappedArea.columnName],
                    fieldTypeName: mappedArea.viewName
                });
                module.search = search;
                $6e7b60f5d853bd16$var$resetSelectedSavedSearch(module);
            }));
        },
        setSelectedAreas: ({ fieldName: fieldName, selectedAreas: selectedAreas, listIsDirty: listIsDirty, marketAreaLists: marketAreaLists })=>{
            set((0, $8cYiI.produce)((state)=>{
                const module = state[get().selectedModule];
                const search = module.search;
                const mls = $5ILgR.default(search.searchCriteria.criteria.realEstateDatasourceIdsWithFilters, (i)=>i.realEstateDatasourceId === search.mlsId);
                const marketAreaCriteria = mls.searchFields.find((f)=>f.fieldName === fieldName);
                if (marketAreaCriteria) {
                    marketAreaCriteria.fieldValues = selectedAreas.map((a)=>a.areaValue);
                    if (fieldName === "areaKey" || fieldName === "area2Key") {
                        marketAreaCriteria.fieldValues = selectedAreas.map((a)=>a.areaKey);
                        marketAreaCriteria.fieldValueDescriptions = selectedAreas.map((a)=>a.areaValue);
                    }
                    if (listIsDirty) marketAreaCriteria.savedAreaId = undefined;
                    module.marketAreaTitle = marketAreaCriteria.savedAreaId ? (0, $5269x.getMarketAreaListTitle)(marketAreaLists.find((l)=>l.id === marketAreaCriteria.savedAreaId).name, marketAreaCriteria.fieldTypeName) : (0, $5269x.getMarketAreaTitle)({
                        selectedAreas: [
                            marketAreaCriteria
                        ],
                        module: get().selectedModule
                    });
                    module.search = search;
                }
            }));
        },
        setSelectedOffices: (selectedOffices, listIsDirty, offices)=>{
            set((0, $8cYiI.produce)((state)=>{
                const module = state[get().selectedModule];
                const search = module.search;
                const mls = $5ILgR.default(search.searchCriteria.criteria.realEstateDatasourceIdsWithFilters, (i)=>i.realEstateDatasourceId === search.mlsId);
                const officeCriteria = mls.idFiltering.find((filter)=>filter.idType.toLowerCase() === (0, $cstaF.searchTerms).officeIdType.toLowerCase());
                const selectedOfficeIds = selectedOffices.map((o)=>o.officeId);
                if (officeCriteria) {
                    officeCriteria.idValues = selectedOfficeIds;
                    if (listIsDirty) officeCriteria.listId = undefined;
                } else mls.idFiltering.push({
                    idType: (0, $cstaF.searchTerms).officeIdType,
                    idValues: selectedOfficeIds
                });
                module.officesTitle = (0, $5269x.getOfficesTitle)(selectedOfficeIds, offices);
                module.listIsDirty = listIsDirty;
                $6e7b60f5d853bd16$var$resetSelectedSavedSearch(module);
            }));
        },
        setSelectedAgents: (selectedAgents, listIsDirty)=>{
            set((0, $8cYiI.produce)((state)=>{
                const module = state[get().selectedModule];
                const search = module.search;
                const mls = $5ILgR.default(search.searchCriteria.criteria.realEstateDatasourceIdsWithFilters, (i)=>i.realEstateDatasourceId === search.mlsId);
                const agentCriteria = mls.idFiltering.find((f)=>f.idType.toLowerCase() === (0, $cstaF.searchTerms).agentIdType.toLowerCase());
                if (agentCriteria) agentCriteria.idValues = selectedAgents.map((a)=>a.agentId);
                else mls.idFiltering.push({
                    idType: (0, $cstaF.searchTerms).agentIdType,
                    idValues: selectedAgents.map((a)=>a.agentId)
                });
                module.agentsTitle = (0, $5269x.getAgentsTitle)(selectedAgents);
                module.listIsDirty = listIsDirty;
                $6e7b60f5d853bd16$var$resetSelectedSavedSearch(module);
            }));
        },
        setAgentsTitle: (selectedAgents)=>{
            set((0, $8cYiI.produce)((state)=>{
                const module = state[get().selectedModule];
                module.agentsTitle = (0, $5269x.getAgentsTitle)(selectedAgents);
            }));
        },
        setAllMls: ()=>{
            set((0, $8cYiI.produce)((state)=>{
                const module = state[get().selectedModule];
                const search = module.search;
                const mls = $5ILgR.default(search.searchCriteria.criteria.realEstateDatasourceIdsWithFilters, (i)=>i.realEstateDatasourceId === search.mlsId);
                // clear existing area selections
                mls.searchFields = mls.searchFields.filter((sf)=>!(0, $cstaF.areaSearchTypes).includes(sf.fieldName));
                mls.searchAllMLS = true;
                module.search = search;
                module.marketAreaTitle = (0, $5269x.getMarketAreaTitle)({
                    searchAllMls: true,
                    viewId: module.id
                });
                $6e7b60f5d853bd16$var$resetSelectedSavedSearch(module);
            }));
        },
        setSelectedPropTypes: (selectedPropertyTypes, propTypes)=>{
            set((0, $8cYiI.produce)((state)=>{
                const module = state[get().selectedModule];
                const search = module.search;
                const mls = $5ILgR.default(search.searchCriteria.criteria.realEstateDatasourceIdsWithFilters, (i)=>i.realEstateDatasourceId === search.mlsId);
                mls.searchFields = mls.searchFields.filter((f)=>f.fieldName !== "propertyType");
                if (!selectedPropertyTypes) {
                    module.propertyTypeTitle.mainTitle = (0, $5269x.defaultPropTypeTitle);
                    module.selectedPropTypes = [];
                } else {
                    const fieldValueDescriptions = [];
                    const selectedPropTypes = $3kePu.default(selectedPropertyTypes, (t)=>t.toString());
                    module.selectedPropTypes = [
                        ...selectedPropTypes
                    ];
                    module.propertyTypeTitle = (0, $5269x.getPropertyTypeTitle)(propTypes, module.selectedPropTypes);
                    $fpekr.default(propTypes, (propType)=>{
                        propType.types?.map((type)=>{
                            selectedPropertyTypes.forEach((selectedPropType)=>{
                                if (type.typeId === selectedPropType) fieldValueDescriptions.push(type.longName);
                            });
                        });
                    });
                    mls.searchFields.push({
                        fieldName: "propertyType",
                        fieldValues: [
                            ...$3kePu.default(selectedPropTypes, (t)=>t.toString())
                        ],
                        fieldValueDescriptions: [
                            ...$3kePu.default(fieldValueDescriptions, (t)=>t.toString())
                        ]
                    });
                }
                $6e7b60f5d853bd16$var$resetSelectedSavedSearch(module);
                module.search = search;
            }));
        },
        setTimePeriod: (intervalType, startDate, endDate, timeIntervals)=>{
            set((0, $8cYiI.produce)((state)=>{
                const selectedModule = get().selectedModule;
                const module = state[selectedModule];
                const search = module.search;
                const newTimePeriodCriteria = {
                    intervalType: intervalType
                };
                // add custom dates if applicable
                if (intervalType === (0, $cstaF.TimePeriods)["Custom Date"]) {
                    newTimePeriodCriteria.startDate = startDate;
                    newTimePeriodCriteria.endDate = endDate;
                }
                search.searchCriteria.criteria.timePeriod = newTimePeriodCriteria;
                module.timeFrameTitle = (0, $5269x.getTimeFrameTitle)(newTimePeriodCriteria, timeIntervals, selectedModule);
                module.search = search;
                $6e7b60f5d853bd16$var$resetSelectedSavedSearch(module);
            }));
        },
        updateSearchFilters: (updatedFilters)=>{
            set((0, $8cYiI.produce)((state)=>{
                const selectedModule = get().selectedModule;
                const module = state[selectedModule];
                module.searchFilters = updatedFilters;
            }), false, "updateSearchFilters");
        },
        resetFilter: (type)=>{
            set((0, $8cYiI.produce)((state)=>{
                const selectedModule = get().selectedModule;
                const module = state[selectedModule];
                const search = module.search;
                const mls = $5ILgR.default(search?.searchCriteria.criteria.realEstateDatasourceIdsWithFilters, (i)=>i.realEstateDatasourceId === search.mlsId);
                switch(type){
                    case (0, $cstaF.searchTerms).fullBathroomsFilter:
                        mls.searchFields = mls.searchFields.filter((f)=>f.fieldName !== "fullBathrooms");
                        module.fullBathroomsTitle = (0, $3FMCA.defaultTitles).fullBathroomsTitle;
                        break;
                    case (0, $cstaF.searchTerms).bedroomsFilter:
                        mls.searchFields = mls.searchFields.filter((f)=>f.fieldName !== "bedrooms");
                        module.bedroomsTitle = (0, $3FMCA.defaultTitles).bedroomsTitle;
                        break;
                    case (0, $cstaF.searchTerms).soldPriceFilter:
                        mls.searchFields = mls.searchFields.filter((f)=>f.fieldName !== "soldPrice");
                        module.soldPriceRangeTitle = (0, $3FMCA.defaultTitles).soldPriceRangeTitle;
                        break;
                    case (0, $cstaF.searchTerms).priceRangeFilter:
                        mls.searchFields = mls.searchFields.filter((f)=>f.fieldName !== "lastPrice");
                        module.priceRangeTitle = (0, $3FMCA.defaultTitles).priceRangeTitle;
                        break;
                    case (0, $cstaF.searchTerms).totalUnitsFilter:
                        mls.computedFields = mls.computedFields.filter((f)=>f.fieldName !== "totalUnits");
                        module.totalUnitsTitle = (0, $3FMCA.defaultTitles).totalUnitsTitle;
                        break;
                    case (0, $cstaF.searchTerms).totalVolumeFilter:
                        mls.computedFields = mls.computedFields.filter((f)=>f.fieldName !== "totalVolume");
                        module.totalVolumeTitle = (0, $3FMCA.defaultTitles).totalVolumeTitle;
                        break;
                    case (0, $cstaF.searchTerms).lotSizeFilter:
                        mls.searchFields = mls.searchFields.filter((f)=>!(0, $cstaF.lotSizeTypes).includes(f.fieldName));
                        module.lotSizeTitle = (0, $3FMCA.defaultTitles).lotSizeTitle;
                        break;
                    case (0, $cstaF.searchTerms).squareFootageFilter:
                        mls.searchFields = mls.searchFields.filter((f)=>f.fieldName !== (0, $cstaF.searchTerms).squareFeetFilter);
                        module.squareFootageTitle = (0, $3FMCA.defaultTitles).squareFootageTitle;
                        break;
                    case (0, $cstaF.searchTerms).constructionTypeFilter:
                        mls.searchFields = mls.searchFields.filter((f)=>f.fieldName !== (0, $cstaF.searchTerms).newConstruction);
                        module.constructionTypeTitle = (0, $3FMCA.defaultTitles).constructionTypeTitle;
                        break;
                    case (0, $cstaF.searchTerms).comparisonSetFilter:
                        if (mls?.searchFields) mls.searchFields = mls.searchFields.filter((f)=>f.fieldName !== (0, $cstaF.searchTerms).comparisonSetFilter);
                        module.comparisonSetTitle = (0, $3FMCA.defaultTitles).comparisonSetTitle;
                        break;
                }
            }), false, "resetFilter");
        },
        setTotalVolume: (totalVolume)=>{
            set((0, $8cYiI.produce)((state)=>{
                const selectedModule = get().selectedModule;
                const module = state[selectedModule];
                const search = module.search;
                const mls = $5ILgR.default(search.searchCriteria.criteria.realEstateDatasourceIdsWithFilters, (i)=>i.realEstateDatasourceId === search.mlsId);
                mls.computedFields = mls.computedFields.filter((f)=>f.fieldName !== "totalVolume");
                mls.computedFields.push({
                    fieldName: "totalVolume",
                    ...totalVolume.min && {
                        fieldMinValue: totalVolume.min
                    },
                    ...totalVolume.max && {
                        fieldMaxValue: totalVolume.max
                    }
                });
                module.totalVolumeTitle = (0, $5269x.getRangeTitle)((0, $cstaF.searchTerms).totalVolume, {
                    min: totalVolume.min,
                    max: totalVolume.max
                }, true);
                $6e7b60f5d853bd16$var$resetSelectedSavedSearch(module);
            }));
        },
        setTotalUnits: (totalUnits)=>{
            set((0, $8cYiI.produce)((state)=>{
                const selectedModule = get().selectedModule;
                const module = state[selectedModule];
                const search = module.search;
                const mls = $5ILgR.default(search.searchCriteria.criteria.realEstateDatasourceIdsWithFilters, (i)=>i.realEstateDatasourceId === search.mlsId);
                mls.computedFields = mls.computedFields.filter((f)=>f.fieldName !== "totalUnits");
                mls.computedFields.push({
                    fieldName: "totalUnits",
                    ...totalUnits.min && {
                        fieldMinValue: totalUnits.min
                    },
                    ...totalUnits.max && {
                        fieldMaxValue: totalUnits.max
                    }
                });
                module.totalUnitsTitle = (0, $5269x.getRangeTitle)((0, $cstaF.searchTerms).totalUnits, {
                    min: totalUnits.min,
                    max: totalUnits.max
                }, false);
                $6e7b60f5d853bd16$var$resetSelectedSavedSearch(module);
            }));
        },
        setSoldPrice: (soldPrice)=>{
            set((0, $8cYiI.produce)((state)=>{
                const selectedModule = get().selectedModule;
                const module = state[selectedModule];
                const search = module.search;
                const mls = $5ILgR.default(search.searchCriteria.criteria.realEstateDatasourceIdsWithFilters, (i)=>i.realEstateDatasourceId === search.mlsId);
                mls.searchFields = mls.searchFields.filter((f)=>f.fieldName !== "soldPrice");
                mls.searchFields.push({
                    fieldName: "soldPrice",
                    ...soldPrice.min && {
                        fieldMinValue: soldPrice.min
                    },
                    ...soldPrice.max && {
                        fieldMaxValue: soldPrice.max
                    }
                });
                module.soldPriceRangeTitle = (0, $5269x.getRangeTitle)((0, $cstaF.searchTerms).soldPriceRange, {
                    min: soldPrice.min,
                    max: soldPrice.max
                }, true);
                $6e7b60f5d853bd16$var$resetSelectedSavedSearch(module);
            }));
        },
        setLastPrice: (lastPrice)=>{
            set((0, $8cYiI.produce)((state)=>{
                const selectedModule = get().selectedModule;
                const module = state[selectedModule];
                const search = module.search;
                const mls = $5ILgR.default(search.searchCriteria.criteria.realEstateDatasourceIdsWithFilters, (i)=>i.realEstateDatasourceId === search.mlsId);
                mls.searchFields = mls.searchFields.filter((f)=>f.fieldName !== "lastPrice");
                mls.searchFields.push({
                    fieldName: "lastPrice",
                    ...lastPrice.min && {
                        fieldMinValue: lastPrice.min
                    },
                    ...lastPrice.max && {
                        fieldMaxValue: lastPrice.max
                    }
                });
                module.priceRangeTitle = (0, $5269x.getRangeTitle)((0, $cstaF.searchTerms).priceRange, {
                    min: lastPrice.min,
                    max: lastPrice.max
                }, true);
                $6e7b60f5d853bd16$var$resetSelectedSavedSearch(module);
            }));
        },
        setBathrooms: (bathrooms)=>{
            set((0, $8cYiI.produce)((state)=>{
                const selectedModule = get().selectedModule;
                const module = state[selectedModule];
                const search = module.search;
                const mls = $5ILgR.default(search.searchCriteria.criteria.realEstateDatasourceIdsWithFilters, (i)=>i.realEstateDatasourceId === search.mlsId);
                mls.searchFields = mls.searchFields.filter((f)=>f.fieldName !== "fullBathrooms");
                mls.searchFields.push({
                    fieldName: "fullBathrooms",
                    ...bathrooms.min && {
                        fieldMinValue: bathrooms.min
                    },
                    ...bathrooms.max && {
                        fieldMaxValue: bathrooms.max
                    }
                });
                module.fullBathroomsTitle = (0, $5269x.getRangeTitle)((0, $cstaF.searchTerms).fullBathrooms, {
                    min: bathrooms.min,
                    max: bathrooms.max
                }, false);
                $6e7b60f5d853bd16$var$resetSelectedSavedSearch(module);
            }));
        },
        setBedrooms: (bedrooms)=>{
            set((0, $8cYiI.produce)((state)=>{
                const selectedModule = get().selectedModule;
                const module = state[selectedModule];
                const search = module.search;
                const mls = $5ILgR.default(search.searchCriteria.criteria.realEstateDatasourceIdsWithFilters, (i)=>i.realEstateDatasourceId === search.mlsId);
                mls.searchFields = mls.searchFields.filter((f)=>f.fieldName !== "bedrooms");
                mls.searchFields.push({
                    fieldName: "bedrooms",
                    ...bedrooms.min && {
                        fieldMinValue: bedrooms.min
                    },
                    ...bedrooms.max && {
                        fieldMaxValue: bedrooms.max
                    }
                });
                module.bedroomsTitle = (0, $5269x.getRangeTitle)((0, $cstaF.searchTerms).bedrooms, {
                    min: bedrooms.min,
                    max: bedrooms.max
                }, false);
                $6e7b60f5d853bd16$var$resetSelectedSavedSearch(module);
            }));
        },
        setComparisonSetSearch: (comparisonSet)=>{
            set((0, $8cYiI.produce)((state)=>{
                const selectedModule = get().selectedModule;
                const module = state[selectedModule];
                const search = module.search;
                const mls = $5ILgR.default(search?.searchCriteria?.criteria?.realEstateDatasourceIdsWithFilters, (i)=>i.realEstateDatasourceId === search.mlsId);
                if (!mls) return;
                if (mls.mlsObjectId || comparisonSet?.id) mls.mlsObjectId = comparisonSet?.id;
                module.comparisonSetTitle = {
                    mainTitle: comparisonSet?.name ? comparisonSet.name : (0, $3FMCA.defaultTitles).comparisonSetTitle.mainTitle
                };
                module.selectedComparisonSetSearch = comparisonSet;
            }), false, "setComparisonSetSearch");
        },
        setListingStatus: (listingStatus)=>{
            set((0, $8cYiI.produce)((state)=>{
                const selectedModule = get().selectedModule;
                const module = state[selectedModule];
                const search = module.search;
                const mls = $5ILgR.default(search.searchCriteria.criteria.realEstateDatasourceIdsWithFilters, (i)=>i.realEstateDatasourceId === search.mlsId);
                mls.computedFields = mls.computedFields.filter((f)=>f.fieldName !== (0, $cstaF.searchTerms).transactionStatus);
                mls.computedFields.push({
                    fieldName: (0, $cstaF.searchTerms).transactionStatus,
                    fieldValues: [
                        listingStatus.value
                    ]
                });
                module.listingStatusTitle = {
                    mainTitle: listingStatus.title
                };
                $6e7b60f5d853bd16$var$resetSelectedSavedSearch(module);
            }));
        },
        setConstructionType: (constructionType)=>{
            set((0, $8cYiI.produce)((state)=>{
                const selectedModule = get().selectedModule;
                const module = state[selectedModule];
                const search = module.search;
                const mls = $5ILgR.default(search.searchCriteria.criteria.realEstateDatasourceIdsWithFilters, (i)=>i.realEstateDatasourceId === search.mlsId);
                mls.searchFields = mls.searchFields.filter((f)=>f.fieldName !== (0, $cstaF.searchTerms).newConstruction);
                mls.searchFields.push({
                    fieldName: (0, $cstaF.searchTerms).newConstruction,
                    fieldValues: [
                        (0, $cstaF.constructionTypeMap)[constructionType.value]
                    ]
                });
                module.constructionTypeTitle = {
                    mainTitle: (0, $cstaF.searchTerms).constructionType,
                    subTitle: constructionType.value
                };
                $6e7b60f5d853bd16$var$resetSelectedSavedSearch(module);
            }));
        },
        setLotSize: (lotSize)=>{
            set((0, $8cYiI.produce)((state)=>{
                const selectedModule = get().selectedModule;
                const module = state[selectedModule];
                const search = module.search;
                const mls = $5ILgR.default(search.searchCriteria.criteria.realEstateDatasourceIdsWithFilters, (i)=>i.realEstateDatasourceId === search.mlsId);
                mls.searchFields = mls.searchFields.filter((f)=>!(0, $cstaF.lotSizeTypes).includes(f.fieldName));
                mls.searchFields.push({
                    fieldName: lotSize.measureType === (0, $cstaF.searchTerms).acres.toLowerCase() ? (0, $cstaF.searchTerms).lotSizeAcresFilter : (0, $cstaF.searchTerms).lotSquareFeetFilter,
                    ...lotSize.min && {
                        fieldMinValue: lotSize.min
                    },
                    ...lotSize.max && {
                        fieldMaxValue: lotSize.max
                    }
                });
                module.lotSizeTitle = (0, $5269x.getLotSizeTitle)((0, $cstaF.searchTerms).lotSize, {
                    min: lotSize.min,
                    max: lotSize.max,
                    measureType: lotSize.measureType
                });
                $6e7b60f5d853bd16$var$resetSelectedSavedSearch(module);
            }));
        },
        setSquareFootage: (squareFootage)=>{
            set((0, $8cYiI.produce)((state)=>{
                const selectedModule = get().selectedModule;
                const module = state[selectedModule];
                const search = module.search;
                const mls = $5ILgR.default(search.searchCriteria.criteria.realEstateDatasourceIdsWithFilters, (i)=>i.realEstateDatasourceId === search.mlsId);
                mls.searchFields = mls.searchFields.filter((f)=>f.fieldName !== (0, $cstaF.searchTerms).squareFeetFilter);
                mls.searchFields.push({
                    fieldName: (0, $cstaF.searchTerms).squareFeetFilter,
                    ...squareFootage.min && {
                        fieldMinValue: squareFootage.min
                    },
                    ...squareFootage.max && {
                        fieldMaxValue: squareFootage.max
                    }
                });
                module.squareFootageTitle = (0, $5269x.getRangeTitle)((0, $cstaF.searchTerms).squareFootage, {
                    min: squareFootage.min,
                    max: squareFootage.max
                }, false);
                $6e7b60f5d853bd16$var$resetSelectedSavedSearch(module);
            }));
        },
        setAreaType: (title, areaType)=>{
            set((0, $8cYiI.produce)((state)=>{
                const selectedModule = get().selectedModule;
                const module = state[selectedModule];
                const search = module.search;
                const mls = $5ILgR.default(search.searchCriteria.criteria.realEstateDatasourceIdsWithFilters, (i)=>i.realEstateDatasourceId === search.mlsId);
                mls.computedFields = mls.computedFields.filter((f)=>f.fieldName !== (0, $cstaF.searchTerms).areaTypeFilter);
                mls.computedFields.push({
                    fieldName: (0, $cstaF.searchTerms).areaTypeFilter,
                    fieldValues: [
                        areaType
                    ]
                });
                module.areaTypeTitle = {
                    mainTitle: title
                };
                $6e7b60f5d853bd16$var$resetSelectedSavedSearch(module);
            }));
        },
        setListIsDirty: (isDirty)=>{
            set((0, $8cYiI.produce)((state)=>{
                const selectedModule = get().selectedModule;
                const module = state[selectedModule];
                module.listIsDirty = isDirty;
            }), false, "setListIsDirty");
        },
        setSelectedMarketAreaList: (marketAreaList, selectedSavedSearch)=>{
            set((0, $8cYiI.produce)((state)=>{
                const selectedModule = get().selectedModule;
                const module = state[selectedModule];
                const search = module.search;
                const mls = $5ILgR.default(search.searchCriteria.criteria.realEstateDatasourceIdsWithFilters, (i)=>i.realEstateDatasourceId === search.mlsId);
                const savedSearchAreaId = module.selectedSavedSearch?.savedSearch.searchCriteria.criteria.realEstateDatasourceIdsWithFilters[0].searchFields.find((sf)=>(0, $cstaF.areaSearchTypes).includes(sf.fieldName))?.savedAreaId;
                mls.searchFields = mls.searchFields.filter((sf)=>!(0, $cstaF.areaSearchTypes).includes(sf.fieldName));
                mls.searchAllMLS = false;
                mls.searchFields.push({
                    ...marketAreaList.elements,
                    savedAreaId: marketAreaList.id
                });
                if (selectedSavedSearch && savedSearchAreaId !== marketAreaList.id) $6e7b60f5d853bd16$var$resetSelectedSavedSearch(module);
                module.marketAreaTitle = (0, $5269x.getMarketAreaListTitle)(marketAreaList.name, marketAreaList.elements.fieldTypeName);
            }));
        },
        setSelectedOfficeList: (officeList, selectedSavedSearch)=>{
            set((0, $8cYiI.produce)((state)=>{
                const selectedModule = get().selectedModule;
                const module = state[selectedModule];
                const search = module.search;
                const mls = $5ILgR.default(search.searchCriteria.criteria.realEstateDatasourceIdsWithFilters, (i)=>i.realEstateDatasourceId === search.mlsId);
                const savedSearchListId = module.selectedSavedSearch?.savedSearch.searchCriteria.criteria.realEstateDatasourceIdsWithFilters[0].idFiltering.find((f)=>f.idType.toLowerCase() === (0, $cstaF.searchTerms).officeIdType.toLowerCase()).listId;
                mls.idFiltering = [
                    {
                        idType: (0, $cstaF.searchTerms).officeIdType,
                        idValues: officeList.officeIds,
                        listId: officeList.officeListId
                    }
                ];
                if (selectedSavedSearch && savedSearchListId !== officeList.id) $6e7b60f5d853bd16$var$resetSelectedSavedSearch(module);
                module.selectedOfficeList = officeList.name;
                module.officesTitle = (0, $5269x.getOfficeListTitle)(officeList.name);
            }), false, "setSelectedOfficeList");
        },
        setListInSearchByAgentSearch: (agentList, searchListId)=>{
            set((0, $8cYiI.produce)((state)=>{
                const search = state[(0, $cstaF.modules).proficiencyMetrics.agents].search;
                const mls = $5ILgR.default(search.searchCriteria.criteria.realEstateDatasourceIdsWithFilters, (i)=>i.realEstateDatasourceId === search.mlsId);
                mls.idFiltering = [
                    {
                        idType: (0, $cstaF.searchTerms).agentIdType,
                        idValues: agentList,
                        listId: searchListId
                    }
                ];
            }));
            get().setAgentNameRerunOnLoad(true);
        },
        setSelectedAgentList: (agentList, selectedSavedSearch)=>{
            set((0, $8cYiI.produce)((state)=>{
                const selectedModule = get().selectedModule;
                const module = state[selectedModule];
                const search = module.search;
                const mls = $5ILgR.default(search.searchCriteria.criteria.realEstateDatasourceIdsWithFilters, (i)=>i.realEstateDatasourceId === search.mlsId);
                const savedSearchListId = selectedSavedSearch?.savedSearch.searchCriteria.criteria.realEstateDatasourceIdsWithFilters[0].idFiltering.find((f)=>f.idType.toLowerCase() === (0, $cstaF.searchTerms).agentIdType.toLowerCase()).listId;
                mls.idFiltering = [
                    {
                        idType: (0, $cstaF.searchTerms).agentIdType,
                        idValues: agentList.agentIds,
                        listId: agentList.agentListId
                    }
                ];
                if (selectedSavedSearch && savedSearchListId !== agentList.agentListId) $6e7b60f5d853bd16$var$resetSelectedSavedSearch(module);
            }));
        },
        resetSelectedAgentList: ()=>{
            set((0, $8cYiI.produce)((state)=>{
                const selectedModule = get().selectedModule;
                const module = state[selectedModule];
                const search = module.search;
                const mls = $5ILgR.default(search.searchCriteria.criteria.realEstateDatasourceIdsWithFilters, (i)=>i.realEstateDatasourceId === search.mlsId);
                mls.idFiltering = mls.idFiltering.filter((idFilter)=>idFilter.idType.toLowerCase() !== (0, $cstaF.searchTerms).agentIdType.toLowerCase());
                module.agentsTitle = (0, $3FMCA.defaultTitles).agentsTitle;
            }));
        },
        resetSelectedAgentListTitle: (agentList, selectedAgents)=>{
            set((0, $8cYiI.produce)((state)=>{
                const selectedModule = get().selectedModule;
                const module = state[selectedModule];
                const search = module.search;
                const mls = $5ILgR.default(search.searchCriteria.criteria.realEstateDatasourceIdsWithFilters, (i)=>i.realEstateDatasourceId === search.mlsId);
                module.agentsTitle = (0, $5269x.getAgentsTitle)(selectedAgents);
                mls.idFiltering = mls.idFiltering.filter((idFilter)=>idFilter.idType.toLowerCase() !== (0, $cstaF.searchTerms).agentIdType.toLowerCase());
            }));
        },
        resetSelectedOfficeList: ()=>{
            set((0, $8cYiI.produce)((state)=>{
                const selectedModule = get().selectedModule;
                const module = state[selectedModule];
                const search = module.search;
                const mls = $5ILgR.default(search.searchCriteria.criteria.realEstateDatasourceIdsWithFilters, (i)=>i.realEstateDatasourceId === search.mlsId);
                mls.idFiltering = mls.idFiltering.filter((idFilter)=>idFilter.idType.toLowerCase() !== (0, $cstaF.searchTerms).officeIdType.toLowerCase());
                module.selectedOfficeList = undefined;
                module.officesTitle = (0, $3FMCA.defaultTitles).officesTitle;
            }), false, "resetSelectedOfficeList");
        },
        resetSelectedOfficeListTitle: (officeList, selectedOffices)=>{
            set((0, $8cYiI.produce)((state)=>{
                const selectedModule = get().selectedModule;
                const module = state[selectedModule];
                const search = module.search;
                const mls = $5ILgR.default(search.searchCriteria.criteria.realEstateDatasourceIdsWithFilters, (i)=>i.realEstateDatasourceId === search.mlsId);
                module.selectedOfficeList = undefined;
                module.officesTitle = (0, $5269x.getOfficesTitle)(officeList.officeIds, selectedOffices);
                mls.idFiltering = [
                    {
                        idType: (0, $cstaF.searchTerms).officeIdType,
                        idValues: officeList.officeIds
                    }
                ];
            }));
        },
        setSearchCriteria: (criteria)=>{
            set((0, $8cYiI.produce)((state)=>{
                state[state.selectedModule].search.searchCriteria = criteria;
            }), false, "setSearchCriteria");
        },
        setLoadedSearch: (reset)=>{
            set((0, $8cYiI.produce)((state)=>{
                state[state.selectedModule].loadedSearchCriteria = reset ? undefined : {
                    ...state[state.selectedModule].search?.searchCriteria?.criteria
                };
            }), false, "setLoadedSearch");
        },
        setSearchStatus: (status)=>{
            set((0, $8cYiI.produce)((state)=>{
                state[state.selectedModule].searchStatus = status;
            }), false, "setSearchStatus");
        },
        setTotalsRowData: (soldTotals, keyToStore)=>{
            if (!soldTotals) {
                set((0, $8cYiI.produce)((state)=>{
                    state[state.selectedModule].recruitingSoldTotals = soldTotals;
                }), false, (0, $i1BZc.responseKeys).recruitingSoldTotals);
                return;
            }
            set((0, $8cYiI.produce)((state)=>{
                state[state.selectedModule][keyToStore] = soldTotals;
            }), false, keyToStore);
        },
        setSummaryPinnedData: (view, keyToRead, totalsData)=>{
            if (!view || !(0, $jilhO.pinnedColIds)[view]) return;
            const selectedModule = get().selectedModule;
            const soldTotals = totalsData || get()[selectedModule][keyToRead];
            const summaryPinnedData = (0, $jilhO.getSummaryPinnedData)(soldTotals, view);
            set((0, $8cYiI.produce)((state)=>{
                state[state.selectedModule].summaryPinnedData = summaryPinnedData;
            }), false, "summaryPinnedData");
        },
        setIsLoadingSearchData: (isLoading)=>{
            set({
                isLoadingSearchData: isLoading
            });
        },
        resetStore: ()=>{
            set((0, $jKEVi.initialSearchState)({
                ...(0, $jKEVi.initialView)
            }), false, "resetStore");
        },
        clearAllSearch: ()=>{
            const module = get().selectedModule;
            set((0, $8cYiI.produce)((state)=>{
                const moduleState = {
                    ...state[module]
                };
                state.isLoading = false, state.isLoadingSearchData = false, state.listIsDirty = false, state.shouldCloseChips = true;
                state[module] = {
                    ...moduleState,
                    ...(0, $3FMCA.viewByModule)[module]({
                        ...(0, $jKEVi.initialView)
                    }),
                    searchFilters: moduleState.searchFilters.filter((filterName)=>!(0, $kmjbt.getFiltersByGroupTitle)((0, $4ZFhI.allFilterGroups), (0, $cstaF.searchTerms).optional).includes(filterName)),
                    savedSearchList: moduleState.savedSearchList,
                    loadedSearchCriteria: undefined,
                    selectedMls: undefined,
                    selectedSavedSearch: undefined,
                    search: undefined
                };
                get().resetPersistedData();
            }));
            if (module === (0, $cstaF.modules).proficiencyMetrics.agents) (0, $jpGV2.useSavedAgentsStore).getState().clearSelectedAgentList();
        },
        setShouldCloseChips: (shouldCloseChips)=>set({
                shouldCloseChips: shouldCloseChips
            }, false, "setShouldCloseChips"),
        setAgentNameRerunOnLoad: (shouldAgentNameRerunOnLoad)=>set({
                shouldAgentNameRerunOnLoad: shouldAgentNameRerunOnLoad
            }),
        resetComparisonSetSavedSearch: ()=>{
            set((0, $8cYiI.produce)((state)=>{
                const selectedModule = get().selectedModule;
                const module = state[selectedModule];
                const savedSearchMlsObjectId = module.selectedSavedSearch?.savedSearch?.searchCriteria?.criteria?.realEstateDatasourceIdsWithFilters[0]?.mlsObjectId;
                if (savedSearchMlsObjectId !== module.selectedComparisonSetSearch?.id) $6e7b60f5d853bd16$var$resetSelectedSavedSearch(module);
            }));
        },
        runMarketShareTotalsSearch: async (searchCriteria, setAgentData)=>{
            const selectedModule = get().selectedModule;
            const comparisonSetStore = (0, $ae040.useComparisonSetsStore).getState();
            const isComparisonSetSearch = !!searchCriteria.criteria.realEstateDatasourceIdsWithFilters[0]?.mlsObjectId;
            comparisonSetStore.setIsComparisonSetView(isComparisonSetSearch);
            if (isComparisonSetSearch) {
                const comparionSetSearchResponse = await (0, $luxkV.getComparisonSetResults)(searchCriteria.criteria);
                setAgentData((agentData)=>({
                        ...agentData,
                        [selectedModule]: {
                            officeSearch: undefined,
                            brokerSearch: undefined,
                            comparisonSetSearch: comparionSetSearchResponse
                        }
                    }));
                return;
            }
            const officeSearchResponse = await (0, $luxkV.getTotalsOfficeSearch)(searchCriteria);
            const brokerSearchResponse = await (0, $luxkV.getTotalsBrokerSearch)(searchCriteria);
            if (!officeSearchResponse.error && !brokerSearchResponse.error) setAgentData((agentData)=>({
                    ...agentData,
                    [selectedModule]: {
                        officeSearch: officeSearchResponse,
                        brokerSearch: brokerSearchResponse,
                        comparisonSetSearch: undefined
                    }
                }));
        },
        resetPersistedData: ()=>{
            get().resetPMPersistedData();
            get().resetMSPersistedData();
            get().resetMDPersistedData();
        },
        setShouldShowChart: ()=>{
            set((0, $8cYiI.produce)((state)=>{
                const toggleState = !state[state.selectedModule].shouldShowChart;
                state[state.selectedModule].shouldShowChart = toggleState;
            }), false, "setShouldShowChart");
        }
    });

});
parcelRegister("5ILgR", function(module, exports) {

$parcel$export(module.exports, "default", () => $42a5bada1896155c$export$2e2bcd8739ae039);

var $hw3Be = parcelRequire("hw3Be");

var $f58Tb = parcelRequire("f58Tb");
/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $42a5bada1896155c$var$find = (0, $hw3Be.default)((0, $f58Tb.default));
var $42a5bada1896155c$export$2e2bcd8739ae039 = $42a5bada1896155c$var$find;

});
parcelRegister("hw3Be", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc08379f7dd918be$export$2e2bcd8739ae039);

var $dKmGr = parcelRequire("dKmGr");

var $lAOUf = parcelRequire("lAOUf");

var $8krEv = parcelRequire("8krEv");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $cc08379f7dd918be$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!(0, $lAOUf.default)(collection)) {
            var iteratee = (0, $dKmGr.default)(predicate, 3);
            collection = (0, $8krEv.default)(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
var $cc08379f7dd918be$export$2e2bcd8739ae039 = $cc08379f7dd918be$var$createFind;

});
parcelRegister("dKmGr", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0212ab78648add2$export$2e2bcd8739ae039);

var $3a0Ub = parcelRequire("3a0Ub");

var $dblNV = parcelRequire("dblNV");

var $jSR8v = parcelRequire("jSR8v");

var $hf0C9 = parcelRequire("hf0C9");

var $gFZ2v = parcelRequire("gFZ2v");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $a0212ab78648add2$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return 0, $jSR8v.default;
    if (typeof value == "object") return (0, $hf0C9.default)(value) ? (0, $dblNV.default)(value[0], value[1]) : (0, $3a0Ub.default)(value);
    return (0, $gFZ2v.default)(value);
}
var $a0212ab78648add2$export$2e2bcd8739ae039 = $a0212ab78648add2$var$baseIteratee;

});
parcelRegister("3a0Ub", function(module, exports) {

$parcel$export(module.exports, "default", () => $24d30208023909d0$export$2e2bcd8739ae039);

var $lgJAv = parcelRequire("lgJAv");

var $7H3kZ = parcelRequire("7H3kZ");

var $fgvE4 = parcelRequire("fgvE4");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $24d30208023909d0$var$baseMatches(source) {
    var matchData = (0, $7H3kZ.default)(source);
    if (matchData.length == 1 && matchData[0][2]) return (0, $fgvE4.default)(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || (0, $lgJAv.default)(object, source, matchData);
    };
}
var $24d30208023909d0$export$2e2bcd8739ae039 = $24d30208023909d0$var$baseMatches;

});
parcelRegister("lgJAv", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7be745fcdc67850$export$2e2bcd8739ae039);

var $9WjpT = parcelRequire("9WjpT");

var $h2imA = parcelRequire("h2imA");
/** Used to compose bitmasks for value comparisons. */ var $f7be745fcdc67850$var$COMPARE_PARTIAL_FLAG = 1, $f7be745fcdc67850$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $f7be745fcdc67850$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new (0, $9WjpT.default);
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? (0, $h2imA.default)(srcValue, objValue, $f7be745fcdc67850$var$COMPARE_PARTIAL_FLAG | $f7be745fcdc67850$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
var $f7be745fcdc67850$export$2e2bcd8739ae039 = $f7be745fcdc67850$var$baseIsMatch;

});
parcelRegister("h2imA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c670de299407e555$export$2e2bcd8739ae039);

var $jneo7 = parcelRequire("jneo7");

var $f2iog = parcelRequire("f2iog");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $c670de299407e555$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !(0, $f2iog.default)(value) && !(0, $f2iog.default)(other)) return value !== value && other !== other;
    return (0, $jneo7.default)(value, other, bitmask, customizer, $c670de299407e555$var$baseIsEqual, stack);
}
var $c670de299407e555$export$2e2bcd8739ae039 = $c670de299407e555$var$baseIsEqual;

});
parcelRegister("jneo7", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1ab537c68aa36d5$export$2e2bcd8739ae039);

var $9WjpT = parcelRequire("9WjpT");

var $etcwV = parcelRequire("etcwV");

var $alETr = parcelRequire("alETr");

var $517wt = parcelRequire("517wt");

var $4wkSQ = parcelRequire("4wkSQ");

var $hf0C9 = parcelRequire("hf0C9");

var $f3ZL4 = parcelRequire("f3ZL4");

var $cmTeE = parcelRequire("cmTeE");
/** Used to compose bitmasks for value comparisons. */ var $e1ab537c68aa36d5$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $e1ab537c68aa36d5$var$argsTag = "[object Arguments]", $e1ab537c68aa36d5$var$arrayTag = "[object Array]", $e1ab537c68aa36d5$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $e1ab537c68aa36d5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e1ab537c68aa36d5$var$hasOwnProperty = $e1ab537c68aa36d5$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $e1ab537c68aa36d5$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = (0, $hf0C9.default)(object), othIsArr = (0, $hf0C9.default)(other), objTag = objIsArr ? $e1ab537c68aa36d5$var$arrayTag : (0, $4wkSQ.default)(object), othTag = othIsArr ? $e1ab537c68aa36d5$var$arrayTag : (0, $4wkSQ.default)(other);
    objTag = objTag == $e1ab537c68aa36d5$var$argsTag ? $e1ab537c68aa36d5$var$objectTag : objTag;
    othTag = othTag == $e1ab537c68aa36d5$var$argsTag ? $e1ab537c68aa36d5$var$objectTag : othTag;
    var objIsObj = objTag == $e1ab537c68aa36d5$var$objectTag, othIsObj = othTag == $e1ab537c68aa36d5$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && (0, $f3ZL4.default)(object)) {
        if (!(0, $f3ZL4.default)(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new (0, $9WjpT.default));
        return objIsArr || (0, $cmTeE.default)(object) ? (0, $etcwV.default)(object, other, bitmask, customizer, equalFunc, stack) : (0, $alETr.default)(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $e1ab537c68aa36d5$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $e1ab537c68aa36d5$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $e1ab537c68aa36d5$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new (0, $9WjpT.default));
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new (0, $9WjpT.default));
    return (0, $517wt.default)(object, other, bitmask, customizer, equalFunc, stack);
}
var $e1ab537c68aa36d5$export$2e2bcd8739ae039 = $e1ab537c68aa36d5$var$baseIsEqualDeep;

});
parcelRegister("etcwV", function(module, exports) {

$parcel$export(module.exports, "default", () => $a88d7e53afca3b5f$export$2e2bcd8739ae039);

var $dTR92 = parcelRequire("dTR92");

var $8v1iI = parcelRequire("8v1iI");

var $lEs8E = parcelRequire("lEs8E");
/** Used to compose bitmasks for value comparisons. */ var $a88d7e53afca3b5f$var$COMPARE_PARTIAL_FLAG = 1, $a88d7e53afca3b5f$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $a88d7e53afca3b5f$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $a88d7e53afca3b5f$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $a88d7e53afca3b5f$var$COMPARE_UNORDERED_FLAG ? new (0, $dTR92.default) : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!(0, $8v1iI.default)(other, function(othValue, othIndex) {
                if (!(0, $lEs8E.default)(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
var $a88d7e53afca3b5f$export$2e2bcd8739ae039 = $a88d7e53afca3b5f$var$equalArrays;

});
parcelRegister("dTR92", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1e9a2ddf37e1e25$export$2e2bcd8739ae039);

var $7n3PR = parcelRequire("7n3PR");

var $j3oih = parcelRequire("j3oih");

var $ebCAc = parcelRequire("ebCAc");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $a1e9a2ddf37e1e25$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new (0, $7n3PR.default);
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$a1e9a2ddf37e1e25$var$SetCache.prototype.add = $a1e9a2ddf37e1e25$var$SetCache.prototype.push = (0, $j3oih.default);
$a1e9a2ddf37e1e25$var$SetCache.prototype.has = (0, $ebCAc.default);
var $a1e9a2ddf37e1e25$export$2e2bcd8739ae039 = $a1e9a2ddf37e1e25$var$SetCache;

});
parcelRegister("j3oih", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddf12460e0325b87$export$2e2bcd8739ae039);
/** Used to stand-in for `undefined` hash values. */ var $ddf12460e0325b87$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $ddf12460e0325b87$var$setCacheAdd(value) {
    this.__data__.set(value, $ddf12460e0325b87$var$HASH_UNDEFINED);
    return this;
}
var $ddf12460e0325b87$export$2e2bcd8739ae039 = $ddf12460e0325b87$var$setCacheAdd;

});

parcelRegister("ebCAc", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5400587c2b0dcec$export$2e2bcd8739ae039);
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */ function $a5400587c2b0dcec$var$setCacheHas(value) {
    return this.__data__.has(value);
}
var $a5400587c2b0dcec$export$2e2bcd8739ae039 = $a5400587c2b0dcec$var$setCacheHas;

});


parcelRegister("8v1iI", function(module, exports) {

$parcel$export(module.exports, "default", () => $63023a486d78f8d1$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $63023a486d78f8d1$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
var $63023a486d78f8d1$export$2e2bcd8739ae039 = $63023a486d78f8d1$var$arraySome;

});

parcelRegister("lEs8E", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc33292595196d6a$export$2e2bcd8739ae039);
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $fc33292595196d6a$var$cacheHas(cache, key) {
    return cache.has(key);
}
var $fc33292595196d6a$export$2e2bcd8739ae039 = $fc33292595196d6a$var$cacheHas;

});


parcelRegister("alETr", function(module, exports) {

$parcel$export(module.exports, "default", () => $788b9615ccc4ea9d$export$2e2bcd8739ae039);

var $kRxPv = parcelRequire("kRxPv");

var $dJVnF = parcelRequire("dJVnF");

var $lvgV1 = parcelRequire("lvgV1");

var $etcwV = parcelRequire("etcwV");

var $7YTsx = parcelRequire("7YTsx");

var $827W0 = parcelRequire("827W0");
/** Used to compose bitmasks for value comparisons. */ var $788b9615ccc4ea9d$var$COMPARE_PARTIAL_FLAG = 1, $788b9615ccc4ea9d$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $788b9615ccc4ea9d$var$boolTag = "[object Boolean]", $788b9615ccc4ea9d$var$dateTag = "[object Date]", $788b9615ccc4ea9d$var$errorTag = "[object Error]", $788b9615ccc4ea9d$var$mapTag = "[object Map]", $788b9615ccc4ea9d$var$numberTag = "[object Number]", $788b9615ccc4ea9d$var$regexpTag = "[object RegExp]", $788b9615ccc4ea9d$var$setTag = "[object Set]", $788b9615ccc4ea9d$var$stringTag = "[object String]", $788b9615ccc4ea9d$var$symbolTag = "[object Symbol]";
var $788b9615ccc4ea9d$var$arrayBufferTag = "[object ArrayBuffer]", $788b9615ccc4ea9d$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $788b9615ccc4ea9d$var$symbolProto = (0, $kRxPv.default) ? (0, $kRxPv.default).prototype : undefined, $788b9615ccc4ea9d$var$symbolValueOf = $788b9615ccc4ea9d$var$symbolProto ? $788b9615ccc4ea9d$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $788b9615ccc4ea9d$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $788b9615ccc4ea9d$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $788b9615ccc4ea9d$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new (0, $dJVnF.default)(object), new (0, $dJVnF.default)(other))) return false;
            return true;
        case $788b9615ccc4ea9d$var$boolTag:
        case $788b9615ccc4ea9d$var$dateTag:
        case $788b9615ccc4ea9d$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return (0, $lvgV1.default)(+object, +other);
        case $788b9615ccc4ea9d$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $788b9615ccc4ea9d$var$regexpTag:
        case $788b9615ccc4ea9d$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $788b9615ccc4ea9d$var$mapTag:
            var convert = (0, $7YTsx.default);
        case $788b9615ccc4ea9d$var$setTag:
            var isPartial = bitmask & $788b9615ccc4ea9d$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = (0, $827W0.default));
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $788b9615ccc4ea9d$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = (0, $etcwV.default)(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $788b9615ccc4ea9d$var$symbolTag:
            if ($788b9615ccc4ea9d$var$symbolValueOf) return $788b9615ccc4ea9d$var$symbolValueOf.call(object) == $788b9615ccc4ea9d$var$symbolValueOf.call(other);
    }
    return false;
}
var $788b9615ccc4ea9d$export$2e2bcd8739ae039 = $788b9615ccc4ea9d$var$equalByTag;

});
parcelRegister("7YTsx", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cf92809ef98e399$export$2e2bcd8739ae039);
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $5cf92809ef98e399$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
var $5cf92809ef98e399$export$2e2bcd8739ae039 = $5cf92809ef98e399$var$mapToArray;

});

parcelRegister("827W0", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d94aa434317cc8a$export$2e2bcd8739ae039);
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $5d94aa434317cc8a$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
var $5d94aa434317cc8a$export$2e2bcd8739ae039 = $5d94aa434317cc8a$var$setToArray;

});


parcelRegister("517wt", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a72e1a244e07566$export$2e2bcd8739ae039);

var $oK0lo = parcelRequire("oK0lo");
/** Used to compose bitmasks for value comparisons. */ var $3a72e1a244e07566$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $3a72e1a244e07566$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3a72e1a244e07566$var$hasOwnProperty = $3a72e1a244e07566$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $3a72e1a244e07566$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $3a72e1a244e07566$var$COMPARE_PARTIAL_FLAG, objProps = (0, $oK0lo.default)(object), objLength = objProps.length, othProps = (0, $oK0lo.default)(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $3a72e1a244e07566$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
var $3a72e1a244e07566$export$2e2bcd8739ae039 = $3a72e1a244e07566$var$equalObjects;

});




parcelRegister("7H3kZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $599f234e9e3f0f59$export$2e2bcd8739ae039);

var $jfIsX = parcelRequire("jfIsX");

var $8krEv = parcelRequire("8krEv");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $599f234e9e3f0f59$var$getMatchData(object) {
    var result = (0, $8krEv.default)(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            (0, $jfIsX.default)(value)
        ];
    }
    return result;
}
var $599f234e9e3f0f59$export$2e2bcd8739ae039 = $599f234e9e3f0f59$var$getMatchData;

});
parcelRegister("jfIsX", function(module, exports) {

$parcel$export(module.exports, "default", () => $e041e90de407bce3$export$2e2bcd8739ae039);

var $iYDsF = parcelRequire("iYDsF");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $e041e90de407bce3$var$isStrictComparable(value) {
    return value === value && !(0, $iYDsF.default)(value);
}
var $e041e90de407bce3$export$2e2bcd8739ae039 = $e041e90de407bce3$var$isStrictComparable;

});


parcelRegister("fgvE4", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1d0e5b68de69e09$export$2e2bcd8739ae039);
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $b1d0e5b68de69e09$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
var $b1d0e5b68de69e09$export$2e2bcd8739ae039 = $b1d0e5b68de69e09$var$matchesStrictComparable;

});


parcelRegister("dblNV", function(module, exports) {

$parcel$export(module.exports, "default", () => $998d375609b22804$export$2e2bcd8739ae039);

var $h2imA = parcelRequire("h2imA");

var $kWunJ = parcelRequire("kWunJ");

var $cMLDw = parcelRequire("cMLDw");

var $6f10l = parcelRequire("6f10l");

var $jfIsX = parcelRequire("jfIsX");

var $fgvE4 = parcelRequire("fgvE4");

var $ft2bY = parcelRequire("ft2bY");
/** Used to compose bitmasks for value comparisons. */ var $998d375609b22804$var$COMPARE_PARTIAL_FLAG = 1, $998d375609b22804$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $998d375609b22804$var$baseMatchesProperty(path, srcValue) {
    if ((0, $6f10l.default)(path) && (0, $jfIsX.default)(srcValue)) return (0, $fgvE4.default)((0, $ft2bY.default)(path), srcValue);
    return function(object) {
        var objValue = (0, $kWunJ.default)(object, path);
        return objValue === undefined && objValue === srcValue ? (0, $cMLDw.default)(object, path) : (0, $h2imA.default)(srcValue, objValue, $998d375609b22804$var$COMPARE_PARTIAL_FLAG | $998d375609b22804$var$COMPARE_UNORDERED_FLAG);
    };
}
var $998d375609b22804$export$2e2bcd8739ae039 = $998d375609b22804$var$baseMatchesProperty;

});
parcelRegister("kWunJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3f0ca997cdf37f0$export$2e2bcd8739ae039);

var $foHRp = parcelRequire("foHRp");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $f3f0ca997cdf37f0$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : (0, $foHRp.default)(object, path);
    return result === undefined ? defaultValue : result;
}
var $f3f0ca997cdf37f0$export$2e2bcd8739ae039 = $f3f0ca997cdf37f0$var$get;

});
parcelRegister("foHRp", function(module, exports) {

$parcel$export(module.exports, "default", () => $b35b1eb26f74d6d6$export$2e2bcd8739ae039);

var $dUJCp = parcelRequire("dUJCp");

var $ft2bY = parcelRequire("ft2bY");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $b35b1eb26f74d6d6$var$baseGet(object, path) {
    path = (0, $dUJCp.default)(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[(0, $ft2bY.default)(path[index++])];
    return index && index == length ? object : undefined;
}
var $b35b1eb26f74d6d6$export$2e2bcd8739ae039 = $b35b1eb26f74d6d6$var$baseGet;

});
parcelRegister("dUJCp", function(module, exports) {

$parcel$export(module.exports, "default", () => $a213e439f16f86c2$export$2e2bcd8739ae039);

var $hf0C9 = parcelRequire("hf0C9");

var $6f10l = parcelRequire("6f10l");

var $6D9Aa = parcelRequire("6D9Aa");

var $1fnxW = parcelRequire("1fnxW");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $a213e439f16f86c2$var$castPath(value, object) {
    if ((0, $hf0C9.default)(value)) return value;
    return (0, $6f10l.default)(value, object) ? [
        value
    ] : (0, $6D9Aa.default)((0, $1fnxW.default)(value));
}
var $a213e439f16f86c2$export$2e2bcd8739ae039 = $a213e439f16f86c2$var$castPath;

});
parcelRegister("6f10l", function(module, exports) {

$parcel$export(module.exports, "default", () => $48b4ec444ff09357$export$2e2bcd8739ae039);

var $hf0C9 = parcelRequire("hf0C9");

var $1WN0o = parcelRequire("1WN0o");
/** Used to match property names within property paths. */ var $48b4ec444ff09357$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $48b4ec444ff09357$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $48b4ec444ff09357$var$isKey(value, object) {
    if ((0, $hf0C9.default)(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || (0, $1WN0o.default)(value)) return true;
    return $48b4ec444ff09357$var$reIsPlainProp.test(value) || !$48b4ec444ff09357$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
var $48b4ec444ff09357$export$2e2bcd8739ae039 = $48b4ec444ff09357$var$isKey;

});

parcelRegister("6D9Aa", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d3dd1738f3a2bd9$export$2e2bcd8739ae039);

var $bOE4H = parcelRequire("bOE4H");
/** Used to match property names within property paths. */ var $4d3dd1738f3a2bd9$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $4d3dd1738f3a2bd9$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $4d3dd1738f3a2bd9$var$stringToPath = (0, $bOE4H.default)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($4d3dd1738f3a2bd9$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($4d3dd1738f3a2bd9$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
var $4d3dd1738f3a2bd9$export$2e2bcd8739ae039 = $4d3dd1738f3a2bd9$var$stringToPath;

});
parcelRegister("bOE4H", function(module, exports) {

$parcel$export(module.exports, "default", () => $89a3733fc9405b69$export$2e2bcd8739ae039);

var $e21Zk = parcelRequire("e21Zk");
/** Used as the maximum memoize cache size. */ var $89a3733fc9405b69$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $89a3733fc9405b69$var$memoizeCapped(func) {
    var result = (0, $e21Zk.default)(func, function(key) {
        if (cache.size === $89a3733fc9405b69$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $89a3733fc9405b69$export$2e2bcd8739ae039 = $89a3733fc9405b69$var$memoizeCapped;

});
parcelRegister("e21Zk", function(module, exports) {

$parcel$export(module.exports, "default", () => $a372cb680e5e1128$export$2e2bcd8739ae039);

var $7n3PR = parcelRequire("7n3PR");
/** Error message constants. */ var $a372cb680e5e1128$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $a372cb680e5e1128$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($a372cb680e5e1128$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($a372cb680e5e1128$var$memoize.Cache || (0, $7n3PR.default));
    return memoized;
}
// Expose `MapCache`.
$a372cb680e5e1128$var$memoize.Cache = (0, $7n3PR.default);
var $a372cb680e5e1128$export$2e2bcd8739ae039 = $a372cb680e5e1128$var$memoize;

});



parcelRegister("1fnxW", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e8974ff738aca49$export$2e2bcd8739ae039);

var $5sJxm = parcelRequire("5sJxm");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $0e8974ff738aca49$var$toString(value) {
    return value == null ? "" : (0, $5sJxm.default)(value);
}
var $0e8974ff738aca49$export$2e2bcd8739ae039 = $0e8974ff738aca49$var$toString;

});
parcelRegister("5sJxm", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fa2e3fba0ff938d$export$2e2bcd8739ae039);

var $kRxPv = parcelRequire("kRxPv");

var $afgje = parcelRequire("afgje");

var $hf0C9 = parcelRequire("hf0C9");

var $1WN0o = parcelRequire("1WN0o");
/** Used as references for various `Number` constants. */ var $3fa2e3fba0ff938d$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $3fa2e3fba0ff938d$var$symbolProto = (0, $kRxPv.default) ? (0, $kRxPv.default).prototype : undefined, $3fa2e3fba0ff938d$var$symbolToString = $3fa2e3fba0ff938d$var$symbolProto ? $3fa2e3fba0ff938d$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $3fa2e3fba0ff938d$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ((0, $hf0C9.default)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $afgje.default)(value, $3fa2e3fba0ff938d$var$baseToString) + "";
    if ((0, $1WN0o.default)(value)) return $3fa2e3fba0ff938d$var$symbolToString ? $3fa2e3fba0ff938d$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$3fa2e3fba0ff938d$var$INFINITY ? "-0" : result;
}
var $3fa2e3fba0ff938d$export$2e2bcd8739ae039 = $3fa2e3fba0ff938d$var$baseToString;

});
parcelRegister("afgje", function(module, exports) {

$parcel$export(module.exports, "default", () => $7757f4c9b8d2d7a9$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $7757f4c9b8d2d7a9$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $7757f4c9b8d2d7a9$export$2e2bcd8739ae039 = $7757f4c9b8d2d7a9$var$arrayMap;

});




parcelRegister("ft2bY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b42b43c5a84e61a9$export$2e2bcd8739ae039);

var $1WN0o = parcelRequire("1WN0o");
/** Used as references for various `Number` constants. */ var $b42b43c5a84e61a9$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $b42b43c5a84e61a9$var$toKey(value) {
    if (typeof value == "string" || (0, $1WN0o.default)(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$b42b43c5a84e61a9$var$INFINITY ? "-0" : result;
}
var $b42b43c5a84e61a9$export$2e2bcd8739ae039 = $b42b43c5a84e61a9$var$toKey;

});



parcelRegister("cMLDw", function(module, exports) {

$parcel$export(module.exports, "default", () => $94eeeb5c0678fbac$export$2e2bcd8739ae039);

var $kyik6 = parcelRequire("kyik6");

var $3AXYs = parcelRequire("3AXYs");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $94eeeb5c0678fbac$var$hasIn(object, path) {
    return object != null && (0, $3AXYs.default)(object, path, (0, $kyik6.default));
}
var $94eeeb5c0678fbac$export$2e2bcd8739ae039 = $94eeeb5c0678fbac$var$hasIn;

});
parcelRegister("kyik6", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef65323979230da4$export$2e2bcd8739ae039);
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $ef65323979230da4$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
var $ef65323979230da4$export$2e2bcd8739ae039 = $ef65323979230da4$var$baseHasIn;

});

parcelRegister("3AXYs", function(module, exports) {

$parcel$export(module.exports, "default", () => $29e34186fa753d89$export$2e2bcd8739ae039);

var $dUJCp = parcelRequire("dUJCp");

var $5VdmZ = parcelRequire("5VdmZ");

var $hf0C9 = parcelRequire("hf0C9");

var $cBYZY = parcelRequire("cBYZY");

var $idNmI = parcelRequire("idNmI");

var $ft2bY = parcelRequire("ft2bY");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $29e34186fa753d89$var$hasPath(object, path, hasFunc) {
    path = (0, $dUJCp.default)(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = (0, $ft2bY.default)(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && (0, $idNmI.default)(length) && (0, $cBYZY.default)(key, length) && ((0, $hf0C9.default)(object) || (0, $5VdmZ.default)(object));
}
var $29e34186fa753d89$export$2e2bcd8739ae039 = $29e34186fa753d89$var$hasPath;

});



parcelRegister("jSR8v", function(module, exports) {

$parcel$export(module.exports, "default", () => $e79c473b2396ff2f$export$2e2bcd8739ae039);
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $e79c473b2396ff2f$var$identity(value) {
    return value;
}
var $e79c473b2396ff2f$export$2e2bcd8739ae039 = $e79c473b2396ff2f$var$identity;

});

parcelRegister("gFZ2v", function(module, exports) {

$parcel$export(module.exports, "default", () => $c23fd2d05c98c812$export$2e2bcd8739ae039);

var $7cEkV = parcelRequire("7cEkV");

var $axdWU = parcelRequire("axdWU");

var $6f10l = parcelRequire("6f10l");

var $ft2bY = parcelRequire("ft2bY");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $c23fd2d05c98c812$var$property(path) {
    return (0, $6f10l.default)(path) ? (0, $7cEkV.default)((0, $ft2bY.default)(path)) : (0, $axdWU.default)(path);
}
var $c23fd2d05c98c812$export$2e2bcd8739ae039 = $c23fd2d05c98c812$var$property;

});
parcelRegister("7cEkV", function(module, exports) {

$parcel$export(module.exports, "default", () => $53e8f161f80fe1f1$export$2e2bcd8739ae039);
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $53e8f161f80fe1f1$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
var $53e8f161f80fe1f1$export$2e2bcd8739ae039 = $53e8f161f80fe1f1$var$baseProperty;

});

parcelRegister("axdWU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ab7ce7ad108fa99$export$2e2bcd8739ae039);

var $foHRp = parcelRequire("foHRp");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $7ab7ce7ad108fa99$var$basePropertyDeep(path) {
    return function(object) {
        return (0, $foHRp.default)(object, path);
    };
}
var $7ab7ce7ad108fa99$export$2e2bcd8739ae039 = $7ab7ce7ad108fa99$var$basePropertyDeep;

});




parcelRegister("f58Tb", function(module, exports) {

$parcel$export(module.exports, "default", () => $afae37cffa73d900$export$2e2bcd8739ae039);

var $38tNx = parcelRequire("38tNx");

var $dKmGr = parcelRequire("dKmGr");

var $bj7KL = parcelRequire("bj7KL");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $afae37cffa73d900$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $afae37cffa73d900$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : (0, $bj7KL.default)(fromIndex);
    if (index < 0) index = $afae37cffa73d900$var$nativeMax(length + index, 0);
    return (0, $38tNx.default)(array, (0, $dKmGr.default)(predicate, 3), index);
}
var $afae37cffa73d900$export$2e2bcd8739ae039 = $afae37cffa73d900$var$findIndex;

});
parcelRegister("38tNx", function(module, exports) {

$parcel$export(module.exports, "default", () => $24893bb682afffd8$export$2e2bcd8739ae039);
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $24893bb682afffd8$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
var $24893bb682afffd8$export$2e2bcd8739ae039 = $24893bb682afffd8$var$baseFindIndex;

});

parcelRegister("bj7KL", function(module, exports) {

$parcel$export(module.exports, "default", () => $83b77baf04e9e448$export$2e2bcd8739ae039);

var $7exj4 = parcelRequire("7exj4");
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $83b77baf04e9e448$var$toInteger(value) {
    var result = (0, $7exj4.default)(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
var $83b77baf04e9e448$export$2e2bcd8739ae039 = $83b77baf04e9e448$var$toInteger;

});
parcelRegister("7exj4", function(module, exports) {

$parcel$export(module.exports, "default", () => $5443ad2f6d2956e1$export$2e2bcd8739ae039);

var $1fkDi = parcelRequire("1fkDi");
/** Used as references for various `Number` constants. */ var $5443ad2f6d2956e1$var$INFINITY = 1 / 0, $5443ad2f6d2956e1$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $5443ad2f6d2956e1$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = (0, $1fkDi.default)(value);
    if (value === $5443ad2f6d2956e1$var$INFINITY || value === -$5443ad2f6d2956e1$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $5443ad2f6d2956e1$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
var $5443ad2f6d2956e1$export$2e2bcd8739ae039 = $5443ad2f6d2956e1$var$toFinite;

});




parcelRegister("fpekr", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3744e2f16a7bb6d$export$2e2bcd8739ae039);

var $iDECW = parcelRequire("iDECW");

var $irzyZ = parcelRequire("irzyZ");

var $lmrTu = parcelRequire("lmrTu");

var $hf0C9 = parcelRequire("hf0C9");
/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $b3744e2f16a7bb6d$var$forEach(collection, iteratee) {
    var func = (0, $hf0C9.default)(collection) ? (0, $iDECW.default) : (0, $irzyZ.default);
    return func(collection, (0, $lmrTu.default)(iteratee));
}
var $b3744e2f16a7bb6d$export$2e2bcd8739ae039 = $b3744e2f16a7bb6d$var$forEach;

});
parcelRegister("irzyZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6d655c33eaad986$export$2e2bcd8739ae039);

var $by0Fh = parcelRequire("by0Fh");

var $b5f7h = parcelRequire("b5f7h");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $d6d655c33eaad986$var$baseEach = (0, $b5f7h.default)((0, $by0Fh.default));
var $d6d655c33eaad986$export$2e2bcd8739ae039 = $d6d655c33eaad986$var$baseEach;

});
parcelRegister("by0Fh", function(module, exports) {

$parcel$export(module.exports, "default", () => $868362ae4d3d3a88$export$2e2bcd8739ae039);

var $RlazS = parcelRequire("RlazS");

var $8krEv = parcelRequire("8krEv");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $868362ae4d3d3a88$var$baseForOwn(object, iteratee) {
    return object && (0, $RlazS.default)(object, iteratee, (0, $8krEv.default));
}
var $868362ae4d3d3a88$export$2e2bcd8739ae039 = $868362ae4d3d3a88$var$baseForOwn;

});
parcelRegister("RlazS", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a055f31ee6b9615$export$2e2bcd8739ae039);

var $XI7zJ = parcelRequire("XI7zJ");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $0a055f31ee6b9615$var$baseFor = (0, $XI7zJ.default)();
var $0a055f31ee6b9615$export$2e2bcd8739ae039 = $0a055f31ee6b9615$var$baseFor;

});
parcelRegister("XI7zJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b37bc59bcb3fc9f$export$2e2bcd8739ae039);
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $0b37bc59bcb3fc9f$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
var $0b37bc59bcb3fc9f$export$2e2bcd8739ae039 = $0b37bc59bcb3fc9f$var$createBaseFor;

});



parcelRegister("b5f7h", function(module, exports) {

$parcel$export(module.exports, "default", () => $811be325f80aa79f$export$2e2bcd8739ae039);

var $lAOUf = parcelRequire("lAOUf");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $811be325f80aa79f$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!(0, $lAOUf.default)(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
var $811be325f80aa79f$export$2e2bcd8739ae039 = $811be325f80aa79f$var$createBaseEach;

});


parcelRegister("lmrTu", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8d14a3c0f7c8cd0$export$2e2bcd8739ae039);

var $jSR8v = parcelRequire("jSR8v");
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $f8d14a3c0f7c8cd0$var$castFunction(value) {
    return typeof value == "function" ? value : (0, $jSR8v.default);
}
var $f8d14a3c0f7c8cd0$export$2e2bcd8739ae039 = $f8d14a3c0f7c8cd0$var$castFunction;

});


parcelRegister("3kePu", function(module, exports) {

$parcel$export(module.exports, "default", () => $26bebe30abf83879$export$2e2bcd8739ae039);

var $afgje = parcelRequire("afgje");

var $dKmGr = parcelRequire("dKmGr");

var $7dWrG = parcelRequire("7dWrG");

var $hf0C9 = parcelRequire("hf0C9");
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $26bebe30abf83879$var$map(collection, iteratee) {
    var func = (0, $hf0C9.default)(collection) ? (0, $afgje.default) : (0, $7dWrG.default);
    return func(collection, (0, $dKmGr.default)(iteratee, 3));
}
var $26bebe30abf83879$export$2e2bcd8739ae039 = $26bebe30abf83879$var$map;

});
parcelRegister("7dWrG", function(module, exports) {

$parcel$export(module.exports, "default", () => $5427155e39bdb121$export$2e2bcd8739ae039);

var $irzyZ = parcelRequire("irzyZ");

var $lAOUf = parcelRequire("lAOUf");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $5427155e39bdb121$var$baseMap(collection, iteratee) {
    var index = -1, result = (0, $lAOUf.default)(collection) ? Array(collection.length) : [];
    (0, $irzyZ.default)(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
var $5427155e39bdb121$export$2e2bcd8739ae039 = $5427155e39bdb121$var$baseMap;

});


parcelRegister("69p3P", function(module, exports) {

$parcel$export(module.exports, "default", () => $47a705e7a0941da7$export$2e2bcd8739ae039);

var $afgje = parcelRequire("afgje");

var $gbpSA = parcelRequire("gbpSA");

var $iPtpn = parcelRequire("iPtpn");

var $dUJCp = parcelRequire("dUJCp");

var $3Wzdm = parcelRequire("3Wzdm");

var $b99Lb = parcelRequire("b99Lb");

var $1GImM = parcelRequire("1GImM");

var $7bulh = parcelRequire("7bulh");
/** Used to compose bitmasks for cloning. */ var $47a705e7a0941da7$var$CLONE_DEEP_FLAG = 1, $47a705e7a0941da7$var$CLONE_FLAT_FLAG = 2, $47a705e7a0941da7$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */ var $47a705e7a0941da7$var$omit = (0, $1GImM.default)(function(object, paths) {
    var result = {};
    if (object == null) return result;
    var isDeep = false;
    paths = (0, $afgje.default)(paths, function(path) {
        path = (0, $dUJCp.default)(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
    });
    (0, $3Wzdm.default)(object, (0, $7bulh.default)(object), result);
    if (isDeep) result = (0, $gbpSA.default)(result, $47a705e7a0941da7$var$CLONE_DEEP_FLAG | $47a705e7a0941da7$var$CLONE_FLAT_FLAG | $47a705e7a0941da7$var$CLONE_SYMBOLS_FLAG, (0, $b99Lb.default));
    var length = paths.length;
    while(length--)(0, $iPtpn.default)(result, paths[length]);
    return result;
});
var $47a705e7a0941da7$export$2e2bcd8739ae039 = $47a705e7a0941da7$var$omit;

});
parcelRegister("iPtpn", function(module, exports) {

$parcel$export(module.exports, "default", () => $db53cd4f4a1bcb9c$export$2e2bcd8739ae039);

var $dUJCp = parcelRequire("dUJCp");

var $ke5ip = parcelRequire("ke5ip");

var $jw63c = parcelRequire("jw63c");

var $ft2bY = parcelRequire("ft2bY");
/** Used for built-in method references. */ var $db53cd4f4a1bcb9c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $db53cd4f4a1bcb9c$var$hasOwnProperty = $db53cd4f4a1bcb9c$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */ function $db53cd4f4a1bcb9c$var$baseUnset(object, path) {
    path = (0, $dUJCp.default)(path, object);
    // Prevent prototype pollution:
    // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
    // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
    var index = -1, length = path.length;
    if (!length) return true;
    while(++index < length){
        var key = (0, $ft2bY.default)(path[index]);
        // Always block "__proto__" anywhere in the path if it's not expected
        if (key === "__proto__" && !$db53cd4f4a1bcb9c$var$hasOwnProperty.call(object, "__proto__")) return false;
        // Block constructor/prototype as non-terminal traversal keys to prevent
        // escaping the object graph into built-in constructors and prototypes.
        if ((key === "constructor" || key === "prototype") && index < length - 1) return false;
    }
    var obj = (0, $jw63c.default)(object, path);
    return obj == null || delete obj[(0, $ft2bY.default)((0, $ke5ip.default)(path))];
}
var $db53cd4f4a1bcb9c$export$2e2bcd8739ae039 = $db53cd4f4a1bcb9c$var$baseUnset;

});
parcelRegister("ke5ip", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb99391fe11a02ac$export$2e2bcd8739ae039);
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $eb99391fe11a02ac$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
var $eb99391fe11a02ac$export$2e2bcd8739ae039 = $eb99391fe11a02ac$var$last;

});

parcelRegister("jw63c", function(module, exports) {

$parcel$export(module.exports, "default", () => $e355b2fcb769d2c8$export$2e2bcd8739ae039);

var $foHRp = parcelRequire("foHRp");

var $8vRoo = parcelRequire("8vRoo");
/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */ function $e355b2fcb769d2c8$var$parent(object, path) {
    return path.length < 2 ? object : (0, $foHRp.default)(object, (0, $8vRoo.default)(path, 0, -1));
}
var $e355b2fcb769d2c8$export$2e2bcd8739ae039 = $e355b2fcb769d2c8$var$parent;

});
parcelRegister("8vRoo", function(module, exports) {

$parcel$export(module.exports, "default", () => $632aa29c87e61531$export$2e2bcd8739ae039);
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $632aa29c87e61531$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
var $632aa29c87e61531$export$2e2bcd8739ae039 = $632aa29c87e61531$var$baseSlice;

});



parcelRegister("b99Lb", function(module, exports) {

$parcel$export(module.exports, "default", () => $81d81b1620695b3f$export$2e2bcd8739ae039);

var $3rtvu = parcelRequire("3rtvu");
/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */ function $81d81b1620695b3f$var$customOmitClone(value) {
    return (0, $3rtvu.default)(value) ? undefined : value;
}
var $81d81b1620695b3f$export$2e2bcd8739ae039 = $81d81b1620695b3f$var$customOmitClone;

});
parcelRegister("3rtvu", function(module, exports) {

$parcel$export(module.exports, "default", () => $281ac82f5f5844b1$export$2e2bcd8739ae039);

var $hArsG = parcelRequire("hArsG");

var $bzIQZ = parcelRequire("bzIQZ");

var $f2iog = parcelRequire("f2iog");
/** `Object#toString` result references. */ var $281ac82f5f5844b1$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $281ac82f5f5844b1$var$funcProto = Function.prototype, $281ac82f5f5844b1$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $281ac82f5f5844b1$var$funcToString = $281ac82f5f5844b1$var$funcProto.toString;
/** Used to check objects for own properties. */ var $281ac82f5f5844b1$var$hasOwnProperty = $281ac82f5f5844b1$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $281ac82f5f5844b1$var$objectCtorString = $281ac82f5f5844b1$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $281ac82f5f5844b1$var$isPlainObject(value) {
    if (!(0, $f2iog.default)(value) || (0, $hArsG.default)(value) != $281ac82f5f5844b1$var$objectTag) return false;
    var proto = (0, $bzIQZ.default)(value);
    if (proto === null) return true;
    var Ctor = $281ac82f5f5844b1$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $281ac82f5f5844b1$var$funcToString.call(Ctor) == $281ac82f5f5844b1$var$objectCtorString;
}
var $281ac82f5f5844b1$export$2e2bcd8739ae039 = $281ac82f5f5844b1$var$isPlainObject;

});


parcelRegister("1GImM", function(module, exports) {

$parcel$export(module.exports, "default", () => $13ac20f2e48b583b$export$2e2bcd8739ae039);

var $0MuaS = parcelRequire("0MuaS");

var $dQSON = parcelRequire("dQSON");

var $3CD6d = parcelRequire("3CD6d");
/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $13ac20f2e48b583b$var$flatRest(func) {
    return (0, $3CD6d.default)((0, $dQSON.default)(func, undefined, (0, $0MuaS.default)), func + "");
}
var $13ac20f2e48b583b$export$2e2bcd8739ae039 = $13ac20f2e48b583b$var$flatRest;

});
parcelRegister("0MuaS", function(module, exports) {

$parcel$export(module.exports, "default", () => $00259c72dfc3e307$export$2e2bcd8739ae039);

var $kQGD1 = parcelRequire("kQGD1");
/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $00259c72dfc3e307$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? (0, $kQGD1.default)(array, 1) : [];
}
var $00259c72dfc3e307$export$2e2bcd8739ae039 = $00259c72dfc3e307$var$flatten;

});
parcelRegister("kQGD1", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2d9bb1470b40f11$export$2e2bcd8739ae039);

var $6JPqi = parcelRequire("6JPqi");

var $gIOz7 = parcelRequire("gIOz7");
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $f2d9bb1470b40f11$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = (0, $gIOz7.default));
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $f2d9bb1470b40f11$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else (0, $6JPqi.default)(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
var $f2d9bb1470b40f11$export$2e2bcd8739ae039 = $f2d9bb1470b40f11$var$baseFlatten;

});
parcelRegister("gIOz7", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2c7faaacfb4b375$export$2e2bcd8739ae039);

var $kRxPv = parcelRequire("kRxPv");

var $5VdmZ = parcelRequire("5VdmZ");

var $hf0C9 = parcelRequire("hf0C9");
/** Built-in value references. */ var $c2c7faaacfb4b375$var$spreadableSymbol = (0, $kRxPv.default) ? (0, $kRxPv.default).isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $c2c7faaacfb4b375$var$isFlattenable(value) {
    return (0, $hf0C9.default)(value) || (0, $5VdmZ.default)(value) || !!($c2c7faaacfb4b375$var$spreadableSymbol && value && value[$c2c7faaacfb4b375$var$spreadableSymbol]);
}
var $c2c7faaacfb4b375$export$2e2bcd8739ae039 = $c2c7faaacfb4b375$var$isFlattenable;

});



parcelRegister("dQSON", function(module, exports) {

$parcel$export(module.exports, "default", () => $a15aa7792aefa7ab$export$2e2bcd8739ae039);

var $dDkGf = parcelRequire("dDkGf");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $a15aa7792aefa7ab$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $a15aa7792aefa7ab$var$overRest(func, start, transform) {
    start = $a15aa7792aefa7ab$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $a15aa7792aefa7ab$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return (0, $dDkGf.default)(func, this, otherArgs);
    };
}
var $a15aa7792aefa7ab$export$2e2bcd8739ae039 = $a15aa7792aefa7ab$var$overRest;

});
parcelRegister("dDkGf", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ecef59737507c1b$export$2e2bcd8739ae039);
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $9ecef59737507c1b$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
var $9ecef59737507c1b$export$2e2bcd8739ae039 = $9ecef59737507c1b$var$apply;

});


parcelRegister("3CD6d", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a333ffc4129ee1c$export$2e2bcd8739ae039);

var $b4MjZ = parcelRequire("b4MjZ");

var $8KfXk = parcelRequire("8KfXk");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $2a333ffc4129ee1c$var$setToString = (0, $8KfXk.default)((0, $b4MjZ.default));
var $2a333ffc4129ee1c$export$2e2bcd8739ae039 = $2a333ffc4129ee1c$var$setToString;

});
parcelRegister("b4MjZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $81058d0e7e5193a8$export$2e2bcd8739ae039);

var $5Oe6X = parcelRequire("5Oe6X");

var $1RMjB = parcelRequire("1RMjB");

var $jSR8v = parcelRequire("jSR8v");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $81058d0e7e5193a8$var$baseSetToString = !(0, $1RMjB.default) ? (0, $jSR8v.default) : function(func, string) {
    return (0, $1RMjB.default)(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": (0, $5Oe6X.default)(string),
        "writable": true
    });
};
var $81058d0e7e5193a8$export$2e2bcd8739ae039 = $81058d0e7e5193a8$var$baseSetToString;

});
parcelRegister("5Oe6X", function(module, exports) {

$parcel$export(module.exports, "default", () => $43ac9174038e0ebf$export$2e2bcd8739ae039);
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $43ac9174038e0ebf$var$constant(value) {
    return function() {
        return value;
    };
}
var $43ac9174038e0ebf$export$2e2bcd8739ae039 = $43ac9174038e0ebf$var$constant;

});


parcelRegister("8KfXk", function(module, exports) {

$parcel$export(module.exports, "default", () => $65deff1999b4a0f2$export$2e2bcd8739ae039);
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $65deff1999b4a0f2$var$HOT_COUNT = 800, $65deff1999b4a0f2$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $65deff1999b4a0f2$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $65deff1999b4a0f2$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $65deff1999b4a0f2$var$nativeNow(), remaining = $65deff1999b4a0f2$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $65deff1999b4a0f2$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
var $65deff1999b4a0f2$export$2e2bcd8739ae039 = $65deff1999b4a0f2$var$shortOut;

});




parcelRegister("kmjbt", function(module, exports) {

$parcel$export(module.exports, "getFilterGroups", () => $ed24be488ae767c6$export$d0763120579d10d4);
$parcel$export(module.exports, "getFiltersByGroupTitle", () => $ed24be488ae767c6$export$a622cd0fee2e8e3f);
$parcel$export(module.exports, "getIsFilterHidden", () => $ed24be488ae767c6$export$2296dbfd38aa02f3);

var $4ZFhI = parcelRequire("4ZFhI");

var $cstaF = parcelRequire("cstaF");
const $ed24be488ae767c6$export$df62c3276e234c8c = (groups, filterIdToRemove)=>{
    return groups.map((group)=>{
        return {
            title: group.title,
            filters: group.filters.filter((filter)=>filter.id !== filterIdToRemove)
        };
    });
};
const $ed24be488ae767c6$export$d0763120579d10d4 = ({ isComparisonSetsEnabled: isComparisonSetsEnabled })=>{
    if (!isComparisonSetsEnabled) return $ed24be488ae767c6$export$df62c3276e234c8c((0, $4ZFhI.allFilterGroups), (0, $4ZFhI.GROUP_FILTERS).COMPARISON_SET.id);
    return 0, $4ZFhI.allFilterGroups;
};
const $ed24be488ae767c6$export$a622cd0fee2e8e3f = (filterGroups, groupTitle)=>{
    return filterGroups.find((group)=>group.title === groupTitle).filters.map((filter)=>filter.id);
};
const $ed24be488ae767c6$export$2296dbfd38aa02f3 = (filter, mlsMembershipInfo)=>{
    if (filter.id === (0, $cstaF.searchTerms).constructionTypeFilter) return !mlsMembershipInfo?.supportsNewConstruction;
    return false;
};

});
parcelRegister("4ZFhI", function(module, exports) {

$parcel$export(module.exports, "GROUP_FILTERS", () => $3a2ce234b2c41f98$export$36fcf418fd17de2);
$parcel$export(module.exports, "allFilterGroups", () => $3a2ce234b2c41f98$export$dbdd29fc918f835a);

var $cstaF = parcelRequire("cstaF");
const $3a2ce234b2c41f98$export$36fcf418fd17de2 = Object.freeze({
    COMPARISON_SET: {
        id: (0, $cstaF.searchTerms).comparisonSetFilter
    }
});
const $3a2ce234b2c41f98$export$dbdd29fc918f835a = [
    {
        title: (0, $cstaF.searchTerms).required,
        filters: [
            {
                id: (0, $cstaF.searchTerms).mlsFilter,
                name: (0, $cstaF.searchTerms).mls,
                permanent: true,
                modules: [
                    (0, $cstaF.modules).proficiencyMetrics.transactions,
                    (0, $cstaF.modules).proficiencyMetrics.agents,
                    (0, $cstaF.modules).proficiencyMetrics.offices,
                    (0, $cstaF.modules).proficiencyMetrics.suggestedAgents,
                    (0, $cstaF.modules).proficiencyMetrics.agentMovement,
                    (0, $cstaF.modules).proficiencyMetrics.savedAgents,
                    (0, $cstaF.modules).marketShare.totals,
                    (0, $cstaF.modules).marketShare.coverage,
                    (0, $cstaF.modules).marketDynamics.marketDynamics
                ]
            },
            {
                id: (0, $cstaF.searchTerms).areaTypeFilter,
                name: (0, $cstaF.searchTerms).areaType,
                path: "computedFields/areaType",
                permanent: true,
                modules: [
                    (0, $cstaF.modules).marketShare.coverage
                ]
            },
            {
                id: (0, $cstaF.searchTerms).marketAreaFilter,
                name: {
                    [(0, $cstaF.modules).proficiencyMetrics.transactions]: (0, $cstaF.searchTerms).marketArea,
                    [(0, $cstaF.modules).marketShare.totals]: (0, $cstaF.searchTerms).marketArea,
                    [(0, $cstaF.modules).marketDynamics.marketDynamics]: (0, $cstaF.searchTerms).areaType
                },
                permanent: true,
                modules: [
                    (0, $cstaF.modules).proficiencyMetrics.transactions,
                    (0, $cstaF.modules).proficiencyMetrics.savedAgents,
                    (0, $cstaF.modules).marketShare.totals,
                    (0, $cstaF.modules).marketDynamics.marketDynamics
                ]
            },
            {
                id: (0, $cstaF.searchTerms).propTypeFilter,
                name: (0, $cstaF.searchTerms).propertyType,
                permanent: true,
                path: "searchFields/propertyType",
                modules: [
                    (0, $cstaF.modules).proficiencyMetrics.transactions,
                    (0, $cstaF.modules).proficiencyMetrics.agents,
                    (0, $cstaF.modules).proficiencyMetrics.savedAgents,
                    (0, $cstaF.modules).marketShare.totals,
                    (0, $cstaF.modules).marketShare.coverage,
                    (0, $cstaF.modules).marketDynamics.marketDynamics
                ]
            },
            {
                id: (0, $cstaF.searchTerms).timeFrameFilter,
                name: (0, $cstaF.searchTerms).timeFrame,
                permanent: true,
                modules: [
                    (0, $cstaF.modules).proficiencyMetrics.transactions,
                    (0, $cstaF.modules).proficiencyMetrics.agents,
                    (0, $cstaF.modules).proficiencyMetrics.offices,
                    (0, $cstaF.modules).proficiencyMetrics.savedAgents,
                    (0, $cstaF.modules).marketShare.totals,
                    (0, $cstaF.modules).marketShare.coverage,
                    (0, $cstaF.modules).marketDynamics.marketDynamics
                ]
            },
            {
                id: (0, $cstaF.searchTerms).listingStatusFilter,
                name: (0, $cstaF.searchTerms).listingStatus,
                permanent: true,
                modules: [
                    (0, $cstaF.modules).marketShare.totals,
                    (0, $cstaF.modules).marketShare.coverage
                ],
                path: "computedFields/transactionStatus"
            },
            {
                id: (0, $cstaF.searchTerms).officesFilter,
                name: (0, $cstaF.searchTerms).offices,
                permanent: true,
                modules: [
                    (0, $cstaF.modules).proficiencyMetrics.offices,
                    (0, $cstaF.modules).proficiencyMetrics.agentMovement,
                    (0, $cstaF.modules).marketShare.coverage
                ],
                path: "idFiltering/idType"
            },
            {
                id: (0, $cstaF.searchTerms).agentsFilter,
                name: (0, $cstaF.searchTerms).agents,
                permanent: true,
                modules: [
                    (0, $cstaF.modules).proficiencyMetrics.agents
                ],
                path: "idFiltering/idType"
            }
        ]
    },
    {
        title: (0, $cstaF.searchTerms).optional,
        filters: [
            {
                id: (0, $cstaF.searchTerms).totalVolumeFilter,
                name: (0, $cstaF.searchTerms).totalVolume,
                path: "computedFields/totalVolume",
                modules: [
                    (0, $cstaF.modules).proficiencyMetrics.transactions,
                    (0, $cstaF.modules).proficiencyMetrics.offices,
                    (0, $cstaF.modules).proficiencyMetrics.savedAgents
                ]
            },
            {
                id: (0, $cstaF.searchTerms).soldPriceFilter,
                name: (0, $cstaF.searchTerms).soldPriceRange,
                path: "searchFields/soldPrice",
                modules: [
                    (0, $cstaF.modules).proficiencyMetrics.transactions,
                    (0, $cstaF.modules).proficiencyMetrics.agents,
                    (0, $cstaF.modules).proficiencyMetrics.offices,
                    (0, $cstaF.modules).proficiencyMetrics.savedAgents
                ]
            },
            {
                id: (0, $cstaF.searchTerms).priceRangeFilter,
                name: (0, $cstaF.searchTerms).priceRange,
                path: "searchFields/lastPrice",
                modules: [
                    (0, $cstaF.modules).marketShare.totals,
                    (0, $cstaF.modules).marketShare.coverage,
                    (0, $cstaF.modules).marketDynamics.marketDynamics
                ]
            },
            {
                id: (0, $cstaF.searchTerms).totalUnitsFilter,
                name: (0, $cstaF.searchTerms).totalUnits,
                path: "computedFields/totalUnits",
                modules: [
                    (0, $cstaF.modules).proficiencyMetrics.transactions,
                    (0, $cstaF.modules).proficiencyMetrics.offices,
                    (0, $cstaF.modules).proficiencyMetrics.savedAgents
                ]
            },
            {
                id: (0, $cstaF.searchTerms).fullBathroomsFilter,
                name: (0, $cstaF.searchTerms).fullBathrooms,
                path: "searchFields/fullBathrooms",
                modules: [
                    (0, $cstaF.modules).proficiencyMetrics.transactions,
                    (0, $cstaF.modules).marketShare.totals,
                    (0, $cstaF.modules).marketShare.coverage,
                    (0, $cstaF.modules).marketDynamics.marketDynamics,
                    (0, $cstaF.modules).proficiencyMetrics.savedAgents
                ]
            },
            {
                id: (0, $cstaF.searchTerms).bedroomsFilter,
                name: (0, $cstaF.searchTerms).bedrooms,
                path: "searchFields/bedrooms",
                modules: [
                    (0, $cstaF.modules).proficiencyMetrics.transactions,
                    (0, $cstaF.modules).marketShare.totals,
                    (0, $cstaF.modules).marketShare.coverage,
                    (0, $cstaF.modules).marketDynamics.marketDynamics,
                    (0, $cstaF.modules).proficiencyMetrics.savedAgents
                ]
            },
            {
                id: (0, $cstaF.searchTerms).squareFootageFilter,
                name: (0, $cstaF.searchTerms).squareFootage,
                path: "searchFields/squareFeet",
                modules: [
                    (0, $cstaF.modules).marketDynamics.marketDynamics
                ]
            },
            {
                id: (0, $cstaF.searchTerms).lotSizeFilter,
                name: (0, $cstaF.searchTerms).lotSize,
                path: "searchFields/lotSize",
                modules: [
                    (0, $cstaF.modules).marketDynamics.marketDynamics
                ]
            },
            {
                id: (0, $cstaF.searchTerms).constructionTypeFilter,
                name: (0, $cstaF.searchTerms).constructionType,
                path: "searchFields/newConstruction",
                modules: [
                    (0, $cstaF.modules).proficiencyMetrics.transactions,
                    (0, $cstaF.modules).proficiencyMetrics.agents,
                    (0, $cstaF.modules).proficiencyMetrics.offices,
                    (0, $cstaF.modules).marketShare.totals,
                    (0, $cstaF.modules).marketShare.coverage,
                    (0, $cstaF.modules).marketDynamics.marketDynamics,
                    (0, $cstaF.modules).proficiencyMetrics.savedAgents
                ]
            },
            {
                id: $3a2ce234b2c41f98$export$36fcf418fd17de2.COMPARISON_SET.id,
                name: (0, $cstaF.searchTerms).comparisonSet,
                path: "searchFields/comparisonSet",
                modules: [
                    (0, $cstaF.modules).marketShare.totals
                ]
            }
        ]
    }
];

});


parcelRegister("5269x", function(module, exports) {

$parcel$export(module.exports, "defaultPropTypeTitle", () => $3aa1e97531f76864$export$be20b0d0b1537502);
$parcel$export(module.exports, "getPropertyTypeTitle", () => $3aa1e97531f76864$export$6745a28b2f182397);
$parcel$export(module.exports, "getTimeFrameTitle", () => $3aa1e97531f76864$export$64572f59fbdb00f0);
$parcel$export(module.exports, "getMarketAreaMainTitle", () => $3aa1e97531f76864$export$604a279f14436fe);
$parcel$export(module.exports, "getMarketAreaTitle", () => $3aa1e97531f76864$export$4a6aba513881bf21);
$parcel$export(module.exports, "getMarketAreaListTitle", () => $3aa1e97531f76864$export$c415c3fad4cb3a8c);
$parcel$export(module.exports, "getOfficeListTitle", () => $3aa1e97531f76864$export$b407fd1fe336f269);
$parcel$export(module.exports, "getOfficesTitle", () => $3aa1e97531f76864$export$742f1a69ed7a1222);
$parcel$export(module.exports, "getAgentsTitle", () => $3aa1e97531f76864$export$aec0b9a532ba9a4d);
$parcel$export(module.exports, "getRangeTitle", () => $3aa1e97531f76864$export$9cda298bc6b45a8d);
$parcel$export(module.exports, "getLotSizeTitle", () => $3aa1e97531f76864$export$d9f171635d5829da);
$parcel$export(module.exports, "currencyFields", () => $3aa1e97531f76864$export$e8fcb57a0a1a2e90);
$parcel$export(module.exports, "getActivityText", () => $3aa1e97531f76864$export$109ea071ab690aee);
$parcel$export(module.exports, "getDateRangeText", () => $3aa1e97531f76864$export$78af759abc273eab);

var $5ILgR = parcelRequire("5ILgR");
var $96LH4 = parcelRequire("96LH4");
var $0MuaS = parcelRequire("0MuaS");
var $fpekr = parcelRequire("fpekr");
var $b0dsn = parcelRequire("b0dsn");
var $3kePu = parcelRequire("3kePu");
var $lsEd9 = parcelRequire("lsEd9");
var $jUkRP = parcelRequire("jUkRP");

var $cstaF = parcelRequire("cstaF");

var $dlZsJ = parcelRequire("dlZsJ");

var $75U5M = parcelRequire("75U5M");

var $aYbF1 = parcelRequire("aYbF1");

var $htzEo = parcelRequire("htzEo");

var $cstaF = parcelRequire("cstaF");

var $4EYT7 = parcelRequire("4EYT7");
const $3aa1e97531f76864$export$be20b0d0b1537502 = (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).propertyTypes);
const $3aa1e97531f76864$export$6745a28b2f182397 = (propTypes, selectedPropTypes)=>{
    let title = $3aa1e97531f76864$export$be20b0d0b1537502;
    const propTypesCount = $jUkRP.default($96LH4.default(propTypes, (x)=>x.types.length));
    if (selectedPropTypes.length === 0) title = $3aa1e97531f76864$export$be20b0d0b1537502;
    else if (selectedPropTypes.length === 1) {
        const found = $5ILgR.default($0MuaS.default($3kePu.default(propTypes, (propType)=>propType.types)), (type)=>type.typeId.toString() === selectedPropTypes[0]);
        if (found) title = found.longName;
    } else if (selectedPropTypes.length === propTypesCount) title = "All Property Types";
    else {
        title = "";
        $fpekr.default(propTypes, (propType)=>{
            const intersectionLength = $b0dsn.default($3kePu.default(propType.types, (type)=>type.typeId.toString()), selectedPropTypes).length;
            if (propType.types.length === intersectionLength && selectedPropTypes.length === intersectionLength) title = "All " + propType.longName;
        });
        if (!title) {
            const found = $5ILgR.default($0MuaS.default($3kePu.default(propTypes, (propType)=>propType.types)), (x)=>x.typeId.toString() === selectedPropTypes[0]);
            if (found) title = `${found.longName} +${selectedPropTypes.length - 1}`;
        }
    }
    return {
        mainTitle: title
    };
};
const $3aa1e97531f76864$export$64572f59fbdb00f0 = (selectedTimeFrame, timeIntervals, module)=>{
    const selectedTimeInterval = timeIntervals?.find((ti)=>ti.intervalType === selectedTimeFrame.intervalType);
    const dateRange = selectedTimeInterval && (0, $75U5M.formatMediumDate)(new Date(`${selectedTimeInterval.last.from}Z`)) + " - " + (0, $75U5M.formatMediumDate)(new Date(`${selectedTimeInterval.last.to}Z`));
    const timePeriods = (0, $aYbF1.getTimePeriods)(module);
    return {
        mainTitle: (0, $dlZsJ.getKeyByValue)(timePeriods, selectedTimeFrame.intervalType),
        subtitle: dateRange ?? (selectedTimeFrame.startDate && selectedTimeFrame.endDate ? `${(0, $75U5M.formatMediumDate)(new Date(`${selectedTimeFrame.startDate}T00:00:00Z`))} - ${(0, $75U5M.formatMediumDate)(new Date(`${selectedTimeFrame.endDate}T23:59:59Z`))}` : undefined)
    };
};
const $3aa1e97531f76864$export$604a279f14436fe = ({ module: module, isEmpty: isEmpty = true })=>{
    const isMarketDynamics = module === (0, $cstaF.modules).marketDynamics.marketDynamics;
    const mainTitle = isMarketDynamics ? (0, $cstaF.searchTerms).areaType : (0, $cstaF.searchTerms).marketArea;
    return isEmpty ? (0, $cstaF.searchTerms).selectType(mainTitle) : mainTitle;
};
const $3aa1e97531f76864$export$4a6aba513881bf21 = ({ selectedAreas: selectedAreas, searchAllMls: searchAllMls, module: module })=>{
    if (searchAllMls) return {
        mainTitle: (0, $cstaF.searchTerms).marketArea,
        subTitle: (0, $cstaF.searchTerms).lowerAllMls
    };
    const valuesCount = selectedAreas[0]?.fieldValues?.length;
    return {
        mainTitle: valuesCount ? (0, $cstaF.searchTerms).transactionsIn : $3aa1e97531f76864$export$604a279f14436fe({
            module: module
        }),
        subTitle: valuesCount ? `${selectedAreas[0].fieldValueDescriptions && selectedAreas[0].fieldValueDescriptions[0] !== "undefined" && selectedAreas[0].fieldValueDescriptions[0] !== selectedAreas[0].fieldValues[0] ? `${$lsEd9.default(selectedAreas[0].fieldValues[0])} (${$lsEd9.default(selectedAreas[0].fieldValueDescriptions[0])})` : `${$lsEd9.default(selectedAreas[0].fieldValues[0])}`} ${valuesCount > 1 ? ` +${valuesCount - 1}` : ""}` : undefined
    };
};
const $3aa1e97531f76864$export$c415c3fad4cb3a8c = (name, area)=>{
    return {
        mainTitle: `${name} (${area})`
    };
};
const $3aa1e97531f76864$var$getRangeSubtitle = (values, isCurrency)=>{
    return values.min || values.max ? values.min === values.max ? `${isCurrency ? "$" : ""}${values.min.toLocaleString()}` : `${!values.min ? values.max && "up to " : `${isCurrency ? "$" : ""}${values.min.toLocaleString()}`}` + `${values.max ? values.min ? ` - ${isCurrency ? "$" : ""}${values.max.toLocaleString()}` : `${isCurrency ? "$" : ""}${values.max.toLocaleString()}` : "+"}` : undefined;
};
const $3aa1e97531f76864$export$b407fd1fe336f269 = (officeListName)=>{
    return {
        mainTitle: officeListName
    };
};
const $3aa1e97531f76864$export$742f1a69ed7a1222 = (selectedOffices, offices)=>{
    const officesCount = selectedOffices?.length;
    return {
        mainTitle: officesCount ? `${offices.find((o)=>o.officeId === selectedOffices[0])?.officeName}${officesCount > 1 ? ` +${officesCount - 1}` : ""}` : (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).offices)
    };
};
const $3aa1e97531f76864$export$aec0b9a532ba9a4d = (selectedAgents)=>{
    const agentsCount = selectedAgents?.length;
    return {
        mainTitle: agentsCount ? `${(0, $cstaF.agentFullName)(selectedAgents[0])}${agentsCount > 1 ? ` +${agentsCount - 1}` : ""}` : (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).agents)
    };
};
const $3aa1e97531f76864$export$4be82b5b38dbaed9 = (agentListName)=>{
    return {
        mainTitle: agentListName
    };
};
const $3aa1e97531f76864$export$9cda298bc6b45a8d = (searchTerm, values, isCurrency)=>{
    const range = $3aa1e97531f76864$var$getRangeSubtitle(values, isCurrency);
    return {
        mainTitle: range ? searchTerm : (0, $cstaF.searchTerms).selectType(searchTerm),
        subTitle: range && range.toLowerCase()
    };
};
const $3aa1e97531f76864$export$d9f171635d5829da = (searchTerm, values)=>{
    const range = $3aa1e97531f76864$var$getRangeSubtitle(values, false);
    return {
        mainTitle: range ? searchTerm : (0, $cstaF.searchTerms).selectType(searchTerm),
        subTitle: range && range.toLowerCase()
    };
};
const $3aa1e97531f76864$export$e8fcb57a0a1a2e90 = [
    "totalVolume",
    "soldPrice"
];
const $3aa1e97531f76864$export$109ea071ab690aee = (activity)=>{
    const isSold = activity?.activityType?.toLowerCase() === "sold";
    const actionText = isSold ? (0, $4EYT7.terms).closedSaleAt : (0, $4EYT7.terms).listed;
    const price = (0, $htzEo.getCurrencyFormat)(activity.price);
    return `${actionText} ${activity.address}, ${price}`;
};
const $3aa1e97531f76864$export$78af759abc273eab = (currentSearchDates)=>{
    if (!currentSearchDates || !currentSearchDates.lastIntervalText || !currentSearchDates.from || !currentSearchDates.to) return {
        lastIntervalText: "",
        from: "",
        to: ""
    };
    const intervalValue = currentSearchDates.lastIntervalText;
    const lastIntervalText = Object.keys((0, $cstaF.TimePeriods)).find((key)=>(0, $cstaF.TimePeriods)[key] === intervalValue) || intervalValue;
    return {
        lastIntervalText: lastIntervalText,
        from: (0, $75U5M.formatMediumDate)(currentSearchDates.from),
        to: (0, $75U5M.formatMediumDate)(currentSearchDates.to)
    };
};

});
parcelRegister("96LH4", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a19ab8cc178ba96$export$2e2bcd8739ae039);

var $kQGD1 = parcelRequire("kQGD1");

var $3kePu = parcelRequire("3kePu");
/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function $6a19ab8cc178ba96$var$flatMap(collection, iteratee) {
    return (0, $kQGD1.default)((0, $3kePu.default)(collection, iteratee), 1);
}
var $6a19ab8cc178ba96$export$2e2bcd8739ae039 = $6a19ab8cc178ba96$var$flatMap;

});

parcelRegister("b0dsn", function(module, exports) {

$parcel$export(module.exports, "default", () => $802a22039c1de325$export$2e2bcd8739ae039);

var $afgje = parcelRequire("afgje");

var $7Jd2v = parcelRequire("7Jd2v");

var $exqIp = parcelRequire("exqIp");

var $hxH8F = parcelRequire("hxH8F");
/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */ var $802a22039c1de325$var$intersection = (0, $exqIp.default)(function(arrays) {
    var mapped = (0, $afgje.default)(arrays, (0, $hxH8F.default));
    return mapped.length && mapped[0] === arrays[0] ? (0, $7Jd2v.default)(mapped) : [];
});
var $802a22039c1de325$export$2e2bcd8739ae039 = $802a22039c1de325$var$intersection;

});
parcelRegister("7Jd2v", function(module, exports) {

$parcel$export(module.exports, "default", () => $5a06d9b8629cb2ad$export$2e2bcd8739ae039);

var $dTR92 = parcelRequire("dTR92");

var $aVe6w = parcelRequire("aVe6w");

var $8OVl5 = parcelRequire("8OVl5");

var $afgje = parcelRequire("afgje");

var $hb0cD = parcelRequire("hb0cD");

var $lEs8E = parcelRequire("lEs8E");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5a06d9b8629cb2ad$var$nativeMin = Math.min;
/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */ function $5a06d9b8629cb2ad$var$baseIntersection(arrays, iteratee, comparator) {
    var includes = comparator ? (0, $8OVl5.default) : (0, $aVe6w.default), length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array(othLength), maxLength = Infinity, result = [];
    while(othIndex--){
        var array = arrays[othIndex];
        if (othIndex && iteratee) array = (0, $afgje.default)(array, (0, $hb0cD.default)(iteratee));
        maxLength = $5a06d9b8629cb2ad$var$nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new (0, $dTR92.default)(othIndex && array) : undefined;
    }
    array = arrays[0];
    var index = -1, seen = caches[0];
    outer: while(++index < length && result.length < maxLength){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (!(seen ? (0, $lEs8E.default)(seen, computed) : includes(result, computed, comparator))) {
            othIndex = othLength;
            while(--othIndex){
                var cache = caches[othIndex];
                if (!(cache ? (0, $lEs8E.default)(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
            }
            if (seen) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
var $5a06d9b8629cb2ad$export$2e2bcd8739ae039 = $5a06d9b8629cb2ad$var$baseIntersection;

});
parcelRegister("aVe6w", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f3a2b0ad65588a2$export$2e2bcd8739ae039);

var $4gro2 = parcelRequire("4gro2");
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $7f3a2b0ad65588a2$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && (0, $4gro2.default)(array, value, 0) > -1;
}
var $7f3a2b0ad65588a2$export$2e2bcd8739ae039 = $7f3a2b0ad65588a2$var$arrayIncludes;

});
parcelRegister("4gro2", function(module, exports) {

$parcel$export(module.exports, "default", () => $31ade67e18f9b0d6$export$2e2bcd8739ae039);

var $38tNx = parcelRequire("38tNx");

var $dyOlA = parcelRequire("dyOlA");

var $l8Zb6 = parcelRequire("l8Zb6");
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $31ade67e18f9b0d6$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? (0, $l8Zb6.default)(array, value, fromIndex) : (0, $38tNx.default)(array, (0, $dyOlA.default), fromIndex);
}
var $31ade67e18f9b0d6$export$2e2bcd8739ae039 = $31ade67e18f9b0d6$var$baseIndexOf;

});
parcelRegister("dyOlA", function(module, exports) {

$parcel$export(module.exports, "default", () => $9df581379b7484c4$export$2e2bcd8739ae039);
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $9df581379b7484c4$var$baseIsNaN(value) {
    return value !== value;
}
var $9df581379b7484c4$export$2e2bcd8739ae039 = $9df581379b7484c4$var$baseIsNaN;

});

parcelRegister("l8Zb6", function(module, exports) {

$parcel$export(module.exports, "default", () => $f649cd031bd381c3$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $f649cd031bd381c3$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
var $f649cd031bd381c3$export$2e2bcd8739ae039 = $f649cd031bd381c3$var$strictIndexOf;

});



parcelRegister("8OVl5", function(module, exports) {

$parcel$export(module.exports, "default", () => $66bf7896b6a68e88$export$2e2bcd8739ae039);
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $66bf7896b6a68e88$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
var $66bf7896b6a68e88$export$2e2bcd8739ae039 = $66bf7896b6a68e88$var$arrayIncludesWith;

});


parcelRegister("exqIp", function(module, exports) {

$parcel$export(module.exports, "default", () => $a958ded4e39f3487$export$2e2bcd8739ae039);

var $jSR8v = parcelRequire("jSR8v");

var $dQSON = parcelRequire("dQSON");

var $3CD6d = parcelRequire("3CD6d");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $a958ded4e39f3487$var$baseRest(func, start) {
    return (0, $3CD6d.default)((0, $dQSON.default)(func, start, (0, $jSR8v.default)), func + "");
}
var $a958ded4e39f3487$export$2e2bcd8739ae039 = $a958ded4e39f3487$var$baseRest;

});

parcelRegister("hxH8F", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc56fb3313aa7935$export$2e2bcd8739ae039);

var $8Y2y0 = parcelRequire("8Y2y0");
/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */ function $cc56fb3313aa7935$var$castArrayLikeObject(value) {
    return (0, $8Y2y0.default)(value) ? value : [];
}
var $cc56fb3313aa7935$export$2e2bcd8739ae039 = $cc56fb3313aa7935$var$castArrayLikeObject;

});
parcelRegister("8Y2y0", function(module, exports) {

$parcel$export(module.exports, "default", () => $6875e7309728ffbd$export$2e2bcd8739ae039);

var $lAOUf = parcelRequire("lAOUf");

var $f2iog = parcelRequire("f2iog");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $6875e7309728ffbd$var$isArrayLikeObject(value) {
    return (0, $f2iog.default)(value) && (0, $lAOUf.default)(value);
}
var $6875e7309728ffbd$export$2e2bcd8739ae039 = $6875e7309728ffbd$var$isArrayLikeObject;

});



parcelRegister("lsEd9", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9fb6799dbc80b80$export$2e2bcd8739ae039);

var $fbN8B = parcelRequire("fbN8B");

var $hBmZL = parcelRequire("hBmZL");
/**
 * Converts `string` to
 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
 *
 * @static
 * @memberOf _
 * @since 3.1.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the start cased string.
 * @example
 *
 * _.startCase('--foo-bar--');
 * // => 'Foo Bar'
 *
 * _.startCase('fooBar');
 * // => 'Foo Bar'
 *
 * _.startCase('__FOO_BAR__');
 * // => 'FOO BAR'
 */ var $f9fb6799dbc80b80$var$startCase = (0, $fbN8B.default)(function(result, word, index) {
    return result + (index ? " " : "") + (0, $hBmZL.default)(word);
});
var $f9fb6799dbc80b80$export$2e2bcd8739ae039 = $f9fb6799dbc80b80$var$startCase;

});
parcelRegister("fbN8B", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0edffd6e8b73bc7$export$2e2bcd8739ae039);

var $jZsE4 = parcelRequire("jZsE4");

var $hqoVj = parcelRequire("hqoVj");

var $3eCGl = parcelRequire("3eCGl");
/** Used to compose unicode capture groups. */ var $b0edffd6e8b73bc7$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $b0edffd6e8b73bc7$var$reApos = RegExp($b0edffd6e8b73bc7$var$rsApos, "g");
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $b0edffd6e8b73bc7$var$createCompounder(callback) {
    return function(string) {
        return (0, $jZsE4.default)((0, $3eCGl.default)((0, $hqoVj.default)(string).replace($b0edffd6e8b73bc7$var$reApos, "")), callback, "");
    };
}
var $b0edffd6e8b73bc7$export$2e2bcd8739ae039 = $b0edffd6e8b73bc7$var$createCompounder;

});
parcelRegister("jZsE4", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8d9ef3488ca3193$export$2e2bcd8739ae039);
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $e8d9ef3488ca3193$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
var $e8d9ef3488ca3193$export$2e2bcd8739ae039 = $e8d9ef3488ca3193$var$arrayReduce;

});

parcelRegister("hqoVj", function(module, exports) {

$parcel$export(module.exports, "default", () => $caf8329f989df6e3$export$2e2bcd8739ae039);

var $3vvIk = parcelRequire("3vvIk");

var $1fnxW = parcelRequire("1fnxW");
/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $caf8329f989df6e3$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $caf8329f989df6e3$var$rsComboMarksRange = "\\u0300-\\u036f", $caf8329f989df6e3$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $caf8329f989df6e3$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $caf8329f989df6e3$var$rsComboRange = $caf8329f989df6e3$var$rsComboMarksRange + $caf8329f989df6e3$var$reComboHalfMarksRange + $caf8329f989df6e3$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $caf8329f989df6e3$var$rsCombo = "[" + $caf8329f989df6e3$var$rsComboRange + "]";
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $caf8329f989df6e3$var$reComboMark = RegExp($caf8329f989df6e3$var$rsCombo, "g");
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $caf8329f989df6e3$var$deburr(string) {
    string = (0, $1fnxW.default)(string);
    return string && string.replace($caf8329f989df6e3$var$reLatin, (0, $3vvIk.default)).replace($caf8329f989df6e3$var$reComboMark, "");
}
var $caf8329f989df6e3$export$2e2bcd8739ae039 = $caf8329f989df6e3$var$deburr;

});
parcelRegister("3vvIk", function(module, exports) {

$parcel$export(module.exports, "default", () => $28dcde10004623b8$export$2e2bcd8739ae039);

var $56Q2M = parcelRequire("56Q2M");
/** Used to map Latin Unicode letters to basic Latin letters. */ var $28dcde10004623b8$var$deburredLetters = {
    // Latin-1 Supplement block.
    "\xc0": "A",
    "\xc1": "A",
    "\xc2": "A",
    "\xc3": "A",
    "\xc4": "A",
    "\xc5": "A",
    "\xe0": "a",
    "\xe1": "a",
    "\xe2": "a",
    "\xe3": "a",
    "\xe4": "a",
    "\xe5": "a",
    "\xc7": "C",
    "\xe7": "c",
    "\xd0": "D",
    "\xf0": "d",
    "\xc8": "E",
    "\xc9": "E",
    "\xca": "E",
    "\xcb": "E",
    "\xe8": "e",
    "\xe9": "e",
    "\xea": "e",
    "\xeb": "e",
    "\xcc": "I",
    "\xcd": "I",
    "\xce": "I",
    "\xcf": "I",
    "\xec": "i",
    "\xed": "i",
    "\xee": "i",
    "\xef": "i",
    "\xd1": "N",
    "\xf1": "n",
    "\xd2": "O",
    "\xd3": "O",
    "\xd4": "O",
    "\xd5": "O",
    "\xd6": "O",
    "\xd8": "O",
    "\xf2": "o",
    "\xf3": "o",
    "\xf4": "o",
    "\xf5": "o",
    "\xf6": "o",
    "\xf8": "o",
    "\xd9": "U",
    "\xda": "U",
    "\xdb": "U",
    "\xdc": "U",
    "\xf9": "u",
    "\xfa": "u",
    "\xfb": "u",
    "\xfc": "u",
    "\xdd": "Y",
    "\xfd": "y",
    "\xff": "y",
    "\xc6": "Ae",
    "\xe6": "ae",
    "\xde": "Th",
    "\xfe": "th",
    "\xdf": "ss",
    // Latin Extended-A block.
    "\u0100": "A",
    "\u0102": "A",
    "\u0104": "A",
    "\u0101": "a",
    "\u0103": "a",
    "\u0105": "a",
    "\u0106": "C",
    "\u0108": "C",
    "\u010A": "C",
    "\u010C": "C",
    "\u0107": "c",
    "\u0109": "c",
    "\u010B": "c",
    "\u010D": "c",
    "\u010E": "D",
    "\u0110": "D",
    "\u010F": "d",
    "\u0111": "d",
    "\u0112": "E",
    "\u0114": "E",
    "\u0116": "E",
    "\u0118": "E",
    "\u011A": "E",
    "\u0113": "e",
    "\u0115": "e",
    "\u0117": "e",
    "\u0119": "e",
    "\u011B": "e",
    "\u011C": "G",
    "\u011E": "G",
    "\u0120": "G",
    "\u0122": "G",
    "\u011D": "g",
    "\u011F": "g",
    "\u0121": "g",
    "\u0123": "g",
    "\u0124": "H",
    "\u0126": "H",
    "\u0125": "h",
    "\u0127": "h",
    "\u0128": "I",
    "\u012A": "I",
    "\u012C": "I",
    "\u012E": "I",
    "\u0130": "I",
    "\u0129": "i",
    "\u012B": "i",
    "\u012D": "i",
    "\u012F": "i",
    "\u0131": "i",
    "\u0134": "J",
    "\u0135": "j",
    "\u0136": "K",
    "\u0137": "k",
    "\u0138": "k",
    "\u0139": "L",
    "\u013B": "L",
    "\u013D": "L",
    "\u013F": "L",
    "\u0141": "L",
    "\u013A": "l",
    "\u013C": "l",
    "\u013E": "l",
    "\u0140": "l",
    "\u0142": "l",
    "\u0143": "N",
    "\u0145": "N",
    "\u0147": "N",
    "\u014A": "N",
    "\u0144": "n",
    "\u0146": "n",
    "\u0148": "n",
    "\u014B": "n",
    "\u014C": "O",
    "\u014E": "O",
    "\u0150": "O",
    "\u014D": "o",
    "\u014F": "o",
    "\u0151": "o",
    "\u0154": "R",
    "\u0156": "R",
    "\u0158": "R",
    "\u0155": "r",
    "\u0157": "r",
    "\u0159": "r",
    "\u015A": "S",
    "\u015C": "S",
    "\u015E": "S",
    "\u0160": "S",
    "\u015B": "s",
    "\u015D": "s",
    "\u015F": "s",
    "\u0161": "s",
    "\u0162": "T",
    "\u0164": "T",
    "\u0166": "T",
    "\u0163": "t",
    "\u0165": "t",
    "\u0167": "t",
    "\u0168": "U",
    "\u016A": "U",
    "\u016C": "U",
    "\u016E": "U",
    "\u0170": "U",
    "\u0172": "U",
    "\u0169": "u",
    "\u016B": "u",
    "\u016D": "u",
    "\u016F": "u",
    "\u0171": "u",
    "\u0173": "u",
    "\u0174": "W",
    "\u0175": "w",
    "\u0176": "Y",
    "\u0177": "y",
    "\u0178": "Y",
    "\u0179": "Z",
    "\u017B": "Z",
    "\u017D": "Z",
    "\u017A": "z",
    "\u017C": "z",
    "\u017E": "z",
    "\u0132": "IJ",
    "\u0133": "ij",
    "\u0152": "Oe",
    "\u0153": "oe",
    "\u0149": "'n",
    "\u017F": "s"
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $28dcde10004623b8$var$deburrLetter = (0, $56Q2M.default)($28dcde10004623b8$var$deburredLetters);
var $28dcde10004623b8$export$2e2bcd8739ae039 = $28dcde10004623b8$var$deburrLetter;

});
parcelRegister("56Q2M", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b85e21977fb59c8$export$2e2bcd8739ae039);
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $3b85e21977fb59c8$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
var $3b85e21977fb59c8$export$2e2bcd8739ae039 = $3b85e21977fb59c8$var$basePropertyOf;

});



parcelRegister("3eCGl", function(module, exports) {

$parcel$export(module.exports, "default", () => $25b0af50751d7f34$export$2e2bcd8739ae039);

var $eIUuP = parcelRequire("eIUuP");

var $hSzKI = parcelRequire("hSzKI");

var $1fnxW = parcelRequire("1fnxW");

var $fAl3h = parcelRequire("fAl3h");
/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $25b0af50751d7f34$var$words(string, pattern, guard) {
    string = (0, $1fnxW.default)(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return (0, $hSzKI.default)(string) ? (0, $fAl3h.default)(string) : (0, $eIUuP.default)(string);
    return string.match(pattern) || [];
}
var $25b0af50751d7f34$export$2e2bcd8739ae039 = $25b0af50751d7f34$var$words;

});
parcelRegister("eIUuP", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab80ffb88e878c05$export$2e2bcd8739ae039);
/** Used to match words composed of alphanumeric characters. */ var $ab80ffb88e878c05$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $ab80ffb88e878c05$var$asciiWords(string) {
    return string.match($ab80ffb88e878c05$var$reAsciiWord) || [];
}
var $ab80ffb88e878c05$export$2e2bcd8739ae039 = $ab80ffb88e878c05$var$asciiWords;

});

parcelRegister("hSzKI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d043367ca578c4f9$export$2e2bcd8739ae039);
/** Used to detect strings that need a more robust regexp to match words. */ var $d043367ca578c4f9$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $d043367ca578c4f9$var$hasUnicodeWord(string) {
    return $d043367ca578c4f9$var$reHasUnicodeWord.test(string);
}
var $d043367ca578c4f9$export$2e2bcd8739ae039 = $d043367ca578c4f9$var$hasUnicodeWord;

});

parcelRegister("fAl3h", function(module, exports) {

$parcel$export(module.exports, "default", () => $b58a8c4a2218d852$export$2e2bcd8739ae039);
/** Used to compose unicode character classes. */ var $b58a8c4a2218d852$var$rsAstralRange = "\ud800-\udfff", $b58a8c4a2218d852$var$rsComboMarksRange = "\\u0300-\\u036f", $b58a8c4a2218d852$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $b58a8c4a2218d852$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $b58a8c4a2218d852$var$rsComboRange = $b58a8c4a2218d852$var$rsComboMarksRange + $b58a8c4a2218d852$var$reComboHalfMarksRange + $b58a8c4a2218d852$var$rsComboSymbolsRange, $b58a8c4a2218d852$var$rsDingbatRange = "\\u2700-\\u27bf", $b58a8c4a2218d852$var$rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", $b58a8c4a2218d852$var$rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", $b58a8c4a2218d852$var$rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", $b58a8c4a2218d852$var$rsPunctuationRange = "\\u2000-\\u206f", $b58a8c4a2218d852$var$rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", $b58a8c4a2218d852$var$rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", $b58a8c4a2218d852$var$rsVarRange = "\\ufe0e\\ufe0f", $b58a8c4a2218d852$var$rsBreakRange = $b58a8c4a2218d852$var$rsMathOpRange + $b58a8c4a2218d852$var$rsNonCharRange + $b58a8c4a2218d852$var$rsPunctuationRange + $b58a8c4a2218d852$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $b58a8c4a2218d852$var$rsApos = "['\u2019]", $b58a8c4a2218d852$var$rsBreak = "[" + $b58a8c4a2218d852$var$rsBreakRange + "]", $b58a8c4a2218d852$var$rsCombo = "[" + $b58a8c4a2218d852$var$rsComboRange + "]", $b58a8c4a2218d852$var$rsDigits = "\\d+", $b58a8c4a2218d852$var$rsDingbat = "[" + $b58a8c4a2218d852$var$rsDingbatRange + "]", $b58a8c4a2218d852$var$rsLower = "[" + $b58a8c4a2218d852$var$rsLowerRange + "]", $b58a8c4a2218d852$var$rsMisc = "[^" + $b58a8c4a2218d852$var$rsAstralRange + $b58a8c4a2218d852$var$rsBreakRange + $b58a8c4a2218d852$var$rsDigits + $b58a8c4a2218d852$var$rsDingbatRange + $b58a8c4a2218d852$var$rsLowerRange + $b58a8c4a2218d852$var$rsUpperRange + "]", $b58a8c4a2218d852$var$rsFitz = "\ud83c[\udffb-\udfff]", $b58a8c4a2218d852$var$rsModifier = "(?:" + $b58a8c4a2218d852$var$rsCombo + "|" + $b58a8c4a2218d852$var$rsFitz + ")", $b58a8c4a2218d852$var$rsNonAstral = "[^" + $b58a8c4a2218d852$var$rsAstralRange + "]", $b58a8c4a2218d852$var$rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", $b58a8c4a2218d852$var$rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", $b58a8c4a2218d852$var$rsUpper = "[" + $b58a8c4a2218d852$var$rsUpperRange + "]", $b58a8c4a2218d852$var$rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var $b58a8c4a2218d852$var$rsMiscLower = "(?:" + $b58a8c4a2218d852$var$rsLower + "|" + $b58a8c4a2218d852$var$rsMisc + ")", $b58a8c4a2218d852$var$rsMiscUpper = "(?:" + $b58a8c4a2218d852$var$rsUpper + "|" + $b58a8c4a2218d852$var$rsMisc + ")", $b58a8c4a2218d852$var$rsOptContrLower = "(?:" + $b58a8c4a2218d852$var$rsApos + "(?:d|ll|m|re|s|t|ve))?", $b58a8c4a2218d852$var$rsOptContrUpper = "(?:" + $b58a8c4a2218d852$var$rsApos + "(?:D|LL|M|RE|S|T|VE))?", $b58a8c4a2218d852$var$reOptMod = $b58a8c4a2218d852$var$rsModifier + "?", $b58a8c4a2218d852$var$rsOptVar = "[" + $b58a8c4a2218d852$var$rsVarRange + "]?", $b58a8c4a2218d852$var$rsOptJoin = "(?:" + $b58a8c4a2218d852$var$rsZWJ + "(?:" + [
    $b58a8c4a2218d852$var$rsNonAstral,
    $b58a8c4a2218d852$var$rsRegional,
    $b58a8c4a2218d852$var$rsSurrPair
].join("|") + ")" + $b58a8c4a2218d852$var$rsOptVar + $b58a8c4a2218d852$var$reOptMod + ")*", $b58a8c4a2218d852$var$rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", $b58a8c4a2218d852$var$rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", $b58a8c4a2218d852$var$rsSeq = $b58a8c4a2218d852$var$rsOptVar + $b58a8c4a2218d852$var$reOptMod + $b58a8c4a2218d852$var$rsOptJoin, $b58a8c4a2218d852$var$rsEmoji = "(?:" + [
    $b58a8c4a2218d852$var$rsDingbat,
    $b58a8c4a2218d852$var$rsRegional,
    $b58a8c4a2218d852$var$rsSurrPair
].join("|") + ")" + $b58a8c4a2218d852$var$rsSeq;
/** Used to match complex or compound words. */ var $b58a8c4a2218d852$var$reUnicodeWord = RegExp([
    $b58a8c4a2218d852$var$rsUpper + "?" + $b58a8c4a2218d852$var$rsLower + "+" + $b58a8c4a2218d852$var$rsOptContrLower + "(?=" + [
        $b58a8c4a2218d852$var$rsBreak,
        $b58a8c4a2218d852$var$rsUpper,
        "$"
    ].join("|") + ")",
    $b58a8c4a2218d852$var$rsMiscUpper + "+" + $b58a8c4a2218d852$var$rsOptContrUpper + "(?=" + [
        $b58a8c4a2218d852$var$rsBreak,
        $b58a8c4a2218d852$var$rsUpper + $b58a8c4a2218d852$var$rsMiscLower,
        "$"
    ].join("|") + ")",
    $b58a8c4a2218d852$var$rsUpper + "?" + $b58a8c4a2218d852$var$rsMiscLower + "+" + $b58a8c4a2218d852$var$rsOptContrLower,
    $b58a8c4a2218d852$var$rsUpper + "+" + $b58a8c4a2218d852$var$rsOptContrUpper,
    $b58a8c4a2218d852$var$rsOrdUpper,
    $b58a8c4a2218d852$var$rsOrdLower,
    $b58a8c4a2218d852$var$rsDigits,
    $b58a8c4a2218d852$var$rsEmoji
].join("|"), "g");
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $b58a8c4a2218d852$var$unicodeWords(string) {
    return string.match($b58a8c4a2218d852$var$reUnicodeWord) || [];
}
var $b58a8c4a2218d852$export$2e2bcd8739ae039 = $b58a8c4a2218d852$var$unicodeWords;

});



parcelRegister("hBmZL", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd07bab7cc5d99bb$export$2e2bcd8739ae039);

var $a30PF = parcelRequire("a30PF");
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $cd07bab7cc5d99bb$var$upperFirst = (0, $a30PF.default)("toUpperCase");
var $cd07bab7cc5d99bb$export$2e2bcd8739ae039 = $cd07bab7cc5d99bb$var$upperFirst;

});
parcelRegister("a30PF", function(module, exports) {

$parcel$export(module.exports, "default", () => $750ad476ec58e06d$export$2e2bcd8739ae039);

var $d5OJ9 = parcelRequire("d5OJ9");

var $6MCUi = parcelRequire("6MCUi");

var $h5ULu = parcelRequire("h5ULu");

var $1fnxW = parcelRequire("1fnxW");
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $750ad476ec58e06d$var$createCaseFirst(methodName) {
    return function(string) {
        string = (0, $1fnxW.default)(string);
        var strSymbols = (0, $6MCUi.default)(string) ? (0, $h5ULu.default)(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? (0, $d5OJ9.default)(strSymbols, 1).join("") : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
var $750ad476ec58e06d$export$2e2bcd8739ae039 = $750ad476ec58e06d$var$createCaseFirst;

});
parcelRegister("d5OJ9", function(module, exports) {

$parcel$export(module.exports, "default", () => $9883175c52fe19da$export$2e2bcd8739ae039);

var $8vRoo = parcelRequire("8vRoo");
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $9883175c52fe19da$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : (0, $8vRoo.default)(array, start, end);
}
var $9883175c52fe19da$export$2e2bcd8739ae039 = $9883175c52fe19da$var$castSlice;

});

parcelRegister("6MCUi", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f0567e72dd9ce2b$export$2e2bcd8739ae039);
/** Used to compose unicode character classes. */ var $4f0567e72dd9ce2b$var$rsAstralRange = "\ud800-\udfff", $4f0567e72dd9ce2b$var$rsComboMarksRange = "\\u0300-\\u036f", $4f0567e72dd9ce2b$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $4f0567e72dd9ce2b$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $4f0567e72dd9ce2b$var$rsComboRange = $4f0567e72dd9ce2b$var$rsComboMarksRange + $4f0567e72dd9ce2b$var$reComboHalfMarksRange + $4f0567e72dd9ce2b$var$rsComboSymbolsRange, $4f0567e72dd9ce2b$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $4f0567e72dd9ce2b$var$rsZWJ = "\\u200d";
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $4f0567e72dd9ce2b$var$reHasUnicode = RegExp("[" + $4f0567e72dd9ce2b$var$rsZWJ + $4f0567e72dd9ce2b$var$rsAstralRange + $4f0567e72dd9ce2b$var$rsComboRange + $4f0567e72dd9ce2b$var$rsVarRange + "]");
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $4f0567e72dd9ce2b$var$hasUnicode(string) {
    return $4f0567e72dd9ce2b$var$reHasUnicode.test(string);
}
var $4f0567e72dd9ce2b$export$2e2bcd8739ae039 = $4f0567e72dd9ce2b$var$hasUnicode;

});

parcelRegister("h5ULu", function(module, exports) {

$parcel$export(module.exports, "default", () => $c71eef9ea1732fba$export$2e2bcd8739ae039);

var $aEW27 = parcelRequire("aEW27");

var $6MCUi = parcelRequire("6MCUi");

var $llmuY = parcelRequire("llmuY");
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $c71eef9ea1732fba$var$stringToArray(string) {
    return (0, $6MCUi.default)(string) ? (0, $llmuY.default)(string) : (0, $aEW27.default)(string);
}
var $c71eef9ea1732fba$export$2e2bcd8739ae039 = $c71eef9ea1732fba$var$stringToArray;

});
parcelRegister("aEW27", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c2aa7f8f772b324$export$2e2bcd8739ae039);
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $7c2aa7f8f772b324$var$asciiToArray(string) {
    return string.split("");
}
var $7c2aa7f8f772b324$export$2e2bcd8739ae039 = $7c2aa7f8f772b324$var$asciiToArray;

});

parcelRegister("llmuY", function(module, exports) {

$parcel$export(module.exports, "default", () => $f89d02de0bef2564$export$2e2bcd8739ae039);
/** Used to compose unicode character classes. */ var $f89d02de0bef2564$var$rsAstralRange = "\ud800-\udfff", $f89d02de0bef2564$var$rsComboMarksRange = "\\u0300-\\u036f", $f89d02de0bef2564$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $f89d02de0bef2564$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $f89d02de0bef2564$var$rsComboRange = $f89d02de0bef2564$var$rsComboMarksRange + $f89d02de0bef2564$var$reComboHalfMarksRange + $f89d02de0bef2564$var$rsComboSymbolsRange, $f89d02de0bef2564$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $f89d02de0bef2564$var$rsAstral = "[" + $f89d02de0bef2564$var$rsAstralRange + "]", $f89d02de0bef2564$var$rsCombo = "[" + $f89d02de0bef2564$var$rsComboRange + "]", $f89d02de0bef2564$var$rsFitz = "\ud83c[\udffb-\udfff]", $f89d02de0bef2564$var$rsModifier = "(?:" + $f89d02de0bef2564$var$rsCombo + "|" + $f89d02de0bef2564$var$rsFitz + ")", $f89d02de0bef2564$var$rsNonAstral = "[^" + $f89d02de0bef2564$var$rsAstralRange + "]", $f89d02de0bef2564$var$rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", $f89d02de0bef2564$var$rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", $f89d02de0bef2564$var$rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var $f89d02de0bef2564$var$reOptMod = $f89d02de0bef2564$var$rsModifier + "?", $f89d02de0bef2564$var$rsOptVar = "[" + $f89d02de0bef2564$var$rsVarRange + "]?", $f89d02de0bef2564$var$rsOptJoin = "(?:" + $f89d02de0bef2564$var$rsZWJ + "(?:" + [
    $f89d02de0bef2564$var$rsNonAstral,
    $f89d02de0bef2564$var$rsRegional,
    $f89d02de0bef2564$var$rsSurrPair
].join("|") + ")" + $f89d02de0bef2564$var$rsOptVar + $f89d02de0bef2564$var$reOptMod + ")*", $f89d02de0bef2564$var$rsSeq = $f89d02de0bef2564$var$rsOptVar + $f89d02de0bef2564$var$reOptMod + $f89d02de0bef2564$var$rsOptJoin, $f89d02de0bef2564$var$rsSymbol = "(?:" + [
    $f89d02de0bef2564$var$rsNonAstral + $f89d02de0bef2564$var$rsCombo + "?",
    $f89d02de0bef2564$var$rsCombo,
    $f89d02de0bef2564$var$rsRegional,
    $f89d02de0bef2564$var$rsSurrPair,
    $f89d02de0bef2564$var$rsAstral
].join("|") + ")";
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $f89d02de0bef2564$var$reUnicode = RegExp($f89d02de0bef2564$var$rsFitz + "(?=" + $f89d02de0bef2564$var$rsFitz + ")|" + $f89d02de0bef2564$var$rsSymbol + $f89d02de0bef2564$var$rsSeq, "g");
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $f89d02de0bef2564$var$unicodeToArray(string) {
    return string.match($f89d02de0bef2564$var$reUnicode) || [];
}
var $f89d02de0bef2564$export$2e2bcd8739ae039 = $f89d02de0bef2564$var$unicodeToArray;

});





parcelRegister("jUkRP", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7e36f0ccb479e24$export$2e2bcd8739ae039);

var $bIRpd = parcelRequire("bIRpd");

var $jSR8v = parcelRequire("jSR8v");
/**
 * Computes the sum of the values in `array`.
 *
 * @static
 * @memberOf _
 * @since 3.4.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {number} Returns the sum.
 * @example
 *
 * _.sum([4, 2, 8, 6]);
 * // => 20
 */ function $e7e36f0ccb479e24$var$sum(array) {
    return array && array.length ? (0, $bIRpd.default)(array, (0, $jSR8v.default)) : 0;
}
var $e7e36f0ccb479e24$export$2e2bcd8739ae039 = $e7e36f0ccb479e24$var$sum;

});
parcelRegister("bIRpd", function(module, exports) {

$parcel$export(module.exports, "default", () => $888d3b01a66f78b5$export$2e2bcd8739ae039);
/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */ function $888d3b01a66f78b5$var$baseSum(array, iteratee) {
    var result, index = -1, length = array.length;
    while(++index < length){
        var current = iteratee(array[index]);
        if (current !== undefined) result = result === undefined ? current : result + current;
    }
    return result;
}
var $888d3b01a66f78b5$export$2e2bcd8739ae039 = $888d3b01a66f78b5$var$baseSum;

});


parcelRegister("aYbF1", function(module, exports) {

$parcel$export(module.exports, "isCustomDate", () => $7fc88d89e062b1d4$export$d67da1d367d5ef36);
$parcel$export(module.exports, "getTimePeriods", () => $7fc88d89e062b1d4$export$a4a703a4fa2881c3);
$parcel$export(module.exports, "getTimePeriodsByModule", () => $7fc88d89e062b1d4$export$b377597796b52d22);
$parcel$export(module.exports, "getTimePeriodLabelKey", () => $7fc88d89e062b1d4$export$51c376334229fe55);

var $3rLsW = parcelRequire("3rLsW");

var $cstaF = parcelRequire("cstaF");

var $1byMr = parcelRequire("1byMr");
const $7fc88d89e062b1d4$var$excludedTimePeriods = [
    (0, $cstaF.agentProductionTerms).last24Months,
    (0, $cstaF.agentProductionTerms).yearToDate,
    (0, $cstaF.agentProductionTerms).annually,
    (0, $1byMr.terms).last60Days,
    (0, $1byMr.terms).last90Days,
    (0, $1byMr.terms).last180Days,
    (0, $1byMr.terms).last365Days
];
const $7fc88d89e062b1d4$export$d67da1d367d5ef36 = (value)=>value === (0, $cstaF.TimePeriods)["Custom Date"];
const $7fc88d89e062b1d4$export$a4a703a4fa2881c3 = (module)=>(0, $3rLsW.isMarketDynamics)(module) ? (0, $cstaF.marketDynamicsTimePeriods) : (0, $cstaF.TimePeriods);
const $7fc88d89e062b1d4$export$b377597796b52d22 = ({ module: module, mlsMembershipList: mlsMembershipList, selectedMlsId: selectedMlsId })=>{
    const timePeriods = $7fc88d89e062b1d4$export$a4a703a4fa2881c3(module);
    const isMarketDynamicsModule = (0, $3rLsW.isMarketDynamics)(module);
    return Object.keys(timePeriods).filter((timePeriodKey)=>!$7fc88d89e062b1d4$var$excludedTimePeriods.includes(timePeriodKey)).map((timePeriod)=>{
        let option = {
            value: timePeriods[timePeriod],
            label: timePeriod
        };
        if (isMarketDynamicsModule && mlsMembershipList && timePeriods[timePeriod] === (0, $cstaF.marketDynamicsTimePeriods)[(0, $cstaF.marketDynamicsTerms).years3Quarterly]) {
            const isMlsSupport3YearsOption = mlsMembershipList.length && mlsMembershipList?.find((mls)=>mls.mlsId === selectedMlsId)?.supports13Quarters;
            return {
                ...option,
                isDisabled: !isMlsSupport3YearsOption
            };
        }
        return option;
    });
};
const $7fc88d89e062b1d4$export$51c376334229fe55 = (value)=>{
    return Object.keys((0, $cstaF.TimePeriods)).find((key)=>(0, $cstaF.TimePeriods)[key] === value);
};

});
parcelRegister("3rLsW", function(module, exports) {

$parcel$export(module.exports, "isMarketDynamics", () => $2828b670b878ccf3$export$a7bf5fed5058f854);

var $cstaF = parcelRequire("cstaF");
const $2828b670b878ccf3$export$a7bf5fed5058f854 = (module)=>module === (0, $cstaF.moduleNames).marketDynamics;

});

parcelRegister("1byMr", function(module, exports) {

$parcel$export(module.exports, "terms", () => $0dd1cc27f4749eee$export$8a21ba990ca4a7cb);
$parcel$export(module.exports, "filterIds", () => $0dd1cc27f4749eee$export$691234149d9c7e3b);
$parcel$export(module.exports, "filterValues", () => $0dd1cc27f4749eee$export$171b31829f46f49a);
const $0dd1cc27f4749eee$export$8a21ba990ca4a7cb = {
    searchFilterAdjust: "Please adjust your search filters to find agents you're looking for",
    agentMovement: "Agent Movement",
    last60Days: "Last 60 Days",
    last90Days: "Last 90 Days",
    last180Days: "Last 180 Days",
    last365Days: "Last 365 Days"
};
const $0dd1cc27f4749eee$export$691234149d9c7e3b = {
    period: "agent-movement-period-dropdown",
    menu: "agent-movement-period-menu",
    metrics: "agent-movement-metrics-dropdown",
    last365: "last-365-days-item"
};
const $0dd1cc27f4749eee$export$171b31829f46f49a = {
    last365Days: "Last365Days"
};

});


parcelRegister("4EYT7", function(module, exports) {

$parcel$export(module.exports, "terms", () => $364a20ee0e410aa2$export$8a21ba990ca4a7cb);
$parcel$export(module.exports, "periodDropdownItems", () => $364a20ee0e410aa2$export$482e55978c801541);
$parcel$export(module.exports, "viewTypes", () => $364a20ee0e410aa2$export$811d3b07089d5dd3);
const $364a20ee0e410aa2$export$8a21ba990ca4a7cb = Object.freeze({
    dashboard: "Dashboard",
    welcome: "Hi [AGENT_NAME], let's make real estate happen.",
    last12Months: "Last 12 Months",
    recruitingActivity: "Recruiting Activity",
    last30Days: "Last 30 days",
    seeAll: "See All",
    savedAgentActivities: "SAVED AGENT ACTIVITIES",
    noAgentsTrackedYet: "No Agents Tracked Yet",
    noAgentsOnYourRadarYet: "No agents on your radar yet.",
    saveOneToFollowTheirActivity: "Save one to follow their activity.",
    noNewActivity: "No New Activity",
    noNewActivityMessage: "Your followed agents haven't had any recent updates.",
    allMlsAndPropertyTypes: "All MLS & Property Types",
    transactionVolume: "Transaction Volume",
    marketAverage: "Market Average",
    selectedOffice: "Selected Office",
    errorLoadingData: "Failed to load activity data",
    closedSaleAt: "Closed sale at",
    listed: "Listed",
    agentProductivity: "Agent Productivity",
    topProducers: "Top Producers",
    atRisk: "At Risk",
    noAgentActivityTitle: "Awaiting Agent Activity",
    noAgentActivityMessage1: "Agent productivity stats will appear here",
    noAgentActivityMessage2: "once activity is recorded.",
    supplyAmpDemand: "Supply & Demand",
    supplyOfInventoryTitle: (currentMsi)=>`${currentMsi} Months Supply of Inventory`,
    averageDaysOnMarketTitle: (currentAvgDom)=>`${currentAvgDom} Average Days on Market`,
    supplyOfInventory: (monthName, currentMsi, msiDirection)=>`${monthName}'s Supply of Inventory is currently ${currentMsi} months. ${msiDirection} from the same period last year.`,
    averageDaysOnMarket: (monthName, currentAvgDom, avgDomDirection)=>`${monthName}'s Average Days on Market is currently ${currentAvgDom} days. ${avgDomDirection} from the same period last year.`,
    upwardShift: "This is an UPWARD shift",
    downwardShift: "This is a DOWNWARD shift",
    noChange: "There is NO CHANGE",
    emptySupplyAndDemandData: "No supply and demand data available for the selected MLS."
});
const $364a20ee0e410aa2$export$482e55978c801541 = [
    {
        dataLwtId: "no-split-item1",
        itemText: $364a20ee0e410aa2$export$8a21ba990ca4a7cb.last12Months,
        key: "item_1"
    }
];
const $364a20ee0e410aa2$export$811d3b07089d5dd3 = {
    byOffice: {
        id: "byOffice",
        label: "By Office"
    },
    byBrokerage: {
        id: "byBrokerage",
        label: "By Brokerage"
    }
};

});


parcelRegister("3FMCA", function(module, exports) {

$parcel$export(module.exports, "defaultTitles", () => $2acaea9eb8a552a4$export$c9bb0e60410dfb2f);
$parcel$export(module.exports, "viewByModule", () => $2acaea9eb8a552a4$export$dd6eebe5f1afb054);

var $cstaF = parcelRequire("cstaF");

var $5269x = parcelRequire("5269x");

var $5lFnP = parcelRequire("5lFnP");

var $1G8OF = parcelRequire("1G8OF");

var $gzAOa = parcelRequire("gzAOa");
const $2acaea9eb8a552a4$export$c9bb0e60410dfb2f = {
    propertyTypeTitle: {
        mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).propertyTypes)
    },
    timeFrameTitle: {
        mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).timeFrame)
    },
    totalVolumeTitle: {
        mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).totalVolume)
    },
    soldPriceRangeTitle: {
        mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).soldPriceRange)
    },
    priceRangeTitle: {
        mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).priceRange)
    },
    totalUnitsTitle: {
        mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).totalUnits)
    },
    bedroomsTitle: {
        mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).bedrooms)
    },
    fullBathroomsTitle: {
        mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).fullBathrooms)
    },
    marketAreaTitle: (module)=>({
            mainTitle: (0, $5269x.getMarketAreaMainTitle)({
                module: module.id
            })
        }),
    areaTypeTitle: {
        mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).areaType)
    },
    listingStatusTitle: {
        mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).listingStatus)
    },
    officesTitle: {
        mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).offices)
    },
    agentsTitle: {
        mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).agents)
    },
    lotSizeTitle: {
        mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).lotSize)
    },
    squareFootageTitle: {
        mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).squareFootage)
    },
    comparisonSetTitle: {
        mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).comparisonSet)
    },
    constructionTypeTitle: {
        mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).constructionType)
    }
};
const $2acaea9eb8a552a4$export$dd6eebe5f1afb054 = {
    [(0, $cstaF.modules).proficiencyMetrics.transactions]: (0, $5lFnP.transactionsSearchView),
    [(0, $cstaF.modules).proficiencyMetrics.offices]: (0, $5lFnP.officeSearchView),
    [(0, $cstaF.modules).proficiencyMetrics.agents]: (0, $5lFnP.agentSearchView),
    [(0, $cstaF.modules).proficiencyMetrics.agentMovement]: (0, $5lFnP.agentMovementSearchView),
    [(0, $cstaF.modules).marketShare.totals]: (0, $1G8OF.marketTotalsView),
    [(0, $cstaF.modules).marketShare.coverage]: (0, $1G8OF.marketCoverageView),
    [(0, $cstaF.modules).marketDynamics.marketDynamics]: (0, $gzAOa.marketDynamicsView)
};

});
parcelRegister("5lFnP", function(module, exports) {

$parcel$export(module.exports, "transactionsSearchView", () => $3e4f03cd7ab24807$export$fa6e1cbc2882b8a6);
$parcel$export(module.exports, "officeSearchView", () => $3e4f03cd7ab24807$export$101eb10a7d9aed02);
$parcel$export(module.exports, "agentSearchView", () => $3e4f03cd7ab24807$export$3fa9837b18855cd);
$parcel$export(module.exports, "suggestedAgentsSearchView", () => $3e4f03cd7ab24807$export$39073e1f29d3ea38);
$parcel$export(module.exports, "agentMovementSearchView", () => $3e4f03cd7ab24807$export$41aa288e2129b9f0);
$parcel$export(module.exports, "savedAgentsSearchView", () => $3e4f03cd7ab24807$export$33630bc9e604a4b0);

var $fPGDZ = parcelRequire("fPGDZ");

var $9QX0f = parcelRequire("9QX0f");

var $cstaF = parcelRequire("cstaF");

var $aypMh = parcelRequire("aypMh");

var $1byMr = parcelRequire("1byMr");

var $53A0d = parcelRequire("53A0d");

var $eHBjM = parcelRequire("eHBjM");
const $3e4f03cd7ab24807$var$persistedProfMetricsView = {
    currentTab: (0, $fPGDZ.tabIndexes).OVERVIEW
};
const $3e4f03cd7ab24807$export$fa6e1cbc2882b8a6 = (initialView)=>({
        ...initialView,
        ...$3e4f03cd7ab24807$var$persistedProfMetricsView,
        id: (0, $cstaF.modules).proficiencyMetrics.transactions,
        selectedPropTypes: [],
        selectedMarketAreaList: undefined,
        selectedViewHideAgentsFilter: (0, $eHBjM.viewHideAgentsDropdownLabels).viewHideAgents,
        marketAreaTitle: {
            mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).marketArea)
        },
        propertyTypeTitle: {
            mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).propertyTypes)
        },
        totalVolumeTitle: {
            mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).totalVolume)
        },
        soldPriceRangeTitle: {
            mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).soldPriceRange)
        },
        totalUnitsTitle: {
            mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).totalUnits)
        },
        bedroomsTitle: {
            mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).bedrooms)
        },
        fullBathroomsTitle: {
            mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).fullBathrooms)
        },
        searchFilters: [
            (0, $cstaF.searchTerms).savedSearchFilter,
            (0, $cstaF.searchTerms).mlsFilter,
            (0, $cstaF.searchTerms).marketAreaFilter,
            (0, $cstaF.searchTerms).propTypeFilter,
            (0, $cstaF.searchTerms).timeFrameFilter
        ]
    });
const $3e4f03cd7ab24807$export$101eb10a7d9aed02 = (initialView)=>({
        ...initialView,
        ...$3e4f03cd7ab24807$var$persistedProfMetricsView,
        id: (0, $cstaF.modules).proficiencyMetrics.offices,
        selectedViewHideAgentsFilter: (0, $eHBjM.viewHideAgentsDropdownLabels).viewHideAgents,
        officesTitle: {
            mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).offices)
        },
        totalVolumeTitle: {
            mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).totalVolume)
        },
        soldPriceRangeTitle: {
            mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).soldPriceRange)
        },
        totalUnitsTitle: {
            mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).totalUnits)
        },
        searchFilters: [
            (0, $cstaF.searchTerms).savedSearchFilter,
            (0, $cstaF.searchTerms).mlsFilter,
            (0, $cstaF.searchTerms).timeFrameFilter,
            (0, $cstaF.searchTerms).officesFilter
        ],
        selectedRowIndex: undefined
    });
const $3e4f03cd7ab24807$export$3fa9837b18855cd = (initialView)=>({
        ...initialView,
        ...$3e4f03cd7ab24807$var$persistedProfMetricsView,
        id: (0, $cstaF.modules).proficiencyMetrics.agents,
        selectedViewHideAgentsFilter: (0, $eHBjM.viewHideAgentsDropdownLabels).viewHideAgents,
        agents: [],
        selectedPropTypes: [],
        propertyTypeTitle: {
            mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).propertyTypes)
        },
        agentsTitle: {
            mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).agents)
        },
        soldPriceRangeTitle: {
            mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).soldPriceRange)
        },
        searchFilters: [
            (0, $cstaF.searchTerms).savedSearchFilter,
            (0, $cstaF.searchTerms).mlsFilter,
            (0, $cstaF.searchTerms).propTypeFilter,
            (0, $cstaF.searchTerms).timeFrameFilter,
            (0, $cstaF.searchTerms).agentsFilter
        ]
    });
const $3e4f03cd7ab24807$var$getTabCommonOptions = (tabId)=>({
        display: {
            selectedView: $3e4f03cd7ab24807$var$producerOptionById[tabId].defaultView,
            selectedAgentsView: (0, $aypMh.showOptions)[0]
        },
        producers: $3e4f03cd7ab24807$var$producerOptionById[tabId],
        growthAnalysisPeriod: {
            value: (0, $cstaF.agentProductionTerms).last12Months
        }
    });
const $3e4f03cd7ab24807$var$producerOptionById = {
    [(0, $9QX0f.tabs).topProducers.id]: {
        defaultView: (0, $9QX0f.allViewOptions)[0],
        lowPos: (0, $9QX0f.producerOptions).lowPos[0],
        validationSettings: {}
    },
    [(0, $9QX0f.tabs).incProducers.id]: {
        defaultView: (0, $9QX0f.allViewOptions)[2],
        minGrowth: "10",
        maxGrowth: "",
        timeFrame: (0, $9QX0f.producerOptions).timeFrame[0],
        growthTimeFrame: (0, $9QX0f.growthAnalysisIncDecTimeFrame)[0],
        validationSettings: {}
    },
    [(0, $9QX0f.tabs).decProducers.id]: {
        defaultView: (0, $9QX0f.allViewOptions)[2],
        minGrowth: "10",
        maxGrowth: "",
        timeFrame: (0, $9QX0f.producerOptions).timeFrame[0],
        growthTimeFrame: (0, $9QX0f.growthAnalysisIncDecTimeFrame)[0],
        validationSettings: {}
    },
    [(0, $9QX0f.tabs).newProducers.id]: {
        defaultView: (0, $9QX0f.allViewOptions)[0],
        newProd: (0, $9QX0f.producerOptions).newProd[1],
        inactivity: (0, $9QX0f.producerOptions).inactivity[1],
        validationSettings: {}
    },
    [(0, $9QX0f.tabs).coopAgents.id]: {
        defaultView: (0, $9QX0f.allViewOptions)[0],
        timePeriod: (0, $9QX0f.producerOptions).timePeriod[0],
        validationSettings: {}
    }
};
const $3e4f03cd7ab24807$export$39073e1f29d3ea38 = (initialView)=>({
        ...initialView,
        currentTabIndex: (0, $9QX0f.tabs).topProducers.index,
        currentTabId: Object.values((0, $9QX0f.tabs))[(0, $9QX0f.tabs).topProducers.index].id,
        id: (0, $cstaF.modules).proficiencyMetrics.suggestedAgents,
        selectedPropTypes: [],
        selectedMarketAreaList: undefined,
        searchFilters: [
            (0, $cstaF.searchTerms).mlsFilter
        ],
        searchOptions: {
            topProducers: {
                ...$3e4f03cd7ab24807$var$getTabCommonOptions((0, $9QX0f.tabs).topProducers.id)
            },
            incProducers: {
                ...$3e4f03cd7ab24807$var$getTabCommonOptions((0, $9QX0f.tabs).incProducers.id)
            },
            decProducers: {
                ...$3e4f03cd7ab24807$var$getTabCommonOptions((0, $9QX0f.tabs).decProducers.id)
            },
            newProducers: {
                ...$3e4f03cd7ab24807$var$getTabCommonOptions((0, $9QX0f.tabs).newProducers.id)
            },
            coopAgents: {
                ...$3e4f03cd7ab24807$var$getTabCommonOptions((0, $9QX0f.tabs).coopAgents.id)
            }
        },
        selectedAgentIdsByTab: {}
    });
const $3e4f03cd7ab24807$var$persistedAgentMovementView = {
    breakdowns: (0, $53A0d.initialBreakdownState)
};
const $3e4f03cd7ab24807$export$41aa288e2129b9f0 = (initialView)=>({
        ...initialView,
        ...$3e4f03cd7ab24807$var$persistedAgentMovementView,
        id: (0, $cstaF.modules).proficiencyMetrics.agentMovement,
        officesTitle: {
            mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).offices)
        },
        searchFilters: [
            (0, $cstaF.searchTerms).savedSearchFilter,
            (0, $cstaF.searchTerms).mlsFilter,
            (0, $cstaF.searchTerms).officesFilter
        ],
        search: {
            ...initialView.search,
            searchCriteria: {
                criteria: {
                    timePeriod: {
                        intervalType: (0, $1byMr.filterValues).last365Days
                    }
                }
            }
        }
    });
const $3e4f03cd7ab24807$export$33630bc9e604a4b0 = (initialView)=>({
        ...initialView,
        ...$3e4f03cd7ab24807$var$persistedProfMetricsView,
        id: (0, $cstaF.modules).proficiencyMetrics.savedAgents,
        selectedPropTypes: [],
        selectedMarketAreaList: undefined,
        selectedView: (0, $aypMh.viewOptions)[0],
        selectedListByModule: {
            [(0, $cstaF.modules).proficiencyMetrics.agents]: undefined,
            [(0, $cstaF.modules).proficiencyMetrics.savedAgents]: undefined
        },
        agentList: undefined,
        propertyTypeNames: [],
        isLoading: false,
        agentListsCheckedValues: {},
        popoverDataForAddAgentList: {},
        ...(0, $cstaF.initialOptionalFilterTitles),
        searchFilters: [
            (0, $cstaF.searchTerms).savedSearchFilter,
            (0, $cstaF.searchTerms).mlsFilter,
            (0, $cstaF.searchTerms).marketAreaFilter,
            (0, $cstaF.searchTerms).propTypeFilter,
            (0, $cstaF.searchTerms).timeFrameFilter
        ],
        selectedViewHideAgentsFilter: (0, $aypMh.types).SHOW_ALL_AGENTS
    });

});
parcelRegister("53A0d", function(module, exports) {

$parcel$export(module.exports, "tabs", () => $3ae928e9307c45d6$export$39f5674517ec0000);
$parcel$export(module.exports, "initialBreakdownState", () => $3ae928e9307c45d6$export$dff077666fd4d17f);
$parcel$export(module.exports, "OFFICE_BRKDWN_GROWTH_TAB_INDEX", () => $3ae928e9307c45d6$export$fb7877f8312cf187);

var $cstaF = parcelRequire("cstaF");
const $3ae928e9307c45d6$export$39f5674517ec0000 = {
    GAINED_AGENTS: 0,
    LOST_AGENTS: 1,
    OFFICE_DETAILS: 2
};
const $3ae928e9307c45d6$export$a14162e6160bb957 = {
    shouldShowAdditionalInfo: false,
    isFooterDisabled: false,
    listingStatus: {
        label: ""
    }
};
const $3ae928e9307c45d6$var$initialTabsState = {
    [$3ae928e9307c45d6$export$39f5674517ec0000.GAINED_AGENTS]: $3ae928e9307c45d6$export$a14162e6160bb957,
    [$3ae928e9307c45d6$export$39f5674517ec0000.LOST_AGENTS]: $3ae928e9307c45d6$export$a14162e6160bb957,
    [$3ae928e9307c45d6$export$39f5674517ec0000.OFFICE_DETAILS]: $3ae928e9307c45d6$export$a14162e6160bb957
};
const $3ae928e9307c45d6$export$dff077666fd4d17f = Object.freeze({
    selectedBreakdownTab: $3ae928e9307c45d6$export$39f5674517ec0000.GAINED_AGENTS,
    tabsByRoute: {
        [(0, $cstaF.searchRoutes).agentsGainedBreakdown]: $3ae928e9307c45d6$var$initialTabsState,
        [(0, $cstaF.searchRoutes).officeListBreakdown]: $3ae928e9307c45d6$var$initialTabsState
    }
});
const $3ae928e9307c45d6$export$fb7877f8312cf187 = 2;

});


parcelRegister("1G8OF", function(module, exports) {

$parcel$export(module.exports, "marketTotalsView", () => $13908d6906b1f7a4$export$5c085c245ba66ba7);
$parcel$export(module.exports, "marketCoverageView", () => $13908d6906b1f7a4$export$e15d8e4f6cb9d224);

var $cstaF = parcelRequire("cstaF");

var $4UTP7 = parcelRequire("4UTP7");
const $13908d6906b1f7a4$var$persistedMarketShareTotalsView = {
    listingType: undefined,
    listingViewId: (0, $4UTP7.listingViews).total$Volume.id
};
const $13908d6906b1f7a4$export$5c085c245ba66ba7 = (initialView)=>({
        ...initialView,
        ...$13908d6906b1f7a4$var$persistedMarketShareTotalsView,
        id: (0, $cstaF.modules).marketShare.totals,
        selectedPropTypes: [],
        selectedComparisonSetSearch: undefined,
        marketAreaTitle: {
            mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).marketArea)
        },
        propertyTypeTitle: {
            mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).propertyTypes)
        },
        listingStatusTitle: {
            mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).listingStatus)
        },
        priceRangeTitle: {
            mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).priceRange)
        },
        bedroomsTitle: {
            mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).bedrooms)
        },
        fullBathroomsTitle: {
            mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).fullBathrooms)
        },
        comparisonSetTitle: {
            mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).comparisonSet)
        },
        searchFilters: [
            (0, $cstaF.searchTerms).savedSearchFilter,
            (0, $cstaF.searchTerms).mlsFilter,
            (0, $cstaF.searchTerms).marketAreaFilter,
            (0, $cstaF.searchTerms).propTypeFilter,
            (0, $cstaF.searchTerms).timeFrameFilter,
            (0, $cstaF.searchTerms).listingStatusFilter
        ],
        showHideOptions: {},
        selectedColumnId: null
    });
const $13908d6906b1f7a4$export$e15d8e4f6cb9d224 = (initialView)=>({
        ...initialView,
        listingViewId: (0, $4UTP7.listingViews).total$Volume.id,
        id: (0, $cstaF.modules).marketShare.coverage,
        selectedPropTypes: [],
        areaTypeTitle: {
            mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).areaType)
        },
        propertyTypeTitle: {
            mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).propertyTypes)
        },
        listingStatusTitle: {
            mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).listingStatus)
        },
        officesTitle: {
            mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).offices)
        },
        priceRangeTitle: {
            mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).priceRange)
        },
        bedroomsTitle: {
            mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).bedrooms)
        },
        fullBathroomsTitle: {
            mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).fullBathrooms)
        },
        searchFilters: [
            (0, $cstaF.searchTerms).savedSearchFilter,
            (0, $cstaF.searchTerms).mlsFilter,
            (0, $cstaF.searchTerms).areaTypeFilter,
            (0, $cstaF.searchTerms).propTypeFilter,
            (0, $cstaF.searchTerms).timeFrameFilter,
            (0, $cstaF.searchTerms).listingStatusFilter,
            (0, $cstaF.searchTerms).officesFilter
        ],
        showHideOptions: {},
        selectedColumnId: null
    });

});

parcelRegister("gzAOa", function(module, exports) {

$parcel$export(module.exports, "breakdownTabs", () => $c10c778ba3b12656$export$4a38b2c60320cac1);
$parcel$export(module.exports, "initialFooterDisabledState", () => $c10c778ba3b12656$export$2180039d5a9336ee);
$parcel$export(module.exports, "initialBreakdownsState", () => $c10c778ba3b12656$export$e4dd9791683b931d);
$parcel$export(module.exports, "marketDynamicsView", () => $c10c778ba3b12656$export$b9d339fd25672d89);

var $cstaF = parcelRequire("cstaF");

var $g7mFm = parcelRequire("g7mFm");
const $c10c778ba3b12656$export$4a38b2c60320cac1 = {
    OFFICE: 0,
    LISTING_1: 1,
    LISTING_2: 2,
    LISTING_3: 3
};
const $c10c778ba3b12656$export$2180039d5a9336ee = {
    isFooterDisabled: true
};
const $c10c778ba3b12656$export$2852b47dec708eac = {
    ...$c10c778ba3b12656$export$2180039d5a9336ee,
    shouldShowAdditionalInfo: false
};
const $c10c778ba3b12656$export$cb06e06f4904cc66 = {
    ...$c10c778ba3b12656$export$2852b47dec708eac,
    listingStatus: {
        label: ""
    }
};
const $c10c778ba3b12656$export$e4dd9791683b931d = Object.freeze({
    selectedBreakdownTab: $c10c778ba3b12656$export$4a38b2c60320cac1.OFFICE,
    tabsByRoute: {
        [(0, $g7mFm.officeBreakdownRoute)]: {
            [$c10c778ba3b12656$export$4a38b2c60320cac1.OFFICE]: $c10c778ba3b12656$export$2852b47dec708eac,
            [$c10c778ba3b12656$export$4a38b2c60320cac1.LISTING_1]: $c10c778ba3b12656$export$cb06e06f4904cc66,
            [$c10c778ba3b12656$export$4a38b2c60320cac1.LISTING_2]: $c10c778ba3b12656$export$cb06e06f4904cc66,
            [$c10c778ba3b12656$export$4a38b2c60320cac1.LISTING_3]: $c10c778ba3b12656$export$cb06e06f4904cc66
        },
        [(0, $g7mFm.listingsBreakdownRoute)]: {
            [$c10c778ba3b12656$export$4a38b2c60320cac1.OFFICE]: $c10c778ba3b12656$export$2852b47dec708eac,
            [$c10c778ba3b12656$export$4a38b2c60320cac1.LISTING_1]: $c10c778ba3b12656$export$cb06e06f4904cc66,
            [$c10c778ba3b12656$export$4a38b2c60320cac1.LISTING_2]: $c10c778ba3b12656$export$cb06e06f4904cc66,
            [$c10c778ba3b12656$export$4a38b2c60320cac1.LISTING_3]: $c10c778ba3b12656$export$cb06e06f4904cc66
        },
        [(0, $g7mFm.officeListingsRoute)]: {
            [$c10c778ba3b12656$export$4a38b2c60320cac1.OFFICE]: $c10c778ba3b12656$export$2852b47dec708eac,
            [$c10c778ba3b12656$export$4a38b2c60320cac1.LISTING_1]: $c10c778ba3b12656$export$cb06e06f4904cc66,
            [$c10c778ba3b12656$export$4a38b2c60320cac1.LISTING_2]: $c10c778ba3b12656$export$cb06e06f4904cc66,
            [$c10c778ba3b12656$export$4a38b2c60320cac1.LISTING_3]: $c10c778ba3b12656$export$cb06e06f4904cc66
        }
    }
});
const $c10c778ba3b12656$var$persistedMarketDynamicsView = {
    listingViewId: "overview",
    breakdowns: $c10c778ba3b12656$export$e4dd9791683b931d,
    listingStatusByView: {}
};
const $c10c778ba3b12656$export$b9d339fd25672d89 = (initialView)=>({
        ...initialView,
        ...$c10c778ba3b12656$var$persistedMarketDynamicsView,
        id: (0, $cstaF.modules).marketDynamics.marketDynamics,
        selectedPropTypes: [],
        marketAreaTitle: {
            mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).marketArea)
        },
        propertyTypeTitle: {
            mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).propertyTypes)
        },
        priceRangeTitle: {
            mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).priceRange)
        },
        bedroomsTitle: {
            mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).bedrooms)
        },
        fullBathroomsTitle: {
            mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).fullBathrooms)
        },
        lotSizeTitle: {
            mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).lotSize)
        },
        squareFootageTitle: {
            mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).squareFootage)
        },
        searchFilters: [
            (0, $cstaF.searchTerms).savedSearchFilter,
            (0, $cstaF.searchTerms).mlsFilter,
            (0, $cstaF.searchTerms).marketAreaFilter,
            (0, $cstaF.searchTerms).propTypeFilter,
            (0, $cstaF.searchTerms).timeFrameFilter
        ]
    });

});


parcelRegister("luxkV", function(module, exports) {

$parcel$export(module.exports, "getTotalsOfficeSearch", () => $fa56423c024936e1$export$ced504e353347f2d);
$parcel$export(module.exports, "getTotalsBrokerSearch", () => $fa56423c024936e1$export$d4746b32b43a0511);
$parcel$export(module.exports, "getCoverageSearch", () => $fa56423c024936e1$export$269ab5a7b8d608f4);
$parcel$export(module.exports, "getComparisonSetResults", () => $fa56423c024936e1$export$a9433ac5e36e86a9);

var $chB0Q = parcelRequire("chB0Q");

var $gDxKE = parcelRequire("gDxKE");

var $24YIE = parcelRequire("24YIE");

var $1ujWz = parcelRequire("1ujWz");

var $ae040 = parcelRequire("ae040");
const $fa56423c024936e1$var$searchCriteriaData = (criteria, parameters = [])=>{
    const cleanCriteria = (0, $gDxKE.removeSearchAllMLSFlag)((0, $chB0Q.default)(criteria));
    return [
        {
            parameter: "aergo_search_criteria",
            value: JSON.stringify(cleanCriteria)
        },
        ...parameters
    ];
};
const $fa56423c024936e1$export$ced504e353347f2d = async (criteria)=>{
    return await (0, $24YIE.sendApiRequest)("Market_share_office_search", $fa56423c024936e1$var$searchCriteriaData(criteria), 60000);
};
const $fa56423c024936e1$export$d4746b32b43a0511 = async (criteria)=>{
    return await (0, $24YIE.sendApiRequest)("Market_share_broker_search", $fa56423c024936e1$var$searchCriteriaData(criteria), 60000);
};
const $fa56423c024936e1$export$269ab5a7b8d608f4 = async (criteria)=>{
    return await (0, $24YIE.sendApiRequest)("Market_share_coverage", $fa56423c024936e1$var$searchCriteriaData(criteria), 60000);
};
const $fa56423c024936e1$export$a9433ac5e36e86a9 = async (receivedCriteria)=>{
    const criteria = receivedCriteria.realEstateDatasourceIdsWithFilters[0];
    const comparisonSetIdFromCriteria = criteria?.mlsObjectId;
    const selectedComparisonSet = (0, $ae040.useComparisonSetsStore).getState().comparisonSets?.list.find((cs)=>cs.id === comparisonSetIdFromCriteria);
    const { params: params, transactionStatus: transactionStatus } = (0, $1ujWz.getComparisonSetParams)(receivedCriteria, selectedComparisonSet);
    if (!params.comparisonSet.length) return [];
    const inputParameters = [
        {
            parameter: "comparisonSetParams",
            value: JSON.stringify(params)
        },
        {
            parameter: "transactionStatus",
            value: transactionStatus
        }
    ];
    return await (0, $24YIE.sendApiRequest)("Market_share_comparison_sets", inputParameters);
};

});
parcelRegister("ae040", function(module, exports) {

$parcel$export(module.exports, "initialComparisonSetsState", () => $771b42d42a087c19$export$372c0a3adf682fc4);
$parcel$export(module.exports, "useComparisonSetsStore", () => $771b42d42a087c19$export$3349d006bf13e7e0);

var $9phu9 = parcelRequire("9phu9");

var $28hPD = parcelRequire("28hPD");

var $88tPr = parcelRequire("88tPr");

var $cstaF = parcelRequire("cstaF");
const $771b42d42a087c19$export$372c0a3adf682fc4 = {
    comparisonSets: {
        list: []
    },
    comparisonSetsBySelectedMls: [],
    shouldShowByModal: {
        [(0, $cstaF.comparisonSetsModals).SAVE]: false,
        [(0, $cstaF.comparisonSetsModals).EDIT]: false,
        [(0, $cstaF.comparisonSetsModals).DELETE]: false,
        [(0, $cstaF.comparisonSetsModals).DELETE_OFFICE_GROUP]: false
    },
    selectedMls: undefined,
    comparisonSetListOptions: undefined,
    comparisonSetListOptionsBySelectedMls: undefined,
    selectedComparisonSetOfficesList: undefined,
    comparisonSetResults: {},
    isComparisonSetView: false,
    addedOffices: [],
    officeGroupName: "",
    isOfficeGroupEdit: undefined,
    selectedOfficeGroup: undefined,
    newCompSetName: undefined,
    selectedComparisonSet: undefined,
    isLoading: false,
    hasLoadedComparisonSets: false
};
const $771b42d42a087c19$export$eb462b495d584ebf = (set, get)=>({
        ...$771b42d42a087c19$export$372c0a3adf682fc4,
        ...(0, $28hPD.actions)(set, get)
    });
const $771b42d42a087c19$export$3349d006bf13e7e0 = (0, $9phu9.createWithEqualityFn)((0, $88tPr.devtools)((0, $88tPr.persist)($771b42d42a087c19$export$eb462b495d584ebf, {
    name: "comparison_sets_state",
    storage: (0, $88tPr.createJSONStorage)(()=>sessionStorage)
})));

});
parcelRegister("28hPD", function(module, exports) {

$parcel$export(module.exports, "actions", () => $18da292531cc93d0$export$e324594224ef24da);

var $7ROc5 = parcelRequire("7ROc5");

var $jeANf = parcelRequire("jeANf");

var $iCDWi = parcelRequire("iCDWi");

var $9S3rS = parcelRequire("9S3rS");

var $cstaF = parcelRequire("cstaF");

var $1ujWz = parcelRequire("1ujWz");

var $5NVz0 = parcelRequire("5NVz0");

var $lEGzp = parcelRequire("lEGzp");

var $24YIE = parcelRequire("24YIE");

var $90ISC = parcelRequire("90ISC");

var $ae040 = parcelRequire("ae040");

var $dDBOF = parcelRequire("dDBOF");
const $18da292531cc93d0$export$e324594224ef24da = (set, get)=>({
        skipComparisonSetsLoad: ()=>{
            set({
                isLoading: false,
                comparisonSets: (0, $ae040.initialComparisonSetsState).comparisonSets,
                hasLoadedComparisonSets: true
            });
        },
        getComparisonSetsByUser: async (userAccountId)=>{
            try {
                if (0, $dDBOF.isAgentMetrics) {
                    get().skipComparisonSetsLoad();
                    return;
                }
                const commonStore = (0, $90ISC.useCommonStore).getState();
                const userProducts = commonStore.privileges?.userProducts || [];
                const hasMarketShareAccess = userProducts.includes((0, $cstaF.moduleNames).marketShare);
                if (commonStore.privileges && !hasMarketShareAccess) {
                    get().skipComparisonSetsLoad();
                    return;
                }
                set({
                    isLoading: true
                });
                const response = await (0, $lEGzp.getComparisonSetsByUser)(userAccountId);
                if (response === 404) {
                    get().skipComparisonSetsLoad();
                    return;
                }
                const comparisonSets = !response?.error ? response : (0, $ae040.initialComparisonSetsState).comparisonSets;
                set({
                    isLoading: false,
                    comparisonSets: comparisonSets,
                    hasLoadedComparisonSets: true
                });
            } catch (err) {
                console.error(err, "Error getting comparison sets");
                set({
                    isLoading: false,
                    error: err.message,
                    hasLoadedComparisonSets: true
                });
            }
        },
        handleComparisonSetNameChange: (e, setState)=>{
            const input = e.target.value;
            const newCompSetName = get().newCompSetName;
            const selectedCompSetName = get().selectedComparisonSet?.name;
            const newState = {
                isSaveButtonDisabled: newCompSetName === selectedCompSetName
            };
            setState((prevState)=>({
                    ...prevState,
                    ...newState
                }));
            set({
                newCompSetName: input.toString()
            });
        },
        createNewCompSet: ({ setState: setState, comparisonSets: comparisonSets, selectedMlsDescription: selectedMlsDescription, saveModal: saveModal, userAccount: userAccount, selectedMlsId: selectedMlsId, newCompSetName: newCompSetName })=>{
            (0, $24YIE.saveComparisonSet)(newCompSetName, userAccount?.id, selectedMlsId).then((savedComparisonSet)=>{
                if (savedComparisonSet?.error) throw new Error(savedComparisonSet?.error);
                const mlsList = (0, $90ISC.useCommonStore).getState().mlsList;
                const mlsToSet = {
                    ...mlsList?.filter((mls)=>mls.mlsId === savedComparisonSet.mlsId)[0]
                };
                const savedSetOption = {
                    ...savedComparisonSet,
                    label: (0, $cstaF.marketShareTerms).getComparisonSetLabel(newCompSetName, selectedMlsDescription),
                    value: savedComparisonSet.id
                };
                const comparisonSetsList = comparisonSets?.list ?? [];
                set((prevState)=>({
                        comparisonSets: {
                            list: [
                                savedComparisonSet,
                                ...comparisonSetsList
                            ]
                        },
                        comparisonSetListOptions: [
                            savedSetOption,
                            ...prevState.comparisonSetListOptions
                        ],
                        selectedComparisonSet: savedSetOption
                    }));
                get().handleMlsChange({
                    label: (0, $cstaF.marketShareTerms).getComparisonSetLabel(mlsToSet?.shortDescription, mlsToSet?.longDescription),
                    value: mlsToSet
                });
                (0, $jeANf.showToast)((0, $jeANf.toastTypes).success, (0, $cstaF.marketShareTerms).getCreatedComparisonSetMessage(`${newCompSetName} (${selectedMlsDescription})`), setState);
            }).catch((e)=>{
                (0, $jeANf.showToast)((0, $jeANf.toastTypes).error, (0, $cstaF.marketShareTerms).createComparisonSetsError, setState);
                console.error((0, $cstaF.marketShareTerms).createComparisonSetsError, e);
            }).finally(()=>{
                get().toggleModal(false, saveModal);
            });
        },
        renameComparisonSet: ({ setState: setState, comparisonSets: comparisonSets, selectedMlsDescription: selectedMlsDescription, saveModal: saveModal, newCompSetName: newCompSetName })=>{
            const selectedCompSet = get().selectedComparisonSet;
            (0, $24YIE.updateComparisonSet)({
                ...selectedCompSet,
                name: newCompSetName
            }, [
                ...selectedCompSet.groups
            ]).then((updatedComparisonSet)=>{
                if (updatedComparisonSet?.error) throw new Error(updatedComparisonSet?.error);
                const comparisonSetIndex = comparisonSets?.list.findIndex((cs)=>cs.id === updatedComparisonSet.id);
                const savedSetOption = {
                    label: (0, $cstaF.marketShareTerms).getComparisonSetLabel(updatedComparisonSet?.name, selectedMlsDescription),
                    value: updatedComparisonSet.id,
                    ...updatedComparisonSet
                };
                (0, $jeANf.showToast)((0, $jeANf.toastTypes).success, (0, $cstaF.marketShareTerms).getCompNameUpdatedMsg(updatedComparisonSet?.name), setState);
                if (comparisonSetIndex > -1 && comparisonSets.list.length) comparisonSets.list[comparisonSetIndex] = {
                    ...comparisonSets.list[comparisonSetIndex],
                    ...updatedComparisonSet
                };
                const updatedComparisonSetListOptions = get().comparisonSetListOptions.map((cs)=>cs.id === updatedComparisonSet.id ? savedSetOption : cs);
                set({
                    comparisonSets: comparisonSets,
                    comparisonSetListOptions: updatedComparisonSetListOptions,
                    selectedComparisonSet: savedSetOption
                });
            }).catch((e)=>{
                (0, $jeANf.showToast)((0, $jeANf.toastTypes).error, (0, $cstaF.marketShareTerms).createComparisonSetsError, setState);
                console.error((0, $cstaF.marketShareTerms).updateOfficeGroupError, e);
            }).finally(()=>{
                get().toggleModal(false, saveModal);
                get().clearState();
            });
        },
        removeComparisonSetFromSavedSearches: async (selectedCompSet)=>{
            const searchStore = (0, $90ISC.useSearchStore).getState();
            const module = (0, $cstaF.modules).marketShare.totals;
            const search = searchStore[module];
            const savedSearchList = search?.savedSearchList;
            if (!savedSearchList?.length) return;
            const revisedSavedSearches = savedSearchList.filter((ss)=>(0, $iCDWi.getCriteriaObject)(ss?.savedSearch.searchCriteria)?.mlsObjectId === selectedCompSet.id).map((ss)=>(0, $iCDWi.getUpdatedObjectByKeyfield)(ss, "mlsObjectId", undefined));
            const updateSavedSearchCalls = revisedSavedSearches.map((ss)=>(0, $24YIE.updateSavedSearch)(ss));
            try {
                await Promise.all(updateSavedSearchCalls);
            } catch (err) {
                console.error((0, $cstaF.marketShareTerms).errorUpdatingSavedSearches, err);
            }
        },
        deleteComparisonSet: (selectedCompSet, userInfoId, setState)=>{
            if (!selectedCompSet) return;
            get().setIsLoading(true);
            (0, $24YIE.deleteComparisonSet)(selectedCompSet).then(async (removedComparisonSet)=>{
                if (removedComparisonSet?.error) throw new Error((0, $cstaF.marketShareTerms).getRemovedComparisonSetErrorMessage(selectedCompSet.name));
                await get().getComparisonSetsByUser(userInfoId, true);
                get().setIsLoading(false);
                (0, $jeANf.showToast)((0, $jeANf.toastTypes).success, (0, $cstaF.marketShareTerms).getRemovedComparisonSetMessage(removedComparisonSet.name), setState);
                get().handleSelectedComparisonSet(undefined);
                get().buildComparisonSetOptions();
                get().removeComparisonSetFromSavedSearches(selectedCompSet);
                get().toggleModal(false, (0, $cstaF.comparisonSetsModals).DELETE);
            }).catch(()=>{
                get().setIsLoading(false);
                (0, $jeANf.showToast)((0, $jeANf.toastTypes).error, (0, $cstaF.marketShareTerms).getRemovedComparisonSetErrorMessage(selectedCompSet.name), setState);
            });
        },
        handleSaveComparisonSet: ({ setState: setState, defaultMlsOption: defaultMlsOption, comparisonSets: comparisonSets, isEdit: isEdit = false, selectedMls: selectedMls })=>{
            const newCompSetName = get().newCompSetName;
            const mls = selectedMls ?? defaultMlsOption;
            const selectedMlsId = mls?.value?.mlsId;
            const selectedMlsSets = comparisonSets?.list?.filter((comparisonSet)=>comparisonSet.mlsId === selectedMlsId);
            const userAccount = (0, $90ISC.useCommonStore).getState().userInfo;
            const selectedMlsDescription = mls?.value.shortDescription;
            const saveModal = (0, $cstaF.comparisonSetsModals).SAVE;
            const hasDuplicatedName = selectedMlsSets ? (0, $9S3rS.getHasDuplicatedText)(selectedMlsSets, "name", newCompSetName) : false;
            if (hasDuplicatedName) {
                (0, $jeANf.showToast)((0, $jeANf.toastTypes).error, (0, $cstaF.marketShareTerms).duplicateComparisonSetName, setState);
                return;
            }
            if (isEdit) {
                get().renameComparisonSet({
                    setState: setState,
                    comparisonSets: comparisonSets,
                    selectedMlsDescription: selectedMlsDescription,
                    saveModal: saveModal,
                    newCompSetName: newCompSetName
                });
                return;
            }
            get().createNewCompSet({
                setState: setState,
                comparisonSets: comparisonSets,
                selectedMlsDescription: selectedMlsDescription,
                saveModal: saveModal,
                userAccount: userAccount,
                selectedMlsId: selectedMlsId,
                newCompSetName: newCompSetName
            });
        },
        handleOfficeGroupsAdd: ()=>{
            set({
                addedOffices: [],
                isOfficeGroupEdit: undefined,
                selectedOfficeGroup: undefined
            });
            get().toggleModal(true, (0, $cstaF.comparisonSetsModals).OFFICE_GROUP);
        },
        handleOfficeGroupsEdit: (officeGroup)=>{
            if (!officeGroup.offices?.length) return;
            const selectedComparisonSetOfficesList = get().selectedComparisonSetOfficesList;
            const officesIds = officeGroup?.offices.map((office)=>office?.officeId);
            const addedOffices = selectedComparisonSetOfficesList.filter((office)=>officesIds.includes(office.officeId));
            const availableOffices = selectedComparisonSetOfficesList.filter((office)=>!officesIds.includes(office.officeId));
            set({
                addedOffices: addedOffices,
                isOfficeGroupEdit: true,
                selectedOfficeGroup: {
                    name: officeGroup?.name,
                    addedOffices: addedOffices,
                    availableOffices: availableOffices
                }
            });
            get().toggleModal(true, (0, $cstaF.comparisonSetsModals).OFFICE_GROUP);
        },
        handleOfficeGroupsDelete: (officeGroup)=>{
            set({
                selectedOfficeGroup: officeGroup
            });
            get().toggleModal(true, (0, $cstaF.comparisonSetsModals).DELETE_OFFICE_GROUP);
        },
        deleteOfficeGroup: (selectedComparisonSet, selectedOfficeGroup, setState)=>{
            get().setIsLoading(true);
            const comparisonSets = get().comparisonSets;
            const deleteOfficeGroupModal = (0, $cstaF.comparisonSetsModals).DELETE_OFFICE_GROUP;
            const updatedGroups = selectedComparisonSet.groups.filter((group)=>group.name !== selectedOfficeGroup.name);
            (0, $24YIE.updateComparisonSet)(selectedComparisonSet, updatedGroups).then((updatedComparisonSet)=>{
                if (updatedComparisonSet?.error) throw new Error(updatedComparisonSet?.error);
                const comparisonSetIndex = comparisonSets?.list.findIndex((cs)=>cs.id === updatedComparisonSet.id);
                const revisedComparisonSet = {
                    ...selectedComparisonSet,
                    ...updatedComparisonSet
                };
                get().setIsLoading(false);
                get().toggleModal(false, deleteOfficeGroupModal);
                (0, $jeANf.showToast)((0, $jeANf.toastTypes).success, (0, $cstaF.marketShareTerms).getOfficeGroupDeletedMsg(selectedOfficeGroup.name), setState);
                if (comparisonSetIndex > -1 && comparisonSets.list.length) comparisonSets.list[comparisonSetIndex] = {
                    ...comparisonSets.list[comparisonSetIndex],
                    ...updatedComparisonSet
                };
                const updatedComparisonSetsList = comparisonSets?.list.filter((cs)=>cs.id !== updatedComparisonSet.id);
                set({
                    selectedComparisonSet: revisedComparisonSet,
                    comparisonSets: {
                        list: [
                            revisedComparisonSet,
                            ...updatedComparisonSetsList
                        ]
                    }
                });
            }).catch((e)=>{
                get().setIsLoading(false);
                (0, $jeANf.showToast)((0, $jeANf.toastTypes).error, (0, $cstaF.marketShareTerms).getOfficeGroupDeleteError(selectedOfficeGroup.name), setState);
                console.error((0, $cstaF.marketShareTerms).deleteOfficeGroupError, e);
            }).finally(()=>{
                get().clearState();
            });
        },
        setNewCompSetName: (newCompSetName)=>set({
                newCompSetName: newCompSetName
            }, false, "setNewCompSetName"),
        toggleModal: (shouldOpen, modal)=>set({
                shouldShowByModal: {
                    [modal]: shouldOpen
                }
            }),
        handleMlsChange: (selectedMls)=>set({
                selectedMls: selectedMls
            }),
        handleSelectedComparisonSet: (selectedComparisonSet)=>set({
                selectedComparisonSet: selectedComparisonSet
            }),
        buildComparisonSetOptions: (module = (0, $cstaF.navTerms).myProfile)=>{
            const mlsList = (0, $90ISC.useCommonStore).getState().mlsList || (0, $90ISC.useCommonStore).getState().membership;
            const comparisonSets = get().comparisonSets;
            const comparisonSetListOptions = comparisonSets?.list?.map((cs)=>{
                const mls = mlsList?.find((mls)=>mls.mlsId === cs?.mlsId);
                return {
                    ...cs,
                    label: (0, $cstaF.marketShareTerms).getComparisonSetLabel(cs?.name, mls?.shortDescription),
                    shortDescription: mls?.shortDescription,
                    value: cs?.id
                };
            });
            const sortedComparisonSets = comparisonSetListOptions?.sort((a, b)=>{
                if (a.shortDescription !== b.shortDescription) return a.shortDescription < b.shortDescription ? -1 : 1;
                return a.name?.localeCompare(b.name);
            }) ?? [];
            const selectedComparisonSet = sortedComparisonSets.find((cs)=>cs.id === get().selectedComparisonSet?.id) ?? sortedComparisonSets?.[0];
            set({
                selectedComparisonSet: selectedComparisonSet,
                comparisonSetListOptions: sortedComparisonSets
            });
            const isMarketShareTotals = module === (0, $cstaF.modules).marketShare.totals;
            if (!isMarketShareTotals) return;
            return get().buildComparisonSetChipOptions(sortedComparisonSets);
        },
        buildComparisonSetChipOptions: (sortedComparisonSet)=>{
            const searchStore = (0, $90ISC.useSearchStore).getState();
            const selectedModule = searchStore.selectedModule;
            const selectedMls = searchStore[selectedModule]?.selectedMls;
            const selectedComparisonSet = get().selectedComparisonSet;
            const comparisonSets = get().comparisonSets;
            const comparisonSetsByMls = (0, $7ROc5.getFilteredListByKeyField)(comparisonSets?.list, (0, $cstaF.marketShareTerms).comparisonSetMlsIdField, selectedMls?.mlsId);
            if (!comparisonSetsByMls?.length > 0) return {
                messageType: (0, $cstaF.searchTerms).comparisonSet,
                redirectButtonTitle: (0, $cstaF.searchTerms).createComparisonSets,
                shouldShow: true
            };
            const comparisonSetsByMlsWithGroupOffice = comparisonSetsByMls?.filter((comparisonSet)=>comparisonSet?.groups.length > 0);
            if (!comparisonSetsByMlsWithGroupOffice?.length > 0) return {
                messageType: (0, $cstaF.marketShareTerms).officeGroup,
                redirectButtonTitle: (0, $cstaF.searchTerms).createOfficeGroups,
                shouldShow: true
            };
            const comparisonSetsOptionsByMlsWithGroupOffice = (0, $1ujWz.getCompSetsByMLsWithOfficeGroup)(sortedComparisonSet, selectedMls);
            get().handleSelectedComparisonSet(selectedComparisonSet || comparisonSetsByMlsWithGroupOffice?.[0]);
            set({
                comparisonSetListOptionsBySelectedMls: comparisonSetsOptionsByMlsWithGroupOffice,
                comparisonSetsBySelectedMls: comparisonSetsByMlsWithGroupOffice
            });
            return {
                comparisonSetsOptionsByMlsWithGroupOffice: comparisonSetsOptionsByMlsWithGroupOffice,
                comparisonSetsByMlsWithGroupOffice: comparisonSetsByMlsWithGroupOffice
            };
        },
        handleSaveOfficeGroups: ({ comparisonSets: comparisonSets, selectedComparisonSet: selectedComparisonSet, groups: groups, setState: setState, groupLabel: groupLabel })=>{
            const newGroupName = groups[0].name;
            const saveModal = (0, $cstaF.comparisonSetsModals).OFFICE_GROUP;
            const isOfficeGroupEdit = get().isOfficeGroupEdit;
            const selectedOfficeGroup = get().selectedOfficeGroup;
            const selectedCompSetGroups = isOfficeGroupEdit ? [
                ...selectedComparisonSet.groups.filter((group)=>group.name !== selectedOfficeGroup.name)
            ] : [
                ...selectedComparisonSet.groups
            ];
            const isDuplicatedOfficeGroupName = (0, $9S3rS.getHasDuplicatedText)(selectedCompSetGroups, "name", newGroupName);
            if (isDuplicatedOfficeGroupName) {
                (0, $jeANf.showToast)((0, $jeANf.toastTypes).error, (0, $cstaF.marketShareTerms).duplicateOfficeGroupName, setState);
                return;
            }
            (0, $24YIE.updateComparisonSet)(selectedComparisonSet, [
                ...selectedCompSetGroups,
                ...groups
            ]).then((updatedComparisonSet)=>{
                if (updatedComparisonSet?.error) throw new Error(updatedComparisonSet?.error);
                const successMsg = isOfficeGroupEdit ? (0, $cstaF.marketShareTerms).getGroupEditedMsg(groupLabel) : (0, $cstaF.marketShareTerms).getGroupUpdatedMessage(groupLabel);
                (0, $jeANf.showToast)((0, $jeANf.toastTypes).success, successMsg, setState);
                const comparisonSetsList = comparisonSets?.list ?? [];
                const comparisonSetIndex = comparisonSetsList.findIndex((cs)=>cs.id === updatedComparisonSet.id);
                if (comparisonSetIndex > -1 && comparisonSetsList.length) comparisonSetsList[comparisonSetIndex] = {
                    ...comparisonSetsList[comparisonSetIndex],
                    ...updatedComparisonSet
                };
                const revisedComparisonSet = {
                    ...selectedComparisonSet,
                    ...updatedComparisonSet
                };
                const updatedComparisonSetsList = comparisonSetsList.filter((cs)=>cs.id !== updatedComparisonSet.id);
                set({
                    selectedComparisonSet: revisedComparisonSet,
                    comparisonSets: {
                        list: [
                            revisedComparisonSet,
                            ...updatedComparisonSetsList
                        ]
                    }
                });
                get().toggleModal(false, saveModal);
                get().clearState();
            }).catch((e)=>{
                const errorMsg = isOfficeGroupEdit ? (0, $cstaF.marketShareTerms).getOfficeGroupEditError(groupLabel) : (0, $cstaF.marketShareTerms).createComparisonSetsError;
                (0, $jeANf.showToast)((0, $jeANf.toastTypes).error, errorMsg, setState);
                console.error((0, $cstaF.marketShareTerms).updateOfficeGroupError, e);
                get().toggleModal(false, saveModal);
                get().clearState();
            });
        },
        getSelectedComparisonSetOfficesList: async ()=>{
            try {
                const selectedComparisonSet = get().selectedComparisonSet || get().comparisonSetListOptions?.[0];
                if (!selectedComparisonSet) return;
                const offices = await (0, $5NVz0.getCoverageOffices)(selectedComparisonSet?.mlsId);
                set({
                    selectedComparisonSetOfficesList: offices
                });
            } catch (err) {
                set({
                    error: err.message
                });
            }
        },
        getIsOfficeGroupSaveBtnDisabled: ()=>{
            const addedOffices = get().addedOffices;
            const comparisonSets = get().comparisonSets;
            const officeGroupName = get().officeGroupName?.trim();
            const isOfficeGroupEdit = get().isOfficeGroupEdit;
            const selectedOfficeGroup = get().selectedOfficeGroup;
            const selectedComparisonSet = get().selectedComparisonSet;
            if (officeGroupName.length === 0) return true;
            if (!isOfficeGroupEdit) return !addedOffices.length || !officeGroupName.length;
            const isNewName = selectedOfficeGroup?.name !== officeGroupName;
            const filteredGroup = comparisonSets?.list.filter((comparisonSet)=>comparisonSet.id === selectedComparisonSet.id)[0]?.groups?.find((group)=>group.name === selectedOfficeGroup.name);
            const addedOfficesIds = addedOffices.map((office)=>office.officeId);
            const groupOfficesIds = filteredGroup?.offices.map((office)=>office.officeId);
            const hasGroupChange = !(addedOfficesIds.every((item)=>groupOfficesIds?.includes(item)) && groupOfficesIds.every((item)=>addedOfficesIds.includes(item)));
            return !addedOffices.length || !isNewName && !hasGroupChange;
        },
        setIsComparisonSetView: (isComparisonSetView)=>set({
                isComparisonSetView: isComparisonSetView
            }),
        setSelectedComparisonSetOfficesList: (selectedComparisonSetOfficesList)=>set({
                selectedComparisonSetOfficesList: selectedComparisonSetOfficesList
            }),
        setAddedOffices: (addedOffices)=>set({
                addedOffices: addedOffices
            }),
        setOfficeGroupName: (officeGroupName)=>set({
                officeGroupName: officeGroupName
            }, false, "setOfficeGroupName"),
        setSelectedMls: (selectedMls)=>set({
                selectedMls: selectedMls
            }, false, "setSelectedMls"),
        clearState: ()=>{
            set({
                addedOffices: []
            });
            set({
                officeGroupName: ""
            });
        },
        setIsLoading: (isLoading)=>set({
                isLoading: isLoading
            })
    });

});



parcelRegister("bxSLe", function(module, exports) {

$parcel$export(module.exports, "hasRequiredCriteria", () => $867d411ebfc0c064$export$794039ff5c621a64);
$parcel$export(module.exports, "popoverModifiers", () => $867d411ebfc0c064$export$ea82393ba8ef0414);
$parcel$export(module.exports, "toggleRunSearchButton", () => $867d411ebfc0c064$export$86130519e7c1d627);
$parcel$export(module.exports, "getOfficesByModule", () => $867d411ebfc0c064$export$44eba10e171021eb);

var $5ILgR = parcelRequire("5ILgR");

var $cstaF = parcelRequire("cstaF");

var $90ISC = parcelRequire("90ISC");

var $5NVz0 = parcelRequire("5NVz0");
const $867d411ebfc0c064$export$794039ff5c621a64 = (search, module)=>{
    let hasCriteria = false;
    const mlsId = search?.mlsId;
    if (mlsId) {
        const mls = $5ILgR.default(search.searchCriteria.criteria?.realEstateDatasourceIdsWithFilters, (i)=>i.realEstateDatasourceId === mlsId);
        if (mls) {
            const foundPropTypes = $5ILgR.default(mls.searchFields, (f)=>f.fieldName === "propertyType");
            const foundMarketAreas = $5ILgR.default(mls.searchFields, (f)=>(0, $cstaF.areaSearchTypes).includes(f.fieldName));
            const hasPropTypes = foundPropTypes ? !!foundPropTypes.fieldValues?.length : false;
            const hasTimePeriod = search.searchCriteria.criteria?.hasOwnProperty("timePeriod");
            const hasMarketAreas = foundMarketAreas ? !!foundMarketAreas?.fieldValues?.length : mls.searchAllMLS;
            const hasAreaType = $5ILgR.default(mls.computedFields, (f)=>f.fieldName === (0, $cstaF.searchTerms).areaTypeFilter);
            const foundListingStatus = $5ILgR.default(mls.computedFields, (f)=>f.fieldName === (0, $cstaF.searchTerms).transactionStatus);
            const hasListingStatus = foundListingStatus ? !!foundListingStatus.fieldValues?.length : false;
            const foundOffices = $5ILgR.default(mls.idFiltering, (f)=>f.idType === (0, $cstaF.searchTerms).officeIdType);
            const hasOffices = foundOffices ? !!foundOffices.idValues?.length : false;
            const foundAgents = $5ILgR.default(mls.idFiltering, (f)=>f.idType === (0, $cstaF.searchTerms).agentIdType);
            const hasAgents = foundAgents ? foundAgents.idValues?.length > 0 : false;
            switch(module){
                case (0, $cstaF.modules).proficiencyMetrics.transactions:
                    hasCriteria = !!hasPropTypes && !!hasTimePeriod && !!hasMarketAreas;
                    break;
                case (0, $cstaF.modules).proficiencyMetrics.offices:
                    hasCriteria = !!hasTimePeriod && !!hasOffices;
                    break;
                case (0, $cstaF.modules).proficiencyMetrics.agents:
                    hasCriteria = !!hasPropTypes && !!hasTimePeriod && !!hasAgents;
                    break;
                case (0, $cstaF.modules).proficiencyMetrics.agentMovement:
                    hasCriteria = !!hasOffices;
                    break;
                case (0, $cstaF.modules).marketShare.totals:
                    hasCriteria = !!hasPropTypes && !!hasTimePeriod && !!hasMarketAreas && !!hasListingStatus;
                    break;
                case (0, $cstaF.modules).marketShare.coverage:
                    hasCriteria = !!hasAreaType && !!hasPropTypes && !!hasTimePeriod && !!hasListingStatus && !!hasOffices;
                    break;
                case (0, $cstaF.modules).marketDynamics.marketDynamics:
                    hasCriteria = !!hasMarketAreas && !!hasPropTypes && !!hasTimePeriod;
                    break;
                case (0, $cstaF.modules).proficiencyMetrics.savedAgents:
                    hasCriteria = !!hasPropTypes && !!hasTimePeriod && !!hasMarketAreas;
                    break;
                default:
                    hasCriteria = false;
                    break;
            }
        }
    }
    return hasCriteria;
};
const $867d411ebfc0c064$export$ea82393ba8ef0414 = {
    modifiers: {
        flip: {
            enabled: false
        }
    }
};
const $867d411ebfc0c064$export$86130519e7c1d627 = (menuIsOpen)=>{
    (0, $90ISC.useCommonStore).getState().toggleMenuIsOpen(menuIsOpen);
};
const $867d411ebfc0c064$export$44eba10e171021eb = (searchMlsId)=>Object.freeze({
        [(0, $cstaF.modules).proficiencyMetrics.offices]: async ()=>await (0, $5NVz0.getOffices)(searchMlsId),
        [(0, $cstaF.modules).marketShare.coverage]: async ()=>await (0, $5NVz0.getCoverageOffices)(searchMlsId),
        [(0, $cstaF.modules).proficiencyMetrics.agentMovement]: async ()=>await (0, $5NVz0.getOffices)(searchMlsId)
    });

});

parcelRegister("jilhO", function(module, exports) {

$parcel$export(module.exports, "pinnedColIds", () => $e0c035c402ff2968$export$61ca254f592eea2b);
$parcel$export(module.exports, "getSummaryPinnedData", () => $e0c035c402ff2968$export$dfa31e504b96f0d1);
$parcel$export(module.exports, "getSummaryPinnedConfig", () => $e0c035c402ff2968$export$92270800a0aa14bb);

var $iQ57b = parcelRequire("iQ57b");

var $eHBjM = parcelRequire("eHBjM");

var $aypMh = parcelRequire("aypMh");

var $cL3O2 = parcelRequire("cL3O2");

var $1PiL9 = parcelRequire("1PiL9");

var $42prG = parcelRequire("42prG");
const $e0c035c402ff2968$export$61ca254f592eea2b = {
    [(0, $aypMh.views).overview]: [
        (0, $eHBjM.agentsColumns).listVolume.id,
        (0, $eHBjM.agentsColumns).sellVolume.id,
        (0, $eHBjM.agentsColumns).totalVolume.id,
        (0, $eHBjM.agentsColumns).listUnits.id,
        (0, $eHBjM.agentsColumns).sellUnits.id,
        (0, $eHBjM.agentsColumns).totalUnits.id,
        (0, $eHBjM.agentsColumns).last12AvgDom.id,
        (0, $eHBjM.agentsColumns).last12ListVolume.id,
        (0, $eHBjM.agentsColumns).last12SellVolume.id,
        (0, $eHBjM.agentsColumns).last12TotalVolume.id,
        (0, $eHBjM.agentsColumns).last12ListUnits.id,
        (0, $eHBjM.agentsColumns).last12SellUnits.id,
        (0, $eHBjM.agentsColumns).last12TotalUnits.id
    ],
    [(0, $aypMh.views).listingProficiency]: [
        (0, $eHBjM.agentsColumns).last12SellUnits.id,
        (0, $eHBjM.agentsColumns).last12SellVolume.id,
        (0, $eHBjM.agentsColumns).last12ListUnits.id,
        (0, $eHBjM.agentsColumns).last12ListVolume.id,
        (0, $eHBjM.agentsColumns).noPcLast12ListUnits.id,
        (0, $eHBjM.agentsColumns).noPcLast12ListUnitsPct.id,
        (0, $eHBjM.agentsColumns).noPcLast12ListVolume.id,
        (0, $eHBjM.agentsColumns).noPcLast12ListVolumePct.id,
        (0, $eHBjM.agentsColumns).noPcLast12ListDom.id,
        (0, $eHBjM.agentsColumns).noPcLast12ListCdom.id,
        (0, $eHBjM.agentsColumns).noPcLast12SpOp.id,
        (0, $eHBjM.agentsColumns).pcLast12ListUnits.id,
        (0, $eHBjM.agentsColumns).pcLast12ListUnitsPct.id,
        (0, $eHBjM.agentsColumns).pcLast12ListVolume.id,
        (0, $eHBjM.agentsColumns).pcLast12ListVolumePct.id,
        (0, $eHBjM.agentsColumns).pcLast12ListDom.id,
        (0, $eHBjM.agentsColumns).pcLast12ListCdom.id,
        (0, $eHBjM.agentsColumns).pcLast12ListPcDom.id,
        (0, $eHBjM.agentsColumns).pcLast12ListSpOp.id,
        (0, $eHBjM.agentsColumns).pcLast12ListSpLp.id,
        (0, $eHBjM.agentsColumns).pcLast12ListAvgNumPc.id
    ],
    [(0, $cL3O2.listingViews).soldAvgVsMedianPrice.value]: [
        (0, $eHBjM.agentsColumns).officeName.id,
        (0, $1PiL9.marketDynamicsColumns).soldUnits.id,
        (0, $1PiL9.marketDynamicsColumns).soldMedianVolume.id,
        (0, $1PiL9.marketDynamicsColumns).soldAvgVolume.id,
        (0, $1PiL9.marketDynamicsColumns).soldChangeVolume.id,
        (0, $1PiL9.marketDynamicsColumns).soldGrowthVolumePct.id,
        (0, $1PiL9.marketDynamicsColumns).soldAvgDom.id
    ],
    [(0, $cL3O2.listingViews).avg$Sqft.value]: (0, $42prG.getBreakdownPinnedRowColumns)((0, $cL3O2.listingViews).avg$Sqft.tableSettings.tables),
    [(0, $cL3O2.listingViews).avgDomCdom.value]: (0, $42prG.getBreakdownPinnedRowColumns)((0, $cL3O2.listingViews).avgDomCdom.tableSettings.tables),
    [(0, $cL3O2.listingViews).avgSpLpComparison.value]: (0, $42prG.getBreakdownPinnedRowColumns)((0, $cL3O2.listingViews).avgSpLpComparison.tableSettings.tables),
    [(0, $cL3O2.listingViews).avgSpOpAllProperties.value]: (0, $42prG.getBreakdownPinnedRowColumns)((0, $cL3O2.listingViews).avgSpOpAllProperties.tableSettings.tables),
    [(0, $cL3O2.listingViews).avgSpOpComparison.value]: (0, $42prG.getBreakdownPinnedRowColumns)((0, $cL3O2.listingViews).avgSpOpComparison.tableSettings.tables),
    [(0, $cL3O2.listingViews).forSaleVsFsldm.value]: (0, $42prG.getBreakdownPinnedRowColumns)((0, $cL3O2.listingViews).forSaleVsFsldm.tableSettings.tables),
    [(0, $cL3O2.listingViews).medianPrice.value]: (0, $42prG.getBreakdownPinnedRowColumns)((0, $cL3O2.listingViews).medianPrice.tableSettings.tables),
    [(0, $cL3O2.listingViews).monthlySupplyOfInventory.value]: (0, $42prG.getBreakdownPinnedRowColumns)((0, $cL3O2.listingViews).monthlySupplyOfInventory.tableSettings.tables),
    [(0, $cL3O2.listingViews).salesAbsorption.value]: (0, $42prG.getBreakdownPinnedRowColumns)((0, $cL3O2.listingViews).salesAbsorption.tableSettings.tables),
    [(0, $cL3O2.listingViews).supplyAmpDemandNumUnits.value]: (0, $42prG.getBreakdownPinnedRowColumns)((0, $cL3O2.listingViews).supplyAmpDemandNumUnits.tableSettings.tables),
    [(0, $cL3O2.listingViews).underContractUc.value]: (0, $42prG.getBreakdownPinnedRowColumns)((0, $cL3O2.listingViews).underContractUc.tableSettings.tables),
    [(0, $eHBjM.tableViewNames).agentMovement]: [
        (0, $iQ57b.agentsParentColumns).agentsLost.id,
        (0, $iQ57b.agentsParentColumns).agentsGained.id,
        (0, $iQ57b.agentsParentColumns).netAgents.id,
        (0, $iQ57b.potentialImpactParentColumns).netVolume.id
    ]
};
const $e0c035c402ff2968$export$dfa31e504b96f0d1 = (summaryData, view)=>{
    if (!summaryData || !$e0c035c402ff2968$export$61ca254f592eea2b[view]) return [];
    const overrideKey = Object.entries((0, $42prG.getPinnedRowTitle)(view)).flat()[0];
    let revisedSummaryData;
    revisedSummaryData = !summaryData[overrideKey] ? {
        ...summaryData,
        [overrideKey]: (0, $42prG.getPinnedRowTitle)(view)
    } : summaryData;
    const result = Object.entries(revisedSummaryData).filter((obj)=>$e0c035c402ff2968$export$61ca254f592eea2b[view].includes(obj[0])).reduce((obj, [key, value])=>{
        const cellToOverrideMatch = !!(0, $42prG.getPinnedRowTitle)(view)[key];
        obj[key] = cellToOverrideMatch ? (0, $42prG.getPinnedRowTitle)(view)[key] : value;
        return obj;
    }, {});
    return result;
};
const $e0c035c402ff2968$export$92270800a0aa14bb = (view)=>{
    if (!$e0c035c402ff2968$export$61ca254f592eea2b[view]) return null;
    return {
        cellsToShow: $e0c035c402ff2968$export$61ca254f592eea2b[view],
        cellsToOverride: (0, $42prG.getPinnedRowTitle)(view)
    };
};

});
parcelRegister("iQ57b", function(module, exports) {

$parcel$export(module.exports, "additionalTableHeaderIds", () => $db710d0da560e816$export$96d963e9968890e3);
$parcel$export(module.exports, "agentsParentColumns", () => $db710d0da560e816$export$fa8323e57cbdfa71);
$parcel$export(module.exports, "potentialImpactParentColumns", () => $db710d0da560e816$export$fb344d718b49ba5c);
$parcel$export(module.exports, "columns", () => $db710d0da560e816$export$53b3c91859018cd4);
$parcel$export(module.exports, "officeBreakdownColumns", () => $db710d0da560e816$export$be23786429a3339d);
$parcel$export(module.exports, "officeNameColumn", () => $db710d0da560e816$export$15bbc98d8d1969df);
$parcel$export(module.exports, "officeInformationArrayColumns", () => $db710d0da560e816$export$ad4d71e8fee712a4);
$parcel$export(module.exports, "officeInformationColumnsOfficeBreakdown", () => $db710d0da560e816$export$8b284962acfffff6);
$parcel$export(module.exports, "agentsArrayColumns", () => $db710d0da560e816$export$d2eb55754cab4e27);
$parcel$export(module.exports, "agentsColumnsOfficeBreakdown", () => $db710d0da560e816$export$5889d3fcce5b983);
$parcel$export(module.exports, "potentialImpactArrayColumns", () => $db710d0da560e816$export$38d8c5643ffe4630);
$parcel$export(module.exports, "additionalTableHeaders", () => $db710d0da560e816$export$e5b8f80f89782c65);
$parcel$export(module.exports, "breakdownAdditionalHeaders", () => $db710d0da560e816$export$86e91994e8c6c915);

var $98ROn = parcelRequire("98ROn");

var $cstaF = parcelRequire("cstaF");

var $eHBjM = parcelRequire("eHBjM");

var $6OeBN = parcelRequire("6OeBN");

var $hQz0O = parcelRequire("hQz0O");
const $db710d0da560e816$export$96d963e9968890e3 = Object.freeze({
    officeInformation: "officeInformation",
    agents: "agents",
    potentialImpact: "potentialImpact",
    agentInformation: "agentInformation",
    beforeMove: "beforeMove",
    afterMove: "afterMove"
});
const $db710d0da560e816$export$35949b9398bc219a = Object.freeze({
    officeStreetName: "officeStreetName",
    agentsLost: "agentsLost",
    agentsGained: "agentsGained",
    netAgents: "netAgents",
    netVolume: "netVolume"
});
const $db710d0da560e816$export$eff12436b8728415 = Object.freeze({
    officeInformation: {
        id: $db710d0da560e816$export$96d963e9968890e3.officeInformation,
        label: (0, $eHBjM.listingProficiencyColTitles).officeInformation
    },
    agents: {
        id: $db710d0da560e816$export$96d963e9968890e3.agents,
        label: (0, $eHBjM.listingProficiencyColTitles).agents
    },
    potentialImpact: {
        id: $db710d0da560e816$export$96d963e9968890e3.potentialImpact,
        label: (0, $eHBjM.listingProficiencyColTitles).potentialImpact
    }
});
const $db710d0da560e816$export$932453059b728017 = Object.freeze({
    officeName: {
        ...(0, $eHBjM.agentsColumns).officeName,
        tip: (0, $hQz0O.tooltips).officeName,
        isDisplayed: true
    },
    officeId: {
        ...(0, $eHBjM.agentsColumns).officeId,
        tip: (0, $hQz0O.tooltips).officeId,
        metrics: {
            ...$db710d0da560e816$export$eff12436b8728415.officeInformation
        },
        isDisplayed: false
    },
    officeStreetName: {
        id: $db710d0da560e816$export$35949b9398bc219a.officeStreetName,
        label: (0, $cstaF.agentProductionTerms).officeAddress,
        tip: (0, $hQz0O.tooltips).officeAddress,
        metrics: {
            ...$db710d0da560e816$export$eff12436b8728415.officeInformation
        },
        isDisplayed: false
    },
    officeCity: {
        ...(0, $eHBjM.agentsColumns).officeCity,
        tip: (0, $hQz0O.tooltips).city,
        isDisplayed: false,
        boundMetricId: $db710d0da560e816$export$35949b9398bc219a.officeStreetName
    },
    officeZipCode: {
        ...(0, $eHBjM.agentsColumns).officeZipCode,
        tip: (0, $hQz0O.tooltips).zip,
        isDisplayed: false,
        boundMetricId: $db710d0da560e816$export$35949b9398bc219a.officeStreetName
    }
});
const $db710d0da560e816$export$fa8323e57cbdfa71 = Object.freeze({
    agentsLost: {
        id: $db710d0da560e816$export$35949b9398bc219a.agentsLost,
        label: (0, $hQz0O.terms).lostAgentsTo,
        metricLabel: (0, $hQz0O.terms).lost,
        tip: (0, $hQz0O.tooltips).lostAgentsTo,
        metrics: {
            ...$db710d0da560e816$export$eff12436b8728415.agents
        },
        isDisplayed: true
    },
    agentsGained: {
        id: $db710d0da560e816$export$35949b9398bc219a.agentsGained,
        label: (0, $hQz0O.terms).gainedAgentsFrom,
        metricLabel: (0, $hQz0O.terms).gained,
        tip: (0, $hQz0O.tooltips).gainedAgentsFrom,
        metrics: {
            ...$db710d0da560e816$export$eff12436b8728415.agents
        },
        isDisplayed: true
    },
    netAgents: {
        id: $db710d0da560e816$export$35949b9398bc219a.netAgents,
        label: (0, $hQz0O.terms).netAgentsGained,
        metricLabel: (0, $hQz0O.terms).netGained,
        tip: (0, $hQz0O.tooltips).netAgentsGained,
        metrics: {
            ...$db710d0da560e816$export$eff12436b8728415.agents
        },
        isDisplayed: true
    }
});
const $db710d0da560e816$export$fb344d718b49ba5c = Object.freeze({
    netVolume: {
        id: $db710d0da560e816$export$35949b9398bc219a.netVolume,
        label: (0, $hQz0O.terms).netDollarVolume,
        tip: (0, $hQz0O.tooltips).netDollarVolume,
        metrics: {
            ...$db710d0da560e816$export$eff12436b8728415.potentialImpact
        },
        isDisplayed: true
    }
});
const $db710d0da560e816$export$53b3c91859018cd4 = Object.freeze({
    ...$db710d0da560e816$export$932453059b728017,
    ...$db710d0da560e816$export$fa8323e57cbdfa71,
    ...$db710d0da560e816$export$fb344d718b49ba5c
});
const $db710d0da560e816$export$99daa87e205bca54 = Object.freeze({
    agentsGained: {
        ...$db710d0da560e816$export$fa8323e57cbdfa71.agentsGained,
        label: (0, $hQz0O.terms).agentsGained,
        tip: (0, $hQz0O.tooltips).agentsGained
    },
    agentsLost: {
        ...$db710d0da560e816$export$fa8323e57cbdfa71.agentsLost,
        label: (0, $hQz0O.terms).agentsLost,
        tip: (0, $hQz0O.tooltips).agentsLost
    },
    netAgents: {
        ...$db710d0da560e816$export$fa8323e57cbdfa71.netAgents
    }
});
const $db710d0da560e816$export$be23786429a3339d = Object.freeze({
    ...$db710d0da560e816$export$932453059b728017,
    ...$db710d0da560e816$export$99daa87e205bca54,
    ...$db710d0da560e816$export$fb344d718b49ba5c
});
const $db710d0da560e816$export$15bbc98d8d1969df = {
    col: $db710d0da560e816$export$932453059b728017.officeName,
    colDef: (0, $98ROn.colSettings).textLg,
    cellRenderer: (0, $6OeBN.default)
};
const $db710d0da560e816$export$ad4d71e8fee712a4 = (shouldShowAdditionalInfo)=>[
        {
            col: {
                ...$db710d0da560e816$export$932453059b728017.officeId,
                isDisplayed: shouldShowAdditionalInfo
            },
            colDef: (0, $98ROn.colSettings).textSm
        },
        {
            col: {
                ...$db710d0da560e816$export$932453059b728017.officeStreetName,
                isDisplayed: shouldShowAdditionalInfo
            },
            colDef: (0, $98ROn.colSettings).textMd
        },
        {
            col: {
                ...$db710d0da560e816$export$932453059b728017.officeCity,
                isDisplayed: shouldShowAdditionalInfo
            },
            colDef: (0, $98ROn.colSettings).textSm
        },
        {
            col: {
                ...$db710d0da560e816$export$932453059b728017.officeZipCode,
                isDisplayed: shouldShowAdditionalInfo
            },
            colDef: (0, $98ROn.colSettings).textXs
        }
    ];
const $db710d0da560e816$export$8b284962acfffff6 = (shouldShowAdditionalInfo)=>[
        $db710d0da560e816$export$15bbc98d8d1969df,
        ...$db710d0da560e816$export$ad4d71e8fee712a4(shouldShowAdditionalInfo)
    ];
const $db710d0da560e816$export$d2eb55754cab4e27 = [
    {
        col: $db710d0da560e816$export$fa8323e57cbdfa71.agentsLost,
        colDef: (0, $98ROn.colSettings).numberSmInteger
    },
    {
        col: $db710d0da560e816$export$fa8323e57cbdfa71.agentsGained,
        colDef: (0, $98ROn.colSettings).numberMdInteger
    },
    {
        col: $db710d0da560e816$export$fa8323e57cbdfa71.netAgents,
        colDef: (0, $98ROn.colSettings).numberMdInteger
    }
];
const $db710d0da560e816$export$5889d3fcce5b983 = [
    {
        col: {
            ...$db710d0da560e816$export$fa8323e57cbdfa71.agentsGained,
            label: (0, $hQz0O.terms).agentsGained
        },
        colDef: (0, $98ROn.colSettings).numberMdInteger
    },
    {
        col: {
            ...$db710d0da560e816$export$fa8323e57cbdfa71.agentsLost,
            label: (0, $hQz0O.terms).agentsLost
        },
        colDef: (0, $98ROn.colSettings).numberSmInteger
    },
    {
        col: $db710d0da560e816$export$fa8323e57cbdfa71.netAgents,
        colDef: (0, $98ROn.colSettings).numberMdInteger
    }
];
const $db710d0da560e816$export$38d8c5643ffe4630 = [
    {
        col: $db710d0da560e816$export$fb344d718b49ba5c.netVolume,
        colDef: (0, $98ROn.colSettings).numberSmInteger
    }
];
const $db710d0da560e816$export$e5b8f80f89782c65 = [
    {
        [$db710d0da560e816$export$96d963e9968890e3.officeInformation]: {
            title: (0, $eHBjM.listingProficiencyColTitles).officeInformation,
            attrs: {
                colSpan: 5,
                clasName: "border text-center"
            }
        },
        [$db710d0da560e816$export$96d963e9968890e3.agents]: {
            title: (0, $eHBjM.listingProficiencyColTitles).agents,
            attrs: {
                colSpan: 3,
                clasName: "border text-center"
            }
        },
        [$db710d0da560e816$export$96d963e9968890e3.potentialImpact]: {
            title: (0, $eHBjM.listingProficiencyColTitles).potentialImpact,
            attrs: {
                colSpan: 1,
                clasName: "border text-center"
            }
        }
    }
];
const $db710d0da560e816$export$86e91994e8c6c915 = [
    {
        [$db710d0da560e816$export$96d963e9968890e3.agentInformation]: {
            title: (0, $eHBjM.listingProficiencyColTitles).agentInformation,
            attrs: {
                colSpan: 14
            }
        },
        [$db710d0da560e816$export$96d963e9968890e3.beforeMove]: {
            title: (0, $eHBjM.listingProficiencyColTitles).beforeMove,
            attrs: {
                colSpan: 1
            }
        },
        [$db710d0da560e816$export$96d963e9968890e3.afterMove]: {
            title: (0, $eHBjM.listingProficiencyColTitles).afterMove,
            attrs: {
                colSpan: 6
            }
        }
    }
];

});
parcelRegister("6OeBN", function(module, exports) {

$parcel$export(module.exports, "default", () => $835309bd6ceddee9$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $kfZjc = parcelRequire("kfZjc");

var $c9Z8w = parcelRequire("c9Z8w");

var $cstaF = parcelRequire("cstaF");

var $90ISC = parcelRequire("90ISC");

var $53A0d = parcelRequire("53A0d");
const $835309bd6ceddee9$var$OfficeNameLink = ({ data: data })=>{
    const history = (0, $kfZjc.useHistory)();
    const { selectedBreakdownTab: selectedBreakdownTab, setSelectedBreakdownTab: setSelectedBreakdownTab, setSelectedBreakdownOffice: setSelectedBreakdownOffice } = (0, $90ISC.useSearchStore)((state)=>({
            selectedBreakdownTab: state[state.selectedModule]?.breakdowns?.selectedBreakdownTab,
            setSelectedBreakdownTab: state.setSelectedBreakdownTab,
            setSelectedBreakdownOffice: state.setSelectedBreakdownOffice
        }));
    const handleClick = ()=>{
        setSelectedBreakdownOffice({
            officeId: data.officeId,
            name: data.officeName
        });
        if (selectedBreakdownTab === (0, $53A0d.OFFICE_BRKDWN_GROWTH_TAB_INDEX)) setSelectedBreakdownTab(0);
        history.push((0, $cstaF.searchRoutes).agentsGainedBreakdown, {
            fromOfficeBreakdownAndGrowthTab: selectedBreakdownTab === (0, $53A0d.OFFICE_BRKDWN_GROWTH_TAB_INDEX)
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: "table-row-link clickable",
        onClick: handleClick,
        children: data.officeName
    });
};
$835309bd6ceddee9$var$OfficeNameLink.propTypes = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf({
        officeId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired,
        officeName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired
    })
};
var $835309bd6ceddee9$export$2e2bcd8739ae039 = $835309bd6ceddee9$var$OfficeNameLink;

});

parcelRegister("hQz0O", function(module, exports) {

$parcel$export(module.exports, "terms", () => $cfe273a96172ad06$export$8a21ba990ca4a7cb);
$parcel$export(module.exports, "tooltips", () => $cfe273a96172ad06$export$1fc29293196e3bc);
$parcel$export(module.exports, "indicatorsSettingsByKeyName", () => $cfe273a96172ad06$export$a2c35be6a2904520);
$parcel$export(module.exports, "agentsGainedTooltips", () => $cfe273a96172ad06$export$1af75cb449ba214f);
$parcel$export(module.exports, "lostAgentsTooltips", () => $cfe273a96172ad06$export$fa69b7335e8e7cc6);
$parcel$export(module.exports, "exportFilenameTemplates", () => $cfe273a96172ad06$export$b02d86cbb3d565d5);

var $i95vK = parcelRequire("i95vK");
const $cfe273a96172ad06$export$8a21ba990ca4a7cb = Object.freeze({
    gainedAgents: "Gained Agents",
    gainedAgentsFrom: "Gained Agents From",
    lostAgents: "Lost Agents",
    lostAgentsTo: "Lost Agents To",
    netAgentsGained: "Net Agents Gained",
    netDollarVolume: "Net $ Volume",
    officeDetails: "Office Details",
    viewBreakdown: "View Breakdown",
    officeBreakdownAndGrowth: "Office Breakdown & Growth",
    selectedOffices: "Selected Offices",
    selectedOfficeOrOffices: "Selected Office(s)",
    getGrewByAgents: (officesTitle, agentsAmount)=>`${officesTitle} grew by ${agentsAmount} agent(s).`,
    getShrunkByAgents: (officesTitle, agentsAmount)=>`${officesTitle} shrunk by ${agentsAmount} agent(s).`,
    getZeroAgents: (officesTitle)=>`${officesTitle} experienced no change in agent count.`,
    gained: "Gained",
    lost: "Lost",
    netGained: "Net Gained",
    agentsLost: "Agents Lost",
    agentsGained: "Agents Gained",
    from: " from ",
    to: " to "
});
const $cfe273a96172ad06$export$1fc29293196e3bc = Object.freeze({
    // Office information
    officeName: "The name of the office as reflected in the MLS data",
    officeId: "ID code of the office (assigned by MLS)",
    officeAddress: "The office's physical and/or mailing address as reflected in the MLS data",
    city: "The city associated with the office as reflected in the MLS data",
    zip: "The USPS zip code associated with the office as reflected in the MLS data",
    // Agents
    lostAgentsTo: "The number of agents who left another office in your MLS and joined one of your offices or the selected offices",
    gainedAgentsFrom: "The number of agents who left one of your offices or the selected offices and joined another office in your MLS",
    netAgentsGained: "The difference between the number of agents gained and the number of agents lost",
    agentsGained: "The number of agents who left another office in your MLS and joined one of your offices or the selected office",
    agentsLost: "The number of agents who left one of your offices or the selected office and joined another office in your MLS",
    // Potential Impact
    netDollarVolume: `The net difference in Total $ Volume (based on the listings sold during the 365 Days prior to the agent's move) for the agents who left one of your offices and the agents who joined one of your offices`,
    // Dashboard Indicators
    dashboardAgentsGained: `The number of agents who left another office in your MLS and joined one of your offices`,
    dashboardAgentsLost: `The number of agents who left one of your offices and joined another office in your MLS`,
    dashboardPotentialGain: `The net Total $ Volume (based on the listings sold during the Last 365 Days prior to the agent's move) for the agents who joined one of your offices`,
    dashboardPotentialLoss: `The net Total $ Volume (based on the listings sold during the Last 365 Days prior to the agent's move) for the agents who left one of your offices`
});
const $cfe273a96172ad06$export$6992fdcbb10bf1d8 = Object.freeze({
    agentsGained: "Agents Gained",
    agentsLost: "Agents Lost",
    potentialGain: "Potential Gain (Volume)",
    potentialLoss: "Potential Loss (Volume)"
});
const $cfe273a96172ad06$export$a2c35be6a2904520 = Object.freeze({
    otherAgentsGained: {
        id: "otherAgentsGained",
        label: $cfe273a96172ad06$export$6992fdcbb10bf1d8.agentsGained,
        tooltip: $cfe273a96172ad06$export$1fc29293196e3bc.dashboardAgentsGained
    },
    otherAgentsLost: {
        id: "otherAgentsLost",
        label: $cfe273a96172ad06$export$6992fdcbb10bf1d8.agentsLost,
        tooltip: $cfe273a96172ad06$export$1fc29293196e3bc.dashboardAgentsLost
    },
    otherVolumeGained: {
        id: "otherVolumeGained",
        label: $cfe273a96172ad06$export$6992fdcbb10bf1d8.potentialGain,
        tooltip: $cfe273a96172ad06$export$1fc29293196e3bc.dashboardPotentialGain
    },
    otherVolumeLost: {
        id: "otherVolumeLost",
        label: $cfe273a96172ad06$export$6992fdcbb10bf1d8.potentialLoss,
        tooltip: $cfe273a96172ad06$export$1fc29293196e3bc.dashboardPotentialLoss
    }
});
const $cfe273a96172ad06$export$339cecd0af4786de = {
    agentCity: {
        id: "agentCity",
        label: "Agent City",
        tip: "The city associated with the agent as reflected in the MLS data"
    },
    agentEmail: {
        id: "agentEmail",
        label: "Agent Email",
        tip: "The agent's email address as reflected in the MLS data"
    },
    agentName: {
        id: "agentName",
        label: "Agent Name",
        tip: "Name of the Agent"
    },
    agentPhone1: {
        id: "agentPhone1",
        label: "Agent Phone 1",
        tip: "A telephone number for the agent as reflected in the MLS data"
    },
    agentPhone2: {
        id: "agentPhone2",
        label: "Agent Phone 2",
        tip: "A telephone number for the agent as reflected in the MLS data"
    },
    agentPhone3: {
        id: "agentPhone3",
        label: "Agent Phone 3",
        tip: "A telephone number for the agent as reflected in the MLS data"
    },
    agentStreetName: {
        id: "agentStreetName",
        label: "Agent Address",
        tip: "The agent's alternate  physical and/or mailing address as reflected in the MLS data"
    },
    agentZipCode: {
        id: "agentZipCode",
        label: "Agent Zip",
        tip: "The USPS zip code associated with the agent as reflected in the MLS data"
    },
    daysSinceMove: {
        id: "daysSinceMove",
        label: "# Days",
        tip: "The number of days since the agent moved to a different office"
    },
    moveDate: {
        id: "moveDate",
        label: "Move Date",
        tip: "Date when agents office changed"
    },
    officeCity: {
        id: "officeCity",
        label: "City",
        tip: "The city associated with the office as reflected in the MLS data"
    },
    officeId: {
        id: "officeId",
        label: "Office ID",
        tip: "ID Code assigned by MLS"
    },
    officeStreetName: {
        id: "officeStreetName",
        label: "Office Address",
        tip: "The office's physical and/or mailing address as reflected in the MLS data"
    },
    officeZipCode: {
        id: "officeZipCode",
        label: "Zip",
        tip: "The USPS zip code associated with the office as reflected in the MLS data"
    },
    percentOf365DaysWithOffice: {
        id: "percentOf365DaysWithOffice",
        label: "% of 365",
        tip: "The percentage of a full year that the agent has been with the office"
    },
    volumeDifference: {
        id: "volumeDifference",
        label: "Difference",
        tip: "The difference between the agent's total $ volume after the move and the agent's $ volume yardstick "
    },
    volumeGrowth: {
        id: "volumeGrowth",
        label: "% Growth",
        tip: "A percentage measurement of the agent's actual $ volume performance relative to their $ volume yardstick  "
    },
    volumePostMove: {
        id: "volumePostMove",
        label: "$ Volume",
        tip: "The agent's total $ volume since moving to a different office"
    },
    volumePreMove: {
        id: "volumePreMove",
        label: "$ Volume",
        tip: "The agent's total $ volume for the 365 days prior to the move to a different office"
    },
    volumeYardstick: {
        id: "volumeYardstick",
        label: "$ Volume Yardstick",
        tip: "The amount of post-move $ volume that would be necessary to keep the agent on pace with their 365 day pre-move $ volume yardstick"
    }
};
const $cfe273a96172ad06$export$1af75cb449ba214f = Object.freeze({
    ...$cfe273a96172ad06$export$339cecd0af4786de,
    officeName: {
        id: "officeName",
        label: "Office From",
        tip: "The office the agent left to join one of your offices"
    }
});
const $cfe273a96172ad06$export$fa69b7335e8e7cc6 = Object.freeze({
    ...$cfe273a96172ad06$export$339cecd0af4786de,
    officeName: {
        id: "officeName",
        label: "Office To",
        tip: "The office the agent joined after leaving one of your offices"
    }
});
const $cfe273a96172ad06$export$b02d86cbb3d565d5 = {
    amSearchResults: `Agent Movement Report - ${(0, $i95vK.fieldMarkers).DATE}`,
    breakdownResults: `Agent Movement - ${(0, $i95vK.fieldMarkers).AM_BREAKDOWN_TAB}${(0, $i95vK.fieldMarkers).FROM_OR_TO}${(0, $i95vK.fieldMarkers).OFFICE} - ${(0, $i95vK.fieldMarkers).DATE}`,
    fromBreakdownGrowthResults: `Agent Movement - ${(0, $i95vK.fieldMarkers).OFFICE} ${(0, $i95vK.fieldMarkers).AM_BREAKDOWN_TAB} - ${(0, $i95vK.fieldMarkers).DATE}`
};

});


parcelRegister("cL3O2", function(module, exports) {

$parcel$export(module.exports, "listingViews", () => $949cd3a6e1cf1ce4$export$c69b2be925a17897);
$parcel$export(module.exports, "getListingTabsByStatus", () => $949cd3a6e1cf1ce4$export$c364a4c7d6cdd32c);
$parcel$export(module.exports, "listingBreakdownViewsIds", () => $949cd3a6e1cf1ce4$export$a2d64dda7734048b);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $bLQRh = parcelRequire("bLQRh");

var $RG6ps = parcelRequire("RG6ps");

var $dBG6V = parcelRequire("dBG6V");

var $yM1a3 = parcelRequire("yM1a3");

var $2t1vB = parcelRequire("2t1vB");

var $Y3wXx = parcelRequire("Y3wXx");

var $jYTRP = parcelRequire("jYTRP");

var $5usXl = parcelRequire("5usXl");

var $e6sW3 = parcelRequire("e6sW3");

var $e88jF = parcelRequire("e88jF");

var $gmkC2 = parcelRequire("gmkC2");

var $emacI = parcelRequire("emacI");

var $gRzdS = parcelRequire("gRzdS");

var $kwMiU = parcelRequire("kwMiU");

var $f1v6f = parcelRequire("f1v6f");

var $ikyhZ = parcelRequire("ikyhZ");
const $949cd3a6e1cf1ce4$var$initialListingsbreakdownTab = 1;
const $949cd3a6e1cf1ce4$export$dc323532bb68919b = Object.freeze({
    avg$Sqft: $yM1a3.avg$Sqft,
    avgDomCdom: $Y3wXx.avgDomCdom,
    avgSpLpComparison: $e6sW3.avgSpLpComparison,
    avgSpOpComparison: $emacI.avgSpOpComparison,
    avgSpOpAllComparison: {
        label: (0, $bLQRh.terms).avgSpOpAllComparison,
        value: "avgSpOpAllComparison"
    },
    avgSpOpAllProperties: $gmkC2.avgSpOpAllProperties,
    cdomBreakout: $kwMiU.cdomBreakout,
    forSaleVsFsldm: $gRzdS.forSaleVsFsldm,
    medianPrice: $RG6ps.medianPrice,
    monthlySupplyOfInventory: $jYTRP.monthlySupplyOfInventory,
    overview: {
        label: (0, $bLQRh.terms).overview,
        value: "overview"
    },
    salesAbsorption: $e88jF.salesAbsorption,
    soldAvgVsMedianPrice: $dBG6V.soldAvgVsMedianPrice,
    supplyAmpDemandNumUnits: $2t1vB.supplyAmpDemandNumUnits,
    underContractUc: $5usXl.underContractUc
});
const $949cd3a6e1cf1ce4$export$c69b2be925a17897 = Object.fromEntries(Object.entries($949cd3a6e1cf1ce4$export$dc323532bb68919b).map(([key, value])=>{
    const tablesWithCellRenderer = value.tableSettings?.tables.map((table)=>table.col?.id === "timePeriodStart" ? {
            ...table,
            cellRenderer: (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $f1v6f.default), {
                    ...props
                })
        } : table);
    return [
        key,
        key !== (0, $kwMiU.cdomBreakout).value ? {
            ...value,
            tableSettings: {
                ...value.tableSettings,
                tables: tablesWithCellRenderer
            }
        } : value
    ];
}));
const $949cd3a6e1cf1ce4$var$buildTab = ({ listingStatus: listingStatus, tableTitleWithTooltips: tableTitleWithTooltips, searchCriteria: searchCriteria, component: component, gridRefs: gridRefs, tabIndex: tabIndex = 1, isOfficeListing: isOfficeListing })=>({
        title: (0, $bLQRh.terms).getListingTitle(listingStatus.label),
        content: {
            jsx: component({
                listingStatus: listingStatus,
                tableTitleWithTooltips: tableTitleWithTooltips,
                searchCriteria: searchCriteria,
                tabIndex: tabIndex,
                gridRef: (ref)=>gridRefs.current[tabIndex] = ref,
                isOfficeListing: isOfficeListing
            })
        }
    });
const $949cd3a6e1cf1ce4$var$getForSaleLastDayOfTheMonthTab = (args)=>$949cd3a6e1cf1ce4$var$buildTab({
        ...args,
        listingStatus: (0, $ikyhZ.listingStatuses).forSaleLdm
    });
const $949cd3a6e1cf1ce4$var$getUnderContractsTab = (args)=>$949cd3a6e1cf1ce4$var$buildTab({
        ...args,
        listingStatus: (0, $ikyhZ.listingStatuses).underContract
    });
const $949cd3a6e1cf1ce4$var$getForSaleTab = (args)=>$949cd3a6e1cf1ce4$var$buildTab({
        ...args,
        listingStatus: (0, $ikyhZ.listingStatuses).forSale
    });
const $949cd3a6e1cf1ce4$var$getSoldTab = (args)=>$949cd3a6e1cf1ce4$var$buildTab({
        ...args,
        listingStatus: (0, $ikyhZ.listingStatuses).sold
    });
const $949cd3a6e1cf1ce4$var$buildmonthlySupplyOfInventoryTabs = ({ checkedStatusOptions: checkedStatusOptions, ...args })=>{
    const hasMsiSold = !!checkedStatusOptions.find((item)=>item.id === (0, $ikyhZ.listingStatuses).msiSold.id);
    const hasUnderContractMsi = !!checkedStatusOptions.find((item)=>item.id === (0, $ikyhZ.listingStatuses).underContractMsi.id);
    const tabs = [];
    let tabIndex = $949cd3a6e1cf1ce4$var$initialListingsbreakdownTab;
    if (hasMsiSold) {
        tabs.push($949cd3a6e1cf1ce4$var$getSoldTab({
            ...args,
            tabIndex: tabIndex
        }));
        tabIndex++;
    }
    tabs.push($949cd3a6e1cf1ce4$var$getForSaleLastDayOfTheMonthTab({
        ...args,
        tabIndex: tabIndex
    })), tabIndex++;
    hasUnderContractMsi && tabs.push($949cd3a6e1cf1ce4$var$getUnderContractsTab({
        ...args,
        tabIndex: tabIndex
    }));
    return tabs;
};
const $949cd3a6e1cf1ce4$var$buildSalesAbsortionTabs = ({ checkedStatusOptions: checkedStatusOptions, ...args })=>{
    const hasUnderContract = !!checkedStatusOptions.find((item)=>item.id === (0, $ikyhZ.listingStatuses).underContract.id);
    const hasSold = !!checkedStatusOptions.find((item)=>item.id === (0, $ikyhZ.listingStatuses).sold.id);
    const tabs = [];
    let tabIndex = $949cd3a6e1cf1ce4$var$initialListingsbreakdownTab;
    tabs.push($949cd3a6e1cf1ce4$var$getForSaleTab({
        ...args,
        tabIndex: tabIndex
    })), tabIndex++;
    if (hasUnderContract) {
        tabs.push($949cd3a6e1cf1ce4$var$getUnderContractsTab({
            ...args,
            tabIndex: tabIndex
        }));
        tabIndex++;
    }
    hasSold && tabs.push($949cd3a6e1cf1ce4$var$getSoldTab({
        ...args,
        tabIndex: tabIndex
    }));
    return tabs;
};
const $949cd3a6e1cf1ce4$export$c364a4c7d6cdd32c = ({ selectedListingViewId: selectedListingViewId, ...args })=>{
    let tabs = [];
    if (selectedListingViewId === (0, $dBG6V.soldAvgVsMedianPrice).value) tabs = [
        $949cd3a6e1cf1ce4$var$getSoldTab(args)
    ];
    if (selectedListingViewId === (0, $emacI.avgSpOpComparison).value) tabs = [
        $949cd3a6e1cf1ce4$var$getSoldTab(args)
    ];
    if (selectedListingViewId === (0, $e6sW3.avgSpLpComparison).value) tabs = [
        $949cd3a6e1cf1ce4$var$getSoldTab(args)
    ];
    if (selectedListingViewId === (0, $gmkC2.avgSpOpAllProperties).value) tabs = [
        $949cd3a6e1cf1ce4$var$getSoldTab(args)
    ];
    if (selectedListingViewId === (0, $e88jF.salesAbsorption).value) tabs = $949cd3a6e1cf1ce4$var$buildSalesAbsortionTabs(args);
    if (selectedListingViewId === (0, $5usXl.underContractUc).value) tabs = [
        $949cd3a6e1cf1ce4$var$getUnderContractsTab(args)
    ];
    if (selectedListingViewId === (0, $Y3wXx.avgDomCdom).value) tabs = [
        $949cd3a6e1cf1ce4$var$getUnderContractsTab(args)
    ];
    if (selectedListingViewId === (0, $jYTRP.monthlySupplyOfInventory).value) tabs = $949cd3a6e1cf1ce4$var$buildmonthlySupplyOfInventoryTabs(args);
    return tabs;
};
const $949cd3a6e1cf1ce4$export$a2d64dda7734048b = [
    (0, $RG6ps.medianPrice).value,
    (0, $yM1a3.avg$Sqft).value,
    (0, $2t1vB.supplyAmpDemandNumUnits).value,
    (0, $gRzdS.forSaleVsFsldm).value
];

});
parcelRegister("RG6ps", function(module, exports) {

$parcel$export(module.exports, "medianPrice", () => $0a159c01f13c884c$export$ccae59725fc6f47b);

var $bLQRh = parcelRequire("bLQRh");

var $ikyhZ = parcelRequire("ikyhZ");

var $htzEo = parcelRequire("htzEo");

var $1PiL9 = parcelRequire("1PiL9");

var $98ROn = parcelRequire("98ROn");
const $0a159c01f13c884c$export$ccae59725fc6f47b = {
    label: (0, $bLQRh.terms).medianPrice,
    value: "medianPrice",
    statusOptions: {
        groups: [
            {
                options: [
                    {
                        ...(0, $ikyhZ.listingStatuses).newListings,
                        keyField: "newMedianVolume"
                    },
                    {
                        ...(0, $ikyhZ.listingStatuses).forSale,
                        keyField: "forSaleMedianVolume"
                    },
                    {
                        ...(0, $ikyhZ.listingStatuses).underContract,
                        keyField: "ucMedianVolume"
                    },
                    {
                        ...(0, $ikyhZ.listingStatuses).sold,
                        isDefault: true,
                        keyField: "soldMedianVolume"
                    },
                    {
                        ...(0, $ikyhZ.listingStatuses).expired,
                        keyField: "expMedianVolume"
                    }
                ]
            }
        ]
    },
    tableSettings: {
        id: "medianPrice",
        showPagination: false,
        defaultSort: {
            colId: (0, $1PiL9.marketDynamicsColumns).timePeriodStart.id,
            sortDir: "desc"
        },
        tables: [
            {
                col: (0, $1PiL9.marketDynamicsColumns).timePeriodStart,
                colDef: (0, $98ROn.colSettings).quarterNumYearFormat
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).newMedianVolume,
                colDef: (0, $98ROn.colSettings).numberSmVolume,
                statusId: (0, $ikyhZ.listingStatuses).newListings.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).newUnits,
                colDef: (0, $98ROn.colSettings).numberSmInteger,
                statusId: (0, $ikyhZ.listingStatuses).newListings.id,
                measureType: (0, $bLQRh.measureTypes).units
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).forSaleMedianVolume,
                colDef: (0, $98ROn.colSettings).numberSmVolume,
                statusId: (0, $ikyhZ.listingStatuses).forSale.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).forSaleUnits,
                colDef: (0, $98ROn.colSettings).numberSmInteger,
                statusId: (0, $ikyhZ.listingStatuses).forSale.id,
                measureType: (0, $bLQRh.measureTypes).units
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).ucMedianVolume,
                colDef: (0, $98ROn.colSettings).numberSmVolume,
                statusId: (0, $ikyhZ.listingStatuses).underContract.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).ucUnits,
                colDef: (0, $98ROn.colSettings).numberSmInteger,
                statusId: (0, $ikyhZ.listingStatuses).underContract.id,
                measureType: (0, $bLQRh.measureTypes).units
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).soldMedianVolume,
                colDef: (0, $98ROn.colSettings).numberSmVolume,
                statusId: (0, $ikyhZ.listingStatuses).sold.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).soldUnits,
                colDef: (0, $98ROn.colSettings).numberSmInteger,
                statusId: (0, $ikyhZ.listingStatuses).sold.id,
                measureType: (0, $bLQRh.measureTypes).units
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).expMedianVolume,
                colDef: (0, $98ROn.colSettings).numberSmVolume,
                statusId: (0, $ikyhZ.listingStatuses).expired.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).expUnits,
                colDef: (0, $98ROn.colSettings).numberSmInteger,
                statusId: (0, $ikyhZ.listingStatuses).expired.id,
                measureType: (0, $bLQRh.measureTypes).units
            }
        ]
    },
    chart: {
        yAxis: {
            title: (0, $bLQRh.getYAxisTitle)((0, $bLQRh.terms).yAxisDollarChartTitle),
            labels: {
                formatter: (0, $htzEo.getCompactDollars)
            }
        },
        popOverDataFormatter: (0, $htzEo.popOverDataFormatters).volume
    },
    keyInformation: {
        formatter: (0, $htzEo.formatVolume),
        changeColumnHeaderName: (0, $bLQRh.terms).change$
    }
};

});
parcelRegister("1PiL9", function(module, exports) {

$parcel$export(module.exports, "marketDynamicsColumns", () => $15491b1ac107dbb5$export$887ae5fcc3e35b8c);

var $bLQRh = parcelRequire("bLQRh");

var $cstaF = parcelRequire("cstaF");
const $15491b1ac107dbb5$export$887ae5fcc3e35b8c = Object.freeze({
    address: {
        id: "address",
        label: (0, $cstaF.agentProductionTerms).address
    },
    areaId: {
        id: "areaId",
        label: (0, $cstaF.agentProductionTerms).area
    },
    avgCdom: {
        id: "avgCdom",
        label: (0, $bLQRh.terms).avgCdom,
        keyField: "ucAvgCdom"
    },
    avgDom: {
        id: "avgDom",
        label: (0, $bLQRh.terms).avgDom,
        keyField: "ucAvgDom"
    },
    avgSpOp: {
        id: "avgSpOp",
        label: (0, $bLQRh.terms).avgSpOp,
        keyField: "spOpRatioAllProperties"
    },
    bankStatus: {
        id: "bankStatus",
        label: (0, $cstaF.agentProductionTerms).bankProperty
    },
    fullBaths: {
        id: "fullBaths",
        label: (0, $cstaF.agentProductionTerms).ba
    },
    bedrooms: {
        id: "bedrooms",
        label: (0, $cstaF.agentProductionTerms).bd
    },
    beginPeriod: {
        id: "beginPeriod",
        field: (0, $bLQRh.periodKeys).beginPeriodValue
    },
    cdom: {
        id: "cdom",
        label: (0, $cstaF.agentProductionTerms).cdom
    },
    changeAvg: {
        id: "changeAvg",
        label: (0, $bLQRh.terms).medianPriceChange
    },
    changeAvgPercentage: {
        id: "changeAvgPercentage",
        label: (0, $bLQRh.terms).changePct
    },
    changeValue: {
        id: "changeValue",
        label: (0, $bLQRh.terms).change$
    },
    changeValuePercentage: {
        id: "changeValuePercentage",
        label: (0, $bLQRh.terms).changePct
    },
    city: {
        id: "city",
        label: (0, $cstaF.agentProductionTerms).city
    },
    costPerSqft: {
        id: "costPerSqft",
        label: (0, $bLQRh.terms).pricePerSqft
    },
    dom: {
        id: "dom",
        label: (0, $cstaF.agentProductionTerms).dom
    },
    endPeriod: {
        id: "endPeriod",
        field: (0, $bLQRh.periodKeys).endPeriodValue
    },
    expAvgDom: {
        id: "expAvgDom",
        label: (0, $bLQRh.terms).expAvgDom
    },
    expAvgPricePerSqft: {
        id: "expAvgPricePerSqft",
        label: (0, $bLQRh.terms).expAvgPricePerSqft
    },
    expAvgSqft: {
        id: "expAvgSqft",
        label: (0, $bLQRh.terms).expAvgSqft
    },
    expAvgVolume: {
        id: "expAvgVolume",
        label: (0, $bLQRh.terms).expAvgVolume
    },
    expMedianVolume: {
        id: "expMedianVolume",
        label: (0, $bLQRh.terms).expMedianVolume
    },
    expUnits: {
        id: "expUnits",
        label: (0, $bLQRh.terms).expUnits
    },
    forSaleAvgDom: {
        id: "forSaleAvgDom",
        label: (0, $bLQRh.terms).forSaleAvgDom
    },
    forSaleAvgPricePerSqft: {
        id: "forSaleAvgPricePerSqft",
        label: (0, $bLQRh.terms).forSaleAvgPricePerSqft
    },
    forSaleAvgSqft: {
        id: "forSaleAvgSqft",
        label: (0, $bLQRh.terms).forSaleAvgSqft
    },
    forSaleAvgVolume: {
        id: "forSaleAvgVolume",
        label: (0, $bLQRh.terms).forSaleAvgVolume
    },
    forSaleLastDayChangeVolume: {
        id: "forSaleLastDayChangeVolume",
        label: (0, $bLQRh.terms).forSaleLastDayChangeVolume
    },
    forSaleLastDayPercentage: {
        id: "forSaleLastDayPercentage",
        label: (0, $bLQRh.terms).percentDifference
    },
    forSaleLastDayUnits: {
        id: "forSaleLastDayUnits",
        label: (0, $bLQRh.terms).forSaleLastDayUnits
    },
    forSaleLastDayUnits0to90: {
        id: "forSaleLastDayUnits0to90",
        label: (0, $bLQRh.terms).units0To90Cdom
    },
    forSaleLastDayUnits0to90Pct: {
        id: "forSaleLastDayUnits0to90Pct",
        label: (0, $bLQRh.terms).units0To90CdomPct
    },
    forSaleLastDayUnits91to180: {
        id: "forSaleLastDayUnits91to180",
        label: (0, $bLQRh.terms).units91To180Cdom
    },
    forSaleLastDayUnits91to180Pct: {
        id: "forSaleLastDayUnits91to180Pct",
        label: (0, $bLQRh.terms).units91To180CdomPct
    },
    forSaleLastDayUnitsOver180: {
        id: "forSaleLastDayUnitsOver180",
        label: (0, $bLQRh.terms).unitsOver180Cdom
    },
    forSaleLastDayUnitsOver180Pct: {
        id: "forSaleLastDayUnitsOver180Pct",
        label: (0, $bLQRh.terms).unitsOver180CdomPct
    },
    forSaleMedianVolume: {
        id: "forSaleMedianVolume",
        label: (0, $bLQRh.terms).forSaleMedianVolume
    },
    forSaleUnits: {
        id: "forSaleUnits",
        label: (0, $bLQRh.terms).forSaleUnits
    },
    lastWeeksAvg: {
        id: "lastWeeksAvg",
        label: (0, $bLQRh.terms).lastWeeksAvg
    },
    listAgent: {
        id: "listAgent",
        label: (0, $cstaF.agentProductionTerms).listAgent
    },
    listDate: {
        id: "listDate",
        label: (0, $cstaF.agentProductionTerms).listDate,
        keyField: "date"
    },
    listPrice: {
        id: "listPrice",
        label: (0, $cstaF.agentProductionTerms).listPrice
    },
    lotSizeSquareFt: {
        id: "lotSizeSquareFt",
        label: (0, $cstaF.agentProductionTerms).lotSizeSqft
    },
    mlsNum: {
        id: "mlsNum",
        label: (0, $cstaF.agentProductionTerms).mlsNum
    },
    newAvgPricePerSqft: {
        id: "newAvgPricePerSqft",
        label: (0, $bLQRh.terms).newAvgPricePerSqft
    },
    newAvgSqft: {
        id: "newAvgSqft",
        label: (0, $bLQRh.terms).newAvgSqft
    },
    newAvgVolume: {
        id: "newAvgVolume",
        label: (0, $bLQRh.terms).newAvgVolume
    },
    newMedianVolume: {
        id: "newMedianVolume",
        label: (0, $bLQRh.terms).newMedianVolume
    },
    newUnits: {
        id: "newUnits",
        label: (0, $bLQRh.terms).newUnits
    },
    officeId: {
        id: "officeId",
        label: (0, $cstaF.agentProductionTerms).officeId
    },
    officeName: {
        id: "officeName",
        label: (0, $cstaF.agentProductionTerms).office
    },
    offMarketDate: {
        id: "offMarketDate",
        label: (0, $bLQRh.terms).offMarketDate,
        keyField: "date"
    },
    orgPrice: {
        id: "orgPrice",
        label: (0, $bLQRh.terms).orgPrice
    },
    periodChange: {
        id: "periodChange"
    },
    periodChangeVolume: {
        id: "periodChangeVolume"
    },
    periodPercentChange: {
        id: "periodPercentChange"
    },
    periodPercentChangeUnits: {
        id: "periodPercentChangeUnits"
    },
    previousWeeksAvg: {
        id: "previousWeeksAvg",
        label: (0, $bLQRh.terms).previousWeeksAvg
    },
    price: {
        id: "price",
        label: (0, $bLQRh.terms).price
    },
    priceChangeCnt: {
        id: "priceChangeCnt",
        label: (0, $cstaF.agentProductionTerms).priceChangeCnt
    },
    soldAvgDom: {
        id: "soldAvgDom",
        label: (0, $bLQRh.terms).soldAvgDom
    },
    soldAvgDomWithoutPriceChanges: {
        id: "soldAvgDomWithoutPriceChanges",
        label: (0, $bLQRh.terms).soldAvgDomWithoutPriceChanges
    },
    soldAvgDomWithPriceChanges: {
        id: "soldAvgDomWithPriceChanges",
        label: (0, $bLQRh.terms).soldAvgDomWithPriceChanges
    },
    soldAvgPricePerSqft: {
        id: "soldAvgPricePerSqft",
        label: (0, $bLQRh.terms).soldAvgPricePerSqft
    },
    soldAvgSqft: {
        id: "soldAvgSqft",
        label: (0, $bLQRh.terms).soldAvgSqft
    },
    soldAvgVolume: {
        id: "soldAvgVolume",
        label: (0, $bLQRh.terms).soldAvgVolume
    },
    soldChangeVolume: {
        id: "soldChangeVolume",
        label: (0, $bLQRh.terms).soldChangeVolume
    },
    soldDate: {
        id: "soldDate",
        label: (0, $cstaF.agentProductionTerms).soldDate,
        keyField: "date"
    },
    soldGrowthVolumePct: {
        id: "soldGrowthVolumePct",
        label: (0, $bLQRh.terms).soldGrowthVolumePct
    },
    soldMedianVolume: {
        id: "soldMedianVolume",
        label: (0, $bLQRh.terms).soldMedianVolume
    },
    soldMsi: {
        id: "soldMsi",
        label: (0, $bLQRh.terms).msiSold
    },
    soldPrice: {
        id: "soldPrice",
        label: (0, $cstaF.agentProductionTerms).soldPrice,
        keyField: "price"
    },
    soldToForSaleUnitsPct: {
        id: "soldToForSaleUnitsPct",
        label: (0, $bLQRh.terms).soldPercentage
    },
    soldUnits: {
        id: "soldUnits",
        label: (0, $bLQRh.terms).soldUnits
    },
    soldUnits0to90: {
        id: "soldUnits0to90",
        label: (0, $bLQRh.terms).units0To90Cdom
    },
    soldUnits0to90Pct: {
        id: "soldUnits0to90Pct",
        label: (0, $bLQRh.terms).units0To90CdomPct
    },
    soldUnits91to180: {
        id: "soldUnits91to180",
        label: (0, $bLQRh.terms).units91To180Cdom
    },
    soldUnits91to180Pct: {
        id: "soldUnits91to180Pct",
        label: (0, $bLQRh.terms).units91To180CdomPct
    },
    soldUnitsOver180: {
        id: "soldUnitsOver180",
        label: (0, $bLQRh.terms).unitsOver180Cdom
    },
    soldUnitsOver180Pct: {
        id: "soldUnitsOver180Pct",
        label: (0, $bLQRh.terms).unitsOver180CdomPct
    },
    soldUnitsWithoutPriceChanges: {
        id: "soldUnitsWithoutPriceChanges",
        label: (0, $bLQRh.terms).soldUnitsWithoutPriceChanges
    },
    soldUnitsWithPriceChanges: {
        id: "soldUnitsWithPriceChanges",
        label: (0, $bLQRh.terms).soldUnitsWithPriceChanges
    },
    spLpRatioWithoutPriceChanges: {
        id: "spLpRatioWithoutPriceChanges",
        label: (0, $bLQRh.terms).spLpRatioWithoutPriceChanges
    },
    spLpRatioWithPriceChanges: {
        id: "spLpRatioWithPriceChanges",
        label: (0, $bLQRh.terms).spLpRatioWithPriceChanges
    },
    spOpRatioWithoutPriceChanges: {
        id: "spOpRatioWithoutPriceChanges",
        label: (0, $bLQRh.terms).spOpRatioWithoutPriceChanges
    },
    spOpRatioWithPriceChanges: {
        id: "spOpRatioWithPriceChanges",
        label: (0, $bLQRh.terms).spOpRatioWithPriceChanges
    },
    squareFt: {
        id: "squareFt",
        label: (0, $cstaF.agentProductionTerms).sqft
    },
    status: {
        id: "status",
        label: (0, $bLQRh.terms).status
    },
    streetName: {
        id: "streetName",
        label: (0, $cstaF.agentProductionTerms).address
    },
    timePeriodStart: {
        id: "timePeriodStart"
    },
    totalChange: {
        id: "totalChange",
        label: (0, $bLQRh.terms).totalChange
    },
    totalChangeUnits: {
        id: "totalChangeUnits"
    },
    totalPercentChange: {
        id: "totalPercentChange",
        label: (0, $bLQRh.terms).totalPercentChange
    },
    totalPercentChangeUnits: {
        id: "totalPercentChangeUnits"
    },
    typeName: {
        id: "typeName",
        label: (0, $cstaF.agentProductionTerms).type
    },
    ucAvgCdom: {
        id: "ucAvgCdom",
        label: (0, $bLQRh.terms).avgCdom
    },
    ucAvgDom: {
        id: "ucAvgDom",
        label: (0, $bLQRh.terms).ucAvgDom
    },
    ucAvgPricePerSqft: {
        id: "ucAvgPricePerSqft",
        label: (0, $bLQRh.terms).ucAvgPricePerSqft
    },
    ucAvgSqft: {
        id: "ucAvgSqft",
        label: (0, $bLQRh.terms).ucAvgSqft
    },
    ucAvgVolume: {
        id: "ucAvgVolume",
        label: (0, $bLQRh.terms).ucAvgVolume
    },
    ucDate: {
        id: "ucDate",
        label: (0, $cstaF.agentProductionTerms).ucDate,
        keyField: "date"
    },
    ucMedianVolume: {
        id: "ucMedianVolume",
        label: (0, $bLQRh.terms).ucMedianVolume
    },
    ucMsi: {
        id: "ucMsi",
        label: (0, $bLQRh.terms).underContractMsi
    },
    ucToForSaleUnitsPct: {
        id: "ucToForSaleUnitsPct",
        label: (0, $bLQRh.terms).ucPercentage
    },
    ucUnits: {
        id: "ucUnits",
        label: (0, $bLQRh.terms).ucUnits
    },
    ucUnits0to90: {
        id: "ucUnits0to90",
        label: (0, $bLQRh.terms).units0To90Cdom
    },
    ucUnits0to90Pct: {
        id: "ucUnits0to90Pct",
        label: (0, $bLQRh.terms).units0To90CdomPct
    },
    ucUnits91to180: {
        id: "ucUnits91to180",
        label: (0, $bLQRh.terms).units91To180Cdom
    },
    ucUnits91to180Pct: {
        id: "ucUnits91to180Pct",
        label: (0, $bLQRh.terms).units91To180CdomPct
    },
    ucUnitsOver180: {
        id: "ucUnitsOver180",
        label: (0, $bLQRh.terms).unitsOver180Cdom
    },
    ucUnitsOver180Pct: {
        id: "ucUnitsOver180Pct",
        label: (0, $bLQRh.terms).unitsOver180CdomPct
    },
    yearBuilt: {
        id: "yearBuilt",
        label: (0, $cstaF.agentProductionTerms).yearBuilt
    },
    zipcode: {
        id: "zipcode",
        label: (0, $cstaF.agentProductionTerms).zip
    },
    zipCode: {
        id: "zipCode",
        label: (0, $cstaF.agentProductionTerms).zip
    },
    periodChangePercent: {
        id: "periodChangePercent"
    },
    periodPercentChangePercent: {
        id: "periodPercentChangePercent"
    },
    totalChangePercent: {
        id: "totalChangePercent",
        label: (0, $bLQRh.terms).totalChange
    },
    totalPercentChangePercent: {
        id: "totalPercentChangePercent",
        label: (0, $bLQRh.terms).totalPercentChange
    }
});

});


parcelRegister("dBG6V", function(module, exports) {

$parcel$export(module.exports, "soldAvgVsMedianPrice", () => $9e7f655f175e384f$export$946a1e1f5f1acebd);

var $bLQRh = parcelRequire("bLQRh");

var $ikyhZ = parcelRequire("ikyhZ");

var $htzEo = parcelRequire("htzEo");

var $1PiL9 = parcelRequire("1PiL9");

var $98ROn = parcelRequire("98ROn");
const $9e7f655f175e384f$export$946a1e1f5f1acebd = {
    label: (0, $bLQRh.terms).soldAvgVsMedianPrice,
    value: "soldAvgVsMedianPrice",
    statusOptions: {
        groups: [
            {
                options: [
                    {
                        ...(0, $ikyhZ.listingStatuses).averagePrice,
                        isDefault: true,
                        keyField: "soldAvgVolume"
                    },
                    {
                        ...(0, $ikyhZ.listingStatuses).medianPrice,
                        isDefault: true,
                        keyField: "soldMedianVolume"
                    }
                ]
            }
        ]
    },
    tableSettings: {
        id: "soldAvgVsMedianPrice",
        showPagination: false,
        defaultSort: {
            colId: (0, $1PiL9.marketDynamicsColumns).timePeriodStart.id,
            sortDir: "desc"
        },
        tables: [
            {
                col: (0, $1PiL9.marketDynamicsColumns).timePeriodStart,
                colDef: (0, $98ROn.colSettings).quarterNumYearFormat
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).soldChangeVolume,
                colDef: (0, $98ROn.colSettings).numberSmVolume
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).soldAvgVolume,
                colDef: (0, $98ROn.colSettings).numberSmVolume
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).soldGrowthVolumePct,
                colDef: (0, $98ROn.colSettings).numberSmPercentage
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).soldAvgDom,
                colDef: (0, $98ROn.colSettings).numberSmInteger
            }
        ]
    },
    chart: {
        yAxis: {
            title: (0, $bLQRh.getYAxisTitle)((0, $bLQRh.terms).yAxisDollarChartTitle),
            labels: {
                formatter: (0, $htzEo.getCompactDollars)
            }
        },
        popOverDataFormatter: (0, $htzEo.popOverDataFormatters).volume
    },
    keyInformation: {
        formatter: (0, $htzEo.formatVolume),
        changeColumnHeaderName: (0, $bLQRh.terms).change$
    }
};

});

parcelRegister("yM1a3", function(module, exports) {

$parcel$export(module.exports, "avg$Sqft", () => $06886c694b4090e2$export$fb50498ab86658de);

var $bLQRh = parcelRequire("bLQRh");

var $ikyhZ = parcelRequire("ikyhZ");

var $1PiL9 = parcelRequire("1PiL9");

var $htzEo = parcelRequire("htzEo");

var $98ROn = parcelRequire("98ROn");
const $06886c694b4090e2$export$fb50498ab86658de = {
    label: (0, $bLQRh.terms).avgPriceSqft,
    value: "avgPriceSqft",
    statusOptions: {
        groups: [
            {
                options: [
                    {
                        ...(0, $ikyhZ.listingStatuses).newListings,
                        keyField: "newAvgPricePerSqft",
                        keyInfoLabel: (0, $bLQRh.terms).avgPriceSqftLabel((0, $ikyhZ.listingStatuses).newListings.label)
                    },
                    {
                        ...(0, $ikyhZ.listingStatuses).forSale,
                        keyField: "forSaleAvgPricePerSqft",
                        keyInfoLabel: (0, $bLQRh.terms).avgPriceSqftLabel((0, $ikyhZ.listingStatuses).forSale.label)
                    },
                    {
                        ...(0, $ikyhZ.listingStatuses).underContract,
                        keyField: "ucAvgPricePerSqft",
                        keyInfoLabel: (0, $bLQRh.terms).avgPriceSqftLabel((0, $ikyhZ.listingStatuses).underContract.label)
                    },
                    {
                        ...(0, $ikyhZ.listingStatuses).sold,
                        keyField: "soldAvgPricePerSqft",
                        keyInfoLabel: (0, $bLQRh.terms).avgPriceSqftLabel((0, $ikyhZ.listingStatuses).sold.label),
                        isDefault: true
                    },
                    {
                        ...(0, $ikyhZ.listingStatuses).expired,
                        keyField: "expAvgPricePerSqft",
                        keyInfoLabel: (0, $bLQRh.terms).avgPriceSqftLabel((0, $ikyhZ.listingStatuses).expired.label)
                    }
                ]
            }
        ]
    },
    tableSettings: {
        id: "avgPriceSqft",
        showPagination: false,
        defaultSort: {
            colId: (0, $1PiL9.marketDynamicsColumns).timePeriodStart.id,
            sortDir: "desc"
        },
        tables: [
            {
                col: (0, $1PiL9.marketDynamicsColumns).timePeriodStart
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).newUnits,
                colDef: (0, $98ROn.colSettings).numberMdInteger,
                statusId: (0, $ikyhZ.listingStatuses).newListings.id,
                measureType: (0, $bLQRh.measureTypes).units
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).newAvgVolume,
                colDef: (0, $98ROn.colSettings).numberSmVolume,
                statusId: (0, $ikyhZ.listingStatuses).newListings.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).newAvgSqft,
                colDef: (0, $98ROn.colSettings).numberMdInteger,
                statusId: (0, $ikyhZ.listingStatuses).newListings.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).newAvgPricePerSqft,
                colDef: (0, $98ROn.colSettings).numberSmVolume,
                statusId: (0, $ikyhZ.listingStatuses).newListings.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).forSaleUnits,
                colDef: (0, $98ROn.colSettings).numberSmInteger,
                statusId: (0, $ikyhZ.listingStatuses).forSale.id,
                measureType: (0, $bLQRh.measureTypes).units
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).forSaleAvgVolume,
                colDef: (0, $98ROn.colSettings).numberMdVolume,
                statusId: (0, $ikyhZ.listingStatuses).forSale.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).forSaleAvgSqft,
                colDef: (0, $98ROn.colSettings).numberLgInteger,
                statusId: (0, $ikyhZ.listingStatuses).forSale.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).forSaleAvgPricePerSqft,
                colDef: (0, $98ROn.colSettings).numberMdVolume,
                statusId: (0, $ikyhZ.listingStatuses).forSale.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).ucUnits,
                colDef: (0, $98ROn.colSettings).numberLgInteger,
                statusId: (0, $ikyhZ.listingStatuses).underContract.id,
                measureType: (0, $bLQRh.measureTypes).units
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).ucAvgVolume,
                colDef: {
                    ...(0, $98ROn.colSettings).numberMdVolume,
                    minWidth: 250
                },
                statusId: (0, $ikyhZ.listingStatuses).underContract.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).ucAvgSqft,
                colDef: {
                    ...(0, $98ROn.colSettings).numberLgInteger,
                    minWidth: 270
                },
                statusId: (0, $ikyhZ.listingStatuses).underContract.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).ucAvgPricePerSqft,
                colDef: {
                    ...(0, $98ROn.colSettings).numberMdVolume,
                    minWidth: 250
                },
                statusId: (0, $ikyhZ.listingStatuses).underContract.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).soldUnits,
                colDef: (0, $98ROn.colSettings).numberSmInteger,
                statusId: (0, $ikyhZ.listingStatuses).sold.id,
                measureType: (0, $bLQRh.measureTypes).units
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).soldAvgVolume,
                colDef: (0, $98ROn.colSettings).numberSmVolume,
                statusId: (0, $ikyhZ.listingStatuses).sold.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).soldAvgSqft,
                colDef: (0, $98ROn.colSettings).numberMdInteger,
                statusId: (0, $ikyhZ.listingStatuses).sold.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).soldAvgPricePerSqft,
                colDef: (0, $98ROn.colSettings).numberSmVolume,
                statusId: (0, $ikyhZ.listingStatuses).sold.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).expUnits,
                colDef: (0, $98ROn.colSettings).numberSmInteger,
                statusId: (0, $ikyhZ.listingStatuses).expired.id,
                measureType: (0, $bLQRh.measureTypes).units
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).expAvgVolume,
                colDef: (0, $98ROn.colSettings).numberMdVolume,
                statusId: (0, $ikyhZ.listingStatuses).expired.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).expAvgSqft,
                colDef: (0, $98ROn.colSettings).numberLgInteger,
                statusId: (0, $ikyhZ.listingStatuses).expired.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).expAvgPricePerSqft,
                colDef: (0, $98ROn.colSettings).numberMdVolume,
                statusId: (0, $ikyhZ.listingStatuses).expired.id
            }
        ]
    },
    chart: {
        yAxis: {
            title: (0, $bLQRh.getYAxisTitle)((0, $bLQRh.terms).pricePerSqft),
            labels: {
                formatter: (0, $htzEo.getCompactDollars)
            }
        },
        popOverDataFormatter: (0, $htzEo.popOverDataFormatters).volume
    },
    keyInformation: {
        formatter: (0, $htzEo.formatVolume),
        changeColumnHeaderName: (0, $bLQRh.terms).change$
    }
};

});

parcelRegister("2t1vB", function(module, exports) {

$parcel$export(module.exports, "supplyAmpDemandNumUnits", () => $1cbf75c89eb25bad$export$df6cb7688174f151);

var $98ROn = parcelRequire("98ROn");

var $1PiL9 = parcelRequire("1PiL9");

var $bLQRh = parcelRequire("bLQRh");

var $ikyhZ = parcelRequire("ikyhZ");

var $htzEo = parcelRequire("htzEo");
const $1cbf75c89eb25bad$export$df6cb7688174f151 = {
    label: (0, $bLQRh.terms).supplyAmpDemandNumUnits,
    value: "supplyAmpDemandNumUnits",
    statusOptions: {
        groups: [
            {
                options: [
                    {
                        ...(0, $ikyhZ.listingStatuses).newListings,
                        keyField: "newUnits"
                    },
                    {
                        ...(0, $ikyhZ.listingStatuses).forSale,
                        isDefault: true,
                        keyField: "forSaleUnits"
                    },
                    {
                        ...(0, $ikyhZ.listingStatuses).underContract,
                        isDefault: true,
                        keyField: "ucUnits"
                    },
                    {
                        ...(0, $ikyhZ.listingStatuses).sold,
                        isDefault: true,
                        keyField: "soldUnits"
                    },
                    {
                        ...(0, $ikyhZ.listingStatuses).expired,
                        keyField: "expUnits"
                    }
                ]
            }
        ]
    },
    tableSettings: {
        id: "supplyAmpDemandNumUnits",
        showPagination: false,
        defaultSort: {
            colId: (0, $1PiL9.marketDynamicsColumns).timePeriodStart.id,
            sortDir: "desc"
        },
        tables: [
            {
                col: (0, $1PiL9.marketDynamicsColumns).timePeriodStart
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).newUnits,
                colDef: (0, $98ROn.colSettings).numberSmInteger,
                statusId: (0, $ikyhZ.listingStatuses).newListings.id,
                measureType: (0, $bLQRh.measureTypes).units
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).forSaleUnits,
                colDef: (0, $98ROn.colSettings).numberSmInteger,
                statusId: (0, $ikyhZ.listingStatuses).forSale.id,
                measureType: (0, $bLQRh.measureTypes).units
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).forSaleAvgDom,
                colDef: (0, $98ROn.colSettings).numberSmInteger,
                statusId: (0, $ikyhZ.listingStatuses).forSale.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).ucUnits,
                colDef: (0, $98ROn.colSettings).numberSmInteger,
                statusId: (0, $ikyhZ.listingStatuses).underContract.id,
                measureType: (0, $bLQRh.measureTypes).units
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).ucAvgDom,
                colDef: (0, $98ROn.colSettings).numberSmInteger,
                statusId: (0, $ikyhZ.listingStatuses).underContract.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).soldUnits,
                colDef: (0, $98ROn.colSettings).numberSmInteger,
                statusId: (0, $ikyhZ.listingStatuses).sold.id,
                measureType: (0, $bLQRh.measureTypes).units
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).soldAvgDom,
                colDef: (0, $98ROn.colSettings).numberSmInteger,
                statusId: (0, $ikyhZ.listingStatuses).sold.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).expUnits,
                colDef: (0, $98ROn.colSettings).numberSmInteger,
                statusId: (0, $ikyhZ.listingStatuses).expired.id,
                measureType: (0, $bLQRh.measureTypes).units
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).expAvgDom,
                colDef: (0, $98ROn.colSettings).numberSmInteger,
                statusId: (0, $ikyhZ.listingStatuses).expired.id
            }
        ]
    },
    chart: {
        yAxis: {
            title: (0, $bLQRh.getYAxisTitle)((0, $bLQRh.terms).unitsNum),
            labels: {
                formatter: (0, $htzEo.formatInteger)
            }
        },
        popOverDataFormatter: (0, $htzEo.popOverDataFormatters).units
    },
    keyInformation: {
        formatter: (0, $htzEo.formatInteger),
        changeColumnHeaderName: (0, $bLQRh.terms).unitsChangeNum,
        headerTooltipUnitType: (0, $bLQRh.terms).unitsNum.toLowerCase()
    }
};

});

parcelRegister("Y3wXx", function(module, exports) {

$parcel$export(module.exports, "avgDomCdom", () => $0b4857d09b30be61$export$c9d52b8e187feb2e);

var $bLQRh = parcelRequire("bLQRh");

var $ikyhZ = parcelRequire("ikyhZ");

var $htzEo = parcelRequire("htzEo");

var $1PiL9 = parcelRequire("1PiL9");

var $98ROn = parcelRequire("98ROn");
const $0b4857d09b30be61$export$c9d52b8e187feb2e = {
    label: (0, $bLQRh.terms).avgDomCdom,
    value: "avgDomCdom",
    statusOptions: {
        groups: [
            {
                options: [
                    {
                        ...(0, $ikyhZ.listingStatuses).averageDom,
                        isDefault: true,
                        keyField: "ucAvgDom"
                    },
                    {
                        ...(0, $ikyhZ.listingStatuses).averageCdom,
                        isDefault: true,
                        keyField: "ucAvgCdom"
                    }
                ]
            }
        ]
    },
    tableSettings: {
        id: "avgDomCdom",
        showPagination: false,
        defaultSort: {
            colId: (0, $1PiL9.marketDynamicsColumns).timePeriodStart.id,
            sortDir: "desc"
        },
        tables: [
            {
                col: (0, $1PiL9.marketDynamicsColumns).timePeriodStart,
                colDef: (0, $98ROn.colSettings).quarterNumYearFormat
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).ucUnits,
                colDef: (0, $98ROn.colSettings).numberSmInteger
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).ucAvgDom,
                colDef: (0, $98ROn.colSettings).numberSmInteger,
                statusId: (0, $ikyhZ.listingStatuses).averageDom.id,
                measureType: (0, $bLQRh.measureTypes).units
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).ucAvgCdom,
                colDef: (0, $98ROn.colSettings).numberSmInteger,
                statusId: (0, $ikyhZ.listingStatuses).averageCdom.id,
                measureType: (0, $bLQRh.measureTypes).units
            }
        ]
    },
    chart: {
        yAxis: {
            title: (0, $bLQRh.getYAxisTitle)((0, $bLQRh.terms).days),
            labels: {
                formatter: (0, $htzEo.formatInteger)
            }
        },
        popOverDataFormatter: (0, $htzEo.popOverDataFormatters).units
    },
    keyInformation: {
        formatter: (0, $htzEo.formatInteger),
        changeColumnHeaderName: (0, $bLQRh.terms).daysChange,
        headerTooltipUnitType: (0, $bLQRh.terms).dom
    }
};

});

parcelRegister("jYTRP", function(module, exports) {

$parcel$export(module.exports, "monthlySupplyOfInventory", () => $e8bef4fac0d9ebbb$export$fecc35c9e7415217);

var $bLQRh = parcelRequire("bLQRh");

var $ikyhZ = parcelRequire("ikyhZ");

var $eNmV5 = parcelRequire("eNmV5");

var $htzEo = parcelRequire("htzEo");

var $1PiL9 = parcelRequire("1PiL9");

var $98ROn = parcelRequire("98ROn");
const $e8bef4fac0d9ebbb$export$fecc35c9e7415217 = {
    label: (0, $bLQRh.terms).monthlySupplyOfInventory,
    value: "monthlySupplyOfInventory",
    statusOptions: {
        groups: [
            {
                options: [
                    {
                        ...(0, $ikyhZ.listingStatuses).underContractMsi,
                        keyField: "ucMsi",
                        isDefault: true,
                        tooltip: (0, $eNmV5.marketDynamicsStatusTooltips).underContractMsi
                    },
                    {
                        ...(0, $ikyhZ.listingStatuses).msiSold,
                        keyField: "soldMsi",
                        tooltip: (0, $eNmV5.marketDynamicsStatusTooltips).msiSold
                    }
                ]
            }
        ]
    },
    tableSettings: {
        id: "monthlySupplyOfInventory",
        showPagination: false,
        defaultSort: {
            colId: (0, $1PiL9.marketDynamicsColumns).timePeriodStart.id,
            sortDir: "desc"
        },
        tables: [
            {
                col: (0, $1PiL9.marketDynamicsColumns).timePeriodStart,
                colDef: (0, $98ROn.colSettings).quarterNumYearFormat
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).ucMsi,
                colDef: (0, $98ROn.colSettings).numberSmUnits,
                statusId: (0, $ikyhZ.listingStatuses).underContractMsi.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).soldMsi,
                colDef: (0, $98ROn.colSettings).numberSmUnits,
                statusId: (0, $ikyhZ.listingStatuses).msiSold.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).forSaleLastDayUnits,
                colDef: (0, $98ROn.colSettings).numberSmInteger,
                measureType: (0, $bLQRh.measureTypes).units
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).ucUnits,
                colDef: (0, $98ROn.colSettings).numberSmInteger,
                statusId: (0, $ikyhZ.listingStatuses).underContractMsi.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).soldUnits,
                colDef: (0, $98ROn.colSettings).numberSmInteger,
                statusId: (0, $ikyhZ.listingStatuses).msiSold.id
            }
        ]
    },
    chart: {
        yAxis: {
            title: (0, $bLQRh.getYAxisTitle)((0, $bLQRh.terms).months),
            labels: {
                formatter: (0, $htzEo.getDecimalNumber)
            }
        },
        popOverDataFormatter: (0, $htzEo.popOverDataFormatters).units
    },
    keyInformation: {
        formatter: (0, $htzEo.getDecimalNumber),
        changeColumnHeaderName: (0, $bLQRh.terms).msiChange,
        headerTooltipUnitType: (0, $bLQRh.terms).msi
    }
};

});
parcelRegister("eNmV5", function(module, exports) {

$parcel$export(module.exports, "normalizePeriodType", () => $ac576ba81a7c8a25$export$b20385f7ce797f45);
$parcel$export(module.exports, "marketDynamicsTooltips", () => $ac576ba81a7c8a25$export$27eb672f2d9f7d9d);
$parcel$export(module.exports, "getResolvedTooltips", () => $ac576ba81a7c8a25$export$3752b8074c6b7351);
$parcel$export(module.exports, "marketDynamicsStatusTooltips", () => $ac576ba81a7c8a25$export$e70564d2ccfc4765);
$parcel$export(module.exports, "getBreakdownTooltips", () => $ac576ba81a7c8a25$export$589a02d4af270dd4);

var $1PiL9 = parcelRequire("1PiL9");

var $cstaF = parcelRequire("cstaF");

var $bLQRh = parcelRequire("bLQRh");

var $cL3O2 = parcelRequire("cL3O2");
const $ac576ba81a7c8a25$var$tooltipTimePeriods = {
    [(0, $cstaF.marketDynamicsTerms).years2Monthly]: (0, $bLQRh.terms).month.toLowerCase(),
    [(0, $cstaF.marketDynamicsTerms).years1Monthly]: (0, $bLQRh.terms).month.toLowerCase(),
    [(0, $cstaF.marketDynamicsTerms).months6Weekly]: (0, $bLQRh.terms).week.toLowerCase(),
    [(0, $cstaF.marketDynamicsTerms).years3Quarterly]: (0, $bLQRh.terms).quarter.toLowerCase()
};
const $ac576ba81a7c8a25$var$periodStartTooltips = {
    [(0, $bLQRh.terms).week.toLowerCase()]: "Week beginning on the date shown",
    [(0, $bLQRh.terms).month.toLowerCase()]: "Month and year of the data within the row",
    [(0, $bLQRh.terms).quarter.toLowerCase()]: "Quarter and year of the data within the row"
};
const $ac576ba81a7c8a25$var$periodLabelToType = {
    [(0, $bLQRh.terms).weekOf.toLowerCase()]: (0, $bLQRh.terms).week.toLowerCase()
};
const $ac576ba81a7c8a25$export$b20385f7ce797f45 = (label)=>{
    const lower = label?.toLowerCase();
    return $ac576ba81a7c8a25$var$periodLabelToType[lower] ?? lower;
};
const $ac576ba81a7c8a25$export$27eb672f2d9f7d9d = Object.freeze({
    streetName: {
        ...(0, $1PiL9.marketDynamicsColumns).address,
        tip: (0, $1PiL9.marketDynamicsColumns).address.label
    },
    avgCdom: {
        ...(0, $1PiL9.marketDynamicsColumns).avgCdom,
        tip: (0, $bLQRh.terms).avgCdom
    },
    avgDom: {
        ...(0, $1PiL9.marketDynamicsColumns).avgDom,
        tip: (0, $bLQRh.terms).avgDom
    },
    avgSpOp: {
        ...(0, $1PiL9.marketDynamicsColumns).avgSpOp,
        tip: (0, $bLQRh.terms).avgSpOp
    },
    beginPeriod: {
        ...(0, $1PiL9.marketDynamicsColumns).beginPeriod,
        tip: (periodType, beginPeriod)=>`Begin ${periodType} (${beginPeriod})`
    },
    city: {
        ...(0, $1PiL9.marketDynamicsColumns).city,
        tip: (0, $1PiL9.marketDynamicsColumns).city.label
    },
    changeAvg: {
        ...(0, $1PiL9.marketDynamicsColumns).changeAvg,
        tip: "Value difference between the average for the previous 12 weeks and the average for the last 12 weeks"
    },
    changeAvgPercentage: {
        ...(0, $1PiL9.marketDynamicsColumns).changeAvgPercentage,
        tip: "Percentage change from the previous 12-week average"
    },
    changeValue: {
        ...(0, $1PiL9.marketDynamicsColumns).changeValue,
        tip: (beginPeriod, endPeriod, periodType)=>`Value difference between Begin and End ${periodType} (${beginPeriod} - ${endPeriod})`
    },
    changeValuePercentage: {
        ...(0, $1PiL9.marketDynamicsColumns).changeValuePercentage,
        tip: (periodType, beginPeriod)=>`Percentage change from the Begin ${periodType} (${beginPeriod})`
    },
    endPeriod: {
        ...(0, $1PiL9.marketDynamicsColumns).endPeriod,
        tip: (periodType, endPeriod)=>`End ${periodType} (${endPeriod})`
    },
    expAvgDom: {
        ...(0, $1PiL9.marketDynamicsColumns).expAvgDom,
        tip: (0, $bLQRh.terms).expAvgDom
    },
    expAvgPricePerSqft: {
        ...(0, $1PiL9.marketDynamicsColumns).expAvgPricePerSqft,
        tip: (0, $bLQRh.terms).expAvgPricePerSqft
    },
    expAvgSqft: {
        ...(0, $1PiL9.marketDynamicsColumns).expAvgSqft,
        tip: (0, $bLQRh.terms).expAvgSqft
    },
    expAvgVolume: {
        ...(0, $1PiL9.marketDynamicsColumns).expAvgVolume,
        tip: (0, $bLQRh.terms).expAvgVolume
    },
    expMedianVolume: {
        ...(0, $1PiL9.marketDynamicsColumns).expMedianVolume,
        tip: (0, $bLQRh.terms).expMedianVolume
    },
    expUnits: {
        ...(0, $1PiL9.marketDynamicsColumns).expUnits,
        tip: (0, $bLQRh.terms).expUnits
    },
    forSaleAvgDom: {
        ...(0, $1PiL9.marketDynamicsColumns).forSaleAvgDom,
        tip: (0, $bLQRh.terms).forSaleAvgDom
    },
    forSaleAvgPricePerSqft: {
        ...(0, $1PiL9.marketDynamicsColumns).forSaleAvgPricePerSqft,
        tip: (0, $bLQRh.terms).forSaleAvgPricePerSqft
    },
    forSaleAvgSqft: {
        ...(0, $1PiL9.marketDynamicsColumns).forSaleAvgSqft,
        tip: (0, $bLQRh.terms).forSaleAvgSqft
    },
    forSaleAvgVolume: {
        ...(0, $1PiL9.marketDynamicsColumns).forSaleAvgVolume,
        tip: (0, $bLQRh.terms).forSaleAvgVolume
    },
    forSaleLastDayChangeVolume: {
        ...(0, $1PiL9.marketDynamicsColumns).forSaleLastDayChangeVolume,
        tip: (0, $bLQRh.terms).forSaleLastDayChangeVolumeTip
    },
    forSaleLastDayPercentage: {
        ...(0, $1PiL9.marketDynamicsColumns).forSaleLastDayPercentage,
        tip: (0, $bLQRh.terms).percentDifferenceTip
    },
    forSaleLastDayUnits: {
        ...(0, $1PiL9.marketDynamicsColumns).forSaleLastDayUnits,
        tip: (0, $bLQRh.terms).forSaleLastDayUnitsTip
    },
    forSaleLastDayUnits0to90: {
        ...(0, $1PiL9.marketDynamicsColumns).forSaleLastDayUnits0to90,
        tip: (0, $bLQRh.terms).units0To90Cdom
    },
    forSaleLastDayUnits0to90Pct: {
        ...(0, $1PiL9.marketDynamicsColumns).forSaleLastDayUnits0to90Pct,
        tip: (0, $bLQRh.terms).units0To90CdomPct
    },
    forSaleLastDayUnits91to180: {
        ...(0, $1PiL9.marketDynamicsColumns).forSaleLastDayUnits91to180,
        tip: (0, $bLQRh.terms).units91To180Cdom
    },
    forSaleLastDayUnits91to180Pct: {
        ...(0, $1PiL9.marketDynamicsColumns).forSaleLastDayUnits91to180Pct,
        tip: (0, $bLQRh.terms).units91To180CdomPct
    },
    forSaleLastDayUnitsOver180: {
        ...(0, $1PiL9.marketDynamicsColumns).forSaleLastDayUnitsOver180,
        tip: (0, $bLQRh.terms).unitsOver180Cdom
    },
    forSaleLastDayUnitsOver180Pct: {
        ...(0, $1PiL9.marketDynamicsColumns).forSaleLastDayUnitsOver180Pct,
        tip: (0, $bLQRh.terms).unitsOver180CdomPct
    },
    forSaleMedianVolume: {
        ...(0, $1PiL9.marketDynamicsColumns).forSaleMedianVolume,
        tip: (0, $bLQRh.terms).forSaleMedianVolume
    },
    forSaleUnits: {
        ...(0, $1PiL9.marketDynamicsColumns).forSaleUnits,
        tip: (0, $bLQRh.terms).forSaleUnits
    },
    lastWeeksAvg: {
        ...(0, $1PiL9.marketDynamicsColumns).lastWeeksAvg,
        tip: (0, $bLQRh.terms).lastWeeksAvgTip
    },
    officeId: {
        ...(0, $1PiL9.marketDynamicsColumns).officeId,
        tip: (0, $1PiL9.marketDynamicsColumns).officeId.label
    },
    officeName: {
        ...(0, $1PiL9.marketDynamicsColumns).officeName,
        tip: (0, $bLQRh.terms).office
    },
    newAvgPricePerSqft: {
        ...(0, $1PiL9.marketDynamicsColumns).newAvgPricePerSqft,
        tip: (0, $bLQRh.terms).newAvgPricePerSqft
    },
    newAvgSqft: {
        ...(0, $1PiL9.marketDynamicsColumns).newAvgSqft,
        tip: (0, $bLQRh.terms).newAvgSqft
    },
    newAvgVolume: {
        ...(0, $1PiL9.marketDynamicsColumns).newAvgVolume,
        tip: (0, $bLQRh.terms).newAvgVolume
    },
    newMedianVolume: {
        ...(0, $1PiL9.marketDynamicsColumns).newMedianVolume,
        tip: (0, $bLQRh.terms).newMedianVolume
    },
    newUnits: {
        ...(0, $1PiL9.marketDynamicsColumns).newUnits,
        tip: (0, $bLQRh.terms).newUnits
    },
    periodChange: {
        ...(0, $1PiL9.marketDynamicsColumns).periodChange,
        tip: (periodType, amountType)=>`The amount of ${amountType} change per ${periodType}, for the variable being measured,
            over the selected time period; calculations are based on the slope of the
            linear trend line for the illuminated bar`
    },
    periodChangeVolume: {
        ...(0, $1PiL9.marketDynamicsColumns).periodChange,
        tip: (periodType)=>`The dollar ($) change per ${periodType}, for the variable being measured,
        over the selected time period; calculations are based on the slope of the
        linear trend line for the illuminated bar`
    },
    periodPercentChangeUnits: {
        ...(0, $1PiL9.marketDynamicsColumns).periodPercentChange,
        tip: (periodType, amountType)=>`The percent (%) ${amountType} change per ${periodType}, for the variable being measured, over the selected time period; 
         calculations are based on the slope of the linear trend line for the illuminated bar`
    },
    periodPercentChange: {
        ...(0, $1PiL9.marketDynamicsColumns).periodPercentChange,
        tip: (periodType)=>`The percent (%) change per ${periodType}, for the variable being measured, over the selected time period; 
         calculations are based on the slope of the linear trend line for the illuminated bar`
    },
    periodChangePercent: {
        ...(0, $1PiL9.marketDynamicsColumns).periodChangePercent,
        tip: (periodType, amountType)=>`The incremental change in the ${amountType} value per ${periodType}, for the time period selected; this figure is derived using the slope of the linear trend line`
    },
    periodPercentChangePercent: {
        ...(0, $1PiL9.marketDynamicsColumns).periodPercentChangePercent,
        tip: (periodType, amountType)=>`The percent (%) change per ${periodType} of ${amountType} relative to the beginning month for the time period selected`
    },
    totalChangePercent: {
        ...(0, $1PiL9.marketDynamicsColumns).totalChangePercent,
        tip: (amountType)=>`The total increment change in the ${amountType} value over the time period selected; this figure is derived using the slope of the linear trend line`
    },
    totalPercentChangePercent: {
        ...(0, $1PiL9.marketDynamicsColumns).totalPercentChangePercent,
        tip: (amountType)=>`The total (%) change of ${amountType} over the whole time period selected; calculations are based on the slope of the linear trend line for the illuminated bars`
    },
    previousWeeksAvg: {
        ...(0, $1PiL9.marketDynamicsColumns).previousWeeksAvg,
        tip: (0, $bLQRh.terms).previousWeeksAvgTip
    },
    soldAvgDom: {
        ...(0, $1PiL9.marketDynamicsColumns).soldAvgDom,
        tip: (0, $bLQRh.terms).soldAvgDom
    },
    soldAvgDomWithoutPriceChanges: {
        ...(0, $1PiL9.marketDynamicsColumns).soldAvgDomWithoutPriceChanges,
        tip: (0, $bLQRh.terms).soldAvgDomWithoutPriceChanges
    },
    soldAvgDomWithPriceChanges: {
        ...(0, $1PiL9.marketDynamicsColumns).soldAvgDomWithPriceChanges,
        tip: (0, $bLQRh.terms).soldAvgDomWithPriceChanges
    },
    soldAvgPricePerSqft: {
        ...(0, $1PiL9.marketDynamicsColumns).soldAvgPricePerSqft,
        tip: (0, $bLQRh.terms).soldAvgPricePerSqft
    },
    soldAvgSqft: {
        ...(0, $1PiL9.marketDynamicsColumns).soldAvgSqft,
        tip: (0, $bLQRh.terms).soldAvgSqft
    },
    soldAvgVolume: {
        ...(0, $1PiL9.marketDynamicsColumns).soldAvgVolume,
        tip: (0, $bLQRh.terms).soldAvgVolume
    },
    soldChangeVolume: {
        ...(0, $1PiL9.marketDynamicsColumns).soldChangeVolume,
        tip: (0, $bLQRh.terms).soldChangeVolume
    },
    soldGrowthVolumePct: {
        ...(0, $1PiL9.marketDynamicsColumns).soldGrowthVolumePct,
        tip: (0, $bLQRh.terms).soldGrowthVolumePct
    },
    soldMedianVolume: {
        ...(0, $1PiL9.marketDynamicsColumns).soldMedianVolume,
        tip: (0, $bLQRh.terms).soldMedianVolume
    },
    soldMsi: {
        ...(0, $1PiL9.marketDynamicsColumns).soldMsi,
        tip: (0, $bLQRh.terms).msiSold
    },
    soldToForSaleUnitsPct: {
        ...(0, $1PiL9.marketDynamicsColumns).soldToForSaleUnitsPct,
        tip: (0, $bLQRh.terms).soldPercentage
    },
    soldUnits: {
        ...(0, $1PiL9.marketDynamicsColumns).soldUnits,
        tip: (0, $bLQRh.terms).soldUnits
    },
    soldUnits0to90: {
        ...(0, $1PiL9.marketDynamicsColumns).soldUnits0to90,
        tip: (0, $bLQRh.terms).units0To90Cdom
    },
    soldUnits0to90Pct: {
        ...(0, $1PiL9.marketDynamicsColumns).soldUnits0to90Pct,
        tip: (0, $bLQRh.terms).units0To90CdomPct
    },
    soldUnits91to180: {
        ...(0, $1PiL9.marketDynamicsColumns).soldUnits91to180,
        tip: (0, $bLQRh.terms).units91To180Cdom
    },
    soldUnits91to180Pct: {
        ...(0, $1PiL9.marketDynamicsColumns).soldUnits91to180Pct,
        tip: (0, $bLQRh.terms).units91To180CdomPct
    },
    soldUnitsOver180: {
        ...(0, $1PiL9.marketDynamicsColumns).soldUnitsOver180,
        tip: (0, $bLQRh.terms).unitsOver180Cdom
    },
    soldUnitsOver180Pct: {
        ...(0, $1PiL9.marketDynamicsColumns).soldUnitsOver180Pct,
        tip: (0, $bLQRh.terms).unitsOver180CdomPct
    },
    soldUnitsWithoutPriceChanges: {
        ...(0, $1PiL9.marketDynamicsColumns).soldUnitsWithoutPriceChanges,
        tip: (0, $bLQRh.terms).soldUnitsWithoutPriceChanges
    },
    soldUnitsWithPriceChanges: {
        ...(0, $1PiL9.marketDynamicsColumns).soldUnitsWithPriceChanges,
        tip: (0, $bLQRh.terms).soldUnitsWithPriceChanges
    },
    spLpRatioWithoutPriceChanges: {
        ...(0, $1PiL9.marketDynamicsColumns).spLpRatioWithoutPriceChanges,
        tip: (0, $bLQRh.terms).spLpRatioWithoutPriceChanges
    },
    spLpRatioWithPriceChanges: {
        ...(0, $1PiL9.marketDynamicsColumns).spLpRatioWithPriceChanges,
        tip: (0, $bLQRh.terms).spLpRatioWithPriceChanges
    },
    spOpRatioWithoutPriceChanges: {
        ...(0, $1PiL9.marketDynamicsColumns).spOpRatioWithoutPriceChanges,
        tip: (0, $bLQRh.terms).spOpRatioWithoutPriceChanges
    },
    spOpRatioWithPriceChanges: {
        ...(0, $1PiL9.marketDynamicsColumns).spOpRatioWithPriceChanges,
        tip: (0, $bLQRh.terms).spOpRatioWithPriceChanges
    },
    status: {
        ...(0, $1PiL9.marketDynamicsColumns).status
    },
    timePeriodStart: {
        ...(0, $1PiL9.marketDynamicsColumns).timePeriodStart,
        tip: (0, $bLQRh.terms).timePeriodStart
    },
    totalChange: {
        ...(0, $1PiL9.marketDynamicsColumns).totalChange,
        tip: `The total ($) change for the variable being measured over the whole time period selected; 
         calculations are based on the slope of the linear trend line for the illuminated bar`
    },
    totalChangeUnits: {
        ...(0, $1PiL9.marketDynamicsColumns).totalChange,
        tip: (amountType)=>`The total ${amountType} change for the variable being measured over the whole time period selected; 
         calculations are based on the slope of the linear trend line for the illuminated bar`
    },
    totalPercentChange: {
        ...(0, $1PiL9.marketDynamicsColumns).totalPercentChange,
        tip: `The total (%) change for the variable being measured over the whole time period selected; 
        calculations are based on the slope of the linear trend line for the illuminated bar`
    },
    totalPercentChangeUnits: {
        ...(0, $1PiL9.marketDynamicsColumns).totalPercentChange,
        tip: (amountType)=>`The total (%) ${amountType} change for the variable being measured over the whole time period selected; 
        calculations are based on the slope of the linear trend line for the illuminated bar`
    },
    ucAvgCdom: {
        ...(0, $1PiL9.marketDynamicsColumns).avgCdom,
        tip: (0, $bLQRh.terms).avgCdom
    },
    ucAvgDom: {
        ...(0, $1PiL9.marketDynamicsColumns).ucAvgDom,
        tip: (0, $bLQRh.terms).avgDom
    },
    ucAvgPricePerSqft: {
        ...(0, $1PiL9.marketDynamicsColumns).ucAvgPricePerSqft,
        tip: (0, $bLQRh.terms).ucAvgPricePerSqft
    },
    ucAvgSqft: {
        ...(0, $1PiL9.marketDynamicsColumns).ucAvgSqft,
        tip: (0, $bLQRh.terms).ucAvgSqft
    },
    ucAvgVolume: {
        ...(0, $1PiL9.marketDynamicsColumns).ucAvgVolume,
        tip: (0, $bLQRh.terms).ucAvgVolume
    },
    ucMedianVolume: {
        ...(0, $1PiL9.marketDynamicsColumns).ucMedianVolume,
        tip: (0, $bLQRh.terms).ucMedianVolume
    },
    ucMsi: {
        ...(0, $1PiL9.marketDynamicsColumns).ucMsi,
        tip: (0, $bLQRh.terms).underContractMsi
    },
    ucToForSaleUnitsPct: {
        ...(0, $1PiL9.marketDynamicsColumns).ucToForSaleUnitsPct,
        tip: (0, $bLQRh.terms).ucPercentage
    },
    ucUnits: {
        ...(0, $1PiL9.marketDynamicsColumns).ucUnits,
        tip: (0, $bLQRh.terms).ucUnits
    },
    ucUnits0to90: {
        ...(0, $1PiL9.marketDynamicsColumns).ucUnits0to90,
        tip: (0, $bLQRh.terms).units0To90Cdom
    },
    ucUnits0to90Pct: {
        ...(0, $1PiL9.marketDynamicsColumns).ucUnits0to90Pct,
        tip: (0, $bLQRh.terms).units0To90CdomPct
    },
    ucUnits91to180: {
        ...(0, $1PiL9.marketDynamicsColumns).ucUnits91to180,
        tip: (0, $bLQRh.terms).units91To180Cdom
    },
    ucUnits91to180Pct: {
        ...(0, $1PiL9.marketDynamicsColumns).ucUnits91to180Pct,
        tip: (0, $bLQRh.terms).units91To180CdomPct
    },
    ucUnitsOver180: {
        ...(0, $1PiL9.marketDynamicsColumns).ucUnitsOver180,
        tip: (0, $bLQRh.terms).unitsOver180Cdom
    },
    ucUnitsOver180Pct: {
        ...(0, $1PiL9.marketDynamicsColumns).ucUnitsOver180Pct,
        tip: (0, $bLQRh.terms).unitsOver180CdomPct
    },
    zipCode: {
        ...(0, $1PiL9.marketDynamicsColumns).zipCode,
        tip: (0, $1PiL9.marketDynamicsColumns).zipCode.label
    }
});
const $ac576ba81a7c8a25$export$3752b8074c6b7351 = (periodType, view)=>({
        ...$ac576ba81a7c8a25$export$27eb672f2d9f7d9d,
        timePeriodStart: {
            ...(0, $1PiL9.marketDynamicsColumns).timePeriodStart,
            tip: $ac576ba81a7c8a25$var$periodStartTooltips[periodType] ?? (0, $bLQRh.terms).timePeriodStart
        },
        ...view === (0, $cL3O2.listingViews).avgDomCdom.value && {
            ucUnits: {
                ...(0, $1PiL9.marketDynamicsColumns).ucUnits,
                tip: `Number of listings that went under contract during the ${periodType}`
            },
            ucAvgDom: {
                ...(0, $1PiL9.marketDynamicsColumns).ucAvgDom,
                tip: `Average DOM of listings that went under contract during the ${periodType}`
            },
            ucAvgCdom: {
                ...(0, $1PiL9.marketDynamicsColumns).ucAvgCdom,
                tip: `Average CDOM of listings that went under contract during the ${periodType}`
            }
        },
        ...view === (0, $cL3O2.listingViews).avgSpOpAllProperties.value && {
            soldUnits: {
                ...(0, $1PiL9.marketDynamicsColumns).soldUnits,
                tip: `The number of listings that closed during the ${periodType}`
            },
            avgSpOp: {
                ...(0, $1PiL9.marketDynamicsColumns).avgSpOp,
                tip: `The ratio of the sold price (closed price) to the original list price as a percentage for all properties sold during the ${periodType}`
            },
            soldAvgDom: {
                ...(0, $1PiL9.marketDynamicsColumns).soldAvgDom,
                tip: `The average number of Days on Market for all properties sold during the ${periodType}`
            }
        },
        ...view === (0, $cL3O2.listingViews).cdomBreakout.value && {
            forSaleLastDayUnits0to90: {
                ...(0, $1PiL9.marketDynamicsColumns).forSaleLastDayUnits0to90,
                tip: "Number of listings that were for sale on the last day of the month for which the CDOM was 90 or less"
            },
            forSaleLastDayUnits0to90Pct: {
                ...(0, $1PiL9.marketDynamicsColumns).forSaleLastDayUnits0to90Pct,
                tip: "The percentage of listings that were for sale on the last day of the month for which the CDOM was 90 or less"
            },
            forSaleLastDayUnits91to180: {
                ...(0, $1PiL9.marketDynamicsColumns).forSaleLastDayUnits91to180,
                tip: "Number of listings that were for sale on the last day of the month for which the CDOM was 91-180"
            },
            forSaleLastDayUnits91to180Pct: {
                ...(0, $1PiL9.marketDynamicsColumns).forSaleLastDayUnits91to180Pct,
                tip: "The percentage of listings that were for sale on the last day of the month for which the CDOM was 91-180"
            },
            forSaleLastDayUnitsOver180: {
                ...(0, $1PiL9.marketDynamicsColumns).forSaleLastDayUnitsOver180,
                tip: "Number of listings that were for sale on the last day of the month for which the CDOM was 181 or more"
            },
            forSaleLastDayUnitsOver180Pct: {
                ...(0, $1PiL9.marketDynamicsColumns).forSaleLastDayUnitsOver180Pct,
                tip: "The percentage of listings that were for sale on the last day of the month for which the CDOM was 181 or more"
            },
            ucUnits: {
                ...(0, $1PiL9.marketDynamicsColumns).ucUnits,
                tip: "Number of listings that went under contract during the month"
            },
            ucUnits0to90: {
                ...(0, $1PiL9.marketDynamicsColumns).ucUnits0to90,
                tip: "Number of listings that went under contract during the month for which the CDOM was 90 or less"
            },
            ucUnits0to90Pct: {
                ...(0, $1PiL9.marketDynamicsColumns).ucUnits0to90Pct,
                tip: "The percentage of listings that went under contract during the month for which the CDOM was 90 or less"
            },
            ucUnits91to180: {
                ...(0, $1PiL9.marketDynamicsColumns).ucUnits91to180,
                tip: "Number of listings that went under contract during the month for which the CDOM was 91-180"
            },
            ucUnits91to180Pct: {
                ...(0, $1PiL9.marketDynamicsColumns).ucUnits91to180Pct,
                tip: "The percentage of listings that went under contract during the month for which the CDOM was 91-180"
            },
            ucUnitsOver180: {
                ...(0, $1PiL9.marketDynamicsColumns).ucUnitsOver180,
                tip: "Number of listings that went under contract during the month for which the CDOM was 181 or more"
            },
            ucUnitsOver180Pct: {
                ...(0, $1PiL9.marketDynamicsColumns).ucUnitsOver180Pct,
                tip: "The percentage of listings that went under contract during the month for which the CDOM was 181 or more"
            },
            soldUnits: {
                ...(0, $1PiL9.marketDynamicsColumns).soldUnits,
                tip: "Number of listings sold during the month"
            },
            soldUnits0to90: {
                ...(0, $1PiL9.marketDynamicsColumns).soldUnits0to90,
                tip: "Number of listings that closed during the month for which the CDOM was 90 or less"
            },
            soldUnits0to90Pct: {
                ...(0, $1PiL9.marketDynamicsColumns).soldUnits0to90Pct,
                tip: "The percentage of listings that closed during the month for which the CDOM was 90 or less"
            },
            soldUnits91to180: {
                ...(0, $1PiL9.marketDynamicsColumns).soldUnits91to180,
                tip: "Number of listings that closed during the month for which the CDOM was 91-180"
            },
            soldUnits91to180Pct: {
                ...(0, $1PiL9.marketDynamicsColumns).soldUnits91to180Pct,
                tip: "The percentage of listings that closed during the month for which the CDOM was 91-180"
            },
            soldUnitsOver180: {
                ...(0, $1PiL9.marketDynamicsColumns).soldUnitsOver180,
                tip: "Number of listings that closed during the month for which the CDOM was 181 or more"
            },
            soldUnitsOver180Pct: {
                ...(0, $1PiL9.marketDynamicsColumns).soldUnitsOver180Pct,
                tip: "The percentage of listings that closed during the month for which the CDOM was 181 or more"
            }
        },
        ...view === (0, $cL3O2.listingViews).avg$Sqft.value && {
            newUnits: {
                ...(0, $1PiL9.marketDynamicsColumns).newUnits,
                tip: `Number of listings that were listed during the ${periodType}`
            },
            newAvgVolume: {
                ...(0, $1PiL9.marketDynamicsColumns).newAvgVolume,
                tip: `Average price of listings that were listed during the ${periodType}`
            },
            newAvgSqft: {
                ...(0, $1PiL9.marketDynamicsColumns).newAvgSqft,
                tip: "SQFT reflects the gross living area as supplied by MLS data feed; the figure stated is the average square footage for all the properties within the time period. This calculation excludes 0 square footage properties."
            },
            newAvgPricePerSqft: {
                ...(0, $1PiL9.marketDynamicsColumns).newAvgPricePerSqft,
                tip: "The average price per square foot of the gross living area. This calculation excludes 0 square footage properties."
            },
            forSaleUnits: {
                ...(0, $1PiL9.marketDynamicsColumns).forSaleUnits,
                tip: `Number of listings that were for sale during the ${periodType}`
            },
            forSaleAvgVolume: {
                ...(0, $1PiL9.marketDynamicsColumns).forSaleAvgVolume,
                tip: `Average price of listings that were for sale during the ${periodType}`
            },
            forSaleAvgSqft: {
                ...(0, $1PiL9.marketDynamicsColumns).forSaleAvgSqft,
                tip: "SQFT reflects the gross living area as supplied by MLS data feed; the figure stated is the average square footage for all the properties within the time period. This calculation excludes 0 square footage properties."
            },
            forSaleAvgPricePerSqft: {
                ...(0, $1PiL9.marketDynamicsColumns).forSaleAvgPricePerSqft,
                tip: "The average price per square foot of the gross living area. This calculation excludes 0 square footage properties."
            },
            ucUnits: {
                ...(0, $1PiL9.marketDynamicsColumns).ucUnits,
                tip: `Number of listings that went under contract during the ${periodType}`
            },
            ucAvgVolume: {
                ...(0, $1PiL9.marketDynamicsColumns).ucAvgVolume,
                tip: `Average price of listings that went under contract during the ${periodType}`
            },
            ucAvgSqft: {
                ...(0, $1PiL9.marketDynamicsColumns).ucAvgSqft,
                tip: "SQFT reflects the gross living area as supplied by MLS data feed; the figure stated is the average square footage for all the properties within the time period. This calculation excludes 0 square footage properties."
            },
            ucAvgPricePerSqft: {
                ...(0, $1PiL9.marketDynamicsColumns).ucAvgPricePerSqft,
                tip: "The average price per square foot of the gross living area. This calculation excludes 0 square footage properties."
            },
            soldUnits: {
                ...(0, $1PiL9.marketDynamicsColumns).soldUnits,
                tip: `Number of listings that closed during the ${periodType}`
            },
            soldAvgVolume: {
                ...(0, $1PiL9.marketDynamicsColumns).soldAvgVolume,
                tip: "The Sold Price reflects the price-point at which the property closed escrow; the figure stated is the average sold price for all the properties within the time period"
            },
            soldAvgSqft: {
                ...(0, $1PiL9.marketDynamicsColumns).soldAvgSqft,
                tip: "SQFT reflects the gross living area as supplied by MLS data feed; the figure stated is the average square footage for all the properties within the time period. This calculation excludes 0 square footage properties."
            },
            soldAvgPricePerSqft: {
                ...(0, $1PiL9.marketDynamicsColumns).soldAvgPricePerSqft,
                tip: "A value calculation of $/SQFT; the averages of sold price and square footage for all the properties within the time period are used in the calculation. This calculation excludes 0 square footage properties."
            },
            expUnits: {
                ...(0, $1PiL9.marketDynamicsColumns).expUnits,
                tip: `Number of listings that went off market during the ${periodType}`
            },
            expAvgVolume: {
                ...(0, $1PiL9.marketDynamicsColumns).expAvgVolume,
                tip: `Average price of listings that went off market during the ${periodType}`
            },
            expAvgSqft: {
                ...(0, $1PiL9.marketDynamicsColumns).expAvgSqft,
                tip: "SQFT reflects the gross living area as supplied by MLS data feed; the figure stated is the average square footage for all the properties within the time period. This calculation excludes 0 square footage properties."
            },
            expAvgPricePerSqft: {
                ...(0, $1PiL9.marketDynamicsColumns).expAvgPricePerSqft,
                tip: "The average price per square foot of the gross living area. This calculation excludes 0 square footage properties."
            }
        },
        ...view === (0, $cL3O2.listingViews).underContractUc.value && {
            ucUnits: {
                ...(0, $1PiL9.marketDynamicsColumns).ucUnits,
                tip: `Number of listings that went under contract during the ${periodType}`
            }
        },
        ...view === (0, $cL3O2.listingViews).avgSpLpComparison.value && {
            soldUnitsWithoutPriceChanges: {
                ...(0, $1PiL9.marketDynamicsColumns).soldUnitsWithoutPriceChanges,
                tip: `The number of properties sold during the ${periodType} that had no price changes`
            },
            spLpRatioWithoutPriceChanges: {
                ...(0, $1PiL9.marketDynamicsColumns).spLpRatioWithoutPriceChanges,
                tip: "The ratio of the sold price (closed price) to the list price (the price that drew the offer) as a percentage for properties that had no price changes"
            },
            soldAvgDomWithoutPriceChanges: {
                ...(0, $1PiL9.marketDynamicsColumns).soldAvgDomWithoutPriceChanges,
                tip: `The average number of Days on Market for properties sold during the ${periodType} that had no price changes`
            },
            soldUnitsWithPriceChanges: {
                ...(0, $1PiL9.marketDynamicsColumns).soldUnitsWithPriceChanges,
                tip: `The number of properties sold during the ${periodType} that had one or more price changes`
            },
            spLpRatioWithPriceChanges: {
                ...(0, $1PiL9.marketDynamicsColumns).spLpRatioWithPriceChanges,
                tip: "The ratio of the sold price (closed price) to the list price (the price that drew the offer) as a percentage for properties that had one or more price changes"
            },
            soldAvgDomWithPriceChanges: {
                ...(0, $1PiL9.marketDynamicsColumns).soldAvgDomWithPriceChanges,
                tip: `The average number of Days on Market for properties sold during the ${periodType} that had one or more price changes`
            }
        },
        ...view === (0, $cL3O2.listingViews).avgSpOpComparison.value && {
            soldUnitsWithoutPriceChanges: {
                ...(0, $1PiL9.marketDynamicsColumns).soldUnitsWithoutPriceChanges,
                tip: `The number of properties sold during the ${periodType} that had no price changes`
            },
            spOpRatioWithoutPriceChanges: {
                ...(0, $1PiL9.marketDynamicsColumns).spOpRatioWithoutPriceChanges,
                tip: "The ratio of the sold price (closed price) to the original list price as a percentage for properties that had no price changes"
            },
            soldAvgDomWithoutPriceChanges: {
                ...(0, $1PiL9.marketDynamicsColumns).soldAvgDomWithoutPriceChanges,
                tip: `The average number of Days on Market for properties sold during the ${periodType} that had no price changes`
            },
            soldUnitsWithPriceChanges: {
                ...(0, $1PiL9.marketDynamicsColumns).soldUnitsWithPriceChanges,
                tip: `The number of properties sold during the ${periodType} that had one or more price changes`
            },
            spOpRatioWithPriceChanges: {
                ...(0, $1PiL9.marketDynamicsColumns).spOpRatioWithPriceChanges,
                tip: "The ratio of the sold price (closed price) to the original list price as a percentage for properties that had one or more price changes"
            },
            soldAvgDomWithPriceChanges: {
                ...(0, $1PiL9.marketDynamicsColumns).soldAvgDomWithPriceChanges,
                tip: `The average number of Days on Market for properties sold during the ${periodType} that had one or more price changes`
            }
        },
        ...view === (0, $cL3O2.listingViews).supplyAmpDemandNumUnits.value && {
            newUnits: {
                ...(0, $1PiL9.marketDynamicsColumns).newUnits,
                tip: `Number of listings that were listed during the ${periodType}`
            },
            forSaleUnits: {
                ...(0, $1PiL9.marketDynamicsColumns).forSaleUnits,
                tip: `Number of listings that were for sale during the ${periodType}`
            },
            forSaleAvgDom: {
                ...(0, $1PiL9.marketDynamicsColumns).forSaleAvgDom,
                tip: `Average DOM of listings that were for sale during the ${periodType}`
            },
            ucUnits: {
                ...(0, $1PiL9.marketDynamicsColumns).ucUnits,
                tip: `Number of listings that went under contract during the ${periodType}`
            },
            ucAvgDom: {
                ...(0, $1PiL9.marketDynamicsColumns).ucAvgDom,
                tip: `Average DOM of listings that went under contract during the ${periodType}`
            },
            soldUnits: {
                ...(0, $1PiL9.marketDynamicsColumns).soldUnits,
                tip: `Number of listings sold during the ${periodType}`
            },
            soldAvgDom: {
                ...(0, $1PiL9.marketDynamicsColumns).soldAvgDom,
                tip: `Average time it took to sell (list date to under contract date) for the listings that closed during the ${periodType}`
            },
            expUnits: {
                ...(0, $1PiL9.marketDynamicsColumns).expUnits,
                tip: `Number of listings that went off market during the ${periodType}`
            },
            expAvgDom: {
                ...(0, $1PiL9.marketDynamicsColumns).expAvgDom,
                tip: `Average DOM of listings that went off market during the ${periodType}`
            }
        },
        ...view === (0, $cL3O2.listingViews).soldAvgVsMedianPrice.value && {
            soldChangeVolume: {
                ...(0, $1PiL9.marketDynamicsColumns).soldChangeVolume,
                tip: `Difference between the average price and the median price of listings sold during the ${periodType}`
            },
            soldAvgVolume: {
                ...(0, $1PiL9.marketDynamicsColumns).soldAvgVolume,
                tip: `Average price of listings that closed during the ${periodType}`
            },
            soldGrowthVolumePct: {
                ...(0, $1PiL9.marketDynamicsColumns).soldGrowthVolumePct,
                tip: "Median price as a percentage of Average price"
            },
            soldAvgDom: {
                ...(0, $1PiL9.marketDynamicsColumns).soldAvgDom,
                tip: `Average time it took to sell (list date to under contract date) for the properties that closed during the ${periodType}`
            }
        },
        ...view === (0, $cL3O2.listingViews).medianPrice.value && {
            newMedianVolume: {
                ...(0, $1PiL9.marketDynamicsColumns).newMedianVolume,
                tip: `Median price of listings that were listed during the ${periodType}`
            },
            newUnits: {
                ...(0, $1PiL9.marketDynamicsColumns).newUnits,
                tip: `Number of listings that were listed during the ${periodType}`
            },
            forSaleMedianVolume: {
                ...(0, $1PiL9.marketDynamicsColumns).forSaleMedianVolume,
                tip: `Median price of listings that were for sale during the ${periodType}`
            },
            forSaleUnits: {
                ...(0, $1PiL9.marketDynamicsColumns).forSaleUnits,
                tip: `Number of listings that were for sale during the ${periodType}`
            },
            ucMedianVolume: {
                ...(0, $1PiL9.marketDynamicsColumns).ucMedianVolume,
                tip: `Median price of listings that went under contract during the ${periodType}`
            },
            ucUnits: {
                ...(0, $1PiL9.marketDynamicsColumns).ucUnits,
                tip: `Number of listings that went under contract during the ${periodType}`
            },
            soldMedianVolume: {
                ...(0, $1PiL9.marketDynamicsColumns).soldMedianVolume,
                tip: `Median price of listings that closed during the ${periodType}`
            },
            soldUnits: {
                ...(0, $1PiL9.marketDynamicsColumns).soldUnits,
                tip: `Number of listings that closed during the ${periodType}`
            },
            expMedianVolume: {
                ...(0, $1PiL9.marketDynamicsColumns).expMedianVolume,
                tip: `Median price of listings that went off market during the ${periodType}`
            },
            expUnits: {
                ...(0, $1PiL9.marketDynamicsColumns).expUnits,
                tip: `Number of listings that went off market during the ${periodType}`
            }
        },
        ...view === (0, $cL3O2.listingViews).forSaleVsFsldm.value && {
            forSaleUnits: {
                ...(0, $1PiL9.marketDynamicsColumns).forSaleUnits,
                tip: `Number of listings that were for sale during the month`
            }
        },
        ...view === (0, $cL3O2.listingViews).salesAbsorption.value && {
            ucToForSaleUnitsPct: {
                ...(0, $1PiL9.marketDynamicsColumns).ucToForSaleUnitsPct,
                tip: `#UC \xf7 #FS as a percent`
            },
            soldToForSaleUnitsPct: {
                ...(0, $1PiL9.marketDynamicsColumns).soldToForSaleUnitsPct,
                tip: `#Sold \xf7 #FS as a percent`
            },
            forSaleUnits: {
                ...(0, $1PiL9.marketDynamicsColumns).forSaleUnits,
                tip: `Number of listings that were for sale during the ${periodType}`
            },
            ucUnits: {
                ...(0, $1PiL9.marketDynamicsColumns).ucUnits,
                tip: `Number of listings that went under contract during the ${periodType}`
            },
            soldUnits: {
                ...(0, $1PiL9.marketDynamicsColumns).soldUnits,
                tip: `Number of listings sold during the ${periodType}`
            }
        },
        ...view === (0, $cL3O2.listingViews).monthlySupplyOfInventory.value && {
            ucMsi: {
                ...(0, $1PiL9.marketDynamicsColumns).ucMsi,
                tip: `MSI calculation using the most current sales information - the # of properties that went Under Contract during the month (#FSLD/#UC)`
            },
            soldMsi: {
                ...(0, $1PiL9.marketDynamicsColumns).soldMsi,
                tip: `MSI calculation using a mixture of sales information from previous months, i.e, the # of properties that closed during the month (#FSLD/#Sold)`
            },
            ucUnits: {
                ...(0, $1PiL9.marketDynamicsColumns).ucUnits,
                tip: `Number of listings that went under contract during the month`
            },
            soldUnits: {
                ...(0, $1PiL9.marketDynamicsColumns).soldUnits,
                tip: `Number of listings sold during the month`
            }
        }
    });
const $ac576ba81a7c8a25$export$e70564d2ccfc4765 = Object.freeze({
    msiSold: "MSI-Sold: Monthly Supply of Inventory calculated by taking the number of active listings on the last day of the month (FSLD) and dividing the number of listings that went Sold in selected month.",
    underContractMsi: "MSI-Under Contract: Monthly Supply of Inventory calculated by taking the number of active listings on the last day of the month (FSLD) and dividing the number of listings that went Under Contract (UC) in selected month."
});
const $ac576ba81a7c8a25$export$589a02d4af270dd4 = (periodTitle, view)=>({
        ...$ac576ba81a7c8a25$export$27eb672f2d9f7d9d,
        address: {
            ...(0, $1PiL9.marketDynamicsColumns).address,
            tip: "The street address"
        },
        areaId: {
            ...(0, $1PiL9.marketDynamicsColumns).areaId,
            tip: "The code the MLS uses to define an area"
        },
        fullBaths: {
            ...(0, $1PiL9.marketDynamicsColumns).fullBaths,
            tip: "Bathrooms"
        },
        bankStatus: {
            ...(0, $1PiL9.marketDynamicsColumns).bankStatus,
            tip: "A 'Y' indicates that the property is distressed (in foreclosure, or in foreclosure and subject to short sale; or owned/REO); an 'N' indicates the property is free of any bank mediation"
        },
        bedrooms: {
            ...(0, $1PiL9.marketDynamicsColumns).bedrooms,
            tip: "Bedrooms"
        },
        city: {
            ...(0, $1PiL9.marketDynamicsColumns).city,
            tip: "City Name"
        },
        cdom: {
            ...(0, $1PiL9.marketDynamicsColumns).cdom,
            tip: "The continuous Days on Market associated with the property record's MLS history"
        },
        costPerSqft: {
            ...(0, $1PiL9.marketDynamicsColumns).costPerSqft,
            tip: "Price per Square Feet"
        },
        dom: {
            ...(0, $1PiL9.marketDynamicsColumns).dom,
            tip: "The Days on Market associated with the property record's current MLS number"
        },
        expAvgPricePerSqft: {
            ...(0, $1PiL9.marketDynamicsColumns).expAvgPricePerSqft,
            tip: `The average price per square foot of the gross living area. This calculation excludes 0 square footage properties.`
        },
        expAvgSqft: {
            ...(0, $1PiL9.marketDynamicsColumns).expAvgSqft,
            tip: `SQFT reflects the gross living area as supplied by MLS data feed; the figure stated is the average square footage for all the properties within the time period. This calculation excludes 0 square footage properties.`
        },
        expAvgVolume: {
            ...(0, $1PiL9.marketDynamicsColumns).expAvgVolume,
            tip: `Average price of listings that went off market during the ${$ac576ba81a7c8a25$var$tooltipTimePeriods[periodTitle]}`
        },
        expMedianVolume: {
            ...(0, $1PiL9.marketDynamicsColumns).expMedianVolume,
            tip: `Median price of listings that went off market during the ${$ac576ba81a7c8a25$var$tooltipTimePeriods[periodTitle]}`
        },
        expUnits: {
            ...(0, $1PiL9.marketDynamicsColumns).expUnits,
            tip: `Number of listings that went off market during the ${$ac576ba81a7c8a25$var$tooltipTimePeriods[periodTitle]}`
        },
        forSaleAvgPricePerSqft: {
            ...(0, $1PiL9.marketDynamicsColumns).forSaleAvgPricePerSqft,
            tip: `The average price per square foot of the gross living area. This calculation excludes 0 square footage properties.`
        },
        forSaleAvgSqft: {
            ...(0, $1PiL9.marketDynamicsColumns).forSaleAvgSqft,
            tip: `SQFT reflects the gross living area as supplied by MLS data feed; the figure stated is the average square footage for all the properties within the time period. This calculation excludes 0 square footage properties.`
        },
        forSaleAvgVolume: {
            ...(0, $1PiL9.marketDynamicsColumns).forSaleAvgVolume,
            tip: `Average price of listings that were for sale during the ${$ac576ba81a7c8a25$var$tooltipTimePeriods[periodTitle]}`
        },
        forSaleMedianVolume: {
            ...(0, $1PiL9.marketDynamicsColumns).forSaleMedianVolume,
            tip: `Median price of listings that were for sale during the ${$ac576ba81a7c8a25$var$tooltipTimePeriods[periodTitle]}`
        },
        forSaleUnits: {
            ...(0, $1PiL9.marketDynamicsColumns).forSaleUnits,
            tip: `Number of listings that were for sale during the ${$ac576ba81a7c8a25$var$tooltipTimePeriods[periodTitle]}`
        },
        listAgent: {
            ...(0, $1PiL9.marketDynamicsColumns).listAgent,
            tip: "Agent(s) representing the list side of the transaction"
        },
        listDate: {
            ...(0, $1PiL9.marketDynamicsColumns).listDate,
            tip: "List Date"
        },
        listPrice: {
            ...(0, $1PiL9.marketDynamicsColumns).listPrice,
            tip: "Price that drew the offer"
        },
        lotSizeSquareFt: {
            ...(0, $1PiL9.marketDynamicsColumns).lotSizeSquareFt,
            tip: "Lot Size (SQFT)"
        },
        mlsNum: {
            ...(0, $1PiL9.marketDynamicsColumns).mlsNum,
            tip: "Unique MLS Number"
        },
        newAvgPricePerSqft: {
            ...(0, $1PiL9.marketDynamicsColumns).newAvgPricePerSqft,
            tip: `The average price per square foot of the gross living area. This calculation excludes 0 square footage properties.`
        },
        newAvgSqft: {
            ...(0, $1PiL9.marketDynamicsColumns).newAvgSqft,
            tip: `SQFT reflects the gross living area as supplied by MLS data feed; the figure stated is the average square footage for all the properties within the time period. This calculation excludes 0 square footage properties.`
        },
        newAvgVolume: {
            ...(0, $1PiL9.marketDynamicsColumns).newAvgVolume,
            tip: `Average price of listings that were listed during the ${$ac576ba81a7c8a25$var$tooltipTimePeriods[periodTitle]}`
        },
        newMedianVolume: {
            ...(0, $1PiL9.marketDynamicsColumns).newMedianVolume,
            tip: `Median price of listings that were listed during the ${$ac576ba81a7c8a25$var$tooltipTimePeriods[periodTitle]}`
        },
        newUnits: {
            ...(0, $1PiL9.marketDynamicsColumns).newUnits,
            tip: `Number of listings that were listed during the ${$ac576ba81a7c8a25$var$tooltipTimePeriods[periodTitle]}`
        },
        officeName: {
            ...(0, $1PiL9.marketDynamicsColumns).officeName,
            tip: "Office Name - derived from MLS records"
        },
        offMarketDate: {
            ...(0, $1PiL9.marketDynamicsColumns).offMarketDate,
            tip: "Off Market Date"
        },
        orgPrice: {
            ...(0, $1PiL9.marketDynamicsColumns).orgPrice,
            tip: "The original list price"
        },
        price: {
            ...(0, $1PiL9.marketDynamicsColumns).price,
            tip: "List Price"
        },
        priceChangeCnt: {
            ...(0, $1PiL9.marketDynamicsColumns).priceChangeCnt,
            tip: "Price Change Quantity"
        },
        soldAvgDom: {
            ...(0, $1PiL9.marketDynamicsColumns).soldAvgDom,
            tip: `Average time it took to sell (list date to under contract date) for the properties that closed during the ${$ac576ba81a7c8a25$var$tooltipTimePeriods[periodTitle]}`
        },
        soldAvgPricePerSqft: {
            ...(0, $1PiL9.marketDynamicsColumns).soldAvgPricePerSqft,
            tip: `A value calculation of $/SQFT; the averages of sold price and square footage for all the properties within the time period are used in the calculation. This calculation excludes 0 square footage properties.`
        },
        soldAvgSqft: {
            ...(0, $1PiL9.marketDynamicsColumns).soldAvgSqft,
            tip: `SQFT reflects the gross living area as supplied by MLS data feed; the figure stated is the average square footage for all the properties within the time period. This calculation excludes 0 square footage properties.`
        },
        soldAvgVolume: {
            ...(0, $1PiL9.marketDynamicsColumns).soldAvgVolume,
            tip: `Average price of listings that closed during the ${$ac576ba81a7c8a25$var$tooltipTimePeriods[periodTitle]}`
        },
        ...view === "avgPriceSqft" && {
            soldAvgVolume: {
                ...(0, $1PiL9.marketDynamicsColumns).soldAvgVolume,
                tip: `The Sold Price reflects the price-point at which the property closed escrow; the figure stated is the average sold price for all the properties within the time period.`
            }
        },
        soldChangeVolume: {
            ...(0, $1PiL9.marketDynamicsColumns).soldChangeVolume,
            tip: `Difference between the average price and the median price of listings sold during the ${$ac576ba81a7c8a25$var$tooltipTimePeriods[periodTitle]}`
        },
        soldDate: {
            ...(0, $1PiL9.marketDynamicsColumns).soldDate,
            tip: "Sold Date"
        },
        soldPrice: {
            ...(0, $1PiL9.marketDynamicsColumns).soldPrice,
            tip: "Sold Price"
        },
        soldGrowthVolumePct: {
            ...(0, $1PiL9.marketDynamicsColumns).soldGrowthVolumePct,
            tip: `Difference between the average price and the median price of listings sold during the ${$ac576ba81a7c8a25$var$tooltipTimePeriods[periodTitle]} as a percentage of the average price`
        },
        soldMedianVolume: {
            ...(0, $1PiL9.marketDynamicsColumns).soldMedianVolume,
            tip: `Median price of listings that closed during the ${$ac576ba81a7c8a25$var$tooltipTimePeriods[periodTitle]}`
        },
        soldUnits: {
            ...(0, $1PiL9.marketDynamicsColumns).soldUnits,
            tip: `The number of listings that closed during the ${$ac576ba81a7c8a25$var$tooltipTimePeriods[periodTitle]}`
        },
        soldUnitsWithoutPriceChanges: {
            ...(0, $1PiL9.marketDynamicsColumns).soldUnitsWithoutPriceChanges,
            tip: `The number of properties sold during the ${$ac576ba81a7c8a25$var$tooltipTimePeriods[periodTitle]} that had no price changes`
        },
        spOpRatioWithoutPriceChanges: {
            ...(0, $1PiL9.marketDynamicsColumns).spOpRatioWithoutPriceChanges,
            tip: `The ratio of the sold price (closed price) to the original list price as a percentage for properties that had no price changes`
        },
        soldAvgDomWithoutPriceChanges: {
            ...(0, $1PiL9.marketDynamicsColumns).soldAvgDomWithoutPriceChanges,
            tip: `The average number of Days on Market for properties sold during the ${$ac576ba81a7c8a25$var$tooltipTimePeriods[periodTitle]} that had no price changes`
        },
        soldUnitsWithPriceChanges: {
            ...(0, $1PiL9.marketDynamicsColumns).soldUnitsWithPriceChanges,
            tip: `The number of properties sold during the ${$ac576ba81a7c8a25$var$tooltipTimePeriods[periodTitle]} that had one or more price changes`
        },
        spOpRatioWithPriceChanges: {
            ...(0, $1PiL9.marketDynamicsColumns).spOpRatioWithPriceChanges,
            tip: `The ratio of the sold price (closed price) to the original list price as a percentage for properties that had one or more price changes`
        },
        soldAvgDomWithPriceChanges: {
            ...(0, $1PiL9.marketDynamicsColumns).soldAvgDomWithPriceChanges,
            tip: `The average number of Days on Market for properties sold during the ${$ac576ba81a7c8a25$var$tooltipTimePeriods[periodTitle]} that had one or more price changes`
        },
        squareFt: {
            ...(0, $1PiL9.marketDynamicsColumns).squareFt,
            tip: `Square Feet`
        },
        typeName: {
            ...(0, $1PiL9.marketDynamicsColumns).typeName,
            tip: "Property Type i.e. DE, AT "
        },
        ucAvgPricePerSqft: {
            ...(0, $1PiL9.marketDynamicsColumns).ucAvgPricePerSqft,
            tip: `The average price per square foot of the gross living area. This calculation excludes 0 square footage properties.`
        },
        ucAvgSqft: {
            ...(0, $1PiL9.marketDynamicsColumns).ucAvgSqft,
            tip: `SQFT reflects the gross living area as supplied by MLS data feed; the figure stated is the average square footage for all the properties within the time period. This calculation excludes 0 square footage properties.`
        },
        ucAvgVolume: {
            ...(0, $1PiL9.marketDynamicsColumns).ucAvgVolume,
            tip: `Average price of listings that went under contract during the ${$ac576ba81a7c8a25$var$tooltipTimePeriods[periodTitle]}`
        },
        ucDate: {
            ...(0, $1PiL9.marketDynamicsColumns).ucDate,
            tip: "UC Date"
        },
        ucMedianVolume: {
            ...(0, $1PiL9.marketDynamicsColumns).ucMedianVolume,
            tip: `Median price of listings that went under contract during the ${$ac576ba81a7c8a25$var$tooltipTimePeriods[periodTitle]}`
        },
        ucUnits: {
            ...(0, $1PiL9.marketDynamicsColumns).ucUnits,
            tip: `Number of listings that went under contract during the ${$ac576ba81a7c8a25$var$tooltipTimePeriods[periodTitle]}`
        },
        spLpRatioWithoutPriceChanges: {
            ...(0, $1PiL9.marketDynamicsColumns).spLpRatioWithoutPriceChanges,
            tip: `The ratio of the sold price (closed price) to the list price (the price that drew the offer) as a percentage for properties that had no price changes`
        },
        spLpRatioWithPriceChanges: {
            ...(0, $1PiL9.marketDynamicsColumns).spLpRatioWithPriceChanges,
            tip: `The ratio of the sold price (closed price) to the list price (the price that drew the offer) as a percentage for properties that had one or more price changes`
        },
        ucToForSaleUnitsPct: {
            ...(0, $1PiL9.marketDynamicsColumns).ucToForSaleUnitsPct,
            tip: `#UC \xf7 #FS as a percent`
        },
        soldToForSaleUnitsPct: {
            ...(0, $1PiL9.marketDynamicsColumns).soldToForSaleUnitsPct,
            tip: `#Sold \xf7 #FS as a percent`
        },
        zipcode: {
            ...(0, $1PiL9.marketDynamicsColumns).zipcode,
            tip: "Zip Code"
        },
        ...view === (0, $cL3O2.listingViews).salesAbsorption.value || view === (0, $cL3O2.listingViews).supplyAmpDemandNumUnits.value && {
            soldUnits: {
                ...(0, $1PiL9.marketDynamicsColumns).soldUnits,
                tip: `Number of listings sold during the ${$ac576ba81a7c8a25$var$tooltipTimePeriods[periodTitle]}`
            }
        },
        avgSpOp: {
            ...(0, $1PiL9.marketDynamicsColumns).avgSpOp,
            tip: `The ratio of the sold price (closed price) to the original list price as a percentage for all properties sold during the ${$ac576ba81a7c8a25$var$tooltipTimePeriods[periodTitle]}`
        },
        ...view === (0, $cL3O2.listingViews).avgSpOpAllProperties.value && {
            soldAvgDom: {
                ...(0, $1PiL9.marketDynamicsColumns).soldAvgDom,
                tip: `The average number of Days on Market for all properties sold during the ${$ac576ba81a7c8a25$var$tooltipTimePeriods[periodTitle]}`
            }
        },
        avgDom: {
            ...(0, $1PiL9.marketDynamicsColumns).avgDom,
            tip: `Average DOM of listings that went under contract during the ${$ac576ba81a7c8a25$var$tooltipTimePeriods[periodTitle]}`
        },
        avgCdom: {
            ...(0, $1PiL9.marketDynamicsColumns).avgCdom,
            tip: `Average CDOM of listings that went under contract during the ${$ac576ba81a7c8a25$var$tooltipTimePeriods[periodTitle]}`
        },
        forSaleAvgDom: {
            ...(0, $1PiL9.marketDynamicsColumns).forSaleAvgDom,
            tip: `Average DOM of listings that were for sale during the ${$ac576ba81a7c8a25$var$tooltipTimePeriods[periodTitle]}`
        },
        ucAvgDom: {
            ...(0, $1PiL9.marketDynamicsColumns).ucAvgDom,
            ...view === (0, $cL3O2.listingViews).avgDomCdom.value && {
                label: (0, $bLQRh.terms).avgDom
            },
            tip: `Average DOM of listings that went under contract during the ${$ac576ba81a7c8a25$var$tooltipTimePeriods[periodTitle]}`
        },
        expAvgDom: {
            ...(0, $1PiL9.marketDynamicsColumns).expAvgDom,
            tip: `Average DOM of listings that went off market during the ${$ac576ba81a7c8a25$var$tooltipTimePeriods[periodTitle]}`
        },
        soldMsi: {
            ...(0, $1PiL9.marketDynamicsColumns).soldMsi,
            tip: "The number of listings For Sale on the last day of the month divided by the number of listings that went under contract during the month"
        },
        ucMsi: {
            ...(0, $1PiL9.marketDynamicsColumns).ucMsi,
            tip: "The number of For Sale listings minus Under Contract minus listings that have gone off market divided by the number of under contract listings"
        },
        forSaleLastDayUnits: {
            ...(0, $1PiL9.marketDynamicsColumns).forSaleLastDayUnits,
            tip: "The number of listings that were for sale on the last day of the month"
        },
        ...view === (0, $cL3O2.listingViews).monthlySupplyOfInventory.value && {
            soldUnits: {
                ...(0, $1PiL9.marketDynamicsColumns).soldUnits,
                tip: "Number of listings sold during the month"
            }
        },
        ucAvgCdom: {
            ...(0, $1PiL9.marketDynamicsColumns).ucAvgCdom,
            tip: `Average CDOM of listings that went under contract during the ${$ac576ba81a7c8a25$var$tooltipTimePeriods[periodTitle]}`
        },
        yearBuilt: {
            ...(0, $1PiL9.marketDynamicsColumns).yearBuilt,
            tip: "Year Built"
        }
    });

});


parcelRegister("5usXl", function(module, exports) {

$parcel$export(module.exports, "underContractUc", () => $3ff6373283589bd4$export$ffeaa86452bb27f4);

var $bLQRh = parcelRequire("bLQRh");

var $ikyhZ = parcelRequire("ikyhZ");

var $1PiL9 = parcelRequire("1PiL9");

var $htzEo = parcelRequire("htzEo");

var $98ROn = parcelRequire("98ROn");
const $3ff6373283589bd4$export$ffeaa86452bb27f4 = {
    label: (0, $bLQRh.terms).underContractUc,
    value: "underContractUc",
    statusOptions: {
        groups: [
            {
                options: [
                    {
                        ...(0, $ikyhZ.listingStatuses).underContractUc,
                        isDefault: true,
                        keyField: "ucUnits"
                    }
                ]
            }
        ]
    },
    tableSettings: {
        id: "underContractUc",
        showPagination: false,
        defaultSort: {
            colId: (0, $1PiL9.marketDynamicsColumns).timePeriodStart.id,
            sortDir: "desc"
        },
        tables: [
            {
                col: (0, $1PiL9.marketDynamicsColumns).timePeriodStart
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).ucUnits,
                colDef: (0, $98ROn.colSettings).numberSmInteger,
                statusId: (0, $ikyhZ.listingStatuses).underContractUc.id,
                measureType: (0, $bLQRh.measureTypes).units
            }
        ]
    },
    chart: {
        yAxis: {
            title: (0, $bLQRh.getYAxisTitle)((0, $bLQRh.terms).unitsNum),
            labels: {
                formatter: (0, $htzEo.formatInteger)
            }
        },
        popOverDataFormatter: (0, $htzEo.popOverDataFormatters).units
    },
    keyInformation: {
        formatter: (0, $htzEo.formatInteger),
        changeColumnHeaderName: (0, $bLQRh.terms).unitsChangeNum
    }
};

});

parcelRegister("e6sW3", function(module, exports) {

$parcel$export(module.exports, "avgSpLpComparison", () => $a448122e3809ebcd$export$6241ff86d706c880);

var $bLQRh = parcelRequire("bLQRh");

var $ikyhZ = parcelRequire("ikyhZ");

var $htzEo = parcelRequire("htzEo");

var $1PiL9 = parcelRequire("1PiL9");

var $98ROn = parcelRequire("98ROn");
const $a448122e3809ebcd$export$6241ff86d706c880 = {
    label: (0, $bLQRh.terms).avgSpLpComparison,
    value: "avgSpLpComparison",
    statusOptions: {
        groups: [
            {
                options: [
                    {
                        ...(0, $ikyhZ.listingStatuses).spLpNoPriceChanges,
                        isDefault: true,
                        keyField: "spLpRatioWithoutPriceChanges"
                    },
                    {
                        ...(0, $ikyhZ.listingStatuses).spLpPriceChanges,
                        isDefault: true,
                        keyField: "spLpRatioWithPriceChanges"
                    }
                ]
            }
        ]
    },
    tableSettings: {
        id: "avgSpLpComparison",
        showPagination: false,
        defaultSort: {
            colId: (0, $1PiL9.marketDynamicsColumns).timePeriodStart.id,
            sortDir: "desc"
        },
        tables: [
            {
                col: (0, $1PiL9.marketDynamicsColumns).timePeriodStart
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).soldUnitsWithoutPriceChanges,
                colDef: (0, $98ROn.colSettings).numberMdInteger,
                statusId: (0, $ikyhZ.listingStatuses).spLpNoPriceChanges.id,
                measureType: (0, $bLQRh.measureTypes).units
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).spLpRatioWithoutPriceChanges,
                colDef: (0, $98ROn.colSettings).numberLgPercentageOneDecimal,
                statusId: (0, $ikyhZ.listingStatuses).spLpNoPriceChanges.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).soldAvgDomWithoutPriceChanges,
                colDef: (0, $98ROn.colSettings).numberMdInteger,
                statusId: (0, $ikyhZ.listingStatuses).spLpNoPriceChanges.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).soldUnitsWithPriceChanges,
                colDef: (0, $98ROn.colSettings).numberMdInteger,
                statusId: (0, $ikyhZ.listingStatuses).spLpPriceChanges.id,
                measureType: (0, $bLQRh.measureTypes).units
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).spLpRatioWithPriceChanges,
                colDef: (0, $98ROn.colSettings).numberLgPercentageOneDecimal,
                statusId: (0, $ikyhZ.listingStatuses).spLpPriceChanges.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).soldAvgDomWithPriceChanges,
                colDef: (0, $98ROn.colSettings).numberMdInteger,
                statusId: (0, $ikyhZ.listingStatuses).spLpPriceChanges.id
            }
        ]
    },
    chart: {
        yAxis: {
            title: (0, $bLQRh.getYAxisTitle)((0, $bLQRh.terms).percentage),
            labels: {
                formatter: (0, $htzEo.formatOneDecimalPercentageWithMultiplier)
            }
        },
        popOverDataFormatter: (0, $htzEo.formatOneDecimalPercentageWithMultiplier)
    },
    keyInformation: {
        formatter: (0, $htzEo.formatOneDecimalPercentageWithMultiplier),
        changeColumnHeaderName: (0, $bLQRh.terms).change,
        headerTooltipPercentType: (0, $bLQRh.terms).spLp
    }
};

});

parcelRegister("e88jF", function(module, exports) {

$parcel$export(module.exports, "salesAbsorption", () => $a498437a19c12374$export$80d5159345deb8d9);

var $bLQRh = parcelRequire("bLQRh");

var $ikyhZ = parcelRequire("ikyhZ");

var $htzEo = parcelRequire("htzEo");

var $1PiL9 = parcelRequire("1PiL9");

var $98ROn = parcelRequire("98ROn");
const $a498437a19c12374$export$80d5159345deb8d9 = {
    label: (0, $bLQRh.terms).salesAbsorption,
    value: "salesAbsorption",
    statusOptions: {
        groups: [
            {
                options: [
                    {
                        ...(0, $ikyhZ.listingStatuses).underContract,
                        label: (0, $bLQRh.terms).ucPercentage,
                        isDefault: true,
                        keyField: "ucToForSaleUnitsPct"
                    },
                    {
                        ...(0, $ikyhZ.listingStatuses).sold,
                        label: (0, $bLQRh.terms).soldPercentage,
                        isDefault: true,
                        keyField: "soldToForSaleUnitsPct"
                    }
                ]
            }
        ]
    },
    tableSettings: {
        id: "salesAbsorption",
        showPagination: false,
        defaultSort: {
            colId: (0, $1PiL9.marketDynamicsColumns).timePeriodStart.id,
            sortDir: "desc"
        },
        tables: [
            {
                col: (0, $1PiL9.marketDynamicsColumns).timePeriodStart
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).ucToForSaleUnitsPct,
                colDef: (0, $98ROn.colSettings).blankEmptyNumberSmPercentage,
                statusId: (0, $ikyhZ.listingStatuses).underContract.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).soldToForSaleUnitsPct,
                colDef: (0, $98ROn.colSettings).blankEmptyNumberSmPercentage,
                statusId: (0, $ikyhZ.listingStatuses).sold.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).forSaleUnits,
                colDef: (0, $98ROn.colSettings).numberMdInteger,
                measureType: (0, $bLQRh.measureTypes).units
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).ucUnits,
                colDef: (0, $98ROn.colSettings).numberMdInteger,
                statusId: (0, $ikyhZ.listingStatuses).underContract.id,
                measureType: (0, $bLQRh.measureTypes).units
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).soldUnits,
                colDef: (0, $98ROn.colSettings).numberMdInteger,
                statusId: (0, $ikyhZ.listingStatuses).sold.id,
                measureType: (0, $bLQRh.measureTypes).units
            }
        ]
    },
    chart: {
        yAxis: {
            title: (0, $bLQRh.getYAxisTitle)((0, $bLQRh.terms).percentage),
            labels: {
                formatter: (0, $htzEo.formatPercentage)
            }
        },
        popOverDataFormatter: (0, $htzEo.formatPercentage)
    },
    keyInformation: {
        formatter: (0, $htzEo.formatPercentage),
        changeColumnHeaderName: (0, $bLQRh.terms).change,
        headerTooltipPercentType: (0, $bLQRh.terms).salesAbsorption
    }
};

});

parcelRegister("gmkC2", function(module, exports) {

$parcel$export(module.exports, "avgSpOpAllProperties", () => $be8eb0a0cef28cc4$export$a4cac8d0f6d81e84);

var $ikyhZ = parcelRequire("ikyhZ");

var $bLQRh = parcelRequire("bLQRh");

var $htzEo = parcelRequire("htzEo");

var $1PiL9 = parcelRequire("1PiL9");

var $98ROn = parcelRequire("98ROn");
const $be8eb0a0cef28cc4$export$a4cac8d0f6d81e84 = {
    label: (0, $bLQRh.terms).avgSpOpAllProperties,
    value: "avgSpOpAllProperties",
    statusOptions: {
        groups: [
            {
                options: [
                    {
                        ...(0, $ikyhZ.listingStatuses).spOp,
                        isDefault: true,
                        keyField: "spOpRatioAllProperties"
                    }
                ]
            }
        ]
    },
    tableSettings: {
        id: "avgSpOpAllProperties",
        showPagination: false,
        defaultSort: {
            colId: (0, $1PiL9.marketDynamicsColumns).timePeriodStart.id,
            sortDir: "desc"
        },
        tables: [
            {
                col: (0, $1PiL9.marketDynamicsColumns).timePeriodStart
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).soldUnits,
                colDef: (0, $98ROn.colSettings).numberSmInteger,
                measureType: (0, $bLQRh.measureTypes).units
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).avgSpOp,
                colDef: (0, $98ROn.colSettings).numberLgPercentageOneDecimal
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).soldAvgDom,
                colDef: (0, $98ROn.colSettings).numberSmInteger
            }
        ]
    },
    chart: {
        yAxis: {
            title: (0, $bLQRh.getYAxisTitle)((0, $bLQRh.terms).percentage),
            labels: {
                formatter: (0, $htzEo.formatOneDecimalPercentageWithMultiplier)
            }
        },
        popOverDataFormatter: (0, $htzEo.formatOneDecimalPercentageWithMultiplier)
    },
    keyInformation: {
        formatter: (0, $htzEo.formatOneDecimalPercentageWithMultiplier),
        changeColumnHeaderName: (0, $bLQRh.terms).change,
        headerTooltipPercentType: (0, $bLQRh.terms).spOp
    }
};

});

parcelRegister("emacI", function(module, exports) {

$parcel$export(module.exports, "avgSpOpComparison", () => $a73b09134686f3cf$export$85a290c780d946e5);

var $bLQRh = parcelRequire("bLQRh");

var $ikyhZ = parcelRequire("ikyhZ");

var $htzEo = parcelRequire("htzEo");

var $1PiL9 = parcelRequire("1PiL9");

var $98ROn = parcelRequire("98ROn");
const $a73b09134686f3cf$export$85a290c780d946e5 = {
    label: (0, $bLQRh.terms).avgSpOpAllComparison,
    value: "avgSpOpComparison",
    statusOptions: {
        groups: [
            {
                options: [
                    {
                        ...(0, $ikyhZ.listingStatuses).spOpNoPriceChanges,
                        isDefault: true,
                        keyField: "spOpRatioWithoutPriceChanges"
                    },
                    {
                        ...(0, $ikyhZ.listingStatuses).spOpPriceChanges,
                        isDefault: true,
                        keyField: "spOpRatioWithPriceChanges"
                    }
                ]
            }
        ]
    },
    tableSettings: {
        id: "avgSpOpComparison",
        showPagination: false,
        defaultSort: {
            colId: (0, $1PiL9.marketDynamicsColumns).timePeriodStart.id,
            sortDir: "desc"
        },
        tables: [
            {
                col: (0, $1PiL9.marketDynamicsColumns).timePeriodStart
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).soldUnitsWithoutPriceChanges,
                colDef: (0, $98ROn.colSettings).numberMdInteger,
                statusId: (0, $ikyhZ.listingStatuses).spOpNoPriceChanges.id,
                measureType: (0, $bLQRh.measureTypes).units
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).spOpRatioWithoutPriceChanges,
                colDef: (0, $98ROn.colSettings).numberLgPercentageOneDecimal,
                statusId: (0, $ikyhZ.listingStatuses).spOpNoPriceChanges.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).soldAvgDomWithoutPriceChanges,
                colDef: (0, $98ROn.colSettings).numberMdInteger,
                statusId: (0, $ikyhZ.listingStatuses).spOpNoPriceChanges.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).soldUnitsWithPriceChanges,
                colDef: (0, $98ROn.colSettings).numberMdInteger,
                statusId: (0, $ikyhZ.listingStatuses).spOpPriceChanges.id,
                measureType: (0, $bLQRh.measureTypes).units
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).spOpRatioWithPriceChanges,
                colDef: (0, $98ROn.colSettings).numberLgPercentageOneDecimal,
                statusId: (0, $ikyhZ.listingStatuses).spOpPriceChanges.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).soldAvgDomWithPriceChanges,
                colDef: (0, $98ROn.colSettings).numberMdInteger,
                statusId: (0, $ikyhZ.listingStatuses).spOpPriceChanges.id
            }
        ]
    },
    chart: {
        yAxis: {
            title: (0, $bLQRh.getYAxisTitle)((0, $bLQRh.terms).percentage),
            labels: {
                formatter: (0, $htzEo.formatOneDecimalPercentageWithMultiplier)
            }
        },
        popOverDataFormatter: (0, $htzEo.formatOneDecimalPercentageWithMultiplier)
    },
    keyInformation: {
        formatter: (0, $htzEo.formatOneDecimalPercentageWithMultiplier),
        changeColumnHeaderName: (0, $bLQRh.terms).change,
        headerTooltipPercentType: (0, $bLQRh.terms).spOp
    }
};

});

parcelRegister("gRzdS", function(module, exports) {

$parcel$export(module.exports, "forSaleVsFsldm", () => $c46ceb13a638e584$export$d800145b6dc170b4);

var $bLQRh = parcelRequire("bLQRh");

var $ikyhZ = parcelRequire("ikyhZ");

var $htzEo = parcelRequire("htzEo");

var $1PiL9 = parcelRequire("1PiL9");

var $98ROn = parcelRequire("98ROn");
const $c46ceb13a638e584$export$d800145b6dc170b4 = {
    label: (0, $bLQRh.terms).forSaleVsFsldm,
    value: "forSaleVsFsldm",
    statusOptions: {
        groups: [
            {
                options: [
                    {
                        ...(0, $ikyhZ.listingStatuses).forSale,
                        isDefault: true,
                        keyField: "forSaleUnits"
                    },
                    {
                        ...(0, $ikyhZ.listingStatuses).forSaleLdm,
                        isDefault: true,
                        keyField: "forSaleLastDayUnits"
                    }
                ]
            }
        ]
    },
    tableSettings: {
        id: "forSaleVsFsldm",
        showPagination: false,
        defaultSort: {
            colId: (0, $1PiL9.marketDynamicsColumns).timePeriodStart.id,
            sortDir: "desc"
        },
        tables: [
            {
                col: (0, $1PiL9.marketDynamicsColumns).timePeriodStart,
                colDef: (0, $98ROn.colSettings).quarterNumYearFormat
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).forSaleUnits,
                colDef: (0, $98ROn.colSettings).numberSmInteger,
                measureType: (0, $bLQRh.measureTypes).units
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).forSaleLastDayUnits,
                colDef: (0, $98ROn.colSettings).numberSmInteger,
                measureType: (0, $bLQRh.measureTypes).units
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).forSaleLastDayChangeVolume,
                colDef: (0, $98ROn.colSettings).numberSmInteger
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).forSaleLastDayPercentage,
                colDef: (0, $98ROn.colSettings).numberSmPercentage
            }
        ]
    },
    chart: {
        yAxis: {
            title: (0, $bLQRh.getYAxisTitle)((0, $bLQRh.terms).units),
            labels: {
                formatter: (0, $htzEo.formatInteger)
            }
        },
        popOverDataFormatter: (0, $htzEo.popOverDataFormatters).units
    },
    keyInformation: {
        formatter: (0, $htzEo.formatInteger),
        changeColumnHeaderName: (0, $bLQRh.terms).unitsChangeNum,
        headerTooltipUnitType: (0, $bLQRh.terms).unitsNum.toLowerCase()
    }
};

});

parcelRegister("kwMiU", function(module, exports) {

$parcel$export(module.exports, "cdomBreakout", () => $ef1c43f339c949dd$export$9206767861b534ed);

var $bLQRh = parcelRequire("bLQRh");

var $ikyhZ = parcelRequire("ikyhZ");

var $htzEo = parcelRequire("htzEo");

var $1PiL9 = parcelRequire("1PiL9");

var $98ROn = parcelRequire("98ROn");
const $ef1c43f339c949dd$export$9206767861b534ed = {
    label: (0, $bLQRh.terms).cdomBreakout,
    value: "cdomBreakout",
    statusOptions: {
        groups: [
            {
                options: [
                    {
                        ...(0, $ikyhZ.listingStatuses).forSaleLdm,
                        label: (0, $bLQRh.terms).fsldm,
                        isDefault: true,
                        isRadio: true,
                        keyField: "forSaleLastDayUnits"
                    },
                    {
                        ...(0, $ikyhZ.listingStatuses).underContract,
                        isRadio: true,
                        keyField: "ucUnits"
                    },
                    {
                        ...(0, $ikyhZ.listingStatuses).sold,
                        isRadio: true,
                        keyField: "soldUnits"
                    },
                    {
                        ...(0, $ikyhZ.listingStatuses).units0To90,
                        isDefault: true,
                        keyFieldComplement: "0to90"
                    },
                    {
                        ...(0, $ikyhZ.listingStatuses).units91To180,
                        isDefault: true,
                        keyFieldComplement: "91to180"
                    },
                    {
                        ...(0, $ikyhZ.listingStatuses).unitsOver180,
                        isDefault: true,
                        keyFieldComplement: "Over180"
                    }
                ]
            }
        ]
    },
    tableSettings: {
        id: "cdomBreakout",
        showPagination: false,
        isBreakout: true,
        defaultSort: {
            colId: (0, $1PiL9.marketDynamicsColumns).timePeriodStart.id,
            sortDir: "desc"
        },
        tables: [
            {
                col: (0, $1PiL9.marketDynamicsColumns).timePeriodStart,
                colDef: (0, $98ROn.colSettings).quarterNumYearFormat
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).forSaleLastDayUnits,
                colDef: (0, $98ROn.colSettings).numberMdLgInteger,
                statusId: (0, $ikyhZ.listingStatuses).forSaleLdm.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).forSaleLastDayUnits0to90,
                colDef: (0, $98ROn.colSettings).numberSmInteger,
                statusId: (0, $ikyhZ.listingStatuses).forSaleLdm.id + (0, $ikyhZ.listingStatuses).units0To90.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).forSaleLastDayUnits0to90Pct,
                colDef: (0, $98ROn.colSettings).numberSmPercentage,
                statusId: (0, $ikyhZ.listingStatuses).forSaleLdm.id + (0, $ikyhZ.listingStatuses).units0To90.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).forSaleLastDayUnits91to180,
                colDef: (0, $98ROn.colSettings).numberSmInteger,
                statusId: (0, $ikyhZ.listingStatuses).forSaleLdm.id + (0, $ikyhZ.listingStatuses).units91To180.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).forSaleLastDayUnits91to180Pct,
                colDef: (0, $98ROn.colSettings).numberSmPercentage,
                statusId: (0, $ikyhZ.listingStatuses).forSaleLdm.id + (0, $ikyhZ.listingStatuses).units91To180.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).forSaleLastDayUnitsOver180,
                colDef: (0, $98ROn.colSettings).numberSmInteger,
                statusId: (0, $ikyhZ.listingStatuses).forSaleLdm.id + (0, $ikyhZ.listingStatuses).unitsOver180.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).forSaleLastDayUnitsOver180Pct,
                colDef: (0, $98ROn.colSettings).numberSmPercentage,
                statusId: (0, $ikyhZ.listingStatuses).forSaleLdm.id + (0, $ikyhZ.listingStatuses).unitsOver180.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).ucUnits,
                colDef: (0, $98ROn.colSettings).numberSmInteger,
                statusId: (0, $ikyhZ.listingStatuses).underContract.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).ucUnits0to90,
                colDef: (0, $98ROn.colSettings).numberSmInteger,
                statusId: (0, $ikyhZ.listingStatuses).underContract.id + (0, $ikyhZ.listingStatuses).units0To90.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).ucUnits0to90Pct,
                colDef: (0, $98ROn.colSettings).numberSmPercentage,
                statusId: (0, $ikyhZ.listingStatuses).underContract.id + (0, $ikyhZ.listingStatuses).units0To90.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).ucUnits91to180,
                colDef: (0, $98ROn.colSettings).numberSmInteger,
                statusId: (0, $ikyhZ.listingStatuses).underContract.id + (0, $ikyhZ.listingStatuses).units91To180.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).ucUnits91to180Pct,
                colDef: (0, $98ROn.colSettings).numberSmPercentage,
                statusId: (0, $ikyhZ.listingStatuses).underContract.id + (0, $ikyhZ.listingStatuses).units91To180.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).ucUnitsOver180,
                colDef: (0, $98ROn.colSettings).numberSmInteger,
                statusId: (0, $ikyhZ.listingStatuses).underContract.id + (0, $ikyhZ.listingStatuses).unitsOver180.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).ucUnitsOver180Pct,
                colDef: (0, $98ROn.colSettings).numberSmPercentage,
                statusId: (0, $ikyhZ.listingStatuses).underContract.id + (0, $ikyhZ.listingStatuses).unitsOver180.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).soldUnits,
                colDef: (0, $98ROn.colSettings).numberSmInteger,
                statusId: (0, $ikyhZ.listingStatuses).sold.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).soldUnits0to90,
                colDef: (0, $98ROn.colSettings).numberSmInteger,
                statusId: (0, $ikyhZ.listingStatuses).sold.id + (0, $ikyhZ.listingStatuses).units0To90.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).soldUnits0to90Pct,
                colDef: (0, $98ROn.colSettings).numberSmPercentage,
                statusId: (0, $ikyhZ.listingStatuses).sold.id + (0, $ikyhZ.listingStatuses).units0To90.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).soldUnits91to180,
                colDef: (0, $98ROn.colSettings).numberSmInteger,
                statusId: (0, $ikyhZ.listingStatuses).sold.id + (0, $ikyhZ.listingStatuses).units91To180.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).soldUnits91to180Pct,
                colDef: (0, $98ROn.colSettings).numberSmPercentage,
                statusId: (0, $ikyhZ.listingStatuses).sold.id + (0, $ikyhZ.listingStatuses).units91To180.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).soldUnitsOver180,
                colDef: (0, $98ROn.colSettings).numberSmInteger,
                statusId: (0, $ikyhZ.listingStatuses).sold.id + (0, $ikyhZ.listingStatuses).unitsOver180.id
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).soldUnitsOver180Pct,
                colDef: (0, $98ROn.colSettings).numberSmPercentage,
                statusId: (0, $ikyhZ.listingStatuses).sold.id + (0, $ikyhZ.listingStatuses).unitsOver180.id
            }
        ]
    },
    chart: {
        yAxis: {
            title: (0, $bLQRh.getYAxisTitle)((0, $bLQRh.terms).units),
            labels: {
                formatter: (0, $htzEo.formatInteger)
            }
        },
        isStacked: true
    },
    keyInformation: {
        formatter: (0, $htzEo.formatInteger),
        changeColumnHeaderName: (0, $bLQRh.terms).unitsChangeNum
    }
};

});

parcelRegister("f1v6f", function(module, exports) {

$parcel$export(module.exports, "default", () => $e96b09ef7478b064$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $g7mFm = parcelRequire("g7mFm");

var $5ynEC = parcelRequire("5ynEC");

var $70q5f = parcelRequire("70q5f");

var $90ISC = parcelRequire("90ISC");

var $kLrt8 = parcelRequire("kLrt8");
const $e96b09ef7478b064$var$MarketDynamicsPeriod = ({ data: data, valueFormatted: valueFormatted })=>{
    const { checkedStatusOptions: checkedStatusOptions, setSelectedBreakdownPeriod: setSelectedBreakdownPeriod } = (0, $70q5f.useMarketDynamicsStore)((state)=>({
            checkedStatusOptions: state.checkedStatusOptions,
            setSelectedBreakdownPeriod: state.setSelectedBreakdownPeriod
        }));
    const featureToggles = (0, $kLrt8.useFeatureToggles)();
    const setBackNavbarTitle = (0, $90ISC.useCommonStore)((state)=>state.setBackNavbarTitle);
    const handleClick = ()=>{
        setBackNavbarTitle(valueFormatted);
        setSelectedBreakdownPeriod(data);
    };
    const isMDOfficeBreakdownEnabled = featureToggles.mdOfficeBreakdown.isEnabled;
    const listingHasValue = checkedStatusOptions.some((status)=>data?.[status.keyField] > 0);
    const shouldRedirect = isMDOfficeBreakdownEnabled && listingHasValue;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ynEC.default), {
        linkProps: {
            to: {
                pathname: (0, $g7mFm.officeBreakdownRoute)
            },
            onClick: handleClick
        },
        shouldRedirect: shouldRedirect,
        label: valueFormatted
    });
};
$e96b09ef7478b064$var$MarketDynamicsPeriod.propTypes = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    context: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    valueFormatted: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};
var $e96b09ef7478b064$export$2e2bcd8739ae039 = $e96b09ef7478b064$var$MarketDynamicsPeriod;

});
parcelRegister("5ynEC", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc9bccb1fb419bcc$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $4fGPb = parcelRequire("4fGPb");
const $dc9bccb1fb419bcc$var$RedirectLink = ({ shouldRedirect: shouldRedirect, linkProps: linkProps, label: label })=>{
    if (!shouldRedirect) return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        children: label
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fGPb.Link), {
        ...linkProps,
        children: label
    });
};
$dc9bccb1fb419bcc$var$RedirectLink.propTypes = {
    shouldRedirect: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    linkProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired
};
var $dc9bccb1fb419bcc$export$2e2bcd8739ae039 = $dc9bccb1fb419bcc$var$RedirectLink;

});

parcelRegister("kLrt8", function(module, exports) {

$parcel$export(module.exports, "useFeatureToggles", () => $771eeba6d6369660$export$68d38bc471eccfe7);

var $kfZjc = parcelRequire("kfZjc");

var $3T9wI = parcelRequire("3T9wI");

var $f6CJ4 = parcelRequire("f6CJ4");

var $90ISC = parcelRequire("90ISC");

var $dDBOF = parcelRequire("dDBOF");
const $771eeba6d6369660$export$68d38bc471eccfe7 = ()=>{
    const selectedModule = (0, $90ISC.useSearchStore)((state)=>state.selectedModule);
    const currentPath = (0, $kfZjc.useLocation)().pathname;
    const email = (0, $f6CJ4.useAuthStore)((state)=>state.tokenInfo?.email);
    const isConnectMlsEnabled = (0, $3T9wI.getIsConnectMlsEnabled)({
        isAgentMetrics: $dDBOF.isAgentMetrics,
        hostname: location.hostname,
        email: email,
        envirosWhereIsHidden: (0, $3T9wI.ENVIROS_WHERE_CONNECT_MLS_IS_HIDDEN)
    });
    const { id: accountId } = (0, $90ISC.useCommonStore)((state)=>state.accountInfo || {});
    const isDashboardEnabled = (0, $3T9wI.getIsDashboardEnabled)((0, $dDBOF.isAgentMetrics));
    const isNotificationsEnabled = (0, $3T9wI.getIsNotificationsEnabled)((0, $dDBOF.isAgentMetrics), accountId);
    const isInternalAccount = (0, $3T9wI.getIsInternalAccount)(accountId);
    const isTrendAnalysisDebugOutputEnabled = (0, $3T9wI.getIsTrendAnalysisDebugEnabled)(location.hostname, (0, $3T9wI.ENVIROS_WHERE_TREND_ANALYSIS_IS_HIDDEN));
    return {
        trendAnalysisDebugOutput: {
            isEnabled: isTrendAnalysisDebugOutputEnabled
        },
        notifications: {
            isEnabled: isNotificationsEnabled
        },
        comparisonSets: {
            isEnabled: (0, $3T9wI.isComparisonSetsEnabled)
        },
        dashboard: {
            isEnabled: isDashboardEnabled
        },
        mdOfficeBreakdown: {
            isEnabled: true
        },
        suggestedAgents: {
            isEnabled: true
        },
        agentMovement: {
            isEnabled: true
        },
        connectMls: {
            isEnabled: isConnectMlsEnabled
        },
        isPdfUnderConstruction: (0, $3T9wI.pdfUnderConstructionModules).includes(selectedModule) || (0, $3T9wI.pdfDisabledRoutes).includes(currentPath),
        agentProduction: {
            isEnabled: true
        },
        todaysPicks: {
            isEnabled: isInternalAccount
        },
        talent: {
            isEnabled: (0, $3T9wI.IS_TALENT_LINK_ENABLED)
        }
    };
};

});



parcelRegister("42prG", function(module, exports) {

$parcel$export(module.exports, "hasAllZeroValues", () => $2f0b16458d01b73e$export$384d845309e48e40);
$parcel$export(module.exports, "getConfigData", () => $2f0b16458d01b73e$export$257da993075af2c3);
$parcel$export(module.exports, "getTransformData", () => $2f0b16458d01b73e$export$f7ccc2211180b4e0);
$parcel$export(module.exports, "getTransformKeyFields", () => $2f0b16458d01b73e$export$5862ff3b923e84fd);
$parcel$export(module.exports, "getChartTooltipContent", () => $2f0b16458d01b73e$export$cf94253ae1055687);
$parcel$export(module.exports, "getHeaderAndTooltip", () => $2f0b16458d01b73e$export$858bc22b1aede958);
$parcel$export(module.exports, "getQuarterlyOrMonthlyData", () => $2f0b16458d01b73e$export$4cd60cc39f18a22d);
$parcel$export(module.exports, "getWeeklyData", () => $2f0b16458d01b73e$export$b6f38a0bc32c796d);
$parcel$export(module.exports, "getBreakdownPinnedRowColumns", () => $2f0b16458d01b73e$export$d81b2ea9272cdfea);
$parcel$export(module.exports, "getPinnedRowTitle", () => $2f0b16458d01b73e$export$c37f6b03c22265cb);
$parcel$export(module.exports, "addOverviewConfig", () => $2f0b16458d01b73e$export$cac6d61b3a4eb55f);
$parcel$export(module.exports, "getBeginAndEndPeriodsData", () => $2f0b16458d01b73e$export$1c5775a253fa6add);
$parcel$export(module.exports, "getIncreaseDecreaseValue", () => $2f0b16458d01b73e$export$7e94318be8a2b6c6);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $bLQRh = parcelRequire("bLQRh");

var $cL3O2 = parcelRequire("cL3O2");

var $htzEo = parcelRequire("htzEo");

var $hbMru = parcelRequire("hbMru");

var $aXDbK = parcelRequire("aXDbK");

var $1PiL9 = parcelRequire("1PiL9");

var $e1whT = parcelRequire("e1whT");

var $70q5f = parcelRequire("70q5f");

var $aypMh = parcelRequire("aypMh");

var $cstaF = parcelRequire("cstaF");

var $eHBjM = parcelRequire("eHBjM");

var $4fYAk = parcelRequire("4fYAk");

var $ikyhZ = parcelRequire("ikyhZ");

var $2t1vB = parcelRequire("2t1vB");
parcelRequire("iCDWi");
const $2f0b16458d01b73e$export$384d845309e48e40 = (data, keysToDisregard)=>{
    return data?.every((obj)=>{
        for(let key in obj)if (!keysToDisregard.includes(key)) {
            if (typeof obj[key] === "number" && !isNaN(obj[key]) && obj[key] !== 0) return false;
        }
        return true;
    });
};
const $2f0b16458d01b73e$export$257da993075af2c3 = (listing, config)=>{
    let listingConfig, groupConfig;
    config?.find((item)=>{
        groupConfig = item;
        listingConfig = item?.options.find((option)=>option.value === listing);
        return listingConfig;
    });
    return {
        listingConfig: listingConfig,
        groupConfig: groupConfig
    };
};
const $2f0b16458d01b73e$var$calculatePercentChange = (start, end)=>{
    if (start === 0) return 0;
    return Math.abs((end - start) / start) * 100;
};
const $2f0b16458d01b73e$export$f7ccc2211180b4e0 = (searchResults)=>{
    if (!searchResults) return;
    const getTransformedData = (prev)=>{
        const { forSaleUnits: forSaleUnits, forSaleLastDayUnits: forSaleLastDayUnits } = prev;
        return {
            ...prev,
            forSaleLastDayChangeVolume: forSaleUnits - forSaleLastDayUnits,
            forSaleLastDayPercentage: $2f0b16458d01b73e$var$calculatePercentChange(forSaleUnits, forSaleLastDayUnits)
        };
    };
    if (!searchResults.length) return getTransformedData(searchResults);
    return searchResults?.map((searchResult)=>{
        return getTransformedData(searchResult);
    });
};
const $2f0b16458d01b73e$export$5862ff3b923e84fd = (options, listingViewId)=>{
    if (listingViewId !== (0, $cL3O2.listingViews).cdomBreakout.value) return options;
    const checkedWithRadio = options?.find((obj)=>obj?.checked && obj?.isRadio);
    if (!checkedWithRadio) return [];
    const revisedOptions = [];
    options.forEach((obj)=>{
        if (obj?.checked && !obj?.isRadio) revisedOptions.push({
            ...obj,
            keyField: checkedWithRadio.keyField + obj.keyFieldComplement,
            keyInfoLabel: `${checkedWithRadio.label} ${obj.label} ${(0, $bLQRh.terms).cdom}`
        });
        else revisedOptions.push({
            ...obj
        });
    });
    return revisedOptions;
};
const $2f0b16458d01b73e$export$cf94253ae1055687 = (data, series, dataPointIndex, barColors, config)=>{
    const checkedStatusOptions = (0, $70q5f.useMarketDynamicsStore).getState().checkedStatusOptions;
    const tooltipHeadersByPeriod = {
        [(0, $bLQRh.terms).weekOf]: `Week ${(0, $hbMru.default)(new Date(data[dataPointIndex].timePeriodStart))} <br />
            ${(0, $htzEo.dayFirstDateFormat)(data[dataPointIndex].timePeriodStart)} - ${(0, $htzEo.dayFirstDateFormat)(data[dataPointIndex].timePeriodEnd)}`,
        [(0, $bLQRh.terms).month]: (0, $htzEo.shortMonthAndShortYearFormat)(data[dataPointIndex].timePeriodStart),
        [(0, $bLQRh.terms).quarter]: (0, $htzEo.quarterNumYearFormat)(data[dataPointIndex].timePeriodStart)
    };
    const tooltipHeader = tooltipHeadersByPeriod[config.groupConfig.columnSettings.label];
    const popOverDataFormatter = config?.listingConfig?.chart?.popOverDataFormatter;
    if (!popOverDataFormatter) return `<div />`;
    const tooltipBody = checkedStatusOptions.map((option, index)=>`<span class='bullet' style='background-color: ${barColors[index]}'}></span>
                ${option?.label}: ${popOverDataFormatter(series[index][dataPointIndex])} <br />`);
    return `<div class='arrow_box volume-chart-tooltip'>
                <div class='header'>
                    ${tooltipHeader}
                </div>
                <div class='body'>
                <div class='items'>
                    ${tooltipBody.join("")}
                </div>
                </div>
            </div>`;
};
const $2f0b16458d01b73e$export$858bc22b1aede958 = (baseTooltip, ...params)=>{
    if (typeof baseTooltip?.tip !== "function") {
        const headerDetails = {
            ...baseTooltip,
            tip: baseTooltip?.tip
        };
        return {
            titleWithTooltip: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aXDbK.default), {
                isStatus: baseTooltip.label === (0, $1PiL9.marketDynamicsColumns).status.label,
                headerDetails: headerDetails
            })
        };
    }
    const tooltip = baseTooltip.tip(...params);
    const headerDetails = {
        ...baseTooltip,
        tip: tooltip
    };
    return {
        titleWithTooltip: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aXDbK.default), {
            isStatus: baseTooltip.label === (0, $1PiL9.marketDynamicsColumns).status.label,
            headerDetails: headerDetails
        })
    };
};
const $2f0b16458d01b73e$var$getPercentageChange = (changeVolume, beginValue)=>{
    if (changeVolume.data === 0) return "0";
    if (!beginValue) return "";
    return changeVolume.data / beginValue;
};
const $2f0b16458d01b73e$var$getAvg = (data, keyField)=>{
    const dataForAvg = data?.map((x)=>x[keyField]).filter((x)=>x !== undefined);
    return dataForAvg?.reduce((acc, curr)=>acc + curr, 0) / dataForAvg?.length;
};
const $2f0b16458d01b73e$var$getChange = (beginValue, endValue, formatter)=>{
    if (!endValue || !beginValue) return "";
    return {
        formatter: formatter,
        data: endValue - beginValue
    };
};
const $2f0b16458d01b73e$export$3610c7580b95262f = (value)=>{
    if (typeof value === "number") return value;
    return value && parseFloat(value.replace(/[$,%]/g, ""));
};
const $2f0b16458d01b73e$export$4cd60cc39f18a22d = ({ selectedPeriodComparison: selectedPeriodComparison, beginPeriodData: beginPeriodData, endPeriodData: endPeriodData, searchResults: searchResults, featureToggles: featureToggles, id: id, statusLabel: statusLabel, keyField: keyField, formatter: formatter, changeFormatter: changeFormatter, isOverview: isOverview })=>{
    if (selectedPeriodComparison === (0, $bLQRh.periodKeys).wholeTimePeriod) {
        if (beginPeriodData && endPeriodData) {
            const filteredSearchResults = searchResults?.filter((searchResult)=>new Date(searchResult.timePeriodStart) >= new Date(beginPeriodData?.timePeriodStart) && new Date(searchResult.timePeriodStart) <= new Date(endPeriodData?.timePeriodStart));
            return (0, $e1whT.getTrendAnalysis)({
                filteredSearchResults: filteredSearchResults,
                id: id,
                statusLabel: statusLabel,
                keyField: keyField,
                featureToggles: featureToggles,
                formatter: formatter
            });
        }
    }
    const endValue = isOverview ? endPeriodData?.[keyField] : String(formatter(endPeriodData?.[keyField]) ?? 0);
    const beginValue = isOverview ? beginPeriodData?.[keyField] : String(formatter(beginPeriodData?.[keyField]) ?? 0);
    const changeValue = $2f0b16458d01b73e$var$getChange($2f0b16458d01b73e$export$3610c7580b95262f(beginValue), $2f0b16458d01b73e$export$3610c7580b95262f(endValue), changeFormatter);
    const changeValuePercentage = $2f0b16458d01b73e$var$getPercentageChange(changeValue, $2f0b16458d01b73e$export$3610c7580b95262f(beginValue));
    return {
        id: id,
        status: statusLabel,
        beginPeriodValue: beginValue,
        endPeriodValue: endValue,
        changeValue: changeValue,
        changeValuePercentage: changeValuePercentage
    };
};
const $2f0b16458d01b73e$export$b6f38a0bc32c796d = (formatter, previousWeeksData, lastWeeksData, keyField, changeFormatter, id, label)=>{
    if (!previousWeeksData?.length || !lastWeeksData?.length) return {
        id: id,
        status: label
    };
    const previousWeeksAvg = formatter($2f0b16458d01b73e$var$getAvg(previousWeeksData, keyField));
    const lastWeeksAvg = formatter($2f0b16458d01b73e$var$getAvg(lastWeeksData, keyField));
    const changeAvg = $2f0b16458d01b73e$var$getChange($2f0b16458d01b73e$export$3610c7580b95262f(previousWeeksAvg), $2f0b16458d01b73e$export$3610c7580b95262f(lastWeeksAvg), changeFormatter);
    const changeAvgPercentage = $2f0b16458d01b73e$var$getPercentageChange(changeAvg, $2f0b16458d01b73e$export$3610c7580b95262f(previousWeeksAvg));
    return {
        id: id,
        status: label,
        previousWeeksAvg: previousWeeksAvg,
        lastWeeksAvg: lastWeeksAvg,
        changeAvg: changeAvg,
        changeAvgPercentage: changeAvgPercentage
    };
};
const $2f0b16458d01b73e$export$d81b2ea9272cdfea = (columns)=>{
    return columns.map((col)=>{
        if (col.col.id === (0, $1PiL9.marketDynamicsColumns).timePeriodStart.id) return (0, $1PiL9.marketDynamicsColumns).officeName.id;
        return col.col?.keyField || col.col.id;
    });
};
const $2f0b16458d01b73e$var$viewsToReplaceAgentName = [
    (0, $aypMh.views).overview,
    (0, $aypMh.views).listingProficiency
];
const $2f0b16458d01b73e$var$viewsToReplaceOfficeName = [
    (0, $cL3O2.listingViews).medianPrice.value,
    (0, $cL3O2.listingViews).soldAvgVsMedianPrice.value,
    (0, $cL3O2.listingViews).avg$Sqft.value,
    (0, $cL3O2.listingViews).avgSpOpComparison.value,
    (0, $cL3O2.listingViews).avgSpLpComparison.value,
    (0, $cL3O2.listingViews).avgSpOpAllProperties.value,
    (0, $cL3O2.listingViews).salesAbsorption.value,
    (0, $cL3O2.listingViews).avgDomCdom.value,
    (0, $cL3O2.listingViews).supplyAmpDemandNumUnits.value,
    (0, $cL3O2.listingViews).monthlySupplyOfInventory.value,
    (0, $cL3O2.listingViews).underContractUc.value,
    (0, $cL3O2.listingViews).forSaleVsFsldm.value,
    (0, $eHBjM.tableViewNames).agentMovement
];
const $2f0b16458d01b73e$export$c37f6b03c22265cb = (view)=>{
    if ($2f0b16458d01b73e$var$viewsToReplaceAgentName.includes(view)) return {
        [(0, $eHBjM.agentsColumns).agentName.id]: (0, $cstaF.agentProductionTerms).summary
    };
    if ($2f0b16458d01b73e$var$viewsToReplaceOfficeName.includes(view)) return {
        [(0, $eHBjM.agentsColumns).officeName.id]: (0, $cstaF.searchTerms).totals
    };
    return {};
};
const $2f0b16458d01b73e$export$8f62657832dc8cad = (searchPeriod, timePeriod)=>({
        ...(0, $4fYAk.overviewPeriods)[searchPeriod],
        listingId: (0, $4fYAk.listingIds)[timePeriod]
    });
const $2f0b16458d01b73e$var$getGroupAndFilteredOptions = (config, groupTerm, value)=>{
    const group = config.find((item)=>item?.group === groupTerm);
    const { options: options, ...rest } = group || {};
    const filteredOptions = options?.find((option)=>option?.value === value);
    return {
        filteredOptions: filteredOptions,
        rest: rest
    };
};
const $2f0b16458d01b73e$var$createChartConfig = ({ filteredOptions: filteredOptions, overviewChartConfig: overviewChartConfig, xAxisLegends: xAxisLegends, yAxisText: yAxisText, statusOptionsLabels: statusOptionsLabels, is6Months: is6Months, customToolTipLabels: customToolTipLabels, tabName: tabName })=>{
    const isInventory = tabName === (0, $4fYAk.tabNames).inventory.toLowerCase();
    const isPrices = tabName === (0, $4fYAk.tabNames).prices.toLowerCase();
    return {
        ...filteredOptions,
        label: (0, $4fYAk.listingOptions).overview.label,
        value: (0, $4fYAk.listingOptions).overview.value,
        isDefault: true,
        chart: {
            ...filteredOptions?.chart,
            lowHexColor: overviewChartConfig?.lowHexColor,
            highHexColor: overviewChartConfig?.highHexColor,
            auxHexColor: overviewChartConfig?.auxHexColor,
            threshold: overviewChartConfig?.threshold,
            xAxisLegends: xAxisLegends,
            yAxis: {
                ...filteredOptions?.chart?.yAxis,
                title: {
                    ...filteredOptions?.chart?.yAxis.title,
                    ...yAxisText && {
                        text: yAxisText
                    }
                }
            }
        },
        statusOptions: {
            ...filteredOptions?.statusOptions,
            groups: [
                {
                    options: statusOptionsLabels.map((label, index)=>({
                            ...filteredOptions?.statusOptions?.groups[0]?.options.find((option)=>option.label === label),
                            ...isPrices && customToolTipLabels && {
                                label: customToolTipLabels[index]
                            },
                            ...isInventory && is6Months && index === 0 && {
                                keyField: (0, $1PiL9.marketDynamicsColumns).ucAvgDom.id,
                                label: (0, $bLQRh.terms).avgDom
                            },
                            isDefault: true
                        }))
                }
            ]
        }
    };
};
const $2f0b16458d01b73e$var$chartConfigs = ({ tabName: tabName, config: config, overviewChartConfig: overviewChartConfig, timePeriod: timePeriod })=>{
    const configs = {
        inventory: {
            groupTerm: (0, $bLQRh.terms).salesRate,
            value: overviewChartConfig.listingId,
            xAxisLegends: overviewChartConfig?.xAxisLegends,
            yAxisText: overviewChartConfig?.yAxisText,
            statusOptionsLabels: (filteredOptions)=>[
                    filteredOptions?.statusOptions?.groups[0]?.options[0]?.label
                ],
            is6Months: timePeriod === (0, $cstaF.marketDynamicsTimePeriods)[(0, $cstaF.marketDynamicsTerms).months6Weekly],
            customToolTipLabels: null
        },
        prices: {
            groupTerm: (0, $bLQRh.terms).price,
            value: (0, $ikyhZ.listingStatuses).medianPrice.id,
            xAxisLegends: [
                (0, $4fYAk.chartLegends).medianList,
                (0, $4fYAk.chartLegends).medianSold
            ],
            yAxisText: false,
            statusOptionsLabels: [
                (0, $4fYAk.optionLabels).forSale,
                (0, $4fYAk.optionLabels).sold
            ],
            is6Months: false,
            customToolTipLabels: [
                (0, $4fYAk.labels).medianList,
                (0, $4fYAk.labels).medianSold
            ]
        },
        activity: {
            groupTerm: (0, $bLQRh.terms).supplyAmpDemand,
            value: (0, $2t1vB.supplyAmpDemandNumUnits).value,
            xAxisLegends: [
                (0, $4fYAk.chartLegends).forSale,
                (0, $4fYAk.chartLegends).underContract,
                (0, $4fYAk.chartLegends).sold
            ],
            yAxisText: false,
            statusOptionsLabels: (filteredOptions)=>[
                    filteredOptions?.statusOptions?.groups[0]?.options[1]?.label,
                    filteredOptions?.statusOptions?.groups[0]?.options[2]?.label,
                    filteredOptions?.statusOptions?.groups[0]?.options[3]?.label
                ],
            is6Months: false,
            customToolTipLabels: null
        }
    };
    const { groupTerm: groupTerm, value: value, xAxisLegends: xAxisLegends, yAxisText: yAxisText, statusOptionsLabels: statusOptionsLabels, is6Months: is6Months, customToolTipLabels: customToolTipLabels } = configs[tabName];
    const { filteredOptions: filteredOptions, rest: rest } = $2f0b16458d01b73e$var$getGroupAndFilteredOptions(config, groupTerm, value);
    return {
        filteredOptions: filteredOptions,
        rest: rest,
        xAxisLegends: xAxisLegends,
        yAxisText: yAxisText,
        statusOptionsLabels: statusOptionsLabels,
        is6Months: is6Months,
        customToolTipLabels: customToolTipLabels
    };
};
const $2f0b16458d01b73e$export$d7c59eb446e622 = (tabName, config, overviewChartConfig, timePeriod)=>{
    const { filteredOptions: filteredOptions, rest: rest, xAxisLegends: xAxisLegends, yAxisText: yAxisText, statusOptionsLabels: statusOptionsLabels, is6Months: is6Months, customToolTipLabels: customToolTipLabels } = $2f0b16458d01b73e$var$chartConfigs({
        tabName: tabName,
        config: config,
        overviewChartConfig: overviewChartConfig,
        timePeriod: timePeriod
    });
    const chartOptions = $2f0b16458d01b73e$var$createChartConfig({
        filteredOptions: filteredOptions,
        overviewChartConfig: overviewChartConfig,
        xAxisLegends: xAxisLegends,
        yAxisText: yAxisText,
        statusOptionsLabels: typeof statusOptionsLabels === "function" ? statusOptionsLabels(filteredOptions) : statusOptionsLabels,
        is6Months: is6Months,
        customToolTipLabels: customToolTipLabels,
        tabName: tabName
    });
    return {
        ...rest,
        group: null,
        id: (0, $4fYAk.listingOptions).overview.value,
        options: [
            chartOptions
        ],
        periodSelection: false
    };
};
const $2f0b16458d01b73e$export$cac6d61b3a4eb55f = (config, loadedSearchCriteria)=>{
    if (!config?.length) return;
    const timePeriod = loadedSearchCriteria?.timePeriod?.intervalType;
    const monthlyPeriods = Object.keys((0, $4fYAk.listingIds)).slice(0, 2);
    const searchPeriod = monthlyPeriods.includes(timePeriod) ? (0, $4fYAk.overviewPeriods).monthly.value : (0, $4fYAk.overviewPeriods).other.value;
    const overviewChartConfig = $2f0b16458d01b73e$export$8f62657832dc8cad(searchPeriod, timePeriod);
    const inventory = $2f0b16458d01b73e$export$d7c59eb446e622((0, $4fYAk.tabNames).inventory.toLowerCase(), config, overviewChartConfig, timePeriod);
    const prices = $2f0b16458d01b73e$export$d7c59eb446e622((0, $4fYAk.tabNames).prices.toLowerCase(), config, overviewChartConfig, timePeriod);
    const activity = $2f0b16458d01b73e$export$d7c59eb446e622((0, $4fYAk.tabNames).activity.toLowerCase(), config, overviewChartConfig, timePeriod);
    return {
        inventory: inventory,
        prices: prices,
        activity: activity
    };
};
const $2f0b16458d01b73e$export$1c5775a253fa6add = (chartData)=>{
    if (chartData.length < 2) return;
    return [
        chartData[0],
        chartData[chartData.length - 1]
    ];
};
const $2f0b16458d01b73e$export$7e94318be8a2b6c6 = (args)=>{
    const { changeValuePercentage: changeValuePercentage } = $2f0b16458d01b73e$export$4cd60cc39f18a22d(args);
    const changeValueFormattedUnits = (0, $htzEo.formatUnits)(changeValuePercentage * 100);
    const absChangeValue = Math.abs($2f0b16458d01b73e$export$3610c7580b95262f(changeValueFormattedUnits));
    const changeValueFormattedPercentage = (0, $htzEo.formatPercentage)(absChangeValue, 1);
    const isIncrease = $2f0b16458d01b73e$export$3610c7580b95262f(changeValueFormattedUnits) >= 0;
    const label = isIncrease ? (0, $bLQRh.terms).increase : (0, $bLQRh.terms).decrease;
    return `${changeValueFormattedPercentage} ${label}`;
};

});
parcelRegister("aXDbK", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac1b6acccf304db6$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $rMeTm = parcelRequire("rMeTm");
const $ac1b6acccf304db6$var$CustomHeaderKeyInfo = ({ headerDetails: headerDetails, isStatus: isStatus })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `key-info-header pb-1 ${isStatus ? "" : "td-num"}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $rMeTm.default), {
                target: headerDetails.id,
                placement: "top",
                boundariesElement: "window",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "helix-small",
                    children: headerDetails.tip
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                id: headerDetails.id,
                className: `clickable`,
                children: headerDetails.label
            })
        ]
    });
};
var $ac1b6acccf304db6$export$2e2bcd8739ae039 = $ac1b6acccf304db6$var$CustomHeaderKeyInfo;

});

parcelRegister("e1whT", function(module, exports) {

$parcel$export(module.exports, "getTrendAnalysis", () => $a35a3457d6073b34$export$cd279de93de7bbda);

var $dzAso = parcelRequire("dzAso");
const $a35a3457d6073b34$export$835ee6e6eb67882 = ({ totalChange: totalChange, slope: slope, totalPercentChange: totalPercentChange, keyField: keyField, periodPercentChange: periodPercentChange, coordinates: coordinates })=>{
    console.log("");
    console.log("status is", keyField);
    console.log("coordinates are", coordinates);
    console.log("totalChange is", totalChange);
    console.log("periodChange is", slope);
    console.log("totalPercentChange is", totalPercentChange * 100);
    console.log("periodPercentChange is", periodPercentChange * 100);
    console.log("");
};
const $a35a3457d6073b34$export$cd279de93de7bbda = ({ filteredSearchResults: filteredSearchResults, id: id, statusLabel: statusLabel, keyField: keyField, featureToggles: featureToggles, formatter: formatter })=>{
    const coordinates = $a35a3457d6073b34$export$908ce77ba66af1(filteredSearchResults, keyField);
    const slope = (0, $dzAso.linearRegression)(coordinates).m;
    const periodCount = coordinates.length - 1;
    const totalChange = slope * periodCount;
    const totalPercentChange = totalChange / coordinates[0][1];
    const periodPercentChange = totalPercentChange / periodCount;
    if (featureToggles.trendAnalysisDebugOutput.isEnabled) $a35a3457d6073b34$export$835ee6e6eb67882({
        totalChange: totalChange,
        keyField: keyField,
        slope: slope,
        totalPercentChange: totalPercentChange,
        periodPercentChange: periodPercentChange,
        coordinates: coordinates
    });
    return {
        id: id,
        status: statusLabel,
        totalChange: formatter(totalChange),
        periodChange: formatter(slope),
        totalPercentChange: totalPercentChange,
        periodPercentChange: periodPercentChange
    };
};
const $a35a3457d6073b34$export$908ce77ba66af1 = (searchResults, keyField)=>{
    return searchResults.slice().reverse().map((item, index)=>{
        if (keyField in item) return [
            index + 1,
            item[keyField]
        ];
        return [
            index + 1,
            0
        ];
    });
};

});
parcelRegister("dzAso", function(module, exports) {
!function(r, t) {
    t(module.exports);
}(module.exports, function(r) {
    "use strict";
    function t(r) {
        if (0 === r.length) return 0;
        var t, n = r[0], e = 0;
        if ("number" != typeof n) return NaN;
        for(var a = 1; a < r.length; a++){
            if ("number" != typeof r[a]) return NaN;
            t = n + r[a], Math.abs(n) >= Math.abs(r[a]) ? e += n - t + r[a] : e += r[a] - t + n, n = t;
        }
        return n + e;
    }
    function n(r) {
        if (0 === r.length) throw new Error("mean requires at least one data point");
        return t(r) / r.length;
    }
    function e(r, t) {
        var e, a, o = n(r), i = 0;
        if (2 === t) for(a = 0; a < r.length; a++)i += (e = r[a] - o) * e;
        else for(a = 0; a < r.length; a++)i += Math.pow(r[a] - o, t);
        return i;
    }
    function a(r) {
        if (0 === r.length) throw new Error("variance requires at least one data point");
        return e(r, 2) / r.length;
    }
    function o(r) {
        if (1 === r.length) return 0;
        var t = a(r);
        return Math.sqrt(t);
    }
    function i(r) {
        if (0 === r.length) throw new Error("mode requires at least one data point");
        if (1 === r.length) return r[0];
        for(var t = r[0], n = NaN, e = 0, a = 1, o = 1; o < r.length + 1; o++)r[o] !== t ? (a > e && (e = a, n = t), a = 1, t = r[o]) : a++;
        return n;
    }
    function u(r) {
        return r.slice().sort(function(r, t) {
            return r - t;
        });
    }
    function h(r) {
        if (0 === r.length) throw new Error("min requires at least one data point");
        for(var t = r[0], n = 1; n < r.length; n++)r[n] < t && (t = r[n]);
        return t;
    }
    function f(r) {
        if (0 === r.length) throw new Error("max requires at least one data point");
        for(var t = r[0], n = 1; n < r.length; n++)r[n] > t && (t = r[n]);
        return t;
    }
    function l(r) {
        for(var t = 0, n = 0; n < r.length; n++){
            if ("number" != typeof r[n]) return NaN;
            t += r[n];
        }
        return t;
    }
    function s(r, t) {
        var n = r.length * t;
        if (0 === r.length) throw new Error("quantile requires at least one data point.");
        if (t < 0 || t > 1) throw new Error("quantiles must be between 0 and 1");
        return 1 === t ? r[r.length - 1] : 0 === t ? r[0] : n % 1 != 0 ? r[Math.ceil(n) - 1] : r.length % 2 == 0 ? (r[n - 1] + r[n]) / 2 : r[n];
    }
    function c(r, t, n, e) {
        for(n = n || 0, e = e || r.length - 1; e > n;){
            if (e - n > 600) {
                var a = e - n + 1, o = t - n + 1, i = Math.log(a), u = .5 * Math.exp(2 * i / 3), h = .5 * Math.sqrt(i * u * (a - u) / a);
                o - a / 2 < 0 && (h *= -1), c(r, t, Math.max(n, Math.floor(t - o * u / a + h)), Math.min(e, Math.floor(t + (a - o) * u / a + h)));
            }
            var f = r[t], l = n, s = e;
            for(g(r, n, t), r[e] > f && g(r, n, e); l < s;){
                for(g(r, l, s), l++, s--; r[l] < f;)l++;
                for(; r[s] > f;)s--;
            }
            r[n] === f ? g(r, n, s) : g(r, ++s, e), s <= t && (n = s + 1), t <= s && (e = s - 1);
        }
    }
    function g(r, t, n) {
        var e = r[t];
        r[t] = r[n], r[n] = e;
    }
    function v(r, t) {
        var n = r.slice();
        if (Array.isArray(t)) {
            !function(r, t) {
                for(var n = [
                    0
                ], e = 0; e < t.length; e++)n.push(w(r.length, t[e]));
                n.push(r.length - 1), n.sort(m);
                var a = [
                    0,
                    n.length - 1
                ];
                for(; a.length;){
                    var o = Math.ceil(a.pop()), i = Math.floor(a.pop());
                    if (!(o - i <= 1)) {
                        var u = Math.floor((i + o) / 2);
                        p(r, n[u], Math.floor(n[i]), Math.ceil(n[o])), a.push(i, u, u, o);
                    }
                }
            }(n, t);
            for(var e = [], a = 0; a < t.length; a++)e[a] = s(n, t[a]);
            return e;
        }
        return p(n, w(n.length, t), 0, n.length - 1), s(n, t);
    }
    function p(r, t, n, e) {
        t % 1 == 0 ? c(r, t, n, e) : (c(r, t = Math.floor(t), n, e), c(r, t + 1, t + 1, e));
    }
    function m(r, t) {
        return r - t;
    }
    function w(r, t) {
        var n = r * t;
        return 1 === t ? r - 1 : 0 === t ? 0 : n % 1 != 0 ? Math.ceil(n) - 1 : r % 2 == 0 ? n - .5 : n;
    }
    function M(r, t) {
        if (t < r[0]) return 0;
        if (t > r[r.length - 1]) return 1;
        var n = function(r, t) {
            var n = 0, e = 0, a = r.length;
            for(; e < a;)t <= r[n = e + a >>> 1] ? a = n : e = -~n;
            return e;
        }(r, t);
        if (r[n] !== t) return n / r.length;
        n++;
        var e = function(r, t) {
            var n = 0, e = 0, a = r.length;
            for(; e < a;)t >= r[n = e + a >>> 1] ? e = -~n : a = n;
            return e;
        }(r, t);
        if (e === n) return n / r.length;
        var a = e - n + 1;
        return a * (e + n) / 2 / a / r.length;
    }
    function d(r) {
        var t = v(r, .75), n = v(r, .25);
        if ("number" == typeof t && "number" == typeof n) return t - n;
    }
    function b(r) {
        return +v(r, .5);
    }
    function q(r) {
        for(var t = b(r), n = [], e = 0; e < r.length; e++)n.push(Math.abs(r[e] - t));
        return b(n);
    }
    function y(r, t) {
        t = t || Math.random;
        for(var n, e, a = r.length; a > 0;)e = Math.floor(t() * a--), n = r[a], r[a] = r[e], r[e] = n;
        return r;
    }
    function E(r, t) {
        return y(r.slice(), t);
    }
    function x(r, t, n) {
        return E(r, n).slice(0, t);
    }
    function S(r, t) {
        for(var n = [], e = 0; e < r; e++){
            for(var a = [], o = 0; o < t; o++)a.push(0);
            n.push(a);
        }
        return n;
    }
    function k(r) {
        for(var t, n = 0, e = 0; e < r.length; e++)0 !== e && r[e] === t || (t = r[e], n++);
        return n;
    }
    function A(r, t, n, e) {
        var a;
        if (r > 0) {
            var o = (n[t] - n[r - 1]) / (t - r + 1);
            a = e[t] - e[r - 1] - (t - r + 1) * o * o;
        } else a = e[t] - n[t] * n[t] / (t + 1);
        return a < 0 ? 0 : a;
    }
    function N(r, t, n, e, a, o, i) {
        if (!(r > t)) {
            var u = Math.floor((r + t) / 2);
            e[n][u] = e[n - 1][u - 1], a[n][u] = u;
            var h = n;
            r > n && (h = Math.max(h, a[n][r - 1] || 0)), h = Math.max(h, a[n - 1][u] || 0);
            var f, l, s, c = u - 1;
            t < e[0].length - 1 && (c = Math.min(c, a[n][t + 1] || 0));
            for(var g = c; g >= h && !((f = A(g, u, o, i)) + e[n - 1][h - 1] >= e[n][u]); --g)(l = A(h, u, o, i) + e[n - 1][h - 1]) < e[n][u] && (e[n][u] = l, a[n][u] = h), h++, (s = f + e[n - 1][g - 1]) < e[n][u] && (e[n][u] = s, a[n][u] = g);
            N(r, u - 1, n, e, a, o, i), N(u + 1, t, n, e, a, o, i);
        }
    }
    function P(r, t) {
        if (r.length !== t.length) throw new Error("sampleCovariance requires samples with equal lengths");
        if (r.length < 2) throw new Error("sampleCovariance requires at least two data points in each sample");
        for(var e = n(r), a = n(t), o = 0, i = 0; i < r.length; i++)o += (r[i] - e) * (t[i] - a);
        return o / (r.length - 1);
    }
    function C(r) {
        if (r.length < 2) throw new Error("sampleVariance requires at least two data points");
        return e(r, 2) / (r.length - 1);
    }
    function I(r) {
        var t = C(r);
        return Math.sqrt(t);
    }
    function T(r, t) {
        return P(r, t) / I(r) / I(t);
    }
    function D(r, t, n, e) {
        return (r * t + n * e) / (t + e);
    }
    function R(r) {
        if (0 === r.length) throw new Error("meanSimple requires at least one data point");
        return l(r) / r.length;
    }
    function _(r) {
        if (0 === r.length) throw new Error("rootMeanSquare requires at least one data point");
        for(var t = 0, n = 0; n < r.length; n++)t += Math.pow(r[n], 2);
        return Math.sqrt(t / r.length);
    }
    var L = function() {
        this.totalCount = 0, this.data = {};
    };
    L.prototype.train = function(r, t) {
        for(var n in this.data[t] || (this.data[t] = {}), r){
            var e = r[n];
            void 0 === this.data[t][n] && (this.data[t][n] = {}), void 0 === this.data[t][n][e] && (this.data[t][n][e] = 0), this.data[t][n][e]++;
        }
        this.totalCount++;
    }, L.prototype.score = function(r) {
        var t, n = {};
        for(var e in r){
            var a = r[e];
            for(t in this.data)n[t] = {}, this.data[t][e] ? n[t][e + "_" + a] = (this.data[t][e][a] || 0) / this.totalCount : n[t][e + "_" + a] = 0;
        }
        var o = {};
        for(t in n)for(var i in o[t] = 0, n[t])o[t] += n[t][i];
        return o;
    };
    var V = function() {
        this.weights = [], this.bias = 0;
    };
    V.prototype.predict = function(r) {
        if (r.length !== this.weights.length) return null;
        for(var t = 0, n = 0; n < this.weights.length; n++)t += this.weights[n] * r[n];
        return (t += this.bias) > 0 ? 1 : 0;
    }, V.prototype.train = function(r, t) {
        if (0 !== t && 1 !== t) return null;
        r.length !== this.weights.length && (this.weights = r, this.bias = 1);
        var n = this.predict(r);
        if ("number" == typeof n && n !== t) {
            for(var e = t - n, a = 0; a < this.weights.length; a++)this.weights[a] += e * r[a];
            this.bias += e;
        }
        return this;
    };
    var F = 1e-4;
    function U(r) {
        if (r < 0) throw new Error("factorial requires a non-negative value");
        if (Math.floor(r) !== r) throw new Error("factorial requires an integer input");
        for(var t = 1, n = 2; n <= r; n++)t *= n;
        return t;
    }
    var z = [
        .9999999999999971,
        57.15623566586292,
        -59.59796035547549,
        14.136097974741746,
        -0.4919138160976202,
        3399464998481189e-20,
        4652362892704858e-20,
        -0.00009837447530487956,
        .0001580887032249125,
        -0.00021026444172410488,
        .00021743961811521265,
        -0.0001643181065367639,
        8441822398385275e-20,
        -0.000026190838401581408,
        36899182659531625e-22
    ], X = Math.log(Math.sqrt(2 * Math.PI));
    var j = {
        1: {
            .995: 0,
            .99: 0,
            .975: 0,
            .95: 0,
            .9: .02,
            .5: .45,
            .1: 2.71,
            .05: 3.84,
            .025: 5.02,
            .01: 6.63,
            .005: 7.88
        },
        2: {
            .995: .01,
            .99: .02,
            .975: .05,
            .95: .1,
            .9: .21,
            .5: 1.39,
            .1: 4.61,
            .05: 5.99,
            .025: 7.38,
            .01: 9.21,
            .005: 10.6
        },
        3: {
            .995: .07,
            .99: .11,
            .975: .22,
            .95: .35,
            .9: .58,
            .5: 2.37,
            .1: 6.25,
            .05: 7.81,
            .025: 9.35,
            .01: 11.34,
            .005: 12.84
        },
        4: {
            .995: .21,
            .99: .3,
            .975: .48,
            .95: .71,
            .9: 1.06,
            .5: 3.36,
            .1: 7.78,
            .05: 9.49,
            .025: 11.14,
            .01: 13.28,
            .005: 14.86
        },
        5: {
            .995: .41,
            .99: .55,
            .975: .83,
            .95: 1.15,
            .9: 1.61,
            .5: 4.35,
            .1: 9.24,
            .05: 11.07,
            .025: 12.83,
            .01: 15.09,
            .005: 16.75
        },
        6: {
            .995: .68,
            .99: .87,
            .975: 1.24,
            .95: 1.64,
            .9: 2.2,
            .5: 5.35,
            .1: 10.65,
            .05: 12.59,
            .025: 14.45,
            .01: 16.81,
            .005: 18.55
        },
        7: {
            .995: .99,
            .99: 1.25,
            .975: 1.69,
            .95: 2.17,
            .9: 2.83,
            .5: 6.35,
            .1: 12.02,
            .05: 14.07,
            .025: 16.01,
            .01: 18.48,
            .005: 20.28
        },
        8: {
            .995: 1.34,
            .99: 1.65,
            .975: 2.18,
            .95: 2.73,
            .9: 3.49,
            .5: 7.34,
            .1: 13.36,
            .05: 15.51,
            .025: 17.53,
            .01: 20.09,
            .005: 21.96
        },
        9: {
            .995: 1.73,
            .99: 2.09,
            .975: 2.7,
            .95: 3.33,
            .9: 4.17,
            .5: 8.34,
            .1: 14.68,
            .05: 16.92,
            .025: 19.02,
            .01: 21.67,
            .005: 23.59
        },
        10: {
            .995: 2.16,
            .99: 2.56,
            .975: 3.25,
            .95: 3.94,
            .9: 4.87,
            .5: 9.34,
            .1: 15.99,
            .05: 18.31,
            .025: 20.48,
            .01: 23.21,
            .005: 25.19
        },
        11: {
            .995: 2.6,
            .99: 3.05,
            .975: 3.82,
            .95: 4.57,
            .9: 5.58,
            .5: 10.34,
            .1: 17.28,
            .05: 19.68,
            .025: 21.92,
            .01: 24.72,
            .005: 26.76
        },
        12: {
            .995: 3.07,
            .99: 3.57,
            .975: 4.4,
            .95: 5.23,
            .9: 6.3,
            .5: 11.34,
            .1: 18.55,
            .05: 21.03,
            .025: 23.34,
            .01: 26.22,
            .005: 28.3
        },
        13: {
            .995: 3.57,
            .99: 4.11,
            .975: 5.01,
            .95: 5.89,
            .9: 7.04,
            .5: 12.34,
            .1: 19.81,
            .05: 22.36,
            .025: 24.74,
            .01: 27.69,
            .005: 29.82
        },
        14: {
            .995: 4.07,
            .99: 4.66,
            .975: 5.63,
            .95: 6.57,
            .9: 7.79,
            .5: 13.34,
            .1: 21.06,
            .05: 23.68,
            .025: 26.12,
            .01: 29.14,
            .005: 31.32
        },
        15: {
            .995: 4.6,
            .99: 5.23,
            .975: 6.27,
            .95: 7.26,
            .9: 8.55,
            .5: 14.34,
            .1: 22.31,
            .05: 25,
            .025: 27.49,
            .01: 30.58,
            .005: 32.8
        },
        16: {
            .995: 5.14,
            .99: 5.81,
            .975: 6.91,
            .95: 7.96,
            .9: 9.31,
            .5: 15.34,
            .1: 23.54,
            .05: 26.3,
            .025: 28.85,
            .01: 32,
            .005: 34.27
        },
        17: {
            .995: 5.7,
            .99: 6.41,
            .975: 7.56,
            .95: 8.67,
            .9: 10.09,
            .5: 16.34,
            .1: 24.77,
            .05: 27.59,
            .025: 30.19,
            .01: 33.41,
            .005: 35.72
        },
        18: {
            .995: 6.26,
            .99: 7.01,
            .975: 8.23,
            .95: 9.39,
            .9: 10.87,
            .5: 17.34,
            .1: 25.99,
            .05: 28.87,
            .025: 31.53,
            .01: 34.81,
            .005: 37.16
        },
        19: {
            .995: 6.84,
            .99: 7.63,
            .975: 8.91,
            .95: 10.12,
            .9: 11.65,
            .5: 18.34,
            .1: 27.2,
            .05: 30.14,
            .025: 32.85,
            .01: 36.19,
            .005: 38.58
        },
        20: {
            .995: 7.43,
            .99: 8.26,
            .975: 9.59,
            .95: 10.85,
            .9: 12.44,
            .5: 19.34,
            .1: 28.41,
            .05: 31.41,
            .025: 34.17,
            .01: 37.57,
            .005: 40
        },
        21: {
            .995: 8.03,
            .99: 8.9,
            .975: 10.28,
            .95: 11.59,
            .9: 13.24,
            .5: 20.34,
            .1: 29.62,
            .05: 32.67,
            .025: 35.48,
            .01: 38.93,
            .005: 41.4
        },
        22: {
            .995: 8.64,
            .99: 9.54,
            .975: 10.98,
            .95: 12.34,
            .9: 14.04,
            .5: 21.34,
            .1: 30.81,
            .05: 33.92,
            .025: 36.78,
            .01: 40.29,
            .005: 42.8
        },
        23: {
            .995: 9.26,
            .99: 10.2,
            .975: 11.69,
            .95: 13.09,
            .9: 14.85,
            .5: 22.34,
            .1: 32.01,
            .05: 35.17,
            .025: 38.08,
            .01: 41.64,
            .005: 44.18
        },
        24: {
            .995: 9.89,
            .99: 10.86,
            .975: 12.4,
            .95: 13.85,
            .9: 15.66,
            .5: 23.34,
            .1: 33.2,
            .05: 36.42,
            .025: 39.36,
            .01: 42.98,
            .005: 45.56
        },
        25: {
            .995: 10.52,
            .99: 11.52,
            .975: 13.12,
            .95: 14.61,
            .9: 16.47,
            .5: 24.34,
            .1: 34.28,
            .05: 37.65,
            .025: 40.65,
            .01: 44.31,
            .005: 46.93
        },
        26: {
            .995: 11.16,
            .99: 12.2,
            .975: 13.84,
            .95: 15.38,
            .9: 17.29,
            .5: 25.34,
            .1: 35.56,
            .05: 38.89,
            .025: 41.92,
            .01: 45.64,
            .005: 48.29
        },
        27: {
            .995: 11.81,
            .99: 12.88,
            .975: 14.57,
            .95: 16.15,
            .9: 18.11,
            .5: 26.34,
            .1: 36.74,
            .05: 40.11,
            .025: 43.19,
            .01: 46.96,
            .005: 49.65
        },
        28: {
            .995: 12.46,
            .99: 13.57,
            .975: 15.31,
            .95: 16.93,
            .9: 18.94,
            .5: 27.34,
            .1: 37.92,
            .05: 41.34,
            .025: 44.46,
            .01: 48.28,
            .005: 50.99
        },
        29: {
            .995: 13.12,
            .99: 14.26,
            .975: 16.05,
            .95: 17.71,
            .9: 19.77,
            .5: 28.34,
            .1: 39.09,
            .05: 42.56,
            .025: 45.72,
            .01: 49.59,
            .005: 52.34
        },
        30: {
            .995: 13.79,
            .99: 14.95,
            .975: 16.79,
            .95: 18.49,
            .9: 20.6,
            .5: 29.34,
            .1: 40.26,
            .05: 43.77,
            .025: 46.98,
            .01: 50.89,
            .005: 53.67
        },
        40: {
            .995: 20.71,
            .99: 22.16,
            .975: 24.43,
            .95: 26.51,
            .9: 29.05,
            .5: 39.34,
            .1: 51.81,
            .05: 55.76,
            .025: 59.34,
            .01: 63.69,
            .005: 66.77
        },
        50: {
            .995: 27.99,
            .99: 29.71,
            .975: 32.36,
            .95: 34.76,
            .9: 37.69,
            .5: 49.33,
            .1: 63.17,
            .05: 67.5,
            .025: 71.42,
            .01: 76.15,
            .005: 79.49
        },
        60: {
            .995: 35.53,
            .99: 37.48,
            .975: 40.48,
            .95: 43.19,
            .9: 46.46,
            .5: 59.33,
            .1: 74.4,
            .05: 79.08,
            .025: 83.3,
            .01: 88.38,
            .005: 91.95
        },
        70: {
            .995: 43.28,
            .99: 45.44,
            .975: 48.76,
            .95: 51.74,
            .9: 55.33,
            .5: 69.33,
            .1: 85.53,
            .05: 90.53,
            .025: 95.02,
            .01: 100.42,
            .005: 104.22
        },
        80: {
            .995: 51.17,
            .99: 53.54,
            .975: 57.15,
            .95: 60.39,
            .9: 64.28,
            .5: 79.33,
            .1: 96.58,
            .05: 101.88,
            .025: 106.63,
            .01: 112.33,
            .005: 116.32
        },
        90: {
            .995: 59.2,
            .99: 61.75,
            .975: 65.65,
            .95: 69.13,
            .9: 73.29,
            .5: 89.33,
            .1: 107.57,
            .05: 113.14,
            .025: 118.14,
            .01: 124.12,
            .005: 128.3
        },
        100: {
            .995: 67.33,
            .99: 70.06,
            .975: 74.22,
            .95: 77.93,
            .9: 82.36,
            .5: 99.33,
            .1: 118.5,
            .05: 124.34,
            .025: 129.56,
            .01: 135.81,
            .005: 140.17
        }
    };
    var B = Math.sqrt(2 * Math.PI), K = {
        gaussian: function(r) {
            return Math.exp(-0.5 * r * r) / B;
        }
    }, O = {
        nrd: function(r) {
            var t = I(r), n = d(r);
            return "number" == typeof n && (t = Math.min(t, n / 1.34)), 1.06 * t * Math.pow(r.length, -0.2);
        }
    };
    function G(r, t, n) {
        var e, a;
        if (void 0 === t) e = K.gaussian;
        else if ("string" == typeof t) {
            if (!K[t]) throw new Error('Unknown kernel "' + t + '"');
            e = K[t];
        } else e = t;
        if (void 0 === n) a = O.nrd(r);
        else if ("string" == typeof n) {
            if (!O[n]) throw new Error('Unknown bandwidth method "' + n + '"');
            a = O[n](r);
        } else a = n;
        return function(t) {
            var n = 0, o = 0;
            for(n = 0; n < r.length; n++)o += e((t - r[n]) / a);
            return o / a / r.length;
        };
    }
    var H = Math.sqrt(2 * Math.PI);
    function W(r) {
        for(var t = r, n = r, e = 1; e < 15; e++)t += n *= r * r / (2 * e + 1);
        return Math.round(1e4 * (.5 + t / H * Math.exp(-r * r / 2))) / 1e4;
    }
    for(var J = [], Q = 0; Q <= 3.09; Q += .01)J.push(W(Q));
    function Y(r) {
        var t = 1 / (1 + .5 * Math.abs(r)), n = t * Math.exp(-r * r + ((((((((.17087277 * t - .82215223) * t + 1.48851587) * t - 1.13520398) * t + .27886807) * t - .18628806) * t + .09678418) * t + .37409196) * t + 1.00002368) * t - 1.26551223);
        return r >= 0 ? 1 - n : n - 1;
    }
    function Z(r) {
        var t = 8 * (Math.PI - 3) / (3 * Math.PI * (4 - Math.PI)), n = Math.sqrt(Math.sqrt(Math.pow(2 / (Math.PI * t) + Math.log(1 - r * r) / 2, 2) - Math.log(1 - r * r) / t) - (2 / (Math.PI * t) + Math.log(1 - r * r) / 2));
        return r >= 0 ? n : -n;
    }
    function $(r) {
        if ("number" == typeof r) return r < 0 ? -1 : 0 === r ? 0 : 1;
        throw new TypeError("not a number");
    }
    function rr(r, t) {
        for(var n = 0, e = 0; e < r.length; e++){
            var a = r[e] - t[e];
            n += a * a;
        }
        return Math.sqrt(n);
    }
    function tr(r, t) {
        return r.map(function(r) {
            for(var n = Number.MAX_VALUE, e = -1, a = 0; a < t.length; a++){
                var o = rr(r, t[a]);
                o < n && (n = o, e = a);
            }
            return e;
        });
    }
    function nr(r, t, n) {
        for(var e = r[0].length, a = S(n, e), o = Array(n).fill(0), i = r.length, u = 0; u < i; u++){
            for(var h = r[u], f = t[u], l = a[f], s = 0; s < e; s++)l[s] += h[s];
            o[f] += 1;
        }
        for(var c = 0; c < n; c++){
            if (0 === o[c]) throw new Error("Centroid " + c + " has no friends");
            for(var g = a[c], v = 0; v < e; v++)g[v] /= o[c];
        }
        return a;
    }
    function er(r, t) {
        for(var n = 0, e = 0; e < r.length; e++)n += rr(r[e], t[e]);
        return n;
    }
    function ar(r, t) {
        if (r.length !== t.length) throw new Error("must have exactly as many labels as points");
        for(var n = function(r) {
            for(var t = 1 + f(r), n = Array(t), e = 0; e < r.length; e++){
                var a = r[e];
                void 0 === n[a] && (n[a] = []), n[a].push(e);
            }
            return n;
        }(t), e = function(r) {
            for(var t = r.length, n = S(t, t), e = 0; e < t; e++)for(var a = 0; a < e; a++)n[e][a] = rr(r[e], r[a]), n[a][e] = n[e][a];
            return n;
        }(r), a = [], o = 0; o < r.length; o++){
            var i = 0;
            if (n[t[o]].length > 1) {
                var u = ir(o, n[t[o]], e), h = or(o, t, n, e);
                i = (h - u) / Math.max(u, h);
            }
            a.push(i);
        }
        return a;
    }
    function or(r, t, n, e) {
        for(var a = t[r], o = Number.MAX_VALUE, i = 0; i < n.length; i++)if (i !== a) {
            var u = ir(r, n[i], e);
            u < o && (o = u);
        }
        return o;
    }
    function ir(r, t, n) {
        for(var e = 0, a = 0; a < t.length; a++)e += n[r][t[a]];
        return e / t.length;
    }
    function ur(r, t) {
        return 0 === r && 0 === t ? 0 : Math.abs((r - t) / t);
    }
    r.BayesianClassifier = L, r.PerceptronModel = V, r.addToMean = function(r, t, n) {
        return r + (n - r) / (t + 1);
    }, r.approxEqual = function(r, t, n) {
        return void 0 === n && (n = F), ur(r, t) <= n;
    }, r.average = n, r.averageSimple = R, r.bayesian = L, r.bernoulliDistribution = function(r) {
        if (r < 0 || r > 1) throw new Error("bernoulliDistribution requires probability to be between 0 and 1 inclusive");
        return [
            1 - r,
            r
        ];
    }, r.binomialDistribution = function(r, t) {
        if (!(t < 0 || t > 1 || r <= 0 || r % 1 != 0)) {
            var n = 0, e = 0, a = [], o = 1;
            do a[n] = o * Math.pow(t, n) * Math.pow(1 - t, r - n), e += a[n], o = o * (r - ++n + 1) / n;
            while (e < .9999);
            return a;
        }
    }, r.bisect = function(r, t, n, e, a) {
        if ("function" != typeof r) throw new TypeError("func must be a function");
        for(var o = 0; o < e; o++){
            var i = (t + n) / 2;
            if (0 === r(i) || Math.abs((n - t) / 2) < a) return i;
            $(r(i)) === $(r(t)) ? t = i : n = i;
        }
        throw new Error("maximum number of iterations exceeded");
    }, r.chiSquaredDistributionTable = j, r.chiSquaredGoodnessOfFit = function(r, t, e) {
        for(var a = 0, o = t(n(r)), i = [], u = [], h = 0; h < r.length; h++)void 0 === i[r[h]] && (i[r[h]] = 0), i[r[h]]++;
        for(var f = 0; f < i.length; f++)void 0 === i[f] && (i[f] = 0);
        for(var l in o)l in i && (u[+l] = o[l] * r.length);
        for(var s = u.length - 1; s >= 0; s--)u[s] < 3 && (u[s - 1] += u[s], u.pop(), i[s - 1] += i[s], i.pop());
        for(var c = 0; c < i.length; c++)a += Math.pow(i[c] - u[c], 2) / u[c];
        var g = i.length - 1 - 1;
        return j[g][e] < a;
    }, r.chunk = function(r, t) {
        var n = [];
        if (t < 1) throw new Error("chunk size must be a positive number");
        if (Math.floor(t) !== t) throw new Error("chunk size must be an integer");
        for(var e = 0; e < r.length; e += t)n.push(r.slice(e, e + t));
        return n;
    }, r.ckmeans = function(r, t) {
        if (t > r.length) throw new Error("cannot generate more classes than there are data values");
        var n = u(r);
        if (1 === k(n)) return [
            n
        ];
        var e = S(t, n.length), a = S(t, n.length);
        !function(r, t, n) {
            for(var e = t[0].length, a = r[Math.floor(e / 2)], o = [], i = [], u = 0, h = void 0; u < e; ++u)h = r[u] - a, 0 === u ? (o.push(h), i.push(h * h)) : (o.push(o[u - 1] + h), i.push(i[u - 1] + h * h)), t[0][u] = A(0, u, o, i), n[0][u] = 0;
            for(var f = 1; f < t.length; ++f)N(f < t.length - 1 ? f : e - 1, e - 1, f, t, n, o, i);
        }(n, e, a);
        for(var o = [], i = a[0].length - 1, h = a.length - 1; h >= 0; h--){
            var f = a[h][i];
            o[h] = n.slice(f, i + 1), h > 0 && (i = f - 1);
        }
        return o;
    }, r.coefficientOfVariation = function(r) {
        return I(r) / n(r);
    }, r.combinations = function r(t, n) {
        var e, a, o, i, u = [];
        for(e = 0; e < t.length; e++)if (1 === n) u.push([
            t[e]
        ]);
        else for(o = r(t.slice(e + 1, t.length), n - 1), a = 0; a < o.length; a++)(i = o[a]).unshift(t[e]), u.push(i);
        return u;
    }, r.combinationsReplacement = function r(t, n) {
        for(var e = [], a = 0; a < t.length; a++)if (1 === n) e.push([
            t[a]
        ]);
        else for(var o = r(t.slice(a, t.length), n - 1), i = 0; i < o.length; i++)e.push([
            t[a]
        ].concat(o[i]));
        return e;
    }, r.combineMeans = D, r.combineVariances = function(r, t, n, e, a, o) {
        var i = D(t, n, a, o);
        return (n * (r + Math.pow(t - i, 2)) + o * (e + Math.pow(a - i, 2))) / (n + o);
    }, r.cumulativeStdLogisticProbability = function(r) {
        return 1 / (Math.exp(-r) + 1);
    }, r.cumulativeStdNormalProbability = function(r) {
        var t = Math.abs(r), n = Math.min(Math.round(100 * t), J.length - 1);
        return r >= 0 ? J[n] : +(1 - J[n]).toFixed(4);
    }, r.epsilon = F, r.equalIntervalBreaks = function(r, t) {
        if (r.length < 2) return r;
        for(var n = h(r), e = f(r), a = [
            n
        ], o = (e - n) / t, i = 1; i < t; i++)a.push(a[0] + o * i);
        return a.push(e), a;
    }, r.erf = Y, r.errorFunction = Y, r.extent = function(r) {
        if (0 === r.length) throw new Error("extent requires at least one data point");
        for(var t = r[0], n = r[0], e = 1; e < r.length; e++)r[e] > n && (n = r[e]), r[e] < t && (t = r[e]);
        return [
            t,
            n
        ];
    }, r.extentSorted = function(r) {
        return [
            r[0],
            r[r.length - 1]
        ];
    }, r.factorial = U, r.gamma = function r(t) {
        if (Number.isInteger(t)) return t <= 0 ? NaN : U(t - 1);
        if (--t < 0) return Math.PI / (Math.sin(Math.PI * -t) * r(-t));
        var n = t + 1 / 4;
        return Math.pow(t / Math.E, t) * Math.sqrt(2 * Math.PI * (t + 1 / 6)) * (1 + 1 / 144 / Math.pow(n, 2) - 1 / 12960 / Math.pow(n, 3) - 257 / 207360 / Math.pow(n, 4) - 52 / 2612736 / Math.pow(n, 5) + 5741173 / 9405849600 / Math.pow(n, 6) + 37529 / 18811699200 / Math.pow(n, 7));
    }, r.gammaln = function(r) {
        if (r <= 0) return 1 / 0;
        r--;
        for(var t = z[0], n = 1; n < 15; n++)t += z[n] / (r + n);
        var e = 5.2421875 + r;
        return X + Math.log(t) - e + (r + .5) * Math.log(e);
    }, r.geometricMean = function(r) {
        if (0 === r.length) throw new Error("geometricMean requires at least one data point");
        for(var t = 1, n = 0; n < r.length; n++){
            if (r[n] < 0) throw new Error("geometricMean requires only non-negative numbers as input");
            t *= r[n];
        }
        return Math.pow(t, 1 / r.length);
    }, r.harmonicMean = function(r) {
        if (0 === r.length) throw new Error("harmonicMean requires at least one data point");
        for(var t = 0, n = 0; n < r.length; n++){
            if (r[n] <= 0) throw new Error("harmonicMean requires only positive numbers as input");
            t += 1 / r[n];
        }
        return r.length / t;
    }, r.interquartileRange = d, r.inverseErrorFunction = Z, r.iqr = d, r.jenks = function(r, t) {
        if (t > r.length) return null;
        var n = function(r, t) {
            var n, e, a = [], o = [], i = 0;
            for(n = 0; n < r.length + 1; n++){
                var u = [], h = [];
                for(e = 0; e < t + 1; e++)u.push(0), h.push(0);
                a.push(u), o.push(h);
            }
            for(n = 1; n < t + 1; n++)for(a[1][n] = 1, o[1][n] = 0, e = 2; e < r.length + 1; e++)o[e][n] = 1 / 0;
            for(var f = 2; f < r.length + 1; f++){
                for(var l = 0, s = 0, c = 0, g = 0, v = 1; v < f + 1; v++){
                    var p = f - v + 1, m = r[p - 1];
                    if (i = (s += m * m) - (l += m) * l / ++c, 0 != (g = p - 1)) for(e = 2; e < t + 1; e++)o[f][e] >= i + o[g][e - 1] && (a[f][e] = p, o[f][e] = i + o[g][e - 1]);
                }
                a[f][1] = 1, o[f][1] = i;
            }
            return {
                lowerClassLimits: a,
                varianceCombinations: o
            };
        }(r = r.slice().sort(function(r, t) {
            return r - t;
        }), t);
        return function(r, t, n) {
            var e = r.length, a = [], o = n;
            for(a[n] = r[r.length - 1]; o > 0;)a[o - 1] = r[t[e][o] - 1], e = t[e][o] - 1, o--;
            return a;
        }(r, n.lowerClassLimits, t);
    }, r.kMeansCluster = function(r, t, n) {
        void 0 === n && (n = Math.random);
        for(var e = null, a = x(r, t, n), o = null, i = Number.MAX_VALUE; 0 !== i;)e = a, i = er(a = nr(r, o = tr(r, a), t), e);
        return {
            labels: o,
            centroids: a
        };
    }, r.kde = G, r.kernelDensityEstimation = G, r.linearRegression = function(r) {
        var t, n, e = r.length;
        if (1 === e) t = 0, n = r[0][1];
        else {
            for(var a, o, i, u = 0, h = 0, f = 0, l = 0, s = 0; s < e; s++)u += o = (a = r[s])[0], h += i = a[1], f += o * o, l += o * i;
            n = h / e - (t = (e * l - u * h) / (e * f - u * u)) * u / e;
        }
        return {
            m: t,
            b: n
        };
    }, r.linearRegressionLine = function(r) {
        return function(t) {
            return r.b + r.m * t;
        };
    }, r.logAverage = function(r) {
        if (0 === r.length) throw new Error("logAverage requires at least one data point");
        for(var t = 0, n = 0; n < r.length; n++){
            if (r[n] < 0) throw new Error("logAverage requires only non-negative numbers as input");
            t += Math.log(r[n]);
        }
        return Math.exp(t / r.length);
    }, r.logit = function(r) {
        if (r <= 0 || r >= 1) throw new Error("p must be strictly between zero and one");
        return Math.log(r / (1 - r));
    }, r.mad = q, r.max = f, r.maxSorted = function(r) {
        return r[r.length - 1];
    }, r.mean = n, r.meanSimple = R, r.median = b, r.medianAbsoluteDeviation = q, r.medianSorted = function(r) {
        return s(r, .5);
    }, r.min = h, r.minSorted = function(r) {
        return r[0];
    }, r.mode = function(r) {
        return i(u(r));
    }, r.modeFast = function(r) {
        for(var t, n = new Map, e = 0, a = 0; a < r.length; a++){
            var o = n.get(r[a]);
            void 0 === o ? o = 1 : o++, o > e && (t = r[a], e = o), n.set(r[a], o);
        }
        if (0 === e) throw new Error("mode requires at last one data point");
        return t;
    }, r.modeSorted = i, r.numericSort = u, r.perceptron = V, r.permutationTest = function(r, t, e, a, o) {
        if (void 0 === a && (a = 1e4), void 0 === e && (e = "two_side"), "two_side" !== e && "greater" !== e && "less" !== e) throw new Error("`alternative` must be either 'two_side', 'greater', or 'less'.");
        for(var i = n(r) - n(t), u = new Array(a), h = r.concat(t), f = Math.floor(h.length / 2), l = 0; l < a; l++){
            y(h, o);
            var s = h.slice(0, f), c = h.slice(f, h.length), g = n(s) - n(c);
            u[l] = g;
        }
        var v = 0;
        if ("two_side" === e) for(var p = 0; p <= a; p++)Math.abs(u[p]) >= Math.abs(i) && (v += 1);
        else if ("greater" === e) for(var m = 0; m <= a; m++)u[m] >= i && (v += 1);
        else for(var w = 0; w <= a; w++)u[w] <= i && (v += 1);
        return v / a;
    }, r.permutationsHeap = function(r) {
        for(var t = new Array(r.length), n = [
            r.slice()
        ], e = 0; e < r.length; e++)t[e] = 0;
        for(var a = 0; a < r.length;)if (t[a] < a) {
            var o = 0;
            a % 2 != 0 && (o = t[a]);
            var i = r[o];
            r[o] = r[a], r[a] = i, n.push(r.slice()), t[a]++, a = 0;
        } else t[a] = 0, a++;
        return n;
    }, r.poissonDistribution = function(r) {
        if (!(r <= 0)) {
            var t = 0, n = 0, e = [], a = 1;
            do e[t] = Math.exp(-r) * Math.pow(r, t) / a, n += e[t], a *= ++t;
            while (n < .9999);
            return e;
        }
    }, r.probit = function(r) {
        return 0 === r ? r = F : r >= 1 && (r = .9999), Math.sqrt(2) * Z(2 * r - 1);
    }, r.product = function(r) {
        for(var t = 1, n = 0; n < r.length; n++)t *= r[n];
        return t;
    }, r.quantile = v, r.quantileRank = function(r, t) {
        return M(u(r), t);
    }, r.quantileRankSorted = M, r.quantileSorted = s, r.quickselect = c, r.rSquared = function(r, t) {
        if (r.length < 2) return 1;
        for(var n = 0, e = 0; e < r.length; e++)n += r[e][1];
        for(var a = n / r.length, o = 0, i = 0; i < r.length; i++)o += Math.pow(a - r[i][1], 2);
        for(var u = 0, h = 0; h < r.length; h++)u += Math.pow(r[h][1] - t(r[h][0]), 2);
        return 1 - u / o;
    }, r.relativeError = ur, r.rms = _, r.rootMeanSquare = _, r.sample = x, r.sampleCorrelation = T, r.sampleCovariance = P, r.sampleKurtosis = function(r) {
        var t = r.length;
        if (t < 4) throw new Error("sampleKurtosis requires at least four data points");
        for(var e, a = n(r), o = 0, i = 0, u = 0; u < t; u++)o += (e = r[u] - a) * e, i += e * e * e * e;
        return (t - 1) / ((t - 2) * (t - 3)) * (t * (t + 1) * i / (o * o) - 3 * (t - 1));
    }, r.sampleRankCorrelation = function(r, t) {
        for(var n = r.map(function(r, t) {
            return [
                r,
                t
            ];
        }).sort(function(r, t) {
            return r[0] - t[0];
        }).map(function(r) {
            return r[1];
        }), e = t.map(function(r, t) {
            return [
                r,
                t
            ];
        }).sort(function(r, t) {
            return r[0] - t[0];
        }).map(function(r) {
            return r[1];
        }), a = Array(n.length), o = Array(n.length), i = 0; i < n.length; i++)a[n[i]] = i, o[e[i]] = i;
        return T(a, o);
    }, r.sampleSkewness = function(r) {
        if (r.length < 3) throw new Error("sampleSkewness requires at least three data points");
        for(var t, e = n(r), a = 0, o = 0, i = 0; i < r.length; i++)a += (t = r[i] - e) * t, o += t * t * t;
        var u = r.length - 1, h = Math.sqrt(a / u), f = r.length;
        return f * o / ((f - 1) * (f - 2) * Math.pow(h, 3));
    }, r.sampleStandardDeviation = I, r.sampleVariance = C, r.sampleWithReplacement = function(r, t, n) {
        if (0 === r.length) return [];
        n = n || Math.random;
        for(var e = r.length, a = [], o = 0; o < t; o++){
            var i = Math.floor(n() * e);
            a.push(r[i]);
        }
        return a;
    }, r.shuffle = E, r.shuffleInPlace = y, r.sign = $, r.silhouette = ar, r.silhouetteMetric = function(r, t) {
        return f(ar(r, t));
    }, r.standardDeviation = o, r.standardNormalTable = J, r.subtractFromMean = function(r, t, n) {
        return (r * t - n) / (t - 1);
    }, r.sum = t, r.sumNthPowerDeviations = e, r.sumSimple = l, r.tTest = function(r, t) {
        return (n(r) - t) / (o(r) / Math.sqrt(r.length));
    }, r.tTestTwoSample = function(r, t, e) {
        var a = r.length, o = t.length;
        if (!a || !o) return null;
        e || (e = 0);
        var i = n(r), u = n(t), h = C(r), f = C(t);
        if ("number" == typeof i && "number" == typeof u && "number" == typeof h && "number" == typeof f) {
            var l = ((a - 1) * h + (o - 1) * f) / (a + o - 2);
            return (i - u - e) / Math.sqrt(l * (1 / a + 1 / o));
        }
    }, r.uniqueCountSorted = k, r.variance = a, r.wilcoxonRankSum = function(r, t) {
        if (!r.length || !t.length) throw new Error("Neither sample can be empty");
        for(var n = r.map(function(r) {
            return {
                label: "x",
                value: r
            };
        }).concat(t.map(function(r) {
            return {
                label: "y",
                value: r
            };
        })).sort(function(r, t) {
            return r.value - t.value;
        }), e = 0; e < n.length; e++)n[e].rank = e;
        for(var a = [
            n[0].rank
        ], o = 1; o < n.length; o++)n[o].value === n[o - 1].value ? (a.push(n[o].rank), o === n.length - 1 && i(n, a)) : a.length > 1 ? i(n, a) : a = [
            n[o].rank
        ];
        function i(r, t) {
            for(var n = (t[0] + t[t.length - 1]) / 2, e = 0; e < t.length; e++)r[t[e]].rank = n;
        }
        for(var u = 0, h = 0; h < n.length; h++){
            var f = n[h];
            "x" === f.label && (u += f.rank + 1);
        }
        return u;
    }, r.zScore = function(r, t, n) {
        return (r - t) / n;
    };
});

});





parcelRegister("g6VQn", function(module, exports) {

$parcel$export(module.exports, "actions", () => $bbaa1378f286f6ca$export$e324594224ef24da);

var $8cYiI = parcelRequire("8cYiI");

var $fPGDZ = parcelRequire("fPGDZ");

var $cstaF = parcelRequire("cstaF");

var $9QX0f = parcelRequire("9QX0f");

var $5NVz0 = parcelRequire("5NVz0");

var $bnHw5 = parcelRequire("bnHw5");

var $iCDWi = parcelRequire("iCDWi");

var $90ISC = parcelRequire("90ISC");

var $fVDYX = parcelRequire("fVDYX");

var $eickZ = parcelRequire("eickZ");

var $eHBjM = parcelRequire("eHBjM");

var $jKEVi = parcelRequire("jKEVi");

var $aypMh = parcelRequire("aypMh");
const $bbaa1378f286f6ca$var$suggestedAgentsActions = (set, get)=>({
        setSearchFilterState: (value, filterId, stateId, hasRefreshSearchBtn)=>set((0, $8cYiI.produce)((state)=>{
                const currentModule = get().selectedModule;
                const tabState = (0, $fVDYX.getCurrentTabState)(currentModule, state);
                if (currentModule !== (0, $cstaF.modules).proficiencyMetrics.suggestedAgents) return;
                if (filterId !== (0, $9QX0f.filterIds).display) {
                    tabState[filterId] = {
                        ...tabState[filterId],
                        ...value
                    };
                    return;
                }
                if (filterId === (0, $9QX0f.filterIds).producers && hasRefreshSearchBtn) {
                    tabState.producers = {
                        ...tabState.producers,
                        ...value
                    };
                    return;
                }
                tabState[filterId][stateId] = value;
            }, false, "setSearchFilterState")),
        getCurrentTabSearchOptions: ()=>{
            const searchStoreState = (0, $90ISC.useSearchStore).getState();
            const currentTabId = searchStoreState[searchStoreState.selectedModule]?.currentTabId;
            if (currentTabId === (0, $9QX0f.tabs).todaysPicks.id) return {
                displayOptions: null,
                producerOptions: null
            };
            const { [currentTabId]: currentTabSearchOptions } = searchStoreState[searchStoreState.selectedModule].searchOptions;
            const { display: displayOptions, producers: producerOptions } = currentTabSearchOptions;
            return {
                displayOptions: displayOptions,
                producerOptions: producerOptions
            };
        },
        setSuggestedAgentsData: async ({ setState: setState, mlsId: mlsId, currentTabId: currentTabId })=>{
            if (currentTabId === (0, $9QX0f.tabs).todaysPicks.id) {
                get().setIsLoading(false);
                return;
            }
            try {
                get().setIsLoading(true);
                const shouldNotRank = false;
                const isCoopAgentsOverview = currentTabId === (0, $9QX0f.tabs).coopAgents.id;
                const officeIds = isCoopAgentsOverview ? (0, $90ISC.useCommonStore).getState().privileges?.userOffices.find((o)=>o.mlsId === mlsId)?.officeIds : [
                    ...new Set((0, $90ISC.useCommonStore).getState().privileges?.userOffices.flatMap((obj)=>obj.officeIds))
                ];
                const propertyTypes = await (0, $5NVz0.getPropertyTypes)(mlsId);
                const { producerOptions: producerOptions, displayOptions: displayOptions } = get().getCurrentTabSearchOptions();
                const { getApiService: getApiService, getParameters: getParameters, getProducerValues: getProducerValues } = (0, $9QX0f.searchConfigByTabId)[currentTabId] || (0, $9QX0f.searchConfigFallback);
                const isGrowthAnalysis = displayOptions.selectedView.value === (0, $aypMh.views).growthAnalysis;
                const currentTabProducer = getProducerValues(producerOptions, isGrowthAnalysis);
                const timePeriod = currentTabProducer?.newProd || currentTabProducer?.timePeriod || (0, $cstaF.agentProductionTerms).annually;
                const allResidentialPropertyTypes = (0, $bnHw5.getSearchCriteriaPropertyTypes)(propertyTypes);
                const propertyTypeNames = (0, $bnHw5.getPropertyTypeValues)(allResidentialPropertyTypes, "longName");
                const parameters = getParameters && getParameters(currentTabProducer);
                const searchCriteria = (0, $iCDWi.buildSearchCriteria)({
                    currentTabId: currentTabId,
                    mlsId: mlsId,
                    officeIds: officeIds,
                    propertyTypeIds: (0, $bnHw5.getPropertyTypeValues)(allResidentialPropertyTypes, "typeId"),
                    propertyTypeNames: propertyTypeNames,
                    searchAllMLS: false,
                    timePeriod: timePeriod
                });
                const { recruitingSoldResponse: recruitingSoldResponse, recruitingSoldTotals: recruitingSoldTotals } = await getApiService(searchCriteria, parameters);
                const tabConfig = (0, $9QX0f.tableSettingsByTab)[currentTabId];
                const rowData = tabConfig?.shouldExcludeZeroGrowthAgents ? (0, $fPGDZ.getNonZeroData)(recruitingSoldResponse, (0, $eHBjM.agentsColumns).totalVolumeGrowth.id) : (0, $fPGDZ.getRowDataSortedAndRanked)(recruitingSoldResponse, shouldNotRank, isCoopAgentsOverview);
                get().setSearchCriteria(searchCriteria);
                get().setLoadedSearch();
                const searchResultsStore = (0, $eickZ.useSearchResultsStore).getState();
                searchResultsStore.setSearchResults({
                    results: recruitingSoldResponse,
                    totals: recruitingSoldTotals
                });
                setState((state)=>({
                        ...state,
                        rowDataByTab: {
                            ...state.rowDataByTab,
                            [currentTabId]: {
                                results: rowData.map((d)=>({
                                        ...d,
                                        hasFavStar: true
                                    })),
                                totals: recruitingSoldTotals
                            }
                        },
                        propertyTypeNames: propertyTypeNames,
                        timePeriod: timePeriod
                    }));
            } catch (err) {
                console.error("Error retrieving Suggested Agents data: ", err);
            } finally{
                get().setIsLoading(false);
            }
        },
        setCurrentTabIndex: (currentTabIndex, tabValues)=>set((0, $8cYiI.produce)((state)=>{
                const moduleState = state[get().selectedModule];
                if (moduleState?.currentTabId === undefined) return;
                moduleState.currentTabIndex = currentTabIndex;
                moduleState.currentTabId = tabValues?.[currentTabIndex]?.id;
            }), false, "setSuggestedAgentsCurrentTab"),
        setSelectedRowIndex: (selectedRowIndex)=>set((0, $8cYiI.produce)((state)=>{
                const moduleState = state[get().selectedModule];
                moduleState.selectedRowIndex = selectedRowIndex;
            }), false, "setSelectedRowIndex"),
        setTabDescription: (value)=>set((0, $8cYiI.produce)((state)=>{
                const currentModule = get().selectedModule;
                const tabState = (0, $fVDYX.getCurrentTabState)(currentModule, state);
                tabState.tabDescription = value;
            }), false, "setTabDescription"),
        resetFiltersState: ()=>set((0, $8cYiI.produce)((state)=>{
                const currentModule = get().selectedModule;
                if (currentModule !== (0, $cstaF.modules).proficiencyMetrics.suggestedAgents) return;
                state[currentModule] = state[currentModule] = {
                    ...(0, $jKEVi.initialSearchState)((0, $jKEVi.initialView))[currentModule],
                    currentTabId: state[currentModule]?.currentTabId,
                    currentTabIndex: state[currentModule]?.currentTabIndex,
                    selectedMls: state[currentModule]?.selectedMls
                };
            }), false, "resetFiltersState")
    });
const $bbaa1378f286f6ca$export$e324594224ef24da = (set, get)=>({
        ...$bbaa1378f286f6ca$var$suggestedAgentsActions(set, get),
        setCurrentTab: (currentTab)=>set((0, $8cYiI.produce)((state)=>{
                const moduleState = state[get().selectedModule];
                if (moduleState?.currentTab === undefined) return;
                moduleState.currentTab = currentTab;
            }), false, "setProfMetricsCurrentTab"),
        resetViewHideAgentsFilter: ()=>set((0, $8cYiI.produce)((state)=>{
                const moduleState = state[get().selectedModule];
                if (!moduleState) return;
                moduleState.selectedViewHideAgentsFilter = (0, $eHBjM.viewHideAgentsDropdownLabels).viewHideAgents;
            }), false, "resetViewHideAgentsFilter"),
        resetPMPersistedData: ()=>{
            get().setCurrentTab((0, $fPGDZ.tabIndexes).OVERVIEW);
            get().resetViewHideAgentsFilter();
        },
        setViewHideAgentsFilter: (module, value)=>set((0, $8cYiI.produce)((state)=>{
                const moduleState = state[module];
                if (moduleState?.selectedViewHideAgentsFilter !== undefined) moduleState.selectedViewHideAgentsFilter = value;
            }), false, "setViewHideAgentsFilter"),
        setPMSelectedColumnIds: (updatedColumns, tabMode, isPeriodLast12Months)=>set((0, $8cYiI.produce)((state)=>{
                const selectedModule = get().selectedModule;
                if (!(0, $fPGDZ.persistedMetricsModules).includes(selectedModule)) return;
                const effectiveTabMode = (0, $fPGDZ.getEffectiveTabMode)(tabMode, isPeriodLast12Months);
                const moduleState = state[selectedModule];
                if (!moduleState.selectedColumnIds) moduleState.selectedColumnIds = {};
                if (!moduleState.selectedColumnIds?.[effectiveTabMode]) moduleState.selectedColumnIds[effectiveTabMode] = {};
                moduleState.selectedColumnIds[effectiveTabMode] = {
                    columns: updatedColumns ?? []
                };
            }), false, "setPMSelectedColumnIds"),
        clearPMSelectedColumnIds: ()=>set((0, $8cYiI.produce)((state)=>{
                const selectedModule = get().selectedModule;
                const moduleState = state[selectedModule];
                if (!moduleState) return;
                moduleState.selectedColumnIds = {};
            }), false, "clearPMSelectedColumnIds")
    });

});

parcelRegister("k0fob", function(module, exports) {

$parcel$export(module.exports, "actions", () => $e8ffbea7bbe3435a$export$e324594224ef24da);

var $8cYiI = parcelRequire("8cYiI");

var $cstaF = parcelRequire("cstaF");

var $94cVo = parcelRequire("94cVo");
const $e8ffbea7bbe3435a$export$e324594224ef24da = (set, get)=>({
        setListingType: (listingType)=>set((0, $8cYiI.produce)((state)=>{
                const selectedModule = get().selectedModule;
                if (selectedModule !== (0, $cstaF.modules).marketShare.totals) return;
                const moduleState = state[get().selectedModule];
                moduleState.listingType = listingType;
            }), false, "setMarketShareTotalsListingType"),
        resetMSPersistedData: ()=>set((0, $8cYiI.produce)((state)=>{
                if (get().selectedModule !== (0, $cstaF.modules).marketShare.totals && get().selectedModule !== (0, $cstaF.modules).marketShare.coverage) return;
                const moduleState = state[get().selectedModule];
                moduleState.listingType = undefined;
                moduleState.listingViewId = undefined;
                moduleState.showHideOptions = {};
            })),
        setMSListingViewId: (listingViewId)=>set((0, $8cYiI.produce)((state)=>{
                const selectedModule = get().selectedModule;
                if (selectedModule !== (0, $cstaF.modules).marketShare.totals && selectedModule !== (0, $cstaF.modules).marketShare.coverage) return;
                const moduleState = state[get().selectedModule];
                moduleState.listingViewId = listingViewId;
            }), false, "setMarketShareListingViewId"),
        setMSshowHideOptions: (listingType, listingViewId, updatedOptions)=>set((0, $8cYiI.produce)((state)=>{
                const selectedModule = get().selectedModule;
                if (selectedModule !== (0, $cstaF.modules).marketShare.totals && selectedModule !== (0, $cstaF.modules).marketShare.coverage) return;
                if (!listingViewId) return;
                if (selectedModule === (0, $cstaF.modules).marketShare.totals && !listingType) return;
                const moduleState = state[get().selectedModule];
                if (!moduleState.showHideOptions) moduleState.showHideOptions = {};
                moduleState.showHideOptions[(0, $94cVo.getShowHideKey)(listingType, listingViewId)] = {
                    options: updatedOptions?.options ?? [],
                    columns: updatedOptions?.columns ?? []
                };
            }), false, "setMSshowHideOptions"),
        setMSselectedColumnId: (clickedOptionId)=>set((0, $8cYiI.produce)((state)=>{
                const selectedModule = get().selectedModule;
                if (selectedModule !== (0, $cstaF.modules).marketShare.totals && selectedModule !== (0, $cstaF.modules).marketShare.coverage) return;
                const moduleState = state[get().selectedModule];
                moduleState.selectedColumnId = clickedOptionId;
            }), false, "setMSSelectedColumnId")
    });

});

parcelRegister("1b2v3", function(module, exports) {

$parcel$export(module.exports, "actions", () => $0db8c1ef6b63a113$export$e324594224ef24da);

var $8cYiI = parcelRequire("8cYiI");

var $cstaF = parcelRequire("cstaF");

var $gzAOa = parcelRequire("gzAOa");

var $cL3O2 = parcelRequire("cL3O2");

var $bLQRh = parcelRequire("bLQRh");
const $0db8c1ef6b63a113$export$e324594224ef24da = (set, get)=>({
        setMDListingViewId: (listingViewId)=>set((0, $8cYiI.produce)((state)=>{
                const selectedModule = get().selectedModule;
                if (selectedModule !== (0, $cstaF.modules).marketDynamics.marketDynamics) return;
                const moduleState = state[selectedModule];
                moduleState.listingViewId = listingViewId;
            }), false, "setMarketDynamicsListingViewId"),
        setIsFooterDisabled: (tabIndex, isFooterDisabled, pathname)=>get().setBreakdownTabs([
                {
                    [tabIndex]: {
                        isFooterDisabled: isFooterDisabled
                    }
                }
            ], pathname),
        setTabListingStatus: (tabIndex, listingStatus, pathname)=>get().setBreakdownTabs([
                {
                    [tabIndex]: {
                        listingStatus: listingStatus
                    }
                }
            ], pathname),
        resetDisabledFooterTabs: (pathname)=>get().setBreakdownTabs([
                {
                    [(0, $gzAOa.breakdownTabs).OFFICE]: (0, $gzAOa.initialFooterDisabledState),
                    [(0, $gzAOa.breakdownTabs).LISTING_1]: (0, $gzAOa.initialFooterDisabledState),
                    [(0, $gzAOa.breakdownTabs).LISTING_2]: (0, $gzAOa.initialFooterDisabledState),
                    [(0, $gzAOa.breakdownTabs).LISTING_3]: (0, $gzAOa.initialFooterDisabledState)
                }
            ], pathname),
        setMDListingStatusByView: (listingViewId, options)=>set((0, $8cYiI.produce)((state)=>{
                const selectedModule = get().selectedModule;
                if (selectedModule !== (0, $cstaF.modules).marketDynamics.marketDynamics) return;
                const moduleState = state[(0, $cstaF.modules).marketDynamics.marketDynamics];
                if (!moduleState.listingStatusByView) moduleState.listingStatusByView = {};
                moduleState.listingStatusByView[listingViewId] = options.map(({ id: id, checked: checked })=>({
                        id: id,
                        checked: checked
                    }));
            }), false, "setMDListingStatusByView"),
        clearMDSortByView: (listingViewId)=>set((0, $8cYiI.produce)((state)=>{
                const selectedModule = get().selectedModule;
                if (!state[selectedModule]?.retainedSortStateByView) return;
                delete state[selectedModule].retainedSortStateByView[listingViewId];
            }), false, "clearMDSortByView"),
        resetMDPersistedData: ()=>set((0, $8cYiI.produce)((state)=>{
                if (get().selectedModule !== (0, $cstaF.modules).marketDynamics.marketDynamics) return;
                const moduleState = state[get().selectedModule];
                if (moduleState.listingViewId) moduleState.listingViewId = (0, $cL3O2.listingViews).overview.value;
                moduleState.chartFilters = {
                    selectedPeriodComparison: (0, $bLQRh.periodKeys).beginVsEndMonth
                };
                moduleState.listingStatusByView = {};
                get().resetBreakdowns();
            })),
        mergeStoredOptionsWithDefaults: (defaultOptions, storedOptions)=>{
            return defaultOptions.map((defaultOption)=>{
                const storedOption = storedOptions.find((stored)=>stored.id === defaultOption.id);
                return {
                    ...defaultOption,
                    checked: storedOption ? storedOption.checked : defaultOption.checked || false
                };
            });
        },
        setMDChartFilters: ({ selectedPeriodComparison: selectedPeriodComparison, selectedBeginValue: selectedBeginValue, selectedEndValue: selectedEndValue })=>set((0, $8cYiI.produce)((state)=>{
                const moduleState = state[(0, $cstaF.modules).marketDynamics.marketDynamics];
                if (!moduleState.chartFilters) moduleState.chartFilters = {};
                if (selectedEndValue !== undefined) moduleState.chartFilters.selectedEndValue = selectedEndValue;
                if (selectedPeriodComparison !== undefined) moduleState.chartFilters.selectedPeriodComparison = selectedPeriodComparison;
                if (selectedBeginValue !== undefined) moduleState.chartFilters.selectedBeginValue = selectedBeginValue;
            }), false, "setMDChartFilters")
    });

});

parcelRegister("iIoxY", function(module, exports) {

$parcel$export(module.exports, "actions", () => $d9ff6096b37f4df4$export$e324594224ef24da);

var $24YIE = parcelRequire("24YIE");
const $d9ff6096b37f4df4$export$e324594224ef24da = ()=>({
        getMlsList: async ()=>{
            try {
                return await (0, $24YIE.getAllMlsListInfo)();
            } catch (err) {
                throw new Error(`MLS list fetch error: ${err}`);
            }
        }
    });

});

parcelRegister("6mw4P", function(module, exports) {

$parcel$export(module.exports, "actions", () => $4a1dadf13e2f229c$export$e324594224ef24da);

var $8cYiI = parcelRequire("8cYiI");

var $brSoF = parcelRequire("brSoF");
const $4a1dadf13e2f229c$export$e324594224ef24da = (set, get)=>({
        setSelectedBreakdownTab: (selectedBreakdownTab)=>set((0, $8cYiI.produce)((state)=>{
                const selectedModule = get().selectedModule;
                const moduleState = state[selectedModule];
                if (!Object.keys((0, $brSoF.breakdownModules)).includes(selectedModule)) return;
                moduleState.breakdowns.selectedBreakdownTab = selectedBreakdownTab;
            }), false, "setSelectedBreakdownTab"),
        setBreakdownTabs: (newTabs, pathname)=>set((0, $8cYiI.produce)((state)=>{
                const selectedModule = get().selectedModule;
                const moduleState = state[selectedModule];
                if (!Object.keys((0, $brSoF.breakdownModules)).includes(selectedModule) || !moduleState?.breakdowns?.tabsByRoute) return;
                newTabs.forEach((item)=>{
                    Object.keys(item).forEach((key)=>{
                        // eslint-disable-next-line no-prototype-builtins
                        if (moduleState.breakdowns.tabsByRoute[pathname].hasOwnProperty(key)) moduleState.breakdowns.tabsByRoute[pathname][key] = {
                            ...moduleState.breakdowns.tabsByRoute[pathname][key],
                            ...item[key]
                        };
                        else throw new Error(`Key "${key}" doesn't exist in breakdownTabs.`);
                    });
                });
            }), false, `setBreakdownTabs`),
        setToggleShouldShowAdditionalInfo: (pathname)=>{
            const selectedModule = get().selectedModule;
            const moduleState = get()?.[selectedModule];
            const selectedBreakdownTab = moduleState?.breakdowns.selectedBreakdownTab;
            const prevShouldShowAdditionlInfo = moduleState?.breakdowns?.tabsByRoute[pathname][selectedBreakdownTab]?.shouldShowAdditionalInfo;
            get().setBreakdownTabs([
                {
                    [selectedBreakdownTab]: {
                        shouldShowAdditionalInfo: !prevShouldShowAdditionlInfo
                    }
                }
            ], pathname);
        },
        setSelectedBreakdownOffice: (office)=>set((0, $8cYiI.produce)((state)=>{
                const selectedModule = get().selectedModule;
                const moduleState = state[selectedModule];
                if (!Object.keys((0, $brSoF.breakdownModules)).includes(selectedModule)) return;
                moduleState.breakdowns.selectedBreakdownOffice = office;
            }), false, "setSelectedBreakdownOffice"),
        resetBreakdowns: ()=>set((0, $8cYiI.produce)((state)=>{
                const selectedModule = get().selectedModule;
                const moduleState = state[selectedModule];
                if (!Object.keys((0, $brSoF.breakdownModules)).includes(selectedModule)) return;
                moduleState.breakdowns = (0, $brSoF.breakdownModules)[selectedModule].initialState;
            }), false, "resetBreakdowns")
    });

});
parcelRegister("brSoF", function(module, exports) {

$parcel$export(module.exports, "breakdownModules", () => $855c696cec749b28$export$762334acac368992);

var $53A0d = parcelRequire("53A0d");

var $cstaF = parcelRequire("cstaF");

var $gzAOa = parcelRequire("gzAOa");
const $855c696cec749b28$export$762334acac368992 = {
    [(0, $cstaF.modules).marketDynamics.marketDynamics]: {
        initialState: (0, $gzAOa.initialBreakdownsState)
    },
    [(0, $cstaF.modules).proficiencyMetrics.agentMovement]: {
        initialState: (0, $53A0d.initialBreakdownState)
    }
};

});


parcelRegister("hJEGM", function(module, exports) {

$parcel$export(module.exports, "actions", () => $ce9633a4cfeb4fdb$export$e324594224ef24da);

var $8cYiI = parcelRequire("8cYiI");
const $ce9633a4cfeb4fdb$export$e324594224ef24da = (set, get)=>({
        setSelectedOfficeListSearch: (selectedOfficeListSearch)=>set((0, $8cYiI.produce)((state)=>{
                const moduleState = state[get().selectedModule]?.search;
                if (!moduleState) return;
                state[get().selectedModule].search.selectedOfficeListSearch = selectedOfficeListSearch;
            }), false, "setSelectedOfficeListSearch")
    });

});

parcelRegister("4DJah", function(module, exports) {

$parcel$export(module.exports, "actions", () => $360dd6b97d482aaa$export$e324594224ef24da);

var $8cYiI = parcelRequire("8cYiI");
const $360dd6b97d482aaa$export$e324594224ef24da = (set, get)=>({
        setSelectedViewTypeId: (viewTypeId)=>{
            set((0, $8cYiI.produce)((state)=>{
                const module = state[get().selectedModule];
                module.viewTypeId = viewTypeId;
            }), false, "setSelectedViewTypeId");
        },
        setSelectedOffice: (office)=>{
            set((0, $8cYiI.produce)((state)=>{
                const module = state[get().selectedModule];
                module.selectedOffice = office;
            }), false, "setSelectedOffice");
        }
    });

});

parcelRegister("3X7wA", function(module, exports) {

$parcel$export(module.exports, "tableRetainActions", () => $2e0cb8093983aa35$export$6c3bbb465de1ab46);

var $8cYiI = parcelRequire("8cYiI");

var $dqgmD = parcelRequire("dqgmD");

var $dQwVS = parcelRequire("dQwVS");

var $cstaF = parcelRequire("cstaF");
const $2e0cb8093983aa35$export$6c3bbb465de1ab46 = (set, get)=>({
        getFloatingFilterInputByColId: ()=>{
            const activeElement = document.activeElement;
            const floatingFilters = document.querySelectorAll(".ag-floating-filter");
            const activeFloatingFilter = Array.from(floatingFilters).find((floatingFilter)=>floatingFilter.contains(activeElement));
            return activeFloatingFilter?.querySelector("input") || null;
        },
        getShouldRetainTableByType: ({ tableId: tableId, type: type })=>{
            if (!(0, $dQwVS.validPersistedTypes).includes(type)) return null;
            const selectedModule = get().selectedModule;
            return {
                selectedModule: selectedModule,
                shouldRetain: (0, $dQwVS.retainTableConfigByModule)[selectedModule]?.[type]?.includes(tableId)
            };
        },
        setRetainedFloatingFilterState: ({ tableId: tableId, colName: colName, value: value })=>{
            const selectedModule = get().selectedModule;
            const editedInput = get().getFloatingFilterInputByColId();
            set((state)=>(0, $8cYiI.produce)(state, (draft)=>{
                    const prev = draft[selectedModule]?.retainedFloatingFilter?.[tableId]?.[colName];
                    if (prev === value) return;
                    if (!draft[selectedModule]) draft[selectedModule] = {};
                    if (!draft[selectedModule].retainedFloatingFilter) draft[selectedModule].retainedFloatingFilter = {};
                    if (!draft[selectedModule].retainedFloatingFilter[tableId]) draft[selectedModule].retainedFloatingFilter[tableId] = {};
                    draft[selectedModule].retainedFloatingFilter[tableId][colName] = value;
                    if (editedInput?.focus) setTimeout(()=>editedInput.focus(), 10); // workaround to avoid focus loss.
                }));
        },
        setRetainedSortState: ({ tableId: tableId, sortState: sortState })=>{
            const selectedModule = get().selectedModule;
            set((state)=>{
                const prev = state[selectedModule]?.retainedSortStateByView?.[tableId];
                if (prev && prev.colId === sortState.colId && prev.sort === sortState.sort) return state;
                return {
                    [selectedModule]: {
                        ...state[selectedModule],
                        retainedSortStateByView: {
                            ...state[selectedModule]?.retainedSortStateByView,
                            [tableId]: sortState
                        }
                    }
                };
            });
        },
        setTableRetainedStateByType: ({ tableId: tableId, type: type, sortState: sortState, colName: colName, value: value })=>{
            const { shouldRetain: shouldRetain } = get().getShouldRetainTableByType({
                tableId: tableId,
                type: type
            });
            if (!shouldRetain) return;
            if (type === (0, $dQwVS.retainTerms).sort) get().setRetainedSortState({
                tableId: tableId,
                sortState: sortState
            });
            if (type === (0, $dQwVS.retainTerms).floatingFilter) get().setRetainedFloatingFilterState({
                tableId: tableId,
                colName: colName,
                value: value
            });
        },
        getTableRetainedStateByType: ({ tableId: tableId, type: type })=>{
            const { selectedModule: selectedModule, shouldRetain: shouldRetain } = get().getShouldRetainTableByType({
                tableId: tableId,
                type: type
            });
            if (!shouldRetain) return null;
            if (type === (0, $dQwVS.retainTerms).sort) return get()[selectedModule]?.retainedSortStateByView?.[tableId] || null;
            if (type === (0, $dQwVS.retainTerms).floatingFilter) return get()[selectedModule]?.retainedFloatingFilter?.[tableId] || null;
        },
        restoreTableRetainedStateByType: ({ api: api, tableId: tableId, type: type })=>{
            const storedState = get().getTableRetainedStateByType({
                tableId: tableId,
                type: type
            });
            if (!storedState) return;
            if (type === (0, $dQwVS.retainTerms).sort) (0, $dqgmD.setAgGridSort)({
                api: api,
                sortState: storedState
            });
            if (type === (0, $dQwVS.retainTerms).floatingFilter) (0, $dqgmD.setAgGridFloatingFilter)({
                api: api,
                filterState: storedState
            });
        },
        handleFloatingFilterRetain: ({ tableViewId: tableViewId, api: api, setTableRetainedStateByType: setTableRetainedStateByType })=>{
            const selectedModule = get().selectedModule;
            if ((0, $dQwVS.retainTableConfigByModule)[selectedModule]?.floatingFilter?.includes(tableViewId)) {
                const filterModel = api.getFilterModel();
                const savedFilters = get()[selectedModule]?.retainedFloatingFilter?.[tableViewId] || {};
                Object.keys(savedFilters).forEach((colName)=>{
                    const currentFilter = filterModel[colName];
                    if (!currentFilter || !currentFilter.filter) setTableRetainedStateByType({
                        tableId: tableViewId,
                        type: (0, $dQwVS.retainTerms).floatingFilter,
                        colName: colName,
                        value: ""
                    });
                });
                Object.entries(filterModel).forEach(([colName, filterConfig])=>{
                    if (filterConfig.filter) setTableRetainedStateByType({
                        tableId: tableViewId,
                        type: (0, $dQwVS.retainTerms).floatingFilter,
                        colName: colName,
                        value: filterConfig.filter
                    });
                });
            }
        },
        setCrossSortOrder: (rowData, sourceTableId, sortedColId = null, sortDirection = null)=>set((0, $8cYiI.produce)((state)=>{
                const selectedModule = get().selectedModule;
                const sortOrder = {};
                rowData.forEach((agent, index)=>{
                    sortOrder[agent.agentId] = index;
                });
                state[selectedModule].crossSortOrder = sortOrder;
                state[selectedModule].crossSortSourceTableId = sourceTableId;
                state[selectedModule].crossSortColId = sortedColId;
                state[selectedModule].crossSortDirection = sortDirection;
            }), false, "setCrossSortOrder"),
        setSelectedAgentIds: (agentIds)=>set((0, $8cYiI.produce)((state)=>{
                const selectedModule = get().selectedModule;
                if (selectedModule === (0, $cstaF.modules).proficiencyMetrics.suggestedAgents) state[selectedModule].selectedAgentIdsByTab[state[selectedModule].currentTabId] = agentIds;
                else state[selectedModule].selectedAgentIds = agentIds;
            }), false, "setSelectedAgentIds"),
        clearSelectedAgentIds: ()=>set((0, $8cYiI.produce)((state)=>{
                const selectedModule = get().selectedModule;
                if (selectedModule === (0, $cstaF.modules).proficiencyMetrics.suggestedAgents && state[selectedModule]?.currentTabId) state[selectedModule].selectedAgentIdsByTab[state[selectedModule].currentTabId] = [];
                else state[selectedModule].selectedAgentIds = [];
            }), false, "clearSelectedAgentIds"),
        sortByStoredOrder: (agentData)=>{
            const selectedModule = get().selectedModule;
            const crossSortOrder = get()[selectedModule]?.crossSortOrder;
            if (!agentData) return [];
            if (!crossSortOrder || !Object.keys(crossSortOrder).length || Object.keys(agentData).length === 0) return agentData;
            return [
                ...agentData
            ].sort((a, b)=>{
                const positionA = crossSortOrder[a.agentId] ?? Infinity;
                const positionB = crossSortOrder[b.agentId] ?? Infinity;
                return positionA - positionB;
            });
        }
    });

});
parcelRegister("dQwVS", function(module, exports) {

$parcel$export(module.exports, "retainTerms", () => $a149ad6842200b30$export$d225bff7a6d44633);
$parcel$export(module.exports, "validPersistedTypes", () => $a149ad6842200b30$export$6abbb88f9cdafd9d);
$parcel$export(module.exports, "retainTableConfigByModule", () => $a149ad6842200b30$export$a743a68c76b695f0);

var $eHBjM = parcelRequire("eHBjM");

var $3etjB = parcelRequire("3etjB");

var $cstaF = parcelRequire("cstaF");

var $bLQRh = parcelRequire("bLQRh");
const $a149ad6842200b30$export$d225bff7a6d44633 = Object.freeze({
    sort: "sort",
    floatingFilter: "floatingFilter",
    retainedSortByModule: "retainedSortByModule",
    retainedFloatingFilterByModule: "retainedFloatingFilterByModule"
});
const $a149ad6842200b30$export$6abbb88f9cdafd9d = [
    $a149ad6842200b30$export$d225bff7a6d44633.sort,
    $a149ad6842200b30$export$d225bff7a6d44633.floatingFilter
];
const $a149ad6842200b30$var$defaultTableViews = [
    (0, $eHBjM.tableViewNames).overview,
    (0, $eHBjM.tableViewNames).contactInformation,
    (0, $eHBjM.tableViewNames).growthAnalysisLtm,
    (0, $eHBjM.tableViewNames).growthAnalysisYtd,
    (0, $eHBjM.tableViewNames).listingProficiency
];
const $a149ad6842200b30$var$marketDynamicsTableViews = [
    (0, $bLQRh.marketDynamicsTableViewNames).avgPriceSqft,
    (0, $bLQRh.marketDynamicsTableViewNames).avgDomCdom,
    (0, $bLQRh.marketDynamicsTableViewNames).avgSpLpComparison,
    (0, $bLQRh.marketDynamicsTableViewNames).avgSpOpAllProperties,
    (0, $bLQRh.marketDynamicsTableViewNames).avgSpOpComparison,
    (0, $bLQRh.marketDynamicsTableViewNames).cdomBreakout,
    (0, $bLQRh.marketDynamicsTableViewNames).forSaleVsFsldm,
    (0, $bLQRh.marketDynamicsTableViewNames).medianPrice,
    (0, $bLQRh.marketDynamicsTableViewNames).monthlySupplyOfInventory,
    (0, $bLQRh.marketDynamicsTableViewNames).salesAbsorption,
    (0, $bLQRh.marketDynamicsTableViewNames).soldAvgVsMedianPrice,
    (0, $bLQRh.marketDynamicsTableViewNames).supplyAmpDemandNumUnits,
    (0, $bLQRh.marketDynamicsTableViewNames).underContractUc,
    (0, $bLQRh.marketDynamicsTableViewNames).newListings,
    (0, $bLQRh.marketDynamicsTableViewNames).forSale,
    (0, $bLQRh.marketDynamicsTableViewNames).forSaleLdm,
    (0, $bLQRh.marketDynamicsTableViewNames).underContract,
    (0, $bLQRh.marketDynamicsTableViewNames).sold,
    (0, $bLQRh.marketDynamicsTableViewNames).expired
];
const $a149ad6842200b30$export$a743a68c76b695f0 = {
    [(0, $cstaF.modules).proficiencyMetrics.transactions]: {
        floatingFilter: $a149ad6842200b30$var$defaultTableViews
    },
    [(0, $cstaF.modules).proficiencyMetrics.offices]: {
        floatingFilter: $a149ad6842200b30$var$defaultTableViews
    },
    [(0, $cstaF.modules).proficiencyMetrics.agents]: {
        floatingFilter: $a149ad6842200b30$var$defaultTableViews
    },
    [(0, $cstaF.modules).proficiencyMetrics.savedAgents]: {
        floatingFilter: $a149ad6842200b30$var$defaultTableViews
    },
    [(0, $cstaF.modules).marketShare.totals]: {
        floatingFilter: (0, $3etjB.msTableViewNames).totals
    },
    [(0, $cstaF.modules).marketDynamics.marketDynamics]: {
        sort: $a149ad6842200b30$var$marketDynamicsTableViews
    }
};

});


parcelRegister("385ED", function(module, exports) {

$parcel$export(module.exports, "dashboardView", () => $247681491f469d79$export$366aa864aad9555d);

var $cstaF = parcelRequire("cstaF");

var $4EYT7 = parcelRequire("4EYT7");
const $247681491f469d79$export$366aa864aad9555d = (initialView)=>({
        ...initialView,
        id: (0, $cstaF.modules).dashboard.dashboard,
        searchFilters: [
            (0, $cstaF.searchTerms).mlsFilter
        ],
        viewTypeId: (0, $4EYT7.viewTypes).byOffice.id,
        selectedOffice: {}
    });

});


parcelRegister("7JB23", function(module, exports) {
/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */ /* global Reflect, Promise */ var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    function __extends(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }
    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for(var s, i = 1, n = arguments.length; i < n; i++){
                s = arguments[i];
                for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };
    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }
    function __generator(thisArg, body) {
        var _ = {
            label: 0,
            sent: function() {
                if (t[0] & 1) throw t[1];
                return t[1];
            },
            trys: [],
            ops: []
        }, f, y, t, g;
        return g = {
            next: verb(0),
            "throw": verb(1),
            "return": verb(2)
        }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
            return this;
        }), g;
        function verb(n) {
            return function(v) {
                return step([
                    n,
                    v
                ]);
            };
        }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while(_)try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [
                    op[0] & 2,
                    t.value
                ];
                switch(op[0]){
                    case 0:
                    case 1:
                        t = op;
                        break;
                    case 4:
                        _.label++;
                        return {
                            value: op[1],
                            done: false
                        };
                    case 5:
                        _.label++;
                        y = op[1];
                        op = [
                            0
                        ];
                        continue;
                    case 7:
                        op = _.ops.pop();
                        _.trys.pop();
                        continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                            _ = 0;
                            continue;
                        }
                        if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                            _.label = op[1];
                            break;
                        }
                        if (op[0] === 6 && _.label < t[1]) {
                            _.label = t[1];
                            t = op;
                            break;
                        }
                        if (t && _.label < t[2]) {
                            _.label = t[2];
                            _.ops.push(op);
                            break;
                        }
                        if (t[2]) _.ops.pop();
                        _.trys.pop();
                        continue;
                }
                op = body.call(thisArg, _);
            } catch (e) {
                op = [
                    6,
                    e
                ];
                y = 0;
            } finally{
                f = t = 0;
            }
            if (op[0] & 5) throw op[1];
            return {
                value: op[0] ? op[1] : void 0,
                done: true
            };
        }
    }
    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) {
            for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || from);
    }
    var Bounds = /** @class */ function() {
        function Bounds(left, top, width, height) {
            this.left = left;
            this.top = top;
            this.width = width;
            this.height = height;
        }
        Bounds.prototype.add = function(x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function(context, clientRect) {
            return new Bounds(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
        };
        Bounds.fromDOMRectList = function(context, domRectList) {
            var domRect = Array.from(domRectList).find(function(rect) {
                return rect.width !== 0;
            });
            return domRect ? new Bounds(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height) : Bounds.EMPTY;
        };
        Bounds.EMPTY = new Bounds(0, 0, 0, 0);
        return Bounds;
    }();
    var parseBounds = function(context, node) {
        return Bounds.fromClientRect(context, node.getBoundingClientRect());
    };
    var parseDocumentSize = function(document1) {
        var body = document1.body;
        var documentElement = document1.documentElement;
        if (!body || !documentElement) throw new Error("Unable to get document size");
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };
    /*
     * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var toCodePoints$1 = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint$1 = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return "";
        var codeUnits = [];
        var index = -1;
        var result = "";
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars$2 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup$2 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i$2 = 0; i$2 < chars$2.length; i$2++)lookup$2[chars$2.charCodeAt(i$2)] = i$2;
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1$1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup$1$1 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++)lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
    var decode$1 = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === "=") {
            bufferLength--;
            if (base64[base64.length - 2] === "=") bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined" && typeof Uint8Array.prototype.slice !== "undefined" ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1$1[base64.charCodeAt(i)];
            encoded2 = lookup$1$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array$1 = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2$1 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1$1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT$1 = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
    var slice16$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32$1 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64$1 = function(base64, _byteLength) {
        var buffer = decode$1(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16$1(view16, (headerLength + view32[4]) / 2) : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie$1 = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + (codePoint - 0xd800 >> UTRIE2_SHIFT_2$1)];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2$1 & UTRIE2_INDEX_2_MASK$1;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$3 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup$3 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i$3 = 0; i$3 < chars$3.length; i$3++)lookup$3[chars$3.charCodeAt(i$3)] = i$3;
    var base64$1 = "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";
    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR$1 = 2; //  Cause a line break (after), except between CR and LF
    var LF$1 = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var ea_OP = [
        0x2329,
        0xff08
    ];
    var BREAK_MANDATORY = "!";
    var BREAK_NOT_ALLOWED$1 = "\xd7";
    var BREAK_ALLOWED$1 = "\xf7";
    var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
    var ALPHABETICS = [
        AL,
        HL
    ];
    var HARD_LINE_BREAKS = [
        BK,
        CR$1,
        LF$1,
        NL
    ];
    var SPACE$1 = [
        SP,
        ZW
    ];
    var PREFIX_POSTFIX = [
        PR,
        PO
    ];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
    var KOREAN_SYLLABLE_BLOCK = [
        JL,
        JV,
        JT,
        H2,
        H3
    ];
    var HYPHEN = [
        HY,
        BA
    ];
    var codePointsToCharacterClasses = function(codePoints, lineBreak) {
        if (lineBreak === void 0) lineBreak = "strict";
        var types = [];
        var indices = [];
        var categories = [];
        codePoints.forEach(function(codePoint, index) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            } else categories.push(false);
            if ([
                "normal",
                "auto",
                "loose"
            ].indexOf(lineBreak) !== -1) // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
            {
                if ([
                    0x2010,
                    0x2013,
                    0x301c,
                    0x30a0
                ].indexOf(codePoint) !== -1) {
                    indices.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ$1) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indices.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indices.push(indices[index - 1]);
                    return types.push(prev);
                }
                indices.push(index);
                return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) return types.push(lineBreak === "strict" ? NS : ID);
            if (classType === SA) return types.push(AL);
            if (classType === AI) return types.push(AL);
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if (codePoint >= 0x20000 && codePoint <= 0x2fffd || codePoint >= 0x30000 && codePoint <= 0x3fffd) return types.push(ID);
                else return types.push(AL);
            }
            types.push(classType);
        });
        return [
            indices,
            types,
            categories
        ];
    };
    var isAdjacentWithSpaceIgnored = function(a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while(i <= classTypes.length){
                i++;
                var next = classTypes[i];
                if (next === b) return true;
                if (next !== SP) break;
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while(i > 0){
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while(n <= classTypes.length){
                        n++;
                        var next = classTypes[n];
                        if (next === b) return true;
                        if (next !== SP) break;
                    }
                }
                if (prev !== SP) break;
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function(currentIndex, classTypes) {
        var i = currentIndex;
        while(i >= 0){
            var type = classTypes[i];
            if (type === SP) i--;
            else return type;
        }
        return 0;
    };
    var _lineBreakAtIndex = function(codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) return BREAK_NOT_ALLOWED$1;
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) return BREAK_NOT_ALLOWED$1;
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR$1 && next === LF$1) return BREAK_NOT_ALLOWED$1;
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) return BREAK_MANDATORY;
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB7 Do not break before spaces or zero width space.
        if (SPACE$1.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) return BREAK_ALLOWED$1;
        // LB8a Do not break after a zero width joiner.
        if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // zwj emojis
        if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) return BREAK_NOT_ALLOWED$1;
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) return BREAK_NOT_ALLOWED$1;
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) return BREAK_NOT_ALLOWED$1;
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([
            SP,
            BA,
            HY
        ].indexOf(current) === -1 && next === GL) return BREAK_NOT_ALLOWED$1;
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([
            CL,
            CP,
            EX,
            IS,
            SY
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) return BREAK_NOT_ALLOWED$1;
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([
            CL,
            CP
        ], NS, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) return BREAK_NOT_ALLOWED$1;
        // LB18 Break after spaces.
        if (current === SP) return BREAK_ALLOWED$1;
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) return BREAK_NOT_ALLOWED$1;
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) return BREAK_ALLOWED$1;
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([
            BA,
            HY,
            NS
        ].indexOf(next) !== -1 || current === BB) return BREAK_NOT_ALLOWED$1;
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) return BREAK_NOT_ALLOWED$1;
        // LB22 Do not break before ellipsis.
        if (next === IN) return BREAK_NOT_ALLOWED$1;
        // LB23 Do not break between digits and letters.
        if (ALPHABETICS.indexOf(next) !== -1 && current === NU || ALPHABETICS.indexOf(current) !== -1 && next === NU) return BREAK_NOT_ALLOWED$1;
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if (current === PR && [
            ID,
            EB,
            EM
        ].indexOf(next) !== -1 || [
            ID,
            EB,
            EM
        ].indexOf(current) !== -1 && next === PO) return BREAK_NOT_ALLOWED$1;
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if (ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1 || PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (// (PR | PO) × ( OP | HY )? NU
        [
            PR,
            PO
        ].indexOf(current) !== -1 && (next === NU || [
            OP,
            HY
        ].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU) || // ( OP | HY ) × NU
        [
            OP,
            HY
        ].indexOf(current) !== -1 && next === NU || // NU ×	(NU | SY | IS)
        current === NU && [
            NU,
            SY,
            IS
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([
            NU,
            SY,
            IS,
            CL,
            CP
        ].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([
            PR,
            PO
        ].indexOf(next) !== -1) {
            var prevIndex = [
                CL,
                CP
            ].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while(prevIndex >= 0){
                var type = classTypes[prevIndex];
                if (type === NU) return BREAK_NOT_ALLOWED$1;
                else if ([
                    SY,
                    IS
                ].indexOf(type) !== -1) prevIndex--;
                else break;
            }
        }
        // LB26 Do not break a Korean syllable.
        if (JL === current && [
            JL,
            JV,
            H2,
            H3
        ].indexOf(next) !== -1 || [
            JV,
            H2
        ].indexOf(current) !== -1 && [
            JV,
            JT
        ].indexOf(next) !== -1 || [
            JT,
            H3
        ].indexOf(current) !== -1 && next === JT) return BREAK_NOT_ALLOWED$1;
        // LB27 Treat a Korean Syllable Block the same as ID.
        if (KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [
            IN,
            PO
        ].indexOf(next) !== -1 || KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR) return BREAK_NOT_ALLOWED$1;
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) return BREAK_NOT_ALLOWED$1;
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if (ALPHABETICS.concat(NU).indexOf(current) !== -1 && next === OP && ea_OP.indexOf(codePoints[afterIndex]) === -1 || ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP) return BREAK_NOT_ALLOWED$1;
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI$1 && next === RI$1) {
            var i = indicies[currentIndex];
            var count = 1;
            while(i > 0){
                i--;
                if (classTypes[i] === RI$1) count++;
                else break;
            }
            if (count % 2 !== 0) return BREAK_NOT_ALLOWED$1;
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) return BREAK_NOT_ALLOWED$1;
        return BREAK_ALLOWED$1;
    };
    var cssFormattedClasses = function(codePoints, options) {
        if (!options) options = {
            lineBreak: "normal",
            wordBreak: "normal"
        };
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === "break-all" || options.wordBreak === "break-word") classTypes = classTypes.map(function(type) {
            return [
                NU,
                AL,
                SA
            ].indexOf(type) !== -1 ? ID : type;
        });
        var forbiddenBreakpoints = options.wordBreak === "keep-all" ? isLetterNumber.map(function(letterNumber, i) {
            return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
        }) : undefined;
        return [
            indicies,
            classTypes,
            forbiddenBreakpoints
        ];
    };
    var Break = /** @class */ function() {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function() {
            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }();
    var LineBreaker = function(str, options) {
        var codePoints = toCodePoints$1(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function() {
                if (nextIndex >= length) return {
                    done: true,
                    value: null
                };
                var lineBreak = BREAK_NOT_ALLOWED$1;
                while(nextIndex < length && (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) === BREAK_NOT_ALLOWED$1);
                if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    // https://www.w3.org/TR/css-syntax-3
    var FLAG_UNRESTRICTED = 1;
    var FLAG_ID = 2;
    var FLAG_INTEGER = 4;
    var FLAG_NUMBER = 8;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function(codePoint) {
        return codePoint >= ZERO && codePoint <= 0x0039;
    };
    var isSurrogateCodePoint = function(codePoint) {
        return codePoint >= 0xd800 && codePoint <= 0xdfff;
    };
    var isHex = function(codePoint) {
        return isDigit(codePoint) || codePoint >= A && codePoint <= F || codePoint >= a && codePoint <= f;
    };
    var isLowerCaseLetter = function(codePoint) {
        return codePoint >= a && codePoint <= z;
    };
    var isUpperCaseLetter = function(codePoint) {
        return codePoint >= A && codePoint <= Z;
    };
    var isLetter = function(codePoint) {
        return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint);
    };
    var isNonASCIICodePoint = function(codePoint) {
        return codePoint >= CONTROL;
    };
    var isWhiteSpace = function(codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
    };
    var isNameStartCodePoint = function(codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function(codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function(codePoint) {
        return codePoint >= NULL && codePoint <= BACKSPACE || codePoint === LINE_TABULATION || codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE || codePoint === DELETE;
    };
    var isValidEscape = function(c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) return false;
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function(c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        else if (isNameStartCodePoint(c1)) return true;
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) return true;
        return false;
    };
    var isNumberStart = function(c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) return true;
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) return isDigit(c2);
        return isDigit(c1);
    };
    var stringToNumber = function(codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) sign = -1;
            c++;
        }
        var integers = [];
        while(isDigit(codePoints[c]))integers.push(codePoints[c++]);
        var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) c++;
        var fraction = [];
        while(isDigit(codePoints[c]))fraction.push(codePoints[c++]);
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) c++;
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) expsign = -1;
            c++;
        }
        var exponent = [];
        while(isDigit(codePoints[c]))exponent.push(codePoints[c++]);
        var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: 2 /* LEFT_PARENTHESIS_TOKEN */ 
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: 3 /* RIGHT_PARENTHESIS_TOKEN */ 
    };
    var COMMA_TOKEN = {
        type: 4 /* COMMA_TOKEN */ 
    };
    var SUFFIX_MATCH_TOKEN = {
        type: 13 /* SUFFIX_MATCH_TOKEN */ 
    };
    var PREFIX_MATCH_TOKEN = {
        type: 8 /* PREFIX_MATCH_TOKEN */ 
    };
    var COLUMN_TOKEN = {
        type: 21 /* COLUMN_TOKEN */ 
    };
    var DASH_MATCH_TOKEN = {
        type: 9 /* DASH_MATCH_TOKEN */ 
    };
    var INCLUDE_MATCH_TOKEN = {
        type: 10 /* INCLUDE_MATCH_TOKEN */ 
    };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: 11 /* LEFT_CURLY_BRACKET_TOKEN */ 
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */ 
    };
    var SUBSTRING_MATCH_TOKEN = {
        type: 14 /* SUBSTRING_MATCH_TOKEN */ 
    };
    var BAD_URL_TOKEN = {
        type: 23 /* BAD_URL_TOKEN */ 
    };
    var BAD_STRING_TOKEN = {
        type: 1 /* BAD_STRING_TOKEN */ 
    };
    var CDO_TOKEN = {
        type: 25 /* CDO_TOKEN */ 
    };
    var CDC_TOKEN = {
        type: 24 /* CDC_TOKEN */ 
    };
    var COLON_TOKEN = {
        type: 26 /* COLON_TOKEN */ 
    };
    var SEMICOLON_TOKEN = {
        type: 27 /* SEMICOLON_TOKEN */ 
    };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */ 
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ 
    };
    var WHITESPACE_TOKEN = {
        type: 31 /* WHITESPACE_TOKEN */ 
    };
    var EOF_TOKEN = {
        type: 32 /* EOF_TOKEN */ 
    };
    var Tokenizer = /** @class */ function() {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function(chunk) {
            this._value = this._value.concat(toCodePoints$1(chunk));
        };
        Tokenizer.prototype.read = function() {
            var tokens = [];
            var token = this.consumeToken();
            while(token !== EOF_TOKEN){
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function() {
            var codePoint = this.consumeCodePoint();
            switch(codePoint){
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return {
                            type: 5 /* HASH_TOKEN */ ,
                            value: value,
                            flags: flags
                        };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while(true){
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) return this.consumeToken();
                            }
                            if (c === EOF) return this.consumeToken();
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK && this.peekCodePoint(1) === HYPHEN_MINUS && this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return {
                            type: 7 /* AT_KEYWORD_TOKEN */ ,
                            value: value
                        };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return {
                type: 6 /* DELIM_TOKEN */ ,
                value: fromCodePoint$1(codePoint)
            };
        };
        Tokenizer.prototype.consumeCodePoint = function() {
            var value = this._value.shift();
            return typeof value === "undefined" ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function(codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function(delta) {
            if (delta >= this._value.length) return -1;
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function() {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while(isHex(codePoint) && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while(codePoint === QUESTION_MARK && digits.length < 6){
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? ZERO : digit;
                })), 16);
                var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function(digit) {
                    return digit === QUESTION_MARK ? F : digit;
                })), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start_1,
                    end: end
                };
            }
            var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while(isHex(codePoint) && endDigits.length < 6){
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
                return {
                    type: 30 /* UNICODE_RANGE_TOKEN */ ,
                    start: start,
                    end: end
                };
            } else return {
                type: 30 /* UNICODE_RANGE_TOKEN */ ,
                start: start,
                end: start
            };
        };
        Tokenizer.prototype.consumeIdentLikeToken = function() {
            var value = this.consumeName();
            if (value.toLowerCase() === "url" && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            } else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return {
                    type: 19 /* FUNCTION_TOKEN */ ,
                    value: value
                };
            }
            return {
                type: 20 /* IDENT_TOKEN */ ,
                value: value
            };
        };
        Tokenizer.prototype.consumeUrlToken = function() {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) return {
                type: 22 /* URL_TOKEN */ ,
                value: ""
            };
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === 0 /* STRING_TOKEN */ ) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: stringToken.value
                        };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) return {
                    type: 22 /* URL_TOKEN */ ,
                    value: fromCodePoint$1.apply(void 0, value)
                };
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return {
                            type: 22 /* URL_TOKEN */ ,
                            value: fromCodePoint$1.apply(void 0, value)
                        };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === QUOTATION_MARK || codePoint === APOSTROPHE || codePoint === LEFT_PARENTHESIS || isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                } else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) value.push(this.consumeEscapedCodePoint());
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                } else value.push(codePoint);
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function() {
            while(isWhiteSpace(this.peekCodePoint(0)))this.consumeCodePoint();
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function() {
            while(true){
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) return;
                if (isValidEscape(codePoint, this.peekCodePoint(0))) this.consumeEscapedCodePoint();
            }
        };
        Tokenizer.prototype.consumeStringSlice = function(count) {
            var SLICE_STACK_SIZE = 50000;
            var value = "";
            while(count > 0){
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function(endingCodePoint) {
            var value = "";
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return {
                        type: 0 /* STRING_TOKEN */ ,
                        value: value
                    };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        } else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint$1(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            }while (true);
        };
        Tokenizer.prototype.consumeNumber = function() {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) repr.push(this.consumeCodePoint());
            while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && ((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while(isDigit(this.peekCodePoint(0)))repr.push(this.consumeCodePoint());
            }
            return [
                stringToNumber(repr),
                type
            ];
        };
        Tokenizer.prototype.consumeNumericToken = function() {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return {
                    type: 15 /* DIMENSION_TOKEN */ ,
                    number: number,
                    flags: flags,
                    unit: unit
                };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return {
                    type: 16 /* PERCENTAGE_TOKEN */ ,
                    number: number,
                    flags: flags
                };
            }
            return {
                type: 17 /* NUMBER_TOKEN */ ,
                number: number,
                flags: flags
            };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function() {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint$1(codePoint);
                while(isHex(this.peekCodePoint(0)) && hex.length < 6)hex += fromCodePoint$1(this.consumeCodePoint());
                if (isWhiteSpace(this.peekCodePoint(0))) this.consumeCodePoint();
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) return REPLACEMENT_CHARACTER;
                return hexCodePoint;
            }
            if (codePoint === EOF) return REPLACEMENT_CHARACTER;
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function() {
            var result = "";
            while(true){
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) result += fromCodePoint$1(codePoint);
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) result += fromCodePoint$1(this.consumeEscapedCodePoint());
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }();
    var Parser = /** @class */ function() {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function(value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function(value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function(value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function() {
            var token = this.consumeToken();
            while(token.type === 31 /* WHITESPACE_TOKEN */ )token = this.consumeToken();
            if (token.type === 32 /* EOF_TOKEN */ ) throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do token = this.consumeToken();
            while (token.type === 31 /* WHITESPACE_TOKEN */ );
            if (token.type === 32 /* EOF_TOKEN */ ) return value;
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function() {
            var values = [];
            while(true){
                var value = this.consumeComponentValue();
                if (value.type === 32 /* EOF_TOKEN */ ) return values;
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function() {
            var token = this.consumeToken();
            switch(token.type){
                case 11 /* LEFT_CURLY_BRACKET_TOKEN */ :
                case 28 /* LEFT_SQUARE_BRACKET_TOKEN */ :
                case 2 /* LEFT_PARENTHESIS_TOKEN */ :
                    return this.consumeSimpleBlock(token.type);
                case 19 /* FUNCTION_TOKEN */ :
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function(type) {
            var block = {
                type: type,
                values: []
            };
            var token = this.consumeToken();
            while(true){
                if (token.type === 32 /* EOF_TOKEN */  || isEndingTokenFor(token, type)) return block;
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function(functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: 18 /* FUNCTION */ 
            };
            while(true){
                var token = this.consumeToken();
                if (token.type === 32 /* EOF_TOKEN */  || token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ) return cssFunction;
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function() {
            var token = this._tokens.shift();
            return typeof token === "undefined" ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function(token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }();
    var isDimensionToken = function(token) {
        return token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isNumberToken = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */ ;
    };
    var isIdentToken = function(token) {
        return token.type === 20 /* IDENT_TOKEN */ ;
    };
    var isStringToken = function(token) {
        return token.type === 0 /* STRING_TOKEN */ ;
    };
    var isIdentWithValue = function(token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */ ;
    };
    var nonFunctionArgSeparator = function(token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */  && token.type !== 4 /* COMMA_TOKEN */ ;
    };
    var parseFunctionArgs = function(tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function(token) {
            if (token.type === 4 /* COMMA_TOKEN */ ) {
                if (arg.length === 0) throw new Error("Error parsing function args, zero tokens for arg");
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== 31 /* WHITESPACE_TOKEN */ ) arg.push(token);
        });
        if (arg.length) args.push(arg);
        return args;
    };
    var isEndingTokenFor = function(token, type) {
        if (type === 11 /* LEFT_CURLY_BRACKET_TOKEN */  && token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */ ) return true;
        if (type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */  && token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */ ) return true;
        return type === 2 /* LEFT_PARENTHESIS_TOKEN */  && token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */ ;
    };
    var isLength = function(token) {
        return token.type === 17 /* NUMBER_TOKEN */  || token.type === 15 /* DIMENSION_TOKEN */ ;
    };
    var isLengthPercentage = function(token) {
        return token.type === 16 /* PERCENTAGE_TOKEN */  || isLength(token);
    };
    var parseLengthPercentageTuple = function(tokens) {
        return tokens.length > 1 ? [
            tokens[0],
            tokens[1]
        ] : [
            tokens[0]
        ];
    };
    var ZERO_LENGTH = {
        type: 17 /* NUMBER_TOKEN */ ,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function(tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [
            getAbsoluteValue(x, width),
            getAbsoluteValue(typeof y !== "undefined" ? y : x, height)
        ];
    };
    var getAbsoluteValue = function(token, parent) {
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) return token.number / 100 * parent;
        if (isDimensionToken(token)) switch(token.unit){
            case "rem":
            case "em":
                return 16 * token.number; // TODO use correct font-size
            case "px":
            default:
                return token.number;
        }
        return token.number;
    };
    var DEG = "deg";
    var GRAD = "grad";
    var RAD = "rad";
    var TURN = "turn";
    var angle = {
        name: "angle",
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit){
                case DEG:
                    return Math.PI * value.number / 180;
                case GRAD:
                    return Math.PI / 200 * value.number;
                case RAD:
                    return value.number;
                case TURN:
                    return Math.PI * 2 * value.number;
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function(value) {
        if (value.type === 15 /* DIMENSION_TOKEN */ ) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) return true;
        }
        return false;
    };
    var parseNamedSide = function(tokens) {
        var sideOrCorner = tokens.filter(isIdentToken).map(function(ident) {
            return ident.value;
        }).join(" ");
        switch(sideOrCorner){
            case "to bottom right":
            case "to right bottom":
            case "left top":
            case "top left":
                return [
                    ZERO_LENGTH,
                    ZERO_LENGTH
                ];
            case "to top":
            case "bottom":
                return deg(0);
            case "to bottom left":
            case "to left bottom":
            case "right top":
            case "top right":
                return [
                    ZERO_LENGTH,
                    HUNDRED_PERCENT
                ];
            case "to right":
            case "left":
                return deg(90);
            case "to top left":
            case "to left top":
            case "right bottom":
            case "bottom right":
                return [
                    HUNDRED_PERCENT,
                    HUNDRED_PERCENT
                ];
            case "to bottom":
            case "top":
                return deg(180);
            case "to top right":
            case "to right top":
            case "left bottom":
            case "bottom left":
                return [
                    HUNDRED_PERCENT,
                    ZERO_LENGTH
                ];
            case "to left":
            case "right":
                return deg(270);
        }
        return 0;
    };
    var deg = function(deg) {
        return Math.PI * deg / 180;
    };
    var color$1 = {
        name: "color",
        parse: function(context, value) {
            if (value.type === 18 /* FUNCTION */ ) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === "undefined") throw new Error('Attempting to parse an unsupported color function "' + value.name + '"');
                return colorFunction(context, value.values);
            }
            if (value.type === 5 /* HASH_TOKEN */ ) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === 20 /* IDENT_TOKEN */ ) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== "undefined") return namedColor;
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function(color) {
        return (0xff & color) === 0;
    };
    var asString = function(color) {
        var alpha = 0xff & color;
        var blue = 0xff & color >> 8;
        var green = 0xff & color >> 16;
        var red = 0xff & color >> 24;
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function(r, g, b, a) {
        return (r << 24 | g << 16 | b << 8 | Math.round(a * 255) << 0) >>> 0;
    };
    var getTokenColorValue = function(token, i) {
        if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
        if (token.type === 16 /* PERCENTAGE_TOKEN */ ) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? token.number / 100 * max : Math.round(token.number / 100 * max);
        }
        return 0;
    };
    var rgb = function(_context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) hue += 1;
        if (hue >= 1) hue -= 1;
        if (hue < 1 / 6) return (t2 - t1) * hue * 6 + t1;
        else if (hue < 0.5) return t2;
        else if (hue < 2 / 3) return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        else return t1;
    }
    var hsl = function(context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === 17 /* NUMBER_TOKEN */  ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== "undefined" && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) return pack(l * 255, l * 255, l * 255, 1);
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var parseColor = function(context, value) {
        return color$1.parse(context, Parser.create(value).parseComponentValue());
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };
    var backgroundClip = {
        name: "background-clip",
        initialValue: "border-box",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case "padding-box":
                        return 1 /* PADDING_BOX */ ;
                    case "content-box":
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundColor = {
        name: "background-color",
        initialValue: "transparent",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "color"
    };
    var parseColorStop = function(context, args) {
        var color = color$1.parse(context, args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? {
            color: color,
            stop: stop
        } : {
            color: color,
            stop: null
        };
    };
    var processColorStops = function(stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) first.stop = ZERO_LENGTH;
        if (last.stop === null) last.stop = HUNDRED_PERCENT;
        var processStops = [];
        var previous = 0;
        for(var i = 0; i < stops.length; i++){
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) processStops.push(absoluteValue);
                else processStops.push(previous);
                previous = absoluteValue;
            } else processStops.push(null);
        }
        var gapBegin = null;
        for(var i = 0; i < processStops.length; i++){
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) gapBegin = i;
            } else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for(var g = 1; g <= gapLength; g++)processStops[gapBegin + g - 1] = gapValue * g;
                gapBegin = null;
            }
        }
        return stops.map(function(_a, i) {
            var color = _a.color;
            return {
                color: color,
                stop: Math.max(Math.min(1, processStops[i] / lineLength), 0)
            };
        });
    };
    var getAngleFromCorner = function(corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function(angle, width, height) {
        var radian = typeof angle === "number" ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [
            lineLength,
            halfWidth - xDiff,
            halfWidth + xDiff,
            halfHeight - yDiff,
            halfHeight + yDiff
        ];
    };
    var distance = function(a, b) {
        return Math.sqrt(a * a + b * b);
    };
    var findCorner = function(width, height, x, y, closest) {
        var corners = [
            [
                0,
                0
            ],
            [
                0,
                height
            ],
            [
                width,
                0
            ],
            [
                width,
                height
            ]
        ];
        return corners.reduce(function(stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) return {
                optimumCorner: corner,
                optimumDistance: d
            };
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function(gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch(gradient.size){
            case 0 /* CLOSEST_SIDE */ :
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 2 /* CLOSEST_CORNER */ :
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case 1 /* FARTHEST_SIDE */ :
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 3 /* FARTHEST_CORNER */ :
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */ ) rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                else if (gradient.shape === 1 /* ELLIPSE */ ) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [
            rx,
            ry
        ];
    };
    var linearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && firstToken.value === "to") {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(context, firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var prefixLinearGradient = function(context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */  && [
                    "top",
                    "left",
                    "right",
                    "bottom"
                ].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                } else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */ 
        };
    };
    var webkitGradient = function(context, tokens) {
        var angle = deg(180);
        var stops = [];
        var type = 1 /* LINEAR_GRADIENT */ ;
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === "linear") {
                    type = 1 /* LINEAR_GRADIENT */ ;
                    return;
                } else if (isIdentToken(firstToken) && firstToken.value === "radial") {
                    type = 2 /* RADIAL_GRADIENT */ ;
                    return;
                }
            }
            if (firstToken.type === 18 /* FUNCTION */ ) {
                if (firstToken.name === "from") {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: ZERO_LENGTH,
                        color: color
                    });
                } else if (firstToken.name === "to") {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({
                        stop: HUNDRED_PERCENT,
                        color: color
                    });
                } else if (firstToken.name === "color-stop") {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color = color$1.parse(context, values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) stops.push({
                            stop: {
                                type: 16 /* PERCENTAGE_TOKEN */ ,
                                number: stop_1.number * 100,
                                flags: stop_1.flags
                            },
                            color: color
                        });
                    }
                }
            }
        });
        return type === 1 /* LINEAR_GRADIENT */  ? {
            angle: (angle + deg(180)) % deg(360),
            stops: stops,
            type: type
        } : {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: type
        };
    };
    var CLOSEST_SIDE = "closest-side";
    var FARTHEST_SIDE = "farthest-side";
    var CLOSEST_CORNER = "closest-corner";
    var FARTHEST_CORNER = "farthest-corner";
    var CIRCLE = "circle";
    var ELLIPSE = "ellipse";
    var COVER = "cover";
    var CONTAIN = "contain";
    var radialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function(acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) switch(token.value){
                            case "center":
                                position.push(FIFTY_PERCENT);
                                return acc;
                            case "top":
                            case "left":
                                position.push(ZERO_LENGTH);
                                return acc;
                            case "right":
                            case "bottom":
                                position.push(HUNDRED_PERCENT);
                                return acc;
                        }
                        else if (isLengthPercentage(token) || isLength(token)) position.push(token);
                    } else if (isIdentToken(token)) switch(token.value){
                        case CIRCLE:
                            shape = 0 /* CIRCLE */ ;
                            return false;
                        case ELLIPSE:
                            shape = 1 /* ELLIPSE */ ;
                            return false;
                        case "at":
                            isAtPosition_1 = true;
                            return false;
                        case CLOSEST_SIDE:
                            size = 0 /* CLOSEST_SIDE */ ;
                            return false;
                        case COVER:
                        case FARTHEST_SIDE:
                            size = 1 /* FARTHEST_SIDE */ ;
                            return false;
                        case CONTAIN:
                        case CLOSEST_CORNER:
                            size = 2 /* CLOSEST_CORNER */ ;
                            return false;
                        case FARTHEST_CORNER:
                            size = 3 /* FARTHEST_CORNER */ ;
                            return false;
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) size = [];
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var prefixRadialGradient = function(context, tokens) {
        var shape = 0 /* CIRCLE */ ;
        var size = 3 /* FARTHEST_CORNER */ ;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function(arg, i) {
            var isColorStop = true;
            if (i === 0) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case "center":
                        position.push(FIFTY_PERCENT);
                        return false;
                    case "top":
                    case "left":
                        position.push(ZERO_LENGTH);
                        return false;
                    case "right":
                    case "bottom":
                        position.push(HUNDRED_PERCENT);
                        return false;
                }
                else if (isLengthPercentage(token) || isLength(token)) {
                    position.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            else if (i === 1) isColorStop = arg.reduce(function(acc, token) {
                if (isIdentToken(token)) switch(token.value){
                    case CIRCLE:
                        shape = 0 /* CIRCLE */ ;
                        return false;
                    case ELLIPSE:
                        shape = 1 /* ELLIPSE */ ;
                        return false;
                    case CONTAIN:
                    case CLOSEST_SIDE:
                        size = 0 /* CLOSEST_SIDE */ ;
                        return false;
                    case FARTHEST_SIDE:
                        size = 1 /* FARTHEST_SIDE */ ;
                        return false;
                    case CLOSEST_CORNER:
                        size = 2 /* CLOSEST_CORNER */ ;
                        return false;
                    case COVER:
                    case FARTHEST_CORNER:
                        size = 3 /* FARTHEST_CORNER */ ;
                        return false;
                }
                else if (isLength(token) || isLengthPercentage(token)) {
                    if (!Array.isArray(size)) size = [];
                    size.push(token);
                    return false;
                }
                return acc;
            }, isColorStop);
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return {
            size: size,
            shape: shape,
            stops: stops,
            position: position,
            type: 2 /* RADIAL_GRADIENT */ 
        };
    };
    var isLinearGradient = function(background) {
        return background.type === 1 /* LINEAR_GRADIENT */ ;
    };
    var isRadialGradient = function(background) {
        return background.type === 2 /* RADIAL_GRADIENT */ ;
    };
    var image = {
        name: "image",
        parse: function(context, value) {
            if (value.type === 22 /* URL_TOKEN */ ) {
                var image_1 = {
                    url: value.value,
                    type: 0 /* URL */ 
                };
                context.cache.addImage(value.value);
                return image_1;
            }
            if (value.type === 18 /* FUNCTION */ ) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === "undefined") throw new Error('Attempting to parse an unsupported image function "' + value.name + '"');
                return imageFunction(context, value.values);
            }
            throw new Error("Unsupported image type " + value.type);
        }
    };
    function isSupportedImage(value) {
        return !(value.type === 20 /* IDENT_TOKEN */  && value.value === "none") && (value.type !== 18 /* FUNCTION */  || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]);
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        "linear-gradient": linearGradient,
        "-moz-linear-gradient": prefixLinearGradient,
        "-ms-linear-gradient": prefixLinearGradient,
        "-o-linear-gradient": prefixLinearGradient,
        "-webkit-linear-gradient": prefixLinearGradient,
        "radial-gradient": radialGradient,
        "-moz-radial-gradient": prefixRadialGradient,
        "-ms-radial-gradient": prefixRadialGradient,
        "-o-radial-gradient": prefixRadialGradient,
        "-webkit-radial-gradient": prefixRadialGradient,
        "-webkit-gradient": webkitGradient
    };
    var backgroundImage = {
        name: "background-image",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === "none") return [];
            return tokens.filter(function(value) {
                return nonFunctionArgSeparator(value) && isSupportedImage(value);
            }).map(function(value) {
                return image.parse(context, value);
            });
        }
    };
    var backgroundOrigin = {
        name: "background-origin",
        initialValue: "border-box",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.map(function(token) {
                if (isIdentToken(token)) switch(token.value){
                    case "padding-box":
                        return 1 /* PADDING_BOX */ ;
                    case "content-box":
                        return 2 /* CONTENT_BOX */ ;
                }
                return 0 /* BORDER_BOX */ ;
            });
        }
    };
    var backgroundPosition = {
        name: "background-position",
        initialValue: "0% 0%",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isLengthPercentage);
            }).map(parseLengthPercentageTuple);
        }
    };
    var backgroundRepeat = {
        name: "background-repeat",
        initialValue: "repeat",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isIdentToken).map(function(token) {
                    return token.value;
                }).join(" ");
            }).map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function(value) {
        switch(value){
            case "no-repeat":
                return 1 /* NO_REPEAT */ ;
            case "repeat-x":
            case "repeat no-repeat":
                return 2 /* REPEAT_X */ ;
            case "repeat-y":
            case "no-repeat repeat":
                return 3 /* REPEAT_Y */ ;
            case "repeat":
            default:
                return 0 /* REPEAT */ ;
        }
    };
    var BACKGROUND_SIZE;
    (function(BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: "background-size",
        initialValue: "0",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return parseFunctionArgs(tokens).map(function(values) {
                return values.filter(isBackgroundSizeInfoToken);
            });
        }
    };
    var isBackgroundSizeInfoToken = function(value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };
    var borderColorForSide = function(side) {
        return {
            name: "border-" + side + "-color",
            initialValue: "transparent",
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: "color"
        };
    };
    var borderTopColor = borderColorForSide("top");
    var borderRightColor = borderColorForSide("right");
    var borderBottomColor = borderColorForSide("bottom");
    var borderLeftColor = borderColorForSide("left");
    var borderRadiusForSide = function(side) {
        return {
            name: "border-radius-" + side,
            initialValue: "0 0",
            prefix: false,
            type: 1 /* LIST */ ,
            parse: function(_context, tokens) {
                return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
            }
        };
    };
    var borderTopLeftRadius = borderRadiusForSide("top-left");
    var borderTopRightRadius = borderRadiusForSide("top-right");
    var borderBottomRightRadius = borderRadiusForSide("bottom-right");
    var borderBottomLeftRadius = borderRadiusForSide("bottom-left");
    var borderStyleForSide = function(side) {
        return {
            name: "border-" + side + "-style",
            initialValue: "solid",
            prefix: false,
            type: 2 /* IDENT_VALUE */ ,
            parse: function(_context, style) {
                switch(style){
                    case "none":
                        return 0 /* NONE */ ;
                    case "dashed":
                        return 2 /* DASHED */ ;
                    case "dotted":
                        return 3 /* DOTTED */ ;
                    case "double":
                        return 4 /* DOUBLE */ ;
                }
                return 1 /* SOLID */ ;
            }
        };
    };
    var borderTopStyle = borderStyleForSide("top");
    var borderRightStyle = borderStyleForSide("right");
    var borderBottomStyle = borderStyleForSide("bottom");
    var borderLeftStyle = borderStyleForSide("left");
    var borderWidthForSide = function(side) {
        return {
            name: "border-" + side + "-width",
            initialValue: "0",
            type: 0 /* VALUE */ ,
            prefix: false,
            parse: function(_context, token) {
                if (isDimensionToken(token)) return token.number;
                return 0;
            }
        };
    };
    var borderTopWidth = borderWidthForSide("top");
    var borderRightWidth = borderWidthForSide("right");
    var borderBottomWidth = borderWidthForSide("bottom");
    var borderLeftWidth = borderWidthForSide("left");
    var color = {
        name: "color",
        initialValue: "transparent",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "color"
    };
    var direction = {
        name: "direction",
        initialValue: "ltr",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, direction) {
            switch(direction){
                case "rtl":
                    return 1 /* RTL */ ;
                case "ltr":
                default:
                    return 0 /* LTR */ ;
            }
        }
    };
    var display = {
        name: "display",
        initialValue: "inline-block",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).reduce(function(bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */ );
        }
    };
    var parseDisplayValue = function(display) {
        switch(display){
            case "block":
            case "-webkit-box":
                return 2 /* BLOCK */ ;
            case "inline":
                return 4 /* INLINE */ ;
            case "run-in":
                return 8 /* RUN_IN */ ;
            case "flow":
                return 16 /* FLOW */ ;
            case "flow-root":
                return 32 /* FLOW_ROOT */ ;
            case "table":
                return 64 /* TABLE */ ;
            case "flex":
            case "-webkit-flex":
                return 128 /* FLEX */ ;
            case "grid":
            case "-ms-grid":
                return 256 /* GRID */ ;
            case "ruby":
                return 512 /* RUBY */ ;
            case "subgrid":
                return 1024 /* SUBGRID */ ;
            case "list-item":
                return 2048 /* LIST_ITEM */ ;
            case "table-row-group":
                return 4096 /* TABLE_ROW_GROUP */ ;
            case "table-header-group":
                return 8192 /* TABLE_HEADER_GROUP */ ;
            case "table-footer-group":
                return 16384 /* TABLE_FOOTER_GROUP */ ;
            case "table-row":
                return 32768 /* TABLE_ROW */ ;
            case "table-cell":
                return 65536 /* TABLE_CELL */ ;
            case "table-column-group":
                return 131072 /* TABLE_COLUMN_GROUP */ ;
            case "table-column":
                return 262144 /* TABLE_COLUMN */ ;
            case "table-caption":
                return 524288 /* TABLE_CAPTION */ ;
            case "ruby-base":
                return 1048576 /* RUBY_BASE */ ;
            case "ruby-text":
                return 2097152 /* RUBY_TEXT */ ;
            case "ruby-base-container":
                return 4194304 /* RUBY_BASE_CONTAINER */ ;
            case "ruby-text-container":
                return 8388608 /* RUBY_TEXT_CONTAINER */ ;
            case "contents":
                return 16777216 /* CONTENTS */ ;
            case "inline-block":
                return 33554432 /* INLINE_BLOCK */ ;
            case "inline-list-item":
                return 67108864 /* INLINE_LIST_ITEM */ ;
            case "inline-table":
                return 134217728 /* INLINE_TABLE */ ;
            case "inline-flex":
                return 268435456 /* INLINE_FLEX */ ;
            case "inline-grid":
                return 536870912 /* INLINE_GRID */ ;
        }
        return 0 /* NONE */ ;
    };
    var float = {
        name: "float",
        initialValue: "none",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, float) {
            switch(float){
                case "left":
                    return 1 /* LEFT */ ;
                case "right":
                    return 2 /* RIGHT */ ;
                case "inline-start":
                    return 3 /* INLINE_START */ ;
                case "inline-end":
                    return 4 /* INLINE_END */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var letterSpacing = {
        name: "letter-spacing",
        initialValue: "0",
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === "normal") return 0;
            if (token.type === 17 /* NUMBER_TOKEN */ ) return token.number;
            if (token.type === 15 /* DIMENSION_TOKEN */ ) return token.number;
            return 0;
        }
    };
    var LINE_BREAK;
    (function(LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: "line-break",
        initialValue: "normal",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, lineBreak) {
            switch(lineBreak){
                case "strict":
                    return LINE_BREAK.STRICT;
                case "normal":
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };
    var lineHeight = {
        name: "line-height",
        initialValue: "normal",
        prefix: false,
        type: 4 /* TOKEN_VALUE */ 
    };
    var computeLineHeight = function(token, fontSize) {
        if (isIdentToken(token) && token.value === "normal") return 1.2 * fontSize;
        else if (token.type === 17 /* NUMBER_TOKEN */ ) return fontSize * token.number;
        else if (isLengthPercentage(token)) return getAbsoluteValue(token, fontSize);
        return fontSize;
    };
    var listStyleImage = {
        name: "list-style-image",
        initialValue: "none",
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === "none") return null;
            return image.parse(context, token);
        }
    };
    var listStylePosition = {
        name: "list-style-position",
        initialValue: "outside",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case "inside":
                    return 0 /* INSIDE */ ;
                case "outside":
                default:
                    return 1 /* OUTSIDE */ ;
            }
        }
    };
    var listStyleType = {
        name: "list-style-type",
        initialValue: "none",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, type) {
            switch(type){
                case "disc":
                    return 0 /* DISC */ ;
                case "circle":
                    return 1 /* CIRCLE */ ;
                case "square":
                    return 2 /* SQUARE */ ;
                case "decimal":
                    return 3 /* DECIMAL */ ;
                case "cjk-decimal":
                    return 4 /* CJK_DECIMAL */ ;
                case "decimal-leading-zero":
                    return 5 /* DECIMAL_LEADING_ZERO */ ;
                case "lower-roman":
                    return 6 /* LOWER_ROMAN */ ;
                case "upper-roman":
                    return 7 /* UPPER_ROMAN */ ;
                case "lower-greek":
                    return 8 /* LOWER_GREEK */ ;
                case "lower-alpha":
                    return 9 /* LOWER_ALPHA */ ;
                case "upper-alpha":
                    return 10 /* UPPER_ALPHA */ ;
                case "arabic-indic":
                    return 11 /* ARABIC_INDIC */ ;
                case "armenian":
                    return 12 /* ARMENIAN */ ;
                case "bengali":
                    return 13 /* BENGALI */ ;
                case "cambodian":
                    return 14 /* CAMBODIAN */ ;
                case "cjk-earthly-branch":
                    return 15 /* CJK_EARTHLY_BRANCH */ ;
                case "cjk-heavenly-stem":
                    return 16 /* CJK_HEAVENLY_STEM */ ;
                case "cjk-ideographic":
                    return 17 /* CJK_IDEOGRAPHIC */ ;
                case "devanagari":
                    return 18 /* DEVANAGARI */ ;
                case "ethiopic-numeric":
                    return 19 /* ETHIOPIC_NUMERIC */ ;
                case "georgian":
                    return 20 /* GEORGIAN */ ;
                case "gujarati":
                    return 21 /* GUJARATI */ ;
                case "gurmukhi":
                    return 22 /* GURMUKHI */ ;
                case "hebrew":
                    return 22 /* HEBREW */ ;
                case "hiragana":
                    return 23 /* HIRAGANA */ ;
                case "hiragana-iroha":
                    return 24 /* HIRAGANA_IROHA */ ;
                case "japanese-formal":
                    return 25 /* JAPANESE_FORMAL */ ;
                case "japanese-informal":
                    return 26 /* JAPANESE_INFORMAL */ ;
                case "kannada":
                    return 27 /* KANNADA */ ;
                case "katakana":
                    return 28 /* KATAKANA */ ;
                case "katakana-iroha":
                    return 29 /* KATAKANA_IROHA */ ;
                case "khmer":
                    return 30 /* KHMER */ ;
                case "korean-hangul-formal":
                    return 31 /* KOREAN_HANGUL_FORMAL */ ;
                case "korean-hanja-formal":
                    return 32 /* KOREAN_HANJA_FORMAL */ ;
                case "korean-hanja-informal":
                    return 33 /* KOREAN_HANJA_INFORMAL */ ;
                case "lao":
                    return 34 /* LAO */ ;
                case "lower-armenian":
                    return 35 /* LOWER_ARMENIAN */ ;
                case "malayalam":
                    return 36 /* MALAYALAM */ ;
                case "mongolian":
                    return 37 /* MONGOLIAN */ ;
                case "myanmar":
                    return 38 /* MYANMAR */ ;
                case "oriya":
                    return 39 /* ORIYA */ ;
                case "persian":
                    return 40 /* PERSIAN */ ;
                case "simp-chinese-formal":
                    return 41 /* SIMP_CHINESE_FORMAL */ ;
                case "simp-chinese-informal":
                    return 42 /* SIMP_CHINESE_INFORMAL */ ;
                case "tamil":
                    return 43 /* TAMIL */ ;
                case "telugu":
                    return 44 /* TELUGU */ ;
                case "thai":
                    return 45 /* THAI */ ;
                case "tibetan":
                    return 46 /* TIBETAN */ ;
                case "trad-chinese-formal":
                    return 47 /* TRAD_CHINESE_FORMAL */ ;
                case "trad-chinese-informal":
                    return 48 /* TRAD_CHINESE_INFORMAL */ ;
                case "upper-armenian":
                    return 49 /* UPPER_ARMENIAN */ ;
                case "disclosure-open":
                    return 50 /* DISCLOSURE_OPEN */ ;
                case "disclosure-closed":
                    return 51 /* DISCLOSURE_CLOSED */ ;
                case "none":
                default:
                    return -1 /* NONE */ ;
            }
        }
    };
    var marginForSide = function(side) {
        return {
            name: "margin-" + side,
            initialValue: "0",
            prefix: false,
            type: 4 /* TOKEN_VALUE */ 
        };
    };
    var marginTop = marginForSide("top");
    var marginRight = marginForSide("right");
    var marginBottom = marginForSide("bottom");
    var marginLeft = marginForSide("left");
    var overflow = {
        name: "overflow",
        initialValue: "visible",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(overflow) {
                switch(overflow.value){
                    case "hidden":
                        return 1 /* HIDDEN */ ;
                    case "scroll":
                        return 2 /* SCROLL */ ;
                    case "clip":
                        return 3 /* CLIP */ ;
                    case "auto":
                        return 4 /* AUTO */ ;
                    case "visible":
                    default:
                        return 0 /* VISIBLE */ ;
                }
            });
        }
    };
    var overflowWrap = {
        name: "overflow-wrap",
        initialValue: "normal",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case "break-word":
                    return "break-word" /* BREAK_WORD */ ;
                case "normal":
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var paddingForSide = function(side) {
        return {
            name: "padding-" + side,
            initialValue: "0",
            prefix: false,
            type: 3 /* TYPE_VALUE */ ,
            format: "length-percentage"
        };
    };
    var paddingTop = paddingForSide("top");
    var paddingRight = paddingForSide("right");
    var paddingBottom = paddingForSide("bottom");
    var paddingLeft = paddingForSide("left");
    var textAlign = {
        name: "text-align",
        initialValue: "left",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textAlign) {
            switch(textAlign){
                case "right":
                    return 2 /* RIGHT */ ;
                case "center":
                case "justify":
                    return 1 /* CENTER */ ;
                case "left":
                default:
                    return 0 /* LEFT */ ;
            }
        }
    };
    var position = {
        name: "position",
        initialValue: "static",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, position) {
            switch(position){
                case "relative":
                    return 1 /* RELATIVE */ ;
                case "absolute":
                    return 2 /* ABSOLUTE */ ;
                case "fixed":
                    return 3 /* FIXED */ ;
                case "sticky":
                    return 4 /* STICKY */ ;
            }
            return 0 /* STATIC */ ;
        }
    };
    var textShadow = {
        name: "text-shadow",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], "none")) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else shadow.blur = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var textTransform = {
        name: "text-transform",
        initialValue: "none",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, textTransform) {
            switch(textTransform){
                case "uppercase":
                    return 2 /* UPPERCASE */ ;
                case "lowercase":
                    return 1 /* LOWERCASE */ ;
                case "capitalize":
                    return 3 /* CAPITALIZE */ ;
            }
            return 0 /* NONE */ ;
        }
    };
    var transform$1 = {
        name: "transform",
        initialValue: "none",
        prefix: true,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */  && token.value === "none") return null;
            if (token.type === 18 /* FUNCTION */ ) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === "undefined") throw new Error('Attempting to parse an unsupported transform function "' + token.name + '"');
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function(args) {
        var values = args.filter(function(arg) {
            return arg.type === 17 /* NUMBER_TOKEN */ ;
        }).map(function(arg) {
            return arg.number;
        });
        var a1 = values[0], b1 = values[1];
        values[2];
        values[3];
        var a2 = values[4], b2 = values[5];
        values[6];
        values[7];
        values[8];
        values[9];
        values[10];
        values[11];
        var a4 = values[12], b4 = values[13];
        values[14];
        values[15];
        return values.length === 16 ? [
            a1,
            b1,
            a2,
            b2,
            a4,
            b4
        ] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };
    var DEFAULT_VALUE = {
        type: 16 /* PERCENTAGE_TOKEN */ ,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [
        DEFAULT_VALUE,
        DEFAULT_VALUE
    ];
    var transformOrigin = {
        name: "transform-origin",
        initialValue: "50% 50%",
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) return DEFAULT;
            return [
                origins[0],
                origins[1]
            ];
        }
    };
    var visibility = {
        name: "visible",
        initialValue: "none",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, visibility) {
            switch(visibility){
                case "hidden":
                    return 1 /* HIDDEN */ ;
                case "collapse":
                    return 2 /* COLLAPSE */ ;
                case "visible":
                default:
                    return 0 /* VISIBLE */ ;
            }
        }
    };
    var WORD_BREAK;
    (function(WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: "word-break",
        initialValue: "normal",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, wordBreak) {
            switch(wordBreak){
                case "break-all":
                    return WORD_BREAK.BREAK_ALL;
                case "keep-all":
                    return WORD_BREAK.KEEP_ALL;
                case "normal":
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };
    var zIndex = {
        name: "z-index",
        initialValue: "auto",
        prefix: false,
        type: 0 /* VALUE */ ,
        parse: function(_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ ) return {
                auto: true,
                order: 0
            };
            if (isNumberToken(token)) return {
                auto: false,
                order: token.number
            };
            throw new Error("Invalid z-index number parsed");
        }
    };
    var time = {
        name: "time",
        parse: function(_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */ ) switch(value.unit.toLowerCase()){
                case "s":
                    return 1000 * value.number;
                case "ms":
                    return value.number;
            }
            throw new Error("Unsupported time type");
        }
    };
    var opacity = {
        name: "opacity",
        initialValue: "1",
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            return 1;
        }
    };
    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: "transparent",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "color"
    };
    var textDecorationLine = {
        name: "text-decoration-line",
        initialValue: "none",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                switch(token.value){
                    case "underline":
                        return 1 /* UNDERLINE */ ;
                    case "overline":
                        return 2 /* OVERLINE */ ;
                    case "line-through":
                        return 3 /* LINE_THROUGH */ ;
                    case "none":
                        return 4 /* BLINK */ ;
                }
                return 0 /* NONE */ ;
            }).filter(function(line) {
                return line !== 0 /* NONE */ ;
            });
        }
    };
    var fontFamily = {
        name: "font-family",
        initialValue: "",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function(token) {
                switch(token.type){
                    case 20 /* IDENT_TOKEN */ :
                    case 0 /* STRING_TOKEN */ :
                        accumulator.push(token.value);
                        break;
                    case 17 /* NUMBER_TOKEN */ :
                        accumulator.push(token.number.toString());
                        break;
                    case 4 /* COMMA_TOKEN */ :
                        results.push(accumulator.join(" "));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) results.push(accumulator.join(" "));
            return results.map(function(result) {
                return result.indexOf(" ") === -1 ? result : "'" + result + "'";
            });
        }
    };
    var fontSize = {
        name: "font-size",
        initialValue: "0",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "length"
    };
    var fontWeight = {
        name: "font-weight",
        initialValue: "normal",
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isNumberToken(token)) return token.number;
            if (isIdentToken(token)) switch(token.value){
                case "bold":
                    return 700;
                case "normal":
                default:
                    return 400;
            }
            return 400;
        }
    };
    var fontVariant = {
        name: "font-variant",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            return tokens.filter(isIdentToken).map(function(token) {
                return token.value;
            });
        }
    };
    var fontStyle = {
        name: "font-style",
        initialValue: "normal",
        prefix: false,
        type: 2 /* IDENT_VALUE */ ,
        parse: function(_context, overflow) {
            switch(overflow){
                case "oblique":
                    return "oblique" /* OBLIQUE */ ;
                case "italic":
                    return "italic" /* ITALIC */ ;
                case "normal":
                default:
                    return "normal" /* NORMAL */ ;
            }
        }
    };
    var contains = function(bit, value) {
        return (bit & value) !== 0;
    };
    var content = {
        name: "content",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === "none") return [];
            return tokens;
        }
    };
    var counterIncrement = {
        name: "counter-increment",
        initialValue: "none",
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === "none") return null;
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === 20 /* IDENT_TOKEN */ ) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({
                        counter: counter.value,
                        increment: increment
                    });
                }
            }
            return increments;
        }
    };
    var counterReset = {
        name: "counter-reset",
        initialValue: "none",
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return [];
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for(var i = 0; i < filtered.length; i++){
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== "none") {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({
                        counter: counter.value,
                        reset: reset
                    });
                }
            }
            return resets;
        }
    };
    var duration = {
        name: "duration",
        initialValue: "0s",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(context, tokens) {
            return tokens.filter(isDimensionToken).map(function(token) {
                return time.parse(context, token);
            });
        }
    };
    var quotes = {
        name: "quotes",
        initialValue: "none",
        prefix: true,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            if (tokens.length === 0) return null;
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */  && first.value === "none") return null;
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) return null;
            for(var i = 0; i < filtered.length; i += 2){
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({
                    open: open_1,
                    close: close_1
                });
            }
            return quotes;
        }
    };
    var getQuote = function(quotes, depth, open) {
        if (!quotes) return "";
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) return "";
        return open ? quote.open : quote.close;
    };
    var boxShadow = {
        name: "box-shadow",
        initialValue: "none",
        type: 1 /* LIST */ ,
        prefix: false,
        parse: function(context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], "none")) return [];
            return parseFunctionArgs(tokens).map(function(values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for(var i = 0; i < values.length; i++){
                    var token = values[i];
                    if (isIdentWithValue(token, "inset")) shadow.inset = true;
                    else if (isLength(token)) {
                        if (c === 0) shadow.offsetX = token;
                        else if (c === 1) shadow.offsetY = token;
                        else if (c === 2) shadow.blur = token;
                        else shadow.spread = token;
                        c++;
                    } else shadow.color = color$1.parse(context, token);
                }
                return shadow;
            });
        }
    };
    var paintOrder = {
        name: "paint-order",
        initialValue: "normal",
        prefix: false,
        type: 1 /* LIST */ ,
        parse: function(_context, tokens) {
            var DEFAULT_VALUE = [
                0 /* FILL */ ,
                1 /* STROKE */ ,
                2 /* MARKERS */ 
            ];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function(token) {
                switch(token.value){
                    case "stroke":
                        layers.push(1 /* STROKE */ );
                        break;
                    case "fill":
                        layers.push(0 /* FILL */ );
                        break;
                    case "markers":
                        layers.push(2 /* MARKERS */ );
                        break;
                }
            });
            DEFAULT_VALUE.forEach(function(value) {
                if (layers.indexOf(value) === -1) layers.push(value);
            });
            return layers;
        }
    };
    var webkitTextStrokeColor = {
        name: "-webkit-text-stroke-color",
        initialValue: "currentcolor",
        prefix: false,
        type: 3 /* TYPE_VALUE */ ,
        format: "color"
    };
    var webkitTextStrokeWidth = {
        name: "-webkit-text-stroke-width",
        initialValue: "0",
        type: 0 /* VALUE */ ,
        prefix: false,
        parse: function(_context, token) {
            if (isDimensionToken(token)) return token.number;
            return 0;
        }
    };
    var CSSParsedDeclaration = /** @class */ function() {
        function CSSParsedDeclaration(context, declaration) {
            var _a, _b;
            this.animationDuration = parse(context, duration, declaration.animationDuration);
            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
            this.color = parse(context, color, declaration.color);
            this.direction = parse(context, direction, declaration.direction);
            this.display = parse(context, display, declaration.display);
            this.float = parse(context, float, declaration.cssFloat);
            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
            this.fontSize = parse(context, fontSize, declaration.fontSize);
            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
            this.marginTop = parse(context, marginTop, declaration.marginTop);
            this.marginRight = parse(context, marginRight, declaration.marginRight);
            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
            this.opacity = parse(context, opacity, declaration.opacity);
            var overflowTuple = parse(context, overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
            this.position = parse(context, position, declaration.position);
            this.textAlign = parse(context, textAlign, declaration.textAlign);
            this.textDecorationColor = parse(context, textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
            this.textDecorationLine = parse(context, textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
            this.textShadow = parse(context, textShadow, declaration.textShadow);
            this.textTransform = parse(context, textTransform, declaration.textTransform);
            this.transform = parse(context, transform$1, declaration.transform);
            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
            this.visibility = parse(context, visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
            this.zIndex = parse(context, zIndex, declaration.zIndex);
        }
        CSSParsedDeclaration.prototype.isVisible = function() {
            return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBLE */ ;
        };
        CSSParsedDeclaration.prototype.isTransparent = function() {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function() {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function() {
            return this.position !== 0 /* STATIC */ ;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function() {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function() {
            return this.float !== 0 /* NONE */ ;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function() {
            return contains(this.display, 4 /* INLINE */ ) || contains(this.display, 33554432 /* INLINE_BLOCK */ ) || contains(this.display, 268435456 /* INLINE_FLEX */ ) || contains(this.display, 536870912 /* INLINE_GRID */ ) || contains(this.display, 67108864 /* INLINE_LIST_ITEM */ ) || contains(this.display, 134217728 /* INLINE_TABLE */ );
        };
        return CSSParsedDeclaration;
    }();
    var CSSParsedPseudoDeclaration = /** @class */ function() {
        function CSSParsedPseudoDeclaration(context, declaration) {
            this.content = parse(context, content, declaration.content);
            this.quotes = parse(context, quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }();
    var CSSParsedCounterDeclaration = /** @class */ function() {
        function CSSParsedCounterDeclaration(context, declaration) {
            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(context, counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function(context, descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== "undefined" ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch(descriptor.type){
            case 2 /* IDENT_VALUE */ :
                var token = parser.parseComponentValue();
                return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0 /* VALUE */ :
                return descriptor.parse(context, parser.parseComponentValue());
            case 1 /* LIST */ :
                return descriptor.parse(context, parser.parseComponentValues());
            case 4 /* TOKEN_VALUE */ :
                return parser.parseComponentValue();
            case 3 /* TYPE_VALUE */ :
                switch(descriptor.format){
                    case "angle":
                        return angle.parse(context, parser.parseComponentValue());
                    case "color":
                        return color$1.parse(context, parser.parseComponentValue());
                    case "image":
                        return image.parse(context, parser.parseComponentValue());
                    case "length":
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case "length-percentage":
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                    case "time":
                        return time.parse(context, parser.parseComponentValue());
                }
                break;
        }
    };
    var elementDebuggerAttribute = "data-html2canvas-debug";
    var getElementDebugType = function(element) {
        var attribute = element.getAttribute(elementDebuggerAttribute);
        switch(attribute){
            case "all":
                return 1 /* ALL */ ;
            case "clone":
                return 2 /* CLONE */ ;
            case "parse":
                return 3 /* PARSE */ ;
            case "render":
                return 4 /* RENDER */ ;
            default:
                return 0 /* NONE */ ;
        }
    };
    var isDebugging = function(element, type) {
        var elementType = getElementDebugType(element);
        return elementType === 1 /* ALL */  || type === elementType;
    };
    var ElementContainer = /** @class */ function() {
        function ElementContainer(context, element) {
            this.context = context;
            this.textNodes = [];
            this.elements = [];
            this.flags = 0;
            if (isDebugging(element, 3 /* PARSE */ )) debugger;
            this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
            if (isHTMLElementNode(element)) {
                if (this.styles.animationDuration.some(function(duration) {
                    return duration > 0;
                })) element.style.animationDuration = "0s";
                if (this.styles.transform !== null) // getBoundingClientRect takes transforms into account
                element.style.transform = "none";
            }
            this.bounds = parseBounds(this.context, element);
            if (isDebugging(element, 4 /* RENDER */ )) this.flags |= 16 /* DEBUG_RENDER */ ;
        }
        return ElementContainer;
    }();
    /*
     * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var base64 = "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";
    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars$1 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup$1 = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i$1 = 0; i$1 < chars$1.length; i$1++)lookup$1[chars$1.charCodeAt(i$1)] = i$1;
    var decode = function(base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === "=") {
            bufferLength--;
            if (base64[base64.length - 2] === "=") bufferLength--;
        }
        var buffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined" && typeof Uint8Array.prototype.slice !== "undefined" ? new ArrayBuffer(bufferLength) : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for(i = 0; i < len; i += 4){
            encoded1 = lookup$1[base64.charCodeAt(i)];
            encoded2 = lookup$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1[base64.charCodeAt(i + 3)];
            bytes[p++] = encoded1 << 2 | encoded2 >> 4;
            bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
            bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
        }
        return buffer;
    };
    var polyUint16Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 2)bytes.push(buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    var polyUint32Array = function(buffer) {
        var length = buffer.length;
        var bytes = [];
        for(var i = 0; i < length; i += 4)bytes.push(buffer[i + 3] << 24 | buffer[i + 2] << 16 | buffer[i + 1] << 8 | buffer[i]);
        return bytes;
    };
    /** Shift size for getting the index-2 table offset. */ var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */ var UTRIE2_SHIFT_1 = 11;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */ var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */ var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */ var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */ var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */ var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */ var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */ var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 32; /* U+0800 is the first code point after 2-byte UTF-8 */ 
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */ var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */ var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */ var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */ var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function(view, start, end) {
        if (view.slice) return view.slice(start, end);
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function(base64, _byteLength) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2 ? slice16(view16, (headerLength + view32[4]) / 2) : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ function() {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */ Trie.prototype.get = function(codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || codePoint > 0x0dbff && codePoint <= 0x0ffff) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += codePoint >> UTRIE2_SHIFT_2 & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) return this.data[this.highValueIndex];
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }();
    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */ var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === "undefined" ? [] : new Uint8Array(256);
    for(var i = 0; i < chars.length; i++)lookup[chars.charCodeAt(i)] = i;
    var Prepend = 1;
    var CR = 2;
    var LF = 3;
    var Control = 4;
    var Extend = 5;
    var SpacingMark = 7;
    var L = 8;
    var V = 9;
    var T = 10;
    var LV = 11;
    var LVT = 12;
    var ZWJ = 13;
    var Extended_Pictographic = 14;
    var RI = 15;
    var toCodePoints = function(str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while(i < length){
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                else {
                    codePoints.push(value);
                    i--;
                }
            } else codePoints.push(value);
        }
        return codePoints;
    };
    var fromCodePoint = function() {
        var codePoints = [];
        for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
        if (String.fromCodePoint) return String.fromCodePoint.apply(String, codePoints);
        var length = codePoints.length;
        if (!length) return "";
        var codeUnits = [];
        var index = -1;
        var result = "";
        while(++index < length){
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) codeUnits.push(codePoint);
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, codePoint % 0x400 + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var UnicodeTrie = createTrieFromBase64(base64);
    var BREAK_NOT_ALLOWED = "\xd7";
    var BREAK_ALLOWED = "\xf7";
    var codePointToClass = function(codePoint) {
        return UnicodeTrie.get(codePoint);
    };
    var _graphemeBreakAtIndex = function(_codePoints, classTypes, index) {
        var prevIndex = index - 2;
        var prev = classTypes[prevIndex];
        var current = classTypes[index - 1];
        var next = classTypes[index];
        // GB3 Do not break between a CR and LF
        if (current === CR && next === LF) return BREAK_NOT_ALLOWED;
        // GB4 Otherwise, break before and after controls.
        if (current === CR || current === LF || current === Control) return BREAK_ALLOWED;
        // GB5
        if (next === CR || next === LF || next === Control) return BREAK_ALLOWED;
        // Do not break Hangul syllable sequences.
        // GB6
        if (current === L && [
            L,
            V,
            LV,
            LVT
        ].indexOf(next) !== -1) return BREAK_NOT_ALLOWED;
        // GB7
        if ((current === LV || current === V) && (next === V || next === T)) return BREAK_NOT_ALLOWED;
        // GB8
        if ((current === LVT || current === T) && next === T) return BREAK_NOT_ALLOWED;
        // GB9 Do not break before extending characters or ZWJ.
        if (next === ZWJ || next === Extend) return BREAK_NOT_ALLOWED;
        // Do not break before SpacingMarks, or after Prepend characters.
        // GB9a
        if (next === SpacingMark) return BREAK_NOT_ALLOWED;
        // GB9a
        if (current === Prepend) return BREAK_NOT_ALLOWED;
        // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
        if (current === ZWJ && next === Extended_Pictographic) {
            while(prev === Extend)prev = classTypes[--prevIndex];
            if (prev === Extended_Pictographic) return BREAK_NOT_ALLOWED;
        }
        // GB12 Do not break within emoji flag sequences.
        // That is, do not break between regional indicator (RI) symbols
        // if there is an odd number of RI characters before the break point.
        if (current === RI && next === RI) {
            var countRI = 0;
            while(prev === RI){
                countRI++;
                prev = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) return BREAK_NOT_ALLOWED;
        }
        return BREAK_ALLOWED;
    };
    var GraphemeBreaker = function(str) {
        var codePoints = toCodePoints(str);
        var length = codePoints.length;
        var index = 0;
        var lastEnd = 0;
        var classTypes = codePoints.map(codePointToClass);
        return {
            next: function() {
                if (index >= length) return {
                    done: true,
                    value: null
                };
                var graphemeBreak = BREAK_NOT_ALLOWED;
                while(index < length && (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED);
                if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
                    var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
                    lastEnd = index;
                    return {
                        value: value,
                        done: false
                    };
                }
                return {
                    done: true,
                    value: null
                };
            }
        };
    };
    var splitGraphemes = function(str) {
        var breaker = GraphemeBreaker(str);
        var graphemes = [];
        var bk;
        while(!(bk = breaker.next()).done)if (bk.value) graphemes.push(bk.value.slice());
        return graphemes;
    };
    var testRangeBounds = function(document1) {
        var TEST_HEIGHT = 123;
        if (document1.createRange) {
            var range = document1.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document1.createElement("boundtest");
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = "block";
                document1.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document1.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) return true;
            }
        }
        return false;
    };
    var testIOSLineBreak = function(document1) {
        var testElement = document1.createElement("boundtest");
        testElement.style.width = "50px";
        testElement.style.display = "block";
        testElement.style.fontSize = "12px";
        testElement.style.letterSpacing = "0px";
        testElement.style.wordSpacing = "0px";
        document1.body.appendChild(testElement);
        var range = document1.createRange();
        testElement.innerHTML = typeof "".repeat === "function" ? "&#128104;".repeat(10) : "";
        var node = testElement.firstChild;
        var textList = toCodePoints$1(node.data).map(function(i) {
            return fromCodePoint$1(i);
        });
        var offset = 0;
        var prev = {};
        // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
        var supports = textList.every(function(text, i) {
            range.setStart(node, offset);
            range.setEnd(node, offset + text.length);
            var rect = range.getBoundingClientRect();
            offset += text.length;
            var boundAhead = rect.x > prev.x || rect.y > prev.y;
            prev = rect;
            if (i === 0) return true;
            return boundAhead;
        });
        document1.body.removeChild(testElement);
        return supports;
    };
    var testCORS = function() {
        return typeof new Image().crossOrigin !== "undefined";
    };
    var testResponseType = function() {
        return typeof new XMLHttpRequest().responseType === "string";
    };
    var testSVG = function(document1) {
        var img = new Image();
        var canvas = document1.createElement("canvas");
        var ctx = canvas.getContext("2d");
        if (!ctx) return false;
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        } catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function(data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function(document1) {
        var canvas = document1.createElement("canvas");
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext("2d");
        if (!ctx) return Promise.reject(false);
        ctx.fillStyle = "rgb(0, 255, 0)";
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = "red";
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG$1(svg).then(function(img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = "red";
            ctx.fillRect(0, 0, size, size);
            var node = document1.createElement("div");
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data) ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node)) : Promise.reject(false);
        }).then(function(img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        }).catch(function() {
            return false;
        });
    };
    var createForeignObjectSVG = function(width, height, x, y, node) {
        var xmlns = "http://www.w3.org/2000/svg";
        var svg = document.createElementNS(xmlns, "svg");
        var foreignObject = document.createElementNS(xmlns, "foreignObject");
        svg.setAttributeNS(null, "width", width.toString());
        svg.setAttributeNS(null, "height", height.toString());
        foreignObject.setAttributeNS(null, "width", "100%");
        foreignObject.setAttributeNS(null, "height", "100%");
        foreignObject.setAttributeNS(null, "x", x.toString());
        foreignObject.setAttributeNS(null, "y", y.toString());
        foreignObject.setAttributeNS(null, "externalResourcesRequired", "true");
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG$1 = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                return resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS () {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, "SUPPORT_RANGE_BOUNDS", {
                value: value
            });
            return value;
        },
        get SUPPORT_WORD_BREAKING () {
            var value1 = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, "SUPPORT_WORD_BREAKING", {
                value: value1
            });
            return value1;
        },
        get SUPPORT_SVG_DRAWING () {
            var value2 = testSVG(document);
            Object.defineProperty(FEATURES, "SUPPORT_SVG_DRAWING", {
                value: value2
            });
            return value2;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING () {
            var value3 = typeof Array.from === "function" && typeof window.fetch === "function" ? testForeignObject(document) : Promise.resolve(false);
            Object.defineProperty(FEATURES, "SUPPORT_FOREIGNOBJECT_DRAWING", {
                value: value3
            });
            return value3;
        },
        get SUPPORT_CORS_IMAGES () {
            var value4 = testCORS();
            Object.defineProperty(FEATURES, "SUPPORT_CORS_IMAGES", {
                value: value4
            });
            return value4;
        },
        get SUPPORT_RESPONSE_TYPE () {
            var value5 = testResponseType();
            Object.defineProperty(FEATURES, "SUPPORT_RESPONSE_TYPE", {
                value: value5
            });
            return value5;
        },
        get SUPPORT_CORS_XHR () {
            var value6 = "withCredentials" in new XMLHttpRequest();
            Object.defineProperty(FEATURES, "SUPPORT_CORS_XHR", {
                value: value6
            });
            return value6;
        },
        get SUPPORT_NATIVE_TEXT_SEGMENTATION () {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var value7 = !!(typeof Intl !== "undefined" && Intl.Segmenter);
            Object.defineProperty(FEATURES, "SUPPORT_NATIVE_TEXT_SEGMENTATION", {
                value: value7
            });
            return value7;
        }
    };
    var TextBounds = /** @class */ function() {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }();
    var parseTextBounds = function(context, value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function(text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    var clientRects = createRange(node, offset, text.length).getClientRects();
                    if (clientRects.length > 1) {
                        var subSegments = segmentGraphemes(text);
                        var subOffset_1 = 0;
                        subSegments.forEach(function(subSegment) {
                            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
                            subOffset_1 += subSegment.length;
                        });
                    } else textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
                } else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
                    node = replacementNode;
                }
            } else if (!FEATURES.SUPPORT_RANGE_BOUNDS) node = node.splitText(text.length);
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function(context, node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement("html2canvaswrapper");
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(context, wrapper);
                if (wrapper.firstChild) parentNode.replaceChild(wrapper.firstChild, wrapper);
                return bounds;
            }
        }
        return Bounds.EMPTY;
    };
    var createRange = function(node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) throw new Error("Node has no owner document");
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return range;
    };
    var segmentGraphemes = function(value) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: "grapheme"
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return splitGraphemes(value);
    };
    var segmentWords = function(value, styles) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: "word"
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function(segment) {
                return segment.segment;
            });
        }
        return breakWords(value, styles);
    };
    var breakText = function(value, styles) {
        return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
    };
    // https://drafts.csswg.org/css-text/#word-separator
    var wordSeparators = [
        0x0020,
        0x00a0,
        0x1361,
        0x10100,
        0x10101,
        0x1039,
        0x1091
    ];
    var breakWords = function(str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === "break-word" /* BREAK_WORD */  ? "break-word" : styles.wordBreak
        });
        var words = [];
        var bk;
        var _loop_1 = function() {
            if (bk.value) {
                var value = bk.value.slice();
                var codePoints = toCodePoints$1(value);
                var word_1 = "";
                codePoints.forEach(function(codePoint) {
                    if (wordSeparators.indexOf(codePoint) === -1) word_1 += fromCodePoint$1(codePoint);
                    else {
                        if (word_1.length) words.push(word_1);
                        words.push(fromCodePoint$1(codePoint));
                        word_1 = "";
                    }
                });
                if (word_1.length) words.push(word_1);
            }
        };
        while(!(bk = breaker.next()).done)_loop_1();
        return words;
    };
    var TextContainer = /** @class */ function() {
        function TextContainer(context, node, styles) {
            this.text = transform(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(context, this.text, styles, node);
        }
        return TextContainer;
    }();
    var transform = function(text, transform) {
        switch(transform){
            case 1 /* LOWERCASE */ :
                return text.toLowerCase();
            case 3 /* CAPITALIZE */ :
                return text.replace(CAPITALIZE, capitalize);
            case 2 /* UPPERCASE */ :
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function(m, p1, p2) {
        if (m.length > 0) return p1 + p2.toUpperCase();
        return m;
    };
    var ImageElementContainer = /** @class */ function(_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            _this.context.cache.addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer);
    var CanvasElementContainer = /** @class */ function(_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(context, canvas) {
            var _this = _super.call(this, context, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer);
    var SVGElementContainer = /** @class */ function(_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            var s = new XMLSerializer();
            var bounds = parseBounds(context, img);
            img.setAttribute("width", bounds.width + "px");
            img.setAttribute("height", bounds.height + "px");
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            _this.context.cache.addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer);
    var LIElementContainer = /** @class */ function(_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer);
    var OLElementContainer = /** @class */ function(_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === "boolean" && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer);
    var CHECKBOX_BORDER_RADIUS = [
        {
            type: 15 /* DIMENSION_TOKEN */ ,
            flags: 0,
            unit: "px",
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: 16 /* PERCENTAGE_TOKEN */ ,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function(bounds) {
        if (bounds.width > bounds.height) return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        else if (bounds.width < bounds.height) return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        return bounds;
    };
    var getInputValue = function(node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join("\u2022") : node.value;
        return value.length === 0 ? node.placeholder || "" : value;
    };
    var CHECKBOX = "checkbox";
    var RADIO = "radio";
    var PASSWORD = "password";
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ function(_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(context, input) {
            var _this = _super.call(this, context, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor = _this.styles.borderRightColor = _this.styles.borderBottomColor = _this.styles.borderLeftColor = 0xa5a5a5ff;
                _this.styles.borderTopWidth = _this.styles.borderRightWidth = _this.styles.borderBottomWidth = _this.styles.borderLeftWidth = 1;
                _this.styles.borderTopStyle = _this.styles.borderRightStyle = _this.styles.borderBottomStyle = _this.styles.borderLeftStyle = 1 /* SOLID */ ;
                _this.styles.backgroundClip = [
                    0 /* BORDER_BOX */ 
                ];
                _this.styles.backgroundOrigin = [
                    0 /* BORDER_BOX */ 
                ];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch(_this.type){
                case CHECKBOX:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius = _this.styles.borderTopLeftRadius = _this.styles.borderBottomRightRadius = _this.styles.borderBottomLeftRadius = RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer);
    var SelectElementContainer = /** @class */ function(_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || "" : "";
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer);
    var TextareaElementContainer = /** @class */ function(_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer);
    var IFrameElementContainer = /** @class */ function(_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(context, iframe) {
            var _this = _super.call(this, context, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow && iframe.contentWindow.document && iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor) : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor) : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? _this.styles.backgroundColor : bodyBackgroundColor : documentBackgroundColor;
                }
            } catch (e) {}
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer);
    var LIST_OWNERS = [
        "OL",
        "UL",
        "MENU"
    ];
    var parseNodeTree = function(context, node, parent, root) {
        for(var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode){
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
            else if (isElementNode(childNode)) {
                if (isSlotElement(childNode) && childNode.assignedNodes) childNode.assignedNodes().forEach(function(childNode) {
                    return parseNodeTree(context, childNode, parent, root);
                });
                else {
                    var container = createContainer(context, childNode);
                    if (container.styles.isVisible()) {
                        if (createsRealStackingContext(childNode, container, root)) container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
                        else if (createsStackingContext(container.styles)) container.flags |= 2 /* CREATES_STACKING_CONTEXT */ ;
                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) container.flags |= 8 /* IS_LIST_OWNER */ ;
                        parent.elements.push(container);
                        childNode.slot;
                        if (childNode.shadowRoot) parseNodeTree(context, childNode.shadowRoot, container, root);
                        else if (!isTextareaElement(childNode) && !isSVGElement(childNode) && !isSelectElement(childNode)) parseNodeTree(context, childNode, container, root);
                    }
                }
            }
        }
    };
    var createContainer = function(context, element) {
        if (isImageElement(element)) return new ImageElementContainer(context, element);
        if (isCanvasElement(element)) return new CanvasElementContainer(context, element);
        if (isSVGElement(element)) return new SVGElementContainer(context, element);
        if (isLIElement(element)) return new LIElementContainer(context, element);
        if (isOLElement(element)) return new OLElementContainer(context, element);
        if (isInputElement(element)) return new InputElementContainer(context, element);
        if (isSelectElement(element)) return new SelectElementContainer(context, element);
        if (isTextareaElement(element)) return new TextareaElementContainer(context, element);
        if (isIFrameElement(element)) return new IFrameElementContainer(context, element);
        return new ElementContainer(context, element);
    };
    var parseTree = function(context, element) {
        var container = createContainer(context, element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */ ;
        parseNodeTree(context, element, container, container);
        return container;
    };
    var createsRealStackingContext = function(node, container, root) {
        return container.styles.isPositionedWithZIndex() || container.styles.opacity < 1 || container.styles.isTransformed() || isBodyElement(node) && root.styles.isTransparent();
    };
    var createsStackingContext = function(styles) {
        return styles.isPositioned() || styles.isFloating();
    };
    var isTextNode = function(node) {
        return node.nodeType === Node.TEXT_NODE;
    };
    var isElementNode = function(node) {
        return node.nodeType === Node.ELEMENT_NODE;
    };
    var isHTMLElementNode = function(node) {
        return isElementNode(node) && typeof node.style !== "undefined" && !isSVGElementNode(node);
    };
    var isSVGElementNode = function(element) {
        return typeof element.className === "object";
    };
    var isLIElement = function(node) {
        return node.tagName === "LI";
    };
    var isOLElement = function(node) {
        return node.tagName === "OL";
    };
    var isInputElement = function(node) {
        return node.tagName === "INPUT";
    };
    var isHTMLElement = function(node) {
        return node.tagName === "HTML";
    };
    var isSVGElement = function(node) {
        return node.tagName === "svg";
    };
    var isBodyElement = function(node) {
        return node.tagName === "BODY";
    };
    var isCanvasElement = function(node) {
        return node.tagName === "CANVAS";
    };
    var isVideoElement = function(node) {
        return node.tagName === "VIDEO";
    };
    var isImageElement = function(node) {
        return node.tagName === "IMG";
    };
    var isIFrameElement = function(node) {
        return node.tagName === "IFRAME";
    };
    var isStyleElement = function(node) {
        return node.tagName === "STYLE";
    };
    var isScriptElement = function(node) {
        return node.tagName === "SCRIPT";
    };
    var isTextareaElement = function(node) {
        return node.tagName === "TEXTAREA";
    };
    var isSelectElement = function(node) {
        return node.tagName === "SELECT";
    };
    var isSlotElement = function(node) {
        return node.tagName === "SLOT";
    };
    // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
    var isCustomElement = function(node) {
        return node.tagName.indexOf("-") > 0;
    };
    var CounterState = /** @class */ function() {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function(name) {
            var counter = this.counters[name];
            if (counter && counter.length) return counter[counter.length - 1];
            return 1;
        };
        CounterState.prototype.getCounterValues = function(name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function(counters) {
            var _this = this;
            counters.forEach(function(counter) {
                return _this.counters[counter].pop();
            });
        };
        CounterState.prototype.parse = function(style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) counterIncrement.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                if (counter && entry.increment !== 0) {
                    canReset = false;
                    if (!counter.length) counter.push(1);
                    counter[Math.max(0, counter.length - 1)] += entry.increment;
                }
            });
            var counterNames = [];
            if (canReset) counterReset.forEach(function(entry) {
                var counter = _this.counters[entry.counter];
                counterNames.push(entry.counter);
                if (!counter) counter = _this.counters[entry.counter] = [];
                counter.push(entry.reset);
            });
            return counterNames;
        };
        return CounterState;
    }();
    var ROMAN_UPPER = {
        integers: [
            1000,
            900,
            500,
            400,
            100,
            90,
            50,
            40,
            10,
            9,
            5,
            4,
            1
        ],
        values: [
            "M",
            "CM",
            "D",
            "CD",
            "C",
            "XC",
            "L",
            "XL",
            "X",
            "IX",
            "V",
            "IV",
            "I"
        ]
    };
    var ARMENIAN = {
        integers: [
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u0554",
            "\u0553",
            "\u0552",
            "\u0551",
            "\u0550",
            "\u054F",
            "\u054E",
            "\u054D",
            "\u054C",
            "\u054B",
            "\u054A",
            "\u0549",
            "\u0548",
            "\u0547",
            "\u0546",
            "\u0545",
            "\u0544",
            "\u0543",
            "\u0542",
            "\u0541",
            "\u0540",
            "\u053F",
            "\u053E",
            "\u053D",
            "\u053C",
            "\u053B",
            "\u053A",
            "\u0539",
            "\u0538",
            "\u0537",
            "\u0536",
            "\u0535",
            "\u0534",
            "\u0533",
            "\u0532",
            "\u0531"
        ]
    };
    var HEBREW = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            19,
            18,
            17,
            16,
            15,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u05D9\u05F3",
            "\u05D8\u05F3",
            "\u05D7\u05F3",
            "\u05D6\u05F3",
            "\u05D5\u05F3",
            "\u05D4\u05F3",
            "\u05D3\u05F3",
            "\u05D2\u05F3",
            "\u05D1\u05F3",
            "\u05D0\u05F3",
            "\u05EA",
            "\u05E9",
            "\u05E8",
            "\u05E7",
            "\u05E6",
            "\u05E4",
            "\u05E2",
            "\u05E1",
            "\u05E0",
            "\u05DE",
            "\u05DC",
            "\u05DB",
            "\u05D9\u05D8",
            "\u05D9\u05D7",
            "\u05D9\u05D6",
            "\u05D8\u05D6",
            "\u05D8\u05D5",
            "\u05D9",
            "\u05D8",
            "\u05D7",
            "\u05D6",
            "\u05D5",
            "\u05D4",
            "\u05D3",
            "\u05D2",
            "\u05D1",
            "\u05D0"
        ]
    };
    var GEORGIAN = {
        integers: [
            10000,
            9000,
            8000,
            7000,
            6000,
            5000,
            4000,
            3000,
            2000,
            1000,
            900,
            800,
            700,
            600,
            500,
            400,
            300,
            200,
            100,
            90,
            80,
            70,
            60,
            50,
            40,
            30,
            20,
            10,
            9,
            8,
            7,
            6,
            5,
            4,
            3,
            2,
            1
        ],
        values: [
            "\u10F5",
            "\u10F0",
            "\u10EF",
            "\u10F4",
            "\u10EE",
            "\u10ED",
            "\u10EC",
            "\u10EB",
            "\u10EA",
            "\u10E9",
            "\u10E8",
            "\u10E7",
            "\u10E6",
            "\u10E5",
            "\u10E4",
            "\u10F3",
            "\u10E2",
            "\u10E1",
            "\u10E0",
            "\u10DF",
            "\u10DE",
            "\u10DD",
            "\u10F2",
            "\u10DC",
            "\u10DB",
            "\u10DA",
            "\u10D9",
            "\u10D8",
            "\u10D7",
            "\u10F1",
            "\u10D6",
            "\u10D5",
            "\u10D4",
            "\u10D3",
            "\u10D2",
            "\u10D1",
            "\u10D0"
        ]
    };
    var createAdditiveCounter = function(value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) return createCounterText(value, fallback, suffix.length > 0);
        return symbols.integers.reduce(function(string, integer, index) {
            while(value >= integer){
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, "") + suffix;
    };
    var createCounterStyleWithSymbolResolver = function(value, codePointRangeLength, isNumeric, resolver) {
        var string = "";
        do {
            if (!isNumeric) value--;
            string = resolver(value) + string;
            value /= codePointRangeLength;
        }while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function(value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return (value < 0 ? "-" : "") + (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function(codePoint) {
            return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
        }) + suffix);
    };
    var createCounterStyleFromSymbols = function(value, symbols, suffix) {
        if (suffix === void 0) suffix = ". ";
        var codePointRangeLength = symbols.length;
        return createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function(codePoint) {
            return symbols[Math.floor(codePoint % codePointRangeLength)];
        }) + suffix;
    };
    var CJK_ZEROS = 1;
    var CJK_TEN_COEFFICIENTS = 2;
    var CJK_TEN_HIGH_COEFFICIENTS = 4;
    var CJK_HUNDRED_COEFFICIENTS = 8;
    var createCJKCounter = function(value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) return createCounterText(value, 4 /* CJK_DECIMAL */ , suffix.length > 0);
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) return numbers[0] + string;
        for(var digit = 0; tmp > 0 && digit <= 4; digit++){
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== "") string = numbers[coefficient] + string;
            else if (coefficient > 1 || coefficient === 1 && digit === 0 || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS) || coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100 || coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS)) string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : "") + string;
            else if (coefficient === 1 && digit > 0) string = multipliers[digit - 1] + string;
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : "") + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = "\u5341\u767E\u5343\u842C";
    var CHINESE_FORMAL_MULTIPLIERS = "\u62FE\u4F70\u4EDF\u842C";
    var JAPANESE_NEGATIVE = "\u30DE\u30A4\u30CA\u30B9";
    var KOREAN_NEGATIVE = "\uB9C8\uC774\uB108\uC2A4";
    var createCounterText = function(value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? ". " : "";
        var cjkSuffix = appendSuffix ? "\u3001" : "";
        var koreanSuffix = appendSuffix ? ", " : "";
        var spaceSuffix = appendSuffix ? " " : "";
        switch(type){
            case 0 /* DISC */ :
                return "\u2022" + spaceSuffix;
            case 1 /* CIRCLE */ :
                return "\u25E6" + spaceSuffix;
            case 2 /* SQUARE */ :
                return "\u25FE" + spaceSuffix;
            case 5 /* DECIMAL_LEADING_ZERO */ :
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case 4 /* CJK_DECIMAL */ :
                return createCounterStyleFromSymbols(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", cjkSuffix);
            case 6 /* LOWER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 7 /* UPPER_ROMAN */ :
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */ , defaultSuffix);
            case 8 /* LOWER_GREEK */ :
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case 9 /* LOWER_ALPHA */ :
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case 10 /* UPPER_ALPHA */ :
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case 11 /* ARABIC_INDIC */ :
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case 12 /* ARMENIAN */ :
            case 49 /* UPPER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 35 /* LOWER_ARMENIAN */ :
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */ , defaultSuffix).toLowerCase();
            case 13 /* BENGALI */ :
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case 14 /* CAMBODIAN */ :
            case 30 /* KHMER */ :
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case 15 /* CJK_EARTHLY_BRANCH */ :
                return createCounterStyleFromSymbols(value, "\u5B50\u4E11\u5BC5\u536F\u8FB0\u5DF3\u5348\u672A\u7533\u9149\u620C\u4EA5", cjkSuffix);
            case 16 /* CJK_HEAVENLY_STEM */ :
                return createCounterStyleFromSymbols(value, "\u7532\u4E59\u4E19\u4E01\u620A\u5DF1\u5E9A\u8F9B\u58EC\u7678", cjkSuffix);
            case 17 /* CJK_IDEOGRAPHIC */ :
            case 48 /* TRAD_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 47 /* TRAD_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u8086\u4F0D\u9678\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8CA0", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 42 /* SIMP_CHINESE_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", CHINESE_INFORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 41 /* SIMP_CHINESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8D30\u53C1\u8086\u4F0D\u9646\u67D2\u634C\u7396", CHINESE_FORMAL_MULTIPLIERS, "\u8D1F", cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 26 /* JAPANESE_INFORMAL */ :
                return createCJKCounter(value, "\u3007\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, 0);
            case 25 /* JAPANESE_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F1\u5F10\u53C2\u56DB\u4F0D\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343\u4E07", JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 31 /* KOREAN_HANGUL_FORMAL */ :
                return createCJKCounter(value, "\uC601\uC77C\uC774\uC0BC\uC0AC\uC624\uC721\uCE60\uD314\uAD6C", "\uC2ED\uBC31\uCC9C\uB9CC", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 33 /* KOREAN_HANJA_INFORMAL */ :
                return createCJKCounter(value, "\u96F6\u4E00\u4E8C\u4E09\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u5341\u767E\u5343\u842C", KOREAN_NEGATIVE, koreanSuffix, 0);
            case 32 /* KOREAN_HANJA_FORMAL */ :
                return createCJKCounter(value, "\u96F6\u58F9\u8CB3\u53C3\u56DB\u4E94\u516D\u4E03\u516B\u4E5D", "\u62FE\u767E\u5343", KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 18 /* DEVANAGARI */ :
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case 20 /* GEORGIAN */ :
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* DECIMAL */ , defaultSuffix);
            case 21 /* GUJARATI */ :
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case 22 /* GURMUKHI */ :
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case 22 /* HEBREW */ :
                return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* DECIMAL */ , defaultSuffix);
            case 23 /* HIRAGANA */ :
                return createCounterStyleFromSymbols(value, "\u3042\u3044\u3046\u3048\u304A\u304B\u304D\u304F\u3051\u3053\u3055\u3057\u3059\u305B\u305D\u305F\u3061\u3064\u3066\u3068\u306A\u306B\u306C\u306D\u306E\u306F\u3072\u3075\u3078\u307B\u307E\u307F\u3080\u3081\u3082\u3084\u3086\u3088\u3089\u308A\u308B\u308C\u308D\u308F\u3090\u3091\u3092\u3093");
            case 24 /* HIRAGANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u3044\u308D\u306F\u306B\u307B\u3078\u3068\u3061\u308A\u306C\u308B\u3092\u308F\u304B\u3088\u305F\u308C\u305D\u3064\u306D\u306A\u3089\u3080\u3046\u3090\u306E\u304A\u304F\u3084\u307E\u3051\u3075\u3053\u3048\u3066\u3042\u3055\u304D\u3086\u3081\u307F\u3057\u3091\u3072\u3082\u305B\u3059");
            case 27 /* KANNADA */ :
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case 28 /* KATAKANA */ :
                return createCounterStyleFromSymbols(value, "\u30A2\u30A4\u30A6\u30A8\u30AA\u30AB\u30AD\u30AF\u30B1\u30B3\u30B5\u30B7\u30B9\u30BB\u30BD\u30BF\u30C1\u30C4\u30C6\u30C8\u30CA\u30CB\u30CC\u30CD\u30CE\u30CF\u30D2\u30D5\u30D8\u30DB\u30DE\u30DF\u30E0\u30E1\u30E2\u30E4\u30E6\u30E8\u30E9\u30EA\u30EB\u30EC\u30ED\u30EF\u30F0\u30F1\u30F2\u30F3", cjkSuffix);
            case 29 /* KATAKANA_IROHA */ :
                return createCounterStyleFromSymbols(value, "\u30A4\u30ED\u30CF\u30CB\u30DB\u30D8\u30C8\u30C1\u30EA\u30CC\u30EB\u30F2\u30EF\u30AB\u30E8\u30BF\u30EC\u30BD\u30C4\u30CD\u30CA\u30E9\u30E0\u30A6\u30F0\u30CE\u30AA\u30AF\u30E4\u30DE\u30B1\u30D5\u30B3\u30A8\u30C6\u30A2\u30B5\u30AD\u30E6\u30E1\u30DF\u30B7\u30F1\u30D2\u30E2\u30BB\u30B9", cjkSuffix);
            case 34 /* LAO */ :
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case 37 /* MONGOLIAN */ :
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case 38 /* MYANMAR */ :
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case 39 /* ORIYA */ :
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case 40 /* PERSIAN */ :
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case 43 /* TAMIL */ :
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case 44 /* TELUGU */ :
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case 45 /* THAI */ :
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case 46 /* TIBETAN */ :
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case 3 /* DECIMAL */ :
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };
    var IGNORE_ATTRIBUTE = "data-html2canvas-ignore";
    var DocumentCloner = /** @class */ function() {
        function DocumentCloner(context, element, options) {
            this.context = context;
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) throw new Error("Cloned element does not have an owner document");
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
        }
        DocumentCloner.prototype.toIFrame = function(ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) return Promise.reject("Unable to find iframe window");
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */ var iframeLoad = iframeLoader(iframe).then(function() {
                return __awaiter(_this, void 0, void 0, function() {
                    var onclone, referenceElement;
                    return __generator(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                this.scrolledElements.forEach(restoreNodeScroll);
                                if (cloneWindow) {
                                    cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                    if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) && (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                        this.context.logger.warn("Unable to restore scroll position for cloned document");
                                        this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                                    }
                                }
                                onclone = this.options.onclone;
                                referenceElement = this.clonedReferenceElement;
                                if (typeof referenceElement === "undefined") return [
                                    2 /*return*/ ,
                                    Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")
                                ];
                                if (!(documentClone.fonts && documentClone.fonts.ready)) return [
                                    3 /*break*/ ,
                                    2
                                ];
                                return [
                                    4 /*yield*/ ,
                                    documentClone.fonts.ready
                                ];
                            case 1:
                                _a.sent();
                                _a.label = 2;
                            case 2:
                                if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [
                                    3 /*break*/ ,
                                    4
                                ];
                                return [
                                    4 /*yield*/ ,
                                    imagesReady(documentClone)
                                ];
                            case 3:
                                _a.sent();
                                _a.label = 4;
                            case 4:
                                if (typeof onclone === "function") return [
                                    2 /*return*/ ,
                                    Promise.resolve().then(function() {
                                        return onclone(documentClone, referenceElement);
                                    }).then(function() {
                                        return iframe;
                                    })
                                ];
                                return [
                                    2 /*return*/ ,
                                    iframe
                                ];
                        }
                    });
                });
            });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function(node) {
            if (isDebugging(node, 2 /* CLONE */ )) debugger;
            if (isCanvasElement(node)) return this.createCanvasClone(node);
            if (isVideoElement(node)) return this.createVideoClone(node);
            if (isStyleElement(node)) return this.createStyleClone(node);
            var clone = node.cloneNode(false);
            if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                    clone.src = node.currentSrc;
                    clone.srcset = "";
                }
                if (clone.loading === "lazy") clone.loading = "eager";
            }
            if (isCustomElement(clone)) return this.createCustomElementClone(clone);
            return clone;
        };
        DocumentCloner.prototype.createCustomElementClone = function(node) {
            var clone = document.createElement("html2canvascustomelement");
            copyCSSStyles(node.style, clone);
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function(node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function(css, rule) {
                        if (rule && typeof rule.cssText === "string") return css + rule.cssText;
                        return css;
                    }, "");
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            } catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                this.context.logger.error("Unable to access cssRules property", e);
                if (e.name !== "SecurityError") throw e;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function(canvas) {
            var _a;
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement("img");
                try {
                    img.src = canvas.toDataURL();
                    return img;
                } catch (e) {
                    this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext("2d");
                var clonedCtx = clonedCanvas.getContext("2d");
                if (clonedCtx) {
                    if (!this.options.allowTaint && ctx) clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    else {
                        var gl = (_a = canvas.getContext("webgl2")) !== null && _a !== void 0 ? _a : canvas.getContext("webgl");
                        if (gl) {
                            var attribs = gl.getContextAttributes();
                            if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) this.context.logger.warn("Unable to clone WebGL context as it has preserveDrawingBuffer=false", canvas);
                        }
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            } catch (e) {
                this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
            }
            return clonedCanvas;
        };
        DocumentCloner.prototype.createVideoClone = function(video) {
            var canvas = video.ownerDocument.createElement("canvas");
            canvas.width = video.offsetWidth;
            canvas.height = video.offsetHeight;
            var ctx = canvas.getContext("2d");
            try {
                if (ctx) {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    if (!this.options.allowTaint) ctx.getImageData(0, 0, canvas.width, canvas.height);
                }
                return canvas;
            } catch (e) {
                this.context.logger.info("Unable to clone video as it is tainted", video);
            }
            var blankCanvas = video.ownerDocument.createElement("canvas");
            blankCanvas.width = video.offsetWidth;
            blankCanvas.height = video.offsetHeight;
            return blankCanvas;
        };
        DocumentCloner.prototype.appendChildNode = function(clone, child, copyStyles) {
            if (!isElementNode(child) || !isScriptElement(child) && !child.hasAttribute(IGNORE_ATTRIBUTE) && (typeof this.options.ignoreElements !== "function" || !this.options.ignoreElements(child))) {
                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) clone.appendChild(this.cloneNode(child, copyStyles));
            }
        };
        DocumentCloner.prototype.cloneChildNodes = function(node, clone, copyStyles) {
            var _this = this;
            for(var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling)if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === "function") {
                var assignedNodes = child.assignedNodes();
                if (assignedNodes.length) assignedNodes.forEach(function(assignedNode) {
                    return _this.appendChildNode(clone, assignedNode, copyStyles);
                });
            } else this.appendChildNode(clone, child, copyStyles);
        };
        DocumentCloner.prototype.cloneNode = function(node, copyStyles) {
            if (isTextNode(node)) return document.createTextNode(node.data);
            if (!node.ownerDocument) return node.cloneNode(false);
            var window1 = node.ownerDocument.defaultView;
            if (window1 && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                clone.style.transitionProperty = "none";
                var style = window1.getComputedStyle(node);
                var styleBefore = window1.getComputedStyle(node, ":before");
                var styleAfter = window1.getComputedStyle(node, ":after");
                if (this.referenceElement === node && isHTMLElementNode(clone)) this.clonedReferenceElement = clone;
                if (isBodyElement(clone)) createPseudoHideStyles(clone);
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                if (isCustomElement(node)) copyStyles = true;
                if (!isVideoElement(node)) this.cloneChildNodes(node, clone, copyStyles);
                if (before) clone.insertBefore(before, clone.firstChild);
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) clone.appendChild(after);
                this.counters.pop(counters);
                if (style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node) || copyStyles) copyCSSStyles(style, clone);
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) this.scrolledElements.push([
                    clone,
                    node.scrollLeft,
                    node.scrollTop
                ]);
                if ((isTextareaElement(node) || isSelectElement(node)) && (isTextareaElement(clone) || isSelectElement(clone))) clone.value = node.value;
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function(node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) return;
            var value = style.content;
            var document1 = clone.ownerDocument;
            if (!document1 || !value || value === "none" || value === "-moz-alt-content" || style.display === "none") return;
            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
            var declaration = new CSSParsedPseudoDeclaration(this.context, style);
            var anonymousReplacedElement = document1.createElement("html2canvaspseudoelement");
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function(token) {
                if (token.type === 0 /* STRING_TOKEN */ ) anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                else if (token.type === 22 /* URL_TOKEN */ ) {
                    var img = document1.createElement("img");
                    img.src = token.value;
                    img.style.opacity = "1";
                    anonymousReplacedElement.appendChild(img);
                } else if (token.type === 18 /* FUNCTION */ ) {
                    if (token.name === "attr") {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) anonymousReplacedElement.appendChild(document1.createTextNode(node.getAttribute(attr[0].value) || ""));
                    } else if (token.name === "counter") {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            anonymousReplacedElement.appendChild(document1.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    } else if (token.name === "counters") {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle) ? listStyleType.parse(_this.context, counterStyle.value) : 3 /* DECIMAL */ ;
                            var separator = delim && delim.type === 0 /* STRING_TOKEN */  ? delim.value : "";
                            var text = counterStates.map(function(value) {
                                return createCounterText(value, counterType_1, false);
                            }).join(separator);
                            anonymousReplacedElement.appendChild(document1.createTextNode(text));
                        }
                    }
                } else if (token.type === 20 /* IDENT_TOKEN */ ) switch(token.value){
                    case "open-quote":
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                        break;
                    case "close-quote":
                        anonymousReplacedElement.appendChild(document1.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                        break;
                    default:
                        // safari doesn't parse string tokens correctly because of lack of quotes
                        anonymousReplacedElement.appendChild(document1.createTextNode(token.value));
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) clone.className.baseValue += newClassName;
            else clone.className += newClassName;
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function(container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }();
    var PseudoElementType;
    (function(PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function(ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement("iframe");
        cloneIframeContainer.className = "html2canvas-container";
        cloneIframeContainer.style.visibility = "hidden";
        cloneIframeContainer.style.position = "fixed";
        cloneIframeContainer.style.left = "-10000px";
        cloneIframeContainer.style.top = "0px";
        cloneIframeContainer.style.border = "0";
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = "no"; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, "true");
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var imageReady = function(img) {
        return new Promise(function(resolve) {
            if (img.complete) {
                resolve();
                return;
            }
            if (!img.src) {
                resolve();
                return;
            }
            img.onload = resolve;
            img.onerror = resolve;
        });
    };
    var imagesReady = function(document1) {
        return Promise.all([].slice.call(document1.images, 0).map(imageReady));
    };
    var iframeLoader = function(iframe) {
        return new Promise(function(resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) return reject("No window assigned for iframe");
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function() {
                cloneWindow.onload = iframe.onload = null;
                var interval = setInterval(function() {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === "complete") {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var ignoredStyleProperties = [
        "all",
        "d",
        "content" // Safari shows pseudoelements if content is set
    ];
    var copyCSSStyles = function(style, target) {
        // Edge does not provide value for cssText
        for(var i = style.length - 1; i >= 0; i--){
            var property = style.item(i);
            if (ignoredStyleProperties.indexOf(property) === -1) target.style.setProperty(property, style.getPropertyValue(property));
        }
        return target;
    };
    var serializeDoctype = function(doctype) {
        var str = "";
        if (doctype) {
            str += "<!DOCTYPE ";
            if (doctype.name) str += doctype.name;
            if (doctype.internalSubset) str += doctype.internalSubset;
            if (doctype.publicId) str += '"' + doctype.publicId + '"';
            if (doctype.systemId) str += '"' + doctype.systemId + '"';
            str += ">";
        }
        return str;
    };
    var restoreOwnerScroll = function(ownerDocument, x, y) {
        if (ownerDocument && ownerDocument.defaultView && (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) ownerDocument.defaultView.scrollTo(x, y);
    };
    var restoreNodeScroll = function(_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ":before";
    var PSEUDO_AFTER = ":after";
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = "___html2canvas___pseudoelement_before";
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = "___html2canvas___pseudoelement_after";
    var PSEUDO_HIDE_ELEMENT_STYLE = '{\n    content: "" !important;\n    display: none !important;\n}';
    var createPseudoHideStyles = function(body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function(body, styles) {
        var document1 = body.ownerDocument;
        if (document1) {
            var style = document1.createElement("style");
            style.textContent = styles;
            body.appendChild(style);
        }
    };
    var CacheStorage = /** @class */ function() {
        function CacheStorage() {}
        CacheStorage.getOrigin = function(url) {
            var link = CacheStorage._link;
            if (!link) return "about:blank";
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function(src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function(window1) {
            CacheStorage._link = window1.document.createElement("a");
            CacheStorage._origin = CacheStorage.getOrigin(window1.location.href);
        };
        CacheStorage._origin = "about:blank";
        return CacheStorage;
    }();
    var Cache = /** @class */ function() {
        function Cache(context, _options) {
            this.context = context;
            this._options = _options;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._cache = {};
        }
        Cache.prototype.addImage = function(src) {
            var result = Promise.resolve();
            if (this.has(src)) return result;
            if (isBlobImage(src) || isRenderable(src)) {
                (this._cache[src] = this.loadImage(src)).catch(function() {
                // prevent unhandled rejection
                });
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function(src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function(key) {
            return __awaiter(this, void 0, void 0, function() {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) && !isSameOrigin && !isBlobImage(key) && typeof this._options.proxy === "string" && FEATURES.SUPPORT_CORS_XHR && !useCORS;
                            if (!isSameOrigin && this._options.allowTaint === false && !isInlineImage(key) && !isBlobImage(key) && !useProxy && !useCORS) return [
                                2 /*return*/ 
                            ];
                            src = key;
                            if (!useProxy) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.proxy(src)
                            ];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            this.context.logger.debug("Added image " + key.substring(0, 256));
                            return [
                                4 /*yield*/ ,
                                new Promise(function(resolve, reject) {
                                    var img = new Image();
                                    img.onload = function() {
                                        return resolve(img);
                                    };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) img.crossOrigin = "anonymous";
                                    img.src = src;
                                    if (img.complete === true) // Inline XML images may fail to parse, throwing an Error later on
                                    setTimeout(function() {
                                        return resolve(img);
                                    }, 500);
                                    if (_this._options.imageTimeout > 0) setTimeout(function() {
                                        return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image");
                                    }, _this._options.imageTimeout);
                                })
                            ];
                        case 3:
                            return [
                                2 /*return*/ ,
                                _a.sent()
                            ];
                    }
                });
            });
        };
        Cache.prototype.has = function(key) {
            return typeof this._cache[key] !== "undefined";
        };
        Cache.prototype.keys = function() {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function(src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) throw new Error("No proxy defined");
            var key = src.substring(0, 256);
            return new Promise(function(resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? "blob" : "text";
                var xhr = new XMLHttpRequest();
                xhr.onload = function() {
                    if (xhr.status === 200) {
                        if (responseType === "text") resolve(xhr.response);
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener("load", function() {
                                return resolve(reader_1.result);
                            }, false);
                            reader_1.addEventListener("error", function(e) {
                                return reject(e);
                            }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    } else reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                };
                xhr.onerror = reject;
                var queryString = proxy.indexOf("?") > -1 ? "&" : "?";
                xhr.open("GET", "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== "text" && xhr instanceof XMLHttpRequest) xhr.responseType = responseType;
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function() {
                        return reject("Timed out (" + timeout_1 + "ms) proxying " + key);
                    };
                }
                xhr.send();
            });
        };
        return Cache;
    }();
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function(src) {
        return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src);
    };
    var isInlineImage = function(src) {
        return INLINE_IMG.test(src);
    };
    var isInlineBase64Image = function(src) {
        return INLINE_BASE64.test(src);
    };
    var isBlobImage = function(src) {
        return src.substr(0, 4) === "blob";
    };
    var isSVG = function(src) {
        return src.substr(-3).toLowerCase() === "svg" || INLINE_SVG.test(src);
    };
    var Vector = /** @class */ function() {
        function Vector(x, y) {
            this.type = 0 /* VECTOR */ ;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function(deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }();
    var lerp = function(a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ function() {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = 1 /* BEZIER_CURVE */ ;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function(t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function(deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function() {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }();
    var isBezierCurve = function(path) {
        return path.type === 1 /* BEZIER_CURVE */ ;
    };
    var BoundCurves = /** @class */ function() {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3, tlh - borderLeftWidth * 2 / 3, tlv - borderTopWidth * 2 / 3, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.topRightBorderDoubleInnerBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth * 2 / 3, trh - borderRightWidth * 2 / 3, trv - borderTopWidth * 2 / 3, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + borderTopWidth * 2 / 3);
            this.bottomRightBorderDoubleInnerBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth * 2 / 3, brv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.bottomLeftBorderDoubleInnerBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth * 2 / 3, bounds.top + leftHeight, blh - borderLeftWidth * 2 / 3, blv - borderBottomWidth * 2 / 3, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth * 2 / 3, bounds.top + bounds.height - borderBottomWidth * 2 / 3);
            this.topLeftBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT) : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT) : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox = tlh > 0 || tlv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox = trh > 0 || trv > 0 ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox = brh > 0 || brv > 0 ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT) : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox = blh > 0 || blv > 0 ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT) : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
        return BoundCurves;
    }();
    var CORNER;
    (function(CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function(x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch(position){
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function(curves) {
        return [
            curves.topLeftBorderBox,
            curves.topRightBorderBox,
            curves.bottomRightBorderBox,
            curves.bottomLeftBorderBox
        ];
    };
    var calculateContentBoxPath = function(curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function(curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };
    var TransformEffect = /** @class */ function() {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.type = 0 /* TRANSFORM */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return TransformEffect;
    }();
    var ClipEffect = /** @class */ function() {
        function ClipEffect(path, target) {
            this.path = path;
            this.target = target;
            this.type = 1 /* CLIP */ ;
        }
        return ClipEffect;
    }();
    var OpacityEffect = /** @class */ function() {
        function OpacityEffect(opacity) {
            this.opacity = opacity;
            this.type = 2 /* OPACITY */ ;
            this.target = 6 /* CONTENT */ ;
        }
        return OpacityEffect;
    }();
    var isTransformEffect = function(effect) {
        return effect.type === 0 /* TRANSFORM */ ;
    };
    var isClipEffect = function(effect) {
        return effect.type === 1 /* CLIP */ ;
    };
    var isOpacityEffect = function(effect) {
        return effect.type === 2 /* OPACITY */ ;
    };
    var equalPath = function(a, b) {
        if (a.length === b.length) return a.some(function(v, i) {
            return v === b[i];
        });
        return false;
    };
    var transformPath = function(path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function(point, index) {
            switch(index){
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };
    var StackingContext = /** @class */ function() {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }();
    var ElementPaint = /** @class */ function() {
        function ElementPaint(container, parent) {
            this.container = container;
            this.parent = parent;
            this.effects = [];
            this.curves = new BoundCurves(this.container);
            if (this.container.styles.opacity < 1) this.effects.push(new OpacityEffect(this.container.styles.opacity));
            if (this.container.styles.transform !== null) {
                var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
                var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
                var matrix = this.container.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (this.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) this.effects.push(new ClipEffect(borderBox, 6 /* CONTENT */ ));
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ ));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */ ));
                }
            }
        }
        ElementPaint.prototype.getEffects = function(target) {
            var inFlow = [
                2 /* ABSOLUTE */ ,
                3 /* FIXED */ 
            ].indexOf(this.container.styles.position) === -1;
            var parent = this.parent;
            var effects = this.effects.slice(0);
            while(parent){
                var croplessEffects = parent.effects.filter(function(effect) {
                    return !isClipEffect(effect);
                });
                if (inFlow || parent.container.styles.position !== 0 /* STATIC */  || !parent.parent) {
                    effects.unshift.apply(effects, croplessEffects);
                    inFlow = [
                        2 /* ABSOLUTE */ ,
                        3 /* FIXED */ 
                    ].indexOf(parent.container.styles.position) === -1;
                    if (parent.container.styles.overflowX !== 0 /* VISIBLE */ ) {
                        var borderBox = calculateBorderBoxPath(parent.curves);
                        var paddingBox = calculatePaddingBoxPath(parent.curves);
                        if (!equalPath(borderBox, paddingBox)) effects.unshift(new ClipEffect(paddingBox, 6 /* CONTENT */ ));
                    }
                } else effects.unshift.apply(effects, croplessEffects);
                parent = parent.parent;
            }
            return effects.filter(function(effect) {
                return contains(effect.target, target);
            });
        };
        return ElementPaint;
    }();
    var parseStackTree = function(parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function(child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */ );
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */ );
            var paintContainer = new ElementPaint(child, parent);
            if (contains(child.styles.display, 2048 /* LIST_ITEM */ )) listItems.push(paintContainer);
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */ ) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function(current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            } else if (index_1 > 0) return true;
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    } else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function(current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            } else if (index_2 > 0) return true;
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    } else parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                } else if (child.styles.isFloating()) parentStack.nonPositionedFloats.push(stack);
                else parentStack.nonPositionedInlineLevel.push(stack);
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            } else {
                if (child.styles.isInlineLevel()) stackingContext.inlineLevel.push(paintContainer);
                else stackingContext.nonInlineLevel.push(paintContainer);
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */ )) processListItems(child, listOwnerItems);
        });
    };
    var processListItems = function(owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for(var i = 0; i < elements.length; i++){
            var item = elements[i];
            if (item.container instanceof LIElementContainer && typeof item.container.value === "number" && item.container.value !== 0) numbering = item.container.value;
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function(container) {
        var paintContainer = new ElementPaint(container, null);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };
    var parsePathForBorder = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderDoubleOuter = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    var parsePathForBorderDoubleInner = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderStroke = function(curves, borderSide) {
        switch(borderSide){
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    var createStrokePathFromCurves = function(outer1, outer2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        return path;
    };
    var createPathFromCurves = function(outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) path.push(outer1.subdivide(0.5, false));
        else path.push(outer1);
        if (isBezierCurve(outer2)) path.push(outer2.subdivide(0.5, true));
        else path.push(outer2);
        if (isBezierCurve(inner2)) path.push(inner2.subdivide(0.5, true).reverse());
        else path.push(inner2);
        if (isBezierCurve(inner1)) path.push(inner1.subdivide(0.5, false).reverse());
        else path.push(inner1);
        return path;
    };
    var paddingBox = function(element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function(element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };
    var calculateBackgroundPositioningArea = function(backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundOrigin === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function(backgroundClip, element) {
        if (backgroundClip === 0 /* BORDER_BOX */ ) return element.bounds;
        if (backgroundClip === 2 /* CONTENT_BOX */ ) return contentBox(element);
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function(container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [
            path,
            offsetX,
            offsetY,
            sizeWidth,
            sizeHeight
        ];
    };
    var isAuto = function(token) {
        return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO;
    };
    var hasIntrinsicValue = function(value) {
        return typeof value === "number";
    };
    var calculateBackgroundSize = function(size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (!first) return [
            0,
            0
        ];
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) return [
            getAbsoluteValue(first, bounds.width),
            getAbsoluteValue(second, bounds.height)
        ];
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER) ? [
                    bounds.width,
                    bounds.width / intrinsicProportion
                ] : [
                    bounds.height * intrinsicProportion,
                    bounds.height
                ];
            }
            return [
                bounds.width,
                bounds.height
            ];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) return [
                intrinsicWidth,
                intrinsicHeight
            ];
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) return [
                bounds.width,
                bounds.height
            ];
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth ? intrinsicWidth : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight ? intrinsicHeight : intrinsicWidth / intrinsicProportion;
                return [
                    width_1,
                    height_1
                ];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [
                width_2,
                height_2
            ];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) width_3 = getAbsoluteValue(first, bounds.width);
            else if (isLengthPercentage(second)) height_3 = getAbsoluteValue(second, bounds.height);
            if (isAuto(first)) width_3 = height_3 * intrinsicProportion;
            else if (!second || isAuto(second)) height_3 = width_3 / intrinsicProportion;
            return [
                width_3,
                height_3
            ];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) width = getAbsoluteValue(first, bounds.width);
        else if (second && isLengthPercentage(second)) height = getAbsoluteValue(second, bounds.height);
        if (width !== null && (!second || isAuto(second))) height = hasIntrinsicWidth && hasIntrinsicHeight ? width / intrinsicWidth * intrinsicHeight : bounds.height;
        if (height !== null && isAuto(first)) width = hasIntrinsicWidth && hasIntrinsicHeight ? height / intrinsicHeight * intrinsicWidth : bounds.width;
        if (width !== null && height !== null) return [
            width,
            height
        ];
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function(values, index) {
        var value = values[index];
        if (typeof value === "undefined") return values[0];
        return value;
    };
    var calculateBackgroundRepeatPath = function(repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch(repeat){
            case 2 /* REPEAT_X */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case 3 /* REPEAT_Y */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case 1 /* NO_REPEAT */ :
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };
    var SMALL_IMAGE = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
    var SAMPLE_TEXT = "Hidden Text";
    var FontMetrics = /** @class */ function() {
        function FontMetrics(document1) {
            this._data = {};
            this._document = document1;
        }
        FontMetrics.prototype.parseMetrics = function(fontFamily, fontSize) {
            var container = this._document.createElement("div");
            var img = this._document.createElement("img");
            var span = this._document.createElement("span");
            var body = this._document.body;
            container.style.visibility = "hidden";
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = "0";
            container.style.padding = "0";
            container.style.whiteSpace = "nowrap";
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = "0";
            img.style.padding = "0";
            img.style.verticalAlign = "baseline";
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = "0";
            span.style.padding = "0";
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = "normal";
            img.style.verticalAlign = "super";
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return {
                baseline: baseline,
                middle: middle
            };
        };
        FontMetrics.prototype.getMetrics = function(fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === "undefined") this._data[key] = this.parseMetrics(fontFamily, fontSize);
            return this._data[key];
        };
        return FontMetrics;
    }();
    var Renderer = /** @class */ function() {
        function Renderer(context, options) {
            this.context = context;
            this.options = options;
        }
        return Renderer;
    }();
    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ function(_super) {
        __extends(CanvasRenderer, _super);
        function CanvasRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this._activeEffects = [];
            _this.canvas = options.canvas ? options.canvas : document.createElement("canvas");
            _this.ctx = _this.canvas.getContext("2d");
            if (!options.canvas) {
                _this.canvas.width = Math.floor(options.width * options.scale);
                _this.canvas.height = Math.floor(options.height * options.scale);
                _this.canvas.style.width = options.width + "px";
                _this.canvas.style.height = options.height + "px";
            }
            _this.fontMetrics = new FontMetrics(document);
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.ctx.textBaseline = "bottom";
            _this._activeEffects = [];
            _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
            return _this;
        }
        CanvasRenderer.prototype.applyEffects = function(effects) {
            var _this = this;
            while(this._activeEffects.length)this.popEffect();
            effects.forEach(function(effect) {
                return _this.applyEffect(effect);
            });
        };
        CanvasRenderer.prototype.applyEffect = function(effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) this.ctx.globalAlpha = effect.opacity;
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function() {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var styles;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderStackContent(stack)
                            ];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (contains(paint.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            if (!paint.container.styles.isVisible()) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(paint)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(paint)
                            ];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function(text, letterSpacing, baseline) {
            var _this = this;
            if (letterSpacing === 0) this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
            else {
                var letters = segmentGraphemes(text.text);
                letters.reduce(function(left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + baseline);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function(styles) {
            var fontVariant = styles.fontVariant.filter(function(variant) {
                return variant === "normal" || variant === "small-caps";
            }).join("");
            var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(", ");
            var fontSize = isDimensionToken(styles.fontSize) ? "" + styles.fontSize.number + styles.fontSize.unit : styles.fontSize.number + "px";
            return [
                [
                    styles.fontStyle,
                    fontVariant,
                    styles.fontWeight,
                    fontSize,
                    fontFamily
                ].join(" "),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function(text, styles) {
            return __awaiter(this, void 0, void 0, function() {
                var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder;
                var _this = this;
                return __generator(this, function(_c) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    this.ctx.direction = styles.direction === 1 /* RTL */  ? "rtl" : "ltr";
                    this.ctx.textAlign = "left";
                    this.ctx.textBaseline = "alphabetic";
                    _b = this.fontMetrics.getMetrics(fontFamily, fontSize), baseline = _b.baseline, middle = _b.middle;
                    paintOrder = styles.paintOrder;
                    text.textBounds.forEach(function(text) {
                        paintOrder.forEach(function(paintOrderLayer) {
                            switch(paintOrderLayer){
                                case 0 /* FILL */ :
                                    _this.ctx.fillStyle = asString(styles.color);
                                    _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                    var textShadows = styles.textShadow;
                                    if (textShadows.length && text.text.trim().length) {
                                        textShadows.slice(0).reverse().forEach(function(textShadow) {
                                            _this.ctx.shadowColor = asString(textShadow.color);
                                            _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                            _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                            _this.ctx.shadowBlur = textShadow.blur.number;
                                            _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                        });
                                        _this.ctx.shadowColor = "";
                                        _this.ctx.shadowOffsetX = 0;
                                        _this.ctx.shadowOffsetY = 0;
                                        _this.ctx.shadowBlur = 0;
                                    }
                                    if (styles.textDecorationLine.length) {
                                        _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                                        styles.textDecorationLine.forEach(function(textDecorationLine) {
                                            switch(textDecorationLine){
                                                case 1 /* UNDERLINE */ :
                                                    // Draws a line at the baseline of the font
                                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
                                                    // need to take that into account both in position and size
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                                    break;
                                                case 2 /* OVERLINE */ :
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                                    break;
                                                case 3 /* LINE_THROUGH */ :
                                                    // TODO try and find exact position for line-through
                                                    _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                                    break;
                                            }
                                        });
                                    }
                                    break;
                                case 1 /* STROKE */ :
                                    if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                                        _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                        _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        _this.ctx.lineJoin = !!window.chrome ? "miter" : "round";
                                        _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
                                    }
                                    _this.ctx.strokeStyle = "";
                                    _this.ctx.lineWidth = 0;
                                    _this.ctx.lineJoin = "miter";
                                    break;
                            }
                        });
                    });
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function(container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var container, curves, styles, _i, _a, child, image, image, iframeRenderer, canvas, size, _b, fontFamily, fontSize, baseline, bounds, x, textBounds, img, image, url, fontFamily, bounds;
                return __generator(this, function(_c) {
                    switch(_c.label){
                        case 0:
                            this.applyEffects(paint.getEffects(4 /* CONTENT */ ));
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderTextNode(child, styles)
                            ];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [
                                3 /*break*/ ,
                                8
                            ];
                            _c.label = 5;
                        case 5:
                            _c.trys.push([
                                5,
                                7,
                                ,
                                8
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.src)
                            ];
                        case 6:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 7:
                            _c.sent();
                            this.context.logger.error("Error loading image " + container.src);
                            return [
                                3 /*break*/ ,
                                8
                            ];
                        case 8:
                            if (container instanceof CanvasElementContainer) this.renderReplacedElement(container, curves, container.canvas);
                            if (!(container instanceof SVGElementContainer)) return [
                                3 /*break*/ ,
                                12
                            ];
                            _c.label = 9;
                        case 9:
                            _c.trys.push([
                                9,
                                11,
                                ,
                                12
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(container.svg)
                            ];
                        case 10:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 11:
                            _c.sent();
                            this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
                            return [
                                3 /*break*/ ,
                                12
                            ];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [
                                3 /*break*/ ,
                                14
                            ];
                            iframeRenderer = new CanvasRenderer(this.context, {
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                width: container.width,
                                height: container.height
                            });
                            return [
                                4 /*yield*/ ,
                                iframeRenderer.render(container.tree)
                            ];
                        case 13:
                            canvas = _c.sent();
                            if (container.width && container.height) this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            _c.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                } else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                _b = this.createFontStyle(styles), fontFamily = _b[0], fontSize = _b[1];
                                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = "alphabetic";
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch(container.styles.textAlign){
                                    case 1 /* CENTER */ :
                                        x += bounds.width / 2;
                                        break;
                                    case 2 /* RIGHT */ :
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                                this.ctx.restore();
                                this.ctx.textBaseline = "alphabetic";
                                this.ctx.textAlign = "left";
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */ )) return [
                                3 /*break*/ ,
                                20
                            ];
                            if (!(container.styles.listStyleImage !== null)) return [
                                3 /*break*/ ,
                                19
                            ];
                            img = container.styles.listStyleImage;
                            if (!(img.type === 0 /* URL */ )) return [
                                3 /*break*/ ,
                                18
                            ];
                            image = void 0;
                            url = img.url;
                            _c.label = 15;
                        case 15:
                            _c.trys.push([
                                15,
                                17,
                                ,
                                18
                            ]);
                            return [
                                4 /*yield*/ ,
                                this.context.cache.match(url)
                            ];
                        case 16:
                            image = _c.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 17:
                            _c.sent();
                            this.context.logger.error("Error loading list-style-image " + url);
                            return [
                                3 /*break*/ ,
                                18
                            ];
                        case 18:
                            return [
                                3 /*break*/ ,
                                20
                            ];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== -1 /* NONE */ ) {
                                fontFamily = this.createFontStyle(styles)[0];
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = "middle";
                                this.ctx.textAlign = "right";
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                                this.ctx.textBaseline = "bottom";
                                this.ctx.textAlign = "left";
                            }
                            _c.label = 20;
                        case 20:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function(stack) {
            return __awaiter(this, void 0, void 0, function() {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function(_p) {
                    switch(_p.label){
                        case 0:
                            if (contains(stack.element.container.flags, 16 /* DEBUG_RENDER */ )) debugger;
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            return [
                                4 /*yield*/ ,
                                this.renderNodeBackgroundAndBorders(stack.element)
                            ];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                5
                            ];
                            child = _a[_i];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [
                                3 /*break*/ ,
                                2
                            ];
                        case 5:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            return [
                                4 /*yield*/ ,
                                this.renderNodeContent(stack.element)
                            ];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [
                                3 /*break*/ ,
                                10
                            ];
                            child = _c[_b];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [
                                3 /*break*/ ,
                                7
                            ];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [
                                3 /*break*/ ,
                                14
                            ];
                            child = _e[_d];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [
                                3 /*break*/ ,
                                18
                            ];
                            child = _g[_f];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [
                                3 /*break*/ ,
                                15
                            ];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [
                                3 /*break*/ ,
                                22
                            ];
                            child = _j[_h];
                            return [
                                4 /*yield*/ ,
                                this.renderNode(child)
                            ];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [
                                3 /*break*/ ,
                                19
                            ];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [
                                3 /*break*/ ,
                                26
                            ];
                            child = _l[_k];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [
                                3 /*break*/ ,
                                23
                            ];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [
                                3 /*break*/ ,
                                30
                            ];
                            child = _o[_m];
                            return [
                                4 /*yield*/ ,
                                this.renderStack(child)
                            ];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [
                                3 /*break*/ ,
                                27
                            ];
                        case 30:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function(paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function(paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function(paths) {
            var _this = this;
            paths.forEach(function(point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) _this.ctx.moveTo(start.x, start.y);
                else _this.ctx.lineTo(start.x, start.y);
                if (isBezierCurve(point)) _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
            });
        };
        CanvasRenderer.prototype.renderRepeat = function(path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function(image, width, height) {
            var _a;
            if (image.width === width && image.height === height) return image;
            var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
            var canvas = ownerDocument.createElement("canvas");
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            var ctx = canvas.getContext("2d");
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function(container) {
            return __awaiter(this, void 0, void 0, function() {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function(backgroundImage) {
                                var image, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position, x, y, _g, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function(_h) {
                                    switch(_h.label){
                                        case 0:
                                            if (!(backgroundImage.type === 0 /* URL */ )) return [
                                                3 /*break*/ ,
                                                5
                                            ];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _h.label = 1;
                                        case 1:
                                            _h.trys.push([
                                                1,
                                                3,
                                                ,
                                                4
                                            ]);
                                            return [
                                                4 /*yield*/ ,
                                                this_1.context.cache.match(url)
                                            ];
                                        case 2:
                                            image = _h.sent();
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 3:
                                            _h.sent();
                                            this_1.context.logger.error("Error loading background-image " + url);
                                            return [
                                                3 /*break*/ ,
                                                4
                                            ];
                                        case 4:
                                            if (image) {
                                                _c = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), "repeat");
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [
                                                3 /*break*/ ,
                                                6
                                            ];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                                                _e = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                                canvas = document.createElement("canvas");
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext("2d");
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function(colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, "repeat");
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            } else if (isRadialGradient(backgroundImage)) {
                                                _f = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                                position = backgroundImage.position.length === 0 ? [
                                                    FIFTY_PERCENT
                                                ] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _g = calculateRadius(backgroundImage, x, y, width, height), rx = _g[0], ry = _g[1];
                                                if (rx > 0 && ry > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function(colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    } else this_1.ctx.fill();
                                                }
                                            }
                                            _h.label = 6;
                                        case 6:
                                            index--;
                                            return [
                                                2 /*return*/ 
                                            ];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [
                                3 /*break*/ ,
                                4
                            ];
                            backgroundImage = _a[_i];
                            return [
                                5 /*yield**/ ,
                                _loop_1(backgroundImage)
                            ];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [
                                3 /*break*/ ,
                                1
                            ];
                        case 4:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderSolidBorder = function(color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                return __generator(this, function(_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.renderDoubleBorder = function(color, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function() {
                var outerPaths, innerPaths;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (!(width < 3)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(color, side, curvePoints)
                            ];
                        case 1:
                            _a.sent();
                            return [
                                2 /*return*/ 
                            ];
                        case 2:
                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                            this.path(outerPaths);
                            this.ctx.fillStyle = asString(color);
                            this.ctx.fill();
                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                            this.path(innerPaths);
                            this.ctx.fill();
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function(paint) {
            return __awaiter(this, void 0, void 0, function() {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            this.applyEffects(paint.getEffects(2 /* BACKGROUND_BORDERS */ ));
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                {
                                    style: styles.borderTopStyle,
                                    color: styles.borderTopColor,
                                    width: styles.borderTopWidth
                                },
                                {
                                    style: styles.borderRightStyle,
                                    color: styles.borderRightColor,
                                    width: styles.borderRightWidth
                                },
                                {
                                    style: styles.borderBottomStyle,
                                    color: styles.borderBottomColor,
                                    width: styles.borderBottomWidth
                                },
                                {
                                    style: styles.borderLeftStyle,
                                    color: styles.borderLeftColor,
                                    width: styles.borderLeftWidth
                                }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [
                                3 /*break*/ ,
                                2
                            ];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [
                                4 /*yield*/ ,
                                this.renderBackgroundImage(paint.container)
                            ];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow.slice(0).reverse().forEach(function(shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                } else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : "rgba(0,0,0,1)";
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [
                                3 /*break*/ ,
                                13
                            ];
                            border = borders_1[_i];
                            if (!(border.style !== 0 /* NONE */  && !isTransparent(border.color) && border.width > 0)) return [
                                3 /*break*/ ,
                                11
                            ];
                            if (!(border.style === 2 /* DASHED */ )) return [
                                3 /*break*/ ,
                                5
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2 /* DASHED */ )
                            ];
                        case 4:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 5:
                            if (!(border.style === 3 /* DOTTED */ )) return [
                                3 /*break*/ ,
                                7
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3 /* DOTTED */ )
                            ];
                        case 6:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 7:
                            if (!(border.style === 4 /* DOUBLE */ )) return [
                                3 /*break*/ ,
                                9
                            ];
                            return [
                                4 /*yield*/ ,
                                this.renderDoubleBorder(border.color, border.width, side, paint.curves)
                            ];
                        case 8:
                            _a.sent();
                            return [
                                3 /*break*/ ,
                                11
                            ];
                        case 9:
                            return [
                                4 /*yield*/ ,
                                this.renderSolidBorder(border.color, side, paint.curves)
                            ];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            side++;
                            _a.label = 12;
                        case 12:
                            _i++;
                            return [
                                3 /*break*/ ,
                                3
                            ];
                        case 13:
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderDashedDottedBorder = function(color, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function() {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function(_a) {
                    this.ctx.save();
                    strokePaths = parsePathForBorderStroke(curvePoints, side);
                    boxPaths = parsePathForBorder(curvePoints, side);
                    if (style === 2 /* DASHED */ ) {
                        this.path(boxPaths);
                        this.ctx.clip();
                    }
                    if (isBezierCurve(boxPaths[0])) {
                        startX = boxPaths[0].start.x;
                        startY = boxPaths[0].start.y;
                    } else {
                        startX = boxPaths[0].x;
                        startY = boxPaths[0].y;
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        endX = boxPaths[1].end.x;
                        endY = boxPaths[1].end.y;
                    } else {
                        endX = boxPaths[1].x;
                        endY = boxPaths[1].y;
                    }
                    if (side === 0 || side === 2) length = Math.abs(startX - endX);
                    else length = Math.abs(startY - endY);
                    this.ctx.beginPath();
                    if (style === 3 /* DOTTED */ ) this.formatPath(strokePaths);
                    else this.formatPath(boxPaths.slice(0, 2));
                    dashLength = width < 3 ? width * 3 : width * 2;
                    spaceLength = width < 3 ? width * 2 : width;
                    if (style === 3 /* DOTTED */ ) {
                        dashLength = width;
                        spaceLength = width;
                    }
                    useLineDash = true;
                    if (length <= dashLength * 2) useLineDash = false;
                    else if (length <= dashLength * 2 + spaceLength) {
                        multiplier = length / (2 * dashLength + spaceLength);
                        dashLength *= multiplier;
                        spaceLength *= multiplier;
                    } else {
                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                        spaceLength = maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace) ? minSpace : maxSpace;
                    }
                    if (useLineDash) {
                        if (style === 3 /* DOTTED */ ) this.ctx.setLineDash([
                            0,
                            dashLength + spaceLength
                        ]);
                        else this.ctx.setLineDash([
                            dashLength,
                            spaceLength
                        ]);
                    }
                    if (style === 3 /* DOTTED */ ) {
                        this.ctx.lineCap = "round";
                        this.ctx.lineWidth = width;
                    } else this.ctx.lineWidth = width * 2 + 1.1;
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    this.ctx.setLineDash([]);
                    // dashed round edge gap
                    if (style === 2 /* DASHED */ ) {
                        if (isBezierCurve(boxPaths[0])) {
                            path1 = boxPaths[3];
                            path2 = boxPaths[0];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                        if (isBezierCurve(boxPaths[1])) {
                            path1 = boxPaths[1];
                            path2 = boxPaths[2];
                            this.ctx.beginPath();
                            this.formatPath([
                                new Vector(path1.end.x, path1.end.y),
                                new Vector(path2.start.x, path2.start.y)
                            ]);
                            this.ctx.stroke();
                        }
                    }
                    this.ctx.restore();
                    return [
                        2 /*return*/ 
                    ];
                });
            });
        };
        CanvasRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var stack;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [
                                4 /*yield*/ ,
                                this.renderStack(stack)
                            ];
                        case 1:
                            _a.sent();
                            this.applyEffects([]);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return CanvasRenderer;
    }(Renderer);
    var isTextInputElement = function(container) {
        if (container instanceof TextareaElementContainer) return true;
        else if (container instanceof SelectElementContainer) return true;
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) return true;
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function(clip, curves) {
        switch(clip){
            case 0 /* BORDER_BOX */ :
                return calculateBorderBoxPath(curves);
            case 2 /* CONTENT_BOX */ :
                return calculateContentBoxPath(curves);
            case 1 /* PADDING_BOX */ :
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function(textAlign) {
        switch(textAlign){
            case 1 /* CENTER */ :
                return "center";
            case 2 /* RIGHT */ :
                return "right";
            case 0 /* LEFT */ :
            default:
                return "left";
        }
    };
    // see https://github.com/niklasvh/html2canvas/pull/2645
    var iOSBrokenFonts = [
        "-apple-system",
        "system-ui"
    ];
    var fixIOSSystemFonts = function(fontFamilies) {
        return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent) ? fontFamilies.filter(function(fontFamily) {
            return iOSBrokenFonts.indexOf(fontFamily) === -1;
        }) : fontFamilies;
    };
    var ForeignObjectRenderer = /** @class */ function(_super) {
        __extends(ForeignObjectRenderer, _super);
        function ForeignObjectRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this.canvas = options.canvas ? options.canvas : document.createElement("canvas");
            _this.ctx = _this.canvas.getContext("2d");
            _this.options = options;
            _this.canvas.width = Math.floor(options.width * options.scale);
            _this.canvas.height = Math.floor(options.height * options.scale);
            _this.canvas.style.width = options.width + "px";
            _this.canvas.style.height = options.height + "px";
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
            return _this;
        }
        ForeignObjectRenderer.prototype.render = function(element) {
            return __awaiter(this, void 0, void 0, function() {
                var svg, img;
                return __generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                            return [
                                4 /*yield*/ ,
                                loadSerializedSVG(svg)
                            ];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [
                                2 /*return*/ ,
                                this.canvas
                            ];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }(Renderer);
    var loadSerializedSVG = function(svg) {
        return new Promise(function(resolve, reject) {
            var img = new Image();
            img.onload = function() {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var Logger = /** @class */ function() {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== "undefined" && window.console && typeof console.debug === "function") // eslint-disable-next-line no-console
                console.debug.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.prototype.getTime = function() {
            return Date.now() - this.start;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) // eslint-disable-next-line no-console
            {
                if (typeof window !== "undefined" && window.console && typeof console.info === "function") // eslint-disable-next-line no-console
                console.info.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.warn = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== "undefined" && window.console && typeof console.warn === "function") // eslint-disable-next-line no-console
                console.warn.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== "undefined" && window.console && typeof console.error === "function") // eslint-disable-next-line no-console
                console.error.apply(console, __spreadArray([
                    this.id,
                    this.getTime() + "ms"
                ], args));
                else this.info.apply(this, args);
            }
        };
        Logger.instances = {};
        return Logger;
    }();
    var Context = /** @class */ function() {
        function Context(options, windowBounds) {
            var _a;
            this.windowBounds = windowBounds;
            this.instanceName = "#" + Context.instanceCount++;
            this.logger = new Logger({
                id: this.instanceName,
                enabled: options.logging
            });
            this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options);
        }
        Context.instanceCount = 1;
        return Context;
    }();
    var html2canvas = function(element, options) {
        if (options === void 0) options = {};
        return renderElement(element, options);
    };
    if (typeof window !== "undefined") CacheStorage.setContext(window);
    var renderElement = function(element, opts) {
        return __awaiter(void 0, void 0, void 0, function() {
            var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a, width, height, left, top, backgroundColor, renderOptions, canvas, renderer, root, renderer;
            var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
            return __generator(this, function(_u) {
                switch(_u.label){
                    case 0:
                        if (!element || typeof element !== "object") return [
                            2 /*return*/ ,
                            Promise.reject("Invalid element provided as first argument")
                        ];
                        ownerDocument = element.ownerDocument;
                        if (!ownerDocument) throw new Error("Element is not attached to a Document");
                        defaultView = ownerDocument.defaultView;
                        if (!defaultView) throw new Error("Document is not attached to a Window");
                        resourceOptions = {
                            allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
                            imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15000,
                            proxy: opts.proxy,
                            useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
                        };
                        contextOptions = __assign({
                            logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true,
                            cache: opts.cache
                        }, resourceOptions);
                        windowOptions = {
                            windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
                            windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
                            scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
                            scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
                        };
                        windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
                        context = new Context(contextOptions, windowBounds);
                        foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
                        cloneOptions = {
                            allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
                            onclone: opts.onclone,
                            ignoreElements: opts.ignoreElements,
                            inlineImages: foreignObjectRendering,
                            copyStyles: foreignObjectRendering
                        };
                        context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
                        documentCloner = new DocumentCloner(context, element, cloneOptions);
                        clonedElement = documentCloner.clonedReferenceElement;
                        if (!clonedElement) return [
                            2 /*return*/ ,
                            Promise.reject("Unable to find element in cloned iframe")
                        ];
                        return [
                            4 /*yield*/ ,
                            documentCloner.toIFrame(ownerDocument, windowBounds)
                        ];
                    case 1:
                        container = _u.sent();
                        _a = isBodyElement(clonedElement) || isHTMLElement(clonedElement) ? parseDocumentSize(clonedElement.ownerDocument) : parseBounds(context, clonedElement), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                        backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
                        renderOptions = {
                            canvas: opts.canvas,
                            backgroundColor: backgroundColor,
                            scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
                            x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
                            y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
                            width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
                            height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height)
                        };
                        if (!foreignObjectRendering) return [
                            3 /*break*/ ,
                            3
                        ];
                        context.logger.debug("Document cloned, using foreign object rendering");
                        renderer = new ForeignObjectRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(clonedElement)
                        ];
                    case 2:
                        canvas = _u.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
                        context.logger.debug("Starting DOM parsing");
                        root = parseTree(context, clonedElement);
                        if (backgroundColor === root.styles.backgroundColor) root.styles.backgroundColor = COLORS.TRANSPARENT;
                        context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
                        renderer = new CanvasRenderer(context, renderOptions);
                        return [
                            4 /*yield*/ ,
                            renderer.render(root)
                        ];
                    case 4:
                        canvas = _u.sent();
                        _u.label = 5;
                    case 5:
                        if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
                            if (!DocumentCloner.destroy(container)) context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                        context.logger.debug("Finished rendering");
                        return [
                            2 /*return*/ ,
                            canvas
                        ];
                }
            });
        });
    };
    var parseBackgroundColor = function(context, element, backgroundColorOverride) {
        var ownerDocument = element.ownerDocument;
        // http://www.w3.org/TR/css3-background/#special-backgrounds
        var documentBackgroundColor = ownerDocument.documentElement ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor) : COLORS.TRANSPARENT;
        var bodyBackgroundColor = ownerDocument.body ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor) : COLORS.TRANSPARENT;
        var defaultBackgroundColor = typeof backgroundColorOverride === "string" ? parseColor(context, backgroundColorOverride) : backgroundColorOverride === null ? COLORS.TRANSPARENT : 0xffffffff;
        return element === ownerDocument.documentElement ? isTransparent(documentBackgroundColor) ? isTransparent(bodyBackgroundColor) ? defaultBackgroundColor : bodyBackgroundColor : documentBackgroundColor : defaultBackgroundColor;
    };
    return html2canvas;
});

});

parcelRegister("jenAg", function(module, exports) {

$parcel$export(module.exports, "getListingStatus", () => $e0019e6236e0a7fd$export$8224da3637449c0b);

var $cstaF = parcelRequire("cstaF");

var $cstaF = parcelRequire("cstaF");
const $e0019e6236e0a7fd$export$8224da3637449c0b = (module, searchCriteria)=>{
    const selectedListingStatus = searchCriteria?.realEstateDatasourceIdsWithFilters[0].computedFields.find((field)=>field.fieldName === "transactionStatus")?.fieldValues[0];
    const listingStatuses = module === (0, $cstaF.modules).marketShare.totals ? (0, $cstaF.marketShareListingStatuses) : (0, $cstaF.marketShareListingStatusesCoverage);
    return listingStatuses[selectedListingStatus];
};

});

parcelRegister("ekOct", function(module, exports) {

$parcel$export(module.exports, "getFirstToolRoute", () => $a6f9dfaaf4e03125$export$fb5afc445af5e020);
$parcel$export(module.exports, "getAllowedModuleByUrl", () => $a6f9dfaaf4e03125$export$7504c19fe24ac84d);
$parcel$export(module.exports, "maskUrlVar", () => $a6f9dfaaf4e03125$export$40c17b339d89bf8a);
$parcel$export(module.exports, "unmaskUrlVar", () => $a6f9dfaaf4e03125$export$18cbb7443d154753);
$parcel$export(module.exports, "backButtonConfig", () => $a6f9dfaaf4e03125$export$6a61933a6e30ea04);
$parcel$export(module.exports, "exportModalByRoute", () => $a6f9dfaaf4e03125$export$fe4bb7cf235edf);

var $cstaF = parcelRequire("cstaF");

var $g7mFm = parcelRequire("g7mFm");

var $c7dF9 = parcelRequire("c7dF9");
const $a6f9dfaaf4e03125$export$fb5afc445af5e020 = (allowedModules, isDashboardEnabled)=>{
    if (isDashboardEnabled) return (0, $cstaF.moduleRoutes)[(0, $cstaF.modules).dashboard.dashboard];
    return (0, $cstaF.moduleRoutes)[$a6f9dfaaf4e03125$export$7386845f9a227559(allowedModules)];
};
const $a6f9dfaaf4e03125$export$7386845f9a227559 = (allowedModules)=>{
    const [_, defaultModule] = Object.entries((0, $cstaF.defaultModules)).find(([key])=>{
        return allowedModules?.includes(key);
    });
    return defaultModule;
};
const $a6f9dfaaf4e03125$export$7504c19fe24ac84d = ({ url: url, allowedModules: allowedModules, modulesByRouteAndNameAssociation: modulesByRouteAndNameAssociation })=>{
    const moduleByUrl = modulesByRouteAndNameAssociation.find(({ route: route })=>route === url);
    if (allowedModules?.includes(moduleByUrl?.moduleName)) return moduleByUrl?.module;
    return $a6f9dfaaf4e03125$export$7386845f9a227559(allowedModules);
};
const $a6f9dfaaf4e03125$export$40c17b339d89bf8a = (value)=>encodeURIComponent(value);
const $a6f9dfaaf4e03125$export$18cbb7443d154753 = (value)=>decodeURIComponent(value);
const $a6f9dfaaf4e03125$export$6a61933a6e30ea04 = {
    [(0, $g7mFm.officeBreakdownRoute)]: (history)=>{
        history.replace((0, $c7dF9.Routes).MARKET_DYNAMICS.BASE);
    },
    [(0, $g7mFm.listingsBreakdownRoute)]: (history)=>{
        history.replace((0, $c7dF9.Routes).MARKET_DYNAMICS.BASE);
    },
    [(0, $g7mFm.officeListingsRoute)]: (history)=>{
        history.replace((0, $g7mFm.officeBreakdownRoute));
    },
    [(0, $cstaF.searchRoutes).agentsGainedBreakdown]: (history, altBackRoute)=>{
        history.replace(altBackRoute || (0, $cstaF.searchRoutes).agentMovement);
    },
    [(0, $cstaF.searchRoutes).officeListBreakdown]: (history)=>{
        history.replace((0, $cstaF.searchRoutes).agentMovement);
    }
};
const $a6f9dfaaf4e03125$export$31076580e18fb46e = Object.freeze({
    [(0, $g7mFm.officeBreakdownRoute)]: (history)=>history.replace((0, $c7dF9.Routes).MARKET_DYNAMICS.BASE),
    [(0, $g7mFm.listingsBreakdownRoute)]: (history)=>history.replace((0, $c7dF9.Routes).MARKET_DYNAMICS.BASE)
});
const $a6f9dfaaf4e03125$export$fe4bb7cf235edf = [
    (0, $g7mFm.baseRoute),
    (0, $cstaF.searchRoutes).totals,
    (0, $cstaF.searchRoutes).coverage,
    (0, $cstaF.searchRoutes).agentMovement,
    (0, $cstaF.searchRoutes).agentDetail,
    (0, $cstaF.searchRoutes).agentProduction
];

});

parcelRegister("an08p", function(module, exports) {

$parcel$export(module.exports, "actions", () => $78cc281d722644e9$export$e324594224ef24da);

var $8cYiI = parcelRequire("8cYiI");
const $78cc281d722644e9$export$e324594224ef24da = (set)=>({
        setBackLinkTitle: (backLinkTitle)=>set((0, $8cYiI.produce)((state)=>{
                state.backNavbar.backLinkTitle = backLinkTitle;
            }), false, "setBackLinkTitle"),
        setBackNavbarTitle: (title)=>set((0, $8cYiI.produce)((state)=>{
                state.backNavbar.title = title;
            }), false, "setBackNavbarTitle")
    });

});

parcelRegister("35weQ", function(module, exports) {

$parcel$export(module.exports, "createTransactionCoveragePDFView", () => $23fad89a2a6aaa3e$export$f8828044e038f14b);
$parcel$export(module.exports, "inventoryView", () => $23fad89a2a6aaa3e$export$2d9f10c34ef0ef64);

var $eHBjM = parcelRequire("eHBjM");

var $ihvwF = parcelRequire("ihvwF");

var $98ROn = parcelRequire("98ROn");
const $23fad89a2a6aaa3e$export$f8828044e038f14b = (selectedAreaLabel)=>({
        id: (0, $eHBjM.tableViewNames).transactionCoveragePDF,
        tables: [
            {
                col: (0, $ihvwF.transactionCoveragePDFColumns).rank,
                colDef: (0, $98ROn.colSettings).textSm
            },
            {
                col: {
                    ...(0, $ihvwF.transactionCoveragePDFColumns).area,
                    label: selectedAreaLabel
                },
                colDef: (0, $98ROn.colSettings).textSmRightAlign
            },
            {
                col: (0, $ihvwF.transactionCoveragePDFColumns).totalUnits,
                colDef: (0, $98ROn.colSettings).numberSmUnits
            },
            {
                col: (0, $ihvwF.transactionCoveragePDFColumns).totalVolume,
                colDef: (0, $98ROn.colSettings).numberSmVolume
            },
            {
                col: (0, $ihvwF.transactionCoveragePDFColumns).totalUnitsPct,
                colDef: (0, $98ROn.colSettings).numberSmPercentage
            },
            {
                col: (0, $ihvwF.transactionCoveragePDFColumns).totalVolumePct,
                colDef: (0, $98ROn.colSettings).numberSmPercentage
            }
        ]
    });
const $23fad89a2a6aaa3e$export$2d9f10c34ef0ef64 = {
    id: (0, $eHBjM.tableViewNames).inventory,
    tables: [
        {
            col: (0, $eHBjM.agentsColumns).mlsNum,
            colDef: (0, $98ROn.colSettings).textSm
        },
        {
            col: (0, $eHBjM.agentsColumns).statusCode,
            colDef: (0, $98ROn.colSettings).textSm
        },
        {
            col: (0, $eHBjM.agentsColumns).typeName,
            colDef: (0, $98ROn.colSettings).textSm
        },
        {
            col: (0, $eHBjM.agentsColumns).address,
            colDef: (0, $98ROn.colSettings).textMd
        },
        {
            col: (0, $eHBjM.agentsColumns).contract,
            colDef: (0, $98ROn.colSettings).numberSmInteger
        },
        {
            col: (0, $eHBjM.agentsColumns).cdom,
            colDef: (0, $98ROn.colSettings).numberSmInteger
        },
        {
            col: (0, $eHBjM.agentsColumns).orgPrice,
            colDef: (0, $98ROn.colSettings).numberMdVolume
        },
        {
            col: (0, $eHBjM.agentsColumns).listPrice,
            colDef: (0, $98ROn.colSettings).numberMdVolume
        },
        {
            col: (0, $eHBjM.agentsColumns).priceChangeCnt,
            colDef: (0, $98ROn.colSettings).numberMdInteger
        }
    ]
};

});
parcelRegister("ihvwF", function(module, exports) {

$parcel$export(module.exports, "transactionCoveragePDFColumns", () => $d4f244e6c511875f$export$885b4ccacd7db28d);

var $eHBjM = parcelRequire("eHBjM");
const $d4f244e6c511875f$export$885b4ccacd7db28d = Object.freeze({
    rank: (0, $eHBjM.agentsColumns).rank,
    area: (0, $eHBjM.agentsColumns).area,
    totalUnits: {
        ...(0, $eHBjM.agentsColumns).totalUnits,
        label: "# Listings"
    },
    totalVolume: {
        ...(0, $eHBjM.agentsColumns).totalVolume,
        label: "Total $"
    },
    totalUnitsPct: {
        ...(0, $eHBjM.agentsColumns).totalUnitsPct,
        label: "Units %"
    },
    totalVolumePct: {
        ...(0, $eHBjM.agentsColumns).totalVolumePct,
        label: "$ Volume %"
    }
});

});


parcelRegister("4tbBr", function(module, exports) {

$parcel$export(module.exports, "cellRenderers", () => $3412def860541caa$export$cc0e79d2a41dc68a);
$parcel$export(module.exports, "growthAnalysisColumnsLtmIncDec", () => $3412def860541caa$export$7442199ed440152b);
$parcel$export(module.exports, "growthAnalysisColumnsYtdIncDec", () => $3412def860541caa$export$68df32e4d1287a96);
$parcel$export(module.exports, "growthAnalysisColumnsL90d", () => $3412def860541caa$export$1d3d3c46b46af74e);
$parcel$export(module.exports, "tableViews", () => $3412def860541caa$export$5896849918c6fabd);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $kWnaD = parcelRequire("kWnaD");

var $eHBjM = parcelRequire("eHBjM");

var $98ROn = parcelRequire("98ROn");

var $61Zb3 = parcelRequire("61Zb3");

var $foeS8 = parcelRequire("foeS8");

var $cIUhV = parcelRequire("cIUhV");

var $4fGPb = parcelRequire("4fGPb");

var $cL3O2 = parcelRequire("cL3O2");

var $bq4QZ = parcelRequire("bq4QZ");

var $c7dF9 = parcelRequire("c7dF9");

var $7jSpM = parcelRequire("7jSpM");

var $8E8vr = parcelRequire("8E8vr");

var $5GRJ8 = parcelRequire("5GRJ8");

var $cstaF = parcelRequire("cstaF");

var $fPGDZ = parcelRequire("fPGDZ");

var $3D0uP = parcelRequire("3D0uP");
parcelRequire("jbbzx");
var $jrnUE = parcelRequire("jrnUE");
var $fEn75 = parcelRequire("fEn75");
var $bksJ0 = parcelRequire("bksJ0");
var $eLlZr = parcelRequire("eLlZr");
var $6RwGN = parcelRequire("6RwGN");
var $gC1w5 = parcelRequire("gC1w5");
var $hAeWH = parcelRequire("hAeWH");
var $d9xWn = parcelRequire("d9xWn");
var $4mur5 = parcelRequire("4mur5");
var $g5uaS = parcelRequire("g5uaS");
var $lb545 = parcelRequire("lb545");

var $dDBOF = parcelRequire("dDBOF");
const $3412def860541caa$var$agentEmailLink = (data)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        title: data.agentEmail,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
            href: `mailto:${data.agentEmail}`,
            children: data.agentEmail
        })
    });
const $3412def860541caa$var$agentAddress = (data)=>{
    const altAddress = data?.agentAddress || "";
    const agentCity = data?.agentCity ? data.agentCity + " " : "";
    const agentZip = data?.agentZipcode ? data.agentZipcode : "";
    const agentCityAndAgentZip = agentCity || agentZip ? `${agentCity + agentZip}` : null;
    const altState = data?.agentState ? data.agentState : null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
        className: "text-wrap col-address",
        children: [
            " ",
            altAddress,
            " ",
            agentCityAndAgentZip,
            " ",
            altState,
            " "
        ]
    });
};
const $3412def860541caa$var$agentProductionListingLink = (props)=>{
    const { data: data, timePeriod: timePeriod, productionGraphMode: productionGraphMode } = props;
    const idParam = `?id=${data.agentId}`;
    const periodParam = `&period=${(0, $5GRJ8.monthTextYearFormatter)(data.month).replace("- 20", "")}`;
    const graphParam = `&graph=${productionGraphMode}`;
    const chartParam = `&chartMode=${data.chartMode}`;
    const intervalParam = `&intervalType=${timePeriod}`;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fGPb.Link), {
        to: `${(0, $eHBjM.productionListingRoute)}${idParam}${periodParam}${graphParam}${chartParam}${intervalParam}`,
        children: (0, $5GRJ8.monthTextYearFormatter)(data.month)
    });
};
const $3412def860541caa$var$areaTransactionCoverageLink = (props)=>{
    const { data: data, goToCoverageListingsPage: goToCoverageListingsPage } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
        id: "agentsCoverageTableLink",
        href: "#",
        onClick: ()=>goToCoverageListingsPage(data.area),
        children: data.area
    });
};
const $3412def860541caa$var$inventoryName = ({ data: data, setSelectedRow: setSelectedRow })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
        href: "#",
        id: `status-select-${data.id}`,
        onClick: ()=>setSelectedRow(data),
        className: "text-capitalize text-left text-wrap border-0",
        children: data.status
    });
};
const $3412def860541caa$var$currentlyAddress = (data)=>{
    let query = (0, $bq4QZ.useQuery)();
    const listingInfoRoute = `${(0, $dDBOF.isAgentMetrics) ? (0, $c7dF9.Routes).AGENT_PRODUCTION.BASE : (0, $c7dF9.Routes).PROF_METRICS.BASE}${(0, $c7dF9.Routes).PROF_METRICS.LISTING_INFO}`;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fGPb.Link), {
        className: "text-truncate w-max text-left text-wrap text-decoration-none border-0",
        to: `${listingInfoRoute}?mlsNum=${data.mlsNum}&agentId=${query.get("id")}&tabIndex=1`,
        children: data.address
    });
};
const $3412def860541caa$var$showMoveDate = (props)=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
        className: props.data.display ? "" : "first-office",
        children: (0, $7jSpM.getShortDate)(props.data.moveDate)
    });
};
const $3412def860541caa$var$checkboxColumn = {
    col: (0, $eHBjM.agentsColumns).isSelected,
    sortable: false,
    colDef: {
        ...(0, $98ROn.colSettings).checkboxSmallRight,
        headerCheckboxSelection: true,
        checkboxSelection: true
    }
};
const $3412def860541caa$export$cc0e79d2a41dc68a = {
    agentNameLink: (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $foeS8.AgentProfileLink), {
            ...props
        }),
    inventoryType: (props)=>$3412def860541caa$var$inventoryName(props),
    address: (props)=>$3412def860541caa$var$currentlyAddress(props.data),
    agentProductionListingLink: (props)=>$3412def860541caa$var$agentProductionListingLink(props),
    emailLink: (props)=>$3412def860541caa$var$agentEmailLink(props.data),
    alternativeAddress: (props)=>$3412def860541caa$var$agentAddress(props.data),
    areaTransactionCoverageLink: (props)=>$3412def860541caa$var$areaTransactionCoverageLink(props),
    renderFavorited: (params)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $61Zb3.default), {
            ...params
        }),
    moveDate: (props)=>$3412def860541caa$var$showMoveDate(props),
    coverageAddressListingsLink: (props)=>(0, $3D0uP.CoverageAddressFormatter)(props.data),
    productionAddressListingsLink: (props)=>(0, $3D0uP.ProductionAddressFormatter)(props.data),
    pinnedRow: (value)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
            children: value || ""
        })
};
const $3412def860541caa$var$growthAnalysisColumns = (0, $7jSpM.transformSchemaTableColumns)((0, $eHBjM.growthAnalysisTooltips), (0, $eHBjM.tabModes).GROWTH_ANALYSIS);
const $3412def860541caa$export$7442199ed440152b = (0, $7jSpM.transformSchemaTableColumns)((0, $eHBjM.incDecLtmGrowthAnalysisTooltips), (0, $eHBjM.tabModes).GROWTH_ANALYSIS);
const $3412def860541caa$export$68df32e4d1287a96 = (0, $7jSpM.transformSchemaTableColumns)((0, $eHBjM.incDecYtdGrowthAnalysisTooltips), (0, $eHBjM.tabModes).GROWTH_ANALYSIS);
const $3412def860541caa$export$1d3d3c46b46af74e = (0, $7jSpM.transformSchemaTableColumns)((0, $eHBjM.growthAnalysisTooltipsL90d), (0, $eHBjM.tabModes).GROWTH_ANALYSIS);
const $3412def860541caa$var$columns = (0, $8E8vr.getDefaultGrowthAnalysisColumnsLtm)();
const $3412def860541caa$export$c6898a0725882d3a = {
    agentsColumns: $eHBjM.agentsColumns,
    additionalTableHeaders: $eHBjM.additionalTableHeaders,
    cellRenderers: $3412def860541caa$export$cc0e79d2a41dc68a,
    colSettings: $98ROn.colSettings,
    getAdditionalTableHeader: $cIUhV.getAdditionalTableHeader,
    tableViewNames: $eHBjM.tableViewNames,
    TextFloatingFilterComponent: $kWnaD.default
};
const $3412def860541caa$export$5896849918c6fabd = {
    [(0, $eHBjM.tableViewNames).overview]: {
        id: (0, $eHBjM.tableViewNames).overview,
        defaultSort: {
            colId: (0, $eHBjM.agentsColumns).totalVolume.id,
            sortDir: "desc"
        },
        tables: [
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)((0, $eHBjM.additionalTableHeaders).column1, props),
                children: [
                    $3412def860541caa$var$checkboxColumn,
                    {
                        col: (0, $eHBjM.agentsColumns).rank,
                        colDef: (0, $98ROn.colSettings).textXsRightAlign
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).agentName,
                        colDef: (0, $98ROn.colSettings).textLg,
                        cellRenderer: $3412def860541caa$export$cc0e79d2a41dc68a.agentNameLink,
                        filterOptions: {
                            filter: "agTextColumnFilter",
                            floatingFilterComponent: (0, $kWnaD.default),
                            floatingFilterComponentParams: {
                                placeholder: (0, $cstaF.searchTerms).searchName
                            }
                        }
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).agentId,
                        colDef: (0, $98ROn.colSettings).textMd,
                        initialHide: true,
                        filterOptions: {
                            filter: "agTextColumnFilter",
                            floatingFilterComponent: (0, $kWnaD.default),
                            floatingFilterComponentParams: {
                                placeholder: (0, $cstaF.searchTerms).searchId
                            }
                        }
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).officeName,
                        colDef: (0, $98ROn.colSettings).textLg,
                        filterOptions: {
                            filter: "agTextColumnFilter",
                            floatingFilterComponent: (0, $kWnaD.default),
                            floatingFilterComponentParams: {
                                placeholder: (0, $cstaF.searchTerms).searchOffice
                            }
                        }
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).officeId,
                        colDef: (0, $98ROn.colSettings).textSm,
                        initialHide: true
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).officeAddress,
                        colDef: (0, $98ROn.colSettings).textMd,
                        initialHide: true
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).officeCity,
                        colDef: (0, $98ROn.colSettings).textSm,
                        initialHide: true
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).officeZipCode,
                        colDef: (0, $98ROn.colSettings).textXs,
                        initialHide: true
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).officeCounty,
                        colDef: (0, $98ROn.colSettings).textSm,
                        initialHide: true
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).listVolume,
                        colDef: (0, $98ROn.colSettings).numberSmVolume
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).sellVolume,
                        colDef: (0, $98ROn.colSettings).numberSmVolume
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).totalVolume,
                        colDef: (0, $98ROn.colSettings).numberSmVolume
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).listUnits,
                        colDef: (0, $98ROn.colSettings).numberSmUnits
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).sellUnits,
                        colDef: (0, $98ROn.colSettings).numberSmUnits
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).totalUnits,
                        colDef: (0, $98ROn.colSettings).numberSmUnits
                    }
                ]
            },
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)((0, $eHBjM.additionalTableHeaders).column2, props),
                children: [
                    {
                        col: (0, $eHBjM.agentsColumns).averagePrice,
                        colDef: (0, $98ROn.colSettings).numberSmVolume,
                        initialHide: true
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).last12Spop,
                        colDef: (0, $98ROn.colSettings).numberSmPercentage,
                        initialHide: true
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).last12AvgDom,
                        colDef: (0, $98ROn.colSettings).numberSmInteger,
                        initialHide: true
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).totalUnitsChange,
                        colDef: (0, $98ROn.colSettings).numberSmUnits,
                        initialHide: true
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).totalVolumeChange,
                        colDef: (0, $98ROn.colSettings).numberSmVolume,
                        initialHide: true
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).last12ListVolume,
                        colDef: (0, $98ROn.colSettings).numberSmVolume
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).last12SellVolume,
                        colDef: (0, $98ROn.colSettings).numberSmVolume
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).last12TotalVolume,
                        colDef: (0, $98ROn.colSettings).numberSmVolume
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).last12ListUnits,
                        colDef: (0, $98ROn.colSettings).numberSmUnits
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).last12SellUnits,
                        colDef: (0, $98ROn.colSettings).numberSmUnits
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).last12TotalUnits,
                        colDef: (0, $98ROn.colSettings).numberSmUnits
                    }
                ]
            }
        ]
    },
    [(0, $eHBjM.tableViewNames).overviewCoopAgents]: {
        id: (0, $eHBjM.tableViewNames).overview,
        defaultSort: {
            colId: (0, $eHBjM.agentsColumns).listingClosedDate.id,
            sortDir: "desc"
        },
        tables: [
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)((0, $eHBjM.additionalTableHeaders).column1, props),
                children: [
                    $3412def860541caa$var$checkboxColumn,
                    {
                        col: (0, $eHBjM.agentsColumns).rank,
                        colDef: (0, $98ROn.colSettings).textXsRightAlign
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).agentName,
                        colDef: (0, $98ROn.colSettings).textLg,
                        cellRenderer: $3412def860541caa$export$cc0e79d2a41dc68a.agentNameLink,
                        filterOptions: {
                            filter: "agTextColumnFilter",
                            floatingFilterComponent: (0, $kWnaD.default),
                            floatingFilterComponentParams: {
                                placeholder: (0, $cstaF.searchTerms).searchName
                            }
                        }
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).agentId,
                        colDef: (0, $98ROn.colSettings).textMd,
                        initialHide: true,
                        filterOptions: {
                            filter: "agTextColumnFilter",
                            floatingFilterComponent: (0, $kWnaD.default),
                            floatingFilterComponentParams: {
                                placeholder: (0, $cstaF.searchTerms).searchId
                            }
                        }
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).officeName,
                        colDef: (0, $98ROn.colSettings).textLg,
                        filterOptions: {
                            filter: "agTextColumnFilter",
                            floatingFilterComponent: (0, $kWnaD.default),
                            floatingFilterComponentParams: {
                                placeholder: (0, $cstaF.searchTerms).searchOffice
                            }
                        }
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).officeId,
                        colDef: (0, $98ROn.colSettings).textSm,
                        initialHide: true
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).listingClosedDate,
                        colDef: (0, $98ROn.colSettings).dateSm
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).listingAddress,
                        colDef: (0, $98ROn.colSettings).textMd
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).listingCity,
                        colDef: (0, $98ROn.colSettings).textSm
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).listingZipCode,
                        colDef: (0, $98ROn.colSettings).textSm
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).listingCounty,
                        colDef: (0, $98ROn.colSettings).textSm
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).listingSalePrice,
                        colDef: (0, $98ROn.colSettings).numberSmVolume
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).coopSide,
                        colDef: (0, $98ROn.colSettings).textSm
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).totalVolume,
                        colDef: (0, $98ROn.colSettings).numberSmVolume
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).totalUnits,
                        colDef: (0, $98ROn.colSettings).numberSmUnits
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).myAgentName,
                        colDef: (0, $98ROn.colSettings).textMd
                    }
                ]
            },
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)((0, $eHBjM.additionalTableHeaders).column2, props),
                children: [
                    {
                        col: (0, $eHBjM.agentsColumns).averagePrice,
                        colDef: (0, $98ROn.colSettings).numberSmVolume,
                        initialHide: true
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).last12Spop,
                        colDef: (0, $98ROn.colSettings).numberSmPercentage,
                        initialHide: true
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).last12AvgDom,
                        colDef: (0, $98ROn.colSettings).numberSmInteger,
                        initialHide: true
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).totalUnitsChange,
                        colDef: (0, $98ROn.colSettings).numberSmUnits,
                        initialHide: true
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).totalVolumeChange,
                        colDef: (0, $98ROn.colSettings).numberSmVolume,
                        initialHide: true
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).last12ListVolume,
                        colDef: (0, $98ROn.colSettings).numberSmVolume
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).last12SellVolume,
                        colDef: (0, $98ROn.colSettings).numberSmVolume
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).last12TotalVolume,
                        colDef: (0, $98ROn.colSettings).numberSmVolume
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).last12ListUnits,
                        colDef: (0, $98ROn.colSettings).numberSmUnits
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).last12SellUnits,
                        colDef: (0, $98ROn.colSettings).numberSmUnits
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).last12TotalUnits,
                        colDef: (0, $98ROn.colSettings).numberSmUnits
                    }
                ]
            }
        ]
    },
    [(0, $eHBjM.tableViewNames).incDecOverview]: {
        id: (0, $eHBjM.tableViewNames).incDecOverview,
        defaultSort: {
            colId: (0, $eHBjM.agentsColumns).totalVolume.id,
            sortDir: "desc"
        },
        tables: [
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)((0, $eHBjM.additionalTableHeaders).column1, props),
                children: [
                    $3412def860541caa$var$checkboxColumn,
                    {
                        col: (0, $eHBjM.agentsColumns).rank,
                        colDef: (0, $98ROn.colSettings).textXsRightAlign
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).agentName,
                        colDef: (0, $98ROn.colSettings).textLg,
                        cellRenderer: $3412def860541caa$export$cc0e79d2a41dc68a.agentNameLink,
                        filterOptions: {
                            filter: "agTextColumnFilter",
                            floatingFilterComponent: (0, $kWnaD.default),
                            floatingFilterComponentParams: {
                                placeholder: (0, $cstaF.searchTerms).searchName
                            }
                        }
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).agentId,
                        colDef: (0, $98ROn.colSettings).textMd,
                        initialHide: true,
                        filterOptions: {
                            filter: "agTextColumnFilter",
                            floatingFilterComponent: (0, $kWnaD.default),
                            floatingFilterComponentParams: {
                                placeholder: (0, $cstaF.searchTerms).searchId
                            }
                        }
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).officeName,
                        colDef: (0, $98ROn.colSettings).textLg,
                        filterOptions: {
                            filter: "agTextColumnFilter",
                            floatingFilterComponent: (0, $kWnaD.default),
                            floatingFilterComponentParams: {
                                placeholder: (0, $cstaF.searchTerms).searchOffice
                            }
                        }
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).officeId,
                        colDef: (0, $98ROn.colSettings).textSm,
                        initialHide: true
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).officeAddress,
                        colDef: (0, $98ROn.colSettings).textMd,
                        initialHide: true
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).officeCity,
                        colDef: (0, $98ROn.colSettings).textSm,
                        initialHide: true
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).officeZipCode,
                        colDef: (0, $98ROn.colSettings).textXs,
                        initialHide: true
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).officeCounty,
                        colDef: (0, $98ROn.colSettings).textSm,
                        initialHide: true
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).listVolume,
                        colDef: (0, $98ROn.colSettings).numberSmVolume
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).sellVolume,
                        colDef: (0, $98ROn.colSettings).numberSmVolume
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).totalVolume,
                        colDef: (0, $98ROn.colSettings).numberSmVolume
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).listUnits,
                        colDef: (0, $98ROn.colSettings).numberSmUnits
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).sellUnits,
                        colDef: (0, $98ROn.colSettings).numberSmUnits
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).totalUnits,
                        colDef: (0, $98ROn.colSettings).numberSmUnits
                    }
                ]
            },
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)((0, $eHBjM.additionalTableHeaders).column2, props),
                children: [
                    {
                        col: (0, $eHBjM.agentsColumns).averagePrice,
                        colDef: (0, $98ROn.colSettings).numberSmVolume,
                        initialHide: true
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).last12Spop,
                        colDef: (0, $98ROn.colSettings).numberSmPercentage,
                        initialHide: true
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).last12AvgDom,
                        colDef: (0, $98ROn.colSettings).numberSmInteger,
                        initialHide: true
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).ltmTotalUnitsChange,
                        colDef: (0, $98ROn.colSettings).numberSmUnits,
                        initialHide: true
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).ltmTotalVolumeChange,
                        colDef: (0, $98ROn.colSettings).numberSmVolume,
                        initialHide: true
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).last12ListVolume,
                        colDef: (0, $98ROn.colSettings).numberSmVolume
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).last12SellVolume,
                        colDef: (0, $98ROn.colSettings).numberSmVolume
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).last12TotalVolume,
                        colDef: (0, $98ROn.colSettings).numberSmVolume
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).last12ListUnits,
                        colDef: (0, $98ROn.colSettings).numberSmUnits
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).last12SellUnits,
                        colDef: (0, $98ROn.colSettings).numberSmUnits
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).last12TotalUnits,
                        colDef: (0, $98ROn.colSettings).numberSmUnits
                    }
                ]
            }
        ]
    },
    [(0, $eHBjM.tableViewNames).pricingHistory]: {
        id: (0, $eHBjM.tableViewNames).pricingHistory,
        showPagination: false,
        defaultSort: {
            colId: (0, $eHBjM.pricingHistoryTooltips).date.id,
            sortDir: "desc"
        },
        tables: [
            {
                col: (0, $eHBjM.pricingHistoryTooltips).date,
                colDef: (0, $98ROn.colSettings).dateSm
            },
            {
                col: (0, $eHBjM.pricingHistoryTooltips).status,
                colDef: (0, $98ROn.colSettings).textSm
            },
            {
                col: (0, $eHBjM.pricingHistoryTooltips).price,
                colDef: (0, $98ROn.colSettings).numberSmVolume
            },
            {
                col: (0, $eHBjM.pricingHistoryTooltips).priceChange,
                colDef: (0, $98ROn.colSettings).blankEmptySmVolume
            },
            {
                col: (0, $eHBjM.pricingHistoryTooltips).priceChangePct,
                colDef: (0, $98ROn.colSettings).blankEmptyNumberSmPercentageWithMultiplier
            },
            {
                col: (0, $eHBjM.pricingHistoryTooltips).days,
                colDef: (0, $98ROn.colSettings).numberSmInteger
            },
            {
                col: (0, $eHBjM.pricingHistoryTooltips).changeType,
                colDef: (0, $98ROn.colSettings).textSm
            },
            {
                col: (0, $eHBjM.pricingHistoryTooltips).spop,
                colDef: (0, $98ROn.colSettings).blankEmptyNumberSmPercentageWithMultiplier
            },
            {
                col: (0, $eHBjM.pricingHistoryTooltips).splp,
                colDef: (0, $98ROn.colSettings).blankEmptyNumberSmPercentageWithMultiplier
            }
        ]
    },
    [(0, $eHBjM.tableViewNames).inventory]: {
        id: (0, $eHBjM.tableViewNames).inventory,
        tables: [
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)((0, $eHBjM.additionalTableHeaders).column2, props),
                children: [
                    {
                        col: (0, $eHBjM.agentsColumns).status,
                        colDef: (0, $98ROn.colSettings).textMd
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).inventoryTotalUnits,
                        colDef: (0, $98ROn.colSettings).numberSmUnits
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).inventoryPriceVolume,
                        colDef: (0, $98ROn.colSettings).numberSmVolume
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).inventoryAvgPrice,
                        colDef: (0, $98ROn.colSettings).numberSmVolume
                    }
                ]
            },
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)((0, $eHBjM.additionalTableHeaders).column3, props),
                children: [
                    {
                        col: (0, $eHBjM.agentsColumns).pcUnits,
                        colDef: (0, $98ROn.colSettings).numberSmUnits
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).lpop,
                        colDef: (0, $98ROn.colSettings).numberSmPercentage
                    }
                ]
            },
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)((0, $eHBjM.additionalTableHeaders).column4, props),
                children: [
                    {
                        col: (0, $eHBjM.agentsColumns).cdomTier1,
                        colDef: (0, $98ROn.colSettings).numberSmInteger
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).cdomTier2,
                        colDef: (0, $98ROn.colSettings).numberSmInteger
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).cdomTier3,
                        colDef: (0, $98ROn.colSettings).numberSmInteger
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).cdomTier4,
                        colDef: (0, $98ROn.colSettings).numberSmInteger
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).cdomTier5,
                        colDef: (0, $98ROn.colSettings).numberSmInteger
                    }
                ]
            }
        ]
    },
    [(0, $eHBjM.tableViewNames).forSale]: {
        id: (0, $eHBjM.tableViewNames).forSale,
        defaultSort: {
            colId: (0, $eHBjM.agentsColumns).dateList.id,
            sortDir: "asc"
        },
        tables: [
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)((0, $eHBjM.additionalTableHeaders).column1, props),
                children: [
                    {
                        col: (0, $eHBjM.agentsColumns).typeName,
                        colDef: (0, $98ROn.colSettings).textSm
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).address,
                        colDef: (0, $98ROn.colSettings).textMd,
                        cellRenderer: $3412def860541caa$export$cc0e79d2a41dc68a.address
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).city,
                        colDef: (0, $98ROn.colSettings).textSm
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).zipCode,
                        colDef: (0, $98ROn.colSettings).textSm
                    }
                ]
            },
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)((0, $eHBjM.additionalTableHeaders).column2, props),
                children: [
                    {
                        col: (0, $eHBjM.agentsColumns).orgPrice,
                        colDef: (0, $98ROn.colSettings).numberMdVolume
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).listPrice,
                        colDef: (0, $98ROn.colSettings).numberSmVolume
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).priceChangeCnt,
                        colDef: (0, $98ROn.colSettings).numberMdInteger
                    }
                ]
            },
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)((0, $eHBjM.additionalTableHeaders).column3, props),
                children: [
                    {
                        col: (0, $eHBjM.agentsColumns).dateList,
                        colDef: (0, $98ROn.colSettings).dateSm
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).cdom,
                        colDef: (0, $98ROn.colSettings).numberSmGroupedInteger
                    }
                ]
            },
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)((0, $eHBjM.additionalTableHeaders).column4, props),
                children: [
                    {
                        col: (0, $eHBjM.agentsColumns).bedrooms,
                        colDef: (0, $98ROn.colSettings).numberXsInteger
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).fullBaths,
                        colDef: (0, $98ROn.colSettings).numberXsInteger
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).squareFt,
                        colDef: (0, $98ROn.colSettings).numberSmInteger
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).dollarPerSquareFt,
                        colDef: (0, $98ROn.colSettings).numberMdVolume
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).lotSizeSquareFt,
                        colDef: (0, $98ROn.colSettings).numberMdInteger
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).yearBuilt,
                        colDef: (0, $98ROn.colSettings).numberSmRightAlign
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).mlsNum,
                        colDef: (0, $98ROn.colSettings).textSm
                    }
                ]
            }
        ]
    },
    [(0, $eHBjM.tableViewNames).underContract]: {
        id: (0, $eHBjM.tableViewNames).underContract,
        defaultSort: {
            colId: (0, $eHBjM.agentsColumns).dateList.id,
            sortDir: "asc"
        },
        tables: [
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)((0, $eHBjM.additionalTableHeaders).column1, props),
                children: [
                    {
                        col: (0, $eHBjM.agentsColumns).typeName,
                        colDef: (0, $98ROn.colSettings).textSm
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).address,
                        colDef: (0, $98ROn.colSettings).textMd,
                        cellRenderer: $3412def860541caa$export$cc0e79d2a41dc68a.address
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).city,
                        colDef: (0, $98ROn.colSettings).textSm
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).zipCode,
                        colDef: (0, $98ROn.colSettings).textSm
                    }
                ]
            },
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)((0, $eHBjM.additionalTableHeaders).column2, props),
                children: [
                    {
                        col: (0, $eHBjM.agentsColumns).orgPrice,
                        colDef: (0, $98ROn.colSettings).numberMdVolume
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).listPrice,
                        colDef: (0, $98ROn.colSettings).numberSmVolume
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).priceChangeCnt,
                        colDef: (0, $98ROn.colSettings).numberMdInteger
                    }
                ]
            },
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)((0, $eHBjM.additionalTableHeaders).column3, props),
                children: [
                    {
                        col: (0, $eHBjM.agentsColumns).dateList,
                        colDef: (0, $98ROn.colSettings).dateSm
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).dateCont,
                        colDef: (0, $98ROn.colSettings).dateSm
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).cdom,
                        colDef: (0, $98ROn.colSettings).numberSmGroupedInteger
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).duc,
                        colDef: (0, $98ROn.colSettings).numberXsInteger
                    }
                ]
            },
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)((0, $eHBjM.additionalTableHeaders).column4, props),
                children: [
                    {
                        col: (0, $eHBjM.agentsColumns).statusCode,
                        colDef: (0, $98ROn.colSettings).textSm
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).bedrooms,
                        colDef: (0, $98ROn.colSettings).numberXsInteger
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).fullBaths,
                        colDef: (0, $98ROn.colSettings).numberXsInteger
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).squareFt,
                        colDef: (0, $98ROn.colSettings).numberSmInteger
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).dollarPerSquareFt,
                        colDef: (0, $98ROn.colSettings).numberMdVolume
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).lotSizeSquareFt,
                        colDef: (0, $98ROn.colSettings).numberMdInteger
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).yearBuilt,
                        colDef: (0, $98ROn.colSettings).numberSmRightAlign
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).mlsNum,
                        colDef: (0, $98ROn.colSettings).textSm
                    }
                ]
            }
        ]
    },
    [(0, $eHBjM.tableViewNames).incDecGrowthAnalysisLtm]: {
        id: (0, $eHBjM.tableViewNames).incDecGrowthAnalysisLtm,
        defaultSort: {
            colId: $3412def860541caa$export$7442199ed440152b.totalVolumeGrowth.id,
            sortDir: "desc"
        },
        tables: [
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)((0, $eHBjM.additionalTableHeaders).column1, props),
                children: [
                    $3412def860541caa$var$checkboxColumn,
                    {
                        col: (0, $eHBjM.agentsColumns).rank,
                        colDef: (0, $98ROn.colSettings).textXsRightAlign
                    },
                    {
                        col: $3412def860541caa$export$7442199ed440152b.agentName,
                        colDef: (0, $98ROn.colSettings).textLg,
                        cellRenderer: $3412def860541caa$export$cc0e79d2a41dc68a.agentNameLink,
                        filterOptions: {
                            filter: "agTextColumnFilter",
                            floatingFilterComponent: (0, $kWnaD.default),
                            floatingFilterComponentParams: {
                                placeholder: (0, $cstaF.searchTerms).searchName
                            }
                        }
                    },
                    {
                        col: $3412def860541caa$export$7442199ed440152b.officeName,
                        colDef: (0, $98ROn.colSettings).textLg,
                        filterOptions: {
                            filter: "agTextColumnFilter",
                            floatingFilterComponent: (0, $kWnaD.default),
                            floatingFilterComponentParams: {
                                placeholder: (0, $cstaF.searchTerms).searchOffice
                            }
                        }
                    },
                    {
                        col: $3412def860541caa$export$7442199ed440152b.officeId,
                        colDef: (0, $98ROn.colSettings).textSm,
                        initialHide: true
                    },
                    {
                        col: $3412def860541caa$export$7442199ed440152b.officeAddress,
                        colDef: (0, $98ROn.colSettings).textMd,
                        initialHide: (0, $fPGDZ.isHiddenColumn)($3412def860541caa$export$7442199ed440152b.officeAddress.id, $3412def860541caa$var$columns)
                    },
                    {
                        col: $3412def860541caa$export$7442199ed440152b.officeCity,
                        colDef: (0, $98ROn.colSettings).textSm,
                        initialHide: (0, $fPGDZ.isHiddenColumn)($3412def860541caa$export$7442199ed440152b.officeAddress.id, $3412def860541caa$var$columns)
                    },
                    {
                        col: $3412def860541caa$export$7442199ed440152b.officeZipCode,
                        colDef: (0, $98ROn.colSettings).textXs,
                        initialHide: (0, $fPGDZ.isHiddenColumn)($3412def860541caa$export$7442199ed440152b.officeAddress.id, $3412def860541caa$var$columns)
                    },
                    {
                        col: $3412def860541caa$export$7442199ed440152b.officeCounty,
                        colDef: (0, $98ROn.colSettings).textSm,
                        initialHide: (0, $fPGDZ.isHiddenColumn)($3412def860541caa$export$7442199ed440152b.officeAddress.id, $3412def860541caa$var$columns)
                    }
                ]
            },
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)((0, $eHBjM.additionalTableHeaders).column2, props),
                children: [
                    {
                        col: $3412def860541caa$export$7442199ed440152b.previousPeriodTotalUnits,
                        colDef: (0, $98ROn.colSettings).numberMdUnits
                    },
                    {
                        col: $3412def860541caa$export$7442199ed440152b.totalUnits,
                        colDef: (0, $98ROn.colSettings).numberMdUnits
                    },
                    {
                        col: $3412def860541caa$export$7442199ed440152b.totalUnitsChange,
                        colDef: (0, $98ROn.colSettings).numberSmUnits
                    },
                    {
                        col: $3412def860541caa$export$7442199ed440152b.totalUnitsGrowth,
                        colDef: (0, $98ROn.colSettings).numberSmPercentage
                    }
                ]
            },
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)((0, $eHBjM.additionalTableHeaders).column3, props),
                children: [
                    {
                        col: $3412def860541caa$export$7442199ed440152b.previousPeriodTotalVolume,
                        colDef: (0, $98ROn.colSettings).numberLgVolume
                    },
                    {
                        col: $3412def860541caa$export$7442199ed440152b.totalVolume,
                        colDef: (0, $98ROn.colSettings).numberMdVolume
                    },
                    {
                        col: $3412def860541caa$export$7442199ed440152b.totalVolumeChange,
                        colDef: (0, $98ROn.colSettings).numberSmVolume
                    },
                    {
                        col: $3412def860541caa$export$7442199ed440152b.totalVolumeGrowth,
                        colDef: (0, $98ROn.colSettings).numberSmPercentage
                    }
                ]
            }
        ]
    },
    [(0, $eHBjM.tableViewNames).growthAnalysisLtm]: {
        id: (0, $eHBjM.tableViewNames).growthAnalysisLtm,
        tables: [
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)((0, $eHBjM.additionalTableHeaders).column1, props),
                children: [
                    $3412def860541caa$var$checkboxColumn,
                    {
                        col: (0, $eHBjM.agentsColumns).rank,
                        colDef: (0, $98ROn.colSettings).textXsRightAlign
                    },
                    {
                        col: $3412def860541caa$var$growthAnalysisColumns.agentName,
                        colDef: (0, $98ROn.colSettings).textLg,
                        cellRenderer: $3412def860541caa$export$cc0e79d2a41dc68a.agentNameLink,
                        filterOptions: {
                            filter: "agTextColumnFilter",
                            floatingFilterComponent: (0, $kWnaD.default),
                            floatingFilterComponentParams: {
                                placeholder: (0, $cstaF.searchTerms).searchName
                            }
                        }
                    },
                    {
                        col: $3412def860541caa$var$growthAnalysisColumns.officeName,
                        colDef: (0, $98ROn.colSettings).textLg,
                        filterOptions: {
                            filter: "agTextColumnFilter",
                            floatingFilterComponent: (0, $kWnaD.default),
                            floatingFilterComponentParams: {
                                placeholder: (0, $cstaF.searchTerms).searchOffice
                            }
                        }
                    },
                    {
                        col: $3412def860541caa$var$growthAnalysisColumns.officeId,
                        colDef: (0, $98ROn.colSettings).textSm,
                        initialHide: true
                    },
                    {
                        col: $3412def860541caa$var$growthAnalysisColumns.officeAddress,
                        colDef: (0, $98ROn.colSettings).textMd,
                        initialHide: (0, $fPGDZ.isHiddenColumn)($3412def860541caa$var$growthAnalysisColumns.officeAddress.id, $3412def860541caa$var$columns)
                    },
                    {
                        col: $3412def860541caa$var$growthAnalysisColumns.officeCity,
                        colDef: (0, $98ROn.colSettings).textSm,
                        initialHide: (0, $fPGDZ.isHiddenColumn)($3412def860541caa$var$growthAnalysisColumns.officeAddress.id, $3412def860541caa$var$columns)
                    },
                    {
                        col: $3412def860541caa$var$growthAnalysisColumns.officeZipCode,
                        colDef: (0, $98ROn.colSettings).textXs,
                        initialHide: (0, $fPGDZ.isHiddenColumn)($3412def860541caa$var$growthAnalysisColumns.officeAddress.id, $3412def860541caa$var$columns)
                    },
                    {
                        col: $3412def860541caa$var$growthAnalysisColumns.officeCounty,
                        colDef: (0, $98ROn.colSettings).textSm,
                        initialHide: (0, $fPGDZ.isHiddenColumn)($3412def860541caa$var$growthAnalysisColumns.officeAddress.id, $3412def860541caa$var$columns)
                    }
                ]
            },
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)((0, $eHBjM.additionalTableHeaders).column2, props),
                children: [
                    {
                        col: $3412def860541caa$var$growthAnalysisColumns.ptmTotalUnits,
                        colDef: (0, $98ROn.colSettings).numberMdUnits
                    },
                    {
                        col: $3412def860541caa$var$growthAnalysisColumns.last12TotalUnits,
                        colDef: (0, $98ROn.colSettings).numberMdUnits
                    },
                    {
                        col: $3412def860541caa$var$growthAnalysisColumns.totalUnitsChange,
                        colDef: (0, $98ROn.colSettings).numberSmUnits
                    },
                    {
                        col: $3412def860541caa$var$growthAnalysisColumns.totalUnitsGrowth,
                        colDef: (0, $98ROn.colSettings).numberSmPercentage
                    }
                ]
            },
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)((0, $eHBjM.additionalTableHeaders).column3, props),
                children: [
                    {
                        col: $3412def860541caa$var$growthAnalysisColumns.ptmTotalVolume,
                        colDef: (0, $98ROn.colSettings).numberLgVolume
                    },
                    {
                        col: $3412def860541caa$var$growthAnalysisColumns.last12TotalVolume,
                        colDef: (0, $98ROn.colSettings).numberMdVolume
                    },
                    {
                        col: $3412def860541caa$var$growthAnalysisColumns.totalVolumeChange,
                        colDef: (0, $98ROn.colSettings).numberSmVolume
                    },
                    {
                        col: $3412def860541caa$var$growthAnalysisColumns.totalVolumeGrowth,
                        colDef: (0, $98ROn.colSettings).numberSmPercentage
                    }
                ]
            }
        ]
    },
    [(0, $eHBjM.tableViewNames).growthAnalysisYtd]: {
        id: (0, $eHBjM.tableViewNames).growthAnalysisYtd,
        tables: [
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)((0, $eHBjM.additionalTableHeaders).column1, props),
                children: [
                    $3412def860541caa$var$checkboxColumn,
                    {
                        col: (0, $eHBjM.agentsColumns).rank,
                        colDef: (0, $98ROn.colSettings).textXsRightAlign
                    },
                    {
                        col: $3412def860541caa$var$growthAnalysisColumns.agentName,
                        colDef: (0, $98ROn.colSettings).textLg,
                        cellRenderer: $3412def860541caa$export$cc0e79d2a41dc68a.agentNameLink,
                        filterOptions: {
                            filter: "agTextColumnFilter",
                            floatingFilterComponent: (0, $kWnaD.default),
                            floatingFilterComponentParams: {
                                placeholder: (0, $cstaF.searchTerms).searchName
                            }
                        }
                    },
                    {
                        col: $3412def860541caa$var$growthAnalysisColumns.officeName,
                        colDef: (0, $98ROn.colSettings).textLg,
                        filterOptions: {
                            filter: "agTextColumnFilter",
                            floatingFilterComponent: (0, $kWnaD.default),
                            floatingFilterComponentParams: {
                                placeholder: (0, $cstaF.searchTerms).searchOffice
                            }
                        }
                    },
                    {
                        col: $3412def860541caa$var$growthAnalysisColumns.officeId,
                        colDef: (0, $98ROn.colSettings).textSm,
                        initialHide: true
                    },
                    {
                        col: $3412def860541caa$var$growthAnalysisColumns.officeAddress,
                        colDef: (0, $98ROn.colSettings).textMd,
                        initialHide: (0, $fPGDZ.isHiddenColumn)($3412def860541caa$var$growthAnalysisColumns.officeAddress.id, $3412def860541caa$var$columns)
                    },
                    {
                        col: $3412def860541caa$var$growthAnalysisColumns.officeCity,
                        colDef: (0, $98ROn.colSettings).textSm,
                        initialHide: (0, $fPGDZ.isHiddenColumn)($3412def860541caa$var$growthAnalysisColumns.officeAddress.id, $3412def860541caa$var$columns)
                    },
                    {
                        col: $3412def860541caa$var$growthAnalysisColumns.officeZipCode,
                        colDef: (0, $98ROn.colSettings).textXs,
                        initialHide: (0, $fPGDZ.isHiddenColumn)($3412def860541caa$var$growthAnalysisColumns.officeAddress.id, $3412def860541caa$var$columns)
                    },
                    {
                        col: $3412def860541caa$var$growthAnalysisColumns.officeCounty,
                        colDef: (0, $98ROn.colSettings).textSm,
                        initialHide: (0, $fPGDZ.isHiddenColumn)($3412def860541caa$var$growthAnalysisColumns.officeAddress.id, $3412def860541caa$var$columns)
                    }
                ]
            },
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)((0, $eHBjM.additionalTableHeaders).column2, props),
                children: [
                    {
                        col: $3412def860541caa$var$growthAnalysisColumns.pytdTotalUnits,
                        colDef: (0, $98ROn.colSettings).numberSmUnits
                    },
                    {
                        col: $3412def860541caa$var$growthAnalysisColumns.lytdTotalUnits,
                        colDef: (0, $98ROn.colSettings).numberSmUnits
                    },
                    {
                        col: $3412def860541caa$var$growthAnalysisColumns.lytdPytdTotalUnitsChange,
                        colDef: (0, $98ROn.colSettings).numberSmUnits
                    },
                    {
                        col: $3412def860541caa$var$growthAnalysisColumns.lytdPytdTotalUnitsGrowth,
                        colDef: (0, $98ROn.colSettings).numberSmPercentage
                    }
                ]
            },
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)((0, $eHBjM.additionalTableHeaders).column3, props),
                children: [
                    {
                        col: $3412def860541caa$var$growthAnalysisColumns.pytdTotalVolume,
                        colDef: (0, $98ROn.colSettings).numberSmVolume
                    },
                    {
                        col: $3412def860541caa$var$growthAnalysisColumns.lytdTotalVolume,
                        colDef: (0, $98ROn.colSettings).numberSmVolume
                    },
                    {
                        col: $3412def860541caa$var$growthAnalysisColumns.lytdPytdTotalVolumeChange,
                        colDef: (0, $98ROn.colSettings).numberSmVolume
                    },
                    {
                        col: $3412def860541caa$var$growthAnalysisColumns.lytdPytdTotalVolumeGrowth,
                        colDef: (0, $98ROn.colSettings).numberSmPercentage
                    }
                ]
            }
        ]
    },
    [(0, $eHBjM.tableViewNames).incDecGrowthAnalysisYtd]: {
        id: (0, $eHBjM.tableViewNames).incDecGrowthAnalysisYtd,
        defaultSort: {
            colId: $3412def860541caa$export$68df32e4d1287a96.totalVolumeGrowth.id,
            sortDir: "desc"
        },
        tables: [
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)((0, $eHBjM.additionalTableHeaders).column1, props),
                children: [
                    $3412def860541caa$var$checkboxColumn,
                    {
                        col: $3412def860541caa$export$68df32e4d1287a96.rank,
                        colDef: (0, $98ROn.colSettings).textXsRightAlign
                    },
                    {
                        col: $3412def860541caa$export$68df32e4d1287a96.agentName,
                        colDef: (0, $98ROn.colSettings).textLg,
                        cellRenderer: $3412def860541caa$export$cc0e79d2a41dc68a.agentNameLink,
                        filterOptions: {
                            filter: "agTextColumnFilter",
                            floatingFilterComponent: (0, $kWnaD.default),
                            floatingFilterComponentParams: {
                                placeholder: (0, $cstaF.searchTerms).searchName
                            }
                        }
                    },
                    {
                        col: $3412def860541caa$export$68df32e4d1287a96.officeName,
                        colDef: (0, $98ROn.colSettings).textLg,
                        filterOptions: {
                            filter: "agTextColumnFilter",
                            floatingFilterComponent: (0, $kWnaD.default),
                            floatingFilterComponentParams: {
                                placeholder: (0, $cstaF.searchTerms).searchOffice
                            }
                        }
                    },
                    {
                        col: $3412def860541caa$export$68df32e4d1287a96.officeId,
                        colDef: (0, $98ROn.colSettings).textSm,
                        initialHide: true
                    },
                    {
                        col: $3412def860541caa$export$68df32e4d1287a96.officeAddress,
                        colDef: (0, $98ROn.colSettings).textMd,
                        initialHide: (0, $fPGDZ.isHiddenColumn)($3412def860541caa$export$68df32e4d1287a96.officeAddress.id, $3412def860541caa$var$columns)
                    },
                    {
                        col: $3412def860541caa$export$68df32e4d1287a96.officeCity,
                        colDef: (0, $98ROn.colSettings).textSm,
                        initialHide: (0, $fPGDZ.isHiddenColumn)($3412def860541caa$export$68df32e4d1287a96.officeAddress.id, $3412def860541caa$var$columns)
                    },
                    {
                        col: $3412def860541caa$export$68df32e4d1287a96.officeZipCode,
                        colDef: (0, $98ROn.colSettings).textXs,
                        initialHide: (0, $fPGDZ.isHiddenColumn)($3412def860541caa$export$68df32e4d1287a96.officeAddress.id, $3412def860541caa$var$columns)
                    },
                    {
                        col: $3412def860541caa$export$68df32e4d1287a96.officeCounty,
                        colDef: (0, $98ROn.colSettings).textSm,
                        initialHide: (0, $fPGDZ.isHiddenColumn)($3412def860541caa$export$68df32e4d1287a96.officeAddress.id, $3412def860541caa$var$columns)
                    }
                ]
            },
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)((0, $eHBjM.additionalTableHeaders).column2, props),
                children: [
                    {
                        col: $3412def860541caa$export$68df32e4d1287a96.previousPeriodTotalUnits,
                        colDef: (0, $98ROn.colSettings).numberSmUnits
                    },
                    {
                        col: $3412def860541caa$export$68df32e4d1287a96.totalUnits,
                        colDef: (0, $98ROn.colSettings).numberSmUnits
                    },
                    {
                        col: $3412def860541caa$export$68df32e4d1287a96.totalUnitsChange,
                        colDef: (0, $98ROn.colSettings).numberSmUnits
                    },
                    {
                        col: $3412def860541caa$export$68df32e4d1287a96.totalUnitsGrowth,
                        colDef: (0, $98ROn.colSettings).numberSmPercentage
                    }
                ]
            },
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)((0, $eHBjM.additionalTableHeaders).column3, props),
                children: [
                    {
                        col: $3412def860541caa$export$68df32e4d1287a96.previousPeriodTotalVolume,
                        colDef: (0, $98ROn.colSettings).numberSmVolume
                    },
                    {
                        col: $3412def860541caa$export$68df32e4d1287a96.totalVolume,
                        colDef: (0, $98ROn.colSettings).numberSmVolume
                    },
                    {
                        col: $3412def860541caa$export$68df32e4d1287a96.totalVolumeChange,
                        colDef: (0, $98ROn.colSettings).numberSmVolume
                    },
                    {
                        col: $3412def860541caa$export$68df32e4d1287a96.totalVolumeGrowth,
                        colDef: (0, $98ROn.colSettings).numberSmPercentage
                    }
                ]
            }
        ]
    },
    [(0, $eHBjM.tableViewNames).growthAnalysisL90]: {
        id: (0, $eHBjM.tableViewNames).growthAnalysisL90,
        defaultSort: {
            colId: $3412def860541caa$export$1d3d3c46b46af74e.totalVolumeGrowth.id,
            sortDir: "desc"
        },
        tables: [
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)((0, $eHBjM.additionalTableHeaders).column1, props),
                children: [
                    $3412def860541caa$var$checkboxColumn,
                    {
                        col: (0, $eHBjM.agentsColumns).rank,
                        colDef: (0, $98ROn.colSettings).textXsRightAlign
                    },
                    {
                        col: $3412def860541caa$export$1d3d3c46b46af74e.agentName,
                        colDef: (0, $98ROn.colSettings).textLg,
                        cellRenderer: $3412def860541caa$export$cc0e79d2a41dc68a.agentNameLink,
                        filterOptions: {
                            filter: "agTextColumnFilter",
                            floatingFilterComponent: (0, $kWnaD.default),
                            floatingFilterComponentParams: {
                                placeholder: (0, $cstaF.searchTerms).searchName
                            }
                        }
                    },
                    {
                        col: $3412def860541caa$export$1d3d3c46b46af74e.officeName,
                        colDef: (0, $98ROn.colSettings).textLg,
                        filterOptions: {
                            filter: "agTextColumnFilter",
                            floatingFilterComponent: (0, $kWnaD.default),
                            floatingFilterComponentParams: {
                                placeholder: (0, $cstaF.searchTerms).searchOffice
                            }
                        }
                    },
                    {
                        col: $3412def860541caa$export$1d3d3c46b46af74e.officeId,
                        colDef: (0, $98ROn.colSettings).textSm,
                        initialHide: true
                    },
                    {
                        col: $3412def860541caa$export$1d3d3c46b46af74e.officeAddress,
                        colDef: (0, $98ROn.colSettings).textMd,
                        initialHide: (0, $fPGDZ.isHiddenColumn)($3412def860541caa$export$1d3d3c46b46af74e.officeAddress.id, $3412def860541caa$var$columns)
                    },
                    {
                        col: $3412def860541caa$export$1d3d3c46b46af74e.officeCity,
                        colDef: (0, $98ROn.colSettings).textSm,
                        initialHide: (0, $fPGDZ.isHiddenColumn)($3412def860541caa$export$1d3d3c46b46af74e.officeAddress.id, $3412def860541caa$var$columns)
                    },
                    {
                        col: $3412def860541caa$export$1d3d3c46b46af74e.officeZipCode,
                        colDef: (0, $98ROn.colSettings).textXs,
                        initialHide: (0, $fPGDZ.isHiddenColumn)($3412def860541caa$export$1d3d3c46b46af74e.officeAddress.id, $3412def860541caa$var$columns)
                    },
                    {
                        col: $3412def860541caa$export$1d3d3c46b46af74e.officeCounty,
                        colDef: (0, $98ROn.colSettings).textSm,
                        initialHide: (0, $fPGDZ.isHiddenColumn)($3412def860541caa$export$1d3d3c46b46af74e.officeAddress.id, $3412def860541caa$var$columns)
                    }
                ]
            },
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)((0, $eHBjM.additionalTableHeaders).column2, props),
                children: [
                    {
                        col: $3412def860541caa$export$1d3d3c46b46af74e.previousPeriodTotalUnits,
                        colDef: (0, $98ROn.colSettings).numberMdLgUnits
                    },
                    {
                        col: $3412def860541caa$export$1d3d3c46b46af74e.totalUnits,
                        colDef: (0, $98ROn.colSettings).numberMdUnits
                    },
                    {
                        col: $3412def860541caa$export$1d3d3c46b46af74e.totalUnitsChange,
                        colDef: (0, $98ROn.colSettings).numberSmUnits
                    },
                    {
                        col: $3412def860541caa$export$1d3d3c46b46af74e.totalUnitsGrowth,
                        colDef: (0, $98ROn.colSettings).numberSmPercentage
                    }
                ]
            },
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)((0, $eHBjM.additionalTableHeaders).column3, props),
                children: [
                    {
                        col: $3412def860541caa$export$1d3d3c46b46af74e.previousPeriodTotalVolume,
                        colDef: (0, $98ROn.colSettings).numberMdLgVolume
                    },
                    {
                        col: $3412def860541caa$export$1d3d3c46b46af74e.totalVolume,
                        colDef: (0, $98ROn.colSettings).numberMdVolume
                    },
                    {
                        col: $3412def860541caa$export$1d3d3c46b46af74e.totalVolumeChange,
                        colDef: (0, $98ROn.colSettings).numberSmVolume
                    },
                    {
                        col: $3412def860541caa$export$1d3d3c46b46af74e.totalVolumeGrowth,
                        colDef: (0, $98ROn.colSettings).numberSmPercentage
                    }
                ]
            }
        ]
    },
    [(0, $eHBjM.tableViewNames).agentDetailProduction]: {
        id: (0, $eHBjM.tableViewNames).agentDetailProduction,
        showPagination: false,
        defaultSort: {
            colId: (0, $eHBjM.agentsColumns).agProdMonth.id,
            sortDir: "desc"
        },
        tables: [
            {
                col: (0, $eHBjM.agentsColumns).agProdMonth,
                colDef: (0, $98ROn.colSettings).textLg,
                cellRenderer: $3412def860541caa$export$cc0e79d2a41dc68a.agentProductionListingLink
            },
            {
                col: (0, $eHBjM.agentsColumns).listUnits,
                colDef: (0, $98ROn.colSettings).numberSmUnits
            },
            {
                col: (0, $eHBjM.agentsColumns).sellUnits,
                colDef: (0, $98ROn.colSettings).numberSmUnits
            },
            {
                col: (0, $eHBjM.agentsColumns).totalUnits,
                colDef: (0, $98ROn.colSettings).numberSmUnits
            },
            {
                col: (0, $eHBjM.agentsColumns).listVolume,
                colDef: (0, $98ROn.colSettings).numberSmVolume
            },
            {
                col: (0, $eHBjM.agentsColumns).sellVolume,
                colDef: (0, $98ROn.colSettings).numberSmVolume
            },
            {
                col: (0, $eHBjM.agentsColumns).totalVolume,
                colDef: (0, $98ROn.colSettings).numberSmVolume
            }
        ]
    },
    [(0, $eHBjM.tableViewNames).contactInformation]: {
        id: (0, $eHBjM.tableViewNames).contactInformation,
        defaultSort: {
            colId: (0, $eHBjM.agentsColumns).ciTotalVolume.id,
            sortDir: "desc"
        },
        tables: [
            {
                headerGroupTitle: (0, $cIUhV.getContact),
                children: [
                    $3412def860541caa$var$checkboxColumn,
                    {
                        col: (0, $eHBjM.agentsColumns).rank,
                        colDef: (0, $98ROn.colSettings).textXsRightAlign
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).agentName,
                        colDef: (0, $98ROn.colSettings).textLg,
                        cellRenderer: $3412def860541caa$export$cc0e79d2a41dc68a.agentNameLink,
                        filterOptions: {
                            filter: "agTextColumnFilter",
                            floatingFilterComponent: (0, $kWnaD.default),
                            floatingFilterComponentParams: {
                                placeholder: (0, $cstaF.searchTerms).searchName
                            }
                        }
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).agentId,
                        colDef: (0, $98ROn.colSettings).textMd,
                        filterOptions: {
                            filter: "agTextColumnFilter",
                            floatingFilterComponent: (0, $kWnaD.default),
                            floatingFilterComponentParams: {
                                placeholder: (0, $cstaF.searchTerms).searchId
                            }
                        }
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).officeName,
                        colDef: (0, $98ROn.colSettings).textLg,
                        filterOptions: {
                            filter: "agTextColumnFilter",
                            floatingFilterComponent: (0, $kWnaD.default),
                            floatingFilterComponentParams: {
                                placeholder: (0, $cstaF.searchTerms).searchOffice
                            }
                        }
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).officeId,
                        colDef: (0, $98ROn.colSettings).textSm
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).officeAddress,
                        colDef: (0, $98ROn.colSettings).textLg
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).officeCity,
                        colDef: (0, $98ROn.colSettings).textSm
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).officeZipCode,
                        colDef: (0, $98ROn.colSettings).textXs
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).officeCounty,
                        colDef: (0, $98ROn.colSettings).textSm
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).agentPhoneType1,
                        colDef: (0, $98ROn.colSettings).textSm
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).agentPhone1,
                        colDef: (0, $98ROn.colSettings).textMd
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).agentPhoneType2,
                        colDef: (0, $98ROn.colSettings).textSm
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).agentPhone2,
                        colDef: (0, $98ROn.colSettings).textMd
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).agentPhoneType3,
                        colDef: (0, $98ROn.colSettings).textSm
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).agentPhone3,
                        colDef: (0, $98ROn.colSettings).textMd
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).agentEmail,
                        colDef: (0, $98ROn.colSettings).textLg,
                        cellRenderer: $3412def860541caa$export$cc0e79d2a41dc68a.emailLink
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).agentAddress,
                        colDef: (0, $98ROn.colSettings).textLg,
                        cellRenderer: $3412def860541caa$export$cc0e79d2a41dc68a.alternativeAddress
                    }
                ]
            },
            {
                headerGroupTitle: (0, $cIUhV.getCurrentSearchLast6Months),
                children: [
                    {
                        col: (0, $eHBjM.agentsColumns).ciTotalUnits,
                        colDef: (0, $98ROn.colSettings).numberMdLgUnits
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).ciTotalVolume,
                        colDef: (0, $98ROn.colSettings).numberMdLgVolume
                    }
                ]
            },
            {
                headerGroupTitle: (0, $cIUhV.getAllMlsLast12Months),
                children: [
                    {
                        col: (0, $eHBjM.agentsColumns).last12TotalUnits,
                        colDef: (0, $98ROn.colSettings).numberLgUnits
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).last12TotalVolume,
                        colDef: (0, $98ROn.colSettings).numberExLgVolume
                    }
                ]
            },
            {
                headerGroupTitle: (0, $cIUhV.getGrowth),
                children: [
                    {
                        col: (0, $eHBjM.agentsColumns).totalVolumeChange,
                        colDef: (0, $98ROn.colSettings).numberSmVolume
                    },
                    {
                        col: (0, $eHBjM.agentsColumns).totalVolumeGrowth,
                        colDef: (0, $98ROn.colSettings).numberSmPercentage
                    }
                ]
            }
        ]
    },
    [(0, $eHBjM.tableViewNames).transactionCoverageSold]: {
        id: (0, $eHBjM.tableViewNames).transactionCoverageSold,
        showPagination: true,
        paginationOptions: {
            sizePerPage: 10
        },
        defaultSort: {
            colId: (0, $eHBjM.transactionCoverageSoldColumns).totalVolume.id,
            sortDir: "desc"
        },
        tables: [
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)((0, $eHBjM.additionalTableHeaders).column1, props),
                children: [
                    {
                        col: (0, $eHBjM.transactionCoverageSoldColumns).area,
                        colDef: (0, $98ROn.colSettings).textMd,
                        cellRenderer: $3412def860541caa$export$cc0e79d2a41dc68a.areaTransactionCoverageLink
                    }
                ]
            },
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)((0, $eHBjM.additionalTableHeaders).column2, props),
                children: [
                    {
                        col: (0, $eHBjM.transactionCoverageSoldColumns).listUnits,
                        colDef: (0, $98ROn.colSettings).numberSmUnits
                    },
                    {
                        col: (0, $eHBjM.transactionCoverageSoldColumns).listVolume,
                        colDef: (0, $98ROn.colSettings).numberSmVolume
                    }
                ]
            },
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)((0, $eHBjM.additionalTableHeaders).column3, props),
                children: [
                    {
                        col: (0, $eHBjM.transactionCoverageSoldColumns).sellUnits,
                        colDef: (0, $98ROn.colSettings).numberSmUnits
                    },
                    {
                        col: (0, $eHBjM.transactionCoverageSoldColumns).sellVolume,
                        colDef: (0, $98ROn.colSettings).numberSmVolume
                    }
                ]
            },
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)((0, $eHBjM.additionalTableHeaders).column4, props),
                children: [
                    {
                        col: (0, $eHBjM.transactionCoverageSoldColumns).totalUnits,
                        colDef: (0, $98ROn.colSettings).numberSmUnits
                    },
                    {
                        col: (0, $eHBjM.transactionCoverageSoldColumns).totalVolume,
                        colDef: (0, $98ROn.colSettings).numberSmVolume
                    },
                    {
                        col: (0, $eHBjM.transactionCoverageSoldColumns).totalUnitsPct,
                        colDef: (0, $98ROn.colSettings).numberSmPercentage
                    },
                    {
                        col: (0, $eHBjM.transactionCoverageSoldColumns).totalVolumePct,
                        colDef: (0, $98ROn.colSettings).numberSmPercentage
                    }
                ]
            }
        ]
    },
    [(0, $eHBjM.tableViewNames).transactionCoverageUc]: {
        id: (0, $eHBjM.tableViewNames).transactionCoverageUc,
        showPagination: true,
        paginationOptions: {
            sizePerPage: 10
        },
        defaultSort: {
            colId: (0, $eHBjM.transactionCoverageUcColumns).listVolume.id,
            sortDir: "desc"
        },
        tables: [
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)((0, $eHBjM.additionalTableHeaders).column1, props),
                children: [
                    {
                        col: (0, $eHBjM.transactionCoverageUcColumns).area,
                        colDef: (0, $98ROn.colSettings).textMd,
                        cellRenderer: $3412def860541caa$export$cc0e79d2a41dc68a.areaTransactionCoverageLink
                    }
                ]
            },
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)((0, $eHBjM.additionalTableHeaders).column2, props),
                children: [
                    {
                        col: (0, $eHBjM.transactionCoverageUcColumns).listUnits,
                        colDef: (0, $98ROn.colSettings).numberSmUnits
                    },
                    {
                        col: (0, $eHBjM.transactionCoverageUcColumns).listVolume,
                        colDef: (0, $98ROn.colSettings).numberSmVolume
                    },
                    {
                        col: (0, $eHBjM.transactionCoverageUcColumns).totalUnitsPct,
                        colDef: (0, $98ROn.colSettings).numberSmPercentage
                    },
                    {
                        col: (0, $eHBjM.transactionCoverageUcColumns).totalVolumePct,
                        colDef: (0, $98ROn.colSettings).numberSmPercentage
                    }
                ]
            }
        ]
    },
    [(0, $eHBjM.tableViewNames).transactionCoverageForSale]: {
        id: (0, $eHBjM.tableViewNames).transactionCoverageForSale,
        showPagination: true,
        paginationOptions: {
            sizePerPage: 10
        },
        defaultSort: {
            colId: (0, $eHBjM.transactionCoverageForSaleColumns).listVolume.id,
            sortDir: "desc"
        },
        tables: [
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)((0, $eHBjM.additionalTableHeaders).column1, props),
                children: [
                    {
                        col: (0, $eHBjM.transactionCoverageForSaleColumns).area,
                        colDef: (0, $98ROn.colSettings).textMd,
                        cellRenderer: $3412def860541caa$export$cc0e79d2a41dc68a.areaTransactionCoverageLink
                    }
                ]
            },
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)((0, $eHBjM.additionalTableHeaders).column2, props),
                children: [
                    {
                        col: (0, $eHBjM.transactionCoverageForSaleColumns).listUnits,
                        colDef: (0, $98ROn.colSettings).numberSmUnits
                    },
                    {
                        col: (0, $eHBjM.transactionCoverageForSaleColumns).listVolume,
                        colDef: (0, $98ROn.colSettings).numberSmVolume
                    },
                    {
                        col: (0, $eHBjM.transactionCoverageForSaleColumns).totalUnitsPct,
                        colDef: (0, $98ROn.colSettings).numberSmPercentage
                    },
                    {
                        col: (0, $eHBjM.transactionCoverageForSaleColumns).totalVolumePct,
                        colDef: (0, $98ROn.colSettings).numberSmPercentage
                    }
                ]
            }
        ]
    },
    [(0, $eHBjM.tableViewNames).listingProficiency]: (0, $4mur5.default)($3412def860541caa$export$c6898a0725882d3a),
    [(0, $eHBjM.tableViewNames).availableAgents]: (0, $d9xWn.default)($3412def860541caa$export$c6898a0725882d3a),
    [(0, $eHBjM.tableViewNames).addedAgents]: (0, $fEn75.default)($3412def860541caa$export$c6898a0725882d3a),
    [(0, $eHBjM.tableViewNames).officeHistory]: (0, $lb545.default)($3412def860541caa$export$c6898a0725882d3a),
    [(0, $eHBjM.tableViewNames).agentCoverageListingForSale]: (0, $bksJ0.default)($3412def860541caa$export$c6898a0725882d3a),
    [(0, $eHBjM.tableViewNames).agentCoverageListingSold]: (0, $eLlZr.default)($3412def860541caa$export$c6898a0725882d3a),
    [(0, $eHBjM.tableViewNames).agentCoverageListingUc]: (0, $6RwGN.default)($3412def860541caa$export$c6898a0725882d3a),
    [(0, $eHBjM.tableViewNames).agentProductionListingTotalSold]: (0, $gC1w5.default)((0, $eHBjM.tableViewNames).agentProductionListingTotalSold, $3412def860541caa$export$c6898a0725882d3a),
    [(0, $eHBjM.tableViewNames).agentProductionListingListSide]: (0, $gC1w5.default)((0, $eHBjM.tableViewNames).agentProductionListingListSide, $3412def860541caa$export$c6898a0725882d3a),
    [(0, $eHBjM.tableViewNames).agentProductionListingSellSide]: (0, $gC1w5.default)((0, $eHBjM.tableViewNames).agentProductionListingSellSide, $3412def860541caa$export$c6898a0725882d3a),
    [(0, $eHBjM.tableViewNames).agentsGainedBreakdown]: (shouldShowAdditionalInfo)=>(0, $hAeWH.default)((0, $eHBjM.tableViewNames).agentsGainedBreakdown, $3412def860541caa$export$c6898a0725882d3a, shouldShowAdditionalInfo),
    [(0, $eHBjM.tableViewNames).lostAgentsBreakdown]: (shouldShowAdditionalInfo)=>(0, $g5uaS.default)((0, $eHBjM.tableViewNames).lostAgentsBreakdown, $3412def860541caa$export$c6898a0725882d3a, shouldShowAdditionalInfo),
    [(0, $eHBjM.tableViewNames).activity]: (0, $jrnUE.default)($3412def860541caa$export$c6898a0725882d3a),
    [(0, $cL3O2.listingViews).avg$Sqft.value]: (0, $cL3O2.listingViews).avg$Sqft.tableSettings,
    [(0, $cL3O2.listingViews).avgDomCdom.value]: (0, $cL3O2.listingViews).avgDomCdom.tableSettings,
    [(0, $cL3O2.listingViews).avgSpLpComparison.value]: (0, $cL3O2.listingViews).avgSpLpComparison.tableSettings,
    [(0, $cL3O2.listingViews).avgSpOpAllComparison.value]: (0, $cL3O2.listingViews).avgSpOpAllComparison.tableSettings,
    [(0, $cL3O2.listingViews).avgSpOpAllProperties.value]: (0, $cL3O2.listingViews).avgSpOpAllProperties.tableSettings,
    [(0, $cL3O2.listingViews).avgSpOpComparison.value]: (0, $cL3O2.listingViews).avgSpOpComparison.tableSettings,
    [(0, $cL3O2.listingViews).cdomBreakout.value]: (0, $cL3O2.listingViews).cdomBreakout.tableSettings,
    [(0, $cL3O2.listingViews).forSaleVsFsldm.value]: (0, $cL3O2.listingViews).forSaleVsFsldm.tableSettings,
    [(0, $cL3O2.listingViews).medianPrice.value]: (0, $cL3O2.listingViews).medianPrice.tableSettings,
    [(0, $cL3O2.listingViews).monthlySupplyOfInventory.value]: (0, $cL3O2.listingViews).monthlySupplyOfInventory.tableSettings,
    [(0, $cL3O2.listingViews).salesAbsorption.value]: (0, $cL3O2.listingViews).salesAbsorption.tableSettings,
    [(0, $cL3O2.listingViews).soldAvgVsMedianPrice.value]: (0, $cL3O2.listingViews).soldAvgVsMedianPrice.tableSettings,
    [(0, $cL3O2.listingViews).supplyAmpDemandNumUnits.value]: (0, $cL3O2.listingViews).supplyAmpDemandNumUnits.tableSettings,
    [(0, $cL3O2.listingViews).underContractUc.value]: (0, $cL3O2.listingViews).underContractUc.tableSettings
};

});
parcelRegister("61Zb3", function(module, exports) {

$parcel$export(module.exports, "default", () => $3040920eeb06cc27$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $dI25G = parcelRequire("dI25G");

var $eOjgM = parcelRequire("eOjgM");

var $ajR31 = parcelRequire("ajR31");

var $90ISC = parcelRequire("90ISC");

var $eHBjM = parcelRequire("eHBjM");

var $ivaD7 = parcelRequire("ivaD7");

var $dplp9 = parcelRequire("dplp9");
const $3040920eeb06cc27$var$FavoriteAgent = (props)=>{
    const { colDef: colDef, node: node } = props;
    const tableId = colDef?.cellRendererParams?.tableId;
    const { agentLists: agentLists, removeAgentListsCheckedValues: removeAgentListsCheckedValues, addAgentListsCheckedValues: addAgentListsCheckedValues } = (0, $90ISC.useCommonStore)((state)=>({
            agentLists: state.agentLists,
            removeAgentListsCheckedValues: state.removeAgentListsCheckedValues,
            addAgentListsCheckedValues: state.addAgentListsCheckedValues
        }));
    const { search: search, selectedModule: selectedModule, suggAgentsTabId: suggAgentsTabId } = (0, $90ISC.useSearchStore)((state)=>({
            search: state[state.selectedModule]?.search,
            selectedModule: state.selectedModule,
            suggAgentsTabId: state[state.selectedModule]?.currentTabId
        }));
    const selectedList = (0, $90ISC.useSavedAgentsStore)((state)=>state.selectedListByModule[selectedModule]);
    const mlsId = search?.mlsId || !!agentLists?.length && selectedList?.mlsId;
    const [state, setState] = (0, $acw62.useState)({
        savedAgentLists: agentLists
    });
    const showSavedAgentLists = ()=>{
        state.savedAgentLists.map((list)=>{
            if (list.agentIds.includes(node.data?.agentId)) addAgentListsCheckedValues(list?.agentListId);
            else removeAgentListsCheckedValues(list?.agentListId);
        });
    };
    const handleStarClick = ()=>{
        showSavedAgentLists();
        const popoverData = {
            agentId: node.data?.agentId,
            rowIndex: node.data?.rank,
            tableId: tableId,
            popoverIsOpen: true,
            ...suggAgentsTabId ? {
                suggAgentsTabId: suggAgentsTabId
            } : {}
        };
        (0, $90ISC.useCommonStore).setState({
            popoverDataForAddAgentList: popoverData
        });
    };
    (0, $acw62.useEffect)(()=>{
        (0, $ivaD7.setStateData)("savedAgentLists", agentLists?.filter((list)=>list?.mlsId === mlsId), setState);
    }, [
        agentLists
    ]);
    const renderStarIcon = ()=>{
        const currentMlsSavedAgentLists = state.savedAgentLists?.filter((list)=>list.mlsId === mlsId);
        const isAgentInSavedAgentLists = currentMlsSavedAgentLists?.find((list)=>{
            return !!list.agentIds.includes(node.data.agentId);
        });
        const startContainerId = (0, $eHBjM.popoverTerms).starIcon(tableId, node.data?.rank, suggAgentsTabId);
        const starIcon = isAgentInSavedAgentLists ? (0, $ajR31.star) : (0, $eOjgM.star);
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            id: startContainerId,
            className: `${(0, $dplp9.cssClassNames).centeredChildren} d-flex`,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                icon: starIcon,
                onClick: handleStarClick
            })
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: renderStarIcon()
    });
};
$3040920eeb06cc27$var$FavoriteAgent.propTypes = {
    colDef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object.isRequired,
    node: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object.isRequired
};
var $3040920eeb06cc27$export$2e2bcd8739ae039 = $3040920eeb06cc27$var$FavoriteAgent;

});
parcelRegister("ajR31", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.warning = module.exports.video_player = module.exports.toggle = module.exports.thumb_up = module.exports.thumb_down = module.exports.star = module.exports.required_circle = module.exports.remove = module.exports.plug = module.exports.marker = module.exports.heart = module.exports.flag = module.exports.dots = module.exports.diamond_exclamation = module.exports.crown = module.exports.comment = module.exports.clock = module.exports.circle_x = module.exports.circle_small_x = module.exports.circle_info = module.exports.circle_checkmark = module.exports.circle_arrow_right = module.exports.camera_video = module.exports.arrow_sliding_down = module.exports.add = void 0;

var $b2Sy1 = parcelRequire("b2Sy1");
Object.defineProperty(module.exports, "add", {
    enumerable: true,
    get: function() {
        return $b2Sy1.add;
    }
});

var $14PuL = parcelRequire("14PuL");
Object.defineProperty(module.exports, "arrow_sliding_down", {
    enumerable: true,
    get: function() {
        return $14PuL.arrow_sliding_down;
    }
});

var $b1UCK = parcelRequire("b1UCK");
Object.defineProperty(module.exports, "camera_video", {
    enumerable: true,
    get: function() {
        return $b1UCK.camera_video;
    }
});

var $jSrKN = parcelRequire("jSrKN");
Object.defineProperty(module.exports, "circle_arrow_right", {
    enumerable: true,
    get: function() {
        return $jSrKN.circle_arrow_right;
    }
});

var $6feJc = parcelRequire("6feJc");
Object.defineProperty(module.exports, "circle_checkmark", {
    enumerable: true,
    get: function() {
        return $6feJc.circle_checkmark;
    }
});

var $llTrZ = parcelRequire("llTrZ");
Object.defineProperty(module.exports, "circle_info", {
    enumerable: true,
    get: function() {
        return $llTrZ.circle_info;
    }
});

var $37FPR = parcelRequire("37FPR");
Object.defineProperty(module.exports, "circle_small_x", {
    enumerable: true,
    get: function() {
        return $37FPR.circle_small_x;
    }
});

var $jUD1P = parcelRequire("jUD1P");
Object.defineProperty(module.exports, "circle_x", {
    enumerable: true,
    get: function() {
        return $jUD1P.circle_x;
    }
});

var $dcfvZ = parcelRequire("dcfvZ");
Object.defineProperty(module.exports, "clock", {
    enumerable: true,
    get: function() {
        return $dcfvZ.clock;
    }
});

var $7Mtwj = parcelRequire("7Mtwj");
Object.defineProperty(module.exports, "comment", {
    enumerable: true,
    get: function() {
        return $7Mtwj.comment;
    }
});

var $eDO0N = parcelRequire("eDO0N");
Object.defineProperty(module.exports, "crown", {
    enumerable: true,
    get: function() {
        return $eDO0N.crown;
    }
});

var $gIX56 = parcelRequire("gIX56");
Object.defineProperty(module.exports, "diamond_exclamation", {
    enumerable: true,
    get: function() {
        return $gIX56.diamond_exclamation;
    }
});

var $i1ceW = parcelRequire("i1ceW");
Object.defineProperty(module.exports, "dots", {
    enumerable: true,
    get: function() {
        return $i1ceW.dots;
    }
});

var $7v4zM = parcelRequire("7v4zM");
Object.defineProperty(module.exports, "flag", {
    enumerable: true,
    get: function() {
        return $7v4zM.flag;
    }
});

var $6LyuI = parcelRequire("6LyuI");
Object.defineProperty(module.exports, "heart", {
    enumerable: true,
    get: function() {
        return $6LyuI.heart;
    }
});

var $dWgpS = parcelRequire("dWgpS");
Object.defineProperty(module.exports, "marker", {
    enumerable: true,
    get: function() {
        return $dWgpS.marker;
    }
});

var $42BdQ = parcelRequire("42BdQ");
Object.defineProperty(module.exports, "plug", {
    enumerable: true,
    get: function() {
        return $42BdQ.plug;
    }
});

var $dBIYr = parcelRequire("dBIYr");
Object.defineProperty(module.exports, "remove", {
    enumerable: true,
    get: function() {
        return $dBIYr.remove;
    }
});

var $7CwSJ = parcelRequire("7CwSJ");
Object.defineProperty(module.exports, "required_circle", {
    enumerable: true,
    get: function() {
        return $7CwSJ.required_circle;
    }
});

var $9Ezpm = parcelRequire("9Ezpm");
Object.defineProperty(module.exports, "star", {
    enumerable: true,
    get: function() {
        return $9Ezpm.star;
    }
});

var $bMjeJ = parcelRequire("bMjeJ");
Object.defineProperty(module.exports, "thumb_down", {
    enumerable: true,
    get: function() {
        return $bMjeJ.thumb_down;
    }
});

var $8cj5z = parcelRequire("8cj5z");
Object.defineProperty(module.exports, "thumb_up", {
    enumerable: true,
    get: function() {
        return $8cj5z.thumb_up;
    }
});

var $7C0bk = parcelRequire("7C0bk");
Object.defineProperty(module.exports, "toggle", {
    enumerable: true,
    get: function() {
        return $7C0bk.toggle;
    }
});

var $6gS2o = parcelRequire("6gS2o");
Object.defineProperty(module.exports, "video_player", {
    enumerable: true,
    get: function() {
        return $6gS2o.video_player;
    }
});

var $hvwkd = parcelRequire("hvwkd");
Object.defineProperty(module.exports, "warning", {
    enumerable: true,
    get: function() {
        return $hvwkd.warning;
    }
});

});
parcelRegister("b2Sy1", function(module, exports) {
"use strict";
var $80aa31a6d88a877c$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $80aa31a6d88a877c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.add = void 0;

/* eslint-disable max-len */ const $80aa31a6d88a877c$var$react_1 = $80aa31a6d88a877c$var$__importDefault((parcelRequire("acw62")));

const $80aa31a6d88a877c$var$classnames_1 = $80aa31a6d88a877c$var$__importDefault((parcelRequire("8g1PZ")));
const $80aa31a6d88a877c$var$add = (_a)=>{
    var { className: className } = _a, rest = $80aa31a6d88a877c$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $80aa31a6d88a877c$var$classnames_1.default)("helix-icon", "add-solid", className);
    return $80aa31a6d88a877c$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $80aa31a6d88a877c$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 16C13.3137 16 16 13.3137 16 10C16 6.68629 13.3137 4 10 4C6.68629 4 4 6.68629 4 10C4 13.3137 6.68629 16 10 16ZM10.75 6.75C10.75 6.33579 10.4142 6 10 6C9.58579 6 9.25 6.33579 9.25 6.75V9.25H6.75C6.33579 9.25 6 9.58579 6 10C6 10.4142 6.33579 10.75 6.75 10.75H9.25V13.25C9.25 13.6642 9.58579 14 10 14C10.4142 14 10.75 13.6642 10.75 13.25V10.75H13.25C13.6642 10.75 14 10.4142 14 10C14 9.58579 13.6642 9.25 13.25 9.25H10.75V6.75Z",
        fill: "#4B5563"
    }));
};
module.exports.add = $80aa31a6d88a877c$var$add;

});

parcelRegister("14PuL", function(module, exports) {
"use strict";
var $0c8e1c0b98731661$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $0c8e1c0b98731661$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.arrow_sliding_down = void 0;

/* eslint-disable max-len */ const $0c8e1c0b98731661$var$react_1 = $0c8e1c0b98731661$var$__importDefault((parcelRequire("acw62")));

const $0c8e1c0b98731661$var$classnames_1 = $0c8e1c0b98731661$var$__importDefault((parcelRequire("8g1PZ")));
const $0c8e1c0b98731661$var$arrow_sliding_down = (_a)=>{
    var { className: className } = _a, rest = $0c8e1c0b98731661$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $0c8e1c0b98731661$var$classnames_1.default)("helix-icon", "arrow-sliding-down-solid", className);
    return $0c8e1c0b98731661$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $0c8e1c0b98731661$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3 6.75C3 6.33579 3.33579 6 3.75 6C8.15644 6 10.5977 7.17576 12.3203 8.76055C13.1154 9.49207 13.7404 10.2965 14.3102 11.0298C14.3392 11.0671 14.368 11.1042 14.3967 11.1411C15.0025 11.92 15.5508 12.6077 16.2301 13.1738C16.5483 13.439 16.5913 13.9119 16.3262 14.2301C16.061 14.5483 15.5881 14.5913 15.2699 14.3262C14.4492 13.6423 13.81 12.83 13.2127 12.062C13.1907 12.0337 13.1687 12.0054 13.1468 11.9772C12.5613 11.2241 12.0054 10.5091 11.3047 9.86445C9.90231 8.57424 7.84356 7.5 3.75 7.5C3.33579 7.5 3 7.16421 3 6.75Z",
        fill: "#4B5563"
    }), $0c8e1c0b98731661$var$react_1.default.createElement("path", {
        d: "M12.5503 15H16C16.5523 15 17 14.5523 17 14V10.5503C17 10.1048 16.4614 9.88172 16.1464 10.1967L14.7701 11.5924L13.5924 12.7507L12.1967 14.1464C11.8817 14.4614 12.1048 15 12.5503 15Z",
        fill: "#4B5563"
    }));
};
module.exports.arrow_sliding_down = $0c8e1c0b98731661$var$arrow_sliding_down;

});

parcelRegister("b1UCK", function(module, exports) {
"use strict";
var $807bb610aefd4c13$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $807bb610aefd4c13$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.camera_video = void 0;

/* eslint-disable max-len */ const $807bb610aefd4c13$var$react_1 = $807bb610aefd4c13$var$__importDefault((parcelRequire("acw62")));

const $807bb610aefd4c13$var$classnames_1 = $807bb610aefd4c13$var$__importDefault((parcelRequire("8g1PZ")));
const $807bb610aefd4c13$var$camera_video = (_a)=>{
    var { className: className } = _a, rest = $807bb610aefd4c13$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $807bb610aefd4c13$var$classnames_1.default)("helix-icon", "camera-video-solid", className);
    return $807bb610aefd4c13$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $807bb610aefd4c13$var$react_1.default.createElement("path", {
        d: "M3 4C1.89543 4 1 4.89543 1 6V14C1 15.1046 1.89543 16 3 16H12C13.1046 16 14 15.1046 14 14V11.7962L17.0818 14.564C17.7256 15.1421 18.75 14.6853 18.75 13.82V6.18002C18.75 5.31474 17.7256 4.85786 17.0818 5.43602L14 8.2038V6C14 4.89543 13.1046 4 12 4H3Z",
        fill: "#4B5563"
    }));
};
module.exports.camera_video = $807bb610aefd4c13$var$camera_video;

});

parcelRegister("jSrKN", function(module, exports) {
"use strict";
var $e78896c9bd56a0a3$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $e78896c9bd56a0a3$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.circle_arrow_right = void 0;

/* eslint-disable max-len */ const $e78896c9bd56a0a3$var$react_1 = $e78896c9bd56a0a3$var$__importDefault((parcelRequire("acw62")));

const $e78896c9bd56a0a3$var$classnames_1 = $e78896c9bd56a0a3$var$__importDefault((parcelRequire("8g1PZ")));
const $e78896c9bd56a0a3$var$circle_arrow_right = (_a)=>{
    var { className: className } = _a, rest = $e78896c9bd56a0a3$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $e78896c9bd56a0a3$var$classnames_1.default)("helix-icon", "circle-arrow-right", className);
    return $e78896c9bd56a0a3$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e78896c9bd56a0a3$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6.99961 13.4001C8.69699 13.4001 10.3249 12.7258 11.5251 11.5256C12.7253 10.3253 13.3996 8.69748 13.3996 7.0001C13.3996 5.30271 12.7253 3.67485 11.5251 2.47461C10.3249 1.27438 8.69699 0.600098 6.99961 0.600098C5.30222 0.600098 3.67436 1.27438 2.47413 2.47461C1.27389 3.67485 0.599609 5.30271 0.599609 7.0001C0.599609 8.69748 1.27389 10.3253 2.47413 11.5256C3.67436 12.7258 5.30222 13.4001 6.99961 13.4001ZM4.39961 6.4001C4.24048 6.4001 4.08787 6.46331 3.97535 6.57583C3.86282 6.68836 3.79961 6.84097 3.79961 7.0001C3.79961 7.15923 3.86282 7.31184 3.97535 7.42436C4.08787 7.53688 4.24048 7.6001 4.39961 7.6001H8.07161L6.39161 9.1601C6.27491 9.26831 6.20598 9.41844 6.19998 9.57747C6.19398 9.7365 6.2514 9.8914 6.35961 10.0081C6.46782 10.1248 6.61795 10.1937 6.77698 10.1997C6.93601 10.2057 7.09091 10.1483 7.20761 10.0401L10.0076 7.4401C10.0682 7.38393 10.1165 7.31586 10.1496 7.24015C10.1826 7.16443 10.1997 7.08271 10.1997 7.0001C10.1997 6.91748 10.1826 6.83576 10.1496 6.76005C10.1165 6.68434 10.0682 6.61626 10.0076 6.5601L7.20761 3.9601C7.14983 3.90652 7.08206 3.86484 7.00817 3.83746C6.93428 3.81007 6.85573 3.7975 6.77698 3.80047C6.61795 3.80647 6.46782 3.8754 6.35961 3.9921C6.2514 4.10879 6.19398 4.26369 6.19998 4.42272C6.20598 4.58176 6.27491 4.73189 6.39161 4.8401L8.07161 6.4001H4.39961Z",
        fill: "#4B5563"
    }));
};
module.exports.circle_arrow_right = $e78896c9bd56a0a3$var$circle_arrow_right;

});

parcelRegister("6feJc", function(module, exports) {
"use strict";
var $48bf917afeba6311$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $48bf917afeba6311$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.circle_checkmark = void 0;

/* eslint-disable max-len */ const $48bf917afeba6311$var$react_1 = $48bf917afeba6311$var$__importDefault((parcelRequire("acw62")));

const $48bf917afeba6311$var$classnames_1 = $48bf917afeba6311$var$__importDefault((parcelRequire("8g1PZ")));
const $48bf917afeba6311$var$circle_checkmark = (_a)=>{
    var { className: className } = _a, rest = $48bf917afeba6311$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $48bf917afeba6311$var$classnames_1.default)("helix-icon", "circle-checkmark-solid", className);
    return $48bf917afeba6311$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $48bf917afeba6311$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58173 2 10C2 14.4183 5.58172 18 10 18ZM13.5919 7.2911C13.2042 6.90343 12.5759 6.9029 12.1875 7.28992L8.5123 10.9528L7.69805 10.1386C7.30959 9.75012 6.67979 9.75013 6.29134 10.1386C5.9038 10.5261 5.90275 11.1541 6.28901 11.543L7.64671 12.9097C7.68616 12.9728 7.73333 13.0325 7.78823 13.0874C7.96997 13.2692 8.20431 13.3663 8.44224 13.3787C8.72674 13.4043 9.02015 13.3082 9.23801 13.0903C9.29548 13.0328 9.34448 12.9701 9.38501 12.9037L13.5919 8.69667C13.9801 8.30853 13.98 7.67924 13.5919 7.2911Z",
        fill: "#4B5563"
    }));
};
module.exports.circle_checkmark = $48bf917afeba6311$var$circle_checkmark;

});

parcelRegister("llTrZ", function(module, exports) {
"use strict";
var $f8b6926db6072caa$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $f8b6926db6072caa$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.circle_info = void 0;

/* eslint-disable max-len */ const $f8b6926db6072caa$var$react_1 = $f8b6926db6072caa$var$__importDefault((parcelRequire("acw62")));

const $f8b6926db6072caa$var$classnames_1 = $f8b6926db6072caa$var$__importDefault((parcelRequire("8g1PZ")));
const $f8b6926db6072caa$var$circle_info = (_a)=>{
    var { className: className } = _a, rest = $f8b6926db6072caa$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $f8b6926db6072caa$var$classnames_1.default)("helix-icon", "circle-info-solid", className);
    return $f8b6926db6072caa$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $f8b6926db6072caa$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM10 7C10.5523 7 11 6.55228 11 6C11 5.44772 10.5523 5 10 5C9.44771 5 9 5.44772 9 6C9 6.55228 9.44771 7 10 7ZM10.0039 8C9.4557 8 9.01098 8.44385 9.00989 8.99207L9 13.999C8.99891 14.5515 9.4465 15 9.99901 15C10.5507 15 10.998 14.5527 10.998 14.001L10.998 8.99402C10.998 8.44504 10.5529 8 10.0039 8Z",
        fill: "#4B5563"
    }));
};
module.exports.circle_info = $f8b6926db6072caa$var$circle_info;

});

parcelRegister("37FPR", function(module, exports) {
"use strict";
var $24627a3626910395$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $24627a3626910395$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.circle_small_x = void 0;

/* eslint-disable max-len */ const $24627a3626910395$var$react_1 = $24627a3626910395$var$__importDefault((parcelRequire("acw62")));

const $24627a3626910395$var$classnames_1 = $24627a3626910395$var$__importDefault((parcelRequire("8g1PZ")));
const $24627a3626910395$var$circle_small_x = (_a)=>{
    var { className: className } = _a, rest = $24627a3626910395$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $24627a3626910395$var$classnames_1.default)("helix-icon", "circle-small-x-solid", className);
    return $24627a3626910395$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $24627a3626910395$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 16C13.3137 16 16 13.3137 16 10C16 6.68629 13.3137 4 10 4C6.68629 4 4 6.68629 4 10C4 13.3137 6.68629 16 10 16ZM8.54881 7.47082C8.25656 7.17729 7.78168 7.17626 7.48815 7.46852C7.19463 7.76078 7.19359 8.23565 7.48585 8.52918L8.94164 9.9913L7.46852 11.4708C7.17626 11.7644 7.17729 12.2392 7.47082 12.5315C7.76435 12.8237 8.23922 12.8227 8.53148 12.5292L10 11.0543L11.4685 12.5292C11.7608 12.8227 12.2356 12.8237 12.5292 12.5315C12.8227 12.2392 12.8237 11.7644 12.5315 11.4708L11.0584 9.9913L12.5141 8.52918C12.8064 8.23565 12.8054 7.76078 12.5118 7.46852C12.2183 7.17626 11.7434 7.17729 11.4512 7.47082L10 8.92833L8.54881 7.47082Z",
        fill: "#4B5563"
    }));
};
module.exports.circle_small_x = $24627a3626910395$var$circle_small_x;

});

parcelRegister("jUD1P", function(module, exports) {
"use strict";
var $e7f1858d5523b6e2$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $e7f1858d5523b6e2$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.circle_x = void 0;

/* eslint-disable max-len */ const $e7f1858d5523b6e2$var$react_1 = $e7f1858d5523b6e2$var$__importDefault((parcelRequire("acw62")));

const $e7f1858d5523b6e2$var$classnames_1 = $e7f1858d5523b6e2$var$__importDefault((parcelRequire("8g1PZ")));
const $e7f1858d5523b6e2$var$circle_x = (_a)=>{
    var { className: className } = _a, rest = $e7f1858d5523b6e2$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $e7f1858d5523b6e2$var$classnames_1.default)("helix-icon", "circle-x-solid", className);
    return $e7f1858d5523b6e2$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $e7f1858d5523b6e2$var$react_1.default.createElement("circle", {
        cx: "10",
        cy: "10",
        r: "8",
        fill: "#4B5563"
    }), $e7f1858d5523b6e2$var$react_1.default.createElement("path", {
        d: "M8 8L12 12M8 12L12 8",
        stroke: "white",
        strokeWidth: "1.5",
        strokeLinecap: "square"
    }));
};
module.exports.circle_x = $e7f1858d5523b6e2$var$circle_x;

});

parcelRegister("dcfvZ", function(module, exports) {
"use strict";
var $99b86e4a674eadc5$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $99b86e4a674eadc5$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.clock = void 0;

/* eslint-disable max-len */ const $99b86e4a674eadc5$var$react_1 = $99b86e4a674eadc5$var$__importDefault((parcelRequire("acw62")));

const $99b86e4a674eadc5$var$classnames_1 = $99b86e4a674eadc5$var$__importDefault((parcelRequire("8g1PZ")));
const $99b86e4a674eadc5$var$clock = (_a)=>{
    var { className: className } = _a, rest = $99b86e4a674eadc5$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $99b86e4a674eadc5$var$classnames_1.default)("helix-icon", "clock-solid", className);
    return $99b86e4a674eadc5$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $99b86e4a674eadc5$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM10 5.25C10.4142 5.25 10.75 5.58579 10.75 6V9.63953L12.9685 11.4143C13.292 11.6731 13.3444 12.1451 13.0857 12.4685C12.8269 12.792 12.3549 12.8444 12.0315 12.5857L9.53148 10.5857C9.35357 10.4433 9.25 10.2278 9.25 10V6C9.25 5.58579 9.58579 5.25 10 5.25Z",
        fill: "#4B5563"
    }));
};
module.exports.clock = $99b86e4a674eadc5$var$clock;

});

parcelRegister("7Mtwj", function(module, exports) {
"use strict";
var $5aa3ea2b81e4eab7$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $5aa3ea2b81e4eab7$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.comment = void 0;

/* eslint-disable max-len */ const $5aa3ea2b81e4eab7$var$react_1 = $5aa3ea2b81e4eab7$var$__importDefault((parcelRequire("acw62")));

const $5aa3ea2b81e4eab7$var$classnames_1 = $5aa3ea2b81e4eab7$var$__importDefault((parcelRequire("8g1PZ")));
const $5aa3ea2b81e4eab7$var$comment = (_a)=>{
    var { className: className } = _a, rest = $5aa3ea2b81e4eab7$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $5aa3ea2b81e4eab7$var$classnames_1.default)("helix-icon", "comment-solid", className);
    return $5aa3ea2b81e4eab7$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $5aa3ea2b81e4eab7$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2.25 10C2.25 5.71979 5.71979 2.25 10 2.25C14.2802 2.25 17.75 5.71979 17.75 10C17.75 11.394 17.3813 12.7038 16.7359 13.8352L17.7115 16.7629C17.8013 17.0324 17.7312 17.3295 17.5303 17.5303C17.3295 17.7312 17.0324 17.8013 16.7629 17.7115L13.8352 16.7359C12.7038 17.3813 11.394 17.75 10 17.75C5.71979 17.75 2.25 14.2802 2.25 10Z",
        fill: "#4B5563"
    }));
};
module.exports.comment = $5aa3ea2b81e4eab7$var$comment;

});

parcelRegister("eDO0N", function(module, exports) {
"use strict";
var $02c02f7de7d3fb22$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $02c02f7de7d3fb22$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.crown = void 0;

/* eslint-disable max-len */ const $02c02f7de7d3fb22$var$react_1 = $02c02f7de7d3fb22$var$__importDefault((parcelRequire("acw62")));

const $02c02f7de7d3fb22$var$classnames_1 = $02c02f7de7d3fb22$var$__importDefault((parcelRequire("8g1PZ")));
const $02c02f7de7d3fb22$var$crown = (_a)=>{
    var { className: className } = _a, rest = $02c02f7de7d3fb22$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $02c02f7de7d3fb22$var$classnames_1.default)("helix-icon", "crown-solid", className);
    return $02c02f7de7d3fb22$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $02c02f7de7d3fb22$var$react_1.default.createElement("path", {
        d: "M3 6.80517C3 6.29806 3.66784 6.11308 3.92875 6.54792L6 10L9.58397 4.62405C9.78189 4.32718 10.2181 4.32718 10.416 4.62405L14 10L16.0713 6.54792C16.3322 6.11308 17 6.29806 17 6.80517V15C17 15.5523 16.5523 16 16 16H4C3.44772 16 3 15.5523 3 15V6.80517Z",
        fill: "#4B5563"
    }));
};
module.exports.crown = $02c02f7de7d3fb22$var$crown;

});

parcelRegister("gIX56", function(module, exports) {
"use strict";
var $c2ce95b914a1fa58$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $c2ce95b914a1fa58$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.diamond_exclamation = void 0;

/* eslint-disable max-len */ const $c2ce95b914a1fa58$var$react_1 = $c2ce95b914a1fa58$var$__importDefault((parcelRequire("acw62")));

const $c2ce95b914a1fa58$var$classnames_1 = $c2ce95b914a1fa58$var$__importDefault((parcelRequire("8g1PZ")));
const $c2ce95b914a1fa58$var$diamond_exclamation = (_a)=>{
    var { className: className } = _a, rest = $c2ce95b914a1fa58$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $c2ce95b914a1fa58$var$classnames_1.default)("helix-icon", "diamond_exclamation-solid", className);
    return $c2ce95b914a1fa58$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $c2ce95b914a1fa58$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M11.3845 2.57349C10.6199 1.80884 9.38013 1.80884 8.61548 2.57349L2.57349 8.61548C1.80884 9.38013 1.80884 10.6199 2.57349 11.3845L8.61548 17.4265C9.38013 18.1912 10.6199 18.1912 11.3845 17.4265L17.4265 11.3845C18.1912 10.6199 18.1912 9.38013 17.4265 8.61548L11.3845 2.57349ZM10.0072 11.902C10.3891 11.902 10.7054 11.6055 10.7302 11.2244L11.0651 6.06477C11.1025 5.48821 10.645 5 10.0672 5H9.94722C9.36945 5 8.91189 5.48822 8.94932 6.06477L9.28422 11.2244C9.30896 11.6055 9.62529 11.902 10.0072 11.902ZM9.2302 13.148C9.01554 13.3627 8.9082 13.624 8.9082 13.932C8.9082 14.24 9.01554 14.5013 9.2302 14.716C9.44487 14.9307 9.70154 15.038 10.0002 15.038C10.3082 15.038 10.5695 14.9307 10.7842 14.716C11.0082 14.5013 11.1202 14.24 11.1202 13.932C11.1202 13.624 11.0082 13.3627 10.7842 13.148C10.5695 12.924 10.3082 12.812 10.0002 12.812C9.70154 12.812 9.44487 12.924 9.2302 13.148Z",
        fill: "#4B5563"
    }));
};
module.exports.diamond_exclamation = $c2ce95b914a1fa58$var$diamond_exclamation;

});

parcelRegister("i1ceW", function(module, exports) {
"use strict";
var $d1e1d0959cd162cc$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $d1e1d0959cd162cc$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.dots = void 0;

/* eslint-disable max-len */ const $d1e1d0959cd162cc$var$react_1 = $d1e1d0959cd162cc$var$__importDefault((parcelRequire("acw62")));

const $d1e1d0959cd162cc$var$classnames_1 = $d1e1d0959cd162cc$var$__importDefault((parcelRequire("8g1PZ")));
const $d1e1d0959cd162cc$var$dots = (_a)=>{
    var { className: className } = _a, rest = $d1e1d0959cd162cc$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $d1e1d0959cd162cc$var$classnames_1.default)("helix-icon", "dots-solid", className);
    return $d1e1d0959cd162cc$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $d1e1d0959cd162cc$var$react_1.default.createElement("circle", {
        cx: "7",
        cy: "10",
        r: "3",
        fill: "#4B5563"
    }), $d1e1d0959cd162cc$var$react_1.default.createElement("circle", {
        cx: "13",
        cy: "10",
        r: "3",
        fill: "#4B5563"
    }));
};
module.exports.dots = $d1e1d0959cd162cc$var$dots;

});

parcelRegister("7v4zM", function(module, exports) {
"use strict";
var $575efa64a436e569$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $575efa64a436e569$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.flag = void 0;

/* eslint-disable max-len */ const $575efa64a436e569$var$react_1 = $575efa64a436e569$var$__importDefault((parcelRequire("acw62")));

const $575efa64a436e569$var$classnames_1 = $575efa64a436e569$var$__importDefault((parcelRequire("8g1PZ")));
const $575efa64a436e569$var$flag = (_a)=>{
    var { className: className } = _a, rest = $575efa64a436e569$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $575efa64a436e569$var$classnames_1.default)("helix-icon", "flag-solid", className);
    return $575efa64a436e569$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $575efa64a436e569$var$react_1.default.createElement("path", {
        d: "M5.125 4.5625C5.125 4.41332 5.06574 4.27024 4.96025 4.16475C4.85476 4.05926 4.71168 4 4.5625 4C4.41332 4 4.27024 4.05926 4.16475 4.16475C4.05926 4.27024 4 4.41332 4 4.5625V15.4375C4 15.5867 4.05926 15.7298 4.16475 15.8352C4.27024 15.9407 4.41332 16 4.5625 16C4.71168 16 4.85476 15.9407 4.96025 15.8352C5.06574 15.7298 5.125 15.5867 5.125 15.4375V12.1435L6.36775 11.8825C7.4531 11.654 8.58402 11.8054 9.571 12.3115C10.954 13.0207 12.5593 13.1617 14.0448 12.7045L15.6033 12.2245C15.7181 12.1891 15.8185 12.1179 15.8899 12.0212C15.9613 11.9246 15.9999 11.8076 16 11.6875V5.3125C16 5.22883 15.9813 5.14622 15.9454 5.07068C15.9094 4.99514 15.857 4.92857 15.7921 4.87583C15.7271 4.82309 15.6512 4.78551 15.5699 4.76582C15.4886 4.74612 15.4039 4.74482 15.322 4.762L13.537 5.13775C12.4866 5.35888 11.3942 5.26416 10.3975 4.8655L10.021 4.7155C8.81796 4.234 7.4993 4.11943 6.23125 4.38625L5.125 4.61875V4.5625Z",
        fill: "#4B5563"
    }));
};
module.exports.flag = $575efa64a436e569$var$flag;

});

parcelRegister("6LyuI", function(module, exports) {
"use strict";
var $4ed1e3c1165052ef$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $4ed1e3c1165052ef$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.heart = void 0;

/* eslint-disable max-len */ const $4ed1e3c1165052ef$var$react_1 = $4ed1e3c1165052ef$var$__importDefault((parcelRequire("acw62")));

const $4ed1e3c1165052ef$var$classnames_1 = $4ed1e3c1165052ef$var$__importDefault((parcelRequire("8g1PZ")));
const $4ed1e3c1165052ef$var$heart = (_a)=>{
    var { className: className } = _a, rest = $4ed1e3c1165052ef$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $4ed1e3c1165052ef$var$classnames_1.default)("helix-icon", "heart-solid", className);
    return $4ed1e3c1165052ef$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $4ed1e3c1165052ef$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 17L8.9125 15.9967C5.05 12.43 2.5 10.0763 2.5 7.19619C2.5 4.84251 4.31125 3 6.625 3C7.93 3 9.1825 3.61798 10 4.59074C10.8175 3.61798 12.07 3 13.375 3C15.6888 3 17.5 4.84251 17.5 7.19619C17.5 10.0763 14.95 12.43 11.0875 15.9967L10 17Z",
        fill: "#4B5563",
        stroke: "#4B5563",
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));
};
module.exports.heart = $4ed1e3c1165052ef$var$heart;

});

parcelRegister("dWgpS", function(module, exports) {
"use strict";
var $a25d6d17044beeaf$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $a25d6d17044beeaf$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.marker = void 0;

/* eslint-disable max-len */ const $a25d6d17044beeaf$var$react_1 = $a25d6d17044beeaf$var$__importDefault((parcelRequire("acw62")));

const $a25d6d17044beeaf$var$classnames_1 = $a25d6d17044beeaf$var$__importDefault((parcelRequire("8g1PZ")));
const $a25d6d17044beeaf$var$marker = (_a)=>{
    var { className: className } = _a, rest = $a25d6d17044beeaf$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $a25d6d17044beeaf$var$classnames_1.default)("helix-icon", "marker-solid", className);
    return $a25d6d17044beeaf$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $a25d6d17044beeaf$var$react_1.default.createElement("path", {
        d: "M13.1459 1.28932C13.5302 0.903538 14.1532 0.903565 14.5375 1.28938L18.7118 5.48016C19.0961 5.86602 19.0961 6.49162 18.7117 6.87745L9.66479 15.9587C9.28047 16.3444 8.65742 16.3444 8.27313 15.9586L4.0989 11.7678C3.71457 11.382 3.7146 10.7564 4.09896 10.3705L13.1459 1.28932Z",
        fill: "#4B5563"
    }), $a25d6d17044beeaf$var$react_1.default.createElement("path", {
        d: "M2.24991 13.5534L6.42505 17.7451L2.8269 18.9493C2.47328 19.0676 2.08342 18.9752 1.81985 18.7106L1.28826 18.1769C1.02469 17.9123 0.932654 17.5209 1.05053 17.1659L2.24991 13.5534Z",
        fill: "#4B5563"
    }));
};
module.exports.marker = $a25d6d17044beeaf$var$marker;

});

parcelRegister("42BdQ", function(module, exports) {
"use strict";
var $2f1438e2e744e29d$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $2f1438e2e744e29d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.plug = void 0;

/* eslint-disable max-len */ const $2f1438e2e744e29d$var$react_1 = $2f1438e2e744e29d$var$__importDefault((parcelRequire("acw62")));

const $2f1438e2e744e29d$var$classnames_1 = $2f1438e2e744e29d$var$__importDefault((parcelRequire("8g1PZ")));
const $2f1438e2e744e29d$var$plug = (_a)=>{
    var { className: className } = _a, rest = $2f1438e2e744e29d$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $2f1438e2e744e29d$var$classnames_1.default)("helix-icon", "plug-solid", className);
    return $2f1438e2e744e29d$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $2f1438e2e744e29d$var$react_1.default.createElement("path", {
        d: "M6.28868 16.9982L2.75315 13.4627L4.87447 11.3414C4.87447 11.3414 2.75315 8.51293 4.52091 6.74516L8.76355 2.50252L17.2488 10.9878L13.0062 15.2304C11.2384 16.9982 8.41 14.8769 8.41 14.8769L6.28868 16.9982Z",
        fill: "#4B5563"
    }), $2f1438e2e744e29d$var$react_1.default.createElement("path", {
        d: "M2.75315 13.4627L2.22282 12.9323C2.08216 13.073 2.00315 13.2638 2.00315 13.4627C2.00315 13.6616 2.08216 13.8524 2.22282 13.993L2.75315 13.4627ZM6.28868 16.9982L5.75835 17.5285C6.05124 17.8214 6.52612 17.8214 6.81901 17.5285L6.28868 16.9982ZM8.41 14.8769L8.86 14.2769C8.56141 14.0529 8.14359 14.0826 7.87967 14.3466L8.41 14.8769ZM13.0062 15.2304L13.5365 15.7608H13.5365L13.0062 15.2304ZM17.2488 10.9878L17.7792 11.5181C18.0721 11.2252 18.0721 10.7504 17.7792 10.4575L17.2488 10.9878ZM8.76355 2.50252L9.29388 1.97219C9.15323 1.83154 8.96247 1.75252 8.76355 1.75252C8.56464 1.75252 8.37388 1.83154 8.23322 1.97219L8.76355 2.50252ZM4.52091 6.74516L3.99058 6.21483L4.52091 6.74516ZM4.87447 11.3414L5.4048 11.8717C5.66872 11.6078 5.69841 11.1899 5.47447 10.8914L4.87447 11.3414ZM13.8898 2.67916C14.1827 2.38627 14.1827 1.9114 13.8898 1.6185C13.5969 1.32561 13.122 1.32561 12.8292 1.6185L13.8898 2.67916ZM10.7078 3.73982C10.4149 4.03272 10.4149 4.50759 10.7078 4.80048C11.0007 5.09338 11.4756 5.09338 11.7685 4.80048L10.7078 3.73982ZM18.1325 6.9218C18.4253 6.62891 18.4253 6.15404 18.1325 5.86114C17.8396 5.56825 17.3647 5.56825 17.0718 5.86114L18.1325 6.9218ZM14.9505 7.98246C14.6576 8.27536 14.6576 8.75023 14.9505 9.04312C15.2434 9.33602 15.7182 9.33602 16.0111 9.04312L14.9505 7.98246ZM2.22282 13.993L5.75835 17.5285L6.81901 16.4679L3.28348 12.9323L2.22282 13.993ZM6.81901 17.5285L8.94033 15.4072L7.87967 14.3466L5.75835 16.4679L6.81901 17.5285ZM8.41 14.8769C7.96 15.4769 7.96022 15.477 7.96044 15.4772C7.96053 15.4773 7.96077 15.4775 7.96095 15.4776C7.96132 15.4779 7.96172 15.4782 7.96217 15.4785C7.96307 15.4792 7.96415 15.48 7.9654 15.4809C7.96789 15.4828 7.97109 15.4851 7.97496 15.488C7.98271 15.4936 7.99318 15.5012 8.00627 15.5106C8.03243 15.5293 8.06909 15.555 8.11529 15.5862C8.20755 15.6485 8.33868 15.7332 8.5009 15.8281C8.82267 16.0163 9.27993 16.2521 9.80801 16.4281C10.8386 16.7716 12.3519 16.9454 13.5365 15.7608L12.4759 14.7001C11.8927 15.2833 11.1079 15.2803 10.2824 15.0051C9.88236 14.8717 9.52203 14.6876 9.25823 14.5333C9.12766 14.457 9.02401 14.3898 8.95468 14.343C8.92009 14.3197 8.89426 14.3015 8.87813 14.29C8.87006 14.2842 8.86444 14.2801 8.86138 14.2779C8.85985 14.2768 8.85896 14.2761 8.85872 14.2759C8.8586 14.2758 8.85865 14.2759 8.85886 14.276C8.85897 14.2761 8.85912 14.2762 8.85931 14.2764C8.8594 14.2764 8.85957 14.2766 8.85962 14.2766C8.85981 14.2767 8.86 14.2769 8.41 14.8769ZM13.5365 15.7608L17.7792 11.5181L16.7185 10.4575L12.4759 14.7001L13.5365 15.7608ZM17.7792 10.4575L9.29388 1.97219L8.23322 3.03285L16.7185 11.5181L17.7792 10.4575ZM8.23322 1.97219L3.99058 6.21483L5.05124 7.27549L9.29388 3.03285L8.23322 1.97219ZM3.99058 6.21483C2.80596 7.39945 2.97974 8.91275 3.32327 9.94334C3.49929 10.4714 3.73504 10.9287 3.92324 11.2505C4.01813 11.4127 4.1029 11.5438 4.16519 11.6361C4.19639 11.6823 4.22209 11.7189 4.24078 11.7451C4.25012 11.7582 4.25773 11.7686 4.2634 11.7764C4.26624 11.7803 4.2686 11.7835 4.27045 11.786C4.27137 11.7872 4.27217 11.7883 4.27284 11.7892C4.27318 11.7896 4.27348 11.79 4.27375 11.7904C4.27389 11.7906 4.27407 11.7908 4.27413 11.7909C4.27431 11.7911 4.27447 11.7914 4.87447 11.3414C5.47447 10.8914 5.47461 10.8915 5.47475 10.8917C5.47479 10.8918 5.47492 10.892 5.47499 10.892C5.47513 10.8922 5.47524 10.8924 5.47532 10.8925C5.47548 10.8927 5.47551 10.8928 5.47543 10.8926C5.47525 10.8924 5.47459 10.8915 5.47347 10.89C5.47123 10.8869 5.46713 10.8813 5.46138 10.8732C5.44985 10.8571 5.4317 10.8313 5.40834 10.7967C5.36153 10.7273 5.29439 10.6237 5.21802 10.4931C5.06372 10.2293 4.87962 9.86899 4.74629 9.469C4.4711 8.64343 4.4681 7.85863 5.05124 7.27549L3.99058 6.21483ZM4.34414 10.811L2.22282 12.9323L3.28348 13.993L5.4048 11.8717L4.34414 10.811ZM12.8292 1.6185L10.7078 3.73982L11.7685 4.80048L13.8898 2.67916L12.8292 1.6185ZM17.0718 5.86114L14.9505 7.98246L16.0111 9.04312L18.1325 6.9218L17.0718 5.86114Z",
        fill: "#4B5563"
    }));
};
module.exports.plug = $2f1438e2e744e29d$var$plug;

});

parcelRegister("dBIYr", function(module, exports) {
"use strict";
var $9e819def87001e3c$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $9e819def87001e3c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.remove = void 0;

/* eslint-disable max-len */ const $9e819def87001e3c$var$react_1 = $9e819def87001e3c$var$__importDefault((parcelRequire("acw62")));

const $9e819def87001e3c$var$classnames_1 = $9e819def87001e3c$var$__importDefault((parcelRequire("8g1PZ")));
const $9e819def87001e3c$var$remove = (_a)=>{
    var { className: className } = _a, rest = $9e819def87001e3c$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $9e819def87001e3c$var$classnames_1.default)("helix-icon", "remove-solid", className);
    return $9e819def87001e3c$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $9e819def87001e3c$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 16C13.3137 16 16 13.3137 16 10C16 6.68629 13.3137 4 10 4C6.68629 4 4 6.68629 4 10C4 13.3137 6.68629 16 10 16ZM6.75 9.25C6.33579 9.25 6 9.58579 6 10C6 10.4142 6.33579 10.75 6.75 10.75H13.25C13.6642 10.75 14 10.4142 14 10C14 9.58579 13.6642 9.25 13.25 9.25H6.75Z",
        fill: "#4B5563"
    }));
};
module.exports.remove = $9e819def87001e3c$var$remove;

});

parcelRegister("7CwSJ", function(module, exports) {
"use strict";
var $58c596a1b7c51f5d$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $58c596a1b7c51f5d$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.required_circle = void 0;

/* eslint-disable max-len */ const $58c596a1b7c51f5d$var$react_1 = $58c596a1b7c51f5d$var$__importDefault((parcelRequire("acw62")));

const $58c596a1b7c51f5d$var$classnames_1 = $58c596a1b7c51f5d$var$__importDefault((parcelRequire("8g1PZ")));
const $58c596a1b7c51f5d$var$required_circle = (_a)=>{
    var { className: className } = _a, rest = $58c596a1b7c51f5d$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $58c596a1b7c51f5d$var$classnames_1.default)("helix-icon", "required_circle-solid", className);
    return $58c596a1b7c51f5d$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $58c596a1b7c51f5d$var$react_1.default.createElement("path", {
        d: "M8.92004 9.72754V7.24609H10.0157C10.8751 7.24609 11.38 7.70801 11.38 8.47607C11.38 9.26025 10.8644 9.72754 9.99963 9.72754H8.92004Z",
        fill: "#4B5563"
    }), $58c596a1b7c51f5d$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18ZM8.92004 10.8984H10.0265L11.3907 13.7505H13.1095L11.5573 10.646C12.4005 10.313 12.9323 9.4751 12.9323 8.4707C12.9323 6.93457 11.901 6 10.2145 6H7.40002V13.7505H8.92004V10.8984Z",
        fill: "#4B5563"
    }));
};
module.exports.required_circle = $58c596a1b7c51f5d$var$required_circle;

});

parcelRegister("9Ezpm", function(module, exports) {
"use strict";
var $707350c23f89af47$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $707350c23f89af47$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.star = void 0;

/* eslint-disable max-len */ const $707350c23f89af47$var$react_1 = $707350c23f89af47$var$__importDefault((parcelRequire("acw62")));

const $707350c23f89af47$var$classnames_1 = $707350c23f89af47$var$__importDefault((parcelRequire("8g1PZ")));
const $707350c23f89af47$var$star = (_a)=>{
    var { className: className } = _a, rest = $707350c23f89af47$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $707350c23f89af47$var$classnames_1.default)("helix-icon", "star-solid", className);
    return $707350c23f89af47$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $707350c23f89af47$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10 1.75C10.2855 1.75 10.5462 1.91207 10.6726 2.16808L12.8492 6.57843L17.7163 7.28566C17.9988 7.32671 18.2335 7.52459 18.3217 7.7961C18.41 8.06761 18.3364 8.36566 18.132 8.56493L14.6101 11.9979L15.4415 16.8454C15.4897 17.1267 15.3741 17.4111 15.1431 17.5789C14.9122 17.7467 14.606 17.7688 14.3533 17.636L10 15.3473L5.64672 17.636C5.39403 17.7688 5.08784 17.7467 4.85688 17.5789C4.62592 17.4111 4.51025 17.1267 4.55851 16.8454L5.38991 11.9979L1.86804 8.56493C1.66361 8.36566 1.59004 8.06761 1.67826 7.7961C1.76647 7.52459 2.00118 7.32671 2.2837 7.28566L7.15081 6.57843L9.32745 2.16808C9.45379 1.91207 9.71452 1.75 10 1.75Z",
        fill: "#4B5563"
    }));
};
module.exports.star = $707350c23f89af47$var$star;

});

parcelRegister("bMjeJ", function(module, exports) {
"use strict";
var $89331966b4eb2d4f$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $89331966b4eb2d4f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.thumb_down = void 0;

/* eslint-disable max-len */ const $89331966b4eb2d4f$var$react_1 = $89331966b4eb2d4f$var$__importDefault((parcelRequire("acw62")));

const $89331966b4eb2d4f$var$classnames_1 = $89331966b4eb2d4f$var$__importDefault((parcelRequire("8g1PZ")));
const $89331966b4eb2d4f$var$thumb_down = (_a)=>{
    var { className: className } = _a, rest = $89331966b4eb2d4f$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $89331966b4eb2d4f$var$classnames_1.default)("helix-icon", "thumb_down-solid", className);
    return $89331966b4eb2d4f$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $89331966b4eb2d4f$var$react_1.default.createElement("path", {
        d: "M8.32262 17.5C8.63525 17.5 8.91509 17.3061 9.02486 17.0133L10.2815 13.6622C10.2999 13.6131 10.3333 13.5711 10.3769 13.542L11.5474 12.7617C11.7462 12.6292 11.9319 12.4779 12.1019 12.3101L13.5546 11.1044C13.5665 11.0946 13.5779 11.0841 13.5888 11.0732C13.6357 11.0263 13.6993 11 13.7656 11L15.7656 11C16.1798 11 16.5156 10.6642 16.5156 10.25V5.75C16.5156 5.33579 16.1798 5 15.7656 5H14.4738C13.9693 5 13.4717 4.88253 13.0204 4.65689L11.0761 3.68475C10.8331 3.56325 10.5652 3.5 10.2935 3.5H6.00322C4.85674 3.5 3.89359 4.36206 3.76698 5.50153L3.26085 10.0567C3.14567 11.0934 3.95713 12 5.00014 12L5.64078 12C6.53693 12 6.77643 12.275 6.85469 12.462C6.96536 12.7264 6.91941 13.1637 6.69918 13.7142L6.53383 14.1276C6.35665 14.5706 6.26562 15.0433 6.26562 15.5203V15.75C6.26562 16.7165 7.04912 17.5 8.01562 17.5H8.32262Z",
        fill: "#4B5563"
    }));
};
module.exports.thumb_down = $89331966b4eb2d4f$var$thumb_down;

});

parcelRegister("8cj5z", function(module, exports) {
"use strict";
var $5f7e406135d13483$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $5f7e406135d13483$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.thumb_up = void 0;

/* eslint-disable max-len */ const $5f7e406135d13483$var$react_1 = $5f7e406135d13483$var$__importDefault((parcelRequire("acw62")));

const $5f7e406135d13483$var$classnames_1 = $5f7e406135d13483$var$__importDefault((parcelRequire("8g1PZ")));
const $5f7e406135d13483$var$thumb_up = (_a)=>{
    var { className: className } = _a, rest = $5f7e406135d13483$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $5f7e406135d13483$var$classnames_1.default)("helix-icon", "thumb-up-solid", className);
    return $5f7e406135d13483$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $5f7e406135d13483$var$react_1.default.createElement("path", {
        d: "M11.443 2.75C11.1304 2.75 10.8505 2.94393 10.7408 3.23666L9.48408 6.58778C9.46567 6.63687 9.4323 6.67893 9.38867 6.70801L8.21823 7.48831C8.01942 7.62085 7.83375 7.77208 7.66374 7.93992L6.21101 9.14558C6.19912 9.15545 6.1877 9.16586 6.17678 9.17678C6.12989 9.22367 6.0663 9.25 6 9.25H4C3.58579 9.25 3.25 9.58579 3.25 10V14.5C3.25 14.9142 3.58579 15.25 4 15.25H5.2918C5.79634 15.25 6.29396 15.3675 6.74524 15.5931L8.68951 16.5653C8.93251 16.6868 9.20046 16.75 9.47214 16.75H13.7624C14.9089 16.75 15.872 15.8879 15.9986 14.7485L16.5048 10.1933C16.6199 9.15662 15.8085 8.25 14.7655 8.25L14.1248 8.25C13.2287 8.25 12.9892 7.975 12.9109 7.78803C12.8003 7.52365 12.8462 7.08634 13.0664 6.53576L13.2318 6.12239C13.409 5.67943 13.5 5.20674 13.5 4.72967V4.5C13.5 3.5335 12.7165 2.75 11.75 2.75H11.443Z",
        fill: "#4B5563"
    }));
};
module.exports.thumb_up = $5f7e406135d13483$var$thumb_up;

});

parcelRegister("7C0bk", function(module, exports) {
"use strict";
var $58ac39161b3ba70f$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $58ac39161b3ba70f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toggle = void 0;

/* eslint-disable max-len */ const $58ac39161b3ba70f$var$react_1 = $58ac39161b3ba70f$var$__importDefault((parcelRequire("acw62")));

const $58ac39161b3ba70f$var$classnames_1 = $58ac39161b3ba70f$var$__importDefault((parcelRequire("8g1PZ")));
const $58ac39161b3ba70f$var$toggle = (_a)=>{
    var { className: className } = _a, rest = $58ac39161b3ba70f$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $58ac39161b3ba70f$var$classnames_1.default)("helix-icon", "toggle-solid", className);
    return $58ac39161b3ba70f$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $58ac39161b3ba70f$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 4C2.68629 4 0 6.68629 0 10C0 13.3137 2.68629 16 6 16H14C17.3137 16 20 13.3137 20 10C20 6.68629 17.3137 4 14 4H6ZM14 14C16.2091 14 18 12.2091 18 10C18 7.79086 16.2091 6 14 6C11.7909 6 10 7.79086 10 10C10 12.2091 11.7909 14 14 14Z",
        fill: "#4B5563"
    }));
};
module.exports.toggle = $58ac39161b3ba70f$var$toggle;

});

parcelRegister("6gS2o", function(module, exports) {
"use strict";
var $490e27756dc34d9c$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $490e27756dc34d9c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.video_player = void 0;

/* eslint-disable max-len */ const $490e27756dc34d9c$var$react_1 = $490e27756dc34d9c$var$__importDefault((parcelRequire("acw62")));

const $490e27756dc34d9c$var$classnames_1 = $490e27756dc34d9c$var$__importDefault((parcelRequire("8g1PZ")));
const $490e27756dc34d9c$var$video_player = (_a)=>{
    var { className: className } = _a, rest = $490e27756dc34d9c$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $490e27756dc34d9c$var$classnames_1.default)("helix-icon", "video-player-solid", className);
    return $490e27756dc34d9c$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $490e27756dc34d9c$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M2 3C1.44772 3 1 3.44772 1 4V16C1 16.5523 1.44772 17 2 17H18C18.5523 17 19 16.5523 19 16V4C19 3.44772 18.5523 3 18 3H2ZM8 13.4641L14 10L8 6.5359V13.4641Z",
        fill: "#4B5563"
    }));
};
module.exports.video_player = $490e27756dc34d9c$var$video_player;

});

parcelRegister("hvwkd", function(module, exports) {
"use strict";
var $cbee680641bb4201$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $cbee680641bb4201$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.warning = void 0;

/* eslint-disable max-len */ const $cbee680641bb4201$var$react_1 = $cbee680641bb4201$var$__importDefault((parcelRequire("acw62")));

const $cbee680641bb4201$var$classnames_1 = $cbee680641bb4201$var$__importDefault((parcelRequire("8g1PZ")));
const $cbee680641bb4201$var$warning = (_a)=>{
    var { className: className } = _a, rest = $cbee680641bb4201$var$__rest(_a, [
        "className"
    ]);
    const classes = (0, $cbee680641bb4201$var$classnames_1.default)("helix-icon", "warning-solid", className);
    return $cbee680641bb4201$var$react_1.default.createElement("svg", Object.assign({
        className: classes,
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-hidden": "true"
    }, rest), $cbee680641bb4201$var$react_1.default.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.1111 3.30761C11.24 1.56413 8.75388 1.56413 7.88281 3.30761L2.25259 14.5766C1.46678 16.1494 2.60961 18 4.36673 18H15.6272C17.3843 18 18.5271 16.1495 17.7413 14.5766L12.1111 3.30761ZM10.0043 12.902C10.3862 12.902 10.7025 12.6055 10.7273 12.2244L11.0622 7.06477C11.0996 6.48821 10.642 6 10.0643 6H9.94429C9.36652 6 8.90896 6.48822 8.94639 7.06477L9.28129 12.2244C9.30603 12.6055 9.62236 12.902 10.0043 12.902ZM9.22727 14.148C9.01261 14.3627 8.90527 14.624 8.90527 14.932C8.90527 15.24 9.01261 15.5013 9.22727 15.716C9.44194 15.9307 9.69861 16.038 9.99727 16.038C10.3053 16.038 10.5666 15.9307 10.7813 15.716C11.0053 15.5013 11.1173 15.24 11.1173 14.932C11.1173 14.624 11.0053 14.3627 10.7813 14.148C10.5666 13.924 10.3053 13.812 9.99727 13.812C9.69861 13.812 9.44194 13.924 9.22727 14.148Z",
        fill: "#4B5563"
    }));
};
module.exports.warning = $cbee680641bb4201$var$warning;

});


parcelRegister("dplp9", function(module, exports) {

$parcel$export(module.exports, "cssClassNames", () => $9c2e36a948a2b962$export$6be16c45581d4ac4);
const $9c2e36a948a2b962$export$6be16c45581d4ac4 = {
    inactiveRow: "inactive-row",
    centeredChildren: "d-flex justify-content-center align-items-center"
};

});


parcelRegister("foeS8", function(module, exports) {

$parcel$export(module.exports, "AgentProfileLink", () => $618f49c3721818ca$export$bd81620d169e64fb);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $kfZjc = parcelRequire("kfZjc");

var $90ISC = parcelRequire("90ISC");

var $c9Z8w = parcelRequire("c9Z8w");

var $eHBjM = parcelRequire("eHBjM");

var $61Zb3 = parcelRequire("61Zb3");
const $618f49c3721818ca$export$bd81620d169e64fb = (props)=>{
    const location = (0, $kfZjc.useLocation)();
    const history = (0, $kfZjc.useHistory)();
    const { clearAgentListPopover: clearAgentListPopover, setAgentDetailNavigation: setAgentDetailNavigation } = (0, $90ISC.useCommonStore)((state)=>({
            clearAgentListPopover: state.clearAgentListPopover,
            setAgentDetailNavigation: state.setAgentDetailNavigation
        }));
    const handleClick = ()=>{
        clearAgentListPopover();
        setAgentDetailNavigation({
            incomingPage: location.pathname,
            tabIndex: 0
        });
        history.push(`${(0, $eHBjM.agentProfileRoute)}?id=${props.data.agentId}`, {
            fromOfficeBreakdownAndGrowthTab: location.state?.fromOfficeBreakdownAndGrowthTab
        });
    };
    if (props?.data?.hasFavStar) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "agent-favorite-wrapper",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "table-row-link clickable agent-name-limited",
                onClick: handleClick,
                title: props.data.agentName,
                children: props.data.agentName
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $61Zb3.default), {
                ...props
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: "table-row-link clickable",
        onClick: handleClick,
        children: props.data.agentName
    });
};
$618f49c3721818ca$export$bd81620d169e64fb.propTypes = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};

});

parcelRegister("cIUhV", function(module, exports) {

$parcel$export(module.exports, "getAdditionalTableHeader", () => $3f09751f5b87fbb0$export$151bb7f371a9c8fa);
$parcel$export(module.exports, "getContact", () => $3f09751f5b87fbb0$export$52411745da118fc8);
$parcel$export(module.exports, "getCurrentSearchLast6Months", () => $3f09751f5b87fbb0$export$b9e01bd799748893);
$parcel$export(module.exports, "getAllMlsLast12Months", () => $3f09751f5b87fbb0$export$9483a29702dd4e7c);
$parcel$export(module.exports, "getGrowth", () => $3f09751f5b87fbb0$export$f94bef22c5a32fcc);
$parcel$export(module.exports, "handleDrawDivider", () => $3f09751f5b87fbb0$export$1ed904eff7d869dd);
$parcel$export(module.exports, "handleSortedHighlight", () => $3f09751f5b87fbb0$export$aacaf45217cb68d3);
$parcel$export(module.exports, "generateTableColDefs", () => $3f09751f5b87fbb0$export$6240cafea8f9dcd3);
$parcel$export(module.exports, "AG_GRID_LICENSE", () => $3f09751f5b87fbb0$export$49747c523476eb04);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7jSpM = parcelRequire("7jSpM");

var $2JujF = parcelRequire("2JujF");

var $eHBjM = parcelRequire("eHBjM");

var $98ROn = parcelRequire("98ROn");

var $4tbBr = parcelRequire("4tbBr");

var $jKEVi = parcelRequire("jKEVi");

var $dQwVS = parcelRequire("dQwVS");

var $iIEeV = parcelRequire("iIEeV");
const { getTableRetainedStateByType: $3f09751f5b87fbb0$var$getTableRetainedStateByType, setTableRetainedStateByType: $3f09751f5b87fbb0$var$setTableRetainedStateByType } = (0, $jKEVi.useSearchStore).getState();
function $3f09751f5b87fbb0$var$headerWrapper(text) {
    return /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
        className: "ag-header-group-text mx-auto ag-grid-cell-link text-uppercase text-wrap text-center m-2",
        role: "presentation",
        children: text
    });
}
function $3f09751f5b87fbb0$export$151bb7f371a9c8fa(field, props) {
    const { additionalTableHeaders: additionalTableHeaders } = props;
    return $3f09751f5b87fbb0$var$headerWrapper(additionalTableHeaders[0][field]?.title);
}
function $3f09751f5b87fbb0$export$52411745da118fc8(props) {
    const { additionalTableHeaders: additionalTableHeaders } = props;
    return $3f09751f5b87fbb0$var$headerWrapper(additionalTableHeaders[0].contact.title);
}
function $3f09751f5b87fbb0$export$b9e01bd799748893(props) {
    const { additionalTableHeaders: additionalTableHeaders } = props;
    return $3f09751f5b87fbb0$var$headerWrapper(additionalTableHeaders[0].search.title);
}
function $3f09751f5b87fbb0$export$9483a29702dd4e7c(props) {
    const { additionalTableHeaders: additionalTableHeaders } = props;
    return $3f09751f5b87fbb0$var$headerWrapper(additionalTableHeaders[0].mls.title);
}
function $3f09751f5b87fbb0$export$f94bef22c5a32fcc(props) {
    const { additionalTableHeaders: additionalTableHeaders } = props;
    return $3f09751f5b87fbb0$var$headerWrapper(additionalTableHeaders[0].growth.title);
}
const $3f09751f5b87fbb0$var$setDefaultSort = (e, tableView)=>{
    const { defaultSort: defaultSort } = tableView;
    if (defaultSort) {
        const state = (0, $jKEVi.useSearchStore).getState();
        const selectedModule = state.selectedModule;
        const crossSortSourceTableId = state[selectedModule]?.crossSortSourceTableId;
        if (crossSortSourceTableId && (0, $iIEeV.CROSS_SORT_TABLES).includes(tableView.id)) return;
        const columnState = {
            state: [
                {
                    colId: defaultSort.colId,
                    sort: defaultSort.sortDir
                }
            ]
        };
        e.api.applyColumnState(columnState);
    }
};
const $3f09751f5b87fbb0$var$addRemoveHighlights = (elements, columnIndex, highlightClass)=>{
    elements?.forEach((element)=>{
        const ATTR_COLUMN_INDEX = "aria-colindex";
        if (element.getAttribute(ATTR_COLUMN_INDEX) === columnIndex.toString()) element.classList.add(highlightClass);
        else element.classList.remove(highlightClass);
    });
};
const $3f09751f5b87fbb0$var$drawHeaderGroupDivider = ()=>{
    const headerGroupCellElements = document.querySelectorAll(`.ag-header-group-cell`);
    headerGroupCellElements.forEach((element, index)=>{
        const headerResizeElement = element.querySelectorAll(".ag-header-cell-resize")?.[0];
        headerResizeElement.classList.add((0, $98ROn.dividerClassNames).transparentResizeIcon);
        if (index !== headerGroupCellElements.length - 1) element.classList.add((0, $98ROn.dividerClassNames).dividerCol);
    });
};
const $3f09751f5b87fbb0$export$1ed904eff7d869dd = (tableName, columnDefs)=>{
    if (tableName !== (0, $eHBjM.tableViewNames).overview) return;
    $3f09751f5b87fbb0$var$drawHeaderGroupDivider();
    let colIndex = 0;
    let lastShownColumnDefWithIndex = [];
    const hiddenDividers = document.querySelectorAll(`.ag-header-cell > div.ag-header-cell-resize.${(0, $98ROn.dividerClassNames).transparentResizeIcon}`);
    hiddenDividers?.forEach((divider)=>{
        divider.classList.remove((0, $98ROn.dividerClassNames).transparentResizeIcon);
    });
    const filterDividers = document.querySelectorAll(`.ag-floating-filter.${(0, $98ROn.dividerClassNames).dividerCol}`);
    filterDividers?.forEach((divider)=>divider.classList.remove((0, $98ROn.dividerClassNames).dividerCol));
    lastShownColumnDefWithIndex?.forEach(({ id: id })=>{
        const el = document.querySelector(`.ag-floating-filter[aria-colindex='${id}']`);
        el && el.classList.remove((0, $98ROn.dividerClassNames).dividerCol);
    });
    columnDefs.forEach((columDef, index)=>{
        columDef.children.forEach((child, childIndex)=>{
            colIndex++;
            const newArray = columDef.children.slice();
            const lastShownChild = newArray.reverse().find((child)=>!child.initialHide);
            const lastShownChildIndex = columDef.children.findIndex((child)=>{
                return child?.field === lastShownChild?.field;
            });
            const lastShownChildren = columDef.children[lastShownChildIndex];
            const lastIndex = columnDefs.length - 1;
            if (index !== lastIndex) lastShownChildren.cellClass = lastShownChildren.cellClass + ` ${(0, $98ROn.dividerClassNames).dividerCol}`;
            if (childIndex === lastShownChildIndex && lastShownChildren) lastShownColumnDefWithIndex.push({
                ...child,
                id: colIndex,
                group: index
            });
        });
    });
    lastShownColumnDefWithIndex.forEach(({ id: id })=>{
        const floatingFilterElement = document.querySelector(`.ag-floating-filter[aria-colindex='${id}']`);
        floatingFilterElement && floatingFilterElement.classList.add((0, $98ROn.dividerClassNames).dividerCol);
        const headerElement = document.querySelector(`.ag-header-cell[aria-colindex='${id}']`);
        headerElement && headerElement.classList.add((0, $98ROn.dividerClassNames).dividerCol);
    });
    const dividers = document.querySelectorAll(`.ag-header-cell.${(0, $98ROn.dividerClassNames).dividerCol} > div.ag-header-cell-resize`);
    dividers.forEach((divider)=>{
        divider.classList.add((0, $98ROn.dividerClassNames).transparentResizeIcon);
    });
};
const $3f09751f5b87fbb0$export$aacaf45217cb68d3 = (e, tableView, crossSortSourceTableId)=>{
    const columns = e.api.getColumns();
    if (!columns?.length || !tableView) return;
    const CLASS_HIGHLIGHT = "highlighted-column";
    const filteredColumnElements = document.querySelectorAll(`#${tableView?.id} .ag-floating-filter.ag-header-cell`);
    const headerCellElements = document.querySelectorAll(`#${tableView?.id} .ag-header-cell`);
    const clearHighlights = (sortedColumn = null)=>{
        const sortedColumnIndex = sortedColumn ? e.api.getColumns()?.indexOf(sortedColumn) + 1 : -1;
        $3f09751f5b87fbb0$var$addRemoveHighlights(headerCellElements, sortedColumnIndex, CLASS_HIGHLIGHT);
        $3f09751f5b87fbb0$var$addRemoveHighlights(filteredColumnElements, sortedColumnIndex, CLASS_HIGHLIGHT);
        columns?.forEach((column)=>{
            if (column === sortedColumn) column.getColDef().cellClass = `${sortedColumn.userProvidedColDef.cellClass} ${CLASS_HIGHLIGHT}`;
            if (column !== sortedColumn) column.getColDef().cellClass = column.userProvidedColDef.cellClass;
        });
        setTimeout(()=>e.api.refreshCells({
                force: true,
                suppressFlash: true
            }), 10);
    };
    const isSourceTable = tableView?.id === crossSortSourceTableId;
    if (crossSortSourceTableId && !isSourceTable && (0, $iIEeV.CROSS_SORT_TABLES).includes(tableView?.id)) {
        clearHighlights();
        return;
    }
    const sortedColumn = columns?.find((column)=>column.isSorting() && (column.getSortIndex() ?? 0) === 0);
    if (!sortedColumn) {
        const savedSortState = $3f09751f5b87fbb0$var$getTableRetainedStateByType({
            tableId: tableView?.id,
            type: (0, $dQwVS.retainTerms).sort
        });
        if (!savedSortState) $3f09751f5b87fbb0$var$setDefaultSort(e, tableView);
        return;
    }
    const sortState = {
        colId: sortedColumn.getColId(),
        sort: sortedColumn.getSort()
    };
    $3f09751f5b87fbb0$var$setTableRetainedStateByType({
        tableId: tableView?.id,
        type: (0, $dQwVS.retainTerms).sort,
        sortState: sortState
    });
    clearHighlights(sortedColumn);
};
const $3f09751f5b87fbb0$var$generateChildDefs = (item, columns, columnDefs, additionalTableHeaders, tableTitleWithTooltips, externalParams)=>{
    const headerGroup = {
        headerGroupComponent: item.headerGroupTitle,
        headerGroupComponentParams: {
            additionalTableHeaders: additionalTableHeaders
        }
    };
    const childrenObjects = [];
    item.children.map((child)=>{
        const titleWithTooltip = (0, $7jSpM.getTitleWithTooltip)(tableTitleWithTooltips[child.col.id], "", false, externalParams?.tooltipTargetPrefix);
        const filterProps = child.filterOptions && {
            ...child.filterOptions,
            floatingFilter: true,
            suppressHeaderMenuButton: true
        };
        const extControl = columns?.filter((col)=>col.id === child.col.id)[0];
        childrenObjects.push({
            field: child.col.id,
            headerName: child.col.label,
            initialHide: !!extControl ? !extControl?.isDisplayed : !!child.initialHide,
            cellClassRules: child.cellClassRules,
            cellRendererSelector: (params)=>{
                if (!params.node.rowPinned || !externalParams?.summaryPinnedConfig) return {
                    component: child.cellRenderer
                };
                const { cellsToShow: cellsToShow, cellsToOverride: cellsToOverride } = externalParams?.summaryPinnedConfig || {};
                const colId = child.col.id;
                const isCellToShow = cellsToShow.includes(colId);
                const cellOverride = cellsToOverride[colId];
                if (isCellToShow) return {
                    component: child.cellRenderer
                };
                if (!isCellToShow && !cellOverride) return {
                    component: ()=>(0, $4tbBr.cellRenderers).pinnedRow()
                };
                if (cellOverride) return {
                    component: ()=>(0, $4tbBr.cellRenderers).pinnedRow(cellOverride)
                };
            },
            cellRendererParams: externalParams || null,
            headerComponentParams: {
                titleWithTooltip: titleWithTooltip
            },
            ...filterProps,
            ...child.colDef
        });
    });
    columnDefs.push({
        ...headerGroup,
        children: childrenObjects
    });
};
const $3f09751f5b87fbb0$export$6240cafea8f9dcd3 = ({ columns: columns, tableView: tableView, additionalTableHeaders: additionalTableHeaders, tableTitleWithTooltips: tableTitleWithTooltips, externalParams: externalParams })=>{
    let columnDefs = [];
    let columnDefsLevel2 = [];
    if (!tableView) return columnDefs;
    tableView?.tables?.map((item)=>{
        // superHeader level2 columnDefs building logic.
        const hasSecondLevelHeaders = item.children?.length > 0 && item.children[0]?.children;
        if (hasSecondLevelHeaders) {
            const headerGroupLevel2 = {
                headerGroupComponent: item.headerGroupTitle,
                headerGroupComponentParams: {
                    additionalTableHeaders: additionalTableHeaders
                }
            };
            item.children.map((group)=>{
                $3f09751f5b87fbb0$var$generateChildDefs(group, columns, columnDefsLevel2, additionalTableHeaders, tableTitleWithTooltips, externalParams);
            });
            columnDefs.push({
                ...headerGroupLevel2,
                children: columnDefsLevel2
            });
            columnDefsLevel2 = [];
        }
        // superHeader level1 columnDefs building logic.
        const hasFirstLevelHeaders = item.children && Array.isArray(item.children);
        if (hasFirstLevelHeaders && !hasSecondLevelHeaders) $3f09751f5b87fbb0$var$generateChildDefs(item, columns, columnDefs, additionalTableHeaders, tableTitleWithTooltips, externalParams);
        // No-superHeaders columnDefs building logic.
        if (!hasSecondLevelHeaders && !hasFirstLevelHeaders) {
            const titleWithTooltip = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2JujF.default), {
                headerDetails: tableTitleWithTooltips[item.col?.id]
            });
            const filterOptions = item?.filterOptions ? item.filterOptions : {};
            const isDefaultSort = tableView?.defaultSort?.colId === item.col.id;
            const isBreakdown = tableView?.defaultSort?.isBreakdown;
            const savedSortState = $3f09751f5b87fbb0$var$getTableRetainedStateByType({
                tableId: tableView?.id,
                type: (0, $dQwVS.retainTerms).sort
            });
            const shouldApplyDefaultSort = !savedSortState && !isBreakdown && isDefaultSort;
            const colDef = {
                field: item.col.keyField || item.col.id,
                ...shouldApplyDefaultSort && {
                    sort: tableView?.defaultSort?.sortDir
                },
                headerName: item.col.label,
                initialHide: !!item.initialHide,
                cellClassRules: item.cellClassRules,
                cellRenderer: item.cellRenderer,
                cellRendererParams: externalParams || null,
                headerComponentParams: {
                    titleWithTooltip: titleWithTooltip
                },
                ...filterOptions,
                ...item.colDef
            };
            columnDefs.push(colDef);
        }
    });
    return columnDefs;
};
const $3f09751f5b87fbb0$export$49747c523476eb04 = `Using_this_{AG_Grid}_Enterprise_key_{AG-082526}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Lone_Wolf_Technologies_and_affiliates}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{BrokerMetrics}_only_for_{4}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_working_on_{BrokerMetrics}_need_to_be_licensed___{BrokerMetrics}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{4_August_2026}____[v3]_[01]_MTc4NTc5ODAwMDAwMA==4f732ca6e2f29be9fcd9fc9b5e392c29`;

});
parcelRegister("7jSpM", function(module, exports) {

$parcel$export(module.exports, "addAdditionalTableHeader", () => $26d05cf8d0ada400$export$dca5bf2e19720c42);
$parcel$export(module.exports, "getShortDate", () => $26d05cf8d0ada400$export$e1af8aea6eabbbdb);
$parcel$export(module.exports, "getClassNameSuppressHeaders", () => $26d05cf8d0ada400$export$3b6ece0889e0d7bc);
$parcel$export(module.exports, "getAdditionalColumnCount", () => $26d05cf8d0ada400$export$291a15d0ed1da16a);
$parcel$export(module.exports, "dataPointMouseOverStyler", () => $26d05cf8d0ada400$export$18f0ab5a3b6b413e);
$parcel$export(module.exports, "transformSchemaTableColumns", () => $26d05cf8d0ada400$export$72c07fef07fc63b8);
$parcel$export(module.exports, "getTitleWithTooltip", () => $26d05cf8d0ada400$export$196120b6bf315aee);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $rMeTm = parcelRequire("rMeTm");

var $htzEo = parcelRequire("htzEo");

var $eHBjM = parcelRequire("eHBjM");

var $g3CkB = parcelRequire("g3CkB");

var $b77Er = parcelRequire("b77Er");

var $cstaF = parcelRequire("cstaF");
const $26d05cf8d0ada400$export$666707b6301dbcb0 = "col-";
const $26d05cf8d0ada400$export$6bc7b89b30961631 = (columnType)=>$26d05cf8d0ada400$export$666707b6301dbcb0 + columnType;
const $26d05cf8d0ada400$export$dca5bf2e19720c42 = (objHeaders, countNewHeaders, title, addTabHeader, classHeader)=>{
    if (!countNewHeaders) return objHeaders;
    const objResult = {
        ...objHeaders
    };
    objResult[addTabHeader] = {
        title: title,
        attrs: {
            colSpan: countNewHeaders,
            className: classHeader
        }
    };
    return objResult;
};
const $26d05cf8d0ada400$export$c1c0562ec8379000 = (cssClasses)=>{
    return {
        cssClasses: `${$26d05cf8d0ada400$var$stdCssClasses} ${$26d05cf8d0ada400$export$666707b6301dbcb0}${cssClasses ?? ""}`
    };
};
const $26d05cf8d0ada400$export$e1af8aea6eabbbdb = (date)=>(0, $htzEo.getFormattedDate)(date, "yyyy-MM-dd");
const $26d05cf8d0ada400$export$fe306bcb76aa2459 = (value, noShrink)=>/*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: !noShrink && "small",
        children: value
    });
const $26d05cf8d0ada400$export$3b6ece0889e0d7bc = (additionalHeaders)=>{
    const hasAdditionalTableHeaders = !!additionalHeaders.length;
    return hasAdditionalTableHeaders ? "" : "has-no-superheaders";
};
const $26d05cf8d0ada400$export$291a15d0ed1da16a = (columns, columnId)=>{
    return ({
        [(0, $eHBjM.agentsColumns).officeAddress.id]: columns.find((c)=>c.id === columnId)?.isDisplayed ? (0, $eHBjM.additionalOfficeAddressColumns).length : 0
    })[columnId];
};
const $26d05cf8d0ada400$export$c4be143ee8b6a050 = "align-top no-wrap";
const $26d05cf8d0ada400$export$44f0498c9534a736 = `${$26d05cf8d0ada400$export$c4be143ee8b6a050} text-uppercase text-right border-0`;
const $26d05cf8d0ada400$export$347adb45ef1d7ff = `${$26d05cf8d0ada400$export$c4be143ee8b6a050} td-num`;
const $26d05cf8d0ada400$export$bbc5545b3cf4ffd5 = "td-num";
const $26d05cf8d0ada400$var$stdCssClasses = "text-wrap";
const $26d05cf8d0ada400$var$translateNullsToEnd = (value)=>{
    const VERY_LOW_VALUE = -999999999999;
    return value ?? VERY_LOW_VALUE;
};
const $26d05cf8d0ada400$export$94bae3b389ffa7 = (cssClasses)=>({
        headerClasses: $26d05cf8d0ada400$export$347adb45ef1d7ff,
        cssClasses: $26d05cf8d0ada400$export$bbc5545b3cf4ffd5 + ` ${$26d05cf8d0ada400$export$666707b6301dbcb0}${cssClasses ?? ""}`,
        type: "string",
        filter: "none",
        format: "custom",
        sortValue: (cell)=>$26d05cf8d0ada400$var$translateNullsToEnd(cell)
    });
const $26d05cf8d0ada400$export$20659866f529581f = (cssClasses)=>{
    return {
        headerClasses: $26d05cf8d0ada400$export$c4be143ee8b6a050,
        type: "string",
        filter: "none",
        cssClasses: `${$26d05cf8d0ada400$var$stdCssClasses} ${$26d05cf8d0ada400$export$666707b6301dbcb0}${cssClasses ?? ""}`,
        format: "custom"
    };
};
const $26d05cf8d0ada400$export$71206b459a57d279 = {
    headerClasses: $26d05cf8d0ada400$export$c4be143ee8b6a050,
    type: "date",
    filter: "none",
    format: "custom",
    cssClasses: $26d05cf8d0ada400$export$6bc7b89b30961631("date"),
    formatter: (cell)=>(0, $htzEo.shortDateFormatWithSlashes)(cell)
};
const $26d05cf8d0ada400$export$f867556968447e24 = (filterCriteria, data, key)=>{
    const filterCriteriaValues = filterCriteria.trim().split(" ");
    const partialMatchFilter = data.filter((row)=>{
        return filterCriteriaValues.some((filterValue)=>{
            return row[key].toLowerCase().indexOf(filterValue.toLowerCase()) > -1;
        });
    });
    return partialMatchFilter.filter((row)=>{
        return filterCriteriaValues.every((word)=>{
            return row[key].toLowerCase().includes(word.toLowerCase());
        });
    });
};
const $26d05cf8d0ada400$export$18f0ab5a3b6b413e = (event)=>{
    document.getElementById(event.target.instance.node.id)?.setAttribute("cursor", "pointer");
};
const $26d05cf8d0ada400$export$72c07fef07fc63b8 = (columns, table)=>{
    for(const property in columns){
        columns[property].id = property;
        columns[property].table = table;
    }
    return columns;
};
const $26d05cf8d0ada400$export$196120b6bf315aee = (value, className, noShrink, tooltipTargetPrefix, columns)=>{
    const timePeriods = (0, $b77Er.getTimeIntervalData)();
    if (!timePeriods?.length) return;
    const lastYear = timePeriods?.find((value)=>value.intervalType === "YTD")?.last.from;
    const previousYear = timePeriods?.find((value)=>value.intervalType === "YTD")?.previous.from;
    const label = value?.label?.replace("[currentYearNumber]", `${(0, $htzEo.yearFormat)(lastYear)}`).replace("[previousYearNumber]", `${(0, $htzEo.yearFormat)(previousYear)}`);
    const tipId = value?.table ? `${value?.table}-${value.id}` : value.id;
    const lastColumnTooltipClass = value?.isLastColumn ? "last-header-tooltip" : "";
    const tooltipClass = noShrink ? lastColumnTooltipClass : `helix-small ${lastColumnTooltipClass}`;
    const tooltipTarget = tooltipTargetPrefix ? `${tooltipTargetPrefix}-${tipId}` : tipId;
    const shouldHideTooltip = value?.label === (0, $cstaF.agentProductionTerms).currently;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: shouldHideTooltip ? label : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $rMeTm.default), {
                    target: tooltipTarget,
                    placement: "top",
                    boundariesElement: "window",
                    className: lastColumnTooltipClass,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: tooltipClass,
                        children: (0, $g3CkB.getTooltipText)(value)
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    id: tooltipTarget,
                    className: `clickable ${className || ""} ${lastColumnTooltipClass}`,
                    children: label
                })
            ]
        })
    });
};

});
parcelRegister("g3CkB", function(module, exports) {

$parcel$export(module.exports, "getTrendArrow", () => $0bed823e7a13f04d$export$b0f78926873df718);
$parcel$export(module.exports, "getOverviewChartTableLabels", () => $0bed823e7a13f04d$export$ab363449f86671b7);
$parcel$export(module.exports, "getLabelTextWithDate", () => $0bed823e7a13f04d$export$a452d2588c22dd9d);
$parcel$export(module.exports, "getTooltipText", () => $0bed823e7a13f04d$export$3c8120d2b233073c);
$parcel$export(module.exports, "OverviewGraphLabelMaker", () => $0bed823e7a13f04d$export$9910882e08df3bd9);
$parcel$export(module.exports, "selectMouseoverStyle", () => $0bed823e7a13f04d$export$c654c4fc6279de9a);
$parcel$export(module.exports, "getElementTooltip", () => $0bed823e7a13f04d$export$28e4647ddf4107f7);
$parcel$export(module.exports, "getSelectBrandColorConfig", () => $0bed823e7a13f04d$export$d72c158ce2c3f2f2);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $auRgN = parcelRequire("auRgN");

var $aTLkh = parcelRequire("aTLkh");

var $rMeTm = parcelRequire("rMeTm");

var $htzEo = parcelRequire("htzEo");

var $cstaF = parcelRequire("cstaF");

var $b77Er = parcelRequire("b77Er");

var $9QX0f = parcelRequire("9QX0f");
const $0bed823e7a13f04d$export$b0f78926873df718 = (difference)=>{
    if (difference === 0) return null;
    if (difference > 0) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aTLkh.default), {
        dataLwtId: "icon-yoy-change",
        iconName: "north_east",
        className: "text-success"
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aTLkh.default), {
        dataLwtId: "icon-yoy-change",
        iconName: "south_east",
        className: "text-danger"
    });
};
const $0bed823e7a13f04d$var$getTimePeriodLabels = (timePeriod)=>{
    let labelLastPeriod, labelPrevPeriod;
    if (timePeriod === (0, $cstaF.TimePeriods).QTD) {
        labelLastPeriod = (0, $cstaF.agentProductionTerms).QTD;
        labelPrevPeriod = (0, $cstaF.agentProductionTerms).previousQuarterToDate;
    } else if (timePeriod === (0, $cstaF.TimePeriods).YTD) {
        labelLastPeriod = (0, $cstaF.agentProductionTerms).YTD;
        labelPrevPeriod = (0, $cstaF.agentProductionTerms).previousYearToDate;
    } else if (timePeriod === (0, $cstaF.TimePeriods).MTD) {
        labelLastPeriod = (0, $cstaF.agentProductionTerms).MTD;
        labelPrevPeriod = (0, $cstaF.agentProductionTerms).previousMonthToDate;
    } else if (timePeriod === (0, $cstaF.TimePeriods)[(0, $cstaF.agentProductionTerms).lastMonth]) {
        labelLastPeriod = (0, $cstaF.agentProductionTerms).lastMonth;
        labelPrevPeriod = (0, $cstaF.agentProductionTerms).previousMonth;
    } else if (timePeriod === (0, $cstaF.TimePeriods)[(0, $cstaF.agentProductionTerms).last6Months]) {
        labelLastPeriod = (0, $cstaF.agentProductionTerms).last6Months;
        labelPrevPeriod = (0, $cstaF.agentProductionTerms).previous6Months;
    } else if (timePeriod === (0, $cstaF.TimePeriods)[(0, $cstaF.agentProductionTerms).last12Months]) {
        labelLastPeriod = (0, $cstaF.agentProductionTerms).last12Months;
        labelPrevPeriod = (0, $cstaF.agentProductionTerms).previous12Months;
    }
    return {
        labelLastPeriod: labelLastPeriod,
        labelPrevPeriod: labelPrevPeriod
    };
};
const $0bed823e7a13f04d$export$ab363449f86671b7 = ({ timePeriod: timePeriod, chartData: chartData, dataIndexes: dataIndexes })=>{
    let labelLastPeriod = "", dateRangeLast = "", labelPrevPeriod = "", dateRangePrev = "";
    if (!chartData) return {
        labelLastPeriod: labelLastPeriod,
        dateRangeLast: dateRangeLast,
        labelPrevPeriod: labelPrevPeriod,
        dateRangePrev: dateRangePrev
    };
    const dateLastStart = (0, $htzEo.getFormattedDate)(chartData[dataIndexes.lastPeriodStart].month, "MMM yyyy");
    const dateLastFinish = (0, $htzEo.getFormattedDate)(chartData[dataIndexes.lastPeriodFinish].month, "MMM yyyy");
    const datePrevStart = (0, $htzEo.getFormattedDate)(chartData[dataIndexes.prevPeriodStart].month, "MMM yyyy");
    const datePrevFinish = (0, $htzEo.getFormattedDate)(chartData[dataIndexes.prevPeriodFinish].month, "MMM yyyy");
    const isDateRangeCoversOneMonth = (start, finish)=>start === finish;
    dateRangeLast = isDateRangeCoversOneMonth(dataIndexes.lastPeriodStart, dataIndexes.lastPeriodFinish) ? `${dateLastStart}` : `${dateLastStart} - ${dateLastFinish}`;
    dateRangePrev = isDateRangeCoversOneMonth(dataIndexes.prevPeriodStart, dataIndexes.prevPeriodFinish) ? `${datePrevStart}` : `${datePrevStart} - ${datePrevFinish}`;
    const labels = $0bed823e7a13f04d$var$getTimePeriodLabels(timePeriod);
    return {
        labelLastPeriod: labels.labelLastPeriod,
        dateRangeLast: dateRangeLast,
        labelPrevPeriod: labels.labelPrevPeriod,
        dateRangePrev: dateRangePrev
    };
};
const $0bed823e7a13f04d$export$a452d2588c22dd9d = (value)=>{
    if (!value?.hasDate) return value?.metricLabel || value?.label;
    const timePeriods = (0, $b77Er.getTimeIntervalData)();
    if (!timePeriods) return;
    const lastYear = timePeriods?.find((value)=>value.intervalType === "YTD")?.last.from;
    const previousYear = timePeriods?.find((value)=>value.intervalType === "YTD")?.previous.from;
    return value?.label.replace("[currentYearNumber]", `${(0, $htzEo.yearFormat)(lastYear)}`).replace("[previousYearNumber]", `${(0, $htzEo.yearFormat)(previousYear)}`);
};
const $0bed823e7a13f04d$export$3c8120d2b233073c = (value)=>{
    if (!value?.hasDate) return value?.tip;
    const timePeriods = (0, $b77Er.getTimeIntervalData)();
    if (!timePeriods) return;
    const Last12Months = timePeriods?.find((value)=>value.intervalType === "Annually")?.last;
    const previous12Months = timePeriods?.find((value)=>value.intervalType === "Annually")?.previous;
    const lastYear = timePeriods?.find((value)=>value.intervalType === "YTD")?.last.from;
    const previousYear = timePeriods?.find((value)=>value.intervalType === "YTD")?.previous.from;
    const last90Days = timePeriods?.find((value)=>value.intervalType === (0, $9QX0f.producerOptions).timeFrame[0].value)?.last;
    const previous90Days = timePeriods?.find((value)=>value.intervalType === (0, $9QX0f.producerOptions).timeFrame[0].value)?.lastYear;
    return value?.tip.replace("[last12Months]", `(${(0, $htzEo.longDateTwoDigitsFormat)(Last12Months?.from)} - ${(0, $htzEo.longDateTwoDigitsFormat)(Last12Months.to)})`).replace("[previous12Months]", `(${(0, $htzEo.longDateTwoDigitsFormat)(previous12Months?.from)} - ${(0, $htzEo.longDateTwoDigitsFormat)(previous12Months.to)})`).replace("[currentYear]", `${(0, $htzEo.yearFormat)(lastYear)}`).replace("[previousYear]", `${(0, $htzEo.yearFormat)(previousYear)}`).replace("[currentYearNumber]", `${(0, $htzEo.yearFormat)(lastYear)}`).replace("[previousYearNumber]", `${(0, $htzEo.yearFormat)(previousYear)}`).replace("[last90days]", `(${(0, $htzEo.longDateTwoDigitsFormat)(last90Days?.from)} - ${(0, $htzEo.longDateTwoDigitsFormat)(last90Days.to)})`).replace("[previous90days]", `(${(0, $htzEo.longDateTwoDigitsFormat)(previous90Days?.from)} - ${(0, $htzEo.longDateTwoDigitsFormat)(previous90Days.to)})`);
};
class $0bed823e7a13f04d$export$9910882e08df3bd9 {
    static getLabelDate = (dataItem)=>(0, $htzEo.getFormattedDate)(dataItem.month, "MMM yy").toUpperCase();
    static getDateMonthFromGraphLabel = (label)=>{
        const partsLabel = label.split(" ");
        const month = partsLabel[0];
        const year = `20${partsLabel[1]}`;
        const dateToAvoidIncorrectConversionToMonth = `${year}-${month}-15`;
        return (0, $auRgN.default)(dateToAvoidIncorrectConversionToMonth, "yyyy-MMM-dd", new Date());
    };
}
const $0bed823e7a13f04d$export$c654c4fc6279de9a = (base)=>({
        ...base,
        cursor: "pointer"
    });
const $0bed823e7a13f04d$export$28e4647ddf4107f7 = (tooltip, isUpperCaseLabel = false)=>{
    const storedTimePeriod = (0, $b77Er.getTimePeriodData)();
    const currentTimePeriod = $0bed823e7a13f04d$var$getTimePeriodLabels(storedTimePeriod)?.labelLastPeriod;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $rMeTm.default), {
                target: tooltip?.id,
                children: tooltip?.tip.replace("[Time Period]", currentTimePeriod ? currentTimePeriod : storedTimePeriod)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                id: tooltip?.id,
                className: "gray-text bold-font-500",
                children: isUpperCaseLabel ? tooltip?.label.toUpperCase() : tooltip?.label
            })
        ]
    });
};
const $0bed823e7a13f04d$export$d72c158ce2c3f2f2 = (state)=>({
        backgroundColor: state.isSelected ? "var(--helix-brand)" : state.isFocused ? "var(--helix-brand-pale)" : "var(--white)",
        "&:active": {
            backgroundColor: state.isSelected ? "var(--helix-brand)" : "var(--helix-brand-pale)"
        },
        cursor: "pointer"
    });

});
parcelRegister("b77Er", function(module, exports) {

$parcel$export(module.exports, "setTimeIntervalData", () => $6a7a246dd871d2c1$export$f3f58a4cc343646e);
$parcel$export(module.exports, "getTimeIntervalData", () => $6a7a246dd871d2c1$export$2d5baf9c7a31bdbf);
$parcel$export(module.exports, "setTimePeriodData", () => $6a7a246dd871d2c1$export$265ed69b97dd0f2f);
$parcel$export(module.exports, "getTimePeriodData", () => $6a7a246dd871d2c1$export$bee771251882261d);

var $90ISC = parcelRequire("90ISC");
const $6a7a246dd871d2c1$export$f3f58a4cc343646e = (value)=>{
    sessionStorage.setItem("timeIntervals", JSON.stringify(value));
};
const $6a7a246dd871d2c1$export$2d5baf9c7a31bdbf = ()=>(0, $90ISC.useCommonStore).getState().timeIntervals;
const $6a7a246dd871d2c1$export$265ed69b97dd0f2f = (value)=>{
    sessionStorage.setItem("timePeriod", JSON.stringify(value));
};
const $6a7a246dd871d2c1$export$bee771251882261d = ()=>{
    return JSON.parse(sessionStorage.getItem("timePeriod"));
};

});



parcelRegister("2JujF", function(module, exports) {

$parcel$export(module.exports, "default", () => $db65b06abf872a7f$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $rMeTm = parcelRequire("rMeTm");

var $c9Z8w = parcelRequire("c9Z8w");
const $db65b06abf872a7f$var$CustomHeader = ({ headerDetails: headerDetails })=>{
    if (!headerDetails) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $rMeTm.default), {
                target: headerDetails?.id,
                placement: "top",
                boundariesElement: "window",
                className: headerDetails?.isLastColumn ? "last-header-tooltip" : "",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "helix-small",
                    children: headerDetails?.tip
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                id: headerDetails?.id,
                className: "clickable",
                children: headerDetails?.label
            })
        ]
    });
};
$db65b06abf872a7f$var$CustomHeader.propTypes = {
    headerDetails: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $db65b06abf872a7f$export$2e2bcd8739ae039 = $db65b06abf872a7f$var$CustomHeader;

});

parcelRegister("iIEeV", function(module, exports) {

$parcel$export(module.exports, "CROSS_SORT_TABLES", () => $da0b8cd5a2ca8b67$export$f46279bc1b04f2b4);
$parcel$export(module.exports, "getIsCrossSortEnabled", () => $da0b8cd5a2ca8b67$export$25eb0458dddc3dd);

var $eHBjM = parcelRequire("eHBjM");

var $cstaF = parcelRequire("cstaF");
const $da0b8cd5a2ca8b67$export$21da5001506b933f = [
    (0, $cstaF.modules).proficiencyMetrics.agents,
    (0, $cstaF.modules).proficiencyMetrics.offices,
    (0, $cstaF.modules).proficiencyMetrics.savedAgents,
    (0, $cstaF.modules).proficiencyMetrics.transactions
];
const $da0b8cd5a2ca8b67$export$f46279bc1b04f2b4 = [
    (0, $eHBjM.tableViewNames).overview,
    (0, $eHBjM.tableViewNames).contactInformation,
    (0, $eHBjM.tableViewNames).growthAnalysisLtm,
    (0, $eHBjM.tableViewNames).growthAnalysisYtd,
    (0, $eHBjM.tableViewNames).listingProficiency
];
const $da0b8cd5a2ca8b67$export$25eb0458dddc3dd = (module, tableViewName)=>{
    return $da0b8cd5a2ca8b67$export$21da5001506b933f.includes(module) && $da0b8cd5a2ca8b67$export$f46279bc1b04f2b4.includes(tableViewName);
};

});


parcelRegister("8E8vr", function(module, exports) {

$parcel$export(module.exports, "getDefaultGrowthAnalysisColumnsLtm", () => $64b8a848e91d3be3$export$8c58834ae783b6ab);
$parcel$export(module.exports, "getDefaultGrowthAnalysisColumnsLtmIncDec", () => $64b8a848e91d3be3$export$b17bc6bdc403d25d);
$parcel$export(module.exports, "getDefaultGrowthAnalysisColumnsYtd", () => $64b8a848e91d3be3$export$d13bca8a84ea06c0);
$parcel$export(module.exports, "getDefaultGrowthAnalysisColumnsYtdIncDec", () => $64b8a848e91d3be3$export$221b8aa4d678d29e);
$parcel$export(module.exports, "getDefaultGrowthAnalysisColumnsL90", () => $64b8a848e91d3be3$export$96442db3b5d92dab);
$parcel$export(module.exports, "growthAnalysisColumnsByPeriod", () => $64b8a848e91d3be3$export$88ed51c0148c85e7);
$parcel$export(module.exports, "getGrowthAnalysisTableSettingsByPeriod", () => $64b8a848e91d3be3$export$b944530ee19dcddc);
$parcel$export(module.exports, "getIsPeriodLast12Months", () => $64b8a848e91d3be3$export$7ddaa6bf172f5eec);
$parcel$export(module.exports, "getAdditionalTableHeaders", () => $64b8a848e91d3be3$export$892433a963901c8);

var $eHBjM = parcelRequire("eHBjM");

var $fPGDZ = parcelRequire("fPGDZ");

var $htzEo = parcelRequire("htzEo");

var $cstaF = parcelRequire("cstaF");

var $7jSpM = parcelRequire("7jSpM");

var $4tbBr = parcelRequire("4tbBr");
const $64b8a848e91d3be3$export$8c58834ae783b6ab = ()=>{
    const columns = [
        {
            ...(0, $eHBjM.agentsColumns).officeId,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_CONTACT)
        },
        {
            ...(0, $eHBjM.agentsColumns).officeAddress,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_CONTACT)
        },
        {
            ...(0, $eHBjM.agentsColumns).officeCity,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_CONTACT)
        },
        {
            ...(0, $eHBjM.agentsColumns).officeZipCode,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_CONTACT)
        },
        {
            ...(0, $eHBjM.agentsColumns).officeCounty,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_CONTACT)
        },
        {
            ...(0, $eHBjM.agentsColumns).ptmTotalUnits,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_UNITS)
        },
        {
            ...(0, $eHBjM.agentsColumns).last12TotalUnits,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_UNITS)
        },
        {
            ...(0, $eHBjM.agentsColumns).totalUnitsChange,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_UNITS)
        },
        {
            ...(0, $eHBjM.agentsColumns).totalUnitsGrowth,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_UNITS)
        },
        {
            ...(0, $eHBjM.agentsColumns).ptmTotalVolume,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_VOLUME)
        },
        {
            ...(0, $eHBjM.agentsColumns).last12TotalVolume,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_VOLUME)
        },
        {
            ...(0, $eHBjM.agentsColumns).totalVolumeChange,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_VOLUME)
        },
        {
            ...(0, $eHBjM.agentsColumns).totalVolumeGrowth,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_VOLUME)
        }
    ];
    const columnsToHide = [
        (0, $eHBjM.agentsColumns).officeId,
        (0, $eHBjM.agentsColumns).officeAddress,
        (0, $eHBjM.agentsColumns).officeCity,
        (0, $eHBjM.agentsColumns).officeZipCode,
        (0, $eHBjM.agentsColumns).officeCounty
    ];
    return (0, $fPGDZ.displayAllButSelected)(columns, columnsToHide);
};
const $64b8a848e91d3be3$export$b17bc6bdc403d25d = ()=>{
    const columns = [
        {
            ...(0, $eHBjM.agentsColumns).officeId,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_CONTACT)
        },
        {
            ...(0, $eHBjM.agentsColumns).officeAddress,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_CONTACT)
        },
        {
            ...(0, $eHBjM.agentsColumns).officeCity,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_CONTACT)
        },
        {
            ...(0, $eHBjM.agentsColumns).officeZipCode,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_CONTACT)
        },
        {
            ...(0, $eHBjM.agentsColumns).officeCounty,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_CONTACT)
        },
        {
            ...(0, $eHBjM.agentsColumns).previousPeriodTotalUnits,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_UNITS)
        },
        {
            ...(0, $eHBjM.agentsColumns).totalUnits,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_UNITS)
        },
        {
            ...(0, $eHBjM.agentsColumns).totalUnitsChange,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_UNITS)
        },
        {
            ...(0, $eHBjM.agentsColumns).totalUnitsGrowth,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_UNITS)
        },
        {
            ...(0, $eHBjM.agentsColumns).previousPeriodTotalVolume,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_VOLUME)
        },
        {
            ...(0, $eHBjM.agentsColumns).totalVolume,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_VOLUME)
        },
        {
            ...(0, $eHBjM.agentsColumns).totalVolumeChange,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_VOLUME)
        },
        {
            ...(0, $eHBjM.agentsColumns).totalVolumeGrowth,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_VOLUME)
        }
    ];
    const columnsToHide = [
        (0, $eHBjM.agentsColumns).officeId,
        (0, $eHBjM.agentsColumns).officeAddress,
        (0, $eHBjM.agentsColumns).officeCity,
        (0, $eHBjM.agentsColumns).officeZipCode,
        (0, $eHBjM.agentsColumns).officeCounty
    ];
    return (0, $fPGDZ.displayAllButSelected)(columns, columnsToHide);
};
const $64b8a848e91d3be3$export$d13bca8a84ea06c0 = ()=>{
    const columns = [
        {
            ...(0, $eHBjM.agentsColumns).officeId,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_CONTACT)
        },
        {
            ...(0, $eHBjM.agentsColumns).officeAddress,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_CONTACT)
        },
        {
            ...(0, $eHBjM.agentsColumns).officeCity,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_CONTACT)
        },
        {
            ...(0, $eHBjM.agentsColumns).officeZipCode,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_CONTACT)
        },
        {
            ...(0, $eHBjM.agentsColumns).officeCounty,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_CONTACT)
        },
        {
            ...(0, $eHBjM.agentsColumns).pytdTotalUnits,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_UNITS)
        },
        {
            ...(0, $eHBjM.agentsColumns).lytdTotalUnits,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_UNITS)
        },
        {
            ...(0, $eHBjM.agentsColumns).lytdPytdTotalUnitsChange,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_UNITS)
        },
        {
            ...(0, $eHBjM.agentsColumns).lytdPytdTotalUnitsGrowth,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_UNITS)
        },
        {
            ...(0, $eHBjM.agentsColumns).pytdTotalVolume,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_VOLUME)
        },
        {
            ...(0, $eHBjM.agentsColumns).lytdTotalVolume,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_VOLUME)
        },
        {
            ...(0, $eHBjM.agentsColumns).lytdPytdTotalVolumeChange,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_VOLUME)
        },
        {
            ...(0, $eHBjM.agentsColumns).lytdPytdTotalVolumeGrowth,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_VOLUME)
        }
    ];
    const columnsToHide = [
        (0, $eHBjM.agentsColumns).officeId,
        (0, $eHBjM.agentsColumns).officeAddress,
        (0, $eHBjM.agentsColumns).officeCity,
        (0, $eHBjM.agentsColumns).officeZipCode,
        (0, $eHBjM.agentsColumns).officeCounty
    ];
    return (0, $fPGDZ.displayAllButSelected)(columns, columnsToHide);
};
const $64b8a848e91d3be3$export$221b8aa4d678d29e = ()=>{
    const columns = [
        {
            ...(0, $eHBjM.agentsColumns).officeId,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_CONTACT)
        },
        {
            ...(0, $eHBjM.agentsColumns).officeAddress,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_CONTACT)
        },
        {
            ...(0, $eHBjM.agentsColumns).officeCity,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_CONTACT)
        },
        {
            ...(0, $eHBjM.agentsColumns).officeZipCode,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_CONTACT)
        },
        {
            ...(0, $eHBjM.agentsColumns).officeCounty,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_CONTACT)
        },
        {
            ...(0, $eHBjM.agentsColumns).previousPeriodTotalUnits,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_UNITS)
        },
        {
            ...(0, $eHBjM.agentsColumns).totalUnits,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_UNITS)
        },
        {
            ...(0, $eHBjM.agentsColumns).totalUnitsChange,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_UNITS)
        },
        {
            ...(0, $eHBjM.agentsColumns).totalUnitsGrowth,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_UNITS)
        },
        {
            ...(0, $eHBjM.agentsColumns).previousPeriodTotalVolume,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_VOLUME)
        },
        {
            ...(0, $eHBjM.agentsColumns).totalVolume,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_VOLUME)
        },
        {
            ...(0, $eHBjM.agentsColumns).totalVolumeChange,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_VOLUME)
        },
        {
            ...(0, $eHBjM.agentsColumns).totalVolumeGrowth,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_VOLUME)
        }
    ];
    const columnsToHide = [
        (0, $eHBjM.agentsColumns).officeId,
        (0, $eHBjM.agentsColumns).officeAddress,
        (0, $eHBjM.agentsColumns).officeCity,
        (0, $eHBjM.agentsColumns).officeZipCode,
        (0, $eHBjM.agentsColumns).officeCounty
    ];
    return (0, $fPGDZ.displayAllButSelected)(columns, columnsToHide);
};
const $64b8a848e91d3be3$export$96442db3b5d92dab = ()=>{
    const columns = [
        {
            ...(0, $eHBjM.agentsColumns).officeId,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_CONTACT)
        },
        {
            ...(0, $eHBjM.agentsColumns).officeAddress,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_CONTACT)
        },
        {
            ...(0, $eHBjM.agentsColumns).officeCity,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_CONTACT)
        },
        {
            ...(0, $eHBjM.agentsColumns).officeZipCode,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_CONTACT)
        },
        {
            ...(0, $eHBjM.agentsColumns).officeCounty,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_CONTACT)
        },
        {
            ...(0, $eHBjM.agentsColumns).previousPeriodTotalUnits,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_UNITS)
        },
        {
            ...(0, $eHBjM.agentsColumns).totalUnits,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_UNITS)
        },
        {
            ...(0, $eHBjM.agentsColumns).totalUnitsChange,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_UNITS)
        },
        {
            ...(0, $eHBjM.agentsColumns).totalUnitsGrowth,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_UNITS)
        },
        {
            ...(0, $eHBjM.agentsColumns).previousPeriodTotalVolume,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_VOLUME)
        },
        {
            ...(0, $eHBjM.agentsColumns).totalVolume,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_VOLUME)
        },
        {
            ...(0, $eHBjM.agentsColumns).totalVolumeChange,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_VOLUME)
        },
        {
            ...(0, $eHBjM.agentsColumns).totalVolumeGrowth,
            headerPlacement: (0, $fPGDZ.COLUMN_GROUP_VOLUME)
        }
    ];
    const columnsToHide = [
        (0, $eHBjM.agentsColumns).officeId,
        (0, $eHBjM.agentsColumns).officeAddress,
        (0, $eHBjM.agentsColumns).officeCity,
        (0, $eHBjM.agentsColumns).officeZipCode,
        (0, $eHBjM.agentsColumns).officeCounty
    ];
    return (0, $fPGDZ.displayAllButSelected)(columns, columnsToHide);
};
const $64b8a848e91d3be3$export$88ed51c0148c85e7 = {
    [(0, $cstaF.agentProductionTerms).last12Months]: $64b8a848e91d3be3$export$8c58834ae783b6ab(),
    [(0, $cstaF.agentProductionTerms).yearToDate]: $64b8a848e91d3be3$export$d13bca8a84ea06c0()
};
const $64b8a848e91d3be3$export$b944530ee19dcddc = (period)=>{
    if (period === (0, $cstaF.agentProductionTerms).last12Months) return (0, $4tbBr.tableViews).growthAnalysisLtm;
    if (period === (0, $cstaF.agentProductionTerms).yearToDate) return (0, $4tbBr.tableViews).growthAnalysisYtd;
};
const $64b8a848e91d3be3$export$7ddaa6bf172f5eec = (period)=>period === (0, $cstaF.agentProductionTerms).last12Months;
const $64b8a848e91d3be3$export$4355e61e2735f902 = (agentData)=>{
    const headers = [
        {
            label: "First Name",
            key: "firstName"
        },
        {
            label: "Last Name",
            key: "lastName"
        },
        {
            label: "Office ID",
            key: (0, $eHBjM.agentsColumns).officeId.id
        },
        {
            label: "Office Name",
            key: (0, $eHBjM.agentsColumns).officeName.id
        },
        {
            label: "Office Address",
            key: (0, $eHBjM.agentsColumns).officeAddress.id
        },
        {
            label: "Office City",
            key: "officeCity"
        },
        {
            label: "Office Zip",
            key: "officeZipCode"
        },
        {
            label: "Office County",
            key: "officeCounty"
        },
        {
            label: "PTM #",
            key: (0, $eHBjM.agentsColumns).ptmTotalUnits.id
        },
        {
            label: "LTM #",
            key: (0, $eHBjM.agentsColumns).last12TotalUnits.id
        },
        {
            label: "Change (#)",
            key: (0, $eHBjM.agentsColumns).totalUnitsChange.id
        },
        {
            label: "% Change (#)",
            key: (0, $eHBjM.agentsColumns).totalUnitsGrowth.id
        },
        {
            label: "PTM $",
            key: (0, $eHBjM.agentsColumns).ptmTotalVolume.id
        },
        {
            label: "LTM $",
            key: (0, $eHBjM.agentsColumns).last12TotalVolume.id
        },
        {
            label: "Change ($)",
            key: (0, $eHBjM.agentsColumns).totalVolumeChange.id
        },
        {
            label: "% Change ($)",
            key: (0, $eHBjM.agentsColumns).totalVolumeGrowth.id
        }
    ];
    const data = agentData.length > 0 && agentData.map((a)=>{
        const names = a?.agentName.split(" ") ?? [];
        const firstName = names[0];
        const lastName = names[names.length - 1];
        return {
            ...a,
            firstName: firstName,
            lastName: lastName,
            [(0, $eHBjM.agentsColumns).ptmTotalVolume.id]: (0, $htzEo.formatVolumeOrDays)(a?.ptmTotalVolume, true),
            [(0, $eHBjM.agentsColumns).last12TotalVolume.id]: (0, $htzEo.formatVolumeOrDays)(a?.last12TotalVolume, true),
            [(0, $eHBjM.agentsColumns).totalVolumeChange.id]: (0, $htzEo.formatVolumeOrDays)(a?.totalVolumeChange, true),
            [(0, $eHBjM.agentsColumns).ptmTotalUnits.id]: (0, $htzEo.formatUnitOrPercentage)(a?.ptmTotalUnits, true),
            [(0, $eHBjM.agentsColumns).last12TotalUnits.id]: (0, $htzEo.formatUnitOrPercentage)(a?.last12TotalUnits, true),
            [(0, $eHBjM.agentsColumns).totalUnitsChange.id]: (0, $htzEo.formatUnitOrPercentage)(a?.totalUnitsChange, true),
            [(0, $eHBjM.agentsColumns).totalUnitsGrowth.id]: (0, $htzEo.addPctSymbol)((0, $htzEo.formatUnitOrPercentage)(a?.totalUnitsGrowth, true)),
            [(0, $eHBjM.agentsColumns).totalVolumeGrowth.id]: (0, $htzEo.addPctSymbol)((0, $htzEo.formatUnitOrPercentage)(a?.totalVolumeGrowth, true))
        };
    }) || [];
    return {
        headers: headers,
        data: data
    };
};
const $64b8a848e91d3be3$export$72a4652553b539b1 = (agentData, year)=>{
    const headers = [
        {
            label: "First Name",
            key: "firstName"
        },
        {
            label: "Last Name",
            key: "lastName"
        },
        {
            label: "Office ID",
            key: (0, $eHBjM.agentsColumns).officeId.id
        },
        {
            label: "Office Name",
            key: (0, $eHBjM.agentsColumns).officeName.id
        },
        {
            label: "Office Address",
            key: (0, $eHBjM.agentsColumns).officeAddress.id
        },
        {
            label: "Office City",
            key: "officeCity"
        },
        {
            label: "Office Zip",
            key: "officeZipCode"
        },
        {
            label: "Office County",
            key: "officeCounty"
        },
        {
            label: `YTD ${year.previous} #`,
            key: (0, $eHBjM.agentsColumns).pytdTotalUnits.id
        },
        {
            label: `YTD ${year.last} #`,
            key: (0, $eHBjM.agentsColumns).lytdTotalUnits.id
        },
        {
            label: "Change (#)",
            key: (0, $eHBjM.agentsColumns).lytdPytdTotalUnitsChange.id
        },
        {
            label: "% Change (#)",
            key: (0, $eHBjM.agentsColumns).lytdPytdTotalUnitsGrowth.id
        },
        {
            label: `YTD ${year.previous} $`,
            key: (0, $eHBjM.agentsColumns).pytdTotalVolume.id
        },
        {
            label: `YTD ${year.last} $`,
            key: (0, $eHBjM.agentsColumns).lytdTotalVolume.id
        },
        {
            label: "Change ($)",
            key: (0, $eHBjM.agentsColumns).lytdPytdTotalVolumeChange.id
        },
        {
            label: "% Change ($)",
            key: (0, $eHBjM.agentsColumns).lytdPytdTotalVolumeGrowth.id
        }
    ];
    const data = agentData.length > 0 && agentData.map((a)=>{
        const names = a?.agentName.split(" ") ?? [];
        const firstName = names[0];
        const lastName = names[names.length - 1];
        return {
            ...a,
            firstName: firstName,
            lastName: lastName,
            [(0, $eHBjM.agentsColumns).pytdTotalVolume.id]: (0, $htzEo.formatVolumeOrDays)(a?.pytdTotalVolume, true),
            [(0, $eHBjM.agentsColumns).lytdTotalVolume.id]: (0, $htzEo.formatVolumeOrDays)(a?.lytdTotalVolume, true),
            [(0, $eHBjM.agentsColumns).lytdPytdTotalVolumeChange.id]: (0, $htzEo.formatVolumeOrDays)(a?.lytdPytdTotalVolumeChange, true),
            [(0, $eHBjM.agentsColumns).pytdTotalUnits.id]: (0, $htzEo.formatUnitOrPercentage)(a?.pytdTotalUnits, true),
            [(0, $eHBjM.agentsColumns).lytdTotalUnits.id]: (0, $htzEo.formatUnitOrPercentage)(a?.lytdTotalUnits, true),
            [(0, $eHBjM.agentsColumns).lytdPytdTotalUnitsChange.id]: (0, $htzEo.formatUnitOrPercentage)(a?.lytdPytdTotalUnitsChange, true),
            [(0, $eHBjM.agentsColumns).lytdPytdTotalUnitsGrowth.id]: (0, $htzEo.addPctSymbol)((0, $htzEo.formatUnitOrPercentage)(a?.lytdPytdTotalUnitsGrowth, true)),
            [(0, $eHBjM.agentsColumns).lytdPytdTotalVolumeGrowth.id]: (0, $htzEo.addPctSymbol)((0, $htzEo.formatUnitOrPercentage)(a?.lytdPytdTotalVolumeGrowth, true))
        };
    }) || [];
    return {
        headers: headers,
        data: data
    };
};
const $64b8a848e91d3be3$export$3d24be68b3c2d24a = (columns, headerPlacement)=>columns?.filter((c)=>c.isDisplayed && c.headerPlacement === headerPlacement).length || 0;
const $64b8a848e91d3be3$export$892433a963901c8 = (columns, contactColumnsToAlwaysDisplay)=>{
    const additionalAddressColumns = (0, $7jSpM.getAdditionalColumnCount)(columns, (0, $eHBjM.agentsColumns).officeAddress.id);
    const countDisplayedColumnsContact = $64b8a848e91d3be3$export$3d24be68b3c2d24a(columns, (0, $fPGDZ.COLUMN_GROUP_CONTACT)) + contactColumnsToAlwaysDisplay.length + additionalAddressColumns;
    const countDisplayedColumnsUnits = $64b8a848e91d3be3$export$3d24be68b3c2d24a(columns, (0, $fPGDZ.COLUMN_GROUP_UNITS));
    const countDisplayedColumnsVolume = $64b8a848e91d3be3$export$3d24be68b3c2d24a(columns, (0, $fPGDZ.COLUMN_GROUP_VOLUME));
    const headers = [];
    let headersRow2 = {};
    const classHeader = "border text-center";
    const apt = (0, $cstaF.agentProductionTerms);
    const addHeaderWithClass = (classToUse)=>{
        return (lowers, count, title, addTabHeader)=>(0, $7jSpM.addAdditionalTableHeader)(lowers, count, title, addTabHeader, classToUse);
    };
    const addHeader = addHeaderWithClass(classHeader);
    const ath = (0, $eHBjM.additionalTableHeaders);
    headersRow2 = addHeader(headersRow2, countDisplayedColumnsContact, apt.officeInformation, ath.column1);
    headersRow2 = addHeader(headersRow2, countDisplayedColumnsUnits, apt.numberUnits, ath.column2);
    headersRow2 = addHeader(headersRow2, countDisplayedColumnsVolume, apt.dollarVolume, ath.column3);
    headers.push(headersRow2);
    return headers;
};

});

parcelRegister("3D0uP", function(module, exports) {

$parcel$export(module.exports, "CoverageAddressFormatter", () => $2a45662ce47d48ca$export$d4dcb4d5a23882d9);
$parcel$export(module.exports, "ProductionAddressFormatter", () => $2a45662ce47d48ca$export$349cfd8f580f439e);

var $ayMG0 = parcelRequire("ayMG0");

var $c7dF9 = parcelRequire("c7dF9");

var $ekOct = parcelRequire("ekOct");

var $4fGPb = parcelRequire("4fGPb");
parcelRequire("acw62");

var $90ISC = parcelRequire("90ISC");

var $bq4QZ = parcelRequire("bq4QZ");

var $dDBOF = parcelRequire("dDBOF");
const $2a45662ce47d48ca$var$getCurrentPeriod = (period)=>{
    const dateSplitted = period.split(" ");
    const month = dateSplitted[0];
    const year = dateSplitted[1].slice(2);
    return `${month} ${year}`;
};
const $2a45662ce47d48ca$export$d4dcb4d5a23882d9 = (data)=>{
    const { selectedAgentId: selectedAgentId, selectedArea: selectedArea, displayMode: displayMode, isUnits: isUnits } = (0, $90ISC.useAgentProfileStore)();
    const to = `${(0, $dDBOF.isAgentMetrics) ? (0, $c7dF9.Routes).AGENT_PRODUCTION.BASE : (0, $c7dF9.Routes).PROF_METRICS.BASE}${(0, $c7dF9.Routes).PROF_METRICS.LISTING_INFO}` + `?mlsNum=${data.mlsNum}` + `&agentId=${selectedAgentId}` + `&incomingPage=${(0, $c7dF9.Routes).PROF_METRICS.COVERAGE_LISTING}` + `&selectedArea=${(0, $ekOct.maskUrlVar)(selectedArea?.value)}` + `&displayMode=${displayMode}` + `&isUnits=${isUnits}`;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fGPb.Link), {
        to: to,
        children: data.address
    });
};
const $2a45662ce47d48ca$export$349cfd8f580f439e = (data)=>{
    const query = (0, $bq4QZ.useQuery)();
    const { selectedAgentId: selectedAgentId, displayMode: displayMode, currentTab: currentTab, timePeriod: timePeriod } = (0, $90ISC.useAgentProfileStore)();
    const to = `${(0, $dDBOF.isAgentMetrics) ? (0, $c7dF9.Routes).AGENT_PRODUCTION.BASE : (0, $c7dF9.Routes).PROF_METRICS.BASE}${(0, $c7dF9.Routes).PROF_METRICS.LISTING_INFO}` + `?mlsNum=${data.mlsNum}` + `&agentId=${selectedAgentId}` + `&period=${$2a45662ce47d48ca$var$getCurrentPeriod(timePeriod)}` + `&tabIndex=${currentTab}` + `&graph=${query.get("graph")}` + `&chartMode=${displayMode}` + `&isShowBarLabels=${query.get("isShowBarLabels")}` + `&intervalType=${query.get("intervalType")}`;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fGPb.Link), {
        to: to,
        children: data.address
    });
};

});

parcelRegister("jbbzx", function(module, exports) {

$parcel$export(module.exports, "listingProficiencyView", () => (parcelRequire("4mur5")).default);
$parcel$export(module.exports, "availableAgentsView", () => (parcelRequire("d9xWn")).default);
$parcel$export(module.exports, "addedAgentsView", () => (parcelRequire("fEn75")).default);
$parcel$export(module.exports, "officeHistoryView", () => (parcelRequire("lb545")).default);
$parcel$export(module.exports, "agentCoverageListingForSaleView", () => (parcelRequire("bksJ0")).default);
$parcel$export(module.exports, "agentCoverageListingSoldView", () => (parcelRequire("eLlZr")).default);
$parcel$export(module.exports, "agentCoverageListingUcView", () => (parcelRequire("6RwGN")).default);
$parcel$export(module.exports, "agentProductionListingView", () => (parcelRequire("gC1w5")).default);
$parcel$export(module.exports, "agentsGainedBreakdown", () => (parcelRequire("hAeWH")).default);
$parcel$export(module.exports, "lostAgentsBreakdown", () => (parcelRequire("g5uaS")).default);
$parcel$export(module.exports, "activityView", () => (parcelRequire("jrnUE")).default);

var $4mur5 = parcelRequire("4mur5");

var $d9xWn = parcelRequire("d9xWn");

var $fEn75 = parcelRequire("fEn75");

var $lb545 = parcelRequire("lb545");

var $bksJ0 = parcelRequire("bksJ0");

var $eLlZr = parcelRequire("eLlZr");

var $6RwGN = parcelRequire("6RwGN");

var $gC1w5 = parcelRequire("gC1w5");

var $hAeWH = parcelRequire("hAeWH");

var $g5uaS = parcelRequire("g5uaS");

var $jrnUE = parcelRequire("jrnUE");

});
parcelRegister("4mur5", function(module, exports) {

$parcel$export(module.exports, "default", () => $32d0d36cc35fe523$export$2e2bcd8739ae039);
const $32d0d36cc35fe523$var$listingProficiencyView = ({ agentsColumns: agentsColumns, additionalTableHeaders: additionalTableHeaders, cellRenderers: cellRenderers, colSettings: colSettings, getAdditionalTableHeader: getAdditionalTableHeader, tableViewNames: tableViewNames, TextFloatingFilterComponent: TextFloatingFilterComponent })=>{
    return {
        id: tableViewNames.listingProficiency,
        tables: [
            {
                headerGroupTitle: (props)=>getAdditionalTableHeader(additionalTableHeaders.column7, props),
                children: [
                    {
                        headerGroupTitle: (props)=>getAdditionalTableHeader(additionalTableHeaders.column1, props),
                        children: [
                            {
                                col: agentsColumns.isSelected,
                                sortable: false,
                                colDef: {
                                    ...colSettings.checkboxSmallRight,
                                    headerCheckboxSelection: true,
                                    checkboxSelection: true
                                }
                            },
                            {
                                col: agentsColumns.rank,
                                colDef: colSettings.textXsRightAlign
                            },
                            {
                                col: agentsColumns.agentName,
                                colDef: colSettings.textLg,
                                cellRenderer: cellRenderers.agentNameLink,
                                filterOptions: {
                                    filter: "agTextColumnFilter",
                                    floatingFilterComponent: TextFloatingFilterComponent,
                                    floatingFilterComponentParams: {
                                        placeholder: "Search Name"
                                    }
                                }
                            },
                            {
                                col: agentsColumns.officeName,
                                colDef: colSettings.textLg,
                                filterOptions: {
                                    filter: "agTextColumnFilter",
                                    floatingFilterComponent: TextFloatingFilterComponent,
                                    floatingFilterComponentParams: {
                                        placeholder: "Search Office"
                                    }
                                }
                            },
                            {
                                col: agentsColumns.officeId,
                                colDef: colSettings.textSm,
                                initialHide: true
                            },
                            {
                                col: agentsColumns.officeAddress,
                                colDef: colSettings.textMd,
                                initialHide: true
                            },
                            {
                                col: agentsColumns.officeCity,
                                colDef: colSettings.textSm,
                                initialHide: true
                            },
                            {
                                col: agentsColumns.officeZipCode,
                                colDef: colSettings.textXs,
                                initialHide: true
                            },
                            {
                                col: agentsColumns.officeCounty,
                                colDef: colSettings.textSm,
                                initialHide: true
                            }
                        ]
                    }
                ]
            },
            {
                headerGroupTitle: (props)=>getAdditionalTableHeader(additionalTableHeaders.column6, props),
                children: [
                    {
                        headerGroupTitle: (props)=>getAdditionalTableHeader(additionalTableHeaders.column2, props),
                        children: [
                            {
                                col: agentsColumns.last12SellUnits,
                                colDef: colSettings.numberSmUnits
                            },
                            {
                                col: agentsColumns.last12SellVolume,
                                colDef: colSettings.numberSmVolume
                            }
                        ]
                    },
                    {
                        headerGroupTitle: (props)=>getAdditionalTableHeader(additionalTableHeaders.column3, props),
                        children: [
                            {
                                col: agentsColumns.last12ListUnits,
                                colDef: colSettings.numberSmUnits
                            },
                            {
                                col: agentsColumns.last12ListVolume,
                                colDef: colSettings.numberSmVolume
                            }
                        ]
                    },
                    {
                        headerGroupTitle: (props)=>getAdditionalTableHeader(additionalTableHeaders.column4, props),
                        children: [
                            {
                                col: agentsColumns.noPcLast12ListUnits,
                                colDef: colSettings.numberSmUnits
                            },
                            {
                                col: agentsColumns.noPcLast12ListUnitsPct,
                                colDef: colSettings.numberMdPercentage
                            },
                            {
                                col: agentsColumns.noPcLast12ListVolume,
                                colDef: colSettings.numberSmVolume
                            },
                            {
                                col: agentsColumns.noPcLast12ListVolumePct,
                                colDef: colSettings.numberMdPercentage
                            },
                            {
                                col: agentsColumns.noPcLast12ListDom,
                                colDef: colSettings.numberXsInteger
                            },
                            {
                                col: agentsColumns.noPcLast12ListCdom,
                                colDef: colSettings.numberSmInteger
                            },
                            {
                                col: agentsColumns.noPcLast12SpOp,
                                colDef: colSettings.numberXsPercentage
                            }
                        ]
                    },
                    {
                        headerGroupTitle: (props)=>getAdditionalTableHeader(additionalTableHeaders.column5, props),
                        children: [
                            {
                                col: agentsColumns.pcLast12ListUnits,
                                colDef: colSettings.numberSmUnits
                            },
                            {
                                col: agentsColumns.pcLast12ListUnitsPct,
                                colDef: colSettings.numberMdPercentage
                            },
                            {
                                col: agentsColumns.pcLast12ListVolume,
                                colDef: colSettings.numberSmVolume
                            },
                            {
                                col: agentsColumns.pcLast12ListVolumePct,
                                colDef: colSettings.numberMdPercentage
                            },
                            {
                                col: agentsColumns.pcLast12ListDom,
                                colDef: colSettings.numberSmInteger
                            },
                            {
                                col: agentsColumns.pcLast12ListCdom,
                                colDef: colSettings.numberSmInteger,
                                initialHide: true
                            },
                            {
                                col: agentsColumns.pcLast12ListPcDom,
                                colDef: colSettings.numberSmInteger,
                                initialHide: true
                            },
                            {
                                col: agentsColumns.pcLast12ListSpOp,
                                colDef: colSettings.numberXsPercentage,
                                initialHide: true
                            },
                            {
                                col: agentsColumns.pcLast12ListSpLp,
                                colDef: colSettings.numberXsPercentage,
                                initialHide: true
                            },
                            {
                                col: agentsColumns.pcLast12ListAvgNumPc,
                                colDef: colSettings.numberSmUnits,
                                initialHide: true
                            }
                        ]
                    }
                ]
            }
        ]
    };
};
var $32d0d36cc35fe523$export$2e2bcd8739ae039 = $32d0d36cc35fe523$var$listingProficiencyView;

});

parcelRegister("d9xWn", function(module, exports) {

$parcel$export(module.exports, "default", () => $993671878148c5dd$export$2e2bcd8739ae039);

var $eHBjM = parcelRequire("eHBjM");
const $993671878148c5dd$var$availableAgentsClassRules = {
    "available-agents-inactive": (params)=>params.node.data.status === "I"
};
const $993671878148c5dd$var$availableAgentsView = ({ colSettings: colSettings, tableViewNames: tableViewNames })=>{
    return {
        id: tableViewNames.availableAgents,
        sortable: false,
        tables: [
            {
                col: (0, $eHBjM.availableAgentsTooltips).agentName,
                colDef: colSettings.textSmall,
                cellClassRules: $993671878148c5dd$var$availableAgentsClassRules
            },
            {
                col: (0, $eHBjM.availableAgentsTooltips).agentId,
                colDef: {
                    ...colSettings.textSmRightAlign,
                    minWidth: 140
                },
                cellClassRules: $993671878148c5dd$var$availableAgentsClassRules
            },
            {
                col: (0, $eHBjM.availableAgentsTooltips).agentStatus,
                colDef: colSettings.textTinyRightAlign,
                cellClassRules: $993671878148c5dd$var$availableAgentsClassRules
            },
            {
                col: (0, $eHBjM.availableAgentsTooltips).officeName,
                colDef: colSettings.textSmRightAlign,
                cellClassRules: $993671878148c5dd$var$availableAgentsClassRules
            },
            {
                col: (0, $eHBjM.availableAgentsTooltips).officeCity,
                colDef: colSettings.textSmRightAlign,
                cellClassRules: $993671878148c5dd$var$availableAgentsClassRules
            },
            {
                col: (0, $eHBjM.availableAgentsTooltips).officeZipCode,
                colDef: colSettings.textTinyRightAlign,
                cellClassRules: $993671878148c5dd$var$availableAgentsClassRules
            },
            {
                col: (0, $eHBjM.availableAgentsTooltips).volume,
                colDef: colSettings.blankEmptyXsVolume,
                cellClassRules: $993671878148c5dd$var$availableAgentsClassRules
            }
        ]
    };
};
var $993671878148c5dd$export$2e2bcd8739ae039 = $993671878148c5dd$var$availableAgentsView;

});

parcelRegister("fEn75", function(module, exports) {

$parcel$export(module.exports, "default", () => $b64c853e11b7b835$export$2e2bcd8739ae039);

var $eHBjM = parcelRequire("eHBjM");
const $b64c853e11b7b835$var$addedAgentsView = ({ colSettings: colSettings, tableViewNames: tableViewNames })=>{
    return {
        id: tableViewNames.addedAgents,
        tables: [
            {
                col: (0, $eHBjM.availableAgentsTooltips).agentName,
                colDef: colSettings.textSmall
            },
            {
                col: (0, $eHBjM.availableAgentsTooltips).agentId,
                colDef: colSettings.textSmRightAlign
            }
        ]
    };
};
var $b64c853e11b7b835$export$2e2bcd8739ae039 = $b64c853e11b7b835$var$addedAgentsView;

});

parcelRegister("lb545", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6ae8dd87e54490c$export$2e2bcd8739ae039);

var $eHBjM = parcelRequire("eHBjM");
const $f6ae8dd87e54490c$var$officeHistoryView = ({ colSettings: colSettings, tableViewNames: tableViewNames, cellRenderers: cellRenderers })=>{
    return {
        id: tableViewNames.officeHistory,
        defaultSort: {
            colId: (0, $eHBjM.officeHistoryTooltips).moveDate.id,
            sortDir: "desc"
        },
        tables: [
            {
                col: (0, $eHBjM.officeHistoryTooltips).officeId,
                colDef: colSettings.textLg
            },
            {
                col: (0, $eHBjM.officeHistoryTooltips).officeName,
                colDef: colSettings.textLg
            },
            {
                col: (0, $eHBjM.officeHistoryTooltips).moveDate,
                colDef: colSettings.dateSm,
                cellRenderer: cellRenderers.moveDate
            }
        ]
    };
};
var $f6ae8dd87e54490c$export$2e2bcd8739ae039 = $f6ae8dd87e54490c$var$officeHistoryView;

});

parcelRegister("bksJ0", function(module, exports) {

$parcel$export(module.exports, "default", () => $83f7d81ef6f85382$export$2e2bcd8739ae039);

var $eHBjM = parcelRequire("eHBjM");
const $83f7d81ef6f85382$var$agentCoverageListingForSaleView = ({ colSettings: cs, tableViewNames: tableViewNames, cellRenderers: cellRenderers })=>{
    return {
        id: tableViewNames.agentCoverageListingForSale,
        showPagination: true,
        paginationOptions: {
            sizePerPage: 10
        },
        defaultSort: {
            colId: (0, $eHBjM.coverageListingsTooltips).dateLastForSale.keyField,
            sortDir: "desc"
        },
        tables: [
            {
                col: (0, $eHBjM.coverageListingsTooltips).officeId,
                colDef: cs.textSm
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).officeName,
                colDef: cs.textLg
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).mlsNum,
                colDef: cs.textSm
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).typeName,
                colDef: cs.textSm
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).address,
                colDef: cs.textMd,
                cellRenderer: cellRenderers.coverageAddressListingsLink
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).city,
                colDef: cs.textSm
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).zipCode,
                colDef: cs.textXs
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).areaId,
                colDef: cs.textXs
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).orgPrice,
                colDef: cs.numberMdVolume
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).listPrice,
                colDef: cs.numberSmVolume
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).dateLastForSale,
                colDef: cs.dateSm
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).dom,
                colDef: cs.numberXsInteger
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).cdom,
                colDef: cs.numberSmInteger
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).bankStatus,
                colDef: cs.bankStatus
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).priceChangeCnt,
                colDef: cs.numberLgInteger
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).bedrooms,
                colDef: cs.numberXsInteger
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).fullBaths,
                colDef: cs.numberXsInteger
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).squareFt,
                colDef: cs.numberXsInteger
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).pricePerSquareFt,
                colDef: cs.numberSmVolume
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).lotSizeSquareFt,
                colDef: cs.numberMdInteger
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).yearBuilt,
                colDef: cs.numberSmRightAlign
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).listAgent,
                colDef: cs.textLg
            }
        ]
    };
};
var $83f7d81ef6f85382$export$2e2bcd8739ae039 = $83f7d81ef6f85382$var$agentCoverageListingForSaleView;

});

parcelRegister("eLlZr", function(module, exports) {

$parcel$export(module.exports, "default", () => $abf68337fde039bf$export$2e2bcd8739ae039);

var $eHBjM = parcelRequire("eHBjM");
const $abf68337fde039bf$var$agentCoverageListingSoldView = ({ colSettings: cs, tableViewNames: tableViewNames, cellRenderers: cellRenderers })=>{
    return {
        id: tableViewNames.agentCoverageListingSold,
        showPagination: true,
        paginationOptions: {
            sizePerPage: 10
        },
        defaultSort: {
            colId: (0, $eHBjM.coverageListingsTooltips).dateLastSold.keyField,
            sortDir: "desc"
        },
        tables: [
            {
                col: (0, $eHBjM.coverageListingsTooltips).mlsNum,
                colDef: cs.textSm
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).typeName,
                colDef: cs.textSm
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).address,
                colDef: cs.textMd,
                cellRenderer: cellRenderers.coverageAddressListingsLink
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).city,
                colDef: cs.textSm
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).zipCode,
                colDef: cs.textXs
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).areaId,
                colDef: cs.textXs
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).bankStatus,
                colDef: cs.bankStatus
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).orgPrice,
                colDef: cs.numberMdVolume
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).listPrice,
                colDef: cs.numberSmVolume
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).lastPrice,
                colDef: cs.numberSmVolume
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).priceChangeCnt,
                colDef: cs.numberLgInteger
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).spop,
                colDef: cs.numberTwoDecimalsPercentage
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).splp,
                colDef: cs.numberTwoDecimalsPercentage
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).dateLastSold,
                colDef: cs.dateSm
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).dom,
                colDef: cs.numberXsInteger
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).cdom,
                colDef: cs.numberSmInteger
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).pcDom,
                colDef: cs.numberSmInteger
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).bedrooms,
                colDef: cs.numberXsInteger
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).fullBaths,
                colDef: cs.numberXsInteger
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).squareFt,
                colDef: cs.numberXsInteger
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).pricePerSquareFt,
                colDef: cs.numberSmVolume
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).lotSizeSquareFt,
                colDef: cs.numberMdInteger
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).yearBuilt,
                colDef: cs.numberSmRightAlign
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).listAgent,
                colDef: cs.textLg
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).sellAgent,
                colDef: cs.textLg
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).doubleSided,
                colDef: cs.textSmall
            }
        ]
    };
};
var $abf68337fde039bf$export$2e2bcd8739ae039 = $abf68337fde039bf$var$agentCoverageListingSoldView;

});

parcelRegister("6RwGN", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ff10cb5712bc7a0$export$2e2bcd8739ae039);

var $eHBjM = parcelRequire("eHBjM");
const $4ff10cb5712bc7a0$var$agentCoverageListingUcView = ({ colSettings: cs, tableViewNames: tableViewNames, cellRenderers: cellRenderers })=>{
    return {
        id: tableViewNames.agentCoverageListingUc,
        showPagination: true,
        paginationOptions: {
            sizePerPage: 10
        },
        defaultSort: {
            colId: (0, $eHBjM.coverageListingsTooltips).dateLastUC.keyField,
            sortDir: "desc"
        },
        tables: [
            {
                col: (0, $eHBjM.coverageListingsTooltips).officeId,
                colDef: cs.textSm
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).officeName,
                colDef: cs.textLg
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).mlsNum,
                colDef: cs.textSm
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).typeName,
                colDef: cs.textSm
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).address,
                colDef: cs.textMd,
                cellRenderer: cellRenderers.coverageAddressListingsLink
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).city,
                colDef: cs.textSm
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).zipCode,
                colDef: cs.textXs
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).areaId,
                colDef: cs.textXs
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).orgPrice,
                colDef: cs.numberMdVolume
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).listPrice,
                colDef: cs.numberSmVolume
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).dateLastUC,
                colDef: cs.dateSm
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).dom,
                colDef: cs.numberXsInteger
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).cdom,
                colDef: cs.numberSmInteger
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).bankStatus,
                colDef: cs.bankStatus
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).priceChangeCnt,
                colDef: cs.numberLgInteger
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).bedrooms,
                colDef: cs.numberXsInteger
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).fullBaths,
                colDef: cs.numberXsInteger
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).squareFt,
                colDef: cs.numberXsInteger
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).pricePerSquareFt,
                colDef: cs.numberSmVolume
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).lotSizeSquareFt,
                colDef: cs.numberMdInteger
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).yearBuilt,
                colDef: cs.numberSmRightAlign
            },
            {
                col: (0, $eHBjM.coverageListingsTooltips).listAgent,
                colDef: cs.textLg
            }
        ]
    };
};
var $4ff10cb5712bc7a0$export$2e2bcd8739ae039 = $4ff10cb5712bc7a0$var$agentCoverageListingUcView;

});

parcelRegister("gC1w5", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1815f190d9609e6$export$2e2bcd8739ae039);

var $eHBjM = parcelRequire("eHBjM");
const $c1815f190d9609e6$var$agentProductionListingView = (id, { colSettings: cs, cellRenderers: cellRenderers })=>({
        id: id,
        showPagination: true,
        paginationOptions: {
            sizePerPage: 10
        },
        defaultSort: {
            colId: (0, $eHBjM.productionListingsTooltips).soldDate.keyField,
            sortDir: "desc"
        },
        tables: [
            {
                col: (0, $eHBjM.productionListingsTooltips).mlsNum,
                colDef: cs.textSm
            },
            {
                col: (0, $eHBjM.productionListingsTooltips).typeName,
                colDef: cs.textSm
            },
            {
                col: (0, $eHBjM.productionListingsTooltips).address,
                colDef: cs.textMd,
                cellRenderer: cellRenderers.productionAddressListingsLink
            },
            {
                col: (0, $eHBjM.productionListingsTooltips).city,
                colDef: cs.textSm
            },
            {
                col: (0, $eHBjM.productionListingsTooltips).zip,
                colDef: cs.textXs
            },
            {
                col: (0, $eHBjM.productionListingsTooltips).area,
                colDef: cs.textXs
            },
            {
                col: (0, $eHBjM.productionListingsTooltips).bankProperty,
                colDef: cs.textSm
            },
            {
                col: (0, $eHBjM.productionListingsTooltips).orgPrice,
                colDef: cs.numberMdVolume
            },
            {
                col: (0, $eHBjM.productionListingsTooltips).listPrice,
                colDef: cs.numberSmVolume
            },
            {
                col: (0, $eHBjM.productionListingsTooltips).lastPrice,
                colDef: cs.numberSmVolume
            },
            {
                col: (0, $eHBjM.productionListingsTooltips).priceChangeCnt,
                colDef: cs.numberLgInteger
            },
            {
                col: (0, $eHBjM.productionListingsTooltips).spop,
                colDef: cs.numberSmPercentage
            },
            {
                col: (0, $eHBjM.productionListingsTooltips).splp,
                colDef: cs.numberSmPercentage
            },
            {
                col: (0, $eHBjM.productionListingsTooltips).soldDate,
                colDef: cs.dateSm
            },
            {
                col: (0, $eHBjM.productionListingsTooltips).dom,
                colDef: cs.numberXsInteger
            },
            {
                col: (0, $eHBjM.productionListingsTooltips).cdom,
                colDef: cs.numberSmInteger
            },
            {
                col: (0, $eHBjM.productionListingsTooltips).pcDom,
                colDef: cs.numberSmInteger
            },
            {
                col: (0, $eHBjM.productionListingsTooltips).bedrooms,
                colDef: cs.numberXsInteger
            },
            {
                col: (0, $eHBjM.productionListingsTooltips).bathrooms,
                colDef: cs.numberXsInteger
            },
            {
                col: (0, $eHBjM.productionListingsTooltips).squareFt,
                colDef: cs.numberXsInteger
            },
            {
                col: (0, $eHBjM.productionListingsTooltips).pricePerSquareFt,
                colDef: cs.numberSmVolume
            },
            {
                col: (0, $eHBjM.productionListingsTooltips).lotSizeSquareFt,
                colDef: cs.numberMdInteger
            },
            {
                col: (0, $eHBjM.productionListingsTooltips).yearBuilt,
                colDef: cs.numberSmRightAlign
            },
            {
                col: (0, $eHBjM.productionListingsTooltips).listAgent,
                colDef: cs.textLg
            },
            {
                col: (0, $eHBjM.productionListingsTooltips).sellAgent,
                colDef: cs.textLg
            },
            {
                col: (0, $eHBjM.productionListingsTooltips).doubleSided,
                colDef: cs.textSm
            }
        ]
    });
var $c1815f190d9609e6$export$2e2bcd8739ae039 = $c1815f190d9609e6$var$agentProductionListingView;

});

parcelRegister("hAeWH", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccd1646301c0e3b7$export$2e2bcd8739ae039);

var $hQz0O = parcelRequire("hQz0O");

var $cIUhV = parcelRequire("cIUhV");

var $4tbBr = parcelRequire("4tbBr");
const $ccd1646301c0e3b7$var$agentsGainedBreakdown = (id, { colSettings: cs }, shouldShowAdditionalInfo)=>({
        id: id,
        defaultSort: {
            colId: (0, $hQz0O.agentsGainedTooltips).agentName.keyField,
            sortDir: "desc"
        },
        tables: [
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)("agentInformation", props),
                children: [
                    {
                        col: {
                            ...(0, $hQz0O.agentsGainedTooltips).agentName,
                            isDisplayed: true
                        },
                        colDef: cs.textMd,
                        cellRenderer: (0, $4tbBr.cellRenderers).agentNameLink
                    },
                    {
                        col: {
                            ...(0, $hQz0O.agentsGainedTooltips).officeId,
                            isDisplayed: shouldShowAdditionalInfo
                        },
                        colDef: cs.textSm
                    },
                    {
                        col: {
                            ...(0, $hQz0O.agentsGainedTooltips).officeName,
                            isDisplayed: shouldShowAdditionalInfo
                        },
                        colDef: cs.textSm
                    },
                    {
                        col: {
                            ...(0, $hQz0O.agentsGainedTooltips).officeStreetName,
                            isDisplayed: shouldShowAdditionalInfo
                        },
                        colDef: cs.textMd
                    },
                    {
                        col: {
                            ...(0, $hQz0O.agentsGainedTooltips).officeCity,
                            isDisplayed: shouldShowAdditionalInfo
                        },
                        colDef: cs.textSm
                    },
                    {
                        col: {
                            ...(0, $hQz0O.agentsGainedTooltips).officeZipCode,
                            isDisplayed: shouldShowAdditionalInfo
                        },
                        colDef: cs.textXs
                    },
                    {
                        col: {
                            ...(0, $hQz0O.agentsGainedTooltips).agentPhone1,
                            isDisplayed: shouldShowAdditionalInfo
                        },
                        colDef: cs.textMd
                    },
                    {
                        col: {
                            ...(0, $hQz0O.agentsGainedTooltips).agentPhone2,
                            isDisplayed: shouldShowAdditionalInfo
                        },
                        colDef: cs.textMd
                    },
                    {
                        col: {
                            ...(0, $hQz0O.agentsGainedTooltips).agentPhone3,
                            isDisplayed: shouldShowAdditionalInfo
                        },
                        colDef: cs.textMd
                    },
                    {
                        col: {
                            ...(0, $hQz0O.agentsGainedTooltips).agentEmail,
                            isDisplayed: shouldShowAdditionalInfo
                        },
                        colDef: cs.textMd
                    },
                    {
                        col: {
                            ...(0, $hQz0O.agentsGainedTooltips).agentStreetName,
                            isDisplayed: shouldShowAdditionalInfo
                        },
                        colDef: cs.textMd
                    },
                    {
                        col: {
                            ...(0, $hQz0O.agentsGainedTooltips).agentCity,
                            isDisplayed: shouldShowAdditionalInfo
                        },
                        colDef: cs.textSm
                    },
                    {
                        col: {
                            ...(0, $hQz0O.agentsGainedTooltips).agentZipCode,
                            isDisplayed: shouldShowAdditionalInfo
                        },
                        colDef: cs.textSm
                    },
                    {
                        col: {
                            ...(0, $hQz0O.agentsGainedTooltips).moveDate,
                            isDisplayed: true
                        },
                        colDef: cs.dateSm
                    }
                ]
            },
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)("beforeMove", props),
                children: [
                    {
                        col: {
                            ...(0, $hQz0O.agentsGainedTooltips).volumePreMove,
                            isDisplayed: true
                        },
                        colDef: cs.numberSmInteger
                    }
                ]
            },
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)("afterMove", props),
                children: [
                    {
                        col: {
                            ...(0, $hQz0O.agentsGainedTooltips).daysSinceMove,
                            isDisplayed: true
                        },
                        colDef: cs.numberSmInteger
                    },
                    {
                        col: {
                            ...(0, $hQz0O.agentsGainedTooltips).percentOf365DaysWithOffice,
                            isDisplayed: true
                        },
                        colDef: cs.numberSmPercentageMultiplier
                    },
                    {
                        col: {
                            ...(0, $hQz0O.agentsGainedTooltips).volumePostMove,
                            isDisplayed: true
                        },
                        colDef: cs.numberSmInteger
                    },
                    {
                        col: {
                            ...(0, $hQz0O.agentsGainedTooltips).volumeYardstick,
                            isDisplayed: true
                        },
                        colDef: cs.numberMdInteger
                    },
                    {
                        col: {
                            ...(0, $hQz0O.agentsGainedTooltips).volumeDifference,
                            isDisplayed: true
                        },
                        colDef: cs.numberSmInteger
                    },
                    {
                        col: {
                            ...(0, $hQz0O.agentsGainedTooltips).volumeGrowth,
                            isDisplayed: true
                        },
                        colDef: cs.numberSmPercentageMultiplier
                    }
                ]
            }
        ]
    });
var $ccd1646301c0e3b7$export$2e2bcd8739ae039 = $ccd1646301c0e3b7$var$agentsGainedBreakdown;

});

parcelRegister("g5uaS", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb6484f9bb0ab91d$export$2e2bcd8739ae039);

var $hQz0O = parcelRequire("hQz0O");

var $cIUhV = parcelRequire("cIUhV");

var $4tbBr = parcelRequire("4tbBr");
const $bb6484f9bb0ab91d$var$lostAgentsBreakdown = (id, { colSettings: cs }, shouldShowAdditionalInfo)=>({
        id: id,
        defaultSort: {
            colId: (0, $hQz0O.lostAgentsTooltips).officeName.keyField,
            sortDir: "desc"
        },
        tables: [
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)("agentInformation", props),
                children: [
                    {
                        col: {
                            ...(0, $hQz0O.lostAgentsTooltips).agentName,
                            isDisplayed: true
                        },
                        colDef: cs.textSm,
                        cellRenderer: (0, $4tbBr.cellRenderers).agentNameLink
                    },
                    {
                        col: {
                            ...(0, $hQz0O.lostAgentsTooltips).officeId,
                            isDisplayed: shouldShowAdditionalInfo
                        },
                        colDef: cs.textSm
                    },
                    {
                        col: {
                            ...(0, $hQz0O.lostAgentsTooltips).officeName,
                            isDisplayed: shouldShowAdditionalInfo
                        },
                        colDef: cs.textSm
                    },
                    {
                        col: {
                            ...(0, $hQz0O.lostAgentsTooltips).officeStreetName,
                            isDisplayed: shouldShowAdditionalInfo
                        },
                        colDef: cs.textMd
                    },
                    {
                        col: {
                            ...(0, $hQz0O.lostAgentsTooltips).officeCity,
                            isDisplayed: shouldShowAdditionalInfo
                        },
                        colDef: cs.textSm
                    },
                    {
                        col: {
                            ...(0, $hQz0O.lostAgentsTooltips).officeZipCode,
                            isDisplayed: shouldShowAdditionalInfo
                        },
                        colDef: cs.textXs
                    },
                    {
                        col: {
                            ...(0, $hQz0O.lostAgentsTooltips).agentPhone1,
                            isDisplayed: shouldShowAdditionalInfo
                        },
                        colDef: cs.textMd
                    },
                    {
                        col: {
                            ...(0, $hQz0O.lostAgentsTooltips).agentPhone2,
                            isDisplayed: shouldShowAdditionalInfo
                        },
                        colDef: cs.textMd
                    },
                    {
                        col: {
                            ...(0, $hQz0O.lostAgentsTooltips).agentPhone3,
                            isDisplayed: shouldShowAdditionalInfo
                        },
                        colDef: cs.textMd
                    },
                    {
                        col: {
                            ...(0, $hQz0O.lostAgentsTooltips).agentEmail,
                            isDisplayed: shouldShowAdditionalInfo
                        },
                        colDef: cs.textMd
                    },
                    {
                        col: {
                            ...(0, $hQz0O.lostAgentsTooltips).agentStreetName,
                            isDisplayed: shouldShowAdditionalInfo
                        },
                        colDef: cs.textMd
                    },
                    {
                        col: {
                            ...(0, $hQz0O.lostAgentsTooltips).agentCity,
                            isDisplayed: shouldShowAdditionalInfo
                        },
                        colDef: cs.textSm
                    },
                    {
                        col: {
                            ...(0, $hQz0O.lostAgentsTooltips).agentZipCode,
                            isDisplayed: shouldShowAdditionalInfo
                        },
                        colDef: cs.textSm
                    },
                    {
                        col: {
                            ...(0, $hQz0O.lostAgentsTooltips).moveDate,
                            isDisplayed: true
                        },
                        colDef: cs.dateSm
                    }
                ]
            },
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)("beforeMove", props),
                children: [
                    {
                        col: {
                            ...(0, $hQz0O.lostAgentsTooltips).volumePreMove,
                            isDisplayed: true
                        },
                        colDef: cs.numberSmInteger
                    }
                ]
            },
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)("afterMove", props),
                children: [
                    {
                        col: {
                            ...(0, $hQz0O.lostAgentsTooltips).daysSinceMove,
                            isDisplayed: true
                        },
                        colDef: cs.numberSmInteger
                    },
                    {
                        col: {
                            ...(0, $hQz0O.lostAgentsTooltips).percentOf365DaysWithOffice,
                            isDisplayed: true
                        },
                        colDef: cs.numberSmPercentageMultiplier
                    },
                    {
                        col: {
                            ...(0, $hQz0O.lostAgentsTooltips).volumePostMove,
                            isDisplayed: true
                        },
                        colDef: cs.numberSmInteger
                    },
                    {
                        col: {
                            ...(0, $hQz0O.lostAgentsTooltips).volumeYardstick,
                            isDisplayed: true
                        },
                        colDef: cs.numberMdInteger
                    },
                    {
                        col: {
                            ...(0, $hQz0O.lostAgentsTooltips).volumeDifference,
                            isDisplayed: true
                        },
                        colDef: cs.numberSmInteger
                    },
                    {
                        col: {
                            ...(0, $hQz0O.lostAgentsTooltips).volumeGrowth,
                            isDisplayed: true
                        },
                        colDef: cs.numberSmPercentageMultiplier
                    }
                ]
            }
        ]
    });
var $bb6484f9bb0ab91d$export$2e2bcd8739ae039 = $bb6484f9bb0ab91d$var$lostAgentsBreakdown;

});

parcelRegister("jrnUE", function(module, exports) {

$parcel$export(module.exports, "default", () => $e27316858e778b84$export$2e2bcd8739ae039);

var $cstaF = parcelRequire("cstaF");

var $cIUhV = parcelRequire("cIUhV");
const $e27316858e778b84$var$dateWithRankTiebreaker = (valueA, valueB, nodeA, nodeB)=>{
    const dateA = new Date(valueA).getTime();
    const dateB = new Date(valueB).getTime();
    if (dateA !== dateB) return dateA - dateB;
    return nodeB.data.rank - nodeA.data.rank;
};
const $e27316858e778b84$var$activityView = ({ agentsColumns: agentsColumns, cellRenderers: cellRenderers, colSettings: colSettings, tableViewNames: tableViewNames, TextFloatingFilterComponent: TextFloatingFilterComponent })=>{
    return {
        id: tableViewNames.activity,
        showPagination: true,
        paginationOptions: {
            sizePerPage: 100,
            sizePerPageList: [
                10,
                20,
                50,
                100
            ]
        },
        defaultSort: {
            colId: agentsColumns.date.id,
            sortDir: "desc"
        },
        tables: [
            {
                headerGroupTitle: (0, $cIUhV.getCurrentSearchLast6Months),
                children: [
                    {
                        col: agentsColumns.rank,
                        colDef: colSettings.textXsRightAlign
                    },
                    {
                        col: agentsColumns.agentName,
                        colDef: colSettings.textLg,
                        cellRenderer: cellRenderers.agentNameLink,
                        filterOptions: {
                            filter: "agTextColumnFilter",
                            floatingFilterComponent: TextFloatingFilterComponent,
                            floatingFilterComponentParams: {
                                placeholder: (0, $cstaF.searchTerms).searchName
                            }
                        }
                    },
                    {
                        col: agentsColumns.officeName,
                        colDef: colSettings.textLg,
                        filterOptions: {
                            filter: "agTextColumnFilter",
                            floatingFilterComponent: TextFloatingFilterComponent,
                            floatingFilterComponentParams: {
                                placeholder: (0, $cstaF.searchTerms).searchOffice
                            }
                        }
                    },
                    {
                        col: agentsColumns.activity,
                        colDef: colSettings.textXl,
                        filterOptions: {
                            filter: "agTextColumnFilter",
                            floatingFilterComponent: TextFloatingFilterComponent,
                            floatingFilterComponentParams: {
                                placeholder: (0, $cstaF.searchTerms).searchActivity
                            }
                        }
                    },
                    {
                        col: agentsColumns.side,
                        colDef: colSettings.textSm
                    },
                    {
                        col: agentsColumns.date,
                        colDef: {
                            ...colSettings.textSm,
                            comparator: $e27316858e778b84$var$dateWithRankTiebreaker
                        }
                    }
                ]
            },
            {
                headerGroupTitle: (0, $cIUhV.getAllMlsLast12Months),
                children: [
                    {
                        col: agentsColumns.listVolume,
                        colDef: colSettings.numberMdInteger
                    },
                    {
                        col: agentsColumns.sellVolume,
                        colDef: colSettings.numberMdInteger
                    },
                    {
                        col: agentsColumns.totalVolume,
                        colDef: colSettings.numberMdInteger
                    }
                ]
            }
        ]
    };
};
var $e27316858e778b84$export$2e2bcd8739ae039 = $e27316858e778b84$var$activityView;

});




parcelRegister("EHEsI", function(module, exports) {

$parcel$export(module.exports, "default", () => $07a598d7bdcdfb03$export$2e2bcd8739ae039);

var $h2imA = parcelRequire("h2imA");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $07a598d7bdcdfb03$var$isEqual(value, other) {
    return (0, $h2imA.default)(value, other);
}
var $07a598d7bdcdfb03$export$2e2bcd8739ae039 = $07a598d7bdcdfb03$var$isEqual;

});

parcelRegister("7oK46", function(module, exports) {

$parcel$export(module.exports, "default", () => $562e81dafb71f537$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $e9hDx = parcelRequire("e9hDx");
var $562e81dafb71f537$var$propTypes = {
    tag: (0, $e9hDx.tagPropType),
    active: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $562e81dafb71f537$var$defaultProps = {
    tag: "li"
};
var $562e81dafb71f537$var$NavItem = function NavItem(props) {
    var className = props.className, cssModule = props.cssModule, active = props.active, Tag = props.tag, attributes = (0, $1En50.default)(props, [
        "className",
        "cssModule",
        "active",
        "tag"
    ]);
    var classes = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, "nav-item", active ? "active" : false), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({}, attributes, {
        className: classes
    }));
};
$562e81dafb71f537$var$NavItem.propTypes = $562e81dafb71f537$var$propTypes;
$562e81dafb71f537$var$NavItem.defaultProps = $562e81dafb71f537$var$defaultProps;
var $562e81dafb71f537$export$2e2bcd8739ae039 = $562e81dafb71f537$var$NavItem;

});

parcelRegister("8WMG5", function(module, exports) {

$parcel$export(module.exports, "default", () => $68397fe5c5a463c0$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $hDpcU = parcelRequire("hDpcU");

var $g7ajw = parcelRequire("g7ajw");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $e9hDx = parcelRequire("e9hDx");
var $68397fe5c5a463c0$var$propTypes = {
    tag: (0, $e9hDx.tagPropType),
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    active: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    href: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any
};
var $68397fe5c5a463c0$var$defaultProps = {
    tag: "a"
};
var $68397fe5c5a463c0$var$NavLink = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(NavLink, _React$Component);
    function NavLink(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.onClick = _this.onClick.bind((0, $hDpcU.default)(_this));
        return _this;
    }
    var _proto = NavLink.prototype;
    _proto.onClick = function onClick(e) {
        if (this.props.disabled) {
            e.preventDefault();
            return;
        }
        if (this.props.href === "#") e.preventDefault();
        if (this.props.onClick) this.props.onClick(e);
    };
    _proto.render = function render() {
        var _this$props = this.props, className = _this$props.className, cssModule = _this$props.cssModule, active = _this$props.active, Tag = _this$props.tag, innerRef = _this$props.innerRef, attributes = (0, $1En50.default)(_this$props, [
            "className",
            "cssModule",
            "active",
            "tag",
            "innerRef"
        ]);
        var classes = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, "nav-link", {
            disabled: attributes.disabled,
            active: active
        }), cssModule);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({}, attributes, {
            ref: innerRef,
            onClick: this.onClick,
            className: classes
        }));
    };
    return NavLink;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$68397fe5c5a463c0$var$NavLink.propTypes = $68397fe5c5a463c0$var$propTypes;
$68397fe5c5a463c0$var$NavLink.defaultProps = $68397fe5c5a463c0$var$defaultProps;
var $68397fe5c5a463c0$export$2e2bcd8739ae039 = $68397fe5c5a463c0$var$NavLink;

});

parcelRegister("g1G2y", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $baad59a05ac80ee8$export$2e2bcd8739ae039);

var $8cHIL = parcelRequire("8cHIL");
var $baad59a05ac80ee8$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($8cHIL)));

});
parcelRegister("8cHIL", function(module, exports) {
"use strict";
var $5f915bcf4dab3069$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $5f915bcf4dab3069$var$react_1 = $5f915bcf4dab3069$var$__importDefault((parcelRequire("acw62")));

const $5f915bcf4dab3069$var$classnames_1 = $5f915bcf4dab3069$var$__importDefault((parcelRequire("8g1PZ")));
const $5f915bcf4dab3069$var$getVerticalClass = (vertical)=>{
    if (!vertical) return false;
    else if (vertical === true || vertical === "xs") return "flex-column";
    else return `flex-${vertical}-column`;
};
const $5f915bcf4dab3069$var$Nav = (props)=>{
    const { className: className, tabs: tabs, pills: pills, vertical: vertical, stretch: stretch, primary: primary, navbar: navbar, card: card, tag: tag, dataLwtId: dataLwtId, ...attributes } = props;
    const classes = (0, $5f915bcf4dab3069$var$classnames_1.default)(className, navbar ? "navbar-nav" : "nav", stretch ? "justify-content-stretch" : false, primary ? "nav-primary" : false, $5f915bcf4dab3069$var$getVerticalClass(vertical), tabs ? "nav-tabs" : false, card && tabs ? "card-header-tabs" : false, pills ? "nav-pills" : false);
    const Tag = tag === "nav" ? "nav" : "ul";
    return $5f915bcf4dab3069$var$react_1.default.createElement(Tag, {
        ...attributes,
        className: classes,
        "data-lwt-id": dataLwtId
    });
};
$5f915bcf4dab3069$var$Nav.defaultProps = {
    vertical: false,
    tag: "ul"
};
module.exports.default = $5f915bcf4dab3069$var$Nav;

});


parcelRegister("1royG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $10cb5cd9b5cd6e6f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "withTheme", () => (parcelRequire("imRAj")).default);
$parcel$export(module.exports, "utils", () => (parcelRequire("ip6TK")));

var $dk1mq = parcelRequire("dk1mq");

var $imRAj = parcelRequire("imRAj");

var $ip6TK = parcelRequire("ip6TK");
var $10cb5cd9b5cd6e6f$export$2e2bcd8739ae039 = (0, $dk1mq.default);

});
parcelRegister("dk1mq", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b2e32d222a420d9$export$2e2bcd8739ae039);

var $k4zDq = parcelRequire("k4zDq");

var $8lpxl = parcelRequire("8lpxl");

var $a5du3 = parcelRequire("a5du3");

var $cD46i = parcelRequire("cD46i");

var $7PwEf = parcelRequire("7PwEf");

var $4tWkZ = parcelRequire("4tWkZ");

var $eBH73 = parcelRequire("eBH73");

var $ctnWZ = parcelRequire("ctnWZ");

var $hl9R1 = parcelRequire("hl9R1");

var $ivxVa = parcelRequire("ivxVa");

var $kB4x2 = parcelRequire("kB4x2");

var $acw62 = parcelRequire("acw62");


var $12eN8 = parcelRequire("12eN8");

var $i51gj = parcelRequire("i51gj");

var $44Pmt = parcelRequire("44Pmt");

var $kYVvO = parcelRequire("kYVvO");

var $ip6TK = parcelRequire("ip6TK");

var $3cXpG = parcelRequire("3cXpG");
var $9b2e32d222a420d9$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, $ivxVa.default)(Form, _Component);
    function Form(props) {
        var _this;
        (0, $7PwEf.default)(this, Form);
        _this = (0, $eBH73.default)(this, (0, $ctnWZ.default)(Form).call(this, props));
        (0, $kB4x2.default)((0, $hl9R1.default)(_this), "getUsedFormData", function(formData, fields) {
            //for the case of a single input form
            if (fields.length === 0 && (0, $cD46i.default)(formData) !== "object") return formData;
            var data = (0, (/*@__PURE__*/$parcel$interopDefault($12eN8)))(formData, fields);
            if ((0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(formData)) return (0, (/*@__PURE__*/$parcel$interopDefault($8lpxl)))(data).map(function(key) {
                return data[key];
            });
            return data;
        });
        (0, $kB4x2.default)((0, $hl9R1.default)(_this), "getFieldNames", function(pathSchema, formData) {
            var getAllPaths = function getAllPaths(_obj) {
                var acc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
                var paths = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [
                    ""
                ];
                (0, (/*@__PURE__*/$parcel$interopDefault($8lpxl)))(_obj).forEach(function(key) {
                    if ((0, $cD46i.default)(_obj[key]) === "object") {
                        var newPaths = paths.map(function(path) {
                            return "".concat(path, ".").concat(key);
                        }); // If an object is marked with additionalProperties, all its keys are valid
                        if (_obj[key].__rjsf_additionalProperties && _obj[key].$name !== "") acc.push(_obj[key].$name);
                        else getAllPaths(_obj[key], acc, newPaths);
                    } else if (key === "$name" && _obj[key] !== "") paths.forEach(function(path) {
                        path = path.replace(/^\./, "");
                        var formValue = (0, (/*@__PURE__*/$parcel$interopDefault($i51gj)))(formData, path); // adds path to fieldNames if it points to a value
                        // or an empty object/array
                        if ((0, $cD46i.default)(formValue) !== "object" || (0, (/*@__PURE__*/$parcel$interopDefault($44Pmt)))(formValue)) acc.push(path);
                    });
                });
                return acc;
            };
            return getAllPaths(pathSchema);
        });
        (0, $kB4x2.default)((0, $hl9R1.default)(_this), "onChange", function(formData, newErrorSchema) {
            if ((0, $ip6TK.isObject)(formData) || (0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(formData)) {
                var newState = _this.getStateFromProps(_this.props, formData);
                formData = newState.formData;
            }
            var mustValidate = !_this.props.noValidate && _this.props.liveValidate;
            var state = {
                formData: formData
            };
            var newFormData = formData;
            if (_this.props.omitExtraData === true && _this.props.liveOmit === true) {
                var retrievedSchema = (0, $ip6TK.retrieveSchema)(_this.state.schema, _this.state.schema, formData);
                var pathSchema = (0, $ip6TK.toPathSchema)(retrievedSchema, "", _this.state.schema, formData);
                var fieldNames = _this.getFieldNames(pathSchema, formData);
                newFormData = _this.getUsedFormData(formData, fieldNames);
                state = {
                    formData: newFormData
                };
            }
            if (mustValidate) {
                var schemaValidation = _this.validate(newFormData);
                var errors = schemaValidation.errors;
                var errorSchema = schemaValidation.errorSchema;
                var schemaValidationErrors = errors;
                var schemaValidationErrorSchema = errorSchema;
                if (_this.props.extraErrors) {
                    errorSchema = (0, $ip6TK.mergeObjects)(errorSchema, _this.props.extraErrors, true);
                    errors = (0, $3cXpG.toErrorList)(errorSchema);
                }
                state = {
                    formData: newFormData,
                    errors: errors,
                    errorSchema: errorSchema,
                    schemaValidationErrors: schemaValidationErrors,
                    schemaValidationErrorSchema: schemaValidationErrorSchema
                };
            } else if (!_this.props.noValidate && newErrorSchema) {
                var _errorSchema = _this.props.extraErrors ? (0, $ip6TK.mergeObjects)(newErrorSchema, _this.props.extraErrors, true) : newErrorSchema;
                state = {
                    formData: newFormData,
                    errorSchema: _errorSchema,
                    errors: (0, $3cXpG.toErrorList)(_errorSchema)
                };
            }
            _this.setState(state, function() {
                return _this.props.onChange && _this.props.onChange(_this.state);
            });
        });
        (0, $kB4x2.default)((0, $hl9R1.default)(_this), "onBlur", function() {
            if (_this.props.onBlur) {
                var _this$props;
                (_this$props = _this.props).onBlur.apply(_this$props, arguments);
            }
        });
        (0, $kB4x2.default)((0, $hl9R1.default)(_this), "onFocus", function() {
            if (_this.props.onFocus) {
                var _this$props2;
                (_this$props2 = _this.props).onFocus.apply(_this$props2, arguments);
            }
        });
        (0, $kB4x2.default)((0, $hl9R1.default)(_this), "onSubmit", function(event) {
            event.preventDefault();
            if (event.target !== event.currentTarget) return;
            event.persist();
            var newFormData = _this.state.formData;
            if (_this.props.omitExtraData === true) {
                var retrievedSchema = (0, $ip6TK.retrieveSchema)(_this.state.schema, _this.state.schema, newFormData);
                var pathSchema = (0, $ip6TK.toPathSchema)(retrievedSchema, "", _this.state.schema, newFormData);
                var fieldNames = _this.getFieldNames(pathSchema, newFormData);
                newFormData = _this.getUsedFormData(newFormData, fieldNames);
            }
            if (!_this.props.noValidate) {
                var schemaValidation = _this.validate(newFormData);
                var _errors = schemaValidation.errors;
                var _errorSchema2 = schemaValidation.errorSchema;
                var schemaValidationErrors = _errors;
                var schemaValidationErrorSchema = _errorSchema2;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($8lpxl)))(_errors).length > 0) {
                    if (_this.props.extraErrors) {
                        _errorSchema2 = (0, $ip6TK.mergeObjects)(_errorSchema2, _this.props.extraErrors, true);
                        _errors = (0, $3cXpG.toErrorList)(_errorSchema2);
                    }
                    _this.setState({
                        errors: _errors,
                        errorSchema: _errorSchema2,
                        schemaValidationErrors: schemaValidationErrors,
                        schemaValidationErrorSchema: schemaValidationErrorSchema
                    }, function() {
                        if (_this.props.onError) _this.props.onError(_errors);
                        else console.error("Form validation failed", _errors);
                    });
                    return;
                }
            }
            var errorSchema;
            var errors;
            if (_this.props.extraErrors) {
                errorSchema = _this.props.extraErrors;
                errors = (0, $3cXpG.toErrorList)(errorSchema);
            } else {
                errorSchema = {};
                errors = [];
            }
            _this.setState({
                formData: newFormData,
                errors: errors,
                errorSchema: errorSchema
            }, function() {
                if (_this.props.onSubmit) _this.props.onSubmit((0, $k4zDq.default)({}, _this.state, {
                    formData: newFormData,
                    status: "submitted"
                }), event);
            });
        });
        _this.state = _this.getStateFromProps(props, props.formData);
        if (_this.props.onChange && !(0, $ip6TK.deepEquals)(_this.state.formData, _this.props.formData)) _this.props.onChange(_this.state);
        _this.formElement = null;
        return _this;
    }
    (0, $4tWkZ.default)(Form, [
        {
            key: "UNSAFE_componentWillReceiveProps",
            value: function UNSAFE_componentWillReceiveProps(nextProps) {
                var nextState = this.getStateFromProps(nextProps, nextProps.formData);
                if (!(0, $ip6TK.deepEquals)(nextState.formData, nextProps.formData) && !(0, $ip6TK.deepEquals)(nextState.formData, this.state.formData) && this.props.onChange) this.props.onChange(nextState);
                this.setState(nextState);
            }
        },
        {
            key: "getStateFromProps",
            value: function getStateFromProps(props, inputFormData) {
                var state = this.state || {};
                var schema = "schema" in props ? props.schema : this.props.schema;
                var uiSchema = "uiSchema" in props ? props.uiSchema : this.props.uiSchema;
                var edit = typeof inputFormData !== "undefined";
                var liveValidate = "liveValidate" in props ? props.liveValidate : this.props.liveValidate;
                var mustValidate = edit && !props.noValidate && liveValidate;
                var rootSchema = schema;
                var formData = (0, $ip6TK.getDefaultFormState)(schema, inputFormData, rootSchema);
                var retrievedSchema = (0, $ip6TK.retrieveSchema)(schema, rootSchema, formData);
                var customFormats = props.customFormats;
                var additionalMetaSchemas = props.additionalMetaSchemas;
                var getCurrentErrors = function getCurrentErrors() {
                    if (props.noValidate) return {
                        errors: [],
                        errorSchema: {}
                    };
                    else if (!props.liveValidate) return {
                        errors: state.schemaValidationErrors || [],
                        errorSchema: state.schemaValidationErrorSchema || {}
                    };
                    return {
                        errors: state.errors || [],
                        errorSchema: state.errorSchema || {}
                    };
                };
                var errors, errorSchema, schemaValidationErrors, schemaValidationErrorSchema;
                if (mustValidate) {
                    var schemaValidation = this.validate(formData, schema, additionalMetaSchemas, customFormats);
                    errors = schemaValidation.errors;
                    errorSchema = schemaValidation.errorSchema;
                    schemaValidationErrors = errors;
                    schemaValidationErrorSchema = errorSchema;
                } else {
                    var currentErrors = getCurrentErrors();
                    errors = currentErrors.errors;
                    errorSchema = currentErrors.errorSchema;
                    schemaValidationErrors = state.schemaValidationErrors;
                    schemaValidationErrorSchema = state.schemaValidationErrorSchema;
                }
                if (props.extraErrors) {
                    errorSchema = (0, $ip6TK.mergeObjects)(errorSchema, props.extraErrors, true);
                    errors = (0, $3cXpG.toErrorList)(errorSchema);
                }
                var idSchema = (0, $ip6TK.toIdSchema)(retrievedSchema, uiSchema["ui:rootFieldId"], rootSchema, formData, props.idPrefix);
                var nextState = {
                    schema: schema,
                    uiSchema: uiSchema,
                    idSchema: idSchema,
                    formData: formData,
                    edit: edit,
                    errors: errors,
                    errorSchema: errorSchema,
                    additionalMetaSchemas: additionalMetaSchemas
                };
                if (schemaValidationErrors) {
                    nextState.schemaValidationErrors = schemaValidationErrors;
                    nextState.schemaValidationErrorSchema = schemaValidationErrorSchema;
                }
                return nextState;
            }
        },
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps, nextState) {
                return (0, $ip6TK.shouldRender)(this, nextProps, nextState);
            }
        },
        {
            key: "validate",
            value: function validate(formData) {
                var schema = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props.schema;
                var additionalMetaSchemas = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.props.additionalMetaSchemas;
                var customFormats = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : this.props.customFormats;
                var _this$props3 = this.props, validate = _this$props3.validate, transformErrors = _this$props3.transformErrors;
                var _this$getRegistry = this.getRegistry(), rootSchema = _this$getRegistry.rootSchema;
                var resolvedSchema = (0, $ip6TK.retrieveSchema)(schema, rootSchema, formData);
                return (0, $3cXpG.default)(formData, resolvedSchema, validate, transformErrors, additionalMetaSchemas, customFormats);
            }
        },
        {
            key: "renderErrors",
            value: function renderErrors() {
                var _this$state = this.state, errors = _this$state.errors, errorSchema = _this$state.errorSchema, schema = _this$state.schema, uiSchema = _this$state.uiSchema;
                var _this$props4 = this.props, ErrorList = _this$props4.ErrorList, showErrorList = _this$props4.showErrorList, formContext = _this$props4.formContext;
                if (errors.length && showErrorList != false) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ErrorList, {
                    errors: errors,
                    errorSchema: errorSchema,
                    schema: schema,
                    uiSchema: uiSchema,
                    formContext: formContext
                });
                return null;
            }
        },
        {
            key: "getRegistry",
            value: function getRegistry() {
                // For BC, accept passed SchemaField and TitleField props and pass them to
                // the "fields" registry one.
                var _getDefaultRegistry = (0, $ip6TK.getDefaultRegistry)(), fields = _getDefaultRegistry.fields, widgets = _getDefaultRegistry.widgets;
                return {
                    fields: (0, $k4zDq.default)({}, fields, this.props.fields),
                    widgets: (0, $k4zDq.default)({}, widgets, this.props.widgets),
                    ArrayFieldTemplate: this.props.ArrayFieldTemplate,
                    ObjectFieldTemplate: this.props.ObjectFieldTemplate,
                    FieldTemplate: this.props.FieldTemplate,
                    definitions: this.props.schema.definitions || {},
                    rootSchema: this.props.schema,
                    formContext: this.props.formContext || {}
                };
            }
        },
        {
            key: "submit",
            value: function submit() {
                if (this.formElement) this.formElement.dispatchEvent(new CustomEvent("submit", {
                    cancelable: true
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props5 = this.props, children = _this$props5.children, id = _this$props5.id, idPrefix = _this$props5.idPrefix, className = _this$props5.className, tagName = _this$props5.tagName, name = _this$props5.name, method = _this$props5.method, target = _this$props5.target, action = _this$props5.action, deprecatedAutocomplete = _this$props5.autocomplete, currentAutoComplete = _this$props5.autoComplete, enctype = _this$props5.enctype, acceptcharset = _this$props5.acceptcharset, noHtml5Validate = _this$props5.noHtml5Validate, disabled = _this$props5.disabled, formContext = _this$props5.formContext;
                var _this$state2 = this.state, schema = _this$state2.schema, uiSchema = _this$state2.uiSchema, formData = _this$state2.formData, errorSchema = _this$state2.errorSchema, idSchema = _this$state2.idSchema;
                var registry = this.getRegistry();
                var _SchemaField = registry.fields.SchemaField;
                var FormTag = tagName ? tagName : "form";
                if (deprecatedAutocomplete) console.warn("Using autocomplete property of Form is deprecated, use autoComplete instead.");
                var autoComplete = currentAutoComplete ? currentAutoComplete : deprecatedAutocomplete;
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(FormTag, {
                    className: className ? className : "rjsf",
                    id: id,
                    name: name,
                    method: method,
                    target: target,
                    action: action,
                    autoComplete: autoComplete,
                    encType: enctype,
                    acceptCharset: acceptcharset,
                    noValidate: noHtml5Validate,
                    onSubmit: this.onSubmit,
                    ref: function ref(form) {
                        _this2.formElement = form;
                    }
                }, this.renderErrors(), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(_SchemaField, {
                    schema: schema,
                    uiSchema: uiSchema,
                    errorSchema: errorSchema,
                    idSchema: idSchema,
                    idPrefix: idPrefix,
                    formContext: formContext,
                    formData: formData,
                    onChange: this.onChange,
                    onBlur: this.onBlur,
                    onFocus: this.onFocus,
                    registry: registry,
                    disabled: disabled
                }), children ? children : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                    type: "submit",
                    className: "btn btn-info"
                }, "Submit")));
            }
        }
    ]);
    return Form;
}((0, $acw62.Component));
(0, $kB4x2.default)($9b2e32d222a420d9$export$2e2bcd8739ae039, "defaultProps", {
    uiSchema: {},
    noValidate: false,
    liveValidate: false,
    disabled: false,
    noHtml5Validate: false,
    ErrorList: (0, $kYVvO.default),
    omitExtraData: false
});

});
parcelRegister("k4zDq", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9cfd2b0e74c3906$export$2e2bcd8739ae039);

var $8lpxl = parcelRequire("8lpxl");

var $1HdKo = parcelRequire("1HdKo");

var $2pSGe = parcelRequire("2pSGe");

var $kB4x2 = parcelRequire("kB4x2");
function $e9cfd2b0e74c3906$export$2e2bcd8739ae039(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? Object(arguments[i]) : {};
        var ownKeys = (0, (/*@__PURE__*/$parcel$interopDefault($8lpxl)))(source);
        if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($1HdKo))) === "function") ownKeys.push.apply(ownKeys, (0, (/*@__PURE__*/$parcel$interopDefault($1HdKo)))(source).filter(function(sym) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($2pSGe)))(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $kB4x2.default)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("8lpxl", function(module, exports) {

module.exports = (parcelRequire("2tv0U"));

});
parcelRegister("2tv0U", function(module, exports) {
parcelRequire("aocrK");

module.exports = (parcelRequire("314Mo")).Object.keys;

});
parcelRegister("aocrK", function(module, exports) {
// 19.1.2.14 Object.keys(O)

var $jK6u7 = parcelRequire("jK6u7");

var $iGTn6 = parcelRequire("iGTn6");

(parcelRequire("9xran"))("keys", function() {
    return function keys(it) {
        return $iGTn6($jK6u7(it));
    };
});

});
parcelRegister("jK6u7", function(module, exports) {
// 7.1.13 ToObject(argument)

var $gXRFA = parcelRequire("gXRFA");
module.exports = function(it) {
    return Object($gXRFA(it));
};

});
parcelRegister("gXRFA", function(module, exports) {
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
};

});


parcelRegister("iGTn6", function(module, exports) {
// 19.1.2.14 / 15.2.3.14 Object.keys(O)

var $lbqci = parcelRequire("lbqci");

var $gkAZp = parcelRequire("gkAZp");
module.exports = Object.keys || function keys(O) {
    return $lbqci(O, $gkAZp);
};

});
parcelRegister("lbqci", function(module, exports) {

var $jPa5S = parcelRequire("jPa5S");

var $1nvjF = parcelRequire("1nvjF");

var $f6bef246b06234ee$var$arrayIndexOf = (parcelRequire("fBEhL"))(false);

var $f6bef246b06234ee$var$IE_PROTO = (parcelRequire("oswNj"))("IE_PROTO");
module.exports = function(object, names) {
    var O = $1nvjF(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)if (key != $f6bef246b06234ee$var$IE_PROTO) $jPa5S(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($jPa5S(O, key = names[i++])) ~$f6bef246b06234ee$var$arrayIndexOf(result, key) || result.push(key);
    return result;
};

});
parcelRegister("jPa5S", function(module, exports) {
var $e6ea9c24305d8764$var$hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key) {
    return $e6ea9c24305d8764$var$hasOwnProperty.call(it, key);
};

});

parcelRegister("1nvjF", function(module, exports) {
// to indexed object, toObject with fallback for non-array-like ES3 strings

var $39tBo = parcelRequire("39tBo");

var $gXRFA = parcelRequire("gXRFA");
module.exports = function(it) {
    return $39tBo($gXRFA(it));
};

});
parcelRegister("39tBo", function(module, exports) {
// fallback for non-array-like ES3 and non-enumerable old V8 strings

var $2aVBS = parcelRequire("2aVBS");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object("z").propertyIsEnumerable(0) ? Object : function(it) {
    return $2aVBS(it) == "String" ? it.split("") : Object(it);
};

});
parcelRegister("2aVBS", function(module, exports) {
var $1959340d24198299$var$toString = {}.toString;
module.exports = function(it) {
    return $1959340d24198299$var$toString.call(it).slice(8, -1);
};

});



parcelRegister("fBEhL", function(module, exports) {
// false -> Array#indexOf
// true  -> Array#includes

var $1nvjF = parcelRequire("1nvjF");

var $cqWYf = parcelRequire("cqWYf");

var $8i8IL = parcelRequire("8i8IL");
module.exports = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $1nvjF($this);
        var length = $cqWYf(O.length);
        var index = $8i8IL(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++)if (IS_INCLUDES || index in O) {
            if (O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};

});
parcelRegister("cqWYf", function(module, exports) {
// 7.1.15 ToLength

var $9tqXE = parcelRequire("9tqXE");
var $90d5a81e30c5df3f$var$min = Math.min;
module.exports = function(it) {
    return it > 0 ? $90d5a81e30c5df3f$var$min($9tqXE(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

});
parcelRegister("9tqXE", function(module, exports) {
// 7.1.4 ToInteger
var $6e5bbc6c77d52811$var$ceil = Math.ceil;
var $6e5bbc6c77d52811$var$floor = Math.floor;
module.exports = function(it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? $6e5bbc6c77d52811$var$floor : $6e5bbc6c77d52811$var$ceil)(it);
};

});


parcelRegister("8i8IL", function(module, exports) {

var $9tqXE = parcelRequire("9tqXE");
var $6096c4fbaefc3a22$var$max = Math.max;
var $6096c4fbaefc3a22$var$min = Math.min;
module.exports = function(index, length) {
    index = $9tqXE(index);
    return index < 0 ? $6096c4fbaefc3a22$var$max(index + length, 0) : $6096c4fbaefc3a22$var$min(index, length);
};

});


parcelRegister("oswNj", function(module, exports) {

var $04985f0f6f1ea062$var$shared = (parcelRequire("8KNRS"))("keys");

var $44PZr = parcelRequire("44PZr");
module.exports = function(key) {
    return $04985f0f6f1ea062$var$shared[key] || ($04985f0f6f1ea062$var$shared[key] = $44PZr(key));
};

});
parcelRegister("8KNRS", function(module, exports) {

var $314Mo = parcelRequire("314Mo");

var $llv21 = parcelRequire("llv21");
var $65f94d5e2d41a908$var$SHARED = "__core-js_shared__";
var $65f94d5e2d41a908$var$store = $llv21[$65f94d5e2d41a908$var$SHARED] || ($llv21[$65f94d5e2d41a908$var$SHARED] = {});

(module.exports = function(key, value) {
    return $65f94d5e2d41a908$var$store[key] || ($65f94d5e2d41a908$var$store[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: $314Mo.version,
    mode: (parcelRequire("dJ8Vu")) ? "pure" : "global",
    copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
});

});
parcelRegister("314Mo", function(module, exports) {
var $23252c346c2d4b2f$var$core = module.exports = {
    version: "2.6.12"
};
if (typeof __e == "number") __e = $23252c346c2d4b2f$var$core; // eslint-disable-line no-undef

});

parcelRegister("llv21", function(module, exports) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $f8a3a16212fbdfe6$var$global = module.exports = typeof window != "undefined" && window.Math == Math ? window : typeof self != "undefined" && self.Math == Math ? self : Function("return this")();
if (typeof __g == "number") __g = $f8a3a16212fbdfe6$var$global; // eslint-disable-line no-undef

});

parcelRegister("dJ8Vu", function(module, exports) {
module.exports = true;

});


parcelRegister("44PZr", function(module, exports) {
var $2f7fdd481f0e55cf$var$id = 0;
var $2f7fdd481f0e55cf$var$px = Math.random();
module.exports = function(key) {
    return "Symbol(".concat(key === undefined ? "" : key, ")_", (++$2f7fdd481f0e55cf$var$id + $2f7fdd481f0e55cf$var$px).toString(36));
};

});



parcelRegister("gkAZp", function(module, exports) {
// IE 8- don't enum bug keys
module.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");

});


parcelRegister("9xran", function(module, exports) {
// most Object methods by ES6 should accept primitives

var $kEXpx = parcelRequire("kEXpx");

var $314Mo = parcelRequire("314Mo");

var $g49ub = parcelRequire("g49ub");
module.exports = function(KEY, exec) {
    var fn = ($314Mo.Object || {})[KEY] || Object[KEY];
    var exp = {};
    exp[KEY] = exec(fn);
    $kEXpx($kEXpx.S + $kEXpx.F * $g49ub(function() {
        fn(1);
    }), "Object", exp);
};

});
parcelRegister("kEXpx", function(module, exports) {

var $llv21 = parcelRequire("llv21");

var $314Mo = parcelRequire("314Mo");

var $5iFqY = parcelRequire("5iFqY");

var $jSmLC = parcelRequire("jSmLC");

var $jPa5S = parcelRequire("jPa5S");
var $f0a5a0d39ea41415$var$PROTOTYPE = "prototype";
var $f0a5a0d39ea41415$var$$export = function(type, name, source) {
    var IS_FORCED = type & $f0a5a0d39ea41415$var$$export.F;
    var IS_GLOBAL = type & $f0a5a0d39ea41415$var$$export.G;
    var IS_STATIC = type & $f0a5a0d39ea41415$var$$export.S;
    var IS_PROTO = type & $f0a5a0d39ea41415$var$$export.P;
    var IS_BIND = type & $f0a5a0d39ea41415$var$$export.B;
    var IS_WRAP = type & $f0a5a0d39ea41415$var$$export.W;
    var exports = IS_GLOBAL ? $314Mo : $314Mo[name] || ($314Mo[name] = {});
    var expProto = exports[$f0a5a0d39ea41415$var$PROTOTYPE];
    var target = IS_GLOBAL ? $llv21 : IS_STATIC ? $llv21[name] : ($llv21[name] || {})[$f0a5a0d39ea41415$var$PROTOTYPE];
    var key, own, out;
    if (IS_GLOBAL) source = name;
    for(key in source){
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        if (own && $jPa5S(exports, key)) continue;
        // export native or passed
        out = own ? target[key] : source[key];
        // prevent global pollution for namespaces
        exports[key] = IS_GLOBAL && typeof target[key] != "function" ? source[key] : IS_BIND && own ? $5iFqY(out, $llv21) : IS_WRAP && target[key] == out ? function(C) {
            var F = function(a, b, c) {
                if (this instanceof C) {
                    switch(arguments.length){
                        case 0:
                            return new C();
                        case 1:
                            return new C(a);
                        case 2:
                            return new C(a, b);
                    }
                    return new C(a, b, c);
                }
                return C.apply(this, arguments);
            };
            F[$f0a5a0d39ea41415$var$PROTOTYPE] = C[$f0a5a0d39ea41415$var$PROTOTYPE];
            return F;
        // make static versions for prototype methods
        }(out) : IS_PROTO && typeof out == "function" ? $5iFqY(Function.call, out) : out;
        // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
        if (IS_PROTO) {
            (exports.virtual || (exports.virtual = {}))[key] = out;
            // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
            if (type & $f0a5a0d39ea41415$var$$export.R && expProto && !expProto[key]) $jSmLC(expProto, key, out);
        }
    }
};
// type bitmap
$f0a5a0d39ea41415$var$$export.F = 1; // forced
$f0a5a0d39ea41415$var$$export.G = 2; // global
$f0a5a0d39ea41415$var$$export.S = 4; // static
$f0a5a0d39ea41415$var$$export.P = 8; // proto
$f0a5a0d39ea41415$var$$export.B = 16; // bind
$f0a5a0d39ea41415$var$$export.W = 32; // wrap
$f0a5a0d39ea41415$var$$export.U = 64; // safe
$f0a5a0d39ea41415$var$$export.R = 128; // real proto method for `library`
module.exports = $f0a5a0d39ea41415$var$$export;

});
parcelRegister("5iFqY", function(module, exports) {
// optional / simple context binding

var $6ZyoG = parcelRequire("6ZyoG");
module.exports = function(fn, that, length) {
    $6ZyoG(fn);
    if (that === undefined) return fn;
    switch(length){
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};

});
parcelRegister("6ZyoG", function(module, exports) {
module.exports = function(it) {
    if (typeof it != "function") throw TypeError(it + " is not a function!");
    return it;
};

});


parcelRegister("jSmLC", function(module, exports) {

var $4aG98 = parcelRequire("4aG98");

var $yk0ka = parcelRequire("yk0ka");

module.exports = (parcelRequire("4G9qa")) ? function(object, key, value) {
    return $4aG98.f(object, key, $yk0ka(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("4aG98", function(module, exports) {

$parcel$export(module.exports, "f", () => $3098c9fb13959112$export$2d1720544b23b823, (v) => $3098c9fb13959112$export$2d1720544b23b823 = v);
var $3098c9fb13959112$export$2d1720544b23b823;

var $52hVC = parcelRequire("52hVC");

var $j0Zat = parcelRequire("j0Zat");

var $3UD4G = parcelRequire("3UD4G");
var $3098c9fb13959112$var$dP = Object.defineProperty;

$3098c9fb13959112$export$2d1720544b23b823 = (parcelRequire("4G9qa")) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    $52hVC(O);
    P = $3UD4G(P, true);
    $52hVC(Attributes);
    if ($j0Zat) try {
        return $3098c9fb13959112$var$dP(O, P, Attributes);
    } catch (e) {}
    if ("get" in Attributes || "set" in Attributes) throw TypeError("Accessors not supported!");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("52hVC", function(module, exports) {

var $6sMmO = parcelRequire("6sMmO");
module.exports = function(it) {
    if (!$6sMmO(it)) throw TypeError(it + " is not an object!");
    return it;
};

});
parcelRegister("6sMmO", function(module, exports) {
module.exports = function(it) {
    return typeof it === "object" ? it !== null : typeof it === "function";
};

});


parcelRegister("j0Zat", function(module, exports) {



module.exports = !(parcelRequire("4G9qa")) && !(parcelRequire("g49ub"))(function() {
    return Object.defineProperty((parcelRequire("11bWq"))("div"), "a", {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("4G9qa", function(module, exports) {
// Thank's IE8 for his funny defineProperty

module.exports = !(parcelRequire("g49ub"))(function() {
    return Object.defineProperty({}, "a", {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("g49ub", function(module, exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (e) {
        return true;
    }
};

});


parcelRegister("11bWq", function(module, exports) {

var $6sMmO = parcelRequire("6sMmO");

var $llv21 = parcelRequire("llv21");
var $0bdf25bce0769ede$require$document = $llv21.document;
// typeof document.createElement is 'object' in old IE
var $0bdf25bce0769ede$var$is = $6sMmO($0bdf25bce0769ede$require$document) && $6sMmO($0bdf25bce0769ede$require$document.createElement);
module.exports = function(it) {
    return $0bdf25bce0769ede$var$is ? $0bdf25bce0769ede$require$document.createElement(it) : {};
};

});


parcelRegister("3UD4G", function(module, exports) {
// 7.1.1 ToPrimitive(input [, PreferredType])

var $6sMmO = parcelRequire("6sMmO");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S) {
    if (!$6sMmO(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == "function" && !$6sMmO(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == "function" && !$6sMmO(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == "function" && !$6sMmO(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
};

});


parcelRegister("yk0ka", function(module, exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});







parcelRegister("1HdKo", function(module, exports) {

module.exports = (parcelRequire("48vy9"));

});
parcelRegister("48vy9", function(module, exports) {
parcelRequire("e42WA");

module.exports = (parcelRequire("314Mo")).Object.getOwnPropertySymbols;

});
parcelRegister("e42WA", function(module, exports) {
"use strict";

var $llv21 = parcelRequire("llv21");

var $jPa5S = parcelRequire("jPa5S");

var $4G9qa = parcelRequire("4G9qa");

var $kEXpx = parcelRequire("kEXpx");

var $bYQA7 = parcelRequire("bYQA7");

var $gS7kc = parcelRequire("gS7kc");
var $a3d3b8fe28b14b24$require$META = $gS7kc.KEY;

var $g49ub = parcelRequire("g49ub");

var $8KNRS = parcelRequire("8KNRS");

var $2l8lG = parcelRequire("2l8lG");

var $44PZr = parcelRequire("44PZr");

var $isDo7 = parcelRequire("isDo7");

var $195ps = parcelRequire("195ps");

var $7GCOB = parcelRequire("7GCOB");

var $jfgSp = parcelRequire("jfgSp");

var $dl4rN = parcelRequire("dl4rN");

var $52hVC = parcelRequire("52hVC");

var $6sMmO = parcelRequire("6sMmO");

var $jK6u7 = parcelRequire("jK6u7");

var $1nvjF = parcelRequire("1nvjF");

var $3UD4G = parcelRequire("3UD4G");

var $yk0ka = parcelRequire("yk0ka");

var $98yfN = parcelRequire("98yfN");

var $4LjFW = parcelRequire("4LjFW");

var $dMmZa = parcelRequire("dMmZa");

var $iLHFk = parcelRequire("iLHFk");

var $4aG98 = parcelRequire("4aG98");

var $iGTn6 = parcelRequire("iGTn6");
var $a3d3b8fe28b14b24$var$gOPD = $dMmZa.f;
var $a3d3b8fe28b14b24$var$dP = $4aG98.f;
var $a3d3b8fe28b14b24$var$gOPN = $4LjFW.f;
var $a3d3b8fe28b14b24$var$$Symbol = $llv21.Symbol;
var $a3d3b8fe28b14b24$var$$JSON = $llv21.JSON;
var $a3d3b8fe28b14b24$var$_stringify = $a3d3b8fe28b14b24$var$$JSON && $a3d3b8fe28b14b24$var$$JSON.stringify;
var $a3d3b8fe28b14b24$var$PROTOTYPE = "prototype";
var $a3d3b8fe28b14b24$var$HIDDEN = $isDo7("_hidden");
var $a3d3b8fe28b14b24$var$TO_PRIMITIVE = $isDo7("toPrimitive");
var $a3d3b8fe28b14b24$var$isEnum = {}.propertyIsEnumerable;
var $a3d3b8fe28b14b24$var$SymbolRegistry = $8KNRS("symbol-registry");
var $a3d3b8fe28b14b24$var$AllSymbols = $8KNRS("symbols");
var $a3d3b8fe28b14b24$var$OPSymbols = $8KNRS("op-symbols");
var $a3d3b8fe28b14b24$var$ObjectProto = Object[$a3d3b8fe28b14b24$var$PROTOTYPE];
var $a3d3b8fe28b14b24$var$USE_NATIVE = typeof $a3d3b8fe28b14b24$var$$Symbol == "function" && !!$iLHFk.f;
var $a3d3b8fe28b14b24$var$QObject = $llv21.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var $a3d3b8fe28b14b24$var$setter = !$a3d3b8fe28b14b24$var$QObject || !$a3d3b8fe28b14b24$var$QObject[$a3d3b8fe28b14b24$var$PROTOTYPE] || !$a3d3b8fe28b14b24$var$QObject[$a3d3b8fe28b14b24$var$PROTOTYPE].findChild;
// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var $a3d3b8fe28b14b24$var$setSymbolDesc = $4G9qa && $g49ub(function() {
    return $98yfN($a3d3b8fe28b14b24$var$dP({}, "a", {
        get: function() {
            return $a3d3b8fe28b14b24$var$dP(this, "a", {
                value: 7
            }).a;
        }
    })).a != 7;
}) ? function(it, key, D) {
    var protoDesc = $a3d3b8fe28b14b24$var$gOPD($a3d3b8fe28b14b24$var$ObjectProto, key);
    if (protoDesc) delete $a3d3b8fe28b14b24$var$ObjectProto[key];
    $a3d3b8fe28b14b24$var$dP(it, key, D);
    if (protoDesc && it !== $a3d3b8fe28b14b24$var$ObjectProto) $a3d3b8fe28b14b24$var$dP($a3d3b8fe28b14b24$var$ObjectProto, key, protoDesc);
} : $a3d3b8fe28b14b24$var$dP;
var $a3d3b8fe28b14b24$var$wrap = function(tag) {
    var sym = $a3d3b8fe28b14b24$var$AllSymbols[tag] = $98yfN($a3d3b8fe28b14b24$var$$Symbol[$a3d3b8fe28b14b24$var$PROTOTYPE]);
    sym._k = tag;
    return sym;
};
var $a3d3b8fe28b14b24$var$isSymbol = $a3d3b8fe28b14b24$var$USE_NATIVE && typeof $a3d3b8fe28b14b24$var$$Symbol.iterator == "symbol" ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    return it instanceof $a3d3b8fe28b14b24$var$$Symbol;
};
var $a3d3b8fe28b14b24$var$$defineProperty = function defineProperty(it, key, D) {
    if (it === $a3d3b8fe28b14b24$var$ObjectProto) $a3d3b8fe28b14b24$var$$defineProperty($a3d3b8fe28b14b24$var$OPSymbols, key, D);
    $52hVC(it);
    key = $3UD4G(key, true);
    $52hVC(D);
    if ($jPa5S($a3d3b8fe28b14b24$var$AllSymbols, key)) {
        if (!D.enumerable) {
            if (!$jPa5S(it, $a3d3b8fe28b14b24$var$HIDDEN)) $a3d3b8fe28b14b24$var$dP(it, $a3d3b8fe28b14b24$var$HIDDEN, $yk0ka(1, {}));
            it[$a3d3b8fe28b14b24$var$HIDDEN][key] = true;
        } else {
            if ($jPa5S(it, $a3d3b8fe28b14b24$var$HIDDEN) && it[$a3d3b8fe28b14b24$var$HIDDEN][key]) it[$a3d3b8fe28b14b24$var$HIDDEN][key] = false;
            D = $98yfN(D, {
                enumerable: $yk0ka(0, false)
            });
        }
        return $a3d3b8fe28b14b24$var$setSymbolDesc(it, key, D);
    }
    return $a3d3b8fe28b14b24$var$dP(it, key, D);
};
var $a3d3b8fe28b14b24$var$$defineProperties = function defineProperties(it, P) {
    $52hVC(it);
    var keys = $jfgSp(P = $1nvjF(P));
    var i = 0;
    var l = keys.length;
    var key;
    while(l > i)$a3d3b8fe28b14b24$var$$defineProperty(it, key = keys[i++], P[key]);
    return it;
};
var $a3d3b8fe28b14b24$var$$create = function create(it, P) {
    return P === undefined ? $98yfN(it) : $a3d3b8fe28b14b24$var$$defineProperties($98yfN(it), P);
};
var $a3d3b8fe28b14b24$var$$propertyIsEnumerable = function propertyIsEnumerable(key) {
    var E = $a3d3b8fe28b14b24$var$isEnum.call(this, key = $3UD4G(key, true));
    if (this === $a3d3b8fe28b14b24$var$ObjectProto && $jPa5S($a3d3b8fe28b14b24$var$AllSymbols, key) && !$jPa5S($a3d3b8fe28b14b24$var$OPSymbols, key)) return false;
    return E || !$jPa5S(this, key) || !$jPa5S($a3d3b8fe28b14b24$var$AllSymbols, key) || $jPa5S(this, $a3d3b8fe28b14b24$var$HIDDEN) && this[$a3d3b8fe28b14b24$var$HIDDEN][key] ? E : true;
};
var $a3d3b8fe28b14b24$var$$getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
    it = $1nvjF(it);
    key = $3UD4G(key, true);
    if (it === $a3d3b8fe28b14b24$var$ObjectProto && $jPa5S($a3d3b8fe28b14b24$var$AllSymbols, key) && !$jPa5S($a3d3b8fe28b14b24$var$OPSymbols, key)) return;
    var D = $a3d3b8fe28b14b24$var$gOPD(it, key);
    if (D && $jPa5S($a3d3b8fe28b14b24$var$AllSymbols, key) && !($jPa5S(it, $a3d3b8fe28b14b24$var$HIDDEN) && it[$a3d3b8fe28b14b24$var$HIDDEN][key])) D.enumerable = true;
    return D;
};
var $a3d3b8fe28b14b24$var$$getOwnPropertyNames = function getOwnPropertyNames(it) {
    var names = $a3d3b8fe28b14b24$var$gOPN($1nvjF(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if (!$jPa5S($a3d3b8fe28b14b24$var$AllSymbols, key = names[i++]) && key != $a3d3b8fe28b14b24$var$HIDDEN && key != $a3d3b8fe28b14b24$require$META) result.push(key);
    return result;
};
var $a3d3b8fe28b14b24$var$$getOwnPropertySymbols = function getOwnPropertySymbols(it) {
    var IS_OP = it === $a3d3b8fe28b14b24$var$ObjectProto;
    var names = $a3d3b8fe28b14b24$var$gOPN(IS_OP ? $a3d3b8fe28b14b24$var$OPSymbols : $1nvjF(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if ($jPa5S($a3d3b8fe28b14b24$var$AllSymbols, key = names[i++]) && (IS_OP ? $jPa5S($a3d3b8fe28b14b24$var$ObjectProto, key) : true)) result.push($a3d3b8fe28b14b24$var$AllSymbols[key]);
    return result;
};



// 19.4.1.1 Symbol([description])
if (!$a3d3b8fe28b14b24$var$USE_NATIVE) {
    $a3d3b8fe28b14b24$var$$Symbol = function Symbol() {
        if (this instanceof $a3d3b8fe28b14b24$var$$Symbol) throw TypeError("Symbol is not a constructor!");
        var tag = $44PZr(arguments.length > 0 ? arguments[0] : undefined);
        var $set = function(value) {
            if (this === $a3d3b8fe28b14b24$var$ObjectProto) $set.call($a3d3b8fe28b14b24$var$OPSymbols, value);
            if ($jPa5S(this, $a3d3b8fe28b14b24$var$HIDDEN) && $jPa5S(this[$a3d3b8fe28b14b24$var$HIDDEN], tag)) this[$a3d3b8fe28b14b24$var$HIDDEN][tag] = false;
            $a3d3b8fe28b14b24$var$setSymbolDesc(this, tag, $yk0ka(1, value));
        };
        if ($4G9qa && $a3d3b8fe28b14b24$var$setter) $a3d3b8fe28b14b24$var$setSymbolDesc($a3d3b8fe28b14b24$var$ObjectProto, tag, {
            configurable: true,
            set: $set
        });
        return $a3d3b8fe28b14b24$var$wrap(tag);
    };
    $bYQA7($a3d3b8fe28b14b24$var$$Symbol[$a3d3b8fe28b14b24$var$PROTOTYPE], "toString", function toString() {
        return this._k;
    });
    $dMmZa.f = $a3d3b8fe28b14b24$var$$getOwnPropertyDescriptor;
    $4aG98.f = $a3d3b8fe28b14b24$var$$defineProperty;
    (parcelRequire("38fDX")).f = $4LjFW.f = $a3d3b8fe28b14b24$var$$getOwnPropertyNames;
    (parcelRequire("kNK9k")).f = $a3d3b8fe28b14b24$var$$propertyIsEnumerable;
    $iLHFk.f = $a3d3b8fe28b14b24$var$$getOwnPropertySymbols;
    if ($4G9qa && !(parcelRequire("dJ8Vu"))) $bYQA7($a3d3b8fe28b14b24$var$ObjectProto, "propertyIsEnumerable", $a3d3b8fe28b14b24$var$$propertyIsEnumerable, true);
    $195ps.f = function(name) {
        return $a3d3b8fe28b14b24$var$wrap($isDo7(name));
    };
}
$kEXpx($kEXpx.G + $kEXpx.W + $kEXpx.F * !$a3d3b8fe28b14b24$var$USE_NATIVE, {
    Symbol: $a3d3b8fe28b14b24$var$$Symbol
});
for(var $a3d3b8fe28b14b24$var$es6Symbols = // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
"hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), $a3d3b8fe28b14b24$var$j = 0; $a3d3b8fe28b14b24$var$es6Symbols.length > $a3d3b8fe28b14b24$var$j;)$isDo7($a3d3b8fe28b14b24$var$es6Symbols[$a3d3b8fe28b14b24$var$j++]);
for(var $a3d3b8fe28b14b24$var$wellKnownSymbols = $iGTn6($isDo7.store), $a3d3b8fe28b14b24$var$k = 0; $a3d3b8fe28b14b24$var$wellKnownSymbols.length > $a3d3b8fe28b14b24$var$k;)$7GCOB($a3d3b8fe28b14b24$var$wellKnownSymbols[$a3d3b8fe28b14b24$var$k++]);
$kEXpx($kEXpx.S + $kEXpx.F * !$a3d3b8fe28b14b24$var$USE_NATIVE, "Symbol", {
    // 19.4.2.1 Symbol.for(key)
    "for": function(key) {
        return $jPa5S($a3d3b8fe28b14b24$var$SymbolRegistry, key += "") ? $a3d3b8fe28b14b24$var$SymbolRegistry[key] : $a3d3b8fe28b14b24$var$SymbolRegistry[key] = $a3d3b8fe28b14b24$var$$Symbol(key);
    },
    // 19.4.2.5 Symbol.keyFor(sym)
    keyFor: function keyFor(sym) {
        if (!$a3d3b8fe28b14b24$var$isSymbol(sym)) throw TypeError(sym + " is not a symbol!");
        for(var key in $a3d3b8fe28b14b24$var$SymbolRegistry)if ($a3d3b8fe28b14b24$var$SymbolRegistry[key] === sym) return key;
    },
    useSetter: function() {
        $a3d3b8fe28b14b24$var$setter = true;
    },
    useSimple: function() {
        $a3d3b8fe28b14b24$var$setter = false;
    }
});
$kEXpx($kEXpx.S + $kEXpx.F * !$a3d3b8fe28b14b24$var$USE_NATIVE, "Object", {
    // 19.1.2.2 Object.create(O [, Properties])
    create: $a3d3b8fe28b14b24$var$$create,
    // 19.1.2.4 Object.defineProperty(O, P, Attributes)
    defineProperty: $a3d3b8fe28b14b24$var$$defineProperty,
    // 19.1.2.3 Object.defineProperties(O, Properties)
    defineProperties: $a3d3b8fe28b14b24$var$$defineProperties,
    // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
    getOwnPropertyDescriptor: $a3d3b8fe28b14b24$var$$getOwnPropertyDescriptor,
    // 19.1.2.7 Object.getOwnPropertyNames(O)
    getOwnPropertyNames: $a3d3b8fe28b14b24$var$$getOwnPropertyNames,
    // 19.1.2.8 Object.getOwnPropertySymbols(O)
    getOwnPropertySymbols: $a3d3b8fe28b14b24$var$$getOwnPropertySymbols
});
// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var $a3d3b8fe28b14b24$var$FAILS_ON_PRIMITIVES = $g49ub(function() {
    $iLHFk.f(1);
});
$kEXpx($kEXpx.S + $kEXpx.F * $a3d3b8fe28b14b24$var$FAILS_ON_PRIMITIVES, "Object", {
    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
        return $iLHFk.f($jK6u7(it));
    }
});
// 24.3.2 JSON.stringify(value [, replacer [, space]])
$a3d3b8fe28b14b24$var$$JSON && $kEXpx($kEXpx.S + $kEXpx.F * (!$a3d3b8fe28b14b24$var$USE_NATIVE || $g49ub(function() {
    var S = $a3d3b8fe28b14b24$var$$Symbol();
    // MS Edge converts symbol values to JSON as {}
    // WebKit converts symbol values to JSON as null
    // V8 throws on boxed symbols
    return $a3d3b8fe28b14b24$var$_stringify([
        S
    ]) != "[null]" || $a3d3b8fe28b14b24$var$_stringify({
        a: S
    }) != "{}" || $a3d3b8fe28b14b24$var$_stringify(Object(S)) != "{}";
})), "JSON", {
    stringify: function stringify(it) {
        var args = [
            it
        ];
        var i = 1;
        var replacer, $replacer;
        while(arguments.length > i)args.push(arguments[i++]);
        $replacer = replacer = args[1];
        if (!$6sMmO(replacer) && it === undefined || $a3d3b8fe28b14b24$var$isSymbol(it)) return; // IE8 returns string on undefined
        if (!$dl4rN(replacer)) replacer = function(key, value) {
            if (typeof $replacer == "function") value = $replacer.call(this, key, value);
            if (!$a3d3b8fe28b14b24$var$isSymbol(value)) return value;
        };
        args[1] = replacer;
        return $a3d3b8fe28b14b24$var$_stringify.apply($a3d3b8fe28b14b24$var$$JSON, args);
    }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$a3d3b8fe28b14b24$var$$Symbol[$a3d3b8fe28b14b24$var$PROTOTYPE][$a3d3b8fe28b14b24$var$TO_PRIMITIVE] || (parcelRequire("jSmLC"))($a3d3b8fe28b14b24$var$$Symbol[$a3d3b8fe28b14b24$var$PROTOTYPE], $a3d3b8fe28b14b24$var$TO_PRIMITIVE, $a3d3b8fe28b14b24$var$$Symbol[$a3d3b8fe28b14b24$var$PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
$2l8lG($a3d3b8fe28b14b24$var$$Symbol, "Symbol");
// 20.2.1.9 Math[@@toStringTag]
$2l8lG(Math, "Math", true);
// 24.3.3 JSON[@@toStringTag]
$2l8lG($llv21.JSON, "JSON", true);

});
parcelRegister("bYQA7", function(module, exports) {

module.exports = (parcelRequire("jSmLC"));

});

parcelRegister("gS7kc", function(module, exports) {

var $c4875f08aaad2608$var$META = (parcelRequire("44PZr"))("meta");

var $6sMmO = parcelRequire("6sMmO");

var $jPa5S = parcelRequire("jPa5S");

var $4aG98 = parcelRequire("4aG98");
var $c4875f08aaad2608$require$setDesc = $4aG98.f;
var $c4875f08aaad2608$var$id = 0;
var $c4875f08aaad2608$var$isExtensible = Object.isExtensible || function() {
    return true;
};

var $c4875f08aaad2608$var$FREEZE = !(parcelRequire("g49ub"))(function() {
    return $c4875f08aaad2608$var$isExtensible(Object.preventExtensions({}));
});
var $c4875f08aaad2608$var$setMeta = function(it) {
    $c4875f08aaad2608$require$setDesc(it, $c4875f08aaad2608$var$META, {
        value: {
            i: "O" + ++$c4875f08aaad2608$var$id,
            w: {} // weak collections IDs
        }
    });
};
var $c4875f08aaad2608$var$fastKey = function(it, create) {
    // return primitive with prefix
    if (!$6sMmO(it)) return typeof it == "symbol" ? it : (typeof it == "string" ? "S" : "P") + it;
    if (!$jPa5S(it, $c4875f08aaad2608$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$c4875f08aaad2608$var$isExtensible(it)) return "F";
        // not necessary to add metadata
        if (!create) return "E";
        // add missing metadata
        $c4875f08aaad2608$var$setMeta(it);
    // return object ID
    }
    return it[$c4875f08aaad2608$var$META].i;
};
var $c4875f08aaad2608$var$getWeak = function(it, create) {
    if (!$jPa5S(it, $c4875f08aaad2608$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$c4875f08aaad2608$var$isExtensible(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $c4875f08aaad2608$var$setMeta(it);
    // return hash weak collections IDs
    }
    return it[$c4875f08aaad2608$var$META].w;
};
// add metadata on freeze-family methods calling
var $c4875f08aaad2608$var$onFreeze = function(it) {
    if ($c4875f08aaad2608$var$FREEZE && $c4875f08aaad2608$var$meta.NEED && $c4875f08aaad2608$var$isExtensible(it) && !$jPa5S(it, $c4875f08aaad2608$var$META)) $c4875f08aaad2608$var$setMeta(it);
    return it;
};
var $c4875f08aaad2608$var$meta = module.exports = {
    KEY: $c4875f08aaad2608$var$META,
    NEED: false,
    fastKey: $c4875f08aaad2608$var$fastKey,
    getWeak: $c4875f08aaad2608$var$getWeak,
    onFreeze: $c4875f08aaad2608$var$onFreeze
};

});

parcelRegister("2l8lG", function(module, exports) {

var $4aG98 = parcelRequire("4aG98");
var $1b4404d4cc053e24$require$def = $4aG98.f;

var $jPa5S = parcelRequire("jPa5S");

var $1b4404d4cc053e24$var$TAG = (parcelRequire("isDo7"))("toStringTag");
module.exports = function(it, tag, stat) {
    if (it && !$jPa5S(it = stat ? it : it.prototype, $1b4404d4cc053e24$var$TAG)) $1b4404d4cc053e24$require$def(it, $1b4404d4cc053e24$var$TAG, {
        configurable: true,
        value: tag
    });
};

});
parcelRegister("isDo7", function(module, exports) {

var $d70965284b264315$var$store = (parcelRequire("8KNRS"))("wks");

var $44PZr = parcelRequire("44PZr");

var $llv21 = parcelRequire("llv21");
var $d70965284b264315$require$Symbol = $llv21.Symbol;
var $d70965284b264315$var$USE_SYMBOL = typeof $d70965284b264315$require$Symbol == "function";
var $d70965284b264315$var$$exports = module.exports = function(name) {
    return $d70965284b264315$var$store[name] || ($d70965284b264315$var$store[name] = $d70965284b264315$var$USE_SYMBOL && $d70965284b264315$require$Symbol[name] || ($d70965284b264315$var$USE_SYMBOL ? $d70965284b264315$require$Symbol : $44PZr)("Symbol." + name));
};
$d70965284b264315$var$$exports.store = $d70965284b264315$var$store;

});


parcelRegister("195ps", function(module, exports) {

$parcel$export(module.exports, "f", () => $0d5ad3f0f9a951bc$export$2d1720544b23b823, (v) => $0d5ad3f0f9a951bc$export$2d1720544b23b823 = v);
var $0d5ad3f0f9a951bc$export$2d1720544b23b823;

$0d5ad3f0f9a951bc$export$2d1720544b23b823 = (parcelRequire("isDo7"));

});

parcelRegister("7GCOB", function(module, exports) {

var $llv21 = parcelRequire("llv21");

var $314Mo = parcelRequire("314Mo");

var $dJ8Vu = parcelRequire("dJ8Vu");

var $195ps = parcelRequire("195ps");

var $4aG98 = parcelRequire("4aG98");
var $598a908ad3292b44$require$defineProperty = $4aG98.f;
module.exports = function(name) {
    var $Symbol = $314Mo.Symbol || ($314Mo.Symbol = $dJ8Vu ? {} : $llv21.Symbol || {});
    if (name.charAt(0) != "_" && !(name in $Symbol)) $598a908ad3292b44$require$defineProperty($Symbol, name, {
        value: $195ps.f(name)
    });
};

});

parcelRegister("jfgSp", function(module, exports) {
// all enumerable object keys, includes symbols

var $iGTn6 = parcelRequire("iGTn6");

var $iLHFk = parcelRequire("iLHFk");

var $kNK9k = parcelRequire("kNK9k");
module.exports = function(it) {
    var result = $iGTn6(it);
    var getSymbols = $iLHFk.f;
    if (getSymbols) {
        var symbols = getSymbols(it);
        var isEnum = $kNK9k.f;
        var i = 0;
        var key;
        while(symbols.length > i)if (isEnum.call(it, key = symbols[i++])) result.push(key);
    }
    return result;
};

});
parcelRegister("iLHFk", function(module, exports) {

$parcel$export(module.exports, "f", () => $0386af6ef7fca3e5$export$2d1720544b23b823, (v) => $0386af6ef7fca3e5$export$2d1720544b23b823 = v);
var $0386af6ef7fca3e5$export$2d1720544b23b823;
$0386af6ef7fca3e5$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});

parcelRegister("kNK9k", function(module, exports) {

$parcel$export(module.exports, "f", () => $f24c2e8eacbce5d2$export$2d1720544b23b823, (v) => $f24c2e8eacbce5d2$export$2d1720544b23b823 = v);
var $f24c2e8eacbce5d2$export$2d1720544b23b823;
$f24c2e8eacbce5d2$export$2d1720544b23b823 = ({}).propertyIsEnumerable;

});


parcelRegister("dl4rN", function(module, exports) {
// 7.2.2 IsArray(argument)

var $2aVBS = parcelRequire("2aVBS");
module.exports = Array.isArray || function isArray(arg) {
    return $2aVBS(arg) == "Array";
};

});

parcelRegister("98yfN", function(module, exports) {
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])

var $52hVC = parcelRequire("52hVC");

var $b12V2 = parcelRequire("b12V2");

var $gkAZp = parcelRequire("gkAZp");

var $6a6f6e836154ff00$var$IE_PROTO = (parcelRequire("oswNj"))("IE_PROTO");
var $6a6f6e836154ff00$var$Empty = function() {};
var $6a6f6e836154ff00$var$PROTOTYPE = "prototype";


// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $6a6f6e836154ff00$var$createDict = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = (parcelRequire("11bWq"))("iframe");
    var i = $gkAZp.length;
    var lt = "<";
    var gt = ">";
    var iframeDocument;
    iframe.style.display = "none";
    (parcelRequire("03zCw")).appendChild(iframe);
    iframe.src = "javascript:"; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + "script" + gt + "document.F=Object" + lt + "/script" + gt);
    iframeDocument.close();
    $6a6f6e836154ff00$var$createDict = iframeDocument.F;
    while(i--)delete $6a6f6e836154ff00$var$createDict[$6a6f6e836154ff00$var$PROTOTYPE][$gkAZp[i]];
    return $6a6f6e836154ff00$var$createDict();
};
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $6a6f6e836154ff00$var$Empty[$6a6f6e836154ff00$var$PROTOTYPE] = $52hVC(O);
        result = new $6a6f6e836154ff00$var$Empty();
        $6a6f6e836154ff00$var$Empty[$6a6f6e836154ff00$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$6a6f6e836154ff00$var$IE_PROTO] = O;
    } else result = $6a6f6e836154ff00$var$createDict();
    return Properties === undefined ? result : $b12V2(result, Properties);
};

});
parcelRegister("b12V2", function(module, exports) {

var $4aG98 = parcelRequire("4aG98");

var $52hVC = parcelRequire("52hVC");

var $iGTn6 = parcelRequire("iGTn6");

module.exports = (parcelRequire("4G9qa")) ? Object.defineProperties : function defineProperties(O, Properties) {
    $52hVC(O);
    var keys = $iGTn6(Properties);
    var length = keys.length;
    var i = 0;
    var P;
    while(length > i)$4aG98.f(O, P = keys[i++], Properties[P]);
    return O;
};

});

parcelRegister("03zCw", function(module, exports) {

var $llv21 = parcelRequire("llv21");
var $00abe95db1db8216$require$document = $llv21.document;
module.exports = $00abe95db1db8216$require$document && $00abe95db1db8216$require$document.documentElement;

});


parcelRegister("4LjFW", function(module, exports) {

$parcel$export(module.exports, "f", () => $377ad058b38dc2d9$export$2d1720544b23b823, (v) => $377ad058b38dc2d9$export$2d1720544b23b823 = v);
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var $377ad058b38dc2d9$export$2d1720544b23b823;

var $1nvjF = parcelRequire("1nvjF");

var $38fDX = parcelRequire("38fDX");
var $377ad058b38dc2d9$require$gOPN = $38fDX.f;
var $377ad058b38dc2d9$var$toString = {}.toString;
var $377ad058b38dc2d9$var$windowNames = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $377ad058b38dc2d9$var$getWindowNames = function(it) {
    try {
        return $377ad058b38dc2d9$require$gOPN(it);
    } catch (e) {
        return $377ad058b38dc2d9$var$windowNames.slice();
    }
};
$377ad058b38dc2d9$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
    return $377ad058b38dc2d9$var$windowNames && $377ad058b38dc2d9$var$toString.call(it) == "[object Window]" ? $377ad058b38dc2d9$var$getWindowNames(it) : $377ad058b38dc2d9$require$gOPN($1nvjF(it));
};

});
parcelRegister("38fDX", function(module, exports) {

$parcel$export(module.exports, "f", () => $247e40e917b4af39$export$2d1720544b23b823, (v) => $247e40e917b4af39$export$2d1720544b23b823 = v);
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $247e40e917b4af39$export$2d1720544b23b823;

var $lbqci = parcelRequire("lbqci");

var $247e40e917b4af39$var$hiddenKeys = (parcelRequire("gkAZp")).concat("length", "prototype");
$247e40e917b4af39$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $lbqci(O, $247e40e917b4af39$var$hiddenKeys);
};

});


parcelRegister("dMmZa", function(module, exports) {

$parcel$export(module.exports, "f", () => $a0819681fa23508c$export$2d1720544b23b823, (v) => $a0819681fa23508c$export$2d1720544b23b823 = v);
var $a0819681fa23508c$export$2d1720544b23b823;

var $kNK9k = parcelRequire("kNK9k");

var $yk0ka = parcelRequire("yk0ka");

var $1nvjF = parcelRequire("1nvjF");

var $3UD4G = parcelRequire("3UD4G");

var $jPa5S = parcelRequire("jPa5S");

var $j0Zat = parcelRequire("j0Zat");
var $a0819681fa23508c$var$gOPD = Object.getOwnPropertyDescriptor;

$a0819681fa23508c$export$2d1720544b23b823 = (parcelRequire("4G9qa")) ? $a0819681fa23508c$var$gOPD : function getOwnPropertyDescriptor(O, P) {
    O = $1nvjF(O);
    P = $3UD4G(P, true);
    if ($j0Zat) try {
        return $a0819681fa23508c$var$gOPD(O, P);
    } catch (e) {}
    if ($jPa5S(O, P)) return $yk0ka(!$kNK9k.f.call(O, P), O[P]);
};

});




parcelRegister("2pSGe", function(module, exports) {

module.exports = (parcelRequire("c06ww"));

});
parcelRegister("c06ww", function(module, exports) {
parcelRequire("W1Jux");

var $314Mo = parcelRequire("314Mo");
var $8bca8b89c3f12f74$require$$Object = $314Mo.Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
    return $8bca8b89c3f12f74$require$$Object.getOwnPropertyDescriptor(it, key);
};

});
parcelRegister("W1Jux", function(module, exports) {
// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)

var $1nvjF = parcelRequire("1nvjF");

var $dMmZa = parcelRequire("dMmZa");
var $0ae6c2fab57690bc$require$$getOwnPropertyDescriptor = $dMmZa.f;

(parcelRequire("9xran"))("getOwnPropertyDescriptor", function() {
    return function getOwnPropertyDescriptor(it, key) {
        return $0ae6c2fab57690bc$require$$getOwnPropertyDescriptor($1nvjF(it), key);
    };
});

});



parcelRegister("kB4x2", function(module, exports) {

$parcel$export(module.exports, "default", () => $efeac7468956f939$export$2e2bcd8739ae039);

var $cYBgI = parcelRequire("cYBgI");
function $efeac7468956f939$export$2e2bcd8739ae039(obj, key, value) {
    if (key in obj) (0, (/*@__PURE__*/$parcel$interopDefault($cYBgI)))(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});
parcelRegister("cYBgI", function(module, exports) {

module.exports = (parcelRequire("aDzng"));

});
parcelRegister("aDzng", function(module, exports) {
parcelRequire("6pOjX");

var $314Mo = parcelRequire("314Mo");
var $7be8fc7ec53378a2$require$$Object = $314Mo.Object;
module.exports = function defineProperty(it, key, desc) {
    return $7be8fc7ec53378a2$require$$Object.defineProperty(it, key, desc);
};

});
parcelRegister("6pOjX", function(module, exports) {

var $kEXpx = parcelRequire("kEXpx");


// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$kEXpx($kEXpx.S + $kEXpx.F * !(parcelRequire("4G9qa")), "Object", {
    defineProperty: (parcelRequire("4aG98")).f
});

});





parcelRegister("a5du3", function(module, exports) {

module.exports = (parcelRequire("fYjgz"));

});
parcelRegister("fYjgz", function(module, exports) {
parcelRequire("43vxf");

module.exports = (parcelRequire("314Mo")).Array.isArray;

});
parcelRegister("43vxf", function(module, exports) {
// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)

var $kEXpx = parcelRequire("kEXpx");

$kEXpx($kEXpx.S, "Array", {
    isArray: (parcelRequire("dl4rN"))
});

});



parcelRegister("cD46i", function(module, exports) {

$parcel$export(module.exports, "default", () => $931c4eda4cdbabc4$export$2e2bcd8739ae039);

var $ePChe = parcelRequire("ePChe");

var $fjvI1 = parcelRequire("fjvI1");
function $931c4eda4cdbabc4$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($ePChe))) === "function" && typeof (0, (/*@__PURE__*/$parcel$interopDefault($fjvI1))) === "symbol") $931c4eda4cdbabc4$export$2e2bcd8739ae039 = function _typeof(obj) {
        return typeof obj;
    };
    else $931c4eda4cdbabc4$export$2e2bcd8739ae039 = function _typeof(obj) {
        return obj && typeof (0, (/*@__PURE__*/$parcel$interopDefault($ePChe))) === "function" && obj.constructor === (0, (/*@__PURE__*/$parcel$interopDefault($ePChe))) && obj !== (0, (/*@__PURE__*/$parcel$interopDefault($ePChe))).prototype ? "symbol" : typeof obj;
    };
    return $931c4eda4cdbabc4$export$2e2bcd8739ae039(obj);
}

});
parcelRegister("ePChe", function(module, exports) {

module.exports = (parcelRequire("7L0iI"));

});
parcelRegister("7L0iI", function(module, exports) {
parcelRequire("e42WA");
parcelRequire("6JkF2");
parcelRequire("eQ5SU");
parcelRequire("8xMnq");

module.exports = (parcelRequire("314Mo")).Symbol;

});
parcelRegister("6JkF2", function(module, exports) {

});

parcelRegister("eQ5SU", function(module, exports) {

(parcelRequire("7GCOB"))("asyncIterator");

});

parcelRegister("8xMnq", function(module, exports) {

(parcelRequire("7GCOB"))("observable");

});



parcelRegister("fjvI1", function(module, exports) {

module.exports = (parcelRequire("h3TAy"));

});
parcelRegister("h3TAy", function(module, exports) {
parcelRequire("kPnXr");
parcelRequire("hfW11");

module.exports = (parcelRequire("195ps")).f("iterator");

});
parcelRegister("kPnXr", function(module, exports) {
"use strict";

var $f29b278eaa32791a$var$$at = (parcelRequire("3CfVU"))(true);

// 21.1.3.27 String.prototype[@@iterator]()
(parcelRequire("kb1OX"))(String, "String", function(iterated) {
    this._t = String(iterated); // target
    this._i = 0; // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var index = this._i;
    var point;
    if (index >= O.length) return {
        value: undefined,
        done: true
    };
    point = $f29b278eaa32791a$var$$at(O, index);
    this._i += point.length;
    return {
        value: point,
        done: false
    };
});

});
parcelRegister("3CfVU", function(module, exports) {

var $9tqXE = parcelRequire("9tqXE");

var $gXRFA = parcelRequire("gXRFA");
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING) {
    return function(that, pos) {
        var s = String($gXRFA(that));
        var i = $9tqXE(pos);
        var l = s.length;
        var a, b;
        if (i < 0 || i >= l) return TO_STRING ? "" : undefined;
        a = s.charCodeAt(i);
        return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
    };
};

});

parcelRegister("kb1OX", function(module, exports) {
"use strict";

var $dJ8Vu = parcelRequire("dJ8Vu");

var $kEXpx = parcelRequire("kEXpx");

var $bYQA7 = parcelRequire("bYQA7");

var $jSmLC = parcelRequire("jSmLC");

var $gVXUH = parcelRequire("gVXUH");

var $jbtlG = parcelRequire("jbtlG");

var $2l8lG = parcelRequire("2l8lG");

var $8qEfL = parcelRequire("8qEfL");

var $eb063f51c69fbf52$var$ITERATOR = (parcelRequire("isDo7"))("iterator");
var $eb063f51c69fbf52$var$BUGGY = !([].keys && "next" in [].keys()); // Safari has buggy iterators w/o `next`
var $eb063f51c69fbf52$var$FF_ITERATOR = "@@iterator";
var $eb063f51c69fbf52$var$KEYS = "keys";
var $eb063f51c69fbf52$var$VALUES = "values";
var $eb063f51c69fbf52$var$returnThis = function() {
    return this;
};
module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
    $jbtlG(Constructor, NAME, next);
    var getMethod = function(kind) {
        if (!$eb063f51c69fbf52$var$BUGGY && kind in proto) return proto[kind];
        switch(kind){
            case $eb063f51c69fbf52$var$KEYS:
                return function keys() {
                    return new Constructor(this, kind);
                };
            case $eb063f51c69fbf52$var$VALUES:
                return function values() {
                    return new Constructor(this, kind);
                };
        }
        return function entries() {
            return new Constructor(this, kind);
        };
    };
    var TAG = NAME + " Iterator";
    var DEF_VALUES = DEFAULT == $eb063f51c69fbf52$var$VALUES;
    var VALUES_BUG = false;
    var proto = Base.prototype;
    var $native = proto[$eb063f51c69fbf52$var$ITERATOR] || proto[$eb063f51c69fbf52$var$FF_ITERATOR] || DEFAULT && proto[DEFAULT];
    var $default = $native || getMethod(DEFAULT);
    var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod("entries") : undefined;
    var $anyNative = NAME == "Array" ? proto.entries || $native : $native;
    var methods, key, IteratorPrototype;
    // Fix native
    if ($anyNative) {
        IteratorPrototype = $8qEfL($anyNative.call(new Base()));
        if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
            // Set @@toStringTag to native iterators
            $2l8lG(IteratorPrototype, TAG, true);
            // fix for some old engines
            if (!$dJ8Vu && typeof IteratorPrototype[$eb063f51c69fbf52$var$ITERATOR] != "function") $jSmLC(IteratorPrototype, $eb063f51c69fbf52$var$ITERATOR, $eb063f51c69fbf52$var$returnThis);
        }
    }
    // fix Array#{values, @@iterator}.name in V8 / FF
    if (DEF_VALUES && $native && $native.name !== $eb063f51c69fbf52$var$VALUES) {
        VALUES_BUG = true;
        $default = function values() {
            return $native.call(this);
        };
    }
    // Define iterator
    if ((!$dJ8Vu || FORCED) && ($eb063f51c69fbf52$var$BUGGY || VALUES_BUG || !proto[$eb063f51c69fbf52$var$ITERATOR])) $jSmLC(proto, $eb063f51c69fbf52$var$ITERATOR, $default);
    // Plug for library
    $gVXUH[NAME] = $default;
    $gVXUH[TAG] = $eb063f51c69fbf52$var$returnThis;
    if (DEFAULT) {
        methods = {
            values: DEF_VALUES ? $default : getMethod($eb063f51c69fbf52$var$VALUES),
            keys: IS_SET ? $default : getMethod($eb063f51c69fbf52$var$KEYS),
            entries: $entries
        };
        if (FORCED) {
            for(key in methods)if (!(key in proto)) $bYQA7(proto, key, methods[key]);
        } else $kEXpx($kEXpx.P + $kEXpx.F * ($eb063f51c69fbf52$var$BUGGY || VALUES_BUG), NAME, methods);
    }
    return methods;
};

});
parcelRegister("gVXUH", function(module, exports) {
module.exports = {};

});

parcelRegister("jbtlG", function(module, exports) {
"use strict";

var $98yfN = parcelRequire("98yfN");

var $yk0ka = parcelRequire("yk0ka");

var $2l8lG = parcelRequire("2l8lG");
var $df75cf764951d7a1$var$IteratorPrototype = {};


// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
(parcelRequire("jSmLC"))($df75cf764951d7a1$var$IteratorPrototype, (parcelRequire("isDo7"))("iterator"), function() {
    return this;
});
module.exports = function(Constructor, NAME, next) {
    Constructor.prototype = $98yfN($df75cf764951d7a1$var$IteratorPrototype, {
        next: $yk0ka(1, next)
    });
    $2l8lG(Constructor, NAME + " Iterator");
};

});

parcelRegister("8qEfL", function(module, exports) {
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)

var $jPa5S = parcelRequire("jPa5S");

var $jK6u7 = parcelRequire("jK6u7");

var $622ff9e4ace64561$var$IE_PROTO = (parcelRequire("oswNj"))("IE_PROTO");
var $622ff9e4ace64561$var$ObjectProto = Object.prototype;
module.exports = Object.getPrototypeOf || function(O) {
    O = $jK6u7(O);
    if ($jPa5S(O, $622ff9e4ace64561$var$IE_PROTO)) return O[$622ff9e4ace64561$var$IE_PROTO];
    if (typeof O.constructor == "function" && O instanceof O.constructor) return O.constructor.prototype;
    return O instanceof Object ? $622ff9e4ace64561$var$ObjectProto : null;
};

});



parcelRegister("hfW11", function(module, exports) {
parcelRequire("8f5o5");

var $llv21 = parcelRequire("llv21");

var $jSmLC = parcelRequire("jSmLC");

var $gVXUH = parcelRequire("gVXUH");

var $c900d70fe3226e30$var$TO_STRING_TAG = (parcelRequire("isDo7"))("toStringTag");
var $c900d70fe3226e30$var$DOMIterables = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(",");
for(var $c900d70fe3226e30$var$i = 0; $c900d70fe3226e30$var$i < $c900d70fe3226e30$var$DOMIterables.length; $c900d70fe3226e30$var$i++){
    var $c900d70fe3226e30$var$NAME = $c900d70fe3226e30$var$DOMIterables[$c900d70fe3226e30$var$i];
    var $c900d70fe3226e30$var$Collection = $llv21[$c900d70fe3226e30$var$NAME];
    var $c900d70fe3226e30$var$proto = $c900d70fe3226e30$var$Collection && $c900d70fe3226e30$var$Collection.prototype;
    if ($c900d70fe3226e30$var$proto && !$c900d70fe3226e30$var$proto[$c900d70fe3226e30$var$TO_STRING_TAG]) $jSmLC($c900d70fe3226e30$var$proto, $c900d70fe3226e30$var$TO_STRING_TAG, $c900d70fe3226e30$var$NAME);
    $gVXUH[$c900d70fe3226e30$var$NAME] = $gVXUH.Array;
}

});
parcelRegister("8f5o5", function(module, exports) {
"use strict";

var $gPMhp = parcelRequire("gPMhp");

var $8v1Yx = parcelRequire("8v1Yx");

var $gVXUH = parcelRequire("gVXUH");

var $1nvjF = parcelRequire("1nvjF");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = (parcelRequire("kb1OX"))(Array, "Array", function(iterated, kind) {
    this._t = $1nvjF(iterated); // target
    this._i = 0; // next index
    this._k = kind; // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var kind = this._k;
    var index = this._i++;
    if (!O || index >= O.length) {
        this._t = undefined;
        return $8v1Yx(1);
    }
    if (kind == "keys") return $8v1Yx(0, index);
    if (kind == "values") return $8v1Yx(0, O[index]);
    return $8v1Yx(0, [
        index,
        O[index]
    ]);
}, "values");
// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
$gVXUH.Arguments = $gVXUH.Array;
$gPMhp("keys");
$gPMhp("values");
$gPMhp("entries");

});
parcelRegister("gPMhp", function(module, exports) {
module.exports = function() {};

});

parcelRegister("8v1Yx", function(module, exports) {
module.exports = function(done, value) {
    return {
        value: value,
        done: !!done
    };
};

});






parcelRegister("7PwEf", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b369f0d4de78f1a$export$2e2bcd8739ae039);
function $5b369f0d4de78f1a$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("4tWkZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $34371f755ac0a562$export$2e2bcd8739ae039);

var $cYBgI = parcelRequire("cYBgI");
function $34371f755ac0a562$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($cYBgI)))(target, descriptor.key, descriptor);
    }
}
function $34371f755ac0a562$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $34371f755ac0a562$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $34371f755ac0a562$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("eBH73", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa25f6ad743cf379$export$2e2bcd8739ae039);

var $lmfIF = parcelRequire("lmfIF");

var $hl9R1 = parcelRequire("hl9R1");
function $aa25f6ad743cf379$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, (/*@__PURE__*/$parcel$interopDefault($lmfIF)))(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $hl9R1.default)(self);
}

});
parcelRegister("lmfIF", function(module, exports) {

var $ePChe = parcelRequire("ePChe");

var $fjvI1 = parcelRequire("fjvI1");
function $f8c7d893554e4041$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof $ePChe === "function" && typeof $fjvI1 === "symbol") {
        module.exports = $f8c7d893554e4041$var$_typeof = function _typeof(obj) {
            return typeof obj;
        };
        module.exports["default"] = module.exports, module.exports.__esModule = true;
    } else {
        module.exports = $f8c7d893554e4041$var$_typeof = function _typeof(obj) {
            return obj && typeof $ePChe === "function" && obj.constructor === $ePChe && obj !== $ePChe.prototype ? "symbol" : typeof obj;
        };
        module.exports["default"] = module.exports, module.exports.__esModule = true;
    }
    return $f8c7d893554e4041$var$_typeof(obj);
}
module.exports = $f8c7d893554e4041$var$_typeof;
module.exports["default"] = module.exports, module.exports.__esModule = true;

});

parcelRegister("hl9R1", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9fc0aa7b1a2005a$export$2e2bcd8739ae039);
function $c9fc0aa7b1a2005a$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});


parcelRegister("ctnWZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $914ac5878b7a1eb1$export$2e2bcd8739ae039);

var $cerK7 = parcelRequire("cerK7");

var $bAGlL = parcelRequire("bAGlL");
function $914ac5878b7a1eb1$export$2e2bcd8739ae039(o) {
    $914ac5878b7a1eb1$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($cerK7))) ? (0, (/*@__PURE__*/$parcel$interopDefault($bAGlL))) : function _getPrototypeOf(o) {
        return o.__proto__ || (0, (/*@__PURE__*/$parcel$interopDefault($bAGlL)))(o);
    };
    return $914ac5878b7a1eb1$export$2e2bcd8739ae039(o);
}

});
parcelRegister("cerK7", function(module, exports) {

module.exports = (parcelRequire("bhf1n"));

});
parcelRegister("bhf1n", function(module, exports) {
parcelRequire("5axVV");

module.exports = (parcelRequire("314Mo")).Object.setPrototypeOf;

});
parcelRegister("5axVV", function(module, exports) {
// 19.1.3.19 Object.setPrototypeOf(O, proto)

var $kEXpx = parcelRequire("kEXpx");

$kEXpx($kEXpx.S, "Object", {
    setPrototypeOf: (parcelRequire("4DZaQ")).set
});

});
parcelRegister("4DZaQ", function(module, exports) {
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */ 
var $6sMmO = parcelRequire("6sMmO");

var $52hVC = parcelRequire("52hVC");
var $361a41cc88c0d1aa$var$check = function(O, proto) {
    $52hVC(O);
    if (!$6sMmO(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};


module.exports = {
    set: Object.setPrototypeOf || ("__proto__" in {} ? function(test, buggy, set) {
        try {
            set = (parcelRequire("5iFqY"))(Function.call, (parcelRequire("dMmZa")).f(Object.prototype, "__proto__").set, 2);
            set(test, []);
            buggy = !(test instanceof Array);
        } catch (e) {
            buggy = true;
        }
        return function setPrototypeOf(O, proto) {
            $361a41cc88c0d1aa$var$check(O, proto);
            if (buggy) O.__proto__ = proto;
            else set(O, proto);
            return O;
        };
    }({}, false) : undefined),
    check: $361a41cc88c0d1aa$var$check
};

});




parcelRegister("bAGlL", function(module, exports) {

module.exports = (parcelRequire("3tIQg"));

});
parcelRegister("3tIQg", function(module, exports) {
parcelRequire("5Bcpo");

module.exports = (parcelRequire("314Mo")).Object.getPrototypeOf;

});
parcelRegister("5Bcpo", function(module, exports) {
// 19.1.2.9 Object.getPrototypeOf(O)

var $jK6u7 = parcelRequire("jK6u7");

var $8qEfL = parcelRequire("8qEfL");

(parcelRequire("9xran"))("getPrototypeOf", function() {
    return function getPrototypeOf(it) {
        return $8qEfL($jK6u7(it));
    };
});

});




parcelRegister("ivxVa", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7956f417d792da5$export$2e2bcd8739ae039);

var $lduhU = parcelRequire("lduhU");

var $l4Nx0 = parcelRequire("l4Nx0");
function $d7956f417d792da5$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = (0, (/*@__PURE__*/$parcel$interopDefault($lduhU)))(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $l4Nx0.default)(subClass, superClass);
}

});
parcelRegister("lduhU", function(module, exports) {

module.exports = (parcelRequire("j0uCj"));

});
parcelRegister("j0uCj", function(module, exports) {
parcelRequire("kmb5d");

var $314Mo = parcelRequire("314Mo");
var $dd65c4468e060cd1$require$$Object = $314Mo.Object;
module.exports = function create(P, D) {
    return $dd65c4468e060cd1$require$$Object.create(P, D);
};

});
parcelRegister("kmb5d", function(module, exports) {

var $kEXpx = parcelRequire("kEXpx");

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$kEXpx($kEXpx.S, "Object", {
    create: (parcelRequire("98yfN"))
});

});



parcelRegister("l4Nx0", function(module, exports) {

$parcel$export(module.exports, "default", () => $f5806490b1b792f2$export$2e2bcd8739ae039);

var $cerK7 = parcelRequire("cerK7");
function $f5806490b1b792f2$export$2e2bcd8739ae039(o, p) {
    $f5806490b1b792f2$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($cerK7))) || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $f5806490b1b792f2$export$2e2bcd8739ae039(o, p);
}

});


parcelRegister("12eN8", function(module, exports) {

var $1AWBt = parcelRequire("1AWBt");

var $8KK0w = parcelRequire("8KK0w");
/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $0c11739df3ac35ad$var$pick = $8KK0w(function(object, paths) {
    return object == null ? {} : $1AWBt(object, paths);
});
module.exports = $0c11739df3ac35ad$var$pick;

});
parcelRegister("1AWBt", function(module, exports) {

var $6IXDN = parcelRequire("6IXDN");

var $2VBx6 = parcelRequire("2VBx6");
/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $12969ca4851cc4ab$var$basePick(object, paths) {
    return $6IXDN(object, paths, function(value, path) {
        return $2VBx6(object, path);
    });
}
module.exports = $12969ca4851cc4ab$var$basePick;

});
parcelRegister("6IXDN", function(module, exports) {

var $lJEX1 = parcelRequire("lJEX1");

var $eJzCK = parcelRequire("eJzCK");

var $4RK0h = parcelRequire("4RK0h");
/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function $4e551d8e73f04819$var$basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = $lJEX1(object, path);
        if (predicate(value, path)) $eJzCK(result, $4RK0h(path, object), value);
    }
    return result;
}
module.exports = $4e551d8e73f04819$var$basePickBy;

});
parcelRegister("lJEX1", function(module, exports) {

var $4RK0h = parcelRequire("4RK0h");

var $6DSvu = parcelRequire("6DSvu");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $fd2d90f592c63519$var$baseGet(object, path) {
    path = $4RK0h(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$6DSvu(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $fd2d90f592c63519$var$baseGet;

});
parcelRegister("4RK0h", function(module, exports) {

var $o8HxT = parcelRequire("o8HxT");

var $kPpic = parcelRequire("kPpic");

var $lnP3M = parcelRequire("lnP3M");

var $l6E2L = parcelRequire("l6E2L");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $38afcbfab85a0553$var$castPath(value, object) {
    if ($o8HxT(value)) return value;
    return $kPpic(value, object) ? [
        value
    ] : $lnP3M($l6E2L(value));
}
module.exports = $38afcbfab85a0553$var$castPath;

});
parcelRegister("o8HxT", function(module, exports) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $0488fde9aa355453$var$isArray = Array.isArray;
module.exports = $0488fde9aa355453$var$isArray;

});

parcelRegister("kPpic", function(module, exports) {

var $o8HxT = parcelRequire("o8HxT");

var $9dr3u = parcelRequire("9dr3u");
/** Used to match property names within property paths. */ var $03e9beb856e9b4cd$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $03e9beb856e9b4cd$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $03e9beb856e9b4cd$var$isKey(value, object) {
    if ($o8HxT(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $9dr3u(value)) return true;
    return $03e9beb856e9b4cd$var$reIsPlainProp.test(value) || !$03e9beb856e9b4cd$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = $03e9beb856e9b4cd$var$isKey;

});
parcelRegister("9dr3u", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $6b5a5095e0934938$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $6b5a5095e0934938$var$isSymbol(value) {
    return typeof value == "symbol" || $8l89S(value) && $eq6CV(value) == $6b5a5095e0934938$var$symbolTag;
}
module.exports = $6b5a5095e0934938$var$isSymbol;

});
parcelRegister("eq6CV", function(module, exports) {

var $57wYk = parcelRequire("57wYk");

var $iMn5C = parcelRequire("iMn5C");

var $5tDQy = parcelRequire("5tDQy");
/** `Object#toString` result references. */ var $a7f8a2555793d7d3$var$nullTag = "[object Null]", $a7f8a2555793d7d3$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $a7f8a2555793d7d3$var$symToStringTag = $57wYk ? $57wYk.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $a7f8a2555793d7d3$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $a7f8a2555793d7d3$var$undefinedTag : $a7f8a2555793d7d3$var$nullTag;
    return $a7f8a2555793d7d3$var$symToStringTag && $a7f8a2555793d7d3$var$symToStringTag in Object(value) ? $iMn5C(value) : $5tDQy(value);
}
module.exports = $a7f8a2555793d7d3$var$baseGetTag;

});
parcelRegister("57wYk", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/** Built-in value references. */ var $3ba72ebe7e4419b5$var$Symbol = $23YZo.Symbol;
module.exports = $3ba72ebe7e4419b5$var$Symbol;

});
parcelRegister("23YZo", function(module, exports) {

var $ljJ8G = parcelRequire("ljJ8G");
/** Detect free variable `self`. */ var $180b2bc3c0deaf6c$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $180b2bc3c0deaf6c$var$root = $ljJ8G || $180b2bc3c0deaf6c$var$freeSelf || Function("return this")();
module.exports = $180b2bc3c0deaf6c$var$root;

});
parcelRegister("ljJ8G", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $f84e62f9db5b9ccd$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $f84e62f9db5b9ccd$var$freeGlobal;

});



parcelRegister("iMn5C", function(module, exports) {

var $57wYk = parcelRequire("57wYk");
/** Used for built-in method references. */ var $dabe9ecbecc6d0b5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dabe9ecbecc6d0b5$var$hasOwnProperty = $dabe9ecbecc6d0b5$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $dabe9ecbecc6d0b5$var$nativeObjectToString = $dabe9ecbecc6d0b5$var$objectProto.toString;
/** Built-in value references. */ var $dabe9ecbecc6d0b5$var$symToStringTag = $57wYk ? $57wYk.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $dabe9ecbecc6d0b5$var$getRawTag(value) {
    var isOwn = $dabe9ecbecc6d0b5$var$hasOwnProperty.call(value, $dabe9ecbecc6d0b5$var$symToStringTag), tag = value[$dabe9ecbecc6d0b5$var$symToStringTag];
    try {
        value[$dabe9ecbecc6d0b5$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $dabe9ecbecc6d0b5$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$dabe9ecbecc6d0b5$var$symToStringTag] = tag;
        else delete value[$dabe9ecbecc6d0b5$var$symToStringTag];
    }
    return result;
}
module.exports = $dabe9ecbecc6d0b5$var$getRawTag;

});

parcelRegister("5tDQy", function(module, exports) {
/** Used for built-in method references. */ var $3fce91ec3914aaed$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3fce91ec3914aaed$var$nativeObjectToString = $3fce91ec3914aaed$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $3fce91ec3914aaed$var$objectToString(value) {
    return $3fce91ec3914aaed$var$nativeObjectToString.call(value);
}
module.exports = $3fce91ec3914aaed$var$objectToString;

});


parcelRegister("8l89S", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $61269cf1f3e020be$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
module.exports = $61269cf1f3e020be$var$isObjectLike;

});



parcelRegister("lnP3M", function(module, exports) {

var $99Rk8 = parcelRequire("99Rk8");
/** Used to match property names within property paths. */ var $f9135a667399ede4$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $f9135a667399ede4$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f9135a667399ede4$var$stringToPath = $99Rk8(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($f9135a667399ede4$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($f9135a667399ede4$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
module.exports = $f9135a667399ede4$var$stringToPath;

});
parcelRegister("99Rk8", function(module, exports) {

var $23xpV = parcelRequire("23xpV");
/** Used as the maximum memoize cache size. */ var $6aae515404bf5dd2$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $6aae515404bf5dd2$var$memoizeCapped(func) {
    var result = $23xpV(func, function(key) {
        if (cache.size === $6aae515404bf5dd2$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = $6aae515404bf5dd2$var$memoizeCapped;

});
parcelRegister("23xpV", function(module, exports) {

var $6gDBQ = parcelRequire("6gDBQ");
/** Error message constants. */ var $17f5c88c594eac51$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $17f5c88c594eac51$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($17f5c88c594eac51$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($17f5c88c594eac51$var$memoize.Cache || $6gDBQ);
    return memoized;
}
// Expose `MapCache`.
$17f5c88c594eac51$var$memoize.Cache = $6gDBQ;
module.exports = $17f5c88c594eac51$var$memoize;

});
parcelRegister("6gDBQ", function(module, exports) {

var $j9XgB = parcelRequire("j9XgB");

var $5Rqhl = parcelRequire("5Rqhl");

var $g0JTV = parcelRequire("g0JTV");

var $iaILb = parcelRequire("iaILb");

var $4vfJO = parcelRequire("4vfJO");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $4902f64a16640324$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$4902f64a16640324$var$MapCache.prototype.clear = $j9XgB;
$4902f64a16640324$var$MapCache.prototype["delete"] = $5Rqhl;
$4902f64a16640324$var$MapCache.prototype.get = $g0JTV;
$4902f64a16640324$var$MapCache.prototype.has = $iaILb;
$4902f64a16640324$var$MapCache.prototype.set = $4vfJO;
module.exports = $4902f64a16640324$var$MapCache;

});
parcelRegister("j9XgB", function(module, exports) {

var $c8dKl = parcelRequire("c8dKl");

var $iYOpJ = parcelRequire("iYOpJ");

var $2cJKd = parcelRequire("2cJKd");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $df2cd4bc93f21548$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $c8dKl,
        "map": new ($2cJKd || $iYOpJ),
        "string": new $c8dKl
    };
}
module.exports = $df2cd4bc93f21548$var$mapCacheClear;

});
parcelRegister("c8dKl", function(module, exports) {

var $b4nbb = parcelRequire("b4nbb");

var $8ink3 = parcelRequire("8ink3");

var $VQwbj = parcelRequire("VQwbj");

var $19QNA = parcelRequire("19QNA");

var $i8qJC = parcelRequire("i8qJC");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $8d50e526a9e9b7fa$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$8d50e526a9e9b7fa$var$Hash.prototype.clear = $b4nbb;
$8d50e526a9e9b7fa$var$Hash.prototype["delete"] = $8ink3;
$8d50e526a9e9b7fa$var$Hash.prototype.get = $VQwbj;
$8d50e526a9e9b7fa$var$Hash.prototype.has = $19QNA;
$8d50e526a9e9b7fa$var$Hash.prototype.set = $i8qJC;
module.exports = $8d50e526a9e9b7fa$var$Hash;

});
parcelRegister("b4nbb", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $80f20c637ba11563$var$hashClear() {
    this.__data__ = $k1Z3J ? $k1Z3J(null) : {};
    this.size = 0;
}
module.exports = $80f20c637ba11563$var$hashClear;

});
parcelRegister("k1Z3J", function(module, exports) {

var $6T08O = parcelRequire("6T08O");
/* Built-in method references that are verified to be native. */ var $e95343b7bf5d617b$var$nativeCreate = $6T08O(Object, "create");
module.exports = $e95343b7bf5d617b$var$nativeCreate;

});
parcelRegister("6T08O", function(module, exports) {

var $bhj99 = parcelRequire("bhj99");

var $ii1B1 = parcelRequire("ii1B1");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $5037fd2e597c2a03$var$getNative(object, key) {
    var value = $ii1B1(object, key);
    return $bhj99(value) ? value : undefined;
}
module.exports = $5037fd2e597c2a03$var$getNative;

});
parcelRegister("bhj99", function(module, exports) {

var $01ubZ = parcelRequire("01ubZ");

var $87ifd = parcelRequire("87ifd");

var $lsJ54 = parcelRequire("lsJ54");

var $dqC5h = parcelRequire("dqC5h");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $8360225fb63098b3$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $8360225fb63098b3$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $8360225fb63098b3$var$funcProto = Function.prototype, $8360225fb63098b3$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $8360225fb63098b3$var$funcToString = $8360225fb63098b3$var$funcProto.toString;
/** Used to check objects for own properties. */ var $8360225fb63098b3$var$hasOwnProperty = $8360225fb63098b3$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $8360225fb63098b3$var$reIsNative = RegExp("^" + $8360225fb63098b3$var$funcToString.call($8360225fb63098b3$var$hasOwnProperty).replace($8360225fb63098b3$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $8360225fb63098b3$var$baseIsNative(value) {
    if (!$lsJ54(value) || $87ifd(value)) return false;
    var pattern = $01ubZ(value) ? $8360225fb63098b3$var$reIsNative : $8360225fb63098b3$var$reIsHostCtor;
    return pattern.test($dqC5h(value));
}
module.exports = $8360225fb63098b3$var$baseIsNative;

});
parcelRegister("01ubZ", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $lsJ54 = parcelRequire("lsJ54");
/** `Object#toString` result references. */ var $004783abbde551e4$var$asyncTag = "[object AsyncFunction]", $004783abbde551e4$var$funcTag = "[object Function]", $004783abbde551e4$var$genTag = "[object GeneratorFunction]", $004783abbde551e4$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $004783abbde551e4$var$isFunction(value) {
    if (!$lsJ54(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $eq6CV(value);
    return tag == $004783abbde551e4$var$funcTag || tag == $004783abbde551e4$var$genTag || tag == $004783abbde551e4$var$asyncTag || tag == $004783abbde551e4$var$proxyTag;
}
module.exports = $004783abbde551e4$var$isFunction;

});
parcelRegister("lsJ54", function(module, exports) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $f9ff2e983beb6b86$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
module.exports = $f9ff2e983beb6b86$var$isObject;

});


parcelRegister("87ifd", function(module, exports) {

var $g3dHA = parcelRequire("g3dHA");
/** Used to detect methods masquerading as native. */ var $5e8d211f630cd46d$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($g3dHA && $g3dHA.keys && $g3dHA.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $5e8d211f630cd46d$var$isMasked(func) {
    return !!$5e8d211f630cd46d$var$maskSrcKey && $5e8d211f630cd46d$var$maskSrcKey in func;
}
module.exports = $5e8d211f630cd46d$var$isMasked;

});
parcelRegister("g3dHA", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/** Used to detect overreaching core-js shims. */ var $baf78e1246b3b18f$var$coreJsData = $23YZo["__core-js_shared__"];
module.exports = $baf78e1246b3b18f$var$coreJsData;

});


parcelRegister("dqC5h", function(module, exports) {
/** Used for built-in method references. */ var $9c6b3ec69362487e$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $9c6b3ec69362487e$var$funcToString = $9c6b3ec69362487e$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $9c6b3ec69362487e$var$toSource(func) {
    if (func != null) {
        try {
            return $9c6b3ec69362487e$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
module.exports = $9c6b3ec69362487e$var$toSource;

});


parcelRegister("ii1B1", function(module, exports) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $d50b255f8680c47a$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = $d50b255f8680c47a$var$getValue;

});




parcelRegister("8ink3", function(module, exports) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $60a2188452e03a76$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $60a2188452e03a76$var$hashDelete;

});

parcelRegister("VQwbj", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/** Used to stand-in for `undefined` hash values. */ var $0ade0ffa62051a98$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $0ade0ffa62051a98$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0ade0ffa62051a98$var$hasOwnProperty = $0ade0ffa62051a98$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $0ade0ffa62051a98$var$hashGet(key) {
    var data = this.__data__;
    if ($k1Z3J) {
        var result = data[key];
        return result === $0ade0ffa62051a98$var$HASH_UNDEFINED ? undefined : result;
    }
    return $0ade0ffa62051a98$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = $0ade0ffa62051a98$var$hashGet;

});

parcelRegister("19QNA", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/** Used for built-in method references. */ var $0d7f9677a17b6bef$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0d7f9677a17b6bef$var$hasOwnProperty = $0d7f9677a17b6bef$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $0d7f9677a17b6bef$var$hashHas(key) {
    var data = this.__data__;
    return $k1Z3J ? data[key] !== undefined : $0d7f9677a17b6bef$var$hasOwnProperty.call(data, key);
}
module.exports = $0d7f9677a17b6bef$var$hashHas;

});

parcelRegister("i8qJC", function(module, exports) {

var $k1Z3J = parcelRequire("k1Z3J");
/** Used to stand-in for `undefined` hash values. */ var $d33db65186b62952$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $d33db65186b62952$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $k1Z3J && value === undefined ? $d33db65186b62952$var$HASH_UNDEFINED : value;
    return this;
}
module.exports = $d33db65186b62952$var$hashSet;

});


parcelRegister("iYOpJ", function(module, exports) {

var $bjX1n = parcelRequire("bjX1n");

var $i2OST = parcelRequire("i2OST");

var $fmh4d = parcelRequire("fmh4d");

var $3AXiV = parcelRequire("3AXiV");

var $lWpQQ = parcelRequire("lWpQQ");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $dd14efc87ba1cd5b$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$dd14efc87ba1cd5b$var$ListCache.prototype.clear = $bjX1n;
$dd14efc87ba1cd5b$var$ListCache.prototype["delete"] = $i2OST;
$dd14efc87ba1cd5b$var$ListCache.prototype.get = $fmh4d;
$dd14efc87ba1cd5b$var$ListCache.prototype.has = $3AXiV;
$dd14efc87ba1cd5b$var$ListCache.prototype.set = $lWpQQ;
module.exports = $dd14efc87ba1cd5b$var$ListCache;

});
parcelRegister("bjX1n", function(module, exports) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $83df40714bf7006e$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = $83df40714bf7006e$var$listCacheClear;

});

parcelRegister("i2OST", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/** Used for built-in method references. */ var $d22fe27824ff9351$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $d22fe27824ff9351$var$splice = $d22fe27824ff9351$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $d22fe27824ff9351$var$listCacheDelete(key) {
    var data = this.__data__, index = $bBnDb(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $d22fe27824ff9351$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = $d22fe27824ff9351$var$listCacheDelete;

});
parcelRegister("bBnDb", function(module, exports) {

var $6TC8i = parcelRequire("6TC8i");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $87257b05f5d9ad81$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($6TC8i(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = $87257b05f5d9ad81$var$assocIndexOf;

});
parcelRegister("6TC8i", function(module, exports) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $50557587dab070a0$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = $50557587dab070a0$var$eq;

});



parcelRegister("fmh4d", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $b2e6263d81cdc1b3$var$listCacheGet(key) {
    var data = this.__data__, index = $bBnDb(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = $b2e6263d81cdc1b3$var$listCacheGet;

});

parcelRegister("3AXiV", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $29e2bc7b7348833e$var$listCacheHas(key) {
    return $bBnDb(this.__data__, key) > -1;
}
module.exports = $29e2bc7b7348833e$var$listCacheHas;

});

parcelRegister("lWpQQ", function(module, exports) {

var $bBnDb = parcelRequire("bBnDb");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $ff9311500b60ab72$var$listCacheSet(key, value) {
    var data = this.__data__, index = $bBnDb(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = $ff9311500b60ab72$var$listCacheSet;

});


parcelRegister("2cJKd", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $19b02faa57603249$var$Map = $6T08O($23YZo, "Map");
module.exports = $19b02faa57603249$var$Map;

});


parcelRegister("5Rqhl", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $44464964ade29765$var$mapCacheDelete(key) {
    var result = $gxIuO(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = $44464964ade29765$var$mapCacheDelete;

});
parcelRegister("gxIuO", function(module, exports) {

var $PZpyR = parcelRequire("PZpyR");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $c0b23e5f03c2595b$var$getMapData(map, key) {
    var data = map.__data__;
    return $PZpyR(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
module.exports = $c0b23e5f03c2595b$var$getMapData;

});
parcelRegister("PZpyR", function(module, exports) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $09c4668903e66c1d$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
module.exports = $09c4668903e66c1d$var$isKeyable;

});



parcelRegister("g0JTV", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $ba80406da5503086$var$mapCacheGet(key) {
    return $gxIuO(this, key).get(key);
}
module.exports = $ba80406da5503086$var$mapCacheGet;

});

parcelRegister("iaILb", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d3abe18ea687dfb7$var$mapCacheHas(key) {
    return $gxIuO(this, key).has(key);
}
module.exports = $d3abe18ea687dfb7$var$mapCacheHas;

});

parcelRegister("4vfJO", function(module, exports) {

var $gxIuO = parcelRequire("gxIuO");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $347643e3dcfcc207$var$mapCacheSet(key, value) {
    var data = $gxIuO(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = $347643e3dcfcc207$var$mapCacheSet;

});





parcelRegister("l6E2L", function(module, exports) {

var $kJ9w3 = parcelRequire("kJ9w3");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $f5d9385a9cc7e413$var$toString(value) {
    return value == null ? "" : $kJ9w3(value);
}
module.exports = $f5d9385a9cc7e413$var$toString;

});
parcelRegister("kJ9w3", function(module, exports) {

var $57wYk = parcelRequire("57wYk");

var $i46jW = parcelRequire("i46jW");

var $o8HxT = parcelRequire("o8HxT");

var $9dr3u = parcelRequire("9dr3u");
/** Used as references for various `Number` constants. */ var $f16f644742c27c21$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $f16f644742c27c21$var$symbolProto = $57wYk ? $57wYk.prototype : undefined, $f16f644742c27c21$var$symbolToString = $f16f644742c27c21$var$symbolProto ? $f16f644742c27c21$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $f16f644742c27c21$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($o8HxT(value)) // Recursively convert values (susceptible to call stack limits).
    return $i46jW(value, $f16f644742c27c21$var$baseToString) + "";
    if ($9dr3u(value)) return $f16f644742c27c21$var$symbolToString ? $f16f644742c27c21$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$f16f644742c27c21$var$INFINITY ? "-0" : result;
}
module.exports = $f16f644742c27c21$var$baseToString;

});
parcelRegister("i46jW", function(module, exports) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $d26d80da1ba3948c$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = $d26d80da1ba3948c$var$arrayMap;

});




parcelRegister("6DSvu", function(module, exports) {

var $9dr3u = parcelRequire("9dr3u");
/** Used as references for various `Number` constants. */ var $4d60aa8c33155976$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $4d60aa8c33155976$var$toKey(value) {
    if (typeof value == "string" || $9dr3u(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$4d60aa8c33155976$var$INFINITY ? "-0" : result;
}
module.exports = $4d60aa8c33155976$var$toKey;

});


parcelRegister("eJzCK", function(module, exports) {

var $5i71d = parcelRequire("5i71d");

var $4RK0h = parcelRequire("4RK0h");

var $iyUuu = parcelRequire("iyUuu");

var $lsJ54 = parcelRequire("lsJ54");

var $6DSvu = parcelRequire("6DSvu");
/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $aba0e6d66e8d80dd$var$baseSet(object, path, value, customizer) {
    if (!$lsJ54(object)) return object;
    path = $4RK0h(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = $6DSvu(path[index]), newValue = value;
        if (key === "__proto__" || key === "constructor" || key === "prototype") return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = $lsJ54(objValue) ? objValue : $iyUuu(path[index + 1]) ? [] : {};
        }
        $5i71d(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
module.exports = $aba0e6d66e8d80dd$var$baseSet;

});
parcelRegister("5i71d", function(module, exports) {

var $cWbJD = parcelRequire("cWbJD");

var $6TC8i = parcelRequire("6TC8i");
/** Used for built-in method references. */ var $3da413f0b86c10df$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3da413f0b86c10df$var$hasOwnProperty = $3da413f0b86c10df$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $3da413f0b86c10df$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($3da413f0b86c10df$var$hasOwnProperty.call(object, key) && $6TC8i(objValue, value)) || value === undefined && !(key in object)) $cWbJD(object, key, value);
}
module.exports = $3da413f0b86c10df$var$assignValue;

});
parcelRegister("cWbJD", function(module, exports) {

var $4hwTc = parcelRequire("4hwTc");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $96b401257ea00d24$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && $4hwTc) $4hwTc(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
module.exports = $96b401257ea00d24$var$baseAssignValue;

});
parcelRegister("4hwTc", function(module, exports) {

var $6T08O = parcelRequire("6T08O");
var $31e24313ace94404$var$defineProperty = function() {
    try {
        var func = $6T08O(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
module.exports = $31e24313ace94404$var$defineProperty;

});



parcelRegister("iyUuu", function(module, exports) {
/** Used as references for various `Number` constants. */ var $d83738e053b5eb08$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $d83738e053b5eb08$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $d83738e053b5eb08$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $d83738e053b5eb08$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $d83738e053b5eb08$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = $d83738e053b5eb08$var$isIndex;

});



parcelRegister("2VBx6", function(module, exports) {

var $ij33W = parcelRequire("ij33W");

var $btvBm = parcelRequire("btvBm");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $221e04e57e35dd04$var$hasIn(object, path) {
    return object != null && $btvBm(object, path, $ij33W);
}
module.exports = $221e04e57e35dd04$var$hasIn;

});
parcelRegister("ij33W", function(module, exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $d53c6080f339a51f$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = $d53c6080f339a51f$var$baseHasIn;

});

parcelRegister("btvBm", function(module, exports) {

var $4RK0h = parcelRequire("4RK0h");

var $aJD6g = parcelRequire("aJD6g");

var $o8HxT = parcelRequire("o8HxT");

var $iyUuu = parcelRequire("iyUuu");

var $1S9lz = parcelRequire("1S9lz");

var $6DSvu = parcelRequire("6DSvu");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $85aaea8f77d790ae$var$hasPath(object, path, hasFunc) {
    path = $4RK0h(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $6DSvu(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $1S9lz(length) && $iyUuu(key, length) && ($o8HxT(object) || $aJD6g(object));
}
module.exports = $85aaea8f77d790ae$var$hasPath;

});
parcelRegister("aJD6g", function(module, exports) {

var $lB3aj = parcelRequire("lB3aj");

var $8l89S = parcelRequire("8l89S");
/** Used for built-in method references. */ var $7d0c6fd0eb26be0e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7d0c6fd0eb26be0e$var$hasOwnProperty = $7d0c6fd0eb26be0e$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $7d0c6fd0eb26be0e$var$propertyIsEnumerable = $7d0c6fd0eb26be0e$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $7d0c6fd0eb26be0e$var$isArguments = $lB3aj(function() {
    return arguments;
}()) ? $lB3aj : function(value) {
    return $8l89S(value) && $7d0c6fd0eb26be0e$var$hasOwnProperty.call(value, "callee") && !$7d0c6fd0eb26be0e$var$propertyIsEnumerable.call(value, "callee");
};
module.exports = $7d0c6fd0eb26be0e$var$isArguments;

});
parcelRegister("lB3aj", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $fb8f823cdc90f511$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $fb8f823cdc90f511$var$baseIsArguments(value) {
    return $8l89S(value) && $eq6CV(value) == $fb8f823cdc90f511$var$argsTag;
}
module.exports = $fb8f823cdc90f511$var$baseIsArguments;

});


parcelRegister("1S9lz", function(module, exports) {
/** Used as references for various `Number` constants. */ var $15d215b19bcf1187$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $15d215b19bcf1187$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $15d215b19bcf1187$var$MAX_SAFE_INTEGER;
}
module.exports = $15d215b19bcf1187$var$isLength;

});




parcelRegister("8KK0w", function(module, exports) {

var $20Rgr = parcelRequire("20Rgr");

var $b86t6 = parcelRequire("b86t6");

var $iGMVy = parcelRequire("iGMVy");
/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $65f64eb9f31faa0d$var$flatRest(func) {
    return $iGMVy($b86t6(func, undefined, $20Rgr), func + "");
}
module.exports = $65f64eb9f31faa0d$var$flatRest;

});
parcelRegister("20Rgr", function(module, exports) {

var $fgBHx = parcelRequire("fgBHx");
/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $1774e6065e7ade58$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $fgBHx(array, 1) : [];
}
module.exports = $1774e6065e7ade58$var$flatten;

});
parcelRegister("fgBHx", function(module, exports) {

var $hynws = parcelRequire("hynws");

var $hStNq = parcelRequire("hStNq");
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $b1d5985487d54dea$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $hStNq);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $b1d5985487d54dea$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $hynws(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $b1d5985487d54dea$var$baseFlatten;

});
parcelRegister("hynws", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $cc77dbb7c08db6a8$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $cc77dbb7c08db6a8$var$arrayPush;

});

parcelRegister("hStNq", function(module, exports) {

var $57wYk = parcelRequire("57wYk");

var $aJD6g = parcelRequire("aJD6g");

var $o8HxT = parcelRequire("o8HxT");
/** Built-in value references. */ var $035bd928078475ee$var$spreadableSymbol = $57wYk ? $57wYk.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $035bd928078475ee$var$isFlattenable(value) {
    return $o8HxT(value) || $aJD6g(value) || !!($035bd928078475ee$var$spreadableSymbol && value && value[$035bd928078475ee$var$spreadableSymbol]);
}
module.exports = $035bd928078475ee$var$isFlattenable;

});



parcelRegister("b86t6", function(module, exports) {

var $jpWht = parcelRequire("jpWht");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $81a5758ee0248452$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $81a5758ee0248452$var$overRest(func, start, transform) {
    start = $81a5758ee0248452$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $81a5758ee0248452$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $jpWht(func, this, otherArgs);
    };
}
module.exports = $81a5758ee0248452$var$overRest;

});
parcelRegister("jpWht", function(module, exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $e22d8f7aab4ea8e2$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = $e22d8f7aab4ea8e2$var$apply;

});


parcelRegister("iGMVy", function(module, exports) {

var $2yzAw = parcelRequire("2yzAw");

var $7WhTB = parcelRequire("7WhTB");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $d9b21a2cad7f96c2$var$setToString = $7WhTB($2yzAw);
module.exports = $d9b21a2cad7f96c2$var$setToString;

});
parcelRegister("2yzAw", function(module, exports) {

var $9HRmE = parcelRequire("9HRmE");

var $4hwTc = parcelRequire("4hwTc");

var $4Nq5y = parcelRequire("4Nq5y");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $1dca5cc74bf5ffaf$var$baseSetToString = !$4hwTc ? $4Nq5y : function(func, string) {
    return $4hwTc(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": $9HRmE(string),
        "writable": true
    });
};
module.exports = $1dca5cc74bf5ffaf$var$baseSetToString;

});
parcelRegister("9HRmE", function(module, exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $7111863c3c692f0e$var$constant(value) {
    return function() {
        return value;
    };
}
module.exports = $7111863c3c692f0e$var$constant;

});

parcelRegister("4Nq5y", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $37dff9aa04444f9c$var$identity(value) {
    return value;
}
module.exports = $37dff9aa04444f9c$var$identity;

});


parcelRegister("7WhTB", function(module, exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $5c7bd4e931ae22e5$var$HOT_COUNT = 800, $5c7bd4e931ae22e5$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5c7bd4e931ae22e5$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $5c7bd4e931ae22e5$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $5c7bd4e931ae22e5$var$nativeNow(), remaining = $5c7bd4e931ae22e5$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $5c7bd4e931ae22e5$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = $5c7bd4e931ae22e5$var$shortOut;

});




parcelRegister("i51gj", function(module, exports) {

var $lJEX1 = parcelRequire("lJEX1");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $d299ac421c05c135$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $lJEX1(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $d299ac421c05c135$var$get;

});

parcelRegister("44Pmt", function(module, exports) {

var $jViFF = parcelRequire("jViFF");

var $67A6V = parcelRequire("67A6V");

var $aJD6g = parcelRequire("aJD6g");

var $o8HxT = parcelRequire("o8HxT");

var $eMthh = parcelRequire("eMthh");

var $f504n = parcelRequire("f504n");

var $3wZFp = parcelRequire("3wZFp");

var $1Q21n = parcelRequire("1Q21n");
/** `Object#toString` result references. */ var $2f7f607262506341$var$mapTag = "[object Map]", $2f7f607262506341$var$setTag = "[object Set]";
/** Used for built-in method references. */ var $2f7f607262506341$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2f7f607262506341$var$hasOwnProperty = $2f7f607262506341$var$objectProto.hasOwnProperty;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function $2f7f607262506341$var$isEmpty(value) {
    if (value == null) return true;
    if ($eMthh(value) && ($o8HxT(value) || typeof value == "string" || typeof value.splice == "function" || $f504n(value) || $1Q21n(value) || $aJD6g(value))) return !value.length;
    var tag = $67A6V(value);
    if (tag == $2f7f607262506341$var$mapTag || tag == $2f7f607262506341$var$setTag) return !value.size;
    if ($3wZFp(value)) return !$jViFF(value).length;
    for(var key in value){
        if ($2f7f607262506341$var$hasOwnProperty.call(value, key)) return false;
    }
    return true;
}
module.exports = $2f7f607262506341$var$isEmpty;

});
parcelRegister("jViFF", function(module, exports) {

var $3wZFp = parcelRequire("3wZFp");

var $Xlg65 = parcelRequire("Xlg65");
/** Used for built-in method references. */ var $e811d2e210fb58cc$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e811d2e210fb58cc$var$hasOwnProperty = $e811d2e210fb58cc$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $e811d2e210fb58cc$var$baseKeys(object) {
    if (!$3wZFp(object)) return $Xlg65(object);
    var result = [];
    for(var key in Object(object))if ($e811d2e210fb58cc$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
module.exports = $e811d2e210fb58cc$var$baseKeys;

});
parcelRegister("3wZFp", function(module, exports) {
/** Used for built-in method references. */ var $292432068be14a79$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $292432068be14a79$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $292432068be14a79$var$objectProto;
    return value === proto;
}
module.exports = $292432068be14a79$var$isPrototype;

});

parcelRegister("Xlg65", function(module, exports) {

var $lW2Sc = parcelRequire("lW2Sc");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $0b26005314403d97$var$nativeKeys = $lW2Sc(Object.keys, Object);
module.exports = $0b26005314403d97$var$nativeKeys;

});
parcelRegister("lW2Sc", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $ff813e49bf3cca3d$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $ff813e49bf3cca3d$var$overArg;

});



parcelRegister("67A6V", function(module, exports) {

var $5Ehf1 = parcelRequire("5Ehf1");

var $2cJKd = parcelRequire("2cJKd");

var $f7yH3 = parcelRequire("f7yH3");

var $vH4x0 = parcelRequire("vH4x0");

var $f0N2p = parcelRequire("f0N2p");

var $eq6CV = parcelRequire("eq6CV");

var $dqC5h = parcelRequire("dqC5h");
/** `Object#toString` result references. */ var $474f685f496bfe31$var$mapTag = "[object Map]", $474f685f496bfe31$var$objectTag = "[object Object]", $474f685f496bfe31$var$promiseTag = "[object Promise]", $474f685f496bfe31$var$setTag = "[object Set]", $474f685f496bfe31$var$weakMapTag = "[object WeakMap]";
var $474f685f496bfe31$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $474f685f496bfe31$var$dataViewCtorString = $dqC5h($5Ehf1), $474f685f496bfe31$var$mapCtorString = $dqC5h($2cJKd), $474f685f496bfe31$var$promiseCtorString = $dqC5h($f7yH3), $474f685f496bfe31$var$setCtorString = $dqC5h($vH4x0), $474f685f496bfe31$var$weakMapCtorString = $dqC5h($f0N2p);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $474f685f496bfe31$var$getTag = $eq6CV;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($5Ehf1 && $474f685f496bfe31$var$getTag(new $5Ehf1(new ArrayBuffer(1))) != $474f685f496bfe31$var$dataViewTag || $2cJKd && $474f685f496bfe31$var$getTag(new $2cJKd) != $474f685f496bfe31$var$mapTag || $f7yH3 && $474f685f496bfe31$var$getTag($f7yH3.resolve()) != $474f685f496bfe31$var$promiseTag || $vH4x0 && $474f685f496bfe31$var$getTag(new $vH4x0) != $474f685f496bfe31$var$setTag || $f0N2p && $474f685f496bfe31$var$getTag(new $f0N2p) != $474f685f496bfe31$var$weakMapTag) $474f685f496bfe31$var$getTag = function(value) {
    var result = $eq6CV(value), Ctor = result == $474f685f496bfe31$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $dqC5h(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $474f685f496bfe31$var$dataViewCtorString:
            return $474f685f496bfe31$var$dataViewTag;
        case $474f685f496bfe31$var$mapCtorString:
            return $474f685f496bfe31$var$mapTag;
        case $474f685f496bfe31$var$promiseCtorString:
            return $474f685f496bfe31$var$promiseTag;
        case $474f685f496bfe31$var$setCtorString:
            return $474f685f496bfe31$var$setTag;
        case $474f685f496bfe31$var$weakMapCtorString:
            return $474f685f496bfe31$var$weakMapTag;
    }
    return result;
};
module.exports = $474f685f496bfe31$var$getTag;

});
parcelRegister("5Ehf1", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $41ce0ff3b38ee753$var$DataView = $6T08O($23YZo, "DataView");
module.exports = $41ce0ff3b38ee753$var$DataView;

});

parcelRegister("f7yH3", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $b0226bdea11cb834$var$Promise = $6T08O($23YZo, "Promise");
module.exports = $b0226bdea11cb834$var$Promise;

});

parcelRegister("vH4x0", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $05f44e958da968eb$var$Set = $6T08O($23YZo, "Set");
module.exports = $05f44e958da968eb$var$Set;

});

parcelRegister("f0N2p", function(module, exports) {

var $6T08O = parcelRequire("6T08O");

var $23YZo = parcelRequire("23YZo");
/* Built-in method references that are verified to be native. */ var $aedce50092a1e6a6$var$WeakMap = $6T08O($23YZo, "WeakMap");
module.exports = $aedce50092a1e6a6$var$WeakMap;

});


parcelRegister("eMthh", function(module, exports) {

var $01ubZ = parcelRequire("01ubZ");

var $1S9lz = parcelRequire("1S9lz");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $ac2c42592aa05543$var$isArrayLike(value) {
    return value != null && $1S9lz(value.length) && !$01ubZ(value);
}
module.exports = $ac2c42592aa05543$var$isArrayLike;

});

parcelRegister("f504n", function(module, exports) {

var $23YZo = parcelRequire("23YZo");

var $fiQnm = parcelRequire("fiQnm");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $23YZo.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $fiQnm;
module.exports = isBuffer;

});
parcelRegister("fiQnm", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $b2412a30bba480f5$var$stubFalse() {
    return false;
}
module.exports = $b2412a30bba480f5$var$stubFalse;

});


parcelRegister("1Q21n", function(module, exports) {

var $dtRoq = parcelRequire("dtRoq");

var $91Qdd = parcelRequire("91Qdd");

var $jIny1 = parcelRequire("jIny1");
/* Node.js helper references. */ var $156c3727697ab085$var$nodeIsTypedArray = $jIny1 && $jIny1.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $156c3727697ab085$var$isTypedArray = $156c3727697ab085$var$nodeIsTypedArray ? $91Qdd($156c3727697ab085$var$nodeIsTypedArray) : $dtRoq;
module.exports = $156c3727697ab085$var$isTypedArray;

});
parcelRegister("dtRoq", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $1S9lz = parcelRequire("1S9lz");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $9d076681a0e29d68$var$argsTag = "[object Arguments]", $9d076681a0e29d68$var$arrayTag = "[object Array]", $9d076681a0e29d68$var$boolTag = "[object Boolean]", $9d076681a0e29d68$var$dateTag = "[object Date]", $9d076681a0e29d68$var$errorTag = "[object Error]", $9d076681a0e29d68$var$funcTag = "[object Function]", $9d076681a0e29d68$var$mapTag = "[object Map]", $9d076681a0e29d68$var$numberTag = "[object Number]", $9d076681a0e29d68$var$objectTag = "[object Object]", $9d076681a0e29d68$var$regexpTag = "[object RegExp]", $9d076681a0e29d68$var$setTag = "[object Set]", $9d076681a0e29d68$var$stringTag = "[object String]", $9d076681a0e29d68$var$weakMapTag = "[object WeakMap]";
var $9d076681a0e29d68$var$arrayBufferTag = "[object ArrayBuffer]", $9d076681a0e29d68$var$dataViewTag = "[object DataView]", $9d076681a0e29d68$var$float32Tag = "[object Float32Array]", $9d076681a0e29d68$var$float64Tag = "[object Float64Array]", $9d076681a0e29d68$var$int8Tag = "[object Int8Array]", $9d076681a0e29d68$var$int16Tag = "[object Int16Array]", $9d076681a0e29d68$var$int32Tag = "[object Int32Array]", $9d076681a0e29d68$var$uint8Tag = "[object Uint8Array]", $9d076681a0e29d68$var$uint8ClampedTag = "[object Uint8ClampedArray]", $9d076681a0e29d68$var$uint16Tag = "[object Uint16Array]", $9d076681a0e29d68$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $9d076681a0e29d68$var$typedArrayTags = {};
$9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$float32Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$float64Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int8Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int16Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$int32Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint8Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint8ClampedTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint16Tag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$uint32Tag] = true;
$9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$argsTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$arrayTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$arrayBufferTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$boolTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$dataViewTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$dateTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$errorTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$funcTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$mapTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$numberTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$objectTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$regexpTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$setTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$stringTag] = $9d076681a0e29d68$var$typedArrayTags[$9d076681a0e29d68$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $9d076681a0e29d68$var$baseIsTypedArray(value) {
    return $8l89S(value) && $1S9lz(value.length) && !!$9d076681a0e29d68$var$typedArrayTags[$eq6CV(value)];
}
module.exports = $9d076681a0e29d68$var$baseIsTypedArray;

});

parcelRegister("91Qdd", function(module, exports) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $692cb5474f422969$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = $692cb5474f422969$var$baseUnary;

});

parcelRegister("jIny1", function(module, exports) {

var $ljJ8G = parcelRequire("ljJ8G");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $ljJ8G.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});



parcelRegister("kYVvO", function(module, exports) {

$parcel$export(module.exports, "default", () => $f46605f96bdf1fad$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
function $f46605f96bdf1fad$export$2e2bcd8739ae039(props) {
    var errors = props.errors;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "panel panel-danger errors"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "panel-heading"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h3", {
        className: "panel-title"
    }, "Errors")), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        className: "list-group"
    }, errors.map(function(error, i) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: i,
            className: "list-group-item text-danger"
        }, error.stack);
    })));
}

});

parcelRegister("ip6TK", function(module, exports) {

$parcel$export(module.exports, "ADDITIONAL_PROPERTY_FLAG", () => $d65fe99d36de3cd4$export$60d2d9c11642ddd6);
$parcel$export(module.exports, "canExpand", () => $d65fe99d36de3cd4$export$cc546884e5fe11c1);
$parcel$export(module.exports, "getUiOptions", () => $d65fe99d36de3cd4$export$5559168444c1cc6f);
$parcel$export(module.exports, "getDefaultRegistry", () => $d65fe99d36de3cd4$export$976cc06ffd96e4eb);
$parcel$export(module.exports, "getSchemaType", () => $d65fe99d36de3cd4$export$c37d213d49c78145);
$parcel$export(module.exports, "guessType", () => $d65fe99d36de3cd4$export$211ef2ad09ba7d20);
$parcel$export(module.exports, "getWidget", () => $d65fe99d36de3cd4$export$a091d7f3bd9ea9f);
$parcel$export(module.exports, "hasWidget", () => $d65fe99d36de3cd4$export$896ad1360bd43c21);
$parcel$export(module.exports, "isObject", () => $d65fe99d36de3cd4$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "mergeObjects", () => $d65fe99d36de3cd4$export$2321aea138b44780);
$parcel$export(module.exports, "findSchemaDefinition", () => $d65fe99d36de3cd4$export$ba75abbfed20f81f);
$parcel$export(module.exports, "isFixedItems", () => $d65fe99d36de3cd4$export$f214a64b20942f03);
$parcel$export(module.exports, "getMatchingOption", () => $d65fe99d36de3cd4$export$8165cea9d212ff07);
$parcel$export(module.exports, "isMultiSelect", () => $d65fe99d36de3cd4$export$109f4e03a72b2d9b);
$parcel$export(module.exports, "getDefaultFormState", () => $d65fe99d36de3cd4$export$889286269976f0f0);
$parcel$export(module.exports, "retrieveSchema", () => $d65fe99d36de3cd4$export$120b571b9a37c370);
$parcel$export(module.exports, "mergeDefaultsWithFormData", () => $d65fe99d36de3cd4$export$f39406613502c7ad);
$parcel$export(module.exports, "getDisplayLabel", () => $d65fe99d36de3cd4$export$b90a189477005ecf);
$parcel$export(module.exports, "isFilesArray", () => $d65fe99d36de3cd4$export$abcac65377e58c37);
$parcel$export(module.exports, "asNumber", () => $d65fe99d36de3cd4$export$37576b9ba69b50db);
$parcel$export(module.exports, "orderProperties", () => $d65fe99d36de3cd4$export$dfe1e6e459a6aaf3);
$parcel$export(module.exports, "isConstant", () => $d65fe99d36de3cd4$export$614ff3cc3ef6eda9);
$parcel$export(module.exports, "toConstant", () => $d65fe99d36de3cd4$export$2d50ffa8d7cfb37);
$parcel$export(module.exports, "isSelect", () => $d65fe99d36de3cd4$export$47ed34a15a70bfcf);
$parcel$export(module.exports, "allowAdditionalItems", () => $d65fe99d36de3cd4$export$b5ae80b7edac7510);
$parcel$export(module.exports, "optionsList", () => $d65fe99d36de3cd4$export$675008a38d270fd3);
$parcel$export(module.exports, "stubExistingAdditionalProperties", () => $d65fe99d36de3cd4$export$7f455fe1643a61e7);
$parcel$export(module.exports, "resolveSchema", () => $d65fe99d36de3cd4$export$108f8296d443cf05);
$parcel$export(module.exports, "mergeSchemas", () => $d65fe99d36de3cd4$export$dd610e1878d5f5e);
$parcel$export(module.exports, "deepEquals", () => $d65fe99d36de3cd4$export$73ce4178444047a5);
$parcel$export(module.exports, "shouldRender", () => $d65fe99d36de3cd4$export$74f9e9340d52d089);
$parcel$export(module.exports, "toIdSchema", () => $d65fe99d36de3cd4$export$9e93037aa8764d4d);
$parcel$export(module.exports, "toPathSchema", () => $d65fe99d36de3cd4$export$7c522d40b1c31ae0);
$parcel$export(module.exports, "parseDateString", () => $d65fe99d36de3cd4$export$e684af8cfb294f41);
$parcel$export(module.exports, "toDateString", () => $d65fe99d36de3cd4$export$b7c4e1545c61edee);
$parcel$export(module.exports, "utcToLocal", () => $d65fe99d36de3cd4$export$ccd9a1bc6174ad42);
$parcel$export(module.exports, "pad", () => $d65fe99d36de3cd4$export$5d04458e2a6c373e);
$parcel$export(module.exports, "localToUTC", () => $d65fe99d36de3cd4$export$779990c68cce4240);
$parcel$export(module.exports, "dataURItoBlob", () => $d65fe99d36de3cd4$export$24bc7e761c190a9f);
$parcel$export(module.exports, "rangeSpec", () => $d65fe99d36de3cd4$export$241fd4b305d2db0a);
$parcel$export(module.exports, "schemaRequiresTrueValue", () => $d65fe99d36de3cd4$export$1203181f0b231402);

var $6I5NX = parcelRequire("6I5NX");

var $lyRnQ = parcelRequire("lyRnQ");

var $UVaxg = parcelRequire("UVaxg");

var $4juyi = parcelRequire("4juyi");

var $kltfT = parcelRequire("kltfT");

var $kB4x2 = parcelRequire("kB4x2");

var $a5du3 = parcelRequire("a5du3");

var $cD46i = parcelRequire("cD46i");

var $cG9FK = parcelRequire("cG9FK");

var $k4zDq = parcelRequire("k4zDq");

var $gpTap = parcelRequire("gpTap");

var $8lpxl = parcelRequire("8lpxl");

var $acw62 = parcelRequire("acw62");

var $4jPKB = parcelRequire("4jPKB");

var $6j9O2 = parcelRequire("6j9O2");

var $e8CxN = parcelRequire("e8CxN");

var $1c10x = parcelRequire("1c10x");

var $raQQi = parcelRequire("raQQi");

var $iz2CH = parcelRequire("iz2CH");

var $aCa1n = parcelRequire("aCa1n");

var $3cXpG = parcelRequire("3cXpG");
function $d65fe99d36de3cd4$var$_toPropertyKey(arg) {
    var key = $d65fe99d36de3cd4$var$_toPrimitive(arg, "string");
    return (0, $cD46i.default)(key) === "symbol" ? key : String(key);
}
function $d65fe99d36de3cd4$var$_toPrimitive(input, hint) {
    if ((0, $cD46i.default)(input) !== "object" || input === null) return input;
    var prim = input[0, (/*@__PURE__*/$parcel$interopDefault($6I5NX))];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $cD46i.default)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $d65fe99d36de3cd4$export$60d2d9c11642ddd6 = "__additional_property";
var $d65fe99d36de3cd4$var$widgetMap = {
    "boolean": {
        checkbox: "CheckboxWidget",
        radio: "RadioWidget",
        select: "SelectWidget",
        hidden: "HiddenWidget"
    },
    string: {
        text: "TextWidget",
        password: "PasswordWidget",
        email: "EmailWidget",
        hostname: "TextWidget",
        ipv4: "TextWidget",
        ipv6: "TextWidget",
        uri: "URLWidget",
        "data-url": "FileWidget",
        radio: "RadioWidget",
        select: "SelectWidget",
        textarea: "TextareaWidget",
        hidden: "HiddenWidget",
        date: "DateWidget",
        datetime: "DateTimeWidget",
        "date-time": "DateTimeWidget",
        "alt-date": "AltDateWidget",
        "alt-datetime": "AltDateTimeWidget",
        color: "ColorWidget",
        file: "FileWidget"
    },
    number: {
        text: "TextWidget",
        select: "SelectWidget",
        updown: "UpDownWidget",
        range: "RangeWidget",
        radio: "RadioWidget",
        hidden: "HiddenWidget"
    },
    integer: {
        text: "TextWidget",
        select: "SelectWidget",
        updown: "UpDownWidget",
        range: "RangeWidget",
        radio: "RadioWidget",
        hidden: "HiddenWidget"
    },
    array: {
        select: "SelectWidget",
        checkboxes: "CheckboxesWidget",
        files: "FileWidget",
        hidden: "HiddenWidget"
    }
};
function $d65fe99d36de3cd4$export$cc546884e5fe11c1(schema, uiSchema, formData) {
    if (!schema.additionalProperties) return false;
    var _getUiOptions = $d65fe99d36de3cd4$export$5559168444c1cc6f(uiSchema), expandable = _getUiOptions.expandable;
    if (expandable === false) return expandable;
     // if ui:options.expandable was not explicitly set to false, we can add
    // another property if we have not exceeded maxProperties yet
    if (schema.maxProperties !== undefined) return (0, (/*@__PURE__*/$parcel$interopDefault($8lpxl)))(formData).length < schema.maxProperties;
    return true;
}
function $d65fe99d36de3cd4$export$976cc06ffd96e4eb() {
    return {
        fields: (0, $iz2CH.default),
        widgets: (0, $aCa1n.default),
        definitions: {},
        rootSchema: {},
        formContext: {}
    };
}
function $d65fe99d36de3cd4$export$c37d213d49c78145(schema) {
    var type = schema.type;
    if (!type && schema["const"]) return $d65fe99d36de3cd4$export$211ef2ad09ba7d20(schema["const"]);
    if (!type && schema["enum"]) return "string";
    if (!type && (schema.properties || schema.additionalProperties)) return "object";
    if (type instanceof Array && type.length === 2 && type.includes("null")) return type.find(function(type) {
        return type !== "null";
    });
    return type;
}
function $d65fe99d36de3cd4$export$a091d7f3bd9ea9f(schema, widget) {
    var registeredWidgets = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var type = $d65fe99d36de3cd4$export$c37d213d49c78145(schema);
    function mergeOptions(Widget) {
        // cache return value as property of widget for proper react reconciliation
        if (!Widget.MergedWidget) {
            var defaultOptions = Widget.defaultProps && Widget.defaultProps.options || {};
            Widget.MergedWidget = function(_ref) {
                var _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, props = (0, $gpTap.default)(_ref, [
                    "options"
                ]);
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Widget, (0, $cG9FK.default)({
                    options: (0, $k4zDq.default)({}, defaultOptions, options)
                }, props));
            };
        }
        return Widget.MergedWidget;
    }
    if (typeof widget === "function" || $4jPKB.isForwardRef((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(widget)) || $4jPKB.isMemo(widget)) return mergeOptions(widget);
    if (typeof widget !== "string") throw new Error("Unsupported widget definition: ".concat((0, $cD46i.default)(widget)));
    if (registeredWidgets.hasOwnProperty(widget)) {
        var registeredWidget = registeredWidgets[widget];
        return $d65fe99d36de3cd4$export$a091d7f3bd9ea9f(schema, registeredWidget, registeredWidgets);
    }
    if (!$d65fe99d36de3cd4$var$widgetMap.hasOwnProperty(type)) throw new Error('No widget for type "'.concat(type, '"'));
    if ($d65fe99d36de3cd4$var$widgetMap[type].hasOwnProperty(widget)) {
        var _registeredWidget = registeredWidgets[$d65fe99d36de3cd4$var$widgetMap[type][widget]];
        return $d65fe99d36de3cd4$export$a091d7f3bd9ea9f(schema, _registeredWidget, registeredWidgets);
    }
    throw new Error('No widget "'.concat(widget, '" for type "').concat(type, '"'));
}
function $d65fe99d36de3cd4$export$896ad1360bd43c21(schema, widget) {
    var registeredWidgets = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    try {
        $d65fe99d36de3cd4$export$a091d7f3bd9ea9f(schema, widget, registeredWidgets);
        return true;
    } catch (e) {
        if (e.message && (e.message.startsWith("No widget") || e.message.startsWith("Unsupported widget"))) return false;
        throw e;
    }
}
function $d65fe99d36de3cd4$var$computeDefaults(_schema, parentDefaults, rootSchema) {
    var rawFormData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var includeUndefinedValues = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var schema = $d65fe99d36de3cd4$export$a6cdc56e425d0d0a(_schema) ? _schema : {};
    var formData = $d65fe99d36de3cd4$export$a6cdc56e425d0d0a(rawFormData) ? rawFormData : {}; // Compute the defaults recursively: give highest priority to deepest nodes.
    var defaults = parentDefaults;
    if ($d65fe99d36de3cd4$export$a6cdc56e425d0d0a(defaults) && $d65fe99d36de3cd4$export$a6cdc56e425d0d0a(schema["default"])) // For object defaults, only override parent defaults that are defined in
    // schema.default.
    defaults = $d65fe99d36de3cd4$export$2321aea138b44780(defaults, schema["default"]);
    else if ("default" in schema) // Use schema defaults for this node.
    defaults = schema["default"];
    else if ("$ref" in schema) {
        // Use referenced schema defaults for this node.
        var refSchema = $d65fe99d36de3cd4$export$ba75abbfed20f81f(schema.$ref, rootSchema);
        return $d65fe99d36de3cd4$var$computeDefaults(refSchema, defaults, rootSchema, formData, includeUndefinedValues);
    } else if ("dependencies" in schema) {
        var resolvedSchema = $d65fe99d36de3cd4$var$resolveDependencies(schema, rootSchema, formData);
        return $d65fe99d36de3cd4$var$computeDefaults(resolvedSchema, defaults, rootSchema, formData, includeUndefinedValues);
    } else if ($d65fe99d36de3cd4$export$f214a64b20942f03(schema)) defaults = schema.items.map(function(itemSchema, idx) {
        return $d65fe99d36de3cd4$var$computeDefaults(itemSchema, (0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(parentDefaults) ? parentDefaults[idx] : undefined, rootSchema, formData, includeUndefinedValues);
    });
    else if ("oneOf" in schema) schema = schema.oneOf[$d65fe99d36de3cd4$export$8165cea9d212ff07(undefined, schema.oneOf, rootSchema)];
    else if ("anyOf" in schema) schema = schema.anyOf[$d65fe99d36de3cd4$export$8165cea9d212ff07(undefined, schema.anyOf, rootSchema)];
     // Not defaults defined for this node, fallback to generic typed ones.
    if (typeof defaults === "undefined") defaults = schema["default"];
    switch($d65fe99d36de3cd4$export$c37d213d49c78145(schema)){
        // We need to recur for object schema inner default values.
        case "object":
            return (0, (/*@__PURE__*/$parcel$interopDefault($8lpxl)))(schema.properties || {}).reduce(function(acc, key) {
                // Compute the defaults for this node, with the parent defaults we might
                // have from a previous run: defaults[key].
                var computedDefault = $d65fe99d36de3cd4$var$computeDefaults(schema.properties[key], (defaults || {})[key], rootSchema, (formData || {})[key], includeUndefinedValues);
                if (includeUndefinedValues || computedDefault !== undefined) acc[key] = computedDefault;
                return acc;
            }, {});
        case "array":
            // Inject defaults into existing array defaults
            if ((0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(defaults)) defaults = defaults.map(function(item, idx) {
                return $d65fe99d36de3cd4$var$computeDefaults(schema.items[idx] || schema.additionalItems || {}, item, rootSchema);
            });
             // Deeply inject defaults into already existing form data
            if ((0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(rawFormData)) defaults = rawFormData.map(function(item, idx) {
                return $d65fe99d36de3cd4$var$computeDefaults(schema.items, (defaults || {})[idx], rootSchema, item);
            });
            if (schema.minItems) {
                if (!$d65fe99d36de3cd4$export$109f4e03a72b2d9b(schema, rootSchema)) {
                    var defaultsLength = defaults ? defaults.length : 0;
                    if (schema.minItems > defaultsLength) {
                        var defaultEntries = defaults || []; // populate the array with the defaults
                        var fillerSchema = (0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(schema.items) ? schema.additionalItems : schema.items;
                        var fillerEntries = (0, (/*@__PURE__*/$parcel$interopDefault($e8CxN)))(new Array(schema.minItems - defaultsLength), $d65fe99d36de3cd4$var$computeDefaults(fillerSchema, fillerSchema.defaults, rootSchema)); // then fill up the rest with either the item default or empty, up to minItems
                        return defaultEntries.concat(fillerEntries);
                    }
                } else return defaults ? defaults : [];
            }
    }
    return defaults;
}
function $d65fe99d36de3cd4$export$889286269976f0f0(_schema, formData) {
    var rootSchema = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var includeUndefinedValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (!$d65fe99d36de3cd4$export$a6cdc56e425d0d0a(_schema)) throw new Error("Invalid schema: " + _schema);
    var schema = $d65fe99d36de3cd4$export$120b571b9a37c370(_schema, rootSchema, formData);
    var defaults = $d65fe99d36de3cd4$var$computeDefaults(schema, _schema["default"], rootSchema, formData, includeUndefinedValues);
    if (typeof formData === "undefined") // No form data? Use schema defaults.
    return defaults;
    if ($d65fe99d36de3cd4$export$a6cdc56e425d0d0a(formData) || (0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(formData)) return $d65fe99d36de3cd4$export$f39406613502c7ad(defaults, formData);
    if (formData === 0 || formData === false || formData === "") return formData;
    return formData || defaults;
}
function $d65fe99d36de3cd4$export$f39406613502c7ad(defaults, formData) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(formData)) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(defaults)) defaults = [];
        return formData.map(function(value, idx) {
            if (defaults[idx]) return $d65fe99d36de3cd4$export$f39406613502c7ad(defaults[idx], value);
            return value;
        });
    } else if ($d65fe99d36de3cd4$export$a6cdc56e425d0d0a(formData)) {
        var acc = (0, $cG9FK.default)({}, defaults); // Prevent mutation of source object.
        return (0, (/*@__PURE__*/$parcel$interopDefault($8lpxl)))(formData).reduce(function(acc, key) {
            acc[key] = $d65fe99d36de3cd4$export$f39406613502c7ad(defaults ? defaults[key] : {}, formData[key]);
            return acc;
        }, acc);
    } else return formData;
}
function $d65fe99d36de3cd4$export$5559168444c1cc6f(uiSchema) {
    // get all passed options from ui:widget, ui:options, and ui:<optionName>
    return (0, (/*@__PURE__*/$parcel$interopDefault($8lpxl)))(uiSchema).filter(function(key) {
        return key.indexOf("ui:") === 0;
    }).reduce(function(options, key) {
        var value = uiSchema[key];
        if (key === "ui:widget" && $d65fe99d36de3cd4$export$a6cdc56e425d0d0a(value)) {
            console.warn("Setting options via ui:widget object is deprecated, use ui:options instead");
            return (0, $k4zDq.default)({}, options, value.options || {}, {
                widget: value.component
            });
        }
        if (key === "ui:options" && $d65fe99d36de3cd4$export$a6cdc56e425d0d0a(value)) return (0, $k4zDq.default)({}, options, value);
        return (0, $k4zDq.default)({}, options, (0, $kB4x2.default)({}, key.substring(3), value));
    }, {});
}
function $d65fe99d36de3cd4$export$b90a189477005ecf(schema, uiSchema, rootSchema) {
    var uiOptions = $d65fe99d36de3cd4$export$5559168444c1cc6f(uiSchema);
    var _uiOptions$label = uiOptions.label, displayLabel = _uiOptions$label === void 0 ? true : _uiOptions$label;
    if (schema.type === "array") displayLabel = $d65fe99d36de3cd4$export$109f4e03a72b2d9b(schema, rootSchema) || $d65fe99d36de3cd4$export$abcac65377e58c37(schema, uiSchema, rootSchema);
    if (schema.type === "object") displayLabel = false;
    if (schema.type === "boolean" && !uiSchema["ui:widget"]) displayLabel = false;
    if (uiSchema["ui:field"]) displayLabel = false;
    return displayLabel;
}
function $d65fe99d36de3cd4$export$a6cdc56e425d0d0a(thing) {
    if (typeof File !== "undefined" && thing instanceof File) return false;
    return (0, $cD46i.default)(thing) === "object" && thing !== null && !(0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(thing);
}
function $d65fe99d36de3cd4$export$2321aea138b44780(obj1, obj2) {
    var concatArrays = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    // Recursively merge deeply nested objects.
    var acc = (0, $cG9FK.default)({}, obj1); // Prevent mutation of source object.
    return (0, (/*@__PURE__*/$parcel$interopDefault($8lpxl)))(obj2).reduce(function(acc, key) {
        var left = obj1 ? obj1[key] : {}, right = obj2[key];
        if (obj1 && obj1.hasOwnProperty(key) && $d65fe99d36de3cd4$export$a6cdc56e425d0d0a(right)) acc[key] = $d65fe99d36de3cd4$export$2321aea138b44780(left, right, concatArrays);
        else if (concatArrays && (0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(left) && (0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(right)) acc[key] = left.concat(right);
        else acc[key] = right;
        return acc;
    }, acc);
}
function $d65fe99d36de3cd4$export$37576b9ba69b50db(value) {
    if (value === "") return undefined;
    if (value === null) return null;
    if (/\.$/.test(value)) // "3." can't really be considered a number even if it parses in js. The
    // user is most likely entering a float.
    return value;
    if (/\.0$/.test(value)) // we need to return this as a string here, to allow for input like 3.07
    return value;
    var n = Number(value);
    var valid = typeof n === "number" && !(0, (/*@__PURE__*/$parcel$interopDefault($kltfT)))(n);
    if (/\.\d*0$/.test(value)) // It's a number, that's cool - but we need it as a string so it doesn't screw
    // with the user when entering dollar amounts or other values (such as those with
    // specific precision or number of significant digits)
    return value;
    return valid ? n : value;
}
function $d65fe99d36de3cd4$export$dfe1e6e459a6aaf3(properties, order) {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(order)) return properties;
    var arrayToHash = function arrayToHash(arr) {
        return arr.reduce(function(prev, curr) {
            prev[curr] = true;
            return prev;
        }, {});
    };
    var errorPropList = function errorPropList(arr) {
        return arr.length > 1 ? "properties '".concat(arr.join("', '"), "'") : "property '".concat(arr[0], "'");
    };
    var propertyHash = arrayToHash(properties);
    var orderFiltered = order.filter(function(prop) {
        return prop === "*" || propertyHash[prop];
    });
    var orderHash = arrayToHash(orderFiltered);
    var rest = properties.filter(function(prop) {
        return !orderHash[prop];
    });
    var restIndex = orderFiltered.indexOf("*");
    if (restIndex === -1) {
        if (rest.length) throw new Error("uiSchema order list does not contain ".concat(errorPropList(rest)));
        return orderFiltered;
    }
    if (restIndex !== orderFiltered.lastIndexOf("*")) throw new Error("uiSchema order list contains more than one wildcard item");
    var complete = (0, $4juyi.default)(orderFiltered);
    complete.splice.apply(complete, [
        restIndex,
        1
    ].concat((0, $4juyi.default)(rest)));
    return complete;
}
function $d65fe99d36de3cd4$export$614ff3cc3ef6eda9(schema) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(schema["enum"]) && schema["enum"].length === 1 || schema.hasOwnProperty("const");
}
function $d65fe99d36de3cd4$export$2d50ffa8d7cfb37(schema) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(schema["enum"]) && schema["enum"].length === 1) return schema["enum"][0];
    else if (schema.hasOwnProperty("const")) return schema["const"];
    else throw new Error("schema cannot be inferred as a constant");
}
function $d65fe99d36de3cd4$export$47ed34a15a70bfcf(_schema) {
    var rootSchema = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var schema = $d65fe99d36de3cd4$export$120b571b9a37c370(_schema, rootSchema);
    var altSchemas = schema.oneOf || schema.anyOf;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(schema["enum"])) return true;
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(altSchemas)) return altSchemas.every(function(altSchemas) {
        return $d65fe99d36de3cd4$export$614ff3cc3ef6eda9(altSchemas);
    });
    return false;
}
function $d65fe99d36de3cd4$export$109f4e03a72b2d9b(schema) {
    var rootSchema = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!schema.uniqueItems || !schema.items) return false;
    return $d65fe99d36de3cd4$export$47ed34a15a70bfcf(schema.items, rootSchema);
}
function $d65fe99d36de3cd4$export$abcac65377e58c37(schema, uiSchema) {
    var rootSchema = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (uiSchema["ui:widget"] === "files") return true;
    else if (schema.items) {
        var itemsSchema = $d65fe99d36de3cd4$export$120b571b9a37c370(schema.items, rootSchema);
        return itemsSchema.type === "string" && itemsSchema.format === "data-url";
    }
    return false;
}
function $d65fe99d36de3cd4$export$f214a64b20942f03(schema) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(schema.items) && schema.items.length > 0 && schema.items.every(function(item) {
        return $d65fe99d36de3cd4$export$a6cdc56e425d0d0a(item);
    });
}
function $d65fe99d36de3cd4$export$b5ae80b7edac7510(schema) {
    if (schema.additionalItems === true) console.warn("additionalItems=true is currently not supported");
    return $d65fe99d36de3cd4$export$a6cdc56e425d0d0a(schema.additionalItems);
}
function $d65fe99d36de3cd4$export$675008a38d270fd3(schema) {
    if (schema["enum"]) return schema["enum"].map(function(value, i) {
        var label = schema.enumNames && schema.enumNames[i] || String(value);
        return {
            label: label,
            value: value
        };
    });
    else {
        var altSchemas = schema.oneOf || schema.anyOf;
        return altSchemas.map(function(schema, i) {
            var value = $d65fe99d36de3cd4$export$2d50ffa8d7cfb37(schema);
            var label = schema.title || String(value);
            return {
                schema: schema,
                label: label,
                value: value
            };
        });
    }
}
function $d65fe99d36de3cd4$export$ba75abbfed20f81f($ref) {
    var rootSchema = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var origRef = $ref;
    if ($ref.startsWith("#")) // Decode URI fragment representation.
    $ref = decodeURIComponent($ref.substring(1));
    else throw new Error("Could not find a definition for ".concat(origRef, "."));
    var current = (0, (/*@__PURE__*/$parcel$interopDefault($raQQi))).get(rootSchema, $ref);
    if (current === undefined) throw new Error("Could not find a definition for ".concat(origRef, "."));
    if (current.hasOwnProperty("$ref")) return $d65fe99d36de3cd4$export$ba75abbfed20f81f(current.$ref, rootSchema);
    return current;
} // In the case where we have to implicitly create a schema, it is useful to know what type to use
var $d65fe99d36de3cd4$export$211ef2ad09ba7d20 = function guessType(value) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(value)) return "array";
    else if (typeof value === "string") return "string";
    else if (value == null) return "null";
    else if (typeof value === "boolean") return "boolean";
    else if (!isNaN(value)) return "number";
    else if ((0, $cD46i.default)(value) === "object") return "object";
     // Default to string if we can't figure it out
    return "string";
}; // This function will create new "properties" items for each key in our formData
function $d65fe99d36de3cd4$export$7f455fe1643a61e7(schema) {
    var rootSchema = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var formData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    // Clone the schema so we don't ruin the consumer's original
    schema = (0, $k4zDq.default)({}, schema, {
        properties: (0, $k4zDq.default)({}, schema.properties)
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($8lpxl)))(formData).forEach(function(key) {
        if (schema.properties.hasOwnProperty(key)) // No need to stub, our schema already has the property
        return;
        var additionalProperties;
        if (schema.additionalProperties.hasOwnProperty("$ref")) additionalProperties = $d65fe99d36de3cd4$export$120b571b9a37c370({
            $ref: schema.additionalProperties["$ref"]
        }, rootSchema, formData);
        else if (schema.additionalProperties.hasOwnProperty("type")) additionalProperties = (0, $k4zDq.default)({}, schema.additionalProperties);
        else additionalProperties = {
            type: $d65fe99d36de3cd4$export$211ef2ad09ba7d20(formData[key])
        };
         // The type of our new key should match the additionalProperties value;
        schema.properties[key] = additionalProperties; // Set our additional property flag so we know it was dynamically added
        schema.properties[key][$d65fe99d36de3cd4$export$60d2d9c11642ddd6] = true;
    });
    return schema;
}
function $d65fe99d36de3cd4$export$108f8296d443cf05(schema) {
    var rootSchema = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var formData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (schema.hasOwnProperty("$ref")) return $d65fe99d36de3cd4$var$resolveReference(schema, rootSchema, formData);
    else if (schema.hasOwnProperty("dependencies")) {
        var resolvedSchema = $d65fe99d36de3cd4$var$resolveDependencies(schema, rootSchema, formData);
        return $d65fe99d36de3cd4$export$120b571b9a37c370(resolvedSchema, rootSchema, formData);
    } else if (schema.hasOwnProperty("allOf")) return (0, $k4zDq.default)({}, schema, {
        allOf: schema.allOf.map(function(allOfSubschema) {
            return $d65fe99d36de3cd4$export$120b571b9a37c370(allOfSubschema, rootSchema, formData);
        })
    });
    else // No $ref or dependencies attribute found, returning the original schema.
    return schema;
}
function $d65fe99d36de3cd4$var$resolveReference(schema, rootSchema, formData) {
    // Retrieve the referenced schema definition.
    var $refSchema = $d65fe99d36de3cd4$export$ba75abbfed20f81f(schema.$ref, rootSchema); // Drop the $ref property of the source schema.
    var $ref = schema.$ref, localSchema = (0, $gpTap.default)(schema, [
        "$ref"
    ]); // Update referenced schema definition with local schema properties.
    return $d65fe99d36de3cd4$export$120b571b9a37c370((0, $k4zDq.default)({}, $refSchema, localSchema), rootSchema, formData);
}
function $d65fe99d36de3cd4$export$120b571b9a37c370(schema) {
    var rootSchema = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var formData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!$d65fe99d36de3cd4$export$a6cdc56e425d0d0a(schema)) return {};
    var resolvedSchema = $d65fe99d36de3cd4$export$108f8296d443cf05(schema, rootSchema, formData);
    if ("allOf" in schema) try {
        resolvedSchema = (0, (/*@__PURE__*/$parcel$interopDefault($6j9O2)))((0, $k4zDq.default)({}, resolvedSchema, {
            allOf: resolvedSchema.allOf
        }));
    } catch (e) {
        console.warn("could not merge subschemas in allOf:\n" + e);
        var _resolvedSchema = resolvedSchema, allOf = _resolvedSchema.allOf, resolvedSchemaWithoutAllOf = (0, $gpTap.default)(_resolvedSchema, [
            "allOf"
        ]);
        return resolvedSchemaWithoutAllOf;
    }
    var hasAdditionalProperties = resolvedSchema.hasOwnProperty("additionalProperties") && resolvedSchema.additionalProperties !== false;
    if (hasAdditionalProperties) return $d65fe99d36de3cd4$export$7f455fe1643a61e7(resolvedSchema, rootSchema, formData);
    return resolvedSchema;
}
function $d65fe99d36de3cd4$var$resolveDependencies(schema, rootSchema, formData) {
    // Drop the dependencies from the source schema.
    var _schema$dependencies = schema.dependencies, dependencies = _schema$dependencies === void 0 ? {} : _schema$dependencies, resolvedSchema = (0, $gpTap.default)(schema, [
        "dependencies"
    ]);
    if ("oneOf" in resolvedSchema) resolvedSchema = resolvedSchema.oneOf[$d65fe99d36de3cd4$export$8165cea9d212ff07(formData, resolvedSchema.oneOf, rootSchema)];
    else if ("anyOf" in resolvedSchema) resolvedSchema = resolvedSchema.anyOf[$d65fe99d36de3cd4$export$8165cea9d212ff07(formData, resolvedSchema.anyOf, rootSchema)];
    return $d65fe99d36de3cd4$var$processDependencies(dependencies, resolvedSchema, rootSchema, formData);
}
function $d65fe99d36de3cd4$var$processDependencies(dependencies, resolvedSchema, rootSchema, formData) {
    // Process dependencies updating the local schema properties as appropriate.
    for(var dependencyKey in dependencies){
        // Skip this dependency if its trigger property is not present.
        if (formData[dependencyKey] === undefined) continue;
         // Skip this dependency if it is not included in the schema (such as when dependencyKey is itself a hidden dependency.)
        if (resolvedSchema.properties && !(dependencyKey in resolvedSchema.properties)) continue;
        var dependencyValue = dependencies[dependencyKey], remainingDependencies = (0, $gpTap.default)(dependencies, [
            dependencyKey
        ].map($d65fe99d36de3cd4$var$_toPropertyKey));
        if ((0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(dependencyValue)) resolvedSchema = $d65fe99d36de3cd4$var$withDependentProperties(resolvedSchema, dependencyValue);
        else if ($d65fe99d36de3cd4$export$a6cdc56e425d0d0a(dependencyValue)) resolvedSchema = $d65fe99d36de3cd4$var$withDependentSchema(resolvedSchema, rootSchema, formData, dependencyKey, dependencyValue);
        return $d65fe99d36de3cd4$var$processDependencies(remainingDependencies, resolvedSchema, rootSchema, formData);
    }
    return resolvedSchema;
}
function $d65fe99d36de3cd4$var$withDependentProperties(schema, additionallyRequired) {
    if (!additionallyRequired) return schema;
    var required = (0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(schema.required) ? (0, (/*@__PURE__*/$parcel$interopDefault($UVaxg)))(new (0, (/*@__PURE__*/$parcel$interopDefault($lyRnQ)))([].concat((0, $4juyi.default)(schema.required), (0, $4juyi.default)(additionallyRequired)))) : additionallyRequired;
    return (0, $k4zDq.default)({}, schema, {
        required: required
    });
}
function $d65fe99d36de3cd4$var$withDependentSchema(schema, rootSchema, formData, dependencyKey, dependencyValue) {
    var _retrieveSchema = $d65fe99d36de3cd4$export$120b571b9a37c370(dependencyValue, rootSchema, formData), oneOf = _retrieveSchema.oneOf, dependentSchema = (0, $gpTap.default)(_retrieveSchema, [
        "oneOf"
    ]);
    schema = $d65fe99d36de3cd4$export$dd610e1878d5f5e(schema, dependentSchema); // Since it does not contain oneOf, we return the original schema.
    if (oneOf === undefined) return schema;
    else if (!(0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(oneOf)) throw new Error("invalid: it is some ".concat((0, $cD46i.default)(oneOf), " instead of an array"));
     // Resolve $refs inside oneOf.
    var resolvedOneOf = oneOf.map(function(subschema) {
        return subschema.hasOwnProperty("$ref") ? $d65fe99d36de3cd4$var$resolveReference(subschema, rootSchema, formData) : subschema;
    });
    return $d65fe99d36de3cd4$var$withExactlyOneSubschema(schema, rootSchema, formData, dependencyKey, resolvedOneOf);
}
function $d65fe99d36de3cd4$var$withExactlyOneSubschema(schema, rootSchema, formData, dependencyKey, oneOf) {
    var validSubschemas = oneOf.filter(function(subschema) {
        if (!subschema.properties) return false;
        var conditionPropertySchema = subschema.properties[dependencyKey];
        if (conditionPropertySchema) {
            var conditionSchema = {
                type: "object",
                properties: (0, $kB4x2.default)({}, dependencyKey, conditionPropertySchema)
            };
            var _validateFormData = (0, $3cXpG.default)(formData, conditionSchema), errors = _validateFormData.errors;
            return errors.length === 0;
        }
    });
    if (validSubschemas.length !== 1) {
        console.warn("ignoring oneOf in dependencies because there isn't exactly one subschema that is valid");
        return schema;
    }
    var subschema = validSubschemas[0];
    var _subschema$properties = subschema.properties, conditionPropertySchema = _subschema$properties[dependencyKey], dependentSubschema = (0, $gpTap.default)(_subschema$properties, [
        dependencyKey
    ].map($d65fe99d36de3cd4$var$_toPropertyKey));
    var dependentSchema = (0, $k4zDq.default)({}, subschema, {
        properties: dependentSubschema
    });
    return $d65fe99d36de3cd4$export$dd610e1878d5f5e(schema, $d65fe99d36de3cd4$export$120b571b9a37c370(dependentSchema, rootSchema, formData));
} // Recursively merge deeply nested schemas.
function $d65fe99d36de3cd4$export$dd610e1878d5f5e(obj1, obj2) {
    var acc = (0, $cG9FK.default)({}, obj1); // Prevent mutation of source object.
    return (0, (/*@__PURE__*/$parcel$interopDefault($8lpxl)))(obj2).reduce(function(acc, key) {
        var left = obj1 ? obj1[key] : {}, right = obj2[key];
        if (obj1 && obj1.hasOwnProperty(key) && $d65fe99d36de3cd4$export$a6cdc56e425d0d0a(right)) acc[key] = $d65fe99d36de3cd4$export$dd610e1878d5f5e(left, right);
        else if (obj1 && obj2 && ($d65fe99d36de3cd4$export$c37d213d49c78145(obj1) === "object" || $d65fe99d36de3cd4$export$c37d213d49c78145(obj2) === "object") && key === "required" && (0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(left) && (0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(right)) // Don't include duplicate values when merging
        // "required" fields.
        acc[key] = (0, (/*@__PURE__*/$parcel$interopDefault($1c10x)))(left, right);
        else acc[key] = right;
        return acc;
    }, acc);
}
function $d65fe99d36de3cd4$var$isArguments(object) {
    return Object.prototype.toString.call(object) === "[object Arguments]";
}
function $d65fe99d36de3cd4$export$73ce4178444047a5(a, b) {
    var ca = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var cb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    // Partially extracted from node-deeper and adapted to exclude comparison
    // checks for functions.
    // https://github.com/othiym23/node-deeper
    if (a === b) return true;
    else if (typeof a === "function" || typeof b === "function") // Assume all functions are equivalent
    // see https://github.com/rjsf-team/react-jsonschema-form/issues/255
    return true;
    else if ((0, $cD46i.default)(a) !== "object" || (0, $cD46i.default)(b) !== "object") return false;
    else if (a === null || b === null) return false;
    else if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
    else if (a instanceof RegExp && b instanceof RegExp) return a.source === b.source && a.global === b.global && a.multiline === b.multiline && a.lastIndex === b.lastIndex && a.ignoreCase === b.ignoreCase;
    else if ($d65fe99d36de3cd4$var$isArguments(a) || $d65fe99d36de3cd4$var$isArguments(b)) {
        if (!($d65fe99d36de3cd4$var$isArguments(a) && $d65fe99d36de3cd4$var$isArguments(b))) return false;
        var slice = Array.prototype.slice;
        return $d65fe99d36de3cd4$export$73ce4178444047a5(slice.call(a), slice.call(b), ca, cb);
    } else {
        if (a.constructor !== b.constructor) return false;
        var ka = (0, (/*@__PURE__*/$parcel$interopDefault($8lpxl)))(a);
        var kb = (0, (/*@__PURE__*/$parcel$interopDefault($8lpxl)))(b); // don't bother with stack acrobatics if there's nothing there
        if (ka.length === 0 && kb.length === 0) return true;
        if (ka.length !== kb.length) return false;
        var cal = ca.length;
        while(cal--){
            if (ca[cal] === a) return cb[cal] === b;
        }
        ca.push(a);
        cb.push(b);
        ka.sort();
        kb.sort();
        for(var j = ka.length - 1; j >= 0; j--){
            if (ka[j] !== kb[j]) return false;
        }
        var key;
        for(var k = ka.length - 1; k >= 0; k--){
            key = ka[k];
            if (!$d65fe99d36de3cd4$export$73ce4178444047a5(a[key], b[key], ca, cb)) return false;
        }
        ca.pop();
        cb.pop();
        return true;
    }
}
function $d65fe99d36de3cd4$export$74f9e9340d52d089(comp, nextProps, nextState) {
    var props = comp.props, state = comp.state;
    return !$d65fe99d36de3cd4$export$73ce4178444047a5(props, nextProps) || !$d65fe99d36de3cd4$export$73ce4178444047a5(state, nextState);
}
function $d65fe99d36de3cd4$export$9e93037aa8764d4d(schema, id, rootSchema) {
    var formData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var idPrefix = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "root";
    var idSchema = {
        $id: id || idPrefix
    };
    if ("$ref" in schema || "dependencies" in schema || "allOf" in schema) {
        var _schema = $d65fe99d36de3cd4$export$120b571b9a37c370(schema, rootSchema, formData);
        return $d65fe99d36de3cd4$export$9e93037aa8764d4d(_schema, id, rootSchema, formData, idPrefix);
    }
    if ("items" in schema && !schema.items.$ref) return $d65fe99d36de3cd4$export$9e93037aa8764d4d(schema.items, id, rootSchema, formData, idPrefix);
    if (schema.type !== "object") return idSchema;
    for(var name in schema.properties || {}){
        var field = schema.properties[name];
        var fieldId = idSchema.$id + "_" + name;
        idSchema[name] = $d65fe99d36de3cd4$export$9e93037aa8764d4d($d65fe99d36de3cd4$export$a6cdc56e425d0d0a(field) ? field : {}, fieldId, rootSchema, // array item has just been added, but not populated with data yet
        (formData || {})[name], idPrefix);
    }
    return idSchema;
}
function $d65fe99d36de3cd4$export$7c522d40b1c31ae0(schema) {
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var rootSchema = arguments.length > 2 ? arguments[2] : undefined;
    var formData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var pathSchema = {
        $name: name.replace(/^\./, "")
    };
    if ("$ref" in schema || "dependencies" in schema || "allOf" in schema) {
        var _schema = $d65fe99d36de3cd4$export$120b571b9a37c370(schema, rootSchema, formData);
        return $d65fe99d36de3cd4$export$7c522d40b1c31ae0(_schema, name, rootSchema, formData);
    }
    if (schema.hasOwnProperty("additionalProperties")) pathSchema.__rjsf_additionalProperties = true;
    if (schema.hasOwnProperty("items") && (0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(formData)) formData.forEach(function(element, i) {
        pathSchema[i] = $d65fe99d36de3cd4$export$7c522d40b1c31ae0(schema.items, "".concat(name, ".").concat(i), rootSchema, element);
    });
    else if (schema.hasOwnProperty("properties")) for(var property in schema.properties)pathSchema[property] = $d65fe99d36de3cd4$export$7c522d40b1c31ae0(schema.properties[property], "".concat(name, ".").concat(property), rootSchema, // array item has just been added, but not populated with data yet
    (formData || {})[property]);
    return pathSchema;
}
function $d65fe99d36de3cd4$export$e684af8cfb294f41(dateString) {
    var includeTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (!dateString) return {
        year: -1,
        month: -1,
        day: -1,
        hour: includeTime ? -1 : 0,
        minute: includeTime ? -1 : 0,
        second: includeTime ? -1 : 0
    };
    var date = new Date(dateString);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($kltfT)))(date.getTime())) throw new Error("Unable to parse date " + dateString);
    return {
        year: date.getUTCFullYear(),
        month: date.getUTCMonth() + 1,
        // oh you, javascript.
        day: date.getUTCDate(),
        hour: includeTime ? date.getUTCHours() : 0,
        minute: includeTime ? date.getUTCMinutes() : 0,
        second: includeTime ? date.getUTCSeconds() : 0
    };
}
function $d65fe99d36de3cd4$export$b7c4e1545c61edee(_ref2) {
    var year = _ref2.year, month = _ref2.month, day = _ref2.day, _ref2$hour = _ref2.hour, hour = _ref2$hour === void 0 ? 0 : _ref2$hour, _ref2$minute = _ref2.minute, minute = _ref2$minute === void 0 ? 0 : _ref2$minute, _ref2$second = _ref2.second, second = _ref2$second === void 0 ? 0 : _ref2$second;
    var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var utcTime = Date.UTC(year, month - 1, day, hour, minute, second);
    var datetime = new Date(utcTime).toJSON();
    return time ? datetime : datetime.slice(0, 10);
}
function $d65fe99d36de3cd4$export$ccd9a1bc6174ad42(jsonDate) {
    if (!jsonDate) return "";
     // required format of `"yyyy-MM-ddThh:mm" followed by optional ":ss" or ":ss.SSS"
    // https://html.spec.whatwg.org/multipage/input.html#local-date-and-time-state-(type%3Ddatetime-local)
    // > should be a _valid local date and time string_ (not GMT)
    // Note - date constructor passed local ISO-8601 does not correctly
    // change time to UTC in node pre-8
    var date = new Date(jsonDate);
    var yyyy = $d65fe99d36de3cd4$export$5d04458e2a6c373e(date.getFullYear(), 4);
    var MM = $d65fe99d36de3cd4$export$5d04458e2a6c373e(date.getMonth() + 1, 2);
    var dd = $d65fe99d36de3cd4$export$5d04458e2a6c373e(date.getDate(), 2);
    var hh = $d65fe99d36de3cd4$export$5d04458e2a6c373e(date.getHours(), 2);
    var mm = $d65fe99d36de3cd4$export$5d04458e2a6c373e(date.getMinutes(), 2);
    var ss = $d65fe99d36de3cd4$export$5d04458e2a6c373e(date.getSeconds(), 2);
    var SSS = $d65fe99d36de3cd4$export$5d04458e2a6c373e(date.getMilliseconds(), 3);
    return "".concat(yyyy, "-").concat(MM, "-").concat(dd, "T").concat(hh, ":").concat(mm, ":").concat(ss, ".").concat(SSS);
}
function $d65fe99d36de3cd4$export$779990c68cce4240(dateString) {
    if (dateString) return new Date(dateString).toJSON();
}
function $d65fe99d36de3cd4$export$5d04458e2a6c373e(num, size) {
    var s = String(num);
    while(s.length < size)s = "0" + s;
    return s;
}
function $d65fe99d36de3cd4$export$24bc7e761c190a9f(dataURI) {
    // Split metadata from data
    var splitted = dataURI.split(","); // Split params
    var params = splitted[0].split(";"); // Get mime-type from params
    var type = params[0].replace("data:", ""); // Filter the name property from params
    var properties = params.filter(function(param) {
        return param.split("=")[0] === "name";
    }); // Look for the name and use unknown if no name property.
    var name;
    if (properties.length !== 1) name = "unknown";
    else // Because we filtered out the other property,
    // we only have the name case here.
    name = properties[0].split("=")[1];
     // Built the Uint8Array Blob parameter from the base64 string.
    var binary = atob(splitted[1]);
    var array = [];
    for(var i = 0; i < binary.length; i++)array.push(binary.charCodeAt(i));
     // Create the blob object
    var blob = new window.Blob([
        new Uint8Array(array)
    ], {
        type: type
    });
    return {
        blob: blob,
        name: name
    };
}
function $d65fe99d36de3cd4$export$241fd4b305d2db0a(schema) {
    var spec = {};
    if (schema.multipleOf) spec.step = schema.multipleOf;
    if (schema.minimum || schema.minimum === 0) spec.min = schema.minimum;
    if (schema.maximum || schema.maximum === 0) spec.max = schema.maximum;
    return spec;
}
function $d65fe99d36de3cd4$export$8165cea9d212ff07(formData, options, rootSchema) {
    for(var i = 0; i < options.length; i++){
        var option = options[i]; // If the schema describes an object then we need to add slightly more
        // strict matching to the schema, because unless the schema uses the
        // "requires" keyword, an object will match the schema as long as it
        // doesn't have matching keys with a conflicting type. To do this we use an
        // "anyOf" with an array of requires. This augmentation expresses that the
        // schema should match if any of the keys in the schema are present on the
        // object and pass validation.
        if (option.properties) {
            // Create an "anyOf" schema that requires at least one of the keys in the
            // "properties" object
            var requiresAnyOf = {
                anyOf: (0, (/*@__PURE__*/$parcel$interopDefault($8lpxl)))(option.properties).map(function(key) {
                    return {
                        required: [
                            key
                        ]
                    };
                })
            };
            var augmentedSchema = void 0; // If the "anyOf" keyword already exists, wrap the augmentation in an "allOf"
            if (option.anyOf) {
                // Create a shallow clone of the option
                var shallowClone = (0, $cG9FK.default)({}, option);
                if (!shallowClone.allOf) shallowClone.allOf = [];
                else // If "allOf" already exists, shallow clone the array
                shallowClone.allOf = shallowClone.allOf.slice();
                shallowClone.allOf.push(requiresAnyOf);
                augmentedSchema = shallowClone;
            } else augmentedSchema = (0, $cG9FK.default)({}, option, requiresAnyOf);
             // Remove the "required" field as it's likely that not all fields have
            // been filled in yet, which will mean that the schema is not valid
            delete augmentedSchema.required;
            if ((0, $3cXpG.isValid)(augmentedSchema, formData)) return i;
        } else if ((0, $3cXpG.isValid)(options[i], formData)) return i;
    }
    return 0;
} // Check to see if a schema specifies that a value must be true
function $d65fe99d36de3cd4$export$1203181f0b231402(schema) {
    // Check if const is a truthy value
    if (schema["const"]) return true;
     // Check if an enum has a single value of true
    if (schema["enum"] && schema["enum"].length === 1 && schema["enum"][0] === true) return true;
     // If anyOf has a single value, evaluate the subschema
    if (schema.anyOf && schema.anyOf.length === 1) return $d65fe99d36de3cd4$export$1203181f0b231402(schema.anyOf[0]);
     // If oneOf has a single value, evaluate the subschema
    if (schema.oneOf && schema.oneOf.length === 1) return $d65fe99d36de3cd4$export$1203181f0b231402(schema.oneOf[0]);
     // Evaluate each subschema in allOf, to see if one of them requires a true
    // value
    if (schema.allOf) return schema.allOf.some($d65fe99d36de3cd4$export$1203181f0b231402);
    return false;
}

});
parcelRegister("6I5NX", function(module, exports) {

module.exports = (parcelRequire("527wD"));

});
parcelRegister("527wD", function(module, exports) {

module.exports = (parcelRequire("195ps")).f("toPrimitive");

});


parcelRegister("lyRnQ", function(module, exports) {

module.exports = (parcelRequire("baDyW"));

});
parcelRegister("baDyW", function(module, exports) {
parcelRequire("6JkF2");
parcelRequire("kPnXr");
parcelRequire("hfW11");
parcelRequire("g2I6P");
parcelRequire("8tNAh");
parcelRequire("3AHRg");
parcelRequire("9Wy1j");

module.exports = (parcelRequire("314Mo")).Set;

});
parcelRegister("g2I6P", function(module, exports) {
"use strict";

var $ak3qw = parcelRequire("ak3qw");

var $jE82y = parcelRequire("jE82y");
var $badf0c606cf327cc$var$SET = "Set";

// 23.2 Set Objects
module.exports = (parcelRequire("8llRH"))($badf0c606cf327cc$var$SET, function(get) {
    return function Set() {
        return get(this, arguments.length > 0 ? arguments[0] : undefined);
    };
}, {
    // 23.2.3.1 Set.prototype.add(value)
    add: function add(value) {
        return $ak3qw.def($jE82y(this, $badf0c606cf327cc$var$SET), value = value === 0 ? 0 : value, value);
    }
}, $ak3qw);

});
parcelRegister("ak3qw", function(module, exports) {
"use strict";

var $4aG98 = parcelRequire("4aG98");
var $783e6e26b2ad9f44$require$dP = $4aG98.f;

var $98yfN = parcelRequire("98yfN");

var $iGcAD = parcelRequire("iGcAD");

var $5iFqY = parcelRequire("5iFqY");

var $heUpR = parcelRequire("heUpR");

var $92nMp = parcelRequire("92nMp");

var $kb1OX = parcelRequire("kb1OX");

var $8v1Yx = parcelRequire("8v1Yx");

var $hUMoU = parcelRequire("hUMoU");

var $4G9qa = parcelRequire("4G9qa");

var $gS7kc = parcelRequire("gS7kc");
var $783e6e26b2ad9f44$require$fastKey = $gS7kc.fastKey;

var $jE82y = parcelRequire("jE82y");
var $783e6e26b2ad9f44$var$SIZE = $4G9qa ? "_s" : "size";
var $783e6e26b2ad9f44$var$getEntry = function(that, key) {
    // fast case
    var index = $783e6e26b2ad9f44$require$fastKey(key);
    var entry;
    if (index !== "F") return that._i[index];
    // frozen object case
    for(entry = that._f; entry; entry = entry.n){
        if (entry.k == key) return entry;
    }
};
module.exports = {
    getConstructor: function(wrapper, NAME, IS_MAP, ADDER) {
        var C = wrapper(function(that, iterable) {
            $heUpR(that, C, NAME, "_i");
            that._t = NAME; // collection type
            that._i = $98yfN(null); // index
            that._f = undefined; // first entry
            that._l = undefined; // last entry
            that[$783e6e26b2ad9f44$var$SIZE] = 0; // size
            if (iterable != undefined) $92nMp(iterable, IS_MAP, that[ADDER], that);
        });
        $iGcAD(C.prototype, {
            // 23.1.3.1 Map.prototype.clear()
            // 23.2.3.2 Set.prototype.clear()
            clear: function clear() {
                for(var that = $jE82y(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n){
                    entry.r = true;
                    if (entry.p) entry.p = entry.p.n = undefined;
                    delete data[entry.i];
                }
                that._f = that._l = undefined;
                that[$783e6e26b2ad9f44$var$SIZE] = 0;
            },
            // 23.1.3.3 Map.prototype.delete(key)
            // 23.2.3.4 Set.prototype.delete(value)
            "delete": function(key) {
                var that = $jE82y(this, NAME);
                var entry = $783e6e26b2ad9f44$var$getEntry(that, key);
                if (entry) {
                    var next = entry.n;
                    var prev = entry.p;
                    delete that._i[entry.i];
                    entry.r = true;
                    if (prev) prev.n = next;
                    if (next) next.p = prev;
                    if (that._f == entry) that._f = next;
                    if (that._l == entry) that._l = prev;
                    that[$783e6e26b2ad9f44$var$SIZE]--;
                }
                return !!entry;
            },
            // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
            // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
            forEach: function forEach(callbackfn /* , that = undefined */ ) {
                $jE82y(this, NAME);
                var f = $5iFqY(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
                var entry;
                while(entry = entry ? entry.n : this._f){
                    f(entry.v, entry.k, this);
                    // revert to the last existing entry
                    while(entry && entry.r)entry = entry.p;
                }
            },
            // 23.1.3.7 Map.prototype.has(key)
            // 23.2.3.7 Set.prototype.has(value)
            has: function has(key) {
                return !!$783e6e26b2ad9f44$var$getEntry($jE82y(this, NAME), key);
            }
        });
        if ($4G9qa) $783e6e26b2ad9f44$require$dP(C.prototype, "size", {
            get: function() {
                return $jE82y(this, NAME)[$783e6e26b2ad9f44$var$SIZE];
            }
        });
        return C;
    },
    def: function(that, key, value) {
        var entry = $783e6e26b2ad9f44$var$getEntry(that, key);
        var prev, index;
        // change existing entry
        if (entry) entry.v = value;
        else {
            that._l = entry = {
                i: index = $783e6e26b2ad9f44$require$fastKey(key, true),
                k: key,
                v: value,
                p: prev = that._l,
                n: undefined,
                r: false // <- removed
            };
            if (!that._f) that._f = entry;
            if (prev) prev.n = entry;
            that[$783e6e26b2ad9f44$var$SIZE]++;
            // add to index
            if (index !== "F") that._i[index] = entry;
        }
        return that;
    },
    getEntry: $783e6e26b2ad9f44$var$getEntry,
    setStrong: function(C, NAME, IS_MAP) {
        // add .keys, .values, .entries, [@@iterator]
        // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
        $kb1OX(C, NAME, function(iterated, kind) {
            this._t = $jE82y(iterated, NAME); // target
            this._k = kind; // kind
            this._l = undefined; // previous
        }, function() {
            var that = this;
            var kind = that._k;
            var entry = that._l;
            // revert to the last existing entry
            while(entry && entry.r)entry = entry.p;
            // get next entry
            if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
                // or finish the iteration
                that._t = undefined;
                return $8v1Yx(1);
            }
            // return step by kind
            if (kind == "keys") return $8v1Yx(0, entry.k);
            if (kind == "values") return $8v1Yx(0, entry.v);
            return $8v1Yx(0, [
                entry.k,
                entry.v
            ]);
        }, IS_MAP ? "entries" : "values", !IS_MAP, true);
        // add [@@species], 23.1.2.2, 23.2.2.2
        $hUMoU(NAME);
    }
};

});
parcelRegister("iGcAD", function(module, exports) {

var $jSmLC = parcelRequire("jSmLC");
module.exports = function(target, src, safe) {
    for(var key in src)if (safe && target[key]) target[key] = src[key];
    else $jSmLC(target, key, src[key]);
    return target;
};

});

parcelRegister("heUpR", function(module, exports) {
module.exports = function(it, Constructor, name, forbiddenField) {
    if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) throw TypeError(name + ": incorrect invocation!");
    return it;
};

});

parcelRegister("92nMp", function(module, exports) {

var $5iFqY = parcelRequire("5iFqY");

var $aVWdF = parcelRequire("aVWdF");

var $47BGV = parcelRequire("47BGV");

var $52hVC = parcelRequire("52hVC");

var $cqWYf = parcelRequire("cqWYf");

var $frxUU = parcelRequire("frxUU");
var $6946bf1c75013286$var$BREAK = {};
var $6946bf1c75013286$var$RETURN = {};
var $6946bf1c75013286$var$exports = module.exports = function(iterable, entries, fn, that, ITERATOR) {
    var iterFn = ITERATOR ? function() {
        return iterable;
    } : $frxUU(iterable);
    var f = $5iFqY(fn, that, entries ? 2 : 1);
    var index = 0;
    var length, step, iterator, result;
    if (typeof iterFn != "function") throw TypeError(iterable + " is not iterable!");
    // fast case for arrays with default iterator
    if ($47BGV(iterFn)) for(length = $cqWYf(iterable.length); length > index; index++){
        result = entries ? f($52hVC(step = iterable[index])[0], step[1]) : f(iterable[index]);
        if (result === $6946bf1c75013286$var$BREAK || result === $6946bf1c75013286$var$RETURN) return result;
    }
    else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done;){
        result = $aVWdF(iterator, f, step.value, entries);
        if (result === $6946bf1c75013286$var$BREAK || result === $6946bf1c75013286$var$RETURN) return result;
    }
};
$6946bf1c75013286$var$exports.BREAK = $6946bf1c75013286$var$BREAK;
$6946bf1c75013286$var$exports.RETURN = $6946bf1c75013286$var$RETURN;

});
parcelRegister("aVWdF", function(module, exports) {
// call something on iterator step with safe closing on error

var $52hVC = parcelRequire("52hVC");
module.exports = function(iterator, fn, value, entries) {
    try {
        return entries ? fn($52hVC(value)[0], value[1]) : fn(value);
    // 7.4.6 IteratorClose(iterator, completion)
    } catch (e) {
        var ret = iterator["return"];
        if (ret !== undefined) $52hVC(ret.call(iterator));
        throw e;
    }
};

});

parcelRegister("47BGV", function(module, exports) {
// check on default Array iterator

var $gVXUH = parcelRequire("gVXUH");

var $30050d97e110dd2b$var$ITERATOR = (parcelRequire("isDo7"))("iterator");
var $30050d97e110dd2b$var$ArrayProto = Array.prototype;
module.exports = function(it) {
    return it !== undefined && ($gVXUH.Array === it || $30050d97e110dd2b$var$ArrayProto[$30050d97e110dd2b$var$ITERATOR] === it);
};

});

parcelRegister("frxUU", function(module, exports) {

var $gFwGK = parcelRequire("gFwGK");

var $b3e3afce7979266c$var$ITERATOR = (parcelRequire("isDo7"))("iterator");

var $gVXUH = parcelRequire("gVXUH");

module.exports = (parcelRequire("314Mo")).getIteratorMethod = function(it) {
    if (it != undefined) return it[$b3e3afce7979266c$var$ITERATOR] || it["@@iterator"] || $gVXUH[$gFwGK(it)];
};

});
parcelRegister("gFwGK", function(module, exports) {
// getting tag from 19.1.3.6 Object.prototype.toString()

var $2aVBS = parcelRequire("2aVBS");

var $c229d4ed8cd471e7$var$TAG = (parcelRequire("isDo7"))("toStringTag");
// ES3 wrong here
var $c229d4ed8cd471e7$var$ARG = $2aVBS(function() {
    return arguments;
}()) == "Arguments";
// fallback for IE11 Script Access Denied error
var $c229d4ed8cd471e7$var$tryGet = function(it, key) {
    try {
        return it[key];
    } catch (e) {}
};
module.exports = function(it) {
    var O, T, B;
    return it === undefined ? "Undefined" : it === null ? "Null" : typeof (T = $c229d4ed8cd471e7$var$tryGet(O = Object(it), $c229d4ed8cd471e7$var$TAG)) == "string" ? T : $c229d4ed8cd471e7$var$ARG ? $2aVBS(O) : (B = $2aVBS(O)) == "Object" && typeof O.callee == "function" ? "Arguments" : B;
};

});



parcelRegister("hUMoU", function(module, exports) {
"use strict";

var $llv21 = parcelRequire("llv21");

var $314Mo = parcelRequire("314Mo");

var $4aG98 = parcelRequire("4aG98");

var $4G9qa = parcelRequire("4G9qa");

var $d0ad3601c913a6dd$var$SPECIES = (parcelRequire("isDo7"))("species");
module.exports = function(KEY) {
    var C = typeof $314Mo[KEY] == "function" ? $314Mo[KEY] : $llv21[KEY];
    if ($4G9qa && C && !C[$d0ad3601c913a6dd$var$SPECIES]) $4aG98.f(C, $d0ad3601c913a6dd$var$SPECIES, {
        configurable: true,
        get: function() {
            return this;
        }
    });
};

});

parcelRegister("jE82y", function(module, exports) {

var $6sMmO = parcelRequire("6sMmO");
module.exports = function(it, TYPE) {
    if (!$6sMmO(it) || it._t !== TYPE) throw TypeError("Incompatible receiver, " + TYPE + " required!");
    return it;
};

});


parcelRegister("8llRH", function(module, exports) {
"use strict";

var $llv21 = parcelRequire("llv21");

var $kEXpx = parcelRequire("kEXpx");

var $gS7kc = parcelRequire("gS7kc");

var $g49ub = parcelRequire("g49ub");

var $jSmLC = parcelRequire("jSmLC");

var $iGcAD = parcelRequire("iGcAD");

var $92nMp = parcelRequire("92nMp");

var $heUpR = parcelRequire("heUpR");

var $6sMmO = parcelRequire("6sMmO");

var $2l8lG = parcelRequire("2l8lG");

var $4aG98 = parcelRequire("4aG98");
var $61313edd99863283$require$dP = $4aG98.f;

var $61313edd99863283$var$each = (parcelRequire("hlkFl"))(0);

var $4G9qa = parcelRequire("4G9qa");
module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
    var Base = $llv21[NAME];
    var C = Base;
    var ADDER = IS_MAP ? "set" : "add";
    var proto = C && C.prototype;
    var O = {};
    if (!$4G9qa || typeof C != "function" || !(IS_WEAK || proto.forEach && !$g49ub(function() {
        new C().entries().next();
    }))) {
        // create collection constructor
        C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
        $iGcAD(C.prototype, methods);
        $gS7kc.NEED = true;
    } else {
        C = wrapper(function(target, iterable) {
            $heUpR(target, C, NAME, "_c");
            target._c = new Base();
            if (iterable != undefined) $92nMp(iterable, IS_MAP, target[ADDER], target);
        });
        $61313edd99863283$var$each("add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON".split(","), function(KEY) {
            var IS_ADDER = KEY == "add" || KEY == "set";
            if (KEY in proto && !(IS_WEAK && KEY == "clear")) $jSmLC(C.prototype, KEY, function(a, b) {
                $heUpR(this, C, KEY);
                if (!IS_ADDER && IS_WEAK && !$6sMmO(a)) return KEY == "get" ? undefined : false;
                var result = this._c[KEY](a === 0 ? 0 : a, b);
                return IS_ADDER ? this : result;
            });
        });
        IS_WEAK || $61313edd99863283$require$dP(C.prototype, "size", {
            get: function() {
                return this._c.size;
            }
        });
    }
    $2l8lG(C, NAME);
    O[NAME] = C;
    $kEXpx($kEXpx.G + $kEXpx.W + $kEXpx.F, O);
    if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
    return C;
};

});
parcelRegister("hlkFl", function(module, exports) {
// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex

var $5iFqY = parcelRequire("5iFqY");

var $39tBo = parcelRequire("39tBo");

var $jK6u7 = parcelRequire("jK6u7");

var $cqWYf = parcelRequire("cqWYf");

var $021LZ = parcelRequire("021LZ");
module.exports = function(TYPE, $create) {
    var IS_MAP = TYPE == 1;
    var IS_FILTER = TYPE == 2;
    var IS_SOME = TYPE == 3;
    var IS_EVERY = TYPE == 4;
    var IS_FIND_INDEX = TYPE == 6;
    var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
    var create = $create || $021LZ;
    return function($this, callbackfn, that) {
        var O = $jK6u7($this);
        var self = $39tBo(O);
        var f = $5iFqY(callbackfn, that, 3);
        var length = $cqWYf(self.length);
        var index = 0;
        var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
        var val, res;
        for(; length > index; index++)if (NO_HOLES || index in self) {
            val = self[index];
            res = f(val, index, O);
            if (TYPE) {
                if (IS_MAP) result[index] = res; // map
                else if (res) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return val; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        result.push(val); // filter
                }
                else if (IS_EVERY) return false; // every
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
    };
};

});
parcelRegister("021LZ", function(module, exports) {
// 9.4.2.3 ArraySpeciesCreate(originalArray, length)

var $eRNdI = parcelRequire("eRNdI");
module.exports = function(original, length) {
    return new ($eRNdI(original))(length);
};

});
parcelRegister("eRNdI", function(module, exports) {

var $6sMmO = parcelRequire("6sMmO");

var $dl4rN = parcelRequire("dl4rN");

var $ad2c320f3ed58e70$var$SPECIES = (parcelRequire("isDo7"))("species");
module.exports = function(original) {
    var C;
    if ($dl4rN(original)) {
        C = original.constructor;
        // cross-realm fallback
        if (typeof C == "function" && (C === Array || $dl4rN(C.prototype))) C = undefined;
        if ($6sMmO(C)) {
            C = C[$ad2c320f3ed58e70$var$SPECIES];
            if (C === null) C = undefined;
        }
    }
    return C === undefined ? Array : C;
};

});





parcelRegister("8tNAh", function(module, exports) {
// https://github.com/DavidBruant/Map-Set.prototype.toJSON

var $kEXpx = parcelRequire("kEXpx");

$kEXpx($kEXpx.P + $kEXpx.R, "Set", {
    toJSON: (parcelRequire("aozz0"))("Set")
});

});
parcelRegister("aozz0", function(module, exports) {
// https://github.com/DavidBruant/Map-Set.prototype.toJSON

var $gFwGK = parcelRequire("gFwGK");

var $eL7U3 = parcelRequire("eL7U3");
module.exports = function(NAME) {
    return function toJSON() {
        if ($gFwGK(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
        return $eL7U3(this);
    };
};

});
parcelRegister("eL7U3", function(module, exports) {

var $92nMp = parcelRequire("92nMp");
module.exports = function(iter, ITERATOR) {
    var result = [];
    $92nMp(iter, false, result.push, result, ITERATOR);
    return result;
};

});



parcelRegister("3AHRg", function(module, exports) {
// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of

(parcelRequire("1N2f5"))("Set");

});
parcelRegister("1N2f5", function(module, exports) {
"use strict";

var $kEXpx = parcelRequire("kEXpx");
module.exports = function(COLLECTION) {
    $kEXpx($kEXpx.S, COLLECTION, {
        of: function of() {
            var length = arguments.length;
            var A = new Array(length);
            while(length--)A[length] = arguments[length];
            return new this(A);
        }
    });
};

});


parcelRegister("9Wy1j", function(module, exports) {
// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from

(parcelRequire("3Hx16"))("Set");

});
parcelRegister("3Hx16", function(module, exports) {
"use strict";

var $kEXpx = parcelRequire("kEXpx");

var $6ZyoG = parcelRequire("6ZyoG");

var $5iFqY = parcelRequire("5iFqY");

var $92nMp = parcelRequire("92nMp");
module.exports = function(COLLECTION) {
    $kEXpx($kEXpx.S, COLLECTION, {
        from: function from(source /* , mapFn, thisArg */ ) {
            var mapFn = arguments[1];
            var mapping, A, n, cb;
            $6ZyoG(this);
            mapping = mapFn !== undefined;
            if (mapping) $6ZyoG(mapFn);
            if (source == undefined) return new this();
            A = [];
            if (mapping) {
                n = 0;
                cb = $5iFqY(mapFn, arguments[2], 2);
                $92nMp(source, false, function(nextItem) {
                    A.push(cb(nextItem, n++));
                });
            } else $92nMp(source, false, A.push, A);
            return new this(A);
        }
    });
};

});




parcelRegister("UVaxg", function(module, exports) {

module.exports = (parcelRequire("9cE9q"));

});
parcelRegister("9cE9q", function(module, exports) {
parcelRequire("kPnXr");
parcelRequire("lihXk");

module.exports = (parcelRequire("314Mo")).Array.from;

});
parcelRegister("lihXk", function(module, exports) {
"use strict";

var $5iFqY = parcelRequire("5iFqY");

var $kEXpx = parcelRequire("kEXpx");

var $jK6u7 = parcelRequire("jK6u7");

var $aVWdF = parcelRequire("aVWdF");

var $47BGV = parcelRequire("47BGV");

var $cqWYf = parcelRequire("cqWYf");

var $dtMIU = parcelRequire("dtMIU");

var $frxUU = parcelRequire("frxUU");

$kEXpx($kEXpx.S + $kEXpx.F * !(parcelRequire("hulk4"))(function(iter) {
    Array.from(iter);
}), "Array", {
    // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
    from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */ ) {
        var O = $jK6u7(arrayLike);
        var C = typeof this == "function" ? this : Array;
        var aLen = arguments.length;
        var mapfn = aLen > 1 ? arguments[1] : undefined;
        var mapping = mapfn !== undefined;
        var index = 0;
        var iterFn = $frxUU(O);
        var length, result, step, iterator;
        if (mapping) mapfn = $5iFqY(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
        // if object isn't iterable or it's array with default iterator - use simple case
        if (iterFn != undefined && !(C == Array && $47BGV(iterFn))) for(iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++)$dtMIU(result, index, mapping ? $aVWdF(iterator, mapfn, [
            step.value,
            index
        ], true) : step.value);
        else {
            length = $cqWYf(O.length);
            for(result = new C(length); length > index; index++)$dtMIU(result, index, mapping ? mapfn(O[index], index) : O[index]);
        }
        result.length = index;
        return result;
    }
});

});
parcelRegister("dtMIU", function(module, exports) {
"use strict";

var $4aG98 = parcelRequire("4aG98");

var $yk0ka = parcelRequire("yk0ka");
module.exports = function(object, index, value) {
    if (index in object) $4aG98.f(object, index, $yk0ka(0, value));
    else object[index] = value;
};

});

parcelRegister("hulk4", function(module, exports) {

var $cbb5c73bd8feab26$var$ITERATOR = (parcelRequire("isDo7"))("iterator");
var $cbb5c73bd8feab26$var$SAFE_CLOSING = false;
try {
    var $cbb5c73bd8feab26$var$riter = [
        7
    ][$cbb5c73bd8feab26$var$ITERATOR]();
    $cbb5c73bd8feab26$var$riter["return"] = function() {
        $cbb5c73bd8feab26$var$SAFE_CLOSING = true;
    };
    // eslint-disable-next-line no-throw-literal
    Array.from($cbb5c73bd8feab26$var$riter, function() {
        throw 2;
    });
} catch (e) {}
module.exports = function(exec, skipClosing) {
    if (!skipClosing && !$cbb5c73bd8feab26$var$SAFE_CLOSING) return false;
    var safe = false;
    try {
        var arr = [
            7
        ];
        var iter = arr[$cbb5c73bd8feab26$var$ITERATOR]();
        iter.next = function() {
            return {
                done: safe = true
            };
        };
        arr[$cbb5c73bd8feab26$var$ITERATOR] = function() {
            return iter;
        };
        exec(arr);
    } catch (e) {}
    return safe;
};

});




parcelRegister("4juyi", function(module, exports) {

$parcel$export(module.exports, "default", () => $3240a2cdaf548396$export$2e2bcd8739ae039);

var $iSMSo = parcelRequire("iSMSo");

var $6KeNC = parcelRequire("6KeNC");

var $53viC = parcelRequire("53viC");

var $9VkKx = parcelRequire("9VkKx");
function $3240a2cdaf548396$export$2e2bcd8739ae039(arr) {
    return (0, $iSMSo.default)(arr) || (0, $6KeNC.default)(arr) || (0, $53viC.default)(arr) || (0, $9VkKx.default)();
}

});
parcelRegister("iSMSo", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbf32ef460684a38$export$2e2bcd8739ae039);

var $a5du3 = parcelRequire("a5du3");

var $bCLYS = parcelRequire("bCLYS");
function $dbf32ef460684a38$export$2e2bcd8739ae039(arr) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(arr)) return (0, $bCLYS.default)(arr);
}

});
parcelRegister("bCLYS", function(module, exports) {

$parcel$export(module.exports, "default", () => $876876553870df97$export$2e2bcd8739ae039);
function $876876553870df97$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRegister("6KeNC", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e9284ca1ae57865$export$2e2bcd8739ae039);

var $ePChe = parcelRequire("ePChe");

var $fjvI1 = parcelRequire("fjvI1");

var $UVaxg = parcelRequire("UVaxg");
function $4e9284ca1ae57865$export$2e2bcd8739ae039(iter) {
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($ePChe))) !== "undefined" && iter[0, (/*@__PURE__*/$parcel$interopDefault($fjvI1))] != null || iter["@@iterator"] != null) return (0, (/*@__PURE__*/$parcel$interopDefault($UVaxg)))(iter);
}

});

parcelRegister("53viC", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ae582f19e0170c9$export$2e2bcd8739ae039);

var $UVaxg = parcelRequire("UVaxg");

var $bCLYS = parcelRequire("bCLYS");
function $3ae582f19e0170c9$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $bCLYS.default)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return (0, (/*@__PURE__*/$parcel$interopDefault($UVaxg)))(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $bCLYS.default)(o, minLen);
}

});

parcelRegister("9VkKx", function(module, exports) {

$parcel$export(module.exports, "default", () => $7399885b8c7bf341$export$2e2bcd8739ae039);
function $7399885b8c7bf341$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("kltfT", function(module, exports) {

module.exports = (parcelRequire("lkXAl"));

});
parcelRegister("lkXAl", function(module, exports) {
parcelRequire("2VE5J");

module.exports = (parcelRequire("314Mo")).Number.isNaN;

});
parcelRegister("2VE5J", function(module, exports) {
// 20.1.2.4 Number.isNaN(number)

var $kEXpx = parcelRequire("kEXpx");
$kEXpx($kEXpx.S, "Number", {
    isNaN: function isNaN(number) {
        // eslint-disable-next-line no-self-compare
        return number != number;
    }
});

});



parcelRegister("cG9FK", function(module, exports) {

$parcel$export(module.exports, "default", () => $93b0e8fbc3633a62$export$2e2bcd8739ae039);

var $4Y5xJ = parcelRequire("4Y5xJ");
function $93b0e8fbc3633a62$export$2e2bcd8739ae039() {
    $93b0e8fbc3633a62$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($4Y5xJ))) || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $93b0e8fbc3633a62$export$2e2bcd8739ae039.apply(this, arguments);
}

});
parcelRegister("4Y5xJ", function(module, exports) {

module.exports = (parcelRequire("3aKJv"));

});
parcelRegister("3aKJv", function(module, exports) {
parcelRequire("kJvvQ");

module.exports = (parcelRequire("314Mo")).Object.assign;

});
parcelRegister("kJvvQ", function(module, exports) {
// 19.1.3.1 Object.assign(target, source)

var $kEXpx = parcelRequire("kEXpx");

$kEXpx($kEXpx.S + $kEXpx.F, "Object", {
    assign: (parcelRequire("d9qFO"))
});

});
parcelRegister("d9qFO", function(module, exports) {
"use strict";

var $4G9qa = parcelRequire("4G9qa");

var $iGTn6 = parcelRequire("iGTn6");

var $iLHFk = parcelRequire("iLHFk");

var $kNK9k = parcelRequire("kNK9k");

var $jK6u7 = parcelRequire("jK6u7");

var $39tBo = parcelRequire("39tBo");
var $9930ce68330d1101$var$$assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$9930ce68330d1101$var$$assign || (parcelRequire("g49ub"))(function() {
    var A = {};
    var B = {};
    // eslint-disable-next-line no-undef
    var S = Symbol();
    var K = "abcdefghijklmnopqrst";
    A[S] = 7;
    K.split("").forEach(function(k) {
        B[k] = k;
    });
    return $9930ce68330d1101$var$$assign({}, A)[S] != 7 || Object.keys($9930ce68330d1101$var$$assign({}, B)).join("") != K;
}) ? function assign(target, source) {
    var T = $jK6u7(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = $iLHFk.f;
    var isEnum = $kNK9k.f;
    while(aLen > index){
        var S = $39tBo(arguments[index++]);
        var keys = getSymbols ? $iGTn6(S).concat(getSymbols(S)) : $iGTn6(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$4G9qa || isEnum.call(S, key)) T[key] = S[key];
        }
    }
    return T;
} : $9930ce68330d1101$var$$assign;

});





parcelRegister("gpTap", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf39c6245d5d25bd$export$2e2bcd8739ae039);

var $1HdKo = parcelRequire("1HdKo");

var $jcrfT = parcelRequire("jcrfT");
function $bf39c6245d5d25bd$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = (0, $jcrfT.default)(source, excluded);
    var key, i;
    if (0, (/*@__PURE__*/$parcel$interopDefault($1HdKo))) {
        var sourceSymbolKeys = (0, (/*@__PURE__*/$parcel$interopDefault($1HdKo)))(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRegister("jcrfT", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfa447a951ca82b2$export$2e2bcd8739ae039);

var $8lpxl = parcelRequire("8lpxl");
function $dfa447a951ca82b2$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = (0, (/*@__PURE__*/$parcel$interopDefault($8lpxl)))(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRegister("6j9O2", function(module, exports) {

var $iGQLm = parcelRequire("iGQLm");

var $ikaiq = parcelRequire("ikaiq");

var $4NxxH = parcelRequire("4NxxH");

var $5l4PJ = parcelRequire("5l4PJ");

var $20Rgr = parcelRequire("20Rgr");

var $7JcvP = parcelRequire("7JcvP");

var $aJAVg = parcelRequire("aJAVg");

var $iYJk1 = parcelRequire("iYJk1");

var $4UXHD = parcelRequire("4UXHD");

var $xMy82 = parcelRequire("xMy82");

var $3MjAw = parcelRequire("3MjAw");

var $47O2q = parcelRequire("47O2q");

var $iWSff = parcelRequire("iWSff");

var $8l7PP = parcelRequire("8l7PP");

var $jqUWg = parcelRequire("jqUWg");

var $34IFf = parcelRequire("34IFf");
var $497c1fb35aa44458$var$withoutArr = (arr, ...rest)=>$34IFf.apply(null, [
        arr
    ].concat($20Rgr(rest)));
var $497c1fb35aa44458$var$isPropertyRelated = (key)=>$497c1fb35aa44458$var$contains($497c1fb35aa44458$var$propertyRelated, key);
var $497c1fb35aa44458$var$isItemsRelated = (key)=>$497c1fb35aa44458$var$contains($497c1fb35aa44458$var$itemsRelated, key);
var $497c1fb35aa44458$var$contains = (arr, val)=>arr.indexOf(val) !== -1;
var $497c1fb35aa44458$var$isEmptySchema = (obj)=>!$497c1fb35aa44458$var$keys(obj).length && obj !== false && obj !== true;
var $497c1fb35aa44458$var$isSchema = (val)=>$xMy82(val) || val === true || val === false;
var $497c1fb35aa44458$var$isFalse = (val)=>val === false;
var $497c1fb35aa44458$var$isTrue = (val)=>val === true;
var $497c1fb35aa44458$var$schemaResolver = (compacted, key, mergeSchemas)=>mergeSchemas(compacted);
var $497c1fb35aa44458$var$stringArray = (values)=>$47O2q($8l7PP($7JcvP(values)));
var $497c1fb35aa44458$var$notUndefined = (val)=>val !== undefined;
var $497c1fb35aa44458$var$allUniqueKeys = (arr)=>$8l7PP($7JcvP(arr.map($497c1fb35aa44458$var$keys)));
// resolvers
var $497c1fb35aa44458$var$first = (compacted)=>compacted[0];
var $497c1fb35aa44458$var$required = (compacted)=>$497c1fb35aa44458$var$stringArray(compacted);
var $497c1fb35aa44458$var$maximumValue = (compacted)=>Math.max.apply(Math, compacted);
var $497c1fb35aa44458$var$minimumValue = (compacted)=>Math.min.apply(Math, compacted);
var $497c1fb35aa44458$var$uniqueItems = (compacted)=>compacted.some($497c1fb35aa44458$var$isTrue);
var $497c1fb35aa44458$var$examples = (compacted)=>$jqUWg($20Rgr(compacted), $4UXHD);
function $497c1fb35aa44458$var$compareProp(key) {
    return function(a, b) {
        return $ikaiq({
            [key]: a
        }, {
            [key]: b
        });
    };
}
function $497c1fb35aa44458$var$getAllOf(schema) {
    if (Array.isArray(schema.allOf)) {
        var allOf = schema.allOf;
        delete schema.allOf;
        return [
            schema
        ].concat(allOf.map(function(allSchema) {
            return $497c1fb35aa44458$var$getAllOf(allSchema);
        }));
    } else return [
        schema
    ];
}
function $497c1fb35aa44458$var$getValues(schemas, key) {
    return schemas.map(function(schema) {
        return schema && schema[key];
    });
}
function $497c1fb35aa44458$var$getItemSchemas(subSchemas, key) {
    return subSchemas.map(function(sub) {
        if (!sub) return;
        if (Array.isArray(sub.items)) {
            var schemaAtPos = sub.items[key];
            if ($497c1fb35aa44458$var$isSchema(schemaAtPos)) return schemaAtPos;
            else if (sub.hasOwnProperty("additionalItems")) return sub.additionalItems;
        } else return sub.items;
    });
}
function $497c1fb35aa44458$var$tryMergeSchemaGroups(schemaGroups, mergeSchemas) {
    return schemaGroups.map(function(schemas, index) {
        try {
            return mergeSchemas(schemas, index);
        } catch (e) {
            return undefined;
        }
    }).filter($497c1fb35aa44458$var$notUndefined);
}
function $497c1fb35aa44458$var$getAdditionalSchemas(subSchemas) {
    return subSchemas.map(function(sub) {
        if (!sub) return;
        if (Array.isArray(sub.items)) return sub.additionalItems;
        return sub.items;
    });
}
function $497c1fb35aa44458$var$keys(obj) {
    if ($xMy82(obj) || Array.isArray(obj)) return Object.keys(obj);
    else return [];
}
function $497c1fb35aa44458$var$getAnyOfCombinations(arrOfArrays, combinations) {
    combinations = combinations || [];
    if (!arrOfArrays.length) return combinations;
    var values = arrOfArrays.slice(0).shift();
    var rest = arrOfArrays.slice(1);
    if (combinations.length) return $497c1fb35aa44458$var$getAnyOfCombinations(rest, $20Rgr(combinations.map((combination)=>values.map((item)=>[
                item
            ].concat(combination)))));
    return $497c1fb35aa44458$var$getAnyOfCombinations(rest, values.map((item)=>item));
}
function $497c1fb35aa44458$var$mergeWithArray(base, newItems) {
    if (Array.isArray(base)) {
        base.splice.apply(base, [
            0,
            0
        ].concat(newItems));
        return base;
    } else return newItems;
}
function $497c1fb35aa44458$var$throwIncompatible(values, paths) {
    var asJSON;
    try {
        asJSON = values.map(function(val) {
            return JSON.stringify(val, null, 2);
        }).join("\n");
    } catch (variable) {
        asJSON = values.join(", ");
    }
    throw new Error('Could not resolve values for path:"' + paths.join(".") + '". They are probably incompatible. Values: \n' + asJSON);
}
function $497c1fb35aa44458$var$cleanupReturnValue(returnObject) {
    // cleanup empty
    for(var prop in returnObject)if (returnObject.hasOwnProperty(prop) && $497c1fb35aa44458$var$isEmptySchema(returnObject[prop])) delete returnObject[prop];
    return returnObject;
}
function $497c1fb35aa44458$var$createRequiredSubMerger(mergeSchemas, key, parents) {
    return function(schemas, subKey) {
        if (subKey === undefined) throw new Error("You need to call merger with a key for the property name or index if array.");
        subKey = String(subKey);
        return mergeSchemas(schemas, null, parents.concat(key, subKey));
    };
}
function $497c1fb35aa44458$var$callGroupResolver(keys, resolverName, schemas, mergeSchemas, options, parents) {
    if (keys.length) {
        var resolver = options.resolvers[resolverName];
        if (!resolver) throw new Error("No resolver found for " + resolverName);
        var compacted = $jqUWg(schemas.map(function(schema) {
            return keys.reduce(function(all, key) {
                if (schema[key] !== undefined) all[key] = schema[key];
                return all;
            }, {});
        }).filter($497c1fb35aa44458$var$notUndefined), $ikaiq);
        var related = resolverName === "properties" ? $497c1fb35aa44458$var$propertyRelated : $497c1fb35aa44458$var$itemsRelated;
        var mergers = related.reduce(function(all, key) {
            if ($497c1fb35aa44458$var$contains($497c1fb35aa44458$var$schemaGroupProps, key)) all[key] = $497c1fb35aa44458$var$createRequiredSubMerger(mergeSchemas, key, parents);
            else all[key] = function(schemas) {
                return mergeSchemas(schemas, null, parents.concat(key));
            };
            return all;
        }, {});
        if (resolverName === "items") {
            mergers.itemsArray = $497c1fb35aa44458$var$createRequiredSubMerger(mergeSchemas, "items", parents);
            mergers.items = function(schemas) {
                return mergeSchemas(schemas, null, parents.concat("items"));
            };
        }
        var result = resolver(compacted, parents.concat(resolverName), mergers, options);
        if (!$xMy82(result)) $497c1fb35aa44458$var$throwIncompatible(compacted, parents.concat(resolverName));
        return $497c1fb35aa44458$var$cleanupReturnValue(result);
    }
}
// Provide source when array
function $497c1fb35aa44458$var$mergeSchemaGroup(group, mergeSchemas, source) {
    var allKeys = $497c1fb35aa44458$var$allUniqueKeys(source || group);
    var extractor = source ? $497c1fb35aa44458$var$getItemSchemas : $497c1fb35aa44458$var$getValues;
    return allKeys.reduce(function(all, key) {
        var schemas = extractor(group, key);
        var compacted = $jqUWg(schemas.filter($497c1fb35aa44458$var$notUndefined), $ikaiq);
        all[key] = mergeSchemas(compacted, key);
        return all;
    }, source ? [] : {});
}
function $497c1fb35aa44458$var$removeFalseSchemas(target) {
    $iWSff(target, function(schema, prop) {
        if (schema === false) delete target[prop];
    });
}
function $497c1fb35aa44458$var$removeFalseSchemasFromArray(target) {
    $iWSff(target, function(schema, index) {
        if (schema === false) target.splice(index, 1);
    });
}
function $497c1fb35aa44458$var$createRequiredMetaArray(arr) {
    return {
        required: arr
    };
}
var $497c1fb35aa44458$var$propertyRelated = [
    "properties",
    "patternProperties",
    "additionalProperties"
];
var $497c1fb35aa44458$var$itemsRelated = [
    "items",
    "additionalItems"
];
var $497c1fb35aa44458$var$schemaGroupProps = [
    "properties",
    "patternProperties",
    "definitions",
    "dependencies"
];
var $497c1fb35aa44458$var$schemaArrays = [
    "anyOf",
    "oneOf"
];
var $497c1fb35aa44458$var$schemaProps = [
    "additionalProperties",
    "additionalItems",
    "contains",
    "propertyNames",
    "not",
    "items"
];
var $497c1fb35aa44458$var$defaultResolvers = {
    type (compacted) {
        if (compacted.some(Array.isArray)) {
            var normalized = compacted.map(function(val) {
                return Array.isArray(val) ? val : [
                    val
                ];
            });
            var common = $aJAVg.apply(null, normalized);
            if (common.length === 1) return common[0];
            else if (common.length > 1) return $8l7PP(common);
        }
    },
    properties (values, key, mergers, options) {
        // first get rid of all non permitted properties
        if (!options.ignoreAdditionalProperties) {
            values.forEach(function(subSchema) {
                var otherSubSchemas = values.filter((s)=>s !== subSchema);
                var ownKeys = $497c1fb35aa44458$var$keys(subSchema.properties);
                var ownPatternKeys = $497c1fb35aa44458$var$keys(subSchema.patternProperties);
                var ownPatterns = ownPatternKeys.map((k)=>new RegExp(k));
                otherSubSchemas.forEach(function(other) {
                    var allOtherKeys = $497c1fb35aa44458$var$keys(other.properties);
                    var keysMatchingPattern = allOtherKeys.filter((k)=>ownPatterns.some((pk)=>pk.test(k)));
                    var additionalKeys = $497c1fb35aa44458$var$withoutArr(allOtherKeys, ownKeys, keysMatchingPattern);
                    additionalKeys.forEach(function(key) {
                        other.properties[key] = mergers.properties([
                            other.properties[key],
                            subSchema.additionalProperties
                        ], key);
                    });
                });
            });
            // remove disallowed patternProperties
            values.forEach(function(subSchema) {
                var otherSubSchemas = values.filter((s)=>s !== subSchema);
                var ownPatternKeys = $497c1fb35aa44458$var$keys(subSchema.patternProperties);
                if (subSchema.additionalProperties === false) otherSubSchemas.forEach(function(other) {
                    var allOtherPatterns = $497c1fb35aa44458$var$keys(other.patternProperties);
                    var additionalPatternKeys = $497c1fb35aa44458$var$withoutArr(allOtherPatterns, ownPatternKeys);
                    additionalPatternKeys.forEach((key)=>delete other.patternProperties[key]);
                });
            });
        }
        var returnObject = {
            additionalProperties: mergers.additionalProperties(values.map((s)=>s.additionalProperties)),
            patternProperties: $497c1fb35aa44458$var$mergeSchemaGroup(values.map((s)=>s.patternProperties), mergers.patternProperties),
            properties: $497c1fb35aa44458$var$mergeSchemaGroup(values.map((s)=>s.properties), mergers.properties)
        };
        if (returnObject.additionalProperties === false) $497c1fb35aa44458$var$removeFalseSchemas(returnObject.properties);
        return returnObject;
    },
    dependencies (compacted, paths, mergeSchemas) {
        var allChildren = $497c1fb35aa44458$var$allUniqueKeys(compacted);
        return allChildren.reduce(function(all, childKey) {
            var childSchemas = $497c1fb35aa44458$var$getValues(compacted, childKey);
            var innerCompacted = $jqUWg(childSchemas.filter($497c1fb35aa44458$var$notUndefined), $4UXHD);
            // to support dependencies
            var innerArrays = innerCompacted.filter(Array.isArray);
            if (innerArrays.length) {
                if (innerArrays.length === innerCompacted.length) all[childKey] = $497c1fb35aa44458$var$stringArray(innerCompacted);
                else {
                    var innerSchemas = innerCompacted.filter($497c1fb35aa44458$var$isSchema);
                    var arrayMetaScheams = innerArrays.map($497c1fb35aa44458$var$createRequiredMetaArray);
                    all[childKey] = mergeSchemas(innerSchemas.concat(arrayMetaScheams), childKey);
                }
                return all;
            }
            innerCompacted = $jqUWg(innerCompacted, $ikaiq);
            all[childKey] = mergeSchemas(innerCompacted, childKey);
            return all;
        }, {});
    },
    items (values, paths, mergers) {
        var items = values.map((s)=>s.items);
        var itemsCompacted = items.filter($497c1fb35aa44458$var$notUndefined);
        var returnObject = {};
        if (itemsCompacted.every($497c1fb35aa44458$var$isSchema)) returnObject.items = mergers.items(items);
        else returnObject.items = $497c1fb35aa44458$var$mergeSchemaGroup(values, mergers.itemsArray, items);
        var schemasAtLastPos;
        if (itemsCompacted.every(Array.isArray)) schemasAtLastPos = values.map((s)=>s.additionalItems);
        else if (itemsCompacted.some(Array.isArray)) schemasAtLastPos = $497c1fb35aa44458$var$getAdditionalSchemas(values);
        if (schemasAtLastPos) returnObject.additionalItems = mergers.additionalItems(schemasAtLastPos);
        if (returnObject.additionalItems === false && Array.isArray(returnObject.items)) $497c1fb35aa44458$var$removeFalseSchemasFromArray(returnObject.items);
        return returnObject;
    },
    oneOf (compacted, paths, mergeSchemas) {
        var combinations = $497c1fb35aa44458$var$getAnyOfCombinations($iGQLm(compacted));
        var result = $497c1fb35aa44458$var$tryMergeSchemaGroups(combinations, mergeSchemas);
        var unique = $jqUWg(result, $ikaiq);
        if (unique.length) return unique;
    },
    not (compacted) {
        return {
            anyOf: compacted
        };
    },
    pattern (compacted, paths, mergeSchemas, options, reportUnresolved) {
        var key = paths.pop();
        reportUnresolved(compacted.map(function(regexp) {
            return {
                [key]: regexp
            };
        }));
    },
    multipleOf (compacted) {
        var integers = compacted.slice(0);
        var factor = 1;
        while(integers.some((n)=>!Number.isInteger(n))){
            integers = integers.map((n)=>n * 10);
            factor = factor * 10;
        }
        return $4NxxH(integers) / factor;
    },
    enum (compacted) {
        var enums = $iYJk1.apply(null, compacted.concat($4UXHD));
        if (enums.length) return $47O2q(enums);
    }
};
$497c1fb35aa44458$var$defaultResolvers.$id = $497c1fb35aa44458$var$first;
$497c1fb35aa44458$var$defaultResolvers.$ref = $497c1fb35aa44458$var$first;
$497c1fb35aa44458$var$defaultResolvers.$schema = $497c1fb35aa44458$var$first;
$497c1fb35aa44458$var$defaultResolvers.additionalItems = $497c1fb35aa44458$var$schemaResolver;
$497c1fb35aa44458$var$defaultResolvers.additionalProperties = $497c1fb35aa44458$var$schemaResolver;
$497c1fb35aa44458$var$defaultResolvers.anyOf = $497c1fb35aa44458$var$defaultResolvers.oneOf;
$497c1fb35aa44458$var$defaultResolvers.contains = $497c1fb35aa44458$var$schemaResolver;
$497c1fb35aa44458$var$defaultResolvers.default = $497c1fb35aa44458$var$first;
$497c1fb35aa44458$var$defaultResolvers.definitions = $497c1fb35aa44458$var$defaultResolvers.dependencies;
$497c1fb35aa44458$var$defaultResolvers.description = $497c1fb35aa44458$var$first;
$497c1fb35aa44458$var$defaultResolvers.examples = $497c1fb35aa44458$var$examples;
$497c1fb35aa44458$var$defaultResolvers.exclusiveMaximum = $497c1fb35aa44458$var$minimumValue;
$497c1fb35aa44458$var$defaultResolvers.exclusiveMinimum = $497c1fb35aa44458$var$maximumValue;
$497c1fb35aa44458$var$defaultResolvers.maximum = $497c1fb35aa44458$var$minimumValue;
$497c1fb35aa44458$var$defaultResolvers.maxItems = $497c1fb35aa44458$var$minimumValue;
$497c1fb35aa44458$var$defaultResolvers.maxLength = $497c1fb35aa44458$var$minimumValue;
$497c1fb35aa44458$var$defaultResolvers.maxProperties = $497c1fb35aa44458$var$minimumValue;
$497c1fb35aa44458$var$defaultResolvers.minimum = $497c1fb35aa44458$var$maximumValue;
$497c1fb35aa44458$var$defaultResolvers.minItems = $497c1fb35aa44458$var$maximumValue;
$497c1fb35aa44458$var$defaultResolvers.minLength = $497c1fb35aa44458$var$maximumValue;
$497c1fb35aa44458$var$defaultResolvers.minProperties = $497c1fb35aa44458$var$maximumValue;
$497c1fb35aa44458$var$defaultResolvers.propertyNames = $497c1fb35aa44458$var$schemaResolver;
$497c1fb35aa44458$var$defaultResolvers.required = $497c1fb35aa44458$var$required;
$497c1fb35aa44458$var$defaultResolvers.title = $497c1fb35aa44458$var$first;
$497c1fb35aa44458$var$defaultResolvers.uniqueItems = $497c1fb35aa44458$var$uniqueItems;
function $497c1fb35aa44458$var$merger(rootSchema, options, totalSchemas) {
    totalSchemas = totalSchemas || [];
    options = $5l4PJ(options, {
        ignoreAdditionalProperties: false,
        resolvers: $497c1fb35aa44458$var$defaultResolvers
    });
    function mergeSchemas(schemas, base, parents) {
        schemas = $iGQLm(schemas.filter($497c1fb35aa44458$var$notUndefined));
        parents = parents || [];
        var merged = $xMy82(base) ? base : {};
        // return undefined, an empty schema
        if (!schemas.length) return;
        if (schemas.some($497c1fb35aa44458$var$isFalse)) return false;
        if (schemas.every($497c1fb35aa44458$var$isTrue)) return true;
        // there are no false and we don't need the true ones as they accept everything
        schemas = schemas.filter($xMy82);
        var allKeys = $497c1fb35aa44458$var$allUniqueKeys(schemas);
        if ($497c1fb35aa44458$var$contains(allKeys, "allOf")) return $497c1fb35aa44458$var$merger({
            allOf: schemas
        }, options, totalSchemas);
        var propertyKeys = allKeys.filter($497c1fb35aa44458$var$isPropertyRelated);
        $3MjAw(allKeys, propertyKeys);
        var itemKeys = allKeys.filter($497c1fb35aa44458$var$isItemsRelated);
        $3MjAw(allKeys, itemKeys);
        allKeys.forEach(function(key) {
            var values = $497c1fb35aa44458$var$getValues(schemas, key);
            var compacted = $jqUWg(values.filter($497c1fb35aa44458$var$notUndefined), $497c1fb35aa44458$var$compareProp(key));
            // arrayprops like anyOf and oneOf must be merged first, as they contains schemas
            // allOf is treated differently alltogether
            if (compacted.length === 1 && $497c1fb35aa44458$var$contains($497c1fb35aa44458$var$schemaArrays, key)) merged[key] = compacted[0].map(function(schema) {
                return mergeSchemas([
                    schema
                ], schema);
            });
            else if (compacted.length === 1 && !$497c1fb35aa44458$var$contains($497c1fb35aa44458$var$schemaGroupProps, key) && !$497c1fb35aa44458$var$contains($497c1fb35aa44458$var$schemaProps, key)) merged[key] = compacted[0];
            else {
                var resolver = options.resolvers[key] || options.resolvers.defaultResolver;
                if (!resolver) throw new Error("No resolver found for key " + key + ". You can provide a resolver for this keyword in the options, or provide a default resolver.");
                var merger;
                // get custom merger for groups
                if ($497c1fb35aa44458$var$contains($497c1fb35aa44458$var$schemaGroupProps, key) || $497c1fb35aa44458$var$contains($497c1fb35aa44458$var$schemaArrays, key)) merger = $497c1fb35aa44458$var$createRequiredSubMerger(mergeSchemas, key, parents);
                else merger = function(schemas) {
                    return mergeSchemas(schemas, null, parents.concat(key));
                };
                var calledWithArray = false;
                merged[key] = resolver(compacted, parents.concat(key), merger, options, function(unresolvedSchemas) {
                    calledWithArray = Array.isArray(unresolvedSchemas);
                    return addToAllOf(unresolvedSchemas);
                });
                if (merged[key] === undefined && !calledWithArray) $497c1fb35aa44458$var$throwIncompatible(compacted, parents.concat(key));
                else if (merged[key] === undefined) delete merged[key];
            }
        });
        Object.assign(merged, $497c1fb35aa44458$var$callGroupResolver(propertyKeys, "properties", schemas, mergeSchemas, options, parents));
        Object.assign(merged, $497c1fb35aa44458$var$callGroupResolver(itemKeys, "items", schemas, mergeSchemas, options, parents));
        function addToAllOf(unresolvedSchemas) {
            merged.allOf = $497c1fb35aa44458$var$mergeWithArray(merged.allOf, unresolvedSchemas);
        }
        return merged;
    }
    var allSchemas = $7JcvP($497c1fb35aa44458$var$getAllOf(rootSchema));
    var merged = mergeSchemas(allSchemas, rootSchema);
    return merged;
}
$497c1fb35aa44458$var$merger.options = {
    resolvers: $497c1fb35aa44458$var$defaultResolvers
};
module.exports = $497c1fb35aa44458$var$merger;

});
parcelRegister("iGQLm", function(module, exports) {

var $kqX4j = parcelRequire("kqX4j");
/** Used to compose bitmasks for cloning. */ var $d9b513d63d79678d$var$CLONE_DEEP_FLAG = 1, $d9b513d63d79678d$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $d9b513d63d79678d$var$cloneDeep(value) {
    return $kqX4j(value, $d9b513d63d79678d$var$CLONE_DEEP_FLAG | $d9b513d63d79678d$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $d9b513d63d79678d$var$cloneDeep;

});
parcelRegister("kqX4j", function(module, exports) {

var $g779E = parcelRequire("g779E");

var $bFZGr = parcelRequire("bFZGr");

var $5i71d = parcelRequire("5i71d");

var $XXQDs = parcelRequire("XXQDs");

var $1djPb = parcelRequire("1djPb");

var $uQ1Em = parcelRequire("uQ1Em");

var $aA0pv = parcelRequire("aA0pv");

var $hIxJe = parcelRequire("hIxJe");

var $7n7lE = parcelRequire("7n7lE");

var $apVCl = parcelRequire("apVCl");

var $i0kKc = parcelRequire("i0kKc");

var $67A6V = parcelRequire("67A6V");

var $4UmGC = parcelRequire("4UmGC");

var $btuqH = parcelRequire("btuqH");

var $dFJsF = parcelRequire("dFJsF");

var $o8HxT = parcelRequire("o8HxT");

var $f504n = parcelRequire("f504n");

var $eJObK = parcelRequire("eJObK");

var $lsJ54 = parcelRequire("lsJ54");

var $jZm8C = parcelRequire("jZm8C");

var $LAMcS = parcelRequire("LAMcS");

var $f4lqP = parcelRequire("f4lqP");
/** Used to compose bitmasks for cloning. */ var $ee040e257a097984$var$CLONE_DEEP_FLAG = 1, $ee040e257a097984$var$CLONE_FLAT_FLAG = 2, $ee040e257a097984$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $ee040e257a097984$var$argsTag = "[object Arguments]", $ee040e257a097984$var$arrayTag = "[object Array]", $ee040e257a097984$var$boolTag = "[object Boolean]", $ee040e257a097984$var$dateTag = "[object Date]", $ee040e257a097984$var$errorTag = "[object Error]", $ee040e257a097984$var$funcTag = "[object Function]", $ee040e257a097984$var$genTag = "[object GeneratorFunction]", $ee040e257a097984$var$mapTag = "[object Map]", $ee040e257a097984$var$numberTag = "[object Number]", $ee040e257a097984$var$objectTag = "[object Object]", $ee040e257a097984$var$regexpTag = "[object RegExp]", $ee040e257a097984$var$setTag = "[object Set]", $ee040e257a097984$var$stringTag = "[object String]", $ee040e257a097984$var$symbolTag = "[object Symbol]", $ee040e257a097984$var$weakMapTag = "[object WeakMap]";
var $ee040e257a097984$var$arrayBufferTag = "[object ArrayBuffer]", $ee040e257a097984$var$dataViewTag = "[object DataView]", $ee040e257a097984$var$float32Tag = "[object Float32Array]", $ee040e257a097984$var$float64Tag = "[object Float64Array]", $ee040e257a097984$var$int8Tag = "[object Int8Array]", $ee040e257a097984$var$int16Tag = "[object Int16Array]", $ee040e257a097984$var$int32Tag = "[object Int32Array]", $ee040e257a097984$var$uint8Tag = "[object Uint8Array]", $ee040e257a097984$var$uint8ClampedTag = "[object Uint8ClampedArray]", $ee040e257a097984$var$uint16Tag = "[object Uint16Array]", $ee040e257a097984$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $ee040e257a097984$var$cloneableTags = {};
$ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$argsTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$arrayTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$arrayBufferTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$dataViewTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$boolTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$dateTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$float32Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$float64Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$int8Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$int16Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$int32Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$mapTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$numberTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$objectTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$regexpTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$setTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$stringTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$symbolTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$uint8Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$uint8ClampedTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$uint16Tag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$uint32Tag] = true;
$ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$errorTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$funcTag] = $ee040e257a097984$var$cloneableTags[$ee040e257a097984$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $ee040e257a097984$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $ee040e257a097984$var$CLONE_DEEP_FLAG, isFlat = bitmask & $ee040e257a097984$var$CLONE_FLAT_FLAG, isFull = bitmask & $ee040e257a097984$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$lsJ54(value)) return value;
    var isArr = $o8HxT(value);
    if (isArr) {
        result = $4UmGC(value);
        if (!isDeep) return $aA0pv(value, result);
    } else {
        var tag = $67A6V(value), isFunc = tag == $ee040e257a097984$var$funcTag || tag == $ee040e257a097984$var$genTag;
        if ($f504n(value)) return $uQ1Em(value, isDeep);
        if (tag == $ee040e257a097984$var$objectTag || tag == $ee040e257a097984$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $dFJsF(value);
            if (!isDeep) return isFlat ? $7n7lE(value, $1djPb(result, value)) : $hIxJe(value, $XXQDs(result, value));
        } else {
            if (!$ee040e257a097984$var$cloneableTags[tag]) return object ? value : {};
            result = $btuqH(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $g779E);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($jZm8C(value)) value.forEach(function(subValue) {
        result.add($ee040e257a097984$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($eJObK(value)) value.forEach(function(subValue, key) {
        result.set(key, $ee040e257a097984$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $i0kKc : $apVCl : isFlat ? $f4lqP : $LAMcS;
    var props = isArr ? undefined : keysFunc(value);
    $bFZGr(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $5i71d(result, key, $ee040e257a097984$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
module.exports = $ee040e257a097984$var$baseClone;

});
parcelRegister("g779E", function(module, exports) {

var $iYOpJ = parcelRequire("iYOpJ");

var $jZSEZ = parcelRequire("jZSEZ");

var $fm6cW = parcelRequire("fm6cW");

var $b3G1Z = parcelRequire("b3G1Z");

var $5DEbp = parcelRequire("5DEbp");

var $czPDU = parcelRequire("czPDU");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $bbb2d98cae25b61a$var$Stack(entries) {
    var data = this.__data__ = new $iYOpJ(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$bbb2d98cae25b61a$var$Stack.prototype.clear = $jZSEZ;
$bbb2d98cae25b61a$var$Stack.prototype["delete"] = $fm6cW;
$bbb2d98cae25b61a$var$Stack.prototype.get = $b3G1Z;
$bbb2d98cae25b61a$var$Stack.prototype.has = $5DEbp;
$bbb2d98cae25b61a$var$Stack.prototype.set = $czPDU;
module.exports = $bbb2d98cae25b61a$var$Stack;

});
parcelRegister("jZSEZ", function(module, exports) {

var $iYOpJ = parcelRequire("iYOpJ");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $e8ee1d354807980a$var$stackClear() {
    this.__data__ = new $iYOpJ;
    this.size = 0;
}
module.exports = $e8ee1d354807980a$var$stackClear;

});

parcelRegister("fm6cW", function(module, exports) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $b2ddb9d63293f3a5$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
module.exports = $b2ddb9d63293f3a5$var$stackDelete;

});

parcelRegister("b3G1Z", function(module, exports) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $80d0940a423a17dc$var$stackGet(key) {
    return this.__data__.get(key);
}
module.exports = $80d0940a423a17dc$var$stackGet;

});

parcelRegister("5DEbp", function(module, exports) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $010f38d5d914cfa2$var$stackHas(key) {
    return this.__data__.has(key);
}
module.exports = $010f38d5d914cfa2$var$stackHas;

});

parcelRegister("czPDU", function(module, exports) {

var $iYOpJ = parcelRequire("iYOpJ");

var $2cJKd = parcelRequire("2cJKd");

var $6gDBQ = parcelRequire("6gDBQ");
/** Used as the size to enable large array optimizations. */ var $9280d00f89f25fa9$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $9280d00f89f25fa9$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $iYOpJ) {
        var pairs = data.__data__;
        if (!$2cJKd || pairs.length < $9280d00f89f25fa9$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $6gDBQ(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = $9280d00f89f25fa9$var$stackSet;

});


parcelRegister("bFZGr", function(module, exports) {
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $88035f224ff89479$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
module.exports = $88035f224ff89479$var$arrayEach;

});

parcelRegister("XXQDs", function(module, exports) {

var $cYlGN = parcelRequire("cYlGN");

var $LAMcS = parcelRequire("LAMcS");
/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $0b43ef5c64ba7f70$var$baseAssign(object, source) {
    return object && $cYlGN(source, $LAMcS(source), object);
}
module.exports = $0b43ef5c64ba7f70$var$baseAssign;

});
parcelRegister("cYlGN", function(module, exports) {

var $5i71d = parcelRequire("5i71d");

var $cWbJD = parcelRequire("cWbJD");
/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $971be9a5edcd8d07$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $cWbJD(object, key, newValue);
        else $5i71d(object, key, newValue);
    }
    return object;
}
module.exports = $971be9a5edcd8d07$var$copyObject;

});

parcelRegister("LAMcS", function(module, exports) {

var $8C60w = parcelRequire("8C60w");

var $jViFF = parcelRequire("jViFF");

var $eMthh = parcelRequire("eMthh");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $08f0eaf3fbcb2fde$var$keys(object) {
    return $eMthh(object) ? $8C60w(object) : $jViFF(object);
}
module.exports = $08f0eaf3fbcb2fde$var$keys;

});
parcelRegister("8C60w", function(module, exports) {

var $fdM6B = parcelRequire("fdM6B");

var $aJD6g = parcelRequire("aJD6g");

var $o8HxT = parcelRequire("o8HxT");

var $f504n = parcelRequire("f504n");

var $iyUuu = parcelRequire("iyUuu");

var $1Q21n = parcelRequire("1Q21n");
/** Used for built-in method references. */ var $64568844439edb7f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $64568844439edb7f$var$hasOwnProperty = $64568844439edb7f$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $64568844439edb7f$var$arrayLikeKeys(value, inherited) {
    var isArr = $o8HxT(value), isArg = !isArr && $aJD6g(value), isBuff = !isArr && !isArg && $f504n(value), isType = !isArr && !isArg && !isBuff && $1Q21n(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $fdM6B(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $64568844439edb7f$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $iyUuu(key, length)))) result.push(key);
    return result;
}
module.exports = $64568844439edb7f$var$arrayLikeKeys;

});
parcelRegister("fdM6B", function(module, exports) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $b14d62a510ae7f2d$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = $b14d62a510ae7f2d$var$baseTimes;

});




parcelRegister("1djPb", function(module, exports) {

var $cYlGN = parcelRequire("cYlGN");

var $f4lqP = parcelRequire("f4lqP");
/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $0e266213253a5976$var$baseAssignIn(object, source) {
    return object && $cYlGN(source, $f4lqP(source), object);
}
module.exports = $0e266213253a5976$var$baseAssignIn;

});
parcelRegister("f4lqP", function(module, exports) {

var $8C60w = parcelRequire("8C60w");

var $4ECPT = parcelRequire("4ECPT");

var $eMthh = parcelRequire("eMthh");
/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $af87da9a76941740$var$keysIn(object) {
    return $eMthh(object) ? $8C60w(object, true) : $4ECPT(object);
}
module.exports = $af87da9a76941740$var$keysIn;

});
parcelRegister("4ECPT", function(module, exports) {

var $lsJ54 = parcelRequire("lsJ54");

var $3wZFp = parcelRequire("3wZFp");

var $7w1ie = parcelRequire("7w1ie");
/** Used for built-in method references. */ var $363905e043db7569$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $363905e043db7569$var$hasOwnProperty = $363905e043db7569$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $363905e043db7569$var$baseKeysIn(object) {
    if (!$lsJ54(object)) return $7w1ie(object);
    var isProto = $3wZFp(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$363905e043db7569$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
module.exports = $363905e043db7569$var$baseKeysIn;

});
parcelRegister("7w1ie", function(module, exports) {
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $578c86548a505f7a$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
module.exports = $578c86548a505f7a$var$nativeKeysIn;

});




parcelRegister("uQ1Em", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $23YZo.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRegister("aA0pv", function(module, exports) {
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $7b3d95b0cd9dcb32$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
module.exports = $7b3d95b0cd9dcb32$var$copyArray;

});

parcelRegister("hIxJe", function(module, exports) {

var $cYlGN = parcelRequire("cYlGN");

var $6YcYN = parcelRequire("6YcYN");
/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $ce60b583e6a24a63$var$copySymbols(source, object) {
    return $cYlGN(source, $6YcYN(source), object);
}
module.exports = $ce60b583e6a24a63$var$copySymbols;

});
parcelRegister("6YcYN", function(module, exports) {

var $8H9RZ = parcelRequire("8H9RZ");

var $clnSu = parcelRequire("clnSu");
/** Used for built-in method references. */ var $51326a29f571e7cd$var$objectProto = Object.prototype;
/** Built-in value references. */ var $51326a29f571e7cd$var$propertyIsEnumerable = $51326a29f571e7cd$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $51326a29f571e7cd$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $51326a29f571e7cd$var$getSymbols = !$51326a29f571e7cd$var$nativeGetSymbols ? $clnSu : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $8H9RZ($51326a29f571e7cd$var$nativeGetSymbols(object), function(symbol) {
        return $51326a29f571e7cd$var$propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = $51326a29f571e7cd$var$getSymbols;

});
parcelRegister("8H9RZ", function(module, exports) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $6549fed720324048$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = $6549fed720324048$var$arrayFilter;

});

parcelRegister("clnSu", function(module, exports) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $8fc9f7df9b0c06bb$var$stubArray() {
    return [];
}
module.exports = $8fc9f7df9b0c06bb$var$stubArray;

});



parcelRegister("7n7lE", function(module, exports) {

var $cYlGN = parcelRequire("cYlGN");

var $aiaLi = parcelRequire("aiaLi");
/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $55e06195de8b50ba$var$copySymbolsIn(source, object) {
    return $cYlGN(source, $aiaLi(source), object);
}
module.exports = $55e06195de8b50ba$var$copySymbolsIn;

});
parcelRegister("aiaLi", function(module, exports) {

var $hynws = parcelRequire("hynws");

var $cdnOB = parcelRequire("cdnOB");

var $6YcYN = parcelRequire("6YcYN");

var $clnSu = parcelRequire("clnSu");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $77e3eeed2d30c6bc$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $77e3eeed2d30c6bc$var$getSymbolsIn = !$77e3eeed2d30c6bc$var$nativeGetSymbols ? $clnSu : function(object) {
    var result = [];
    while(object){
        $hynws(result, $6YcYN(object));
        object = $cdnOB(object);
    }
    return result;
};
module.exports = $77e3eeed2d30c6bc$var$getSymbolsIn;

});
parcelRegister("cdnOB", function(module, exports) {

var $lW2Sc = parcelRequire("lW2Sc");
/** Built-in value references. */ var $8e492c1d7a7ea307$var$getPrototype = $lW2Sc(Object.getPrototypeOf, Object);
module.exports = $8e492c1d7a7ea307$var$getPrototype;

});



parcelRegister("apVCl", function(module, exports) {

var $ctgi8 = parcelRequire("ctgi8");

var $6YcYN = parcelRequire("6YcYN");

var $LAMcS = parcelRequire("LAMcS");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $7958eecccfe4cef6$var$getAllKeys(object) {
    return $ctgi8(object, $LAMcS, $6YcYN);
}
module.exports = $7958eecccfe4cef6$var$getAllKeys;

});
parcelRegister("ctgi8", function(module, exports) {

var $hynws = parcelRequire("hynws");

var $o8HxT = parcelRequire("o8HxT");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $9144d49da7a47a72$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $o8HxT(object) ? result : $hynws(result, symbolsFunc(object));
}
module.exports = $9144d49da7a47a72$var$baseGetAllKeys;

});


parcelRegister("i0kKc", function(module, exports) {

var $ctgi8 = parcelRequire("ctgi8");

var $aiaLi = parcelRequire("aiaLi");

var $f4lqP = parcelRequire("f4lqP");
/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $d1b85174ea17081a$var$getAllKeysIn(object) {
    return $ctgi8(object, $f4lqP, $aiaLi);
}
module.exports = $d1b85174ea17081a$var$getAllKeysIn;

});

parcelRegister("4UmGC", function(module, exports) {
/** Used for built-in method references. */ var $392dfd68f4953502$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $392dfd68f4953502$var$hasOwnProperty = $392dfd68f4953502$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $392dfd68f4953502$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == "string" && $392dfd68f4953502$var$hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
module.exports = $392dfd68f4953502$var$initCloneArray;

});

parcelRegister("btuqH", function(module, exports) {

var $jjbq1 = parcelRequire("jjbq1");

var $aKTvD = parcelRequire("aKTvD");

var $5IIrB = parcelRequire("5IIrB");

var $jxFRj = parcelRequire("jxFRj");

var $5JAGM = parcelRequire("5JAGM");
/** `Object#toString` result references. */ var $85aa01d56b12d536$var$boolTag = "[object Boolean]", $85aa01d56b12d536$var$dateTag = "[object Date]", $85aa01d56b12d536$var$mapTag = "[object Map]", $85aa01d56b12d536$var$numberTag = "[object Number]", $85aa01d56b12d536$var$regexpTag = "[object RegExp]", $85aa01d56b12d536$var$setTag = "[object Set]", $85aa01d56b12d536$var$stringTag = "[object String]", $85aa01d56b12d536$var$symbolTag = "[object Symbol]";
var $85aa01d56b12d536$var$arrayBufferTag = "[object ArrayBuffer]", $85aa01d56b12d536$var$dataViewTag = "[object DataView]", $85aa01d56b12d536$var$float32Tag = "[object Float32Array]", $85aa01d56b12d536$var$float64Tag = "[object Float64Array]", $85aa01d56b12d536$var$int8Tag = "[object Int8Array]", $85aa01d56b12d536$var$int16Tag = "[object Int16Array]", $85aa01d56b12d536$var$int32Tag = "[object Int32Array]", $85aa01d56b12d536$var$uint8Tag = "[object Uint8Array]", $85aa01d56b12d536$var$uint8ClampedTag = "[object Uint8ClampedArray]", $85aa01d56b12d536$var$uint16Tag = "[object Uint16Array]", $85aa01d56b12d536$var$uint32Tag = "[object Uint32Array]";
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $85aa01d56b12d536$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $85aa01d56b12d536$var$arrayBufferTag:
            return $jjbq1(object);
        case $85aa01d56b12d536$var$boolTag:
        case $85aa01d56b12d536$var$dateTag:
            return new Ctor(+object);
        case $85aa01d56b12d536$var$dataViewTag:
            return $aKTvD(object, isDeep);
        case $85aa01d56b12d536$var$float32Tag:
        case $85aa01d56b12d536$var$float64Tag:
        case $85aa01d56b12d536$var$int8Tag:
        case $85aa01d56b12d536$var$int16Tag:
        case $85aa01d56b12d536$var$int32Tag:
        case $85aa01d56b12d536$var$uint8Tag:
        case $85aa01d56b12d536$var$uint8ClampedTag:
        case $85aa01d56b12d536$var$uint16Tag:
        case $85aa01d56b12d536$var$uint32Tag:
            return $5JAGM(object, isDeep);
        case $85aa01d56b12d536$var$mapTag:
            return new Ctor;
        case $85aa01d56b12d536$var$numberTag:
        case $85aa01d56b12d536$var$stringTag:
            return new Ctor(object);
        case $85aa01d56b12d536$var$regexpTag:
            return $5IIrB(object);
        case $85aa01d56b12d536$var$setTag:
            return new Ctor;
        case $85aa01d56b12d536$var$symbolTag:
            return $jxFRj(object);
    }
}
module.exports = $85aa01d56b12d536$var$initCloneByTag;

});
parcelRegister("jjbq1", function(module, exports) {

var $lx3EF = parcelRequire("lx3EF");
/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $e0e8a62ea95bc20a$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $lx3EF(result).set(new $lx3EF(arrayBuffer));
    return result;
}
module.exports = $e0e8a62ea95bc20a$var$cloneArrayBuffer;

});
parcelRegister("lx3EF", function(module, exports) {

var $23YZo = parcelRequire("23YZo");
/** Built-in value references. */ var $facf83d1449a27b8$var$Uint8Array = $23YZo.Uint8Array;
module.exports = $facf83d1449a27b8$var$Uint8Array;

});


parcelRegister("aKTvD", function(module, exports) {

var $jjbq1 = parcelRequire("jjbq1");
/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $7d49423a2080f7e8$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $jjbq1(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
module.exports = $7d49423a2080f7e8$var$cloneDataView;

});

parcelRegister("5IIrB", function(module, exports) {
/** Used to match `RegExp` flags from their coerced string values. */ var $42a38980bea1ca34$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $42a38980bea1ca34$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $42a38980bea1ca34$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
module.exports = $42a38980bea1ca34$var$cloneRegExp;

});

parcelRegister("jxFRj", function(module, exports) {

var $57wYk = parcelRequire("57wYk");
/** Used to convert symbols to primitives and strings. */ var $e3a191b3227aae5b$var$symbolProto = $57wYk ? $57wYk.prototype : undefined, $e3a191b3227aae5b$var$symbolValueOf = $e3a191b3227aae5b$var$symbolProto ? $e3a191b3227aae5b$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $e3a191b3227aae5b$var$cloneSymbol(symbol) {
    return $e3a191b3227aae5b$var$symbolValueOf ? Object($e3a191b3227aae5b$var$symbolValueOf.call(symbol)) : {};
}
module.exports = $e3a191b3227aae5b$var$cloneSymbol;

});

parcelRegister("5JAGM", function(module, exports) {

var $jjbq1 = parcelRequire("jjbq1");
/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $42cd9d64f56ec214$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $jjbq1(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
module.exports = $42cd9d64f56ec214$var$cloneTypedArray;

});


parcelRegister("dFJsF", function(module, exports) {

var $4XGZt = parcelRequire("4XGZt");

var $cdnOB = parcelRequire("cdnOB");

var $3wZFp = parcelRequire("3wZFp");
/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $9f425e619197b80f$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !$3wZFp(object) ? $4XGZt($cdnOB(object)) : {};
}
module.exports = $9f425e619197b80f$var$initCloneObject;

});
parcelRegister("4XGZt", function(module, exports) {

var $lsJ54 = parcelRequire("lsJ54");
/** Built-in value references. */ var $39ce05228f203f9a$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $39ce05228f203f9a$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$lsJ54(proto)) return {};
        if ($39ce05228f203f9a$var$objectCreate) return $39ce05228f203f9a$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
module.exports = $39ce05228f203f9a$var$baseCreate;

});


parcelRegister("eJObK", function(module, exports) {

var $9ORep = parcelRequire("9ORep");

var $91Qdd = parcelRequire("91Qdd");

var $jIny1 = parcelRequire("jIny1");
/* Node.js helper references. */ var $abac330771f68232$var$nodeIsMap = $jIny1 && $jIny1.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $abac330771f68232$var$isMap = $abac330771f68232$var$nodeIsMap ? $91Qdd($abac330771f68232$var$nodeIsMap) : $9ORep;
module.exports = $abac330771f68232$var$isMap;

});
parcelRegister("9ORep", function(module, exports) {

var $67A6V = parcelRequire("67A6V");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $7262133281c40437$var$mapTag = "[object Map]";
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $7262133281c40437$var$baseIsMap(value) {
    return $8l89S(value) && $67A6V(value) == $7262133281c40437$var$mapTag;
}
module.exports = $7262133281c40437$var$baseIsMap;

});


parcelRegister("jZm8C", function(module, exports) {

var $eFk8g = parcelRequire("eFk8g");

var $91Qdd = parcelRequire("91Qdd");

var $jIny1 = parcelRequire("jIny1");
/* Node.js helper references. */ var $e8d4e2fa1f2b8f08$var$nodeIsSet = $jIny1 && $jIny1.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $e8d4e2fa1f2b8f08$var$isSet = $e8d4e2fa1f2b8f08$var$nodeIsSet ? $91Qdd($e8d4e2fa1f2b8f08$var$nodeIsSet) : $eFk8g;
module.exports = $e8d4e2fa1f2b8f08$var$isSet;

});
parcelRegister("eFk8g", function(module, exports) {

var $67A6V = parcelRequire("67A6V");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $aad482e59457493b$var$setTag = "[object Set]";
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $aad482e59457493b$var$baseIsSet(value) {
    return $8l89S(value) && $67A6V(value) == $aad482e59457493b$var$setTag;
}
module.exports = $aad482e59457493b$var$baseIsSet;

});




parcelRegister("ikaiq", function(module, exports) {

var $4UXHD = parcelRequire("4UXHD");

var $47O2q = parcelRequire("47O2q");

var $8l7PP = parcelRequire("8l7PP");

var $jqUWg = parcelRequire("jqUWg");

var $1SWLj = parcelRequire("1SWLj");

var $iYJk1 = parcelRequire("iYJk1");

var $xMy82 = parcelRequire("xMy82");

var $9P3tH = parcelRequire("9P3tH");
var $d57214db80dd0f29$var$normalizeArray = (val)=>Array.isArray(val) ? val : [
        val
    ];
var $d57214db80dd0f29$var$undef = (val)=>val === undefined;
var $d57214db80dd0f29$var$keys = (obj)=>$xMy82(obj) || Array.isArray(obj) ? Object.keys(obj) : [];
var $d57214db80dd0f29$var$has = (obj, key)=>obj.hasOwnProperty(key);
var $d57214db80dd0f29$var$stringArray = (arr)=>$47O2q($8l7PP(arr));
var $d57214db80dd0f29$var$undefEmpty = (val)=>$d57214db80dd0f29$var$undef(val) || Array.isArray(val) && val.length === 0;
var $d57214db80dd0f29$var$keyValEqual = (a, b, key, compare)=>b && $d57214db80dd0f29$var$has(b, key) && a && $d57214db80dd0f29$var$has(a, key) && compare(a[key], b[key]);
var $d57214db80dd0f29$var$undefAndZero = (a, b)=>$d57214db80dd0f29$var$undef(a) && b === 0 || $d57214db80dd0f29$var$undef(b) && a === 0 || $4UXHD(a, b);
var $d57214db80dd0f29$var$falseUndefined = (a, b)=>$d57214db80dd0f29$var$undef(a) && b === false || $d57214db80dd0f29$var$undef(b) && a === false || $4UXHD(a, b);
var $d57214db80dd0f29$var$emptySchema = (schema)=>$d57214db80dd0f29$var$undef(schema) || $4UXHD(schema, {}) || schema === true;
var $d57214db80dd0f29$var$emptyObjUndef = (schema)=>$d57214db80dd0f29$var$undef(schema) || $4UXHD(schema, {});
var $d57214db80dd0f29$var$isSchema = (val)=>$d57214db80dd0f29$var$undef(val) || $xMy82(val) || val === true || val === false;
function $d57214db80dd0f29$var$undefArrayEqual(a, b) {
    if ($d57214db80dd0f29$var$undefEmpty(a) && $d57214db80dd0f29$var$undefEmpty(b)) return true;
    else return $4UXHD($d57214db80dd0f29$var$stringArray(a), $d57214db80dd0f29$var$stringArray(b));
}
function $d57214db80dd0f29$var$unsortedNormalizedArray(a, b) {
    a = $d57214db80dd0f29$var$normalizeArray(a);
    b = $d57214db80dd0f29$var$normalizeArray(b);
    return $4UXHD($d57214db80dd0f29$var$stringArray(a), $d57214db80dd0f29$var$stringArray(b));
}
function $d57214db80dd0f29$var$schemaGroup(a, b, key, compare) {
    var allProps = $8l7PP($d57214db80dd0f29$var$keys(a).concat($d57214db80dd0f29$var$keys(b)));
    if ($d57214db80dd0f29$var$emptyObjUndef(a) && $d57214db80dd0f29$var$emptyObjUndef(b)) return true;
    else if ($d57214db80dd0f29$var$emptyObjUndef(a) && $d57214db80dd0f29$var$keys(b).length) return false;
    else if ($d57214db80dd0f29$var$emptyObjUndef(b) && $d57214db80dd0f29$var$keys(a).length) return false;
    return allProps.every(function(key) {
        var aVal = a[key];
        var bVal = b[key];
        if (Array.isArray(aVal) && Array.isArray(bVal)) return $4UXHD($d57214db80dd0f29$var$stringArray(a), $d57214db80dd0f29$var$stringArray(b));
        else if (Array.isArray(aVal) && !Array.isArray(bVal)) return false;
        else if (Array.isArray(bVal) && !Array.isArray(aVal)) return false;
        return $d57214db80dd0f29$var$keyValEqual(a, b, key, compare);
    });
}
function $d57214db80dd0f29$var$items(a, b, key, compare) {
    if ($xMy82(a) && $xMy82(b)) return compare(a, b);
    else if (Array.isArray(a) && Array.isArray(b)) return $d57214db80dd0f29$var$schemaGroup(a, b, key, compare);
    else return $4UXHD(a, b);
}
function $d57214db80dd0f29$var$unsortedArray(a, b, key, compare) {
    var uniqueA = $jqUWg(a, compare);
    var uniqueB = $jqUWg(b, compare);
    var inter = $iYJk1(uniqueA, uniqueB, compare);
    return inter.length === Math.max(uniqueA.length, uniqueB.length);
}
var $d57214db80dd0f29$var$comparers = {
    title: $4UXHD,
    uniqueItems: $d57214db80dd0f29$var$falseUndefined,
    minLength: $d57214db80dd0f29$var$undefAndZero,
    minItems: $d57214db80dd0f29$var$undefAndZero,
    minProperties: $d57214db80dd0f29$var$undefAndZero,
    required: $d57214db80dd0f29$var$undefArrayEqual,
    enum: $d57214db80dd0f29$var$undefArrayEqual,
    type: $d57214db80dd0f29$var$unsortedNormalizedArray,
    items: $d57214db80dd0f29$var$items,
    anyOf: $d57214db80dd0f29$var$unsortedArray,
    allOf: $d57214db80dd0f29$var$unsortedArray,
    oneOf: $d57214db80dd0f29$var$unsortedArray,
    properties: $d57214db80dd0f29$var$schemaGroup,
    patternProperties: $d57214db80dd0f29$var$schemaGroup,
    dependencies: $d57214db80dd0f29$var$schemaGroup
};
var $d57214db80dd0f29$var$acceptsUndefined = [
    "properties",
    "patternProperties",
    "dependencies",
    "uniqueItems",
    "minLength",
    "minItems",
    "minProperties",
    "required"
];
var $d57214db80dd0f29$var$schemaProps = [
    "additionalProperties",
    "additionalItems",
    "contains",
    "propertyNames",
    "not"
];
function $d57214db80dd0f29$var$compare(a, b, options) {
    options = $1SWLj(options, {
        ignore: []
    });
    if ($d57214db80dd0f29$var$emptySchema(a) && $d57214db80dd0f29$var$emptySchema(b)) return true;
    if (!$d57214db80dd0f29$var$isSchema(a) || !$d57214db80dd0f29$var$isSchema(b)) throw new Error("Either of the values are not a JSON schema.");
    if (a === b) return true;
    if ($9P3tH(a) && $9P3tH(b)) return a === b;
    if (a === undefined && b === false || b === undefined && a === false) return false;
    if ($d57214db80dd0f29$var$undef(a) && !$d57214db80dd0f29$var$undef(b) || !$d57214db80dd0f29$var$undef(a) && $d57214db80dd0f29$var$undef(b)) return false;
    var allKeys = $8l7PP(Object.keys(a).concat(Object.keys(b)));
    if (options.ignore.length) allKeys = allKeys.filter((k)=>options.ignore.indexOf(k) === -1);
    if (!allKeys.length) return true;
    function innerCompare(a, b) {
        return $d57214db80dd0f29$var$compare(a, b, options);
    }
    return allKeys.every(function(key) {
        var aValue = a[key];
        var bValue = b[key];
        if ($d57214db80dd0f29$var$schemaProps.indexOf(key) !== -1) return $d57214db80dd0f29$var$compare(aValue, bValue, options);
        var comparer = $d57214db80dd0f29$var$comparers[key];
        if (!comparer) comparer = $4UXHD;
        // do simple lodash check first
        if ($4UXHD(aValue, bValue)) return true;
        if ($d57214db80dd0f29$var$acceptsUndefined.indexOf(key) === -1) {
            if (!$d57214db80dd0f29$var$has(a, key) && $d57214db80dd0f29$var$has(b, key) || $d57214db80dd0f29$var$has(a, key) && !$d57214db80dd0f29$var$has(b, key)) return aValue === bValue;
        }
        var result = comparer(aValue, bValue, key, innerCompare);
        if (!$9P3tH(result)) throw new Error("Comparer must return true or false");
        return result;
    });
}
module.exports = $d57214db80dd0f29$var$compare;

});
parcelRegister("4UXHD", function(module, exports) {

var $abgWr = parcelRequire("abgWr");
/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $394ab417e9bd75cc$var$isEqual(value, other) {
    return $abgWr(value, other);
}
module.exports = $394ab417e9bd75cc$var$isEqual;

});
parcelRegister("abgWr", function(module, exports) {

var $7qq40 = parcelRequire("7qq40");

var $8l89S = parcelRequire("8l89S");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $769812b29c18141e$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$8l89S(value) && !$8l89S(other)) return value !== value && other !== other;
    return $7qq40(value, other, bitmask, customizer, $769812b29c18141e$var$baseIsEqual, stack);
}
module.exports = $769812b29c18141e$var$baseIsEqual;

});
parcelRegister("7qq40", function(module, exports) {

var $g779E = parcelRequire("g779E");

var $1pRE7 = parcelRequire("1pRE7");

var $g3aCZ = parcelRequire("g3aCZ");

var $eOqMj = parcelRequire("eOqMj");

var $67A6V = parcelRequire("67A6V");

var $o8HxT = parcelRequire("o8HxT");

var $f504n = parcelRequire("f504n");

var $1Q21n = parcelRequire("1Q21n");
/** Used to compose bitmasks for value comparisons. */ var $567f2dd161ebd4f6$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $567f2dd161ebd4f6$var$argsTag = "[object Arguments]", $567f2dd161ebd4f6$var$arrayTag = "[object Array]", $567f2dd161ebd4f6$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $567f2dd161ebd4f6$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $567f2dd161ebd4f6$var$hasOwnProperty = $567f2dd161ebd4f6$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $567f2dd161ebd4f6$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $o8HxT(object), othIsArr = $o8HxT(other), objTag = objIsArr ? $567f2dd161ebd4f6$var$arrayTag : $67A6V(object), othTag = othIsArr ? $567f2dd161ebd4f6$var$arrayTag : $67A6V(other);
    objTag = objTag == $567f2dd161ebd4f6$var$argsTag ? $567f2dd161ebd4f6$var$objectTag : objTag;
    othTag = othTag == $567f2dd161ebd4f6$var$argsTag ? $567f2dd161ebd4f6$var$objectTag : othTag;
    var objIsObj = objTag == $567f2dd161ebd4f6$var$objectTag, othIsObj = othTag == $567f2dd161ebd4f6$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $f504n(object)) {
        if (!$f504n(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $g779E);
        return objIsArr || $1Q21n(object) ? $1pRE7(object, other, bitmask, customizer, equalFunc, stack) : $g3aCZ(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $567f2dd161ebd4f6$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $567f2dd161ebd4f6$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $567f2dd161ebd4f6$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $g779E);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $g779E);
    return $eOqMj(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = $567f2dd161ebd4f6$var$baseIsEqualDeep;

});
parcelRegister("1pRE7", function(module, exports) {

var $dXA7v = parcelRequire("dXA7v");

var $eFBTL = parcelRequire("eFBTL");

var $2l8n7 = parcelRequire("2l8n7");
/** Used to compose bitmasks for value comparisons. */ var $1081bd3a2e361911$var$COMPARE_PARTIAL_FLAG = 1, $1081bd3a2e361911$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $1081bd3a2e361911$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $1081bd3a2e361911$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $1081bd3a2e361911$var$COMPARE_UNORDERED_FLAG ? new $dXA7v : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$eFBTL(other, function(othValue, othIndex) {
                if (!$2l8n7(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
module.exports = $1081bd3a2e361911$var$equalArrays;

});
parcelRegister("dXA7v", function(module, exports) {

var $6gDBQ = parcelRequire("6gDBQ");

var $j1Tfx = parcelRequire("j1Tfx");

var $8NkYQ = parcelRequire("8NkYQ");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $a29ccdc0f60e279e$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $6gDBQ;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$a29ccdc0f60e279e$var$SetCache.prototype.add = $a29ccdc0f60e279e$var$SetCache.prototype.push = $j1Tfx;
$a29ccdc0f60e279e$var$SetCache.prototype.has = $8NkYQ;
module.exports = $a29ccdc0f60e279e$var$SetCache;

});
parcelRegister("j1Tfx", function(module, exports) {
/** Used to stand-in for `undefined` hash values. */ var $dda8f7b6b589544e$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $dda8f7b6b589544e$var$setCacheAdd(value) {
    this.__data__.set(value, $dda8f7b6b589544e$var$HASH_UNDEFINED);
    return this;
}
module.exports = $dda8f7b6b589544e$var$setCacheAdd;

});

parcelRegister("8NkYQ", function(module, exports) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $66732c92c350622c$var$setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = $66732c92c350622c$var$setCacheHas;

});


parcelRegister("eFBTL", function(module, exports) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $aae24ad60cc3cfcb$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = $aae24ad60cc3cfcb$var$arraySome;

});

parcelRegister("2l8n7", function(module, exports) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $1b44096ad4b9e2d5$var$cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = $1b44096ad4b9e2d5$var$cacheHas;

});


parcelRegister("g3aCZ", function(module, exports) {

var $57wYk = parcelRequire("57wYk");

var $lx3EF = parcelRequire("lx3EF");

var $6TC8i = parcelRequire("6TC8i");

var $1pRE7 = parcelRequire("1pRE7");

var $cwfcG = parcelRequire("cwfcG");

var $1xAji = parcelRequire("1xAji");
/** Used to compose bitmasks for value comparisons. */ var $baf52b9e146f3da7$var$COMPARE_PARTIAL_FLAG = 1, $baf52b9e146f3da7$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $baf52b9e146f3da7$var$boolTag = "[object Boolean]", $baf52b9e146f3da7$var$dateTag = "[object Date]", $baf52b9e146f3da7$var$errorTag = "[object Error]", $baf52b9e146f3da7$var$mapTag = "[object Map]", $baf52b9e146f3da7$var$numberTag = "[object Number]", $baf52b9e146f3da7$var$regexpTag = "[object RegExp]", $baf52b9e146f3da7$var$setTag = "[object Set]", $baf52b9e146f3da7$var$stringTag = "[object String]", $baf52b9e146f3da7$var$symbolTag = "[object Symbol]";
var $baf52b9e146f3da7$var$arrayBufferTag = "[object ArrayBuffer]", $baf52b9e146f3da7$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $baf52b9e146f3da7$var$symbolProto = $57wYk ? $57wYk.prototype : undefined, $baf52b9e146f3da7$var$symbolValueOf = $baf52b9e146f3da7$var$symbolProto ? $baf52b9e146f3da7$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $baf52b9e146f3da7$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $baf52b9e146f3da7$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $baf52b9e146f3da7$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $lx3EF(object), new $lx3EF(other))) return false;
            return true;
        case $baf52b9e146f3da7$var$boolTag:
        case $baf52b9e146f3da7$var$dateTag:
        case $baf52b9e146f3da7$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $6TC8i(+object, +other);
        case $baf52b9e146f3da7$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $baf52b9e146f3da7$var$regexpTag:
        case $baf52b9e146f3da7$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $baf52b9e146f3da7$var$mapTag:
            var convert = $cwfcG;
        case $baf52b9e146f3da7$var$setTag:
            var isPartial = bitmask & $baf52b9e146f3da7$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $1xAji);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $baf52b9e146f3da7$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $1pRE7(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $baf52b9e146f3da7$var$symbolTag:
            if ($baf52b9e146f3da7$var$symbolValueOf) return $baf52b9e146f3da7$var$symbolValueOf.call(object) == $baf52b9e146f3da7$var$symbolValueOf.call(other);
    }
    return false;
}
module.exports = $baf52b9e146f3da7$var$equalByTag;

});
parcelRegister("cwfcG", function(module, exports) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $91d4444cbb077e0c$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = $91d4444cbb077e0c$var$mapToArray;

});

parcelRegister("1xAji", function(module, exports) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $11f509f8f53d8c36$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = $11f509f8f53d8c36$var$setToArray;

});


parcelRegister("eOqMj", function(module, exports) {

var $apVCl = parcelRequire("apVCl");
/** Used to compose bitmasks for value comparisons. */ var $ac8a81cbae0357e8$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $ac8a81cbae0357e8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ac8a81cbae0357e8$var$hasOwnProperty = $ac8a81cbae0357e8$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $ac8a81cbae0357e8$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $ac8a81cbae0357e8$var$COMPARE_PARTIAL_FLAG, objProps = $apVCl(object), objLength = objProps.length, othProps = $apVCl(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $ac8a81cbae0357e8$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
module.exports = $ac8a81cbae0357e8$var$equalObjects;

});




parcelRegister("47O2q", function(module, exports) {

var $fgBHx = parcelRequire("fgBHx");

var $jrtNg = parcelRequire("jrtNg");

var $5iyRF = parcelRequire("5iyRF");

var $b8mN0 = parcelRequire("b8mN0");
/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $300ea168693086c2$var$sortBy = $5iyRF(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $b8mN0(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $b8mN0(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $jrtNg(collection, $fgBHx(iteratees, 1), []);
});
module.exports = $300ea168693086c2$var$sortBy;

});
parcelRegister("jrtNg", function(module, exports) {

var $i46jW = parcelRequire("i46jW");

var $lJEX1 = parcelRequire("lJEX1");

var $7MWok = parcelRequire("7MWok");

var $fDc61 = parcelRequire("fDc61");

var $9xZGY = parcelRequire("9xZGY");

var $91Qdd = parcelRequire("91Qdd");

var $fyGSR = parcelRequire("fyGSR");

var $4Nq5y = parcelRequire("4Nq5y");

var $o8HxT = parcelRequire("o8HxT");
/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $e277a64de4eeade6$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $i46jW(iteratees, function(iteratee) {
        if ($o8HxT(iteratee)) return function(value) {
            return $lJEX1(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $4Nq5y
    ];
    var index = -1;
    iteratees = $i46jW(iteratees, $91Qdd($7MWok));
    var result = $fDc61(collection, function(value, key, collection) {
        var criteria = $i46jW(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            "criteria": criteria,
            "index": ++index,
            "value": value
        };
    });
    return $9xZGY(result, function(object, other) {
        return $fyGSR(object, other, orders);
    });
}
module.exports = $e277a64de4eeade6$var$baseOrderBy;

});
parcelRegister("7MWok", function(module, exports) {

var $jShkp = parcelRequire("jShkp");

var $in5n5 = parcelRequire("in5n5");

var $4Nq5y = parcelRequire("4Nq5y");

var $o8HxT = parcelRequire("o8HxT");

var $bAYPD = parcelRequire("bAYPD");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $5aba4f6d9f8304a3$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return $4Nq5y;
    if (typeof value == "object") return $o8HxT(value) ? $in5n5(value[0], value[1]) : $jShkp(value);
    return $bAYPD(value);
}
module.exports = $5aba4f6d9f8304a3$var$baseIteratee;

});
parcelRegister("jShkp", function(module, exports) {

var $kgn8n = parcelRequire("kgn8n");

var $9dd8D = parcelRequire("9dd8D");

var $2IhDm = parcelRequire("2IhDm");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $e780807e2b795134$var$baseMatches(source) {
    var matchData = $9dd8D(source);
    if (matchData.length == 1 && matchData[0][2]) return $2IhDm(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $kgn8n(object, source, matchData);
    };
}
module.exports = $e780807e2b795134$var$baseMatches;

});
parcelRegister("kgn8n", function(module, exports) {

var $g779E = parcelRequire("g779E");

var $abgWr = parcelRequire("abgWr");
/** Used to compose bitmasks for value comparisons. */ var $ec073f38db6e7d54$var$COMPARE_PARTIAL_FLAG = 1, $ec073f38db6e7d54$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $ec073f38db6e7d54$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $g779E;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $abgWr(srcValue, objValue, $ec073f38db6e7d54$var$COMPARE_PARTIAL_FLAG | $ec073f38db6e7d54$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = $ec073f38db6e7d54$var$baseIsMatch;

});

parcelRegister("9dd8D", function(module, exports) {

var $1n1hd = parcelRequire("1n1hd");

var $LAMcS = parcelRequire("LAMcS");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $6b4f84f6be7f825c$var$getMatchData(object) {
    var result = $LAMcS(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $1n1hd(value)
        ];
    }
    return result;
}
module.exports = $6b4f84f6be7f825c$var$getMatchData;

});
parcelRegister("1n1hd", function(module, exports) {

var $lsJ54 = parcelRequire("lsJ54");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $0ff8edf4f90a7955$var$isStrictComparable(value) {
    return value === value && !$lsJ54(value);
}
module.exports = $0ff8edf4f90a7955$var$isStrictComparable;

});


parcelRegister("2IhDm", function(module, exports) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $1f9d5e891556ddb9$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = $1f9d5e891556ddb9$var$matchesStrictComparable;

});


parcelRegister("in5n5", function(module, exports) {

var $abgWr = parcelRequire("abgWr");

var $i51gj = parcelRequire("i51gj");

var $2VBx6 = parcelRequire("2VBx6");

var $kPpic = parcelRequire("kPpic");

var $1n1hd = parcelRequire("1n1hd");

var $2IhDm = parcelRequire("2IhDm");

var $6DSvu = parcelRequire("6DSvu");
/** Used to compose bitmasks for value comparisons. */ var $d5fe8a98fe4800eb$var$COMPARE_PARTIAL_FLAG = 1, $d5fe8a98fe4800eb$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $d5fe8a98fe4800eb$var$baseMatchesProperty(path, srcValue) {
    if ($kPpic(path) && $1n1hd(srcValue)) return $2IhDm($6DSvu(path), srcValue);
    return function(object) {
        var objValue = $i51gj(object, path);
        return objValue === undefined && objValue === srcValue ? $2VBx6(object, path) : $abgWr(srcValue, objValue, $d5fe8a98fe4800eb$var$COMPARE_PARTIAL_FLAG | $d5fe8a98fe4800eb$var$COMPARE_UNORDERED_FLAG);
    };
}
module.exports = $d5fe8a98fe4800eb$var$baseMatchesProperty;

});

parcelRegister("bAYPD", function(module, exports) {

var $ielIK = parcelRequire("ielIK");

var $jfdoV = parcelRequire("jfdoV");

var $kPpic = parcelRequire("kPpic");

var $6DSvu = parcelRequire("6DSvu");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $87123e72266aa58c$var$property(path) {
    return $kPpic(path) ? $ielIK($6DSvu(path)) : $jfdoV(path);
}
module.exports = $87123e72266aa58c$var$property;

});
parcelRegister("ielIK", function(module, exports) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $d45a621b4548f6bb$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $d45a621b4548f6bb$var$baseProperty;

});

parcelRegister("jfdoV", function(module, exports) {

var $lJEX1 = parcelRequire("lJEX1");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $e029d02f9dd10368$var$basePropertyDeep(path) {
    return function(object) {
        return $lJEX1(object, path);
    };
}
module.exports = $e029d02f9dd10368$var$basePropertyDeep;

});



parcelRegister("fDc61", function(module, exports) {

var $4DjQp = parcelRequire("4DjQp");

var $eMthh = parcelRequire("eMthh");
/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $b613e194c1b157de$var$baseMap(collection, iteratee) {
    var index = -1, result = $eMthh(collection) ? Array(collection.length) : [];
    $4DjQp(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
module.exports = $b613e194c1b157de$var$baseMap;

});
parcelRegister("4DjQp", function(module, exports) {

var $4xK4A = parcelRequire("4xK4A");

var $kCOH9 = parcelRequire("kCOH9");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $35fa3296f177aa01$var$baseEach = $kCOH9($4xK4A);
module.exports = $35fa3296f177aa01$var$baseEach;

});
parcelRegister("4xK4A", function(module, exports) {

var $dEvx9 = parcelRequire("dEvx9");

var $LAMcS = parcelRequire("LAMcS");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $34edfba366a0cfa1$var$baseForOwn(object, iteratee) {
    return object && $dEvx9(object, iteratee, $LAMcS);
}
module.exports = $34edfba366a0cfa1$var$baseForOwn;

});
parcelRegister("dEvx9", function(module, exports) {

var $jTvRt = parcelRequire("jTvRt");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $9f0778b809a8c692$var$baseFor = $jTvRt();
module.exports = $9f0778b809a8c692$var$baseFor;

});
parcelRegister("jTvRt", function(module, exports) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $e7bbde6376f4568a$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = $e7bbde6376f4568a$var$createBaseFor;

});



parcelRegister("kCOH9", function(module, exports) {

var $eMthh = parcelRequire("eMthh");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $f03eae3721f9ace8$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$eMthh(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = $f03eae3721f9ace8$var$createBaseEach;

});



parcelRegister("9xZGY", function(module, exports) {
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $6f370ce7a904568e$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
module.exports = $6f370ce7a904568e$var$baseSortBy;

});

parcelRegister("fyGSR", function(module, exports) {

var $1HU00 = parcelRequire("1HU00");
/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $b53b4bd61680c3b6$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $1HU00(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == "desc" ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
module.exports = $b53b4bd61680c3b6$var$compareMultiple;

});
parcelRegister("1HU00", function(module, exports) {

var $9dr3u = parcelRequire("9dr3u");
/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $13e53edf809f77b7$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $9dr3u(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $9dr3u(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
module.exports = $13e53edf809f77b7$var$compareAscending;

});



parcelRegister("5iyRF", function(module, exports) {

var $4Nq5y = parcelRequire("4Nq5y");

var $b86t6 = parcelRequire("b86t6");

var $iGMVy = parcelRequire("iGMVy");
/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $3db9ad8fe1351fef$var$baseRest(func, start) {
    return $iGMVy($b86t6(func, start, $4Nq5y), func + "");
}
module.exports = $3db9ad8fe1351fef$var$baseRest;

});

parcelRegister("b8mN0", function(module, exports) {

var $6TC8i = parcelRequire("6TC8i");

var $eMthh = parcelRequire("eMthh");

var $iyUuu = parcelRequire("iyUuu");

var $lsJ54 = parcelRequire("lsJ54");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $81b21e8b41d211e8$var$isIterateeCall(value, index, object) {
    if (!$lsJ54(object)) return false;
    var type = typeof index;
    if (type == "number" ? $eMthh(object) && $iyUuu(index, object.length) : type == "string" && index in object) return $6TC8i(object[index], value);
    return false;
}
module.exports = $81b21e8b41d211e8$var$isIterateeCall;

});


parcelRegister("8l7PP", function(module, exports) {

var $5VSS6 = parcelRequire("5VSS6");
/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */ function $61265cbd5811e578$var$uniq(array) {
    return array && array.length ? $5VSS6(array) : [];
}
module.exports = $61265cbd5811e578$var$uniq;

});
parcelRegister("5VSS6", function(module, exports) {

var $dXA7v = parcelRequire("dXA7v");

var $ebE2M = parcelRequire("ebE2M");

var $eSdxB = parcelRequire("eSdxB");

var $2l8n7 = parcelRequire("2l8n7");

var $5sRi0 = parcelRequire("5sRi0");

var $1xAji = parcelRequire("1xAji");
/** Used as the size to enable large array optimizations. */ var $451cd6fc5b077ebe$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $451cd6fc5b077ebe$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $ebE2M, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $eSdxB;
    } else if (length >= $451cd6fc5b077ebe$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $5sRi0(array);
        if (set) return $1xAji(set);
        isCommon = false;
        includes = $2l8n7;
        seen = new $dXA7v;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $451cd6fc5b077ebe$var$baseUniq;

});
parcelRegister("ebE2M", function(module, exports) {

var $7pFTU = parcelRequire("7pFTU");
/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $a541279ebb64f2c9$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $7pFTU(array, value, 0) > -1;
}
module.exports = $a541279ebb64f2c9$var$arrayIncludes;

});
parcelRegister("7pFTU", function(module, exports) {

var $eAor6 = parcelRequire("eAor6");

var $h2dHy = parcelRequire("h2dHy");

var $dU1uo = parcelRequire("dU1uo");
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $565b5ed18efa4b9c$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $dU1uo(array, value, fromIndex) : $eAor6(array, $h2dHy, fromIndex);
}
module.exports = $565b5ed18efa4b9c$var$baseIndexOf;

});
parcelRegister("eAor6", function(module, exports) {
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a9e76203bd7c412f$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
module.exports = $a9e76203bd7c412f$var$baseFindIndex;

});

parcelRegister("h2dHy", function(module, exports) {
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $c66d4063f81f4687$var$baseIsNaN(value) {
    return value !== value;
}
module.exports = $c66d4063f81f4687$var$baseIsNaN;

});

parcelRegister("dU1uo", function(module, exports) {
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $a1f1a90cd7caaefa$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
module.exports = $a1f1a90cd7caaefa$var$strictIndexOf;

});



parcelRegister("eSdxB", function(module, exports) {
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $ad409cc63f3cbe79$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
module.exports = $ad409cc63f3cbe79$var$arrayIncludesWith;

});

parcelRegister("5sRi0", function(module, exports) {

var $vH4x0 = parcelRequire("vH4x0");

var $9iECD = parcelRequire("9iECD");

var $1xAji = parcelRequire("1xAji");
/** Used as references for various `Number` constants. */ var $3fa8e773494800f5$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $3fa8e773494800f5$var$createSet = !($vH4x0 && 1 / $1xAji(new $vH4x0([
    ,
    -0
]))[1] == $3fa8e773494800f5$var$INFINITY) ? $9iECD : function(values) {
    return new $vH4x0(values);
};
module.exports = $3fa8e773494800f5$var$createSet;

});
parcelRegister("9iECD", function(module, exports) {
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $6c554e32feae9faa$var$noop() {
// No operation performed.
}
module.exports = $6c554e32feae9faa$var$noop;

});




parcelRegister("jqUWg", function(module, exports) {

var $5VSS6 = parcelRequire("5VSS6");
/**
 * This method is like `_.uniq` except that it accepts `comparator` which
 * is invoked to compare elements of `array`. The order of result values is
 * determined by the order they occur in the array.The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.uniqWith(objects, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
 */ function $e25c9cded6d70245$var$uniqWith(array, comparator) {
    comparator = typeof comparator == "function" ? comparator : undefined;
    return array && array.length ? $5VSS6(array, undefined, comparator) : [];
}
module.exports = $e25c9cded6d70245$var$uniqWith;

});

parcelRegister("1SWLj", function(module, exports) {

var $5iyRF = parcelRequire("5iyRF");

var $6TC8i = parcelRequire("6TC8i");

var $b8mN0 = parcelRequire("b8mN0");

var $f4lqP = parcelRequire("f4lqP");
/** Used for built-in method references. */ var $15f86a7fdfb0f225$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $15f86a7fdfb0f225$var$hasOwnProperty = $15f86a7fdfb0f225$var$objectProto.hasOwnProperty;
/**
 * Assigns own and inherited enumerable string keyed properties of source
 * objects to the destination object for all destination properties that
 * resolve to `undefined`. Source objects are applied from left to right.
 * Once a property is set, additional values of the same property are ignored.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaultsDeep
 * @example
 *
 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
 * // => { 'a': 1, 'b': 2 }
 */ var $15f86a7fdfb0f225$var$defaults = $5iyRF(function(object, sources) {
    object = Object(object);
    var index = -1;
    var length = sources.length;
    var guard = length > 2 ? sources[2] : undefined;
    if (guard && $b8mN0(sources[0], sources[1], guard)) length = 1;
    while(++index < length){
        var source = sources[index];
        var props = $f4lqP(source);
        var propsIndex = -1;
        var propsLength = props.length;
        while(++propsIndex < propsLength){
            var key = props[propsIndex];
            var value = object[key];
            if (value === undefined || $6TC8i(value, $15f86a7fdfb0f225$var$objectProto[key]) && !$15f86a7fdfb0f225$var$hasOwnProperty.call(object, key)) object[key] = source[key];
        }
    }
    return object;
});
module.exports = $15f86a7fdfb0f225$var$defaults;

});

parcelRegister("iYJk1", function(module, exports) {

var $i46jW = parcelRequire("i46jW");

var $6Ikd8 = parcelRequire("6Ikd8");

var $5iyRF = parcelRequire("5iyRF");

var $2lqgl = parcelRequire("2lqgl");

var $hkfXi = parcelRequire("hkfXi");
/**
 * This method is like `_.intersection` except that it accepts `comparator`
 * which is invoked to compare elements of `arrays`. The order and references
 * of result values are determined by the first array. The comparator is
 * invoked with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
 * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.intersectionWith(objects, others, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }]
 */ var $dd10fc955e7b2bd6$var$intersectionWith = $5iyRF(function(arrays) {
    var comparator = $hkfXi(arrays), mapped = $i46jW(arrays, $2lqgl);
    comparator = typeof comparator == "function" ? comparator : undefined;
    if (comparator) mapped.pop();
    return mapped.length && mapped[0] === arrays[0] ? $6Ikd8(mapped, undefined, comparator) : [];
});
module.exports = $dd10fc955e7b2bd6$var$intersectionWith;

});
parcelRegister("6Ikd8", function(module, exports) {

var $dXA7v = parcelRequire("dXA7v");

var $ebE2M = parcelRequire("ebE2M");

var $eSdxB = parcelRequire("eSdxB");

var $i46jW = parcelRequire("i46jW");

var $91Qdd = parcelRequire("91Qdd");

var $2l8n7 = parcelRequire("2l8n7");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $4e36879618b4e4e6$var$nativeMin = Math.min;
/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */ function $4e36879618b4e4e6$var$baseIntersection(arrays, iteratee, comparator) {
    var includes = comparator ? $eSdxB : $ebE2M, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array(othLength), maxLength = Infinity, result = [];
    while(othIndex--){
        var array = arrays[othIndex];
        if (othIndex && iteratee) array = $i46jW(array, $91Qdd(iteratee));
        maxLength = $4e36879618b4e4e6$var$nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new $dXA7v(othIndex && array) : undefined;
    }
    array = arrays[0];
    var index = -1, seen = caches[0];
    outer: while(++index < length && result.length < maxLength){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (!(seen ? $2l8n7(seen, computed) : includes(result, computed, comparator))) {
            othIndex = othLength;
            while(--othIndex){
                var cache = caches[othIndex];
                if (!(cache ? $2l8n7(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
            }
            if (seen) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $4e36879618b4e4e6$var$baseIntersection;

});

parcelRegister("2lqgl", function(module, exports) {

var $jGP9B = parcelRequire("jGP9B");
/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */ function $1b51ea2925b1420f$var$castArrayLikeObject(value) {
    return $jGP9B(value) ? value : [];
}
module.exports = $1b51ea2925b1420f$var$castArrayLikeObject;

});
parcelRegister("jGP9B", function(module, exports) {

var $eMthh = parcelRequire("eMthh");

var $8l89S = parcelRequire("8l89S");
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $e5599ea424e07f76$var$isArrayLikeObject(value) {
    return $8l89S(value) && $eMthh(value);
}
module.exports = $e5599ea424e07f76$var$isArrayLikeObject;

});


parcelRegister("hkfXi", function(module, exports) {
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $c9d0ae50fd1d1372$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
module.exports = $c9d0ae50fd1d1372$var$last;

});


parcelRegister("xMy82", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $cdnOB = parcelRequire("cdnOB");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $0658be17f7793a43$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $0658be17f7793a43$var$funcProto = Function.prototype, $0658be17f7793a43$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $0658be17f7793a43$var$funcToString = $0658be17f7793a43$var$funcProto.toString;
/** Used to check objects for own properties. */ var $0658be17f7793a43$var$hasOwnProperty = $0658be17f7793a43$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $0658be17f7793a43$var$objectCtorString = $0658be17f7793a43$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $0658be17f7793a43$var$isPlainObject(value) {
    if (!$8l89S(value) || $eq6CV(value) != $0658be17f7793a43$var$objectTag) return false;
    var proto = $cdnOB(value);
    if (proto === null) return true;
    var Ctor = $0658be17f7793a43$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $0658be17f7793a43$var$funcToString.call(Ctor) == $0658be17f7793a43$var$objectCtorString;
}
module.exports = $0658be17f7793a43$var$isPlainObject;

});

parcelRegister("9P3tH", function(module, exports) {

var $eq6CV = parcelRequire("eq6CV");

var $8l89S = parcelRequire("8l89S");
/** `Object#toString` result references. */ var $726b932117967293$var$boolTag = "[object Boolean]";
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function $726b932117967293$var$isBoolean(value) {
    return value === true || value === false || $8l89S(value) && $eq6CV(value) == $726b932117967293$var$boolTag;
}
module.exports = $726b932117967293$var$isBoolean;

});


parcelRegister("4NxxH", function(module, exports) {
"use strict";

var $578TN = parcelRequire("578TN");

var $4ZrEw = parcelRequire("4ZrEw");

var $euwdR = parcelRequire("euwdR");

var $8MBIo = parcelRequire("8MBIo");
// LEAST COMMON MULTIPLE //
/**
* FUNCTION: lcm( arr[, clbk] )
*	Computes the least common multiple (lcm).
*
* @param {Number[]|Number} arr - input array of integers
* @param {Function|Number} [accessor] - accessor function for accessing array values
* @returns {Number|Null} least common multiple or null
*/ function $37e5c1dccea37802$var$lcm() {
    var nargs = arguments.length, args, clbk, arr, len, a, b, i;
    // Copy the input arguments to an array...
    args = new Array(nargs);
    for(i = 0; i < nargs; i++)args[i] = arguments[i];
    // Have we been provided with integer arguments?
    if ($euwdR(args)) {
        if (nargs === 2) {
            a = args[0];
            b = args[1];
            if (a < 0) a = -a;
            if (b < 0) b = -b;
            if (a === 0 || b === 0) return 0;
            return a / $578TN(a, b) * b;
        }
        arr = args;
    } else if (!$4ZrEw(args[0])) throw new TypeError("lcm()::invalid input argument. Must provide an array of integers. Value: `" + args[0] + "`.");
    else if (nargs > 1) {
        arr = args[0];
        clbk = args[1];
        if (!$8MBIo(clbk)) throw new TypeError("lcm()::invalid input argument. Accessor must be a function. Value: `" + clbk + "`.");
    } else arr = args[0];
    len = arr.length;
    // Check if a sufficient number of values have been provided...
    if (len < 2) return null;
    // If an accessor is provided, extract the array values...
    if (clbk) {
        a = new Array(len);
        for(i = 0; i < len; i++)a[i] = clbk(arr[i], i);
        arr = a;
    }
    // Given an input array, ensure all array values are integers...
    if (nargs < 3) {
        if (!$euwdR(arr)) throw new TypeError("lcm()::invalid input argument. Accessed array values must be integers. Value: `" + arr + "`.");
    }
    // Convert any negative integers to positive integers...
    for(i = 0; i < len; i++){
        a = arr[i];
        if (a < 0) arr[i] = -a;
    }
    // Exploit the fact that the lcm is an associative function...
    a = arr[0];
    for(i = 1; i < len; i++){
        b = arr[i];
        if (a === 0 || b === 0) return 0;
        a = a / $578TN(a, b) * b;
    }
    return a;
} // end FUNCTION lcm()
// EXPORTS //
module.exports = $37e5c1dccea37802$var$lcm;

});
parcelRegister("578TN", function(module, exports) {
"use strict";

var $4ZrEw = parcelRequire("4ZrEw");

var $euwdR = parcelRequire("euwdR");

var $8MBIo = parcelRequire("8MBIo");
// VARIABLES //
var $3b948253d3bf0223$var$MAXINT = Math.pow(2, 31) - 1;
// FUNCTIONS //
/**
* FUNCTION: gcd( a, b )
*	Computes the greatest common divisor of two integers `a` and `b`, using the binary GCD algorithm.
*
* @param {Number} a - integer
* @param {Number} b - integer
* @returns {Number} greatest common divisor
*/ function $3b948253d3bf0223$var$gcd(a, b) {
    var k = 1, t;
    // Simple cases:
    if (a === 0) return b;
    if (b === 0) return a;
    // Reduce `a` and/or `b` to odd numbers and keep track of the greatest power of 2 dividing both `a` and `b`...
    while(a % 2 === 0 && b % 2 === 0){
        a = a / 2; // right shift
        b = b / 2; // right shift
        k = k * 2; // left shift
    }
    // Reduce `a` to an odd number...
    while(a % 2 === 0)a = a / 2; // right shift
    // Henceforth, `a` is always odd...
    while(b){
        // Remove all factors of 2 in `b`, as they are not common...
        while(b % 2 === 0)b = b / 2; // right shift
        // `a` and `b` are both odd. Swap values such that `b` is the larger of the two values, and then set `b` to the difference (which is even)...
        if (a > b) {
            t = b;
            b = a;
            a = t;
        }
        b = b - a; // b=0 iff b=a
    }
    // Restore common factors of 2...
    return k * a;
} // end FUNCTION gcd()
/**
* FUNCTION: bitwise( a, b )
*	Computes the greatest common divisor of two integers `a` and `b`, using the binary GCD algorithm and bitwise operations.
*
* @param {Number} a - safe integer
* @param {Number} b - safe integer
* @returns {Number} greatest common divisor
*/ function $3b948253d3bf0223$var$bitwise(a, b) {
    var k = 0, t;
    // Simple cases:
    if (a === 0) return b;
    if (b === 0) return a;
    // Reduce `a` and/or `b` to odd numbers and keep track of the greatest power of 2 dividing both `a` and `b`...
    while((a & 1) === 0 && (b & 1) === 0){
        a >>>= 1; // right shift
        b >>>= 1; // right shift
        k++;
    }
    // Reduce `a` to an odd number...
    while((a & 1) === 0)a >>>= 1; // right shift
    // Henceforth, `a` is always odd...
    while(b){
        // Remove all factors of 2 in `b`, as they are not common...
        while((b & 1) === 0)b >>>= 1; // right shift
        // `a` and `b` are both odd. Swap values such that `b` is the larger of the two values, and then set `b` to the difference (which is even)...
        if (a > b) {
            t = b;
            b = a;
            a = t;
        }
        b = b - a; // b=0 iff b=a
    }
    // Restore common factors of 2...
    return a << k;
} // end FUNCTION bitwise()
// GREATEST COMMON DIVISOR //
/**
* FUNCTION: compute( arr[, clbk] )
*	Computes the greatest common divisor.
*
* @param {Number[]|Number} arr - input array of integers
* @param {Function|Number} [clbk] - accessor function for accessing array values
* @returns {Number|Null} greatest common divisor or null
*/ function $3b948253d3bf0223$var$compute() {
    var nargs = arguments.length, args, clbk, arr, len, a, b, i;
    // Copy the input arguments to an array...
    args = new Array(nargs);
    for(i = 0; i < nargs; i++)args[i] = arguments[i];
    // Have we been provided with integer arguments?
    if ($euwdR(args)) {
        if (nargs === 2) {
            a = args[0];
            b = args[1];
            if (a < 0) a = -a;
            if (b < 0) b = -b;
            if (a <= $3b948253d3bf0223$var$MAXINT && b <= $3b948253d3bf0223$var$MAXINT) return $3b948253d3bf0223$var$bitwise(a, b);
            else return $3b948253d3bf0223$var$gcd(a, b);
        }
        arr = args;
    } else if (!$4ZrEw(args[0])) throw new TypeError("gcd()::invalid input argument. Must provide an array of integers. Value: `" + args[0] + "`.");
    else if (nargs > 1) {
        arr = args[0];
        clbk = args[1];
        if (!$8MBIo(clbk)) throw new TypeError("gcd()::invalid input argument. Accessor must be a function. Value: `" + clbk + "`.");
    } else arr = args[0];
    len = arr.length;
    // Check if a sufficient number of values have been provided...
    if (len < 2) return null;
    // If an accessor is provided, extract the array values...
    if (clbk) {
        a = new Array(len);
        for(i = 0; i < len; i++)a[i] = clbk(arr[i], i);
        arr = a;
    }
    // Given an input array, ensure all array values are integers...
    if (nargs < 3) {
        if (!$euwdR(arr)) throw new TypeError("gcd()::invalid input argument. Accessed array values must be integers. Value: `" + arr + "`.");
    }
    // Convert any negative integers to positive integers...
    for(i = 0; i < len; i++){
        a = arr[i];
        if (a < 0) arr[i] = -a;
    }
    // Exploit the fact that the gcd is an associative function...
    a = arr[0];
    for(i = 1; i < len; i++){
        b = arr[i];
        if (b <= $3b948253d3bf0223$var$MAXINT && a <= $3b948253d3bf0223$var$MAXINT) a = $3b948253d3bf0223$var$bitwise(a, b);
        else a = $3b948253d3bf0223$var$gcd(a, b);
    }
    return a;
} // end FUNCTION compute()
// EXPORTS //
module.exports = $3b948253d3bf0223$var$compute;

});
parcelRegister("4ZrEw", function(module, exports) {
"use strict";
/**
* FUNCTION: isArray( value )
*	Validates if a value is an array.
*
* @param {*} value - value to be validated
* @returns {Boolean} boolean indicating whether value is an array
*/ function $3a224f2158766a50$var$isArray(value) {
    return Object.prototype.toString.call(value) === "[object Array]";
} // end FUNCTION isArray()
// EXPORTS //
module.exports = Array.isArray || $3a224f2158766a50$var$isArray;

});

parcelRegister("euwdR", function(module, exports) {
/**
*
*	VALIDATE: integer-array
*
*
*	DESCRIPTION:
*		- Validates if a value is an integer array.
*
*
*	NOTES:
*		[1]
*
*
*	TODO:
*		[1]
*
*
*	LICENSE:
*		MIT
*
*	Copyright (c) 2015. Athan Reines.
*
*
*	AUTHOR:
*		Athan Reines. kgryte@gmail.com. 2015.
*
*/ "use strict";

var $4ZrEw = parcelRequire("4ZrEw");

var $bxXv8 = parcelRequire("bxXv8");
// IS INTEGER ARRAY //
/**
* FUNCTION: isIntegerArray( value )
*	Validates if a value is an integer array.
*
* @param {*} value - value to be validated
* @returns {Boolean} boolean indicating if a value is an integer array
*/ function $a8ccdcc0a6ea4ef2$var$isIntegerArray(value) {
    var len;
    if (!$4ZrEw(value)) return false;
    len = value.length;
    if (!len) return false;
    for(var i = 0; i < len; i++){
        if (!$bxXv8(value[i])) return false;
    }
    return true;
} // end FUNCTION isIntegerArray()
// EXPORTS //
module.exports = $a8ccdcc0a6ea4ef2$var$isIntegerArray;

});
parcelRegister("bxXv8", function(module, exports) {
/**
*
*	VALIDATE: integer
*
*
*	DESCRIPTION:
*		- Validates if a value is an integer.
*
*
*	NOTES:
*		[1]
*
*
*	TODO:
*		[1]
*
*
*	LICENSE:
*		MIT
*
*	Copyright (c) 2014. Athan Reines.
*
*
*	AUTHOR:
*		Athan Reines. kgryte@gmail.com. 2014.
*
*/ "use strict";

var $5mKdV = parcelRequire("5mKdV");
// ISINTEGER //
/**
* FUNCTION: isInteger( value )
*	Validates if a value is an integer.
*
* @param {Number} value - value to be validated
* @returns {Boolean} boolean indicating whether value is an integer
*/ function $8680ee74f5706565$var$isInteger(value) {
    return $5mKdV(value) && value % 1 === 0;
} // end FUNCTION isInteger()
// EXPORTS //
module.exports = $8680ee74f5706565$var$isInteger;

});
parcelRegister("5mKdV", function(module, exports) {
/**
*
*	VALIDATE: number
*
*
*	DESCRIPTION:
*		- Validates if a value is a number.
*
*
*	NOTES:
*		[1]
*
*
*	TODO:
*		[1]
*
*
*	LICENSE:
*		MIT
*
*	Copyright (c) 2014. Athan Reines.
*
*
*	AUTHOR:
*		Athan Reines. kgryte@gmail.com. 2014.
*
*/ "use strict";
/**
* FUNCTION: isNumber( value )
*	Validates if a value is a number.
*
* @param {*} value - value to be validated
* @returns {Boolean} boolean indicating whether value is a number
*/ function $3e82dcddc0e66aaa$var$isNumber(value) {
    return (typeof value === "number" || Object.prototype.toString.call(value) === "[object Number]") && value.valueOf() === value.valueOf();
} // end FUNCTION isNumber()
// EXPORTS //
module.exports = $3e82dcddc0e66aaa$var$isNumber;

});



parcelRegister("8MBIo", function(module, exports) {
/**
*
*	VALIDATE: function
*
*
*	DESCRIPTION:
*		- Validates if a value is a function.
*
*
*	NOTES:
*		[1]
*
*
*	TODO:
*		[1]
*
*
*	LICENSE:
*		MIT
*
*	Copyright (c) 2014. Athan Reines.
*
*
*	AUTHOR:
*		Athan Reines. kgryte@gmail.com. 2014.
*
*/ "use strict";
/**
* FUNCTION: isFunction( value )
*	Validates if a value is a function.
*
* @param {*} value - value to be validated
* @returns {Boolean} boolean indicating whether value is a function
*/ function $66500fdb1f086b78$var$isFunction(value) {
    return typeof value === "function";
} // end FUNCTION isFunction()
// EXPORTS //
module.exports = $66500fdb1f086b78$var$isFunction;

});



parcelRegister("5l4PJ", function(module, exports) {

var $jpWht = parcelRequire("jpWht");

var $5iyRF = parcelRequire("5iyRF");

var $dnten = parcelRequire("dnten");

var $cHPb0 = parcelRequire("cHPb0");
/**
 * This method is like `_.defaults` except that it recursively assigns
 * default properties.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.defaults
 * @example
 *
 * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
 * // => { 'a': { 'b': 2, 'c': 3 } }
 */ var $3e32a9babf840d70$var$defaultsDeep = $5iyRF(function(args) {
    args.push(undefined, $dnten);
    return $jpWht($cHPb0, undefined, args);
});
module.exports = $3e32a9babf840d70$var$defaultsDeep;

});
parcelRegister("dnten", function(module, exports) {

var $4uZ7x = parcelRequire("4uZ7x");

var $lsJ54 = parcelRequire("lsJ54");
/**
 * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
 * objects into destination objects that are passed thru.
 *
 * @private
 * @param {*} objValue The destination value.
 * @param {*} srcValue The source value.
 * @param {string} key The key of the property to merge.
 * @param {Object} object The parent object of `objValue`.
 * @param {Object} source The parent object of `srcValue`.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 * @returns {*} Returns the value to assign.
 */ function $9bd418fc371ad84f$var$customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
    if ($lsJ54(objValue) && $lsJ54(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        $4uZ7x(objValue, srcValue, undefined, $9bd418fc371ad84f$var$customDefaultsMerge, stack);
        stack["delete"](srcValue);
    }
    return objValue;
}
module.exports = $9bd418fc371ad84f$var$customDefaultsMerge;

});
parcelRegister("4uZ7x", function(module, exports) {

var $g779E = parcelRequire("g779E");

var $7RXmv = parcelRequire("7RXmv");

var $dEvx9 = parcelRequire("dEvx9");

var $cTZHA = parcelRequire("cTZHA");

var $lsJ54 = parcelRequire("lsJ54");

var $f4lqP = parcelRequire("f4lqP");

var $1ys2O = parcelRequire("1ys2O");
/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $34696005ed9b3f30$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    $dEvx9(source, function(srcValue, key) {
        stack || (stack = new $g779E);
        if ($lsJ54(srcValue)) $cTZHA(object, source, key, srcIndex, $34696005ed9b3f30$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer($1ys2O(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            $7RXmv(object, key, newValue);
        }
    }, $f4lqP);
}
module.exports = $34696005ed9b3f30$var$baseMerge;

});
parcelRegister("7RXmv", function(module, exports) {

var $cWbJD = parcelRequire("cWbJD");

var $6TC8i = parcelRequire("6TC8i");
/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $5bab87b519c266a0$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !$6TC8i(object[key], value) || value === undefined && !(key in object)) $cWbJD(object, key, value);
}
module.exports = $5bab87b519c266a0$var$assignMergeValue;

});

parcelRegister("cTZHA", function(module, exports) {

var $7RXmv = parcelRequire("7RXmv");

var $uQ1Em = parcelRequire("uQ1Em");

var $5JAGM = parcelRequire("5JAGM");

var $aA0pv = parcelRequire("aA0pv");

var $dFJsF = parcelRequire("dFJsF");

var $aJD6g = parcelRequire("aJD6g");

var $o8HxT = parcelRequire("o8HxT");

var $jGP9B = parcelRequire("jGP9B");

var $f504n = parcelRequire("f504n");

var $01ubZ = parcelRequire("01ubZ");

var $lsJ54 = parcelRequire("lsJ54");

var $xMy82 = parcelRequire("xMy82");

var $1Q21n = parcelRequire("1Q21n");

var $1ys2O = parcelRequire("1ys2O");

var $kp2OI = parcelRequire("kp2OI");
/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $964a7bd734d0fbad$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = $1ys2O(object, key), srcValue = $1ys2O(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        $7RXmv(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = $o8HxT(srcValue), isBuff = !isArr && $f504n(srcValue), isTyped = !isArr && !isBuff && $1Q21n(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ($o8HxT(objValue)) newValue = objValue;
            else if ($jGP9B(objValue)) newValue = $aA0pv(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = $uQ1Em(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = $5JAGM(srcValue, true);
            } else newValue = [];
        } else if ($xMy82(srcValue) || $aJD6g(srcValue)) {
            newValue = objValue;
            if ($aJD6g(objValue)) newValue = $kp2OI(objValue);
            else if (!$lsJ54(objValue) || $01ubZ(objValue)) newValue = $dFJsF(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    $7RXmv(object, key, newValue);
}
module.exports = $964a7bd734d0fbad$var$baseMergeDeep;

});
parcelRegister("1ys2O", function(module, exports) {
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $121eb86ef7ce6b9c$var$safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
module.exports = $121eb86ef7ce6b9c$var$safeGet;

});

parcelRegister("kp2OI", function(module, exports) {

var $cYlGN = parcelRequire("cYlGN");

var $f4lqP = parcelRequire("f4lqP");
/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $eda853de6b056001$var$toPlainObject(value) {
    return $cYlGN(value, $f4lqP(value));
}
module.exports = $eda853de6b056001$var$toPlainObject;

});




parcelRegister("cHPb0", function(module, exports) {

var $4uZ7x = parcelRequire("4uZ7x");

var $i1jm6 = parcelRequire("i1jm6");
/**
 * This method is like `_.merge` except that it accepts `customizer` which
 * is invoked to produce the merged values of the destination and source
 * properties. If `customizer` returns `undefined`, merging is handled by the
 * method instead. The `customizer` is invoked with six arguments:
 * (objValue, srcValue, key, object, source, stack).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} sources The source objects.
 * @param {Function} customizer The function to customize assigned values.
 * @returns {Object} Returns `object`.
 * @example
 *
 * function customizer(objValue, srcValue) {
 *   if (_.isArray(objValue)) {
 *     return objValue.concat(srcValue);
 *   }
 * }
 *
 * var object = { 'a': [1], 'b': [2] };
 * var other = { 'a': [3], 'b': [4] };
 *
 * _.mergeWith(object, other, customizer);
 * // => { 'a': [1, 3], 'b': [2, 4] }
 */ var $940132c5229936a0$var$mergeWith = $i1jm6(function(object, source, srcIndex, customizer) {
    $4uZ7x(object, source, srcIndex, customizer);
});
module.exports = $940132c5229936a0$var$mergeWith;

});
parcelRegister("i1jm6", function(module, exports) {

var $5iyRF = parcelRequire("5iyRF");

var $b8mN0 = parcelRequire("b8mN0");
/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $d1e75591f556b111$var$createAssigner(assigner) {
    return $5iyRF(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && $b8mN0(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
module.exports = $d1e75591f556b111$var$createAssigner;

});



parcelRegister("7JcvP", function(module, exports) {

var $fgBHx = parcelRequire("fgBHx");
/** Used as references for various `Number` constants. */ var $5a06711408304e05$var$INFINITY = 1 / 0;
/**
 * Recursively flattens `array`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flattenDeep([1, [2, [3, [4]], 5]]);
 * // => [1, 2, 3, 4, 5]
 */ function $5a06711408304e05$var$flattenDeep(array) {
    var length = array == null ? 0 : array.length;
    return length ? $fgBHx(array, $5a06711408304e05$var$INFINITY) : [];
}
module.exports = $5a06711408304e05$var$flattenDeep;

});

parcelRegister("aJAVg", function(module, exports) {

var $i46jW = parcelRequire("i46jW");

var $6Ikd8 = parcelRequire("6Ikd8");

var $5iyRF = parcelRequire("5iyRF");

var $2lqgl = parcelRequire("2lqgl");
/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */ var $7d0abf6a6db17d41$var$intersection = $5iyRF(function(arrays) {
    var mapped = $i46jW(arrays, $2lqgl);
    return mapped.length && mapped[0] === arrays[0] ? $6Ikd8(mapped) : [];
});
module.exports = $7d0abf6a6db17d41$var$intersection;

});

parcelRegister("3MjAw", function(module, exports) {

var $k3xuf = parcelRequire("k3xuf");
/**
 * This method is like `_.pull` except that it accepts an array of values to remove.
 *
 * **Note:** Unlike `_.difference`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pullAll(array, ['a', 'c']);
 * console.log(array);
 * // => ['b', 'b']
 */ function $2c050c929f0424b0$var$pullAll(array, values) {
    return array && array.length && values && values.length ? $k3xuf(array, values) : array;
}
module.exports = $2c050c929f0424b0$var$pullAll;

});
parcelRegister("k3xuf", function(module, exports) {

var $i46jW = parcelRequire("i46jW");

var $7pFTU = parcelRequire("7pFTU");

var $HYijK = parcelRequire("HYijK");

var $91Qdd = parcelRequire("91Qdd");

var $aA0pv = parcelRequire("aA0pv");
/** Used for built-in method references. */ var $e99e103be7621c23$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $e99e103be7621c23$var$splice = $e99e103be7621c23$var$arrayProto.splice;
/**
 * The base implementation of `_.pullAllBy` without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 */ function $e99e103be7621c23$var$basePullAll(array, values, iteratee, comparator) {
    var indexOf = comparator ? $HYijK : $7pFTU, index = -1, length = values.length, seen = array;
    if (array === values) values = $aA0pv(values);
    if (iteratee) seen = $i46jW(array, $91Qdd(iteratee));
    while(++index < length){
        var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
        while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
            if (seen !== array) $e99e103be7621c23$var$splice.call(seen, fromIndex, 1);
            $e99e103be7621c23$var$splice.call(array, fromIndex, 1);
        }
    }
    return array;
}
module.exports = $e99e103be7621c23$var$basePullAll;

});
parcelRegister("HYijK", function(module, exports) {
/**
 * This function is like `baseIndexOf` except that it accepts a comparator.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $0842c97ccd80fb57$var$baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (comparator(array[index], value)) return index;
    }
    return -1;
}
module.exports = $0842c97ccd80fb57$var$baseIndexOfWith;

});



parcelRegister("iWSff", function(module, exports) {

var $bFZGr = parcelRequire("bFZGr");

var $4DjQp = parcelRequire("4DjQp");

var $4c8Zb = parcelRequire("4c8Zb");

var $o8HxT = parcelRequire("o8HxT");
/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $dcb7b8b4ed4ef64b$var$forEach(collection, iteratee) {
    var func = $o8HxT(collection) ? $bFZGr : $4DjQp;
    return func(collection, $4c8Zb(iteratee));
}
module.exports = $dcb7b8b4ed4ef64b$var$forEach;

});
parcelRegister("4c8Zb", function(module, exports) {

var $4Nq5y = parcelRequire("4Nq5y");
/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $30df40d61e63f4ce$var$castFunction(value) {
    return typeof value == "function" ? value : $4Nq5y;
}
module.exports = $30df40d61e63f4ce$var$castFunction;

});


parcelRegister("34IFf", function(module, exports) {

var $ad5bh = parcelRequire("ad5bh");

var $5iyRF = parcelRequire("5iyRF");

var $jGP9B = parcelRequire("jGP9B");
/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */ var $23d4643723f7192c$var$without = $5iyRF(function(array, values) {
    return $jGP9B(array) ? $ad5bh(array, values) : [];
});
module.exports = $23d4643723f7192c$var$without;

});
parcelRegister("ad5bh", function(module, exports) {

var $dXA7v = parcelRequire("dXA7v");

var $ebE2M = parcelRequire("ebE2M");

var $eSdxB = parcelRequire("eSdxB");

var $i46jW = parcelRequire("i46jW");

var $91Qdd = parcelRequire("91Qdd");

var $2l8n7 = parcelRequire("2l8n7");
/** Used as the size to enable large array optimizations. */ var $76ef232132c297fc$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function $76ef232132c297fc$var$baseDifference(array, values, iteratee, comparator) {
    var index = -1, includes = $ebE2M, isCommon = true, length = array.length, result = [], valuesLength = values.length;
    if (!length) return result;
    if (iteratee) values = $i46jW(values, $91Qdd(iteratee));
    if (comparator) {
        includes = $eSdxB;
        isCommon = false;
    } else if (values.length >= $76ef232132c297fc$var$LARGE_ARRAY_SIZE) {
        includes = $2l8n7;
        isCommon = false;
        values = new $dXA7v(values);
    }
    outer: while(++index < length){
        var value = array[index], computed = iteratee == null ? value : iteratee(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values[valuesIndex] === computed) continue outer;
            }
            result.push(value);
        } else if (!includes(values, computed, comparator)) result.push(value);
    }
    return result;
}
module.exports = $76ef232132c297fc$var$baseDifference;

});



parcelRegister("e8CxN", function(module, exports) {
parcelRequire("FjW9i");

module.exports = (parcelRequire("314Mo")).Array.fill;

});
parcelRegister("FjW9i", function(module, exports) {
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var $kEXpx = parcelRequire("kEXpx");

$kEXpx($kEXpx.P, "Array", {
    fill: (parcelRequire("3iwWn"))
});

(parcelRequire("gPMhp"))("fill");

});
parcelRegister("3iwWn", function(module, exports) {
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
"use strict";

var $jK6u7 = parcelRequire("jK6u7");

var $8i8IL = parcelRequire("8i8IL");

var $cqWYf = parcelRequire("cqWYf");
module.exports = function fill(value /* , start = 0, end = @length */ ) {
    var O = $jK6u7(this);
    var length = $cqWYf(O.length);
    var aLen = arguments.length;
    var index = $8i8IL(aLen > 1 ? arguments[1] : undefined, length);
    var end = aLen > 2 ? arguments[2] : undefined;
    var endPos = end === undefined ? length : $8i8IL(end, length);
    while(endPos > index)O[index++] = value;
    return O;
};

});



parcelRegister("1c10x", function(module, exports) {

var $fgBHx = parcelRequire("fgBHx");

var $5iyRF = parcelRequire("5iyRF");

var $5VSS6 = parcelRequire("5VSS6");

var $jGP9B = parcelRequire("jGP9B");
/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */ var $0de7b1862975f367$var$union = $5iyRF(function(arrays) {
    return $5VSS6($fgBHx(arrays, 1, $jGP9B, true));
});
module.exports = $0de7b1862975f367$var$union;

});

parcelRegister("raQQi", function(module, exports) {

$parcel$export(module.exports, "get", () => $051af092c42ed6c4$export$3988ae62b71be9a3, (v) => $051af092c42ed6c4$export$3988ae62b71be9a3 = v);
$parcel$export(module.exports, "set", () => $051af092c42ed6c4$export$adaa4cf7ef1b65be, (v) => $051af092c42ed6c4$export$adaa4cf7ef1b65be = v);
$parcel$export(module.exports, "compile", () => $051af092c42ed6c4$export$ef7acd7185315e22, (v) => $051af092c42ed6c4$export$ef7acd7185315e22 = v);
var $051af092c42ed6c4$export$3988ae62b71be9a3;
var $051af092c42ed6c4$export$adaa4cf7ef1b65be;
var $051af092c42ed6c4$export$ef7acd7185315e22;
var $051af092c42ed6c4$var$hasExcape = /~/;
var $051af092c42ed6c4$var$escapeMatcher = /~[01]/g;
function $051af092c42ed6c4$var$escapeReplacer(m) {
    switch(m){
        case "~1":
            return "/";
        case "~0":
            return "~";
    }
    throw new Error("Invalid tilde escape: " + m);
}
function $051af092c42ed6c4$var$untilde(str) {
    if (!$051af092c42ed6c4$var$hasExcape.test(str)) return str;
    return str.replace($051af092c42ed6c4$var$escapeMatcher, $051af092c42ed6c4$var$escapeReplacer);
}
function $051af092c42ed6c4$var$setter(obj, pointer, value) {
    var part;
    var hasNextPart;
    if (pointer[1] === "constructor" && pointer[2] === "prototype") return obj;
    if (pointer[1] === "__proto__") return obj;
    for(var p = 1, len = pointer.length; p < len;){
        part = $051af092c42ed6c4$var$untilde(pointer[p++]);
        hasNextPart = len > p;
        if (typeof obj[part] === "undefined") {
            // support setting of /-
            if (Array.isArray(obj) && part === "-") part = obj.length;
            // support nested objects/array when setting values
            if (hasNextPart) {
                if (pointer[p] !== "" && pointer[p] < Infinity || pointer[p] === "-") obj[part] = [];
                else obj[part] = {};
            }
        }
        if (!hasNextPart) break;
        obj = obj[part];
    }
    var oldValue = obj[part];
    if (value === undefined) delete obj[part];
    else obj[part] = value;
    return oldValue;
}
function $051af092c42ed6c4$var$compilePointer(pointer) {
    if (typeof pointer === "string") {
        pointer = pointer.split("/");
        if (pointer[0] === "") return pointer;
        throw new Error("Invalid JSON pointer.");
    } else if (Array.isArray(pointer)) return pointer;
    throw new Error("Invalid JSON pointer.");
}
function $051af092c42ed6c4$var$get(obj, pointer) {
    if (typeof obj !== "object") throw new Error("Invalid input object.");
    pointer = $051af092c42ed6c4$var$compilePointer(pointer);
    var len = pointer.length;
    if (len === 1) return obj;
    for(var p = 1; p < len;){
        obj = obj[$051af092c42ed6c4$var$untilde(pointer[p++])];
        if (len === p) return obj;
        if (typeof obj !== "object") return undefined;
    }
}
function $051af092c42ed6c4$var$set(obj, pointer, value) {
    if (typeof obj !== "object") throw new Error("Invalid input object.");
    pointer = $051af092c42ed6c4$var$compilePointer(pointer);
    if (pointer.length === 0) throw new Error("Invalid JSON pointer for set.");
    return $051af092c42ed6c4$var$setter(obj, pointer, value);
}
function $051af092c42ed6c4$var$compile(pointer) {
    var compiled = $051af092c42ed6c4$var$compilePointer(pointer);
    return {
        get: function(object) {
            return $051af092c42ed6c4$var$get(object, compiled);
        },
        set: function(object, value) {
            return $051af092c42ed6c4$var$set(object, compiled, value);
        }
    };
}
$051af092c42ed6c4$export$3988ae62b71be9a3 = $051af092c42ed6c4$var$get;
$051af092c42ed6c4$export$adaa4cf7ef1b65be = $051af092c42ed6c4$var$set;
$051af092c42ed6c4$export$ef7acd7185315e22 = $051af092c42ed6c4$var$compile;

});

parcelRegister("iz2CH", function(module, exports) {

$parcel$export(module.exports, "default", () => $d83d87cc676d68e8$export$2e2bcd8739ae039);

var $iEy3i = parcelRequire("iEy3i");

var $5iUCz = parcelRequire("5iUCz");

var $l5jfN = parcelRequire("l5jfN");

var $9JRba = parcelRequire("9JRba");

var $4FkDh = parcelRequire("4FkDh");

var $9XUqB = parcelRequire("9XUqB");

var $kHm9D = parcelRequire("kHm9D");

var $10O6B = parcelRequire("10O6B");

var $2LOqb = parcelRequire("2LOqb");

var $kFTPr = parcelRequire("kFTPr");

var $c1x0Z = parcelRequire("c1x0Z");
var $d83d87cc676d68e8$export$2e2bcd8739ae039 = {
    AnyOfField: (0, $9JRba.default),
    ArrayField: (0, $iEy3i.default),
    BooleanField: (0, $5iUCz.default),
    DescriptionField: (0, $l5jfN.default),
    NumberField: (0, $4FkDh.default),
    ObjectField: (0, $9XUqB.default),
    OneOfField: (0, $9JRba.default),
    SchemaField: (0, $kHm9D.default),
    StringField: (0, $10O6B.default),
    TitleField: (0, $2LOqb.default),
    NullField: (0, $kFTPr.default),
    UnsupportedField: (0, $c1x0Z.default)
};

});
parcelRegister("iEy3i", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9466073482193ab$export$2e2bcd8739ae039);

var $8lpxl = parcelRequire("8lpxl");

var $gpTap = parcelRequire("gpTap");

var $k4zDq = parcelRequire("k4zDq");

var $aYvV6 = parcelRequire("aYvV6");

var $4juyi = parcelRequire("4juyi");

var $7PwEf = parcelRequire("7PwEf");

var $4tWkZ = parcelRequire("4tWkZ");

var $eBH73 = parcelRequire("eBH73");

var $ctnWZ = parcelRequire("ctnWZ");

var $hl9R1 = parcelRequire("hl9R1");

var $ivxVa = parcelRequire("ivxVa");

var $kB4x2 = parcelRequire("kB4x2");

var $a5du3 = parcelRequire("a5du3");

var $bHfI3 = parcelRequire("bHfI3");

var $6Kb1d = parcelRequire("6Kb1d");

var $acw62 = parcelRequire("acw62");

var $3IXh5 = parcelRequire("3IXh5");
parcelRequire("9N0A7");

var $ip6TK = parcelRequire("ip6TK");

var $86Jyb = parcelRequire("86Jyb");
function $d9466073482193ab$var$ArrayFieldTitle(_ref) {
    var TitleField = _ref.TitleField, idSchema = _ref.idSchema, title = _ref.title, required = _ref.required;
    if (!title) return null;
    var id = "".concat(idSchema.$id, "__title");
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TitleField, {
        id: id,
        title: title,
        required: required
    });
}
function $d9466073482193ab$var$ArrayFieldDescription(_ref2) {
    var DescriptionField = _ref2.DescriptionField, idSchema = _ref2.idSchema, description = _ref2.description;
    if (!description) return null;
    var id = "".concat(idSchema.$id, "__description");
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(DescriptionField, {
        id: id,
        description: description
    });
} // Used in the two templates
function $d9466073482193ab$var$DefaultArrayItem(props) {
    var btnStyle = {
        flex: 1,
        paddingLeft: 6,
        paddingRight: 6,
        fontWeight: "bold"
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        key: props.key,
        className: props.className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: props.hasToolbar ? "col-xs-9" : "col-xs-12"
    }, props.children), props.hasToolbar && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "col-xs-3 array-item-toolbox"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "btn-group",
        style: {
            display: "flex",
            justifyContent: "space-around"
        }
    }, (props.hasMoveUp || props.hasMoveDown) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6Kb1d.default), {
        icon: "arrow-up",
        "aria-label": "Move up",
        className: "array-item-move-up",
        tabIndex: "-1",
        style: btnStyle,
        disabled: props.disabled || props.readonly || !props.hasMoveUp,
        onClick: props.onReorderClick(props.index, props.index - 1)
    }), (props.hasMoveUp || props.hasMoveDown) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6Kb1d.default), {
        icon: "arrow-down",
        className: "array-item-move-down",
        "aria-label": "Move down",
        tabIndex: "-1",
        style: btnStyle,
        disabled: props.disabled || props.readonly || !props.hasMoveDown,
        onClick: props.onReorderClick(props.index, props.index + 1)
    }), props.hasRemove && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6Kb1d.default), {
        type: "danger",
        icon: "remove",
        "aria-label": "Remove",
        className: "array-item-remove",
        tabIndex: "-1",
        style: btnStyle,
        disabled: props.disabled || props.readonly,
        onClick: props.onDropIndexClick(props.index)
    }))));
}
function $d9466073482193ab$var$DefaultFixedArrayFieldTemplate(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("fieldset", {
        className: props.className,
        id: props.idSchema.$id
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9466073482193ab$var$ArrayFieldTitle, {
        key: "array-field-title-".concat(props.idSchema.$id),
        TitleField: props.TitleField,
        idSchema: props.idSchema,
        title: props.uiSchema["ui:title"] || props.title,
        required: props.required
    }), (props.uiSchema["ui:description"] || props.schema.description) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "field-description",
        key: "field-description-".concat(props.idSchema.$id)
    }, props.uiSchema["ui:description"] || props.schema.description), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "row array-item-list",
        key: "array-item-list-".concat(props.idSchema.$id)
    }, props.items && props.items.map($d9466073482193ab$var$DefaultArrayItem)), props.canAdd && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bHfI3.default), {
        className: "array-item-add",
        onClick: props.onAddClick,
        disabled: props.disabled || props.readonly
    }));
}
function $d9466073482193ab$var$DefaultNormalArrayFieldTemplate(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("fieldset", {
        className: props.className,
        id: props.idSchema.$id
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9466073482193ab$var$ArrayFieldTitle, {
        key: "array-field-title-".concat(props.idSchema.$id),
        TitleField: props.TitleField,
        idSchema: props.idSchema,
        title: props.uiSchema["ui:title"] || props.title,
        required: props.required
    }), (props.uiSchema["ui:description"] || props.schema.description) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d9466073482193ab$var$ArrayFieldDescription, {
        key: "array-field-description-".concat(props.idSchema.$id),
        DescriptionField: props.DescriptionField,
        idSchema: props.idSchema,
        description: props.uiSchema["ui:description"] || props.schema.description
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "row array-item-list",
        key: "array-item-list-".concat(props.idSchema.$id)
    }, props.items && props.items.map(function(p) {
        return $d9466073482193ab$var$DefaultArrayItem(p);
    })), props.canAdd && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bHfI3.default), {
        className: "array-item-add",
        onClick: props.onAddClick,
        disabled: props.disabled || props.readonly
    }));
}
function $d9466073482193ab$var$generateRowId() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($86Jyb))).generate();
}
function $d9466073482193ab$var$generateKeyedFormData(formData) {
    return !(0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(formData) ? [] : formData.map(function(item) {
        return {
            key: $d9466073482193ab$var$generateRowId(),
            item: item
        };
    });
}
function $d9466073482193ab$var$keyedToPlainFormData(keyedFormData) {
    return keyedFormData.map(function(keyedItem) {
        return keyedItem.item;
    });
}
var $d9466073482193ab$var$ArrayField = /*#__PURE__*/ function(_Component) {
    (0, $ivxVa.default)(ArrayField, _Component);
    function ArrayField(props) {
        var _this;
        (0, $7PwEf.default)(this, ArrayField);
        _this = (0, $eBH73.default)(this, (0, $ctnWZ.default)(ArrayField).call(this, props));
        (0, $kB4x2.default)((0, $hl9R1.default)(_this), "_getNewFormDataRow", function() {
            var _this$props = _this.props, schema = _this$props.schema, _this$props$registry = _this$props.registry, registry = _this$props$registry === void 0 ? (0, $ip6TK.getDefaultRegistry)() : _this$props$registry;
            var rootSchema = registry.rootSchema;
            var itemSchema = schema.items;
            if ((0, $ip6TK.isFixedItems)(schema) && (0, $ip6TK.allowAdditionalItems)(schema)) itemSchema = schema.additionalItems;
            return (0, $ip6TK.getDefaultFormState)(itemSchema, undefined, rootSchema);
        });
        (0, $kB4x2.default)((0, $hl9R1.default)(_this), "onAddClick", function(event) {
            if (event) event.preventDefault();
            var onChange = _this.props.onChange;
            var newKeyedFormDataRow = {
                key: $d9466073482193ab$var$generateRowId(),
                item: _this._getNewFormDataRow()
            };
            var newKeyedFormData = [].concat((0, $4juyi.default)(_this.state.keyedFormData), [
                newKeyedFormDataRow
            ]);
            _this.setState({
                keyedFormData: newKeyedFormData,
                updatedKeyedFormData: true
            }, function() {
                return onChange($d9466073482193ab$var$keyedToPlainFormData(newKeyedFormData));
            });
        });
        (0, $kB4x2.default)((0, $hl9R1.default)(_this), "onAddIndexClick", function(index) {
            return function(event) {
                if (event) event.preventDefault();
                var onChange = _this.props.onChange;
                var newKeyedFormDataRow = {
                    key: $d9466073482193ab$var$generateRowId(),
                    item: _this._getNewFormDataRow()
                };
                var newKeyedFormData = (0, $4juyi.default)(_this.state.keyedFormData);
                newKeyedFormData.splice(index, 0, newKeyedFormDataRow);
                _this.setState({
                    keyedFormData: newKeyedFormData,
                    updatedKeyedFormData: true
                }, function() {
                    return onChange($d9466073482193ab$var$keyedToPlainFormData(newKeyedFormData));
                });
            };
        });
        (0, $kB4x2.default)((0, $hl9R1.default)(_this), "onDropIndexClick", function(index) {
            return function(event) {
                if (event) event.preventDefault();
                var onChange = _this.props.onChange;
                var keyedFormData = _this.state.keyedFormData; // refs #195: revalidate to ensure properly reindexing errors
                var newErrorSchema;
                if (_this.props.errorSchema) {
                    newErrorSchema = {};
                    var errorSchema = _this.props.errorSchema;
                    for(var i in errorSchema){
                        i = (0, (/*@__PURE__*/$parcel$interopDefault($aYvV6)))(i);
                        if (i < index) newErrorSchema[i] = errorSchema[i];
                        else if (i > index) newErrorSchema[i - 1] = errorSchema[i];
                    }
                }
                var newKeyedFormData = keyedFormData.filter(function(_, i) {
                    return i !== index;
                });
                _this.setState({
                    keyedFormData: newKeyedFormData,
                    updatedKeyedFormData: true
                }, function() {
                    return onChange($d9466073482193ab$var$keyedToPlainFormData(newKeyedFormData), newErrorSchema);
                });
            };
        });
        (0, $kB4x2.default)((0, $hl9R1.default)(_this), "onReorderClick", function(index, newIndex) {
            return function(event) {
                if (event) {
                    event.preventDefault();
                    event.target.blur();
                }
                var onChange = _this.props.onChange;
                var newErrorSchema;
                if (_this.props.errorSchema) {
                    newErrorSchema = {};
                    var errorSchema = _this.props.errorSchema;
                    for(var i in errorSchema){
                        if (i == index) newErrorSchema[newIndex] = errorSchema[index];
                        else if (i == newIndex) newErrorSchema[index] = errorSchema[newIndex];
                        else newErrorSchema[i] = errorSchema[i];
                    }
                }
                var keyedFormData = _this.state.keyedFormData;
                function reOrderArray() {
                    // Copy item
                    var _newKeyedFormData = keyedFormData.slice(); // Moves item from index to newIndex
                    _newKeyedFormData.splice(index, 1);
                    _newKeyedFormData.splice(newIndex, 0, keyedFormData[index]);
                    return _newKeyedFormData;
                }
                var newKeyedFormData = reOrderArray();
                _this.setState({
                    keyedFormData: newKeyedFormData
                }, function() {
                    return onChange($d9466073482193ab$var$keyedToPlainFormData(newKeyedFormData), newErrorSchema);
                });
            };
        });
        (0, $kB4x2.default)((0, $hl9R1.default)(_this), "onChangeForIndex", function(index) {
            return function(value, errorSchema) {
                var _this$props2 = _this.props, formData = _this$props2.formData, onChange = _this$props2.onChange;
                var newFormData = formData.map(function(item, i) {
                    // We need to treat undefined items as nulls to have validation.
                    // See https://github.com/tdegrunt/jsonschema/issues/206
                    var jsonValue = typeof value === "undefined" ? null : value;
                    return index === i ? jsonValue : item;
                });
                onChange(newFormData, errorSchema && _this.props.errorSchema && (0, $k4zDq.default)({}, _this.props.errorSchema, (0, $kB4x2.default)({}, index, errorSchema)));
            };
        });
        (0, $kB4x2.default)((0, $hl9R1.default)(_this), "onSelectChange", function(value) {
            _this.props.onChange(value);
        });
        var _formData = props.formData;
        var _keyedFormData = $d9466073482193ab$var$generateKeyedFormData(_formData);
        _this.state = {
            keyedFormData: _keyedFormData,
            updatedKeyedFormData: false
        };
        return _this;
    }
    (0, $4tWkZ.default)(ArrayField, [
        {
            key: "isItemRequired",
            value: function isItemRequired(itemSchema) {
                if ((0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(itemSchema.type)) // While we don't yet support composite/nullable jsonschema types, it's
                // future-proof to check for requirement against these.
                return !(0, (/*@__PURE__*/$parcel$interopDefault($3IXh5)))(itemSchema.type, "null");
                 // All non-null array item types are inherently required by design
                return itemSchema.type !== "null";
            }
        },
        {
            key: "canAddItem",
            value: function canAddItem(formItems) {
                var _this$props3 = this.props, schema = _this$props3.schema, uiSchema = _this$props3.uiSchema;
                var _getUiOptions = (0, $ip6TK.getUiOptions)(uiSchema), addable = _getUiOptions.addable;
                if (addable !== false) {
                    // if ui:options.addable was not explicitly set to false, we can add
                    // another item if we have not exceeded maxItems yet
                    if (schema.maxItems !== undefined) addable = formItems.length < schema.maxItems;
                    else addable = true;
                }
                return addable;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, schema = _this$props4.schema, uiSchema = _this$props4.uiSchema, idSchema = _this$props4.idSchema, _this$props4$registry = _this$props4.registry, registry = _this$props4$registry === void 0 ? (0, $ip6TK.getDefaultRegistry)() : _this$props4$registry;
                var rootSchema = registry.rootSchema;
                if (!schema.hasOwnProperty("items")) {
                    var fields = registry.fields;
                    var UnsupportedField = fields.UnsupportedField;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(UnsupportedField, {
                        schema: schema,
                        idSchema: idSchema,
                        reason: "Missing items definition"
                    });
                }
                if ((0, $ip6TK.isFixedItems)(schema)) return this.renderFixedArray();
                if ((0, $ip6TK.isFilesArray)(schema, uiSchema, rootSchema)) return this.renderFiles();
                if ((0, $ip6TK.isMultiSelect)(schema, rootSchema)) return this.renderMultiSelect();
                return this.renderNormalArray();
            }
        },
        {
            key: "renderNormalArray",
            value: function renderNormalArray() {
                var _this2 = this;
                var _this$props5 = this.props, schema = _this$props5.schema, uiSchema = _this$props5.uiSchema, errorSchema = _this$props5.errorSchema, idSchema = _this$props5.idSchema, name = _this$props5.name, required = _this$props5.required, disabled = _this$props5.disabled, readonly = _this$props5.readonly, autofocus = _this$props5.autofocus, _this$props5$registry = _this$props5.registry, registry = _this$props5$registry === void 0 ? (0, $ip6TK.getDefaultRegistry)() : _this$props5$registry, onBlur = _this$props5.onBlur, onFocus = _this$props5.onFocus, idPrefix = _this$props5.idPrefix, rawErrors = _this$props5.rawErrors;
                var title = schema.title === undefined ? name : schema.title;
                var ArrayFieldTemplate = registry.ArrayFieldTemplate, rootSchema = registry.rootSchema, fields = registry.fields, formContext = registry.formContext;
                var TitleField = fields.TitleField, DescriptionField = fields.DescriptionField;
                var itemsSchema = (0, $ip6TK.retrieveSchema)(schema.items, rootSchema);
                var formData = $d9466073482193ab$var$keyedToPlainFormData(this.state.keyedFormData);
                var arrayProps = {
                    canAdd: this.canAddItem(formData),
                    items: this.state.keyedFormData.map(function(keyedItem, index) {
                        var key = keyedItem.key, item = keyedItem.item;
                        var itemSchema = (0, $ip6TK.retrieveSchema)(schema.items, rootSchema, item);
                        var itemErrorSchema = errorSchema ? errorSchema[index] : undefined;
                        var itemIdPrefix = idSchema.$id + "_" + index;
                        var itemIdSchema = (0, $ip6TK.toIdSchema)(itemSchema, itemIdPrefix, rootSchema, item, idPrefix);
                        return _this2.renderArrayFieldItem({
                            key: key,
                            index: index,
                            canMoveUp: index > 0,
                            canMoveDown: index < formData.length - 1,
                            itemSchema: itemSchema,
                            itemIdSchema: itemIdSchema,
                            itemErrorSchema: itemErrorSchema,
                            itemData: item,
                            itemUiSchema: uiSchema.items,
                            autofocus: autofocus && index === 0,
                            onBlur: onBlur,
                            onFocus: onFocus
                        });
                    }),
                    className: "field field-array field-array-of-".concat(itemsSchema.type),
                    DescriptionField: DescriptionField,
                    disabled: disabled,
                    idSchema: idSchema,
                    uiSchema: uiSchema,
                    onAddClick: this.onAddClick,
                    readonly: readonly,
                    required: required,
                    schema: schema,
                    title: title,
                    TitleField: TitleField,
                    formContext: formContext,
                    formData: formData,
                    rawErrors: rawErrors,
                    registry: registry
                }; // Check if a custom render function was passed in
                var Component = uiSchema["ui:ArrayFieldTemplate"] || ArrayFieldTemplate || $d9466073482193ab$var$DefaultNormalArrayFieldTemplate;
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, arrayProps);
            }
        },
        {
            key: "renderMultiSelect",
            value: function renderMultiSelect() {
                var _this$props6 = this.props, schema = _this$props6.schema, idSchema = _this$props6.idSchema, uiSchema = _this$props6.uiSchema, formData = _this$props6.formData, disabled = _this$props6.disabled, readonly = _this$props6.readonly, required = _this$props6.required, label = _this$props6.label, placeholder = _this$props6.placeholder, autofocus = _this$props6.autofocus, onBlur = _this$props6.onBlur, onFocus = _this$props6.onFocus, _this$props6$registry = _this$props6.registry, registry = _this$props6$registry === void 0 ? (0, $ip6TK.getDefaultRegistry)() : _this$props6$registry, rawErrors = _this$props6.rawErrors;
                var items = this.props.formData;
                var widgets = registry.widgets, rootSchema = registry.rootSchema, formContext = registry.formContext;
                var itemsSchema = (0, $ip6TK.retrieveSchema)(schema.items, rootSchema, formData);
                var enumOptions = (0, $ip6TK.optionsList)(itemsSchema);
                var _getUiOptions$enumOpt = (0, $k4zDq.default)({}, (0, $ip6TK.getUiOptions)(uiSchema), {
                    enumOptions: enumOptions
                }), _getUiOptions$enumOpt2 = _getUiOptions$enumOpt.widget, widget = _getUiOptions$enumOpt2 === void 0 ? "select" : _getUiOptions$enumOpt2, options = (0, $gpTap.default)(_getUiOptions$enumOpt, [
                    "widget"
                ]);
                var Widget = (0, $ip6TK.getWidget)(schema, widget, widgets);
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Widget, {
                    id: idSchema && idSchema.$id,
                    multiple: true,
                    onChange: this.onSelectChange,
                    onBlur: onBlur,
                    onFocus: onFocus,
                    options: options,
                    schema: schema,
                    registry: registry,
                    value: items,
                    disabled: disabled,
                    readonly: readonly,
                    required: required,
                    label: label,
                    placeholder: placeholder,
                    formContext: formContext,
                    autofocus: autofocus,
                    rawErrors: rawErrors
                });
            }
        },
        {
            key: "renderFiles",
            value: function renderFiles() {
                var _this$props7 = this.props, schema = _this$props7.schema, uiSchema = _this$props7.uiSchema, idSchema = _this$props7.idSchema, name = _this$props7.name, disabled = _this$props7.disabled, readonly = _this$props7.readonly, autofocus = _this$props7.autofocus, onBlur = _this$props7.onBlur, onFocus = _this$props7.onFocus, _this$props7$registry = _this$props7.registry, registry = _this$props7$registry === void 0 ? (0, $ip6TK.getDefaultRegistry)() : _this$props7$registry, rawErrors = _this$props7.rawErrors;
                var title = schema.title || name;
                var items = this.props.formData;
                var widgets = registry.widgets, formContext = registry.formContext;
                var _getUiOptions2 = (0, $ip6TK.getUiOptions)(uiSchema), _getUiOptions2$widget = _getUiOptions2.widget, widget = _getUiOptions2$widget === void 0 ? "files" : _getUiOptions2$widget, options = (0, $gpTap.default)(_getUiOptions2, [
                    "widget"
                ]);
                var Widget = (0, $ip6TK.getWidget)(schema, widget, widgets);
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Widget, {
                    options: options,
                    id: idSchema && idSchema.$id,
                    multiple: true,
                    onChange: this.onSelectChange,
                    onBlur: onBlur,
                    onFocus: onFocus,
                    schema: schema,
                    title: title,
                    value: items,
                    disabled: disabled,
                    readonly: readonly,
                    formContext: formContext,
                    autofocus: autofocus,
                    rawErrors: rawErrors
                });
            }
        },
        {
            key: "renderFixedArray",
            value: function renderFixedArray() {
                var _this3 = this;
                var _this$props8 = this.props, schema = _this$props8.schema, uiSchema = _this$props8.uiSchema, formData = _this$props8.formData, errorSchema = _this$props8.errorSchema, idPrefix = _this$props8.idPrefix, idSchema = _this$props8.idSchema, name = _this$props8.name, required = _this$props8.required, disabled = _this$props8.disabled, readonly = _this$props8.readonly, autofocus = _this$props8.autofocus, _this$props8$registry = _this$props8.registry, registry = _this$props8$registry === void 0 ? (0, $ip6TK.getDefaultRegistry)() : _this$props8$registry, onBlur = _this$props8.onBlur, onFocus = _this$props8.onFocus, rawErrors = _this$props8.rawErrors;
                var title = schema.title || name;
                var items = this.props.formData;
                var ArrayFieldTemplate = registry.ArrayFieldTemplate, rootSchema = registry.rootSchema, fields = registry.fields, formContext = registry.formContext;
                var TitleField = fields.TitleField;
                var itemSchemas = schema.items.map(function(item, index) {
                    return (0, $ip6TK.retrieveSchema)(item, rootSchema, formData[index]);
                });
                var additionalSchema = (0, $ip6TK.allowAdditionalItems)(schema) ? (0, $ip6TK.retrieveSchema)(schema.additionalItems, rootSchema, formData) : null;
                if (!items || items.length < itemSchemas.length) {
                    // to make sure at least all fixed items are generated
                    items = items || [];
                    items = items.concat(new Array(itemSchemas.length - items.length));
                } // These are the props passed into the render function
                var arrayProps = {
                    canAdd: this.canAddItem(items) && additionalSchema,
                    className: "field field-array field-array-fixed-items",
                    disabled: disabled,
                    idSchema: idSchema,
                    formData: formData,
                    items: this.state.keyedFormData.map(function(keyedItem, index) {
                        var key = keyedItem.key, item = keyedItem.item;
                        var additional = index >= itemSchemas.length;
                        var itemSchema = additional ? (0, $ip6TK.retrieveSchema)(schema.additionalItems, rootSchema, item) : itemSchemas[index];
                        var itemIdPrefix = idSchema.$id + "_" + index;
                        var itemIdSchema = (0, $ip6TK.toIdSchema)(itemSchema, itemIdPrefix, rootSchema, item, idPrefix);
                        var itemUiSchema = additional ? uiSchema.additionalItems || {} : (0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(uiSchema.items) ? uiSchema.items[index] : uiSchema.items || {};
                        var itemErrorSchema = errorSchema ? errorSchema[index] : undefined;
                        return _this3.renderArrayFieldItem({
                            key: key,
                            index: index,
                            canRemove: additional,
                            canMoveUp: index >= itemSchemas.length + 1,
                            canMoveDown: additional && index < items.length - 1,
                            itemSchema: itemSchema,
                            itemData: item,
                            itemUiSchema: itemUiSchema,
                            itemIdSchema: itemIdSchema,
                            itemErrorSchema: itemErrorSchema,
                            autofocus: autofocus && index === 0,
                            onBlur: onBlur,
                            onFocus: onFocus
                        });
                    }),
                    onAddClick: this.onAddClick,
                    readonly: readonly,
                    required: required,
                    schema: schema,
                    uiSchema: uiSchema,
                    title: title,
                    TitleField: TitleField,
                    formContext: formContext,
                    rawErrors: rawErrors
                }; // Check if a custom template template was passed in
                var Template = uiSchema["ui:ArrayFieldTemplate"] || ArrayFieldTemplate || $d9466073482193ab$var$DefaultFixedArrayFieldTemplate;
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Template, arrayProps);
            }
        },
        {
            key: "renderArrayFieldItem",
            value: function renderArrayFieldItem(props) {
                var key = props.key, index = props.index, _props$canRemove = props.canRemove, canRemove = _props$canRemove === void 0 ? true : _props$canRemove, _props$canMoveUp = props.canMoveUp, canMoveUp = _props$canMoveUp === void 0 ? true : _props$canMoveUp, _props$canMoveDown = props.canMoveDown, canMoveDown = _props$canMoveDown === void 0 ? true : _props$canMoveDown, itemSchema = props.itemSchema, itemData = props.itemData, itemUiSchema = props.itemUiSchema, itemIdSchema = props.itemIdSchema, itemErrorSchema = props.itemErrorSchema, autofocus = props.autofocus, onBlur = props.onBlur, onFocus = props.onFocus, rawErrors = props.rawErrors;
                var _this$props9 = this.props, disabled = _this$props9.disabled, readonly = _this$props9.readonly, uiSchema = _this$props9.uiSchema, _this$props9$registry = _this$props9.registry, registry = _this$props9$registry === void 0 ? (0, $ip6TK.getDefaultRegistry)() : _this$props9$registry;
                var SchemaField = registry.fields.SchemaField;
                var _orderable$removable$ = (0, $k4zDq.default)({
                    orderable: true,
                    removable: true
                }, uiSchema["ui:options"]), orderable = _orderable$removable$.orderable, removable = _orderable$removable$.removable;
                var has = {
                    moveUp: orderable && canMoveUp,
                    moveDown: orderable && canMoveDown,
                    remove: removable && canRemove
                };
                has.toolbar = (0, (/*@__PURE__*/$parcel$interopDefault($8lpxl)))(has).some(function(key) {
                    return has[key];
                });
                return {
                    children: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(SchemaField, {
                        index: index,
                        schema: itemSchema,
                        uiSchema: itemUiSchema,
                        formData: itemData,
                        errorSchema: itemErrorSchema,
                        idSchema: itemIdSchema,
                        required: this.isItemRequired(itemSchema),
                        onChange: this.onChangeForIndex(index),
                        onBlur: onBlur,
                        onFocus: onFocus,
                        registry: this.props.registry,
                        disabled: this.props.disabled,
                        readonly: this.props.readonly,
                        autofocus: autofocus,
                        rawErrors: rawErrors
                    }),
                    className: "array-item",
                    disabled: disabled,
                    hasToolbar: has.toolbar,
                    hasMoveUp: has.moveUp,
                    hasMoveDown: has.moveDown,
                    hasRemove: has.remove,
                    index: index,
                    key: key,
                    onAddIndexClick: this.onAddIndexClick,
                    onDropIndexClick: this.onDropIndexClick,
                    onReorderClick: this.onReorderClick,
                    readonly: readonly
                };
            }
        },
        {
            key: "itemTitle",
            get: function get() {
                var schema = this.props.schema;
                return schema.items.title || schema.items.description || "Item";
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                // Don't call getDerivedStateFromProps if keyed formdata was just updated.
                if (prevState.updatedKeyedFormData) return {
                    updatedKeyedFormData: false
                };
                var nextFormData = nextProps.formData || [];
                var previousKeyedFormData = prevState.keyedFormData || [];
                var newKeyedFormData = nextFormData.length === previousKeyedFormData.length ? previousKeyedFormData.map(function(previousKeyedFormDatum, index) {
                    return {
                        key: previousKeyedFormDatum.key,
                        item: nextFormData[index]
                    };
                }) : $d9466073482193ab$var$generateKeyedFormData(nextFormData);
                return {
                    keyedFormData: newKeyedFormData
                };
            }
        }
    ]);
    return ArrayField;
}((0, $acw62.Component));
(0, $kB4x2.default)($d9466073482193ab$var$ArrayField, "defaultProps", {
    uiSchema: {},
    formData: [],
    idSchema: {},
    required: false,
    disabled: false,
    readonly: false,
    autofocus: false
});
var $d9466073482193ab$export$2e2bcd8739ae039 = $d9466073482193ab$var$ArrayField;

});
parcelRegister("aYvV6", function(module, exports) {

module.exports = (parcelRequire("e4Er3"));

});
parcelRegister("e4Er3", function(module, exports) {
parcelRequire("hkGbQ");

module.exports = (parcelRequire("314Mo")).parseInt;

});
parcelRegister("hkGbQ", function(module, exports) {

var $kEXpx = parcelRequire("kEXpx");

var $7kjJ1 = parcelRequire("7kjJ1");
// 18.2.5 parseInt(string, radix)
$kEXpx($kEXpx.G + $kEXpx.F * (parseInt != $7kjJ1), {
    parseInt: $7kjJ1
});

});
parcelRegister("7kjJ1", function(module, exports) {

var $llv21 = parcelRequire("llv21");
var $5559b3ade45a8d63$require$$parseInt = $llv21.parseInt;

var $89DWS = parcelRequire("89DWS");
var $5559b3ade45a8d63$require$$trim = $89DWS.trim;

var $5ofVR = parcelRequire("5ofVR");
var $5559b3ade45a8d63$var$hex = /^[-+]?0[xX]/;
module.exports = $5559b3ade45a8d63$require$$parseInt($5ofVR + "08") !== 8 || $5559b3ade45a8d63$require$$parseInt($5ofVR + "0x16") !== 22 ? function parseInt(str, radix) {
    var string = $5559b3ade45a8d63$require$$trim(String(str), 3);
    return $5559b3ade45a8d63$require$$parseInt(string, radix >>> 0 || ($5559b3ade45a8d63$var$hex.test(string) ? 16 : 10));
} : $5559b3ade45a8d63$require$$parseInt;

});
parcelRegister("89DWS", function(module, exports) {

var $kEXpx = parcelRequire("kEXpx");

var $gXRFA = parcelRequire("gXRFA");

var $g49ub = parcelRequire("g49ub");

var $5ofVR = parcelRequire("5ofVR");
var $5efe26f538b19508$var$space = "[" + $5ofVR + "]";
var $5efe26f538b19508$var$non = "\u200B\x85";
var $5efe26f538b19508$var$ltrim = RegExp("^" + $5efe26f538b19508$var$space + $5efe26f538b19508$var$space + "*");
var $5efe26f538b19508$var$rtrim = RegExp($5efe26f538b19508$var$space + $5efe26f538b19508$var$space + "*$");
var $5efe26f538b19508$var$exporter = function(KEY, exec, ALIAS) {
    var exp = {};
    var FORCE = $g49ub(function() {
        return !!$5ofVR[KEY]() || $5efe26f538b19508$var$non[KEY]() != $5efe26f538b19508$var$non;
    });
    var fn = exp[KEY] = FORCE ? exec($5efe26f538b19508$var$trim) : $5ofVR[KEY];
    if (ALIAS) exp[ALIAS] = fn;
    $kEXpx($kEXpx.P + $kEXpx.F * FORCE, "String", exp);
};
// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var $5efe26f538b19508$var$trim = $5efe26f538b19508$var$exporter.trim = function(string, TYPE) {
    string = String($gXRFA(string));
    if (TYPE & 1) string = string.replace($5efe26f538b19508$var$ltrim, "");
    if (TYPE & 2) string = string.replace($5efe26f538b19508$var$rtrim, "");
    return string;
};
module.exports = $5efe26f538b19508$var$exporter;

});
parcelRegister("5ofVR", function(module, exports) {
module.exports = "	\n\v\f\r \xa0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";

});






parcelRegister("bHfI3", function(module, exports) {

$parcel$export(module.exports, "default", () => $883fe56da8db319c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $6Kb1d = parcelRequire("6Kb1d");
function $883fe56da8db319c$export$2e2bcd8739ae039(_ref) {
    var className = _ref.className, onClick = _ref.onClick, disabled = _ref.disabled;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "row"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        className: "col-xs-3 col-xs-offset-9 text-right ".concat(className)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6Kb1d.default), {
        type: "info",
        icon: "plus",
        className: "btn-add col-xs-12",
        "aria-label": "Add",
        tabIndex: "0",
        onClick: onClick,
        disabled: disabled
    })));
}

});
parcelRegister("6Kb1d", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e8f96049db29ff5$export$2e2bcd8739ae039);

var $cG9FK = parcelRequire("cG9FK");

var $gpTap = parcelRequire("gpTap");

var $acw62 = parcelRequire("acw62");
function $4e8f96049db29ff5$export$2e2bcd8739ae039(props) {
    var _props$type = props.type, type = _props$type === void 0 ? "default" : _props$type, icon = props.icon, className = props.className, otherProps = (0, $gpTap.default)(props, [
        "type",
        "icon",
        "className"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", (0, $cG9FK.default)({
        type: "button",
        className: "btn btn-".concat(type, " ").concat(className)
    }, otherProps), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("i", {
        className: "glyphicon glyphicon-".concat(icon)
    }));
}

});


parcelRegister("3IXh5", function(module, exports) {
parcelRequire("huGHh");

module.exports = (parcelRequire("314Mo")).Array.includes;

});
parcelRegister("huGHh", function(module, exports) {
"use strict";

var $kEXpx = parcelRequire("kEXpx");

var $cbc65bbc4e9bac0d$var$$includes = (parcelRequire("fBEhL"))(true);
$kEXpx($kEXpx.P, "Array", {
    includes: function includes(el /* , fromIndex = 0 */ ) {
        return $cbc65bbc4e9bac0d$var$$includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
    }
});

(parcelRequire("gPMhp"))("includes");

});


parcelRegister("9N0A7", function(module, exports) {

var $c9Z8w = parcelRequire("c9Z8w");
var $7209242b04ae4eda$export$4bb7493d241fd8a5 = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
    ArrayFieldTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    FieldTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    ObjectFieldTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    definitions: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object.isRequired,
    rootSchema: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    fields: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType).isRequired,
    formContext: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object.isRequired,
    widgets: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ])).isRequired
});
var $7209242b04ae4eda$export$cdefc4c738b53a5e = {
    autofocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    errorSchema: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    formData: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    idSchema: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    rawErrors: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string),
    readonly: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    registry: $7209242b04ae4eda$export$4bb7493d241fd8a5.isRequired,
    required: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    schema: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object.isRequired,
    uiSchema: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        "ui:options": (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            addable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
            orderable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
            removable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        })
    })
};

});

parcelRegister("86Jyb", function(module, exports) {
"use strict";

module.exports = (parcelRequire("k4mSs"));

});
parcelRegister("k4mSs", function(module, exports) {
"use strict";

var $c1WOw = parcelRequire("c1WOw");

var $lyUht = parcelRequire("lyUht");

var $a3ZNN = parcelRequire("a3ZNN");

// if you are using cluster or multiple servers use this to make each instance
// has a unique value for worker
// Note: I don't know if this is automatically set when using third
// party cluster solutions such as pm2.
var $e9c5ed5b799343e5$var$clusterWorkerId = (parcelRequire("fdgZy")) || 0;
/**
 * Set the seed.
 * Highly recommended if you don't want people to try to figure out your id schema.
 * exposed as shortid.seed(int)
 * @param seed Integer value to seed the random alphabet.  ALWAYS USE THE SAME SEED or you might get overlaps.
 */ function $e9c5ed5b799343e5$var$seed(seedValue) {
    $c1WOw.seed(seedValue);
    return module.exports;
}
/**
 * Set the cluster worker or machine id
 * exposed as shortid.worker(int)
 * @param workerId worker must be positive integer.  Number less than 16 is recommended.
 * returns shortid module so it can be chained.
 */ function $e9c5ed5b799343e5$var$worker(workerId) {
    $e9c5ed5b799343e5$var$clusterWorkerId = workerId;
    return module.exports;
}
/**
 *
 * sets new characters to use in the alphabet
 * returns the shuffled alphabet
 */ function $e9c5ed5b799343e5$var$characters(newCharacters) {
    if (newCharacters !== undefined) $c1WOw.characters(newCharacters);
    return $c1WOw.shuffled();
}
/**
 * Generate unique id
 * Returns string id
 */ function $e9c5ed5b799343e5$var$generate() {
    return $lyUht($e9c5ed5b799343e5$var$clusterWorkerId);
}
// Export all other functions as properties of the generate function
module.exports = $e9c5ed5b799343e5$var$generate;
module.exports.generate = $e9c5ed5b799343e5$var$generate;
module.exports.seed = $e9c5ed5b799343e5$var$seed;
module.exports.worker = $e9c5ed5b799343e5$var$worker;
module.exports.characters = $e9c5ed5b799343e5$var$characters;
module.exports.isValid = $a3ZNN;

});
parcelRegister("c1WOw", function(module, exports) {
"use strict";

var $9QMEO = parcelRequire("9QMEO");
var $8c23333828cc3125$var$ORIGINAL = "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_-";
var $8c23333828cc3125$var$alphabet;
var $8c23333828cc3125$var$previousSeed;
var $8c23333828cc3125$var$shuffled;
function $8c23333828cc3125$var$reset() {
    $8c23333828cc3125$var$shuffled = false;
}
function $8c23333828cc3125$var$setCharacters(_alphabet_) {
    if (!_alphabet_) {
        if ($8c23333828cc3125$var$alphabet !== $8c23333828cc3125$var$ORIGINAL) {
            $8c23333828cc3125$var$alphabet = $8c23333828cc3125$var$ORIGINAL;
            $8c23333828cc3125$var$reset();
        }
        return;
    }
    if (_alphabet_ === $8c23333828cc3125$var$alphabet) return;
    if (_alphabet_.length !== $8c23333828cc3125$var$ORIGINAL.length) throw new Error("Custom alphabet for shortid must be " + $8c23333828cc3125$var$ORIGINAL.length + " unique characters. You submitted " + _alphabet_.length + " characters: " + _alphabet_);
    var unique = _alphabet_.split("").filter(function(item, ind, arr) {
        return ind !== arr.lastIndexOf(item);
    });
    if (unique.length) throw new Error("Custom alphabet for shortid must be " + $8c23333828cc3125$var$ORIGINAL.length + " unique characters. These characters were not unique: " + unique.join(", "));
    $8c23333828cc3125$var$alphabet = _alphabet_;
    $8c23333828cc3125$var$reset();
}
function $8c23333828cc3125$var$characters(_alphabet_) {
    $8c23333828cc3125$var$setCharacters(_alphabet_);
    return $8c23333828cc3125$var$alphabet;
}
function $8c23333828cc3125$var$setSeed(seed) {
    $9QMEO.seed(seed);
    if ($8c23333828cc3125$var$previousSeed !== seed) {
        $8c23333828cc3125$var$reset();
        $8c23333828cc3125$var$previousSeed = seed;
    }
}
function $8c23333828cc3125$var$shuffle() {
    if (!$8c23333828cc3125$var$alphabet) $8c23333828cc3125$var$setCharacters($8c23333828cc3125$var$ORIGINAL);
    var sourceArray = $8c23333828cc3125$var$alphabet.split("");
    var targetArray = [];
    var r = $9QMEO.nextValue();
    var characterIndex;
    while(sourceArray.length > 0){
        r = $9QMEO.nextValue();
        characterIndex = Math.floor(r * sourceArray.length);
        targetArray.push(sourceArray.splice(characterIndex, 1)[0]);
    }
    return targetArray.join("");
}
function $8c23333828cc3125$var$getShuffled() {
    if ($8c23333828cc3125$var$shuffled) return $8c23333828cc3125$var$shuffled;
    $8c23333828cc3125$var$shuffled = $8c23333828cc3125$var$shuffle();
    return $8c23333828cc3125$var$shuffled;
}
/**
 * lookup shuffled letter
 * @param index
 * @returns {string}
 */ function $8c23333828cc3125$var$lookup(index) {
    var alphabetShuffled = $8c23333828cc3125$var$getShuffled();
    return alphabetShuffled[index];
}
function $8c23333828cc3125$var$get() {
    return $8c23333828cc3125$var$alphabet || $8c23333828cc3125$var$ORIGINAL;
}
module.exports = {
    get: $8c23333828cc3125$var$get,
    characters: $8c23333828cc3125$var$characters,
    seed: $8c23333828cc3125$var$setSeed,
    lookup: $8c23333828cc3125$var$lookup,
    shuffled: $8c23333828cc3125$var$getShuffled
};

});
parcelRegister("9QMEO", function(module, exports) {
"use strict";
// Found this seed-based random generator somewhere
// Based on The Central Randomizer 1.3 (C) 1997 by Paul Houle (houle@msc.cornell.edu)
var $72beb6ba744b7542$var$seed = 1;
/**
 * return a random number based on a seed
 * @param seed
 * @returns {number}
 */ function $72beb6ba744b7542$var$getNextValue() {
    $72beb6ba744b7542$var$seed = ($72beb6ba744b7542$var$seed * 9301 + 49297) % 233280;
    return $72beb6ba744b7542$var$seed / 233280.0;
}
function $72beb6ba744b7542$var$setSeed(_seed_) {
    $72beb6ba744b7542$var$seed = _seed_;
}
module.exports = {
    nextValue: $72beb6ba744b7542$var$getNextValue,
    seed: $72beb6ba744b7542$var$setSeed
};

});


parcelRegister("lyUht", function(module, exports) {
"use strict";

var $ajyTY = parcelRequire("ajyTY");
parcelRequire("c1WOw");
// Ignore all milliseconds before a certain time to reduce the size of the date entropy without sacrificing uniqueness.
// This number should be updated every year or so to keep the generated id short.
// To regenerate `new Date() - 0` and bump the version. Always bump the version!
var $fb286e221af32807$var$REDUCE_TIME = 1567752802062;
// don't change unless we change the algos or REDUCE_TIME
// must be an integer and less than 16
var $fb286e221af32807$var$version = 7;
// Counter is used when shortid is called multiple times in one second.
var $fb286e221af32807$var$counter;
// Remember the last time shortid was called in case counter is needed.
var $fb286e221af32807$var$previousSeconds;
/**
 * Generate unique id
 * Returns string id
 */ function $fb286e221af32807$var$build(clusterWorkerId) {
    var str = "";
    var seconds = Math.floor((Date.now() - $fb286e221af32807$var$REDUCE_TIME) * 0.001);
    if (seconds === $fb286e221af32807$var$previousSeconds) $fb286e221af32807$var$counter++;
    else {
        $fb286e221af32807$var$counter = 0;
        $fb286e221af32807$var$previousSeconds = seconds;
    }
    str = str + $ajyTY($fb286e221af32807$var$version);
    str = str + $ajyTY(clusterWorkerId);
    if ($fb286e221af32807$var$counter > 0) str = str + $ajyTY($fb286e221af32807$var$counter);
    str = str + $ajyTY(seconds);
    return str;
}
module.exports = $fb286e221af32807$var$build;

});
parcelRegister("ajyTY", function(module, exports) {
"use strict";

var $c1WOw = parcelRequire("c1WOw");

var $hjtYC = parcelRequire("hjtYC");

var $2VQKY = parcelRequire("2VQKY");
function $7826c07ea7f5db37$var$generate(number) {
    var loopCounter = 0;
    var done;
    var str = "";
    while(!done){
        str = str + $2VQKY($hjtYC, $c1WOw.get(), 1);
        done = number < Math.pow(16, loopCounter + 1);
        loopCounter++;
    }
    return str;
}
module.exports = $7826c07ea7f5db37$var$generate;

});
parcelRegister("hjtYC", function(module, exports) {
"use strict";
var $c9ab76c51769857c$var$crypto = typeof window === "object" && (window.crypto || window.msCrypto); // IE 11 uses window.msCrypto
var $c9ab76c51769857c$var$randomByte;
if (!$c9ab76c51769857c$var$crypto || !$c9ab76c51769857c$var$crypto.getRandomValues) $c9ab76c51769857c$var$randomByte = function(size) {
    var bytes = [];
    for(var i = 0; i < size; i++)bytes.push(Math.floor(Math.random() * 256));
    return bytes;
};
else $c9ab76c51769857c$var$randomByte = function(size) {
    return $c9ab76c51769857c$var$crypto.getRandomValues(new Uint8Array(size));
};
module.exports = $c9ab76c51769857c$var$randomByte;

});

parcelRegister("2VQKY", function(module, exports) {
// This file replaces `format.js` in bundlers like webpack or Rollup,
// according to `browser` config in `package.json`.
module.exports = function(random, alphabet, size) {
    // We can’t use bytes bigger than the alphabet. To make bytes values closer
    // to the alphabet, we apply bitmask on them. We look for the closest
    // `2 ** x - 1` number, which will be bigger than alphabet size. If we have
    // 30 symbols in the alphabet, we will take 31 (00011111).
    // We do not use faster Math.clz32, because it is not available in browsers.
    var mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
    // Bitmask is not a perfect solution (in our example it will pass 31 bytes,
    // which is bigger than the alphabet). As a result, we will need more bytes,
    // than ID size, because we will refuse bytes bigger than the alphabet.
    // Every hardware random generator call is costly,
    // because we need to wait for entropy collection. This is why often it will
    // be faster to ask for few extra bytes in advance, to avoid additional calls.
    // Here we calculate how many random bytes should we call in advance.
    // It depends on ID length, mask / alphabet size and magic number 1.6
    // (which was selected according benchmarks).
    // -~f => Math.ceil(f) if n is float number
    // -~i => i + 1 if n is integer number
    var step = -~(1.6 * mask * size / alphabet.length);
    var id = "";
    while(true){
        var bytes = random(step);
        // Compact alternative for `for (var i = 0; i < step; i++)`
        var i = step;
        while(i--){
            // If random byte is bigger than alphabet even after bitmask,
            // we refuse it by `|| ''`.
            id += alphabet[bytes[i] & mask] || "";
            // More compact than `id.length + 1 === size`
            if (id.length === +size) return id;
        }
    }
};

});



parcelRegister("a3ZNN", function(module, exports) {
"use strict";

var $c1WOw = parcelRequire("c1WOw");
function $753a1fd6a37c913c$var$isShortId(id) {
    if (!id || typeof id !== "string" || id.length < 6) return false;
    var nonAlphabetic = new RegExp("[^" + $c1WOw.get().replace(/[|\\{}()[\]^$+*?.-]/g, "\\$&") + "]");
    return !nonAlphabetic.test(id);
}
module.exports = $753a1fd6a37c913c$var$isShortId;

});

parcelRegister("fdgZy", function(module, exports) {
"use strict";
module.exports = 0;

});




parcelRegister("5iUCz", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dca8df6fd35e0f6$export$2e2bcd8739ae039);

var $k4zDq = parcelRequire("k4zDq");

var $a5du3 = parcelRequire("a5du3");

var $gpTap = parcelRequire("gpTap");

var $acw62 = parcelRequire("acw62");
parcelRequire("9N0A7");

var $ip6TK = parcelRequire("ip6TK");
function $3dca8df6fd35e0f6$var$BooleanField(props) {
    var schema = props.schema, name = props.name, uiSchema = props.uiSchema, idSchema = props.idSchema, formData = props.formData, _props$registry = props.registry, registry = _props$registry === void 0 ? (0, $ip6TK.getDefaultRegistry)() : _props$registry, required = props.required, disabled = props.disabled, readonly = props.readonly, autofocus = props.autofocus, onChange = props.onChange, onFocus = props.onFocus, onBlur = props.onBlur, rawErrors = props.rawErrors;
    var title = schema.title;
    var widgets = registry.widgets, formContext = registry.formContext, fields = registry.fields;
    var _getUiOptions = (0, $ip6TK.getUiOptions)(uiSchema), _getUiOptions$widget = _getUiOptions.widget, widget = _getUiOptions$widget === void 0 ? "checkbox" : _getUiOptions$widget, options = (0, $gpTap.default)(_getUiOptions, [
        "widget"
    ]);
    var Widget = (0, $ip6TK.getWidget)(schema, widget, widgets);
    var enumOptions;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(schema.oneOf)) enumOptions = (0, $ip6TK.optionsList)({
        oneOf: schema.oneOf.map(function(option) {
            return (0, $k4zDq.default)({}, option, {
                title: option.title || (option["const"] === true ? "Yes" : "No")
            });
        })
    });
    else enumOptions = (0, $ip6TK.optionsList)({
        "enum": schema["enum"] || [
            true,
            false
        ],
        enumNames: schema.enumNames || (schema["enum"] && schema["enum"][0] === false ? [
            "No",
            "Yes"
        ] : [
            "Yes",
            "No"
        ])
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Widget, {
        options: (0, $k4zDq.default)({}, options, {
            enumOptions: enumOptions
        }),
        schema: schema,
        id: idSchema && idSchema.$id,
        onChange: onChange,
        onFocus: onFocus,
        onBlur: onBlur,
        label: title === undefined ? name : title,
        value: formData,
        required: required,
        disabled: disabled,
        readonly: readonly,
        registry: registry,
        formContext: formContext,
        autofocus: autofocus,
        rawErrors: rawErrors,
        DescriptionField: fields.DescriptionField
    });
}
$3dca8df6fd35e0f6$var$BooleanField.defaultProps = {
    uiSchema: {},
    disabled: false,
    readonly: false,
    autofocus: false
};
var $3dca8df6fd35e0f6$export$2e2bcd8739ae039 = $3dca8df6fd35e0f6$var$BooleanField;

});

parcelRegister("l5jfN", function(module, exports) {

$parcel$export(module.exports, "default", () => $f59900035771b178$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

function $f59900035771b178$var$DescriptionField(props) {
    var id = props.id, description = props.description;
    if (!description) return null;
    if (typeof description === "string") return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        id: id,
        className: "field-description"
    }, description);
    else return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: id,
        className: "field-description"
    }, description);
}
var $f59900035771b178$export$2e2bcd8739ae039 = $f59900035771b178$var$DescriptionField;

});

parcelRegister("9JRba", function(module, exports) {

$parcel$export(module.exports, "default", () => $7171914fdafd6651$export$2e2bcd8739ae039);

var $gpTap = parcelRequire("gpTap");

var $bTUgL = parcelRequire("bTUgL");

var $cG9FK = parcelRequire("cG9FK");

var $aYvV6 = parcelRequire("aYvV6");

var $7PwEf = parcelRequire("7PwEf");

var $4tWkZ = parcelRequire("4tWkZ");

var $eBH73 = parcelRequire("eBH73");

var $ctnWZ = parcelRequire("ctnWZ");

var $hl9R1 = parcelRequire("hl9R1");

var $ivxVa = parcelRequire("ivxVa");

var $kB4x2 = parcelRequire("kB4x2");

var $acw62 = parcelRequire("acw62");

parcelRequire("9N0A7");

var $ip6TK = parcelRequire("ip6TK");
var $7171914fdafd6651$var$AnyOfField = /*#__PURE__*/ function(_Component) {
    (0, $ivxVa.default)(AnyOfField, _Component);
    function AnyOfField(props) {
        var _this;
        (0, $7PwEf.default)(this, AnyOfField);
        _this = (0, $eBH73.default)(this, (0, $ctnWZ.default)(AnyOfField).call(this, props));
        (0, $kB4x2.default)((0, $hl9R1.default)(_this), "onOptionChange", function(option) {
            var selectedOption = (0, (/*@__PURE__*/$parcel$interopDefault($aYvV6)))(option, 10);
            var _this$props = _this.props, formData = _this$props.formData, onChange = _this$props.onChange, options = _this$props.options, registry = _this$props.registry;
            var rootSchema = registry.rootSchema;
            var newOption = (0, $ip6TK.retrieveSchema)(options[selectedOption], rootSchema, formData); // If the new option is of type object and the current data is an object,
            // discard properties added using the old option.
            var newFormData = undefined;
            if ((0, $ip6TK.guessType)(formData) === "object" && (newOption.type === "object" || newOption.properties)) {
                newFormData = (0, $cG9FK.default)({}, formData);
                var optionsToDiscard = options.slice();
                optionsToDiscard.splice(selectedOption, 1); // Discard any data added using other options
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;
                try {
                    for(var _iterator = (0, (/*@__PURE__*/$parcel$interopDefault($bTUgL)))(optionsToDiscard), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _option = _step.value;
                        if (_option.properties) {
                            for(var key in _option.properties)if (newFormData.hasOwnProperty(key)) delete newFormData[key];
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) _iterator["return"]();
                    } finally{
                        if (_didIteratorError) throw _iteratorError;
                    }
                }
            } // Call getDefaultFormState to make sure defaults are populated on change.
            onChange((0, $ip6TK.getDefaultFormState)(options[selectedOption], newFormData, rootSchema));
            _this.setState({
                selectedOption: (0, (/*@__PURE__*/$parcel$interopDefault($aYvV6)))(option, 10)
            });
        });
        var _this$props2 = _this.props, _formData = _this$props2.formData, _options = _this$props2.options;
        _this.state = {
            selectedOption: _this.getMatchingOption(_formData, _options)
        };
        return _this;
    }
    (0, $4tWkZ.default)(AnyOfField, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                if (!(0, $ip6TK.deepEquals)(this.props.formData, prevProps.formData) && this.props.idSchema.$id === prevProps.idSchema.$id) {
                    var matchingOption = this.getMatchingOption(this.props.formData, this.props.options);
                    if (!prevState || matchingOption === this.state.selectedOption) return;
                    this.setState({
                        selectedOption: matchingOption
                    });
                }
            }
        },
        {
            key: "getMatchingOption",
            value: function getMatchingOption(formData, options) {
                var rootSchema = this.props.registry.rootSchema;
                var option = (0, $ip6TK.getMatchingOption)(formData, options, rootSchema);
                if (option !== 0) return option;
                 // If the form data matches none of the options, use the currently selected
                // option, assuming it's available; otherwise use the first option
                return this && this.state ? this.state.selectedOption : 0;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props3 = this.props, baseType = _this$props3.baseType, disabled = _this$props3.disabled, errorSchema = _this$props3.errorSchema, formData = _this$props3.formData, idPrefix = _this$props3.idPrefix, idSchema = _this$props3.idSchema, onBlur = _this$props3.onBlur, onChange = _this$props3.onChange, onFocus = _this$props3.onFocus, options = _this$props3.options, registry = _this$props3.registry, uiSchema = _this$props3.uiSchema, schema = _this$props3.schema;
                var _SchemaField = registry.fields.SchemaField;
                var widgets = registry.widgets;
                var selectedOption = this.state.selectedOption;
                var _getUiOptions = (0, $ip6TK.getUiOptions)(uiSchema), _getUiOptions$widget = _getUiOptions.widget, widget = _getUiOptions$widget === void 0 ? "select" : _getUiOptions$widget, uiOptions = (0, $gpTap.default)(_getUiOptions, [
                    "widget"
                ]);
                var Widget = (0, $ip6TK.getWidget)({
                    type: "number"
                }, widget, widgets);
                var option = options[selectedOption] || null;
                var optionSchema;
                if (option) // If the subschema doesn't declare a type, infer the type from the
                // parent schema
                optionSchema = option.type ? option : (0, $cG9FK.default)({}, option, {
                    type: baseType
                });
                var enumOptions = options.map(function(option, index) {
                    return {
                        label: option.title || "Option ".concat(index + 1),
                        value: index
                    };
                });
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: "panel panel-default panel-body"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: "form-group"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Widget, (0, $cG9FK.default)({
                    id: "".concat(idSchema.$id).concat(schema.oneOf ? "__oneof_select" : "__anyof_select"),
                    schema: {
                        type: "number",
                        "default": 0
                    },
                    onChange: this.onOptionChange,
                    onBlur: onBlur,
                    onFocus: onFocus,
                    value: selectedOption,
                    options: {
                        enumOptions: enumOptions
                    }
                }, uiOptions))), option !== null && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(_SchemaField, {
                    schema: optionSchema,
                    uiSchema: uiSchema,
                    errorSchema: errorSchema,
                    idSchema: idSchema,
                    idPrefix: idPrefix,
                    formData: formData,
                    onChange: onChange,
                    onBlur: onBlur,
                    onFocus: onFocus,
                    registry: registry,
                    disabled: disabled
                }));
            }
        }
    ]);
    return AnyOfField;
}((0, $acw62.Component));
$7171914fdafd6651$var$AnyOfField.defaultProps = {
    disabled: false,
    errorSchema: {},
    idSchema: {},
    uiSchema: {}
};
var $7171914fdafd6651$export$2e2bcd8739ae039 = $7171914fdafd6651$var$AnyOfField;

});
parcelRegister("bTUgL", function(module, exports) {

module.exports = (parcelRequire("5hCpy"));

});
parcelRegister("5hCpy", function(module, exports) {
parcelRequire("hfW11");
parcelRequire("kPnXr");

module.exports = (parcelRequire("6CRfg"));

});
parcelRegister("6CRfg", function(module, exports) {

var $52hVC = parcelRequire("52hVC");

var $frxUU = parcelRequire("frxUU");

module.exports = (parcelRequire("314Mo")).getIterator = function(it) {
    var iterFn = $frxUU(it);
    if (typeof iterFn != "function") throw TypeError(it + " is not iterable!");
    return $52hVC(iterFn.call(it));
};

});




parcelRegister("4FkDh", function(module, exports) {

$parcel$export(module.exports, "default", () => $365afeee072af614$export$2e2bcd8739ae039);

var $cG9FK = parcelRequire("cG9FK");

var $gpTap = parcelRequire("gpTap");

var $7PwEf = parcelRequire("7PwEf");

var $4tWkZ = parcelRequire("4tWkZ");

var $eBH73 = parcelRequire("eBH73");

var $ctnWZ = parcelRequire("ctnWZ");

var $hl9R1 = parcelRequire("hl9R1");

var $ivxVa = parcelRequire("ivxVa");

var $kB4x2 = parcelRequire("kB4x2");

var $acw62 = parcelRequire("acw62");
parcelRequire("9N0A7");

var $ip6TK = parcelRequire("ip6TK");
// digits followed by any number of 0 characters up until the end of the line.
// Ensuring that there is at least one prefixed character is important so that
// you don't incorrectly match against "0".
var $365afeee072af614$var$trailingCharMatcherWithPrefix = /\.([0-9]*0)*$/; // This is used for trimming the trailing 0 and . characters without affecting
// the rest of the string. Its possible to use one RegEx with groups for this
// functionality, but it is fairly complex compared to simply defining two
// different matchers.
var $365afeee072af614$var$trailingCharMatcher = /[0.]0*$/;
/**
 * The NumberField class has some special handling for dealing with trailing
 * decimal points and/or zeroes. This logic is designed to allow trailing values
 * to be visible in the input element, but not be represented in the
 * corresponding form data.
 *
 * The algorithm is as follows:
 *
 * 1. When the input value changes the value is cached in the component state
 *
 * 2. The value is then normalized, removing trailing decimal points and zeros,
 *    then passed to the "onChange" callback
 *
 * 3. When the component is rendered, the formData value is checked against the
 *    value cached in the state. If it matches the cached value, the cached
 *    value is passed to the input instead of the formData value
 */ var $365afeee072af614$var$NumberField = /*#__PURE__*/ function(_React$Component) {
    (0, $ivxVa.default)(NumberField, _React$Component);
    function NumberField(props) {
        var _this;
        (0, $7PwEf.default)(this, NumberField);
        _this = (0, $eBH73.default)(this, (0, $ctnWZ.default)(NumberField).call(this, props));
        (0, $kB4x2.default)((0, $hl9R1.default)(_this), "handleChange", function(value) {
            // Cache the original value in component state
            _this.setState({
                lastValue: value
            }); // Normalize decimals that don't start with a zero character in advance so
            // that the rest of the normalization logic is simpler
            if ("".concat(value).charAt(0) === ".") value = "0".concat(value);
             // Check that the value is a string (this can happen if the widget used is a
            // <select>, due to an enum declaration etc) then, if the value ends in a
            // trailing decimal point or multiple zeroes, strip the trailing values
            var processed = typeof value === "string" && value.match($365afeee072af614$var$trailingCharMatcherWithPrefix) ? (0, $ip6TK.asNumber)(value.replace($365afeee072af614$var$trailingCharMatcher, "")) : (0, $ip6TK.asNumber)(value);
            _this.props.onChange(processed);
        });
        _this.state = {
            lastValue: props.value
        };
        return _this;
    }
    (0, $4tWkZ.default)(NumberField, [
        {
            key: "render",
            value: function render() {
                var StringField = this.props.registry.fields.StringField;
                var _this$props = this.props, formData = _this$props.formData, props = (0, $gpTap.default)(_this$props, [
                    "formData"
                ]);
                var lastValue = this.state.lastValue;
                var value = formData;
                if (typeof lastValue === "string" && typeof value === "number") {
                    // Construct a regular expression that checks for a string that consists
                    // of the formData value suffixed with zero or one '.' characters and zero
                    // or more '0' characters
                    var re = new RegExp("".concat(value).replace(".", "\\.") + "\\.?0*$"); // If the cached "lastValue" is a match, use that instead of the formData
                    // value to prevent the input value from changing in the UI
                    if (lastValue.match(re)) value = lastValue;
                }
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(StringField, (0, $cG9FK.default)({}, props, {
                    formData: value,
                    onChange: this.handleChange
                }));
            }
        }
    ]);
    return NumberField;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$365afeee072af614$var$NumberField.defaultProps = {
    uiSchema: {}
};
var $365afeee072af614$export$2e2bcd8739ae039 = $365afeee072af614$var$NumberField;

});

parcelRegister("9XUqB", function(module, exports) {

$parcel$export(module.exports, "default", () => $74156532dbe7ae7e$export$2e2bcd8739ae039);

var $8gMgl = parcelRequire("8gMgl");

var $a5du3 = parcelRequire("a5du3");

var $4juyi = parcelRequire("4juyi");

var $cG9FK = parcelRequire("cG9FK");

var $8lpxl = parcelRequire("8lpxl");

var $k4zDq = parcelRequire("k4zDq");

var $7PwEf = parcelRequire("7PwEf");

var $4tWkZ = parcelRequire("4tWkZ");

var $eBH73 = parcelRequire("eBH73");

var $ctnWZ = parcelRequire("ctnWZ");

var $hl9R1 = parcelRequire("hl9R1");

var $ivxVa = parcelRequire("ivxVa");

var $kB4x2 = parcelRequire("kB4x2");

var $bHfI3 = parcelRequire("bHfI3");

var $acw62 = parcelRequire("acw62");
parcelRequire("9N0A7");

var $ip6TK = parcelRequire("ip6TK");
function $74156532dbe7ae7e$var$DefaultObjectFieldTemplate(props) {
    var TitleField = props.TitleField, DescriptionField = props.DescriptionField;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("fieldset", {
        id: props.idSchema.$id
    }, (props.uiSchema["ui:title"] || props.title) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TitleField, {
        id: "".concat(props.idSchema.$id, "__title"),
        title: props.title || props.uiSchema["ui:title"],
        required: props.required,
        formContext: props.formContext
    }), props.description && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(DescriptionField, {
        id: "".concat(props.idSchema.$id, "__description"),
        description: props.description,
        formContext: props.formContext
    }), props.properties.map(function(prop) {
        return prop.content;
    }), (0, $ip6TK.canExpand)(props.schema, props.uiSchema, props.formData) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bHfI3.default), {
        className: "object-property-expand",
        onClick: props.onAddClick(props.schema),
        disabled: props.disabled || props.readonly
    }));
}
var $74156532dbe7ae7e$var$ObjectField = /*#__PURE__*/ function(_Component) {
    (0, $ivxVa.default)(ObjectField, _Component);
    function ObjectField() {
        var _getPrototypeOf2;
        var _this;
        (0, $7PwEf.default)(this, ObjectField);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, $eBH73.default)(this, (_getPrototypeOf2 = (0, $ctnWZ.default)(ObjectField)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        (0, $kB4x2.default)((0, $hl9R1.default)(_this), "state", {
            wasPropertyKeyModified: false,
            additionalProperties: {}
        });
        (0, $kB4x2.default)((0, $hl9R1.default)(_this), "onPropertyChange", function(name) {
            var addedByAdditionalProperties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            return function(value, errorSchema) {
                if (!value && addedByAdditionalProperties) // Don't set value = undefined for fields added by
                // additionalProperties. Doing so removes them from the
                // formData, which causes them to completely disappear
                // (including the input field for the property name). Unlike
                // fields which are "mandated" by the schema, these fields can
                // be set to undefined by clicking a "delete field" button, so
                // set empty values to the empty string.
                value = "";
                var newFormData = (0, $k4zDq.default)({}, _this.props.formData, (0, $kB4x2.default)({}, name, value));
                _this.props.onChange(newFormData, errorSchema && _this.props.errorSchema && (0, $k4zDq.default)({}, _this.props.errorSchema, (0, $kB4x2.default)({}, name, errorSchema)));
            };
        });
        (0, $kB4x2.default)((0, $hl9R1.default)(_this), "onDropPropertyClick", function(key) {
            return function(event) {
                event.preventDefault();
                var _this$props = _this.props, onChange = _this$props.onChange, formData = _this$props.formData;
                var copiedFormData = (0, $k4zDq.default)({}, formData);
                delete copiedFormData[key];
                onChange(copiedFormData);
            };
        });
        (0, $kB4x2.default)((0, $hl9R1.default)(_this), "getAvailableKey", function(preferredKey, formData) {
            var index = 0;
            var newKey = preferredKey;
            while(formData.hasOwnProperty(newKey))newKey = "".concat(preferredKey, "-").concat(++index);
            return newKey;
        });
        (0, $kB4x2.default)((0, $hl9R1.default)(_this), "onKeyChange", function(oldValue) {
            return function(value, errorSchema) {
                if (oldValue === value) return;
                value = _this.getAvailableKey(value, _this.props.formData);
                var newFormData = (0, $k4zDq.default)({}, _this.props.formData);
                var newKeys = (0, $kB4x2.default)({}, oldValue, value);
                var keyValues = (0, (/*@__PURE__*/$parcel$interopDefault($8lpxl)))(newFormData).map(function(key) {
                    var newKey = newKeys[key] || key;
                    return (0, $kB4x2.default)({}, newKey, newFormData[key]);
                });
                var renamedObj = (0, $cG9FK.default).apply(void 0, [
                    {}
                ].concat((0, $4juyi.default)(keyValues)));
                _this.setState({
                    wasPropertyKeyModified: true
                });
                _this.props.onChange(renamedObj, errorSchema && _this.props.errorSchema && (0, $k4zDq.default)({}, _this.props.errorSchema, (0, $kB4x2.default)({}, value, errorSchema)));
            };
        });
        (0, $kB4x2.default)((0, $hl9R1.default)(_this), "handleAddClick", function(schema) {
            return function() {
                var type = schema.additionalProperties.type;
                var newFormData = (0, $k4zDq.default)({}, _this.props.formData);
                if (schema.additionalProperties.hasOwnProperty("$ref")) {
                    var _this$props$registry = _this.props.registry, registry = _this$props$registry === void 0 ? (0, $ip6TK.getDefaultRegistry)() : _this$props$registry;
                    var refSchema = (0, $ip6TK.retrieveSchema)({
                        $ref: schema.additionalProperties["$ref"]
                    }, registry.rootSchema, _this.props.formData);
                    type = refSchema.type;
                }
                newFormData[_this.getAvailableKey("newKey", newFormData)] = _this.getDefaultValue(type);
                _this.props.onChange(newFormData);
            };
        });
        return _this;
    }
    (0, $4tWkZ.default)(ObjectField, [
        {
            key: "isRequired",
            value: function isRequired(name) {
                var schema = this.props.schema;
                return (0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(schema.required) && schema.required.indexOf(name) !== -1;
            }
        },
        {
            key: "getDefaultValue",
            value: function getDefaultValue(type) {
                switch(type){
                    case "string":
                        return "New Value";
                    case "array":
                        return [];
                    case "boolean":
                        return false;
                    case "null":
                        return null;
                    case "number":
                        return 0;
                    case "object":
                        return {};
                    default:
                        // We don't have a datatype for some reason (perhaps additionalProperties was true)
                        return "New Value";
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props2 = this.props, uiSchema = _this$props2.uiSchema, formData = _this$props2.formData, errorSchema = _this$props2.errorSchema, idSchema = _this$props2.idSchema, name = _this$props2.name, required = _this$props2.required, disabled = _this$props2.disabled, readonly = _this$props2.readonly, idPrefix = _this$props2.idPrefix, onBlur = _this$props2.onBlur, onFocus = _this$props2.onFocus, _this$props2$registry = _this$props2.registry, registry = _this$props2$registry === void 0 ? (0, $ip6TK.getDefaultRegistry)() : _this$props2$registry;
                var rootSchema = registry.rootSchema, fields = registry.fields, formContext = registry.formContext;
                var SchemaField = fields.SchemaField, TitleField = fields.TitleField, DescriptionField = fields.DescriptionField;
                var schema = (0, $ip6TK.retrieveSchema)(this.props.schema, rootSchema, formData);
                var title = schema.title === undefined ? name : schema.title;
                var description = uiSchema["ui:description"] || schema.description;
                var orderedProperties;
                try {
                    var properties = (0, (/*@__PURE__*/$parcel$interopDefault($8lpxl)))(schema.properties || {});
                    orderedProperties = (0, $ip6TK.orderProperties)(properties, uiSchema["ui:order"]);
                } catch (err) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
                        className: "config-error",
                        style: {
                            color: "red"
                        }
                    }, "Invalid ", name || "root", " object field configuration:", (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("em", null, err.message), "."), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("pre", null, (0, (/*@__PURE__*/$parcel$interopDefault($8gMgl)))(schema)));
                }
                var Template = uiSchema["ui:ObjectFieldTemplate"] || registry.ObjectFieldTemplate || $74156532dbe7ae7e$var$DefaultObjectFieldTemplate;
                var templateProps = {
                    title: uiSchema["ui:title"] || title,
                    description: description,
                    TitleField: TitleField,
                    DescriptionField: DescriptionField,
                    properties: orderedProperties.map(function(name) {
                        var addedByAdditionalProperties = schema.properties[name].hasOwnProperty((0, $ip6TK.ADDITIONAL_PROPERTY_FLAG));
                        return {
                            content: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(SchemaField, {
                                key: name,
                                name: name,
                                required: _this2.isRequired(name),
                                schema: schema.properties[name],
                                uiSchema: addedByAdditionalProperties ? uiSchema.additionalProperties : uiSchema[name],
                                errorSchema: errorSchema[name],
                                idSchema: idSchema[name],
                                idPrefix: idPrefix,
                                formData: (formData || {})[name],
                                wasPropertyKeyModified: _this2.state.wasPropertyKeyModified,
                                onKeyChange: _this2.onKeyChange(name),
                                onChange: _this2.onPropertyChange(name, addedByAdditionalProperties),
                                onBlur: onBlur,
                                onFocus: onFocus,
                                registry: registry,
                                disabled: disabled,
                                readonly: readonly,
                                onDropPropertyClick: _this2.onDropPropertyClick
                            }),
                            name: name,
                            readonly: readonly,
                            disabled: disabled,
                            required: required
                        };
                    }),
                    readonly: readonly,
                    disabled: disabled,
                    required: required,
                    idSchema: idSchema,
                    uiSchema: uiSchema,
                    schema: schema,
                    formData: formData,
                    formContext: formContext
                };
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Template, (0, $cG9FK.default)({}, templateProps, {
                    onAddClick: this.handleAddClick
                }));
            }
        }
    ]);
    return ObjectField;
}((0, $acw62.Component));
(0, $kB4x2.default)($74156532dbe7ae7e$var$ObjectField, "defaultProps", {
    uiSchema: {},
    formData: {},
    errorSchema: {},
    idSchema: {},
    required: false,
    disabled: false,
    readonly: false
});
var $74156532dbe7ae7e$export$2e2bcd8739ae039 = $74156532dbe7ae7e$var$ObjectField;

});
parcelRegister("8gMgl", function(module, exports) {

module.exports = (parcelRequire("eWHNU"));

});
parcelRegister("eWHNU", function(module, exports) {

var $314Mo = parcelRequire("314Mo");
var $ae187605f8c5a921$var$$JSON = $314Mo.JSON || ($314Mo.JSON = {
    stringify: JSON.stringify
});
module.exports = function stringify(it) {
    return $ae187605f8c5a921$var$$JSON.stringify.apply($ae187605f8c5a921$var$$JSON, arguments);
};

});



parcelRegister("kHm9D", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1190238658a892e$export$2e2bcd8739ae039);

var $7PwEf = parcelRequire("7PwEf");

var $4tWkZ = parcelRequire("4tWkZ");

var $eBH73 = parcelRequire("eBH73");

var $ctnWZ = parcelRequire("ctnWZ");

var $ivxVa = parcelRequire("ivxVa");

var $cG9FK = parcelRequire("cG9FK");

var $k4zDq = parcelRequire("k4zDq");

var $gpTap = parcelRequire("gpTap");

var $8lpxl = parcelRequire("8lpxl");

var $6Kb1d = parcelRequire("6Kb1d");

var $acw62 = parcelRequire("acw62");

parcelRequire("9N0A7");

var $ip6TK = parcelRequire("ip6TK");
var $f1190238658a892e$var$REQUIRED_FIELD_SYMBOL = "*";
var $f1190238658a892e$var$COMPONENT_TYPES = {
    array: "ArrayField",
    "boolean": "BooleanField",
    integer: "NumberField",
    number: "NumberField",
    object: "ObjectField",
    string: "StringField",
    "null": "NullField"
};
function $f1190238658a892e$var$getFieldComponent(schema, uiSchema, idSchema, fields) {
    var field = uiSchema["ui:field"];
    if (typeof field === "function") return field;
    if (typeof field === "string" && field in fields) return fields[field];
    var componentName = $f1190238658a892e$var$COMPONENT_TYPES[(0, $ip6TK.getSchemaType)(schema)]; // If the type is not defined and the schema uses 'anyOf' or 'oneOf', don't
    // render a field and let the MultiSchemaField component handle the form display
    if (!componentName && (schema.anyOf || schema.oneOf)) return function() {
        return null;
    };
    return componentName in fields ? fields[componentName] : function() {
        var UnsupportedField = fields.UnsupportedField;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(UnsupportedField, {
            schema: schema,
            idSchema: idSchema,
            reason: "Unknown field type ".concat(schema.type)
        });
    };
}
function $f1190238658a892e$var$Label(props) {
    var label = props.label, required = props.required, id = props.id;
    if (!label) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        className: "control-label",
        htmlFor: id
    }, label, required && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "required"
    }, $f1190238658a892e$var$REQUIRED_FIELD_SYMBOL));
}
function $f1190238658a892e$var$LabelInput(props) {
    var id = props.id, label = props.label, onChange = props.onChange;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        className: "form-control",
        type: "text",
        id: id,
        onBlur: function onBlur(event) {
            return onChange(event.target.value);
        },
        defaultValue: label
    });
}
function $f1190238658a892e$var$Help(props) {
    var help = props.help;
    if (!help) return null;
    if (typeof help === "string") return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        className: "help-block"
    }, help);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "help-block"
    }, help);
}
function $f1190238658a892e$var$ErrorList(props) {
    var _props$errors = props.errors, errors = _props$errors === void 0 ? [] : _props$errors;
    if (errors.length === 0) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        className: "error-detail bs-callout bs-callout-info"
    }, errors.filter(function(elem) {
        return !!elem;
    }).map(function(error, index) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            className: "text-danger",
            key: index
        }, error);
    })));
}
function $f1190238658a892e$var$DefaultTemplate(props) {
    var id = props.id, label = props.label, children = props.children, errors = props.errors, help = props.help, description = props.description, hidden = props.hidden, required = props.required, displayLabel = props.displayLabel;
    if (hidden) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "hidden"
    }, children);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f1190238658a892e$var$WrapIfAdditional, props, displayLabel && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f1190238658a892e$var$Label, {
        label: label,
        required: required,
        id: id
    }), displayLabel && description ? description : null, children, errors, help);
}
$f1190238658a892e$var$DefaultTemplate.defaultProps = {
    hidden: false,
    readonly: false,
    required: false,
    displayLabel: true
};
function $f1190238658a892e$var$WrapIfAdditional(props) {
    var id = props.id, classNames = props.classNames, disabled = props.disabled, label = props.label, onKeyChange = props.onKeyChange, onDropPropertyClick = props.onDropPropertyClick, readonly = props.readonly, required = props.required, schema = props.schema;
    var keyLabel = "".concat(label, " Key"); // i18n ?
    var additional = schema.hasOwnProperty((0, $ip6TK.ADDITIONAL_PROPERTY_FLAG));
    if (!additional) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classNames
    }, props.children);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classNames
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "row"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "col-xs-5 form-additional"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "form-group"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f1190238658a892e$var$Label, {
        label: keyLabel,
        required: required,
        id: "".concat(id, "-key")
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f1190238658a892e$var$LabelInput, {
        label: label,
        required: required,
        id: "".concat(id, "-key"),
        onChange: onKeyChange
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "form-additional form-group col-xs-5"
    }, props.children), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "col-xs-2"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6Kb1d.default), {
        type: "danger",
        icon: "remove",
        className: "array-item-remove btn-block",
        tabIndex: "-1",
        style: {
            border: "0"
        },
        disabled: disabled || readonly,
        onClick: onDropPropertyClick(label)
    }))));
}
function $f1190238658a892e$var$SchemaFieldRender(props) {
    var uiSchema = props.uiSchema, formData = props.formData, errorSchema = props.errorSchema, idPrefix = props.idPrefix, name = props.name, onChange = props.onChange, onKeyChange = props.onKeyChange, onDropPropertyClick = props.onDropPropertyClick, required = props.required, _props$registry = props.registry, registry = _props$registry === void 0 ? (0, $ip6TK.getDefaultRegistry)() : _props$registry, _props$wasPropertyKey = props.wasPropertyKeyModified, wasPropertyKeyModified = _props$wasPropertyKey === void 0 ? false : _props$wasPropertyKey;
    var rootSchema = registry.rootSchema, fields = registry.fields, formContext = registry.formContext;
    var FieldTemplate = uiSchema["ui:FieldTemplate"] || registry.FieldTemplate || $f1190238658a892e$var$DefaultTemplate;
    var idSchema = props.idSchema;
    var schema = (0, $ip6TK.retrieveSchema)(props.schema, rootSchema, formData);
    idSchema = (0, $ip6TK.mergeObjects)((0, $ip6TK.toIdSchema)(schema, null, rootSchema, formData, idPrefix), idSchema);
    var FieldComponent = $f1190238658a892e$var$getFieldComponent(schema, uiSchema, idSchema, fields);
    var DescriptionField = fields.DescriptionField;
    var disabled = Boolean(props.disabled || uiSchema["ui:disabled"]);
    var readonly = Boolean(props.readonly || uiSchema["ui:readonly"] || props.schema.readOnly || schema.readOnly);
    var autofocus = Boolean(props.autofocus || uiSchema["ui:autofocus"]);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8lpxl)))(schema).length === 0) return null;
    var displayLabel = (0, $ip6TK.getDisplayLabel)(schema, uiSchema, rootSchema);
    var __errors = errorSchema.__errors, fieldErrorSchema = (0, $gpTap.default)(errorSchema, [
        "__errors"
    ]); // See #439: uiSchema: Don't pass consumed class names to child components
    var field = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(FieldComponent, (0, $cG9FK.default)({}, props, {
        idSchema: idSchema,
        schema: schema,
        uiSchema: (0, $k4zDq.default)({}, uiSchema, {
            classNames: undefined
        }),
        disabled: disabled,
        readonly: readonly,
        autofocus: autofocus,
        errorSchema: fieldErrorSchema,
        formContext: formContext,
        rawErrors: __errors
    }));
    var id = idSchema.$id; // If this schema has a title defined, but the user has set a new key/label, retain their input.
    var label;
    if (wasPropertyKeyModified) label = name;
    else label = uiSchema["ui:title"] || props.schema.title || schema.title || name;
    var description = uiSchema["ui:description"] || props.schema.description || schema.description;
    var errors = __errors;
    var help = uiSchema["ui:help"];
    var hidden = uiSchema["ui:widget"] === "hidden";
    var classNames = [
        "form-group",
        "field",
        "field-".concat(schema.type),
        errors && errors.length > 0 ? "field-error has-error has-danger" : "",
        uiSchema.classNames
    ].join(" ").trim();
    var fieldProps = {
        description: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(DescriptionField, {
            id: id + "__description",
            description: description,
            formContext: formContext
        }),
        rawDescription: description,
        help: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f1190238658a892e$var$Help, {
            help: help
        }),
        rawHelp: typeof help === "string" ? help : undefined,
        errors: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($f1190238658a892e$var$ErrorList, {
            errors: errors
        }),
        rawErrors: errors,
        id: id,
        label: label,
        hidden: hidden,
        onChange: onChange,
        onKeyChange: onKeyChange,
        onDropPropertyClick: onDropPropertyClick,
        required: required,
        disabled: disabled,
        readonly: readonly,
        displayLabel: displayLabel,
        classNames: classNames,
        formContext: formContext,
        formData: formData,
        fields: fields,
        schema: schema,
        uiSchema: uiSchema,
        registry: registry
    };
    var _AnyOfField = registry.fields.AnyOfField;
    var _OneOfField = registry.fields.OneOfField;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(FieldTemplate, fieldProps, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, field, schema.anyOf && !(0, $ip6TK.isSelect)(schema) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(_AnyOfField, {
        disabled: disabled,
        errorSchema: errorSchema,
        formData: formData,
        idPrefix: idPrefix,
        idSchema: idSchema,
        onBlur: props.onBlur,
        onChange: props.onChange,
        onFocus: props.onFocus,
        options: schema.anyOf,
        baseType: schema.type,
        registry: registry,
        schema: schema,
        uiSchema: uiSchema
    }), schema.oneOf && !(0, $ip6TK.isSelect)(schema) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(_OneOfField, {
        disabled: disabled,
        errorSchema: errorSchema,
        formData: formData,
        idPrefix: idPrefix,
        idSchema: idSchema,
        onBlur: props.onBlur,
        onChange: props.onChange,
        onFocus: props.onFocus,
        options: schema.oneOf,
        baseType: schema.type,
        registry: registry,
        schema: schema,
        uiSchema: uiSchema
    })));
}
var $f1190238658a892e$var$SchemaField = /*#__PURE__*/ function(_React$Component) {
    (0, $ivxVa.default)(SchemaField, _React$Component);
    function SchemaField() {
        (0, $7PwEf.default)(this, SchemaField);
        return (0, $eBH73.default)(this, (0, $ctnWZ.default)(SchemaField).apply(this, arguments));
    }
    (0, $4tWkZ.default)(SchemaField, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps, nextState) {
                return !(0, $ip6TK.deepEquals)(this.props, nextProps);
            }
        },
        {
            key: "render",
            value: function render() {
                return $f1190238658a892e$var$SchemaFieldRender(this.props);
            }
        }
    ]);
    return SchemaField;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$f1190238658a892e$var$SchemaField.defaultProps = {
    uiSchema: {},
    errorSchema: {},
    idSchema: {},
    disabled: false,
    readonly: false,
    autofocus: false
};
var $f1190238658a892e$export$2e2bcd8739ae039 = $f1190238658a892e$var$SchemaField;

});

parcelRegister("10O6B", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bcca87571f3f951$export$2e2bcd8739ae039);

var $k4zDq = parcelRequire("k4zDq");

var $gpTap = parcelRequire("gpTap");

var $acw62 = parcelRequire("acw62");
parcelRequire("9N0A7");

var $ip6TK = parcelRequire("ip6TK");
function $0bcca87571f3f951$var$StringField(props) {
    var schema = props.schema, name = props.name, uiSchema = props.uiSchema, idSchema = props.idSchema, formData = props.formData, required = props.required, disabled = props.disabled, readonly = props.readonly, autofocus = props.autofocus, onChange = props.onChange, onBlur = props.onBlur, onFocus = props.onFocus, _props$registry = props.registry, registry = _props$registry === void 0 ? (0, $ip6TK.getDefaultRegistry)() : _props$registry, rawErrors = props.rawErrors;
    var title = schema.title, format = schema.format;
    var widgets = registry.widgets, formContext = registry.formContext;
    var enumOptions = (0, $ip6TK.isSelect)(schema) && (0, $ip6TK.optionsList)(schema);
    var defaultWidget = enumOptions ? "select" : "text";
    if (format && (0, $ip6TK.hasWidget)(schema, format, widgets)) defaultWidget = format;
    var _getUiOptions = (0, $ip6TK.getUiOptions)(uiSchema), _getUiOptions$widget = _getUiOptions.widget, widget = _getUiOptions$widget === void 0 ? defaultWidget : _getUiOptions$widget, _getUiOptions$placeho = _getUiOptions.placeholder, placeholder = _getUiOptions$placeho === void 0 ? "" : _getUiOptions$placeho, options = (0, $gpTap.default)(_getUiOptions, [
        "widget",
        "placeholder"
    ]);
    var Widget = (0, $ip6TK.getWidget)(schema, widget, widgets);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Widget, {
        options: (0, $k4zDq.default)({}, options, {
            enumOptions: enumOptions
        }),
        schema: schema,
        uiSchema: uiSchema,
        id: idSchema && idSchema.$id,
        label: title === undefined ? name : title,
        value: formData,
        onChange: onChange,
        onBlur: onBlur,
        onFocus: onFocus,
        required: required,
        disabled: disabled,
        readonly: readonly,
        formContext: formContext,
        autofocus: autofocus,
        registry: registry,
        placeholder: placeholder,
        rawErrors: rawErrors
    });
}
$0bcca87571f3f951$var$StringField.defaultProps = {
    uiSchema: {},
    disabled: false,
    readonly: false,
    autofocus: false
};
var $0bcca87571f3f951$export$2e2bcd8739ae039 = $0bcca87571f3f951$var$StringField;

});

parcelRegister("2LOqb", function(module, exports) {

$parcel$export(module.exports, "default", () => $204715342611bb74$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $204715342611bb74$var$REQUIRED_FIELD_SYMBOL = "*";
function $204715342611bb74$var$TitleField(props) {
    var id = props.id, title = props.title, required = props.required;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("legend", {
        id: id
    }, title, required && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "required"
    }, $204715342611bb74$var$REQUIRED_FIELD_SYMBOL));
}
var $204715342611bb74$export$2e2bcd8739ae039 = $204715342611bb74$var$TitleField;

});

parcelRegister("kFTPr", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0d2f163320395e5$export$2e2bcd8739ae039);

var $7PwEf = parcelRequire("7PwEf");

var $4tWkZ = parcelRequire("4tWkZ");

var $eBH73 = parcelRequire("eBH73");

var $ctnWZ = parcelRequire("ctnWZ");

var $ivxVa = parcelRequire("ivxVa");

var $acw62 = parcelRequire("acw62");
parcelRequire("9N0A7");
var $f0d2f163320395e5$var$NullField = /*#__PURE__*/ function(_Component) {
    (0, $ivxVa.default)(NullField, _Component);
    function NullField() {
        (0, $7PwEf.default)(this, NullField);
        return (0, $eBH73.default)(this, (0, $ctnWZ.default)(NullField).apply(this, arguments));
    }
    (0, $4tWkZ.default)(NullField, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.formData === undefined) this.props.onChange(null);
            }
        },
        {
            key: "render",
            value: function render() {
                return null;
            }
        }
    ]);
    return NullField;
}((0, $acw62.Component));
var $f0d2f163320395e5$export$2e2bcd8739ae039 = $f0d2f163320395e5$var$NullField;

});

parcelRegister("c1x0Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c0f301fd2c6432f$export$2e2bcd8739ae039);

var $8gMgl = parcelRequire("8gMgl");

var $acw62 = parcelRequire("acw62");

function $8c0f301fd2c6432f$var$UnsupportedField(_ref) {
    var schema = _ref.schema, idSchema = _ref.idSchema, reason = _ref.reason;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "unsupported-field"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "Unsupported field schema", idSchema && idSchema.$id && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, " for", " field ", (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("code", null, idSchema.$id)), reason && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("em", null, ": ", reason), "."), schema && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("pre", null, (0, (/*@__PURE__*/$parcel$interopDefault($8gMgl)))(schema, null, 2)));
}
var $8c0f301fd2c6432f$export$2e2bcd8739ae039 = $8c0f301fd2c6432f$var$UnsupportedField;

});


parcelRegister("aCa1n", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ba539fb4a48ef8a$export$2e2bcd8739ae039);

var $cEbK5 = parcelRequire("cEbK5");

var $6Q7Yi = parcelRequire("6Q7Yi");

var $7jPPv = parcelRequire("7jPPv");

var $d1pEL = parcelRequire("d1pEL");

var $9eHmu = parcelRequire("9eHmu");

var $7hPlQ = parcelRequire("7hPlQ");

var $eKeY7 = parcelRequire("eKeY7");

var $1gVe5 = parcelRequire("1gVe5");

var $zJ57z = parcelRequire("zJ57z");

var $bPjUv = parcelRequire("bPjUv");

var $w7Lqo = parcelRequire("w7Lqo");

var $dWFnk = parcelRequire("dWFnk");

var $88Nn7 = parcelRequire("88Nn7");

var $9Jno1 = parcelRequire("9Jno1");

var $cUreO = parcelRequire("cUreO");

var $OE4fu = parcelRequire("OE4fu");

var $2Nvmy = parcelRequire("2Nvmy");

var $hKaGm = parcelRequire("hKaGm");

var $40HJL = parcelRequire("40HJL");
var $7ba539fb4a48ef8a$export$2e2bcd8739ae039 = {
    BaseInput: (0, $7jPPv.default),
    PasswordWidget: (0, $dWFnk.default),
    RadioWidget: (0, $88Nn7.default),
    UpDownWidget: (0, $40HJL.default),
    RangeWidget: (0, $9Jno1.default),
    SelectWidget: (0, $cUreO.default),
    TextWidget: (0, $2Nvmy.default),
    DateWidget: (0, $eKeY7.default),
    DateTimeWidget: (0, $1gVe5.default),
    AltDateWidget: (0, $cEbK5.default),
    AltDateTimeWidget: (0, $6Q7Yi.default),
    EmailWidget: (0, $zJ57z.default),
    URLWidget: (0, $hKaGm.default),
    TextareaWidget: (0, $OE4fu.default),
    HiddenWidget: (0, $w7Lqo.default),
    ColorWidget: (0, $7hPlQ.default),
    FileWidget: (0, $bPjUv.default),
    CheckboxWidget: (0, $d1pEL.default),
    CheckboxesWidget: (0, $9eHmu.default)
};

});
parcelRegister("cEbK5", function(module, exports) {

$parcel$export(module.exports, "default", () => $935254420a55ba21$export$2e2bcd8739ae039);

var $cG9FK = parcelRequire("cG9FK");

var $7PwEf = parcelRequire("7PwEf");

var $4tWkZ = parcelRequire("4tWkZ");

var $eBH73 = parcelRequire("eBH73");

var $ctnWZ = parcelRequire("ctnWZ");

var $hl9R1 = parcelRequire("hl9R1");

var $ivxVa = parcelRequire("ivxVa");

var $kB4x2 = parcelRequire("kB4x2");

var $8lpxl = parcelRequire("8lpxl");

var $acw62 = parcelRequire("acw62");


var $ip6TK = parcelRequire("ip6TK");
function $935254420a55ba21$var$rangeOptions(start, stop) {
    var options = [];
    for(var i = start; i <= stop; i++)options.push({
        value: i,
        label: (0, $ip6TK.pad)(i, 2)
    });
    return options;
}
function $935254420a55ba21$var$readyForChange(state) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($8lpxl)))(state).every(function(key) {
        return state[key] !== -1;
    });
}
function $935254420a55ba21$var$DateElement(props) {
    var type = props.type, range = props.range, value = props.value, select = props.select, rootId = props.rootId, disabled = props.disabled, readonly = props.readonly, autofocus = props.autofocus, registry = props.registry, onBlur = props.onBlur;
    var id = rootId + "_" + type;
    var SelectWidget = registry.widgets.SelectWidget;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(SelectWidget, {
        schema: {
            type: "integer"
        },
        id: id,
        className: "form-control",
        options: {
            enumOptions: $935254420a55ba21$var$rangeOptions(range[0], range[1])
        },
        placeholder: type,
        value: value,
        disabled: disabled,
        readonly: readonly,
        autofocus: autofocus,
        onChange: function onChange(value) {
            return select(type, value);
        },
        onBlur: onBlur
    });
}
var $935254420a55ba21$var$AltDateWidget = /*#__PURE__*/ function(_Component) {
    (0, $ivxVa.default)(AltDateWidget, _Component);
    function AltDateWidget(props) {
        var _this;
        (0, $7PwEf.default)(this, AltDateWidget);
        _this = (0, $eBH73.default)(this, (0, $ctnWZ.default)(AltDateWidget).call(this, props));
        (0, $kB4x2.default)((0, $hl9R1.default)(_this), "onChange", function(property, value) {
            _this.setState((0, $kB4x2.default)({}, property, typeof value === "undefined" ? -1 : value), function() {
                // Only propagate to parent state if we have a complete date{time}
                if ($935254420a55ba21$var$readyForChange(_this.state)) _this.props.onChange((0, $ip6TK.toDateString)(_this.state, _this.props.time));
            });
        });
        (0, $kB4x2.default)((0, $hl9R1.default)(_this), "setNow", function(event) {
            event.preventDefault();
            var _this$props = _this.props, time = _this$props.time, disabled = _this$props.disabled, readonly = _this$props.readonly, onChange = _this$props.onChange;
            if (disabled || readonly) return;
            var nowDateObj = (0, $ip6TK.parseDateString)(new Date().toJSON(), time);
            _this.setState(nowDateObj, function() {
                return onChange((0, $ip6TK.toDateString)(_this.state, time));
            });
        });
        (0, $kB4x2.default)((0, $hl9R1.default)(_this), "clear", function(event) {
            event.preventDefault();
            var _this$props2 = _this.props, time = _this$props2.time, disabled = _this$props2.disabled, readonly = _this$props2.readonly, onChange = _this$props2.onChange;
            if (disabled || readonly) return;
            _this.setState((0, $ip6TK.parseDateString)("", time), function() {
                return onChange(undefined);
            });
        });
        _this.state = (0, $ip6TK.parseDateString)(props.value, props.time);
        return _this;
    }
    (0, $4tWkZ.default)(AltDateWidget, [
        {
            key: "UNSAFE_componentWillReceiveProps",
            value: function UNSAFE_componentWillReceiveProps(nextProps) {
                this.setState((0, $ip6TK.parseDateString)(nextProps.value, nextProps.time));
            }
        },
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps, nextState) {
                return (0, $ip6TK.shouldRender)(this, nextProps, nextState);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props3 = this.props, id = _this$props3.id, disabled = _this$props3.disabled, readonly = _this$props3.readonly, autofocus = _this$props3.autofocus, registry = _this$props3.registry, onBlur = _this$props3.onBlur, options = _this$props3.options;
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
                    className: "list-inline"
                }, this.dateElementProps.map(function(elemProps, i) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                        key: i
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($935254420a55ba21$var$DateElement, (0, $cG9FK.default)({
                        rootId: id,
                        select: _this2.onChange
                    }, elemProps, {
                        disabled: disabled,
                        readonly: readonly,
                        registry: registry,
                        onBlur: onBlur,
                        autofocus: autofocus && i === 0
                    })));
                }), (options.hideNowButton !== "undefined" ? !options.hideNowButton : true) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
                    href: "#",
                    className: "btn btn-info btn-now",
                    onClick: this.setNow
                }, "Now")), (options.hideClearButton !== "undefined" ? !options.hideClearButton : true) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
                    href: "#",
                    className: "btn btn-warning btn-clear",
                    onClick: this.clear
                }, "Clear")));
            }
        },
        {
            key: "dateElementProps",
            get: function get() {
                var _this$props4 = this.props, time = _this$props4.time, options = _this$props4.options;
                var _this$state = this.state, year = _this$state.year, month = _this$state.month, day = _this$state.day, hour = _this$state.hour, minute = _this$state.minute, second = _this$state.second;
                var data = [
                    {
                        type: "year",
                        range: options.yearsRange,
                        value: year
                    },
                    {
                        type: "month",
                        range: [
                            1,
                            12
                        ],
                        value: month
                    },
                    {
                        type: "day",
                        range: [
                            1,
                            31
                        ],
                        value: day
                    }
                ];
                if (time) data.push({
                    type: "hour",
                    range: [
                        0,
                        23
                    ],
                    value: hour
                }, {
                    type: "minute",
                    range: [
                        0,
                        59
                    ],
                    value: minute
                }, {
                    type: "second",
                    range: [
                        0,
                        59
                    ],
                    value: second
                });
                return data;
            }
        }
    ]);
    return AltDateWidget;
}((0, $acw62.Component));
(0, $kB4x2.default)($935254420a55ba21$var$AltDateWidget, "defaultProps", {
    time: false,
    disabled: false,
    readonly: false,
    autofocus: false,
    options: {
        yearsRange: [
            1900,
            new Date().getFullYear() + 2
        ]
    }
});
var $935254420a55ba21$export$2e2bcd8739ae039 = $935254420a55ba21$var$AltDateWidget;

});

parcelRegister("6Q7Yi", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fadc8622fd98685$export$2e2bcd8739ae039);

var $k4zDq = parcelRequire("k4zDq");

var $cG9FK = parcelRequire("cG9FK");

var $acw62 = parcelRequire("acw62");


var $cEbK5 = parcelRequire("cEbK5");
function $4fadc8622fd98685$var$AltDateTimeWidget(props) {
    var AltDateWidget = props.registry.widgets.AltDateWidget;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(AltDateWidget, (0, $cG9FK.default)({
        time: true
    }, props));
}
$4fadc8622fd98685$var$AltDateTimeWidget.defaultProps = (0, $k4zDq.default)({}, (0, $cEbK5.default).defaultProps, {
    time: true
});
var $4fadc8622fd98685$export$2e2bcd8739ae039 = $4fadc8622fd98685$var$AltDateTimeWidget;

});

parcelRegister("7jPPv", function(module, exports) {

$parcel$export(module.exports, "default", () => $55428310fd883133$export$2e2bcd8739ae039);

var $lyRnQ = parcelRequire("lyRnQ");

var $4juyi = parcelRequire("4juyi");

var $cG9FK = parcelRequire("cG9FK");

var $gpTap = parcelRequire("gpTap");

var $8gMgl = parcelRequire("8gMgl");

var $acw62 = parcelRequire("acw62");

function $55428310fd883133$var$BaseInput(props) {
    // Note: since React 15.2.0 we can't forward unknown element attributes, so we
    // exclude the "options" and "schema" ones here.
    if (!props.id) {
        console.log("No id for", props);
        throw new Error("no id for props ".concat((0, (/*@__PURE__*/$parcel$interopDefault($8gMgl)))(props)));
    }
    var value = props.value, readonly = props.readonly, disabled = props.disabled, autofocus = props.autofocus, onBlur = props.onBlur, onFocus = props.onFocus, options = props.options, schema = props.schema, uiSchema = props.uiSchema, formContext = props.formContext, registry = props.registry, rawErrors = props.rawErrors, inputProps = (0, $gpTap.default)(props, [
        "value",
        "readonly",
        "disabled",
        "autofocus",
        "onBlur",
        "onFocus",
        "options",
        "schema",
        "uiSchema",
        "formContext",
        "registry",
        "rawErrors"
    ]); // If options.inputType is set use that as the input type
    if (options.inputType) inputProps.type = options.inputType;
    else if (!inputProps.type) {
        // If the schema is of type number or integer, set the input type to number
        if (schema.type === "number") {
            inputProps.type = "number"; // Setting step to 'any' fixes a bug in Safari where decimals are not
            // allowed in number inputs
            inputProps.step = "any";
        } else if (schema.type === "integer") {
            inputProps.type = "number"; // Since this is integer, you always want to step up or down in multiples
            // of 1
            inputProps.step = "1";
        } else inputProps.type = "text";
    }
    if (options.autocomplete) inputProps.autoComplete = options.autocomplete;
     // If multipleOf is defined, use this as the step value. This mainly improves
    // the experience for keyboard users (who can use the up/down KB arrows).
    if (schema.multipleOf) inputProps.step = schema.multipleOf;
    if (typeof schema.minimum !== "undefined") inputProps.min = schema.minimum;
    if (typeof schema.maximum !== "undefined") inputProps.max = schema.maximum;
    var _onChange = function _onChange(_ref) {
        var value = _ref.target.value;
        return props.onChange(value === "" ? options.emptyValue : value);
    };
    return [
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", (0, $cG9FK.default)({
            key: inputProps.id,
            className: "form-control",
            readOnly: readonly,
            disabled: disabled,
            autoFocus: autofocus,
            value: value == null ? "" : value
        }, inputProps, {
            list: schema.examples ? "examples_".concat(inputProps.id) : null,
            onChange: _onChange,
            onBlur: onBlur && function(event) {
                return onBlur(inputProps.id, event.target.value);
            },
            onFocus: onFocus && function(event) {
                return onFocus(inputProps.id, event.target.value);
            }
        })),
        schema.examples ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("datalist", {
            id: "examples_".concat(inputProps.id)
        }, (0, $4juyi.default)(new (0, (/*@__PURE__*/$parcel$interopDefault($lyRnQ)))(schema.examples.concat(schema["default"] ? [
            schema["default"]
        ] : []))).map(function(example) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
                key: example,
                value: example
            });
        })) : null
    ];
}
$55428310fd883133$var$BaseInput.defaultProps = {
    required: false,
    disabled: false,
    readonly: false,
    autofocus: false
};
var $55428310fd883133$export$2e2bcd8739ae039 = $55428310fd883133$var$BaseInput;

});

parcelRegister("d1pEL", function(module, exports) {

$parcel$export(module.exports, "default", () => $97af453231d8d6e5$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $ip6TK = parcelRequire("ip6TK");
function $97af453231d8d6e5$var$CheckboxWidget(props) {
    var schema = props.schema, id = props.id, value = props.value, disabled = props.disabled, readonly = props.readonly, label = props.label, autofocus = props.autofocus, onBlur = props.onBlur, onFocus = props.onFocus, _onChange = props.onChange, DescriptionField = props.DescriptionField; // Because an unchecked checkbox will cause html5 validation to fail, only add
    // the "required" attribute if the field value must be "true", due to the
    // "const" or "enum" keywords
    var required = (0, $ip6TK.schemaRequiresTrueValue)(schema);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "checkbox ".concat(disabled || readonly ? "disabled" : "")
    }, schema.description && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(DescriptionField, {
        description: schema.description
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        type: "checkbox",
        id: id,
        checked: typeof value === "undefined" ? false : value,
        required: required,
        disabled: disabled || readonly,
        autoFocus: autofocus,
        onChange: function onChange(event) {
            return _onChange(event.target.checked);
        },
        onBlur: onBlur && function(event) {
            return onBlur(id, event.target.checked);
        },
        onFocus: onFocus && function(event) {
            return onFocus(id, event.target.checked);
        }
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, label)));
}
$97af453231d8d6e5$var$CheckboxWidget.defaultProps = {
    autofocus: false
};
var $97af453231d8d6e5$export$2e2bcd8739ae039 = $97af453231d8d6e5$var$CheckboxWidget;

});

parcelRegister("9eHmu", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b970e9b0911b71c$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

function $6b970e9b0911b71c$var$selectValue(value, selected, all) {
    var at = all.indexOf(value);
    var updated = selected.slice(0, at).concat(value, selected.slice(at)); // As inserting values at predefined index positions doesn't work with empty
    // arrays, we need to reorder the updated selection to match the initial order
    return updated.sort(function(a, b) {
        return all.indexOf(a) > all.indexOf(b);
    });
}
function $6b970e9b0911b71c$var$deselectValue(value, selected) {
    return selected.filter(function(v) {
        return v !== value;
    });
}
function $6b970e9b0911b71c$var$CheckboxesWidget(props) {
    var id = props.id, disabled = props.disabled, options = props.options, value = props.value, autofocus = props.autofocus, readonly = props.readonly, _onChange = props.onChange;
    var enumOptions = options.enumOptions, enumDisabled = options.enumDisabled, inline = options.inline;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "checkboxes",
        id: id
    }, enumOptions.map(function(option, index) {
        var checked = value.indexOf(option.value) !== -1;
        var itemDisabled = enumDisabled && enumDisabled.indexOf(option.value) != -1;
        var disabledCls = disabled || itemDisabled || readonly ? "disabled" : "";
        var checkbox = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
            type: "checkbox",
            id: "".concat(id, "_").concat(index),
            checked: checked,
            disabled: disabled || itemDisabled || readonly,
            autoFocus: autofocus && index === 0,
            onChange: function onChange(event) {
                var all = enumOptions.map(function(_ref) {
                    var value = _ref.value;
                    return value;
                });
                if (event.target.checked) _onChange($6b970e9b0911b71c$var$selectValue(option.value, value, all));
                else _onChange($6b970e9b0911b71c$var$deselectValue(option.value, value));
            }
        }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, option.label));
        return inline ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
            key: index,
            className: "checkbox-inline ".concat(disabledCls)
        }, checkbox) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: index,
            className: "checkbox ".concat(disabledCls)
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", null, checkbox));
    }));
}
$6b970e9b0911b71c$var$CheckboxesWidget.defaultProps = {
    autofocus: false,
    options: {
        inline: false
    }
};
var $6b970e9b0911b71c$export$2e2bcd8739ae039 = $6b970e9b0911b71c$var$CheckboxesWidget;

});

parcelRegister("7hPlQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $54e1f437318f1707$export$2e2bcd8739ae039);

var $cG9FK = parcelRequire("cG9FK");

var $acw62 = parcelRequire("acw62");

function $54e1f437318f1707$var$ColorWidget(props) {
    var disabled = props.disabled, readonly = props.readonly, BaseInput = props.registry.widgets.BaseInput;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(BaseInput, (0, $cG9FK.default)({
        type: "color"
    }, props, {
        disabled: disabled || readonly
    }));
}
var $54e1f437318f1707$export$2e2bcd8739ae039 = $54e1f437318f1707$var$ColorWidget;

});

parcelRegister("eKeY7", function(module, exports) {

$parcel$export(module.exports, "default", () => $abc0f907c25592d1$export$2e2bcd8739ae039);

var $cG9FK = parcelRequire("cG9FK");

var $acw62 = parcelRequire("acw62");

function $abc0f907c25592d1$var$DateWidget(props) {
    var _onChange = props.onChange, BaseInput = props.registry.widgets.BaseInput;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(BaseInput, (0, $cG9FK.default)({
        type: "date"
    }, props, {
        onChange: function onChange(value) {
            return _onChange(value || undefined);
        }
    }));
}
var $abc0f907c25592d1$export$2e2bcd8739ae039 = $abc0f907c25592d1$var$DateWidget;

});

parcelRegister("1gVe5", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ed3ad04dfbbc84c$export$2e2bcd8739ae039);

var $cG9FK = parcelRequire("cG9FK");

var $acw62 = parcelRequire("acw62");


var $ip6TK = parcelRequire("ip6TK");
function $0ed3ad04dfbbc84c$var$DateTimeWidget(props) {
    var value = props.value, _onChange = props.onChange, BaseInput = props.registry.widgets.BaseInput;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(BaseInput, (0, $cG9FK.default)({
        type: "datetime-local"
    }, props, {
        value: (0, $ip6TK.utcToLocal)(value),
        onChange: function onChange(value) {
            return _onChange((0, $ip6TK.localToUTC)(value));
        }
    }));
}
var $0ed3ad04dfbbc84c$export$2e2bcd8739ae039 = $0ed3ad04dfbbc84c$var$DateTimeWidget;

});

parcelRegister("zJ57z", function(module, exports) {

$parcel$export(module.exports, "default", () => $06b63d43f182e632$export$2e2bcd8739ae039);

var $cG9FK = parcelRequire("cG9FK");

var $acw62 = parcelRequire("acw62");

function $06b63d43f182e632$var$EmailWidget(props) {
    var BaseInput = props.registry.widgets.BaseInput;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(BaseInput, (0, $cG9FK.default)({
        type: "email"
    }, props));
}
var $06b63d43f182e632$export$2e2bcd8739ae039 = $06b63d43f182e632$var$EmailWidget;

});

parcelRegister("bPjUv", function(module, exports) {

$parcel$export(module.exports, "default", () => $89c3e6e498051085$export$2e2bcd8739ae039);

var $a5du3 = parcelRequire("a5du3");

var $7PwEf = parcelRequire("7PwEf");

var $4tWkZ = parcelRequire("4tWkZ");

var $eBH73 = parcelRequire("eBH73");

var $ctnWZ = parcelRequire("ctnWZ");

var $hl9R1 = parcelRequire("hl9R1");

var $ivxVa = parcelRequire("ivxVa");

var $kB4x2 = parcelRequire("kB4x2");

var $7oVy1 = parcelRequire("7oVy1");

var $acw62 = parcelRequire("acw62");


var $ip6TK = parcelRequire("ip6TK");
function $89c3e6e498051085$var$addNameToDataURL(dataURL, name) {
    return dataURL.replace(";base64", ";name=".concat(encodeURIComponent(name), ";base64"));
}
function $89c3e6e498051085$var$processFile(file) {
    var name = file.name, size = file.size, type = file.type;
    return new (0, (/*@__PURE__*/$parcel$interopDefault($7oVy1)))(function(resolve, reject) {
        var reader = new window.FileReader();
        reader.onerror = reject;
        reader.onload = function(event) {
            resolve({
                dataURL: $89c3e6e498051085$var$addNameToDataURL(event.target.result, name),
                name: name,
                size: size,
                type: type
            });
        };
        reader.readAsDataURL(file);
    });
}
function $89c3e6e498051085$var$processFiles(files) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7oVy1))).all([].map.call(files, $89c3e6e498051085$var$processFile));
}
function $89c3e6e498051085$var$FilesInfo(props) {
    var filesInfo = props.filesInfo;
    if (filesInfo.length === 0) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        className: "file-info"
    }, filesInfo.map(function(fileInfo, key) {
        var name = fileInfo.name, size = fileInfo.size, type = fileInfo.type;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: key
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("strong", null, name), " (", type, ", ", size, " bytes)");
    }));
}
function $89c3e6e498051085$var$extractFileInfo(dataURLs) {
    return dataURLs.filter(function(dataURL) {
        return typeof dataURL !== "undefined";
    }).map(function(dataURL) {
        var _dataURItoBlob = (0, $ip6TK.dataURItoBlob)(dataURL), blob = _dataURItoBlob.blob, name = _dataURItoBlob.name;
        return {
            name: name,
            size: blob.size,
            type: blob.type
        };
    });
}
var $89c3e6e498051085$var$FileWidget = /*#__PURE__*/ function(_Component) {
    (0, $ivxVa.default)(FileWidget, _Component);
    function FileWidget(props) {
        var _this;
        (0, $7PwEf.default)(this, FileWidget);
        _this = (0, $eBH73.default)(this, (0, $ctnWZ.default)(FileWidget).call(this, props));
        (0, $kB4x2.default)((0, $hl9R1.default)(_this), "onChange", function(event) {
            var _this$props = _this.props, multiple = _this$props.multiple, onChange = _this$props.onChange;
            $89c3e6e498051085$var$processFiles(event.target.files).then(function(filesInfo) {
                var state = {
                    values: filesInfo.map(function(fileInfo) {
                        return fileInfo.dataURL;
                    }),
                    filesInfo: filesInfo
                };
                _this.setState(state, function() {
                    if (multiple) onChange(state.values);
                    else onChange(state.values[0]);
                });
            });
        });
        var value = props.value;
        var values = (0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(value) ? value : [
            value
        ];
        _this.state = {
            values: values,
            filesInfo: $89c3e6e498051085$var$extractFileInfo(values)
        };
        return _this;
    }
    (0, $4tWkZ.default)(FileWidget, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps, nextState) {
                return (0, $ip6TK.shouldRender)(this, nextProps, nextState);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props2 = this.props, multiple = _this$props2.multiple, id = _this$props2.id, readonly = _this$props2.readonly, disabled = _this$props2.disabled, autofocus = _this$props2.autofocus, options = _this$props2.options;
                var filesInfo = this.state.filesInfo;
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
                    ref: function ref(_ref) {
                        return _this2.inputRef = _ref;
                    },
                    id: id,
                    type: "file",
                    disabled: readonly || disabled,
                    onChange: this.onChange,
                    defaultValue: "",
                    autoFocus: autofocus,
                    multiple: multiple,
                    accept: options.accept
                })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($89c3e6e498051085$var$FilesInfo, {
                    filesInfo: filesInfo
                }));
            }
        }
    ]);
    return FileWidget;
}((0, $acw62.Component));
$89c3e6e498051085$var$FileWidget.defaultProps = {
    autofocus: false
};
var $89c3e6e498051085$export$2e2bcd8739ae039 = $89c3e6e498051085$var$FileWidget;

});
parcelRegister("7oVy1", function(module, exports) {

module.exports = (parcelRequire("WfEJm"));

});
parcelRegister("WfEJm", function(module, exports) {
parcelRequire("6JkF2");
parcelRequire("kPnXr");
parcelRequire("hfW11");
parcelRequire("6rl0S");
parcelRequire("6knvh");
parcelRequire("3mXXj");

module.exports = (parcelRequire("314Mo")).Promise;

});
parcelRegister("6rl0S", function(module, exports) {
"use strict";

var $dJ8Vu = parcelRequire("dJ8Vu");

var $llv21 = parcelRequire("llv21");

var $5iFqY = parcelRequire("5iFqY");

var $gFwGK = parcelRequire("gFwGK");

var $kEXpx = parcelRequire("kEXpx");

var $6sMmO = parcelRequire("6sMmO");

var $6ZyoG = parcelRequire("6ZyoG");

var $heUpR = parcelRequire("heUpR");

var $92nMp = parcelRequire("92nMp");

var $lfpsn = parcelRequire("lfpsn");

var $94pn8 = parcelRequire("94pn8");
var $4b05907641136dfb$require$task = $94pn8.set;

var $4b05907641136dfb$var$microtask = (parcelRequire("6Woeh"))();

var $3kBCh = parcelRequire("3kBCh");

var $59du4 = parcelRequire("59du4");

var $7I8YD = parcelRequire("7I8YD");

var $qxxt1 = parcelRequire("qxxt1");
var $4b05907641136dfb$var$PROMISE = "Promise";
var $4b05907641136dfb$var$TypeError = $llv21.TypeError;
var $4b05907641136dfb$var$process = $llv21.process;
var $4b05907641136dfb$var$versions = $4b05907641136dfb$var$process && $4b05907641136dfb$var$process.versions;
var $4b05907641136dfb$var$v8 = $4b05907641136dfb$var$versions && $4b05907641136dfb$var$versions.v8 || "";
var $4b05907641136dfb$var$$Promise = $llv21[$4b05907641136dfb$var$PROMISE];
var $4b05907641136dfb$var$isNode = $gFwGK($4b05907641136dfb$var$process) == "process";
var $4b05907641136dfb$var$empty = function() {};
var $4b05907641136dfb$var$Internal, $4b05907641136dfb$var$newGenericPromiseCapability, $4b05907641136dfb$var$OwnPromiseCapability, $4b05907641136dfb$var$Wrapper;
var $4b05907641136dfb$var$newPromiseCapability = $4b05907641136dfb$var$newGenericPromiseCapability = $3kBCh.f;

var $4b05907641136dfb$var$USE_NATIVE = !!function() {
    try {
        // correct subclassing with @@species support
        var promise = $4b05907641136dfb$var$$Promise.resolve(1);
        var FakePromise = (promise.constructor = {})[(parcelRequire("isDo7"))("species")] = function(exec) {
            exec($4b05907641136dfb$var$empty, $4b05907641136dfb$var$empty);
        };
        // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
        return ($4b05907641136dfb$var$isNode || typeof PromiseRejectionEvent == "function") && promise.then($4b05907641136dfb$var$empty) instanceof FakePromise && $4b05907641136dfb$var$v8.indexOf("6.6") !== 0 && $7I8YD.indexOf("Chrome/66") === -1;
    } catch (e) {}
}();
// helpers
var $4b05907641136dfb$var$isThenable = function(it) {
    var then;
    return $6sMmO(it) && typeof (then = it.then) == "function" ? then : false;
};
var $4b05907641136dfb$var$notify = function(promise, isReject) {
    if (promise._n) return;
    promise._n = true;
    var chain = promise._c;
    $4b05907641136dfb$var$microtask(function() {
        var value = promise._v;
        var ok = promise._s == 1;
        var i = 0;
        var run = function(reaction) {
            var handler = ok ? reaction.ok : reaction.fail;
            var resolve = reaction.resolve;
            var reject = reaction.reject;
            var domain = reaction.domain;
            var result, then, exited;
            try {
                if (handler) {
                    if (!ok) {
                        if (promise._h == 2) $4b05907641136dfb$var$onHandleUnhandled(promise);
                        promise._h = 1;
                    }
                    if (handler === true) result = value;
                    else {
                        if (domain) domain.enter();
                        result = handler(value); // may throw
                        if (domain) {
                            domain.exit();
                            exited = true;
                        }
                    }
                    if (result === reaction.promise) reject($4b05907641136dfb$var$TypeError("Promise-chain cycle"));
                    else if (then = $4b05907641136dfb$var$isThenable(result)) then.call(result, resolve, reject);
                    else resolve(result);
                } else reject(value);
            } catch (e) {
                if (domain && !exited) domain.exit();
                reject(e);
            }
        };
        while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
        promise._c = [];
        promise._n = false;
        if (isReject && !promise._h) $4b05907641136dfb$var$onUnhandled(promise);
    });
};
var $4b05907641136dfb$var$onUnhandled = function(promise) {
    $4b05907641136dfb$require$task.call($llv21, function() {
        var value = promise._v;
        var unhandled = $4b05907641136dfb$var$isUnhandled(promise);
        var result, handler, console;
        if (unhandled) {
            result = $59du4(function() {
                if ($4b05907641136dfb$var$isNode) $4b05907641136dfb$var$process.emit("unhandledRejection", value, promise);
                else if (handler = $llv21.onunhandledrejection) handler({
                    promise: promise,
                    reason: value
                });
                else if ((console = $llv21.console) && console.error) console.error("Unhandled promise rejection", value);
            });
            // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
            promise._h = $4b05907641136dfb$var$isNode || $4b05907641136dfb$var$isUnhandled(promise) ? 2 : 1;
        }
        promise._a = undefined;
        if (unhandled && result.e) throw result.v;
    });
};
var $4b05907641136dfb$var$isUnhandled = function(promise) {
    return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var $4b05907641136dfb$var$onHandleUnhandled = function(promise) {
    $4b05907641136dfb$require$task.call($llv21, function() {
        var handler;
        if ($4b05907641136dfb$var$isNode) $4b05907641136dfb$var$process.emit("rejectionHandled", promise);
        else if (handler = $llv21.onrejectionhandled) handler({
            promise: promise,
            reason: promise._v
        });
    });
};
var $4b05907641136dfb$var$$reject = function(value) {
    var promise = this;
    if (promise._d) return;
    promise._d = true;
    promise = promise._w || promise; // unwrap
    promise._v = value;
    promise._s = 2;
    if (!promise._a) promise._a = promise._c.slice();
    $4b05907641136dfb$var$notify(promise, true);
};
var $4b05907641136dfb$var$$resolve = function(value) {
    var promise = this;
    var then;
    if (promise._d) return;
    promise._d = true;
    promise = promise._w || promise; // unwrap
    try {
        if (promise === value) throw $4b05907641136dfb$var$TypeError("Promise can't be resolved itself");
        if (then = $4b05907641136dfb$var$isThenable(value)) $4b05907641136dfb$var$microtask(function() {
            var wrapper = {
                _w: promise,
                _d: false
            }; // wrap
            try {
                then.call(value, $5iFqY($4b05907641136dfb$var$$resolve, wrapper, 1), $5iFqY($4b05907641136dfb$var$$reject, wrapper, 1));
            } catch (e) {
                $4b05907641136dfb$var$$reject.call(wrapper, e);
            }
        });
        else {
            promise._v = value;
            promise._s = 1;
            $4b05907641136dfb$var$notify(promise, false);
        }
    } catch (e) {
        $4b05907641136dfb$var$$reject.call({
            _w: promise,
            _d: false
        }, e); // wrap
    }
};

// constructor polyfill
if (!$4b05907641136dfb$var$USE_NATIVE) {
    // 25.4.3.1 Promise(executor)
    $4b05907641136dfb$var$$Promise = function Promise(executor) {
        $heUpR(this, $4b05907641136dfb$var$$Promise, $4b05907641136dfb$var$PROMISE, "_h");
        $6ZyoG(executor);
        $4b05907641136dfb$var$Internal.call(this);
        try {
            executor($5iFqY($4b05907641136dfb$var$$resolve, this, 1), $5iFqY($4b05907641136dfb$var$$reject, this, 1));
        } catch (err) {
            $4b05907641136dfb$var$$reject.call(this, err);
        }
    };
    // eslint-disable-next-line no-unused-vars
    $4b05907641136dfb$var$Internal = function Promise(executor) {
        this._c = []; // <- awaiting reactions
        this._a = undefined; // <- checked in isUnhandled reactions
        this._s = 0; // <- state
        this._d = false; // <- done
        this._v = undefined; // <- value
        this._h = 0; // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
        this._n = false; // <- notify
    };
    $4b05907641136dfb$var$Internal.prototype = (parcelRequire("iGcAD"))($4b05907641136dfb$var$$Promise.prototype, {
        // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
        then: function then(onFulfilled, onRejected) {
            var reaction = $4b05907641136dfb$var$newPromiseCapability($lfpsn(this, $4b05907641136dfb$var$$Promise));
            reaction.ok = typeof onFulfilled == "function" ? onFulfilled : true;
            reaction.fail = typeof onRejected == "function" && onRejected;
            reaction.domain = $4b05907641136dfb$var$isNode ? $4b05907641136dfb$var$process.domain : undefined;
            this._c.push(reaction);
            if (this._a) this._a.push(reaction);
            if (this._s) $4b05907641136dfb$var$notify(this, false);
            return reaction.promise;
        },
        // 25.4.5.1 Promise.prototype.catch(onRejected)
        "catch": function(onRejected) {
            return this.then(undefined, onRejected);
        }
    });
    $4b05907641136dfb$var$OwnPromiseCapability = function() {
        var promise = new $4b05907641136dfb$var$Internal();
        this.promise = promise;
        this.resolve = $5iFqY($4b05907641136dfb$var$$resolve, promise, 1);
        this.reject = $5iFqY($4b05907641136dfb$var$$reject, promise, 1);
    };
    $3kBCh.f = $4b05907641136dfb$var$newPromiseCapability = function(C) {
        return C === $4b05907641136dfb$var$$Promise || C === $4b05907641136dfb$var$Wrapper ? new $4b05907641136dfb$var$OwnPromiseCapability(C) : $4b05907641136dfb$var$newGenericPromiseCapability(C);
    };
}
$kEXpx($kEXpx.G + $kEXpx.W + $kEXpx.F * !$4b05907641136dfb$var$USE_NATIVE, {
    Promise: $4b05907641136dfb$var$$Promise
});

(parcelRequire("2l8lG"))($4b05907641136dfb$var$$Promise, $4b05907641136dfb$var$PROMISE);

(parcelRequire("hUMoU"))($4b05907641136dfb$var$PROMISE);

$4b05907641136dfb$var$Wrapper = (parcelRequire("314Mo"))[$4b05907641136dfb$var$PROMISE];
// statics
$kEXpx($kEXpx.S + $kEXpx.F * !$4b05907641136dfb$var$USE_NATIVE, $4b05907641136dfb$var$PROMISE, {
    // 25.4.4.5 Promise.reject(r)
    reject: function reject(r) {
        var capability = $4b05907641136dfb$var$newPromiseCapability(this);
        var $$reject = capability.reject;
        $$reject(r);
        return capability.promise;
    }
});
$kEXpx($kEXpx.S + $kEXpx.F * ($dJ8Vu || !$4b05907641136dfb$var$USE_NATIVE), $4b05907641136dfb$var$PROMISE, {
    // 25.4.4.6 Promise.resolve(x)
    resolve: function resolve(x) {
        return $qxxt1($dJ8Vu && this === $4b05907641136dfb$var$Wrapper ? $4b05907641136dfb$var$$Promise : this, x);
    }
});

$kEXpx($kEXpx.S + $kEXpx.F * !($4b05907641136dfb$var$USE_NATIVE && (parcelRequire("hulk4"))(function(iter) {
    $4b05907641136dfb$var$$Promise.all(iter)["catch"]($4b05907641136dfb$var$empty);
})), $4b05907641136dfb$var$PROMISE, {
    // 25.4.4.1 Promise.all(iterable)
    all: function all(iterable) {
        var C = this;
        var capability = $4b05907641136dfb$var$newPromiseCapability(C);
        var resolve = capability.resolve;
        var reject = capability.reject;
        var result = $59du4(function() {
            var values = [];
            var index = 0;
            var remaining = 1;
            $92nMp(iterable, false, function(promise) {
                var $index = index++;
                var alreadyCalled = false;
                values.push(undefined);
                remaining++;
                C.resolve(promise).then(function(value) {
                    if (alreadyCalled) return;
                    alreadyCalled = true;
                    values[$index] = value;
                    --remaining || resolve(values);
                }, reject);
            });
            --remaining || resolve(values);
        });
        if (result.e) reject(result.v);
        return capability.promise;
    },
    // 25.4.4.4 Promise.race(iterable)
    race: function race(iterable) {
        var C = this;
        var capability = $4b05907641136dfb$var$newPromiseCapability(C);
        var reject = capability.reject;
        var result = $59du4(function() {
            $92nMp(iterable, false, function(promise) {
                C.resolve(promise).then(capability.resolve, reject);
            });
        });
        if (result.e) reject(result.v);
        return capability.promise;
    }
});

});
parcelRegister("lfpsn", function(module, exports) {
// 7.3.20 SpeciesConstructor(O, defaultConstructor)

var $52hVC = parcelRequire("52hVC");

var $6ZyoG = parcelRequire("6ZyoG");

var $f77ebed97c881513$var$SPECIES = (parcelRequire("isDo7"))("species");
module.exports = function(O, D) {
    var C = $52hVC(O).constructor;
    var S;
    return C === undefined || (S = $52hVC(C)[$f77ebed97c881513$var$SPECIES]) == undefined ? D : $6ZyoG(S);
};

});

parcelRegister("94pn8", function(module, exports) {

var $5iFqY = parcelRequire("5iFqY");

var $iLAUf = parcelRequire("iLAUf");

var $03zCw = parcelRequire("03zCw");

var $11bWq = parcelRequire("11bWq");

var $llv21 = parcelRequire("llv21");
var $69a82b27f7778ee2$var$process = $llv21.process;
var $69a82b27f7778ee2$var$setTask = $llv21.setImmediate;
var $69a82b27f7778ee2$var$clearTask = $llv21.clearImmediate;
var $69a82b27f7778ee2$var$MessageChannel = $llv21.MessageChannel;
var $69a82b27f7778ee2$var$Dispatch = $llv21.Dispatch;
var $69a82b27f7778ee2$var$counter = 0;
var $69a82b27f7778ee2$var$queue = {};
var $69a82b27f7778ee2$var$ONREADYSTATECHANGE = "onreadystatechange";
var $69a82b27f7778ee2$var$defer, $69a82b27f7778ee2$var$channel, $69a82b27f7778ee2$var$port;
var $69a82b27f7778ee2$var$run = function() {
    var id = +this;
    // eslint-disable-next-line no-prototype-builtins
    if ($69a82b27f7778ee2$var$queue.hasOwnProperty(id)) {
        var fn = $69a82b27f7778ee2$var$queue[id];
        delete $69a82b27f7778ee2$var$queue[id];
        fn();
    }
};
var $69a82b27f7778ee2$var$listener = function(event) {
    $69a82b27f7778ee2$var$run.call(event.data);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$69a82b27f7778ee2$var$setTask || !$69a82b27f7778ee2$var$clearTask) {
    $69a82b27f7778ee2$var$setTask = function setImmediate(fn) {
        var args = [];
        var i = 1;
        while(arguments.length > i)args.push(arguments[i++]);
        $69a82b27f7778ee2$var$queue[++$69a82b27f7778ee2$var$counter] = function() {
            // eslint-disable-next-line no-new-func
            $iLAUf(typeof fn == "function" ? fn : Function(fn), args);
        };
        $69a82b27f7778ee2$var$defer($69a82b27f7778ee2$var$counter);
        return $69a82b27f7778ee2$var$counter;
    };
    $69a82b27f7778ee2$var$clearTask = function clearImmediate(id) {
        delete $69a82b27f7778ee2$var$queue[id];
    };
    // Node.js 0.8-
    if ((parcelRequire("2aVBS"))($69a82b27f7778ee2$var$process) == "process") $69a82b27f7778ee2$var$defer = function(id) {
        $69a82b27f7778ee2$var$process.nextTick($5iFqY($69a82b27f7778ee2$var$run, id, 1));
    };
    else if ($69a82b27f7778ee2$var$Dispatch && $69a82b27f7778ee2$var$Dispatch.now) $69a82b27f7778ee2$var$defer = function(id) {
        $69a82b27f7778ee2$var$Dispatch.now($5iFqY($69a82b27f7778ee2$var$run, id, 1));
    };
    else if ($69a82b27f7778ee2$var$MessageChannel) {
        $69a82b27f7778ee2$var$channel = new $69a82b27f7778ee2$var$MessageChannel();
        $69a82b27f7778ee2$var$port = $69a82b27f7778ee2$var$channel.port2;
        $69a82b27f7778ee2$var$channel.port1.onmessage = $69a82b27f7778ee2$var$listener;
        $69a82b27f7778ee2$var$defer = $5iFqY($69a82b27f7778ee2$var$port.postMessage, $69a82b27f7778ee2$var$port, 1);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($llv21.addEventListener && typeof postMessage == "function" && !$llv21.importScripts) {
        $69a82b27f7778ee2$var$defer = function(id) {
            $llv21.postMessage(id + "", "*");
        };
        $llv21.addEventListener("message", $69a82b27f7778ee2$var$listener, false);
    // IE8-
    } else if ($69a82b27f7778ee2$var$ONREADYSTATECHANGE in $11bWq("script")) $69a82b27f7778ee2$var$defer = function(id) {
        $03zCw.appendChild($11bWq("script"))[$69a82b27f7778ee2$var$ONREADYSTATECHANGE] = function() {
            $03zCw.removeChild(this);
            $69a82b27f7778ee2$var$run.call(id);
        };
    };
    else $69a82b27f7778ee2$var$defer = function(id) {
        setTimeout($5iFqY($69a82b27f7778ee2$var$run, id, 1), 0);
    };
}
module.exports = {
    set: $69a82b27f7778ee2$var$setTask,
    clear: $69a82b27f7778ee2$var$clearTask
};

});
parcelRegister("iLAUf", function(module, exports) {
// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function(fn, args, that) {
    var un = that === undefined;
    switch(args.length){
        case 0:
            return un ? fn() : fn.call(that);
        case 1:
            return un ? fn(args[0]) : fn.call(that, args[0]);
        case 2:
            return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);
        case 3:
            return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);
        case 4:
            return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
    }
    return fn.apply(that, args);
};

});


parcelRegister("6Woeh", function(module, exports) {

var $llv21 = parcelRequire("llv21");

var $94pn8 = parcelRequire("94pn8");
var $50daf44c155b47cd$require$macrotask = $94pn8.set;
var $50daf44c155b47cd$var$Observer = $llv21.MutationObserver || $llv21.WebKitMutationObserver;
var $50daf44c155b47cd$var$process = $llv21.process;
var $50daf44c155b47cd$var$Promise = $llv21.Promise;

var $50daf44c155b47cd$var$isNode = (parcelRequire("2aVBS"))($50daf44c155b47cd$var$process) == "process";
module.exports = function() {
    var head, last, notify;
    var flush = function() {
        var parent, fn;
        if ($50daf44c155b47cd$var$isNode && (parent = $50daf44c155b47cd$var$process.domain)) parent.exit();
        while(head){
            fn = head.fn;
            head = head.next;
            try {
                fn();
            } catch (e) {
                if (head) notify();
                else last = undefined;
                throw e;
            }
        }
        last = undefined;
        if (parent) parent.enter();
    };
    // Node.js
    if ($50daf44c155b47cd$var$isNode) notify = function() {
        $50daf44c155b47cd$var$process.nextTick(flush);
    };
    else if ($50daf44c155b47cd$var$Observer && !($llv21.navigator && $llv21.navigator.standalone)) {
        var toggle = true;
        var node = document.createTextNode("");
        new $50daf44c155b47cd$var$Observer(flush).observe(node, {
            characterData: true
        }); // eslint-disable-line no-new
        notify = function() {
            node.data = toggle = !toggle;
        };
    // environments with maybe non-completely correct, but existent Promise
    } else if ($50daf44c155b47cd$var$Promise && $50daf44c155b47cd$var$Promise.resolve) {
        // Promise.resolve without an argument throws an error in LG WebOS 2
        var promise = $50daf44c155b47cd$var$Promise.resolve(undefined);
        notify = function() {
            promise.then(flush);
        };
    // for other environments - macrotask based on:
    // - setImmediate
    // - MessageChannel
    // - window.postMessag
    // - onreadystatechange
    // - setTimeout
    } else notify = function() {
        // strange IE + webpack dev server bug - use .call(global)
        $50daf44c155b47cd$require$macrotask.call($llv21, flush);
    };
    return function(fn) {
        var task = {
            fn: fn,
            next: undefined
        };
        if (last) last.next = task;
        if (!head) {
            head = task;
            notify();
        }
        last = task;
    };
};

});

parcelRegister("3kBCh", function(module, exports) {

$parcel$export(module.exports, "f", () => $26d06b3529deda18$export$2d1720544b23b823, (v) => $26d06b3529deda18$export$2d1720544b23b823 = v);
var $26d06b3529deda18$export$2d1720544b23b823;
"use strict";

var $6ZyoG = parcelRequire("6ZyoG");
function $26d06b3529deda18$var$PromiseCapability(C) {
    var resolve, reject;
    this.promise = new C(function($$resolve, $$reject) {
        if (resolve !== undefined || reject !== undefined) throw TypeError("Bad Promise constructor");
        resolve = $$resolve;
        reject = $$reject;
    });
    this.resolve = $6ZyoG(resolve);
    this.reject = $6ZyoG(reject);
}
$26d06b3529deda18$export$2d1720544b23b823 = function(C) {
    return new $26d06b3529deda18$var$PromiseCapability(C);
};

});

parcelRegister("59du4", function(module, exports) {
module.exports = function(exec) {
    try {
        return {
            e: false,
            v: exec()
        };
    } catch (e) {
        return {
            e: true,
            v: e
        };
    }
};

});

parcelRegister("7I8YD", function(module, exports) {

var $llv21 = parcelRequire("llv21");
var $59d39b198faf9544$var$navigator = $llv21.navigator;
module.exports = $59d39b198faf9544$var$navigator && $59d39b198faf9544$var$navigator.userAgent || "";

});

parcelRegister("qxxt1", function(module, exports) {

var $52hVC = parcelRequire("52hVC");

var $6sMmO = parcelRequire("6sMmO");

var $3kBCh = parcelRequire("3kBCh");
module.exports = function(C, x) {
    $52hVC(C);
    if ($6sMmO(x) && x.constructor === C) return x;
    var promiseCapability = $3kBCh.f(C);
    var resolve = promiseCapability.resolve;
    resolve(x);
    return promiseCapability.promise;
};

});


parcelRegister("6knvh", function(module, exports) {
// https://github.com/tc39/proposal-promise-finally
"use strict";

var $kEXpx = parcelRequire("kEXpx");

var $314Mo = parcelRequire("314Mo");

var $llv21 = parcelRequire("llv21");

var $lfpsn = parcelRequire("lfpsn");

var $qxxt1 = parcelRequire("qxxt1");
$kEXpx($kEXpx.P + $kEXpx.R, "Promise", {
    "finally": function(onFinally) {
        var C = $lfpsn(this, $314Mo.Promise || $llv21.Promise);
        var isFunction = typeof onFinally == "function";
        return this.then(isFunction ? function(x) {
            return $qxxt1(C, onFinally()).then(function() {
                return x;
            });
        } : onFinally, isFunction ? function(e) {
            return $qxxt1(C, onFinally()).then(function() {
                throw e;
            });
        } : onFinally);
    }
});

});

parcelRegister("3mXXj", function(module, exports) {
"use strict";

var $kEXpx = parcelRequire("kEXpx");

var $3kBCh = parcelRequire("3kBCh");

var $59du4 = parcelRequire("59du4");
$kEXpx($kEXpx.S, "Promise", {
    "try": function(callbackfn) {
        var promiseCapability = $3kBCh.f(this);
        var result = $59du4(callbackfn);
        (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
        return promiseCapability.promise;
    }
});

});




parcelRegister("w7Lqo", function(module, exports) {

$parcel$export(module.exports, "default", () => $0609030672a9b3bd$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

function $0609030672a9b3bd$var$HiddenWidget(_ref) {
    var id = _ref.id, value = _ref.value;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        type: "hidden",
        id: id,
        value: typeof value === "undefined" ? "" : value
    });
}
var $0609030672a9b3bd$export$2e2bcd8739ae039 = $0609030672a9b3bd$var$HiddenWidget;

});

parcelRegister("dWFnk", function(module, exports) {

$parcel$export(module.exports, "default", () => $a270c96c5a25fdce$export$2e2bcd8739ae039);

var $cG9FK = parcelRequire("cG9FK");

var $acw62 = parcelRequire("acw62");

function $a270c96c5a25fdce$var$PasswordWidget(props) {
    var BaseInput = props.registry.widgets.BaseInput;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(BaseInput, (0, $cG9FK.default)({
        type: "password"
    }, props));
}
var $a270c96c5a25fdce$export$2e2bcd8739ae039 = $a270c96c5a25fdce$var$PasswordWidget;

});

parcelRegister("88Nn7", function(module, exports) {

$parcel$export(module.exports, "default", () => $5ed55e4fc929c7e1$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

function $5ed55e4fc929c7e1$var$RadioWidget(props) {
    var options = props.options, value = props.value, required = props.required, disabled = props.disabled, readonly = props.readonly, autofocus = props.autofocus, onBlur = props.onBlur, onFocus = props.onFocus, _onChange = props.onChange, id = props.id; // Generating a unique field name to identify this set of radio buttons
    var name = Math.random().toString();
    var enumOptions = options.enumOptions, enumDisabled = options.enumDisabled, inline = options.inline; // checked={checked} has been moved above name={name}, As mentioned in #349;
    // this is a temporary fix for radio button rendering bug in React, facebook/react#7630.
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "field-radio-group",
        id: id
    }, enumOptions.map(function(option, i) {
        var checked = option.value === value;
        var itemDisabled = enumDisabled && enumDisabled.indexOf(option.value) != -1;
        var disabledCls = disabled || itemDisabled || readonly ? "disabled" : "";
        var radio = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
            type: "radio",
            checked: checked,
            name: name,
            required: required,
            value: option.value,
            disabled: disabled || itemDisabled || readonly,
            autoFocus: autofocus && i === 0,
            onChange: function onChange(_) {
                return _onChange(option.value);
            },
            onBlur: onBlur && function(event) {
                return onBlur(id, event.target.value);
            },
            onFocus: onFocus && function(event) {
                return onFocus(id, event.target.value);
            }
        }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, option.label));
        return inline ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
            key: i,
            className: "radio-inline ".concat(disabledCls)
        }, radio) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            className: "radio ".concat(disabledCls)
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", null, radio));
    }));
}
$5ed55e4fc929c7e1$var$RadioWidget.defaultProps = {
    autofocus: false
};
var $5ed55e4fc929c7e1$export$2e2bcd8739ae039 = $5ed55e4fc929c7e1$var$RadioWidget;

});

parcelRegister("9Jno1", function(module, exports) {

$parcel$export(module.exports, "default", () => $715a7518f85337e1$export$2e2bcd8739ae039);

var $cG9FK = parcelRequire("cG9FK");

var $acw62 = parcelRequire("acw62");


var $ip6TK = parcelRequire("ip6TK");
function $715a7518f85337e1$var$RangeWidget(props) {
    var schema = props.schema, value = props.value, BaseInput = props.registry.widgets.BaseInput;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "field-range-wrapper"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(BaseInput, (0, $cG9FK.default)({
        type: "range"
    }, props, (0, $ip6TK.rangeSpec)(schema))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "range-view"
    }, value));
}
var $715a7518f85337e1$export$2e2bcd8739ae039 = $715a7518f85337e1$var$RangeWidget;

});

parcelRegister("cUreO", function(module, exports) {

$parcel$export(module.exports, "default", () => $965fd7e62b99749c$export$2e2bcd8739ae039);

var $lyRnQ = parcelRequire("lyRnQ");

var $acw62 = parcelRequire("acw62");


var $ip6TK = parcelRequire("ip6TK");
var $965fd7e62b99749c$var$nums = new (0, (/*@__PURE__*/$parcel$interopDefault($lyRnQ)))([
    "number",
    "integer"
]);
/**
 * This is a silly limitation in the DOM where option change event values are
 * always retrieved as strings.
 */ function $965fd7e62b99749c$var$processValue(schema, value) {
    // "enum" is a reserved word, so only "type" and "items" can be destructured
    var type = schema.type, items = schema.items;
    if (value === "") return undefined;
    else if (type === "array" && items && $965fd7e62b99749c$var$nums.has(items.type)) return value.map((0, $ip6TK.asNumber));
    else if (type === "boolean") return value === "true";
    else if (type === "number") return (0, $ip6TK.asNumber)(value);
     // If type is undefined, but an enum is present, try and infer the type from
    // the enum values
    if (schema["enum"]) {
        if (schema["enum"].every(function(x) {
            return (0, $ip6TK.guessType)(x) === "number";
        })) return (0, $ip6TK.asNumber)(value);
        else if (schema["enum"].every(function(x) {
            return (0, $ip6TK.guessType)(x) === "boolean";
        })) return value === "true";
    }
    return value;
}
function $965fd7e62b99749c$var$getValue(event, multiple) {
    if (multiple) return [].slice.call(event.target.options).filter(function(o) {
        return o.selected;
    }).map(function(o) {
        return o.value;
    });
    else return event.target.value;
}
function $965fd7e62b99749c$var$SelectWidget(props) {
    var schema = props.schema, id = props.id, options = props.options, value = props.value, required = props.required, disabled = props.disabled, readonly = props.readonly, multiple = props.multiple, autofocus = props.autofocus, _onChange = props.onChange, onBlur = props.onBlur, onFocus = props.onFocus, placeholder = props.placeholder;
    var enumOptions = options.enumOptions, enumDisabled = options.enumDisabled;
    var emptyValue = multiple ? [] : "";
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("select", {
        id: id,
        multiple: multiple,
        className: "form-control",
        value: typeof value === "undefined" ? emptyValue : value,
        required: required,
        disabled: disabled || readonly,
        autoFocus: autofocus,
        onBlur: onBlur && function(event) {
            var newValue = $965fd7e62b99749c$var$getValue(event, multiple);
            onBlur(id, $965fd7e62b99749c$var$processValue(schema, newValue));
        },
        onFocus: onFocus && function(event) {
            var newValue = $965fd7e62b99749c$var$getValue(event, multiple);
            onFocus(id, $965fd7e62b99749c$var$processValue(schema, newValue));
        },
        onChange: function onChange(event) {
            var newValue = $965fd7e62b99749c$var$getValue(event, multiple);
            _onChange($965fd7e62b99749c$var$processValue(schema, newValue));
        }
    }, !multiple && schema["default"] === undefined && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
        value: ""
    }, placeholder), enumOptions.map(function(_ref, i) {
        var value = _ref.value, label = _ref.label;
        var disabled = enumDisabled && enumDisabled.indexOf(value) != -1;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
            key: i,
            value: value,
            disabled: disabled
        }, label);
    }));
}
$965fd7e62b99749c$var$SelectWidget.defaultProps = {
    autofocus: false
};
var $965fd7e62b99749c$export$2e2bcd8739ae039 = $965fd7e62b99749c$var$SelectWidget;

});

parcelRegister("OE4fu", function(module, exports) {

$parcel$export(module.exports, "default", () => $0983c0340b71703a$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

function $0983c0340b71703a$var$TextareaWidget(props) {
    var id = props.id, options = props.options, placeholder = props.placeholder, value = props.value, required = props.required, disabled = props.disabled, readonly = props.readonly, autofocus = props.autofocus, onChange = props.onChange, onBlur = props.onBlur, onFocus = props.onFocus;
    var _onChange = function _onChange(_ref) {
        var value = _ref.target.value;
        return onChange(value === "" ? options.emptyValue : value);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("textarea", {
        id: id,
        className: "form-control",
        value: value ? value : "",
        placeholder: placeholder,
        required: required,
        disabled: disabled,
        readOnly: readonly,
        autoFocus: autofocus,
        rows: options.rows,
        onBlur: onBlur && function(event) {
            return onBlur(id, event.target.value);
        },
        onFocus: onFocus && function(event) {
            return onFocus(id, event.target.value);
        },
        onChange: _onChange
    });
}
$0983c0340b71703a$var$TextareaWidget.defaultProps = {
    autofocus: false,
    options: {}
};
var $0983c0340b71703a$export$2e2bcd8739ae039 = $0983c0340b71703a$var$TextareaWidget;

});

parcelRegister("2Nvmy", function(module, exports) {

$parcel$export(module.exports, "default", () => $20987c6313b0a748$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

function $20987c6313b0a748$var$TextWidget(props) {
    var BaseInput = props.registry.widgets.BaseInput;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(BaseInput, props);
}
var $20987c6313b0a748$export$2e2bcd8739ae039 = $20987c6313b0a748$var$TextWidget;

});

parcelRegister("hKaGm", function(module, exports) {

$parcel$export(module.exports, "default", () => $ceaf04d36ad40ecb$export$2e2bcd8739ae039);

var $cG9FK = parcelRequire("cG9FK");

var $acw62 = parcelRequire("acw62");

function $ceaf04d36ad40ecb$var$URLWidget(props) {
    var BaseInput = props.registry.widgets.BaseInput;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(BaseInput, (0, $cG9FK.default)({
        type: "url"
    }, props));
}
var $ceaf04d36ad40ecb$export$2e2bcd8739ae039 = $ceaf04d36ad40ecb$var$URLWidget;

});

parcelRegister("40HJL", function(module, exports) {

$parcel$export(module.exports, "default", () => $2eb916c95b9216fb$export$2e2bcd8739ae039);

var $cG9FK = parcelRequire("cG9FK");

var $acw62 = parcelRequire("acw62");


var $ip6TK = parcelRequire("ip6TK");
function $2eb916c95b9216fb$var$UpDownWidget(props) {
    var BaseInput = props.registry.widgets.BaseInput;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(BaseInput, (0, $cG9FK.default)({
        type: "number"
    }, props, (0, $ip6TK.rangeSpec)(props.schema)));
}
var $2eb916c95b9216fb$export$2e2bcd8739ae039 = $2eb916c95b9216fb$var$UpDownWidget;

});


parcelRegister("3cXpG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "toErrorList", () => $2560944c61edec4e$export$29c1d0951c919856);
$parcel$export(module.exports, "default", () => $2560944c61edec4e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "isValid", () => $2560944c61edec4e$export$1ea939691cdc45b8);

var $4juyi = parcelRequire("4juyi");

var $kB4x2 = parcelRequire("kB4x2");

var $k4zDq = parcelRequire("k4zDq");

var $8lpxl = parcelRequire("8lpxl");

var $bTUgL = parcelRequire("bTUgL");

var $a5du3 = parcelRequire("a5du3");

var $ilhTG = parcelRequire("ilhTG");

var $5KOyW = parcelRequire("5KOyW");

var $ip6TK = parcelRequire("ip6TK");
var $2560944c61edec4e$var$ajv = $2560944c61edec4e$var$createAjvInstance();
var $2560944c61edec4e$var$formerCustomFormats = null;
var $2560944c61edec4e$var$formerMetaSchema = null;
function $2560944c61edec4e$var$createAjvInstance() {
    var ajv = new (0, (/*@__PURE__*/$parcel$interopDefault($5KOyW)))({
        errorDataPath: "property",
        allErrors: true,
        multipleOfPrecision: 8,
        schemaId: "auto",
        unknownFormats: "ignore"
    }); // add custom formats
    ajv.addFormat("data-url", /^data:([a-z]+\/[a-z0-9-+.]+)?;(?:name=(.*);)?base64,(.*)$/);
    ajv.addFormat("color", /^(#?([0-9A-Fa-f]{3}){1,2}\b|aqua|black|blue|fuchsia|gray|green|lime|maroon|navy|olive|orange|purple|red|silver|teal|white|yellow|(rgb\(\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*,\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*,\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*\))|(rgb\(\s*(\d?\d%|100%)+\s*,\s*(\d?\d%|100%)+\s*,\s*(\d?\d%|100%)+\s*\)))$/);
    return ajv;
}
function $2560944c61edec4e$var$toErrorSchema(errors) {
    // Transforms a ajv validation errors list:
    // [
    //   {property: ".level1.level2[2].level3", message: "err a"},
    //   {property: ".level1.level2[2].level3", message: "err b"},
    //   {property: ".level1.level2[4].level3", message: "err b"},
    // ]
    // Into an error tree:
    // {
    //   level1: {
    //     level2: {
    //       2: {level3: {errors: ["err a", "err b"]}},
    //       4: {level3: {errors: ["err b"]}},
    //     }
    //   }
    // };
    if (!errors.length) return {};
    return errors.reduce(function(errorSchema, error) {
        var property = error.property, message = error.message;
        var path = (0, (/*@__PURE__*/$parcel$interopDefault($ilhTG)))(property);
        var parent = errorSchema; // If the property is at the root (.level1) then toPath creates
        // an empty array element at the first index. Remove it.
        if (path.length > 0 && path[0] === "") path.splice(0, 1);
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;
        try {
            for(var _iterator = (0, (/*@__PURE__*/$parcel$interopDefault($bTUgL)))(path.slice(0)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var segment = _step.value;
                if (!(segment in parent)) parent[segment] = {};
                parent = parent[segment];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) _iterator["return"]();
            } finally{
                if (_didIteratorError) throw _iteratorError;
            }
        }
        if ((0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(parent.__errors)) // We store the list of errors for this node in a property named __errors
        // to avoid name collision with a possible sub schema field named
        // "errors" (see `validate.createErrorHandler`).
        parent.__errors = parent.__errors.concat(message);
        else if (message) parent.__errors = [
            message
        ];
        return errorSchema;
    }, {});
}
function $2560944c61edec4e$export$29c1d0951c919856(errorSchema) {
    var fieldName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "root";
    // XXX: We should transform fieldName as a full field path string.
    var errorList = [];
    if ("__errors" in errorSchema) errorList = errorList.concat(errorSchema.__errors.map(function(stack) {
        return {
            stack: "".concat(fieldName, ": ").concat(stack)
        };
    }));
    return (0, (/*@__PURE__*/$parcel$interopDefault($8lpxl)))(errorSchema).reduce(function(acc, key) {
        if (key !== "__errors") acc = acc.concat($2560944c61edec4e$export$29c1d0951c919856(errorSchema[key], key));
        return acc;
    }, errorList);
}
function $2560944c61edec4e$var$createErrorHandler(formData) {
    var handler = {
        // We store the list of errors for this node in a property named __errors
        // to avoid name collision with a possible sub schema field named
        // "errors" (see `utils.toErrorSchema`).
        __errors: [],
        addError: function addError(message) {
            this.__errors.push(message);
        }
    };
    if ((0, $ip6TK.isObject)(formData)) return (0, (/*@__PURE__*/$parcel$interopDefault($8lpxl)))(formData).reduce(function(acc, key) {
        return (0, $k4zDq.default)({}, acc, (0, $kB4x2.default)({}, key, $2560944c61edec4e$var$createErrorHandler(formData[key])));
    }, handler);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(formData)) return formData.reduce(function(acc, value, key) {
        return (0, $k4zDq.default)({}, acc, (0, $kB4x2.default)({}, key, $2560944c61edec4e$var$createErrorHandler(value)));
    }, handler);
    return handler;
}
function $2560944c61edec4e$var$unwrapErrorHandler(errorHandler) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($8lpxl)))(errorHandler).reduce(function(acc, key) {
        if (key === "addError") return acc;
        else if (key === "__errors") return (0, $k4zDq.default)({}, acc, (0, $kB4x2.default)({}, key, errorHandler[key]));
        return (0, $k4zDq.default)({}, acc, (0, $kB4x2.default)({}, key, $2560944c61edec4e$var$unwrapErrorHandler(errorHandler[key])));
    }, {});
}
/**
 * Transforming the error output from ajv to format used by jsonschema.
 * At some point, components should be updated to support ajv.
 */ function $2560944c61edec4e$var$transformAjvErrors() {
    var errors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    if (errors === null) return [];
    return errors.map(function(e) {
        var dataPath = e.dataPath, keyword = e.keyword, message = e.message, params = e.params, schemaPath = e.schemaPath;
        var property = "".concat(dataPath); // put data in expected format
        return {
            name: keyword,
            property: property,
            message: message,
            params: params,
            // specific to ajv
            stack: "".concat(property, " ").concat(message).trim(),
            schemaPath: schemaPath
        };
    });
}
function $2560944c61edec4e$export$2e2bcd8739ae039(formData, schema, customValidate, transformErrors) {
    var additionalMetaSchemas = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
    var customFormats = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
    // Include form data with undefined values, which is required for validation.
    var rootSchema = schema;
    formData = (0, $ip6TK.getDefaultFormState)(schema, formData, rootSchema, true);
    var newMetaSchemas = !(0, $ip6TK.deepEquals)($2560944c61edec4e$var$formerMetaSchema, additionalMetaSchemas);
    var newFormats = !(0, $ip6TK.deepEquals)($2560944c61edec4e$var$formerCustomFormats, customFormats);
    if (newMetaSchemas || newFormats) $2560944c61edec4e$var$ajv = $2560944c61edec4e$var$createAjvInstance();
     // add more schemas to validate against
    if (additionalMetaSchemas && newMetaSchemas && (0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(additionalMetaSchemas)) {
        $2560944c61edec4e$var$ajv.addMetaSchema(additionalMetaSchemas);
        $2560944c61edec4e$var$formerMetaSchema = additionalMetaSchemas;
    } // add more custom formats to validate against
    if (customFormats && newFormats && (0, $ip6TK.isObject)(customFormats)) {
        (0, (/*@__PURE__*/$parcel$interopDefault($8lpxl)))(customFormats).forEach(function(formatName) {
            $2560944c61edec4e$var$ajv.addFormat(formatName, customFormats[formatName]);
        });
        $2560944c61edec4e$var$formerCustomFormats = customFormats;
    }
    var validationError = null;
    try {
        $2560944c61edec4e$var$ajv.validate(schema, formData);
    } catch (err) {
        validationError = err;
    }
    var errors = $2560944c61edec4e$var$transformAjvErrors($2560944c61edec4e$var$ajv.errors); // Clear errors to prevent persistent errors, see #1104
    $2560944c61edec4e$var$ajv.errors = null;
    var noProperMetaSchema = validationError && validationError.message && typeof validationError.message === "string" && validationError.message.includes("no schema with key or ref ");
    if (noProperMetaSchema) errors = [].concat((0, $4juyi.default)(errors), [
        {
            stack: validationError.message
        }
    ]);
    if (typeof transformErrors === "function") errors = transformErrors(errors);
    var errorSchema = $2560944c61edec4e$var$toErrorSchema(errors);
    if (noProperMetaSchema) errorSchema = (0, $k4zDq.default)({}, errorSchema, {
        $schema: {
            __errors: [
                validationError.message
            ]
        }
    });
    if (typeof customValidate !== "function") return {
        errors: errors,
        errorSchema: errorSchema
    };
    var errorHandler = customValidate(formData, $2560944c61edec4e$var$createErrorHandler(formData));
    var userErrorSchema = $2560944c61edec4e$var$unwrapErrorHandler(errorHandler);
    var newErrorSchema = (0, $ip6TK.mergeObjects)(errorSchema, userErrorSchema, true); // XXX: The errors list produced is not fully compliant with the format
    // exposed by the jsonschema lib, which contains full field paths and other
    // properties.
    var newErrors = $2560944c61edec4e$export$29c1d0951c919856(newErrorSchema);
    return {
        errors: newErrors,
        errorSchema: newErrorSchema
    };
}
function $2560944c61edec4e$export$1ea939691cdc45b8(schema, data) {
    try {
        return $2560944c61edec4e$var$ajv.validate(schema, data);
    } catch (e) {
        return false;
    }
}

});
parcelRegister("ilhTG", function(module, exports) {

var $i46jW = parcelRequire("i46jW");

var $aA0pv = parcelRequire("aA0pv");

var $o8HxT = parcelRequire("o8HxT");

var $9dr3u = parcelRequire("9dr3u");

var $lnP3M = parcelRequire("lnP3M");

var $6DSvu = parcelRequire("6DSvu");

var $l6E2L = parcelRequire("l6E2L");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function $d5a812248d162412$var$toPath(value) {
    if ($o8HxT(value)) return $i46jW(value, $6DSvu);
    return $9dr3u(value) ? [
        value
    ] : $aA0pv($lnP3M($l6E2L(value)));
}
module.exports = $d5a812248d162412$var$toPath;

});

parcelRegister("5KOyW", function(module, exports) {
"use strict";

var $1sjgr = parcelRequire("1sjgr");

var $gY6uQ = parcelRequire("gY6uQ");

var $boFVy = parcelRequire("boFVy");

var $dvpPZ = parcelRequire("dvpPZ");

var $1FoUm = parcelRequire("1FoUm");

var $3gXPV = parcelRequire("3gXPV");

var $K8gzo = parcelRequire("K8gzo");

var $jSQ5p = parcelRequire("jSQ5p");

var $lv04s = parcelRequire("lv04s");
module.exports = $43087853b829e551$var$Ajv;
$43087853b829e551$var$Ajv.prototype.validate = $43087853b829e551$var$validate;
$43087853b829e551$var$Ajv.prototype.compile = $43087853b829e551$var$compile;
$43087853b829e551$var$Ajv.prototype.addSchema = $43087853b829e551$var$addSchema;
$43087853b829e551$var$Ajv.prototype.addMetaSchema = $43087853b829e551$var$addMetaSchema;
$43087853b829e551$var$Ajv.prototype.validateSchema = $43087853b829e551$var$validateSchema;
$43087853b829e551$var$Ajv.prototype.getSchema = $43087853b829e551$var$getSchema;
$43087853b829e551$var$Ajv.prototype.removeSchema = $43087853b829e551$var$removeSchema;
$43087853b829e551$var$Ajv.prototype.addFormat = $43087853b829e551$var$addFormat;
$43087853b829e551$var$Ajv.prototype.errorsText = $43087853b829e551$var$errorsText;
$43087853b829e551$var$Ajv.prototype._addSchema = $43087853b829e551$var$_addSchema;
$43087853b829e551$var$Ajv.prototype._compile = $43087853b829e551$var$_compile;

$43087853b829e551$var$Ajv.prototype.compileAsync = (parcelRequire("23QXm"));

var $70CFv = parcelRequire("70CFv");
$43087853b829e551$var$Ajv.prototype.addKeyword = $70CFv.add;
$43087853b829e551$var$Ajv.prototype.getKeyword = $70CFv.get;
$43087853b829e551$var$Ajv.prototype.removeKeyword = $70CFv.remove;
$43087853b829e551$var$Ajv.prototype.validateKeyword = $70CFv.validate;

var $4BeMy = parcelRequire("4BeMy");
$43087853b829e551$var$Ajv.ValidationError = $4BeMy.Validation;
$43087853b829e551$var$Ajv.MissingRefError = $4BeMy.MissingRef;
$43087853b829e551$var$Ajv.$dataMetaSchema = $jSQ5p;
var $43087853b829e551$var$META_SCHEMA_ID = "http://json-schema.org/draft-07/schema";
var $43087853b829e551$var$META_IGNORE_OPTIONS = [
    "removeAdditional",
    "useDefaults",
    "coerceTypes",
    "strictDefaults"
];
var $43087853b829e551$var$META_SUPPORT_DATA = [
    "/properties"
];
/**
 * Creates validator instance.
 * Usage: `Ajv(opts)`
 * @param {Object} opts optional options
 * @return {Object} ajv instance
 */ function $43087853b829e551$var$Ajv(opts) {
    if (!(this instanceof $43087853b829e551$var$Ajv)) return new $43087853b829e551$var$Ajv(opts);
    opts = this._opts = $lv04s.copy(opts) || {};
    $43087853b829e551$var$setLogger(this);
    this._schemas = {};
    this._refs = {};
    this._fragments = {};
    this._formats = $3gXPV(opts.format);
    this._cache = opts.cache || new $boFVy;
    this._loadingSchemas = {};
    this._compilations = [];
    this.RULES = $K8gzo();
    this._getId = $43087853b829e551$var$chooseGetId(opts);
    opts.loopRequired = opts.loopRequired || Infinity;
    if (opts.errorDataPath == "property") opts._errorDataPathProperty = true;
    if (opts.serialize === undefined) opts.serialize = $1FoUm;
    this._metaOpts = $43087853b829e551$var$getMetaSchemaOptions(this);
    if (opts.formats) $43087853b829e551$var$addInitialFormats(this);
    if (opts.keywords) $43087853b829e551$var$addInitialKeywords(this);
    $43087853b829e551$var$addDefaultMetaSchema(this);
    if (typeof opts.meta == "object") this.addMetaSchema(opts.meta);
    if (opts.nullable) this.addKeyword("nullable", {
        metaSchema: {
            type: "boolean"
        }
    });
    $43087853b829e551$var$addInitialSchemas(this);
}
/**
 * Validate data using schema
 * Schema will be compiled and cached (using serialized JSON as key. [fast-json-stable-stringify](https://github.com/epoberezkin/fast-json-stable-stringify) is used to serialize.
 * @this   Ajv
 * @param  {String|Object} schemaKeyRef key, ref or schema object
 * @param  {Any} data to be validated
 * @return {Boolean} validation result. Errors from the last validation will be available in `ajv.errors` (and also in compiled schema: `schema.errors`).
 */ function $43087853b829e551$var$validate(schemaKeyRef, data) {
    var v;
    if (typeof schemaKeyRef == "string") {
        v = this.getSchema(schemaKeyRef);
        if (!v) throw new Error('no schema with key or ref "' + schemaKeyRef + '"');
    } else {
        var schemaObj = this._addSchema(schemaKeyRef);
        v = schemaObj.validate || this._compile(schemaObj);
    }
    var valid = v(data);
    if (v.$async !== true) this.errors = v.errors;
    return valid;
}
/**
 * Create validating function for passed schema.
 * @this   Ajv
 * @param  {Object} schema schema object
 * @param  {Boolean} _meta true if schema is a meta-schema. Used internally to compile meta schemas of custom keywords.
 * @return {Function} validating function
 */ function $43087853b829e551$var$compile(schema, _meta) {
    var schemaObj = this._addSchema(schema, undefined, _meta);
    return schemaObj.validate || this._compile(schemaObj);
}
/**
 * Adds schema to the instance.
 * @this   Ajv
 * @param {Object|Array} schema schema or array of schemas. If array is passed, `key` and other parameters will be ignored.
 * @param {String} key Optional schema key. Can be passed to `validate` method instead of schema object or id/ref. One schema per instance can have empty `id` and `key`.
 * @param {Boolean} _skipValidation true to skip schema validation. Used internally, option validateSchema should be used instead.
 * @param {Boolean} _meta true if schema is a meta-schema. Used internally, addMetaSchema should be used instead.
 * @return {Ajv} this for method chaining
 */ function $43087853b829e551$var$addSchema(schema, key, _skipValidation, _meta) {
    if (Array.isArray(schema)) {
        for(var i = 0; i < schema.length; i++)this.addSchema(schema[i], undefined, _skipValidation, _meta);
        return this;
    }
    var id = this._getId(schema);
    if (id !== undefined && typeof id != "string") throw new Error("schema id must be string");
    key = $gY6uQ.normalizeId(key || id);
    $43087853b829e551$var$checkUnique(this, key);
    this._schemas[key] = this._addSchema(schema, _skipValidation, _meta, true);
    return this;
}
/**
 * Add schema that will be used to validate other schemas
 * options in META_IGNORE_OPTIONS are alway set to false
 * @this   Ajv
 * @param {Object} schema schema object
 * @param {String} key optional schema key
 * @param {Boolean} skipValidation true to skip schema validation, can be used to override validateSchema option for meta-schema
 * @return {Ajv} this for method chaining
 */ function $43087853b829e551$var$addMetaSchema(schema, key, skipValidation) {
    this.addSchema(schema, key, skipValidation, true);
    return this;
}
/**
 * Validate schema
 * @this   Ajv
 * @param {Object} schema schema to validate
 * @param {Boolean} throwOrLogError pass true to throw (or log) an error if invalid
 * @return {Boolean} true if schema is valid
 */ function $43087853b829e551$var$validateSchema(schema, throwOrLogError) {
    var $schema = schema.$schema;
    if ($schema !== undefined && typeof $schema != "string") throw new Error("$schema must be a string");
    $schema = $schema || this._opts.defaultMeta || $43087853b829e551$var$defaultMeta(this);
    if (!$schema) {
        this.logger.warn("meta-schema not available");
        this.errors = null;
        return true;
    }
    var valid = this.validate($schema, schema);
    if (!valid && throwOrLogError) {
        var message = "schema is invalid: " + this.errorsText();
        if (this._opts.validateSchema == "log") this.logger.error(message);
        else throw new Error(message);
    }
    return valid;
}
function $43087853b829e551$var$defaultMeta(self) {
    var meta = self._opts.meta;
    self._opts.defaultMeta = typeof meta == "object" ? self._getId(meta) || meta : self.getSchema($43087853b829e551$var$META_SCHEMA_ID) ? $43087853b829e551$var$META_SCHEMA_ID : undefined;
    return self._opts.defaultMeta;
}
/**
 * Get compiled schema from the instance by `key` or `ref`.
 * @this   Ajv
 * @param  {String} keyRef `key` that was passed to `addSchema` or full schema reference (`schema.id` or resolved id).
 * @return {Function} schema validating function (with property `schema`).
 */ function $43087853b829e551$var$getSchema(keyRef) {
    var schemaObj = $43087853b829e551$var$_getSchemaObj(this, keyRef);
    switch(typeof schemaObj){
        case "object":
            return schemaObj.validate || this._compile(schemaObj);
        case "string":
            return this.getSchema(schemaObj);
        case "undefined":
            return $43087853b829e551$var$_getSchemaFragment(this, keyRef);
    }
}
function $43087853b829e551$var$_getSchemaFragment(self, ref) {
    var res = $gY6uQ.schema.call(self, {
        schema: {}
    }, ref);
    if (res) {
        var schema = res.schema, root = res.root, baseId = res.baseId;
        var v = $1sjgr.call(self, schema, root, undefined, baseId);
        self._fragments[ref] = new $dvpPZ({
            ref: ref,
            fragment: true,
            schema: schema,
            root: root,
            baseId: baseId,
            validate: v
        });
        return v;
    }
}
function $43087853b829e551$var$_getSchemaObj(self, keyRef) {
    keyRef = $gY6uQ.normalizeId(keyRef);
    return self._schemas[keyRef] || self._refs[keyRef] || self._fragments[keyRef];
}
/**
 * Remove cached schema(s).
 * If no parameter is passed all schemas but meta-schemas are removed.
 * If RegExp is passed all schemas with key/id matching pattern but meta-schemas are removed.
 * Even if schema is referenced by other schemas it still can be removed as other schemas have local references.
 * @this   Ajv
 * @param  {String|Object|RegExp} schemaKeyRef key, ref, pattern to match key/ref or schema object
 * @return {Ajv} this for method chaining
 */ function $43087853b829e551$var$removeSchema(schemaKeyRef) {
    if (schemaKeyRef instanceof RegExp) {
        $43087853b829e551$var$_removeAllSchemas(this, this._schemas, schemaKeyRef);
        $43087853b829e551$var$_removeAllSchemas(this, this._refs, schemaKeyRef);
        return this;
    }
    switch(typeof schemaKeyRef){
        case "undefined":
            $43087853b829e551$var$_removeAllSchemas(this, this._schemas);
            $43087853b829e551$var$_removeAllSchemas(this, this._refs);
            this._cache.clear();
            return this;
        case "string":
            var schemaObj = $43087853b829e551$var$_getSchemaObj(this, schemaKeyRef);
            if (schemaObj) this._cache.del(schemaObj.cacheKey);
            delete this._schemas[schemaKeyRef];
            delete this._refs[schemaKeyRef];
            return this;
        case "object":
            var serialize = this._opts.serialize;
            var cacheKey = serialize ? serialize(schemaKeyRef) : schemaKeyRef;
            this._cache.del(cacheKey);
            var id = this._getId(schemaKeyRef);
            if (id) {
                id = $gY6uQ.normalizeId(id);
                delete this._schemas[id];
                delete this._refs[id];
            }
    }
    return this;
}
function $43087853b829e551$var$_removeAllSchemas(self, schemas, regex) {
    for(var keyRef in schemas){
        var schemaObj = schemas[keyRef];
        if (!schemaObj.meta && (!regex || regex.test(keyRef))) {
            self._cache.del(schemaObj.cacheKey);
            delete schemas[keyRef];
        }
    }
}
/* @this   Ajv */ function $43087853b829e551$var$_addSchema(schema, skipValidation, meta, shouldAddSchema) {
    if (typeof schema != "object" && typeof schema != "boolean") throw new Error("schema should be object or boolean");
    var serialize = this._opts.serialize;
    var cacheKey = serialize ? serialize(schema) : schema;
    var cached = this._cache.get(cacheKey);
    if (cached) return cached;
    shouldAddSchema = shouldAddSchema || this._opts.addUsedSchema !== false;
    var id = $gY6uQ.normalizeId(this._getId(schema));
    if (id && shouldAddSchema) $43087853b829e551$var$checkUnique(this, id);
    var willValidate = this._opts.validateSchema !== false && !skipValidation;
    var recursiveMeta;
    if (willValidate && !(recursiveMeta = id && id == $gY6uQ.normalizeId(schema.$schema))) this.validateSchema(schema, true);
    var localRefs = $gY6uQ.ids.call(this, schema);
    var schemaObj = new $dvpPZ({
        id: id,
        schema: schema,
        localRefs: localRefs,
        cacheKey: cacheKey,
        meta: meta
    });
    if (id[0] != "#" && shouldAddSchema) this._refs[id] = schemaObj;
    this._cache.put(cacheKey, schemaObj);
    if (willValidate && recursiveMeta) this.validateSchema(schema, true);
    return schemaObj;
}
/* @this   Ajv */ function $43087853b829e551$var$_compile(schemaObj, root) {
    if (schemaObj.compiling) {
        schemaObj.validate = callValidate;
        callValidate.schema = schemaObj.schema;
        callValidate.errors = null;
        callValidate.root = root ? root : callValidate;
        if (schemaObj.schema.$async === true) callValidate.$async = true;
        return callValidate;
    }
    schemaObj.compiling = true;
    var currentOpts;
    if (schemaObj.meta) {
        currentOpts = this._opts;
        this._opts = this._metaOpts;
    }
    var v;
    try {
        v = $1sjgr.call(this, schemaObj.schema, root, schemaObj.localRefs);
    } catch (e) {
        delete schemaObj.validate;
        throw e;
    } finally{
        schemaObj.compiling = false;
        if (schemaObj.meta) this._opts = currentOpts;
    }
    schemaObj.validate = v;
    schemaObj.refs = v.refs;
    schemaObj.refVal = v.refVal;
    schemaObj.root = v.root;
    return v;
    /* @this   {*} - custom context, see passContext option */ function callValidate() {
        /* jshint validthis: true */ var _validate = schemaObj.validate;
        var result = _validate.apply(this, arguments);
        callValidate.errors = _validate.errors;
        return result;
    }
}
function $43087853b829e551$var$chooseGetId(opts) {
    switch(opts.schemaId){
        case "auto":
            return $43087853b829e551$var$_get$IdOrId;
        case "id":
            return $43087853b829e551$var$_getId;
        default:
            return $43087853b829e551$var$_get$Id;
    }
}
/* @this   Ajv */ function $43087853b829e551$var$_getId(schema) {
    if (schema.$id) this.logger.warn("schema $id ignored", schema.$id);
    return schema.id;
}
/* @this   Ajv */ function $43087853b829e551$var$_get$Id(schema) {
    if (schema.id) this.logger.warn("schema id ignored", schema.id);
    return schema.$id;
}
function $43087853b829e551$var$_get$IdOrId(schema) {
    if (schema.$id && schema.id && schema.$id != schema.id) throw new Error("schema $id is different from id");
    return schema.$id || schema.id;
}
/**
 * Convert array of error message objects to string
 * @this   Ajv
 * @param  {Array<Object>} errors optional array of validation errors, if not passed errors from the instance are used.
 * @param  {Object} options optional options with properties `separator` and `dataVar`.
 * @return {String} human readable string with all errors descriptions
 */ function $43087853b829e551$var$errorsText(errors, options) {
    errors = errors || this.errors;
    if (!errors) return "No errors";
    options = options || {};
    var separator = options.separator === undefined ? ", " : options.separator;
    var dataVar = options.dataVar === undefined ? "data" : options.dataVar;
    var text = "";
    for(var i = 0; i < errors.length; i++){
        var e = errors[i];
        if (e) text += dataVar + e.dataPath + " " + e.message + separator;
    }
    return text.slice(0, -separator.length);
}
/**
 * Add custom format
 * @this   Ajv
 * @param {String} name format name
 * @param {String|RegExp|Function} format string is converted to RegExp; function should return boolean (true when valid)
 * @return {Ajv} this for method chaining
 */ function $43087853b829e551$var$addFormat(name, format) {
    if (typeof format == "string") format = new RegExp(format);
    this._formats[name] = format;
    return this;
}


function $43087853b829e551$var$addDefaultMetaSchema(self) {
    var $dataSchema;
    if (self._opts.$data) {
        $dataSchema = (parcelRequire("8eKVK"));
        self.addMetaSchema($dataSchema, $dataSchema.$id, true);
    }
    if (self._opts.meta === false) return;
    var metaSchema = (parcelRequire("fLmi3"));
    if (self._opts.$data) metaSchema = $jSQ5p(metaSchema, $43087853b829e551$var$META_SUPPORT_DATA);
    self.addMetaSchema(metaSchema, $43087853b829e551$var$META_SCHEMA_ID, true);
    self._refs["http://json-schema.org/schema"] = $43087853b829e551$var$META_SCHEMA_ID;
}
function $43087853b829e551$var$addInitialSchemas(self) {
    var optsSchemas = self._opts.schemas;
    if (!optsSchemas) return;
    if (Array.isArray(optsSchemas)) self.addSchema(optsSchemas);
    else for(var key in optsSchemas)self.addSchema(optsSchemas[key], key);
}
function $43087853b829e551$var$addInitialFormats(self) {
    for(var name in self._opts.formats){
        var format = self._opts.formats[name];
        self.addFormat(name, format);
    }
}
function $43087853b829e551$var$addInitialKeywords(self) {
    for(var name in self._opts.keywords){
        var keyword = self._opts.keywords[name];
        self.addKeyword(name, keyword);
    }
}
function $43087853b829e551$var$checkUnique(self, id) {
    if (self._schemas[id] || self._refs[id]) throw new Error('schema with key or id "' + id + '" already exists');
}
function $43087853b829e551$var$getMetaSchemaOptions(self) {
    var metaOpts = $lv04s.copy(self._opts);
    for(var i = 0; i < $43087853b829e551$var$META_IGNORE_OPTIONS.length; i++)delete metaOpts[$43087853b829e551$var$META_IGNORE_OPTIONS[i]];
    return metaOpts;
}
function $43087853b829e551$var$setLogger(self) {
    var logger = self._opts.logger;
    if (logger === false) self.logger = {
        log: $43087853b829e551$var$noop,
        warn: $43087853b829e551$var$noop,
        error: $43087853b829e551$var$noop
    };
    else {
        if (logger === undefined) logger = console;
        if (!(typeof logger == "object" && logger.log && logger.warn && logger.error)) throw new Error("logger must implement log, warn and error methods");
        self.logger = logger;
    }
}
function $43087853b829e551$var$noop() {}

});
parcelRegister("1sjgr", function(module, exports) {
"use strict";

var $gY6uQ = parcelRequire("gY6uQ");

var $lv04s = parcelRequire("lv04s");

var $4BeMy = parcelRequire("4BeMy");

var $1FoUm = parcelRequire("1FoUm");

var $dtJDJ = parcelRequire("dtJDJ");
/**
 * Functions below are used inside compiled validations function
 */ var $10f75972eb6b345c$var$ucs2length = $lv04s.ucs2length;

var $7hFx0 = parcelRequire("7hFx0");
// this error is thrown by async schemas to return validation errors via exception
var $10f75972eb6b345c$var$ValidationError = $4BeMy.Validation;
module.exports = $10f75972eb6b345c$var$compile;
/**
 * Compiles schema to validation function
 * @this   Ajv
 * @param  {Object} schema schema object
 * @param  {Object} root object with information about the root schema for this schema
 * @param  {Object} localRefs the hash of local references inside the schema (created by resolve.id), used for inline resolution
 * @param  {String} baseId base ID for IDs in the schema
 * @return {Function} validation function
 */ function $10f75972eb6b345c$var$compile(schema, root, localRefs, baseId) {
    /* jshint validthis: true, evil: true */ /* eslint no-shadow: 0 */ var self = this, opts = this._opts, refVal = [
        undefined
    ], refs = {}, patterns = [], patternsHash = {}, defaults = [], defaultsHash = {}, customRules = [];
    root = root || {
        schema: schema,
        refVal: refVal,
        refs: refs
    };
    var c = $10f75972eb6b345c$var$checkCompiling.call(this, schema, root, baseId);
    var compilation = this._compilations[c.index];
    if (c.compiling) return compilation.callValidate = callValidate;
    var formats = this._formats;
    var RULES = this.RULES;
    try {
        var v = localCompile(schema, root, localRefs, baseId);
        compilation.validate = v;
        var cv = compilation.callValidate;
        if (cv) {
            cv.schema = v.schema;
            cv.errors = null;
            cv.refs = v.refs;
            cv.refVal = v.refVal;
            cv.root = v.root;
            cv.$async = v.$async;
            if (opts.sourceCode) cv.source = v.source;
        }
        return v;
    } finally{
        $10f75972eb6b345c$var$endCompiling.call(this, schema, root, baseId);
    }
    /* @this   {*} - custom context, see passContext option */ function callValidate() {
        /* jshint validthis: true */ var validate = compilation.validate;
        var result = validate.apply(this, arguments);
        callValidate.errors = validate.errors;
        return result;
    }
    function localCompile(_schema, _root, localRefs, baseId) {
        var isRoot = !_root || _root && _root.schema == _schema;
        if (_root.schema != root.schema) return $10f75972eb6b345c$var$compile.call(self, _schema, _root, localRefs, baseId);
        var $async = _schema.$async === true;
        var sourceCode = $dtJDJ({
            isTop: true,
            schema: _schema,
            isRoot: isRoot,
            baseId: baseId,
            root: _root,
            schemaPath: "",
            errSchemaPath: "#",
            errorPath: '""',
            MissingRefError: $4BeMy.MissingRef,
            RULES: RULES,
            validate: $dtJDJ,
            util: $lv04s,
            resolve: $gY6uQ,
            resolveRef: resolveRef,
            usePattern: usePattern,
            useDefault: useDefault,
            useCustomRule: useCustomRule,
            opts: opts,
            formats: formats,
            logger: self.logger,
            self: self
        });
        sourceCode = $10f75972eb6b345c$var$vars(refVal, $10f75972eb6b345c$var$refValCode) + $10f75972eb6b345c$var$vars(patterns, $10f75972eb6b345c$var$patternCode) + $10f75972eb6b345c$var$vars(defaults, $10f75972eb6b345c$var$defaultCode) + $10f75972eb6b345c$var$vars(customRules, $10f75972eb6b345c$var$customRuleCode) + sourceCode;
        if (opts.processCode) sourceCode = opts.processCode(sourceCode, _schema);
        // console.log('\n\n\n *** \n', JSON.stringify(sourceCode));
        var validate;
        try {
            var makeValidate = new Function("self", "RULES", "formats", "root", "refVal", "defaults", "customRules", "equal", "ucs2length", "ValidationError", sourceCode);
            validate = makeValidate(self, RULES, formats, root, refVal, defaults, customRules, $7hFx0, $10f75972eb6b345c$var$ucs2length, $10f75972eb6b345c$var$ValidationError);
            refVal[0] = validate;
        } catch (e) {
            self.logger.error("Error compiling schema, function code:", sourceCode);
            throw e;
        }
        validate.schema = _schema;
        validate.errors = null;
        validate.refs = refs;
        validate.refVal = refVal;
        validate.root = isRoot ? validate : _root;
        if ($async) validate.$async = true;
        if (opts.sourceCode === true) validate.source = {
            code: sourceCode,
            patterns: patterns,
            defaults: defaults
        };
        return validate;
    }
    function resolveRef(baseId, ref, isRoot) {
        ref = $gY6uQ.url(baseId, ref);
        var refIndex = refs[ref];
        var _refVal, refCode;
        if (refIndex !== undefined) {
            _refVal = refVal[refIndex];
            refCode = "refVal[" + refIndex + "]";
            return resolvedRef(_refVal, refCode);
        }
        if (!isRoot && root.refs) {
            var rootRefId = root.refs[ref];
            if (rootRefId !== undefined) {
                _refVal = root.refVal[rootRefId];
                refCode = addLocalRef(ref, _refVal);
                return resolvedRef(_refVal, refCode);
            }
        }
        refCode = addLocalRef(ref);
        var v = $gY6uQ.call(self, localCompile, root, ref);
        if (v === undefined) {
            var localSchema = localRefs && localRefs[ref];
            if (localSchema) v = $gY6uQ.inlineRef(localSchema, opts.inlineRefs) ? localSchema : $10f75972eb6b345c$var$compile.call(self, localSchema, root, localRefs, baseId);
        }
        if (v === undefined) removeLocalRef(ref);
        else {
            replaceLocalRef(ref, v);
            return resolvedRef(v, refCode);
        }
    }
    function addLocalRef(ref, v) {
        var refId = refVal.length;
        refVal[refId] = v;
        refs[ref] = refId;
        return "refVal" + refId;
    }
    function removeLocalRef(ref) {
        delete refs[ref];
    }
    function replaceLocalRef(ref, v) {
        var refId = refs[ref];
        refVal[refId] = v;
    }
    function resolvedRef(refVal, code) {
        return typeof refVal == "object" || typeof refVal == "boolean" ? {
            code: code,
            schema: refVal,
            inline: true
        } : {
            code: code,
            $async: refVal && !!refVal.$async
        };
    }
    function usePattern(regexStr) {
        var index = patternsHash[regexStr];
        if (index === undefined) {
            index = patternsHash[regexStr] = patterns.length;
            patterns[index] = regexStr;
        }
        return "pattern" + index;
    }
    function useDefault(value) {
        switch(typeof value){
            case "boolean":
            case "number":
                return "" + value;
            case "string":
                return $lv04s.toQuotedString(value);
            case "object":
                if (value === null) return "null";
                var valueStr = $1FoUm(value);
                var index = defaultsHash[valueStr];
                if (index === undefined) {
                    index = defaultsHash[valueStr] = defaults.length;
                    defaults[index] = value;
                }
                return "default" + index;
        }
    }
    function useCustomRule(rule, schema, parentSchema, it) {
        if (self._opts.validateSchema !== false) {
            var deps = rule.definition.dependencies;
            if (deps && !deps.every(function(keyword) {
                return Object.prototype.hasOwnProperty.call(parentSchema, keyword);
            })) throw new Error("parent schema must have all required keywords: " + deps.join(","));
            var validateSchema = rule.definition.validateSchema;
            if (validateSchema) {
                var valid = validateSchema(schema);
                if (!valid) {
                    var message = "keyword schema is invalid: " + self.errorsText(validateSchema.errors);
                    if (self._opts.validateSchema == "log") self.logger.error(message);
                    else throw new Error(message);
                }
            }
        }
        var compile = rule.definition.compile, inline = rule.definition.inline, macro = rule.definition.macro;
        var validate;
        if (compile) validate = compile.call(self, schema, parentSchema, it);
        else if (macro) {
            validate = macro.call(self, schema, parentSchema, it);
            if (opts.validateSchema !== false) self.validateSchema(validate, true);
        } else if (inline) validate = inline.call(self, it, rule.keyword, schema, parentSchema);
        else {
            validate = rule.definition.validate;
            if (!validate) return;
        }
        if (validate === undefined) throw new Error('custom keyword "' + rule.keyword + '"failed to compile');
        var index = customRules.length;
        customRules[index] = validate;
        return {
            code: "customRule" + index,
            validate: validate
        };
    }
}
/**
 * Checks if the schema is currently compiled
 * @this   Ajv
 * @param  {Object} schema schema to compile
 * @param  {Object} root root object
 * @param  {String} baseId base schema ID
 * @return {Object} object with properties "index" (compilation index) and "compiling" (boolean)
 */ function $10f75972eb6b345c$var$checkCompiling(schema, root, baseId) {
    /* jshint validthis: true */ var index = $10f75972eb6b345c$var$compIndex.call(this, schema, root, baseId);
    if (index >= 0) return {
        index: index,
        compiling: true
    };
    index = this._compilations.length;
    this._compilations[index] = {
        schema: schema,
        root: root,
        baseId: baseId
    };
    return {
        index: index,
        compiling: false
    };
}
/**
 * Removes the schema from the currently compiled list
 * @this   Ajv
 * @param  {Object} schema schema to compile
 * @param  {Object} root root object
 * @param  {String} baseId base schema ID
 */ function $10f75972eb6b345c$var$endCompiling(schema, root, baseId) {
    /* jshint validthis: true */ var i = $10f75972eb6b345c$var$compIndex.call(this, schema, root, baseId);
    if (i >= 0) this._compilations.splice(i, 1);
}
/**
 * Index of schema compilation in the currently compiled list
 * @this   Ajv
 * @param  {Object} schema schema to compile
 * @param  {Object} root root object
 * @param  {String} baseId base schema ID
 * @return {Integer} compilation index
 */ function $10f75972eb6b345c$var$compIndex(schema, root, baseId) {
    /* jshint validthis: true */ for(var i = 0; i < this._compilations.length; i++){
        var c = this._compilations[i];
        if (c.schema == schema && c.root == root && c.baseId == baseId) return i;
    }
    return -1;
}
function $10f75972eb6b345c$var$patternCode(i, patterns) {
    return "var pattern" + i + " = new RegExp(" + $lv04s.toQuotedString(patterns[i]) + ");";
}
function $10f75972eb6b345c$var$defaultCode(i) {
    return "var default" + i + " = defaults[" + i + "];";
}
function $10f75972eb6b345c$var$refValCode(i, refVal) {
    return refVal[i] === undefined ? "" : "var refVal" + i + " = refVal[" + i + "];";
}
function $10f75972eb6b345c$var$customRuleCode(i) {
    return "var customRule" + i + " = customRules[" + i + "];";
}
function $10f75972eb6b345c$var$vars(arr, statement) {
    if (!arr.length) return "";
    var code = "";
    for(var i = 0; i < arr.length; i++)code += statement(i, arr);
    return code;
}

});
parcelRegister("gY6uQ", function(module, exports) {
"use strict";

var $2h43S = parcelRequire("2h43S");

var $7hFx0 = parcelRequire("7hFx0");

var $lv04s = parcelRequire("lv04s");

var $dvpPZ = parcelRequire("dvpPZ");

var $7dBhG = parcelRequire("7dBhG");
module.exports = $c5a749fc6f1d7187$var$resolve;
$c5a749fc6f1d7187$var$resolve.normalizeId = $c5a749fc6f1d7187$var$normalizeId;
$c5a749fc6f1d7187$var$resolve.fullPath = $c5a749fc6f1d7187$var$getFullPath;
$c5a749fc6f1d7187$var$resolve.url = $c5a749fc6f1d7187$var$resolveUrl;
$c5a749fc6f1d7187$var$resolve.ids = $c5a749fc6f1d7187$var$resolveIds;
$c5a749fc6f1d7187$var$resolve.inlineRef = $c5a749fc6f1d7187$var$inlineRef;
$c5a749fc6f1d7187$var$resolve.schema = $c5a749fc6f1d7187$var$resolveSchema;
/**
 * [resolve and compile the references ($ref)]
 * @this   Ajv
 * @param  {Function} compile reference to schema compilation funciton (localCompile)
 * @param  {Object} root object with information about the root schema for the current schema
 * @param  {String} ref reference to resolve
 * @return {Object|Function} schema object (if the schema can be inlined) or validation function
 */ function $c5a749fc6f1d7187$var$resolve(compile, root, ref) {
    /* jshint validthis: true */ var refVal = this._refs[ref];
    if (typeof refVal == "string") {
        if (this._refs[refVal]) refVal = this._refs[refVal];
        else return $c5a749fc6f1d7187$var$resolve.call(this, compile, root, refVal);
    }
    refVal = refVal || this._schemas[ref];
    if (refVal instanceof $dvpPZ) return $c5a749fc6f1d7187$var$inlineRef(refVal.schema, this._opts.inlineRefs) ? refVal.schema : refVal.validate || this._compile(refVal);
    var res = $c5a749fc6f1d7187$var$resolveSchema.call(this, root, ref);
    var schema, v, baseId;
    if (res) {
        schema = res.schema;
        root = res.root;
        baseId = res.baseId;
    }
    if (schema instanceof $dvpPZ) v = schema.validate || compile.call(this, schema.schema, root, undefined, baseId);
    else if (schema !== undefined) v = $c5a749fc6f1d7187$var$inlineRef(schema, this._opts.inlineRefs) ? schema : compile.call(this, schema, root, undefined, baseId);
    return v;
}
/**
 * Resolve schema, its root and baseId
 * @this Ajv
 * @param  {Object} root root object with properties schema, refVal, refs
 * @param  {String} ref  reference to resolve
 * @return {Object} object with properties schema, root, baseId
 */ function $c5a749fc6f1d7187$var$resolveSchema(root, ref) {
    /* jshint validthis: true */ var p = $2h43S.parse(ref), refPath = $c5a749fc6f1d7187$var$_getFullPath(p), baseId = $c5a749fc6f1d7187$var$getFullPath(this._getId(root.schema));
    if (Object.keys(root.schema).length === 0 || refPath !== baseId) {
        var id = $c5a749fc6f1d7187$var$normalizeId(refPath);
        var refVal = this._refs[id];
        if (typeof refVal == "string") return $c5a749fc6f1d7187$var$resolveRecursive.call(this, root, refVal, p);
        else if (refVal instanceof $dvpPZ) {
            if (!refVal.validate) this._compile(refVal);
            root = refVal;
        } else {
            refVal = this._schemas[id];
            if (refVal instanceof $dvpPZ) {
                if (!refVal.validate) this._compile(refVal);
                if (id == $c5a749fc6f1d7187$var$normalizeId(ref)) return {
                    schema: refVal,
                    root: root,
                    baseId: baseId
                };
                root = refVal;
            } else return;
        }
        if (!root.schema) return;
        baseId = $c5a749fc6f1d7187$var$getFullPath(this._getId(root.schema));
    }
    return $c5a749fc6f1d7187$var$getJsonPointer.call(this, p, baseId, root.schema, root);
}
/* @this Ajv */ function $c5a749fc6f1d7187$var$resolveRecursive(root, ref, parsedRef) {
    /* jshint validthis: true */ var res = $c5a749fc6f1d7187$var$resolveSchema.call(this, root, ref);
    if (res) {
        var schema = res.schema;
        var baseId = res.baseId;
        root = res.root;
        var id = this._getId(schema);
        if (id) baseId = $c5a749fc6f1d7187$var$resolveUrl(baseId, id);
        return $c5a749fc6f1d7187$var$getJsonPointer.call(this, parsedRef, baseId, schema, root);
    }
}
var $c5a749fc6f1d7187$var$PREVENT_SCOPE_CHANGE = $lv04s.toHash([
    "properties",
    "patternProperties",
    "enum",
    "dependencies",
    "definitions"
]);
/* @this Ajv */ function $c5a749fc6f1d7187$var$getJsonPointer(parsedRef, baseId, schema, root) {
    /* jshint validthis: true */ parsedRef.fragment = parsedRef.fragment || "";
    if (parsedRef.fragment.slice(0, 1) != "/") return;
    var parts = parsedRef.fragment.split("/");
    for(var i = 1; i < parts.length; i++){
        var part = parts[i];
        if (part) {
            part = $lv04s.unescapeFragment(part);
            schema = schema[part];
            if (schema === undefined) break;
            var id;
            if (!$c5a749fc6f1d7187$var$PREVENT_SCOPE_CHANGE[part]) {
                id = this._getId(schema);
                if (id) baseId = $c5a749fc6f1d7187$var$resolveUrl(baseId, id);
                if (schema.$ref) {
                    var $ref = $c5a749fc6f1d7187$var$resolveUrl(baseId, schema.$ref);
                    var res = $c5a749fc6f1d7187$var$resolveSchema.call(this, root, $ref);
                    if (res) {
                        schema = res.schema;
                        root = res.root;
                        baseId = res.baseId;
                    }
                }
            }
        }
    }
    if (schema !== undefined && schema !== root.schema) return {
        schema: schema,
        root: root,
        baseId: baseId
    };
}
var $c5a749fc6f1d7187$var$SIMPLE_INLINED = $lv04s.toHash([
    "type",
    "format",
    "pattern",
    "maxLength",
    "minLength",
    "maxProperties",
    "minProperties",
    "maxItems",
    "minItems",
    "maximum",
    "minimum",
    "uniqueItems",
    "multipleOf",
    "required",
    "enum"
]);
function $c5a749fc6f1d7187$var$inlineRef(schema, limit) {
    if (limit === false) return false;
    if (limit === undefined || limit === true) return $c5a749fc6f1d7187$var$checkNoRef(schema);
    else if (limit) return $c5a749fc6f1d7187$var$countKeys(schema) <= limit;
}
function $c5a749fc6f1d7187$var$checkNoRef(schema) {
    var item;
    if (Array.isArray(schema)) for(var i = 0; i < schema.length; i++){
        item = schema[i];
        if (typeof item == "object" && !$c5a749fc6f1d7187$var$checkNoRef(item)) return false;
    }
    else for(var key in schema){
        if (key == "$ref") return false;
        item = schema[key];
        if (typeof item == "object" && !$c5a749fc6f1d7187$var$checkNoRef(item)) return false;
    }
    return true;
}
function $c5a749fc6f1d7187$var$countKeys(schema) {
    var count = 0, item;
    if (Array.isArray(schema)) for(var i = 0; i < schema.length; i++){
        item = schema[i];
        if (typeof item == "object") count += $c5a749fc6f1d7187$var$countKeys(item);
        if (count == Infinity) return Infinity;
    }
    else for(var key in schema){
        if (key == "$ref") return Infinity;
        if ($c5a749fc6f1d7187$var$SIMPLE_INLINED[key]) count++;
        else {
            item = schema[key];
            if (typeof item == "object") count += $c5a749fc6f1d7187$var$countKeys(item) + 1;
            if (count == Infinity) return Infinity;
        }
    }
    return count;
}
function $c5a749fc6f1d7187$var$getFullPath(id, normalize) {
    if (normalize !== false) id = $c5a749fc6f1d7187$var$normalizeId(id);
    var p = $2h43S.parse(id);
    return $c5a749fc6f1d7187$var$_getFullPath(p);
}
function $c5a749fc6f1d7187$var$_getFullPath(p) {
    return $2h43S.serialize(p).split("#")[0] + "#";
}
var $c5a749fc6f1d7187$var$TRAILING_SLASH_HASH = /#\/?$/;
function $c5a749fc6f1d7187$var$normalizeId(id) {
    return id ? id.replace($c5a749fc6f1d7187$var$TRAILING_SLASH_HASH, "") : "";
}
function $c5a749fc6f1d7187$var$resolveUrl(baseId, id) {
    id = $c5a749fc6f1d7187$var$normalizeId(id);
    return $2h43S.resolve(baseId, id);
}
/* @this Ajv */ function $c5a749fc6f1d7187$var$resolveIds(schema) {
    var schemaId = $c5a749fc6f1d7187$var$normalizeId(this._getId(schema));
    var baseIds = {
        "": schemaId
    };
    var fullPaths = {
        "": $c5a749fc6f1d7187$var$getFullPath(schemaId, false)
    };
    var localRefs = {};
    var self = this;
    $7dBhG(schema, {
        allKeys: true
    }, function(sch, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex) {
        if (jsonPtr === "") return;
        var id = self._getId(sch);
        var baseId = baseIds[parentJsonPtr];
        var fullPath = fullPaths[parentJsonPtr] + "/" + parentKeyword;
        if (keyIndex !== undefined) fullPath += "/" + (typeof keyIndex == "number" ? keyIndex : $lv04s.escapeFragment(keyIndex));
        if (typeof id == "string") {
            id = baseId = $c5a749fc6f1d7187$var$normalizeId(baseId ? $2h43S.resolve(baseId, id) : id);
            var refVal = self._refs[id];
            if (typeof refVal == "string") refVal = self._refs[refVal];
            if (refVal && refVal.schema) {
                if (!$7hFx0(sch, refVal.schema)) throw new Error('id "' + id + '" resolves to more than one schema');
            } else if (id != $c5a749fc6f1d7187$var$normalizeId(fullPath)) {
                if (id[0] == "#") {
                    if (localRefs[id] && !$7hFx0(sch, localRefs[id])) throw new Error('id "' + id + '" resolves to more than one schema');
                    localRefs[id] = sch;
                } else self._refs[id] = fullPath;
            }
        }
        baseIds[jsonPtr] = baseId;
        fullPaths[jsonPtr] = fullPath;
    });
    return localRefs;
}

});
parcelRegister("2h43S", function(module, exports) {
/** @license URI.js v4.4.1 (c) 2011 Gary Court. License: http://github.com/garycourt/uri-js */ (function(global, factory) {
    factory(module.exports);
})(module.exports, function(exports1) {
    "use strict";
    function merge() {
        for(var _len = arguments.length, sets = Array(_len), _key = 0; _key < _len; _key++)sets[_key] = arguments[_key];
        if (sets.length > 1) {
            sets[0] = sets[0].slice(0, -1);
            var xl = sets.length - 1;
            for(var x = 1; x < xl; ++x)sets[x] = sets[x].slice(1, -1);
            sets[xl] = sets[xl].slice(1);
            return sets.join("");
        } else return sets[0];
    }
    function subexp(str) {
        return "(?:" + str + ")";
    }
    function typeOf(o) {
        return o === undefined ? "undefined" : o === null ? "null" : Object.prototype.toString.call(o).split(" ").pop().split("]").shift().toLowerCase();
    }
    function toUpperCase(str) {
        return str.toUpperCase();
    }
    function toArray(obj) {
        return obj !== undefined && obj !== null ? obj instanceof Array ? obj : typeof obj.length !== "number" || obj.split || obj.setInterval || obj.call ? [
            obj
        ] : Array.prototype.slice.call(obj) : [];
    }
    function assign(target, source) {
        var obj = target;
        if (source) for(var key in source)obj[key] = source[key];
        return obj;
    }
    function buildExps(isIRI) {
        var ALPHA$$ = "[A-Za-z]", CR$ = "[\\x0D]", DIGIT$$ = "[0-9]", DQUOTE$$ = "[\\x22]", HEXDIG$$ = merge(DIGIT$$, "[A-Fa-f]"), //case-insensitive
        LF$$ = "[\\x0A]", SP$$ = "[\\x20]", PCT_ENCODED$ = subexp(subexp("%[EFef]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%[89A-Fa-f]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%" + HEXDIG$$ + HEXDIG$$)), //expanded
        GEN_DELIMS$$ = "[\\:\\/\\?\\#\\[\\]\\@]", SUB_DELIMS$$ = "[\\!\\$\\&\\'\\(\\)\\*\\+\\,\\;\\=]", RESERVED$$ = merge(GEN_DELIMS$$, SUB_DELIMS$$), UCSCHAR$$ = isIRI ? "[\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]" : "[]", //subset, excludes bidi control characters
        IPRIVATE$$ = isIRI ? "[\\uE000-\\uF8FF]" : "[]", //subset
        UNRESERVED$$ = merge(ALPHA$$, DIGIT$$, "[\\-\\.\\_\\~]", UCSCHAR$$), SCHEME$ = subexp(ALPHA$$ + merge(ALPHA$$, DIGIT$$, "[\\+\\-\\.]") + "*"), USERINFO$ = subexp(subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\:]")) + "*"), DEC_OCTET$ = subexp(subexp("25[0-5]") + "|" + subexp("2[0-4]" + DIGIT$$) + "|" + subexp("1" + DIGIT$$ + DIGIT$$) + "|" + subexp("[1-9]" + DIGIT$$) + "|" + DIGIT$$), DEC_OCTET_RELAXED$ = subexp(subexp("25[0-5]") + "|" + subexp("2[0-4]" + DIGIT$$) + "|" + subexp("1" + DIGIT$$ + DIGIT$$) + "|" + subexp("0?[1-9]" + DIGIT$$) + "|0?0?" + DIGIT$$), //relaxed parsing rules
        IPV4ADDRESS$ = subexp(DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$ + "\\." + DEC_OCTET_RELAXED$), H16$ = subexp(HEXDIG$$ + "{1,4}"), LS32$ = subexp(subexp(H16$ + "\\:" + H16$) + "|" + IPV4ADDRESS$), IPV6ADDRESS1$ = subexp(subexp(H16$ + "\\:") + "{6}" + LS32$), //                           6( h16 ":" ) ls32
        IPV6ADDRESS2$ = subexp("\\:\\:" + subexp(H16$ + "\\:") + "{5}" + LS32$), //                      "::" 5( h16 ":" ) ls32
        IPV6ADDRESS3$ = subexp(subexp(H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{4}" + LS32$), //[               h16 ] "::" 4( h16 ":" ) ls32
        IPV6ADDRESS4$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,1}" + H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{3}" + LS32$), //[ *1( h16 ":" ) h16 ] "::" 3( h16 ":" ) ls32
        IPV6ADDRESS5$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,2}" + H16$) + "?\\:\\:" + subexp(H16$ + "\\:") + "{2}" + LS32$), //[ *2( h16 ":" ) h16 ] "::" 2( h16 ":" ) ls32
        IPV6ADDRESS6$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,3}" + H16$) + "?\\:\\:" + H16$ + "\\:" + LS32$), //[ *3( h16 ":" ) h16 ] "::"    h16 ":"   ls32
        IPV6ADDRESS7$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,4}" + H16$) + "?\\:\\:" + LS32$), //[ *4( h16 ":" ) h16 ] "::"              ls32
        IPV6ADDRESS8$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,5}" + H16$) + "?\\:\\:" + H16$), //[ *5( h16 ":" ) h16 ] "::"              h16
        IPV6ADDRESS9$ = subexp(subexp(subexp(H16$ + "\\:") + "{0,6}" + H16$) + "?\\:\\:"), //[ *6( h16 ":" ) h16 ] "::"
        IPV6ADDRESS$ = subexp([
            IPV6ADDRESS1$,
            IPV6ADDRESS2$,
            IPV6ADDRESS3$,
            IPV6ADDRESS4$,
            IPV6ADDRESS5$,
            IPV6ADDRESS6$,
            IPV6ADDRESS7$,
            IPV6ADDRESS8$,
            IPV6ADDRESS9$
        ].join("|")), ZONEID$ = subexp(subexp(UNRESERVED$$ + "|" + PCT_ENCODED$) + "+"), //RFC 6874
        IPV6ADDRZ$ = subexp(IPV6ADDRESS$ + "\\%25" + ZONEID$), //RFC 6874
        IPV6ADDRZ_RELAXED$ = subexp(IPV6ADDRESS$ + subexp("\\%25|\\%(?!" + HEXDIG$$ + "{2})") + ZONEID$), //RFC 6874, with relaxed parsing rules
        IPVFUTURE$ = subexp("[vV]" + HEXDIG$$ + "+\\." + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\:]") + "+"), IP_LITERAL$ = subexp("\\[" + subexp(IPV6ADDRZ_RELAXED$ + "|" + IPV6ADDRESS$ + "|" + IPVFUTURE$) + "\\]"), //RFC 6874
        REG_NAME$ = subexp(subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$)) + "*"), HOST$ = subexp(IP_LITERAL$ + "|" + IPV4ADDRESS$ + "(?!" + REG_NAME$ + ")" + "|" + REG_NAME$), PORT$ = subexp(DIGIT$$ + "*"), AUTHORITY$ = subexp(subexp(USERINFO$ + "@") + "?" + HOST$ + subexp("\\:" + PORT$) + "?"), PCHAR$ = subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\:\\@]")), SEGMENT$ = subexp(PCHAR$ + "*"), SEGMENT_NZ$ = subexp(PCHAR$ + "+"), SEGMENT_NZ_NC$ = subexp(subexp(PCT_ENCODED$ + "|" + merge(UNRESERVED$$, SUB_DELIMS$$, "[\\@]")) + "+"), PATH_ABEMPTY$ = subexp(subexp("\\/" + SEGMENT$) + "*"), PATH_ABSOLUTE$ = subexp("\\/" + subexp(SEGMENT_NZ$ + PATH_ABEMPTY$) + "?"), //simplified
        PATH_NOSCHEME$ = subexp(SEGMENT_NZ_NC$ + PATH_ABEMPTY$), //simplified
        PATH_ROOTLESS$ = subexp(SEGMENT_NZ$ + PATH_ABEMPTY$), //simplified
        PATH_EMPTY$ = "(?!" + PCHAR$ + ")", PATH$ = subexp(PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$), QUERY$ = subexp(subexp(PCHAR$ + "|" + merge("[\\/\\?]", IPRIVATE$$)) + "*"), FRAGMENT$ = subexp(subexp(PCHAR$ + "|[\\/\\?]") + "*"), HIER_PART$ = subexp(subexp("\\/\\/" + AUTHORITY$ + PATH_ABEMPTY$) + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$), URI$ = subexp(SCHEME$ + "\\:" + HIER_PART$ + subexp("\\?" + QUERY$) + "?" + subexp("\\#" + FRAGMENT$) + "?"), RELATIVE_PART$ = subexp(subexp("\\/\\/" + AUTHORITY$ + PATH_ABEMPTY$) + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_EMPTY$), RELATIVE$ = subexp(RELATIVE_PART$ + subexp("\\?" + QUERY$) + "?" + subexp("\\#" + FRAGMENT$) + "?"), URI_REFERENCE$ = subexp(URI$ + "|" + RELATIVE$), ABSOLUTE_URI$ = subexp(SCHEME$ + "\\:" + HIER_PART$ + subexp("\\?" + QUERY$) + "?"), GENERIC_REF$ = "^(" + SCHEME$ + ")\\:" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?" + subexp("\\#(" + FRAGMENT$ + ")") + "?$", RELATIVE_REF$ = "^(){0}" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_NOSCHEME$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?" + subexp("\\#(" + FRAGMENT$ + ")") + "?$", ABSOLUTE_REF$ = "^(" + SCHEME$ + ")\\:" + subexp(subexp("\\/\\/(" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?)") + "?(" + PATH_ABEMPTY$ + "|" + PATH_ABSOLUTE$ + "|" + PATH_ROOTLESS$ + "|" + PATH_EMPTY$ + ")") + subexp("\\?(" + QUERY$ + ")") + "?$", SAMEDOC_REF$ = "^" + subexp("\\#(" + FRAGMENT$ + ")") + "?$", AUTHORITY_REF$ = "^" + subexp("(" + USERINFO$ + ")@") + "?(" + HOST$ + ")" + subexp("\\:(" + PORT$ + ")") + "?$";
        return {
            NOT_SCHEME: new RegExp(merge("[^]", ALPHA$$, DIGIT$$, "[\\+\\-\\.]"), "g"),
            NOT_USERINFO: new RegExp(merge("[^\\%\\:]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            NOT_HOST: new RegExp(merge("[^\\%\\[\\]\\:]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            NOT_PATH: new RegExp(merge("[^\\%\\/\\:\\@]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            NOT_PATH_NOSCHEME: new RegExp(merge("[^\\%\\/\\@]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            NOT_QUERY: new RegExp(merge("[^\\%]", UNRESERVED$$, SUB_DELIMS$$, "[\\:\\@\\/\\?]", IPRIVATE$$), "g"),
            NOT_FRAGMENT: new RegExp(merge("[^\\%]", UNRESERVED$$, SUB_DELIMS$$, "[\\:\\@\\/\\?]"), "g"),
            ESCAPE: new RegExp(merge("[^]", UNRESERVED$$, SUB_DELIMS$$), "g"),
            UNRESERVED: new RegExp(UNRESERVED$$, "g"),
            OTHER_CHARS: new RegExp(merge("[^\\%]", UNRESERVED$$, RESERVED$$), "g"),
            PCT_ENCODED: new RegExp(PCT_ENCODED$, "g"),
            IPV4ADDRESS: new RegExp("^(" + IPV4ADDRESS$ + ")$"),
            IPV6ADDRESS: new RegExp("^\\[?(" + IPV6ADDRESS$ + ")" + subexp(subexp("\\%25|\\%(?!" + HEXDIG$$ + "{2})") + "(" + ZONEID$ + ")") + "?\\]?$") //RFC 6874, with relaxed parsing rules
        };
    }
    var URI_PROTOCOL = buildExps(false);
    var IRI_PROTOCOL = buildExps(true);
    var slicedToArray = function() {
        function sliceIterator(arr, i) {
            var _arr = [];
            var _n = true;
            var _d = false;
            var _e = undefined;
            try {
                for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                    _arr.push(_s.value);
                    if (i && _arr.length === i) break;
                }
            } catch (err) {
                _d = true;
                _e = err;
            } finally{
                try {
                    if (!_n && _i["return"]) _i["return"]();
                } finally{
                    if (_d) throw _e;
                }
            }
            return _arr;
        }
        return function(arr, i) {
            if (Array.isArray(arr)) return arr;
            else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
            else throw new TypeError("Invalid attempt to destructure non-iterable instance");
        };
    }();
    var toConsumableArray = function(arr) {
        if (Array.isArray(arr)) {
            for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
            return arr2;
        } else return Array.from(arr);
    };
    /** Highest positive signed 32-bit float value */ var maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
    /** Bootstring parameters */ var base = 36;
    var tMin = 1;
    var tMax = 26;
    var skew = 38;
    var damp = 700;
    var initialBias = 72;
    var initialN = 128; // 0x80
    var delimiter = "-"; // '\x2D'
    /** Regular expressions */ var regexPunycode = /^xn--/;
    var regexNonASCII = /[^\0-\x7E]/; // non-ASCII chars
    var regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
    /** Error messages */ var errors = {
        "overflow": "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
    };
    /** Convenience shortcuts */ var baseMinusTMin = base - tMin;
    var floor = Math.floor;
    var stringFromCharCode = String.fromCharCode;
    /*--------------------------------------------------------------------------*/ /**
 * A generic error utility function.
 * @private
 * @param {String} type The error type.
 * @returns {Error} Throws a `RangeError` with the applicable error message.
 */ function error$1(type) {
        throw new RangeError(errors[type]);
    }
    /**
 * A generic `Array#map` utility function.
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} callback The function that gets called for every array
 * item.
 * @returns {Array} A new array of values returned by the callback function.
 */ function map(array, fn) {
        var result = [];
        var length = array.length;
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @private
 * @param {String} domain The domain name or email address.
 * @param {Function} callback The function that gets called for every
 * character.
 * @returns {Array} A new string of characters returned by the callback
 * function.
 */ function mapDomain(string, fn) {
        var parts = string.split("@");
        var result = "";
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + "@";
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, ".");
        var labels = string.split(".");
        var encoded = map(labels, fn).join(".");
        return result + encoded;
    }
    /**
 * Creates an array containing the numeric code points of each Unicode
 * character in the string. While JavaScript uses UCS-2 internally,
 * this function will convert a pair of surrogate halves (each of which
 * UCS-2 exposes as separate characters) into a single code point,
 * matching UTF-16.
 * @see `punycode.ucs2.encode`
 * @see <https://mathiasbynens.be/notes/javascript-encoding>
 * @memberOf punycode.ucs2
 * @name decode
 * @param {String} string The Unicode input string (UCS-2).
 * @returns {Array} The new array of code points.
 */ function ucs2decode(string) {
        var output = [];
        var counter = 0;
        var length = string.length;
        while(counter < length){
            var value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // It's a high surrogate, and there is a next character.
                var extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) // Low surrogate.
                output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // It's an unmatched surrogate; only append this code unit, in case the
                    // next code unit is the high surrogate of a surrogate pair.
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
 * Creates a string based on an array of numeric code points.
 * @see `punycode.ucs2.decode`
 * @memberOf punycode.ucs2
 * @name encode
 * @param {Array} codePoints The array of numeric code points.
 * @returns {String} The new Unicode string (UCS-2).
 */ var ucs2encode = function ucs2encode(array) {
        return String.fromCodePoint.apply(String, toConsumableArray(array));
    };
    /**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @private
 * @param {Number} codePoint The basic numeric code point value.
 * @returns {Number} The numeric value of a basic code point (for use in
 * representing integers) in the range `0` to `base - 1`, or `base` if
 * the code point does not represent a value.
 */ var basicToDigit = function basicToDigit(codePoint) {
        if (codePoint - 0x30 < 0x0A) return codePoint - 0x16;
        if (codePoint - 0x41 < 0x1A) return codePoint - 0x41;
        if (codePoint - 0x61 < 0x1A) return codePoint - 0x61;
        return base;
    };
    /**
 * Converts a digit/integer into a basic code point.
 * @see `basicToDigit()`
 * @private
 * @param {Number} digit The numeric value of a basic code point.
 * @returns {Number} The basic code point whose value (when used for
 * representing integers) is `digit`, which needs to be in the range
 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
 * used; else, the lowercase form is used. The behavior is undefined
 * if `flag` is non-zero and `digit` has no uppercase form.
 */ var digitToBasic = function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    };
    /**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @private
 */ var adapt = function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    };
    /**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @memberOf punycode
 * @param {String} input The Punycode string of ASCII-only symbols.
 * @returns {String} The resulting string of Unicode symbols.
 */ var decode = function decode(input) {
        // Don't use UCS-2.
        var output = [];
        var inputLength = input.length;
        var i = 0;
        var n = initialN;
        var bias = initialBias;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        var basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(var j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error$1("not-basic");
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(var index = basic > 0 ? basic + 1 : 0; index < inputLength;)/* no final expression */ {
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            var oldi = i;
            for(var w = 1, k = base;; k += base){
                if (index >= inputLength) error$1("invalid-input");
                var digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error$1("overflow");
                i += digit * w;
                var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                var baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error$1("overflow");
                w *= baseMinusT;
            }
            var out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error$1("overflow");
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output.
            output.splice(i++, 0, n);
        }
        return String.fromCodePoint.apply(String, output);
    };
    /**
 * Converts a string of Unicode symbols (e.g. a domain name label) to a
 * Punycode string of ASCII-only symbols.
 * @memberOf punycode
 * @param {String} input The string of Unicode symbols.
 * @returns {String} The resulting Punycode string of ASCII-only symbols.
 */ var encode = function encode(input) {
        var output = [];
        // Convert the input in UCS-2 to an array of Unicode code points.
        input = ucs2decode(input);
        // Cache the length.
        var inputLength = input.length;
        // Initialize the state.
        var n = initialN;
        var delta = 0;
        var bias = initialBias;
        // Handle the basic code points.
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;
        try {
            for(var _iterator = input[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _currentValue2 = _step.value;
                if (_currentValue2 < 0x80) output.push(stringFromCharCode(_currentValue2));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
            } finally{
                if (_didIteratorError) throw _iteratorError;
            }
        }
        var basicLength = output.length;
        var handledCPCount = basicLength;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string with a delimiter unless it's empty.
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            var m = maxInt;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;
            try {
                for(var _iterator2 = input[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                    var currentValue = _step2.value;
                    if (currentValue >= n && currentValue < m) m = currentValue;
                }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow.
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) _iterator2.return();
                } finally{
                    if (_didIteratorError2) throw _iteratorError2;
                }
            }
            var handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error$1("overflow");
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            var _iteratorNormalCompletion3 = true;
            var _didIteratorError3 = false;
            var _iteratorError3 = undefined;
            try {
                for(var _iterator3 = input[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                    var _currentValue = _step3.value;
                    if (_currentValue < n && ++delta > maxInt) error$1("overflow");
                    if (_currentValue == n) {
                        // Represent delta as a generalized variable-length integer.
                        var q = delta;
                        for(var k = base;; k += base){
                            var t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                            if (q < t) break;
                            var qMinusT = q - t;
                            var baseMinusT = base - t;
                            output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                            q = floor(qMinusT / baseMinusT);
                        }
                        output.push(stringFromCharCode(digitToBasic(q, 0)));
                        bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                        delta = 0;
                        ++handledCPCount;
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) _iterator3.return();
                } finally{
                    if (_didIteratorError3) throw _iteratorError3;
                }
            }
            ++delta;
            ++n;
        }
        return output.join("");
    };
    /**
 * Converts a Punycode string representing a domain name or an email address
 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
 * it doesn't matter if you call it on a string that has already been
 * converted to Unicode.
 * @memberOf punycode
 * @param {String} input The Punycoded domain name or email address to
 * convert to Unicode.
 * @returns {String} The Unicode representation of the given Punycode
 * string.
 */ var toUnicode = function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    };
    /**
 * Converts a Unicode string representing a domain name or an email address to
 * Punycode. Only the non-ASCII parts of the domain name will be converted,
 * i.e. it doesn't matter if you call it with a domain that's already in
 * ASCII.
 * @memberOf punycode
 * @param {String} input The domain name or email address to convert, as a
 * Unicode string.
 * @returns {String} The Punycode representation of the given domain name or
 * email address.
 */ var toASCII = function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
        });
    };
    /*--------------------------------------------------------------------------*/ /** Define the public API */ var punycode = {
        /**
  * A string representing the current Punycode.js version number.
  * @memberOf punycode
  * @type String
  */ "version": "2.1.0",
        /**
  * An object of methods to convert from JavaScript's internal character
  * representation (UCS-2) to Unicode code points, and back.
  * @see <https://mathiasbynens.be/notes/javascript-encoding>
  * @memberOf punycode
  * @type Object
  */ "ucs2": {
            "decode": ucs2decode,
            "encode": ucs2encode
        },
        "decode": decode,
        "encode": encode,
        "toASCII": toASCII,
        "toUnicode": toUnicode
    };
    /**
 * URI.js
 *
 * @fileoverview An RFC 3986 compliant, scheme extendable URI parsing/validating/resolving library for JavaScript.
 * @author <a href="mailto:gary.court@gmail.com">Gary Court</a>
 * @see http://github.com/garycourt/uri-js
 */ /**
 * Copyright 2011 Gary Court. All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without modification, are
 * permitted provided that the following conditions are met:
 *
 *    1. Redistributions of source code must retain the above copyright notice, this list of
 *       conditions and the following disclaimer.
 *
 *    2. Redistributions in binary form must reproduce the above copyright notice, this list
 *       of conditions and the following disclaimer in the documentation and/or other materials
 *       provided with the distribution.
 *
 * THIS SOFTWARE IS PROVIDED BY GARY COURT ``AS IS'' AND ANY EXPRESS OR IMPLIED
 * WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND
 * FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL GARY COURT OR
 * CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR
 * SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON
 * ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
 * NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF
 * ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * The views and conclusions contained in the software and documentation are those of the
 * authors and should not be interpreted as representing official policies, either expressed
 * or implied, of Gary Court.
 */ var SCHEMES = {};
    function pctEncChar(chr) {
        var c = chr.charCodeAt(0);
        var e = void 0;
        if (c < 16) e = "%0" + c.toString(16).toUpperCase();
        else if (c < 128) e = "%" + c.toString(16).toUpperCase();
        else if (c < 2048) e = "%" + (c >> 6 | 192).toString(16).toUpperCase() + "%" + (c & 63 | 128).toString(16).toUpperCase();
        else e = "%" + (c >> 12 | 224).toString(16).toUpperCase() + "%" + (c >> 6 & 63 | 128).toString(16).toUpperCase() + "%" + (c & 63 | 128).toString(16).toUpperCase();
        return e;
    }
    function pctDecChars(str) {
        var newStr = "";
        var i = 0;
        var il = str.length;
        while(i < il){
            var c = parseInt(str.substr(i + 1, 2), 16);
            if (c < 128) {
                newStr += String.fromCharCode(c);
                i += 3;
            } else if (c >= 194 && c < 224) {
                if (il - i >= 6) {
                    var c2 = parseInt(str.substr(i + 4, 2), 16);
                    newStr += String.fromCharCode((c & 31) << 6 | c2 & 63);
                } else newStr += str.substr(i, 6);
                i += 6;
            } else if (c >= 224) {
                if (il - i >= 9) {
                    var _c = parseInt(str.substr(i + 4, 2), 16);
                    var c3 = parseInt(str.substr(i + 7, 2), 16);
                    newStr += String.fromCharCode((c & 15) << 12 | (_c & 63) << 6 | c3 & 63);
                } else newStr += str.substr(i, 9);
                i += 9;
            } else {
                newStr += str.substr(i, 3);
                i += 3;
            }
        }
        return newStr;
    }
    function _normalizeComponentEncoding(components, protocol) {
        function decodeUnreserved(str) {
            var decStr = pctDecChars(str);
            return !decStr.match(protocol.UNRESERVED) ? str : decStr;
        }
        if (components.scheme) components.scheme = String(components.scheme).replace(protocol.PCT_ENCODED, decodeUnreserved).toLowerCase().replace(protocol.NOT_SCHEME, "");
        if (components.userinfo !== undefined) components.userinfo = String(components.userinfo).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(protocol.NOT_USERINFO, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.host !== undefined) components.host = String(components.host).replace(protocol.PCT_ENCODED, decodeUnreserved).toLowerCase().replace(protocol.NOT_HOST, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.path !== undefined) components.path = String(components.path).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(components.scheme ? protocol.NOT_PATH : protocol.NOT_PATH_NOSCHEME, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.query !== undefined) components.query = String(components.query).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(protocol.NOT_QUERY, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        if (components.fragment !== undefined) components.fragment = String(components.fragment).replace(protocol.PCT_ENCODED, decodeUnreserved).replace(protocol.NOT_FRAGMENT, pctEncChar).replace(protocol.PCT_ENCODED, toUpperCase);
        return components;
    }
    function _stripLeadingZeros(str) {
        return str.replace(/^0*(.*)/, "$1") || "0";
    }
    function _normalizeIPv4(host, protocol) {
        var matches = host.match(protocol.IPV4ADDRESS) || [];
        var _matches = slicedToArray(matches, 2), address = _matches[1];
        if (address) return address.split(".").map(_stripLeadingZeros).join(".");
        else return host;
    }
    function _normalizeIPv6(host, protocol) {
        var matches = host.match(protocol.IPV6ADDRESS) || [];
        var _matches2 = slicedToArray(matches, 3), address = _matches2[1], zone = _matches2[2];
        if (address) {
            var _address$toLowerCase$ = address.toLowerCase().split("::").reverse(), _address$toLowerCase$2 = slicedToArray(_address$toLowerCase$, 2), last = _address$toLowerCase$2[0], first = _address$toLowerCase$2[1];
            var firstFields = first ? first.split(":").map(_stripLeadingZeros) : [];
            var lastFields = last.split(":").map(_stripLeadingZeros);
            var isLastFieldIPv4Address = protocol.IPV4ADDRESS.test(lastFields[lastFields.length - 1]);
            var fieldCount = isLastFieldIPv4Address ? 7 : 8;
            var lastFieldsStart = lastFields.length - fieldCount;
            var fields = Array(fieldCount);
            for(var x = 0; x < fieldCount; ++x)fields[x] = firstFields[x] || lastFields[lastFieldsStart + x] || "";
            if (isLastFieldIPv4Address) fields[fieldCount - 1] = _normalizeIPv4(fields[fieldCount - 1], protocol);
            var allZeroFields = fields.reduce(function(acc, field, index) {
                if (!field || field === "0") {
                    var lastLongest = acc[acc.length - 1];
                    if (lastLongest && lastLongest.index + lastLongest.length === index) lastLongest.length++;
                    else acc.push({
                        index: index,
                        length: 1
                    });
                }
                return acc;
            }, []);
            var longestZeroFields = allZeroFields.sort(function(a, b) {
                return b.length - a.length;
            })[0];
            var newHost = void 0;
            if (longestZeroFields && longestZeroFields.length > 1) {
                var newFirst = fields.slice(0, longestZeroFields.index);
                var newLast = fields.slice(longestZeroFields.index + longestZeroFields.length);
                newHost = newFirst.join(":") + "::" + newLast.join(":");
            } else newHost = fields.join(":");
            if (zone) newHost += "%" + zone;
            return newHost;
        } else return host;
    }
    var URI_PARSE = /^(?:([^:\/?#]+):)?(?:\/\/((?:([^\/?#@]*)@)?(\[[^\/?#\]]+\]|[^\/?#:]*)(?:\:(\d*))?))?([^?#]*)(?:\?([^#]*))?(?:#((?:.|\n|\r)*))?/i;
    var NO_MATCH_IS_UNDEFINED = "".match(/(){0}/)[1] === undefined;
    function parse(uriString) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var components = {};
        var protocol = options.iri !== false ? IRI_PROTOCOL : URI_PROTOCOL;
        if (options.reference === "suffix") uriString = (options.scheme ? options.scheme + ":" : "") + "//" + uriString;
        var matches = uriString.match(URI_PARSE);
        if (matches) {
            if (NO_MATCH_IS_UNDEFINED) {
                //store each component
                components.scheme = matches[1];
                components.userinfo = matches[3];
                components.host = matches[4];
                components.port = parseInt(matches[5], 10);
                components.path = matches[6] || "";
                components.query = matches[7];
                components.fragment = matches[8];
                //fix port number
                if (isNaN(components.port)) components.port = matches[5];
            } else {
                //IE FIX for improper RegExp matching
                //store each component
                components.scheme = matches[1] || undefined;
                components.userinfo = uriString.indexOf("@") !== -1 ? matches[3] : undefined;
                components.host = uriString.indexOf("//") !== -1 ? matches[4] : undefined;
                components.port = parseInt(matches[5], 10);
                components.path = matches[6] || "";
                components.query = uriString.indexOf("?") !== -1 ? matches[7] : undefined;
                components.fragment = uriString.indexOf("#") !== -1 ? matches[8] : undefined;
                //fix port number
                if (isNaN(components.port)) components.port = uriString.match(/\/\/(?:.|\n)*\:(?:\/|\?|\#|$)/) ? matches[4] : undefined;
            }
            if (components.host) //normalize IP hosts
            components.host = _normalizeIPv6(_normalizeIPv4(components.host, protocol), protocol);
            //determine reference type
            if (components.scheme === undefined && components.userinfo === undefined && components.host === undefined && components.port === undefined && !components.path && components.query === undefined) components.reference = "same-document";
            else if (components.scheme === undefined) components.reference = "relative";
            else if (components.fragment === undefined) components.reference = "absolute";
            else components.reference = "uri";
            //check for reference errors
            if (options.reference && options.reference !== "suffix" && options.reference !== components.reference) components.error = components.error || "URI is not a " + options.reference + " reference.";
            //find scheme handler
            var schemeHandler = SCHEMES[(options.scheme || components.scheme || "").toLowerCase()];
            //check if scheme can't handle IRIs
            if (!options.unicodeSupport && (!schemeHandler || !schemeHandler.unicodeSupport)) {
                //if host component is a domain name
                if (components.host && (options.domainHost || schemeHandler && schemeHandler.domainHost)) //convert Unicode IDN -> ASCII IDN
                try {
                    components.host = punycode.toASCII(components.host.replace(protocol.PCT_ENCODED, pctDecChars).toLowerCase());
                } catch (e) {
                    components.error = components.error || "Host's domain name can not be converted to ASCII via punycode: " + e;
                }
                //convert IRI -> URI
                _normalizeComponentEncoding(components, URI_PROTOCOL);
            } else //normalize encodings
            _normalizeComponentEncoding(components, protocol);
            //perform scheme specific parsing
            if (schemeHandler && schemeHandler.parse) schemeHandler.parse(components, options);
        } else components.error = components.error || "URI can not be parsed.";
        return components;
    }
    function _recomposeAuthority(components, options) {
        var protocol = options.iri !== false ? IRI_PROTOCOL : URI_PROTOCOL;
        var uriTokens = [];
        if (components.userinfo !== undefined) {
            uriTokens.push(components.userinfo);
            uriTokens.push("@");
        }
        if (components.host !== undefined) //normalize IP hosts, add brackets and escape zone separator for IPv6
        uriTokens.push(_normalizeIPv6(_normalizeIPv4(String(components.host), protocol), protocol).replace(protocol.IPV6ADDRESS, function(_, $1, $2) {
            return "[" + $1 + ($2 ? "%25" + $2 : "") + "]";
        }));
        if (typeof components.port === "number" || typeof components.port === "string") {
            uriTokens.push(":");
            uriTokens.push(String(components.port));
        }
        return uriTokens.length ? uriTokens.join("") : undefined;
    }
    var RDS1 = /^\.\.?\//;
    var RDS2 = /^\/\.(\/|$)/;
    var RDS3 = /^\/\.\.(\/|$)/;
    var RDS5 = /^\/?(?:.|\n)*?(?=\/|$)/;
    function removeDotSegments(input) {
        var output = [];
        while(input.length){
            if (input.match(RDS1)) input = input.replace(RDS1, "");
            else if (input.match(RDS2)) input = input.replace(RDS2, "/");
            else if (input.match(RDS3)) {
                input = input.replace(RDS3, "/");
                output.pop();
            } else if (input === "." || input === "..") input = "";
            else {
                var im = input.match(RDS5);
                if (im) {
                    var s = im[0];
                    input = input.slice(s.length);
                    output.push(s);
                } else throw new Error("Unexpected dot segment condition");
            }
        }
        return output.join("");
    }
    function serialize(components) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var protocol = options.iri ? IRI_PROTOCOL : URI_PROTOCOL;
        var uriTokens = [];
        //find scheme handler
        var schemeHandler = SCHEMES[(options.scheme || components.scheme || "").toLowerCase()];
        //perform scheme specific serialization
        if (schemeHandler && schemeHandler.serialize) schemeHandler.serialize(components, options);
        if (components.host) {
            //if host component is an IPv6 address
            if (protocol.IPV6ADDRESS.test(components.host)) ;
            else if (options.domainHost || schemeHandler && schemeHandler.domainHost) //convert IDN via punycode
            try {
                components.host = !options.iri ? punycode.toASCII(components.host.replace(protocol.PCT_ENCODED, pctDecChars).toLowerCase()) : punycode.toUnicode(components.host);
            } catch (e) {
                components.error = components.error || "Host's domain name can not be converted to " + (!options.iri ? "ASCII" : "Unicode") + " via punycode: " + e;
            }
        }
        //normalize encoding
        _normalizeComponentEncoding(components, protocol);
        if (options.reference !== "suffix" && components.scheme) {
            uriTokens.push(components.scheme);
            uriTokens.push(":");
        }
        var authority = _recomposeAuthority(components, options);
        if (authority !== undefined) {
            if (options.reference !== "suffix") uriTokens.push("//");
            uriTokens.push(authority);
            if (components.path && components.path.charAt(0) !== "/") uriTokens.push("/");
        }
        if (components.path !== undefined) {
            var s = components.path;
            if (!options.absolutePath && (!schemeHandler || !schemeHandler.absolutePath)) s = removeDotSegments(s);
            if (authority === undefined) s = s.replace(/^\/\//, "/%2F"); //don't allow the path to start with "//"
            uriTokens.push(s);
        }
        if (components.query !== undefined) {
            uriTokens.push("?");
            uriTokens.push(components.query);
        }
        if (components.fragment !== undefined) {
            uriTokens.push("#");
            uriTokens.push(components.fragment);
        }
        return uriTokens.join(""); //merge tokens into a string
    }
    function resolveComponents(base, relative) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var skipNormalization = arguments[3];
        var target = {};
        if (!skipNormalization) {
            base = parse(serialize(base, options), options); //normalize base components
            relative = parse(serialize(relative, options), options); //normalize relative components
        }
        options = options || {};
        if (!options.tolerant && relative.scheme) {
            target.scheme = relative.scheme;
            //target.authority = relative.authority;
            target.userinfo = relative.userinfo;
            target.host = relative.host;
            target.port = relative.port;
            target.path = removeDotSegments(relative.path || "");
            target.query = relative.query;
        } else {
            if (relative.userinfo !== undefined || relative.host !== undefined || relative.port !== undefined) {
                //target.authority = relative.authority;
                target.userinfo = relative.userinfo;
                target.host = relative.host;
                target.port = relative.port;
                target.path = removeDotSegments(relative.path || "");
                target.query = relative.query;
            } else {
                if (!relative.path) {
                    target.path = base.path;
                    if (relative.query !== undefined) target.query = relative.query;
                    else target.query = base.query;
                } else {
                    if (relative.path.charAt(0) === "/") target.path = removeDotSegments(relative.path);
                    else {
                        if ((base.userinfo !== undefined || base.host !== undefined || base.port !== undefined) && !base.path) target.path = "/" + relative.path;
                        else if (!base.path) target.path = relative.path;
                        else target.path = base.path.slice(0, base.path.lastIndexOf("/") + 1) + relative.path;
                        target.path = removeDotSegments(target.path);
                    }
                    target.query = relative.query;
                }
                //target.authority = base.authority;
                target.userinfo = base.userinfo;
                target.host = base.host;
                target.port = base.port;
            }
            target.scheme = base.scheme;
        }
        target.fragment = relative.fragment;
        return target;
    }
    function resolve(baseURI, relativeURI, options) {
        var schemelessOptions = assign({
            scheme: "null"
        }, options);
        return serialize(resolveComponents(parse(baseURI, schemelessOptions), parse(relativeURI, schemelessOptions), schemelessOptions, true), schemelessOptions);
    }
    function normalize(uri, options) {
        if (typeof uri === "string") uri = serialize(parse(uri, options), options);
        else if (typeOf(uri) === "object") uri = parse(serialize(uri, options), options);
        return uri;
    }
    function equal(uriA, uriB, options) {
        if (typeof uriA === "string") uriA = serialize(parse(uriA, options), options);
        else if (typeOf(uriA) === "object") uriA = serialize(uriA, options);
        if (typeof uriB === "string") uriB = serialize(parse(uriB, options), options);
        else if (typeOf(uriB) === "object") uriB = serialize(uriB, options);
        return uriA === uriB;
    }
    function escapeComponent(str, options) {
        return str && str.toString().replace(!options || !options.iri ? URI_PROTOCOL.ESCAPE : IRI_PROTOCOL.ESCAPE, pctEncChar);
    }
    function unescapeComponent(str, options) {
        return str && str.toString().replace(!options || !options.iri ? URI_PROTOCOL.PCT_ENCODED : IRI_PROTOCOL.PCT_ENCODED, pctDecChars);
    }
    var handler = {
        scheme: "http",
        domainHost: true,
        parse: function parse(components, options) {
            //report missing host
            if (!components.host) components.error = components.error || "HTTP URIs must have a host.";
            return components;
        },
        serialize: function serialize(components, options) {
            var secure = String(components.scheme).toLowerCase() === "https";
            //normalize the default port
            if (components.port === (secure ? 443 : 80) || components.port === "") components.port = undefined;
            //normalize the empty path
            if (!components.path) components.path = "/";
            //NOTE: We do not parse query strings for HTTP URIs
            //as WWW Form Url Encoded query strings are part of the HTML4+ spec,
            //and not the HTTP spec.
            return components;
        }
    };
    var handler$1 = {
        scheme: "https",
        domainHost: handler.domainHost,
        parse: handler.parse,
        serialize: handler.serialize
    };
    function isSecure(wsComponents) {
        return typeof wsComponents.secure === "boolean" ? wsComponents.secure : String(wsComponents.scheme).toLowerCase() === "wss";
    }
    //RFC 6455
    var handler$2 = {
        scheme: "ws",
        domainHost: true,
        parse: function parse(components, options) {
            var wsComponents = components;
            //indicate if the secure flag is set
            wsComponents.secure = isSecure(wsComponents);
            //construct resouce name
            wsComponents.resourceName = (wsComponents.path || "/") + (wsComponents.query ? "?" + wsComponents.query : "");
            wsComponents.path = undefined;
            wsComponents.query = undefined;
            return wsComponents;
        },
        serialize: function serialize(wsComponents, options) {
            //normalize the default port
            if (wsComponents.port === (isSecure(wsComponents) ? 443 : 80) || wsComponents.port === "") wsComponents.port = undefined;
            //ensure scheme matches secure flag
            if (typeof wsComponents.secure === "boolean") {
                wsComponents.scheme = wsComponents.secure ? "wss" : "ws";
                wsComponents.secure = undefined;
            }
            //reconstruct path from resource name
            if (wsComponents.resourceName) {
                var _wsComponents$resourc = wsComponents.resourceName.split("?"), _wsComponents$resourc2 = slicedToArray(_wsComponents$resourc, 2), path = _wsComponents$resourc2[0], query = _wsComponents$resourc2[1];
                wsComponents.path = path && path !== "/" ? path : undefined;
                wsComponents.query = query;
                wsComponents.resourceName = undefined;
            }
            //forbid fragment component
            wsComponents.fragment = undefined;
            return wsComponents;
        }
    };
    var handler$3 = {
        scheme: "wss",
        domainHost: handler$2.domainHost,
        parse: handler$2.parse,
        serialize: handler$2.serialize
    };
    var O = {};
    var isIRI = true;
    //RFC 3986
    var UNRESERVED$$ = "[A-Za-z0-9\\-\\.\\_\\~" + (isIRI ? "\\xA0-\\u200D\\u2010-\\u2029\\u202F-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF" : "") + "]";
    var HEXDIG$$ = "[0-9A-Fa-f]"; //case-insensitive
    var PCT_ENCODED$ = subexp(subexp("%[EFef]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%[89A-Fa-f]" + HEXDIG$$ + "%" + HEXDIG$$ + HEXDIG$$) + "|" + subexp("%" + HEXDIG$$ + HEXDIG$$)); //expanded
    //RFC 5322, except these symbols as per RFC 6068: @ : / ? # [ ] & ; =
    //const ATEXT$$ = "[A-Za-z0-9\\!\\#\\$\\%\\&\\'\\*\\+\\-\\/\\=\\?\\^\\_\\`\\{\\|\\}\\~]";
    //const WSP$$ = "[\\x20\\x09]";
    //const OBS_QTEXT$$ = "[\\x01-\\x08\\x0B\\x0C\\x0E-\\x1F\\x7F]";  //(%d1-8 / %d11-12 / %d14-31 / %d127)
    //const QTEXT$$ = merge("[\\x21\\x23-\\x5B\\x5D-\\x7E]", OBS_QTEXT$$);  //%d33 / %d35-91 / %d93-126 / obs-qtext
    //const VCHAR$$ = "[\\x21-\\x7E]";
    //const WSP$$ = "[\\x20\\x09]";
    //const OBS_QP$ = subexp("\\\\" + merge("[\\x00\\x0D\\x0A]", OBS_QTEXT$$));  //%d0 / CR / LF / obs-qtext
    //const FWS$ = subexp(subexp(WSP$$ + "*" + "\\x0D\\x0A") + "?" + WSP$$ + "+");
    //const QUOTED_PAIR$ = subexp(subexp("\\\\" + subexp(VCHAR$$ + "|" + WSP$$)) + "|" + OBS_QP$);
    //const QUOTED_STRING$ = subexp('\\"' + subexp(FWS$ + "?" + QCONTENT$) + "*" + FWS$ + "?" + '\\"');
    var ATEXT$$ = "[A-Za-z0-9\\!\\$\\%\\'\\*\\+\\-\\^\\_\\`\\{\\|\\}\\~]";
    var QTEXT$$ = "[\\!\\$\\%\\'\\(\\)\\*\\+\\,\\-\\.0-9\\<\\>A-Z\\x5E-\\x7E]";
    var VCHAR$$ = merge(QTEXT$$, '[\\"\\\\]');
    var SOME_DELIMS$$ = "[\\!\\$\\'\\(\\)\\*\\+\\,\\;\\:\\@]";
    var UNRESERVED = new RegExp(UNRESERVED$$, "g");
    var PCT_ENCODED = new RegExp(PCT_ENCODED$, "g");
    var NOT_LOCAL_PART = new RegExp(merge("[^]", ATEXT$$, "[\\.]", '[\\"]', VCHAR$$), "g");
    var NOT_HFNAME = new RegExp(merge("[^]", UNRESERVED$$, SOME_DELIMS$$), "g");
    var NOT_HFVALUE = NOT_HFNAME;
    function decodeUnreserved(str) {
        var decStr = pctDecChars(str);
        return !decStr.match(UNRESERVED) ? str : decStr;
    }
    var handler$4 = {
        scheme: "mailto",
        parse: function parse$$1(components, options) {
            var mailtoComponents = components;
            var to = mailtoComponents.to = mailtoComponents.path ? mailtoComponents.path.split(",") : [];
            mailtoComponents.path = undefined;
            if (mailtoComponents.query) {
                var unknownHeaders = false;
                var headers = {};
                var hfields = mailtoComponents.query.split("&");
                for(var x = 0, xl = hfields.length; x < xl; ++x){
                    var hfield = hfields[x].split("=");
                    switch(hfield[0]){
                        case "to":
                            var toAddrs = hfield[1].split(",");
                            for(var _x = 0, _xl = toAddrs.length; _x < _xl; ++_x)to.push(toAddrs[_x]);
                            break;
                        case "subject":
                            mailtoComponents.subject = unescapeComponent(hfield[1], options);
                            break;
                        case "body":
                            mailtoComponents.body = unescapeComponent(hfield[1], options);
                            break;
                        default:
                            unknownHeaders = true;
                            headers[unescapeComponent(hfield[0], options)] = unescapeComponent(hfield[1], options);
                            break;
                    }
                }
                if (unknownHeaders) mailtoComponents.headers = headers;
            }
            mailtoComponents.query = undefined;
            for(var _x2 = 0, _xl2 = to.length; _x2 < _xl2; ++_x2){
                var addr = to[_x2].split("@");
                addr[0] = unescapeComponent(addr[0]);
                if (!options.unicodeSupport) //convert Unicode IDN -> ASCII IDN
                try {
                    addr[1] = punycode.toASCII(unescapeComponent(addr[1], options).toLowerCase());
                } catch (e) {
                    mailtoComponents.error = mailtoComponents.error || "Email address's domain name can not be converted to ASCII via punycode: " + e;
                }
                else addr[1] = unescapeComponent(addr[1], options).toLowerCase();
                to[_x2] = addr.join("@");
            }
            return mailtoComponents;
        },
        serialize: function serialize$$1(mailtoComponents, options) {
            var components = mailtoComponents;
            var to = toArray(mailtoComponents.to);
            if (to) {
                for(var x = 0, xl = to.length; x < xl; ++x){
                    var toAddr = String(to[x]);
                    var atIdx = toAddr.lastIndexOf("@");
                    var localPart = toAddr.slice(0, atIdx).replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_LOCAL_PART, pctEncChar);
                    var domain = toAddr.slice(atIdx + 1);
                    //convert IDN via punycode
                    try {
                        domain = !options.iri ? punycode.toASCII(unescapeComponent(domain, options).toLowerCase()) : punycode.toUnicode(domain);
                    } catch (e) {
                        components.error = components.error || "Email address's domain name can not be converted to " + (!options.iri ? "ASCII" : "Unicode") + " via punycode: " + e;
                    }
                    to[x] = localPart + "@" + domain;
                }
                components.path = to.join(",");
            }
            var headers = mailtoComponents.headers = mailtoComponents.headers || {};
            if (mailtoComponents.subject) headers["subject"] = mailtoComponents.subject;
            if (mailtoComponents.body) headers["body"] = mailtoComponents.body;
            var fields = [];
            for(var name in headers)if (headers[name] !== O[name]) fields.push(name.replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_HFNAME, pctEncChar) + "=" + headers[name].replace(PCT_ENCODED, decodeUnreserved).replace(PCT_ENCODED, toUpperCase).replace(NOT_HFVALUE, pctEncChar));
            if (fields.length) components.query = fields.join("&");
            return components;
        }
    };
    var URN_PARSE = /^([^\:]+)\:(.*)/;
    //RFC 2141
    var handler$5 = {
        scheme: "urn",
        parse: function parse$$1(components, options) {
            var matches = components.path && components.path.match(URN_PARSE);
            var urnComponents = components;
            if (matches) {
                var scheme = options.scheme || urnComponents.scheme || "urn";
                var nid = matches[1].toLowerCase();
                var nss = matches[2];
                var urnScheme = scheme + ":" + (options.nid || nid);
                var schemeHandler = SCHEMES[urnScheme];
                urnComponents.nid = nid;
                urnComponents.nss = nss;
                urnComponents.path = undefined;
                if (schemeHandler) urnComponents = schemeHandler.parse(urnComponents, options);
            } else urnComponents.error = urnComponents.error || "URN can not be parsed.";
            return urnComponents;
        },
        serialize: function serialize$$1(urnComponents, options) {
            var scheme = options.scheme || urnComponents.scheme || "urn";
            var nid = urnComponents.nid;
            var urnScheme = scheme + ":" + (options.nid || nid);
            var schemeHandler = SCHEMES[urnScheme];
            if (schemeHandler) urnComponents = schemeHandler.serialize(urnComponents, options);
            var uriComponents = urnComponents;
            var nss = urnComponents.nss;
            uriComponents.path = (nid || options.nid) + ":" + nss;
            return uriComponents;
        }
    };
    var UUID = /^[0-9A-Fa-f]{8}(?:\-[0-9A-Fa-f]{4}){3}\-[0-9A-Fa-f]{12}$/;
    //RFC 4122
    var handler$6 = {
        scheme: "urn:uuid",
        parse: function parse(urnComponents, options) {
            var uuidComponents = urnComponents;
            uuidComponents.uuid = uuidComponents.nss;
            uuidComponents.nss = undefined;
            if (!options.tolerant && (!uuidComponents.uuid || !uuidComponents.uuid.match(UUID))) uuidComponents.error = uuidComponents.error || "UUID is not valid.";
            return uuidComponents;
        },
        serialize: function serialize(uuidComponents, options) {
            var urnComponents = uuidComponents;
            //normalize UUID
            urnComponents.nss = (uuidComponents.uuid || "").toLowerCase();
            return urnComponents;
        }
    };
    SCHEMES[handler.scheme] = handler;
    SCHEMES[handler$1.scheme] = handler$1;
    SCHEMES[handler$2.scheme] = handler$2;
    SCHEMES[handler$3.scheme] = handler$3;
    SCHEMES[handler$4.scheme] = handler$4;
    SCHEMES[handler$5.scheme] = handler$5;
    SCHEMES[handler$6.scheme] = handler$6;
    exports1.SCHEMES = SCHEMES;
    exports1.pctEncChar = pctEncChar;
    exports1.pctDecChars = pctDecChars;
    exports1.parse = parse;
    exports1.removeDotSegments = removeDotSegments;
    exports1.serialize = serialize;
    exports1.resolveComponents = resolveComponents;
    exports1.resolve = resolve;
    exports1.normalize = normalize;
    exports1.equal = equal;
    exports1.escapeComponent = escapeComponent;
    exports1.unescapeComponent = unescapeComponent;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});

});

parcelRegister("7hFx0", function(module, exports) {
"use strict";
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});

parcelRegister("lv04s", function(module, exports) {
"use strict";


module.exports = {
    copy: $fa6c8c4bf84f8bb7$var$copy,
    checkDataType: $fa6c8c4bf84f8bb7$var$checkDataType,
    checkDataTypes: $fa6c8c4bf84f8bb7$var$checkDataTypes,
    coerceToTypes: $fa6c8c4bf84f8bb7$var$coerceToTypes,
    toHash: $fa6c8c4bf84f8bb7$var$toHash,
    getProperty: $fa6c8c4bf84f8bb7$var$getProperty,
    escapeQuotes: $fa6c8c4bf84f8bb7$var$escapeQuotes,
    equal: (parcelRequire("7hFx0")),
    ucs2length: (parcelRequire("5bR6m")),
    varOccurences: $fa6c8c4bf84f8bb7$var$varOccurences,
    varReplace: $fa6c8c4bf84f8bb7$var$varReplace,
    schemaHasRules: $fa6c8c4bf84f8bb7$var$schemaHasRules,
    schemaHasRulesExcept: $fa6c8c4bf84f8bb7$var$schemaHasRulesExcept,
    schemaUnknownRules: $fa6c8c4bf84f8bb7$var$schemaUnknownRules,
    toQuotedString: $fa6c8c4bf84f8bb7$var$toQuotedString,
    getPathExpr: $fa6c8c4bf84f8bb7$var$getPathExpr,
    getPath: $fa6c8c4bf84f8bb7$var$getPath,
    getData: $fa6c8c4bf84f8bb7$var$getData,
    unescapeFragment: $fa6c8c4bf84f8bb7$var$unescapeFragment,
    unescapeJsonPointer: $fa6c8c4bf84f8bb7$var$unescapeJsonPointer,
    escapeFragment: $fa6c8c4bf84f8bb7$var$escapeFragment,
    escapeJsonPointer: $fa6c8c4bf84f8bb7$var$escapeJsonPointer
};
function $fa6c8c4bf84f8bb7$var$copy(o, to) {
    to = to || {};
    for(var key in o)to[key] = o[key];
    return to;
}
function $fa6c8c4bf84f8bb7$var$checkDataType(dataType, data, strictNumbers, negate) {
    var EQUAL = negate ? " !== " : " === ", AND = negate ? " || " : " && ", OK = negate ? "!" : "", NOT = negate ? "" : "!";
    switch(dataType){
        case "null":
            return data + EQUAL + "null";
        case "array":
            return OK + "Array.isArray(" + data + ")";
        case "object":
            return "(" + OK + data + AND + "typeof " + data + EQUAL + '"object"' + AND + NOT + "Array.isArray(" + data + "))";
        case "integer":
            return "(typeof " + data + EQUAL + '"number"' + AND + NOT + "(" + data + " % 1)" + AND + data + EQUAL + data + (strictNumbers ? AND + OK + "isFinite(" + data + ")" : "") + ")";
        case "number":
            return "(typeof " + data + EQUAL + '"' + dataType + '"' + (strictNumbers ? AND + OK + "isFinite(" + data + ")" : "") + ")";
        default:
            return "typeof " + data + EQUAL + '"' + dataType + '"';
    }
}
function $fa6c8c4bf84f8bb7$var$checkDataTypes(dataTypes, data, strictNumbers) {
    switch(dataTypes.length){
        case 1:
            return $fa6c8c4bf84f8bb7$var$checkDataType(dataTypes[0], data, strictNumbers, true);
        default:
            var code = "";
            var types = $fa6c8c4bf84f8bb7$var$toHash(dataTypes);
            if (types.array && types.object) {
                code = types.null ? "(" : "(!" + data + " || ";
                code += "typeof " + data + ' !== "object")';
                delete types.null;
                delete types.array;
                delete types.object;
            }
            if (types.number) delete types.integer;
            for(var t in types)code += (code ? " && " : "") + $fa6c8c4bf84f8bb7$var$checkDataType(t, data, strictNumbers, true);
            return code;
    }
}
var $fa6c8c4bf84f8bb7$var$COERCE_TO_TYPES = $fa6c8c4bf84f8bb7$var$toHash([
    "string",
    "number",
    "integer",
    "boolean",
    "null"
]);
function $fa6c8c4bf84f8bb7$var$coerceToTypes(optionCoerceTypes, dataTypes) {
    if (Array.isArray(dataTypes)) {
        var types = [];
        for(var i = 0; i < dataTypes.length; i++){
            var t = dataTypes[i];
            if ($fa6c8c4bf84f8bb7$var$COERCE_TO_TYPES[t]) types[types.length] = t;
            else if (optionCoerceTypes === "array" && t === "array") types[types.length] = t;
        }
        if (types.length) return types;
    } else if ($fa6c8c4bf84f8bb7$var$COERCE_TO_TYPES[dataTypes]) return [
        dataTypes
    ];
    else if (optionCoerceTypes === "array" && dataTypes === "array") return [
        "array"
    ];
}
function $fa6c8c4bf84f8bb7$var$toHash(arr) {
    var hash = {};
    for(var i = 0; i < arr.length; i++)hash[arr[i]] = true;
    return hash;
}
var $fa6c8c4bf84f8bb7$var$IDENTIFIER = /^[a-z$_][a-z$_0-9]*$/i;
var $fa6c8c4bf84f8bb7$var$SINGLE_QUOTE = /'|\\/g;
function $fa6c8c4bf84f8bb7$var$getProperty(key) {
    return typeof key == "number" ? "[" + key + "]" : $fa6c8c4bf84f8bb7$var$IDENTIFIER.test(key) ? "." + key : "['" + $fa6c8c4bf84f8bb7$var$escapeQuotes(key) + "']";
}
function $fa6c8c4bf84f8bb7$var$escapeQuotes(str) {
    return str.replace($fa6c8c4bf84f8bb7$var$SINGLE_QUOTE, "\\$&").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\f/g, "\\f").replace(/\t/g, "\\t");
}
function $fa6c8c4bf84f8bb7$var$varOccurences(str, dataVar) {
    dataVar += "[^0-9]";
    var matches = str.match(new RegExp(dataVar, "g"));
    return matches ? matches.length : 0;
}
function $fa6c8c4bf84f8bb7$var$varReplace(str, dataVar, expr) {
    dataVar += "([^0-9])";
    expr = expr.replace(/\$/g, "$$$$");
    return str.replace(new RegExp(dataVar, "g"), expr + "$1");
}
function $fa6c8c4bf84f8bb7$var$schemaHasRules(schema, rules) {
    if (typeof schema == "boolean") return !schema;
    for(var key in schema)if (rules[key]) return true;
}
function $fa6c8c4bf84f8bb7$var$schemaHasRulesExcept(schema, rules, exceptKeyword) {
    if (typeof schema == "boolean") return !schema && exceptKeyword != "not";
    for(var key in schema)if (key != exceptKeyword && rules[key]) return true;
}
function $fa6c8c4bf84f8bb7$var$schemaUnknownRules(schema, rules) {
    if (typeof schema == "boolean") return;
    for(var key in schema)if (!rules[key]) return key;
}
function $fa6c8c4bf84f8bb7$var$toQuotedString(str) {
    return "'" + $fa6c8c4bf84f8bb7$var$escapeQuotes(str) + "'";
}
function $fa6c8c4bf84f8bb7$var$getPathExpr(currentPath, expr, jsonPointers, isNumber) {
    var path = jsonPointers // false by default
     ? "'/' + " + expr + (isNumber ? "" : ".replace(/~/g, '~0').replace(/\\//g, '~1')") : isNumber ? "'[' + " + expr + " + ']'" : "'[\\'' + " + expr + " + '\\']'";
    return $fa6c8c4bf84f8bb7$var$joinPaths(currentPath, path);
}
function $fa6c8c4bf84f8bb7$var$getPath(currentPath, prop, jsonPointers) {
    var path = jsonPointers // false by default
     ? $fa6c8c4bf84f8bb7$var$toQuotedString("/" + $fa6c8c4bf84f8bb7$var$escapeJsonPointer(prop)) : $fa6c8c4bf84f8bb7$var$toQuotedString($fa6c8c4bf84f8bb7$var$getProperty(prop));
    return $fa6c8c4bf84f8bb7$var$joinPaths(currentPath, path);
}
var $fa6c8c4bf84f8bb7$var$JSON_POINTER = /^\/(?:[^~]|~0|~1)*$/;
var $fa6c8c4bf84f8bb7$var$RELATIVE_JSON_POINTER = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
function $fa6c8c4bf84f8bb7$var$getData($data, lvl, paths) {
    var up, jsonPointer, data, matches;
    if ($data === "") return "rootData";
    if ($data[0] == "/") {
        if (!$fa6c8c4bf84f8bb7$var$JSON_POINTER.test($data)) throw new Error("Invalid JSON-pointer: " + $data);
        jsonPointer = $data;
        data = "rootData";
    } else {
        matches = $data.match($fa6c8c4bf84f8bb7$var$RELATIVE_JSON_POINTER);
        if (!matches) throw new Error("Invalid JSON-pointer: " + $data);
        up = +matches[1];
        jsonPointer = matches[2];
        if (jsonPointer == "#") {
            if (up >= lvl) throw new Error("Cannot access property/index " + up + " levels up, current level is " + lvl);
            return paths[lvl - up];
        }
        if (up > lvl) throw new Error("Cannot access data " + up + " levels up, current level is " + lvl);
        data = "data" + (lvl - up || "");
        if (!jsonPointer) return data;
    }
    var expr = data;
    var segments = jsonPointer.split("/");
    for(var i = 0; i < segments.length; i++){
        var segment = segments[i];
        if (segment) {
            data += $fa6c8c4bf84f8bb7$var$getProperty($fa6c8c4bf84f8bb7$var$unescapeJsonPointer(segment));
            expr += " && " + data;
        }
    }
    return expr;
}
function $fa6c8c4bf84f8bb7$var$joinPaths(a, b) {
    if (a == '""') return b;
    return (a + " + " + b).replace(/([^\\])' \+ '/g, "$1");
}
function $fa6c8c4bf84f8bb7$var$unescapeFragment(str) {
    return $fa6c8c4bf84f8bb7$var$unescapeJsonPointer(decodeURIComponent(str));
}
function $fa6c8c4bf84f8bb7$var$escapeFragment(str) {
    return encodeURIComponent($fa6c8c4bf84f8bb7$var$escapeJsonPointer(str));
}
function $fa6c8c4bf84f8bb7$var$escapeJsonPointer(str) {
    return str.replace(/~/g, "~0").replace(/\//g, "~1");
}
function $fa6c8c4bf84f8bb7$var$unescapeJsonPointer(str) {
    return str.replace(/~1/g, "/").replace(/~0/g, "~");
}

});
parcelRegister("5bR6m", function(module, exports) {
"use strict";
// https://mathiasbynens.be/notes/javascript-encoding
// https://github.com/bestiejs/punycode.js - punycode.ucs2.decode
module.exports = function ucs2length(str) {
    var length = 0, len = str.length, pos = 0, value;
    while(pos < len){
        length++;
        value = str.charCodeAt(pos++);
        if (value >= 0xD800 && value <= 0xDBFF && pos < len) {
            // high surrogate, and there is a next character
            value = str.charCodeAt(pos);
            if ((value & 0xFC00) == 0xDC00) pos++; // low surrogate
        }
    }
    return length;
};

});


parcelRegister("dvpPZ", function(module, exports) {
"use strict";

var $lv04s = parcelRequire("lv04s");
module.exports = $9d52366d3b70b1d2$var$SchemaObject;
function $9d52366d3b70b1d2$var$SchemaObject(obj) {
    $lv04s.copy(obj, this);
}

});

parcelRegister("7dBhG", function(module, exports) {
"use strict";
var $5416ab2f1394f8d9$var$traverse = module.exports = function(schema, opts, cb) {
    // Legacy support for v0.3.1 and earlier.
    if (typeof opts == "function") {
        cb = opts;
        opts = {};
    }
    cb = opts.cb || cb;
    var pre = typeof cb == "function" ? cb : cb.pre || function() {};
    var post = cb.post || function() {};
    $5416ab2f1394f8d9$var$_traverse(opts, pre, post, schema, "", schema);
};
$5416ab2f1394f8d9$var$traverse.keywords = {
    additionalItems: true,
    items: true,
    contains: true,
    additionalProperties: true,
    propertyNames: true,
    not: true
};
$5416ab2f1394f8d9$var$traverse.arrayKeywords = {
    items: true,
    allOf: true,
    anyOf: true,
    oneOf: true
};
$5416ab2f1394f8d9$var$traverse.propsKeywords = {
    definitions: true,
    properties: true,
    patternProperties: true,
    dependencies: true
};
$5416ab2f1394f8d9$var$traverse.skipKeywords = {
    default: true,
    enum: true,
    const: true,
    required: true,
    maximum: true,
    minimum: true,
    exclusiveMaximum: true,
    exclusiveMinimum: true,
    multipleOf: true,
    maxLength: true,
    minLength: true,
    pattern: true,
    format: true,
    maxItems: true,
    minItems: true,
    uniqueItems: true,
    maxProperties: true,
    minProperties: true
};
function $5416ab2f1394f8d9$var$_traverse(opts, pre, post, schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex) {
    if (schema && typeof schema == "object" && !Array.isArray(schema)) {
        pre(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
        for(var key in schema){
            var sch = schema[key];
            if (Array.isArray(sch)) {
                if (key in $5416ab2f1394f8d9$var$traverse.arrayKeywords) for(var i = 0; i < sch.length; i++)$5416ab2f1394f8d9$var$_traverse(opts, pre, post, sch[i], jsonPtr + "/" + key + "/" + i, rootSchema, jsonPtr, key, schema, i);
            } else if (key in $5416ab2f1394f8d9$var$traverse.propsKeywords) {
                if (sch && typeof sch == "object") for(var prop in sch)$5416ab2f1394f8d9$var$_traverse(opts, pre, post, sch[prop], jsonPtr + "/" + key + "/" + $5416ab2f1394f8d9$var$escapeJsonPtr(prop), rootSchema, jsonPtr, key, schema, prop);
            } else if (key in $5416ab2f1394f8d9$var$traverse.keywords || opts.allKeys && !(key in $5416ab2f1394f8d9$var$traverse.skipKeywords)) $5416ab2f1394f8d9$var$_traverse(opts, pre, post, sch, jsonPtr + "/" + key, rootSchema, jsonPtr, key, schema);
        }
        post(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
    }
}
function $5416ab2f1394f8d9$var$escapeJsonPtr(str) {
    return str.replace(/~/g, "~0").replace(/\//g, "~1");
}

});


parcelRegister("4BeMy", function(module, exports) {
"use strict";

var $gY6uQ = parcelRequire("gY6uQ");
module.exports = {
    Validation: $3596158bebceb832$var$errorSubclass($3596158bebceb832$var$ValidationError),
    MissingRef: $3596158bebceb832$var$errorSubclass($3596158bebceb832$var$MissingRefError)
};
function $3596158bebceb832$var$ValidationError(errors) {
    this.message = "validation failed";
    this.errors = errors;
    this.ajv = this.validation = true;
}
$3596158bebceb832$var$MissingRefError.message = function(baseId, ref) {
    return "can't resolve reference " + ref + " from id " + baseId;
};
function $3596158bebceb832$var$MissingRefError(baseId, ref, message) {
    this.message = message || $3596158bebceb832$var$MissingRefError.message(baseId, ref);
    this.missingRef = $gY6uQ.url(baseId, ref);
    this.missingSchema = $gY6uQ.normalizeId($gY6uQ.fullPath(this.missingRef));
}
function $3596158bebceb832$var$errorSubclass(Subclass) {
    Subclass.prototype = Object.create(Error.prototype);
    Subclass.prototype.constructor = Subclass;
    return Subclass;
}

});

parcelRegister("1FoUm", function(module, exports) {
"use strict";
module.exports = function(data, opts) {
    if (!opts) opts = {};
    if (typeof opts === "function") opts = {
        cmp: opts
    };
    var cycles = typeof opts.cycles === "boolean" ? opts.cycles : false;
    var cmp = opts.cmp && function(f) {
        return function(node) {
            return function(a, b) {
                var aobj = {
                    key: a,
                    value: node[a]
                };
                var bobj = {
                    key: b,
                    value: node[b]
                };
                return f(aobj, bobj);
            };
        };
    }(opts.cmp);
    var seen = [];
    return function stringify(node) {
        if (node && node.toJSON && typeof node.toJSON === "function") node = node.toJSON();
        if (node === undefined) return;
        if (typeof node == "number") return isFinite(node) ? "" + node : "null";
        if (typeof node !== "object") return JSON.stringify(node);
        var i, out;
        if (Array.isArray(node)) {
            out = "[";
            for(i = 0; i < node.length; i++){
                if (i) out += ",";
                out += stringify(node[i]) || "null";
            }
            return out + "]";
        }
        if (node === null) return "null";
        if (seen.indexOf(node) !== -1) {
            if (cycles) return JSON.stringify("__cycle__");
            throw new TypeError("Converting circular structure to JSON");
        }
        var seenIndex = seen.push(node) - 1;
        var keys = Object.keys(node).sort(cmp && cmp(node));
        out = "";
        for(i = 0; i < keys.length; i++){
            var key = keys[i];
            var value = stringify(node[key]);
            if (!value) continue;
            if (out) out += ",";
            out += JSON.stringify(key) + ":" + value;
        }
        seen.splice(seenIndex, 1);
        return "{" + out + "}";
    }(data);
};

});

parcelRegister("dtJDJ", function(module, exports) {
"use strict";
module.exports = function generate_validate(it, $keyword, $ruleType) {
    var out = "";
    var $async = it.schema.$async === true, $refKeywords = it.util.schemaHasRulesExcept(it.schema, it.RULES.all, "$ref"), $id = it.self._getId(it.schema);
    if (it.opts.strictKeywords) {
        var $unknownKwd = it.util.schemaUnknownRules(it.schema, it.RULES.keywords);
        if ($unknownKwd) {
            var $keywordsMsg = "unknown keyword: " + $unknownKwd;
            if (it.opts.strictKeywords === "log") it.logger.warn($keywordsMsg);
            else throw new Error($keywordsMsg);
        }
    }
    if (it.isTop) {
        out += " var validate = ";
        if ($async) {
            it.async = true;
            out += "async ";
        }
        out += "function(data, dataPath, parentData, parentDataProperty, rootData) { 'use strict'; ";
        if ($id && (it.opts.sourceCode || it.opts.processCode)) out += " " + ("/*# sourceURL=" + $id + " */") + " ";
    }
    if (typeof it.schema == "boolean" || !($refKeywords || it.schema.$ref)) {
        var $keyword = "false schema";
        var $lvl = it.level;
        var $dataLvl = it.dataLevel;
        var $schema = it.schema[$keyword];
        var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
        var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
        var $breakOnError = !it.opts.allErrors;
        var $errorKeyword;
        var $data = "data" + ($dataLvl || "");
        var $valid = "valid" + $lvl;
        if (it.schema === false) {
            if (it.isTop) $breakOnError = true;
            else out += " var " + $valid + " = false; ";
            var $$outStack = $$outStack || [];
            $$outStack.push(out);
            out = ""; /* istanbul ignore else */ 
            if (it.createErrors !== false) {
                out += " { keyword: '" + ($errorKeyword || "false schema") + "' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: {} ";
                if (it.opts.messages !== false) out += " , message: 'boolean schema is false' ";
                if (it.opts.verbose) out += " , schema: false , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
                out += " } ";
            } else out += " {} ";
            var __err = out;
            out = $$outStack.pop();
            if (!it.compositeRule && $breakOnError) {
                /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
                else out += " validate.errors = [" + __err + "]; return false; ";
            } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
        } else if (it.isTop) {
            if ($async) out += " return data; ";
            else out += " validate.errors = null; return true; ";
        } else out += " var " + $valid + " = true; ";
        if (it.isTop) out += " }; return validate; ";
        return out;
    }
    if (it.isTop) {
        var $top = it.isTop, $lvl = it.level = 0, $dataLvl = it.dataLevel = 0, $data = "data";
        it.rootId = it.resolve.fullPath(it.self._getId(it.root.schema));
        it.baseId = it.baseId || it.rootId;
        delete it.isTop;
        it.dataPathArr = [
            ""
        ];
        if (it.schema.default !== undefined && it.opts.useDefaults && it.opts.strictDefaults) {
            var $defaultMsg = "default is ignored in the schema root";
            if (it.opts.strictDefaults === "log") it.logger.warn($defaultMsg);
            else throw new Error($defaultMsg);
        }
        out += " var vErrors = null; ";
        out += " var errors = 0;     ";
        out += " if (rootData === undefined) rootData = data; ";
    } else {
        var $lvl = it.level, $dataLvl = it.dataLevel, $data = "data" + ($dataLvl || "");
        if ($id) it.baseId = it.resolve.url(it.baseId, $id);
        if ($async && !it.async) throw new Error("async schema in sync schema");
        out += " var errs_" + $lvl + " = errors;";
    }
    var $valid = "valid" + $lvl, $breakOnError = !it.opts.allErrors, $closingBraces1 = "", $closingBraces2 = "";
    var $errorKeyword;
    var $typeSchema = it.schema.type, $typeIsArray = Array.isArray($typeSchema);
    if ($typeSchema && it.opts.nullable && it.schema.nullable === true) {
        if ($typeIsArray) {
            if ($typeSchema.indexOf("null") == -1) $typeSchema = $typeSchema.concat("null");
        } else if ($typeSchema != "null") {
            $typeSchema = [
                $typeSchema,
                "null"
            ];
            $typeIsArray = true;
        }
    }
    if ($typeIsArray && $typeSchema.length == 1) {
        $typeSchema = $typeSchema[0];
        $typeIsArray = false;
    }
    if (it.schema.$ref && $refKeywords) {
        if (it.opts.extendRefs == "fail") throw new Error('$ref: validation keywords used in schema at path "' + it.errSchemaPath + '" (see option extendRefs)');
        else if (it.opts.extendRefs !== true) {
            $refKeywords = false;
            it.logger.warn('$ref: keywords ignored in schema at path "' + it.errSchemaPath + '"');
        }
    }
    if (it.schema.$comment && it.opts.$comment) out += " " + it.RULES.all.$comment.code(it, "$comment");
    if ($typeSchema) {
        if (it.opts.coerceTypes) var $coerceToTypes = it.util.coerceToTypes(it.opts.coerceTypes, $typeSchema);
        var $rulesGroup = it.RULES.types[$typeSchema];
        if ($coerceToTypes || $typeIsArray || $rulesGroup === true || $rulesGroup && !$shouldUseGroup($rulesGroup)) {
            var $schemaPath = it.schemaPath + ".type", $errSchemaPath = it.errSchemaPath + "/type";
            var $schemaPath = it.schemaPath + ".type", $errSchemaPath = it.errSchemaPath + "/type", $method = $typeIsArray ? "checkDataTypes" : "checkDataType";
            out += " if (" + it.util[$method]($typeSchema, $data, it.opts.strictNumbers, true) + ") { ";
            if ($coerceToTypes) {
                var $dataType = "dataType" + $lvl, $coerced = "coerced" + $lvl;
                out += " var " + $dataType + " = typeof " + $data + "; var " + $coerced + " = undefined; ";
                if (it.opts.coerceTypes == "array") out += " if (" + $dataType + " == 'object' && Array.isArray(" + $data + ") && " + $data + ".length == 1) { " + $data + " = " + $data + "[0]; " + $dataType + " = typeof " + $data + "; if (" + it.util.checkDataType(it.schema.type, $data, it.opts.strictNumbers) + ") " + $coerced + " = " + $data + "; } ";
                out += " if (" + $coerced + " !== undefined) ; ";
                var arr1 = $coerceToTypes;
                if (arr1) {
                    var $type, $i = -1, l1 = arr1.length - 1;
                    while($i < l1){
                        $type = arr1[$i += 1];
                        if ($type == "string") out += " else if (" + $dataType + " == 'number' || " + $dataType + " == 'boolean') " + $coerced + " = '' + " + $data + "; else if (" + $data + " === null) " + $coerced + " = ''; ";
                        else if ($type == "number" || $type == "integer") {
                            out += " else if (" + $dataType + " == 'boolean' || " + $data + " === null || (" + $dataType + " == 'string' && " + $data + " && " + $data + " == +" + $data + " ";
                            if ($type == "integer") out += " && !(" + $data + " % 1)";
                            out += ")) " + $coerced + " = +" + $data + "; ";
                        } else if ($type == "boolean") out += " else if (" + $data + " === 'false' || " + $data + " === 0 || " + $data + " === null) " + $coerced + " = false; else if (" + $data + " === 'true' || " + $data + " === 1) " + $coerced + " = true; ";
                        else if ($type == "null") out += " else if (" + $data + " === '' || " + $data + " === 0 || " + $data + " === false) " + $coerced + " = null; ";
                        else if (it.opts.coerceTypes == "array" && $type == "array") out += " else if (" + $dataType + " == 'string' || " + $dataType + " == 'number' || " + $dataType + " == 'boolean' || " + $data + " == null) " + $coerced + " = [" + $data + "]; ";
                    }
                }
                out += " else {   ";
                var $$outStack = $$outStack || [];
                $$outStack.push(out);
                out = ""; /* istanbul ignore else */ 
                if (it.createErrors !== false) {
                    out += " { keyword: '" + ($errorKeyword || "type") + "' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { type: '";
                    if ($typeIsArray) out += "" + $typeSchema.join(",");
                    else out += "" + $typeSchema;
                    out += "' } ";
                    if (it.opts.messages !== false) {
                        out += " , message: 'should be ";
                        if ($typeIsArray) out += "" + $typeSchema.join(",");
                        else out += "" + $typeSchema;
                        out += "' ";
                    }
                    if (it.opts.verbose) out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
                    out += " } ";
                } else out += " {} ";
                var __err = out;
                out = $$outStack.pop();
                if (!it.compositeRule && $breakOnError) {
                    /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
                    else out += " validate.errors = [" + __err + "]; return false; ";
                } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
                out += " } if (" + $coerced + " !== undefined) {  ";
                var $parentData = $dataLvl ? "data" + ($dataLvl - 1 || "") : "parentData", $parentDataProperty = $dataLvl ? it.dataPathArr[$dataLvl] : "parentDataProperty";
                out += " " + $data + " = " + $coerced + "; ";
                if (!$dataLvl) out += "if (" + $parentData + " !== undefined)";
                out += " " + $parentData + "[" + $parentDataProperty + "] = " + $coerced + "; } ";
            } else {
                var $$outStack = $$outStack || [];
                $$outStack.push(out);
                out = ""; /* istanbul ignore else */ 
                if (it.createErrors !== false) {
                    out += " { keyword: '" + ($errorKeyword || "type") + "' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { type: '";
                    if ($typeIsArray) out += "" + $typeSchema.join(",");
                    else out += "" + $typeSchema;
                    out += "' } ";
                    if (it.opts.messages !== false) {
                        out += " , message: 'should be ";
                        if ($typeIsArray) out += "" + $typeSchema.join(",");
                        else out += "" + $typeSchema;
                        out += "' ";
                    }
                    if (it.opts.verbose) out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
                    out += " } ";
                } else out += " {} ";
                var __err = out;
                out = $$outStack.pop();
                if (!it.compositeRule && $breakOnError) {
                    /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
                    else out += " validate.errors = [" + __err + "]; return false; ";
                } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
            }
            out += " } ";
        }
    }
    if (it.schema.$ref && !$refKeywords) {
        out += " " + it.RULES.all.$ref.code(it, "$ref") + " ";
        if ($breakOnError) {
            out += " } if (errors === ";
            if ($top) out += "0";
            else out += "errs_" + $lvl;
            out += ") { ";
            $closingBraces2 += "}";
        }
    } else {
        var arr2 = it.RULES;
        if (arr2) {
            var $rulesGroup, i2 = -1, l2 = arr2.length - 1;
            while(i2 < l2){
                $rulesGroup = arr2[i2 += 1];
                if ($shouldUseGroup($rulesGroup)) {
                    if ($rulesGroup.type) out += " if (" + it.util.checkDataType($rulesGroup.type, $data, it.opts.strictNumbers) + ") { ";
                    if (it.opts.useDefaults) {
                        if ($rulesGroup.type == "object" && it.schema.properties) {
                            var $schema = it.schema.properties, $schemaKeys = Object.keys($schema);
                            var arr3 = $schemaKeys;
                            if (arr3) {
                                var $propertyKey, i3 = -1, l3 = arr3.length - 1;
                                while(i3 < l3){
                                    $propertyKey = arr3[i3 += 1];
                                    var $sch = $schema[$propertyKey];
                                    if ($sch.default !== undefined) {
                                        var $passData = $data + it.util.getProperty($propertyKey);
                                        if (it.compositeRule) {
                                            if (it.opts.strictDefaults) {
                                                var $defaultMsg = "default is ignored for: " + $passData;
                                                if (it.opts.strictDefaults === "log") it.logger.warn($defaultMsg);
                                                else throw new Error($defaultMsg);
                                            }
                                        } else {
                                            out += " if (" + $passData + " === undefined ";
                                            if (it.opts.useDefaults == "empty") out += " || " + $passData + " === null || " + $passData + " === '' ";
                                            out += " ) " + $passData + " = ";
                                            if (it.opts.useDefaults == "shared") out += " " + it.useDefault($sch.default) + " ";
                                            else out += " " + JSON.stringify($sch.default) + " ";
                                            out += "; ";
                                        }
                                    }
                                }
                            }
                        } else if ($rulesGroup.type == "array" && Array.isArray(it.schema.items)) {
                            var arr4 = it.schema.items;
                            if (arr4) {
                                var $sch, $i = -1, l4 = arr4.length - 1;
                                while($i < l4){
                                    $sch = arr4[$i += 1];
                                    if ($sch.default !== undefined) {
                                        var $passData = $data + "[" + $i + "]";
                                        if (it.compositeRule) {
                                            if (it.opts.strictDefaults) {
                                                var $defaultMsg = "default is ignored for: " + $passData;
                                                if (it.opts.strictDefaults === "log") it.logger.warn($defaultMsg);
                                                else throw new Error($defaultMsg);
                                            }
                                        } else {
                                            out += " if (" + $passData + " === undefined ";
                                            if (it.opts.useDefaults == "empty") out += " || " + $passData + " === null || " + $passData + " === '' ";
                                            out += " ) " + $passData + " = ";
                                            if (it.opts.useDefaults == "shared") out += " " + it.useDefault($sch.default) + " ";
                                            else out += " " + JSON.stringify($sch.default) + " ";
                                            out += "; ";
                                        }
                                    }
                                }
                            }
                        }
                    }
                    var arr5 = $rulesGroup.rules;
                    if (arr5) {
                        var $rule, i5 = -1, l5 = arr5.length - 1;
                        while(i5 < l5){
                            $rule = arr5[i5 += 1];
                            if ($shouldUseRule($rule)) {
                                var $code = $rule.code(it, $rule.keyword, $rulesGroup.type);
                                if ($code) {
                                    out += " " + $code + " ";
                                    if ($breakOnError) $closingBraces1 += "}";
                                }
                            }
                        }
                    }
                    if ($breakOnError) {
                        out += " " + $closingBraces1 + " ";
                        $closingBraces1 = "";
                    }
                    if ($rulesGroup.type) {
                        out += " } ";
                        if ($typeSchema && $typeSchema === $rulesGroup.type && !$coerceToTypes) {
                            out += " else { ";
                            var $schemaPath = it.schemaPath + ".type", $errSchemaPath = it.errSchemaPath + "/type";
                            var $$outStack = $$outStack || [];
                            $$outStack.push(out);
                            out = ""; /* istanbul ignore else */ 
                            if (it.createErrors !== false) {
                                out += " { keyword: '" + ($errorKeyword || "type") + "' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { type: '";
                                if ($typeIsArray) out += "" + $typeSchema.join(",");
                                else out += "" + $typeSchema;
                                out += "' } ";
                                if (it.opts.messages !== false) {
                                    out += " , message: 'should be ";
                                    if ($typeIsArray) out += "" + $typeSchema.join(",");
                                    else out += "" + $typeSchema;
                                    out += "' ";
                                }
                                if (it.opts.verbose) out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
                                out += " } ";
                            } else out += " {} ";
                            var __err = out;
                            out = $$outStack.pop();
                            if (!it.compositeRule && $breakOnError) {
                                /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
                                else out += " validate.errors = [" + __err + "]; return false; ";
                            } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
                            out += " } ";
                        }
                    }
                    if ($breakOnError) {
                        out += " if (errors === ";
                        if ($top) out += "0";
                        else out += "errs_" + $lvl;
                        out += ") { ";
                        $closingBraces2 += "}";
                    }
                }
            }
        }
    }
    if ($breakOnError) out += " " + $closingBraces2 + " ";
    if ($top) {
        if ($async) {
            out += " if (errors === 0) return data;           ";
            out += " else throw new ValidationError(vErrors); ";
        } else {
            out += " validate.errors = vErrors; ";
            out += " return errors === 0;       ";
        }
        out += " }; return validate;";
    } else out += " var " + $valid + " = errors === errs_" + $lvl + ";";
    function $shouldUseGroup($rulesGroup) {
        var rules = $rulesGroup.rules;
        for(var i = 0; i < rules.length; i++)if ($shouldUseRule(rules[i])) return true;
    }
    function $shouldUseRule($rule) {
        return it.schema[$rule.keyword] !== undefined || $rule.implements && $ruleImplementsSomeKeyword($rule);
    }
    function $ruleImplementsSomeKeyword($rule) {
        var impl = $rule.implements;
        for(var i = 0; i < impl.length; i++)if (it.schema[impl[i]] !== undefined) return true;
    }
    return out;
};

});


parcelRegister("boFVy", function(module, exports) {
"use strict";
var $84c27582c054ac08$var$Cache = module.exports = function Cache() {
    this._cache = {};
};
$84c27582c054ac08$var$Cache.prototype.put = function Cache_put(key, value) {
    this._cache[key] = value;
};
$84c27582c054ac08$var$Cache.prototype.get = function Cache_get(key) {
    return this._cache[key];
};
$84c27582c054ac08$var$Cache.prototype.del = function Cache_del(key) {
    delete this._cache[key];
};
$84c27582c054ac08$var$Cache.prototype.clear = function Cache_clear() {
    this._cache = {};
};

});

parcelRegister("3gXPV", function(module, exports) {
"use strict";

var $lv04s = parcelRequire("lv04s");
var $26214805efdd63e4$var$DATE = /^(\d\d\d\d)-(\d\d)-(\d\d)$/;
var $26214805efdd63e4$var$DAYS = [
    0,
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
var $26214805efdd63e4$var$TIME = /^(\d\d):(\d\d):(\d\d)(\.\d+)?(z|[+-]\d\d(?::?\d\d)?)?$/i;
var $26214805efdd63e4$var$HOSTNAME = /^(?=.{1,253}\.?$)[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[-0-9a-z]{0,61}[0-9a-z])?)*\.?$/i;
var $26214805efdd63e4$var$URI = /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'()*+,;=:@]|%[0-9a-f]{2})*)*)(?:\?(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
var $26214805efdd63e4$var$URIREF = /^(?:[a-z][a-z0-9+\-.]*:)?(?:\/?\/(?:(?:[a-z0-9\-._~!$&'()*+,;=:]|%[0-9a-f]{2})*@)?(?:\[(?:(?:(?:(?:[0-9a-f]{1,4}:){6}|::(?:[0-9a-f]{1,4}:){5}|(?:[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){4}|(?:(?:[0-9a-f]{1,4}:){0,1}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){3}|(?:(?:[0-9a-f]{1,4}:){0,2}[0-9a-f]{1,4})?::(?:[0-9a-f]{1,4}:){2}|(?:(?:[0-9a-f]{1,4}:){0,3}[0-9a-f]{1,4})?::[0-9a-f]{1,4}:|(?:(?:[0-9a-f]{1,4}:){0,4}[0-9a-f]{1,4})?::)(?:[0-9a-f]{1,4}:[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?))|(?:(?:[0-9a-f]{1,4}:){0,5}[0-9a-f]{1,4})?::[0-9a-f]{1,4}|(?:(?:[0-9a-f]{1,4}:){0,6}[0-9a-f]{1,4})?::)|[Vv][0-9a-f]+\.[a-z0-9\-._~!$&'()*+,;=:]+)\]|(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)|(?:[a-z0-9\-._~!$&'"()*+,;=]|%[0-9a-f]{2})*)(?::\d*)?(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*|\/(?:(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?|(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})+(?:\/(?:[a-z0-9\-._~!$&'"()*+,;=:@]|%[0-9a-f]{2})*)*)?(?:\?(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?(?:#(?:[a-z0-9\-._~!$&'"()*+,;=:@/?]|%[0-9a-f]{2})*)?$/i;
// uri-template: https://tools.ietf.org/html/rfc6570
var $26214805efdd63e4$var$URITEMPLATE = /^(?:(?:[^\x00-\x20"'<>%\\^`{|}]|%[0-9a-f]{2})|\{[+#./;?&=,!@|]?(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?(?:,(?:[a-z0-9_]|%[0-9a-f]{2})+(?::[1-9][0-9]{0,3}|\*)?)*\})*$/i;
// For the source: https://gist.github.com/dperini/729294
// For test cases: https://mathiasbynens.be/demo/url-regex
// @todo Delete current URL in favour of the commented out URL rule when this issue is fixed https://github.com/eslint/eslint/issues/7983.
// var URL = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u{00a1}-\u{ffff}0-9]+-)*[a-z\u{00a1}-\u{ffff}0-9]+)(?:\.(?:[a-z\u{00a1}-\u{ffff}0-9]+-)*[a-z\u{00a1}-\u{ffff}0-9]+)*(?:\.(?:[a-z\u{00a1}-\u{ffff}]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/iu;
var $26214805efdd63e4$var$URL = /^(?:(?:http[s\u017F]?|ftp):\/\/)(?:(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+(?::(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?@)?(?:(?!10(?:\.[0-9]{1,3}){3})(?!127(?:\.[0-9]{1,3}){3})(?!169\.254(?:\.[0-9]{1,3}){2})(?!192\.168(?:\.[0-9]{1,3}){2})(?!172\.(?:1[6-9]|2[0-9]|3[01])(?:\.[0-9]{1,3}){2})(?:[1-9][0-9]?|1[0-9][0-9]|2[01][0-9]|22[0-3])(?:\.(?:1?[0-9]{1,2}|2[0-4][0-9]|25[0-5])){2}(?:\.(?:[1-9][0-9]?|1[0-9][0-9]|2[0-4][0-9]|25[0-4]))|(?:(?:(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-)*(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)(?:\.(?:(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+-)*(?:[0-9a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])+)*(?:\.(?:(?:[a-z\xA1-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]){2,})))(?::[0-9]{2,5})?(?:\/(?:[\0-\x08\x0E-\x1F!-\x9F\xA1-\u167F\u1681-\u1FFF\u200B-\u2027\u202A-\u202E\u2030-\u205E\u2060-\u2FFF\u3001-\uD7FF\uE000-\uFEFE\uFF00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*)?$/i;
var $26214805efdd63e4$var$UUID = /^(?:urn:uuid:)?[0-9a-f]{8}-(?:[0-9a-f]{4}-){3}[0-9a-f]{12}$/i;
var $26214805efdd63e4$var$JSON_POINTER = /^(?:\/(?:[^~/]|~0|~1)*)*$/;
var $26214805efdd63e4$var$JSON_POINTER_URI_FRAGMENT = /^#(?:\/(?:[a-z0-9_\-.!$&'()*+,;:=@]|%[0-9a-f]{2}|~0|~1)*)*$/i;
var $26214805efdd63e4$var$RELATIVE_JSON_POINTER = /^(?:0|[1-9][0-9]*)(?:#|(?:\/(?:[^~/]|~0|~1)*)*)$/;
module.exports = $26214805efdd63e4$var$formats;
function $26214805efdd63e4$var$formats(mode) {
    mode = mode == "full" ? "full" : "fast";
    return $lv04s.copy($26214805efdd63e4$var$formats[mode]);
}
$26214805efdd63e4$var$formats.fast = {
    // date: http://tools.ietf.org/html/rfc3339#section-5.6
    date: /^\d\d\d\d-[0-1]\d-[0-3]\d$/,
    // date-time: http://tools.ietf.org/html/rfc3339#section-5.6
    time: /^(?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)?$/i,
    "date-time": /^\d\d\d\d-[0-1]\d-[0-3]\d[t\s](?:[0-2]\d:[0-5]\d:[0-5]\d|23:59:60)(?:\.\d+)?(?:z|[+-]\d\d(?::?\d\d)?)$/i,
    // uri: https://github.com/mafintosh/is-my-json-valid/blob/master/formats.js
    uri: /^(?:[a-z][a-z0-9+\-.]*:)(?:\/?\/)?[^\s]*$/i,
    "uri-reference": /^(?:(?:[a-z][a-z0-9+\-.]*:)?\/?\/)?(?:[^\\\s#][^\s#]*)?(?:#[^\\\s]*)?$/i,
    "uri-template": $26214805efdd63e4$var$URITEMPLATE,
    url: $26214805efdd63e4$var$URL,
    // email (sources from jsen validator):
    // http://stackoverflow.com/questions/201323/using-a-regular-expression-to-validate-an-email-address#answer-8829363
    // http://www.w3.org/TR/html5/forms.html#valid-e-mail-address (search for 'willful violation')
    email: /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i,
    hostname: $26214805efdd63e4$var$HOSTNAME,
    // optimized https://www.safaribooksonline.com/library/view/regular-expressions-cookbook/9780596802837/ch07s16.html
    ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
    // optimized http://stackoverflow.com/questions/53497/regular-expression-that-matches-valid-ipv6-addresses
    ipv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,
    regex: $26214805efdd63e4$var$regex,
    // uuid: http://tools.ietf.org/html/rfc4122
    uuid: $26214805efdd63e4$var$UUID,
    // JSON-pointer: https://tools.ietf.org/html/rfc6901
    // uri fragment: https://tools.ietf.org/html/rfc3986#appendix-A
    "json-pointer": $26214805efdd63e4$var$JSON_POINTER,
    "json-pointer-uri-fragment": $26214805efdd63e4$var$JSON_POINTER_URI_FRAGMENT,
    // relative JSON-pointer: http://tools.ietf.org/html/draft-luff-relative-json-pointer-00
    "relative-json-pointer": $26214805efdd63e4$var$RELATIVE_JSON_POINTER
};
$26214805efdd63e4$var$formats.full = {
    date: $26214805efdd63e4$var$date,
    time: $26214805efdd63e4$var$time,
    "date-time": $26214805efdd63e4$var$date_time,
    uri: $26214805efdd63e4$var$uri,
    "uri-reference": $26214805efdd63e4$var$URIREF,
    "uri-template": $26214805efdd63e4$var$URITEMPLATE,
    url: $26214805efdd63e4$var$URL,
    email: /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/i,
    hostname: $26214805efdd63e4$var$HOSTNAME,
    ipv4: /^(?:(?:25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(?:25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
    ipv6: /^\s*(?:(?:(?:[0-9a-f]{1,4}:){7}(?:[0-9a-f]{1,4}|:))|(?:(?:[0-9a-f]{1,4}:){6}(?::[0-9a-f]{1,4}|(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){5}(?:(?:(?::[0-9a-f]{1,4}){1,2})|:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(?:(?:[0-9a-f]{1,4}:){4}(?:(?:(?::[0-9a-f]{1,4}){1,3})|(?:(?::[0-9a-f]{1,4})?:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){3}(?:(?:(?::[0-9a-f]{1,4}){1,4})|(?:(?::[0-9a-f]{1,4}){0,2}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){2}(?:(?:(?::[0-9a-f]{1,4}){1,5})|(?:(?::[0-9a-f]{1,4}){0,3}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?:(?:[0-9a-f]{1,4}:){1}(?:(?:(?::[0-9a-f]{1,4}){1,6})|(?:(?::[0-9a-f]{1,4}){0,4}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(?::(?:(?:(?::[0-9a-f]{1,4}){1,7})|(?:(?::[0-9a-f]{1,4}){0,5}:(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(?:%.+)?\s*$/i,
    regex: $26214805efdd63e4$var$regex,
    uuid: $26214805efdd63e4$var$UUID,
    "json-pointer": $26214805efdd63e4$var$JSON_POINTER,
    "json-pointer-uri-fragment": $26214805efdd63e4$var$JSON_POINTER_URI_FRAGMENT,
    "relative-json-pointer": $26214805efdd63e4$var$RELATIVE_JSON_POINTER
};
function $26214805efdd63e4$var$isLeapYear(year) {
    // https://tools.ietf.org/html/rfc3339#appendix-C
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function $26214805efdd63e4$var$date(str) {
    // full-date from http://tools.ietf.org/html/rfc3339#section-5.6
    var matches = str.match($26214805efdd63e4$var$DATE);
    if (!matches) return false;
    var year = +matches[1];
    var month = +matches[2];
    var day = +matches[3];
    return month >= 1 && month <= 12 && day >= 1 && day <= (month == 2 && $26214805efdd63e4$var$isLeapYear(year) ? 29 : $26214805efdd63e4$var$DAYS[month]);
}
function $26214805efdd63e4$var$time(str, full) {
    var matches = str.match($26214805efdd63e4$var$TIME);
    if (!matches) return false;
    var hour = matches[1];
    var minute = matches[2];
    var second = matches[3];
    var timeZone = matches[5];
    return (hour <= 23 && minute <= 59 && second <= 59 || hour == 23 && minute == 59 && second == 60) && (!full || timeZone);
}
var $26214805efdd63e4$var$DATE_TIME_SEPARATOR = /t|\s/i;
function $26214805efdd63e4$var$date_time(str) {
    // http://tools.ietf.org/html/rfc3339#section-5.6
    var dateTime = str.split($26214805efdd63e4$var$DATE_TIME_SEPARATOR);
    return dateTime.length == 2 && $26214805efdd63e4$var$date(dateTime[0]) && $26214805efdd63e4$var$time(dateTime[1], true);
}
var $26214805efdd63e4$var$NOT_URI_FRAGMENT = /\/|:/;
function $26214805efdd63e4$var$uri(str) {
    // http://jmrware.com/articles/2009/uri_regexp/URI_regex.html + optional protocol + required "."
    return $26214805efdd63e4$var$NOT_URI_FRAGMENT.test(str) && $26214805efdd63e4$var$URI.test(str);
}
var $26214805efdd63e4$var$Z_ANCHOR = /[^\\]\\Z/;
function $26214805efdd63e4$var$regex(str) {
    if ($26214805efdd63e4$var$Z_ANCHOR.test(str)) return false;
    try {
        new RegExp(str);
        return true;
    } catch (e) {
        return false;
    }
}

});

parcelRegister("K8gzo", function(module, exports) {
"use strict";

var $izfQw = parcelRequire("izfQw");

var $lv04s = parcelRequire("lv04s");
var $08aab57fb2e76c5c$require$toHash = $lv04s.toHash;
module.exports = function rules() {
    var RULES = [
        {
            type: "number",
            rules: [
                {
                    "maximum": [
                        "exclusiveMaximum"
                    ]
                },
                {
                    "minimum": [
                        "exclusiveMinimum"
                    ]
                },
                "multipleOf",
                "format"
            ]
        },
        {
            type: "string",
            rules: [
                "maxLength",
                "minLength",
                "pattern",
                "format"
            ]
        },
        {
            type: "array",
            rules: [
                "maxItems",
                "minItems",
                "items",
                "contains",
                "uniqueItems"
            ]
        },
        {
            type: "object",
            rules: [
                "maxProperties",
                "minProperties",
                "required",
                "dependencies",
                "propertyNames",
                {
                    "properties": [
                        "additionalProperties",
                        "patternProperties"
                    ]
                }
            ]
        },
        {
            rules: [
                "$ref",
                "const",
                "enum",
                "not",
                "anyOf",
                "oneOf",
                "allOf",
                "if"
            ]
        }
    ];
    var ALL = [
        "type",
        "$comment"
    ];
    var KEYWORDS = [
        "$schema",
        "$id",
        "id",
        "$data",
        "$async",
        "title",
        "description",
        "default",
        "definitions",
        "examples",
        "readOnly",
        "writeOnly",
        "contentMediaType",
        "contentEncoding",
        "additionalItems",
        "then",
        "else"
    ];
    var TYPES = [
        "number",
        "integer",
        "string",
        "array",
        "object",
        "boolean",
        "null"
    ];
    RULES.all = $08aab57fb2e76c5c$require$toHash(ALL);
    RULES.types = $08aab57fb2e76c5c$require$toHash(TYPES);
    RULES.forEach(function(group) {
        group.rules = group.rules.map(function(keyword) {
            var implKeywords;
            if (typeof keyword == "object") {
                var key = Object.keys(keyword)[0];
                implKeywords = keyword[key];
                keyword = key;
                implKeywords.forEach(function(k) {
                    ALL.push(k);
                    RULES.all[k] = true;
                });
            }
            ALL.push(keyword);
            var rule = RULES.all[keyword] = {
                keyword: keyword,
                code: $izfQw[keyword],
                implements: implKeywords
            };
            return rule;
        });
        RULES.all.$comment = {
            keyword: "$comment",
            code: $izfQw.$comment
        };
        if (group.type) RULES.types[group.type] = group;
    });
    RULES.keywords = $08aab57fb2e76c5c$require$toHash(ALL.concat(KEYWORDS));
    RULES.custom = {};
    return RULES;
};

});
parcelRegister("izfQw", function(module, exports) {
"use strict";




























//all requires must be explicit because browserify won't work with dynamic requires
module.exports = {
    "$ref": (parcelRequire("iuibv")),
    allOf: (parcelRequire("8l317")),
    anyOf: (parcelRequire("03aUl")),
    "$comment": (parcelRequire("hODi9")),
    const: (parcelRequire("eGqs8")),
    contains: (parcelRequire("71pCV")),
    dependencies: (parcelRequire("5Q6Mj")),
    "enum": (parcelRequire("iSCzF")),
    format: (parcelRequire("kd1CH")),
    "if": (parcelRequire("apTZx")),
    items: (parcelRequire("ba5xx")),
    maximum: (parcelRequire("lgn6A")),
    minimum: (parcelRequire("lgn6A")),
    maxItems: (parcelRequire("13J9x")),
    minItems: (parcelRequire("13J9x")),
    maxLength: (parcelRequire("jRn3o")),
    minLength: (parcelRequire("jRn3o")),
    maxProperties: (parcelRequire("QwtK5")),
    minProperties: (parcelRequire("QwtK5")),
    multipleOf: (parcelRequire("kHCrn")),
    not: (parcelRequire("hR68u")),
    oneOf: (parcelRequire("5HumT")),
    pattern: (parcelRequire("famX3")),
    properties: (parcelRequire("l3qDZ")),
    propertyNames: (parcelRequire("cltmp")),
    required: (parcelRequire("1dWcG")),
    uniqueItems: (parcelRequire("cfMdF")),
    validate: (parcelRequire("dtJDJ"))
};

});
parcelRegister("iuibv", function(module, exports) {
"use strict";
module.exports = function generate_ref(it, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $valid = "valid" + $lvl;
    var $async, $refCode;
    if ($schema == "#" || $schema == "#/") {
        if (it.isRoot) {
            $async = it.async;
            $refCode = "validate";
        } else {
            $async = it.root.schema.$async === true;
            $refCode = "root.refVal[0]";
        }
    } else {
        var $refVal = it.resolveRef(it.baseId, $schema, it.isRoot);
        if ($refVal === undefined) {
            var $message = it.MissingRefError.message(it.baseId, $schema);
            if (it.opts.missingRefs == "fail") {
                it.logger.error($message);
                var $$outStack = $$outStack || [];
                $$outStack.push(out);
                out = ""; /* istanbul ignore else */ 
                if (it.createErrors !== false) {
                    out += " { keyword: '$ref' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { ref: '" + it.util.escapeQuotes($schema) + "' } ";
                    if (it.opts.messages !== false) out += " , message: 'can\\'t resolve reference " + it.util.escapeQuotes($schema) + "' ";
                    if (it.opts.verbose) out += " , schema: " + it.util.toQuotedString($schema) + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
                    out += " } ";
                } else out += " {} ";
                var __err = out;
                out = $$outStack.pop();
                if (!it.compositeRule && $breakOnError) {
                    /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
                    else out += " validate.errors = [" + __err + "]; return false; ";
                } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
                if ($breakOnError) out += " if (false) { ";
            } else if (it.opts.missingRefs == "ignore") {
                it.logger.warn($message);
                if ($breakOnError) out += " if (true) { ";
            } else throw new it.MissingRefError(it.baseId, $schema, $message);
        } else if ($refVal.inline) {
            var $it = it.util.copy(it);
            $it.level++;
            var $nextValid = "valid" + $it.level;
            $it.schema = $refVal.schema;
            $it.schemaPath = "";
            $it.errSchemaPath = $schema;
            var $code = it.validate($it).replace(/validate\.schema/g, $refVal.code);
            out += " " + $code + " ";
            if ($breakOnError) out += " if (" + $nextValid + ") { ";
        } else {
            $async = $refVal.$async === true || it.async && $refVal.$async !== false;
            $refCode = $refVal.code;
        }
    }
    if ($refCode) {
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = "";
        if (it.opts.passContext) out += " " + $refCode + ".call(this, ";
        else out += " " + $refCode + "( ";
        out += " " + $data + ", (dataPath || '')";
        if (it.errorPath != '""') out += " + " + it.errorPath;
        var $parentData = $dataLvl ? "data" + ($dataLvl - 1 || "") : "parentData", $parentDataProperty = $dataLvl ? it.dataPathArr[$dataLvl] : "parentDataProperty";
        out += " , " + $parentData + " , " + $parentDataProperty + ", rootData)  ";
        var __callValidate = out;
        out = $$outStack.pop();
        if ($async) {
            if (!it.async) throw new Error("async schema referenced by sync schema");
            if ($breakOnError) out += " var " + $valid + "; ";
            out += " try { await " + __callValidate + "; ";
            if ($breakOnError) out += " " + $valid + " = true; ";
            out += " } catch (e) { if (!(e instanceof ValidationError)) throw e; if (vErrors === null) vErrors = e.errors; else vErrors = vErrors.concat(e.errors); errors = vErrors.length; ";
            if ($breakOnError) out += " " + $valid + " = false; ";
            out += " } ";
            if ($breakOnError) out += " if (" + $valid + ") { ";
        } else {
            out += " if (!" + __callValidate + ") { if (vErrors === null) vErrors = " + $refCode + ".errors; else vErrors = vErrors.concat(" + $refCode + ".errors); errors = vErrors.length; } ";
            if ($breakOnError) out += " else { ";
        }
    }
    return out;
};

});

parcelRegister("8l317", function(module, exports) {
"use strict";
module.exports = function generate_allOf(it, $keyword, $ruleType) {
    var out = " ";
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $it = it.util.copy(it);
    var $closingBraces = "";
    $it.level++;
    var $nextValid = "valid" + $it.level;
    var $currentBaseId = $it.baseId, $allSchemasEmpty = true;
    var arr1 = $schema;
    if (arr1) {
        var $sch, $i = -1, l1 = arr1.length - 1;
        while($i < l1){
            $sch = arr1[$i += 1];
            if (it.opts.strictKeywords ? typeof $sch == "object" && Object.keys($sch).length > 0 || $sch === false : it.util.schemaHasRules($sch, it.RULES.all)) {
                $allSchemasEmpty = false;
                $it.schema = $sch;
                $it.schemaPath = $schemaPath + "[" + $i + "]";
                $it.errSchemaPath = $errSchemaPath + "/" + $i;
                out += "  " + it.validate($it) + " ";
                $it.baseId = $currentBaseId;
                if ($breakOnError) {
                    out += " if (" + $nextValid + ") { ";
                    $closingBraces += "}";
                }
            }
        }
    }
    if ($breakOnError) {
        if ($allSchemasEmpty) out += " if (true) { ";
        else out += " " + $closingBraces.slice(0, -1) + " ";
    }
    return out;
};

});

parcelRegister("03aUl", function(module, exports) {
"use strict";
module.exports = function generate_anyOf(it, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $valid = "valid" + $lvl;
    var $errs = "errs__" + $lvl;
    var $it = it.util.copy(it);
    var $closingBraces = "";
    $it.level++;
    var $nextValid = "valid" + $it.level;
    var $noEmptySchema = $schema.every(function($sch) {
        return it.opts.strictKeywords ? typeof $sch == "object" && Object.keys($sch).length > 0 || $sch === false : it.util.schemaHasRules($sch, it.RULES.all);
    });
    if ($noEmptySchema) {
        var $currentBaseId = $it.baseId;
        out += " var " + $errs + " = errors; var " + $valid + " = false;  ";
        var $wasComposite = it.compositeRule;
        it.compositeRule = $it.compositeRule = true;
        var arr1 = $schema;
        if (arr1) {
            var $sch, $i = -1, l1 = arr1.length - 1;
            while($i < l1){
                $sch = arr1[$i += 1];
                $it.schema = $sch;
                $it.schemaPath = $schemaPath + "[" + $i + "]";
                $it.errSchemaPath = $errSchemaPath + "/" + $i;
                out += "  " + it.validate($it) + " ";
                $it.baseId = $currentBaseId;
                out += " " + $valid + " = " + $valid + " || " + $nextValid + "; if (!" + $valid + ") { ";
                $closingBraces += "}";
            }
        }
        it.compositeRule = $it.compositeRule = $wasComposite;
        out += " " + $closingBraces + " if (!" + $valid + ") {   var err =   "; /* istanbul ignore else */ 
        if (it.createErrors !== false) {
            out += " { keyword: 'anyOf' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: {} ";
            if (it.opts.messages !== false) out += " , message: 'should match some schema in anyOf' ";
            if (it.opts.verbose) out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
            out += " } ";
        } else out += " {} ";
        out += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
        if (!it.compositeRule && $breakOnError) {
            /* istanbul ignore if */ if (it.async) out += " throw new ValidationError(vErrors); ";
            else out += " validate.errors = vErrors; return false; ";
        }
        out += " } else {  errors = " + $errs + "; if (vErrors !== null) { if (" + $errs + ") vErrors.length = " + $errs + "; else vErrors = null; } ";
        if (it.opts.allErrors) out += " } ";
    } else if ($breakOnError) out += " if (true) { ";
    return out;
};

});

parcelRegister("hODi9", function(module, exports) {
"use strict";
module.exports = function generate_comment(it, $keyword, $ruleType) {
    var out = " ";
    var $schema = it.schema[$keyword];
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $comment = it.util.toQuotedString($schema);
    if (it.opts.$comment === true) out += " console.log(" + $comment + ");";
    else if (typeof it.opts.$comment == "function") out += " self._opts.$comment(" + $comment + ", " + it.util.toQuotedString($errSchemaPath) + ", validate.root.schema);";
    return out;
};

});

parcelRegister("eGqs8", function(module, exports) {
"use strict";
module.exports = function generate_const(it, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $valid = "valid" + $lvl;
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += " var schema" + $lvl + " = " + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + "; ";
        $schemaValue = "schema" + $lvl;
    } else $schemaValue = $schema;
    if (!$isData) out += " var schema" + $lvl + " = validate.schema" + $schemaPath + ";";
    out += "var " + $valid + " = equal(" + $data + ", schema" + $lvl + "); if (!" + $valid + ") {   ";
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ""; /* istanbul ignore else */ 
    if (it.createErrors !== false) {
        out += " { keyword: 'const' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { allowedValue: schema" + $lvl + " } ";
        if (it.opts.messages !== false) out += " , message: 'should be equal to constant' ";
        if (it.opts.verbose) out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
        out += " } ";
    } else out += " {} ";
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
        else out += " validate.errors = [" + __err + "]; return false; ";
    } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
    out += " }";
    if ($breakOnError) out += " else { ";
    return out;
};

});

parcelRegister("71pCV", function(module, exports) {
"use strict";
module.exports = function generate_contains(it, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $valid = "valid" + $lvl;
    var $errs = "errs__" + $lvl;
    var $it = it.util.copy(it);
    var $closingBraces = "";
    $it.level++;
    var $nextValid = "valid" + $it.level;
    var $idx = "i" + $lvl, $dataNxt = $it.dataLevel = it.dataLevel + 1, $nextData = "data" + $dataNxt, $currentBaseId = it.baseId, $nonEmptySchema = it.opts.strictKeywords ? typeof $schema == "object" && Object.keys($schema).length > 0 || $schema === false : it.util.schemaHasRules($schema, it.RULES.all);
    out += "var " + $errs + " = errors;var " + $valid + ";";
    if ($nonEmptySchema) {
        var $wasComposite = it.compositeRule;
        it.compositeRule = $it.compositeRule = true;
        $it.schema = $schema;
        $it.schemaPath = $schemaPath;
        $it.errSchemaPath = $errSchemaPath;
        out += " var " + $nextValid + " = false; for (var " + $idx + " = 0; " + $idx + " < " + $data + ".length; " + $idx + "++) { ";
        $it.errorPath = it.util.getPathExpr(it.errorPath, $idx, it.opts.jsonPointers, true);
        var $passData = $data + "[" + $idx + "]";
        $it.dataPathArr[$dataNxt] = $idx;
        var $code = it.validate($it);
        $it.baseId = $currentBaseId;
        if (it.util.varOccurences($code, $nextData) < 2) out += " " + it.util.varReplace($code, $nextData, $passData) + " ";
        else out += " var " + $nextData + " = " + $passData + "; " + $code + " ";
        out += " if (" + $nextValid + ") break; }  ";
        it.compositeRule = $it.compositeRule = $wasComposite;
        out += " " + $closingBraces + " if (!" + $nextValid + ") {";
    } else out += " if (" + $data + ".length == 0) {";
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ""; /* istanbul ignore else */ 
    if (it.createErrors !== false) {
        out += " { keyword: 'contains' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: {} ";
        if (it.opts.messages !== false) out += " , message: 'should contain a valid item' ";
        if (it.opts.verbose) out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
        out += " } ";
    } else out += " {} ";
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
        else out += " validate.errors = [" + __err + "]; return false; ";
    } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
    out += " } else { ";
    if ($nonEmptySchema) out += "  errors = " + $errs + "; if (vErrors !== null) { if (" + $errs + ") vErrors.length = " + $errs + "; else vErrors = null; } ";
    if (it.opts.allErrors) out += " } ";
    return out;
};

});

parcelRegister("5Q6Mj", function(module, exports) {
"use strict";
module.exports = function generate_dependencies(it, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $errs = "errs__" + $lvl;
    var $it = it.util.copy(it);
    var $closingBraces = "";
    $it.level++;
    var $nextValid = "valid" + $it.level;
    var $schemaDeps = {}, $propertyDeps = {}, $ownProperties = it.opts.ownProperties;
    for($property in $schema){
        if ($property == "__proto__") continue;
        var $sch = $schema[$property];
        var $deps = Array.isArray($sch) ? $propertyDeps : $schemaDeps;
        $deps[$property] = $sch;
    }
    out += "var " + $errs + " = errors;";
    var $currentErrorPath = it.errorPath;
    out += "var missing" + $lvl + ";";
    for(var $property in $propertyDeps){
        $deps = $propertyDeps[$property];
        if ($deps.length) {
            out += " if ( " + $data + it.util.getProperty($property) + " !== undefined ";
            if ($ownProperties) out += " && Object.prototype.hasOwnProperty.call(" + $data + ", '" + it.util.escapeQuotes($property) + "') ";
            if ($breakOnError) {
                out += " && ( ";
                var arr1 = $deps;
                if (arr1) {
                    var $propertyKey, $i = -1, l1 = arr1.length - 1;
                    while($i < l1){
                        $propertyKey = arr1[$i += 1];
                        if ($i) out += " || ";
                        var $prop = it.util.getProperty($propertyKey), $useData = $data + $prop;
                        out += " ( ( " + $useData + " === undefined ";
                        if ($ownProperties) out += " || ! Object.prototype.hasOwnProperty.call(" + $data + ", '" + it.util.escapeQuotes($propertyKey) + "') ";
                        out += ") && (missing" + $lvl + " = " + it.util.toQuotedString(it.opts.jsonPointers ? $propertyKey : $prop) + ") ) ";
                    }
                }
                out += ")) {  ";
                var $propertyPath = "missing" + $lvl, $missingProperty = "' + " + $propertyPath + " + '";
                if (it.opts._errorDataPathProperty) it.errorPath = it.opts.jsonPointers ? it.util.getPathExpr($currentErrorPath, $propertyPath, true) : $currentErrorPath + " + " + $propertyPath;
                var $$outStack = $$outStack || [];
                $$outStack.push(out);
                out = ""; /* istanbul ignore else */ 
                if (it.createErrors !== false) {
                    out += " { keyword: 'dependencies' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { property: '" + it.util.escapeQuotes($property) + "', missingProperty: '" + $missingProperty + "', depsCount: " + $deps.length + ", deps: '" + it.util.escapeQuotes($deps.length == 1 ? $deps[0] : $deps.join(", ")) + "' } ";
                    if (it.opts.messages !== false) {
                        out += " , message: 'should have ";
                        if ($deps.length == 1) out += "property " + it.util.escapeQuotes($deps[0]);
                        else out += "properties " + it.util.escapeQuotes($deps.join(", "));
                        out += " when property " + it.util.escapeQuotes($property) + " is present' ";
                    }
                    if (it.opts.verbose) out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
                    out += " } ";
                } else out += " {} ";
                var __err = out;
                out = $$outStack.pop();
                if (!it.compositeRule && $breakOnError) {
                    /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
                    else out += " validate.errors = [" + __err + "]; return false; ";
                } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
            } else {
                out += " ) { ";
                var arr2 = $deps;
                if (arr2) {
                    var $propertyKey, i2 = -1, l2 = arr2.length - 1;
                    while(i2 < l2){
                        $propertyKey = arr2[i2 += 1];
                        var $prop = it.util.getProperty($propertyKey), $missingProperty = it.util.escapeQuotes($propertyKey), $useData = $data + $prop;
                        if (it.opts._errorDataPathProperty) it.errorPath = it.util.getPath($currentErrorPath, $propertyKey, it.opts.jsonPointers);
                        out += " if ( " + $useData + " === undefined ";
                        if ($ownProperties) out += " || ! Object.prototype.hasOwnProperty.call(" + $data + ", '" + it.util.escapeQuotes($propertyKey) + "') ";
                        out += ") {  var err =   "; /* istanbul ignore else */ 
                        if (it.createErrors !== false) {
                            out += " { keyword: 'dependencies' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { property: '" + it.util.escapeQuotes($property) + "', missingProperty: '" + $missingProperty + "', depsCount: " + $deps.length + ", deps: '" + it.util.escapeQuotes($deps.length == 1 ? $deps[0] : $deps.join(", ")) + "' } ";
                            if (it.opts.messages !== false) {
                                out += " , message: 'should have ";
                                if ($deps.length == 1) out += "property " + it.util.escapeQuotes($deps[0]);
                                else out += "properties " + it.util.escapeQuotes($deps.join(", "));
                                out += " when property " + it.util.escapeQuotes($property) + " is present' ";
                            }
                            if (it.opts.verbose) out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
                            out += " } ";
                        } else out += " {} ";
                        out += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ";
                    }
                }
            }
            out += " }   ";
            if ($breakOnError) {
                $closingBraces += "}";
                out += " else { ";
            }
        }
    }
    it.errorPath = $currentErrorPath;
    var $currentBaseId = $it.baseId;
    for(var $property in $schemaDeps){
        var $sch = $schemaDeps[$property];
        if (it.opts.strictKeywords ? typeof $sch == "object" && Object.keys($sch).length > 0 || $sch === false : it.util.schemaHasRules($sch, it.RULES.all)) {
            out += " " + $nextValid + " = true; if ( " + $data + it.util.getProperty($property) + " !== undefined ";
            if ($ownProperties) out += " && Object.prototype.hasOwnProperty.call(" + $data + ", '" + it.util.escapeQuotes($property) + "') ";
            out += ") { ";
            $it.schema = $sch;
            $it.schemaPath = $schemaPath + it.util.getProperty($property);
            $it.errSchemaPath = $errSchemaPath + "/" + it.util.escapeFragment($property);
            out += "  " + it.validate($it) + " ";
            $it.baseId = $currentBaseId;
            out += " }  ";
            if ($breakOnError) {
                out += " if (" + $nextValid + ") { ";
                $closingBraces += "}";
            }
        }
    }
    if ($breakOnError) out += "   " + $closingBraces + " if (" + $errs + " == errors) {";
    return out;
};

});

parcelRegister("iSCzF", function(module, exports) {
"use strict";
module.exports = function generate_enum(it, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $valid = "valid" + $lvl;
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += " var schema" + $lvl + " = " + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + "; ";
        $schemaValue = "schema" + $lvl;
    } else $schemaValue = $schema;
    var $i = "i" + $lvl, $vSchema = "schema" + $lvl;
    if (!$isData) out += " var " + $vSchema + " = validate.schema" + $schemaPath + ";";
    out += "var " + $valid + ";";
    if ($isData) out += " if (schema" + $lvl + " === undefined) " + $valid + " = true; else if (!Array.isArray(schema" + $lvl + ")) " + $valid + " = false; else {";
    out += "" + $valid + " = false;for (var " + $i + "=0; " + $i + "<" + $vSchema + ".length; " + $i + "++) if (equal(" + $data + ", " + $vSchema + "[" + $i + "])) { " + $valid + " = true; break; }";
    if ($isData) out += "  }  ";
    out += " if (!" + $valid + ") {   ";
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ""; /* istanbul ignore else */ 
    if (it.createErrors !== false) {
        out += " { keyword: 'enum' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { allowedValues: schema" + $lvl + " } ";
        if (it.opts.messages !== false) out += " , message: 'should be equal to one of the allowed values' ";
        if (it.opts.verbose) out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
        out += " } ";
    } else out += " {} ";
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
        else out += " validate.errors = [" + __err + "]; return false; ";
    } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
    out += " }";
    if ($breakOnError) out += " else { ";
    return out;
};

});

parcelRegister("kd1CH", function(module, exports) {
"use strict";
module.exports = function generate_format(it, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    if (it.opts.format === false) {
        if ($breakOnError) out += " if (true) { ";
        return out;
    }
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += " var schema" + $lvl + " = " + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + "; ";
        $schemaValue = "schema" + $lvl;
    } else $schemaValue = $schema;
    var $unknownFormats = it.opts.unknownFormats, $allowUnknown = Array.isArray($unknownFormats);
    if ($isData) {
        var $format = "format" + $lvl, $isObject = "isObject" + $lvl, $formatType = "formatType" + $lvl;
        out += " var " + $format + " = formats[" + $schemaValue + "]; var " + $isObject + " = typeof " + $format + " == 'object' && !(" + $format + " instanceof RegExp) && " + $format + ".validate; var " + $formatType + " = " + $isObject + " && " + $format + ".type || 'string'; if (" + $isObject + ") { ";
        if (it.async) out += " var async" + $lvl + " = " + $format + ".async; ";
        out += " " + $format + " = " + $format + ".validate; } if (  ";
        if ($isData) out += " (" + $schemaValue + " !== undefined && typeof " + $schemaValue + " != 'string') || ";
        out += " (";
        if ($unknownFormats != "ignore") {
            out += " (" + $schemaValue + " && !" + $format + " ";
            if ($allowUnknown) out += " && self._opts.unknownFormats.indexOf(" + $schemaValue + ") == -1 ";
            out += ") || ";
        }
        out += " (" + $format + " && " + $formatType + " == '" + $ruleType + "' && !(typeof " + $format + " == 'function' ? ";
        if (it.async) out += " (async" + $lvl + " ? await " + $format + "(" + $data + ") : " + $format + "(" + $data + ")) ";
        else out += " " + $format + "(" + $data + ") ";
        out += " : " + $format + ".test(" + $data + "))))) {";
    } else {
        var $format = it.formats[$schema];
        if (!$format) {
            if ($unknownFormats == "ignore") {
                it.logger.warn('unknown format "' + $schema + '" ignored in schema at path "' + it.errSchemaPath + '"');
                if ($breakOnError) out += " if (true) { ";
                return out;
            } else if ($allowUnknown && $unknownFormats.indexOf($schema) >= 0) {
                if ($breakOnError) out += " if (true) { ";
                return out;
            } else throw new Error('unknown format "' + $schema + '" is used in schema at path "' + it.errSchemaPath + '"');
        }
        var $isObject = typeof $format == "object" && !($format instanceof RegExp) && $format.validate;
        var $formatType = $isObject && $format.type || "string";
        if ($isObject) {
            var $async = $format.async === true;
            $format = $format.validate;
        }
        if ($formatType != $ruleType) {
            if ($breakOnError) out += " if (true) { ";
            return out;
        }
        if ($async) {
            if (!it.async) throw new Error("async format in sync schema");
            var $formatRef = "formats" + it.util.getProperty($schema) + ".validate";
            out += " if (!(await " + $formatRef + "(" + $data + "))) { ";
        } else {
            out += " if (! ";
            var $formatRef = "formats" + it.util.getProperty($schema);
            if ($isObject) $formatRef += ".validate";
            if (typeof $format == "function") out += " " + $formatRef + "(" + $data + ") ";
            else out += " " + $formatRef + ".test(" + $data + ") ";
            out += ") { ";
        }
    }
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ""; /* istanbul ignore else */ 
    if (it.createErrors !== false) {
        out += " { keyword: 'format' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { format:  ";
        if ($isData) out += "" + $schemaValue;
        else out += "" + it.util.toQuotedString($schema);
        out += "  } ";
        if (it.opts.messages !== false) {
            out += " , message: 'should match format \"";
            if ($isData) out += "' + " + $schemaValue + " + '";
            else out += "" + it.util.escapeQuotes($schema);
            out += "\"' ";
        }
        if (it.opts.verbose) {
            out += " , schema:  ";
            if ($isData) out += "validate.schema" + $schemaPath;
            else out += "" + it.util.toQuotedString($schema);
            out += "         , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
        }
        out += " } ";
    } else out += " {} ";
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
        else out += " validate.errors = [" + __err + "]; return false; ";
    } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
    out += " } ";
    if ($breakOnError) out += " else { ";
    return out;
};

});

parcelRegister("apTZx", function(module, exports) {
"use strict";
module.exports = function generate_if(it, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $valid = "valid" + $lvl;
    var $errs = "errs__" + $lvl;
    var $it = it.util.copy(it);
    $it.level++;
    var $nextValid = "valid" + $it.level;
    var $thenSch = it.schema["then"], $elseSch = it.schema["else"], $thenPresent = $thenSch !== undefined && (it.opts.strictKeywords ? typeof $thenSch == "object" && Object.keys($thenSch).length > 0 || $thenSch === false : it.util.schemaHasRules($thenSch, it.RULES.all)), $elsePresent = $elseSch !== undefined && (it.opts.strictKeywords ? typeof $elseSch == "object" && Object.keys($elseSch).length > 0 || $elseSch === false : it.util.schemaHasRules($elseSch, it.RULES.all)), $currentBaseId = $it.baseId;
    if ($thenPresent || $elsePresent) {
        var $ifClause;
        $it.createErrors = false;
        $it.schema = $schema;
        $it.schemaPath = $schemaPath;
        $it.errSchemaPath = $errSchemaPath;
        out += " var " + $errs + " = errors; var " + $valid + " = true;  ";
        var $wasComposite = it.compositeRule;
        it.compositeRule = $it.compositeRule = true;
        out += "  " + it.validate($it) + " ";
        $it.baseId = $currentBaseId;
        $it.createErrors = true;
        out += "  errors = " + $errs + "; if (vErrors !== null) { if (" + $errs + ") vErrors.length = " + $errs + "; else vErrors = null; }  ";
        it.compositeRule = $it.compositeRule = $wasComposite;
        if ($thenPresent) {
            out += " if (" + $nextValid + ") {  ";
            $it.schema = it.schema["then"];
            $it.schemaPath = it.schemaPath + ".then";
            $it.errSchemaPath = it.errSchemaPath + "/then";
            out += "  " + it.validate($it) + " ";
            $it.baseId = $currentBaseId;
            out += " " + $valid + " = " + $nextValid + "; ";
            if ($thenPresent && $elsePresent) {
                $ifClause = "ifClause" + $lvl;
                out += " var " + $ifClause + " = 'then'; ";
            } else $ifClause = "'then'";
            out += " } ";
            if ($elsePresent) out += " else { ";
        } else out += " if (!" + $nextValid + ") { ";
        if ($elsePresent) {
            $it.schema = it.schema["else"];
            $it.schemaPath = it.schemaPath + ".else";
            $it.errSchemaPath = it.errSchemaPath + "/else";
            out += "  " + it.validate($it) + " ";
            $it.baseId = $currentBaseId;
            out += " " + $valid + " = " + $nextValid + "; ";
            if ($thenPresent && $elsePresent) {
                $ifClause = "ifClause" + $lvl;
                out += " var " + $ifClause + " = 'else'; ";
            } else $ifClause = "'else'";
            out += " } ";
        }
        out += " if (!" + $valid + ") {   var err =   "; /* istanbul ignore else */ 
        if (it.createErrors !== false) {
            out += " { keyword: 'if' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { failingKeyword: " + $ifClause + " } ";
            if (it.opts.messages !== false) out += " , message: 'should match \"' + " + $ifClause + " + '\" schema' ";
            if (it.opts.verbose) out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
            out += " } ";
        } else out += " {} ";
        out += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
        if (!it.compositeRule && $breakOnError) {
            /* istanbul ignore if */ if (it.async) out += " throw new ValidationError(vErrors); ";
            else out += " validate.errors = vErrors; return false; ";
        }
        out += " }   ";
        if ($breakOnError) out += " else { ";
    } else if ($breakOnError) out += " if (true) { ";
    return out;
};

});

parcelRegister("ba5xx", function(module, exports) {
"use strict";
module.exports = function generate_items(it, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $valid = "valid" + $lvl;
    var $errs = "errs__" + $lvl;
    var $it = it.util.copy(it);
    var $closingBraces = "";
    $it.level++;
    var $nextValid = "valid" + $it.level;
    var $idx = "i" + $lvl, $dataNxt = $it.dataLevel = it.dataLevel + 1, $nextData = "data" + $dataNxt, $currentBaseId = it.baseId;
    out += "var " + $errs + " = errors;var " + $valid + ";";
    if (Array.isArray($schema)) {
        var $additionalItems = it.schema.additionalItems;
        if ($additionalItems === false) {
            out += " " + $valid + " = " + $data + ".length <= " + $schema.length + "; ";
            var $currErrSchemaPath = $errSchemaPath;
            $errSchemaPath = it.errSchemaPath + "/additionalItems";
            out += "  if (!" + $valid + ") {   ";
            var $$outStack = $$outStack || [];
            $$outStack.push(out);
            out = ""; /* istanbul ignore else */ 
            if (it.createErrors !== false) {
                out += " { keyword: 'additionalItems' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { limit: " + $schema.length + " } ";
                if (it.opts.messages !== false) out += " , message: 'should NOT have more than " + $schema.length + " items' ";
                if (it.opts.verbose) out += " , schema: false , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
                out += " } ";
            } else out += " {} ";
            var __err = out;
            out = $$outStack.pop();
            if (!it.compositeRule && $breakOnError) {
                /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
                else out += " validate.errors = [" + __err + "]; return false; ";
            } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
            out += " } ";
            $errSchemaPath = $currErrSchemaPath;
            if ($breakOnError) {
                $closingBraces += "}";
                out += " else { ";
            }
        }
        var arr1 = $schema;
        if (arr1) {
            var $sch, $i = -1, l1 = arr1.length - 1;
            while($i < l1){
                $sch = arr1[$i += 1];
                if (it.opts.strictKeywords ? typeof $sch == "object" && Object.keys($sch).length > 0 || $sch === false : it.util.schemaHasRules($sch, it.RULES.all)) {
                    out += " " + $nextValid + " = true; if (" + $data + ".length > " + $i + ") { ";
                    var $passData = $data + "[" + $i + "]";
                    $it.schema = $sch;
                    $it.schemaPath = $schemaPath + "[" + $i + "]";
                    $it.errSchemaPath = $errSchemaPath + "/" + $i;
                    $it.errorPath = it.util.getPathExpr(it.errorPath, $i, it.opts.jsonPointers, true);
                    $it.dataPathArr[$dataNxt] = $i;
                    var $code = it.validate($it);
                    $it.baseId = $currentBaseId;
                    if (it.util.varOccurences($code, $nextData) < 2) out += " " + it.util.varReplace($code, $nextData, $passData) + " ";
                    else out += " var " + $nextData + " = " + $passData + "; " + $code + " ";
                    out += " }  ";
                    if ($breakOnError) {
                        out += " if (" + $nextValid + ") { ";
                        $closingBraces += "}";
                    }
                }
            }
        }
        if (typeof $additionalItems == "object" && (it.opts.strictKeywords ? typeof $additionalItems == "object" && Object.keys($additionalItems).length > 0 || $additionalItems === false : it.util.schemaHasRules($additionalItems, it.RULES.all))) {
            $it.schema = $additionalItems;
            $it.schemaPath = it.schemaPath + ".additionalItems";
            $it.errSchemaPath = it.errSchemaPath + "/additionalItems";
            out += " " + $nextValid + " = true; if (" + $data + ".length > " + $schema.length + ") {  for (var " + $idx + " = " + $schema.length + "; " + $idx + " < " + $data + ".length; " + $idx + "++) { ";
            $it.errorPath = it.util.getPathExpr(it.errorPath, $idx, it.opts.jsonPointers, true);
            var $passData = $data + "[" + $idx + "]";
            $it.dataPathArr[$dataNxt] = $idx;
            var $code = it.validate($it);
            $it.baseId = $currentBaseId;
            if (it.util.varOccurences($code, $nextData) < 2) out += " " + it.util.varReplace($code, $nextData, $passData) + " ";
            else out += " var " + $nextData + " = " + $passData + "; " + $code + " ";
            if ($breakOnError) out += " if (!" + $nextValid + ") break; ";
            out += " } }  ";
            if ($breakOnError) {
                out += " if (" + $nextValid + ") { ";
                $closingBraces += "}";
            }
        }
    } else if (it.opts.strictKeywords ? typeof $schema == "object" && Object.keys($schema).length > 0 || $schema === false : it.util.schemaHasRules($schema, it.RULES.all)) {
        $it.schema = $schema;
        $it.schemaPath = $schemaPath;
        $it.errSchemaPath = $errSchemaPath;
        out += "  for (var " + $idx + " = " + 0 + "; " + $idx + " < " + $data + ".length; " + $idx + "++) { ";
        $it.errorPath = it.util.getPathExpr(it.errorPath, $idx, it.opts.jsonPointers, true);
        var $passData = $data + "[" + $idx + "]";
        $it.dataPathArr[$dataNxt] = $idx;
        var $code = it.validate($it);
        $it.baseId = $currentBaseId;
        if (it.util.varOccurences($code, $nextData) < 2) out += " " + it.util.varReplace($code, $nextData, $passData) + " ";
        else out += " var " + $nextData + " = " + $passData + "; " + $code + " ";
        if ($breakOnError) out += " if (!" + $nextValid + ") break; ";
        out += " }";
    }
    if ($breakOnError) out += " " + $closingBraces + " if (" + $errs + " == errors) {";
    return out;
};

});

parcelRegister("lgn6A", function(module, exports) {
"use strict";
module.exports = function generate__limit(it, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $errorKeyword;
    var $data = "data" + ($dataLvl || "");
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += " var schema" + $lvl + " = " + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + "; ";
        $schemaValue = "schema" + $lvl;
    } else $schemaValue = $schema;
    var $isMax = $keyword == "maximum", $exclusiveKeyword = $isMax ? "exclusiveMaximum" : "exclusiveMinimum", $schemaExcl = it.schema[$exclusiveKeyword], $isDataExcl = it.opts.$data && $schemaExcl && $schemaExcl.$data, $op = $isMax ? "<" : ">", $notOp = $isMax ? ">" : "<", $errorKeyword = undefined;
    if (!($isData || typeof $schema == "number" || $schema === undefined)) throw new Error($keyword + " must be number");
    if (!($isDataExcl || $schemaExcl === undefined || typeof $schemaExcl == "number" || typeof $schemaExcl == "boolean")) throw new Error($exclusiveKeyword + " must be number or boolean");
    if ($isDataExcl) {
        var $schemaValueExcl = it.util.getData($schemaExcl.$data, $dataLvl, it.dataPathArr), $exclusive = "exclusive" + $lvl, $exclType = "exclType" + $lvl, $exclIsNumber = "exclIsNumber" + $lvl, $opExpr = "op" + $lvl, $opStr = "' + " + $opExpr + " + '";
        out += " var schemaExcl" + $lvl + " = " + $schemaValueExcl + "; ";
        $schemaValueExcl = "schemaExcl" + $lvl;
        out += " var " + $exclusive + "; var " + $exclType + " = typeof " + $schemaValueExcl + "; if (" + $exclType + " != 'boolean' && " + $exclType + " != 'undefined' && " + $exclType + " != 'number') { ";
        var $errorKeyword = $exclusiveKeyword;
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = ""; /* istanbul ignore else */ 
        if (it.createErrors !== false) {
            out += " { keyword: '" + ($errorKeyword || "_exclusiveLimit") + "' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: {} ";
            if (it.opts.messages !== false) out += " , message: '" + $exclusiveKeyword + " should be boolean' ";
            if (it.opts.verbose) out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
            out += " } ";
        } else out += " {} ";
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
            /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
            else out += " validate.errors = [" + __err + "]; return false; ";
        } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
        out += " } else if ( ";
        if ($isData) out += " (" + $schemaValue + " !== undefined && typeof " + $schemaValue + " != 'number') || ";
        out += " " + $exclType + " == 'number' ? ( (" + $exclusive + " = " + $schemaValue + " === undefined || " + $schemaValueExcl + " " + $op + "= " + $schemaValue + ") ? " + $data + " " + $notOp + "= " + $schemaValueExcl + " : " + $data + " " + $notOp + " " + $schemaValue + " ) : ( (" + $exclusive + " = " + $schemaValueExcl + " === true) ? " + $data + " " + $notOp + "= " + $schemaValue + " : " + $data + " " + $notOp + " " + $schemaValue + " ) || " + $data + " !== " + $data + ") { var op" + $lvl + " = " + $exclusive + " ? '" + $op + "' : '" + $op + "='; ";
        if ($schema === undefined) {
            $errorKeyword = $exclusiveKeyword;
            $errSchemaPath = it.errSchemaPath + "/" + $exclusiveKeyword;
            $schemaValue = $schemaValueExcl;
            $isData = $isDataExcl;
        }
    } else {
        var $exclIsNumber = typeof $schemaExcl == "number", $opStr = $op;
        if ($exclIsNumber && $isData) {
            var $opExpr = "'" + $opStr + "'";
            out += " if ( ";
            if ($isData) out += " (" + $schemaValue + " !== undefined && typeof " + $schemaValue + " != 'number') || ";
            out += " ( " + $schemaValue + " === undefined || " + $schemaExcl + " " + $op + "= " + $schemaValue + " ? " + $data + " " + $notOp + "= " + $schemaExcl + " : " + $data + " " + $notOp + " " + $schemaValue + " ) || " + $data + " !== " + $data + ") { ";
        } else {
            if ($exclIsNumber && $schema === undefined) {
                $exclusive = true;
                $errorKeyword = $exclusiveKeyword;
                $errSchemaPath = it.errSchemaPath + "/" + $exclusiveKeyword;
                $schemaValue = $schemaExcl;
                $notOp += "=";
            } else {
                if ($exclIsNumber) $schemaValue = Math[$isMax ? "min" : "max"]($schemaExcl, $schema);
                if ($schemaExcl === ($exclIsNumber ? $schemaValue : true)) {
                    $exclusive = true;
                    $errorKeyword = $exclusiveKeyword;
                    $errSchemaPath = it.errSchemaPath + "/" + $exclusiveKeyword;
                    $notOp += "=";
                } else {
                    $exclusive = false;
                    $opStr += "=";
                }
            }
            var $opExpr = "'" + $opStr + "'";
            out += " if ( ";
            if ($isData) out += " (" + $schemaValue + " !== undefined && typeof " + $schemaValue + " != 'number') || ";
            out += " " + $data + " " + $notOp + " " + $schemaValue + " || " + $data + " !== " + $data + ") { ";
        }
    }
    $errorKeyword = $errorKeyword || $keyword;
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ""; /* istanbul ignore else */ 
    if (it.createErrors !== false) {
        out += " { keyword: '" + ($errorKeyword || "_limit") + "' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { comparison: " + $opExpr + ", limit: " + $schemaValue + ", exclusive: " + $exclusive + " } ";
        if (it.opts.messages !== false) {
            out += " , message: 'should be " + $opStr + " ";
            if ($isData) out += "' + " + $schemaValue;
            else out += "" + $schemaValue + "'";
        }
        if (it.opts.verbose) {
            out += " , schema:  ";
            if ($isData) out += "validate.schema" + $schemaPath;
            else out += "" + $schema;
            out += "         , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
        }
        out += " } ";
    } else out += " {} ";
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
        else out += " validate.errors = [" + __err + "]; return false; ";
    } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
    out += " } ";
    if ($breakOnError) out += " else { ";
    return out;
};

});

parcelRegister("13J9x", function(module, exports) {
"use strict";
module.exports = function generate__limitItems(it, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $errorKeyword;
    var $data = "data" + ($dataLvl || "");
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += " var schema" + $lvl + " = " + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + "; ";
        $schemaValue = "schema" + $lvl;
    } else $schemaValue = $schema;
    if (!($isData || typeof $schema == "number")) throw new Error($keyword + " must be number");
    var $op = $keyword == "maxItems" ? ">" : "<";
    out += "if ( ";
    if ($isData) out += " (" + $schemaValue + " !== undefined && typeof " + $schemaValue + " != 'number') || ";
    out += " " + $data + ".length " + $op + " " + $schemaValue + ") { ";
    var $errorKeyword = $keyword;
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ""; /* istanbul ignore else */ 
    if (it.createErrors !== false) {
        out += " { keyword: '" + ($errorKeyword || "_limitItems") + "' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { limit: " + $schemaValue + " } ";
        if (it.opts.messages !== false) {
            out += " , message: 'should NOT have ";
            if ($keyword == "maxItems") out += "more";
            else out += "fewer";
            out += " than ";
            if ($isData) out += "' + " + $schemaValue + " + '";
            else out += "" + $schema;
            out += " items' ";
        }
        if (it.opts.verbose) {
            out += " , schema:  ";
            if ($isData) out += "validate.schema" + $schemaPath;
            else out += "" + $schema;
            out += "         , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
        }
        out += " } ";
    } else out += " {} ";
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
        else out += " validate.errors = [" + __err + "]; return false; ";
    } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
    out += "} ";
    if ($breakOnError) out += " else { ";
    return out;
};

});

parcelRegister("jRn3o", function(module, exports) {
"use strict";
module.exports = function generate__limitLength(it, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $errorKeyword;
    var $data = "data" + ($dataLvl || "");
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += " var schema" + $lvl + " = " + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + "; ";
        $schemaValue = "schema" + $lvl;
    } else $schemaValue = $schema;
    if (!($isData || typeof $schema == "number")) throw new Error($keyword + " must be number");
    var $op = $keyword == "maxLength" ? ">" : "<";
    out += "if ( ";
    if ($isData) out += " (" + $schemaValue + " !== undefined && typeof " + $schemaValue + " != 'number') || ";
    if (it.opts.unicode === false) out += " " + $data + ".length ";
    else out += " ucs2length(" + $data + ") ";
    out += " " + $op + " " + $schemaValue + ") { ";
    var $errorKeyword = $keyword;
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ""; /* istanbul ignore else */ 
    if (it.createErrors !== false) {
        out += " { keyword: '" + ($errorKeyword || "_limitLength") + "' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { limit: " + $schemaValue + " } ";
        if (it.opts.messages !== false) {
            out += " , message: 'should NOT be ";
            if ($keyword == "maxLength") out += "longer";
            else out += "shorter";
            out += " than ";
            if ($isData) out += "' + " + $schemaValue + " + '";
            else out += "" + $schema;
            out += " characters' ";
        }
        if (it.opts.verbose) {
            out += " , schema:  ";
            if ($isData) out += "validate.schema" + $schemaPath;
            else out += "" + $schema;
            out += "         , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
        }
        out += " } ";
    } else out += " {} ";
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
        else out += " validate.errors = [" + __err + "]; return false; ";
    } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
    out += "} ";
    if ($breakOnError) out += " else { ";
    return out;
};

});

parcelRegister("QwtK5", function(module, exports) {
"use strict";
module.exports = function generate__limitProperties(it, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $errorKeyword;
    var $data = "data" + ($dataLvl || "");
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += " var schema" + $lvl + " = " + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + "; ";
        $schemaValue = "schema" + $lvl;
    } else $schemaValue = $schema;
    if (!($isData || typeof $schema == "number")) throw new Error($keyword + " must be number");
    var $op = $keyword == "maxProperties" ? ">" : "<";
    out += "if ( ";
    if ($isData) out += " (" + $schemaValue + " !== undefined && typeof " + $schemaValue + " != 'number') || ";
    out += " Object.keys(" + $data + ").length " + $op + " " + $schemaValue + ") { ";
    var $errorKeyword = $keyword;
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ""; /* istanbul ignore else */ 
    if (it.createErrors !== false) {
        out += " { keyword: '" + ($errorKeyword || "_limitProperties") + "' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { limit: " + $schemaValue + " } ";
        if (it.opts.messages !== false) {
            out += " , message: 'should NOT have ";
            if ($keyword == "maxProperties") out += "more";
            else out += "fewer";
            out += " than ";
            if ($isData) out += "' + " + $schemaValue + " + '";
            else out += "" + $schema;
            out += " properties' ";
        }
        if (it.opts.verbose) {
            out += " , schema:  ";
            if ($isData) out += "validate.schema" + $schemaPath;
            else out += "" + $schema;
            out += "         , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
        }
        out += " } ";
    } else out += " {} ";
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
        else out += " validate.errors = [" + __err + "]; return false; ";
    } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
    out += "} ";
    if ($breakOnError) out += " else { ";
    return out;
};

});

parcelRegister("kHCrn", function(module, exports) {
"use strict";
module.exports = function generate_multipleOf(it, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += " var schema" + $lvl + " = " + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + "; ";
        $schemaValue = "schema" + $lvl;
    } else $schemaValue = $schema;
    if (!($isData || typeof $schema == "number")) throw new Error($keyword + " must be number");
    out += "var division" + $lvl + ";if (";
    if ($isData) out += " " + $schemaValue + " !== undefined && ( typeof " + $schemaValue + " != 'number' || ";
    out += " (division" + $lvl + " = " + $data + " / " + $schemaValue + ", ";
    if (it.opts.multipleOfPrecision) out += " Math.abs(Math.round(division" + $lvl + ") - division" + $lvl + ") > 1e-" + it.opts.multipleOfPrecision + " ";
    else out += " division" + $lvl + " !== parseInt(division" + $lvl + ") ";
    out += " ) ";
    if ($isData) out += "  )  ";
    out += " ) {   ";
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ""; /* istanbul ignore else */ 
    if (it.createErrors !== false) {
        out += " { keyword: 'multipleOf' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { multipleOf: " + $schemaValue + " } ";
        if (it.opts.messages !== false) {
            out += " , message: 'should be multiple of ";
            if ($isData) out += "' + " + $schemaValue;
            else out += "" + $schemaValue + "'";
        }
        if (it.opts.verbose) {
            out += " , schema:  ";
            if ($isData) out += "validate.schema" + $schemaPath;
            else out += "" + $schema;
            out += "         , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
        }
        out += " } ";
    } else out += " {} ";
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
        else out += " validate.errors = [" + __err + "]; return false; ";
    } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
    out += "} ";
    if ($breakOnError) out += " else { ";
    return out;
};

});

parcelRegister("hR68u", function(module, exports) {
"use strict";
module.exports = function generate_not(it, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $errs = "errs__" + $lvl;
    var $it = it.util.copy(it);
    $it.level++;
    var $nextValid = "valid" + $it.level;
    if (it.opts.strictKeywords ? typeof $schema == "object" && Object.keys($schema).length > 0 || $schema === false : it.util.schemaHasRules($schema, it.RULES.all)) {
        $it.schema = $schema;
        $it.schemaPath = $schemaPath;
        $it.errSchemaPath = $errSchemaPath;
        out += " var " + $errs + " = errors;  ";
        var $wasComposite = it.compositeRule;
        it.compositeRule = $it.compositeRule = true;
        $it.createErrors = false;
        var $allErrorsOption;
        if ($it.opts.allErrors) {
            $allErrorsOption = $it.opts.allErrors;
            $it.opts.allErrors = false;
        }
        out += " " + it.validate($it) + " ";
        $it.createErrors = true;
        if ($allErrorsOption) $it.opts.allErrors = $allErrorsOption;
        it.compositeRule = $it.compositeRule = $wasComposite;
        out += " if (" + $nextValid + ") {   ";
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = ""; /* istanbul ignore else */ 
        if (it.createErrors !== false) {
            out += " { keyword: 'not' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: {} ";
            if (it.opts.messages !== false) out += " , message: 'should NOT be valid' ";
            if (it.opts.verbose) out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
            out += " } ";
        } else out += " {} ";
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
            /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
            else out += " validate.errors = [" + __err + "]; return false; ";
        } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
        out += " } else {  errors = " + $errs + "; if (vErrors !== null) { if (" + $errs + ") vErrors.length = " + $errs + "; else vErrors = null; } ";
        if (it.opts.allErrors) out += " } ";
    } else {
        out += "  var err =   "; /* istanbul ignore else */ 
        if (it.createErrors !== false) {
            out += " { keyword: 'not' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: {} ";
            if (it.opts.messages !== false) out += " , message: 'should NOT be valid' ";
            if (it.opts.verbose) out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
            out += " } ";
        } else out += " {} ";
        out += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
        if ($breakOnError) out += " if (false) { ";
    }
    return out;
};

});

parcelRegister("5HumT", function(module, exports) {
"use strict";
module.exports = function generate_oneOf(it, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $valid = "valid" + $lvl;
    var $errs = "errs__" + $lvl;
    var $it = it.util.copy(it);
    var $closingBraces = "";
    $it.level++;
    var $nextValid = "valid" + $it.level;
    var $currentBaseId = $it.baseId, $prevValid = "prevValid" + $lvl, $passingSchemas = "passingSchemas" + $lvl;
    out += "var " + $errs + " = errors , " + $prevValid + " = false , " + $valid + " = false , " + $passingSchemas + " = null; ";
    var $wasComposite = it.compositeRule;
    it.compositeRule = $it.compositeRule = true;
    var arr1 = $schema;
    if (arr1) {
        var $sch, $i = -1, l1 = arr1.length - 1;
        while($i < l1){
            $sch = arr1[$i += 1];
            if (it.opts.strictKeywords ? typeof $sch == "object" && Object.keys($sch).length > 0 || $sch === false : it.util.schemaHasRules($sch, it.RULES.all)) {
                $it.schema = $sch;
                $it.schemaPath = $schemaPath + "[" + $i + "]";
                $it.errSchemaPath = $errSchemaPath + "/" + $i;
                out += "  " + it.validate($it) + " ";
                $it.baseId = $currentBaseId;
            } else out += " var " + $nextValid + " = true; ";
            if ($i) {
                out += " if (" + $nextValid + " && " + $prevValid + ") { " + $valid + " = false; " + $passingSchemas + " = [" + $passingSchemas + ", " + $i + "]; } else { ";
                $closingBraces += "}";
            }
            out += " if (" + $nextValid + ") { " + $valid + " = " + $prevValid + " = true; " + $passingSchemas + " = " + $i + "; }";
        }
    }
    it.compositeRule = $it.compositeRule = $wasComposite;
    out += "" + $closingBraces + "if (!" + $valid + ") {   var err =   "; /* istanbul ignore else */ 
    if (it.createErrors !== false) {
        out += " { keyword: 'oneOf' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { passingSchemas: " + $passingSchemas + " } ";
        if (it.opts.messages !== false) out += " , message: 'should match exactly one schema in oneOf' ";
        if (it.opts.verbose) out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
        out += " } ";
    } else out += " {} ";
    out += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
    if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */ if (it.async) out += " throw new ValidationError(vErrors); ";
        else out += " validate.errors = vErrors; return false; ";
    }
    out += "} else {  errors = " + $errs + "; if (vErrors !== null) { if (" + $errs + ") vErrors.length = " + $errs + "; else vErrors = null; }";
    if (it.opts.allErrors) out += " } ";
    return out;
};

});

parcelRegister("famX3", function(module, exports) {
"use strict";
module.exports = function generate_pattern(it, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += " var schema" + $lvl + " = " + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + "; ";
        $schemaValue = "schema" + $lvl;
    } else $schemaValue = $schema;
    var $regexp = $isData ? "(new RegExp(" + $schemaValue + "))" : it.usePattern($schema);
    out += "if ( ";
    if ($isData) out += " (" + $schemaValue + " !== undefined && typeof " + $schemaValue + " != 'string') || ";
    out += " !" + $regexp + ".test(" + $data + ") ) {   ";
    var $$outStack = $$outStack || [];
    $$outStack.push(out);
    out = ""; /* istanbul ignore else */ 
    if (it.createErrors !== false) {
        out += " { keyword: 'pattern' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { pattern:  ";
        if ($isData) out += "" + $schemaValue;
        else out += "" + it.util.toQuotedString($schema);
        out += "  } ";
        if (it.opts.messages !== false) {
            out += " , message: 'should match pattern \"";
            if ($isData) out += "' + " + $schemaValue + " + '";
            else out += "" + it.util.escapeQuotes($schema);
            out += "\"' ";
        }
        if (it.opts.verbose) {
            out += " , schema:  ";
            if ($isData) out += "validate.schema" + $schemaPath;
            else out += "" + it.util.toQuotedString($schema);
            out += "         , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
        }
        out += " } ";
    } else out += " {} ";
    var __err = out;
    out = $$outStack.pop();
    if (!it.compositeRule && $breakOnError) {
        /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
        else out += " validate.errors = [" + __err + "]; return false; ";
    } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
    out += "} ";
    if ($breakOnError) out += " else { ";
    return out;
};

});

parcelRegister("l3qDZ", function(module, exports) {
"use strict";
module.exports = function generate_properties(it, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $errs = "errs__" + $lvl;
    var $it = it.util.copy(it);
    var $closingBraces = "";
    $it.level++;
    var $nextValid = "valid" + $it.level;
    var $key = "key" + $lvl, $idx = "idx" + $lvl, $dataNxt = $it.dataLevel = it.dataLevel + 1, $nextData = "data" + $dataNxt, $dataProperties = "dataProperties" + $lvl;
    var $schemaKeys = Object.keys($schema || {}).filter(notProto), $pProperties = it.schema.patternProperties || {}, $pPropertyKeys = Object.keys($pProperties).filter(notProto), $aProperties = it.schema.additionalProperties, $someProperties = $schemaKeys.length || $pPropertyKeys.length, $noAdditional = $aProperties === false, $additionalIsSchema = typeof $aProperties == "object" && Object.keys($aProperties).length, $removeAdditional = it.opts.removeAdditional, $checkAdditional = $noAdditional || $additionalIsSchema || $removeAdditional, $ownProperties = it.opts.ownProperties, $currentBaseId = it.baseId;
    var $required = it.schema.required;
    if ($required && !(it.opts.$data && $required.$data) && $required.length < it.opts.loopRequired) var $requiredHash = it.util.toHash($required);
    function notProto(p) {
        return p !== "__proto__";
    }
    out += "var " + $errs + " = errors;var " + $nextValid + " = true;";
    if ($ownProperties) out += " var " + $dataProperties + " = undefined;";
    if ($checkAdditional) {
        if ($ownProperties) out += " " + $dataProperties + " = " + $dataProperties + " || Object.keys(" + $data + "); for (var " + $idx + "=0; " + $idx + "<" + $dataProperties + ".length; " + $idx + "++) { var " + $key + " = " + $dataProperties + "[" + $idx + "]; ";
        else out += " for (var " + $key + " in " + $data + ") { ";
        if ($someProperties) {
            out += " var isAdditional" + $lvl + " = !(false ";
            if ($schemaKeys.length) {
                if ($schemaKeys.length > 8) out += " || validate.schema" + $schemaPath + ".hasOwnProperty(" + $key + ") ";
                else {
                    var arr1 = $schemaKeys;
                    if (arr1) {
                        var $propertyKey, i1 = -1, l1 = arr1.length - 1;
                        while(i1 < l1){
                            $propertyKey = arr1[i1 += 1];
                            out += " || " + $key + " == " + it.util.toQuotedString($propertyKey) + " ";
                        }
                    }
                }
            }
            if ($pPropertyKeys.length) {
                var arr2 = $pPropertyKeys;
                if (arr2) {
                    var $pProperty, $i = -1, l2 = arr2.length - 1;
                    while($i < l2){
                        $pProperty = arr2[$i += 1];
                        out += " || " + it.usePattern($pProperty) + ".test(" + $key + ") ";
                    }
                }
            }
            out += " ); if (isAdditional" + $lvl + ") { ";
        }
        if ($removeAdditional == "all") out += " delete " + $data + "[" + $key + "]; ";
        else {
            var $currentErrorPath = it.errorPath;
            var $additionalProperty = "' + " + $key + " + '";
            if (it.opts._errorDataPathProperty) it.errorPath = it.util.getPathExpr(it.errorPath, $key, it.opts.jsonPointers);
            if ($noAdditional) {
                if ($removeAdditional) out += " delete " + $data + "[" + $key + "]; ";
                else {
                    out += " " + $nextValid + " = false; ";
                    var $currErrSchemaPath = $errSchemaPath;
                    $errSchemaPath = it.errSchemaPath + "/additionalProperties";
                    var $$outStack = $$outStack || [];
                    $$outStack.push(out);
                    out = ""; /* istanbul ignore else */ 
                    if (it.createErrors !== false) {
                        out += " { keyword: 'additionalProperties' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { additionalProperty: '" + $additionalProperty + "' } ";
                        if (it.opts.messages !== false) {
                            out += " , message: '";
                            if (it.opts._errorDataPathProperty) out += "is an invalid additional property";
                            else out += "should NOT have additional properties";
                            out += "' ";
                        }
                        if (it.opts.verbose) out += " , schema: false , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
                        out += " } ";
                    } else out += " {} ";
                    var __err = out;
                    out = $$outStack.pop();
                    if (!it.compositeRule && $breakOnError) {
                        /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
                        else out += " validate.errors = [" + __err + "]; return false; ";
                    } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
                    $errSchemaPath = $currErrSchemaPath;
                    if ($breakOnError) out += " break; ";
                }
            } else if ($additionalIsSchema) {
                if ($removeAdditional == "failing") {
                    out += " var " + $errs + " = errors;  ";
                    var $wasComposite = it.compositeRule;
                    it.compositeRule = $it.compositeRule = true;
                    $it.schema = $aProperties;
                    $it.schemaPath = it.schemaPath + ".additionalProperties";
                    $it.errSchemaPath = it.errSchemaPath + "/additionalProperties";
                    $it.errorPath = it.opts._errorDataPathProperty ? it.errorPath : it.util.getPathExpr(it.errorPath, $key, it.opts.jsonPointers);
                    var $passData = $data + "[" + $key + "]";
                    $it.dataPathArr[$dataNxt] = $key;
                    var $code = it.validate($it);
                    $it.baseId = $currentBaseId;
                    if (it.util.varOccurences($code, $nextData) < 2) out += " " + it.util.varReplace($code, $nextData, $passData) + " ";
                    else out += " var " + $nextData + " = " + $passData + "; " + $code + " ";
                    out += " if (!" + $nextValid + ") { errors = " + $errs + "; if (validate.errors !== null) { if (errors) validate.errors.length = errors; else validate.errors = null; } delete " + $data + "[" + $key + "]; }  ";
                    it.compositeRule = $it.compositeRule = $wasComposite;
                } else {
                    $it.schema = $aProperties;
                    $it.schemaPath = it.schemaPath + ".additionalProperties";
                    $it.errSchemaPath = it.errSchemaPath + "/additionalProperties";
                    $it.errorPath = it.opts._errorDataPathProperty ? it.errorPath : it.util.getPathExpr(it.errorPath, $key, it.opts.jsonPointers);
                    var $passData = $data + "[" + $key + "]";
                    $it.dataPathArr[$dataNxt] = $key;
                    var $code = it.validate($it);
                    $it.baseId = $currentBaseId;
                    if (it.util.varOccurences($code, $nextData) < 2) out += " " + it.util.varReplace($code, $nextData, $passData) + " ";
                    else out += " var " + $nextData + " = " + $passData + "; " + $code + " ";
                    if ($breakOnError) out += " if (!" + $nextValid + ") break; ";
                }
            }
            it.errorPath = $currentErrorPath;
        }
        if ($someProperties) out += " } ";
        out += " }  ";
        if ($breakOnError) {
            out += " if (" + $nextValid + ") { ";
            $closingBraces += "}";
        }
    }
    var $useDefaults = it.opts.useDefaults && !it.compositeRule;
    if ($schemaKeys.length) {
        var arr3 = $schemaKeys;
        if (arr3) {
            var $propertyKey, i3 = -1, l3 = arr3.length - 1;
            while(i3 < l3){
                $propertyKey = arr3[i3 += 1];
                var $sch = $schema[$propertyKey];
                if (it.opts.strictKeywords ? typeof $sch == "object" && Object.keys($sch).length > 0 || $sch === false : it.util.schemaHasRules($sch, it.RULES.all)) {
                    var $prop = it.util.getProperty($propertyKey), $passData = $data + $prop, $hasDefault = $useDefaults && $sch.default !== undefined;
                    $it.schema = $sch;
                    $it.schemaPath = $schemaPath + $prop;
                    $it.errSchemaPath = $errSchemaPath + "/" + it.util.escapeFragment($propertyKey);
                    $it.errorPath = it.util.getPath(it.errorPath, $propertyKey, it.opts.jsonPointers);
                    $it.dataPathArr[$dataNxt] = it.util.toQuotedString($propertyKey);
                    var $code = it.validate($it);
                    $it.baseId = $currentBaseId;
                    if (it.util.varOccurences($code, $nextData) < 2) {
                        $code = it.util.varReplace($code, $nextData, $passData);
                        var $useData = $passData;
                    } else {
                        var $useData = $nextData;
                        out += " var " + $nextData + " = " + $passData + "; ";
                    }
                    if ($hasDefault) out += " " + $code + " ";
                    else {
                        if ($requiredHash && $requiredHash[$propertyKey]) {
                            out += " if ( " + $useData + " === undefined ";
                            if ($ownProperties) out += " || ! Object.prototype.hasOwnProperty.call(" + $data + ", '" + it.util.escapeQuotes($propertyKey) + "') ";
                            out += ") { " + $nextValid + " = false; ";
                            var $currentErrorPath = it.errorPath, $currErrSchemaPath = $errSchemaPath, $missingProperty = it.util.escapeQuotes($propertyKey);
                            if (it.opts._errorDataPathProperty) it.errorPath = it.util.getPath($currentErrorPath, $propertyKey, it.opts.jsonPointers);
                            $errSchemaPath = it.errSchemaPath + "/required";
                            var $$outStack = $$outStack || [];
                            $$outStack.push(out);
                            out = ""; /* istanbul ignore else */ 
                            if (it.createErrors !== false) {
                                out += " { keyword: 'required' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { missingProperty: '" + $missingProperty + "' } ";
                                if (it.opts.messages !== false) {
                                    out += " , message: '";
                                    if (it.opts._errorDataPathProperty) out += "is a required property";
                                    else out += "should have required property \\'" + $missingProperty + "\\'";
                                    out += "' ";
                                }
                                if (it.opts.verbose) out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
                                out += " } ";
                            } else out += " {} ";
                            var __err = out;
                            out = $$outStack.pop();
                            if (!it.compositeRule && $breakOnError) {
                                /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
                                else out += " validate.errors = [" + __err + "]; return false; ";
                            } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
                            $errSchemaPath = $currErrSchemaPath;
                            it.errorPath = $currentErrorPath;
                            out += " } else { ";
                        } else if ($breakOnError) {
                            out += " if ( " + $useData + " === undefined ";
                            if ($ownProperties) out += " || ! Object.prototype.hasOwnProperty.call(" + $data + ", '" + it.util.escapeQuotes($propertyKey) + "') ";
                            out += ") { " + $nextValid + " = true; } else { ";
                        } else {
                            out += " if (" + $useData + " !== undefined ";
                            if ($ownProperties) out += " &&   Object.prototype.hasOwnProperty.call(" + $data + ", '" + it.util.escapeQuotes($propertyKey) + "') ";
                            out += " ) { ";
                        }
                        out += " " + $code + " } ";
                    }
                }
                if ($breakOnError) {
                    out += " if (" + $nextValid + ") { ";
                    $closingBraces += "}";
                }
            }
        }
    }
    if ($pPropertyKeys.length) {
        var arr4 = $pPropertyKeys;
        if (arr4) {
            var $pProperty, i4 = -1, l4 = arr4.length - 1;
            while(i4 < l4){
                $pProperty = arr4[i4 += 1];
                var $sch = $pProperties[$pProperty];
                if (it.opts.strictKeywords ? typeof $sch == "object" && Object.keys($sch).length > 0 || $sch === false : it.util.schemaHasRules($sch, it.RULES.all)) {
                    $it.schema = $sch;
                    $it.schemaPath = it.schemaPath + ".patternProperties" + it.util.getProperty($pProperty);
                    $it.errSchemaPath = it.errSchemaPath + "/patternProperties/" + it.util.escapeFragment($pProperty);
                    if ($ownProperties) out += " " + $dataProperties + " = " + $dataProperties + " || Object.keys(" + $data + "); for (var " + $idx + "=0; " + $idx + "<" + $dataProperties + ".length; " + $idx + "++) { var " + $key + " = " + $dataProperties + "[" + $idx + "]; ";
                    else out += " for (var " + $key + " in " + $data + ") { ";
                    out += " if (" + it.usePattern($pProperty) + ".test(" + $key + ")) { ";
                    $it.errorPath = it.util.getPathExpr(it.errorPath, $key, it.opts.jsonPointers);
                    var $passData = $data + "[" + $key + "]";
                    $it.dataPathArr[$dataNxt] = $key;
                    var $code = it.validate($it);
                    $it.baseId = $currentBaseId;
                    if (it.util.varOccurences($code, $nextData) < 2) out += " " + it.util.varReplace($code, $nextData, $passData) + " ";
                    else out += " var " + $nextData + " = " + $passData + "; " + $code + " ";
                    if ($breakOnError) out += " if (!" + $nextValid + ") break; ";
                    out += " } ";
                    if ($breakOnError) out += " else " + $nextValid + " = true; ";
                    out += " }  ";
                    if ($breakOnError) {
                        out += " if (" + $nextValid + ") { ";
                        $closingBraces += "}";
                    }
                }
            }
        }
    }
    if ($breakOnError) out += " " + $closingBraces + " if (" + $errs + " == errors) {";
    return out;
};

});

parcelRegister("cltmp", function(module, exports) {
"use strict";
module.exports = function generate_propertyNames(it, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $errs = "errs__" + $lvl;
    var $it = it.util.copy(it);
    var $closingBraces = "";
    $it.level++;
    var $nextValid = "valid" + $it.level;
    out += "var " + $errs + " = errors;";
    if (it.opts.strictKeywords ? typeof $schema == "object" && Object.keys($schema).length > 0 || $schema === false : it.util.schemaHasRules($schema, it.RULES.all)) {
        $it.schema = $schema;
        $it.schemaPath = $schemaPath;
        $it.errSchemaPath = $errSchemaPath;
        var $key = "key" + $lvl, $idx = "idx" + $lvl, $i = "i" + $lvl, $invalidName = "' + " + $key + " + '", $dataNxt = $it.dataLevel = it.dataLevel + 1, $nextData = "data" + $dataNxt, $dataProperties = "dataProperties" + $lvl, $ownProperties = it.opts.ownProperties, $currentBaseId = it.baseId;
        if ($ownProperties) out += " var " + $dataProperties + " = undefined; ";
        if ($ownProperties) out += " " + $dataProperties + " = " + $dataProperties + " || Object.keys(" + $data + "); for (var " + $idx + "=0; " + $idx + "<" + $dataProperties + ".length; " + $idx + "++) { var " + $key + " = " + $dataProperties + "[" + $idx + "]; ";
        else out += " for (var " + $key + " in " + $data + ") { ";
        out += " var startErrs" + $lvl + " = errors; ";
        var $passData = $key;
        var $wasComposite = it.compositeRule;
        it.compositeRule = $it.compositeRule = true;
        var $code = it.validate($it);
        $it.baseId = $currentBaseId;
        if (it.util.varOccurences($code, $nextData) < 2) out += " " + it.util.varReplace($code, $nextData, $passData) + " ";
        else out += " var " + $nextData + " = " + $passData + "; " + $code + " ";
        it.compositeRule = $it.compositeRule = $wasComposite;
        out += " if (!" + $nextValid + ") { for (var " + $i + "=startErrs" + $lvl + "; " + $i + "<errors; " + $i + "++) { vErrors[" + $i + "].propertyName = " + $key + "; }   var err =   "; /* istanbul ignore else */ 
        if (it.createErrors !== false) {
            out += " { keyword: 'propertyNames' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { propertyName: '" + $invalidName + "' } ";
            if (it.opts.messages !== false) out += " , message: 'property name \\'" + $invalidName + "\\' is invalid' ";
            if (it.opts.verbose) out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
            out += " } ";
        } else out += " {} ";
        out += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
        if (!it.compositeRule && $breakOnError) {
            /* istanbul ignore if */ if (it.async) out += " throw new ValidationError(vErrors); ";
            else out += " validate.errors = vErrors; return false; ";
        }
        if ($breakOnError) out += " break; ";
        out += " } }";
    }
    if ($breakOnError) out += " " + $closingBraces + " if (" + $errs + " == errors) {";
    return out;
};

});

parcelRegister("1dWcG", function(module, exports) {
"use strict";
module.exports = function generate_required(it, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $valid = "valid" + $lvl;
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += " var schema" + $lvl + " = " + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + "; ";
        $schemaValue = "schema" + $lvl;
    } else $schemaValue = $schema;
    var $vSchema = "schema" + $lvl;
    if (!$isData) {
        if ($schema.length < it.opts.loopRequired && it.schema.properties && Object.keys(it.schema.properties).length) {
            var $required = [];
            var arr1 = $schema;
            if (arr1) {
                var $property, i1 = -1, l1 = arr1.length - 1;
                while(i1 < l1){
                    $property = arr1[i1 += 1];
                    var $propertySch = it.schema.properties[$property];
                    if (!($propertySch && (it.opts.strictKeywords ? typeof $propertySch == "object" && Object.keys($propertySch).length > 0 || $propertySch === false : it.util.schemaHasRules($propertySch, it.RULES.all)))) $required[$required.length] = $property;
                }
            }
        } else var $required = $schema;
    }
    if ($isData || $required.length) {
        var $currentErrorPath = it.errorPath, $loopRequired = $isData || $required.length >= it.opts.loopRequired, $ownProperties = it.opts.ownProperties;
        if ($breakOnError) {
            out += " var missing" + $lvl + "; ";
            if ($loopRequired) {
                if (!$isData) out += " var " + $vSchema + " = validate.schema" + $schemaPath + "; ";
                var $i = "i" + $lvl, $propertyPath = "schema" + $lvl + "[" + $i + "]", $missingProperty = "' + " + $propertyPath + " + '";
                if (it.opts._errorDataPathProperty) it.errorPath = it.util.getPathExpr($currentErrorPath, $propertyPath, it.opts.jsonPointers);
                out += " var " + $valid + " = true; ";
                if ($isData) out += " if (schema" + $lvl + " === undefined) " + $valid + " = true; else if (!Array.isArray(schema" + $lvl + ")) " + $valid + " = false; else {";
                out += " for (var " + $i + " = 0; " + $i + " < " + $vSchema + ".length; " + $i + "++) { " + $valid + " = " + $data + "[" + $vSchema + "[" + $i + "]] !== undefined ";
                if ($ownProperties) out += " &&   Object.prototype.hasOwnProperty.call(" + $data + ", " + $vSchema + "[" + $i + "]) ";
                out += "; if (!" + $valid + ") break; } ";
                if ($isData) out += "  }  ";
                out += "  if (!" + $valid + ") {   ";
                var $$outStack = $$outStack || [];
                $$outStack.push(out);
                out = ""; /* istanbul ignore else */ 
                if (it.createErrors !== false) {
                    out += " { keyword: 'required' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { missingProperty: '" + $missingProperty + "' } ";
                    if (it.opts.messages !== false) {
                        out += " , message: '";
                        if (it.opts._errorDataPathProperty) out += "is a required property";
                        else out += "should have required property \\'" + $missingProperty + "\\'";
                        out += "' ";
                    }
                    if (it.opts.verbose) out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
                    out += " } ";
                } else out += " {} ";
                var __err = out;
                out = $$outStack.pop();
                if (!it.compositeRule && $breakOnError) {
                    /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
                    else out += " validate.errors = [" + __err + "]; return false; ";
                } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
                out += " } else { ";
            } else {
                out += " if ( ";
                var arr2 = $required;
                if (arr2) {
                    var $propertyKey, $i = -1, l2 = arr2.length - 1;
                    while($i < l2){
                        $propertyKey = arr2[$i += 1];
                        if ($i) out += " || ";
                        var $prop = it.util.getProperty($propertyKey), $useData = $data + $prop;
                        out += " ( ( " + $useData + " === undefined ";
                        if ($ownProperties) out += " || ! Object.prototype.hasOwnProperty.call(" + $data + ", '" + it.util.escapeQuotes($propertyKey) + "') ";
                        out += ") && (missing" + $lvl + " = " + it.util.toQuotedString(it.opts.jsonPointers ? $propertyKey : $prop) + ") ) ";
                    }
                }
                out += ") {  ";
                var $propertyPath = "missing" + $lvl, $missingProperty = "' + " + $propertyPath + " + '";
                if (it.opts._errorDataPathProperty) it.errorPath = it.opts.jsonPointers ? it.util.getPathExpr($currentErrorPath, $propertyPath, true) : $currentErrorPath + " + " + $propertyPath;
                var $$outStack = $$outStack || [];
                $$outStack.push(out);
                out = ""; /* istanbul ignore else */ 
                if (it.createErrors !== false) {
                    out += " { keyword: 'required' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { missingProperty: '" + $missingProperty + "' } ";
                    if (it.opts.messages !== false) {
                        out += " , message: '";
                        if (it.opts._errorDataPathProperty) out += "is a required property";
                        else out += "should have required property \\'" + $missingProperty + "\\'";
                        out += "' ";
                    }
                    if (it.opts.verbose) out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
                    out += " } ";
                } else out += " {} ";
                var __err = out;
                out = $$outStack.pop();
                if (!it.compositeRule && $breakOnError) {
                    /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
                    else out += " validate.errors = [" + __err + "]; return false; ";
                } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
                out += " } else { ";
            }
        } else if ($loopRequired) {
            if (!$isData) out += " var " + $vSchema + " = validate.schema" + $schemaPath + "; ";
            var $i = "i" + $lvl, $propertyPath = "schema" + $lvl + "[" + $i + "]", $missingProperty = "' + " + $propertyPath + " + '";
            if (it.opts._errorDataPathProperty) it.errorPath = it.util.getPathExpr($currentErrorPath, $propertyPath, it.opts.jsonPointers);
            if ($isData) {
                out += " if (" + $vSchema + " && !Array.isArray(" + $vSchema + ")) {  var err =   "; /* istanbul ignore else */ 
                if (it.createErrors !== false) {
                    out += " { keyword: 'required' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { missingProperty: '" + $missingProperty + "' } ";
                    if (it.opts.messages !== false) {
                        out += " , message: '";
                        if (it.opts._errorDataPathProperty) out += "is a required property";
                        else out += "should have required property \\'" + $missingProperty + "\\'";
                        out += "' ";
                    }
                    if (it.opts.verbose) out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
                    out += " } ";
                } else out += " {} ";
                out += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } else if (" + $vSchema + " !== undefined) { ";
            }
            out += " for (var " + $i + " = 0; " + $i + " < " + $vSchema + ".length; " + $i + "++) { if (" + $data + "[" + $vSchema + "[" + $i + "]] === undefined ";
            if ($ownProperties) out += " || ! Object.prototype.hasOwnProperty.call(" + $data + ", " + $vSchema + "[" + $i + "]) ";
            out += ") {  var err =   "; /* istanbul ignore else */ 
            if (it.createErrors !== false) {
                out += " { keyword: 'required' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { missingProperty: '" + $missingProperty + "' } ";
                if (it.opts.messages !== false) {
                    out += " , message: '";
                    if (it.opts._errorDataPathProperty) out += "is a required property";
                    else out += "should have required property \\'" + $missingProperty + "\\'";
                    out += "' ";
                }
                if (it.opts.verbose) out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
                out += " } ";
            } else out += " {} ";
            out += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } } ";
            if ($isData) out += "  }  ";
        } else {
            var arr3 = $required;
            if (arr3) {
                var $propertyKey, i3 = -1, l3 = arr3.length - 1;
                while(i3 < l3){
                    $propertyKey = arr3[i3 += 1];
                    var $prop = it.util.getProperty($propertyKey), $missingProperty = it.util.escapeQuotes($propertyKey), $useData = $data + $prop;
                    if (it.opts._errorDataPathProperty) it.errorPath = it.util.getPath($currentErrorPath, $propertyKey, it.opts.jsonPointers);
                    out += " if ( " + $useData + " === undefined ";
                    if ($ownProperties) out += " || ! Object.prototype.hasOwnProperty.call(" + $data + ", '" + it.util.escapeQuotes($propertyKey) + "') ";
                    out += ") {  var err =   "; /* istanbul ignore else */ 
                    if (it.createErrors !== false) {
                        out += " { keyword: 'required' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { missingProperty: '" + $missingProperty + "' } ";
                        if (it.opts.messages !== false) {
                            out += " , message: '";
                            if (it.opts._errorDataPathProperty) out += "is a required property";
                            else out += "should have required property \\'" + $missingProperty + "\\'";
                            out += "' ";
                        }
                        if (it.opts.verbose) out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
                        out += " } ";
                    } else out += " {} ";
                    out += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; } ";
                }
            }
        }
        it.errorPath = $currentErrorPath;
    } else if ($breakOnError) out += " if (true) {";
    return out;
};

});

parcelRegister("cfMdF", function(module, exports) {
"use strict";
module.exports = function generate_uniqueItems(it, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $data = "data" + ($dataLvl || "");
    var $valid = "valid" + $lvl;
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += " var schema" + $lvl + " = " + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + "; ";
        $schemaValue = "schema" + $lvl;
    } else $schemaValue = $schema;
    if (($schema || $isData) && it.opts.uniqueItems !== false) {
        if ($isData) out += " var " + $valid + "; if (" + $schemaValue + " === false || " + $schemaValue + " === undefined) " + $valid + " = true; else if (typeof " + $schemaValue + " != 'boolean') " + $valid + " = false; else { ";
        out += " var i = " + $data + ".length , " + $valid + " = true , j; if (i > 1) { ";
        var $itemType = it.schema.items && it.schema.items.type, $typeIsArray = Array.isArray($itemType);
        if (!$itemType || $itemType == "object" || $itemType == "array" || $typeIsArray && ($itemType.indexOf("object") >= 0 || $itemType.indexOf("array") >= 0)) out += " outer: for (;i--;) { for (j = i; j--;) { if (equal(" + $data + "[i], " + $data + "[j])) { " + $valid + " = false; break outer; } } } ";
        else {
            out += " var itemIndices = {}, item; for (;i--;) { var item = " + $data + "[i]; ";
            var $method = "checkDataType" + ($typeIsArray ? "s" : "");
            out += " if (" + it.util[$method]($itemType, "item", it.opts.strictNumbers, true) + ") continue; ";
            if ($typeIsArray) out += " if (typeof item == 'string') item = '\"' + item; ";
            out += " if (typeof itemIndices[item] == 'number') { " + $valid + " = false; j = itemIndices[item]; break; } itemIndices[item] = i; } ";
        }
        out += " } ";
        if ($isData) out += "  }  ";
        out += " if (!" + $valid + ") {   ";
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = ""; /* istanbul ignore else */ 
        if (it.createErrors !== false) {
            out += " { keyword: 'uniqueItems' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { i: i, j: j } ";
            if (it.opts.messages !== false) out += " , message: 'should NOT have duplicate items (items ## ' + j + ' and ' + i + ' are identical)' ";
            if (it.opts.verbose) {
                out += " , schema:  ";
                if ($isData) out += "validate.schema" + $schemaPath;
                else out += "" + $schema;
                out += "         , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
            }
            out += " } ";
        } else out += " {} ";
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
            /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
            else out += " validate.errors = [" + __err + "]; return false; ";
        } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
        out += " } ";
        if ($breakOnError) out += " else { ";
    } else if ($breakOnError) out += " if (true) { ";
    return out;
};

});



parcelRegister("jSQ5p", function(module, exports) {
"use strict";
var $e79b76b16b8945ac$var$KEYWORDS = [
    "multipleOf",
    "maximum",
    "exclusiveMaximum",
    "minimum",
    "exclusiveMinimum",
    "maxLength",
    "minLength",
    "pattern",
    "additionalItems",
    "maxItems",
    "minItems",
    "uniqueItems",
    "maxProperties",
    "minProperties",
    "required",
    "additionalProperties",
    "enum",
    "format",
    "const"
];
module.exports = function(metaSchema, keywordsJsonPointers) {
    for(var i = 0; i < keywordsJsonPointers.length; i++){
        metaSchema = JSON.parse(JSON.stringify(metaSchema));
        var segments = keywordsJsonPointers[i].split("/");
        var keywords = metaSchema;
        var j;
        for(j = 1; j < segments.length; j++)keywords = keywords[segments[j]];
        for(j = 0; j < $e79b76b16b8945ac$var$KEYWORDS.length; j++){
            var key = $e79b76b16b8945ac$var$KEYWORDS[j];
            var schema = keywords[key];
            if (schema) keywords[key] = {
                anyOf: [
                    schema,
                    {
                        $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#"
                    }
                ]
            };
        }
    }
    return metaSchema;
};

});

parcelRegister("23QXm", function(module, exports) {
"use strict";

var $4BeMy = parcelRequire("4BeMy");
var $1804f0a12080b02f$require$MissingRefError = $4BeMy.MissingRef;
module.exports = $1804f0a12080b02f$var$compileAsync;
/**
 * Creates validating function for passed schema with asynchronous loading of missing schemas.
 * `loadSchema` option should be a function that accepts schema uri and returns promise that resolves with the schema.
 * @this  Ajv
 * @param {Object}   schema schema object
 * @param {Boolean}  meta optional true to compile meta-schema; this parameter can be skipped
 * @param {Function} callback an optional node-style callback, it is called with 2 parameters: error (or null) and validating function.
 * @return {Promise} promise that resolves with a validating function.
 */ function $1804f0a12080b02f$var$compileAsync(schema, meta, callback) {
    /* eslint no-shadow: 0 */ /* global Promise */ /* jshint validthis: true */ var self = this;
    if (typeof this._opts.loadSchema != "function") throw new Error("options.loadSchema should be a function");
    if (typeof meta == "function") {
        callback = meta;
        meta = undefined;
    }
    var p = loadMetaSchemaOf(schema).then(function() {
        var schemaObj = self._addSchema(schema, undefined, meta);
        return schemaObj.validate || _compileAsync(schemaObj);
    });
    if (callback) p.then(function(v) {
        callback(null, v);
    }, callback);
    return p;
    function loadMetaSchemaOf(sch) {
        var $schema = sch.$schema;
        return $schema && !self.getSchema($schema) ? $1804f0a12080b02f$var$compileAsync.call(self, {
            $ref: $schema
        }, true) : Promise.resolve();
    }
    function _compileAsync(schemaObj) {
        try {
            return self._compile(schemaObj);
        } catch (e) {
            if (e instanceof $1804f0a12080b02f$require$MissingRefError) return loadMissingSchema(e);
            throw e;
        }
        function loadMissingSchema(e) {
            var ref = e.missingSchema;
            if (added(ref)) throw new Error("Schema " + ref + " is loaded but " + e.missingRef + " cannot be resolved");
            var schemaPromise = self._loadingSchemas[ref];
            if (!schemaPromise) {
                schemaPromise = self._loadingSchemas[ref] = self._opts.loadSchema(ref);
                schemaPromise.then(removePromise, removePromise);
            }
            return schemaPromise.then(function(sch) {
                if (!added(ref)) return loadMetaSchemaOf(sch).then(function() {
                    if (!added(ref)) self.addSchema(sch, ref, undefined, meta);
                });
            }).then(function() {
                return _compileAsync(schemaObj);
            });
            function removePromise() {
                delete self._loadingSchemas[ref];
            }
            function added(ref) {
                return self._refs[ref] || self._schemas[ref];
            }
        }
    }
}

});

parcelRegister("70CFv", function(module, exports) {
"use strict";
var $51a6873763299168$var$IDENTIFIER = /^[a-z_$][a-z0-9_$-]*$/i;

var $5TE2n = parcelRequire("5TE2n");

var $XfxXS = parcelRequire("XfxXS");
module.exports = {
    add: $51a6873763299168$var$addKeyword,
    get: $51a6873763299168$var$getKeyword,
    remove: $51a6873763299168$var$removeKeyword,
    validate: $51a6873763299168$var$validateKeyword
};
/**
 * Define custom keyword
 * @this  Ajv
 * @param {String} keyword custom keyword, should be unique (including different from all standard, custom and macro keywords).
 * @param {Object} definition keyword definition object with properties `type` (type(s) which the keyword applies to), `validate` or `compile`.
 * @return {Ajv} this for method chaining
 */ function $51a6873763299168$var$addKeyword(keyword, definition) {
    /* jshint validthis: true */ /* eslint no-shadow: 0 */ var RULES = this.RULES;
    if (RULES.keywords[keyword]) throw new Error("Keyword " + keyword + " is already defined");
    if (!$51a6873763299168$var$IDENTIFIER.test(keyword)) throw new Error("Keyword " + keyword + " is not a valid identifier");
    if (definition) {
        this.validateKeyword(definition, true);
        var dataType = definition.type;
        if (Array.isArray(dataType)) for(var i = 0; i < dataType.length; i++)_addRule(keyword, dataType[i], definition);
        else _addRule(keyword, dataType, definition);
        var metaSchema = definition.metaSchema;
        if (metaSchema) {
            if (definition.$data && this._opts.$data) metaSchema = {
                anyOf: [
                    metaSchema,
                    {
                        "$ref": "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#"
                    }
                ]
            };
            definition.validateSchema = this.compile(metaSchema, true);
        }
    }
    RULES.keywords[keyword] = RULES.all[keyword] = true;
    function _addRule(keyword, dataType, definition) {
        var ruleGroup;
        for(var i = 0; i < RULES.length; i++){
            var rg = RULES[i];
            if (rg.type == dataType) {
                ruleGroup = rg;
                break;
            }
        }
        if (!ruleGroup) {
            ruleGroup = {
                type: dataType,
                rules: []
            };
            RULES.push(ruleGroup);
        }
        var rule = {
            keyword: keyword,
            definition: definition,
            custom: true,
            code: $5TE2n,
            implements: definition.implements
        };
        ruleGroup.rules.push(rule);
        RULES.custom[keyword] = rule;
    }
    return this;
}
/**
 * Get keyword
 * @this  Ajv
 * @param {String} keyword pre-defined or custom keyword.
 * @return {Object|Boolean} custom keyword definition, `true` if it is a predefined keyword, `false` otherwise.
 */ function $51a6873763299168$var$getKeyword(keyword) {
    /* jshint validthis: true */ var rule = this.RULES.custom[keyword];
    return rule ? rule.definition : this.RULES.keywords[keyword] || false;
}
/**
 * Remove keyword
 * @this  Ajv
 * @param {String} keyword pre-defined or custom keyword.
 * @return {Ajv} this for method chaining
 */ function $51a6873763299168$var$removeKeyword(keyword) {
    /* jshint validthis: true */ var RULES = this.RULES;
    delete RULES.keywords[keyword];
    delete RULES.all[keyword];
    delete RULES.custom[keyword];
    for(var i = 0; i < RULES.length; i++){
        var rules = RULES[i].rules;
        for(var j = 0; j < rules.length; j++)if (rules[j].keyword == keyword) {
            rules.splice(j, 1);
            break;
        }
    }
    return this;
}
/**
 * Validate keyword definition
 * @this  Ajv
 * @param {Object} definition keyword definition object.
 * @param {Boolean} throwError true to throw exception if definition is invalid
 * @return {boolean} validation result
 */ function $51a6873763299168$var$validateKeyword(definition, throwError) {
    $51a6873763299168$var$validateKeyword.errors = null;
    var v = this._validateKeyword = this._validateKeyword || this.compile($XfxXS, true);
    if (v(definition)) return true;
    $51a6873763299168$var$validateKeyword.errors = v.errors;
    if (throwError) throw new Error("custom keyword definition is invalid: " + this.errorsText(v.errors));
    else return false;
}

});
parcelRegister("5TE2n", function(module, exports) {
"use strict";
module.exports = function generate_custom(it, $keyword, $ruleType) {
    var out = " ";
    var $lvl = it.level;
    var $dataLvl = it.dataLevel;
    var $schema = it.schema[$keyword];
    var $schemaPath = it.schemaPath + it.util.getProperty($keyword);
    var $errSchemaPath = it.errSchemaPath + "/" + $keyword;
    var $breakOnError = !it.opts.allErrors;
    var $errorKeyword;
    var $data = "data" + ($dataLvl || "");
    var $valid = "valid" + $lvl;
    var $errs = "errs__" + $lvl;
    var $isData = it.opts.$data && $schema && $schema.$data, $schemaValue;
    if ($isData) {
        out += " var schema" + $lvl + " = " + it.util.getData($schema.$data, $dataLvl, it.dataPathArr) + "; ";
        $schemaValue = "schema" + $lvl;
    } else $schemaValue = $schema;
    var $rule = this, $definition = "definition" + $lvl, $rDef = $rule.definition, $closingBraces = "";
    var $compile, $inline, $macro, $ruleValidate, $validateCode;
    if ($isData && $rDef.$data) {
        $validateCode = "keywordValidate" + $lvl;
        var $validateSchema = $rDef.validateSchema;
        out += " var " + $definition + " = RULES.custom['" + $keyword + "'].definition; var " + $validateCode + " = " + $definition + ".validate;";
    } else {
        $ruleValidate = it.useCustomRule($rule, $schema, it.schema, it);
        if (!$ruleValidate) return;
        $schemaValue = "validate.schema" + $schemaPath;
        $validateCode = $ruleValidate.code;
        $compile = $rDef.compile;
        $inline = $rDef.inline;
        $macro = $rDef.macro;
    }
    var $ruleErrs = $validateCode + ".errors", $i = "i" + $lvl, $ruleErr = "ruleErr" + $lvl, $asyncKeyword = $rDef.async;
    if ($asyncKeyword && !it.async) throw new Error("async keyword in sync schema");
    if (!($inline || $macro)) out += "" + $ruleErrs + " = null;";
    out += "var " + $errs + " = errors;var " + $valid + ";";
    if ($isData && $rDef.$data) {
        $closingBraces += "}";
        out += " if (" + $schemaValue + " === undefined) { " + $valid + " = true; } else { ";
        if ($validateSchema) {
            $closingBraces += "}";
            out += " " + $valid + " = " + $definition + ".validateSchema(" + $schemaValue + "); if (" + $valid + ") { ";
        }
    }
    if ($inline) {
        if ($rDef.statements) out += " " + $ruleValidate.validate + " ";
        else out += " " + $valid + " = " + $ruleValidate.validate + "; ";
    } else if ($macro) {
        var $it = it.util.copy(it);
        var $closingBraces = "";
        $it.level++;
        var $nextValid = "valid" + $it.level;
        $it.schema = $ruleValidate.validate;
        $it.schemaPath = "";
        var $wasComposite = it.compositeRule;
        it.compositeRule = $it.compositeRule = true;
        var $code = it.validate($it).replace(/validate\.schema/g, $validateCode);
        it.compositeRule = $it.compositeRule = $wasComposite;
        out += " " + $code;
    } else {
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = "";
        out += "  " + $validateCode + ".call( ";
        if (it.opts.passContext) out += "this";
        else out += "self";
        if ($compile || $rDef.schema === false) out += " , " + $data + " ";
        else out += " , " + $schemaValue + " , " + $data + " , validate.schema" + it.schemaPath + " ";
        out += " , (dataPath || '')";
        if (it.errorPath != '""') out += " + " + it.errorPath;
        var $parentData = $dataLvl ? "data" + ($dataLvl - 1 || "") : "parentData", $parentDataProperty = $dataLvl ? it.dataPathArr[$dataLvl] : "parentDataProperty";
        out += " , " + $parentData + " , " + $parentDataProperty + " , rootData )  ";
        var def_callRuleValidate = out;
        out = $$outStack.pop();
        if ($rDef.errors === false) {
            out += " " + $valid + " = ";
            if ($asyncKeyword) out += "await ";
            out += "" + def_callRuleValidate + "; ";
        } else if ($asyncKeyword) {
            $ruleErrs = "customErrors" + $lvl;
            out += " var " + $ruleErrs + " = null; try { " + $valid + " = await " + def_callRuleValidate + "; } catch (e) { " + $valid + " = false; if (e instanceof ValidationError) " + $ruleErrs + " = e.errors; else throw e; } ";
        } else out += " " + $ruleErrs + " = null; " + $valid + " = " + def_callRuleValidate + "; ";
    }
    if ($rDef.modifying) out += " if (" + $parentData + ") " + $data + " = " + $parentData + "[" + $parentDataProperty + "];";
    out += "" + $closingBraces;
    if ($rDef.valid) {
        if ($breakOnError) out += " if (true) { ";
    } else {
        out += " if ( ";
        if ($rDef.valid === undefined) {
            out += " !";
            if ($macro) out += "" + $nextValid;
            else out += "" + $valid;
        } else out += " " + !$rDef.valid + " ";
        out += ") { ";
        $errorKeyword = $rule.keyword;
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = "";
        var $$outStack = $$outStack || [];
        $$outStack.push(out);
        out = ""; /* istanbul ignore else */ 
        if (it.createErrors !== false) {
            out += " { keyword: '" + ($errorKeyword || "custom") + "' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { keyword: '" + $rule.keyword + "' } ";
            if (it.opts.messages !== false) out += " , message: 'should pass \"" + $rule.keyword + "\" keyword validation' ";
            if (it.opts.verbose) out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
            out += " } ";
        } else out += " {} ";
        var __err = out;
        out = $$outStack.pop();
        if (!it.compositeRule && $breakOnError) {
            /* istanbul ignore if */ if (it.async) out += " throw new ValidationError([" + __err + "]); ";
            else out += " validate.errors = [" + __err + "]; return false; ";
        } else out += " var err = " + __err + ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
        var def_customError = out;
        out = $$outStack.pop();
        if ($inline) {
            if ($rDef.errors) {
                if ($rDef.errors != "full") {
                    out += "  for (var " + $i + "=" + $errs + "; " + $i + "<errors; " + $i + "++) { var " + $ruleErr + " = vErrors[" + $i + "]; if (" + $ruleErr + ".dataPath === undefined) " + $ruleErr + ".dataPath = (dataPath || '') + " + it.errorPath + "; if (" + $ruleErr + ".schemaPath === undefined) { " + $ruleErr + '.schemaPath = "' + $errSchemaPath + '"; } ';
                    if (it.opts.verbose) out += " " + $ruleErr + ".schema = " + $schemaValue + "; " + $ruleErr + ".data = " + $data + "; ";
                    out += " } ";
                }
            } else if ($rDef.errors === false) out += " " + def_customError + " ";
            else {
                out += " if (" + $errs + " == errors) { " + def_customError + " } else {  for (var " + $i + "=" + $errs + "; " + $i + "<errors; " + $i + "++) { var " + $ruleErr + " = vErrors[" + $i + "]; if (" + $ruleErr + ".dataPath === undefined) " + $ruleErr + ".dataPath = (dataPath || '') + " + it.errorPath + "; if (" + $ruleErr + ".schemaPath === undefined) { " + $ruleErr + '.schemaPath = "' + $errSchemaPath + '"; } ';
                if (it.opts.verbose) out += " " + $ruleErr + ".schema = " + $schemaValue + "; " + $ruleErr + ".data = " + $data + "; ";
                out += " } } ";
            }
        } else if ($macro) {
            out += "   var err =   "; /* istanbul ignore else */ 
            if (it.createErrors !== false) {
                out += " { keyword: '" + ($errorKeyword || "custom") + "' , dataPath: (dataPath || '') + " + it.errorPath + " , schemaPath: " + it.util.toQuotedString($errSchemaPath) + " , params: { keyword: '" + $rule.keyword + "' } ";
                if (it.opts.messages !== false) out += " , message: 'should pass \"" + $rule.keyword + "\" keyword validation' ";
                if (it.opts.verbose) out += " , schema: validate.schema" + $schemaPath + " , parentSchema: validate.schema" + it.schemaPath + " , data: " + $data + " ";
                out += " } ";
            } else out += " {} ";
            out += ";  if (vErrors === null) vErrors = [err]; else vErrors.push(err); errors++; ";
            if (!it.compositeRule && $breakOnError) {
                /* istanbul ignore if */ if (it.async) out += " throw new ValidationError(vErrors); ";
                else out += " validate.errors = vErrors; return false; ";
            }
        } else if ($rDef.errors === false) out += " " + def_customError + " ";
        else {
            out += " if (Array.isArray(" + $ruleErrs + ")) { if (vErrors === null) vErrors = " + $ruleErrs + "; else vErrors = vErrors.concat(" + $ruleErrs + "); errors = vErrors.length;  for (var " + $i + "=" + $errs + "; " + $i + "<errors; " + $i + "++) { var " + $ruleErr + " = vErrors[" + $i + "]; if (" + $ruleErr + ".dataPath === undefined) " + $ruleErr + ".dataPath = (dataPath || '') + " + it.errorPath + ";  " + $ruleErr + '.schemaPath = "' + $errSchemaPath + '";  ';
            if (it.opts.verbose) out += " " + $ruleErr + ".schema = " + $schemaValue + "; " + $ruleErr + ".data = " + $data + "; ";
            out += " } } else { " + def_customError + " } ";
        }
        out += " } ";
        if ($breakOnError) out += " else { ";
    }
    return out;
};

});

parcelRegister("XfxXS", function(module, exports) {
"use strict";

var $fLmi3 = parcelRequire("fLmi3");
module.exports = {
    $id: "https://github.com/ajv-validator/ajv/blob/master/lib/definition_schema.js",
    definitions: {
        simpleTypes: $fLmi3.definitions.simpleTypes
    },
    type: "object",
    dependencies: {
        schema: [
            "validate"
        ],
        $data: [
            "validate"
        ],
        statements: [
            "inline"
        ],
        valid: {
            not: {
                required: [
                    "macro"
                ]
            }
        }
    },
    properties: {
        type: $fLmi3.properties.type,
        schema: {
            type: "boolean"
        },
        statements: {
            type: "boolean"
        },
        dependencies: {
            type: "array",
            items: {
                type: "string"
            }
        },
        metaSchema: {
            type: "object"
        },
        modifying: {
            type: "boolean"
        },
        valid: {
            type: "boolean"
        },
        $data: {
            type: "boolean"
        },
        async: {
            type: "boolean"
        },
        errors: {
            anyOf: [
                {
                    type: "boolean"
                },
                {
                    const: "full"
                }
            ]
        }
    }
};

});
parcelRegister("fLmi3", function(module, exports) {
module.exports = JSON.parse('{"$schema":"http://json-schema.org/draft-07/schema#","$id":"http://json-schema.org/draft-07/schema#","title":"Core schema meta-schema","definitions":{"schemaArray":{"type":"array","minItems":1,"items":{"$ref":"#"}},"nonNegativeInteger":{"type":"integer","minimum":0},"nonNegativeIntegerDefault0":{"allOf":[{"$ref":"#/definitions/nonNegativeInteger"},{"default":0}]},"simpleTypes":{"enum":["array","boolean","integer","null","number","object","string"]},"stringArray":{"type":"array","items":{"type":"string"},"uniqueItems":true,"default":[]}},"type":["object","boolean"],"properties":{"$id":{"type":"string","format":"uri-reference"},"$schema":{"type":"string","format":"uri"},"$ref":{"type":"string","format":"uri-reference"},"$comment":{"type":"string"},"title":{"type":"string"},"description":{"type":"string"},"default":true,"readOnly":{"type":"boolean","default":false},"examples":{"type":"array","items":true},"multipleOf":{"type":"number","exclusiveMinimum":0},"maximum":{"type":"number"},"exclusiveMaximum":{"type":"number"},"minimum":{"type":"number"},"exclusiveMinimum":{"type":"number"},"maxLength":{"$ref":"#/definitions/nonNegativeInteger"},"minLength":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"pattern":{"type":"string","format":"regex"},"additionalItems":{"$ref":"#"},"items":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/schemaArray"}],"default":true},"maxItems":{"$ref":"#/definitions/nonNegativeInteger"},"minItems":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"uniqueItems":{"type":"boolean","default":false},"contains":{"$ref":"#"},"maxProperties":{"$ref":"#/definitions/nonNegativeInteger"},"minProperties":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"required":{"$ref":"#/definitions/stringArray"},"additionalProperties":{"$ref":"#"},"definitions":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"properties":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"patternProperties":{"type":"object","additionalProperties":{"$ref":"#"},"propertyNames":{"format":"regex"},"default":{}},"dependencies":{"type":"object","additionalProperties":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/stringArray"}]}},"propertyNames":{"$ref":"#"},"const":true,"enum":{"type":"array","items":true,"minItems":1,"uniqueItems":true},"type":{"anyOf":[{"$ref":"#/definitions/simpleTypes"},{"type":"array","items":{"$ref":"#/definitions/simpleTypes"},"minItems":1,"uniqueItems":true}]},"format":{"type":"string"},"contentMediaType":{"type":"string"},"contentEncoding":{"type":"string"},"if":{"$ref":"#"},"then":{"$ref":"#"},"else":{"$ref":"#"},"allOf":{"$ref":"#/definitions/schemaArray"},"anyOf":{"$ref":"#/definitions/schemaArray"},"oneOf":{"$ref":"#/definitions/schemaArray"},"not":{"$ref":"#"}},"default":true}');

});



parcelRegister("8eKVK", function(module, exports) {
module.exports = JSON.parse('{"$schema":"http://json-schema.org/draft-07/schema#","$id":"https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#","description":"Meta-schema for $data reference (JSON Schema extension proposal)","type":"object","required":["$data"],"properties":{"$data":{"type":"string","anyOf":[{"format":"relative-json-pointer"},{"format":"json-pointer"}]}},"additionalProperties":false}');

});





parcelRegister("imRAj", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5f3d8e196355522$export$2e2bcd8739ae039);

var $cG9FK = parcelRequire("cG9FK");

var $k4zDq = parcelRequire("k4zDq");

var $gpTap = parcelRequire("gpTap");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $1royG = parcelRequire("1royG");
function $d5f3d8e196355522$var$withTheme(themeProps) {
    return (0, $acw62.forwardRef)(function(_ref, ref) {
        var fields = _ref.fields, widgets = _ref.widgets, directProps = (0, $gpTap.default)(_ref, [
            "fields",
            "widgets"
        ]);
        fields = (0, $k4zDq.default)({}, themeProps.fields, fields);
        widgets = (0, $k4zDq.default)({}, themeProps.widgets, widgets);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1royG.default), (0, $cG9FK.default)({}, themeProps, directProps, {
            fields: fields,
            widgets: widgets,
            ref: ref
        }));
    });
}
$d5f3d8e196355522$var$withTheme.propTypes = {
    widgets: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    fields: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $d5f3d8e196355522$export$2e2bcd8739ae039 = $d5f3d8e196355522$var$withTheme;

});


parcelRegister("428tW", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function stringifiable(obj) {
    // Safely stringify Object.create(null)
    /* istanbul ignore next */ return typeof obj === "object" && !("toString" in obj) ? Object.prototype.toString.call(obj).slice(8, -1) : obj;
}
var isProduction = typeof $hPtJY === "object" && true;
function invariant(condition, message) {
    if (!condition) {
        /* istanbul ignore next */ if (isProduction) throw new Error("Invariant failed");
        throw new Error(message());
    }
}
exports.invariant = invariant;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var splice = Array.prototype.splice;
var toString = Object.prototype.toString;
function type(obj) {
    return toString.call(obj).slice(8, -1);
}
var assign = Object.assign || /* istanbul ignore next */ function(target, source) {
    getAllKeys(source).forEach(function(key) {
        if (hasOwnProperty.call(source, key)) target[key] = source[key];
    });
    return target;
};
var getAllKeys = typeof Object.getOwnPropertySymbols === "function" ? function(obj) {
    return Object.keys(obj).concat(Object.getOwnPropertySymbols(obj));
} : function(obj) {
    return Object.keys(obj);
};
function copy(object) {
    return Array.isArray(object) ? assign(object.constructor(object.length), object) : type(object) === "Map" ? new Map(object) : type(object) === "Set" ? new Set(object) : object && typeof object === "object" ? assign(Object.create(Object.getPrototypeOf(object)), object) : object;
}
var Context = /** @class */ function() {
    function Context() {
        this.commands = assign({}, defaultCommands);
        this.update = this.update.bind(this);
        // Deprecated: update.extend, update.isEquals and update.newContext
        this.update.extend = this.extend = this.extend.bind(this);
        this.update.isEquals = function(x, y) {
            return x === y;
        };
        this.update.newContext = function() {
            return new Context().update;
        };
    }
    Object.defineProperty(Context.prototype, "isEquals", {
        get: function() {
            return this.update.isEquals;
        },
        set: function(value) {
            this.update.isEquals = value;
        },
        enumerable: true,
        configurable: true
    });
    Context.prototype.extend = function(directive, fn) {
        this.commands[directive] = fn;
    };
    Context.prototype.update = function(object, $spec) {
        var _this = this;
        var spec = typeof $spec === "function" ? {
            $apply: $spec
        } : $spec;
        if (!(Array.isArray(object) && Array.isArray(spec))) invariant(!Array.isArray(spec), function() {
            return "update(): You provided an invalid spec to update(). The spec may not contain an array except as the value of $set, $push, $unshift, $splice or any custom command allowing an array value.";
        });
        invariant(typeof spec === "object" && spec !== null, function() {
            return "update(): You provided an invalid spec to update(). The spec and every included key path must be plain objects containing one of the " + ("following commands: " + Object.keys(_this.commands).join(", ") + ".");
        });
        var nextObject = object;
        getAllKeys(spec).forEach(function(key) {
            if (hasOwnProperty.call(_this.commands, key)) {
                var objectWasNextObject = object === nextObject;
                nextObject = _this.commands[key](spec[key], nextObject, spec, object);
                if (objectWasNextObject && _this.isEquals(nextObject, object)) nextObject = object;
            } else {
                var nextValueForKey = type(object) === "Map" ? _this.update(object.get(key), spec[key]) : _this.update(object[key], spec[key]);
                var nextObjectValue = type(nextObject) === "Map" ? nextObject.get(key) : nextObject[key];
                if (!_this.isEquals(nextValueForKey, nextObjectValue) || typeof nextValueForKey === "undefined" && !hasOwnProperty.call(object, key)) {
                    if (nextObject === object) nextObject = copy(object);
                    if (type(nextObject) === "Map") nextObject.set(key, nextValueForKey);
                    else nextObject[key] = nextValueForKey;
                }
            }
        });
        return nextObject;
    };
    return Context;
}();
exports.Context = Context;
var defaultCommands = {
    $push: function(value, nextObject, spec) {
        invariantPushAndUnshift(nextObject, spec, "$push");
        return value.length ? nextObject.concat(value) : nextObject;
    },
    $unshift: function(value, nextObject, spec) {
        invariantPushAndUnshift(nextObject, spec, "$unshift");
        return value.length ? value.concat(nextObject) : nextObject;
    },
    $splice: function(value, nextObject, spec, originalObject) {
        invariantSplices(nextObject, spec);
        value.forEach(function(args) {
            invariantSplice(args);
            if (nextObject === originalObject && args.length) nextObject = copy(originalObject);
            splice.apply(nextObject, args);
        });
        return nextObject;
    },
    $set: function(value, _nextObject, spec) {
        invariantSet(spec);
        return value;
    },
    $toggle: function(targets, nextObject) {
        invariantSpecArray(targets, "$toggle");
        var nextObjectCopy = targets.length ? copy(nextObject) : nextObject;
        targets.forEach(function(target) {
            nextObjectCopy[target] = !nextObject[target];
        });
        return nextObjectCopy;
    },
    $unset: function(value, nextObject, _spec, originalObject) {
        invariantSpecArray(value, "$unset");
        value.forEach(function(key) {
            if (Object.hasOwnProperty.call(nextObject, key)) {
                if (nextObject === originalObject) nextObject = copy(originalObject);
                delete nextObject[key];
            }
        });
        return nextObject;
    },
    $add: function(values, nextObject, _spec, originalObject) {
        invariantMapOrSet(nextObject, "$add");
        invariantSpecArray(values, "$add");
        if (type(nextObject) === "Map") values.forEach(function(_a) {
            var key = _a[0], value = _a[1];
            if (nextObject === originalObject && nextObject.get(key) !== value) nextObject = copy(originalObject);
            nextObject.set(key, value);
        });
        else values.forEach(function(value) {
            if (nextObject === originalObject && !nextObject.has(value)) nextObject = copy(originalObject);
            nextObject.add(value);
        });
        return nextObject;
    },
    $remove: function(value, nextObject, _spec, originalObject) {
        invariantMapOrSet(nextObject, "$remove");
        invariantSpecArray(value, "$remove");
        value.forEach(function(key) {
            if (nextObject === originalObject && nextObject.has(key)) nextObject = copy(originalObject);
            nextObject.delete(key);
        });
        return nextObject;
    },
    $merge: function(value, nextObject, _spec, originalObject) {
        invariantMerge(nextObject, value);
        getAllKeys(value).forEach(function(key) {
            if (value[key] !== nextObject[key]) {
                if (nextObject === originalObject) nextObject = copy(originalObject);
                nextObject[key] = value[key];
            }
        });
        return nextObject;
    },
    $apply: function(value, original) {
        invariantApply(value);
        return value(original);
    }
};
var defaultContext = new Context();
exports.isEquals = defaultContext.update.isEquals;
exports.extend = defaultContext.extend;
exports.default = defaultContext.update;
// @ts-ignore
exports.default.default = module.exports = assign(exports.default, exports);
// invariants
function invariantPushAndUnshift(value, spec, command) {
    invariant(Array.isArray(value), function() {
        return "update(): expected target of " + stringifiable(command) + " to be an array; got " + stringifiable(value) + ".";
    });
    invariantSpecArray(spec[command], command);
}
function invariantSpecArray(spec, command) {
    invariant(Array.isArray(spec), function() {
        return "update(): expected spec of " + stringifiable(command) + " to be an array; got " + stringifiable(spec) + ". " + "Did you forget to wrap your parameter in an array?";
    });
}
function invariantSplices(value, spec) {
    invariant(Array.isArray(value), function() {
        return "Expected $splice target to be an array; got " + stringifiable(value);
    });
    invariantSplice(spec.$splice);
}
function invariantSplice(value) {
    invariant(Array.isArray(value), function() {
        return "update(): expected spec of $splice to be an array of arrays; got " + stringifiable(value) + ". " + "Did you forget to wrap your parameters in an array?";
    });
}
function invariantApply(fn) {
    invariant(typeof fn === "function", function() {
        return "update(): expected spec of $apply to be a function; got " + stringifiable(fn) + ".";
    });
}
function invariantSet(spec) {
    invariant(Object.keys(spec).length === 1, function() {
        return "Cannot have more than one key in an object with $set";
    });
}
function invariantMerge(target, specValue) {
    invariant(specValue && typeof specValue === "object", function() {
        return "update(): $merge expects a spec of type 'object'; got " + stringifiable(specValue);
    });
    invariant(target && typeof target === "object", function() {
        return "update(): $merge expects a target of type 'object'; got " + stringifiable(target);
    });
}
function invariantMapOrSet(target, command) {
    var typeOfTarget = type(target);
    invariant(typeOfTarget === "Map" || typeOfTarget === "Set", function() {
        return "update(): " + stringifiable(command) + " expects a target of type Set or Map; got " + stringifiable(typeOfTarget);
    });
}

});

parcelRegister("dTdPZ", function(module, exports) {
"use strict";
var $029c0cfce720a5ae$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $029c0cfce720a5ae$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $029c0cfce720a5ae$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $029c0cfce720a5ae$var$__createBinding(result, mod, k);
    }
    $029c0cfce720a5ae$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $029c0cfce720a5ae$var$react_1 = $029c0cfce720a5ae$var$__importStar((parcelRequire("acw62")));
parcelRequire("1royG");
var $ip6TK = parcelRequire("ip6TK");
class $029c0cfce720a5ae$var$RowField extends $029c0cfce720a5ae$var$react_1.Component {
    constructor(props){
        super(props);
    }
    render() {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const _this2 = this;
        const isRequired = (propName)=>{
            return Array.isArray(this.props.schema.required) && this.props.schema.required.indexOf(propName) !== -1;
        };
        const onPropertyChange = (propName, addedByAdditionalProperties = false)=>{
            return (value, errSchema)=>{
                if (!value && addedByAdditionalProperties) // Don't set value = undefined for fields added by
                // additionalProperties. Doing so removes them from the
                // formData, which causes them to completely disappear
                // (including the input field for the property name). Unlike
                // fields which are "mandated" by the schema, these fields can
                // be set to undefined by clicking a "delete field" button, so
                // set empty values to the empty string.
                value = "";
                const newFormData = Object.assign(Object.assign({}, _this2.props.formData), {
                    [propName]: value
                });
                _this2.props.onChange(newFormData, errSchema && _this2.props.errorSchema && Object.assign(Object.assign({}, _this2.props.errorSchema), {
                    [propName]: errSchema
                }));
            };
        };
        const { uiSchema: uiSchema, formData: formData, errorSchema: errorSchema, idSchema: idSchema, name: name, disabled: disabled, readonly: readonly, onBlur: onBlur, onFocus: onFocus, registry: registry, autofocus: autofocus, idPrefix: idPrefix, required: required, onChange: onChange } = this.props;
        const { definitions: definitions, fields: fields, formContext: formContext } = registry;
        const { SchemaField: SchemaField, DescriptionField: DescriptionField } = fields;
        const schema = $ip6TK.retrieveSchema(this.props.schema, definitions);
        let orderedProperties;
        try {
            const properties = Object.keys(schema.properties || {});
            orderedProperties = $ip6TK.orderProperties(properties, uiSchema["ui:order"]);
        } catch (err) {
            return $029c0cfce720a5ae$var$react_1.default.createElement("div", null, $029c0cfce720a5ae$var$react_1.default.createElement("p", {
                className: "config-error",
                style: {
                    color: "red"
                }
            }, "Invalid ", name || "root", " object field configuration:", $029c0cfce720a5ae$var$react_1.default.createElement("em", null, err.message), "."), $029c0cfce720a5ae$var$react_1.default.createElement("pre", null, JSON.stringify(schema)));
        }
        const RowComp = $029c0cfce720a5ae$var$react_1.default.createElement("div", {
            className: "row"
        }, schema.description && $029c0cfce720a5ae$var$react_1.default.createElement(DescriptionField, {
            id: `${idSchema.$id}__description`,
            description: schema.description,
            formContext: formContext,
            schema: schema,
            uiSchema: uiSchema,
            errorSchema: errorSchema,
            idSchema: idSchema,
            formData: formData,
            onChange: onChange,
            registry: registry,
            disabled: disabled,
            readonly: readonly,
            autofocus: autofocus,
            required: required,
            name: name,
            onBlur: onBlur
        }), orderedProperties && orderedProperties.map((propName, index)=>{
            return $029c0cfce720a5ae$var$react_1.default.createElement(SchemaField, {
                key: index,
                name: propName,
                required: isRequired(propName),
                schema: schema.properties ? schema.properties[propName] : {},
                uiSchema: uiSchema[propName],
                errorSchema: errorSchema[propName],
                idSchema: idSchema[propName],
                formData: formData[propName],
                onChange: onPropertyChange(propName),
                onBlur: onBlur,
                onFocus: onFocus,
                registry: registry,
                disabled: disabled,
                readonly: readonly,
                formContext: formContext,
                autofocus: autofocus,
                idPrefix: idPrefix
            });
        }));
        return $029c0cfce720a5ae$var$react_1.default.createElement("div", null, RowComp);
    }
}
module.exports.default = $029c0cfce720a5ae$var$RowField;

});

parcelRegister("kKOgc", function(module, exports) {
"use strict";
var $f1bf172986d53cfd$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $f1bf172986d53cfd$var$react_1 = $f1bf172986d53cfd$var$__importDefault((parcelRequire("acw62")));

const $f1bf172986d53cfd$var$classnames_1 = $f1bf172986d53cfd$var$__importDefault((parcelRequire("8g1PZ")));
parcelRequire("fHiKR");
var $kN5vy = parcelRequire("kN5vy");

var $jWEnY = parcelRequire("jWEnY");
const $f1bf172986d53cfd$var$CustomField = (props)=>{
    const { id: id, classNames: classes, label: label, children: children, errors: errors, help: help, description: description, hidden: hidden, required: required, displayLabel: displayLabel, formContext: formContext, schema: schema, uiSchema: uiSchema } = props;
    if (hidden) return children;
    let cls = (0, $f1bf172986d53cfd$var$classnames_1.default)($jWEnY.Util.isARow(uiSchema) ? "" : classes, $jWEnY.Util.isAnArrayField(schema) ? "form-group field-array" : "");
    let readMode = formContext.readMode;
    if (formContext.editing) formContext.editing.forEach((itemId)=>{
        if (id.startsWith(itemId)) readMode = false;
    });
    if (readMode) switch(children.props.schema.type){
        case "string":
        case "number":
        case "boolean":
            {
                let val = children.props.formData;
                // eslint-disable-next-line no-prototype-builtins
                if (children.props.schema.hasOwnProperty("enum") && children.props.schema.hasOwnProperty("enumNames")) {
                    let i;
                    for(i = 0; i < children.props.schema.enum.length; i++)if (children.props.schema.enum[i] === val) val = children.props.schema.enumNames[i];
                }
                if (children.props.schema.type === "boolean" && (val === true || val === false)) val = val === true ? "Yes" : "No";
                if (children.props.schema.format === "date") val = $jWEnY.Util.formatDate(val.toString());
                return $f1bf172986d53cfd$var$react_1.default.createElement("div", null, $f1bf172986d53cfd$var$react_1.default.createElement("p", null, schema.title, ":", $f1bf172986d53cfd$var$react_1.default.createElement("span", null, val)), errors);
            }
        default:
    }
    if (formContext.readMode && $jWEnY.Util.isAWidgetField(uiSchema) && !$jWEnY.Util.isArrayItem(id)) cls = (0, $f1bf172986d53cfd$var$classnames_1.default)(cls, "form-entry");
    return uiSchema && uiSchema["lwolf:inline"] ? $f1bf172986d53cfd$var$react_1.default.createElement("fieldset", {
        className: cls
    }, displayLabel && description ? description : null, $f1bf172986d53cfd$var$react_1.default.createElement("div", {
        className: "row"
    }, displayLabel && $f1bf172986d53cfd$var$react_1.default.createElement($kN5vy.default, {
        dataLwtId: id,
        required: required,
        for: id,
        // eslint-disable-next-line max-len
        className: `col-md-${uiSchema["lwolf:inline"].label["col-width"]}${uiSchema["lwolf:labelCssClass"]}`
    }, label), $f1bf172986d53cfd$var$react_1.default.createElement("div", {
        className: (0, $f1bf172986d53cfd$var$classnames_1.default)("control-label", `col-md-${uiSchema["lwolf:inline"].control["col-width"]}`)
    }, children)), !formContext.hideValidationMessages && errors, help) : $f1bf172986d53cfd$var$react_1.default.createElement("fieldset", {
        className: cls
    }, displayLabel && $f1bf172986d53cfd$var$react_1.default.createElement($kN5vy.default, {
        dataLwtId: id,
        required: required,
        for: id,
        className: (0, $f1bf172986d53cfd$var$classnames_1.default)("control-label", uiSchema && uiSchema["lwolf:labelCssClass"])
    }, label), displayLabel && description ? description : null, children, !formContext.hideValidationMessages && errors, help);
};
module.exports.default = $f1bf172986d53cfd$var$CustomField;

});
parcelRegister("jWEnY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Util = module.exports.addCustomError = module.exports.getSchemaPathsMap = module.exports.stripRows = module.exports.rowify = module.exports.hasKey = void 0;
const $e852c2d8a00cbef7$var$hasKey = (obj, key)=>{
    return key in obj;
};
module.exports.hasKey = $e852c2d8a00cbef7$var$hasKey;
const $e852c2d8a00cbef7$var$rowify = (flatSchema, flatUiSchema, flatData)=>{
    flatSchema = flatSchema || {};
    flatUiSchema = flatUiSchema || {};
    flatData = flatData || {};
    const schema = JSON.parse(JSON.stringify(flatSchema));
    const uiSchema = JSON.parse(JSON.stringify(flatUiSchema));
    const formData = JSON.parse(JSON.stringify(flatData));
    if (flatUiSchema.hasOwnProperty("lwolf:rows")) {
        let row, uiRow, dataRow;
        const createRow = (val)=>{
            if (flatSchema.properties && flatSchema.properties[val].type === "object" && flatSchema.properties[val].hasOwnProperty("properties")) {
                const dataItem = flatData ? flatData[val] || {} : {};
                const item = (0, module.exports.rowify)(flatSchema.properties[val], uiSchema[val], dataItem);
                item.schema.required = [];
                if (row.properties) row.properties[val] = item.schema;
                uiRow[val] = item.uiSchema;
                dataRow[val] = item.formData;
            } else if (flatSchema.properties && flatSchema.properties[val].type === "array") {
                const arrayItems = [];
                if (row.properties) {
                    row.properties[val] = Object.assign({}, flatSchema.properties[val]);
                    row.properties[val].items = [];
                }
                uiRow[val] = {
                    "ui:options": flatUiSchema[val]["ui:options"]
                };
                const items = flatSchema.properties[val].items;
                const item = (0, module.exports.rowify)(items, uiSchema[val]);
                item.schema.required = [];
                if (row.properties) row.properties[val].items = item.schema;
                uiRow[val] = item.uiSchema;
                const dataItem = flatData ? flatData[val] || [] : [];
                const rowProperties = row.properties;
                if (rowProperties[val].minItems > 0 && dataItem.length < rowProperties[val].minItems) for(let i = 0; i < rowProperties[val].minItems; i++)dataItem.push({});
                dataItem.forEach((arrayItem)=>{
                    if (flatSchema.properties) {
                        const property = flatSchema.properties[val];
                        const rowified = (0, module.exports.rowify)(property.items, uiSchema[val], arrayItem);
                        arrayItems.push(rowified.formData);
                    }
                });
                dataRow[val] = arrayItems;
            } else {
                dataRow[val] = flatData ? flatData[val] : undefined;
                if (row.properties) row.properties[val] = Object.assign({}, flatSchema.properties && flatSchema.properties[val]);
                if (flatUiSchema.hasOwnProperty(val)) {
                    uiRow[val] = flatUiSchema[val];
                    uiRow["lwolf:col-width"] += flatUiSchema[val].hasOwnProperty("lwolf:col-width") ? flatUiSchema[val]["lwolf:col-width"] : 0;
                    uiRow["lwolf:classNames"] += flatUiSchema[val].hasOwnProperty("lwolf:classNames") ? flatUiSchema[val]["lwolf:classNames"] : "";
                    delete uiSchema[val];
                } else uiRow[val] = {};
            }
            if (schema.properties) delete schema.properties[val];
        };
        const expandRequireds = (index, key)=>{
            if (schema.required) {
                const ind = schema.required.indexOf(key);
                if (ind > -1) {
                    if (schema.properties) {
                        const rowProperty = schema.properties["row" + index];
                        rowProperty.required && rowProperty.required.push(key);
                    }
                    schema.required.splice(ind, -1);
                }
            }
        };
        for(let i = 1; i <= flatUiSchema["lwolf:rows"].length; i++){
            row = {
                type: "object",
                required: [],
                properties: {}
            };
            uiRow = {
                "ui:field": "row",
                "lwolf:col-width": 0
            };
            dataRow = {};
            flatUiSchema["lwolf:rows"][i - 1].forEach(createRow);
            if (schema.properties) schema.properties["row" + i] = row;
            uiSchema["row" + i] = uiRow;
            formData["row" + i] = dataRow;
            if (schema.hasOwnProperty("required")) {
                if (schema.properties) schema.properties["row" + i].required = [];
                if (row.properties) Object.keys(row.properties).forEach(expandRequireds.bind(null, i));
            }
        }
        if (schema.hasOwnProperty("required")) delete schema.required;
        Object.keys(flatData).forEach((key)=>{
            delete formData[key];
        });
    }
    return {
        schema: schema,
        uiSchema: uiSchema,
        formData: formData
    };
};
module.exports.rowify = $e852c2d8a00cbef7$var$rowify;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const $e852c2d8a00cbef7$var$stripRows = (formData)=>{
    const stripped = {};
    let topLevel;
    let i;
    if (formData === undefined || formData === null) return formData;
    Object.keys(formData).forEach((row)=>{
        if (formData[row] !== null) {
            if (typeof formData[row] === "object") Object.keys(formData[row]).forEach((level1)=>{
                // widget
                if (Array.isArray(formData[row][level1])) {
                    topLevel = [];
                    for(i = 0; i < formData[row][level1].length; i++){
                        topLevel[i] = {};
                        Object.keys(formData[row][level1][i]).forEach((key)=>{
                            Object.keys(formData[row][level1][i][key]).forEach((subkey)=>{
                                topLevel[i][subkey] = formData[row][level1][i][key][subkey];
                            });
                        });
                    }
                } else {
                    topLevel = {};
                    if (formData[row][level1] !== null && typeof formData[row][level1] === "object") Object.keys(formData[row][level1]).forEach((key)=>{
                        Object.keys(formData[row][level1][key]).forEach((subkey)=>{
                            topLevel[subkey] = formData[row][level1][key][subkey];
                        });
                    });
                    else topLevel = formData[row][level1];
                }
                if (!row.startsWith("row") || !Number(row.slice(3, row.length))) {
                    stripped[row] = stripped[row] || {};
                    stripped[row][level1] = topLevel;
                } else stripped[level1] = topLevel;
            });
            else stripped[row] = formData[row];
        }
    });
    return stripped;
};
module.exports.stripRows = $e852c2d8a00cbef7$var$stripRows;
const $e852c2d8a00cbef7$var$getSchemaPathsMap = (schema, path = [])=>{
    const map = {};
    if ((0, module.exports.hasKey)(schema, "properties")) {
        const properties = schema.properties;
        Object.keys(properties).forEach((row)=>{
            const rowProperties = properties[row].properties;
            if (rowProperties) Object.keys(rowProperties).forEach((property)=>{
                const propertyPath = [];
                propertyPath.push(row);
                propertyPath.push(property);
                map[property] = (0, module.exports.getSchemaPathsMap)(rowProperties[property], path.concat(propertyPath));
            });
            else map[row] = [
                row
            ];
        });
    } else if ((0, module.exports.hasKey)(schema, "items")) return (0, module.exports.getSchemaPathsMap)(schema.items, path);
    else return path;
    return map;
};
module.exports.getSchemaPathsMap = $e852c2d8a00cbef7$var$getSchemaPathsMap;
const $e852c2d8a00cbef7$var$addCustomError = (errors, pathArray, errorMessage, uiSchema)=>{
    const errorProperty = module.exports.Util.getObjectByStringArray(errors, pathArray);
    const uiPathArray = [];
    pathArray.forEach((path)=>path.startsWith && !path.startsWith("row") && uiPathArray.push(path));
    const propertyUiSchema = module.exports.Util.getObjectByStringArray(uiSchema, uiPathArray);
    errorProperty && errorProperty.addError(errorMessage.replace(/{(field)}/g, propertyUiSchema["ui:title"]));
};
module.exports.addCustomError = $e852c2d8a00cbef7$var$addCustomError;
module.exports.Util = {
    isAnArrayField (schema) {
        return schema !== undefined && schema.type === "array";
    },
    isARow (uiSchema) {
        return uiSchema !== undefined && uiSchema.hasOwnProperty("ui:field") && uiSchema["ui:field"] === "row";
    },
    isAWidgetField (uiSchema) {
        return uiSchema !== undefined && uiSchema.hasOwnProperty("ui:field") && uiSchema["ui:field"] === "widget";
    },
    isArrayItem (id) {
        const tokens = id.split("_");
        return tokens.length === 4 && this.isNumeric(tokens[tokens.length - 1]);
    },
    // TODO: The following functions should go into the Javascript Common npm module
    isNumeric (n) {
        return !isNaN(parseFloat(n)) && isFinite(Number(n));
    },
    formatDate (date) {
        if (date !== "" && date !== undefined) {
            const dateObj = new Date(date);
            let month = (dateObj.getUTCMonth() + 1).toString();
            let day = dateObj.getUTCDate().toString();
            const year = dateObj.getUTCFullYear();
            if (month.length < 2) month = "0" + month;
            if (day.length < 2) day = "0" + day;
            date = [
                month,
                day,
                year
            ].join("/");
        }
        return date;
    },
    getObjectByStringArray: (o, a)=>{
        let keyValue = o;
        for(let i = 0, n = a.length; i < n; ++i){
            const k = a[i];
            if ((0, module.exports.hasKey)(keyValue, k)) keyValue = keyValue[k];
            else return undefined;
        }
        return keyValue;
    }
};

});


parcelRegister("1UlbJ", function(module, exports) {
"use strict";
var $163b74f531b92a2f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $163b74f531b92a2f$var$react_1 = $163b74f531b92a2f$var$__importDefault((parcelRequire("acw62")));
const $163b74f531b92a2f$var$TitleField = (props)=>{
    const toggleEditing = (parentId)=>{
        if (props.formContext.toggleEditing) props.formContext.toggleEditing(parentId);
    };
    const { title: title } = props;
    const titleId = props.id;
    const parentFieldId = titleId && titleId.split("__")[0];
    // Hide row names
    if (title && title.startsWith("row") || parentFieldId && parentFieldId.split("_").length === 4) return $163b74f531b92a2f$var$react_1.default.createElement($163b74f531b92a2f$var$react_1.default.Fragment, null);
    let cls = "col-title";
    let titleHtml;
    // special formatting for root title i.e. form title
    if (parentFieldId === "root") {
        cls += " col-lg-12";
        titleHtml = $163b74f531b92a2f$var$react_1.default.createElement("div", null, $163b74f531b92a2f$var$react_1.default.createElement("h2", {
            id: titleId
        }, title), $163b74f531b92a2f$var$react_1.default.createElement("hr", null));
    } else {
        cls += " col-lg-12";
        titleHtml = $163b74f531b92a2f$var$react_1.default.createElement("h4", {
            id: titleId
        }, title);
    }
    const readMode = props.formContext && props.formContext.readMode;
    const editingMode = props.formContext && props.formContext.editing && props.formContext.editing.indexOf(parentFieldId) > -1;
    const editBtnCls = "btn btn-sm" + (editingMode ? " btn-primary" : "");
    return $163b74f531b92a2f$var$react_1.default.createElement("div", null, $163b74f531b92a2f$var$react_1.default.createElement("div", {
        className: "row",
        id: "form-title"
    }, $163b74f531b92a2f$var$react_1.default.createElement("div", {
        className: cls
    }, $163b74f531b92a2f$var$react_1.default.createElement("div", {
        className: "form-title"
    }, titleHtml)), readMode && parentFieldId !== "root" && $163b74f531b92a2f$var$react_1.default.createElement("div", {
        className: "col-lg-6 text-right"
    }, $163b74f531b92a2f$var$react_1.default.createElement("button", {
        type: "button",
        className: editBtnCls,
        onClick: toggleEditing.bind(null, parentFieldId)
    }, $163b74f531b92a2f$var$react_1.default.createElement("span", {
        className: "material-icons"
    }, editingMode ? "done" : "edit"), $163b74f531b92a2f$var$react_1.default.createElement("div", {
        className: "ripple-container"
    })))));
};
module.exports.default = $163b74f531b92a2f$var$TitleField;

});

parcelRegister("h9179", function(module, exports) {
"use strict";
var $c7b4243651ce7bb4$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $c7b4243651ce7bb4$var$react_1 = $c7b4243651ce7bb4$var$__importDefault((parcelRequire("acw62")));
function $c7b4243651ce7bb4$var$ArrayFieldTitle({ TitleField: TitleField, idSchema: idSchema, title: title, required: required }) {
    if (!title) return null;
    const id = `${idSchema.$id}__title`;
    return $c7b4243651ce7bb4$var$react_1.default.createElement(TitleField, {
        id: id,
        title: title,
        required: required
    });
}
function $c7b4243651ce7bb4$var$ArrayFieldDescription({ DescriptionField: DescriptionField, idSchema: idSchema, description: description }) {
    if (!description) return null;
    const id = `${idSchema.$id}__description`;
    return $c7b4243651ce7bb4$var$react_1.default.createElement(DescriptionField, {
        id: id,
        description: description
    });
}
const $c7b4243651ce7bb4$var$ArrayField = (props)=>{
    const toggleEditing = (index)=>{
        if (props.formContext.toggleEditing) props.formContext.toggleEditing(props.idSchema.$id + "_" + index);
    };
    const readMode = props.formContext && props.formContext.readMode;
    let addButtonCls = "btn btn-secondary";
    if (readMode) addButtonCls = "btn btn-default-outline";
    return $c7b4243651ce7bb4$var$react_1.default.createElement("fieldset", {
        className: props.className,
        id: props.idSchema.$id,
        "data-lwt-id": props.idSchema.$id
    }, $c7b4243651ce7bb4$var$react_1.default.createElement($c7b4243651ce7bb4$var$ArrayFieldTitle, {
        key: `array-field-title-${props.idSchema.$id}`,
        TitleField: props.TitleField,
        idSchema: props.idSchema,
        title: props.uiSchema["ui:title"] || props.title,
        required: props.required
    }), (props.uiSchema["ui:description"] || props.schema.description) && $c7b4243651ce7bb4$var$react_1.default.createElement($c7b4243651ce7bb4$var$ArrayFieldDescription, {
        key: `array-field-description-${props.idSchema.$id}`,
        DescriptionField: props.DescriptionField,
        idSchema: props.idSchema,
        description: props.uiSchema["ui:description"] || props.schema.description
    }), props.items && props.items.map((element)=>{
        const childrenWithUiSchemas = $c7b4243651ce7bb4$var$react_1.default.Children.map(element.children, (child)=>$c7b4243651ce7bb4$var$react_1.default.cloneElement(child, {
                uiSchema: props.uiSchema
            }));
        const editingMode = props.formContext.editing && props.formContext.editing.indexOf(`${props.idSchema.$id}_${element.index}`) > -1;
        const editBtnCls = "btn btn-sm" + (editingMode ? " btn-primary" : "");
        return $c7b4243651ce7bb4$var$react_1.default.createElement("div", {
            key: `${props.idSchema.$id}-${element.index}`,
            id: element.index.toString()
        }, $c7b4243651ce7bb4$var$react_1.default.createElement("div", {
            className: "row"
        }, $c7b4243651ce7bb4$var$react_1.default.createElement("div", {
            className: "col"
        }, $c7b4243651ce7bb4$var$react_1.default.createElement("h5", null, element.children.props.schema && element.children.props.schema.title)), $c7b4243651ce7bb4$var$react_1.default.createElement("div", {
            className: "col text-right"
        }, $c7b4243651ce7bb4$var$react_1.default.createElement("button", {
            type: "button",
            className: "btn btn-sm btn-danger",
            onClick: element.onDropIndexClick(element.index)
        }, $c7b4243651ce7bb4$var$react_1.default.createElement("span", {
            className: "material-icons"
        }, "delete"), $c7b4243651ce7bb4$var$react_1.default.createElement("div", {
            className: "ripple-container"
        })), readMode && $c7b4243651ce7bb4$var$react_1.default.createElement("button", {
            type: "button",
            className: editBtnCls,
            onClick: toggleEditing.bind(null, element.index)
        }, $c7b4243651ce7bb4$var$react_1.default.createElement("span", {
            className: "material-icons"
        }, editingMode ? "done" : "edit"), $c7b4243651ce7bb4$var$react_1.default.createElement("div", {
            className: "ripple-container"
        })))), $c7b4243651ce7bb4$var$react_1.default.createElement("div", {
            className: "row"
        }, childrenWithUiSchemas), readMode && element.index !== props.items.length - 1 && $c7b4243651ce7bb4$var$react_1.default.createElement("hr", null));
    }), $c7b4243651ce7bb4$var$react_1.default.createElement("div", {
        className: "row"
    }, $c7b4243651ce7bb4$var$react_1.default.createElement("div", {
        className: "col"
    }, $c7b4243651ce7bb4$var$react_1.default.createElement("div", {
        className: "element-actions text-center"
    }, $c7b4243651ce7bb4$var$react_1.default.createElement("button", {
        type: "button",
        className: addButtonCls,
        onClick: props.onAddClick,
        "data-target": "#add-trust-modal"
    }, "Add ", props.schema.items.title, $c7b4243651ce7bb4$var$react_1.default.createElement("div", {
        className: "ripple-container"
    }))))));
};
module.exports.default = $c7b4243651ce7bb4$var$ArrayField;

});

parcelRegister("76zRy", function(module, exports) {
"use strict";
var $52c4e98b855e0c2b$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

/* eslint-disable no-prototype-builtins */ const $52c4e98b855e0c2b$var$react_1 = $52c4e98b855e0c2b$var$__importDefault((parcelRequire("acw62")));

const $52c4e98b855e0c2b$var$SchemaField_1 = $52c4e98b855e0c2b$var$__importDefault((parcelRequire("izrop")));
parcelRequire("3lOdM");
var $1iwUl = parcelRequire("1iwUl");

var $jWEnY = parcelRequire("jWEnY");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $52c4e98b855e0c2b$var$CustomSchemaField = (props)=>{
    let cls = "";
    const isRow = $jWEnY.Util.isARow(props.uiSchema);
    const isWidget = $jWEnY.Util.isAWidgetField(props.uiSchema);
    const isFieldElement = props.hasOwnProperty("name");
    if (isFieldElement && !isRow && props.uiSchema && props.uiSchema.hasOwnProperty("lwolf:classNames")) cls += ` ${props.uiSchema["lwolf:classNames"]}`;
    if (isFieldElement && !isRow && props.uiSchema && props.uiSchema.hasOwnProperty("lwolf:col-width")) cls += ` col-md-${props.uiSchema["lwolf:col-width"]}`;
    if (props.schema.hasOwnProperty("enum") && props.uiSchema["ui:placeholder"] === undefined && !props.uiSchema["ui:hidePlaceholder"]) props.uiSchema["ui:placeholder"] = "- Select -";
    const schemaField = $52c4e98b855e0c2b$var$react_1.default.createElement($52c4e98b855e0c2b$var$SchemaField_1.default, Object.assign({}, props));
    return isWidget && !isRow ? $52c4e98b855e0c2b$var$react_1.default.createElement($1iwUl.default, {
        className: cls,
        id: props.name
    }, schemaField) : $52c4e98b855e0c2b$var$react_1.default.createElement("div", {
        className: cls,
        id: props.name
    }, schemaField);
};
module.exports.default = $52c4e98b855e0c2b$var$CustomSchemaField;

});
parcelRegister("izrop", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $d850be82cb362d56$export$2e2bcd8739ae039);

var $7PwEf = parcelRequire("7PwEf");

var $4tWkZ = parcelRequire("4tWkZ");

var $eBH73 = parcelRequire("eBH73");

var $ctnWZ = parcelRequire("ctnWZ");

var $ivxVa = parcelRequire("ivxVa");

var $cG9FK = parcelRequire("cG9FK");

var $k4zDq = parcelRequire("k4zDq");

var $gpTap = parcelRequire("gpTap");

var $8lpxl = parcelRequire("8lpxl");

var $99rTF = parcelRequire("99rTF");

var $acw62 = parcelRequire("acw62");

parcelRequire("bdadt");

var $513QU = parcelRequire("513QU");
var $d850be82cb362d56$var$REQUIRED_FIELD_SYMBOL = "*";
var $d850be82cb362d56$var$COMPONENT_TYPES = {
    array: "ArrayField",
    "boolean": "BooleanField",
    integer: "NumberField",
    number: "NumberField",
    object: "ObjectField",
    string: "StringField",
    "null": "NullField"
};
function $d850be82cb362d56$var$getFieldComponent(schema, uiSchema, idSchema, fields) {
    var field = uiSchema["ui:field"];
    if (typeof field === "function") return field;
    if (typeof field === "string" && field in fields) return fields[field];
    var componentName = $d850be82cb362d56$var$COMPONENT_TYPES[(0, $513QU.getSchemaType)(schema)]; // If the type is not defined and the schema uses 'anyOf' or 'oneOf', don't
    // render a field and let the MultiSchemaField component handle the form display
    if (!componentName && (schema.anyOf || schema.oneOf)) return function() {
        return null;
    };
    return componentName in fields ? fields[componentName] : function() {
        var UnsupportedField = fields.UnsupportedField;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(UnsupportedField, {
            schema: schema,
            idSchema: idSchema,
            reason: "Unknown field type ".concat(schema.type)
        });
    };
}
function $d850be82cb362d56$var$Label(props) {
    var label = props.label, required = props.required, id = props.id;
    if (!label) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
        className: "control-label",
        htmlFor: id
    }, label, required && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "required"
    }, $d850be82cb362d56$var$REQUIRED_FIELD_SYMBOL));
}
function $d850be82cb362d56$var$LabelInput(props) {
    var id = props.id, label = props.label, onChange = props.onChange;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        className: "form-control",
        type: "text",
        id: id,
        onBlur: function onBlur(event) {
            return onChange(event.target.value);
        },
        defaultValue: label
    });
}
function $d850be82cb362d56$var$Help(props) {
    var help = props.help;
    if (!help) return null;
    if (typeof help === "string") return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        className: "help-block"
    }, help);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "help-block"
    }, help);
}
function $d850be82cb362d56$var$ErrorList(props) {
    var _props$errors = props.errors, errors = _props$errors === void 0 ? [] : _props$errors;
    if (errors.length === 0) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        className: "error-detail bs-callout bs-callout-info"
    }, errors.filter(function(elem) {
        return !!elem;
    }).map(function(error, index) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            className: "text-danger",
            key: index
        }, error);
    })));
}
function $d850be82cb362d56$var$DefaultTemplate(props) {
    var id = props.id, label = props.label, children = props.children, errors = props.errors, help = props.help, description = props.description, hidden = props.hidden, required = props.required, displayLabel = props.displayLabel;
    if (hidden) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "hidden"
    }, children);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d850be82cb362d56$var$WrapIfAdditional, props, displayLabel && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d850be82cb362d56$var$Label, {
        label: label,
        required: required,
        id: id
    }), displayLabel && description ? description : null, children, errors, help);
}
$d850be82cb362d56$var$DefaultTemplate.defaultProps = {
    hidden: false,
    readonly: false,
    required: false,
    displayLabel: true
};
function $d850be82cb362d56$var$WrapIfAdditional(props) {
    var id = props.id, classNames = props.classNames, disabled = props.disabled, label = props.label, onKeyChange = props.onKeyChange, onDropPropertyClick = props.onDropPropertyClick, readonly = props.readonly, required = props.required, schema = props.schema;
    var keyLabel = "".concat(label, " Key"); // i18n ?
    var additional = schema.hasOwnProperty((0, $513QU.ADDITIONAL_PROPERTY_FLAG));
    if (!additional) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classNames
    }, props.children);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: classNames
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "row"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "col-xs-5 form-additional"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "form-group"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d850be82cb362d56$var$Label, {
        label: keyLabel,
        required: required,
        id: "".concat(id, "-key")
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d850be82cb362d56$var$LabelInput, {
        label: label,
        required: required,
        id: "".concat(id, "-key"),
        onChange: onKeyChange
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "form-additional form-group col-xs-5"
    }, props.children), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "col-xs-2"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $99rTF.default), {
        type: "danger",
        icon: "remove",
        className: "array-item-remove btn-block",
        tabIndex: "-1",
        style: {
            border: "0"
        },
        disabled: disabled || readonly,
        onClick: onDropPropertyClick(label)
    }))));
}
function $d850be82cb362d56$var$SchemaFieldRender(props) {
    var uiSchema = props.uiSchema, formData = props.formData, errorSchema = props.errorSchema, idPrefix = props.idPrefix, name = props.name, onChange = props.onChange, onKeyChange = props.onKeyChange, onDropPropertyClick = props.onDropPropertyClick, required = props.required, _props$registry = props.registry, registry = _props$registry === void 0 ? (0, $513QU.getDefaultRegistry)() : _props$registry, _props$wasPropertyKey = props.wasPropertyKeyModified, wasPropertyKeyModified = _props$wasPropertyKey === void 0 ? false : _props$wasPropertyKey;
    var rootSchema = registry.rootSchema, fields = registry.fields, formContext = registry.formContext;
    var FieldTemplate = uiSchema["ui:FieldTemplate"] || registry.FieldTemplate || $d850be82cb362d56$var$DefaultTemplate;
    var idSchema = props.idSchema;
    var schema = (0, $513QU.retrieveSchema)(props.schema, rootSchema, formData);
    idSchema = (0, $513QU.mergeObjects)((0, $513QU.toIdSchema)(schema, null, rootSchema, formData, idPrefix), idSchema);
    var FieldComponent = $d850be82cb362d56$var$getFieldComponent(schema, uiSchema, idSchema, fields);
    var DescriptionField = fields.DescriptionField;
    var disabled = Boolean(props.disabled || uiSchema["ui:disabled"]);
    var readonly = Boolean(props.readonly || uiSchema["ui:readonly"] || props.schema.readOnly || schema.readOnly);
    var autofocus = Boolean(props.autofocus || uiSchema["ui:autofocus"]);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($8lpxl)))(schema).length === 0) return null;
    var displayLabel = (0, $513QU.getDisplayLabel)(schema, uiSchema, rootSchema);
    var __errors = errorSchema.__errors, fieldErrorSchema = (0, $gpTap.default)(errorSchema, [
        "__errors"
    ]); // See #439: uiSchema: Don't pass consumed class names to child components
    var field = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(FieldComponent, (0, $cG9FK.default)({}, props, {
        idSchema: idSchema,
        schema: schema,
        uiSchema: (0, $k4zDq.default)({}, uiSchema, {
            classNames: undefined
        }),
        disabled: disabled,
        readonly: readonly,
        autofocus: autofocus,
        errorSchema: fieldErrorSchema,
        formContext: formContext,
        rawErrors: __errors
    }));
    var id = idSchema.$id; // If this schema has a title defined, but the user has set a new key/label, retain their input.
    var label;
    if (wasPropertyKeyModified) label = name;
    else label = uiSchema["ui:title"] || props.schema.title || schema.title || name;
    var description = uiSchema["ui:description"] || props.schema.description || schema.description;
    var errors = __errors;
    var help = uiSchema["ui:help"];
    var hidden = uiSchema["ui:widget"] === "hidden";
    var classNames = [
        "form-group",
        "field",
        "field-".concat(schema.type),
        errors && errors.length > 0 ? "field-error has-error has-danger" : "",
        uiSchema.classNames
    ].join(" ").trim();
    var fieldProps = {
        description: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(DescriptionField, {
            id: id + "__description",
            description: description,
            formContext: formContext
        }),
        rawDescription: description,
        help: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d850be82cb362d56$var$Help, {
            help: help
        }),
        rawHelp: typeof help === "string" ? help : undefined,
        errors: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d850be82cb362d56$var$ErrorList, {
            errors: errors
        }),
        rawErrors: errors,
        id: id,
        label: label,
        hidden: hidden,
        onChange: onChange,
        onKeyChange: onKeyChange,
        onDropPropertyClick: onDropPropertyClick,
        required: required,
        disabled: disabled,
        readonly: readonly,
        displayLabel: displayLabel,
        classNames: classNames,
        formContext: formContext,
        formData: formData,
        fields: fields,
        schema: schema,
        uiSchema: uiSchema,
        registry: registry
    };
    var _AnyOfField = registry.fields.AnyOfField;
    var _OneOfField = registry.fields.OneOfField;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(FieldTemplate, fieldProps, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, field, schema.anyOf && !(0, $513QU.isSelect)(schema) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(_AnyOfField, {
        disabled: disabled,
        errorSchema: errorSchema,
        formData: formData,
        idPrefix: idPrefix,
        idSchema: idSchema,
        onBlur: props.onBlur,
        onChange: props.onChange,
        onFocus: props.onFocus,
        options: schema.anyOf,
        baseType: schema.type,
        registry: registry,
        schema: schema,
        uiSchema: uiSchema
    }), schema.oneOf && !(0, $513QU.isSelect)(schema) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(_OneOfField, {
        disabled: disabled,
        errorSchema: errorSchema,
        formData: formData,
        idPrefix: idPrefix,
        idSchema: idSchema,
        onBlur: props.onBlur,
        onChange: props.onChange,
        onFocus: props.onFocus,
        options: schema.oneOf,
        baseType: schema.type,
        registry: registry,
        schema: schema,
        uiSchema: uiSchema
    })));
}
var $d850be82cb362d56$var$SchemaField = /*#__PURE__*/ function(_React$Component) {
    (0, $ivxVa.default)(SchemaField, _React$Component);
    function SchemaField() {
        (0, $7PwEf.default)(this, SchemaField);
        return (0, $eBH73.default)(this, (0, $ctnWZ.default)(SchemaField).apply(this, arguments));
    }
    (0, $4tWkZ.default)(SchemaField, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps, nextState) {
                return !(0, $513QU.deepEquals)(this.props, nextProps);
            }
        },
        {
            key: "render",
            value: function render() {
                return $d850be82cb362d56$var$SchemaFieldRender(this.props);
            }
        }
    ]);
    return SchemaField;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$d850be82cb362d56$var$SchemaField.defaultProps = {
    uiSchema: {},
    errorSchema: {},
    idSchema: {},
    disabled: false,
    readonly: false,
    autofocus: false
};
var $d850be82cb362d56$export$2e2bcd8739ae039 = $d850be82cb362d56$var$SchemaField;

});
parcelRegister("99rTF", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a9a9809370209f0$export$2e2bcd8739ae039);

var $cG9FK = parcelRequire("cG9FK");

var $gpTap = parcelRequire("gpTap");

var $acw62 = parcelRequire("acw62");
function $6a9a9809370209f0$export$2e2bcd8739ae039(props) {
    var _props$type = props.type, type = _props$type === void 0 ? "default" : _props$type, icon = props.icon, className = props.className, otherProps = (0, $gpTap.default)(props, [
        "type",
        "icon",
        "className"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", (0, $cG9FK.default)({
        type: "button",
        className: "btn btn-".concat(type, " ").concat(className)
    }, otherProps), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("i", {
        className: "glyphicon glyphicon-".concat(icon)
    }));
}

});

parcelRegister("bdadt", function(module, exports) {

var $c9Z8w = parcelRequire("c9Z8w");
var $8298d555b2449a95$export$4bb7493d241fd8a5 = (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
    ArrayFieldTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    FieldTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    ObjectFieldTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    definitions: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object.isRequired,
    rootSchema: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    fields: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType).isRequired,
    formContext: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object.isRequired,
    widgets: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    ])).isRequired
});
var $8298d555b2449a95$export$cdefc4c738b53a5e = {
    autofocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    errorSchema: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    formData: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    idSchema: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    onFocus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    rawErrors: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string),
    readonly: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    registry: $8298d555b2449a95$export$4bb7493d241fd8a5.isRequired,
    required: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    schema: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object.isRequired,
    uiSchema: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        "ui:options": (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            addable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
            orderable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
            removable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
        })
    })
};

});

parcelRegister("513QU", function(module, exports) {

$parcel$export(module.exports, "ADDITIONAL_PROPERTY_FLAG", () => $3a7008c520083246$export$60d2d9c11642ddd6);
$parcel$export(module.exports, "canExpand", () => $3a7008c520083246$export$cc546884e5fe11c1);
$parcel$export(module.exports, "getUiOptions", () => $3a7008c520083246$export$5559168444c1cc6f);
$parcel$export(module.exports, "getDefaultRegistry", () => $3a7008c520083246$export$976cc06ffd96e4eb);
$parcel$export(module.exports, "getSchemaType", () => $3a7008c520083246$export$c37d213d49c78145);
$parcel$export(module.exports, "guessType", () => $3a7008c520083246$export$211ef2ad09ba7d20);
$parcel$export(module.exports, "getWidget", () => $3a7008c520083246$export$a091d7f3bd9ea9f);
$parcel$export(module.exports, "hasWidget", () => $3a7008c520083246$export$896ad1360bd43c21);
$parcel$export(module.exports, "isObject", () => $3a7008c520083246$export$a6cdc56e425d0d0a);
$parcel$export(module.exports, "mergeObjects", () => $3a7008c520083246$export$2321aea138b44780);
$parcel$export(module.exports, "isFixedItems", () => $3a7008c520083246$export$f214a64b20942f03);
$parcel$export(module.exports, "getMatchingOption", () => $3a7008c520083246$export$8165cea9d212ff07);
$parcel$export(module.exports, "isMultiSelect", () => $3a7008c520083246$export$109f4e03a72b2d9b);
$parcel$export(module.exports, "getDefaultFormState", () => $3a7008c520083246$export$889286269976f0f0);
$parcel$export(module.exports, "retrieveSchema", () => $3a7008c520083246$export$120b571b9a37c370);
$parcel$export(module.exports, "getDisplayLabel", () => $3a7008c520083246$export$b90a189477005ecf);
$parcel$export(module.exports, "isFilesArray", () => $3a7008c520083246$export$abcac65377e58c37);
$parcel$export(module.exports, "asNumber", () => $3a7008c520083246$export$37576b9ba69b50db);
$parcel$export(module.exports, "orderProperties", () => $3a7008c520083246$export$dfe1e6e459a6aaf3);
$parcel$export(module.exports, "isSelect", () => $3a7008c520083246$export$47ed34a15a70bfcf);
$parcel$export(module.exports, "allowAdditionalItems", () => $3a7008c520083246$export$b5ae80b7edac7510);
$parcel$export(module.exports, "optionsList", () => $3a7008c520083246$export$675008a38d270fd3);
$parcel$export(module.exports, "deepEquals", () => $3a7008c520083246$export$73ce4178444047a5);
$parcel$export(module.exports, "shouldRender", () => $3a7008c520083246$export$74f9e9340d52d089);
$parcel$export(module.exports, "toIdSchema", () => $3a7008c520083246$export$9e93037aa8764d4d);
$parcel$export(module.exports, "parseDateString", () => $3a7008c520083246$export$e684af8cfb294f41);
$parcel$export(module.exports, "toDateString", () => $3a7008c520083246$export$b7c4e1545c61edee);
$parcel$export(module.exports, "utcToLocal", () => $3a7008c520083246$export$ccd9a1bc6174ad42);
$parcel$export(module.exports, "pad", () => $3a7008c520083246$export$5d04458e2a6c373e);
$parcel$export(module.exports, "localToUTC", () => $3a7008c520083246$export$779990c68cce4240);
$parcel$export(module.exports, "dataURItoBlob", () => $3a7008c520083246$export$24bc7e761c190a9f);
$parcel$export(module.exports, "rangeSpec", () => $3a7008c520083246$export$241fd4b305d2db0a);
$parcel$export(module.exports, "schemaRequiresTrueValue", () => $3a7008c520083246$export$1203181f0b231402);

var $6I5NX = parcelRequire("6I5NX");

var $lyRnQ = parcelRequire("lyRnQ");

var $UVaxg = parcelRequire("UVaxg");

var $4juyi = parcelRequire("4juyi");

var $kltfT = parcelRequire("kltfT");

var $kB4x2 = parcelRequire("kB4x2");

var $a5du3 = parcelRequire("a5du3");

var $cD46i = parcelRequire("cD46i");

var $cG9FK = parcelRequire("cG9FK");

var $k4zDq = parcelRequire("k4zDq");

var $gpTap = parcelRequire("gpTap");

var $8lpxl = parcelRequire("8lpxl");

var $acw62 = parcelRequire("acw62");

var $4jPKB = parcelRequire("4jPKB");

var $6j9O2 = parcelRequire("6j9O2");

var $e8CxN = parcelRequire("e8CxN");

var $1c10x = parcelRequire("1c10x");

var $raQQi = parcelRequire("raQQi");

var $C6M3y = parcelRequire("C6M3y");

var $3EOho = parcelRequire("3EOho");

var $czU5E = parcelRequire("czU5E");
function $3a7008c520083246$var$_toPropertyKey(arg) {
    var key = $3a7008c520083246$var$_toPrimitive(arg, "string");
    return (0, $cD46i.default)(key) === "symbol" ? key : String(key);
}
function $3a7008c520083246$var$_toPrimitive(input, hint) {
    if ((0, $cD46i.default)(input) !== "object" || input === null) return input;
    var prim = input[0, (/*@__PURE__*/$parcel$interopDefault($6I5NX))];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $cD46i.default)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $3a7008c520083246$export$60d2d9c11642ddd6 = "__additional_property";
var $3a7008c520083246$var$widgetMap = {
    "boolean": {
        checkbox: "CheckboxWidget",
        radio: "RadioWidget",
        select: "SelectWidget",
        hidden: "HiddenWidget"
    },
    string: {
        text: "TextWidget",
        password: "PasswordWidget",
        email: "EmailWidget",
        hostname: "TextWidget",
        ipv4: "TextWidget",
        ipv6: "TextWidget",
        uri: "URLWidget",
        "data-url": "FileWidget",
        radio: "RadioWidget",
        select: "SelectWidget",
        textarea: "TextareaWidget",
        hidden: "HiddenWidget",
        date: "DateWidget",
        datetime: "DateTimeWidget",
        "date-time": "DateTimeWidget",
        "alt-date": "AltDateWidget",
        "alt-datetime": "AltDateTimeWidget",
        color: "ColorWidget",
        file: "FileWidget"
    },
    number: {
        text: "TextWidget",
        select: "SelectWidget",
        updown: "UpDownWidget",
        range: "RangeWidget",
        radio: "RadioWidget",
        hidden: "HiddenWidget"
    },
    integer: {
        text: "TextWidget",
        select: "SelectWidget",
        updown: "UpDownWidget",
        range: "RangeWidget",
        radio: "RadioWidget",
        hidden: "HiddenWidget"
    },
    array: {
        select: "SelectWidget",
        checkboxes: "CheckboxesWidget",
        files: "FileWidget",
        hidden: "HiddenWidget"
    }
};
function $3a7008c520083246$export$cc546884e5fe11c1(schema, uiSchema, formData) {
    if (!schema.additionalProperties) return false;
    var _getUiOptions = $3a7008c520083246$export$5559168444c1cc6f(uiSchema), expandable = _getUiOptions.expandable;
    if (expandable === false) return expandable;
     // if ui:options.expandable was not explicitly set to false, we can add
    // another property if we have not exceeded maxProperties yet
    if (schema.maxProperties !== undefined) return (0, (/*@__PURE__*/$parcel$interopDefault($8lpxl)))(formData).length < schema.maxProperties;
    return true;
}
function $3a7008c520083246$export$976cc06ffd96e4eb() {
    return {
        fields: (0, $C6M3y.default),
        widgets: (0, $3EOho.default),
        definitions: {},
        rootSchema: {},
        formContext: {}
    };
}
function $3a7008c520083246$export$c37d213d49c78145(schema) {
    var type = schema.type;
    if (!type && schema["const"]) return $3a7008c520083246$export$211ef2ad09ba7d20(schema["const"]);
    if (!type && schema["enum"]) return "string";
    if (!type && (schema.properties || schema.additionalProperties)) return "object";
    if (type instanceof Array && type.length === 2 && type.includes("null")) return type.find(function(type) {
        return type !== "null";
    });
    return type;
}
function $3a7008c520083246$export$a091d7f3bd9ea9f(schema, widget) {
    var registeredWidgets = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var type = $3a7008c520083246$export$c37d213d49c78145(schema);
    function mergeOptions(Widget) {
        // cache return value as property of widget for proper react reconciliation
        if (!Widget.MergedWidget) {
            var defaultOptions = Widget.defaultProps && Widget.defaultProps.options || {};
            Widget.MergedWidget = function(_ref) {
                var _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, props = (0, $gpTap.default)(_ref, [
                    "options"
                ]);
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Widget, (0, $cG9FK.default)({
                    options: (0, $k4zDq.default)({}, defaultOptions, options)
                }, props));
            };
        }
        return Widget.MergedWidget;
    }
    if (typeof widget === "function" || $4jPKB.isForwardRef((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(widget)) || $4jPKB.isMemo(widget)) return mergeOptions(widget);
    if (typeof widget !== "string") throw new Error("Unsupported widget definition: ".concat((0, $cD46i.default)(widget)));
    if (registeredWidgets.hasOwnProperty(widget)) {
        var registeredWidget = registeredWidgets[widget];
        return $3a7008c520083246$export$a091d7f3bd9ea9f(schema, registeredWidget, registeredWidgets);
    }
    if (!$3a7008c520083246$var$widgetMap.hasOwnProperty(type)) throw new Error('No widget for type "'.concat(type, '"'));
    if ($3a7008c520083246$var$widgetMap[type].hasOwnProperty(widget)) {
        var _registeredWidget = registeredWidgets[$3a7008c520083246$var$widgetMap[type][widget]];
        return $3a7008c520083246$export$a091d7f3bd9ea9f(schema, _registeredWidget, registeredWidgets);
    }
    throw new Error('No widget "'.concat(widget, '" for type "').concat(type, '"'));
}
function $3a7008c520083246$export$896ad1360bd43c21(schema, widget) {
    var registeredWidgets = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    try {
        $3a7008c520083246$export$a091d7f3bd9ea9f(schema, widget, registeredWidgets);
        return true;
    } catch (e) {
        if (e.message && (e.message.startsWith("No widget") || e.message.startsWith("Unsupported widget"))) return false;
        throw e;
    }
}
function $3a7008c520083246$var$computeDefaults(_schema, parentDefaults, rootSchema) {
    var rawFormData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var includeUndefinedValues = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var schema = $3a7008c520083246$export$a6cdc56e425d0d0a(_schema) ? _schema : {};
    var formData = $3a7008c520083246$export$a6cdc56e425d0d0a(rawFormData) ? rawFormData : {}; // Compute the defaults recursively: give highest priority to deepest nodes.
    var defaults = parentDefaults;
    if ($3a7008c520083246$export$a6cdc56e425d0d0a(defaults) && $3a7008c520083246$export$a6cdc56e425d0d0a(schema["default"])) // For object defaults, only override parent defaults that are defined in
    // schema.default.
    defaults = $3a7008c520083246$export$2321aea138b44780(defaults, schema["default"]);
    else if ("default" in schema) // Use schema defaults for this node.
    defaults = schema["default"];
    else if ("$ref" in schema) {
        // Use referenced schema defaults for this node.
        var refSchema = $3a7008c520083246$export$ba75abbfed20f81f(schema.$ref, rootSchema);
        return $3a7008c520083246$var$computeDefaults(refSchema, defaults, rootSchema, formData, includeUndefinedValues);
    } else if ("dependencies" in schema) {
        var resolvedSchema = $3a7008c520083246$var$resolveDependencies(schema, rootSchema, formData);
        return $3a7008c520083246$var$computeDefaults(resolvedSchema, defaults, rootSchema, formData, includeUndefinedValues);
    } else if ($3a7008c520083246$export$f214a64b20942f03(schema)) defaults = schema.items.map(function(itemSchema, idx) {
        return $3a7008c520083246$var$computeDefaults(itemSchema, (0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(parentDefaults) ? parentDefaults[idx] : undefined, rootSchema, formData, includeUndefinedValues);
    });
    else if ("oneOf" in schema) schema = schema.oneOf[$3a7008c520083246$export$8165cea9d212ff07(undefined, schema.oneOf, rootSchema)];
    else if ("anyOf" in schema) schema = schema.anyOf[$3a7008c520083246$export$8165cea9d212ff07(undefined, schema.anyOf, rootSchema)];
     // Not defaults defined for this node, fallback to generic typed ones.
    if (typeof defaults === "undefined") defaults = schema["default"];
    switch($3a7008c520083246$export$c37d213d49c78145(schema)){
        // We need to recur for object schema inner default values.
        case "object":
            return (0, (/*@__PURE__*/$parcel$interopDefault($8lpxl)))(schema.properties || {}).reduce(function(acc, key) {
                // Compute the defaults for this node, with the parent defaults we might
                // have from a previous run: defaults[key].
                var computedDefault = $3a7008c520083246$var$computeDefaults(schema.properties[key], (defaults || {})[key], rootSchema, (formData || {})[key], includeUndefinedValues);
                if (includeUndefinedValues || computedDefault !== undefined) acc[key] = computedDefault;
                return acc;
            }, {});
        case "array":
            // Inject defaults into existing array defaults
            if ((0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(defaults)) defaults = defaults.map(function(item, idx) {
                return $3a7008c520083246$var$computeDefaults(schema.items[idx] || schema.additionalItems || {}, item, rootSchema);
            });
             // Deeply inject defaults into already existing form data
            if ((0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(rawFormData)) defaults = rawFormData.map(function(item, idx) {
                return $3a7008c520083246$var$computeDefaults(schema.items, (defaults || {})[idx], rootSchema, item);
            });
            if (schema.minItems) {
                if (!$3a7008c520083246$export$109f4e03a72b2d9b(schema, rootSchema)) {
                    var defaultsLength = defaults ? defaults.length : 0;
                    if (schema.minItems > defaultsLength) {
                        var defaultEntries = defaults || []; // populate the array with the defaults
                        var fillerSchema = (0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(schema.items) ? schema.additionalItems : schema.items;
                        var fillerEntries = (0, (/*@__PURE__*/$parcel$interopDefault($e8CxN)))(new Array(schema.minItems - defaultsLength), $3a7008c520083246$var$computeDefaults(fillerSchema, fillerSchema.defaults, rootSchema)); // then fill up the rest with either the item default or empty, up to minItems
                        return defaultEntries.concat(fillerEntries);
                    }
                } else return defaults ? defaults : [];
            }
    }
    return defaults;
}
function $3a7008c520083246$export$889286269976f0f0(_schema, formData) {
    var rootSchema = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var includeUndefinedValues = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (!$3a7008c520083246$export$a6cdc56e425d0d0a(_schema)) throw new Error("Invalid schema: " + _schema);
    var schema = $3a7008c520083246$export$120b571b9a37c370(_schema, rootSchema, formData);
    var defaults = $3a7008c520083246$var$computeDefaults(schema, _schema["default"], rootSchema, formData, includeUndefinedValues);
    if (typeof formData === "undefined") // No form data? Use schema defaults.
    return defaults;
    if ($3a7008c520083246$export$a6cdc56e425d0d0a(formData) || (0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(formData)) return $3a7008c520083246$export$f39406613502c7ad(defaults, formData);
    if (formData === 0 || formData === false || formData === "") return formData;
    return formData || defaults;
}
function $3a7008c520083246$export$f39406613502c7ad(defaults, formData) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(formData)) {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(defaults)) defaults = [];
        return formData.map(function(value, idx) {
            if (defaults[idx]) return $3a7008c520083246$export$f39406613502c7ad(defaults[idx], value);
            return value;
        });
    } else if ($3a7008c520083246$export$a6cdc56e425d0d0a(formData)) {
        var acc = (0, $cG9FK.default)({}, defaults); // Prevent mutation of source object.
        return (0, (/*@__PURE__*/$parcel$interopDefault($8lpxl)))(formData).reduce(function(acc, key) {
            acc[key] = $3a7008c520083246$export$f39406613502c7ad(defaults ? defaults[key] : {}, formData[key]);
            return acc;
        }, acc);
    } else return formData;
}
function $3a7008c520083246$export$5559168444c1cc6f(uiSchema) {
    // get all passed options from ui:widget, ui:options, and ui:<optionName>
    return (0, (/*@__PURE__*/$parcel$interopDefault($8lpxl)))(uiSchema).filter(function(key) {
        return key.indexOf("ui:") === 0;
    }).reduce(function(options, key) {
        var value = uiSchema[key];
        if (key === "ui:widget" && $3a7008c520083246$export$a6cdc56e425d0d0a(value)) {
            console.warn("Setting options via ui:widget object is deprecated, use ui:options instead");
            return (0, $k4zDq.default)({}, options, value.options || {}, {
                widget: value.component
            });
        }
        if (key === "ui:options" && $3a7008c520083246$export$a6cdc56e425d0d0a(value)) return (0, $k4zDq.default)({}, options, value);
        return (0, $k4zDq.default)({}, options, (0, $kB4x2.default)({}, key.substring(3), value));
    }, {});
}
function $3a7008c520083246$export$b90a189477005ecf(schema, uiSchema, rootSchema) {
    var uiOptions = $3a7008c520083246$export$5559168444c1cc6f(uiSchema);
    var _uiOptions$label = uiOptions.label, displayLabel = _uiOptions$label === void 0 ? true : _uiOptions$label;
    if (schema.type === "array") displayLabel = $3a7008c520083246$export$109f4e03a72b2d9b(schema, rootSchema) || $3a7008c520083246$export$abcac65377e58c37(schema, uiSchema, rootSchema);
    if (schema.type === "object") displayLabel = false;
    if (schema.type === "boolean" && !uiSchema["ui:widget"]) displayLabel = false;
    if (uiSchema["ui:field"]) displayLabel = false;
    return displayLabel;
}
function $3a7008c520083246$export$a6cdc56e425d0d0a(thing) {
    if (typeof File !== "undefined" && thing instanceof File) return false;
    return (0, $cD46i.default)(thing) === "object" && thing !== null && !(0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(thing);
}
function $3a7008c520083246$export$2321aea138b44780(obj1, obj2) {
    var concatArrays = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    // Recursively merge deeply nested objects.
    var acc = (0, $cG9FK.default)({}, obj1); // Prevent mutation of source object.
    return (0, (/*@__PURE__*/$parcel$interopDefault($8lpxl)))(obj2).reduce(function(acc, key) {
        var left = obj1 ? obj1[key] : {}, right = obj2[key];
        if (obj1 && obj1.hasOwnProperty(key) && $3a7008c520083246$export$a6cdc56e425d0d0a(right)) acc[key] = $3a7008c520083246$export$2321aea138b44780(left, right, concatArrays);
        else if (concatArrays && (0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(left) && (0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(right)) acc[key] = left.concat(right);
        else acc[key] = right;
        return acc;
    }, acc);
}
function $3a7008c520083246$export$37576b9ba69b50db(value) {
    if (value === "") return undefined;
    if (value === null) return null;
    if (/\.$/.test(value)) // "3." can't really be considered a number even if it parses in js. The
    // user is most likely entering a float.
    return value;
    if (/\.0$/.test(value)) // we need to return this as a string here, to allow for input like 3.07
    return value;
    var n = Number(value);
    var valid = typeof n === "number" && !(0, (/*@__PURE__*/$parcel$interopDefault($kltfT)))(n);
    if (/\.\d*0$/.test(value)) // It's a number, that's cool - but we need it as a string so it doesn't screw
    // with the user when entering dollar amounts or other values (such as those with
    // specific precision or number of significant digits)
    return value;
    return valid ? n : value;
}
function $3a7008c520083246$export$dfe1e6e459a6aaf3(properties, order) {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(order)) return properties;
    var arrayToHash = function arrayToHash(arr) {
        return arr.reduce(function(prev, curr) {
            prev[curr] = true;
            return prev;
        }, {});
    };
    var errorPropList = function errorPropList(arr) {
        return arr.length > 1 ? "properties '".concat(arr.join("', '"), "'") : "property '".concat(arr[0], "'");
    };
    var propertyHash = arrayToHash(properties);
    var orderFiltered = order.filter(function(prop) {
        return prop === "*" || propertyHash[prop];
    });
    var orderHash = arrayToHash(orderFiltered);
    var rest = properties.filter(function(prop) {
        return !orderHash[prop];
    });
    var restIndex = orderFiltered.indexOf("*");
    if (restIndex === -1) {
        if (rest.length) throw new Error("uiSchema order list does not contain ".concat(errorPropList(rest)));
        return orderFiltered;
    }
    if (restIndex !== orderFiltered.lastIndexOf("*")) throw new Error("uiSchema order list contains more than one wildcard item");
    var complete = (0, $4juyi.default)(orderFiltered);
    complete.splice.apply(complete, [
        restIndex,
        1
    ].concat((0, $4juyi.default)(rest)));
    return complete;
}
function $3a7008c520083246$export$614ff3cc3ef6eda9(schema) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(schema["enum"]) && schema["enum"].length === 1 || schema.hasOwnProperty("const");
}
function $3a7008c520083246$export$2d50ffa8d7cfb37(schema) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(schema["enum"]) && schema["enum"].length === 1) return schema["enum"][0];
    else if (schema.hasOwnProperty("const")) return schema["const"];
    else throw new Error("schema cannot be inferred as a constant");
}
function $3a7008c520083246$export$47ed34a15a70bfcf(_schema) {
    var rootSchema = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var schema = $3a7008c520083246$export$120b571b9a37c370(_schema, rootSchema);
    var altSchemas = schema.oneOf || schema.anyOf;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(schema["enum"])) return true;
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(altSchemas)) return altSchemas.every(function(altSchemas) {
        return $3a7008c520083246$export$614ff3cc3ef6eda9(altSchemas);
    });
    return false;
}
function $3a7008c520083246$export$109f4e03a72b2d9b(schema) {
    var rootSchema = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!schema.uniqueItems || !schema.items) return false;
    return $3a7008c520083246$export$47ed34a15a70bfcf(schema.items, rootSchema);
}
function $3a7008c520083246$export$abcac65377e58c37(schema, uiSchema) {
    var rootSchema = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (uiSchema["ui:widget"] === "files") return true;
    else if (schema.items) {
        var itemsSchema = $3a7008c520083246$export$120b571b9a37c370(schema.items, rootSchema);
        return itemsSchema.type === "string" && itemsSchema.format === "data-url";
    }
    return false;
}
function $3a7008c520083246$export$f214a64b20942f03(schema) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(schema.items) && schema.items.length > 0 && schema.items.every(function(item) {
        return $3a7008c520083246$export$a6cdc56e425d0d0a(item);
    });
}
function $3a7008c520083246$export$b5ae80b7edac7510(schema) {
    if (schema.additionalItems === true) console.warn("additionalItems=true is currently not supported");
    return $3a7008c520083246$export$a6cdc56e425d0d0a(schema.additionalItems);
}
function $3a7008c520083246$export$675008a38d270fd3(schema) {
    if (schema["enum"]) return schema["enum"].map(function(value, i) {
        var label = schema.enumNames && schema.enumNames[i] || String(value);
        return {
            label: label,
            value: value
        };
    });
    else {
        var altSchemas = schema.oneOf || schema.anyOf;
        return altSchemas.map(function(schema, i) {
            var value = $3a7008c520083246$export$2d50ffa8d7cfb37(schema);
            var label = schema.title || String(value);
            return {
                schema: schema,
                label: label,
                value: value
            };
        });
    }
}
function $3a7008c520083246$export$ba75abbfed20f81f($ref) {
    var rootSchema = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var origRef = $ref;
    if ($ref.startsWith("#")) // Decode URI fragment representation.
    $ref = decodeURIComponent($ref.substring(1));
    else throw new Error("Could not find a definition for ".concat(origRef, "."));
    var current = (0, (/*@__PURE__*/$parcel$interopDefault($raQQi))).get(rootSchema, $ref);
    if (current === undefined) throw new Error("Could not find a definition for ".concat(origRef, "."));
    if (current.hasOwnProperty("$ref")) return $3a7008c520083246$export$ba75abbfed20f81f(current.$ref, rootSchema);
    return current;
} // In the case where we have to implicitly create a schema, it is useful to know what type to use
var $3a7008c520083246$export$211ef2ad09ba7d20 = function guessType(value) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(value)) return "array";
    else if (typeof value === "string") return "string";
    else if (value == null) return "null";
    else if (typeof value === "boolean") return "boolean";
    else if (!isNaN(value)) return "number";
    else if ((0, $cD46i.default)(value) === "object") return "object";
     // Default to string if we can't figure it out
    return "string";
}; // This function will create new "properties" items for each key in our formData
function $3a7008c520083246$export$7f455fe1643a61e7(schema) {
    var rootSchema = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var formData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    // Clone the schema so we don't ruin the consumer's original
    schema = (0, $k4zDq.default)({}, schema, {
        properties: (0, $k4zDq.default)({}, schema.properties)
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($8lpxl)))(formData).forEach(function(key) {
        if (schema.properties.hasOwnProperty(key)) // No need to stub, our schema already has the property
        return;
        var additionalProperties;
        if (schema.additionalProperties.hasOwnProperty("$ref")) additionalProperties = $3a7008c520083246$export$120b571b9a37c370({
            $ref: schema.additionalProperties["$ref"]
        }, rootSchema, formData);
        else if (schema.additionalProperties.hasOwnProperty("type")) additionalProperties = (0, $k4zDq.default)({}, schema.additionalProperties);
        else additionalProperties = {
            type: $3a7008c520083246$export$211ef2ad09ba7d20(formData[key])
        };
         // The type of our new key should match the additionalProperties value;
        schema.properties[key] = additionalProperties; // Set our additional property flag so we know it was dynamically added
        schema.properties[key][$3a7008c520083246$export$60d2d9c11642ddd6] = true;
    });
    return schema;
}
function $3a7008c520083246$export$108f8296d443cf05(schema) {
    var rootSchema = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var formData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (schema.hasOwnProperty("$ref")) return $3a7008c520083246$var$resolveReference(schema, rootSchema, formData);
    else if (schema.hasOwnProperty("dependencies")) {
        var resolvedSchema = $3a7008c520083246$var$resolveDependencies(schema, rootSchema, formData);
        return $3a7008c520083246$export$120b571b9a37c370(resolvedSchema, rootSchema, formData);
    } else if (schema.hasOwnProperty("allOf")) return (0, $k4zDq.default)({}, schema, {
        allOf: schema.allOf.map(function(allOfSubschema) {
            return $3a7008c520083246$export$120b571b9a37c370(allOfSubschema, rootSchema, formData);
        })
    });
    else // No $ref or dependencies attribute found, returning the original schema.
    return schema;
}
function $3a7008c520083246$var$resolveReference(schema, rootSchema, formData) {
    // Retrieve the referenced schema definition.
    var $refSchema = $3a7008c520083246$export$ba75abbfed20f81f(schema.$ref, rootSchema); // Drop the $ref property of the source schema.
    var $ref = schema.$ref, localSchema = (0, $gpTap.default)(schema, [
        "$ref"
    ]); // Update referenced schema definition with local schema properties.
    return $3a7008c520083246$export$120b571b9a37c370((0, $k4zDq.default)({}, $refSchema, localSchema), rootSchema, formData);
}
function $3a7008c520083246$export$120b571b9a37c370(schema) {
    var rootSchema = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var formData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!$3a7008c520083246$export$a6cdc56e425d0d0a(schema)) return {};
    var resolvedSchema = $3a7008c520083246$export$108f8296d443cf05(schema, rootSchema, formData);
    if ("allOf" in schema) try {
        resolvedSchema = (0, (/*@__PURE__*/$parcel$interopDefault($6j9O2)))((0, $k4zDq.default)({}, resolvedSchema, {
            allOf: resolvedSchema.allOf
        }));
    } catch (e) {
        console.warn("could not merge subschemas in allOf:\n" + e);
        var _resolvedSchema = resolvedSchema, allOf = _resolvedSchema.allOf, resolvedSchemaWithoutAllOf = (0, $gpTap.default)(_resolvedSchema, [
            "allOf"
        ]);
        return resolvedSchemaWithoutAllOf;
    }
    var hasAdditionalProperties = resolvedSchema.hasOwnProperty("additionalProperties") && resolvedSchema.additionalProperties !== false;
    if (hasAdditionalProperties) return $3a7008c520083246$export$7f455fe1643a61e7(resolvedSchema, rootSchema, formData);
    return resolvedSchema;
}
function $3a7008c520083246$var$resolveDependencies(schema, rootSchema, formData) {
    // Drop the dependencies from the source schema.
    var _schema$dependencies = schema.dependencies, dependencies = _schema$dependencies === void 0 ? {} : _schema$dependencies, resolvedSchema = (0, $gpTap.default)(schema, [
        "dependencies"
    ]);
    if ("oneOf" in resolvedSchema) resolvedSchema = resolvedSchema.oneOf[$3a7008c520083246$export$8165cea9d212ff07(formData, resolvedSchema.oneOf, rootSchema)];
    else if ("anyOf" in resolvedSchema) resolvedSchema = resolvedSchema.anyOf[$3a7008c520083246$export$8165cea9d212ff07(formData, resolvedSchema.anyOf, rootSchema)];
    return $3a7008c520083246$var$processDependencies(dependencies, resolvedSchema, rootSchema, formData);
}
function $3a7008c520083246$var$processDependencies(dependencies, resolvedSchema, rootSchema, formData) {
    // Process dependencies updating the local schema properties as appropriate.
    for(var dependencyKey in dependencies){
        // Skip this dependency if its trigger property is not present.
        if (formData[dependencyKey] === undefined) continue;
         // Skip this dependency if it is not included in the schema (such as when dependencyKey is itself a hidden dependency.)
        if (resolvedSchema.properties && !(dependencyKey in resolvedSchema.properties)) continue;
        var dependencyValue = dependencies[dependencyKey], remainingDependencies = (0, $gpTap.default)(dependencies, [
            dependencyKey
        ].map($3a7008c520083246$var$_toPropertyKey));
        if ((0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(dependencyValue)) resolvedSchema = $3a7008c520083246$var$withDependentProperties(resolvedSchema, dependencyValue);
        else if ($3a7008c520083246$export$a6cdc56e425d0d0a(dependencyValue)) resolvedSchema = $3a7008c520083246$var$withDependentSchema(resolvedSchema, rootSchema, formData, dependencyKey, dependencyValue);
        return $3a7008c520083246$var$processDependencies(remainingDependencies, resolvedSchema, rootSchema, formData);
    }
    return resolvedSchema;
}
function $3a7008c520083246$var$withDependentProperties(schema, additionallyRequired) {
    if (!additionallyRequired) return schema;
    var required = (0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(schema.required) ? (0, (/*@__PURE__*/$parcel$interopDefault($UVaxg)))(new (0, (/*@__PURE__*/$parcel$interopDefault($lyRnQ)))([].concat((0, $4juyi.default)(schema.required), (0, $4juyi.default)(additionallyRequired)))) : additionallyRequired;
    return (0, $k4zDq.default)({}, schema, {
        required: required
    });
}
function $3a7008c520083246$var$withDependentSchema(schema, rootSchema, formData, dependencyKey, dependencyValue) {
    var _retrieveSchema = $3a7008c520083246$export$120b571b9a37c370(dependencyValue, rootSchema, formData), oneOf = _retrieveSchema.oneOf, dependentSchema = (0, $gpTap.default)(_retrieveSchema, [
        "oneOf"
    ]);
    schema = $3a7008c520083246$export$dd610e1878d5f5e(schema, dependentSchema); // Since it does not contain oneOf, we return the original schema.
    if (oneOf === undefined) return schema;
    else if (!(0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(oneOf)) throw new Error("invalid: it is some ".concat((0, $cD46i.default)(oneOf), " instead of an array"));
     // Resolve $refs inside oneOf.
    var resolvedOneOf = oneOf.map(function(subschema) {
        return subschema.hasOwnProperty("$ref") ? $3a7008c520083246$var$resolveReference(subschema, rootSchema, formData) : subschema;
    });
    return $3a7008c520083246$var$withExactlyOneSubschema(schema, rootSchema, formData, dependencyKey, resolvedOneOf);
}
function $3a7008c520083246$var$withExactlyOneSubschema(schema, rootSchema, formData, dependencyKey, oneOf) {
    var validSubschemas = oneOf.filter(function(subschema) {
        if (!subschema.properties) return false;
        var conditionPropertySchema = subschema.properties[dependencyKey];
        if (conditionPropertySchema) {
            var conditionSchema = {
                type: "object",
                properties: (0, $kB4x2.default)({}, dependencyKey, conditionPropertySchema)
            };
            var _validateFormData = (0, $czU5E.default)(formData, conditionSchema), errors = _validateFormData.errors;
            return errors.length === 0;
        }
    });
    if (validSubschemas.length !== 1) {
        console.warn("ignoring oneOf in dependencies because there isn't exactly one subschema that is valid");
        return schema;
    }
    var subschema = validSubschemas[0];
    var _subschema$properties = subschema.properties, conditionPropertySchema = _subschema$properties[dependencyKey], dependentSubschema = (0, $gpTap.default)(_subschema$properties, [
        dependencyKey
    ].map($3a7008c520083246$var$_toPropertyKey));
    var dependentSchema = (0, $k4zDq.default)({}, subschema, {
        properties: dependentSubschema
    });
    return $3a7008c520083246$export$dd610e1878d5f5e(schema, $3a7008c520083246$export$120b571b9a37c370(dependentSchema, rootSchema, formData));
} // Recursively merge deeply nested schemas.
function $3a7008c520083246$export$dd610e1878d5f5e(obj1, obj2) {
    var acc = (0, $cG9FK.default)({}, obj1); // Prevent mutation of source object.
    return (0, (/*@__PURE__*/$parcel$interopDefault($8lpxl)))(obj2).reduce(function(acc, key) {
        var left = obj1 ? obj1[key] : {}, right = obj2[key];
        if (obj1 && obj1.hasOwnProperty(key) && $3a7008c520083246$export$a6cdc56e425d0d0a(right)) acc[key] = $3a7008c520083246$export$dd610e1878d5f5e(left, right);
        else if (obj1 && obj2 && ($3a7008c520083246$export$c37d213d49c78145(obj1) === "object" || $3a7008c520083246$export$c37d213d49c78145(obj2) === "object") && key === "required" && (0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(left) && (0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(right)) // Don't include duplicate values when merging
        // "required" fields.
        acc[key] = (0, (/*@__PURE__*/$parcel$interopDefault($1c10x)))(left, right);
        else acc[key] = right;
        return acc;
    }, acc);
}
function $3a7008c520083246$var$isArguments(object) {
    return Object.prototype.toString.call(object) === "[object Arguments]";
}
function $3a7008c520083246$export$73ce4178444047a5(a, b) {
    var ca = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var cb = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    // Partially extracted from node-deeper and adapted to exclude comparison
    // checks for functions.
    // https://github.com/othiym23/node-deeper
    if (a === b) return true;
    else if (typeof a === "function" || typeof b === "function") // Assume all functions are equivalent
    // see https://github.com/rjsf-team/react-jsonschema-form/issues/255
    return true;
    else if ((0, $cD46i.default)(a) !== "object" || (0, $cD46i.default)(b) !== "object") return false;
    else if (a === null || b === null) return false;
    else if (a instanceof Date && b instanceof Date) return a.getTime() === b.getTime();
    else if (a instanceof RegExp && b instanceof RegExp) return a.source === b.source && a.global === b.global && a.multiline === b.multiline && a.lastIndex === b.lastIndex && a.ignoreCase === b.ignoreCase;
    else if ($3a7008c520083246$var$isArguments(a) || $3a7008c520083246$var$isArguments(b)) {
        if (!($3a7008c520083246$var$isArguments(a) && $3a7008c520083246$var$isArguments(b))) return false;
        var slice = Array.prototype.slice;
        return $3a7008c520083246$export$73ce4178444047a5(slice.call(a), slice.call(b), ca, cb);
    } else {
        if (a.constructor !== b.constructor) return false;
        var ka = (0, (/*@__PURE__*/$parcel$interopDefault($8lpxl)))(a);
        var kb = (0, (/*@__PURE__*/$parcel$interopDefault($8lpxl)))(b); // don't bother with stack acrobatics if there's nothing there
        if (ka.length === 0 && kb.length === 0) return true;
        if (ka.length !== kb.length) return false;
        var cal = ca.length;
        while(cal--){
            if (ca[cal] === a) return cb[cal] === b;
        }
        ca.push(a);
        cb.push(b);
        ka.sort();
        kb.sort();
        for(var j = ka.length - 1; j >= 0; j--){
            if (ka[j] !== kb[j]) return false;
        }
        var key;
        for(var k = ka.length - 1; k >= 0; k--){
            key = ka[k];
            if (!$3a7008c520083246$export$73ce4178444047a5(a[key], b[key], ca, cb)) return false;
        }
        ca.pop();
        cb.pop();
        return true;
    }
}
function $3a7008c520083246$export$74f9e9340d52d089(comp, nextProps, nextState) {
    var props = comp.props, state = comp.state;
    return !$3a7008c520083246$export$73ce4178444047a5(props, nextProps) || !$3a7008c520083246$export$73ce4178444047a5(state, nextState);
}
function $3a7008c520083246$export$9e93037aa8764d4d(schema, id, rootSchema) {
    var formData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var idPrefix = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "root";
    var idSchema = {
        $id: id || idPrefix
    };
    if ("$ref" in schema || "dependencies" in schema || "allOf" in schema) {
        var _schema = $3a7008c520083246$export$120b571b9a37c370(schema, rootSchema, formData);
        return $3a7008c520083246$export$9e93037aa8764d4d(_schema, id, rootSchema, formData, idPrefix);
    }
    if ("items" in schema && !schema.items.$ref) return $3a7008c520083246$export$9e93037aa8764d4d(schema.items, id, rootSchema, formData, idPrefix);
    if (schema.type !== "object") return idSchema;
    for(var name in schema.properties || {}){
        var field = schema.properties[name];
        var fieldId = idSchema.$id + "_" + name;
        idSchema[name] = $3a7008c520083246$export$9e93037aa8764d4d($3a7008c520083246$export$a6cdc56e425d0d0a(field) ? field : {}, fieldId, rootSchema, // array item has just been added, but not populated with data yet
        (formData || {})[name], idPrefix);
    }
    return idSchema;
}
function $3a7008c520083246$export$7c522d40b1c31ae0(schema) {
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var rootSchema = arguments.length > 2 ? arguments[2] : undefined;
    var formData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var pathSchema = {
        $name: name.replace(/^\./, "")
    };
    if ("$ref" in schema || "dependencies" in schema || "allOf" in schema) {
        var _schema = $3a7008c520083246$export$120b571b9a37c370(schema, rootSchema, formData);
        return $3a7008c520083246$export$7c522d40b1c31ae0(_schema, name, rootSchema, formData);
    }
    if (schema.hasOwnProperty("additionalProperties")) pathSchema.__rjsf_additionalProperties = true;
    if (schema.hasOwnProperty("items") && (0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(formData)) formData.forEach(function(element, i) {
        pathSchema[i] = $3a7008c520083246$export$7c522d40b1c31ae0(schema.items, "".concat(name, ".").concat(i), rootSchema, element);
    });
    else if (schema.hasOwnProperty("properties")) for(var property in schema.properties)pathSchema[property] = $3a7008c520083246$export$7c522d40b1c31ae0(schema.properties[property], "".concat(name, ".").concat(property), rootSchema, // array item has just been added, but not populated with data yet
    (formData || {})[property]);
    return pathSchema;
}
function $3a7008c520083246$export$e684af8cfb294f41(dateString) {
    var includeTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (!dateString) return {
        year: -1,
        month: -1,
        day: -1,
        hour: includeTime ? -1 : 0,
        minute: includeTime ? -1 : 0,
        second: includeTime ? -1 : 0
    };
    var date = new Date(dateString);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($kltfT)))(date.getTime())) throw new Error("Unable to parse date " + dateString);
    return {
        year: date.getUTCFullYear(),
        month: date.getUTCMonth() + 1,
        // oh you, javascript.
        day: date.getUTCDate(),
        hour: includeTime ? date.getUTCHours() : 0,
        minute: includeTime ? date.getUTCMinutes() : 0,
        second: includeTime ? date.getUTCSeconds() : 0
    };
}
function $3a7008c520083246$export$b7c4e1545c61edee(_ref2) {
    var year = _ref2.year, month = _ref2.month, day = _ref2.day, _ref2$hour = _ref2.hour, hour = _ref2$hour === void 0 ? 0 : _ref2$hour, _ref2$minute = _ref2.minute, minute = _ref2$minute === void 0 ? 0 : _ref2$minute, _ref2$second = _ref2.second, second = _ref2$second === void 0 ? 0 : _ref2$second;
    var time = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var utcTime = Date.UTC(year, month - 1, day, hour, minute, second);
    var datetime = new Date(utcTime).toJSON();
    return time ? datetime : datetime.slice(0, 10);
}
function $3a7008c520083246$export$ccd9a1bc6174ad42(jsonDate) {
    if (!jsonDate) return "";
     // required format of `"yyyy-MM-ddThh:mm" followed by optional ":ss" or ":ss.SSS"
    // https://html.spec.whatwg.org/multipage/input.html#local-date-and-time-state-(type%3Ddatetime-local)
    // > should be a _valid local date and time string_ (not GMT)
    // Note - date constructor passed local ISO-8601 does not correctly
    // change time to UTC in node pre-8
    var date = new Date(jsonDate);
    var yyyy = $3a7008c520083246$export$5d04458e2a6c373e(date.getFullYear(), 4);
    var MM = $3a7008c520083246$export$5d04458e2a6c373e(date.getMonth() + 1, 2);
    var dd = $3a7008c520083246$export$5d04458e2a6c373e(date.getDate(), 2);
    var hh = $3a7008c520083246$export$5d04458e2a6c373e(date.getHours(), 2);
    var mm = $3a7008c520083246$export$5d04458e2a6c373e(date.getMinutes(), 2);
    var ss = $3a7008c520083246$export$5d04458e2a6c373e(date.getSeconds(), 2);
    var SSS = $3a7008c520083246$export$5d04458e2a6c373e(date.getMilliseconds(), 3);
    return "".concat(yyyy, "-").concat(MM, "-").concat(dd, "T").concat(hh, ":").concat(mm, ":").concat(ss, ".").concat(SSS);
}
function $3a7008c520083246$export$779990c68cce4240(dateString) {
    if (dateString) return new Date(dateString).toJSON();
}
function $3a7008c520083246$export$5d04458e2a6c373e(num, size) {
    var s = String(num);
    while(s.length < size)s = "0" + s;
    return s;
}
function $3a7008c520083246$export$24bc7e761c190a9f(dataURI) {
    // Split metadata from data
    var splitted = dataURI.split(","); // Split params
    var params = splitted[0].split(";"); // Get mime-type from params
    var type = params[0].replace("data:", ""); // Filter the name property from params
    var properties = params.filter(function(param) {
        return param.split("=")[0] === "name";
    }); // Look for the name and use unknown if no name property.
    var name;
    if (properties.length !== 1) name = "unknown";
    else // Because we filtered out the other property,
    // we only have the name case here.
    name = properties[0].split("=")[1];
     // Built the Uint8Array Blob parameter from the base64 string.
    var binary = atob(splitted[1]);
    var array = [];
    for(var i = 0; i < binary.length; i++)array.push(binary.charCodeAt(i));
     // Create the blob object
    var blob = new window.Blob([
        new Uint8Array(array)
    ], {
        type: type
    });
    return {
        blob: blob,
        name: name
    };
}
function $3a7008c520083246$export$241fd4b305d2db0a(schema) {
    var spec = {};
    if (schema.multipleOf) spec.step = schema.multipleOf;
    if (schema.minimum || schema.minimum === 0) spec.min = schema.minimum;
    if (schema.maximum || schema.maximum === 0) spec.max = schema.maximum;
    return spec;
}
function $3a7008c520083246$export$8165cea9d212ff07(formData, options, rootSchema) {
    for(var i = 0; i < options.length; i++){
        var option = options[i]; // If the schema describes an object then we need to add slightly more
        // strict matching to the schema, because unless the schema uses the
        // "requires" keyword, an object will match the schema as long as it
        // doesn't have matching keys with a conflicting type. To do this we use an
        // "anyOf" with an array of requires. This augmentation expresses that the
        // schema should match if any of the keys in the schema are present on the
        // object and pass validation.
        if (option.properties) {
            // Create an "anyOf" schema that requires at least one of the keys in the
            // "properties" object
            var requiresAnyOf = {
                anyOf: (0, (/*@__PURE__*/$parcel$interopDefault($8lpxl)))(option.properties).map(function(key) {
                    return {
                        required: [
                            key
                        ]
                    };
                })
            };
            var augmentedSchema = void 0; // If the "anyOf" keyword already exists, wrap the augmentation in an "allOf"
            if (option.anyOf) {
                // Create a shallow clone of the option
                var shallowClone = (0, $cG9FK.default)({}, option);
                if (!shallowClone.allOf) shallowClone.allOf = [];
                else // If "allOf" already exists, shallow clone the array
                shallowClone.allOf = shallowClone.allOf.slice();
                shallowClone.allOf.push(requiresAnyOf);
                augmentedSchema = shallowClone;
            } else augmentedSchema = (0, $cG9FK.default)({}, option, requiresAnyOf);
             // Remove the "required" field as it's likely that not all fields have
            // been filled in yet, which will mean that the schema is not valid
            delete augmentedSchema.required;
            if ((0, $czU5E.isValid)(augmentedSchema, formData)) return i;
        } else if ((0, $czU5E.isValid)(options[i], formData)) return i;
    }
    return 0;
} // Check to see if a schema specifies that a value must be true
function $3a7008c520083246$export$1203181f0b231402(schema) {
    // Check if const is a truthy value
    if (schema["const"]) return true;
     // Check if an enum has a single value of true
    if (schema["enum"] && schema["enum"].length === 1 && schema["enum"][0] === true) return true;
     // If anyOf has a single value, evaluate the subschema
    if (schema.anyOf && schema.anyOf.length === 1) return $3a7008c520083246$export$1203181f0b231402(schema.anyOf[0]);
     // If oneOf has a single value, evaluate the subschema
    if (schema.oneOf && schema.oneOf.length === 1) return $3a7008c520083246$export$1203181f0b231402(schema.oneOf[0]);
     // Evaluate each subschema in allOf, to see if one of them requires a true
    // value
    if (schema.allOf) return schema.allOf.some($3a7008c520083246$export$1203181f0b231402);
    return false;
}

});
parcelRegister("C6M3y", function(module, exports) {

$parcel$export(module.exports, "default", () => $0728cdeb7e910ac3$export$2e2bcd8739ae039);

var $6A0eI = parcelRequire("6A0eI");

var $krM5C = parcelRequire("krM5C");

var $6ojM0 = parcelRequire("6ojM0");

var $jsrg2 = parcelRequire("jsrg2");

var $b2QFn = parcelRequire("b2QFn");

var $foC1q = parcelRequire("foC1q");

var $izrop = parcelRequire("izrop");

var $8o4rR = parcelRequire("8o4rR");

var $1vIXA = parcelRequire("1vIXA");

var $aoDvC = parcelRequire("aoDvC");

var $ctUWC = parcelRequire("ctUWC");
var $0728cdeb7e910ac3$export$2e2bcd8739ae039 = {
    AnyOfField: (0, $jsrg2.default),
    ArrayField: (0, $6A0eI.default),
    BooleanField: (0, $krM5C.default),
    DescriptionField: (0, $6ojM0.default),
    NumberField: (0, $b2QFn.default),
    ObjectField: (0, $foC1q.default),
    OneOfField: (0, $jsrg2.default),
    SchemaField: (0, $izrop.default),
    StringField: (0, $8o4rR.default),
    TitleField: (0, $1vIXA.default),
    NullField: (0, $aoDvC.default),
    UnsupportedField: (0, $ctUWC.default)
};

});
parcelRegister("6A0eI", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ca649cffd4665f1$export$2e2bcd8739ae039);

var $8lpxl = parcelRequire("8lpxl");

var $gpTap = parcelRequire("gpTap");

var $k4zDq = parcelRequire("k4zDq");

var $aYvV6 = parcelRequire("aYvV6");

var $4juyi = parcelRequire("4juyi");

var $7PwEf = parcelRequire("7PwEf");

var $4tWkZ = parcelRequire("4tWkZ");

var $eBH73 = parcelRequire("eBH73");

var $ctnWZ = parcelRequire("ctnWZ");

var $hl9R1 = parcelRequire("hl9R1");

var $ivxVa = parcelRequire("ivxVa");

var $kB4x2 = parcelRequire("kB4x2");

var $a5du3 = parcelRequire("a5du3");

var $iu2ms = parcelRequire("iu2ms");

var $99rTF = parcelRequire("99rTF");

var $acw62 = parcelRequire("acw62");

var $3IXh5 = parcelRequire("3IXh5");
parcelRequire("bdadt");

var $513QU = parcelRequire("513QU");

var $86Jyb = parcelRequire("86Jyb");
function $4ca649cffd4665f1$var$ArrayFieldTitle(_ref) {
    var TitleField = _ref.TitleField, idSchema = _ref.idSchema, title = _ref.title, required = _ref.required;
    if (!title) return null;
    var id = "".concat(idSchema.$id, "__title");
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TitleField, {
        id: id,
        title: title,
        required: required
    });
}
function $4ca649cffd4665f1$var$ArrayFieldDescription(_ref2) {
    var DescriptionField = _ref2.DescriptionField, idSchema = _ref2.idSchema, description = _ref2.description;
    if (!description) return null;
    var id = "".concat(idSchema.$id, "__description");
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(DescriptionField, {
        id: id,
        description: description
    });
} // Used in the two templates
function $4ca649cffd4665f1$var$DefaultArrayItem(props) {
    var btnStyle = {
        flex: 1,
        paddingLeft: 6,
        paddingRight: 6,
        fontWeight: "bold"
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        key: props.key,
        className: props.className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: props.hasToolbar ? "col-xs-9" : "col-xs-12"
    }, props.children), props.hasToolbar && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "col-xs-3 array-item-toolbox"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "btn-group",
        style: {
            display: "flex",
            justifyContent: "space-around"
        }
    }, (props.hasMoveUp || props.hasMoveDown) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $99rTF.default), {
        icon: "arrow-up",
        "aria-label": "Move up",
        className: "array-item-move-up",
        tabIndex: "-1",
        style: btnStyle,
        disabled: props.disabled || props.readonly || !props.hasMoveUp,
        onClick: props.onReorderClick(props.index, props.index - 1)
    }), (props.hasMoveUp || props.hasMoveDown) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $99rTF.default), {
        icon: "arrow-down",
        className: "array-item-move-down",
        "aria-label": "Move down",
        tabIndex: "-1",
        style: btnStyle,
        disabled: props.disabled || props.readonly || !props.hasMoveDown,
        onClick: props.onReorderClick(props.index, props.index + 1)
    }), props.hasRemove && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $99rTF.default), {
        type: "danger",
        icon: "remove",
        "aria-label": "Remove",
        className: "array-item-remove",
        tabIndex: "-1",
        style: btnStyle,
        disabled: props.disabled || props.readonly,
        onClick: props.onDropIndexClick(props.index)
    }))));
}
function $4ca649cffd4665f1$var$DefaultFixedArrayFieldTemplate(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("fieldset", {
        className: props.className,
        id: props.idSchema.$id
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4ca649cffd4665f1$var$ArrayFieldTitle, {
        key: "array-field-title-".concat(props.idSchema.$id),
        TitleField: props.TitleField,
        idSchema: props.idSchema,
        title: props.uiSchema["ui:title"] || props.title,
        required: props.required
    }), (props.uiSchema["ui:description"] || props.schema.description) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "field-description",
        key: "field-description-".concat(props.idSchema.$id)
    }, props.uiSchema["ui:description"] || props.schema.description), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "row array-item-list",
        key: "array-item-list-".concat(props.idSchema.$id)
    }, props.items && props.items.map($4ca649cffd4665f1$var$DefaultArrayItem)), props.canAdd && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $iu2ms.default), {
        className: "array-item-add",
        onClick: props.onAddClick,
        disabled: props.disabled || props.readonly
    }));
}
function $4ca649cffd4665f1$var$DefaultNormalArrayFieldTemplate(props) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("fieldset", {
        className: props.className,
        id: props.idSchema.$id
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4ca649cffd4665f1$var$ArrayFieldTitle, {
        key: "array-field-title-".concat(props.idSchema.$id),
        TitleField: props.TitleField,
        idSchema: props.idSchema,
        title: props.uiSchema["ui:title"] || props.title,
        required: props.required
    }), (props.uiSchema["ui:description"] || props.schema.description) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($4ca649cffd4665f1$var$ArrayFieldDescription, {
        key: "array-field-description-".concat(props.idSchema.$id),
        DescriptionField: props.DescriptionField,
        idSchema: props.idSchema,
        description: props.uiSchema["ui:description"] || props.schema.description
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "row array-item-list",
        key: "array-item-list-".concat(props.idSchema.$id)
    }, props.items && props.items.map(function(p) {
        return $4ca649cffd4665f1$var$DefaultArrayItem(p);
    })), props.canAdd && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $iu2ms.default), {
        className: "array-item-add",
        onClick: props.onAddClick,
        disabled: props.disabled || props.readonly
    }));
}
function $4ca649cffd4665f1$var$generateRowId() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($86Jyb))).generate();
}
function $4ca649cffd4665f1$var$generateKeyedFormData(formData) {
    return !(0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(formData) ? [] : formData.map(function(item) {
        return {
            key: $4ca649cffd4665f1$var$generateRowId(),
            item: item
        };
    });
}
function $4ca649cffd4665f1$var$keyedToPlainFormData(keyedFormData) {
    return keyedFormData.map(function(keyedItem) {
        return keyedItem.item;
    });
}
var $4ca649cffd4665f1$var$ArrayField = /*#__PURE__*/ function(_Component) {
    (0, $ivxVa.default)(ArrayField, _Component);
    function ArrayField(props) {
        var _this;
        (0, $7PwEf.default)(this, ArrayField);
        _this = (0, $eBH73.default)(this, (0, $ctnWZ.default)(ArrayField).call(this, props));
        (0, $kB4x2.default)((0, $hl9R1.default)(_this), "_getNewFormDataRow", function() {
            var _this$props = _this.props, schema = _this$props.schema, _this$props$registry = _this$props.registry, registry = _this$props$registry === void 0 ? (0, $513QU.getDefaultRegistry)() : _this$props$registry;
            var rootSchema = registry.rootSchema;
            var itemSchema = schema.items;
            if ((0, $513QU.isFixedItems)(schema) && (0, $513QU.allowAdditionalItems)(schema)) itemSchema = schema.additionalItems;
            return (0, $513QU.getDefaultFormState)(itemSchema, undefined, rootSchema);
        });
        (0, $kB4x2.default)((0, $hl9R1.default)(_this), "onAddClick", function(event) {
            if (event) event.preventDefault();
            var onChange = _this.props.onChange;
            var newKeyedFormDataRow = {
                key: $4ca649cffd4665f1$var$generateRowId(),
                item: _this._getNewFormDataRow()
            };
            var newKeyedFormData = [].concat((0, $4juyi.default)(_this.state.keyedFormData), [
                newKeyedFormDataRow
            ]);
            _this.setState({
                keyedFormData: newKeyedFormData,
                updatedKeyedFormData: true
            }, function() {
                return onChange($4ca649cffd4665f1$var$keyedToPlainFormData(newKeyedFormData));
            });
        });
        (0, $kB4x2.default)((0, $hl9R1.default)(_this), "onAddIndexClick", function(index) {
            return function(event) {
                if (event) event.preventDefault();
                var onChange = _this.props.onChange;
                var newKeyedFormDataRow = {
                    key: $4ca649cffd4665f1$var$generateRowId(),
                    item: _this._getNewFormDataRow()
                };
                var newKeyedFormData = (0, $4juyi.default)(_this.state.keyedFormData);
                newKeyedFormData.splice(index, 0, newKeyedFormDataRow);
                _this.setState({
                    keyedFormData: newKeyedFormData,
                    updatedKeyedFormData: true
                }, function() {
                    return onChange($4ca649cffd4665f1$var$keyedToPlainFormData(newKeyedFormData));
                });
            };
        });
        (0, $kB4x2.default)((0, $hl9R1.default)(_this), "onDropIndexClick", function(index) {
            return function(event) {
                if (event) event.preventDefault();
                var onChange = _this.props.onChange;
                var keyedFormData = _this.state.keyedFormData; // refs #195: revalidate to ensure properly reindexing errors
                var newErrorSchema;
                if (_this.props.errorSchema) {
                    newErrorSchema = {};
                    var errorSchema = _this.props.errorSchema;
                    for(var i in errorSchema){
                        i = (0, (/*@__PURE__*/$parcel$interopDefault($aYvV6)))(i);
                        if (i < index) newErrorSchema[i] = errorSchema[i];
                        else if (i > index) newErrorSchema[i - 1] = errorSchema[i];
                    }
                }
                var newKeyedFormData = keyedFormData.filter(function(_, i) {
                    return i !== index;
                });
                _this.setState({
                    keyedFormData: newKeyedFormData,
                    updatedKeyedFormData: true
                }, function() {
                    return onChange($4ca649cffd4665f1$var$keyedToPlainFormData(newKeyedFormData), newErrorSchema);
                });
            };
        });
        (0, $kB4x2.default)((0, $hl9R1.default)(_this), "onReorderClick", function(index, newIndex) {
            return function(event) {
                if (event) {
                    event.preventDefault();
                    event.target.blur();
                }
                var onChange = _this.props.onChange;
                var newErrorSchema;
                if (_this.props.errorSchema) {
                    newErrorSchema = {};
                    var errorSchema = _this.props.errorSchema;
                    for(var i in errorSchema){
                        if (i == index) newErrorSchema[newIndex] = errorSchema[index];
                        else if (i == newIndex) newErrorSchema[index] = errorSchema[newIndex];
                        else newErrorSchema[i] = errorSchema[i];
                    }
                }
                var keyedFormData = _this.state.keyedFormData;
                function reOrderArray() {
                    // Copy item
                    var _newKeyedFormData = keyedFormData.slice(); // Moves item from index to newIndex
                    _newKeyedFormData.splice(index, 1);
                    _newKeyedFormData.splice(newIndex, 0, keyedFormData[index]);
                    return _newKeyedFormData;
                }
                var newKeyedFormData = reOrderArray();
                _this.setState({
                    keyedFormData: newKeyedFormData
                }, function() {
                    return onChange($4ca649cffd4665f1$var$keyedToPlainFormData(newKeyedFormData), newErrorSchema);
                });
            };
        });
        (0, $kB4x2.default)((0, $hl9R1.default)(_this), "onChangeForIndex", function(index) {
            return function(value, errorSchema) {
                var _this$props2 = _this.props, formData = _this$props2.formData, onChange = _this$props2.onChange;
                var newFormData = formData.map(function(item, i) {
                    // We need to treat undefined items as nulls to have validation.
                    // See https://github.com/tdegrunt/jsonschema/issues/206
                    var jsonValue = typeof value === "undefined" ? null : value;
                    return index === i ? jsonValue : item;
                });
                onChange(newFormData, errorSchema && _this.props.errorSchema && (0, $k4zDq.default)({}, _this.props.errorSchema, (0, $kB4x2.default)({}, index, errorSchema)));
            };
        });
        (0, $kB4x2.default)((0, $hl9R1.default)(_this), "onSelectChange", function(value) {
            _this.props.onChange(value);
        });
        var _formData = props.formData;
        var _keyedFormData = $4ca649cffd4665f1$var$generateKeyedFormData(_formData);
        _this.state = {
            keyedFormData: _keyedFormData,
            updatedKeyedFormData: false
        };
        return _this;
    }
    (0, $4tWkZ.default)(ArrayField, [
        {
            key: "isItemRequired",
            value: function isItemRequired(itemSchema) {
                if ((0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(itemSchema.type)) // While we don't yet support composite/nullable jsonschema types, it's
                // future-proof to check for requirement against these.
                return !(0, (/*@__PURE__*/$parcel$interopDefault($3IXh5)))(itemSchema.type, "null");
                 // All non-null array item types are inherently required by design
                return itemSchema.type !== "null";
            }
        },
        {
            key: "canAddItem",
            value: function canAddItem(formItems) {
                var _this$props3 = this.props, schema = _this$props3.schema, uiSchema = _this$props3.uiSchema;
                var _getUiOptions = (0, $513QU.getUiOptions)(uiSchema), addable = _getUiOptions.addable;
                if (addable !== false) {
                    // if ui:options.addable was not explicitly set to false, we can add
                    // another item if we have not exceeded maxItems yet
                    if (schema.maxItems !== undefined) addable = formItems.length < schema.maxItems;
                    else addable = true;
                }
                return addable;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, schema = _this$props4.schema, uiSchema = _this$props4.uiSchema, idSchema = _this$props4.idSchema, _this$props4$registry = _this$props4.registry, registry = _this$props4$registry === void 0 ? (0, $513QU.getDefaultRegistry)() : _this$props4$registry;
                var rootSchema = registry.rootSchema;
                if (!schema.hasOwnProperty("items")) {
                    var fields = registry.fields;
                    var UnsupportedField = fields.UnsupportedField;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(UnsupportedField, {
                        schema: schema,
                        idSchema: idSchema,
                        reason: "Missing items definition"
                    });
                }
                if ((0, $513QU.isFixedItems)(schema)) return this.renderFixedArray();
                if ((0, $513QU.isFilesArray)(schema, uiSchema, rootSchema)) return this.renderFiles();
                if ((0, $513QU.isMultiSelect)(schema, rootSchema)) return this.renderMultiSelect();
                return this.renderNormalArray();
            }
        },
        {
            key: "renderNormalArray",
            value: function renderNormalArray() {
                var _this2 = this;
                var _this$props5 = this.props, schema = _this$props5.schema, uiSchema = _this$props5.uiSchema, errorSchema = _this$props5.errorSchema, idSchema = _this$props5.idSchema, name = _this$props5.name, required = _this$props5.required, disabled = _this$props5.disabled, readonly = _this$props5.readonly, autofocus = _this$props5.autofocus, _this$props5$registry = _this$props5.registry, registry = _this$props5$registry === void 0 ? (0, $513QU.getDefaultRegistry)() : _this$props5$registry, onBlur = _this$props5.onBlur, onFocus = _this$props5.onFocus, idPrefix = _this$props5.idPrefix, rawErrors = _this$props5.rawErrors;
                var title = schema.title === undefined ? name : schema.title;
                var ArrayFieldTemplate = registry.ArrayFieldTemplate, rootSchema = registry.rootSchema, fields = registry.fields, formContext = registry.formContext;
                var TitleField = fields.TitleField, DescriptionField = fields.DescriptionField;
                var itemsSchema = (0, $513QU.retrieveSchema)(schema.items, rootSchema);
                var formData = $4ca649cffd4665f1$var$keyedToPlainFormData(this.state.keyedFormData);
                var arrayProps = {
                    canAdd: this.canAddItem(formData),
                    items: this.state.keyedFormData.map(function(keyedItem, index) {
                        var key = keyedItem.key, item = keyedItem.item;
                        var itemSchema = (0, $513QU.retrieveSchema)(schema.items, rootSchema, item);
                        var itemErrorSchema = errorSchema ? errorSchema[index] : undefined;
                        var itemIdPrefix = idSchema.$id + "_" + index;
                        var itemIdSchema = (0, $513QU.toIdSchema)(itemSchema, itemIdPrefix, rootSchema, item, idPrefix);
                        return _this2.renderArrayFieldItem({
                            key: key,
                            index: index,
                            canMoveUp: index > 0,
                            canMoveDown: index < formData.length - 1,
                            itemSchema: itemSchema,
                            itemIdSchema: itemIdSchema,
                            itemErrorSchema: itemErrorSchema,
                            itemData: item,
                            itemUiSchema: uiSchema.items,
                            autofocus: autofocus && index === 0,
                            onBlur: onBlur,
                            onFocus: onFocus
                        });
                    }),
                    className: "field field-array field-array-of-".concat(itemsSchema.type),
                    DescriptionField: DescriptionField,
                    disabled: disabled,
                    idSchema: idSchema,
                    uiSchema: uiSchema,
                    onAddClick: this.onAddClick,
                    readonly: readonly,
                    required: required,
                    schema: schema,
                    title: title,
                    TitleField: TitleField,
                    formContext: formContext,
                    formData: formData,
                    rawErrors: rawErrors,
                    registry: registry
                }; // Check if a custom render function was passed in
                var Component = uiSchema["ui:ArrayFieldTemplate"] || ArrayFieldTemplate || $4ca649cffd4665f1$var$DefaultNormalArrayFieldTemplate;
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, arrayProps);
            }
        },
        {
            key: "renderMultiSelect",
            value: function renderMultiSelect() {
                var _this$props6 = this.props, schema = _this$props6.schema, idSchema = _this$props6.idSchema, uiSchema = _this$props6.uiSchema, formData = _this$props6.formData, disabled = _this$props6.disabled, readonly = _this$props6.readonly, required = _this$props6.required, label = _this$props6.label, placeholder = _this$props6.placeholder, autofocus = _this$props6.autofocus, onBlur = _this$props6.onBlur, onFocus = _this$props6.onFocus, _this$props6$registry = _this$props6.registry, registry = _this$props6$registry === void 0 ? (0, $513QU.getDefaultRegistry)() : _this$props6$registry, rawErrors = _this$props6.rawErrors;
                var items = this.props.formData;
                var widgets = registry.widgets, rootSchema = registry.rootSchema, formContext = registry.formContext;
                var itemsSchema = (0, $513QU.retrieveSchema)(schema.items, rootSchema, formData);
                var enumOptions = (0, $513QU.optionsList)(itemsSchema);
                var _getUiOptions$enumOpt = (0, $k4zDq.default)({}, (0, $513QU.getUiOptions)(uiSchema), {
                    enumOptions: enumOptions
                }), _getUiOptions$enumOpt2 = _getUiOptions$enumOpt.widget, widget = _getUiOptions$enumOpt2 === void 0 ? "select" : _getUiOptions$enumOpt2, options = (0, $gpTap.default)(_getUiOptions$enumOpt, [
                    "widget"
                ]);
                var Widget = (0, $513QU.getWidget)(schema, widget, widgets);
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Widget, {
                    id: idSchema && idSchema.$id,
                    multiple: true,
                    onChange: this.onSelectChange,
                    onBlur: onBlur,
                    onFocus: onFocus,
                    options: options,
                    schema: schema,
                    registry: registry,
                    value: items,
                    disabled: disabled,
                    readonly: readonly,
                    required: required,
                    label: label,
                    placeholder: placeholder,
                    formContext: formContext,
                    autofocus: autofocus,
                    rawErrors: rawErrors
                });
            }
        },
        {
            key: "renderFiles",
            value: function renderFiles() {
                var _this$props7 = this.props, schema = _this$props7.schema, uiSchema = _this$props7.uiSchema, idSchema = _this$props7.idSchema, name = _this$props7.name, disabled = _this$props7.disabled, readonly = _this$props7.readonly, autofocus = _this$props7.autofocus, onBlur = _this$props7.onBlur, onFocus = _this$props7.onFocus, _this$props7$registry = _this$props7.registry, registry = _this$props7$registry === void 0 ? (0, $513QU.getDefaultRegistry)() : _this$props7$registry, rawErrors = _this$props7.rawErrors;
                var title = schema.title || name;
                var items = this.props.formData;
                var widgets = registry.widgets, formContext = registry.formContext;
                var _getUiOptions2 = (0, $513QU.getUiOptions)(uiSchema), _getUiOptions2$widget = _getUiOptions2.widget, widget = _getUiOptions2$widget === void 0 ? "files" : _getUiOptions2$widget, options = (0, $gpTap.default)(_getUiOptions2, [
                    "widget"
                ]);
                var Widget = (0, $513QU.getWidget)(schema, widget, widgets);
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Widget, {
                    options: options,
                    id: idSchema && idSchema.$id,
                    multiple: true,
                    onChange: this.onSelectChange,
                    onBlur: onBlur,
                    onFocus: onFocus,
                    schema: schema,
                    title: title,
                    value: items,
                    disabled: disabled,
                    readonly: readonly,
                    formContext: formContext,
                    autofocus: autofocus,
                    rawErrors: rawErrors
                });
            }
        },
        {
            key: "renderFixedArray",
            value: function renderFixedArray() {
                var _this3 = this;
                var _this$props8 = this.props, schema = _this$props8.schema, uiSchema = _this$props8.uiSchema, formData = _this$props8.formData, errorSchema = _this$props8.errorSchema, idPrefix = _this$props8.idPrefix, idSchema = _this$props8.idSchema, name = _this$props8.name, required = _this$props8.required, disabled = _this$props8.disabled, readonly = _this$props8.readonly, autofocus = _this$props8.autofocus, _this$props8$registry = _this$props8.registry, registry = _this$props8$registry === void 0 ? (0, $513QU.getDefaultRegistry)() : _this$props8$registry, onBlur = _this$props8.onBlur, onFocus = _this$props8.onFocus, rawErrors = _this$props8.rawErrors;
                var title = schema.title || name;
                var items = this.props.formData;
                var ArrayFieldTemplate = registry.ArrayFieldTemplate, rootSchema = registry.rootSchema, fields = registry.fields, formContext = registry.formContext;
                var TitleField = fields.TitleField;
                var itemSchemas = schema.items.map(function(item, index) {
                    return (0, $513QU.retrieveSchema)(item, rootSchema, formData[index]);
                });
                var additionalSchema = (0, $513QU.allowAdditionalItems)(schema) ? (0, $513QU.retrieveSchema)(schema.additionalItems, rootSchema, formData) : null;
                if (!items || items.length < itemSchemas.length) {
                    // to make sure at least all fixed items are generated
                    items = items || [];
                    items = items.concat(new Array(itemSchemas.length - items.length));
                } // These are the props passed into the render function
                var arrayProps = {
                    canAdd: this.canAddItem(items) && additionalSchema,
                    className: "field field-array field-array-fixed-items",
                    disabled: disabled,
                    idSchema: idSchema,
                    formData: formData,
                    items: this.state.keyedFormData.map(function(keyedItem, index) {
                        var key = keyedItem.key, item = keyedItem.item;
                        var additional = index >= itemSchemas.length;
                        var itemSchema = additional ? (0, $513QU.retrieveSchema)(schema.additionalItems, rootSchema, item) : itemSchemas[index];
                        var itemIdPrefix = idSchema.$id + "_" + index;
                        var itemIdSchema = (0, $513QU.toIdSchema)(itemSchema, itemIdPrefix, rootSchema, item, idPrefix);
                        var itemUiSchema = additional ? uiSchema.additionalItems || {} : (0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(uiSchema.items) ? uiSchema.items[index] : uiSchema.items || {};
                        var itemErrorSchema = errorSchema ? errorSchema[index] : undefined;
                        return _this3.renderArrayFieldItem({
                            key: key,
                            index: index,
                            canRemove: additional,
                            canMoveUp: index >= itemSchemas.length + 1,
                            canMoveDown: additional && index < items.length - 1,
                            itemSchema: itemSchema,
                            itemData: item,
                            itemUiSchema: itemUiSchema,
                            itemIdSchema: itemIdSchema,
                            itemErrorSchema: itemErrorSchema,
                            autofocus: autofocus && index === 0,
                            onBlur: onBlur,
                            onFocus: onFocus
                        });
                    }),
                    onAddClick: this.onAddClick,
                    readonly: readonly,
                    required: required,
                    schema: schema,
                    uiSchema: uiSchema,
                    title: title,
                    TitleField: TitleField,
                    formContext: formContext,
                    rawErrors: rawErrors
                }; // Check if a custom template template was passed in
                var Template = uiSchema["ui:ArrayFieldTemplate"] || ArrayFieldTemplate || $4ca649cffd4665f1$var$DefaultFixedArrayFieldTemplate;
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Template, arrayProps);
            }
        },
        {
            key: "renderArrayFieldItem",
            value: function renderArrayFieldItem(props) {
                var key = props.key, index = props.index, _props$canRemove = props.canRemove, canRemove = _props$canRemove === void 0 ? true : _props$canRemove, _props$canMoveUp = props.canMoveUp, canMoveUp = _props$canMoveUp === void 0 ? true : _props$canMoveUp, _props$canMoveDown = props.canMoveDown, canMoveDown = _props$canMoveDown === void 0 ? true : _props$canMoveDown, itemSchema = props.itemSchema, itemData = props.itemData, itemUiSchema = props.itemUiSchema, itemIdSchema = props.itemIdSchema, itemErrorSchema = props.itemErrorSchema, autofocus = props.autofocus, onBlur = props.onBlur, onFocus = props.onFocus, rawErrors = props.rawErrors;
                var _this$props9 = this.props, disabled = _this$props9.disabled, readonly = _this$props9.readonly, uiSchema = _this$props9.uiSchema, _this$props9$registry = _this$props9.registry, registry = _this$props9$registry === void 0 ? (0, $513QU.getDefaultRegistry)() : _this$props9$registry;
                var SchemaField = registry.fields.SchemaField;
                var _orderable$removable$ = (0, $k4zDq.default)({
                    orderable: true,
                    removable: true
                }, uiSchema["ui:options"]), orderable = _orderable$removable$.orderable, removable = _orderable$removable$.removable;
                var has = {
                    moveUp: orderable && canMoveUp,
                    moveDown: orderable && canMoveDown,
                    remove: removable && canRemove
                };
                has.toolbar = (0, (/*@__PURE__*/$parcel$interopDefault($8lpxl)))(has).some(function(key) {
                    return has[key];
                });
                return {
                    children: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(SchemaField, {
                        index: index,
                        schema: itemSchema,
                        uiSchema: itemUiSchema,
                        formData: itemData,
                        errorSchema: itemErrorSchema,
                        idSchema: itemIdSchema,
                        required: this.isItemRequired(itemSchema),
                        onChange: this.onChangeForIndex(index),
                        onBlur: onBlur,
                        onFocus: onFocus,
                        registry: this.props.registry,
                        disabled: this.props.disabled,
                        readonly: this.props.readonly,
                        autofocus: autofocus,
                        rawErrors: rawErrors
                    }),
                    className: "array-item",
                    disabled: disabled,
                    hasToolbar: has.toolbar,
                    hasMoveUp: has.moveUp,
                    hasMoveDown: has.moveDown,
                    hasRemove: has.remove,
                    index: index,
                    key: key,
                    onAddIndexClick: this.onAddIndexClick,
                    onDropIndexClick: this.onDropIndexClick,
                    onReorderClick: this.onReorderClick,
                    readonly: readonly
                };
            }
        },
        {
            key: "itemTitle",
            get: function get() {
                var schema = this.props.schema;
                return schema.items.title || schema.items.description || "Item";
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                // Don't call getDerivedStateFromProps if keyed formdata was just updated.
                if (prevState.updatedKeyedFormData) return {
                    updatedKeyedFormData: false
                };
                var nextFormData = nextProps.formData || [];
                var previousKeyedFormData = prevState.keyedFormData || [];
                var newKeyedFormData = nextFormData.length === previousKeyedFormData.length ? previousKeyedFormData.map(function(previousKeyedFormDatum, index) {
                    return {
                        key: previousKeyedFormDatum.key,
                        item: nextFormData[index]
                    };
                }) : $4ca649cffd4665f1$var$generateKeyedFormData(nextFormData);
                return {
                    keyedFormData: newKeyedFormData
                };
            }
        }
    ]);
    return ArrayField;
}((0, $acw62.Component));
(0, $kB4x2.default)($4ca649cffd4665f1$var$ArrayField, "defaultProps", {
    uiSchema: {},
    formData: [],
    idSchema: {},
    required: false,
    disabled: false,
    readonly: false,
    autofocus: false
});
var $4ca649cffd4665f1$export$2e2bcd8739ae039 = $4ca649cffd4665f1$var$ArrayField;

});
parcelRegister("iu2ms", function(module, exports) {

$parcel$export(module.exports, "default", () => $d74cdc3bfad426df$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $99rTF = parcelRequire("99rTF");
function $d74cdc3bfad426df$export$2e2bcd8739ae039(_ref) {
    var className = _ref.className, onClick = _ref.onClick, disabled = _ref.disabled;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "row"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        className: "col-xs-3 col-xs-offset-9 text-right ".concat(className)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $99rTF.default), {
        type: "info",
        icon: "plus",
        className: "btn-add col-xs-12",
        "aria-label": "Add",
        tabIndex: "0",
        onClick: onClick,
        disabled: disabled
    })));
}

});


parcelRegister("krM5C", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee2ba1e3225166d8$export$2e2bcd8739ae039);

var $k4zDq = parcelRequire("k4zDq");

var $a5du3 = parcelRequire("a5du3");

var $gpTap = parcelRequire("gpTap");

var $acw62 = parcelRequire("acw62");
parcelRequire("bdadt");

var $513QU = parcelRequire("513QU");
function $ee2ba1e3225166d8$var$BooleanField(props) {
    var schema = props.schema, name = props.name, uiSchema = props.uiSchema, idSchema = props.idSchema, formData = props.formData, _props$registry = props.registry, registry = _props$registry === void 0 ? (0, $513QU.getDefaultRegistry)() : _props$registry, required = props.required, disabled = props.disabled, readonly = props.readonly, autofocus = props.autofocus, onChange = props.onChange, onFocus = props.onFocus, onBlur = props.onBlur, rawErrors = props.rawErrors;
    var title = schema.title;
    var widgets = registry.widgets, formContext = registry.formContext, fields = registry.fields;
    var _getUiOptions = (0, $513QU.getUiOptions)(uiSchema), _getUiOptions$widget = _getUiOptions.widget, widget = _getUiOptions$widget === void 0 ? "checkbox" : _getUiOptions$widget, options = (0, $gpTap.default)(_getUiOptions, [
        "widget"
    ]);
    var Widget = (0, $513QU.getWidget)(schema, widget, widgets);
    var enumOptions;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(schema.oneOf)) enumOptions = (0, $513QU.optionsList)({
        oneOf: schema.oneOf.map(function(option) {
            return (0, $k4zDq.default)({}, option, {
                title: option.title || (option["const"] === true ? "Yes" : "No")
            });
        })
    });
    else enumOptions = (0, $513QU.optionsList)({
        "enum": schema["enum"] || [
            true,
            false
        ],
        enumNames: schema.enumNames || (schema["enum"] && schema["enum"][0] === false ? [
            "No",
            "Yes"
        ] : [
            "Yes",
            "No"
        ])
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Widget, {
        options: (0, $k4zDq.default)({}, options, {
            enumOptions: enumOptions
        }),
        schema: schema,
        id: idSchema && idSchema.$id,
        onChange: onChange,
        onFocus: onFocus,
        onBlur: onBlur,
        label: title === undefined ? name : title,
        value: formData,
        required: required,
        disabled: disabled,
        readonly: readonly,
        registry: registry,
        formContext: formContext,
        autofocus: autofocus,
        rawErrors: rawErrors,
        DescriptionField: fields.DescriptionField
    });
}
$ee2ba1e3225166d8$var$BooleanField.defaultProps = {
    uiSchema: {},
    disabled: false,
    readonly: false,
    autofocus: false
};
var $ee2ba1e3225166d8$export$2e2bcd8739ae039 = $ee2ba1e3225166d8$var$BooleanField;

});

parcelRegister("6ojM0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a74528a53dabe6a$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

function $4a74528a53dabe6a$var$DescriptionField(props) {
    var id = props.id, description = props.description;
    if (!description) return null;
    if (typeof description === "string") return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
        id: id,
        className: "field-description"
    }, description);
    else return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: id,
        className: "field-description"
    }, description);
}
var $4a74528a53dabe6a$export$2e2bcd8739ae039 = $4a74528a53dabe6a$var$DescriptionField;

});

parcelRegister("jsrg2", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2a5c6a9b9a831ac$export$2e2bcd8739ae039);

var $gpTap = parcelRequire("gpTap");

var $bTUgL = parcelRequire("bTUgL");

var $cG9FK = parcelRequire("cG9FK");

var $aYvV6 = parcelRequire("aYvV6");

var $7PwEf = parcelRequire("7PwEf");

var $4tWkZ = parcelRequire("4tWkZ");

var $eBH73 = parcelRequire("eBH73");

var $ctnWZ = parcelRequire("ctnWZ");

var $hl9R1 = parcelRequire("hl9R1");

var $ivxVa = parcelRequire("ivxVa");

var $kB4x2 = parcelRequire("kB4x2");

var $acw62 = parcelRequire("acw62");

parcelRequire("bdadt");

var $513QU = parcelRequire("513QU");
var $e2a5c6a9b9a831ac$var$AnyOfField = /*#__PURE__*/ function(_Component) {
    (0, $ivxVa.default)(AnyOfField, _Component);
    function AnyOfField(props) {
        var _this;
        (0, $7PwEf.default)(this, AnyOfField);
        _this = (0, $eBH73.default)(this, (0, $ctnWZ.default)(AnyOfField).call(this, props));
        (0, $kB4x2.default)((0, $hl9R1.default)(_this), "onOptionChange", function(option) {
            var selectedOption = (0, (/*@__PURE__*/$parcel$interopDefault($aYvV6)))(option, 10);
            var _this$props = _this.props, formData = _this$props.formData, onChange = _this$props.onChange, options = _this$props.options, registry = _this$props.registry;
            var rootSchema = registry.rootSchema;
            var newOption = (0, $513QU.retrieveSchema)(options[selectedOption], rootSchema, formData); // If the new option is of type object and the current data is an object,
            // discard properties added using the old option.
            var newFormData = undefined;
            if ((0, $513QU.guessType)(formData) === "object" && (newOption.type === "object" || newOption.properties)) {
                newFormData = (0, $cG9FK.default)({}, formData);
                var optionsToDiscard = options.slice();
                optionsToDiscard.splice(selectedOption, 1); // Discard any data added using other options
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;
                try {
                    for(var _iterator = (0, (/*@__PURE__*/$parcel$interopDefault($bTUgL)))(optionsToDiscard), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _option = _step.value;
                        if (_option.properties) {
                            for(var key in _option.properties)if (newFormData.hasOwnProperty(key)) delete newFormData[key];
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator["return"] != null) _iterator["return"]();
                    } finally{
                        if (_didIteratorError) throw _iteratorError;
                    }
                }
            } // Call getDefaultFormState to make sure defaults are populated on change.
            onChange((0, $513QU.getDefaultFormState)(options[selectedOption], newFormData, rootSchema));
            _this.setState({
                selectedOption: (0, (/*@__PURE__*/$parcel$interopDefault($aYvV6)))(option, 10)
            });
        });
        var _this$props2 = _this.props, _formData = _this$props2.formData, _options = _this$props2.options;
        _this.state = {
            selectedOption: _this.getMatchingOption(_formData, _options)
        };
        return _this;
    }
    (0, $4tWkZ.default)(AnyOfField, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                if (!(0, $513QU.deepEquals)(this.props.formData, prevProps.formData) && this.props.idSchema.$id === prevProps.idSchema.$id) {
                    var matchingOption = this.getMatchingOption(this.props.formData, this.props.options);
                    if (!prevState || matchingOption === this.state.selectedOption) return;
                    this.setState({
                        selectedOption: matchingOption
                    });
                }
            }
        },
        {
            key: "getMatchingOption",
            value: function getMatchingOption(formData, options) {
                var rootSchema = this.props.registry.rootSchema;
                var option = (0, $513QU.getMatchingOption)(formData, options, rootSchema);
                if (option !== 0) return option;
                 // If the form data matches none of the options, use the currently selected
                // option, assuming it's available; otherwise use the first option
                return this && this.state ? this.state.selectedOption : 0;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props3 = this.props, baseType = _this$props3.baseType, disabled = _this$props3.disabled, errorSchema = _this$props3.errorSchema, formData = _this$props3.formData, idPrefix = _this$props3.idPrefix, idSchema = _this$props3.idSchema, onBlur = _this$props3.onBlur, onChange = _this$props3.onChange, onFocus = _this$props3.onFocus, options = _this$props3.options, registry = _this$props3.registry, uiSchema = _this$props3.uiSchema, schema = _this$props3.schema;
                var _SchemaField = registry.fields.SchemaField;
                var widgets = registry.widgets;
                var selectedOption = this.state.selectedOption;
                var _getUiOptions = (0, $513QU.getUiOptions)(uiSchema), _getUiOptions$widget = _getUiOptions.widget, widget = _getUiOptions$widget === void 0 ? "select" : _getUiOptions$widget, uiOptions = (0, $gpTap.default)(_getUiOptions, [
                    "widget"
                ]);
                var Widget = (0, $513QU.getWidget)({
                    type: "number"
                }, widget, widgets);
                var option = options[selectedOption] || null;
                var optionSchema;
                if (option) // If the subschema doesn't declare a type, infer the type from the
                // parent schema
                optionSchema = option.type ? option : (0, $cG9FK.default)({}, option, {
                    type: baseType
                });
                var enumOptions = options.map(function(option, index) {
                    return {
                        label: option.title || "Option ".concat(index + 1),
                        value: index
                    };
                });
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: "panel panel-default panel-body"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: "form-group"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Widget, (0, $cG9FK.default)({
                    id: "".concat(idSchema.$id).concat(schema.oneOf ? "__oneof_select" : "__anyof_select"),
                    schema: {
                        type: "number",
                        "default": 0
                    },
                    onChange: this.onOptionChange,
                    onBlur: onBlur,
                    onFocus: onFocus,
                    value: selectedOption,
                    options: {
                        enumOptions: enumOptions
                    }
                }, uiOptions))), option !== null && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(_SchemaField, {
                    schema: optionSchema,
                    uiSchema: uiSchema,
                    errorSchema: errorSchema,
                    idSchema: idSchema,
                    idPrefix: idPrefix,
                    formData: formData,
                    onChange: onChange,
                    onBlur: onBlur,
                    onFocus: onFocus,
                    registry: registry,
                    disabled: disabled
                }));
            }
        }
    ]);
    return AnyOfField;
}((0, $acw62.Component));
$e2a5c6a9b9a831ac$var$AnyOfField.defaultProps = {
    disabled: false,
    errorSchema: {},
    idSchema: {},
    uiSchema: {}
};
var $e2a5c6a9b9a831ac$export$2e2bcd8739ae039 = $e2a5c6a9b9a831ac$var$AnyOfField;

});

parcelRegister("b2QFn", function(module, exports) {

$parcel$export(module.exports, "default", () => $02133cd6f89ecede$export$2e2bcd8739ae039);

var $cG9FK = parcelRequire("cG9FK");

var $gpTap = parcelRequire("gpTap");

var $7PwEf = parcelRequire("7PwEf");

var $4tWkZ = parcelRequire("4tWkZ");

var $eBH73 = parcelRequire("eBH73");

var $ctnWZ = parcelRequire("ctnWZ");

var $hl9R1 = parcelRequire("hl9R1");

var $ivxVa = parcelRequire("ivxVa");

var $kB4x2 = parcelRequire("kB4x2");

var $acw62 = parcelRequire("acw62");
parcelRequire("bdadt");

var $513QU = parcelRequire("513QU");
// digits followed by any number of 0 characters up until the end of the line.
// Ensuring that there is at least one prefixed character is important so that
// you don't incorrectly match against "0".
var $02133cd6f89ecede$var$trailingCharMatcherWithPrefix = /\.([0-9]*0)*$/; // This is used for trimming the trailing 0 and . characters without affecting
// the rest of the string. Its possible to use one RegEx with groups for this
// functionality, but it is fairly complex compared to simply defining two
// different matchers.
var $02133cd6f89ecede$var$trailingCharMatcher = /[0.]0*$/;
/**
 * The NumberField class has some special handling for dealing with trailing
 * decimal points and/or zeroes. This logic is designed to allow trailing values
 * to be visible in the input element, but not be represented in the
 * corresponding form data.
 *
 * The algorithm is as follows:
 *
 * 1. When the input value changes the value is cached in the component state
 *
 * 2. The value is then normalized, removing trailing decimal points and zeros,
 *    then passed to the "onChange" callback
 *
 * 3. When the component is rendered, the formData value is checked against the
 *    value cached in the state. If it matches the cached value, the cached
 *    value is passed to the input instead of the formData value
 */ var $02133cd6f89ecede$var$NumberField = /*#__PURE__*/ function(_React$Component) {
    (0, $ivxVa.default)(NumberField, _React$Component);
    function NumberField(props) {
        var _this;
        (0, $7PwEf.default)(this, NumberField);
        _this = (0, $eBH73.default)(this, (0, $ctnWZ.default)(NumberField).call(this, props));
        (0, $kB4x2.default)((0, $hl9R1.default)(_this), "handleChange", function(value) {
            // Cache the original value in component state
            _this.setState({
                lastValue: value
            }); // Normalize decimals that don't start with a zero character in advance so
            // that the rest of the normalization logic is simpler
            if ("".concat(value).charAt(0) === ".") value = "0".concat(value);
             // Check that the value is a string (this can happen if the widget used is a
            // <select>, due to an enum declaration etc) then, if the value ends in a
            // trailing decimal point or multiple zeroes, strip the trailing values
            var processed = typeof value === "string" && value.match($02133cd6f89ecede$var$trailingCharMatcherWithPrefix) ? (0, $513QU.asNumber)(value.replace($02133cd6f89ecede$var$trailingCharMatcher, "")) : (0, $513QU.asNumber)(value);
            _this.props.onChange(processed);
        });
        _this.state = {
            lastValue: props.value
        };
        return _this;
    }
    (0, $4tWkZ.default)(NumberField, [
        {
            key: "render",
            value: function render() {
                var StringField = this.props.registry.fields.StringField;
                var _this$props = this.props, formData = _this$props.formData, props = (0, $gpTap.default)(_this$props, [
                    "formData"
                ]);
                var lastValue = this.state.lastValue;
                var value = formData;
                if (typeof lastValue === "string" && typeof value === "number") {
                    // Construct a regular expression that checks for a string that consists
                    // of the formData value suffixed with zero or one '.' characters and zero
                    // or more '0' characters
                    var re = new RegExp("".concat(value).replace(".", "\\.") + "\\.?0*$"); // If the cached "lastValue" is a match, use that instead of the formData
                    // value to prevent the input value from changing in the UI
                    if (lastValue.match(re)) value = lastValue;
                }
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(StringField, (0, $cG9FK.default)({}, props, {
                    formData: value,
                    onChange: this.handleChange
                }));
            }
        }
    ]);
    return NumberField;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$02133cd6f89ecede$var$NumberField.defaultProps = {
    uiSchema: {}
};
var $02133cd6f89ecede$export$2e2bcd8739ae039 = $02133cd6f89ecede$var$NumberField;

});

parcelRegister("foC1q", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3569749a0c2ac6e$export$2e2bcd8739ae039);

var $8gMgl = parcelRequire("8gMgl");

var $a5du3 = parcelRequire("a5du3");

var $4juyi = parcelRequire("4juyi");

var $cG9FK = parcelRequire("cG9FK");

var $8lpxl = parcelRequire("8lpxl");

var $k4zDq = parcelRequire("k4zDq");

var $7PwEf = parcelRequire("7PwEf");

var $4tWkZ = parcelRequire("4tWkZ");

var $eBH73 = parcelRequire("eBH73");

var $ctnWZ = parcelRequire("ctnWZ");

var $hl9R1 = parcelRequire("hl9R1");

var $ivxVa = parcelRequire("ivxVa");

var $kB4x2 = parcelRequire("kB4x2");

var $iu2ms = parcelRequire("iu2ms");

var $acw62 = parcelRequire("acw62");
parcelRequire("bdadt");

var $513QU = parcelRequire("513QU");
function $b3569749a0c2ac6e$var$DefaultObjectFieldTemplate(props) {
    var TitleField = props.TitleField, DescriptionField = props.DescriptionField;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("fieldset", {
        id: props.idSchema.$id
    }, (props.uiSchema["ui:title"] || props.title) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(TitleField, {
        id: "".concat(props.idSchema.$id, "__title"),
        title: props.title || props.uiSchema["ui:title"],
        required: props.required,
        formContext: props.formContext
    }), props.description && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(DescriptionField, {
        id: "".concat(props.idSchema.$id, "__description"),
        description: props.description,
        formContext: props.formContext
    }), props.properties.map(function(prop) {
        return prop.content;
    }), (0, $513QU.canExpand)(props.schema, props.uiSchema, props.formData) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $iu2ms.default), {
        className: "object-property-expand",
        onClick: props.onAddClick(props.schema),
        disabled: props.disabled || props.readonly
    }));
}
var $b3569749a0c2ac6e$var$ObjectField = /*#__PURE__*/ function(_Component) {
    (0, $ivxVa.default)(ObjectField, _Component);
    function ObjectField() {
        var _getPrototypeOf2;
        var _this;
        (0, $7PwEf.default)(this, ObjectField);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = (0, $eBH73.default)(this, (_getPrototypeOf2 = (0, $ctnWZ.default)(ObjectField)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        (0, $kB4x2.default)((0, $hl9R1.default)(_this), "state", {
            wasPropertyKeyModified: false,
            additionalProperties: {}
        });
        (0, $kB4x2.default)((0, $hl9R1.default)(_this), "onPropertyChange", function(name) {
            var addedByAdditionalProperties = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            return function(value, errorSchema) {
                if (!value && addedByAdditionalProperties) // Don't set value = undefined for fields added by
                // additionalProperties. Doing so removes them from the
                // formData, which causes them to completely disappear
                // (including the input field for the property name). Unlike
                // fields which are "mandated" by the schema, these fields can
                // be set to undefined by clicking a "delete field" button, so
                // set empty values to the empty string.
                value = "";
                var newFormData = (0, $k4zDq.default)({}, _this.props.formData, (0, $kB4x2.default)({}, name, value));
                _this.props.onChange(newFormData, errorSchema && _this.props.errorSchema && (0, $k4zDq.default)({}, _this.props.errorSchema, (0, $kB4x2.default)({}, name, errorSchema)));
            };
        });
        (0, $kB4x2.default)((0, $hl9R1.default)(_this), "onDropPropertyClick", function(key) {
            return function(event) {
                event.preventDefault();
                var _this$props = _this.props, onChange = _this$props.onChange, formData = _this$props.formData;
                var copiedFormData = (0, $k4zDq.default)({}, formData);
                delete copiedFormData[key];
                onChange(copiedFormData);
            };
        });
        (0, $kB4x2.default)((0, $hl9R1.default)(_this), "getAvailableKey", function(preferredKey, formData) {
            var index = 0;
            var newKey = preferredKey;
            while(formData.hasOwnProperty(newKey))newKey = "".concat(preferredKey, "-").concat(++index);
            return newKey;
        });
        (0, $kB4x2.default)((0, $hl9R1.default)(_this), "onKeyChange", function(oldValue) {
            return function(value, errorSchema) {
                if (oldValue === value) return;
                value = _this.getAvailableKey(value, _this.props.formData);
                var newFormData = (0, $k4zDq.default)({}, _this.props.formData);
                var newKeys = (0, $kB4x2.default)({}, oldValue, value);
                var keyValues = (0, (/*@__PURE__*/$parcel$interopDefault($8lpxl)))(newFormData).map(function(key) {
                    var newKey = newKeys[key] || key;
                    return (0, $kB4x2.default)({}, newKey, newFormData[key]);
                });
                var renamedObj = (0, $cG9FK.default).apply(void 0, [
                    {}
                ].concat((0, $4juyi.default)(keyValues)));
                _this.setState({
                    wasPropertyKeyModified: true
                });
                _this.props.onChange(renamedObj, errorSchema && _this.props.errorSchema && (0, $k4zDq.default)({}, _this.props.errorSchema, (0, $kB4x2.default)({}, value, errorSchema)));
            };
        });
        (0, $kB4x2.default)((0, $hl9R1.default)(_this), "handleAddClick", function(schema) {
            return function() {
                var type = schema.additionalProperties.type;
                var newFormData = (0, $k4zDq.default)({}, _this.props.formData);
                if (schema.additionalProperties.hasOwnProperty("$ref")) {
                    var _this$props$registry = _this.props.registry, registry = _this$props$registry === void 0 ? (0, $513QU.getDefaultRegistry)() : _this$props$registry;
                    var refSchema = (0, $513QU.retrieveSchema)({
                        $ref: schema.additionalProperties["$ref"]
                    }, registry.rootSchema, _this.props.formData);
                    type = refSchema.type;
                }
                newFormData[_this.getAvailableKey("newKey", newFormData)] = _this.getDefaultValue(type);
                _this.props.onChange(newFormData);
            };
        });
        return _this;
    }
    (0, $4tWkZ.default)(ObjectField, [
        {
            key: "isRequired",
            value: function isRequired(name) {
                var schema = this.props.schema;
                return (0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(schema.required) && schema.required.indexOf(name) !== -1;
            }
        },
        {
            key: "getDefaultValue",
            value: function getDefaultValue(type) {
                switch(type){
                    case "string":
                        return "New Value";
                    case "array":
                        return [];
                    case "boolean":
                        return false;
                    case "null":
                        return null;
                    case "number":
                        return 0;
                    case "object":
                        return {};
                    default:
                        // We don't have a datatype for some reason (perhaps additionalProperties was true)
                        return "New Value";
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props2 = this.props, uiSchema = _this$props2.uiSchema, formData = _this$props2.formData, errorSchema = _this$props2.errorSchema, idSchema = _this$props2.idSchema, name = _this$props2.name, required = _this$props2.required, disabled = _this$props2.disabled, readonly = _this$props2.readonly, idPrefix = _this$props2.idPrefix, onBlur = _this$props2.onBlur, onFocus = _this$props2.onFocus, _this$props2$registry = _this$props2.registry, registry = _this$props2$registry === void 0 ? (0, $513QU.getDefaultRegistry)() : _this$props2$registry;
                var rootSchema = registry.rootSchema, fields = registry.fields, formContext = registry.formContext;
                var SchemaField = fields.SchemaField, TitleField = fields.TitleField, DescriptionField = fields.DescriptionField;
                var schema = (0, $513QU.retrieveSchema)(this.props.schema, rootSchema, formData);
                var title = schema.title === undefined ? name : schema.title;
                var description = uiSchema["ui:description"] || schema.description;
                var orderedProperties;
                try {
                    var properties = (0, (/*@__PURE__*/$parcel$interopDefault($8lpxl)))(schema.properties || {});
                    orderedProperties = (0, $513QU.orderProperties)(properties, uiSchema["ui:order"]);
                } catch (err) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", {
                        className: "config-error",
                        style: {
                            color: "red"
                        }
                    }, "Invalid ", name || "root", " object field configuration:", (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("em", null, err.message), "."), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("pre", null, (0, (/*@__PURE__*/$parcel$interopDefault($8gMgl)))(schema)));
                }
                var Template = uiSchema["ui:ObjectFieldTemplate"] || registry.ObjectFieldTemplate || $b3569749a0c2ac6e$var$DefaultObjectFieldTemplate;
                var templateProps = {
                    title: uiSchema["ui:title"] || title,
                    description: description,
                    TitleField: TitleField,
                    DescriptionField: DescriptionField,
                    properties: orderedProperties.map(function(name) {
                        var addedByAdditionalProperties = schema.properties[name].hasOwnProperty((0, $513QU.ADDITIONAL_PROPERTY_FLAG));
                        return {
                            content: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(SchemaField, {
                                key: name,
                                name: name,
                                required: _this2.isRequired(name),
                                schema: schema.properties[name],
                                uiSchema: addedByAdditionalProperties ? uiSchema.additionalProperties : uiSchema[name],
                                errorSchema: errorSchema[name],
                                idSchema: idSchema[name],
                                idPrefix: idPrefix,
                                formData: (formData || {})[name],
                                wasPropertyKeyModified: _this2.state.wasPropertyKeyModified,
                                onKeyChange: _this2.onKeyChange(name),
                                onChange: _this2.onPropertyChange(name, addedByAdditionalProperties),
                                onBlur: onBlur,
                                onFocus: onFocus,
                                registry: registry,
                                disabled: disabled,
                                readonly: readonly,
                                onDropPropertyClick: _this2.onDropPropertyClick
                            }),
                            name: name,
                            readonly: readonly,
                            disabled: disabled,
                            required: required
                        };
                    }),
                    readonly: readonly,
                    disabled: disabled,
                    required: required,
                    idSchema: idSchema,
                    uiSchema: uiSchema,
                    schema: schema,
                    formData: formData,
                    formContext: formContext
                };
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Template, (0, $cG9FK.default)({}, templateProps, {
                    onAddClick: this.handleAddClick
                }));
            }
        }
    ]);
    return ObjectField;
}((0, $acw62.Component));
(0, $kB4x2.default)($b3569749a0c2ac6e$var$ObjectField, "defaultProps", {
    uiSchema: {},
    formData: {},
    errorSchema: {},
    idSchema: {},
    required: false,
    disabled: false,
    readonly: false
});
var $b3569749a0c2ac6e$export$2e2bcd8739ae039 = $b3569749a0c2ac6e$var$ObjectField;

});

parcelRegister("8o4rR", function(module, exports) {

$parcel$export(module.exports, "default", () => $61b403fa1a3dbdca$export$2e2bcd8739ae039);

var $k4zDq = parcelRequire("k4zDq");

var $gpTap = parcelRequire("gpTap");

var $acw62 = parcelRequire("acw62");
parcelRequire("bdadt");

var $513QU = parcelRequire("513QU");
function $61b403fa1a3dbdca$var$StringField(props) {
    var schema = props.schema, name = props.name, uiSchema = props.uiSchema, idSchema = props.idSchema, formData = props.formData, required = props.required, disabled = props.disabled, readonly = props.readonly, autofocus = props.autofocus, onChange = props.onChange, onBlur = props.onBlur, onFocus = props.onFocus, _props$registry = props.registry, registry = _props$registry === void 0 ? (0, $513QU.getDefaultRegistry)() : _props$registry, rawErrors = props.rawErrors;
    var title = schema.title, format = schema.format;
    var widgets = registry.widgets, formContext = registry.formContext;
    var enumOptions = (0, $513QU.isSelect)(schema) && (0, $513QU.optionsList)(schema);
    var defaultWidget = enumOptions ? "select" : "text";
    if (format && (0, $513QU.hasWidget)(schema, format, widgets)) defaultWidget = format;
    var _getUiOptions = (0, $513QU.getUiOptions)(uiSchema), _getUiOptions$widget = _getUiOptions.widget, widget = _getUiOptions$widget === void 0 ? defaultWidget : _getUiOptions$widget, _getUiOptions$placeho = _getUiOptions.placeholder, placeholder = _getUiOptions$placeho === void 0 ? "" : _getUiOptions$placeho, options = (0, $gpTap.default)(_getUiOptions, [
        "widget",
        "placeholder"
    ]);
    var Widget = (0, $513QU.getWidget)(schema, widget, widgets);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Widget, {
        options: (0, $k4zDq.default)({}, options, {
            enumOptions: enumOptions
        }),
        schema: schema,
        uiSchema: uiSchema,
        id: idSchema && idSchema.$id,
        label: title === undefined ? name : title,
        value: formData,
        onChange: onChange,
        onBlur: onBlur,
        onFocus: onFocus,
        required: required,
        disabled: disabled,
        readonly: readonly,
        formContext: formContext,
        autofocus: autofocus,
        registry: registry,
        placeholder: placeholder,
        rawErrors: rawErrors
    });
}
$61b403fa1a3dbdca$var$StringField.defaultProps = {
    uiSchema: {},
    disabled: false,
    readonly: false,
    autofocus: false
};
var $61b403fa1a3dbdca$export$2e2bcd8739ae039 = $61b403fa1a3dbdca$var$StringField;

});

parcelRegister("1vIXA", function(module, exports) {

$parcel$export(module.exports, "default", () => $119b8fd091de28b9$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

var $119b8fd091de28b9$var$REQUIRED_FIELD_SYMBOL = "*";
function $119b8fd091de28b9$var$TitleField(props) {
    var id = props.id, title = props.title, required = props.required;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("legend", {
        id: id
    }, title, required && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "required"
    }, $119b8fd091de28b9$var$REQUIRED_FIELD_SYMBOL));
}
var $119b8fd091de28b9$export$2e2bcd8739ae039 = $119b8fd091de28b9$var$TitleField;

});

parcelRegister("aoDvC", function(module, exports) {

$parcel$export(module.exports, "default", () => $791acae8f464ad74$export$2e2bcd8739ae039);

var $7PwEf = parcelRequire("7PwEf");

var $4tWkZ = parcelRequire("4tWkZ");

var $eBH73 = parcelRequire("eBH73");

var $ctnWZ = parcelRequire("ctnWZ");

var $ivxVa = parcelRequire("ivxVa");

var $acw62 = parcelRequire("acw62");
parcelRequire("bdadt");
var $791acae8f464ad74$var$NullField = /*#__PURE__*/ function(_Component) {
    (0, $ivxVa.default)(NullField, _Component);
    function NullField() {
        (0, $7PwEf.default)(this, NullField);
        return (0, $eBH73.default)(this, (0, $ctnWZ.default)(NullField).apply(this, arguments));
    }
    (0, $4tWkZ.default)(NullField, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.formData === undefined) this.props.onChange(null);
            }
        },
        {
            key: "render",
            value: function render() {
                return null;
            }
        }
    ]);
    return NullField;
}((0, $acw62.Component));
var $791acae8f464ad74$export$2e2bcd8739ae039 = $791acae8f464ad74$var$NullField;

});

parcelRegister("ctUWC", function(module, exports) {

$parcel$export(module.exports, "default", () => $91645d7475363741$export$2e2bcd8739ae039);

var $8gMgl = parcelRequire("8gMgl");

var $acw62 = parcelRequire("acw62");

function $91645d7475363741$var$UnsupportedField(_ref) {
    var schema = _ref.schema, idSchema = _ref.idSchema, reason = _ref.reason;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "unsupported-field"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, "Unsupported field schema", idSchema && idSchema.$id && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, " for", " field ", (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("code", null, idSchema.$id)), reason && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("em", null, ": ", reason), "."), schema && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("pre", null, (0, (/*@__PURE__*/$parcel$interopDefault($8gMgl)))(schema, null, 2)));
}
var $91645d7475363741$export$2e2bcd8739ae039 = $91645d7475363741$var$UnsupportedField;

});


parcelRegister("3EOho", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a9c1bfb8212b878$export$2e2bcd8739ae039);

var $ayMZV = parcelRequire("ayMZV");

var $6CdBR = parcelRequire("6CdBR");

var $2eJFx = parcelRequire("2eJFx");

var $aa4ig = parcelRequire("aa4ig");

var $55Nsu = parcelRequire("55Nsu");

var $epPto = parcelRequire("epPto");

var $cfmj6 = parcelRequire("cfmj6");

var $7iVcW = parcelRequire("7iVcW");

var $7lZut = parcelRequire("7lZut");

var $hbHqt = parcelRequire("hbHqt");

var $lDCyR = parcelRequire("lDCyR");

var $aZrTT = parcelRequire("aZrTT");

var $bAKq8 = parcelRequire("bAKq8");

var $g15OE = parcelRequire("g15OE");

var $2uIQk = parcelRequire("2uIQk");

var $5zMBD = parcelRequire("5zMBD");

var $9oEBR = parcelRequire("9oEBR");

var $2jGNr = parcelRequire("2jGNr");

var $1wLJD = parcelRequire("1wLJD");
var $2a9c1bfb8212b878$export$2e2bcd8739ae039 = {
    BaseInput: (0, $2eJFx.default),
    PasswordWidget: (0, $aZrTT.default),
    RadioWidget: (0, $bAKq8.default),
    UpDownWidget: (0, $1wLJD.default),
    RangeWidget: (0, $g15OE.default),
    SelectWidget: (0, $2uIQk.default),
    TextWidget: (0, $9oEBR.default),
    DateWidget: (0, $cfmj6.default),
    DateTimeWidget: (0, $7iVcW.default),
    AltDateWidget: (0, $ayMZV.default),
    AltDateTimeWidget: (0, $6CdBR.default),
    EmailWidget: (0, $7lZut.default),
    URLWidget: (0, $2jGNr.default),
    TextareaWidget: (0, $5zMBD.default),
    HiddenWidget: (0, $lDCyR.default),
    ColorWidget: (0, $epPto.default),
    FileWidget: (0, $hbHqt.default),
    CheckboxWidget: (0, $aa4ig.default),
    CheckboxesWidget: (0, $55Nsu.default)
};

});
parcelRegister("ayMZV", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b03165183fa6904$export$2e2bcd8739ae039);

var $cG9FK = parcelRequire("cG9FK");

var $7PwEf = parcelRequire("7PwEf");

var $4tWkZ = parcelRequire("4tWkZ");

var $eBH73 = parcelRequire("eBH73");

var $ctnWZ = parcelRequire("ctnWZ");

var $hl9R1 = parcelRequire("hl9R1");

var $ivxVa = parcelRequire("ivxVa");

var $kB4x2 = parcelRequire("kB4x2");

var $8lpxl = parcelRequire("8lpxl");

var $acw62 = parcelRequire("acw62");


var $513QU = parcelRequire("513QU");
function $7b03165183fa6904$var$rangeOptions(start, stop) {
    var options = [];
    for(var i = start; i <= stop; i++)options.push({
        value: i,
        label: (0, $513QU.pad)(i, 2)
    });
    return options;
}
function $7b03165183fa6904$var$readyForChange(state) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($8lpxl)))(state).every(function(key) {
        return state[key] !== -1;
    });
}
function $7b03165183fa6904$var$DateElement(props) {
    var type = props.type, range = props.range, value = props.value, select = props.select, rootId = props.rootId, disabled = props.disabled, readonly = props.readonly, autofocus = props.autofocus, registry = props.registry, onBlur = props.onBlur;
    var id = rootId + "_" + type;
    var SelectWidget = registry.widgets.SelectWidget;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(SelectWidget, {
        schema: {
            type: "integer"
        },
        id: id,
        className: "form-control",
        options: {
            enumOptions: $7b03165183fa6904$var$rangeOptions(range[0], range[1])
        },
        placeholder: type,
        value: value,
        disabled: disabled,
        readonly: readonly,
        autofocus: autofocus,
        onChange: function onChange(value) {
            return select(type, value);
        },
        onBlur: onBlur
    });
}
var $7b03165183fa6904$var$AltDateWidget = /*#__PURE__*/ function(_Component) {
    (0, $ivxVa.default)(AltDateWidget, _Component);
    function AltDateWidget(props) {
        var _this;
        (0, $7PwEf.default)(this, AltDateWidget);
        _this = (0, $eBH73.default)(this, (0, $ctnWZ.default)(AltDateWidget).call(this, props));
        (0, $kB4x2.default)((0, $hl9R1.default)(_this), "onChange", function(property, value) {
            _this.setState((0, $kB4x2.default)({}, property, typeof value === "undefined" ? -1 : value), function() {
                // Only propagate to parent state if we have a complete date{time}
                if ($7b03165183fa6904$var$readyForChange(_this.state)) _this.props.onChange((0, $513QU.toDateString)(_this.state, _this.props.time));
            });
        });
        (0, $kB4x2.default)((0, $hl9R1.default)(_this), "setNow", function(event) {
            event.preventDefault();
            var _this$props = _this.props, time = _this$props.time, disabled = _this$props.disabled, readonly = _this$props.readonly, onChange = _this$props.onChange;
            if (disabled || readonly) return;
            var nowDateObj = (0, $513QU.parseDateString)(new Date().toJSON(), time);
            _this.setState(nowDateObj, function() {
                return onChange((0, $513QU.toDateString)(_this.state, time));
            });
        });
        (0, $kB4x2.default)((0, $hl9R1.default)(_this), "clear", function(event) {
            event.preventDefault();
            var _this$props2 = _this.props, time = _this$props2.time, disabled = _this$props2.disabled, readonly = _this$props2.readonly, onChange = _this$props2.onChange;
            if (disabled || readonly) return;
            _this.setState((0, $513QU.parseDateString)("", time), function() {
                return onChange(undefined);
            });
        });
        _this.state = (0, $513QU.parseDateString)(props.value, props.time);
        return _this;
    }
    (0, $4tWkZ.default)(AltDateWidget, [
        {
            key: "UNSAFE_componentWillReceiveProps",
            value: function UNSAFE_componentWillReceiveProps(nextProps) {
                this.setState((0, $513QU.parseDateString)(nextProps.value, nextProps.time));
            }
        },
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps, nextState) {
                return (0, $513QU.shouldRender)(this, nextProps, nextState);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props3 = this.props, id = _this$props3.id, disabled = _this$props3.disabled, readonly = _this$props3.readonly, autofocus = _this$props3.autofocus, registry = _this$props3.registry, onBlur = _this$props3.onBlur, options = _this$props3.options;
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
                    className: "list-inline"
                }, this.dateElementProps.map(function(elemProps, i) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                        key: i
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($7b03165183fa6904$var$DateElement, (0, $cG9FK.default)({
                        rootId: id,
                        select: _this2.onChange
                    }, elemProps, {
                        disabled: disabled,
                        readonly: readonly,
                        registry: registry,
                        onBlur: onBlur,
                        autofocus: autofocus && i === 0
                    })));
                }), (options.hideNowButton !== "undefined" ? !options.hideNowButton : true) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
                    href: "#",
                    className: "btn btn-info btn-now",
                    onClick: this.setNow
                }, "Now")), (options.hideClearButton !== "undefined" ? !options.hideClearButton : true) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
                    href: "#",
                    className: "btn btn-warning btn-clear",
                    onClick: this.clear
                }, "Clear")));
            }
        },
        {
            key: "dateElementProps",
            get: function get() {
                var _this$props4 = this.props, time = _this$props4.time, options = _this$props4.options;
                var _this$state = this.state, year = _this$state.year, month = _this$state.month, day = _this$state.day, hour = _this$state.hour, minute = _this$state.minute, second = _this$state.second;
                var data = [
                    {
                        type: "year",
                        range: options.yearsRange,
                        value: year
                    },
                    {
                        type: "month",
                        range: [
                            1,
                            12
                        ],
                        value: month
                    },
                    {
                        type: "day",
                        range: [
                            1,
                            31
                        ],
                        value: day
                    }
                ];
                if (time) data.push({
                    type: "hour",
                    range: [
                        0,
                        23
                    ],
                    value: hour
                }, {
                    type: "minute",
                    range: [
                        0,
                        59
                    ],
                    value: minute
                }, {
                    type: "second",
                    range: [
                        0,
                        59
                    ],
                    value: second
                });
                return data;
            }
        }
    ]);
    return AltDateWidget;
}((0, $acw62.Component));
(0, $kB4x2.default)($7b03165183fa6904$var$AltDateWidget, "defaultProps", {
    time: false,
    disabled: false,
    readonly: false,
    autofocus: false,
    options: {
        yearsRange: [
            1900,
            new Date().getFullYear() + 2
        ]
    }
});
var $7b03165183fa6904$export$2e2bcd8739ae039 = $7b03165183fa6904$var$AltDateWidget;

});

parcelRegister("6CdBR", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d10d94d3b140974$export$2e2bcd8739ae039);

var $k4zDq = parcelRequire("k4zDq");

var $cG9FK = parcelRequire("cG9FK");

var $acw62 = parcelRequire("acw62");


var $ayMZV = parcelRequire("ayMZV");
function $4d10d94d3b140974$var$AltDateTimeWidget(props) {
    var AltDateWidget = props.registry.widgets.AltDateWidget;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(AltDateWidget, (0, $cG9FK.default)({
        time: true
    }, props));
}
$4d10d94d3b140974$var$AltDateTimeWidget.defaultProps = (0, $k4zDq.default)({}, (0, $ayMZV.default).defaultProps, {
    time: true
});
var $4d10d94d3b140974$export$2e2bcd8739ae039 = $4d10d94d3b140974$var$AltDateTimeWidget;

});

parcelRegister("2eJFx", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a1050794ab9965b$export$2e2bcd8739ae039);

var $lyRnQ = parcelRequire("lyRnQ");

var $4juyi = parcelRequire("4juyi");

var $cG9FK = parcelRequire("cG9FK");

var $gpTap = parcelRequire("gpTap");

var $8gMgl = parcelRequire("8gMgl");

var $acw62 = parcelRequire("acw62");

function $1a1050794ab9965b$var$BaseInput(props) {
    // Note: since React 15.2.0 we can't forward unknown element attributes, so we
    // exclude the "options" and "schema" ones here.
    if (!props.id) {
        console.log("No id for", props);
        throw new Error("no id for props ".concat((0, (/*@__PURE__*/$parcel$interopDefault($8gMgl)))(props)));
    }
    var value = props.value, readonly = props.readonly, disabled = props.disabled, autofocus = props.autofocus, onBlur = props.onBlur, onFocus = props.onFocus, options = props.options, schema = props.schema, uiSchema = props.uiSchema, formContext = props.formContext, registry = props.registry, rawErrors = props.rawErrors, inputProps = (0, $gpTap.default)(props, [
        "value",
        "readonly",
        "disabled",
        "autofocus",
        "onBlur",
        "onFocus",
        "options",
        "schema",
        "uiSchema",
        "formContext",
        "registry",
        "rawErrors"
    ]); // If options.inputType is set use that as the input type
    if (options.inputType) inputProps.type = options.inputType;
    else if (!inputProps.type) {
        // If the schema is of type number or integer, set the input type to number
        if (schema.type === "number") {
            inputProps.type = "number"; // Setting step to 'any' fixes a bug in Safari where decimals are not
            // allowed in number inputs
            inputProps.step = "any";
        } else if (schema.type === "integer") {
            inputProps.type = "number"; // Since this is integer, you always want to step up or down in multiples
            // of 1
            inputProps.step = "1";
        } else inputProps.type = "text";
    }
    if (options.autocomplete) inputProps.autoComplete = options.autocomplete;
     // If multipleOf is defined, use this as the step value. This mainly improves
    // the experience for keyboard users (who can use the up/down KB arrows).
    if (schema.multipleOf) inputProps.step = schema.multipleOf;
    if (typeof schema.minimum !== "undefined") inputProps.min = schema.minimum;
    if (typeof schema.maximum !== "undefined") inputProps.max = schema.maximum;
    var _onChange = function _onChange(_ref) {
        var value = _ref.target.value;
        return props.onChange(value === "" ? options.emptyValue : value);
    };
    return [
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", (0, $cG9FK.default)({
            key: inputProps.id,
            className: "form-control",
            readOnly: readonly,
            disabled: disabled,
            autoFocus: autofocus,
            value: value == null ? "" : value
        }, inputProps, {
            list: schema.examples ? "examples_".concat(inputProps.id) : null,
            onChange: _onChange,
            onBlur: onBlur && function(event) {
                return onBlur(inputProps.id, event.target.value);
            },
            onFocus: onFocus && function(event) {
                return onFocus(inputProps.id, event.target.value);
            }
        })),
        schema.examples ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("datalist", {
            id: "examples_".concat(inputProps.id)
        }, (0, $4juyi.default)(new (0, (/*@__PURE__*/$parcel$interopDefault($lyRnQ)))(schema.examples.concat(schema["default"] ? [
            schema["default"]
        ] : []))).map(function(example) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
                key: example,
                value: example
            });
        })) : null
    ];
}
$1a1050794ab9965b$var$BaseInput.defaultProps = {
    required: false,
    disabled: false,
    readonly: false,
    autofocus: false
};
var $1a1050794ab9965b$export$2e2bcd8739ae039 = $1a1050794ab9965b$var$BaseInput;

});

parcelRegister("aa4ig", function(module, exports) {

$parcel$export(module.exports, "default", () => $765e2b26026e6e7a$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $513QU = parcelRequire("513QU");
function $765e2b26026e6e7a$var$CheckboxWidget(props) {
    var schema = props.schema, id = props.id, value = props.value, disabled = props.disabled, readonly = props.readonly, label = props.label, autofocus = props.autofocus, onBlur = props.onBlur, onFocus = props.onFocus, _onChange = props.onChange, DescriptionField = props.DescriptionField; // Because an unchecked checkbox will cause html5 validation to fail, only add
    // the "required" attribute if the field value must be "true", due to the
    // "const" or "enum" keywords
    var required = (0, $513QU.schemaRequiresTrueValue)(schema);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "checkbox ".concat(disabled || readonly ? "disabled" : "")
    }, schema.description && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(DescriptionField, {
        description: schema.description
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        type: "checkbox",
        id: id,
        checked: typeof value === "undefined" ? false : value,
        required: required,
        disabled: disabled || readonly,
        autoFocus: autofocus,
        onChange: function onChange(event) {
            return _onChange(event.target.checked);
        },
        onBlur: onBlur && function(event) {
            return onBlur(id, event.target.checked);
        },
        onFocus: onFocus && function(event) {
            return onFocus(id, event.target.checked);
        }
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, label)));
}
$765e2b26026e6e7a$var$CheckboxWidget.defaultProps = {
    autofocus: false
};
var $765e2b26026e6e7a$export$2e2bcd8739ae039 = $765e2b26026e6e7a$var$CheckboxWidget;

});

parcelRegister("55Nsu", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b53c8cbf678a92e$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

function $3b53c8cbf678a92e$var$selectValue(value, selected, all) {
    var at = all.indexOf(value);
    var updated = selected.slice(0, at).concat(value, selected.slice(at)); // As inserting values at predefined index positions doesn't work with empty
    // arrays, we need to reorder the updated selection to match the initial order
    return updated.sort(function(a, b) {
        return all.indexOf(a) > all.indexOf(b);
    });
}
function $3b53c8cbf678a92e$var$deselectValue(value, selected) {
    return selected.filter(function(v) {
        return v !== value;
    });
}
function $3b53c8cbf678a92e$var$CheckboxesWidget(props) {
    var id = props.id, disabled = props.disabled, options = props.options, value = props.value, autofocus = props.autofocus, readonly = props.readonly, _onChange = props.onChange;
    var enumOptions = options.enumOptions, enumDisabled = options.enumDisabled, inline = options.inline;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "checkboxes",
        id: id
    }, enumOptions.map(function(option, index) {
        var checked = value.indexOf(option.value) !== -1;
        var itemDisabled = enumDisabled && enumDisabled.indexOf(option.value) != -1;
        var disabledCls = disabled || itemDisabled || readonly ? "disabled" : "";
        var checkbox = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
            type: "checkbox",
            id: "".concat(id, "_").concat(index),
            checked: checked,
            disabled: disabled || itemDisabled || readonly,
            autoFocus: autofocus && index === 0,
            onChange: function onChange(event) {
                var all = enumOptions.map(function(_ref) {
                    var value = _ref.value;
                    return value;
                });
                if (event.target.checked) _onChange($3b53c8cbf678a92e$var$selectValue(option.value, value, all));
                else _onChange($3b53c8cbf678a92e$var$deselectValue(option.value, value));
            }
        }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, option.label));
        return inline ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
            key: index,
            className: "checkbox-inline ".concat(disabledCls)
        }, checkbox) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: index,
            className: "checkbox ".concat(disabledCls)
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", null, checkbox));
    }));
}
$3b53c8cbf678a92e$var$CheckboxesWidget.defaultProps = {
    autofocus: false,
    options: {
        inline: false
    }
};
var $3b53c8cbf678a92e$export$2e2bcd8739ae039 = $3b53c8cbf678a92e$var$CheckboxesWidget;

});

parcelRegister("epPto", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7eb53fab3d65de3$export$2e2bcd8739ae039);

var $cG9FK = parcelRequire("cG9FK");

var $acw62 = parcelRequire("acw62");

function $a7eb53fab3d65de3$var$ColorWidget(props) {
    var disabled = props.disabled, readonly = props.readonly, BaseInput = props.registry.widgets.BaseInput;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(BaseInput, (0, $cG9FK.default)({
        type: "color"
    }, props, {
        disabled: disabled || readonly
    }));
}
var $a7eb53fab3d65de3$export$2e2bcd8739ae039 = $a7eb53fab3d65de3$var$ColorWidget;

});

parcelRegister("cfmj6", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ea83074e5788c05$export$2e2bcd8739ae039);

var $cG9FK = parcelRequire("cG9FK");

var $acw62 = parcelRequire("acw62");

function $8ea83074e5788c05$var$DateWidget(props) {
    var _onChange = props.onChange, BaseInput = props.registry.widgets.BaseInput;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(BaseInput, (0, $cG9FK.default)({
        type: "date"
    }, props, {
        onChange: function onChange(value) {
            return _onChange(value || undefined);
        }
    }));
}
var $8ea83074e5788c05$export$2e2bcd8739ae039 = $8ea83074e5788c05$var$DateWidget;

});

parcelRegister("7iVcW", function(module, exports) {

$parcel$export(module.exports, "default", () => $55169715905fc51d$export$2e2bcd8739ae039);

var $cG9FK = parcelRequire("cG9FK");

var $acw62 = parcelRequire("acw62");


var $513QU = parcelRequire("513QU");
function $55169715905fc51d$var$DateTimeWidget(props) {
    var value = props.value, _onChange = props.onChange, BaseInput = props.registry.widgets.BaseInput;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(BaseInput, (0, $cG9FK.default)({
        type: "datetime-local"
    }, props, {
        value: (0, $513QU.utcToLocal)(value),
        onChange: function onChange(value) {
            return _onChange((0, $513QU.localToUTC)(value));
        }
    }));
}
var $55169715905fc51d$export$2e2bcd8739ae039 = $55169715905fc51d$var$DateTimeWidget;

});

parcelRegister("7lZut", function(module, exports) {

$parcel$export(module.exports, "default", () => $55aa3151c52d6ee6$export$2e2bcd8739ae039);

var $cG9FK = parcelRequire("cG9FK");

var $acw62 = parcelRequire("acw62");

function $55aa3151c52d6ee6$var$EmailWidget(props) {
    var BaseInput = props.registry.widgets.BaseInput;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(BaseInput, (0, $cG9FK.default)({
        type: "email"
    }, props));
}
var $55aa3151c52d6ee6$export$2e2bcd8739ae039 = $55aa3151c52d6ee6$var$EmailWidget;

});

parcelRegister("hbHqt", function(module, exports) {

$parcel$export(module.exports, "default", () => $c83526446cb477bf$export$2e2bcd8739ae039);

var $a5du3 = parcelRequire("a5du3");

var $7PwEf = parcelRequire("7PwEf");

var $4tWkZ = parcelRequire("4tWkZ");

var $eBH73 = parcelRequire("eBH73");

var $ctnWZ = parcelRequire("ctnWZ");

var $hl9R1 = parcelRequire("hl9R1");

var $ivxVa = parcelRequire("ivxVa");

var $kB4x2 = parcelRequire("kB4x2");

var $7oVy1 = parcelRequire("7oVy1");

var $acw62 = parcelRequire("acw62");


var $513QU = parcelRequire("513QU");
function $c83526446cb477bf$var$addNameToDataURL(dataURL, name) {
    return dataURL.replace(";base64", ";name=".concat(encodeURIComponent(name), ";base64"));
}
function $c83526446cb477bf$var$processFile(file) {
    var name = file.name, size = file.size, type = file.type;
    return new (0, (/*@__PURE__*/$parcel$interopDefault($7oVy1)))(function(resolve, reject) {
        var reader = new window.FileReader();
        reader.onerror = reject;
        reader.onload = function(event) {
            resolve({
                dataURL: $c83526446cb477bf$var$addNameToDataURL(event.target.result, name),
                name: name,
                size: size,
                type: type
            });
        };
        reader.readAsDataURL(file);
    });
}
function $c83526446cb477bf$var$processFiles(files) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7oVy1))).all([].map.call(files, $c83526446cb477bf$var$processFile));
}
function $c83526446cb477bf$var$FilesInfo(props) {
    var filesInfo = props.filesInfo;
    if (filesInfo.length === 0) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
        className: "file-info"
    }, filesInfo.map(function(fileInfo, key) {
        var name = fileInfo.name, size = fileInfo.size, type = fileInfo.type;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: key
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("strong", null, name), " (", type, ", ", size, " bytes)");
    }));
}
function $c83526446cb477bf$var$extractFileInfo(dataURLs) {
    return dataURLs.filter(function(dataURL) {
        return typeof dataURL !== "undefined";
    }).map(function(dataURL) {
        var _dataURItoBlob = (0, $513QU.dataURItoBlob)(dataURL), blob = _dataURItoBlob.blob, name = _dataURItoBlob.name;
        return {
            name: name,
            size: blob.size,
            type: blob.type
        };
    });
}
var $c83526446cb477bf$var$FileWidget = /*#__PURE__*/ function(_Component) {
    (0, $ivxVa.default)(FileWidget, _Component);
    function FileWidget(props) {
        var _this;
        (0, $7PwEf.default)(this, FileWidget);
        _this = (0, $eBH73.default)(this, (0, $ctnWZ.default)(FileWidget).call(this, props));
        (0, $kB4x2.default)((0, $hl9R1.default)(_this), "onChange", function(event) {
            var _this$props = _this.props, multiple = _this$props.multiple, onChange = _this$props.onChange;
            $c83526446cb477bf$var$processFiles(event.target.files).then(function(filesInfo) {
                var state = {
                    values: filesInfo.map(function(fileInfo) {
                        return fileInfo.dataURL;
                    }),
                    filesInfo: filesInfo
                };
                _this.setState(state, function() {
                    if (multiple) onChange(state.values);
                    else onChange(state.values[0]);
                });
            });
        });
        var value = props.value;
        var values = (0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(value) ? value : [
            value
        ];
        _this.state = {
            values: values,
            filesInfo: $c83526446cb477bf$var$extractFileInfo(values)
        };
        return _this;
    }
    (0, $4tWkZ.default)(FileWidget, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps, nextState) {
                return (0, $513QU.shouldRender)(this, nextProps, nextState);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props2 = this.props, multiple = _this$props2.multiple, id = _this$props2.id, readonly = _this$props2.readonly, disabled = _this$props2.disabled, autofocus = _this$props2.autofocus, options = _this$props2.options;
                var filesInfo = this.state.filesInfo;
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
                    ref: function ref(_ref) {
                        return _this2.inputRef = _ref;
                    },
                    id: id,
                    type: "file",
                    disabled: readonly || disabled,
                    onChange: this.onChange,
                    defaultValue: "",
                    autoFocus: autofocus,
                    multiple: multiple,
                    accept: options.accept
                })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c83526446cb477bf$var$FilesInfo, {
                    filesInfo: filesInfo
                }));
            }
        }
    ]);
    return FileWidget;
}((0, $acw62.Component));
$c83526446cb477bf$var$FileWidget.defaultProps = {
    autofocus: false
};
var $c83526446cb477bf$export$2e2bcd8739ae039 = $c83526446cb477bf$var$FileWidget;

});

parcelRegister("lDCyR", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc0b26f92af01e8a$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

function $fc0b26f92af01e8a$var$HiddenWidget(_ref) {
    var id = _ref.id, value = _ref.value;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
        type: "hidden",
        id: id,
        value: typeof value === "undefined" ? "" : value
    });
}
var $fc0b26f92af01e8a$export$2e2bcd8739ae039 = $fc0b26f92af01e8a$var$HiddenWidget;

});

parcelRegister("aZrTT", function(module, exports) {

$parcel$export(module.exports, "default", () => $80053e5671b7079a$export$2e2bcd8739ae039);

var $cG9FK = parcelRequire("cG9FK");

var $acw62 = parcelRequire("acw62");

function $80053e5671b7079a$var$PasswordWidget(props) {
    var BaseInput = props.registry.widgets.BaseInput;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(BaseInput, (0, $cG9FK.default)({
        type: "password"
    }, props));
}
var $80053e5671b7079a$export$2e2bcd8739ae039 = $80053e5671b7079a$var$PasswordWidget;

});

parcelRegister("bAKq8", function(module, exports) {

$parcel$export(module.exports, "default", () => $870710aafaecd2a9$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

function $870710aafaecd2a9$var$RadioWidget(props) {
    var options = props.options, value = props.value, required = props.required, disabled = props.disabled, readonly = props.readonly, autofocus = props.autofocus, onBlur = props.onBlur, onFocus = props.onFocus, _onChange = props.onChange, id = props.id; // Generating a unique field name to identify this set of radio buttons
    var name = Math.random().toString();
    var enumOptions = options.enumOptions, enumDisabled = options.enumDisabled, inline = options.inline; // checked={checked} has been moved above name={name}, As mentioned in #349;
    // this is a temporary fix for radio button rendering bug in React, facebook/react#7630.
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "field-radio-group",
        id: id
    }, enumOptions.map(function(option, i) {
        var checked = option.value === value;
        var itemDisabled = enumDisabled && enumDisabled.indexOf(option.value) != -1;
        var disabledCls = disabled || itemDisabled || readonly ? "disabled" : "";
        var radio = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
            type: "radio",
            checked: checked,
            name: name,
            required: required,
            value: option.value,
            disabled: disabled || itemDisabled || readonly,
            autoFocus: autofocus && i === 0,
            onChange: function onChange(_) {
                return _onChange(option.value);
            },
            onBlur: onBlur && function(event) {
                return onBlur(id, event.target.value);
            },
            onFocus: onFocus && function(event) {
                return onFocus(id, event.target.value);
            }
        }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, option.label));
        return inline ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", {
            key: i,
            className: "radio-inline ".concat(disabledCls)
        }, radio) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: i,
            className: "radio ".concat(disabledCls)
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("label", null, radio));
    }));
}
$870710aafaecd2a9$var$RadioWidget.defaultProps = {
    autofocus: false
};
var $870710aafaecd2a9$export$2e2bcd8739ae039 = $870710aafaecd2a9$var$RadioWidget;

});

parcelRegister("g15OE", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba914047f5e96556$export$2e2bcd8739ae039);

var $cG9FK = parcelRequire("cG9FK");

var $acw62 = parcelRequire("acw62");


var $513QU = parcelRequire("513QU");
function $ba914047f5e96556$var$RangeWidget(props) {
    var schema = props.schema, value = props.value, BaseInput = props.registry.widgets.BaseInput;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "field-range-wrapper"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(BaseInput, (0, $cG9FK.default)({
        type: "range"
    }, props, (0, $513QU.rangeSpec)(schema))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "range-view"
    }, value));
}
var $ba914047f5e96556$export$2e2bcd8739ae039 = $ba914047f5e96556$var$RangeWidget;

});

parcelRegister("2uIQk", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d112afe1f4d4988$export$2e2bcd8739ae039);

var $lyRnQ = parcelRequire("lyRnQ");

var $acw62 = parcelRequire("acw62");


var $513QU = parcelRequire("513QU");
var $1d112afe1f4d4988$var$nums = new (0, (/*@__PURE__*/$parcel$interopDefault($lyRnQ)))([
    "number",
    "integer"
]);
/**
 * This is a silly limitation in the DOM where option change event values are
 * always retrieved as strings.
 */ function $1d112afe1f4d4988$var$processValue(schema, value) {
    // "enum" is a reserved word, so only "type" and "items" can be destructured
    var type = schema.type, items = schema.items;
    if (value === "") return undefined;
    else if (type === "array" && items && $1d112afe1f4d4988$var$nums.has(items.type)) return value.map((0, $513QU.asNumber));
    else if (type === "boolean") return value === "true";
    else if (type === "number") return (0, $513QU.asNumber)(value);
     // If type is undefined, but an enum is present, try and infer the type from
    // the enum values
    if (schema["enum"]) {
        if (schema["enum"].every(function(x) {
            return (0, $513QU.guessType)(x) === "number";
        })) return (0, $513QU.asNumber)(value);
        else if (schema["enum"].every(function(x) {
            return (0, $513QU.guessType)(x) === "boolean";
        })) return value === "true";
    }
    return value;
}
function $1d112afe1f4d4988$var$getValue(event, multiple) {
    if (multiple) return [].slice.call(event.target.options).filter(function(o) {
        return o.selected;
    }).map(function(o) {
        return o.value;
    });
    else return event.target.value;
}
function $1d112afe1f4d4988$var$SelectWidget(props) {
    var schema = props.schema, id = props.id, options = props.options, value = props.value, required = props.required, disabled = props.disabled, readonly = props.readonly, multiple = props.multiple, autofocus = props.autofocus, _onChange = props.onChange, onBlur = props.onBlur, onFocus = props.onFocus, placeholder = props.placeholder;
    var enumOptions = options.enumOptions, enumDisabled = options.enumDisabled;
    var emptyValue = multiple ? [] : "";
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("select", {
        id: id,
        multiple: multiple,
        className: "form-control",
        value: typeof value === "undefined" ? emptyValue : value,
        required: required,
        disabled: disabled || readonly,
        autoFocus: autofocus,
        onBlur: onBlur && function(event) {
            var newValue = $1d112afe1f4d4988$var$getValue(event, multiple);
            onBlur(id, $1d112afe1f4d4988$var$processValue(schema, newValue));
        },
        onFocus: onFocus && function(event) {
            var newValue = $1d112afe1f4d4988$var$getValue(event, multiple);
            onFocus(id, $1d112afe1f4d4988$var$processValue(schema, newValue));
        },
        onChange: function onChange(event) {
            var newValue = $1d112afe1f4d4988$var$getValue(event, multiple);
            _onChange($1d112afe1f4d4988$var$processValue(schema, newValue));
        }
    }, !multiple && schema["default"] === undefined && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
        value: ""
    }, placeholder), enumOptions.map(function(_ref, i) {
        var value = _ref.value, label = _ref.label;
        var disabled = enumDisabled && enumDisabled.indexOf(value) != -1;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
            key: i,
            value: value,
            disabled: disabled
        }, label);
    }));
}
$1d112afe1f4d4988$var$SelectWidget.defaultProps = {
    autofocus: false
};
var $1d112afe1f4d4988$export$2e2bcd8739ae039 = $1d112afe1f4d4988$var$SelectWidget;

});

parcelRegister("5zMBD", function(module, exports) {

$parcel$export(module.exports, "default", () => $40f5ecc0f4dbf80d$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

function $40f5ecc0f4dbf80d$var$TextareaWidget(props) {
    var id = props.id, options = props.options, placeholder = props.placeholder, value = props.value, required = props.required, disabled = props.disabled, readonly = props.readonly, autofocus = props.autofocus, onChange = props.onChange, onBlur = props.onBlur, onFocus = props.onFocus;
    var _onChange = function _onChange(_ref) {
        var value = _ref.target.value;
        return onChange(value === "" ? options.emptyValue : value);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("textarea", {
        id: id,
        className: "form-control",
        value: value ? value : "",
        placeholder: placeholder,
        required: required,
        disabled: disabled,
        readOnly: readonly,
        autoFocus: autofocus,
        rows: options.rows,
        onBlur: onBlur && function(event) {
            return onBlur(id, event.target.value);
        },
        onFocus: onFocus && function(event) {
            return onFocus(id, event.target.value);
        },
        onChange: _onChange
    });
}
$40f5ecc0f4dbf80d$var$TextareaWidget.defaultProps = {
    autofocus: false,
    options: {}
};
var $40f5ecc0f4dbf80d$export$2e2bcd8739ae039 = $40f5ecc0f4dbf80d$var$TextareaWidget;

});

parcelRegister("9oEBR", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d75db2e048ad548$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");

function $6d75db2e048ad548$var$TextWidget(props) {
    var BaseInput = props.registry.widgets.BaseInput;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(BaseInput, props);
}
var $6d75db2e048ad548$export$2e2bcd8739ae039 = $6d75db2e048ad548$var$TextWidget;

});

parcelRegister("2jGNr", function(module, exports) {

$parcel$export(module.exports, "default", () => $1afe8d9e2bf0867b$export$2e2bcd8739ae039);

var $cG9FK = parcelRequire("cG9FK");

var $acw62 = parcelRequire("acw62");

function $1afe8d9e2bf0867b$var$URLWidget(props) {
    var BaseInput = props.registry.widgets.BaseInput;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(BaseInput, (0, $cG9FK.default)({
        type: "url"
    }, props));
}
var $1afe8d9e2bf0867b$export$2e2bcd8739ae039 = $1afe8d9e2bf0867b$var$URLWidget;

});

parcelRegister("1wLJD", function(module, exports) {

$parcel$export(module.exports, "default", () => $11cdcecbaba1aa98$export$2e2bcd8739ae039);

var $cG9FK = parcelRequire("cG9FK");

var $acw62 = parcelRequire("acw62");


var $513QU = parcelRequire("513QU");
function $11cdcecbaba1aa98$var$UpDownWidget(props) {
    var BaseInput = props.registry.widgets.BaseInput;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(BaseInput, (0, $cG9FK.default)({
        type: "number"
    }, props, (0, $513QU.rangeSpec)(props.schema)));
}
var $11cdcecbaba1aa98$export$2e2bcd8739ae039 = $11cdcecbaba1aa98$var$UpDownWidget;

});


parcelRegister("czU5E", function(module, exports) {

$parcel$export(module.exports, "default", () => $92844340126509b5$export$2e2bcd8739ae039);
$parcel$export(module.exports, "isValid", () => $92844340126509b5$export$1ea939691cdc45b8);

var $4juyi = parcelRequire("4juyi");

var $kB4x2 = parcelRequire("kB4x2");

var $k4zDq = parcelRequire("k4zDq");

var $8lpxl = parcelRequire("8lpxl");

var $bTUgL = parcelRequire("bTUgL");

var $a5du3 = parcelRequire("a5du3");

var $ilhTG = parcelRequire("ilhTG");

var $5KOyW = parcelRequire("5KOyW");

var $513QU = parcelRequire("513QU");
var $92844340126509b5$var$ajv = $92844340126509b5$var$createAjvInstance();
var $92844340126509b5$var$formerCustomFormats = null;
var $92844340126509b5$var$formerMetaSchema = null;
function $92844340126509b5$var$createAjvInstance() {
    var ajv = new (0, (/*@__PURE__*/$parcel$interopDefault($5KOyW)))({
        errorDataPath: "property",
        allErrors: true,
        multipleOfPrecision: 8,
        schemaId: "auto",
        unknownFormats: "ignore"
    }); // add custom formats
    ajv.addFormat("data-url", /^data:([a-z]+\/[a-z0-9-+.]+)?;(?:name=(.*);)?base64,(.*)$/);
    ajv.addFormat("color", /^(#?([0-9A-Fa-f]{3}){1,2}\b|aqua|black|blue|fuchsia|gray|green|lime|maroon|navy|olive|orange|purple|red|silver|teal|white|yellow|(rgb\(\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*,\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*,\s*\b([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])\b\s*\))|(rgb\(\s*(\d?\d%|100%)+\s*,\s*(\d?\d%|100%)+\s*,\s*(\d?\d%|100%)+\s*\)))$/);
    return ajv;
}
function $92844340126509b5$var$toErrorSchema(errors) {
    // Transforms a ajv validation errors list:
    // [
    //   {property: ".level1.level2[2].level3", message: "err a"},
    //   {property: ".level1.level2[2].level3", message: "err b"},
    //   {property: ".level1.level2[4].level3", message: "err b"},
    // ]
    // Into an error tree:
    // {
    //   level1: {
    //     level2: {
    //       2: {level3: {errors: ["err a", "err b"]}},
    //       4: {level3: {errors: ["err b"]}},
    //     }
    //   }
    // };
    if (!errors.length) return {};
    return errors.reduce(function(errorSchema, error) {
        var property = error.property, message = error.message;
        var path = (0, (/*@__PURE__*/$parcel$interopDefault($ilhTG)))(property);
        var parent = errorSchema; // If the property is at the root (.level1) then toPath creates
        // an empty array element at the first index. Remove it.
        if (path.length > 0 && path[0] === "") path.splice(0, 1);
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;
        try {
            for(var _iterator = (0, (/*@__PURE__*/$parcel$interopDefault($bTUgL)))(path.slice(0)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var segment = _step.value;
                if (!(segment in parent)) parent[segment] = {};
                parent = parent[segment];
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator["return"] != null) _iterator["return"]();
            } finally{
                if (_didIteratorError) throw _iteratorError;
            }
        }
        if ((0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(parent.__errors)) // We store the list of errors for this node in a property named __errors
        // to avoid name collision with a possible sub schema field named
        // "errors" (see `validate.createErrorHandler`).
        parent.__errors = parent.__errors.concat(message);
        else if (message) parent.__errors = [
            message
        ];
        return errorSchema;
    }, {});
}
function $92844340126509b5$export$29c1d0951c919856(errorSchema) {
    var fieldName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "root";
    // XXX: We should transform fieldName as a full field path string.
    var errorList = [];
    if ("__errors" in errorSchema) errorList = errorList.concat(errorSchema.__errors.map(function(stack) {
        return {
            stack: "".concat(fieldName, ": ").concat(stack)
        };
    }));
    return (0, (/*@__PURE__*/$parcel$interopDefault($8lpxl)))(errorSchema).reduce(function(acc, key) {
        if (key !== "__errors") acc = acc.concat($92844340126509b5$export$29c1d0951c919856(errorSchema[key], key));
        return acc;
    }, errorList);
}
function $92844340126509b5$var$createErrorHandler(formData) {
    var handler = {
        // We store the list of errors for this node in a property named __errors
        // to avoid name collision with a possible sub schema field named
        // "errors" (see `utils.toErrorSchema`).
        __errors: [],
        addError: function addError(message) {
            this.__errors.push(message);
        }
    };
    if ((0, $513QU.isObject)(formData)) return (0, (/*@__PURE__*/$parcel$interopDefault($8lpxl)))(formData).reduce(function(acc, key) {
        return (0, $k4zDq.default)({}, acc, (0, $kB4x2.default)({}, key, $92844340126509b5$var$createErrorHandler(formData[key])));
    }, handler);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(formData)) return formData.reduce(function(acc, value, key) {
        return (0, $k4zDq.default)({}, acc, (0, $kB4x2.default)({}, key, $92844340126509b5$var$createErrorHandler(value)));
    }, handler);
    return handler;
}
function $92844340126509b5$var$unwrapErrorHandler(errorHandler) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($8lpxl)))(errorHandler).reduce(function(acc, key) {
        if (key === "addError") return acc;
        else if (key === "__errors") return (0, $k4zDq.default)({}, acc, (0, $kB4x2.default)({}, key, errorHandler[key]));
        return (0, $k4zDq.default)({}, acc, (0, $kB4x2.default)({}, key, $92844340126509b5$var$unwrapErrorHandler(errorHandler[key])));
    }, {});
}
/**
 * Transforming the error output from ajv to format used by jsonschema.
 * At some point, components should be updated to support ajv.
 */ function $92844340126509b5$var$transformAjvErrors() {
    var errors = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    if (errors === null) return [];
    return errors.map(function(e) {
        var dataPath = e.dataPath, keyword = e.keyword, message = e.message, params = e.params, schemaPath = e.schemaPath;
        var property = "".concat(dataPath); // put data in expected format
        return {
            name: keyword,
            property: property,
            message: message,
            params: params,
            // specific to ajv
            stack: "".concat(property, " ").concat(message).trim(),
            schemaPath: schemaPath
        };
    });
}
function $92844340126509b5$export$2e2bcd8739ae039(formData, schema, customValidate, transformErrors) {
    var additionalMetaSchemas = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
    var customFormats = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
    // Include form data with undefined values, which is required for validation.
    var rootSchema = schema;
    formData = (0, $513QU.getDefaultFormState)(schema, formData, rootSchema, true);
    var newMetaSchemas = !(0, $513QU.deepEquals)($92844340126509b5$var$formerMetaSchema, additionalMetaSchemas);
    var newFormats = !(0, $513QU.deepEquals)($92844340126509b5$var$formerCustomFormats, customFormats);
    if (newMetaSchemas || newFormats) $92844340126509b5$var$ajv = $92844340126509b5$var$createAjvInstance();
     // add more schemas to validate against
    if (additionalMetaSchemas && newMetaSchemas && (0, (/*@__PURE__*/$parcel$interopDefault($a5du3)))(additionalMetaSchemas)) {
        $92844340126509b5$var$ajv.addMetaSchema(additionalMetaSchemas);
        $92844340126509b5$var$formerMetaSchema = additionalMetaSchemas;
    } // add more custom formats to validate against
    if (customFormats && newFormats && (0, $513QU.isObject)(customFormats)) {
        (0, (/*@__PURE__*/$parcel$interopDefault($8lpxl)))(customFormats).forEach(function(formatName) {
            $92844340126509b5$var$ajv.addFormat(formatName, customFormats[formatName]);
        });
        $92844340126509b5$var$formerCustomFormats = customFormats;
    }
    var validationError = null;
    try {
        $92844340126509b5$var$ajv.validate(schema, formData);
    } catch (err) {
        validationError = err;
    }
    var errors = $92844340126509b5$var$transformAjvErrors($92844340126509b5$var$ajv.errors); // Clear errors to prevent persistent errors, see #1104
    $92844340126509b5$var$ajv.errors = null;
    var noProperMetaSchema = validationError && validationError.message && typeof validationError.message === "string" && validationError.message.includes("no schema with key or ref ");
    if (noProperMetaSchema) errors = [].concat((0, $4juyi.default)(errors), [
        {
            stack: validationError.message
        }
    ]);
    if (typeof transformErrors === "function") errors = transformErrors(errors);
    var errorSchema = $92844340126509b5$var$toErrorSchema(errors);
    if (noProperMetaSchema) errorSchema = (0, $k4zDq.default)({}, errorSchema, {
        $schema: {
            __errors: [
                validationError.message
            ]
        }
    });
    if (typeof customValidate !== "function") return {
        errors: errors,
        errorSchema: errorSchema
    };
    var errorHandler = customValidate(formData, $92844340126509b5$var$createErrorHandler(formData));
    var userErrorSchema = $92844340126509b5$var$unwrapErrorHandler(errorHandler);
    var newErrorSchema = (0, $513QU.mergeObjects)(errorSchema, userErrorSchema, true); // XXX: The errors list produced is not fully compliant with the format
    // exposed by the jsonschema lib, which contains full field paths and other
    // properties.
    var newErrors = $92844340126509b5$export$29c1d0951c919856(newErrorSchema);
    return {
        errors: newErrors,
        errorSchema: newErrorSchema
    };
}
function $92844340126509b5$export$1ea939691cdc45b8(schema, data) {
    try {
        return $92844340126509b5$var$ajv.validate(schema, data);
    } catch (e) {
        return false;
    }
}

});




parcelRegister("8n5Wo", function(module, exports) {
"use strict";
var $6185146a837b2a2a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $6185146a837b2a2a$var$react_1 = $6185146a837b2a2a$var$__importDefault((parcelRequire("acw62")));

const $6185146a837b2a2a$var$Input_1 = $6185146a837b2a2a$var$__importDefault((parcelRequire("8xbn2")));
const $6185146a837b2a2a$var$BaseInput = (props)=>{
    return $6185146a837b2a2a$var$react_1.default.createElement($6185146a837b2a2a$var$Input_1.default, Object.assign({
        isCustom: false
    }, props));
};
module.exports.default = $6185146a837b2a2a$var$BaseInput;

});
parcelRegister("8xbn2", function(module, exports) {
"use strict";
var $636a39c49e5fa7e3$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $636a39c49e5fa7e3$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $636a39c49e5fa7e3$var$react_1 = $636a39c49e5fa7e3$var$__importDefault((parcelRequire("acw62")));

const $636a39c49e5fa7e3$var$classnames_1 = $636a39c49e5fa7e3$var$__importDefault((parcelRequire("8g1PZ")));

var $bpOLS = parcelRequire("bpOLS");
parcelRequire("fHiKR");
var $1BYDb = parcelRequire("1BYDb");
var $5txPe = parcelRequire("5txPe");
const $636a39c49e5fa7e3$var$selectValue = (value, all, selected)=>{
    const at = all.indexOf(value);
    const updated = selected && selected.slice(0, at).concat(value, selected.slice(at)) || [
        value
    ];
    // As inserting values at predefined index positions doesn't work with empty
    // arrays, we need to reorder the updated selection to match the initial order
    return updated.sort((a, b)=>all.indexOf(a) > all.indexOf(b) ? 1 : -1);
};
const $636a39c49e5fa7e3$var$deselectValue = (value, selected)=>{
    return selected.filter((v)=>v !== value);
};
const $636a39c49e5fa7e3$var$getValue = (event, isMulti, hideBlankOption)=>{
    if (isMulti) {
        const selectedValues = [].slice.call(event.target.options).filter((o, index)=>o.selected && (hideBlankOption || index !== 0)).map((o)=>o.value);
        return selectedValues.length > 0 ? selectedValues : undefined;
    } else return event.target.value;
};
const $636a39c49e5fa7e3$var$Input = (props)=>{
    // Note: since React 15.2.0 we can't forward unknown element attributes, so we
    // exclude the "options" and "schema" ones here.
    if (!props.id) throw new Error(`No id for props ${JSON.stringify(props)}`);
    const { id: id, isCustom: isCustom, value: value, readonly: readonly = false, disabled: disabled = false, autofocus: autofocus = false, onChange: onChange, onBlur: onBlur, onFocus: onFocus, options: options, schema: schema, rawErrors: rawErrors, dataLwtId: dataLwtId, className: className, placeholder: placeholder } = props, restProps = $636a39c49e5fa7e3$var$__rest(props, [
        "id",
        "isCustom",
        "value",
        "readonly",
        "disabled",
        "autofocus",
        "onChange",
        "onBlur",
        "onFocus",
        "options",
        "schema",
        "rawErrors",
        "dataLwtId",
        "className",
        "placeholder"
    ]);
    const { title: title, inputType: inputType, emptyValue: emptyValue, enumOptions: enumOptions, enumDisabled: enumDisabled, inline: inline, hideBlankOption: hideBlankOption, isMulti: isMulti } = options;
    const cssClasses = (0, $636a39c49e5fa7e3$var$classnames_1.default)(className, rawErrors && rawErrors.length > 0 && "is-invalid");
    let inputProps = restProps;
    if ((restProps === null || restProps === void 0 ? void 0 : restProps.uiSchema) && restProps.uiSchema["ui:options"]) inputProps = Object.assign(Object.assign({}, restProps), restProps.uiSchema["ui:options"]);
    const inputRef = $636a39c49e5fa7e3$var$react_1.default.createRef();
    const mask = (0, $bpOLS.useMask)({
        mask: inputProps.uiSchema && inputProps.uiSchema["lwolf:mask"] ? inputProps.uiSchema["lwolf:mask"].mask : null,
        elementRef: inputRef,
        options: {
            placeholder: inputProps.uiSchema && inputProps.uiSchema["lwolf:mask"] ? inputProps.uiSchema["lwolf:mask"].placeholder : null
        }
    });
    const getMask = ()=>{
        return inputProps.uiSchema["lwolf:mask"] ? Object.assign(Object.assign({}, mask), {
            innerRef: inputRef
        }) : {};
    };
    // If options.inputType is set use that as the input type
    if (inputType) inputProps.type = inputType;
    else if (!inputProps.type) {
        // If the schema is of type number or integer, set the input type to number
        if (schema.type === "number") {
            inputProps.type = "number";
            // Setting step to 'any' fixes a bug in Safari where decimals are not
            // allowed in number inputs
            inputProps.step = "any";
        } else if (schema.type === "integer") {
            inputProps.type = "number";
            // Since this is integer, you always want to step up or down in multiples
            // of 1
            inputProps.step = "1";
        } else inputProps.type = "text";
    }
    // If multipleOf is defined, use this as the step value. This mainly improves
    // the experience for keyboard users (who can use the up/down KB arrows).
    if (schema.multipleOf) inputProps.step = schema.multipleOf;
    if (typeof schema.minimum !== "undefined") inputProps.min = schema.minimum;
    if (typeof schema.maximum !== "undefined") inputProps.max = schema.maximum;
    let _onChange = ({ target: { value: v } })=>{
        onChange(v === "" ? emptyValue : v);
    };
    let input;
    if (isCustom) {
        if (enumOptions && schema.type !== "boolean") {
            const inputs = [];
            const children = [];
            if (inputProps.type === "select" && !hideBlankOption) children.push($636a39c49e5fa7e3$var$react_1.default.createElement("option", {
                key: `option-${id}_0`,
                value: ""
            }, placeholder ? placeholder : "- Select -"));
            enumOptions.forEach((option, i)=>{
                if (inputProps.type === "radio") _onChange = ()=>onChange(option.value);
                else if (inputProps.type === "select") _onChange = (event)=>{
                    const newValue = $636a39c49e5fa7e3$var$getValue(event, isMulti, hideBlankOption);
                    onChange(newValue);
                };
                else _onChange = (event)=>{
                    const all = enumOptions.map(({ value: v })=>v);
                    if (event.target.checked) onChange($636a39c49e5fa7e3$var$selectValue(option.value, all, value));
                    else onChange($636a39c49e5fa7e3$var$deselectValue(option.value, value));
                };
                const checked = inputProps.type === "radio" ? option.value === value : value && value.indexOf(option.value) !== -1 || false;
                const itemDisabled = enumDisabled && enumDisabled.indexOf(option.value) !== -1;
                if (inputProps.type === "select") children.push($636a39c49e5fa7e3$var$react_1.default.createElement("option", {
                    key: `option-${id}_${++i}`,
                    value: option.value
                }, option.label));
                else inputs.push($636a39c49e5fa7e3$var$react_1.default.createElement($1BYDb.default, Object.assign({}, inputProps, {
                    id: inputProps.type === "radio" ? option.value : `${id}_${i}`,
                    dataLwtId: inputProps.type === "radio" ? option.value : `${id}_${i}`,
                    key: `input-${id}_${i}`,
                    type: inputProps.type,
                    className: cssClasses,
                    checked: checked,
                    disabled: disabled || itemDisabled || readonly,
                    autoFocus: autofocus && i === 0,
                    inline: inline,
                    value: inputProps.type === "radio" ? option.value : value,
                    label: option.label,
                    onChange: _onChange,
                    onBlur: onBlur && ((event)=>onBlur(id, event.target.value)),
                    onFocus: onFocus && ((event)=>onFocus(id, event.target.value))
                }), children));
            });
            input = $636a39c49e5fa7e3$var$react_1.default.createElement("div", {
                "data-lwt-id": dataLwtId
            }, inputProps.type === "select" ? $636a39c49e5fa7e3$var$react_1.default.createElement($1BYDb.default, Object.assign({}, inputProps, {
                id: id,
                dataLwtId: id,
                type: inputProps.type,
                value: value,
                className: cssClasses,
                disabled: disabled || readonly,
                autoFocus: autofocus,
                inline: inline,
                onChange: _onChange,
                onBlur: onBlur && ((event)=>onBlur(id, event.target.value)),
                onFocus: onFocus && ((event)=>onFocus(id, event.target.value)),
                multiple: isMulti || false
            }), children) : inputs);
        } else {
            const additionalProps = {
                id: id,
                dataLwtId: id,
                type: inputProps.type,
                value: value || ""
            };
            if (schema.type === "boolean") {
                additionalProps.checked = value || false;
                additionalProps.value = value || false;
                additionalProps.label = title;
                additionalProps.disabled = readonly;
                additionalProps.type = "checkbox";
                _onChange = (event)=>{
                    if (event.target.checked) onChange(true);
                    else onChange(false);
                };
            } else additionalProps.readOnly = readonly;
            input = $636a39c49e5fa7e3$var$react_1.default.createElement($1BYDb.default, Object.assign({}, inputProps, additionalProps, {
                className: cssClasses,
                disabled: disabled,
                autoFocus: autofocus,
                dataLwtId: dataLwtId,
                onChange: _onChange,
                onBlur: onBlur && ((event)=>onBlur(id, event.target.value)),
                onFocus: onFocus && ((event)=>onFocus(id, event.target.value))
            }));
        }
    } else input = $636a39c49e5fa7e3$var$react_1.default.createElement($5txPe.default, Object.assign({}, inputProps, {
        id: id,
        dataLwtId: dataLwtId,
        type: inputProps.type,
        className: cssClasses,
        disabled: disabled,
        autoFocus: autofocus,
        readOnly: readonly,
        value: value == null ? "" : value,
        onChange: _onChange,
        onBlur: onBlur && ((event)=>onBlur(id, event.target.value)),
        onFocus: onFocus && ((event)=>onFocus(id, event.target.value))
    }, getMask()));
    return input;
};
module.exports.default = $636a39c49e5fa7e3$var$Input;

});
parcelRegister("bpOLS", function(module, exports) {
"use strict";
var $84f9699f0a4ae027$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useMask = void 0;

var $nMJse = parcelRequire("nMJse");
Object.defineProperty(module.exports, "useMask", {
    enumerable: true,
    get: function() {
        return $84f9699f0a4ae027$var$__importDefault($nMJse).default;
    }
});

});
parcelRegister("nMJse", function(module, exports) {
"use strict";
var $0477f348b7cc7322$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $acw62 = parcelRequire("acw62");

const $0477f348b7cc7322$var$inputmask_1 = $0477f348b7cc7322$var$__importDefault((parcelRequire("e3x0F")));
const $0477f348b7cc7322$var$useMask = ({ mask: mask, options: options, elementRef: elementRef })=>{
    (0, $acw62.useEffect)(()=>{
        if (elementRef === undefined) return;
        if (!elementRef.current) return;
        (0, $0477f348b7cc7322$var$inputmask_1.default)(mask, options).mask(elementRef.current);
    }, [
        mask,
        elementRef
    ]);
    return {};
};
module.exports.default = $0477f348b7cc7322$var$useMask;

});
parcelRegister("e3x0F", function(module, exports) {
/*!
 * dist/inputmask
 * https://github.com/RobinHerbots/Inputmask
 * Copyright (c) 2010 - 2021 Robin Herbots
 * Licensed under the MIT license
 * Version: 5.0.7
 */ !function(e, t) {
    var i, a;
    module.exports = t();
}(self, function() {
    return function() {
        "use strict";
        var e = {
            8741: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var i = !("undefined" == typeof window || !window.document || !window.document.createElement);
                t.default = i;
            },
            3976: function(e, t, i) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var a, n = (a = i(5581)) && a.__esModule ? a : {
                    default: a
                };
                var r = {
                    _maxTestPos: 500,
                    placeholder: "_",
                    optionalmarker: [
                        "[",
                        "]"
                    ],
                    quantifiermarker: [
                        "{",
                        "}"
                    ],
                    groupmarker: [
                        "(",
                        ")"
                    ],
                    alternatormarker: "|",
                    escapeChar: "\\",
                    mask: null,
                    regex: null,
                    oncomplete: function() {},
                    onincomplete: function() {},
                    oncleared: function() {},
                    repeat: 0,
                    greedy: !1,
                    autoUnmask: !1,
                    removeMaskOnSubmit: !1,
                    clearMaskOnLostFocus: !0,
                    insertMode: !0,
                    insertModeVisual: !0,
                    clearIncomplete: !1,
                    alias: null,
                    onKeyDown: function() {},
                    onBeforeMask: null,
                    onBeforePaste: function(e, t) {
                        return "function" == typeof t.onBeforeMask ? t.onBeforeMask.call(this, e, t) : e;
                    },
                    onBeforeWrite: null,
                    onUnMask: null,
                    showMaskOnFocus: !0,
                    showMaskOnHover: !0,
                    onKeyValidation: function() {},
                    skipOptionalPartCharacter: " ",
                    numericInput: !1,
                    rightAlign: !1,
                    undoOnEscape: !0,
                    radixPoint: "",
                    _radixDance: !1,
                    groupSeparator: "",
                    keepStatic: null,
                    positionCaretOnTab: !0,
                    tabThrough: !1,
                    supportsInputType: [
                        "text",
                        "tel",
                        "url",
                        "password",
                        "search"
                    ],
                    ignorables: [
                        n.default.BACKSPACE,
                        n.default.TAB,
                        n.default["PAUSE/BREAK"],
                        n.default.ESCAPE,
                        n.default.PAGE_UP,
                        n.default.PAGE_DOWN,
                        n.default.END,
                        n.default.HOME,
                        n.default.LEFT,
                        n.default.UP,
                        n.default.RIGHT,
                        n.default.DOWN,
                        n.default.INSERT,
                        n.default.DELETE,
                        93,
                        112,
                        113,
                        114,
                        115,
                        116,
                        117,
                        118,
                        119,
                        120,
                        121,
                        122,
                        123,
                        0,
                        229
                    ],
                    isComplete: null,
                    preValidation: null,
                    postValidation: null,
                    staticDefinitionSymbol: void 0,
                    jitMasking: !1,
                    nullable: !0,
                    inputEventOnly: !1,
                    noValuePatching: !1,
                    positionCaretOnClick: "lvp",
                    casing: null,
                    inputmode: "text",
                    importDataAttributes: !0,
                    shiftPositions: !0,
                    usePrototypeDefinitions: !0,
                    validationEventTimeOut: 3e3,
                    substitutes: {}
                };
                t.default = r;
            },
            7392: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                t.default = {
                    9: {
                        validator: "[0-9\uFF10-\uFF19]",
                        definitionSymbol: "*"
                    },
                    a: {
                        validator: "[A-Za-z\u0410-\u044F\u0401\u0451\xc0-\xff\xb5]",
                        definitionSymbol: "*"
                    },
                    "*": {
                        validator: "[0-9\uFF10-\uFF19A-Za-z\u0410-\u044F\u0401\u0451\xc0-\xff\xb5]"
                    }
                };
            },
            253: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = function(e, t, i) {
                    if (void 0 === i) return e.__data ? e.__data[t] : null;
                    e.__data = e.__data || {}, e.__data[t] = i;
                };
            },
            3776: function(e, t, i) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.Event = void 0, t.off = function(e, t) {
                    var i, a;
                    function n(e, t, n) {
                        if (e in i == !0) {
                            if (a.removeEventListener ? a.removeEventListener(e, n, !1) : a.detachEvent && a.detachEvent("on" + e, n), "global" === t) for(var r in i[e])i[e][r].splice(i[e][r].indexOf(n), 1);
                            else i[e][t].splice(i[e][t].indexOf(n), 1);
                        }
                    }
                    function r(e, a) {
                        var n, r, o = [];
                        if (e.length > 0) {
                            if (void 0 === t) for(n = 0, r = i[e][a].length; n < r; n++)o.push({
                                ev: e,
                                namespace: a && a.length > 0 ? a : "global",
                                handler: i[e][a][n]
                            });
                            else o.push({
                                ev: e,
                                namespace: a && a.length > 0 ? a : "global",
                                handler: t
                            });
                        } else if (a.length > 0) {
                            for(var l in i)for(var s in i[l])if (s === a) {
                                if (void 0 === t) for(n = 0, r = i[l][s].length; n < r; n++)o.push({
                                    ev: l,
                                    namespace: s,
                                    handler: i[l][s][n]
                                });
                                else o.push({
                                    ev: l,
                                    namespace: s,
                                    handler: t
                                });
                            }
                        }
                        return o;
                    }
                    if (u(this[0]) && e) {
                        i = this[0].eventRegistry, a = this[0];
                        for(var o = e.split(" "), l = 0; l < o.length; l++)for(var s = o[l].split("."), c = r(s[0], s[1]), f = 0, d = c.length; f < d; f++)n(c[f].ev, c[f].namespace, c[f].handler);
                    }
                    return this;
                }, t.on = function(e, t) {
                    function i(e, i) {
                        n.addEventListener ? n.addEventListener(e, t, !1) : n.attachEvent && n.attachEvent("on" + e, t), a[e] = a[e] || {}, a[e][i] = a[e][i] || [], a[e][i].push(t);
                    }
                    if (u(this[0])) for(var a = this[0].eventRegistry, n = this[0], r = e.split(" "), o = 0; o < r.length; o++){
                        var l = r[o].split("."), s = l[0], c = l[1] || "global";
                        i(s, c);
                    }
                    return this;
                }, t.trigger = function(e) {
                    if (u(this[0])) for(var t = this[0].eventRegistry, i = this[0], a = "string" == typeof e ? e.split(" ") : [
                        e.type
                    ], r = 0; r < a.length; r++){
                        var l = a[r].split("."), s = l[0], c = l[1] || "global";
                        if (void 0 !== document && "global" === c) {
                            var f, d, p = {
                                bubbles: !0,
                                cancelable: !0,
                                detail: arguments[1]
                            };
                            if (document.createEvent) {
                                try {
                                    if ("input" === s) p.inputType = "insertText", f = new InputEvent(s, p);
                                    else f = new CustomEvent(s, p);
                                } catch (e) {
                                    (f = document.createEvent("CustomEvent")).initCustomEvent(s, p.bubbles, p.cancelable, p.detail);
                                }
                                e.type && (0, n.default)(f, e), i.dispatchEvent(f);
                            } else (f = document.createEventObject()).eventType = s, f.detail = arguments[1], e.type && (0, n.default)(f, e), i.fireEvent("on" + f.eventType, f);
                        } else if (void 0 !== t[s]) {
                            if (arguments[0] = arguments[0].type ? arguments[0] : o.default.Event(arguments[0]), arguments[0].detail = arguments.slice(1), "global" === c) for(var h in t[s])for(d = 0; d < t[s][h].length; d++)t[s][h][d].apply(i, arguments);
                            else for(d = 0; d < t[s][c].length; d++)t[s][c][d].apply(i, arguments);
                        }
                    }
                    return this;
                };
                var a, n = s(i(600)), r = s(i(9380)), o = s(i(4963)), l = s(i(8741));
                function s(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                function u(e) {
                    return e instanceof Element;
                }
                t.Event = a, "function" == typeof r.default.CustomEvent ? t.Event = a = r.default.CustomEvent : l.default && (t.Event = a = function(e, t) {
                    t = t || {
                        bubbles: !1,
                        cancelable: !1,
                        detail: void 0
                    };
                    var i = document.createEvent("CustomEvent");
                    return i.initCustomEvent(e, t.bubbles, t.cancelable, t.detail), i;
                }, a.prototype = r.default.Event.prototype);
            },
            600: function(e, t) {
                function i(e) {
                    return i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, i(e);
                }
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = function e() {
                    var t, a, n, r, o, l, s = arguments[0] || {}, u = 1, c = arguments.length, f = !1;
                    "boolean" == typeof s && (f = s, s = arguments[u] || {}, u++);
                    "object" !== i(s) && "function" != typeof s && (s = {});
                    for(; u < c; u++)if (null != (t = arguments[u])) for(a in t)n = s[a], r = t[a], s !== r && (f && r && ("[object Object]" === Object.prototype.toString.call(r) || (o = Array.isArray(r))) ? (o ? (o = !1, l = n && Array.isArray(n) ? n : []) : l = n && "[object Object]" === Object.prototype.toString.call(n) ? n : {}, s[a] = e(f, l, r)) : void 0 !== r && (s[a] = r));
                    return s;
                };
            },
            4963: function(e, t, i) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var a = l(i(600)), n = l(i(9380)), r = l(i(253)), o = i(3776);
                function l(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                var s = n.default.document;
                function u(e) {
                    return e instanceof u ? e : this instanceof u ? void (null != e && e !== n.default && (this[0] = e.nodeName ? e : void 0 !== e[0] && e[0].nodeName ? e[0] : s.querySelector(e), void 0 !== this[0] && null !== this[0] && (this[0].eventRegistry = this[0].eventRegistry || {}))) : new u(e);
                }
                u.prototype = {
                    on: o.on,
                    off: o.off,
                    trigger: o.trigger
                }, u.extend = a.default, u.data = r.default, u.Event = o.Event;
                var c = u;
                t.default = c;
            },
            9845: function(e, t, i) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.ua = t.mobile = t.iphone = t.iemobile = t.ie = void 0;
                var a, n = (a = i(9380)) && a.__esModule ? a : {
                    default: a
                };
                var r = n.default.navigator && n.default.navigator.userAgent || "", o = r.indexOf("MSIE ") > 0 || r.indexOf("Trident/") > 0, l = "ontouchstart" in n.default, s = /iemobile/i.test(r), u = /iphone/i.test(r) && !s;
                t.iphone = u, t.iemobile = s, t.mobile = l, t.ie = o, t.ua = r;
            },
            7184: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = function(e) {
                    return e.replace(i, "\\$1");
                };
                var i = new RegExp("(\\" + [
                    "/",
                    ".",
                    "*",
                    "+",
                    "?",
                    "|",
                    "(",
                    ")",
                    "[",
                    "]",
                    "{",
                    "}",
                    "\\",
                    "$",
                    "^"
                ].join("|\\") + ")", "gim");
            },
            6030: function(e, t, i) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.EventHandlers = void 0;
                var a, n = i(8711), r = (a = i(5581)) && a.__esModule ? a : {
                    default: a
                }, o = i(9845), l = i(7215), s = i(7760), u = i(4713);
                function c(e, t) {
                    var i = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                    if (!i) {
                        if (Array.isArray(e) || (i = function(e, t) {
                            if (!e) return;
                            if ("string" == typeof e) return f(e, t);
                            var i = Object.prototype.toString.call(e).slice(8, -1);
                            "Object" === i && e.constructor && (i = e.constructor.name);
                            if ("Map" === i || "Set" === i) return Array.from(e);
                            if ("Arguments" === i || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)) return f(e, t);
                        }(e)) || t && e && "number" == typeof e.length) {
                            i && (e = i);
                            var a = 0, n = function() {};
                            return {
                                s: n,
                                n: function() {
                                    return a >= e.length ? {
                                        done: !0
                                    } : {
                                        done: !1,
                                        value: e[a++]
                                    };
                                },
                                e: function(e) {
                                    throw e;
                                },
                                f: n
                            };
                        }
                        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var r, o = !0, l = !1;
                    return {
                        s: function() {
                            i = i.call(e);
                        },
                        n: function() {
                            var e = i.next();
                            return o = e.done, e;
                        },
                        e: function(e) {
                            l = !0, r = e;
                        },
                        f: function() {
                            try {
                                o || null == i.return || i.return();
                            } finally{
                                if (l) throw r;
                            }
                        }
                    };
                }
                function f(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for(var i = 0, a = new Array(t); i < t; i++)a[i] = e[i];
                    return a;
                }
                var d = {
                    keydownEvent: function(e) {
                        var t = this.inputmask, i = t.opts, a = t.dependencyLib, c = t.maskset, f = this, d = a(f), p = e.keyCode, h = n.caret.call(t, f), v = i.onKeyDown.call(this, e, n.getBuffer.call(t), h, i);
                        if (void 0 !== v) return v;
                        if (p === r.default.BACKSPACE || p === r.default.DELETE || o.iphone && p === r.default.BACKSPACE_SAFARI || e.ctrlKey && p === r.default.X && !("oncut" in f)) e.preventDefault(), l.handleRemove.call(t, f, p, h), (0, s.writeBuffer)(f, n.getBuffer.call(t, !0), c.p, e, f.inputmask._valueGet() !== n.getBuffer.call(t).join(""));
                        else if (p === r.default.END || p === r.default.PAGE_DOWN) {
                            e.preventDefault();
                            var m = n.seekNext.call(t, n.getLastValidPosition.call(t));
                            n.caret.call(t, f, e.shiftKey ? h.begin : m, m, !0);
                        } else p === r.default.HOME && !e.shiftKey || p === r.default.PAGE_UP ? (e.preventDefault(), n.caret.call(t, f, 0, e.shiftKey ? h.begin : 0, !0)) : i.undoOnEscape && p === r.default.ESCAPE && !0 !== e.altKey ? ((0, s.checkVal)(f, !0, !1, t.undoValue.split("")), d.trigger("click")) : p !== r.default.INSERT || e.shiftKey || e.ctrlKey || void 0 !== t.userOptions.insertMode ? !0 === i.tabThrough && p === r.default.TAB ? !0 === e.shiftKey ? (h.end = n.seekPrevious.call(t, h.end, !0), !0 === u.getTest.call(t, h.end - 1).match.static && h.end--, h.begin = n.seekPrevious.call(t, h.end, !0), h.begin >= 0 && h.end > 0 && (e.preventDefault(), n.caret.call(t, f, h.begin, h.end))) : (h.begin = n.seekNext.call(t, h.begin, !0), h.end = n.seekNext.call(t, h.begin, !0), h.end < c.maskLength && h.end--, h.begin <= c.maskLength && (e.preventDefault(), n.caret.call(t, f, h.begin, h.end))) : e.shiftKey || i.insertModeVisual && !1 === i.insertMode && (p === r.default.RIGHT ? setTimeout(function() {
                            var e = n.caret.call(t, f);
                            n.caret.call(t, f, e.begin);
                        }, 0) : p === r.default.LEFT && setTimeout(function() {
                            var e = n.translatePosition.call(t, f.inputmask.caretPos.begin);
                            n.translatePosition.call(t, f.inputmask.caretPos.end);
                            t.isRTL ? n.caret.call(t, f, e + (e === c.maskLength ? 0 : 1)) : n.caret.call(t, f, e - (0 === e ? 0 : 1));
                        }, 0)) : l.isSelection.call(t, h) ? i.insertMode = !i.insertMode : (i.insertMode = !i.insertMode, n.caret.call(t, f, h.begin, h.begin));
                        t.ignorable = i.ignorables.includes(p);
                    },
                    keypressEvent: function(e, t, i, a, o) {
                        var u = this.inputmask || this, c = u.opts, f = u.dependencyLib, d = u.maskset, p = u.el, h = f(p), v = e.keyCode;
                        if (!(!0 === t || e.ctrlKey && e.altKey) && (e.ctrlKey || e.metaKey || u.ignorable)) return v === r.default.ENTER && u.undoValue !== u._valueGet(!0) && (u.undoValue = u._valueGet(!0), setTimeout(function() {
                            h.trigger("change");
                        }, 0)), u.skipInputEvent = !0, !0;
                        if (v) {
                            44 !== v && 46 !== v || 3 !== e.location || "" === c.radixPoint || (v = c.radixPoint.charCodeAt(0));
                            var m, g = t ? {
                                begin: o,
                                end: o
                            } : n.caret.call(u, p), k = String.fromCharCode(v);
                            k = c.substitutes[k] || k, d.writeOutBuffer = !0;
                            var y = l.isValid.call(u, g, k, a, void 0, void 0, void 0, t);
                            if (!1 !== y && (n.resetMaskSet.call(u, !0), m = void 0 !== y.caret ? y.caret : n.seekNext.call(u, y.pos.begin ? y.pos.begin : y.pos), d.p = m), m = c.numericInput && void 0 === y.caret ? n.seekPrevious.call(u, m) : m, !1 !== i && (setTimeout(function() {
                                c.onKeyValidation.call(p, v, y);
                            }, 0), d.writeOutBuffer && !1 !== y)) {
                                var b = n.getBuffer.call(u);
                                (0, s.writeBuffer)(p, b, m, e, !0 !== t);
                            }
                            if (e.preventDefault(), t) return !1 !== y && (y.forwardPosition = m), y;
                        }
                    },
                    keyupEvent: function(e) {
                        var t = this.inputmask;
                        !t.isComposing || e.keyCode !== r.default.KEY_229 && e.keyCode !== r.default.ENTER || t.$el.trigger("input");
                    },
                    pasteEvent: function(e) {
                        var t, i = this.inputmask, a = i.opts, r = i._valueGet(!0), o = n.caret.call(i, this);
                        i.isRTL && (t = o.end, o.end = n.translatePosition.call(i, o.begin), o.begin = n.translatePosition.call(i, t));
                        var l = r.substr(0, o.begin), u = r.substr(o.end, r.length);
                        if (l == (i.isRTL ? n.getBufferTemplate.call(i).slice().reverse() : n.getBufferTemplate.call(i)).slice(0, o.begin).join("") && (l = ""), u == (i.isRTL ? n.getBufferTemplate.call(i).slice().reverse() : n.getBufferTemplate.call(i)).slice(o.end).join("") && (u = ""), window.clipboardData && window.clipboardData.getData) r = l + window.clipboardData.getData("Text") + u;
                        else {
                            if (!e.clipboardData || !e.clipboardData.getData) return !0;
                            r = l + e.clipboardData.getData("text/plain") + u;
                        }
                        var f = r;
                        if (i.isRTL) {
                            f = f.split("");
                            var d, p = c(n.getBufferTemplate.call(i));
                            try {
                                for(p.s(); !(d = p.n()).done;){
                                    var h = d.value;
                                    f[0] === h && f.shift();
                                }
                            } catch (e) {
                                p.e(e);
                            } finally{
                                p.f();
                            }
                            f = f.join("");
                        }
                        if ("function" == typeof a.onBeforePaste) {
                            if (!1 === (f = a.onBeforePaste.call(i, f, a))) return !1;
                            f || (f = r);
                        }
                        (0, s.checkVal)(this, !0, !1, f.toString().split(""), e), e.preventDefault();
                    },
                    inputFallBackEvent: function(e) {
                        var t = this.inputmask, i = t.opts, a = t.dependencyLib;
                        var l = this, c = l.inputmask._valueGet(!0), f = (t.isRTL ? n.getBuffer.call(t).slice().reverse() : n.getBuffer.call(t)).join(""), p = n.caret.call(t, l, void 0, void 0, !0);
                        if (f !== c) {
                            c = function(e, i, a) {
                                if (o.iemobile) {
                                    var r = i.replace(n.getBuffer.call(t).join(""), "");
                                    if (1 === r.length) {
                                        var l = i.split("");
                                        l.splice(a.begin, 0, r), i = l.join("");
                                    }
                                }
                                return i;
                            }(0, c, p);
                            var h = function(e, a, r) {
                                for(var o, l, s, c = e.substr(0, r.begin).split(""), f = e.substr(r.begin).split(""), d = a.substr(0, r.begin).split(""), p = a.substr(r.begin).split(""), h = c.length >= d.length ? c.length : d.length, v = f.length >= p.length ? f.length : p.length, m = "", g = [], k = "~"; c.length < h;)c.push(k);
                                for(; d.length < h;)d.push(k);
                                for(; f.length < v;)f.unshift(k);
                                for(; p.length < v;)p.unshift(k);
                                var y = c.concat(f), b = d.concat(p);
                                for(l = 0, o = y.length; l < o; l++)switch(s = u.getPlaceholder.call(t, n.translatePosition.call(t, l)), m){
                                    case "insertText":
                                        b[l - 1] === y[l] && r.begin == y.length - 1 && g.push(y[l]), l = o;
                                        break;
                                    case "insertReplacementText":
                                    case "deleteContentBackward":
                                        y[l] === k ? r.end++ : l = o;
                                        break;
                                    default:
                                        y[l] !== b[l] && (y[l + 1] !== k && y[l + 1] !== s && void 0 !== y[l + 1] || (b[l] !== s || b[l + 1] !== k) && b[l] !== k ? b[l + 1] === k && b[l] === y[l + 1] ? (m = "insertText", g.push(y[l]), r.begin--, r.end--) : y[l] !== s && y[l] !== k && (y[l + 1] === k || b[l] !== y[l] && b[l + 1] === y[l + 1]) ? (m = "insertReplacementText", g.push(y[l]), r.begin--) : y[l] === k ? (m = "deleteContentBackward", (n.isMask.call(t, n.translatePosition.call(t, l), !0) || b[l] === i.radixPoint) && r.end++) : l = o : (m = "insertText", g.push(y[l]), r.begin--, r.end--));
                                }
                                return {
                                    action: m,
                                    data: g,
                                    caret: r
                                };
                            }(c, f, p);
                            switch((l.inputmask.shadowRoot || l.ownerDocument).activeElement !== l && l.focus(), (0, s.writeBuffer)(l, n.getBuffer.call(t)), n.caret.call(t, l, p.begin, p.end, !0), h.action){
                                case "insertText":
                                case "insertReplacementText":
                                    h.data.forEach(function(e, i) {
                                        var n = new a.Event("keypress");
                                        n.keyCode = e.charCodeAt(0), t.ignorable = !1, d.keypressEvent.call(l, n);
                                    }), setTimeout(function() {
                                        t.$el.trigger("keyup");
                                    }, 0);
                                    break;
                                case "deleteContentBackward":
                                    var v = new a.Event("keydown");
                                    v.keyCode = r.default.BACKSPACE, d.keydownEvent.call(l, v);
                                    break;
                                default:
                                    (0, s.applyInputValue)(l, c);
                            }
                            e.preventDefault();
                        }
                    },
                    compositionendEvent: function(e) {
                        var t = this.inputmask;
                        t.isComposing = !1, t.$el.trigger("input");
                    },
                    setValueEvent: function(e) {
                        var t = this.inputmask, i = this, a = e && e.detail ? e.detail[0] : arguments[1];
                        void 0 === a && (a = i.inputmask._valueGet(!0)), (0, s.applyInputValue)(i, a), (e.detail && void 0 !== e.detail[1] || void 0 !== arguments[2]) && n.caret.call(t, i, e.detail ? e.detail[1] : arguments[2]);
                    },
                    focusEvent: function(e) {
                        var t = this.inputmask, i = t.opts, a = this, r = a.inputmask._valueGet();
                        i.showMaskOnFocus && r !== n.getBuffer.call(t).join("") && (0, s.writeBuffer)(a, n.getBuffer.call(t), n.seekNext.call(t, n.getLastValidPosition.call(t))), !0 !== i.positionCaretOnTab || !1 !== t.mouseEnter || l.isComplete.call(t, n.getBuffer.call(t)) && -1 !== n.getLastValidPosition.call(t) || d.clickEvent.apply(a, [
                            e,
                            !0
                        ]), t.undoValue = t._valueGet(!0);
                    },
                    invalidEvent: function(e) {
                        this.inputmask.validationEvent = !0;
                    },
                    mouseleaveEvent: function() {
                        var e = this.inputmask, t = e.opts, i = this;
                        e.mouseEnter = !1, t.clearMaskOnLostFocus && (i.inputmask.shadowRoot || i.ownerDocument).activeElement !== i && (0, s.HandleNativePlaceholder)(i, e.originalPlaceholder);
                    },
                    clickEvent: function(e, t) {
                        var i = this.inputmask, a = this;
                        if ((a.inputmask.shadowRoot || a.ownerDocument).activeElement === a) {
                            var r = n.determineNewCaretPosition.call(i, n.caret.call(i, a), t);
                            void 0 !== r && n.caret.call(i, a, r);
                        }
                    },
                    cutEvent: function(e) {
                        var t = this.inputmask, i = t.maskset, a = this, o = n.caret.call(t, a), u = t.isRTL ? n.getBuffer.call(t).slice(o.end, o.begin) : n.getBuffer.call(t).slice(o.begin, o.end), c = t.isRTL ? u.reverse().join("") : u.join("");
                        window.navigator.clipboard ? window.navigator.clipboard.writeText(c) : window.clipboardData && window.clipboardData.getData && window.clipboardData.setData("Text", c), l.handleRemove.call(t, a, r.default.DELETE, o), (0, s.writeBuffer)(a, n.getBuffer.call(t), i.p, e, t.undoValue !== t._valueGet(!0));
                    },
                    blurEvent: function(e) {
                        var t = this.inputmask, i = t.opts, a = (0, t.dependencyLib)(this), r = this;
                        if (r.inputmask) {
                            (0, s.HandleNativePlaceholder)(r, t.originalPlaceholder);
                            var o = r.inputmask._valueGet(), u = n.getBuffer.call(t).slice();
                            "" !== o && (i.clearMaskOnLostFocus && (-1 === n.getLastValidPosition.call(t) && o === n.getBufferTemplate.call(t).join("") ? u = [] : s.clearOptionalTail.call(t, u)), !1 === l.isComplete.call(t, u) && (setTimeout(function() {
                                a.trigger("incomplete");
                            }, 0), i.clearIncomplete && (n.resetMaskSet.call(t), u = i.clearMaskOnLostFocus ? [] : n.getBufferTemplate.call(t).slice())), (0, s.writeBuffer)(r, u, void 0, e)), t.undoValue !== t._valueGet(!0) && (t.undoValue = t._valueGet(!0), a.trigger("change"));
                        }
                    },
                    mouseenterEvent: function() {
                        var e = this.inputmask, t = e.opts, i = this;
                        if (e.mouseEnter = !0, (i.inputmask.shadowRoot || i.ownerDocument).activeElement !== i) {
                            var a = (e.isRTL ? n.getBufferTemplate.call(e).slice().reverse() : n.getBufferTemplate.call(e)).join("");
                            e.placeholder !== a && i.placeholder !== e.originalPlaceholder && (e.originalPlaceholder = i.placeholder), t.showMaskOnHover && (0, s.HandleNativePlaceholder)(i, a);
                        }
                    },
                    submitEvent: function() {
                        var e = this.inputmask, t = e.opts;
                        e.undoValue !== e._valueGet(!0) && e.$el.trigger("change"), -1 === n.getLastValidPosition.call(e) && e._valueGet && e._valueGet() === n.getBufferTemplate.call(e).join("") && e._valueSet(""), t.clearIncomplete && !1 === l.isComplete.call(e, n.getBuffer.call(e)) && e._valueSet(""), t.removeMaskOnSubmit && (e._valueSet(e.unmaskedvalue(), !0), setTimeout(function() {
                            (0, s.writeBuffer)(e.el, n.getBuffer.call(e));
                        }, 0));
                    },
                    resetEvent: function() {
                        var e = this.inputmask;
                        e.refreshValue = !0, setTimeout(function() {
                            (0, s.applyInputValue)(e.el, e._valueGet(!0));
                        }, 0);
                    }
                };
                t.EventHandlers = d;
            },
            9716: function(e, t, i) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.EventRuler = void 0;
                var a = l(i(2394)), n = l(i(5581)), r = i(8711), o = i(7760);
                function l(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                var s = {
                    on: function(e, t, i) {
                        var l = e.inputmask.dependencyLib, s = function(t) {
                            t.originalEvent && (t = t.originalEvent || t, arguments[0] = t);
                            var s, u = this, c = u.inputmask, f = c ? c.opts : void 0;
                            if (void 0 === c && "FORM" !== this.nodeName) {
                                var d = l.data(u, "_inputmask_opts");
                                l(u).off(), d && new a.default(d).mask(u);
                            } else {
                                if ([
                                    "submit",
                                    "reset",
                                    "setvalue"
                                ].includes(t.type) || "FORM" === this.nodeName || !(u.disabled || u.readOnly && !("keydown" === t.type && t.ctrlKey && 67 === t.keyCode || !1 === f.tabThrough && t.keyCode === n.default.TAB))) {
                                    switch(t.type){
                                        case "input":
                                            if (!0 === c.skipInputEvent || t.inputType && "insertCompositionText" === t.inputType) return c.skipInputEvent = !1, t.preventDefault();
                                            break;
                                        case "keydown":
                                            c.skipKeyPressEvent = !1, c.skipInputEvent = c.isComposing = t.keyCode === n.default.KEY_229;
                                            break;
                                        case "keyup":
                                        case "compositionend":
                                            c.isComposing && (c.skipInputEvent = !1);
                                            break;
                                        case "keypress":
                                            if (!0 === c.skipKeyPressEvent) return t.preventDefault();
                                            c.skipKeyPressEvent = !0;
                                            break;
                                        case "click":
                                        case "focus":
                                            return c.validationEvent ? (c.validationEvent = !1, e.blur(), (0, o.HandleNativePlaceholder)(e, (c.isRTL ? r.getBufferTemplate.call(c).slice().reverse() : r.getBufferTemplate.call(c)).join("")), setTimeout(function() {
                                                e.focus();
                                            }, f.validationEventTimeOut), !1) : (s = arguments, setTimeout(function() {
                                                e.inputmask && i.apply(u, s);
                                            }, 0), !1);
                                    }
                                    var p = i.apply(u, arguments);
                                    return !1 === p && (t.preventDefault(), t.stopPropagation()), p;
                                }
                                t.preventDefault();
                            }
                        };
                        [
                            "submit",
                            "reset"
                        ].includes(t) ? (s = s.bind(e), null !== e.form && l(e.form).on(t, s)) : l(e).on(t, s), e.inputmask.events[t] = e.inputmask.events[t] || [], e.inputmask.events[t].push(s);
                    },
                    off: function(e, t) {
                        if (e.inputmask && e.inputmask.events) {
                            var i = e.inputmask.dependencyLib, a = e.inputmask.events;
                            for(var n in t && ((a = [])[t] = e.inputmask.events[t]), a){
                                for(var r = a[n]; r.length > 0;){
                                    var o = r.pop();
                                    [
                                        "submit",
                                        "reset"
                                    ].includes(n) ? null !== e.form && i(e.form).off(n, o) : i(e).off(n, o);
                                }
                                delete e.inputmask.events[n];
                            }
                        }
                    }
                };
                t.EventRuler = s;
            },
            219: function(e, t, i) {
                var a = d(i(2394)), n = d(i(5581)), r = d(i(7184)), o = i(8711), l = i(4713);
                function s(e) {
                    return s = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, s(e);
                }
                function u(e, t) {
                    return function(e) {
                        if (Array.isArray(e)) return e;
                    }(e) || function(e, t) {
                        var i = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                        if (null == i) return;
                        var a, n, r = [], o = !0, l = !1;
                        try {
                            for(i = i.call(e); !(o = (a = i.next()).done) && (r.push(a.value), !t || r.length !== t); o = !0);
                        } catch (e) {
                            l = !0, n = e;
                        } finally{
                            try {
                                o || null == i.return || i.return();
                            } finally{
                                if (l) throw n;
                            }
                        }
                        return r;
                    }(e, t) || function(e, t) {
                        if (!e) return;
                        if ("string" == typeof e) return c(e, t);
                        var i = Object.prototype.toString.call(e).slice(8, -1);
                        "Object" === i && e.constructor && (i = e.constructor.name);
                        if ("Map" === i || "Set" === i) return Array.from(e);
                        if ("Arguments" === i || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)) return c(e, t);
                    }(e, t) || function() {
                        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }();
                }
                function c(e, t) {
                    (null == t || t > e.length) && (t = e.length);
                    for(var i = 0, a = new Array(t); i < t; i++)a[i] = e[i];
                    return a;
                }
                function f(e, t) {
                    for(var i = 0; i < t.length; i++){
                        var a = t[i];
                        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
                    }
                }
                function d(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                var p = a.default.dependencyLib, h = function() {
                    function e(t, i, a) {
                        !function(e, t) {
                            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                        }(this, e), this.mask = t, this.format = i, this.opts = a, this._date = new Date(1, 0, 1), this.initDateObject(t, this.opts);
                    }
                    var t, i, a;
                    return t = e, i = [
                        {
                            key: "date",
                            get: function() {
                                return void 0 === this._date && (this._date = new Date(1, 0, 1), this.initDateObject(void 0, this.opts)), this._date;
                            }
                        },
                        {
                            key: "initDateObject",
                            value: function(e, t) {
                                var i;
                                for(P(t).lastIndex = 0; i = P(t).exec(this.format);){
                                    var a = new RegExp("\\d+$").exec(i[0]), n = a ? i[0][0] + "x" : i[0], r = void 0;
                                    if (void 0 !== e) {
                                        if (a) {
                                            var o = P(t).lastIndex, l = O(i.index, t);
                                            P(t).lastIndex = o, r = e.slice(0, e.indexOf(l.nextMatch[0]));
                                        } else r = e.slice(0, n.length);
                                        e = e.slice(r.length);
                                    }
                                    Object.prototype.hasOwnProperty.call(g, n) && this.setValue(this, r, n, g[n][2], g[n][1]);
                                }
                            }
                        },
                        {
                            key: "setValue",
                            value: function(e, t, i, a, n) {
                                if (void 0 !== t && (e[a] = "ampm" === a ? t : t.replace(/[^0-9]/g, "0"), e["raw" + a] = t.replace(/\s/g, "_")), void 0 !== n) {
                                    var r = e[a];
                                    ("day" === a && 29 === parseInt(r) || "month" === a && 2 === parseInt(r)) && (29 !== parseInt(e.day) || 2 !== parseInt(e.month) || "" !== e.year && void 0 !== e.year || e._date.setFullYear(2012, 1, 29)), "day" === a && (m = !0, 0 === parseInt(r) && (r = 1)), "month" === a && (m = !0), "year" === a && (m = !0, r.length < 4 && (r = _(r, 4, !0))), "" === r || isNaN(r) || n.call(e._date, r), "ampm" === a && n.call(e._date, r);
                                }
                            }
                        },
                        {
                            key: "reset",
                            value: function() {
                                this._date = new Date(1, 0, 1);
                            }
                        },
                        {
                            key: "reInit",
                            value: function() {
                                this._date = void 0, this.date;
                            }
                        }
                    ], f(t.prototype, i), a && f(t, a), Object.defineProperty(t, "prototype", {
                        writable: !1
                    }), e;
                }(), v = (new Date).getFullYear(), m = !1, g = {
                    d: [
                        "[1-9]|[12][0-9]|3[01]",
                        Date.prototype.setDate,
                        "day",
                        Date.prototype.getDate
                    ],
                    dd: [
                        "0[1-9]|[12][0-9]|3[01]",
                        Date.prototype.setDate,
                        "day",
                        function() {
                            return _(Date.prototype.getDate.call(this), 2);
                        }
                    ],
                    ddd: [
                        ""
                    ],
                    dddd: [
                        ""
                    ],
                    m: [
                        "[1-9]|1[012]",
                        function(e) {
                            var t = e ? parseInt(e) : 0;
                            return t > 0 && t--, Date.prototype.setMonth.call(this, t);
                        },
                        "month",
                        function() {
                            return Date.prototype.getMonth.call(this) + 1;
                        }
                    ],
                    mm: [
                        "0[1-9]|1[012]",
                        function(e) {
                            var t = e ? parseInt(e) : 0;
                            return t > 0 && t--, Date.prototype.setMonth.call(this, t);
                        },
                        "month",
                        function() {
                            return _(Date.prototype.getMonth.call(this) + 1, 2);
                        }
                    ],
                    mmm: [
                        ""
                    ],
                    mmmm: [
                        ""
                    ],
                    yy: [
                        "[0-9]{2}",
                        Date.prototype.setFullYear,
                        "year",
                        function() {
                            return _(Date.prototype.getFullYear.call(this), 2);
                        }
                    ],
                    yyyy: [
                        "[0-9]{4}",
                        Date.prototype.setFullYear,
                        "year",
                        function() {
                            return _(Date.prototype.getFullYear.call(this), 4);
                        }
                    ],
                    h: [
                        "[1-9]|1[0-2]",
                        Date.prototype.setHours,
                        "hours",
                        Date.prototype.getHours
                    ],
                    hh: [
                        "0[1-9]|1[0-2]",
                        Date.prototype.setHours,
                        "hours",
                        function() {
                            return _(Date.prototype.getHours.call(this), 2);
                        }
                    ],
                    hx: [
                        function(e) {
                            return "[0-9]{".concat(e, "}");
                        },
                        Date.prototype.setHours,
                        "hours",
                        function(e) {
                            return Date.prototype.getHours;
                        }
                    ],
                    H: [
                        "1?[0-9]|2[0-3]",
                        Date.prototype.setHours,
                        "hours",
                        Date.prototype.getHours
                    ],
                    HH: [
                        "0[0-9]|1[0-9]|2[0-3]",
                        Date.prototype.setHours,
                        "hours",
                        function() {
                            return _(Date.prototype.getHours.call(this), 2);
                        }
                    ],
                    Hx: [
                        function(e) {
                            return "[0-9]{".concat(e, "}");
                        },
                        Date.prototype.setHours,
                        "hours",
                        function(e) {
                            return function() {
                                return _(Date.prototype.getHours.call(this), e);
                            };
                        }
                    ],
                    M: [
                        "[1-5]?[0-9]",
                        Date.prototype.setMinutes,
                        "minutes",
                        Date.prototype.getMinutes
                    ],
                    MM: [
                        "0[0-9]|1[0-9]|2[0-9]|3[0-9]|4[0-9]|5[0-9]",
                        Date.prototype.setMinutes,
                        "minutes",
                        function() {
                            return _(Date.prototype.getMinutes.call(this), 2);
                        }
                    ],
                    s: [
                        "[1-5]?[0-9]",
                        Date.prototype.setSeconds,
                        "seconds",
                        Date.prototype.getSeconds
                    ],
                    ss: [
                        "0[0-9]|1[0-9]|2[0-9]|3[0-9]|4[0-9]|5[0-9]",
                        Date.prototype.setSeconds,
                        "seconds",
                        function() {
                            return _(Date.prototype.getSeconds.call(this), 2);
                        }
                    ],
                    l: [
                        "[0-9]{3}",
                        Date.prototype.setMilliseconds,
                        "milliseconds",
                        function() {
                            return _(Date.prototype.getMilliseconds.call(this), 3);
                        }
                    ],
                    L: [
                        "[0-9]{2}",
                        Date.prototype.setMilliseconds,
                        "milliseconds",
                        function() {
                            return _(Date.prototype.getMilliseconds.call(this), 2);
                        }
                    ],
                    t: [
                        "[ap]",
                        y,
                        "ampm",
                        b,
                        1
                    ],
                    tt: [
                        "[ap]m",
                        y,
                        "ampm",
                        b,
                        2
                    ],
                    T: [
                        "[AP]",
                        y,
                        "ampm",
                        b,
                        1
                    ],
                    TT: [
                        "[AP]M",
                        y,
                        "ampm",
                        b,
                        2
                    ],
                    Z: [
                        ".*",
                        void 0,
                        "Z",
                        function() {
                            var e = this.toString().match(/\((.+)\)/)[1];
                            e.includes(" ") && (e = (e = e.replace("-", " ").toUpperCase()).split(" ").map(function(e) {
                                return u(e, 1)[0];
                            }).join(""));
                            return e;
                        }
                    ],
                    o: [
                        ""
                    ],
                    S: [
                        ""
                    ]
                }, k = {
                    isoDate: "yyyy-mm-dd",
                    isoTime: "HH:MM:ss",
                    isoDateTime: "yyyy-mm-dd'T'HH:MM:ss",
                    isoUtcDateTime: "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'"
                };
                function y(e) {
                    var t = this.getHours();
                    e.toLowerCase().includes("p") ? this.setHours(t + 12) : e.toLowerCase().includes("a") && t >= 12 && this.setHours(t - 12);
                }
                function b() {
                    var e = this.getHours();
                    return (e = e || 12) >= 12 ? "PM" : "AM";
                }
                function x(e) {
                    var t = new RegExp("\\d+$").exec(e[0]);
                    if (t && void 0 !== t[0]) {
                        var i = g[e[0][0] + "x"].slice("");
                        return i[0] = i[0](t[0]), i[3] = i[3](t[0]), i;
                    }
                    if (g[e[0]]) return g[e[0]];
                }
                function P(e) {
                    if (!e.tokenizer) {
                        var t = [], i = [];
                        for(var a in g)if (/\.*x$/.test(a)) {
                            var n = a[0] + "\\d+";
                            -1 === i.indexOf(n) && i.push(n);
                        } else -1 === t.indexOf(a[0]) && t.push(a[0]);
                        e.tokenizer = "(" + (i.length > 0 ? i.join("|") + "|" : "") + t.join("+|") + ")+?|.", e.tokenizer = new RegExp(e.tokenizer, "g");
                    }
                    return e.tokenizer;
                }
                function E(e, t, i) {
                    if (!m) return !0;
                    if (void 0 === e.rawday || !isFinite(e.rawday) && new Date(e.date.getFullYear(), isFinite(e.rawmonth) ? e.month : e.date.getMonth() + 1, 0).getDate() >= e.day || "29" == e.day && (!isFinite(e.rawyear) || void 0 === e.rawyear || "" === e.rawyear) || new Date(e.date.getFullYear(), isFinite(e.rawmonth) ? e.month : e.date.getMonth() + 1, 0).getDate() >= e.day) return t;
                    if ("29" == e.day) {
                        var a = O(t.pos, i);
                        if ("yyyy" === a.targetMatch[0] && t.pos - a.targetMatchIndex == 2) return t.remove = t.pos + 1, t;
                    } else if ("02" == e.month && "30" == e.day && void 0 !== t.c) return e.day = "03", e.date.setDate(3), e.date.setMonth(1), t.insert = [
                        {
                            pos: t.pos,
                            c: "0"
                        },
                        {
                            pos: t.pos + 1,
                            c: t.c
                        }
                    ], t.caret = o.seekNext.call(this, t.pos + 1), t;
                    return !1;
                }
                function S(e, t, i, a) {
                    var n, o, l = "";
                    for(P(i).lastIndex = 0; n = P(i).exec(e);){
                        if (void 0 === t) {
                            if (o = x(n)) l += "(" + o[0] + ")";
                            else switch(n[0]){
                                case "[":
                                    l += "(";
                                    break;
                                case "]":
                                    l += ")?";
                                    break;
                                default:
                                    l += (0, r.default)(n[0]);
                            }
                        } else if (o = x(n)) {
                            if (!0 !== a && o[3]) l += o[3].call(t.date);
                            else o[2] ? l += t["raw" + o[2]] : l += n[0];
                        } else l += n[0];
                    }
                    return l;
                }
                function _(e, t, i) {
                    for(e = String(e), t = t || 2; e.length < t;)e = i ? e + "0" : "0" + e;
                    return e;
                }
                function w(e, t, i) {
                    return "string" == typeof e ? new h(e, t, i) : e && "object" === s(e) && Object.prototype.hasOwnProperty.call(e, "date") ? e : void 0;
                }
                function M(e, t) {
                    return S(t.inputFormat, {
                        date: e
                    }, t);
                }
                function O(e, t) {
                    var i, a, n = 0, r = 0;
                    for(P(t).lastIndex = 0; a = P(t).exec(t.inputFormat);){
                        var o = new RegExp("\\d+$").exec(a[0]);
                        if ((n += r = o ? parseInt(o[0]) : a[0].length) >= e + 1) {
                            i = a, a = P(t).exec(t.inputFormat);
                            break;
                        }
                    }
                    return {
                        targetMatchIndex: n - r,
                        nextMatch: a,
                        targetMatch: i
                    };
                }
                a.default.extendAliases({
                    datetime: {
                        mask: function(e) {
                            return e.numericInput = !1, g.S = e.i18n.ordinalSuffix.join("|"), e.inputFormat = k[e.inputFormat] || e.inputFormat, e.displayFormat = k[e.displayFormat] || e.displayFormat || e.inputFormat, e.outputFormat = k[e.outputFormat] || e.outputFormat || e.inputFormat, e.placeholder = "" !== e.placeholder ? e.placeholder : e.inputFormat.replace(/[[\]]/, ""), e.regex = S(e.inputFormat, void 0, e), e.min = w(e.min, e.inputFormat, e), e.max = w(e.max, e.inputFormat, e), null;
                        },
                        placeholder: "",
                        inputFormat: "isoDateTime",
                        displayFormat: null,
                        outputFormat: null,
                        min: null,
                        max: null,
                        skipOptionalPartCharacter: "",
                        i18n: {
                            dayNames: [
                                "Mon",
                                "Tue",
                                "Wed",
                                "Thu",
                                "Fri",
                                "Sat",
                                "Sun",
                                "Monday",
                                "Tuesday",
                                "Wednesday",
                                "Thursday",
                                "Friday",
                                "Saturday",
                                "Sunday"
                            ],
                            monthNames: [
                                "Jan",
                                "Feb",
                                "Mar",
                                "Apr",
                                "May",
                                "Jun",
                                "Jul",
                                "Aug",
                                "Sep",
                                "Oct",
                                "Nov",
                                "Dec",
                                "January",
                                "February",
                                "March",
                                "April",
                                "May",
                                "June",
                                "July",
                                "August",
                                "September",
                                "October",
                                "November",
                                "December"
                            ],
                            ordinalSuffix: [
                                "st",
                                "nd",
                                "rd",
                                "th"
                            ]
                        },
                        preValidation: function(e, t, i, a, n, r, o, l) {
                            if (l) return !0;
                            if (isNaN(i) && e[t] !== i) {
                                var s = O(t, n);
                                if (s.nextMatch && s.nextMatch[0] === i && s.targetMatch[0].length > 1) {
                                    var u = g[s.targetMatch[0]][0];
                                    if (new RegExp(u).test("0" + e[t - 1])) return e[t] = e[t - 1], e[t - 1] = "0", {
                                        fuzzy: !0,
                                        buffer: e,
                                        refreshFromBuffer: {
                                            start: t - 1,
                                            end: t + 1
                                        },
                                        pos: t + 1
                                    };
                                }
                            }
                            return !0;
                        },
                        postValidation: function(e, t, i, a, n, r, o, s) {
                            var u, c;
                            if (o) return !0;
                            if (!1 === a && (((u = O(t + 1, n)).targetMatch && u.targetMatchIndex === t && u.targetMatch[0].length > 1 && void 0 !== g[u.targetMatch[0]] || (u = O(t + 2, n)).targetMatch && u.targetMatchIndex === t + 1 && u.targetMatch[0].length > 1 && void 0 !== g[u.targetMatch[0]]) && (c = g[u.targetMatch[0]][0]), void 0 !== c && (void 0 !== r.validPositions[t + 1] && new RegExp(c).test(i + "0") ? (e[t] = i, e[t + 1] = "0", a = {
                                pos: t + 2,
                                caret: t
                            }) : new RegExp(c).test("0" + i) && (e[t] = "0", e[t + 1] = i, a = {
                                pos: t + 2
                            })), !1 === a)) return a;
                            if (a.fuzzy && (e = a.buffer, t = a.pos), (u = O(t, n)).targetMatch && u.targetMatch[0] && void 0 !== g[u.targetMatch[0]]) {
                                var f = g[u.targetMatch[0]];
                                c = f[0];
                                var d = e.slice(u.targetMatchIndex, u.targetMatchIndex + u.targetMatch[0].length);
                                if (!1 === new RegExp(c).test(d.join("")) && 2 === u.targetMatch[0].length && r.validPositions[u.targetMatchIndex] && r.validPositions[u.targetMatchIndex + 1] && (r.validPositions[u.targetMatchIndex + 1].input = "0"), "year" == f[2]) for(var p = l.getMaskTemplate.call(this, !1, 1, void 0, !0), h = t + 1; h < e.length; h++)e[h] = p[h], delete r.validPositions[h];
                            }
                            var m = a, k = w(e.join(""), n.inputFormat, n);
                            return m && k.date.getTime() == k.date.getTime() && (n.prefillYear && (m = function(e, t, i) {
                                if (e.year !== e.rawyear) {
                                    var a = v.toString(), n = e.rawyear.replace(/[^0-9]/g, ""), r = a.slice(0, n.length), o = a.slice(n.length);
                                    if (2 === n.length && n === r) {
                                        var l = new Date(v, e.month - 1, e.day);
                                        e.day == l.getDate() && (!i.max || i.max.date.getTime() >= l.getTime()) && (e.date.setFullYear(v), e.year = a, t.insert = [
                                            {
                                                pos: t.pos + 1,
                                                c: o[0]
                                            },
                                            {
                                                pos: t.pos + 2,
                                                c: o[1]
                                            }
                                        ]);
                                    }
                                }
                                return t;
                            }(k, m, n)), m = function(e, t, i, a, n) {
                                if (!t) return t;
                                if (t && i.min && i.min.date.getTime() == i.min.date.getTime()) {
                                    var r;
                                    for(e.reset(), P(i).lastIndex = 0; r = P(i).exec(i.inputFormat);){
                                        var o;
                                        if ((o = x(r)) && o[3]) {
                                            for(var l = o[1], s = e[o[2]], u = i.min[o[2]], c = i.max ? i.max[o[2]] : u, f = [], d = !1, p = 0; p < u.length; p++)void 0 !== a.validPositions[p + r.index] || d ? (f[p] = s[p], d = d || s[p] > u[p]) : (f[p] = u[p], "year" === o[2] && s.length - 1 == p && u != c && (f = (parseInt(f.join("")) + 1).toString().split("")), "ampm" === o[2] && u != c && i.min.date.getTime() > e.date.getTime() && (f[p] = c[p]));
                                            l.call(e._date, f.join(""));
                                        }
                                    }
                                    t = i.min.date.getTime() <= e.date.getTime(), e.reInit();
                                }
                                return t && i.max && i.max.date.getTime() == i.max.date.getTime() && (t = i.max.date.getTime() >= e.date.getTime()), t;
                            }(k, m = E.call(this, k, m, n), n, r)), void 0 !== t && m && a.pos !== t ? {
                                buffer: S(n.inputFormat, k, n).split(""),
                                refreshFromBuffer: {
                                    start: t,
                                    end: a.pos
                                },
                                pos: a.caret || a.pos
                            } : m;
                        },
                        onKeyDown: function(e, t, i, a) {
                            e.ctrlKey && e.keyCode === n.default.RIGHT && (this.inputmask._valueSet(M(new Date, a)), p(this).trigger("setvalue"));
                        },
                        onUnMask: function(e, t, i) {
                            return t ? S(i.outputFormat, w(e, i.inputFormat, i), i, !0) : t;
                        },
                        casing: function(e, t, i, a) {
                            return 0 == t.nativeDef.indexOf("[ap]") ? e.toLowerCase() : 0 == t.nativeDef.indexOf("[AP]") ? e.toUpperCase() : e;
                        },
                        onBeforeMask: function(e, t) {
                            return "[object Date]" === Object.prototype.toString.call(e) && (e = M(e, t)), e;
                        },
                        insertMode: !1,
                        shiftPositions: !1,
                        keepStatic: !1,
                        inputmode: "numeric",
                        prefillYear: !0
                    }
                });
            },
            3851: function(e, t, i) {
                var a, n = (a = i(2394)) && a.__esModule ? a : {
                    default: a
                }, r = i(8711), o = i(4713);
                n.default.extendDefinitions({
                    A: {
                        validator: "[A-Za-z\u0410-\u044F\u0401\u0451\xc0-\xff\xb5]",
                        casing: "upper"
                    },
                    "&": {
                        validator: "[0-9A-Za-z\u0410-\u044F\u0401\u0451\xc0-\xff\xb5]",
                        casing: "upper"
                    },
                    "#": {
                        validator: "[0-9A-Fa-f]",
                        casing: "upper"
                    }
                });
                var l = new RegExp("25[0-5]|2[0-4][0-9]|[01][0-9][0-9]");
                function s(e, t, i, a, n) {
                    return i - 1 > -1 && "." !== t.buffer[i - 1] ? (e = t.buffer[i - 1] + e, e = i - 2 > -1 && "." !== t.buffer[i - 2] ? t.buffer[i - 2] + e : "0" + e) : e = "00" + e, l.test(e);
                }
                n.default.extendAliases({
                    cssunit: {
                        regex: "[+-]?[0-9]+\\.?([0-9]+)?(px|em|rem|ex|%|in|cm|mm|pt|pc)"
                    },
                    url: {
                        regex: "(https?|ftp)://.*",
                        autoUnmask: !1,
                        keepStatic: !1,
                        tabThrough: !0
                    },
                    ip: {
                        mask: "i{1,3}.j{1,3}.k{1,3}.l{1,3}",
                        definitions: {
                            i: {
                                validator: s
                            },
                            j: {
                                validator: s
                            },
                            k: {
                                validator: s
                            },
                            l: {
                                validator: s
                            }
                        },
                        onUnMask: function(e, t, i) {
                            return e;
                        },
                        inputmode: "decimal",
                        substitutes: {
                            ",": "."
                        }
                    },
                    email: {
                        mask: function(e) {
                            var t = "*{1,64}[.*{1,64}][.*{1,64}][.*{1,63}]@-{1,63}.-{1,63}[.-{1,63}][.-{1,63}]", i = t;
                            if (e.separator) for(var a = 0; a < e.quantifier; a++)i += "[".concat(e.separator).concat(t, "]");
                            return i;
                        },
                        greedy: !1,
                        casing: "lower",
                        separator: null,
                        quantifier: 5,
                        skipOptionalPartCharacter: "",
                        onBeforePaste: function(e, t) {
                            return (e = e.toLowerCase()).replace("mailto:", "");
                        },
                        definitions: {
                            "*": {
                                validator: "[0-9\uFF11-\uFF19A-Za-z\u0410-\u044F\u0401\u0451\xc0-\xff\xb5!#$%&'*+/=?^_`{|}~-]"
                            },
                            "-": {
                                validator: "[0-9A-Za-z-]"
                            }
                        },
                        onUnMask: function(e, t, i) {
                            return e;
                        },
                        inputmode: "email"
                    },
                    mac: {
                        mask: "##:##:##:##:##:##"
                    },
                    vin: {
                        mask: "V{13}9{4}",
                        definitions: {
                            V: {
                                validator: "[A-HJ-NPR-Za-hj-npr-z\\d]",
                                casing: "upper"
                            }
                        },
                        clearIncomplete: !0,
                        autoUnmask: !0
                    },
                    ssn: {
                        mask: "999-99-9999",
                        postValidation: function(e, t, i, a, n, l, s) {
                            var u = o.getMaskTemplate.call(this, !0, r.getLastValidPosition.call(this), !0, !0);
                            return /^(?!219-09-9999|078-05-1120)(?!666|000|9.{2}).{3}-(?!00).{2}-(?!0{4}).{4}$/.test(u.join(""));
                        }
                    }
                });
            },
            207: function(e, t, i) {
                var a = l(i(2394)), n = l(i(5581)), r = l(i(7184)), o = i(8711);
                function l(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                var s = a.default.dependencyLib;
                function u(e, t) {
                    for(var i = "", n = 0; n < e.length; n++)a.default.prototype.definitions[e.charAt(n)] || t.definitions[e.charAt(n)] || t.optionalmarker[0] === e.charAt(n) || t.optionalmarker[1] === e.charAt(n) || t.quantifiermarker[0] === e.charAt(n) || t.quantifiermarker[1] === e.charAt(n) || t.groupmarker[0] === e.charAt(n) || t.groupmarker[1] === e.charAt(n) || t.alternatormarker === e.charAt(n) ? i += "\\" + e.charAt(n) : i += e.charAt(n);
                    return i;
                }
                function c(e, t, i, a) {
                    if (e.length > 0 && t > 0 && (!i.digitsOptional || a)) {
                        var n = e.indexOf(i.radixPoint), r = !1;
                        i.negationSymbol.back === e[e.length - 1] && (r = !0, e.length--), -1 === n && (e.push(i.radixPoint), n = e.length - 1);
                        for(var o = 1; o <= t; o++)isFinite(e[n + o]) || (e[n + o] = "0");
                    }
                    return r && e.push(i.negationSymbol.back), e;
                }
                function f(e, t) {
                    var i = 0;
                    if ("+" === e) {
                        for(i in t.validPositions);
                        i = o.seekNext.call(this, parseInt(i));
                    }
                    for(var a in t.tests)if ((a = parseInt(a)) >= i) {
                        for(var n = 0, r = t.tests[a].length; n < r; n++)if ((void 0 === t.validPositions[a] || "-" === e) && t.tests[a][n].match.def === e) return a + (void 0 !== t.validPositions[a] && "-" !== e ? 1 : 0);
                    }
                    return i;
                }
                function d(e, t) {
                    var i = -1;
                    for(var a in t.validPositions){
                        var n = t.validPositions[a];
                        if (n && n.match.def === e) {
                            i = parseInt(a);
                            break;
                        }
                    }
                    return i;
                }
                function p(e, t, i, a, n) {
                    var r = t.buffer ? t.buffer.indexOf(n.radixPoint) : -1, o = (-1 !== r || a && n.jitMasking) && new RegExp(n.definitions[9].validator).test(e);
                    return n._radixDance && -1 !== r && o && null == t.validPositions[r] ? {
                        insert: {
                            pos: r === i ? r + 1 : r,
                            c: n.radixPoint
                        },
                        pos: i
                    } : o;
                }
                a.default.extendAliases({
                    numeric: {
                        mask: function(e) {
                            e.repeat = 0, e.groupSeparator === e.radixPoint && e.digits && "0" !== e.digits && ("." === e.radixPoint ? e.groupSeparator = "," : "," === e.radixPoint ? e.groupSeparator = "." : e.groupSeparator = ""), " " === e.groupSeparator && (e.skipOptionalPartCharacter = void 0), e.placeholder.length > 1 && (e.placeholder = e.placeholder.charAt(0)), "radixFocus" === e.positionCaretOnClick && "" === e.placeholder && (e.positionCaretOnClick = "lvp");
                            var t = "0", i = e.radixPoint;
                            !0 === e.numericInput && void 0 === e.__financeInput ? (t = "1", e.positionCaretOnClick = "radixFocus" === e.positionCaretOnClick ? "lvp" : e.positionCaretOnClick, e.digitsOptional = !1, isNaN(e.digits) && (e.digits = 2), e._radixDance = !1, i = "," === e.radixPoint ? "?" : "!", "" !== e.radixPoint && void 0 === e.definitions[i] && (e.definitions[i] = {}, e.definitions[i].validator = "[" + e.radixPoint + "]", e.definitions[i].placeholder = e.radixPoint, e.definitions[i].static = !0, e.definitions[i].generated = !0)) : (e.__financeInput = !1, e.numericInput = !0);
                            var a, n = "[+]";
                            if (n += u(e.prefix, e), "" !== e.groupSeparator ? (void 0 === e.definitions[e.groupSeparator] && (e.definitions[e.groupSeparator] = {}, e.definitions[e.groupSeparator].validator = "[" + e.groupSeparator + "]", e.definitions[e.groupSeparator].placeholder = e.groupSeparator, e.definitions[e.groupSeparator].static = !0, e.definitions[e.groupSeparator].generated = !0), n += e._mask(e)) : n += "9{+}", void 0 !== e.digits && 0 !== e.digits) {
                                var o = e.digits.toString().split(",");
                                isFinite(o[0]) && o[1] && isFinite(o[1]) ? n += i + t + "{" + e.digits + "}" : (isNaN(e.digits) || parseInt(e.digits) > 0) && (e.digitsOptional || e.jitMasking ? (a = n + i + t + "{0," + e.digits + "}", e.keepStatic = !0) : n += i + t + "{" + e.digits + "}");
                            } else e.inputmode = "numeric";
                            return n += u(e.suffix, e), n += "[-]", a && (n = [
                                a + u(e.suffix, e) + "[-]",
                                n
                            ]), e.greedy = !1, function(e) {
                                void 0 === e.parseMinMaxOptions && (null !== e.min && (e.min = e.min.toString().replace(new RegExp((0, r.default)(e.groupSeparator), "g"), ""), "," === e.radixPoint && (e.min = e.min.replace(e.radixPoint, ".")), e.min = isFinite(e.min) ? parseFloat(e.min) : NaN, isNaN(e.min) && (e.min = Number.MIN_VALUE)), null !== e.max && (e.max = e.max.toString().replace(new RegExp((0, r.default)(e.groupSeparator), "g"), ""), "," === e.radixPoint && (e.max = e.max.replace(e.radixPoint, ".")), e.max = isFinite(e.max) ? parseFloat(e.max) : NaN, isNaN(e.max) && (e.max = Number.MAX_VALUE)), e.parseMinMaxOptions = "done");
                            }(e), "" !== e.radixPoint && (e.substitutes["." == e.radixPoint ? "," : "."] = e.radixPoint), n;
                        },
                        _mask: function(e) {
                            return "(" + e.groupSeparator + "999){+|1}";
                        },
                        digits: "*",
                        digitsOptional: !0,
                        enforceDigitsOnBlur: !1,
                        radixPoint: ".",
                        positionCaretOnClick: "radixFocus",
                        _radixDance: !0,
                        groupSeparator: "",
                        allowMinus: !0,
                        negationSymbol: {
                            front: "-",
                            back: ""
                        },
                        prefix: "",
                        suffix: "",
                        min: null,
                        max: null,
                        SetMaxOnOverflow: !1,
                        step: 1,
                        inputType: "text",
                        unmaskAsNumber: !1,
                        roundingFN: Math.round,
                        inputmode: "decimal",
                        shortcuts: {
                            k: "1000",
                            m: "1000000"
                        },
                        placeholder: "0",
                        greedy: !1,
                        rightAlign: !0,
                        insertMode: !0,
                        autoUnmask: !1,
                        skipOptionalPartCharacter: "",
                        usePrototypeDefinitions: !1,
                        stripLeadingZeroes: !0,
                        definitions: {
                            0: {
                                validator: p
                            },
                            1: {
                                validator: p,
                                definitionSymbol: "9"
                            },
                            9: {
                                validator: "[0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9]",
                                definitionSymbol: "*"
                            },
                            "+": {
                                validator: function(e, t, i, a, n) {
                                    return n.allowMinus && ("-" === e || e === n.negationSymbol.front);
                                }
                            },
                            "-": {
                                validator: function(e, t, i, a, n) {
                                    return n.allowMinus && e === n.negationSymbol.back;
                                }
                            }
                        },
                        preValidation: function(e, t, i, a, n, r, o, l) {
                            if (!1 !== n.__financeInput && i === n.radixPoint) return !1;
                            var s = e.indexOf(n.radixPoint), u = t;
                            if (t = function(e, t, i, a, n) {
                                return n._radixDance && n.numericInput && t !== n.negationSymbol.back && e <= i && (i > 0 || t == n.radixPoint) && (void 0 === a.validPositions[e - 1] || a.validPositions[e - 1].input !== n.negationSymbol.back) && (e -= 1), e;
                            }(t, i, s, r, n), "-" === i || i === n.negationSymbol.front) {
                                if (!0 !== n.allowMinus) return !1;
                                var c = !1, p = d("+", r), h = d("-", r);
                                return -1 !== p && (c = [
                                    p,
                                    h
                                ]), !1 !== c ? {
                                    remove: c,
                                    caret: u - n.negationSymbol.back.length
                                } : {
                                    insert: [
                                        {
                                            pos: f.call(this, "+", r),
                                            c: n.negationSymbol.front,
                                            fromIsValid: !0
                                        },
                                        {
                                            pos: f.call(this, "-", r),
                                            c: n.negationSymbol.back,
                                            fromIsValid: void 0
                                        }
                                    ],
                                    caret: u + n.negationSymbol.back.length
                                };
                            }
                            if (i === n.groupSeparator) return {
                                caret: u
                            };
                            if (l) return !0;
                            if (-1 !== s && !0 === n._radixDance && !1 === a && i === n.radixPoint && void 0 !== n.digits && (isNaN(n.digits) || parseInt(n.digits) > 0) && s !== t) return {
                                caret: n._radixDance && t === s - 1 ? s + 1 : s
                            };
                            if (!1 === n.__financeInput) {
                                if (a) {
                                    if (n.digitsOptional) return {
                                        rewritePosition: o.end
                                    };
                                    if (!n.digitsOptional) {
                                        if (o.begin > s && o.end <= s) return i === n.radixPoint ? {
                                            insert: {
                                                pos: s + 1,
                                                c: "0",
                                                fromIsValid: !0
                                            },
                                            rewritePosition: s
                                        } : {
                                            rewritePosition: s + 1
                                        };
                                        if (o.begin < s) return {
                                            rewritePosition: o.begin - 1
                                        };
                                    }
                                } else if (!n.showMaskOnHover && !n.showMaskOnFocus && !n.digitsOptional && n.digits > 0 && "" === this.__valueGet.call(this.el)) return {
                                    rewritePosition: s
                                };
                            }
                            return {
                                rewritePosition: t
                            };
                        },
                        postValidation: function(e, t, i, a, n, r, o) {
                            if (!1 === a) return a;
                            if (o) return !0;
                            if (null !== n.min || null !== n.max) {
                                var l = n.onUnMask(e.slice().reverse().join(""), void 0, s.extend({}, n, {
                                    unmaskAsNumber: !0
                                }));
                                if (null !== n.min && l < n.min && (l.toString().length > n.min.toString().length || l < 0)) return !1;
                                if (null !== n.max && l > n.max) return !!n.SetMaxOnOverflow && {
                                    refreshFromBuffer: !0,
                                    buffer: c(n.max.toString().replace(".", n.radixPoint).split(""), n.digits, n).reverse()
                                };
                            }
                            return a;
                        },
                        onUnMask: function(e, t, i) {
                            if ("" === t && !0 === i.nullable) return t;
                            var a = e.replace(i.prefix, "");
                            return a = (a = a.replace(i.suffix, "")).replace(new RegExp((0, r.default)(i.groupSeparator), "g"), ""), "" !== i.placeholder.charAt(0) && (a = a.replace(new RegExp(i.placeholder.charAt(0), "g"), "0")), i.unmaskAsNumber ? ("" !== i.radixPoint && -1 !== a.indexOf(i.radixPoint) && (a = a.replace(r.default.call(this, i.radixPoint), ".")), a = (a = a.replace(new RegExp("^" + (0, r.default)(i.negationSymbol.front)), "-")).replace(new RegExp((0, r.default)(i.negationSymbol.back) + "$"), ""), Number(a)) : a;
                        },
                        isComplete: function(e, t) {
                            var i = (t.numericInput ? e.slice().reverse() : e).join("");
                            return i = (i = (i = (i = (i = i.replace(new RegExp("^" + (0, r.default)(t.negationSymbol.front)), "-")).replace(new RegExp((0, r.default)(t.negationSymbol.back) + "$"), "")).replace(t.prefix, "")).replace(t.suffix, "")).replace(new RegExp((0, r.default)(t.groupSeparator) + "([0-9]{3})", "g"), "$1"), "," === t.radixPoint && (i = i.replace((0, r.default)(t.radixPoint), ".")), isFinite(i);
                        },
                        onBeforeMask: function(e, t) {
                            var i = t.radixPoint || ",";
                            isFinite(t.digits) && (t.digits = parseInt(t.digits)), "number" != typeof e && "number" !== t.inputType || "" === i || (e = e.toString().replace(".", i));
                            var a = "-" === e.charAt(0) || e.charAt(0) === t.negationSymbol.front, n = e.split(i), o = n[0].replace(/[^\-0-9]/g, ""), l = n.length > 1 ? n[1].replace(/[^0-9]/g, "") : "", s = n.length > 1;
                            e = o + ("" !== l ? i + l : l);
                            var u = 0;
                            if ("" !== i && (u = t.digitsOptional ? t.digits < l.length ? t.digits : l.length : t.digits, "" !== l || !t.digitsOptional)) {
                                var f = Math.pow(10, u || 1);
                                e = e.replace((0, r.default)(i), "."), isNaN(parseFloat(e)) || (e = (t.roundingFN(parseFloat(e) * f) / f).toFixed(u)), e = e.toString().replace(".", i);
                            }
                            if (0 === t.digits && -1 !== e.indexOf(i) && (e = e.substring(0, e.indexOf(i))), null !== t.min || null !== t.max) {
                                var d = e.toString().replace(i, ".");
                                null !== t.min && d < t.min ? e = t.min.toString().replace(".", i) : null !== t.max && d > t.max && (e = t.max.toString().replace(".", i));
                            }
                            return a && "-" !== e.charAt(0) && (e = "-" + e), c(e.toString().split(""), u, t, s).join("");
                        },
                        onBeforeWrite: function(e, t, i, a) {
                            function n(e, t) {
                                if (!1 !== a.__financeInput || t) {
                                    var i = e.indexOf(a.radixPoint);
                                    -1 !== i && e.splice(i, 1);
                                }
                                if ("" !== a.groupSeparator) for(; -1 !== (i = e.indexOf(a.groupSeparator));)e.splice(i, 1);
                                return e;
                            }
                            var o, l;
                            if (a.stripLeadingZeroes && (l = function(e, t) {
                                var i = new RegExp("(^" + ("" !== t.negationSymbol.front ? (0, r.default)(t.negationSymbol.front) + "?" : "") + (0, r.default)(t.prefix) + ")(.*)(" + (0, r.default)(t.suffix) + ("" != t.negationSymbol.back ? (0, r.default)(t.negationSymbol.back) + "?" : "") + "$)").exec(e.slice().reverse().join("")), a = i ? i[2] : "", n = !1;
                                return a && (a = a.split(t.radixPoint.charAt(0))[0], n = new RegExp("^[0" + t.groupSeparator + "]*").exec(a)), !(!n || !(n[0].length > 1 || n[0].length > 0 && n[0].length < a.length)) && n;
                            }(t, a))) for(var u = t.join("").lastIndexOf(l[0].split("").reverse().join("")) - (l[0] == l.input ? 0 : 1), f = l[0] == l.input ? 1 : 0, d = l[0].length - f; d > 0; d--)delete this.maskset.validPositions[u + d], delete t[u + d];
                            if (e) switch(e.type){
                                case "blur":
                                case "checkval":
                                    if (null !== a.min) {
                                        var p = a.onUnMask(t.slice().reverse().join(""), void 0, s.extend({}, a, {
                                            unmaskAsNumber: !0
                                        }));
                                        if (null !== a.min && p < a.min) return {
                                            refreshFromBuffer: !0,
                                            buffer: c(a.min.toString().replace(".", a.radixPoint).split(""), a.digits, a).reverse()
                                        };
                                    }
                                    if (t[t.length - 1] === a.negationSymbol.front) {
                                        var h = new RegExp("(^" + ("" != a.negationSymbol.front ? (0, r.default)(a.negationSymbol.front) + "?" : "") + (0, r.default)(a.prefix) + ")(.*)(" + (0, r.default)(a.suffix) + ("" != a.negationSymbol.back ? (0, r.default)(a.negationSymbol.back) + "?" : "") + "$)").exec(n(t.slice(), !0).reverse().join(""));
                                        0 == (h ? h[2] : "") && (o = {
                                            refreshFromBuffer: !0,
                                            buffer: [
                                                0
                                            ]
                                        });
                                    } else if ("" !== a.radixPoint) t.indexOf(a.radixPoint) === a.suffix.length && (o && o.buffer ? o.buffer.splice(0, 1 + a.suffix.length) : (t.splice(0, 1 + a.suffix.length), o = {
                                        refreshFromBuffer: !0,
                                        buffer: n(t)
                                    }));
                                    if (a.enforceDigitsOnBlur) {
                                        var v = (o = o || {}, o.buffer) || t.slice().reverse();
                                        o.refreshFromBuffer = !0, o.buffer = c(v, a.digits, a, !0).reverse();
                                    }
                            }
                            return o;
                        },
                        onKeyDown: function(e, t, i, a) {
                            var r, o, l = s(this), u = String.fromCharCode(e.keyCode).toLowerCase();
                            if ((o = a.shortcuts && a.shortcuts[u]) && o.length > 1) return this.inputmask.__valueSet.call(this, parseFloat(this.inputmask.unmaskedvalue()) * parseInt(o)), l.trigger("setvalue"), !1;
                            if (e.ctrlKey) switch(e.keyCode){
                                case n.default.UP:
                                    return this.inputmask.__valueSet.call(this, parseFloat(this.inputmask.unmaskedvalue()) + parseInt(a.step)), l.trigger("setvalue"), !1;
                                case n.default.DOWN:
                                    return this.inputmask.__valueSet.call(this, parseFloat(this.inputmask.unmaskedvalue()) - parseInt(a.step)), l.trigger("setvalue"), !1;
                            }
                            if (!e.shiftKey && (e.keyCode === n.default.DELETE || e.keyCode === n.default.BACKSPACE || e.keyCode === n.default.BACKSPACE_SAFARI) && i.begin !== t.length) {
                                if (t[e.keyCode === n.default.DELETE ? i.begin - 1 : i.end] === a.negationSymbol.front) return r = t.slice().reverse(), "" !== a.negationSymbol.front && r.shift(), "" !== a.negationSymbol.back && r.pop(), l.trigger("setvalue", [
                                    r.join(""),
                                    i.begin
                                ]), !1;
                                if (!0 === a._radixDance) {
                                    var f = t.indexOf(a.radixPoint);
                                    if (a.digitsOptional) {
                                        if (0 === f) return (r = t.slice().reverse()).pop(), l.trigger("setvalue", [
                                            r.join(""),
                                            i.begin >= r.length ? r.length : i.begin
                                        ]), !1;
                                    } else if (-1 !== f && (i.begin < f || i.end < f || e.keyCode === n.default.DELETE && i.begin === f)) return i.begin !== i.end || e.keyCode !== n.default.BACKSPACE && e.keyCode !== n.default.BACKSPACE_SAFARI || i.begin++, (r = t.slice().reverse()).splice(r.length - i.begin, i.begin - i.end + 1), r = c(r, a.digits, a).join(""), l.trigger("setvalue", [
                                        r,
                                        i.begin >= r.length ? f + 1 : i.begin
                                    ]), !1;
                                }
                            }
                        }
                    },
                    currency: {
                        prefix: "",
                        groupSeparator: ",",
                        alias: "numeric",
                        digits: 2,
                        digitsOptional: !1
                    },
                    decimal: {
                        alias: "numeric"
                    },
                    integer: {
                        alias: "numeric",
                        inputmode: "numeric",
                        digits: 0
                    },
                    percentage: {
                        alias: "numeric",
                        min: 0,
                        max: 100,
                        suffix: " %",
                        digits: 0,
                        allowMinus: !1
                    },
                    indianns: {
                        alias: "numeric",
                        _mask: function(e) {
                            return "(" + e.groupSeparator + "99){*|1}(" + e.groupSeparator + "999){1|1}";
                        },
                        groupSeparator: ",",
                        radixPoint: ".",
                        placeholder: "0",
                        digits: 2,
                        digitsOptional: !1
                    }
                });
            },
            9380: function(e, t, i) {
                var a;
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0;
                var n = ((a = i(8741)) && a.__esModule ? a : {
                    default: a
                }).default ? window : {};
                t.default = n;
            },
            7760: function(e, t, i) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.HandleNativePlaceholder = function(e, t) {
                    var i = e ? e.inputmask : this;
                    if (s.ie) {
                        if (e.inputmask._valueGet() !== t && (e.placeholder !== t || "" === e.placeholder)) {
                            var a = o.getBuffer.call(i).slice(), n = e.inputmask._valueGet();
                            if (n !== t) {
                                var r = o.getLastValidPosition.call(i);
                                -1 === r && n === o.getBufferTemplate.call(i).join("") ? a = [] : -1 !== r && f.call(i, a), p(e, a);
                            }
                        }
                    } else e.placeholder !== t && (e.placeholder = t, "" === e.placeholder && e.removeAttribute("placeholder"));
                }, t.applyInputValue = c, t.checkVal = d, t.clearOptionalTail = f, t.unmaskedvalue = function(e) {
                    var t = e ? e.inputmask : this, i = t.opts, a = t.maskset;
                    if (e) {
                        if (void 0 === e.inputmask) return e.value;
                        e.inputmask && e.inputmask.refreshValue && c(e, e.inputmask._valueGet(!0));
                    }
                    var n = [], r = a.validPositions;
                    for(var l in r)r[l] && r[l].match && (1 != r[l].match.static || Array.isArray(a.metadata) && !0 !== r[l].generatedInput) && n.push(r[l].input);
                    var s = 0 === n.length ? "" : (t.isRTL ? n.reverse() : n).join("");
                    if ("function" == typeof i.onUnMask) {
                        var u = (t.isRTL ? o.getBuffer.call(t).slice().reverse() : o.getBuffer.call(t)).join("");
                        s = i.onUnMask.call(t, u, s, i);
                    }
                    return s;
                }, t.writeBuffer = p;
                var a, n = (a = i(5581)) && a.__esModule ? a : {
                    default: a
                }, r = i(4713), o = i(8711), l = i(7215), s = i(9845), u = i(6030);
                function c(e, t) {
                    var i = e ? e.inputmask : this, a = i.opts;
                    e.inputmask.refreshValue = !1, "function" == typeof a.onBeforeMask && (t = a.onBeforeMask.call(i, t, a) || t), d(e, !0, !1, t = t.toString().split("")), i.undoValue = i._valueGet(!0), (a.clearMaskOnLostFocus || a.clearIncomplete) && e.inputmask._valueGet() === o.getBufferTemplate.call(i).join("") && -1 === o.getLastValidPosition.call(i) && e.inputmask._valueSet("");
                }
                function f(e) {
                    e.length = 0;
                    for(var t, i = r.getMaskTemplate.call(this, !0, 0, !0, void 0, !0); void 0 !== (t = i.shift());)e.push(t);
                    return e;
                }
                function d(e, t, i, a, n) {
                    var s = e ? e.inputmask : this, c = s.maskset, f = s.opts, d = s.dependencyLib, h = a.slice(), v = "", m = -1, g = void 0, k = f.skipOptionalPartCharacter;
                    f.skipOptionalPartCharacter = "", o.resetMaskSet.call(s), c.tests = {}, m = f.radixPoint ? o.determineNewCaretPosition.call(s, {
                        begin: 0,
                        end: 0
                    }, !1, !1 === f.__financeInput ? "radixFocus" : void 0).begin : 0, c.p = m, s.caretPos = {
                        begin: m
                    };
                    var y = [], b = s.caretPos;
                    if (h.forEach(function(e, t) {
                        if (void 0 !== e) {
                            var a = new d.Event("_checkval");
                            a.keyCode = e.toString().charCodeAt(0), v += e;
                            var n = o.getLastValidPosition.call(s, void 0, !0);
                            !function(e, t) {
                                for(var i = r.getMaskTemplate.call(s, !0, 0).slice(e, o.seekNext.call(s, e, !1, !1)).join("").replace(/'/g, ""), a = i.indexOf(t); a > 0 && " " === i[a - 1];)a--;
                                var n = 0 === a && !o.isMask.call(s, e) && (r.getTest.call(s, e).match.nativeDef === t.charAt(0) || !0 === r.getTest.call(s, e).match.static && r.getTest.call(s, e).match.nativeDef === "'" + t.charAt(0) || " " === r.getTest.call(s, e).match.nativeDef && (r.getTest.call(s, e + 1).match.nativeDef === t.charAt(0) || !0 === r.getTest.call(s, e + 1).match.static && r.getTest.call(s, e + 1).match.nativeDef === "'" + t.charAt(0)));
                                if (!n && a > 0 && !o.isMask.call(s, e, !1, !0)) {
                                    var l = o.seekNext.call(s, e);
                                    s.caretPos.begin < l && (s.caretPos = {
                                        begin: l
                                    });
                                }
                                return n;
                            }(m, v) ? (g = u.EventHandlers.keypressEvent.call(s, a, !0, !1, i, s.caretPos.begin)) && (m = s.caretPos.begin + 1, v = "") : g = u.EventHandlers.keypressEvent.call(s, a, !0, !1, i, n + 1), g ? (void 0 !== g.pos && c.validPositions[g.pos] && !0 === c.validPositions[g.pos].match.static && void 0 === c.validPositions[g.pos].alternation && (y.push(g.pos), s.isRTL || (g.forwardPosition = g.pos + 1)), p.call(s, void 0, o.getBuffer.call(s), g.forwardPosition, a, !1), s.caretPos = {
                                begin: g.forwardPosition,
                                end: g.forwardPosition
                            }, b = s.caretPos) : void 0 === c.validPositions[t] && h[t] === r.getPlaceholder.call(s, t) && o.isMask.call(s, t, !0) ? s.caretPos.begin++ : s.caretPos = b;
                        }
                    }), y.length > 0) {
                        var x, P, E = o.seekNext.call(s, -1, void 0, !1);
                        if (!l.isComplete.call(s, o.getBuffer.call(s)) && y.length <= E || l.isComplete.call(s, o.getBuffer.call(s)) && y.length > 0 && y.length !== E && 0 === y[0]) for(var S = E; void 0 !== (x = y.shift());){
                            var _ = new d.Event("_checkval");
                            if ((P = c.validPositions[x]).generatedInput = !0, _.keyCode = P.input.charCodeAt(0), (g = u.EventHandlers.keypressEvent.call(s, _, !0, !1, i, S)) && void 0 !== g.pos && g.pos !== x && c.validPositions[g.pos] && !0 === c.validPositions[g.pos].match.static) y.push(g.pos);
                            else if (!g) break;
                            S++;
                        }
                    }
                    t && p.call(s, e, o.getBuffer.call(s), g ? g.forwardPosition : s.caretPos.begin, n || new d.Event("checkval"), n && ("input" === n.type && s.undoValue !== o.getBuffer.call(s).join("") || "paste" === n.type)), f.skipOptionalPartCharacter = k;
                }
                function p(e, t, i, a, r) {
                    var s = e ? e.inputmask : this, u = s.opts, c = s.dependencyLib;
                    if (a && "function" == typeof u.onBeforeWrite) {
                        var f = u.onBeforeWrite.call(s, a, t, i, u);
                        if (f) {
                            if (f.refreshFromBuffer) {
                                var d = f.refreshFromBuffer;
                                l.refreshFromBuffer.call(s, !0 === d ? d : d.start, d.end, f.buffer || t), t = o.getBuffer.call(s, !0);
                            }
                            void 0 !== i && (i = void 0 !== f.caret ? f.caret : i);
                        }
                    }
                    if (void 0 !== e && (e.inputmask._valueSet(t.join("")), void 0 === i || void 0 !== a && "blur" === a.type || o.caret.call(s, e, i, void 0, void 0, void 0 !== a && "keydown" === a.type && (a.keyCode === n.default.DELETE || a.keyCode === n.default.BACKSPACE)), !0 === r)) {
                        var p = c(e), h = e.inputmask._valueGet();
                        e.inputmask.skipInputEvent = !0, p.trigger("input"), setTimeout(function() {
                            h === o.getBufferTemplate.call(s).join("") ? p.trigger("cleared") : !0 === l.isComplete.call(s, t) && p.trigger("complete");
                        }, 0);
                    }
                }
            },
            2394: function(e, t, i) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = void 0, i(7149), i(3194);
                var a = i(157), n = m(i(4963)), r = m(i(9380)), o = i(2391), l = i(4713), s = i(8711), u = i(7215), c = i(7760), f = i(9716), d = m(i(7392)), p = m(i(3976)), h = m(i(8741));
                function v(e) {
                    return v = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, v(e);
                }
                function m(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                var g = r.default.document, k = "_inputmask_opts";
                function y(e, t, i) {
                    if (h.default) {
                        if (!(this instanceof y)) return new y(e, t, i);
                        this.dependencyLib = n.default, this.el = void 0, this.events = {}, this.maskset = void 0, !0 !== i && ("[object Object]" === Object.prototype.toString.call(e) ? t = e : (t = t || {}, e && (t.alias = e)), this.opts = n.default.extend(!0, {}, this.defaults, t), this.noMasksCache = t && void 0 !== t.definitions, this.userOptions = t || {}, b(this.opts.alias, t, this.opts)), this.refreshValue = !1, this.undoValue = void 0, this.$el = void 0, this.skipKeyPressEvent = !1, this.skipInputEvent = !1, this.validationEvent = !1, this.ignorable = !1, this.maxLength, this.mouseEnter = !1, this.originalPlaceholder = void 0, this.isComposing = !1;
                    }
                }
                function b(e, t, i) {
                    var a = y.prototype.aliases[e];
                    return a ? (a.alias && b(a.alias, void 0, i), n.default.extend(!0, i, a), n.default.extend(!0, i, t), !0) : (null === i.mask && (i.mask = e), !1);
                }
                y.prototype = {
                    dataAttribute: "data-inputmask",
                    defaults: p.default,
                    definitions: d.default,
                    aliases: {},
                    masksCache: {},
                    get isRTL () {
                        return this.opts.isRTL || this.opts.numericInput;
                    },
                    mask: function(e) {
                        var t = this;
                        return "string" == typeof e && (e = g.getElementById(e) || g.querySelectorAll(e)), (e = e.nodeName ? [
                            e
                        ] : Array.isArray(e) ? e : Array.from(e)).forEach(function(e, i) {
                            var l = n.default.extend(!0, {}, t.opts);
                            if (function(e, t, i, a) {
                                function o(t, n) {
                                    var o = "" === a ? t : a + "-" + t;
                                    null !== (n = void 0 !== n ? n : e.getAttribute(o)) && ("string" == typeof n && (0 === t.indexOf("on") ? n = r.default[n] : "false" === n ? n = !1 : "true" === n && (n = !0)), i[t] = n);
                                }
                                if (!0 === t.importDataAttributes) {
                                    var l, s, u, c, f = e.getAttribute(a);
                                    if (f && "" !== f && (f = f.replace(/'/g, '"'), s = JSON.parse("{" + f + "}")), s) {
                                        for(c in u = void 0, s)if ("alias" === c.toLowerCase()) {
                                            u = s[c];
                                            break;
                                        }
                                    }
                                    for(l in o("alias", u), i.alias && b(i.alias, i, t), t){
                                        if (s) {
                                            for(c in u = void 0, s)if (c.toLowerCase() === l.toLowerCase()) {
                                                u = s[c];
                                                break;
                                            }
                                        }
                                        o(l, u);
                                    }
                                }
                                n.default.extend(!0, t, i), ("rtl" === e.dir || t.rightAlign) && (e.style.textAlign = "right");
                                ("rtl" === e.dir || t.numericInput) && (e.dir = "ltr", e.removeAttribute("dir"), t.isRTL = !0);
                                return Object.keys(i).length;
                            }(e, l, n.default.extend(!0, {}, t.userOptions), t.dataAttribute)) {
                                var s = (0, o.generateMaskSet)(l, t.noMasksCache);
                                void 0 !== s && (void 0 !== e.inputmask && (e.inputmask.opts.autoUnmask = !0, e.inputmask.remove()), e.inputmask = new y(void 0, void 0, !0), e.inputmask.opts = l, e.inputmask.noMasksCache = t.noMasksCache, e.inputmask.userOptions = n.default.extend(!0, {}, t.userOptions), e.inputmask.el = e, e.inputmask.$el = (0, n.default)(e), e.inputmask.maskset = s, n.default.data(e, k, t.userOptions), a.mask.call(e.inputmask));
                            }
                        }), e && e[0] && e[0].inputmask || this;
                    },
                    option: function(e, t) {
                        return "string" == typeof e ? this.opts[e] : "object" === v(e) ? (n.default.extend(this.userOptions, e), this.el && !0 !== t && this.mask(this.el), this) : void 0;
                    },
                    unmaskedvalue: function(e) {
                        if (this.maskset = this.maskset || (0, o.generateMaskSet)(this.opts, this.noMasksCache), void 0 === this.el || void 0 !== e) {
                            var t = ("function" == typeof this.opts.onBeforeMask && this.opts.onBeforeMask.call(this, e, this.opts) || e).split("");
                            c.checkVal.call(this, void 0, !1, !1, t), "function" == typeof this.opts.onBeforeWrite && this.opts.onBeforeWrite.call(this, void 0, s.getBuffer.call(this), 0, this.opts);
                        }
                        return c.unmaskedvalue.call(this, this.el);
                    },
                    remove: function() {
                        if (this.el) {
                            n.default.data(this.el, k, null);
                            var e = this.opts.autoUnmask ? (0, c.unmaskedvalue)(this.el) : this._valueGet(this.opts.autoUnmask);
                            e !== s.getBufferTemplate.call(this).join("") ? this._valueSet(e, this.opts.autoUnmask) : this._valueSet(""), f.EventRuler.off(this.el), Object.getOwnPropertyDescriptor && Object.getPrototypeOf ? Object.getOwnPropertyDescriptor(Object.getPrototypeOf(this.el), "value") && this.__valueGet && Object.defineProperty(this.el, "value", {
                                get: this.__valueGet,
                                set: this.__valueSet,
                                configurable: !0
                            }) : g.__lookupGetter__ && this.el.__lookupGetter__("value") && this.__valueGet && (this.el.__defineGetter__("value", this.__valueGet), this.el.__defineSetter__("value", this.__valueSet)), this.el.inputmask = void 0;
                        }
                        return this.el;
                    },
                    getemptymask: function() {
                        return this.maskset = this.maskset || (0, o.generateMaskSet)(this.opts, this.noMasksCache), s.getBufferTemplate.call(this).join("");
                    },
                    hasMaskedValue: function() {
                        return !this.opts.autoUnmask;
                    },
                    isComplete: function() {
                        return this.maskset = this.maskset || (0, o.generateMaskSet)(this.opts, this.noMasksCache), u.isComplete.call(this, s.getBuffer.call(this));
                    },
                    getmetadata: function() {
                        if (this.maskset = this.maskset || (0, o.generateMaskSet)(this.opts, this.noMasksCache), Array.isArray(this.maskset.metadata)) {
                            var e = l.getMaskTemplate.call(this, !0, 0, !1).join("");
                            return this.maskset.metadata.forEach(function(t) {
                                return t.mask !== e || (e = t, !1);
                            }), e;
                        }
                        return this.maskset.metadata;
                    },
                    isValid: function(e) {
                        if (this.maskset = this.maskset || (0, o.generateMaskSet)(this.opts, this.noMasksCache), e) {
                            var t = ("function" == typeof this.opts.onBeforeMask && this.opts.onBeforeMask.call(this, e, this.opts) || e).split("");
                            c.checkVal.call(this, void 0, !0, !1, t);
                        } else e = this.isRTL ? s.getBuffer.call(this).slice().reverse().join("") : s.getBuffer.call(this).join("");
                        for(var i = s.getBuffer.call(this), a = s.determineLastRequiredPosition.call(this), n = i.length - 1; n > a && !s.isMask.call(this, n); n--);
                        return i.splice(a, n + 1 - a), u.isComplete.call(this, i) && e === (this.isRTL ? s.getBuffer.call(this).slice().reverse().join("") : s.getBuffer.call(this).join(""));
                    },
                    format: function(e, t) {
                        this.maskset = this.maskset || (0, o.generateMaskSet)(this.opts, this.noMasksCache);
                        var i = ("function" == typeof this.opts.onBeforeMask && this.opts.onBeforeMask.call(this, e, this.opts) || e).split("");
                        c.checkVal.call(this, void 0, !0, !1, i);
                        var a = this.isRTL ? s.getBuffer.call(this).slice().reverse().join("") : s.getBuffer.call(this).join("");
                        return t ? {
                            value: a,
                            metadata: this.getmetadata()
                        } : a;
                    },
                    setValue: function(e) {
                        this.el && (0, n.default)(this.el).trigger("setvalue", [
                            e
                        ]);
                    },
                    analyseMask: o.analyseMask
                }, y.extendDefaults = function(e) {
                    n.default.extend(!0, y.prototype.defaults, e);
                }, y.extendDefinitions = function(e) {
                    n.default.extend(!0, y.prototype.definitions, e);
                }, y.extendAliases = function(e) {
                    n.default.extend(!0, y.prototype.aliases, e);
                }, y.format = function(e, t, i) {
                    return y(t).format(e, i);
                }, y.unmask = function(e, t) {
                    return y(t).unmaskedvalue(e);
                }, y.isValid = function(e, t) {
                    return y(t).isValid(e);
                }, y.remove = function(e) {
                    "string" == typeof e && (e = g.getElementById(e) || g.querySelectorAll(e)), (e = e.nodeName ? [
                        e
                    ] : e).forEach(function(e) {
                        e.inputmask && e.inputmask.remove();
                    });
                }, y.setValue = function(e, t) {
                    "string" == typeof e && (e = g.getElementById(e) || g.querySelectorAll(e)), (e = e.nodeName ? [
                        e
                    ] : e).forEach(function(e) {
                        e.inputmask ? e.inputmask.setValue(t) : (0, n.default)(e).trigger("setvalue", [
                            t
                        ]);
                    });
                }, y.dependencyLib = n.default, r.default.Inputmask = y;
                var x = y;
                t.default = x;
            },
            5296: function(e, t, i) {
                function a(e) {
                    return a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, a(e);
                }
                var n = h(i(9380)), r = h(i(2394)), o = h(i(8741));
                function l(e, t) {
                    for(var i = 0; i < t.length; i++){
                        var a = t[i];
                        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
                    }
                }
                function s(e, t) {
                    if (t && ("object" === a(t) || "function" == typeof t)) return t;
                    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
                    return function(e) {
                        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                        return e;
                    }(e);
                }
                function u(e) {
                    var t = "function" == typeof Map ? new Map : void 0;
                    return u = function(e) {
                        if (null === e || (i = e, -1 === Function.toString.call(i).indexOf("[native code]"))) return e;
                        var i;
                        if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                        if (void 0 !== t) {
                            if (t.has(e)) return t.get(e);
                            t.set(e, a);
                        }
                        function a() {
                            return c(e, arguments, p(this).constructor);
                        }
                        return a.prototype = Object.create(e.prototype, {
                            constructor: {
                                value: a,
                                enumerable: !1,
                                writable: !0,
                                configurable: !0
                            }
                        }), d(a, e);
                    }, u(e);
                }
                function c(e, t, i) {
                    return c = f() ? Reflect.construct : function(e, t, i) {
                        var a = [
                            null
                        ];
                        a.push.apply(a, t);
                        var n = new (Function.bind.apply(e, a));
                        return i && d(n, i.prototype), n;
                    }, c.apply(null, arguments);
                }
                function f() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e) {
                        return !1;
                    }
                }
                function d(e, t) {
                    return d = Object.setPrototypeOf || function(e, t) {
                        return e.__proto__ = t, e;
                    }, d(e, t);
                }
                function p(e) {
                    return p = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
                        return e.__proto__ || Object.getPrototypeOf(e);
                    }, p(e);
                }
                function h(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
                var v = n.default.document;
                if (o.default && v && v.head && v.head.attachShadow && n.default.customElements && void 0 === n.default.customElements.get("input-mask")) {
                    var m = function(e) {
                        !function(e, t) {
                            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                            Object.defineProperty(e, "prototype", {
                                value: Object.create(t && t.prototype, {
                                    constructor: {
                                        value: e,
                                        writable: !0,
                                        configurable: !0
                                    }
                                }),
                                writable: !1
                            }), t && d(e, t);
                        }(c, e);
                        var t, i, a, n, o, u = (t = c, i = f(), function() {
                            var e, a = p(t);
                            if (i) {
                                var n = p(this).constructor;
                                e = Reflect.construct(a, arguments, n);
                            } else e = a.apply(this, arguments);
                            return s(this, e);
                        });
                        function c() {
                            var e;
                            !function(e, t) {
                                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                            }(this, c);
                            var t = (e = u.call(this)).getAttributeNames(), i = e.attachShadow({
                                mode: "closed"
                            }), a = v.createElement("input");
                            for(var n in a.type = "text", i.appendChild(a), t)Object.prototype.hasOwnProperty.call(t, n) && a.setAttribute(t[n], e.getAttribute(t[n]));
                            var o = new r.default;
                            return o.dataAttribute = "", o.mask(a), a.inputmask.shadowRoot = i, e;
                        }
                        return a = c, n && l(a.prototype, n), o && l(a, o), Object.defineProperty(a, "prototype", {
                            writable: !1
                        }), a;
                    }(u(HTMLElement));
                    n.default.customElements.define("input-mask", m);
                }
            },
            2391: function(e, t, i) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.analyseMask = function(e, t, i) {
                    var a, o, l, s, u, c, f = /(?:[?*+]|\{[0-9+*]+(?:,[0-9+*]*)?(?:\|[0-9+*]*)?\})|[^.?*+^${[]()|\\]+|./g, d = /\[\^?]?(?:[^\\\]]+|\\[\S\s]?)*]?|\\(?:0(?:[0-3][0-7]{0,2}|[4-7][0-7]?)?|[1-9][0-9]*|x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4}|c[A-Za-z]|[\S\s]?)|\((?:\?[:=!]?)?|(?:[?*+]|\{[0-9]+(?:,[0-9]*)?\})\??|[^.?*+^${[()|\\]+|./g, p = !1, h = new n.default, v = [], m = [], g = !1;
                    function k(e, a, n) {
                        n = void 0 !== n ? n : e.matches.length;
                        var o = e.matches[n - 1];
                        if (t) 0 === a.indexOf("[") || p && /\\d|\\s|\\w/i.test(a) || "." === a ? e.matches.splice(n++, 0, {
                            fn: new RegExp(a, i.casing ? "i" : ""),
                            static: !1,
                            optionality: !1,
                            newBlockMarker: void 0 === o ? "master" : o.def !== a,
                            casing: null,
                            def: a,
                            placeholder: void 0,
                            nativeDef: a
                        }) : (p && (a = a[a.length - 1]), a.split("").forEach(function(t, a) {
                            o = e.matches[n - 1], e.matches.splice(n++, 0, {
                                fn: /[a-z]/i.test(i.staticDefinitionSymbol || t) ? new RegExp("[" + (i.staticDefinitionSymbol || t) + "]", i.casing ? "i" : "") : null,
                                static: !0,
                                optionality: !1,
                                newBlockMarker: void 0 === o ? "master" : o.def !== t && !0 !== o.static,
                                casing: null,
                                def: i.staticDefinitionSymbol || t,
                                placeholder: void 0 !== i.staticDefinitionSymbol ? t : void 0,
                                nativeDef: (p ? "'" : "") + t
                            });
                        })), p = !1;
                        else {
                            var l = i.definitions && i.definitions[a] || i.usePrototypeDefinitions && r.default.prototype.definitions[a];
                            l && !p ? e.matches.splice(n++, 0, {
                                fn: l.validator ? "string" == typeof l.validator ? new RegExp(l.validator, i.casing ? "i" : "") : new function() {
                                    this.test = l.validator;
                                } : new RegExp("."),
                                static: l.static || !1,
                                optionality: l.optional || !1,
                                newBlockMarker: void 0 === o || l.optional ? "master" : o.def !== (l.definitionSymbol || a),
                                casing: l.casing,
                                def: l.definitionSymbol || a,
                                placeholder: l.placeholder,
                                nativeDef: a,
                                generated: l.generated
                            }) : (e.matches.splice(n++, 0, {
                                fn: /[a-z]/i.test(i.staticDefinitionSymbol || a) ? new RegExp("[" + (i.staticDefinitionSymbol || a) + "]", i.casing ? "i" : "") : null,
                                static: !0,
                                optionality: !1,
                                newBlockMarker: void 0 === o ? "master" : o.def !== a && !0 !== o.static,
                                casing: null,
                                def: i.staticDefinitionSymbol || a,
                                placeholder: void 0 !== i.staticDefinitionSymbol ? a : void 0,
                                nativeDef: (p ? "'" : "") + a
                            }), p = !1);
                        }
                    }
                    function y() {
                        if (v.length > 0) {
                            if (k(s = v[v.length - 1], o), s.isAlternator) {
                                u = v.pop();
                                for(var e = 0; e < u.matches.length; e++)u.matches[e].isGroup && (u.matches[e].isGroup = !1);
                                v.length > 0 ? (s = v[v.length - 1]).matches.push(u) : h.matches.push(u);
                            }
                        } else k(h, o);
                    }
                    function b(e) {
                        var t = new n.default(!0);
                        return t.openGroup = !1, t.matches = e, t;
                    }
                    function x() {
                        if ((l = v.pop()).openGroup = !1, void 0 !== l) {
                            if (v.length > 0) {
                                if ((s = v[v.length - 1]).matches.push(l), s.isAlternator) {
                                    for(var e = (u = v.pop()).matches[0].matches ? u.matches[0].matches.length : 1, t = 0; t < u.matches.length; t++)u.matches[t].isGroup = !1, u.matches[t].alternatorGroup = !1, null === i.keepStatic && e < (u.matches[t].matches ? u.matches[t].matches.length : 1) && (i.keepStatic = !0), e = u.matches[t].matches ? u.matches[t].matches.length : 1;
                                    v.length > 0 ? (s = v[v.length - 1]).matches.push(u) : h.matches.push(u);
                                }
                            } else h.matches.push(l);
                        } else y();
                    }
                    function P(e) {
                        var t = e.pop();
                        return t.isQuantifier && (t = b([
                            e.pop(),
                            t
                        ])), t;
                    }
                    t && (i.optionalmarker[0] = void 0, i.optionalmarker[1] = void 0);
                    for(; a = t ? d.exec(e) : f.exec(e);){
                        if (o = a[0], t) {
                            switch(o.charAt(0)){
                                case "?":
                                    o = "{0,1}";
                                    break;
                                case "+":
                                case "*":
                                    o = "{" + o + "}";
                                    break;
                                case "|":
                                    if (0 === v.length) {
                                        var E = b(h.matches);
                                        E.openGroup = !0, v.push(E), h.matches = [], g = !0;
                                    }
                            }
                            if ("\\d" === o) o = "[0-9]";
                        }
                        if (p) y();
                        else switch(o.charAt(0)){
                            case "$":
                            case "^":
                                t || y();
                                break;
                            case i.escapeChar:
                                p = !0, t && y();
                                break;
                            case i.optionalmarker[1]:
                            case i.groupmarker[1]:
                                x();
                                break;
                            case i.optionalmarker[0]:
                                v.push(new n.default(!1, !0));
                                break;
                            case i.groupmarker[0]:
                                v.push(new n.default(!0));
                                break;
                            case i.quantifiermarker[0]:
                                var S = new n.default(!1, !1, !0), _ = (o = o.replace(/[{}?]/g, "")).split("|"), w = _[0].split(","), M = isNaN(w[0]) ? w[0] : parseInt(w[0]), O = 1 === w.length ? M : isNaN(w[1]) ? w[1] : parseInt(w[1]), T = isNaN(_[1]) ? _[1] : parseInt(_[1]);
                                "*" !== M && "+" !== M || (M = "*" === O ? 0 : 1), S.quantifier = {
                                    min: M,
                                    max: O,
                                    jit: T
                                };
                                var C = v.length > 0 ? v[v.length - 1].matches : h.matches;
                                if ((a = C.pop()).isAlternator) {
                                    C.push(a), C = a.matches;
                                    var A = new n.default(!0), D = C.pop();
                                    C.push(A), C = A.matches, a = D;
                                }
                                a.isGroup || (a = b([
                                    a
                                ])), C.push(a), C.push(S);
                                break;
                            case i.alternatormarker:
                                if (v.length > 0) {
                                    var j = (s = v[v.length - 1]).matches[s.matches.length - 1];
                                    c = s.openGroup && (void 0 === j.matches || !1 === j.isGroup && !1 === j.isAlternator) ? v.pop() : P(s.matches);
                                } else c = P(h.matches);
                                if (c.isAlternator) v.push(c);
                                else if (c.alternatorGroup ? (u = v.pop(), c.alternatorGroup = !1) : u = new n.default(!1, !1, !1, !0), u.matches.push(c), v.push(u), c.openGroup) {
                                    c.openGroup = !1;
                                    var B = new n.default(!0);
                                    B.alternatorGroup = !0, v.push(B);
                                }
                                break;
                            default:
                                y();
                        }
                    }
                    g && x();
                    for(; v.length > 0;)l = v.pop(), h.matches.push(l);
                    h.matches.length > 0 && (!function e(a) {
                        a && a.matches && a.matches.forEach(function(n, r) {
                            var o = a.matches[r + 1];
                            (void 0 === o || void 0 === o.matches || !1 === o.isQuantifier) && n && n.isGroup && (n.isGroup = !1, t || (k(n, i.groupmarker[0], 0), !0 !== n.openGroup && k(n, i.groupmarker[1]))), e(n);
                        });
                    }(h), m.push(h));
                    (i.numericInput || i.isRTL) && function e(t) {
                        for(var a in t.matches = t.matches.reverse(), t.matches)if (Object.prototype.hasOwnProperty.call(t.matches, a)) {
                            var n = parseInt(a);
                            if (t.matches[a].isQuantifier && t.matches[n + 1] && t.matches[n + 1].isGroup) {
                                var r = t.matches[a];
                                t.matches.splice(a, 1), t.matches.splice(n + 1, 0, r);
                            }
                            void 0 !== t.matches[a].matches ? t.matches[a] = e(t.matches[a]) : t.matches[a] = ((o = t.matches[a]) === i.optionalmarker[0] ? o = i.optionalmarker[1] : o === i.optionalmarker[1] ? o = i.optionalmarker[0] : o === i.groupmarker[0] ? o = i.groupmarker[1] : o === i.groupmarker[1] && (o = i.groupmarker[0]), o);
                        }
                        var o;
                        return t;
                    }(m[0]);
                    return m;
                }, t.generateMaskSet = function(e, t) {
                    var i;
                    function n(e, i, n) {
                        var o, l, s = !1;
                        if (null !== e && "" !== e || ((s = null !== n.regex) ? e = (e = n.regex).replace(/^(\^)(.*)(\$)$/, "$2") : (s = !0, e = ".*")), 1 === e.length && !1 === n.greedy && 0 !== n.repeat && (n.placeholder = ""), n.repeat > 0 || "*" === n.repeat || "+" === n.repeat) {
                            var u = "*" === n.repeat ? 0 : "+" === n.repeat ? 1 : n.repeat;
                            e = n.groupmarker[0] + e + n.groupmarker[1] + n.quantifiermarker[0] + u + "," + n.repeat + n.quantifiermarker[1];
                        }
                        return l = s ? "regex_" + n.regex : n.numericInput ? e.split("").reverse().join("") : e, null !== n.keepStatic && (l = "ks_" + n.keepStatic + l), void 0 === r.default.prototype.masksCache[l] || !0 === t ? (o = {
                            mask: e,
                            maskToken: r.default.prototype.analyseMask(e, s, n),
                            validPositions: {},
                            _buffer: void 0,
                            buffer: void 0,
                            tests: {},
                            excludes: {},
                            metadata: i,
                            maskLength: void 0,
                            jitOffset: {}
                        }, !0 !== t && (r.default.prototype.masksCache[l] = o, o = a.default.extend(!0, {}, r.default.prototype.masksCache[l]))) : o = a.default.extend(!0, {}, r.default.prototype.masksCache[l]), o;
                    }
                    "function" == typeof e.mask && (e.mask = e.mask(e));
                    if (Array.isArray(e.mask)) {
                        if (e.mask.length > 1) {
                            null === e.keepStatic && (e.keepStatic = !0);
                            var o = e.groupmarker[0];
                            return (e.isRTL ? e.mask.reverse() : e.mask).forEach(function(t) {
                                o.length > 1 && (o += e.alternatormarker), void 0 !== t.mask && "function" != typeof t.mask ? o += t.mask : o += t;
                            }), n(o += e.groupmarker[1], e.mask, e);
                        }
                        e.mask = e.mask.pop();
                    }
                    i = e.mask && void 0 !== e.mask.mask && "function" != typeof e.mask.mask ? n(e.mask.mask, e.mask, e) : n(e.mask, e.mask, e);
                    null === e.keepStatic && (e.keepStatic = !1);
                    return i;
                };
                var a = o(i(4963)), n = o(i(9695)), r = o(i(2394));
                function o(e) {
                    return e && e.__esModule ? e : {
                        default: e
                    };
                }
            },
            157: function(e, t, i) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.mask = function() {
                    var e = this, t = this.opts, i = this.el, a = this.dependencyLib;
                    l.EventRuler.off(i);
                    var f = function(t, i) {
                        "textarea" !== t.tagName.toLowerCase() && i.ignorables.push(n.default.ENTER);
                        var s = t.getAttribute("type"), u = "input" === t.tagName.toLowerCase() && i.supportsInputType.includes(s) || t.isContentEditable || "textarea" === t.tagName.toLowerCase();
                        if (!u) {
                            if ("input" === t.tagName.toLowerCase()) {
                                var c = document.createElement("input");
                                c.setAttribute("type", s), u = "text" === c.type, c = null;
                            } else u = "partial";
                        }
                        return !1 !== u ? function(t) {
                            var n, s;
                            function u() {
                                return this.inputmask ? this.inputmask.opts.autoUnmask ? this.inputmask.unmaskedvalue() : -1 !== r.getLastValidPosition.call(e) || !0 !== i.nullable ? (this.inputmask.shadowRoot || this.ownerDocument).activeElement === this && i.clearMaskOnLostFocus ? (e.isRTL ? o.clearOptionalTail.call(e, r.getBuffer.call(e).slice()).reverse() : o.clearOptionalTail.call(e, r.getBuffer.call(e).slice())).join("") : n.call(this) : "" : n.call(this);
                            }
                            function c(e) {
                                s.call(this, e), this.inputmask && (0, o.applyInputValue)(this, e);
                            }
                            if (!t.inputmask.__valueGet) {
                                if (!0 !== i.noValuePatching) {
                                    if (Object.getOwnPropertyDescriptor) {
                                        var f = Object.getPrototypeOf ? Object.getOwnPropertyDescriptor(Object.getPrototypeOf(t), "value") : void 0;
                                        f && f.get && f.set ? (n = f.get, s = f.set, Object.defineProperty(t, "value", {
                                            get: u,
                                            set: c,
                                            configurable: !0
                                        })) : "input" !== t.tagName.toLowerCase() && (n = function() {
                                            return this.textContent;
                                        }, s = function(e) {
                                            this.textContent = e;
                                        }, Object.defineProperty(t, "value", {
                                            get: u,
                                            set: c,
                                            configurable: !0
                                        }));
                                    } else document.__lookupGetter__ && t.__lookupGetter__("value") && (n = t.__lookupGetter__("value"), s = t.__lookupSetter__("value"), t.__defineGetter__("value", u), t.__defineSetter__("value", c));
                                    t.inputmask.__valueGet = n, t.inputmask.__valueSet = s;
                                }
                                t.inputmask._valueGet = function(t) {
                                    return e.isRTL && !0 !== t ? n.call(this.el).split("").reverse().join("") : n.call(this.el);
                                }, t.inputmask._valueSet = function(t, i) {
                                    s.call(this.el, null == t ? "" : !0 !== i && e.isRTL ? t.split("").reverse().join("") : t);
                                }, void 0 === n && (n = function() {
                                    return this.value;
                                }, s = function(e) {
                                    this.value = e;
                                }, function(t) {
                                    if (a.valHooks && (void 0 === a.valHooks[t] || !0 !== a.valHooks[t].inputmaskpatch)) {
                                        var n = a.valHooks[t] && a.valHooks[t].get ? a.valHooks[t].get : function(e) {
                                            return e.value;
                                        }, l = a.valHooks[t] && a.valHooks[t].set ? a.valHooks[t].set : function(e, t) {
                                            return e.value = t, e;
                                        };
                                        a.valHooks[t] = {
                                            get: function(t) {
                                                if (t.inputmask) {
                                                    if (t.inputmask.opts.autoUnmask) return t.inputmask.unmaskedvalue();
                                                    var a = n(t);
                                                    return -1 !== r.getLastValidPosition.call(e, void 0, void 0, t.inputmask.maskset.validPositions) || !0 !== i.nullable ? a : "";
                                                }
                                                return n(t);
                                            },
                                            set: function(e, t) {
                                                var i = l(e, t);
                                                return e.inputmask && (0, o.applyInputValue)(e, t), i;
                                            },
                                            inputmaskpatch: !0
                                        };
                                    }
                                }(t.type), function(t) {
                                    l.EventRuler.on(t, "mouseenter", function() {
                                        var t = this.inputmask._valueGet(!0);
                                        t !== (e.isRTL ? r.getBuffer.call(e).reverse() : r.getBuffer.call(e)).join("") && (0, o.applyInputValue)(this, t);
                                    });
                                }(t));
                            }
                        }(t) : t.inputmask = void 0, u;
                    }(i, t);
                    if (!1 !== f) {
                        e.originalPlaceholder = i.placeholder, e.maxLength = void 0 !== i ? i.maxLength : void 0, -1 === e.maxLength && (e.maxLength = void 0), "inputMode" in i && null === i.getAttribute("inputmode") && (i.inputMode = t.inputmode, i.setAttribute("inputmode", t.inputmode)), !0 === f && (t.showMaskOnFocus = t.showMaskOnFocus && -1 === [
                            "cc-number",
                            "cc-exp"
                        ].indexOf(i.autocomplete), s.iphone && (t.insertModeVisual = !1), l.EventRuler.on(i, "submit", c.EventHandlers.submitEvent), l.EventRuler.on(i, "reset", c.EventHandlers.resetEvent), l.EventRuler.on(i, "blur", c.EventHandlers.blurEvent), l.EventRuler.on(i, "focus", c.EventHandlers.focusEvent), l.EventRuler.on(i, "invalid", c.EventHandlers.invalidEvent), l.EventRuler.on(i, "click", c.EventHandlers.clickEvent), l.EventRuler.on(i, "mouseleave", c.EventHandlers.mouseleaveEvent), l.EventRuler.on(i, "mouseenter", c.EventHandlers.mouseenterEvent), l.EventRuler.on(i, "paste", c.EventHandlers.pasteEvent), l.EventRuler.on(i, "cut", c.EventHandlers.cutEvent), l.EventRuler.on(i, "complete", t.oncomplete), l.EventRuler.on(i, "incomplete", t.onincomplete), l.EventRuler.on(i, "cleared", t.oncleared), !0 !== t.inputEventOnly && (l.EventRuler.on(i, "keydown", c.EventHandlers.keydownEvent), l.EventRuler.on(i, "keypress", c.EventHandlers.keypressEvent), l.EventRuler.on(i, "keyup", c.EventHandlers.keyupEvent)), (s.mobile || t.inputEventOnly) && i.removeAttribute("maxLength"), l.EventRuler.on(i, "input", c.EventHandlers.inputFallBackEvent), l.EventRuler.on(i, "compositionend", c.EventHandlers.compositionendEvent)), l.EventRuler.on(i, "setvalue", c.EventHandlers.setValueEvent), r.getBufferTemplate.call(e).join(""), e.undoValue = e._valueGet(!0);
                        var d = (i.inputmask.shadowRoot || i.ownerDocument).activeElement;
                        if ("" !== i.inputmask._valueGet(!0) || !1 === t.clearMaskOnLostFocus || d === i) {
                            (0, o.applyInputValue)(i, i.inputmask._valueGet(!0), t);
                            var p = r.getBuffer.call(e).slice();
                            !1 === u.isComplete.call(e, p) && t.clearIncomplete && r.resetMaskSet.call(e), t.clearMaskOnLostFocus && d !== i && (-1 === r.getLastValidPosition.call(e) ? p = [] : o.clearOptionalTail.call(e, p)), (!1 === t.clearMaskOnLostFocus || t.showMaskOnFocus && d === i || "" !== i.inputmask._valueGet(!0)) && (0, o.writeBuffer)(i, p), d === i && r.caret.call(e, i, r.seekNext.call(e, r.getLastValidPosition.call(e)));
                        }
                    }
                };
                var a, n = (a = i(5581)) && a.__esModule ? a : {
                    default: a
                }, r = i(8711), o = i(7760), l = i(9716), s = i(9845), u = i(7215), c = i(6030);
            },
            9695: function(e, t) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.default = function(e, t, i, a) {
                    this.matches = [], this.openGroup = e || !1, this.alternatorGroup = !1, this.isGroup = e || !1, this.isOptional = t || !1, this.isQuantifier = i || !1, this.isAlternator = a || !1, this.quantifier = {
                        min: 1,
                        max: 1
                    };
                };
            },
            3194: function() {
                Array.prototype.includes || Object.defineProperty(Array.prototype, "includes", {
                    value: function(e, t) {
                        if (null == this) throw new TypeError('"this" is null or not defined');
                        var i = Object(this), a = i.length >>> 0;
                        if (0 === a) return !1;
                        for(var n = 0 | t, r = Math.max(n >= 0 ? n : a - Math.abs(n), 0); r < a;){
                            if (i[r] === e) return !0;
                            r++;
                        }
                        return !1;
                    }
                });
            },
            7149: function() {
                function e(t) {
                    return e = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                        return typeof e;
                    } : function(e) {
                        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
                    }, e(t);
                }
                "function" != typeof Object.getPrototypeOf && (Object.getPrototypeOf = "object" === e("test".__proto__) ? function(e) {
                    return e.__proto__;
                } : function(e) {
                    return e.constructor.prototype;
                });
            },
            8711: function(e, t, i) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.caret = function(e, t, i, a, n) {
                    var r, o = this, l = this.opts;
                    if (void 0 === t) return "selectionStart" in e && "selectionEnd" in e ? (t = e.selectionStart, i = e.selectionEnd) : window.getSelection ? (r = window.getSelection().getRangeAt(0)).commonAncestorContainer.parentNode !== e && r.commonAncestorContainer !== e || (t = r.startOffset, i = r.endOffset) : document.selection && document.selection.createRange && (r = document.selection.createRange(), t = 0 - r.duplicate().moveStart("character", -e.inputmask._valueGet().length), i = t + r.text.length), {
                        begin: a ? t : u.call(o, t),
                        end: a ? i : u.call(o, i)
                    };
                    if (Array.isArray(t) && (i = o.isRTL ? t[0] : t[1], t = o.isRTL ? t[1] : t[0]), void 0 !== t.begin && (i = o.isRTL ? t.begin : t.end, t = o.isRTL ? t.end : t.begin), "number" == typeof t) {
                        t = a ? t : u.call(o, t), i = "number" == typeof (i = a ? i : u.call(o, i)) ? i : t;
                        var s = parseInt(((e.ownerDocument.defaultView || window).getComputedStyle ? (e.ownerDocument.defaultView || window).getComputedStyle(e, null) : e.currentStyle).fontSize) * i;
                        if (e.scrollLeft = s > e.scrollWidth ? s : 0, e.inputmask.caretPos = {
                            begin: t,
                            end: i
                        }, l.insertModeVisual && !1 === l.insertMode && t === i && (n || i++), e === (e.inputmask.shadowRoot || e.ownerDocument).activeElement) {
                            if ("setSelectionRange" in e) e.setSelectionRange(t, i);
                            else if (window.getSelection) {
                                if (r = document.createRange(), void 0 === e.firstChild || null === e.firstChild) {
                                    var c = document.createTextNode("");
                                    e.appendChild(c);
                                }
                                r.setStart(e.firstChild, t < e.inputmask._valueGet().length ? t : e.inputmask._valueGet().length), r.setEnd(e.firstChild, i < e.inputmask._valueGet().length ? i : e.inputmask._valueGet().length), r.collapse(!0);
                                var f = window.getSelection();
                                f.removeAllRanges(), f.addRange(r);
                            } else e.createTextRange && ((r = e.createTextRange()).collapse(!0), r.moveEnd("character", i), r.moveStart("character", t), r.select());
                        }
                    }
                }, t.determineLastRequiredPosition = function(e) {
                    var t, i, r = this, l = this.maskset, s = this.dependencyLib, u = a.getMaskTemplate.call(r, !0, o.call(r), !0, !0), c = u.length, f = o.call(r), d = {}, p = l.validPositions[f], h = void 0 !== p ? p.locator.slice() : void 0;
                    for(t = f + 1; t < u.length; t++)i = a.getTestTemplate.call(r, t, h, t - 1), h = i.locator.slice(), d[t] = s.extend(!0, {}, i);
                    var v = p && void 0 !== p.alternation ? p.locator[p.alternation] : void 0;
                    for(t = c - 1; t > f && ((i = d[t]).match.optionality || i.match.optionalQuantifier && i.match.newBlockMarker || v && (v !== d[t].locator[p.alternation] && 1 != i.match.static || !0 === i.match.static && i.locator[p.alternation] && n.checkAlternationMatch.call(r, i.locator[p.alternation].toString().split(","), v.toString().split(",")) && "" !== a.getTests.call(r, t)[0].def)) && u[t] === a.getPlaceholder.call(r, t, i.match); t--)c--;
                    return e ? {
                        l: c,
                        def: d[c] ? d[c].match : void 0
                    } : c;
                }, t.determineNewCaretPosition = function(e, t, i) {
                    var n = this, u = this.maskset, c = this.opts;
                    t && (n.isRTL ? e.end = e.begin : e.begin = e.end);
                    if (e.begin === e.end) {
                        switch(i = i || c.positionCaretOnClick){
                            case "none":
                                break;
                            case "select":
                                e = {
                                    begin: 0,
                                    end: r.call(n).length
                                };
                                break;
                            case "ignore":
                                e.end = e.begin = s.call(n, o.call(n));
                                break;
                            case "radixFocus":
                                if (function(e) {
                                    if ("" !== c.radixPoint && 0 !== c.digits) {
                                        var t = u.validPositions;
                                        if (void 0 === t[e] || t[e].input === a.getPlaceholder.call(n, e)) {
                                            if (e < s.call(n, -1)) return !0;
                                            var i = r.call(n).indexOf(c.radixPoint);
                                            if (-1 !== i) {
                                                for(var o in t)if (t[o] && i < o && t[o].input !== a.getPlaceholder.call(n, o)) return !1;
                                                return !0;
                                            }
                                        }
                                    }
                                    return !1;
                                }(e.begin)) {
                                    var f = r.call(n).join("").indexOf(c.radixPoint);
                                    e.end = e.begin = c.numericInput ? s.call(n, f) : f;
                                    break;
                                }
                            default:
                                var d = e.begin, p = o.call(n, d, !0), h = s.call(n, -1 !== p || l.call(n, 0) ? p : -1);
                                if (d <= h) e.end = e.begin = l.call(n, d, !1, !0) ? d : s.call(n, d);
                                else {
                                    var v = u.validPositions[p], m = a.getTestTemplate.call(n, h, v ? v.match.locator : void 0, v), g = a.getPlaceholder.call(n, h, m.match);
                                    if ("" !== g && r.call(n)[h] !== g && !0 !== m.match.optionalQuantifier && !0 !== m.match.newBlockMarker || !l.call(n, h, c.keepStatic, !0) && m.match.def === g) {
                                        var k = s.call(n, h);
                                        (d >= k || d === h) && (h = k);
                                    }
                                    e.end = e.begin = h;
                                }
                        }
                        return e;
                    }
                }, t.getBuffer = r, t.getBufferTemplate = function() {
                    var e = this.maskset;
                    void 0 === e._buffer && (e._buffer = a.getMaskTemplate.call(this, !1, 1), void 0 === e.buffer && (e.buffer = e._buffer.slice()));
                    return e._buffer;
                }, t.getLastValidPosition = o, t.isMask = l, t.resetMaskSet = function(e) {
                    var t = this.maskset;
                    t.buffer = void 0, !0 !== e && (t.validPositions = {}, t.p = 0);
                }, t.seekNext = s, t.seekPrevious = function(e, t) {
                    var i = this, n = e - 1;
                    if (e <= 0) return 0;
                    for(; n > 0 && (!0 === t && (!0 !== a.getTest.call(i, n).match.newBlockMarker || !l.call(i, n, void 0, !0)) || !0 !== t && !l.call(i, n, void 0, !0));)n--;
                    return n;
                }, t.translatePosition = u;
                var a = i(4713), n = i(7215);
                function r(e) {
                    var t = this.maskset;
                    return void 0 !== t.buffer && !0 !== e || (t.buffer = a.getMaskTemplate.call(this, !0, o.call(this), !0), void 0 === t._buffer && (t._buffer = t.buffer.slice())), t.buffer;
                }
                function o(e, t, i) {
                    var a = this.maskset, n = -1, r = -1, o = i || a.validPositions;
                    for(var l in void 0 === e && (e = -1), o){
                        var s = parseInt(l);
                        o[s] && (t || !0 !== o[s].generatedInput) && (s <= e && (n = s), s >= e && (r = s));
                    }
                    return -1 === n || n == e ? r : -1 == r || e - n < r - e ? n : r;
                }
                function l(e, t, i) {
                    var n = this, r = this.maskset, o = a.getTestTemplate.call(n, e).match;
                    if ("" === o.def && (o = a.getTest.call(n, e).match), !0 !== o.static) return o.fn;
                    if (!0 === i && void 0 !== r.validPositions[e] && !0 !== r.validPositions[e].generatedInput) return !0;
                    if (!0 !== t && e > -1) {
                        if (i) {
                            var l = a.getTests.call(n, e);
                            return l.length > 1 + ("" === l[l.length - 1].match.def ? 1 : 0);
                        }
                        var s = a.determineTestTemplate.call(n, e, a.getTests.call(n, e)), u = a.getPlaceholder.call(n, e, s.match);
                        return s.match.def !== u;
                    }
                    return !1;
                }
                function s(e, t, i) {
                    var n = this;
                    void 0 === i && (i = !0);
                    for(var r = e + 1; "" !== a.getTest.call(n, r).match.def && (!0 === t && (!0 !== a.getTest.call(n, r).match.newBlockMarker || !l.call(n, r, void 0, !0)) || !0 !== t && !l.call(n, r, void 0, i));)r++;
                    return r;
                }
                function u(e) {
                    var t = this.opts, i = this.el;
                    return !this.isRTL || "number" != typeof e || t.greedy && "" === t.placeholder || !i || (e = Math.abs(this._valueGet().length - e)), e;
                }
            },
            4713: function(e, t, i) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.determineTestTemplate = u, t.getDecisionTaker = o, t.getMaskTemplate = function(e, t, i, a, n) {
                    var r = this, o = this.opts, c = this.maskset, f = o.greedy;
                    n && o.greedy && (o.greedy = !1, r.maskset.tests = {});
                    t = t || 0;
                    var p, h, v, m, g = [], k = 0;
                    do {
                        if (!0 === e && c.validPositions[k]) v = n && c.validPositions[k].match.optionality && void 0 === c.validPositions[k + 1] && (!0 === c.validPositions[k].generatedInput || c.validPositions[k].input == o.skipOptionalPartCharacter && k > 0) ? u.call(r, k, d.call(r, k, p, k - 1)) : c.validPositions[k], h = v.match, p = v.locator.slice(), g.push(!0 === i ? v.input : !1 === i ? h.nativeDef : l.call(r, k, h));
                        else {
                            v = s.call(r, k, p, k - 1), h = v.match, p = v.locator.slice();
                            var y = !0 !== a && (!1 !== o.jitMasking ? o.jitMasking : h.jit);
                            (m = (m && h.static && h.def !== o.groupSeparator && null === h.fn || c.validPositions[k - 1] && h.static && h.def !== o.groupSeparator && null === h.fn) && c.tests[k] && 1 === c.tests[k].length) || !1 === y || void 0 === y || "number" == typeof y && isFinite(y) && y > k ? g.push(!1 === i ? h.nativeDef : l.call(r, k, h)) : m = !1;
                        }
                        k++;
                    }while (!0 !== h.static || "" !== h.def || t > k);
                    "" === g[g.length - 1] && g.pop();
                    !1 === i && void 0 !== c.maskLength || (c.maskLength = k - 1);
                    return o.greedy = f, g;
                }, t.getPlaceholder = l, t.getTest = c, t.getTestTemplate = s, t.getTests = d, t.isSubsetOf = f;
                var a, n = (a = i(2394)) && a.__esModule ? a : {
                    default: a
                };
                function r(e, t) {
                    var i = (null != e.alternation ? e.mloc[o(e)] : e.locator).join("");
                    if ("" !== i) for(; i.length < t;)i += "0";
                    return i;
                }
                function o(e) {
                    var t = e.locator[e.alternation];
                    return "string" == typeof t && t.length > 0 && (t = t.split(",")[0]), void 0 !== t ? t.toString() : "";
                }
                function l(e, t, i) {
                    var a = this.opts, n = this.maskset;
                    if (void 0 !== (t = t || c.call(this, e).match).placeholder || !0 === i) return "function" == typeof t.placeholder ? t.placeholder(a) : t.placeholder;
                    if (!0 === t.static) {
                        if (e > -1 && void 0 === n.validPositions[e]) {
                            var r, o = d.call(this, e), l = [];
                            if (o.length > 1 + ("" === o[o.length - 1].match.def ? 1 : 0)) {
                                for(var s = 0; s < o.length; s++)if ("" !== o[s].match.def && !0 !== o[s].match.optionality && !0 !== o[s].match.optionalQuantifier && (!0 === o[s].match.static || void 0 === r || !1 !== o[s].match.fn.test(r.match.def, n, e, !0, a)) && (l.push(o[s]), !0 === o[s].match.static && (r = o[s]), l.length > 1 && /[0-9a-bA-Z]/.test(l[0].match.def))) return a.placeholder.charAt(e % a.placeholder.length);
                            }
                        }
                        return t.def;
                    }
                    return a.placeholder.charAt(e % a.placeholder.length);
                }
                function s(e, t, i) {
                    return this.maskset.validPositions[e] || u.call(this, e, d.call(this, e, t ? t.slice() : t, i));
                }
                function u(e, t) {
                    var i = this.opts, a = function(e, t) {
                        var i = 0, a = !1;
                        t.forEach(function(e) {
                            e.match.optionality && (0 !== i && i !== e.match.optionality && (a = !0), (0 === i || i > e.match.optionality) && (i = e.match.optionality));
                        }), i && (0 == e || 1 == t.length ? i = 0 : a || (i = 0));
                        return i;
                    }(e, t);
                    e = e > 0 ? e - 1 : 0;
                    var n, o, l, s = r(c.call(this, e));
                    i.greedy && t.length > 1 && "" === t[t.length - 1].match.def && t.pop();
                    for(var u = 0; u < t.length; u++){
                        var f = t[u];
                        n = r(f, s.length);
                        var d = Math.abs(n - s);
                        (void 0 === o || "" !== n && d < o || l && !i.greedy && l.match.optionality && l.match.optionality - a > 0 && "master" === l.match.newBlockMarker && (!f.match.optionality || f.match.optionality - a < 1 || !f.match.newBlockMarker) || l && !i.greedy && l.match.optionalQuantifier && !f.match.optionalQuantifier) && (o = d, l = f);
                    }
                    return l;
                }
                function c(e, t) {
                    var i = this.maskset;
                    return i.validPositions[e] ? i.validPositions[e] : (t || d.call(this, e))[0];
                }
                function f(e, t, i) {
                    function a(e) {
                        for(var t, i = [], a = -1, n = 0, r = e.length; n < r; n++)if ("-" === e.charAt(n)) for(t = e.charCodeAt(n + 1); ++a < t;)i.push(String.fromCharCode(a));
                        else a = e.charCodeAt(n), i.push(e.charAt(n));
                        return i.join("");
                    }
                    return e.match.def === t.match.nativeDef || !(!(i.regex || e.match.fn instanceof RegExp && t.match.fn instanceof RegExp) || !0 === e.match.static || !0 === t.match.static) && -1 !== a(t.match.fn.toString().replace(/[[\]/]/g, "")).indexOf(a(e.match.fn.toString().replace(/[[\]/]/g, "")));
                }
                function d(e, t, i) {
                    var a, r, o = this, l = this.dependencyLib, s = this.maskset, c = this.opts, d = this.el, p = s.maskToken, h = t ? i : 0, v = t ? t.slice() : [
                        0
                    ], m = [], g = !1, k = t ? t.join("") : "";
                    function y(t, i, r, o) {
                        function l(r, o, u) {
                            function p(e, t) {
                                var i = 0 === t.matches.indexOf(e);
                                return i || t.matches.every(function(a, n) {
                                    return !0 === a.isQuantifier ? i = p(e, t.matches[n - 1]) : Object.prototype.hasOwnProperty.call(a, "matches") && (i = p(e, a)), !i;
                                }), i;
                            }
                            function v(e, t, i) {
                                var a, n;
                                if ((s.tests[e] || s.validPositions[e]) && (s.tests[e] || [
                                    s.validPositions[e]
                                ]).every(function(e, r) {
                                    if (e.mloc[t]) return a = e, !1;
                                    var o = void 0 !== i ? i : e.alternation, l = void 0 !== e.locator[o] ? e.locator[o].toString().indexOf(t) : -1;
                                    return (void 0 === n || l < n) && -1 !== l && (a = e, n = l), !0;
                                }), a) {
                                    var r = a.locator[a.alternation];
                                    return (a.mloc[t] || a.mloc[r] || a.locator).slice((void 0 !== i ? i : a.alternation) + 1);
                                }
                                return void 0 !== i ? v(e, t) : void 0;
                            }
                            function b(e, t) {
                                var i = e.alternation, a = void 0 === t || i === t.alternation && -1 === e.locator[i].toString().indexOf(t.locator[i]);
                                if (!a && i > t.alternation) {
                                    for(var n = t.alternation; n < i; n++)if (e.locator[n] !== t.locator[n]) {
                                        i = n, a = !0;
                                        break;
                                    }
                                }
                                if (a) {
                                    e.mloc = e.mloc || {};
                                    var r = e.locator[i];
                                    if (void 0 !== r) {
                                        if ("string" == typeof r && (r = r.split(",")[0]), void 0 === e.mloc[r] && (e.mloc[r] = e.locator.slice()), void 0 !== t) {
                                            for(var o in t.mloc)"string" == typeof o && (o = o.split(",")[0]), void 0 === e.mloc[o] && (e.mloc[o] = t.mloc[o]);
                                            e.locator[i] = Object.keys(e.mloc).join(",");
                                        }
                                        return !0;
                                    }
                                    e.alternation = void 0;
                                }
                                return !1;
                            }
                            function x(e, t) {
                                if (e.locator.length !== t.locator.length) return !1;
                                for(var i = e.alternation + 1; i < e.locator.length; i++)if (e.locator[i] !== t.locator[i]) return !1;
                                return !0;
                            }
                            if (h > e + c._maxTestPos) throw "Inputmask: There is probably an error in your mask definition or in the code. Create an issue on github with an example of the mask you are using. " + s.mask;
                            if (h === e && void 0 === r.matches) {
                                if (m.push({
                                    match: r,
                                    locator: o.reverse(),
                                    cd: k,
                                    mloc: {}
                                }), !r.optionality || void 0 !== u || !(c.definitions && c.definitions[r.nativeDef] && c.definitions[r.nativeDef].optional || n.default.prototype.definitions[r.nativeDef] && n.default.prototype.definitions[r.nativeDef].optional)) return !0;
                                g = !0, h = e;
                            } else if (void 0 !== r.matches) {
                                if (r.isGroup && u !== r) {
                                    if (r = l(t.matches[t.matches.indexOf(r) + 1], o, u)) return !0;
                                } else if (r.isOptional) {
                                    var P = r, E = m.length;
                                    if (r = y(r, i, o, u)) {
                                        if (m.forEach(function(e, t) {
                                            t >= E && (e.match.optionality = e.match.optionality ? e.match.optionality + 1 : 1);
                                        }), a = m[m.length - 1].match, void 0 !== u || !p(a, P)) return !0;
                                        g = !0, h = e;
                                    }
                                } else if (r.isAlternator) {
                                    var S, _ = r, w = [], M = m.slice(), O = o.length, T = !1, C = i.length > 0 ? i.shift() : -1;
                                    if (-1 === C || "string" == typeof C) {
                                        var A, D = h, j = i.slice(), B = [];
                                        if ("string" == typeof C) B = C.split(",");
                                        else for(A = 0; A < _.matches.length; A++)B.push(A.toString());
                                        if (void 0 !== s.excludes[e]) {
                                            for(var R = B.slice(), L = 0, I = s.excludes[e].length; L < I; L++){
                                                var F = s.excludes[e][L].toString().split(":");
                                                o.length == F[1] && B.splice(B.indexOf(F[0]), 1);
                                            }
                                            0 === B.length && (delete s.excludes[e], B = R);
                                        }
                                        (!0 === c.keepStatic || isFinite(parseInt(c.keepStatic)) && D >= c.keepStatic) && (B = B.slice(0, 1));
                                        for(var N = 0; N < B.length; N++){
                                            A = parseInt(B[N]), m = [], i = "string" == typeof C && v(h, A, O) || j.slice();
                                            var V = _.matches[A];
                                            if (V && l(V, [
                                                A
                                            ].concat(o), u)) r = !0;
                                            else if (0 === N && (T = !0), V && V.matches && V.matches.length > _.matches[0].matches.length) break;
                                            S = m.slice(), h = D, m = [];
                                            for(var G = 0; G < S.length; G++){
                                                var H = S[G], K = !1;
                                                H.match.jit = H.match.jit || T, H.alternation = H.alternation || O, b(H);
                                                for(var U = 0; U < w.length; U++){
                                                    var $ = w[U];
                                                    if ("string" != typeof C || void 0 !== H.alternation && B.includes(H.locator[H.alternation].toString())) {
                                                        if (H.match.nativeDef === $.match.nativeDef) {
                                                            K = !0, b($, H);
                                                            break;
                                                        }
                                                        if (f(H, $, c)) {
                                                            b(H, $) && (K = !0, w.splice(w.indexOf($), 0, H));
                                                            break;
                                                        }
                                                        if (f($, H, c)) {
                                                            b($, H);
                                                            break;
                                                        }
                                                        if (Z = $, !0 === (Q = H).match.static && !0 !== Z.match.static && Z.match.fn.test(Q.match.def, s, e, !1, c, !1)) {
                                                            x(H, $) || void 0 !== d.inputmask.userOptions.keepStatic ? b(H, $) && (K = !0, w.splice(w.indexOf($), 0, H)) : c.keepStatic = !0;
                                                            break;
                                                        }
                                                    }
                                                }
                                                K || w.push(H);
                                            }
                                        }
                                        m = M.concat(w), h = e, g = m.length > 0, r = w.length > 0, i = j.slice();
                                    } else r = l(_.matches[C] || t.matches[C], [
                                        C
                                    ].concat(o), u);
                                    if (r) return !0;
                                } else if (r.isQuantifier && u !== t.matches[t.matches.indexOf(r) - 1]) for(var q = r, z = i.length > 0 ? i.shift() : 0; z < (isNaN(q.quantifier.max) ? z + 1 : q.quantifier.max) && h <= e; z++){
                                    var W = t.matches[t.matches.indexOf(q) - 1];
                                    if (r = l(W, [
                                        z
                                    ].concat(o), W)) {
                                        if ((a = m[m.length - 1].match).optionalQuantifier = z >= q.quantifier.min, a.jit = (z + 1) * (W.matches.indexOf(a) + 1) > q.quantifier.jit, a.optionalQuantifier && p(a, W)) {
                                            g = !0, h = e;
                                            break;
                                        }
                                        return a.jit && (s.jitOffset[e] = W.matches.length - W.matches.indexOf(a)), !0;
                                    }
                                }
                                else if (r = y(r, i, o, u)) return !0;
                            } else h++;
                            var Q, Z;
                        }
                        for(var u = i.length > 0 ? i.shift() : 0; u < t.matches.length; u++)if (!0 !== t.matches[u].isQuantifier) {
                            var p = l(t.matches[u], [
                                u
                            ].concat(r), o);
                            if (p && h === e) return p;
                            if (h > e) break;
                        }
                    }
                    if (e > -1) {
                        if (void 0 === t) {
                            for(var b, x = e - 1; void 0 === (b = s.validPositions[x] || s.tests[x]) && x > -1;)x--;
                            void 0 !== b && x > -1 && (v = function(e, t) {
                                var i, a = [];
                                return Array.isArray(t) || (t = [
                                    t
                                ]), t.length > 0 && (void 0 === t[0].alternation || !0 === c.keepStatic ? 0 === (a = u.call(o, e, t.slice()).locator.slice()).length && (a = t[0].locator.slice()) : t.forEach(function(e) {
                                    "" !== e.def && (0 === a.length ? (i = e.alternation, a = e.locator.slice()) : e.locator[i] && -1 === a[i].toString().indexOf(e.locator[i]) && (a[i] += "," + e.locator[i]));
                                })), a;
                            }(x, b), k = v.join(""), h = x);
                        }
                        if (s.tests[e] && s.tests[e][0].cd === k) return s.tests[e];
                        for(var P = v.shift(); P < p.length; P++){
                            if (y(p[P], v, [
                                P
                            ]) && h === e || h > e) break;
                        }
                    }
                    return (0 === m.length || g) && m.push({
                        match: {
                            fn: null,
                            static: !0,
                            optionality: !1,
                            casing: null,
                            def: "",
                            placeholder: ""
                        },
                        locator: [],
                        mloc: {},
                        cd: k
                    }), void 0 !== t && s.tests[e] ? r = l.extend(!0, [], m) : (s.tests[e] = l.extend(!0, [], m), r = s.tests[e]), m.forEach(function(e) {
                        e.match.optionality = !1;
                    }), r;
                }
            },
            7215: function(e, t, i) {
                Object.defineProperty(t, "__esModule", {
                    value: !0
                }), t.alternate = s, t.checkAlternationMatch = function(e, t, i) {
                    for(var a, n = this.opts.greedy ? t : t.slice(0, 1), r = !1, o = void 0 !== i ? i.split(",") : [], l = 0; l < o.length; l++)-1 !== (a = e.indexOf(o[l])) && e.splice(a, 1);
                    for(var s = 0; s < e.length; s++)if (n.includes(e[s])) {
                        r = !0;
                        break;
                    }
                    return r;
                }, t.handleRemove = function(e, t, i, a, l) {
                    var u = this, c = this.maskset, f = this.opts;
                    if ((f.numericInput || u.isRTL) && (t === r.default.BACKSPACE ? t = r.default.DELETE : t === r.default.DELETE && (t = r.default.BACKSPACE), u.isRTL)) {
                        var d = i.end;
                        i.end = i.begin, i.begin = d;
                    }
                    var p, h = o.getLastValidPosition.call(u, void 0, !0);
                    i.end >= o.getBuffer.call(u).length && h >= i.end && (i.end = h + 1);
                    t === r.default.BACKSPACE ? i.end - i.begin < 1 && (i.begin = o.seekPrevious.call(u, i.begin)) : t === r.default.DELETE && i.begin === i.end && (i.end = o.isMask.call(u, i.end, !0, !0) ? i.end + 1 : o.seekNext.call(u, i.end) + 1);
                    if (!1 !== (p = m.call(u, i))) {
                        if (!0 !== a && !1 !== f.keepStatic || null !== f.regex && -1 !== n.getTest.call(u, i.begin).match.def.indexOf("|")) {
                            var v = s.call(u, !0);
                            if (v) {
                                var g = void 0 !== v.caret ? v.caret : v.pos ? o.seekNext.call(u, v.pos.begin ? v.pos.begin : v.pos) : o.getLastValidPosition.call(u, -1, !0);
                                (t !== r.default.DELETE || i.begin > g) && i.begin;
                            }
                        }
                        !0 !== a && (c.p = t === r.default.DELETE ? i.begin + p : i.begin, c.p = o.determineNewCaretPosition.call(u, {
                            begin: c.p,
                            end: c.p
                        }, !1, !1 === f.insertMode && t === r.default.BACKSPACE ? "none" : void 0).begin);
                    }
                }, t.isComplete = c, t.isSelection = f, t.isValid = d, t.refreshFromBuffer = h, t.revalidateMask = m;
                var a, n = i(4713), r = (a = i(5581)) && a.__esModule ? a : {
                    default: a
                }, o = i(8711), l = i(6030);
                function s(e, t, i, a, r, l) {
                    var u, c, f, p, h, v, m, g, k, y, b, x = this, P = this.dependencyLib, E = this.opts, S = x.maskset, _ = P.extend(!0, {}, S.validPositions), w = P.extend(!0, {}, S.tests), M = !1, O = !1, T = void 0 !== r ? r : o.getLastValidPosition.call(x);
                    if (l && (y = l.begin, b = l.end, l.begin > l.end && (y = l.end, b = l.begin)), -1 === T && void 0 === r) u = 0, c = (p = n.getTest.call(x, u)).alternation;
                    else for(; T >= 0; T--)if ((f = S.validPositions[T]) && void 0 !== f.alternation) {
                        if (p && p.locator[f.alternation] !== f.locator[f.alternation]) break;
                        u = T, c = S.validPositions[u].alternation, p = f;
                    }
                    if (void 0 !== c) {
                        m = parseInt(u), S.excludes[m] = S.excludes[m] || [], !0 !== e && S.excludes[m].push((0, n.getDecisionTaker)(p) + ":" + p.alternation);
                        var C = [], A = -1;
                        for(h = m; h < o.getLastValidPosition.call(x, void 0, !0) + 1; h++)-1 === A && e <= h && void 0 !== t && (C.push(t), A = C.length - 1), (v = S.validPositions[h]) && !0 !== v.generatedInput && (void 0 === l || h < y || h >= b) && C.push(v.input), delete S.validPositions[h];
                        for(-1 === A && void 0 !== t && (C.push(t), A = C.length - 1); void 0 !== S.excludes[m] && S.excludes[m].length < 10;){
                            for(S.tests = {}, o.resetMaskSet.call(x, !0), M = !0, h = 0; h < C.length && (g = M.caret || o.getLastValidPosition.call(x, void 0, !0) + 1, k = C[h], M = d.call(x, g, k, !1, a, !0)); h++)h === A && (O = M), 1 == e && M && (O = {
                                caretPos: h
                            });
                            if (M) break;
                            if (o.resetMaskSet.call(x), p = n.getTest.call(x, m), S.validPositions = P.extend(!0, {}, _), S.tests = P.extend(!0, {}, w), !S.excludes[m]) {
                                O = s.call(x, e, t, i, a, m - 1, l);
                                break;
                            }
                            var D = (0, n.getDecisionTaker)(p);
                            if (-1 !== S.excludes[m].indexOf(D + ":" + p.alternation)) {
                                O = s.call(x, e, t, i, a, m - 1, l);
                                break;
                            }
                            for(S.excludes[m].push(D + ":" + p.alternation), h = m; h < o.getLastValidPosition.call(x, void 0, !0) + 1; h++)delete S.validPositions[h];
                        }
                    }
                    return O && !1 === E.keepStatic || delete S.excludes[m], O;
                }
                function u(e, t, i) {
                    var a = this.opts, n = this.maskset;
                    switch(a.casing || t.casing){
                        case "upper":
                            e = e.toUpperCase();
                            break;
                        case "lower":
                            e = e.toLowerCase();
                            break;
                        case "title":
                            var o = n.validPositions[i - 1];
                            e = 0 === i || o && o.input === String.fromCharCode(r.default.SPACE) ? e.toUpperCase() : e.toLowerCase();
                            break;
                        default:
                            if ("function" == typeof a.casing) {
                                var l = Array.prototype.slice.call(arguments);
                                l.push(n.validPositions), e = a.casing.apply(this, l);
                            }
                    }
                    return e;
                }
                function c(e) {
                    var t = this, i = this.opts, a = this.maskset;
                    if ("function" == typeof i.isComplete) return i.isComplete(e, i);
                    if ("*" !== i.repeat) {
                        var r = !1, l = o.determineLastRequiredPosition.call(t, !0), s = o.seekPrevious.call(t, l.l);
                        if (void 0 === l.def || l.def.newBlockMarker || l.def.optionality || l.def.optionalQuantifier) {
                            r = !0;
                            for(var u = 0; u <= s; u++){
                                var c = n.getTestTemplate.call(t, u).match;
                                if (!0 !== c.static && void 0 === a.validPositions[u] && !0 !== c.optionality && !0 !== c.optionalQuantifier || !0 === c.static && e[u] !== n.getPlaceholder.call(t, u, c)) {
                                    r = !1;
                                    break;
                                }
                            }
                        }
                        return r;
                    }
                }
                function f(e) {
                    var t = this.opts.insertMode ? 0 : 1;
                    return this.isRTL ? e.begin - e.end > t : e.end - e.begin > t;
                }
                function d(e, t, i, a, r, l, p) {
                    var g = this, k = this.dependencyLib, y = this.opts, b = g.maskset;
                    i = !0 === i;
                    var x = e;
                    function P(e) {
                        if (void 0 !== e) {
                            if (void 0 !== e.remove && (Array.isArray(e.remove) || (e.remove = [
                                e.remove
                            ]), e.remove.sort(function(e, t) {
                                return t.pos - e.pos;
                            }).forEach(function(e) {
                                m.call(g, {
                                    begin: e,
                                    end: e + 1
                                });
                            }), e.remove = void 0), void 0 !== e.insert && (Array.isArray(e.insert) || (e.insert = [
                                e.insert
                            ]), e.insert.sort(function(e, t) {
                                return e.pos - t.pos;
                            }).forEach(function(e) {
                                "" !== e.c && d.call(g, e.pos, e.c, void 0 === e.strict || e.strict, void 0 !== e.fromIsValid ? e.fromIsValid : a);
                            }), e.insert = void 0), e.refreshFromBuffer && e.buffer) {
                                var t = e.refreshFromBuffer;
                                h.call(g, !0 === t ? t : t.start, t.end, e.buffer), e.refreshFromBuffer = void 0;
                            }
                            void 0 !== e.rewritePosition && (x = e.rewritePosition, e = !0);
                        }
                        return e;
                    }
                    function E(t, i, r) {
                        var l = !1;
                        return n.getTests.call(g, t).every(function(s, c) {
                            var d = s.match;
                            if (o.getBuffer.call(g, !0), !1 !== (l = (!d.jit || void 0 !== b.validPositions[o.seekPrevious.call(g, t)]) && (null != d.fn ? d.fn.test(i, b, t, r, y, f.call(g, e)) : (i === d.def || i === y.skipOptionalPartCharacter) && "" !== d.def && {
                                c: n.getPlaceholder.call(g, t, d, !0) || d.def,
                                pos: t
                            }))) {
                                var p = void 0 !== l.c ? l.c : i, h = t;
                                return p = p === y.skipOptionalPartCharacter && !0 === d.static ? n.getPlaceholder.call(g, t, d, !0) || d.def : p, !0 !== (l = P(l)) && void 0 !== l.pos && l.pos !== t && (h = l.pos), !0 !== l && void 0 === l.pos && void 0 === l.c ? !1 : (!1 === m.call(g, e, k.extend({}, s, {
                                    input: u.call(g, p, d, h)
                                }), a, h) && (l = !1), !1);
                            }
                            return !0;
                        }), l;
                    }
                    void 0 !== e.begin && (x = g.isRTL ? e.end : e.begin);
                    var S = !0, _ = k.extend(!0, {}, b.validPositions);
                    if (!1 === y.keepStatic && void 0 !== b.excludes[x] && !0 !== r && !0 !== a) for(var w = x; w < (g.isRTL ? e.begin : e.end); w++)void 0 !== b.excludes[w] && (b.excludes[w] = void 0, delete b.tests[w]);
                    if ("function" == typeof y.preValidation && !0 !== a && !0 !== l && (S = P(S = y.preValidation.call(g, o.getBuffer.call(g), x, t, f.call(g, e), y, b, e, i || r))), !0 === S) {
                        if (S = E(x, t, i), (!i || !0 === a) && !1 === S && !0 !== l) {
                            var M = b.validPositions[x];
                            if (!M || !0 !== M.match.static || M.match.def !== t && t !== y.skipOptionalPartCharacter) {
                                if (y.insertMode || void 0 === b.validPositions[o.seekNext.call(g, x)] || e.end > x) {
                                    var O = !1;
                                    if (b.jitOffset[x] && void 0 === b.validPositions[o.seekNext.call(g, x)] && !1 !== (S = d.call(g, x + b.jitOffset[x], t, !0, !0)) && (!0 !== r && (S.caret = x), O = !0), e.end > x && (b.validPositions[x] = void 0), !O && !o.isMask.call(g, x, y.keepStatic && 0 === x)) {
                                        for(var T = x + 1, C = o.seekNext.call(g, x, !1, 0 !== x); T <= C; T++)if (!1 !== (S = E(T, t, i))) {
                                            S = v.call(g, x, void 0 !== S.pos ? S.pos : T) || S, x = T;
                                            break;
                                        }
                                    }
                                }
                            } else S = {
                                caret: o.seekNext.call(g, x)
                            };
                        }
                        !1 !== S || !y.keepStatic || !c.call(g, o.getBuffer.call(g)) && 0 !== x || i || !0 === r ? f.call(g, e) && b.tests[x] && b.tests[x].length > 1 && y.keepStatic && !i && !0 !== r && (S = s.call(g, !0)) : S = s.call(g, x, t, i, a, void 0, e), !0 === S && (S = {
                            pos: x
                        });
                    }
                    if ("function" == typeof y.postValidation && !0 !== a && !0 !== l) {
                        var A = y.postValidation.call(g, o.getBuffer.call(g, !0), void 0 !== e.begin ? g.isRTL ? e.end : e.begin : e, t, S, y, b, i, p);
                        void 0 !== A && (S = !0 === A ? S : A);
                    }
                    S && void 0 === S.pos && (S.pos = x), !1 === S || !0 === l ? (o.resetMaskSet.call(g, !0), b.validPositions = k.extend(!0, {}, _)) : v.call(g, void 0, x, !0);
                    var D = P(S);
                    void 0 !== g.maxLength && o.getBuffer.call(g).length > g.maxLength && !a && (o.resetMaskSet.call(g, !0), b.validPositions = k.extend(!0, {}, _), D = !1);
                    return D;
                }
                function p(e, t, i) {
                    for(var a = this.maskset, r = !1, o = n.getTests.call(this, e), l = 0; l < o.length; l++){
                        if (o[l].match && (o[l].match.nativeDef === t.match[i.shiftPositions ? "def" : "nativeDef"] && (!i.shiftPositions || !t.match.static) || o[l].match.nativeDef === t.match.nativeDef || i.regex && !o[l].match.static && o[l].match.fn.test(t.input))) {
                            r = !0;
                            break;
                        }
                        if (o[l].match && o[l].match.def === t.match.nativeDef) {
                            r = void 0;
                            break;
                        }
                    }
                    return !1 === r && void 0 !== a.jitOffset[e] && (r = p.call(this, e + a.jitOffset[e], t, i)), r;
                }
                function h(e, t, i) {
                    var a, n, r = this, s = this.maskset, u = this.opts, c = this.dependencyLib, f = u.skipOptionalPartCharacter, d = r.isRTL ? i.slice().reverse() : i;
                    if (u.skipOptionalPartCharacter = "", !0 === e) o.resetMaskSet.call(r), s.tests = {}, e = 0, t = i.length, n = o.determineNewCaretPosition.call(r, {
                        begin: 0,
                        end: 0
                    }, !1).begin;
                    else {
                        for(a = e; a < t; a++)delete s.validPositions[a];
                        n = e;
                    }
                    var p = new c.Event("keypress");
                    for(a = e; a < t; a++){
                        p.keyCode = d[a].toString().charCodeAt(0), r.ignorable = !1;
                        var h = l.EventHandlers.keypressEvent.call(r, p, !0, !1, !1, n);
                        !1 !== h && void 0 !== h && (n = h.forwardPosition);
                    }
                    u.skipOptionalPartCharacter = f;
                }
                function v(e, t, i) {
                    var a = this, r = this.maskset, l = this.dependencyLib;
                    if (void 0 === e) for(e = t - 1; e > 0 && !r.validPositions[e]; e--);
                    for(var s = e; s < t; s++){
                        if (void 0 === r.validPositions[s] && !o.isMask.call(a, s, !1)) {
                            if (0 == s ? n.getTest.call(a, s) : r.validPositions[s - 1]) {
                                var u = n.getTests.call(a, s).slice();
                                "" === u[u.length - 1].match.def && u.pop();
                                var c, f = n.determineTestTemplate.call(a, s, u);
                                if (f && (!0 !== f.match.jit || "master" === f.match.newBlockMarker && (c = r.validPositions[s + 1]) && !0 === c.match.optionalQuantifier) && ((f = l.extend({}, f, {
                                    input: n.getPlaceholder.call(a, s, f.match, !0) || f.match.def
                                })).generatedInput = !0, m.call(a, s, f, !0), !0 !== i)) {
                                    var p = r.validPositions[t].input;
                                    return r.validPositions[t] = void 0, d.call(a, t, p, !0, !0);
                                }
                            }
                        }
                    }
                }
                function m(e, t, i, a) {
                    var r = this, l = this.maskset, s = this.opts, u = this.dependencyLib;
                    function c(e, t, i) {
                        var a = t[e];
                        if (void 0 !== a && !0 === a.match.static && !0 !== a.match.optionality && (void 0 === t[0] || void 0 === t[0].alternation)) {
                            var n = i.begin <= e - 1 ? t[e - 1] && !0 === t[e - 1].match.static && t[e - 1] : t[e - 1], r = i.end > e + 1 ? t[e + 1] && !0 === t[e + 1].match.static && t[e + 1] : t[e + 1];
                            return n && r;
                        }
                        return !1;
                    }
                    var f = 0, h = void 0 !== e.begin ? e.begin : e, v = void 0 !== e.end ? e.end : e, m = !0;
                    if (e.begin > e.end && (h = e.end, v = e.begin), a = void 0 !== a ? a : h, h !== v || s.insertMode && void 0 !== l.validPositions[a] && void 0 === i || void 0 === t || t.match.optionalQuantifier || t.match.optionality) {
                        var g, k = u.extend(!0, {}, l.validPositions), y = o.getLastValidPosition.call(r, void 0, !0);
                        for(l.p = h, g = y; g >= h; g--)delete l.validPositions[g], void 0 === t && delete l.tests[g + 1];
                        var b, x, P = a, E = P;
                        for(t && (l.validPositions[a] = u.extend(!0, {}, t), E++, P++), g = t ? v : v - 1; g <= y; g++){
                            if (void 0 !== (b = k[g]) && !0 !== b.generatedInput && (g >= v || g >= h && c(g, k, {
                                begin: h,
                                end: v
                            }))) {
                                for(; "" !== n.getTest.call(r, E).match.def;){
                                    if (!1 !== (x = p.call(r, E, b, s)) || "+" === b.match.def) {
                                        "+" === b.match.def && o.getBuffer.call(r, !0);
                                        var S = d.call(r, E, b.input, "+" !== b.match.def, !0);
                                        if (m = !1 !== S, P = (S.pos || E) + 1, !m && x) break;
                                    } else m = !1;
                                    if (m) {
                                        void 0 === t && b.match.static && g === e.begin && f++;
                                        break;
                                    }
                                    if (!m && o.getBuffer.call(r), E > l.maskLength) break;
                                    E++;
                                }
                                "" == n.getTest.call(r, E).match.def && (m = !1), E = P;
                            }
                            if (!m) break;
                        }
                        if (!m) return l.validPositions = u.extend(!0, {}, k), o.resetMaskSet.call(r, !0), !1;
                    } else t && n.getTest.call(r, a).match.cd === t.match.cd && (l.validPositions[a] = u.extend(!0, {}, t));
                    return o.resetMaskSet.call(r, !0), f;
                }
            },
            5581: function(e) {
                e.exports = JSON.parse('{"BACKSPACE":8,"BACKSPACE_SAFARI":127,"DELETE":46,"DOWN":40,"END":35,"ENTER":13,"ESCAPE":27,"HOME":36,"INSERT":45,"LEFT":37,"PAGE_DOWN":34,"PAGE_UP":33,"RIGHT":39,"SPACE":32,"TAB":9,"UP":38,"X":88,"Z":90,"CONTROL":17,"PAUSE/BREAK":19,"WINDOWS_LEFT":91,"WINDOWS_RIGHT":92,"KEY_229":229}');
            }
        }, t = {};
        function i(a) {
            var n = t[a];
            if (void 0 !== n) return n.exports;
            var r = t[a] = {
                exports: {}
            };
            return e[a](r, r.exports, i), r.exports;
        }
        var a = {};
        return function() {
            var e, t = a;
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.default = void 0, i(3851), i(219), i(207), i(5296);
            var n = ((e = i(2394)) && e.__esModule ? e : {
                default: e
            }).default;
            t.default = n;
        }(), a;
    }();
});

});





parcelRegister("doAVW", function(module, exports) {
"use strict";
var $9c0a2a7f430e276c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $9c0a2a7f430e276c$var$react_1 = $9c0a2a7f430e276c$var$__importDefault((parcelRequire("acw62")));

const $9c0a2a7f430e276c$var$Input_1 = $9c0a2a7f430e276c$var$__importDefault((parcelRequire("8xbn2")));
const $9c0a2a7f430e276c$var$CustomInput = (props)=>{
    return $9c0a2a7f430e276c$var$react_1.default.createElement($9c0a2a7f430e276c$var$Input_1.default, Object.assign({
        isCustom: true
    }, props));
};
module.exports.default = $9c0a2a7f430e276c$var$CustomInput;

});

parcelRegister("86V0K", function(module, exports) {
"use strict";
var $5e7b1b797eca7019$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5e7b1b797eca7019$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $5e7b1b797eca7019$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5e7b1b797eca7019$var$__createBinding(result, mod, k);
    }
    $5e7b1b797eca7019$var$__setModuleDefault(result, mod);
    return result;
};
var $5e7b1b797eca7019$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $5e7b1b797eca7019$var$react_1 = $5e7b1b797eca7019$var$__importStar((parcelRequire("acw62")));

const $5e7b1b797eca7019$var$react_autosuggest_1 = $5e7b1b797eca7019$var$__importDefault((parcelRequire("7LZLt")));
class $5e7b1b797eca7019$var$SearchField extends $5e7b1b797eca7019$var$react_1.Component {
    constructor(props){
        super(props);
        this.state = {
            value: props.value !== undefined ? props.value : null,
            checkValidEntry: props.checkValidEntry || false,
            suggestions: [],
            validEntrySelected: props.value !== undefined,
            displayFieldName: props.id.split("_").pop() || "" // Get from props.id
        };
        if (this.props.formContext.searchFieldMap) {
            const stateProps = this.props.formContext.searchFieldMap[this.getFieldPrefix() + this.state.displayFieldName];
            Object.assign(this.state, stateProps);
        }
        this.timer = -1;
        this.getFieldPrefix = this.getFieldPrefix.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onFocus = this.onFocus.bind(this);
        this.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested.bind(this);
        this.onSuggestionsClearRequested = this.onSuggestionsClearRequested.bind(this);
        this.getSuggestionValue = this.getSuggestionValue.bind(this);
        this.renderSuggestion = this.renderSuggestion.bind(this);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        let stateProps = this.state;
        if (nextProps.value !== undefined && nextProps.value !== "") {
            stateProps.value = nextProps.value;
            stateProps.validEntrySelected = true;
        }
        if (nextProps.formContext.searchFieldMap) stateProps = Object.assign(stateProps || {}, nextProps.formContext.searchFieldMap[this.getFieldPrefix() + this.state.displayFieldName]);
        if (stateProps) this.setState(stateProps);
    }
    getFieldPrefix() {
        const tokens = this.props.id.split("_");
        if (tokens.length > 3) return tokens[2] + "_";
        else return "";
    }
    onChange(event, { newValue: newValue, method: method }) {
        let value = "";
        let validEntrySelected = false;
        const autofillObj = {};
        if (method === "type") {
            value = newValue;
            this.state.autofillMap && this.state.autofillMap.forEach((entry)=>{
                autofillObj[Object.keys(entry)[0]] = undefined;
            });
            autofillObj[this.state.displayFieldName] = this.state.checkValidEntry ? "" : newValue;
        } else {
            let i = 0;
            const buildAutofill = (suggestion)=>{
                this.state.autofillMap && this.state.autofillMap.forEach((entry)=>{
                    autofillObj[Object.keys(entry)[0]] = suggestion[entry[Object.keys(entry)[0]]];
                });
            };
            if (this.state.suggestions) {
                for(i = 0; i < this.state.suggestions.length; i++)if (this.state.suggestions[i][this.state.idFieldName || "id"] === newValue) {
                    value = this.state.formatDisplayValue ? this.state.formatDisplayValue(this.state.suggestions[i]) : "";
                    buildAutofill(this.state.suggestions[i]);
                    autofillObj[this.state.displayFieldName] = value;
                    validEntrySelected = true;
                }
            }
        }
        this.setState({
            value: value,
            suggestions: [],
            validEntrySelected: validEntrySelected
        });
        if (this.props.formContext.autofill) this.props.formContext.autofill(this.props.id, autofillObj);
    }
    onBlur() {
        if (!this.state.validEntrySelected && this.state.checkValidEntry) this.setState({
            value: "",
            suggestions: []
        });
        this.props.onBlur && this.props.onBlur(this.props.id, this.state.value);
    }
    onFocus() {
        this.props.onFocus && this.props.onFocus(this.props.id, this.state.value);
    }
    renderSuggestion(suggestion) {
        return this.state.renderSuggestion && this.state.renderSuggestion(suggestion);
    }
    getSuggestionValue(suggestion) {
        return suggestion[this.state.idFieldName || "id"];
    }
    onSuggestionsClearRequested() {
        this.setState({
            suggestions: []
        });
    }
    onSuggestionsFetchRequested({ value: value }) {
        if (this.timer > -1) clearTimeout(this.timer);
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self = this;
        this.timer = window.setTimeout(()=>{
            self.fetchRequested(value);
        }, 300);
    }
    fetchRequested(value) {
        this.state.getSuggestions && this.state.getSuggestions(value, (suggestions)=>{
            this.setState({
                suggestions: suggestions
            });
        });
    }
    render() {
        const inputProps = {
            placeholder: this.props.placeholder,
            value: this.state.value === null ? "" : this.state.value,
            onChange: this.onChange,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            id: this.props.id
        };
        const theme = {
            container: "autosuggest",
            input: "form-control",
            suggestionsContainer: "dropdown dropdown-scroll",
            suggestionsList: "dropdown-menu show",
            suggestion: "dropdown-item",
            suggestionFocused: "active"
        };
        return $5e7b1b797eca7019$var$react_1.default.createElement($5e7b1b797eca7019$var$react_autosuggest_1.default, {
            suggestions: this.state.suggestions,
            onSuggestionsFetchRequested: this.onSuggestionsFetchRequested,
            onSuggestionsClearRequested: this.onSuggestionsClearRequested,
            getSuggestionValue: this.getSuggestionValue,
            renderSuggestion: this.renderSuggestion,
            inputProps: inputProps,
            theme: theme,
            "data-lwt-id": this.props.dataLwtId
        });
    }
}
module.exports.default = $5e7b1b797eca7019$var$SearchField;

});
parcelRegister("7LZLt", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gtHXA")).default;

});
parcelRegister("gtHXA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $bff1745ab4e26647$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $bff1745ab4e26647$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $bff1745ab4e26647$var$_react2 = $bff1745ab4e26647$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");
var $bff1745ab4e26647$var$_propTypes2 = $bff1745ab4e26647$var$_interopRequireDefault($c9Z8w);

var $6KMbV = parcelRequire("6KMbV");
var $bff1745ab4e26647$var$_arrays2 = $bff1745ab4e26647$var$_interopRequireDefault($6KMbV);

var $1Cn5h = parcelRequire("1Cn5h");
var $bff1745ab4e26647$var$_reactAutowhatever2 = $bff1745ab4e26647$var$_interopRequireDefault($1Cn5h);

var $5IbB8 = parcelRequire("5IbB8");
function $bff1745ab4e26647$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $bff1745ab4e26647$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $bff1745ab4e26647$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $bff1745ab4e26647$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $bff1745ab4e26647$var$alwaysTrue = function alwaysTrue() {
    return true;
};
var $bff1745ab4e26647$var$defaultShouldRenderSuggestions = function defaultShouldRenderSuggestions(value) {
    return value.trim().length > 0;
};
var $bff1745ab4e26647$var$defaultRenderSuggestionsContainer = function defaultRenderSuggestionsContainer(_ref) {
    var containerProps = _ref.containerProps, children = _ref.children;
    return $bff1745ab4e26647$var$_react2.default.createElement("div", containerProps, children);
};
var $bff1745ab4e26647$var$Autosuggest = function(_Component) {
    $bff1745ab4e26647$var$_inherits(Autosuggest, _Component);
    function Autosuggest(_ref2) {
        var alwaysRenderSuggestions = _ref2.alwaysRenderSuggestions;
        $bff1745ab4e26647$var$_classCallCheck(this, Autosuggest);
        var _this = $bff1745ab4e26647$var$_possibleConstructorReturn(this, (Autosuggest.__proto__ || Object.getPrototypeOf(Autosuggest)).call(this));
        $bff1745ab4e26647$var$_initialiseProps.call(_this);
        _this.state = {
            isFocused: false,
            isCollapsed: !alwaysRenderSuggestions,
            highlightedSectionIndex: null,
            highlightedSuggestionIndex: null,
            highlightedSuggestion: null,
            valueBeforeUpDown: null
        };
        _this.justPressedUpDown = false;
        _this.justMouseEntered = false;
        _this.pressedSuggestion = null;
        return _this;
    }
    $bff1745ab4e26647$var$_createClass(Autosuggest, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                document.addEventListener("mousedown", this.onDocumentMouseDown);
                document.addEventListener("mouseup", this.onDocumentMouseUp);
                this.input = this.autowhatever.input;
                this.suggestionsContainer = this.autowhatever.itemsContainer;
            }
        },
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(nextProps) {
                if ((0, $bff1745ab4e26647$var$_arrays2.default)(nextProps.suggestions, this.props.suggestions)) {
                    if (nextProps.highlightFirstSuggestion && nextProps.suggestions.length > 0 && this.justPressedUpDown === false && this.justMouseEntered === false) this.highlightFirstSuggestion();
                } else {
                    if (this.willRenderSuggestions(nextProps)) {
                        if (this.state.isCollapsed && !this.justSelectedSuggestion) this.revealSuggestions();
                    } else this.resetHighlightedSuggestion();
                }
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                var _props = this.props, suggestions = _props.suggestions, onSuggestionHighlighted = _props.onSuggestionHighlighted, highlightFirstSuggestion = _props.highlightFirstSuggestion;
                if (!(0, $bff1745ab4e26647$var$_arrays2.default)(suggestions, prevProps.suggestions) && suggestions.length > 0 && highlightFirstSuggestion) {
                    this.highlightFirstSuggestion();
                    return;
                }
                if (onSuggestionHighlighted) {
                    var highlightedSuggestion = this.getHighlightedSuggestion();
                    var prevHighlightedSuggestion = prevState.highlightedSuggestion;
                    if (highlightedSuggestion != prevHighlightedSuggestion) onSuggestionHighlighted({
                        suggestion: highlightedSuggestion
                    });
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                document.removeEventListener("mousedown", this.onDocumentMouseDown);
                document.removeEventListener("mouseup", this.onDocumentMouseUp);
            }
        },
        {
            key: "updateHighlightedSuggestion",
            value: function updateHighlightedSuggestion(sectionIndex, suggestionIndex, prevValue) {
                var _this2 = this;
                this.setState(function(state) {
                    var valueBeforeUpDown = state.valueBeforeUpDown;
                    if (suggestionIndex === null) valueBeforeUpDown = null;
                    else if (valueBeforeUpDown === null && typeof prevValue !== "undefined") valueBeforeUpDown = prevValue;
                    return {
                        highlightedSectionIndex: sectionIndex,
                        highlightedSuggestionIndex: suggestionIndex,
                        highlightedSuggestion: suggestionIndex === null ? null : _this2.getSuggestion(sectionIndex, suggestionIndex),
                        valueBeforeUpDown: valueBeforeUpDown
                    };
                });
            }
        },
        {
            key: "resetHighlightedSuggestion",
            value: function resetHighlightedSuggestion() {
                var shouldResetValueBeforeUpDown = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                this.setState(function(state) {
                    var valueBeforeUpDown = state.valueBeforeUpDown;
                    return {
                        highlightedSectionIndex: null,
                        highlightedSuggestionIndex: null,
                        highlightedSuggestion: null,
                        valueBeforeUpDown: shouldResetValueBeforeUpDown ? null : valueBeforeUpDown
                    };
                });
            }
        },
        {
            key: "revealSuggestions",
            value: function revealSuggestions() {
                this.setState({
                    isCollapsed: false
                });
            }
        },
        {
            key: "closeSuggestions",
            value: function closeSuggestions() {
                this.setState({
                    highlightedSectionIndex: null,
                    highlightedSuggestionIndex: null,
                    highlightedSuggestion: null,
                    valueBeforeUpDown: null,
                    isCollapsed: true
                });
            }
        },
        {
            key: "getSuggestion",
            value: function getSuggestion(sectionIndex, suggestionIndex) {
                var _props2 = this.props, suggestions = _props2.suggestions, multiSection = _props2.multiSection, getSectionSuggestions = _props2.getSectionSuggestions;
                if (multiSection) return getSectionSuggestions(suggestions[sectionIndex])[suggestionIndex];
                return suggestions[suggestionIndex];
            }
        },
        {
            key: "getHighlightedSuggestion",
            value: function getHighlightedSuggestion() {
                var _state = this.state, highlightedSectionIndex = _state.highlightedSectionIndex, highlightedSuggestionIndex = _state.highlightedSuggestionIndex;
                if (highlightedSuggestionIndex === null) return null;
                return this.getSuggestion(highlightedSectionIndex, highlightedSuggestionIndex);
            }
        },
        {
            key: "getSuggestionValueByIndex",
            value: function getSuggestionValueByIndex(sectionIndex, suggestionIndex) {
                var getSuggestionValue = this.props.getSuggestionValue;
                return getSuggestionValue(this.getSuggestion(sectionIndex, suggestionIndex));
            }
        },
        {
            key: "getSuggestionIndices",
            value: function getSuggestionIndices(suggestionElement) {
                var sectionIndex = suggestionElement.getAttribute("data-section-index");
                var suggestionIndex = suggestionElement.getAttribute("data-suggestion-index");
                return {
                    sectionIndex: typeof sectionIndex === "string" ? parseInt(sectionIndex, 10) : null,
                    suggestionIndex: parseInt(suggestionIndex, 10)
                };
            }
        },
        {
            key: "findSuggestionElement",
            value: function findSuggestionElement(startNode) {
                var node = startNode;
                do {
                    if (node.getAttribute("data-suggestion-index") !== null) return node;
                    node = node.parentNode;
                }while (node !== null);
                console.error("Clicked element:", startNode); // eslint-disable-line no-console
                throw new Error("Couldn't find suggestion element");
            }
        },
        {
            key: "maybeCallOnChange",
            value: function maybeCallOnChange(event, newValue, method) {
                var _props$inputProps = this.props.inputProps, value = _props$inputProps.value, onChange = _props$inputProps.onChange;
                if (newValue !== value) onChange(event, {
                    newValue: newValue,
                    method: method
                });
            }
        },
        {
            key: "willRenderSuggestions",
            value: function willRenderSuggestions(props) {
                var suggestions = props.suggestions, inputProps = props.inputProps, shouldRenderSuggestions = props.shouldRenderSuggestions;
                var value = inputProps.value;
                return suggestions.length > 0 && shouldRenderSuggestions(value);
            }
        },
        {
            key: "getQuery",
            value: function getQuery() {
                var inputProps = this.props.inputProps;
                var value = inputProps.value;
                var valueBeforeUpDown = this.state.valueBeforeUpDown;
                return (valueBeforeUpDown === null ? value : valueBeforeUpDown).trim();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _props3 = this.props, suggestions = _props3.suggestions, renderInputComponent = _props3.renderInputComponent, onSuggestionsFetchRequested = _props3.onSuggestionsFetchRequested, renderSuggestion = _props3.renderSuggestion, inputProps = _props3.inputProps, multiSection = _props3.multiSection, renderSectionTitle = _props3.renderSectionTitle, id = _props3.id, getSectionSuggestions = _props3.getSectionSuggestions, theme = _props3.theme, getSuggestionValue = _props3.getSuggestionValue, alwaysRenderSuggestions = _props3.alwaysRenderSuggestions, highlightFirstSuggestion = _props3.highlightFirstSuggestion;
                var _state2 = this.state, isFocused = _state2.isFocused, isCollapsed = _state2.isCollapsed, highlightedSectionIndex = _state2.highlightedSectionIndex, highlightedSuggestionIndex = _state2.highlightedSuggestionIndex, valueBeforeUpDown = _state2.valueBeforeUpDown;
                var shouldRenderSuggestions = alwaysRenderSuggestions ? $bff1745ab4e26647$var$alwaysTrue : this.props.shouldRenderSuggestions;
                var value = inputProps.value, _onFocus = inputProps.onFocus, _onKeyDown = inputProps.onKeyDown;
                var willRenderSuggestions = this.willRenderSuggestions(this.props);
                var isOpen = alwaysRenderSuggestions || isFocused && !isCollapsed && willRenderSuggestions;
                var items = isOpen ? suggestions : [];
                var autowhateverInputProps = $bff1745ab4e26647$var$_extends({}, inputProps, {
                    onFocus: function onFocus(event) {
                        if (!_this3.justSelectedSuggestion && !_this3.justClickedOnSuggestionsContainer) {
                            var shouldRender = shouldRenderSuggestions(value);
                            _this3.setState({
                                isFocused: true,
                                isCollapsed: !shouldRender
                            });
                            _onFocus && _onFocus(event);
                            if (shouldRender) onSuggestionsFetchRequested({
                                value: value,
                                reason: "input-focused"
                            });
                        }
                    },
                    onBlur: function onBlur(event) {
                        if (_this3.justClickedOnSuggestionsContainer) {
                            _this3.input.focus();
                            return;
                        }
                        _this3.blurEvent = event;
                        if (!_this3.justSelectedSuggestion) {
                            _this3.onBlur();
                            _this3.onSuggestionsClearRequested();
                        }
                    },
                    onChange: function onChange(event) {
                        var value = event.target.value;
                        var shouldRender = shouldRenderSuggestions(value);
                        _this3.maybeCallOnChange(event, value, "type");
                        if (_this3.suggestionsContainer) _this3.suggestionsContainer.scrollTop = 0;
                        _this3.setState($bff1745ab4e26647$var$_extends({}, highlightFirstSuggestion ? {} : {
                            highlightedSectionIndex: null,
                            highlightedSuggestionIndex: null,
                            highlightedSuggestion: null
                        }, {
                            valueBeforeUpDown: null,
                            isCollapsed: !shouldRender
                        }));
                        if (shouldRender) onSuggestionsFetchRequested({
                            value: value,
                            reason: "input-changed"
                        });
                        else _this3.onSuggestionsClearRequested();
                    },
                    onKeyDown: function onKeyDown(event, data) {
                        var keyCode = event.keyCode;
                        switch(keyCode){
                            case 40:
                            case 38:
                                // ArrowUp
                                if (isCollapsed) {
                                    if (shouldRenderSuggestions(value)) {
                                        onSuggestionsFetchRequested({
                                            value: value,
                                            reason: "suggestions-revealed"
                                        });
                                        _this3.revealSuggestions();
                                    }
                                } else if (suggestions.length > 0) {
                                    var newHighlightedSectionIndex = data.newHighlightedSectionIndex, newHighlightedItemIndex = data.newHighlightedItemIndex;
                                    var newValue = void 0;
                                    if (newHighlightedItemIndex === null) // valueBeforeUpDown can be null if, for example, user
                                    // hovers on the first suggestion and then pressed Up.
                                    // If that happens, use the original input value.
                                    newValue = valueBeforeUpDown === null ? value : valueBeforeUpDown;
                                    else newValue = _this3.getSuggestionValueByIndex(newHighlightedSectionIndex, newHighlightedItemIndex);
                                    _this3.updateHighlightedSuggestion(newHighlightedSectionIndex, newHighlightedItemIndex, value);
                                    _this3.maybeCallOnChange(event, newValue, keyCode === 40 ? "down" : "up");
                                }
                                event.preventDefault(); // Prevents the cursor from moving
                                _this3.justPressedUpDown = true;
                                setTimeout(function() {
                                    _this3.justPressedUpDown = false;
                                });
                                break;
                            // Enter
                            case 13:
                                // See #388
                                if (event.keyCode === 229) break;
                                var highlightedSuggestion = _this3.getHighlightedSuggestion();
                                if (isOpen && !alwaysRenderSuggestions) _this3.closeSuggestions();
                                if (highlightedSuggestion != null) {
                                    var _newValue = getSuggestionValue(highlightedSuggestion);
                                    _this3.maybeCallOnChange(event, _newValue, "enter");
                                    _this3.onSuggestionSelected(event, {
                                        suggestion: highlightedSuggestion,
                                        suggestionValue: _newValue,
                                        suggestionIndex: highlightedSuggestionIndex,
                                        sectionIndex: highlightedSectionIndex,
                                        method: "enter"
                                    });
                                    _this3.justSelectedSuggestion = true;
                                    setTimeout(function() {
                                        _this3.justSelectedSuggestion = false;
                                    });
                                }
                                break;
                            // Escape
                            case 27:
                                if (isOpen) // If input.type === 'search', the browser clears the input
                                // when Escape is pressed. We want to disable this default
                                // behaviour so that, when suggestions are shown, we just hide
                                // them, without clearing the input.
                                event.preventDefault();
                                var willCloseSuggestions = isOpen && !alwaysRenderSuggestions;
                                if (valueBeforeUpDown === null) // Didn't interact with Up/Down
                                {
                                    if (!willCloseSuggestions) {
                                        var _newValue2 = "";
                                        _this3.maybeCallOnChange(event, _newValue2, "escape");
                                        if (shouldRenderSuggestions(_newValue2)) onSuggestionsFetchRequested({
                                            value: _newValue2,
                                            reason: "escape-pressed"
                                        });
                                        else _this3.onSuggestionsClearRequested();
                                    }
                                } else // Interacted with Up/Down
                                _this3.maybeCallOnChange(event, valueBeforeUpDown, "escape");
                                if (willCloseSuggestions) {
                                    _this3.onSuggestionsClearRequested();
                                    _this3.closeSuggestions();
                                } else _this3.resetHighlightedSuggestion();
                                break;
                        }
                        _onKeyDown && _onKeyDown(event);
                    }
                });
                var renderSuggestionData = {
                    query: this.getQuery()
                };
                return $bff1745ab4e26647$var$_react2.default.createElement($bff1745ab4e26647$var$_reactAutowhatever2.default, {
                    multiSection: multiSection,
                    items: items,
                    renderInputComponent: renderInputComponent,
                    renderItemsContainer: this.renderSuggestionsContainer,
                    renderItem: renderSuggestion,
                    renderItemData: renderSuggestionData,
                    renderSectionTitle: renderSectionTitle,
                    getSectionItems: getSectionSuggestions,
                    highlightedSectionIndex: highlightedSectionIndex,
                    highlightedItemIndex: highlightedSuggestionIndex,
                    inputProps: autowhateverInputProps,
                    itemProps: this.itemProps,
                    theme: (0, $5IbB8.mapToAutowhateverTheme)(theme),
                    id: id,
                    ref: this.storeAutowhateverRef
                });
            }
        }
    ]);
    return Autosuggest;
}($acw62.Component);
$bff1745ab4e26647$var$Autosuggest.propTypes = {
    suggestions: $bff1745ab4e26647$var$_propTypes2.default.array.isRequired,
    onSuggestionsFetchRequested: function onSuggestionsFetchRequested(props, propName) {
        var onSuggestionsFetchRequested = props[propName];
        if (typeof onSuggestionsFetchRequested !== "function") throw new Error("'onSuggestionsFetchRequested' must be implemented. See: https://github.com/moroshko/react-autosuggest#onSuggestionsFetchRequestedProp");
    },
    onSuggestionsClearRequested: function onSuggestionsClearRequested(props, propName) {
        var onSuggestionsClearRequested = props[propName];
        if (props.alwaysRenderSuggestions === false && typeof onSuggestionsClearRequested !== "function") throw new Error("'onSuggestionsClearRequested' must be implemented. See: https://github.com/moroshko/react-autosuggest#onSuggestionsClearRequestedProp");
    },
    onSuggestionSelected: $bff1745ab4e26647$var$_propTypes2.default.func,
    onSuggestionHighlighted: $bff1745ab4e26647$var$_propTypes2.default.func,
    renderInputComponent: $bff1745ab4e26647$var$_propTypes2.default.func,
    renderSuggestionsContainer: $bff1745ab4e26647$var$_propTypes2.default.func,
    getSuggestionValue: $bff1745ab4e26647$var$_propTypes2.default.func.isRequired,
    renderSuggestion: $bff1745ab4e26647$var$_propTypes2.default.func.isRequired,
    inputProps: function inputProps(props, propName) {
        var inputProps = props[propName];
        if (!inputProps.hasOwnProperty("value")) throw new Error("'inputProps' must have 'value'.");
        if (!inputProps.hasOwnProperty("onChange")) throw new Error("'inputProps' must have 'onChange'.");
    },
    shouldRenderSuggestions: $bff1745ab4e26647$var$_propTypes2.default.func,
    alwaysRenderSuggestions: $bff1745ab4e26647$var$_propTypes2.default.bool,
    multiSection: $bff1745ab4e26647$var$_propTypes2.default.bool,
    renderSectionTitle: function renderSectionTitle(props, propName) {
        var renderSectionTitle = props[propName];
        if (props.multiSection === true && typeof renderSectionTitle !== "function") throw new Error("'renderSectionTitle' must be implemented. See: https://github.com/moroshko/react-autosuggest#renderSectionTitleProp");
    },
    getSectionSuggestions: function getSectionSuggestions(props, propName) {
        var getSectionSuggestions = props[propName];
        if (props.multiSection === true && typeof getSectionSuggestions !== "function") throw new Error("'getSectionSuggestions' must be implemented. See: https://github.com/moroshko/react-autosuggest#getSectionSuggestionsProp");
    },
    focusInputOnSuggestionClick: $bff1745ab4e26647$var$_propTypes2.default.bool,
    highlightFirstSuggestion: $bff1745ab4e26647$var$_propTypes2.default.bool,
    theme: $bff1745ab4e26647$var$_propTypes2.default.object,
    id: $bff1745ab4e26647$var$_propTypes2.default.string
};
$bff1745ab4e26647$var$Autosuggest.defaultProps = {
    renderSuggestionsContainer: $bff1745ab4e26647$var$defaultRenderSuggestionsContainer,
    shouldRenderSuggestions: $bff1745ab4e26647$var$defaultShouldRenderSuggestions,
    alwaysRenderSuggestions: false,
    multiSection: false,
    focusInputOnSuggestionClick: true,
    highlightFirstSuggestion: false,
    theme: $5IbB8.defaultTheme,
    id: "1"
};
var $bff1745ab4e26647$var$_initialiseProps = function _initialiseProps() {
    var _this4 = this;
    this.onDocumentMouseDown = function(event) {
        _this4.justClickedOnSuggestionsContainer = false;
        var node = event.detail && event.detail.target || // This is for testing only. Please show me a better way to emulate this.
        event.target;
        while(node !== null && node !== document){
            if (node.getAttribute("data-suggestion-index") !== null) // Suggestion was clicked
            return;
            if (node === _this4.suggestionsContainer) {
                // Something else inside suggestions container was clicked
                _this4.justClickedOnSuggestionsContainer = true;
                return;
            }
            node = node.parentNode;
        }
    };
    this.storeAutowhateverRef = function(autowhatever) {
        if (autowhatever !== null) _this4.autowhatever = autowhatever;
    };
    this.onSuggestionMouseEnter = function(event, _ref3) {
        var sectionIndex = _ref3.sectionIndex, itemIndex = _ref3.itemIndex;
        _this4.updateHighlightedSuggestion(sectionIndex, itemIndex);
        if (event.target === _this4.pressedSuggestion) _this4.justSelectedSuggestion = true;
        _this4.justMouseEntered = true;
        setTimeout(function() {
            _this4.justMouseEntered = false;
        });
    };
    this.highlightFirstSuggestion = function() {
        _this4.updateHighlightedSuggestion(_this4.props.multiSection ? 0 : null, 0);
    };
    this.onDocumentMouseUp = function() {
        if (_this4.pressedSuggestion && !_this4.justSelectedSuggestion) _this4.input.focus();
        _this4.pressedSuggestion = null;
    };
    this.onSuggestionMouseDown = function(event) {
        // Checking if this.justSelectedSuggestion is already true to not duplicate touch events in chrome
        // See: https://github.com/facebook/react/issues/9809#issuecomment-413978405
        if (!_this4.justSelectedSuggestion) {
            _this4.justSelectedSuggestion = true;
            _this4.pressedSuggestion = event.target;
        }
    };
    this.onSuggestionsClearRequested = function() {
        var onSuggestionsClearRequested = _this4.props.onSuggestionsClearRequested;
        onSuggestionsClearRequested && onSuggestionsClearRequested();
    };
    this.onSuggestionSelected = function(event, data) {
        var _props4 = _this4.props, alwaysRenderSuggestions = _props4.alwaysRenderSuggestions, onSuggestionSelected = _props4.onSuggestionSelected, onSuggestionsFetchRequested = _props4.onSuggestionsFetchRequested;
        onSuggestionSelected && onSuggestionSelected(event, data);
        if (alwaysRenderSuggestions) onSuggestionsFetchRequested({
            value: data.suggestionValue,
            reason: "suggestion-selected"
        });
        else _this4.onSuggestionsClearRequested();
        _this4.resetHighlightedSuggestion();
    };
    this.onSuggestionClick = function(event) {
        var _props5 = _this4.props, alwaysRenderSuggestions = _props5.alwaysRenderSuggestions, focusInputOnSuggestionClick = _props5.focusInputOnSuggestionClick;
        var _getSuggestionIndices = _this4.getSuggestionIndices(_this4.findSuggestionElement(event.target)), sectionIndex = _getSuggestionIndices.sectionIndex, suggestionIndex = _getSuggestionIndices.suggestionIndex;
        var clickedSuggestion = _this4.getSuggestion(sectionIndex, suggestionIndex);
        var clickedSuggestionValue = _this4.props.getSuggestionValue(clickedSuggestion);
        _this4.maybeCallOnChange(event, clickedSuggestionValue, "click");
        _this4.onSuggestionSelected(event, {
            suggestion: clickedSuggestion,
            suggestionValue: clickedSuggestionValue,
            suggestionIndex: suggestionIndex,
            sectionIndex: sectionIndex,
            method: "click"
        });
        if (!alwaysRenderSuggestions) _this4.closeSuggestions();
        if (focusInputOnSuggestionClick === true) _this4.input.focus();
        else _this4.onBlur();
        setTimeout(function() {
            _this4.justSelectedSuggestion = false;
        });
    };
    this.onBlur = function() {
        var _props6 = _this4.props, inputProps = _props6.inputProps, shouldRenderSuggestions = _props6.shouldRenderSuggestions;
        var value = inputProps.value, onBlur = inputProps.onBlur;
        var highlightedSuggestion = _this4.getHighlightedSuggestion();
        var shouldRender = shouldRenderSuggestions(value);
        _this4.setState({
            isFocused: false,
            highlightedSectionIndex: null,
            highlightedSuggestionIndex: null,
            highlightedSuggestion: null,
            valueBeforeUpDown: null,
            isCollapsed: !shouldRender
        });
        onBlur && onBlur(_this4.blurEvent, {
            highlightedSuggestion: highlightedSuggestion
        });
    };
    this.onSuggestionMouseLeave = function(event) {
        _this4.resetHighlightedSuggestion(false); // shouldResetValueBeforeUpDown
        if (_this4.justSelectedSuggestion && event.target === _this4.pressedSuggestion) _this4.justSelectedSuggestion = false;
    };
    this.onSuggestionTouchStart = function() {
        _this4.justSelectedSuggestion = true;
    // todo: event.preventDefault when https://github.com/facebook/react/issues/2043
    // todo: gets released so onSuggestionMouseDown won't fire in chrome
    };
    this.onSuggestionTouchMove = function() {
        _this4.justSelectedSuggestion = false;
        _this4.pressedSuggestion = null;
        _this4.input.focus();
    };
    this.itemProps = function(_ref4) {
        var sectionIndex = _ref4.sectionIndex, itemIndex = _ref4.itemIndex;
        return {
            "data-section-index": sectionIndex,
            "data-suggestion-index": itemIndex,
            onMouseEnter: _this4.onSuggestionMouseEnter,
            onMouseLeave: _this4.onSuggestionMouseLeave,
            onMouseDown: _this4.onSuggestionMouseDown,
            onTouchStart: _this4.onSuggestionTouchStart,
            onTouchMove: _this4.onSuggestionTouchMove,
            onClick: _this4.onSuggestionClick
        };
    };
    this.renderSuggestionsContainer = function(_ref5) {
        var containerProps = _ref5.containerProps, children = _ref5.children;
        var renderSuggestionsContainer = _this4.props.renderSuggestionsContainer;
        return renderSuggestionsContainer({
            containerProps: containerProps,
            children: children,
            query: _this4.getQuery()
        });
    };
};
module.exports.default = $bff1745ab4e26647$var$Autosuggest;

});
parcelRegister("6KMbV", function(module, exports) {
"use strict";
function $4eac6bc3bf7b7151$var$shallowEqualArrays(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    var len = arrA.length;
    if (arrB.length !== len) return false;
    for(var i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
module.exports = $4eac6bc3bf7b7151$var$shallowEqualArrays;

});

parcelRegister("1Cn5h", function(module, exports) {
"use strict";

module.exports = (parcelRequire("aQHvf")).default;

});
parcelRegister("aQHvf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $7e608181f865f58f$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $7e608181f865f58f$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();
var $7e608181f865f58f$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $7e608181f865f58f$var$_react2 = $7e608181f865f58f$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");
var $7e608181f865f58f$var$_propTypes2 = $7e608181f865f58f$var$_interopRequireDefault($c9Z8w);

var $bzeoG = parcelRequire("bzeoG");
var $7e608181f865f58f$var$_sectionIterator2 = $7e608181f865f58f$var$_interopRequireDefault($bzeoG);

var $4zE4h = parcelRequire("4zE4h");
var $7e608181f865f58f$var$_reactThemeable2 = $7e608181f865f58f$var$_interopRequireDefault($4zE4h);

var $j8tXH = parcelRequire("j8tXH");
var $7e608181f865f58f$var$_SectionTitle2 = $7e608181f865f58f$var$_interopRequireDefault($j8tXH);

var $kAix6 = parcelRequire("kAix6");
var $7e608181f865f58f$var$_ItemsList2 = $7e608181f865f58f$var$_interopRequireDefault($kAix6);
function $7e608181f865f58f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7e608181f865f58f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7e608181f865f58f$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $7e608181f865f58f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $7e608181f865f58f$var$emptyObject = {};
var $7e608181f865f58f$var$defaultRenderInputComponent = function defaultRenderInputComponent(props) {
    return $7e608181f865f58f$var$_react2.default.createElement("input", props);
};
var $7e608181f865f58f$var$defaultRenderItemsContainer = function defaultRenderItemsContainer(_ref) {
    var containerProps = _ref.containerProps, children = _ref.children;
    return $7e608181f865f58f$var$_react2.default.createElement("div", containerProps, children);
};
var $7e608181f865f58f$var$defaultTheme = {
    container: "react-autowhatever__container",
    containerOpen: "react-autowhatever__container--open",
    input: "react-autowhatever__input",
    inputOpen: "react-autowhatever__input--open",
    inputFocused: "react-autowhatever__input--focused",
    itemsContainer: "react-autowhatever__items-container",
    itemsContainerOpen: "react-autowhatever__items-container--open",
    itemsList: "react-autowhatever__items-list",
    item: "react-autowhatever__item",
    itemFirst: "react-autowhatever__item--first",
    itemHighlighted: "react-autowhatever__item--highlighted",
    sectionContainer: "react-autowhatever__section-container",
    sectionContainerFirst: "react-autowhatever__section-container--first",
    sectionTitle: "react-autowhatever__section-title"
};
var $7e608181f865f58f$var$Autowhatever = function(_Component) {
    $7e608181f865f58f$var$_inherits(Autowhatever, _Component);
    function Autowhatever(props) {
        $7e608181f865f58f$var$_classCallCheck(this, Autowhatever);
        var _this = $7e608181f865f58f$var$_possibleConstructorReturn(this, (Autowhatever.__proto__ || Object.getPrototypeOf(Autowhatever)).call(this, props));
        _this.storeInputReference = function(input) {
            if (input !== null) _this.input = input;
        };
        _this.storeItemsContainerReference = function(itemsContainer) {
            if (itemsContainer !== null) _this.itemsContainer = itemsContainer;
        };
        _this.onHighlightedItemChange = function(highlightedItem) {
            _this.highlightedItem = highlightedItem;
        };
        _this.getItemId = function(sectionIndex, itemIndex) {
            if (itemIndex === null) return null;
            var id = _this.props.id;
            var section = sectionIndex === null ? "" : "section-" + sectionIndex;
            return "react-autowhatever-" + id + "-" + section + "-item-" + itemIndex;
        };
        _this.onFocus = function(event) {
            var inputProps = _this.props.inputProps;
            _this.setState({
                isInputFocused: true
            });
            inputProps.onFocus && inputProps.onFocus(event);
        };
        _this.onBlur = function(event) {
            var inputProps = _this.props.inputProps;
            _this.setState({
                isInputFocused: false
            });
            inputProps.onBlur && inputProps.onBlur(event);
        };
        _this.onKeyDown = function(event) {
            var _this$props = _this.props, inputProps = _this$props.inputProps, highlightedSectionIndex = _this$props.highlightedSectionIndex, highlightedItemIndex = _this$props.highlightedItemIndex;
            switch(event.key){
                case "ArrowDown":
                case "ArrowUp":
                    var nextPrev = event.key === "ArrowDown" ? "next" : "prev";
                    var _this$sectionIterator = _this.sectionIterator[nextPrev]([
                        highlightedSectionIndex,
                        highlightedItemIndex
                    ]), _this$sectionIterator2 = $7e608181f865f58f$var$_slicedToArray(_this$sectionIterator, 2), newHighlightedSectionIndex = _this$sectionIterator2[0], newHighlightedItemIndex = _this$sectionIterator2[1];
                    inputProps.onKeyDown(event, {
                        newHighlightedSectionIndex: newHighlightedSectionIndex,
                        newHighlightedItemIndex: newHighlightedItemIndex
                    });
                    break;
                default:
                    inputProps.onKeyDown(event, {
                        highlightedSectionIndex: highlightedSectionIndex,
                        highlightedItemIndex: highlightedItemIndex
                    });
            }
        };
        _this.highlightedItem = null;
        _this.state = {
            isInputFocused: false
        };
        _this.setSectionsItems(props);
        _this.setSectionIterator(props);
        _this.setTheme(props);
        return _this;
    }
    $7e608181f865f58f$var$_createClass(Autowhatever, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.ensureHighlightedItemIsVisible();
            }
        },
        {
            key: "UNSAFE_componentWillReceiveProps",
            value: function UNSAFE_componentWillReceiveProps(nextProps) {
                if (nextProps.items !== this.props.items) this.setSectionsItems(nextProps);
                if (nextProps.items !== this.props.items || nextProps.multiSection !== this.props.multiSection) this.setSectionIterator(nextProps);
                if (nextProps.theme !== this.props.theme) this.setTheme(nextProps);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.ensureHighlightedItemIsVisible();
            }
        },
        {
            key: "setSectionsItems",
            value: function setSectionsItems(props) {
                if (props.multiSection) {
                    this.sectionsItems = props.items.map(function(section) {
                        return props.getSectionItems(section);
                    });
                    this.sectionsLengths = this.sectionsItems.map(function(items) {
                        return items.length;
                    });
                    this.allSectionsAreEmpty = this.sectionsLengths.every(function(itemsCount) {
                        return itemsCount === 0;
                    });
                }
            }
        },
        {
            key: "setSectionIterator",
            value: function setSectionIterator(props) {
                this.sectionIterator = (0, $7e608181f865f58f$var$_sectionIterator2.default)({
                    multiSection: props.multiSection,
                    data: props.multiSection ? this.sectionsLengths : props.items.length
                });
            }
        },
        {
            key: "setTheme",
            value: function setTheme(props) {
                this.theme = (0, $7e608181f865f58f$var$_reactThemeable2.default)(props.theme);
            }
        },
        {
            key: "renderSections",
            value: function renderSections() {
                var _this2 = this;
                if (this.allSectionsAreEmpty) return null;
                var theme = this.theme;
                var _props = this.props, id = _props.id, items = _props.items, renderItem = _props.renderItem, renderItemData = _props.renderItemData, renderSectionTitle = _props.renderSectionTitle, highlightedSectionIndex = _props.highlightedSectionIndex, highlightedItemIndex = _props.highlightedItemIndex, itemProps = _props.itemProps;
                return items.map(function(section, sectionIndex) {
                    var keyPrefix = "react-autowhatever-" + id + "-";
                    var sectionKeyPrefix = keyPrefix + "section-" + sectionIndex + "-";
                    var isFirstSection = sectionIndex === 0;
                    // `key` is provided by theme()
                    /* eslint-disable react/jsx-key */ return $7e608181f865f58f$var$_react2.default.createElement("div", theme(sectionKeyPrefix + "container", "sectionContainer", isFirstSection && "sectionContainerFirst"), $7e608181f865f58f$var$_react2.default.createElement($7e608181f865f58f$var$_SectionTitle2.default, {
                        section: section,
                        renderSectionTitle: renderSectionTitle,
                        theme: theme,
                        sectionKeyPrefix: sectionKeyPrefix
                    }), $7e608181f865f58f$var$_react2.default.createElement($7e608181f865f58f$var$_ItemsList2.default, {
                        items: _this2.sectionsItems[sectionIndex],
                        itemProps: itemProps,
                        renderItem: renderItem,
                        renderItemData: renderItemData,
                        sectionIndex: sectionIndex,
                        highlightedItemIndex: highlightedSectionIndex === sectionIndex ? highlightedItemIndex : null,
                        onHighlightedItemChange: _this2.onHighlightedItemChange,
                        getItemId: _this2.getItemId,
                        theme: theme,
                        keyPrefix: keyPrefix,
                        ref: _this2.storeItemsListReference
                    }));
                /* eslint-enable react/jsx-key */ });
            }
        },
        {
            key: "renderItems",
            value: function renderItems() {
                var items = this.props.items;
                if (items.length === 0) return null;
                var theme = this.theme;
                var _props2 = this.props, id = _props2.id, renderItem = _props2.renderItem, renderItemData = _props2.renderItemData, highlightedSectionIndex = _props2.highlightedSectionIndex, highlightedItemIndex = _props2.highlightedItemIndex, itemProps = _props2.itemProps;
                return $7e608181f865f58f$var$_react2.default.createElement($7e608181f865f58f$var$_ItemsList2.default, {
                    items: items,
                    itemProps: itemProps,
                    renderItem: renderItem,
                    renderItemData: renderItemData,
                    highlightedItemIndex: highlightedSectionIndex === null ? highlightedItemIndex : null,
                    onHighlightedItemChange: this.onHighlightedItemChange,
                    getItemId: this.getItemId,
                    theme: theme,
                    keyPrefix: "react-autowhatever-" + id + "-"
                });
            }
        },
        {
            key: "ensureHighlightedItemIsVisible",
            value: function ensureHighlightedItemIsVisible() {
                var highlightedItem = this.highlightedItem;
                if (!highlightedItem) return;
                var itemsContainer = this.itemsContainer;
                var itemOffsetRelativeToContainer = highlightedItem.offsetParent === itemsContainer ? highlightedItem.offsetTop : highlightedItem.offsetTop - itemsContainer.offsetTop;
                var scrollTop = itemsContainer.scrollTop; // Top of the visible area
                if (itemOffsetRelativeToContainer < scrollTop) // Item is off the top of the visible area
                scrollTop = itemOffsetRelativeToContainer;
                else if (itemOffsetRelativeToContainer + highlightedItem.offsetHeight > scrollTop + itemsContainer.offsetHeight) // Item is off the bottom of the visible area
                scrollTop = itemOffsetRelativeToContainer + highlightedItem.offsetHeight - itemsContainer.offsetHeight;
                if (scrollTop !== itemsContainer.scrollTop) itemsContainer.scrollTop = scrollTop;
            }
        },
        {
            key: "render",
            value: function render() {
                var theme = this.theme;
                var _props3 = this.props, id = _props3.id, multiSection = _props3.multiSection, renderInputComponent = _props3.renderInputComponent, renderItemsContainer = _props3.renderItemsContainer, highlightedSectionIndex = _props3.highlightedSectionIndex, highlightedItemIndex = _props3.highlightedItemIndex;
                var isInputFocused = this.state.isInputFocused;
                var renderedItems = multiSection ? this.renderSections() : this.renderItems();
                var isOpen = renderedItems !== null;
                var ariaActivedescendant = this.getItemId(highlightedSectionIndex, highlightedItemIndex);
                var itemsContainerId = "react-autowhatever-" + id;
                var containerProps = $7e608181f865f58f$var$_extends({
                    role: "combobox",
                    "aria-haspopup": "listbox",
                    "aria-owns": itemsContainerId,
                    "aria-expanded": isOpen
                }, theme("react-autowhatever-" + id + "-container", "container", isOpen && "containerOpen"), this.props.containerProps);
                var inputComponent = renderInputComponent($7e608181f865f58f$var$_extends({
                    type: "text",
                    value: "",
                    autoComplete: "off",
                    "aria-autocomplete": "list",
                    "aria-controls": itemsContainerId,
                    "aria-activedescendant": ariaActivedescendant
                }, theme("react-autowhatever-" + id + "-input", "input", isOpen && "inputOpen", isInputFocused && "inputFocused"), this.props.inputProps, {
                    onFocus: this.onFocus,
                    onBlur: this.onBlur,
                    onKeyDown: this.props.inputProps.onKeyDown && this.onKeyDown,
                    ref: this.storeInputReference
                }));
                var itemsContainer = renderItemsContainer({
                    containerProps: $7e608181f865f58f$var$_extends({
                        id: itemsContainerId,
                        role: "listbox"
                    }, theme("react-autowhatever-" + id + "-items-container", "itemsContainer", isOpen && "itemsContainerOpen"), {
                        ref: this.storeItemsContainerReference
                    }),
                    children: renderedItems
                });
                return $7e608181f865f58f$var$_react2.default.createElement("div", containerProps, inputComponent, itemsContainer);
            }
        }
    ]);
    return Autowhatever;
}($acw62.Component);
$7e608181f865f58f$var$Autowhatever.propTypes = {
    id: $7e608181f865f58f$var$_propTypes2.default.string,
    multiSection: $7e608181f865f58f$var$_propTypes2.default.bool,
    renderInputComponent: $7e608181f865f58f$var$_propTypes2.default.func,
    renderItemsContainer: $7e608181f865f58f$var$_propTypes2.default.func,
    items: $7e608181f865f58f$var$_propTypes2.default.array.isRequired,
    renderItem: $7e608181f865f58f$var$_propTypes2.default.func,
    renderItemData: $7e608181f865f58f$var$_propTypes2.default.object,
    renderSectionTitle: $7e608181f865f58f$var$_propTypes2.default.func,
    getSectionItems: $7e608181f865f58f$var$_propTypes2.default.func,
    containerProps: $7e608181f865f58f$var$_propTypes2.default.object,
    inputProps: $7e608181f865f58f$var$_propTypes2.default.object,
    itemProps: $7e608181f865f58f$var$_propTypes2.default.oneOfType([
        $7e608181f865f58f$var$_propTypes2.default.object,
        $7e608181f865f58f$var$_propTypes2.default.func
    ]),
    highlightedSectionIndex: $7e608181f865f58f$var$_propTypes2.default.number,
    highlightedItemIndex: $7e608181f865f58f$var$_propTypes2.default.number,
    theme: $7e608181f865f58f$var$_propTypes2.default.oneOfType([
        $7e608181f865f58f$var$_propTypes2.default.object,
        $7e608181f865f58f$var$_propTypes2.default.array
    ])
};
$7e608181f865f58f$var$Autowhatever.defaultProps = {
    id: "1",
    multiSection: false,
    renderInputComponent: $7e608181f865f58f$var$defaultRenderInputComponent,
    renderItemsContainer: $7e608181f865f58f$var$defaultRenderItemsContainer,
    renderItem: function renderItem() {
        throw new Error("`renderItem` must be provided");
    },
    renderItemData: $7e608181f865f58f$var$emptyObject,
    renderSectionTitle: function renderSectionTitle() {
        throw new Error("`renderSectionTitle` must be provided");
    },
    getSectionItems: function getSectionItems() {
        throw new Error("`getSectionItems` must be provided");
    },
    containerProps: $7e608181f865f58f$var$emptyObject,
    inputProps: $7e608181f865f58f$var$emptyObject,
    itemProps: $7e608181f865f58f$var$emptyObject,
    highlightedSectionIndex: null,
    highlightedItemIndex: null,
    theme: $7e608181f865f58f$var$defaultTheme
};
module.exports.default = $7e608181f865f58f$var$Autowhatever;

});
parcelRegister("bzeoG", function(module, exports) {
"use strict";
var $86be218cbea4ea95$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();
module.exports = function(_ref) {
    var data = _ref.data;
    var multiSection = _ref.multiSection;
    function nextNonEmptySectionIndex(sectionIndex) {
        if (sectionIndex === null) sectionIndex = 0;
        else sectionIndex++;
        while(sectionIndex < data.length && data[sectionIndex] === 0)sectionIndex++;
        return sectionIndex === data.length ? null : sectionIndex;
    }
    function prevNonEmptySectionIndex(sectionIndex) {
        if (sectionIndex === null) sectionIndex = data.length - 1;
        else sectionIndex--;
        while(sectionIndex >= 0 && data[sectionIndex] === 0)sectionIndex--;
        return sectionIndex === -1 ? null : sectionIndex;
    }
    function next(position) {
        var _position = $86be218cbea4ea95$var$_slicedToArray(position, 2);
        var sectionIndex = _position[0];
        var itemIndex = _position[1];
        if (multiSection) {
            if (itemIndex === null || itemIndex === data[sectionIndex] - 1) {
                sectionIndex = nextNonEmptySectionIndex(sectionIndex);
                if (sectionIndex === null) return [
                    null,
                    null
                ];
                return [
                    sectionIndex,
                    0
                ];
            }
            return [
                sectionIndex,
                itemIndex + 1
            ];
        }
        if (data === 0 || itemIndex === data - 1) return [
            null,
            null
        ];
        if (itemIndex === null) return [
            null,
            0
        ];
        return [
            null,
            itemIndex + 1
        ];
    }
    function prev(position) {
        var _position2 = $86be218cbea4ea95$var$_slicedToArray(position, 2);
        var sectionIndex = _position2[0];
        var itemIndex = _position2[1];
        if (multiSection) {
            if (itemIndex === null || itemIndex === 0) {
                sectionIndex = prevNonEmptySectionIndex(sectionIndex);
                if (sectionIndex === null) return [
                    null,
                    null
                ];
                return [
                    sectionIndex,
                    data[sectionIndex] - 1
                ];
            }
            return [
                sectionIndex,
                itemIndex - 1
            ];
        }
        if (data === 0 || itemIndex === 0) return [
            null,
            null
        ];
        if (itemIndex === null) return [
            null,
            data - 1
        ];
        return [
            null,
            itemIndex - 1
        ];
    }
    function isLast(position) {
        return next(position)[1] === null;
    }
    return {
        next: next,
        prev: prev,
        isLast: isLast
    };
};

});

parcelRegister("4zE4h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $354982f833249ff9$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();
function $354982f833249ff9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
function $354982f833249ff9$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}

var $kvkCT = parcelRequire("kvkCT");
var $354982f833249ff9$var$_objectAssign2 = $354982f833249ff9$var$_interopRequireDefault($kvkCT);
var $354982f833249ff9$var$truthy = function truthy(x) {
    return x;
};
module.exports["default"] = function(input) {
    var _ref = Array.isArray(input) && input.length === 2 ? input : [
        input,
        null
    ];
    var _ref2 = $354982f833249ff9$var$_slicedToArray(_ref, 2);
    var theme = _ref2[0];
    var classNameDecorator = _ref2[1];
    return function(key) {
        for(var _len = arguments.length, names = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)names[_key - 1] = arguments[_key];
        var styles = names.map(function(name) {
            return theme[name];
        }).filter($354982f833249ff9$var$truthy);
        return typeof styles[0] === "string" || typeof classNameDecorator === "function" ? {
            key: key,
            className: classNameDecorator ? classNameDecorator.apply(undefined, $354982f833249ff9$var$_toConsumableArray(styles)) : styles.join(" ")
        } : {
            key: key,
            style: $354982f833249ff9$var$_objectAssign2["default"].apply(undefined, [
                {}
            ].concat($354982f833249ff9$var$_toConsumableArray(styles)))
        };
    };
};
module.exports = module.exports["default"];

});
parcelRegister("kvkCT", function(module, exports) {
"use strict";
var $eed6b3db921550a1$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $eed6b3db921550a1$var$ToObject(val) {
    if (val == null) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $eed6b3db921550a1$var$ownEnumerableKeys(obj) {
    var keys = Object.getOwnPropertyNames(obj);
    if (Object.getOwnPropertySymbols) keys = keys.concat(Object.getOwnPropertySymbols(obj));
    return keys.filter(function(key) {
        return $eed6b3db921550a1$var$propIsEnumerable.call(obj, key);
    });
}
module.exports = Object.assign || function(target, source) {
    var from;
    var keys;
    var to = $eed6b3db921550a1$var$ToObject(target);
    for(var s = 1; s < arguments.length; s++){
        from = arguments[s];
        keys = $eed6b3db921550a1$var$ownEnumerableKeys(Object(from));
        for(var i = 0; i < keys.length; i++)to[keys[i]] = from[keys[i]];
    }
    return to;
};

});


parcelRegister("j8tXH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $dee601822abaab23$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $dee601822abaab23$var$_react2 = $dee601822abaab23$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");
var $dee601822abaab23$var$_propTypes2 = $dee601822abaab23$var$_interopRequireDefault($c9Z8w);

var $eEqWX = parcelRequire("eEqWX");
var $dee601822abaab23$var$_compareObjects2 = $dee601822abaab23$var$_interopRequireDefault($eEqWX);
function $dee601822abaab23$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $dee601822abaab23$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $dee601822abaab23$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $dee601822abaab23$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $dee601822abaab23$var$SectionTitle = function(_Component) {
    $dee601822abaab23$var$_inherits(SectionTitle, _Component);
    function SectionTitle() {
        $dee601822abaab23$var$_classCallCheck(this, SectionTitle);
        return $dee601822abaab23$var$_possibleConstructorReturn(this, (SectionTitle.__proto__ || Object.getPrototypeOf(SectionTitle)).apply(this, arguments));
    }
    $dee601822abaab23$var$_createClass(SectionTitle, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                return (0, $dee601822abaab23$var$_compareObjects2.default)(nextProps, this.props);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, section = _props.section, renderSectionTitle = _props.renderSectionTitle, theme = _props.theme, sectionKeyPrefix = _props.sectionKeyPrefix;
                var sectionTitle = renderSectionTitle(section);
                if (!sectionTitle) return null;
                return $dee601822abaab23$var$_react2.default.createElement("div", theme(sectionKeyPrefix + "title", "sectionTitle"), sectionTitle);
            }
        }
    ]);
    return SectionTitle;
}($acw62.Component);
$dee601822abaab23$var$SectionTitle.propTypes = {
    section: $dee601822abaab23$var$_propTypes2.default.any.isRequired,
    renderSectionTitle: $dee601822abaab23$var$_propTypes2.default.func.isRequired,
    theme: $dee601822abaab23$var$_propTypes2.default.func.isRequired,
    sectionKeyPrefix: $dee601822abaab23$var$_propTypes2.default.string.isRequired
};
module.exports.default = $dee601822abaab23$var$SectionTitle;

});
parcelRegister("eEqWX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $aaa9b4d5076feddf$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
module.exports.default = $aaa9b4d5076feddf$var$compareObjects;
function $aaa9b4d5076feddf$var$compareObjects(objA, objB) {
    var keys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    if (objA === objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    if (aKeys.length !== bKeys.length) return true;
    var keysMap = {};
    var i = void 0, len = void 0;
    for(i = 0, len = keys.length; i < len; i++)keysMap[keys[i]] = true;
    for(i = 0, len = aKeys.length; i < len; i++){
        var key = aKeys[i];
        var aValue = objA[key];
        var bValue = objB[key];
        if (aValue === bValue) continue;
        if (!keysMap[key] || aValue === null || bValue === null || (typeof aValue === "undefined" ? "undefined" : $aaa9b4d5076feddf$var$_typeof(aValue)) !== "object" || (typeof bValue === "undefined" ? "undefined" : $aaa9b4d5076feddf$var$_typeof(bValue)) !== "object") return true;
        var aValueKeys = Object.keys(aValue);
        var bValueKeys = Object.keys(bValue);
        if (aValueKeys.length !== bValueKeys.length) return true;
        for(var n = 0, length = aValueKeys.length; n < length; n++){
            var aValueKey = aValueKeys[n];
            if (aValue[aValueKey] !== bValue[aValueKey]) return true;
        }
    }
    return false;
}

});


parcelRegister("kAix6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $efc58baeb7c23d71$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $efc58baeb7c23d71$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $efc58baeb7c23d71$var$_react2 = $efc58baeb7c23d71$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");
var $efc58baeb7c23d71$var$_propTypes2 = $efc58baeb7c23d71$var$_interopRequireDefault($c9Z8w);

var $3wKgy = parcelRequire("3wKgy");
var $efc58baeb7c23d71$var$_Item2 = $efc58baeb7c23d71$var$_interopRequireDefault($3wKgy);

var $eEqWX = parcelRequire("eEqWX");
var $efc58baeb7c23d71$var$_compareObjects2 = $efc58baeb7c23d71$var$_interopRequireDefault($eEqWX);
function $efc58baeb7c23d71$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $efc58baeb7c23d71$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $efc58baeb7c23d71$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $efc58baeb7c23d71$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $efc58baeb7c23d71$var$ItemsList = function(_Component) {
    $efc58baeb7c23d71$var$_inherits(ItemsList, _Component);
    function ItemsList() {
        var _ref;
        var _temp, _this, _ret;
        $efc58baeb7c23d71$var$_classCallCheck(this, ItemsList);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $efc58baeb7c23d71$var$_possibleConstructorReturn(this, (_ref = ItemsList.__proto__ || Object.getPrototypeOf(ItemsList)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.storeHighlightedItemReference = function(highlightedItem) {
            _this.props.onHighlightedItemChange(highlightedItem === null ? null : highlightedItem.item);
        }, _temp), $efc58baeb7c23d71$var$_possibleConstructorReturn(_this, _ret);
    }
    $efc58baeb7c23d71$var$_createClass(ItemsList, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                return (0, $efc58baeb7c23d71$var$_compareObjects2.default)(nextProps, this.props, [
                    "itemProps"
                ]);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _props = this.props, items = _props.items, itemProps = _props.itemProps, renderItem = _props.renderItem, renderItemData = _props.renderItemData, sectionIndex = _props.sectionIndex, highlightedItemIndex = _props.highlightedItemIndex, getItemId = _props.getItemId, theme = _props.theme, keyPrefix = _props.keyPrefix;
                var sectionPrefix = sectionIndex === null ? keyPrefix : keyPrefix + "section-" + sectionIndex + "-";
                var isItemPropsFunction = typeof itemProps === "function";
                return $efc58baeb7c23d71$var$_react2.default.createElement("ul", $efc58baeb7c23d71$var$_extends({
                    role: "listbox"
                }, theme(sectionPrefix + "items-list", "itemsList")), items.map(function(item, itemIndex) {
                    var isFirst = itemIndex === 0;
                    var isHighlighted = itemIndex === highlightedItemIndex;
                    var itemKey = sectionPrefix + "item-" + itemIndex;
                    var itemPropsObj = isItemPropsFunction ? itemProps({
                        sectionIndex: sectionIndex,
                        itemIndex: itemIndex
                    }) : itemProps;
                    var allItemProps = $efc58baeb7c23d71$var$_extends({
                        id: getItemId(sectionIndex, itemIndex),
                        "aria-selected": isHighlighted
                    }, theme(itemKey, "item", isFirst && "itemFirst", isHighlighted && "itemHighlighted"), itemPropsObj);
                    if (isHighlighted) allItemProps.ref = _this2.storeHighlightedItemReference;
                    // `key` is provided by theme()
                    /* eslint-disable react/jsx-key */ return $efc58baeb7c23d71$var$_react2.default.createElement($efc58baeb7c23d71$var$_Item2.default, $efc58baeb7c23d71$var$_extends({}, allItemProps, {
                        sectionIndex: sectionIndex,
                        isHighlighted: isHighlighted,
                        itemIndex: itemIndex,
                        item: item,
                        renderItem: renderItem,
                        renderItemData: renderItemData
                    }));
                /* eslint-enable react/jsx-key */ }));
            }
        }
    ]);
    return ItemsList;
}($acw62.Component);
$efc58baeb7c23d71$var$ItemsList.propTypes = {
    items: $efc58baeb7c23d71$var$_propTypes2.default.array.isRequired,
    itemProps: $efc58baeb7c23d71$var$_propTypes2.default.oneOfType([
        $efc58baeb7c23d71$var$_propTypes2.default.object,
        $efc58baeb7c23d71$var$_propTypes2.default.func
    ]),
    renderItem: $efc58baeb7c23d71$var$_propTypes2.default.func.isRequired,
    renderItemData: $efc58baeb7c23d71$var$_propTypes2.default.object.isRequired,
    sectionIndex: $efc58baeb7c23d71$var$_propTypes2.default.number,
    highlightedItemIndex: $efc58baeb7c23d71$var$_propTypes2.default.number,
    onHighlightedItemChange: $efc58baeb7c23d71$var$_propTypes2.default.func.isRequired,
    getItemId: $efc58baeb7c23d71$var$_propTypes2.default.func.isRequired,
    theme: $efc58baeb7c23d71$var$_propTypes2.default.func.isRequired,
    keyPrefix: $efc58baeb7c23d71$var$_propTypes2.default.string.isRequired
};
$efc58baeb7c23d71$var$ItemsList.defaultProps = {
    sectionIndex: null
};
module.exports.default = $efc58baeb7c23d71$var$ItemsList;

});
parcelRegister("3wKgy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $29183fbabf40f0f5$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $29183fbabf40f0f5$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $29183fbabf40f0f5$var$_react2 = $29183fbabf40f0f5$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");
var $29183fbabf40f0f5$var$_propTypes2 = $29183fbabf40f0f5$var$_interopRequireDefault($c9Z8w);

var $eEqWX = parcelRequire("eEqWX");
var $29183fbabf40f0f5$var$_compareObjects2 = $29183fbabf40f0f5$var$_interopRequireDefault($eEqWX);
function $29183fbabf40f0f5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $29183fbabf40f0f5$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $29183fbabf40f0f5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $29183fbabf40f0f5$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $29183fbabf40f0f5$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $29183fbabf40f0f5$var$Item = function(_Component) {
    $29183fbabf40f0f5$var$_inherits(Item, _Component);
    function Item() {
        var _ref;
        var _temp, _this, _ret;
        $29183fbabf40f0f5$var$_classCallCheck(this, Item);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $29183fbabf40f0f5$var$_possibleConstructorReturn(this, (_ref = Item.__proto__ || Object.getPrototypeOf(Item)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.storeItemReference = function(item) {
            if (item !== null) _this.item = item;
        }, _this.onMouseEnter = function(event) {
            var _this$props = _this.props, sectionIndex = _this$props.sectionIndex, itemIndex = _this$props.itemIndex;
            _this.props.onMouseEnter(event, {
                sectionIndex: sectionIndex,
                itemIndex: itemIndex
            });
        }, _this.onMouseLeave = function(event) {
            var _this$props2 = _this.props, sectionIndex = _this$props2.sectionIndex, itemIndex = _this$props2.itemIndex;
            _this.props.onMouseLeave(event, {
                sectionIndex: sectionIndex,
                itemIndex: itemIndex
            });
        }, _this.onMouseDown = function(event) {
            var _this$props3 = _this.props, sectionIndex = _this$props3.sectionIndex, itemIndex = _this$props3.itemIndex;
            _this.props.onMouseDown(event, {
                sectionIndex: sectionIndex,
                itemIndex: itemIndex
            });
        }, _this.onClick = function(event) {
            var _this$props4 = _this.props, sectionIndex = _this$props4.sectionIndex, itemIndex = _this$props4.itemIndex;
            _this.props.onClick(event, {
                sectionIndex: sectionIndex,
                itemIndex: itemIndex
            });
        }, _temp), $29183fbabf40f0f5$var$_possibleConstructorReturn(_this, _ret);
    }
    $29183fbabf40f0f5$var$_createClass(Item, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                return (0, $29183fbabf40f0f5$var$_compareObjects2.default)(nextProps, this.props, [
                    "renderItemData"
                ]);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, isHighlighted = _props.isHighlighted, item = _props.item, renderItem = _props.renderItem, renderItemData = _props.renderItemData, restProps = $29183fbabf40f0f5$var$_objectWithoutProperties(_props, [
                    "isHighlighted",
                    "item",
                    "renderItem",
                    "renderItemData"
                ]);
                delete restProps.sectionIndex;
                delete restProps.itemIndex;
                if (typeof restProps.onMouseEnter === "function") restProps.onMouseEnter = this.onMouseEnter;
                if (typeof restProps.onMouseLeave === "function") restProps.onMouseLeave = this.onMouseLeave;
                if (typeof restProps.onMouseDown === "function") restProps.onMouseDown = this.onMouseDown;
                if (typeof restProps.onClick === "function") restProps.onClick = this.onClick;
                return $29183fbabf40f0f5$var$_react2.default.createElement("li", $29183fbabf40f0f5$var$_extends({
                    role: "option"
                }, restProps, {
                    ref: this.storeItemReference
                }), renderItem(item, $29183fbabf40f0f5$var$_extends({
                    isHighlighted: isHighlighted
                }, renderItemData)));
            }
        }
    ]);
    return Item;
}($acw62.Component);
$29183fbabf40f0f5$var$Item.propTypes = {
    sectionIndex: $29183fbabf40f0f5$var$_propTypes2.default.number,
    isHighlighted: $29183fbabf40f0f5$var$_propTypes2.default.bool.isRequired,
    itemIndex: $29183fbabf40f0f5$var$_propTypes2.default.number.isRequired,
    item: $29183fbabf40f0f5$var$_propTypes2.default.any.isRequired,
    renderItem: $29183fbabf40f0f5$var$_propTypes2.default.func.isRequired,
    renderItemData: $29183fbabf40f0f5$var$_propTypes2.default.object.isRequired,
    onMouseEnter: $29183fbabf40f0f5$var$_propTypes2.default.func,
    onMouseLeave: $29183fbabf40f0f5$var$_propTypes2.default.func,
    onMouseDown: $29183fbabf40f0f5$var$_propTypes2.default.func,
    onClick: $29183fbabf40f0f5$var$_propTypes2.default.func
};
module.exports.default = $29183fbabf40f0f5$var$Item;

});




parcelRegister("5IbB8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $428a0eeb1331c510$var$defaultTheme = module.exports.defaultTheme = {
    container: "react-autosuggest__container",
    containerOpen: "react-autosuggest__container--open",
    input: "react-autosuggest__input",
    inputOpen: "react-autosuggest__input--open",
    inputFocused: "react-autosuggest__input--focused",
    suggestionsContainer: "react-autosuggest__suggestions-container",
    suggestionsContainerOpen: "react-autosuggest__suggestions-container--open",
    suggestionsList: "react-autosuggest__suggestions-list",
    suggestion: "react-autosuggest__suggestion",
    suggestionFirst: "react-autosuggest__suggestion--first",
    suggestionHighlighted: "react-autosuggest__suggestion--highlighted",
    sectionContainer: "react-autosuggest__section-container",
    sectionContainerFirst: "react-autosuggest__section-container--first",
    sectionTitle: "react-autosuggest__section-title"
};
var $428a0eeb1331c510$var$mapToAutowhateverTheme = module.exports.mapToAutowhateverTheme = function mapToAutowhateverTheme(theme) {
    var result = {};
    for(var key in theme)switch(key){
        case "suggestionsContainer":
            result["itemsContainer"] = theme[key];
            break;
        case "suggestionsContainerOpen":
            result["itemsContainerOpen"] = theme[key];
            break;
        case "suggestion":
            result["item"] = theme[key];
            break;
        case "suggestionFirst":
            result["itemFirst"] = theme[key];
            break;
        case "suggestionHighlighted":
            result["itemHighlighted"] = theme[key];
            break;
        case "suggestionsList":
            result["itemsList"] = theme[key];
            break;
        default:
            result[key] = theme[key];
    }
    return result;
};

});




parcelRegister("5yshQ", function(module, exports) {
"use strict";
var $40b611e11bc08db5$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $40b611e11bc08db5$var$react_1 = $40b611e11bc08db5$var$__importDefault((parcelRequire("acw62")));
parcelRequire("fHiKR");
var $kN5vy = parcelRequire("kN5vy");
const $40b611e11bc08db5$var$RadioWidget = (props)=>{
    const { options: //
    options, value: value, required: required, disabled: disabled, readonly: readonly, autofocus: autofocus = false, onBlur: onBlur, onFocus: onFocus, onChange: onChange, id: id } = props;
    // Generating a unique field name to identify this set of radio buttons
    const name = Math.random().toString();
    const { enumOptions: enumOptions, enumDisabled: enumDisabled, inline: inline } = options;
    // checked={checked} has been moved above name={name}, As mentioned in #349;
    // this is a temporary fix for radio button rendering bug in React, facebook/react#7630.
    return $40b611e11bc08db5$var$react_1.default.createElement("fieldset", {
        className: "field-radio-group",
        id: id
    }, enumOptions.map((option, i)=>{
        const checked = option.value === value;
        const itemDisabled = enumDisabled && enumDisabled.indexOf(option.value) !== -1;
        const disabledCls = disabled || itemDisabled || readonly ? "disabled" : "";
        const radio = $40b611e11bc08db5$var$react_1.default.createElement("input", {
            type: "radio",
            checked: checked,
            id: option.value,
            name: name,
            required: required,
            value: option.value,
            disabled: disabled || itemDisabled || readonly,
            autoFocus: autofocus && i === 0,
            className: "custom-control-input",
            onChange: ()=>onChange(option.value),
            onBlur: onBlur && ((event)=>onBlur(id, event.target.value)),
            onFocus: onFocus && ((event)=>onFocus(id, event.target.value))
        });
        return inline ? $40b611e11bc08db5$var$react_1.default.createElement("div", {
            key: i,
            className: `custom-radio custom-control custom-control-inline ${disabledCls}`
        }, radio, $40b611e11bc08db5$var$react_1.default.createElement($kN5vy.default, {
            dataLwtId: `label-${option.value}`,
            className: "custom-control-label",
            for: option.value
        }, option.label)) : $40b611e11bc08db5$var$react_1.default.createElement("div", {
            key: i,
            className: `custom-radio custom-control ${disabledCls}`
        }, radio, $40b611e11bc08db5$var$react_1.default.createElement($kN5vy.default, {
            dataLwtId: `label-${option.value}`,
            className: "custom-control-label",
            for: option.value
        }, option.label));
    }));
};
module.exports.default = $40b611e11bc08db5$var$RadioWidget;

});

parcelRegister("dNig3", function(module, exports) {
"use strict";
var $a0ae039d6a2294af$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $a0ae039d6a2294af$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $a0ae039d6a2294af$var$react_1 = $a0ae039d6a2294af$var$__importDefault((parcelRequire("acw62")));

const $a0ae039d6a2294af$var$classnames_1 = $a0ae039d6a2294af$var$__importDefault((parcelRequire("8g1PZ")));

const $a0ae039d6a2294af$var$date_picker_1 = $a0ae039d6a2294af$var$__importDefault((parcelRequire("3qQ5g")));
const $a0ae039d6a2294af$var$DatePickerWidget = (props)=>{
    const { id: //
    id, dataLwtId: dataLwtId, options: options, rawErrors: rawErrors, className: className, onBlur: onBlur, onFocus: onFocus } = props, restProps = $a0ae039d6a2294af$var$__rest(props, [
        "id",
        "dataLwtId",
        "options",
        "rawErrors",
        "className",
        "onBlur",
        "onFocus"
    ]);
    const displayFormat = options && options.displayFormat ? options.displayFormat : "MM/dd/yyyy";
    const backEndFormat = options && options.backEndFormat ? options.backEndFormat : "yyyy-MM-dd";
    const placeholderText = options && options.placeholderText ? options.placeholderText : displayFormat;
    const datePickerOnBlur = (event)=>{
        const onBlurEvent = event.target;
        onBlur && onBlur(id, onBlurEvent.value);
    };
    const datePickerOnFocus = (event)=>{
        const onFocusEvent = event.target;
        onFocus && onFocus(id, onFocusEvent.value);
    };
    const cssClasses = (0, $a0ae039d6a2294af$var$classnames_1.default)(className, rawErrors && rawErrors.length > 0 && "is-invalid");
    // WidgetProps and DatePickerProps have incompatible definitions for 'onselect'
    //  DatePicker will not accept WidgetProps.onSelect's definition and BaseForm requires a WidgetProps object
    //  setting this as 'any' satisfies both needs for the time being
    const restPropsAsAny = restProps;
    return $a0ae039d6a2294af$var$react_1.default.createElement($a0ae039d6a2294af$var$date_picker_1.default, Object.assign({}, restPropsAsAny, {
        dataLwtId: `dp-${dataLwtId}`,
        className: cssClasses,
        displayFormat: displayFormat,
        backEndFormat: backEndFormat,
        placeholderText: placeholderText,
        onBlur: datePickerOnBlur,
        onFocus: datePickerOnFocus
    }));
};
module.exports.default = $a0ae039d6a2294af$var$DatePickerWidget;

});
parcelRegister("3qQ5g", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $27fc339833121e86$export$2e2bcd8739ae039);

var $8ofpx = parcelRequire("8ofpx");
var $27fc339833121e86$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($8ofpx)));

});
parcelRegister("8ofpx", function(module, exports) {
"use strict";
var $61bc84e858533039$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $61bc84e858533039$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $61bc84e858533039$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $61bc84e858533039$var$__createBinding(result, mod, k);
    }
    $61bc84e858533039$var$__setModuleDefault(result, mod);
    return result;
};
var $61bc84e858533039$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $61bc84e858533039$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $61bc84e858533039$var$react_1 = $61bc84e858533039$var$__importStar((parcelRequire("acw62")));

const $61bc84e858533039$var$react_datepicker_1 = $61bc84e858533039$var$__importStar((parcelRequire("hrXzG")));

var $6IhJz = parcelRequire("6IhJz");
var $cFZfS = parcelRequire("cFZfS");

const $61bc84e858533039$var$classnames_1 = $61bc84e858533039$var$__importDefault((parcelRequire("8g1PZ")));

const $61bc84e858533039$var$react_text_mask_1 = $61bc84e858533039$var$__importDefault((parcelRequire("8H68z")));



const $61bc84e858533039$var$Locales = $61bc84e858533039$var$__importStar((parcelRequire("j9gmE")));

const $61bc84e858533039$var$Portal_1 = $61bc84e858533039$var$__importDefault((parcelRequire("92FXn")));
const $61bc84e858533039$var$LocalesArray = Object.values($61bc84e858533039$var$Locales);
class $61bc84e858533039$var$DatePicker extends $61bc84e858533039$var$react_1.Component {
    constructor(props){
        super(props);
        this.handleDivChange = (event)=>{
            let selectedDate;
            let backEndDateValue;
            if (event && event.target) {
                const inputEvent = event.target;
                const displayDate = new Date(inputEvent.value);
                if (!(0, $cFZfS.default)(displayDate) || $61bc84e858533039$var$DatePicker.isYearGreaterThan10000(displayDate)) {
                    event.preventDefault();
                    return;
                }
                if (displayDate) {
                    if (!isNaN(displayDate.getTime())) {
                        selectedDate = displayDate;
                        backEndDateValue = (0, $6IhJz.default)(selectedDate, this.state.backEndFormat);
                    } else {
                        selectedDate = this.state.selectedDate;
                        backEndDateValue = this.state.selectedDate && (0, $6IhJz.default)(this.state.selectedDate, this.state.backEndFormat);
                    }
                } else selectedDate = null;
                this.changeState(selectedDate, backEndDateValue);
            }
        };
        this.handleChange = (date)=>{
            if (date && $61bc84e858533039$var$DatePicker.isYearGreaterThan10000(date)) return;
            const backEndDateValue = date ? (0, $6IhJz.default)(date, this.state.backEndFormat) : undefined;
            this.changeState(date, backEndDateValue);
        };
        this.handleRefChange = (ref)=>{
            if (ref) this.datePickerRef = ref;
        };
        this.handleKeyDown = (e)=>{
            if (e.key === "Tab") // close the calendar if tab is pressed
            this.datePickerRef.setOpen(false);
            this.props.onKeyDown && this.props.onKeyDown(e);
        };
        this.handleCalendarClose = ()=>{
            // Work around for input not blurring when calendar is closed
            // This is a know issue with react-datepicker and can be removed when it is fixed
            // https://github.com/Hacker0x01/react-datepicker/issues/2028
            if (this.datePickerRef.input && this.datePickerRef.input.focus) {
                this.datePickerRef.input.focus();
                this.datePickerRef.input.blur();
            }
            if (this.datePickerRef.input.inputElement && this.datePickerRef.input.inputElement.focus) {
                this.datePickerRef.input.inputElement.focus();
                this.datePickerRef.input.inputElement.blur();
            }
            this.props.onCalendarClose && this.props.onCalendarClose();
        };
        this.changeState = (selectedDate, backEndDateValue)=>{
            this.setState({
                selectedDate: selectedDate
            }, ()=>{
                if (this.props.onChange) this.props.onChange(backEndDateValue);
            });
        };
        this.datePickerRef = $61bc84e858533039$var$react_1.default.createRef();
        const value = this.props.value && $61bc84e858533039$var$DatePicker.formatDate(this.props.value);
        this.state = {
            selectedDate: value ? new Date(value.includes("T") ? value.replace(/T.+/, "") : value) : null,
            placeholderText: this.props.placeholderText ? this.props.placeholderText : this.props.displayFormat ? this.props.displayFormat : "MM/DD/YYYY",
            className: this.props.className ? this.props.className : "form-control",
            classNameContainer: this.props.fullWidth ? "react-datepicker-full-width" : "",
            displayFormat: this.props.displayFormat ? this.props.displayFormat : "MM/dd/yyyy",
            backEndFormat: this.props.backEndFormat ? this.props.backEndFormat : "yyyy-MM-dd",
            locale: this.props.locale ? this.props.locale : "en-US"
        };
        $61bc84e858533039$var$DatePicker.registerLocalization(this.props.locale);
    }
    static formatDate(date) {
        return date.replace(/-/g, "/").replace(/\./g, "/");
    }
    static isYearGreaterThan10000(date) {
        return Math.round(date.getFullYear() / 10000) > 0;
    }
    static registerLocalization(code) {
        if (code) {
            const locale = $61bc84e858533039$var$LocalesArray.find((l)=>l.code === code);
            if (locale && locale.code) (0, $61bc84e858533039$var$react_datepicker_1.registerLocale)(locale.code, locale);
        }
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState((prevState)=>{
            const value = nextProps.value && $61bc84e858533039$var$DatePicker.formatDate(nextProps.value);
            const date = value && new Date(value.includes("T") ? value.replace(/T.+/, "") : value) || undefined;
            const className = (0, $61bc84e858533039$var$classnames_1.default)(nextProps.className, prevState.className.indexOf("form-control") !== -1 && "form-control");
            if (nextProps.locale !== prevState.locale) $61bc84e858533039$var$DatePicker.registerLocalization(nextProps.locale);
            return Object.assign(Object.assign({}, prevState), {
                selectedDate: date !== undefined && !isNaN(date.getTime()) ? date : null,
                className: className,
                classNameContainer: this.props.fullWidth ? "react-datepicker-full-width" : ""
            });
        });
    }
    render() {
        var _a;
        const _b = this.props, { value: value, placeholderText: placeholderText, displayFormat: displayFormat, className: className, backEndFormat: backEndFormat, locale: locale, usePortal: usePortal, dataLwtId: dataLwtId, readOnly: readOnly, onChange: onChange, onBlur: onBlur, onFocus: onFocus, maskCharacter: maskCharacter = (_a = this.props.maskCharacter) !== null && _a !== void 0 ? _a : "/", mask: mask, onKeyDown: onKeyDown, onCalendarClose: onCalendarClose } = _b, restProps = $61bc84e858533039$var$__rest(_b, [
            "value",
            "placeholderText",
            "displayFormat",
            "className",
            "backEndFormat",
            "locale",
            "usePortal",
            "dataLwtId",
            "readOnly",
            "onChange",
            "onBlur",
            "onFocus",
            "maskCharacter",
            "mask",
            "onKeyDown",
            "onCalendarClose"
        ]);
        // const maskCharacter = this.props.maskCharacter ?? '/';
        const maskCollection = [];
        if (mask && displayFormat) {
            let maskSeparator;
            for(let i = 0; i < displayFormat.length; i++){
                const char = displayFormat.charAt(i);
                switch(char){
                    case "M":
                    case "d":
                    case "y":
                        maskCollection.push(/\d/);
                        break;
                    default:
                        if (maskCollection.length > 0) {
                            if (!maskSeparator) maskSeparator = char;
                            if (char === maskSeparator) maskCollection.push(maskCharacter);
                        }
                        break;
                }
            }
        }
        const optionalProps = {};
        if (usePortal) {
            optionalProps.popperContainer = $61bc84e858533039$var$Portal_1.default;
            optionalProps.popperModifiers = {
                preventOverflow: {
                    enabled: true
                }
            };
        }
        return $61bc84e858533039$var$react_1.default.createElement("div", {
            "data-lwt-id": dataLwtId,
            className: this.state.classNameContainer,
            onChange: this.handleDivChange,
            onClick: (e)=>e.stopPropagation()
        }, $61bc84e858533039$var$react_1.default.createElement($61bc84e858533039$var$react_datepicker_1.default, Object.assign({
            className: this.state.className,
            selected: this.state.selectedDate,
            onChange: this.handleChange,
            isClearable: !readOnly,
            dateFormat: this.state.displayFormat,
            placeholderText: this.state.placeholderText,
            onBlur: onBlur,
            onFocus: onFocus,
            onKeyDown: (e)=>this.handleKeyDown(e),
            onCalendarClose: ()=>this.handleCalendarClose(),
            readOnly: readOnly,
            locale: locale,
            customInput: mask && $61bc84e858533039$var$react_1.default.createElement($61bc84e858533039$var$react_text_mask_1.default, {
                type: "text",
                mask: maskCollection
            })
        }, optionalProps, restProps, {
            ref: this.handleRefChange
        })));
    }
}
module.exports.default = $61bc84e858533039$var$DatePicker;

});
parcelRegister("hrXzG", function(module, exports) {






























































!function(e, t) {
    t(module.exports, (parcelRequire("acw62")), (parcelRequire("c9Z8w")), (parcelRequire("8g1PZ")), (parcelRequire("9BdaM")), (parcelRequire("cFZfS")), (parcelRequire("6IhJz")), (parcelRequire("bTSG2")), (parcelRequire("kehhj")), (parcelRequire("6OX6Q")), (parcelRequire("2MTnF")), (parcelRequire("eqWMS")), (parcelRequire("kbDwl")), (parcelRequire("8o58w")), (parcelRequire("58cSq")), (parcelRequire("4irF8")), (parcelRequire("lDduA")), (parcelRequire("lXe7Q")), (parcelRequire("4UG1B")), (parcelRequire("6fhf3")), (parcelRequire("aABJG")), (parcelRequire("kjLiX")), (parcelRequire("34ylv")), (parcelRequire("eZOMj")), (parcelRequire("hbMru")), (parcelRequire("4UeRq")), (parcelRequire("3LPyO")), (parcelRequire("knAHj")), (parcelRequire("2SwgK")), (parcelRequire("d0W11")), (parcelRequire("6mdUF")), (parcelRequire("gpyWg")), (parcelRequire("cZ2kT")), (parcelRequire("fVhCa")), (parcelRequire("3lKFD")), (parcelRequire("8v9st")), (parcelRequire("6atcA")), (parcelRequire("lm2ga")), (parcelRequire("1Whvr")), (parcelRequire("e4h6L")), (parcelRequire("jMhzE")), (parcelRequire("cJfMa")), (parcelRequire("7yBDJ")), (parcelRequire("5E40x")), (parcelRequire("gVPZO")), (parcelRequire("6eIgt")), (parcelRequire("6uyHy")), (parcelRequire("75XN4")), (parcelRequire("l2vHo")), (parcelRequire("gd5RE")), (parcelRequire("hjw1k")), (parcelRequire("b27pX")), (parcelRequire("R4xmB")), (parcelRequire("kggGd")), (parcelRequire("baBa1")), (parcelRequire("4YTY5")), (parcelRequire("gDwFN")), (parcelRequire("gdr0J")), (parcelRequire("auRgN")), (parcelRequire("dpjX2")), (parcelRequire("hL3CS")), (parcelRequire("1u0KT")), (parcelRequire("fiaok")));
}(module.exports, function(e, t, r, a, n, o, s, i, p, l, d, c, u, f, h, m, y, D, v, w, g, k, b, S, C, _, M, P, E, N, x, O, Y, I, T, L, R, F, A, q, W, B, K, H, j, Q, V, U, $, z, G, J, X, Z, ee, te, re, ae, ne, oe, se, ie, pe) {
    "use strict";
    function le(e) {
        return e && "object" == typeof e && "default" in e ? e : {
            default: e
        };
    }
    var de = le(t), ce = le(a), ue = le(n), fe = le(o), he = le(s), me = le(i), ye = le(p), De = le(l), ve = le(d), we = le(c), ge = le(u), ke = le(m), be = le(y), Se = le(D), Ce = le(v), _e = le(w), Me = le(g), Pe = le(k), Ee = le(b), Ne = le(S), xe = le(C), Oe = le(_), Ye = le(M), Ie = le(P), Te = le(E), Le = le(N), Re = le(x), Fe = le(O), Ae = le(Y), qe = le(I), We = le(T), Be = le(L), Ke = le(R), He = le(F), je = le(A), Qe = le(W), Ve = le(B), Ue = le(K), $e = le(H), ze = le(j), Ge = le(Q), Je = le(V), Xe = le(z), Ze = le(G), et = le(J), tt = le(X), rt = le(Z), at = le(ee), nt = le(te), ot = le(re), st = le(ae), it = le(ne), pt = le(oe), lt = le(se), dt = le(ie);
    function ct(e, t) {
        var r = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var a = Object.getOwnPropertySymbols(e);
            t && (a = a.filter(function(t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })), r.push.apply(r, a);
        }
        return r;
    }
    function ut(e) {
        for(var t = 1; t < arguments.length; t++){
            var r = null != arguments[t] ? arguments[t] : {};
            t % 2 ? ct(Object(r), !0).forEach(function(t) {
                Dt(e, t, r[t]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ct(Object(r)).forEach(function(t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
            });
        }
        return e;
    }
    function ft(e) {
        return (ft = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e;
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
        })(e);
    }
    function ht(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }
    function mt(e, t) {
        for(var r = 0; r < t.length; r++){
            var a = t[r];
            a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
        }
    }
    function yt(e, t, r) {
        return t && mt(e.prototype, t), r && mt(e, r), Object.defineProperty(e, "prototype", {
            writable: !1
        }), e;
    }
    function Dt(e, t, r) {
        return t in e ? Object.defineProperty(e, t, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = r, e;
    }
    function vt() {
        return (vt = Object.assign || function(e) {
            for(var t = 1; t < arguments.length; t++){
                var r = arguments[t];
                for(var a in r)Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
            }
            return e;
        }).apply(this, arguments);
    }
    function wt(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        Object.defineProperty(e, "prototype", {
            value: Object.create(t && t.prototype, {
                constructor: {
                    value: e,
                    writable: !0,
                    configurable: !0
                }
            }),
            writable: !1
        }), t && kt(e, t);
    }
    function gt(e) {
        return (gt = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
            return e.__proto__ || Object.getPrototypeOf(e);
        })(e);
    }
    function kt(e, t) {
        return (kt = Object.setPrototypeOf || function(e, t) {
            return e.__proto__ = t, e;
        })(e, t);
    }
    function bt(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e;
    }
    function St(e, t) {
        if (t && ("object" == typeof t || "function" == typeof t)) return t;
        if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
        return bt(e);
    }
    function Ct(e) {
        var t = function() {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
            } catch (e) {
                return !1;
            }
        }();
        return function() {
            var r, a = gt(e);
            if (t) {
                var n = gt(this).constructor;
                r = Reflect.construct(a, arguments, n);
            } else r = a.apply(this, arguments);
            return St(this, r);
        };
    }
    function _t(e) {
        return function(e) {
            if (Array.isArray(e)) return Mt(e);
        }(e) || function(e) {
            if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
        }(e) || function(e, t) {
            if (!e) return;
            if ("string" == typeof e) return Mt(e, t);
            var r = Object.prototype.toString.call(e).slice(8, -1);
            "Object" === r && e.constructor && (r = e.constructor.name);
            if ("Map" === r || "Set" === r) return Array.from(e);
            if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return Mt(e, t);
        }(e) || function() {
            throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
        }();
    }
    function Mt(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for(var r = 0, a = new Array(t); r < t; r++)a[r] = e[r];
        return a;
    }
    function Pt(e, t) {
        switch(e){
            case "P":
                return t.date({
                    width: "short"
                });
            case "PP":
                return t.date({
                    width: "medium"
                });
            case "PPP":
                return t.date({
                    width: "long"
                });
            case "PPPP":
            default:
                return t.date({
                    width: "full"
                });
        }
    }
    function Et(e, t) {
        switch(e){
            case "p":
                return t.time({
                    width: "short"
                });
            case "pp":
                return t.time({
                    width: "medium"
                });
            case "ppp":
                return t.time({
                    width: "long"
                });
            case "pppp":
            default:
                return t.time({
                    width: "full"
                });
        }
    }
    var Nt = {
        p: Et,
        P: function(e, t) {
            var r, a = e.match(/(P+)(p+)?/) || [], n = a[1], o = a[2];
            if (!o) return Pt(e, t);
            switch(n){
                case "P":
                    r = t.dateTime({
                        width: "short"
                    });
                    break;
                case "PP":
                    r = t.dateTime({
                        width: "medium"
                    });
                    break;
                case "PPP":
                    r = t.dateTime({
                        width: "long"
                    });
                    break;
                case "PPPP":
                default:
                    r = t.dateTime({
                        width: "full"
                    });
            }
            return r.replace("{{date}}", Pt(n, t)).replace("{{time}}", Et(o, t));
        }
    }, xt = 12, Ot = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
    function Yt(e) {
        var t = e ? "string" == typeof e || e instanceof String ? pt.default(e) : st.default(e) : new Date;
        return Tt(t) ? t : null;
    }
    function It(e, t, r, a, n) {
        var o = null, s = Xt(r) || Xt(Jt()), i = !0;
        return Array.isArray(t) ? (t.forEach(function(t) {
            var p = it.default(e, t, new Date, {
                locale: s
            });
            a && (i = Tt(p, n) && e === Lt(p, t, r)), Tt(p, n) && i && (o = p);
        }), o) : (o = it.default(e, t, new Date, {
            locale: s
        }), a ? i = Tt(o) && e === Lt(o, t, r) : Tt(o) || (t = t.match(Ot).map(function(e) {
            var t = e[0];
            return "p" === t || "P" === t ? s ? (0, Nt[t])(e, s.formatLong) : t : e;
        }).join(""), e.length > 0 && (o = it.default(e, t.slice(0, e.length), new Date)), Tt(o) || (o = new Date(e))), Tt(o) && i ? o : null);
    }
    function Tt(e, t) {
        return t = t || new Date("1/1/1000"), fe.default(e) && !nt.default(e, t);
    }
    function Lt(e, t, r) {
        if ("en" === r) return he.default(e, t, {
            awareOfUnicodeTokens: !0
        });
        var a = Xt(r);
        return r && !a && console.warn('A locale object was not found for the provided string ["'.concat(r, '"].')), !a && Jt() && Xt(Jt()) && (a = Xt(Jt())), he.default(e, t, {
            locale: a || null,
            awareOfUnicodeTokens: !0
        });
    }
    function Rt(e, t) {
        var r = t.dateFormat, a = t.locale;
        return e && Lt(e, Array.isArray(r) ? r[0] : r, a) || "";
    }
    function Ft(e, t) {
        var r = t.hour, a = void 0 === r ? 0 : r, n = t.minute, o = void 0 === n ? 0 : n, s = t.second, i = void 0 === s ? 0 : s;
        return Fe.default(Re.default(Le.default(e, i), o), a);
    }
    function At(e, t) {
        var r = t && Xt(t) || Jt() && Xt(Jt());
        return xe.default(e, r ? {
            locale: r
        } : null);
    }
    function qt(e, t) {
        return Lt(e, "ddd", t);
    }
    function Wt(e) {
        return Ve.default(e);
    }
    function Bt(e, t, r) {
        var a = Xt(t || Jt());
        return Ue.default(e, {
            locale: a,
            weekStartsOn: r
        });
    }
    function Kt(e) {
        return $e.default(e);
    }
    function Ht(e) {
        return Ge.default(e);
    }
    function jt(e) {
        return ze.default(e);
    }
    function Qt(e, t) {
        return e && t ? tt.default(e, t) : !e && !t;
    }
    function Vt(e, t) {
        return e && t ? et.default(e, t) : !e && !t;
    }
    function Ut(e, t) {
        return e && t ? rt.default(e, t) : !e && !t;
    }
    function $t(e, t) {
        return e && t ? Ze.default(e, t) : !e && !t;
    }
    function zt(e, t) {
        return e && t ? Xe.default(e, t) : !e && !t;
    }
    function Gt(e, t, r) {
        var a, n = Ve.default(t), o = Je.default(r);
        try {
            a = ot.default(e, {
                start: n,
                end: o
            });
        } catch (e) {
            a = !1;
        }
        return a;
    }
    function Jt() {
        return ("undefined" != typeof window ? window : globalThis).__localeId__;
    }
    function Xt(e) {
        if ("string" == typeof e) {
            var t = "undefined" != typeof window ? window : globalThis;
            return t.__localeData__ ? t.__localeData__[e] : null;
        }
        return e;
    }
    function Zt(e, t) {
        return Lt(Ae.default(Yt(), e), "LLLL", t);
    }
    function er(e, t) {
        return Lt(Ae.default(Yt(), e), "LLL", t);
    }
    function tr(e, t) {
        return Lt(qe.default(Yt(), e), "QQQ", t);
    }
    function rr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.maxDate, n = t.excludeDates, o = t.excludeDateIntervals, s = t.includeDates, i = t.includeDateIntervals, p = t.filterDate;
        return lr(e, {
            minDate: r,
            maxDate: a
        }) || n && n.some(function(t) {
            return $t(e, t);
        }) || o && o.some(function(t) {
            var r = t.start, a = t.end;
            return ot.default(e, {
                start: r,
                end: a
            });
        }) || s && !s.some(function(t) {
            return $t(e, t);
        }) || i && !i.some(function(t) {
            var r = t.start, a = t.end;
            return ot.default(e, {
                start: r,
                end: a
            });
        }) || p && !p(Yt(e)) || !1;
    }
    function ar(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.excludeDates, a = t.excludeDateIntervals;
        return a && a.length > 0 ? a.some(function(t) {
            var r = t.start, a = t.end;
            return ot.default(e, {
                start: r,
                end: a
            });
        }) : r && r.some(function(t) {
            return $t(e, t);
        }) || !1;
    }
    function nr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.maxDate, n = t.excludeDates, o = t.includeDates, s = t.filterDate;
        return lr(e, {
            minDate: r,
            maxDate: a
        }) || n && n.some(function(t) {
            return Vt(e, t);
        }) || o && !o.some(function(t) {
            return Vt(e, t);
        }) || s && !s(Yt(e)) || !1;
    }
    function or(e, t, r, a) {
        var n = Ie.default(e), o = Oe.default(e), s = Ie.default(t), i = Oe.default(t), p = Ie.default(a);
        return n === s && n === p ? o <= r && r <= i : n < s ? p === n && o <= r || p === s && i >= r || p < s && p > n : void 0;
    }
    function sr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.maxDate, n = t.excludeDates, o = t.includeDates, s = t.filterDate;
        return lr(e, {
            minDate: r,
            maxDate: a
        }) || n && n.some(function(t) {
            return Ut(e, t);
        }) || o && !o.some(function(t) {
            return Ut(e, t);
        }) || s && !s(Yt(e)) || !1;
    }
    function ir(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.maxDate, n = new Date(e, 0, 1);
        return lr(n, {
            minDate: r,
            maxDate: a
        }) || !1;
    }
    function pr(e, t, r, a) {
        var n = Ie.default(e), o = Ye.default(e), s = Ie.default(t), i = Ye.default(t), p = Ie.default(a);
        return n === s && n === p ? o <= r && r <= i : n < s ? p === n && o <= r || p === s && i >= r || p < s && p > n : void 0;
    }
    function lr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.maxDate;
        return r && He.default(e, r) < 0 || a && He.default(e, a) > 0;
    }
    function dr(e, t) {
        return t.some(function(t) {
            return Pe.default(t) === Pe.default(e) && Me.default(t) === Me.default(e);
        });
    }
    function cr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.excludeTimes, a = t.includeTimes, n = t.filterTime;
        return r && dr(e, r) || a && !dr(e, a) || n && !n(e) || !1;
    }
    function ur(e, t) {
        var r = t.minTime, a = t.maxTime;
        if (!r || !a) throw new Error("Both minTime and maxTime props required");
        var n, o = Yt(), s = Fe.default(Re.default(o, Me.default(e)), Pe.default(e)), i = Fe.default(Re.default(o, Me.default(r)), Pe.default(r)), p = Fe.default(Re.default(o, Me.default(a)), Pe.default(a));
        try {
            n = !ot.default(s, {
                start: i,
                end: p
            });
        } catch (e) {
            n = !1;
        }
        return n;
    }
    function fr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.includeDates, n = Se.default(e, 1);
        return r && je.default(r, n) > 0 || a && a.every(function(e) {
            return je.default(e, n) > 0;
        }) || !1;
    }
    function hr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.maxDate, a = t.includeDates, n = we.default(e, 1);
        return r && je.default(n, r) > 0 || a && a.every(function(e) {
            return je.default(n, e) > 0;
        }) || !1;
    }
    function mr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.includeDates, n = Ce.default(e, 1);
        return r && Qe.default(r, n) > 0 || a && a.every(function(e) {
            return Qe.default(e, n) > 0;
        }) || !1;
    }
    function yr(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.maxDate, a = t.includeDates, n = ge.default(e, 1);
        return r && Qe.default(n, r) > 0 || a && a.every(function(e) {
            return Qe.default(n, e) > 0;
        }) || !1;
    }
    function Dr(e) {
        var t = e.minDate, r = e.includeDates;
        if (r && t) {
            var a = r.filter(function(e) {
                return He.default(e, t) >= 0;
            });
            return Be.default(a);
        }
        return r ? Be.default(r) : t;
    }
    function vr(e) {
        var t = e.maxDate, r = e.includeDates;
        if (r && t) {
            var a = r.filter(function(e) {
                return He.default(e, t) <= 0;
            });
            return Ke.default(a);
        }
        return r ? Ke.default(r) : t;
    }
    function wr() {
        for(var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "react-datepicker__day--highlighted", r = new Map, a = 0, n = e.length; a < n; a++){
            var o = e[a];
            if (ue.default(o)) {
                var s = Lt(o, "MM.dd.yyyy"), i = r.get(s) || [];
                i.includes(t) || (i.push(t), r.set(s, i));
            } else if ("object" === ft(o)) {
                var p = Object.keys(o), l = p[0], d = o[p[0]];
                if ("string" == typeof l && d.constructor === Array) for(var c = 0, u = d.length; c < u; c++){
                    var f = Lt(d[c], "MM.dd.yyyy"), h = r.get(f) || [];
                    h.includes(l) || (h.push(l), r.set(f, h));
                }
            }
        }
        return r;
    }
    function gr(e, t, r, a, n) {
        for(var o = n.length, s = [], i = 0; i < o; i++){
            var p = me.default(ye.default(e, Pe.default(n[i])), Me.default(n[i])), l = me.default(e, (r + 1) * a);
            at.default(p, t) && nt.default(p, l) && s.push(n[i]);
        }
        return s;
    }
    function kr(e) {
        return e < 10 ? "0".concat(e) : "".concat(e);
    }
    function br(e) {
        var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : xt, r = Math.ceil(Ie.default(e) / t) * t, a = r - (t - 1);
        return {
            startPeriod: a,
            endPeriod: r
        };
    }
    function Sr(e, t, r, a) {
        for(var n = [], o = 0; o < 2 * t + 1; o++){
            var s = e + t - o, i = !0;
            r && (i = Ie.default(r) <= s), a && i && (i = Ie.default(a) >= s), i && n.push(s);
        }
        return n;
    }
    var Cr = function(e) {
        wt(a, e);
        var r = Ct(a);
        function a(e) {
            var n;
            ht(this, a), Dt(bt(n = r.call(this, e)), "renderOptions", function() {
                var e = n.props.year, t = n.state.yearsList.map(function(t) {
                    return de.default.createElement("div", {
                        className: e === t ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
                        key: t,
                        onClick: n.onChange.bind(bt(n), t),
                        "aria-selected": e === t ? "true" : void 0
                    }, e === t ? de.default.createElement("span", {
                        className: "react-datepicker__year-option--selected"
                    }, "\u2713") : "", t);
                }), r = n.props.minDate ? Ie.default(n.props.minDate) : null, a = n.props.maxDate ? Ie.default(n.props.maxDate) : null;
                return a && n.state.yearsList.find(function(e) {
                    return e === a;
                }) || t.unshift(de.default.createElement("div", {
                    className: "react-datepicker__year-option",
                    key: "upcoming",
                    onClick: n.incrementYears
                }, de.default.createElement("a", {
                    className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"
                }))), r && n.state.yearsList.find(function(e) {
                    return e === r;
                }) || t.push(de.default.createElement("div", {
                    className: "react-datepicker__year-option",
                    key: "previous",
                    onClick: n.decrementYears
                }, de.default.createElement("a", {
                    className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"
                }))), t;
            }), Dt(bt(n), "onChange", function(e) {
                n.props.onChange(e);
            }), Dt(bt(n), "handleClickOutside", function() {
                n.props.onCancel();
            }), Dt(bt(n), "shiftYears", function(e) {
                var t = n.state.yearsList.map(function(t) {
                    return t + e;
                });
                n.setState({
                    yearsList: t
                });
            }), Dt(bt(n), "incrementYears", function() {
                return n.shiftYears(1);
            }), Dt(bt(n), "decrementYears", function() {
                return n.shiftYears(-1);
            });
            var o = e.yearDropdownItemNumber, s = e.scrollableYearDropdown, i = o || (s ? 10 : 5);
            return n.state = {
                yearsList: Sr(n.props.year, i, n.props.minDate, n.props.maxDate)
            }, n.dropdownRef = t.createRef(), n;
        }
        return yt(a, [
            {
                key: "componentDidMount",
                value: function() {
                    var e = this.dropdownRef.current;
                    e && (e.scrollTop = e.scrollHeight / 2 - e.clientHeight / 2);
                }
            },
            {
                key: "render",
                value: function() {
                    var e = ce.default({
                        "react-datepicker__year-dropdown": !0,
                        "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
                    });
                    return de.default.createElement("div", {
                        className: e,
                        ref: this.dropdownRef
                    }, this.renderOptions());
                }
            }
        ]), a;
    }(de.default.Component), _r = lt.default(Cr), Mr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "state", {
                dropdownVisible: !1
            }), Dt(bt(e), "renderSelectOptions", function() {
                for(var t = e.props.minDate ? Ie.default(e.props.minDate) : 1900, r = e.props.maxDate ? Ie.default(e.props.maxDate) : 2100, a = [], n = t; n <= r; n++)a.push(de.default.createElement("option", {
                    key: n,
                    value: n
                }, n));
                return a;
            }), Dt(bt(e), "onSelectChange", function(t) {
                e.onChange(t.target.value);
            }), Dt(bt(e), "renderSelectMode", function() {
                return de.default.createElement("select", {
                    value: e.props.year,
                    className: "react-datepicker__year-select",
                    onChange: e.onSelectChange
                }, e.renderSelectOptions());
            }), Dt(bt(e), "renderReadView", function(t) {
                return de.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: t ? "visible" : "hidden"
                    },
                    className: "react-datepicker__year-read-view",
                    onClick: function(t) {
                        return e.toggleDropdown(t);
                    }
                }, de.default.createElement("span", {
                    className: "react-datepicker__year-read-view--down-arrow"
                }), de.default.createElement("span", {
                    className: "react-datepicker__year-read-view--selected-year"
                }, e.props.year));
            }), Dt(bt(e), "renderDropdown", function() {
                return de.default.createElement(_r, {
                    key: "dropdown",
                    year: e.props.year,
                    onChange: e.onChange,
                    onCancel: e.toggleDropdown,
                    minDate: e.props.minDate,
                    maxDate: e.props.maxDate,
                    scrollableYearDropdown: e.props.scrollableYearDropdown,
                    yearDropdownItemNumber: e.props.yearDropdownItemNumber
                });
            }), Dt(bt(e), "renderScrollMode", function() {
                var t = e.state.dropdownVisible, r = [
                    e.renderReadView(!t)
                ];
                return t && r.unshift(e.renderDropdown()), r;
            }), Dt(bt(e), "onChange", function(t) {
                e.toggleDropdown(), t !== e.props.year && e.props.onChange(t);
            }), Dt(bt(e), "toggleDropdown", function(t) {
                e.setState({
                    dropdownVisible: !e.state.dropdownVisible
                }, function() {
                    e.props.adjustDateOnChange && e.handleYearChange(e.props.date, t);
                });
            }), Dt(bt(e), "handleYearChange", function(t, r) {
                e.onSelect(t, r), e.setOpen();
            }), Dt(bt(e), "onSelect", function(t, r) {
                e.props.onSelect && e.props.onSelect(t, r);
            }), Dt(bt(e), "setOpen", function() {
                e.props.setOpen && e.props.setOpen(!0);
            }), e;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    var e;
                    switch(this.props.dropdownMode){
                        case "scroll":
                            e = this.renderScrollMode();
                            break;
                        case "select":
                            e = this.renderSelectMode();
                    }
                    return de.default.createElement("div", {
                        className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)
                    }, e);
                }
            }
        ]), r;
    }(de.default.Component), Pr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "isSelectedMonth", function(t) {
                return e.props.month === t;
            }), Dt(bt(e), "renderOptions", function() {
                return e.props.monthNames.map(function(t, r) {
                    return de.default.createElement("div", {
                        className: e.isSelectedMonth(r) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option",
                        key: t,
                        onClick: e.onChange.bind(bt(e), r),
                        "aria-selected": e.isSelectedMonth(r) ? "true" : void 0
                    }, e.isSelectedMonth(r) ? de.default.createElement("span", {
                        className: "react-datepicker__month-option--selected"
                    }, "\u2713") : "", t);
                });
            }), Dt(bt(e), "onChange", function(t) {
                return e.props.onChange(t);
            }), Dt(bt(e), "handleClickOutside", function() {
                return e.props.onCancel();
            }), e;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    return de.default.createElement("div", {
                        className: "react-datepicker__month-dropdown"
                    }, this.renderOptions());
                }
            }
        ]), r;
    }(de.default.Component), Er = lt.default(Pr), Nr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "state", {
                dropdownVisible: !1
            }), Dt(bt(e), "renderSelectOptions", function(e) {
                return e.map(function(e, t) {
                    return de.default.createElement("option", {
                        key: t,
                        value: t
                    }, e);
                });
            }), Dt(bt(e), "renderSelectMode", function(t) {
                return de.default.createElement("select", {
                    value: e.props.month,
                    className: "react-datepicker__month-select",
                    onChange: function(t) {
                        return e.onChange(t.target.value);
                    }
                }, e.renderSelectOptions(t));
            }), Dt(bt(e), "renderReadView", function(t, r) {
                return de.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: t ? "visible" : "hidden"
                    },
                    className: "react-datepicker__month-read-view",
                    onClick: e.toggleDropdown
                }, de.default.createElement("span", {
                    className: "react-datepicker__month-read-view--down-arrow"
                }), de.default.createElement("span", {
                    className: "react-datepicker__month-read-view--selected-month"
                }, r[e.props.month]));
            }), Dt(bt(e), "renderDropdown", function(t) {
                return de.default.createElement(Er, {
                    key: "dropdown",
                    month: e.props.month,
                    monthNames: t,
                    onChange: e.onChange,
                    onCancel: e.toggleDropdown
                });
            }), Dt(bt(e), "renderScrollMode", function(t) {
                var r = e.state.dropdownVisible, a = [
                    e.renderReadView(!r, t)
                ];
                return r && a.unshift(e.renderDropdown(t)), a;
            }), Dt(bt(e), "onChange", function(t) {
                e.toggleDropdown(), t !== e.props.month && e.props.onChange(t);
            }), Dt(bt(e), "toggleDropdown", function() {
                return e.setState({
                    dropdownVisible: !e.state.dropdownVisible
                });
            }), e;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    var e, t = this, r = [
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11
                    ].map(this.props.useShortMonthInDropdown ? function(e) {
                        return er(e, t.props.locale);
                    } : function(e) {
                        return Zt(e, t.props.locale);
                    });
                    switch(this.props.dropdownMode){
                        case "scroll":
                            e = this.renderScrollMode(r);
                            break;
                        case "select":
                            e = this.renderSelectMode(r);
                    }
                    return de.default.createElement("div", {
                        className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)
                    }, e);
                }
            }
        ]), r;
    }(de.default.Component);
    function xr(e, t) {
        for(var r = [], a = Kt(e), n = Kt(t); !at.default(a, n);)r.push(Yt(a)), a = we.default(a, 1);
        return r;
    }
    var Or = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r(e) {
            var a;
            return ht(this, r), Dt(bt(a = t.call(this, e)), "renderOptions", function() {
                return a.state.monthYearsList.map(function(e) {
                    var t = Te.default(e), r = Qt(a.props.date, e) && Vt(a.props.date, e);
                    return de.default.createElement("div", {
                        className: r ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option",
                        key: t,
                        onClick: a.onChange.bind(bt(a), t),
                        "aria-selected": r ? "true" : void 0
                    }, r ? de.default.createElement("span", {
                        className: "react-datepicker__month-year-option--selected"
                    }, "\u2713") : "", Lt(e, a.props.dateFormat, a.props.locale));
                });
            }), Dt(bt(a), "onChange", function(e) {
                return a.props.onChange(e);
            }), Dt(bt(a), "handleClickOutside", function() {
                a.props.onCancel();
            }), a.state = {
                monthYearsList: xr(a.props.minDate, a.props.maxDate)
            }, a;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    var e = ce.default({
                        "react-datepicker__month-year-dropdown": !0,
                        "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
                    });
                    return de.default.createElement("div", {
                        className: e
                    }, this.renderOptions());
                }
            }
        ]), r;
    }(de.default.Component), Yr = lt.default(Or), Ir = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "state", {
                dropdownVisible: !1
            }), Dt(bt(e), "renderSelectOptions", function() {
                for(var t = Kt(e.props.minDate), r = Kt(e.props.maxDate), a = []; !at.default(t, r);){
                    var n = Te.default(t);
                    a.push(de.default.createElement("option", {
                        key: n,
                        value: n
                    }, Lt(t, e.props.dateFormat, e.props.locale))), t = we.default(t, 1);
                }
                return a;
            }), Dt(bt(e), "onSelectChange", function(t) {
                e.onChange(t.target.value);
            }), Dt(bt(e), "renderSelectMode", function() {
                return de.default.createElement("select", {
                    value: Te.default(Kt(e.props.date)),
                    className: "react-datepicker__month-year-select",
                    onChange: e.onSelectChange
                }, e.renderSelectOptions());
            }), Dt(bt(e), "renderReadView", function(t) {
                var r = Lt(e.props.date, e.props.dateFormat, e.props.locale);
                return de.default.createElement("div", {
                    key: "read",
                    style: {
                        visibility: t ? "visible" : "hidden"
                    },
                    className: "react-datepicker__month-year-read-view",
                    onClick: function(t) {
                        return e.toggleDropdown(t);
                    }
                }, de.default.createElement("span", {
                    className: "react-datepicker__month-year-read-view--down-arrow"
                }), de.default.createElement("span", {
                    className: "react-datepicker__month-year-read-view--selected-month-year"
                }, r));
            }), Dt(bt(e), "renderDropdown", function() {
                return de.default.createElement(Yr, {
                    key: "dropdown",
                    date: e.props.date,
                    dateFormat: e.props.dateFormat,
                    onChange: e.onChange,
                    onCancel: e.toggleDropdown,
                    minDate: e.props.minDate,
                    maxDate: e.props.maxDate,
                    scrollableMonthYearDropdown: e.props.scrollableMonthYearDropdown,
                    locale: e.props.locale
                });
            }), Dt(bt(e), "renderScrollMode", function() {
                var t = e.state.dropdownVisible, r = [
                    e.renderReadView(!t)
                ];
                return t && r.unshift(e.renderDropdown()), r;
            }), Dt(bt(e), "onChange", function(t) {
                e.toggleDropdown();
                var r = Yt(parseInt(t));
                Qt(e.props.date, r) && Vt(e.props.date, r) || e.props.onChange(r);
            }), Dt(bt(e), "toggleDropdown", function() {
                return e.setState({
                    dropdownVisible: !e.state.dropdownVisible
                });
            }), e;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    var e;
                    switch(this.props.dropdownMode){
                        case "scroll":
                            e = this.renderScrollMode();
                            break;
                        case "select":
                            e = this.renderSelectMode();
                    }
                    return de.default.createElement("div", {
                        className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)
                    }, e);
                }
            }
        ]), r;
    }(de.default.Component), Tr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "dayEl", de.default.createRef()), Dt(bt(e), "handleClick", function(t) {
                !e.isDisabled() && e.props.onClick && e.props.onClick(t);
            }), Dt(bt(e), "handleMouseEnter", function(t) {
                !e.isDisabled() && e.props.onMouseEnter && e.props.onMouseEnter(t);
            }), Dt(bt(e), "handleOnKeyDown", function(t) {
                " " === t.key && (t.preventDefault(), t.key = "Enter"), e.props.handleOnKeyDown(t);
            }), Dt(bt(e), "isSameDay", function(t) {
                return $t(e.props.day, t);
            }), Dt(bt(e), "isKeyboardSelected", function() {
                return !e.props.disabledKeyboardNavigation && !e.isSameDay(e.props.selected) && e.isSameDay(e.props.preSelection);
            }), Dt(bt(e), "isDisabled", function() {
                return rr(e.props.day, e.props);
            }), Dt(bt(e), "isExcluded", function() {
                return ar(e.props.day, e.props);
            }), Dt(bt(e), "getHighLightedClass", function(t) {
                var r = e.props, a = r.day, n = r.highlightDates;
                if (!n) return !1;
                var o = Lt(a, "MM.dd.yyyy");
                return n.get(o);
            }), Dt(bt(e), "isInRange", function() {
                var t = e.props, r = t.day, a = t.startDate, n = t.endDate;
                return !(!a || !n) && Gt(r, a, n);
            }), Dt(bt(e), "isInSelectingRange", function() {
                var t, r = e.props, a = r.day, n = r.selectsStart, o = r.selectsEnd, s = r.selectsRange, i = r.selectsDisabledDaysInRange, p = r.startDate, l = r.endDate, d = null !== (t = e.props.selectingDate) && void 0 !== t ? t : e.props.preSelection;
                return !(!(n || o || s) || !d || !i && e.isDisabled()) && (n && l && (nt.default(d, l) || zt(d, l)) ? Gt(a, d, l) : (o && p && (at.default(d, p) || zt(d, p)) || !(!s || !p || l || !at.default(d, p) && !zt(d, p))) && Gt(a, p, d));
            }), Dt(bt(e), "isSelectingRangeStart", function() {
                var t;
                if (!e.isInSelectingRange()) return !1;
                var r = e.props, a = r.day, n = r.startDate, o = r.selectsStart, s = null !== (t = e.props.selectingDate) && void 0 !== t ? t : e.props.preSelection;
                return $t(a, o ? s : n);
            }), Dt(bt(e), "isSelectingRangeEnd", function() {
                var t;
                if (!e.isInSelectingRange()) return !1;
                var r = e.props, a = r.day, n = r.endDate, o = r.selectsEnd, s = null !== (t = e.props.selectingDate) && void 0 !== t ? t : e.props.preSelection;
                return $t(a, o ? s : n);
            }), Dt(bt(e), "isRangeStart", function() {
                var t = e.props, r = t.day, a = t.startDate, n = t.endDate;
                return !(!a || !n) && $t(a, r);
            }), Dt(bt(e), "isRangeEnd", function() {
                var t = e.props, r = t.day, a = t.startDate, n = t.endDate;
                return !(!a || !n) && $t(n, r);
            }), Dt(bt(e), "isWeekend", function() {
                var t = Ee.default(e.props.day);
                return 0 === t || 6 === t;
            }), Dt(bt(e), "isAfterMonth", function() {
                return void 0 !== e.props.month && (e.props.month + 1) % 12 === Oe.default(e.props.day);
            }), Dt(bt(e), "isBeforeMonth", function() {
                return void 0 !== e.props.month && (Oe.default(e.props.day) + 1) % 12 === e.props.month;
            }), Dt(bt(e), "isCurrentDay", function() {
                return e.isSameDay(Yt());
            }), Dt(bt(e), "isSelected", function() {
                return e.isSameDay(e.props.selected);
            }), Dt(bt(e), "getClassNames", function(t) {
                var r = e.props.dayClassName ? e.props.dayClassName(t) : void 0;
                return ce.default("react-datepicker__day", r, "react-datepicker__day--" + qt(e.props.day), {
                    "react-datepicker__day--disabled": e.isDisabled(),
                    "react-datepicker__day--excluded": e.isExcluded(),
                    "react-datepicker__day--selected": e.isSelected(),
                    "react-datepicker__day--keyboard-selected": e.isKeyboardSelected(),
                    "react-datepicker__day--range-start": e.isRangeStart(),
                    "react-datepicker__day--range-end": e.isRangeEnd(),
                    "react-datepicker__day--in-range": e.isInRange(),
                    "react-datepicker__day--in-selecting-range": e.isInSelectingRange(),
                    "react-datepicker__day--selecting-range-start": e.isSelectingRangeStart(),
                    "react-datepicker__day--selecting-range-end": e.isSelectingRangeEnd(),
                    "react-datepicker__day--today": e.isCurrentDay(),
                    "react-datepicker__day--weekend": e.isWeekend(),
                    "react-datepicker__day--outside-month": e.isAfterMonth() || e.isBeforeMonth()
                }, e.getHighLightedClass("react-datepicker__day--highlighted"));
            }), Dt(bt(e), "getAriaLabel", function() {
                var t = e.props, r = t.day, a = t.ariaLabelPrefixWhenEnabled, n = void 0 === a ? "Choose" : a, o = t.ariaLabelPrefixWhenDisabled, s = void 0 === o ? "Not available" : o, i = e.isDisabled() || e.isExcluded() ? s : n;
                return "".concat(i, " ").concat(Lt(r, "PPPP", e.props.locale));
            }), Dt(bt(e), "getTabIndex", function(t, r) {
                var a = t || e.props.selected, n = r || e.props.preSelection;
                return e.isKeyboardSelected() || e.isSameDay(a) && $t(n, a) ? 0 : -1;
            }), Dt(bt(e), "handleFocusDay", function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, r = !1;
                0 === e.getTabIndex() && !t.isInputFocused && e.isSameDay(e.props.preSelection) && (document.activeElement && document.activeElement !== document.body || (r = !0), e.props.inline && !e.props.shouldFocusDayInline && (r = !1), e.props.containerRef && e.props.containerRef.current && e.props.containerRef.current.contains(document.activeElement) && document.activeElement.classList.contains("react-datepicker__day") && (r = !0)), r && e.dayEl.current.focus({
                    preventScroll: !0
                });
            }), Dt(bt(e), "renderDayContents", function() {
                return e.props.monthShowsDuplicateDaysEnd && e.isAfterMonth() || e.props.monthShowsDuplicateDaysStart && e.isBeforeMonth() ? null : e.props.renderDayContents ? e.props.renderDayContents(Ne.default(e.props.day), e.props.day) : Ne.default(e.props.day);
            }), Dt(bt(e), "render", function() {
                return de.default.createElement("div", {
                    ref: e.dayEl,
                    className: e.getClassNames(e.props.day),
                    onKeyDown: e.handleOnKeyDown,
                    onClick: e.handleClick,
                    onMouseEnter: e.handleMouseEnter,
                    tabIndex: e.getTabIndex(),
                    "aria-label": e.getAriaLabel(),
                    role: "option",
                    "aria-disabled": e.isDisabled(),
                    "aria-current": e.isCurrentDay() ? "date" : void 0,
                    "aria-selected": e.isSelected()
                }, e.renderDayContents());
            }), e;
        }
        return yt(r, [
            {
                key: "componentDidMount",
                value: function() {
                    this.handleFocusDay();
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e) {
                    this.handleFocusDay(e);
                }
            }
        ]), r;
    }(de.default.Component), Lr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "handleClick", function(t) {
                e.props.onClick && e.props.onClick(t);
            }), e;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    var e = this.props, t = e.weekNumber, r = e.ariaLabelPrefix, a = void 0 === r ? "week " : r, n = {
                        "react-datepicker__week-number": !0,
                        "react-datepicker__week-number--clickable": !!e.onClick
                    };
                    return de.default.createElement("div", {
                        className: ce.default(n),
                        "aria-label": "".concat(a, " ").concat(this.props.weekNumber),
                        onClick: this.handleClick
                    }, t);
                }
            }
        ]), r;
    }(de.default.Component), Rr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "handleDayClick", function(t, r) {
                e.props.onDayClick && e.props.onDayClick(t, r);
            }), Dt(bt(e), "handleDayMouseEnter", function(t) {
                e.props.onDayMouseEnter && e.props.onDayMouseEnter(t);
            }), Dt(bt(e), "handleWeekClick", function(t, r, a) {
                "function" == typeof e.props.onWeekSelect && e.props.onWeekSelect(t, r, a), e.props.shouldCloseOnSelect && e.props.setOpen(!1);
            }), Dt(bt(e), "formatWeekNumber", function(t) {
                return e.props.formatWeekNumber ? e.props.formatWeekNumber(t) : At(t);
            }), Dt(bt(e), "renderDays", function() {
                var t = Bt(e.props.day, e.props.locale, e.props.calendarStartDay), r = [], a = e.formatWeekNumber(t);
                if (e.props.showWeekNumber) {
                    var n = e.props.onWeekSelect ? e.handleWeekClick.bind(bt(e), t, a) : void 0;
                    r.push(de.default.createElement(Lr, {
                        key: "W",
                        weekNumber: a,
                        onClick: n,
                        ariaLabelPrefix: e.props.ariaLabelPrefix
                    }));
                }
                return r.concat([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6
                ].map(function(r) {
                    var a = De.default(t, r);
                    return de.default.createElement(Tr, {
                        ariaLabelPrefixWhenEnabled: e.props.chooseDayAriaLabelPrefix,
                        ariaLabelPrefixWhenDisabled: e.props.disabledDayAriaLabelPrefix,
                        key: a.valueOf(),
                        day: a,
                        month: e.props.month,
                        onClick: e.handleDayClick.bind(bt(e), a),
                        onMouseEnter: e.handleDayMouseEnter.bind(bt(e), a),
                        minDate: e.props.minDate,
                        maxDate: e.props.maxDate,
                        excludeDates: e.props.excludeDates,
                        excludeDateIntervals: e.props.excludeDateIntervals,
                        includeDates: e.props.includeDates,
                        includeDateIntervals: e.props.includeDateIntervals,
                        highlightDates: e.props.highlightDates,
                        selectingDate: e.props.selectingDate,
                        filterDate: e.props.filterDate,
                        preSelection: e.props.preSelection,
                        selected: e.props.selected,
                        selectsStart: e.props.selectsStart,
                        selectsEnd: e.props.selectsEnd,
                        selectsRange: e.props.selectsRange,
                        selectsDisabledDaysInRange: e.props.selectsDisabledDaysInRange,
                        startDate: e.props.startDate,
                        endDate: e.props.endDate,
                        dayClassName: e.props.dayClassName,
                        renderDayContents: e.props.renderDayContents,
                        disabledKeyboardNavigation: e.props.disabledKeyboardNavigation,
                        handleOnKeyDown: e.props.handleOnKeyDown,
                        isInputFocused: e.props.isInputFocused,
                        containerRef: e.props.containerRef,
                        inline: e.props.inline,
                        shouldFocusDayInline: e.props.shouldFocusDayInline,
                        monthShowsDuplicateDaysEnd: e.props.monthShowsDuplicateDaysEnd,
                        monthShowsDuplicateDaysStart: e.props.monthShowsDuplicateDaysStart,
                        locale: e.props.locale
                    });
                }));
            }), e;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    return de.default.createElement("div", {
                        className: "react-datepicker__week"
                    }, this.renderDays());
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        shouldCloseOnSelect: !0
                    };
                }
            }
        ]), r;
    }(de.default.Component), Fr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "MONTH_REFS", _t(Array(12)).map(function() {
                return de.default.createRef();
            })), Dt(bt(e), "isDisabled", function(t) {
                return rr(t, e.props);
            }), Dt(bt(e), "isExcluded", function(t) {
                return ar(t, e.props);
            }), Dt(bt(e), "handleDayClick", function(t, r) {
                e.props.onDayClick && e.props.onDayClick(t, r, e.props.orderInDisplay);
            }), Dt(bt(e), "handleDayMouseEnter", function(t) {
                e.props.onDayMouseEnter && e.props.onDayMouseEnter(t);
            }), Dt(bt(e), "handleMouseLeave", function() {
                e.props.onMouseLeave && e.props.onMouseLeave();
            }), Dt(bt(e), "isRangeStartMonth", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate;
                return !(!n || !o) && Vt(Ae.default(a, t), n);
            }), Dt(bt(e), "isRangeStartQuarter", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate;
                return !(!n || !o) && Ut(qe.default(a, t), n);
            }), Dt(bt(e), "isRangeEndMonth", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate;
                return !(!n || !o) && Vt(Ae.default(a, t), o);
            }), Dt(bt(e), "isRangeEndQuarter", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate;
                return !(!n || !o) && Ut(qe.default(a, t), o);
            }), Dt(bt(e), "isWeekInMonth", function(t) {
                var r = e.props.day, a = De.default(t, 6);
                return Vt(t, r) || Vt(a, r);
            }), Dt(bt(e), "isCurrentMonth", function(e, t) {
                return Ie.default(e) === Ie.default(Yt()) && t === Oe.default(Yt());
            }), Dt(bt(e), "isSelectedMonth", function(e, t, r) {
                return Oe.default(e) === t && Ie.default(e) === Ie.default(r);
            }), Dt(bt(e), "isSelectedQuarter", function(e, t, r) {
                return Ye.default(e) === t && Ie.default(e) === Ie.default(r);
            }), Dt(bt(e), "renderWeeks", function() {
                for(var t = [], r = e.props.fixedHeight, a = 0, n = !1, o = Bt(Kt(e.props.day), e.props.locale, e.props.calendarStartDay); t.push(de.default.createElement(Rr, {
                    ariaLabelPrefix: e.props.weekAriaLabelPrefix,
                    chooseDayAriaLabelPrefix: e.props.chooseDayAriaLabelPrefix,
                    disabledDayAriaLabelPrefix: e.props.disabledDayAriaLabelPrefix,
                    key: a,
                    day: o,
                    month: Oe.default(e.props.day),
                    onDayClick: e.handleDayClick,
                    onDayMouseEnter: e.handleDayMouseEnter,
                    onWeekSelect: e.props.onWeekSelect,
                    formatWeekNumber: e.props.formatWeekNumber,
                    locale: e.props.locale,
                    minDate: e.props.minDate,
                    maxDate: e.props.maxDate,
                    excludeDates: e.props.excludeDates,
                    excludeDateIntervals: e.props.excludeDateIntervals,
                    includeDates: e.props.includeDates,
                    includeDateIntervals: e.props.includeDateIntervals,
                    inline: e.props.inline,
                    shouldFocusDayInline: e.props.shouldFocusDayInline,
                    highlightDates: e.props.highlightDates,
                    selectingDate: e.props.selectingDate,
                    filterDate: e.props.filterDate,
                    preSelection: e.props.preSelection,
                    selected: e.props.selected,
                    selectsStart: e.props.selectsStart,
                    selectsEnd: e.props.selectsEnd,
                    selectsRange: e.props.selectsRange,
                    selectsDisabledDaysInRange: e.props.selectsDisabledDaysInRange,
                    showWeekNumber: e.props.showWeekNumbers,
                    startDate: e.props.startDate,
                    endDate: e.props.endDate,
                    dayClassName: e.props.dayClassName,
                    setOpen: e.props.setOpen,
                    shouldCloseOnSelect: e.props.shouldCloseOnSelect,
                    disabledKeyboardNavigation: e.props.disabledKeyboardNavigation,
                    renderDayContents: e.props.renderDayContents,
                    handleOnKeyDown: e.props.handleOnKeyDown,
                    isInputFocused: e.props.isInputFocused,
                    containerRef: e.props.containerRef,
                    calendarStartDay: e.props.calendarStartDay,
                    monthShowsDuplicateDaysEnd: e.props.monthShowsDuplicateDaysEnd,
                    monthShowsDuplicateDaysStart: e.props.monthShowsDuplicateDaysStart
                })), !n;){
                    a++, o = ve.default(o, 1);
                    var s = r && a >= 6, i = !r && !e.isWeekInMonth(o);
                    if (s || i) {
                        if (!e.props.peekNextMonth) break;
                        n = !0;
                    }
                }
                return t;
            }), Dt(bt(e), "onMonthClick", function(t, r) {
                e.handleDayClick(Kt(Ae.default(e.props.day, r)), t);
            }), Dt(bt(e), "handleMonthNavigation", function(t, r) {
                e.isDisabled(r) || e.isExcluded(r) || (e.props.setPreSelection(r), e.MONTH_REFS[t].current && e.MONTH_REFS[t].current.focus());
            }), Dt(bt(e), "onMonthKeyDown", function(t, r) {
                var a = t.key;
                if (!e.props.disabledKeyboardNavigation) switch(a){
                    case "Enter":
                        e.onMonthClick(t, r), e.props.setPreSelection(e.props.selected);
                        break;
                    case "ArrowRight":
                        e.handleMonthNavigation(11 === r ? 0 : r + 1, we.default(e.props.preSelection, 1));
                        break;
                    case "ArrowLeft":
                        e.handleMonthNavigation(0 === r ? 11 : r - 1, Se.default(e.props.preSelection, 1));
                }
            }), Dt(bt(e), "onQuarterClick", function(t, r) {
                e.handleDayClick(jt(qe.default(e.props.day, r)), t);
            }), Dt(bt(e), "getMonthClassNames", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate, s = r.selected, i = r.minDate, p = r.maxDate, l = r.preSelection, d = r.monthClassName, c = d ? d(a) : void 0;
                return ce.default("react-datepicker__month-text", "react-datepicker__month-".concat(t), c, {
                    "react-datepicker__month--disabled": (i || p) && nr(Ae.default(a, t), e.props),
                    "react-datepicker__month--selected": e.isSelectedMonth(a, t, s),
                    "react-datepicker__month-text--keyboard-selected": Oe.default(l) === t,
                    "react-datepicker__month--in-range": or(n, o, t, a),
                    "react-datepicker__month--range-start": e.isRangeStartMonth(t),
                    "react-datepicker__month--range-end": e.isRangeEndMonth(t),
                    "react-datepicker__month-text--today": e.isCurrentMonth(a, t)
                });
            }), Dt(bt(e), "getTabIndex", function(t) {
                var r = Oe.default(e.props.preSelection);
                return e.props.disabledKeyboardNavigation || t !== r ? "-1" : "0";
            }), Dt(bt(e), "getAriaLabel", function(t) {
                var r = e.props, a = r.chooseDayAriaLabelPrefix, n = void 0 === a ? "Choose" : a, o = r.disabledDayAriaLabelPrefix, s = void 0 === o ? "Not available" : o, i = r.day, p = Ae.default(i, t), l = e.isDisabled(p) || e.isExcluded(p) ? s : n;
                return "".concat(l, " ").concat(Lt(p, "MMMM yyyy"));
            }), Dt(bt(e), "getQuarterClassNames", function(t) {
                var r = e.props, a = r.day, n = r.startDate, o = r.endDate, s = r.selected, i = r.minDate, p = r.maxDate;
                return ce.default("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(t), {
                    "react-datepicker__quarter--disabled": (i || p) && sr(qe.default(a, t), e.props),
                    "react-datepicker__quarter--selected": e.isSelectedQuarter(a, t, s),
                    "react-datepicker__quarter--in-range": pr(n, o, t, a),
                    "react-datepicker__quarter--range-start": e.isRangeStartQuarter(t),
                    "react-datepicker__quarter--range-end": e.isRangeEndQuarter(t)
                });
            }), Dt(bt(e), "renderMonths", function() {
                var t = e.props, r = t.showFullMonthYearPicker, a = t.showTwoColumnMonthYearPicker, n = t.showFourColumnMonthYearPicker, o = t.locale, s = t.day, i = t.selected;
                return (n ? [
                    [
                        0,
                        1,
                        2,
                        3
                    ],
                    [
                        4,
                        5,
                        6,
                        7
                    ],
                    [
                        8,
                        9,
                        10,
                        11
                    ]
                ] : a ? [
                    [
                        0,
                        1
                    ],
                    [
                        2,
                        3
                    ],
                    [
                        4,
                        5
                    ],
                    [
                        6,
                        7
                    ],
                    [
                        8,
                        9
                    ],
                    [
                        10,
                        11
                    ]
                ] : [
                    [
                        0,
                        1,
                        2
                    ],
                    [
                        3,
                        4,
                        5
                    ],
                    [
                        6,
                        7,
                        8
                    ],
                    [
                        9,
                        10,
                        11
                    ]
                ]).map(function(t, a) {
                    return de.default.createElement("div", {
                        className: "react-datepicker__month-wrapper",
                        key: a
                    }, t.map(function(t, a) {
                        return de.default.createElement("div", {
                            ref: e.MONTH_REFS[t],
                            key: a,
                            onClick: function(r) {
                                e.onMonthClick(r, t);
                            },
                            onKeyDown: function(r) {
                                e.onMonthKeyDown(r, t);
                            },
                            tabIndex: e.getTabIndex(t),
                            className: e.getMonthClassNames(t),
                            role: "option",
                            "aria-label": e.getAriaLabel(t),
                            "aria-current": e.isCurrentMonth(s, t) ? "date" : void 0,
                            "aria-selected": e.isSelectedMonth(s, t, i)
                        }, r ? Zt(t, o) : er(t, o));
                    }));
                });
            }), Dt(bt(e), "renderQuarters", function() {
                var t = e.props, r = t.day, a = t.selected;
                return de.default.createElement("div", {
                    className: "react-datepicker__quarter-wrapper"
                }, [
                    1,
                    2,
                    3,
                    4
                ].map(function(t, n) {
                    return de.default.createElement("div", {
                        key: n,
                        role: "option",
                        onClick: function(r) {
                            e.onQuarterClick(r, t);
                        },
                        className: e.getQuarterClassNames(t),
                        "aria-selected": e.isSelectedQuarter(r, t, a)
                    }, tr(t, e.props.locale));
                }));
            }), Dt(bt(e), "getClassNames", function() {
                var t = e.props;
                t.day;
                var r = t.selectingDate, a = t.selectsStart, n = t.selectsEnd, o = t.showMonthYearPicker, s = t.showQuarterYearPicker;
                return ce.default("react-datepicker__month", {
                    "react-datepicker__month--selecting-range": r && (a || n)
                }, {
                    "react-datepicker__monthPicker": o
                }, {
                    "react-datepicker__quarterPicker": s
                });
            }), e;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    var e = this.props, t = e.showMonthYearPicker, r = e.showQuarterYearPicker, a = e.day, n = e.ariaLabelPrefix, o = void 0 === n ? "month " : n;
                    return de.default.createElement("div", {
                        className: this.getClassNames(),
                        onMouseLeave: this.handleMouseLeave,
                        "aria-label": "".concat(o, " ").concat(Lt(a, "yyyy-MM")),
                        role: "listbox"
                    }, t ? this.renderMonths() : r ? this.renderQuarters() : this.renderWeeks());
                }
            }
        ]), r;
    }(de.default.Component), Ar = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            var e;
            ht(this, r);
            for(var a = arguments.length, n = new Array(a), o = 0; o < a; o++)n[o] = arguments[o];
            return Dt(bt(e = t.call.apply(t, [
                this
            ].concat(n))), "state", {
                height: null
            }), Dt(bt(e), "handleClick", function(t) {
                (e.props.minTime || e.props.maxTime) && ur(t, e.props) || (e.props.excludeTimes || e.props.includeTimes || e.props.filterTime) && cr(t, e.props) || e.props.onChange(t);
            }), Dt(bt(e), "isSelectedTime", function(t, r, a) {
                return e.props.selected && r === Pe.default(t) && a === Me.default(t);
            }), Dt(bt(e), "liClasses", function(t, r, a) {
                var n = [
                    "react-datepicker__time-list-item",
                    e.props.timeClassName ? e.props.timeClassName(t, r, a) : void 0
                ];
                return e.isSelectedTime(t, r, a) && n.push("react-datepicker__time-list-item--selected"), ((e.props.minTime || e.props.maxTime) && ur(t, e.props) || (e.props.excludeTimes || e.props.includeTimes || e.props.filterTime) && cr(t, e.props)) && n.push("react-datepicker__time-list-item--disabled"), e.props.injectTimes && (60 * Pe.default(t) + Me.default(t)) % e.props.intervals != 0 && n.push("react-datepicker__time-list-item--injected"), n.join(" ");
            }), Dt(bt(e), "handleOnKeyDown", function(t, r) {
                " " === t.key && (t.preventDefault(), t.key = "Enter"), "Enter" === t.key && e.handleClick(r), e.props.handleOnKeyDown(t);
            }), Dt(bt(e), "renderTimes", function() {
                for(var t = [], r = e.props.format ? e.props.format : "p", a = e.props.intervals, n = Wt(Yt(e.props.selected)), o = 1440 / a, s = e.props.injectTimes && e.props.injectTimes.sort(function(e, t) {
                    return e - t;
                }), i = e.props.selected || e.props.openToDate || Yt(), p = Pe.default(i), l = Me.default(i), d = Fe.default(Re.default(n, l), p), c = 0; c < o; c++){
                    var u = me.default(n, c * a);
                    if (t.push(u), s) {
                        var f = gr(n, u, c, a, s);
                        t = t.concat(f);
                    }
                }
                return t.map(function(t, a) {
                    return de.default.createElement("li", {
                        key: a,
                        onClick: e.handleClick.bind(bt(e), t),
                        className: e.liClasses(t, p, l),
                        ref: function(r) {
                            (nt.default(t, d) || zt(t, d)) && (e.centerLi = r);
                        },
                        onKeyDown: function(r) {
                            e.handleOnKeyDown(r, t);
                        },
                        tabIndex: "0",
                        "aria-selected": e.isSelectedTime(t, p, l) ? "true" : void 0
                    }, Lt(t, r, e.props.locale));
                });
            }), e;
        }
        return yt(r, [
            {
                key: "componentDidMount",
                value: function() {
                    this.list.scrollTop = r.calcCenterPosition(this.props.monthRef ? this.props.monthRef.clientHeight - this.header.clientHeight : this.list.clientHeight, this.centerLi), this.props.monthRef && this.header && this.setState({
                        height: this.props.monthRef.clientHeight - this.header.clientHeight
                    });
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this, t = this.state.height;
                    return de.default.createElement("div", {
                        className: "react-datepicker__time-container ".concat(this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "")
                    }, de.default.createElement("div", {
                        className: "react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""),
                        ref: function(t) {
                            e.header = t;
                        }
                    }, de.default.createElement("div", {
                        className: "react-datepicker-time__header"
                    }, this.props.timeCaption)), de.default.createElement("div", {
                        className: "react-datepicker__time"
                    }, de.default.createElement("div", {
                        className: "react-datepicker__time-box"
                    }, de.default.createElement("ul", {
                        className: "react-datepicker__time-list",
                        ref: function(t) {
                            e.list = t;
                        },
                        style: t ? {
                            height: t
                        } : {},
                        tabIndex: "0"
                    }, this.renderTimes()))));
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        intervals: 30,
                        onTimeChange: function() {},
                        todayButton: null,
                        timeCaption: "Time"
                    };
                }
            }
        ]), r;
    }(de.default.Component);
    Dt(Ar, "calcCenterPosition", function(e, t) {
        return t.offsetTop - (e / 2 - t.clientHeight / 2);
    });
    var qr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r(e) {
            var a;
            return ht(this, r), Dt(bt(a = t.call(this, e)), "YEAR_REFS", _t(Array(a.props.yearItemNumber)).map(function() {
                return de.default.createRef();
            })), Dt(bt(a), "isDisabled", function(e) {
                return rr(e, a.props);
            }), Dt(bt(a), "isExcluded", function(e) {
                return ar(e, a.props);
            }), Dt(bt(a), "updateFocusOnPaginate", function(e) {
                var t = (function() {
                    this.YEAR_REFS[e].current.focus();
                }).bind(bt(a));
                window.requestAnimationFrame(t);
            }), Dt(bt(a), "handleYearClick", function(e, t) {
                a.props.onDayClick && a.props.onDayClick(e, t);
            }), Dt(bt(a), "handleYearNavigation", function(e, t) {
                var r = a.props, n = r.date, o = r.yearItemNumber, s = br(n, o).startPeriod;
                a.isDisabled(t) || a.isExcluded(t) || (a.props.setPreSelection(t), e - s == -1 ? a.updateFocusOnPaginate(o - 1) : e - s === o ? a.updateFocusOnPaginate(0) : a.YEAR_REFS[e - s].current.focus());
            }), Dt(bt(a), "isSameDay", function(e, t) {
                return $t(e, t);
            }), Dt(bt(a), "isCurrentYear", function(e) {
                return e === Ie.default(Yt());
            }), Dt(bt(a), "isKeyboardSelected", function(e) {
                var t = Ht(We.default(a.props.date, e));
                return !a.props.disabledKeyboardNavigation && !a.props.inline && !$t(t, Ht(a.props.selected)) && $t(t, Ht(a.props.preSelection));
            }), Dt(bt(a), "onYearClick", function(e, t) {
                var r = a.props.date;
                a.handleYearClick(Ht(We.default(r, t)), e);
            }), Dt(bt(a), "onYearKeyDown", function(e, t) {
                var r = e.key;
                if (!a.props.disabledKeyboardNavigation) switch(r){
                    case "Enter":
                        a.onYearClick(e, t), a.props.setPreSelection(a.props.selected);
                        break;
                    case "ArrowRight":
                        a.handleYearNavigation(t + 1, ge.default(a.props.preSelection, 1));
                        break;
                    case "ArrowLeft":
                        a.handleYearNavigation(t - 1, Ce.default(a.props.preSelection, 1));
                }
            }), Dt(bt(a), "getYearClassNames", function(e) {
                var t = a.props, r = t.minDate, n = t.maxDate, o = t.selected;
                return ce.default("react-datepicker__year-text", {
                    "react-datepicker__year-text--selected": e === Ie.default(o),
                    "react-datepicker__year-text--disabled": (r || n) && ir(e, a.props),
                    "react-datepicker__year-text--keyboard-selected": a.isKeyboardSelected(e),
                    "react-datepicker__year-text--today": a.isCurrentYear(e)
                });
            }), Dt(bt(a), "getYearTabIndex", function(e) {
                return a.props.disabledKeyboardNavigation ? "-1" : e === Ie.default(a.props.preSelection) ? "0" : "-1";
            }), a;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    for(var e = this, t = [], r = this.props, a = br(r.date, r.yearItemNumber), n = a.startPeriod, o = a.endPeriod, s = function(r) {
                        t.push(de.default.createElement("div", {
                            ref: e.YEAR_REFS[r - n],
                            onClick: function(t) {
                                e.onYearClick(t, r);
                            },
                            onKeyDown: function(t) {
                                e.onYearKeyDown(t, r);
                            },
                            tabIndex: e.getYearTabIndex(r),
                            className: e.getYearClassNames(r),
                            key: r,
                            "aria-current": e.isCurrentYear(r) ? "date" : void 0
                        }, r));
                    }, i = n; i <= o; i++)s(i);
                    return de.default.createElement("div", {
                        className: "react-datepicker__year"
                    }, de.default.createElement("div", {
                        className: "react-datepicker__year-wrapper"
                    }, t));
                }
            }
        ]), r;
    }(de.default.Component), Wr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r(e) {
            var a;
            return ht(this, r), Dt(bt(a = t.call(this, e)), "onTimeChange", function(e) {
                a.setState({
                    time: e
                });
                var t = new Date;
                t.setHours(e.split(":")[0]), t.setMinutes(e.split(":")[1]), a.props.onChange(t);
            }), Dt(bt(a), "renderTimeInput", function() {
                var e = a.state.time, t = a.props, r = t.date, n = t.timeString, o = t.customTimeInput;
                return o ? de.default.cloneElement(o, {
                    date: r,
                    value: e,
                    onChange: a.onTimeChange
                }) : de.default.createElement("input", {
                    type: "time",
                    className: "react-datepicker-time__input",
                    placeholder: "Time",
                    name: "time-input",
                    required: !0,
                    value: e,
                    onChange: function(e) {
                        a.onTimeChange(e.target.value || n);
                    }
                });
            }), a.state = {
                time: a.props.timeString
            }, a;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    return de.default.createElement("div", {
                        className: "react-datepicker__input-time-container"
                    }, de.default.createElement("div", {
                        className: "react-datepicker-time__caption"
                    }, this.props.timeInputLabel), de.default.createElement("div", {
                        className: "react-datepicker-time__input-container"
                    }, de.default.createElement("div", {
                        className: "react-datepicker-time__input"
                    }, this.renderTimeInput())));
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function(e, t) {
                    return e.timeString !== t.time ? {
                        time: e.timeString
                    } : null;
                }
            }
        ]), r;
    }(de.default.Component);
    function Br(e) {
        var t = e.className, r = e.children, a = e.showPopperArrow, n = e.arrowProps, o = void 0 === n ? {} : n;
        return de.default.createElement("div", {
            className: t
        }, a && de.default.createElement("div", vt({
            className: "react-datepicker__triangle"
        }, o)), r);
    }
    var Kr = [
        "react-datepicker__year-select",
        "react-datepicker__month-select",
        "react-datepicker__month-year-select"
    ], Hr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r(e) {
            var a;
            return ht(this, r), Dt(bt(a = t.call(this, e)), "handleClickOutside", function(e) {
                a.props.onClickOutside(e);
            }), Dt(bt(a), "setClickOutsideRef", function() {
                return a.containerRef.current;
            }), Dt(bt(a), "handleDropdownFocus", function(e) {
                (function() {
                    var e = ((arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).className || "").split(/\s+/);
                    return Kr.some(function(t) {
                        return e.indexOf(t) >= 0;
                    });
                })(e.target) && a.props.onDropdownFocus();
            }), Dt(bt(a), "getDateInView", function() {
                var e = a.props, t = e.preSelection, r = e.selected, n = e.openToDate, o = Dr(a.props), s = vr(a.props), i = Yt(), p = n || r || t;
                return p || (o && nt.default(i, o) ? o : s && at.default(i, s) ? s : i);
            }), Dt(bt(a), "increaseMonth", function() {
                a.setState(function(e) {
                    var t = e.date;
                    return {
                        date: we.default(t, 1)
                    };
                }, function() {
                    return a.handleMonthChange(a.state.date);
                });
            }), Dt(bt(a), "decreaseMonth", function() {
                a.setState(function(e) {
                    var t = e.date;
                    return {
                        date: Se.default(t, 1)
                    };
                }, function() {
                    return a.handleMonthChange(a.state.date);
                });
            }), Dt(bt(a), "handleDayClick", function(e, t, r) {
                a.props.onSelect(e, t, r), a.props.setPreSelection && a.props.setPreSelection(e);
            }), Dt(bt(a), "handleDayMouseEnter", function(e) {
                a.setState({
                    selectingDate: e
                }), a.props.onDayMouseEnter && a.props.onDayMouseEnter(e);
            }), Dt(bt(a), "handleMonthMouseLeave", function() {
                a.setState({
                    selectingDate: null
                }), a.props.onMonthMouseLeave && a.props.onMonthMouseLeave();
            }), Dt(bt(a), "handleYearChange", function(e) {
                a.props.onYearChange && a.props.onYearChange(e), a.props.adjustDateOnChange && (a.props.onSelect && a.props.onSelect(e), a.props.setOpen && a.props.setOpen(!0)), a.props.setPreSelection && a.props.setPreSelection(e);
            }), Dt(bt(a), "handleMonthChange", function(e) {
                a.props.onMonthChange && a.props.onMonthChange(e), a.props.adjustDateOnChange && (a.props.onSelect && a.props.onSelect(e), a.props.setOpen && a.props.setOpen(!0)), a.props.setPreSelection && a.props.setPreSelection(e);
            }), Dt(bt(a), "handleMonthYearChange", function(e) {
                a.handleYearChange(e), a.handleMonthChange(e);
            }), Dt(bt(a), "changeYear", function(e) {
                a.setState(function(t) {
                    var r = t.date;
                    return {
                        date: We.default(r, e)
                    };
                }, function() {
                    return a.handleYearChange(a.state.date);
                });
            }), Dt(bt(a), "changeMonth", function(e) {
                a.setState(function(t) {
                    var r = t.date;
                    return {
                        date: Ae.default(r, e)
                    };
                }, function() {
                    return a.handleMonthChange(a.state.date);
                });
            }), Dt(bt(a), "changeMonthYear", function(e) {
                a.setState(function(t) {
                    var r = t.date;
                    return {
                        date: We.default(Ae.default(r, Oe.default(e)), Ie.default(e))
                    };
                }, function() {
                    return a.handleMonthYearChange(a.state.date);
                });
            }), Dt(bt(a), "header", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : a.state.date, t = Bt(e, a.props.locale, a.props.calendarStartDay), r = [];
                return a.props.showWeekNumbers && r.push(de.default.createElement("div", {
                    key: "W",
                    className: "react-datepicker__day-name"
                }, a.props.weekLabel || "#")), r.concat([
                    0,
                    1,
                    2,
                    3,
                    4,
                    5,
                    6
                ].map(function(e) {
                    var r = De.default(t, e), n = a.formatWeekday(r, a.props.locale), o = a.props.weekDayClassName ? a.props.weekDayClassName(r) : void 0;
                    return de.default.createElement("div", {
                        key: e,
                        className: ce.default("react-datepicker__day-name", o)
                    }, n);
                }));
            }), Dt(bt(a), "formatWeekday", function(e, t) {
                return a.props.formatWeekDay ? function(e, t, r) {
                    return t(Lt(e, "EEEE", r));
                }(e, a.props.formatWeekDay, t) : a.props.useWeekdaysShort ? function(e, t) {
                    return Lt(e, "EEE", t);
                }(e, t) : function(e, t) {
                    return Lt(e, "EEEEEE", t);
                }(e, t);
            }), Dt(bt(a), "decreaseYear", function() {
                a.setState(function(e) {
                    var t = e.date;
                    return {
                        date: Ce.default(t, a.props.showYearPicker ? a.props.yearItemNumber : 1)
                    };
                }, function() {
                    return a.handleYearChange(a.state.date);
                });
            }), Dt(bt(a), "renderPreviousButton", function() {
                if (!a.props.renderCustomHeader) {
                    var e;
                    switch(!0){
                        case a.props.showMonthYearPicker:
                            e = mr(a.state.date, a.props);
                            break;
                        case a.props.showYearPicker:
                            e = function(e) {
                                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.minDate, a = t.yearItemNumber, n = void 0 === a ? xt : a, o = br(Ht(Ce.default(e, n)), n).endPeriod, s = r && Ie.default(r);
                                return s && s > o || !1;
                            }(a.state.date, a.props);
                            break;
                        default:
                            e = fr(a.state.date, a.props);
                    }
                    if ((a.props.forceShowMonthNavigation || a.props.showDisabledMonthNavigation || !e) && !a.props.showTimeSelectOnly) {
                        var t = [
                            "react-datepicker__navigation",
                            "react-datepicker__navigation--previous"
                        ], r = a.decreaseMonth;
                        (a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker) && (r = a.decreaseYear), e && a.props.showDisabledMonthNavigation && (t.push("react-datepicker__navigation--previous--disabled"), r = null);
                        var n = a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker, o = a.props, s = o.previousMonthButtonLabel, i = o.previousYearButtonLabel, p = a.props, l = p.previousMonthAriaLabel, d = void 0 === l ? "string" == typeof s ? s : "Previous Month" : l, c = p.previousYearAriaLabel, u = void 0 === c ? "string" == typeof i ? i : "Previous Year" : c;
                        return de.default.createElement("button", {
                            type: "button",
                            className: t.join(" "),
                            onClick: r,
                            onKeyDown: a.props.handleOnKeyDown,
                            "aria-label": n ? u : d
                        }, de.default.createElement("span", {
                            className: [
                                "react-datepicker__navigation-icon",
                                "react-datepicker__navigation-icon--previous"
                            ].join(" ")
                        }, n ? a.props.previousYearButtonLabel : a.props.previousMonthButtonLabel));
                    }
                }
            }), Dt(bt(a), "increaseYear", function() {
                a.setState(function(e) {
                    var t = e.date;
                    return {
                        date: ge.default(t, a.props.showYearPicker ? a.props.yearItemNumber : 1)
                    };
                }, function() {
                    return a.handleYearChange(a.state.date);
                });
            }), Dt(bt(a), "renderNextButton", function() {
                if (!a.props.renderCustomHeader) {
                    var e;
                    switch(!0){
                        case a.props.showMonthYearPicker:
                            e = yr(a.state.date, a.props);
                            break;
                        case a.props.showYearPicker:
                            e = function(e) {
                                var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, r = t.maxDate, a = t.yearItemNumber, n = void 0 === a ? xt : a, o = br(ge.default(e, n), n).startPeriod, s = r && Ie.default(r);
                                return s && s < o || !1;
                            }(a.state.date, a.props);
                            break;
                        default:
                            e = hr(a.state.date, a.props);
                    }
                    if ((a.props.forceShowMonthNavigation || a.props.showDisabledMonthNavigation || !e) && !a.props.showTimeSelectOnly) {
                        var t = [
                            "react-datepicker__navigation",
                            "react-datepicker__navigation--next"
                        ];
                        a.props.showTimeSelect && t.push("react-datepicker__navigation--next--with-time"), a.props.todayButton && t.push("react-datepicker__navigation--next--with-today-button");
                        var r = a.increaseMonth;
                        (a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker) && (r = a.increaseYear), e && a.props.showDisabledMonthNavigation && (t.push("react-datepicker__navigation--next--disabled"), r = null);
                        var n = a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker, o = a.props, s = o.nextMonthButtonLabel, i = o.nextYearButtonLabel, p = a.props, l = p.nextMonthAriaLabel, d = void 0 === l ? "string" == typeof s ? s : "Next Month" : l, c = p.nextYearAriaLabel, u = void 0 === c ? "string" == typeof i ? i : "Next Year" : c;
                        return de.default.createElement("button", {
                            type: "button",
                            className: t.join(" "),
                            onClick: r,
                            onKeyDown: a.props.handleOnKeyDown,
                            "aria-label": n ? u : d
                        }, de.default.createElement("span", {
                            className: [
                                "react-datepicker__navigation-icon",
                                "react-datepicker__navigation-icon--next"
                            ].join(" ")
                        }, n ? a.props.nextYearButtonLabel : a.props.nextMonthButtonLabel));
                    }
                }
            }), Dt(bt(a), "renderCurrentMonth", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : a.state.date, t = [
                    "react-datepicker__current-month"
                ];
                return a.props.showYearDropdown && t.push("react-datepicker__current-month--hasYearDropdown"), a.props.showMonthDropdown && t.push("react-datepicker__current-month--hasMonthDropdown"), a.props.showMonthYearDropdown && t.push("react-datepicker__current-month--hasMonthYearDropdown"), de.default.createElement("div", {
                    className: t.join(" ")
                }, Lt(e, a.props.dateFormat, a.props.locale));
            }), Dt(bt(a), "renderYearDropdown", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (a.props.showYearDropdown && !e) return de.default.createElement(Mr, {
                    adjustDateOnChange: a.props.adjustDateOnChange,
                    date: a.state.date,
                    onSelect: a.props.onSelect,
                    setOpen: a.props.setOpen,
                    dropdownMode: a.props.dropdownMode,
                    onChange: a.changeYear,
                    minDate: a.props.minDate,
                    maxDate: a.props.maxDate,
                    year: Ie.default(a.state.date),
                    scrollableYearDropdown: a.props.scrollableYearDropdown,
                    yearDropdownItemNumber: a.props.yearDropdownItemNumber
                });
            }), Dt(bt(a), "renderMonthDropdown", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (a.props.showMonthDropdown && !e) return de.default.createElement(Nr, {
                    dropdownMode: a.props.dropdownMode,
                    locale: a.props.locale,
                    onChange: a.changeMonth,
                    month: Oe.default(a.state.date),
                    useShortMonthInDropdown: a.props.useShortMonthInDropdown
                });
            }), Dt(bt(a), "renderMonthYearDropdown", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                if (a.props.showMonthYearDropdown && !e) return de.default.createElement(Ir, {
                    dropdownMode: a.props.dropdownMode,
                    locale: a.props.locale,
                    dateFormat: a.props.dateFormat,
                    onChange: a.changeMonthYear,
                    minDate: a.props.minDate,
                    maxDate: a.props.maxDate,
                    date: a.state.date,
                    scrollableMonthYearDropdown: a.props.scrollableMonthYearDropdown
                });
            }), Dt(bt(a), "renderTodayButton", function() {
                if (a.props.todayButton && !a.props.showTimeSelectOnly) return de.default.createElement("div", {
                    className: "react-datepicker__today-button",
                    onClick: function(e) {
                        return a.props.onSelect(Ve.default(Yt()), e);
                    }
                }, a.props.todayButton);
            }), Dt(bt(a), "renderDefaultHeader", function(e) {
                var t = e.monthDate, r = e.i;
                return de.default.createElement("div", {
                    className: "react-datepicker__header ".concat(a.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "")
                }, a.renderCurrentMonth(t), de.default.createElement("div", {
                    className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(a.props.dropdownMode),
                    onFocus: a.handleDropdownFocus
                }, a.renderMonthDropdown(0 !== r), a.renderMonthYearDropdown(0 !== r), a.renderYearDropdown(0 !== r)), de.default.createElement("div", {
                    className: "react-datepicker__day-names"
                }, a.header(t)));
            }), Dt(bt(a), "renderCustomHeader", function() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = e.monthDate, r = e.i;
                if (a.props.showTimeSelect && !a.state.monthContainer || a.props.showTimeSelectOnly) return null;
                var n = fr(a.state.date, a.props), o = hr(a.state.date, a.props), s = mr(a.state.date, a.props), i = yr(a.state.date, a.props), p = !a.props.showMonthYearPicker && !a.props.showQuarterYearPicker && !a.props.showYearPicker;
                return de.default.createElement("div", {
                    className: "react-datepicker__header react-datepicker__header--custom",
                    onFocus: a.props.onDropdownFocus
                }, a.props.renderCustomHeader(ut(ut({}, a.state), {}, {
                    customHeaderCount: r,
                    monthDate: t,
                    changeMonth: a.changeMonth,
                    changeYear: a.changeYear,
                    decreaseMonth: a.decreaseMonth,
                    increaseMonth: a.increaseMonth,
                    decreaseYear: a.decreaseYear,
                    increaseYear: a.increaseYear,
                    prevMonthButtonDisabled: n,
                    nextMonthButtonDisabled: o,
                    prevYearButtonDisabled: s,
                    nextYearButtonDisabled: i
                })), p && de.default.createElement("div", {
                    className: "react-datepicker__day-names"
                }, a.header(t)));
            }), Dt(bt(a), "renderYearHeader", function() {
                var e = a.state.date, t = a.props, r = t.showYearPicker, n = br(e, t.yearItemNumber), o = n.startPeriod, s = n.endPeriod;
                return de.default.createElement("div", {
                    className: "react-datepicker__header react-datepicker-year-header"
                }, r ? "".concat(o, " - ").concat(s) : Ie.default(e));
            }), Dt(bt(a), "renderHeader", function(e) {
                switch(!0){
                    case void 0 !== a.props.renderCustomHeader:
                        return a.renderCustomHeader(e);
                    case a.props.showMonthYearPicker || a.props.showQuarterYearPicker || a.props.showYearPicker:
                        return a.renderYearHeader(e);
                    default:
                        return a.renderDefaultHeader(e);
                }
            }), Dt(bt(a), "renderMonths", function() {
                if (!a.props.showTimeSelectOnly && !a.props.showYearPicker) {
                    for(var e = [], t = a.props.showPreviousMonths ? a.props.monthsShown - 1 : 0, r = Se.default(a.state.date, t), n = 0; n < a.props.monthsShown; ++n){
                        var o = n - a.props.monthSelectedIn, s = we.default(r, o), i = "month-".concat(n), p = n < a.props.monthsShown - 1, l = n > 0;
                        e.push(de.default.createElement("div", {
                            key: i,
                            ref: function(e) {
                                a.monthContainer = e;
                            },
                            className: "react-datepicker__month-container"
                        }, a.renderHeader({
                            monthDate: s,
                            i: n
                        }), de.default.createElement(Fr, {
                            chooseDayAriaLabelPrefix: a.props.chooseDayAriaLabelPrefix,
                            disabledDayAriaLabelPrefix: a.props.disabledDayAriaLabelPrefix,
                            weekAriaLabelPrefix: a.props.weekAriaLabelPrefix,
                            ariaLabelPrefix: a.props.monthAriaLabelPrefix,
                            onChange: a.changeMonthYear,
                            day: s,
                            dayClassName: a.props.dayClassName,
                            calendarStartDay: a.props.calendarStartDay,
                            monthClassName: a.props.monthClassName,
                            onDayClick: a.handleDayClick,
                            handleOnKeyDown: a.props.handleOnDayKeyDown,
                            onDayMouseEnter: a.handleDayMouseEnter,
                            onMouseLeave: a.handleMonthMouseLeave,
                            onWeekSelect: a.props.onWeekSelect,
                            orderInDisplay: n,
                            formatWeekNumber: a.props.formatWeekNumber,
                            locale: a.props.locale,
                            minDate: a.props.minDate,
                            maxDate: a.props.maxDate,
                            excludeDates: a.props.excludeDates,
                            excludeDateIntervals: a.props.excludeDateIntervals,
                            highlightDates: a.props.highlightDates,
                            selectingDate: a.state.selectingDate,
                            includeDates: a.props.includeDates,
                            includeDateIntervals: a.props.includeDateIntervals,
                            inline: a.props.inline,
                            shouldFocusDayInline: a.props.shouldFocusDayInline,
                            fixedHeight: a.props.fixedHeight,
                            filterDate: a.props.filterDate,
                            preSelection: a.props.preSelection,
                            setPreSelection: a.props.setPreSelection,
                            selected: a.props.selected,
                            selectsStart: a.props.selectsStart,
                            selectsEnd: a.props.selectsEnd,
                            selectsRange: a.props.selectsRange,
                            selectsDisabledDaysInRange: a.props.selectsDisabledDaysInRange,
                            showWeekNumbers: a.props.showWeekNumbers,
                            startDate: a.props.startDate,
                            endDate: a.props.endDate,
                            peekNextMonth: a.props.peekNextMonth,
                            setOpen: a.props.setOpen,
                            shouldCloseOnSelect: a.props.shouldCloseOnSelect,
                            renderDayContents: a.props.renderDayContents,
                            disabledKeyboardNavigation: a.props.disabledKeyboardNavigation,
                            showMonthYearPicker: a.props.showMonthYearPicker,
                            showFullMonthYearPicker: a.props.showFullMonthYearPicker,
                            showTwoColumnMonthYearPicker: a.props.showTwoColumnMonthYearPicker,
                            showFourColumnMonthYearPicker: a.props.showFourColumnMonthYearPicker,
                            showYearPicker: a.props.showYearPicker,
                            showQuarterYearPicker: a.props.showQuarterYearPicker,
                            isInputFocused: a.props.isInputFocused,
                            containerRef: a.containerRef,
                            monthShowsDuplicateDaysEnd: p,
                            monthShowsDuplicateDaysStart: l
                        })));
                    }
                    return e;
                }
            }), Dt(bt(a), "renderYears", function() {
                if (!a.props.showTimeSelectOnly) return a.props.showYearPicker ? de.default.createElement("div", {
                    className: "react-datepicker__year--container"
                }, a.renderHeader(), de.default.createElement(qr, vt({
                    onDayClick: a.handleDayClick,
                    date: a.state.date
                }, a.props))) : void 0;
            }), Dt(bt(a), "renderTimeSection", function() {
                if (a.props.showTimeSelect && (a.state.monthContainer || a.props.showTimeSelectOnly)) return de.default.createElement(Ar, {
                    selected: a.props.selected,
                    openToDate: a.props.openToDate,
                    onChange: a.props.onTimeChange,
                    timeClassName: a.props.timeClassName,
                    format: a.props.timeFormat,
                    includeTimes: a.props.includeTimes,
                    intervals: a.props.timeIntervals,
                    minTime: a.props.minTime,
                    maxTime: a.props.maxTime,
                    excludeTimes: a.props.excludeTimes,
                    filterTime: a.props.filterTime,
                    timeCaption: a.props.timeCaption,
                    todayButton: a.props.todayButton,
                    showMonthDropdown: a.props.showMonthDropdown,
                    showMonthYearDropdown: a.props.showMonthYearDropdown,
                    showYearDropdown: a.props.showYearDropdown,
                    withPortal: a.props.withPortal,
                    monthRef: a.state.monthContainer,
                    injectTimes: a.props.injectTimes,
                    locale: a.props.locale,
                    handleOnKeyDown: a.props.handleOnKeyDown,
                    showTimeSelectOnly: a.props.showTimeSelectOnly
                });
            }), Dt(bt(a), "renderInputTimeSection", function() {
                var e = new Date(a.props.selected), t = Tt(e) && Boolean(a.props.selected) ? "".concat(kr(e.getHours()), ":").concat(kr(e.getMinutes())) : "";
                if (a.props.showTimeInput) return de.default.createElement(Wr, {
                    date: e,
                    timeString: t,
                    timeInputLabel: a.props.timeInputLabel,
                    onChange: a.props.onTimeChange,
                    customTimeInput: a.props.customTimeInput
                });
            }), a.containerRef = de.default.createRef(), a.state = {
                date: a.getDateInView(),
                selectingDate: null,
                monthContainer: null
            }, a;
        }
        return yt(r, [
            {
                key: "componentDidMount",
                value: function() {
                    var e = this;
                    this.props.showTimeSelect && (this.assignMonthContainer = void e.setState({
                        monthContainer: e.monthContainer
                    }));
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e) {
                    this.props.preSelection && !$t(this.props.preSelection, e.preSelection) ? this.setState({
                        date: this.props.preSelection
                    }) : this.props.openToDate && !$t(this.props.openToDate, e.openToDate) && this.setState({
                        date: this.props.openToDate
                    });
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.props.container || Br;
                    return de.default.createElement("div", {
                        ref: this.containerRef
                    }, de.default.createElement(e, {
                        className: ce.default("react-datepicker", this.props.className, {
                            "react-datepicker--time-only": this.props.showTimeSelectOnly
                        }),
                        showPopperArrow: this.props.showPopperArrow,
                        arrowProps: this.props.arrowProps
                    }, this.renderPreviousButton(), this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.props.children));
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        onDropdownFocus: function() {},
                        monthsShown: 1,
                        monthSelectedIn: 0,
                        forceShowMonthNavigation: !1,
                        timeCaption: "Time",
                        previousYearButtonLabel: "Previous Year",
                        nextYearButtonLabel: "Next Year",
                        previousMonthButtonLabel: "Previous Month",
                        nextMonthButtonLabel: "Next Month",
                        customTimeInput: null,
                        yearItemNumber: xt
                    };
                }
            }
        ]), r;
    }(de.default.Component), jr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r(e) {
            var a;
            return ht(this, r), (a = t.call(this, e)).el = document.createElement("div"), a;
        }
        return yt(r, [
            {
                key: "componentDidMount",
                value: function() {
                    this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId), this.portalRoot || (this.portalRoot = document.createElement("div"), this.portalRoot.setAttribute("id", this.props.portalId), (this.props.portalHost || document.body).appendChild(this.portalRoot)), this.portalRoot.appendChild(this.el);
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    this.portalRoot.removeChild(this.el);
                }
            },
            {
                key: "render",
                value: function() {
                    return dt.default.createPortal(this.props.children, this.el);
                }
            }
        ]), r;
    }(de.default.Component), Qr = function(e) {
        return !e.disabled && -1 !== e.tabIndex;
    }, Vr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r(e) {
            var a;
            return ht(this, r), Dt(bt(a = t.call(this, e)), "getTabChildren", function() {
                return Array.prototype.slice.call(a.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"), 1, -1).filter(Qr);
            }), Dt(bt(a), "handleFocusStart", function(e) {
                var t = a.getTabChildren();
                t && t.length > 1 && t[t.length - 1].focus();
            }), Dt(bt(a), "handleFocusEnd", function(e) {
                var t = a.getTabChildren();
                t && t.length > 1 && t[0].focus();
            }), a.tabLoopRef = de.default.createRef(), a;
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    return this.props.enableTabLoop ? de.default.createElement("div", {
                        className: "react-datepicker__tab-loop",
                        ref: this.tabLoopRef
                    }, de.default.createElement("div", {
                        className: "react-datepicker__tab-loop__start",
                        tabIndex: "0",
                        onFocus: this.handleFocusStart
                    }), this.props.children, de.default.createElement("div", {
                        className: "react-datepicker__tab-loop__end",
                        tabIndex: "0",
                        onFocus: this.handleFocusEnd
                    })) : this.props.children;
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        enableTabLoop: !0
                    };
                }
            }
        ]), r;
    }(de.default.Component), Ur = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r() {
            return ht(this, r), t.apply(this, arguments);
        }
        return yt(r, [
            {
                key: "render",
                value: function() {
                    var e, t = this.props, r = t.className, a = t.wrapperClassName, n = t.hidePopper, o = t.popperComponent, s = t.popperModifiers, i = t.popperPlacement, p = t.popperProps, l = t.targetComponent, d = t.enableTabLoop, c = t.popperOnKeyDown, u = t.portalId, f = t.portalHost;
                    if (!n) {
                        var h = ce.default("react-datepicker-popper", r);
                        e = de.default.createElement(pe.Popper, vt({
                            modifiers: s,
                            placement: i
                        }, p), function(e) {
                            var t = e.ref, r = e.style, a = e.placement, n = e.arrowProps;
                            return de.default.createElement(Vr, {
                                enableTabLoop: d
                            }, de.default.createElement("div", {
                                ref: t,
                                style: r,
                                className: h,
                                "data-placement": a,
                                onKeyDown: c
                            }, de.default.cloneElement(o, {
                                arrowProps: n
                            })));
                        });
                    }
                    this.props.popperContainer && (e = de.default.createElement(this.props.popperContainer, {}, e)), u && !n && (e = de.default.createElement(jr, {
                        portalId: u,
                        portalHost: f
                    }, e));
                    var m = ce.default("react-datepicker-wrapper", a);
                    return de.default.createElement(pe.Manager, {
                        className: "react-datepicker-manager"
                    }, de.default.createElement(pe.Reference, null, function(e) {
                        var t = e.ref;
                        return de.default.createElement("div", {
                            ref: t,
                            className: m
                        }, l);
                    }), e);
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        hidePopper: !0,
                        popperModifiers: [],
                        popperProps: {},
                        popperPlacement: "bottom-start"
                    };
                }
            }
        ]), r;
    }(de.default.Component), $r = "react-datepicker-ignore-onclickoutside", zr = lt.default(Hr);
    var Gr = "Date input not valid.", Jr = function(e) {
        wt(r, e);
        var t = Ct(r);
        function r(e) {
            var a;
            return ht(this, r), Dt(bt(a = t.call(this, e)), "getPreSelection", function() {
                return a.props.openToDate ? a.props.openToDate : a.props.selectsEnd && a.props.startDate ? a.props.startDate : a.props.selectsStart && a.props.endDate ? a.props.endDate : Yt();
            }), Dt(bt(a), "calcInitialState", function() {
                var e, t = a.getPreSelection(), r = Dr(a.props), n = vr(a.props), o = r && nt.default(t, Ve.default(r)) ? r : n && at.default(t, Je.default(n)) ? n : t;
                return {
                    open: a.props.startOpen || !1,
                    preventFocus: !1,
                    preSelection: null !== (e = a.props.selectsRange ? a.props.startDate : a.props.selected) && void 0 !== e ? e : o,
                    highlightDates: wr(a.props.highlightDates),
                    focused: !1,
                    shouldFocusDayInline: !1
                };
            }), Dt(bt(a), "clearPreventFocusTimeout", function() {
                a.preventFocusTimeout && clearTimeout(a.preventFocusTimeout);
            }), Dt(bt(a), "setFocus", function() {
                a.input && a.input.focus && a.input.focus({
                    preventScroll: !0
                });
            }), Dt(bt(a), "setBlur", function() {
                a.input && a.input.blur && a.input.blur(), a.cancelFocusInput();
            }), Dt(bt(a), "setOpen", function(e) {
                var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                a.setState({
                    open: e,
                    preSelection: e && a.state.open ? a.state.preSelection : a.calcInitialState().preSelection,
                    lastPreSelectChange: Zr
                }, function() {
                    e || a.setState(function(e) {
                        return {
                            focused: !!t && e.focused
                        };
                    }, function() {
                        !t && a.setBlur(), a.setState({
                            inputValue: null
                        });
                    });
                });
            }), Dt(bt(a), "inputOk", function() {
                return ue.default(a.state.preSelection);
            }), Dt(bt(a), "isCalendarOpen", function() {
                return void 0 === a.props.open ? a.state.open && !a.props.disabled && !a.props.readOnly : a.props.open;
            }), Dt(bt(a), "handleFocus", function(e) {
                a.state.preventFocus || (a.props.onFocus(e), a.props.preventOpenOnFocus || a.props.readOnly || a.setOpen(!0)), a.setState({
                    focused: !0
                });
            }), Dt(bt(a), "cancelFocusInput", function() {
                clearTimeout(a.inputFocusTimeout), a.inputFocusTimeout = null;
            }), Dt(bt(a), "deferFocusInput", function() {
                a.cancelFocusInput(), a.inputFocusTimeout = setTimeout(function() {
                    return a.setFocus();
                }, 1);
            }), Dt(bt(a), "handleDropdownFocus", function() {
                a.cancelFocusInput();
            }), Dt(bt(a), "handleBlur", function(e) {
                (!a.state.open || a.props.withPortal || a.props.showTimeInput) && a.props.onBlur(e), a.setState({
                    focused: !1
                });
            }), Dt(bt(a), "handleCalendarClickOutside", function(e) {
                a.props.inline || a.setOpen(!1), a.props.onClickOutside(e), a.props.withPortal && e.preventDefault();
            }), Dt(bt(a), "handleChange", function() {
                for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
                var n = t[0];
                if (!a.props.onChangeRaw || (a.props.onChangeRaw.apply(bt(a), t), "function" == typeof n.isDefaultPrevented && !n.isDefaultPrevented())) {
                    a.setState({
                        inputValue: n.target.value,
                        lastPreSelectChange: Xr
                    });
                    var o = It(n.target.value, a.props.dateFormat, a.props.locale, a.props.strictParsing, a.props.minDate);
                    !o && n.target.value || a.setSelected(o, n, !0);
                }
            }), Dt(bt(a), "handleSelect", function(e, t, r) {
                if (a.setState({
                    preventFocus: !0
                }, function() {
                    return a.preventFocusTimeout = setTimeout(function() {
                        return a.setState({
                            preventFocus: !1
                        });
                    }, 50), a.preventFocusTimeout;
                }), a.props.onChangeRaw && a.props.onChangeRaw(t), a.setSelected(e, t, !1, r), !a.props.shouldCloseOnSelect || a.props.showTimeSelect) a.setPreSelection(e);
                else if (!a.props.inline) {
                    a.props.selectsRange || a.setOpen(!1);
                    var n = a.props, o = n.startDate, s = n.endDate;
                    !o || s || nt.default(e, o) || a.setOpen(!1);
                }
            }), Dt(bt(a), "setSelected", function(e, t, r, n) {
                var o = e;
                if (null === o || !rr(o, a.props)) {
                    var s = a.props, i = s.onChange, p = s.selectsRange, l = s.startDate, d = s.endDate;
                    if (!zt(a.props.selected, o) || a.props.allowSameDay || p) {
                        if (null !== o && (!a.props.selected || r && (a.props.showTimeSelect || a.props.showTimeSelectOnly || a.props.showTimeInput) || (o = Ft(o, {
                            hour: Pe.default(a.props.selected),
                            minute: Me.default(a.props.selected),
                            second: _e.default(a.props.selected)
                        })), a.props.inline || a.setState({
                            preSelection: o
                        }), a.props.focusSelectedMonth || a.setState({
                            monthSelectedIn: n
                        })), p) {
                            var c = l && !d, u = l && d;
                            !l && !d ? i([
                                o,
                                null
                            ], t) : c && (nt.default(o, l) ? i([
                                o,
                                null
                            ], t) : i([
                                l,
                                o
                            ], t)), u && i([
                                o,
                                null
                            ], t);
                        } else i(o, t);
                    }
                    r || (a.props.onSelect(o, t), a.setState({
                        inputValue: null
                    }));
                }
            }), Dt(bt(a), "setPreSelection", function(e) {
                var t = void 0 !== a.props.minDate, r = void 0 !== a.props.maxDate, n = !0;
                if (e) {
                    var o = Ve.default(e);
                    if (t && r) n = Gt(e, a.props.minDate, a.props.maxDate);
                    else if (t) {
                        var s = Ve.default(a.props.minDate);
                        n = at.default(e, s) || zt(o, s);
                    } else if (r) {
                        var i = Je.default(a.props.maxDate);
                        n = nt.default(e, i) || zt(o, i);
                    }
                }
                n && a.setState({
                    preSelection: e
                });
            }), Dt(bt(a), "handleTimeChange", function(e) {
                var t = Ft(a.props.selected ? a.props.selected : a.getPreSelection(), {
                    hour: Pe.default(e),
                    minute: Me.default(e)
                });
                a.setState({
                    preSelection: t
                }), a.props.onChange(t), a.props.shouldCloseOnSelect && a.setOpen(!1), a.props.showTimeInput && a.setOpen(!0), a.setState({
                    inputValue: null
                });
            }), Dt(bt(a), "onInputClick", function() {
                a.props.disabled || a.props.readOnly || a.setOpen(!0), a.props.onInputClick();
            }), Dt(bt(a), "onInputKeyDown", function(e) {
                a.props.onKeyDown(e);
                var t = e.key;
                if (a.state.open || a.props.inline || a.props.preventOpenOnFocus) {
                    if (a.state.open) {
                        if ("ArrowDown" === t || "ArrowUp" === t) {
                            e.preventDefault();
                            var r = a.calendar.componentNode && a.calendar.componentNode.querySelector('.react-datepicker__day[tabindex="0"]');
                            return void (r && r.focus({
                                preventScroll: !0
                            }));
                        }
                        var n = Yt(a.state.preSelection);
                        "Enter" === t ? (e.preventDefault(), a.inputOk() && a.state.lastPreSelectChange === Zr ? (a.handleSelect(n, e), !a.props.shouldCloseOnSelect && a.setPreSelection(n)) : a.setOpen(!1)) : "Escape" === t && (e.preventDefault(), a.setOpen(!1)), a.inputOk() || a.props.onInputError({
                            code: 1,
                            msg: Gr
                        });
                    }
                } else "ArrowDown" !== t && "ArrowUp" !== t && "Enter" !== t || a.onInputClick();
            }), Dt(bt(a), "onDayKeyDown", function(e) {
                a.props.onKeyDown(e);
                var t = e.key, r = Yt(a.state.preSelection);
                if ("Enter" === t) e.preventDefault(), a.handleSelect(r, e), !a.props.shouldCloseOnSelect && a.setPreSelection(r);
                else if ("Escape" === t) e.preventDefault(), a.setOpen(!1), a.inputOk() || a.props.onInputError({
                    code: 1,
                    msg: Gr
                });
                else if (!a.props.disabledKeyboardNavigation) {
                    var n;
                    switch(t){
                        case "ArrowLeft":
                            n = ke.default(r, 1);
                            break;
                        case "ArrowRight":
                            n = De.default(r, 1);
                            break;
                        case "ArrowUp":
                            n = be.default(r, 1);
                            break;
                        case "ArrowDown":
                            n = ve.default(r, 1);
                            break;
                        case "PageUp":
                            n = Se.default(r, 1);
                            break;
                        case "PageDown":
                            n = we.default(r, 1);
                            break;
                        case "Home":
                            n = Ce.default(r, 1);
                            break;
                        case "End":
                            n = ge.default(r, 1);
                    }
                    if (!n) return void (a.props.onInputError && a.props.onInputError({
                        code: 1,
                        msg: Gr
                    }));
                    if (e.preventDefault(), a.setState({
                        lastPreSelectChange: Zr
                    }), a.props.adjustDateOnChange && a.setSelected(n), a.setPreSelection(n), a.props.inline) {
                        var o = Oe.default(r), s = Oe.default(n), i = Ie.default(r), p = Ie.default(n);
                        o !== s || i !== p ? a.setState({
                            shouldFocusDayInline: !0
                        }) : a.setState({
                            shouldFocusDayInline: !1
                        });
                    }
                }
            }), Dt(bt(a), "onPopperKeyDown", function(e) {
                "Escape" === e.key && (e.preventDefault(), a.setState({
                    preventFocus: !0
                }, function() {
                    a.setOpen(!1), setTimeout(function() {
                        a.setFocus(), a.setState({
                            preventFocus: !1
                        });
                    });
                }));
            }), Dt(bt(a), "onClearClick", function(e) {
                e && e.preventDefault && e.preventDefault(), a.props.selectsRange ? a.props.onChange([
                    null,
                    null
                ], e) : a.props.onChange(null, e), a.setState({
                    inputValue: null
                });
            }), Dt(bt(a), "clear", function() {
                a.onClearClick();
            }), Dt(bt(a), "onScroll", function(e) {
                "boolean" == typeof a.props.closeOnScroll && a.props.closeOnScroll ? e.target !== document && e.target !== document.documentElement && e.target !== document.body || a.setOpen(!1) : "function" == typeof a.props.closeOnScroll && a.props.closeOnScroll(e) && a.setOpen(!1);
            }), Dt(bt(a), "renderCalendar", function() {
                return a.props.inline || a.isCalendarOpen() ? de.default.createElement(zr, {
                    ref: function(e) {
                        a.calendar = e;
                    },
                    locale: a.props.locale,
                    calendarStartDay: a.props.calendarStartDay,
                    chooseDayAriaLabelPrefix: a.props.chooseDayAriaLabelPrefix,
                    disabledDayAriaLabelPrefix: a.props.disabledDayAriaLabelPrefix,
                    weekAriaLabelPrefix: a.props.weekAriaLabelPrefix,
                    monthAriaLabelPrefix: a.props.monthAriaLabelPrefix,
                    adjustDateOnChange: a.props.adjustDateOnChange,
                    setOpen: a.setOpen,
                    shouldCloseOnSelect: a.props.shouldCloseOnSelect,
                    dateFormat: a.props.dateFormatCalendar,
                    useWeekdaysShort: a.props.useWeekdaysShort,
                    formatWeekDay: a.props.formatWeekDay,
                    dropdownMode: a.props.dropdownMode,
                    selected: a.props.selected,
                    preSelection: a.state.preSelection,
                    onSelect: a.handleSelect,
                    onWeekSelect: a.props.onWeekSelect,
                    openToDate: a.props.openToDate,
                    minDate: a.props.minDate,
                    maxDate: a.props.maxDate,
                    selectsStart: a.props.selectsStart,
                    selectsEnd: a.props.selectsEnd,
                    selectsRange: a.props.selectsRange,
                    startDate: a.props.startDate,
                    endDate: a.props.endDate,
                    excludeDates: a.props.excludeDates,
                    excludeDateIntervals: a.props.excludeDateIntervals,
                    filterDate: a.props.filterDate,
                    onClickOutside: a.handleCalendarClickOutside,
                    formatWeekNumber: a.props.formatWeekNumber,
                    highlightDates: a.state.highlightDates,
                    includeDates: a.props.includeDates,
                    includeDateIntervals: a.props.includeDateIntervals,
                    includeTimes: a.props.includeTimes,
                    injectTimes: a.props.injectTimes,
                    inline: a.props.inline,
                    shouldFocusDayInline: a.state.shouldFocusDayInline,
                    peekNextMonth: a.props.peekNextMonth,
                    showMonthDropdown: a.props.showMonthDropdown,
                    showPreviousMonths: a.props.showPreviousMonths,
                    useShortMonthInDropdown: a.props.useShortMonthInDropdown,
                    showMonthYearDropdown: a.props.showMonthYearDropdown,
                    showWeekNumbers: a.props.showWeekNumbers,
                    showYearDropdown: a.props.showYearDropdown,
                    withPortal: a.props.withPortal,
                    forceShowMonthNavigation: a.props.forceShowMonthNavigation,
                    showDisabledMonthNavigation: a.props.showDisabledMonthNavigation,
                    scrollableYearDropdown: a.props.scrollableYearDropdown,
                    scrollableMonthYearDropdown: a.props.scrollableMonthYearDropdown,
                    todayButton: a.props.todayButton,
                    weekLabel: a.props.weekLabel,
                    outsideClickIgnoreClass: $r,
                    fixedHeight: a.props.fixedHeight,
                    monthsShown: a.props.monthsShown,
                    monthSelectedIn: a.state.monthSelectedIn,
                    onDropdownFocus: a.handleDropdownFocus,
                    onMonthChange: a.props.onMonthChange,
                    onYearChange: a.props.onYearChange,
                    dayClassName: a.props.dayClassName,
                    weekDayClassName: a.props.weekDayClassName,
                    monthClassName: a.props.monthClassName,
                    timeClassName: a.props.timeClassName,
                    showTimeSelect: a.props.showTimeSelect,
                    showTimeSelectOnly: a.props.showTimeSelectOnly,
                    onTimeChange: a.handleTimeChange,
                    timeFormat: a.props.timeFormat,
                    timeIntervals: a.props.timeIntervals,
                    minTime: a.props.minTime,
                    maxTime: a.props.maxTime,
                    excludeTimes: a.props.excludeTimes,
                    filterTime: a.props.filterTime,
                    timeCaption: a.props.timeCaption,
                    className: a.props.calendarClassName,
                    container: a.props.calendarContainer,
                    yearItemNumber: a.props.yearItemNumber,
                    yearDropdownItemNumber: a.props.yearDropdownItemNumber,
                    previousMonthAriaLabel: a.props.previousMonthAriaLabel,
                    previousMonthButtonLabel: a.props.previousMonthButtonLabel,
                    nextMonthAriaLabel: a.props.nextMonthAriaLabel,
                    nextMonthButtonLabel: a.props.nextMonthButtonLabel,
                    previousYearAriaLabel: a.props.previousYearAriaLabel,
                    previousYearButtonLabel: a.props.previousYearButtonLabel,
                    nextYearAriaLabel: a.props.nextYearAriaLabel,
                    nextYearButtonLabel: a.props.nextYearButtonLabel,
                    timeInputLabel: a.props.timeInputLabel,
                    disabledKeyboardNavigation: a.props.disabledKeyboardNavigation,
                    renderCustomHeader: a.props.renderCustomHeader,
                    popperProps: a.props.popperProps,
                    renderDayContents: a.props.renderDayContents,
                    onDayMouseEnter: a.props.onDayMouseEnter,
                    onMonthMouseLeave: a.props.onMonthMouseLeave,
                    selectsDisabledDaysInRange: a.props.selectsDisabledDaysInRange,
                    showTimeInput: a.props.showTimeInput,
                    showMonthYearPicker: a.props.showMonthYearPicker,
                    showFullMonthYearPicker: a.props.showFullMonthYearPicker,
                    showTwoColumnMonthYearPicker: a.props.showTwoColumnMonthYearPicker,
                    showFourColumnMonthYearPicker: a.props.showFourColumnMonthYearPicker,
                    showYearPicker: a.props.showYearPicker,
                    showQuarterYearPicker: a.props.showQuarterYearPicker,
                    showPopperArrow: a.props.showPopperArrow,
                    excludeScrollbar: a.props.excludeScrollbar,
                    handleOnKeyDown: a.props.onKeyDown,
                    handleOnDayKeyDown: a.onDayKeyDown,
                    isInputFocused: a.state.focused,
                    customTimeInput: a.props.customTimeInput,
                    setPreSelection: a.setPreSelection
                }, a.props.children) : null;
            }), Dt(bt(a), "renderDateInput", function() {
                var e, t = ce.default(a.props.className, Dt({}, $r, a.state.open)), r = a.props.customInput || de.default.createElement("input", {
                    type: "text"
                }), n = a.props.customInputRef || "ref", o = "string" == typeof a.props.value ? a.props.value : "string" == typeof a.state.inputValue ? a.state.inputValue : a.props.selectsRange ? function(e, t, r) {
                    if (!e) return "";
                    var a = Rt(e, r), n = t ? Rt(t, r) : "";
                    return "".concat(a, " - ").concat(n);
                }(a.props.startDate, a.props.endDate, a.props) : Rt(a.props.selected, a.props);
                return de.default.cloneElement(r, (Dt(e = {}, n, function(e) {
                    a.input = e;
                }), Dt(e, "value", o), Dt(e, "onBlur", a.handleBlur), Dt(e, "onChange", a.handleChange), Dt(e, "onClick", a.onInputClick), Dt(e, "onFocus", a.handleFocus), Dt(e, "onKeyDown", a.onInputKeyDown), Dt(e, "id", a.props.id), Dt(e, "name", a.props.name), Dt(e, "autoFocus", a.props.autoFocus), Dt(e, "placeholder", a.props.placeholderText), Dt(e, "disabled", a.props.disabled), Dt(e, "autoComplete", a.props.autoComplete), Dt(e, "className", ce.default(r.props.className, t)), Dt(e, "title", a.props.title), Dt(e, "readOnly", a.props.readOnly), Dt(e, "required", a.props.required), Dt(e, "tabIndex", a.props.tabIndex), Dt(e, "aria-describedby", a.props.ariaDescribedBy), Dt(e, "aria-invalid", a.props.ariaInvalid), Dt(e, "aria-labelledby", a.props.ariaLabelledBy), Dt(e, "aria-required", a.props.ariaRequired), e));
            }), Dt(bt(a), "renderClearButton", function() {
                var e = a.props, t = e.isClearable, r = e.selected, n = e.startDate, o = e.endDate, s = e.clearButtonTitle, i = e.clearButtonClassName, p = void 0 === i ? "" : i, l = e.ariaLabelClose, d = void 0 === l ? "Close" : l;
                return !t || null == r && null == n && null == o ? null : de.default.createElement("button", {
                    type: "button",
                    className: "react-datepicker__close-icon ".concat(p).trim(),
                    "aria-label": d,
                    onClick: a.onClearClick,
                    title: s,
                    tabIndex: -1
                });
            }), a.state = a.calcInitialState(), a;
        }
        return yt(r, [
            {
                key: "componentDidMount",
                value: function() {
                    window.addEventListener("scroll", this.onScroll, !0);
                }
            },
            {
                key: "componentDidUpdate",
                value: function(e, t) {
                    var r, a;
                    e.inline && (r = e.selected, a = this.props.selected, r && a ? Oe.default(r) !== Oe.default(a) || Ie.default(r) !== Ie.default(a) : r !== a) && this.setPreSelection(this.props.selected), void 0 !== this.state.monthSelectedIn && e.monthsShown !== this.props.monthsShown && this.setState({
                        monthSelectedIn: 0
                    }), e.highlightDates !== this.props.highlightDates && this.setState({
                        highlightDates: wr(this.props.highlightDates)
                    }), t.focused || zt(e.selected, this.props.selected) || this.setState({
                        inputValue: null
                    }), t.open !== this.state.open && (!1 === t.open && !0 === this.state.open && this.props.onCalendarOpen(), !0 === t.open && !1 === this.state.open && this.props.onCalendarClose());
                }
            },
            {
                key: "componentWillUnmount",
                value: function() {
                    this.clearPreventFocusTimeout(), window.removeEventListener("scroll", this.onScroll, !0);
                }
            },
            {
                key: "renderInputContainer",
                value: function() {
                    return de.default.createElement("div", {
                        className: "react-datepicker__input-container"
                    }, this.renderDateInput(), this.renderClearButton());
                }
            },
            {
                key: "render",
                value: function() {
                    var e = this.renderCalendar();
                    if (this.props.inline) return e;
                    if (this.props.withPortal) {
                        var t = this.state.open ? de.default.createElement("div", {
                            className: "react-datepicker__portal"
                        }, e) : null;
                        return this.state.open && this.props.portalId && (t = de.default.createElement(jr, {
                            portalId: this.props.portalId,
                            portalHost: this.props.portalHost
                        }, t)), de.default.createElement("div", null, this.renderInputContainer(), t);
                    }
                    return de.default.createElement(Ur, {
                        className: this.props.popperClassName,
                        wrapperClassName: this.props.wrapperClassName,
                        hidePopper: !this.isCalendarOpen(),
                        portalId: this.props.portalId,
                        portalHost: this.props.portalHost,
                        popperModifiers: this.props.popperModifiers,
                        targetComponent: this.renderInputContainer(),
                        popperContainer: this.props.popperContainer,
                        popperComponent: e,
                        popperPlacement: this.props.popperPlacement,
                        popperProps: this.props.popperProps,
                        popperOnKeyDown: this.onPopperKeyDown,
                        enableTabLoop: this.props.enableTabLoop
                    });
                }
            }
        ], [
            {
                key: "defaultProps",
                get: function() {
                    return {
                        allowSameDay: !1,
                        dateFormat: "MM/dd/yyyy",
                        dateFormatCalendar: "LLLL yyyy",
                        onChange: function() {},
                        disabled: !1,
                        disabledKeyboardNavigation: !1,
                        dropdownMode: "scroll",
                        onFocus: function() {},
                        onBlur: function() {},
                        onKeyDown: function() {},
                        onInputClick: function() {},
                        onSelect: function() {},
                        onClickOutside: function() {},
                        onMonthChange: function() {},
                        onCalendarOpen: function() {},
                        onCalendarClose: function() {},
                        preventOpenOnFocus: !1,
                        onYearChange: function() {},
                        onInputError: function() {},
                        monthsShown: 1,
                        readOnly: !1,
                        withPortal: !1,
                        selectsDisabledDaysInRange: !1,
                        shouldCloseOnSelect: !0,
                        showTimeSelect: !1,
                        showTimeInput: !1,
                        showPreviousMonths: !1,
                        showMonthYearPicker: !1,
                        showFullMonthYearPicker: !1,
                        showTwoColumnMonthYearPicker: !1,
                        showFourColumnMonthYearPicker: !1,
                        showYearPicker: !1,
                        showQuarterYearPicker: !1,
                        strictParsing: !1,
                        timeIntervals: 30,
                        timeCaption: "Time",
                        previousMonthAriaLabel: "Previous Month",
                        previousMonthButtonLabel: "Previous Month",
                        nextMonthAriaLabel: "Next Month",
                        nextMonthButtonLabel: "Next Month",
                        previousYearAriaLabel: "Previous Year",
                        previousYearButtonLabel: "Previous Year",
                        nextYearAriaLabel: "Next Year",
                        nextYearButtonLabel: "Next Year",
                        timeInputLabel: "Time",
                        enableTabLoop: !0,
                        yearItemNumber: xt,
                        renderDayContents: function(e) {
                            return e;
                        },
                        focusSelectedMonth: !1,
                        showPopperArrow: !0,
                        excludeScrollbar: !0,
                        customTimeInput: null,
                        calendarStartDay: void 0
                    };
                }
            }
        ]), r;
    }(de.default.Component), Xr = "input", Zr = "navigate";
    e.CalendarContainer = Br, e.default = Jr, e.getDefaultLocale = Jt, e.registerLocale = function(e, t) {
        var r = "undefined" != typeof window ? window : globalThis;
        r.__localeData__ || (r.__localeData__ = {}), r.__localeData__[e] = t;
    }, e.setDefaultLocale = function(e) {
        ("undefined" != typeof window ? window : globalThis).__localeId__ = e;
    }, Object.defineProperty(e, "__esModule", {
        value: !0
    });
});

});
parcelRegister("8o58w", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $61b48c9d860cd899$export$2e2bcd8739ae039);

var $bTSG2 = parcelRequire("bTSG2");

var $4LmDH = parcelRequire("4LmDH");

var $esGEx = parcelRequire("esGEx");
function $61b48c9d860cd899$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $esGEx.default)(dirtyAmount);
    return (0, $bTSG2.default)(dirtyDate, -amount);
}

});

parcelRegister("58cSq", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $3bc7b0320eecfefe$export$2e2bcd8739ae039);

var $kehhj = parcelRequire("kehhj");

var $4LmDH = parcelRequire("4LmDH");

var $esGEx = parcelRequire("esGEx");
function $3bc7b0320eecfefe$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $4LmDH.default)(2, arguments);
    var amount = (0, $esGEx.default)(dirtyAmount);
    return (0, $kehhj.default)(dirtyDate, -amount);
}

});

parcelRegister("e4h6L", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $a3deb5b5de15b12f$export$2e2bcd8739ae039);

var $7yBDJ = parcelRequire("7yBDJ");

var $9vfYB = parcelRequire("9vfYB");

var $4LmDH = parcelRequire("4LmDH");
var $a3deb5b5de15b12f$var$MILLISECONDS_IN_WEEK = 604800000;
function $a3deb5b5de15b12f$export$2e2bcd8739ae039(dirtyDateLeft, dirtyDateRight, options) {
    (0, $4LmDH.default)(2, arguments);
    var startOfWeekLeft = (0, $7yBDJ.default)(dirtyDateLeft, options);
    var startOfWeekRight = (0, $7yBDJ.default)(dirtyDateRight, options);
    var timestampLeft = startOfWeekLeft.getTime() - (0, $9vfYB.default)(startOfWeekLeft);
    var timestampRight = startOfWeekRight.getTime() - (0, $9vfYB.default)(startOfWeekRight);
    // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round((timestampLeft - timestampRight) / $a3deb5b5de15b12f$var$MILLISECONDS_IN_WEEK);
}

});

parcelRegister("fiaok", function(module, exports) {

$parcel$export(module.exports, "Popper", () => (parcelRequire("hNFK8")).Popper);
$parcel$export(module.exports, "Manager", () => (parcelRequire("6nuyz")).Manager);
$parcel$export(module.exports, "Reference", () => (parcelRequire("3LEJn")).Reference);
$parcel$export(module.exports, "usePopper", () => (parcelRequire("3cPZo")).usePopper);
// Public components

var $hNFK8 = parcelRequire("hNFK8");

var $6nuyz = parcelRequire("6nuyz");

var $3LEJn = parcelRequire("3LEJn");

var $3cPZo = parcelRequire("3cPZo");
 // Public types

});
parcelRegister("hNFK8", function(module, exports) {

$parcel$export(module.exports, "Popper", () => $cf576490797509cd$export$badac9ada3a0bdf9);

var $acw62 = parcelRequire("acw62");

var $6nuyz = parcelRequire("6nuyz");

var $c7d03 = parcelRequire("c7d03");

var $3cPZo = parcelRequire("3cPZo");
var $cf576490797509cd$var$NOOP = function NOOP() {
    return void 0;
};
var $cf576490797509cd$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $cf576490797509cd$var$EMPTY_MODIFIERS = [];
function $cf576490797509cd$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? "bottom" : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? "absolute" : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $cf576490797509cd$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $acw62.useContext((0, $6nuyz.ManagerReferenceNodeContext));
    var _React$useState = $acw62.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $acw62.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $acw62.useEffect(function() {
        (0, $c7d03.setRef)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $acw62.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: "arrow",
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $3cPZo.usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $acw62.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $cf576490797509cd$var$NOOP,
            update: update || $cf576490797509cd$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $c7d03.unwrapArray)(children)(childrenProps);
}

});
parcelRegister("6nuyz", function(module, exports) {

$parcel$export(module.exports, "ManagerReferenceNodeContext", () => $4a4c97f30be3458e$export$3dbd3405086fec7b);
$parcel$export(module.exports, "ManagerReferenceNodeSetterContext", () => $4a4c97f30be3458e$export$cbabb21c2529b130);
$parcel$export(module.exports, "Manager", () => $4a4c97f30be3458e$export$d0d38e7dec7a1a61);

var $acw62 = parcelRequire("acw62");
var $4a4c97f30be3458e$export$3dbd3405086fec7b = $acw62.createContext();
var $4a4c97f30be3458e$export$cbabb21c2529b130 = $acw62.createContext();
function $4a4c97f30be3458e$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $acw62.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $acw62.useRef(false);
    $acw62.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $acw62.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $acw62.createElement($4a4c97f30be3458e$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $acw62.createElement($4a4c97f30be3458e$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}

});

parcelRegister("c7d03", function(module, exports) {

$parcel$export(module.exports, "unwrapArray", () => $8d203902f76c71dc$export$f52c55943429c8b6);
$parcel$export(module.exports, "safeInvoke", () => $8d203902f76c71dc$export$3dfa7c28635fe028);
$parcel$export(module.exports, "setRef", () => $8d203902f76c71dc$export$4bb192c7cacf928f);
$parcel$export(module.exports, "fromEntries", () => $8d203902f76c71dc$export$5150077fc2e7c662);
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $8d203902f76c71dc$export$700979bc83e7db82);

var $acw62 = parcelRequire("acw62");
var $8d203902f76c71dc$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $8d203902f76c71dc$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === "function") {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $8d203902f76c71dc$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === "function") return $8d203902f76c71dc$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $8d203902f76c71dc$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $8d203902f76c71dc$export$700979bc83e7db82 = typeof window !== "undefined" && window.document && window.document.createElement ? $acw62.useLayoutEffect : $acw62.useEffect;

});

parcelRegister("3cPZo", function(module, exports) {

$parcel$export(module.exports, "usePopper", () => $255ad20eeeefdc20$export$f4d5bf230a36dd6e);

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $3tUi5 = parcelRequire("3tUi5");

var $ai2Pb = parcelRequire("ai2Pb");

var $c7d03 = parcelRequire("c7d03");
var $255ad20eeeefdc20$var$EMPTY_MODIFIERS = [];
var $255ad20eeeefdc20$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $acw62.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || "bottom",
        strategy: options.strategy || "absolute",
        modifiers: options.modifiers || $255ad20eeeefdc20$var$EMPTY_MODIFIERS
    };
    var _React$useState = $acw62.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: "0",
                top: "0"
            },
            arrow: {
                position: "absolute"
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $acw62.useMemo(function() {
        return {
            name: "updateState",
            enabled: true,
            phase: "write",
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $1u0KT.flushSync(function() {
                    setState({
                        styles: (0, $c7d03.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $c7d03.fromEntries)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                "computeStyles"
            ]
        };
    }, []);
    var popperOptions = $acw62.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: "applyStyles",
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $acw62.useRef();
    (0, $c7d03.useIsomorphicLayoutEffect)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $c7d03.useIsomorphicLayoutEffect)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $3tUi5.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};

});


parcelRegister("3LEJn", function(module, exports) {

$parcel$export(module.exports, "Reference", () => $2be55b3592e1c225$export$e0be378c32fb70a7);

var $acw62 = parcelRequire("acw62");

var $kg9aN = parcelRequire("kg9aN");

var $6nuyz = parcelRequire("6nuyz");

var $c7d03 = parcelRequire("c7d03");
function $2be55b3592e1c225$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $acw62.useContext((0, $6nuyz.ManagerReferenceNodeSetterContext));
    var refHandler = $acw62.useCallback(function(node) {
        (0, $c7d03.setRef)(innerRef, node);
        (0, $c7d03.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $acw62.useEffect(function() {
        return function() {
            return (0, $c7d03.setRef)(innerRef, null);
        };
    }, []);
    $acw62.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($kg9aN)))(Boolean(setReferenceNode), "`Reference` should not be used outside of a `Manager` component.");
    }, [
        setReferenceNode
    ]);
    return (0, $c7d03.unwrapArray)(children)({
        ref: refHandler
    });
}

});



parcelRegister("92FXn", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $6954d8ad362058f2$export$1e511d4a378977f5, (v) => $6954d8ad362058f2$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "default", () => $6954d8ad362058f2$export$2e2bcd8739ae039, (v) => $6954d8ad362058f2$export$2e2bcd8739ae039 = v);
var $6954d8ad362058f2$export$1e511d4a378977f5;
var $6954d8ad362058f2$export$2e2bcd8739ae039;
"use strict";

var $1jnue = parcelRequire("1jnue");
$6954d8ad362058f2$export$1e511d4a378977f5 = true;
$6954d8ad362058f2$export$2e2bcd8739ae039 = void 0;

var $6954d8ad362058f2$var$_inheritsLoose2 = $1jnue((parcelRequire("6r4zt")));

var $6954d8ad362058f2$var$_react = $1jnue((parcelRequire("acw62")));

var $6954d8ad362058f2$var$_reactDom = $1jnue((parcelRequire("1u0KT")));

var $6954d8ad362058f2$var$_propTypes = $1jnue((parcelRequire("c9Z8w")));

var $4C0sy = parcelRequire("4C0sy");
var $6954d8ad362058f2$var$propTypes = {
    children: $6954d8ad362058f2$var$_propTypes.default.node.isRequired,
    node: $6954d8ad362058f2$var$_propTypes.default.any
};
var $6954d8ad362058f2$var$Portal = /*#__PURE__*/ function(_React$Component) {
    (0, $6954d8ad362058f2$var$_inheritsLoose2.default)(Portal, _React$Component);
    function Portal() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = Portal.prototype;
    _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.defaultNode) document.body.removeChild(this.defaultNode);
        this.defaultNode = null;
    };
    _proto.render = function render() {
        if (!$4C0sy.canUseDOM) return null;
        if (!this.props.node && !this.defaultNode) {
            this.defaultNode = document.createElement("div");
            document.body.appendChild(this.defaultNode);
        }
        return /*#__PURE__*/ $6954d8ad362058f2$var$_reactDom.default.createPortal(this.props.children, this.props.node || this.defaultNode);
    };
    return Portal;
}($6954d8ad362058f2$var$_react.default.Component);
$6954d8ad362058f2$var$Portal.propTypes = $6954d8ad362058f2$var$propTypes;
var $6954d8ad362058f2$var$_default = $6954d8ad362058f2$var$Portal;
$6954d8ad362058f2$export$2e2bcd8739ae039 = $6954d8ad362058f2$var$_default;

});
parcelRegister("4C0sy", function(module, exports) {

$parcel$export(module.exports, "canUseDOM", () => $35bb1146799c5edf$export$71594e8a50f746f4, (v) => $35bb1146799c5edf$export$71594e8a50f746f4 = v);
var $35bb1146799c5edf$export$1e511d4a378977f5;
var $35bb1146799c5edf$export$ace028f8da1a6300;
var $35bb1146799c5edf$export$525633cdbd0969b;
var $35bb1146799c5edf$export$31b5c8f1131a3a52;
var $35bb1146799c5edf$export$f6a6870365e84923;
var $35bb1146799c5edf$export$999f192bbd2b2d9e;
var $35bb1146799c5edf$export$e66f39a23d6009b0;
var $35bb1146799c5edf$export$30a9f098026c5d15;
var $35bb1146799c5edf$export$30a06c8d3562193f;
var $35bb1146799c5edf$export$357523c63a2253b9;
var $35bb1146799c5edf$export$5b28268982f175ba;
var $35bb1146799c5edf$export$cdd73fc4100a6ef4;
var $35bb1146799c5edf$export$97d587dc2049b818;
var $35bb1146799c5edf$export$e10d8bcaa14e0681;
var $35bb1146799c5edf$export$a0a81dc3380ce7d3;
var $35bb1146799c5edf$export$a6cdc56e425d0d0a;
var $35bb1146799c5edf$export$f6e2535fb5126e54;
var $35bb1146799c5edf$export$296b302fe9d56784;
var $35bb1146799c5edf$export$3aa3c75b371c352f;
var $35bb1146799c5edf$export$c22522a4dfa48e9c;
var $35bb1146799c5edf$export$544835a2f8292483;
var $35bb1146799c5edf$export$e2690578cac908dd;
var $35bb1146799c5edf$export$6723c67dee1450cf;
var $35bb1146799c5edf$export$71594e8a50f746f4;
var $35bb1146799c5edf$export$b8db120174e0a6fa;
var $35bb1146799c5edf$export$6d3e562ac77a9517;
var $35bb1146799c5edf$export$9f15c0603df35428;
var $35bb1146799c5edf$export$33d93b05441a6936;
var $35bb1146799c5edf$export$b725afd3e8acce35;
var $35bb1146799c5edf$export$ba0f6daf9558be46;
var $35bb1146799c5edf$export$41ef22d2f70c9575;
"use strict";

var $1jnue = parcelRequire("1jnue");
$35bb1146799c5edf$export$1e511d4a378977f5 = true;
$35bb1146799c5edf$export$ace028f8da1a6300 = $35bb1146799c5edf$var$getScrollbarWidth;
$35bb1146799c5edf$export$525633cdbd0969b = $35bb1146799c5edf$var$setScrollbarWidth;
$35bb1146799c5edf$export$31b5c8f1131a3a52 = $35bb1146799c5edf$var$isBodyOverflowing;
$35bb1146799c5edf$export$f6a6870365e84923 = $35bb1146799c5edf$var$getOriginalBodyPadding;
$35bb1146799c5edf$export$999f192bbd2b2d9e = $35bb1146799c5edf$var$conditionallyUpdateScrollbar;
$35bb1146799c5edf$export$e66f39a23d6009b0 = $35bb1146799c5edf$var$setGlobalCssModule;
$35bb1146799c5edf$export$30a9f098026c5d15 = $35bb1146799c5edf$var$mapToCssModules;
$35bb1146799c5edf$export$30a06c8d3562193f = $35bb1146799c5edf$var$omit;
$35bb1146799c5edf$export$357523c63a2253b9 = $35bb1146799c5edf$var$pick;
$35bb1146799c5edf$export$5b28268982f175ba = $35bb1146799c5edf$var$warnOnce;
$35bb1146799c5edf$export$cdd73fc4100a6ef4 = $35bb1146799c5edf$var$deprecated;
$35bb1146799c5edf$export$97d587dc2049b818 = $35bb1146799c5edf$var$DOMElement;
$35bb1146799c5edf$export$e10d8bcaa14e0681 = $35bb1146799c5edf$var$isReactRefObj;
$35bb1146799c5edf$export$a0a81dc3380ce7d3 = $35bb1146799c5edf$var$toNumber;
$35bb1146799c5edf$export$a6cdc56e425d0d0a = $35bb1146799c5edf$var$isObject;
$35bb1146799c5edf$export$f6e2535fb5126e54 = $35bb1146799c5edf$var$isFunction;
$35bb1146799c5edf$export$296b302fe9d56784 = $35bb1146799c5edf$var$findDOMElements;
$35bb1146799c5edf$export$3aa3c75b371c352f = $35bb1146799c5edf$var$isArrayOrNodeList;
$35bb1146799c5edf$export$c22522a4dfa48e9c = $35bb1146799c5edf$var$getTarget;
$35bb1146799c5edf$export$544835a2f8292483 = $35bb1146799c5edf$var$addMultipleEventListeners;
$35bb1146799c5edf$export$e2690578cac908dd = $35bb1146799c5edf$export$6723c67dee1450cf = $35bb1146799c5edf$export$71594e8a50f746f4 = $35bb1146799c5edf$export$b8db120174e0a6fa = $35bb1146799c5edf$export$6d3e562ac77a9517 = $35bb1146799c5edf$export$9f15c0603df35428 = $35bb1146799c5edf$export$33d93b05441a6936 = $35bb1146799c5edf$export$b725afd3e8acce35 = $35bb1146799c5edf$export$ba0f6daf9558be46 = $35bb1146799c5edf$export$41ef22d2f70c9575 = void 0;

var $35bb1146799c5edf$var$_propTypes = $1jnue((parcelRequire("c9Z8w")));
// https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/js/src/modal.js#L436-L443
function $35bb1146799c5edf$var$getScrollbarWidth() {
    var scrollDiv = document.createElement("div"); // .modal-scrollbar-measure styles // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/scss/_modal.scss#L106-L113
    scrollDiv.style.position = "absolute";
    scrollDiv.style.top = "-9999px";
    scrollDiv.style.width = "50px";
    scrollDiv.style.height = "50px";
    scrollDiv.style.overflow = "scroll";
    document.body.appendChild(scrollDiv);
    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollbarWidth;
}
function $35bb1146799c5edf$var$setScrollbarWidth(padding) {
    document.body.style.paddingRight = padding > 0 ? padding + "px" : null;
}
function $35bb1146799c5edf$var$isBodyOverflowing() {
    return document.body.clientWidth < window.innerWidth;
}
function $35bb1146799c5edf$var$getOriginalBodyPadding() {
    var style = window.getComputedStyle(document.body, null);
    return parseInt(style && style.getPropertyValue("padding-right") || 0, 10);
}
function $35bb1146799c5edf$var$conditionallyUpdateScrollbar() {
    var scrollbarWidth = $35bb1146799c5edf$var$getScrollbarWidth(); // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.6/js/src/modal.js#L433
    var fixedContent = document.querySelectorAll(".fixed-top, .fixed-bottom, .is-fixed, .sticky-top")[0];
    var bodyPadding = fixedContent ? parseInt(fixedContent.style.paddingRight || 0, 10) : 0;
    if ($35bb1146799c5edf$var$isBodyOverflowing()) $35bb1146799c5edf$var$setScrollbarWidth(bodyPadding + scrollbarWidth);
}
var $35bb1146799c5edf$var$globalCssModule;
function $35bb1146799c5edf$var$setGlobalCssModule(cssModule) {
    $35bb1146799c5edf$var$globalCssModule = cssModule;
}
function $35bb1146799c5edf$var$mapToCssModules(className, cssModule) {
    if (className === void 0) className = "";
    if (cssModule === void 0) cssModule = $35bb1146799c5edf$var$globalCssModule;
    if (!cssModule) return className;
    return className.split(" ").map(function(c) {
        return cssModule[c] || c;
    }).join(" ");
}
/**
 * Returns a new object with the key/value pairs from `obj` that are not in the array `omitKeys`.
 */ function $35bb1146799c5edf$var$omit(obj, omitKeys) {
    var result = {};
    Object.keys(obj).forEach(function(key) {
        if (omitKeys.indexOf(key) === -1) result[key] = obj[key];
    });
    return result;
}
/**
 * Returns a filtered copy of an object with only the specified keys.
 */ function $35bb1146799c5edf$var$pick(obj, keys) {
    var pickKeys = Array.isArray(keys) ? keys : [
        keys
    ];
    var length = pickKeys.length;
    var key;
    var result = {};
    while(length > 0){
        length -= 1;
        key = pickKeys[length];
        result[key] = obj[key];
    }
    return result;
}
var $35bb1146799c5edf$var$warned = {};
function $35bb1146799c5edf$var$warnOnce(message) {
    if (!$35bb1146799c5edf$var$warned[message]) {
        /* istanbul ignore else */ if (typeof console !== "undefined") console.error(message); // eslint-disable-line no-console
        $35bb1146799c5edf$var$warned[message] = true;
    }
}
function $35bb1146799c5edf$var$deprecated(propType, explanation) {
    return function validate(props, propName, componentName) {
        if (props[propName] !== null && typeof props[propName] !== "undefined") $35bb1146799c5edf$var$warnOnce('"' + propName + '" property of "' + componentName + '" has been deprecated.\n' + explanation);
        for(var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)rest[_key - 3] = arguments[_key];
        return propType.apply(void 0, [
            props,
            propName,
            componentName
        ].concat(rest));
    };
} // Shim Element if needed (e.g. in Node environment)
var $35bb1146799c5edf$var$Element = typeof window === "object" && window.Element || function() {};
function $35bb1146799c5edf$var$DOMElement(props, propName, componentName) {
    if (!(props[propName] instanceof $35bb1146799c5edf$var$Element)) return new Error("Invalid prop `" + propName + "` supplied to `" + componentName + "`. Expected prop to be an instance of Element. Validation failed.");
}
var $35bb1146799c5edf$var$targetPropType = $35bb1146799c5edf$var$_propTypes.default.oneOfType([
    $35bb1146799c5edf$var$_propTypes.default.string,
    $35bb1146799c5edf$var$_propTypes.default.func,
    $35bb1146799c5edf$var$DOMElement,
    $35bb1146799c5edf$var$_propTypes.default.shape({
        current: $35bb1146799c5edf$var$_propTypes.default.any
    })
]);
$35bb1146799c5edf$export$41ef22d2f70c9575 = $35bb1146799c5edf$var$targetPropType;
var $35bb1146799c5edf$var$tagPropType = $35bb1146799c5edf$var$_propTypes.default.oneOfType([
    $35bb1146799c5edf$var$_propTypes.default.func,
    $35bb1146799c5edf$var$_propTypes.default.string,
    $35bb1146799c5edf$var$_propTypes.default.shape({
        $$typeof: $35bb1146799c5edf$var$_propTypes.default.symbol,
        render: $35bb1146799c5edf$var$_propTypes.default.func
    }),
    $35bb1146799c5edf$var$_propTypes.default.arrayOf($35bb1146799c5edf$var$_propTypes.default.oneOfType([
        $35bb1146799c5edf$var$_propTypes.default.func,
        $35bb1146799c5edf$var$_propTypes.default.string,
        $35bb1146799c5edf$var$_propTypes.default.shape({
            $$typeof: $35bb1146799c5edf$var$_propTypes.default.symbol,
            render: $35bb1146799c5edf$var$_propTypes.default.func
        })
    ]))
]);
/* eslint key-spacing: ["error", { afterColon: true, align: "value" }] */ // These are all setup to match what is in the bootstrap _variables.scss
// https://github.com/twbs/bootstrap/blob/v4-dev/scss/_variables.scss
$35bb1146799c5edf$export$ba0f6daf9558be46 = $35bb1146799c5edf$var$tagPropType;
var $35bb1146799c5edf$var$TransitionTimeouts = {
    Fade: 150,
    // $transition-fade
    Collapse: 350,
    // $transition-collapse
    Modal: 300,
    // $modal-transition
    Carousel: 600 // $carousel-transition
}; // Duplicated Transition.propType keys to ensure that Reactstrap builds
// for distribution properly exclude these keys for nested child HTML attributes
// since `react-transition-group` removes propTypes in production builds.
$35bb1146799c5edf$export$b725afd3e8acce35 = $35bb1146799c5edf$var$TransitionTimeouts;
var $35bb1146799c5edf$var$TransitionPropTypeKeys = [
    "in",
    "mountOnEnter",
    "unmountOnExit",
    "appear",
    "enter",
    "exit",
    "timeout",
    "onEnter",
    "onEntering",
    "onEntered",
    "onExit",
    "onExiting",
    "onExited"
];
$35bb1146799c5edf$export$33d93b05441a6936 = $35bb1146799c5edf$var$TransitionPropTypeKeys;
var $35bb1146799c5edf$var$TransitionStatuses = {
    ENTERING: "entering",
    ENTERED: "entered",
    EXITING: "exiting",
    EXITED: "exited"
};
$35bb1146799c5edf$export$9f15c0603df35428 = $35bb1146799c5edf$var$TransitionStatuses;
var $35bb1146799c5edf$var$keyCodes = {
    esc: 27,
    space: 32,
    enter: 13,
    tab: 9,
    up: 38,
    down: 40,
    home: 36,
    end: 35,
    n: 78,
    p: 80
};
$35bb1146799c5edf$export$6d3e562ac77a9517 = $35bb1146799c5edf$var$keyCodes;
var $35bb1146799c5edf$var$PopperPlacements = [
    "auto-start",
    "auto",
    "auto-end",
    "top-start",
    "top",
    "top-end",
    "right-start",
    "right",
    "right-end",
    "bottom-end",
    "bottom",
    "bottom-start",
    "left-end",
    "left",
    "left-start"
];
$35bb1146799c5edf$export$b8db120174e0a6fa = $35bb1146799c5edf$var$PopperPlacements;
var $35bb1146799c5edf$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
$35bb1146799c5edf$export$71594e8a50f746f4 = $35bb1146799c5edf$var$canUseDOM;
function $35bb1146799c5edf$var$isReactRefObj(target) {
    if (target && typeof target === "object") return "current" in target;
    return false;
}
function $35bb1146799c5edf$var$getTag(value) {
    if (value == null) return value === undefined ? "[object Undefined]" : "[object Null]";
    return Object.prototype.toString.call(value);
}
function $35bb1146799c5edf$var$toNumber(value) {
    var type = typeof value;
    var NAN = 0 / 0;
    if (type === "number") return value;
    if (type === "symbol" || type === "object" && $35bb1146799c5edf$var$getTag(value) === "[object Symbol]") return NAN;
    if ($35bb1146799c5edf$var$isObject(value)) {
        var other = typeof value.valueOf === "function" ? value.valueOf() : value;
        value = $35bb1146799c5edf$var$isObject(other) ? "" + other : other;
    }
    if (type !== "string") return value === 0 ? value : +value;
    value = value.replace(/^\s+|\s+$/g, "");
    var isBinary = /^0b[01]+$/i.test(value);
    return isBinary || /^0o[0-7]+$/i.test(value) ? parseInt(value.slice(2), isBinary ? 2 : 8) : /^[-+]0x[0-9a-f]+$/i.test(value) ? NAN : +value;
}
function $35bb1146799c5edf$var$isObject(value) {
    var type = typeof value;
    return value != null && (type === "object" || type === "function");
}
function $35bb1146799c5edf$var$isFunction(value) {
    if (!$35bb1146799c5edf$var$isObject(value)) return false;
    var tag = $35bb1146799c5edf$var$getTag(value);
    return tag === "[object Function]" || tag === "[object AsyncFunction]" || tag === "[object GeneratorFunction]" || tag === "[object Proxy]";
}
function $35bb1146799c5edf$var$findDOMElements(target) {
    if ($35bb1146799c5edf$var$isReactRefObj(target)) return target.current;
    if ($35bb1146799c5edf$var$isFunction(target)) return target();
    if (typeof target === "string" && $35bb1146799c5edf$var$canUseDOM) {
        var selection = document.querySelectorAll(target);
        if (!selection.length) selection = document.querySelectorAll("#" + target);
        if (!selection.length) throw new Error("The target '" + target + "' could not be identified in the dom, tip: check spelling");
        return selection;
    }
    return target;
}
function $35bb1146799c5edf$var$isArrayOrNodeList(els) {
    if (els === null) return false;
    return Array.isArray(els) || $35bb1146799c5edf$var$canUseDOM && typeof els.length === "number";
}
function $35bb1146799c5edf$var$getTarget(target, allElements) {
    var els = $35bb1146799c5edf$var$findDOMElements(target);
    if (allElements) {
        if ($35bb1146799c5edf$var$isArrayOrNodeList(els)) return els;
        if (els === null) return [];
        return [
            els
        ];
    } else {
        if ($35bb1146799c5edf$var$isArrayOrNodeList(els)) return els[0];
        return els;
    }
}
var $35bb1146799c5edf$var$defaultToggleEvents = [
    "touchstart",
    "click"
];
$35bb1146799c5edf$export$6723c67dee1450cf = $35bb1146799c5edf$var$defaultToggleEvents;
function $35bb1146799c5edf$var$addMultipleEventListeners(_els, handler, _events, useCapture) {
    var els = _els;
    if (!$35bb1146799c5edf$var$isArrayOrNodeList(els)) els = [
        els
    ];
    var events = _events;
    if (typeof events === "string") events = events.split(/\s+/);
    if (!$35bb1146799c5edf$var$isArrayOrNodeList(els) || typeof handler !== "function" || !Array.isArray(events)) throw new Error("\n      The first argument of this function must be DOM node or an array on DOM nodes or NodeList.\n      The second must be a function.\n      The third is a string or an array of strings that represents DOM events\n    ");
    Array.prototype.forEach.call(events, function(event) {
        Array.prototype.forEach.call(els, function(el) {
            el.addEventListener(event, handler, useCapture);
        });
    });
    return function removeEvents() {
        Array.prototype.forEach.call(events, function(event) {
            Array.prototype.forEach.call(els, function(el) {
                el.removeEventListener(event, handler, useCapture);
            });
        });
    };
}
var $35bb1146799c5edf$var$focusableElements = [
    "a[href]",
    "area[href]",
    "input:not([disabled]):not([type=hidden])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "button:not([disabled])",
    "object",
    "embed",
    "[tabindex]:not(.modal)",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])'
];
$35bb1146799c5edf$export$e2690578cac908dd = $35bb1146799c5edf$var$focusableElements;

});





parcelRegister("87zV1", function(module, exports) {

$parcel$export(module.exports, "InputGroup", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("6Twau")))));

var $6Twau = parcelRequire("6Twau");

});
parcelRegister("6Twau", function(module, exports) {
"use strict";
var $5050d512e34d4392$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $5050d512e34d4392$var$react_1 = $5050d512e34d4392$var$__importDefault((parcelRequire("acw62")));

var $5osDW = parcelRequire("5osDW");
var $9293H = parcelRequire("9293H");
var $dXrhI = parcelRequire("dXrhI");
const $5050d512e34d4392$var$InputGroup = (props)=>{
    const { dataLwtId: dataLwtId, prependAddonProps: prependAddonProps, appendAddonProps: appendAddonProps, children: children, className: className, ...restProps } = props;
    const renderInputGroupAddon = (addonProps, index, type)=>{
        return $5050d512e34d4392$var$react_1.default.createElement($9293H.default, {
            "data-lwt-id": `${dataLwtId}-${type}-${index}`,
            className: addonProps.className,
            ...addonProps,
            addonType: type
        }, addonProps.children, addonProps.textProps && $5050d512e34d4392$var$react_1.default.createElement($dXrhI.default, {
            "data-lwt-id": `${dataLwtId}-${type}-${index}-text`,
            ...addonProps.textProps
        }));
    };
    return $5050d512e34d4392$var$react_1.default.createElement($5osDW.default, {
        "data-lwt-id": dataLwtId,
        className: className,
        ...restProps
    }, prependAddonProps && prependAddonProps.map((addonProps, index)=>renderInputGroupAddon(addonProps, index, "prepend")), children, appendAddonProps && appendAddonProps.map((addonProps, index)=>renderInputGroupAddon(addonProps, index, "append")));
};
$5050d512e34d4392$var$InputGroup.defaultProps = {
    size: "sm"
};
module.exports.default = $5050d512e34d4392$var$InputGroup;

});
parcelRegister("5osDW", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ed56997db1327c3$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $e9hDx = parcelRequire("e9hDx");
var $3ed56997db1327c3$var$propTypes = {
    tag: (0, $e9hDx.tagPropType),
    size: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $3ed56997db1327c3$var$defaultProps = {
    tag: "div"
};
var $3ed56997db1327c3$var$InputGroup = function InputGroup(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, size = props.size, attributes = (0, $1En50.default)(props, [
        "className",
        "cssModule",
        "tag",
        "size"
    ]);
    var classes = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, "input-group", size ? "input-group-" + size : null), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({}, attributes, {
        className: classes
    }));
};
$3ed56997db1327c3$var$InputGroup.propTypes = $3ed56997db1327c3$var$propTypes;
$3ed56997db1327c3$var$InputGroup.defaultProps = $3ed56997db1327c3$var$defaultProps;
var $3ed56997db1327c3$export$2e2bcd8739ae039 = $3ed56997db1327c3$var$InputGroup;

});

parcelRegister("9293H", function(module, exports) {

$parcel$export(module.exports, "default", () => $693b53d2f30ef480$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $e9hDx = parcelRequire("e9hDx");

var $dXrhI = parcelRequire("dXrhI");
var $693b53d2f30ef480$var$propTypes = {
    tag: (0, $e9hDx.tagPropType),
    addonType: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "prepend",
        "append"
    ]).isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $693b53d2f30ef480$var$defaultProps = {
    tag: "div"
};
var $693b53d2f30ef480$var$InputGroupAddon = function InputGroupAddon(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, addonType = props.addonType, children = props.children, attributes = (0, $1En50.default)(props, [
        "className",
        "cssModule",
        "tag",
        "addonType",
        "children"
    ]);
    var classes = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, "input-group-" + addonType), cssModule); // Convenience to assist with transition
    if (typeof children === "string") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({}, attributes, {
        className: classes
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $dXrhI.default), {
        children: children
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({}, attributes, {
        className: classes,
        children: children
    }));
};
$693b53d2f30ef480$var$InputGroupAddon.propTypes = $693b53d2f30ef480$var$propTypes;
$693b53d2f30ef480$var$InputGroupAddon.defaultProps = $693b53d2f30ef480$var$defaultProps;
var $693b53d2f30ef480$export$2e2bcd8739ae039 = $693b53d2f30ef480$var$InputGroupAddon;

});
parcelRegister("dXrhI", function(module, exports) {

$parcel$export(module.exports, "default", () => $a295f33d41c01e30$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $e9hDx = parcelRequire("e9hDx");
var $a295f33d41c01e30$var$propTypes = {
    tag: (0, $e9hDx.tagPropType),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $a295f33d41c01e30$var$defaultProps = {
    tag: "span"
};
var $a295f33d41c01e30$var$InputGroupText = function InputGroupText(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, attributes = (0, $1En50.default)(props, [
        "className",
        "cssModule",
        "tag"
    ]);
    var classes = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, "input-group-text"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({}, attributes, {
        className: classes
    }));
};
$a295f33d41c01e30$var$InputGroupText.propTypes = $a295f33d41c01e30$var$propTypes;
$a295f33d41c01e30$var$InputGroupText.defaultProps = $a295f33d41c01e30$var$defaultProps;
var $a295f33d41c01e30$export$2e2bcd8739ae039 = $a295f33d41c01e30$var$InputGroupText;

});




parcelRegister("4TPr9", function(module, exports) {

$parcel$export(module.exports, "default", () => $391432c4ae814251$export$2e2bcd8739ae039);

var $7SAuG = parcelRequire("7SAuG");

var $gRzd0 = parcelRequire("gRzd0");
var $391432c4ae814251$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($7SAuG)));

});
parcelRegister("7SAuG", function(module, exports) {
"use strict";
var $5bc9e27e557137bc$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5bc9e27e557137bc$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $5bc9e27e557137bc$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5bc9e27e557137bc$var$__createBinding(result, mod, k);
    }
    $5bc9e27e557137bc$var$__setModuleDefault(result, mod);
    return result;
};
var $5bc9e27e557137bc$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

/* eslint-disable react/prop-types */ const $5bc9e27e557137bc$var$react_1 = $5bc9e27e557137bc$var$__importDefault((parcelRequire("acw62")));

const $5bc9e27e557137bc$var$react_select_1 = $5bc9e27e557137bc$var$__importStar((parcelRequire("a21V2")));

const $5bc9e27e557137bc$var$creatable_1 = $5bc9e27e557137bc$var$__importDefault((parcelRequire("fcvsF")));
const $5bc9e27e557137bc$var$Select = $5bc9e27e557137bc$var$react_1.default.forwardRef((props, ref)=>{
    const { dataLwtId: dataLwtId, isCreatable: isCreatable = false, styles: styles, matchFrom: matchFrom = "any", closeMenuOnSelect: closeMenuOnSelect = true, hideSelectedOptions: hideSelectedOptions = false, isClearable: isClearable = true, isDisabled: isDisabled = false, isLoading: isLoading = false, isMulti: isMulti = false, isSearchable: isSearchable = true, components: components, className: className, size: size = "md", onlySearchLabel: onlySearchLabel, ...restProps } = props;
    const selectProps = {
        closeMenuOnSelect: closeMenuOnSelect,
        hideSelectedOptions: hideSelectedOptions,
        isClearable: isClearable,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isMulti: isMulti,
        isSearchable: isSearchable,
        ...restProps
    };
    const customStyles = styles || {
        control: (base, state)=>({
                ...base,
                color: state.isFocused ? "#495057" : base.color,
                backgroundColor: state.isFocused ? "#fff" : base.backgroundColor,
                borderColor: state.isFocused ? "#5dbaed" : base.borderColor,
                outline: state.isFocused ? 0 : base.outline,
                boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(20, 125, 183, 0.25)" : base.boxShadow,
                "&:hover": {
                    borderColor: state.isFocused ? "#5dbaed" : base.borderColor
                },
                alignItems: "flex-start"
            }),
        valueContainer: (base)=>({
                ...base,
                padding: "5px 6px 4px 6px"
            })
    };
    const filterOptions = ()=>{
        const filterOptions = {
            matchFrom: matchFrom
        };
        if (onlySearchLabel) filterOptions.stringify = (option)=>`${option.label}`;
        return {
            filterOption: (0, $5bc9e27e557137bc$var$react_select_1.createFilter)(filterOptions)
        };
    };
    const IndicatorSeparator = ()=>{
        return null;
    };
    const DropdownIndicator = (props)=>{
        return $5bc9e27e557137bc$var$react_1.default.createElement($5bc9e27e557137bc$var$react_select_1.components.DropdownIndicator, {
            ...props
        }, $5bc9e27e557137bc$var$react_1.default.createElement("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, $5bc9e27e557137bc$var$react_1.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            // eslint-disable-next-line max-len
            d: "M5.46967 7.46967C5.76256 7.17678 6.23744 7.17678 6.53033 7.46967L10 10.9393L13.4697 7.46967C13.7626 7.17678 14.2374 7.17678 14.5303 7.46967C14.8232 7.76256 14.8232 8.23744 14.5303 8.53033L10.5303 12.5303C10.3897 12.671 10.1989 12.75 10 12.75C9.80109 12.75 9.61032 12.671 9.46967 12.5303L5.46967 8.53033C5.17678 8.23744 5.17678 7.76256 5.46967 7.46967Z",
            fill: "#4B5563"
        })));
    };
    const ClearIndicator = (props)=>{
        return $5bc9e27e557137bc$var$react_1.default.createElement($5bc9e27e557137bc$var$react_select_1.components.ClearIndicator, {
            ...props
        }, $5bc9e27e557137bc$var$react_1.default.createElement("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, $5bc9e27e557137bc$var$react_1.default.createElement("path", {
            d: "M5 5L10 10M10 10L15 15M10 10L5 15M10 10L15 5",
            stroke: "#4B5563",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })));
    };
    const MultiValueRemove = (props)=>{
        return $5bc9e27e557137bc$var$react_1.default.createElement($5bc9e27e557137bc$var$react_select_1.components.MultiValueRemove, {
            ...props
        }, $5bc9e27e557137bc$var$react_1.default.createElement("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, $5bc9e27e557137bc$var$react_1.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            // eslint-disable-next-line max-len
            d: "M10 16C13.3137 16 16 13.3137 16 10C16 6.68629 13.3137 4 10 4C6.68629 4 4 6.68629 4 10C4 13.3137 6.68629 16 10 16ZM8.54881 7.47082C8.25656 7.17729 7.78168 7.17626 7.48815 7.46852C7.19463 7.76078 7.19359 8.23565 7.48585 8.52918L8.94164 9.9913L7.46852 11.4708C7.17626 11.7644 7.17729 12.2392 7.47082 12.5315C7.76435 12.8237 8.23922 12.8227 8.53148 12.5292L10 11.0543L11.4685 12.5292C11.7608 12.8227 12.2356 12.8237 12.5292 12.5315C12.8227 12.2392 12.8237 11.7644 12.5315 11.4708L11.0584 9.9913L12.5141 8.52918C12.8064 8.23565 12.8054 7.76078 12.5118 7.46852C12.2183 7.17626 11.7434 7.17729 11.4512 7.47082L10 8.92833L8.54881 7.47082Z",
            fill: "#6B7280"
        })));
    };
    const SelectIndicators = (props)=>{
        return $5bc9e27e557137bc$var$react_1.default.createElement($5bc9e27e557137bc$var$react_select_1.components.IndicatorsContainer, {
            ...props,
            getStyles: ()=>({
                    alignItems: "flex-start",
                    display: "flex"
                })
        });
    };
    const CustomOption = (props)=>$5bc9e27e557137bc$var$react_1.default.createElement($5bc9e27e557137bc$var$react_select_1.components.Option, {
            ...props
        }, $5bc9e27e557137bc$var$react_1.default.createElement("div", {
            className: "helix-select__option-inner"
        }, $5bc9e27e557137bc$var$react_1.default.createElement("div", {
            className: "helix-select__option-label",
            ...props
        }), props.isSelected && $5bc9e27e557137bc$var$react_1.default.createElement("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, $5bc9e27e557137bc$var$react_1.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            // eslint-disable-next-line max-len
            d: "M15.9962 4.93763C16.3068 5.21168 16.3364 5.68563 16.0624 5.99623L8.56238 14.4962C8.4254 14.6515 8.23034 14.7432 8.0234 14.7496C7.81647 14.7561 7.61607 14.6767 7.46967 14.5303L3.96967 11.0303C3.67678 10.7374 3.67678 10.2626 3.96967 9.96968C4.26256 9.67679 4.73744 9.67679 5.03033 9.96968L7.96582 12.9052L14.9376 5.00379C15.2117 4.6932 15.6856 4.66358 15.9962 4.93763Z",
            fill: "#6B7280"
        }))));
    const replacedComponents = {
        IndicatorSeparator: IndicatorSeparator,
        DropdownIndicator: DropdownIndicator,
        ClearIndicator: ClearIndicator,
        MultiValueRemove: MultiValueRemove,
        Option: CustomOption,
        IndicatorsContainer: SelectIndicators,
        ...components
    };
    const sizeClass = ()=>{
        switch(size){
            case "sm":
                return "helix-select--sm";
            case "lg":
                return "helix-select--lg";
            default:
                return "";
        }
    };
    const classNames = `helix-select__wrapper ${sizeClass()} ${className ? className : ""}`;
    const select = isCreatable ? $5bc9e27e557137bc$var$react_1.default.createElement($5bc9e27e557137bc$var$creatable_1.default, {
        styles: customStyles,
        ...filterOptions(),
        classNamePrefix: "helix-select",
        components: replacedComponents,
        ref: ref,
        ...selectProps
    }) : $5bc9e27e557137bc$var$react_1.default.createElement($5bc9e27e557137bc$var$react_select_1.default, {
        styles: customStyles,
        ...filterOptions(),
        classNamePrefix: "helix-select",
        components: replacedComponents,
        ref: ref,
        ...selectProps
    });
    return $5bc9e27e557137bc$var$react_1.default.createElement("div", {
        "data-lwt-id": dataLwtId,
        className: classNames.trimEnd()
    }, select);
});
$5bc9e27e557137bc$var$Select.displayName = "Select";
module.exports.default = $5bc9e27e557137bc$var$Select;

});
parcelRegister("a21V2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "NonceProvider", () => $74db94543ef6f28d$export$a7deb1594c5ce10e);
$parcel$export(module.exports, "default", () => $74db94543ef6f28d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "components", () => (parcelRequire("32kym")).F);
$parcel$export(module.exports, "createFilter", () => (parcelRequire("bUCRB")).c);
$parcel$export(module.exports, "defaultTheme", () => (parcelRequire("bUCRB")).a);
$parcel$export(module.exports, "mergeStyles", () => (parcelRequire("bUCRB")).m);
parcelRequire("gZU1N");
parcelRequire("3p9rK");
parcelRequire("02Ztr");
parcelRequire("fUHKi");
parcelRequire("g5Zhu");

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");
parcelRequire("6zC7B");

var $1gYAD = parcelRequire("1gYAD");

var $9715X = parcelRequire("9715X");

var $jDKKo = parcelRequire("jDKKo");

var $acw62 = parcelRequire("acw62");

var $jk22o = parcelRequire("jk22o");
parcelRequire("f5Egd");
var $vYtsV = parcelRequire("vYtsV");
parcelRequire("1u0KT");
parcelRequire("41YNz");

var $32kym = parcelRequire("32kym");

var $bUCRB = parcelRequire("bUCRB");
parcelRequire("6xSYO");
parcelRequire("gS6QF");
parcelRequire("83zt3");

var $e9Jgd = parcelRequire("e9Jgd");

var $czXz2 = parcelRequire("czXz2");
function $74db94543ef6f28d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $74db94543ef6f28d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $jDKKo.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $jDKKo.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $9715X.default)(this, result);
    };
}
function $74db94543ef6f28d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $74db94543ef6f28d$export$a7deb1594c5ce10e = /*#__PURE__*/ function(_Component) {
    (0, $1gYAD.default)(NonceProvider, _Component);
    var _super = $74db94543ef6f28d$var$_createSuper(NonceProvider);
    function NonceProvider(props) {
        var _this;
        (0, $6CZeq.default)(this, NonceProvider);
        _this = _super.call(this, props);
        _this.createEmotionCache = function(nonce) {
            return (0, $czXz2.default)({
                nonce: nonce
            });
        };
        _this.createEmotionCache = (0, $jk22o.default)(_this.createEmotionCache);
        return _this;
    }
    (0, $cHPF9.default)(NonceProvider, [
        {
            key: "render",
            value: function render() {
                var emotionCache = this.createEmotionCache(this.props.nonce);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $vYtsV.C), {
                    value: emotionCache
                }, this.props.children);
            }
        }
    ]);
    return NonceProvider;
}((0, $acw62.Component));
var $74db94543ef6f28d$var$index = (0, $e9Jgd.m)((0, $bUCRB.S));
var $74db94543ef6f28d$export$2e2bcd8739ae039 = $74db94543ef6f28d$var$index;

});
parcelRegister("gZU1N", function(module, exports) {

var $c05no = parcelRequire("c05no");
function $c5fdcdd8d5286ae7$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $c05no(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
module.exports = $c5fdcdd8d5286ae7$var$_objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("02Ztr", function(module, exports) {

var $gpDEB = parcelRequire("gpDEB");

var $kzBhd = parcelRequire("kzBhd");

var $72a6v = parcelRequire("72a6v");

var $dIU5s = parcelRequire("dIU5s");
function $008fdf6f13d86ab1$var$_slicedToArray(r, e) {
    return $gpDEB(r) || $kzBhd(r, e) || $72a6v(r, e) || $dIU5s();
}
module.exports = $008fdf6f13d86ab1$var$_slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("gpDEB", function(module, exports) {
function $bf2dbd940d8d1ee7$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
module.exports = $bf2dbd940d8d1ee7$var$_arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("kzBhd", function(module, exports) {
function $efa3fde0b6100532$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
module.exports = $efa3fde0b6100532$var$_iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("72a6v", function(module, exports) {

var $2zZPz = parcelRequire("2zZPz");
function $51f08ebed50a2438$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $2zZPz(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $2zZPz(r, a) : void 0;
    }
}
module.exports = $51f08ebed50a2438$var$_unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("2zZPz", function(module, exports) {
function $1e0ecff44bad0ea1$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
module.exports = $1e0ecff44bad0ea1$var$_arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("dIU5s", function(module, exports) {
function $9fdae42208ebda05$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $9fdae42208ebda05$var$_nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("fUHKi", function(module, exports) {

var $5F6pO = parcelRequire("5F6pO");

var $hAHB6 = parcelRequire("hAHB6");

var $72a6v = parcelRequire("72a6v");

var $8UrHA = parcelRequire("8UrHA");
function $b95e04f2d4c66124$var$_toConsumableArray(r) {
    return $5F6pO(r) || $hAHB6(r) || $72a6v(r) || $8UrHA();
}
module.exports = $b95e04f2d4c66124$var$_toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("5F6pO", function(module, exports) {

var $2zZPz = parcelRequire("2zZPz");
function $41f5c206613f56c9$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $2zZPz(r);
}
module.exports = $41f5c206613f56c9$var$_arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("hAHB6", function(module, exports) {
function $cce79e023a3a67e7$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
module.exports = $cce79e023a3a67e7$var$_iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("8UrHA", function(module, exports) {
function $67c90abe6042aecd$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = $67c90abe6042aecd$var$_nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("jk22o", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $e111773323c0bcc0$export$2e2bcd8739ae039);
var $e111773323c0bcc0$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === "number" && value !== value;
};
function $e111773323c0bcc0$var$isEqual(first, second) {
    if (first === second) return true;
    if ($e111773323c0bcc0$var$safeIsNaN(first) && $e111773323c0bcc0$var$safeIsNaN(second)) return true;
    return false;
}
function $e111773323c0bcc0$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$e111773323c0bcc0$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $e111773323c0bcc0$var$memoizeOne(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $e111773323c0bcc0$var$areInputsEqual;
    var lastThis;
    var lastArgs = [];
    var lastResult;
    var calledOnce = false;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) return lastResult;
        lastResult = resultFn.apply(this, newArgs);
        calledOnce = true;
        lastThis = this;
        lastArgs = newArgs;
        return lastResult;
    }
    return memoized;
}
var $e111773323c0bcc0$export$2e2bcd8739ae039 = $e111773323c0bcc0$var$memoizeOne;

});

parcelRegister("f5Egd", function(module, exports) {

$parcel$export(module.exports, "keyframes", () => $afc68d865495bec5$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ClassNames", () => $afc68d865495bec5$export$9b9c0f9d9f3552b8);
$parcel$export(module.exports, "jsx", () => $afc68d865495bec5$export$c8a8987d4410bf2d);
$parcel$export(module.exports, "CacheProvider", () => (parcelRequire("vYtsV")).C);

var $g7ajw = parcelRequire("g7ajw");

var $acw62 = parcelRequire("acw62");
parcelRequire("czXz2");

var $vYtsV = parcelRequire("vYtsV");

var $boAuA = parcelRequire("boAuA");

var $cXgB3 = parcelRequire("cXgB3");

var $gGJqS = parcelRequire("gGJqS");

var $6xSYO = parcelRequire("6xSYO");
var $afc68d865495bec5$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $vYtsV.h).call(props, "css")) // $FlowFixMe
    return (0, $acw62.createElement).apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $vYtsV.E);
    createElementArgArray[1] = (0, $vYtsV.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return (0, $acw62.createElement).apply(null, createElementArgArray);
};
var $afc68d865495bec5$var$warnedAboutCssPropForGlobal = false;
var $afc68d865495bec5$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $vYtsV.w)(function(props, cache) {
    var styles = props.styles;
    if (typeof styles === "function") return /*#__PURE__*/ (0, $acw62.createElement)((0, $vYtsV.T).Consumer, null, function(theme) {
        var serialized = (0, $cXgB3.serializeStyles)([
            styles(theme)
        ]);
        return /*#__PURE__*/ (0, $acw62.createElement)($afc68d865495bec5$var$InnerGlobal, {
            serialized: serialized,
            cache: cache
        });
    });
    var serialized = (0, $cXgB3.serializeStyles)([
        styles
    ]);
    return /*#__PURE__*/ (0, $acw62.createElement)($afc68d865495bec5$var$InnerGlobal, {
        serialized: serialized,
        cache: cache
    });
});
// maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $afc68d865495bec5$var$InnerGlobal = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(InnerGlobal, _React$Component);
    function InnerGlobal(props, context, updater) {
        return _React$Component.call(this, props, context, updater) || this;
    }
    var _proto = InnerGlobal.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.sheet = new (0, $gGJqS.StyleSheet)({
            key: this.props.cache.key + "-global",
            nonce: this.props.cache.sheet.nonce,
            container: this.props.cache.sheet.container
        }); // $FlowFixMe
        var node = document.querySelector("style[data-emotion-" + this.props.cache.key + '="' + this.props.serialized.name + '"]');
        if (node !== null) this.sheet.tags.push(node);
        if (this.props.cache.sheet.tags.length) this.sheet.before = this.props.cache.sheet.tags[0];
        this.insertStyles();
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (prevProps.serialized.name !== this.props.serialized.name) this.insertStyles();
    };
    _proto.insertStyles = function insertStyles$1() {
        if (this.props.serialized.next !== undefined) // insert keyframes
        (0, $boAuA.insertStyles)(this.props.cache, this.props.serialized.next, true);
        if (this.sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
            this.sheet.before = element;
            this.sheet.flush();
        }
        this.props.cache.insert("", this.props.serialized, this.sheet, false);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.sheet.flush();
    };
    _proto.render = function render() {
        return null;
    };
    return InnerGlobal;
}((0, $acw62.Component));
var $afc68d865495bec5$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = (0, $6xSYO.default).apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $afc68d865495bec5$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = "";
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = "";
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};
function $afc68d865495bec5$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $boAuA.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $afc68d865495bec5$var$Noop = function Noop() {
    return null;
};
var $afc68d865495bec5$export$9b9c0f9d9f3552b8 = (0, $vYtsV.w)(function(props, context) {
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $vYtsV.T).Consumer, null, function(theme) {
        var hasRendered = false;
        var css = function css() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var serialized = (0, $cXgB3.serializeStyles)(args, context.registered);
            (0, $boAuA.insertStyles)(context, serialized, false);
            return context.key + "-" + serialized.name;
        };
        var cx = function cx() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return $afc68d865495bec5$var$merge(context.registered, css, $afc68d865495bec5$var$classnames(args));
        };
        var content = {
            css: css,
            cx: cx,
            theme: theme
        };
        var ele = props.children(content);
        hasRendered = true;
        var possiblyStyleElement = /*#__PURE__*/ (0, $acw62.createElement)($afc68d865495bec5$var$Noop, null);
        return /*#__PURE__*/ (0, $acw62.createElement)((0, $acw62.Fragment), null, possiblyStyleElement, ele);
    });
});

});
parcelRegister("czXz2", function(module, exports) {

$parcel$export(module.exports, "default", () => $9286f517b9779ada$export$2e2bcd8739ae039);

var $gGJqS = parcelRequire("gGJqS");

var $demXJ = parcelRequire("demXJ");
parcelRequire("55EI3");
// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var $9286f517b9779ada$var$delimiter = "/*|*/";
var $9286f517b9779ada$var$needle = $9286f517b9779ada$var$delimiter + "}";
function $9286f517b9779ada$var$toSheet(block) {
    if (block) $9286f517b9779ada$var$Sheet.current.insert(block + "}");
}
var $9286f517b9779ada$var$Sheet = {
    current: null
};
var $9286f517b9779ada$var$ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
    switch(context){
        // property
        case 1:
            switch(content.charCodeAt(0)){
                case 64:
                    // @import
                    $9286f517b9779ada$var$Sheet.current.insert(content + ";");
                    return "";
                // charcode for l
                case 108:
                    // charcode for b
                    // this ignores label
                    if (content.charCodeAt(2) === 98) return "";
            }
            break;
        // selector
        case 2:
            if (ns === 0) return content + $9286f517b9779ada$var$delimiter;
            break;
        // at-rule
        case 3:
            switch(ns){
                // @font-face, @page
                case 102:
                case 112:
                    $9286f517b9779ada$var$Sheet.current.insert(selectors[0] + content);
                    return "";
                default:
                    return content + (at === 0 ? $9286f517b9779ada$var$delimiter : "");
            }
        case -2:
            content.split($9286f517b9779ada$var$needle).forEach($9286f517b9779ada$var$toSheet);
    }
};
var $9286f517b9779ada$var$createCache = function createCache(options) {
    if (options === undefined) options = {};
    var key = options.key || "css";
    var stylisOptions;
    if (options.prefix !== undefined) stylisOptions = {
        prefix: options.prefix
    };
    var stylis = new (0, $demXJ.default)(stylisOptions);
    var inserted = {}; // $FlowFixMe
    var container;
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function(node) {
        var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe
        attrib.split(" ").forEach(function(id) {
            inserted[id] = true;
        });
        if (node.parentNode !== container) container.appendChild(node);
    });
    var _insert;
    stylis.use(options.stylisPlugins)($9286f517b9779ada$var$ruleSheet);
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        var name = serialized.name;
        $9286f517b9779ada$var$Sheet.current = sheet;
        var map;
        stylis(selector, serialized.styles);
        if (shouldCache) cache.inserted[name] = true;
    };
    var commentStart, commentEnd;
    var cache = {
        key: key,
        sheet: new (0, $gGJqS.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    return cache;
};
var $9286f517b9779ada$export$2e2bcd8739ae039 = $9286f517b9779ada$var$createCache;

});
parcelRegister("gGJqS", function(module, exports) {

$parcel$export(module.exports, "StyleSheet", () => $c263cf8568d025ad$export$9d753cd7ae895cce);
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $c263cf8568d025ad$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $c263cf8568d025ad$var$createStyleElement(options) {
    var tag = document.createElement("style");
    tag.setAttribute("data-emotion", options.key);
    if (options.nonce !== undefined) tag.setAttribute("nonce", options.nonce);
    tag.appendChild(document.createTextNode(""));
    return tag;
}
var $c263cf8568d025ad$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    function StyleSheet(options) {
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
            var _tag = $c263cf8568d025ad$var$createStyleElement(this);
            var before;
            if (this.tags.length === 0) before = this.before;
            else before = this.tags[this.tags.length - 1].nextSibling;
            this.container.insertBefore(_tag, before);
            this.tags.push(_tag);
        }
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $c263cf8568d025ad$var$sheetForTag(tag);
            try {
                // this is a really hot path
                // we check the second character first because having "i"
                // as the second character will happen less often than
                // having "@" as the first character
                var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, // otherwise there will be an error
                // technically this means that the @import rules will
                // _usually_(not always since there could be multiple style tags)
                // be the first ones in prod and generally later in dev
                // this shouldn't really matter in the real world though
                // @import is generally only used for font faces from google fonts and etc.
                // so while this could be technically correct then it would be slower and larger
                // for a tiny bit of correctness that won't matter in the real world
                isImportRule ? 0 : sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("55EI3", function(module, exports) {
var $3b4cff6eff59c4cb$var$weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};
var $3b4cff6eff59c4cb$export$2e2bcd8739ae039 = $3b4cff6eff59c4cb$var$weakMemoize;

});


parcelRegister("vYtsV", function(module, exports) {

$parcel$export(module.exports, "h", () => $0601ce4a8a51021f$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "T", () => $0601ce4a8a51021f$export$971d5caa766a69d7);
$parcel$export(module.exports, "C", () => $0601ce4a8a51021f$export$e7094788287c5e9b);
$parcel$export(module.exports, "w", () => $0601ce4a8a51021f$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "c", () => $0601ce4a8a51021f$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $0601ce4a8a51021f$export$a9c23c6ac3fc3eca);
parcelRequire("6r4zt");

var $acw62 = parcelRequire("acw62");

var $czXz2 = parcelRequire("czXz2");

var $boAuA = parcelRequire("boAuA");

var $cXgB3 = parcelRequire("cXgB3");
var $0601ce4a8a51021f$export$dda1d9f60106f0e9 = Object.prototype.hasOwnProperty;
var $0601ce4a8a51021f$var$EmotionCacheContext = /*#__PURE__*/ (0, $acw62.createContext)(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== "undefined" ? (0, $czXz2.default)() : null);
var $0601ce4a8a51021f$export$971d5caa766a69d7 = /*#__PURE__*/ (0, $acw62.createContext)({});
var $0601ce4a8a51021f$export$e7094788287c5e9b = $0601ce4a8a51021f$var$EmotionCacheContext.Provider;
var $0601ce4a8a51021f$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    var render = function render(props, ref) {
        return /*#__PURE__*/ (0, $acw62.createElement)($0601ce4a8a51021f$var$EmotionCacheContext.Consumer, null, function(cache) {
            return func(props, cache, ref);
        });
    }; // $FlowFixMe
    return /*#__PURE__*/ (0, $acw62.forwardRef)(render);
};
// thus we only need to replace what is a valid character for JS, but not for CSS
var $0601ce4a8a51021f$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, "-");
};
var $0601ce4a8a51021f$var$typePropName = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__";
var $0601ce4a8a51021f$var$labelPropName = "__EMOTION_LABEL_PLEASE_DO_NOT_USE__";
var $0601ce4a8a51021f$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($0601ce4a8a51021f$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$0601ce4a8a51021f$var$typePropName] = type; // TODO: check if this still works with all of those different JSX functions
    var error, match;
    return newProps;
};
var $0601ce4a8a51021f$var$Noop = function Noop() {
    return null;
};
var $0601ce4a8a51021f$var$render = function render(cache, props, theme, ref) {
    var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === "string" && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var type = props[$0601ce4a8a51021f$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = "";
    if (typeof props.className === "string") className = (0, $boAuA.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $cXgB3.serializeStyles)(registeredStyles);
    var labelFromStack;
    var rules = (0, $boAuA.insertStyles)(cache, serialized, typeof type === "string");
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($0601ce4a8a51021f$export$dda1d9f60106f0e9.call(props, key) && key !== "css" && key !== $0601ce4a8a51021f$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    var ele = /*#__PURE__*/ (0, $acw62.createElement)(type, newProps);
    var possiblyStyleElement = /*#__PURE__*/ (0, $acw62.createElement)($0601ce4a8a51021f$var$Noop, null);
    return /*#__PURE__*/ (0, $acw62.createElement)((0, $acw62.Fragment), null, possiblyStyleElement, ele);
}; // eslint-disable-next-line no-undef
var $0601ce4a8a51021f$export$a9c23c6ac3fc3eca = /* #__PURE__ */ $0601ce4a8a51021f$export$efccba1c4a2ef57b(function(props, cache, ref) {
    if (typeof props.css === "function") return /*#__PURE__*/ (0, $acw62.createElement)($0601ce4a8a51021f$export$971d5caa766a69d7.Consumer, null, function(theme) {
        return $0601ce4a8a51021f$var$render(cache, props, theme, ref);
    });
    return $0601ce4a8a51021f$var$render(cache, props, null, ref);
});

});
parcelRegister("boAuA", function(module, exports) {

$parcel$export(module.exports, "getRegisteredStyles", () => $84be3e3d8830d20e$export$95d99596f328fd52);
$parcel$export(module.exports, "insertStyles", () => $84be3e3d8830d20e$export$6f077d94b33a01aa);
var $84be3e3d8830d20e$var$isBrowser = true;
function $84be3e3d8830d20e$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = "";
    classNames.split(" ").forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className]);
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $84be3e3d8830d20e$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $84be3e3d8830d20e$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            var maybeStyles = cache.insert("." + className, current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("cXgB3", function(module, exports) {

$parcel$export(module.exports, "serializeStyles", () => $96e7de74f086414c$export$6321afa313b251b5);

var $gz7zU = parcelRequire("gz7zU");

var $iDSBG = parcelRequire("iDSBG");

var $l7O8P = parcelRequire("l7O8P");
var $96e7de74f086414c$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $96e7de74f086414c$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $96e7de74f086414c$var$hyphenateRegex = /[A-Z]|^ms/g;
var $96e7de74f086414c$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $96e7de74f086414c$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $96e7de74f086414c$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== "boolean";
};
var $96e7de74f086414c$var$processStyleName = (0, $l7O8P.default)(function(styleName) {
    return $96e7de74f086414c$var$isCustomProperty(styleName) ? styleName : styleName.replace($96e7de74f086414c$var$hyphenateRegex, "-$&").toLowerCase();
});
var $96e7de74f086414c$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case "animation":
        case "animationName":
            if (typeof value === "string") return value.replace($96e7de74f086414c$var$animationRegex, function(match, p1, p2) {
                $96e7de74f086414c$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $96e7de74f086414c$var$cursor
                };
                return p1;
            });
    }
    if ((0, $iDSBG.default)[key] !== 1 && !$96e7de74f086414c$var$isCustomProperty(key) && typeof value === "number" && value !== 0) return value + "px";
    return value;
};
var $96e7de74f086414c$var$contentValuePattern, $96e7de74f086414c$var$contentValues, $96e7de74f086414c$var$oldProcessStyleValue, $96e7de74f086414c$var$msPattern, $96e7de74f086414c$var$hyphenPattern, $96e7de74f086414c$var$hyphenatedCache;
var $96e7de74f086414c$var$shouldWarnAboutInterpolatingClassNameFromCss = true;
function $96e7de74f086414c$var$handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) return "";
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case "boolean":
            return "";
        case "object":
            if (interpolation.anim === 1) {
                $96e7de74f086414c$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $96e7de74f086414c$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $96e7de74f086414c$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $96e7de74f086414c$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $96e7de74f086414c$var$createStringFromObject(mergedProps, registered, interpolation);
        case "function":
            if (mergedProps !== undefined) {
                var previousCursor = $96e7de74f086414c$var$cursor;
                var result = interpolation(mergedProps);
                $96e7de74f086414c$var$cursor = previousCursor;
                return $96e7de74f086414c$var$handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
            }
            break;
        case "string":
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}
function $96e7de74f086414c$var$createStringFromObject(mergedProps, registered, obj) {
    var string = "";
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $96e7de74f086414c$var$handleInterpolation(mergedProps, registered, obj[i], false);
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== "object") {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($96e7de74f086414c$var$isProcessableValue(value)) string += $96e7de74f086414c$var$processStyleName(_key) + ":" + $96e7de74f086414c$var$processStyleValue(_key, value) + ";";
        } else if (Array.isArray(value) && typeof value[0] === "string" && (registered == null || registered[value[0]] === undefined)) {
            for(var _i = 0; _i < value.length; _i++)if ($96e7de74f086414c$var$isProcessableValue(value[_i])) string += $96e7de74f086414c$var$processStyleName(_key) + ":" + $96e7de74f086414c$var$processStyleValue(_key, value[_i]) + ";";
        } else {
            var interpolated = $96e7de74f086414c$var$handleInterpolation(mergedProps, registered, value, false);
            switch(_key){
                case "animation":
                case "animationName":
                    string += $96e7de74f086414c$var$processStyleName(_key) + ":" + interpolated + ";";
                    break;
                default:
                    string += _key + "{" + interpolated + "}";
            }
        }
    }
    return string;
}
var $96e7de74f086414c$var$labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var $96e7de74f086414c$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $96e7de74f086414c$var$cursor;
var $96e7de74f086414c$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === "object" && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = "";
    $96e7de74f086414c$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $96e7de74f086414c$var$handleInterpolation(mergedProps, registered, strings, false);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $96e7de74f086414c$var$handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $96e7de74f086414c$var$labelPattern.lastIndex = 0;
    var identifierName = "";
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $96e7de74f086414c$var$labelPattern.exec(styles)) !== null)identifierName += "-" + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $gz7zU.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $96e7de74f086414c$var$cursor
    };
};

});
parcelRegister("gz7zU", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0f5cb12993018cc$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $c0f5cb12993018cc$var$murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var $c0f5cb12993018cc$export$2e2bcd8739ae039 = $c0f5cb12993018cc$var$murmur2;

});



parcelRegister("6xSYO", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c4078fc8d62d9b6$export$2e2bcd8739ae039);

var $cXgB3 = parcelRequire("cXgB3");
function $4c4078fc8d62d9b6$var$css() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $cXgB3.serializeStyles)(args);
}
var $4c4078fc8d62d9b6$export$2e2bcd8739ae039 = $4c4078fc8d62d9b6$var$css;

});


parcelRegister("32kym", function(module, exports) {

$parcel$export(module.exports, "E", () => $2361806a25584d2d$export$a9c23c6ac3fc3eca);
$parcel$export(module.exports, "z", () => $2361806a25584d2d$export$df995fae86a55f06);
$parcel$export(module.exports, "C", () => $2361806a25584d2d$export$e7094788287c5e9b);
$parcel$export(module.exports, "G", () => $2361806a25584d2d$export$2329c99376c9d0a4);
$parcel$export(module.exports, "A", () => $2361806a25584d2d$export$ebd11618f299a286);
$parcel$export(module.exports, "D", () => $2361806a25584d2d$export$96f57966bedc81b4);
$parcel$export(module.exports, "w", () => $2361806a25584d2d$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "x", () => $2361806a25584d2d$export$d141bba7fdc215a3);
$parcel$export(module.exports, "m", () => $2361806a25584d2d$export$953cecd6e717a553);
$parcel$export(module.exports, "M", () => $2361806a25584d2d$export$3a1a48c8f6ef640e);
$parcel$export(module.exports, "k", () => $2361806a25584d2d$export$342063e11d6c3cad);
$parcel$export(module.exports, "r", () => $2361806a25584d2d$export$43caf9889c228507);
$parcel$export(module.exports, "j", () => $2361806a25584d2d$export$35e795649ee09318);
$parcel$export(module.exports, "n", () => $2361806a25584d2d$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "B", () => $2361806a25584d2d$export$ef35774e6d314e91);
$parcel$export(module.exports, "a", () => $2361806a25584d2d$export$407448d2b89b1813);
$parcel$export(module.exports, "v", () => $2361806a25584d2d$export$90a7f3efeed30595);
$parcel$export(module.exports, "i", () => $2361806a25584d2d$export$23f2a1d2818174ef);
$parcel$export(module.exports, "d", () => $2361806a25584d2d$export$4368d992c4eafac0);
$parcel$export(module.exports, "c", () => $2361806a25584d2d$export$db3b6bfb95261072);
$parcel$export(module.exports, "f", () => $2361806a25584d2d$export$2d1720544b23b823);
$parcel$export(module.exports, "l", () => $2361806a25584d2d$export$882b5998b3b9117c);
$parcel$export(module.exports, "b", () => $2361806a25584d2d$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "g", () => $2361806a25584d2d$export$39b482c5e57630a8);
$parcel$export(module.exports, "e", () => $2361806a25584d2d$export$f1e1789686576879);
$parcel$export(module.exports, "h", () => $2361806a25584d2d$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "o", () => $2361806a25584d2d$export$ae1af26003f05816);
$parcel$export(module.exports, "p", () => $2361806a25584d2d$export$ffb5f4729a158638);
$parcel$export(module.exports, "q", () => $2361806a25584d2d$export$9e5f44173e64f162);
$parcel$export(module.exports, "s", () => $2361806a25584d2d$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "t", () => $2361806a25584d2d$export$625550452a3fa3ec);
$parcel$export(module.exports, "u", () => $2361806a25584d2d$export$3b14a55fb2447963);
$parcel$export(module.exports, "F", () => $2361806a25584d2d$export$d66501df72047452);
$parcel$export(module.exports, "y", () => $2361806a25584d2d$export$4a5767248b18ef41);

var $9X7IJ = parcelRequire("9X7IJ");

var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $1gYAD = parcelRequire("1gYAD");

var $9715X = parcelRequire("9715X");

var $jDKKo = parcelRequire("jDKKo");

var $acw62 = parcelRequire("acw62");

var $f5Egd = parcelRequire("f5Egd");

var $1u0KT = parcelRequire("1u0KT");

var $fSwVM = parcelRequire("fSwVM");

var $6xSYO = parcelRequire("6xSYO");

var $hvnYt = parcelRequire("hvnYt");

var $83zt3 = parcelRequire("83zt3");
// ==============================
// NO OP
// ==============================
var $2361806a25584d2d$export$a9c23c6ac3fc3eca = function noop() {};
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $2361806a25584d2d$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === "-") return prefix + name;
    else return prefix + "__" + name;
}
function $2361806a25584d2d$export$df995fae86a55f06(prefix, state, className) {
    var arr = [
        className
    ];
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($2361806a25584d2d$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(" ");
} // ==============================
// Clean Value
// ==============================
var $2361806a25584d2d$export$e7094788287c5e9b = function cleanValue(value) {
    if (Array.isArray(value)) return value.filter(Boolean);
    if ((0, $fSwVM.default)(value) === "object" && value !== null) return [
        value
    ];
    return [];
}; // ==============================
// Handle Input Change
// ==============================
function $2361806a25584d2d$export$2329c99376c9d0a4(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === "string") return newValue;
    }
    return inputValue;
} // ==============================
// Scroll Helpers
// ==============================
function $2361806a25584d2d$export$ebd11618f299a286(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
} // Normalized Scroll Top
// ------------------------------
function $2361806a25584d2d$var$getScrollTop(el) {
    if ($2361806a25584d2d$export$ebd11618f299a286(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $2361806a25584d2d$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($2361806a25584d2d$export$ebd11618f299a286(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
} // Get Scroll Parent
// ------------------------------
function $2361806a25584d2d$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === "absolute";
    var overflowRx = /(auto|scroll)/;
    var docEl = document.documentElement; // suck it, flow...
    if (style.position === "fixed") return docEl;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === "static") continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return docEl;
} // Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $2361806a25584d2d$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $2361806a25584d2d$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $2361806a25584d2d$export$a9c23c6ac3fc3eca;
    var start = $2361806a25584d2d$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $2361806a25584d2d$var$easeOutCubic(currentTime, start, change, duration);
        $2361806a25584d2d$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
} // Scroll Into View
// ------------------------------
function $2361806a25584d2d$export$96f57966bedc81b4(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $2361806a25584d2d$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $2361806a25584d2d$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
} // ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $2361806a25584d2d$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// Touch Capability Detector
// ==============================
function $2361806a25584d2d$export$efccba1c4a2ef57b() {
    try {
        document.createEvent("TouchEvent");
        return true;
    } catch (e) {
        return false;
    }
} // ==============================
// Mobile Device Detector
// ==============================
function $2361806a25584d2d$export$d141bba7fdc215a3() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
function $2361806a25584d2d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2361806a25584d2d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $2361806a25584d2d$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $kSlfw.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $2361806a25584d2d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $2361806a25584d2d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $2361806a25584d2d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $jDKKo.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $jDKKo.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $9715X.default)(this, result);
    };
}
function $2361806a25584d2d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $2361806a25584d2d$var$getMenuPlacement(_ref) {
    var maxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, placement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, theme = _ref.theme;
    var spacing = theme.spacing;
    var scrollParent = $2361806a25584d2d$var$getScrollParent(menuEl);
    var defaultState = {
        placement: "bottom",
        maxHeight: maxHeight
    }; // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState; // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = window.innerHeight;
    var scrollTop = $2361806a25584d2d$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(placement){
        case "auto":
        case "bottom":
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: "bottom",
                maxHeight: maxHeight
            };
             // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $2361806a25584d2d$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: "bottom",
                    maxHeight: maxHeight
                };
            } // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $2361806a25584d2d$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                 // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: "bottom",
                    maxHeight: constrainedHeight
                };
            } // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (placement === "auto" || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = maxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - spacing.controlHeight, maxHeight);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight
                };
            } // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (placement === "bottom") {
                $2361806a25584d2d$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: "bottom",
                    maxHeight: maxHeight
                };
            }
            break;
        case "top":
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: "top",
                maxHeight: maxHeight
            };
             // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $2361806a25584d2d$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: maxHeight
                };
            } // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = maxHeight; // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $2361806a25584d2d$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: "top",
                    maxHeight: _constrainedHeight2
                };
            } // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: "bottom",
                maxHeight: maxHeight
            };
        default:
            throw new Error('Invalid placement provided "'.concat(placement, '".'));
    } // fulfil contract with flow: implicit return value of undefined
    return defaultState;
} // Menu Component
// ------------------------------
function $2361806a25584d2d$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: "top",
        top: "bottom"
    };
    return placement ? placementToCSSProp[placement] : "bottom";
}
var $2361806a25584d2d$var$coercePlacement = function coercePlacement(p) {
    return p === "auto" ? "bottom" : p;
};
var $2361806a25584d2d$export$953cecd6e717a553 = function menuCSS(_ref2) {
    var _ref3;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return _ref3 = {
        label: "menu"
    }, (0, $kSlfw.default)(_ref3, $2361806a25584d2d$var$alignToControl(placement), "100%"), (0, $kSlfw.default)(_ref3, "backgroundColor", colors.neutral0), (0, $kSlfw.default)(_ref3, "borderRadius", borderRadius), (0, $kSlfw.default)(_ref3, "boxShadow", "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)"), (0, $kSlfw.default)(_ref3, "marginBottom", spacing.menuGutter), (0, $kSlfw.default)(_ref3, "marginTop", spacing.menuGutter), (0, $kSlfw.default)(_ref3, "position", "absolute"), (0, $kSlfw.default)(_ref3, "width", "100%"), (0, $kSlfw.default)(_ref3, "zIndex", 1), _ref3;
};
var $2361806a25584d2d$var$PortalPlacementContext = /*#__PURE__*/ (0, $acw62.createContext)({
    getPortalPlacement: null
}); // NOTE: internal only
var $2361806a25584d2d$export$3a1a48c8f6ef640e = /*#__PURE__*/ function(_Component) {
    (0, $1gYAD.default)(MenuPlacer, _Component);
    var _super = $2361806a25584d2d$var$_createSuper(MenuPlacer);
    function MenuPlacer() {
        var _this;
        (0, $6CZeq.default)(this, MenuPlacer);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.state = {
            maxHeight: _this.props.maxMenuHeight,
            placement: null
        };
        _this.getPlacement = function(ref) {
            var _this$props = _this.props, minMenuHeight = _this$props.minMenuHeight, maxMenuHeight = _this$props.maxMenuHeight, menuPlacement = _this$props.menuPlacement, menuPosition = _this$props.menuPosition, menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView, theme = _this$props.theme;
            if (!ref) return; // DO NOT scroll if position is fixed
            var isFixedPosition = menuPosition === "fixed";
            var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
            var state = $2361806a25584d2d$var$getMenuPlacement({
                maxHeight: maxMenuHeight,
                menuEl: ref,
                minHeight: minMenuHeight,
                placement: menuPlacement,
                shouldScroll: shouldScroll,
                isFixedPosition: isFixedPosition,
                theme: theme
            });
            var getPortalPlacement = _this.context.getPortalPlacement;
            if (getPortalPlacement) getPortalPlacement(state);
            _this.setState(state);
        };
        _this.getUpdatedProps = function() {
            var menuPlacement = _this.props.menuPlacement;
            var placement = _this.state.placement || $2361806a25584d2d$var$coercePlacement(menuPlacement);
            return $2361806a25584d2d$var$_objectSpread($2361806a25584d2d$var$_objectSpread({}, _this.props), {}, {
                placement: placement,
                maxHeight: _this.state.maxHeight
            });
        };
        return _this;
    }
    (0, $cHPF9.default)(MenuPlacer, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return children({
                    ref: this.getPlacement,
                    placerProps: this.getUpdatedProps()
                });
            }
        }
    ]);
    return MenuPlacer;
}((0, $acw62.Component));
$2361806a25584d2d$export$3a1a48c8f6ef640e.contextType = $2361806a25584d2d$var$PortalPlacementContext;
var $2361806a25584d2d$var$Menu = function Menu(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $f5Egd.jsx)("div", (0, $8nd05.default)({
        css: getStyles("menu", props),
        className: cx({
            menu: true
        }, className)
    }, innerProps, {
        ref: innerRef
    }), children);
};
// Menu List
// ==============================
var $2361806a25584d2d$export$342063e11d6c3cad = function menuListCSS(_ref4) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return {
        maxHeight: maxHeight,
        overflowY: "auto",
        paddingBottom: baseUnit,
        paddingTop: baseUnit,
        position: "relative",
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: "touch"
    };
};
var $2361806a25584d2d$var$MenuList = function MenuList(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, isMulti = props.isMulti, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $f5Egd.jsx)("div", (0, $8nd05.default)({
        css: getStyles("menuList", props),
        className: cx({
            "menu-list": true,
            "menu-list--is-multi": isMulti
        }, className),
        ref: innerRef
    }, innerProps), children);
}; // ==============================
// Menu Notices
// ==============================
var $2361806a25584d2d$var$noticeCSS = function noticeCSS(_ref5) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px"),
        textAlign: "center"
    };
};
var $2361806a25584d2d$export$43caf9889c228507 = $2361806a25584d2d$var$noticeCSS;
var $2361806a25584d2d$export$35e795649ee09318 = $2361806a25584d2d$var$noticeCSS;
var $2361806a25584d2d$var$NoOptionsMessage = function NoOptionsMessage(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, $f5Egd.jsx)("div", (0, $8nd05.default)({
        css: getStyles("noOptionsMessage", props),
        className: cx({
            "menu-notice": true,
            "menu-notice--no-options": true
        }, className)
    }, innerProps), children);
};
$2361806a25584d2d$var$NoOptionsMessage.defaultProps = {
    children: "No options"
};
var $2361806a25584d2d$var$LoadingMessage = function LoadingMessage(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, $f5Egd.jsx)("div", (0, $8nd05.default)({
        css: getStyles("loadingMessage", props),
        className: cx({
            "menu-notice": true,
            "menu-notice--loading": true
        }, className)
    }, innerProps), children);
};
$2361806a25584d2d$var$LoadingMessage.defaultProps = {
    children: "Loading..."
}; // ==============================
// Menu Portal
// ==============================
var $2361806a25584d2d$export$7ccc53e8f1e7dfc5 = function menuPortalCSS(_ref6) {
    var rect = _ref6.rect, offset = _ref6.offset, position = _ref6.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $2361806a25584d2d$var$MenuPortal = /*#__PURE__*/ function(_Component2) {
    (0, $1gYAD.default)(MenuPortal, _Component2);
    var _super2 = $2361806a25584d2d$var$_createSuper(MenuPortal);
    function MenuPortal() {
        var _this2;
        (0, $6CZeq.default)(this, MenuPortal);
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        _this2 = _super2.call.apply(_super2, [
            this
        ].concat(args));
        _this2.state = {
            placement: null
        };
        _this2.getPortalPlacement = function(_ref7) {
            var placement = _ref7.placement;
            var initialPlacement = $2361806a25584d2d$var$coercePlacement(_this2.props.menuPlacement); // avoid re-renders if the placement has not changed
            if (placement !== initialPlacement) _this2.setState({
                placement: placement
            });
        };
        return _this2;
    }
    (0, $cHPF9.default)(MenuPortal, [
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, appendTo = _this$props2.appendTo, children = _this$props2.children, controlElement = _this$props2.controlElement, menuPlacement = _this$props2.menuPlacement, position = _this$props2.menuPosition, getStyles = _this$props2.getStyles;
                var isFixed = position === "fixed"; // bail early if required elements aren't present
                if (!appendTo && !isFixed || !controlElement) return null;
                var placement = this.state.placement || $2361806a25584d2d$var$coercePlacement(menuPlacement);
                var rect = $2361806a25584d2d$var$getBoundingClientObj(controlElement);
                var scrollDistance = isFixed ? 0 : window.pageYOffset;
                var offset = rect[placement] + scrollDistance;
                var state = {
                    offset: offset,
                    position: position,
                    rect: rect
                }; // same wrapper element whether fixed or portalled
                var menuWrapper = (0, $f5Egd.jsx)("div", {
                    css: getStyles("menuPortal", state)
                }, children);
                return (0, $f5Egd.jsx)($2361806a25584d2d$var$PortalPlacementContext.Provider, {
                    value: {
                        getPortalPlacement: this.getPortalPlacement
                    }
                }, appendTo ? /*#__PURE__*/ (0, $1u0KT.createPortal)(menuWrapper, appendTo) : menuWrapper);
            }
        }
    ]);
    return MenuPortal;
}((0, $acw62.Component));
var $2361806a25584d2d$var$isArray = Array.isArray;
var $2361806a25584d2d$var$keyList = Object.keys;
var $2361806a25584d2d$var$hasProp = Object.prototype.hasOwnProperty;
function $2361806a25584d2d$var$equal(a, b) {
    // fast-deep-equal index.js 2.0.1
    if (a === b) return true;
    if (a && b && (0, $fSwVM.default)(a) == "object" && (0, $fSwVM.default)(b) == "object") {
        var arrA = $2361806a25584d2d$var$isArray(a), arrB = $2361806a25584d2d$var$isArray(b), i, length, key;
        if (arrA && arrB) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$2361806a25584d2d$var$equal(a[i], b[i])) return false;
            }
            return true;
        }
        if (arrA != arrB) return false;
        var dateA = a instanceof Date, dateB = b instanceof Date;
        if (dateA != dateB) return false;
        if (dateA && dateB) return a.getTime() == b.getTime();
        var regexpA = a instanceof RegExp, regexpB = b instanceof RegExp;
        if (regexpA != regexpB) return false;
        if (regexpA && regexpB) return a.toString() == b.toString();
        var keys = $2361806a25584d2d$var$keyList(a);
        length = keys.length;
        if (length !== $2361806a25584d2d$var$keyList(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!$2361806a25584d2d$var$hasProp.call(b, keys[i])) return false;
        } // end fast-deep-equal
        // Custom handling for React
        for(i = length; i-- !== 0;){
            key = keys[i];
            if (key === "_owner" && a.$$typeof) continue;
            else {
                // all other properties should be traversed as usual
                if (!$2361806a25584d2d$var$equal(a[key], b[key])) return false;
            }
        } // fast-deep-equal index.js 2.0.1
        return true;
    }
    return a !== a && b !== b;
} // end fast-deep-equal
function $2361806a25584d2d$export$ef35774e6d314e91(a, b) {
    try {
        return $2361806a25584d2d$var$equal(a, b);
    } catch (error) {
        if (error.message && error.message.match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("Warning: react-fast-compare does not handle circular references.", error.name, error.message);
            return false;
        } // some other error. we should definitely know about these
        throw error;
    }
}
var $2361806a25584d2d$export$407448d2b89b1813 = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: "container",
        direction: isRtl ? "rtl" : null,
        pointerEvents: isDisabled ? "none" : null,
        // cancel mouse events when disabled
        position: "relative"
    };
};
var $2361806a25584d2d$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $f5Egd.jsx)("div", (0, $8nd05.default)({
        css: getStyles("container", props),
        className: cx({
            "--is-disabled": isDisabled,
            "--is-rtl": isRtl
        }, className)
    }, innerProps), children);
}; // ==============================
// Value Container
// ==============================
var $2361806a25584d2d$export$90a7f3efeed30595 = function valueContainerCSS(_ref2) {
    var spacing = _ref2.theme.spacing;
    return {
        alignItems: "center",
        display: "flex",
        flex: 1,
        flexWrap: "wrap",
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px"),
        WebkitOverflowScrolling: "touch",
        position: "relative",
        overflow: "hidden"
    };
};
var $2361806a25584d2d$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, className = props.className, cx = props.cx, isMulti = props.isMulti, getStyles = props.getStyles, hasValue = props.hasValue;
    return (0, $f5Egd.jsx)("div", {
        css: getStyles("valueContainer", props),
        className: cx({
            "value-container": true,
            "value-container--is-multi": isMulti,
            "value-container--has-value": hasValue
        }, className)
    }, children);
}; // ==============================
// Indicator Container
// ==============================
var $2361806a25584d2d$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: "center",
        alignSelf: "stretch",
        display: "flex",
        flexShrink: 0
    };
};
var $2361806a25584d2d$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles;
    return (0, $f5Egd.jsx)("div", {
        css: getStyles("indicatorsContainer", props),
        className: cx({
            indicators: true
        }, className)
    }, children);
};
function $2361806a25584d2d$var$_templateObject() {
    var data = (0, $hvnYt.default)([
        "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
    ]);
    $2361806a25584d2d$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function $2361806a25584d2d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $2361806a25584d2d$var$_ref2 = {
    name: "19bqh2r",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;"
};
// ==============================
// Dropdown & Clear Icons
// ==============================
var $2361806a25584d2d$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $9X7IJ.default)(_ref, [
        "size"
    ]);
    return (0, $f5Egd.jsx)("svg", (0, $8nd05.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $2361806a25584d2d$var$_ref2
    }, props));
};
var $2361806a25584d2d$var$CrossIcon = function CrossIcon(props) {
    return (0, $f5Egd.jsx)($2361806a25584d2d$var$Svg, (0, $8nd05.default)({
        size: 20
    }, props), (0, $f5Egd.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $2361806a25584d2d$var$DownChevron = function DownChevron(props) {
    return (0, $f5Egd.jsx)($2361806a25584d2d$var$Svg, (0, $8nd05.default)({
        size: 20
    }, props), (0, $f5Egd.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
}; // ==============================
// Dropdown & Clear Buttons
// ==============================
var $2361806a25584d2d$var$baseCSS = function baseCSS(_ref3) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return {
        label: "indicatorContainer",
        color: isFocused ? colors.neutral60 : colors.neutral20,
        display: "flex",
        padding: baseUnit * 2,
        transition: "color 150ms",
        ":hover": {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    };
};
var $2361806a25584d2d$export$4368d992c4eafac0 = $2361806a25584d2d$var$baseCSS;
var $2361806a25584d2d$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, $f5Egd.jsx)("div", (0, $8nd05.default)({}, innerProps, {
        css: getStyles("dropdownIndicator", props),
        className: cx({
            indicator: true,
            "dropdown-indicator": true
        }, className)
    }), children || (0, $f5Egd.jsx)($2361806a25584d2d$var$DownChevron, null));
};
var $2361806a25584d2d$export$db3b6bfb95261072 = $2361806a25584d2d$var$baseCSS;
var $2361806a25584d2d$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, $f5Egd.jsx)("div", (0, $8nd05.default)({}, innerProps, {
        css: getStyles("clearIndicator", props),
        className: cx({
            indicator: true,
            "clear-indicator": true
        }, className)
    }), children || (0, $f5Egd.jsx)($2361806a25584d2d$var$CrossIcon, null));
}; // ==============================
// Separator
// ==============================
var $2361806a25584d2d$export$2d1720544b23b823 = function indicatorSeparatorCSS(_ref4) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return {
        label: "indicatorSeparator",
        alignSelf: "stretch",
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2,
        width: 1
    };
};
var $2361806a25584d2d$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, $f5Egd.jsx)("span", (0, $8nd05.default)({}, innerProps, {
        css: getStyles("indicatorSeparator", props),
        className: cx({
            "indicator-separator": true
        }, className)
    }));
}; // ==============================
// Loading
// ==============================
var $2361806a25584d2d$var$loadingDotAnimations = (0, $f5Egd.keyframes)($2361806a25584d2d$var$_templateObject());
var $2361806a25584d2d$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return {
        label: "loadingIndicator",
        color: isFocused ? colors.neutral60 : colors.neutral20,
        display: "flex",
        padding: baseUnit * 2,
        transition: "color 150ms",
        alignSelf: "center",
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: "center",
        verticalAlign: "middle"
    };
};
var $2361806a25584d2d$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $f5Egd.jsx)("span", {
        css: /*#__PURE__*/ (0, $6xSYO.default)({
            animation: "".concat($2361806a25584d2d$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: "currentColor",
            borderRadius: "1em",
            display: "inline-block",
            marginLeft: offset ? "1em" : null,
            height: "1em",
            verticalAlign: "top",
            width: "1em"
        }, "")
    });
};
var $2361806a25584d2d$var$LoadingIndicator = function LoadingIndicator(props) {
    var className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps, isRtl = props.isRtl;
    return (0, $f5Egd.jsx)("div", (0, $8nd05.default)({}, innerProps, {
        css: getStyles("loadingIndicator", props),
        className: cx({
            indicator: true,
            "loading-indicator": true
        }, className)
    }), (0, $f5Egd.jsx)($2361806a25584d2d$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $f5Egd.jsx)($2361806a25584d2d$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $f5Egd.jsx)($2361806a25584d2d$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
$2361806a25584d2d$var$LoadingIndicator.defaultProps = {
    size: 4
};
var $2361806a25584d2d$export$8b22cf2602fb60ce = function css(_ref) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return {
        label: "control",
        alignItems: "center",
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: "solid",
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : null,
        cursor: "default",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        minHeight: spacing.controlHeight,
        outline: "0 !important",
        position: "relative",
        transition: "all 100ms",
        "&:hover": {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    };
};
var $2361806a25584d2d$var$Control = function Control(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, className = props.className, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $f5Egd.jsx)("div", (0, $8nd05.default)({
        ref: innerRef,
        css: getStyles("control", props),
        className: cx({
            control: true,
            "control--is-disabled": isDisabled,
            "control--is-focused": isFocused,
            "control--menu-is-open": menuIsOpen
        }, className)
    }, innerProps), children);
};
function $2361806a25584d2d$var$ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2361806a25584d2d$var$_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $2361806a25584d2d$var$ownKeys$1(Object(source), true).forEach(function(key) {
            (0, $kSlfw.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $2361806a25584d2d$var$ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $2361806a25584d2d$export$39b482c5e57630a8 = function groupCSS(_ref) {
    var spacing = _ref.theme.spacing;
    return {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $2361806a25584d2d$var$Group = function Group(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, Heading = props.Heading, headingProps = props.headingProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $f5Egd.jsx)("div", {
        css: getStyles("group", props),
        className: cx({
            group: true
        }, className)
    }, (0, $f5Egd.jsx)(Heading, (0, $8nd05.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        cx: cx
    }), label), (0, $f5Egd.jsx)("div", null, children));
};
var $2361806a25584d2d$export$f1e1789686576879 = function groupHeadingCSS(_ref2) {
    var spacing = _ref2.theme.spacing;
    return {
        label: "group",
        color: "#999",
        cursor: "default",
        display: "block",
        fontSize: "75%",
        fontWeight: "500",
        marginBottom: "0.25em",
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: "uppercase"
    };
};
var $2361806a25584d2d$var$GroupHeading = function GroupHeading(props) {
    var className = props.className, cx = props.cx, getStyles = props.getStyles, theme = props.theme, selectProps = props.selectProps, cleanProps = (0, $9X7IJ.default)(props, [
        "className",
        "cx",
        "getStyles",
        "theme",
        "selectProps"
    ]);
    return (0, $f5Egd.jsx)("div", (0, $8nd05.default)({
        css: getStyles("groupHeading", $2361806a25584d2d$var$_objectSpread$1({
            theme: theme
        }, cleanProps)),
        className: cx({
            "group-heading": true
        }, className)
    }, cleanProps));
};
function $2361806a25584d2d$var$ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2361806a25584d2d$var$_objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $2361806a25584d2d$var$ownKeys$2(Object(source), true).forEach(function(key) {
            (0, $kSlfw.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $2361806a25584d2d$var$ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $2361806a25584d2d$export$dda1d9f60106f0e9 = function inputCSS(_ref) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        visibility: isDisabled ? "hidden" : "visible",
        color: colors.neutral80
    };
};
var $2361806a25584d2d$var$inputStyle = function inputStyle(isHidden) {
    return {
        label: "input",
        background: 0,
        border: 0,
        fontSize: "inherit",
        opacity: isHidden ? 0 : 1,
        outline: 0,
        padding: 0,
        color: "inherit"
    };
};
var $2361806a25584d2d$var$Input = function Input(_ref2) {
    var className = _ref2.className, cx = _ref2.cx, getStyles = _ref2.getStyles, innerRef = _ref2.innerRef, isHidden = _ref2.isHidden, isDisabled = _ref2.isDisabled, theme = _ref2.theme, selectProps = _ref2.selectProps, props = (0, $9X7IJ.default)(_ref2, [
        "className",
        "cx",
        "getStyles",
        "innerRef",
        "isHidden",
        "isDisabled",
        "theme",
        "selectProps"
    ]);
    return (0, $f5Egd.jsx)("div", {
        css: getStyles("input", $2361806a25584d2d$var$_objectSpread$2({
            theme: theme
        }, props))
    }, (0, $f5Egd.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($83zt3))), (0, $8nd05.default)({
        className: cx({
            input: true
        }, className),
        inputRef: innerRef,
        inputStyle: $2361806a25584d2d$var$inputStyle(isHidden),
        disabled: isDisabled
    }, props)));
};
function $2361806a25584d2d$var$ownKeys$3(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2361806a25584d2d$var$_objectSpread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $2361806a25584d2d$var$ownKeys$3(Object(source), true).forEach(function(key) {
            (0, $kSlfw.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $2361806a25584d2d$var$ownKeys$3(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $2361806a25584d2d$export$ae1af26003f05816 = function multiValueCSS(_ref) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return {
        label: "multiValue",
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        display: "flex",
        margin: spacing.baseUnit / 2,
        minWidth: 0 // resolves flex/text-overflow bug
    };
};
var $2361806a25584d2d$export$ffb5f4729a158638 = function multiValueLabelCSS(_ref2) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: "85%",
        overflow: "hidden",
        padding: 3,
        paddingLeft: 6,
        textOverflow: cropWithEllipsis ? "ellipsis" : null,
        whiteSpace: "nowrap"
    };
};
var $2361806a25584d2d$export$9e5f44173e64f162 = function multiValueRemoveCSS(_ref3) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return {
        alignItems: "center",
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused && colors.dangerLight,
        display: "flex",
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ":hover": {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    };
};
var $2361806a25584d2d$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $f5Egd.jsx)("div", innerProps, children);
};
var $2361806a25584d2d$var$MultiValueContainer = $2361806a25584d2d$var$MultiValueGeneric;
var $2361806a25584d2d$var$MultiValueLabel = $2361806a25584d2d$var$MultiValueGeneric;
function $2361806a25584d2d$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $f5Egd.jsx)("div", innerProps, children || (0, $f5Egd.jsx)($2361806a25584d2d$var$CrossIcon, {
        size: 14
    }));
}
var $2361806a25584d2d$var$MultiValue = function MultiValue(props) {
    var children = props.children, className = props.className, components = props.components, cx = props.cx, data = props.data, getStyles = props.getStyles, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $f5Egd.jsx)((0, $f5Egd.ClassNames), null, function(_ref6) {
        var css = _ref6.css, emotionCx = _ref6.cx;
        return (0, $f5Egd.jsx)(Container, {
            data: data,
            innerProps: $2361806a25584d2d$var$_objectSpread$3($2361806a25584d2d$var$_objectSpread$3({}, innerProps), {}, {
                className: emotionCx(css(getStyles("multiValue", props)), cx({
                    "multi-value": true,
                    "multi-value--is-disabled": isDisabled
                }, className))
            }),
            selectProps: selectProps
        }, (0, $f5Egd.jsx)(Label, {
            data: data,
            innerProps: {
                className: emotionCx(css(getStyles("multiValueLabel", props)), cx({
                    "multi-value__label": true
                }, className))
            },
            selectProps: selectProps
        }, children), (0, $f5Egd.jsx)(Remove, {
            data: data,
            innerProps: $2361806a25584d2d$var$_objectSpread$3({
                className: emotionCx(css(getStyles("multiValueRemove", props)), cx({
                    "multi-value__remove": true
                }, className))
            }, removeProps),
            selectProps: selectProps
        }));
    });
};
$2361806a25584d2d$var$MultiValue.defaultProps = {
    cropWithEllipsis: true
};
var $2361806a25584d2d$export$2408f22a0fab9ae5 = function optionCSS(_ref) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return {
        label: "option",
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : "transparent",
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : "inherit",
        cursor: "default",
        display: "block",
        fontSize: "inherit",
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        width: "100%",
        userSelect: "none",
        WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
        // provide some affordance on touch devices
        ":active": {
            backgroundColor: !isDisabled && (isSelected ? colors.primary : colors.primary50)
        }
    };
};
var $2361806a25584d2d$var$Option = function Option(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $f5Egd.jsx)("div", (0, $8nd05.default)({
        css: getStyles("option", props),
        className: cx({
            option: true,
            "option--is-disabled": isDisabled,
            "option--is-focused": isFocused,
            "option--is-selected": isSelected
        }, className),
        ref: innerRef
    }, innerProps), children);
};
var $2361806a25584d2d$export$625550452a3fa3ec = function placeholderCSS(_ref) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return {
        label: "placeholder",
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2,
        position: "absolute",
        top: "50%",
        transform: "translateY(-50%)"
    };
};
var $2361806a25584d2d$var$Placeholder = function Placeholder(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, innerProps = props.innerProps;
    return (0, $f5Egd.jsx)("div", (0, $8nd05.default)({
        css: getStyles("placeholder", props),
        className: cx({
            placeholder: true
        }, className)
    }, innerProps), children);
};
var $2361806a25584d2d$export$3b14a55fb2447963 = function css(_ref) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return {
        label: "singleValue",
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2,
        maxWidth: "calc(100% - ".concat(spacing.baseUnit * 2, "px)"),
        overflow: "hidden",
        position: "absolute",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        top: "50%",
        transform: "translateY(-50%)"
    };
};
var $2361806a25584d2d$var$SingleValue = function SingleValue(props) {
    var children = props.children, className = props.className, cx = props.cx, getStyles = props.getStyles, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $f5Egd.jsx)("div", (0, $8nd05.default)({
        css: getStyles("singleValue", props),
        className: cx({
            "single-value": true,
            "single-value--is-disabled": isDisabled
        }, className)
    }, innerProps), children);
};
function $2361806a25584d2d$var$ownKeys$4(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2361806a25584d2d$var$_objectSpread$4(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $2361806a25584d2d$var$ownKeys$4(Object(source), true).forEach(function(key) {
            (0, $kSlfw.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $2361806a25584d2d$var$ownKeys$4(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $2361806a25584d2d$export$d66501df72047452 = {
    ClearIndicator: $2361806a25584d2d$var$ClearIndicator,
    Control: $2361806a25584d2d$var$Control,
    DropdownIndicator: $2361806a25584d2d$var$DropdownIndicator,
    DownChevron: $2361806a25584d2d$var$DownChevron,
    CrossIcon: $2361806a25584d2d$var$CrossIcon,
    Group: $2361806a25584d2d$var$Group,
    GroupHeading: $2361806a25584d2d$var$GroupHeading,
    IndicatorsContainer: $2361806a25584d2d$var$IndicatorsContainer,
    IndicatorSeparator: $2361806a25584d2d$var$IndicatorSeparator,
    Input: $2361806a25584d2d$var$Input,
    LoadingIndicator: $2361806a25584d2d$var$LoadingIndicator,
    Menu: $2361806a25584d2d$var$Menu,
    MenuList: $2361806a25584d2d$var$MenuList,
    MenuPortal: $2361806a25584d2d$var$MenuPortal,
    LoadingMessage: $2361806a25584d2d$var$LoadingMessage,
    NoOptionsMessage: $2361806a25584d2d$var$NoOptionsMessage,
    MultiValue: $2361806a25584d2d$var$MultiValue,
    MultiValueContainer: $2361806a25584d2d$var$MultiValueContainer,
    MultiValueLabel: $2361806a25584d2d$var$MultiValueLabel,
    MultiValueRemove: $2361806a25584d2d$var$MultiValueRemove,
    Option: $2361806a25584d2d$var$Option,
    Placeholder: $2361806a25584d2d$var$Placeholder,
    SelectContainer: $2361806a25584d2d$var$SelectContainer,
    SingleValue: $2361806a25584d2d$var$SingleValue,
    ValueContainer: $2361806a25584d2d$var$ValueContainer
};
var $2361806a25584d2d$export$4a5767248b18ef41 = function defaultComponents(props) {
    return $2361806a25584d2d$var$_objectSpread$4($2361806a25584d2d$var$_objectSpread$4({}, $2361806a25584d2d$export$d66501df72047452), props.components);
};

});
parcelRegister("9X7IJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $73ef9ce1c41fc0c0$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");
function $73ef9ce1c41fc0c0$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $1En50.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});

parcelRegister("hvnYt", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbe7edbf3ccb8828$export$2e2bcd8739ae039);
function $cbe7edbf3ccb8828$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}

});

parcelRegister("83zt3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $5dda1db15c8c646c$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $5dda1db15c8c646c$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $5dda1db15c8c646c$var$_react2 = $5dda1db15c8c646c$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");
var $5dda1db15c8c646c$var$_propTypes2 = $5dda1db15c8c646c$var$_interopRequireDefault($c9Z8w);
function $5dda1db15c8c646c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5dda1db15c8c646c$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $5dda1db15c8c646c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5dda1db15c8c646c$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $5dda1db15c8c646c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $5dda1db15c8c646c$var$sizerStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    visibility: "hidden",
    height: 0,
    overflow: "scroll",
    whiteSpace: "pre"
};
var $5dda1db15c8c646c$var$INPUT_PROPS_BLACKLIST = [
    "extraWidth",
    "injectStyles",
    "inputClassName",
    "inputRef",
    "inputStyle",
    "minWidth",
    "onAutosize",
    "placeholderIsMinWidth"
];
var $5dda1db15c8c646c$var$cleanInputProps = function cleanInputProps(inputProps) {
    $5dda1db15c8c646c$var$INPUT_PROPS_BLACKLIST.forEach(function(field) {
        return delete inputProps[field];
    });
    return inputProps;
};
var $5dda1db15c8c646c$var$copyStyles = function copyStyles(styles, node) {
    node.style.fontSize = styles.fontSize;
    node.style.fontFamily = styles.fontFamily;
    node.style.fontWeight = styles.fontWeight;
    node.style.fontStyle = styles.fontStyle;
    node.style.letterSpacing = styles.letterSpacing;
    node.style.textTransform = styles.textTransform;
};
var $5dda1db15c8c646c$var$isIE = typeof window !== "undefined" && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;
var $5dda1db15c8c646c$var$generateId = function generateId() {
    // we only need an auto-generated ID for stylesheet injection, which is only
    // used for IE. so if the browser is not IE, this should return undefined.
    return $5dda1db15c8c646c$var$isIE ? "_" + Math.random().toString(36).substr(2, 12) : undefined;
};
var $5dda1db15c8c646c$var$AutosizeInput = function(_Component) {
    $5dda1db15c8c646c$var$_inherits(AutosizeInput, _Component);
    $5dda1db15c8c646c$var$_createClass(AutosizeInput, null, [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var id = props.id;
                return id !== state.prevId ? {
                    inputId: id || $5dda1db15c8c646c$var$generateId(),
                    prevId: id
                } : null;
            }
        }
    ]);
    function AutosizeInput(props) {
        $5dda1db15c8c646c$var$_classCallCheck(this, AutosizeInput);
        var _this = $5dda1db15c8c646c$var$_possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));
        _this.inputRef = function(el) {
            _this.input = el;
            if (typeof _this.props.inputRef === "function") _this.props.inputRef(el);
        };
        _this.placeHolderSizerRef = function(el) {
            _this.placeHolderSizer = el;
        };
        _this.sizerRef = function(el) {
            _this.sizer = el;
        };
        _this.state = {
            inputWidth: props.minWidth,
            inputId: props.id || $5dda1db15c8c646c$var$generateId(),
            prevId: props.id
        };
        return _this;
    }
    $5dda1db15c8c646c$var$_createClass(AutosizeInput, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.mounted = true;
                this.copyInputStyles();
                this.updateInputWidth();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                if (prevState.inputWidth !== this.state.inputWidth) {
                    if (typeof this.props.onAutosize === "function") this.props.onAutosize(this.state.inputWidth);
                }
                this.updateInputWidth();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mounted = false;
            }
        },
        {
            key: "copyInputStyles",
            value: function copyInputStyles() {
                if (!this.mounted || !window.getComputedStyle) return;
                var inputStyles = this.input && window.getComputedStyle(this.input);
                if (!inputStyles) return;
                $5dda1db15c8c646c$var$copyStyles(inputStyles, this.sizer);
                if (this.placeHolderSizer) $5dda1db15c8c646c$var$copyStyles(inputStyles, this.placeHolderSizer);
            }
        },
        {
            key: "updateInputWidth",
            value: function updateInputWidth() {
                if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === "undefined") return;
                var newInputWidth = void 0;
                if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
                else newInputWidth = this.sizer.scrollWidth + 2;
                // add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
                var extraWidth = this.props.type === "number" && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
                newInputWidth += extraWidth;
                if (newInputWidth < this.props.minWidth) newInputWidth = this.props.minWidth;
                if (newInputWidth !== this.state.inputWidth) this.setState({
                    inputWidth: newInputWidth
                });
            }
        },
        {
            key: "getInput",
            value: function getInput() {
                return this.input;
            }
        },
        {
            key: "focus",
            value: function focus() {
                this.input.focus();
            }
        },
        {
            key: "blur",
            value: function blur() {
                this.input.blur();
            }
        },
        {
            key: "select",
            value: function select() {
                this.input.select();
            }
        },
        {
            key: "renderStyles",
            value: function renderStyles() {
                // this method injects styles to hide IE's clear indicator, which messes
                // with input size detection. the stylesheet is only injected when the
                // browser is IE, and can also be disabled by the `injectStyles` prop.
                var injectStyles = this.props.injectStyles;
                return $5dda1db15c8c646c$var$isIE && injectStyles ? $5dda1db15c8c646c$var$_react2.default.createElement("style", {
                    dangerouslySetInnerHTML: {
                        __html: "input#" + this.state.inputId + "::-ms-clear {display: none;}"
                    }
                }) : null;
            }
        },
        {
            key: "render",
            value: function render() {
                var sizerValue = [
                    this.props.defaultValue,
                    this.props.value,
                    ""
                ].reduce(function(previousValue, currentValue) {
                    if (previousValue !== null && previousValue !== undefined) return previousValue;
                    return currentValue;
                });
                var wrapperStyle = $5dda1db15c8c646c$var$_extends({}, this.props.style);
                if (!wrapperStyle.display) wrapperStyle.display = "inline-block";
                var inputStyle = $5dda1db15c8c646c$var$_extends({
                    boxSizing: "content-box",
                    width: this.state.inputWidth + "px"
                }, this.props.inputStyle);
                var inputProps = $5dda1db15c8c646c$var$_objectWithoutProperties(this.props, []);
                $5dda1db15c8c646c$var$cleanInputProps(inputProps);
                inputProps.className = this.props.inputClassName;
                inputProps.id = this.state.inputId;
                inputProps.style = inputStyle;
                return $5dda1db15c8c646c$var$_react2.default.createElement("div", {
                    className: this.props.className,
                    style: wrapperStyle
                }, this.renderStyles(), $5dda1db15c8c646c$var$_react2.default.createElement("input", $5dda1db15c8c646c$var$_extends({}, inputProps, {
                    ref: this.inputRef
                })), $5dda1db15c8c646c$var$_react2.default.createElement("div", {
                    ref: this.sizerRef,
                    style: $5dda1db15c8c646c$var$sizerStyle
                }, sizerValue), this.props.placeholder ? $5dda1db15c8c646c$var$_react2.default.createElement("div", {
                    ref: this.placeHolderSizerRef,
                    style: $5dda1db15c8c646c$var$sizerStyle
                }, this.props.placeholder) : null);
            }
        }
    ]);
    return AutosizeInput;
}($acw62.Component);
$5dda1db15c8c646c$var$AutosizeInput.propTypes = {
    className: $5dda1db15c8c646c$var$_propTypes2.default.string,
    defaultValue: $5dda1db15c8c646c$var$_propTypes2.default.any,
    extraWidth: $5dda1db15c8c646c$var$_propTypes2.default.oneOfType([
        $5dda1db15c8c646c$var$_propTypes2.default.number,
        $5dda1db15c8c646c$var$_propTypes2.default.string
    ]),
    id: $5dda1db15c8c646c$var$_propTypes2.default.string,
    injectStyles: $5dda1db15c8c646c$var$_propTypes2.default.bool,
    inputClassName: $5dda1db15c8c646c$var$_propTypes2.default.string,
    inputRef: $5dda1db15c8c646c$var$_propTypes2.default.func,
    inputStyle: $5dda1db15c8c646c$var$_propTypes2.default.object,
    minWidth: $5dda1db15c8c646c$var$_propTypes2.default.oneOfType([
        $5dda1db15c8c646c$var$_propTypes2.default.number,
        $5dda1db15c8c646c$var$_propTypes2.default.string
    ]),
    onAutosize: $5dda1db15c8c646c$var$_propTypes2.default.func,
    onChange: $5dda1db15c8c646c$var$_propTypes2.default.func,
    placeholder: $5dda1db15c8c646c$var$_propTypes2.default.string,
    placeholderIsMinWidth: $5dda1db15c8c646c$var$_propTypes2.default.bool,
    style: $5dda1db15c8c646c$var$_propTypes2.default.object,
    value: $5dda1db15c8c646c$var$_propTypes2.default.any // field value
};
$5dda1db15c8c646c$var$AutosizeInput.defaultProps = {
    minWidth: 1,
    injectStyles: true
};
module.exports.default = $5dda1db15c8c646c$var$AutosizeInput;

});


parcelRegister("bUCRB", function(module, exports) {

$parcel$export(module.exports, "c", () => $8ac3122ed2a8618b$export$db3b6bfb95261072);
$parcel$export(module.exports, "m", () => $8ac3122ed2a8618b$export$953cecd6e717a553);
$parcel$export(module.exports, "a", () => $8ac3122ed2a8618b$export$407448d2b89b1813);
$parcel$export(module.exports, "S", () => $8ac3122ed2a8618b$export$25ce5a424b770e84);

var $9X7IJ = parcelRequire("9X7IJ");

var $8nd05 = parcelRequire("8nd05");

var $eUqlC = parcelRequire("eUqlC");

var $kbxxf = parcelRequire("kbxxf");

var $kSlfw = parcelRequire("kSlfw");

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $hDpcU = parcelRequire("hDpcU");

var $1gYAD = parcelRequire("1gYAD");

var $9715X = parcelRequire("9715X");

var $jDKKo = parcelRequire("jDKKo");

var $acw62 = parcelRequire("acw62");

var $jk22o = parcelRequire("jk22o");

var $f5Egd = parcelRequire("f5Egd");

var $1u0KT = parcelRequire("1u0KT");

var $32kym = parcelRequire("32kym");

var $6xSYO = parcelRequire("6xSYO");
var $8ac3122ed2a8618b$var$diacritics = [
    {
        base: "A",
        letters: "A\u24B6\uFF21\xc0\xc1\xc2\u1EA6\u1EA4\u1EAA\u1EA8\xc3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xc4\u01DE\u1EA2\xc5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: "AA",
        letters: "\uA732"
    },
    {
        base: "AE",
        letters: "\xc6\u01FC\u01E2"
    },
    {
        base: "AO",
        letters: "\uA734"
    },
    {
        base: "AU",
        letters: "\uA736"
    },
    {
        base: "AV",
        letters: "\uA738\uA73A"
    },
    {
        base: "AY",
        letters: "\uA73C"
    },
    {
        base: "B",
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: "C",
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xc7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: "D",
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: "DZ",
        letters: "\u01F1\u01C4"
    },
    {
        base: "Dz",
        letters: "\u01F2\u01C5"
    },
    {
        base: "E",
        letters: "E\u24BA\uFF25\xc8\xc9\xca\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xcb\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: "F",
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: "G",
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: "H",
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: "I",
        letters: "I\u24BE\uFF29\xcc\xcd\xce\u0128\u012A\u012C\u0130\xcf\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: "J",
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: "K",
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: "L",
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: "LJ",
        letters: "\u01C7"
    },
    {
        base: "Lj",
        letters: "\u01C8"
    },
    {
        base: "M",
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: "N",
        letters: "N\u24C3\uFF2E\u01F8\u0143\xd1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: "NJ",
        letters: "\u01CA"
    },
    {
        base: "Nj",
        letters: "\u01CB"
    },
    {
        base: "O",
        letters: "O\u24C4\uFF2F\xd2\xd3\xd4\u1ED2\u1ED0\u1ED6\u1ED4\xd5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xd6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xd8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: "OI",
        letters: "\u01A2"
    },
    {
        base: "OO",
        letters: "\uA74E"
    },
    {
        base: "OU",
        letters: "\u0222"
    },
    {
        base: "P",
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: "Q",
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: "R",
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: "S",
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: "T",
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: "TZ",
        letters: "\uA728"
    },
    {
        base: "U",
        letters: "U\u24CA\uFF35\xd9\xda\xdb\u0168\u1E78\u016A\u1E7A\u016C\xdc\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: "V",
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: "VY",
        letters: "\uA760"
    },
    {
        base: "W",
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: "X",
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: "Y",
        letters: "Y\u24CE\uFF39\u1EF2\xdd\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: "Z",
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: "a",
        letters: "a\u24D0\uFF41\u1E9A\xe0\xe1\xe2\u1EA7\u1EA5\u1EAB\u1EA9\xe3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xe4\u01DF\u1EA3\xe5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: "aa",
        letters: "\uA733"
    },
    {
        base: "ae",
        letters: "\xe6\u01FD\u01E3"
    },
    {
        base: "ao",
        letters: "\uA735"
    },
    {
        base: "au",
        letters: "\uA737"
    },
    {
        base: "av",
        letters: "\uA739\uA73B"
    },
    {
        base: "ay",
        letters: "\uA73D"
    },
    {
        base: "b",
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: "c",
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xe7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: "d",
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: "dz",
        letters: "\u01F3\u01C6"
    },
    {
        base: "e",
        letters: "e\u24D4\uFF45\xe8\xe9\xea\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xeb\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: "f",
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: "g",
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: "h",
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: "hv",
        letters: "\u0195"
    },
    {
        base: "i",
        letters: "i\u24D8\uFF49\xec\xed\xee\u0129\u012B\u012D\xef\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: "j",
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: "k",
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: "l",
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: "lj",
        letters: "\u01C9"
    },
    {
        base: "m",
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: "n",
        letters: "n\u24DD\uFF4E\u01F9\u0144\xf1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: "nj",
        letters: "\u01CC"
    },
    {
        base: "o",
        letters: "o\u24DE\uFF4F\xf2\xf3\xf4\u1ED3\u1ED1\u1ED7\u1ED5\xf5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xf6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xf8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: "oi",
        letters: "\u01A3"
    },
    {
        base: "ou",
        letters: "\u0223"
    },
    {
        base: "oo",
        letters: "\uA74F"
    },
    {
        base: "p",
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: "q",
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: "r",
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: "s",
        letters: "s\u24E2\uFF53\xdf\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: "t",
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: "tz",
        letters: "\uA729"
    },
    {
        base: "u",
        letters: "u\u24E4\uFF55\xf9\xfa\xfb\u0169\u1E79\u016B\u1E7B\u016D\xfc\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: "v",
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: "vy",
        letters: "\uA761"
    },
    {
        base: "w",
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: "x",
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: "y",
        letters: "y\u24E8\uFF59\u1EF3\xfd\u0177\u1EF9\u0233\u1E8F\xff\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: "z",
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $8ac3122ed2a8618b$var$anyDiacritic = new RegExp("[" + $8ac3122ed2a8618b$var$diacritics.map(function(d) {
    return d.letters;
}).join("") + "]", "g");
var $8ac3122ed2a8618b$var$diacriticToBase = {};
for(var $8ac3122ed2a8618b$var$i = 0; $8ac3122ed2a8618b$var$i < $8ac3122ed2a8618b$var$diacritics.length; $8ac3122ed2a8618b$var$i++){
    var $8ac3122ed2a8618b$var$diacritic = $8ac3122ed2a8618b$var$diacritics[$8ac3122ed2a8618b$var$i];
    for(var $8ac3122ed2a8618b$var$j = 0; $8ac3122ed2a8618b$var$j < $8ac3122ed2a8618b$var$diacritic.letters.length; $8ac3122ed2a8618b$var$j++)$8ac3122ed2a8618b$var$diacriticToBase[$8ac3122ed2a8618b$var$diacritic.letters[$8ac3122ed2a8618b$var$j]] = $8ac3122ed2a8618b$var$diacritic.base;
}
var $8ac3122ed2a8618b$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($8ac3122ed2a8618b$var$anyDiacritic, function(match) {
        return $8ac3122ed2a8618b$var$diacriticToBase[match];
    });
};
function $8ac3122ed2a8618b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8ac3122ed2a8618b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $8ac3122ed2a8618b$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $kSlfw.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $8ac3122ed2a8618b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $8ac3122ed2a8618b$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, "");
};
var $8ac3122ed2a8618b$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $8ac3122ed2a8618b$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        var _ignoreCase$ignoreAcc = $8ac3122ed2a8618b$var$_objectSpread({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $8ac3122ed2a8618b$var$defaultStringify,
            trim: true,
            matchFrom: "any"
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $8ac3122ed2a8618b$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $8ac3122ed2a8618b$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $8ac3122ed2a8618b$var$stripDiacritics(input);
            candidate = $8ac3122ed2a8618b$var$stripDiacritics(candidate);
        }
        return matchFrom === "start" ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
function $8ac3122ed2a8618b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $8ac3122ed2a8618b$var$_ref = {
    name: "1laao21-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;"
};
var $8ac3122ed2a8618b$var$A11yText = function A11yText(props) {
    return (0, $f5Egd.jsx)("span", (0, $8nd05.default)({
        css: $8ac3122ed2a8618b$var$_ref
    }, props));
};
function $8ac3122ed2a8618b$var$DummyInput(_ref) {
    var inProp = _ref.in, out = _ref.out, onExited = _ref.onExited, appear = _ref.appear, enter = _ref.enter, exit = _ref.exit, innerRef = _ref.innerRef, emotion = _ref.emotion, props = (0, $9X7IJ.default)(_ref, [
        "in",
        "out",
        "onExited",
        "appear",
        "enter",
        "exit",
        "innerRef",
        "emotion"
    ]);
    return (0, $f5Egd.jsx)("input", (0, $8nd05.default)({
        ref: innerRef
    }, props, {
        css: /*#__PURE__*/ (0, $6xSYO.default)({
            label: "dummyInput",
            // get rid of any default styles
            background: 0,
            border: 0,
            fontSize: "inherit",
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: "transparent",
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: "relative",
            transform: "scale(0)"
        }, "")
    }));
}
function $8ac3122ed2a8618b$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $8ac3122ed2a8618b$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $jDKKo.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $jDKKo.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $9715X.default)(this, result);
    };
}
function $8ac3122ed2a8618b$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $8ac3122ed2a8618b$var$NodeResolver = /*#__PURE__*/ function(_Component) {
    (0, $1gYAD.default)(NodeResolver, _Component);
    var _super = $8ac3122ed2a8618b$var$_createSuper(NodeResolver);
    function NodeResolver() {
        (0, $6CZeq.default)(this, NodeResolver);
        return _super.apply(this, arguments);
    }
    (0, $cHPF9.default)(NodeResolver, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.props.innerRef((0, $1u0KT.findDOMNode)(this));
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.props.innerRef(null);
            }
        },
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ]);
    return NodeResolver;
}((0, $acw62.Component));
var $8ac3122ed2a8618b$var$STYLE_KEYS = [
    "boxSizing",
    "height",
    "overflow",
    "paddingRight",
    "position"
];
var $8ac3122ed2a8618b$var$LOCK_STYLES = {
    boxSizing: "border-box",
    // account for possible declaration `width: 100%;` on body
    overflow: "hidden",
    position: "relative",
    height: "100%"
};
function $8ac3122ed2a8618b$var$preventTouchMove(e) {
    e.preventDefault();
}
function $8ac3122ed2a8618b$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $8ac3122ed2a8618b$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
} // `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $8ac3122ed2a8618b$var$isTouchDevice() {
    return "ontouchstart" in window || navigator.maxTouchPoints;
}
function $8ac3122ed2a8618b$var$_createSuper$1(Derived) {
    var hasNativeReflectConstruct = $8ac3122ed2a8618b$var$_isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = (0, $jDKKo.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $jDKKo.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $9715X.default)(this, result);
    };
}
function $8ac3122ed2a8618b$var$_isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $8ac3122ed2a8618b$var$canUseDOM = !!(window.document && window.document.createElement);
var $8ac3122ed2a8618b$var$activeScrollLocks = 0;
var $8ac3122ed2a8618b$var$ScrollLock = /*#__PURE__*/ function(_Component) {
    (0, $1gYAD.default)(ScrollLock, _Component);
    var _super = $8ac3122ed2a8618b$var$_createSuper$1(ScrollLock);
    function ScrollLock() {
        var _this;
        (0, $6CZeq.default)(this, ScrollLock);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.originalStyles = {};
        _this.listenerOptions = {
            capture: false,
            passive: false
        };
        return _this;
    }
    (0, $cHPF9.default)(ScrollLock, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this2 = this;
                if (!$8ac3122ed2a8618b$var$canUseDOM) return;
                var _this$props = this.props, accountForScrollbars = _this$props.accountForScrollbars, touchScrollTarget = _this$props.touchScrollTarget;
                var target = document.body;
                var targetStyle = target && target.style;
                if (accountForScrollbars) // store any styles already applied to the body
                $8ac3122ed2a8618b$var$STYLE_KEYS.forEach(function(key) {
                    var val = targetStyle && targetStyle[key];
                    _this2.originalStyles[key] = val;
                });
                 // apply the lock styles and padding if this is the first scroll lock
                if (accountForScrollbars && $8ac3122ed2a8618b$var$activeScrollLocks < 1) {
                    var currentPadding = parseInt(this.originalStyles.paddingRight, 10) || 0;
                    var clientWidth = document.body ? document.body.clientWidth : 0;
                    var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
                    Object.keys($8ac3122ed2a8618b$var$LOCK_STYLES).forEach(function(key) {
                        var val = $8ac3122ed2a8618b$var$LOCK_STYLES[key];
                        if (targetStyle) targetStyle[key] = val;
                    });
                    if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
                } // account for touch devices
                if (target && $8ac3122ed2a8618b$var$isTouchDevice()) {
                    // Mobile Safari ignores { overflow: hidden } declaration on the body.
                    target.addEventListener("touchmove", $8ac3122ed2a8618b$var$preventTouchMove, this.listenerOptions); // Allow scroll on provided target
                    if (touchScrollTarget) {
                        touchScrollTarget.addEventListener("touchstart", $8ac3122ed2a8618b$var$preventInertiaScroll, this.listenerOptions);
                        touchScrollTarget.addEventListener("touchmove", $8ac3122ed2a8618b$var$allowTouchMove, this.listenerOptions);
                    }
                } // increment active scroll locks
                $8ac3122ed2a8618b$var$activeScrollLocks += 1;
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var _this3 = this;
                if (!$8ac3122ed2a8618b$var$canUseDOM) return;
                var _this$props2 = this.props, accountForScrollbars = _this$props2.accountForScrollbars, touchScrollTarget = _this$props2.touchScrollTarget;
                var target = document.body;
                var targetStyle = target && target.style; // safely decrement active scroll locks
                $8ac3122ed2a8618b$var$activeScrollLocks = Math.max($8ac3122ed2a8618b$var$activeScrollLocks - 1, 0); // reapply original body styles, if any
                if (accountForScrollbars && $8ac3122ed2a8618b$var$activeScrollLocks < 1) $8ac3122ed2a8618b$var$STYLE_KEYS.forEach(function(key) {
                    var val = _this3.originalStyles[key];
                    if (targetStyle) targetStyle[key] = val;
                });
                 // remove touch listeners
                if (target && $8ac3122ed2a8618b$var$isTouchDevice()) {
                    target.removeEventListener("touchmove", $8ac3122ed2a8618b$var$preventTouchMove, this.listenerOptions);
                    if (touchScrollTarget) {
                        touchScrollTarget.removeEventListener("touchstart", $8ac3122ed2a8618b$var$preventInertiaScroll, this.listenerOptions);
                        touchScrollTarget.removeEventListener("touchmove", $8ac3122ed2a8618b$var$allowTouchMove, this.listenerOptions);
                    }
                }
            }
        },
        {
            key: "render",
            value: function render() {
                return null;
            }
        }
    ]);
    return ScrollLock;
}((0, $acw62.Component));
$8ac3122ed2a8618b$var$ScrollLock.defaultProps = {
    accountForScrollbars: true
};
function $8ac3122ed2a8618b$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
function $8ac3122ed2a8618b$var$_createSuper$2(Derived) {
    var hasNativeReflectConstruct = $8ac3122ed2a8618b$var$_isNativeReflectConstruct$2();
    return function _createSuperInternal() {
        var Super = (0, $jDKKo.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $jDKKo.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $9715X.default)(this, result);
    };
}
function $8ac3122ed2a8618b$var$_isNativeReflectConstruct$2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $8ac3122ed2a8618b$var$_ref$1 = {
    name: "1dsbpcp",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0;"
};
// NOTE:
// We shouldn't need this after updating to React v16.3.0, which introduces:
// - createRef() https://reactjs.org/docs/react-api.html#reactcreateref
// - forwardRef() https://reactjs.org/docs/react-api.html#reactforwardref
var $8ac3122ed2a8618b$var$ScrollBlock = /*#__PURE__*/ function(_PureComponent) {
    (0, $1gYAD.default)(ScrollBlock, _PureComponent);
    var _super = $8ac3122ed2a8618b$var$_createSuper$2(ScrollBlock);
    function ScrollBlock() {
        var _this;
        (0, $6CZeq.default)(this, ScrollBlock);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.state = {
            touchScrollTarget: null
        };
        _this.getScrollTarget = function(ref) {
            if (ref === _this.state.touchScrollTarget) return;
            _this.setState({
                touchScrollTarget: ref
            });
        };
        _this.blurSelectInput = function() {
            if (document.activeElement) document.activeElement.blur();
        };
        return _this;
    }
    (0, $cHPF9.default)(ScrollBlock, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, children = _this$props.children, isEnabled = _this$props.isEnabled;
                var touchScrollTarget = this.state.touchScrollTarget; // bail early if not enabled
                if (!isEnabled) return children;
                /*
       * Div
       * ------------------------------
       * blocks scrolling on non-body elements behind the menu
        * NodeResolver
       * ------------------------------
       * we need a reference to the scrollable element to "unlock" scroll on
       * mobile devices
        * ScrollLock
       * ------------------------------
       * actually does the scroll locking
       */ return (0, $f5Egd.jsx)("div", null, (0, $f5Egd.jsx)("div", {
                    onClick: this.blurSelectInput,
                    css: $8ac3122ed2a8618b$var$_ref$1
                }), (0, $f5Egd.jsx)($8ac3122ed2a8618b$var$NodeResolver, {
                    innerRef: this.getScrollTarget
                }, children), touchScrollTarget ? (0, $f5Egd.jsx)($8ac3122ed2a8618b$var$ScrollLock, {
                    touchScrollTarget: touchScrollTarget
                }) : null);
            }
        }
    ]);
    return ScrollBlock;
}((0, $acw62.PureComponent));
function $8ac3122ed2a8618b$var$_createSuper$3(Derived) {
    var hasNativeReflectConstruct = $8ac3122ed2a8618b$var$_isNativeReflectConstruct$3();
    return function _createSuperInternal() {
        var Super = (0, $jDKKo.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $jDKKo.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $9715X.default)(this, result);
    };
}
function $8ac3122ed2a8618b$var$_isNativeReflectConstruct$3() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $8ac3122ed2a8618b$var$ScrollCaptor = /*#__PURE__*/ function(_Component) {
    (0, $1gYAD.default)(ScrollCaptor, _Component);
    var _super = $8ac3122ed2a8618b$var$_createSuper$3(ScrollCaptor);
    function ScrollCaptor() {
        var _this;
        (0, $6CZeq.default)(this, ScrollCaptor);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.isBottom = false;
        _this.isTop = false;
        _this.scrollTarget = void 0;
        _this.touchStart = void 0;
        _this.cancelScroll = function(event) {
            event.preventDefault();
            event.stopPropagation();
        };
        _this.handleEventDelta = function(event, delta) {
            var _this$props = _this.props, onBottomArrive = _this$props.onBottomArrive, onBottomLeave = _this$props.onBottomLeave, onTopArrive = _this$props.onTopArrive, onTopLeave = _this$props.onTopLeave;
            var _this$scrollTarget = _this.scrollTarget, scrollTop = _this$scrollTarget.scrollTop, scrollHeight = _this$scrollTarget.scrollHeight, clientHeight = _this$scrollTarget.clientHeight;
            var target = _this.scrollTarget;
            var isDeltaPositive = delta > 0;
            var availableScroll = scrollHeight - clientHeight - scrollTop;
            var shouldCancelScroll = false; // reset bottom/top flags
            if (availableScroll > delta && _this.isBottom) {
                if (onBottomLeave) onBottomLeave(event);
                _this.isBottom = false;
            }
            if (isDeltaPositive && _this.isTop) {
                if (onTopLeave) onTopLeave(event);
                _this.isTop = false;
            } // bottom limit
            if (isDeltaPositive && delta > availableScroll) {
                if (onBottomArrive && !_this.isBottom) onBottomArrive(event);
                target.scrollTop = scrollHeight;
                shouldCancelScroll = true;
                _this.isBottom = true; // top limit
            } else if (!isDeltaPositive && -delta > scrollTop) {
                if (onTopArrive && !_this.isTop) onTopArrive(event);
                target.scrollTop = 0;
                shouldCancelScroll = true;
                _this.isTop = true;
            } // cancel scroll
            if (shouldCancelScroll) _this.cancelScroll(event);
        };
        _this.onWheel = function(event) {
            _this.handleEventDelta(event, event.deltaY);
        };
        _this.onTouchStart = function(event) {
            // set touch start so we can calculate touchmove delta
            _this.touchStart = event.changedTouches[0].clientY;
        };
        _this.onTouchMove = function(event) {
            var deltaY = _this.touchStart - event.changedTouches[0].clientY;
            _this.handleEventDelta(event, deltaY);
        };
        _this.getScrollTarget = function(ref) {
            _this.scrollTarget = ref;
        };
        return _this;
    }
    (0, $cHPF9.default)(ScrollCaptor, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListening(this.scrollTarget);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListening(this.scrollTarget);
            }
        },
        {
            key: "startListening",
            value: function startListening(el) {
                // bail early if no element is available to attach to
                if (!el) return; // all the if statements are to appease Flow 😢
                if (typeof el.addEventListener === "function") el.addEventListener("wheel", this.onWheel, false);
                if (typeof el.addEventListener === "function") el.addEventListener("touchstart", this.onTouchStart, false);
                if (typeof el.addEventListener === "function") el.addEventListener("touchmove", this.onTouchMove, false);
            }
        },
        {
            key: "stopListening",
            value: function stopListening(el) {
                if (!el) return; // all the if statements are to appease Flow 😢
                if (typeof el.removeEventListener === "function") el.removeEventListener("wheel", this.onWheel, false);
                if (typeof el.removeEventListener === "function") el.removeEventListener("touchstart", this.onTouchStart, false);
                if (typeof el.removeEventListener === "function") el.removeEventListener("touchmove", this.onTouchMove, false);
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ac3122ed2a8618b$var$NodeResolver, {
                    innerRef: this.getScrollTarget
                }, this.props.children);
            }
        }
    ]);
    return ScrollCaptor;
}((0, $acw62.Component));
function $8ac3122ed2a8618b$var$ScrollCaptorSwitch(_ref) {
    var _ref$isEnabled = _ref.isEnabled, isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled, props = (0, $9X7IJ.default)(_ref, [
        "isEnabled"
    ]);
    return isEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ac3122ed2a8618b$var$ScrollCaptor, props) : props.children;
}
var $8ac3122ed2a8618b$var$instructionsAriaMessage = function instructionsAriaMessage(event) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var isSearchable = context.isSearchable, isMulti = context.isMulti, label = context.label, isDisabled = context.isDisabled, tabSelectsValue = context.tabSelectsValue;
    switch(event){
        case "menu":
            return "Use Up and Down to choose options".concat(isDisabled ? "" : ", press Enter to select the currently focused option", ", press Escape to exit the menu").concat(tabSelectsValue ? ", press Tab to select the option and exit the menu" : "", ".");
        case "input":
            return "".concat(label ? label : "Select", " is focused ").concat(isSearchable ? ",type to refine list" : "", ", press Down to open the menu, ").concat(isMulti ? " press left to focus selected values" : "");
        case "value":
            return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
    }
};
var $8ac3122ed2a8618b$var$valueEventAriaMessage = function valueEventAriaMessage(event, context) {
    var value = context.value, isDisabled = context.isDisabled;
    if (!value) return;
    switch(event){
        case "deselect-option":
        case "pop-value":
        case "remove-value":
            return "option ".concat(value, ", deselected.");
        case "select-option":
            return isDisabled ? "option ".concat(value, " is disabled. Select another option.") : "option ".concat(value, ", selected.");
    }
};
var $8ac3122ed2a8618b$var$valueFocusAriaMessage = function valueFocusAriaMessage(_ref) {
    var focusedValue = _ref.focusedValue, getOptionLabel = _ref.getOptionLabel, selectValue = _ref.selectValue;
    return "value ".concat(getOptionLabel(focusedValue), " focused, ").concat(selectValue.indexOf(focusedValue) + 1, " of ").concat(selectValue.length, ".");
};
var $8ac3122ed2a8618b$var$optionFocusAriaMessage = function optionFocusAriaMessage(_ref2) {
    var focusedOption = _ref2.focusedOption, getOptionLabel = _ref2.getOptionLabel, options = _ref2.options;
    return "option ".concat(getOptionLabel(focusedOption), " focused").concat(focusedOption.isDisabled ? " disabled" : "", ", ").concat(options.indexOf(focusedOption) + 1, " of ").concat(options.length, ".");
};
var $8ac3122ed2a8618b$var$resultsAriaMessage = function resultsAriaMessage(_ref3) {
    var inputValue = _ref3.inputValue, screenReaderMessage = _ref3.screenReaderMessage;
    return "".concat(screenReaderMessage).concat(inputValue ? " for search term " + inputValue : "", ".");
};
var $8ac3122ed2a8618b$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $8ac3122ed2a8618b$var$getOptionLabel = function getOptionLabel(option) {
    return option.label;
};
var $8ac3122ed2a8618b$var$getOptionValue = function getOptionValue(option) {
    return option.value;
};
var $8ac3122ed2a8618b$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
function $8ac3122ed2a8618b$var$ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8ac3122ed2a8618b$var$_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $8ac3122ed2a8618b$var$ownKeys$1(Object(source), true).forEach(function(key) {
            (0, $kSlfw.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $8ac3122ed2a8618b$var$ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $8ac3122ed2a8618b$var$defaultStyles = {
    clearIndicator: (0, $32kym.c),
    container: (0, $32kym.a),
    control: (0, $32kym.b),
    dropdownIndicator: (0, $32kym.d),
    group: (0, $32kym.g),
    groupHeading: (0, $32kym.e),
    indicatorsContainer: (0, $32kym.i),
    indicatorSeparator: (0, $32kym.f),
    input: (0, $32kym.h),
    loadingIndicator: (0, $32kym.l),
    loadingMessage: (0, $32kym.j),
    menu: (0, $32kym.m),
    menuList: (0, $32kym.k),
    menuPortal: (0, $32kym.n),
    multiValue: (0, $32kym.o),
    multiValueLabel: (0, $32kym.p),
    multiValueRemove: (0, $32kym.q),
    noOptionsMessage: (0, $32kym.r),
    option: (0, $32kym.s),
    placeholder: (0, $32kym.t),
    singleValue: (0, $32kym.u),
    valueContainer: (0, $32kym.v)
}; // Merge Utility
// Allows consumers to extend a base Select with additional styles
function $8ac3122ed2a8618b$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = $8ac3122ed2a8618b$var$_objectSpread$1({}, source); // massage in target styles
    Object.keys(target).forEach(function(key) {
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $8ac3122ed2a8618b$var$colors = {
    primary: "#2684FF",
    primary75: "#4C9AFF",
    primary50: "#B2D4FF",
    primary25: "#DEEBFF",
    danger: "#DE350B",
    dangerLight: "#FFBDAD",
    neutral0: "hsl(0, 0%, 100%)",
    neutral5: "hsl(0, 0%, 95%)",
    neutral10: "hsl(0, 0%, 90%)",
    neutral20: "hsl(0, 0%, 80%)",
    neutral30: "hsl(0, 0%, 70%)",
    neutral40: "hsl(0, 0%, 60%)",
    neutral50: "hsl(0, 0%, 50%)",
    neutral60: "hsl(0, 0%, 40%)",
    neutral70: "hsl(0, 0%, 30%)",
    neutral80: "hsl(0, 0%, 20%)",
    neutral90: "hsl(0, 0%, 10%)"
};
var $8ac3122ed2a8618b$var$borderRadius = 4; // Used to calculate consistent margin/padding on elements
var $8ac3122ed2a8618b$var$baseUnit = 4; // The minimum height of the control
var $8ac3122ed2a8618b$var$controlHeight = 38; // The amount of space between the control and menu */
var $8ac3122ed2a8618b$var$menuGutter = $8ac3122ed2a8618b$var$baseUnit * 2;
var $8ac3122ed2a8618b$var$spacing = {
    baseUnit: $8ac3122ed2a8618b$var$baseUnit,
    controlHeight: $8ac3122ed2a8618b$var$controlHeight,
    menuGutter: $8ac3122ed2a8618b$var$menuGutter
};
var $8ac3122ed2a8618b$export$407448d2b89b1813 = {
    borderRadius: $8ac3122ed2a8618b$var$borderRadius,
    colors: $8ac3122ed2a8618b$var$colors,
    spacing: $8ac3122ed2a8618b$var$spacing
};
function $8ac3122ed2a8618b$var$ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $8ac3122ed2a8618b$var$_objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $8ac3122ed2a8618b$var$ownKeys$2(Object(source), true).forEach(function(key) {
            (0, $kSlfw.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $8ac3122ed2a8618b$var$ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $8ac3122ed2a8618b$var$_createSuper$4(Derived) {
    var hasNativeReflectConstruct = $8ac3122ed2a8618b$var$_isNativeReflectConstruct$4();
    return function _createSuperInternal() {
        var Super = (0, $jDKKo.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $jDKKo.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $9715X.default)(this, result);
    };
}
function $8ac3122ed2a8618b$var$_isNativeReflectConstruct$4() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $8ac3122ed2a8618b$export$4368d992c4eafac0 = {
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $32kym.w)(),
    captureMenuScroll: !(0, $32kym.w)(),
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $8ac3122ed2a8618b$export$db3b6bfb95261072(),
    formatGroupLabel: $8ac3122ed2a8618b$var$formatGroupLabel,
    getOptionLabel: $8ac3122ed2a8618b$var$getOptionLabel,
    getOptionValue: $8ac3122ed2a8618b$var$getOptionValue,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $8ac3122ed2a8618b$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return "Loading...";
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: "bottom",
    menuPosition: "absolute",
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $32kym.x)(),
    noOptionsMessage: function noOptionsMessage() {
        return "No options";
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: "Select...",
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? "s" : "", " available");
    },
    styles: {},
    tabIndex: "0",
    tabSelectsValue: true
};
var $8ac3122ed2a8618b$var$instanceId = 1;
var $8ac3122ed2a8618b$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $1gYAD.default)(Select, _Component);
    var _super = $8ac3122ed2a8618b$var$_createSuper$4(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $6CZeq.default)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaLiveSelection: "",
            ariaLiveContext: "",
            focusedOption: null,
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            menuOptions: {
                render: [],
                focusable: []
            },
            selectValue: []
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.clearFocusValueOnUpdate = false;
        _this.commonProps = void 0;
        _this.components = void 0;
        _this.hasGroups = false;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.inputIsHiddenAfterUpdate = void 0;
        _this.instancePrefix = "";
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.cacheComponents = function(components) {
            _this.components = (0, $32kym.y)({
                components: components
            });
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            onChange(newValue, $8ac3122ed2a8618b$var$_objectSpread$2($8ac3122ed2a8618b$var$_objectSpread$2({}, actionMeta), {}, {
                name: name
            }));
        };
        _this.setValue = function(newValue) {
            var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "set-value";
            var option = arguments.length > 2 ? arguments[2] : undefined;
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti;
            _this.onInputChange("", {
                action: "set-value"
            });
            if (closeMenuOnSelect) {
                _this.inputIsHiddenAfterUpdate = !isMulti;
                _this.onMenuClose();
            } // when the select value should change, we should reset focusedValue
            _this.clearFocusValueOnUpdate = true;
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti;
            var selectValue = _this.state.selectValue;
            if (isMulti) {
                if (_this.isOptionSelected(newValue, selectValue)) {
                    var candidate = _this.getOptionValue(newValue);
                    _this.setValue(selectValue.filter(function(i) {
                        return _this.getOptionValue(i) !== candidate;
                    }), "deselect-option", newValue);
                    _this.announceAriaLiveSelection({
                        event: "deselect-option",
                        context: {
                            value: _this.getOptionLabel(newValue)
                        }
                    });
                } else if (!_this.isOptionDisabled(newValue, selectValue)) {
                    _this.setValue([].concat((0, $kbxxf.default)(selectValue), [
                        newValue
                    ]), "select-option", newValue);
                    _this.announceAriaLiveSelection({
                        event: "select-option",
                        context: {
                            value: _this.getOptionLabel(newValue)
                        }
                    });
                } else // announce that option is disabled
                _this.announceAriaLiveSelection({
                    event: "select-option",
                    context: {
                        value: _this.getOptionLabel(newValue),
                        isDisabled: true
                    }
                });
            } else if (!_this.isOptionDisabled(newValue, selectValue)) {
                _this.setValue(newValue, "select-option");
                _this.announceAriaLiveSelection({
                    event: "select-option",
                    context: {
                        value: _this.getOptionLabel(newValue)
                    }
                });
            } else // announce that option is disabled
            _this.announceAriaLiveSelection({
                event: "select-option",
                context: {
                    value: _this.getOptionLabel(newValue),
                    isDisabled: true
                }
            });
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValue = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            _this.onChange(newValue.length ? newValue : null, {
                action: "remove-value",
                removedValue: removedValue
            });
            _this.announceAriaLiveSelection({
                event: "remove-value",
                context: {
                    value: removedValue ? _this.getOptionLabel(removedValue) : ""
                }
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            _this.onChange(null, {
                action: "clear"
            });
        };
        _this.popValue = function() {
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValue = selectValue.slice(0, selectValue.length - 1);
            _this.announceAriaLiveSelection({
                event: "pop-value",
                context: {
                    value: lastSelectedValue ? _this.getOptionLabel(lastSelectedValue) : ""
                }
            });
            _this.onChange(newValue.length ? newValue : null, {
                action: "pop-value",
                removedValue: lastSelectedValue
            });
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $32kym.z).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return _this.props.getOptionLabel(data);
        };
        _this.getOptionValue = function(data) {
            return _this.props.getOptionValue(data);
        };
        _this.getStyles = function(key, props) {
            var base = $8ac3122ed2a8618b$var$defaultStyles[key](props);
            base.boxSizing = "border-box";
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getElementId = function(element) {
            return "".concat(_this.instancePrefix, "-").concat(element);
        };
        _this.getActiveDescendentId = function() {
            var menuIsOpen = _this.props.menuIsOpen;
            var _this$state = _this.state, menuOptions = _this$state.menuOptions, focusedOption = _this$state.focusedOption;
            if (!focusedOption || !menuIsOpen) return undefined;
            var index = menuOptions.focusable.indexOf(focusedOption);
            var option = menuOptions.render[index];
            return option && option.key;
        };
        _this.announceAriaLiveSelection = function(_ref2) {
            var event = _ref2.event, context = _ref2.context;
            _this.setState({
                ariaLiveSelection: $8ac3122ed2a8618b$var$valueEventAriaMessage(event, context)
            });
        };
        _this.announceAriaLiveContext = function(_ref3) {
            var event = _ref3.event, context = _ref3.context;
            _this.setState({
                ariaLiveContext: $8ac3122ed2a8618b$var$instructionsAriaMessage(event, $8ac3122ed2a8618b$var$_objectSpread$2($8ac3122ed2a8618b$var$_objectSpread$2({}, context), {}, {
                    label: _this.props["aria-label"]
                }))
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu("first");
            } else if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") _this.onMenuClose();
            if (event.target.tagName !== "INPUT" && event.target.tagName !== "TEXTAREA") event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.inputIsHiddenAfterUpdate = !isMulti;
                _this.onMenuClose();
            } else _this.openMenu("first");
            event.preventDefault();
            event.stopPropagation();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === "mousedown" && event.button !== 0) return;
            _this.clearValue();
            event.stopPropagation();
            _this.openAfterFocus = false;
            if (event.type === "touchend") _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === "boolean") {
                if (event.target instanceof HTMLElement && (0, $32kym.A)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === "function") {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref4) {
            var touches = _ref4.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref5) {
            var touches = _ref5.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return; // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
             // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var inputValue = event.currentTarget.value;
            _this.inputIsHiddenAfterUpdate = false;
            _this.onInputChange(inputValue, {
                action: "input-change"
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            var _this$props5 = _this.props, isSearchable = _this$props5.isSearchable, isMulti = _this$props5.isMulti;
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.inputIsHiddenAfterUpdate = false;
            _this.announceAriaLiveContext({
                event: "input",
                context: {
                    isSearchable: isSearchable,
                    isMulti: isMulti
                }
            });
            _this.setState({
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu("first");
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange("", {
                action: "input-blur"
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            _this.setState({
                focusedOption: focusedOption
            });
        };
        _this.shouldHideSelectedOptions = function() {
            var _this$props6 = _this.props, hideSelectedOptions = _this$props6.hideSelectedOptions, isMulti = _this$props6.isMulti;
            if (hideSelectedOptions === undefined) return isMulti;
            return hideSelectedOptions;
        };
        _this.onKeyDown = function(event) {
            var _this$props7 = _this.props, isMulti = _this$props7.isMulti, backspaceRemovesValue = _this$props7.backspaceRemovesValue, escapeClearsValue = _this$props7.escapeClearsValue, inputValue = _this$props7.inputValue, isClearable = _this$props7.isClearable, isDisabled = _this$props7.isDisabled, menuIsOpen = _this$props7.menuIsOpen, onKeyDown = _this$props7.onKeyDown, tabSelectsValue = _this$props7.tabSelectsValue, openMenuOnFocus = _this$props7.openMenuOnFocus;
            var _this$state2 = _this.state, focusedOption = _this$state2.focusedOption, focusedValue = _this$state2.focusedValue, selectValue = _this$state2.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === "function") {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            } // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case "ArrowLeft":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("previous");
                    break;
                case "ArrowRight":
                    if (!isMulti || inputValue) return;
                    _this.focusValue("next");
                    break;
                case "Delete":
                case "Backspace":
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case "Tab":
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case "Enter":
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case "Escape":
                    if (menuIsOpen) {
                        _this.inputIsHiddenAfterUpdate = false;
                        _this.onInputChange("", {
                            action: "menu-close"
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case " ":
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu("first");
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case "ArrowUp":
                    if (menuIsOpen) _this.focusOption("up");
                    else _this.openMenu("last");
                    break;
                case "ArrowDown":
                    if (menuIsOpen) _this.focusOption("down");
                    else _this.openMenu("first");
                    break;
                case "PageUp":
                    if (!menuIsOpen) return;
                    _this.focusOption("pageup");
                    break;
                case "PageDown":
                    if (!menuIsOpen) return;
                    _this.focusOption("pagedown");
                    break;
                case "Home":
                    if (!menuIsOpen) return;
                    _this.focusOption("first");
                    break;
                case "End":
                    if (!menuIsOpen) return;
                    _this.focusOption("last");
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.buildMenuOptions = function(props, selectValue) {
            var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? "" : _props$inputValue, options = props.options;
            var toOption = function toOption(option, id) {
                var isDisabled = _this.isOptionDisabled(option, selectValue);
                var isSelected = _this.isOptionSelected(option, selectValue);
                var label = _this.getOptionLabel(option);
                var value = _this.getOptionValue(option);
                if (_this.shouldHideSelectedOptions() && isSelected || !_this.filterOption({
                    label: label,
                    value: value,
                    data: option
                }, inputValue)) return;
                var onHover = isDisabled ? undefined : function() {
                    return _this.onOptionHover(option);
                };
                var onSelect = isDisabled ? undefined : function() {
                    return _this.selectOption(option);
                };
                var optionId = "".concat(_this.getElementId("option"), "-").concat(id);
                return {
                    innerProps: {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1
                    },
                    data: option,
                    isDisabled: isDisabled,
                    isSelected: isSelected,
                    key: optionId,
                    label: label,
                    type: "option",
                    value: value
                };
            };
            return options.reduce(function(acc, item, itemIndex) {
                if (item.options) {
                    // TODO needs a tidier implementation
                    if (!_this.hasGroups) _this.hasGroups = true;
                    var items = item.options;
                    var children = items.map(function(child, i) {
                        var option = toOption(child, "".concat(itemIndex, "-").concat(i));
                        if (option) acc.focusable.push(child);
                        return option;
                    }).filter(Boolean);
                    if (children.length) {
                        var groupId = "".concat(_this.getElementId("group"), "-").concat(itemIndex);
                        acc.render.push({
                            type: "group",
                            key: groupId,
                            data: item,
                            options: children
                        });
                    }
                } else {
                    var option = toOption(item, "".concat(itemIndex));
                    if (option) {
                        acc.render.push(option);
                        acc.focusable.push(item);
                    }
                }
                return acc;
            }, {
                render: [],
                focusable: []
            });
        };
        var _value = _props.value;
        _this.cacheComponents = (0, $jk22o.default)(_this.cacheComponents, (0, $32kym.B)).bind((0, $hDpcU.default)(_this));
        _this.cacheComponents(_props.components);
        _this.instancePrefix = "react-select-" + (_this.props.instanceId || ++$8ac3122ed2a8618b$var$instanceId);
        var _selectValue = (0, $32kym.C)(_value);
        _this.buildMenuOptions = (0, $jk22o.default)(_this.buildMenuOptions, function(newArgs, lastArgs) {
            var _ref6 = newArgs, _ref7 = (0, $eUqlC.default)(_ref6, 2), newProps = _ref7[0], newSelectValue = _ref7[1];
            var _ref8 = lastArgs, _ref9 = (0, $eUqlC.default)(_ref8, 2), lastProps = _ref9[0], lastSelectValue = _ref9[1];
            return newSelectValue === lastSelectValue && newProps.inputValue === lastProps.inputValue && newProps.options === lastProps.options;
        }).bind((0, $hDpcU.default)(_this));
        var _menuOptions = _props.menuIsOpen ? _this.buildMenuOptions(_props, _selectValue) : {
            render: [],
            focusable: []
        };
        _this.state.menuOptions = _menuOptions;
        _this.state.selectValue = _selectValue;
        return _this;
    }
    (0, $cHPF9.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener("scroll", this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
            }
        },
        {
            key: "UNSAFE_componentWillReceiveProps",
            value: function UNSAFE_componentWillReceiveProps(nextProps) {
                var _this$props8 = this.props, options = _this$props8.options, value = _this$props8.value, menuIsOpen = _this$props8.menuIsOpen, inputValue = _this$props8.inputValue; // re-cache custom components
                this.cacheComponents(nextProps.components); // rebuild the menu options
                if (nextProps.value !== value || nextProps.options !== options || nextProps.menuIsOpen !== menuIsOpen || nextProps.inputValue !== inputValue) {
                    var selectValue = (0, $32kym.C)(nextProps.value);
                    var menuOptions = nextProps.menuIsOpen ? this.buildMenuOptions(nextProps, selectValue) : {
                        render: [],
                        focusable: []
                    };
                    var focusedValue = this.getNextFocusedValue(selectValue);
                    var focusedOption = this.getNextFocusedOption(menuOptions.focusable);
                    this.setState({
                        menuOptions: menuOptions,
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedValue: focusedValue
                    });
                } // some updates should toggle the state of the input visibility
                if (this.inputIsHiddenAfterUpdate != null) {
                    this.setState({
                        inputIsHidden: this.inputIsHiddenAfterUpdate
                    });
                    delete this.inputIsHiddenAfterUpdate;
                }
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props9 = this.props, isDisabled = _this$props9.isDisabled, menuIsOpen = _this$props9.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programatically disabled while focused
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                 // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $32kym.D)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener("scroll", this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            // ==============================
            // Consumer Handlers
            // ==============================
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                var _this$props10 = this.props, isSearchable = _this$props10.isSearchable, isMulti = _this$props10.isMulti;
                this.announceAriaLiveContext({
                    event: "input",
                    context: {
                        isSearchable: isSearchable,
                        isMulti: isMulti
                    }
                });
                this.onInputChange("", {
                    action: "menu-close"
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            } // ==============================
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            } // aliased for consumers
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, isFocused = _this$state3.isFocused;
                var menuOptions = this.buildMenuOptions(this.props, selectValue);
                var _this$props11 = this.props, isMulti = _this$props11.isMulti, tabSelectsValue = _this$props11.tabSelectsValue;
                var openAtIndex = focusOption === "first" ? 0 : menuOptions.focusable.length - 1;
                if (!isMulti) {
                    var selectedIndex = menuOptions.focusable.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                } // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.inputIsHiddenAfterUpdate = false;
                this.setState({
                    menuOptions: menuOptions,
                    focusedValue: null,
                    focusedOption: menuOptions.focusable[openAtIndex]
                }, function() {
                    _this2.onMenuOpen();
                    _this2.announceAriaLiveContext({
                        event: "menu",
                        context: {
                            tabSelectsValue: tabSelectsValue
                        }
                    });
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$props12 = this.props, isMulti = _this$props12.isMulti, isSearchable = _this$props12.isSearchable;
                var _this$state4 = this.state, selectValue = _this$state4.selectValue, focusedValue = _this$state4.focusedValue; // Only multiselects support value focusing
                if (!isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) {
                    focusedIndex = -1;
                    this.announceAriaLiveContext({
                        event: "value"
                    });
                }
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case "previous":
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case "next":
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                if (nextFocus === -1) this.announceAriaLiveContext({
                    event: "input",
                    context: {
                        isSearchable: isSearchable,
                        isMulti: isMulti
                    }
                });
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "first";
                var _this$props13 = this.props, pageSize = _this$props13.pageSize, tabSelectsValue = _this$props13.tabSelectsValue;
                var _this$state5 = this.state, focusedOption = _this$state5.focusedOption, menuOptions = _this$state5.menuOptions;
                var options = menuOptions.focusable;
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) {
                    focusedIndex = -1;
                    this.announceAriaLiveContext({
                        event: "menu",
                        context: {
                            tabSelectsValue: tabSelectsValue
                        }
                    });
                }
                if (direction === "up") nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === "down") nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === "pageup") {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === "pagedown") {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === "last") nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null
                });
                this.announceAriaLiveContext({
                    event: "menu",
                    context: {
                        isDisabled: $8ac3122ed2a8618b$var$isOptionDisabled(options[nextFocus]),
                        tabSelectsValue: tabSelectsValue
                    }
                });
            }
        },
        {
            key: "getTheme",
            // ==============================
            // Getters
            // ==============================
            value: function getTheme() {
                // Use the default theme if there are no customizations.
                if (!this.props.theme) return $8ac3122ed2a8618b$export$407448d2b89b1813;
                 // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === "function") return this.props.theme($8ac3122ed2a8618b$export$407448d2b89b1813);
                 // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return $8ac3122ed2a8618b$var$_objectSpread$2($8ac3122ed2a8618b$var$_objectSpread$2({}, $8ac3122ed2a8618b$export$407448d2b89b1813), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getValue = this.getValue, setValue = this.setValue, selectOption = this.selectOption, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    cx: cx,
                    clearValue: clearValue,
                    getStyles: getStyles,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    setValue: setValue,
                    selectProps: props,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "getNextFocusedValue",
            value: function getNextFocusedValue(nextSelectValue) {
                if (this.clearFocusValueOnUpdate) {
                    this.clearFocusValueOnUpdate = false;
                    return null;
                }
                var _this$state6 = this.state, focusedValue = _this$state6.focusedValue, lastSelectValue = _this$state6.selectValue;
                var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
                if (lastFocusedIndex > -1) {
                    var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
                    if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
                    return focusedValue;
                    else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
                    // reference, so return the new value at the same index
                    return nextSelectValue[lastFocusedIndex];
                }
                return null;
            }
        },
        {
            key: "getNextFocusedOption",
            value: function getNextFocusedOption(options) {
                var lastFocusedOption = this.state.focusedOption;
                return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.state.menuOptions.render.length;
            }
        },
        {
            key: "countOptions",
            value: function countOptions() {
                return this.state.menuOptions.focusable.length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props14 = this.props, isClearable = _this$props14.isClearable, isMulti = _this$props14.isMulti; // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return typeof this.props.isOptionDisabled === "function" ? this.props.isOptionDisabled(option, selectValue) : false;
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                var _this3 = this;
                if (selectValue.indexOf(option) > -1) return true;
                if (typeof this.props.isOptionSelected === "function") return this.props.isOptionSelected(option, selectValue);
                var candidate = this.getOptionValue(option);
                return selectValue.some(function(i) {
                    return _this3.getOptionValue(i) === candidate;
                });
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return this.props.filterOption ? this.props.filterOption(option, inputValue) : true;
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === "function") {
                    var inputValue = this.props.inputValue;
                    var selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: inputValue,
                        selectValue: selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            } // ==============================
        },
        {
            key: "startListeningComposition",
            // ==============================
            // Composition Handlers
            // ==============================
            value: function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener("compositionstart", this.onCompositionStart, false);
                    document.addEventListener("compositionend", this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("compositionstart", this.onCompositionStart);
                    document.removeEventListener("compositionend", this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            // ==============================
            // Touch Handlers
            // ==============================
            value: function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener("touchstart", this.onTouchStart, false);
                    document.addEventListener("touchmove", this.onTouchMove, false);
                    document.addEventListener("touchend", this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener("touchstart", this.onTouchStart);
                    document.removeEventListener("touchmove", this.onTouchMove);
                    document.removeEventListener("touchend", this.onTouchEnd);
                }
            }
        },
        {
            key: "constructAriaLiveMessage",
            // ==============================
            // Renderers
            // ==============================
            value: function constructAriaLiveMessage() {
                var _this$state7 = this.state, ariaLiveContext = _this$state7.ariaLiveContext, selectValue = _this$state7.selectValue, focusedValue = _this$state7.focusedValue, focusedOption = _this$state7.focusedOption;
                var _this$props15 = this.props, options = _this$props15.options, menuIsOpen = _this$props15.menuIsOpen, inputValue = _this$props15.inputValue, screenReaderStatus = _this$props15.screenReaderStatus; // An aria live message representing the currently focused value in the select.
                var focusedValueMsg = focusedValue ? $8ac3122ed2a8618b$var$valueFocusAriaMessage({
                    focusedValue: focusedValue,
                    getOptionLabel: this.getOptionLabel,
                    selectValue: selectValue
                }) : ""; // An aria live message representing the currently focused option in the select.
                var focusedOptionMsg = focusedOption && menuIsOpen ? $8ac3122ed2a8618b$var$optionFocusAriaMessage({
                    focusedOption: focusedOption,
                    getOptionLabel: this.getOptionLabel,
                    options: options
                }) : ""; // An aria live message representing the set of focusable results and current searchterm/inputvalue.
                var resultsMsg = $8ac3122ed2a8618b$var$resultsAriaMessage({
                    inputValue: inputValue,
                    screenReaderMessage: screenReaderStatus({
                        count: this.countOptions()
                    })
                });
                return "".concat(focusedValueMsg, " ").concat(focusedOptionMsg, " ").concat(resultsMsg, " ").concat(ariaLiveContext);
            }
        },
        {
            key: "renderInput",
            value: function renderInput() {
                var _this$props16 = this.props, isDisabled = _this$props16.isDisabled, isSearchable = _this$props16.isSearchable, inputId = _this$props16.inputId, inputValue = _this$props16.inputValue, tabIndex = _this$props16.tabIndex, form = _this$props16.form;
                var Input = this.components.Input;
                var inputIsHidden = this.state.inputIsHidden;
                var id = inputId || this.getElementId("input"); // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = {
                    "aria-autocomplete": "list",
                    "aria-label": this.props["aria-label"],
                    "aria-labelledby": this.props["aria-labelledby"]
                };
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ac3122ed2a8618b$var$DummyInput, (0, $8nd05.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $32kym.E),
                    onFocus: this.onInputFocus,
                    readOnly: true,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    form: form,
                    value: ""
                }, ariaAttributes));
                var _this$commonProps = this.commonProps, cx = _this$commonProps.cx, theme = _this$commonProps.theme, selectProps = _this$commonProps.selectProps;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Input, (0, $8nd05.default)({
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    cx: cx,
                    getStyles: this.getStyles,
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    selectProps: selectProps,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    theme: theme,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this4 = this;
                var _this$components = this.components, MultiValue = _this$components.MultiValue, MultiValueContainer = _this$components.MultiValueContainer, MultiValueLabel = _this$components.MultiValueLabel, MultiValueRemove = _this$components.MultiValueRemove, SingleValue = _this$components.SingleValue, Placeholder = _this$components.Placeholder;
                var commonProps = this.commonProps;
                var _this$props17 = this.props, controlShouldRenderValue = _this$props17.controlShouldRenderValue, isDisabled = _this$props17.isDisabled, isMulti = _this$props17.isMulti, inputValue = _this$props17.inputValue, placeholder = _this$props17.placeholder;
                var _this$state8 = this.state, selectValue = _this$state8.selectValue, focusedValue = _this$state8.focusedValue, isFocused = _this$state8.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Placeholder, (0, $8nd05.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), placeholder);
                if (isMulti) {
                    var selectValues = selectValue.map(function(opt, index) {
                        var isOptionFocused = opt === focusedValue;
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(MultiValue, (0, $8nd05.default)({}, commonProps, {
                            components: {
                                Container: MultiValueContainer,
                                Label: MultiValueLabel,
                                Remove: MultiValueRemove
                            },
                            isFocused: isOptionFocused,
                            isDisabled: isDisabled,
                            key: "".concat(_this4.getOptionValue(opt)).concat(index),
                            index: index,
                            removeProps: {
                                onClick: function onClick() {
                                    return _this4.removeValue(opt);
                                },
                                onTouchEnd: function onTouchEnd() {
                                    return _this4.removeValue(opt);
                                },
                                onMouseDown: function onMouseDown(e) {
                                    e.preventDefault();
                                    e.stopPropagation();
                                }
                            },
                            data: opt
                        }), _this4.formatOptionLabel(opt, "value"));
                    });
                    return selectValues;
                }
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(SingleValue, (0, $8nd05.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, "value"));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var ClearIndicator = this.components.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props18 = this.props, isDisabled = _this$props18.isDisabled, isLoading = _this$props18.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ClearIndicator, (0, $8nd05.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var LoadingIndicator = this.components.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props19 = this.props, isDisabled = _this$props19.isDisabled, isLoading = _this$props19.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(LoadingIndicator, (0, $8nd05.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$components2 = this.components, DropdownIndicator = _this$components2.DropdownIndicator, IndicatorSeparator = _this$components2.IndicatorSeparator; // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(IndicatorSeparator, (0, $8nd05.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var DropdownIndicator = this.components.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    "aria-hidden": "true"
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(DropdownIndicator, (0, $8nd05.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this5 = this;
                var _this$components3 = this.components, Group = _this$components3.Group, GroupHeading = _this$components3.GroupHeading, Menu = _this$components3.Menu, MenuList = _this$components3.MenuList, MenuPortal = _this$components3.MenuPortal, LoadingMessage = _this$components3.LoadingMessage, NoOptionsMessage = _this$components3.NoOptionsMessage, Option = _this$components3.Option;
                var commonProps = this.commonProps;
                var _this$state9 = this.state, focusedOption = _this$state9.focusedOption, menuOptions = _this$state9.menuOptions;
                var _this$props20 = this.props, captureMenuScroll = _this$props20.captureMenuScroll, inputValue = _this$props20.inputValue, isLoading = _this$props20.isLoading, loadingMessage = _this$props20.loadingMessage, minMenuHeight = _this$props20.minMenuHeight, maxMenuHeight = _this$props20.maxMenuHeight, menuIsOpen = _this$props20.menuIsOpen, menuPlacement = _this$props20.menuPlacement, menuPosition = _this$props20.menuPosition, menuPortalTarget = _this$props20.menuPortalTarget, menuShouldBlockScroll = _this$props20.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props20.menuShouldScrollIntoView, noOptionsMessage = _this$props20.noOptionsMessage, onMenuScrollToTop = _this$props20.onMenuScrollToTop, onMenuScrollToBottom = _this$props20.onMenuScrollToBottom;
                if (!menuIsOpen) return null; // TODO: Internal Option Type here
                var render = function render(props) {
                    // for performance, the menu options in state aren't changed when the
                    // focused option changes so we calculate additional props based on that
                    var isFocused = focusedOption === props.data;
                    props.innerRef = isFocused ? _this5.getFocusedOptionRef : undefined;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Option, (0, $8nd05.default)({}, commonProps, props, {
                        isFocused: isFocused
                    }), _this5.formatOptionLabel(props.data, "menu"));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = menuOptions.render.map(function(item) {
                    if (item.type === "group") {
                        var type = item.type, group = (0, $9X7IJ.default)(item, [
                            "type"
                        ]);
                        var headingId = "".concat(item.key, "-heading");
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Group, (0, $8nd05.default)({}, commonProps, group, {
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this5.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option);
                        }));
                    } else if (item.type === "option") return render(item);
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $32kym.M), (0, $8nd05.default)({}, commonProps, menuPlacementProps), function(_ref10) {
                    var ref = _ref10.ref, _ref10$placerProps = _ref10.placerProps, placement = _ref10$placerProps.placement, maxHeight = _ref10$placerProps.maxHeight;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Menu, (0, $8nd05.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this5.onMenuMouseDown,
                            onMouseMove: _this5.onMenuMouseMove
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ac3122ed2a8618b$var$ScrollCaptorSwitch, {
                        isEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ac3122ed2a8618b$var$ScrollBlock, {
                        isEnabled: menuShouldBlockScroll
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(MenuList, (0, $8nd05.default)({}, commonProps, {
                        innerRef: _this5.getMenuListRef,
                        isLoading: isLoading,
                        maxHeight: maxHeight
                    }), menuUI))));
                }); // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === "fixed" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(MenuPortal, (0, $8nd05.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this6 = this;
                var _this$props21 = this.props, delimiter = _this$props21.delimiter, isDisabled = _this$props21.isDisabled, isMulti = _this$props21.isMulti, name = _this$props21.name;
                var selectValue = this.state.selectValue;
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this6.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this6.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
                            name: name,
                            type: "hidden"
                        });
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, input);
                    }
                } else {
                    var _value2 = selectValue[0] ? this.getOptionValue(selectValue[0]) : "";
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value2
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                if (!this.state.isFocused) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8ac3122ed2a8618b$var$A11yText, {
                    "aria-live": "polite"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    id: "aria-selection-event"
                }, "\xa0", this.state.ariaLiveSelection), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    id: "aria-context"
                }, "\xa0", this.constructAriaLiveMessage()));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$components4 = this.components, Control = _this$components4.Control, IndicatorsContainer = _this$components4.IndicatorsContainer, SelectContainer = _this$components4.SelectContainer, ValueContainer = _this$components4.ValueContainer;
                var _this$props22 = this.props, className = _this$props22.className, id = _this$props22.id, isDisabled = _this$props22.isDisabled, menuIsOpen = _this$props22.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(SelectContainer, (0, $8nd05.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Control, (0, $8nd05.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ValueContainer, (0, $8nd05.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(IndicatorsContainer, (0, $8nd05.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ]);
    return Select;
}((0, $acw62.Component));
$8ac3122ed2a8618b$export$25ce5a424b770e84.defaultProps = $8ac3122ed2a8618b$export$4368d992c4eafac0;

});
parcelRegister("eUqlC", function(module, exports) {

$parcel$export(module.exports, "default", () => $adaabbc18727b3e6$export$2e2bcd8739ae039);

var $1uEeT = parcelRequire("1uEeT");

var $guSBA = parcelRequire("guSBA");

var $abLc2 = parcelRequire("abLc2");

var $782Uh = parcelRequire("782Uh");
function $adaabbc18727b3e6$export$2e2bcd8739ae039(r, e) {
    return (0, $1uEeT.default)(r) || (0, $guSBA.default)(r, e) || (0, $abLc2.default)(r, e) || (0, $782Uh.default)();
}

});
parcelRegister("1uEeT", function(module, exports) {

$parcel$export(module.exports, "default", () => $1167ce760980f343$export$2e2bcd8739ae039);
function $1167ce760980f343$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("guSBA", function(module, exports) {

$parcel$export(module.exports, "default", () => $c029ce1ef065e371$export$2e2bcd8739ae039);
function $c029ce1ef065e371$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("782Uh", function(module, exports) {

$parcel$export(module.exports, "default", () => $530b88ff20858fe6$export$2e2bcd8739ae039);
function $530b88ff20858fe6$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("kbxxf", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb1ed927433e7e98$export$2e2bcd8739ae039);

var $cN7Ua = parcelRequire("cN7Ua");

var $dOjF6 = parcelRequire("dOjF6");

var $abLc2 = parcelRequire("abLc2");

var $fB5Ly = parcelRequire("fB5Ly");
function $eb1ed927433e7e98$export$2e2bcd8739ae039(r) {
    return (0, $cN7Ua.default)(r) || (0, $dOjF6.default)(r) || (0, $abLc2.default)(r) || (0, $fB5Ly.default)();
}

});
parcelRegister("cN7Ua", function(module, exports) {

$parcel$export(module.exports, "default", () => $95003165623aa54c$export$2e2bcd8739ae039);

var $7K8zV = parcelRequire("7K8zV");
function $95003165623aa54c$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $7K8zV.default)(r);
}

});

parcelRegister("dOjF6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0df324e6f81ee90$export$2e2bcd8739ae039);
function $a0df324e6f81ee90$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("fB5Ly", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5aec8b8da7ac2f2$export$2e2bcd8739ae039);
function $b5aec8b8da7ac2f2$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});



parcelRegister("gS6QF", function(module, exports) {
function $c4870074adc2be76$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
module.exports = $c4870074adc2be76$var$_taggedTemplateLiteral, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("e9Jgd", function(module, exports) {

$parcel$export(module.exports, "m", () => $a4e503baa4efcfb1$export$953cecd6e717a553);

var $9X7IJ = parcelRequire("9X7IJ");

var $8nd05 = parcelRequire("8nd05");

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");

var $1gYAD = parcelRequire("1gYAD");

var $9715X = parcelRequire("9715X");

var $jDKKo = parcelRequire("jDKKo");

var $acw62 = parcelRequire("acw62");
function $a4e503baa4efcfb1$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $a4e503baa4efcfb1$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $jDKKo.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $jDKKo.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $9715X.default)(this, result);
    };
}
function $a4e503baa4efcfb1$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $a4e503baa4efcfb1$var$defaultProps = {
    defaultInputValue: "",
    defaultMenuIsOpen: false,
    defaultValue: null
};
var $a4e503baa4efcfb1$export$953cecd6e717a553 = function manageState(SelectComponent) {
    var _class, _temp;
    return _temp = _class = /*#__PURE__*/ function(_Component) {
        (0, $1gYAD.default)(StateManager, _Component);
        var _super = $a4e503baa4efcfb1$var$_createSuper(StateManager);
        function StateManager() {
            var _this;
            (0, $6CZeq.default)(this, StateManager);
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _super.call.apply(_super, [
                this
            ].concat(args));
            _this.select = void 0;
            _this.state = {
                inputValue: _this.props.inputValue !== undefined ? _this.props.inputValue : _this.props.defaultInputValue,
                menuIsOpen: _this.props.menuIsOpen !== undefined ? _this.props.menuIsOpen : _this.props.defaultMenuIsOpen,
                value: _this.props.value !== undefined ? _this.props.value : _this.props.defaultValue
            };
            _this.onChange = function(value, actionMeta) {
                _this.callProp("onChange", value, actionMeta);
                _this.setState({
                    value: value
                });
            };
            _this.onInputChange = function(value, actionMeta) {
                // TODO: for backwards compatibility, we allow the prop to return a new
                // value, but now inputValue is a controllable prop we probably shouldn't
                var newValue = _this.callProp("onInputChange", value, actionMeta);
                _this.setState({
                    inputValue: newValue !== undefined ? newValue : value
                });
            };
            _this.onMenuOpen = function() {
                _this.callProp("onMenuOpen");
                _this.setState({
                    menuIsOpen: true
                });
            };
            _this.onMenuClose = function() {
                _this.callProp("onMenuClose");
                _this.setState({
                    menuIsOpen: false
                });
            };
            return _this;
        }
        (0, $cHPF9.default)(StateManager, [
            {
                key: "focus",
                value: function focus() {
                    this.select.focus();
                }
            },
            {
                key: "blur",
                value: function blur() {
                    this.select.blur();
                } // FIXME: untyped flow code, return any
            },
            {
                key: "getProp",
                value: function getProp(key) {
                    return this.props[key] !== undefined ? this.props[key] : this.state[key];
                } // FIXME: untyped flow code, return any
            },
            {
                key: "callProp",
                value: function callProp(name) {
                    if (typeof this.props[name] === "function") {
                        var _this$props;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        return (_this$props = this.props)[name].apply(_this$props, args);
                    }
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    var _this$props2 = this.props, defaultInputValue = _this$props2.defaultInputValue, defaultMenuIsOpen = _this$props2.defaultMenuIsOpen, defaultValue = _this$props2.defaultValue, props = (0, $9X7IJ.default)(_this$props2, [
                        "defaultInputValue",
                        "defaultMenuIsOpen",
                        "defaultValue"
                    ]);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(SelectComponent, (0, $8nd05.default)({}, props, {
                        ref: function ref(_ref) {
                            _this2.select = _ref;
                        },
                        inputValue: this.getProp("inputValue"),
                        menuIsOpen: this.getProp("menuIsOpen"),
                        onChange: this.onChange,
                        onInputChange: this.onInputChange,
                        onMenuClose: this.onMenuClose,
                        onMenuOpen: this.onMenuOpen,
                        value: this.getProp("value")
                    }));
                }
            }
        ]);
        return StateManager;
    }((0, $acw62.Component)), _class.defaultProps = $a4e503baa4efcfb1$var$defaultProps, _temp;
};

});


parcelRegister("fcvsF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "defaultProps", () => $b1106196094e4a81$export$9c21a3269931e1e6);
$parcel$export(module.exports, "makeCreatableSelect", () => $b1106196094e4a81$export$dd4e25915d5350b7);
$parcel$export(module.exports, "default", () => $b1106196094e4a81$export$2e2bcd8739ae039);
parcelRequire("gZU1N");

var $8nd05 = parcelRequire("8nd05");
parcelRequire("02Ztr");

var $kbxxf = parcelRequire("kbxxf");

var $kSlfw = parcelRequire("kSlfw");

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");
parcelRequire("6zC7B");

var $1gYAD = parcelRequire("1gYAD");

var $9715X = parcelRequire("9715X");

var $jDKKo = parcelRequire("jDKKo");

var $acw62 = parcelRequire("acw62");

parcelRequire("f5Egd");
parcelRequire("1u0KT");
parcelRequire("41YNz");

var $32kym = parcelRequire("32kym");

var $bUCRB = parcelRequire("bUCRB");
parcelRequire("6xSYO");
parcelRequire("gS6QF");
parcelRequire("83zt3");

var $e9Jgd = parcelRequire("e9Jgd");
function $b1106196094e4a81$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $b1106196094e4a81$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $jDKKo.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $jDKKo.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $9715X.default)(this, result);
    };
}
function $b1106196094e4a81$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $b1106196094e4a81$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b1106196094e4a81$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $b1106196094e4a81$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $kSlfw.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $b1106196094e4a81$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $b1106196094e4a81$var$compareOption = function compareOption() {
    var inputValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    var option = arguments.length > 1 ? arguments[1] : undefined;
    var candidate = String(inputValue).toLowerCase();
    var optionValue = String(option.value).toLowerCase();
    var optionLabel = String(option.label).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
var $b1106196094e4a81$var$builtins = {
    formatCreateLabel: function formatCreateLabel(inputValue) {
        return 'Create "'.concat(inputValue, '"');
    },
    isValidNewOption: function isValidNewOption(inputValue, selectValue, selectOptions) {
        return !(!inputValue || selectValue.some(function(option) {
            return $b1106196094e4a81$var$compareOption(inputValue, option);
        }) || selectOptions.some(function(option) {
            return $b1106196094e4a81$var$compareOption(inputValue, option);
        }));
    },
    getNewOptionData: function getNewOptionData(inputValue, optionLabel) {
        return {
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        };
    }
};
var $b1106196094e4a81$export$9c21a3269931e1e6 = $b1106196094e4a81$var$_objectSpread({
    allowCreateWhileLoading: false,
    createOptionPosition: "last"
}, $b1106196094e4a81$var$builtins);
var $b1106196094e4a81$export$dd4e25915d5350b7 = function makeCreatableSelect(SelectComponent) {
    var _class, _temp;
    return _temp = _class = /*#__PURE__*/ function(_Component) {
        (0, $1gYAD.default)(Creatable, _Component);
        var _super = $b1106196094e4a81$var$_createSuper(Creatable);
        function Creatable(props) {
            var _this;
            (0, $6CZeq.default)(this, Creatable);
            _this = _super.call(this, props);
            _this.select = void 0;
            _this.onChange = function(newValue, actionMeta) {
                var _this$props = _this.props, getNewOptionData = _this$props.getNewOptionData, inputValue = _this$props.inputValue, isMulti = _this$props.isMulti, onChange = _this$props.onChange, onCreateOption = _this$props.onCreateOption, value = _this$props.value, name = _this$props.name;
                if (actionMeta.action !== "select-option") return onChange(newValue, actionMeta);
                var newOption = _this.state.newOption;
                var valueArray = Array.isArray(newValue) ? newValue : [
                    newValue
                ];
                if (valueArray[valueArray.length - 1] === newOption) {
                    if (onCreateOption) onCreateOption(inputValue);
                    else {
                        var newOptionData = getNewOptionData(inputValue, inputValue);
                        var newActionMeta = {
                            action: "create-option",
                            name: name
                        };
                        if (isMulti) onChange([].concat((0, $kbxxf.default)((0, $32kym.C)(value)), [
                            newOptionData
                        ]), newActionMeta);
                        else onChange(newOptionData, newActionMeta);
                    }
                    return;
                }
                onChange(newValue, actionMeta);
            };
            var options = props.options || [];
            _this.state = {
                newOption: undefined,
                options: options
            };
            return _this;
        }
        (0, $cHPF9.default)(Creatable, [
            {
                key: "UNSAFE_componentWillReceiveProps",
                value: function UNSAFE_componentWillReceiveProps(nextProps) {
                    var allowCreateWhileLoading = nextProps.allowCreateWhileLoading, createOptionPosition = nextProps.createOptionPosition, formatCreateLabel = nextProps.formatCreateLabel, getNewOptionData = nextProps.getNewOptionData, inputValue = nextProps.inputValue, isLoading = nextProps.isLoading, isValidNewOption = nextProps.isValidNewOption, value = nextProps.value;
                    var options = nextProps.options || [];
                    var newOption = this.state.newOption;
                    if (isValidNewOption(inputValue, (0, $32kym.C)(value), options)) newOption = getNewOptionData(inputValue, formatCreateLabel(inputValue));
                    else newOption = undefined;
                    this.setState({
                        newOption: newOption,
                        options: (allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === "first" ? [
                            newOption
                        ].concat((0, $kbxxf.default)(options)) : [].concat((0, $kbxxf.default)(options), [
                            newOption
                        ]) : options
                    });
                }
            },
            {
                key: "focus",
                value: function focus() {
                    this.select.focus();
                }
            },
            {
                key: "blur",
                value: function blur() {
                    this.select.blur();
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    var options = this.state.options;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(SelectComponent, (0, $8nd05.default)({}, this.props, {
                        ref: function ref(_ref) {
                            _this2.select = _ref;
                        },
                        options: options,
                        onChange: this.onChange
                    }));
                }
            }
        ]);
        return Creatable;
    }((0, $acw62.Component)), _class.defaultProps = $b1106196094e4a81$export$9c21a3269931e1e6, _temp;
}; // TODO: do this in package entrypoint
var $b1106196094e4a81$var$SelectCreatable = $b1106196094e4a81$export$dd4e25915d5350b7((0, $bUCRB.S));
var $b1106196094e4a81$var$Creatable = (0, $e9Jgd.m)($b1106196094e4a81$var$SelectCreatable);
var $b1106196094e4a81$export$2e2bcd8739ae039 = $b1106196094e4a81$var$Creatable;

});


parcelRegister("gRzd0", function(module, exports) {
"use strict";
var $c46ce84b7ee72db1$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $c46ce84b7ee72db1$var$react_1 = $c46ce84b7ee72db1$var$__importDefault((parcelRequire("acw62")));

var $32kym = parcelRequire("32kym");

const $c46ce84b7ee72db1$var$async_1 = $c46ce84b7ee72db1$var$__importDefault((parcelRequire("ks4RT")));

const $c46ce84b7ee72db1$var$async_creatable_1 = $c46ce84b7ee72db1$var$__importDefault((parcelRequire("aW0I9")));
const $c46ce84b7ee72db1$var$SelectAsync = (props)=>{
    const { className: className, size: size = "md", components: components } = props;
    const customStyles = {
        control: (base, state)=>({
                ...base,
                color: state.isFocused ? "#495057" : base.color,
                backgroundColor: state.isFocused ? "#fff" : base.backgroundColor,
                borderColor: state.isFocused ? "#5dbaed" : base.borderColor,
                outline: state.isFocused ? 0 : base.outline,
                boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(20, 125, 183, 0.25)" : base.boxShadow,
                "&:hover": {
                    borderColor: state.isFocused ? "#5dbaed" : base.borderColor
                }
            })
    };
    const IndicatorSeparator = ()=>{
        return null;
    };
    const DropdownIndicator = (props)=>{
        return $c46ce84b7ee72db1$var$react_1.default.createElement($32kym.F.DropdownIndicator, {
            ...props
        }, $c46ce84b7ee72db1$var$react_1.default.createElement("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, $c46ce84b7ee72db1$var$react_1.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            // eslint-disable-next-line max-len
            d: "M5.46967 7.46967C5.76256 7.17678 6.23744 7.17678 6.53033 7.46967L10 10.9393L13.4697 7.46967C13.7626 7.17678 14.2374 7.17678 14.5303 7.46967C14.8232 7.76256 14.8232 8.23744 14.5303 8.53033L10.5303 12.5303C10.3897 12.671 10.1989 12.75 10 12.75C9.80109 12.75 9.61032 12.671 9.46967 12.5303L5.46967 8.53033C5.17678 8.23744 5.17678 7.76256 5.46967 7.46967Z",
            fill: "#4B5563"
        })));
    };
    const ClearIndicator = (props)=>{
        return $c46ce84b7ee72db1$var$react_1.default.createElement($32kym.F.ClearIndicator, {
            ...props
        }, $c46ce84b7ee72db1$var$react_1.default.createElement("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, $c46ce84b7ee72db1$var$react_1.default.createElement("path", {
            d: "M5 5L10 10M10 10L15 15M10 10L5 15M10 10L15 5",
            stroke: "#4B5563",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })));
    };
    const MultiValueRemove = (props)=>{
        return $c46ce84b7ee72db1$var$react_1.default.createElement($32kym.F.MultiValueRemove, {
            ...props
        }, $c46ce84b7ee72db1$var$react_1.default.createElement("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, $c46ce84b7ee72db1$var$react_1.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            // eslint-disable-next-line max-len
            d: "M10 16C13.3137 16 16 13.3137 16 10C16 6.68629 13.3137 4 10 4C6.68629 4 4 6.68629 4 10C4 13.3137 6.68629 16 10 16ZM8.54881 7.47082C8.25656 7.17729 7.78168 7.17626 7.48815 7.46852C7.19463 7.76078 7.19359 8.23565 7.48585 8.52918L8.94164 9.9913L7.46852 11.4708C7.17626 11.7644 7.17729 12.2392 7.47082 12.5315C7.76435 12.8237 8.23922 12.8227 8.53148 12.5292L10 11.0543L11.4685 12.5292C11.7608 12.8227 12.2356 12.8237 12.5292 12.5315C12.8227 12.2392 12.8237 11.7644 12.5315 11.4708L11.0584 9.9913L12.5141 8.52918C12.8064 8.23565 12.8054 7.76078 12.5118 7.46852C12.2183 7.17626 11.7434 7.17729 11.4512 7.47082L10 8.92833L8.54881 7.47082Z",
            fill: "#6B7280"
        })));
    };
    const CustomOption = (props)=>$c46ce84b7ee72db1$var$react_1.default.createElement($32kym.F.Option, {
            ...props
        }, $c46ce84b7ee72db1$var$react_1.default.createElement("div", {
            className: "helix-select__option-inner"
        }, $c46ce84b7ee72db1$var$react_1.default.createElement("div", {
            className: "helix-select__option-label",
            ...props
        }), props.isSelected && $c46ce84b7ee72db1$var$react_1.default.createElement("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, $c46ce84b7ee72db1$var$react_1.default.createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            // eslint-disable-next-line max-len
            d: "M15.9962 4.93763C16.3068 5.21168 16.3364 5.68563 16.0624 5.99623L8.56238 14.4962C8.4254 14.6515 8.23034 14.7432 8.0234 14.7496C7.81647 14.7561 7.61607 14.6767 7.46967 14.5303L3.96967 11.0303C3.67678 10.7374 3.67678 10.2626 3.96967 9.96968C4.26256 9.67679 4.73744 9.67679 5.03033 9.96968L7.96582 12.9052L14.9376 5.00379C15.2117 4.6932 15.6856 4.66358 15.9962 4.93763Z",
            fill: "#2563EB"
        }))));
    const replacedComponents = {
        IndicatorSeparator: IndicatorSeparator,
        DropdownIndicator: DropdownIndicator,
        ClearIndicator: ClearIndicator,
        MultiValueRemove: MultiValueRemove,
        Option: CustomOption,
        ...components
    };
    const sizeClass = ()=>{
        switch(size){
            case "sm":
                return "helix-select--sm";
            case "lg":
                return "helix-select--lg";
            default:
                return "";
        }
    };
    const classNames = `helix-select__wrapper ${sizeClass()} ${className ? className : ""}`;
    const select = props.isCreatable ? $c46ce84b7ee72db1$var$react_1.default.createElement($c46ce84b7ee72db1$var$async_creatable_1.default, {
        className: classNames,
        styles: customStyles,
        classNamePrefix: "helix-select",
        ...props,
        components: replacedComponents
    }) : $c46ce84b7ee72db1$var$react_1.default.createElement($c46ce84b7ee72db1$var$async_1.default, {
        className: classNames,
        styles: customStyles,
        classNamePrefix: "helix-select",
        ...props,
        components: replacedComponents
    });
    return $c46ce84b7ee72db1$var$react_1.default.createElement("div", {
        className: classNames
    }, select);
};
module.exports.default = $c46ce84b7ee72db1$var$SelectAsync;

});
parcelRegister("ks4RT", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "defaultProps", () => $ee3a32e59d4a8ce0$export$9c21a3269931e1e6);
$parcel$export(module.exports, "makeAsyncSelect", () => $ee3a32e59d4a8ce0$export$fde5c51448bdd112);
$parcel$export(module.exports, "default", () => $ee3a32e59d4a8ce0$export$2e2bcd8739ae039);

var $9X7IJ = parcelRequire("9X7IJ");

var $8nd05 = parcelRequire("8nd05");
parcelRequire("02Ztr");
parcelRequire("fUHKi");
parcelRequire("g5Zhu");

var $6CZeq = parcelRequire("6CZeq");

var $cHPF9 = parcelRequire("cHPF9");
parcelRequire("6zC7B");

var $1gYAD = parcelRequire("1gYAD");

var $9715X = parcelRequire("9715X");

var $jDKKo = parcelRequire("jDKKo");

var $acw62 = parcelRequire("acw62");

parcelRequire("f5Egd");
parcelRequire("1u0KT");
parcelRequire("41YNz");

var $32kym = parcelRequire("32kym");

var $bUCRB = parcelRequire("bUCRB");
parcelRequire("6xSYO");
parcelRequire("gS6QF");
parcelRequire("83zt3");

var $e9Jgd = parcelRequire("e9Jgd");
function $ee3a32e59d4a8ce0$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $ee3a32e59d4a8ce0$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $jDKKo.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $jDKKo.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $9715X.default)(this, result);
    };
}
function $ee3a32e59d4a8ce0$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $ee3a32e59d4a8ce0$export$9c21a3269931e1e6 = {
    cacheOptions: false,
    defaultOptions: false,
    filterOption: null,
    isLoading: false
};
var $ee3a32e59d4a8ce0$export$fde5c51448bdd112 = function makeAsyncSelect(SelectComponent) {
    var _class, _temp;
    return _temp = _class = /*#__PURE__*/ function(_Component) {
        (0, $1gYAD.default)(Async, _Component);
        var _super = $ee3a32e59d4a8ce0$var$_createSuper(Async);
        function Async(props) {
            var _this;
            (0, $6CZeq.default)(this, Async);
            _this = _super.call(this);
            _this.select = void 0;
            _this.lastRequest = void 0;
            _this.mounted = false;
            _this.optionsCache = {};
            _this.handleInputChange = function(newValue, actionMeta) {
                var _this$props = _this.props, cacheOptions = _this$props.cacheOptions, onInputChange = _this$props.onInputChange; // TODO
                var inputValue = (0, $32kym.G)(newValue, actionMeta, onInputChange);
                if (!inputValue) {
                    delete _this.lastRequest;
                    _this.setState({
                        inputValue: "",
                        loadedInputValue: "",
                        loadedOptions: [],
                        isLoading: false,
                        passEmptyOptions: false
                    });
                    return;
                }
                if (cacheOptions && _this.optionsCache[inputValue]) _this.setState({
                    inputValue: inputValue,
                    loadedInputValue: inputValue,
                    loadedOptions: _this.optionsCache[inputValue],
                    isLoading: false,
                    passEmptyOptions: false
                });
                else {
                    var request = _this.lastRequest = {};
                    _this.setState({
                        inputValue: inputValue,
                        isLoading: true,
                        passEmptyOptions: !_this.state.loadedInputValue
                    }, function() {
                        _this.loadOptions(inputValue, function(options) {
                            if (!_this.mounted) return;
                            if (options) _this.optionsCache[inputValue] = options;
                            if (request !== _this.lastRequest) return;
                            delete _this.lastRequest;
                            _this.setState({
                                isLoading: false,
                                loadedInputValue: inputValue,
                                loadedOptions: options || [],
                                passEmptyOptions: false
                            });
                        });
                    });
                }
                return inputValue;
            };
            _this.state = {
                defaultOptions: Array.isArray(props.defaultOptions) ? props.defaultOptions : undefined,
                inputValue: typeof props.inputValue !== "undefined" ? props.inputValue : "",
                isLoading: props.defaultOptions === true,
                loadedOptions: [],
                passEmptyOptions: false
            };
            return _this;
        }
        (0, $cHPF9.default)(Async, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    var _this2 = this;
                    this.mounted = true;
                    var defaultOptions = this.props.defaultOptions;
                    var inputValue = this.state.inputValue;
                    if (defaultOptions === true) this.loadOptions(inputValue, function(options) {
                        if (!_this2.mounted) return;
                        var isLoading = !!_this2.lastRequest;
                        _this2.setState({
                            defaultOptions: options || [],
                            isLoading: isLoading
                        });
                    });
                }
            },
            {
                key: "UNSAFE_componentWillReceiveProps",
                value: function UNSAFE_componentWillReceiveProps(nextProps) {
                    // if the cacheOptions prop changes, clear the cache
                    if (nextProps.cacheOptions !== this.props.cacheOptions) this.optionsCache = {};
                    if (nextProps.defaultOptions !== this.props.defaultOptions) this.setState({
                        defaultOptions: Array.isArray(nextProps.defaultOptions) ? nextProps.defaultOptions : undefined
                    });
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.mounted = false;
                }
            },
            {
                key: "focus",
                value: function focus() {
                    this.select.focus();
                }
            },
            {
                key: "blur",
                value: function blur() {
                    this.select.blur();
                }
            },
            {
                key: "loadOptions",
                value: function loadOptions(inputValue, callback) {
                    var loadOptions = this.props.loadOptions;
                    if (!loadOptions) return callback();
                    var loader = loadOptions(inputValue, callback);
                    if (loader && typeof loader.then === "function") loader.then(callback, function() {
                        return callback();
                    });
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this3 = this;
                    var _this$props2 = this.props, loadOptions = _this$props2.loadOptions, isLoadingProp = _this$props2.isLoading, props = (0, $9X7IJ.default)(_this$props2, [
                        "loadOptions",
                        "isLoading"
                    ]);
                    var _this$state = this.state, defaultOptions = _this$state.defaultOptions, inputValue = _this$state.inputValue, isLoading = _this$state.isLoading, loadedInputValue = _this$state.loadedInputValue, loadedOptions = _this$state.loadedOptions, passEmptyOptions = _this$state.passEmptyOptions;
                    var options = passEmptyOptions ? [] : inputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(SelectComponent, (0, $8nd05.default)({}, props, {
                        ref: function ref(_ref) {
                            _this3.select = _ref;
                        },
                        options: options,
                        isLoading: isLoading || isLoadingProp,
                        onInputChange: this.handleInputChange
                    }));
                }
            }
        ]);
        return Async;
    }((0, $acw62.Component)), _class.defaultProps = $ee3a32e59d4a8ce0$export$9c21a3269931e1e6, _temp;
};
var $ee3a32e59d4a8ce0$var$SelectState = (0, $e9Jgd.m)((0, $bUCRB.S));
var $ee3a32e59d4a8ce0$var$Async = $ee3a32e59d4a8ce0$export$fde5c51448bdd112($ee3a32e59d4a8ce0$var$SelectState);
var $ee3a32e59d4a8ce0$export$2e2bcd8739ae039 = $ee3a32e59d4a8ce0$var$Async;

});

parcelRegister("aW0I9", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7f5fdf6175959cb9$export$2e2bcd8739ae039);
parcelRequire("gZU1N");
parcelRequire("3p9rK");
parcelRequire("02Ztr");
parcelRequire("fUHKi");
parcelRequire("g5Zhu");
parcelRequire("fu0YK");
parcelRequire("lR7jo");
parcelRequire("6zC7B");
parcelRequire("f8wIT");
parcelRequire("eN9hz");
parcelRequire("cGTaw");
parcelRequire("acw62");

parcelRequire("f5Egd");
parcelRequire("1u0KT");
parcelRequire("41YNz");


var $bUCRB = parcelRequire("bUCRB");
parcelRequire("6xSYO");
parcelRequire("gS6QF");
parcelRequire("83zt3");

var $e9Jgd = parcelRequire("e9Jgd");

var $ks4RT = parcelRequire("ks4RT");

var $fcvsF = parcelRequire("fcvsF");
var $7f5fdf6175959cb9$var$SelectCreatable = (0, $fcvsF.makeCreatableSelect)((0, $bUCRB.S));
var $7f5fdf6175959cb9$var$SelectCreatableState = (0, $e9Jgd.m)($7f5fdf6175959cb9$var$SelectCreatable);
var $7f5fdf6175959cb9$var$AsyncCreatable = (0, $ks4RT.makeAsyncSelect)($7f5fdf6175959cb9$var$SelectCreatableState);
var $7f5fdf6175959cb9$export$2e2bcd8739ae039 = $7f5fdf6175959cb9$var$AsyncCreatable;

});
parcelRegister("fu0YK", function(module, exports) {
function $b45a6abf916bff88$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
module.exports = $b45a6abf916bff88$var$_classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("lR7jo", function(module, exports) {

var $5DKOa = parcelRequire("5DKOa");
function $fe9438347a673ba6$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $5DKOa(o.key), o);
    }
}
function $fe9438347a673ba6$var$_createClass(e, r, t) {
    return r && $fe9438347a673ba6$var$_defineProperties(e.prototype, r), t && $fe9438347a673ba6$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
module.exports = $fe9438347a673ba6$var$_createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("f8wIT", function(module, exports) {

var $aAhot = parcelRequire("aAhot");
function $b050fc8434f4a0e1$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $aAhot(t, e);
}
module.exports = $b050fc8434f4a0e1$var$_inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("eN9hz", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $ac4cd79166dac6e4$var$_typeof = $41YNz.default;

var $6zC7B = parcelRequire("6zC7B");
function $ac4cd79166dac6e4$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $ac4cd79166dac6e4$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $6zC7B(t);
}
module.exports = $ac4cd79166dac6e4$var$_possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("cGTaw", function(module, exports) {
function $93d4339c80153a6a$var$_getPrototypeOf(t) {
    return module.exports = $93d4339c80153a6a$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $93d4339c80153a6a$var$_getPrototypeOf(t);
}
module.exports = $93d4339c80153a6a$var$_getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

});




parcelRegister("hdbmc", function(module, exports) {

$parcel$export(module.exports, "AvailableOfficeTable", () => $f435f005e77eba1f$export$559a3fb60eb05c10);
$parcel$export(module.exports, "AddedOfficeTable", () => $f435f005e77eba1f$export$1f4091cf22d5879c);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $l05Px = parcelRequire("l05Px");

var $eHBjM = parcelRequire("eHBjM");

var $cstaF = parcelRequire("cstaF");

var $eEE2e = parcelRequire("eEE2e");

var $6xHGz = parcelRequire("6xHGz");
const $f435f005e77eba1f$export$559a3fb60eb05c10 = (props)=>{
    const { availableOffices: availableOffices, hasAvailableOffices: hasAvailableOffices, hasColumnFilters: hasColumnFilters, setDisplayedOffices: setDisplayedOffices, setCheckedAvailableOffices: setCheckedAvailableOffices, gridRef: gridRef } = props;
    const tableViewSettings = (0, $acw62.useMemo)(()=>{
        return hasColumnFilters ? (0, $eEE2e.getColumnsWithFilters)() : (0, $eEE2e.availableOfficesColumns).availableOffices;
    }, []);
    const rowData = (0, $acw62.useMemo)(()=>availableOffices?.map((office, i)=>({
                ...office,
                id: `${i}-${office.officeId}`
            })) || [], [
        availableOffices
    ]);
    const updateDisplayedOffices = (e)=>{
        const visibleRows = [];
        const gridApi = e.api;
        gridApi.forEachNodeAfterFilterAndSort((node)=>{
            visibleRows.push(node.data);
        });
        setDisplayedOffices(visibleRows);
    };
    const handleSelectionChanged = (event)=>{
        const selectedNodes = event.api.getSelectedNodes();
        const selectedOffices = selectedNodes.map((node)=>node.data);
        setCheckedAvailableOffices(selectedOffices);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: hasAvailableOffices ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "m-2",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l05Px.default), {
                gridRef: gridRef,
                tableView: tableViewSettings,
                rowData: rowData,
                tableTitleWithTooltips: (0, $eHBjM.availableOfficesTooltips),
                suppressNoRowsOverlay: true,
                updateDisplayedOffices: setDisplayedOffices ? updateDisplayedOffices : null,
                suppressRowClickSelection: false,
                onSelectionChanged: handleSelectionChanged,
                rowSelection: "multiple",
                rowMultiSelectWithClick: true
            })
        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "h-75 w-100 d-flex flex-column justify-content-center align-items-center",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "font-weight-bold d-block",
                    children: (0, $cstaF.searchTerms).noneAdded
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "text-muted",
                    children: (0, $cstaF.searchTerms).noOfficesAvailable
                })
            ]
        })
    });
};
const $f435f005e77eba1f$export$1f4091cf22d5879c = (props)=>{
    const { addedOffices: addedOffices, setCheckedAddedOffices: setCheckedAddedOffices, gridRef: gridRef } = props;
    const handleSelectionChanged = (event)=>{
        const selectedNodes = event.api.getSelectedNodes();
        const selectedOffices = selectedNodes.map((node)=>node.data);
        setCheckedAddedOffices(selectedOffices);
    };
    const revisedAddedOffices = addedOffices.map((office)=>{
        if (office.officeStatus === (0, $cstaF.status).INACTIVE) return {
            ...office,
            officeName: (0, $cstaF.searchTerms).inactiveOffice,
            statusKeyfield: "officeStatus"
        };
        return office;
    });
    const rowData = (0, $acw62.useMemo)(()=>revisedAddedOffices?.map((office, i)=>({
                ...office,
                id: `${i}-${office.officeId}`
            })) || [], [
        addedOffices
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l05Px.default), {
        gridRef: gridRef,
        tableView: (0, $6xHGz.default).addedOffices,
        rowData: rowData,
        tableTitleWithTooltips: (0, $eHBjM.availableOfficesTooltips),
        suppressNoRowsOverlay: true,
        suppressRowClickSelection: false,
        rowSelection: "multiple",
        onSelectionChanged: handleSelectionChanged,
        rowMultiSelectWithClick: true
    });
};

});
parcelRegister("l05Px", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f614d3326fc752b$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $2z9GT = parcelRequire("2z9GT");

var $98ROn = parcelRequire("98ROn");

var $cIUhV = parcelRequire("cIUhV");

var $dSrCm = parcelRequire("dSrCm");

var $eHBjM = parcelRequire("eHBjM");

var $cstaF = parcelRequire("cstaF");

var $dplp9 = parcelRequire("dplp9");

var $8SeGW = parcelRequire("8SeGW");

var $dqgmD = parcelRequire("dqgmD");

var $90ISC = parcelRequire("90ISC");

var $dQwVS = parcelRequire("dQwVS");

var $iIEeV = parcelRequire("iIEeV");

var $koMgC = parcelRequire("koMgC");
const $3f614d3326fc752b$var$Table = (props)=>{
    const { tableView: tableView, rowData: rowData, pinnedBottomRowData: pinnedBottomRowData, columns: columns, additionalTableHeaders: additionalTableHeaders, tableTitleWithTooltips: tableTitleWithTooltips, externalParams: externalParams, rowSelection: rowSelection, onCellClicked: onCellClicked, gridRef: gridRef, onRowClicked: onRowClicked, suppressNoRowsOverlay: suppressNoRowsOverlay, updateDisplayedOffices: updateDisplayedOffices, isTableAutoHeight: isTableAutoHeight = true, hasFooter: hasFooter, suppressRowClickSelection: suppressRowClickSelection = false, onSelectionChanged: onSelectionChanged, rowMultiSelectWithClick: rowMultiSelectWithClick = false } = props;
    const { restoreTableRetainedStateByType: restoreTableRetainedStateByType, setTableRetainedStateByType: setTableRetainedStateByType, handleFloatingFilterRetain: handleFloatingFilterRetain, setSelectedRowIndex: setSelectedRowIndex, setCrossSortOrder: setCrossSortOrder, crossSortOrder: crossSortOrder, crossSortSourceTableId: crossSortSourceTableId, crossSortColId: crossSortColId, crossSortDirection: crossSortDirection, selectedModule: selectedModule, selectedAgentIds: selectedAgentIds, setSelectedAgentIds: setSelectedAgentIds } = (0, $90ISC.useSearchStore)((state)=>({
            restoreTableRetainedStateByType: state.restoreTableRetainedStateByType,
            setTableRetainedStateByType: state.setTableRetainedStateByType,
            handleFloatingFilterRetain: state.handleFloatingFilterRetain,
            setSelectedRowIndex: state.setSelectedRowIndex,
            setCrossSortOrder: state.setCrossSortOrder,
            crossSortOrder: state[state.selectedModule]?.crossSortOrder,
            crossSortSourceTableId: state[state.selectedModule]?.crossSortSourceTableId,
            crossSortColId: state[state.selectedModule]?.crossSortColId,
            crossSortDirection: state[state.selectedModule]?.crossSortDirection,
            selectedModule: state.selectedModule,
            selectedAgentIds: (0, $koMgC.getSelectedAgentIds)(state),
            setSelectedAgentIds: state.setSelectedAgentIds
        }));
    const isCrossSortEnabled = (0, $iIEeV.getIsCrossSortEnabled)(selectedModule, tableView?.id);
    const isCrossViewSelectionEnabled = (0, $koMgC.getIsCrossViewSelectionEnabled)(selectedModule, tableView?.id);
    (0, $acw62.useEffect)(()=>{
        (0, $dqgmD.applyPersistedSelection)(gridRef?.current?.api, selectedAgentIds, isCrossViewSelectionEnabled);
    }, [
        selectedAgentIds,
        isCrossViewSelectionEnabled,
        gridRef
    ]);
    const [groupHeaders, setGroupHeaders] = (0, $acw62.useState)(undefined);
    const agGridComponents = (0, $acw62.useMemo)(()=>{
        return {
            agColumnHeader: (0, $dSrCm.default)
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!isCrossSortEnabled) return;
        if (crossSortSourceTableId && crossSortSourceTableId !== tableView?.id && gridRef?.current?.api) {
            gridRef.current.api.applyColumnState({
                defaultState: {
                    sort: null
                }
            });
            gridRef.current.api.refreshHeader();
        }
    }, [
        crossSortOrder,
        crossSortSourceTableId,
        tableView?.id,
        isCrossSortEnabled,
        gridRef
    ]);
    (0, $acw62.useEffect)(()=>{
        const tableObserver = (0, $8SeGW.getColumnDividerObserver)(tableView?.id);
        if (tableObserver) {
            const tableContainer = document.querySelector(`#${tableView?.id}`);
            tableObserver.observe(tableContainer, {
                childList: true,
                subtree: true
            });
            return ()=>tableObserver.disconnect();
        }
    }, [
        tableView?.id
    ]);
    // It generates table colDefs dynamically.
    const columnDefs = (0, $acw62.useMemo)(()=>{
        return (0, $cIUhV.generateTableColDefs)({
            columns: columns,
            tableView: tableView,
            additionalTableHeaders: additionalTableHeaders,
            tableTitleWithTooltips: tableTitleWithTooltips,
            externalParams: {
                ...externalParams,
                tableId: tableView?.id
            }
        });
    }, [
        columns,
        tableView,
        additionalTableHeaders,
        tableTitleWithTooltips,
        externalParams
    ]);
    // It validates if additionalTab1leHeaders were updated.
    (0, $acw62.useEffect)(()=>{
        switch(tableView?.id){
            case (0, $eHBjM.tableViewNames).overview:
                if (additionalTableHeaders[0].column1.title.length > 33 && additionalTableHeaders[0].column2.title.length > 39 && (!groupHeaders || groupHeaders !== additionalTableHeaders)) setGroupHeaders(additionalTableHeaders);
                break;
            default:
                if (!groupHeaders || groupHeaders !== additionalTableHeaders) setGroupHeaders(additionalTableHeaders);
                break;
        }
    }, [
        additionalTableHeaders
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!gridRef || !columns) return;
        if (gridRef.current?.api) {
            const api = gridRef.current.api;
            columns.forEach((col)=>{
                api.setColumnsVisible([
                    col.id
                ], col.isDisplayed);
            });
        }
    }, [
        columns,
        gridRef
    ]);
    const shouldSetScrollIndex = [
        (0, $eHBjM.tableViewNames).availableAgents,
        (0, $eHBjM.tableViewNames).availableOffices,
        (0, $eHBjM.tableViewNames).addedAgents,
        (0, $eHBjM.tableViewNames).addedOffices
    ].includes(tableView?.id);
    const handleRowClicked = (e)=>{
        const isAvailableAgentsActive = tableView?.id === (0, $eHBjM.tableViewNames).availableAgents && e.data.status === (0, $cstaF.status).ACTIVE;
        setSelectedRowIndex(e.rowIndex);
        if (shouldSetScrollIndex && (tableView?.id !== (0, $eHBjM.tableViewNames).availableAgents || isAvailableAgentsActive)) {
            if (!onRowClicked) return;
            onRowClicked(e.data);
        }
    };
    const rowClassRules = (0, $acw62.useMemo)(()=>{
        return {
            [(0, $dplp9.cssClassNames).inactiveRow]: (params)=>params.data[params.data?.statusKeyfield] === (0, $cstaF.status).INACTIVE
        };
    }, []);
    const tablesWithNoHighlight = [
        (0, $eHBjM.tableViewNames).addedAgents,
        (0, $eHBjM.tableViewNames).availableAgents
    ];
    const handleTableAction = (e, newSourceTableId = null)=>{
        if (tablesWithNoHighlight.includes(tableView?.id)) return;
        const sourceTableId = newSourceTableId ?? crossSortSourceTableId;
        (0, $cIUhV.handleSortedHighlight)(e, tableView, sourceTableId);
    };
    const handleSortChanged = (e)=>{
        const columnState = e.api.getColumnState();
        const hasActiveSort = columnState.some((col)=>col.sort);
        if (!hasActiveSort) return;
        if (isCrossSortEnabled && e.source === "uiColumnSorted") {
            const orderedData = [];
            e.api.forEachNodeAfterFilterAndSort((node)=>{
                if (node.data) orderedData.push(node.data);
            });
            const sortedColState = columnState.find((col)=>col.sort);
            setCrossSortOrder(orderedData, tableView?.id, sortedColState?.colId, sortedColState?.sort);
            handleTableAction(e, tableView?.id);
            return;
        }
        handleTableAction(e);
    };
    const handleGridReady = (e)=>{
        if (isCrossSortEnabled && tableView?.id === crossSortSourceTableId && crossSortColId && crossSortDirection) {
            e.api.applyColumnState({
                state: [
                    {
                        colId: crossSortColId,
                        sort: crossSortDirection
                    }
                ],
                defaultState: {
                    sort: null
                }
            });
            handleTableAction(e, tableView?.id);
            restoreTableRetainedStateByType({
                api: e.api,
                tableId: tableView?.id,
                type: (0, $dQwVS.retainTerms).floatingFilter
            });
            return;
        }
        restoreTableRetainedStateByType({
            api: e.api,
            tableId: tableView?.id,
            type: (0, $dQwVS.retainTerms).sort
        });
        restoreTableRetainedStateByType({
            api: e.api,
            tableId: tableView?.id,
            type: (0, $dQwVS.retainTerms).floatingFilter
        });
        handleTableAction(e);
    };
    const handleFirstDataRendered = (e)=>{
        (0, $dqgmD.applyPersistedSelection)(e.api, selectedAgentIds, isCrossViewSelectionEnabled);
    };
    const handleOnFilterChanged = (e)=>{
        if (updateDisplayedOffices) updateDisplayedOffices(e);
        handleFloatingFilterRetain({
            tableViewId: tableView?.id,
            api: e.api,
            setTableRetainedStateByType: setTableRetainedStateByType
        });
    };
    const handleOnRowDataChanged = (e)=>{
        handleTableAction(e);
        if (updateDisplayedOffices) updateDisplayedOffices(e);
        (0, $dqgmD.applyPersistedSelection)(e.api, selectedAgentIds, isCrossViewSelectionEnabled);
    };
    const handleSelectionChanged = (e)=>{
        if (isCrossViewSelectionEnabled && e.source !== "api") {
            const selectedIds = e.api.getSelectedRows().map((row)=>row?.agentId);
            setSelectedAgentIds(selectedIds);
        }
        if (onSelectionChanged) onSelectionChanged(e);
    };
    const handleGridColumnsChange = (e)=>{
        handleTableAction(e);
        (0, $cIUhV.handleDrawDivider)(tableView?.id, columnDefs);
    };
    const gridOptions = {
        localeText: {
            noRowsToShow: (0, $cstaF.agentProductionTerms).searchReturnedNoResults
        }
    };
    const tablesWithoutAutoHeight = [
        (0, $eHBjM.tableViewNames).addedAgents,
        (0, $eHBjM.tableViewNames).addedOffices,
        (0, $eHBjM.tableViewNames).availableAgents,
        (0, $eHBjM.tableViewNames).availableOffices,
        (0, $eHBjM.tableViewNames).overview,
        (0, $eHBjM.tableViewNames).activity,
        (0, $eHBjM.tableViewNames).contactInformation,
        (0, $eHBjM.tableViewNames).growthAnalysisLtm,
        (0, $eHBjM.tableViewNames).growthAnalysisYtd,
        (0, $eHBjM.tableViewNames).listingProficiency,
        (0, $eHBjM.tableViewNames).incDecGrowthAnalysisLtm,
        (0, $eHBjM.tableViewNames).growthAnalysisL90,
        (0, $eHBjM.tableViewNames).incDecOverview,
        (0, $eHBjM.tableViewNames).lostAgentsBreakdown,
        (0, $eHBjM.tableViewNames).agentsGainedBreakdown,
        (0, $eHBjM.tableViewNames).officeBreakdown,
        (0, $eHBjM.tableViewNames).agentDetailProduction,
        (0, $eHBjM.tableViewNames).incDecGrowthAnalysisYtd
    ];
    const domLayout = (tablesWithoutAutoHeight.includes(tableView?.id) || !isTableAutoHeight) && !hasFooter ? "normal" : "autoHeight";
    const rowIdParam = (0, $dqgmD.getRowIdParam)(tableView?.id);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        id: tableView?.id,
        className: `mt-2 ${rowData?.length === 0 ? "ag-no-table-results" : ""}`,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2z9GT.AGGridHelix), {
            ref: gridRef,
            defaultColDef: (0, $98ROn.defaultColumnDef),
            columnDefs: columnDefs,
            context: {
                tableViewId: tableView?.id
            },
            rowData: rowData,
            pagination: tableView?.showPagination,
            paginationPageSize: tableView?.paginationOptions?.sizePerPage,
            sizePerPageList: tableView?.paginationOptions?.sizePerPageList,
            domLayout: domLayout,
            components: agGridComponents,
            rowSelection: rowSelection,
            onCellClicked: onCellClicked,
            onVirtualColumnsChanged: handleTableAction,
            onSortChanged: handleSortChanged,
            onColumnResized: handleGridColumnsChange,
            onRowDataChanged: handleOnRowDataChanged,
            suppressCsvExport: false,
            onGridColumnsChanged: handleGridColumnsChange,
            onBodyScroll: handleTableAction,
            onGridReady: handleGridReady,
            onFirstDataRendered: handleFirstDataRendered,
            onRowClicked: handleRowClicked,
            gridOptions: gridOptions,
            rowClassRules: rowClassRules,
            suppressNoRowsOverlay: suppressNoRowsOverlay,
            onFilterChanged: handleOnFilterChanged,
            pinnedBottomRowData: pinnedBottomRowData || [],
            ...rowIdParam,
            deltaRowDataMode: true,
            suppressRowClickSelection: suppressRowClickSelection,
            onSelectionChanged: handleSelectionChanged,
            rowMultiSelectWithClick: rowMultiSelectWithClick
        }, tableView?.id)
    });
};
$3f614d3326fc752b$var$Table.propTypes = {
    tableView: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object.isRequired,
    rowData: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array.isRequired,
    columns: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    additionalTableHeaders: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    tableTitleWithTooltips: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object.isRequired,
    externalParams: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
    ]),
    rowSelection: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    onCellClicked: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    gridRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    updateDisplayedOffices: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onRowClicked: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    suppressNoRowsOverlay: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    pinnedBottomRowData: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    isTableAutoHeight: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    hasFooter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    suppressRowClickSelection: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    onSelectionChanged: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    rowMultiSelectWithClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
var $3f614d3326fc752b$export$2e2bcd8739ae039 = $3f614d3326fc752b$var$Table;

});
parcelRegister("2z9GT", function(module, exports) {
"use strict";
var $1de65e0f2ede4491$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $1de65e0f2ede4491$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $1de65e0f2ede4491$var$__createBinding(exports1, m, p);
};
var $1de65e0f2ede4491$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AGGridProvider = module.exports.AGGridHelix = void 0;

var $kZKAI = parcelRequire("kZKAI");
Object.defineProperty(module.exports, "AGGridHelix", {
    enumerable: true,
    get: function() {
        return $1de65e0f2ede4491$var$__importDefault($kZKAI).default;
    }
});

var $4UcKD = parcelRequire("4UcKD");
Object.defineProperty(module.exports, "AGGridProvider", {
    enumerable: true,
    get: function() {
        return $4UcKD.AGGridProvider;
    }
});

$1de65e0f2ede4491$var$__exportStar((parcelRequire("gxPgh")), module.exports);

$1de65e0f2ede4491$var$__exportStar((parcelRequire("geReh")), module.exports);

});
parcelRegister("kZKAI", function(module, exports) {
"use strict";
var $f48da536baef643e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f48da536baef643e$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $f48da536baef643e$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $f48da536baef643e$var$__createBinding(result, mod, k);
    }
    $f48da536baef643e$var$__setModuleDefault(result, mod);
    return result;
};
var $f48da536baef643e$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $f48da536baef643e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AGGridHelix = void 0;

/* eslint-disable max-len */ const $f48da536baef643e$var$react_1 = $f48da536baef643e$var$__importStar((parcelRequire("acw62")));


parcelRequire("geReh");

var $4CL4O = parcelRequire("4CL4O");

const $f48da536baef643e$var$BtnCellRenderer_1 = $f48da536baef643e$var$__importDefault((parcelRequire("eQY4r")));

const $f48da536baef643e$var$ActionCellRenderer_1 = $f48da536baef643e$var$__importDefault((parcelRequire("ar71Y")));

const $f48da536baef643e$var$DatePickerFilter_1 = $f48da536baef643e$var$__importDefault((parcelRequire("sYDkv")));
parcelRequire("cwg1h");
var $c27cS = parcelRequire("c27cS");
var $5QGPq = parcelRequire("5QGPq");
var $3os0Q = parcelRequire("3os0Q");

var $9GSMu = parcelRequire("9GSMu");
var $2zfPk = parcelRequire("2zfPk");
var $eA2p4 = parcelRequire("eA2p4");
var $kXn8S = parcelRequire("kXn8S");

const $f48da536baef643e$var$DatePickerEditor_1 = $f48da536baef643e$var$__importDefault((parcelRequire("cPy95")));
module.exports.AGGridHelix = $f48da536baef643e$var$react_1.default.forwardRef((_a, ref)=>{
    var { paginationPageSize: paginationPageSize = 10, sizePerPageList: sizePerPageList = [
        10,
        25,
        30,
        50
    ], pagination: pagination = false, rowSelection: rowSelection = "multiple", suppressMovableColumns: suppressMovableColumns = true, suppressCsvExport: suppressCsvExport = true, suppressExcelExport: suppressExcelExport = true, suppressCellFocus: suppressCellFocus = true, width: width = "100%", height: height = "400px", domLayout: domLayout, suppressPaginationPanel: suppressPaginationPanel = false, animateRows: animateRows = false } = _a, rest = $f48da536baef643e$var$__rest(_a, [
        "paginationPageSize",
        "sizePerPageList",
        "pagination",
        "rowSelection",
        "suppressMovableColumns",
        "suppressCsvExport",
        "suppressExcelExport",
        "suppressCellFocus",
        "width",
        "height",
        "domLayout",
        "suppressPaginationPanel",
        "animateRows"
    ]);
    const gridRef = (0, $f48da536baef643e$var$react_1.useRef)();
    const [currentPage, setCurrentPage] = (0, $f48da536baef643e$var$react_1.useState)(1);
    const [dropdownOpen, setDropdownOpen] = (0, $f48da536baef643e$var$react_1.useState)(false);
    const [, setTotalPage] = (0, $f48da536baef643e$var$react_1.useState)(0);
    (0, $f48da536baef643e$var$react_1.useImperativeHandle)(ref, ()=>gridRef.current);
    const icons = (0, $f48da536baef643e$var$react_1.useMemo)(()=>{
        return {
            filter: `<svg width="18" height="10" viewBox="0 0 18 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M0.25 1C0.25 0.585786 0.585786 0.25 1 0.25H17C17.4142 0.25 17.75 0.585786 17.75 1C17.75 1.41421 17.4142 1.75 17 1.75H1C0.585786 1.75 0.25 1.41421 0.25 1ZM3.25 5C3.25 4.58579 3.58579 4.25 4 4.25H14C14.4142 4.25 14.75 4.58579 14.75 5C14.75 5.41421 14.4142 5.75 14 5.75H4C3.58579 5.75 3.25 5.41421 3.25 5ZM6.25 9C6.25 8.58579 6.58579 8.25 7 8.25H11C11.4142 8.25 11.75 8.58579 11.75 9C11.75 9.41421 11.4142 9.75 11 9.75H7C6.58579 9.75 6.25 9.41421 6.25 9Z" fill="#4B5563"/>
      </svg>      
      `,
            sortAscending: `<svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.82979 0.883691C5.43074 0.418916 4.7114 0.418916 4.31235 0.88369L0.417873 5.41965C-0.138922 6.06816 0.321846 7.07107 1.17659 7.07107L8.96554 7.07107C9.82029 7.07107 10.2811 6.06816 9.72426 5.41965L5.82979 0.883691Z" fill="#4B5563"/>
      </svg>      
      `,
            sortDescending: `<svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.31236 6.18735C4.71141 6.65213 5.43076 6.65213 5.8298 6.18736L9.72428 1.6514C10.2811 1.00289 9.8203 -2.18189e-05 8.96556 -2.22211e-05L1.17661 -2.2017e-05C0.321864 -2.24191e-05 -0.138909 1.00289 0.417887 1.6514L4.31236 6.18735Z" fill="#4B5563"/>
      </svg>            
      `,
            clipboardCopy: `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M14.5556 6.5H8.44444C7.87491 6.5 7.5 6.93379 7.5 7.36364V15.6364C7.5 16.0662 7.87491 16.5 8.44444 16.5H14.5556C15.1251 16.5 15.5 16.0662 15.5 15.6364V7.36364C15.5 6.93379 15.1251 6.5 14.5556 6.5ZM8.44444 5C7.09442 5 6 6.05824 6 7.36364V15.6364C6 16.9418 7.09441 18 8.44444 18H14.5556C15.9056 18 17 16.9418 17 15.6364V7.36364C17 6.05824 15.9056 5 14.5556 5H8.44444Z" fill="#4B5563"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M3.21967 2.21967C3.36032 2.07902 3.55109 2 3.75001 2L10.7503 2.00009C11.1645 2.00009 11.5003 2.33588 11.5003 2.75009C11.5003 3.16431 11.1645 3.50009 10.7503 3.50009L4.50002 3.50001L4.5002 11.25C4.50021 11.6642 4.16443 12 3.75022 12C3.336 12 3.00021 11.6642 3.0002 11.25L3 2.75002C3 2.5511 3.07901 2.36033 3.21967 2.21967Z" fill="#4B5563"/>
      </svg>
      `
        };
    }, []);
    const handleNext = (e)=>{
        var _a;
        e.preventDefault();
        (_a = gridRef.current) === null || _a === void 0 || _a.api.paginationGoToNextPage();
    };
    const handlePrevious = (e)=>{
        var _a;
        e.preventDefault();
        (_a = gridRef.current) === null || _a === void 0 || _a.api.paginationGoToPreviousPage();
    };
    const handleFirst = (e)=>{
        var _a;
        e.preventDefault();
        (_a = gridRef.current) === null || _a === void 0 || _a.api.paginationGoToFirstPage();
    };
    const handleLast = (e)=>{
        var _a;
        e.preventDefault();
        (_a = gridRef.current) === null || _a === void 0 || _a.api.paginationGoToLastPage();
    };
    const onPaginationChanged = (0, $f48da536baef643e$var$react_1.useCallback)(()=>{
        var _a, _b, _c, _d;
        setCurrentPage((_b = (_a = gridRef.current) === null || _a === void 0 ? void 0 : _a.api) === null || _b === void 0 ? void 0 : _b.paginationGetCurrentPage());
        setTotalPage((_d = (_c = gridRef.current) === null || _c === void 0 ? void 0 : _c.api) === null || _d === void 0 ? void 0 : _d.paginationGetTotalPages());
    }, []);
    const handlePageClick = (e, page)=>{
        var _a;
        e.preventDefault();
        (_a = gridRef.current) === null || _a === void 0 || _a.api.paginationGoToPage(page);
    };
    // generate pages to only show 5 pages at a time
    const pages = ()=>{
        var _a;
        if (!((_a = gridRef.current) === null || _a === void 0 ? void 0 : _a.api)) return [];
        const pageCount = gridRef.current.api.paginationGetTotalPages();
        // if page count is 5 or less, show all pages
        if (pageCount <= 5) return [
            ...Array(pageCount).keys()
        ];
        const currentPage = gridRef.current.api.paginationGetCurrentPage() - 1;
        const startPage = currentPage >= 2 ? currentPage - 1 : currentPage - 2;
        const endPage = currentPage >= 2 ? currentPage + 3 : 4;
        const pages = [];
        for(let i = startPage; i <= endPage; i++)if (i > -1 && i <= pageCount - 1) pages.push(i);
        // if less then 5 pages add previous page numbers until pages equal 5
        if (pages.length < 5 && pageCount) {
            const startPage = currentPage - 2;
            const endPage = currentPage - 2 + 5 - pages.length;
            for(let i = startPage; i <= endPage; i++)if (i > 0 && i <= pageCount) {
                // only unshift if not already in array
                if (!pages.includes(i)) pages.unshift(i);
                // if on the last page then unshift an extra page
                if (i === endPage && pages.length < 5) pages.unshift(currentPage - pages.length + 1);
            }
        }
        return pages;
    };
    return $f48da536baef643e$var$react_1.default.createElement($f48da536baef643e$var$react_1.default.Fragment, null, $f48da536baef643e$var$react_1.default.createElement("div", {
        className: "ag-theme-alpine",
        style: {
            height: domLayout === "autoHeight" ? "" : height,
            width: width
        }
    }, $f48da536baef643e$var$react_1.default.createElement($4CL4O.StyledAgGrid, Object.assign({
        ref: gridRef,
        domLayout: domLayout,
        rowSelection: rowSelection,
        suppressRowClickSelection: true,
        columnHoverHighlight: false,
        icons: icons,
        paginationPageSize: paginationPageSize,
        pagination: pagination,
        suppressMovableColumns: suppressMovableColumns,
        onPaginationChanged: onPaginationChanged,
        suppressCellFocus: suppressCellFocus,
        suppressExcelExport: suppressExcelExport,
        suppressCsvExport: suppressCsvExport,
        components: {
            btnCellRenderer: $f48da536baef643e$var$BtnCellRenderer_1.default,
            actionCellRenderer: $f48da536baef643e$var$ActionCellRenderer_1.default,
            datePickerFilter: $f48da536baef643e$var$DatePickerFilter_1.default,
            datePickerEditor: $f48da536baef643e$var$DatePickerEditor_1.default
        },
        noRowsOverlayComponentParams: {
            noRowsMessageFunc: ()=>"No data to display"
        },
        animateRows: animateRows
    }, rest, {
        suppressPaginationPanel: true
    }))), pagination && !suppressPaginationPanel && $f48da536baef643e$var$react_1.default.createElement($4CL4O.StyledPaginationRow, {
        className: "row mt-3"
    }, $f48da536baef643e$var$react_1.default.createElement("div", {
        className: "col-md-6 col-xs-6 col-sm-6 col-lg-6"
    }, $f48da536baef643e$var$react_1.default.createElement($9GSMu.default, {
        isOpen: dropdownOpen,
        toggle: ()=>setDropdownOpen(!dropdownOpen)
    }, $f48da536baef643e$var$react_1.default.createElement($kXn8S.default, {
        caret: true
    }, gridRef.current && gridRef.current.api && gridRef.current.api.paginationGetPageSize()), $f48da536baef643e$var$react_1.default.createElement($eA2p4.default, null, sizePerPageList.map((sizePerPage)=>$f48da536baef643e$var$react_1.default.createElement($2zfPk.default, {
            key: sizePerPage,
            onClick: ()=>{
                var _a;
                (_a = gridRef.current) === null || _a === void 0 || _a.api.paginationSetPageSize(sizePerPage);
            }
        }, sizePerPage))))), $f48da536baef643e$var$react_1.default.createElement("div", {
        className: "col-md-6 col-xs-6 col-sm-6 col-lg-6"
    }, $f48da536baef643e$var$react_1.default.createElement($c27cS.default, {
        tag: "span",
        className: "float-right"
    }, $f48da536baef643e$var$react_1.default.createElement($5QGPq.default, {
        tag: "li",
        disabled: gridRef.current && gridRef.current.api && gridRef.current.api.paginationGetCurrentPage() === 0
    }, $f48da536baef643e$var$react_1.default.createElement($3os0Q.default, {
        onClick: (e)=>handleFirst(e),
        first: true,
        href: "#",
        tag: "a"
    })), $f48da536baef643e$var$react_1.default.createElement($5QGPq.default, {
        tag: "li",
        disabled: gridRef.current && gridRef.current.api && gridRef.current.api.paginationGetCurrentPage() === 0
    }, $f48da536baef643e$var$react_1.default.createElement($3os0Q.default, {
        onClick: (e)=>handlePrevious(e),
        previous: true,
        href: "#",
        tag: "a"
    })), pages().map((page)=>$f48da536baef643e$var$react_1.default.createElement($5QGPq.default, {
            key: page,
            active: page === currentPage,
            tag: "li"
        }, $f48da536baef643e$var$react_1.default.createElement($3os0Q.default, {
            onClick: (e)=>handlePageClick(e, page),
            href: "#",
            tag: "a"
        }, page + 1))), $f48da536baef643e$var$react_1.default.createElement($5QGPq.default, {
        tag: "li",
        disabled: gridRef.current && gridRef.current.api && gridRef.current.api.paginationGetTotalPages() === gridRef.current.api.paginationGetCurrentPage() + 1
    }, $f48da536baef643e$var$react_1.default.createElement($3os0Q.default, {
        tag: "a",
        onClick: (e)=>handleNext(e),
        next: true,
        href: "#"
    })), $f48da536baef643e$var$react_1.default.createElement($5QGPq.default, {
        tag: "li",
        disabled: gridRef.current && gridRef.current.api && gridRef.current.api.paginationGetTotalPages() === gridRef.current.api.paginationGetCurrentPage() + 1
    }, $f48da536baef643e$var$react_1.default.createElement($3os0Q.default, {
        tag: "a",
        onClick: (e)=>handleLast(e),
        last: true,
        href: "#"
    }))))));
});
module.exports.AGGridHelix.displayName = "AGGridHelix";
module.exports.default = module.exports.AGGridHelix;

});
parcelRegister("4CL4O", function(module, exports) {
"use strict";
var $35df3a73333392d2$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StyledPaginationRow = module.exports.StyledAgGrid = void 0;

/* eslint-disable max-len */ const $35df3a73333392d2$var$styled_components_1 = $35df3a73333392d2$var$__importDefault((parcelRequire("lmFrL")));

var $gxPgh = parcelRequire("gxPgh");
module.exports.StyledAgGrid = (0, $35df3a73333392d2$var$styled_components_1.default)($gxPgh.AgGridReact)`
    --ag-border-color: #e6e8f0;
    --ag-alpine-active-color: var(--helix-brand);
    --ag-selected-row-background-color: #e9effc;
    --ag-row-hover-color: #f9fafb;
    --ag-selected-row-background-color: #f9fafb;
    --ag-checkbox-checked-color: var(--helix-brand);
    .ag-root-wrapper {
        border-radius: 4px;
        border: none;
        box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.2), 0px 1px 2px rgba(0, 0, 0, 0.1);
    }
    .ag-header-group-cell-label {
        justify-content: center;
        font-weight: normal;
    }
    .ag-header-row-column-group {
        border: none !important;
        outline-color: purple !important;
    }

    .ag-header {
        background-color: white;
    }
    .ag-menu {
        background-color: white;
        border-radius: 6px;
        box-shadow: none;
    }
    .ag-popup-child {
        box-shadow: none !important;
        border: none !important;
        filter: drop-shadow(0px 0px 1px rgba(0, 0, 0, 0.2)) drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.1));
    }
    .ag-tabs-header {
        background-color: white;
        border: none;
    }
    .ag-tab {
        &.ag-tab-selected {
            color: var(--helix-brand);
            border-color: var(--helix-brand);
        }
    }

    .ag-header-cell-text {
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 16px;
        letter-spacing: 0.04em;
        text-transform: uppercase;
        color: #6b7280;
    }

    .ag-checkbox-input-wrapper {
        width: 14px;
        height: 14px;
    }
    .ag-checkbox-input-wrapper.ag-checked::after {
        content: '';
        width: 14px;
        height: 14px;
        background-image: url("data:image/svg+xml,%3Csvg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect width='14' height='14' rx='4' fill='%23236847'/%3E%3Crect width='14' height='14' rx='4' stroke='%23236847'/%3E%3Cpath d='M4 7L6 9L10 5' stroke='white' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
    }
    .ag-checkbox-input-wrapper::after {
        content: '';
        background-image: url("data:image/svg+xml,%3Csvg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='0.75' y='0.75' width='12.5' height='12.5' rx='3.25' fill='white' stroke='%239CA3AF' stroke-width='1.5'/%3E%3C/svg%3E%0A");
        width: 20px;
        height: 14px;
        width: 14px;
    }

    .ag-input-field-input,
    .ag-picker-field-wrapper,
    .react-datepicker__input-container input {
        display: block;
        width: 100%;
        padding: 8px 12px !important;
        font-size: 14px;
        line-height: 1;
        color: #5c656d;
        background-color: #fff;
        background-clip: padding-box;
        border: 1px solid #ced4da !important;
        border-radius: 6px !important;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
        .ag-picker-field-display {
            margin: 0;
        }
        &:focus {
            color: #5c656d;
            background-color: #fff;
            border-color: #d1d5db;
            outline: 0 !important;
            box-shadow: 0 0 0 2px var(--helix-brand) !important;
        }
    }

    .ag-picker-field-wrapper {
        display: flex;
    }

    .ag-cell-inline-editing {
        border: solid 2px var(--brand) !important;
        .react-datepicker-wrapper,
        .react-datepicker__input-container {
            width: 100%;
        }
        input,
        .ag-picker-field-wrapper {
            border: none !important;
            border-radius: 0 !important;
            box-shadow: none;
            width: 100%;
            &:focus {
                box-shadow: none !important;
            }
        }
    }

    .ag-floating-filter-full-body {
        .react-datepicker-wrapper,
        .react-datepicker__input-container {
            width: 100%;
        }
    }

    .ag-menu-option-active {
        background-color: var(--helix-brand-pale);
    }

    .ag-radio-button-input-wrapper.ag-checked::after {
        color: var(--helix-brand);
    }

    .ag-picker-field-wrapper:focus-within {
        border-color: var(--helix-brand);
        box-shadow: none;
    }
    .ag-radio-button-input-wrapper:focus-within, .ag-radio-button-input-wrapper:active {
    box-shadow: none;
    outline-color: var(--helix-brand);
}

.ag-select-list-item.ag-active-item {
    background-color: var(--helix-brand-pale);
}
`;
module.exports.StyledPaginationRow = $35df3a73333392d2$var$styled_components_1.default.div`
    .dropdown-menu:not(.show) {
        display: none;
    }
    .dropdown-menu.show {
        display: block;
    }
`;

});

parcelRegister("cwg1h", function(module, exports) {

$parcel$export(module.exports, "Pagination", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("c27cS")))));
$parcel$export(module.exports, "PaginationItem", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("5QGPq")))));
$parcel$export(module.exports, "PaginationLink", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("3os0Q")))));

var $c27cS = parcelRequire("c27cS");

var $5QGPq = parcelRequire("5QGPq");

var $3os0Q = parcelRequire("3os0Q");

});
parcelRegister("c27cS", function(module, exports) {
"use strict";
var $8c2b430723f8da33$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $8c2b430723f8da33$var$react_1 = $8c2b430723f8da33$var$__importDefault((parcelRequire("acw62")));

var $e27T1 = parcelRequire("e27T1");
const $8c2b430723f8da33$var$Pagination = (props)=>{
    const { dataLwtId: dataLwtId, ...restProps } = props;
    return $8c2b430723f8da33$var$react_1.default.createElement($e27T1.default, {
        "data-lwt-id": dataLwtId,
        ...restProps
    });
};
module.exports.default = $8c2b430723f8da33$var$Pagination;

});
parcelRegister("e27T1", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3775eb35479c88f$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $e9hDx = parcelRequire("e9hDx");
var $a3775eb35479c88f$var$propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    listClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    tag: (0, $e9hDx.tagPropType),
    listTag: (0, $e9hDx.tagPropType),
    "aria-label": (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};
var $a3775eb35479c88f$var$defaultProps = {
    tag: "nav",
    listTag: "ul",
    "aria-label": "pagination"
};
var $a3775eb35479c88f$var$Pagination = function Pagination(props) {
    var _classNames;
    var className = props.className, listClassName = props.listClassName, cssModule = props.cssModule, size = props.size, Tag = props.tag, ListTag = props.listTag, label = props["aria-label"], attributes = (0, $1En50.default)(props, [
        "className",
        "listClassName",
        "cssModule",
        "size",
        "tag",
        "listTag",
        "aria-label"
    ]);
    var classes = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className), cssModule);
    var listClasses = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(listClassName, "pagination", (_classNames = {}, _classNames["pagination-" + size] = !!size, _classNames)), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, {
        className: classes,
        "aria-label": label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(ListTag, (0, $8nd05.default)({}, attributes, {
        className: listClasses
    })));
};
$a3775eb35479c88f$var$Pagination.propTypes = $a3775eb35479c88f$var$propTypes;
$a3775eb35479c88f$var$Pagination.defaultProps = $a3775eb35479c88f$var$defaultProps;
var $a3775eb35479c88f$export$2e2bcd8739ae039 = $a3775eb35479c88f$var$Pagination;

});


parcelRegister("5QGPq", function(module, exports) {
"use strict";
var $442307e817688bb7$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $442307e817688bb7$var$react_1 = $442307e817688bb7$var$__importDefault((parcelRequire("acw62")));

var $bg7gF = parcelRequire("bg7gF");
const $442307e817688bb7$var$PaginationItem = (props)=>{
    const { dataLwtId: dataLwtId, ...restProps } = props;
    return $442307e817688bb7$var$react_1.default.createElement($bg7gF.default, {
        "data-lwt-id": dataLwtId,
        ...restProps
    });
};
module.exports.default = $442307e817688bb7$var$PaginationItem;

});
parcelRegister("bg7gF", function(module, exports) {

$parcel$export(module.exports, "default", () => $8326d3933f84d9a8$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $e9hDx = parcelRequire("e9hDx");
var $8326d3933f84d9a8$var$propTypes = {
    active: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    tag: (0, $e9hDx.tagPropType)
};
var $8326d3933f84d9a8$var$defaultProps = {
    tag: "li"
};
var $8326d3933f84d9a8$var$PaginationItem = function PaginationItem(props) {
    var active = props.active, className = props.className, cssModule = props.cssModule, disabled = props.disabled, Tag = props.tag, attributes = (0, $1En50.default)(props, [
        "active",
        "className",
        "cssModule",
        "disabled",
        "tag"
    ]);
    var classes = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, "page-item", {
        active: active,
        disabled: disabled
    }), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({}, attributes, {
        className: classes
    }));
};
$8326d3933f84d9a8$var$PaginationItem.propTypes = $8326d3933f84d9a8$var$propTypes;
$8326d3933f84d9a8$var$PaginationItem.defaultProps = $8326d3933f84d9a8$var$defaultProps;
var $8326d3933f84d9a8$export$2e2bcd8739ae039 = $8326d3933f84d9a8$var$PaginationItem;

});


parcelRegister("3os0Q", function(module, exports) {
"use strict";
var $278957b1eb3888f0$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $278957b1eb3888f0$var$react_1 = $278957b1eb3888f0$var$__importDefault((parcelRequire("acw62")));

var $9P0gr = parcelRequire("9P0gr");
const $278957b1eb3888f0$var$PaginationLink = (props)=>{
    const { dataLwtId: dataLwtId, ...restProps } = props;
    // avoids typescript error TS2769 when attempting to use 'restProps'
    const paginationProps = restProps;
    return $278957b1eb3888f0$var$react_1.default.createElement($9P0gr.default, {
        "data-lwt-id": dataLwtId,
        ...paginationProps
    });
};
module.exports.default = $278957b1eb3888f0$var$PaginationLink;

});
parcelRegister("9P0gr", function(module, exports) {

$parcel$export(module.exports, "default", () => $726914f360f4d057$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $e9hDx = parcelRequire("e9hDx");
var $726914f360f4d057$var$propTypes = {
    "aria-label": (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    next: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    previous: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    first: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    last: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    tag: (0, $e9hDx.tagPropType)
};
var $726914f360f4d057$var$defaultProps = {
    tag: "a"
};
var $726914f360f4d057$var$PaginationLink = function PaginationLink(props) {
    var className = props.className, cssModule = props.cssModule, next = props.next, previous = props.previous, first = props.first, last = props.last, Tag = props.tag, attributes = (0, $1En50.default)(props, [
        "className",
        "cssModule",
        "next",
        "previous",
        "first",
        "last",
        "tag"
    ]);
    var classes = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, "page-link"), cssModule);
    var defaultAriaLabel;
    if (previous) defaultAriaLabel = "Previous";
    else if (next) defaultAriaLabel = "Next";
    else if (first) defaultAriaLabel = "First";
    else if (last) defaultAriaLabel = "Last";
    var ariaLabel = props["aria-label"] || defaultAriaLabel;
    var defaultCaret;
    if (previous) defaultCaret = "\u2039";
    else if (next) defaultCaret = "\u203A";
    else if (first) defaultCaret = "\xab";
    else if (last) defaultCaret = "\xbb";
    var children = props.children;
    if (children && Array.isArray(children) && children.length === 0) children = null;
    if (!attributes.href && Tag === "a") Tag = "button";
    if (previous || next || first || last) children = [
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-hidden": "true",
            key: "caret"
        }, children || defaultCaret),
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "sr-only",
            key: "sr"
        }, ariaLabel)
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({}, attributes, {
        className: classes,
        "aria-label": ariaLabel
    }), children);
};
$726914f360f4d057$var$PaginationLink.propTypes = $726914f360f4d057$var$propTypes;
$726914f360f4d057$var$PaginationLink.defaultProps = $726914f360f4d057$var$defaultProps;
var $726914f360f4d057$export$2e2bcd8739ae039 = $726914f360f4d057$var$PaginationLink;

});



parcelRegister("9GSMu", function(module, exports) {

$parcel$export(module.exports, "default", () => $70e287b4493f0050$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $hDpcU = parcelRequire("hDpcU");

var $g7ajw = parcelRequire("g7ajw");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8j0J5 = parcelRequire("8j0J5");

var $8g1PZ = parcelRequire("8g1PZ");

var $d2d2p = parcelRequire("d2d2p");

var $e9hDx = parcelRequire("e9hDx");
var $70e287b4493f0050$var$propTypes = {
    a11y: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    direction: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "up",
        "down",
        "left",
        "right"
    ]),
    group: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    nav: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    active: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    addonType: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
            "prepend",
            "append"
        ])
    ]),
    size: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    tag: (0, $e9hDx.tagPropType),
    toggle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    inNavbar: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    setActiveFromChild: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
var $70e287b4493f0050$var$defaultProps = {
    a11y: true,
    isOpen: false,
    direction: "down",
    nav: false,
    active: false,
    addonType: false,
    inNavbar: false,
    setActiveFromChild: false
};
var $70e287b4493f0050$var$preventDefaultKeys = [
    (0, $e9hDx.keyCodes).space,
    (0, $e9hDx.keyCodes).enter,
    (0, $e9hDx.keyCodes).up,
    (0, $e9hDx.keyCodes).down,
    (0, $e9hDx.keyCodes).end,
    (0, $e9hDx.keyCodes).home
];
var $70e287b4493f0050$var$Dropdown = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(Dropdown, _React$Component);
    function Dropdown(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.addEvents = _this.addEvents.bind((0, $hDpcU.default)(_this));
        _this.handleDocumentClick = _this.handleDocumentClick.bind((0, $hDpcU.default)(_this));
        _this.handleKeyDown = _this.handleKeyDown.bind((0, $hDpcU.default)(_this));
        _this.removeEvents = _this.removeEvents.bind((0, $hDpcU.default)(_this));
        _this.toggle = _this.toggle.bind((0, $hDpcU.default)(_this));
        _this.handleMenuRef = _this.handleMenuRef.bind((0, $hDpcU.default)(_this));
        _this.containerRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createRef();
        _this.menuRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createRef();
        return _this;
    }
    var _proto = Dropdown.prototype;
    _proto.handleMenuRef = function handleMenuRef(menuRef) {
        this.menuRef.current = menuRef;
    };
    _proto.getContextValue = function getContextValue() {
        return {
            toggle: this.toggle,
            isOpen: this.props.isOpen,
            direction: this.props.direction === "down" && this.props.dropup ? "up" : this.props.direction,
            inNavbar: this.props.inNavbar,
            disabled: this.props.disabled,
            // Callback that should be called by DropdownMenu to provide a ref to
            // a HTML tag that's used for the DropdownMenu
            onMenuRef: this.handleMenuRef
        };
    };
    _proto.componentDidMount = function componentDidMount() {
        this.handleProps();
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.isOpen !== prevProps.isOpen) this.handleProps();
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.removeEvents();
    };
    _proto.getContainer = function getContainer() {
        return this.containerRef.current;
    };
    _proto.getMenu = function getMenu() {
        return this.menuRef.current;
    };
    _proto.getMenuCtrl = function getMenuCtrl() {
        if (this._$menuCtrl) return this._$menuCtrl;
        this._$menuCtrl = this.getContainer().querySelector("[aria-expanded]");
        return this._$menuCtrl;
    };
    _proto.getMenuItems = function getMenuItems() {
        // In a real menu with a child DropdownMenu, `this.getMenu()` should never
        // be null, but it is sometimes null in tests. To mitigate that, we just
        // use `this.getContainer()` as the fallback `menuContainer`.
        var menuContainer = this.getMenu() || this.getContainer();
        return [].slice.call(menuContainer.querySelectorAll('[role="menuitem"]'));
    };
    _proto.addEvents = function addEvents() {
        var _this2 = this;
        [
            "click",
            "touchstart",
            "keyup"
        ].forEach(function(event) {
            return document.addEventListener(event, _this2.handleDocumentClick, true);
        });
    };
    _proto.removeEvents = function removeEvents() {
        var _this3 = this;
        [
            "click",
            "touchstart",
            "keyup"
        ].forEach(function(event) {
            return document.removeEventListener(event, _this3.handleDocumentClick, true);
        });
    };
    _proto.handleDocumentClick = function handleDocumentClick(e) {
        if (e && (e.which === 3 || e.type === "keyup" && e.which !== (0, $e9hDx.keyCodes).tab)) return;
        var container = this.getContainer();
        var menu = this.getMenu();
        var clickIsInContainer = container.contains(e.target) && container !== e.target;
        var clickIsInMenu = menu && menu.contains(e.target) && menu !== e.target;
        if ((clickIsInContainer || clickIsInMenu) && (e.type !== "keyup" || e.which === (0, $e9hDx.keyCodes).tab)) return;
        this.toggle(e);
    };
    _proto.handleKeyDown = function handleKeyDown(e) {
        var _this4 = this;
        var isTargetMenuItem = e.target.getAttribute("role") === "menuitem";
        var isTargetMenuCtrl = this.getMenuCtrl() === e.target;
        var isTab = (0, $e9hDx.keyCodes).tab === e.which;
        if (/input|textarea/i.test(e.target.tagName) || isTab && !this.props.a11y || isTab && !(isTargetMenuItem || isTargetMenuCtrl)) return;
        if ($70e287b4493f0050$var$preventDefaultKeys.indexOf(e.which) !== -1 || e.which >= 48 && e.which <= 90) e.preventDefault();
        if (this.props.disabled) return;
        if (isTargetMenuCtrl) {
            if ([
                (0, $e9hDx.keyCodes).space,
                (0, $e9hDx.keyCodes).enter,
                (0, $e9hDx.keyCodes).up,
                (0, $e9hDx.keyCodes).down
            ].indexOf(e.which) > -1) {
                // Open the menu (if not open) and focus the first menu item
                if (!this.props.isOpen) this.toggle(e);
                setTimeout(function() {
                    return _this4.getMenuItems()[0].focus();
                });
            } else if (this.props.isOpen && isTab) {
                // Focus the first menu item if tabbing from an open menu. We need this
                // for cases where the DropdownMenu sets a custom container, which may
                // not be the natural next item to tab to from the DropdownToggle.
                e.preventDefault();
                this.getMenuItems()[0].focus();
            } else if (this.props.isOpen && e.which === (0, $e9hDx.keyCodes).esc) this.toggle(e);
        }
        if (this.props.isOpen && e.target.getAttribute("role") === "menuitem") {
            if ([
                (0, $e9hDx.keyCodes).tab,
                (0, $e9hDx.keyCodes).esc
            ].indexOf(e.which) > -1) {
                this.toggle(e);
                this.getMenuCtrl().focus();
            } else if ([
                (0, $e9hDx.keyCodes).space,
                (0, $e9hDx.keyCodes).enter
            ].indexOf(e.which) > -1) {
                e.target.click();
                this.getMenuCtrl().focus();
            } else if ([
                (0, $e9hDx.keyCodes).down,
                (0, $e9hDx.keyCodes).up
            ].indexOf(e.which) > -1 || [
                (0, $e9hDx.keyCodes).n,
                (0, $e9hDx.keyCodes).p
            ].indexOf(e.which) > -1 && e.ctrlKey) {
                var $menuitems = this.getMenuItems();
                var index = $menuitems.indexOf(e.target);
                if ((0, $e9hDx.keyCodes).up === e.which || (0, $e9hDx.keyCodes).p === e.which && e.ctrlKey) index = index !== 0 ? index - 1 : $menuitems.length - 1;
                else if ((0, $e9hDx.keyCodes).down === e.which || (0, $e9hDx.keyCodes).n === e.which && e.ctrlKey) index = index === $menuitems.length - 1 ? 0 : index + 1;
                $menuitems[index].focus();
            } else if ((0, $e9hDx.keyCodes).end === e.which) {
                var _$menuitems = this.getMenuItems();
                _$menuitems[_$menuitems.length - 1].focus();
            } else if ((0, $e9hDx.keyCodes).home === e.which) {
                var _$menuitems2 = this.getMenuItems();
                _$menuitems2[0].focus();
            } else if (e.which >= 48 && e.which <= 90) {
                var _$menuitems3 = this.getMenuItems();
                var charPressed = String.fromCharCode(e.which).toLowerCase();
                for(var i = 0; i < _$menuitems3.length; i += 1){
                    var firstLetter = _$menuitems3[i].textContent && _$menuitems3[i].textContent[0].toLowerCase();
                    if (firstLetter === charPressed) {
                        _$menuitems3[i].focus();
                        break;
                    }
                }
            }
        }
    };
    _proto.handleProps = function handleProps() {
        if (this.props.isOpen) this.addEvents();
        else this.removeEvents();
    };
    _proto.toggle = function toggle(e) {
        if (this.props.disabled) return e && e.preventDefault();
        return this.props.toggle(e);
    };
    _proto.render = function render() {
        var _classNames, _ref;
        var _omit = (0, $e9hDx.omit)(this.props, [
            "toggle",
            "disabled",
            "inNavbar",
            "a11y"
        ]), className = _omit.className, cssModule = _omit.cssModule, direction = _omit.direction, isOpen = _omit.isOpen, group = _omit.group, size = _omit.size, nav = _omit.nav, setActiveFromChild = _omit.setActiveFromChild, active = _omit.active, addonType = _omit.addonType, tag = _omit.tag, attrs = (0, $1En50.default)(_omit, [
            "className",
            "cssModule",
            "direction",
            "isOpen",
            "group",
            "size",
            "nav",
            "setActiveFromChild",
            "active",
            "addonType",
            "tag"
        ]);
        var Tag = tag || (nav ? "li" : "div");
        var subItemIsActive = false;
        if (setActiveFromChild) (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(this.props.children[1].props.children, function(dropdownItem) {
            if (dropdownItem && dropdownItem.props.active) subItemIsActive = true;
        });
        var classes = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, direction !== "down" && "drop" + direction, nav && active ? "active" : false, setActiveFromChild && subItemIsActive ? "active" : false, (_classNames = {}, _classNames["input-group-" + addonType] = addonType, _classNames["btn-group"] = group, _classNames["btn-group-" + size] = !!size, _classNames.dropdown = !group && !addonType, _classNames.show = isOpen, _classNames["nav-item"] = nav, _classNames)), cssModule);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $d2d2p.DropdownContext).Provider, {
            value: this.getContextValue()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8j0J5.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({}, attrs, (_ref = {}, _ref[typeof Tag === "string" ? "ref" : "innerRef"] = this.containerRef, _ref), {
            onKeyDown: this.handleKeyDown,
            className: classes
        }))));
    };
    return Dropdown;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$70e287b4493f0050$var$Dropdown.propTypes = $70e287b4493f0050$var$propTypes;
$70e287b4493f0050$var$Dropdown.defaultProps = $70e287b4493f0050$var$defaultProps;
var $70e287b4493f0050$export$2e2bcd8739ae039 = $70e287b4493f0050$var$Dropdown;

});
parcelRegister("d2d2p", function(module, exports) {

$parcel$export(module.exports, "DropdownContext", () => $97d5935369a22e7d$export$df140987c38a308d);

var $acw62 = parcelRequire("acw62");
var $97d5935369a22e7d$export$df140987c38a308d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({});

});


parcelRegister("2zfPk", function(module, exports) {

$parcel$export(module.exports, "default", () => $1deb208f61118db1$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $hDpcU = parcelRequire("hDpcU");

var $g7ajw = parcelRequire("g7ajw");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $d2d2p = parcelRequire("d2d2p");

var $e9hDx = parcelRequire("e9hDx");
var $1deb208f61118db1$var$propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    active: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    divider: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    tag: (0, $e9hDx.tagPropType),
    header: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    toggle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    text: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
var $1deb208f61118db1$var$defaultProps = {
    tag: "button",
    toggle: true
};
var $1deb208f61118db1$var$DropdownItem = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(DropdownItem, _React$Component);
    function DropdownItem(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.onClick = _this.onClick.bind((0, $hDpcU.default)(_this));
        _this.getTabIndex = _this.getTabIndex.bind((0, $hDpcU.default)(_this));
        return _this;
    }
    var _proto = DropdownItem.prototype;
    _proto.onClick = function onClick(e) {
        var _this$props = this.props, disabled = _this$props.disabled, header = _this$props.header, divider = _this$props.divider, text = _this$props.text;
        if (disabled || header || divider || text) {
            e.preventDefault();
            return;
        }
        if (this.props.onClick) this.props.onClick(e);
        if (this.props.toggle) this.context.toggle(e);
    };
    _proto.getTabIndex = function getTabIndex() {
        var _this$props2 = this.props, disabled = _this$props2.disabled, header = _this$props2.header, divider = _this$props2.divider, text = _this$props2.text;
        if (disabled || header || divider || text) return "-1";
        return "0";
    };
    _proto.render = function render() {
        var tabIndex = this.getTabIndex();
        var role = tabIndex > -1 ? "menuitem" : undefined;
        var _omit = (0, $e9hDx.omit)(this.props, [
            "toggle"
        ]), className = _omit.className, cssModule = _omit.cssModule, divider = _omit.divider, Tag = _omit.tag, header = _omit.header, active = _omit.active, text = _omit.text, props = (0, $1En50.default)(_omit, [
            "className",
            "cssModule",
            "divider",
            "tag",
            "header",
            "active",
            "text"
        ]);
        var classes = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, {
            disabled: props.disabled,
            "dropdown-item": !divider && !header && !text,
            active: active,
            "dropdown-header": header,
            "dropdown-divider": divider,
            "dropdown-item-text": text
        }), cssModule);
        if (Tag === "button") {
            if (header) Tag = "h6";
            else if (divider) Tag = "div";
            else if (props.href) Tag = "a";
            else if (text) Tag = "span";
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({
            type: Tag === "button" && (props.onClick || this.props.toggle) ? "button" : undefined
        }, props, {
            tabIndex: tabIndex,
            role: role,
            className: classes,
            onClick: this.onClick
        }));
    };
    return DropdownItem;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$1deb208f61118db1$var$DropdownItem.propTypes = $1deb208f61118db1$var$propTypes;
$1deb208f61118db1$var$DropdownItem.defaultProps = $1deb208f61118db1$var$defaultProps;
$1deb208f61118db1$var$DropdownItem.contextType = (0, $d2d2p.DropdownContext);
var $1deb208f61118db1$export$2e2bcd8739ae039 = $1deb208f61118db1$var$DropdownItem;

});

parcelRegister("eA2p4", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9d64abbb010eddd$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $kSlfw = parcelRequire("kSlfw");

var $1En50 = parcelRequire("1En50");

var $g7ajw = parcelRequire("g7ajw");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $1u0KT = parcelRequire("1u0KT");

var $8g1PZ = parcelRequire("8g1PZ");

var $3cbhK = parcelRequire("3cbhK");

var $d2d2p = parcelRequire("d2d2p");

var $e9hDx = parcelRequire("e9hDx");
function $a9d64abbb010eddd$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a9d64abbb010eddd$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $a9d64abbb010eddd$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $kSlfw.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $a9d64abbb010eddd$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $a9d64abbb010eddd$var$propTypes = {
    tag: (0, $e9hDx.tagPropType),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node.isRequired,
    right: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    flip: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    modifiers: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    persist: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    positionFixed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    container: (0, $e9hDx.targetPropType)
};
var $a9d64abbb010eddd$var$defaultProps = {
    tag: "div",
    flip: true
};
var $a9d64abbb010eddd$var$noFlipModifier = {
    flip: {
        enabled: false
    }
};
var $a9d64abbb010eddd$var$directionPositionMap = {
    up: "top",
    left: "left",
    right: "right",
    down: "bottom"
};
var $a9d64abbb010eddd$var$DropdownMenu = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(DropdownMenu, _React$Component);
    function DropdownMenu() {
        return _React$Component.apply(this, arguments) || this;
    }
    var _proto = DropdownMenu.prototype;
    _proto.render = function render() {
        var _this = this;
        var _this$props = this.props, className = _this$props.className, cssModule = _this$props.cssModule, right = _this$props.right, tag = _this$props.tag, flip = _this$props.flip, modifiers = _this$props.modifiers, persist = _this$props.persist, positionFixed = _this$props.positionFixed, container = _this$props.container, attrs = (0, $1En50.default)(_this$props, [
            "className",
            "cssModule",
            "right",
            "tag",
            "flip",
            "modifiers",
            "persist",
            "positionFixed",
            "container"
        ]);
        var classes = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, "dropdown-menu", {
            "dropdown-menu-right": right,
            show: this.context.isOpen
        }), cssModule);
        var Tag = tag;
        if (persist || this.context.isOpen && !this.context.inNavbar) {
            var position1 = $a9d64abbb010eddd$var$directionPositionMap[this.context.direction] || "bottom";
            var position2 = right ? "end" : "start";
            var poperPlacement = position1 + "-" + position2;
            var poperModifiers = !flip ? $a9d64abbb010eddd$var$_objectSpread($a9d64abbb010eddd$var$_objectSpread({}, modifiers), $a9d64abbb010eddd$var$noFlipModifier) : modifiers;
            var popperPositionFixed = !!positionFixed;
            var popper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3cbhK.default), {
                placement: poperPlacement,
                modifiers: poperModifiers,
                positionFixed: popperPositionFixed
            }, function(_ref) {
                var ref = _ref.ref, style = _ref.style, placement = _ref.placement;
                var combinedStyle = $a9d64abbb010eddd$var$_objectSpread($a9d64abbb010eddd$var$_objectSpread({}, _this.props.style), style);
                var handleRef = function handleRef(tagRef) {
                    // Send the ref to `react-popper`
                    ref(tagRef); // Send the ref to the parent Dropdown so that clicks outside
                    // it will cause it to close
                    var onMenuRef = _this.context.onMenuRef;
                    if (onMenuRef) onMenuRef(tagRef);
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({
                    tabIndex: "-1",
                    role: "menu",
                    ref: handleRef
                }, attrs, {
                    style: combinedStyle,
                    "aria-hidden": !_this.context.isOpen,
                    className: classes,
                    "x-placement": placement
                }));
            });
            if (container) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).createPortal(popper, (0, $e9hDx.getTarget)(container));
            else return popper;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({
            tabIndex: "-1",
            role: "menu"
        }, attrs, {
            "aria-hidden": !this.context.isOpen,
            className: classes,
            "x-placement": attrs.placement
        }));
    };
    return DropdownMenu;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$a9d64abbb010eddd$var$DropdownMenu.propTypes = $a9d64abbb010eddd$var$propTypes;
$a9d64abbb010eddd$var$DropdownMenu.defaultProps = $a9d64abbb010eddd$var$defaultProps;
$a9d64abbb010eddd$var$DropdownMenu.contextType = (0, $d2d2p.DropdownContext);
var $a9d64abbb010eddd$export$2e2bcd8739ae039 = $a9d64abbb010eddd$var$DropdownMenu;

});

parcelRegister("kXn8S", function(module, exports) {

$parcel$export(module.exports, "default", () => $f41b44e413fab7bf$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $hDpcU = parcelRequire("hDpcU");

var $g7ajw = parcelRequire("g7ajw");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $6KgD0 = parcelRequire("6KgD0");

var $d2d2p = parcelRequire("d2d2p");

var $e9hDx = parcelRequire("e9hDx");

var $3QSAp = parcelRequire("3QSAp");
var $f41b44e413fab7bf$var$propTypes = {
    caret: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    "aria-haspopup": (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    split: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    tag: (0, $e9hDx.tagPropType),
    nav: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
var $f41b44e413fab7bf$var$defaultProps = {
    "aria-haspopup": true,
    color: "secondary"
};
var $f41b44e413fab7bf$var$DropdownToggle = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(DropdownToggle, _React$Component);
    function DropdownToggle(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.onClick = _this.onClick.bind((0, $hDpcU.default)(_this));
        return _this;
    }
    var _proto = DropdownToggle.prototype;
    _proto.onClick = function onClick(e) {
        if (this.props.disabled || this.context.disabled) {
            e.preventDefault();
            return;
        }
        if (this.props.nav && !this.props.tag) e.preventDefault();
        if (this.props.onClick) this.props.onClick(e);
        this.context.toggle(e);
    };
    _proto.render = function render() {
        var _this2 = this;
        var _this$props = this.props, className = _this$props.className, color = _this$props.color, cssModule = _this$props.cssModule, caret = _this$props.caret, split = _this$props.split, nav = _this$props.nav, tag = _this$props.tag, innerRef = _this$props.innerRef, props = (0, $1En50.default)(_this$props, [
            "className",
            "color",
            "cssModule",
            "caret",
            "split",
            "nav",
            "tag",
            "innerRef"
        ]);
        var ariaLabel = props["aria-label"] || "Toggle Dropdown";
        var classes = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, {
            "dropdown-toggle": caret || split,
            "dropdown-toggle-split": split,
            "nav-link": nav
        }), cssModule);
        var children = typeof props.children !== "undefined" ? props.children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "sr-only"
        }, ariaLabel);
        var Tag;
        if (nav && !tag) {
            Tag = "a";
            props.href = "#";
        } else if (!tag) {
            Tag = (0, $3QSAp.default);
            props.color = color;
            props.cssModule = cssModule;
        } else Tag = tag;
        if (this.context.inNavbar) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({}, props, {
            className: classes,
            onClick: this.onClick,
            "aria-expanded": this.context.isOpen,
            children: children
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6KgD0.default), {
            innerRef: innerRef
        }, function(_ref) {
            var _ref2;
            var ref = _ref.ref;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({}, props, (_ref2 = {}, _ref2[typeof Tag === "string" ? "ref" : "innerRef"] = ref, _ref2), {
                className: classes,
                onClick: _this2.onClick,
                "aria-expanded": _this2.context.isOpen,
                children: children
            }));
        });
    };
    return DropdownToggle;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$f41b44e413fab7bf$var$DropdownToggle.propTypes = $f41b44e413fab7bf$var$propTypes;
$f41b44e413fab7bf$var$DropdownToggle.defaultProps = $f41b44e413fab7bf$var$defaultProps;
$f41b44e413fab7bf$var$DropdownToggle.contextType = (0, $d2d2p.DropdownContext);
var $f41b44e413fab7bf$export$2e2bcd8739ae039 = $f41b44e413fab7bf$var$DropdownToggle;

});
parcelRegister("6KgD0", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e93effa1fe7e7cd$export$2e2bcd8739ae039);

var $3p9rK = parcelRequire("3p9rK");

var $6r4zt = parcelRequire("6r4zt");

var $6zC7B = parcelRequire("6zC7B");

var $g5Zhu = parcelRequire("g5Zhu");

var $acw62 = parcelRequire("acw62");

var $kg9aN = parcelRequire("kg9aN");

var $8j0J5 = parcelRequire("8j0J5");

var $buXxn = parcelRequire("buXxn");
var $4e93effa1fe7e7cd$var$InnerReference = /*#__PURE__*/ function(_React$Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($6r4zt)))(InnerReference, _React$Component);
    function InnerReference() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        (0, (/*@__PURE__*/$parcel$interopDefault($g5Zhu)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))((0, (/*@__PURE__*/$parcel$interopDefault($6zC7B)))(_this)), "refHandler", function(node) {
            (0, $buXxn.setRef)(_this.props.innerRef, node);
            (0, $buXxn.safeInvoke)(_this.props.setReferenceNode, node);
        });
        return _this;
    }
    var _proto = InnerReference.prototype;
    _proto.componentWillUnmount = function componentWillUnmount() {
        (0, $buXxn.setRef)(this.props.innerRef, null);
    };
    _proto.render = function render() {
        (0, (/*@__PURE__*/$parcel$interopDefault($kg9aN)))(Boolean(this.props.setReferenceNode), "`Reference` should not be used outside of a `Manager` component.");
        return (0, $buXxn.unwrapArray)(this.props.children)({
            ref: this.refHandler
        });
    };
    return InnerReference;
}($acw62.Component);
function $4e93effa1fe7e7cd$export$2e2bcd8739ae039(props) {
    return $acw62.createElement((0, $8j0J5.ManagerReferenceNodeSetterContext).Consumer, null, function(setReferenceNode) {
        return $acw62.createElement($4e93effa1fe7e7cd$var$InnerReference, (0, (/*@__PURE__*/$parcel$interopDefault($3p9rK)))({
            setReferenceNode: setReferenceNode
        }, props));
    });
}

});

parcelRegister("3QSAp", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ce092244d40bc73$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $hDpcU = parcelRequire("hDpcU");

var $g7ajw = parcelRequire("g7ajw");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $e9hDx = parcelRequire("e9hDx");
var $2ce092244d40bc73$var$propTypes = {
    active: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    "aria-label": (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    block: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    outline: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    tag: (0, $e9hDx.tagPropType),
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    close: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
var $2ce092244d40bc73$var$defaultProps = {
    color: "secondary",
    tag: "button"
};
var $2ce092244d40bc73$var$Button = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(Button, _React$Component);
    function Button(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.onClick = _this.onClick.bind((0, $hDpcU.default)(_this));
        return _this;
    }
    var _proto = Button.prototype;
    _proto.onClick = function onClick(e) {
        if (this.props.disabled) {
            e.preventDefault();
            return;
        }
        if (this.props.onClick) return this.props.onClick(e);
    };
    _proto.render = function render() {
        var _this$props = this.props, active = _this$props.active, ariaLabel = _this$props["aria-label"], block = _this$props.block, className = _this$props.className, close = _this$props.close, cssModule = _this$props.cssModule, color = _this$props.color, outline = _this$props.outline, size = _this$props.size, Tag = _this$props.tag, innerRef = _this$props.innerRef, attributes = (0, $1En50.default)(_this$props, [
            "active",
            "aria-label",
            "block",
            "className",
            "close",
            "cssModule",
            "color",
            "outline",
            "size",
            "tag",
            "innerRef"
        ]);
        if (close && typeof attributes.children === "undefined") attributes.children = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            "aria-hidden": true
        }, "\xd7");
        var btnOutlineColor = "btn" + (outline ? "-outline" : "") + "-" + color;
        var classes = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, {
            close: close
        }, close || "btn", close || btnOutlineColor, size ? "btn-" + size : false, block ? "btn-block" : false, {
            active: active,
            disabled: this.props.disabled
        }), cssModule);
        if (attributes.href && Tag === "button") Tag = "a";
        var defaultAriaLabel = close ? "Close" : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({
            type: Tag === "button" && attributes.onClick ? "button" : undefined
        }, attributes, {
            className: classes,
            ref: innerRef,
            onClick: this.onClick,
            "aria-label": ariaLabel || defaultAriaLabel
        }));
    };
    return Button;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$2ce092244d40bc73$var$Button.propTypes = $2ce092244d40bc73$var$propTypes;
$2ce092244d40bc73$var$Button.defaultProps = $2ce092244d40bc73$var$defaultProps;
var $2ce092244d40bc73$export$2e2bcd8739ae039 = $2ce092244d40bc73$var$Button;

});



parcelRegister("4UcKD", function(module, exports) {
"use strict";
var $392648841e31b59c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $392648841e31b59c$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $392648841e31b59c$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $392648841e31b59c$var$__createBinding(result, mod, k);
    }
    $392648841e31b59c$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AGGridProvider = module.exports.AGGridConsumer = module.exports.AGGridContext = void 0;

const $392648841e31b59c$var$react_1 = $392648841e31b59c$var$__importStar((parcelRequire("acw62")));

var $geReh = parcelRequire("geReh");
module.exports.AGGridContext = (0, $392648841e31b59c$var$react_1.createContext)({});
module.exports.AGGridConsumer = module.exports.AGGridContext.Consumer;
const $392648841e31b59c$var$AGGridProvider = ({ license: license, children: children })=>{
    $geReh.LicenseManager.setLicenseKey(license);
    return $392648841e31b59c$var$react_1.default.createElement(module.exports.AGGridContext.Provider, {
        value: {}
    }, children);
};
module.exports.AGGridProvider = $392648841e31b59c$var$AGGridProvider;

});


parcelRegister("dSrCm", function(module, exports) {

$parcel$export(module.exports, "default", () => $1980f3dce1879f32$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $aTLkh = parcelRequire("aTLkh");

var $c9Z8w = parcelRequire("c9Z8w");
const $1980f3dce1879f32$var$ColumnHeader = (props)=>{
    const { api: api, column: column, isKeyInfoTable: isKeyInfoTable, setSort: setSort, enableSorting: enableSorting, titleWithTooltip: titleWithTooltip } = props;
    const [state, setState] = (0, $acw62.useState)({
        ascSort: column.colDef?.sort === "asc" ? "d-block" : "d-none",
        descSort: column.colDef?.sort === "desc" ? "d-block" : "d-none",
        isSortDescending: column.colDef?.sort === "desc"
    });
    const onSortChanged = (event)=>{
        const api = event.api;
        if (api.columnModel.displayedColumns) {
            const ownSortedColumn = api.columnModel.displayedColumns.filter((item)=>item.sort && item.sortIndex === 0).find((item)=>item.colId === column.colId);
            setState({
                ascSort: ownSortedColumn?.sort === "asc" ? "d-block" : "d-none",
                descSort: ownSortedColumn?.sort === "desc" ? "d-block" : "d-none",
                isSortDescending: ownSortedColumn?.sort === "desc"
            });
        }
    };
    const onBodyScroll = (e)=>{
        const sortedCol = e.api.columnModel?.displayedColumns.filter((item)=>item.sort);
        if (sortedCol && sortedCol.length > 0 && column.colId === sortedCol[0]?.colId) setState({
            ascSort: sortedCol[0].sort === "asc" ? "d-block" : "d-none",
            descSort: sortedCol[0].sort === "asc" ? "d-none" : "d-block",
            isSortDescending: !(sortedCol[0].sort === "asc")
        });
        else setState({
            ascSort: "d-none",
            descSort: "d-none",
            isSortDescending: false
        });
    };
    (0, $acw62.useEffect)(()=>{
        let isMounted = true;
        const handleSortChanged = (event)=>{
            if (isMounted) onSortChanged(event);
        };
        const handleBodyScroll = (event)=>{
            if (isMounted) onBodyScroll(event);
        };
        column.addEventListener("sortChanged", handleSortChanged);
        api.addEventListener("bodyScroll", handleBodyScroll);
        return ()=>{
            isMounted = false;
            if (column && !column.isDestroyed?.()) column.removeEventListener("sortChanged", handleSortChanged);
            if (api && !api.isDestroyed?.()) api.removeEventListener("bodyScroll", handleBodyScroll);
        };
    }, [
        api,
        column
    ]);
    const handleSort = (event)=>{
        const nextSort = state.isSortDescending ? "asc" : "desc";
        setSort(nextSort, event.shiftKey);
        const isPrimarySort = (column.getSortIndex() ?? 0) === 0;
        setState({
            ascSort: isPrimarySort && nextSort === "asc" ? "d-block" : "d-none",
            descSort: isPrimarySort && nextSort === "desc" ? "d-block" : "d-none",
            isSortDescending: nextSort === "desc"
        });
    };
    let sort = null;
    if (enableSorting) sort = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "d-inline-block",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: `div_arrow_drop_down ${state.descSort}`,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aTLkh.default), {
                    dataLwtId: "icon",
                    iconName: "arrow_drop_down"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: `div_arrow_drop_up ${state.ascSort}`,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aTLkh.default), {
                    dataLwtId: "icon",
                    iconName: "arrow_drop_up"
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "w-100 ag-header-cell-text d-inline-block ag-header-col-text",
        onClick: (event)=>handleSort(event),
        children: [
            titleWithTooltip,
            !isKeyInfoTable && sort
        ]
    });
};
$1980f3dce1879f32$var$ColumnHeader.propTypes = {
    api: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    column: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    enableSorting: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    isKeyInfoTable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    setSort: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    titleWithTooltip: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $1980f3dce1879f32$export$2e2bcd8739ae039 = $1980f3dce1879f32$var$ColumnHeader;

});

parcelRegister("8SeGW", function(module, exports) {

$parcel$export(module.exports, "getColumnDividerObserver", () => $675ec34f73d3ae50$export$2073d3df45c99f4d);

var $eHBjM = parcelRequire("eHBjM");

var $98ROn = parcelRequire("98ROn");
const $675ec34f73d3ae50$var$getCellSize = (cell)=>cell.offsetLeft + cell.offsetWidth;
const $675ec34f73d3ae50$export$1e3e5b89bc7ca42e = ({ tableId: tableId, headerGroupColIds: headerGroupColIds })=>{
    const allDividerElements = document.querySelectorAll(`#${tableId} .left-divider-col`);
    allDividerElements?.forEach((element)=>element.classList.remove((0, $98ROn.dividerClassNames).leftDividerCol));
    const groupCells = Array.from(document.querySelectorAll(`#${tableId} .ag-header-group-cell`));
    const headerCells = Array.from(document.querySelectorAll(`#${tableId} .ag-header-cell`));
    const agFloatingFilterCells = Array.from(document.querySelectorAll(`#${tableId} .ag-floating-filter`));
    headerGroupColIds.forEach((groupId)=>{
        const groupCell = groupCells.find((cell)=>cell.getAttribute("col-id") === groupId);
        if (!groupCell) return;
        groupCell.classList.add((0, $98ROn.dividerClassNames).leftDividerCol);
        const resizeElement = groupCell.querySelector(`#${tableId} .ag-header-cell-resize`);
        if (resizeElement) resizeElement.classList.add((0, $98ROn.dividerClassNames).transparentResizeIcon);
        const groupRight = $675ec34f73d3ae50$var$getCellSize(groupCell);
        const groupHeaderCells = headerCells.filter((cell)=>{
            return Math.abs($675ec34f73d3ae50$var$getCellSize(cell) - groupRight) <= 20;
        });
        if (groupHeaderCells.length === 0) return;
        let lastHeaderCell = groupHeaderCells[0];
        let maxRight = $675ec34f73d3ae50$var$getCellSize(lastHeaderCell);
        groupHeaderCells.forEach((cell)=>{
            const right = $675ec34f73d3ae50$var$getCellSize(cell);
            if (right > maxRight) {
                lastHeaderCell = cell;
                maxRight = right;
            }
        });
        const agFloatingCells = agFloatingFilterCells.filter((cell)=>{
            return Math.abs($675ec34f73d3ae50$var$getCellSize(cell) - groupRight) <= 20;
        });
        agFloatingCells?.forEach((cell)=>cell.classList.add((0, $98ROn.dividerClassNames).leftDividerCol));
        if (lastHeaderCell) {
            lastHeaderCell.classList.add((0, $98ROn.dividerClassNames).leftDividerCol);
            const colId = lastHeaderCell.getAttribute("col-id");
            const rowCells = document.querySelectorAll(`#${tableId} .ag-cell[col-id='${colId}']`);
            rowCells?.forEach((cell)=>cell.classList.add((0, $98ROn.dividerClassNames).leftDividerCol));
            groupCell.classList.add((0, $98ROn.dividerClassNames).leftDividerCol);
            const resizeElement = lastHeaderCell.querySelector(`#${tableId} .ag-header-cell-resize`);
            if (resizeElement) resizeElement.classList.add((0, $98ROn.dividerClassNames).transparentResizeIcon);
        }
    });
};
const $675ec34f73d3ae50$var$headerGroupColIdsByTableId = {
    [(0, $eHBjM.tableViewNames).agentMovement]: [
        "0_0",
        "1_0",
        "2_0"
    ]
};
const $675ec34f73d3ae50$export$2073d3df45c99f4d = (tableId)=>{
    if (!$675ec34f73d3ae50$var$headerGroupColIdsByTableId[tableId]) return null;
    return new MutationObserver(()=>{
        setTimeout(()=>{
            const tableNode = document.querySelector(`#${tableId}`);
            if (tableNode) $675ec34f73d3ae50$export$1e3e5b89bc7ca42e({
                tableId: tableId,
                headerGroupColIds: $675ec34f73d3ae50$var$headerGroupColIdsByTableId[tableId]
            });
        }, 200);
    });
};

});

parcelRegister("koMgC", function(module, exports) {

$parcel$export(module.exports, "getIsCrossViewSelectionEnabled", () => $ed9b7d59c0df8004$export$c5bb7f8d8a683912);
$parcel$export(module.exports, "getSelectedAgentIds", () => $ed9b7d59c0df8004$export$5cbb3f1c20a26900);

var $eHBjM = parcelRequire("eHBjM");

var $cstaF = parcelRequire("cstaF");
const $ed9b7d59c0df8004$export$ca32bef11d5e48b = [
    (0, $cstaF.modules).proficiencyMetrics.transactions,
    (0, $cstaF.modules).proficiencyMetrics.agents,
    (0, $cstaF.modules).proficiencyMetrics.offices,
    (0, $cstaF.modules).proficiencyMetrics.savedAgents,
    (0, $cstaF.modules).proficiencyMetrics.suggestedAgents
];
const $ed9b7d59c0df8004$export$aa0198f173dcc3d6 = [
    (0, $eHBjM.tableViewNames).overview,
    (0, $eHBjM.tableViewNames).overviewCoopAgents,
    (0, $eHBjM.tableViewNames).incDecOverview,
    (0, $eHBjM.tableViewNames).contactInformation,
    (0, $eHBjM.tableViewNames).growthAnalysisLtm,
    (0, $eHBjM.tableViewNames).growthAnalysisYtd,
    (0, $eHBjM.tableViewNames).growthAnalysisL90,
    (0, $eHBjM.tableViewNames).incDecGrowthAnalysisLtm,
    (0, $eHBjM.tableViewNames).incDecGrowthAnalysisYtd,
    (0, $eHBjM.tableViewNames).listingProficiency
];
const $ed9b7d59c0df8004$export$c5bb7f8d8a683912 = (module, tableViewName)=>{
    return $ed9b7d59c0df8004$export$ca32bef11d5e48b.includes(module) && $ed9b7d59c0df8004$export$aa0198f173dcc3d6.includes(tableViewName);
};
const $ed9b7d59c0df8004$export$e74b8fb5f849f3e3 = (module)=>{
    return $ed9b7d59c0df8004$export$ca32bef11d5e48b.includes(module);
};
const $ed9b7d59c0df8004$export$5cbb3f1c20a26900 = (state)=>{
    const moduleState = state[state.selectedModule];
    if (state.selectedModule === (0, $cstaF.modules).proficiencyMetrics.suggestedAgents) {
        const tabId = moduleState?.currentTabId;
        return tabId ? moduleState?.selectedAgentIdsByTab?.[tabId] : undefined;
    }
    return moduleState?.selectedAgentIds;
};

});


parcelRegister("eEE2e", function(module, exports) {

$parcel$export(module.exports, "availableOfficesColumns", () => $aab3db3752ddfe98$export$16bf2d32cd863a68);
$parcel$export(module.exports, "getColumnsWithFilters", () => $aab3db3752ddfe98$export$25fbb23591534640);

var $eHBjM = parcelRequire("eHBjM");

var $cstaF = parcelRequire("cstaF");

var $kWnaD = parcelRequire("kWnaD");

var $98ROn = parcelRequire("98ROn");
const $aab3db3752ddfe98$export$16bf2d32cd863a68 = {
    [(0, $eHBjM.tableViewNames).availableOffices]: {
        id: (0, $eHBjM.tableViewNames).availableOffices,
        sortable: false,
        showPagination: false,
        tables: [
            {
                col: (0, $eHBjM.agentsColumns).isSelected,
                sortable: false,
                colDef: {
                    ...(0, $98ROn.colSettings).checkboxSmall,
                    headerCheckboxSelection: true,
                    checkboxSelection: true
                }
            },
            {
                col: (0, $eHBjM.agentsColumns).officeName,
                sortable: false,
                colDef: (0, $98ROn.colSettings).textSm,
                filterPlaceholder: (0, $cstaF.searchTerms).searchName
            },
            {
                col: (0, $eHBjM.agentsColumns).officeId,
                sortable: false,
                colDef: (0, $98ROn.colSettings).textSmall,
                filterPlaceholder: (0, $cstaF.searchTerms).searchId
            },
            {
                col: (0, $eHBjM.agentsColumns).streetName,
                sortable: false,
                colDef: (0, $98ROn.colSettings).textSm,
                filterPlaceholder: (0, $cstaF.searchTerms).searchAddress
            },
            {
                col: (0, $eHBjM.agentsColumns).city,
                sortable: false,
                colDef: (0, $98ROn.colSettings).textXs,
                filterPlaceholder: (0, $eHBjM.agentsColumns).city.label
            },
            {
                col: (0, $eHBjM.agentsColumns).zipCode,
                sortable: false,
                colDef: (0, $98ROn.colSettings).textXs,
                filterPlaceholder: (0, $eHBjM.agentsColumns).zipCode.label
            },
            {
                col: (0, $eHBjM.agentsColumns).county,
                sortable: false,
                colDef: (0, $98ROn.colSettings).textSmall,
                filterPlaceholder: (0, $eHBjM.agentsColumns).county.label
            },
            {
                col: (0, $eHBjM.agentsColumns).producingAgentCount,
                sortable: false,
                colDef: (0, $98ROn.colSettings).numberSmTiny
            },
            {
                col: (0, $eHBjM.agentsColumns).totalVolume,
                sortable: false,
                colDef: (0, $98ROn.colSettings).blankEmptyXsVolume
            }
        ]
    }
};
const $aab3db3752ddfe98$export$25fbb23591534640 = ()=>{
    return {
        ...$aab3db3752ddfe98$export$16bf2d32cd863a68.availableOffices,
        tables: $aab3db3752ddfe98$export$16bf2d32cd863a68.availableOffices?.tables.map((col)=>{
            if (col.col.id === (0, $eHBjM.agentsColumns).producingAgentCount.id || col.col.id === (0, $eHBjM.agentsColumns).totalVolume.id || col.col.id === (0, $eHBjM.agentsColumns).isSelected.id) return col;
            return {
                ...col,
                filterOptions: {
                    filter: "agTextColumnFilter",
                    floatingFilterComponent: (0, $kWnaD.default),
                    floatingFilter: true,
                    floatingFilterComponentParams: {
                        placeholder: col?.filterPlaceholder
                    },
                    supressMenu: true,
                    suppressFiltersToolPanel: true
                }
            };
        })
    };
};

});

parcelRegister("6xHGz", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c37b62cd0d44a36$export$2e2bcd8739ae039);

var $eHBjM = parcelRequire("eHBjM");

var $98ROn = parcelRequire("98ROn");
const $4c37b62cd0d44a36$var$addedOfficesColumns = {
    [(0, $eHBjM.tableViewNames).addedOffices]: {
        id: (0, $eHBjM.tableViewNames).addedOffices,
        sortable: false,
        showPagination: false,
        tables: [
            {
                col: (0, $eHBjM.agentsColumns).isSelected,
                sortable: false,
                colDef: {
                    ...(0, $98ROn.colSettings).checkboxMedium,
                    headerCheckboxSelection: true,
                    checkboxSelection: true
                }
            },
            {
                col: (0, $eHBjM.agentsColumns).officeName,
                colDef: (0, $98ROn.colSettings).textSm
            },
            {
                col: (0, $eHBjM.agentsColumns).officeId,
                colDef: (0, $98ROn.colSettings).textSmRightAlign
            },
            {
                col: (0, $eHBjM.agentsColumns).city,
                colDef: (0, $98ROn.colSettings).textSm
            }
        ]
    }
};
var $4c37b62cd0d44a36$export$2e2bcd8739ae039 = $4c37b62cd0d44a36$var$addedOfficesColumns;

});


parcelRegister("3RdAS", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5e24978b9d999e3$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $7tOHe = parcelRequire("7tOHe");

var $cstaF = parcelRequire("cstaF");

var $aTLkh = parcelRequire("aTLkh");

var $dI25G = parcelRequire("dI25G");

var $eOjgM = parcelRequire("eOjgM");

var $7ROc5 = parcelRequire("7ROc5");

var $bwlfW = parcelRequire("bwlfW");
const $e5e24978b9d999e3$var$TransferList = (props)=>{
    const { renderedAvailableItems: renderedAvailableItems, renderedAddedItems: renderedAddedItems, addAll: addAll, removeAll: removeAll, showEditModal: showEditModal, closeEditModal: closeEditModal, modalIsOpen: modalIsOpen, selectedList: selectedList, selectedItems: selectedItems, saveList: saveList, updateList: updateList, availableWidth: availableWidth, addedWidth: addedWidth, disabled: disabled, editModalHeader: editModalHeader, idProperty: idProperty, isDirty: isDirty, isLoadingAddedItems: isLoadingAddedItems, shouldHideSaveAsListButton: shouldHideSaveAsListButton, isAddAllDisabled: isAddAllDisabled, addSelected: addSelected, removeSelected: removeSelected, checkedAddedOffices: checkedAddedOffices, checkedAvailableOffices: checkedAvailableOffices } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `w-100 d-inline-block transfer-list-menu ${idProperty}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "available-column-wrapper",
                style: {
                    width: availableWidth || "48%"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "transfer-column-header",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "helix-body--strong",
                            children: "Available"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "available-items transfer-items-list",
                        children: renderedAvailableItems
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "add-controls float-left",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                                dataLwtId: "add-all",
                                color: "secondary",
                                onClick: addAll,
                                disabled: isAddAllDisabled,
                                children: [
                                    (0, $cstaF.buttonTerms).all,
                                    " ",
                                    ">"
                                ]
                            }),
                            checkedAvailableOffices && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                                dataLwtId: "add-selected",
                                color: "secondary",
                                onClick: addSelected,
                                disabled: isAddAllDisabled,
                                children: [
                                    (0, $cstaF.buttonTerms).selected,
                                    " ",
                                    `> (${checkedAvailableOffices?.length})`
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "transfer-column-separator",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "transfer-list-bar"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "transfer-icon",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                            icon: (0, $eOjgM.arrows_exchange),
                            ...(0, $7ROc5.chipIconProps),
                            title: "exchange icon"
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "transfer-list-bar"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "added-column-wrapper",
                style: {
                    width: addedWidth || "48%"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "transfer-column-header",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "helix-body--strong",
                                children: "Added"
                            }),
                            !shouldHideSaveAsListButton && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                                dataLwtId: "edit-list",
                                size: "sm",
                                color: "light",
                                className: "text-capitalize",
                                id: "edit-list",
                                onClick: showEditModal,
                                style: {
                                    padding: "0 0 2px 0"
                                },
                                disabled: disabled,
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aTLkh.default), {
                                        className: "mr-1 text-primary",
                                        iconName: "add_circle",
                                        dataLwtId: "add-icon"
                                    }),
                                    selectedList ? (0, $cstaF.searchTerms).saveList : (0, $cstaF.searchTerms).saveAsList
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bwlfW.default), {
                        closeEditModal: closeEditModal,
                        modalIsOpen: modalIsOpen,
                        initialList: selectedList,
                        idProperty: idProperty,
                        onSaveNew: saveList,
                        onUpdate: updateList,
                        disabled: disabled,
                        headerContent: editModalHeader,
                        isDirty: isDirty
                    }, "transfer-edit-list"),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "added-items transfer-items-list",
                        children: isLoadingAddedItems ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {}) : renderedAddedItems
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "remove-controls float-right",
                        children: [
                            checkedAddedOffices && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                                dataLwtId: "remove-selected",
                                color: "secondary",
                                onClick: removeSelected,
                                disabled: !selectedItems?.length,
                                children: [
                                    `(${checkedAddedOffices?.length}) < `,
                                    " ",
                                    (0, $cstaF.buttonTerms).selected
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                                dataLwtId: "remove-all",
                                color: "secondary",
                                onClick: removeAll,
                                disabled: !selectedItems?.length,
                                children: [
                                    "< ",
                                    (0, $cstaF.buttonTerms).all
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $e5e24978b9d999e3$export$2e2bcd8739ae039 = $e5e24978b9d999e3$var$TransferList;

});
parcelRegister("bwlfW", function(module, exports) {

$parcel$export(module.exports, "default", () => $b69f86aacf42051a$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $f61ig = parcelRequire("f61ig");
parcelRequire("fHiKR");
var $5txPe = parcelRequire("5txPe");
var $kN5vy = parcelRequire("kN5vy");
parcelRequire("3lOdM");
var $e155p = parcelRequire("e155p");

var $ivaD7 = parcelRequire("ivaD7");

var $cstaF = parcelRequire("cstaF");

var $eHBjM = parcelRequire("eHBjM");

var $etdjB = parcelRequire("etdjB");
const $b69f86aacf42051a$var$EditListModal = (props)=>{
    const { key: key, closeEditModal: closeEditModal, modalIsOpen: modalIsOpen, initialList: initialList, idProperty: idProperty, onSaveNew: onSaveNew, onUpdate: onUpdate, onDelete: onDelete, headerContent: headerContent, isDirty: isDirty } = props;
    const [state, setState] = (0, $acw62.useState)({
        reservedNameWarning: ""
    });
    const listNameInput = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(()=>{
        (0, $ivaD7.setStateData)("modalIsOpen", modalIsOpen, setState);
    }, [
        modalIsOpen
    ]);
    (0, $acw62.useEffect)(()=>{
        (0, $ivaD7.setStateData)("selectedList", {
            ...initialList
        }, setState);
    }, [
        initialList
    ]);
    const updateListProperty = (e, property)=>{
        const value = e.target.value.trim();
        (0, $ivaD7.setStateData)("selectedList", {
            ...state.selectedList,
            [property]: value
        }, setState);
        if (value.toLowerCase() === (0, $eHBjM.favoriteAgentTerms).reservedListName.toLowerCase()) (0, $ivaD7.setStateData)("reservedNameWarning", (0, $eHBjM.favoriteAgentTerms).reservedListWarning, setState);
        else (0, $ivaD7.setStateData)("reservedNameWarning", "", setState);
    };
    const editListContent = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "modal-warning",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "m-0 text-danger warning-container",
                children: state.reservedNameWarning
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mx-3",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($e155p))), {
                    className: "pt-0",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kN5vy))), {
                            dataLwtId: "list-name-label",
                            children: (0, $cstaF.searchTerms).listName
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5txPe))), {
                            className: "mt-2",
                            innerRef: listNameInput,
                            dataLwtId: "list-name-input",
                            onChange: (e)=>updateListProperty(e, "name"),
                            defaultValue: initialList?.name,
                            maxLength: 80,
                            autoFocus: true
                        })
                    ]
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f61ig.default), {
        title: headerContent,
        children: editListContent,
        show: state.modalIsOpen,
        onClose: ()=>{
            closeEditModal();
            (0, $ivaD7.setStateData)("selectedList", {
                ...state.selectedList,
                name: initialList?.name
            }, setState);
            (0, $ivaD7.setStateData)("reservedNameWarning", "", setState);
        },
        onOpened: ()=>(0, $etdjB.checkReservedName)(listNameInput, setState, (0, $ivaD7.setStateData)),
        buttons: initialList?.[idProperty] ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "w-100",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "float-left",
                    style: {
                        padding: "5px 10px"
                    },
                    children: onDelete && /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                        dataLwtId: "delete-icon",
                        color: "danger",
                        onClick: ()=>onDelete(state.selectedList),
                        id: "delete-link",
                        children: (0, $cstaF.buttonTerms).delete
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "float-right",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                            dataLwtId: "saveAsNew",
                            id: (0, $cstaF.buttonTerms).saveAsNewButtonId,
                            color: "outline-primary",
                            disabled: !state.selectedList || !state.selectedList.name?.length || state.selectedList.name === initialList?.name || !!state.reservedNameWarning,
                            onClick: (e)=>onSaveNew(e.target, {
                                    ...state.selectedList,
                                    id: undefined
                                }, true),
                            children: (0, $cstaF.buttonTerms).saveAsNew
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                            dataLwtId: "update",
                            color: "primary",
                            id: (0, $cstaF.buttonTerms).updateButtonId,
                            onClick: (e)=>onUpdate(e.target, state.selectedList, state.selectedList.name !== initialList?.name),
                            disabled: !state.selectedList || !state.selectedList.name?.length || state.selectedList.name === initialList?.name && !isDirty || !!state.reservedNameWarning,
                            children: (0, $cstaF.buttonTerms).update
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
            dataLwtId: "save",
            id: (0, $cstaF.buttonTerms).saveAsNewButtonId,
            color: "primary",
            onClick: (e)=>{
                onSaveNew(e.target, state.selectedList, true);
            },
            disabled: !state.selectedList?.name || !!state.reservedNameWarning,
            children: (0, $cstaF.buttonTerms).save
        })
    }, key);
};
var $b69f86aacf42051a$export$2e2bcd8739ae039 = $b69f86aacf42051a$var$EditListModal;

});
parcelRegister("etdjB", function(module, exports) {

$parcel$export(module.exports, "checkReservedName", () => $a88e1a4360ae3ace$export$932aedfa64120262);

var $eHBjM = parcelRequire("eHBjM");
const $a88e1a4360ae3ace$export$932aedfa64120262 = (inputRef, setState, setStateData)=>{
    const value = inputRef.current?.value?.trim().toLowerCase();
    if (value === (0, $eHBjM.favoriteAgentTerms).reservedListName.toLowerCase()) setStateData("reservedNameWarning", (0, $eHBjM.favoriteAgentTerms).reservedListWarning, setState);
    inputRef.current?.focus();
};

});



parcelRegister("jsC5X", function(module, exports) {
"use strict";

var $1Hdcz = parcelRequire("1Hdcz");

var $8jN3b = parcelRequire("8jN3b");

var $4Kuwt = parcelRequire("4Kuwt");

var $iRXC6 = parcelRequire("iRXC6");
function $e2ae2ebc75109f13$var$_classPrivateFieldLooseBase(receiver, privateKey) {
    if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) throw new TypeError("attempted to use private field on non-instance");
    return receiver;
}
var $e2ae2ebc75109f13$var$id = 0;
function $e2ae2ebc75109f13$var$_classPrivateFieldLooseKey(name) {
    return "__private_" + $e2ae2ebc75109f13$var$id++ + "_" + name;
}

var $bnV4R = parcelRequire("bnV4R");

var $i7NSv = parcelRequire("i7NSv");

var $kBmkp = parcelRequire("kBmkp");

var $bbQz1 = parcelRequire("bbQz1");

var $bs0mo = parcelRequire("bs0mo");

var $lB5wD = parcelRequire("lB5wD");

var $jk22o = parcelRequire("jk22o");

var $jLt6s = parcelRequire("jLt6s");

var $exYxU = parcelRequire("exYxU");

var $bdnKs = parcelRequire("bdnKs");
const $e2ae2ebc75109f13$var$packageJson = {
    "version": "2.4.3"
};

var $fW148 = parcelRequire("fW148");
const $e2ae2ebc75109f13$var$memoize = $jk22o.default || $jk22o;
const $e2ae2ebc75109f13$var$TAB_KEY = 9;
const $e2ae2ebc75109f13$var$ESC_KEY = 27;
function $e2ae2ebc75109f13$var$createPromise() {
    const o = {};
    o.promise = new Promise((resolve, reject)=>{
        o.resolve = resolve;
        o.reject = reject;
    });
    return o;
}
function $e2ae2ebc75109f13$var$defaultPickerIcon() {
    return (0, $1Hdcz.h)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        width: "30",
        height: "30",
        viewBox: "0 0 30 30"
    }, (0, $1Hdcz.h)("path", {
        d: "M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15zm4.258-12.676v6.846h-8.426v-6.846H5.204l9.82-12.364 9.82 12.364H19.26z"
    }));
}
/**
 * Dashboard UI with previews, metadata editing, tabs for various services and more
 */ var $e2ae2ebc75109f13$var$_openFileEditorWhenFilesAdded = /*#__PURE__*/ $e2ae2ebc75109f13$var$_classPrivateFieldLooseKey("openFileEditorWhenFilesAdded");
var $e2ae2ebc75109f13$var$_attachRenderFunctionToTarget = /*#__PURE__*/ $e2ae2ebc75109f13$var$_classPrivateFieldLooseKey("attachRenderFunctionToTarget");
var $e2ae2ebc75109f13$var$_isTargetSupported = /*#__PURE__*/ $e2ae2ebc75109f13$var$_classPrivateFieldLooseKey("isTargetSupported");
var $e2ae2ebc75109f13$var$_getAcquirers = /*#__PURE__*/ $e2ae2ebc75109f13$var$_classPrivateFieldLooseKey("getAcquirers");
var $e2ae2ebc75109f13$var$_getProgressIndicators = /*#__PURE__*/ $e2ae2ebc75109f13$var$_classPrivateFieldLooseKey("getProgressIndicators");
var $e2ae2ebc75109f13$var$_getEditors = /*#__PURE__*/ $e2ae2ebc75109f13$var$_classPrivateFieldLooseKey("getEditors");
class $e2ae2ebc75109f13$var$Dashboard extends $8jN3b.UIPlugin {
    constructor(uppy, _opts){
        var _this;
        super(uppy, _opts);
        _this = this;
        this.removeTarget = (plugin)=>{
            const pluginState = this.getPluginState(); // filter out the one we want to remove
            const newTargets = pluginState.targets.filter((target)=>target.id !== plugin.id);
            this.setPluginState({
                targets: newTargets
            });
        };
        this.addTarget = (plugin)=>{
            const callerPluginId = plugin.id || plugin.constructor.name;
            const callerPluginName = plugin.title || callerPluginId;
            const callerPluginType = plugin.type;
            if (callerPluginType !== "acquirer" && callerPluginType !== "progressindicator" && callerPluginType !== "editor") {
                const msg = "Dashboard: can only be targeted by plugins of types: acquirer, progressindicator, editor";
                this.uppy.log(msg, "error");
                return undefined;
            }
            const target = {
                id: callerPluginId,
                name: callerPluginName,
                type: callerPluginType
            };
            const state = this.getPluginState();
            const newTargets = state.targets.slice();
            newTargets.push(target);
            this.setPluginState({
                targets: newTargets
            });
            return this.el;
        };
        this.hideAllPanels = ()=>{
            const state = this.getPluginState();
            const update = {
                activePickerPanel: false,
                showAddFilesPanel: false,
                activeOverlayType: null,
                fileCardFor: null,
                showFileEditor: false
            };
            if (state.activePickerPanel === update.activePickerPanel && state.showAddFilesPanel === update.showAddFilesPanel && state.showFileEditor === update.showFileEditor && state.activeOverlayType === update.activeOverlayType) // avoid doing a state update if nothing changed
            return;
            this.setPluginState(update);
        };
        this.showPanel = (id)=>{
            const { targets: targets } = this.getPluginState();
            const activePickerPanel = targets.filter((target)=>{
                return target.type === "acquirer" && target.id === id;
            })[0];
            this.setPluginState({
                activePickerPanel: activePickerPanel,
                activeOverlayType: "PickerPanel"
            });
        };
        this.canEditFile = (file)=>{
            const { targets: targets } = this.getPluginState();
            const editors = $e2ae2ebc75109f13$var$_classPrivateFieldLooseBase(this, $e2ae2ebc75109f13$var$_getEditors)[$e2ae2ebc75109f13$var$_getEditors](targets);
            return editors.some((target)=>this.uppy.getPlugin(target.id).canEditFile(file));
        };
        this.openFileEditor = (file)=>{
            const { targets: targets } = this.getPluginState();
            const editors = $e2ae2ebc75109f13$var$_classPrivateFieldLooseBase(this, $e2ae2ebc75109f13$var$_getEditors)[$e2ae2ebc75109f13$var$_getEditors](targets);
            this.setPluginState({
                showFileEditor: true,
                fileCardFor: file.id || null,
                activeOverlayType: "FileEditor"
            });
            editors.forEach((editor)=>{
                this.uppy.getPlugin(editor.id).selectFile(file);
            });
        };
        this.saveFileEditor = ()=>{
            const { targets: targets } = this.getPluginState();
            const editors = $e2ae2ebc75109f13$var$_classPrivateFieldLooseBase(this, $e2ae2ebc75109f13$var$_getEditors)[$e2ae2ebc75109f13$var$_getEditors](targets);
            editors.forEach((editor)=>{
                this.uppy.getPlugin(editor.id).save();
            });
            this.hideAllPanels();
        };
        this.openModal = ()=>{
            const { promise: promise, resolve: resolve } = $e2ae2ebc75109f13$var$createPromise(); // save scroll position
            this.savedScrollPosition = window.pageYOffset; // save active element, so we can restore focus when modal is closed
            this.savedActiveElement = document.activeElement;
            if (this.opts.disablePageScrollWhenModalOpen) document.body.classList.add("uppy-Dashboard-isFixed");
            if (this.opts.animateOpenClose && this.getPluginState().isClosing) {
                const handler = ()=>{
                    this.setPluginState({
                        isHidden: false
                    });
                    this.el.removeEventListener("animationend", handler, false);
                    resolve();
                };
                this.el.addEventListener("animationend", handler, false);
            } else {
                this.setPluginState({
                    isHidden: false
                });
                resolve();
            }
            if (this.opts.browserBackButtonClose) this.updateBrowserHistory();
             // handle ESC and TAB keys in modal dialog
            document.addEventListener("keydown", this.handleKeyDownInModal);
            this.uppy.emit("dashboard:modal-open");
            return promise;
        };
        this.closeModal = function(opts) {
            if (opts === void 0) opts = {};
            const { manualClose: // Whether the modal is being closed by the user (`true`) or by other means (e.g. browser back button)
            manualClose = true } = opts;
            const { isHidden: isHidden, isClosing: isClosing } = _this.getPluginState();
            if (isHidden || isClosing) // short-circuit if animation is ongoing
            return undefined;
            const { promise: promise, resolve: resolve } = $e2ae2ebc75109f13$var$createPromise();
            if (_this.opts.disablePageScrollWhenModalOpen) document.body.classList.remove("uppy-Dashboard-isFixed");
            if (_this.opts.animateOpenClose) {
                _this.setPluginState({
                    isClosing: true
                });
                const handler = ()=>{
                    _this.setPluginState({
                        isHidden: true,
                        isClosing: false
                    });
                    _this.superFocus.cancel();
                    _this.savedActiveElement.focus();
                    _this.el.removeEventListener("animationend", handler, false);
                    resolve();
                };
                _this.el.addEventListener("animationend", handler, false);
            } else {
                _this.setPluginState({
                    isHidden: true
                });
                _this.superFocus.cancel();
                _this.savedActiveElement.focus();
                resolve();
            } // handle ESC and TAB keys in modal dialog
            document.removeEventListener("keydown", _this.handleKeyDownInModal);
            if (manualClose) {
                if (_this.opts.browserBackButtonClose) {
                    var _history$state;
                    // Make sure that the latest entry in the history state is our modal name
                    // eslint-disable-next-line no-restricted-globals
                    if ((_history$state = history.state) != null && _history$state[_this.modalName]) // Go back in history to clear out the entry we created (ultimately closing the modal)
                    // eslint-disable-next-line no-restricted-globals
                    history.back();
                }
            }
            _this.uppy.emit("dashboard:modal-closed");
            return promise;
        };
        this.isModalOpen = ()=>{
            return !this.getPluginState().isHidden || false;
        };
        this.requestCloseModal = ()=>{
            if (this.opts.onRequestCloseModal) return this.opts.onRequestCloseModal();
            return this.closeModal();
        };
        this.setDarkModeCapability = (isDarkModeOn)=>{
            const { capabilities: capabilities } = this.uppy.getState();
            this.uppy.setState({
                capabilities: {
                    ...capabilities,
                    darkMode: isDarkModeOn
                }
            });
        };
        this.handleSystemDarkModeChange = (event)=>{
            const isDarkModeOnNow = event.matches;
            this.uppy.log(`[Dashboard] Dark mode is ${isDarkModeOnNow ? "on" : "off"}`);
            this.setDarkModeCapability(isDarkModeOnNow);
        };
        this.toggleFileCard = (show, fileID)=>{
            const file = this.uppy.getFile(fileID);
            if (show) this.uppy.emit("dashboard:file-edit-start", file);
            else this.uppy.emit("dashboard:file-edit-complete", file);
            this.setPluginState({
                fileCardFor: show ? fileID : null,
                activeOverlayType: show ? "FileCard" : null
            });
        };
        this.toggleAddFilesPanel = (show)=>{
            this.setPluginState({
                showAddFilesPanel: show,
                activeOverlayType: show ? "AddFiles" : null
            });
        };
        this.addFiles = (files)=>{
            const descriptors = files.map((file)=>({
                    source: this.id,
                    name: file.name,
                    type: file.type,
                    data: file,
                    meta: {
                        // path of the file relative to the ancestor directory the user selected.
                        // e.g. 'docs/Old Prague/airbnb.pdf'
                        relativePath: file.relativePath || file.webkitRelativePath || null
                    }
                }));
            try {
                this.uppy.addFiles(descriptors);
            } catch (err) {
                this.uppy.log(err);
            }
        };
        this.startListeningToResize = ()=>{
            // Watch for Dashboard container (`.uppy-Dashboard-inner`) resize
            // and update containerWidth/containerHeight in plugin state accordingly.
            // Emits first event on initialization.
            this.resizeObserver = new ResizeObserver((entries)=>{
                const uppyDashboardInnerEl = entries[0];
                const { width: width, height: height } = uppyDashboardInnerEl.contentRect;
                this.uppy.log(`[Dashboard] resized: ${width} / ${height}`, "debug");
                this.setPluginState({
                    containerWidth: width,
                    containerHeight: height,
                    areInsidesReadyToBeVisible: true
                });
            });
            this.resizeObserver.observe(this.el.querySelector(".uppy-Dashboard-inner")); // If ResizeObserver fails to emit an event telling us what size to use - default to the mobile view
            this.makeDashboardInsidesVisibleAnywayTimeout = setTimeout(()=>{
                const pluginState = this.getPluginState();
                const isModalAndClosed = !this.opts.inline && pluginState.isHidden;
                if (!pluginState.areInsidesReadyToBeVisible // and it's not due to the modal being closed
                 && !isModalAndClosed) {
                    this.uppy.log("[Dashboard] resize event didn't fire on time: defaulted to mobile layout", "debug");
                    this.setPluginState({
                        areInsidesReadyToBeVisible: true
                    });
                }
            }, 1000);
        };
        this.stopListeningToResize = ()=>{
            this.resizeObserver.disconnect();
            clearTimeout(this.makeDashboardInsidesVisibleAnywayTimeout);
        };
        this.recordIfFocusedOnUppyRecently = (event)=>{
            if (this.el.contains(event.target)) this.ifFocusedOnUppyRecently = true;
            else {
                this.ifFocusedOnUppyRecently = false; // ___Why run this.superFocus.cancel here when it already runs in superFocusOnEachUpdate?
                //    Because superFocus is debounced, when we move from Uppy to some other element on the page,
                //    previously run superFocus sometimes hits and moves focus back to Uppy.
                this.superFocus.cancel();
            }
        };
        this.disableAllFocusableElements = (disable)=>{
            const focusableNodes = $bs0mo(this.el.querySelectorAll($jLt6s));
            if (disable) focusableNodes.forEach((node)=>{
                // save previous tabindex in a data-attribute, to restore when enabling
                const currentTabIndex = node.getAttribute("tabindex");
                if (currentTabIndex) node.dataset.inertTabindex = currentTabIndex; // eslint-disable-line no-param-reassign
                node.setAttribute("tabindex", "-1");
            });
            else focusableNodes.forEach((node)=>{
                if ("inertTabindex" in node.dataset) node.setAttribute("tabindex", node.dataset.inertTabindex);
                else node.removeAttribute("tabindex");
            });
            this.dashboardIsDisabled = disable;
        };
        this.updateBrowserHistory = ()=>{
            var _history$state2;
            // Ensure history state does not already contain our modal name to avoid double-pushing
            // eslint-disable-next-line no-restricted-globals
            if (!((_history$state2 = history.state) != null && _history$state2[this.modalName])) // Push to history so that the page is not lost on browser back button press
            // eslint-disable-next-line no-restricted-globals
            history.pushState({
                ...history.state,
                [this.modalName]: true
            }, "");
             // Listen for back button presses
            window.addEventListener("popstate", this.handlePopState, false);
        };
        this.handlePopState = (event)=>{
            var _event$state;
            // Close the modal if the history state no longer contains our modal name
            if (this.isModalOpen() && (!event.state || !event.state[this.modalName])) this.closeModal({
                manualClose: false
            });
             // When the browser back button is pressed and uppy is now the latest entry
            // in the history but the modal is closed, fix the history by removing the
            // uppy history entry.
            // This occurs when another entry is added into the history state while the
            // modal is open, and then the modal gets manually closed.
            // Solves PR #575 (https://github.com/transloadit/uppy/pull/575)
            if (!this.isModalOpen() && (_event$state = event.state) != null && _event$state[this.modalName]) // eslint-disable-next-line no-restricted-globals
            history.back();
        };
        this.handleKeyDownInModal = (event)=>{
            // close modal on esc key press
            if (event.keyCode === $e2ae2ebc75109f13$var$ESC_KEY) this.requestCloseModal(event); // trap focus on tab key press
            if (event.keyCode === $e2ae2ebc75109f13$var$TAB_KEY) $iRXC6.forModal(event, this.getPluginState().activeOverlayType, this.el);
        };
        this.handleClickOutside = ()=>{
            if (this.opts.closeModalOnClickOutside) this.requestCloseModal();
        };
        this.handlePaste = (event)=>{
            // Let any acquirer plugin (Url/Webcam/etc.) handle pastes to the root
            this.uppy.iteratePlugins((plugin)=>{
                if (plugin.type === "acquirer") // Every Plugin with .type acquirer can define handleRootPaste(event)
                plugin.handleRootPaste == null || plugin.handleRootPaste(event);
            }); // Add all dropped files
            const files = $bs0mo(event.clipboardData.files);
            if (files.length > 0) {
                this.uppy.log("[Dashboard] Files pasted");
                this.addFiles(files);
            }
        };
        this.handleInputChange = (event)=>{
            event.preventDefault();
            const files = $bs0mo(event.target.files);
            if (files.length > 0) {
                this.uppy.log("[Dashboard] Files selected through input");
                this.addFiles(files);
            }
        };
        this.handleDragOver = (event)=>{
            var _this$opts$onDragOver, _this$opts;
            event.preventDefault();
            event.stopPropagation(); // Check if some plugin can handle the datatransfer without files —
            // for instance, the Url plugin can import a url
            const canSomePluginHandleRootDrop = ()=>{
                let somePluginCanHandleRootDrop = true;
                this.uppy.iteratePlugins((plugin)=>{
                    if (plugin.canHandleRootDrop != null && plugin.canHandleRootDrop(event)) somePluginCanHandleRootDrop = true;
                });
                return somePluginCanHandleRootDrop;
            }; // Check if the "type" of the datatransfer object includes files
            const doesEventHaveFiles = ()=>{
                const { types: types } = event.dataTransfer;
                return types.some((type)=>type === "Files");
            }; // Deny drop, if no plugins can handle datatransfer, there are no files,
            // or when opts.disabled is set, or new uploads are not allowed
            const somePluginCanHandleRootDrop = canSomePluginHandleRootDrop(event);
            const hasFiles = doesEventHaveFiles(event);
            if (!somePluginCanHandleRootDrop && !hasFiles || this.opts.disabled // opts.disableLocalFiles should only be taken into account if no plugins
             || this.opts.disableLocalFiles && (hasFiles || !somePluginCanHandleRootDrop) || !this.uppy.getState().allowNewUpload) {
                event.dataTransfer.dropEffect = "none"; // eslint-disable-line no-param-reassign
                clearTimeout(this.removeDragOverClassTimeout);
                return;
            } // Add a small (+) icon on drop
            // (and prevent browsers from interpreting this as files being _moved_ into the
            // browser, https://github.com/transloadit/uppy/issues/1978).
            event.dataTransfer.dropEffect = "copy"; // eslint-disable-line no-param-reassign
            clearTimeout(this.removeDragOverClassTimeout);
            this.setPluginState({
                isDraggingOver: true
            });
            (_this$opts$onDragOver = (_this$opts = this.opts).onDragOver) == null || _this$opts$onDragOver.call(_this$opts, event);
        };
        this.handleDragLeave = (event)=>{
            var _this$opts$onDragLeav, _this$opts2;
            event.preventDefault();
            event.stopPropagation();
            clearTimeout(this.removeDragOverClassTimeout); // Timeout against flickering, this solution is taken from drag-drop library.
            // Solution with 'pointer-events: none' didn't work across browsers.
            this.removeDragOverClassTimeout = setTimeout(()=>{
                this.setPluginState({
                    isDraggingOver: false
                });
            }, 50);
            (_this$opts$onDragLeav = (_this$opts2 = this.opts).onDragLeave) == null || _this$opts$onDragLeav.call(_this$opts2, event);
        };
        this.handleDrop = async (event)=>{
            var _this$opts$onDrop, _this$opts3;
            event.preventDefault();
            event.stopPropagation();
            clearTimeout(this.removeDragOverClassTimeout);
            this.setPluginState({
                isDraggingOver: false
            }); // Let any acquirer plugin (Url/Webcam/etc.) handle drops to the root
            this.uppy.iteratePlugins((plugin)=>{
                if (plugin.type === "acquirer") // Every Plugin with .type acquirer can define handleRootDrop(event)
                plugin.handleRootDrop == null || plugin.handleRootDrop(event);
            }); // Add all dropped files
            let executedDropErrorOnce = false;
            const logDropError = (error)=>{
                this.uppy.log(error, "error"); // In practice all drop errors are most likely the same,
                // so let's just show one to avoid overwhelming the user
                if (!executedDropErrorOnce) {
                    this.uppy.info(error.message, "error");
                    executedDropErrorOnce = true;
                }
            }; // Add all dropped files
            const files = await $lB5wD(event.dataTransfer, {
                logDropError: logDropError
            });
            if (files.length > 0) {
                this.uppy.log("[Dashboard] Files dropped");
                this.addFiles(files);
            }
            (_this$opts$onDrop = (_this$opts3 = this.opts).onDrop) == null || _this$opts$onDrop.call(_this$opts3, event);
        };
        this.handleRequestThumbnail = (file)=>{
            if (!this.opts.waitForThumbnailsBeforeUpload) this.uppy.emit("thumbnail:request", file);
        };
        this.handleCancelThumbnail = (file)=>{
            if (!this.opts.waitForThumbnailsBeforeUpload) this.uppy.emit("thumbnail:cancel", file);
        };
        this.handleKeyDownInInline = (event)=>{
            // Trap focus on tab key press.
            if (event.keyCode === $e2ae2ebc75109f13$var$TAB_KEY) $iRXC6.forInline(event, this.getPluginState().activeOverlayType, this.el);
        };
        this.handlePasteOnBody = (event)=>{
            const isFocusInOverlay = this.el.contains(document.activeElement);
            if (isFocusInOverlay) this.handlePaste(event);
        };
        this.handleComplete = (_ref)=>{
            let { failed: failed } = _ref;
            if (this.opts.closeAfterFinish && failed.length === 0) // All uploads are done
            this.requestCloseModal();
        };
        this.handleCancelRestore = ()=>{
            this.uppy.emit("restore-canceled");
        };
        Object.defineProperty(this, $e2ae2ebc75109f13$var$_openFileEditorWhenFilesAdded, {
            writable: true,
            value: (files)=>{
                const firstFile = files[0];
                if (this.canEditFile(firstFile)) this.openFileEditor(firstFile);
            }
        });
        this.initEvents = ()=>{
            // Modal open button
            if (this.opts.trigger && !this.opts.inline) {
                const showModalTrigger = $bbQz1(this.opts.trigger);
                if (showModalTrigger) showModalTrigger.forEach((trigger)=>trigger.addEventListener("click", this.openModal));
                else this.uppy.log("Dashboard modal trigger not found. Make sure `trigger` is set in Dashboard options, unless you are planning to call `dashboard.openModal()` method yourself", "warning");
            }
            this.startListeningToResize();
            document.addEventListener("paste", this.handlePasteOnBody);
            this.uppy.on("plugin-remove", this.removeTarget);
            this.uppy.on("file-added", this.hideAllPanels);
            this.uppy.on("dashboard:modal-closed", this.hideAllPanels);
            this.uppy.on("file-editor:complete", this.hideAllPanels);
            this.uppy.on("complete", this.handleComplete); // ___Why fire on capture?
            //    Because this.ifFocusedOnUppyRecently needs to change before onUpdate() fires.
            document.addEventListener("focus", this.recordIfFocusedOnUppyRecently, true);
            document.addEventListener("click", this.recordIfFocusedOnUppyRecently, true);
            if (this.opts.inline) this.el.addEventListener("keydown", this.handleKeyDownInInline);
            if (this.opts.autoOpenFileEditor) this.uppy.on("files-added", $e2ae2ebc75109f13$var$_classPrivateFieldLooseBase(this, $e2ae2ebc75109f13$var$_openFileEditorWhenFilesAdded)[$e2ae2ebc75109f13$var$_openFileEditorWhenFilesAdded]);
        };
        this.removeEvents = ()=>{
            const showModalTrigger = $bbQz1(this.opts.trigger);
            if (!this.opts.inline && showModalTrigger) showModalTrigger.forEach((trigger)=>trigger.removeEventListener("click", this.openModal));
            this.stopListeningToResize();
            document.removeEventListener("paste", this.handlePasteOnBody);
            window.removeEventListener("popstate", this.handlePopState, false);
            this.uppy.off("plugin-remove", this.removeTarget);
            this.uppy.off("file-added", this.hideAllPanels);
            this.uppy.off("dashboard:modal-closed", this.hideAllPanels);
            this.uppy.off("file-editor:complete", this.hideAllPanels);
            this.uppy.off("complete", this.handleComplete);
            document.removeEventListener("focus", this.recordIfFocusedOnUppyRecently);
            document.removeEventListener("click", this.recordIfFocusedOnUppyRecently);
            if (this.opts.inline) this.el.removeEventListener("keydown", this.handleKeyDownInInline);
            if (this.opts.autoOpenFileEditor) this.uppy.off("files-added", $e2ae2ebc75109f13$var$_classPrivateFieldLooseBase(this, $e2ae2ebc75109f13$var$_openFileEditorWhenFilesAdded)[$e2ae2ebc75109f13$var$_openFileEditorWhenFilesAdded]);
        };
        this.superFocusOnEachUpdate = ()=>{
            const isFocusInUppy = this.el.contains(document.activeElement); // When focus is lost on the page (== focus is on body for most browsers, or focus is null for IE11)
            const isFocusNowhere = document.activeElement === document.body || document.activeElement === null;
            const isInformerHidden = this.uppy.getState().info.length === 0;
            const isModal = !this.opts.inline;
            if (isInformerHidden && // on the page (user is unlikely to want to interact with the rest of the page)
            (isModal // If we are already inside of Uppy, or
             || isFocusInUppy // If we are not focused on anything BUT we have already, at least once, focused on uppy
             || isFocusNowhere && this.ifFocusedOnUppyRecently)) this.superFocus(this.el, this.getPluginState().activeOverlayType);
            else this.superFocus.cancel();
        };
        this.afterUpdate = ()=>{
            if (this.opts.disabled && !this.dashboardIsDisabled) {
                this.disableAllFocusableElements(true);
                return;
            }
            if (!this.opts.disabled && this.dashboardIsDisabled) this.disableAllFocusableElements(false);
            this.superFocusOnEachUpdate();
        };
        this.saveFileCard = (meta, fileID)=>{
            this.uppy.setFileMeta(fileID, meta);
            this.toggleFileCard(false, fileID);
        };
        Object.defineProperty(this, $e2ae2ebc75109f13$var$_attachRenderFunctionToTarget, {
            writable: true,
            value: (target)=>{
                const plugin = this.uppy.getPlugin(target.id);
                return {
                    ...target,
                    icon: plugin.icon || this.opts.defaultPickerIcon,
                    render: plugin.render
                };
            }
        });
        Object.defineProperty(this, $e2ae2ebc75109f13$var$_isTargetSupported, {
            writable: true,
            value: (target)=>{
                const plugin = this.uppy.getPlugin(target.id); // If the plugin does not provide a `supported` check, assume the plugin works everywhere.
                if (typeof plugin.isSupported !== "function") return true;
                return plugin.isSupported();
            }
        });
        Object.defineProperty(this, $e2ae2ebc75109f13$var$_getAcquirers, {
            writable: true,
            value: $e2ae2ebc75109f13$var$memoize((targets)=>{
                return targets.filter((target)=>target.type === "acquirer" && $e2ae2ebc75109f13$var$_classPrivateFieldLooseBase(this, $e2ae2ebc75109f13$var$_isTargetSupported)[$e2ae2ebc75109f13$var$_isTargetSupported](target)).map($e2ae2ebc75109f13$var$_classPrivateFieldLooseBase(this, $e2ae2ebc75109f13$var$_attachRenderFunctionToTarget)[$e2ae2ebc75109f13$var$_attachRenderFunctionToTarget]);
            })
        });
        Object.defineProperty(this, $e2ae2ebc75109f13$var$_getProgressIndicators, {
            writable: true,
            value: $e2ae2ebc75109f13$var$memoize((targets)=>{
                return targets.filter((target)=>target.type === "progressindicator").map($e2ae2ebc75109f13$var$_classPrivateFieldLooseBase(this, $e2ae2ebc75109f13$var$_attachRenderFunctionToTarget)[$e2ae2ebc75109f13$var$_attachRenderFunctionToTarget]);
            })
        });
        Object.defineProperty(this, $e2ae2ebc75109f13$var$_getEditors, {
            writable: true,
            value: $e2ae2ebc75109f13$var$memoize((targets)=>{
                return targets.filter((target)=>target.type === "editor").map($e2ae2ebc75109f13$var$_classPrivateFieldLooseBase(this, $e2ae2ebc75109f13$var$_attachRenderFunctionToTarget)[$e2ae2ebc75109f13$var$_attachRenderFunctionToTarget]);
            })
        });
        this.render = (state)=>{
            const pluginState = this.getPluginState();
            const { files: files, capabilities: capabilities, allowNewUpload: allowNewUpload } = state;
            const { newFiles: newFiles, uploadStartedFiles: uploadStartedFiles, completeFiles: completeFiles, erroredFiles: erroredFiles, inProgressFiles: inProgressFiles, inProgressNotPausedFiles: inProgressNotPausedFiles, processingFiles: processingFiles, isUploadStarted: isUploadStarted, isAllComplete: isAllComplete, isAllErrored: isAllErrored, isAllPaused: isAllPaused } = this.uppy.getObjectOfFilesPerState();
            const acquirers = $e2ae2ebc75109f13$var$_classPrivateFieldLooseBase(this, $e2ae2ebc75109f13$var$_getAcquirers)[$e2ae2ebc75109f13$var$_getAcquirers](pluginState.targets);
            const progressindicators = $e2ae2ebc75109f13$var$_classPrivateFieldLooseBase(this, $e2ae2ebc75109f13$var$_getProgressIndicators)[$e2ae2ebc75109f13$var$_getProgressIndicators](pluginState.targets);
            const editors = $e2ae2ebc75109f13$var$_classPrivateFieldLooseBase(this, $e2ae2ebc75109f13$var$_getEditors)[$e2ae2ebc75109f13$var$_getEditors](pluginState.targets);
            let theme;
            if (this.opts.theme === "auto") theme = capabilities.darkMode ? "dark" : "light";
            else theme = this.opts.theme;
            if ([
                "files",
                "folders",
                "both"
            ].indexOf(this.opts.fileManagerSelectionType) < 0) {
                this.opts.fileManagerSelectionType = "files"; // eslint-disable-next-line no-console
                console.warn(`Unsupported option for "fileManagerSelectionType". Using default of "${this.opts.fileManagerSelectionType}".`);
            }
            return $bdnKs({
                state: state,
                isHidden: pluginState.isHidden,
                files: files,
                newFiles: newFiles,
                uploadStartedFiles: uploadStartedFiles,
                completeFiles: completeFiles,
                erroredFiles: erroredFiles,
                inProgressFiles: inProgressFiles,
                inProgressNotPausedFiles: inProgressNotPausedFiles,
                processingFiles: processingFiles,
                isUploadStarted: isUploadStarted,
                isAllComplete: isAllComplete,
                isAllErrored: isAllErrored,
                isAllPaused: isAllPaused,
                totalFileCount: Object.keys(files).length,
                totalProgress: state.totalProgress,
                allowNewUpload: allowNewUpload,
                acquirers: acquirers,
                theme: theme,
                disabled: this.opts.disabled,
                disableLocalFiles: this.opts.disableLocalFiles,
                direction: this.opts.direction,
                activePickerPanel: pluginState.activePickerPanel,
                showFileEditor: pluginState.showFileEditor,
                saveFileEditor: this.saveFileEditor,
                disableAllFocusableElements: this.disableAllFocusableElements,
                animateOpenClose: this.opts.animateOpenClose,
                isClosing: pluginState.isClosing,
                progressindicators: progressindicators,
                editors: editors,
                autoProceed: this.uppy.opts.autoProceed,
                id: this.id,
                closeModal: this.requestCloseModal,
                handleClickOutside: this.handleClickOutside,
                handleInputChange: this.handleInputChange,
                handlePaste: this.handlePaste,
                inline: this.opts.inline,
                showPanel: this.showPanel,
                hideAllPanels: this.hideAllPanels,
                i18n: this.i18n,
                i18nArray: this.i18nArray,
                uppy: this.uppy,
                note: this.opts.note,
                recoveredState: state.recoveredState,
                metaFields: pluginState.metaFields,
                resumableUploads: capabilities.resumableUploads || false,
                individualCancellation: capabilities.individualCancellation,
                isMobileDevice: capabilities.isMobileDevice,
                fileCardFor: pluginState.fileCardFor,
                toggleFileCard: this.toggleFileCard,
                toggleAddFilesPanel: this.toggleAddFilesPanel,
                showAddFilesPanel: pluginState.showAddFilesPanel,
                saveFileCard: this.saveFileCard,
                openFileEditor: this.openFileEditor,
                canEditFile: this.canEditFile,
                width: this.opts.width,
                height: this.opts.height,
                showLinkToFileUploadResult: this.opts.showLinkToFileUploadResult,
                fileManagerSelectionType: this.opts.fileManagerSelectionType,
                proudlyDisplayPoweredByUppy: this.opts.proudlyDisplayPoweredByUppy,
                hideCancelButton: this.opts.hideCancelButton,
                hideRetryButton: this.opts.hideRetryButton,
                hidePauseResumeButton: this.opts.hidePauseResumeButton,
                showRemoveButtonAfterComplete: this.opts.showRemoveButtonAfterComplete,
                containerWidth: pluginState.containerWidth,
                containerHeight: pluginState.containerHeight,
                areInsidesReadyToBeVisible: pluginState.areInsidesReadyToBeVisible,
                isTargetDOMEl: this.isTargetDOMEl,
                parentElement: this.el,
                allowedFileTypes: this.uppy.opts.restrictions.allowedFileTypes,
                maxNumberOfFiles: this.uppy.opts.restrictions.maxNumberOfFiles,
                requiredMetaFields: this.uppy.opts.restrictions.requiredMetaFields,
                showSelectedFiles: this.opts.showSelectedFiles,
                handleCancelRestore: this.handleCancelRestore,
                handleRequestThumbnail: this.handleRequestThumbnail,
                handleCancelThumbnail: this.handleCancelThumbnail,
                // drag props
                isDraggingOver: pluginState.isDraggingOver,
                handleDragOver: this.handleDragOver,
                handleDragLeave: this.handleDragLeave,
                handleDrop: this.handleDrop
            });
        };
        this.discoverProviderPlugins = ()=>{
            this.uppy.iteratePlugins((plugin)=>{
                if (plugin && !plugin.target && plugin.opts && plugin.opts.target === this.constructor) this.addTarget(plugin);
            });
        };
        this.install = ()=>{
            // Set default state for Dashboard
            this.setPluginState({
                isHidden: true,
                fileCardFor: null,
                activeOverlayType: null,
                showAddFilesPanel: false,
                activePickerPanel: false,
                showFileEditor: false,
                metaFields: this.opts.metaFields,
                targets: [],
                // We'll make them visible once .containerWidth is determined
                areInsidesReadyToBeVisible: false,
                isDraggingOver: false
            });
            const { inline: inline, closeAfterFinish: closeAfterFinish } = this.opts;
            if (inline && closeAfterFinish) throw new Error("[Dashboard] `closeAfterFinish: true` cannot be used on an inline Dashboard, because an inline Dashboard cannot be closed at all. Either set `inline: false`, or disable the `closeAfterFinish` option.");
            const { allowMultipleUploads: allowMultipleUploads, allowMultipleUploadBatches: allowMultipleUploadBatches } = this.uppy.opts;
            if ((allowMultipleUploads || allowMultipleUploadBatches) && closeAfterFinish) this.uppy.log("[Dashboard] When using `closeAfterFinish`, we recommended setting the `allowMultipleUploadBatches` option to `false` in the Uppy constructor. See https://uppy.io/docs/uppy/#allowMultipleUploads-true", "warning");
            const { target: target } = this.opts;
            if (target) this.mount(target, this);
            const plugins = this.opts.plugins || [];
            plugins.forEach((pluginID)=>{
                const plugin = this.uppy.getPlugin(pluginID);
                if (plugin) plugin.mount(this, plugin);
            });
            if (!this.opts.disableStatusBar) this.uppy.use($bnV4R, {
                id: `${this.id}:StatusBar`,
                target: this,
                hideUploadButton: this.opts.hideUploadButton,
                hideRetryButton: this.opts.hideRetryButton,
                hidePauseResumeButton: this.opts.hidePauseResumeButton,
                hideCancelButton: this.opts.hideCancelButton,
                showProgressDetails: this.opts.showProgressDetails,
                hideAfterFinish: this.opts.hideProgressAfterFinish,
                locale: this.opts.locale,
                doneButtonHandler: this.opts.doneButtonHandler
            });
            if (!this.opts.disableInformer) this.uppy.use($i7NSv, {
                id: `${this.id}:Informer`,
                target: this
            });
            if (!this.opts.disableThumbnailGenerator) this.uppy.use($kBmkp, {
                id: `${this.id}:ThumbnailGenerator`,
                thumbnailWidth: this.opts.thumbnailWidth,
                thumbnailHeight: this.opts.thumbnailHeight,
                thumbnailType: this.opts.thumbnailType,
                waitForThumbnailsBeforeUpload: this.opts.waitForThumbnailsBeforeUpload,
                // If we don't block on thumbnails, we can lazily generate them
                lazy: !this.opts.waitForThumbnailsBeforeUpload
            });
             // Dark Mode / theme
            this.darkModeMediaQuery = typeof window !== "undefined" && window.matchMedia ? window.matchMedia("(prefers-color-scheme: dark)") : null;
            const isDarkModeOnFromTheStart = this.darkModeMediaQuery ? this.darkModeMediaQuery.matches : false;
            this.uppy.log(`[Dashboard] Dark mode is ${isDarkModeOnFromTheStart ? "on" : "off"}`);
            this.setDarkModeCapability(isDarkModeOnFromTheStart);
            if (this.opts.theme === "auto") this.darkModeMediaQuery.addListener(this.handleSystemDarkModeChange);
            this.discoverProviderPlugins();
            this.initEvents();
        };
        this.uninstall = ()=>{
            if (!this.opts.disableInformer) {
                const informer = this.uppy.getPlugin(`${this.id}:Informer`); // Checking if this plugin exists, in case it was removed by uppy-core
                // before the Dashboard was.
                if (informer) this.uppy.removePlugin(informer);
            }
            if (!this.opts.disableStatusBar) {
                const statusBar = this.uppy.getPlugin(`${this.id}:StatusBar`);
                if (statusBar) this.uppy.removePlugin(statusBar);
            }
            if (!this.opts.disableThumbnailGenerator) {
                const thumbnail = this.uppy.getPlugin(`${this.id}:ThumbnailGenerator`);
                if (thumbnail) this.uppy.removePlugin(thumbnail);
            }
            const plugins = this.opts.plugins || [];
            plugins.forEach((pluginID)=>{
                const plugin = this.uppy.getPlugin(pluginID);
                if (plugin) plugin.unmount();
            });
            if (this.opts.theme === "auto") this.darkModeMediaQuery.removeListener(this.handleSystemDarkModeChange);
            this.unmount();
            this.removeEvents();
        };
        this.id = this.opts.id || "Dashboard";
        this.title = "Dashboard";
        this.type = "orchestrator";
        this.modalName = `uppy-Dashboard-${(0, $4Kuwt.nanoid)()}`;
        this.defaultLocale = $fW148; // set default options
        const defaultOptions = {
            target: "body",
            metaFields: [],
            trigger: null,
            inline: false,
            width: 750,
            height: 550,
            thumbnailWidth: 280,
            thumbnailType: "image/jpeg",
            waitForThumbnailsBeforeUpload: false,
            defaultPickerIcon: $e2ae2ebc75109f13$var$defaultPickerIcon,
            showLinkToFileUploadResult: false,
            showProgressDetails: false,
            hideUploadButton: false,
            hideCancelButton: false,
            hideRetryButton: false,
            hidePauseResumeButton: false,
            hideProgressAfterFinish: false,
            doneButtonHandler: ()=>{
                this.uppy.reset();
                this.requestCloseModal();
            },
            note: null,
            closeModalOnClickOutside: false,
            closeAfterFinish: false,
            disableStatusBar: false,
            disableInformer: false,
            disableThumbnailGenerator: false,
            disablePageScrollWhenModalOpen: true,
            animateOpenClose: true,
            fileManagerSelectionType: "files",
            proudlyDisplayPoweredByUppy: true,
            onRequestCloseModal: ()=>this.closeModal(),
            showSelectedFiles: true,
            showRemoveButtonAfterComplete: false,
            browserBackButtonClose: false,
            theme: "light",
            autoOpenFileEditor: false,
            disabled: false,
            disableLocalFiles: false
        }; // merge default options with the ones set by user
        this.opts = {
            ...defaultOptions,
            ..._opts
        };
        this.i18nInit();
        this.superFocus = $exYxU();
        this.ifFocusedOnUppyRecently = false; // Timeouts
        this.makeDashboardInsidesVisibleAnywayTimeout = null;
        this.removeDragOverClassTimeout = null;
    }
}
$e2ae2ebc75109f13$var$Dashboard.VERSION = $e2ae2ebc75109f13$var$packageJson.version;
module.exports = $e2ae2ebc75109f13$var$Dashboard;

});
parcelRegister("1Hdcz", function(module, exports) {

$parcel$export(module.exports, "createRef", () => $13c40c34b78c8ee2$export$7d1e3a5e95ceca43);
$parcel$export(module.exports, "Fragment", () => $13c40c34b78c8ee2$export$ffb0004e005737fa);
$parcel$export(module.exports, "Component", () => $13c40c34b78c8ee2$export$16fa2f45be04daa8);
$parcel$export(module.exports, "toChildArray", () => $13c40c34b78c8ee2$export$47e4c5b300681277);
$parcel$export(module.exports, "render", () => $13c40c34b78c8ee2$export$b3890eb0ae9dca99);
$parcel$export(module.exports, "cloneElement", () => $13c40c34b78c8ee2$export$e530037191fcd5d7);
$parcel$export(module.exports, "h", () => $13c40c34b78c8ee2$export$c8a8987d4410bf2d);
var $13c40c34b78c8ee2$var$n, $13c40c34b78c8ee2$export$41c562ebe57d11e2, $13c40c34b78c8ee2$var$u, $13c40c34b78c8ee2$export$a8257692ac88316c, $13c40c34b78c8ee2$var$i, $13c40c34b78c8ee2$var$r, $13c40c34b78c8ee2$var$o, $13c40c34b78c8ee2$var$e, $13c40c34b78c8ee2$var$f, $13c40c34b78c8ee2$var$c, $13c40c34b78c8ee2$var$s, $13c40c34b78c8ee2$var$a, $13c40c34b78c8ee2$var$h, $13c40c34b78c8ee2$var$p = {}, $13c40c34b78c8ee2$var$v = [], $13c40c34b78c8ee2$var$y = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, $13c40c34b78c8ee2$var$w = Array.isArray;
function $13c40c34b78c8ee2$var$d(n, l) {
    for(var u in l)n[u] = l[u];
    return n;
}
function $13c40c34b78c8ee2$var$g(n) {
    n && n.parentNode && n.parentNode.removeChild(n);
}
function $13c40c34b78c8ee2$export$c8a8987d4410bf2d(l, u, t) {
    var i, r, o, e = {};
    for(o in u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : e[o] = u[o];
    if (arguments.length > 2 && (e.children = arguments.length > 3 ? $13c40c34b78c8ee2$var$n.call(arguments, 2) : t), "function" == typeof l && null != l.defaultProps) for(o in l.defaultProps)void 0 === e[o] && (e[o] = l.defaultProps[o]);
    return $13c40c34b78c8ee2$var$m(l, e, i, r, null);
}
function $13c40c34b78c8ee2$var$m(n, t, i, r, o) {
    var e = {
        type: n,
        props: t,
        key: i,
        ref: r,
        __k: null,
        __: null,
        __b: 0,
        __e: null,
        __c: null,
        constructor: void 0,
        __v: null == o ? ++$13c40c34b78c8ee2$var$u : o,
        __i: -1,
        __u: 0
    };
    return null == o && null != $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode && $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode(e), e;
}
function $13c40c34b78c8ee2$export$7d1e3a5e95ceca43() {
    return {
        current: null
    };
}
function $13c40c34b78c8ee2$export$ffb0004e005737fa(n) {
    return n.children;
}
function $13c40c34b78c8ee2$export$16fa2f45be04daa8(n, l) {
    this.props = n, this.context = l;
}
function $13c40c34b78c8ee2$var$S(n, l) {
    if (null == l) return n.__ ? $13c40c34b78c8ee2$var$S(n.__, n.__i + 1) : null;
    for(var u; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) return u.__e;
    return "function" == typeof n.type ? $13c40c34b78c8ee2$var$S(n) : null;
}
function $13c40c34b78c8ee2$var$C(n) {
    var l, u;
    if (null != (n = n.__) && null != n.__c) {
        for(n.__e = n.__c.base = null, l = 0; l < n.__k.length; l++)if (null != (u = n.__k[l]) && null != u.__e) {
            n.__e = n.__c.base = u.__e;
            break;
        }
        return $13c40c34b78c8ee2$var$C(n);
    }
}
function $13c40c34b78c8ee2$var$M(n) {
    (!n.__d && (n.__d = !0) && $13c40c34b78c8ee2$var$i.push(n) && !$13c40c34b78c8ee2$var$$.__r++ || $13c40c34b78c8ee2$var$r != $13c40c34b78c8ee2$export$41c562ebe57d11e2.debounceRendering) && (($13c40c34b78c8ee2$var$r = $13c40c34b78c8ee2$export$41c562ebe57d11e2.debounceRendering) || $13c40c34b78c8ee2$var$o)($13c40c34b78c8ee2$var$$);
}
function $13c40c34b78c8ee2$var$$() {
    for(var n, u, t, r, o, f, c, s = 1; $13c40c34b78c8ee2$var$i.length;)$13c40c34b78c8ee2$var$i.length > s && $13c40c34b78c8ee2$var$i.sort($13c40c34b78c8ee2$var$e), n = $13c40c34b78c8ee2$var$i.shift(), s = $13c40c34b78c8ee2$var$i.length, n.__d && (t = void 0, o = (r = (u = n).__v).__e, f = [], c = [], u.__P && ((t = $13c40c34b78c8ee2$var$d({}, r)).__v = r.__v + 1, $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode && $13c40c34b78c8ee2$export$41c562ebe57d11e2.vnode(t), $13c40c34b78c8ee2$var$O(u.__P, t, r, u.__n, u.__P.namespaceURI, 32 & r.__u ? [
        o
    ] : null, f, null == o ? $13c40c34b78c8ee2$var$S(r) : o, !!(32 & r.__u), c), t.__v = r.__v, t.__.__k[t.__i] = t, $13c40c34b78c8ee2$var$z(f, t, c), t.__e != o && $13c40c34b78c8ee2$var$C(t)));
    $13c40c34b78c8ee2$var$$.__r = 0;
}
function $13c40c34b78c8ee2$var$I(n, l, u, t, i, r, o, e, f, c, s) {
    var a, h, y, w, d, g, _ = t && t.__k || $13c40c34b78c8ee2$var$v, m = l.length;
    for(f = $13c40c34b78c8ee2$var$P(u, l, _, f, m), a = 0; a < m; a++)null != (y = u.__k[a]) && (h = -1 == y.__i ? $13c40c34b78c8ee2$var$p : _[y.__i] || $13c40c34b78c8ee2$var$p, y.__i = a, g = $13c40c34b78c8ee2$var$O(n, y, h, i, r, o, e, f, c, s), w = y.__e, y.ref && h.ref != y.ref && (h.ref && $13c40c34b78c8ee2$var$q(h.ref, null, y), s.push(y.ref, y.__c || w, y)), null == d && null != w && (d = w), 4 & y.__u || h.__k === y.__k ? f = $13c40c34b78c8ee2$var$A(y, f, n) : "function" == typeof y.type && void 0 !== g ? f = g : w && (f = w.nextSibling), y.__u &= -7);
    return u.__e = d, f;
}
function $13c40c34b78c8ee2$var$P(n, l, u, t, i) {
    var r, o, e, f, c, s = u.length, a = s, h = 0;
    for(n.__k = new Array(i), r = 0; r < i; r++)null != (o = l[r]) && "boolean" != typeof o && "function" != typeof o ? (f = r + h, (o = n.__k[r] = "string" == typeof o || "number" == typeof o || "bigint" == typeof o || o.constructor == String ? $13c40c34b78c8ee2$var$m(null, o, null, null, null) : $13c40c34b78c8ee2$var$w(o) ? $13c40c34b78c8ee2$var$m($13c40c34b78c8ee2$export$ffb0004e005737fa, {
        children: o
    }, null, null, null) : null == o.constructor && o.__b > 0 ? $13c40c34b78c8ee2$var$m(o.type, o.props, o.key, o.ref ? o.ref : null, o.__v) : o).__ = n, o.__b = n.__b + 1, e = null, -1 != (c = o.__i = $13c40c34b78c8ee2$var$L(o, u, f, a)) && (a--, (e = u[c]) && (e.__u |= 2)), null == e || null == e.__v ? (-1 == c && (i > s ? h-- : i < s && h++), "function" != typeof o.type && (o.__u |= 4)) : c != f && (c == f - 1 ? h-- : c == f + 1 ? h++ : (c > f ? h-- : h++, o.__u |= 4))) : n.__k[r] = null;
    if (a) for(r = 0; r < s; r++)null != (e = u[r]) && 0 == (2 & e.__u) && (e.__e == t && (t = $13c40c34b78c8ee2$var$S(e)), $13c40c34b78c8ee2$var$B(e, e));
    return t;
}
function $13c40c34b78c8ee2$var$A(n, l, u) {
    var t, i;
    if ("function" == typeof n.type) {
        for(t = n.__k, i = 0; t && i < t.length; i++)t[i] && (t[i].__ = n, l = $13c40c34b78c8ee2$var$A(t[i], l, u));
        return l;
    }
    n.__e != l && (l && n.type && !u.contains(l) && (l = $13c40c34b78c8ee2$var$S(n)), u.insertBefore(n.__e, l || null), l = n.__e);
    do l = l && l.nextSibling;
    while (null != l && 8 == l.nodeType);
    return l;
}
function $13c40c34b78c8ee2$export$47e4c5b300681277(n, l) {
    return l = l || [], null == n || "boolean" == typeof n || ($13c40c34b78c8ee2$var$w(n) ? n.some(function(n) {
        $13c40c34b78c8ee2$export$47e4c5b300681277(n, l);
    }) : l.push(n)), l;
}
function $13c40c34b78c8ee2$var$L(n, l, u, t) {
    var i, r, o = n.key, e = n.type, f = l[u];
    if (null === f && null == n.key || f && o == f.key && e == f.type && 0 == (2 & f.__u)) return u;
    if (t > (null != f && 0 == (2 & f.__u) ? 1 : 0)) for(i = u - 1, r = u + 1; i >= 0 || r < l.length;){
        if (i >= 0) {
            if ((f = l[i]) && 0 == (2 & f.__u) && o == f.key && e == f.type) return i;
            i--;
        }
        if (r < l.length) {
            if ((f = l[r]) && 0 == (2 & f.__u) && o == f.key && e == f.type) return r;
            r++;
        }
    }
    return -1;
}
function $13c40c34b78c8ee2$var$T(n, l, u) {
    "-" == l[0] ? n.setProperty(l, null == u ? "" : u) : n[l] = null == u ? "" : "number" != typeof u || $13c40c34b78c8ee2$var$y.test(l) ? u : u + "px";
}
function $13c40c34b78c8ee2$var$j(n, l, u, t, i) {
    var r, o;
    n: if ("style" == l) {
        if ("string" == typeof u) n.style.cssText = u;
        else {
            if ("string" == typeof t && (n.style.cssText = t = ""), t) for(l in t)u && l in u || $13c40c34b78c8ee2$var$T(n.style, l, "");
            if (u) for(l in u)t && u[l] == t[l] || $13c40c34b78c8ee2$var$T(n.style, l, u[l]);
        }
    } else if ("o" == l[0] && "n" == l[1]) r = l != (l = l.replace($13c40c34b78c8ee2$var$f, "$1")), o = l.toLowerCase(), l = o in n || "onFocusOut" == l || "onFocusIn" == l ? o.slice(2) : l.slice(2), n.l || (n.l = {}), n.l[l + r] = u, u ? t ? u.u = t.u : (u.u = $13c40c34b78c8ee2$var$c, n.addEventListener(l, r ? $13c40c34b78c8ee2$var$a : $13c40c34b78c8ee2$var$s, r)) : n.removeEventListener(l, r ? $13c40c34b78c8ee2$var$a : $13c40c34b78c8ee2$var$s, r);
    else {
        if ("http://www.w3.org/2000/svg" == i) l = l.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
        else if ("width" != l && "height" != l && "href" != l && "list" != l && "form" != l && "tabIndex" != l && "download" != l && "rowSpan" != l && "colSpan" != l && "role" != l && "popover" != l && l in n) try {
            n[l] = null == u ? "" : u;
            break n;
        } catch (n) {}
        "function" == typeof u || (null == u || !1 === u && "-" != l[4] ? n.removeAttribute(l) : n.setAttribute(l, "popover" == l && 1 == u ? "" : u));
    }
}
function $13c40c34b78c8ee2$var$F(n) {
    return function(u) {
        if (this.l) {
            var t = this.l[u.type + n];
            if (null == u.t) u.t = $13c40c34b78c8ee2$var$c++;
            else if (u.t < t.u) return;
            return t($13c40c34b78c8ee2$export$41c562ebe57d11e2.event ? $13c40c34b78c8ee2$export$41c562ebe57d11e2.event(u) : u);
        }
    };
}
function $13c40c34b78c8ee2$var$O(n, u, t, i, r, o, e, f, c, s) {
    var a, h, p, v, y, _, m, b, S, C, M, $, P, A, H, L, T, j = u.type;
    if (null != u.constructor) return null;
    128 & t.__u && (c = !!(32 & t.__u), o = [
        f = u.__e = t.__e
    ]), (a = $13c40c34b78c8ee2$export$41c562ebe57d11e2.__b) && a(u);
    n: if ("function" == typeof j) try {
        if (b = u.props, S = "prototype" in j && j.prototype.render, C = (a = j.contextType) && i[a.__c], M = a ? C ? C.props.value : a.__ : i, t.__c ? m = (h = u.__c = t.__c).__ = h.__E : (S ? u.__c = h = new j(b, M) : (u.__c = h = new $13c40c34b78c8ee2$export$16fa2f45be04daa8(b, M), h.constructor = j, h.render = $13c40c34b78c8ee2$var$D), C && C.sub(h), h.props = b, h.state || (h.state = {}), h.context = M, h.__n = i, p = h.__d = !0, h.__h = [], h._sb = []), S && null == h.__s && (h.__s = h.state), S && null != j.getDerivedStateFromProps && (h.__s == h.state && (h.__s = $13c40c34b78c8ee2$var$d({}, h.__s)), $13c40c34b78c8ee2$var$d(h.__s, j.getDerivedStateFromProps(b, h.__s))), v = h.props, y = h.state, h.__v = u, p) S && null == j.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), S && null != h.componentDidMount && h.__h.push(h.componentDidMount);
        else {
            if (S && null == j.getDerivedStateFromProps && b !== v && null != h.componentWillReceiveProps && h.componentWillReceiveProps(b, M), !h.__e && null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(b, h.__s, M) || u.__v == t.__v) {
                for(u.__v != t.__v && (h.props = b, h.state = h.__s, h.__d = !1), u.__e = t.__e, u.__k = t.__k, u.__k.some(function(n) {
                    n && (n.__ = u);
                }), $ = 0; $ < h._sb.length; $++)h.__h.push(h._sb[$]);
                h._sb = [], h.__h.length && e.push(h);
                break n;
            }
            null != h.componentWillUpdate && h.componentWillUpdate(b, h.__s, M), S && null != h.componentDidUpdate && h.__h.push(function() {
                h.componentDidUpdate(v, y, _);
            });
        }
        if (h.context = M, h.props = b, h.__P = n, h.__e = !1, P = $13c40c34b78c8ee2$export$41c562ebe57d11e2.__r, A = 0, S) {
            for(h.state = h.__s, h.__d = !1, P && P(u), a = h.render(h.props, h.state, h.context), H = 0; H < h._sb.length; H++)h.__h.push(h._sb[H]);
            h._sb = [];
        } else do h.__d = !1, P && P(u), a = h.render(h.props, h.state, h.context), h.state = h.__s;
        while (h.__d && ++A < 25);
        h.state = h.__s, null != h.getChildContext && (i = $13c40c34b78c8ee2$var$d($13c40c34b78c8ee2$var$d({}, i), h.getChildContext())), S && !p && null != h.getSnapshotBeforeUpdate && (_ = h.getSnapshotBeforeUpdate(v, y)), L = a, null != a && a.type === $13c40c34b78c8ee2$export$ffb0004e005737fa && null == a.key && (L = $13c40c34b78c8ee2$var$N(a.props.children)), f = $13c40c34b78c8ee2$var$I(n, $13c40c34b78c8ee2$var$w(L) ? L : [
            L
        ], u, t, i, r, o, e, f, c, s), h.base = u.__e, u.__u &= -161, h.__h.length && e.push(h), m && (h.__E = h.__ = null);
    } catch (n) {
        if (u.__v = null, c || null != o) {
            if (n.then) {
                for(u.__u |= c ? 160 : 128; f && 8 == f.nodeType && f.nextSibling;)f = f.nextSibling;
                o[o.indexOf(f)] = null, u.__e = f;
            } else for(T = o.length; T--;)$13c40c34b78c8ee2$var$g(o[T]);
        } else u.__e = t.__e, u.__k = t.__k;
        $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, u, t);
    }
    else null == o && u.__v == t.__v ? (u.__k = t.__k, u.__e = t.__e) : f = u.__e = $13c40c34b78c8ee2$var$V(t.__e, u, t, i, r, o, e, c, s);
    return (a = $13c40c34b78c8ee2$export$41c562ebe57d11e2.diffed) && a(u), 128 & u.__u ? void 0 : f;
}
function $13c40c34b78c8ee2$var$z(n, u, t) {
    for(var i = 0; i < t.length; i++)$13c40c34b78c8ee2$var$q(t[i], t[++i], t[++i]);
    $13c40c34b78c8ee2$export$41c562ebe57d11e2.__c && $13c40c34b78c8ee2$export$41c562ebe57d11e2.__c(u, n), n.some(function(u) {
        try {
            n = u.__h, u.__h = [], n.some(function(n) {
                n.call(u);
            });
        } catch (n) {
            $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, u.__v);
        }
    });
}
function $13c40c34b78c8ee2$var$N(n) {
    return "object" != typeof n || null == n || n.__b && n.__b > 0 ? n : $13c40c34b78c8ee2$var$w(n) ? n.map($13c40c34b78c8ee2$var$N) : $13c40c34b78c8ee2$var$d({}, n);
}
function $13c40c34b78c8ee2$var$V(u, t, i, r, o, e, f, c, s) {
    var a, h, v, y, d, _, m, b = i.props, k = t.props, x = t.type;
    if ("svg" == x ? o = "http://www.w3.org/2000/svg" : "math" == x ? o = "http://www.w3.org/1998/Math/MathML" : o || (o = "http://www.w3.org/1999/xhtml"), null != e) {
        for(a = 0; a < e.length; a++)if ((d = e[a]) && "setAttribute" in d == !!x && (x ? d.localName == x : 3 == d.nodeType)) {
            u = d, e[a] = null;
            break;
        }
    }
    if (null == u) {
        if (null == x) return document.createTextNode(k);
        u = document.createElementNS(o, x, k.is && k), c && ($13c40c34b78c8ee2$export$41c562ebe57d11e2.__m && $13c40c34b78c8ee2$export$41c562ebe57d11e2.__m(t, e), c = !1), e = null;
    }
    if (null == x) b === k || c && u.data == k || (u.data = k);
    else {
        if (e = e && $13c40c34b78c8ee2$var$n.call(u.childNodes), b = i.props || $13c40c34b78c8ee2$var$p, !c && null != e) for(b = {}, a = 0; a < u.attributes.length; a++)b[(d = u.attributes[a]).name] = d.value;
        for(a in b)if (d = b[a], "children" == a) ;
        else if ("dangerouslySetInnerHTML" == a) v = d;
        else if (!(a in k)) {
            if ("value" == a && "defaultValue" in k || "checked" == a && "defaultChecked" in k) continue;
            $13c40c34b78c8ee2$var$j(u, a, null, d, o);
        }
        for(a in k)d = k[a], "children" == a ? y = d : "dangerouslySetInnerHTML" == a ? h = d : "value" == a ? _ = d : "checked" == a ? m = d : c && "function" != typeof d || b[a] === d || $13c40c34b78c8ee2$var$j(u, a, d, b[a], o);
        if (h) c || v && (h.__html == v.__html || h.__html == u.innerHTML) || (u.innerHTML = h.__html), t.__k = [];
        else if (v && (u.innerHTML = ""), $13c40c34b78c8ee2$var$I("template" == t.type ? u.content : u, $13c40c34b78c8ee2$var$w(y) ? y : [
            y
        ], t, i, r, "foreignObject" == x ? "http://www.w3.org/1999/xhtml" : o, e, f, e ? e[0] : i.__k && $13c40c34b78c8ee2$var$S(i, 0), c, s), null != e) for(a = e.length; a--;)$13c40c34b78c8ee2$var$g(e[a]);
        c || (a = "value", "progress" == x && null == _ ? u.removeAttribute("value") : null != _ && (_ !== u[a] || "progress" == x && !_ || "option" == x && _ != b[a]) && $13c40c34b78c8ee2$var$j(u, a, _, b[a], o), a = "checked", null != m && m != u[a] && $13c40c34b78c8ee2$var$j(u, a, m, b[a], o));
    }
    return u;
}
function $13c40c34b78c8ee2$var$q(n, u, t) {
    try {
        if ("function" == typeof n) {
            var i = "function" == typeof n.__u;
            i && n.__u(), i && null == u || (n.__u = n(u));
        } else n.current = u;
    } catch (n) {
        $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, t);
    }
}
function $13c40c34b78c8ee2$var$B(n, u, t) {
    var i, r;
    if ($13c40c34b78c8ee2$export$41c562ebe57d11e2.unmount && $13c40c34b78c8ee2$export$41c562ebe57d11e2.unmount(n), (i = n.ref) && (i.current && i.current != n.__e || $13c40c34b78c8ee2$var$q(i, null, u)), null != (i = n.__c)) {
        if (i.componentWillUnmount) try {
            i.componentWillUnmount();
        } catch (n) {
            $13c40c34b78c8ee2$export$41c562ebe57d11e2.__e(n, u);
        }
        i.base = i.__P = null;
    }
    if (i = n.__k) for(r = 0; r < i.length; r++)i[r] && $13c40c34b78c8ee2$var$B(i[r], u, t || "function" != typeof n.type);
    t || $13c40c34b78c8ee2$var$g(n.__e), n.__c = n.__ = n.__e = void 0;
}
function $13c40c34b78c8ee2$var$D(n, l, u) {
    return this.constructor(n, u);
}
function $13c40c34b78c8ee2$export$b3890eb0ae9dca99(u, t, i) {
    var r, o, e, f;
    t == document && (t = document.documentElement), $13c40c34b78c8ee2$export$41c562ebe57d11e2.__ && $13c40c34b78c8ee2$export$41c562ebe57d11e2.__(u, t), o = (r = "function" == typeof i) ? null : i && i.__k || t.__k, e = [], f = [], $13c40c34b78c8ee2$var$O(t, u = (!r && i || t).__k = $13c40c34b78c8ee2$export$c8a8987d4410bf2d($13c40c34b78c8ee2$export$ffb0004e005737fa, null, [
        u
    ]), o || $13c40c34b78c8ee2$var$p, $13c40c34b78c8ee2$var$p, t.namespaceURI, !r && i ? [
        i
    ] : o ? null : t.firstChild ? $13c40c34b78c8ee2$var$n.call(t.childNodes) : null, e, !r && i ? i : o ? o.__e : t.firstChild, r, f), $13c40c34b78c8ee2$var$z(e, u, f);
}
function $13c40c34b78c8ee2$export$fa8d919ba61d84db(n, l) {
    $13c40c34b78c8ee2$export$b3890eb0ae9dca99(n, l, $13c40c34b78c8ee2$export$fa8d919ba61d84db);
}
function $13c40c34b78c8ee2$export$e530037191fcd5d7(l, u, t) {
    var i, r, o, e, f = $13c40c34b78c8ee2$var$d({}, l.props);
    for(o in l.type && l.type.defaultProps && (e = l.type.defaultProps), u)"key" == o ? i = u[o] : "ref" == o ? r = u[o] : f[o] = void 0 === u[o] && null != e ? e[o] : u[o];
    return arguments.length > 2 && (f.children = arguments.length > 3 ? $13c40c34b78c8ee2$var$n.call(arguments, 2) : t), $13c40c34b78c8ee2$var$m(l.type, f, i || l.key, r || l.ref, null);
}
function $13c40c34b78c8ee2$export$fd42f52fd3ae1109(n) {
    function l(n) {
        var u, t;
        return this.getChildContext || (u = new Set, (t = {})[l.__c] = this, this.getChildContext = function() {
            return t;
        }, this.componentWillUnmount = function() {
            u = null;
        }, this.shouldComponentUpdate = function(n) {
            this.props.value != n.value && u.forEach(function(n) {
                n.__e = !0, $13c40c34b78c8ee2$var$M(n);
            });
        }, this.sub = function(n) {
            u.add(n);
            var l = n.componentWillUnmount;
            n.componentWillUnmount = function() {
                u && u.delete(n), l && l.call(n);
            };
        }), n.children;
    }
    return l.__c = "__cC" + $13c40c34b78c8ee2$var$h++, l.__ = n, l.Provider = l.__l = (l.Consumer = function(n, l) {
        return n.children(l);
    }).contextType = l, l;
}
$13c40c34b78c8ee2$var$n = $13c40c34b78c8ee2$var$v.slice, $13c40c34b78c8ee2$export$41c562ebe57d11e2 = {
    __e: function(n, l, u, t) {
        for(var i, r, o; l = l.__;)if ((i = l.__c) && !i.__) try {
            if ((r = i.constructor) && null != r.getDerivedStateFromError && (i.setState(r.getDerivedStateFromError(n)), o = i.__d), null != i.componentDidCatch && (i.componentDidCatch(n, t || {}), o = i.__d), o) return i.__E = i;
        } catch (l) {
            n = l;
        }
        throw n;
    }
}, $13c40c34b78c8ee2$var$u = 0, $13c40c34b78c8ee2$export$a8257692ac88316c = function(n) {
    return null != n && null == n.constructor;
}, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.setState = function(n, l) {
    var u;
    u = null != this.__s && this.__s != this.state ? this.__s : this.__s = $13c40c34b78c8ee2$var$d({}, this.state), "function" == typeof n && (n = n($13c40c34b78c8ee2$var$d({}, u), this.props)), n && $13c40c34b78c8ee2$var$d(u, n), null != n && this.__v && (l && this._sb.push(l), $13c40c34b78c8ee2$var$M(this));
}, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.forceUpdate = function(n) {
    this.__v && (this.__e = !0, n && this.__h.push(n), $13c40c34b78c8ee2$var$M(this));
}, $13c40c34b78c8ee2$export$16fa2f45be04daa8.prototype.render = $13c40c34b78c8ee2$export$ffb0004e005737fa, $13c40c34b78c8ee2$var$i = [], $13c40c34b78c8ee2$var$o = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, $13c40c34b78c8ee2$var$e = function(n, l) {
    return n.__v.__b - l.__v.__b;
}, $13c40c34b78c8ee2$var$$.__r = 0, $13c40c34b78c8ee2$var$f = /(PointerCapture)$|Capture$/i, $13c40c34b78c8ee2$var$c = 0, $13c40c34b78c8ee2$var$s = $13c40c34b78c8ee2$var$F(!1), $13c40c34b78c8ee2$var$a = $13c40c34b78c8ee2$var$F(!0), $13c40c34b78c8ee2$var$h = 0;

});

parcelRegister("8jN3b", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Uppy = module.exports.UIPlugin = module.exports.BasePlugin = void 0;
Object.defineProperty(module.exports, "debugLogger", {
    enumerable: true,
    get: function() {
        return $8AlrC.debugLogger;
    }
});

var $8AlrC = parcelRequire("8AlrC");

module.exports = (parcelRequire("NHeZe"));

var $ixbbp = parcelRequire("ixbbp");
module.exports.UIPlugin = $ixbbp;

var $7Vc9T = parcelRequire("7Vc9T");
module.exports.BasePlugin = $7Vc9T;

module.exports.Uppy = (parcelRequire("NHeZe"));

var $ixbbp = parcelRequire("ixbbp");

var $7Vc9T = parcelRequire("7Vc9T");
// Backward compatibility: we want those to keep being accessible as static
// properties of `Uppy` to avoid a breaking change.
(parcelRequire("NHeZe")).Uppy = (parcelRequire("NHeZe"));
(parcelRequire("NHeZe")).UIPlugin = $ixbbp;
(parcelRequire("NHeZe")).BasePlugin = $7Vc9T;
(parcelRequire("NHeZe")).debugLogger = $8AlrC.debugLogger;

});
parcelRegister("8AlrC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.justErrorsLogger = module.exports.debugLogger = void 0;

var $7xvkg = parcelRequire("7xvkg");
// default if logger is not set or debug: false
const $640251ec151f3503$var$justErrorsLogger = {
    debug: ()=>{},
    warn: ()=>{},
    error: function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return console.error(`[Uppy] [${$7xvkg()}]`, ...args);
    }
}; // Print logs to console with namespace + timestamp,
// set by logger: Uppy.debugLogger or debug: true
module.exports.justErrorsLogger = $640251ec151f3503$var$justErrorsLogger;
const $640251ec151f3503$var$debugLogger = {
    debug: function() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return console.debug(`[Uppy] [${$7xvkg()}]`, ...args);
    },
    warn: function() {
        for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
        return console.warn(`[Uppy] [${$7xvkg()}]`, ...args);
    },
    error: function() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        return console.error(`[Uppy] [${$7xvkg()}]`, ...args);
    }
};
module.exports.debugLogger = $640251ec151f3503$var$debugLogger;

});
parcelRegister("7xvkg", function(module, exports) {
"use strict";
/**
 * Adds zero to strings shorter than two characters.
 *
 * @param {number} number
 * @returns {string}
 */ function $57d3ea1d6d5f87f5$var$pad(number) {
    return number < 10 ? `0${number}` : number.toString();
}
/**
 * Returns a timestamp in the format of `hours:minutes:seconds`
 */ function $57d3ea1d6d5f87f5$var$getTimeStamp() {
    const date = new Date();
    const hours = $57d3ea1d6d5f87f5$var$pad(date.getHours());
    const minutes = $57d3ea1d6d5f87f5$var$pad(date.getMinutes());
    const seconds = $57d3ea1d6d5f87f5$var$pad(date.getSeconds());
    return `${hours}:${minutes}:${seconds}`;
}
module.exports = $57d3ea1d6d5f87f5$var$getTimeStamp;

});


parcelRegister("NHeZe", function(module, exports) {
"use strict";

var $4Kuwt = parcelRequire("4Kuwt");

var $8AlrC = parcelRequire("8AlrC");

var $bjvEI = parcelRequire("bjvEI");
let $09561e6c9ea9b8f8$var$_Symbol$for, $09561e6c9ea9b8f8$var$_Symbol$for2;
function $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(receiver, privateKey) {
    if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) throw new TypeError("attempted to use private field on non-instance");
    return receiver;
}
var $09561e6c9ea9b8f8$var$id = 0;
function $09561e6c9ea9b8f8$var$_classPrivateFieldLooseKey(name) {
    return "__private_" + $09561e6c9ea9b8f8$var$id++ + "_" + name;
}

var $38UkU = parcelRequire("38UkU");

var $5E2ck = parcelRequire("5E2ck");

var $eMXxl = parcelRequire("eMXxl");

var $87ZT9 = parcelRequire("87ZT9");

var $9y4Co = parcelRequire("9y4Co");

var $hFmsk = parcelRequire("hFmsk");

var $2tdJv = parcelRequire("2tdJv");

var $3omH9 = parcelRequire("3omH9");

var $lPSpS = parcelRequire("lPSpS");
const $09561e6c9ea9b8f8$var$packageJson = {
    "version": "2.3.3"
};

var $eTcBD = parcelRequire("eTcBD");
/**
 * Uppy Core module.
 * Manages plugins, state updates, acts as an event bus,
 * adds/removes files and metadata.
 */ var $09561e6c9ea9b8f8$var$_plugins = /*#__PURE__*/ $09561e6c9ea9b8f8$var$_classPrivateFieldLooseKey("plugins");
var $09561e6c9ea9b8f8$var$_restricter = /*#__PURE__*/ $09561e6c9ea9b8f8$var$_classPrivateFieldLooseKey("restricter");
var $09561e6c9ea9b8f8$var$_storeUnsubscribe = /*#__PURE__*/ $09561e6c9ea9b8f8$var$_classPrivateFieldLooseKey("storeUnsubscribe");
var $09561e6c9ea9b8f8$var$_emitter = /*#__PURE__*/ $09561e6c9ea9b8f8$var$_classPrivateFieldLooseKey("emitter");
var $09561e6c9ea9b8f8$var$_preProcessors = /*#__PURE__*/ $09561e6c9ea9b8f8$var$_classPrivateFieldLooseKey("preProcessors");
var $09561e6c9ea9b8f8$var$_uploaders = /*#__PURE__*/ $09561e6c9ea9b8f8$var$_classPrivateFieldLooseKey("uploaders");
var $09561e6c9ea9b8f8$var$_postProcessors = /*#__PURE__*/ $09561e6c9ea9b8f8$var$_classPrivateFieldLooseKey("postProcessors");
var $09561e6c9ea9b8f8$var$_informAndEmit = /*#__PURE__*/ $09561e6c9ea9b8f8$var$_classPrivateFieldLooseKey("informAndEmit");
var $09561e6c9ea9b8f8$var$_checkRequiredMetaFieldsOnFile = /*#__PURE__*/ $09561e6c9ea9b8f8$var$_classPrivateFieldLooseKey("checkRequiredMetaFieldsOnFile");
var $09561e6c9ea9b8f8$var$_checkRequiredMetaFields = /*#__PURE__*/ $09561e6c9ea9b8f8$var$_classPrivateFieldLooseKey("checkRequiredMetaFields");
var $09561e6c9ea9b8f8$var$_assertNewUploadAllowed = /*#__PURE__*/ $09561e6c9ea9b8f8$var$_classPrivateFieldLooseKey("assertNewUploadAllowed");
var $09561e6c9ea9b8f8$var$_checkAndCreateFileStateObject = /*#__PURE__*/ $09561e6c9ea9b8f8$var$_classPrivateFieldLooseKey("checkAndCreateFileStateObject");
var $09561e6c9ea9b8f8$var$_startIfAutoProceed = /*#__PURE__*/ $09561e6c9ea9b8f8$var$_classPrivateFieldLooseKey("startIfAutoProceed");
var $09561e6c9ea9b8f8$var$_addListeners = /*#__PURE__*/ $09561e6c9ea9b8f8$var$_classPrivateFieldLooseKey("addListeners");
var $09561e6c9ea9b8f8$var$_updateOnlineStatus = /*#__PURE__*/ $09561e6c9ea9b8f8$var$_classPrivateFieldLooseKey("updateOnlineStatus");
var $09561e6c9ea9b8f8$var$_createUpload = /*#__PURE__*/ $09561e6c9ea9b8f8$var$_classPrivateFieldLooseKey("createUpload");
var $09561e6c9ea9b8f8$var$_getUpload = /*#__PURE__*/ $09561e6c9ea9b8f8$var$_classPrivateFieldLooseKey("getUpload");
var $09561e6c9ea9b8f8$var$_removeUpload = /*#__PURE__*/ $09561e6c9ea9b8f8$var$_classPrivateFieldLooseKey("removeUpload");
var $09561e6c9ea9b8f8$var$_runUpload = /*#__PURE__*/ $09561e6c9ea9b8f8$var$_classPrivateFieldLooseKey("runUpload");
$09561e6c9ea9b8f8$var$_Symbol$for = Symbol.for("uppy test: getPlugins");
$09561e6c9ea9b8f8$var$_Symbol$for2 = Symbol.for("uppy test: createUpload");
class $09561e6c9ea9b8f8$var$Uppy {
    /** @type {Record<string, BasePlugin[]>} */ /**
   * Instantiate Uppy
   *
   * @param {object} opts — Uppy options
   */ constructor(_opts){
        Object.defineProperty(this, $09561e6c9ea9b8f8$var$_runUpload, {
            value: $09561e6c9ea9b8f8$var$_runUpload2
        });
        Object.defineProperty(this, $09561e6c9ea9b8f8$var$_removeUpload, {
            value: $09561e6c9ea9b8f8$var$_removeUpload2
        });
        Object.defineProperty(this, $09561e6c9ea9b8f8$var$_getUpload, {
            value: $09561e6c9ea9b8f8$var$_getUpload2
        });
        Object.defineProperty(this, $09561e6c9ea9b8f8$var$_createUpload, {
            value: $09561e6c9ea9b8f8$var$_createUpload2
        });
        Object.defineProperty(this, $09561e6c9ea9b8f8$var$_addListeners, {
            value: $09561e6c9ea9b8f8$var$_addListeners2
        });
        Object.defineProperty(this, $09561e6c9ea9b8f8$var$_startIfAutoProceed, {
            value: $09561e6c9ea9b8f8$var$_startIfAutoProceed2
        });
        Object.defineProperty(this, $09561e6c9ea9b8f8$var$_checkAndCreateFileStateObject, {
            value: $09561e6c9ea9b8f8$var$_checkAndCreateFileStateObject2
        });
        Object.defineProperty(this, $09561e6c9ea9b8f8$var$_assertNewUploadAllowed, {
            value: $09561e6c9ea9b8f8$var$_assertNewUploadAllowed2
        });
        Object.defineProperty(this, $09561e6c9ea9b8f8$var$_checkRequiredMetaFields, {
            value: $09561e6c9ea9b8f8$var$_checkRequiredMetaFields2
        });
        Object.defineProperty(this, $09561e6c9ea9b8f8$var$_checkRequiredMetaFieldsOnFile, {
            value: $09561e6c9ea9b8f8$var$_checkRequiredMetaFieldsOnFile2
        });
        Object.defineProperty(this, $09561e6c9ea9b8f8$var$_informAndEmit, {
            value: $09561e6c9ea9b8f8$var$_informAndEmit2
        });
        Object.defineProperty(this, $09561e6c9ea9b8f8$var$_plugins, {
            writable: true,
            value: Object.create(null)
        });
        Object.defineProperty(this, $09561e6c9ea9b8f8$var$_restricter, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $09561e6c9ea9b8f8$var$_storeUnsubscribe, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $09561e6c9ea9b8f8$var$_emitter, {
            writable: true,
            value: $5E2ck()
        });
        Object.defineProperty(this, $09561e6c9ea9b8f8$var$_preProcessors, {
            writable: true,
            value: new Set()
        });
        Object.defineProperty(this, $09561e6c9ea9b8f8$var$_uploaders, {
            writable: true,
            value: new Set()
        });
        Object.defineProperty(this, $09561e6c9ea9b8f8$var$_postProcessors, {
            writable: true,
            value: new Set()
        });
        Object.defineProperty(this, $09561e6c9ea9b8f8$var$_updateOnlineStatus, {
            writable: true,
            value: this.updateOnlineStatus.bind(this)
        });
        this.defaultLocale = $eTcBD;
        const defaultOptions = {
            id: "uppy",
            autoProceed: false,
            /**
       * @deprecated The method should not be used
       */ allowMultipleUploads: true,
            allowMultipleUploadBatches: true,
            debug: false,
            restrictions: $bjvEI.defaultOptions,
            meta: {},
            onBeforeFileAdded: (currentFile)=>currentFile,
            onBeforeUpload: (files)=>files,
            store: $87ZT9(),
            logger: $8AlrC.justErrorsLogger,
            infoTimeout: 5000
        }; // Merge default options with the ones set by user,
        // making sure to merge restrictions too
        this.opts = {
            ...defaultOptions,
            ..._opts,
            restrictions: {
                ...defaultOptions.restrictions,
                ..._opts && _opts.restrictions
            }
        }; // Support debug: true for backwards-compatability, unless logger is set in opts
        // opts instead of this.opts to avoid comparing objects — we set logger: justErrorsLogger in defaultOptions
        if (_opts && _opts.logger && _opts.debug) this.log("You are using a custom `logger`, but also set `debug: true`, which uses built-in logger to output logs to console. Ignoring `debug: true` and using your custom `logger`.", "warning");
        else if (_opts && _opts.debug) this.opts.logger = $8AlrC.debugLogger;
        this.log(`Using Core v${this.constructor.VERSION}`);
        this.i18nInit(); // ___Why throttle at 500ms?
        //    - We must throttle at >250ms for superfocus in Dashboard to work well
        //    (because animation takes 0.25s, and we want to wait for all animations to be over before refocusing).
        //    [Practical Check]: if thottle is at 100ms, then if you are uploading a file,
        //    and click 'ADD MORE FILES', - focus won't activate in Firefox.
        //    - We must throttle at around >500ms to avoid performance lags.
        //    [Practical Check] Firefox, try to upload a big file for a prolonged period of time. Laptop will start to heat up.
        this.calculateProgress = $eMXxl(this.calculateProgress.bind(this), 500, {
            leading: true,
            trailing: true
        });
        this.store = this.opts.store;
        this.setState({
            plugins: {},
            files: {},
            currentUploads: {},
            allowNewUpload: true,
            capabilities: {
                uploadProgress: $3omH9(),
                individualCancellation: true,
                resumableUploads: false
            },
            totalProgress: 0,
            meta: {
                ...this.opts.meta
            },
            info: [],
            recoveredState: null
        });
        $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_restricter)[$09561e6c9ea9b8f8$var$_restricter] = new $bjvEI.Restricter(()=>this.opts, this.i18n);
        $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_storeUnsubscribe)[$09561e6c9ea9b8f8$var$_storeUnsubscribe] = this.store.subscribe((prevState, nextState, patch)=>{
            this.emit("state-update", prevState, nextState, patch);
            this.updateAll(nextState);
        }); // Exposing uppy object on window for debugging and testing
        if (this.opts.debug && typeof window !== "undefined") window[this.opts.id] = this;
        $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_addListeners)[$09561e6c9ea9b8f8$var$_addListeners]();
    }
    emit(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_emitter)[$09561e6c9ea9b8f8$var$_emitter].emit(event, ...args);
    }
    on(event, callback) {
        $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_emitter)[$09561e6c9ea9b8f8$var$_emitter].on(event, callback);
        return this;
    }
    once(event, callback) {
        $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_emitter)[$09561e6c9ea9b8f8$var$_emitter].once(event, callback);
        return this;
    }
    off(event, callback) {
        $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_emitter)[$09561e6c9ea9b8f8$var$_emitter].off(event, callback);
        return this;
    }
    /**
   * Iterate on all plugins and run `update` on them.
   * Called each time state changes.
   *
   */ updateAll(state) {
        this.iteratePlugins((plugin)=>{
            plugin.update(state);
        });
    }
    /**
   * Updates state with a patch
   *
   * @param {object} patch {foo: 'bar'}
   */ setState(patch) {
        this.store.setState(patch);
    }
    /**
   * Returns current state.
   *
   * @returns {object}
   */ getState() {
        return this.store.getState();
    }
    /**
   * Back compat for when uppy.state is used instead of uppy.getState().
   *
   * @deprecated
   */ get state() {
        // Here, state is a non-enumerable property.
        return this.getState();
    }
    /**
   * Shorthand to set state for a specific file.
   */ setFileState(fileID, state) {
        if (!this.getState().files[fileID]) throw new Error(`Can\u{2019}t set state for ${fileID} (the file could have been removed)`);
        this.setState({
            files: {
                ...this.getState().files,
                [fileID]: {
                    ...this.getState().files[fileID],
                    ...state
                }
            }
        });
    }
    i18nInit() {
        const translator = new $38UkU([
            this.defaultLocale,
            this.opts.locale
        ]);
        this.i18n = translator.translate.bind(translator);
        this.i18nArray = translator.translateArray.bind(translator);
        this.locale = translator.locale;
    }
    setOptions(newOpts) {
        this.opts = {
            ...this.opts,
            ...newOpts,
            restrictions: {
                ...this.opts.restrictions,
                ...newOpts && newOpts.restrictions
            }
        };
        if (newOpts.meta) this.setMeta(newOpts.meta);
        this.i18nInit();
        if (newOpts.locale) this.iteratePlugins((plugin)=>{
            plugin.setOptions();
        });
         // Note: this is not the preact `setState`, it's an internal function that has the same name.
        this.setState(); // so that UI re-renders with new options
    }
    resetProgress() {
        const defaultProgress = {
            percentage: 0,
            bytesUploaded: 0,
            uploadComplete: false,
            uploadStarted: null
        };
        const files = {
            ...this.getState().files
        };
        const updatedFiles = {};
        Object.keys(files).forEach((fileID)=>{
            const updatedFile = {
                ...files[fileID]
            };
            updatedFile.progress = {
                ...updatedFile.progress,
                ...defaultProgress
            };
            updatedFiles[fileID] = updatedFile;
        });
        this.setState({
            files: updatedFiles,
            totalProgress: 0
        });
        this.emit("reset-progress");
    }
    addPreProcessor(fn) {
        $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_preProcessors)[$09561e6c9ea9b8f8$var$_preProcessors].add(fn);
    }
    removePreProcessor(fn) {
        return $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_preProcessors)[$09561e6c9ea9b8f8$var$_preProcessors].delete(fn);
    }
    addPostProcessor(fn) {
        $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_postProcessors)[$09561e6c9ea9b8f8$var$_postProcessors].add(fn);
    }
    removePostProcessor(fn) {
        return $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_postProcessors)[$09561e6c9ea9b8f8$var$_postProcessors].delete(fn);
    }
    addUploader(fn) {
        $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_uploaders)[$09561e6c9ea9b8f8$var$_uploaders].add(fn);
    }
    removeUploader(fn) {
        return $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_uploaders)[$09561e6c9ea9b8f8$var$_uploaders].delete(fn);
    }
    setMeta(data) {
        const updatedMeta = {
            ...this.getState().meta,
            ...data
        };
        const updatedFiles = {
            ...this.getState().files
        };
        Object.keys(updatedFiles).forEach((fileID)=>{
            updatedFiles[fileID] = {
                ...updatedFiles[fileID],
                meta: {
                    ...updatedFiles[fileID].meta,
                    ...data
                }
            };
        });
        this.log("Adding metadata:");
        this.log(data);
        this.setState({
            meta: updatedMeta,
            files: updatedFiles
        });
    }
    setFileMeta(fileID, data) {
        const updatedFiles = {
            ...this.getState().files
        };
        if (!updatedFiles[fileID]) {
            this.log("Was trying to set metadata for a file that has been removed: ", fileID);
            return;
        }
        const newMeta = {
            ...updatedFiles[fileID].meta,
            ...data
        };
        updatedFiles[fileID] = {
            ...updatedFiles[fileID],
            meta: newMeta
        };
        this.setState({
            files: updatedFiles
        });
    }
    /**
   * Get a file object.
   *
   * @param {string} fileID The ID of the file object to return.
   */ getFile(fileID) {
        return this.getState().files[fileID];
    }
    /**
   * Get all files in an array.
   */ getFiles() {
        const { files: files } = this.getState();
        return Object.values(files);
    }
    getObjectOfFilesPerState() {
        const { files: filesObject, totalProgress: totalProgress, error: error } = this.getState();
        const files = Object.values(filesObject);
        const inProgressFiles = files.filter((_ref)=>{
            let { progress: progress } = _ref;
            return !progress.uploadComplete && progress.uploadStarted;
        });
        const newFiles = files.filter((file)=>!file.progress.uploadStarted);
        const startedFiles = files.filter((file)=>file.progress.uploadStarted || file.progress.preprocess || file.progress.postprocess);
        const uploadStartedFiles = files.filter((file)=>file.progress.uploadStarted);
        const pausedFiles = files.filter((file)=>file.isPaused);
        const completeFiles = files.filter((file)=>file.progress.uploadComplete);
        const erroredFiles = files.filter((file)=>file.error);
        const inProgressNotPausedFiles = inProgressFiles.filter((file)=>!file.isPaused);
        const processingFiles = files.filter((file)=>file.progress.preprocess || file.progress.postprocess);
        return {
            newFiles: newFiles,
            startedFiles: startedFiles,
            uploadStartedFiles: uploadStartedFiles,
            pausedFiles: pausedFiles,
            completeFiles: completeFiles,
            erroredFiles: erroredFiles,
            inProgressFiles: inProgressFiles,
            inProgressNotPausedFiles: inProgressNotPausedFiles,
            processingFiles: processingFiles,
            isUploadStarted: uploadStartedFiles.length > 0,
            isAllComplete: totalProgress === 100 && completeFiles.length === files.length && processingFiles.length === 0,
            isAllErrored: !!error && erroredFiles.length === files.length,
            isAllPaused: inProgressFiles.length !== 0 && pausedFiles.length === inProgressFiles.length,
            isUploadInProgress: inProgressFiles.length > 0,
            isSomeGhost: files.some((file)=>file.isGhost)
        };
    }
    /*
  * @constructs
  * @param { Error } error
  * @param { undefined } file
  */ /*
  * @constructs
  * @param { RestrictionError } error
  * @param { UppyFile | undefined } file
  */ validateRestrictions(file, files) {
        if (files === void 0) files = this.getFiles();
        // TODO: directly return the Restriction error in next major version.
        // we create RestrictionError's just to discard immediately, which doesn't make sense.
        try {
            $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_restricter)[$09561e6c9ea9b8f8$var$_restricter].validate(file, files);
            return {
                result: true
            };
        } catch (err) {
            return {
                result: false,
                reason: err.message
            };
        }
    }
    checkIfFileAlreadyExists(fileID) {
        const { files: files } = this.getState();
        if (files[fileID] && !files[fileID].isGhost) return true;
        return false;
    }
    /**
   * Create a file state object based on user-provided `addFile()` options.
   *
   * Note this is extremely side-effectful and should only be done when a file state object
   * will be added to state immediately afterward!
   *
   * The `files` value is passed in because it may be updated by the caller without updating the store.
   */ /**
   * Add a new file to `state.files`. This will run `onBeforeFileAdded`,
   * try to guess file type in a clever way, check file against restrictions,
   * and start an upload if `autoProceed === true`.
   *
   * @param {object} file object to add
   * @returns {string} id for the added file
   */ addFile(file) {
        $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_assertNewUploadAllowed)[$09561e6c9ea9b8f8$var$_assertNewUploadAllowed](file);
        const { files: files } = this.getState();
        let newFile = $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_checkAndCreateFileStateObject)[$09561e6c9ea9b8f8$var$_checkAndCreateFileStateObject](files, file); // Users are asked to re-select recovered files without data,
        // and to keep the progress, meta and everthing else, we only replace said data
        if (files[newFile.id] && files[newFile.id].isGhost) {
            newFile = {
                ...files[newFile.id],
                data: file.data,
                isGhost: false
            };
            this.log(`Replaced the blob in the restored ghost file: ${newFile.name}, ${newFile.id}`);
        }
        this.setState({
            files: {
                ...files,
                [newFile.id]: newFile
            }
        });
        this.emit("file-added", newFile);
        this.emit("files-added", [
            newFile
        ]);
        this.log(`Added file: ${newFile.name}, ${newFile.id}, mime type: ${newFile.type}`);
        $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_startIfAutoProceed)[$09561e6c9ea9b8f8$var$_startIfAutoProceed]();
        return newFile.id;
    }
    /**
   * Add multiple files to `state.files`. See the `addFile()` documentation.
   *
   * If an error occurs while adding a file, it is logged and the user is notified.
   * This is good for UI plugins, but not for programmatic use.
   * Programmatic users should usually still use `addFile()` on individual files.
   */ addFiles(fileDescriptors) {
        $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_assertNewUploadAllowed)[$09561e6c9ea9b8f8$var$_assertNewUploadAllowed](); // create a copy of the files object only once
        const files = {
            ...this.getState().files
        };
        const newFiles = [];
        const errors = [];
        for(let i = 0; i < fileDescriptors.length; i++)try {
            let newFile = $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_checkAndCreateFileStateObject)[$09561e6c9ea9b8f8$var$_checkAndCreateFileStateObject](files, fileDescriptors[i]); // Users are asked to re-select recovered files without data,
            // and to keep the progress, meta and everthing else, we only replace said data
            if (files[newFile.id] && files[newFile.id].isGhost) {
                newFile = {
                    ...files[newFile.id],
                    data: fileDescriptors[i].data,
                    isGhost: false
                };
                this.log(`Replaced blob in a ghost file: ${newFile.name}, ${newFile.id}`);
            }
            files[newFile.id] = newFile;
            newFiles.push(newFile);
        } catch (err) {
            if (!err.isRestriction) errors.push(err);
        }
        this.setState({
            files: files
        });
        newFiles.forEach((newFile)=>{
            this.emit("file-added", newFile);
        });
        this.emit("files-added", newFiles);
        if (newFiles.length > 5) this.log(`Added batch of ${newFiles.length} files`);
        else Object.keys(newFiles).forEach((fileID)=>{
            this.log(`Added file: ${newFiles[fileID].name}\n id: ${newFiles[fileID].id}\n type: ${newFiles[fileID].type}`);
        });
        if (newFiles.length > 0) $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_startIfAutoProceed)[$09561e6c9ea9b8f8$var$_startIfAutoProceed]();
        if (errors.length > 0) {
            let message = "Multiple errors occurred while adding files:\n";
            errors.forEach((subError)=>{
                message += `\n * ${subError.message}`;
            });
            this.info({
                message: this.i18n("addBulkFilesFailed", {
                    smart_count: errors.length
                }),
                details: message
            }, "error", this.opts.infoTimeout);
            if (typeof AggregateError === "function") throw new AggregateError(errors, message);
            else {
                const err = new Error(message);
                err.errors = errors;
                throw err;
            }
        }
    }
    removeFiles(fileIDs, reason) {
        const { files: files, currentUploads: currentUploads } = this.getState();
        const updatedFiles = {
            ...files
        };
        const updatedUploads = {
            ...currentUploads
        };
        const removedFiles = Object.create(null);
        fileIDs.forEach((fileID)=>{
            if (files[fileID]) {
                removedFiles[fileID] = files[fileID];
                delete updatedFiles[fileID];
            }
        }); // Remove files from the `fileIDs` list in each upload.
        function fileIsNotRemoved(uploadFileID) {
            return removedFiles[uploadFileID] === undefined;
        }
        Object.keys(updatedUploads).forEach((uploadID)=>{
            const newFileIDs = currentUploads[uploadID].fileIDs.filter(fileIsNotRemoved); // Remove the upload if no files are associated with it anymore.
            if (newFileIDs.length === 0) {
                delete updatedUploads[uploadID];
                return;
            }
            const { capabilities: capabilities } = this.getState();
            if (newFileIDs.length !== currentUploads[uploadID].fileIDs.length && !capabilities.individualCancellation) throw new Error("individualCancellation is disabled");
            updatedUploads[uploadID] = {
                ...currentUploads[uploadID],
                fileIDs: newFileIDs
            };
        });
        const stateUpdate = {
            currentUploads: updatedUploads,
            files: updatedFiles
        }; // If all files were removed - allow new uploads,
        // and clear recoveredState
        if (Object.keys(updatedFiles).length === 0) {
            stateUpdate.allowNewUpload = true;
            stateUpdate.error = null;
            stateUpdate.recoveredState = null;
        }
        this.setState(stateUpdate);
        this.calculateTotalProgress();
        const removedFileIDs = Object.keys(removedFiles);
        removedFileIDs.forEach((fileID)=>{
            this.emit("file-removed", removedFiles[fileID], reason);
        });
        if (removedFileIDs.length > 5) this.log(`Removed ${removedFileIDs.length} files`);
        else this.log(`Removed files: ${removedFileIDs.join(", ")}`);
    }
    removeFile(fileID, reason) {
        if (reason === void 0) reason = null;
        this.removeFiles([
            fileID
        ], reason);
    }
    pauseResume(fileID) {
        if (!this.getState().capabilities.resumableUploads || this.getFile(fileID).uploadComplete) return undefined;
        const wasPaused = this.getFile(fileID).isPaused || false;
        const isPaused = !wasPaused;
        this.setFileState(fileID, {
            isPaused: isPaused
        });
        this.emit("upload-pause", fileID, isPaused);
        return isPaused;
    }
    pauseAll() {
        const updatedFiles = {
            ...this.getState().files
        };
        const inProgressUpdatedFiles = Object.keys(updatedFiles).filter((file)=>{
            return !updatedFiles[file].progress.uploadComplete && updatedFiles[file].progress.uploadStarted;
        });
        inProgressUpdatedFiles.forEach((file)=>{
            const updatedFile = {
                ...updatedFiles[file],
                isPaused: true
            };
            updatedFiles[file] = updatedFile;
        });
        this.setState({
            files: updatedFiles
        });
        this.emit("pause-all");
    }
    resumeAll() {
        const updatedFiles = {
            ...this.getState().files
        };
        const inProgressUpdatedFiles = Object.keys(updatedFiles).filter((file)=>{
            return !updatedFiles[file].progress.uploadComplete && updatedFiles[file].progress.uploadStarted;
        });
        inProgressUpdatedFiles.forEach((file)=>{
            const updatedFile = {
                ...updatedFiles[file],
                isPaused: false,
                error: null
            };
            updatedFiles[file] = updatedFile;
        });
        this.setState({
            files: updatedFiles
        });
        this.emit("resume-all");
    }
    retryAll() {
        const updatedFiles = {
            ...this.getState().files
        };
        const filesToRetry = Object.keys(updatedFiles).filter((file)=>{
            return updatedFiles[file].error;
        });
        filesToRetry.forEach((file)=>{
            const updatedFile = {
                ...updatedFiles[file],
                isPaused: false,
                error: null
            };
            updatedFiles[file] = updatedFile;
        });
        this.setState({
            files: updatedFiles,
            error: null
        });
        this.emit("retry-all", filesToRetry);
        if (filesToRetry.length === 0) return Promise.resolve({
            successful: [],
            failed: []
        });
        const uploadID = $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_createUpload)[$09561e6c9ea9b8f8$var$_createUpload](filesToRetry, {
            forceAllowNewUpload: true // create new upload even if allowNewUpload: false
        });
        return $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_runUpload)[$09561e6c9ea9b8f8$var$_runUpload](uploadID);
    }
    cancelAll(_temp) {
        let { reason: reason = "user" } = _temp === void 0 ? {} : _temp;
        this.emit("cancel-all", {
            reason: reason
        }); // Only remove existing uploads if user is canceling
        if (reason === "user") {
            const { files: files } = this.getState();
            const fileIDs = Object.keys(files);
            if (fileIDs.length) this.removeFiles(fileIDs, "cancel-all");
            this.setState({
                totalProgress: 0,
                error: null,
                recoveredState: null
            });
        }
    }
    retryUpload(fileID) {
        this.setFileState(fileID, {
            error: null,
            isPaused: false
        });
        this.emit("upload-retry", fileID);
        const uploadID = $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_createUpload)[$09561e6c9ea9b8f8$var$_createUpload]([
            fileID
        ], {
            forceAllowNewUpload: true // create new upload even if allowNewUpload: false
        });
        return $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_runUpload)[$09561e6c9ea9b8f8$var$_runUpload](uploadID);
    }
    reset() {
        this.cancelAll(...arguments);
    }
    logout() {
        this.iteratePlugins((plugin)=>{
            if (plugin.provider && plugin.provider.logout) plugin.provider.logout();
        });
    }
    calculateProgress(file, data) {
        if (file == null || !this.getFile(file.id)) {
            this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
            return;
        } // bytesTotal may be null or zero; in that case we can't divide by it
        const canHavePercentage = Number.isFinite(data.bytesTotal) && data.bytesTotal > 0;
        this.setFileState(file.id, {
            progress: {
                ...this.getFile(file.id).progress,
                bytesUploaded: data.bytesUploaded,
                bytesTotal: data.bytesTotal,
                percentage: canHavePercentage ? Math.round(data.bytesUploaded / data.bytesTotal * 100) : 0
            }
        });
        this.calculateTotalProgress();
    }
    calculateTotalProgress() {
        // calculate total progress, using the number of files currently uploading,
        // multiplied by 100 and the summ of individual progress of each file
        const files = this.getFiles();
        const inProgress = files.filter((file)=>{
            return file.progress.uploadStarted || file.progress.preprocess || file.progress.postprocess;
        });
        if (inProgress.length === 0) {
            this.emit("progress", 0);
            this.setState({
                totalProgress: 0
            });
            return;
        }
        const sizedFiles = inProgress.filter((file)=>file.progress.bytesTotal != null);
        const unsizedFiles = inProgress.filter((file)=>file.progress.bytesTotal == null);
        if (sizedFiles.length === 0) {
            const progressMax = inProgress.length * 100;
            const currentProgress = unsizedFiles.reduce((acc, file)=>{
                return acc + file.progress.percentage;
            }, 0);
            const totalProgress = Math.round(currentProgress / progressMax * 100);
            this.setState({
                totalProgress: totalProgress
            });
            return;
        }
        let totalSize = sizedFiles.reduce((acc, file)=>{
            return acc + file.progress.bytesTotal;
        }, 0);
        const averageSize = totalSize / sizedFiles.length;
        totalSize += averageSize * unsizedFiles.length;
        let uploadedSize = 0;
        sizedFiles.forEach((file)=>{
            uploadedSize += file.progress.bytesUploaded;
        });
        unsizedFiles.forEach((file)=>{
            uploadedSize += averageSize * (file.progress.percentage || 0) / 100;
        });
        let totalProgress = totalSize === 0 ? 0 : Math.round(uploadedSize / totalSize * 100); // hot fix, because:
        // uploadedSize ended up larger than totalSize, resulting in 1325% total
        if (totalProgress > 100) totalProgress = 100;
        this.setState({
            totalProgress: totalProgress
        });
        this.emit("progress", totalProgress);
    }
    /**
   * Registers listeners for all global actions, like:
   * `error`, `file-removed`, `upload-progress`
   */ updateOnlineStatus() {
        const online = typeof window.navigator.onLine !== "undefined" ? window.navigator.onLine : true;
        if (!online) {
            this.emit("is-offline");
            this.info(this.i18n("noInternetConnection"), "error", 0);
            this.wasOffline = true;
        } else {
            this.emit("is-online");
            if (this.wasOffline) {
                this.emit("back-online");
                this.info(this.i18n("connectedToInternet"), "success", 3000);
                this.wasOffline = false;
            }
        }
    }
    getID() {
        return this.opts.id;
    }
    /**
   * Registers a plugin with Core.
   *
   * @param {object} Plugin object
   * @param {object} [opts] object with options to be passed to Plugin
   * @returns {object} self for chaining
   */ // eslint-disable-next-line no-shadow
    use(Plugin, opts) {
        if (typeof Plugin !== "function") {
            const msg = `Expected a plugin class, but got ${Plugin === null ? "null" : typeof Plugin}.` + " Please verify that the plugin was imported and spelled correctly.";
            throw new TypeError(msg);
        } // Instantiate
        const plugin = new Plugin(this, opts);
        const pluginId = plugin.id;
        if (!pluginId) throw new Error("Your plugin must have an id");
        if (!plugin.type) throw new Error("Your plugin must have a type");
        const existsPluginAlready = this.getPlugin(pluginId);
        if (existsPluginAlready) {
            const msg = `Already found a plugin named '${existsPluginAlready.id}'. ` + `Tried to use: '${pluginId}'.\n` + "Uppy plugins must have unique `id` options. See https://uppy.io/docs/plugins/#id.";
            throw new Error(msg);
        }
        if (Plugin.VERSION) this.log(`Using ${pluginId} v${Plugin.VERSION}`);
        if (plugin.type in $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_plugins)[$09561e6c9ea9b8f8$var$_plugins]) $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_plugins)[$09561e6c9ea9b8f8$var$_plugins][plugin.type].push(plugin);
        else $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_plugins)[$09561e6c9ea9b8f8$var$_plugins][plugin.type] = [
            plugin
        ];
        plugin.install();
        return this;
    }
    /**
   * Find one Plugin by name.
   *
   * @param {string} id plugin id
   * @returns {BasePlugin|undefined}
   */ getPlugin(id) {
        for (const plugins of Object.values($09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_plugins)[$09561e6c9ea9b8f8$var$_plugins])){
            const foundPlugin = plugins.find((plugin)=>plugin.id === id);
            if (foundPlugin != null) return foundPlugin;
        }
        return undefined;
    }
    [$09561e6c9ea9b8f8$var$_Symbol$for](type) {
        return $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_plugins)[$09561e6c9ea9b8f8$var$_plugins][type];
    }
    /**
   * Iterate through all `use`d plugins.
   *
   * @param {Function} method that will be run on each plugin
   */ iteratePlugins(method) {
        Object.values($09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_plugins)[$09561e6c9ea9b8f8$var$_plugins]).flat(1).forEach(method);
    }
    /**
   * Uninstall and remove a plugin.
   *
   * @param {object} instance The plugin instance to remove.
   */ removePlugin(instance) {
        this.log(`Removing plugin ${instance.id}`);
        this.emit("plugin-remove", instance);
        if (instance.uninstall) instance.uninstall();
        const list = $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_plugins)[$09561e6c9ea9b8f8$var$_plugins][instance.type]; // list.indexOf failed here, because Vue3 converted the plugin instance
        // to a Proxy object, which failed the strict comparison test:
        // obj !== objProxy
        const index = list.findIndex((item)=>item.id === instance.id);
        if (index !== -1) list.splice(index, 1);
        const state = this.getState();
        const updatedState = {
            plugins: {
                ...state.plugins,
                [instance.id]: undefined
            }
        };
        this.setState(updatedState);
    }
    /**
   * Uninstall all plugins and close down this Uppy instance.
   */ close(_temp2) {
        let { reason: reason } = _temp2 === void 0 ? {} : _temp2;
        this.log(`Closing Uppy instance ${this.opts.id}: removing all files and uninstalling plugins`);
        this.cancelAll({
            reason: reason
        });
        $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_storeUnsubscribe)[$09561e6c9ea9b8f8$var$_storeUnsubscribe]();
        this.iteratePlugins((plugin)=>{
            this.removePlugin(plugin);
        });
        if (typeof window !== "undefined" && window.removeEventListener) {
            window.removeEventListener("online", $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_updateOnlineStatus)[$09561e6c9ea9b8f8$var$_updateOnlineStatus]);
            window.removeEventListener("offline", $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_updateOnlineStatus)[$09561e6c9ea9b8f8$var$_updateOnlineStatus]);
        }
    }
    hideInfo() {
        const { info: info } = this.getState();
        this.setState({
            info: info.slice(1)
        });
        this.emit("info-hidden");
    }
    /**
   * Set info message in `state.info`, so that UI plugins like `Informer`
   * can display the message.
   *
   * @param {string | object} message Message to be displayed by the informer
   * @param {string} [type]
   * @param {number} [duration]
   */ info(message, type, duration) {
        if (type === void 0) type = "info";
        if (duration === void 0) duration = 3000;
        const isComplexMessage = typeof message === "object";
        this.setState({
            info: [
                ...this.getState().info,
                {
                    type: type,
                    message: isComplexMessage ? message.message : message,
                    details: isComplexMessage ? message.details : null
                }
            ]
        });
        setTimeout(()=>this.hideInfo(), duration);
        this.emit("info-visible");
    }
    /**
   * Passes messages to a function, provided in `opts.logger`.
   * If `opts.logger: Uppy.debugLogger` or `opts.debug: true`, logs to the browser console.
   *
   * @param {string|object} message to log
   * @param {string} [type] optional `error` or `warning`
   */ log(message, type) {
        const { logger: logger } = this.opts;
        switch(type){
            case "error":
                logger.error(message);
                break;
            case "warning":
                logger.warn(message);
                break;
            default:
                logger.debug(message);
                break;
        }
    }
    /**
   * Restore an upload by its ID.
   */ restore(uploadID) {
        this.log(`Core: attempting to restore upload "${uploadID}"`);
        if (!this.getState().currentUploads[uploadID]) {
            $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_removeUpload)[$09561e6c9ea9b8f8$var$_removeUpload](uploadID);
            return Promise.reject(new Error("Nonexistent upload"));
        }
        return $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_runUpload)[$09561e6c9ea9b8f8$var$_runUpload](uploadID);
    }
    /**
   * Create an upload for a bunch of files.
   *
   * @param {Array<string>} fileIDs File IDs to include in this upload.
   * @returns {string} ID of this upload.
   */ [$09561e6c9ea9b8f8$var$_Symbol$for2]() {
        return $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_createUpload)[$09561e6c9ea9b8f8$var$_createUpload](...arguments);
    }
    /**
   * Add data to an upload's result object.
   *
   * @param {string} uploadID The ID of the upload.
   * @param {object} data Data properties to add to the result object.
   */ addResultData(uploadID, data) {
        if (!$09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_getUpload)[$09561e6c9ea9b8f8$var$_getUpload](uploadID)) {
            this.log(`Not setting result for an upload that has been removed: ${uploadID}`);
            return;
        }
        const { currentUploads: currentUploads } = this.getState();
        const currentUpload = {
            ...currentUploads[uploadID],
            result: {
                ...currentUploads[uploadID].result,
                ...data
            }
        };
        this.setState({
            currentUploads: {
                ...currentUploads,
                [uploadID]: currentUpload
            }
        });
    }
    /**
   * Remove an upload, eg. if it has been canceled or completed.
   *
   * @param {string} uploadID The ID of the upload.
   */ /**
   * Start an upload for all the files that are not currently being uploaded.
   *
   * @returns {Promise}
   */ upload() {
        var _classPrivateFieldLoo;
        if (!((_classPrivateFieldLoo = $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_plugins)[$09561e6c9ea9b8f8$var$_plugins].uploader) != null && _classPrivateFieldLoo.length)) this.log("No uploader type plugins are used", "warning");
        let { files: files } = this.getState();
        const onBeforeUploadResult = this.opts.onBeforeUpload(files);
        if (onBeforeUploadResult === false) return Promise.reject(new Error("Not starting the upload because onBeforeUpload returned false"));
        if (onBeforeUploadResult && typeof onBeforeUploadResult === "object") {
            files = onBeforeUploadResult; // Updating files in state, because uploader plugins receive file IDs,
            // and then fetch the actual file object from state
            this.setState({
                files: files
            });
        }
        return Promise.resolve().then(()=>$09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_restricter)[$09561e6c9ea9b8f8$var$_restricter].validateMinNumberOfFiles(files)).catch((err)=>{
            $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_informAndEmit)[$09561e6c9ea9b8f8$var$_informAndEmit](err);
            throw err;
        }).then(()=>{
            if (!$09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_checkRequiredMetaFields)[$09561e6c9ea9b8f8$var$_checkRequiredMetaFields](files)) throw new $bjvEI.RestrictionError(this.i18n("missingRequiredMetaField"));
        }).catch((err)=>{
            // Doing this in a separate catch because we already emited and logged
            // all the errors in `checkRequiredMetaFields` so we only throw a generic
            // missing fields error here.
            throw err;
        }).then(()=>{
            const { currentUploads: currentUploads } = this.getState(); // get a list of files that are currently assigned to uploads
            const currentlyUploadingFiles = Object.values(currentUploads).flatMap((curr)=>curr.fileIDs);
            const waitingFileIDs = [];
            Object.keys(files).forEach((fileID)=>{
                const file = this.getFile(fileID); // if the file hasn't started uploading and hasn't already been assigned to an upload..
                if (!file.progress.uploadStarted && currentlyUploadingFiles.indexOf(fileID) === -1) waitingFileIDs.push(file.id);
            });
            const uploadID = $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_createUpload)[$09561e6c9ea9b8f8$var$_createUpload](waitingFileIDs);
            return $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_runUpload)[$09561e6c9ea9b8f8$var$_runUpload](uploadID);
        }).catch((err)=>{
            this.emit("error", err);
            this.log(err, "error");
            throw err;
        });
    }
}
function $09561e6c9ea9b8f8$var$_informAndEmit2(error, file) {
    const { message: message, details: details = "" } = error;
    if (error.isRestriction) this.emit("restriction-failed", file, error);
    else this.emit("error", error);
    this.info({
        message: message,
        details: details
    }, "error", this.opts.infoTimeout);
    this.log(`${message} ${details}`.trim(), "error");
}
function $09561e6c9ea9b8f8$var$_checkRequiredMetaFieldsOnFile2(file) {
    const { missingFields: missingFields, error: error } = $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_restricter)[$09561e6c9ea9b8f8$var$_restricter].getMissingRequiredMetaFields(file);
    if (missingFields.length > 0) {
        this.setFileState(file.id, {
            missingRequiredMetaFields: missingFields
        });
        this.log(error.message);
        this.emit("restriction-failed", file, error);
        return false;
    }
    return true;
}
function $09561e6c9ea9b8f8$var$_checkRequiredMetaFields2(files) {
    let success = true;
    for (const file of Object.values(files))if (!$09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_checkRequiredMetaFieldsOnFile)[$09561e6c9ea9b8f8$var$_checkRequiredMetaFieldsOnFile](file)) success = false;
    return success;
}
function $09561e6c9ea9b8f8$var$_assertNewUploadAllowed2(file) {
    const { allowNewUpload: allowNewUpload } = this.getState();
    if (allowNewUpload === false) {
        const error = new $bjvEI.RestrictionError(this.i18n("noMoreFilesAllowed"));
        $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_informAndEmit)[$09561e6c9ea9b8f8$var$_informAndEmit](error, file);
        throw error;
    }
}
function $09561e6c9ea9b8f8$var$_checkAndCreateFileStateObject2(files, fileDescriptor) {
    const fileType = $9y4Co(fileDescriptor);
    const fileName = $lPSpS(fileType, fileDescriptor);
    const fileExtension = $hFmsk(fileName).extension;
    const isRemote = Boolean(fileDescriptor.isRemote);
    const fileID = $2tdJv({
        ...fileDescriptor,
        type: fileType
    });
    if (this.checkIfFileAlreadyExists(fileID)) {
        const error = new $bjvEI.RestrictionError(this.i18n("noDuplicates", {
            fileName: fileName
        }));
        $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_informAndEmit)[$09561e6c9ea9b8f8$var$_informAndEmit](error, fileDescriptor);
        throw error;
    }
    const meta = fileDescriptor.meta || {};
    meta.name = fileName;
    meta.type = fileType; // `null` means the size is unknown.
    const size = Number.isFinite(fileDescriptor.data.size) ? fileDescriptor.data.size : null;
    let newFile = {
        source: fileDescriptor.source || "",
        id: fileID,
        name: fileName,
        extension: fileExtension || "",
        meta: {
            ...this.getState().meta,
            ...meta
        },
        type: fileType,
        data: fileDescriptor.data,
        progress: {
            percentage: 0,
            bytesUploaded: 0,
            bytesTotal: size,
            uploadComplete: false,
            uploadStarted: null
        },
        size: size,
        isRemote: isRemote,
        remote: fileDescriptor.remote || "",
        preview: fileDescriptor.preview
    };
    const onBeforeFileAddedResult = this.opts.onBeforeFileAdded(newFile, files);
    if (onBeforeFileAddedResult === false) {
        // Don’t show UI info for this error, as it should be done by the developer
        const error = new $bjvEI.RestrictionError("Cannot add the file because onBeforeFileAdded returned false.");
        this.emit("restriction-failed", fileDescriptor, error);
        throw error;
    } else if (typeof onBeforeFileAddedResult === "object" && onBeforeFileAddedResult !== null) newFile = onBeforeFileAddedResult;
    try {
        const filesArray = Object.keys(files).map((i)=>files[i]);
        $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_restricter)[$09561e6c9ea9b8f8$var$_restricter].validate(newFile, filesArray);
    } catch (err) {
        $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_informAndEmit)[$09561e6c9ea9b8f8$var$_informAndEmit](err, newFile);
        throw err;
    }
    return newFile;
}
function $09561e6c9ea9b8f8$var$_startIfAutoProceed2() {
    if (this.opts.autoProceed && !this.scheduledAutoProceed) this.scheduledAutoProceed = setTimeout(()=>{
        this.scheduledAutoProceed = null;
        this.upload().catch((err)=>{
            if (!err.isRestriction) this.log(err.stack || err.message || err);
        });
    }, 4);
}
function $09561e6c9ea9b8f8$var$_addListeners2() {
    /**
   * @param {Error} error
   * @param {object} [file]
   * @param {object} [response]
   */ const errorHandler = (error, file, response)=>{
        let errorMsg = error.message || "Unknown error";
        if (error.details) errorMsg += ` ${error.details}`;
        this.setState({
            error: errorMsg
        });
        if (file != null && file.id in this.getState().files) this.setFileState(file.id, {
            error: errorMsg,
            response: response
        });
    };
    this.on("error", errorHandler);
    this.on("upload-error", (file, error, response)=>{
        errorHandler(error, file, response);
        if (typeof error === "object" && error.message) {
            const newError = new Error(error.message);
            newError.details = error.message;
            if (error.details) newError.details += ` ${error.details}`;
            newError.message = this.i18n("failedToUpload", {
                file: file == null ? void 0 : file.name
            });
            $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_informAndEmit)[$09561e6c9ea9b8f8$var$_informAndEmit](newError);
        } else $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_informAndEmit)[$09561e6c9ea9b8f8$var$_informAndEmit](error);
    });
    this.on("upload", ()=>{
        this.setState({
            error: null
        });
    });
    this.on("upload-started", (file)=>{
        if (file == null || !this.getFile(file.id)) {
            this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
            return;
        }
        this.setFileState(file.id, {
            progress: {
                uploadStarted: Date.now(),
                uploadComplete: false,
                percentage: 0,
                bytesUploaded: 0,
                bytesTotal: file.size
            }
        });
    });
    this.on("upload-progress", this.calculateProgress);
    this.on("upload-success", (file, uploadResp)=>{
        if (file == null || !this.getFile(file.id)) {
            this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
            return;
        }
        const currentProgress = this.getFile(file.id).progress;
        this.setFileState(file.id, {
            progress: {
                ...currentProgress,
                postprocess: $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_postProcessors)[$09561e6c9ea9b8f8$var$_postProcessors].size > 0 ? {
                    mode: "indeterminate"
                } : null,
                uploadComplete: true,
                percentage: 100,
                bytesUploaded: currentProgress.bytesTotal
            },
            response: uploadResp,
            uploadURL: uploadResp.uploadURL,
            isPaused: false
        }); // Remote providers sometimes don't tell us the file size,
        // but we can know how many bytes we uploaded once the upload is complete.
        if (file.size == null) this.setFileState(file.id, {
            size: uploadResp.bytesUploaded || currentProgress.bytesTotal
        });
        this.calculateTotalProgress();
    });
    this.on("preprocess-progress", (file, progress)=>{
        if (file == null || !this.getFile(file.id)) {
            this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
            return;
        }
        this.setFileState(file.id, {
            progress: {
                ...this.getFile(file.id).progress,
                preprocess: progress
            }
        });
    });
    this.on("preprocess-complete", (file)=>{
        if (file == null || !this.getFile(file.id)) {
            this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
            return;
        }
        const files = {
            ...this.getState().files
        };
        files[file.id] = {
            ...files[file.id],
            progress: {
                ...files[file.id].progress
            }
        };
        delete files[file.id].progress.preprocess;
        this.setState({
            files: files
        });
    });
    this.on("postprocess-progress", (file, progress)=>{
        if (file == null || !this.getFile(file.id)) {
            this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
            return;
        }
        this.setFileState(file.id, {
            progress: {
                ...this.getState().files[file.id].progress,
                postprocess: progress
            }
        });
    });
    this.on("postprocess-complete", (file)=>{
        if (file == null || !this.getFile(file.id)) {
            this.log(`Not setting progress for a file that has been removed: ${file == null ? void 0 : file.id}`);
            return;
        }
        const files = {
            ...this.getState().files
        };
        files[file.id] = {
            ...files[file.id],
            progress: {
                ...files[file.id].progress
            }
        };
        delete files[file.id].progress.postprocess;
        this.setState({
            files: files
        });
    });
    this.on("restored", ()=>{
        // Files may have changed--ensure progress is still accurate.
        this.calculateTotalProgress();
    });
    this.on("dashboard:file-edit-complete", (file)=>{
        if (file) $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_checkRequiredMetaFieldsOnFile)[$09561e6c9ea9b8f8$var$_checkRequiredMetaFieldsOnFile](file);
    }); // show informer if offline
    if (typeof window !== "undefined" && window.addEventListener) {
        window.addEventListener("online", $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_updateOnlineStatus)[$09561e6c9ea9b8f8$var$_updateOnlineStatus]);
        window.addEventListener("offline", $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_updateOnlineStatus)[$09561e6c9ea9b8f8$var$_updateOnlineStatus]);
        setTimeout($09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_updateOnlineStatus)[$09561e6c9ea9b8f8$var$_updateOnlineStatus], 3000);
    }
}
function $09561e6c9ea9b8f8$var$_createUpload2(fileIDs, opts) {
    if (opts === void 0) opts = {};
    // uppy.retryAll sets this to true — when retrying we want to ignore `allowNewUpload: false`
    const { forceAllowNewUpload: forceAllowNewUpload = false } = opts;
    const { allowNewUpload: allowNewUpload, currentUploads: currentUploads } = this.getState();
    if (!allowNewUpload && !forceAllowNewUpload) throw new Error("Cannot create a new upload: already uploading.");
    const uploadID = (0, $4Kuwt.nanoid)();
    this.emit("upload", {
        id: uploadID,
        fileIDs: fileIDs
    });
    this.setState({
        allowNewUpload: this.opts.allowMultipleUploadBatches !== false && this.opts.allowMultipleUploads !== false,
        currentUploads: {
            ...currentUploads,
            [uploadID]: {
                fileIDs: fileIDs,
                step: 0,
                result: {}
            }
        }
    });
    return uploadID;
}
function $09561e6c9ea9b8f8$var$_getUpload2(uploadID) {
    const { currentUploads: currentUploads } = this.getState();
    return currentUploads[uploadID];
}
function $09561e6c9ea9b8f8$var$_removeUpload2(uploadID) {
    const currentUploads = {
        ...this.getState().currentUploads
    };
    delete currentUploads[uploadID];
    this.setState({
        currentUploads: currentUploads
    });
}
async function $09561e6c9ea9b8f8$var$_runUpload2(uploadID) {
    let { currentUploads: currentUploads } = this.getState();
    let currentUpload = currentUploads[uploadID];
    const restoreStep = currentUpload.step || 0;
    const steps = [
        ...$09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_preProcessors)[$09561e6c9ea9b8f8$var$_preProcessors],
        ...$09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_uploaders)[$09561e6c9ea9b8f8$var$_uploaders],
        ...$09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_postProcessors)[$09561e6c9ea9b8f8$var$_postProcessors]
    ];
    try {
        for(let step = restoreStep; step < steps.length; step++){
            if (!currentUpload) break;
            const fn = steps[step];
            const updatedUpload = {
                ...currentUpload,
                step: step
            };
            this.setState({
                currentUploads: {
                    ...currentUploads,
                    [uploadID]: updatedUpload
                }
            }); // TODO give this the `updatedUpload` object as its only parameter maybe?
            // Otherwise when more metadata may be added to the upload this would keep getting more parameters
            await fn(updatedUpload.fileIDs, uploadID); // Update currentUpload value in case it was modified asynchronously.
            currentUploads = this.getState().currentUploads;
            currentUpload = currentUploads[uploadID];
        }
    } catch (err) {
        $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_removeUpload)[$09561e6c9ea9b8f8$var$_removeUpload](uploadID);
        throw err;
    } // Set result data.
    if (currentUpload) {
        // Mark postprocessing step as complete if necessary; this addresses a case where we might get
        // stuck in the postprocessing UI while the upload is fully complete.
        // If the postprocessing steps do not do any work, they may not emit postprocessing events at
        // all, and never mark the postprocessing as complete. This is fine on its own but we
        // introduced code in the @uppy/core upload-success handler to prepare postprocessing progress
        // state if any postprocessors are registered. That is to avoid a "flash of completed state"
        // before the postprocessing plugins can emit events.
        //
        // So, just in case an upload with postprocessing plugins *has* completed *without* emitting
        // postprocessing completion, we do it instead.
        currentUpload.fileIDs.forEach((fileID)=>{
            const file = this.getFile(fileID);
            if (file && file.progress.postprocess) this.emit("postprocess-complete", file);
        });
        const files = currentUpload.fileIDs.map((fileID)=>this.getFile(fileID));
        const successful = files.filter((file)=>!file.error);
        const failed = files.filter((file)=>file.error);
        await this.addResultData(uploadID, {
            successful: successful,
            failed: failed,
            uploadID: uploadID
        }); // Update currentUpload value in case it was modified asynchronously.
        currentUploads = this.getState().currentUploads;
        currentUpload = currentUploads[uploadID];
    } // Emit completion events.
    // This is in a separate function so that the `currentUploads` variable
    // always refers to the latest state. In the handler right above it refers
    // to an outdated object without the `.result` property.
    let result;
    if (currentUpload) {
        result = currentUpload.result;
        this.emit("complete", result);
        $09561e6c9ea9b8f8$var$_classPrivateFieldLooseBase(this, $09561e6c9ea9b8f8$var$_removeUpload)[$09561e6c9ea9b8f8$var$_removeUpload](uploadID);
    }
    if (result == null) this.log(`Not setting result for an upload that has been removed: ${uploadID}`);
    return result;
}
$09561e6c9ea9b8f8$var$Uppy.VERSION = $09561e6c9ea9b8f8$var$packageJson.version;
module.exports = $09561e6c9ea9b8f8$var$Uppy;

});
parcelRegister("4Kuwt", function(module, exports) {

$parcel$export(module.exports, "nanoid", () => $3753227fdc8a3f3b$export$ac4959f4f1338dfc);
let $3753227fdc8a3f3b$var$urlAlphabet = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let $3753227fdc8a3f3b$export$62e99e5c9f473d7f = (alphabet, size)=>{
    return ()=>{
        let id = "";
        let i = size;
        while(i--)id += alphabet[Math.random() * alphabet.length | 0];
        return id;
    };
};
let $3753227fdc8a3f3b$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $3753227fdc8a3f3b$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};

});

parcelRegister("bjvEI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.defaultOptions = module.exports.RestrictionError = module.exports.Restricter = void 0;

var $bCrvb = parcelRequire("bCrvb");

var $bnyoL = parcelRequire("bnyoL");
const $83ca063a251f94cc$var$defaultOptions = {
    maxFileSize: null,
    minFileSize: null,
    maxTotalFileSize: null,
    maxNumberOfFiles: null,
    minNumberOfFiles: null,
    allowedFileTypes: null,
    requiredMetaFields: []
};
module.exports.defaultOptions = $83ca063a251f94cc$var$defaultOptions;
class $83ca063a251f94cc$var$RestrictionError extends Error {
    constructor(){
        super(...arguments);
        this.isRestriction = true;
    }
}
module.exports.RestrictionError = $83ca063a251f94cc$var$RestrictionError;
if (typeof AggregateError === "undefined") // eslint-disable-next-line no-global-assign
// TODO: remove this "polyfill" in the next major.
globalThis.AggregateError = class AggregateError1 extends Error {
    constructor(errors, message){
        super(message);
        this.errors = errors;
    }
};
class $83ca063a251f94cc$var$Restricter {
    constructor(getOpts, i18n){
        this.i18n = i18n;
        this.getOpts = ()=>{
            const opts = getOpts();
            if (opts.restrictions.allowedFileTypes != null && !Array.isArray(opts.restrictions.allowedFileTypes)) throw new TypeError("`restrictions.allowedFileTypes` must be an array");
            return opts;
        };
    }
    validate(file, files) {
        const { maxFileSize: maxFileSize, minFileSize: minFileSize, maxTotalFileSize: maxTotalFileSize, maxNumberOfFiles: maxNumberOfFiles, allowedFileTypes: allowedFileTypes } = this.getOpts().restrictions;
        if (maxNumberOfFiles && files.length + 1 > maxNumberOfFiles) throw new $83ca063a251f94cc$var$RestrictionError(`${this.i18n("youCanOnlyUploadX", {
            smart_count: maxNumberOfFiles
        })}`);
        if (allowedFileTypes) {
            const isCorrectFileType = allowedFileTypes.some((type)=>{
                // check if this is a mime-type
                if (type.includes("/")) {
                    if (!file.type) return false;
                    return $bnyoL(file.type.replace(/;.*?$/, ""), type);
                } // otherwise this is likely an extension
                if (type[0] === "." && file.extension) return file.extension.toLowerCase() === type.slice(1).toLowerCase();
                return false;
            });
            if (!isCorrectFileType) {
                const allowedFileTypesString = allowedFileTypes.join(", ");
                throw new $83ca063a251f94cc$var$RestrictionError(this.i18n("youCanOnlyUploadFileTypes", {
                    types: allowedFileTypesString
                }));
            }
        } // We can't check maxTotalFileSize if the size is unknown.
        if (maxTotalFileSize && file.size != null) {
            const totalFilesSize = files.reduce((total, f)=>total + f.size, file.size);
            if (totalFilesSize > maxTotalFileSize) throw new $83ca063a251f94cc$var$RestrictionError(this.i18n("exceedsSize", {
                size: $bCrvb(maxTotalFileSize),
                file: file.name
            }));
        } // We can't check maxFileSize if the size is unknown.
        if (maxFileSize && file.size != null && file.size > maxFileSize) throw new $83ca063a251f94cc$var$RestrictionError(this.i18n("exceedsSize", {
            size: $bCrvb(maxFileSize),
            file: file.name
        }));
         // We can't check minFileSize if the size is unknown.
        if (minFileSize && file.size != null && file.size < minFileSize) throw new $83ca063a251f94cc$var$RestrictionError(this.i18n("inferiorSize", {
            size: $bCrvb(minFileSize)
        }));
    }
    validateMinNumberOfFiles(files) {
        const { minNumberOfFiles: minNumberOfFiles } = this.getOpts().restrictions;
        if (Object.keys(files).length < minNumberOfFiles) throw new $83ca063a251f94cc$var$RestrictionError(this.i18n("youHaveToAtLeastSelectX", {
            smart_count: minNumberOfFiles
        }));
    }
    getMissingRequiredMetaFields(file) {
        const error = new $83ca063a251f94cc$var$RestrictionError(this.i18n("missingRequiredMetaFieldOnFile", {
            fileName: file.name
        }));
        const { requiredMetaFields: requiredMetaFields } = this.getOpts().restrictions; // TODO: migrate to Object.hasOwn in the next major.
        const own = Object.prototype.hasOwnProperty;
        const missingFields = [];
        for (const field of requiredMetaFields)if (!own.call(file.meta, field) || file.meta[field] === "") missingFields.push(field);
        return {
            missingFields: missingFields,
            error: error
        };
    }
}
module.exports.Restricter = $83ca063a251f94cc$var$Restricter;

});
parcelRegister("bCrvb", function(module, exports) {
// Adapted from https://github.com/Flet/prettier-bytes/
// Changing 1000 bytes to 1024, so we can keep uppercase KB vs kB
// ISC License (c) Dan Flettre https://github.com/Flet/prettier-bytes/blob/master/LICENSE
module.exports = function prettierBytes(num) {
    if (typeof num !== "number" || isNaN(num)) throw new TypeError("Expected a number, got " + typeof num);
    var neg = num < 0;
    var units = [
        "B",
        "KB",
        "MB",
        "GB",
        "TB",
        "PB",
        "EB",
        "ZB",
        "YB"
    ];
    if (neg) num = -num;
    if (num < 1) return (neg ? "-" : "") + num + " B";
    var exponent = Math.min(Math.floor(Math.log(num) / Math.log(1024)), units.length - 1);
    num = Number(num / Math.pow(1024, exponent));
    var unit = units[exponent];
    if (num >= 10 || num % 1 === 0) // Do not show decimals when the number is two-digit, or if the number has no
    // decimal component.
    return (neg ? "-" : "") + num.toFixed(0) + " " + unit;
    else return (neg ? "-" : "") + num.toFixed(1) + " " + unit;
};

});

parcelRegister("bnyoL", function(module, exports) {

var $enJjN = parcelRequire("enJjN");
var $848c86846acd75fa$var$reMimePartSplit = /[\/\+\.]/;
/**
  # mime-match

  A simple function to checker whether a target mime type matches a mime-type
  pattern (e.g. image/jpeg matches image/jpeg OR image/*).

  ## Example Usage

  <<< example.js

**/ module.exports = function(target, pattern) {
    function test(pattern) {
        var result = $enJjN(pattern, target, $848c86846acd75fa$var$reMimePartSplit);
        // ensure that we have a valid mime type (should have two parts)
        return result && result.length >= 2;
    }
    return pattern ? test(pattern.split(";")[0]) : test;
};

});
parcelRegister("enJjN", function(module, exports) {
/* jshint node: true */ "use strict";
/**
  # wildcard

  Very simple wildcard matching, which is designed to provide the same
  functionality that is found in the
  [eve](https://github.com/adobe-webplatform/eve) eventing library.

  ## Usage

  It works with strings:

  <<< examples/strings.js

  Arrays:

  <<< examples/arrays.js

  Objects (matching against keys):

  <<< examples/objects.js

  While the library works in Node, if you are are looking for file-based
  wildcard matching then you should have a look at:

  <https://github.com/isaacs/node-glob>
**/ function $a7865dee230829d3$var$WildcardMatcher(text, separator) {
    this.text = text = text || "";
    this.hasWild = ~text.indexOf("*");
    this.separator = separator;
    this.parts = text.split(separator);
}
$a7865dee230829d3$var$WildcardMatcher.prototype.match = function(input) {
    var matches = true;
    var parts = this.parts;
    var ii;
    var partsCount = parts.length;
    var testParts;
    if (typeof input == "string" || input instanceof String) {
        if (!this.hasWild && this.text != input) matches = false;
        else {
            testParts = (input || "").split(this.separator);
            for(ii = 0; matches && ii < partsCount; ii++){
                if (parts[ii] === "*") continue;
                else if (ii < testParts.length) matches = parts[ii] === testParts[ii];
                else matches = false;
            }
            // If matches, then return the component parts
            matches = matches && testParts;
        }
    } else if (typeof input.splice == "function") {
        matches = [];
        for(ii = input.length; ii--;)if (this.match(input[ii])) matches[matches.length] = input[ii];
    } else if (typeof input == "object") {
        matches = {};
        for(var key in input)if (this.match(key)) matches[key] = input[key];
    }
    return matches;
};
module.exports = function(text, test, separator) {
    var matcher = new $a7865dee230829d3$var$WildcardMatcher(text, separator || /[\/\.]/);
    if (typeof test != "undefined") return matcher.match(test);
    return matcher;
};

});



parcelRegister("38UkU", function(module, exports) {
"use strict";
function $249dd1a5d26908a1$var$_classPrivateFieldLooseBase(receiver, privateKey) {
    if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) throw new TypeError("attempted to use private field on non-instance");
    return receiver;
}
var $249dd1a5d26908a1$var$id = 0;
function $249dd1a5d26908a1$var$_classPrivateFieldLooseKey(name) {
    return "__private_" + $249dd1a5d26908a1$var$id++ + "_" + name;
}

var $7sGce = parcelRequire("7sGce");
function $249dd1a5d26908a1$var$insertReplacement(source, rx, replacement) {
    const newParts = [];
    source.forEach((chunk)=>{
        // When the source contains multiple placeholders for interpolation,
        // we should ignore chunks that are not strings, because those
        // can be JSX objects and will be otherwise incorrectly turned into strings.
        // Without this condition we’d get this: [object Object] hello [object Object] my <button>
        if (typeof chunk !== "string") return newParts.push(chunk);
        return rx[Symbol.split](chunk).forEach((raw, i, list)=>{
            if (raw !== "") newParts.push(raw);
             // Interlace with the `replacement` value
            if (i < list.length - 1) newParts.push(replacement);
        });
    });
    return newParts;
}
/**
 * Takes a string with placeholder variables like `%{smart_count} file selected`
 * and replaces it with values from options `{smart_count: 5}`
 *
 * @license https://github.com/airbnb/polyglot.js/blob/master/LICENSE
 * taken from https://github.com/airbnb/polyglot.js/blob/master/lib/polyglot.js#L299
 *
 * @param {string} phrase that needs interpolation, with placeholders
 * @param {object} options with values that will be used to replace placeholders
 * @returns {any[]} interpolated
 */ function $249dd1a5d26908a1$var$interpolate(phrase, options) {
    const dollarRegex = /\$/g;
    const dollarBillsYall = "$$$$";
    let interpolated = [
        phrase
    ];
    if (options == null) return interpolated;
    for (const arg of Object.keys(options))if (arg !== "_") {
        // Ensure replacement value is escaped to prevent special $-prefixed
        // regex replace tokens. the "$$$$" is needed because each "$" needs to
        // be escaped with "$" itself, and we need two in the resulting output.
        let replacement = options[arg];
        if (typeof replacement === "string") replacement = dollarRegex[Symbol.replace](replacement, dollarBillsYall);
         // We create a new `RegExp` each time instead of using a more-efficient
        // string replace so that the same argument can be replaced multiple times
        // in the same phrase.
        interpolated = $249dd1a5d26908a1$var$insertReplacement(interpolated, new RegExp(`%\\{${arg}\\}`, "g"), replacement);
    }
    return interpolated;
}
/**
 * Translates strings with interpolation & pluralization support.
 * Extensible with custom dictionaries and pluralization functions.
 *
 * Borrows heavily from and inspired by Polyglot https://github.com/airbnb/polyglot.js,
 * basically a stripped-down version of it. Differences: pluralization functions are not hardcoded
 * and can be easily added among with dictionaries, nested objects are used for pluralization
 * as opposed to `||||` delimeter
 *
 * Usage example: `translator.translate('files_chosen', {smart_count: 3})`
 */ var $249dd1a5d26908a1$var$_apply = /*#__PURE__*/ $249dd1a5d26908a1$var$_classPrivateFieldLooseKey("apply");
class $249dd1a5d26908a1$var$Translator {
    /**
   * @param {object|Array<object>} locales - locale or list of locales.
   */ constructor(locales){
        Object.defineProperty(this, $249dd1a5d26908a1$var$_apply, {
            value: $249dd1a5d26908a1$var$_apply2
        });
        this.locale = {
            strings: {},
            pluralize (n) {
                if (n === 1) return 0;
                return 1;
            }
        };
        if (Array.isArray(locales)) locales.forEach($249dd1a5d26908a1$var$_classPrivateFieldLooseBase(this, $249dd1a5d26908a1$var$_apply)[$249dd1a5d26908a1$var$_apply], this);
        else $249dd1a5d26908a1$var$_classPrivateFieldLooseBase(this, $249dd1a5d26908a1$var$_apply)[$249dd1a5d26908a1$var$_apply](locales);
    }
    /**
   * Public translate method
   *
   * @param {string} key
   * @param {object} options with values that will be used later to replace placeholders in string
   * @returns {string} translated (and interpolated)
   */ translate(key, options) {
        return this.translateArray(key, options).join("");
    }
    /**
   * Get a translation and return the translated and interpolated parts as an array.
   *
   * @param {string} key
   * @param {object} options with values that will be used to replace placeholders
   * @returns {Array} The translated and interpolated parts, in order.
   */ translateArray(key, options) {
        if (!$7sGce(this.locale.strings, key)) throw new Error(`missing string: ${key}`);
        const string = this.locale.strings[key];
        const hasPluralForms = typeof string === "object";
        if (hasPluralForms) {
            if (options && typeof options.smart_count !== "undefined") {
                const plural = this.locale.pluralize(options.smart_count);
                return $249dd1a5d26908a1$var$interpolate(string[plural], options);
            }
            throw new Error("Attempted to use a string with plural forms, but no value was given for %{smart_count}");
        }
        return $249dd1a5d26908a1$var$interpolate(string, options);
    }
}
function $249dd1a5d26908a1$var$_apply2(locale) {
    if (!(locale != null && locale.strings)) return;
    const prevLocale = this.locale;
    this.locale = {
        ...prevLocale,
        strings: {
            ...prevLocale.strings,
            ...locale.strings
        }
    };
    this.locale.pluralize = locale.pluralize || prevLocale.pluralize;
}
module.exports = $249dd1a5d26908a1$var$Translator;

});
parcelRegister("7sGce", function(module, exports) {
"use strict";
function $56ebe136d9dca885$var$has(object, key) {
    return Object.prototype.hasOwnProperty.call(object, key);
}
module.exports = $56ebe136d9dca885$var$has;

});


parcelRegister("5E2ck", function(module, exports) {
/**
* Create an event emitter with namespaces
* @name createNamespaceEmitter
* @example
* var emitter = require('./index')()
*
* emitter.on('*', function () {
*   console.log('all events emitted', this.event)
* })
*
* emitter.on('example', function () {
*   console.log('example event emitted')
* })
*/ module.exports = function createNamespaceEmitter() {
    var emitter = {};
    var _fns = emitter._fns = {};
    /**
  * Emit an event. Optionally namespace the event. Handlers are fired in the order in which they were added with exact matches taking precedence. Separate the namespace and event with a `:`
  * @name emit
  * @param {String} event – the name of the event, with optional namespace
  * @param {...*} data – up to 6 arguments that are passed to the event listener
  * @example
  * emitter.emit('example')
  * emitter.emit('demo:test')
  * emitter.emit('data', { example: true}, 'a string', 1)
  */ emitter.emit = function emit(event, arg1, arg2, arg3, arg4, arg5, arg6) {
        var toEmit = getListeners(event);
        if (toEmit.length) emitAll(event, toEmit, [
            arg1,
            arg2,
            arg3,
            arg4,
            arg5,
            arg6
        ]);
    };
    /**
  * Create en event listener.
  * @name on
  * @param {String} event
  * @param {Function} fn
  * @example
  * emitter.on('example', function () {})
  * emitter.on('demo', function () {})
  */ emitter.on = function on(event, fn) {
        if (!_fns[event]) _fns[event] = [];
        _fns[event].push(fn);
    };
    /**
  * Create en event listener that fires once.
  * @name once
  * @param {String} event
  * @param {Function} fn
  * @example
  * emitter.once('example', function () {})
  * emitter.once('demo', function () {})
  */ emitter.once = function once(event, fn) {
        function one() {
            fn.apply(this, arguments);
            emitter.off(event, one);
        }
        this.on(event, one);
    };
    /**
  * Stop listening to an event. Stop all listeners on an event by only passing the event name. Stop a single listener by passing that event handler as a callback.
  * You must be explicit about what will be unsubscribed: `emitter.off('demo')` will unsubscribe an `emitter.on('demo')` listener,
  * `emitter.off('demo:example')` will unsubscribe an `emitter.on('demo:example')` listener
  * @name off
  * @param {String} event
  * @param {Function} [fn] – the specific handler
  * @example
  * emitter.off('example')
  * emitter.off('demo', function () {})
  */ emitter.off = function off(event, fn) {
        var keep = [];
        if (event && fn) {
            var fns = this._fns[event];
            var i = 0;
            var l = fns ? fns.length : 0;
            for(i; i < l; i++)if (fns[i] !== fn) keep.push(fns[i]);
        }
        keep.length ? this._fns[event] = keep : delete this._fns[event];
    };
    function getListeners(e) {
        var out = _fns[e] ? _fns[e] : [];
        var idx = e.indexOf(":");
        var args = idx === -1 ? [
            e
        ] : [
            e.substring(0, idx),
            e.substring(idx + 1)
        ];
        var keys = Object.keys(_fns);
        var i = 0;
        var l = keys.length;
        for(i; i < l; i++){
            var key = keys[i];
            if (key === "*") out = out.concat(_fns[key]);
            if (args.length === 2 && args[0] === key) {
                out = out.concat(_fns[key]);
                break;
            }
        }
        return out;
    }
    function emitAll(e, fns, args) {
        var i = 0;
        var l = fns.length;
        for(i; i < l; i++){
            if (!fns[i]) break;
            fns[i].event = e;
            fns[i].apply(fns[i], args);
        }
    }
    return emitter;
};

});

parcelRegister("eMXxl", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $ac43bb23aa0a60e2$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used as references for various `Number` constants. */ var $ac43bb23aa0a60e2$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $ac43bb23aa0a60e2$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $ac43bb23aa0a60e2$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $ac43bb23aa0a60e2$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $ac43bb23aa0a60e2$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $ac43bb23aa0a60e2$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $ac43bb23aa0a60e2$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $ac43bb23aa0a60e2$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $ac43bb23aa0a60e2$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $ac43bb23aa0a60e2$var$root = $ac43bb23aa0a60e2$var$freeGlobal || $ac43bb23aa0a60e2$var$freeSelf || Function("return this")();
/** Used for built-in method references. */ var $ac43bb23aa0a60e2$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $ac43bb23aa0a60e2$var$objectToString = $ac43bb23aa0a60e2$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ac43bb23aa0a60e2$var$nativeMax = Math.max, $ac43bb23aa0a60e2$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $ac43bb23aa0a60e2$var$now = function() {
    return $ac43bb23aa0a60e2$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $ac43bb23aa0a60e2$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($ac43bb23aa0a60e2$var$FUNC_ERROR_TEXT);
    wait = $ac43bb23aa0a60e2$var$toNumber(wait) || 0;
    if ($ac43bb23aa0a60e2$var$isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $ac43bb23aa0a60e2$var$nativeMax($ac43bb23aa0a60e2$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $ac43bb23aa0a60e2$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $ac43bb23aa0a60e2$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($ac43bb23aa0a60e2$var$now());
    }
    function debounced() {
        var time = $ac43bb23aa0a60e2$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $ac43bb23aa0a60e2$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($ac43bb23aa0a60e2$var$FUNC_ERROR_TEXT);
    if ($ac43bb23aa0a60e2$var$isObject(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return $ac43bb23aa0a60e2$var$debounce(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $ac43bb23aa0a60e2$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $ac43bb23aa0a60e2$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $ac43bb23aa0a60e2$var$isSymbol(value) {
    return typeof value == "symbol" || $ac43bb23aa0a60e2$var$isObjectLike(value) && $ac43bb23aa0a60e2$var$objectToString.call(value) == $ac43bb23aa0a60e2$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $ac43bb23aa0a60e2$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($ac43bb23aa0a60e2$var$isSymbol(value)) return $ac43bb23aa0a60e2$var$NAN;
    if ($ac43bb23aa0a60e2$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $ac43bb23aa0a60e2$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($ac43bb23aa0a60e2$var$reTrim, "");
    var isBinary = $ac43bb23aa0a60e2$var$reIsBinary.test(value);
    return isBinary || $ac43bb23aa0a60e2$var$reIsOctal.test(value) ? $ac43bb23aa0a60e2$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $ac43bb23aa0a60e2$var$reIsBadHex.test(value) ? $ac43bb23aa0a60e2$var$NAN : +value;
}
module.exports = $ac43bb23aa0a60e2$var$throttle;

});

parcelRegister("87ZT9", function(module, exports) {
"use strict";
function $5eaefbf13bcf8ac6$var$_classPrivateFieldLooseBase(receiver, privateKey) {
    if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) throw new TypeError("attempted to use private field on non-instance");
    return receiver;
}
var $5eaefbf13bcf8ac6$var$id = 0;
function $5eaefbf13bcf8ac6$var$_classPrivateFieldLooseKey(name) {
    return "__private_" + $5eaefbf13bcf8ac6$var$id++ + "_" + name;
}
const $5eaefbf13bcf8ac6$var$packageJson = {
    "version": "2.1.1"
};
/**
 * Default store that keeps state in a simple object.
 */ var $5eaefbf13bcf8ac6$var$_publish = /*#__PURE__*/ $5eaefbf13bcf8ac6$var$_classPrivateFieldLooseKey("publish");
class $5eaefbf13bcf8ac6$var$DefaultStore {
    constructor(){
        Object.defineProperty(this, $5eaefbf13bcf8ac6$var$_publish, {
            value: $5eaefbf13bcf8ac6$var$_publish2
        });
        this.state = {};
        this.callbacks = []; // TODO: use a Set instead, make it a private prop
    }
    getState() {
        return this.state;
    }
    setState(patch) {
        const prevState = {
            ...this.state
        };
        const nextState = {
            ...this.state,
            ...patch
        };
        this.state = nextState;
        $5eaefbf13bcf8ac6$var$_classPrivateFieldLooseBase(this, $5eaefbf13bcf8ac6$var$_publish)[$5eaefbf13bcf8ac6$var$_publish](prevState, nextState, patch);
    }
    subscribe(listener) {
        this.callbacks.push(listener);
        return ()=>{
            // Remove the listener.
            this.callbacks.splice(this.callbacks.indexOf(listener), 1);
        };
    }
} // TODO: export the class instead in the next major.
function $5eaefbf13bcf8ac6$var$_publish2() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    this.callbacks.forEach((listener)=>{
        listener(...args);
    });
}
$5eaefbf13bcf8ac6$var$DefaultStore.VERSION = $5eaefbf13bcf8ac6$var$packageJson.version;
function $5eaefbf13bcf8ac6$var$defaultStore() {
    return new $5eaefbf13bcf8ac6$var$DefaultStore();
}
module.exports = $5eaefbf13bcf8ac6$var$defaultStore;

});

parcelRegister("9y4Co", function(module, exports) {
"use strict";

var $hFmsk = parcelRequire("hFmsk");

var $gbi6A = parcelRequire("gbi6A");
function $6f3adf1e0f14eebf$var$getFileType(file) {
    var _getFileNameAndExtens;
    if (file.type) return file.type;
    const fileExtension = file.name ? (_getFileNameAndExtens = $hFmsk(file.name).extension) == null ? void 0 : _getFileNameAndExtens.toLowerCase() : null;
    if (fileExtension && fileExtension in $gbi6A) // else, see if we can map extension to a mime type
    return $gbi6A[fileExtension];
     // if all fails, fall back to a generic byte stream type
    return "application/octet-stream";
}
module.exports = $6f3adf1e0f14eebf$var$getFileType;

});
parcelRegister("hFmsk", function(module, exports) {
"use strict";
function $cdc7af4406f5ae46$var$getFileNameAndExtension(fullFileName) {
    const lastDot = fullFileName.lastIndexOf("."); // these count as no extension: "no-dot", "trailing-dot."
    if (lastDot === -1 || lastDot === fullFileName.length - 1) return {
        name: fullFileName,
        extension: undefined
    };
    return {
        name: fullFileName.slice(0, lastDot),
        extension: fullFileName.slice(lastDot + 1)
    };
}
/**
 * Takes a full filename string and returns an object {name, extension}
 *
 * @param {string} fullFileName
 * @returns {object} {name, extension}
 */ module.exports = $cdc7af4406f5ae46$var$getFileNameAndExtension;

});

parcelRegister("gbi6A", function(module, exports) {
"use strict";
// ___Why not add the mime-types package?
//    It's 19.7kB gzipped, and we only need mime types for well-known extensions (for file previews).
// ___Where to take new extensions from?
//    https://github.com/jshttp/mime-db/blob/master/db.json
module.exports = {
    md: "text/markdown",
    markdown: "text/markdown",
    mp4: "video/mp4",
    mp3: "audio/mp3",
    svg: "image/svg+xml",
    jpg: "image/jpeg",
    png: "image/png",
    gif: "image/gif",
    heic: "image/heic",
    heif: "image/heif",
    yaml: "text/yaml",
    yml: "text/yaml",
    csv: "text/csv",
    tsv: "text/tab-separated-values",
    tab: "text/tab-separated-values",
    avi: "video/x-msvideo",
    mks: "video/x-matroska",
    mkv: "video/x-matroska",
    mov: "video/quicktime",
    dicom: "application/dicom",
    doc: "application/msword",
    docm: "application/vnd.ms-word.document.macroenabled.12",
    docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    dot: "application/msword",
    dotm: "application/vnd.ms-word.template.macroenabled.12",
    dotx: "application/vnd.openxmlformats-officedocument.wordprocessingml.template",
    xla: "application/vnd.ms-excel",
    xlam: "application/vnd.ms-excel.addin.macroenabled.12",
    xlc: "application/vnd.ms-excel",
    xlf: "application/x-xliff+xml",
    xlm: "application/vnd.ms-excel",
    xls: "application/vnd.ms-excel",
    xlsb: "application/vnd.ms-excel.sheet.binary.macroenabled.12",
    xlsm: "application/vnd.ms-excel.sheet.macroenabled.12",
    xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    xlt: "application/vnd.ms-excel",
    xltm: "application/vnd.ms-excel.template.macroenabled.12",
    xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template",
    xlw: "application/vnd.ms-excel",
    txt: "text/plain",
    text: "text/plain",
    conf: "text/plain",
    log: "text/plain",
    pdf: "application/pdf",
    zip: "application/zip",
    "7z": "application/x-7z-compressed",
    rar: "application/x-rar-compressed",
    tar: "application/x-tar",
    gz: "application/gzip",
    dmg: "application/x-apple-diskimage"
};

});


parcelRegister("2tdJv", function(module, exports) {
"use strict";
function $1cc8f1472ef13e12$var$encodeCharacter(character) {
    return character.charCodeAt(0).toString(32);
}
function $1cc8f1472ef13e12$var$encodeFilename(name) {
    let suffix = "";
    return name.replace(/[^A-Z0-9]/ig, (character)=>{
        suffix += `-${$1cc8f1472ef13e12$var$encodeCharacter(character)}`;
        return "/";
    }) + suffix;
}
/**
 * Takes a file object and turns it into fileID, by converting file.name to lowercase,
 * removing extra characters and adding type, size and lastModified
 *
 * @param {object} file
 * @returns {string} the fileID
 */ function $1cc8f1472ef13e12$var$generateFileID(file) {
    // It's tempting to do `[items].filter(Boolean).join('-')` here, but that
    // is slower! simple string concatenation is fast
    let id = "uppy";
    if (typeof file.name === "string") id += `-${$1cc8f1472ef13e12$var$encodeFilename(file.name.toLowerCase())}`;
    if (file.type !== undefined) id += `-${file.type}`;
    if (file.meta && typeof file.meta.relativePath === "string") id += `-${$1cc8f1472ef13e12$var$encodeFilename(file.meta.relativePath.toLowerCase())}`;
    if (file.data.size !== undefined) id += `-${file.data.size}`;
    if (file.data.lastModified !== undefined) id += `-${file.data.lastModified}`;
    return id;
}
module.exports = $1cc8f1472ef13e12$var$generateFileID;

});

parcelRegister("3omH9", function(module, exports) {
"use strict";
function $278537c000adb5e2$var$supportsUploadProgress(userAgent) {
    // Allow passing in userAgent for tests
    if (userAgent == null && typeof navigator !== "undefined") // eslint-disable-next-line no-param-reassign
    userAgent = navigator.userAgent;
     // Assume it works because basically everything supports progress events.
    if (!userAgent) return true;
    const m = /Edge\/(\d+\.\d+)/.exec(userAgent);
    if (!m) return true;
    const edgeVersion = m[1];
    let [major, minor] = edgeVersion.split(".");
    major = parseInt(major, 10);
    minor = parseInt(minor, 10); // Worked before:
    // Edge 40.15063.0.0
    // Microsoft EdgeHTML 15.15063
    if (major < 15 || major === 15 && minor < 15063) return true;
     // Fixed in:
    // Microsoft EdgeHTML 18.18218
    if (major > 18 || major === 18 && minor >= 18218) return true;
     // other versions don't work.
    return false;
}
// Edge 15.x does not fire 'progress' events on uploads.
// See https://github.com/transloadit/uppy/issues/945
// And https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/12224510/
module.exports = $278537c000adb5e2$var$supportsUploadProgress;

});

parcelRegister("lPSpS", function(module, exports) {
"use strict";
function $fe589255d76873d0$var$getFileName(fileType, fileDescriptor) {
    if (fileDescriptor.name) return fileDescriptor.name;
    if (fileType.split("/")[0] === "image") return `${fileType.split("/")[0]}.${fileType.split("/")[1]}`;
    return "noname";
}
module.exports = $fe589255d76873d0$var$getFileName;

});

parcelRegister("eTcBD", function(module, exports) {
"use strict";
module.exports = {
    strings: {
        addBulkFilesFailed: {
            0: "Failed to add %{smart_count} file due to an internal error",
            1: "Failed to add %{smart_count} files due to internal errors"
        },
        youCanOnlyUploadX: {
            0: "You can only upload %{smart_count} file",
            1: "You can only upload %{smart_count} files"
        },
        youHaveToAtLeastSelectX: {
            0: "You have to select at least %{smart_count} file",
            1: "You have to select at least %{smart_count} files"
        },
        exceedsSize: "%{file} exceeds maximum allowed size of %{size}",
        missingRequiredMetaField: "Missing required meta fields",
        missingRequiredMetaFieldOnFile: "Missing required meta fields in %{fileName}",
        inferiorSize: "This file is smaller than the allowed size of %{size}",
        youCanOnlyUploadFileTypes: "You can only upload: %{types}",
        noMoreFilesAllowed: "Cannot add more files",
        noDuplicates: "Cannot add the duplicate file '%{fileName}', it already exists",
        companionError: "Connection with Companion failed",
        authAborted: "Authentication aborted",
        companionUnauthorizeHint: "To unauthorize to your %{provider} account, please go to %{url}",
        failedToUpload: "Failed to upload %{file}",
        noInternetConnection: "No Internet connection",
        connectedToInternet: "Connected to the Internet",
        // Strings for remote providers
        noFilesFound: "You have no files or folders here",
        selectX: {
            0: "Select %{smart_count}",
            1: "Select %{smart_count}"
        },
        allFilesFromFolderNamed: "All files from folder %{name}",
        openFolderNamed: "Open folder %{name}",
        cancel: "Cancel",
        logOut: "Log out",
        filter: "Filter",
        resetFilter: "Reset filter",
        loading: "Loading...",
        authenticateWithTitle: "Please authenticate with %{pluginName} to select files",
        authenticateWith: "Connect to %{pluginName}",
        signInWithGoogle: "Sign in with Google",
        searchImages: "Search for images",
        enterTextToSearch: "Enter text to search for images",
        search: "Search",
        emptyFolderAdded: "No files were added from empty folder",
        folderAlreadyAdded: 'The folder "%{folder}" was already added',
        folderAdded: {
            0: "Added %{smart_count} file from %{folder}",
            1: "Added %{smart_count} files from %{folder}"
        }
    }
};

});


parcelRegister("ixbbp", function(module, exports) {
"use strict";

var $1Hdcz = parcelRequire("1Hdcz");
function $d7e3fbc920743e27$var$_classPrivateFieldLooseBase(receiver, privateKey) {
    if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) throw new TypeError("attempted to use private field on non-instance");
    return receiver;
}
var $d7e3fbc920743e27$var$id = 0;
function $d7e3fbc920743e27$var$_classPrivateFieldLooseKey(name) {
    return "__private_" + $d7e3fbc920743e27$var$id++ + "_" + name;
}

var $hWbGx = parcelRequire("hWbGx");

var $huGmp = parcelRequire("huGmp");

var $7Vc9T = parcelRequire("7Vc9T");
/**
 * Defer a frequent call to the microtask queue.
 *
 * @param {() => T} fn
 * @returns {Promise<T>}
 */ function $d7e3fbc920743e27$var$debounce(fn) {
    let calling = null;
    let latestArgs = null;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        latestArgs = args;
        if (!calling) calling = Promise.resolve().then(()=>{
            calling = null; // At this point `args` may be different from the most
            // recent state, if multiple calls happened since this task
            // was queued. So we use the `latestArgs`, which definitely
            // is the most recent call.
            return fn(...latestArgs);
        });
        return calling;
    };
}
/**
 * UIPlugin is the extended version of BasePlugin to incorporate rendering with Preact.
 * Use this for plugins that need a user interface.
 *
 * For plugins without an user interface, see BasePlugin.
 */ var $d7e3fbc920743e27$var$_updateUI = /*#__PURE__*/ $d7e3fbc920743e27$var$_classPrivateFieldLooseKey("updateUI");
class $d7e3fbc920743e27$var$UIPlugin extends $7Vc9T {
    constructor(){
        super(...arguments);
        Object.defineProperty(this, $d7e3fbc920743e27$var$_updateUI, {
            writable: true,
            value: void 0
        });
    }
    /**
   * Check if supplied `target` is a DOM element or an `object`.
   * If it’s an object — target is a plugin, and we search `plugins`
   * for a plugin with same name and return its target.
   */ mount(target, plugin) {
        const callerPluginName = plugin.id;
        const targetElement = $hWbGx(target);
        if (targetElement) {
            this.isTargetDOMEl = true; // When target is <body> with a single <div> element,
            // Preact thinks it’s the Uppy root element in there when doing a diff,
            // and destroys it. So we are creating a fragment (could be empty div)
            const uppyRootElement = document.createElement("div");
            uppyRootElement.classList.add("uppy-Root"); // API for plugins that require a synchronous rerender.
            $d7e3fbc920743e27$var$_classPrivateFieldLooseBase(this, $d7e3fbc920743e27$var$_updateUI)[$d7e3fbc920743e27$var$_updateUI] = $d7e3fbc920743e27$var$debounce((state)=>{
                // plugin could be removed, but this.rerender is debounced below,
                // so it could still be called even after uppy.removePlugin or uppy.close
                // hence the check
                if (!this.uppy.getPlugin(this.id)) return;
                (0, $1Hdcz.render)(this.render(state), uppyRootElement);
                this.afterUpdate();
            });
            this.uppy.log(`Installing ${callerPluginName} to a DOM element '${target}'`);
            if (this.opts.replaceTargetContent) // Doing render(h(null), targetElement), which should have been
            // a better way, since because the component might need to do additional cleanup when it is removed,
            // stopped working — Preact just adds null into target, not replacing
            targetElement.innerHTML = "";
            (0, $1Hdcz.render)(this.render(this.uppy.getState()), uppyRootElement);
            this.el = uppyRootElement;
            targetElement.appendChild(uppyRootElement); // Set the text direction if the page has not defined one.
            uppyRootElement.dir = this.opts.direction || $huGmp(uppyRootElement) || "ltr";
            this.onMount();
            return this.el;
        }
        let targetPlugin;
        if (typeof target === "object" && target instanceof $d7e3fbc920743e27$var$UIPlugin) // Targeting a plugin *instance*
        targetPlugin = target;
        else if (typeof target === "function") {
            // Targeting a plugin type
            const Target = target; // Find the target plugin instance.
            this.uppy.iteratePlugins((p)=>{
                if (p instanceof Target) targetPlugin = p;
            });
        }
        if (targetPlugin) {
            this.uppy.log(`Installing ${callerPluginName} to ${targetPlugin.id}`);
            this.parent = targetPlugin;
            this.el = targetPlugin.addTarget(plugin);
            this.onMount();
            return this.el;
        }
        this.uppy.log(`Not installing ${callerPluginName}`);
        let message = `Invalid target option given to ${callerPluginName}.`;
        if (typeof target === "function") message += " The given target is not a Plugin class. Please check that you're not specifying a React Component instead of a plugin. If you are using @uppy/* packages directly, make sure you have only 1 version of @uppy/core installed: run `npm ls @uppy/core` on the command line and verify that all the versions match and are deduped correctly.";
        else message += "If you meant to target an HTML element, please make sure that the element exists. Check that the <script> tag initializing Uppy is right before the closing </body> tag at the end of the page. (see https://github.com/transloadit/uppy/issues/1042)\n\nIf you meant to target a plugin, please confirm that your `import` statements or `require` calls are correct.";
        throw new Error(message);
    }
    update(state) {
        if (this.el != null) {
            var _classPrivateFieldLoo, _classPrivateFieldLoo2;
            (_classPrivateFieldLoo = (_classPrivateFieldLoo2 = $d7e3fbc920743e27$var$_classPrivateFieldLooseBase(this, $d7e3fbc920743e27$var$_updateUI))[$d7e3fbc920743e27$var$_updateUI]) == null || _classPrivateFieldLoo.call(_classPrivateFieldLoo2, state);
        }
    }
    unmount() {
        if (this.isTargetDOMEl) {
            var _this$el;
            (_this$el = this.el) == null || _this$el.remove();
        }
        this.onUnmount();
    }
    onMount() {}
    onUnmount() {}
}
module.exports = $d7e3fbc920743e27$var$UIPlugin;

});
parcelRegister("hWbGx", function(module, exports) {
"use strict";

var $i5Yzy = parcelRequire("i5Yzy");
/**
 * Find a DOM element.
 *
 * @param {Node|string} element
 * @returns {Node|null}
 */ function $d0f0ead7b84f99e4$var$findDOMElement(element, context) {
    if (context === void 0) context = document;
    if (typeof element === "string") return context.querySelector(element);
    if ($i5Yzy(element)) return element;
    return null;
}
module.exports = $d0f0ead7b84f99e4$var$findDOMElement;

});
parcelRegister("i5Yzy", function(module, exports) {
"use strict";
function $d2c7ae0b8a3c41ed$var$isDOMElement(obj) {
    return (obj == null ? void 0 : obj.nodeType) === Node.ELEMENT_NODE;
}
/**
 * Check if an object is a DOM element. Duck-typing based on `nodeType`.
 *
 * @param {*} obj
 */ module.exports = $d2c7ae0b8a3c41ed$var$isDOMElement;

});


parcelRegister("huGmp", function(module, exports) {
"use strict";
/**
 * Get the declared text direction for an element.
 *
 * @param {Node} element
 * @returns {string|undefined}
 */ function $cbc618eb3e4ce5ac$var$getTextDirection(element) {
    var _element;
    // There is another way to determine text direction using getComputedStyle(), as done here:
    // https://github.com/pencil-js/text-direction/blob/2a235ce95089b3185acec3b51313cbba921b3811/text-direction.js
    //
    // We do not use that approach because we are interested specifically in the _declared_ text direction.
    // If no text direction is declared, we have to provide our own explicit text direction so our
    // bidirectional CSS style sheets work.
    while(element && !element.dir)// eslint-disable-next-line no-param-reassign
    element = element.parentNode;
    return (_element = element) == null ? void 0 : _element.dir;
}
module.exports = $cbc618eb3e4ce5ac$var$getTextDirection;

});

parcelRegister("7Vc9T", function(module, exports) {
"use strict";

var $38UkU = parcelRequire("38UkU");
class $5c4749b328552743$var$BasePlugin {
    constructor(uppy, opts){
        if (opts === void 0) opts = {};
        this.uppy = uppy;
        this.opts = opts;
    }
    getPluginState() {
        const { plugins: plugins } = this.uppy.getState();
        return plugins[this.id] || {};
    }
    setPluginState(update) {
        const { plugins: plugins } = this.uppy.getState();
        this.uppy.setState({
            plugins: {
                ...plugins,
                [this.id]: {
                    ...plugins[this.id],
                    ...update
                }
            }
        });
    }
    setOptions(newOpts) {
        this.opts = {
            ...this.opts,
            ...newOpts
        };
        this.setPluginState(); // so that UI re-renders with new options
        this.i18nInit();
    }
    i18nInit() {
        const translator = new $38UkU([
            this.defaultLocale,
            this.uppy.locale,
            this.opts.locale
        ]);
        this.i18n = translator.translate.bind(translator);
        this.i18nArray = translator.translateArray.bind(translator);
        this.setPluginState(); // so that UI re-renders and we see the updated locale
    }
    /**
   * Extendable methods
   * ==================
   * These methods are here to serve as an overview of the extendable methods as well as
   * making them not conditional in use, such as `if (this.afterUpdate)`.
   */ // eslint-disable-next-line class-methods-use-this
    addTarget() {
        throw new Error("Extend the addTarget method to add your plugin to another plugin's target");
    }
    install() {}
    uninstall() {}
    /**
   * Called when plugin is mounted, whether in DOM or into another plugin.
   * Needed because sometimes plugins are mounted separately/after `install`,
   * so this.el and this.parent might not be available in `install`.
   * This is the case with @uppy/react plugins, for example.
   */ render() {
        throw new Error("Extend the render method to add your plugin to a DOM element");
    }
    // try to use plugins with other frameworks.
    // eslint-disable-next-line class-methods-use-this
    update() {}
    // eslint-disable-next-line class-methods-use-this
    afterUpdate() {}
}
module.exports = $5c4749b328552743$var$BasePlugin;

});



parcelRegister("iRXC6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.forInline = $dbcb6b40a05d665f$var$forInline;
module.exports.forModal = $dbcb6b40a05d665f$var$trapFocus;

var $bs0mo = parcelRequire("bs0mo");

var $jLt6s = parcelRequire("jLt6s");

var $evFQ6 = parcelRequire("evFQ6");
function $dbcb6b40a05d665f$var$focusOnFirstNode(event, nodes) {
    const node = nodes[0];
    if (node) {
        node.focus();
        event.preventDefault();
    }
}
function $dbcb6b40a05d665f$var$focusOnLastNode(event, nodes) {
    const node = nodes[nodes.length - 1];
    if (node) {
        node.focus();
        event.preventDefault();
    }
} // ___Why not just use (focusedItemIndex === -1)?
//    Firefox thinks <ul> is focusable, but we don't have <ul>s in our FOCUSABLE_ELEMENTS. Which means that if we tab into
//    the <ul>, code will think that we are not in the active overlay, and we should focusOnFirstNode() of the currently
//    active overlay!
//    [Practical check] if we use (focusedItemIndex === -1), instagram provider in firefox will never get focus on its pics
//    in the <ul>.
function $dbcb6b40a05d665f$var$isFocusInOverlay(activeOverlayEl) {
    return activeOverlayEl.contains(document.activeElement);
}
function $dbcb6b40a05d665f$var$trapFocus(event, activeOverlayType, dashboardEl) {
    const activeOverlayEl = $evFQ6(dashboardEl, activeOverlayType);
    const focusableNodes = $bs0mo(activeOverlayEl.querySelectorAll($jLt6s));
    const focusedItemIndex = focusableNodes.indexOf(document.activeElement); // If we pressed tab, and focus is not yet within the current overlay - focus on
    // the first element within the current overlay.
    // This is a safety measure (for when user returns from another tab e.g.), most
    // plugins will try to focus on some important element as it loads.
    if (!$dbcb6b40a05d665f$var$isFocusInOverlay(activeOverlayEl)) $dbcb6b40a05d665f$var$focusOnFirstNode(event, focusableNodes); // If we pressed shift + tab, and we're on the first element of a modal
    else if (event.shiftKey && focusedItemIndex === 0) $dbcb6b40a05d665f$var$focusOnLastNode(event, focusableNodes); // If we pressed tab, and we're on the last element of the modal
    else if (!event.shiftKey && focusedItemIndex === focusableNodes.length - 1) $dbcb6b40a05d665f$var$focusOnFirstNode(event, focusableNodes);
} // Traps focus inside of the currently open overlay (e.g. Dashboard, or e.g. Instagram),
// never lets focus disappear from the modal.
// Traps focus inside of the currently open overlay, unless overlay is null - then let the user tab away.
function $dbcb6b40a05d665f$var$forInline(event, activeOverlayType, dashboardEl) {
    // ___When we're in the bare 'Drop files here, paste, browse or import from' screen
    if (activeOverlayType === null) ;
    else // Trap the focus inside this overlay!
    // User can close the overlay (click 'Done') if they want to travel away from Uppy.
    $dbcb6b40a05d665f$var$trapFocus(event, activeOverlayType, dashboardEl);
}

});
parcelRegister("bs0mo", function(module, exports) {
"use strict";
/**
 * Converts list into array
 */ module.exports = Array.from;

});

parcelRegister("jLt6s", function(module, exports) {
"use strict";
module.exports = [
    'a[href]:not([tabindex^="-"]):not([inert]):not([aria-hidden])',
    'area[href]:not([tabindex^="-"]):not([inert]):not([aria-hidden])',
    "input:not([disabled]):not([inert]):not([aria-hidden])",
    "select:not([disabled]):not([inert]):not([aria-hidden])",
    "textarea:not([disabled]):not([inert]):not([aria-hidden])",
    "button:not([disabled]):not([inert]):not([aria-hidden])",
    'iframe:not([tabindex^="-"]):not([inert]):not([aria-hidden])',
    'object:not([tabindex^="-"]):not([inert]):not([aria-hidden])',
    'embed:not([tabindex^="-"]):not([inert]):not([aria-hidden])',
    '[contenteditable]:not([tabindex^="-"]):not([inert]):not([aria-hidden])',
    '[tabindex]:not([tabindex^="-"]):not([inert]):not([aria-hidden])'
];

});

parcelRegister("evFQ6", function(module, exports) {
"use strict";
function $a9046a61579e86ba$var$getActiveOverlayEl(dashboardEl, activeOverlayType) {
    if (activeOverlayType) {
        const overlayEl = dashboardEl.querySelector(`[data-uppy-paneltype="${activeOverlayType}"]`); // if an overlay is already mounted
        if (overlayEl) return overlayEl;
    }
    return dashboardEl;
}
/**
 * @returns {HTMLElement} - either dashboard element, or the overlay that's most on top
 */ module.exports = $a9046a61579e86ba$var$getActiveOverlayEl;

});


parcelRegister("bnV4R", function(module, exports) {
"use strict";

module.exports = (parcelRequire("hAiVP"));

});
parcelRegister("hAiVP", function(module, exports) {
"use strict";

var $8jN3b = parcelRequire("8jN3b");

var $3gWz9 = parcelRequire("3gWz9");

var $j8wKn = parcelRequire("j8wKn");

var $huGmp = parcelRequire("huGmp");

var $jbUSx = parcelRequire("jbUSx");

var $4hBcO = parcelRequire("4hBcO");
const $ccd47beaa6b4dc04$var$packageJson = {
    "version": "2.2.2"
};

var $kA9Pv = parcelRequire("kA9Pv");
function $ccd47beaa6b4dc04$var$getTotalSpeed(files) {
    let totalSpeed = 0;
    files.forEach((file)=>{
        totalSpeed += $3gWz9(file.progress);
    });
    return totalSpeed;
}
function $ccd47beaa6b4dc04$var$getTotalETA(files) {
    const totalSpeed = $ccd47beaa6b4dc04$var$getTotalSpeed(files);
    if (totalSpeed === 0) return 0;
    const totalBytesRemaining = files.reduce((total, file)=>{
        return total + $j8wKn(file.progress);
    }, 0);
    return Math.round(totalBytesRemaining / totalSpeed * 10) / 10;
}
function $ccd47beaa6b4dc04$var$getUploadingState(error, isAllComplete, recoveredState, files) {
    if (error && !isAllComplete) return $jbUSx.STATE_ERROR;
    if (isAllComplete) return $jbUSx.STATE_COMPLETE;
    if (recoveredState) return $jbUSx.STATE_WAITING;
    let state = $jbUSx.STATE_WAITING;
    const fileIDs = Object.keys(files);
    for(let i = 0; i < fileIDs.length; i++){
        const { progress: progress } = files[fileIDs[i]]; // If ANY files are being uploaded right now, show the uploading state.
        if (progress.uploadStarted && !progress.uploadComplete) return $jbUSx.STATE_UPLOADING;
         // If files are being preprocessed AND postprocessed at this time, we show the
        // preprocess state. If any files are being uploaded we show uploading.
        if (progress.preprocess && state !== $jbUSx.STATE_UPLOADING) state = $jbUSx.STATE_PREPROCESSING;
         // If NO files are being preprocessed or uploaded right now, but some files are
        // being postprocessed, show the postprocess state.
        if (progress.postprocess && state !== $jbUSx.STATE_UPLOADING && state !== $jbUSx.STATE_PREPROCESSING) state = $jbUSx.STATE_POSTPROCESSING;
    }
    return state;
}
/**
 * StatusBar: renders a status bar with upload/pause/resume/cancel/retry buttons,
 * progress percentage and time remaining.
 */ class $ccd47beaa6b4dc04$var$StatusBar extends $8jN3b.UIPlugin {
    constructor(uppy, opts){
        super(uppy, opts);
        this.startUpload = ()=>{
            const { recoveredState: recoveredState } = this.uppy.getState();
            if (recoveredState) {
                this.uppy.emit("restore-confirmed");
                return undefined;
            }
            return this.uppy.upload().catch(()=>{});
        };
        this.id = this.opts.id || "StatusBar";
        this.title = "StatusBar";
        this.type = "progressindicator";
        this.defaultLocale = $kA9Pv; // set default options
        const defaultOptions = {
            target: "body",
            hideUploadButton: false,
            hideRetryButton: false,
            hidePauseResumeButton: false,
            hideCancelButton: false,
            showProgressDetails: false,
            hideAfterFinish: true,
            doneButtonHandler: null
        };
        this.opts = {
            ...defaultOptions,
            ...opts
        };
        this.i18nInit();
        this.render = this.render.bind(this);
        this.install = this.install.bind(this);
    }
    render(state) {
        const { capabilities: capabilities, files: files, allowNewUpload: allowNewUpload, totalProgress: totalProgress, error: error, recoveredState: recoveredState } = state;
        const { newFiles: newFiles, startedFiles: startedFiles, completeFiles: completeFiles, inProgressNotPausedFiles: inProgressNotPausedFiles, isUploadStarted: isUploadStarted, isAllComplete: isAllComplete, isAllErrored: isAllErrored, isAllPaused: isAllPaused, isUploadInProgress: isUploadInProgress, isSomeGhost: isSomeGhost } = this.uppy.getObjectOfFilesPerState(); // If some state was recovered, we want to show Upload button/counter
        // for all the files, because in this case it’s not an Upload button,
        // but “Confirm Restore Button”
        const newFilesOrRecovered = recoveredState ? Object.values(files) : newFiles;
        const totalETA = $ccd47beaa6b4dc04$var$getTotalETA(inProgressNotPausedFiles);
        const resumableUploads = !!capabilities.resumableUploads;
        const supportsUploadProgress = capabilities.uploadProgress !== false;
        let totalSize = 0;
        let totalUploadedSize = 0;
        startedFiles.forEach((file)=>{
            totalSize += file.progress.bytesTotal || 0;
            totalUploadedSize += file.progress.bytesUploaded || 0;
        });
        return $4hBcO({
            error: error,
            uploadState: $ccd47beaa6b4dc04$var$getUploadingState(error, isAllComplete, recoveredState, state.files || {}),
            allowNewUpload: allowNewUpload,
            totalProgress: totalProgress,
            totalSize: totalSize,
            totalUploadedSize: totalUploadedSize,
            isAllComplete: false,
            isAllPaused: isAllPaused,
            isAllErrored: isAllErrored,
            isUploadStarted: isUploadStarted,
            isUploadInProgress: isUploadInProgress,
            isSomeGhost: isSomeGhost,
            recoveredState: recoveredState,
            complete: completeFiles.length,
            newFiles: newFilesOrRecovered.length,
            numUploads: startedFiles.length,
            totalETA: totalETA,
            files: files,
            i18n: this.i18n,
            uppy: this.uppy,
            startUpload: this.startUpload,
            doneButtonHandler: this.opts.doneButtonHandler,
            resumableUploads: resumableUploads,
            supportsUploadProgress: supportsUploadProgress,
            showProgressDetails: this.opts.showProgressDetails,
            hideUploadButton: this.opts.hideUploadButton,
            hideRetryButton: this.opts.hideRetryButton,
            hidePauseResumeButton: this.opts.hidePauseResumeButton,
            hideCancelButton: this.opts.hideCancelButton,
            hideAfterFinish: this.opts.hideAfterFinish,
            isTargetDOMEl: this.isTargetDOMEl
        });
    }
    onMount() {
        // Set the text direction if the page has not defined one.
        const element = this.el;
        const direction = $huGmp(element);
        if (!direction) element.dir = "ltr";
    }
    install() {
        const { target: target } = this.opts;
        if (target) this.mount(target, this);
    }
    uninstall() {
        this.unmount();
    }
}
$ccd47beaa6b4dc04$var$StatusBar.VERSION = $ccd47beaa6b4dc04$var$packageJson.version;
module.exports = $ccd47beaa6b4dc04$var$StatusBar;

});
parcelRegister("3gWz9", function(module, exports) {
"use strict";
function $26204bb5f3dcd38f$var$getSpeed(fileProgress) {
    if (!fileProgress.bytesUploaded) return 0;
    const timeElapsed = Date.now() - fileProgress.uploadStarted;
    const uploadSpeed = fileProgress.bytesUploaded / (timeElapsed / 1000);
    return uploadSpeed;
}
module.exports = $26204bb5f3dcd38f$var$getSpeed;

});

parcelRegister("j8wKn", function(module, exports) {
"use strict";
function $dee82a8a11e15076$var$getBytesRemaining(fileProgress) {
    return fileProgress.bytesTotal - fileProgress.bytesUploaded;
}
module.exports = $dee82a8a11e15076$var$getBytesRemaining;

});

parcelRegister("jbUSx", function(module, exports) {
"use strict";
module.exports = {
    STATE_ERROR: "error",
    STATE_WAITING: "waiting",
    STATE_PREPROCESSING: "preprocessing",
    STATE_UPLOADING: "uploading",
    STATE_POSTPROCESSING: "postprocessing",
    STATE_COMPLETE: "complete"
};

});

parcelRegister("4hBcO", function(module, exports) {
"use strict";

var $1Hdcz = parcelRequire("1Hdcz");

var $89z2U = parcelRequire("89z2U");

var $8g1PZ = parcelRequire("8g1PZ");

var $jbUSx = parcelRequire("jbUSx");

var $OHtC8 = parcelRequire("OHtC8");
const { STATE_ERROR: $31e59c33c4e115f4$var$STATE_ERROR, STATE_WAITING: $31e59c33c4e115f4$var$STATE_WAITING, STATE_PREPROCESSING: $31e59c33c4e115f4$var$STATE_PREPROCESSING, STATE_UPLOADING: $31e59c33c4e115f4$var$STATE_UPLOADING, STATE_POSTPROCESSING: $31e59c33c4e115f4$var$STATE_POSTPROCESSING, STATE_COMPLETE: $31e59c33c4e115f4$var$STATE_COMPLETE } = $jbUSx; // TODO: rename the function to StatusBarUI on the next major.
function $31e59c33c4e115f4$var$StatusBar(props) {
    const { newFiles: newFiles, allowNewUpload: allowNewUpload, isUploadInProgress: isUploadInProgress, isAllPaused: isAllPaused, resumableUploads: resumableUploads, error: error, hideUploadButton: hideUploadButton, hidePauseResumeButton: hidePauseResumeButton, hideCancelButton: hideCancelButton, hideRetryButton: hideRetryButton, recoveredState: recoveredState, uploadState: uploadState, totalProgress: totalProgress, files: files, supportsUploadProgress: supportsUploadProgress, hideAfterFinish: hideAfterFinish, isSomeGhost: isSomeGhost, doneButtonHandler: doneButtonHandler, isUploadStarted: isUploadStarted, i18n: i18n, startUpload: startUpload, uppy: uppy, isAllComplete: isAllComplete, showProgressDetails: showProgressDetails, numUploads: numUploads, complete: complete, totalSize: totalSize, totalETA: totalETA, totalUploadedSize: totalUploadedSize } = props;
    function getProgressValue() {
        switch(uploadState){
            case $31e59c33c4e115f4$var$STATE_POSTPROCESSING:
            case $31e59c33c4e115f4$var$STATE_PREPROCESSING:
                {
                    const progress = $OHtC8(files);
                    if (progress.mode === "determinate") return progress.value * 100;
                    return totalProgress;
                }
            case $31e59c33c4e115f4$var$STATE_ERROR:
                return null;
            case $31e59c33c4e115f4$var$STATE_UPLOADING:
                if (!supportsUploadProgress) return null;
                return totalProgress;
            default:
                return totalProgress;
        }
    }
    function getIsIndeterminate() {
        switch(uploadState){
            case $31e59c33c4e115f4$var$STATE_POSTPROCESSING:
            case $31e59c33c4e115f4$var$STATE_PREPROCESSING:
                {
                    const { mode: mode } = $OHtC8(files);
                    return mode === "indeterminate";
                }
            case $31e59c33c4e115f4$var$STATE_UPLOADING:
                if (!supportsUploadProgress) return true;
                return false;
            default:
                return false;
        }
    }
    function getIsHidden() {
        if (recoveredState) return false;
        switch(uploadState){
            case $31e59c33c4e115f4$var$STATE_WAITING:
                return hideUploadButton || newFiles === 0;
            case $31e59c33c4e115f4$var$STATE_COMPLETE:
                return hideAfterFinish;
            default:
                return false;
        }
    }
    const progressValue = getProgressValue();
    const isHidden = getIsHidden();
    const width = progressValue != null ? progressValue : 100;
    const showUploadBtn = !error && newFiles && !isUploadInProgress && !isAllPaused && allowNewUpload && !hideUploadButton;
    const showCancelBtn = !hideCancelButton && uploadState !== $31e59c33c4e115f4$var$STATE_WAITING && uploadState !== $31e59c33c4e115f4$var$STATE_COMPLETE;
    const showPauseResumeBtn = resumableUploads && !hidePauseResumeButton && uploadState === $31e59c33c4e115f4$var$STATE_UPLOADING;
    const showRetryBtn = error && !isAllComplete && !hideRetryButton;
    const showDoneBtn = doneButtonHandler && uploadState === $31e59c33c4e115f4$var$STATE_COMPLETE;
    const progressClassNames = $8g1PZ("uppy-StatusBar-progress", {
        "is-indeterminate": getIsIndeterminate()
    });
    const statusBarClassNames = $8g1PZ("uppy-StatusBar", `is-${uploadState}`, {
        "has-ghosts": isSomeGhost
    });
    return (0, $1Hdcz.h)("div", {
        className: statusBarClassNames,
        "aria-hidden": isHidden
    }, (0, $1Hdcz.h)("div", {
        className: progressClassNames,
        style: {
            width: `${width}%`
        },
        role: "progressbar",
        "aria-label": `${width}%`,
        "aria-valuetext": `${width}%`,
        "aria-valuemin": "0",
        "aria-valuemax": "100",
        "aria-valuenow": progressValue
    }), (()=>{
        switch(uploadState){
            case $31e59c33c4e115f4$var$STATE_PREPROCESSING:
            case $31e59c33c4e115f4$var$STATE_POSTPROCESSING:
                return (0, $1Hdcz.h)($89z2U.ProgressBarProcessing, {
                    progress: $OHtC8(files)
                });
            case $31e59c33c4e115f4$var$STATE_COMPLETE:
                return (0, $1Hdcz.h)($89z2U.ProgressBarComplete, {
                    i18n: i18n
                });
            case $31e59c33c4e115f4$var$STATE_ERROR:
                return (0, $1Hdcz.h)($89z2U.ProgressBarError, {
                    error: error,
                    i18n: i18n,
                    numUploads: numUploads,
                    complete: complete
                });
            case $31e59c33c4e115f4$var$STATE_UPLOADING:
                return (0, $1Hdcz.h)($89z2U.ProgressBarUploading, {
                    i18n: i18n,
                    supportsUploadProgress: supportsUploadProgress,
                    totalProgress: totalProgress,
                    showProgressDetails: showProgressDetails,
                    isUploadStarted: isUploadStarted,
                    isAllComplete: isAllComplete,
                    isAllPaused: isAllPaused,
                    newFiles: newFiles,
                    numUploads: numUploads,
                    complete: complete,
                    totalUploadedSize: totalUploadedSize,
                    totalSize: totalSize,
                    totalETA: totalETA,
                    startUpload: startUpload
                });
            default:
                return null;
        }
    })(), (0, $1Hdcz.h)("div", {
        className: "uppy-StatusBar-actions"
    }, recoveredState || showUploadBtn ? (0, $1Hdcz.h)($89z2U.UploadBtn, {
        newFiles: newFiles,
        isUploadStarted: isUploadStarted,
        recoveredState: recoveredState,
        i18n: i18n,
        isSomeGhost: isSomeGhost,
        startUpload: startUpload,
        uploadState: uploadState
    }) : null, showRetryBtn ? (0, $1Hdcz.h)($89z2U.RetryBtn, {
        i18n: i18n,
        uppy: uppy
    }) : null, showPauseResumeBtn ? (0, $1Hdcz.h)($89z2U.PauseResumeButton, {
        isAllPaused: isAllPaused,
        i18n: i18n,
        isAllComplete: isAllComplete,
        resumableUploads: resumableUploads,
        uppy: uppy
    }) : null, showCancelBtn ? (0, $1Hdcz.h)($89z2U.CancelBtn, {
        i18n: i18n,
        uppy: uppy
    }) : null, showDoneBtn ? (0, $1Hdcz.h)($89z2U.DoneBtn, {
        i18n: i18n,
        doneButtonHandler: doneButtonHandler
    }) : null));
}
module.exports = $31e59c33c4e115f4$var$StatusBar;

});
parcelRegister("89z2U", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CancelBtn = $5efa5966561f5d57$var$CancelBtn;
module.exports.DoneBtn = $5efa5966561f5d57$var$DoneBtn;
module.exports.LoadingSpinner = $5efa5966561f5d57$var$LoadingSpinner;
module.exports.PauseResumeButton = $5efa5966561f5d57$var$PauseResumeButton;
module.exports.ProgressBarComplete = $5efa5966561f5d57$var$ProgressBarComplete;
module.exports.ProgressBarError = $5efa5966561f5d57$var$ProgressBarError;
module.exports.ProgressBarProcessing = $5efa5966561f5d57$var$ProgressBarProcessing;
module.exports.ProgressBarUploading = $5efa5966561f5d57$var$ProgressBarUploading;
module.exports.ProgressDetails = $5efa5966561f5d57$var$ProgressDetails;
module.exports.RetryBtn = $5efa5966561f5d57$var$RetryBtn;
module.exports.UploadBtn = $5efa5966561f5d57$var$UploadBtn;

var $1Hdcz = parcelRequire("1Hdcz");

var $8g1PZ = parcelRequire("8g1PZ");

var $eMXxl = parcelRequire("eMXxl");

var $bCrvb = parcelRequire("bCrvb");

var $4PpO5 = parcelRequire("4PpO5");

var $jbUSx = parcelRequire("jbUSx");
const $5efa5966561f5d57$var$DOT = `\u00B7`;
const $5efa5966561f5d57$var$renderDot = ()=>` ${$5efa5966561f5d57$var$DOT} `;
function $5efa5966561f5d57$var$UploadBtn(props) {
    const { newFiles: newFiles, isUploadStarted: isUploadStarted, recoveredState: recoveredState, i18n: i18n, uploadState: uploadState, isSomeGhost: isSomeGhost, startUpload: startUpload } = props;
    const uploadBtnClassNames = $8g1PZ("uppy-u-reset", "uppy-c-btn", "uppy-StatusBar-actionBtn", "uppy-StatusBar-actionBtn--upload", {
        "uppy-c-btn-primary": uploadState === $jbUSx.STATE_WAITING
    }, {
        "uppy-StatusBar-actionBtn--disabled": isSomeGhost
    });
    const uploadBtnText = newFiles && isUploadStarted && !recoveredState ? i18n("uploadXNewFiles", {
        smart_count: newFiles
    }) : i18n("uploadXFiles", {
        smart_count: newFiles
    });
    return (0, $1Hdcz.h)("button", {
        type: "button",
        className: uploadBtnClassNames,
        "aria-label": i18n("uploadXFiles", {
            smart_count: newFiles
        }),
        onClick: startUpload,
        disabled: isSomeGhost,
        "data-uppy-super-focusable": true
    }, uploadBtnText);
}
function $5efa5966561f5d57$var$RetryBtn(props) {
    const { i18n: i18n, uppy: uppy } = props;
    return (0, $1Hdcz.h)("button", {
        type: "button",
        className: "uppy-u-reset uppy-c-btn uppy-StatusBar-actionBtn uppy-StatusBar-actionBtn--retry",
        "aria-label": i18n("retryUpload"),
        onClick: ()=>uppy.retryAll(),
        "data-uppy-super-focusable": true
    }, (0, $1Hdcz.h)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "8",
        height: "10",
        viewBox: "0 0 8 10"
    }, (0, $1Hdcz.h)("path", {
        d: "M4 2.408a2.75 2.75 0 1 0 2.75 2.75.626.626 0 0 1 1.25.018v.023a4 4 0 1 1-4-4.041V.25a.25.25 0 0 1 .389-.208l2.299 1.533a.25.25 0 0 1 0 .416l-2.3 1.533A.25.25 0 0 1 4 3.316v-.908z"
    })), i18n("retry"));
}
function $5efa5966561f5d57$var$CancelBtn(props) {
    const { i18n: i18n, uppy: uppy } = props;
    return (0, $1Hdcz.h)("button", {
        type: "button",
        className: "uppy-u-reset uppy-StatusBar-actionCircleBtn",
        title: i18n("cancel"),
        "aria-label": i18n("cancel"),
        onClick: ()=>uppy.cancelAll(),
        "data-cy": "cancel",
        "data-uppy-super-focusable": true
    }, (0, $1Hdcz.h)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16"
    }, (0, $1Hdcz.h)("g", {
        fill: "none",
        fillRule: "evenodd"
    }, (0, $1Hdcz.h)("circle", {
        fill: "#888",
        cx: "8",
        cy: "8",
        r: "8"
    }), (0, $1Hdcz.h)("path", {
        fill: "#FFF",
        d: "M9.283 8l2.567 2.567-1.283 1.283L8 9.283 5.433 11.85 4.15 10.567 6.717 8 4.15 5.433 5.433 4.15 8 6.717l2.567-2.567 1.283 1.283z"
    }))));
}
function $5efa5966561f5d57$var$PauseResumeButton(props) {
    const { isAllPaused: isAllPaused, i18n: i18n, isAllComplete: isAllComplete, resumableUploads: resumableUploads, uppy: uppy } = props;
    const title = isAllPaused ? i18n("resume") : i18n("pause");
    function togglePauseResume() {
        if (isAllComplete) return null;
        if (!resumableUploads) return uppy.cancelAll();
        if (isAllPaused) return uppy.resumeAll();
        return uppy.pauseAll();
    }
    return (0, $1Hdcz.h)("button", {
        title: title,
        "aria-label": title,
        className: "uppy-u-reset uppy-StatusBar-actionCircleBtn",
        type: "button",
        onClick: togglePauseResume,
        "data-uppy-super-focusable": true
    }, (0, $1Hdcz.h)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16"
    }, (0, $1Hdcz.h)("g", {
        fill: "none",
        fillRule: "evenodd"
    }, (0, $1Hdcz.h)("circle", {
        fill: "#888",
        cx: "8",
        cy: "8",
        r: "8"
    }), (0, $1Hdcz.h)("path", {
        fill: "#FFF",
        d: isAllPaused ? "M6 4.25L11.5 8 6 11.75z" : "M5 4.5h2v7H5v-7zm4 0h2v7H9v-7z"
    }))));
}
function $5efa5966561f5d57$var$DoneBtn(props) {
    const { i18n: i18n, doneButtonHandler: doneButtonHandler } = props;
    return (0, $1Hdcz.h)("button", {
        type: "button",
        className: "uppy-u-reset uppy-c-btn uppy-StatusBar-actionBtn uppy-StatusBar-actionBtn--done",
        onClick: doneButtonHandler,
        "data-uppy-super-focusable": true
    }, i18n("done"));
}
function $5efa5966561f5d57$var$LoadingSpinner() {
    return (0, $1Hdcz.h)("svg", {
        className: "uppy-StatusBar-spinner",
        "aria-hidden": "true",
        focusable: "false",
        width: "14",
        height: "14"
    }, (0, $1Hdcz.h)("path", {
        d: "M13.983 6.547c-.12-2.509-1.64-4.893-3.939-5.936-2.48-1.127-5.488-.656-7.556 1.094C.524 3.367-.398 6.048.162 8.562c.556 2.495 2.46 4.52 4.94 5.183 2.932.784 5.61-.602 7.256-3.015-1.493 1.993-3.745 3.309-6.298 2.868-2.514-.434-4.578-2.349-5.153-4.84a6.226 6.226 0 0 1 2.98-6.778C6.34.586 9.74 1.1 11.373 3.493c.407.596.693 1.282.842 1.988.127.598.073 1.197.161 1.794.078.525.543 1.257 1.15.864.525-.341.49-1.05.456-1.592-.007-.15.02.3 0 0",
        fillRule: "evenodd"
    }));
}
function $5efa5966561f5d57$var$ProgressBarProcessing(props) {
    const { progress: progress } = props;
    const { value: value, mode: mode, message: message } = progress;
    const roundedValue = Math.round(value * 100);
    const dot = `\u00B7`;
    return (0, $1Hdcz.h)("div", {
        className: "uppy-StatusBar-content"
    }, (0, $1Hdcz.h)($5efa5966561f5d57$var$LoadingSpinner, null), mode === "determinate" ? `${roundedValue}% ${dot} ` : "", message);
}
function $5efa5966561f5d57$var$ProgressDetails(props) {
    const { numUploads: numUploads, complete: complete, totalUploadedSize: totalUploadedSize, totalSize: totalSize, totalETA: totalETA, i18n: i18n } = props;
    const ifShowFilesUploadedOfTotal = numUploads > 1;
    return (0, $1Hdcz.h)("div", {
        className: "uppy-StatusBar-statusSecondary"
    }, ifShowFilesUploadedOfTotal && i18n("filesUploadedOfTotal", {
        complete: complete,
        smart_count: numUploads
    }), (0, $1Hdcz.h)("span", {
        className: "uppy-StatusBar-additionalInfo"
    }, ifShowFilesUploadedOfTotal && $5efa5966561f5d57$var$renderDot(), i18n("dataUploadedOfTotal", {
        complete: $bCrvb(totalUploadedSize),
        total: $bCrvb(totalSize)
    }), $5efa5966561f5d57$var$renderDot(), i18n("xTimeLeft", {
        time: $4PpO5(totalETA)
    })));
}
function $5efa5966561f5d57$var$FileUploadCount(props) {
    const { i18n: i18n, complete: complete, numUploads: numUploads } = props;
    return (0, $1Hdcz.h)("div", {
        className: "uppy-StatusBar-statusSecondary"
    }, i18n("filesUploadedOfTotal", {
        complete: complete,
        smart_count: numUploads
    }));
}
function $5efa5966561f5d57$var$UploadNewlyAddedFiles(props) {
    const { i18n: i18n, newFiles: newFiles, startUpload: startUpload } = props;
    const uploadBtnClassNames = $8g1PZ("uppy-u-reset", "uppy-c-btn", "uppy-StatusBar-actionBtn", "uppy-StatusBar-actionBtn--uploadNewlyAdded");
    return (0, $1Hdcz.h)("div", {
        className: "uppy-StatusBar-statusSecondary"
    }, (0, $1Hdcz.h)("div", {
        className: "uppy-StatusBar-statusSecondaryHint"
    }, i18n("xMoreFilesAdded", {
        smart_count: newFiles
    })), (0, $1Hdcz.h)("button", {
        type: "button",
        className: uploadBtnClassNames,
        "aria-label": i18n("uploadXFiles", {
            smart_count: newFiles
        }),
        onClick: startUpload
    }, i18n("upload")));
}
const $5efa5966561f5d57$var$ThrottledProgressDetails = $eMXxl($5efa5966561f5d57$var$ProgressDetails, 500, {
    leading: true,
    trailing: true
});
function $5efa5966561f5d57$var$ProgressBarUploading(props) {
    const { i18n: i18n, supportsUploadProgress: supportsUploadProgress, totalProgress: totalProgress, showProgressDetails: showProgressDetails, isUploadStarted: isUploadStarted, isAllComplete: isAllComplete, isAllPaused: isAllPaused, newFiles: newFiles, numUploads: numUploads, complete: complete, totalUploadedSize: totalUploadedSize, totalSize: totalSize, totalETA: totalETA, startUpload: startUpload } = props;
    const showUploadNewlyAddedFiles = newFiles && isUploadStarted;
    if (!isUploadStarted || isAllComplete) return null;
    const title = isAllPaused ? i18n("paused") : i18n("uploading");
    function renderProgressDetails() {
        if (!isAllPaused && !showUploadNewlyAddedFiles && showProgressDetails) {
            if (supportsUploadProgress) return (0, $1Hdcz.h)($5efa5966561f5d57$var$ThrottledProgressDetails, {
                numUploads: numUploads,
                complete: complete,
                totalUploadedSize: totalUploadedSize,
                totalSize: totalSize,
                totalETA: totalETA,
                i18n: i18n
            });
            return (0, $1Hdcz.h)($5efa5966561f5d57$var$FileUploadCount, {
                i18n: i18n,
                complete: complete,
                numUploads: numUploads
            });
        }
        return null;
    }
    return (0, $1Hdcz.h)("div", {
        className: "uppy-StatusBar-content",
        "aria-label": title,
        title: title
    }, !isAllPaused ? (0, $1Hdcz.h)($5efa5966561f5d57$var$LoadingSpinner, null) : null, (0, $1Hdcz.h)("div", {
        className: "uppy-StatusBar-status"
    }, (0, $1Hdcz.h)("div", {
        className: "uppy-StatusBar-statusPrimary"
    }, supportsUploadProgress ? `${title}: ${totalProgress}%` : title), renderProgressDetails(), showUploadNewlyAddedFiles ? (0, $1Hdcz.h)($5efa5966561f5d57$var$UploadNewlyAddedFiles, {
        i18n: i18n,
        newFiles: newFiles,
        startUpload: startUpload
    }) : null));
}
function $5efa5966561f5d57$var$ProgressBarComplete(props) {
    const { i18n: i18n } = props;
    return (0, $1Hdcz.h)("div", {
        className: "uppy-StatusBar-content",
        role: "status",
        title: i18n("complete")
    }, (0, $1Hdcz.h)("div", {
        className: "uppy-StatusBar-status"
    }, (0, $1Hdcz.h)("div", {
        className: "uppy-StatusBar-statusPrimary"
    }, (0, $1Hdcz.h)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-StatusBar-statusIndicator uppy-c-icon",
        width: "15",
        height: "11",
        viewBox: "0 0 15 11"
    }, (0, $1Hdcz.h)("path", {
        d: "M.414 5.843L1.627 4.63l3.472 3.472L13.202 0l1.212 1.213L5.1 10.528z"
    })), i18n("complete"))));
}
function $5efa5966561f5d57$var$ProgressBarError(props) {
    const { error: error, i18n: i18n, complete: complete, numUploads: numUploads } = props;
    function displayErrorAlert() {
        const errorMessage = `${i18n("uploadFailed")} \n\n ${error}`; // eslint-disable-next-line no-alert
        alert(errorMessage); // TODO: move to custom alert implementation
    }
    return (0, $1Hdcz.h)("div", {
        className: "uppy-StatusBar-content",
        title: i18n("uploadFailed")
    }, (0, $1Hdcz.h)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-StatusBar-statusIndicator uppy-c-icon",
        width: "11",
        height: "11",
        viewBox: "0 0 11 11"
    }, (0, $1Hdcz.h)("path", {
        d: "M4.278 5.5L0 1.222 1.222 0 5.5 4.278 9.778 0 11 1.222 6.722 5.5 11 9.778 9.778 11 5.5 6.722 1.222 11 0 9.778z"
    })), (0, $1Hdcz.h)("div", {
        className: "uppy-StatusBar-status"
    }, (0, $1Hdcz.h)("div", {
        className: "uppy-StatusBar-statusPrimary"
    }, i18n("uploadFailed"), (0, $1Hdcz.h)("button", {
        className: "uppy-u-reset uppy-StatusBar-details",
        "aria-label": i18n("showErrorDetails"),
        "data-microtip-position": "top-right",
        "data-microtip-size": "medium",
        onClick: displayErrorAlert,
        type: "button"
    }, "?")), (0, $1Hdcz.h)($5efa5966561f5d57$var$FileUploadCount, {
        i18n: i18n,
        complete: complete,
        numUploads: numUploads
    })));
}

});
parcelRegister("4PpO5", function(module, exports) {
"use strict";

var $cEJHG = parcelRequire("cEJHG");
function $383ff188911036f7$var$prettyETA(seconds) {
    const time = $cEJHG(seconds); // Only display hours and minutes if they are greater than 0 but always
    // display minutes if hours is being displayed
    // Display a leading zero if the there is a preceding unit: 1m 05s, but 5s
    const hoursStr = time.hours === 0 ? "" : `${time.hours}h`;
    const minutesStr = time.minutes === 0 ? "" : `${time.hours === 0 ? time.minutes : ` ${time.minutes.toString(10).padStart(2, "0")}`}m`;
    const secondsStr = time.hours !== 0 ? "" : `${time.minutes === 0 ? time.seconds : ` ${time.seconds.toString(10).padStart(2, "0")}`}s`;
    return `${hoursStr}${minutesStr}${secondsStr}`;
}
module.exports = $383ff188911036f7$var$prettyETA;

});
parcelRegister("cEJHG", function(module, exports) {
"use strict";
function $936cac40d3ead2eb$var$secondsToTime(rawSeconds) {
    const hours = Math.floor(rawSeconds / 3600) % 24;
    const minutes = Math.floor(rawSeconds / 60) % 60;
    const seconds = Math.floor(rawSeconds % 60);
    return {
        hours: hours,
        minutes: minutes,
        seconds: seconds
    };
}
module.exports = $936cac40d3ead2eb$var$secondsToTime;

});



parcelRegister("OHtC8", function(module, exports) {
"use strict";
function $0986652ee5c1212d$var$calculateProcessingProgress(files) {
    const values = [];
    let mode;
    let message;
    for (const { progress: progress } of Object.values(files)){
        const { preprocess: preprocess, postprocess: postprocess } = progress; // In the future we should probably do this differently. For now we'll take the
        // mode and message from the first file…
        if (message == null && (preprocess || postprocess)) ({ mode: mode, message: message } = preprocess || postprocess);
        if ((preprocess == null ? void 0 : preprocess.mode) === "determinate") values.push(preprocess.value);
        if ((postprocess == null ? void 0 : postprocess.mode) === "determinate") values.push(postprocess.value);
    }
    const value = values.reduce((total, progressValue)=>{
        return total + progressValue / values.length;
    }, 0);
    return {
        mode: mode,
        message: message,
        value: value
    };
}
module.exports = $0986652ee5c1212d$var$calculateProcessingProgress;

});


parcelRegister("kA9Pv", function(module, exports) {
"use strict";
module.exports = {
    strings: {
        // Shown in the status bar while files are being uploaded.
        uploading: "Uploading",
        // Shown in the status bar once all files have been uploaded.
        complete: "Complete",
        // Shown in the status bar if an upload failed.
        uploadFailed: "Upload failed",
        // Shown in the status bar while the upload is paused.
        paused: "Paused",
        // Used as the label for the button that retries an upload.
        retry: "Retry",
        // Used as the label for the button that cancels an upload.
        cancel: "Cancel",
        // Used as the label for the button that pauses an upload.
        pause: "Pause",
        // Used as the label for the button that resumes an upload.
        resume: "Resume",
        // Used as the label for the button that resets the upload state after an upload
        done: "Done",
        // When `showProgressDetails` is set, shows the number of files that have been fully uploaded so far.
        filesUploadedOfTotal: {
            0: "%{complete} of %{smart_count} file uploaded",
            1: "%{complete} of %{smart_count} files uploaded"
        },
        // When `showProgressDetails` is set, shows the amount of bytes that have been uploaded so far.
        dataUploadedOfTotal: "%{complete} of %{total}",
        // When `showProgressDetails` is set, shows an estimation of how long the upload will take to complete.
        xTimeLeft: "%{time} left",
        // Used as the label for the button that starts an upload.
        uploadXFiles: {
            0: "Upload %{smart_count} file",
            1: "Upload %{smart_count} files"
        },
        // Used as the label for the button that starts an upload, if another upload has been started in the past
        // and new files were added later.
        uploadXNewFiles: {
            0: "Upload +%{smart_count} file",
            1: "Upload +%{smart_count} files"
        },
        upload: "Upload",
        retryUpload: "Retry upload",
        xMoreFilesAdded: {
            0: "%{smart_count} more file added",
            1: "%{smart_count} more files added"
        },
        showErrorDetails: "Show error details"
    }
};

});



parcelRegister("i7NSv", function(module, exports) {
"use strict";

module.exports = (parcelRequire("aiFPB"));

});
parcelRegister("aiFPB", function(module, exports) {
"use strict";

var $1Hdcz = parcelRequire("1Hdcz");

var $8jN3b = parcelRequire("8jN3b");

var $hbqxg = parcelRequire("hbqxg");

var $hjXIp = parcelRequire("hjXIp");
const $77fc08aaff2b6818$var$packageJson = {
    "version": "2.1.1"
};
/**
 * Informer
 * Shows rad message bubbles
 * used like this: `uppy.info('hello world', 'info', 5000)`
 * or for errors: `uppy.info('Error uploading img.jpg', 'error', 5000)`
 *
 */ class $77fc08aaff2b6818$var$Informer extends $8jN3b.UIPlugin {
    constructor(uppy, opts){
        super(uppy, opts);
        this.render = (state)=>{
            return (0, $1Hdcz.h)("div", {
                className: "uppy uppy-Informer"
            }, (0, $1Hdcz.h)($hjXIp, null, state.info.map((info)=>(0, $1Hdcz.h)($hbqxg, {
                    key: info.message
                }, (0, $1Hdcz.h)("p", {
                    role: "alert"
                }, info.message, " ", info.details && (0, $1Hdcz.h)("span", {
                    "aria-label": info.details,
                    "data-microtip-position": "top-left",
                    "data-microtip-size": "medium",
                    role: "tooltip" // eslint-disable-next-line no-alert
                    ,
                    onClick: ()=>alert(`${info.message} \n\n ${info.details}`)
                }, "?"))))));
        };
        this.type = "progressindicator";
        this.id = this.opts.id || "Informer";
        this.title = "Informer"; // set default options
        const defaultOptions = {}; // merge default options with the ones set by user
        this.opts = {
            ...defaultOptions,
            ...opts
        };
    }
    install() {
        const { target: target } = this.opts;
        if (target) this.mount(target, this);
    }
}
$77fc08aaff2b6818$var$Informer.VERSION = $77fc08aaff2b6818$var$packageJson.version;
module.exports = $77fc08aaff2b6818$var$Informer;

});
parcelRegister("hbqxg", function(module, exports) {
"use strict";

var $1Hdcz = parcelRequire("1Hdcz");
const $c8280c21c4957362$var$TRANSITION_MS = 300;
class $c8280c21c4957362$var$FadeIn extends $1Hdcz.Component {
    constructor(){
        super(...arguments);
        this.ref = (0, $1Hdcz.createRef)();
    }
    componentWillEnter(callback) {
        this.ref.current.style.opacity = "1";
        this.ref.current.style.transform = "none";
        setTimeout(callback, $c8280c21c4957362$var$TRANSITION_MS);
    }
    componentWillLeave(callback) {
        this.ref.current.style.opacity = "0";
        this.ref.current.style.transform = "translateY(350%)";
        setTimeout(callback, $c8280c21c4957362$var$TRANSITION_MS);
    }
    render() {
        const { children: children } = this.props;
        return (0, $1Hdcz.h)("div", {
            className: "uppy-Informer-animated",
            ref: this.ref
        }, children);
    }
}
module.exports = $c8280c21c4957362$var$FadeIn;

});

parcelRegister("hjXIp", function(module, exports) {
"use strict";

var $1Hdcz = parcelRequire("1Hdcz");
/* eslint-disable */ /**
 * @source https://github.com/developit/preact-transition-group
 */ function $c9c288395efa1608$var$assign(obj, props) {
    return Object.assign(obj, props);
}
function $c9c288395efa1608$var$getKey(vnode, fallback) {
    var _vnode$key;
    return (_vnode$key = vnode == null ? void 0 : vnode.key) != null ? _vnode$key : fallback;
}
function $c9c288395efa1608$var$linkRef(component, name) {
    const cache = component._ptgLinkedRefs || (component._ptgLinkedRefs = {});
    return cache[name] || (cache[name] = (c)=>{
        component.refs[name] = c;
    });
}
function $c9c288395efa1608$var$getChildMapping(children) {
    const out = {};
    for(let i = 0; i < children.length; i++)if (children[i] != null) {
        const key = $c9c288395efa1608$var$getKey(children[i], i.toString(36));
        out[key] = children[i];
    }
    return out;
}
function $c9c288395efa1608$var$mergeChildMappings(prev, next) {
    prev = prev || {};
    next = next || {};
    const getValueForKey = (key)=>next.hasOwnProperty(key) ? next[key] : prev[key]; // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    const nextKeysPending = {};
    let pendingKeys = [];
    for(const prevKey in prev){
        if (next.hasOwnProperty(prevKey)) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    const childMapping = {};
    for(const nextKey in next){
        if (nextKeysPending.hasOwnProperty(nextKey)) for(let i = 0; i < nextKeysPending[nextKey].length; i++){
            const pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(let i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
const $c9c288395efa1608$var$identity = (i)=>i;
class $c9c288395efa1608$var$TransitionGroup extends $1Hdcz.Component {
    constructor(props, context){
        super(props, context);
        this.refs = {};
        this.state = {
            children: $c9c288395efa1608$var$getChildMapping((0, $1Hdcz.toChildArray)((0, $1Hdcz.toChildArray)(this.props.children)) || [])
        };
        this.performAppear = this.performAppear.bind(this);
        this.performEnter = this.performEnter.bind(this);
        this.performLeave = this.performLeave.bind(this);
    }
    componentWillMount() {
        this.currentlyTransitioningKeys = {};
        this.keysToAbortLeave = [];
        this.keysToEnter = [];
        this.keysToLeave = [];
    }
    componentDidMount() {
        const initialChildMapping = this.state.children;
        for(const key in initialChildMapping)if (initialChildMapping[key]) // this.performAppear(getKey(initialChildMapping[key], key));
        this.performAppear(key);
    }
    componentWillReceiveProps(nextProps) {
        const nextChildMapping = $c9c288395efa1608$var$getChildMapping((0, $1Hdcz.toChildArray)(nextProps.children) || []);
        const prevChildMapping = this.state.children;
        this.setState((prevState)=>({
                children: $c9c288395efa1608$var$mergeChildMappings(prevState.children, nextChildMapping)
            }));
        let key;
        for(key in nextChildMapping)if (nextChildMapping.hasOwnProperty(key)) {
            const hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key); // We should re-enter the component and abort its leave function
            if (nextChildMapping[key] && hasPrev && this.currentlyTransitioningKeys[key]) {
                this.keysToEnter.push(key);
                this.keysToAbortLeave.push(key);
            } else if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) this.keysToEnter.push(key);
        }
        for(key in prevChildMapping)if (prevChildMapping.hasOwnProperty(key)) {
            const hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(key);
            if (prevChildMapping[key] && !hasNext && !this.currentlyTransitioningKeys[key]) this.keysToLeave.push(key);
        }
    }
    componentDidUpdate() {
        const { keysToEnter: keysToEnter } = this;
        this.keysToEnter = [];
        keysToEnter.forEach(this.performEnter);
        const { keysToLeave: keysToLeave } = this;
        this.keysToLeave = [];
        keysToLeave.forEach(this.performLeave);
    }
    _finishAbort(key) {
        const idx = this.keysToAbortLeave.indexOf(key);
        if (idx !== -1) this.keysToAbortLeave.splice(idx, 1);
    }
    performAppear(key) {
        this.currentlyTransitioningKeys[key] = true;
        const component = this.refs[key];
        if (component.componentWillAppear) component.componentWillAppear(this._handleDoneAppearing.bind(this, key));
        else this._handleDoneAppearing(key);
    }
    _handleDoneAppearing(key) {
        const component = this.refs[key];
        if (component.componentDidAppear) component.componentDidAppear();
        delete this.currentlyTransitioningKeys[key];
        this._finishAbort(key);
        const currentChildMapping = $c9c288395efa1608$var$getChildMapping((0, $1Hdcz.toChildArray)(this.props.children) || []);
        if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) // This was removed before it had fully appeared. Remove it.
        this.performLeave(key);
    }
    performEnter(key) {
        this.currentlyTransitioningKeys[key] = true;
        const component = this.refs[key];
        if (component.componentWillEnter) component.componentWillEnter(this._handleDoneEntering.bind(this, key));
        else this._handleDoneEntering(key);
    }
    _handleDoneEntering(key) {
        const component = this.refs[key];
        if (component.componentDidEnter) component.componentDidEnter();
        delete this.currentlyTransitioningKeys[key];
        this._finishAbort(key);
        const currentChildMapping = $c9c288395efa1608$var$getChildMapping((0, $1Hdcz.toChildArray)(this.props.children) || []);
        if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) // This was removed before it had fully entered. Remove it.
        this.performLeave(key);
    }
    performLeave(key) {
        // If we should immediately abort this leave function,
        // don't run the leave transition at all.
        const idx = this.keysToAbortLeave.indexOf(key);
        if (idx !== -1) return;
        this.currentlyTransitioningKeys[key] = true;
        const component = this.refs[key];
        if (component.componentWillLeave) component.componentWillLeave(this._handleDoneLeaving.bind(this, key));
        else // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        this._handleDoneLeaving(key);
    }
    _handleDoneLeaving(key) {
        // If we should immediately abort the leave,
        // then skip this altogether
        const idx = this.keysToAbortLeave.indexOf(key);
        if (idx !== -1) return;
        const component = this.refs[key];
        if (component.componentDidLeave) component.componentDidLeave();
        delete this.currentlyTransitioningKeys[key];
        const currentChildMapping = $c9c288395efa1608$var$getChildMapping((0, $1Hdcz.toChildArray)(this.props.children) || []);
        if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) // This entered again before it fully left. Add it again.
        this.performEnter(key);
        else {
            const children = $c9c288395efa1608$var$assign({}, this.state.children);
            delete children[key];
            this.setState({
                children: children
            });
        }
    }
    render(_ref, _ref2) {
        let { childFactory: childFactory, transitionLeave: transitionLeave, transitionName: transitionName, transitionAppear: transitionAppear, transitionEnter: transitionEnter, transitionLeaveTimeout: transitionLeaveTimeout, transitionEnterTimeout: transitionEnterTimeout, transitionAppearTimeout: transitionAppearTimeout, component: component, ...props } = _ref;
        let { children: children } = _ref2;
        // TODO: we could get rid of the need for the wrapper node
        // by cloning a single child
        const childrenToRender = [];
        for(const key in children)if (children.hasOwnProperty(key)) {
            const child = children[key];
            if (child) {
                const ref = $c9c288395efa1608$var$linkRef(this, key), el = (0, $1Hdcz.cloneElement)(childFactory(child), {
                    ref: ref,
                    key: key
                });
                childrenToRender.push(el);
            }
        }
        return (0, $1Hdcz.h)(component, props, childrenToRender);
    }
}
$c9c288395efa1608$var$TransitionGroup.defaultProps = {
    component: "span",
    childFactory: $c9c288395efa1608$var$identity
};
module.exports = $c9c288395efa1608$var$TransitionGroup;

});



parcelRegister("kBmkp", function(module, exports) {
"use strict";

var $8jN3b = parcelRequire("8jN3b");

var $cToVP = parcelRequire("cToVP");

var $8n0am = parcelRequire("8n0am");

var $7msde = parcelRequire("7msde");

var $gYMX7 = parcelRequire("gYMX7");

var $koevP = parcelRequire("koevP");
const $eff895489fd9539c$var$packageJson = {
    "version": "2.2.2"
};
/**
 * Save a <canvas> element's content to a Blob object.
 *
 * @param {HTMLCanvasElement} canvas
 * @returns {Promise}
 */ function $eff895489fd9539c$var$canvasToBlob(canvas, type, quality) {
    try {
        canvas.getContext("2d").getImageData(0, 0, 1, 1);
    } catch (err) {
        if (err.code === 18) return Promise.reject(new Error("cannot read image, probably an svg with external resources"));
    }
    if (canvas.toBlob) return new Promise((resolve)=>{
        canvas.toBlob(resolve, type, quality);
    }).then((blob)=>{
        if (blob === null) throw new Error("cannot read image, probably an svg with external resources");
        return blob;
    });
    return Promise.resolve().then(()=>{
        return $8n0am(canvas.toDataURL(type, quality), {});
    }).then((blob)=>{
        if (blob === null) throw new Error("could not extract blob, probably an old browser");
        return blob;
    });
}
function $eff895489fd9539c$var$rotateImage(image, translate) {
    let w = image.width;
    let h = image.height;
    if (translate.deg === 90 || translate.deg === 270) {
        w = image.height;
        h = image.width;
    }
    const canvas = document.createElement("canvas");
    canvas.width = w;
    canvas.height = h;
    const context = canvas.getContext("2d");
    context.translate(w / 2, h / 2);
    if (translate.canvas) {
        context.rotate(translate.rad);
        context.scale(translate.scaleX, translate.scaleY);
    }
    context.drawImage(image, -image.width / 2, -image.height / 2, image.width, image.height);
    return canvas;
}
/**
 * Make sure the image doesn’t exceed browser/device canvas limits.
 * For ios with 256 RAM and ie
 */ function $eff895489fd9539c$var$protect(image) {
    // https://stackoverflow.com/questions/6081483/maximum-size-of-a-canvas-element
    const ratio = image.width / image.height;
    const maxSquare = 5000000; // ios max canvas square
    const maxSize = 4096; // ie max canvas dimensions
    let maxW = Math.floor(Math.sqrt(maxSquare * ratio));
    let maxH = Math.floor(maxSquare / Math.sqrt(maxSquare * ratio));
    if (maxW > maxSize) {
        maxW = maxSize;
        maxH = Math.round(maxW / ratio);
    }
    if (maxH > maxSize) {
        maxH = maxSize;
        maxW = Math.round(ratio * maxH);
    }
    if (image.width > maxW) {
        const canvas = document.createElement("canvas");
        canvas.width = maxW;
        canvas.height = maxH;
        canvas.getContext("2d").drawImage(image, 0, 0, maxW, maxH);
        return canvas;
    }
    return image;
}
/**
 * The Thumbnail Generator plugin
 */ class $eff895489fd9539c$var$ThumbnailGenerator extends $8jN3b.UIPlugin {
    constructor(uppy, opts){
        super(uppy, opts);
        this.onFileAdded = (file)=>{
            if (!file.preview && file.data && $gYMX7(file.type) && !file.isRemote) this.addToQueue(file.id);
        };
        this.onCancelRequest = (file)=>{
            const index = this.queue.indexOf(file.id);
            if (index !== -1) this.queue.splice(index, 1);
        };
        this.onFileRemoved = (file)=>{
            const index = this.queue.indexOf(file.id);
            if (index !== -1) this.queue.splice(index, 1);
             // Clean up object URLs.
            if (file.preview && $7msde(file.preview)) URL.revokeObjectURL(file.preview);
        };
        this.onRestored = ()=>{
            const restoredFiles = this.uppy.getFiles().filter((file)=>file.isRestored);
            restoredFiles.forEach((file)=>{
                // Only add blob URLs; they are likely invalid after being restored.
                if (!file.preview || $7msde(file.preview)) this.addToQueue(file.id);
            });
        };
        this.onAllFilesRemoved = ()=>{
            this.queue = [];
        };
        this.waitUntilAllProcessed = (fileIDs)=>{
            fileIDs.forEach((fileID)=>{
                const file = this.uppy.getFile(fileID);
                this.uppy.emit("preprocess-progress", file, {
                    mode: "indeterminate",
                    message: this.i18n("generatingThumbnails")
                });
            });
            const emitPreprocessCompleteForAll = ()=>{
                fileIDs.forEach((fileID)=>{
                    const file = this.uppy.getFile(fileID);
                    this.uppy.emit("preprocess-complete", file);
                });
            };
            return new Promise((resolve)=>{
                if (this.queueProcessing) this.uppy.once("thumbnail:all-generated", ()=>{
                    emitPreprocessCompleteForAll();
                    resolve();
                });
                else {
                    emitPreprocessCompleteForAll();
                    resolve();
                }
            });
        };
        this.type = "modifier";
        this.id = this.opts.id || "ThumbnailGenerator";
        this.title = "Thumbnail Generator";
        this.queue = [];
        this.queueProcessing = false;
        this.defaultThumbnailDimension = 200;
        this.thumbnailType = this.opts.thumbnailType || "image/jpeg";
        this.defaultLocale = $koevP;
        const defaultOptions = {
            thumbnailWidth: null,
            thumbnailHeight: null,
            waitForThumbnailsBeforeUpload: false,
            lazy: false
        };
        this.opts = {
            ...defaultOptions,
            ...opts
        };
        this.i18nInit();
        if (this.opts.lazy && this.opts.waitForThumbnailsBeforeUpload) throw new Error("ThumbnailGenerator: The `lazy` and `waitForThumbnailsBeforeUpload` options are mutually exclusive. Please ensure at most one of them is set to `true`.");
    }
    /**
   * Create a thumbnail for the given Uppy file object.
   *
   * @param {{data: Blob}} file
   * @param {number} targetWidth
   * @param {number} targetHeight
   * @returns {Promise}
   */ createThumbnail(file, targetWidth, targetHeight) {
        const originalUrl = URL.createObjectURL(file.data);
        const onload = new Promise((resolve, reject)=>{
            const image = new Image();
            image.src = originalUrl;
            image.addEventListener("load", ()=>{
                URL.revokeObjectURL(originalUrl);
                resolve(image);
            });
            image.addEventListener("error", (event)=>{
                URL.revokeObjectURL(originalUrl);
                reject(event.error || new Error("Could not create thumbnail"));
            });
        });
        const orientationPromise = (0, $cToVP.rotation)(file.data).catch(()=>1);
        return Promise.all([
            onload,
            orientationPromise
        ]).then((_ref)=>{
            let [image, orientation] = _ref;
            const dimensions = this.getProportionalDimensions(image, targetWidth, targetHeight, orientation.deg);
            const rotatedImage = this.rotateImage(image, orientation);
            const resizedImage = this.resizeImage(rotatedImage, dimensions.width, dimensions.height);
            return this.canvasToBlob(resizedImage, this.thumbnailType, 80);
        }).then((blob)=>{
            return URL.createObjectURL(blob);
        });
    }
    /**
   * Get the new calculated dimensions for the given image and a target width
   * or height. If both width and height are given, only width is taken into
   * account. If neither width nor height are given, the default dimension
   * is used.
   */ getProportionalDimensions(img, width, height, rotation) {
        // eslint-disable-line no-shadow
        let aspect = img.width / img.height;
        if (rotation === 90 || rotation === 270) aspect = img.height / img.width;
        if (width != null) return {
            width: width,
            height: Math.round(width / aspect)
        };
        if (height != null) return {
            width: Math.round(height * aspect),
            height: height
        };
        return {
            width: this.defaultThumbnailDimension,
            height: Math.round(this.defaultThumbnailDimension / aspect)
        };
    }
    /**
   * Resize an image to the target `width` and `height`.
   *
   * Returns a Canvas with the resized image on it.
   */ resizeImage(image, targetWidth, targetHeight) {
        // Resizing in steps refactored to use a solution from
        // https://blog.uploadcare.com/image-resize-in-browsers-is-broken-e38eed08df01
        let img = this.protect(image);
        let steps = Math.ceil(Math.log2(img.width / targetWidth));
        if (steps < 1) steps = 1;
        let sW = targetWidth * 2 ** (steps - 1);
        let sH = targetHeight * 2 ** (steps - 1);
        const x = 2;
        while(steps--){
            const canvas = document.createElement("canvas");
            canvas.width = sW;
            canvas.height = sH;
            canvas.getContext("2d").drawImage(img, 0, 0, sW, sH);
            img = canvas;
            sW = Math.round(sW / x);
            sH = Math.round(sH / x);
        }
        return img;
    }
    /**
   * Set the preview URL for a file.
   */ setPreviewURL(fileID, preview) {
        this.uppy.setFileState(fileID, {
            preview: preview
        });
    }
    addToQueue(item) {
        this.queue.push(item);
        if (this.queueProcessing === false) this.processQueue();
    }
    processQueue() {
        this.queueProcessing = true;
        if (this.queue.length > 0) {
            const current = this.uppy.getFile(this.queue.shift());
            if (!current) {
                this.uppy.log("[ThumbnailGenerator] file was removed before a thumbnail could be generated, but not removed from the queue. This is probably a bug", "error");
                return Promise.resolve();
            }
            return this.requestThumbnail(current).catch(()=>{}) // eslint-disable-line node/handle-callback-err
            .then(()=>this.processQueue());
        }
        this.queueProcessing = false;
        this.uppy.log("[ThumbnailGenerator] Emptied thumbnail queue");
        this.uppy.emit("thumbnail:all-generated");
        return Promise.resolve();
    }
    requestThumbnail(file) {
        if ($gYMX7(file.type) && !file.isRemote) return this.createThumbnail(file, this.opts.thumbnailWidth, this.opts.thumbnailHeight).then((preview)=>{
            this.setPreviewURL(file.id, preview);
            this.uppy.log(`[ThumbnailGenerator] Generated thumbnail for ${file.id}`);
            this.uppy.emit("thumbnail:generated", this.uppy.getFile(file.id), preview);
        }).catch((err)=>{
            this.uppy.log(`[ThumbnailGenerator] Failed thumbnail for ${file.id}:`, "warning");
            this.uppy.log(err, "warning");
            this.uppy.emit("thumbnail:error", this.uppy.getFile(file.id), err);
        });
        return Promise.resolve();
    }
    install() {
        this.uppy.on("file-removed", this.onFileRemoved);
        this.uppy.on("cancel-all", this.onAllFilesRemoved);
        if (this.opts.lazy) {
            this.uppy.on("thumbnail:request", this.onFileAdded);
            this.uppy.on("thumbnail:cancel", this.onCancelRequest);
        } else {
            this.uppy.on("file-added", this.onFileAdded);
            this.uppy.on("restored", this.onRestored);
        }
        if (this.opts.waitForThumbnailsBeforeUpload) this.uppy.addPreProcessor(this.waitUntilAllProcessed);
    }
    uninstall() {
        this.uppy.off("file-removed", this.onFileRemoved);
        this.uppy.off("cancel-all", this.onAllFilesRemoved);
        if (this.opts.lazy) {
            this.uppy.off("thumbnail:request", this.onFileAdded);
            this.uppy.off("thumbnail:cancel", this.onCancelRequest);
        } else {
            this.uppy.off("file-added", this.onFileAdded);
            this.uppy.off("restored", this.onRestored);
        }
        if (this.opts.waitForThumbnailsBeforeUpload) this.uppy.removePreProcessor(this.waitUntilAllProcessed);
    }
}
$eff895489fd9539c$var$ThumbnailGenerator.VERSION = $eff895489fd9539c$var$packageJson.version;
module.exports = $eff895489fd9539c$var$ThumbnailGenerator; // TODO: remove these methods from the prototype in the next major.
$eff895489fd9539c$var$ThumbnailGenerator.prototype.canvasToBlob = $eff895489fd9539c$var$canvasToBlob;
$eff895489fd9539c$var$ThumbnailGenerator.prototype.protect = $eff895489fd9539c$var$protect;
$eff895489fd9539c$var$ThumbnailGenerator.prototype.rotateImage = $eff895489fd9539c$var$rotateImage;

});
parcelRegister("cToVP", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");

var $6ZWSX = parcelRequire("6ZWSX");
var $962df6010b626e01$require$Buffer = $6ZWSX.Buffer;
!function(e, t) {
    t(module.exports);
}(module.exports, function(e) {
    "use strict";
    function t(e, t, s) {
        return t in e ? Object.defineProperty(e, t, {
            value: s,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = s, e;
    }
    var s = "undefined" != typeof self ? self : $parcel$global;
    const i = "undefined" != typeof navigator, n = i && "undefined" == typeof HTMLImageElement, r = !("undefined" == typeof $parcel$global || "undefined" == typeof $hPtJY || !$hPtJY.versions || !$hPtJY.versions.node), a = s.Buffer, h = !!a, f = (e)=>void 0 !== e;
    function l(e) {
        return void 0 === e || (e instanceof Map ? 0 === e.size : 0 === Object.values(e).filter(f).length);
    }
    function o(e) {
        let t = new Error(e);
        throw delete t.stack, t;
    }
    function u(e) {
        let t = function(e) {
            let t = 0;
            return e.ifd0.enabled && (t += 1024), e.exif.enabled && (t += 2048), e.makerNote && (t += 2048), e.userComment && (t += 1024), e.gps.enabled && (t += 512), e.interop.enabled && (t += 100), e.ifd1.enabled && (t += 1024), t + 2048;
        }(e);
        return e.jfif.enabled && (t += 50), e.xmp.enabled && (t += 2e4), e.iptc.enabled && (t += 14e3), e.icc.enabled && (t += 6e3), t;
    }
    const d = (e)=>String.fromCharCode.apply(null, e), c = "undefined" != typeof TextDecoder ? new TextDecoder("utf-8") : void 0;
    class p {
        static from(e, t) {
            return e instanceof this && e.le === t ? e : new p(e, void 0, void 0, t);
        }
        constructor(e, t = 0, s, i){
            if ("boolean" == typeof i && (this.le = i), Array.isArray(e) && (e = new Uint8Array(e)), 0 === e) this.byteOffset = 0, this.byteLength = 0;
            else if (e instanceof ArrayBuffer) {
                void 0 === s && (s = e.byteLength - t);
                let i = new DataView(e, t, s);
                this._swapDataView(i);
            } else if (e instanceof Uint8Array || e instanceof DataView || e instanceof p) {
                void 0 === s && (s = e.byteLength - t), (t += e.byteOffset) + s > e.byteOffset + e.byteLength && o("Creating view outside of available memory in ArrayBuffer");
                let i = new DataView(e.buffer, t, s);
                this._swapDataView(i);
            } else if ("number" == typeof e) {
                let t = new DataView(new ArrayBuffer(e));
                this._swapDataView(t);
            } else o("Invalid input argument for BufferView: " + e);
        }
        _swapArrayBuffer(e) {
            this._swapDataView(new DataView(e));
        }
        _swapBuffer(e) {
            this._swapDataView(new DataView(e.buffer, e.byteOffset, e.byteLength));
        }
        _swapDataView(e) {
            this.dataView = e, this.buffer = e.buffer, this.byteOffset = e.byteOffset, this.byteLength = e.byteLength;
        }
        _lengthToEnd(e) {
            return this.byteLength - e;
        }
        set(e, t, s = p) {
            return e instanceof DataView || e instanceof p ? e = new Uint8Array(e.buffer, e.byteOffset, e.byteLength) : e instanceof ArrayBuffer && (e = new Uint8Array(e)), e instanceof Uint8Array || o("BufferView.set(): Invalid data argument."), this.toUint8().set(e, t), new s(this, t, e.byteLength);
        }
        subarray(e, t) {
            return t = t || this._lengthToEnd(e), new p(this, e, t);
        }
        toUint8() {
            return new Uint8Array(this.buffer, this.byteOffset, this.byteLength);
        }
        getUint8Array(e, t) {
            return new Uint8Array(this.buffer, this.byteOffset + e, t);
        }
        getString(e = 0, t = this.byteLength) {
            let s = this.getUint8Array(e, t);
            var i;
            return i = s, c ? c.decode(i) : h ? $962df6010b626e01$require$Buffer.from(i).toString("utf8") : decodeURIComponent(escape(d(i)));
        }
        getLatin1String(e = 0, t = this.byteLength) {
            let s = this.getUint8Array(e, t);
            return d(s);
        }
        getUnicodeString(e = 0, t = this.byteLength) {
            const s = [];
            for(let i = 0; i < t && e + i < this.byteLength; i += 2)s.push(this.getUint16(e + i));
            return d(s);
        }
        getInt8(e) {
            return this.dataView.getInt8(e);
        }
        getUint8(e) {
            return this.dataView.getUint8(e);
        }
        getInt16(e, t = this.le) {
            return this.dataView.getInt16(e, t);
        }
        getInt32(e, t = this.le) {
            return this.dataView.getInt32(e, t);
        }
        getUint16(e, t = this.le) {
            return this.dataView.getUint16(e, t);
        }
        getUint32(e, t = this.le) {
            return this.dataView.getUint32(e, t);
        }
        getFloat32(e, t = this.le) {
            return this.dataView.getFloat32(e, t);
        }
        getFloat64(e, t = this.le) {
            return this.dataView.getFloat64(e, t);
        }
        getFloat(e, t = this.le) {
            return this.dataView.getFloat32(e, t);
        }
        getDouble(e, t = this.le) {
            return this.dataView.getFloat64(e, t);
        }
        getUintBytes(e, t, s) {
            switch(t){
                case 1:
                    return this.getUint8(e, s);
                case 2:
                    return this.getUint16(e, s);
                case 4:
                    return this.getUint32(e, s);
                case 8:
                    return this.getUint64 && this.getUint64(e, s);
            }
        }
        getUint(e, t, s) {
            switch(t){
                case 8:
                    return this.getUint8(e, s);
                case 16:
                    return this.getUint16(e, s);
                case 32:
                    return this.getUint32(e, s);
                case 64:
                    return this.getUint64 && this.getUint64(e, s);
            }
        }
        toString(e) {
            return this.dataView.toString(e, this.constructor.name);
        }
        ensureChunk() {}
    }
    function g(e, t) {
        o(`${e} '${t}' was not loaded, try using full build of exifr.`);
    }
    class m extends Map {
        constructor(e){
            super(), this.kind = e;
        }
        get(e, t) {
            return this.has(e) || g(this.kind, e), t && (e in t || function(e, t) {
                o(`Unknown ${e} '${t}'.`);
            }(this.kind, e), t[e].enabled || g(this.kind, e)), super.get(e);
        }
        keyList() {
            return Array.from(this.keys());
        }
    }
    var y = new m("file parser"), b = new m("segment parser"), w = new m("file reader");
    let k = s.fetch;
    const O = "Invalid input argument";
    function v(e, t) {
        var s;
        return (s = e).startsWith("data:") || s.length > 1e4 ? A(e, t, "base64") : r && e.includes("://") ? S(e, t, "url", U) : r ? A(e, t, "fs") : i ? S(e, t, "url", U) : void o(O);
    }
    async function S(e, t, s, i) {
        return w.has(s) ? A(e, t, s) : i ? async function(e, t) {
            let s = await t(e);
            return new p(s);
        }(e, i) : void o(`Parser ${s} is not loaded`);
    }
    async function A(e, t, s) {
        let i = new (w.get(s))(e, t);
        return await i.read(), i;
    }
    const U = (e)=>k(e).then((e)=>e.arrayBuffer()), x = (e)=>new Promise((t, s)=>{
            let i = new FileReader;
            i.onloadend = ()=>t(i.result || new ArrayBuffer), i.onerror = s, i.readAsArrayBuffer(e);
        });
    class C extends Map {
        get tagKeys() {
            return this.allKeys || (this.allKeys = Array.from(this.keys())), this.allKeys;
        }
        get tagValues() {
            return this.allValues || (this.allValues = Array.from(this.values())), this.allValues;
        }
    }
    function B(e, t, s) {
        let i = new C;
        for (let [e, t] of s)i.set(e, t);
        if (Array.isArray(t)) for (let s of t)e.set(s, i);
        else e.set(t, i);
        return i;
    }
    function V(e, t, s) {
        let i, n = e.get(t);
        for (i of s)n.set(i[0], i[1]);
    }
    const I = new Map, L = new Map, T = new Map, P = 37500, z = 37510, F = 33723, j = 34675, E = 34665, _ = 34853, D = 40965, M = [
        "chunked",
        "firstChunkSize",
        "firstChunkSizeNode",
        "firstChunkSizeBrowser",
        "chunkSize",
        "chunkLimit"
    ], N = [
        "jfif",
        "xmp",
        "icc",
        "iptc",
        "ihdr"
    ], R = [
        "tiff",
        ...N
    ], $ = [
        "ifd0",
        "ifd1",
        "exif",
        "gps",
        "interop"
    ], K = [
        ...R,
        ...$
    ], W = [
        "makerNote",
        "userComment"
    ], X = [
        "translateKeys",
        "translateValues",
        "reviveValues",
        "multiSegment"
    ], H = [
        ...X,
        "sanitize",
        "mergeOutput",
        "silentErrors"
    ];
    class Y {
        get translate() {
            return this.translateKeys || this.translateValues || this.reviveValues;
        }
    }
    class G extends Y {
        get needed() {
            return this.enabled || this.deps.size > 0;
        }
        constructor(e, s, i, n){
            if (super(), t(this, "enabled", !1), t(this, "skip", new Set), t(this, "pick", new Set), t(this, "deps", new Set), t(this, "translateKeys", !1), t(this, "translateValues", !1), t(this, "reviveValues", !1), this.key = e, this.enabled = s, this.parse = this.enabled, this.applyInheritables(n), this.canBeFiltered = $.includes(e), this.canBeFiltered && (this.dict = I.get(e)), void 0 !== i) {
                if (Array.isArray(i)) this.parse = this.enabled = !0, this.canBeFiltered && i.length > 0 && this.translateTagSet(i, this.pick);
                else if ("object" == typeof i) {
                    if (this.enabled = !0, this.parse = !1 !== i.parse, this.canBeFiltered) {
                        let { pick: e, skip: t } = i;
                        e && e.length > 0 && this.translateTagSet(e, this.pick), t && t.length > 0 && this.translateTagSet(t, this.skip);
                    }
                    this.applyInheritables(i);
                } else !0 === i || !1 === i ? this.parse = this.enabled = i : o(`Invalid options argument: ${i}`);
            }
        }
        applyInheritables(e) {
            let t, s;
            for (t of X)s = e[t], void 0 !== s && (this[t] = s);
        }
        translateTagSet(e, t) {
            if (this.dict) {
                let s, i, { tagKeys: n, tagValues: r } = this.dict;
                for (s of e)"string" == typeof s ? (i = r.indexOf(s), -1 === i && (i = n.indexOf(Number(s))), -1 !== i && t.add(Number(n[i]))) : t.add(s);
            } else for (let s of e)t.add(s);
        }
        finalizeFilters() {
            !this.enabled && this.deps.size > 0 ? (this.enabled = !0, te(this.pick, this.deps)) : this.enabled && this.pick.size > 0 && te(this.pick, this.deps);
        }
    }
    var J = {
        jfif: !1,
        tiff: !0,
        xmp: !1,
        icc: !1,
        iptc: !1,
        ifd0: !0,
        ifd1: !1,
        exif: !0,
        gps: !0,
        interop: !1,
        ihdr: void 0,
        makerNote: !1,
        userComment: !1,
        multiSegment: !1,
        skip: [],
        pick: [],
        translateKeys: !0,
        translateValues: !0,
        reviveValues: !0,
        sanitize: !0,
        mergeOutput: !0,
        silentErrors: !0,
        chunked: !0,
        firstChunkSize: void 0,
        firstChunkSizeNode: 512,
        firstChunkSizeBrowser: 65536,
        chunkSize: 65536,
        chunkLimit: 5
    }, q = new Map;
    class Q extends Y {
        static useCached(e) {
            let t = q.get(e);
            return void 0 !== t || (t = new this(e), q.set(e, t)), t;
        }
        constructor(e){
            super(), !0 === e ? this.setupFromTrue() : void 0 === e ? this.setupFromUndefined() : Array.isArray(e) ? this.setupFromArray(e) : "object" == typeof e ? this.setupFromObject(e) : o(`Invalid options argument ${e}`), void 0 === this.firstChunkSize && (this.firstChunkSize = i ? this.firstChunkSizeBrowser : this.firstChunkSizeNode), this.mergeOutput && (this.ifd1.enabled = !1), this.filterNestedSegmentTags(), this.traverseTiffDependencyTree(), this.checkLoadedPlugins();
        }
        setupFromUndefined() {
            let e;
            for (e of M)this[e] = J[e];
            for (e of H)this[e] = J[e];
            for (e of W)this[e] = J[e];
            for (e of K)this[e] = new G(e, J[e], void 0, this);
        }
        setupFromTrue() {
            let e;
            for (e of M)this[e] = J[e];
            for (e of H)this[e] = J[e];
            for (e of W)this[e] = !0;
            for (e of K)this[e] = new G(e, !0, void 0, this);
        }
        setupFromArray(e) {
            let t;
            for (t of M)this[t] = J[t];
            for (t of H)this[t] = J[t];
            for (t of W)this[t] = J[t];
            for (t of K)this[t] = new G(t, !1, void 0, this);
            this.setupGlobalFilters(e, void 0, $);
        }
        setupFromObject(e) {
            let t;
            for (t of ($.ifd0 = $.ifd0 || $.image, $.ifd1 = $.ifd1 || $.thumbnail, Object.assign(this, e), M))this[t] = ee(e[t], J[t]);
            for (t of H)this[t] = ee(e[t], J[t]);
            for (t of W)this[t] = ee(e[t], J[t]);
            for (t of R)this[t] = new G(t, J[t], e[t], this);
            for (t of $)this[t] = new G(t, J[t], e[t], this.tiff);
            this.setupGlobalFilters(e.pick, e.skip, $, K), !0 === e.tiff ? this.batchEnableWithBool($, !0) : !1 === e.tiff ? this.batchEnableWithUserValue($, e) : Array.isArray(e.tiff) ? this.setupGlobalFilters(e.tiff, void 0, $) : "object" == typeof e.tiff && this.setupGlobalFilters(e.tiff.pick, e.tiff.skip, $);
        }
        batchEnableWithBool(e, t) {
            for (let s of e)this[s].enabled = t;
        }
        batchEnableWithUserValue(e, t) {
            for (let s of e){
                let e = t[s];
                this[s].enabled = !1 !== e && void 0 !== e;
            }
        }
        setupGlobalFilters(e, t, s, i = s) {
            if (e && e.length) {
                for (let e of i)this[e].enabled = !1;
                let t = Z(e, s);
                for (let [e, s] of t)te(this[e].pick, s), this[e].enabled = !0;
            } else if (t && t.length) {
                let e = Z(t, s);
                for (let [t, s] of e)te(this[t].skip, s);
            }
        }
        filterNestedSegmentTags() {
            let { ifd0: e, exif: t, xmp: s, iptc: i, icc: n } = this;
            this.makerNote ? t.deps.add(P) : t.skip.add(P), this.userComment ? t.deps.add(z) : t.skip.add(z), s.enabled || e.skip.add(700), i.enabled || e.skip.add(F), n.enabled || e.skip.add(j);
        }
        traverseTiffDependencyTree() {
            let { ifd0: e, exif: t, gps: s, interop: i } = this;
            i.needed && (t.deps.add(D), e.deps.add(D)), t.needed && e.deps.add(E), s.needed && e.deps.add(_), this.tiff.enabled = $.some((e)=>!0 === this[e].enabled) || this.makerNote || this.userComment;
            for (let e of $)this[e].finalizeFilters();
        }
        get onlyTiff() {
            return !N.map((e)=>this[e].enabled).some((e)=>!0 === e) && this.tiff.enabled;
        }
        checkLoadedPlugins() {
            for (let e of R)this[e].enabled && !b.has(e) && g("segment parser", e);
        }
    }
    function Z(e, t) {
        let s, i, n, r, a = [];
        for (n of t){
            for (r of (s = I.get(n), i = [], s))(e.includes(r[0]) || e.includes(r[1])) && i.push(r[0]);
            i.length && a.push([
                n,
                i
            ]);
        }
        return a;
    }
    function ee(e, t) {
        return void 0 !== e ? e : void 0 !== t ? t : void 0;
    }
    function te(e, t) {
        for (let s of t)e.add(s);
    }
    t(Q, "default", J);
    class se {
        constructor(e){
            t(this, "parsers", {}), t(this, "output", {}), t(this, "errors", []), t(this, "pushToErrors", (e)=>this.errors.push(e)), this.options = Q.useCached(e);
        }
        async read(e) {
            this.file = await function(e, t) {
                return "string" == typeof e ? v(e, t) : i && !n && e instanceof HTMLImageElement ? v(e.src, t) : e instanceof Uint8Array || e instanceof ArrayBuffer || e instanceof DataView ? new p(e) : i && e instanceof Blob ? S(e, t, "blob", x) : void o(O);
            }(e, this.options);
        }
        setup() {
            if (this.fileParser) return;
            let { file: e } = this, t = e.getUint16(0);
            for (let [s, i] of y)if (i.canHandle(e, t)) return this.fileParser = new i(this.options, this.file, this.parsers), e[s] = !0;
            this.file.close && this.file.close(), o("Unknown file format");
        }
        async parse() {
            let { output: e, errors: t } = this;
            var s;
            return this.setup(), this.options.silentErrors ? (await this.executeParsers().catch(this.pushToErrors), t.push(...this.fileParser.errors)) : await this.executeParsers(), this.file.close && this.file.close(), this.options.silentErrors && t.length > 0 && (e.errors = t), l(s = e) ? void 0 : s;
        }
        async executeParsers() {
            let { output: e } = this;
            await this.fileParser.parse();
            let t = Object.values(this.parsers).map(async (t)=>{
                let s = await t.parse();
                t.assignToOutput(e, s);
            });
            this.options.silentErrors && (t = t.map((e)=>e.catch(this.pushToErrors))), await Promise.all(t);
        }
        async extractThumbnail() {
            this.setup();
            let { options: e, file: t } = this, s = b.get("tiff", e);
            var i;
            if (t.tiff ? i = {
                start: 0,
                type: "tiff"
            } : t.jpeg && (i = await this.fileParser.getOrFindSegment("tiff")), void 0 === i) return;
            let n = await this.fileParser.ensureSegmentChunk(i), r = this.parsers.tiff = new s(n, e, t), a = await r.extractThumbnail();
            return t.close && t.close(), a;
        }
    }
    async function ie(e, t) {
        let s = new se(t);
        return await s.read(e), s.parse();
    }
    var ne = Object.freeze({
        __proto__: null,
        parse: ie,
        Exifr: se,
        fileParsers: y,
        segmentParsers: b,
        fileReaders: w,
        tagKeys: I,
        tagValues: L,
        tagRevivers: T,
        createDictionary: B,
        extendDictionary: V,
        fetchUrlAsArrayBuffer: U,
        readBlobAsArrayBuffer: x,
        chunkedProps: M,
        otherSegments: N,
        segments: R,
        tiffBlocks: $,
        segmentsAndBlocks: K,
        tiffExtractables: W,
        inheritables: X,
        allFormatters: H,
        Options: Q
    });
    class re {
        static findPosition(e, t) {
            let s = e.getUint16(t + 2) + 2, i = "function" == typeof this.headerLength ? this.headerLength(e, t, s) : this.headerLength, n = t + i, r = s - i;
            return {
                offset: t,
                length: s,
                headerLength: i,
                start: n,
                size: r,
                end: n + r
            };
        }
        static parse(e, t = {}) {
            return new this(e, new Q({
                [this.type]: t
            }), e).parse();
        }
        normalizeInput(e) {
            return e instanceof p ? e : new p(e);
        }
        constructor(e, s = {}, i){
            t(this, "errors", []), t(this, "raw", new Map), t(this, "handleError", (e)=>{
                if (!this.options.silentErrors) throw e;
                this.errors.push(e.message);
            }), this.chunk = this.normalizeInput(e), this.file = i, this.type = this.constructor.type, this.globalOptions = this.options = s, this.localOptions = s[this.type], this.canTranslate = this.localOptions && this.localOptions.translate;
        }
        translate() {
            this.canTranslate && (this.translated = this.translateBlock(this.raw, this.type));
        }
        get output() {
            return this.translated ? this.translated : this.raw ? Object.fromEntries(this.raw) : void 0;
        }
        translateBlock(e, t) {
            let s = T.get(t), i = L.get(t), n = I.get(t), r = this.options[t], a = r.reviveValues && !!s, h = r.translateValues && !!i, f = r.translateKeys && !!n, l = {};
            for (let [t, r] of e)a && s.has(t) ? r = s.get(t)(r) : h && i.has(t) && (r = this.translateValue(r, i.get(t))), f && n.has(t) && (t = n.get(t) || t), l[t] = r;
            return l;
        }
        translateValue(e, t) {
            return t[e] || t.DEFAULT || e;
        }
        assignToOutput(e, t) {
            this.assignObjectToOutput(e, this.constructor.type, t);
        }
        assignObjectToOutput(e, t, s) {
            if (this.globalOptions.mergeOutput) return Object.assign(e, s);
            e[t] ? Object.assign(e[t], s) : e[t] = s;
        }
    }
    t(re, "headerLength", 4), t(re, "type", void 0), t(re, "multiSegment", !1), t(re, "canHandle", ()=>!1);
    function ae(e) {
        return 192 === e || 194 === e || 196 === e || 219 === e || 221 === e || 218 === e || 254 === e;
    }
    function he(e) {
        return e >= 224 && e <= 239;
    }
    function fe(e, t, s) {
        for (let [i, n] of b)if (n.canHandle(e, t, s)) return i;
    }
    class le extends class {
        constructor(e, s, i){
            t(this, "errors", []), t(this, "ensureSegmentChunk", async (e)=>{
                let t = e.start, s = e.size || 65536;
                if (this.file.chunked) {
                    if (this.file.available(t, s)) e.chunk = this.file.subarray(t, s);
                    else try {
                        e.chunk = await this.file.readChunk(t, s);
                    } catch (t) {
                        o(`Couldn't read segment: ${JSON.stringify(e)}. ${t.message}`);
                    }
                } else this.file.byteLength > t + s ? e.chunk = this.file.subarray(t, s) : void 0 === e.size ? e.chunk = this.file.subarray(t) : o("Segment unreachable: " + JSON.stringify(e));
                return e.chunk;
            }), this.extendOptions && this.extendOptions(e), this.options = e, this.file = s, this.parsers = i;
        }
        injectSegment(e, t) {
            this.options[e].enabled && this.createParser(e, t);
        }
        createParser(e, t) {
            let s = new (b.get(e))(t, this.options, this.file);
            return this.parsers[e] = s;
        }
        createParsers(e) {
            for (let t of e){
                let { type: e, chunk: s } = t, i = this.options[e];
                if (i && i.enabled) {
                    let t = this.parsers[e];
                    t && t.append || t || this.createParser(e, s);
                }
            }
        }
        async readSegments(e) {
            let t = e.map(this.ensureSegmentChunk);
            await Promise.all(t);
        }
    } {
        constructor(...e){
            super(...e), t(this, "appSegments", []), t(this, "jpegSegments", []), t(this, "unknownSegments", []);
        }
        static canHandle(e, t) {
            return 65496 === t;
        }
        async parse() {
            await this.findAppSegments(), await this.readSegments(this.appSegments), this.mergeMultiSegments(), this.createParsers(this.mergedAppSegments || this.appSegments);
        }
        setupSegmentFinderArgs(e) {
            !0 === e ? (this.findAll = !0, this.wanted = new Set(b.keyList())) : (e = void 0 === e ? b.keyList().filter((e)=>this.options[e].enabled) : e.filter((e)=>this.options[e].enabled && b.has(e)), this.findAll = !1, this.remaining = new Set(e), this.wanted = new Set(e)), this.unfinishedMultiSegment = !1;
        }
        async findAppSegments(e = 0, t) {
            this.setupSegmentFinderArgs(t);
            let { file: s, findAll: i, wanted: n, remaining: r } = this;
            if (!i && this.file.chunked && (i = Array.from(n).some((e)=>{
                let t = b.get(e), s = this.options[e];
                return t.multiSegment && s.multiSegment;
            }), i && await this.file.readWhole()), e = this.findAppSegmentsInRange(e, s.byteLength), !this.options.onlyTiff && s.chunked) {
                let t = !1;
                for(; r.size > 0 && !t && (s.canReadNextChunk || this.unfinishedMultiSegment);){
                    let { nextChunkOffset: i } = s, n = this.appSegments.some((e)=>!this.file.available(e.offset || e.start, e.length || e.size));
                    if (t = e > i && !n ? !await s.readNextChunk(e) : !await s.readNextChunk(i), void 0 === (e = this.findAppSegmentsInRange(e, s.byteLength))) return;
                }
            }
        }
        findAppSegmentsInRange(e, t) {
            t -= 2;
            let s, i, n, r, a, h, { file: f, findAll: l, wanted: o, remaining: u, options: d } = this;
            for(; e < t; e++)if (255 === f.getUint8(e)) {
                if (s = f.getUint8(e + 1), he(s)) {
                    if (i = f.getUint16(e + 2), n = fe(f, e, i), n && o.has(n) && (r = b.get(n), a = r.findPosition(f, e), h = d[n], a.type = n, this.appSegments.push(a), !l && (r.multiSegment && h.multiSegment ? (this.unfinishedMultiSegment = a.chunkNumber < a.chunkCount, this.unfinishedMultiSegment || u.delete(n)) : u.delete(n), 0 === u.size))) break;
                    d.recordUnknownSegments && (a = re.findPosition(f, e), a.marker = s, this.unknownSegments.push(a)), e += i + 1;
                } else if (ae(s)) {
                    if (i = f.getUint16(e + 2), 218 === s && !1 !== d.stopAfterSos) return;
                    d.recordJpegSegments && this.jpegSegments.push({
                        offset: e,
                        length: i,
                        marker: s
                    }), e += i + 1;
                }
            }
            return e;
        }
        mergeMultiSegments() {
            if (!this.appSegments.some((e)=>e.multiSegment)) return;
            let e = function(e, t) {
                let s, i, n, r = new Map;
                for(let a = 0; a < e.length; a++)s = e[a], i = s[t], r.has(i) ? n = r.get(i) : r.set(i, n = []), n.push(s);
                return Array.from(r);
            }(this.appSegments, "type");
            this.mergedAppSegments = e.map(([e, t])=>{
                let s = b.get(e, this.options);
                if (s.handleMultiSegments) return {
                    type: e,
                    chunk: s.handleMultiSegments(t)
                };
                return t[0];
            });
        }
        getSegment(e) {
            return this.appSegments.find((t)=>t.type === e);
        }
        async getOrFindSegment(e) {
            let t = this.getSegment(e);
            return void 0 === t && (await this.findAppSegments(0, [
                e
            ]), t = this.getSegment(e)), t;
        }
    }
    t(le, "type", "jpeg"), y.set("jpeg", le);
    const oe = [
        void 0,
        1,
        1,
        2,
        4,
        8,
        1,
        1,
        2,
        4,
        8,
        4,
        8,
        4
    ];
    class ue extends re {
        parseHeader() {
            var e = this.chunk.getUint16();
            18761 === e ? this.le = !0 : 19789 === e && (this.le = !1), this.chunk.le = this.le, this.headerParsed = !0;
        }
        parseTags(e, t, s = new Map) {
            let { pick: i, skip: n } = this.options[t];
            i = new Set(i);
            let r = i.size > 0, a = 0 === n.size, h = this.chunk.getUint16(e);
            e += 2;
            for(let f = 0; f < h; f++){
                let h = this.chunk.getUint16(e);
                if (r) {
                    if (i.has(h) && (s.set(h, this.parseTag(e, h, t)), i.delete(h), 0 === i.size)) break;
                } else !a && n.has(h) || s.set(h, this.parseTag(e, h, t));
                e += 12;
            }
            return s;
        }
        parseTag(e, t, s) {
            let { chunk: i } = this, n = i.getUint16(e + 2), r = i.getUint32(e + 4), a = oe[n];
            if (a * r <= 4 ? e += 8 : e = i.getUint32(e + 8), (n < 1 || n > 13) && o(`Invalid TIFF value type. block: ${s.toUpperCase()}, tag: ${t.toString(16)}, type: ${n}, offset ${e}`), e > i.byteLength && o(`Invalid TIFF value offset. block: ${s.toUpperCase()}, tag: ${t.toString(16)}, type: ${n}, offset ${e} is outside of chunk size ${i.byteLength}`), 1 === n) return i.getUint8Array(e, r);
            if (2 === n) return "" === (h = (function(e) {
                for(; e.endsWith("\0");)e = e.slice(0, -1);
                return e;
            })(h = i.getString(e, r)).trim()) ? void 0 : h;
            var h;
            if (7 === n) return i.getUint8Array(e, r);
            if (1 === r) return this.parseTagValue(n, e);
            {
                let t = new (function(e) {
                    switch(e){
                        case 1:
                            return Uint8Array;
                        case 3:
                            return Uint16Array;
                        case 4:
                            return Uint32Array;
                        case 5:
                            return Array;
                        case 6:
                            return Int8Array;
                        case 8:
                            return Int16Array;
                        case 9:
                            return Int32Array;
                        case 10:
                            return Array;
                        case 11:
                            return Float32Array;
                        case 12:
                            return Float64Array;
                        default:
                            return Array;
                    }
                }(n))(r), s = a;
                for(let i = 0; i < r; i++)t[i] = this.parseTagValue(n, e), e += s;
                return t;
            }
        }
        parseTagValue(e, t) {
            let { chunk: s } = this;
            switch(e){
                case 1:
                    return s.getUint8(t);
                case 3:
                    return s.getUint16(t);
                case 4:
                    return s.getUint32(t);
                case 5:
                    return s.getUint32(t) / s.getUint32(t + 4);
                case 6:
                    return s.getInt8(t);
                case 8:
                    return s.getInt16(t);
                case 9:
                    return s.getInt32(t);
                case 10:
                    return s.getInt32(t) / s.getInt32(t + 4);
                case 11:
                    return s.getFloat(t);
                case 12:
                    return s.getDouble(t);
                case 13:
                    return s.getUint32(t);
                default:
                    o(`Invalid tiff type ${e}`);
            }
        }
    }
    class de extends ue {
        static canHandle(e, t) {
            return 225 === e.getUint8(t + 1) && 1165519206 === e.getUint32(t + 4) && 0 === e.getUint16(t + 8);
        }
        async parse() {
            this.parseHeader();
            let { options: e } = this;
            return e.ifd0.enabled && await this.parseIfd0Block(), e.exif.enabled && await this.safeParse("parseExifBlock"), e.gps.enabled && await this.safeParse("parseGpsBlock"), e.interop.enabled && await this.safeParse("parseInteropBlock"), e.ifd1.enabled && await this.safeParse("parseThumbnailBlock"), this.createOutput();
        }
        safeParse(e) {
            let t = this[e]();
            return void 0 !== t.catch && (t = t.catch(this.handleError)), t;
        }
        findIfd0Offset() {
            void 0 === this.ifd0Offset && (this.ifd0Offset = this.chunk.getUint32(4));
        }
        findIfd1Offset() {
            if (void 0 === this.ifd1Offset) {
                this.findIfd0Offset();
                let e = this.chunk.getUint16(this.ifd0Offset), t = this.ifd0Offset + 2 + 12 * e;
                this.ifd1Offset = this.chunk.getUint32(t);
            }
        }
        parseBlock(e, t) {
            let s = new Map;
            return this[t] = s, this.parseTags(e, t, s), s;
        }
        async parseIfd0Block() {
            if (this.ifd0) return;
            let { file: e } = this;
            this.findIfd0Offset(), this.ifd0Offset < 8 && o("Malformed EXIF data"), !e.chunked && this.ifd0Offset > e.byteLength && o(`IFD0 offset points to outside of file.\nthis.ifd0Offset: ${this.ifd0Offset}, file.byteLength: ${e.byteLength}`), e.tiff && await e.ensureChunk(this.ifd0Offset, u(this.options));
            let t = this.parseBlock(this.ifd0Offset, "ifd0");
            return 0 !== t.size ? (this.exifOffset = t.get(E), this.interopOffset = t.get(D), this.gpsOffset = t.get(_), this.xmp = t.get(700), this.iptc = t.get(F), this.icc = t.get(j), this.options.sanitize && (t.delete(E), t.delete(D), t.delete(_), t.delete(700), t.delete(F), t.delete(j)), t) : void 0;
        }
        async parseExifBlock() {
            if (this.exif) return;
            if (this.ifd0 || await this.parseIfd0Block(), void 0 === this.exifOffset) return;
            this.file.tiff && await this.file.ensureChunk(this.exifOffset, u(this.options));
            let e = this.parseBlock(this.exifOffset, "exif");
            return this.interopOffset || (this.interopOffset = e.get(D)), this.makerNote = e.get(P), this.userComment = e.get(z), this.options.sanitize && (e.delete(D), e.delete(P), e.delete(z)), this.unpack(e, 41728), this.unpack(e, 41729), e;
        }
        unpack(e, t) {
            let s = e.get(t);
            s && 1 === s.length && e.set(t, s[0]);
        }
        async parseGpsBlock() {
            if (this.gps) return;
            if (this.ifd0 || await this.parseIfd0Block(), void 0 === this.gpsOffset) return;
            let e = this.parseBlock(this.gpsOffset, "gps");
            return e && e.has(2) && e.has(4) && (e.set("latitude", ce(...e.get(2), e.get(1))), e.set("longitude", ce(...e.get(4), e.get(3)))), e;
        }
        async parseInteropBlock() {
            if (!this.interop && (this.ifd0 || await this.parseIfd0Block(), void 0 !== this.interopOffset || this.exif || await this.parseExifBlock(), void 0 !== this.interopOffset)) return this.parseBlock(this.interopOffset, "interop");
        }
        async parseThumbnailBlock(e = !1) {
            if (!this.ifd1 && !this.ifd1Parsed && (!this.options.mergeOutput || e)) return this.findIfd1Offset(), this.ifd1Offset > 0 && (this.parseBlock(this.ifd1Offset, "ifd1"), this.ifd1Parsed = !0), this.ifd1;
        }
        async extractThumbnail() {
            if (this.headerParsed || this.parseHeader(), this.ifd1Parsed || await this.parseThumbnailBlock(!0), void 0 === this.ifd1) return;
            let e = this.ifd1.get(513), t = this.ifd1.get(514);
            return this.chunk.getUint8Array(e, t);
        }
        get image() {
            return this.ifd0;
        }
        get thumbnail() {
            return this.ifd1;
        }
        createOutput() {
            let e, t, s, i = {};
            for (t of $)if (e = this[t], !l(e)) {
                if (s = this.canTranslate ? this.translateBlock(e, t) : Object.fromEntries(e), this.options.mergeOutput) {
                    if ("ifd1" === t) continue;
                    Object.assign(i, s);
                } else i[t] = s;
            }
            return this.makerNote && (i.makerNote = this.makerNote), this.userComment && (i.userComment = this.userComment), i;
        }
        assignToOutput(e, t) {
            if (this.globalOptions.mergeOutput) Object.assign(e, t);
            else for (let [s, i] of Object.entries(t))this.assignObjectToOutput(e, s, i);
        }
    }
    function ce(e, t, s, i) {
        var n = e + t / 60 + s / 3600;
        return "S" !== i && "W" !== i || (n *= -1), n;
    }
    t(de, "type", "tiff"), t(de, "headerLength", 10), b.set("tiff", de);
    var pe = Object.freeze({
        __proto__: null,
        default: ne,
        Exifr: se,
        fileParsers: y,
        segmentParsers: b,
        fileReaders: w,
        tagKeys: I,
        tagValues: L,
        tagRevivers: T,
        createDictionary: B,
        extendDictionary: V,
        fetchUrlAsArrayBuffer: U,
        readBlobAsArrayBuffer: x,
        chunkedProps: M,
        otherSegments: N,
        segments: R,
        tiffBlocks: $,
        segmentsAndBlocks: K,
        tiffExtractables: W,
        inheritables: X,
        allFormatters: H,
        Options: Q,
        parse: ie
    });
    const ge = {
        ifd0: !1,
        ifd1: !1,
        exif: !1,
        gps: !1,
        interop: !1,
        sanitize: !1,
        reviveValues: !0,
        translateKeys: !1,
        translateValues: !1,
        mergeOutput: !1
    }, me = Object.assign({}, ge, {
        firstChunkSize: 4e4,
        gps: [
            1,
            2,
            3,
            4
        ]
    });
    const ye = Object.assign({}, ge, {
        tiff: !1,
        ifd1: !0,
        mergeOutput: !1
    });
    const be = Object.assign({}, ge, {
        firstChunkSize: 4e4,
        ifd0: [
            274
        ]
    });
    async function we(e) {
        let t = new se(be);
        await t.read(e);
        let s = await t.parse();
        if (s && s.ifd0) return s.ifd0[274];
    }
    const ke = Object.freeze({
        1: {
            dimensionSwapped: !1,
            scaleX: 1,
            scaleY: 1,
            deg: 0,
            rad: 0
        },
        2: {
            dimensionSwapped: !1,
            scaleX: -1,
            scaleY: 1,
            deg: 0,
            rad: 0
        },
        3: {
            dimensionSwapped: !1,
            scaleX: 1,
            scaleY: 1,
            deg: 180,
            rad: 180 * Math.PI / 180
        },
        4: {
            dimensionSwapped: !1,
            scaleX: -1,
            scaleY: 1,
            deg: 180,
            rad: 180 * Math.PI / 180
        },
        5: {
            dimensionSwapped: !0,
            scaleX: 1,
            scaleY: -1,
            deg: 90,
            rad: 90 * Math.PI / 180
        },
        6: {
            dimensionSwapped: !0,
            scaleX: 1,
            scaleY: 1,
            deg: 90,
            rad: 90 * Math.PI / 180
        },
        7: {
            dimensionSwapped: !0,
            scaleX: 1,
            scaleY: -1,
            deg: 270,
            rad: 270 * Math.PI / 180
        },
        8: {
            dimensionSwapped: !0,
            scaleX: 1,
            scaleY: 1,
            deg: 270,
            rad: 270 * Math.PI / 180
        }
    });
    if (e.rotateCanvas = !0, e.rotateCss = !0, "object" == typeof navigator) {
        let t = navigator.userAgent;
        if (t.includes("iPad") || t.includes("iPhone")) {
            let s = t.match(/OS (\d+)_(\d+)/);
            if (s) {
                let [, t, i] = s, n = Number(t) + .1 * Number(i);
                e.rotateCanvas = n < 13.4, e.rotateCss = !1;
            }
        } else if (t.includes("OS X 10")) {
            let [, s] = t.match(/OS X 10[_.](\d+)/);
            e.rotateCanvas = e.rotateCss = Number(s) < 15;
        }
        if (t.includes("Chrome/")) {
            let [, s] = t.match(/Chrome\/(\d+)/);
            e.rotateCanvas = e.rotateCss = Number(s) < 81;
        } else if (t.includes("Firefox/")) {
            let [, s] = t.match(/Firefox\/(\d+)/);
            e.rotateCanvas = e.rotateCss = Number(s) < 77;
        }
    }
    class Oe extends p {
        constructor(...e){
            super(...e), t(this, "ranges", new ve), 0 !== this.byteLength && this.ranges.add(0, this.byteLength);
        }
        _tryExtend(e, t, s) {
            if (0 === e && 0 === this.byteLength && s) {
                let e = new DataView(s.buffer || s, s.byteOffset, s.byteLength);
                this._swapDataView(e);
            } else {
                let s = e + t;
                if (s > this.byteLength) {
                    let { dataView: e } = this._extend(s);
                    this._swapDataView(e);
                }
            }
        }
        _extend(e) {
            let t;
            t = h ? a.allocUnsafe(e) : new Uint8Array(e);
            let s = new DataView(t.buffer, t.byteOffset, t.byteLength);
            return t.set(new Uint8Array(this.buffer, this.byteOffset, this.byteLength), 0), {
                uintView: t,
                dataView: s
            };
        }
        subarray(e, t, s = !1) {
            return t = t || this._lengthToEnd(e), s && this._tryExtend(e, t), this.ranges.add(e, t), super.subarray(e, t);
        }
        set(e, t, s = !1) {
            s && this._tryExtend(t, e.byteLength, e);
            let i = super.set(e, t);
            return this.ranges.add(t, i.byteLength), i;
        }
        async ensureChunk(e, t) {
            this.chunked && (this.ranges.available(e, t) || await this.readChunk(e, t));
        }
        available(e, t) {
            return this.ranges.available(e, t);
        }
    }
    class ve {
        constructor(){
            t(this, "list", []);
        }
        get length() {
            return this.list.length;
        }
        add(e, t, s = 0) {
            let i = e + t, n = this.list.filter((t)=>Se(e, t.offset, i) || Se(e, t.end, i));
            if (n.length > 0) {
                e = Math.min(e, ...n.map((e)=>e.offset)), i = Math.max(i, ...n.map((e)=>e.end)), t = i - e;
                let s = n.shift();
                s.offset = e, s.length = t, s.end = i, this.list = this.list.filter((e)=>!n.includes(e));
            } else this.list.push({
                offset: e,
                length: t,
                end: i
            });
        }
        available(e, t) {
            let s = e + t;
            return this.list.some((t)=>t.offset <= e && s <= t.end);
        }
    }
    function Se(e, t, s) {
        return e <= t && t <= s;
    }
    class Ae extends Oe {
        constructor(e, s){
            super(0), t(this, "chunksRead", 0), this.input = e, this.options = s;
        }
        async readWhole() {
            this.chunked = !1, await this.readChunk(this.nextChunkOffset);
        }
        async readChunked() {
            this.chunked = !0, await this.readChunk(0, this.options.firstChunkSize);
        }
        async readNextChunk(e = this.nextChunkOffset) {
            if (this.fullyRead) return this.chunksRead++, !1;
            let t = this.options.chunkSize, s = await this.readChunk(e, t);
            return !!s && s.byteLength === t;
        }
        async readChunk(e, t) {
            if (this.chunksRead++, 0 !== (t = this.safeWrapAddress(e, t))) return this._readChunk(e, t);
        }
        safeWrapAddress(e, t) {
            return void 0 !== this.size && e + t > this.size ? Math.max(0, this.size - e) : t;
        }
        get nextChunkOffset() {
            if (0 !== this.ranges.list.length) return this.ranges.list[0].length;
        }
        get canReadNextChunk() {
            return this.chunksRead < this.options.chunkLimit;
        }
        get fullyRead() {
            return void 0 !== this.size && this.nextChunkOffset === this.size;
        }
        read() {
            return this.options.chunked ? this.readChunked() : this.readWhole();
        }
        close() {}
    }
    w.set("blob", class extends Ae {
        async readWhole() {
            this.chunked = !1;
            let e = await x(this.input);
            this._swapArrayBuffer(e);
        }
        readChunked() {
            return this.chunked = !0, this.size = this.input.size, super.readChunked();
        }
        async _readChunk(e, t) {
            let s = t ? e + t : void 0, i = this.input.slice(e, s), n = await x(i);
            return this.set(n, e, !0);
        }
    }), e.Exifr = se, e.Options = Q, e.allFormatters = H, e.chunkedProps = M, e.createDictionary = B, e.default = pe, e.extendDictionary = V, e.fetchUrlAsArrayBuffer = U, e.fileParsers = y, e.fileReaders = w, e.gps = async function(e) {
        let t = new se(me);
        await t.read(e);
        let s = await t.parse();
        if (s && s.gps) {
            let { latitude: e, longitude: t } = s.gps;
            return {
                latitude: e,
                longitude: t
            };
        }
    }, e.gpsOnlyOptions = me, e.inheritables = X, e.orientation = we, e.orientationOnlyOptions = be, e.otherSegments = N, e.parse = ie, e.readBlobAsArrayBuffer = x, e.rotation = async function(t) {
        let s = await we(t);
        return Object.assign({
            canvas: e.rotateCanvas,
            css: e.rotateCss
        }, ke[s]);
    }, e.rotations = ke, e.segmentParsers = b, e.segments = R, e.segmentsAndBlocks = K, e.tagKeys = I, e.tagRevivers = T, e.tagValues = L, e.thumbnail = async function(e) {
        let t = new se(ye);
        await t.read(e);
        let s = await t.extractThumbnail();
        return s && h ? a.from(s) : s;
    }, e.thumbnailOnlyOptions = ye, e.thumbnailUrl = async function(e) {
        let t = await this.thumbnail(e);
        if (void 0 !== t) {
            let e = new Blob([
                t
            ]);
            return URL.createObjectURL(e);
        }
    }, e.tiffBlocks = $, e.tiffExtractables = W, Object.defineProperty(e, "__esModule", {
        value: !0
    });
});

});

parcelRegister("8n0am", function(module, exports) {
"use strict";
const $618099aebc652071$var$DATA_URL_PATTERN = /^data:([^/]+\/[^,;]+(?:[^,]*?))(;base64)?,([\s\S]*)$/;
function $618099aebc652071$var$dataURItoBlob(dataURI, opts, toFile) {
    var _ref, _opts$mimeType;
    // get the base64 data
    const dataURIData = $618099aebc652071$var$DATA_URL_PATTERN.exec(dataURI); // user may provide mime type, if not get it from data URI
    const mimeType = (_ref = (_opts$mimeType = opts.mimeType) != null ? _opts$mimeType : dataURIData == null ? void 0 : dataURIData[1]) != null ? _ref : "plain/text";
    let data;
    if (dataURIData[2] != null) {
        const binary = atob(decodeURIComponent(dataURIData[3]));
        const bytes = new Uint8Array(binary.length);
        for(let i = 0; i < binary.length; i++)bytes[i] = binary.charCodeAt(i);
        data = [
            bytes
        ];
    } else data = [
        decodeURIComponent(dataURIData[3])
    ];
     // Convert to a File?
    if (toFile) return new File(data, opts.name || "", {
        type: mimeType
    });
    return new Blob(data, {
        type: mimeType
    });
}
module.exports = $618099aebc652071$var$dataURItoBlob;

});

parcelRegister("7msde", function(module, exports) {
"use strict";
function $55c078da96a8922f$var$isObjectURL(url) {
    return url.startsWith("blob:");
}
/**
 * Check if a URL string is an object URL from `URL.createObjectURL`.
 *
 * @param {string} url
 * @returns {boolean}
 */ module.exports = $55c078da96a8922f$var$isObjectURL;

});

parcelRegister("gYMX7", function(module, exports) {
"use strict";
function $c5c838e4d811db84$var$isPreviewSupported(fileType) {
    if (!fileType) return false; // list of images that browsers can preview
    return /^[^/]+\/(jpe?g|gif|png|svg|svg\+xml|bmp|webp|avif)$/.test(fileType);
}
module.exports = $c5c838e4d811db84$var$isPreviewSupported;

});

parcelRegister("koevP", function(module, exports) {
"use strict";
module.exports = {
    strings: {
        generatingThumbnails: "Generating thumbnails..."
    }
};

});


parcelRegister("bbQz1", function(module, exports) {
"use strict";

var $i5Yzy = parcelRequire("i5Yzy");
/**
 * Find one or more DOM elements.
 *
 * @param {string|Node} element
 * @returns {Node[]|null}
 */ function $82597ede3e6a1ffe$var$findAllDOMElements(element) {
    if (typeof element === "string") {
        const elements = document.querySelectorAll(element);
        return elements.length === 0 ? null : Array.from(elements);
    }
    if (typeof element === "object" && $i5Yzy(element)) return [
        element
    ];
    return null;
}
module.exports = $82597ede3e6a1ffe$var$findAllDOMElements;

});

parcelRegister("lB5wD", function(module, exports) {
"use strict";

var $gxKVV = parcelRequire("gxKVV");

var $aHetk = parcelRequire("aHetk");
/**
 * Returns a promise that resolves to the array of dropped files (if a folder is
 * dropped, and browser supports folder parsing - promise resolves to the flat
 * array of all files in all directories).
 * Each file has .relativePath prop appended to it (e.g. "/docs/Prague/ticket_from_prague_to_ufa.pdf")
 * if browser supports it. Otherwise it's undefined.
 *
 * @param {DataTransfer} dataTransfer
 * @param {Function} logDropError - a function that's called every time some
 * folder or some file error out (e.g. because of the folder name being too long
 * on Windows). Notice that resulting promise will always be resolved anyway.
 *
 * @returns {Promise} - Array<File>
 */ async function $fb9156e1367a0825$var$getDroppedFiles(dataTransfer, _temp) {
    let { logDropError: logDropError = ()=>{} } = _temp === void 0 ? {} : _temp;
    // Get all files from all subdirs. Works (at least) in Chrome, Mozilla, and Safari
    try {
        const accumulator = [];
        for await (const file of $gxKVV(dataTransfer, logDropError))accumulator.push(file);
        return accumulator; // Otherwise just return all first-order files
    } catch  {
        return $aHetk(dataTransfer);
    }
}
module.exports = $fb9156e1367a0825$var$getDroppedFiles;

});
parcelRegister("gxKVV", function(module, exports) {
"use strict";

var $jb21U = parcelRequire("jb21U");
/**
 * Interop between deprecated webkitGetAsEntry and standard getAsFileSystemHandle.
 */ function $c0b42265ddfa4565$var$getAsFileSystemHandleFromEntry(entry, logDropError) {
    if (entry == null) return entry;
    return {
        // eslint-disable-next-line no-nested-ternary
        kind: entry.isFile ? "file" : entry.isDirectory ? "directory" : undefined,
        name: entry.name,
        getFile () {
            return new Promise((resolve, reject)=>entry.file(resolve, reject));
        },
        async *values () {
            // If the file is a directory.
            const directoryReader = entry.createReader();
            const entries = await new Promise((resolve)=>{
                $jb21U(directoryReader, [], logDropError, {
                    onSuccess: (dirEntries)=>resolve(dirEntries.map((file)=>$c0b42265ddfa4565$var$getAsFileSystemHandleFromEntry(file, logDropError)))
                });
            });
            yield* entries;
        }
    };
}
async function* $c0b42265ddfa4565$var$createPromiseToAddFileOrParseDirectory(entry, relativePath) {
    // For each dropped item, - make sure it's a file/directory, and start deepening in!
    if (entry.kind === "file") {
        const file = await entry.getFile();
        if (file !== null) {
            file.relativePath = relativePath ? `${relativePath}/${entry.name}` : null;
            yield file;
        }
    } else if (entry.kind === "directory") for await (const handle of entry.values())yield* $c0b42265ddfa4565$var$createPromiseToAddFileOrParseDirectory(handle, `${relativePath}/${entry.name}`);
}
async function* $c0b42265ddfa4565$var$getFilesFromDataTransfer(dataTransfer, logDropError) {
    const entries = await Promise.all(Array.from(dataTransfer.items, async (item)=>{
        var _await$item$getAsFile;
        const lastResortFile = item.getAsFile(); // Chromium bug, see https://github.com/transloadit/uppy/issues/3505.
        const entry = (_await$item$getAsFile = await (item.getAsFileSystemHandle == null ? void 0 : item.getAsFileSystemHandle())) != null ? _await$item$getAsFile : $c0b42265ddfa4565$var$getAsFileSystemHandleFromEntry(item.webkitGetAsEntry(), logDropError);
        return {
            lastResortFile: lastResortFile,
            entry: entry
        };
    }));
    for (const { lastResortFile: lastResortFile, entry: entry } of entries){
        // :entry can be null when we drop the url e.g.
        if (entry != null) try {
            yield* $c0b42265ddfa4565$var$createPromiseToAddFileOrParseDirectory(entry, "");
        } catch (err) {
            if (lastResortFile) yield lastResortFile;
            else logDropError(err);
        }
    }
}
module.exports = $c0b42265ddfa4565$var$getFilesFromDataTransfer;

});
parcelRegister("jb21U", function(module, exports) {
"use strict";
function $df609e7903369114$var$getFilesAndDirectoriesFromDirectory(directoryReader, oldEntries, logDropError, _ref) {
    let { onSuccess: onSuccess } = _ref;
    directoryReader.readEntries((entries)=>{
        const newEntries = [
            ...oldEntries,
            ...entries
        ]; // According to the FileSystem API spec, getFilesAndDirectoriesFromDirectory()
        // must be called until it calls the onSuccess with an empty array.
        if (entries.length) queueMicrotask(()=>{
            $df609e7903369114$var$getFilesAndDirectoriesFromDirectory(directoryReader, newEntries, logDropError, {
                onSuccess: onSuccess
            });
        }); // Done iterating this particular directory
        else onSuccess(newEntries);
    }, (error)=>{
        logDropError(error);
        onSuccess(oldEntries);
    });
}
/**
 * Recursive function, calls the original callback() when the directory is entirely parsed.
 *
 * @param {FileSystemDirectoryReader} directoryReader
 * @param {Array} oldEntries
 * @param {Function} logDropError
 * @param {Function} callback - called with ([ all files and directories in that directoryReader ])
 */ module.exports = $df609e7903369114$var$getFilesAndDirectoriesFromDirectory;

});


parcelRegister("aHetk", function(module, exports) {
"use strict";

var $bs0mo = parcelRequire("bs0mo");
function $7c992567e6004c4c$var$fallbackApi(dataTransfer) {
    const files = $bs0mo(dataTransfer.files);
    return Promise.resolve(files);
}
module.exports = $7c992567e6004c4c$var$fallbackApi;

});


parcelRegister("exYxU", function(module, exports) {
"use strict";

var $lwfqC = parcelRequire("lwfqC");

var $jLt6s = parcelRequire("jLt6s");

var $evFQ6 = parcelRequire("evFQ6");
/*
  Focuses on some element in the currently topmost overlay.

  1. If there are some [data-uppy-super-focusable] elements rendered already - focuses
     on the first superfocusable element, and leaves focus up to the control of
     a user (until currently focused element disappears from the screen [which
     can happen when overlay changes, or, e.g., when we click on a folder in googledrive]).
  2. If there are no [data-uppy-super-focusable] elements yet (or ever) - focuses
     on the first focusable element, but switches focus if superfocusable elements appear on next render.
*/ function $a9731cea701c62f4$var$createSuperFocus() {
    let lastFocusWasOnSuperFocusableEl = false;
    const superFocus = (dashboardEl, activeOverlayType)=>{
        const overlayEl = $evFQ6(dashboardEl, activeOverlayType);
        const isFocusInOverlay = overlayEl.contains(document.activeElement); // If focus is already in the topmost overlay, AND on last update we focused on the superfocusable
        // element - then leave focus up to the user.
        // [Practical check] without this line, typing in the search input in googledrive overlay won't work.
        if (isFocusInOverlay && lastFocusWasOnSuperFocusableEl) return;
        const superFocusableEl = overlayEl.querySelector("[data-uppy-super-focusable]"); // If we are already in the topmost overlay, AND there are no super focusable elements yet, - leave focus up to the user.
        // [Practical check] without this line, if you are in an empty folder in google drive, and something's uploading in the
        // bg, - focus will be jumping to Done all the time.
        if (isFocusInOverlay && !superFocusableEl) return;
        if (superFocusableEl) {
            superFocusableEl.focus({
                preventScroll: true
            });
            lastFocusWasOnSuperFocusableEl = true;
        } else {
            const firstEl = overlayEl.querySelector($jLt6s);
            firstEl == null || firstEl.focus({
                preventScroll: true
            });
            lastFocusWasOnSuperFocusableEl = false;
        }
    }; // ___Why do we need to debounce?
    //    1. To deal with animations: overlay changes via animations, which results in the DOM updating AFTER plugin.update()
    //       already executed.
    //    [Practical check] without debounce, if we open the Url overlay, and click 'Done', Dashboard won't get focused again.
    //    [Practical check] if we delay 250ms instead of 260ms - IE11 won't get focused in same situation.
    //    2. Performance: there can be many state update()s in a second, and this function is called every time.
    return $lwfqC(superFocus, 260);
}
module.exports = $a9731cea701c62f4$var$createSuperFocus;

});
parcelRegister("lwfqC", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $faa88de4f0afd1d0$var$FUNC_ERROR_TEXT = "Expected a function";
/** Used as references for various `Number` constants. */ var $faa88de4f0afd1d0$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $faa88de4f0afd1d0$var$symbolTag = "[object Symbol]";
/** Used to match leading and trailing whitespace. */ var $faa88de4f0afd1d0$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $faa88de4f0afd1d0$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $faa88de4f0afd1d0$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $faa88de4f0afd1d0$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $faa88de4f0afd1d0$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $faa88de4f0afd1d0$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $faa88de4f0afd1d0$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $faa88de4f0afd1d0$var$root = $faa88de4f0afd1d0$var$freeGlobal || $faa88de4f0afd1d0$var$freeSelf || Function("return this")();
/** Used for built-in method references. */ var $faa88de4f0afd1d0$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $faa88de4f0afd1d0$var$objectToString = $faa88de4f0afd1d0$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $faa88de4f0afd1d0$var$nativeMax = Math.max, $faa88de4f0afd1d0$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $faa88de4f0afd1d0$var$now = function() {
    return $faa88de4f0afd1d0$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $faa88de4f0afd1d0$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($faa88de4f0afd1d0$var$FUNC_ERROR_TEXT);
    wait = $faa88de4f0afd1d0$var$toNumber(wait) || 0;
    if ($faa88de4f0afd1d0$var$isObject(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $faa88de4f0afd1d0$var$nativeMax($faa88de4f0afd1d0$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $faa88de4f0afd1d0$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $faa88de4f0afd1d0$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($faa88de4f0afd1d0$var$now());
    }
    function debounced() {
        var time = $faa88de4f0afd1d0$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $faa88de4f0afd1d0$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $faa88de4f0afd1d0$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $faa88de4f0afd1d0$var$isSymbol(value) {
    return typeof value == "symbol" || $faa88de4f0afd1d0$var$isObjectLike(value) && $faa88de4f0afd1d0$var$objectToString.call(value) == $faa88de4f0afd1d0$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $faa88de4f0afd1d0$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($faa88de4f0afd1d0$var$isSymbol(value)) return $faa88de4f0afd1d0$var$NAN;
    if ($faa88de4f0afd1d0$var$isObject(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $faa88de4f0afd1d0$var$isObject(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = value.replace($faa88de4f0afd1d0$var$reTrim, "");
    var isBinary = $faa88de4f0afd1d0$var$reIsBinary.test(value);
    return isBinary || $faa88de4f0afd1d0$var$reIsOctal.test(value) ? $faa88de4f0afd1d0$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $faa88de4f0afd1d0$var$reIsBadHex.test(value) ? $faa88de4f0afd1d0$var$NAN : +value;
}
module.exports = $faa88de4f0afd1d0$var$debounce;

});


parcelRegister("bdnKs", function(module, exports) {
"use strict";

var $1Hdcz = parcelRequire("1Hdcz");
function $82a3548d6eca4046$var$_extends() {
    $82a3548d6eca4046$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $82a3548d6eca4046$var$_extends.apply(this, arguments);
}

var $8g1PZ = parcelRequire("8g1PZ");

var $eHmr4 = parcelRequire("eHmr4");

var $kZSC0 = parcelRequire("kZSC0");

var $epRDz = parcelRequire("epRDz");

var $a40Np = parcelRequire("a40Np");

var $cBaYe = parcelRequire("cBaYe");

var $8kMTA = parcelRequire("8kMTA");

var $dXjtP = parcelRequire("dXjtP");

var $196Bx = parcelRequire("196Bx");

var $jrD46 = parcelRequire("jrD46");
// https://github.com/ghosh/micromodal
const $82a3548d6eca4046$var$WIDTH_XL = 900;
const $82a3548d6eca4046$var$WIDTH_LG = 700;
const $82a3548d6eca4046$var$WIDTH_MD = 576;
const $82a3548d6eca4046$var$HEIGHT_MD = 400;
function $82a3548d6eca4046$var$Dashboard(props) {
    const noFiles = props.totalFileCount === 0;
    const isSizeMD = props.containerWidth > $82a3548d6eca4046$var$WIDTH_MD;
    const dashboardClassName = $8g1PZ({
        "uppy-Dashboard": true,
        "uppy-Dashboard--isDisabled": props.disabled,
        "uppy-Dashboard--animateOpenClose": props.animateOpenClose,
        "uppy-Dashboard--isClosing": props.isClosing,
        "uppy-Dashboard--isDraggingOver": props.isDraggingOver,
        "uppy-Dashboard--modal": !props.inline,
        "uppy-size--md": props.containerWidth > $82a3548d6eca4046$var$WIDTH_MD,
        "uppy-size--lg": props.containerWidth > $82a3548d6eca4046$var$WIDTH_LG,
        "uppy-size--xl": props.containerWidth > $82a3548d6eca4046$var$WIDTH_XL,
        "uppy-size--height-md": props.containerHeight > $82a3548d6eca4046$var$HEIGHT_MD,
        "uppy-Dashboard--isAddFilesPanelVisible": props.showAddFilesPanel,
        "uppy-Dashboard--isInnerWrapVisible": props.areInsidesReadyToBeVisible
    }); // Important: keep these in sync with the percent width values in `src/components/FileItem/index.scss`.
    let itemsPerRow = 1; // mobile
    if (props.containerWidth > $82a3548d6eca4046$var$WIDTH_XL) itemsPerRow = 5;
    else if (props.containerWidth > $82a3548d6eca4046$var$WIDTH_LG) itemsPerRow = 4;
    else if (props.containerWidth > $82a3548d6eca4046$var$WIDTH_MD) itemsPerRow = 3;
    const showFileList = props.showSelectedFiles && !noFiles;
    const numberOfFilesForRecovery = props.recoveredState ? Object.keys(props.recoveredState.files).length : null;
    const numberOfGhosts = props.files ? Object.keys(props.files).filter((fileID)=>props.files[fileID].isGhost).length : null;
    const renderRestoredText = ()=>{
        if (numberOfGhosts > 0) return props.i18n("recoveredXFiles", {
            smart_count: numberOfGhosts
        });
        return props.i18n("recoveredAllFiles");
    };
    const dashboard = (0, $1Hdcz.h)("div", {
        className: dashboardClassName,
        "data-uppy-theme": props.theme,
        "data-uppy-num-acquirers": props.acquirers.length,
        "data-uppy-drag-drop-supported": !props.disableLocalFiles && $eHmr4(),
        "aria-hidden": props.inline ? "false" : props.isHidden,
        "aria-disabled": props.disabled,
        "aria-label": !props.inline ? props.i18n("dashboardWindowTitle") : props.i18n("dashboardTitle"),
        onPaste: props.handlePaste,
        onDragOver: props.handleDragOver,
        onDragLeave: props.handleDragLeave,
        onDrop: props.handleDrop
    }, (0, $1Hdcz.h)("div", {
        "aria-hidden": "true",
        className: "uppy-Dashboard-overlay",
        tabIndex: -1,
        onClick: props.handleClickOutside
    }), (0, $1Hdcz.h)("div", {
        className: "uppy-Dashboard-inner",
        "aria-modal": !props.inline && "true",
        role: !props.inline && "dialog",
        style: {
            width: props.inline && props.width ? props.width : "",
            height: props.inline && props.height ? props.height : ""
        }
    }, !props.inline ? (0, $1Hdcz.h)("button", {
        className: "uppy-u-reset uppy-Dashboard-close",
        type: "button",
        "aria-label": props.i18n("closeModal"),
        title: props.i18n("closeModal"),
        onClick: props.closeModal
    }, (0, $1Hdcz.h)("span", {
        "aria-hidden": "true"
    }, "\xd7")) : null, (0, $1Hdcz.h)("div", {
        className: "uppy-Dashboard-innerWrap"
    }, (0, $1Hdcz.h)("div", {
        className: "uppy-Dashboard-dropFilesHereHint"
    }, props.i18n("dropHint")), showFileList && (0, $1Hdcz.h)($dXjtP, props), numberOfFilesForRecovery && (0, $1Hdcz.h)("div", {
        className: "uppy-Dashboard-serviceMsg"
    }, (0, $1Hdcz.h)("svg", {
        className: "uppy-Dashboard-serviceMsg-icon",
        "aria-hidden": "true",
        focusable: "false",
        width: "21",
        height: "16",
        viewBox: "0 0 24 19"
    }, (0, $1Hdcz.h)("g", {
        transform: "translate(0 -1)",
        fill: "none",
        fillRule: "evenodd"
    }, (0, $1Hdcz.h)("path", {
        d: "M12.857 1.43l10.234 17.056A1 1 0 0122.234 20H1.766a1 1 0 01-.857-1.514L11.143 1.429a1 1 0 011.714 0z",
        fill: "#FFD300"
    }), (0, $1Hdcz.h)("path", {
        fill: "#000",
        d: "M11 6h2l-.3 8h-1.4z"
    }), (0, $1Hdcz.h)("circle", {
        fill: "#000",
        cx: "12",
        cy: "17",
        r: "1"
    }))), (0, $1Hdcz.h)("strong", {
        className: "uppy-Dashboard-serviceMsg-title"
    }, props.i18n("sessionRestored")), (0, $1Hdcz.h)("div", {
        className: "uppy-Dashboard-serviceMsg-text"
    }, renderRestoredText())), showFileList ? (0, $1Hdcz.h)($kZSC0 // eslint-disable-next-line react/jsx-props-no-spreading
    , $82a3548d6eca4046$var$_extends({}, props, {
        itemsPerRow: itemsPerRow
    })) : (0, $1Hdcz.h)($epRDz, $82a3548d6eca4046$var$_extends({}, props, {
        isSizeMD: isSizeMD
    })), (0, $1Hdcz.h)($jrD46, null, props.showAddFilesPanel ? (0, $1Hdcz.h)($a40Np, $82a3548d6eca4046$var$_extends({
        key: "AddFiles"
    }, props, {
        isSizeMD: isSizeMD
    })) : null), (0, $1Hdcz.h)($jrD46, null, props.fileCardFor ? (0, $1Hdcz.h)($196Bx, $82a3548d6eca4046$var$_extends({
        key: "FileCard"
    }, props)) : null), (0, $1Hdcz.h)($jrD46, null, props.activePickerPanel ? (0, $1Hdcz.h)($cBaYe, $82a3548d6eca4046$var$_extends({
        key: "Picker"
    }, props)) : null), (0, $1Hdcz.h)($jrD46, null, props.showFileEditor ? (0, $1Hdcz.h)($8kMTA, $82a3548d6eca4046$var$_extends({
        key: "Editor"
    }, props)) : null), (0, $1Hdcz.h)("div", {
        className: "uppy-Dashboard-progressindicators"
    }, props.progressindicators.map((target)=>{
        return props.uppy.getPlugin(target.id).render(props.state);
    })))));
    return dashboard;
}
module.exports = $82a3548d6eca4046$var$Dashboard;

});
parcelRegister("eHmr4", function(module, exports) {
"use strict";
function $ab367c1ca8c9f1e4$var$isDragDropSupported() {
    const div = document.body;
    if (!("draggable" in div) || !("ondragstart" in div && "ondrop" in div)) return false;
    if (!("FormData" in window)) return false;
    if (!("FileReader" in window)) return false;
    return true;
}
/**
 * Checks if the browser supports Drag & Drop (not supported on mobile devices, for example).
 *
 * @returns {boolean}
 */ module.exports = $ab367c1ca8c9f1e4$var$isDragDropSupported;

});

parcelRegister("kZSC0", function(module, exports) {
"use strict";

var $1Hdcz = parcelRequire("1Hdcz");
function $f493ddf87ae459de$var$_extends() {
    $f493ddf87ae459de$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f493ddf87ae459de$var$_extends.apply(this, arguments);
}

var $8g1PZ = parcelRequire("8g1PZ");

var $cCG3O = parcelRequire("cCG3O");

var $5SLrA = parcelRequire("5SLrA");
function $f493ddf87ae459de$var$chunks(list, size) {
    const chunked = [];
    let currentChunk = [];
    list.forEach((item)=>{
        if (currentChunk.length < size) currentChunk.push(item);
        else {
            chunked.push(currentChunk);
            currentChunk = [
                item
            ];
        }
    });
    if (currentChunk.length) chunked.push(currentChunk);
    return chunked;
}
module.exports = (props)=>{
    const noFiles = props.totalFileCount === 0;
    const dashboardFilesClass = $8g1PZ("uppy-Dashboard-files", {
        "uppy-Dashboard-files--noFiles": noFiles
    }); // It's not great that this is hardcoded!
    // It's ESPECIALLY not great that this is checking against `itemsPerRow`!
    const rowHeight = props.itemsPerRow === 1 // Mobile
     ? 71 // 190px height + 2 * 5px margin
     : 200;
    const fileProps = {
        // FIXME This is confusing, it's actually the Dashboard's plugin ID
        id: props.id,
        error: props.error,
        // TODO move this to context
        i18n: props.i18n,
        uppy: props.uppy,
        // features
        acquirers: props.acquirers,
        resumableUploads: props.resumableUploads,
        individualCancellation: props.individualCancellation,
        // visual options
        hideRetryButton: props.hideRetryButton,
        hidePauseResumeButton: props.hidePauseResumeButton,
        hideCancelButton: props.hideCancelButton,
        showLinkToFileUploadResult: props.showLinkToFileUploadResult,
        showRemoveButtonAfterComplete: props.showRemoveButtonAfterComplete,
        isWide: props.isWide,
        metaFields: props.metaFields,
        recoveredState: props.recoveredState,
        // callbacks
        toggleFileCard: props.toggleFileCard,
        handleRequestThumbnail: props.handleRequestThumbnail,
        handleCancelThumbnail: props.handleCancelThumbnail
    };
    const sortByGhostComesFirst = (file1, file2)=>{
        return props.files[file2].isGhost - props.files[file1].isGhost;
    }; // Sort files by file.isGhost, ghost files first, only if recoveredState is present
    const files = Object.keys(props.files);
    if (props.recoveredState) files.sort(sortByGhostComesFirst);
    const rows = $f493ddf87ae459de$var$chunks(files, props.itemsPerRow);
    const renderRow = (row)=>// associated with the `VirtualList` element.
        // We use the first file ID as the key—this should not change across scroll rerenders
        (0, $1Hdcz.h)("div", {
            role: "presentation",
            key: row[0]
        }, row.map((fileID)=>(0, $1Hdcz.h)($cCG3O, $f493ddf87ae459de$var$_extends({
                key: fileID,
                uppy: props.uppy
            }, fileProps, {
                // eslint-disable-line react/jsx-props-no-spreading
                role: "listitem",
                openFileEditor: props.openFileEditor,
                canEditFile: props.canEditFile,
                toggleAddFilesPanel: props.toggleAddFilesPanel,
                file: props.files[fileID]
            }))));
    return (0, $1Hdcz.h)($5SLrA, {
        class: dashboardFilesClass,
        role: "list",
        data: rows,
        renderRow: renderRow,
        rowHeight: rowHeight
    });
};

});
parcelRegister("cCG3O", function(module, exports) {
"use strict";

var $1Hdcz = parcelRequire("1Hdcz");

var $8g1PZ = parcelRequire("8g1PZ");

var $8uONI = parcelRequire("8uONI");

var $gpuix = parcelRequire("gpuix");

var $6Hj7O = parcelRequire("6Hj7O");

var $bTG6u = parcelRequire("bTG6u");

var $3FkmF = parcelRequire("3FkmF");
class $9309a8f876e3e25f$var$FileItem extends $1Hdcz.Component {
    componentDidMount() {
        const { file: file } = this.props;
        if (!file.preview) this.props.handleRequestThumbnail(file);
    }
    shouldComponentUpdate(nextProps) {
        return !$8uONI(this.props, nextProps);
    }
    // Otherwise thumbnails are broken or missing after Golden Retriever restores files
    componentDidUpdate() {
        const { file: file } = this.props;
        if (!file.preview) this.props.handleRequestThumbnail(file);
    }
    componentWillUnmount() {
        const { file: file } = this.props;
        if (!file.preview) this.props.handleCancelThumbnail(file);
    }
    render() {
        const { file: file } = this.props;
        const isProcessing = file.progress.preprocess || file.progress.postprocess;
        const isUploaded = file.progress.uploadComplete && !isProcessing && !file.error;
        const uploadInProgressOrComplete = file.progress.uploadStarted || isProcessing;
        const uploadInProgress = file.progress.uploadStarted && !file.progress.uploadComplete || isProcessing;
        const error = file.error || false; // File that Golden Retriever was able to partly restore (only meta, not blob),
        // users still need to re-add it, so it’s a ghost
        const { isGhost: isGhost } = file;
        let showRemoveButton = this.props.individualCancellation ? !isUploaded : !uploadInProgress && !isUploaded;
        if (isUploaded && this.props.showRemoveButtonAfterComplete) showRemoveButton = true;
        const dashboardItemClass = $8g1PZ({
            "uppy-Dashboard-Item": true,
            "is-inprogress": uploadInProgress && !this.props.recoveredState,
            "is-processing": isProcessing,
            "is-complete": isUploaded,
            "is-error": !!error,
            "is-resumable": this.props.resumableUploads,
            "is-noIndividualCancellation": !this.props.individualCancellation,
            "is-ghost": isGhost
        });
        return (0, $1Hdcz.h)("div", {
            className: dashboardItemClass,
            id: `uppy_${file.id}`,
            role: this.props.role
        }, (0, $1Hdcz.h)("div", {
            className: "uppy-Dashboard-Item-preview"
        }, (0, $1Hdcz.h)($gpuix, {
            file: file,
            showLinkToFileUploadResult: this.props.showLinkToFileUploadResult,
            i18n: this.props.i18n,
            toggleFileCard: this.props.toggleFileCard,
            metaFields: this.props.metaFields
        }), (0, $1Hdcz.h)($6Hj7O, {
            uppy: this.props.uppy,
            file: file,
            error: error,
            isUploaded: isUploaded,
            hideRetryButton: this.props.hideRetryButton,
            hideCancelButton: this.props.hideCancelButton,
            hidePauseResumeButton: this.props.hidePauseResumeButton,
            recoveredState: this.props.recoveredState,
            showRemoveButtonAfterComplete: this.props.showRemoveButtonAfterComplete,
            resumableUploads: this.props.resumableUploads,
            individualCancellation: this.props.individualCancellation,
            i18n: this.props.i18n
        })), (0, $1Hdcz.h)("div", {
            className: "uppy-Dashboard-Item-fileInfoAndButtons"
        }, (0, $1Hdcz.h)($bTG6u, {
            file: file,
            id: this.props.id,
            acquirers: this.props.acquirers,
            containerWidth: this.props.containerWidth,
            i18n: this.props.i18n,
            toggleAddFilesPanel: this.props.toggleAddFilesPanel,
            toggleFileCard: this.props.toggleFileCard,
            metaFields: this.props.metaFields
        }), (0, $1Hdcz.h)($3FkmF, {
            file: file,
            metaFields: this.props.metaFields,
            showLinkToFileUploadResult: this.props.showLinkToFileUploadResult,
            showRemoveButton: showRemoveButton,
            canEditFile: this.props.canEditFile,
            uploadInProgressOrComplete: uploadInProgressOrComplete,
            toggleFileCard: this.props.toggleFileCard,
            openFileEditor: this.props.openFileEditor,
            uppy: this.props.uppy,
            i18n: this.props.i18n
        })));
    }
}
module.exports = $9309a8f876e3e25f$var$FileItem;

});
parcelRegister("8uONI", function(module, exports) {
module.exports = function isShallowEqual(a, b) {
    if (a === b) return true;
    for(var i in a)if (!(i in b)) return false;
    for(var i in b)if (a[i] !== b[i]) return false;
    return true;
};

});

parcelRegister("gpuix", function(module, exports) {
"use strict";

var $1Hdcz = parcelRequire("1Hdcz");

var $4KEB8 = parcelRequire("4KEB8");

var $5Lybo = parcelRequire("5Lybo");

var $ksZSi = parcelRequire("ksZSi");
function $bf267bb4159e1c9f$var$FilePreviewAndLink(props) {
    return (0, $1Hdcz.h)("div", {
        className: "uppy-Dashboard-Item-previewInnerWrap",
        style: {
            backgroundColor: $ksZSi(props.file.type).color
        }
    }, props.showLinkToFileUploadResult && props.file.uploadURL && (0, $1Hdcz.h)("a", {
        className: "uppy-Dashboard-Item-previewLink",
        href: props.file.uploadURL,
        rel: "noreferrer noopener",
        target: "_blank",
        "aria-label": props.file.meta.name
    }, (0, $1Hdcz.h)("span", {
        hidden: true
    }, props.file.meta.name)), (0, $1Hdcz.h)($4KEB8, {
        file: props.file
    }), (0, $1Hdcz.h)($5Lybo, {
        file: props.file,
        i18n: props.i18n,
        toggleFileCard: props.toggleFileCard,
        metaFields: props.metaFields
    }));
}
module.exports = $bf267bb4159e1c9f$var$FilePreviewAndLink;

});
parcelRegister("4KEB8", function(module, exports) {
"use strict";

var $1Hdcz = parcelRequire("1Hdcz");

var $ksZSi = parcelRequire("ksZSi");
function $375af333913e8475$var$FilePreview(props) {
    const { file: file } = props;
    if (file.preview) return (0, $1Hdcz.h)("img", {
        className: "uppy-Dashboard-Item-previewImg",
        alt: file.name,
        src: file.preview
    });
    const { color: color, icon: icon } = $ksZSi(file.type);
    return (0, $1Hdcz.h)("div", {
        className: "uppy-Dashboard-Item-previewIconWrap"
    }, (0, $1Hdcz.h)("span", {
        className: "uppy-Dashboard-Item-previewIcon",
        style: {
            color: color
        }
    }, icon), (0, $1Hdcz.h)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-Dashboard-Item-previewIconBg",
        width: "58",
        height: "76",
        viewBox: "0 0 58 76"
    }, (0, $1Hdcz.h)("rect", {
        fill: "#FFF",
        width: "58",
        height: "76",
        rx: "3",
        fillRule: "evenodd"
    })));
}
module.exports = $375af333913e8475$var$FilePreview;

});
parcelRegister("ksZSi", function(module, exports) {
"use strict";

var $1Hdcz = parcelRequire("1Hdcz");
function $ee666b3a807a12f7$var$iconImage() {
    return (0, $1Hdcz.h)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25"
    }, (0, $1Hdcz.h)("g", {
        fill: "#686DE0",
        fillRule: "evenodd"
    }, (0, $1Hdcz.h)("path", {
        d: "M5 7v10h15V7H5zm0-1h15a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1z",
        fillRule: "nonzero"
    }), (0, $1Hdcz.h)("path", {
        d: "M6.35 17.172l4.994-5.026a.5.5 0 0 1 .707 0l2.16 2.16 3.505-3.505a.5.5 0 0 1 .707 0l2.336 2.31-.707.72-1.983-1.97-3.505 3.505a.5.5 0 0 1-.707 0l-2.16-2.159-3.938 3.939-1.409.026z",
        fillRule: "nonzero"
    }), (0, $1Hdcz.h)("circle", {
        cx: "7.5",
        cy: "9.5",
        r: "1.5"
    })));
}
function $ee666b3a807a12f7$var$iconAudio() {
    return (0, $1Hdcz.h)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25"
    }, (0, $1Hdcz.h)("path", {
        d: "M9.5 18.64c0 1.14-1.145 2-2.5 2s-2.5-.86-2.5-2c0-1.14 1.145-2 2.5-2 .557 0 1.079.145 1.5.396V7.25a.5.5 0 0 1 .379-.485l9-2.25A.5.5 0 0 1 18.5 5v11.64c0 1.14-1.145 2-2.5 2s-2.5-.86-2.5-2c0-1.14 1.145-2 2.5-2 .557 0 1.079.145 1.5.396V8.67l-8 2v7.97zm8-11v-2l-8 2v2l8-2zM7 19.64c.855 0 1.5-.484 1.5-1s-.645-1-1.5-1-1.5.484-1.5 1 .645 1 1.5 1zm9-2c.855 0 1.5-.484 1.5-1s-.645-1-1.5-1-1.5.484-1.5 1 .645 1 1.5 1z",
        fill: "#049BCF",
        fillRule: "nonzero"
    }));
}
function $ee666b3a807a12f7$var$iconVideo() {
    return (0, $1Hdcz.h)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25"
    }, (0, $1Hdcz.h)("path", {
        d: "M16 11.834l4.486-2.691A1 1 0 0 1 22 10v6a1 1 0 0 1-1.514.857L16 14.167V17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v2.834zM15 9H5v8h10V9zm1 4l5 3v-6l-5 3z",
        fill: "#19AF67",
        fillRule: "nonzero"
    }));
}
function $ee666b3a807a12f7$var$iconPDF() {
    return (0, $1Hdcz.h)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25"
    }, (0, $1Hdcz.h)("path", {
        d: "M9.766 8.295c-.691-1.843-.539-3.401.747-3.726 1.643-.414 2.505.938 2.39 3.299-.039.79-.194 1.662-.537 3.148.324.49.66.967 1.055 1.51.17.231.382.488.629.757 1.866-.128 3.653.114 4.918.655 1.487.635 2.192 1.685 1.614 2.84-.566 1.133-1.839 1.084-3.416.249-1.141-.604-2.457-1.634-3.51-2.707a13.467 13.467 0 0 0-2.238.426c-1.392 4.051-4.534 6.453-5.707 4.572-.986-1.58 1.38-4.206 4.914-5.375.097-.322.185-.656.264-1.001.08-.353.306-1.31.407-1.737-.678-1.059-1.2-2.031-1.53-2.91zm2.098 4.87c-.033.144-.068.287-.104.427l.033-.01-.012.038a14.065 14.065 0 0 1 1.02-.197l-.032-.033.052-.004a7.902 7.902 0 0 1-.208-.271c-.197-.27-.38-.526-.555-.775l-.006.028-.002-.003c-.076.323-.148.632-.186.8zm5.77 2.978c1.143.605 1.832.632 2.054.187.26-.519-.087-1.034-1.113-1.473-.911-.39-2.175-.608-3.55-.608.845.766 1.787 1.459 2.609 1.894zM6.559 18.789c.14.223.693.16 1.425-.413.827-.648 1.61-1.747 2.208-3.206-2.563 1.064-4.102 2.867-3.633 3.62zm5.345-10.97c.088-1.793-.351-2.48-1.146-2.28-.473.119-.564 1.05-.056 2.405.213.566.52 1.188.908 1.859.18-.858.268-1.453.294-1.984z",
        fill: "#E2514A",
        fillRule: "nonzero"
    }));
}
function $ee666b3a807a12f7$var$iconArchive() {
    return (0, $1Hdcz.h)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25"
    }, (0, $1Hdcz.h)("path", {
        d: "M10.45 2.05h1.05a.5.5 0 0 1 .5.5v.024a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5V2.55a.5.5 0 0 1 .5-.5zm2.05 1.024h1.05a.5.5 0 0 1 .5.5V3.6a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5v-.001zM10.45 0h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5V.5a.5.5 0 0 1 .5-.5zm2.05 1.025h1.05a.5.5 0 0 1 .5.5v.024a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.024a.5.5 0 0 1 .5-.5zm-2.05 3.074h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5zm2.05 1.025h1.05a.5.5 0 0 1 .5.5v.024a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.024a.5.5 0 0 1 .5-.5zm-2.05 1.024h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5zm2.05 1.025h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5zm-2.05 1.025h1.05a.5.5 0 0 1 .5.5v.025a.5.5 0 0 1-.5.5h-1.05a.5.5 0 0 1-.5-.5v-.025a.5.5 0 0 1 .5-.5zm2.05 1.025h1.05a.5.5 0 0 1 .5.5v.024a.5.5 0 0 1-.5.5H12.5a.5.5 0 0 1-.5-.5v-.024a.5.5 0 0 1 .5-.5zm-1.656 3.074l-.82 5.946c.52.302 1.174.458 1.976.458.803 0 1.455-.156 1.975-.458l-.82-5.946h-2.311zm0-1.025h2.312c.512 0 .946.378 1.015.885l.82 5.946c.056.412-.142.817-.501 1.026-.686.398-1.515.597-2.49.597-.974 0-1.804-.199-2.49-.597a1.025 1.025 0 0 1-.5-1.026l.819-5.946c.07-.507.503-.885 1.015-.885zm.545 6.6a.5.5 0 0 1-.397-.561l.143-.999a.5.5 0 0 1 .495-.429h.74a.5.5 0 0 1 .495.43l.143.998a.5.5 0 0 1-.397.561c-.404.08-.819.08-1.222 0z",
        fill: "#00C469",
        fillRule: "nonzero"
    }));
}
function $ee666b3a807a12f7$var$iconFile() {
    return (0, $1Hdcz.h)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25"
    }, (0, $1Hdcz.h)("g", {
        fill: "#A7AFB7",
        fillRule: "nonzero"
    }, (0, $1Hdcz.h)("path", {
        d: "M5.5 22a.5.5 0 0 1-.5-.5v-18a.5.5 0 0 1 .5-.5h10.719a.5.5 0 0 1 .367.16l3.281 3.556a.5.5 0 0 1 .133.339V21.5a.5.5 0 0 1-.5.5h-14zm.5-1h13V7.25L16 4H6v17z"
    }), (0, $1Hdcz.h)("path", {
        d: "M15 4v3a1 1 0 0 0 1 1h3V7h-3V4h-1z"
    })));
}
function $ee666b3a807a12f7$var$iconText() {
    return (0, $1Hdcz.h)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25"
    }, (0, $1Hdcz.h)("path", {
        d: "M4.5 7h13a.5.5 0 1 1 0 1h-13a.5.5 0 0 1 0-1zm0 3h15a.5.5 0 1 1 0 1h-15a.5.5 0 1 1 0-1zm0 3h15a.5.5 0 1 1 0 1h-15a.5.5 0 1 1 0-1zm0 3h10a.5.5 0 1 1 0 1h-10a.5.5 0 1 1 0-1z",
        fill: "#5A5E69",
        fillRule: "nonzero"
    }));
}
function $ee666b3a807a12f7$var$getIconByMime(fileType) {
    const defaultChoice = {
        color: "#838999",
        icon: $ee666b3a807a12f7$var$iconFile()
    };
    if (!fileType) return defaultChoice;
    const fileTypeGeneral = fileType.split("/")[0];
    const fileTypeSpecific = fileType.split("/")[1]; // Text
    if (fileTypeGeneral === "text") return {
        color: "#5a5e69",
        icon: $ee666b3a807a12f7$var$iconText()
    };
     // Image
    if (fileTypeGeneral === "image") return {
        color: "#686de0",
        icon: $ee666b3a807a12f7$var$iconImage()
    };
     // Audio
    if (fileTypeGeneral === "audio") return {
        color: "#068dbb",
        icon: $ee666b3a807a12f7$var$iconAudio()
    };
     // Video
    if (fileTypeGeneral === "video") return {
        color: "#19af67",
        icon: $ee666b3a807a12f7$var$iconVideo()
    };
     // PDF
    if (fileTypeGeneral === "application" && fileTypeSpecific === "pdf") return {
        color: "#e25149",
        icon: $ee666b3a807a12f7$var$iconPDF()
    };
     // Archive
    const archiveTypes = [
        "zip",
        "x-7z-compressed",
        "x-rar-compressed",
        "x-tar",
        "x-gzip",
        "x-apple-diskimage"
    ];
    if (fileTypeGeneral === "application" && archiveTypes.indexOf(fileTypeSpecific) !== -1) return {
        color: "#00C469",
        icon: $ee666b3a807a12f7$var$iconArchive()
    };
    return defaultChoice;
}
module.exports = $ee666b3a807a12f7$var$getIconByMime;

});


parcelRegister("5Lybo", function(module, exports) {
"use strict";

var $1Hdcz = parcelRequire("1Hdcz");
const $432bdb8306acc6ed$var$metaFieldIdToName = (metaFieldId, metaFields)=>{
    const field = metaFields.filter((f)=>f.id === metaFieldId);
    return field[0].name;
};
function $432bdb8306acc6ed$var$renderMissingMetaFieldsError(props) {
    const { file: file, toggleFileCard: toggleFileCard, i18n: i18n, metaFields: metaFields } = props;
    const { missingRequiredMetaFields: missingRequiredMetaFields } = file;
    if (!(missingRequiredMetaFields != null && missingRequiredMetaFields.length)) return null;
    const metaFieldsString = missingRequiredMetaFields.map((missingMetaField)=>$432bdb8306acc6ed$var$metaFieldIdToName(missingMetaField, metaFields)).join(", ");
    return (0, $1Hdcz.h)("div", {
        className: "uppy-Dashboard-Item-errorMessage"
    }, i18n("missingRequiredMetaFields", {
        smart_count: missingRequiredMetaFields.length,
        fields: metaFieldsString
    }), " ", (0, $1Hdcz.h)("button", {
        type: "button",
        class: "uppy-u-reset uppy-Dashboard-Item-errorMessageBtn",
        onClick: ()=>toggleFileCard(true, file.id)
    }, i18n("editFile")));
}
module.exports = $432bdb8306acc6ed$var$renderMissingMetaFieldsError;

});


parcelRegister("6Hj7O", function(module, exports) {
"use strict";

var $1Hdcz = parcelRequire("1Hdcz");
function $4e05980d23939be3$var$onPauseResumeCancelRetry(props) {
    if (props.isUploaded) return;
    if (props.error && !props.hideRetryButton) {
        props.uppy.retryUpload(props.file.id);
        return;
    }
    if (props.resumableUploads && !props.hidePauseResumeButton) props.uppy.pauseResume(props.file.id);
    else if (props.individualCancellation && !props.hideCancelButton) props.uppy.removeFile(props.file.id);
}
function $4e05980d23939be3$var$progressIndicatorTitle(props) {
    if (props.isUploaded) return props.i18n("uploadComplete");
    if (props.error) return props.i18n("retryUpload");
    if (props.resumableUploads) {
        if (props.file.isPaused) return props.i18n("resumeUpload");
        return props.i18n("pauseUpload");
    }
    if (props.individualCancellation) return props.i18n("cancelUpload");
    return "";
}
function $4e05980d23939be3$var$ProgressIndicatorButton(props) {
    return (0, $1Hdcz.h)("div", {
        className: "uppy-Dashboard-Item-progress"
    }, (0, $1Hdcz.h)("button", {
        className: "uppy-u-reset uppy-Dashboard-Item-progressIndicator",
        type: "button",
        "aria-label": $4e05980d23939be3$var$progressIndicatorTitle(props),
        title: $4e05980d23939be3$var$progressIndicatorTitle(props),
        onClick: ()=>$4e05980d23939be3$var$onPauseResumeCancelRetry(props)
    }, props.children));
}
function $4e05980d23939be3$var$ProgressCircleContainer(_ref) {
    let { children: children } = _ref;
    return (0, $1Hdcz.h)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        width: "70",
        height: "70",
        viewBox: "0 0 36 36",
        className: "uppy-c-icon uppy-Dashboard-Item-progressIcon--circle"
    }, children);
}
function $4e05980d23939be3$var$ProgressCircle(_ref2) {
    let { progress: progress } = _ref2;
    // circle length equals 2 * PI * R
    const circleLength = 2 * Math.PI * 15;
    return (0, $1Hdcz.h)("g", null, (0, $1Hdcz.h)("circle", {
        className: "uppy-Dashboard-Item-progressIcon--bg",
        r: "15",
        cx: "18",
        cy: "18",
        "stroke-width": "2",
        fill: "none"
    }), (0, $1Hdcz.h)("circle", {
        className: "uppy-Dashboard-Item-progressIcon--progress",
        r: "15",
        cx: "18",
        cy: "18",
        transform: "rotate(-90, 18, 18)",
        fill: "none",
        "stroke-width": "2",
        "stroke-dasharray": circleLength,
        "stroke-dashoffset": circleLength - circleLength / 100 * progress
    }));
}
function $4e05980d23939be3$var$FileProgress(props) {
    // Nothing if upload has not started
    if (!props.file.progress.uploadStarted) return null;
     // Green checkmark when complete
    if (props.isUploaded) return (0, $1Hdcz.h)("div", {
        className: "uppy-Dashboard-Item-progress"
    }, (0, $1Hdcz.h)("div", {
        className: "uppy-Dashboard-Item-progressIndicator"
    }, (0, $1Hdcz.h)($4e05980d23939be3$var$ProgressCircleContainer, null, (0, $1Hdcz.h)("circle", {
        r: "15",
        cx: "18",
        cy: "18",
        fill: "#1bb240"
    }), (0, $1Hdcz.h)("polygon", {
        className: "uppy-Dashboard-Item-progressIcon--check",
        transform: "translate(2, 3)",
        points: "14 22.5 7 15.2457065 8.99985857 13.1732815 14 18.3547104 22.9729883 9 25 11.1005634"
    }))));
    if (props.recoveredState) return undefined;
     // Retry button for error
    if (props.error && !props.hideRetryButton) return (0, $1Hdcz.h)($4e05980d23939be3$var$ProgressIndicatorButton, props, (0, $1Hdcz.h)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon uppy-Dashboard-Item-progressIcon--retry",
        width: "28",
        height: "31",
        viewBox: "0 0 16 19"
    }, (0, $1Hdcz.h)("path", {
        d: "M16 11a8 8 0 1 1-8-8v2a6 6 0 1 0 6 6h2z"
    }), (0, $1Hdcz.h)("path", {
        d: "M7.9 3H10v2H7.9z"
    }), (0, $1Hdcz.h)("path", {
        d: "M8.536.5l3.535 3.536-1.414 1.414L7.12 1.914z"
    }), (0, $1Hdcz.h)("path", {
        d: "M10.657 2.621l1.414 1.415L8.536 7.57 7.12 6.157z"
    })));
     // Pause/resume button for resumable uploads
    if (props.resumableUploads && !props.hidePauseResumeButton) return (0, $1Hdcz.h)($4e05980d23939be3$var$ProgressIndicatorButton, props, (0, $1Hdcz.h)($4e05980d23939be3$var$ProgressCircleContainer, null, (0, $1Hdcz.h)($4e05980d23939be3$var$ProgressCircle, {
        progress: props.file.progress.percentage
    }), props.file.isPaused ? (0, $1Hdcz.h)("polygon", {
        className: "uppy-Dashboard-Item-progressIcon--play",
        transform: "translate(3, 3)",
        points: "12 20 12 10 20 15"
    }) : (0, $1Hdcz.h)("g", {
        className: "uppy-Dashboard-Item-progressIcon--pause",
        transform: "translate(14.5, 13)"
    }, (0, $1Hdcz.h)("rect", {
        x: "0",
        y: "0",
        width: "2",
        height: "10",
        rx: "0"
    }), (0, $1Hdcz.h)("rect", {
        x: "5",
        y: "0",
        width: "2",
        height: "10",
        rx: "0"
    }))));
     // Cancel button for non-resumable uploads if individualCancellation is supported (not bundled)
    if (!props.resumableUploads && props.individualCancellation && !props.hideCancelButton) return (0, $1Hdcz.h)($4e05980d23939be3$var$ProgressIndicatorButton, props, (0, $1Hdcz.h)($4e05980d23939be3$var$ProgressCircleContainer, null, (0, $1Hdcz.h)($4e05980d23939be3$var$ProgressCircle, {
        progress: props.file.progress.percentage
    }), (0, $1Hdcz.h)("polygon", {
        className: "cancel",
        transform: "translate(2, 2)",
        points: "19.8856516 11.0625 16 14.9481516 12.1019737 11.0625 11.0625 12.1143484 14.9481516 16 11.0625 19.8980263 12.1019737 20.9375 16 17.0518484 19.8856516 20.9375 20.9375 19.8980263 17.0518484 16 20.9375 12"
    })));
     // Just progress when buttons are disabled
    return (0, $1Hdcz.h)("div", {
        className: "uppy-Dashboard-Item-progress"
    }, (0, $1Hdcz.h)("div", {
        className: "uppy-Dashboard-Item-progressIndicator"
    }, (0, $1Hdcz.h)($4e05980d23939be3$var$ProgressCircleContainer, null, (0, $1Hdcz.h)($4e05980d23939be3$var$ProgressCircle, {
        progress: props.file.progress.percentage
    }))));
}
module.exports = $4e05980d23939be3$var$FileProgress;

});

parcelRegister("bTG6u", function(module, exports) {
"use strict";

var $1Hdcz = parcelRequire("1Hdcz");

var $bCrvb = parcelRequire("bCrvb");

var $5ZXFW = parcelRequire("5ZXFW");

var $5Lybo = parcelRequire("5Lybo");
const $8a957dac8e42086b$var$renderFileName = (props)=>{
    const { author: author, name: name } = props.file.meta;
    function getMaxNameLength() {
        if (props.containerWidth <= 352) return 35;
        if (props.containerWidth <= 576) return 60;
         // When `author` is present, we want to make sure
        // the file name fits on one line so we can place
        // the author on the second line.
        return author ? 20 : 30;
    }
    return (0, $1Hdcz.h)("div", {
        className: "uppy-Dashboard-Item-name",
        title: name
    }, $5ZXFW(name, getMaxNameLength()));
};
const $8a957dac8e42086b$var$renderAuthor = (props)=>{
    const { author: author } = props.file.meta;
    const { providerName: providerName } = props.file.remote;
    const dot = `\u00B7`;
    if (!author) return null;
    return (0, $1Hdcz.h)("div", {
        className: "uppy-Dashboard-Item-author"
    }, (0, $1Hdcz.h)("a", {
        href: `${author.url}?utm_source=Companion&utm_medium=referral`,
        target: "_blank",
        rel: "noopener noreferrer"
    }, $5ZXFW(author.name, 13)), providerName ? (0, $1Hdcz.h)($1Hdcz.Fragment, null, ` ${dot} `, providerName, ` ${dot} `) : null);
};
const $8a957dac8e42086b$var$renderFileSize = (props)=>props.file.size && (0, $1Hdcz.h)("div", {
        className: "uppy-Dashboard-Item-statusSize"
    }, $bCrvb(props.file.size));
const $8a957dac8e42086b$var$ReSelectButton = (props)=>props.file.isGhost && (0, $1Hdcz.h)("span", null, " \u2022 ", (0, $1Hdcz.h)("button", {
        className: "uppy-u-reset uppy-c-btn uppy-Dashboard-Item-reSelect",
        type: "button",
        onClick: props.toggleAddFilesPanel
    }, props.i18n("reSelect")));
const $8a957dac8e42086b$var$ErrorButton = (_ref)=>{
    let { file: file, onClick: onClick } = _ref;
    if (file.error) return (0, $1Hdcz.h)("button", {
        className: "uppy-u-reset uppy-Dashboard-Item-errorDetails",
        "aria-label": file.error,
        "data-microtip-position": "bottom",
        "data-microtip-size": "medium",
        onClick: onClick,
        type: "button"
    }, "?");
    return null;
};
function $8a957dac8e42086b$var$FileInfo(props) {
    const { file: file } = props;
    return (0, $1Hdcz.h)("div", {
        className: "uppy-Dashboard-Item-fileInfo",
        "data-uppy-file-source": file.source
    }, (0, $1Hdcz.h)("div", {
        className: "uppy-Dashboard-Item-fileName"
    }, $8a957dac8e42086b$var$renderFileName(props), (0, $1Hdcz.h)($8a957dac8e42086b$var$ErrorButton, {
        file: props.file // eslint-disable-next-line no-alert
        ,
        onClick: ()=>alert(props.file.error) // TODO: move to a custom alert implementation
    })), (0, $1Hdcz.h)("div", {
        className: "uppy-Dashboard-Item-status"
    }, $8a957dac8e42086b$var$renderAuthor(props), $8a957dac8e42086b$var$renderFileSize(props), $8a957dac8e42086b$var$ReSelectButton(props)), (0, $1Hdcz.h)($5Lybo, {
        file: props.file,
        i18n: props.i18n,
        toggleFileCard: props.toggleFileCard,
        metaFields: props.metaFields
    }));
}
module.exports = $8a957dac8e42086b$var$FileInfo;

});
parcelRegister("5ZXFW", function(module, exports) {
"use strict";
/**
 * Truncates a string to the given number of chars (maxLength) by inserting '...' in the middle of that string.
 * Partially taken from https://stackoverflow.com/a/5723274/3192470.
 *
 * @param {string} string - string to be truncated
 * @param {number} maxLength - maximum size of the resulting string
 * @returns {string}
 */ const $45e0f096133c9352$var$separator = "...";
function $45e0f096133c9352$var$truncateString(string, maxLength) {
    // Return the empty string if maxLength is zero
    if (maxLength === 0) return ""; // Return original string if it's already shorter than maxLength
    if (string.length <= maxLength) return string; // Return truncated substring appended of the ellipsis char if string can't be meaningfully truncated
    if (maxLength <= $45e0f096133c9352$var$separator.length + 1) return `${string.slice(0, maxLength - 1)}\u{2026}`;
    const charsToShow = maxLength - $45e0f096133c9352$var$separator.length;
    const frontChars = Math.ceil(charsToShow / 2);
    const backChars = Math.floor(charsToShow / 2);
    return string.slice(0, frontChars) + $45e0f096133c9352$var$separator + string.slice(-backChars);
}
module.exports = $45e0f096133c9352$var$truncateString;

});


parcelRegister("3FkmF", function(module, exports) {
"use strict";

var $1Hdcz = parcelRequire("1Hdcz");

var $9PMdo = parcelRequire("9PMdo");
function $2ab4ff65ab5dbb90$var$EditButton(_ref) {
    let { file: file, uploadInProgressOrComplete: uploadInProgressOrComplete, metaFields: metaFields, canEditFile: canEditFile, i18n: i18n, onClick: onClick } = _ref;
    if (!uploadInProgressOrComplete && metaFields && metaFields.length > 0 || !uploadInProgressOrComplete && canEditFile(file)) return (0, $1Hdcz.h)("button", {
        className: "uppy-u-reset uppy-Dashboard-Item-action uppy-Dashboard-Item-action--edit",
        type: "button",
        "aria-label": i18n("editFileWithFilename", {
            file: file.meta.name
        }),
        title: i18n("editFileWithFilename", {
            file: file.meta.name
        }),
        onClick: ()=>onClick()
    }, (0, $1Hdcz.h)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "14",
        height: "14",
        viewBox: "0 0 14 14"
    }, (0, $1Hdcz.h)("g", {
        fillRule: "evenodd"
    }, (0, $1Hdcz.h)("path", {
        d: "M1.5 10.793h2.793A1 1 0 0 0 5 10.5L11.5 4a1 1 0 0 0 0-1.414L9.707.793a1 1 0 0 0-1.414 0l-6.5 6.5A1 1 0 0 0 1.5 8v2.793zm1-1V8L9 1.5l1.793 1.793-6.5 6.5H2.5z",
        fillRule: "nonzero"
    }), (0, $1Hdcz.h)("rect", {
        x: "1",
        y: "12.293",
        width: "11",
        height: "1",
        rx: ".5"
    }), (0, $1Hdcz.h)("path", {
        fillRule: "nonzero",
        d: "M6.793 2.5L9.5 5.207l.707-.707L7.5 1.793z"
    }))));
    return null;
}
function $2ab4ff65ab5dbb90$var$RemoveButton(_ref2) {
    let { i18n: i18n, onClick: onClick, file: file } = _ref2;
    return (0, $1Hdcz.h)("button", {
        className: "uppy-u-reset uppy-Dashboard-Item-action uppy-Dashboard-Item-action--remove",
        type: "button",
        "aria-label": i18n("removeFile", {
            file: file.meta.name
        }),
        title: i18n("removeFile", {
            file: file.meta.name
        }),
        onClick: ()=>onClick()
    }, (0, $1Hdcz.h)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "18",
        height: "18",
        viewBox: "0 0 18 18"
    }, (0, $1Hdcz.h)("path", {
        d: "M9 0C4.034 0 0 4.034 0 9s4.034 9 9 9 9-4.034 9-9-4.034-9-9-9z"
    }), (0, $1Hdcz.h)("path", {
        fill: "#FFF",
        d: "M13 12.222l-.778.778L9 9.778 5.778 13 5 12.222 8.222 9 5 5.778 5.778 5 9 8.222 12.222 5l.778.778L9.778 9z"
    })));
}
const $2ab4ff65ab5dbb90$var$copyLinkToClipboard = (event, props)=>{
    $9PMdo(props.file.uploadURL, props.i18n("copyLinkToClipboardFallback")).then(()=>{
        props.uppy.log("Link copied to clipboard.");
        props.uppy.info(props.i18n("copyLinkToClipboardSuccess"), "info", 3000);
    }).catch(props.uppy.log) // avoid losing focus
    .then(()=>event.target.focus({
            preventScroll: true
        }));
};
function $2ab4ff65ab5dbb90$var$CopyLinkButton(props) {
    const { i18n: i18n } = props;
    return (0, $1Hdcz.h)("button", {
        className: "uppy-u-reset uppy-Dashboard-Item-action uppy-Dashboard-Item-action--copyLink",
        type: "button",
        "aria-label": i18n("copyLink"),
        title: i18n("copyLink"),
        onClick: (event)=>$2ab4ff65ab5dbb90$var$copyLinkToClipboard(event, props)
    }, (0, $1Hdcz.h)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "14",
        height: "14",
        viewBox: "0 0 14 12"
    }, (0, $1Hdcz.h)("path", {
        d: "M7.94 7.703a2.613 2.613 0 0 1-.626 2.681l-.852.851a2.597 2.597 0 0 1-1.849.766A2.616 2.616 0 0 1 2.764 7.54l.852-.852a2.596 2.596 0 0 1 2.69-.625L5.267 7.099a1.44 1.44 0 0 0-.833.407l-.852.851a1.458 1.458 0 0 0 1.03 2.486c.39 0 .755-.152 1.03-.426l.852-.852c.231-.231.363-.522.406-.824l1.04-1.038zm4.295-5.937A2.596 2.596 0 0 0 10.387 1c-.698 0-1.355.272-1.849.766l-.852.851a2.614 2.614 0 0 0-.624 2.688l1.036-1.036c.041-.304.173-.6.407-.833l.852-.852c.275-.275.64-.426 1.03-.426a1.458 1.458 0 0 1 1.03 2.486l-.852.851a1.442 1.442 0 0 1-.824.406l-1.04 1.04a2.596 2.596 0 0 0 2.683-.628l.851-.85a2.616 2.616 0 0 0 0-3.697zm-6.88 6.883a.577.577 0 0 0 .82 0l3.474-3.474a.579.579 0 1 0-.819-.82L5.355 7.83a.579.579 0 0 0 0 .819z"
    })));
}
function $2ab4ff65ab5dbb90$var$Buttons(props) {
    const { uppy: uppy, file: file, uploadInProgressOrComplete: uploadInProgressOrComplete, canEditFile: canEditFile, metaFields: metaFields, showLinkToFileUploadResult: showLinkToFileUploadResult, showRemoveButton: showRemoveButton, i18n: i18n, toggleFileCard: toggleFileCard, openFileEditor: openFileEditor } = props;
    const editAction = ()=>{
        if (metaFields && metaFields.length > 0) toggleFileCard(true, file.id);
        else openFileEditor(file);
    };
    return (0, $1Hdcz.h)("div", {
        className: "uppy-Dashboard-Item-actionWrapper"
    }, (0, $1Hdcz.h)($2ab4ff65ab5dbb90$var$EditButton, {
        i18n: i18n,
        file: file,
        uploadInProgressOrComplete: uploadInProgressOrComplete,
        canEditFile: canEditFile,
        metaFields: metaFields,
        onClick: editAction
    }), showLinkToFileUploadResult && file.uploadURL ? (0, $1Hdcz.h)($2ab4ff65ab5dbb90$var$CopyLinkButton, {
        file: file,
        uppy: uppy,
        i18n: i18n
    }) : null, showRemoveButton ? (0, $1Hdcz.h)($2ab4ff65ab5dbb90$var$RemoveButton, {
        i18n: i18n,
        file: file,
        uppy: uppy,
        onClick: ()=>props.uppy.removeFile(file.id, "removed-by-user")
    }) : null);
}
module.exports = $2ab4ff65ab5dbb90$var$Buttons;

});
parcelRegister("9PMdo", function(module, exports) {
"use strict";
function $728e46fd5a5f4d4e$var$copyToClipboard(textToCopy, fallbackString) {
    // TODO: make `fallbackString` an optional parameter instead.
    fallbackString || (fallbackString = "Copy the URL below"); // eslint-disable-line no-param-reassign
    return new Promise((resolve)=>{
        const textArea = document.createElement("textarea");
        textArea.setAttribute("style", {
            position: "fixed",
            top: 0,
            left: 0,
            width: "2em",
            height: "2em",
            padding: 0,
            border: "none",
            outline: "none",
            boxShadow: "none",
            background: "transparent"
        });
        textArea.value = textToCopy;
        document.body.appendChild(textArea);
        textArea.select();
        const magicCopyFailed = ()=>{
            document.body.removeChild(textArea); // eslint-disable-next-line no-alert
            window.prompt(fallbackString, textToCopy);
            resolve();
        };
        try {
            const successful = document.execCommand("copy");
            if (!successful) return magicCopyFailed("copy command unavailable");
            document.body.removeChild(textArea);
            return resolve();
        } catch (err) {
            document.body.removeChild(textArea);
            return magicCopyFailed(err);
        }
    });
}
/**
 * Copies text to clipboard by creating an almost invisible textarea,
 * adding text there, then running execCommand('copy').
 * Falls back to prompt() when the easy way fails (hello, Safari!)
 * From http://stackoverflow.com/a/30810322
 *
 * @param {string} textToCopy
 * @param {string} fallbackString
 * @returns {Promise}
 */ module.exports = $728e46fd5a5f4d4e$var$copyToClipboard;

});



parcelRegister("5SLrA", function(module, exports) {
"use strict";

var $1Hdcz = parcelRequire("1Hdcz");
function $4486cc465549c724$var$_extends() {
    $4486cc465549c724$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4486cc465549c724$var$_extends.apply(this, arguments);
}
const $4486cc465549c724$var$STYLE_INNER = {
    position: "relative",
    // Disabled for our use case: the wrapper elements around FileList already deal with overflow,
    // and this additional property would hide things that we want to show.
    //
    // overflow: 'hidden',
    width: "100%",
    minHeight: "100%"
};
const $4486cc465549c724$var$STYLE_CONTENT = {
    position: "absolute",
    top: 0,
    left: 0,
    // Because the `top` value gets set to some offset, this `height` being 100% would make the scrollbar
    // stretch far beyond the content. For our use case, the content div actually can get its height from
    // the elements inside it, so we don't need to specify a `height` property at all.
    //
    // height: '100%',
    width: "100%",
    overflow: "visible"
};
class $4486cc465549c724$var$VirtualList extends $1Hdcz.Component {
    constructor(props){
        super(props); // The currently focused node, used to retain focus when the visible rows change.
        // To avoid update loops, this should not cause state updates, so it's kept as a plain property.
        this.handleScroll = ()=>{
            this.setState({
                offset: this.base.scrollTop
            });
        };
        this.handleResize = ()=>{
            this.resize();
        };
        this.focusElement = null;
        this.state = {
            offset: 0,
            height: 0
        };
    }
    componentDidMount() {
        this.resize();
        window.addEventListener("resize", this.handleResize);
    }
    // eslint-disable-next-line
    componentWillUpdate() {
        if (this.base.contains(document.activeElement)) this.focusElement = document.activeElement;
    }
    componentDidUpdate() {
        // Maintain focus when rows are added and removed.
        if (this.focusElement && this.focusElement.parentNode && document.activeElement !== this.focusElement) this.focusElement.focus();
        this.focusElement = null;
        this.resize();
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }
    resize() {
        const { height: height } = this.state;
        if (height !== this.base.offsetHeight) this.setState({
            height: this.base.offsetHeight
        });
    }
    render(_ref) {
        let { data: data, rowHeight: rowHeight, renderRow: renderRow, overscanCount: overscanCount = 10, ...props } = _ref;
        const { offset: offset, height: height } = this.state; // first visible row index
        let start = Math.floor(offset / rowHeight); // actual number of visible rows (without overscan)
        let visibleRowCount = Math.floor(height / rowHeight); // Overscan: render blocks of rows modulo an overscan row count
        // This dramatically reduces DOM writes during scrolling
        if (overscanCount) {
            start = Math.max(0, start - start % overscanCount);
            visibleRowCount += overscanCount;
        } // last visible + overscan row index + padding to allow keyboard focus to travel past the visible area
        const end = start + visibleRowCount + 4; // data slice currently in viewport plus overscan items
        const selection = data.slice(start, end);
        const styleInner = {
            ...$4486cc465549c724$var$STYLE_INNER,
            height: data.length * rowHeight
        };
        const styleContent = {
            ...$4486cc465549c724$var$STYLE_CONTENT,
            top: start * rowHeight
        }; // The `role="presentation"` attributes ensure that these wrapper elements are not treated as list
        // items by accessibility and outline tools.
        return (0, $1Hdcz.h)("div", $4486cc465549c724$var$_extends({
            onScroll: this.handleScroll
        }, props), (0, $1Hdcz.h)("div", {
            role: "presentation",
            style: styleInner
        }, (0, $1Hdcz.h)("div", {
            role: "presentation",
            style: styleContent
        }, selection.map(renderRow))));
    }
}
module.exports = $4486cc465549c724$var$VirtualList;

});


parcelRegister("epRDz", function(module, exports) {
"use strict";

var $1Hdcz = parcelRequire("1Hdcz");
let $a7ed01b478cdd9e2$var$_Symbol$for;
$a7ed01b478cdd9e2$var$_Symbol$for = Symbol.for("uppy test: disable unused locale key warning");
class $a7ed01b478cdd9e2$var$AddFiles extends $1Hdcz.Component {
    constructor(){
        super(...arguments);
        this.triggerFileInputClick = ()=>{
            this.fileInput.click();
        };
        this.triggerFolderInputClick = ()=>{
            this.folderInput.click();
        };
        this.onFileInputChange = (event)=>{
            this.props.handleInputChange(event); // We clear the input after a file is selected, because otherwise
            // change event is not fired in Chrome and Safari when a file
            // with the same name is selected.
            // ___Why not use value="" on <input/> instead?
            //    Because if we use that method of clearing the input,
            //    Chrome will not trigger change if we drop the same file twice (Issue #768).
            event.target.value = null; // eslint-disable-line no-param-reassign
        };
        this.renderHiddenInput = (isFolder, refCallback)=>{
            return (0, $1Hdcz.h)("input", {
                className: "uppy-Dashboard-input",
                hidden: true,
                "aria-hidden": "true",
                tabIndex: -1,
                webkitdirectory: isFolder,
                type: "file",
                name: "files[]",
                multiple: this.props.maxNumberOfFiles !== 1,
                onChange: this.onFileInputChange,
                accept: this.props.allowedFileTypes,
                ref: refCallback
            });
        };
        this.renderMyDeviceAcquirer = ()=>{
            return (0, $1Hdcz.h)("div", {
                className: "uppy-DashboardTab",
                role: "presentation",
                "data-uppy-acquirer-id": "MyDevice"
            }, (0, $1Hdcz.h)("button", {
                type: "button",
                className: "uppy-u-reset uppy-c-btn uppy-DashboardTab-btn",
                role: "tab",
                tabIndex: 0,
                "data-uppy-super-focusable": true,
                onClick: this.triggerFileInputClick
            }, (0, $1Hdcz.h)("svg", {
                "aria-hidden": "true",
                focusable: "false",
                width: "32",
                height: "32",
                viewBox: "0 0 32 32"
            }, (0, $1Hdcz.h)("g", {
                fill: "none",
                fillRule: "evenodd"
            }, (0, $1Hdcz.h)("rect", {
                className: "uppy-ProviderIconBg",
                width: "32",
                height: "32",
                rx: "16",
                fill: "#2275D7"
            }), (0, $1Hdcz.h)("path", {
                d: "M21.973 21.152H9.863l-1.108-5.087h14.464l-1.246 5.087zM9.935 11.37h3.958l.886 1.444a.673.673 0 0 0 .585.316h6.506v1.37H9.935v-3.13zm14.898 3.44a.793.793 0 0 0-.616-.31h-.978v-2.126c0-.379-.275-.613-.653-.613H15.75l-.886-1.445a.673.673 0 0 0-.585-.316H9.232c-.378 0-.667.209-.667.587V14.5h-.782a.793.793 0 0 0-.61.303.795.795 0 0 0-.155.663l1.45 6.633c.078.36.396.618.764.618h13.354c.36 0 .674-.246.76-.595l1.631-6.636a.795.795 0 0 0-.144-.675z",
                fill: "#FFF"
            }))), (0, $1Hdcz.h)("div", {
                className: "uppy-DashboardTab-name"
            }, this.props.i18n("myDevice"))));
        };
        this.renderBrowseButton = (text, onClickFn)=>{
            const numberOfAcquirers = this.props.acquirers.length;
            return (0, $1Hdcz.h)("button", {
                type: "button",
                className: "uppy-u-reset uppy-Dashboard-browse",
                onClick: onClickFn,
                "data-uppy-super-focusable": numberOfAcquirers === 0
            }, text);
        };
        this.renderDropPasteBrowseTagline = ()=>{
            const numberOfAcquirers = this.props.acquirers.length;
            const browseFiles = this.renderBrowseButton(this.props.i18n("browseFiles"), this.triggerFileInputClick);
            const browseFolders = this.renderBrowseButton(this.props.i18n("browseFolders"), this.triggerFolderInputClick); // in order to keep the i18n CamelCase and options lower (as are defaults) we will want to transform a lower
            // to Camel
            const lowerFMSelectionType = this.props.fileManagerSelectionType;
            const camelFMSelectionType = lowerFMSelectionType.charAt(0).toUpperCase() + lowerFMSelectionType.slice(1);
            return (0, $1Hdcz.h)("div", {
                class: "uppy-Dashboard-AddFiles-title"
            }, this.props.disableLocalFiles ? this.props.i18n("importFiles") : numberOfAcquirers > 0 ? this.props.i18nArray(`dropPasteImport${camelFMSelectionType}`, {
                browseFiles: browseFiles,
                browseFolders: browseFolders,
                browse: browseFiles
            }) : this.props.i18nArray(`dropPaste${camelFMSelectionType}`, {
                browseFiles: browseFiles,
                browseFolders: browseFolders,
                browse: browseFiles
            }));
        };
        this.renderAcquirer = (acquirer)=>{
            return (0, $1Hdcz.h)("div", {
                className: "uppy-DashboardTab",
                role: "presentation",
                "data-uppy-acquirer-id": acquirer.id
            }, (0, $1Hdcz.h)("button", {
                type: "button",
                className: "uppy-u-reset uppy-c-btn uppy-DashboardTab-btn",
                role: "tab",
                tabIndex: 0,
                "data-cy": acquirer.id,
                "aria-controls": `uppy-DashboardContent-panel--${acquirer.id}`,
                "aria-selected": this.props.activePickerPanel.id === acquirer.id,
                "data-uppy-super-focusable": true,
                onClick: ()=>this.props.showPanel(acquirer.id)
            }, acquirer.icon(), (0, $1Hdcz.h)("div", {
                className: "uppy-DashboardTab-name"
            }, acquirer.name)));
        };
        this.renderAcquirers = (acquirers, disableLocalFiles)=>{
            // Group last two buttons, so we don’t end up with
            // just one button on a new line
            const acquirersWithoutLastTwo = [
                ...acquirers
            ];
            const lastTwoAcquirers = acquirersWithoutLastTwo.splice(acquirers.length - 2, acquirers.length);
            return (0, $1Hdcz.h)("div", {
                className: "uppy-Dashboard-AddFiles-list",
                role: "tablist"
            }, !disableLocalFiles && this.renderMyDeviceAcquirer(), acquirersWithoutLastTwo.map((acquirer)=>this.renderAcquirer(acquirer)), (0, $1Hdcz.h)("span", {
                role: "presentation",
                style: {
                    "white-space": "nowrap"
                }
            }, lastTwoAcquirers.map((acquirer)=>this.renderAcquirer(acquirer))));
        };
    }
    [$a7ed01b478cdd9e2$var$_Symbol$for]() {
        // Those are actually used in `renderDropPasteBrowseTagline` method.
        this.props.i18nArray("dropPasteBoth");
        this.props.i18nArray("dropPasteFiles");
        this.props.i18nArray("dropPasteFolders");
        this.props.i18nArray("dropPasteImportBoth");
        this.props.i18nArray("dropPasteImportFiles");
        this.props.i18nArray("dropPasteImportFolders");
    }
    renderPoweredByUppy() {
        const { i18nArray: i18nArray } = this.props;
        const uppyBranding = (0, $1Hdcz.h)("span", null, (0, $1Hdcz.h)("svg", {
            "aria-hidden": "true",
            focusable: "false",
            className: "uppy-c-icon uppy-Dashboard-poweredByIcon",
            width: "11",
            height: "11",
            viewBox: "0 0 11 11"
        }, (0, $1Hdcz.h)("path", {
            d: "M7.365 10.5l-.01-4.045h2.612L5.5.806l-4.467 5.65h2.604l.01 4.044h3.718z",
            fillRule: "evenodd"
        })), (0, $1Hdcz.h)("span", {
            className: "uppy-Dashboard-poweredByUppy"
        }, "Uppy"));
        const linkText = i18nArray("poweredBy", {
            uppy: uppyBranding
        });
        return (0, $1Hdcz.h)("a", {
            tabIndex: "-1",
            href: "https://uppy.io",
            rel: "noreferrer noopener",
            target: "_blank",
            className: "uppy-Dashboard-poweredBy"
        }, linkText);
    }
    render() {
        return (0, $1Hdcz.h)("div", {
            className: "uppy-Dashboard-AddFiles"
        }, this.renderHiddenInput(false, (ref)=>{
            this.fileInput = ref;
        }), this.renderHiddenInput(true, (ref)=>{
            this.folderInput = ref;
        }), this.renderDropPasteBrowseTagline(), this.props.acquirers.length > 0 && this.renderAcquirers(this.props.acquirers, this.props.disableLocalFiles), (0, $1Hdcz.h)("div", {
            className: "uppy-Dashboard-AddFiles-info"
        }, this.props.note && (0, $1Hdcz.h)("div", {
            className: "uppy-Dashboard-note"
        }, this.props.note), this.props.proudlyDisplayPoweredByUppy && this.renderPoweredByUppy(this.props)));
    }
}
module.exports = $a7ed01b478cdd9e2$var$AddFiles;

});

parcelRegister("a40Np", function(module, exports) {
"use strict";

var $1Hdcz = parcelRequire("1Hdcz");

var $8g1PZ = parcelRequire("8g1PZ");

var $epRDz = parcelRequire("epRDz");
const $753ae522cdcbf8d2$var$AddFilesPanel = (props)=>{
    return (0, $1Hdcz.h)("div", {
        className: $8g1PZ("uppy-Dashboard-AddFilesPanel", props.className),
        "data-uppy-panelType": "AddFiles",
        "aria-hidden": props.showAddFilesPanel
    }, (0, $1Hdcz.h)("div", {
        className: "uppy-DashboardContent-bar"
    }, (0, $1Hdcz.h)("div", {
        className: "uppy-DashboardContent-title",
        role: "heading",
        "aria-level": "1"
    }, props.i18n("addingMoreFiles")), (0, $1Hdcz.h)("button", {
        className: "uppy-DashboardContent-back",
        type: "button",
        onClick: ()=>props.toggleAddFilesPanel(false)
    }, props.i18n("back"))), (0, $1Hdcz.h)($epRDz, props));
};
module.exports = $753ae522cdcbf8d2$var$AddFilesPanel;

});

parcelRegister("cBaYe", function(module, exports) {
"use strict";

var $1Hdcz = parcelRequire("1Hdcz");

var $8g1PZ = parcelRequire("8g1PZ");

var $5HOiS = parcelRequire("5HOiS");
function $92c1733beaf31ee8$var$PickerPanelContent(_ref) {
    let { activePickerPanel: activePickerPanel, className: className, hideAllPanels: hideAllPanels, i18n: i18n, state: state, uppy: uppy } = _ref;
    return (0, $1Hdcz.h)("div", {
        className: $8g1PZ("uppy-DashboardContent-panel", className),
        role: "tabpanel",
        "data-uppy-panelType": "PickerPanel",
        id: `uppy-DashboardContent-panel--${activePickerPanel.id}`,
        onDragOver: $5HOiS,
        onDragLeave: $5HOiS,
        onDrop: $5HOiS,
        onPaste: $5HOiS
    }, (0, $1Hdcz.h)("div", {
        className: "uppy-DashboardContent-bar"
    }, (0, $1Hdcz.h)("div", {
        className: "uppy-DashboardContent-title",
        role: "heading",
        "aria-level": "1"
    }, i18n("importFrom", {
        name: activePickerPanel.name
    })), (0, $1Hdcz.h)("button", {
        className: "uppy-DashboardContent-back",
        type: "button",
        onClick: hideAllPanels
    }, i18n("cancel"))), (0, $1Hdcz.h)("div", {
        className: "uppy-DashboardContent-panelBody"
    }, uppy.getPlugin(activePickerPanel.id).render(state)));
}
module.exports = $92c1733beaf31ee8$var$PickerPanelContent;

});
parcelRegister("5HOiS", function(module, exports) {
"use strict";
// ignore drop/paste events if they are not in input or textarea —
// otherwise when Url plugin adds drop/paste listeners to this.el,
// draging UI elements or pasting anything into any field triggers those events —
// Url treats them as URLs that need to be imported
function $4277fd210e3af627$var$ignoreEvent(ev) {
    const { tagName: tagName } = ev.target;
    if (tagName === "INPUT" || tagName === "TEXTAREA") {
        ev.stopPropagation();
        return;
    }
    ev.preventDefault();
    ev.stopPropagation();
}
module.exports = $4277fd210e3af627$var$ignoreEvent;

});


parcelRegister("8kMTA", function(module, exports) {
"use strict";

var $1Hdcz = parcelRequire("1Hdcz");

var $8g1PZ = parcelRequire("8g1PZ");
function $61161ea14189e0dc$var$EditorPanel(props) {
    const file = props.files[props.fileCardFor];
    return (0, $1Hdcz.h)("div", {
        className: $8g1PZ("uppy-DashboardContent-panel", props.className),
        role: "tabpanel",
        "data-uppy-panelType": "FileEditor",
        id: "uppy-DashboardContent-panel--editor"
    }, (0, $1Hdcz.h)("div", {
        className: "uppy-DashboardContent-bar"
    }, (0, $1Hdcz.h)("div", {
        className: "uppy-DashboardContent-title",
        role: "heading",
        "aria-level": "1"
    }, props.i18nArray("editing", {
        file: (0, $1Hdcz.h)("span", {
            className: "uppy-DashboardContent-titleFile"
        }, file.meta ? file.meta.name : file.name)
    })), (0, $1Hdcz.h)("button", {
        className: "uppy-DashboardContent-back",
        type: "button",
        onClick: props.hideAllPanels
    }, props.i18n("cancel")), (0, $1Hdcz.h)("button", {
        className: "uppy-DashboardContent-save",
        type: "button",
        onClick: props.saveFileEditor
    }, props.i18n("save"))), (0, $1Hdcz.h)("div", {
        className: "uppy-DashboardContent-panelBody"
    }, props.editors.map((target)=>{
        return props.uppy.getPlugin(target.id).render(props.state);
    })));
}
module.exports = $61161ea14189e0dc$var$EditorPanel;

});

parcelRegister("dXjtP", function(module, exports) {
"use strict";

var $1Hdcz = parcelRequire("1Hdcz");
const $a28fe55fc13376e0$var$uploadStates = {
    STATE_ERROR: "error",
    STATE_WAITING: "waiting",
    STATE_PREPROCESSING: "preprocessing",
    STATE_UPLOADING: "uploading",
    STATE_POSTPROCESSING: "postprocessing",
    STATE_COMPLETE: "complete",
    STATE_PAUSED: "paused"
};
function $a28fe55fc13376e0$var$getUploadingState(isAllErrored, isAllComplete, isAllPaused, files) {
    if (files === void 0) files = {};
    if (isAllErrored) return $a28fe55fc13376e0$var$uploadStates.STATE_ERROR;
    if (isAllComplete) return $a28fe55fc13376e0$var$uploadStates.STATE_COMPLETE;
    if (isAllPaused) return $a28fe55fc13376e0$var$uploadStates.STATE_PAUSED;
    let state = $a28fe55fc13376e0$var$uploadStates.STATE_WAITING;
    const fileIDs = Object.keys(files);
    for(let i = 0; i < fileIDs.length; i++){
        const { progress: progress } = files[fileIDs[i]]; // If ANY files are being uploaded right now, show the uploading state.
        if (progress.uploadStarted && !progress.uploadComplete) return $a28fe55fc13376e0$var$uploadStates.STATE_UPLOADING;
         // If files are being preprocessed AND postprocessed at this time, we show the
        // preprocess state. If any files are being uploaded we show uploading.
        if (progress.preprocess && state !== $a28fe55fc13376e0$var$uploadStates.STATE_UPLOADING) state = $a28fe55fc13376e0$var$uploadStates.STATE_PREPROCESSING;
         // If NO files are being preprocessed or uploaded right now, but some files are
        // being postprocessed, show the postprocess state.
        if (progress.postprocess && state !== $a28fe55fc13376e0$var$uploadStates.STATE_UPLOADING && state !== $a28fe55fc13376e0$var$uploadStates.STATE_PREPROCESSING) state = $a28fe55fc13376e0$var$uploadStates.STATE_POSTPROCESSING;
    }
    return state;
}
function $a28fe55fc13376e0$var$UploadStatus(_ref) {
    let { files: files, i18n: i18n, isAllComplete: isAllComplete, isAllErrored: isAllErrored, isAllPaused: isAllPaused, inProgressNotPausedFiles: inProgressNotPausedFiles, newFiles: newFiles, processingFiles: processingFiles } = _ref;
    const uploadingState = $a28fe55fc13376e0$var$getUploadingState(isAllErrored, isAllComplete, isAllPaused, files);
    switch(uploadingState){
        case "uploading":
            return i18n("uploadingXFiles", {
                smart_count: inProgressNotPausedFiles.length
            });
        case "preprocessing":
        case "postprocessing":
            return i18n("processingXFiles", {
                smart_count: processingFiles.length
            });
        case "paused":
            return i18n("uploadPaused");
        case "waiting":
            return i18n("xFilesSelected", {
                smart_count: newFiles.length
            });
        case "complete":
            return i18n("uploadComplete");
        default:
    }
}
function $a28fe55fc13376e0$var$PanelTopBar(props) {
    const { i18n: i18n, isAllComplete: isAllComplete, hideCancelButton: hideCancelButton, maxNumberOfFiles: maxNumberOfFiles, toggleAddFilesPanel: toggleAddFilesPanel, uppy: uppy } = props;
    let { allowNewUpload: allowNewUpload } = props; // TODO maybe this should be done in ../Dashboard.jsx, then just pass that down as `allowNewUpload`
    if (allowNewUpload && maxNumberOfFiles) // eslint-disable-next-line react/destructuring-assignment
    allowNewUpload = props.totalFileCount < props.maxNumberOfFiles;
    return (0, $1Hdcz.h)("div", {
        className: "uppy-DashboardContent-bar"
    }, !isAllComplete && !hideCancelButton ? (0, $1Hdcz.h)("button", {
        className: "uppy-DashboardContent-back",
        type: "button",
        onClick: ()=>uppy.cancelAll()
    }, i18n("cancel")) : (0, $1Hdcz.h)("div", null), (0, $1Hdcz.h)("div", {
        className: "uppy-DashboardContent-title",
        role: "heading",
        "aria-level": "1"
    }, (0, $1Hdcz.h)($a28fe55fc13376e0$var$UploadStatus, props)), allowNewUpload ? (0, $1Hdcz.h)("button", {
        className: "uppy-DashboardContent-addMore",
        type: "button",
        "aria-label": i18n("addMoreFiles"),
        title: i18n("addMoreFiles"),
        onClick: ()=>toggleAddFilesPanel(true)
    }, (0, $1Hdcz.h)("svg", {
        "aria-hidden": "true",
        focusable: "false",
        className: "uppy-c-icon",
        width: "15",
        height: "15",
        viewBox: "0 0 15 15"
    }, (0, $1Hdcz.h)("path", {
        d: "M8 6.5h6a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5H8v6a.5.5 0 0 1-.5.5H7a.5.5 0 0 1-.5-.5V8h-6a.5.5 0 0 1-.5-.5V7a.5.5 0 0 1 .5-.5h6v-6A.5.5 0 0 1 7 0h.5a.5.5 0 0 1 .5.5v6z"
    })), (0, $1Hdcz.h)("span", {
        className: "uppy-DashboardContent-addMoreCaption"
    }, i18n("addMore"))) : (0, $1Hdcz.h)("div", null));
}
module.exports = $a28fe55fc13376e0$var$PanelTopBar;

});

parcelRegister("196Bx", function(module, exports) {
"use strict";

var $1Hdcz = parcelRequire("1Hdcz");

var $4Kuwt = parcelRequire("4Kuwt");

var $8g1PZ = parcelRequire("8g1PZ");

var $ksZSi = parcelRequire("ksZSi");

var $5HOiS = parcelRequire("5HOiS");

var $4KEB8 = parcelRequire("4KEB8");
class $0d5bc1350a3b3a33$var$FileCard extends $1Hdcz.Component {
    constructor(props){
        super(props);
        this.form = document.createElement("form");
        this.updateMeta = (newVal, name)=>{
            this.setState((_ref)=>{
                let { formState: formState } = _ref;
                return {
                    formState: {
                        ...formState,
                        [name]: newVal
                    }
                };
            });
        };
        this.handleSave = (e)=>{
            e.preventDefault();
            const fileID = this.props.fileCardFor;
            this.props.saveFileCard(this.state.formState, fileID);
        };
        this.handleCancel = ()=>{
            const file = this.props.files[this.props.fileCardFor];
            this.props.uppy.emit("file-editor:cancel", file);
            this.props.toggleFileCard(false);
        };
        this.saveOnEnter = (ev)=>{
            if (ev.keyCode === 13) {
                ev.stopPropagation();
                ev.preventDefault();
                const file = this.props.files[this.props.fileCardFor];
                this.props.saveFileCard(this.state.formState, file.id);
            }
        };
        this.renderMetaFields = ()=>{
            const metaFields = this.getMetaFields() || [];
            const fieldCSSClasses = {
                text: "uppy-u-reset uppy-c-textInput uppy-Dashboard-FileCard-input"
            };
            return metaFields.map((field)=>{
                const id = `uppy-Dashboard-FileCard-input-${field.id}`;
                const required = this.props.requiredMetaFields.includes(field.id);
                return (0, $1Hdcz.h)("fieldset", {
                    key: field.id,
                    className: "uppy-Dashboard-FileCard-fieldset"
                }, (0, $1Hdcz.h)("label", {
                    className: "uppy-Dashboard-FileCard-label",
                    htmlFor: id
                }, field.name), field.render !== undefined ? field.render({
                    value: this.state.formState[field.id],
                    onChange: (newVal)=>this.updateMeta(newVal, field.id),
                    fieldCSSClasses: fieldCSSClasses,
                    required: required,
                    form: this.form.id
                }, $1Hdcz.h) : (0, $1Hdcz.h)("input", {
                    className: fieldCSSClasses.text,
                    id: id,
                    form: this.form.id,
                    type: field.type || "text",
                    required: required,
                    value: this.state.formState[field.id],
                    placeholder: field.placeholder // If `form` attribute is not supported, we need to capture pressing Enter to avoid bubbling in case Uppy is
                    ,
                    onKeyUp: "form" in HTMLInputElement.prototype ? undefined : this.saveOnEnter,
                    onKeyDown: "form" in HTMLInputElement.prototype ? undefined : this.saveOnEnter,
                    onKeyPress: "form" in HTMLInputElement.prototype ? undefined : this.saveOnEnter,
                    onInput: (ev)=>this.updateMeta(ev.target.value, field.id),
                    "data-uppy-super-focusable": true
                }));
            });
        };
        const _file = this.props.files[this.props.fileCardFor];
        const _metaFields = this.getMetaFields() || [];
        const storedMetaData = {};
        _metaFields.forEach((field)=>{
            storedMetaData[field.id] = _file.meta[field.id] || "";
        });
        this.state = {
            formState: storedMetaData
        };
        this.form.id = (0, $4Kuwt.nanoid)();
    }
    componentWillMount() {
        // eslint-disable-line react/no-deprecated
        this.form.addEventListener("submit", this.handleSave);
        document.body.appendChild(this.form);
    }
    componentWillUnmount() {
        this.form.removeEventListener("submit", this.handleSave);
        document.body.removeChild(this.form);
    }
    getMetaFields() {
        return typeof this.props.metaFields === "function" ? this.props.metaFields(this.props.files[this.props.fileCardFor]) : this.props.metaFields;
    }
    render() {
        const file = this.props.files[this.props.fileCardFor];
        const showEditButton = this.props.canEditFile(file);
        return (0, $1Hdcz.h)("div", {
            className: $8g1PZ("uppy-Dashboard-FileCard", this.props.className),
            "data-uppy-panelType": "FileCard",
            onDragOver: $5HOiS,
            onDragLeave: $5HOiS,
            onDrop: $5HOiS,
            onPaste: $5HOiS
        }, (0, $1Hdcz.h)("div", {
            className: "uppy-DashboardContent-bar"
        }, (0, $1Hdcz.h)("div", {
            className: "uppy-DashboardContent-title",
            role: "heading",
            "aria-level": "1"
        }, this.props.i18nArray("editing", {
            file: (0, $1Hdcz.h)("span", {
                className: "uppy-DashboardContent-titleFile"
            }, file.meta ? file.meta.name : file.name)
        })), (0, $1Hdcz.h)("button", {
            className: "uppy-DashboardContent-back",
            type: "button",
            form: this.form.id,
            title: this.props.i18n("finishEditingFile"),
            onClick: this.handleCancel
        }, this.props.i18n("cancel"))), (0, $1Hdcz.h)("div", {
            className: "uppy-Dashboard-FileCard-inner"
        }, (0, $1Hdcz.h)("div", {
            className: "uppy-Dashboard-FileCard-preview",
            style: {
                backgroundColor: $ksZSi(file.type).color
            }
        }, (0, $1Hdcz.h)($4KEB8, {
            file: file
        }), showEditButton && (0, $1Hdcz.h)("button", {
            type: "button",
            className: "uppy-u-reset uppy-c-btn uppy-Dashboard-FileCard-edit",
            onClick: (event)=>{
                // When opening the image editor we want to save any meta fields changes.
                // Otherwise it's confusing for the user to click save in the editor,
                // but the changes here are discarded. This bypasses validation,
                // but we are okay with that.
                this.handleSave(event);
                this.props.openFileEditor(file);
            },
            form: this.form.id
        }, this.props.i18n("editFile"))), (0, $1Hdcz.h)("div", {
            className: "uppy-Dashboard-FileCard-info"
        }, this.renderMetaFields()), (0, $1Hdcz.h)("div", {
            className: "uppy-Dashboard-FileCard-actions"
        }, (0, $1Hdcz.h)("button", {
            className: "uppy-u-reset uppy-c-btn uppy-c-btn-primary uppy-Dashboard-FileCard-actionsBtn" // If `form` attribute is supported, we want a submit button to trigger the form validation.
            ,
            type: "form" in HTMLButtonElement.prototype ? "submit" : "button",
            onClick: "form" in HTMLButtonElement.prototype ? undefined : this.handleSave,
            form: this.form.id
        }, this.props.i18n("saveChanges")), (0, $1Hdcz.h)("button", {
            className: "uppy-u-reset uppy-c-btn uppy-c-btn-link uppy-Dashboard-FileCard-actionsBtn",
            type: "button",
            onClick: this.handleCancel,
            form: this.form.id
        }, this.props.i18n("cancel")))));
    }
}
module.exports = $0d5bc1350a3b3a33$var$FileCard;

});

parcelRegister("jrD46", function(module, exports) {
"use strict";

var $1Hdcz = parcelRequire("1Hdcz");

var $8g1PZ = parcelRequire("8g1PZ");
const $e27ed77e162defea$var$transitionName = "uppy-transition-slideDownUp";
const $e27ed77e162defea$var$duration = 250;
/**
 * Vertical slide transition.
 *
 * This can take a _single_ child component, which _must_ accept a `className` prop.
 *
 * Currently this is specific to the `uppy-transition-slideDownUp` transition,
 * but it should be simple to extend this for any type of single-element
 * transition by setting the CSS name and duration as props.
 */ class $e27ed77e162defea$var$Slide extends $1Hdcz.Component {
    constructor(props){
        super(props);
        this.state = {
            cachedChildren: null,
            className: ""
        };
    }
    // eslint-disable-next-line
    componentWillUpdate(nextProps) {
        const { cachedChildren: cachedChildren } = this.state;
        const child = (0, $1Hdcz.toChildArray)(nextProps.children)[0];
        if (cachedChildren === child) return null;
        const patch = {
            cachedChildren: child
        }; // Enter transition
        if (child && !cachedChildren) {
            patch.className = `${$e27ed77e162defea$var$transitionName}-enter`;
            cancelAnimationFrame(this.animationFrame);
            clearTimeout(this.leaveTimeout);
            this.leaveTimeout = undefined;
            this.animationFrame = requestAnimationFrame(()=>{
                // Force it to render before we add the active class
                // this.base.getBoundingClientRect()
                this.setState({
                    className: `${$e27ed77e162defea$var$transitionName}-enter ${$e27ed77e162defea$var$transitionName}-enter-active`
                });
                this.enterTimeout = setTimeout(()=>{
                    this.setState({
                        className: ""
                    });
                }, $e27ed77e162defea$var$duration);
            });
        } // Leave transition
        if (cachedChildren && !child && this.leaveTimeout === undefined) {
            patch.cachedChildren = cachedChildren;
            patch.className = `${$e27ed77e162defea$var$transitionName}-leave`;
            cancelAnimationFrame(this.animationFrame);
            clearTimeout(this.enterTimeout);
            this.enterTimeout = undefined;
            this.animationFrame = requestAnimationFrame(()=>{
                this.setState({
                    className: `${$e27ed77e162defea$var$transitionName}-leave ${$e27ed77e162defea$var$transitionName}-leave-active`
                });
                this.leaveTimeout = setTimeout(()=>{
                    this.setState({
                        cachedChildren: null,
                        className: ""
                    });
                }, $e27ed77e162defea$var$duration);
            });
        } // eslint-disable-next-line
        this.setState(patch);
    }
    render() {
        const { cachedChildren: cachedChildren, className: className } = this.state;
        if (!cachedChildren) return null;
        return (0, $1Hdcz.cloneElement)(cachedChildren, {
            className: $8g1PZ(className, cachedChildren.props.className)
        });
    }
}
module.exports = $e27ed77e162defea$var$Slide;

});


parcelRegister("fW148", function(module, exports) {
"use strict";
module.exports = {
    strings: {
        // When `inline: false`, used as the screen reader label for the button that closes the modal.
        closeModal: "Close Modal",
        // Used as the screen reader label for the plus (+) button that shows the “Add more files” screen
        addMoreFiles: "Add more files",
        addingMoreFiles: "Adding more files",
        // Used as the header for import panels, e.g., “Import from Google Drive”.
        importFrom: "Import from %{name}",
        // When `inline: false`, used as the screen reader label for the dashboard modal.
        dashboardWindowTitle: "Uppy Dashboard Window (Press escape to close)",
        // When `inline: true`, used as the screen reader label for the dashboard area.
        dashboardTitle: "Uppy Dashboard",
        // Shown in the Informer when a link to a file was copied to the clipboard.
        copyLinkToClipboardSuccess: "Link copied to clipboard.",
        // Used when a link cannot be copied automatically — the user has to select the text from the
        // input element below this string.
        copyLinkToClipboardFallback: "Copy the URL below",
        // Used as the hover title and screen reader label for buttons that copy a file link.
        copyLink: "Copy link",
        back: "Back",
        // Used as the screen reader label for buttons that remove a file.
        removeFile: "Remove file",
        // Used as the screen reader label for buttons that open the metadata editor panel for a file.
        editFile: "Edit file",
        // Shown in the panel header for the metadata editor. Rendered as “Editing image.png”.
        editing: "Editing %{file}",
        // Used as the screen reader label for the button that saves metadata edits and returns to the
        // file list view.
        finishEditingFile: "Finish editing file",
        saveChanges: "Save changes",
        // Used as the label for the tab button that opens the system file selection dialog.
        myDevice: "My Device",
        dropHint: "Drop your files here",
        // Used as the hover text and screen reader label for file progress indicators when
        // they have been fully uploaded.
        uploadComplete: "Upload complete",
        uploadPaused: "Upload paused",
        // Used as the hover text and screen reader label for the buttons to resume paused uploads.
        resumeUpload: "Resume upload",
        // Used as the hover text and screen reader label for the buttons to pause uploads.
        pauseUpload: "Pause upload",
        // Used as the hover text and screen reader label for the buttons to retry failed uploads.
        retryUpload: "Retry upload",
        // Used as the hover text and screen reader label for the buttons to cancel uploads.
        cancelUpload: "Cancel upload",
        // Used in a title, how many files are currently selected
        xFilesSelected: {
            0: "%{smart_count} file selected",
            1: "%{smart_count} files selected"
        },
        uploadingXFiles: {
            0: "Uploading %{smart_count} file",
            1: "Uploading %{smart_count} files"
        },
        processingXFiles: {
            0: "Processing %{smart_count} file",
            1: "Processing %{smart_count} files"
        },
        // The "powered by Uppy" link at the bottom of the Dashboard.
        poweredBy: "Powered by %{uppy}",
        addMore: "Add more",
        editFileWithFilename: "Edit file %{file}",
        save: "Save",
        cancel: "Cancel",
        dropPasteFiles: "Drop files here or %{browseFiles}",
        dropPasteFolders: "Drop files here or %{browseFolders}",
        dropPasteBoth: "Drop files here, %{browseFiles} or %{browseFolders}",
        dropPasteImportFiles: "Drop files here, %{browseFiles} or import from:",
        dropPasteImportFolders: "Drop files here, %{browseFolders} or import from:",
        dropPasteImportBoth: "Drop files here, %{browseFiles}, %{browseFolders} or import from:",
        importFiles: "Import files from:",
        browseFiles: "browse files",
        browseFolders: "browse folders",
        recoveredXFiles: {
            0: "We could not fully recover 1 file. Please re-select it and resume the upload.",
            1: "We could not fully recover %{smart_count} files. Please re-select them and resume the upload."
        },
        recoveredAllFiles: "We restored all files. You can now resume the upload.",
        sessionRestored: "Session restored",
        reSelect: "Re-select",
        missingRequiredMetaFields: {
            0: "Missing required meta field: %{fields}.",
            1: "Missing required meta fields: %{fields}."
        }
    }
};

});


parcelRegister("9H7xy", function(module, exports) {
"use strict";

var $8jN3b = parcelRequire("8jN3b");

var $1Hdcz = parcelRequire("1Hdcz");

var $bs0mo = parcelRequire("bs0mo");

var $eHmr4 = parcelRequire("eHmr4");

var $lB5wD = parcelRequire("lB5wD");
const $70edfa877a8b4dad$var$packageJson = {
    "version": "2.1.2"
};

var $GvXio = parcelRequire("GvXio");
/**
 * Drag & Drop plugin
 *
 */ class $70edfa877a8b4dad$var$DragDrop extends $8jN3b.UIPlugin {
    constructor(uppy, opts){
        super(uppy, opts);
        this.handleDrop = async (event)=>{
            var _this$opts$onDrop, _this$opts;
            event.preventDefault();
            event.stopPropagation();
            clearTimeout(this.removeDragOverClassTimeout); // Remove dragover class
            this.setPluginState({
                isDraggingOver: false
            });
            const logDropError = (error)=>{
                this.uppy.log(error, "error");
            }; // Add all dropped files
            const files = await $lB5wD(event.dataTransfer, {
                logDropError: logDropError
            });
            if (files.length > 0) {
                this.uppy.log("[DragDrop] Files dropped");
                this.addFiles(files);
            }
            (_this$opts$onDrop = (_this$opts = this.opts).onDrop) == null || _this$opts$onDrop.call(_this$opts, event);
        };
        this.type = "acquirer";
        this.id = this.opts.id || "DragDrop";
        this.title = "Drag & Drop";
        this.defaultLocale = $GvXio; // Default options
        const defaultOpts = {
            target: null,
            inputName: "files[]",
            width: "100%",
            height: "100%",
            note: null
        }; // Merge default options with the ones set by user
        this.opts = {
            ...defaultOpts,
            ...opts
        };
        this.i18nInit(); // Check for browser dragDrop support
        this.isDragDropSupported = $eHmr4();
        this.removeDragOverClassTimeout = null; // Bind `this` to class methods
        this.onInputChange = this.onInputChange.bind(this);
        this.handleDragOver = this.handleDragOver.bind(this);
        this.handleDragLeave = this.handleDragLeave.bind(this);
        this.handleDrop = this.handleDrop.bind(this);
        this.addFiles = this.addFiles.bind(this);
        this.render = this.render.bind(this);
    }
    addFiles(files) {
        const descriptors = files.map((file)=>({
                source: this.id,
                name: file.name,
                type: file.type,
                data: file,
                meta: {
                    // path of the file relative to the ancestor directory the user selected.
                    // e.g. 'docs/Old Prague/airbnb.pdf'
                    relativePath: file.relativePath || null
                }
            }));
        try {
            this.uppy.addFiles(descriptors);
        } catch (err) {
            this.uppy.log(err);
        }
    }
    onInputChange(event) {
        const files = $bs0mo(event.target.files);
        if (files.length > 0) {
            this.uppy.log("[DragDrop] Files selected through input");
            this.addFiles(files);
        } // We clear the input after a file is selected, because otherwise
        // change event is not fired in Chrome and Safari when a file
        // with the same name is selected.
        // ___Why not use value="" on <input/> instead?
        //    Because if we use that method of clearing the input,
        //    Chrome will not trigger change if we drop the same file twice (Issue #768).
        // eslint-disable-next-line no-param-reassign
        event.target.value = null;
    }
    handleDragOver(event) {
        var _this$opts$onDragOver, _this$opts2;
        event.preventDefault();
        event.stopPropagation(); // Check if the "type" of the datatransfer object includes files. If not, deny drop.
        const { types: types } = event.dataTransfer;
        const hasFiles = types.some((type)=>type === "Files");
        const { allowNewUpload: allowNewUpload } = this.uppy.getState();
        if (!hasFiles || !allowNewUpload) {
            // eslint-disable-next-line no-param-reassign
            event.dataTransfer.dropEffect = "none";
            clearTimeout(this.removeDragOverClassTimeout);
            return;
        } // Add a small (+) icon on drop
        // (and prevent browsers from interpreting this as files being _moved_ into the browser
        // https://github.com/transloadit/uppy/issues/1978)
        //
        // eslint-disable-next-line no-param-reassign
        event.dataTransfer.dropEffect = "copy";
        clearTimeout(this.removeDragOverClassTimeout);
        this.setPluginState({
            isDraggingOver: true
        });
        (_this$opts$onDragOver = (_this$opts2 = this.opts).onDragOver) == null || _this$opts$onDragOver.call(_this$opts2, event);
    }
    handleDragLeave(event) {
        var _this$opts$onDragLeav, _this$opts3;
        event.preventDefault();
        event.stopPropagation();
        clearTimeout(this.removeDragOverClassTimeout); // Timeout against flickering, this solution is taken from drag-drop library.
        // Solution with 'pointer-events: none' didn't work across browsers.
        this.removeDragOverClassTimeout = setTimeout(()=>{
            this.setPluginState({
                isDraggingOver: false
            });
        }, 50);
        (_this$opts$onDragLeav = (_this$opts3 = this.opts).onDragLeave) == null || _this$opts$onDragLeav.call(_this$opts3, event);
    }
    renderHiddenFileInput() {
        const { restrictions: restrictions } = this.uppy.opts;
        return (0, $1Hdcz.h)("input", {
            className: "uppy-DragDrop-input",
            type: "file",
            hidden: true,
            ref: (ref)=>{
                this.fileInputRef = ref;
            },
            name: this.opts.inputName,
            multiple: restrictions.maxNumberOfFiles !== 1,
            accept: restrictions.allowedFileTypes,
            onChange: this.onInputChange
        });
    }
    static renderArrowSvg() {
        return (0, $1Hdcz.h)("svg", {
            "aria-hidden": "true",
            focusable: "false",
            className: "uppy-c-icon uppy-DragDrop-arrow",
            width: "16",
            height: "16",
            viewBox: "0 0 16 16"
        }, (0, $1Hdcz.h)("path", {
            d: "M11 10V0H5v10H2l6 6 6-6h-3zm0 0",
            fillRule: "evenodd"
        }));
    }
    renderLabel() {
        return (0, $1Hdcz.h)("div", {
            className: "uppy-DragDrop-label"
        }, this.i18nArray("dropHereOr", {
            browse: (0, $1Hdcz.h)("span", {
                className: "uppy-DragDrop-browse"
            }, this.i18n("browse"))
        }));
    }
    renderNote() {
        return (0, $1Hdcz.h)("span", {
            className: "uppy-DragDrop-note"
        }, this.opts.note);
    }
    render() {
        const dragDropClass = `uppy-u-reset
      uppy-DragDrop-container
      ${this.isDragDropSupported ? "uppy-DragDrop--isDragDropSupported" : ""}
      ${this.getPluginState().isDraggingOver ? "uppy-DragDrop--isDraggingOver" : ""}
    `;
        const dragDropStyle = {
            width: this.opts.width,
            height: this.opts.height
        };
        return (0, $1Hdcz.h)("button", {
            type: "button",
            className: dragDropClass,
            style: dragDropStyle,
            onClick: ()=>this.fileInputRef.click(),
            onDragOver: this.handleDragOver,
            onDragLeave: this.handleDragLeave,
            onDrop: this.handleDrop
        }, this.renderHiddenFileInput(), (0, $1Hdcz.h)("div", {
            className: "uppy-DragDrop-inner"
        }, $70edfa877a8b4dad$var$DragDrop.renderArrowSvg(), this.renderLabel(), this.renderNote()));
    }
    install() {
        const { target: target } = this.opts;
        this.setPluginState({
            isDraggingOver: false
        });
        if (target) this.mount(target, this);
    }
    uninstall() {
        this.unmount();
    }
}
$70edfa877a8b4dad$var$DragDrop.VERSION = $70edfa877a8b4dad$var$packageJson.version;
module.exports = $70edfa877a8b4dad$var$DragDrop;

});
parcelRegister("GvXio", function(module, exports) {
"use strict";
module.exports = {
    strings: {
        // Text to show on the droppable area.
        // `%{browse}` is replaced with a link that opens the system file selection dialog.
        dropHereOr: "Drop here or %{browse}",
        // Used as the label for the link that opens the system file selection dialog.
        browse: "browse"
    }
};

});


parcelRegister("fe7OG", function(module, exports) {
"use strict";

var $1Hdcz = parcelRequire("1Hdcz");

var $8jN3b = parcelRequire("8jN3b");
const $b15e3a031d6b95b1$var$packageJson = {
    "version": "2.1.2"
};
/**
 * Progress bar
 *
 */ class $b15e3a031d6b95b1$var$ProgressBar extends $8jN3b.UIPlugin {
    constructor(uppy, opts){
        super(uppy, opts);
        this.id = this.opts.id || "ProgressBar";
        this.title = "Progress Bar";
        this.type = "progressindicator"; // set default options
        const defaultOptions = {
            target: "body",
            fixed: false,
            hideAfterFinish: true
        }; // merge default options with the ones set by user
        this.opts = {
            ...defaultOptions,
            ...opts
        };
        this.render = this.render.bind(this);
    }
    render(state) {
        const progress = state.totalProgress || 0; // before starting and after finish should be hidden if specified in the options
        const isHidden = (progress === 0 || progress === 100) && this.opts.hideAfterFinish;
        return (0, $1Hdcz.h)("div", {
            className: "uppy uppy-ProgressBar",
            style: {
                position: this.opts.fixed ? "fixed" : "initial"
            },
            "aria-hidden": isHidden
        }, (0, $1Hdcz.h)("div", {
            className: "uppy-ProgressBar-inner",
            style: {
                width: `${progress}%`
            }
        }), (0, $1Hdcz.h)("div", {
            className: "uppy-ProgressBar-percentage"
        }, progress));
    }
    install() {
        const { target: target } = this.opts;
        if (target) this.mount(target, this);
    }
    uninstall() {
        this.unmount();
    }
}
$b15e3a031d6b95b1$var$ProgressBar.VERSION = $b15e3a031d6b95b1$var$packageJson.version;
module.exports = $b15e3a031d6b95b1$var$ProgressBar;

});

parcelRegister("jS2Ts", function(module, exports) {
"use strict";

var $8jN3b = parcelRequire("8jN3b");

var $1Hdcz = parcelRequire("1Hdcz");

var $bs0mo = parcelRequire("bs0mo");
const $e7754e0eafc80261$var$packageJson = {
    "version": "2.1.2"
};

var $Dhbt5 = parcelRequire("Dhbt5");
class $e7754e0eafc80261$var$FileInput extends $8jN3b.UIPlugin {
    constructor(uppy, opts){
        super(uppy, opts);
        this.id = this.opts.id || "FileInput";
        this.title = "File Input";
        this.type = "acquirer";
        this.defaultLocale = $Dhbt5; // Default options
        const defaultOptions = {
            target: null,
            pretty: true,
            inputName: "files[]"
        }; // Merge default options with the ones set by user
        this.opts = {
            ...defaultOptions,
            ...opts
        };
        this.i18nInit();
        this.render = this.render.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }
    addFiles(files) {
        const descriptors = files.map((file)=>({
                source: this.id,
                name: file.name,
                type: file.type,
                data: file
            }));
        try {
            this.uppy.addFiles(descriptors);
        } catch (err) {
            this.uppy.log(err);
        }
    }
    handleInputChange(event) {
        this.uppy.log("[FileInput] Something selected through input...");
        const files = $bs0mo(event.target.files);
        this.addFiles(files); // We clear the input after a file is selected, because otherwise
        // change event is not fired in Chrome and Safari when a file
        // with the same name is selected.
        // ___Why not use value="" on <input/> instead?
        //    Because if we use that method of clearing the input,
        //    Chrome will not trigger change if we drop the same file twice (Issue #768).
        event.target.value = null; // eslint-disable-line no-param-reassign
    }
    handleClick() {
        this.input.click();
    }
    render() {
        /* http://tympanus.net/codrops/2015/09/15/styling-customizing-file-inputs-smart-way/ */ const hiddenInputStyle = {
            width: "0.1px",
            height: "0.1px",
            opacity: 0,
            overflow: "hidden",
            position: "absolute",
            zIndex: -1
        };
        const { restrictions: restrictions } = this.uppy.opts;
        const accept = restrictions.allowedFileTypes ? restrictions.allowedFileTypes.join(",") : null;
        return (0, $1Hdcz.h)("div", {
            className: "uppy-FileInput-container"
        }, (0, $1Hdcz.h)("input", {
            className: "uppy-FileInput-input",
            style: this.opts.pretty && hiddenInputStyle,
            type: "file",
            name: this.opts.inputName,
            onChange: this.handleInputChange,
            multiple: restrictions.maxNumberOfFiles !== 1,
            accept: accept,
            ref: (input)=>{
                this.input = input;
            }
        }), this.opts.pretty && (0, $1Hdcz.h)("button", {
            className: "uppy-FileInput-btn",
            type: "button",
            onClick: this.handleClick
        }, this.i18n("chooseFiles")));
    }
    install() {
        const { target: target } = this.opts;
        if (target) this.mount(target, this);
    }
    uninstall() {
        this.unmount();
    }
}
$e7754e0eafc80261$var$FileInput.VERSION = $e7754e0eafc80261$var$packageJson.version;
module.exports = $e7754e0eafc80261$var$FileInput;

});
parcelRegister("Dhbt5", function(module, exports) {
"use strict";
module.exports = {
    strings: {
        // The same key is used for the same purpose by @uppy/robodog's `form()` API, but our
        // locale pack scripts can't access it in Robodog. If it is updated here, it should
        // also be updated there!
        chooseFiles: "Choose files"
    }
};

});


parcelRegister("468Vt", function(module, exports) {
"use strict";

var $8jN3b = parcelRequire("8jN3b");

var $1Hdcz = parcelRequire("1Hdcz");

var $fzqPP = parcelRequire("fzqPP");
const $2fbea57a37454e27$var$packageJson = {
    "version": "1.4.0"
};

var $sPEoj = parcelRequire("sPEoj");
class $2fbea57a37454e27$var$ImageEditor extends $8jN3b.UIPlugin {
    constructor(uppy, opts){
        super(uppy, opts);
        this.save = ()=>{
            const saveBlobCallback = (blob)=>{
                const { currentImage: currentImage } = this.getPluginState();
                this.uppy.setFileState(currentImage.id, {
                    data: blob,
                    size: blob.size,
                    preview: null
                });
                const updatedFile = this.uppy.getFile(currentImage.id);
                this.uppy.emit("thumbnail:request", updatedFile);
                this.setPluginState({
                    currentImage: updatedFile
                });
                this.uppy.emit("file-editor:complete", updatedFile);
            };
            const { currentImage: currentImage } = this.getPluginState();
            this.cropper.getCroppedCanvas(this.opts.cropperOptions.croppedCanvasOptions).toBlob(saveBlobCallback, currentImage.type, this.opts.quality);
        };
        this.storeCropperInstance = (cropper)=>{
            this.cropper = cropper;
        };
        this.selectFile = (file)=>{
            this.uppy.emit("file-editor:start", file);
            this.setPluginState({
                currentImage: file
            });
        };
        this.id = this.opts.id || "ImageEditor";
        this.title = "Image Editor";
        this.type = "editor";
        this.defaultLocale = $sPEoj;
        const defaultCropperOptions = {
            viewMode: 1,
            background: false,
            autoCropArea: 1,
            responsive: true,
            croppedCanvasOptions: {}
        };
        const defaultActions = {
            revert: true,
            rotate: true,
            granularRotate: true,
            flip: true,
            zoomIn: true,
            zoomOut: true,
            cropSquare: true,
            cropWidescreen: true,
            cropWidescreenVertical: true
        };
        const defaultOptions = {
            quality: 0.8
        };
        this.opts = {
            ...defaultOptions,
            ...opts,
            actions: {
                ...defaultActions,
                ...opts.actions
            },
            cropperOptions: {
                ...defaultCropperOptions,
                ...opts.cropperOptions
            }
        };
        this.i18nInit();
    }
    canEditFile(file) {
        if (!file.type || file.isRemote) return false;
        const fileTypeSpecific = file.type.split("/")[1];
        if (/^(jpe?g|gif|png|bmp|webp)$/.test(fileTypeSpecific)) return true;
        return false;
    }
    install() {
        this.setPluginState({
            currentImage: null
        });
        const { target: target } = this.opts;
        if (target) this.mount(target, this);
    }
    uninstall() {
        const { currentImage: currentImage } = this.getPluginState();
        const file = this.uppy.getFile(currentImage.id);
        this.uppy.emit("file-editor:cancel", file);
        this.unmount();
    }
    render() {
        const { currentImage: currentImage } = this.getPluginState();
        if (currentImage === null || currentImage.isRemote) return null;
        return (0, $1Hdcz.h)($fzqPP, {
            currentImage: currentImage,
            storeCropperInstance: this.storeCropperInstance,
            save: this.save,
            opts: this.opts,
            i18n: this.i18n
        });
    }
}
$2fbea57a37454e27$var$ImageEditor.VERSION = $2fbea57a37454e27$var$packageJson.version;
module.exports = $2fbea57a37454e27$var$ImageEditor;

});
parcelRegister("fzqPP", function(module, exports) {
"use strict";

var $1Hdcz = parcelRequire("1Hdcz");


const $b55ef0c49a09c94c$var$Cropper = (parcelRequire("avtRj")).default || (parcelRequire("avtRj"));
class $b55ef0c49a09c94c$var$Editor extends $1Hdcz.Component {
    constructor(props){
        super(props);
        this.granularRotateOnChange = (ev)=>{
            const { rotationAngle: rotationAngle, rotationDelta: rotationDelta } = this.state;
            const pendingRotationDelta = Number(ev.target.value) - rotationDelta;
            cancelAnimationFrame(this.granularRotateOnInputNextFrame);
            if (pendingRotationDelta !== 0) {
                const pendingRotationAngle = rotationAngle + pendingRotationDelta;
                this.granularRotateOnInputNextFrame = requestAnimationFrame(()=>{
                    this.cropper.rotateTo(pendingRotationAngle);
                });
            }
        };
        this.state = {
            rotationAngle: 0,
            rotationDelta: 0
        };
    }
    componentDidMount() {
        const { opts: opts, storeCropperInstance: storeCropperInstance } = this.props;
        this.cropper = new $b55ef0c49a09c94c$var$Cropper(this.imgElement, opts.cropperOptions);
        storeCropperInstance(this.cropper);
        if (opts.actions.granularRotate) this.imgElement.addEventListener("crop", (ev)=>{
            const rotationAngle = ev.detail.rotate;
            this.setState({
                rotationAngle: rotationAngle,
                // 405 == 360 + 45
                rotationDelta: (rotationAngle + 405) % 90 - 45
            });
        });
    }
    componentWillUnmount() {
        this.cropper.destroy();
    }
    renderGranularRotate() {
        const { i18n: i18n } = this.props;
        const { rotationDelta: rotationDelta, rotationAngle: rotationAngle } = this.state;
        return (0, $1Hdcz.h)("label", {
            "data-microtip-position": "top",
            role: "tooltip",
            "aria-label": `${rotationAngle}\xba`,
            className: "uppy-ImageCropper-rangeWrapper uppy-u-reset"
        }, (0, $1Hdcz.h)("input", {
            className: "uppy-ImageCropper-range uppy-u-reset",
            type: "range",
            onInput: this.granularRotateOnChange,
            onChange: this.granularRotateOnChange,
            value: rotationDelta,
            min: "-45",
            max: "44",
            "aria-label": i18n("rotate")
        }));
    }
    renderRevert() {
        const { i18n: i18n } = this.props;
        return (0, $1Hdcz.h)("button", {
            type: "button",
            className: "uppy-u-reset uppy-c-btn",
            "aria-label": i18n("revert"),
            "data-microtip-position": "top",
            onClick: ()=>{
                this.cropper.reset();
                this.cropper.setAspectRatio(0);
            }
        }, (0, $1Hdcz.h)("svg", {
            "aria-hidden": "true",
            className: "uppy-c-icon",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24"
        }, (0, $1Hdcz.h)("path", {
            d: "M0 0h24v24H0z",
            fill: "none"
        }), (0, $1Hdcz.h)("path", {
            d: "M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"
        })));
    }
    renderRotate() {
        const { i18n: i18n } = this.props;
        return (0, $1Hdcz.h)("button", {
            type: "button",
            className: "uppy-u-reset uppy-c-btn",
            onClick: ()=>this.cropper.rotate(-90),
            "aria-label": i18n("rotate"),
            "data-microtip-position": "top"
        }, (0, $1Hdcz.h)("svg", {
            "aria-hidden": "true",
            className: "uppy-c-icon",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24"
        }, (0, $1Hdcz.h)("path", {
            d: "M0 0h24v24H0V0zm0 0h24v24H0V0z",
            fill: "none"
        }), (0, $1Hdcz.h)("path", {
            d: "M14 10a2 2 0 012 2v7a2 2 0 01-2 2H6a2 2 0 01-2-2v-7a2 2 0 012-2h8zm0 1.75H6a.25.25 0 00-.243.193L5.75 12v7a.25.25 0 00.193.243L6 19.25h8a.25.25 0 00.243-.193L14.25 19v-7a.25.25 0 00-.193-.243L14 11.75zM12 .76V4c2.3 0 4.61.88 6.36 2.64a8.95 8.95 0 012.634 6.025L21 13a1 1 0 01-1.993.117L19 13h-.003a6.979 6.979 0 00-2.047-4.95 6.97 6.97 0 00-4.652-2.044L12 6v3.24L7.76 5 12 .76z"
        })));
    }
    renderFlip() {
        const { i18n: i18n } = this.props;
        return (0, $1Hdcz.h)("button", {
            type: "button",
            className: "uppy-u-reset uppy-c-btn",
            "aria-label": i18n("flipHorizontal"),
            "data-microtip-position": "top",
            onClick: ()=>this.cropper.scaleX(-this.cropper.getData().scaleX || -1)
        }, (0, $1Hdcz.h)("svg", {
            "aria-hidden": "true",
            className: "uppy-c-icon",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24"
        }, (0, $1Hdcz.h)("path", {
            d: "M0 0h24v24H0z",
            fill: "none"
        }), (0, $1Hdcz.h)("path", {
            d: "M15 21h2v-2h-2v2zm4-12h2V7h-2v2zM3 5v14c0 1.1.9 2 2 2h4v-2H5V5h4V3H5c-1.1 0-2 .9-2 2zm16-2v2h2c0-1.1-.9-2-2-2zm-8 20h2V1h-2v22zm8-6h2v-2h-2v2zM15 5h2V3h-2v2zm4 8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2z"
        })));
    }
    renderZoomIn() {
        const { i18n: i18n } = this.props;
        return (0, $1Hdcz.h)("button", {
            type: "button",
            className: "uppy-u-reset uppy-c-btn",
            "aria-label": i18n("zoomIn"),
            "data-microtip-position": "top",
            onClick: ()=>this.cropper.zoom(0.1)
        }, (0, $1Hdcz.h)("svg", {
            "aria-hidden": "true",
            className: "uppy-c-icon",
            height: "24",
            viewBox: "0 0 24 24",
            width: "24"
        }, (0, $1Hdcz.h)("path", {
            d: "M0 0h24v24H0V0z",
            fill: "none"
        }), (0, $1Hdcz.h)("path", {
            d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
        }), (0, $1Hdcz.h)("path", {
            d: "M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z"
        })));
    }
    renderZoomOut() {
        const { i18n: i18n } = this.props;
        return (0, $1Hdcz.h)("button", {
            type: "button",
            className: "uppy-u-reset uppy-c-btn",
            "aria-label": i18n("zoomOut"),
            "data-microtip-position": "top",
            onClick: ()=>this.cropper.zoom(-0.1)
        }, (0, $1Hdcz.h)("svg", {
            "aria-hidden": "true",
            className: "uppy-c-icon",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24"
        }, (0, $1Hdcz.h)("path", {
            d: "M0 0h24v24H0V0z",
            fill: "none"
        }), (0, $1Hdcz.h)("path", {
            d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7z"
        })));
    }
    renderCropSquare() {
        const { i18n: i18n } = this.props;
        return (0, $1Hdcz.h)("button", {
            type: "button",
            className: "uppy-u-reset uppy-c-btn",
            "aria-label": i18n("aspectRatioSquare"),
            "data-microtip-position": "top",
            onClick: ()=>this.cropper.setAspectRatio(1)
        }, (0, $1Hdcz.h)("svg", {
            "aria-hidden": "true",
            className: "uppy-c-icon",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24"
        }, (0, $1Hdcz.h)("path", {
            d: "M0 0h24v24H0z",
            fill: "none"
        }), (0, $1Hdcz.h)("path", {
            d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
        })));
    }
    renderCropWidescreen() {
        const { i18n: i18n } = this.props;
        return (0, $1Hdcz.h)("button", {
            type: "button",
            className: "uppy-u-reset uppy-c-btn",
            "aria-label": i18n("aspectRatioLandscape"),
            "data-microtip-position": "top",
            onClick: ()=>this.cropper.setAspectRatio(16 / 9)
        }, (0, $1Hdcz.h)("svg", {
            "aria-hidden": "true",
            className: "uppy-c-icon",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24"
        }, (0, $1Hdcz.h)("path", {
            d: "M 19,4.9999992 V 17.000001 H 4.9999998 V 6.9999992 H 19 m 0,-2 H 4.9999998 c -1.0999999,0 -1.9999999,0.9000001 -1.9999999,2 V 17.000001 c 0,1.1 0.9,2 1.9999999,2 H 19 c 1.1,0 2,-0.9 2,-2 V 6.9999992 c 0,-1.0999999 -0.9,-2 -2,-2 z"
        }), (0, $1Hdcz.h)("path", {
            fill: "none",
            d: "M0 0h24v24H0z"
        })));
    }
    renderCropWidescreenVertical() {
        const { i18n: i18n } = this.props;
        return (0, $1Hdcz.h)("button", {
            type: "button",
            className: "uppy-u-reset uppy-c-btn",
            "aria-label": i18n("aspectRatioPortrait"),
            "data-microtip-position": "top",
            onClick: ()=>this.cropper.setAspectRatio(9 / 16)
        }, (0, $1Hdcz.h)("svg", {
            "aria-hidden": "true",
            className: "uppy-c-icon",
            width: "24",
            height: "24",
            viewBox: "0 0 24 24"
        }, (0, $1Hdcz.h)("path", {
            d: "M 19.000001,19 H 6.999999 V 5 h 10.000002 v 14 m 2,0 V 5 c 0,-1.0999999 -0.9,-1.9999999 -2,-1.9999999 H 6.999999 c -1.1,0 -2,0.9 -2,1.9999999 v 14 c 0,1.1 0.9,2 2,2 h 10.000002 c 1.1,0 2,-0.9 2,-2 z"
        }), (0, $1Hdcz.h)("path", {
            d: "M0 0h24v24H0z",
            fill: "none"
        })));
    }
    render() {
        const { currentImage: currentImage, opts: opts } = this.props;
        const { actions: actions } = opts;
        const imageURL = URL.createObjectURL(currentImage.data);
        return (0, $1Hdcz.h)("div", {
            className: "uppy-ImageCropper"
        }, (0, $1Hdcz.h)("div", {
            className: "uppy-ImageCropper-container"
        }, (0, $1Hdcz.h)("img", {
            className: "uppy-ImageCropper-image",
            alt: currentImage.name,
            src: imageURL,
            ref: (ref)=>{
                this.imgElement = ref;
            }
        })), (0, $1Hdcz.h)("div", {
            className: "uppy-ImageCropper-controls"
        }, actions.revert && this.renderRevert(), actions.rotate && this.renderRotate(), actions.granularRotate && this.renderGranularRotate(), actions.flip && this.renderFlip(), actions.zoomIn && this.renderZoomIn(), actions.zoomOut && this.renderZoomOut(), actions.cropSquare && this.renderCropSquare(), actions.cropWidescreen && this.renderCropWidescreen(), actions.cropWidescreenVertical && this.renderCropWidescreenVertical()));
    }
}
module.exports = $b55ef0c49a09c94c$var$Editor;

});
parcelRegister("avtRj", function(module, exports) {
/*!
 * Cropper.js v1.5.7
 * https://fengyuanchen.github.io/cropperjs
 *
 * Copyright 2015-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2020-05-23T05:23:00.081Z
 */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    function _typeof(obj) {
        "@babel/helpers - typeof";
        if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function(obj) {
            return typeof obj;
        };
        else _typeof = function(obj) {
            return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        };
        return _typeof(obj);
    }
    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function _defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    function _createClass(Constructor, protoProps, staticProps) {
        if (protoProps) _defineProperties(Constructor.prototype, protoProps);
        if (staticProps) _defineProperties(Constructor, staticProps);
        return Constructor;
    }
    function _defineProperty(obj, key, value) {
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function ownKeys(object, enumerableOnly) {
        var keys = Object.keys(object);
        if (Object.getOwnPropertySymbols) {
            var symbols = Object.getOwnPropertySymbols(object);
            if (enumerableOnly) symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
            keys.push.apply(keys, symbols);
        }
        return keys;
    }
    function _objectSpread2(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i] != null ? arguments[i] : {};
            if (i % 2) ownKeys(Object(source), true).forEach(function(key) {
                _defineProperty(target, key, source[key]);
            });
            else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
            else ownKeys(Object(source)).forEach(function(key) {
                Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
            });
        }
        return target;
    }
    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }
    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }
    function _iterableToArray(iter) {
        if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var IS_BROWSER = typeof window !== "undefined" && typeof window.document !== "undefined";
    var WINDOW = IS_BROWSER ? window : {};
    var IS_TOUCH_DEVICE = IS_BROWSER && WINDOW.document.documentElement ? "ontouchstart" in WINDOW.document.documentElement : false;
    var HAS_POINTER_EVENT = IS_BROWSER ? "PointerEvent" in WINDOW : false;
    var NAMESPACE = "cropper"; // Actions
    var ACTION_ALL = "all";
    var ACTION_CROP = "crop";
    var ACTION_MOVE = "move";
    var ACTION_ZOOM = "zoom";
    var ACTION_EAST = "e";
    var ACTION_WEST = "w";
    var ACTION_SOUTH = "s";
    var ACTION_NORTH = "n";
    var ACTION_NORTH_EAST = "ne";
    var ACTION_NORTH_WEST = "nw";
    var ACTION_SOUTH_EAST = "se";
    var ACTION_SOUTH_WEST = "sw"; // Classes
    var CLASS_CROP = "".concat(NAMESPACE, "-crop");
    var CLASS_DISABLED = "".concat(NAMESPACE, "-disabled");
    var CLASS_HIDDEN = "".concat(NAMESPACE, "-hidden");
    var CLASS_HIDE = "".concat(NAMESPACE, "-hide");
    var CLASS_INVISIBLE = "".concat(NAMESPACE, "-invisible");
    var CLASS_MODAL = "".concat(NAMESPACE, "-modal");
    var CLASS_MOVE = "".concat(NAMESPACE, "-move"); // Data keys
    var DATA_ACTION = "".concat(NAMESPACE, "Action");
    var DATA_PREVIEW = "".concat(NAMESPACE, "Preview"); // Drag modes
    var DRAG_MODE_CROP = "crop";
    var DRAG_MODE_MOVE = "move";
    var DRAG_MODE_NONE = "none"; // Events
    var EVENT_CROP = "crop";
    var EVENT_CROP_END = "cropend";
    var EVENT_CROP_MOVE = "cropmove";
    var EVENT_CROP_START = "cropstart";
    var EVENT_DBLCLICK = "dblclick";
    var EVENT_TOUCH_START = IS_TOUCH_DEVICE ? "touchstart" : "mousedown";
    var EVENT_TOUCH_MOVE = IS_TOUCH_DEVICE ? "touchmove" : "mousemove";
    var EVENT_TOUCH_END = IS_TOUCH_DEVICE ? "touchend touchcancel" : "mouseup";
    var EVENT_POINTER_DOWN = HAS_POINTER_EVENT ? "pointerdown" : EVENT_TOUCH_START;
    var EVENT_POINTER_MOVE = HAS_POINTER_EVENT ? "pointermove" : EVENT_TOUCH_MOVE;
    var EVENT_POINTER_UP = HAS_POINTER_EVENT ? "pointerup pointercancel" : EVENT_TOUCH_END;
    var EVENT_READY = "ready";
    var EVENT_RESIZE = "resize";
    var EVENT_WHEEL = "wheel";
    var EVENT_ZOOM = "zoom"; // Mime types
    var MIME_TYPE_JPEG = "image/jpeg"; // RegExps
    var REGEXP_ACTIONS = /^e|w|s|n|se|sw|ne|nw|all|crop|move|zoom$/;
    var REGEXP_DATA_URL = /^data:/;
    var REGEXP_DATA_URL_JPEG = /^data:image\/jpeg;base64,/;
    var REGEXP_TAG_NAME = /^img|canvas$/i; // Misc
    var DEFAULTS = {
        // Define the view mode of the cropper
        viewMode: 0,
        // 0, 1, 2, 3
        // Define the dragging mode of the cropper
        dragMode: DRAG_MODE_CROP,
        // 'crop', 'move' or 'none'
        // Define the initial aspect ratio of the crop box
        initialAspectRatio: NaN,
        // Define the aspect ratio of the crop box
        aspectRatio: NaN,
        // An object with the previous cropping result data
        data: null,
        // A selector for adding extra containers to preview
        preview: "",
        // Re-render the cropper when resize the window
        responsive: true,
        // Restore the cropped area after resize the window
        restore: true,
        // Check if the current image is a cross-origin image
        checkCrossOrigin: true,
        // Check the current image's Exif Orientation information
        checkOrientation: true,
        // Show the black modal
        modal: true,
        // Show the dashed lines for guiding
        guides: true,
        // Show the center indicator for guiding
        center: true,
        // Show the white modal to highlight the crop box
        highlight: true,
        // Show the grid background
        background: true,
        // Enable to crop the image automatically when initialize
        autoCrop: true,
        // Define the percentage of automatic cropping area when initializes
        autoCropArea: 0.8,
        // Enable to move the image
        movable: true,
        // Enable to rotate the image
        rotatable: true,
        // Enable to scale the image
        scalable: true,
        // Enable to zoom the image
        zoomable: true,
        // Enable to zoom the image by dragging touch
        zoomOnTouch: true,
        // Enable to zoom the image by wheeling mouse
        zoomOnWheel: true,
        // Define zoom ratio when zoom the image by wheeling mouse
        wheelZoomRatio: 0.1,
        // Enable to move the crop box
        cropBoxMovable: true,
        // Enable to resize the crop box
        cropBoxResizable: true,
        // Toggle drag mode between "crop" and "move" when click twice on the cropper
        toggleDragModeOnDblclick: true,
        // Size limitation
        minCanvasWidth: 0,
        minCanvasHeight: 0,
        minCropBoxWidth: 0,
        minCropBoxHeight: 0,
        minContainerWidth: 200,
        minContainerHeight: 100,
        // Shortcuts of events
        ready: null,
        cropstart: null,
        cropmove: null,
        cropend: null,
        crop: null,
        zoom: null
    };
    var TEMPLATE = '<div class="cropper-container" touch-action="none"><div class="cropper-wrap-box"><div class="cropper-canvas"></div></div><div class="cropper-drag-box"></div><div class="cropper-crop-box"><span class="cropper-view-box"></span><span class="cropper-dashed dashed-h"></span><span class="cropper-dashed dashed-v"></span><span class="cropper-center"></span><span class="cropper-face"></span><span class="cropper-line line-e" data-cropper-action="e"></span><span class="cropper-line line-n" data-cropper-action="n"></span><span class="cropper-line line-w" data-cropper-action="w"></span><span class="cropper-line line-s" data-cropper-action="s"></span><span class="cropper-point point-e" data-cropper-action="e"></span><span class="cropper-point point-n" data-cropper-action="n"></span><span class="cropper-point point-w" data-cropper-action="w"></span><span class="cropper-point point-s" data-cropper-action="s"></span><span class="cropper-point point-ne" data-cropper-action="ne"></span><span class="cropper-point point-nw" data-cropper-action="nw"></span><span class="cropper-point point-sw" data-cropper-action="sw"></span><span class="cropper-point point-se" data-cropper-action="se"></span></div></div>';
    /**
   * Check if the given value is not a number.
   */ var isNaN = Number.isNaN || WINDOW.isNaN;
    /**
   * Check if the given value is a number.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a number, else `false`.
   */ function isNumber(value) {
        return typeof value === "number" && !isNaN(value);
    }
    /**
   * Check if the given value is a positive number.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a positive number, else `false`.
   */ var isPositiveNumber = function isPositiveNumber(value) {
        return value > 0 && value < Infinity;
    };
    /**
   * Check if the given value is undefined.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is undefined, else `false`.
   */ function isUndefined(value) {
        return typeof value === "undefined";
    }
    /**
   * Check if the given value is an object.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is an object, else `false`.
   */ function isObject(value) {
        return _typeof(value) === "object" && value !== null;
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /**
   * Check if the given value is a plain object.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a plain object, else `false`.
   */ function isPlainObject(value) {
        if (!isObject(value)) return false;
        try {
            var _constructor = value.constructor;
            var prototype = _constructor.prototype;
            return _constructor && prototype && hasOwnProperty.call(prototype, "isPrototypeOf");
        } catch (error) {
            return false;
        }
    }
    /**
   * Check if the given value is a function.
   * @param {*} value - The value to check.
   * @returns {boolean} Returns `true` if the given value is a function, else `false`.
   */ function isFunction(value) {
        return typeof value === "function";
    }
    var slice = Array.prototype.slice;
    /**
   * Convert array-like or iterable object to an array.
   * @param {*} value - The value to convert.
   * @returns {Array} Returns a new array.
   */ function toArray(value) {
        return Array.from ? Array.from(value) : slice.call(value);
    }
    /**
   * Iterate the given data.
   * @param {*} data - The data to iterate.
   * @param {Function} callback - The process function for each element.
   * @returns {*} The original data.
   */ function forEach(data, callback) {
        if (data && isFunction(callback)) {
            if (Array.isArray(data) || isNumber(data.length)) toArray(data).forEach(function(value, key) {
                callback.call(data, value, key, data);
            });
            else if (isObject(data)) Object.keys(data).forEach(function(key) {
                callback.call(data, data[key], key, data);
            });
        }
        return data;
    }
    /**
   * Extend the given object.
   * @param {*} target - The target object to extend.
   * @param {*} args - The rest objects for merging to the target object.
   * @returns {Object} The extended object.
   */ var assign = Object.assign || function assign(target) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        if (isObject(target) && args.length > 0) args.forEach(function(arg) {
            if (isObject(arg)) Object.keys(arg).forEach(function(key) {
                target[key] = arg[key];
            });
        });
        return target;
    };
    var REGEXP_DECIMALS = /\.\d*(?:0|9){12}\d*$/;
    /**
   * Normalize decimal number.
   * Check out {@link https://0.30000000000000004.com/}
   * @param {number} value - The value to normalize.
   * @param {number} [times=100000000000] - The times for normalizing.
   * @returns {number} Returns the normalized number.
   */ function normalizeDecimalNumber(value) {
        var times = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100000000000;
        return REGEXP_DECIMALS.test(value) ? Math.round(value * times) / times : value;
    }
    var REGEXP_SUFFIX = /^width|height|left|top|marginLeft|marginTop$/;
    /**
   * Apply styles to the given element.
   * @param {Element} element - The target element.
   * @param {Object} styles - The styles for applying.
   */ function setStyle(element, styles) {
        var style = element.style;
        forEach(styles, function(value, property) {
            if (REGEXP_SUFFIX.test(property) && isNumber(value)) value = "".concat(value, "px");
            style[property] = value;
        });
    }
    /**
   * Check if the given element has a special class.
   * @param {Element} element - The element to check.
   * @param {string} value - The class to search.
   * @returns {boolean} Returns `true` if the special class was found.
   */ function hasClass(element, value) {
        return element.classList ? element.classList.contains(value) : element.className.indexOf(value) > -1;
    }
    /**
   * Add classes to the given element.
   * @param {Element} element - The target element.
   * @param {string} value - The classes to be added.
   */ function addClass(element, value) {
        if (!value) return;
        if (isNumber(element.length)) {
            forEach(element, function(elem) {
                addClass(elem, value);
            });
            return;
        }
        if (element.classList) {
            element.classList.add(value);
            return;
        }
        var className = element.className.trim();
        if (!className) element.className = value;
        else if (className.indexOf(value) < 0) element.className = "".concat(className, " ").concat(value);
    }
    /**
   * Remove classes from the given element.
   * @param {Element} element - The target element.
   * @param {string} value - The classes to be removed.
   */ function removeClass(element, value) {
        if (!value) return;
        if (isNumber(element.length)) {
            forEach(element, function(elem) {
                removeClass(elem, value);
            });
            return;
        }
        if (element.classList) {
            element.classList.remove(value);
            return;
        }
        if (element.className.indexOf(value) >= 0) element.className = element.className.replace(value, "");
    }
    /**
   * Add or remove classes from the given element.
   * @param {Element} element - The target element.
   * @param {string} value - The classes to be toggled.
   * @param {boolean} added - Add only.
   */ function toggleClass(element, value, added) {
        if (!value) return;
        if (isNumber(element.length)) {
            forEach(element, function(elem) {
                toggleClass(elem, value, added);
            });
            return;
        } // IE10-11 doesn't support the second parameter of `classList.toggle`
        if (added) addClass(element, value);
        else removeClass(element, value);
    }
    var REGEXP_CAMEL_CASE = /([a-z\d])([A-Z])/g;
    /**
   * Transform the given string from camelCase to kebab-case
   * @param {string} value - The value to transform.
   * @returns {string} The transformed value.
   */ function toParamCase(value) {
        return value.replace(REGEXP_CAMEL_CASE, "$1-$2").toLowerCase();
    }
    /**
   * Get data from the given element.
   * @param {Element} element - The target element.
   * @param {string} name - The data key to get.
   * @returns {string} The data value.
   */ function getData(element, name) {
        if (isObject(element[name])) return element[name];
        if (element.dataset) return element.dataset[name];
        return element.getAttribute("data-".concat(toParamCase(name)));
    }
    /**
   * Set data to the given element.
   * @param {Element} element - The target element.
   * @param {string} name - The data key to set.
   * @param {string} data - The data value.
   */ function setData(element, name, data) {
        if (isObject(data)) element[name] = data;
        else if (element.dataset) element.dataset[name] = data;
        else element.setAttribute("data-".concat(toParamCase(name)), data);
    }
    /**
   * Remove data from the given element.
   * @param {Element} element - The target element.
   * @param {string} name - The data key to remove.
   */ function removeData(element, name) {
        if (isObject(element[name])) try {
            delete element[name];
        } catch (error) {
            element[name] = undefined;
        }
        else if (element.dataset) // #128 Safari not allows to delete dataset property
        try {
            delete element.dataset[name];
        } catch (error) {
            element.dataset[name] = undefined;
        }
        else element.removeAttribute("data-".concat(toParamCase(name)));
    }
    var REGEXP_SPACES = /\s\s*/;
    var onceSupported = function() {
        var supported = false;
        if (IS_BROWSER) {
            var once = false;
            var listener = function listener() {};
            var options = Object.defineProperty({}, "once", {
                get: function get() {
                    supported = true;
                    return once;
                },
                /**
         * This setter can fix a `TypeError` in strict mode
         * {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Getter_only}
         * @param {boolean} value - The value to set
         */ set: function set(value) {
                    once = value;
                }
            });
            WINDOW.addEventListener("test", listener, options);
            WINDOW.removeEventListener("test", listener, options);
        }
        return supported;
    }();
    /**
   * Remove event listener from the target element.
   * @param {Element} element - The event target.
   * @param {string} type - The event type(s).
   * @param {Function} listener - The event listener.
   * @param {Object} options - The event options.
   */ function removeListener(element, type, listener) {
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var handler = listener;
        type.trim().split(REGEXP_SPACES).forEach(function(event) {
            if (!onceSupported) {
                var listeners = element.listeners;
                if (listeners && listeners[event] && listeners[event][listener]) {
                    handler = listeners[event][listener];
                    delete listeners[event][listener];
                    if (Object.keys(listeners[event]).length === 0) delete listeners[event];
                    if (Object.keys(listeners).length === 0) delete element.listeners;
                }
            }
            element.removeEventListener(event, handler, options);
        });
    }
    /**
   * Add event listener to the target element.
   * @param {Element} element - The event target.
   * @param {string} type - The event type(s).
   * @param {Function} listener - The event listener.
   * @param {Object} options - The event options.
   */ function addListener(element, type, listener) {
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var _handler = listener;
        type.trim().split(REGEXP_SPACES).forEach(function(event) {
            if (options.once && !onceSupported) {
                var _element$listeners = element.listeners, listeners = _element$listeners === void 0 ? {} : _element$listeners;
                _handler = function handler() {
                    delete listeners[event][listener];
                    element.removeEventListener(event, _handler, options);
                    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                    listener.apply(element, args);
                };
                if (!listeners[event]) listeners[event] = {};
                if (listeners[event][listener]) element.removeEventListener(event, listeners[event][listener], options);
                listeners[event][listener] = _handler;
                element.listeners = listeners;
            }
            element.addEventListener(event, _handler, options);
        });
    }
    /**
   * Dispatch event on the target element.
   * @param {Element} element - The event target.
   * @param {string} type - The event type(s).
   * @param {Object} data - The additional event data.
   * @returns {boolean} Indicate if the event is default prevented or not.
   */ function dispatchEvent(element, type, data) {
        var event; // Event and CustomEvent on IE9-11 are global objects, not constructors
        if (isFunction(Event) && isFunction(CustomEvent)) event = new CustomEvent(type, {
            detail: data,
            bubbles: true,
            cancelable: true
        });
        else {
            event = document.createEvent("CustomEvent");
            event.initCustomEvent(type, true, true, data);
        }
        return element.dispatchEvent(event);
    }
    /**
   * Get the offset base on the document.
   * @param {Element} element - The target element.
   * @returns {Object} The offset data.
   */ function getOffset(element) {
        var box = element.getBoundingClientRect();
        return {
            left: box.left + (window.pageXOffset - document.documentElement.clientLeft),
            top: box.top + (window.pageYOffset - document.documentElement.clientTop)
        };
    }
    var location = WINDOW.location;
    var REGEXP_ORIGINS = /^(\w+:)\/\/([^:/?#]*):?(\d*)/i;
    /**
   * Check if the given URL is a cross origin URL.
   * @param {string} url - The target URL.
   * @returns {boolean} Returns `true` if the given URL is a cross origin URL, else `false`.
   */ function isCrossOriginURL(url) {
        var parts = url.match(REGEXP_ORIGINS);
        return parts !== null && (parts[1] !== location.protocol || parts[2] !== location.hostname || parts[3] !== location.port);
    }
    /**
   * Add timestamp to the given URL.
   * @param {string} url - The target URL.
   * @returns {string} The result URL.
   */ function addTimestamp(url) {
        var timestamp = "timestamp=".concat(new Date().getTime());
        return url + (url.indexOf("?") === -1 ? "?" : "&") + timestamp;
    }
    /**
   * Get transforms base on the given object.
   * @param {Object} obj - The target object.
   * @returns {string} A string contains transform values.
   */ function getTransforms(_ref) {
        var rotate = _ref.rotate, scaleX = _ref.scaleX, scaleY = _ref.scaleY, translateX = _ref.translateX, translateY = _ref.translateY;
        var values = [];
        if (isNumber(translateX) && translateX !== 0) values.push("translateX(".concat(translateX, "px)"));
        if (isNumber(translateY) && translateY !== 0) values.push("translateY(".concat(translateY, "px)"));
         // Rotate should come first before scale to match orientation transform
        if (isNumber(rotate) && rotate !== 0) values.push("rotate(".concat(rotate, "deg)"));
        if (isNumber(scaleX) && scaleX !== 1) values.push("scaleX(".concat(scaleX, ")"));
        if (isNumber(scaleY) && scaleY !== 1) values.push("scaleY(".concat(scaleY, ")"));
        var transform = values.length ? values.join(" ") : "none";
        return {
            WebkitTransform: transform,
            msTransform: transform,
            transform: transform
        };
    }
    /**
   * Get the max ratio of a group of pointers.
   * @param {string} pointers - The target pointers.
   * @returns {number} The result ratio.
   */ function getMaxZoomRatio(pointers) {
        var pointers2 = _objectSpread2({}, pointers);
        var ratios = [];
        forEach(pointers, function(pointer, pointerId) {
            delete pointers2[pointerId];
            forEach(pointers2, function(pointer2) {
                var x1 = Math.abs(pointer.startX - pointer2.startX);
                var y1 = Math.abs(pointer.startY - pointer2.startY);
                var x2 = Math.abs(pointer.endX - pointer2.endX);
                var y2 = Math.abs(pointer.endY - pointer2.endY);
                var z1 = Math.sqrt(x1 * x1 + y1 * y1);
                var z2 = Math.sqrt(x2 * x2 + y2 * y2);
                var ratio = (z2 - z1) / z1;
                ratios.push(ratio);
            });
        });
        ratios.sort(function(a, b) {
            return Math.abs(a) < Math.abs(b);
        });
        return ratios[0];
    }
    /**
   * Get a pointer from an event object.
   * @param {Object} event - The target event object.
   * @param {boolean} endOnly - Indicates if only returns the end point coordinate or not.
   * @returns {Object} The result pointer contains start and/or end point coordinates.
   */ function getPointer(_ref2, endOnly) {
        var pageX = _ref2.pageX, pageY = _ref2.pageY;
        var end = {
            endX: pageX,
            endY: pageY
        };
        return endOnly ? end : _objectSpread2({
            startX: pageX,
            startY: pageY
        }, end);
    }
    /**
   * Get the center point coordinate of a group of pointers.
   * @param {Object} pointers - The target pointers.
   * @returns {Object} The center point coordinate.
   */ function getPointersCenter(pointers) {
        var pageX = 0;
        var pageY = 0;
        var count = 0;
        forEach(pointers, function(_ref3) {
            var startX = _ref3.startX, startY = _ref3.startY;
            pageX += startX;
            pageY += startY;
            count += 1;
        });
        pageX /= count;
        pageY /= count;
        return {
            pageX: pageX,
            pageY: pageY
        };
    }
    /**
   * Get the max sizes in a rectangle under the given aspect ratio.
   * @param {Object} data - The original sizes.
   * @param {string} [type='contain'] - The adjust type.
   * @returns {Object} The result sizes.
   */ function getAdjustedSizes(_ref4) {
        var aspectRatio = _ref4.aspectRatio, height = _ref4.height, width = _ref4.width;
        var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "contain";
        var isValidWidth = isPositiveNumber(width);
        var isValidHeight = isPositiveNumber(height);
        if (isValidWidth && isValidHeight) {
            var adjustedWidth = height * aspectRatio;
            if (type === "contain" && adjustedWidth > width || type === "cover" && adjustedWidth < width) height = width / aspectRatio;
            else width = height * aspectRatio;
        } else if (isValidWidth) height = width / aspectRatio;
        else if (isValidHeight) width = height * aspectRatio;
        return {
            width: width,
            height: height
        };
    }
    /**
   * Get the new sizes of a rectangle after rotated.
   * @param {Object} data - The original sizes.
   * @returns {Object} The result sizes.
   */ function getRotatedSizes(_ref5) {
        var width = _ref5.width, height = _ref5.height, degree = _ref5.degree;
        degree = Math.abs(degree) % 180;
        if (degree === 90) return {
            width: height,
            height: width
        };
        var arc = degree % 90 * Math.PI / 180;
        var sinArc = Math.sin(arc);
        var cosArc = Math.cos(arc);
        var newWidth = width * cosArc + height * sinArc;
        var newHeight = width * sinArc + height * cosArc;
        return degree > 90 ? {
            width: newHeight,
            height: newWidth
        } : {
            width: newWidth,
            height: newHeight
        };
    }
    /**
   * Get a canvas which drew the given image.
   * @param {HTMLImageElement} image - The image for drawing.
   * @param {Object} imageData - The image data.
   * @param {Object} canvasData - The canvas data.
   * @param {Object} options - The options.
   * @returns {HTMLCanvasElement} The result canvas.
   */ function getSourceCanvas(image, _ref6, _ref7, _ref8) {
        var imageAspectRatio = _ref6.aspectRatio, imageNaturalWidth = _ref6.naturalWidth, imageNaturalHeight = _ref6.naturalHeight, _ref6$rotate = _ref6.rotate, rotate = _ref6$rotate === void 0 ? 0 : _ref6$rotate, _ref6$scaleX = _ref6.scaleX, scaleX = _ref6$scaleX === void 0 ? 1 : _ref6$scaleX, _ref6$scaleY = _ref6.scaleY, scaleY = _ref6$scaleY === void 0 ? 1 : _ref6$scaleY;
        var aspectRatio = _ref7.aspectRatio, naturalWidth = _ref7.naturalWidth, naturalHeight = _ref7.naturalHeight;
        var _ref8$fillColor = _ref8.fillColor, fillColor = _ref8$fillColor === void 0 ? "transparent" : _ref8$fillColor, _ref8$imageSmoothingE = _ref8.imageSmoothingEnabled, imageSmoothingEnabled = _ref8$imageSmoothingE === void 0 ? true : _ref8$imageSmoothingE, _ref8$imageSmoothingQ = _ref8.imageSmoothingQuality, imageSmoothingQuality = _ref8$imageSmoothingQ === void 0 ? "low" : _ref8$imageSmoothingQ, _ref8$maxWidth = _ref8.maxWidth, maxWidth = _ref8$maxWidth === void 0 ? Infinity : _ref8$maxWidth, _ref8$maxHeight = _ref8.maxHeight, maxHeight = _ref8$maxHeight === void 0 ? Infinity : _ref8$maxHeight, _ref8$minWidth = _ref8.minWidth, minWidth = _ref8$minWidth === void 0 ? 0 : _ref8$minWidth, _ref8$minHeight = _ref8.minHeight, minHeight = _ref8$minHeight === void 0 ? 0 : _ref8$minHeight;
        var canvas = document.createElement("canvas");
        var context = canvas.getContext("2d");
        var maxSizes = getAdjustedSizes({
            aspectRatio: aspectRatio,
            width: maxWidth,
            height: maxHeight
        });
        var minSizes = getAdjustedSizes({
            aspectRatio: aspectRatio,
            width: minWidth,
            height: minHeight
        }, "cover");
        var width = Math.min(maxSizes.width, Math.max(minSizes.width, naturalWidth));
        var height = Math.min(maxSizes.height, Math.max(minSizes.height, naturalHeight)); // Note: should always use image's natural sizes for drawing as
        // imageData.naturalWidth === canvasData.naturalHeight when rotate % 180 === 90
        var destMaxSizes = getAdjustedSizes({
            aspectRatio: imageAspectRatio,
            width: maxWidth,
            height: maxHeight
        });
        var destMinSizes = getAdjustedSizes({
            aspectRatio: imageAspectRatio,
            width: minWidth,
            height: minHeight
        }, "cover");
        var destWidth = Math.min(destMaxSizes.width, Math.max(destMinSizes.width, imageNaturalWidth));
        var destHeight = Math.min(destMaxSizes.height, Math.max(destMinSizes.height, imageNaturalHeight));
        var params = [
            -destWidth / 2,
            -destHeight / 2,
            destWidth,
            destHeight
        ];
        canvas.width = normalizeDecimalNumber(width);
        canvas.height = normalizeDecimalNumber(height);
        context.fillStyle = fillColor;
        context.fillRect(0, 0, width, height);
        context.save();
        context.translate(width / 2, height / 2);
        context.rotate(rotate * Math.PI / 180);
        context.scale(scaleX, scaleY);
        context.imageSmoothingEnabled = imageSmoothingEnabled;
        context.imageSmoothingQuality = imageSmoothingQuality;
        context.drawImage.apply(context, [
            image
        ].concat(_toConsumableArray(params.map(function(param) {
            return Math.floor(normalizeDecimalNumber(param));
        }))));
        context.restore();
        return canvas;
    }
    var fromCharCode = String.fromCharCode;
    /**
   * Get string from char code in data view.
   * @param {DataView} dataView - The data view for read.
   * @param {number} start - The start index.
   * @param {number} length - The read length.
   * @returns {string} The read result.
   */ function getStringFromCharCode(dataView, start, length) {
        var str = "";
        length += start;
        for(var i = start; i < length; i += 1)str += fromCharCode(dataView.getUint8(i));
        return str;
    }
    var REGEXP_DATA_URL_HEAD = /^data:.*,/;
    /**
   * Transform Data URL to array buffer.
   * @param {string} dataURL - The Data URL to transform.
   * @returns {ArrayBuffer} The result array buffer.
   */ function dataURLToArrayBuffer(dataURL) {
        var base64 = dataURL.replace(REGEXP_DATA_URL_HEAD, "");
        var binary = atob(base64);
        var arrayBuffer = new ArrayBuffer(binary.length);
        var uint8 = new Uint8Array(arrayBuffer);
        forEach(uint8, function(value, i) {
            uint8[i] = binary.charCodeAt(i);
        });
        return arrayBuffer;
    }
    /**
   * Transform array buffer to Data URL.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to transform.
   * @param {string} mimeType - The mime type of the Data URL.
   * @returns {string} The result Data URL.
   */ function arrayBufferToDataURL(arrayBuffer, mimeType) {
        var chunks = []; // Chunk Typed Array for better performance (#435)
        var chunkSize = 8192;
        var uint8 = new Uint8Array(arrayBuffer);
        while(uint8.length > 0){
            // XXX: Babel's `toConsumableArray` helper will throw error in IE or Safari 9
            // eslint-disable-next-line prefer-spread
            chunks.push(fromCharCode.apply(null, toArray(uint8.subarray(0, chunkSize))));
            uint8 = uint8.subarray(chunkSize);
        }
        return "data:".concat(mimeType, ";base64,").concat(btoa(chunks.join("")));
    }
    /**
   * Get orientation value from given array buffer.
   * @param {ArrayBuffer} arrayBuffer - The array buffer to read.
   * @returns {number} The read orientation value.
   */ function resetAndGetOrientation(arrayBuffer) {
        var dataView = new DataView(arrayBuffer);
        var orientation; // Ignores range error when the image does not have correct Exif information
        try {
            var littleEndian;
            var app1Start;
            var ifdStart; // Only handle JPEG image (start by 0xFFD8)
            if (dataView.getUint8(0) === 0xFF && dataView.getUint8(1) === 0xD8) {
                var length = dataView.byteLength;
                var offset = 2;
                while(offset + 1 < length){
                    if (dataView.getUint8(offset) === 0xFF && dataView.getUint8(offset + 1) === 0xE1) {
                        app1Start = offset;
                        break;
                    }
                    offset += 1;
                }
            }
            if (app1Start) {
                var exifIDCode = app1Start + 4;
                var tiffOffset = app1Start + 10;
                if (getStringFromCharCode(dataView, exifIDCode, 4) === "Exif") {
                    var endianness = dataView.getUint16(tiffOffset);
                    littleEndian = endianness === 0x4949;
                    if (littleEndian || endianness === 0x4D4D) {
                        if (dataView.getUint16(tiffOffset + 2, littleEndian) === 0x002A) {
                            var firstIFDOffset = dataView.getUint32(tiffOffset + 4, littleEndian);
                            if (firstIFDOffset >= 0x00000008) ifdStart = tiffOffset + firstIFDOffset;
                        }
                    }
                }
            }
            if (ifdStart) {
                var _length = dataView.getUint16(ifdStart, littleEndian);
                var _offset;
                var i;
                for(i = 0; i < _length; i += 1){
                    _offset = ifdStart + i * 12 + 2;
                    if (dataView.getUint16(_offset, littleEndian) === 0x0112) {
                        // 8 is the offset of the current tag's value
                        _offset += 8; // Get the original orientation value
                        orientation = dataView.getUint16(_offset, littleEndian); // Override the orientation with its default value
                        dataView.setUint16(_offset, 1, littleEndian);
                        break;
                    }
                }
            }
        } catch (error) {
            orientation = 1;
        }
        return orientation;
    }
    /**
   * Parse Exif Orientation value.
   * @param {number} orientation - The orientation to parse.
   * @returns {Object} The parsed result.
   */ function parseOrientation(orientation) {
        var rotate = 0;
        var scaleX = 1;
        var scaleY = 1;
        switch(orientation){
            // Flip horizontal
            case 2:
                scaleX = -1;
                break;
            // Rotate left 180°
            case 3:
                rotate = -180;
                break;
            // Flip vertical
            case 4:
                scaleY = -1;
                break;
            // Flip vertical and rotate right 90°
            case 5:
                rotate = 90;
                scaleY = -1;
                break;
            // Rotate right 90°
            case 6:
                rotate = 90;
                break;
            // Flip horizontal and rotate right 90°
            case 7:
                rotate = 90;
                scaleX = -1;
                break;
            // Rotate left 90°
            case 8:
                rotate = -90;
                break;
        }
        return {
            rotate: rotate,
            scaleX: scaleX,
            scaleY: scaleY
        };
    }
    var render = {
        render: function render() {
            this.initContainer();
            this.initCanvas();
            this.initCropBox();
            this.renderCanvas();
            if (this.cropped) this.renderCropBox();
        },
        initContainer: function initContainer() {
            var element = this.element, options = this.options, container = this.container, cropper = this.cropper;
            addClass(cropper, CLASS_HIDDEN);
            removeClass(element, CLASS_HIDDEN);
            var containerData = {
                width: Math.max(container.offsetWidth, Number(options.minContainerWidth) || 200),
                height: Math.max(container.offsetHeight, Number(options.minContainerHeight) || 100)
            };
            this.containerData = containerData;
            setStyle(cropper, {
                width: containerData.width,
                height: containerData.height
            });
            addClass(element, CLASS_HIDDEN);
            removeClass(cropper, CLASS_HIDDEN);
        },
        // Canvas (image wrapper)
        initCanvas: function initCanvas() {
            var containerData = this.containerData, imageData = this.imageData;
            var viewMode = this.options.viewMode;
            var rotated = Math.abs(imageData.rotate) % 180 === 90;
            var naturalWidth = rotated ? imageData.naturalHeight : imageData.naturalWidth;
            var naturalHeight = rotated ? imageData.naturalWidth : imageData.naturalHeight;
            var aspectRatio = naturalWidth / naturalHeight;
            var canvasWidth = containerData.width;
            var canvasHeight = containerData.height;
            if (containerData.height * aspectRatio > containerData.width) {
                if (viewMode === 3) canvasWidth = containerData.height * aspectRatio;
                else canvasHeight = containerData.width / aspectRatio;
            } else if (viewMode === 3) canvasHeight = containerData.width / aspectRatio;
            else canvasWidth = containerData.height * aspectRatio;
            var canvasData = {
                aspectRatio: aspectRatio,
                naturalWidth: naturalWidth,
                naturalHeight: naturalHeight,
                width: canvasWidth,
                height: canvasHeight
            };
            canvasData.left = (containerData.width - canvasWidth) / 2;
            canvasData.top = (containerData.height - canvasHeight) / 2;
            canvasData.oldLeft = canvasData.left;
            canvasData.oldTop = canvasData.top;
            this.canvasData = canvasData;
            this.limited = viewMode === 1 || viewMode === 2;
            this.limitCanvas(true, true);
            this.initialImageData = assign({}, imageData);
            this.initialCanvasData = assign({}, canvasData);
        },
        limitCanvas: function limitCanvas(sizeLimited, positionLimited) {
            var options = this.options, containerData = this.containerData, canvasData = this.canvasData, cropBoxData = this.cropBoxData;
            var viewMode = options.viewMode;
            var aspectRatio = canvasData.aspectRatio;
            var cropped = this.cropped && cropBoxData;
            if (sizeLimited) {
                var minCanvasWidth = Number(options.minCanvasWidth) || 0;
                var minCanvasHeight = Number(options.minCanvasHeight) || 0;
                if (viewMode > 1) {
                    minCanvasWidth = Math.max(minCanvasWidth, containerData.width);
                    minCanvasHeight = Math.max(minCanvasHeight, containerData.height);
                    if (viewMode === 3) {
                        if (minCanvasHeight * aspectRatio > minCanvasWidth) minCanvasWidth = minCanvasHeight * aspectRatio;
                        else minCanvasHeight = minCanvasWidth / aspectRatio;
                    }
                } else if (viewMode > 0) {
                    if (minCanvasWidth) minCanvasWidth = Math.max(minCanvasWidth, cropped ? cropBoxData.width : 0);
                    else if (minCanvasHeight) minCanvasHeight = Math.max(minCanvasHeight, cropped ? cropBoxData.height : 0);
                    else if (cropped) {
                        minCanvasWidth = cropBoxData.width;
                        minCanvasHeight = cropBoxData.height;
                        if (minCanvasHeight * aspectRatio > minCanvasWidth) minCanvasWidth = minCanvasHeight * aspectRatio;
                        else minCanvasHeight = minCanvasWidth / aspectRatio;
                    }
                }
                var _getAdjustedSizes = getAdjustedSizes({
                    aspectRatio: aspectRatio,
                    width: minCanvasWidth,
                    height: minCanvasHeight
                });
                minCanvasWidth = _getAdjustedSizes.width;
                minCanvasHeight = _getAdjustedSizes.height;
                canvasData.minWidth = minCanvasWidth;
                canvasData.minHeight = minCanvasHeight;
                canvasData.maxWidth = Infinity;
                canvasData.maxHeight = Infinity;
            }
            if (positionLimited) {
                if (viewMode > (cropped ? 0 : 1)) {
                    var newCanvasLeft = containerData.width - canvasData.width;
                    var newCanvasTop = containerData.height - canvasData.height;
                    canvasData.minLeft = Math.min(0, newCanvasLeft);
                    canvasData.minTop = Math.min(0, newCanvasTop);
                    canvasData.maxLeft = Math.max(0, newCanvasLeft);
                    canvasData.maxTop = Math.max(0, newCanvasTop);
                    if (cropped && this.limited) {
                        canvasData.minLeft = Math.min(cropBoxData.left, cropBoxData.left + (cropBoxData.width - canvasData.width));
                        canvasData.minTop = Math.min(cropBoxData.top, cropBoxData.top + (cropBoxData.height - canvasData.height));
                        canvasData.maxLeft = cropBoxData.left;
                        canvasData.maxTop = cropBoxData.top;
                        if (viewMode === 2) {
                            if (canvasData.width >= containerData.width) {
                                canvasData.minLeft = Math.min(0, newCanvasLeft);
                                canvasData.maxLeft = Math.max(0, newCanvasLeft);
                            }
                            if (canvasData.height >= containerData.height) {
                                canvasData.minTop = Math.min(0, newCanvasTop);
                                canvasData.maxTop = Math.max(0, newCanvasTop);
                            }
                        }
                    }
                } else {
                    canvasData.minLeft = -canvasData.width;
                    canvasData.minTop = -canvasData.height;
                    canvasData.maxLeft = containerData.width;
                    canvasData.maxTop = containerData.height;
                }
            }
        },
        renderCanvas: function renderCanvas(changed, transformed) {
            var canvasData = this.canvasData, imageData = this.imageData;
            if (transformed) {
                var _getRotatedSizes = getRotatedSizes({
                    width: imageData.naturalWidth * Math.abs(imageData.scaleX || 1),
                    height: imageData.naturalHeight * Math.abs(imageData.scaleY || 1),
                    degree: imageData.rotate || 0
                }), naturalWidth = _getRotatedSizes.width, naturalHeight = _getRotatedSizes.height;
                var width = canvasData.width * (naturalWidth / canvasData.naturalWidth);
                var height = canvasData.height * (naturalHeight / canvasData.naturalHeight);
                canvasData.left -= (width - canvasData.width) / 2;
                canvasData.top -= (height - canvasData.height) / 2;
                canvasData.width = width;
                canvasData.height = height;
                canvasData.aspectRatio = naturalWidth / naturalHeight;
                canvasData.naturalWidth = naturalWidth;
                canvasData.naturalHeight = naturalHeight;
                this.limitCanvas(true, false);
            }
            if (canvasData.width > canvasData.maxWidth || canvasData.width < canvasData.minWidth) canvasData.left = canvasData.oldLeft;
            if (canvasData.height > canvasData.maxHeight || canvasData.height < canvasData.minHeight) canvasData.top = canvasData.oldTop;
            canvasData.width = Math.min(Math.max(canvasData.width, canvasData.minWidth), canvasData.maxWidth);
            canvasData.height = Math.min(Math.max(canvasData.height, canvasData.minHeight), canvasData.maxHeight);
            this.limitCanvas(false, true);
            canvasData.left = Math.min(Math.max(canvasData.left, canvasData.minLeft), canvasData.maxLeft);
            canvasData.top = Math.min(Math.max(canvasData.top, canvasData.minTop), canvasData.maxTop);
            canvasData.oldLeft = canvasData.left;
            canvasData.oldTop = canvasData.top;
            setStyle(this.canvas, assign({
                width: canvasData.width,
                height: canvasData.height
            }, getTransforms({
                translateX: canvasData.left,
                translateY: canvasData.top
            })));
            this.renderImage(changed);
            if (this.cropped && this.limited) this.limitCropBox(true, true);
        },
        renderImage: function renderImage(changed) {
            var canvasData = this.canvasData, imageData = this.imageData;
            var width = imageData.naturalWidth * (canvasData.width / canvasData.naturalWidth);
            var height = imageData.naturalHeight * (canvasData.height / canvasData.naturalHeight);
            assign(imageData, {
                width: width,
                height: height,
                left: (canvasData.width - width) / 2,
                top: (canvasData.height - height) / 2
            });
            setStyle(this.image, assign({
                width: imageData.width,
                height: imageData.height
            }, getTransforms(assign({
                translateX: imageData.left,
                translateY: imageData.top
            }, imageData))));
            if (changed) this.output();
        },
        initCropBox: function initCropBox() {
            var options = this.options, canvasData = this.canvasData;
            var aspectRatio = options.aspectRatio || options.initialAspectRatio;
            var autoCropArea = Number(options.autoCropArea) || 0.8;
            var cropBoxData = {
                width: canvasData.width,
                height: canvasData.height
            };
            if (aspectRatio) {
                if (canvasData.height * aspectRatio > canvasData.width) cropBoxData.height = cropBoxData.width / aspectRatio;
                else cropBoxData.width = cropBoxData.height * aspectRatio;
            }
            this.cropBoxData = cropBoxData;
            this.limitCropBox(true, true); // Initialize auto crop area
            cropBoxData.width = Math.min(Math.max(cropBoxData.width, cropBoxData.minWidth), cropBoxData.maxWidth);
            cropBoxData.height = Math.min(Math.max(cropBoxData.height, cropBoxData.minHeight), cropBoxData.maxHeight); // The width/height of auto crop area must large than "minWidth/Height"
            cropBoxData.width = Math.max(cropBoxData.minWidth, cropBoxData.width * autoCropArea);
            cropBoxData.height = Math.max(cropBoxData.minHeight, cropBoxData.height * autoCropArea);
            cropBoxData.left = canvasData.left + (canvasData.width - cropBoxData.width) / 2;
            cropBoxData.top = canvasData.top + (canvasData.height - cropBoxData.height) / 2;
            cropBoxData.oldLeft = cropBoxData.left;
            cropBoxData.oldTop = cropBoxData.top;
            this.initialCropBoxData = assign({}, cropBoxData);
        },
        limitCropBox: function limitCropBox(sizeLimited, positionLimited) {
            var options = this.options, containerData = this.containerData, canvasData = this.canvasData, cropBoxData = this.cropBoxData, limited = this.limited;
            var aspectRatio = options.aspectRatio;
            if (sizeLimited) {
                var minCropBoxWidth = Number(options.minCropBoxWidth) || 0;
                var minCropBoxHeight = Number(options.minCropBoxHeight) || 0;
                var maxCropBoxWidth = limited ? Math.min(containerData.width, canvasData.width, canvasData.width + canvasData.left, containerData.width - canvasData.left) : containerData.width;
                var maxCropBoxHeight = limited ? Math.min(containerData.height, canvasData.height, canvasData.height + canvasData.top, containerData.height - canvasData.top) : containerData.height; // The min/maxCropBoxWidth/Height must be less than container's width/height
                minCropBoxWidth = Math.min(minCropBoxWidth, containerData.width);
                minCropBoxHeight = Math.min(minCropBoxHeight, containerData.height);
                if (aspectRatio) {
                    if (minCropBoxWidth && minCropBoxHeight) {
                        if (minCropBoxHeight * aspectRatio > minCropBoxWidth) minCropBoxHeight = minCropBoxWidth / aspectRatio;
                        else minCropBoxWidth = minCropBoxHeight * aspectRatio;
                    } else if (minCropBoxWidth) minCropBoxHeight = minCropBoxWidth / aspectRatio;
                    else if (minCropBoxHeight) minCropBoxWidth = minCropBoxHeight * aspectRatio;
                    if (maxCropBoxHeight * aspectRatio > maxCropBoxWidth) maxCropBoxHeight = maxCropBoxWidth / aspectRatio;
                    else maxCropBoxWidth = maxCropBoxHeight * aspectRatio;
                } // The minWidth/Height must be less than maxWidth/Height
                cropBoxData.minWidth = Math.min(minCropBoxWidth, maxCropBoxWidth);
                cropBoxData.minHeight = Math.min(minCropBoxHeight, maxCropBoxHeight);
                cropBoxData.maxWidth = maxCropBoxWidth;
                cropBoxData.maxHeight = maxCropBoxHeight;
            }
            if (positionLimited) {
                if (limited) {
                    cropBoxData.minLeft = Math.max(0, canvasData.left);
                    cropBoxData.minTop = Math.max(0, canvasData.top);
                    cropBoxData.maxLeft = Math.min(containerData.width, canvasData.left + canvasData.width) - cropBoxData.width;
                    cropBoxData.maxTop = Math.min(containerData.height, canvasData.top + canvasData.height) - cropBoxData.height;
                } else {
                    cropBoxData.minLeft = 0;
                    cropBoxData.minTop = 0;
                    cropBoxData.maxLeft = containerData.width - cropBoxData.width;
                    cropBoxData.maxTop = containerData.height - cropBoxData.height;
                }
            }
        },
        renderCropBox: function renderCropBox() {
            var options = this.options, containerData = this.containerData, cropBoxData = this.cropBoxData;
            if (cropBoxData.width > cropBoxData.maxWidth || cropBoxData.width < cropBoxData.minWidth) cropBoxData.left = cropBoxData.oldLeft;
            if (cropBoxData.height > cropBoxData.maxHeight || cropBoxData.height < cropBoxData.minHeight) cropBoxData.top = cropBoxData.oldTop;
            cropBoxData.width = Math.min(Math.max(cropBoxData.width, cropBoxData.minWidth), cropBoxData.maxWidth);
            cropBoxData.height = Math.min(Math.max(cropBoxData.height, cropBoxData.minHeight), cropBoxData.maxHeight);
            this.limitCropBox(false, true);
            cropBoxData.left = Math.min(Math.max(cropBoxData.left, cropBoxData.minLeft), cropBoxData.maxLeft);
            cropBoxData.top = Math.min(Math.max(cropBoxData.top, cropBoxData.minTop), cropBoxData.maxTop);
            cropBoxData.oldLeft = cropBoxData.left;
            cropBoxData.oldTop = cropBoxData.top;
            if (options.movable && options.cropBoxMovable) // Turn to move the canvas when the crop box is equal to the container
            setData(this.face, DATA_ACTION, cropBoxData.width >= containerData.width && cropBoxData.height >= containerData.height ? ACTION_MOVE : ACTION_ALL);
            setStyle(this.cropBox, assign({
                width: cropBoxData.width,
                height: cropBoxData.height
            }, getTransforms({
                translateX: cropBoxData.left,
                translateY: cropBoxData.top
            })));
            if (this.cropped && this.limited) this.limitCanvas(true, true);
            if (!this.disabled) this.output();
        },
        output: function output() {
            this.preview();
            dispatchEvent(this.element, EVENT_CROP, this.getData());
        }
    };
    var preview = {
        initPreview: function initPreview() {
            var element = this.element, crossOrigin = this.crossOrigin;
            var preview = this.options.preview;
            var url = crossOrigin ? this.crossOriginUrl : this.url;
            var alt = element.alt || "The image to preview";
            var image = document.createElement("img");
            if (crossOrigin) image.crossOrigin = crossOrigin;
            image.src = url;
            image.alt = alt;
            this.viewBox.appendChild(image);
            this.viewBoxImage = image;
            if (!preview) return;
            var previews = preview;
            if (typeof preview === "string") previews = element.ownerDocument.querySelectorAll(preview);
            else if (preview.querySelector) previews = [
                preview
            ];
            this.previews = previews;
            forEach(previews, function(el) {
                var img = document.createElement("img"); // Save the original size for recover
                setData(el, DATA_PREVIEW, {
                    width: el.offsetWidth,
                    height: el.offsetHeight,
                    html: el.innerHTML
                });
                if (crossOrigin) img.crossOrigin = crossOrigin;
                img.src = url;
                img.alt = alt;
                /**
         * Override img element styles
         * Add `display:block` to avoid margin top issue
         * Add `height:auto` to override `height` attribute on IE8
         * (Occur only when margin-top <= -height)
         */ img.style.cssText = 'display:block;width:100%;height:auto;min-width:0!important;min-height:0!important;max-width:none!important;max-height:none!important;image-orientation:0deg!important;"';
                el.innerHTML = "";
                el.appendChild(img);
            });
        },
        resetPreview: function resetPreview() {
            forEach(this.previews, function(element) {
                var data = getData(element, DATA_PREVIEW);
                setStyle(element, {
                    width: data.width,
                    height: data.height
                });
                element.innerHTML = data.html;
                removeData(element, DATA_PREVIEW);
            });
        },
        preview: function preview() {
            var imageData = this.imageData, canvasData = this.canvasData, cropBoxData = this.cropBoxData;
            var cropBoxWidth = cropBoxData.width, cropBoxHeight = cropBoxData.height;
            var width = imageData.width, height = imageData.height;
            var left = cropBoxData.left - canvasData.left - imageData.left;
            var top = cropBoxData.top - canvasData.top - imageData.top;
            if (!this.cropped || this.disabled) return;
            setStyle(this.viewBoxImage, assign({
                width: width,
                height: height
            }, getTransforms(assign({
                translateX: -left,
                translateY: -top
            }, imageData))));
            forEach(this.previews, function(element) {
                var data = getData(element, DATA_PREVIEW);
                var originalWidth = data.width;
                var originalHeight = data.height;
                var newWidth = originalWidth;
                var newHeight = originalHeight;
                var ratio = 1;
                if (cropBoxWidth) {
                    ratio = originalWidth / cropBoxWidth;
                    newHeight = cropBoxHeight * ratio;
                }
                if (cropBoxHeight && newHeight > originalHeight) {
                    ratio = originalHeight / cropBoxHeight;
                    newWidth = cropBoxWidth * ratio;
                    newHeight = originalHeight;
                }
                setStyle(element, {
                    width: newWidth,
                    height: newHeight
                });
                setStyle(element.getElementsByTagName("img")[0], assign({
                    width: width * ratio,
                    height: height * ratio
                }, getTransforms(assign({
                    translateX: -left * ratio,
                    translateY: -top * ratio
                }, imageData))));
            });
        }
    };
    var events = {
        bind: function bind() {
            var element = this.element, options = this.options, cropper = this.cropper;
            if (isFunction(options.cropstart)) addListener(element, EVENT_CROP_START, options.cropstart);
            if (isFunction(options.cropmove)) addListener(element, EVENT_CROP_MOVE, options.cropmove);
            if (isFunction(options.cropend)) addListener(element, EVENT_CROP_END, options.cropend);
            if (isFunction(options.crop)) addListener(element, EVENT_CROP, options.crop);
            if (isFunction(options.zoom)) addListener(element, EVENT_ZOOM, options.zoom);
            addListener(cropper, EVENT_POINTER_DOWN, this.onCropStart = this.cropStart.bind(this));
            if (options.zoomable && options.zoomOnWheel) addListener(cropper, EVENT_WHEEL, this.onWheel = this.wheel.bind(this), {
                passive: false,
                capture: true
            });
            if (options.toggleDragModeOnDblclick) addListener(cropper, EVENT_DBLCLICK, this.onDblclick = this.dblclick.bind(this));
            addListener(element.ownerDocument, EVENT_POINTER_MOVE, this.onCropMove = this.cropMove.bind(this));
            addListener(element.ownerDocument, EVENT_POINTER_UP, this.onCropEnd = this.cropEnd.bind(this));
            if (options.responsive) addListener(window, EVENT_RESIZE, this.onResize = this.resize.bind(this));
        },
        unbind: function unbind() {
            var element = this.element, options = this.options, cropper = this.cropper;
            if (isFunction(options.cropstart)) removeListener(element, EVENT_CROP_START, options.cropstart);
            if (isFunction(options.cropmove)) removeListener(element, EVENT_CROP_MOVE, options.cropmove);
            if (isFunction(options.cropend)) removeListener(element, EVENT_CROP_END, options.cropend);
            if (isFunction(options.crop)) removeListener(element, EVENT_CROP, options.crop);
            if (isFunction(options.zoom)) removeListener(element, EVENT_ZOOM, options.zoom);
            removeListener(cropper, EVENT_POINTER_DOWN, this.onCropStart);
            if (options.zoomable && options.zoomOnWheel) removeListener(cropper, EVENT_WHEEL, this.onWheel, {
                passive: false,
                capture: true
            });
            if (options.toggleDragModeOnDblclick) removeListener(cropper, EVENT_DBLCLICK, this.onDblclick);
            removeListener(element.ownerDocument, EVENT_POINTER_MOVE, this.onCropMove);
            removeListener(element.ownerDocument, EVENT_POINTER_UP, this.onCropEnd);
            if (options.responsive) removeListener(window, EVENT_RESIZE, this.onResize);
        }
    };
    var handlers = {
        resize: function resize() {
            if (this.disabled) return;
            var options = this.options, container = this.container, containerData = this.containerData;
            var ratio = container.offsetWidth / containerData.width; // Resize when width changed or height changed
            if (ratio !== 1 || container.offsetHeight !== containerData.height) {
                var canvasData;
                var cropBoxData;
                if (options.restore) {
                    canvasData = this.getCanvasData();
                    cropBoxData = this.getCropBoxData();
                }
                this.render();
                if (options.restore) {
                    this.setCanvasData(forEach(canvasData, function(n, i) {
                        canvasData[i] = n * ratio;
                    }));
                    this.setCropBoxData(forEach(cropBoxData, function(n, i) {
                        cropBoxData[i] = n * ratio;
                    }));
                }
            }
        },
        dblclick: function dblclick() {
            if (this.disabled || this.options.dragMode === DRAG_MODE_NONE) return;
            this.setDragMode(hasClass(this.dragBox, CLASS_CROP) ? DRAG_MODE_MOVE : DRAG_MODE_CROP);
        },
        wheel: function wheel(event) {
            var _this = this;
            var ratio = Number(this.options.wheelZoomRatio) || 0.1;
            var delta = 1;
            if (this.disabled) return;
            event.preventDefault(); // Limit wheel speed to prevent zoom too fast (#21)
            if (this.wheeling) return;
            this.wheeling = true;
            setTimeout(function() {
                _this.wheeling = false;
            }, 50);
            if (event.deltaY) delta = event.deltaY > 0 ? 1 : -1;
            else if (event.wheelDelta) delta = -event.wheelDelta / 120;
            else if (event.detail) delta = event.detail > 0 ? 1 : -1;
            this.zoom(-delta * ratio, event);
        },
        cropStart: function cropStart(event) {
            var buttons = event.buttons, button = event.button;
            if (this.disabled // Handle mouse event and pointer event and ignore touch event
             || (event.type === "mousedown" || event.type === "pointerdown" && event.pointerType === "mouse") && (isNumber(buttons) && buttons !== 1 || isNumber(button) && button !== 0 // Open context menu
             || event.ctrlKey)) return;
            var options = this.options, pointers = this.pointers;
            var action;
            if (event.changedTouches) // Handle touch event
            forEach(event.changedTouches, function(touch) {
                pointers[touch.identifier] = getPointer(touch);
            });
            else // Handle mouse event and pointer event
            pointers[event.pointerId || 0] = getPointer(event);
            if (Object.keys(pointers).length > 1 && options.zoomable && options.zoomOnTouch) action = ACTION_ZOOM;
            else action = getData(event.target, DATA_ACTION);
            if (!REGEXP_ACTIONS.test(action)) return;
            if (dispatchEvent(this.element, EVENT_CROP_START, {
                originalEvent: event,
                action: action
            }) === false) return;
             // This line is required for preventing page zooming in iOS browsers
            event.preventDefault();
            this.action = action;
            this.cropping = false;
            if (action === ACTION_CROP) {
                this.cropping = true;
                addClass(this.dragBox, CLASS_MODAL);
            }
        },
        cropMove: function cropMove(event) {
            var action = this.action;
            if (this.disabled || !action) return;
            var pointers = this.pointers;
            event.preventDefault();
            if (dispatchEvent(this.element, EVENT_CROP_MOVE, {
                originalEvent: event,
                action: action
            }) === false) return;
            if (event.changedTouches) forEach(event.changedTouches, function(touch) {
                // The first parameter should not be undefined (#432)
                assign(pointers[touch.identifier] || {}, getPointer(touch, true));
            });
            else assign(pointers[event.pointerId || 0] || {}, getPointer(event, true));
            this.change(event);
        },
        cropEnd: function cropEnd(event) {
            if (this.disabled) return;
            var action = this.action, pointers = this.pointers;
            if (event.changedTouches) forEach(event.changedTouches, function(touch) {
                delete pointers[touch.identifier];
            });
            else delete pointers[event.pointerId || 0];
            if (!action) return;
            event.preventDefault();
            if (!Object.keys(pointers).length) this.action = "";
            if (this.cropping) {
                this.cropping = false;
                toggleClass(this.dragBox, CLASS_MODAL, this.cropped && this.options.modal);
            }
            dispatchEvent(this.element, EVENT_CROP_END, {
                originalEvent: event,
                action: action
            });
        }
    };
    var change = {
        change: function change(event) {
            var options = this.options, canvasData = this.canvasData, containerData = this.containerData, cropBoxData = this.cropBoxData, pointers = this.pointers;
            var action = this.action;
            var aspectRatio = options.aspectRatio;
            var left = cropBoxData.left, top = cropBoxData.top, width = cropBoxData.width, height = cropBoxData.height;
            var right = left + width;
            var bottom = top + height;
            var minLeft = 0;
            var minTop = 0;
            var maxWidth = containerData.width;
            var maxHeight = containerData.height;
            var renderable = true;
            var offset; // Locking aspect ratio in "free mode" by holding shift key
            if (!aspectRatio && event.shiftKey) aspectRatio = width && height ? width / height : 1;
            if (this.limited) {
                minLeft = cropBoxData.minLeft;
                minTop = cropBoxData.minTop;
                maxWidth = minLeft + Math.min(containerData.width, canvasData.width, canvasData.left + canvasData.width);
                maxHeight = minTop + Math.min(containerData.height, canvasData.height, canvasData.top + canvasData.height);
            }
            var pointer = pointers[Object.keys(pointers)[0]];
            var range = {
                x: pointer.endX - pointer.startX,
                y: pointer.endY - pointer.startY
            };
            var check = function check(side) {
                switch(side){
                    case ACTION_EAST:
                        if (right + range.x > maxWidth) range.x = maxWidth - right;
                        break;
                    case ACTION_WEST:
                        if (left + range.x < minLeft) range.x = minLeft - left;
                        break;
                    case ACTION_NORTH:
                        if (top + range.y < minTop) range.y = minTop - top;
                        break;
                    case ACTION_SOUTH:
                        if (bottom + range.y > maxHeight) range.y = maxHeight - bottom;
                        break;
                }
            };
            switch(action){
                // Move crop box
                case ACTION_ALL:
                    left += range.x;
                    top += range.y;
                    break;
                // Resize crop box
                case ACTION_EAST:
                    if (range.x >= 0 && (right >= maxWidth || aspectRatio && (top <= minTop || bottom >= maxHeight))) {
                        renderable = false;
                        break;
                    }
                    check(ACTION_EAST);
                    width += range.x;
                    if (width < 0) {
                        action = ACTION_WEST;
                        width = -width;
                        left -= width;
                    }
                    if (aspectRatio) {
                        height = width / aspectRatio;
                        top += (cropBoxData.height - height) / 2;
                    }
                    break;
                case ACTION_NORTH:
                    if (range.y <= 0 && (top <= minTop || aspectRatio && (left <= minLeft || right >= maxWidth))) {
                        renderable = false;
                        break;
                    }
                    check(ACTION_NORTH);
                    height -= range.y;
                    top += range.y;
                    if (height < 0) {
                        action = ACTION_SOUTH;
                        height = -height;
                        top -= height;
                    }
                    if (aspectRatio) {
                        width = height * aspectRatio;
                        left += (cropBoxData.width - width) / 2;
                    }
                    break;
                case ACTION_WEST:
                    if (range.x <= 0 && (left <= minLeft || aspectRatio && (top <= minTop || bottom >= maxHeight))) {
                        renderable = false;
                        break;
                    }
                    check(ACTION_WEST);
                    width -= range.x;
                    left += range.x;
                    if (width < 0) {
                        action = ACTION_EAST;
                        width = -width;
                        left -= width;
                    }
                    if (aspectRatio) {
                        height = width / aspectRatio;
                        top += (cropBoxData.height - height) / 2;
                    }
                    break;
                case ACTION_SOUTH:
                    if (range.y >= 0 && (bottom >= maxHeight || aspectRatio && (left <= minLeft || right >= maxWidth))) {
                        renderable = false;
                        break;
                    }
                    check(ACTION_SOUTH);
                    height += range.y;
                    if (height < 0) {
                        action = ACTION_NORTH;
                        height = -height;
                        top -= height;
                    }
                    if (aspectRatio) {
                        width = height * aspectRatio;
                        left += (cropBoxData.width - width) / 2;
                    }
                    break;
                case ACTION_NORTH_EAST:
                    if (aspectRatio) {
                        if (range.y <= 0 && (top <= minTop || right >= maxWidth)) {
                            renderable = false;
                            break;
                        }
                        check(ACTION_NORTH);
                        height -= range.y;
                        top += range.y;
                        width = height * aspectRatio;
                    } else {
                        check(ACTION_NORTH);
                        check(ACTION_EAST);
                        if (range.x >= 0) {
                            if (right < maxWidth) width += range.x;
                            else if (range.y <= 0 && top <= minTop) renderable = false;
                        } else width += range.x;
                        if (range.y <= 0) {
                            if (top > minTop) {
                                height -= range.y;
                                top += range.y;
                            }
                        } else {
                            height -= range.y;
                            top += range.y;
                        }
                    }
                    if (width < 0 && height < 0) {
                        action = ACTION_SOUTH_WEST;
                        height = -height;
                        width = -width;
                        top -= height;
                        left -= width;
                    } else if (width < 0) {
                        action = ACTION_NORTH_WEST;
                        width = -width;
                        left -= width;
                    } else if (height < 0) {
                        action = ACTION_SOUTH_EAST;
                        height = -height;
                        top -= height;
                    }
                    break;
                case ACTION_NORTH_WEST:
                    if (aspectRatio) {
                        if (range.y <= 0 && (top <= minTop || left <= minLeft)) {
                            renderable = false;
                            break;
                        }
                        check(ACTION_NORTH);
                        height -= range.y;
                        top += range.y;
                        width = height * aspectRatio;
                        left += cropBoxData.width - width;
                    } else {
                        check(ACTION_NORTH);
                        check(ACTION_WEST);
                        if (range.x <= 0) {
                            if (left > minLeft) {
                                width -= range.x;
                                left += range.x;
                            } else if (range.y <= 0 && top <= minTop) renderable = false;
                        } else {
                            width -= range.x;
                            left += range.x;
                        }
                        if (range.y <= 0) {
                            if (top > minTop) {
                                height -= range.y;
                                top += range.y;
                            }
                        } else {
                            height -= range.y;
                            top += range.y;
                        }
                    }
                    if (width < 0 && height < 0) {
                        action = ACTION_SOUTH_EAST;
                        height = -height;
                        width = -width;
                        top -= height;
                        left -= width;
                    } else if (width < 0) {
                        action = ACTION_NORTH_EAST;
                        width = -width;
                        left -= width;
                    } else if (height < 0) {
                        action = ACTION_SOUTH_WEST;
                        height = -height;
                        top -= height;
                    }
                    break;
                case ACTION_SOUTH_WEST:
                    if (aspectRatio) {
                        if (range.x <= 0 && (left <= minLeft || bottom >= maxHeight)) {
                            renderable = false;
                            break;
                        }
                        check(ACTION_WEST);
                        width -= range.x;
                        left += range.x;
                        height = width / aspectRatio;
                    } else {
                        check(ACTION_SOUTH);
                        check(ACTION_WEST);
                        if (range.x <= 0) {
                            if (left > minLeft) {
                                width -= range.x;
                                left += range.x;
                            } else if (range.y >= 0 && bottom >= maxHeight) renderable = false;
                        } else {
                            width -= range.x;
                            left += range.x;
                        }
                        if (range.y >= 0) {
                            if (bottom < maxHeight) height += range.y;
                        } else height += range.y;
                    }
                    if (width < 0 && height < 0) {
                        action = ACTION_NORTH_EAST;
                        height = -height;
                        width = -width;
                        top -= height;
                        left -= width;
                    } else if (width < 0) {
                        action = ACTION_SOUTH_EAST;
                        width = -width;
                        left -= width;
                    } else if (height < 0) {
                        action = ACTION_NORTH_WEST;
                        height = -height;
                        top -= height;
                    }
                    break;
                case ACTION_SOUTH_EAST:
                    if (aspectRatio) {
                        if (range.x >= 0 && (right >= maxWidth || bottom >= maxHeight)) {
                            renderable = false;
                            break;
                        }
                        check(ACTION_EAST);
                        width += range.x;
                        height = width / aspectRatio;
                    } else {
                        check(ACTION_SOUTH);
                        check(ACTION_EAST);
                        if (range.x >= 0) {
                            if (right < maxWidth) width += range.x;
                            else if (range.y >= 0 && bottom >= maxHeight) renderable = false;
                        } else width += range.x;
                        if (range.y >= 0) {
                            if (bottom < maxHeight) height += range.y;
                        } else height += range.y;
                    }
                    if (width < 0 && height < 0) {
                        action = ACTION_NORTH_WEST;
                        height = -height;
                        width = -width;
                        top -= height;
                        left -= width;
                    } else if (width < 0) {
                        action = ACTION_SOUTH_WEST;
                        width = -width;
                        left -= width;
                    } else if (height < 0) {
                        action = ACTION_NORTH_EAST;
                        height = -height;
                        top -= height;
                    }
                    break;
                // Move canvas
                case ACTION_MOVE:
                    this.move(range.x, range.y);
                    renderable = false;
                    break;
                // Zoom canvas
                case ACTION_ZOOM:
                    this.zoom(getMaxZoomRatio(pointers), event);
                    renderable = false;
                    break;
                // Create crop box
                case ACTION_CROP:
                    if (!range.x || !range.y) {
                        renderable = false;
                        break;
                    }
                    offset = getOffset(this.cropper);
                    left = pointer.startX - offset.left;
                    top = pointer.startY - offset.top;
                    width = cropBoxData.minWidth;
                    height = cropBoxData.minHeight;
                    if (range.x > 0) action = range.y > 0 ? ACTION_SOUTH_EAST : ACTION_NORTH_EAST;
                    else if (range.x < 0) {
                        left -= width;
                        action = range.y > 0 ? ACTION_SOUTH_WEST : ACTION_NORTH_WEST;
                    }
                    if (range.y < 0) top -= height;
                     // Show the crop box if is hidden
                    if (!this.cropped) {
                        removeClass(this.cropBox, CLASS_HIDDEN);
                        this.cropped = true;
                        if (this.limited) this.limitCropBox(true, true);
                    }
                    break;
            }
            if (renderable) {
                cropBoxData.width = width;
                cropBoxData.height = height;
                cropBoxData.left = left;
                cropBoxData.top = top;
                this.action = action;
                this.renderCropBox();
            } // Override
            forEach(pointers, function(p) {
                p.startX = p.endX;
                p.startY = p.endY;
            });
        }
    };
    var methods = {
        // Show the crop box manually
        crop: function crop() {
            if (this.ready && !this.cropped && !this.disabled) {
                this.cropped = true;
                this.limitCropBox(true, true);
                if (this.options.modal) addClass(this.dragBox, CLASS_MODAL);
                removeClass(this.cropBox, CLASS_HIDDEN);
                this.setCropBoxData(this.initialCropBoxData);
            }
            return this;
        },
        // Reset the image and crop box to their initial states
        reset: function reset() {
            if (this.ready && !this.disabled) {
                this.imageData = assign({}, this.initialImageData);
                this.canvasData = assign({}, this.initialCanvasData);
                this.cropBoxData = assign({}, this.initialCropBoxData);
                this.renderCanvas();
                if (this.cropped) this.renderCropBox();
            }
            return this;
        },
        // Clear the crop box
        clear: function clear() {
            if (this.cropped && !this.disabled) {
                assign(this.cropBoxData, {
                    left: 0,
                    top: 0,
                    width: 0,
                    height: 0
                });
                this.cropped = false;
                this.renderCropBox();
                this.limitCanvas(true, true); // Render canvas after crop box rendered
                this.renderCanvas();
                removeClass(this.dragBox, CLASS_MODAL);
                addClass(this.cropBox, CLASS_HIDDEN);
            }
            return this;
        },
        /**
     * Replace the image's src and rebuild the cropper
     * @param {string} url - The new URL.
     * @param {boolean} [hasSameSize] - Indicate if the new image has the same size as the old one.
     * @returns {Cropper} this
     */ replace: function replace(url) {
            var hasSameSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            if (!this.disabled && url) {
                if (this.isImg) this.element.src = url;
                if (hasSameSize) {
                    this.url = url;
                    this.image.src = url;
                    if (this.ready) {
                        this.viewBoxImage.src = url;
                        forEach(this.previews, function(element) {
                            element.getElementsByTagName("img")[0].src = url;
                        });
                    }
                } else {
                    if (this.isImg) this.replaced = true;
                    this.options.data = null;
                    this.uncreate();
                    this.load(url);
                }
            }
            return this;
        },
        // Enable (unfreeze) the cropper
        enable: function enable() {
            if (this.ready && this.disabled) {
                this.disabled = false;
                removeClass(this.cropper, CLASS_DISABLED);
            }
            return this;
        },
        // Disable (freeze) the cropper
        disable: function disable() {
            if (this.ready && !this.disabled) {
                this.disabled = true;
                addClass(this.cropper, CLASS_DISABLED);
            }
            return this;
        },
        /**
     * Destroy the cropper and remove the instance from the image
     * @returns {Cropper} this
     */ destroy: function destroy() {
            var element = this.element;
            if (!element[NAMESPACE]) return this;
            element[NAMESPACE] = undefined;
            if (this.isImg && this.replaced) element.src = this.originalUrl;
            this.uncreate();
            return this;
        },
        /**
     * Move the canvas with relative offsets
     * @param {number} offsetX - The relative offset distance on the x-axis.
     * @param {number} [offsetY=offsetX] - The relative offset distance on the y-axis.
     * @returns {Cropper} this
     */ move: function move(offsetX) {
            var offsetY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : offsetX;
            var _this$canvasData = this.canvasData, left = _this$canvasData.left, top = _this$canvasData.top;
            return this.moveTo(isUndefined(offsetX) ? offsetX : left + Number(offsetX), isUndefined(offsetY) ? offsetY : top + Number(offsetY));
        },
        /**
     * Move the canvas to an absolute point
     * @param {number} x - The x-axis coordinate.
     * @param {number} [y=x] - The y-axis coordinate.
     * @returns {Cropper} this
     */ moveTo: function moveTo(x) {
            var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : x;
            var canvasData = this.canvasData;
            var changed = false;
            x = Number(x);
            y = Number(y);
            if (this.ready && !this.disabled && this.options.movable) {
                if (isNumber(x)) {
                    canvasData.left = x;
                    changed = true;
                }
                if (isNumber(y)) {
                    canvasData.top = y;
                    changed = true;
                }
                if (changed) this.renderCanvas(true);
            }
            return this;
        },
        /**
     * Zoom the canvas with a relative ratio
     * @param {number} ratio - The target ratio.
     * @param {Event} _originalEvent - The original event if any.
     * @returns {Cropper} this
     */ zoom: function zoom(ratio, _originalEvent) {
            var canvasData = this.canvasData;
            ratio = Number(ratio);
            if (ratio < 0) ratio = 1 / (1 - ratio);
            else ratio = 1 + ratio;
            return this.zoomTo(canvasData.width * ratio / canvasData.naturalWidth, null, _originalEvent);
        },
        /**
     * Zoom the canvas to an absolute ratio
     * @param {number} ratio - The target ratio.
     * @param {Object} pivot - The zoom pivot point coordinate.
     * @param {Event} _originalEvent - The original event if any.
     * @returns {Cropper} this
     */ zoomTo: function zoomTo(ratio, pivot, _originalEvent) {
            var options = this.options, canvasData = this.canvasData;
            var width = canvasData.width, height = canvasData.height, naturalWidth = canvasData.naturalWidth, naturalHeight = canvasData.naturalHeight;
            ratio = Number(ratio);
            if (ratio >= 0 && this.ready && !this.disabled && options.zoomable) {
                var newWidth = naturalWidth * ratio;
                var newHeight = naturalHeight * ratio;
                if (dispatchEvent(this.element, EVENT_ZOOM, {
                    ratio: ratio,
                    oldRatio: width / naturalWidth,
                    originalEvent: _originalEvent
                }) === false) return this;
                if (_originalEvent) {
                    var pointers = this.pointers;
                    var offset = getOffset(this.cropper);
                    var center = pointers && Object.keys(pointers).length ? getPointersCenter(pointers) : {
                        pageX: _originalEvent.pageX,
                        pageY: _originalEvent.pageY
                    }; // Zoom from the triggering point of the event
                    canvasData.left -= (newWidth - width) * ((center.pageX - offset.left - canvasData.left) / width);
                    canvasData.top -= (newHeight - height) * ((center.pageY - offset.top - canvasData.top) / height);
                } else if (isPlainObject(pivot) && isNumber(pivot.x) && isNumber(pivot.y)) {
                    canvasData.left -= (newWidth - width) * ((pivot.x - canvasData.left) / width);
                    canvasData.top -= (newHeight - height) * ((pivot.y - canvasData.top) / height);
                } else {
                    // Zoom from the center of the canvas
                    canvasData.left -= (newWidth - width) / 2;
                    canvasData.top -= (newHeight - height) / 2;
                }
                canvasData.width = newWidth;
                canvasData.height = newHeight;
                this.renderCanvas(true);
            }
            return this;
        },
        /**
     * Rotate the canvas with a relative degree
     * @param {number} degree - The rotate degree.
     * @returns {Cropper} this
     */ rotate: function rotate(degree) {
            return this.rotateTo((this.imageData.rotate || 0) + Number(degree));
        },
        /**
     * Rotate the canvas to an absolute degree
     * @param {number} degree - The rotate degree.
     * @returns {Cropper} this
     */ rotateTo: function rotateTo(degree) {
            degree = Number(degree);
            if (isNumber(degree) && this.ready && !this.disabled && this.options.rotatable) {
                this.imageData.rotate = degree % 360;
                this.renderCanvas(true, true);
            }
            return this;
        },
        /**
     * Scale the image on the x-axis.
     * @param {number} scaleX - The scale ratio on the x-axis.
     * @returns {Cropper} this
     */ scaleX: function scaleX(_scaleX) {
            var scaleY = this.imageData.scaleY;
            return this.scale(_scaleX, isNumber(scaleY) ? scaleY : 1);
        },
        /**
     * Scale the image on the y-axis.
     * @param {number} scaleY - The scale ratio on the y-axis.
     * @returns {Cropper} this
     */ scaleY: function scaleY(_scaleY) {
            var scaleX = this.imageData.scaleX;
            return this.scale(isNumber(scaleX) ? scaleX : 1, _scaleY);
        },
        /**
     * Scale the image
     * @param {number} scaleX - The scale ratio on the x-axis.
     * @param {number} [scaleY=scaleX] - The scale ratio on the y-axis.
     * @returns {Cropper} this
     */ scale: function scale(scaleX) {
            var scaleY = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : scaleX;
            var imageData = this.imageData;
            var transformed = false;
            scaleX = Number(scaleX);
            scaleY = Number(scaleY);
            if (this.ready && !this.disabled && this.options.scalable) {
                if (isNumber(scaleX)) {
                    imageData.scaleX = scaleX;
                    transformed = true;
                }
                if (isNumber(scaleY)) {
                    imageData.scaleY = scaleY;
                    transformed = true;
                }
                if (transformed) this.renderCanvas(true, true);
            }
            return this;
        },
        /**
     * Get the cropped area position and size data (base on the original image)
     * @param {boolean} [rounded=false] - Indicate if round the data values or not.
     * @returns {Object} The result cropped data.
     */ getData: function getData() {
            var rounded = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            var options = this.options, imageData = this.imageData, canvasData = this.canvasData, cropBoxData = this.cropBoxData;
            var data;
            if (this.ready && this.cropped) {
                data = {
                    x: cropBoxData.left - canvasData.left,
                    y: cropBoxData.top - canvasData.top,
                    width: cropBoxData.width,
                    height: cropBoxData.height
                };
                var ratio = imageData.width / imageData.naturalWidth;
                forEach(data, function(n, i) {
                    data[i] = n / ratio;
                });
                if (rounded) {
                    // In case rounding off leads to extra 1px in right or bottom border
                    // we should round the top-left corner and the dimension (#343).
                    var bottom = Math.round(data.y + data.height);
                    var right = Math.round(data.x + data.width);
                    data.x = Math.round(data.x);
                    data.y = Math.round(data.y);
                    data.width = right - data.x;
                    data.height = bottom - data.y;
                }
            } else data = {
                x: 0,
                y: 0,
                width: 0,
                height: 0
            };
            if (options.rotatable) data.rotate = imageData.rotate || 0;
            if (options.scalable) {
                data.scaleX = imageData.scaleX || 1;
                data.scaleY = imageData.scaleY || 1;
            }
            return data;
        },
        /**
     * Set the cropped area position and size with new data
     * @param {Object} data - The new data.
     * @returns {Cropper} this
     */ setData: function setData(data) {
            var options = this.options, imageData = this.imageData, canvasData = this.canvasData;
            var cropBoxData = {};
            if (this.ready && !this.disabled && isPlainObject(data)) {
                var transformed = false;
                if (options.rotatable) {
                    if (isNumber(data.rotate) && data.rotate !== imageData.rotate) {
                        imageData.rotate = data.rotate;
                        transformed = true;
                    }
                }
                if (options.scalable) {
                    if (isNumber(data.scaleX) && data.scaleX !== imageData.scaleX) {
                        imageData.scaleX = data.scaleX;
                        transformed = true;
                    }
                    if (isNumber(data.scaleY) && data.scaleY !== imageData.scaleY) {
                        imageData.scaleY = data.scaleY;
                        transformed = true;
                    }
                }
                if (transformed) this.renderCanvas(true, true);
                var ratio = imageData.width / imageData.naturalWidth;
                if (isNumber(data.x)) cropBoxData.left = data.x * ratio + canvasData.left;
                if (isNumber(data.y)) cropBoxData.top = data.y * ratio + canvasData.top;
                if (isNumber(data.width)) cropBoxData.width = data.width * ratio;
                if (isNumber(data.height)) cropBoxData.height = data.height * ratio;
                this.setCropBoxData(cropBoxData);
            }
            return this;
        },
        /**
     * Get the container size data.
     * @returns {Object} The result container data.
     */ getContainerData: function getContainerData() {
            return this.ready ? assign({}, this.containerData) : {};
        },
        /**
     * Get the image position and size data.
     * @returns {Object} The result image data.
     */ getImageData: function getImageData() {
            return this.sized ? assign({}, this.imageData) : {};
        },
        /**
     * Get the canvas position and size data.
     * @returns {Object} The result canvas data.
     */ getCanvasData: function getCanvasData() {
            var canvasData = this.canvasData;
            var data = {};
            if (this.ready) forEach([
                "left",
                "top",
                "width",
                "height",
                "naturalWidth",
                "naturalHeight"
            ], function(n) {
                data[n] = canvasData[n];
            });
            return data;
        },
        /**
     * Set the canvas position and size with new data.
     * @param {Object} data - The new canvas data.
     * @returns {Cropper} this
     */ setCanvasData: function setCanvasData(data) {
            var canvasData = this.canvasData;
            var aspectRatio = canvasData.aspectRatio;
            if (this.ready && !this.disabled && isPlainObject(data)) {
                if (isNumber(data.left)) canvasData.left = data.left;
                if (isNumber(data.top)) canvasData.top = data.top;
                if (isNumber(data.width)) {
                    canvasData.width = data.width;
                    canvasData.height = data.width / aspectRatio;
                } else if (isNumber(data.height)) {
                    canvasData.height = data.height;
                    canvasData.width = data.height * aspectRatio;
                }
                this.renderCanvas(true);
            }
            return this;
        },
        /**
     * Get the crop box position and size data.
     * @returns {Object} The result crop box data.
     */ getCropBoxData: function getCropBoxData() {
            var cropBoxData = this.cropBoxData;
            var data;
            if (this.ready && this.cropped) data = {
                left: cropBoxData.left,
                top: cropBoxData.top,
                width: cropBoxData.width,
                height: cropBoxData.height
            };
            return data || {};
        },
        /**
     * Set the crop box position and size with new data.
     * @param {Object} data - The new crop box data.
     * @returns {Cropper} this
     */ setCropBoxData: function setCropBoxData(data) {
            var cropBoxData = this.cropBoxData;
            var aspectRatio = this.options.aspectRatio;
            var widthChanged;
            var heightChanged;
            if (this.ready && this.cropped && !this.disabled && isPlainObject(data)) {
                if (isNumber(data.left)) cropBoxData.left = data.left;
                if (isNumber(data.top)) cropBoxData.top = data.top;
                if (isNumber(data.width) && data.width !== cropBoxData.width) {
                    widthChanged = true;
                    cropBoxData.width = data.width;
                }
                if (isNumber(data.height) && data.height !== cropBoxData.height) {
                    heightChanged = true;
                    cropBoxData.height = data.height;
                }
                if (aspectRatio) {
                    if (widthChanged) cropBoxData.height = cropBoxData.width / aspectRatio;
                    else if (heightChanged) cropBoxData.width = cropBoxData.height * aspectRatio;
                }
                this.renderCropBox();
            }
            return this;
        },
        /**
     * Get a canvas drawn the cropped image.
     * @param {Object} [options={}] - The config options.
     * @returns {HTMLCanvasElement} - The result canvas.
     */ getCroppedCanvas: function getCroppedCanvas() {
            var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            if (!this.ready || !window.HTMLCanvasElement) return null;
            var canvasData = this.canvasData;
            var source = getSourceCanvas(this.image, this.imageData, canvasData, options); // Returns the source canvas if it is not cropped.
            if (!this.cropped) return source;
            var _this$getData = this.getData(), initialX = _this$getData.x, initialY = _this$getData.y, initialWidth = _this$getData.width, initialHeight = _this$getData.height;
            var ratio = source.width / Math.floor(canvasData.naturalWidth);
            if (ratio !== 1) {
                initialX *= ratio;
                initialY *= ratio;
                initialWidth *= ratio;
                initialHeight *= ratio;
            }
            var aspectRatio = initialWidth / initialHeight;
            var maxSizes = getAdjustedSizes({
                aspectRatio: aspectRatio,
                width: options.maxWidth || Infinity,
                height: options.maxHeight || Infinity
            });
            var minSizes = getAdjustedSizes({
                aspectRatio: aspectRatio,
                width: options.minWidth || 0,
                height: options.minHeight || 0
            }, "cover");
            var _getAdjustedSizes = getAdjustedSizes({
                aspectRatio: aspectRatio,
                width: options.width || (ratio !== 1 ? source.width : initialWidth),
                height: options.height || (ratio !== 1 ? source.height : initialHeight)
            }), width = _getAdjustedSizes.width, height = _getAdjustedSizes.height;
            width = Math.min(maxSizes.width, Math.max(minSizes.width, width));
            height = Math.min(maxSizes.height, Math.max(minSizes.height, height));
            var canvas = document.createElement("canvas");
            var context = canvas.getContext("2d");
            canvas.width = normalizeDecimalNumber(width);
            canvas.height = normalizeDecimalNumber(height);
            context.fillStyle = options.fillColor || "transparent";
            context.fillRect(0, 0, width, height);
            var _options$imageSmoothi = options.imageSmoothingEnabled, imageSmoothingEnabled = _options$imageSmoothi === void 0 ? true : _options$imageSmoothi, imageSmoothingQuality = options.imageSmoothingQuality;
            context.imageSmoothingEnabled = imageSmoothingEnabled;
            if (imageSmoothingQuality) context.imageSmoothingQuality = imageSmoothingQuality;
             // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D.drawImage
            var sourceWidth = source.width;
            var sourceHeight = source.height; // Source canvas parameters
            var srcX = initialX;
            var srcY = initialY;
            var srcWidth;
            var srcHeight; // Destination canvas parameters
            var dstX;
            var dstY;
            var dstWidth;
            var dstHeight;
            if (srcX <= -initialWidth || srcX > sourceWidth) {
                srcX = 0;
                srcWidth = 0;
                dstX = 0;
                dstWidth = 0;
            } else if (srcX <= 0) {
                dstX = -srcX;
                srcX = 0;
                srcWidth = Math.min(sourceWidth, initialWidth + srcX);
                dstWidth = srcWidth;
            } else if (srcX <= sourceWidth) {
                dstX = 0;
                srcWidth = Math.min(initialWidth, sourceWidth - srcX);
                dstWidth = srcWidth;
            }
            if (srcWidth <= 0 || srcY <= -initialHeight || srcY > sourceHeight) {
                srcY = 0;
                srcHeight = 0;
                dstY = 0;
                dstHeight = 0;
            } else if (srcY <= 0) {
                dstY = -srcY;
                srcY = 0;
                srcHeight = Math.min(sourceHeight, initialHeight + srcY);
                dstHeight = srcHeight;
            } else if (srcY <= sourceHeight) {
                dstY = 0;
                srcHeight = Math.min(initialHeight, sourceHeight - srcY);
                dstHeight = srcHeight;
            }
            var params = [
                srcX,
                srcY,
                srcWidth,
                srcHeight
            ]; // Avoid "IndexSizeError"
            if (dstWidth > 0 && dstHeight > 0) {
                var scale = width / initialWidth;
                params.push(dstX * scale, dstY * scale, dstWidth * scale, dstHeight * scale);
            } // All the numerical parameters should be integer for `drawImage`
            // https://github.com/fengyuanchen/cropper/issues/476
            context.drawImage.apply(context, [
                source
            ].concat(_toConsumableArray(params.map(function(param) {
                return Math.floor(normalizeDecimalNumber(param));
            }))));
            return canvas;
        },
        /**
     * Change the aspect ratio of the crop box.
     * @param {number} aspectRatio - The new aspect ratio.
     * @returns {Cropper} this
     */ setAspectRatio: function setAspectRatio(aspectRatio) {
            var options = this.options;
            if (!this.disabled && !isUndefined(aspectRatio)) {
                // 0 -> NaN
                options.aspectRatio = Math.max(0, aspectRatio) || NaN;
                if (this.ready) {
                    this.initCropBox();
                    if (this.cropped) this.renderCropBox();
                }
            }
            return this;
        },
        /**
     * Change the drag mode.
     * @param {string} mode - The new drag mode.
     * @returns {Cropper} this
     */ setDragMode: function setDragMode(mode) {
            var options = this.options, dragBox = this.dragBox, face = this.face;
            if (this.ready && !this.disabled) {
                var croppable = mode === DRAG_MODE_CROP;
                var movable = options.movable && mode === DRAG_MODE_MOVE;
                mode = croppable || movable ? mode : DRAG_MODE_NONE;
                options.dragMode = mode;
                setData(dragBox, DATA_ACTION, mode);
                toggleClass(dragBox, CLASS_CROP, croppable);
                toggleClass(dragBox, CLASS_MOVE, movable);
                if (!options.cropBoxMovable) {
                    // Sync drag mode to crop box when it is not movable
                    setData(face, DATA_ACTION, mode);
                    toggleClass(face, CLASS_CROP, croppable);
                    toggleClass(face, CLASS_MOVE, movable);
                }
            }
            return this;
        }
    };
    var AnotherCropper = WINDOW.Cropper;
    var Cropper = /*#__PURE__*/ function() {
        /**
     * Create a new Cropper.
     * @param {Element} element - The target element for cropping.
     * @param {Object} [options={}] - The configuration options.
     */ function Cropper(element) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            _classCallCheck(this, Cropper);
            if (!element || !REGEXP_TAG_NAME.test(element.tagName)) throw new Error("The first argument is required and must be an <img> or <canvas> element.");
            this.element = element;
            this.options = assign({}, DEFAULTS, isPlainObject(options) && options);
            this.cropped = false;
            this.disabled = false;
            this.pointers = {};
            this.ready = false;
            this.reloading = false;
            this.replaced = false;
            this.sized = false;
            this.sizing = false;
            this.init();
        }
        _createClass(Cropper, [
            {
                key: "init",
                value: function init() {
                    var element = this.element;
                    var tagName = element.tagName.toLowerCase();
                    var url;
                    if (element[NAMESPACE]) return;
                    element[NAMESPACE] = this;
                    if (tagName === "img") {
                        this.isImg = true; // e.g.: "img/picture.jpg"
                        url = element.getAttribute("src") || "";
                        this.originalUrl = url; // Stop when it's a blank image
                        if (!url) return;
                         // e.g.: "https://example.com/img/picture.jpg"
                        url = element.src;
                    } else if (tagName === "canvas" && window.HTMLCanvasElement) url = element.toDataURL();
                    this.load(url);
                }
            },
            {
                key: "load",
                value: function load(url) {
                    var _this = this;
                    if (!url) return;
                    this.url = url;
                    this.imageData = {};
                    var element = this.element, options = this.options;
                    if (!options.rotatable && !options.scalable) options.checkOrientation = false;
                     // Only IE10+ supports Typed Arrays
                    if (!options.checkOrientation || !window.ArrayBuffer) {
                        this.clone();
                        return;
                    } // Detect the mime type of the image directly if it is a Data URL
                    if (REGEXP_DATA_URL.test(url)) {
                        // Read ArrayBuffer from Data URL of JPEG images directly for better performance
                        if (REGEXP_DATA_URL_JPEG.test(url)) this.read(dataURLToArrayBuffer(url));
                        else // Only a JPEG image may contains Exif Orientation information,
                        // the rest types of Data URLs are not necessary to check orientation at all.
                        this.clone();
                        return;
                    } // 1. Detect the mime type of the image by a XMLHttpRequest.
                    // 2. Load the image as ArrayBuffer for reading orientation if its a JPEG image.
                    var xhr = new XMLHttpRequest();
                    var clone = this.clone.bind(this);
                    this.reloading = true;
                    this.xhr = xhr; // 1. Cross origin requests are only supported for protocol schemes:
                    // http, https, data, chrome, chrome-extension.
                    // 2. Access to XMLHttpRequest from a Data URL will be blocked by CORS policy
                    // in some browsers as IE11 and Safari.
                    xhr.onabort = clone;
                    xhr.onerror = clone;
                    xhr.ontimeout = clone;
                    xhr.onprogress = function() {
                        // Abort the request directly if it not a JPEG image for better performance
                        if (xhr.getResponseHeader("content-type") !== MIME_TYPE_JPEG) xhr.abort();
                    };
                    xhr.onload = function() {
                        _this.read(xhr.response);
                    };
                    xhr.onloadend = function() {
                        _this.reloading = false;
                        _this.xhr = null;
                    }; // Bust cache when there is a "crossOrigin" property to avoid browser cache error
                    if (options.checkCrossOrigin && isCrossOriginURL(url) && element.crossOrigin) url = addTimestamp(url);
                    xhr.open("GET", url);
                    xhr.responseType = "arraybuffer";
                    xhr.withCredentials = element.crossOrigin === "use-credentials";
                    xhr.send();
                }
            },
            {
                key: "read",
                value: function read(arrayBuffer) {
                    var options = this.options, imageData = this.imageData; // Reset the orientation value to its default value 1
                    // as some iOS browsers will render image with its orientation
                    var orientation = resetAndGetOrientation(arrayBuffer);
                    var rotate = 0;
                    var scaleX = 1;
                    var scaleY = 1;
                    if (orientation > 1) {
                        // Generate a new URL which has the default orientation value
                        this.url = arrayBufferToDataURL(arrayBuffer, MIME_TYPE_JPEG);
                        var _parseOrientation = parseOrientation(orientation);
                        rotate = _parseOrientation.rotate;
                        scaleX = _parseOrientation.scaleX;
                        scaleY = _parseOrientation.scaleY;
                    }
                    if (options.rotatable) imageData.rotate = rotate;
                    if (options.scalable) {
                        imageData.scaleX = scaleX;
                        imageData.scaleY = scaleY;
                    }
                    this.clone();
                }
            },
            {
                key: "clone",
                value: function clone() {
                    var element = this.element, url = this.url;
                    var crossOrigin = element.crossOrigin;
                    var crossOriginUrl = url;
                    if (this.options.checkCrossOrigin && isCrossOriginURL(url)) {
                        if (!crossOrigin) crossOrigin = "anonymous";
                         // Bust cache when there is not a "crossOrigin" property (#519)
                        crossOriginUrl = addTimestamp(url);
                    }
                    this.crossOrigin = crossOrigin;
                    this.crossOriginUrl = crossOriginUrl;
                    var image = document.createElement("img");
                    if (crossOrigin) image.crossOrigin = crossOrigin;
                    image.src = crossOriginUrl || url;
                    image.alt = element.alt || "The image to crop";
                    this.image = image;
                    image.onload = this.start.bind(this);
                    image.onerror = this.stop.bind(this);
                    addClass(image, CLASS_HIDE);
                    element.parentNode.insertBefore(image, element.nextSibling);
                }
            },
            {
                key: "start",
                value: function start() {
                    var _this2 = this;
                    var image = this.image;
                    image.onload = null;
                    image.onerror = null;
                    this.sizing = true; // Match all browsers that use WebKit as the layout engine in iOS devices,
                    // such as Safari for iOS, Chrome for iOS, and in-app browsers.
                    var isIOSWebKit = WINDOW.navigator && /(?:iPad|iPhone|iPod).*?AppleWebKit/i.test(WINDOW.navigator.userAgent);
                    var done = function done(naturalWidth, naturalHeight) {
                        assign(_this2.imageData, {
                            naturalWidth: naturalWidth,
                            naturalHeight: naturalHeight,
                            aspectRatio: naturalWidth / naturalHeight
                        });
                        _this2.sizing = false;
                        _this2.sized = true;
                        _this2.build();
                    }; // Most modern browsers (excepts iOS WebKit)
                    if (image.naturalWidth && !isIOSWebKit) {
                        done(image.naturalWidth, image.naturalHeight);
                        return;
                    }
                    var sizingImage = document.createElement("img");
                    var body = document.body || document.documentElement;
                    this.sizingImage = sizingImage;
                    sizingImage.onload = function() {
                        done(sizingImage.width, sizingImage.height);
                        if (!isIOSWebKit) body.removeChild(sizingImage);
                    };
                    sizingImage.src = image.src; // iOS WebKit will convert the image automatically
                    // with its orientation once append it into DOM (#279)
                    if (!isIOSWebKit) {
                        sizingImage.style.cssText = "left:0;max-height:none!important;max-width:none!important;min-height:0!important;min-width:0!important;opacity:0;position:absolute;top:0;z-index:-1;";
                        body.appendChild(sizingImage);
                    }
                }
            },
            {
                key: "stop",
                value: function stop() {
                    var image = this.image;
                    image.onload = null;
                    image.onerror = null;
                    image.parentNode.removeChild(image);
                    this.image = null;
                }
            },
            {
                key: "build",
                value: function build() {
                    if (!this.sized || this.ready) return;
                    var element = this.element, options = this.options, image = this.image; // Create cropper elements
                    var container = element.parentNode;
                    var template = document.createElement("div");
                    template.innerHTML = TEMPLATE;
                    var cropper = template.querySelector(".".concat(NAMESPACE, "-container"));
                    var canvas = cropper.querySelector(".".concat(NAMESPACE, "-canvas"));
                    var dragBox = cropper.querySelector(".".concat(NAMESPACE, "-drag-box"));
                    var cropBox = cropper.querySelector(".".concat(NAMESPACE, "-crop-box"));
                    var face = cropBox.querySelector(".".concat(NAMESPACE, "-face"));
                    this.container = container;
                    this.cropper = cropper;
                    this.canvas = canvas;
                    this.dragBox = dragBox;
                    this.cropBox = cropBox;
                    this.viewBox = cropper.querySelector(".".concat(NAMESPACE, "-view-box"));
                    this.face = face;
                    canvas.appendChild(image); // Hide the original image
                    addClass(element, CLASS_HIDDEN); // Inserts the cropper after to the current image
                    container.insertBefore(cropper, element.nextSibling); // Show the image if is hidden
                    if (!this.isImg) removeClass(image, CLASS_HIDE);
                    this.initPreview();
                    this.bind();
                    options.initialAspectRatio = Math.max(0, options.initialAspectRatio) || NaN;
                    options.aspectRatio = Math.max(0, options.aspectRatio) || NaN;
                    options.viewMode = Math.max(0, Math.min(3, Math.round(options.viewMode))) || 0;
                    addClass(cropBox, CLASS_HIDDEN);
                    if (!options.guides) addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-dashed")), CLASS_HIDDEN);
                    if (!options.center) addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-center")), CLASS_HIDDEN);
                    if (options.background) addClass(cropper, "".concat(NAMESPACE, "-bg"));
                    if (!options.highlight) addClass(face, CLASS_INVISIBLE);
                    if (options.cropBoxMovable) {
                        addClass(face, CLASS_MOVE);
                        setData(face, DATA_ACTION, ACTION_ALL);
                    }
                    if (!options.cropBoxResizable) {
                        addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-line")), CLASS_HIDDEN);
                        addClass(cropBox.getElementsByClassName("".concat(NAMESPACE, "-point")), CLASS_HIDDEN);
                    }
                    this.render();
                    this.ready = true;
                    this.setDragMode(options.dragMode);
                    if (options.autoCrop) this.crop();
                    this.setData(options.data);
                    if (isFunction(options.ready)) addListener(element, EVENT_READY, options.ready, {
                        once: true
                    });
                    dispatchEvent(element, EVENT_READY);
                }
            },
            {
                key: "unbuild",
                value: function unbuild() {
                    if (!this.ready) return;
                    this.ready = false;
                    this.unbind();
                    this.resetPreview();
                    this.cropper.parentNode.removeChild(this.cropper);
                    removeClass(this.element, CLASS_HIDDEN);
                }
            },
            {
                key: "uncreate",
                value: function uncreate() {
                    if (this.ready) {
                        this.unbuild();
                        this.ready = false;
                        this.cropped = false;
                    } else if (this.sizing) {
                        this.sizingImage.onload = null;
                        this.sizing = false;
                        this.sized = false;
                    } else if (this.reloading) {
                        this.xhr.onabort = null;
                        this.xhr.abort();
                    } else if (this.image) this.stop();
                }
            }
        ], [
            {
                key: "noConflict",
                value: function noConflict() {
                    window.Cropper = AnotherCropper;
                    return Cropper;
                }
            },
            {
                key: "setDefaults",
                value: function setDefaults(options) {
                    assign(DEFAULTS, isPlainObject(options) && options);
                }
            }
        ]);
        return Cropper;
    }();
    assign(Cropper.prototype, render, preview, events, handlers, change, methods);
    return Cropper;
});

});


parcelRegister("sPEoj", function(module, exports) {
"use strict";
module.exports = {
    strings: {
        revert: "Revert",
        rotate: "Rotate",
        zoomIn: "Zoom in",
        zoomOut: "Zoom out",
        flipHorizontal: "Flip horizontal",
        aspectRatioSquare: "Crop square",
        aspectRatioLandscape: "Crop landscape (16:9)",
        aspectRatioPortrait: "Crop portrait (9:16)"
    }
};

});


parcelRegister("2OwWq", function(module, exports) {

$parcel$export(module.exports, "default", () => $20c9cdbaf191eab1$export$2e2bcd8739ae039);
$parcel$export(module.exports, "FormGroup", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("7kkwd")))));

var $gxGeN = parcelRequire("gxGeN");

var $7kkwd = parcelRequire("7kkwd");
var $20c9cdbaf191eab1$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($gxGeN)));

});
parcelRegister("gxGeN", function(module, exports) {
"use strict";
var $c0b07df2ff4a4b2c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $c0b07df2ff4a4b2c$var$react_1 = $c0b07df2ff4a4b2c$var$__importDefault((parcelRequire("acw62")));

var $c7ZWm = parcelRequire("c7ZWm");
const $c0b07df2ff4a4b2c$var$Form = (props)=>{
    const { dataLwtId: dataLwtId, ...restProps } = props;
    return $c0b07df2ff4a4b2c$var$react_1.default.createElement($c7ZWm.default, {
        "data-lwt-id": dataLwtId,
        ...restProps
    });
};
module.exports.default = $c0b07df2ff4a4b2c$var$Form;

});
parcelRegister("c7ZWm", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d462f8963186e3a$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $hDpcU = parcelRequire("hDpcU");

var $g7ajw = parcelRequire("g7ajw");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $e9hDx = parcelRequire("e9hDx");
var $8d462f8963186e3a$var$propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    inline: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    tag: (0, $e9hDx.tagPropType),
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $8d462f8963186e3a$var$defaultProps = {
    tag: "form"
};
var $8d462f8963186e3a$var$Form = /*#__PURE__*/ function(_Component) {
    (0, $g7ajw.default)(Form, _Component);
    function Form(props) {
        var _this;
        _this = _Component.call(this, props) || this;
        _this.getRef = _this.getRef.bind((0, $hDpcU.default)(_this));
        _this.submit = _this.submit.bind((0, $hDpcU.default)(_this));
        return _this;
    }
    var _proto = Form.prototype;
    _proto.getRef = function getRef(ref) {
        if (this.props.innerRef) this.props.innerRef(ref);
        this.ref = ref;
    };
    _proto.submit = function submit() {
        if (this.ref) this.ref.submit();
    };
    _proto.render = function render() {
        var _this$props = this.props, className = _this$props.className, cssModule = _this$props.cssModule, inline = _this$props.inline, Tag = _this$props.tag, innerRef = _this$props.innerRef, attributes = (0, $1En50.default)(_this$props, [
            "className",
            "cssModule",
            "inline",
            "tag",
            "innerRef"
        ]);
        var classes = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, inline ? "form-inline" : false), cssModule);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({}, attributes, {
            ref: innerRef,
            className: classes
        }));
    };
    return Form;
}((0, $acw62.Component));
$8d462f8963186e3a$var$Form.propTypes = $8d462f8963186e3a$var$propTypes;
$8d462f8963186e3a$var$Form.defaultProps = $8d462f8963186e3a$var$defaultProps;
var $8d462f8963186e3a$export$2e2bcd8739ae039 = $8d462f8963186e3a$var$Form;

});


parcelRegister("7kkwd", function(module, exports) {
"use strict";
var $555a51401488c40f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $555a51401488c40f$var$react_1 = $555a51401488c40f$var$__importDefault((parcelRequire("acw62")));

var $gjbPq = parcelRequire("gjbPq");
const $555a51401488c40f$var$FormGroup = (props)=>{
    const { dataLwtId: dataLwtId, ...restProps } = props;
    return $555a51401488c40f$var$react_1.default.createElement($gjbPq.default, {
        "data-lwt-id": dataLwtId,
        ...restProps
    });
};
module.exports.default = $555a51401488c40f$var$FormGroup;

});
parcelRegister("gjbPq", function(module, exports) {

$parcel$export(module.exports, "default", () => $bdf798984aa4c258$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $e9hDx = parcelRequire("e9hDx");
var $bdf798984aa4c258$var$propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    row: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    check: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    inline: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    tag: (0, $e9hDx.tagPropType),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $bdf798984aa4c258$var$defaultProps = {
    tag: "div"
};
var $bdf798984aa4c258$var$FormGroup = function FormGroup(props) {
    var className = props.className, cssModule = props.cssModule, row = props.row, disabled = props.disabled, check = props.check, inline = props.inline, Tag = props.tag, attributes = (0, $1En50.default)(props, [
        "className",
        "cssModule",
        "row",
        "disabled",
        "check",
        "inline",
        "tag"
    ]);
    var classes = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, row ? "row" : false, check ? "form-check" : "form-group", check && inline ? "form-check-inline" : false, check && disabled ? "disabled" : false), cssModule);
    if (Tag === "fieldset") attributes.disabled = disabled;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({}, attributes, {
        className: classes
    }));
};
$bdf798984aa4c258$var$FormGroup.propTypes = $bdf798984aa4c258$var$propTypes;
$bdf798984aa4c258$var$FormGroup.defaultProps = $bdf798984aa4c258$var$defaultProps;
var $bdf798984aa4c258$export$2e2bcd8739ae039 = $bdf798984aa4c258$var$FormGroup;

});



parcelRegister("f3gEZ", function(module, exports) {
"use strict";
function $af540f293314ba66$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $af540f293314ba66$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $af540f293314ba66$var$_arrayLikeToArray(o, minLen);
}
function $af540f293314ba66$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $af540f293314ba66$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $af540f293314ba66$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $af540f293314ba66$var$shallow(objA, objB) {
    if (Object.is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    if (objA instanceof Map && objB instanceof Map) {
        if (objA.size !== objB.size) return false;
        for(var _iterator = $af540f293314ba66$var$_createForOfIteratorHelperLoose(objA), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, key = _step$value[0], value = _step$value[1];
            if (!Object.is(value, objB.get(key))) return false;
        }
        return true;
    }
    if (objA instanceof Set && objB instanceof Set) {
        if (objA.size !== objB.size) return false;
        for(var _iterator2 = $af540f293314ba66$var$_createForOfIteratorHelperLoose(objA), _step2; !(_step2 = _iterator2()).done;){
            var _value = _step2.value;
            if (!objB.has(_value)) return false;
        }
        return true;
    }
    var keysA = Object.keys(objA);
    if (keysA.length !== Object.keys(objB).length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !Object.is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
var $af540f293314ba66$var$shallow$1 = function(objA, objB) {
    return $af540f293314ba66$var$shallow(objA, objB);
};
module.exports.default = $af540f293314ba66$var$shallow$1;
module.exports.shallow = $af540f293314ba66$var$shallow;
module.exports = $af540f293314ba66$var$shallow$1;
module.exports.shallow = $af540f293314ba66$var$shallow;
module.exports.default = module.exports;

});

parcelRegister("2Xlz6", function(module, exports) {
"use strict";
var $2271d1ddab3d3ec1$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5nPf2 = parcelRequire("5nPf2");
Object.defineProperty(module.exports, "default", {
    enumerable: true,
    get: function() {
        return $2271d1ddab3d3ec1$var$__importDefault($5nPf2).default;
    }
});

});
parcelRegister("5nPf2", function(module, exports) {
"use strict";
var $3eb6d9391fdc32de$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $3eb6d9391fdc32de$var$react_1 = $3eb6d9391fdc32de$var$__importDefault((parcelRequire("acw62")));

var $ijieC = parcelRequire("ijieC");

var $hI2Ni = parcelRequire("hI2Ni");
var $eiwV4 = parcelRequire("eiwV4");
var $iHnVI = parcelRequire("iHnVI");
var $iF0Y4 = parcelRequire("iF0Y4");
const $3eb6d9391fdc32de$var$Popover = (props)=>{
    const { toggle: toggle, header: header, headerProps: headerProps, body: body, bodyProps: bodyProps, dataLwtId: dataLwtId, size: size } = props;
    const headerDataLwtId = headerProps && headerProps.dataLwtId ? headerProps.dataLwtId : null;
    const bodyDataLwtId = bodyProps && bodyProps.dataLwtId ? bodyProps.dataLwtId : null;
    return !toggle ? $3eb6d9391fdc32de$var$react_1.default.createElement($iF0Y4.default, {
        ...props,
        "data-lwt-id": dataLwtId
    }, $3eb6d9391fdc32de$var$react_1.default.createElement($ijieC.StyledPopover, {
        size: size
    }, $3eb6d9391fdc32de$var$react_1.default.createElement($iHnVI.default, {
        ...headerProps,
        "data-lwt-id": headerDataLwtId
    }, header), $3eb6d9391fdc32de$var$react_1.default.createElement($eiwV4.default, {
        ...bodyProps,
        "data-lwt-id": bodyDataLwtId
    }, body))) : $3eb6d9391fdc32de$var$react_1.default.createElement($hI2Ni.default, {
        ...props,
        "data-lwt-id": dataLwtId
    }, $3eb6d9391fdc32de$var$react_1.default.createElement($ijieC.StyledPopover, {
        size: size
    }, $3eb6d9391fdc32de$var$react_1.default.createElement($iHnVI.default, {
        ...headerProps,
        "data-lwt-id": headerDataLwtId
    }, header), $3eb6d9391fdc32de$var$react_1.default.createElement($eiwV4.default, {
        ...bodyProps,
        "data-lwt-id": bodyDataLwtId
    }, body)));
};
$3eb6d9391fdc32de$var$Popover.defaultProps = {
    size: "auto"
};
module.exports.default = $3eb6d9391fdc32de$var$Popover;

});
parcelRegister("ijieC", function(module, exports) {
"use strict";
var $d5482561d3f83571$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d5482561d3f83571$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $d5482561d3f83571$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $d5482561d3f83571$var$__createBinding(result, mod, k);
    }
    $d5482561d3f83571$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StyledPopover = void 0;

const $d5482561d3f83571$var$styled_components_1 = $d5482561d3f83571$var$__importStar((parcelRequire("lmFrL")));
module.exports.StyledPopover = $d5482561d3f83571$var$styled_components_1.default.div`
    ${({ size: size })=>size && (size === "auto" ? (0, $d5482561d3f83571$var$styled_components_1.css)`
                  width: auto;
              ` : size === "sm" ? (0, $d5482561d3f83571$var$styled_components_1.css)`
                  width: 100px;
              ` : size === "md" ? (0, $d5482561d3f83571$var$styled_components_1.css)`
                  width: 200px;
              ` : size === "lg" ? (0, $d5482561d3f83571$var$styled_components_1.css)`
                  width: 275px;
              ` : (0, $d5482561d3f83571$var$styled_components_1.css)`
                  width: 348px;
              `)}
`;

});

parcelRegister("hI2Ni", function(module, exports) {

$parcel$export(module.exports, "default", () => $0353c0e15167d55a$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $8g1PZ = parcelRequire("8g1PZ");

var $mrQig = parcelRequire("mrQig");
var $0353c0e15167d55a$var$defaultProps = {
    placement: "right",
    placementPrefix: "bs-popover",
    trigger: "click"
};
var $0353c0e15167d55a$var$Popover = function Popover(props) {
    var popperClasses = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("popover", "show", props.popperClassName);
    var classes = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("popover-inner", props.innerClassName);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $mrQig.default), (0, $8nd05.default)({}, props, {
        popperClassName: popperClasses,
        innerClassName: classes
    }));
};
$0353c0e15167d55a$var$Popover.propTypes = (0, $mrQig.propTypes);
$0353c0e15167d55a$var$Popover.defaultProps = $0353c0e15167d55a$var$defaultProps;
var $0353c0e15167d55a$export$2e2bcd8739ae039 = $0353c0e15167d55a$var$Popover;

});

parcelRegister("eiwV4", function(module, exports) {

$parcel$export(module.exports, "default", () => $a68c483c166ae60c$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $e9hDx = parcelRequire("e9hDx");
var $a68c483c166ae60c$var$propTypes = {
    tag: (0, $e9hDx.tagPropType),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $a68c483c166ae60c$var$defaultProps = {
    tag: "div"
};
var $a68c483c166ae60c$var$PopoverBody = function PopoverBody(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, attributes = (0, $1En50.default)(props, [
        "className",
        "cssModule",
        "tag"
    ]);
    var classes = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, "popover-body"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({}, attributes, {
        className: classes
    }));
};
$a68c483c166ae60c$var$PopoverBody.propTypes = $a68c483c166ae60c$var$propTypes;
$a68c483c166ae60c$var$PopoverBody.defaultProps = $a68c483c166ae60c$var$defaultProps;
var $a68c483c166ae60c$export$2e2bcd8739ae039 = $a68c483c166ae60c$var$PopoverBody;

});

parcelRegister("iHnVI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9cece25115d0a0d$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $e9hDx = parcelRequire("e9hDx");
var $d9cece25115d0a0d$var$propTypes = {
    tag: (0, $e9hDx.tagPropType),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $d9cece25115d0a0d$var$defaultProps = {
    tag: "h3"
};
var $d9cece25115d0a0d$var$PopoverHeader = function PopoverHeader(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, attributes = (0, $1En50.default)(props, [
        "className",
        "cssModule",
        "tag"
    ]);
    var classes = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, "popover-header"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({}, attributes, {
        className: classes
    }));
};
$d9cece25115d0a0d$var$PopoverHeader.propTypes = $d9cece25115d0a0d$var$propTypes;
$d9cece25115d0a0d$var$PopoverHeader.defaultProps = $d9cece25115d0a0d$var$defaultProps;
var $d9cece25115d0a0d$export$2e2bcd8739ae039 = $d9cece25115d0a0d$var$PopoverHeader;

});

parcelRegister("iF0Y4", function(module, exports) {

$parcel$export(module.exports, "default", () => $d95cce8271cdc57a$export$2e2bcd8739ae039);

var $kSlfw = parcelRequire("kSlfw");

var $8nd05 = parcelRequire("8nd05");

var $hDpcU = parcelRequire("hDpcU");

var $g7ajw = parcelRequire("g7ajw");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $hI2Ni = parcelRequire("hI2Ni");

var $e9hDx = parcelRequire("e9hDx");
function $d95cce8271cdc57a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d95cce8271cdc57a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $d95cce8271cdc57a$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $kSlfw.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $d95cce8271cdc57a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $d95cce8271cdc57a$var$omitKeys = [
    "defaultOpen"
];
var $d95cce8271cdc57a$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Component) {
    (0, $g7ajw.default)(UncontrolledPopover, _Component);
    function UncontrolledPopover(props) {
        var _this;
        _this = _Component.call(this, props) || this;
        _this.state = {
            isOpen: props.defaultOpen || false
        };
        _this.toggle = _this.toggle.bind((0, $hDpcU.default)(_this));
        return _this;
    }
    var _proto = UncontrolledPopover.prototype;
    _proto.toggle = function toggle() {
        this.setState({
            isOpen: !this.state.isOpen
        });
    };
    _proto.render = function render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $hI2Ni.default), (0, $8nd05.default)({
            isOpen: this.state.isOpen,
            toggle: this.toggle
        }, (0, $e9hDx.omit)(this.props, $d95cce8271cdc57a$var$omitKeys)));
    };
    return UncontrolledPopover;
}((0, $acw62.Component));
$d95cce8271cdc57a$export$2e2bcd8739ae039.propTypes = $d95cce8271cdc57a$var$_objectSpread({
    defaultOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
}, (0, $hI2Ni.default).propTypes);

});



parcelRegister("57vuM", function(module, exports) {

$parcel$export(module.exports, "useCloseChip", () => $3ba6098caa8da5ab$export$ed9932d57d2aff48);

var $acw62 = parcelRequire("acw62");

var $90ISC = parcelRequire("90ISC");

var $ivaD7 = parcelRequire("ivaD7");

var $bxSLe = parcelRequire("bxSLe");
const $3ba6098caa8da5ab$export$ed9932d57d2aff48 = (isPopoverOpen, setState, isListModalOpen)=>{
    const { shouldCloseChips: shouldCloseChips, setShouldCloseChips: setShouldCloseChips } = (0, $90ISC.useSearchStore)((state)=>({
            shouldCloseChips: state.shouldCloseChips,
            setShouldCloseChips: state.setShouldCloseChips
        }));
    (0, $acw62.useEffect)(()=>{
        if (shouldCloseChips && isPopoverOpen) {
            (0, $ivaD7.setStateData)("isPopoverOpen", false, setState);
            isListModalOpen && (0, $ivaD7.setStateData)("isListModalOpen", false, setState);
            setShouldCloseChips(false);
        }
    }, [
        shouldCloseChips
    ]);
    // TODO: Remove this useEffect from every Chip component and leave this one
    (0, $acw62.useEffect)(()=>{
        (0, $bxSLe.toggleRunSearchButton)(isPopoverOpen);
    }, [
        isPopoverOpen
    ]);
};

});

parcelRegister("6Vs3L", function(module, exports) {

$parcel$export(module.exports, "default", () => $50add505c56b4794$export$2e2bcd8739ae039);

var $kQGD1 = parcelRequire("kQGD1");

var $exqIp = parcelRequire("exqIp");

var $kDoXS = parcelRequire("kDoXS");

var $8Y2y0 = parcelRequire("8Y2y0");
/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */ var $50add505c56b4794$var$union = (0, $exqIp.default)(function(arrays) {
    return (0, $kDoXS.default)((0, $kQGD1.default)(arrays, 1, (0, $8Y2y0.default), true));
});
var $50add505c56b4794$export$2e2bcd8739ae039 = $50add505c56b4794$var$union;

});
parcelRegister("kDoXS", function(module, exports) {

$parcel$export(module.exports, "default", () => $f05ad0ab617bf2b6$export$2e2bcd8739ae039);

var $dTR92 = parcelRequire("dTR92");

var $aVe6w = parcelRequire("aVe6w");

var $8OVl5 = parcelRequire("8OVl5");

var $lEs8E = parcelRequire("lEs8E");

var $clhXd = parcelRequire("clhXd");

var $827W0 = parcelRequire("827W0");
/** Used as the size to enable large array optimizations. */ var $f05ad0ab617bf2b6$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $f05ad0ab617bf2b6$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = (0, $aVe6w.default), length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = (0, $8OVl5.default);
    } else if (length >= $f05ad0ab617bf2b6$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : (0, $clhXd.default)(array);
        if (set) return (0, $827W0.default)(set);
        isCommon = false;
        includes = (0, $lEs8E.default);
        seen = new (0, $dTR92.default);
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
var $f05ad0ab617bf2b6$export$2e2bcd8739ae039 = $f05ad0ab617bf2b6$var$baseUniq;

});
parcelRegister("clhXd", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fc55f7d0d396c27$export$2e2bcd8739ae039);

var $iypSL = parcelRequire("iypSL");

var $9PkiD = parcelRequire("9PkiD");

var $827W0 = parcelRequire("827W0");
/** Used as references for various `Number` constants. */ var $8fc55f7d0d396c27$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $8fc55f7d0d396c27$var$createSet = !((0, $iypSL.default) && 1 / (0, $827W0.default)(new (0, $iypSL.default)([
    ,
    -0
]))[1] == $8fc55f7d0d396c27$var$INFINITY) ? (0, $9PkiD.default) : function(values) {
    return new (0, $iypSL.default)(values);
};
var $8fc55f7d0d396c27$export$2e2bcd8739ae039 = $8fc55f7d0d396c27$var$createSet;

});
parcelRegister("9PkiD", function(module, exports) {

$parcel$export(module.exports, "default", () => $72789f8f8886c353$export$2e2bcd8739ae039);
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $72789f8f8886c353$var$noop() {
// No operation performed.
}
var $72789f8f8886c353$export$2e2bcd8739ae039 = $72789f8f8886c353$var$noop;

});




parcelRegister("dyffq", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ebfc58d5324f3d0$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $f61ig = parcelRequire("f61ig");

var $cstaF = parcelRequire("cstaF");
const $3ebfc58d5324f3d0$var$AffectedSavedSearchesModal = (props)=>{
    const { showModal: showModal, onClose: onClose, onYes: onYes, savedSearches: savedSearches, list: list, continuePrompt: continuePrompt, searchType: searchType } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f61ig.default), {
        title: (0, $cstaF.searchTerms).dependentSavedSearches,
        show: showModal,
        onClose: onClose,
        buttons: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                    dataLwtId: "yes",
                    color: "danger",
                    style: {
                        color: "white"
                    },
                    onClick: onYes,
                    children: (0, $cstaF.buttonTerms).yes
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                    dataLwtId: "no",
                    color: "secondary",
                    onClick: onClose,
                    children: (0, $cstaF.buttonTerms).no
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
            children: [
                searchType,
                ' "',
                list?.name,
                '" is used in the following Saved Search(es): ',
                savedSearches?.map((ss)=>`"${ss.savedSearch.searchName}"`).join(", "),
                ".",
                continuePrompt && ` Continue to ${continuePrompt}?` || " Continue?"
            ]
        })
    }, "saved-searches");
};
var $3ebfc58d5324f3d0$export$2e2bcd8739ae039 = $3ebfc58d5324f3d0$var$AffectedSavedSearchesModal;

});

parcelRegister("cvJqS", function(module, exports) {

$parcel$export(module.exports, "OverwriteModalContent", () => $b45336ef99e9f3a0$export$7f1a37419db6cc1e);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $cstaF = parcelRequire("cstaF");
const $b45336ef99e9f3a0$export$7f1a37419db6cc1e = ({ name: name })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "mx-3",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                children: (0, $cstaF.modalTerms).overwriteTitle(name)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                children: (0, $cstaF.modalTerms).overwriteBody
            })
        ]
    });
$b45336ef99e9f3a0$export$7f1a37419db6cc1e.propTypes = {
    name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};

});

parcelRegister("lMblH", function(module, exports) {

$parcel$export(module.exports, "default", () => $9c704ef8cf6bc41c$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
parcelRequire("amkL4");
var $3QXz5 = parcelRequire("3QXz5");
const $9c704ef8cf6bc41c$var$ToastContainerPortal = ({ toastProps: toastProps })=>{
    if (!toastProps) return null;
    return /*#__PURE__*/ (0, $1u0KT.createPortal)(/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3QXz5))), {
        position: "toast-bottom-right",
        dataLwtId: "save-office-list-toasts",
        toastProps: toastProps
    }), document.body);
};
var $9c704ef8cf6bc41c$export$2e2bcd8739ae039 = $9c704ef8cf6bc41c$var$ToastContainerPortal;

});
parcelRegister("amkL4", function(module, exports) {

$parcel$export(module.exports, "Toast", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("iA5rR")))));
$parcel$export(module.exports, "ToastContainer", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("3QXz5")))));

var $iA5rR = parcelRequire("iA5rR");

var $3QXz5 = parcelRequire("3QXz5");

});
parcelRegister("iA5rR", function(module, exports) {
"use strict";
var $d86fd0b5fae40dd8$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $d86fd0b5fae40dd8$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $d86fd0b5fae40dd8$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $d86fd0b5fae40dd8$var$__createBinding(result, mod, k);
    }
    $d86fd0b5fae40dd8$var$__setModuleDefault(result, mod);
    return result;
};
var $d86fd0b5fae40dd8$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $d86fd0b5fae40dd8$var$react_1 = $d86fd0b5fae40dd8$var$__importStar((parcelRequire("acw62")));
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");
parcelRequire("3lOdM");
var $1iwUl = parcelRequire("1iwUl");
var $e155p = parcelRequire("e155p");

const $d86fd0b5fae40dd8$var$icon_1 = $d86fd0b5fae40dd8$var$__importDefault((parcelRequire("aTLkh")));

const $d86fd0b5fae40dd8$var$card_1 = $d86fd0b5fae40dd8$var$__importDefault((parcelRequire("7hEbZ")));
const $d86fd0b5fae40dd8$var$Toast = (props)=>{
    const { id: id, dataLwtId: dataLwtId, color: color, icon: icon, autoDismiss: autoDismiss, dismissTime: dismissTime, className: className, showClose: showClose, buttonText: buttonText, message: message, rounded: rounded, border: border, bodyProps: bodyProps, children: children, onButtonClick: onButtonClick, onDelete: onDelete } = props;
    const CloseAction = ()=>{
        if (onDelete && typeof onDelete === "function") onDelete(id);
    };
    const GetIcon = ()=>{
        if (!icon) return $d86fd0b5fae40dd8$var$react_1.default.createElement($d86fd0b5fae40dd8$var$react_1.default.Fragment, null);
        return $d86fd0b5fae40dd8$var$react_1.default.createElement($1iwUl.default, {
            xs: "1",
            align: "center",
            className: "my-auto pr-0 pl-2",
            style: {
                fontSize: "22px"
            }
        }, $d86fd0b5fae40dd8$var$react_1.default.createElement($d86fd0b5fae40dd8$var$icon_1.default, {
            dataLwtId: `${dataLwtId}-icon`,
            iconName: icon,
            className: "text-" + color
        }));
    };
    const ExtraButton = ()=>{
        return $d86fd0b5fae40dd8$var$react_1.default.createElement($6thlO.default, {
            dataLwtId: `${dataLwtId}-button`,
            color: color,
            onClick: onButtonClick,
            type: "button",
            className: "inline-block",
            size: "sm"
        }, buttonText);
    };
    const CloseButton = ()=>{
        return $d86fd0b5fae40dd8$var$react_1.default.createElement("button", {
            type: "button",
            className: "close ml-auto mt-1 mr-2 inline-block",
            "aria-label": "Close",
            style: {
                fontSize: "18px"
            },
            onClick: CloseAction
        }, $d86fd0b5fae40dd8$var$react_1.default.createElement("span", {
            "aria-hidden": "true",
            className: "material-icons"
        }, "clear"));
    };
    const Content = ()=>{
        if (message) return $d86fd0b5fae40dd8$var$react_1.default.createElement("div", {
            dangerouslySetInnerHTML: {
                __html: message
            }
        });
        else if (children) return children;
        return $d86fd0b5fae40dd8$var$react_1.default.createElement($d86fd0b5fae40dd8$var$react_1.default.Fragment, null);
    };
    (0, $d86fd0b5fae40dd8$var$react_1.useEffect)(()=>{
        let interval;
        let isDismissed = false;
        if (autoDismiss && !isDismissed) {
            isDismissed = true;
            interval = setInterval(()=>{
                CloseAction();
                clearInterval(interval);
                interval = undefined;
            }, dismissTime);
        }
        return ()=>{
            if (interval && !isDismissed) {
                isDismissed = true;
                CloseAction();
                clearInterval(interval);
                interval = undefined;
            }
        };
    }, []);
    const cardProps = bodyProps || {
        dataLwtId: dataLwtId,
        rounded: rounded,
        className: `p-0 toast-card status-border-${border} status-border-${color} ${className}`,
        bodyProps: {
            dataLwtId: id.toString(),
            className: "p-0"
        }
    };
    // Main Column Sizing
    let toastColumns = {
        text: "",
        button: ""
    };
    const columns = {
        textOnly: {
            text: "12",
            button: "0"
        },
        textClose: {
            text: "10",
            button: "2"
        },
        textButton: {
            text: "8",
            button: "4"
        },
        iconText: {
            text: "11",
            button: "0"
        },
        iconTextClose: {
            text: "9",
            button: "2"
        },
        iconTextButton: {
            text: "7",
            button: "4"
        }
    };
    if (!icon && !showClose && !buttonText) toastColumns = columns.textOnly;
    else if (!icon && !buttonText && showClose) toastColumns = columns.textClose;
    else if (!icon && buttonText) toastColumns = columns.textButton;
    else if (icon && !buttonText && !showClose) toastColumns = columns.iconText;
    else if (icon && showClose && !buttonText) toastColumns = columns.iconTextClose;
    else if (icon && buttonText) toastColumns = columns.iconTextButton;
    return $d86fd0b5fae40dd8$var$react_1.default.createElement($d86fd0b5fae40dd8$var$card_1.default, {
        ...cardProps
    }, $d86fd0b5fae40dd8$var$react_1.default.createElement($e155p.default, {
        className: "py-1 m-0 h-100 "
    }, icon && GetIcon(), $d86fd0b5fae40dd8$var$react_1.default.createElement($1iwUl.default, {
        xs: toastColumns.text,
        className: "py-2 pr-0"
    }, $d86fd0b5fae40dd8$var$react_1.default.createElement(Content, null)), $d86fd0b5fae40dd8$var$react_1.default.createElement($1iwUl.default, {
        xs: toastColumns.button,
        align: "right",
        className: "my-auto pr-1"
    }, buttonText && $d86fd0b5fae40dd8$var$react_1.default.createElement(ExtraButton, null), showClose && $d86fd0b5fae40dd8$var$react_1.default.createElement(CloseButton, null))));
};
$d86fd0b5fae40dd8$var$Toast.defaultProps = {
    rounded: true,
    border: "left",
    color: "secondary",
    showClose: true,
    autoDismiss: true,
    dismissTime: 5000
};
module.exports.default = $d86fd0b5fae40dd8$var$Toast;

});

parcelRegister("3QXz5", function(module, exports) {
"use strict";
var $2ce46ec5eca7de7e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $2ce46ec5eca7de7e$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $2ce46ec5eca7de7e$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $2ce46ec5eca7de7e$var$__createBinding(result, mod, k);
    }
    $2ce46ec5eca7de7e$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $2ce46ec5eca7de7e$var$react_1 = $2ce46ec5eca7de7e$var$__importStar((parcelRequire("acw62")));
parcelRequire("amkL4");
var $iA5rR = parcelRequire("iA5rR");
const $2ce46ec5eca7de7e$var$ToastContainer = (props)=>{
    const { toastProps: toast, position: position } = props;
    const [list, setList] = (0, $2ce46ec5eca7de7e$var$react_1.useState)([]);
    (0, $2ce46ec5eca7de7e$var$react_1.useEffect)(()=>{
        if (toast && Object.keys(toast).length !== 0) setList((prev)=>{
            prev.push(toast);
            return [
                ...prev
            ];
        });
    }, [
        toast
    ]);
    const removeToast = (toastToRemove)=>{
        let listItemIndex = list.findIndex((e)=>e.id === toastToRemove.id);
        if (listItemIndex !== -1) setList((prev)=>{
            listItemIndex = prev.findIndex((e)=>e.id === toastToRemove.id);
            prev.splice(listItemIndex, 1);
            return [
                ...prev
            ];
        });
    };
    return $2ce46ec5eca7de7e$var$react_1.default.createElement("div", {
        className: `toast-container ${position}`
    }, list.map((t, i)=>$2ce46ec5eca7de7e$var$react_1.default.createElement($iA5rR.default, {
            ...t,
            className: `${t.className} ${position}`,
            onDelete: ()=>removeToast(t),
            key: i
        }, t.message)));
};
module.exports.default = $2ce46ec5eca7de7e$var$ToastContainer;
$2ce46ec5eca7de7e$var$ToastContainer.defaultProps = {
    width: "350px",
    position: "toast-bottom-left"
};

});



parcelRegister("eJKtk", function(module, exports) {

var $fFLF8 = parcelRequire("fFLF8");
module.exports = $fFLF8("xQwfO").then(()=>parcelRequire("hh49K"));

});

parcelRegister("baHpn", function(module, exports) {

var $fFLF8 = parcelRequire("fFLF8");
module.exports = $fFLF8("gVmgn").then(()=>parcelRequire("eNDRR"));

});

parcelRegister("5O42q", function(module, exports) {

var $fFLF8 = parcelRequire("fFLF8");
module.exports = $fFLF8("itwFo").then(()=>parcelRequire("hBOVH"));

});

parcelRegister("7mGTg", function(module, exports) {

var $fFLF8 = parcelRequire("fFLF8");
module.exports = $fFLF8("g7Ajs").then(()=>parcelRequire("c0TQ7"));

});

parcelRegister("5vG8Z", function(module, exports) {

var $fFLF8 = parcelRequire("fFLF8");
module.exports = $fFLF8("kAyW6").then(()=>parcelRequire("h2k3B"));

});

parcelRegister("3jw3C", function(module, exports) {

var $fFLF8 = parcelRequire("fFLF8");
module.exports = $fFLF8("6nEy2").then(()=>parcelRequire("crqRt"));

});

parcelRegister("hJLnY", function(module, exports) {

var $fFLF8 = parcelRequire("fFLF8");
module.exports = $fFLF8("bHmtW").then(()=>parcelRequire("knh3M"));

});

parcelRegister("gHp6Y", function(module, exports) {

var $fFLF8 = parcelRequire("fFLF8");
module.exports = $fFLF8("jNaIR").then(()=>parcelRequire("5SaDA"));

});

parcelRegister("4LgDK", function(module, exports) {

var $fFLF8 = parcelRequire("fFLF8");
module.exports = $fFLF8("8FmCx").then(()=>parcelRequire("avUZG"));

});

parcelRegister("jKOEt", function(module, exports) {

var $fFLF8 = parcelRequire("fFLF8");
module.exports = $fFLF8("cXtTd").then(()=>parcelRequire("7C6nd"));

});

parcelRegister("40bJv", function(module, exports) {

var $fFLF8 = parcelRequire("fFLF8");
module.exports = $fFLF8("8qcny").then(()=>parcelRequire("7PsdT"));

});

parcelRegister("3PprX", function(module, exports) {

$parcel$export(module.exports, "Dropdown", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("90ODN")))));
$parcel$export(module.exports, "ButtonDropdown", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("9Qlhi")))));

var $90ODN = parcelRequire("90ODN");

var $9Qlhi = parcelRequire("9Qlhi");

});
parcelRegister("90ODN", function(module, exports) {
"use strict";
var $68fb655a99fb4ff7$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $68fb655a99fb4ff7$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $68fb655a99fb4ff7$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $68fb655a99fb4ff7$var$__createBinding(result, mod, k);
    }
    $68fb655a99fb4ff7$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $68fb655a99fb4ff7$var$react_1 = $68fb655a99fb4ff7$var$__importStar((parcelRequire("acw62")));

var $9GSMu = parcelRequire("9GSMu");
var $2zfPk = parcelRequire("2zfPk");
var $eA2p4 = parcelRequire("eA2p4");
var $kXn8S = parcelRequire("kXn8S");

var $eAEgn = parcelRequire("eAEgn");
const $68fb655a99fb4ff7$var$Dropdown = (props)=>{
    const { toggleProps: toggleProps, menuProps: menuProps, items: items, toggle: toggle, isOpen: isOpen, active: active, dataLwtId: dataLwtId, ...rest } = props;
    const { dataLwtId: toggleDataLwtId, ...togglePropsRest } = toggleProps;
    const { dataLwtId: menuDataLwtId, ...menuPropsRest } = menuProps;
    const [dropdownOpen, setOpen] = (0, $68fb655a99fb4ff7$var$react_1.useState)(false);
    return $68fb655a99fb4ff7$var$react_1.default.createElement($9GSMu.default, {
        toggle: toggle || (()=>setOpen(!dropdownOpen)),
        isOpen: isOpen || dropdownOpen,
        active: active,
        "data-lwt-id": dataLwtId,
        ...rest
    }, $68fb655a99fb4ff7$var$react_1.default.createElement($kXn8S.default, {
        "data-lwt-id": toggleDataLwtId,
        ...togglePropsRest
    }), $68fb655a99fb4ff7$var$react_1.default.createElement($eA2p4.default, {
        "data-lwt-id": menuDataLwtId,
        ...menuPropsRest
    }, items && items.map((item)=>{
        const { dataLwtId: itemDataLwtId, itemText: itemText, children: children, ...restItem } = item;
        if (restItem.to != null) return $68fb655a99fb4ff7$var$react_1.default.createElement($eAEgn.LinkContainer, {
            to: restItem.to,
            key: `link-${restItem.key}`
        }, $68fb655a99fb4ff7$var$react_1.default.createElement($2zfPk.default, {
            "data-lwt-id": itemDataLwtId,
            ...restItem
        }, itemText));
        else return $68fb655a99fb4ff7$var$react_1.default.createElement($2zfPk.default, {
            "data-lwt-id": itemDataLwtId,
            ...restItem
        }, itemText ? itemText : children);
    })));
};
module.exports.default = $68fb655a99fb4ff7$var$Dropdown;

});
parcelRegister("eAEgn", function(module, exports) {

$parcel$export(module.exports, "LinkContainer", () => $a9f3a8ec50471b2e$export$af2ec3aa21d10ab7, (v) => $a9f3a8ec50471b2e$export$af2ec3aa21d10ab7 = v);
var $a9f3a8ec50471b2e$export$1e511d4a378977f5;
var $a9f3a8ec50471b2e$export$af2ec3aa21d10ab7;
var $a9f3a8ec50471b2e$export$d5e9b9fbe7f3f0c1;
"use strict";
$a9f3a8ec50471b2e$export$1e511d4a378977f5 = true;
$a9f3a8ec50471b2e$export$af2ec3aa21d10ab7 = $a9f3a8ec50471b2e$export$d5e9b9fbe7f3f0c1 = undefined;

var $7S0tG = parcelRequire("7S0tG");
var $a9f3a8ec50471b2e$var$_IndexLinkContainer3 = $a9f3a8ec50471b2e$var$_interopRequireDefault($7S0tG);

var $iMb4q = parcelRequire("iMb4q");
var $a9f3a8ec50471b2e$var$_LinkContainer3 = $a9f3a8ec50471b2e$var$_interopRequireDefault($iMb4q);
function $a9f3a8ec50471b2e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$a9f3a8ec50471b2e$export$d5e9b9fbe7f3f0c1 = $a9f3a8ec50471b2e$var$_IndexLinkContainer3.default;
$a9f3a8ec50471b2e$export$af2ec3aa21d10ab7 = $a9f3a8ec50471b2e$var$_LinkContainer3.default;

});
parcelRegister("7S0tG", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $5badf26f61339073$export$1e511d4a378977f5, (v) => $5badf26f61339073$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "IndexLinkContainer", () => $5badf26f61339073$export$d5e9b9fbe7f3f0c1, (v) => $5badf26f61339073$export$d5e9b9fbe7f3f0c1 = v);
$parcel$export(module.exports, "default", () => $5badf26f61339073$export$2e2bcd8739ae039, (v) => $5badf26f61339073$export$2e2bcd8739ae039 = v);
var $5badf26f61339073$export$1e511d4a378977f5;
var $5badf26f61339073$export$d5e9b9fbe7f3f0c1;
/* eslint-enable react/prefer-stateless-function */ var $5badf26f61339073$export$2e2bcd8739ae039;
"use strict";
$5badf26f61339073$export$1e511d4a378977f5 = true;
$5badf26f61339073$export$d5e9b9fbe7f3f0c1 = undefined;
var $5badf26f61339073$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $acw62 = parcelRequire("acw62");
var $5badf26f61339073$var$_react2 = $5badf26f61339073$var$_interopRequireDefault($acw62);

var $kfZjc = parcelRequire("kfZjc");

var $iMb4q = parcelRequire("iMb4q");
var $5badf26f61339073$var$_LinkContainer2 = $5badf26f61339073$var$_interopRequireDefault($iMb4q);
function $5badf26f61339073$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5badf26f61339073$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5badf26f61339073$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $5badf26f61339073$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// Don't use a stateless function, to allow users to set a ref.
/* eslint-disable react/prefer-stateless-function */ var $5badf26f61339073$var$IndexLinkContainer = $5badf26f61339073$export$d5e9b9fbe7f3f0c1 = function(_React$Component) {
    $5badf26f61339073$var$_inherits(IndexLinkContainer, _React$Component);
    function IndexLinkContainer() {
        $5badf26f61339073$var$_classCallCheck(this, IndexLinkContainer);
        return $5badf26f61339073$var$_possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }
    IndexLinkContainer.prototype.render = function render() {
        return $5badf26f61339073$var$_react2.default.createElement($5badf26f61339073$var$_LinkContainer2.default, $5badf26f61339073$var$_extends({}, this.props, {
            exact: true
        }));
    };
    return IndexLinkContainer;
}($5badf26f61339073$var$_react2.default.Component);
$5badf26f61339073$export$2e2bcd8739ae039 = (0, $kfZjc.withRouter)($5badf26f61339073$var$IndexLinkContainer);

});
parcelRegister("iMb4q", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", () => $dab54c07724d542c$export$1e511d4a378977f5, (v) => $dab54c07724d542c$export$1e511d4a378977f5 = v);
$parcel$export(module.exports, "LinkContainer", () => $dab54c07724d542c$export$af2ec3aa21d10ab7, (v) => $dab54c07724d542c$export$af2ec3aa21d10ab7 = v);
$parcel$export(module.exports, "default", () => $dab54c07724d542c$export$2e2bcd8739ae039, (v) => $dab54c07724d542c$export$2e2bcd8739ae039 = v);
var $dab54c07724d542c$export$1e511d4a378977f5;
var $dab54c07724d542c$export$af2ec3aa21d10ab7;
var $dab54c07724d542c$export$2e2bcd8739ae039;
"use strict";
$dab54c07724d542c$export$1e511d4a378977f5 = true;
$dab54c07724d542c$export$af2ec3aa21d10ab7 = undefined;
var $dab54c07724d542c$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $dab54c07724d542c$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var $acw62 = parcelRequire("acw62");
var $dab54c07724d542c$var$_react2 = $dab54c07724d542c$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");
var $dab54c07724d542c$var$_propTypes2 = $dab54c07724d542c$var$_interopRequireDefault($c9Z8w);

var $kfZjc = parcelRequire("kfZjc");
function $dab54c07724d542c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $dab54c07724d542c$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $dab54c07724d542c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $dab54c07724d542c$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $dab54c07724d542c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $dab54c07724d542c$var$isModifiedEvent = function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};
var $dab54c07724d542c$var$LinkContainer = $dab54c07724d542c$export$af2ec3aa21d10ab7 = function(_Component) {
    $dab54c07724d542c$var$_inherits(LinkContainer, _Component);
    function LinkContainer() {
        var _temp, _this, _ret;
        $dab54c07724d542c$var$_classCallCheck(this, LinkContainer);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $dab54c07724d542c$var$_possibleConstructorReturn(this, _Component.call.apply(_Component, [
            this
        ].concat(args))), _this), _this.handleClick = function(event) {
            var _this$props = _this.props, children = _this$props.children, onClick = _this$props.onClick;
            if (children.props.onClick) children.props.onClick(event);
            if (onClick) onClick(event);
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && // ignore right clicks
            !$dab54c07724d542c$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                var _this$props2 = _this.props, replace = _this$props2.replace, to = _this$props2.to, history = _this$props2.history;
                if (replace) history.replace(to);
                else history.push(to);
            }
        }, _temp), $dab54c07724d542c$var$_possibleConstructorReturn(_this, _ret);
    }
    LinkContainer.prototype.render = function render() {
        var _this2 = this;
        var _props = this.props, history = _props.history, _location = _props.location, _match = _props.match, _staticContext = _props.staticContext, children = _props.children, replace = _props.replace, to = _props.to, exact = _props.exact, strict = _props.strict, activeClassName = _props.activeClassName, className = _props.className, activeStyle = _props.activeStyle, style = _props.style, getIsActive = _props.isActive, props = $dab54c07724d542c$var$_objectWithoutProperties(_props, [
            "history",
            "location",
            "match",
            "staticContext",
            "children",
            "replace",
            "to",
            "exact",
            "strict",
            "activeClassName",
            "className",
            "activeStyle",
            "style",
            "isActive"
        ]);
        var href = history.createHref(typeof to === "string" ? {
            pathname: to
        } : to);
        var child = $dab54c07724d542c$var$_react2.default.Children.only(children);
        return $dab54c07724d542c$var$_react2.default.createElement($kfZjc.Route, {
            path: (typeof to === "undefined" ? "undefined" : $dab54c07724d542c$var$_typeof(to)) === "object" ? to.pathname : to,
            exact: exact,
            strict: strict,
            children: function children(_ref) {
                var location = _ref.location, match = _ref.match;
                var isActive = !!(getIsActive ? getIsActive(match, location) : match);
                return $dab54c07724d542c$var$_react2.default.cloneElement(child, $dab54c07724d542c$var$_extends({}, props, {
                    className: [
                        className,
                        child.props.className,
                        isActive ? activeClassName : null
                    ].join(" ").trim(),
                    style: isActive ? $dab54c07724d542c$var$_extends({}, style, activeStyle) : style,
                    href: href,
                    onClick: _this2.handleClick
                }));
            }
        });
    };
    return LinkContainer;
}($acw62.Component);
$dab54c07724d542c$var$LinkContainer.propTypes = {
    history: $dab54c07724d542c$var$_propTypes2.default.shape({
        push: $dab54c07724d542c$var$_propTypes2.default.func.isRequired,
        replace: $dab54c07724d542c$var$_propTypes2.default.func.isRequired,
        createHref: $dab54c07724d542c$var$_propTypes2.default.func.isRequired
    }).isRequired,
    location: $dab54c07724d542c$var$_propTypes2.default.object,
    match: $dab54c07724d542c$var$_propTypes2.default.object,
    staticContext: $dab54c07724d542c$var$_propTypes2.default.object,
    children: $dab54c07724d542c$var$_propTypes2.default.element.isRequired,
    onClick: $dab54c07724d542c$var$_propTypes2.default.func,
    replace: $dab54c07724d542c$var$_propTypes2.default.bool,
    to: $dab54c07724d542c$var$_propTypes2.default.oneOfType([
        $dab54c07724d542c$var$_propTypes2.default.string,
        $dab54c07724d542c$var$_propTypes2.default.object
    ]).isRequired,
    exact: $dab54c07724d542c$var$_propTypes2.default.bool,
    strict: $dab54c07724d542c$var$_propTypes2.default.bool,
    className: $dab54c07724d542c$var$_propTypes2.default.string,
    activeClassName: $dab54c07724d542c$var$_propTypes2.default.string,
    style: $dab54c07724d542c$var$_propTypes2.default.object,
    activeStyle: $dab54c07724d542c$var$_propTypes2.default.object,
    isActive: $dab54c07724d542c$var$_propTypes2.default.func
};
$dab54c07724d542c$var$LinkContainer.defaultProps = {
    replace: false,
    exact: false,
    strict: false,
    activeClassName: "active"
};
$dab54c07724d542c$export$2e2bcd8739ae039 = (0, $kfZjc.withRouter)($dab54c07724d542c$var$LinkContainer);

});




parcelRegister("9Qlhi", function(module, exports) {
"use strict";
var $72a979c4433bf58c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $72a979c4433bf58c$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $72a979c4433bf58c$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $72a979c4433bf58c$var$__createBinding(result, mod, k);
    }
    $72a979c4433bf58c$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $72a979c4433bf58c$var$react_1 = $72a979c4433bf58c$var$__importStar((parcelRequire("acw62")));

var $g4GiT = parcelRequire("g4GiT");
var $2zfPk = parcelRequire("2zfPk");
var $eA2p4 = parcelRequire("eA2p4");
var $kXn8S = parcelRequire("kXn8S");

var $eAEgn = parcelRequire("eAEgn");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");
const $72a979c4433bf58c$var$ButtonDropdown = (props)=>{
    const { buttonProps: buttonProps, toggleProps: toggleProps, menuProps: menuProps, items: items, toggle: toggle, isOpen: isOpen, active: active, dataLwtId: dataLwtId, ...rest } = props;
    const { dataLwtId: toggleDataLwtId, ...togglePropsRest } = toggleProps;
    const { dataLwtId: menuDataLwtId, ...menuPropsRest } = menuProps;
    const [dropdownOpen, setOpen] = (0, $72a979c4433bf58c$var$react_1.useState)(false);
    return $72a979c4433bf58c$var$react_1.default.createElement($g4GiT.default, {
        toggle: toggle || (()=>setOpen(!dropdownOpen)),
        isOpen: isOpen || dropdownOpen,
        active: active,
        "data-lwt-id": dataLwtId,
        ...rest
    }, buttonProps && $72a979c4433bf58c$var$react_1.default.createElement($6thlO.default, {
        ...buttonProps
    }), $72a979c4433bf58c$var$react_1.default.createElement($kXn8S.default, {
        "data-lwt-id": toggleDataLwtId,
        ...togglePropsRest
    }), $72a979c4433bf58c$var$react_1.default.createElement($eA2p4.default, {
        "data-lwt-id": menuDataLwtId,
        ...menuPropsRest
    }, items && items.map((item)=>{
        const { dataLwtId: itemDataLwtId, itemText: itemText, ...restItem } = item;
        if (restItem.to != null) return $72a979c4433bf58c$var$react_1.default.createElement($eAEgn.LinkContainer, {
            to: restItem.to,
            key: `link-${restItem.key}`
        }, $72a979c4433bf58c$var$react_1.default.createElement($2zfPk.default, {
            "data-lwt-id": itemDataLwtId,
            ...restItem
        }, itemText));
        else return $72a979c4433bf58c$var$react_1.default.createElement($2zfPk.default, {
            "data-lwt-id": itemDataLwtId,
            ...restItem
        }, itemText);
    })));
};
module.exports.default = $72a979c4433bf58c$var$ButtonDropdown;

});
parcelRegister("g4GiT", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb3dd5b86080a869$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9GSMu = parcelRequire("9GSMu");
var $bb3dd5b86080a869$var$propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node
};
var $bb3dd5b86080a869$var$ButtonDropdown = function ButtonDropdown(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $9GSMu.default), (0, $8nd05.default)({
        group: true
    }, props));
};
$bb3dd5b86080a869$var$ButtonDropdown.propTypes = $bb3dd5b86080a869$var$propTypes;
var $bb3dd5b86080a869$export$2e2bcd8739ae039 = $bb3dd5b86080a869$var$ButtonDropdown;

});



parcelRegister("8NZ49", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d711d7afde9a79e$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $6e921 = parcelRequire("6e921");

var $7hEbZ = parcelRequire("7hEbZ");

var $94MZK = parcelRequire("94MZK");
const AgentChart = ({ options, schema, data, currentAgentChart })=>{
    const bodyProps = {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $94MZK.default), {
            selectedAgent: !!currentAgentChart && currentAgentChart,
            nameBold: false,
            border: false,
            mlsId: "mls-id-coming-soon",
            module: module
        })
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "d-flex row",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mb-3 col-md-6 col-sm-12 col-lg-6 col-xl-4",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6e921.default), {
                    id: "chartTableList",
                    dataLwtId: "ChartTableList",
                    options: options,
                    schema: schema,
                    data: data
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "col-md-6 col-sm-12 col-lg-6 col-xl-8",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7hEbZ.default), {
                    raised: true,
                    bodyProps: bodyProps
                })
            })
        ]
    });
};
AgentChart.propTypes = {
    options: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    schema: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    data: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object)
};
var $4d711d7afde9a79e$export$2e2bcd8739ae039 = AgentChart;

});
parcelRegister("6e921", function(module, exports) {

$parcel$export(module.exports, "default", () => $488b0e58fe6d5ef5$export$2e2bcd8739ae039);

var $e7ESf = parcelRequire("e7ESf");
var $488b0e58fe6d5ef5$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($e7ESf)));

});
parcelRegister("e7ESf", function(module, exports) {
"use strict";
var $a4816cddcbbf781f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a4816cddcbbf781f$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $a4816cddcbbf781f$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $a4816cddcbbf781f$var$__createBinding(result, mod, k);
    }
    $a4816cddcbbf781f$var$__setModuleDefault(result, mod);
    return result;
};
var $a4816cddcbbf781f$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $a4816cddcbbf781f$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.addCustomError = void 0;

/* eslint-disable @typescript-eslint/ban-ts-comment */ /* eslint-disable @typescript-eslint/ban-types */ const $a4816cddcbbf781f$var$react_1 = $a4816cddcbbf781f$var$__importStar((parcelRequire("acw62")));

const $a4816cddcbbf781f$var$react_dom_1 = $a4816cddcbbf781f$var$__importDefault((parcelRequire("1u0KT")));

const $a4816cddcbbf781f$var$react_bootstrap_table_next_1 = $a4816cddcbbf781f$var$__importDefault((parcelRequire("hfoyt")));

const $a4816cddcbbf781f$var$react_bootstrap_table2_paginator_1 = $a4816cddcbbf781f$var$__importDefault((parcelRequire("20w5V")));

const $a4816cddcbbf781f$var$react_bootstrap_table2_filter_1 = $a4816cddcbbf781f$var$__importStar((parcelRequire("dJwER")));




var $kBJxW = parcelRequire("kBJxW");

const $a4816cddcbbf781f$var$validate_1 = $a4816cddcbbf781f$var$__importDefault((parcelRequire("3cXpG")));

const $a4816cddcbbf781f$var$isEqual_1 = $a4816cddcbbf781f$var$__importDefault((parcelRequire("4UXHD")));
parcelRequire("4L5iB");
var $7jSYQ = parcelRequire("7jSYQ");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

const $a4816cddcbbf781f$var$select_1 = $a4816cddcbbf781f$var$__importDefault((parcelRequire("9SWta")));

const $a4816cddcbbf781f$var$EditableCell_1 = $a4816cddcbbf781f$var$__importStar((parcelRequire("6Ml1B")));

const $a4816cddcbbf781f$var$DatePickerFilter_1 = $a4816cddcbbf781f$var$__importDefault((parcelRequire("dfFfy")));
const $a4816cddcbbf781f$var$dateSort = (a, b, order)=>{
    if (order === "asc") return new Date(a).getTime() - new Date(b).getTime();
    else return new Date(b).getTime() - new Date(a).getTime();
};
const $a4816cddcbbf781f$var$enumFormatter = (cell, row, index, enumObject)=>{
    return enumObject[cell];
};
// It is the responsibility of the consuming application to do the routing (due to recent changes to react-router-dom)
const $a4816cddcbbf781f$var$linkFormatter = (cell, row, index, linkObject)=>{
    return $a4816cddcbbf781f$var$react_1.default.createElement($6thlO.default, {
        dataLwtId: `btn-${linkObject.dataLwtId}-${linkObject.fieldName}-${index}`,
        className: linkObject.cssClasses,
        color: linkObject.color || "text",
        onClick: linkObject.onClick.bind(null, row[linkObject.keyName])
    }, cell);
};
const $a4816cddcbbf781f$var$initializeRowEditableCells = (row, columns)=>{
    const editableCells = {};
    columns.forEach((column)=>{
        var _a, _b, _c, _d;
        editableCells[column.name] = {
            disabled: column.editableCellProps.disabled,
            inputProps: {
                disabled: column.editableCellProps.inputProps.disabled || false,
                valueApplied: false,
                appliedValue: ((_a = column.editableCellProps) === null || _a === void 0 ? void 0 : _a.applyButtonProps) ? null : row[column.name],
                originalValue: ((_b = column.editableCellProps) === null || _b === void 0 ? void 0 : _b.inputProps.setInitialValueFromField) ? row[column.editableCellProps.inputProps.setInitialValueFromField] : row[column.name],
                programmaticValue: row[column.name],
                programmaticChange: true
            },
            applyButtonProps: ((_c = column.editableCellProps) === null || _c === void 0 ? void 0 : _c.applyButtonProps) && {
                hidden: column.editableCellProps.applyButtonProps.hidden || false,
                disabled: column.editableCellProps.applyButtonProps.disabled || false
            },
            resetButtonProps: ((_d = column.editableCellProps) === null || _d === void 0 ? void 0 : _d.resetButtonProps) && {
                hidden: column.editableCellProps.applyButtonProps ? true : column.editableCellProps.resetButtonProps.hidden || false,
                disabled: true
            }
        };
    });
    return editableCells;
};
const $a4816cddcbbf781f$var$initializeEditableCells = (keyField, data, schema)=>{
    const editableColumns = Object.keys(schema.properties).filter((column)=>!!schema.properties[column].editableCellProps).map((column)=>({
            name: column,
            editableCellProps: schema.properties[column].editableCellProps
        }));
    if (!editableColumns) return {};
    const editableCells = {};
    data.map((row)=>{
        const rowId = row[keyField];
        editableCells[rowId] = $a4816cddcbbf781f$var$initializeRowEditableCells(row, editableColumns);
    });
    return editableCells;
};
const $a4816cddcbbf781f$var$updateEditableCellState = (action, prevCellState)=>{
    var _a, _b, _c, _d;
    let editableCell;
    if (action === "enable-reset" && prevCellState.resetButtonProps) editableCell = Object.assign(Object.assign({}, prevCellState), {
        applyButtonProps: prevCellState.applyButtonProps && Object.assign({}, prevCellState.applyButtonProps),
        resetButtonProps: Object.assign(Object.assign({}, prevCellState.resetButtonProps), {
            forceEnable: true
        }),
        inputProps: Object.assign(Object.assign({}, prevCellState.inputProps), {
            programmaticChange: true
        })
    });
    else editableCell = Object.assign(Object.assign({}, prevCellState), {
        disabled: action === "disable" ? true : action === "enable" ? false : prevCellState.disabled,
        applyButtonProps: prevCellState.applyButtonProps && {
            hidden: !prevCellState.applyButtonProps || action === "apply" ? true : action === "unapply" ? false : (_a = prevCellState.applyButtonProps) === null || _a === void 0 ? void 0 : _a.hidden,
            disabled: !prevCellState.applyButtonProps || [
                "apply",
                "disable"
            ].includes(action) ? true : [
                "unapply",
                "enable"
            ].includes(action) ? false : (_b = prevCellState.applyButtonProps) === null || _b === void 0 ? void 0 : _b.disabled
        },
        resetButtonProps: prevCellState.resetButtonProps && {
            hidden: !prevCellState.resetButtonProps || action === "unapply" ? true : action === "apply" ? false : (_c = prevCellState.resetButtonProps) === null || _c === void 0 ? void 0 : _c.hidden,
            disabled: !prevCellState.resetButtonProps || [
                "unapply",
                "disable"
            ].includes(action) ? true : action === "apply" || action === "enable" ? false : (_d = prevCellState.resetButtonProps) === null || _d === void 0 ? void 0 : _d.disabled,
            forceEnable: false
        },
        inputProps: Object.assign(Object.assign({}, prevCellState.inputProps), {
            valueApplied: action === "apply" ? true : action === "unapply" ? false : prevCellState.inputProps.valueApplied,
            disabled: ![
                "unapply",
                "enable"
            ].includes(action),
            appliedValue: prevCellState.applyButtonProps && [
                "unapply",
                "enable"
            ].includes(action) ? prevCellState.inputProps.originalValue : prevCellState.inputProps.appliedValue,
            programmaticChange: true
        })
    });
    return editableCell;
};
const $a4816cddcbbf781f$var$applyCustomValidationMessages = (customMessages, error)=>{
    customMessages && Object.keys(customMessages).every((key)=>{
        if (error.name === key) {
            switch(key){
                case "format":
                    if (typeof customMessages[key] === "object" && customMessages[key].constructor === Array) {
                        const index = customMessages[key].findIndex((entry)=>entry.format === error.params.format);
                        error.message = customMessages[key][index].message;
                    }
                    break;
                case "maximum":
                case "minimum":
                    error.message = customMessages[key].replace(/{(limit)}/g, error.params.limit);
                    break;
                default:
                    error.message = customMessages[key];
                    break;
            }
            error.stack = `${error.property} ${error.message}`;
            // We don't need to check again for te same error message
            delete customMessages[key];
            // We found the error message we want to override, so we break the loop.
            return false;
        }
        return true;
    });
};
const $a4816cddcbbf781f$var$SchemaTable = (props)=>{
    const { options: options, schema: schema, data: data, validate: validate, customErrorMessages: customErrorMessages, dataLwtId: dataLwtId, additionalTableHeaders: additionalTableHeaders, id: id, onDataSizeChange: onDataSizeChange } = props;
    const isFirstRender = (0, $a4816cddcbbf781f$var$EditableCell_1.useIsFirstRender)();
    const schemaTableWrapperRef = (0, $a4816cddcbbf781f$var$react_1.useRef)({});
    const columnSectionRef = (0, $a4816cddcbbf781f$var$react_1.useRef)({});
    const [state, setState] = (0, $a4816cddcbbf781f$var$react_1.useState)({
        columns: [],
        editableCells: $a4816cddcbbf781f$var$initializeEditableCells(options.keyField || "id", data, schema),
        data: data.map((row)=>Object.assign({}, row)),
        updatedCell: {
            fieldName: "",
            value: ""
        },
        rangeUpdate: [],
        selectRow: options.selectRow,
        filteredRowIds: data.map((row)=>row[options.keyField || "id"]),
        errors: []
    });
    const memoizedOnSelectAll = (0, $a4816cddcbbf781f$var$react_1.useCallback)((isChecked)=>{
        var _a, _b;
        const anySelected = state.data.some((row)=>{
            var _a;
            return row[((_a = options.selectRow) === null || _a === void 0 ? void 0 : _a.selectedFieldName) || "selected"] && state.filteredRowIds.filter((item)=>{
                var _a, _b;
                return ((_a = options.selectRow) === null || _a === void 0 ? void 0 : _a.nonSelectable) ? ((_b = options.selectRow) === null || _b === void 0 ? void 0 : _b.nonSelectable.indexOf(item)) === -1 : true;
            }).includes(row[options.keyField || "id"]);
        });
        const anyUnselected = state.data.some((row)=>{
            var _a;
            return !row[((_a = options.selectRow) === null || _a === void 0 ? void 0 : _a.selectedFieldName) || "selected"] && state.filteredRowIds.filter((item)=>{
                var _a, _b;
                return ((_a = options.selectRow) === null || _a === void 0 ? void 0 : _a.nonSelectable) ? ((_b = options.selectRow) === null || _b === void 0 ? void 0 : _b.nonSelectable.indexOf(item)) === -1 : true;
            }).includes(row[options.keyField || "id"]);
        });
        const checked = !isChecked && anySelected && anyUnselected ? true : isChecked;
        const filteredRowIds = checked ? ((_a = options.selectRow) === null || _a === void 0 ? void 0 : _a.nonSelectable) ? state.filteredRowIds.filter((item)=>{
            var _a, _b;
            return ((_b = (_a = options.selectRow) === null || _a === void 0 ? void 0 : _a.nonSelectable) === null || _b === void 0 ? void 0 : _b.indexOf(item)) === -1;
        }) : state.filteredRowIds : undefined;
        ((_b = options.selectRow) === null || _b === void 0 ? void 0 : _b.onSelectAll) && options.selectRow.onSelectAll(checked, filteredRowIds);
        if (checked) return filteredRowIds;
    }, // No need to memoize if selectRow is not being used
    [
        options.selectRow ? state.filteredRowIds : undefined,
        options.selectRow ? state.data : undefined
    ]);
    const updateTableState = (id, fieldName, cellState, updateData)=>{
        setState((prevState)=>{
            const nextState = Object.assign(Object.assign({}, prevState), {
                editableCells: {},
                updatedCell: {
                    rowId: id,
                    fieldName: fieldName,
                    value: cellState.inputProps.appliedValue,
                    updateData: updateData
                }
            });
            Object.keys(prevState.editableCells).forEach((rowId)=>{
                nextState.editableCells[rowId] = {};
                Object.keys(prevState.editableCells[rowId]).forEach((field)=>{
                    nextState.editableCells[rowId][field] = id === rowId && fieldName === field ? cellState : Object.assign({}, prevState.editableCells[rowId][field]);
                });
            });
            if (!nextState.editableCells[id]) nextState.editableCells[id] = {};
            if (!nextState.editableCells[id][fieldName]) nextState.editableCells[id][fieldName] = cellState;
            return nextState;
        });
    };
    const memoizedEditableCellFormatter = (0, $a4816cddcbbf781f$var$react_1.useCallback)((editableCellProps, keyField, fieldName, value, row, index, extraData)=>{
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        const { wrapperClasses: wrapperClasses, wrapperStyle: wrapperStyle, inputProps: inputProps, applyButtonProps: applyButtonProps, resetButtonProps: resetButtonProps, datatype: datatype } = editableCellProps;
        let applyProps, resetProps;
        const rowCellState = state.editableCells[row[options.keyField || "id"]] || {};
        const cellState = rowCellState[fieldName];
        const programmaticChange = extraData ? true : cellState.inputProps.programmaticChange;
        if (applyButtonProps) applyProps = Object.assign(Object.assign({}, applyButtonProps), {
            id: `${applyButtonProps.id}_${index}`,
            disabled: !programmaticChange ? (_a = cellState.applyButtonProps) === null || _a === void 0 ? void 0 : _a.disabled : value !== undefined && (cellState.disabled || cellState.inputProps.valueApplied ? true : (_b = cellState.applyButtonProps) === null || _b === void 0 ? void 0 : _b.disabled),
            hidden: !programmaticChange ? (_c = cellState.applyButtonProps) === null || _c === void 0 ? void 0 : _c.hidden : value !== undefined && (cellState.inputProps.valueApplied || ((_d = cellState.applyButtonProps) === null || _d === void 0 ? void 0 : _d.hidden))
        });
        if (resetButtonProps) resetProps = Object.assign(Object.assign({}, resetButtonProps), {
            id: `${resetButtonProps.id}_${index}`,
            disabled: !programmaticChange ? (_e = cellState.resetButtonProps) === null || _e === void 0 ? void 0 : _e.disabled : value === undefined && !!cellState.applyButtonProps || (cellState.disabled ? true : cellState.inputProps.valueApplied ? false : cellState.resetButtonProps && cellState.inputProps.originalValue === value && !applyButtonProps ? true : ((_f = cellState.resetButtonProps) === null || _f === void 0 ? void 0 : _f.disabled) ? !(!cellState.resetButtonProps.hidden && cellState.inputProps.appliedValue !== value || cellState.inputProps.valueApplied) : (_g = cellState.resetButtonProps) === null || _g === void 0 ? void 0 : _g.disabled),
            hidden: !programmaticChange ? (_h = cellState.resetButtonProps) === null || _h === void 0 ? void 0 : _h.hidden : value === undefined && !!cellState.applyButtonProps || (cellState.inputProps.valueApplied ? false : (_j = cellState.resetButtonProps) === null || _j === void 0 ? void 0 : _j.hidden),
            forceEnable: (_k = cellState.resetButtonProps) === null || _k === void 0 ? void 0 : _k.forceEnable
        });
        const editableCellInputProps = Object.assign(Object.assign({}, inputProps), {
            id: `${inputProps.id}_${index}`,
            originalValue: cellState.inputProps.originalValue,
            updatedValue: !programmaticChange ? cellState.inputProps.appliedValue === undefined && inputProps.setInitialValueFromField ? row[inputProps.setInitialValueFromField] : cellState.inputProps.appliedValue : inputProps.setInitialValueFromField && (value === null || value === undefined) ? row[inputProps.setInitialValueFromField] : value,
            disabled: !programmaticChange ? cellState.inputProps.disabled : extraData && [
                "disable",
                "enable"
            ].includes(extraData.action) ? extraData.action === "disable" : (value !== undefined || !cellState.applyButtonProps) && (cellState.disabled || cellState.inputProps.valueApplied || (((_l = cellState.applyButtonProps) === null || _l === void 0 ? void 0 : _l.disabled) && !cellState.applyButtonProps.hidden ? true : cellState.inputProps.disabled)),
            valueApplied: (!programmaticChange || value !== undefined) && cellState.inputProps.valueApplied,
            programmaticValue: !programmaticChange ? cellState.inputProps.programmaticValue : cellState.applyButtonProps ? undefined : cellState.inputProps.appliedValue === value || ((_m = cellState.resetButtonProps) === null || _m === void 0 ? void 0 : _m.forceEnable) ? cellState.inputProps.programmaticValue || value : value,
            isInvalid: !!row.errors && row.errors.includes(fieldName)
        });
        const onChange = (editableCellState, updateData)=>{
            updateTableState(row[keyField || "id"], fieldName, editableCellState, updateData);
        };
        const onBlur = (appliedValue)=>{
            setState((prevState)=>{
                const nextState = Object.assign(Object.assign({}, prevState), {
                    data: []
                });
                nextState.data = prevState.data.map((prevRow)=>{
                    const nextRow = Object.assign({}, prevRow);
                    if (prevRow[options.keyField || "id"] === row[keyField || "id"]) nextRow[fieldName] = appliedValue;
                    return nextRow;
                });
                return nextState;
            });
        };
        return $a4816cddcbbf781f$var$react_1.default.createElement($a4816cddcbbf781f$var$EditableCell_1.default, {
            dataLwtId: `EditableCell_row_${index}_${fieldName}`,
            disabled: extraData && [
                "disable",
                "enable"
            ].includes(extraData.action) ? extraData.action === "disable" : cellState.disabled,
            fieldName: fieldName,
            datatype: datatype,
            wrapperClasses: wrapperClasses,
            wrapperStyle: wrapperStyle,
            inputProps: editableCellInputProps,
            applyButtonProps: applyProps,
            resetButtonProps: resetProps,
            onChange: onChange,
            onBlur: onBlur
        });
    }, [
        state.editableCells
    ]);
    const memoizedConvertJsonSchemaToColumns = (0, $a4816cddcbbf781f$var$react_1.useCallback)((tableSchema, schemaOptions)=>{
        const schemaColumns = [];
        const complexTypes = [
            "object",
            "array"
        ];
        if (!tableSchema.properties) return [];
        Object.keys(tableSchema.properties).forEach((fieldName)=>{
            if (tableSchema.properties) {
                const property = tableSchema.properties[fieldName];
                const isComplex = property.type && complexTypes.indexOf(property.type) > -1;
                let formatter = property.formatter;
                let formatExtraData;
                let colFilter = property.filter !== "none" ? property.filter === undefined ? property.filterOptions ? (0, $a4816cddcbbf781f$var$react_bootstrap_table2_filter_1.textFilter)(Object.assign({}, property.filterOptions)) : (0, $a4816cddcbbf781f$var$react_bootstrap_table2_filter_1.textFilter)() : property.filter : undefined;
                switch(property.format){
                    case "link":
                        formatter = $a4816cddcbbf781f$var$linkFormatter;
                        formatExtraData = property.formatExtraData || {};
                        formatExtraData.dataLwtId = dataLwtId;
                        formatExtraData.fieldName = fieldName;
                        if (!formatExtraData.keyName) formatExtraData.keyName = schemaOptions.keyField || "id";
                        break;
                    case "enum":
                        formatter = property.formatter ? property.formatter : $a4816cddcbbf781f$var$enumFormatter;
                        formatExtraData = property.options;
                        colFilter = (0, $a4816cddcbbf781f$var$react_bootstrap_table2_filter_1.selectFilter)(Object.assign({
                            options: property.options,
                            condition: "eq"
                        }, property.filterOptions));
                        break;
                    case "bool":
                        colFilter = (0, $a4816cddcbbf781f$var$react_bootstrap_table2_filter_1.selectFilter)(Object.assign({
                            options: {
                                true: "true",
                                false: "false"
                            },
                            condition: "eq"
                        }, property.filterOptions));
                        break;
                    case "custom":
                        formatter = property.formatter;
                        formatExtraData = property.formatExtraData;
                        if (property.filterOptions && property.filterRenderer) colFilter = (0, $a4816cddcbbf781f$var$react_bootstrap_table2_filter_1.customFilter)(Object.assign({}, property.filterOptions));
                        break;
                    case "date":
                        {
                            const dateComparators = getComparators(property.comparators ? property.comparators : [
                                "all"
                            ]);
                            colFilter = (0, $a4816cddcbbf781f$var$react_bootstrap_table2_filter_1.dateFilter)(Object.assign(Object.assign({}, property.filterOptions), {
                                comparators: dateComparators
                            }));
                            break;
                        }
                    case "date-picker":
                        colFilter = (0, $a4816cddcbbf781f$var$react_bootstrap_table2_filter_1.customFilter)({
                            type: $a4816cddcbbf781f$var$react_bootstrap_table2_filter_1.FILTER_TYPES.DATE
                        });
                        property.filterRenderer = function filterRenderer(onFilter) {
                            return $a4816cddcbbf781f$var$react_1.default.createElement($a4816cddcbbf781f$var$DatePickerFilter_1.default, {
                                onFilter: onFilter,
                                datePickerProps: property.filterOptions
                            });
                        };
                        break;
                    case "number-compare":
                        {
                            const numberComparators = getComparators(property.comparators ? property.comparators : [
                                "all"
                            ]);
                            colFilter = (0, $a4816cddcbbf781f$var$react_bootstrap_table2_filter_1.numberFilter)(Object.assign(Object.assign({}, property.filterOptions), {
                                comparators: numberComparators
                            }));
                            break;
                        }
                    case "select":
                        {
                            const selectProps = property.filterOptions;
                            formatter = $a4816cddcbbf781f$var$enumFormatter;
                            formatExtraData = property.formatExtraData;
                            colFilter = selectProps.isMulti ? (0, $a4816cddcbbf781f$var$react_bootstrap_table2_filter_1.customFilter)({
                                options: formatExtraData,
                                comparator: $a4816cddcbbf781f$var$react_bootstrap_table2_filter_1.Comparator.LIKE,
                                type: $a4816cddcbbf781f$var$react_bootstrap_table2_filter_1.FILTER_TYPES.MULTISELECT
                            }) : (0, $a4816cddcbbf781f$var$react_bootstrap_table2_filter_1.selectFilter)(Object.assign({
                                options: formatExtraData,
                                condition: "eq"
                            }, formatExtraData));
                            property.filterRenderer = function filterRenderer(onFilter) {
                                var _a;
                                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                const onChange = (value)=>{
                                    let filterVal = null;
                                    if (value) filterVal = selectProps.isMulti ? value.reduce((a, o)=>(a.push(o.value), a), []) : value.value;
                                    onFilter && onFilter(filterVal);
                                };
                                return $a4816cddcbbf781f$var$react_1.default.createElement("span", {
                                    onClick: (e)=>e.stopPropagation()
                                }, $a4816cddcbbf781f$var$react_1.default.createElement($a4816cddcbbf781f$var$select_1.default, Object.assign({}, selectProps, {
                                    className: "schema-table-select",
                                    onChange: (value)=>onChange(value),
                                    styles: (_a = property.filterOptions) === null || _a === void 0 ? void 0 : _a.styles
                                })));
                            };
                        }
                        break;
                    default:
                        break;
                }
                if (property.editableCellProps) {
                    formatter = memoizedEditableCellFormatter.bind(null, Object.assign(Object.assign({}, property.editableCellProps), {
                        datatype: property.type || "string"
                    }), schemaOptions.keyField || "id", fieldName);
                    formatExtraData = property.formatExtraData;
                }
                const columnProps = {
                    dataField: fieldName,
                    text: schemaOptions.translationCallback ? schemaOptions.translationCallback(property.title) : property.title,
                    type: property.type === "boolean" ? "bool" : property.type === "string" && property.format === "date" ? "date" : property.type,
                    hidden: property.hidden,
                    formatter: formatter,
                    formatExtraData: formatExtraData,
                    sort: property.sort != null ? property.sort : !isComplex,
                    classes: property.cssClasses,
                    style: property.style,
                    headerClasses: property.headerClasses,
                    headerStyle: property.headerStyle,
                    filter: colFilter,
                    isDummyField: property.isDummyField,
                    headerAttrs: property.headerAttrs
                };
                if (property.headerFormatter) columnProps.headerFormatter = property.headerFormatter;
                if (property.footer) columnProps.footer = property.footer;
                if (property.footerFormatter) columnProps.footerFormatter = property.footerFormatter;
                if (property.footerClasses) columnProps.footerClasses = property.footerClasses;
                if (property.footerAttrs) columnProps.footerAttrs = property.footerAttrs;
                if (property.sortValue) columnProps.sortValue = property.sortValue;
                if (property.onSort) columnProps.onSort = property.onSort;
                if (property.sortCaret) columnProps.sortCaret = property.sortCaret;
                if (property.filterValue) columnProps.filterValue = property.filterValue;
                if (property.validator) columnProps.validator = property.validator;
                if (property.filterRenderer) columnProps.filterRenderer = property.filterRenderer;
                if (!schemaOptions.showFilters) delete columnProps.filter;
                if (property.sortFunc) columnProps.sortFunc = property.sortFunc;
                else if (property.type === "date") columnProps.sortFunc = $a4816cddcbbf781f$var$dateSort;
                if (fieldName === (schemaOptions.keyField || "id")) columnProps.hidden = schemaOptions.hideKeyColumn !== false;
                schemaColumns.push(columnProps);
            }
        });
        return schemaColumns;
    }, [
        memoizedEditableCellFormatter,
        schema
    ]);
    const getComparators = (propComp)=>{
        const comparators = [];
        if (propComp) {
            if (propComp.findIndex((value)=>value === "all" || value === "eq") > -1) comparators.push($a4816cddcbbf781f$var$react_bootstrap_table2_filter_1.Comparator.EQ);
            if (propComp.findIndex((value)=>value === "all" || value === "gt") > -1) comparators.push($a4816cddcbbf781f$var$react_bootstrap_table2_filter_1.Comparator.GT);
            if (propComp.findIndex((value)=>value === "all" || value === "lt") > -1) comparators.push($a4816cddcbbf781f$var$react_bootstrap_table2_filter_1.Comparator.LT);
            if (propComp.findIndex((value)=>value === "all" || value === "ne") > -1) comparators.push($a4816cddcbbf781f$var$react_bootstrap_table2_filter_1.Comparator.NE);
            if (propComp.findIndex((value)=>value === "all" || value === "le") > -1) comparators.push($a4816cddcbbf781f$var$react_bootstrap_table2_filter_1.Comparator.LE);
            if (propComp.findIndex((value)=>value === "all" || value === "ge") > -1) comparators.push($a4816cddcbbf781f$var$react_bootstrap_table2_filter_1.Comparator.GE);
        }
        return comparators !== null && comparators !== void 0 ? comparators : [
            $a4816cddcbbf781f$var$react_bootstrap_table2_filter_1.Comparator.EQ,
            $a4816cddcbbf781f$var$react_bootstrap_table2_filter_1.Comparator.GT,
            $a4816cddcbbf781f$var$react_bootstrap_table2_filter_1.Comparator.LT
        ];
    };
    const memoizedValidate = (0, $a4816cddcbbf781f$var$react_1.useCallback)((dataFilter)=>{
        const jsonSchema = {
            type: "array",
            items: schema
        };
        // Note that these filtered rows are not necessarily the same as the result of filtering trough the
        // column header filters. These will typically be the rows the user "selected" to submit.
        const filteredRows = dataFilter ? dataFilter(state.data) : state.data;
        const { errors: validationErrors } = (0, $a4816cddcbbf781f$var$validate_1.default)(filteredRows, jsonSchema);
        validationErrors.forEach((error)=>{
            const index = error.property.split("[")[1].split("]")[0];
            const regExp = new RegExp(`[${index}]`, "g");
            error.property = error.property.replace(regExp, filteredRows[index][options.keyField || "id"]);
            error.stack = error.stack.replace(regExp, filteredRows[index][options.keyField || "id"]);
        });
        validate && validate(filteredRows, validationErrors);
        validationErrors.forEach((error)=>{
            $a4816cddcbbf781f$var$applyCustomValidationMessages(Object.assign({}, customErrorMessages), error);
            const fieldName = error.property.split(".").pop() || "";
            const fieldTitle = schema.properties[fieldName].title || "";
            error.message = error.message.replace(/{(field)}/g, fieldTitle);
            error.stack = error.stack.replace(/{(field)}/g, fieldTitle);
            error.id = error.property.split("[")[1].split("]")[0];
        });
        !(0, $a4816cddcbbf781f$var$isEqual_1.default)(state.errors, validationErrors) && setState((prevState)=>Object.assign(Object.assign({}, prevState), {
                errors: validationErrors
            }));
        return validationErrors;
    }, [
        state.data
    ]);
    const initializeSelectRow = (selectRowOptions)=>{
        if (!selectRowOptions) return undefined;
        const { headerCustomInput: headerCustomInput, rowCustomInput: rowCustomInput } = selectRowOptions, selectRowRest = $a4816cddcbbf781f$var$__rest(selectRowOptions, [
            "headerCustomInput",
            "rowCustomInput"
        ]);
        const selectRowProps = Object.assign(Object.assign({}, selectRowRest), {
            mode: selectRowRest.mode || "checkbox",
            selectColumnPosition: selectRowOptions.selectColumnPosition || "right",
            headerColumnStyle: selectRowOptions.headerColumnStyle || {
                fontWeight: "normal",
                verticalAlign: "top",
                textAlign: "center",
                width: "80px"
            },
            selectionHeaderRenderer: selectRowRest.selectionHeaderRenderer || ((headerProps)=>$a4816cddcbbf781f$var$react_1.default.createElement($a4816cddcbbf781f$var$react_1.default.Fragment, null, selectRowRest.headerTitle ? $a4816cddcbbf781f$var$react_1.default.createElement($a4816cddcbbf781f$var$react_1.default.Fragment, null, selectRowRest.headerTitle, $a4816cddcbbf781f$var$react_1.default.createElement("br", null)) : "", $a4816cddcbbf781f$var$react_1.default.createElement($7jSYQ.default, {
                    inline: true,
                    dataLwtId: (headerCustomInput === null || headerCustomInput === void 0 ? void 0 : headerCustomInput.dataLwtId) || "selectAll",
                    type: headerProps.mode,
                    checked: headerProps.checked,
                    className: (headerCustomInput === null || headerCustomInput === void 0 ? void 0 : headerCustomInput.className) || "ml-3 mt-2"
                }))),
            onSelectAll: memoizedOnSelectAll,
            selectColumnStyle: selectRowRest.selectColumnStyle || {
                verticalAlign: "top",
                textAlign: "center"
            },
            selectionRenderer: selectRowRest.selectionRenderer || ((rowProps)=>$a4816cddcbbf781f$var$react_1.default.createElement($a4816cddcbbf781f$var$react_1.default.Fragment, null, $a4816cddcbbf781f$var$react_1.default.createElement($7jSYQ.default, {
                    inline: true,
                    dataLwtId: `select-${(rowCustomInput === null || rowCustomInput === void 0 ? void 0 : rowCustomInput.dataLwtId) || ""}${rowProps.rowIndex}`,
                    type: rowProps.mode,
                    checked: rowProps.checked,
                    className: (rowCustomInput === null || rowCustomInput === void 0 ? void 0 : rowCustomInput.className) || "ml-3",
                    disabled: rowProps.disabled
                })))
        });
        return selectRowProps;
    };
    const afterFilter = (filteredData, filterDetails)=>{
        // If the option to getFilterDetails exist send back the details of the filter
        options.getFilterDetails && options.getFilterDetails(filterDetails);
        // When we update the state it seems that the rerender is causing the filter to be applied again, so this
        // function will continue running in an infinite loop. To solve this, we need to compare the filteredData to
        // state.filteredRows and only update the state if the filtered rows changed
        if (state.filteredRowIds.length !== filteredData.length || filteredData.length > 0 && !filteredData.some((row)=>state.filteredRowIds.some((filteredId)=>filteredId === row[options.keyField || "id"]))) {
            setState((prevState)=>Object.assign(Object.assign({}, prevState), {
                    filteredRowIds: filteredData.map((row)=>row[options.keyField || "id"])
                }));
            options.onFilter && options.onFilter(filteredData.map((filteredRow)=>filteredRow[options.keyField || "id"]));
        }
    };
    const pagination = ()=>{
        if (options.showPagination) return (0, $a4816cddcbbf781f$var$react_bootstrap_table2_paginator_1.default)(Object.assign({}, options.paginationOptions));
    };
    const generateExtraTableHeaders = (tableHeaderColumns, headerRow)=>{
        return tableHeaderColumns.map((header, index)=>{
            const headerAttrs = headerRow[header].attrs ? headerRow[header].attrs : {};
            return $a4816cddcbbf781f$var$react_1.default.createElement("th", Object.assign({}, headerAttrs), $a4816cddcbbf781f$var$react_1.default.createElement($a4816cddcbbf781f$var$react_1.default.Fragment, null, headerRow[header] && headerRow[header].title));
        });
    };
    const getCircularReplacer = ()=>{
        const seen = new WeakSet();
        return (key, value)=>{
            if (typeof value === "object" && value !== null) {
                if (seen.has(value)) return;
                seen.add(value);
            }
            return value;
        };
    };
    (0, $a4816cddcbbf781f$var$react_1.useEffect)(()=>{
        setState((prevState)=>Object.assign(Object.assign({}, prevState), {
                columns: memoizedConvertJsonSchemaToColumns(schema, options)
            }));
        if (options.editableCells && options.editableCells.schemaTableRef && options.editableCells.schemaTableRef.current && !options.editableCells.schemaTableRef.current.updateCellState) options.editableCells.schemaTableRef.current = {
            updateCellState: (update)=>{
                setState((prevState)=>{
                    const rangeUpdate = update.map((row)=>{
                        const fields = {};
                        Object.keys(row.fields).forEach((fieldName)=>{
                            fields[fieldName] = row.fields[fieldName].appliedValue;
                        });
                        return {
                            id: row.id,
                            fields: fields
                        };
                    });
                    const nextState = Object.assign(Object.assign({}, prevState), {
                        editableCells: {},
                        rangeUpdate: rangeUpdate
                    });
                    prevState.data.forEach((prevRow)=>{
                        const rowUpdate = update.find((row)=>row.id === prevRow[options.keyField || "id"]);
                        if (rowUpdate) Object.keys(rowUpdate.fields).forEach((fieldName)=>{
                            const editableCellState = $a4816cddcbbf781f$var$updateEditableCellState(rowUpdate.fields[fieldName].action, prevState.editableCells[rowUpdate.id][fieldName]);
                            nextState.editableCells = Object.assign(Object.assign(Object.assign({}, prevState.editableCells), nextState.editableCells), {
                                [rowUpdate.id]: Object.assign(Object.assign(Object.assign({}, prevState.editableCells[rowUpdate.id]), nextState.editableCells[rowUpdate.id]), {
                                    [fieldName]: editableCellState
                                })
                            });
                        });
                    });
                    return nextState;
                });
            },
            validate: memoizedValidate
        };
    }, [
        memoizedConvertJsonSchemaToColumns
    ]);
    (0, $a4816cddcbbf781f$var$react_1.useEffect)(()=>{
        var _a;
        if ((_a = options === null || options === void 0 ? void 0 : options.editableCells) === null || _a === void 0 ? void 0 : _a.schemaTableRef) options.editableCells.schemaTableRef.current.validate = memoizedValidate;
    }, [
        memoizedValidate
    ]);
    (0, $a4816cddcbbf781f$var$react_1.useEffect)(()=>{
        setState((prevState)=>{
            const nextState = Object.assign(Object.assign({}, prevState), {
                data: []
            });
            const selectedRows = [];
            let selectionChanged = false;
            const editableColumns = Object.keys(schema.properties).filter((column)=>!!schema.properties[column].editableCellProps).map((column)=>({
                    name: column,
                    editableCellProps: schema.properties[column].editableCellProps
                }));
            nextState.data = data.map((row)=>{
                var _a, _b, _c;
                const rowId = row[options.keyField || "id"];
                // In case new rows are added to the table, we need to initialize their editable cells' state
                if (editableColumns && !prevState.editableCells[rowId]) nextState.editableCells[rowId] = $a4816cddcbbf781f$var$initializeRowEditableCells(row, editableColumns);
                if (options.selectionChanged) {
                    if (row[((_a = options.selectRow) === null || _a === void 0 ? void 0 : _a.selectedFieldName) || "selected"]) selectedRows.push(row[options.keyField || "id"]);
                } else if (prevState.selectRow && options.selectionChanged === undefined) {
                    if (row[((_b = options.selectRow) === null || _b === void 0 ? void 0 : _b.selectedFieldName) || "selected"]) {
                        selectedRows.push(row[options.keyField || "id"]);
                        if (prevState.data.some((r)=>{
                            var _a;
                            return r[options.keyField || "id"] === row[options.keyField || "id"] && !r[((_a = options.selectRow) === null || _a === void 0 ? void 0 : _a.selectedFieldName) || "selected"];
                        })) selectionChanged = true;
                    } else if ([
                        undefined,
                        false
                    ].includes(row[((_c = options.selectRow) === null || _c === void 0 ? void 0 : _c.selectedFieldName) || "selected"]) && prevState.data.some((r)=>{
                        var _a;
                        return r[options.keyField || "id"] === row[options.keyField || "id"] && r[((_a = options.selectRow) === null || _a === void 0 ? void 0 : _a.selectedFieldName) || "selected"];
                    })) selectionChanged = true;
                }
                const nextRow = Object.assign({}, row);
                if (!options.ignoreRowChanged) {
                    const prevRow = prevState.data.find((r)=>r[options.keyField || "id"] === rowId);
                    if (prevRow === null || prevRow === void 0 ? void 0 : prevRow.renderTrigger) nextRow.renderTrigger = prevRow.renderTrigger;
                    if (prevRow === null || prevRow === void 0 ? void 0 : prevRow.errors) nextRow.errors = prevRow.errors;
                }
                return nextRow;
            });
            if (options.selectionChanged || selectionChanged) nextState.selectRow = Object.assign(Object.assign({}, prevState.selectRow), {
                selected: selectedRows
            });
            return nextState;
        });
    }, [
        data
    ]);
    (0, $a4816cddcbbf781f$var$react_1.useEffect)(()=>{
        state.updatedCell.rowId && !state.updatedCell.runOnChange && setState((prevState)=>{
            const nextState = Object.assign(Object.assign({}, prevState), {
                data: state.updatedCell.updateData ? [] : prevState.data,
                editableCells: {},
                updatedCell: Object.assign(Object.assign({}, prevState.updatedCell), {
                    runOnChange: true
                })
            });
            const editableColumns = Object.keys(schema.properties).filter((column)=>!!schema.properties[column].editableCellProps).map((column)=>({
                    name: column,
                    editableCellProps: schema.properties[column].editableCellProps
                }));
            const nextData = prevState.data.map((prevRow)=>{
                if (editableColumns) {
                    const rowId = prevRow[options.keyField || "id"];
                    nextState.editableCells[rowId] = {};
                    Object.keys(prevState.editableCells[rowId]).forEach((field)=>{
                        nextState.editableCells[rowId][field] = Object.assign(Object.assign({}, prevState.editableCells[rowId][field]), {
                            inputProps: Object.assign(Object.assign({}, prevState.editableCells[rowId][field].inputProps), {
                                programmaticChange: true
                            })
                        });
                    });
                }
                const nextRow = Object.assign({}, prevRow);
                if (prevRow[options.keyField || "id"] === state.updatedCell.rowId) nextRow[state.updatedCell.fieldName] = state.updatedCell.value;
                return nextRow;
            });
            if (state.updatedCell.updateData) nextState.data = nextData;
            return nextState;
        });
        if (options.editableCells && options.editableCells.onChange && state.updatedCell.rowId && state.updatedCell.runOnChange) {
            setState((prevState)=>Object.assign(Object.assign({}, prevState), {
                    updatedCell: {
                        fieldName: "",
                        value: ""
                    }
                }));
            options.editableCells.onChange(state.updatedCell.rowId, state.updatedCell.fieldName, state.updatedCell.value);
        }
    }, [
        state.updatedCell.rowId,
        state.updatedCell.fieldName,
        state.updatedCell.value,
        state.updatedCell.runOnChange,
        state.updatedCell.updateData
    ]);
    (0, $a4816cddcbbf781f$var$react_1.useEffect)(()=>{
        state.rangeUpdate.length > 0 && setState((prevState)=>Object.assign(Object.assign({}, prevState), {
                rangeUpdate: [],
                data: prevState.data.map((prevRow)=>{
                    const nextRow = Object.assign({}, prevRow);
                    const rowUpdate = state.rangeUpdate.find((row)=>row.id === prevRow[options.keyField || "id"]);
                    if (rowUpdate) {
                        Object.keys(rowUpdate.fields).forEach((fieldName)=>{
                            nextRow[fieldName] = rowUpdate.fields[fieldName];
                        });
                        // Force row to rerender
                        nextRow.renderTrigger = (0, $kBJxW.nanoid)(10);
                    }
                    return Object.assign({}, nextRow);
                })
            }));
    }, [
        state.rangeUpdate
    ]);
    (0, $a4816cddcbbf781f$var$react_1.useEffect)(()=>{
        // I submitted an issue in react-bootstrap-table official website, the related ticket number is
        // selectRow.selectionRenderer miss row id #1534
        // once it is resolved, we can remove isFirstRender check condition, use row id as key value of CustomInput
        if (isFirstRender && options.selectRow) setState((prevState)=>Object.assign(Object.assign({}, prevState), {
                selectRow: initializeSelectRow(options.selectRow)
            }));
    }, [
        options.selectRow
    ]);
    (0, $a4816cddcbbf781f$var$react_1.useEffect)(()=>{
        setState((prevState)=>Object.assign(Object.assign({}, prevState), {
                data: prevState.data.map((prevRow)=>{
                    const nextRow = Object.assign({}, prevRow);
                    const error = state.errors.find((err)=>err.id === nextRow[options.keyField || "id"]);
                    if (error) {
                        const fieldName = error.property.split(".").pop() || "";
                        if (!nextRow.errors) nextRow.errors = [
                            fieldName
                        ];
                        else if (!nextRow.errors.includes(fieldName)) nextRow.errors.push(fieldName);
                    } else if (nextRow.errors) delete nextRow.errors;
                    return nextRow;
                })
            }));
    }, [
        state.errors
    ]);
    (0, $a4816cddcbbf781f$var$react_1.useEffect)(()=>{
        if (state.selectRow) setState((prevState)=>Object.assign(Object.assign({}, prevState), {
                selectRow: Object.assign(Object.assign({}, prevState.selectRow), {
                    onSelectAll: memoizedOnSelectAll
                })
            }));
    }, [
        memoizedOnSelectAll
    ]);
    (0, $a4816cddcbbf781f$var$react_1.useEffect)(()=>{
        if (schemaTableWrapperRef && additionalTableHeaders) {
            if (schemaTableWrapperRef.current.querySelector) {
                const tHead = schemaTableWrapperRef.current.querySelector("thead");
                if (tHead && JSON.stringify(additionalTableHeaders, getCircularReplacer()) !== JSON.stringify(columnSectionRef.current, getCircularReplacer())) {
                    columnSectionRef.current = additionalTableHeaders;
                    const previousItems = schemaTableWrapperRef.current.querySelectorAll('[data-column-section="true"]');
                    // If there are any rows remove them before adding new ones
                    Array.from(previousItems).map((item)=>{
                        item.remove();
                    });
                    const copyOfAdditionalTableHeaders = [
                        ...additionalTableHeaders
                    ];
                    copyOfAdditionalTableHeaders.reverse().map((headerRow)=>{
                        const newTr = document.createElement("tr");
                        newTr.setAttribute("data-column-section", "true");
                        const columns = Object.keys(headerRow);
                        tHead.insertBefore(newTr, tHead.firstChild);
                        const thsToRender = generateExtraTableHeaders(columns, headerRow);
                        $a4816cddcbbf781f$var$react_dom_1.default.render(thsToRender, tHead.childNodes[0]);
                    });
                }
            }
        }
    }, [
        state.columns,
        additionalTableHeaders
    ]);
    return $a4816cddcbbf781f$var$react_1.default.createElement($a4816cddcbbf781f$var$react_1.default.Fragment, null, state.columns.length > 0 ? $a4816cddcbbf781f$var$react_1.default.createElement("div", {
        "data-lwt-id": dataLwtId,
        id: id,
        ref: schemaTableWrapperRef
    }, $a4816cddcbbf781f$var$react_1.default.createElement($a4816cddcbbf781f$var$react_bootstrap_table_next_1.default, {
        id: options.id,
        ref: options.ref,
        keyField: options.keyField || "id",
        columns: state.columns,
        data: state.data,
        bootstrap4: options.bootstrap4,
        noDataIndication: options.noDataIndication,
        classes: options.tableClasses,
        wrapperClasses: options.wrapperClasses || "my-container-class",
        headerClasses: options.headerClasses,
        rowClasses: options.rowClasses,
        rowStyle: options.rowStyle,
        defaultSorted: options.defaultSorted,
        defaultSortDirection: options.defaultSortDirection,
        striped: options.striped,
        hover: options.hover,
        bordered: options.bordered,
        condensed: options.condensed,
        filter: (0, $a4816cddcbbf781f$var$react_bootstrap_table2_filter_1.default)({
            afterFilter: afterFilter
        }),
        filterPosition: options.filterPosition,
        pagination: pagination(),
        selectRow: state.selectRow,
        sort: options.sort,
        hiddenRows: options.hiddenRows,
        onDataSizeChange: onDataSizeChange
    })) : null);
};
module.exports.default = $a4816cddcbbf781f$var$SchemaTable;
const $a4816cddcbbf781f$var$addCustomError = (errors, rowId, fieldName, errorMessage)=>{
    const property = `[${rowId}].${fieldName}`;
    const error = {
        name: "custom",
        property: property,
        stack: `${property} ${errorMessage}`,
        params: {
            comparison: "custom"
        },
        message: errorMessage
    };
    errors.push(error);
};
module.exports.addCustomError = $a4816cddcbbf781f$var$addCustomError;

});
parcelRegister("hfoyt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $d8WAi = parcelRequire("d8WAi");
var $c8e6e28072ff0e67$var$_bootstrapTable2 = $c8e6e28072ff0e67$var$_interopRequireDefault($d8WAi);

var $aKVZT = parcelRequire("aKVZT");
var $c8e6e28072ff0e67$var$_contexts2 = $c8e6e28072ff0e67$var$_interopRequireDefault($aKVZT);
function $c8e6e28072ff0e67$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.default = (0, $c8e6e28072ff0e67$var$_contexts2.default)($c8e6e28072ff0e67$var$_bootstrapTable2.default);

});
parcelRegister("d8WAi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $9919775ac7af4764$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $9919775ac7af4764$var$_react2 = $9919775ac7af4764$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");
var $9919775ac7af4764$var$_propTypes2 = $9919775ac7af4764$var$_interopRequireDefault($c9Z8w);

var $8g1PZ = parcelRequire("8g1PZ");
var $9919775ac7af4764$var$_classnames2 = $9919775ac7af4764$var$_interopRequireDefault($8g1PZ);

var $70H8J = parcelRequire("70H8J");
var $9919775ac7af4764$var$_header2 = $9919775ac7af4764$var$_interopRequireDefault($70H8J);

var $gXQHT = parcelRequire("gXQHT");
var $9919775ac7af4764$var$_filters2 = $9919775ac7af4764$var$_interopRequireDefault($gXQHT);

var $2B8Xk = parcelRequire("2B8Xk");
var $9919775ac7af4764$var$_caption2 = $9919775ac7af4764$var$_interopRequireDefault($2B8Xk);

var $37VUd = parcelRequire("37VUd");
var $9919775ac7af4764$var$_body2 = $9919775ac7af4764$var$_interopRequireDefault($37VUd);

var $bWrrC = parcelRequire("bWrrC");
var $9919775ac7af4764$var$_footer2 = $9919775ac7af4764$var$_interopRequireDefault($bWrrC);

var $dOhOH = parcelRequire("dOhOH");
var $9919775ac7af4764$var$_propsResolver2 = $9919775ac7af4764$var$_interopRequireDefault($dOhOH);

var $jVgbO = parcelRequire("jVgbO");
var $9919775ac7af4764$var$_const2 = $9919775ac7af4764$var$_interopRequireDefault($jVgbO);

var $dQ68B = parcelRequire("dQ68B");
var $9919775ac7af4764$var$_utils2 = $9919775ac7af4764$var$_interopRequireDefault($dQ68B);
function $9919775ac7af4764$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9919775ac7af4764$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9919775ac7af4764$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9919775ac7af4764$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $9919775ac7af4764$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint camelcase: 0 */ 
/* eslint arrow-body-style: 0 */ var $9919775ac7af4764$var$BootstrapTable = function(_PropsBaseResolver) {
    $9919775ac7af4764$var$_inherits(BootstrapTable, _PropsBaseResolver);
    function BootstrapTable(props) {
        $9919775ac7af4764$var$_classCallCheck(this, BootstrapTable);
        var _this = $9919775ac7af4764$var$_possibleConstructorReturn(this, (BootstrapTable.__proto__ || Object.getPrototypeOf(BootstrapTable)).call(this, props));
        _this.getData = function() {
            return _this.visibleRows();
        };
        _this.validateProps();
        return _this;
    }
    $9919775ac7af4764$var$_createClass(BootstrapTable, [
        {
            key: "UNSAFE_componentWillReceiveProps",
            value: function UNSAFE_componentWillReceiveProps(nextProps) {
                if (nextProps.onDataSizeChange && !nextProps.pagination) {
                    if (nextProps.data.length !== this.props.data.length) nextProps.onDataSizeChange({
                        dataSize: nextProps.data.length
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, loading = _props.loading, overlay = _props.overlay;
                if (overlay) {
                    var LoadingOverlay = overlay(loading);
                    return $9919775ac7af4764$var$_react2.default.createElement(LoadingOverlay, null, this.renderTable());
                }
                return this.renderTable();
            }
        },
        {
            key: "renderTable",
            value: function renderTable() {
                var _props2 = this.props, columns = _props2.columns, keyField = _props2.keyField, tabIndexCell = _props2.tabIndexCell, id = _props2.id, classes = _props2.classes, bootstrap4 = _props2.bootstrap4, striped = _props2.striped, hover = _props2.hover, bordered = _props2.bordered, condensed = _props2.condensed, noDataIndication = _props2.noDataIndication, caption = _props2.caption, rowStyle = _props2.rowStyle, rowClasses = _props2.rowClasses, wrapperClasses = _props2.wrapperClasses, rowEvents = _props2.rowEvents, selectRow = _props2.selectRow, expandRow = _props2.expandRow, cellEdit = _props2.cellEdit, filterPosition = _props2.filterPosition;
                var tableWrapperClass = (0, $9919775ac7af4764$var$_classnames2.default)("react-bootstrap-table", wrapperClasses);
                var tableClass = (0, $9919775ac7af4764$var$_classnames2.default)("table", $9919775ac7af4764$var$_defineProperty({
                    "table-striped": striped,
                    "table-hover": hover,
                    "table-bordered": bordered
                }, bootstrap4 ? "table-sm" : "table-condensed", condensed), classes);
                var hasFilters = columns.some(function(col) {
                    return col.filter || col.filterRenderer;
                });
                var hasFooter = $9919775ac7af4764$var$_utils2.default.filter(columns, function(col) {
                    return $9919775ac7af4764$var$_utils2.default.has(col, "footer");
                }).length > 0;
                var tableCaption = caption && $9919775ac7af4764$var$_react2.default.createElement($9919775ac7af4764$var$_caption2.default, {
                    bootstrap4: bootstrap4
                }, caption);
                return $9919775ac7af4764$var$_react2.default.createElement("div", {
                    className: tableWrapperClass
                }, $9919775ac7af4764$var$_react2.default.createElement("table", {
                    id: id,
                    className: tableClass
                }, tableCaption, $9919775ac7af4764$var$_react2.default.createElement($9919775ac7af4764$var$_header2.default, {
                    columns: columns,
                    className: this.props.headerClasses,
                    wrapperClasses: this.props.headerWrapperClasses,
                    sortField: this.props.sortField,
                    sortOrder: this.props.sortOrder,
                    onSort: this.props.onSort,
                    globalSortCaret: this.props.sort && this.props.sort.sortCaret,
                    onFilter: this.props.onFilter,
                    currFilters: this.props.currFilters,
                    onExternalFilter: this.props.onExternalFilter,
                    selectRow: selectRow,
                    expandRow: expandRow,
                    filterPosition: filterPosition
                }), hasFilters && filterPosition !== $9919775ac7af4764$var$_const2.default.FILTERS_POSITION_INLINE && $9919775ac7af4764$var$_react2.default.createElement($9919775ac7af4764$var$_filters2.default, {
                    columns: columns,
                    className: this.props.filtersClasses,
                    onSort: this.props.onSort,
                    onFilter: this.props.onFilter,
                    currFilters: this.props.currFilters,
                    filterPosition: this.props.filterPosition,
                    onExternalFilter: this.props.onExternalFilter,
                    selectRow: selectRow,
                    expandRow: expandRow
                }), $9919775ac7af4764$var$_react2.default.createElement($9919775ac7af4764$var$_body2.default, {
                    className: this.props.bodyClasses,
                    data: this.getData(),
                    keyField: keyField,
                    tabIndexCell: tabIndexCell,
                    columns: columns,
                    isEmpty: this.isEmpty(),
                    visibleColumnSize: this.visibleColumnSize(),
                    noDataIndication: noDataIndication,
                    cellEdit: cellEdit,
                    selectRow: selectRow,
                    expandRow: expandRow,
                    rowStyle: rowStyle,
                    rowClasses: rowClasses,
                    rowEvents: rowEvents
                }), hasFooter && $9919775ac7af4764$var$_react2.default.createElement($9919775ac7af4764$var$_footer2.default, {
                    data: this.getData(),
                    columns: columns,
                    selectRow: selectRow,
                    expandRow: expandRow,
                    className: this.props.footerClasses
                })));
            }
        }
    ]);
    return BootstrapTable;
}((0, $9919775ac7af4764$var$_propsResolver2.default)($acw62.Component));
$9919775ac7af4764$var$BootstrapTable.propTypes = {
    keyField: $9919775ac7af4764$var$_propTypes2.default.string.isRequired,
    data: $9919775ac7af4764$var$_propTypes2.default.array.isRequired,
    columns: $9919775ac7af4764$var$_propTypes2.default.array.isRequired,
    bootstrap4: $9919775ac7af4764$var$_propTypes2.default.bool,
    remote: $9919775ac7af4764$var$_propTypes2.default.oneOfType([
        $9919775ac7af4764$var$_propTypes2.default.bool,
        $9919775ac7af4764$var$_propTypes2.default.shape({
            pagination: $9919775ac7af4764$var$_propTypes2.default.bool
        })
    ]),
    noDataIndication: $9919775ac7af4764$var$_propTypes2.default.oneOfType([
        $9919775ac7af4764$var$_propTypes2.default.node,
        $9919775ac7af4764$var$_propTypes2.default.func
    ]),
    striped: $9919775ac7af4764$var$_propTypes2.default.bool,
    bordered: $9919775ac7af4764$var$_propTypes2.default.bool,
    hover: $9919775ac7af4764$var$_propTypes2.default.bool,
    tabIndexCell: $9919775ac7af4764$var$_propTypes2.default.bool,
    id: $9919775ac7af4764$var$_propTypes2.default.string,
    classes: $9919775ac7af4764$var$_propTypes2.default.string,
    headerClasses: $9919775ac7af4764$var$_propTypes2.default.string,
    bodyClasses: $9919775ac7af4764$var$_propTypes2.default.string,
    wrapperClasses: $9919775ac7af4764$var$_propTypes2.default.string,
    headerWrapperClasses: $9919775ac7af4764$var$_propTypes2.default.string,
    condensed: $9919775ac7af4764$var$_propTypes2.default.bool,
    caption: $9919775ac7af4764$var$_propTypes2.default.oneOfType([
        $9919775ac7af4764$var$_propTypes2.default.node,
        $9919775ac7af4764$var$_propTypes2.default.string
    ]),
    pagination: $9919775ac7af4764$var$_propTypes2.default.object,
    filter: $9919775ac7af4764$var$_propTypes2.default.object,
    cellEdit: $9919775ac7af4764$var$_propTypes2.default.object,
    selectRow: $9919775ac7af4764$var$_propTypes2.default.shape({
        mode: $9919775ac7af4764$var$_propTypes2.default.oneOf([
            $9919775ac7af4764$var$_const2.default.ROW_SELECT_SINGLE,
            $9919775ac7af4764$var$_const2.default.ROW_SELECT_MULTIPLE,
            $9919775ac7af4764$var$_const2.default.ROW_SELECT_DISABLED
        ]).isRequired,
        clickToSelect: $9919775ac7af4764$var$_propTypes2.default.bool,
        clickToExpand: $9919775ac7af4764$var$_propTypes2.default.bool,
        clickToEdit: $9919775ac7af4764$var$_propTypes2.default.bool,
        hideSelectAll: $9919775ac7af4764$var$_propTypes2.default.bool,
        onSelect: $9919775ac7af4764$var$_propTypes2.default.func,
        onSelectAll: $9919775ac7af4764$var$_propTypes2.default.func,
        style: $9919775ac7af4764$var$_propTypes2.default.oneOfType([
            $9919775ac7af4764$var$_propTypes2.default.object,
            $9919775ac7af4764$var$_propTypes2.default.func
        ]),
        classes: $9919775ac7af4764$var$_propTypes2.default.oneOfType([
            $9919775ac7af4764$var$_propTypes2.default.string,
            $9919775ac7af4764$var$_propTypes2.default.func
        ]),
        nonSelectable: $9919775ac7af4764$var$_propTypes2.default.array,
        nonSelectableStyle: $9919775ac7af4764$var$_propTypes2.default.oneOfType([
            $9919775ac7af4764$var$_propTypes2.default.string,
            $9919775ac7af4764$var$_propTypes2.default.func
        ]),
        nonSelectableClasses: $9919775ac7af4764$var$_propTypes2.default.oneOfType([
            $9919775ac7af4764$var$_propTypes2.default.string,
            $9919775ac7af4764$var$_propTypes2.default.func
        ]),
        bgColor: $9919775ac7af4764$var$_propTypes2.default.oneOfType([
            $9919775ac7af4764$var$_propTypes2.default.string,
            $9919775ac7af4764$var$_propTypes2.default.func
        ]),
        hideSelectColumn: $9919775ac7af4764$var$_propTypes2.default.bool,
        selectionRenderer: $9919775ac7af4764$var$_propTypes2.default.func,
        selectionHeaderRenderer: $9919775ac7af4764$var$_propTypes2.default.func,
        headerColumnStyle: $9919775ac7af4764$var$_propTypes2.default.oneOfType([
            $9919775ac7af4764$var$_propTypes2.default.object,
            $9919775ac7af4764$var$_propTypes2.default.func
        ]),
        selectColumnStyle: $9919775ac7af4764$var$_propTypes2.default.oneOfType([
            $9919775ac7af4764$var$_propTypes2.default.object,
            $9919775ac7af4764$var$_propTypes2.default.func
        ]),
        selectColumnPosition: $9919775ac7af4764$var$_propTypes2.default.oneOf([
            $9919775ac7af4764$var$_const2.default.INDICATOR_POSITION_LEFT,
            $9919775ac7af4764$var$_const2.default.INDICATOR_POSITION_RIGHT
        ])
    }),
    expandRow: $9919775ac7af4764$var$_propTypes2.default.shape({
        renderer: $9919775ac7af4764$var$_propTypes2.default.func,
        expanded: $9919775ac7af4764$var$_propTypes2.default.array,
        onExpand: $9919775ac7af4764$var$_propTypes2.default.func,
        onExpandAll: $9919775ac7af4764$var$_propTypes2.default.func,
        nonExpandable: $9919775ac7af4764$var$_propTypes2.default.array,
        showExpandColumn: $9919775ac7af4764$var$_propTypes2.default.bool,
        onlyOneExpanding: $9919775ac7af4764$var$_propTypes2.default.bool,
        expandByColumnOnly: $9919775ac7af4764$var$_propTypes2.default.bool,
        expandColumnRenderer: $9919775ac7af4764$var$_propTypes2.default.func,
        expandHeaderColumnRenderer: $9919775ac7af4764$var$_propTypes2.default.func,
        expandColumnPosition: $9919775ac7af4764$var$_propTypes2.default.oneOf([
            $9919775ac7af4764$var$_const2.default.INDICATOR_POSITION_LEFT,
            $9919775ac7af4764$var$_const2.default.INDICATOR_POSITION_RIGHT
        ]),
        className: $9919775ac7af4764$var$_propTypes2.default.oneOfType([
            $9919775ac7af4764$var$_propTypes2.default.string,
            $9919775ac7af4764$var$_propTypes2.default.func
        ]),
        parentClassName: $9919775ac7af4764$var$_propTypes2.default.oneOfType([
            $9919775ac7af4764$var$_propTypes2.default.string,
            $9919775ac7af4764$var$_propTypes2.default.func
        ])
    }),
    rowStyle: $9919775ac7af4764$var$_propTypes2.default.oneOfType([
        $9919775ac7af4764$var$_propTypes2.default.object,
        $9919775ac7af4764$var$_propTypes2.default.func
    ]),
    rowEvents: $9919775ac7af4764$var$_propTypes2.default.object,
    rowClasses: $9919775ac7af4764$var$_propTypes2.default.oneOfType([
        $9919775ac7af4764$var$_propTypes2.default.string,
        $9919775ac7af4764$var$_propTypes2.default.func
    ]),
    filtersClasses: $9919775ac7af4764$var$_propTypes2.default.string,
    filterPosition: $9919775ac7af4764$var$_propTypes2.default.oneOf([
        $9919775ac7af4764$var$_const2.default.FILTERS_POSITION_TOP,
        $9919775ac7af4764$var$_const2.default.FILTERS_POSITION_INLINE,
        $9919775ac7af4764$var$_const2.default.FILTERS_POSITION_BOTTOM
    ]),
    footerClasses: $9919775ac7af4764$var$_propTypes2.default.string,
    defaultSorted: $9919775ac7af4764$var$_propTypes2.default.arrayOf($9919775ac7af4764$var$_propTypes2.default.shape({
        dataField: $9919775ac7af4764$var$_propTypes2.default.string.isRequired,
        order: $9919775ac7af4764$var$_propTypes2.default.oneOf([
            $9919775ac7af4764$var$_const2.default.SORT_DESC,
            $9919775ac7af4764$var$_const2.default.SORT_ASC
        ]).isRequired
    })),
    sort: $9919775ac7af4764$var$_propTypes2.default.shape({
        dataField: $9919775ac7af4764$var$_propTypes2.default.string,
        order: $9919775ac7af4764$var$_propTypes2.default.oneOf([
            $9919775ac7af4764$var$_const2.default.SORT_DESC,
            $9919775ac7af4764$var$_const2.default.SORT_ASC
        ]),
        sortFunc: $9919775ac7af4764$var$_propTypes2.default.func,
        sortCaret: $9919775ac7af4764$var$_propTypes2.default.func
    }),
    defaultSortDirection: $9919775ac7af4764$var$_propTypes2.default.oneOf([
        $9919775ac7af4764$var$_const2.default.SORT_DESC,
        $9919775ac7af4764$var$_const2.default.SORT_ASC
    ]),
    overlay: $9919775ac7af4764$var$_propTypes2.default.func,
    onTableChange: $9919775ac7af4764$var$_propTypes2.default.func,
    onSort: $9919775ac7af4764$var$_propTypes2.default.func,
    onFilter: $9919775ac7af4764$var$_propTypes2.default.func,
    onExternalFilter: $9919775ac7af4764$var$_propTypes2.default.func,
    onDataSizeChange: $9919775ac7af4764$var$_propTypes2.default.func,
    // Inject from toolkit
    search: $9919775ac7af4764$var$_propTypes2.default.shape({
        searchText: $9919775ac7af4764$var$_propTypes2.default.string,
        searchContext: $9919775ac7af4764$var$_propTypes2.default.func
    }),
    setDependencyModules: $9919775ac7af4764$var$_propTypes2.default.func
};
$9919775ac7af4764$var$BootstrapTable.defaultProps = {
    bootstrap4: false,
    remote: false,
    striped: false,
    bordered: true,
    hover: false,
    condensed: false,
    noDataIndication: null,
    selectRow: {
        mode: $9919775ac7af4764$var$_const2.default.ROW_SELECT_DISABLED,
        selected: [],
        hideSelectColumn: true
    },
    expandRow: {
        renderer: undefined,
        expanded: [],
        nonExpandable: []
    },
    cellEdit: {
        mode: null,
        nonEditableRows: []
    },
    filterPosition: $9919775ac7af4764$var$_const2.default.FILTERS_POSITION_INLINE
};
module.exports.default = $9919775ac7af4764$var$BootstrapTable;

});
parcelRegister("70H8J", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $acw62 = parcelRequire("acw62");
var $51a9ff2fe68abfc3$var$_react2 = $51a9ff2fe68abfc3$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");
var $51a9ff2fe68abfc3$var$_propTypes2 = $51a9ff2fe68abfc3$var$_interopRequireDefault($c9Z8w);

var $dE3DQ = parcelRequire("dE3DQ");
var $51a9ff2fe68abfc3$var$_headerCell2 = $51a9ff2fe68abfc3$var$_interopRequireDefault($dE3DQ);

var $eESlq = parcelRequire("eESlq");
var $51a9ff2fe68abfc3$var$_selectionHeaderCell2 = $51a9ff2fe68abfc3$var$_interopRequireDefault($eESlq);

var $hx0Wj = parcelRequire("hx0Wj");
var $51a9ff2fe68abfc3$var$_expandHeaderCell2 = $51a9ff2fe68abfc3$var$_interopRequireDefault($hx0Wj);

var $aB2AL = parcelRequire("aB2AL");
var $51a9ff2fe68abfc3$var$_selectionHeaderCellConsumer2 = $51a9ff2fe68abfc3$var$_interopRequireDefault($aB2AL);

var $etBWR = parcelRequire("etBWR");
var $51a9ff2fe68abfc3$var$_expandHeaderCellConsumer2 = $51a9ff2fe68abfc3$var$_interopRequireDefault($etBWR);

var $jVgbO = parcelRequire("jVgbO");
var $51a9ff2fe68abfc3$var$_const2 = $51a9ff2fe68abfc3$var$_interopRequireDefault($jVgbO);
function $51a9ff2fe68abfc3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/* eslint react/require-default-props: 0 */ var $51a9ff2fe68abfc3$var$Header = function Header(props) {
    var className = props.className, columns = props.columns, onSort = props.onSort, onFilter = props.onFilter, sortField = props.sortField, sortOrder = props.sortOrder, selectRow = props.selectRow, expandRow = props.expandRow, currFilters = props.currFilters, onExternalFilter = props.onExternalFilter, filterPosition = props.filterPosition, globalSortCaret = props.globalSortCaret, wrapperClasses = props.wrapperClasses;
    var SelectionHeaderCellComp = function SelectionHeaderCellComp() {
        return null;
    };
    var ExpansionHeaderCellComp = function ExpansionHeaderCellComp() {
        return null;
    };
    if (expandRow.showExpandColumn) ExpansionHeaderCellComp = (0, $51a9ff2fe68abfc3$var$_expandHeaderCellConsumer2.default)($51a9ff2fe68abfc3$var$_expandHeaderCell2.default);
    if (selectRow) SelectionHeaderCellComp = (0, $51a9ff2fe68abfc3$var$_selectionHeaderCellConsumer2.default)($51a9ff2fe68abfc3$var$_selectionHeaderCell2.default);
    var isRenderFunctionColumnInLeft = function isRenderFunctionColumnInLeft() {
        var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $51a9ff2fe68abfc3$var$_const2.default.INDICATOR_POSITION_LEFT;
        return position === $51a9ff2fe68abfc3$var$_const2.default.INDICATOR_POSITION_LEFT;
    };
    var childrens = [
        columns.map(function(column, i) {
            var currSort = column.dataField === sortField;
            var isLastSorting = column.dataField === sortField;
            return $51a9ff2fe68abfc3$var$_react2.default.createElement($51a9ff2fe68abfc3$var$_headerCell2.default, {
                index: i,
                key: column.dataField,
                column: column,
                onSort: onSort,
                sorting: currSort,
                sortOrder: sortOrder,
                globalSortCaret: globalSortCaret,
                isLastSorting: isLastSorting,
                onFilter: onFilter,
                currFilters: currFilters,
                onExternalFilter: onExternalFilter,
                filterPosition: filterPosition
            });
        })
    ];
    if (!selectRow.hideSelectColumn) {
        if (isRenderFunctionColumnInLeft(selectRow.selectColumnPosition)) childrens.unshift($51a9ff2fe68abfc3$var$_react2.default.createElement(SelectionHeaderCellComp, {
            key: "selection"
        }));
        else childrens.push($51a9ff2fe68abfc3$var$_react2.default.createElement(SelectionHeaderCellComp, {
            key: "selection"
        }));
    }
    if (expandRow.showExpandColumn) {
        if (isRenderFunctionColumnInLeft(expandRow.expandColumnPosition)) childrens.unshift($51a9ff2fe68abfc3$var$_react2.default.createElement(ExpansionHeaderCellComp, {
            key: "expansion"
        }));
        else childrens.push($51a9ff2fe68abfc3$var$_react2.default.createElement(ExpansionHeaderCellComp, {
            key: "expansion"
        }));
    }
    return $51a9ff2fe68abfc3$var$_react2.default.createElement("thead", {
        className: wrapperClasses
    }, $51a9ff2fe68abfc3$var$_react2.default.createElement("tr", {
        className: className
    }, childrens));
};
$51a9ff2fe68abfc3$var$Header.propTypes = {
    columns: $51a9ff2fe68abfc3$var$_propTypes2.default.array.isRequired,
    onSort: $51a9ff2fe68abfc3$var$_propTypes2.default.func,
    onFilter: $51a9ff2fe68abfc3$var$_propTypes2.default.func,
    sortField: $51a9ff2fe68abfc3$var$_propTypes2.default.string,
    sortOrder: $51a9ff2fe68abfc3$var$_propTypes2.default.string,
    selectRow: $51a9ff2fe68abfc3$var$_propTypes2.default.object,
    currFilters: $51a9ff2fe68abfc3$var$_propTypes2.default.object,
    onExternalFilter: $51a9ff2fe68abfc3$var$_propTypes2.default.func,
    globalSortCaret: $51a9ff2fe68abfc3$var$_propTypes2.default.func,
    className: $51a9ff2fe68abfc3$var$_propTypes2.default.string,
    wrapperClasses: $51a9ff2fe68abfc3$var$_propTypes2.default.string,
    expandRow: $51a9ff2fe68abfc3$var$_propTypes2.default.object,
    filterPosition: $51a9ff2fe68abfc3$var$_propTypes2.default.oneOf([
        $51a9ff2fe68abfc3$var$_const2.default.FILTERS_POSITION_TOP,
        $51a9ff2fe68abfc3$var$_const2.default.FILTERS_POSITION_INLINE,
        $51a9ff2fe68abfc3$var$_const2.default.FILTERS_POSITION_BOTTOM
    ])
};
module.exports.default = $51a9ff2fe68abfc3$var$Header;

});
parcelRegister("dE3DQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $9ef1d5f2619ca3c5$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $9ef1d5f2619ca3c5$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $9ef1d5f2619ca3c5$var$_react2 = $9ef1d5f2619ca3c5$var$_interopRequireDefault($acw62);

var $8g1PZ = parcelRequire("8g1PZ");
var $9ef1d5f2619ca3c5$var$_classnames2 = $9ef1d5f2619ca3c5$var$_interopRequireDefault($8g1PZ);

var $c9Z8w = parcelRequire("c9Z8w");
var $9ef1d5f2619ca3c5$var$_propTypes2 = $9ef1d5f2619ca3c5$var$_interopRequireDefault($c9Z8w);

var $jVgbO = parcelRequire("jVgbO");
var $9ef1d5f2619ca3c5$var$_const2 = $9ef1d5f2619ca3c5$var$_interopRequireDefault($jVgbO);

var $dUy2E = parcelRequire("dUy2E");
var $9ef1d5f2619ca3c5$var$_symbol2 = $9ef1d5f2619ca3c5$var$_interopRequireDefault($dUy2E);

var $3RhzV = parcelRequire("3RhzV");
var $9ef1d5f2619ca3c5$var$_caret2 = $9ef1d5f2619ca3c5$var$_interopRequireDefault($3RhzV);

var $dQ68B = parcelRequire("dQ68B");
var $9ef1d5f2619ca3c5$var$_utils2 = $9ef1d5f2619ca3c5$var$_interopRequireDefault($dQ68B);

var $5a2kX = parcelRequire("5a2kX");
var $9ef1d5f2619ca3c5$var$_cellEventDelegater2 = $9ef1d5f2619ca3c5$var$_interopRequireDefault($5a2kX);
function $9ef1d5f2619ca3c5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9ef1d5f2619ca3c5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9ef1d5f2619ca3c5$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $9ef1d5f2619ca3c5$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint react/require-default-props: 0 */ 
var $9ef1d5f2619ca3c5$var$HeaderCell = function(_eventDelegater) {
    $9ef1d5f2619ca3c5$var$_inherits(HeaderCell, _eventDelegater);
    function HeaderCell() {
        $9ef1d5f2619ca3c5$var$_classCallCheck(this, HeaderCell);
        return $9ef1d5f2619ca3c5$var$_possibleConstructorReturn(this, (HeaderCell.__proto__ || Object.getPrototypeOf(HeaderCell)).apply(this, arguments));
    }
    $9ef1d5f2619ca3c5$var$_createClass(HeaderCell, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, column = _props.column, index = _props.index, onSort = _props.onSort, sorting = _props.sorting, sortOrder = _props.sortOrder, isLastSorting = _props.isLastSorting, onFilter = _props.onFilter, currFilters = _props.currFilters, filterPosition = _props.filterPosition, onExternalFilter = _props.onExternalFilter, globalSortCaret = _props.globalSortCaret;
                var text = column.text, sort = column.sort, sortCaret = column.sortCaret, filter = column.filter, filterRenderer = column.filterRenderer, headerTitle = column.headerTitle, headerAlign = column.headerAlign, headerFormatter = column.headerFormatter, headerEvents = column.headerEvents, headerClasses = column.headerClasses, headerStyle = column.headerStyle, headerAttrs = column.headerAttrs, headerSortingClasses = column.headerSortingClasses, headerSortingStyle = column.headerSortingStyle;
                var sortCaretfunc = sortCaret || globalSortCaret;
                var delegateEvents = this.delegate(headerEvents);
                var customAttrs = $9ef1d5f2619ca3c5$var$_utils2.default.isFunction(headerAttrs) ? headerAttrs(column, index) : headerAttrs || {};
                var cellAttrs = $9ef1d5f2619ca3c5$var$_extends({}, customAttrs, delegateEvents, {
                    tabIndex: $9ef1d5f2619ca3c5$var$_utils2.default.isDefined(customAttrs.tabIndex) ? customAttrs.tabIndex : 0
                });
                var sortSymbol = void 0;
                var filterElm = void 0;
                var cellStyle = {};
                var cellClasses = $9ef1d5f2619ca3c5$var$_utils2.default.isFunction(headerClasses) ? headerClasses(column, index) : headerClasses;
                if (headerStyle) {
                    cellStyle = $9ef1d5f2619ca3c5$var$_utils2.default.isFunction(headerStyle) ? headerStyle(column, index) : headerStyle;
                    cellStyle = cellStyle ? $9ef1d5f2619ca3c5$var$_extends({}, cellStyle) : cellStyle;
                }
                if (headerTitle) cellAttrs.title = $9ef1d5f2619ca3c5$var$_utils2.default.isFunction(headerTitle) ? headerTitle(column, index) : text;
                if (headerAlign) cellStyle.textAlign = $9ef1d5f2619ca3c5$var$_utils2.default.isFunction(headerAlign) ? headerAlign(column, index) : headerAlign;
                if (sort) {
                    var customClick = cellAttrs.onClick;
                    cellAttrs["aria-label"] = sorting ? text + " sort " + sortOrder : text + " sortable";
                    cellAttrs.onKeyUp = function(e) {
                        if (e.key === "Enter") {
                            onSort(column);
                            if ($9ef1d5f2619ca3c5$var$_utils2.default.isFunction(customClick)) customClick(e);
                        }
                    };
                    cellAttrs.onClick = function(e) {
                        onSort(column);
                        if ($9ef1d5f2619ca3c5$var$_utils2.default.isFunction(customClick)) customClick(e);
                    };
                    cellAttrs.className = (0, $9ef1d5f2619ca3c5$var$_classnames2.default)(cellAttrs.className, "sortable");
                    if (sorting) {
                        sortSymbol = sortCaretfunc ? sortCaretfunc(sortOrder, column) : $9ef1d5f2619ca3c5$var$_react2.default.createElement($9ef1d5f2619ca3c5$var$_caret2.default, {
                            order: sortOrder
                        });
                        // append customized classes or style if table was sorting based on the current column.
                        cellClasses = (0, $9ef1d5f2619ca3c5$var$_classnames2.default)(cellClasses, $9ef1d5f2619ca3c5$var$_utils2.default.isFunction(headerSortingClasses) ? headerSortingClasses(column, sortOrder, isLastSorting, index) : headerSortingClasses);
                        cellStyle = $9ef1d5f2619ca3c5$var$_extends({}, cellStyle, $9ef1d5f2619ca3c5$var$_utils2.default.isFunction(headerSortingStyle) ? headerSortingStyle(column, sortOrder, isLastSorting, index) : headerSortingStyle);
                    } else sortSymbol = sortCaretfunc ? sortCaretfunc(undefined, column) : $9ef1d5f2619ca3c5$var$_react2.default.createElement($9ef1d5f2619ca3c5$var$_symbol2.default, null);
                }
                if (cellClasses) cellAttrs.className = (0, $9ef1d5f2619ca3c5$var$_classnames2.default)(cellAttrs.className, cellClasses);
                if (!$9ef1d5f2619ca3c5$var$_utils2.default.isEmptyObject(cellStyle)) cellAttrs.style = cellStyle;
                if (filterPosition === $9ef1d5f2619ca3c5$var$_const2.default.FILTERS_POSITION_INLINE) {
                    if (filterRenderer) {
                        var onCustomFilter = onExternalFilter(column, filter.props.type);
                        filterElm = filterRenderer(onCustomFilter, column);
                    } else if (filter) filterElm = $9ef1d5f2619ca3c5$var$_react2.default.createElement(filter.Filter, $9ef1d5f2619ca3c5$var$_extends({}, filter.props, {
                        filterState: currFilters[column.dataField],
                        onFilter: onFilter,
                        column: column
                    }));
                }
                var children = headerFormatter ? headerFormatter(column, index, {
                    sortElement: sortSymbol,
                    filterElement: filterElm
                }) : text;
                if (headerFormatter) return $9ef1d5f2619ca3c5$var$_react2.default.createElement("th", cellAttrs, children);
                return $9ef1d5f2619ca3c5$var$_react2.default.createElement("th", cellAttrs, children, sortSymbol, filterElm);
            }
        }
    ]);
    return HeaderCell;
}((0, $9ef1d5f2619ca3c5$var$_cellEventDelegater2.default)($9ef1d5f2619ca3c5$var$_react2.default.Component));
$9ef1d5f2619ca3c5$var$HeaderCell.propTypes = {
    column: $9ef1d5f2619ca3c5$var$_propTypes2.default.shape({
        dataField: $9ef1d5f2619ca3c5$var$_propTypes2.default.string.isRequired,
        text: $9ef1d5f2619ca3c5$var$_propTypes2.default.string.isRequired,
        type: $9ef1d5f2619ca3c5$var$_propTypes2.default.oneOf([
            $9ef1d5f2619ca3c5$var$_const2.default.TYPE_STRING,
            $9ef1d5f2619ca3c5$var$_const2.default.TYPE_NUMBER,
            $9ef1d5f2619ca3c5$var$_const2.default.TYPE_BOOLEAN,
            $9ef1d5f2619ca3c5$var$_const2.default.TYPE_DATE
        ]),
        isDummyField: $9ef1d5f2619ca3c5$var$_propTypes2.default.bool,
        hidden: $9ef1d5f2619ca3c5$var$_propTypes2.default.bool,
        headerFormatter: $9ef1d5f2619ca3c5$var$_propTypes2.default.func,
        formatter: $9ef1d5f2619ca3c5$var$_propTypes2.default.func,
        formatExtraData: $9ef1d5f2619ca3c5$var$_propTypes2.default.any,
        headerClasses: $9ef1d5f2619ca3c5$var$_propTypes2.default.oneOfType([
            $9ef1d5f2619ca3c5$var$_propTypes2.default.string,
            $9ef1d5f2619ca3c5$var$_propTypes2.default.func
        ]),
        classes: $9ef1d5f2619ca3c5$var$_propTypes2.default.oneOfType([
            $9ef1d5f2619ca3c5$var$_propTypes2.default.string,
            $9ef1d5f2619ca3c5$var$_propTypes2.default.func
        ]),
        headerStyle: $9ef1d5f2619ca3c5$var$_propTypes2.default.oneOfType([
            $9ef1d5f2619ca3c5$var$_propTypes2.default.object,
            $9ef1d5f2619ca3c5$var$_propTypes2.default.func
        ]),
        style: $9ef1d5f2619ca3c5$var$_propTypes2.default.oneOfType([
            $9ef1d5f2619ca3c5$var$_propTypes2.default.object,
            $9ef1d5f2619ca3c5$var$_propTypes2.default.func
        ]),
        headerTitle: $9ef1d5f2619ca3c5$var$_propTypes2.default.oneOfType([
            $9ef1d5f2619ca3c5$var$_propTypes2.default.bool,
            $9ef1d5f2619ca3c5$var$_propTypes2.default.func
        ]),
        title: $9ef1d5f2619ca3c5$var$_propTypes2.default.oneOfType([
            $9ef1d5f2619ca3c5$var$_propTypes2.default.bool,
            $9ef1d5f2619ca3c5$var$_propTypes2.default.func
        ]),
        headerEvents: $9ef1d5f2619ca3c5$var$_propTypes2.default.object,
        events: $9ef1d5f2619ca3c5$var$_propTypes2.default.object,
        headerAlign: $9ef1d5f2619ca3c5$var$_propTypes2.default.oneOfType([
            $9ef1d5f2619ca3c5$var$_propTypes2.default.string,
            $9ef1d5f2619ca3c5$var$_propTypes2.default.func
        ]),
        align: $9ef1d5f2619ca3c5$var$_propTypes2.default.oneOfType([
            $9ef1d5f2619ca3c5$var$_propTypes2.default.string,
            $9ef1d5f2619ca3c5$var$_propTypes2.default.func
        ]),
        headerAttrs: $9ef1d5f2619ca3c5$var$_propTypes2.default.oneOfType([
            $9ef1d5f2619ca3c5$var$_propTypes2.default.object,
            $9ef1d5f2619ca3c5$var$_propTypes2.default.func
        ]),
        attrs: $9ef1d5f2619ca3c5$var$_propTypes2.default.oneOfType([
            $9ef1d5f2619ca3c5$var$_propTypes2.default.object,
            $9ef1d5f2619ca3c5$var$_propTypes2.default.func
        ]),
        sort: $9ef1d5f2619ca3c5$var$_propTypes2.default.bool,
        sortFunc: $9ef1d5f2619ca3c5$var$_propTypes2.default.func,
        onSort: $9ef1d5f2619ca3c5$var$_propTypes2.default.func,
        editor: $9ef1d5f2619ca3c5$var$_propTypes2.default.object,
        editable: $9ef1d5f2619ca3c5$var$_propTypes2.default.oneOfType([
            $9ef1d5f2619ca3c5$var$_propTypes2.default.bool,
            $9ef1d5f2619ca3c5$var$_propTypes2.default.func
        ]),
        editCellStyle: $9ef1d5f2619ca3c5$var$_propTypes2.default.oneOfType([
            $9ef1d5f2619ca3c5$var$_propTypes2.default.object,
            $9ef1d5f2619ca3c5$var$_propTypes2.default.func
        ]),
        editCellClasses: $9ef1d5f2619ca3c5$var$_propTypes2.default.oneOfType([
            $9ef1d5f2619ca3c5$var$_propTypes2.default.string,
            $9ef1d5f2619ca3c5$var$_propTypes2.default.func
        ]),
        editorStyle: $9ef1d5f2619ca3c5$var$_propTypes2.default.oneOfType([
            $9ef1d5f2619ca3c5$var$_propTypes2.default.object,
            $9ef1d5f2619ca3c5$var$_propTypes2.default.func
        ]),
        editorClasses: $9ef1d5f2619ca3c5$var$_propTypes2.default.oneOfType([
            $9ef1d5f2619ca3c5$var$_propTypes2.default.string,
            $9ef1d5f2619ca3c5$var$_propTypes2.default.func
        ]),
        editorRenderer: $9ef1d5f2619ca3c5$var$_propTypes2.default.func,
        validator: $9ef1d5f2619ca3c5$var$_propTypes2.default.func,
        filter: $9ef1d5f2619ca3c5$var$_propTypes2.default.object,
        filterRenderer: $9ef1d5f2619ca3c5$var$_propTypes2.default.func,
        filterValue: $9ef1d5f2619ca3c5$var$_propTypes2.default.func,
        searchable: $9ef1d5f2619ca3c5$var$_propTypes2.default.bool
    }).isRequired,
    index: $9ef1d5f2619ca3c5$var$_propTypes2.default.number.isRequired,
    onSort: $9ef1d5f2619ca3c5$var$_propTypes2.default.func,
    sorting: $9ef1d5f2619ca3c5$var$_propTypes2.default.bool,
    sortOrder: $9ef1d5f2619ca3c5$var$_propTypes2.default.oneOf([
        $9ef1d5f2619ca3c5$var$_const2.default.SORT_ASC,
        $9ef1d5f2619ca3c5$var$_const2.default.SORT_DESC
    ]),
    sortCaret: $9ef1d5f2619ca3c5$var$_propTypes2.default.func,
    isLastSorting: $9ef1d5f2619ca3c5$var$_propTypes2.default.bool,
    onFilter: $9ef1d5f2619ca3c5$var$_propTypes2.default.func,
    filterPosition: $9ef1d5f2619ca3c5$var$_propTypes2.default.oneOf([
        $9ef1d5f2619ca3c5$var$_const2.default.FILTERS_POSITION_INLINE,
        $9ef1d5f2619ca3c5$var$_const2.default.FILTERS_POSITION_BOTTOM,
        $9ef1d5f2619ca3c5$var$_const2.default.FILTERS_POSITION_TOP
    ]),
    currFilters: $9ef1d5f2619ca3c5$var$_propTypes2.default.object,
    onExternalFilter: $9ef1d5f2619ca3c5$var$_propTypes2.default.func
};
module.exports.default = $9ef1d5f2619ca3c5$var$HeaderCell;

});
parcelRegister("jVgbO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = {
    SORT_ASC: "asc",
    SORT_DESC: "desc",
    ROW_SELECT_SINGLE: "radio",
    ROW_SELECT_MULTIPLE: "checkbox",
    ROW_SELECT_DISABLED: "ROW_SELECT_DISABLED",
    CHECKBOX_STATUS_CHECKED: "checked",
    CHECKBOX_STATUS_INDETERMINATE: "indeterminate",
    CHECKBOX_STATUS_UNCHECKED: "unchecked",
    INDICATOR_POSITION_LEFT: "left",
    INDICATOR_POSITION_RIGHT: "right",
    TYPE_STRING: "string",
    TYPE_NUMBER: "number",
    TYPE_BOOLEAN: "bool",
    TYPE_DATE: "date",
    FILTERS_POSITION_INLINE: "inline",
    FILTERS_POSITION_TOP: "top",
    FILTERS_POSITION_BOTTOM: "bottom"
};

});

parcelRegister("dUy2E", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $acw62 = parcelRequire("acw62");
var $a20ae951634be270$var$_react2 = $a20ae951634be270$var$_interopRequireDefault($acw62);

var $il2Gx = parcelRequire("il2Gx");
function $a20ae951634be270$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $a20ae951634be270$var$SortSymbol = function SortSymbol() {
    return $a20ae951634be270$var$_react2.default.createElement($il2Gx.BootstrapContext.Consumer, null, function(_ref) {
        var bootstrap4 = _ref.bootstrap4;
        return bootstrap4 ? $a20ae951634be270$var$_react2.default.createElement("span", {
            className: "order-4"
        }) : $a20ae951634be270$var$_react2.default.createElement("span", {
            className: "order"
        }, $a20ae951634be270$var$_react2.default.createElement("span", {
            className: "dropdown"
        }, $a20ae951634be270$var$_react2.default.createElement("span", {
            className: "caret"
        })), $a20ae951634be270$var$_react2.default.createElement("span", {
            className: "dropup"
        }, $a20ae951634be270$var$_react2.default.createElement("span", {
            className: "caret"
        })));
    });
};
module.exports.default = $a20ae951634be270$var$SortSymbol;

});
parcelRegister("il2Gx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BootstrapContext = undefined;

var $acw62 = parcelRequire("acw62");
var $d59c455bac8f0840$var$_react2 = $d59c455bac8f0840$var$_interopRequireDefault($acw62);
function $d59c455bac8f0840$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $d59c455bac8f0840$var$BootstrapContext = module.exports.BootstrapContext = $d59c455bac8f0840$var$_react2.default.createContext({
    bootstrap4: false
});

});


parcelRegister("3RhzV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $acw62 = parcelRequire("acw62");
var $2cf3f50fa4712f09$var$_react2 = $2cf3f50fa4712f09$var$_interopRequireDefault($acw62);

var $8g1PZ = parcelRequire("8g1PZ");
var $2cf3f50fa4712f09$var$_classnames2 = $2cf3f50fa4712f09$var$_interopRequireDefault($8g1PZ);

var $c9Z8w = parcelRequire("c9Z8w");
var $2cf3f50fa4712f09$var$_propTypes2 = $2cf3f50fa4712f09$var$_interopRequireDefault($c9Z8w);

var $jVgbO = parcelRequire("jVgbO");
var $2cf3f50fa4712f09$var$_const2 = $2cf3f50fa4712f09$var$_interopRequireDefault($jVgbO);

var $il2Gx = parcelRequire("il2Gx");
function $2cf3f50fa4712f09$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $2cf3f50fa4712f09$var$SortCaret = function SortCaret(_ref) {
    var order = _ref.order;
    var orderClass = (0, $2cf3f50fa4712f09$var$_classnames2.default)("react-bootstrap-table-sort-order", {
        dropup: order === $2cf3f50fa4712f09$var$_const2.default.SORT_ASC
    });
    return $2cf3f50fa4712f09$var$_react2.default.createElement($il2Gx.BootstrapContext.Consumer, null, function(_ref2) {
        var bootstrap4 = _ref2.bootstrap4;
        return bootstrap4 ? $2cf3f50fa4712f09$var$_react2.default.createElement("span", {
            className: "caret-4-" + order
        }) : $2cf3f50fa4712f09$var$_react2.default.createElement("span", {
            className: orderClass
        }, $2cf3f50fa4712f09$var$_react2.default.createElement("span", {
            className: "caret"
        }));
    });
};
$2cf3f50fa4712f09$var$SortCaret.propTypes = {
    order: $2cf3f50fa4712f09$var$_propTypes2.default.oneOf([
        $2cf3f50fa4712f09$var$_const2.default.SORT_ASC,
        $2cf3f50fa4712f09$var$_const2.default.SORT_DESC
    ]).isRequired
};
module.exports.default = $2cf3f50fa4712f09$var$SortCaret;

});

parcelRegister("dQ68B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jm3cT = parcelRequire("jm3cT");
var $a134e47fdd42815b$var$_underscore2 = $a134e47fdd42815b$var$_interopRequireDefault($jm3cT);
function $a134e47fdd42815b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a134e47fdd42815b$var$splitNested(str) {
    return [
        str
    ].join(".").replace(/\[/g, ".").replace(/\]/g, "").split(".");
} /* eslint no-empty: 0 */ 
/* eslint no-param-reassign: 0 */ /* eslint prefer-rest-params: 0 */ function $a134e47fdd42815b$var$contains(list, value) {
    if ($a134e47fdd42815b$var$_underscore2.default.includes) return $a134e47fdd42815b$var$_underscore2.default.includes(list, value);
    return list.indexOf(value) > -1;
}
function $a134e47fdd42815b$var$get(target, field) {
    var directGet = target[field];
    if (directGet !== undefined && directGet !== null) return directGet;
    var pathArray = $a134e47fdd42815b$var$splitNested(field);
    var result = void 0;
    try {
        result = pathArray.reduce(function(curr, path) {
            return curr[path];
        }, target);
    } catch (e) {}
    return result;
}
function $a134e47fdd42815b$var$set(target, field, value) {
    var safe = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var pathArray = $a134e47fdd42815b$var$splitNested(field);
    var level = 0;
    pathArray.reduce(function(a, b) {
        level += 1;
        if (typeof a[b] === "undefined") {
            if (!safe) throw new Error(a + "." + b + " is undefined");
            a[b] = {};
            return a[b];
        }
        if (level === pathArray.length) {
            a[b] = value;
            return value;
        }
        return a[b];
    }, target);
}
function $a134e47fdd42815b$var$isEmptyObject(obj) {
    if (!$a134e47fdd42815b$var$_underscore2.default.isObject(obj)) return false;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var keys = Object.keys(obj);
    for(var i = 0; i < keys.length; i += 1){
        if (hasOwnProperty.call(obj, keys[i])) return false;
    }
    return true;
}
function $a134e47fdd42815b$var$isDefined(value) {
    return typeof value !== "undefined" && value !== null;
}
function $a134e47fdd42815b$var$sleep(fn, ms) {
    return setTimeout(function() {
        return fn();
    }, ms);
}
function $a134e47fdd42815b$var$debounce(func, wait, immediate) {
    var _this = this, _arguments = arguments;
    var timeout = void 0;
    return function() {
        var later = function later() {
            timeout = null;
            if (!immediate) func.apply(_this, _arguments);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait || 0);
        if (callNow) func.apply(_this, _arguments);
    };
}
module.exports.default = Object.assign($a134e47fdd42815b$var$_underscore2.default, {
    get: $a134e47fdd42815b$var$get,
    set: $a134e47fdd42815b$var$set,
    isDefined: $a134e47fdd42815b$var$isDefined,
    isEmptyObject: $a134e47fdd42815b$var$isEmptyObject,
    sleep: $a134e47fdd42815b$var$sleep,
    debounce: $a134e47fdd42815b$var$debounce,
    contains: $a134e47fdd42815b$var$contains
});

});
parcelRegister("jm3cT", function(module, exports) {
//     Underscore.js 1.9.1
//     http://underscorejs.org
//     (c) 2009-2018 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.
(function() {
    // Baseline setup
    // --------------
    // Establish the root object, `window` (`self`) in the browser, `global`
    // on the server, or `this` in some virtual machines. We use `self`
    // instead of `window` for `WebWorker` support.
    var root = typeof self == "object" && self.self === self && self || typeof $parcel$global == "object" && $parcel$global.global === $parcel$global && $parcel$global || this || {};
    // Save the previous value of the `_` variable.
    var previousUnderscore = root._;
    // Save bytes in the minified (but not gzipped) version:
    var ArrayProto = Array.prototype, ObjProto = Object.prototype;
    var SymbolProto = typeof Symbol !== "undefined" ? Symbol.prototype : null;
    // Create quick reference variables for speed access to core prototypes.
    var push = ArrayProto.push, slice = ArrayProto.slice, toString = ObjProto.toString, hasOwnProperty = ObjProto.hasOwnProperty;
    // All **ECMAScript 5** native function implementations that we hope to use
    // are declared here.
    var nativeIsArray = Array.isArray, nativeKeys = Object.keys, nativeCreate = Object.create;
    // Naked function reference for surrogate-prototype-swapping.
    var Ctor = function() {};
    // Create a safe reference to the Underscore object for use below.
    var _ = function(obj) {
        if (obj instanceof _) return obj;
        if (!(this instanceof _)) return new _(obj);
        this._wrapped = obj;
    };
    // Export the Underscore object for **Node.js**, with
    // backwards-compatibility for their old module API. If we're in
    // the browser, add `_` as a global object.
    // (`nodeType` is checked to ensure that `module`
    // and `exports` are not HTML elements.)
    if (!exports.nodeType) {
        if (!module.nodeType && module.exports) exports = module.exports = _;
        exports._ = _;
    } else root._ = _;
    // Current version.
    _.VERSION = "1.9.1";
    // Internal function that returns an efficient (for current engines) version
    // of the passed-in callback, to be repeatedly applied in other Underscore
    // functions.
    var optimizeCb = function(func, context, argCount) {
        if (context === void 0) return func;
        switch(argCount == null ? 3 : argCount){
            case 1:
                return function(value) {
                    return func.call(context, value);
                };
            // The 2-argument case is omitted because we’re not using it.
            case 3:
                return function(value, index, collection) {
                    return func.call(context, value, index, collection);
                };
            case 4:
                return function(accumulator, value, index, collection) {
                    return func.call(context, accumulator, value, index, collection);
                };
        }
        return function() {
            return func.apply(context, arguments);
        };
    };
    var builtinIteratee;
    // An internal function to generate callbacks that can be applied to each
    // element in a collection, returning the desired result — either `identity`,
    // an arbitrary callback, a property matcher, or a property accessor.
    var cb = function(value, context, argCount) {
        if (_.iteratee !== builtinIteratee) return _.iteratee(value, context);
        if (value == null) return _.identity;
        if (_.isFunction(value)) return optimizeCb(value, context, argCount);
        if (_.isObject(value) && !_.isArray(value)) return _.matcher(value);
        return _.property(value);
    };
    // External wrapper for our callback generator. Users may customize
    // `_.iteratee` if they want additional predicate/iteratee shorthand styles.
    // This abstraction hides the internal-only argCount argument.
    _.iteratee = builtinIteratee = function(value, context) {
        return cb(value, context, Infinity);
    };
    // Some functions take a variable number of arguments, or a few expected
    // arguments at the beginning and then a variable number of values to operate
    // on. This helper accumulates all remaining arguments past the function’s
    // argument length (or an explicit `startIndex`), into an array that becomes
    // the last argument. Similar to ES6’s "rest parameter".
    var restArguments = function(func, startIndex) {
        startIndex = startIndex == null ? func.length - 1 : +startIndex;
        return function() {
            var length = Math.max(arguments.length - startIndex, 0), rest = Array(length), index = 0;
            for(; index < length; index++)rest[index] = arguments[index + startIndex];
            switch(startIndex){
                case 0:
                    return func.call(this, rest);
                case 1:
                    return func.call(this, arguments[0], rest);
                case 2:
                    return func.call(this, arguments[0], arguments[1], rest);
            }
            var args = Array(startIndex + 1);
            for(index = 0; index < startIndex; index++)args[index] = arguments[index];
            args[startIndex] = rest;
            return func.apply(this, args);
        };
    };
    // An internal function for creating a new object that inherits from another.
    var baseCreate = function(prototype) {
        if (!_.isObject(prototype)) return {};
        if (nativeCreate) return nativeCreate(prototype);
        Ctor.prototype = prototype;
        var result = new Ctor;
        Ctor.prototype = null;
        return result;
    };
    var shallowProperty = function(key) {
        return function(obj) {
            return obj == null ? void 0 : obj[key];
        };
    };
    var has = function(obj, path) {
        return obj != null && hasOwnProperty.call(obj, path);
    };
    var deepGet = function(obj, path) {
        var length = path.length;
        for(var i = 0; i < length; i++){
            if (obj == null) return void 0;
            obj = obj[path[i]];
        }
        return length ? obj : void 0;
    };
    // Helper for collection methods to determine whether a collection
    // should be iterated as an array or as an object.
    // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
    // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
    var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
    var getLength = shallowProperty("length");
    var isArrayLike = function(collection) {
        var length = getLength(collection);
        return typeof length == "number" && length >= 0 && length <= MAX_ARRAY_INDEX;
    };
    // Collection Functions
    // --------------------
    // The cornerstone, an `each` implementation, aka `forEach`.
    // Handles raw objects in addition to array-likes. Treats all
    // sparse array-likes as if they were dense.
    _.each = _.forEach = function(obj, iteratee, context) {
        iteratee = optimizeCb(iteratee, context);
        var i, length;
        if (isArrayLike(obj)) for(i = 0, length = obj.length; i < length; i++)iteratee(obj[i], i, obj);
        else {
            var keys = _.keys(obj);
            for(i = 0, length = keys.length; i < length; i++)iteratee(obj[keys[i]], keys[i], obj);
        }
        return obj;
    };
    // Return the results of applying the iteratee to each element.
    _.map = _.collect = function(obj, iteratee, context) {
        iteratee = cb(iteratee, context);
        var keys = !isArrayLike(obj) && _.keys(obj), length = (keys || obj).length, results = Array(length);
        for(var index = 0; index < length; index++){
            var currentKey = keys ? keys[index] : index;
            results[index] = iteratee(obj[currentKey], currentKey, obj);
        }
        return results;
    };
    // Create a reducing function iterating left or right.
    var createReduce = function(dir) {
        // Wrap code that reassigns argument variables in a separate function than
        // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
        var reducer = function(obj, iteratee, memo, initial) {
            var keys = !isArrayLike(obj) && _.keys(obj), length = (keys || obj).length, index = dir > 0 ? 0 : length - 1;
            if (!initial) {
                memo = obj[keys ? keys[index] : index];
                index += dir;
            }
            for(; index >= 0 && index < length; index += dir){
                var currentKey = keys ? keys[index] : index;
                memo = iteratee(memo, obj[currentKey], currentKey, obj);
            }
            return memo;
        };
        return function(obj, iteratee, memo, context) {
            var initial = arguments.length >= 3;
            return reducer(obj, optimizeCb(iteratee, context, 4), memo, initial);
        };
    };
    // **Reduce** builds up a single result from a list of values, aka `inject`,
    // or `foldl`.
    _.reduce = _.foldl = _.inject = createReduce(1);
    // The right-associative version of reduce, also known as `foldr`.
    _.reduceRight = _.foldr = createReduce(-1);
    // Return the first value which passes a truth test. Aliased as `detect`.
    _.find = _.detect = function(obj, predicate, context) {
        var keyFinder = isArrayLike(obj) ? _.findIndex : _.findKey;
        var key = keyFinder(obj, predicate, context);
        if (key !== void 0 && key !== -1) return obj[key];
    };
    // Return all the elements that pass a truth test.
    // Aliased as `select`.
    _.filter = _.select = function(obj, predicate, context) {
        var results = [];
        predicate = cb(predicate, context);
        _.each(obj, function(value, index, list) {
            if (predicate(value, index, list)) results.push(value);
        });
        return results;
    };
    // Return all the elements for which a truth test fails.
    _.reject = function(obj, predicate, context) {
        return _.filter(obj, _.negate(cb(predicate)), context);
    };
    // Determine whether all of the elements match a truth test.
    // Aliased as `all`.
    _.every = _.all = function(obj, predicate, context) {
        predicate = cb(predicate, context);
        var keys = !isArrayLike(obj) && _.keys(obj), length = (keys || obj).length;
        for(var index = 0; index < length; index++){
            var currentKey = keys ? keys[index] : index;
            if (!predicate(obj[currentKey], currentKey, obj)) return false;
        }
        return true;
    };
    // Determine if at least one element in the object matches a truth test.
    // Aliased as `any`.
    _.some = _.any = function(obj, predicate, context) {
        predicate = cb(predicate, context);
        var keys = !isArrayLike(obj) && _.keys(obj), length = (keys || obj).length;
        for(var index = 0; index < length; index++){
            var currentKey = keys ? keys[index] : index;
            if (predicate(obj[currentKey], currentKey, obj)) return true;
        }
        return false;
    };
    // Determine if the array or object contains a given item (using `===`).
    // Aliased as `includes` and `include`.
    _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
        if (!isArrayLike(obj)) obj = _.values(obj);
        if (typeof fromIndex != "number" || guard) fromIndex = 0;
        return _.indexOf(obj, item, fromIndex) >= 0;
    };
    // Invoke a method (with arguments) on every item in a collection.
    _.invoke = restArguments(function(obj, path, args) {
        var contextPath, func;
        if (_.isFunction(path)) func = path;
        else if (_.isArray(path)) {
            contextPath = path.slice(0, -1);
            path = path[path.length - 1];
        }
        return _.map(obj, function(context) {
            var method = func;
            if (!method) {
                if (contextPath && contextPath.length) context = deepGet(context, contextPath);
                if (context == null) return void 0;
                method = context[path];
            }
            return method == null ? method : method.apply(context, args);
        });
    });
    // Convenience version of a common use case of `map`: fetching a property.
    _.pluck = function(obj, key) {
        return _.map(obj, _.property(key));
    };
    // Convenience version of a common use case of `filter`: selecting only objects
    // containing specific `key:value` pairs.
    _.where = function(obj, attrs) {
        return _.filter(obj, _.matcher(attrs));
    };
    // Convenience version of a common use case of `find`: getting the first object
    // containing specific `key:value` pairs.
    _.findWhere = function(obj, attrs) {
        return _.find(obj, _.matcher(attrs));
    };
    // Return the maximum element (or element-based computation).
    _.max = function(obj, iteratee, context) {
        var result = -Infinity, lastComputed = -Infinity, value, computed;
        if (iteratee == null || typeof iteratee == "number" && typeof obj[0] != "object" && obj != null) {
            obj = isArrayLike(obj) ? obj : _.values(obj);
            for(var i = 0, length = obj.length; i < length; i++){
                value = obj[i];
                if (value != null && value > result) result = value;
            }
        } else {
            iteratee = cb(iteratee, context);
            _.each(obj, function(v, index, list) {
                computed = iteratee(v, index, list);
                if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
                    result = v;
                    lastComputed = computed;
                }
            });
        }
        return result;
    };
    // Return the minimum element (or element-based computation).
    _.min = function(obj, iteratee, context) {
        var result = Infinity, lastComputed = Infinity, value, computed;
        if (iteratee == null || typeof iteratee == "number" && typeof obj[0] != "object" && obj != null) {
            obj = isArrayLike(obj) ? obj : _.values(obj);
            for(var i = 0, length = obj.length; i < length; i++){
                value = obj[i];
                if (value != null && value < result) result = value;
            }
        } else {
            iteratee = cb(iteratee, context);
            _.each(obj, function(v, index, list) {
                computed = iteratee(v, index, list);
                if (computed < lastComputed || computed === Infinity && result === Infinity) {
                    result = v;
                    lastComputed = computed;
                }
            });
        }
        return result;
    };
    // Shuffle a collection.
    _.shuffle = function(obj) {
        return _.sample(obj, Infinity);
    };
    // Sample **n** random values from a collection using the modern version of the
    // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
    // If **n** is not specified, returns a single random element.
    // The internal `guard` argument allows it to work with `map`.
    _.sample = function(obj, n, guard) {
        if (n == null || guard) {
            if (!isArrayLike(obj)) obj = _.values(obj);
            return obj[_.random(obj.length - 1)];
        }
        var sample = isArrayLike(obj) ? _.clone(obj) : _.values(obj);
        var length = getLength(sample);
        n = Math.max(Math.min(n, length), 0);
        var last = length - 1;
        for(var index = 0; index < n; index++){
            var rand = _.random(index, last);
            var temp = sample[index];
            sample[index] = sample[rand];
            sample[rand] = temp;
        }
        return sample.slice(0, n);
    };
    // Sort the object's values by a criterion produced by an iteratee.
    _.sortBy = function(obj, iteratee, context) {
        var index = 0;
        iteratee = cb(iteratee, context);
        return _.pluck(_.map(obj, function(value, key, list) {
            return {
                value: value,
                index: index++,
                criteria: iteratee(value, key, list)
            };
        }).sort(function(left, right) {
            var a = left.criteria;
            var b = right.criteria;
            if (a !== b) {
                if (a > b || a === void 0) return 1;
                if (a < b || b === void 0) return -1;
            }
            return left.index - right.index;
        }), "value");
    };
    // An internal function used for aggregate "group by" operations.
    var group = function(behavior, partition) {
        return function(obj, iteratee, context) {
            var result = partition ? [
                [],
                []
            ] : {};
            iteratee = cb(iteratee, context);
            _.each(obj, function(value, index) {
                var key = iteratee(value, index, obj);
                behavior(result, value, key);
            });
            return result;
        };
    };
    // Groups the object's values by a criterion. Pass either a string attribute
    // to group by, or a function that returns the criterion.
    _.groupBy = group(function(result, value, key) {
        if (has(result, key)) result[key].push(value);
        else result[key] = [
            value
        ];
    });
    // Indexes the object's values by a criterion, similar to `groupBy`, but for
    // when you know that your index values will be unique.
    _.indexBy = group(function(result, value, key) {
        result[key] = value;
    });
    // Counts instances of an object that group by a certain criterion. Pass
    // either a string attribute to count by, or a function that returns the
    // criterion.
    _.countBy = group(function(result, value, key) {
        if (has(result, key)) result[key]++;
        else result[key] = 1;
    });
    var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
    // Safely create a real, live array from anything iterable.
    _.toArray = function(obj) {
        if (!obj) return [];
        if (_.isArray(obj)) return slice.call(obj);
        if (_.isString(obj)) // Keep surrogate pair characters together
        return obj.match(reStrSymbol);
        if (isArrayLike(obj)) return _.map(obj, _.identity);
        return _.values(obj);
    };
    // Return the number of elements in an object.
    _.size = function(obj) {
        if (obj == null) return 0;
        return isArrayLike(obj) ? obj.length : _.keys(obj).length;
    };
    // Split a collection into two arrays: one whose elements all satisfy the given
    // predicate, and one whose elements all do not satisfy the predicate.
    _.partition = group(function(result, value, pass) {
        result[pass ? 0 : 1].push(value);
    }, true);
    // Array Functions
    // ---------------
    // Get the first element of an array. Passing **n** will return the first N
    // values in the array. Aliased as `head` and `take`. The **guard** check
    // allows it to work with `_.map`.
    _.first = _.head = _.take = function(array, n, guard) {
        if (array == null || array.length < 1) return n == null ? void 0 : [];
        if (n == null || guard) return array[0];
        return _.initial(array, array.length - n);
    };
    // Returns everything but the last entry of the array. Especially useful on
    // the arguments object. Passing **n** will return all the values in
    // the array, excluding the last N.
    _.initial = function(array, n, guard) {
        return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
    };
    // Get the last element of an array. Passing **n** will return the last N
    // values in the array.
    _.last = function(array, n, guard) {
        if (array == null || array.length < 1) return n == null ? void 0 : [];
        if (n == null || guard) return array[array.length - 1];
        return _.rest(array, Math.max(0, array.length - n));
    };
    // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
    // Especially useful on the arguments object. Passing an **n** will return
    // the rest N values in the array.
    _.rest = _.tail = _.drop = function(array, n, guard) {
        return slice.call(array, n == null || guard ? 1 : n);
    };
    // Trim out all falsy values from an array.
    _.compact = function(array) {
        return _.filter(array, Boolean);
    };
    // Internal implementation of a recursive `flatten` function.
    var flatten = function(input, shallow, strict, output) {
        output = output || [];
        var idx = output.length;
        for(var i = 0, length = getLength(input); i < length; i++){
            var value = input[i];
            if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
                // Flatten current level of array or arguments object.
                if (shallow) {
                    var j = 0, len = value.length;
                    while(j < len)output[idx++] = value[j++];
                } else {
                    flatten(value, shallow, strict, output);
                    idx = output.length;
                }
            } else if (!strict) output[idx++] = value;
        }
        return output;
    };
    // Flatten out an array, either recursively (by default), or just one level.
    _.flatten = function(array, shallow) {
        return flatten(array, shallow, false);
    };
    // Return a version of the array that does not contain the specified value(s).
    _.without = restArguments(function(array, otherArrays) {
        return _.difference(array, otherArrays);
    });
    // Produce a duplicate-free version of the array. If the array has already
    // been sorted, you have the option of using a faster algorithm.
    // The faster algorithm will not work with an iteratee if the iteratee
    // is not a one-to-one function, so providing an iteratee will disable
    // the faster algorithm.
    // Aliased as `unique`.
    _.uniq = _.unique = function(array, isSorted, iteratee, context) {
        if (!_.isBoolean(isSorted)) {
            context = iteratee;
            iteratee = isSorted;
            isSorted = false;
        }
        if (iteratee != null) iteratee = cb(iteratee, context);
        var result = [];
        var seen = [];
        for(var i = 0, length = getLength(array); i < length; i++){
            var value = array[i], computed = iteratee ? iteratee(value, i, array) : value;
            if (isSorted && !iteratee) {
                if (!i || seen !== computed) result.push(value);
                seen = computed;
            } else if (iteratee) {
                if (!_.contains(seen, computed)) {
                    seen.push(computed);
                    result.push(value);
                }
            } else if (!_.contains(result, value)) result.push(value);
        }
        return result;
    };
    // Produce an array that contains the union: each distinct element from all of
    // the passed-in arrays.
    _.union = restArguments(function(arrays) {
        return _.uniq(flatten(arrays, true, true));
    });
    // Produce an array that contains every item shared between all the
    // passed-in arrays.
    _.intersection = function(array) {
        var result = [];
        var argsLength = arguments.length;
        for(var i = 0, length = getLength(array); i < length; i++){
            var item = array[i];
            if (_.contains(result, item)) continue;
            var j;
            for(j = 1; j < argsLength; j++){
                if (!_.contains(arguments[j], item)) break;
            }
            if (j === argsLength) result.push(item);
        }
        return result;
    };
    // Take the difference between one array and a number of other arrays.
    // Only the elements present in just the first array will remain.
    _.difference = restArguments(function(array, rest) {
        rest = flatten(rest, true, true);
        return _.filter(array, function(value) {
            return !_.contains(rest, value);
        });
    });
    // Complement of _.zip. Unzip accepts an array of arrays and groups
    // each array's elements on shared indices.
    _.unzip = function(array) {
        var length = array && _.max(array, getLength).length || 0;
        var result = Array(length);
        for(var index = 0; index < length; index++)result[index] = _.pluck(array, index);
        return result;
    };
    // Zip together multiple lists into a single array -- elements that share
    // an index go together.
    _.zip = restArguments(_.unzip);
    // Converts lists into objects. Pass either a single array of `[key, value]`
    // pairs, or two parallel arrays of the same length -- one of keys, and one of
    // the corresponding values. Passing by pairs is the reverse of _.pairs.
    _.object = function(list, values) {
        var result = {};
        for(var i = 0, length = getLength(list); i < length; i++)if (values) result[list[i]] = values[i];
        else result[list[i][0]] = list[i][1];
        return result;
    };
    // Generator function to create the findIndex and findLastIndex functions.
    var createPredicateIndexFinder = function(dir) {
        return function(array, predicate, context) {
            predicate = cb(predicate, context);
            var length = getLength(array);
            var index = dir > 0 ? 0 : length - 1;
            for(; index >= 0 && index < length; index += dir){
                if (predicate(array[index], index, array)) return index;
            }
            return -1;
        };
    };
    // Returns the first index on an array-like that passes a predicate test.
    _.findIndex = createPredicateIndexFinder(1);
    _.findLastIndex = createPredicateIndexFinder(-1);
    // Use a comparator function to figure out the smallest index at which
    // an object should be inserted so as to maintain order. Uses binary search.
    _.sortedIndex = function(array, obj, iteratee, context) {
        iteratee = cb(iteratee, context, 1);
        var value = iteratee(obj);
        var low = 0, high = getLength(array);
        while(low < high){
            var mid = Math.floor((low + high) / 2);
            if (iteratee(array[mid]) < value) low = mid + 1;
            else high = mid;
        }
        return low;
    };
    // Generator function to create the indexOf and lastIndexOf functions.
    var createIndexFinder = function(dir, predicateFind, sortedIndex) {
        return function(array, item, idx) {
            var i = 0, length = getLength(array);
            if (typeof idx == "number") {
                if (dir > 0) i = idx >= 0 ? idx : Math.max(idx + length, i);
                else length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
            } else if (sortedIndex && idx && length) {
                idx = sortedIndex(array, item);
                return array[idx] === item ? idx : -1;
            }
            if (item !== item) {
                idx = predicateFind(slice.call(array, i, length), _.isNaN);
                return idx >= 0 ? idx + i : -1;
            }
            for(idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir){
                if (array[idx] === item) return idx;
            }
            return -1;
        };
    };
    // Return the position of the first occurrence of an item in an array,
    // or -1 if the item is not included in the array.
    // If the array is large and already in sort order, pass `true`
    // for **isSorted** to use binary search.
    _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
    _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);
    // Generate an integer Array containing an arithmetic progression. A port of
    // the native Python `range()` function. See
    // [the Python documentation](http://docs.python.org/library/functions.html#range).
    _.range = function(start, stop, step) {
        if (stop == null) {
            stop = start || 0;
            start = 0;
        }
        if (!step) step = stop < start ? -1 : 1;
        var length = Math.max(Math.ceil((stop - start) / step), 0);
        var range = Array(length);
        for(var idx = 0; idx < length; idx++, start += step)range[idx] = start;
        return range;
    };
    // Chunk a single array into multiple arrays, each containing `count` or fewer
    // items.
    _.chunk = function(array, count) {
        if (count == null || count < 1) return [];
        var result = [];
        var i = 0, length = array.length;
        while(i < length)result.push(slice.call(array, i, i += count));
        return result;
    };
    // Function (ahem) Functions
    // ------------------
    // Determines whether to execute a function as a constructor
    // or a normal function with the provided arguments.
    var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
        if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
        var self1 = baseCreate(sourceFunc.prototype);
        var result = sourceFunc.apply(self1, args);
        if (_.isObject(result)) return result;
        return self1;
    };
    // Create a function bound to a given object (assigning `this`, and arguments,
    // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
    // available.
    _.bind = restArguments(function(func, context, args) {
        if (!_.isFunction(func)) throw new TypeError("Bind must be called on a function");
        var bound = restArguments(function(callArgs) {
            return executeBound(func, bound, context, this, args.concat(callArgs));
        });
        return bound;
    });
    // Partially apply a function by creating a version that has had some of its
    // arguments pre-filled, without changing its dynamic `this` context. _ acts
    // as a placeholder by default, allowing any combination of arguments to be
    // pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
    _.partial = restArguments(function(func, boundArgs) {
        var placeholder = _.partial.placeholder;
        var bound = function() {
            var position = 0, length = boundArgs.length;
            var args = Array(length);
            for(var i = 0; i < length; i++)args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
            while(position < arguments.length)args.push(arguments[position++]);
            return executeBound(func, bound, this, this, args);
        };
        return bound;
    });
    _.partial.placeholder = _;
    // Bind a number of an object's methods to that object. Remaining arguments
    // are the method names to be bound. Useful for ensuring that all callbacks
    // defined on an object belong to it.
    _.bindAll = restArguments(function(obj, keys) {
        keys = flatten(keys, false, false);
        var index = keys.length;
        if (index < 1) throw new Error("bindAll must be passed function names");
        while(index--){
            var key = keys[index];
            obj[key] = _.bind(obj[key], obj);
        }
    });
    // Memoize an expensive function by storing its results.
    _.memoize = function(func, hasher) {
        var memoize = function(key) {
            var cache = memoize.cache;
            var address = "" + (hasher ? hasher.apply(this, arguments) : key);
            if (!has(cache, address)) cache[address] = func.apply(this, arguments);
            return cache[address];
        };
        memoize.cache = {};
        return memoize;
    };
    // Delays a function for the given number of milliseconds, and then calls
    // it with the arguments supplied.
    _.delay = restArguments(function(func, wait, args) {
        return setTimeout(function() {
            return func.apply(null, args);
        }, wait);
    });
    // Defers a function, scheduling it to run after the current call stack has
    // cleared.
    _.defer = _.partial(_.delay, _, 1);
    // Returns a function, that, when invoked, will only be triggered at most once
    // during a given window of time. Normally, the throttled function will run
    // as much as it can, without ever going more than once per `wait` duration;
    // but if you'd like to disable the execution on the leading edge, pass
    // `{leading: false}`. To disable execution on the trailing edge, ditto.
    _.throttle = function(func, wait, options) {
        var timeout, context, args, result;
        var previous = 0;
        if (!options) options = {};
        var later = function() {
            previous = options.leading === false ? 0 : _.now();
            timeout = null;
            result = func.apply(context, args);
            if (!timeout) context = args = null;
        };
        var throttled = function() {
            var now = _.now();
            if (!previous && options.leading === false) previous = now;
            var remaining = wait - (now - previous);
            context = this;
            args = arguments;
            if (remaining <= 0 || remaining > wait) {
                if (timeout) {
                    clearTimeout(timeout);
                    timeout = null;
                }
                previous = now;
                result = func.apply(context, args);
                if (!timeout) context = args = null;
            } else if (!timeout && options.trailing !== false) timeout = setTimeout(later, remaining);
            return result;
        };
        throttled.cancel = function() {
            clearTimeout(timeout);
            previous = 0;
            timeout = context = args = null;
        };
        return throttled;
    };
    // Returns a function, that, as long as it continues to be invoked, will not
    // be triggered. The function will be called after it stops being called for
    // N milliseconds. If `immediate` is passed, trigger the function on the
    // leading edge, instead of the trailing.
    _.debounce = function(func, wait, immediate) {
        var timeout, result;
        var later = function(context, args) {
            timeout = null;
            if (args) result = func.apply(context, args);
        };
        var debounced = restArguments(function(args) {
            if (timeout) clearTimeout(timeout);
            if (immediate) {
                var callNow = !timeout;
                timeout = setTimeout(later, wait);
                if (callNow) result = func.apply(this, args);
            } else timeout = _.delay(later, wait, this, args);
            return result;
        });
        debounced.cancel = function() {
            clearTimeout(timeout);
            timeout = null;
        };
        return debounced;
    };
    // Returns the first function passed as an argument to the second,
    // allowing you to adjust arguments, run code before and after, and
    // conditionally execute the original function.
    _.wrap = function(func, wrapper) {
        return _.partial(wrapper, func);
    };
    // Returns a negated version of the passed-in predicate.
    _.negate = function(predicate) {
        return function() {
            return !predicate.apply(this, arguments);
        };
    };
    // Returns a function that is the composition of a list of functions, each
    // consuming the return value of the function that follows.
    _.compose = function() {
        var args = arguments;
        var start = args.length - 1;
        return function() {
            var i = start;
            var result = args[start].apply(this, arguments);
            while(i--)result = args[i].call(this, result);
            return result;
        };
    };
    // Returns a function that will only be executed on and after the Nth call.
    _.after = function(times, func) {
        return function() {
            if (--times < 1) return func.apply(this, arguments);
        };
    };
    // Returns a function that will only be executed up to (but not including) the Nth call.
    _.before = function(times, func) {
        var memo;
        return function() {
            if (--times > 0) memo = func.apply(this, arguments);
            if (times <= 1) func = null;
            return memo;
        };
    };
    // Returns a function that will be executed at most one time, no matter how
    // often you call it. Useful for lazy initialization.
    _.once = _.partial(_.before, 2);
    _.restArguments = restArguments;
    // Object Functions
    // ----------------
    // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
    var hasEnumBug = !({
        toString: null
    }).propertyIsEnumerable("toString");
    var nonEnumerableProps = [
        "valueOf",
        "isPrototypeOf",
        "toString",
        "propertyIsEnumerable",
        "hasOwnProperty",
        "toLocaleString"
    ];
    var collectNonEnumProps = function(obj, keys) {
        var nonEnumIdx = nonEnumerableProps.length;
        var constructor = obj.constructor;
        var proto = _.isFunction(constructor) && constructor.prototype || ObjProto;
        // Constructor is a special case.
        var prop = "constructor";
        if (has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);
        while(nonEnumIdx--){
            prop = nonEnumerableProps[nonEnumIdx];
            if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) keys.push(prop);
        }
    };
    // Retrieve the names of an object's own properties.
    // Delegates to **ECMAScript 5**'s native `Object.keys`.
    _.keys = function(obj) {
        if (!_.isObject(obj)) return [];
        if (nativeKeys) return nativeKeys(obj);
        var keys = [];
        for(var key in obj)if (has(obj, key)) keys.push(key);
        // Ahem, IE < 9.
        if (hasEnumBug) collectNonEnumProps(obj, keys);
        return keys;
    };
    // Retrieve all the property names of an object.
    _.allKeys = function(obj) {
        if (!_.isObject(obj)) return [];
        var keys = [];
        for(var key in obj)keys.push(key);
        // Ahem, IE < 9.
        if (hasEnumBug) collectNonEnumProps(obj, keys);
        return keys;
    };
    // Retrieve the values of an object's properties.
    _.values = function(obj) {
        var keys = _.keys(obj);
        var length = keys.length;
        var values = Array(length);
        for(var i = 0; i < length; i++)values[i] = obj[keys[i]];
        return values;
    };
    // Returns the results of applying the iteratee to each element of the object.
    // In contrast to _.map it returns an object.
    _.mapObject = function(obj, iteratee, context) {
        iteratee = cb(iteratee, context);
        var keys = _.keys(obj), length = keys.length, results = {};
        for(var index = 0; index < length; index++){
            var currentKey = keys[index];
            results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
        }
        return results;
    };
    // Convert an object into a list of `[key, value]` pairs.
    // The opposite of _.object.
    _.pairs = function(obj) {
        var keys = _.keys(obj);
        var length = keys.length;
        var pairs = Array(length);
        for(var i = 0; i < length; i++)pairs[i] = [
            keys[i],
            obj[keys[i]]
        ];
        return pairs;
    };
    // Invert the keys and values of an object. The values must be serializable.
    _.invert = function(obj) {
        var result = {};
        var keys = _.keys(obj);
        for(var i = 0, length = keys.length; i < length; i++)result[obj[keys[i]]] = keys[i];
        return result;
    };
    // Return a sorted list of the function names available on the object.
    // Aliased as `methods`.
    _.functions = _.methods = function(obj) {
        var names = [];
        for(var key in obj)if (_.isFunction(obj[key])) names.push(key);
        return names.sort();
    };
    // An internal function for creating assigner functions.
    var createAssigner = function(keysFunc, defaults) {
        return function(obj) {
            var length = arguments.length;
            if (defaults) obj = Object(obj);
            if (length < 2 || obj == null) return obj;
            for(var index = 1; index < length; index++){
                var source = arguments[index], keys = keysFunc(source), l = keys.length;
                for(var i = 0; i < l; i++){
                    var key = keys[i];
                    if (!defaults || obj[key] === void 0) obj[key] = source[key];
                }
            }
            return obj;
        };
    };
    // Extend a given object with all the properties in passed-in object(s).
    _.extend = createAssigner(_.allKeys);
    // Assigns a given object with all the own properties in the passed-in object(s).
    // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
    _.extendOwn = _.assign = createAssigner(_.keys);
    // Returns the first key on an object that passes a predicate test.
    _.findKey = function(obj, predicate, context) {
        predicate = cb(predicate, context);
        var keys = _.keys(obj), key;
        for(var i = 0, length = keys.length; i < length; i++){
            key = keys[i];
            if (predicate(obj[key], key, obj)) return key;
        }
    };
    // Internal pick helper function to determine if `obj` has key `key`.
    var keyInObj = function(value, key, obj) {
        return key in obj;
    };
    // Return a copy of the object only containing the whitelisted properties.
    _.pick = restArguments(function(obj, keys) {
        var result = {}, iteratee = keys[0];
        if (obj == null) return result;
        if (_.isFunction(iteratee)) {
            if (keys.length > 1) iteratee = optimizeCb(iteratee, keys[1]);
            keys = _.allKeys(obj);
        } else {
            iteratee = keyInObj;
            keys = flatten(keys, false, false);
            obj = Object(obj);
        }
        for(var i = 0, length = keys.length; i < length; i++){
            var key = keys[i];
            var value = obj[key];
            if (iteratee(value, key, obj)) result[key] = value;
        }
        return result;
    });
    // Return a copy of the object without the blacklisted properties.
    _.omit = restArguments(function(obj, keys) {
        var iteratee = keys[0], context;
        if (_.isFunction(iteratee)) {
            iteratee = _.negate(iteratee);
            if (keys.length > 1) context = keys[1];
        } else {
            keys = _.map(flatten(keys, false, false), String);
            iteratee = function(value, key) {
                return !_.contains(keys, key);
            };
        }
        return _.pick(obj, iteratee, context);
    });
    // Fill in a given object with default properties.
    _.defaults = createAssigner(_.allKeys, true);
    // Creates an object that inherits from the given prototype object.
    // If additional properties are provided then they will be added to the
    // created object.
    _.create = function(prototype, props) {
        var result = baseCreate(prototype);
        if (props) _.extendOwn(result, props);
        return result;
    };
    // Create a (shallow-cloned) duplicate of an object.
    _.clone = function(obj) {
        if (!_.isObject(obj)) return obj;
        return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
    };
    // Invokes interceptor with the obj, and then returns obj.
    // The primary purpose of this method is to "tap into" a method chain, in
    // order to perform operations on intermediate results within the chain.
    _.tap = function(obj, interceptor) {
        interceptor(obj);
        return obj;
    };
    // Returns whether an object has a given set of `key:value` pairs.
    _.isMatch = function(object, attrs) {
        var keys = _.keys(attrs), length = keys.length;
        if (object == null) return !length;
        var obj = Object(object);
        for(var i = 0; i < length; i++){
            var key = keys[i];
            if (attrs[key] !== obj[key] || !(key in obj)) return false;
        }
        return true;
    };
    // Internal recursive comparison function for `isEqual`.
    var eq, deepEq;
    eq = function(a, b, aStack, bStack) {
        // Identical objects are equal. `0 === -0`, but they aren't identical.
        // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
        if (a === b) return a !== 0 || 1 / a === 1 / b;
        // `null` or `undefined` only equal to itself (strict comparison).
        if (a == null || b == null) return false;
        // `NaN`s are equivalent, but non-reflexive.
        if (a !== a) return b !== b;
        // Exhaust primitive checks
        var type = typeof a;
        if (type !== "function" && type !== "object" && typeof b != "object") return false;
        return deepEq(a, b, aStack, bStack);
    };
    // Internal recursive comparison function for `isEqual`.
    deepEq = function(a, b, aStack, bStack) {
        // Unwrap any wrapped objects.
        if (a instanceof _) a = a._wrapped;
        if (b instanceof _) b = b._wrapped;
        // Compare `[[Class]]` names.
        var className = toString.call(a);
        if (className !== toString.call(b)) return false;
        switch(className){
            // Strings, numbers, regular expressions, dates, and booleans are compared by value.
            case "[object RegExp]":
            // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
            case "[object String]":
                // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
                // equivalent to `new String("5")`.
                return "" + a === "" + b;
            case "[object Number]":
                // `NaN`s are equivalent, but non-reflexive.
                // Object(NaN) is equivalent to NaN.
                if (+a !== +a) return +b !== +b;
                // An `egal` comparison is performed for other numeric values.
                return +a === 0 ? 1 / +a === 1 / b : +a === +b;
            case "[object Date]":
            case "[object Boolean]":
                // Coerce dates and booleans to numeric primitive values. Dates are compared by their
                // millisecond representations. Note that invalid dates with millisecond representations
                // of `NaN` are not equivalent.
                return +a === +b;
            case "[object Symbol]":
                return SymbolProto.valueOf.call(a) === SymbolProto.valueOf.call(b);
        }
        var areArrays = className === "[object Array]";
        if (!areArrays) {
            if (typeof a != "object" || typeof b != "object") return false;
            // Objects with different constructors are not equivalent, but `Object`s or `Array`s
            // from different frames are.
            var aCtor = a.constructor, bCtor = b.constructor;
            if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor && _.isFunction(bCtor) && bCtor instanceof bCtor) && "constructor" in a && "constructor" in b) return false;
        }
        // Assume equality for cyclic structures. The algorithm for detecting cyclic
        // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
        // Initializing stack of traversed objects.
        // It's done here since we only need them for objects and arrays comparison.
        aStack = aStack || [];
        bStack = bStack || [];
        var length = aStack.length;
        while(length--){
            // Linear search. Performance is inversely proportional to the number of
            // unique nested structures.
            if (aStack[length] === a) return bStack[length] === b;
        }
        // Add the first object to the stack of traversed objects.
        aStack.push(a);
        bStack.push(b);
        // Recursively compare objects and arrays.
        if (areArrays) {
            // Compare array lengths to determine if a deep comparison is necessary.
            length = a.length;
            if (length !== b.length) return false;
            // Deep compare the contents, ignoring non-numeric properties.
            while(length--){
                if (!eq(a[length], b[length], aStack, bStack)) return false;
            }
        } else {
            // Deep compare objects.
            var keys = _.keys(a), key;
            length = keys.length;
            // Ensure that both objects contain the same number of properties before comparing deep equality.
            if (_.keys(b).length !== length) return false;
            while(length--){
                // Deep compare each member
                key = keys[length];
                if (!(has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
            }
        }
        // Remove the first object from the stack of traversed objects.
        aStack.pop();
        bStack.pop();
        return true;
    };
    // Perform a deep comparison to check if two objects are equal.
    _.isEqual = function(a, b) {
        return eq(a, b);
    };
    // Is a given array, string, or object empty?
    // An "empty" object has no enumerable own-properties.
    _.isEmpty = function(obj) {
        if (obj == null) return true;
        if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
        return _.keys(obj).length === 0;
    };
    // Is a given value a DOM element?
    _.isElement = function(obj) {
        return !!(obj && obj.nodeType === 1);
    };
    // Is a given value an array?
    // Delegates to ECMA5's native Array.isArray
    _.isArray = nativeIsArray || function(obj) {
        return toString.call(obj) === "[object Array]";
    };
    // Is a given variable an object?
    _.isObject = function(obj) {
        var type = typeof obj;
        return type === "function" || type === "object" && !!obj;
    };
    // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError, isMap, isWeakMap, isSet, isWeakSet.
    _.each([
        "Arguments",
        "Function",
        "String",
        "Number",
        "Date",
        "RegExp",
        "Error",
        "Symbol",
        "Map",
        "WeakMap",
        "Set",
        "WeakSet"
    ], function(name) {
        _["is" + name] = function(obj) {
            return toString.call(obj) === "[object " + name + "]";
        };
    });
    // Define a fallback version of the method in browsers (ahem, IE < 9), where
    // there isn't any inspectable "Arguments" type.
    if (!_.isArguments(arguments)) _.isArguments = function(obj) {
        return has(obj, "callee");
    };
    // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
    // IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
    var nodelist = root.document && root.document.childNodes;
    if (typeof /./ != "function" && typeof Int8Array != "object" && typeof nodelist != "function") _.isFunction = function(obj) {
        return typeof obj == "function" || false;
    };
    // Is a given object a finite number?
    _.isFinite = function(obj) {
        return !_.isSymbol(obj) && isFinite(obj) && !isNaN(parseFloat(obj));
    };
    // Is the given value `NaN`?
    _.isNaN = function(obj) {
        return _.isNumber(obj) && isNaN(obj);
    };
    // Is a given value a boolean?
    _.isBoolean = function(obj) {
        return obj === true || obj === false || toString.call(obj) === "[object Boolean]";
    };
    // Is a given value equal to null?
    _.isNull = function(obj) {
        return obj === null;
    };
    // Is a given variable undefined?
    _.isUndefined = function(obj) {
        return obj === void 0;
    };
    // Shortcut function for checking if an object has a given property directly
    // on itself (in other words, not on a prototype).
    _.has = function(obj, path) {
        if (!_.isArray(path)) return has(obj, path);
        var length = path.length;
        for(var i = 0; i < length; i++){
            var key = path[i];
            if (obj == null || !hasOwnProperty.call(obj, key)) return false;
            obj = obj[key];
        }
        return !!length;
    };
    // Utility Functions
    // -----------------
    // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
    // previous owner. Returns a reference to the Underscore object.
    _.noConflict = function() {
        root._ = previousUnderscore;
        return this;
    };
    // Keep the identity function around for default iteratees.
    _.identity = function(value) {
        return value;
    };
    // Predicate-generating functions. Often useful outside of Underscore.
    _.constant = function(value) {
        return function() {
            return value;
        };
    };
    _.noop = function() {};
    // Creates a function that, when passed an object, will traverse that object’s
    // properties down the given `path`, specified as an array of keys or indexes.
    _.property = function(path) {
        if (!_.isArray(path)) return shallowProperty(path);
        return function(obj) {
            return deepGet(obj, path);
        };
    };
    // Generates a function for a given object that returns a given property.
    _.propertyOf = function(obj) {
        if (obj == null) return function() {};
        return function(path) {
            return !_.isArray(path) ? obj[path] : deepGet(obj, path);
        };
    };
    // Returns a predicate for checking whether an object has a given set of
    // `key:value` pairs.
    _.matcher = _.matches = function(attrs) {
        attrs = _.extendOwn({}, attrs);
        return function(obj) {
            return _.isMatch(obj, attrs);
        };
    };
    // Run a function **n** times.
    _.times = function(n, iteratee, context) {
        var accum = Array(Math.max(0, n));
        iteratee = optimizeCb(iteratee, context, 1);
        for(var i = 0; i < n; i++)accum[i] = iteratee(i);
        return accum;
    };
    // Return a random integer between min and max (inclusive).
    _.random = function(min, max) {
        if (max == null) {
            max = min;
            min = 0;
        }
        return min + Math.floor(Math.random() * (max - min + 1));
    };
    // A (possibly faster) way to get the current timestamp as an integer.
    _.now = Date.now || function() {
        return new Date().getTime();
    };
    // List of HTML entities for escaping.
    var escapeMap = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#x27;",
        "`": "&#x60;"
    };
    var unescapeMap = _.invert(escapeMap);
    // Functions for escaping and unescaping strings to/from HTML interpolation.
    var createEscaper = function(map) {
        var escaper = function(match) {
            return map[match];
        };
        // Regexes for identifying a key that needs to be escaped.
        var source = "(?:" + _.keys(map).join("|") + ")";
        var testRegexp = RegExp(source);
        var replaceRegexp = RegExp(source, "g");
        return function(string) {
            string = string == null ? "" : "" + string;
            return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
        };
    };
    _.escape = createEscaper(escapeMap);
    _.unescape = createEscaper(unescapeMap);
    // Traverses the children of `obj` along `path`. If a child is a function, it
    // is invoked with its parent as context. Returns the value of the final
    // child, or `fallback` if any child is undefined.
    _.result = function(obj, path, fallback) {
        if (!_.isArray(path)) path = [
            path
        ];
        var length = path.length;
        if (!length) return _.isFunction(fallback) ? fallback.call(obj) : fallback;
        for(var i = 0; i < length; i++){
            var prop = obj == null ? void 0 : obj[path[i]];
            if (prop === void 0) {
                prop = fallback;
                i = length; // Ensure we don't continue iterating.
            }
            obj = _.isFunction(prop) ? prop.call(obj) : prop;
        }
        return obj;
    };
    // Generate a unique integer id (unique within the entire client session).
    // Useful for temporary DOM ids.
    var idCounter = 0;
    _.uniqueId = function(prefix) {
        var id = ++idCounter + "";
        return prefix ? prefix + id : id;
    };
    // By default, Underscore uses ERB-style template delimiters, change the
    // following template settings to use alternative delimiters.
    _.templateSettings = {
        evaluate: /<%([\s\S]+?)%>/g,
        interpolate: /<%=([\s\S]+?)%>/g,
        escape: /<%-([\s\S]+?)%>/g
    };
    // When customizing `templateSettings`, if you don't want to define an
    // interpolation, evaluation or escaping regex, we need one that is
    // guaranteed not to match.
    var noMatch = /(.)^/;
    // Certain characters need to be escaped so that they can be put into a
    // string literal.
    var escapes = {
        "'": "'",
        "\\": "\\",
        "\r": "r",
        "\n": "n",
        "\u2028": "u2028",
        "\u2029": "u2029"
    };
    var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;
    var escapeChar = function(match) {
        return "\\" + escapes[match];
    };
    // JavaScript micro-templating, similar to John Resig's implementation.
    // Underscore templating handles arbitrary delimiters, preserves whitespace,
    // and correctly escapes quotes within interpolated code.
    // NB: `oldSettings` only exists for backwards compatibility.
    _.template = function(text, settings, oldSettings) {
        if (!settings && oldSettings) settings = oldSettings;
        settings = _.defaults({}, settings, _.templateSettings);
        // Combine delimiters into one regular expression via alternation.
        var matcher = RegExp([
            (settings.escape || noMatch).source,
            (settings.interpolate || noMatch).source,
            (settings.evaluate || noMatch).source
        ].join("|") + "|$", "g");
        // Compile the template source, escaping string literals appropriately.
        var index = 0;
        var source = "__p+='";
        text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
            source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
            index = offset + match.length;
            if (escape) source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
            else if (interpolate) source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
            else if (evaluate) source += "';\n" + evaluate + "\n__p+='";
            // Adobe VMs need the match returned to produce the correct offset.
            return match;
        });
        source += "';\n";
        // If a variable is not specified, place data values in local scope.
        if (!settings.variable) source = "with(obj||{}){\n" + source + "}\n";
        source = "var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n" + source + "return __p;\n";
        var render;
        try {
            render = new Function(settings.variable || "obj", "_", source);
        } catch (e) {
            e.source = source;
            throw e;
        }
        var template = function(data) {
            return render.call(this, data, _);
        };
        // Provide the compiled source as a convenience for precompilation.
        var argument = settings.variable || "obj";
        template.source = "function(" + argument + "){\n" + source + "}";
        return template;
    };
    // Add a "chain" function. Start chaining a wrapped Underscore object.
    _.chain = function(obj) {
        var instance = _(obj);
        instance._chain = true;
        return instance;
    };
    // OOP
    // ---------------
    // If Underscore is called as a function, it returns a wrapped object that
    // can be used OO-style. This wrapper holds altered versions of all the
    // underscore functions. Wrapped objects may be chained.
    // Helper function to continue chaining intermediate results.
    var chainResult = function(instance, obj) {
        return instance._chain ? _(obj).chain() : obj;
    };
    // Add your own custom functions to the Underscore object.
    _.mixin = function(obj) {
        _.each(_.functions(obj), function(name) {
            var func = _[name] = obj[name];
            _.prototype[name] = function() {
                var args = [
                    this._wrapped
                ];
                push.apply(args, arguments);
                return chainResult(this, func.apply(_, args));
            };
        });
        return _;
    };
    // Add all of the Underscore functions to the wrapper object.
    _.mixin(_);
    // Add all mutator Array functions to the wrapper.
    _.each([
        "pop",
        "push",
        "reverse",
        "shift",
        "sort",
        "splice",
        "unshift"
    ], function(name) {
        var method = ArrayProto[name];
        _.prototype[name] = function() {
            var obj = this._wrapped;
            method.apply(obj, arguments);
            if ((name === "shift" || name === "splice") && obj.length === 0) delete obj[0];
            return chainResult(this, obj);
        };
    });
    // Add all accessor Array functions to the wrapper.
    _.each([
        "concat",
        "join",
        "slice"
    ], function(name) {
        var method = ArrayProto[name];
        _.prototype[name] = function() {
            return chainResult(this, method.apply(this._wrapped, arguments));
        };
    });
    // Extracts the result from a wrapped and chained object.
    _.prototype.value = function() {
        return this._wrapped;
    };
    // Provide unwrapping proxy for some methods used in engine operations
    // such as arithmetic and JSON stringification.
    _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;
    _.prototype.toString = function() {
        return String(this._wrapped);
    };
    // AMD registration happens at the end for compatibility with AMD loaders
    // that may not enforce next-turn semantics on modules. Even though general
    // practice for AMD registration is to be anonymous, underscore registers
    // as a named module because, like jQuery, it is a base library that is
    // popular enough to be bundled in a third party lib, but not be part of
    // an AMD load request. Those cases could generate an error when an
    // anonymous define() is called outside of a loader request.
    if (typeof define == "function" && define.amd) define("underscore", [], function() {
        return _;
    });
})();

});


parcelRegister("5a2kX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $3c1fb301f3284561$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $3c1fb301f3284561$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $dQ68B = parcelRequire("dQ68B");
var $3c1fb301f3284561$var$_utils2 = $3c1fb301f3284561$var$_interopRequireDefault($dQ68B);
function $3c1fb301f3284561$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3c1fb301f3284561$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3c1fb301f3284561$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $3c1fb301f3284561$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $3c1fb301f3284561$var$events = [
    "onClick",
    "onDoubleClick",
    "onMouseEnter",
    "onMouseLeave",
    "onContextMenu",
    "onAuxClick"
];
module.exports.default = function(ExtendBase) {
    return function(_ExtendBase) {
        $3c1fb301f3284561$var$_inherits(CellEventDelegater, _ExtendBase);
        function CellEventDelegater(props) {
            $3c1fb301f3284561$var$_classCallCheck(this, CellEventDelegater);
            var _this = $3c1fb301f3284561$var$_possibleConstructorReturn(this, (CellEventDelegater.__proto__ || Object.getPrototypeOf(CellEventDelegater)).call(this, props));
            _this.createDefaultEventHandler = _this.createDefaultEventHandler.bind(_this);
            return _this;
        }
        $3c1fb301f3284561$var$_createClass(CellEventDelegater, [
            {
                key: "createDefaultEventHandler",
                value: function createDefaultEventHandler(cb) {
                    var _this2 = this;
                    return function(e) {
                        var _props = _this2.props, column = _props.column, columnIndex = _props.columnIndex, index = _props.index;
                        cb(e, column, typeof columnIndex !== "undefined" ? columnIndex : index);
                    };
                }
            },
            {
                key: "delegate",
                value: function delegate() {
                    var _this3 = this;
                    var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                    var newAttrs = $3c1fb301f3284561$var$_extends({}, attrs);
                    Object.keys(attrs).forEach(function(attr) {
                        if ($3c1fb301f3284561$var$_utils2.default.contains($3c1fb301f3284561$var$events, attr)) newAttrs[attr] = _this3.createDefaultEventHandler(attrs[attr]);
                    });
                    return newAttrs;
                }
            }
        ]);
        return CellEventDelegater;
    }(ExtendBase);
};

});


parcelRegister("eESlq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CheckBox = undefined;
var $aabef4d6407755ec$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $aabef4d6407755ec$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $aabef4d6407755ec$var$_react2 = $aabef4d6407755ec$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");
var $aabef4d6407755ec$var$_propTypes2 = $aabef4d6407755ec$var$_interopRequireDefault($c9Z8w);

var $jVgbO = parcelRequire("jVgbO");
var $aabef4d6407755ec$var$_const2 = $aabef4d6407755ec$var$_interopRequireDefault($jVgbO);

var $il2Gx = parcelRequire("il2Gx");

var $dQ68B = parcelRequire("dQ68B");
var $aabef4d6407755ec$var$_utils2 = $aabef4d6407755ec$var$_interopRequireDefault($dQ68B);
function $aabef4d6407755ec$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $aabef4d6407755ec$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $aabef4d6407755ec$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $aabef4d6407755ec$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint react/require-default-props: 0 */ 
var $aabef4d6407755ec$var$CheckBox = module.exports.CheckBox = function CheckBox(_ref) {
    var className = _ref.className, checked = _ref.checked, indeterminate = _ref.indeterminate;
    return $aabef4d6407755ec$var$_react2.default.createElement("input", {
        type: "checkbox",
        checked: checked,
        className: className,
        ref: function ref(input) {
            if (input) input.indeterminate = indeterminate; // eslint-disable-line no-param-reassign
        },
        onChange: function onChange() {}
    });
};
$aabef4d6407755ec$var$CheckBox.propTypes = {
    checked: $aabef4d6407755ec$var$_propTypes2.default.bool.isRequired,
    indeterminate: $aabef4d6407755ec$var$_propTypes2.default.bool.isRequired,
    className: $aabef4d6407755ec$var$_propTypes2.default.string
};
var $aabef4d6407755ec$var$SelectionHeaderCell = function(_Component) {
    $aabef4d6407755ec$var$_inherits(SelectionHeaderCell, _Component);
    function SelectionHeaderCell() {
        $aabef4d6407755ec$var$_classCallCheck(this, SelectionHeaderCell);
        var _this = $aabef4d6407755ec$var$_possibleConstructorReturn(this, (SelectionHeaderCell.__proto__ || Object.getPrototypeOf(SelectionHeaderCell)).call(this));
        _this.handleCheckBoxClick = _this.handleCheckBoxClick.bind(_this);
        return _this;
    }
    /**
   * avoid updating if button is
   * 1. radio
   * 2. status was not changed.
   */ $aabef4d6407755ec$var$_createClass(SelectionHeaderCell, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                var ROW_SELECT_SINGLE = $aabef4d6407755ec$var$_const2.default.ROW_SELECT_SINGLE;
                var _props = this.props, mode = _props.mode, checkedStatus = _props.checkedStatus;
                if (mode === ROW_SELECT_SINGLE) return false;
                return nextProps.checkedStatus !== checkedStatus;
            }
        },
        {
            key: "handleCheckBoxClick",
            value: function handleCheckBoxClick(e) {
                var _props2 = this.props, onAllRowsSelect = _props2.onAllRowsSelect, checkedStatus = _props2.checkedStatus;
                var isUnSelect = checkedStatus === $aabef4d6407755ec$var$_const2.default.CHECKBOX_STATUS_CHECKED || checkedStatus === $aabef4d6407755ec$var$_const2.default.CHECKBOX_STATUS_INDETERMINATE;
                onAllRowsSelect(e, isUnSelect);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var CHECKBOX_STATUS_CHECKED = $aabef4d6407755ec$var$_const2.default.CHECKBOX_STATUS_CHECKED, CHECKBOX_STATUS_INDETERMINATE = $aabef4d6407755ec$var$_const2.default.CHECKBOX_STATUS_INDETERMINATE, ROW_SELECT_MULTIPLE = $aabef4d6407755ec$var$_const2.default.ROW_SELECT_MULTIPLE;
                var _props3 = this.props, mode = _props3.mode, checkedStatus = _props3.checkedStatus, selectionHeaderRenderer = _props3.selectionHeaderRenderer, hideSelectAll = _props3.hideSelectAll, headerColumnStyle = _props3.headerColumnStyle;
                if (hideSelectAll) return $aabef4d6407755ec$var$_react2.default.createElement("th", {
                    "data-row-selection": true
                });
                var checked = checkedStatus === CHECKBOX_STATUS_CHECKED;
                var indeterminate = checkedStatus === CHECKBOX_STATUS_INDETERMINATE;
                var attrs = {};
                var content = void 0;
                if (selectionHeaderRenderer || mode === ROW_SELECT_MULTIPLE) attrs.onClick = this.handleCheckBoxClick;
                attrs.style = $aabef4d6407755ec$var$_utils2.default.isFunction(headerColumnStyle) ? headerColumnStyle(checkedStatus) : headerColumnStyle;
                return $aabef4d6407755ec$var$_react2.default.createElement($il2Gx.BootstrapContext.Consumer, null, function(_ref2) {
                    var bootstrap4 = _ref2.bootstrap4;
                    if (selectionHeaderRenderer) content = selectionHeaderRenderer({
                        mode: mode,
                        checked: checked,
                        indeterminate: indeterminate
                    });
                    else if (mode === ROW_SELECT_MULTIPLE) content = $aabef4d6407755ec$var$_react2.default.createElement($aabef4d6407755ec$var$CheckBox, $aabef4d6407755ec$var$_extends({}, _this2.props, {
                        checked: checked,
                        className: bootstrap4 ? "selection-input-4" : "",
                        indeterminate: indeterminate
                    }));
                    return $aabef4d6407755ec$var$_react2.default.createElement("th", $aabef4d6407755ec$var$_extends({
                        className: "selection-cell-header",
                        "data-row-selection": true
                    }, attrs), content);
                });
            }
        }
    ]);
    return SelectionHeaderCell;
}($acw62.Component);
$aabef4d6407755ec$var$SelectionHeaderCell.propTypes = {
    mode: $aabef4d6407755ec$var$_propTypes2.default.string.isRequired,
    checkedStatus: $aabef4d6407755ec$var$_propTypes2.default.string,
    onAllRowsSelect: $aabef4d6407755ec$var$_propTypes2.default.func,
    hideSelectAll: $aabef4d6407755ec$var$_propTypes2.default.bool,
    selectionHeaderRenderer: $aabef4d6407755ec$var$_propTypes2.default.func,
    headerColumnStyle: $aabef4d6407755ec$var$_propTypes2.default.oneOfType([
        $aabef4d6407755ec$var$_propTypes2.default.object,
        $aabef4d6407755ec$var$_propTypes2.default.func
    ])
};
module.exports.default = $aabef4d6407755ec$var$SelectionHeaderCell;

});

parcelRegister("hx0Wj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $cc363f4c9fd0fabc$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $cc363f4c9fd0fabc$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $cc363f4c9fd0fabc$var$_react2 = $cc363f4c9fd0fabc$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");
var $cc363f4c9fd0fabc$var$_propTypes2 = $cc363f4c9fd0fabc$var$_interopRequireDefault($c9Z8w);
function $cc363f4c9fd0fabc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cc363f4c9fd0fabc$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $cc363f4c9fd0fabc$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $cc363f4c9fd0fabc$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint react/require-default-props: 0 */ 
/* eslint no-nested-ternary: 0 */ var $cc363f4c9fd0fabc$var$ExpansionHeaderCell = function(_Component) {
    $cc363f4c9fd0fabc$var$_inherits(ExpansionHeaderCell, _Component);
    function ExpansionHeaderCell() {
        $cc363f4c9fd0fabc$var$_classCallCheck(this, ExpansionHeaderCell);
        var _this = $cc363f4c9fd0fabc$var$_possibleConstructorReturn(this, (ExpansionHeaderCell.__proto__ || Object.getPrototypeOf(ExpansionHeaderCell)).call(this));
        _this.handleCheckBoxClick = _this.handleCheckBoxClick.bind(_this);
        return _this;
    }
    $cc363f4c9fd0fabc$var$_createClass(ExpansionHeaderCell, [
        {
            key: "handleCheckBoxClick",
            value: function handleCheckBoxClick(e) {
                var _props = this.props, isAnyExpands = _props.isAnyExpands, onAllRowExpand = _props.onAllRowExpand;
                onAllRowExpand(e, !isAnyExpands);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props2 = this.props, isAnyExpands = _props2.isAnyExpands, expandHeaderColumnRenderer = _props2.expandHeaderColumnRenderer;
                var attrs = {
                    onClick: this.handleCheckBoxClick
                };
                return $cc363f4c9fd0fabc$var$_react2.default.createElement("th", $cc363f4c9fd0fabc$var$_extends({
                    className: "expand-cell-header",
                    "data-row-selection": true
                }, attrs), expandHeaderColumnRenderer ? expandHeaderColumnRenderer({
                    isAnyExpands: isAnyExpands
                }) : isAnyExpands ? "(-)" : "(+)");
            }
        }
    ]);
    return ExpansionHeaderCell;
}($acw62.Component);
$cc363f4c9fd0fabc$var$ExpansionHeaderCell.propTypes = {
    isAnyExpands: $cc363f4c9fd0fabc$var$_propTypes2.default.bool.isRequired,
    onAllRowExpand: $cc363f4c9fd0fabc$var$_propTypes2.default.func.isRequired,
    expandHeaderColumnRenderer: $cc363f4c9fd0fabc$var$_propTypes2.default.func
};
module.exports.default = $cc363f4c9fd0fabc$var$ExpansionHeaderCell;

});

parcelRegister("aB2AL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $acw62 = parcelRequire("acw62");
var $7b6f5ecc26380787$var$_react2 = $7b6f5ecc26380787$var$_interopRequireDefault($acw62);

var $ihdm8 = parcelRequire("ihdm8");
var $7b6f5ecc26380787$var$_selectionContext2 = $7b6f5ecc26380787$var$_interopRequireDefault($ihdm8);
function $7b6f5ecc26380787$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.default = function(Component) {
    return function() {
        return $7b6f5ecc26380787$var$_react2.default.createElement($7b6f5ecc26380787$var$_selectionContext2.default.Consumer, null, function(selectRow) {
            return $7b6f5ecc26380787$var$_react2.default.createElement(Component, selectRow);
        });
    };
};

});
parcelRegister("ihdm8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $d4e42cc2952d22a8$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $d4e42cc2952d22a8$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $d4e42cc2952d22a8$var$_react2 = $d4e42cc2952d22a8$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");
var $d4e42cc2952d22a8$var$_propTypes2 = $d4e42cc2952d22a8$var$_interopRequireDefault($c9Z8w);

var $jVgbO = parcelRequire("jVgbO");
var $d4e42cc2952d22a8$var$_const2 = $d4e42cc2952d22a8$var$_interopRequireDefault($jVgbO);

var $dQ68B = parcelRequire("dQ68B");
var $d4e42cc2952d22a8$var$_utils2 = $d4e42cc2952d22a8$var$_interopRequireDefault($dQ68B);

var $ijh0r = parcelRequire("ijh0r");
var $d4e42cc2952d22a8$var$_operators2 = $d4e42cc2952d22a8$var$_interopRequireDefault($ijh0r);

var $lDOvM = parcelRequire("lDOvM");
function $d4e42cc2952d22a8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d4e42cc2952d22a8$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
function $d4e42cc2952d22a8$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d4e42cc2952d22a8$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $d4e42cc2952d22a8$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint camelcase: 0 */ 
/* eslint react/prop-types: 0 */ var $d4e42cc2952d22a8$var$SelectionContext = $d4e42cc2952d22a8$var$_react2.default.createContext();
var $d4e42cc2952d22a8$var$SelectionProvider = function(_React$Component) {
    $d4e42cc2952d22a8$var$_inherits(SelectionProvider, _React$Component);
    function SelectionProvider(props) {
        $d4e42cc2952d22a8$var$_classCallCheck(this, SelectionProvider);
        var _this = $d4e42cc2952d22a8$var$_possibleConstructorReturn(this, (SelectionProvider.__proto__ || Object.getPrototypeOf(SelectionProvider)).call(this, props));
        _this.handleRowSelect = function(rowKey, checked, rowIndex, e) {
            var _this$props = _this.props, data = _this$props.data, keyField = _this$props.keyField, _this$props$selectRow = _this$props.selectRow, mode = _this$props$selectRow.mode, onSelect = _this$props$selectRow.onSelect;
            var ROW_SELECT_SINGLE = $d4e42cc2952d22a8$var$_const2.default.ROW_SELECT_SINGLE;
            var currSelected = [].concat($d4e42cc2952d22a8$var$_toConsumableArray(_this.selected));
            var result = true;
            if (onSelect) {
                var row = $d4e42cc2952d22a8$var$_operators2.default.getRowByRowId(data, keyField, rowKey);
                result = onSelect(row, checked, rowIndex, e);
            }
            if (result === true || result === undefined) {
                if (mode === ROW_SELECT_SINGLE) // when select mode is radio
                currSelected = [
                    rowKey
                ];
                else if (checked) // when select mode is checkbox
                currSelected.push(rowKey);
                else currSelected = currSelected.filter(function(value) {
                    return value !== rowKey;
                });
            }
            _this.selected = currSelected;
            _this.forceUpdate();
        };
        _this.handleAllRowsSelect = function(e, isUnSelect) {
            var _this$props2 = _this.props, data = _this$props2.data, keyField = _this$props2.keyField, _this$props2$selectRo = _this$props2.selectRow, onSelectAll = _this$props2$selectRo.onSelectAll, nonSelectable = _this$props2$selectRo.nonSelectable;
            var selected = _this.selected;
            var currSelected = void 0;
            if (!isUnSelect) currSelected = selected.concat($d4e42cc2952d22a8$var$_operators2.default.selectableKeys(data, keyField, nonSelectable));
            else currSelected = selected.filter(function(s) {
                return typeof data.find(function(d) {
                    return $d4e42cc2952d22a8$var$_utils2.default.get(d, keyField) === s;
                }) === "undefined";
            });
            var result = void 0;
            if (onSelectAll) {
                result = onSelectAll(!isUnSelect, $d4e42cc2952d22a8$var$_operators2.default.getSelectedRows(data, keyField, isUnSelect ? selected : currSelected), e);
                if (Array.isArray(result)) currSelected = result;
            }
            _this.selected = currSelected;
            _this.forceUpdate();
        };
        _this.selected = props.selectRow.selected || [];
        return _this;
    }
    // exposed API
    $d4e42cc2952d22a8$var$_createClass(SelectionProvider, [
        {
            key: "getSelected",
            value: function getSelected() {
                return this.selected;
            }
        },
        {
            key: "UNSAFE_componentWillReceiveProps",
            value: function UNSAFE_componentWillReceiveProps(nextProps) {
                if (nextProps.selectRow) this.selected = nextProps.selectRow.selected || this.selected;
            }
        },
        {
            key: "render",
            value: function render() {
                var _getSelectionSummary = (0, $lDOvM.getSelectionSummary)(this.props.data, this.props.keyField, this.selected), allRowsSelected = _getSelectionSummary.allRowsSelected, allRowsNotSelected = _getSelectionSummary.allRowsNotSelected;
                var checkedStatus = void 0;
                // checkbox status depending on selected rows counts
                if (allRowsSelected) checkedStatus = $d4e42cc2952d22a8$var$_const2.default.CHECKBOX_STATUS_CHECKED;
                else if (allRowsNotSelected) checkedStatus = $d4e42cc2952d22a8$var$_const2.default.CHECKBOX_STATUS_UNCHECKED;
                else checkedStatus = $d4e42cc2952d22a8$var$_const2.default.CHECKBOX_STATUS_INDETERMINATE;
                return $d4e42cc2952d22a8$var$_react2.default.createElement($d4e42cc2952d22a8$var$SelectionContext.Provider, {
                    value: $d4e42cc2952d22a8$var$_extends({}, this.props.selectRow, {
                        selected: this.selected,
                        onRowSelect: this.handleRowSelect,
                        onAllRowsSelect: this.handleAllRowsSelect,
                        allRowsSelected: allRowsSelected,
                        allRowsNotSelected: allRowsNotSelected,
                        checkedStatus: checkedStatus
                    })
                }, this.props.children);
            }
        }
    ]);
    return SelectionProvider;
}($d4e42cc2952d22a8$var$_react2.default.Component);
$d4e42cc2952d22a8$var$SelectionProvider.propTypes = {
    children: $d4e42cc2952d22a8$var$_propTypes2.default.node.isRequired,
    data: $d4e42cc2952d22a8$var$_propTypes2.default.array.isRequired,
    keyField: $d4e42cc2952d22a8$var$_propTypes2.default.string.isRequired
};
module.exports.default = {
    Provider: $d4e42cc2952d22a8$var$SelectionProvider,
    Consumer: $d4e42cc2952d22a8$var$SelectionContext.Consumer
};

});
parcelRegister("ijh0r", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $d5473169580f1ebd$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $atKpa = parcelRequire("atKpa");
var $d5473169580f1ebd$var$rows = $d5473169580f1ebd$var$_interopRequireWildcard($atKpa);

var $lDOvM = parcelRequire("lDOvM");
var $d5473169580f1ebd$var$selection = $d5473169580f1ebd$var$_interopRequireWildcard($lDOvM);

var $f8MAX = parcelRequire("f8MAX");
var $d5473169580f1ebd$var$expand = $d5473169580f1ebd$var$_interopRequireWildcard($f8MAX);

var $dzTqi = parcelRequire("dzTqi");
var $d5473169580f1ebd$var$mutate = $d5473169580f1ebd$var$_interopRequireWildcard($dzTqi);

var $ehJyP = parcelRequire("ehJyP");
var $d5473169580f1ebd$var$sort = $d5473169580f1ebd$var$_interopRequireWildcard($ehJyP);

var $ft31c = parcelRequire("ft31c");
var $d5473169580f1ebd$var$type = $d5473169580f1ebd$var$_interopRequireWildcard($ft31c);
function $d5473169580f1ebd$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
module.exports.default = $d5473169580f1ebd$var$_extends({}, $d5473169580f1ebd$var$rows, $d5473169580f1ebd$var$selection, $d5473169580f1ebd$var$expand, $d5473169580f1ebd$var$mutate, $d5473169580f1ebd$var$sort, $d5473169580f1ebd$var$type);

});
parcelRegister("atKpa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getRowByRowId = module.exports.matchRow = undefined;

var $dQ68B = parcelRequire("dQ68B");
var $7a109bdfe109222c$var$_utils2 = $7a109bdfe109222c$var$_interopRequireDefault($dQ68B);
function $7a109bdfe109222c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $7a109bdfe109222c$var$matchRow = module.exports.matchRow = function matchRow(keyField, id) {
    return function(row) {
        return $7a109bdfe109222c$var$_utils2.default.get(row, keyField) === id;
    };
};
var $7a109bdfe109222c$var$getRowByRowId = module.exports.getRowByRowId = function getRowByRowId(data, keyField, id) {
    return data.find($7a109bdfe109222c$var$matchRow(keyField, id));
};

});

parcelRegister("lDOvM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getSelectedRows = module.exports.unSelectableKeys = module.exports.selectableKeys = module.exports.getSelectionSummary = undefined;

var $dQ68B = parcelRequire("dQ68B");
var $fc146c0569cfcd03$var$_utils2 = $fc146c0569cfcd03$var$_interopRequireDefault($dQ68B);

var $atKpa = parcelRequire("atKpa");
function $fc146c0569cfcd03$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $fc146c0569cfcd03$var$getSelectionSummary = module.exports.getSelectionSummary = function getSelectionSummary() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var keyField = arguments[1];
    var selected = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var allRowsSelected = data.length > 0;
    var allRowsNotSelected = true;
    var rowKeys = data.map(function(d) {
        return $fc146c0569cfcd03$var$_utils2.default.get(d, keyField);
    });
    var _loop = function _loop(i) {
        var curr = rowKeys[i];
        if (typeof selected.find(function(x) {
            return x === curr;
        }) === "undefined") allRowsSelected = false;
        else allRowsNotSelected = false;
    };
    for(var i = 0; i < rowKeys.length; i += 1)_loop(i);
    return {
        allRowsSelected: allRowsSelected,
        allRowsNotSelected: allRowsNotSelected
    };
};
var $fc146c0569cfcd03$var$selectableKeys = module.exports.selectableKeys = function selectableKeys() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var keyField = arguments[1];
    var skips = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    if (skips.length === 0) return data.map(function(row) {
        return $fc146c0569cfcd03$var$_utils2.default.get(row, keyField);
    });
    return data.filter(function(row) {
        return !$fc146c0569cfcd03$var$_utils2.default.contains(skips, $fc146c0569cfcd03$var$_utils2.default.get(row, keyField));
    }).map(function(row) {
        return $fc146c0569cfcd03$var$_utils2.default.get(row, keyField);
    });
};
var $fc146c0569cfcd03$var$unSelectableKeys = module.exports.unSelectableKeys = function unSelectableKeys(selected) {
    var skips = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    if (skips.length === 0) return [];
    return selected.filter(function(x) {
        return $fc146c0569cfcd03$var$_utils2.default.contains(skips, x);
    });
};
var $fc146c0569cfcd03$var$getSelectedRows = module.exports.getSelectedRows = function getSelectedRows() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var keyField = arguments[1];
    var selected = arguments[2];
    return selected.map(function(k) {
        return (0, $atKpa.getRowByRowId)(data, keyField, k);
    }).filter(function(x) {
        return !!x;
    });
};

});

parcelRegister("f8MAX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getExpandedRows = module.exports.expandableKeys = module.exports.isAnyExpands = undefined;
var $b05d4c5c346c4645$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var $dQ68B = parcelRequire("dQ68B");
var $b05d4c5c346c4645$var$_utils2 = $b05d4c5c346c4645$var$_interopRequireDefault($dQ68B);

var $atKpa = parcelRequire("atKpa");
function $b05d4c5c346c4645$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $b05d4c5c346c4645$var$isAnyExpands = module.exports.isAnyExpands = function isAnyExpands(data, keyField) {
    var expanded = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var _loop = function _loop(i) {
        var rowKey = $b05d4c5c346c4645$var$_utils2.default.get(data[i], keyField);
        if (typeof expanded.find(function(x) {
            return x === rowKey;
        }) !== "undefined") return {
            v: true
        };
    };
    for(var i = 0; i < data.length; i += 1){
        var _ret = _loop(i);
        if ((typeof _ret === "undefined" ? "undefined" : $b05d4c5c346c4645$var$_typeof(_ret)) === "object") return _ret.v;
    }
    return false;
};
var $b05d4c5c346c4645$var$expandableKeys = module.exports.expandableKeys = function expandableKeys(data, keyField) {
    var skips = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    if (skips.length === 0) return data.map(function(row) {
        return $b05d4c5c346c4645$var$_utils2.default.get(row, keyField);
    });
    return data.filter(function(row) {
        return !$b05d4c5c346c4645$var$_utils2.default.contains(skips, $b05d4c5c346c4645$var$_utils2.default.get(row, keyField));
    }).map(function(row) {
        return $b05d4c5c346c4645$var$_utils2.default.get(row, keyField);
    });
};
var $b05d4c5c346c4645$var$getExpandedRows = module.exports.getExpandedRows = function getExpandedRows(data, keyField, expanded) {
    return expanded.map(function(k) {
        return (0, $atKpa.getRowByRowId)(data, keyField, k);
    });
};

});

parcelRegister("dzTqi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.editCell = undefined;

var $dQ68B = parcelRequire("dQ68B");
var $9e298924334dfc79$var$_utils2 = $9e298924334dfc79$var$_interopRequireDefault($dQ68B);

var $atKpa = parcelRequire("atKpa");
function $9e298924334dfc79$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $9e298924334dfc79$var$editCell = module.exports.editCell = function editCell(data, keyField, rowId, dataField, newValue) {
    var row = (0, $atKpa.getRowByRowId)(data, keyField, rowId);
    if (row) $9e298924334dfc79$var$_utils2.default.set(row, dataField, newValue);
};

});

parcelRegister("ehJyP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.nextOrder = module.exports.sort = undefined;

var $dQ68B = parcelRequire("dQ68B");
var $a665fe9e4198ad88$var$_utils2 = $a665fe9e4198ad88$var$_interopRequireDefault($dQ68B);

var $jVgbO = parcelRequire("jVgbO");
var $a665fe9e4198ad88$var$_const2 = $a665fe9e4198ad88$var$_interopRequireDefault($jVgbO);
function $a665fe9e4198ad88$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a665fe9e4198ad88$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
} /* eslint no-nested-ternary: 0 */ 
/* eslint no-lonely-if: 0 */ /* eslint no-underscore-dangle: 0 */ function $a665fe9e4198ad88$var$comparator(a, b) {
    var result = void 0;
    if (typeof b === "string") result = b.localeCompare(a);
    else result = a > b ? -1 : a < b ? 1 : 0;
    return result;
}
var $a665fe9e4198ad88$var$sort = module.exports.sort = function sort(data, sortOrder, _ref) {
    var dataField = _ref.dataField, sortFunc = _ref.sortFunc, sortValue = _ref.sortValue;
    var _data = [].concat($a665fe9e4198ad88$var$_toConsumableArray(data));
    _data.sort(function(a, b) {
        var result = void 0;
        var valueA = $a665fe9e4198ad88$var$_utils2.default.get(a, dataField);
        var valueB = $a665fe9e4198ad88$var$_utils2.default.get(b, dataField);
        if (sortValue) {
            valueA = sortValue(valueA, a);
            valueB = sortValue(valueB, b);
        } else {
            valueA = $a665fe9e4198ad88$var$_utils2.default.isDefined(valueA) ? valueA : "";
            valueB = $a665fe9e4198ad88$var$_utils2.default.isDefined(valueB) ? valueB : "";
        }
        if (sortFunc) result = sortFunc(valueA, valueB, sortOrder, dataField, a, b);
        else if (sortOrder === $a665fe9e4198ad88$var$_const2.default.SORT_DESC) result = $a665fe9e4198ad88$var$comparator(valueA, valueB);
        else result = $a665fe9e4198ad88$var$comparator(valueB, valueA);
        return result;
    });
    return _data;
};
var $a665fe9e4198ad88$var$nextOrder = module.exports.nextOrder = function nextOrder(currentSortColumn, _ref2) {
    var sortOrder = _ref2.sortOrder, sortColumn = _ref2.sortColumn;
    var defaultOrder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $a665fe9e4198ad88$var$_const2.default.SORT_DESC;
    if (!sortColumn || currentSortColumn.dataField !== sortColumn.dataField) return defaultOrder;
    return sortOrder === $a665fe9e4198ad88$var$_const2.default.SORT_DESC ? $a665fe9e4198ad88$var$_const2.default.SORT_ASC : $a665fe9e4198ad88$var$_const2.default.SORT_DESC;
};

});

parcelRegister("ft31c", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.typeConvert = undefined;

var $jVgbO = parcelRequire("jVgbO");
var $b42be7d1acef5e01$var$_const2 = $b42be7d1acef5e01$var$_interopRequireDefault($jVgbO);
function $b42be7d1acef5e01$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $b42be7d1acef5e01$var$typeConvert = module.exports.typeConvert = function typeConvert(type, value) {
    if (type === $b42be7d1acef5e01$var$_const2.default.TYPE_STRING) return String(value);
    else if (type === $b42be7d1acef5e01$var$_const2.default.TYPE_NUMBER) return Number(value);
    else if (type === $b42be7d1acef5e01$var$_const2.default.TYPE_BOOLEAN) {
        if (typeof value === "boolean") return value;
        return value === "true";
    } else if (type === $b42be7d1acef5e01$var$_const2.default.TYPE_DATE) return new Date(value);
    return value;
};

});




parcelRegister("etBWR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $acw62 = parcelRequire("acw62");
var $a8a135dfde17ab9a$var$_react2 = $a8a135dfde17ab9a$var$_interopRequireDefault($acw62);

var $3qp3X = parcelRequire("3qp3X");
var $a8a135dfde17ab9a$var$_rowExpandContext2 = $a8a135dfde17ab9a$var$_interopRequireDefault($3qp3X);
function $a8a135dfde17ab9a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.default = function(Component) {
    return function() {
        return $a8a135dfde17ab9a$var$_react2.default.createElement($a8a135dfde17ab9a$var$_rowExpandContext2.default.Consumer, null, function(expandRow) {
            return $a8a135dfde17ab9a$var$_react2.default.createElement(Component, expandRow);
        });
    };
};

});
parcelRegister("3qp3X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $27e73dbdbca430a9$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $27e73dbdbca430a9$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $27e73dbdbca430a9$var$_react2 = $27e73dbdbca430a9$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");
var $27e73dbdbca430a9$var$_propTypes2 = $27e73dbdbca430a9$var$_interopRequireDefault($c9Z8w);

var $ijh0r = parcelRequire("ijh0r");
var $27e73dbdbca430a9$var$_operators2 = $27e73dbdbca430a9$var$_interopRequireDefault($ijh0r);

var $dQ68B = parcelRequire("dQ68B");
var $27e73dbdbca430a9$var$_utils2 = $27e73dbdbca430a9$var$_interopRequireDefault($dQ68B);
function $27e73dbdbca430a9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $27e73dbdbca430a9$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
function $27e73dbdbca430a9$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $27e73dbdbca430a9$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $27e73dbdbca430a9$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint camelcase: 0 */ 
/* eslint react/prop-types: 0 */ var $27e73dbdbca430a9$var$RowExpandContext = $27e73dbdbca430a9$var$_react2.default.createContext();
var $27e73dbdbca430a9$var$RowExpandProvider = function(_React$Component) {
    $27e73dbdbca430a9$var$_inherits(RowExpandProvider, _React$Component);
    function RowExpandProvider() {
        var _ref;
        var _temp, _this, _ret;
        $27e73dbdbca430a9$var$_classCallCheck(this, RowExpandProvider);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $27e73dbdbca430a9$var$_possibleConstructorReturn(this, (_ref = RowExpandProvider.__proto__ || Object.getPrototypeOf(RowExpandProvider)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.state = {
            expanded: _this.props.expandRow.expanded || [],
            isClosing: _this.props.expandRow.isClosing || []
        }, _this.onClosed = function(closedRow) {
            _this.setState({
                isClosing: _this.state.isClosing.filter(function(value) {
                    return value !== closedRow;
                })
            });
        }, _this.handleRowExpand = function(rowKey, expanded, rowIndex, e) {
            var _this$props = _this.props, data = _this$props.data, keyField = _this$props.keyField, _this$props$expandRow = _this$props.expandRow, onExpand = _this$props$expandRow.onExpand, onlyOneExpanding = _this$props$expandRow.onlyOneExpanding, nonExpandable = _this$props$expandRow.nonExpandable;
            if (nonExpandable && $27e73dbdbca430a9$var$_utils2.default.contains(nonExpandable, rowKey)) return;
            var currExpanded = [].concat($27e73dbdbca430a9$var$_toConsumableArray(_this.state.expanded));
            var isClosing = [].concat($27e73dbdbca430a9$var$_toConsumableArray(_this.state.isClosing));
            if (expanded) {
                if (onlyOneExpanding) {
                    isClosing = isClosing.concat(currExpanded);
                    currExpanded = [
                        rowKey
                    ];
                } else currExpanded.push(rowKey);
            } else {
                isClosing.push(rowKey);
                currExpanded = currExpanded.filter(function(value) {
                    return value !== rowKey;
                });
            }
            if (onExpand) {
                var row = $27e73dbdbca430a9$var$_operators2.default.getRowByRowId(data, keyField, rowKey);
                onExpand(row, expanded, rowIndex, e);
            }
            _this.setState(function() {
                return {
                    expanded: currExpanded,
                    isClosing: isClosing
                };
            });
        }, _this.handleAllRowExpand = function(e, expandAll) {
            var _this$props2 = _this.props, data = _this$props2.data, keyField = _this$props2.keyField, _this$props2$expandRo = _this$props2.expandRow, onExpandAll = _this$props2$expandRo.onExpandAll, nonExpandable = _this$props2$expandRo.nonExpandable;
            var expanded = _this.state.expanded;
            var currExpanded = void 0;
            if (expandAll) currExpanded = expanded.concat($27e73dbdbca430a9$var$_operators2.default.expandableKeys(data, keyField, nonExpandable));
            else currExpanded = expanded.filter(function(s) {
                return typeof data.find(function(d) {
                    return $27e73dbdbca430a9$var$_utils2.default.get(d, keyField) === s;
                }) === "undefined";
            });
            if (onExpandAll) onExpandAll(expandAll, $27e73dbdbca430a9$var$_operators2.default.getExpandedRows(data, keyField, currExpanded), e);
            _this.setState(function() {
                return {
                    expanded: currExpanded
                };
            });
        }, _temp), $27e73dbdbca430a9$var$_possibleConstructorReturn(_this, _ret);
    }
    $27e73dbdbca430a9$var$_createClass(RowExpandProvider, [
        {
            key: "UNSAFE_componentWillReceiveProps",
            value: function UNSAFE_componentWillReceiveProps(nextProps) {
                var _this2 = this;
                if (nextProps.expandRow) {
                    var nextExpanded = [].concat($27e73dbdbca430a9$var$_toConsumableArray(nextProps.expandRow.expanded || this.state.expanded));
                    var _nextProps$expandRow$ = nextProps.expandRow.nonExpandable, nonExpandable = _nextProps$expandRow$ === undefined ? [] : _nextProps$expandRow$;
                    nextExpanded = nextExpanded.filter(function(rowId) {
                        return !$27e73dbdbca430a9$var$_utils2.default.contains(nonExpandable, rowId);
                    });
                    var isClosing = this.state.expanded.reduce(function(acc, cur) {
                        if (!$27e73dbdbca430a9$var$_utils2.default.contains(nextExpanded, cur)) acc.push(cur);
                        return acc;
                    }, []);
                    this.setState(function() {
                        return {
                            expanded: nextExpanded,
                            isClosing: isClosing
                        };
                    });
                } else this.setState(function() {
                    return {
                        expanded: _this2.state.expanded
                    };
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, data = _props.data, keyField = _props.keyField;
                return $27e73dbdbca430a9$var$_react2.default.createElement($27e73dbdbca430a9$var$RowExpandContext.Provider, {
                    value: $27e73dbdbca430a9$var$_extends({}, this.props.expandRow, {
                        nonExpandable: this.props.expandRow.nonExpandable,
                        expanded: this.state.expanded,
                        isClosing: this.state.isClosing,
                        onClosed: this.onClosed,
                        isAnyExpands: $27e73dbdbca430a9$var$_operators2.default.isAnyExpands(data, keyField, this.state.expanded),
                        onRowExpand: this.handleRowExpand,
                        onAllRowExpand: this.handleAllRowExpand
                    })
                }, this.props.children);
            }
        }
    ]);
    return RowExpandProvider;
}($27e73dbdbca430a9$var$_react2.default.Component);
$27e73dbdbca430a9$var$RowExpandProvider.propTypes = {
    children: $27e73dbdbca430a9$var$_propTypes2.default.node.isRequired,
    data: $27e73dbdbca430a9$var$_propTypes2.default.array.isRequired,
    keyField: $27e73dbdbca430a9$var$_propTypes2.default.string.isRequired
};
module.exports.default = {
    Provider: $27e73dbdbca430a9$var$RowExpandProvider,
    Consumer: $27e73dbdbca430a9$var$RowExpandContext.Consumer
};

});



parcelRegister("gXQHT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $acw62 = parcelRequire("acw62");
var $032feb86451bca1a$var$_react2 = $032feb86451bca1a$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");
var $032feb86451bca1a$var$_propTypes2 = $032feb86451bca1a$var$_interopRequireDefault($c9Z8w);

var $lXL64 = parcelRequire("lXL64");
var $032feb86451bca1a$var$_filtersCell2 = $032feb86451bca1a$var$_interopRequireDefault($lXL64);

var $jVgbO = parcelRequire("jVgbO");
var $032feb86451bca1a$var$_const2 = $032feb86451bca1a$var$_interopRequireDefault($jVgbO);

var $kXTgC = parcelRequire("kXTgC");
var $032feb86451bca1a$var$_rowTemplate2 = $032feb86451bca1a$var$_interopRequireDefault($kXTgC);
function $032feb86451bca1a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $032feb86451bca1a$var$Filters = function Filters(props) {
    var columns = props.columns, onFilter = props.onFilter, currFilters = props.currFilters, filterPosition = props.filterPosition, onExternalFilter = props.onExternalFilter, className = props.className, selectRow = props.selectRow, expandRow = props.expandRow;
    function renderContent() {
        var filterColumns = [];
        var showFiltersRow = false;
        columns.forEach(function(column, i) {
            filterColumns.push($032feb86451bca1a$var$_react2.default.createElement($032feb86451bca1a$var$_filtersCell2.default, {
                index: i,
                key: column.dataField,
                column: column,
                currFilters: currFilters,
                onExternalFilter: onExternalFilter,
                onFilter: onFilter
            }));
            if (column.filterRenderer || column.filter) {
                if (!showFiltersRow) showFiltersRow = true;
            }
        });
        return filterColumns;
    }
    return $032feb86451bca1a$var$_react2.default.createElement("tbody", {
        className: className,
        style: {
            display: filterPosition === $032feb86451bca1a$var$_const2.default.FILTERS_POSITION_TOP ? "table-header-group" : "table-footer-group"
        }
    }, $032feb86451bca1a$var$_react2.default.createElement($032feb86451bca1a$var$_rowTemplate2.default, {
        renderContent: renderContent,
        selectRow: selectRow,
        expandRow: expandRow,
        cellEl: "td"
    }));
}; /* eslint react/require-default-props: 0 */ 
$032feb86451bca1a$var$Filters.propTypes = {
    columns: $032feb86451bca1a$var$_propTypes2.default.array.isRequired,
    onFilter: $032feb86451bca1a$var$_propTypes2.default.func,
    filterPosition: $032feb86451bca1a$var$_propTypes2.default.oneOf([
        $032feb86451bca1a$var$_const2.default.FILTERS_POSITION_TOP,
        $032feb86451bca1a$var$_const2.default.FILTERS_POSITION_INLINE,
        $032feb86451bca1a$var$_const2.default.FILTERS_POSITION_BOTTOM
    ]),
    currFilters: $032feb86451bca1a$var$_propTypes2.default.object,
    onExternalFilter: $032feb86451bca1a$var$_propTypes2.default.func,
    className: $032feb86451bca1a$var$_propTypes2.default.string,
    selectRow: $032feb86451bca1a$var$_propTypes2.default.object,
    expandRow: $032feb86451bca1a$var$_propTypes2.default.object
};
$032feb86451bca1a$var$Filters.defaultProps = {
    position: $032feb86451bca1a$var$_const2.default.FILTERS_POSITION_TOP
};
module.exports.default = $032feb86451bca1a$var$Filters;

});
parcelRegister("lXL64", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $ffd3a41fb9df8f08$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $acw62 = parcelRequire("acw62");
var $ffd3a41fb9df8f08$var$_react2 = $ffd3a41fb9df8f08$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");
var $ffd3a41fb9df8f08$var$_propTypes2 = $ffd3a41fb9df8f08$var$_interopRequireDefault($c9Z8w);

var $dQ68B = parcelRequire("dQ68B");
var $ffd3a41fb9df8f08$var$_utils2 = $ffd3a41fb9df8f08$var$_interopRequireDefault($dQ68B);
function $ffd3a41fb9df8f08$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $ffd3a41fb9df8f08$var$FiltersCell = function FiltersCell(props) {
    var index = props.index, column = props.column, onExternalFilter = props.onExternalFilter, currFilters = props.currFilters, onFilter = props.onFilter;
    var filterRenderer = column.filterRenderer, filter = column.filter;
    var filterElm = void 0;
    var cellAttrs = {};
    var cellStyle = {};
    cellAttrs.style = cellStyle;
    if (column.headerAlign) cellStyle.textAlign = $ffd3a41fb9df8f08$var$_utils2.default.isFunction(column.headerAlign) ? column.headerAlign(column, index) : column.headerAlign;
    if (column.filterRenderer) {
        var onCustomFilter = onExternalFilter(column, filter.props.type);
        filterElm = filterRenderer(onCustomFilter, column);
    } else if (filter) filterElm = $ffd3a41fb9df8f08$var$_react2.default.createElement(filter.Filter, $ffd3a41fb9df8f08$var$_extends({}, filter.props, {
        filterState: currFilters[column.dataField],
        onFilter: onFilter,
        column: column
    }));
    return $ffd3a41fb9df8f08$var$_react2.default.createElement("th", cellAttrs, filterElm);
};
$ffd3a41fb9df8f08$var$FiltersCell.propTypes = {
    index: $ffd3a41fb9df8f08$var$_propTypes2.default.number.isRequired,
    column: $ffd3a41fb9df8f08$var$_propTypes2.default.object.isRequired,
    currFilters: $ffd3a41fb9df8f08$var$_propTypes2.default.object.isRequired,
    onFilter: $ffd3a41fb9df8f08$var$_propTypes2.default.func,
    onExternalFilter: $ffd3a41fb9df8f08$var$_propTypes2.default.func
};
$ffd3a41fb9df8f08$var$FiltersCell.defaultProps = {
    onFilter: function onFilter() {},
    onExternalFilter: function onExternalFilter() {}
};
module.exports.default = $ffd3a41fb9df8f08$var$FiltersCell;

});

parcelRegister("kXTgC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $acw62 = parcelRequire("acw62");
var $f434303ca06af0f9$var$_react2 = $f434303ca06af0f9$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");
var $f434303ca06af0f9$var$_propTypes2 = $f434303ca06af0f9$var$_interopRequireDefault($c9Z8w);

var $jVgbO = parcelRequire("jVgbO");
var $f434303ca06af0f9$var$_const2 = $f434303ca06af0f9$var$_interopRequireDefault($jVgbO);
function $f434303ca06af0f9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f434303ca06af0f9$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
} /* eslint react/require-default-props: 0 */ 
var $f434303ca06af0f9$var$RowTemplate = function RowTemplate(props) {
    var renderContent = props.renderContent, selectRow = props.selectRow, expandRow = props.expandRow, cellEl = props.cellEl, rest = $f434303ca06af0f9$var$_objectWithoutProperties(props, [
        "renderContent",
        "selectRow",
        "expandRow",
        "cellEl"
    ]);
    var isRenderFunctionColumnInLeft = function isRenderFunctionColumnInLeft() {
        var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $f434303ca06af0f9$var$_const2.default.INDICATOR_POSITION_LEFT;
        return position === $f434303ca06af0f9$var$_const2.default.INDICATOR_POSITION_LEFT;
    };
    var childrens = renderContent() || [];
    if (selectRow && selectRow.hideSelectColumn !== true) {
        if (isRenderFunctionColumnInLeft(selectRow.selectColumnPosition)) childrens.unshift($f434303ca06af0f9$var$_react2.default.createElement(cellEl, {
            key: "selection"
        }));
        else childrens.push($f434303ca06af0f9$var$_react2.default.createElement(cellEl, {
            key: "selection"
        }));
    }
    if (expandRow.showExpandColumn) {
        if (isRenderFunctionColumnInLeft(expandRow.expandColumnPosition)) childrens.unshift($f434303ca06af0f9$var$_react2.default.createElement(cellEl, {
            key: "expansion"
        }));
        else childrens.push($f434303ca06af0f9$var$_react2.default.createElement(cellEl, {
            key: "expansion"
        }));
    }
    return $f434303ca06af0f9$var$_react2.default.createElement("tr", rest, childrens);
};
$f434303ca06af0f9$var$RowTemplate.propTypes = {
    renderContent: $f434303ca06af0f9$var$_propTypes2.default.func.isRequired,
    cellEl: $f434303ca06af0f9$var$_propTypes2.default.string.isRequired,
    selectRow: $f434303ca06af0f9$var$_propTypes2.default.object,
    expandRow: $f434303ca06af0f9$var$_propTypes2.default.object
};
module.exports.default = $f434303ca06af0f9$var$RowTemplate;

});


parcelRegister("2B8Xk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $acw62 = parcelRequire("acw62");
var $1e45fbed2571127d$var$_react2 = $1e45fbed2571127d$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");
var $1e45fbed2571127d$var$_propTypes2 = $1e45fbed2571127d$var$_interopRequireDefault($c9Z8w);
function $1e45fbed2571127d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/* eslint react/require-default-props: 0 */ var $1e45fbed2571127d$var$Caption = function Caption(props) {
    if (!props.children) return null;
    var caption = props.bootstrap4 ? $1e45fbed2571127d$var$_react2.default.createElement("caption", {
        style: {
            captionSide: "top"
        }
    }, props.children) : $1e45fbed2571127d$var$_react2.default.createElement("caption", null, props.children);
    return caption;
};
$1e45fbed2571127d$var$Caption.propTypes = {
    children: $1e45fbed2571127d$var$_propTypes2.default.oneOfType([
        $1e45fbed2571127d$var$_propTypes2.default.node,
        $1e45fbed2571127d$var$_propTypes2.default.string
    ]),
    bootstrap4: $1e45fbed2571127d$var$_propTypes2.default.bool
};
module.exports.default = $1e45fbed2571127d$var$Caption;

});

parcelRegister("37VUd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $246ef16eac60f4d1$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $246ef16eac60f4d1$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $246ef16eac60f4d1$var$_react2 = $246ef16eac60f4d1$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");
var $246ef16eac60f4d1$var$_propTypes2 = $246ef16eac60f4d1$var$_interopRequireDefault($c9Z8w);

var $dQ68B = parcelRequire("dQ68B");
var $246ef16eac60f4d1$var$_utils2 = $246ef16eac60f4d1$var$_interopRequireDefault($dQ68B);

var $8xRXi = parcelRequire("8xRXi");
var $246ef16eac60f4d1$var$_simpleRow2 = $246ef16eac60f4d1$var$_interopRequireDefault($8xRXi);

var $k0kaM = parcelRequire("k0kaM");
var $246ef16eac60f4d1$var$_aggregateRow2 = $246ef16eac60f4d1$var$_interopRequireDefault($k0kaM);

var $cKmRl = parcelRequire("cKmRl");
var $246ef16eac60f4d1$var$_rowSection2 = $246ef16eac60f4d1$var$_interopRequireDefault($cKmRl);

var $jVgbO = parcelRequire("jVgbO");
var $246ef16eac60f4d1$var$_const2 = $246ef16eac60f4d1$var$_interopRequireDefault($jVgbO);

var $kcR9T = parcelRequire("kcR9T");
var $246ef16eac60f4d1$var$_rowConsumer2 = $246ef16eac60f4d1$var$_interopRequireDefault($kcR9T);

var $gOk9e = parcelRequire("gOk9e");
var $246ef16eac60f4d1$var$_rowConsumer4 = $246ef16eac60f4d1$var$_interopRequireDefault($gOk9e);
function $246ef16eac60f4d1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $246ef16eac60f4d1$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $246ef16eac60f4d1$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $246ef16eac60f4d1$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint react/prop-types: 0 */ 
/* eslint react/require-default-props: 0 */ var $246ef16eac60f4d1$var$Body = function(_React$Component) {
    $246ef16eac60f4d1$var$_inherits(Body, _React$Component);
    function Body(props) {
        $246ef16eac60f4d1$var$_classCallCheck(this, Body);
        var _this = $246ef16eac60f4d1$var$_possibleConstructorReturn(this, (Body.__proto__ || Object.getPrototypeOf(Body)).call(this, props));
        var keyField = props.keyField, cellEdit = props.cellEdit, selectRow = props.selectRow, expandRow = props.expandRow;
        // Construct Editing Cell Component
        if (cellEdit.createContext) _this.EditingCell = cellEdit.createEditingCell($246ef16eac60f4d1$var$_utils2.default, cellEdit.options.onStartEdit);
        // Construct Row Component
        var RowComponent = $246ef16eac60f4d1$var$_simpleRow2.default;
        var selectRowEnabled = selectRow.mode !== $246ef16eac60f4d1$var$_const2.default.ROW_SELECT_DISABLED;
        var expandRowEnabled = !!expandRow.renderer;
        if (expandRowEnabled) RowComponent = (0, $246ef16eac60f4d1$var$_rowConsumer4.default)($246ef16eac60f4d1$var$_aggregateRow2.default);
        if (selectRowEnabled) RowComponent = (0, $246ef16eac60f4d1$var$_rowConsumer2.default)(expandRowEnabled ? RowComponent : $246ef16eac60f4d1$var$_aggregateRow2.default);
        if (cellEdit.createContext) RowComponent = cellEdit.withRowLevelCellEdit(RowComponent, selectRowEnabled, keyField, $246ef16eac60f4d1$var$_utils2.default);
        _this.RowComponent = RowComponent;
        return _this;
    }
    $246ef16eac60f4d1$var$_createClass(Body, [
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _props = this.props, columns = _props.columns, data = _props.data, tabIndexCell = _props.tabIndexCell, keyField = _props.keyField, isEmpty = _props.isEmpty, noDataIndication = _props.noDataIndication, visibleColumnSize = _props.visibleColumnSize, cellEdit = _props.cellEdit, selectRow = _props.selectRow, rowStyle = _props.rowStyle, rowClasses = _props.rowClasses, rowEvents = _props.rowEvents, expandRow = _props.expandRow, className = _props.className;
                var content = void 0;
                if (isEmpty) {
                    var indication = $246ef16eac60f4d1$var$_utils2.default.isFunction(noDataIndication) ? noDataIndication() : noDataIndication;
                    if (!indication) return null;
                    content = $246ef16eac60f4d1$var$_react2.default.createElement($246ef16eac60f4d1$var$_rowSection2.default, {
                        content: indication,
                        colSpan: visibleColumnSize
                    });
                } else {
                    var selectRowEnabled = selectRow.mode !== $246ef16eac60f4d1$var$_const2.default.ROW_SELECT_DISABLED;
                    var expandRowEnabled = !!expandRow.renderer;
                    var additionalRowProps = {};
                    if (cellEdit.createContext) additionalRowProps.EditingCellComponent = this.EditingCell;
                    if (selectRowEnabled || expandRowEnabled) {
                        additionalRowProps.expandRow = expandRow;
                        additionalRowProps.selectRow = selectRow;
                    }
                    content = data.map(function(row, index) {
                        var key = $246ef16eac60f4d1$var$_utils2.default.get(row, keyField);
                        var baseRowProps = $246ef16eac60f4d1$var$_extends({
                            key: key,
                            row: row,
                            tabIndexCell: tabIndexCell,
                            columns: columns,
                            keyField: keyField,
                            cellEdit: cellEdit,
                            value: key,
                            rowIndex: index,
                            visibleColumnSize: visibleColumnSize,
                            attrs: rowEvents || {}
                        }, additionalRowProps);
                        baseRowProps.style = $246ef16eac60f4d1$var$_utils2.default.isFunction(rowStyle) ? rowStyle(row, index) : rowStyle;
                        baseRowProps.className = $246ef16eac60f4d1$var$_utils2.default.isFunction(rowClasses) ? rowClasses(row, index) : rowClasses;
                        return $246ef16eac60f4d1$var$_react2.default.createElement(_this2.RowComponent, baseRowProps);
                    });
                }
                return $246ef16eac60f4d1$var$_react2.default.createElement("tbody", {
                    className: className
                }, content);
            }
        }
    ]);
    return Body;
}($246ef16eac60f4d1$var$_react2.default.Component);
$246ef16eac60f4d1$var$Body.propTypes = {
    keyField: $246ef16eac60f4d1$var$_propTypes2.default.string.isRequired,
    data: $246ef16eac60f4d1$var$_propTypes2.default.array.isRequired,
    columns: $246ef16eac60f4d1$var$_propTypes2.default.array.isRequired,
    selectRow: $246ef16eac60f4d1$var$_propTypes2.default.object
};
module.exports.default = $246ef16eac60f4d1$var$Body;

});
parcelRegister("8xRXi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $638b4238ced82f2b$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $638b4238ced82f2b$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $638b4238ced82f2b$var$_react2 = $638b4238ced82f2b$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");
var $638b4238ced82f2b$var$_propTypes2 = $638b4238ced82f2b$var$_interopRequireDefault($c9Z8w);

var $37FUg = parcelRequire("37FUg");
var $638b4238ced82f2b$var$_rowPureContent2 = $638b4238ced82f2b$var$_interopRequireDefault($37FUg);

var $bKShc = parcelRequire("bKShc");
var $638b4238ced82f2b$var$_eventDelegater2 = $638b4238ced82f2b$var$_interopRequireDefault($bKShc);

var $66H2y = parcelRequire("66H2y");
var $638b4238ced82f2b$var$_shouldUpdater3 = $638b4238ced82f2b$var$_interopRequireDefault($66H2y);
function $638b4238ced82f2b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $638b4238ced82f2b$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $638b4238ced82f2b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $638b4238ced82f2b$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $638b4238ced82f2b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint react/prop-types: 0 */ 
/* eslint react/no-array-index-key: 0 */ var $638b4238ced82f2b$var$SimpleRow = function(_shouldUpdater) {
    $638b4238ced82f2b$var$_inherits(SimpleRow, _shouldUpdater);
    function SimpleRow(props) {
        $638b4238ced82f2b$var$_classCallCheck(this, SimpleRow);
        var _this = $638b4238ced82f2b$var$_possibleConstructorReturn(this, (SimpleRow.__proto__ || Object.getPrototypeOf(SimpleRow)).call(this, props));
        _this.shouldUpdateRowContent = false;
        return _this;
    }
    $638b4238ced82f2b$var$_createClass(SimpleRow, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                this.shouldUpdateRowContent = false;
                this.shouldUpdateRowContent = this.shouldRowContentUpdate(nextProps);
                if (this.shouldUpdateRowContent) return true;
                return this.shouldUpdatedBySelfProps(nextProps);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, className = _props.className, style = _props.style, attrs = _props.attrs, visibleColumnSize = _props.visibleColumnSize, tabIndexCell = _props.tabIndexCell, rest = $638b4238ced82f2b$var$_objectWithoutProperties(_props, [
                    "className",
                    "style",
                    "attrs",
                    "visibleColumnSize",
                    "tabIndexCell"
                ]);
                var trAttrs = this.delegate(attrs);
                var tabIndexStart = this.props.rowIndex * visibleColumnSize + 1;
                return $638b4238ced82f2b$var$_react2.default.createElement("tr", $638b4238ced82f2b$var$_extends({
                    style: style,
                    className: className
                }, trAttrs), $638b4238ced82f2b$var$_react2.default.createElement($638b4238ced82f2b$var$_rowPureContent2.default, $638b4238ced82f2b$var$_extends({
                    shouldUpdate: this.shouldUpdateRowContent,
                    tabIndexStart: tabIndexCell ? tabIndexStart : -1
                }, rest)));
            }
        }
    ]);
    return SimpleRow;
}((0, $638b4238ced82f2b$var$_shouldUpdater3.default)((0, $638b4238ced82f2b$var$_eventDelegater2.default)($acw62.Component)));
$638b4238ced82f2b$var$SimpleRow.propTypes = {
    row: $638b4238ced82f2b$var$_propTypes2.default.object.isRequired,
    rowIndex: $638b4238ced82f2b$var$_propTypes2.default.number.isRequired,
    columns: $638b4238ced82f2b$var$_propTypes2.default.array.isRequired,
    style: $638b4238ced82f2b$var$_propTypes2.default.object,
    className: $638b4238ced82f2b$var$_propTypes2.default.string,
    attrs: $638b4238ced82f2b$var$_propTypes2.default.object
};
$638b4238ced82f2b$var$SimpleRow.defaultProps = {
    editable: true,
    style: {},
    className: null,
    attrs: {}
};
module.exports.default = $638b4238ced82f2b$var$SimpleRow;

});
parcelRegister("37FUg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $24628852bda5ac1d$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $24628852bda5ac1d$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $24628852bda5ac1d$var$_react2 = $24628852bda5ac1d$var$_interopRequireDefault($acw62);

var $dQ68B = parcelRequire("dQ68B");
var $24628852bda5ac1d$var$_utils2 = $24628852bda5ac1d$var$_interopRequireDefault($dQ68B);

var $kGW8i = parcelRequire("kGW8i");
var $24628852bda5ac1d$var$_cell2 = $24628852bda5ac1d$var$_interopRequireDefault($kGW8i);
function $24628852bda5ac1d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $24628852bda5ac1d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $24628852bda5ac1d$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $24628852bda5ac1d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint react/prop-types: 0 */ 
/* eslint react/no-array-index-key: 0 */ /* eslint no-plusplus: 0 */ var $24628852bda5ac1d$var$RowPureContent = function(_React$Component) {
    $24628852bda5ac1d$var$_inherits(RowPureContent, _React$Component);
    function RowPureContent() {
        $24628852bda5ac1d$var$_classCallCheck(this, RowPureContent);
        return $24628852bda5ac1d$var$_possibleConstructorReturn(this, (RowPureContent.__proto__ || Object.getPrototypeOf(RowPureContent)).apply(this, arguments));
    }
    $24628852bda5ac1d$var$_createClass(RowPureContent, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                if (typeof nextProps.shouldUpdate !== "undefined") return nextProps.shouldUpdate;
                return true;
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, row = _props.row, keyField = _props.keyField, columns = _props.columns, rowIndex = _props.rowIndex, editable = _props.editable, editingRowIdx = _props.editingRowIdx, editingColIdx = _props.editingColIdx, onStart = _props.onStart, clickToEdit = _props.clickToEdit, dbclickToEdit = _props.dbclickToEdit, EditingCellComponent = _props.EditingCellComponent, tabIndexStart = _props.tabIndexStart;
                var tabIndex = tabIndexStart;
                return columns.map(function(column, index) {
                    var dataField = column.dataField;
                    var content = $24628852bda5ac1d$var$_utils2.default.get(row, dataField);
                    if (rowIndex === editingRowIdx && index === editingColIdx) return $24628852bda5ac1d$var$_react2.default.createElement(EditingCellComponent, {
                        key: content + "-" + index + "-editing",
                        row: row,
                        rowIndex: rowIndex,
                        column: column,
                        columnIndex: index
                    });
                    // render cell
                    var cellTitle = void 0;
                    var cellStyle = {};
                    var cellAttrs = $24628852bda5ac1d$var$_extends({}, $24628852bda5ac1d$var$_utils2.default.isFunction(column.attrs) ? column.attrs(content, row, rowIndex, index) : column.attrs);
                    if (column.events) {
                        var events = Object.assign({}, column.events);
                        Object.keys(Object.assign({}, column.events)).forEach(function(key) {
                            var originFn = events[key];
                            events[key] = function() {
                                for(var _len = arguments.length, rest = Array(_len), _key = 0; _key < _len; _key++)rest[_key] = arguments[_key];
                                return originFn.apply(undefined, rest.concat([
                                    row,
                                    rowIndex
                                ]));
                            };
                        });
                        cellAttrs = $24628852bda5ac1d$var$_extends({}, cellAttrs, events);
                    }
                    var cellClasses = $24628852bda5ac1d$var$_utils2.default.isFunction(column.classes) ? column.classes(content, row, rowIndex, index) : column.classes;
                    if (column.style) {
                        cellStyle = $24628852bda5ac1d$var$_utils2.default.isFunction(column.style) ? column.style(content, row, rowIndex, index) : column.style;
                        cellStyle = Object.assign({}, cellStyle) || {};
                    }
                    if (column.title) {
                        cellTitle = $24628852bda5ac1d$var$_utils2.default.isFunction(column.title) ? column.title(content, row, rowIndex, index) : content;
                        cellAttrs.title = cellTitle;
                    }
                    if (column.align) cellStyle.textAlign = $24628852bda5ac1d$var$_utils2.default.isFunction(column.align) ? column.align(content, row, rowIndex, index) : column.align;
                    if (cellClasses) cellAttrs.className = cellClasses;
                    if (!$24628852bda5ac1d$var$_utils2.default.isEmptyObject(cellStyle)) cellAttrs.style = cellStyle;
                    var editableCell = $24628852bda5ac1d$var$_utils2.default.isDefined(column.editable) ? column.editable : true;
                    if (column.dataField === keyField || !editable) editableCell = false;
                    if ($24628852bda5ac1d$var$_utils2.default.isFunction(column.editable)) editableCell = column.editable(content, row, rowIndex, index);
                    if (tabIndexStart !== -1) cellAttrs.tabIndex = tabIndex++;
                    return $24628852bda5ac1d$var$_react2.default.createElement($24628852bda5ac1d$var$_cell2.default, $24628852bda5ac1d$var$_extends({
                        key: content + "-" + index,
                        row: row,
                        editable: editableCell,
                        rowIndex: rowIndex,
                        columnIndex: index,
                        column: column,
                        onStart: onStart,
                        clickToEdit: clickToEdit,
                        dbclickToEdit: dbclickToEdit
                    }, cellAttrs));
                });
            }
        }
    ]);
    return RowPureContent;
}($24628852bda5ac1d$var$_react2.default.Component);
module.exports.default = $24628852bda5ac1d$var$RowPureContent;

});
parcelRegister("kGW8i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $f104d2d580867b68$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $f104d2d580867b68$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $f104d2d580867b68$var$_react2 = $f104d2d580867b68$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");
var $f104d2d580867b68$var$_propTypes2 = $f104d2d580867b68$var$_interopRequireDefault($c9Z8w);

var $5a2kX = parcelRequire("5a2kX");
var $f104d2d580867b68$var$_cellEventDelegater2 = $f104d2d580867b68$var$_interopRequireDefault($5a2kX);

var $dQ68B = parcelRequire("dQ68B");
var $f104d2d580867b68$var$_utils2 = $f104d2d580867b68$var$_interopRequireDefault($dQ68B);
function $f104d2d580867b68$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f104d2d580867b68$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $f104d2d580867b68$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f104d2d580867b68$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $f104d2d580867b68$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint react/prop-types: 0 */ 
var $f104d2d580867b68$var$Cell = function(_eventDelegater) {
    $f104d2d580867b68$var$_inherits(Cell, _eventDelegater);
    function Cell(props) {
        $f104d2d580867b68$var$_classCallCheck(this, Cell);
        var _this = $f104d2d580867b68$var$_possibleConstructorReturn(this, (Cell.__proto__ || Object.getPrototypeOf(Cell)).call(this, props));
        _this.createHandleEditingCell = function(originFunc) {
            return function(e) {
                var _this$props = _this.props, onStart = _this$props.onStart, rowIndex = _this$props.rowIndex, columnIndex = _this$props.columnIndex, clickToEdit = _this$props.clickToEdit, dbclickToEdit = _this$props.dbclickToEdit;
                if ((clickToEdit || dbclickToEdit) && $f104d2d580867b68$var$_utils2.default.isFunction(originFunc)) originFunc(e);
                if (onStart) onStart(rowIndex, columnIndex);
            };
        };
        _this.createHandleEditingCell = _this.createHandleEditingCell.bind(_this);
        return _this;
    }
    $f104d2d580867b68$var$_createClass(Cell, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                var shouldUpdate = false;
                if (nextProps.column.isDummyField) shouldUpdate = !$f104d2d580867b68$var$_utils2.default.isEqual(this.props.row, nextProps.row);
                else shouldUpdate = $f104d2d580867b68$var$_utils2.default.get(this.props.row, this.props.column.dataField) !== $f104d2d580867b68$var$_utils2.default.get(nextProps.row, nextProps.column.dataField);
                if (shouldUpdate) return true;
                // if (nextProps.formatter)
                shouldUpdate = (nextProps.column.formatter ? !$f104d2d580867b68$var$_utils2.default.isEqual(this.props.row, nextProps.row) : false) || this.props.column.hidden !== nextProps.column.hidden || this.props.column.isDummyField !== nextProps.column.isDummyField || this.props.rowIndex !== nextProps.rowIndex || this.props.columnIndex !== nextProps.columnIndex || this.props.className !== nextProps.className || this.props.title !== nextProps.title || this.props.editable !== nextProps.editable || this.props.clickToEdit !== nextProps.clickToEdit || this.props.dbclickToEdit !== nextProps.dbclickToEdit || !$f104d2d580867b68$var$_utils2.default.isEqual(this.props.style, nextProps.style) || !$f104d2d580867b68$var$_utils2.default.isEqual(this.props.column.formatExtraData, nextProps.column.formatExtraData) || !$f104d2d580867b68$var$_utils2.default.isEqual(this.props.column.events, nextProps.column.events) || !$f104d2d580867b68$var$_utils2.default.isEqual(this.props.column.attrs, nextProps.column.attrs) || this.props.tabIndex !== nextProps.tabIndex;
                return shouldUpdate;
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, row = _props.row, rowIndex = _props.rowIndex, column = _props.column, columnIndex = _props.columnIndex, onStart = _props.onStart, editable = _props.editable, clickToEdit = _props.clickToEdit, dbclickToEdit = _props.dbclickToEdit, rest = $f104d2d580867b68$var$_objectWithoutProperties(_props, [
                    "row",
                    "rowIndex",
                    "column",
                    "columnIndex",
                    "onStart",
                    "editable",
                    "clickToEdit",
                    "dbclickToEdit"
                ]);
                var dataField = column.dataField, formatter = column.formatter, formatExtraData = column.formatExtraData;
                var attrs = this.delegate($f104d2d580867b68$var$_extends({}, rest));
                var content = column.isDummyField ? null : $f104d2d580867b68$var$_utils2.default.get(row, dataField);
                if (formatter) content = column.formatter(content, row, rowIndex, formatExtraData);
                if (clickToEdit && editable) attrs.onClick = this.createHandleEditingCell(attrs.onClick);
                else if (dbclickToEdit && editable) attrs.onDoubleClick = this.createHandleEditingCell(attrs.onDoubleClick);
                return $f104d2d580867b68$var$_react2.default.createElement("td", attrs, typeof content === "boolean" ? "" + content : content);
            }
        }
    ]);
    return Cell;
}((0, $f104d2d580867b68$var$_cellEventDelegater2.default)($acw62.Component));
$f104d2d580867b68$var$Cell.propTypes = {
    row: $f104d2d580867b68$var$_propTypes2.default.object.isRequired,
    rowIndex: $f104d2d580867b68$var$_propTypes2.default.number.isRequired,
    column: $f104d2d580867b68$var$_propTypes2.default.object.isRequired,
    columnIndex: $f104d2d580867b68$var$_propTypes2.default.number.isRequired
};
module.exports.default = $f104d2d580867b68$var$Cell;

});


parcelRegister("bKShc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $88ee17be03a1c416$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $88ee17be03a1c416$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $dQ68B = parcelRequire("dQ68B");
var $88ee17be03a1c416$var$_utils2 = $88ee17be03a1c416$var$_interopRequireDefault($dQ68B);

var $jVgbO = parcelRequire("jVgbO");
var $88ee17be03a1c416$var$_const2 = $88ee17be03a1c416$var$_interopRequireDefault($jVgbO);
function $88ee17be03a1c416$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $88ee17be03a1c416$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $88ee17be03a1c416$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $88ee17be03a1c416$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $88ee17be03a1c416$var$events = [
    "onClick",
    "onDoubleClick",
    "onMouseEnter",
    "onMouseLeave",
    "onContextMenu",
    "onAuxClick"
];
module.exports.default = function(ExtendBase) {
    return function(_ExtendBase) {
        $88ee17be03a1c416$var$_inherits(RowEventDelegater, _ExtendBase);
        function RowEventDelegater(props) {
            $88ee17be03a1c416$var$_classCallCheck(this, RowEventDelegater);
            var _this = $88ee17be03a1c416$var$_possibleConstructorReturn(this, (RowEventDelegater.__proto__ || Object.getPrototypeOf(RowEventDelegater)).call(this, props));
            _this.clickNum = 0;
            _this.createDefaultEventHandler = _this.createDefaultEventHandler.bind(_this);
            _this.createClickEventHandler = _this.createClickEventHandler.bind(_this);
            return _this;
        }
        $88ee17be03a1c416$var$_createClass(RowEventDelegater, [
            {
                key: "createClickEventHandler",
                value: function createClickEventHandler(cb) {
                    var _this2 = this;
                    return function(e) {
                        var _props = _this2.props, row = _props.row, selected = _props.selected, keyField = _props.keyField, selectable = _props.selectable, expandable = _props.expandable, rowIndex = _props.rowIndex, expanded = _props.expanded, expandRow = _props.expandRow, selectRow = _props.selectRow, DELAY_FOR_DBCLICK = _props.DELAY_FOR_DBCLICK;
                        var clickFn = function clickFn() {
                            if (cb) cb(e, row, rowIndex);
                            var key = $88ee17be03a1c416$var$_utils2.default.get(row, keyField);
                            if (expandRow && expandable && !expandRow.expandByColumnOnly) {
                                if (selectRow.mode !== $88ee17be03a1c416$var$_const2.default.ROW_SELECT_DISABLED && selectRow.clickToExpand || selectRow.mode === $88ee17be03a1c416$var$_const2.default.ROW_SELECT_DISABLED) expandRow.onRowExpand(key, !expanded, rowIndex, e);
                            }
                            if (selectRow.clickToSelect && selectable) selectRow.onRowSelect(key, !selected, rowIndex, e);
                        };
                        if (DELAY_FOR_DBCLICK) {
                            _this2.clickNum += 1;
                            $88ee17be03a1c416$var$_utils2.default.debounce(function() {
                                if (_this2.clickNum === 1) clickFn();
                                _this2.clickNum = 0;
                            }, DELAY_FOR_DBCLICK)();
                        } else clickFn();
                    };
                }
            },
            {
                key: "createDefaultEventHandler",
                value: function createDefaultEventHandler(cb) {
                    var _this3 = this;
                    return function(e) {
                        var _props2 = _this3.props, row = _props2.row, rowIndex = _props2.rowIndex;
                        cb(e, row, rowIndex);
                    };
                }
            },
            {
                key: "delegate",
                value: function delegate() {
                    var _this4 = this;
                    var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                    var newAttrs = $88ee17be03a1c416$var$_extends({}, attrs);
                    Object.keys(attrs).forEach(function(attr) {
                        if ($88ee17be03a1c416$var$_utils2.default.contains($88ee17be03a1c416$var$events, attr)) newAttrs[attr] = _this4.createDefaultEventHandler(attrs[attr]);
                    });
                    return newAttrs;
                }
            }
        ]);
        return RowEventDelegater;
    }(ExtendBase);
};

});

parcelRegister("66H2y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $4724b07a07514547$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $dQ68B = parcelRequire("dQ68B");
var $4724b07a07514547$var$_utils2 = $4724b07a07514547$var$_interopRequireDefault($dQ68B);
function $4724b07a07514547$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4724b07a07514547$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $4724b07a07514547$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $4724b07a07514547$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint react/prop-types: 0 */ 
module.exports.default = function(ExtendBase) {
    return function(_ExtendBase) {
        $4724b07a07514547$var$_inherits(RowShouldUpdater, _ExtendBase);
        function RowShouldUpdater() {
            $4724b07a07514547$var$_classCallCheck(this, RowShouldUpdater);
            return $4724b07a07514547$var$_possibleConstructorReturn(this, (RowShouldUpdater.__proto__ || Object.getPrototypeOf(RowShouldUpdater)).apply(this, arguments));
        }
        $4724b07a07514547$var$_createClass(RowShouldUpdater, [
            {
                key: "shouldUpdateByCellEditing",
                value: function shouldUpdateByCellEditing(nextProps) {
                    if (!(this.props.clickToEdit || this.props.dbclickToEdit)) return false;
                    return nextProps.editingRowIdx === nextProps.rowIndex || this.props.editingRowIdx === nextProps.rowIndex && nextProps.editingRowIdx === null || this.props.editingRowIdx === nextProps.rowIndex;
                }
            },
            {
                key: "shouldUpdatedBySelfProps",
                value: function shouldUpdatedBySelfProps(nextProps) {
                    return this.props.className !== nextProps.className || !$4724b07a07514547$var$_utils2.default.isEqual(this.props.style, nextProps.style) || !$4724b07a07514547$var$_utils2.default.isEqual(this.props.attrs, nextProps.attrs);
                }
            },
            {
                key: "shouldUpdateByColumnsForSimpleCheck",
                value: function shouldUpdateByColumnsForSimpleCheck(nextProps) {
                    if (this.props.columns.length !== nextProps.columns.length) return true;
                    for(var i = 0; i < this.props.columns.length; i += 1){
                        if (!$4724b07a07514547$var$_utils2.default.isEqual(this.props.columns[i], nextProps.columns[i])) return true;
                    }
                    return false;
                }
            },
            {
                key: "shouldUpdatedByNormalProps",
                value: function shouldUpdatedByNormalProps(nextProps) {
                    var shouldUpdate = this.props.rowIndex !== nextProps.rowIndex || this.props.editable !== nextProps.editable || !$4724b07a07514547$var$_utils2.default.isEqual(this.props.row, nextProps.row) || this.props.columns.length !== nextProps.columns.length;
                    return shouldUpdate;
                }
            },
            {
                key: "shouldUpdateChild",
                value: function shouldUpdateChild(nextProps) {
                    return this.shouldUpdateByCellEditing(nextProps) || this.shouldUpdatedByNormalProps(nextProps);
                }
            },
            {
                key: "shouldRowContentUpdate",
                value: function shouldRowContentUpdate(nextProps) {
                    return this.shouldUpdateChild(nextProps) || this.shouldUpdateByColumnsForSimpleCheck(nextProps);
                }
            }
        ]);
        return RowShouldUpdater;
    }(ExtendBase);
};

});


parcelRegister("k0kaM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $e90374a2ca3bd758$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $e90374a2ca3bd758$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $e90374a2ca3bd758$var$_react2 = $e90374a2ca3bd758$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");
var $e90374a2ca3bd758$var$_propTypes2 = $e90374a2ca3bd758$var$_interopRequireDefault($c9Z8w);

var $dQ68B = parcelRequire("dQ68B");
var $e90374a2ca3bd758$var$_utils2 = $e90374a2ca3bd758$var$_interopRequireDefault($dQ68B);

var $chn26 = parcelRequire("chn26");
var $e90374a2ca3bd758$var$_expandCell2 = $e90374a2ca3bd758$var$_interopRequireDefault($chn26);

var $gR5jz = parcelRequire("gR5jz");
var $e90374a2ca3bd758$var$_selectionCell2 = $e90374a2ca3bd758$var$_interopRequireDefault($gR5jz);

var $66H2y = parcelRequire("66H2y");
var $e90374a2ca3bd758$var$_shouldUpdater3 = $e90374a2ca3bd758$var$_interopRequireDefault($66H2y);

var $bKShc = parcelRequire("bKShc");
var $e90374a2ca3bd758$var$_eventDelegater2 = $e90374a2ca3bd758$var$_interopRequireDefault($bKShc);

var $37FUg = parcelRequire("37FUg");
var $e90374a2ca3bd758$var$_rowPureContent2 = $e90374a2ca3bd758$var$_interopRequireDefault($37FUg);

var $jVgbO = parcelRequire("jVgbO");
var $e90374a2ca3bd758$var$_const2 = $e90374a2ca3bd758$var$_interopRequireDefault($jVgbO);
function $e90374a2ca3bd758$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e90374a2ca3bd758$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $e90374a2ca3bd758$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e90374a2ca3bd758$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $e90374a2ca3bd758$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint class-methods-use-this: 0 */ 
/* eslint react/prop-types: 0 */ /* eslint no-plusplus: 0 */ var $e90374a2ca3bd758$var$RowAggregator = function(_shouldUpdater) {
    $e90374a2ca3bd758$var$_inherits(RowAggregator, _shouldUpdater);
    function RowAggregator(props) {
        $e90374a2ca3bd758$var$_classCallCheck(this, RowAggregator);
        var _this = $e90374a2ca3bd758$var$_possibleConstructorReturn(this, (RowAggregator.__proto__ || Object.getPrototypeOf(RowAggregator)).call(this, props));
        _this.clickNum = 0;
        _this.shouldUpdateRowContent = false;
        _this.createClickEventHandler = _this.createClickEventHandler.bind(_this);
        return _this;
    }
    $e90374a2ca3bd758$var$_createClass(RowAggregator, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                if (this.props.selected !== nextProps.selected || this.props.expanded !== nextProps.expanded || this.props.expandable !== nextProps.expandable || this.props.selectable !== nextProps.selectable || this.props.selectRow.hideSelectColumn !== nextProps.selectRow.hideSelectColumn || this.shouldUpdatedBySelfProps(nextProps)) {
                    this.shouldUpdateRowContent = this.shouldRowContentUpdate(nextProps);
                    return true;
                }
                this.shouldUpdateRowContent = this.shouldRowContentUpdate(nextProps);
                return this.shouldUpdateRowContent;
            }
        },
        {
            key: "isRenderFunctionColumnInLeft",
            value: function isRenderFunctionColumnInLeft() {
                var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $e90374a2ca3bd758$var$_const2.default.INDICATOR_POSITION_LEFT;
                return position === $e90374a2ca3bd758$var$_const2.default.INDICATOR_POSITION_LEFT;
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, row = _props.row, columns = _props.columns, keyField = _props.keyField, rowIndex = _props.rowIndex, style = _props.style, className = _props.className, attrs = _props.attrs, selectRow = _props.selectRow, expandRow = _props.expandRow, expanded = _props.expanded, expandable = _props.expandable, selected = _props.selected, selectable = _props.selectable, visibleColumnSize = _props.visibleColumnSize, tabIndexCell = _props.tabIndexCell, rest = $e90374a2ca3bd758$var$_objectWithoutProperties(_props, [
                    "row",
                    "columns",
                    "keyField",
                    "rowIndex",
                    "style",
                    "className",
                    "attrs",
                    "selectRow",
                    "expandRow",
                    "expanded",
                    "expandable",
                    "selected",
                    "selectable",
                    "visibleColumnSize",
                    "tabIndexCell"
                ]);
                var key = $e90374a2ca3bd758$var$_utils2.default.get(row, keyField);
                var hideSelectColumn = selectRow.hideSelectColumn, selectColumnPosition = selectRow.selectColumnPosition, clickToSelect = selectRow.clickToSelect;
                var showExpandColumn = expandRow.showExpandColumn, expandColumnPosition = expandRow.expandColumnPosition;
                var newAttrs = this.delegate($e90374a2ca3bd758$var$_extends({}, attrs));
                if (clickToSelect || !!expandRow.renderer) newAttrs.onClick = this.createClickEventHandler(newAttrs.onClick);
                var tabIndexStart = rowIndex * visibleColumnSize + 1;
                var childrens = [
                    $e90374a2ca3bd758$var$_react2.default.createElement($e90374a2ca3bd758$var$_rowPureContent2.default, $e90374a2ca3bd758$var$_extends({
                        key: "row",
                        row: row,
                        columns: columns,
                        keyField: keyField,
                        rowIndex: rowIndex,
                        shouldUpdate: this.shouldUpdateRowContent,
                        tabIndexStart: tabIndexCell ? tabIndexStart : -1
                    }, rest))
                ];
                if (!hideSelectColumn) {
                    var selectCell = $e90374a2ca3bd758$var$_react2.default.createElement($e90374a2ca3bd758$var$_selectionCell2.default, $e90374a2ca3bd758$var$_extends({}, selectRow, {
                        key: "selection-cell",
                        rowKey: key,
                        rowIndex: rowIndex,
                        selected: selected,
                        disabled: !selectable,
                        tabIndex: tabIndexCell ? tabIndexStart++ : -1
                    }));
                    if (this.isRenderFunctionColumnInLeft(selectColumnPosition)) childrens.unshift(selectCell);
                    else childrens.push(selectCell);
                }
                if (showExpandColumn) {
                    var expandCell = $e90374a2ca3bd758$var$_react2.default.createElement($e90374a2ca3bd758$var$_expandCell2.default, $e90374a2ca3bd758$var$_extends({}, expandRow, {
                        key: "expand-cell",
                        rowKey: key,
                        rowIndex: rowIndex,
                        expanded: expanded,
                        expandable: expandable,
                        tabIndex: tabIndexCell ? tabIndexStart++ : -1
                    }));
                    if (this.isRenderFunctionColumnInLeft(expandColumnPosition)) childrens.unshift(expandCell);
                    else childrens.push(expandCell);
                }
                return $e90374a2ca3bd758$var$_react2.default.createElement("tr", $e90374a2ca3bd758$var$_extends({
                    style: style,
                    className: className
                }, newAttrs), childrens);
            }
        }
    ]);
    return RowAggregator;
}((0, $e90374a2ca3bd758$var$_shouldUpdater3.default)((0, $e90374a2ca3bd758$var$_eventDelegater2.default)($e90374a2ca3bd758$var$_react2.default.Component)));
$e90374a2ca3bd758$var$RowAggregator.propTypes = {
    attrs: $e90374a2ca3bd758$var$_propTypes2.default.object,
    style: $e90374a2ca3bd758$var$_propTypes2.default.object
};
$e90374a2ca3bd758$var$RowAggregator.defaultProps = {
    attrs: {},
    style: {}
};
module.exports.default = $e90374a2ca3bd758$var$RowAggregator;

});
parcelRegister("chn26", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $8f08f06fbe9562b2$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $8f08f06fbe9562b2$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $8f08f06fbe9562b2$var$_react2 = $8f08f06fbe9562b2$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");
var $8f08f06fbe9562b2$var$_propTypes2 = $8f08f06fbe9562b2$var$_interopRequireDefault($c9Z8w);
function $8f08f06fbe9562b2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8f08f06fbe9562b2$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8f08f06fbe9562b2$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $8f08f06fbe9562b2$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 react/require-default-props: 0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 jsx-a11y/no-noninteractive-element-interactions: 0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */ 
/* eslint no-nested-ternary: 0 */ var $8f08f06fbe9562b2$var$ExpandCell = function(_Component) {
    $8f08f06fbe9562b2$var$_inherits(ExpandCell, _Component);
    function ExpandCell() {
        $8f08f06fbe9562b2$var$_classCallCheck(this, ExpandCell);
        var _this = $8f08f06fbe9562b2$var$_possibleConstructorReturn(this, (ExpandCell.__proto__ || Object.getPrototypeOf(ExpandCell)).call(this));
        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }
    $8f08f06fbe9562b2$var$_createClass(ExpandCell, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                var shouldUpdate = this.props.rowIndex !== nextProps.rowIndex || this.props.expanded !== nextProps.expanded || this.props.rowKey !== nextProps.rowKey || this.props.tabIndex !== nextProps.tabIndex;
                return shouldUpdate;
            }
        },
        {
            key: "handleClick",
            value: function handleClick(e) {
                var _props = this.props, rowKey = _props.rowKey, expanded = _props.expanded, onRowExpand = _props.onRowExpand, rowIndex = _props.rowIndex;
                e.stopPropagation();
                onRowExpand(rowKey, !expanded, rowIndex, e);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props2 = this.props, expanded = _props2.expanded, expandable = _props2.expandable, expandColumnRenderer = _props2.expandColumnRenderer, tabIndex = _props2.tabIndex, rowKey = _props2.rowKey;
                var attrs = {};
                if (tabIndex !== -1) attrs.tabIndex = tabIndex;
                return $8f08f06fbe9562b2$var$_react2.default.createElement("td", $8f08f06fbe9562b2$var$_extends({
                    className: "expand-cell",
                    onClick: this.handleClick
                }, attrs), expandColumnRenderer ? expandColumnRenderer({
                    expandable: expandable,
                    expanded: expanded,
                    rowKey: rowKey
                }) : expandable ? expanded ? "(-)" : "(+)" : "");
            }
        }
    ]);
    return ExpandCell;
}($acw62.Component);
$8f08f06fbe9562b2$var$ExpandCell.propTypes = {
    rowKey: $8f08f06fbe9562b2$var$_propTypes2.default.any,
    expanded: $8f08f06fbe9562b2$var$_propTypes2.default.bool.isRequired,
    expandable: $8f08f06fbe9562b2$var$_propTypes2.default.bool.isRequired,
    onRowExpand: $8f08f06fbe9562b2$var$_propTypes2.default.func.isRequired,
    expandColumnRenderer: $8f08f06fbe9562b2$var$_propTypes2.default.func,
    rowIndex: $8f08f06fbe9562b2$var$_propTypes2.default.number,
    tabIndex: $8f08f06fbe9562b2$var$_propTypes2.default.number
};
module.exports.default = $8f08f06fbe9562b2$var$ExpandCell;

});

parcelRegister("gR5jz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $c455b7f56aeb9b25$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $c455b7f56aeb9b25$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $c455b7f56aeb9b25$var$_react2 = $c455b7f56aeb9b25$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");
var $c455b7f56aeb9b25$var$_propTypes2 = $c455b7f56aeb9b25$var$_interopRequireDefault($c9Z8w);

var $jVgbO = parcelRequire("jVgbO");
var $c455b7f56aeb9b25$var$_const2 = $c455b7f56aeb9b25$var$_interopRequireDefault($jVgbO);

var $dQ68B = parcelRequire("dQ68B");
var $c455b7f56aeb9b25$var$_utils2 = $c455b7f56aeb9b25$var$_interopRequireDefault($dQ68B);

var $il2Gx = parcelRequire("il2Gx");
function $c455b7f56aeb9b25$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c455b7f56aeb9b25$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c455b7f56aeb9b25$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $c455b7f56aeb9b25$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 react/require-default-props: 0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 jsx-a11y/no-noninteractive-element-interactions: 0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */ 
var $c455b7f56aeb9b25$var$SelectionCell = function(_Component) {
    $c455b7f56aeb9b25$var$_inherits(SelectionCell, _Component);
    function SelectionCell() {
        $c455b7f56aeb9b25$var$_classCallCheck(this, SelectionCell);
        var _this = $c455b7f56aeb9b25$var$_possibleConstructorReturn(this, (SelectionCell.__proto__ || Object.getPrototypeOf(SelectionCell)).call(this));
        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }
    $c455b7f56aeb9b25$var$_createClass(SelectionCell, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                var shouldUpdate = this.props.rowIndex !== nextProps.rowIndex || this.props.selected !== nextProps.selected || this.props.disabled !== nextProps.disabled || this.props.rowKey !== nextProps.rowKey || this.props.tabIndex !== nextProps.tabIndex || this.props.selectColumnStyle !== nextProps.selectColumnStyle;
                return shouldUpdate;
            }
        },
        {
            key: "handleClick",
            value: function handleClick(e) {
                var _props = this.props, inputType = _props.mode, rowKey = _props.rowKey, selected = _props.selected, onRowSelect = _props.onRowSelect, disabled = _props.disabled, rowIndex = _props.rowIndex;
                e.stopPropagation();
                if (disabled) return;
                var checked = inputType === $c455b7f56aeb9b25$var$_const2.default.ROW_SELECT_SINGLE ? true : !selected;
                onRowSelect(rowKey, checked, rowIndex, e);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _props2 = this.props, rowKey = _props2.rowKey, inputType = _props2.mode, selected = _props2.selected, disabled = _props2.disabled, tabIndex = _props2.tabIndex, rowIndex = _props2.rowIndex, selectionRenderer = _props2.selectionRenderer, selectColumnStyle = _props2.selectColumnStyle;
                var attrs = {};
                if (tabIndex !== -1) attrs.tabIndex = tabIndex;
                attrs.style = $c455b7f56aeb9b25$var$_utils2.default.isFunction(selectColumnStyle) ? selectColumnStyle({
                    checked: selected,
                    disabled: disabled,
                    rowIndex: rowIndex,
                    rowKey: rowKey
                }) : selectColumnStyle;
                return $c455b7f56aeb9b25$var$_react2.default.createElement($il2Gx.BootstrapContext.Consumer, null, function(_ref) {
                    var bootstrap4 = _ref.bootstrap4;
                    return $c455b7f56aeb9b25$var$_react2.default.createElement("td", $c455b7f56aeb9b25$var$_extends({
                        className: "selection-cell",
                        onClick: _this2.handleClick
                    }, attrs), selectionRenderer ? selectionRenderer({
                        mode: inputType,
                        checked: selected,
                        disabled: disabled,
                        rowIndex: rowIndex,
                        rowKey: rowKey
                    }) : $c455b7f56aeb9b25$var$_react2.default.createElement("input", {
                        type: inputType,
                        checked: selected,
                        disabled: disabled,
                        className: bootstrap4 ? "selection-input-4" : "",
                        onChange: function onChange() {}
                    }));
                });
            }
        }
    ]);
    return SelectionCell;
}($acw62.Component);
$c455b7f56aeb9b25$var$SelectionCell.propTypes = {
    mode: $c455b7f56aeb9b25$var$_propTypes2.default.string.isRequired,
    rowKey: $c455b7f56aeb9b25$var$_propTypes2.default.any,
    selected: $c455b7f56aeb9b25$var$_propTypes2.default.bool,
    onRowSelect: $c455b7f56aeb9b25$var$_propTypes2.default.func,
    disabled: $c455b7f56aeb9b25$var$_propTypes2.default.bool,
    rowIndex: $c455b7f56aeb9b25$var$_propTypes2.default.number,
    tabIndex: $c455b7f56aeb9b25$var$_propTypes2.default.number,
    clickToSelect: $c455b7f56aeb9b25$var$_propTypes2.default.bool,
    selectionRenderer: $c455b7f56aeb9b25$var$_propTypes2.default.func,
    selectColumnStyle: $c455b7f56aeb9b25$var$_propTypes2.default.oneOfType([
        $c455b7f56aeb9b25$var$_propTypes2.default.object,
        $c455b7f56aeb9b25$var$_propTypes2.default.func
    ])
};
module.exports.default = $c455b7f56aeb9b25$var$SelectionCell;

});


parcelRegister("cKmRl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $acw62 = parcelRequire("acw62");
var $947b8350080a2465$var$_react2 = $947b8350080a2465$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");
var $947b8350080a2465$var$_propTypes2 = $947b8350080a2465$var$_interopRequireDefault($c9Z8w);
function $947b8350080a2465$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $947b8350080a2465$var$RowSection = function RowSection(_ref) {
    var content = _ref.content, colSpan = _ref.colSpan;
    return $947b8350080a2465$var$_react2.default.createElement("tr", null, $947b8350080a2465$var$_react2.default.createElement("td", {
        "data-toggle": "collapse",
        colSpan: colSpan,
        className: "react-bs-table-no-data"
    }, content));
};
$947b8350080a2465$var$RowSection.propTypes = {
    content: $947b8350080a2465$var$_propTypes2.default.any,
    colSpan: $947b8350080a2465$var$_propTypes2.default.number
};
$947b8350080a2465$var$RowSection.defaultProps = {
    content: null,
    colSpan: 1
};
module.exports.default = $947b8350080a2465$var$RowSection;

});

parcelRegister("kcR9T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $eb5e29ccf1ed61e4$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
}; /* eslint react/prop-types: 0 */ 

var $acw62 = parcelRequire("acw62");
var $eb5e29ccf1ed61e4$var$_react2 = $eb5e29ccf1ed61e4$var$_interopRequireDefault($acw62);

var $8g1PZ = parcelRequire("8g1PZ");
var $eb5e29ccf1ed61e4$var$_classnames2 = $eb5e29ccf1ed61e4$var$_interopRequireDefault($8g1PZ);

var $dQ68B = parcelRequire("dQ68B");
var $eb5e29ccf1ed61e4$var$_utils2 = $eb5e29ccf1ed61e4$var$_interopRequireDefault($dQ68B);

var $ihdm8 = parcelRequire("ihdm8");
var $eb5e29ccf1ed61e4$var$_selectionContext2 = $eb5e29ccf1ed61e4$var$_interopRequireDefault($ihdm8);
function $eb5e29ccf1ed61e4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.default = function(Component) {
    var renderWithSelection = function renderWithSelection(props, selectRow) {
        var key = props.value;
        var selected = $eb5e29ccf1ed61e4$var$_utils2.default.contains(selectRow.selected, key);
        var selectable = !selectRow.nonSelectable || !$eb5e29ccf1ed61e4$var$_utils2.default.contains(selectRow.nonSelectable, key);
        var notSelectable = $eb5e29ccf1ed61e4$var$_utils2.default.contains(selectRow.nonSelectable, key);
        var style = props.style, className = props.className;
        if (selected) {
            var selectedStyle = $eb5e29ccf1ed61e4$var$_utils2.default.isFunction(selectRow.style) ? selectRow.style(props.row, props.rowIndex) : selectRow.style;
            var selectedClasses = $eb5e29ccf1ed61e4$var$_utils2.default.isFunction(selectRow.classes) ? selectRow.classes(props.row, props.rowIndex) : selectRow.classes;
            style = $eb5e29ccf1ed61e4$var$_extends({}, style, selectedStyle);
            className = (0, $eb5e29ccf1ed61e4$var$_classnames2.default)(className, selectedClasses) || undefined;
            if (selectRow.bgColor) {
                style = style || {};
                style.backgroundColor = $eb5e29ccf1ed61e4$var$_utils2.default.isFunction(selectRow.bgColor) ? selectRow.bgColor(props.row, props.rowIndex) : selectRow.bgColor;
            }
        }
        if (notSelectable) {
            var notSelectableStyle = $eb5e29ccf1ed61e4$var$_utils2.default.isFunction(selectRow.nonSelectableStyle) ? selectRow.nonSelectableStyle(props.row, props.rowIndex) : selectRow.nonSelectableStyle;
            var notSelectableClasses = $eb5e29ccf1ed61e4$var$_utils2.default.isFunction(selectRow.nonSelectableClasses) ? selectRow.nonSelectableClasses(props.row, props.rowIndex) : selectRow.nonSelectableClasses;
            style = $eb5e29ccf1ed61e4$var$_extends({}, style, notSelectableStyle);
            className = (0, $eb5e29ccf1ed61e4$var$_classnames2.default)(className, notSelectableClasses) || undefined;
        }
        return $eb5e29ccf1ed61e4$var$_react2.default.createElement(Component, $eb5e29ccf1ed61e4$var$_extends({}, props, {
            style: style,
            className: className,
            selectRow: selectRow,
            selected: selected,
            selectable: selectable
        }));
    };
    function withConsumer(props) {
        return $eb5e29ccf1ed61e4$var$_react2.default.createElement($eb5e29ccf1ed61e4$var$_selectionContext2.default.Consumer, null, function(selectRow) {
            return renderWithSelection(props, selectRow);
        });
    }
    withConsumer.displayName = "WithSelectionRowConsumer";
    return withConsumer;
};

});

parcelRegister("gOk9e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $c3d0f1c8d8c0aa8b$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
}; /* eslint react/prop-types: 0 */ 

var $acw62 = parcelRequire("acw62");
var $c3d0f1c8d8c0aa8b$var$_react2 = $c3d0f1c8d8c0aa8b$var$_interopRequireDefault($acw62);

var $8g1PZ = parcelRequire("8g1PZ");
var $c3d0f1c8d8c0aa8b$var$_classnames2 = $c3d0f1c8d8c0aa8b$var$_interopRequireDefault($8g1PZ);

var $bAmjZ = parcelRequire("bAmjZ");
var $c3d0f1c8d8c0aa8b$var$_expandRow2 = $c3d0f1c8d8c0aa8b$var$_interopRequireDefault($bAmjZ);

var $dQ68B = parcelRequire("dQ68B");
var $c3d0f1c8d8c0aa8b$var$_utils2 = $c3d0f1c8d8c0aa8b$var$_interopRequireDefault($dQ68B);

var $3qp3X = parcelRequire("3qp3X");
var $c3d0f1c8d8c0aa8b$var$_rowExpandContext2 = $c3d0f1c8d8c0aa8b$var$_interopRequireDefault($3qp3X);
function $c3d0f1c8d8c0aa8b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.default = function(Component) {
    var renderWithExpansion = function renderWithExpansion(props, expandRow) {
        var parentClassName = "";
        var className = "";
        var key = props.value;
        var expanded = $c3d0f1c8d8c0aa8b$var$_utils2.default.contains(expandRow.expanded, key);
        var isClosing = $c3d0f1c8d8c0aa8b$var$_utils2.default.contains(expandRow.isClosing, key);
        var expandable = !expandRow.nonExpandable || !$c3d0f1c8d8c0aa8b$var$_utils2.default.contains(expandRow.nonExpandable, key);
        if (expanded) {
            parentClassName = $c3d0f1c8d8c0aa8b$var$_utils2.default.isFunction(expandRow.parentClassName) ? expandRow.parentClassName(expanded, props.row, props.rowIndex) : expandRow.parentClassName || "";
            className = $c3d0f1c8d8c0aa8b$var$_utils2.default.isFunction(expandRow.className) ? expandRow.className(expanded, props.row, props.rowIndex) : expandRow.className || "";
        }
        return [
            $c3d0f1c8d8c0aa8b$var$_react2.default.createElement(Component, $c3d0f1c8d8c0aa8b$var$_extends({}, props, {
                key: key,
                expanded: expanded,
                expandable: expandable,
                expandRow: $c3d0f1c8d8c0aa8b$var$_extends({}, expandRow),
                className: (0, $c3d0f1c8d8c0aa8b$var$_classnames2.default)(props.className, parentClassName)
            })),
            expanded || isClosing ? $c3d0f1c8d8c0aa8b$var$_react2.default.createElement($c3d0f1c8d8c0aa8b$var$_expandRow2.default, {
                key: key + "-expanding",
                colSpan: props.visibleColumnSize,
                expanded: expanded,
                onClosed: function onClosed() {
                    return expandRow.onClosed(key);
                },
                className: className
            }, expandRow.renderer(props.row, props.rowIndex)) : null
        ];
    };
    return function(props) {
        return $c3d0f1c8d8c0aa8b$var$_react2.default.createElement($c3d0f1c8d8c0aa8b$var$_rowExpandContext2.default.Consumer, null, function(expandRow) {
            return renderWithExpansion(props, expandRow);
        });
    };
};

});
parcelRegister("bAmjZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $86f45f0d92b64c2f$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $8g1PZ = parcelRequire("8g1PZ");
var $86f45f0d92b64c2f$var$_classnames2 = $86f45f0d92b64c2f$var$_interopRequireDefault($8g1PZ);

var $acw62 = parcelRequire("acw62");
var $86f45f0d92b64c2f$var$_react2 = $86f45f0d92b64c2f$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");
var $86f45f0d92b64c2f$var$_propTypes2 = $86f45f0d92b64c2f$var$_interopRequireDefault($c9Z8w);

var $gguWN = parcelRequire("gguWN");
function $86f45f0d92b64c2f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $86f45f0d92b64c2f$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var $86f45f0d92b64c2f$var$ExpandRow = function ExpandRow(_ref) {
    var children = _ref.children, expanded = _ref.expanded, onClosed = _ref.onClosed, className = _ref.className, rest = $86f45f0d92b64c2f$var$_objectWithoutProperties(_ref, [
        "children",
        "expanded",
        "onClosed",
        "className"
    ]);
    return $86f45f0d92b64c2f$var$_react2.default.createElement("tr", null, $86f45f0d92b64c2f$var$_react2.default.createElement("td", $86f45f0d92b64c2f$var$_extends({
        className: (0, $86f45f0d92b64c2f$var$_classnames2.default)("reset-expansion-style", className)
    }, rest), $86f45f0d92b64c2f$var$_react2.default.createElement($gguWN.default, {
        appear: true,
        "in": expanded,
        timeout: 400,
        classNames: "row-expand-slide",
        onExited: onClosed
    }, $86f45f0d92b64c2f$var$_react2.default.createElement("div", null, $86f45f0d92b64c2f$var$_react2.default.createElement("div", {
        className: "row-expansion-style"
    }, children)))));
};
$86f45f0d92b64c2f$var$ExpandRow.propTypes = {
    children: $86f45f0d92b64c2f$var$_propTypes2.default.node,
    expanded: $86f45f0d92b64c2f$var$_propTypes2.default.bool,
    onClosed: $86f45f0d92b64c2f$var$_propTypes2.default.func,
    className: $86f45f0d92b64c2f$var$_propTypes2.default.string
};
$86f45f0d92b64c2f$var$ExpandRow.defaultProps = {
    children: null,
    expanded: false,
    onClosed: null,
    className: ""
};
module.exports.default = $86f45f0d92b64c2f$var$ExpandRow;

});
parcelRegister("gguWN", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd7625733ab5eda2$export$2e2bcd8739ae039);

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $g7ajw = parcelRequire("g7ajw");


var $2sC8d = parcelRequire("2sC8d");

var $eJXGw = parcelRequire("eJXGw");

var $acw62 = parcelRequire("acw62");

var $6Edd3 = parcelRequire("6Edd3");

var $bd7625733ab5eda2$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $2sC8d.default)(node, c);
    });
};
var $bd7625733ab5eda2$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $eJXGw.default)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $bd7625733ab5eda2$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, "exit");
            _this.addClass(node, appearing ? "appear" : "enter", "base");
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? "appear" : "enter";
            _this.addClass(node, type, "active");
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? "appear" : "enter";
            _this.removeClasses(node, type);
            _this.addClass(node, type, "done");
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, "appear");
            _this.removeClasses(node, "enter");
            _this.addClass(node, "exit", "base");
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, "exit", "active");
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, "exit");
            _this.addClass(node, "exit", "done");
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === "string";
            var prefix = isStringClassNames && classNames ? classNames + "-" : "";
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames("enter"), doneClassName = _this$getClassNames.doneClassName;
        if (type === "appear" && phase === "done" && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === "active") /* eslint-disable no-unused-expressions */ node && node.scrollTop;
        if (className) {
            this.appliedClasses[type][phase] = className;
            $bd7625733ab5eda2$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $bd7625733ab5eda2$var$removeClass(node, baseClassName);
        if (activeClassName) $bd7625733ab5eda2$var$removeClass(node, activeClassName);
        if (doneClassName) $bd7625733ab5eda2$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $1En50.default)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6Edd3.default), (0, $8nd05.default)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$bd7625733ab5eda2$var$CSSTransition.defaultProps = {
    classNames: ""
};
$bd7625733ab5eda2$var$CSSTransition.propTypes = {};
var $bd7625733ab5eda2$export$2e2bcd8739ae039 = $bd7625733ab5eda2$var$CSSTransition;

});
parcelRegister("2sC8d", function(module, exports) {

$parcel$export(module.exports, "default", () => $1cabc665688e8989$export$2e2bcd8739ae039);

var $lRKY1 = parcelRequire("lRKY1");
function $1cabc665688e8989$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $lRKY1.default)(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}

});
parcelRegister("lRKY1", function(module, exports) {

$parcel$export(module.exports, "default", () => $feb2fae35a1f9a8d$export$2e2bcd8739ae039);
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $feb2fae35a1f9a8d$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

});


parcelRegister("eJXGw", function(module, exports) {

$parcel$export(module.exports, "default", () => $abb390d189f1ab34$export$2e2bcd8739ae039);
function $abb390d189f1ab34$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function $abb390d189f1ab34$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = $abb390d189f1ab34$var$replaceClassName(element.className, className);
    else element.setAttribute("class", $abb390d189f1ab34$var$replaceClassName(element.className && element.className.baseVal || "", className));
}

});

parcelRegister("6Edd3", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d70b9a536489f32$export$2e2bcd8739ae039);

var $1En50 = parcelRequire("1En50");

var $g7ajw = parcelRequire("g7ajw");


var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $axYxw = parcelRequire("axYxw");


var $1CsZJ = parcelRequire("1CsZJ");
var $4d70b9a536489f32$export$bb38bb9a1161268 = "unmounted";
var $4d70b9a536489f32$export$84cbff306f539230 = "exited";
var $4d70b9a536489f32$export$df38205c966be359 = "entering";
var $4d70b9a536489f32$export$78e9e6e3e014d60a = "entered";
var $4d70b9a536489f32$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $4d70b9a536489f32$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $g7ajw.default)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $4d70b9a536489f32$export$84cbff306f539230;
                _this.appearStatus = $4d70b9a536489f32$export$df38205c966be359;
            } else initialStatus = $4d70b9a536489f32$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $4d70b9a536489f32$export$bb38bb9a1161268;
        else initialStatus = $4d70b9a536489f32$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $4d70b9a536489f32$export$bb38bb9a1161268) return {
            status: $4d70b9a536489f32$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $4d70b9a536489f32$export$df38205c966be359 && status !== $4d70b9a536489f32$export$78e9e6e3e014d60a) nextStatus = $4d70b9a536489f32$export$df38205c966be359;
            } else if (status === $4d70b9a536489f32$export$df38205c966be359 || status === $4d70b9a536489f32$export$78e9e6e3e014d60a) nextStatus = $4d70b9a536489f32$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $4d70b9a536489f32$export$df38205c966be359) this.performEnter(mounting);
            else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $4d70b9a536489f32$export$84cbff306f539230) this.setState({
            status: $4d70b9a536489f32$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $axYxw.default).disabled) {
            this.safeSetState({
                status: $4d70b9a536489f32$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $4d70b9a536489f32$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $4d70b9a536489f32$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $axYxw.default).disabled) {
            this.safeSetState({
                status: $4d70b9a536489f32$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $4d70b9a536489f32$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $4d70b9a536489f32$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $4d70b9a536489f32$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $1En50.default)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1CsZJ.default).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$4d70b9a536489f32$var$Transition.contextType = (0, $1CsZJ.default);
$4d70b9a536489f32$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $4d70b9a536489f32$var$noop() {}
$4d70b9a536489f32$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $4d70b9a536489f32$var$noop,
    onEntering: $4d70b9a536489f32$var$noop,
    onEntered: $4d70b9a536489f32$var$noop,
    onExit: $4d70b9a536489f32$var$noop,
    onExiting: $4d70b9a536489f32$var$noop,
    onExited: $4d70b9a536489f32$var$noop
};
$4d70b9a536489f32$var$Transition.UNMOUNTED = $4d70b9a536489f32$export$bb38bb9a1161268;
$4d70b9a536489f32$var$Transition.EXITED = $4d70b9a536489f32$export$84cbff306f539230;
$4d70b9a536489f32$var$Transition.ENTERING = $4d70b9a536489f32$export$df38205c966be359;
$4d70b9a536489f32$var$Transition.ENTERED = $4d70b9a536489f32$export$78e9e6e3e014d60a;
$4d70b9a536489f32$var$Transition.EXITING = $4d70b9a536489f32$export$4aacc83d4d59139f;
var $4d70b9a536489f32$export$2e2bcd8739ae039 = $4d70b9a536489f32$var$Transition;

});
parcelRegister("axYxw", function(module, exports) {

$parcel$export(module.exports, "default", () => $7adbf264b9593206$export$2e2bcd8739ae039);
var $7adbf264b9593206$export$2e2bcd8739ae039 = {
    disabled: false
};

});

parcelRegister("1CsZJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $12dfd4d075694efb$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");
var $12dfd4d075694efb$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);

});






parcelRegister("bWrrC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $acw62 = parcelRequire("acw62");
var $8b1a6660205a265c$var$_react2 = $8b1a6660205a265c$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");
var $8b1a6660205a265c$var$_propTypes2 = $8b1a6660205a265c$var$_interopRequireDefault($c9Z8w);

var $kXTgC = parcelRequire("kXTgC");
var $8b1a6660205a265c$var$_rowTemplate2 = $8b1a6660205a265c$var$_interopRequireDefault($kXTgC);

var $c96Sk = parcelRequire("c96Sk");
var $8b1a6660205a265c$var$_footerCell2 = $8b1a6660205a265c$var$_interopRequireDefault($c96Sk);

var $dQ68B = parcelRequire("dQ68B");
var $8b1a6660205a265c$var$_utils2 = $8b1a6660205a265c$var$_interopRequireDefault($dQ68B);
function $8b1a6660205a265c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8b1a6660205a265c$var$Footer = function Footer(props) {
    var data = props.data, className = props.className, columns = props.columns, selectRow = props.selectRow, expandRow = props.expandRow;
    function renderContent() {
        return columns.map(function(column, i) {
            if (column.footer === undefined || column.footer === null) return false;
            var columnData = $8b1a6660205a265c$var$_utils2.default.pluck(data, column.dataField);
            return $8b1a6660205a265c$var$_react2.default.createElement($8b1a6660205a265c$var$_footerCell2.default, {
                index: i,
                key: column.dataField,
                column: column,
                columnData: columnData
            });
        });
    }
    return $8b1a6660205a265c$var$_react2.default.createElement("tfoot", null, $8b1a6660205a265c$var$_react2.default.createElement($8b1a6660205a265c$var$_rowTemplate2.default, {
        renderContent: renderContent,
        selectRow: selectRow,
        expandRow: expandRow,
        className: className,
        cellEl: "th"
    }));
}; /* eslint react/require-default-props: 0 */ 
$8b1a6660205a265c$var$Footer.propTypes = {
    data: $8b1a6660205a265c$var$_propTypes2.default.array,
    className: $8b1a6660205a265c$var$_propTypes2.default.string,
    columns: $8b1a6660205a265c$var$_propTypes2.default.array,
    selectRow: $8b1a6660205a265c$var$_propTypes2.default.object,
    expandRow: $8b1a6660205a265c$var$_propTypes2.default.object
};
module.exports.default = $8b1a6660205a265c$var$Footer;

});
parcelRegister("c96Sk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $8d7ba891eca9ad1f$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $8d7ba891eca9ad1f$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $8d7ba891eca9ad1f$var$_react2 = $8d7ba891eca9ad1f$var$_interopRequireDefault($acw62);

var $8g1PZ = parcelRequire("8g1PZ");
var $8d7ba891eca9ad1f$var$_classnames2 = $8d7ba891eca9ad1f$var$_interopRequireDefault($8g1PZ);

var $c9Z8w = parcelRequire("c9Z8w");
var $8d7ba891eca9ad1f$var$_propTypes2 = $8d7ba891eca9ad1f$var$_interopRequireDefault($c9Z8w);

var $dQ68B = parcelRequire("dQ68B");
var $8d7ba891eca9ad1f$var$_utils2 = $8d7ba891eca9ad1f$var$_interopRequireDefault($dQ68B);

var $5a2kX = parcelRequire("5a2kX");
var $8d7ba891eca9ad1f$var$_cellEventDelegater2 = $8d7ba891eca9ad1f$var$_interopRequireDefault($5a2kX);
function $8d7ba891eca9ad1f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8d7ba891eca9ad1f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8d7ba891eca9ad1f$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $8d7ba891eca9ad1f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint react/require-default-props: 0 */ 
var $8d7ba891eca9ad1f$var$FooterCell = function(_eventDelegater) {
    $8d7ba891eca9ad1f$var$_inherits(FooterCell, _eventDelegater);
    function FooterCell() {
        $8d7ba891eca9ad1f$var$_classCallCheck(this, FooterCell);
        return $8d7ba891eca9ad1f$var$_possibleConstructorReturn(this, (FooterCell.__proto__ || Object.getPrototypeOf(FooterCell)).apply(this, arguments));
    }
    $8d7ba891eca9ad1f$var$_createClass(FooterCell, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, index = _props.index, column = _props.column, columnData = _props.columnData;
                var footer = column.footer, footerTitle = column.footerTitle, footerAlign = column.footerAlign, footerFormatter = column.footerFormatter, footerEvents = column.footerEvents, footerClasses = column.footerClasses, footerStyle = column.footerStyle, footerAttrs = column.footerAttrs;
                var delegateEvents = this.delegate(footerEvents);
                var cellAttrs = $8d7ba891eca9ad1f$var$_extends({}, $8d7ba891eca9ad1f$var$_utils2.default.isFunction(footerAttrs) ? footerAttrs(column, index) : footerAttrs, delegateEvents);
                var text = "";
                if ($8d7ba891eca9ad1f$var$_utils2.default.isString(footer)) text = footer;
                else if ($8d7ba891eca9ad1f$var$_utils2.default.isFunction(footer)) text = footer(columnData, column, index);
                var cellStyle = {};
                var cellClasses = $8d7ba891eca9ad1f$var$_utils2.default.isFunction(footerClasses) ? footerClasses(column, index) : footerClasses;
                if (footerStyle) {
                    cellStyle = $8d7ba891eca9ad1f$var$_utils2.default.isFunction(footerStyle) ? footerStyle(column, index) : footerStyle;
                    cellStyle = cellStyle ? $8d7ba891eca9ad1f$var$_extends({}, cellStyle) : cellStyle;
                }
                if (footerTitle) cellAttrs.title = $8d7ba891eca9ad1f$var$_utils2.default.isFunction(footerTitle) ? footerTitle(column, index) : text;
                if (footerAlign) cellStyle.textAlign = $8d7ba891eca9ad1f$var$_utils2.default.isFunction(footerAlign) ? footerAlign(column, index) : footerAlign;
                if (cellClasses) cellAttrs.className = (0, $8d7ba891eca9ad1f$var$_classnames2.default)(cellAttrs.className, cellClasses);
                if (!$8d7ba891eca9ad1f$var$_utils2.default.isEmptyObject(cellStyle)) cellAttrs.style = cellStyle;
                var children = footerFormatter ? footerFormatter(column, index, {
                    text: text
                }) : text;
                return $8d7ba891eca9ad1f$var$_react2.default.createElement("th", cellAttrs, children);
            }
        }
    ]);
    return FooterCell;
}((0, $8d7ba891eca9ad1f$var$_cellEventDelegater2.default)($8d7ba891eca9ad1f$var$_react2.default.Component));
$8d7ba891eca9ad1f$var$FooterCell.propTypes = {
    columnData: $8d7ba891eca9ad1f$var$_propTypes2.default.array,
    index: $8d7ba891eca9ad1f$var$_propTypes2.default.number,
    column: $8d7ba891eca9ad1f$var$_propTypes2.default.object
};
module.exports.default = $8d7ba891eca9ad1f$var$FooterCell;

});


parcelRegister("dOhOH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $a0ddc3e877f8661c$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $dQ68B = parcelRequire("dQ68B");
var $a0ddc3e877f8661c$var$_utils2 = $a0ddc3e877f8661c$var$_interopRequireDefault($dQ68B);

var $aS4Kd = parcelRequire("aS4Kd");
var $a0ddc3e877f8661c$var$_columnResolver2 = $a0ddc3e877f8661c$var$_interopRequireDefault($aS4Kd);
function $a0ddc3e877f8661c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a0ddc3e877f8661c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a0ddc3e877f8661c$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $a0ddc3e877f8661c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
module.exports.default = function(ExtendBase) {
    return function(_ColumnResolver) {
        $a0ddc3e877f8661c$var$_inherits(TableResolver, _ColumnResolver);
        function TableResolver() {
            $a0ddc3e877f8661c$var$_classCallCheck(this, TableResolver);
            return $a0ddc3e877f8661c$var$_possibleConstructorReturn(this, (TableResolver.__proto__ || Object.getPrototypeOf(TableResolver)).apply(this, arguments));
        }
        $a0ddc3e877f8661c$var$_createClass(TableResolver, [
            {
                key: "validateProps",
                value: function validateProps() {
                    var keyField = this.props.keyField;
                    if (!keyField) throw new Error("Please specify a field as key via keyField");
                    if (this.visibleColumnSize(false) <= 0) throw new Error("No visible columns detected");
                }
            },
            {
                key: "isEmpty",
                value: function isEmpty() {
                    return this.props.data.length === 0;
                }
            },
            {
                key: "visibleRows",
                value: function visibleRows() {
                    var _props = this.props, data = _props.data, hiddenRows = _props.hiddenRows, keyField = _props.keyField;
                    if (!hiddenRows || hiddenRows.length === 0) return data;
                    return data.filter(function(row) {
                        var key = $a0ddc3e877f8661c$var$_utils2.default.get(row, keyField);
                        return !$a0ddc3e877f8661c$var$_utils2.default.contains(hiddenRows, key);
                    });
                }
            }
        ]);
        return TableResolver;
    }((0, $a0ddc3e877f8661c$var$_columnResolver2.default)(ExtendBase));
};

});
parcelRegister("aS4Kd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $7ea2a0a8645c243a$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $7ea2a0a8645c243a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7ea2a0a8645c243a$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $7ea2a0a8645c243a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
module.exports.default = function(ExtendBase) {
    return function(_ExtendBase) {
        $7ea2a0a8645c243a$var$_inherits(ColumnResolver, _ExtendBase);
        function ColumnResolver() {
            $7ea2a0a8645c243a$var$_classCallCheck(this, ColumnResolver);
            return $7ea2a0a8645c243a$var$_possibleConstructorReturn(this, (ColumnResolver.__proto__ || Object.getPrototypeOf(ColumnResolver)).apply(this, arguments));
        }
        $7ea2a0a8645c243a$var$_createClass(ColumnResolver, [
            {
                key: "visibleColumnSize",
                value: function visibleColumnSize() {
                    var includeSelectColumn = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
                    var columnLen = void 0;
                    if (this.props.columnToggle && this.props.columnToggle.toggles) {
                        var columns = this.props.columnToggle.toggles;
                        columnLen = Object.keys(columns).filter(function(name) {
                            return columns[name];
                        }).length;
                    } else columnLen = this.props.columns.filter(function(c) {
                        return !c.hidden;
                    }).length;
                    if (!includeSelectColumn) return columnLen;
                    if (this.props.selectRow && !this.props.selectRow.hideSelectColumn) columnLen += 1;
                    if (this.props.expandRow && this.props.expandRow.showExpandColumn) columnLen += 1;
                    return columnLen;
                }
            }
        ]);
        return ColumnResolver;
    }(ExtendBase);
};

});



parcelRegister("aKVZT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $7d4b3049fd9aa463$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $7d4b3049fd9aa463$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $7d4b3049fd9aa463$var$_react2 = $7d4b3049fd9aa463$var$_interopRequireDefault($acw62);

var $7etJZ = parcelRequire("7etJZ");
var $7d4b3049fd9aa463$var$_events2 = $7d4b3049fd9aa463$var$_interopRequireDefault($7etJZ);

var $dQ68B = parcelRequire("dQ68B");
var $7d4b3049fd9aa463$var$_utils2 = $7d4b3049fd9aa463$var$_interopRequireDefault($dQ68B);

var $dkFeH = parcelRequire("dkFeH");
var $7d4b3049fd9aa463$var$_dataContext2 = $7d4b3049fd9aa463$var$_interopRequireDefault($dkFeH);

var $gwirB = parcelRequire("gwirB");
var $7d4b3049fd9aa463$var$_columnContext2 = $7d4b3049fd9aa463$var$_interopRequireDefault($gwirB);

var $gfzf0 = parcelRequire("gfzf0");
var $7d4b3049fd9aa463$var$_sortContext2 = $7d4b3049fd9aa463$var$_interopRequireDefault($gfzf0);

var $ihdm8 = parcelRequire("ihdm8");
var $7d4b3049fd9aa463$var$_selectionContext2 = $7d4b3049fd9aa463$var$_interopRequireDefault($ihdm8);

var $3qp3X = parcelRequire("3qp3X");
var $7d4b3049fd9aa463$var$_rowExpandContext2 = $7d4b3049fd9aa463$var$_interopRequireDefault($3qp3X);

var $kJe5n = parcelRequire("kJe5n");
var $7d4b3049fd9aa463$var$_remoteResolver3 = $7d4b3049fd9aa463$var$_interopRequireDefault($kJe5n);

var $il2Gx = parcelRequire("il2Gx");

var $ijh0r = parcelRequire("ijh0r");
var $7d4b3049fd9aa463$var$_operators2 = $7d4b3049fd9aa463$var$_interopRequireDefault($ijh0r);
function $7d4b3049fd9aa463$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7d4b3049fd9aa463$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7d4b3049fd9aa463$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $7d4b3049fd9aa463$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint camelcase: 0 */ 
/* eslint no-return-assign: 0 */ /* eslint no-param-reassign: 0 */ /* eslint class-methods-use-this: 0 */ var $7d4b3049fd9aa463$var$withContext = function withContext(Base) {
    return function(_remoteResolver) {
        $7d4b3049fd9aa463$var$_inherits(BootstrapTableContainer, _remoteResolver);
        function BootstrapTableContainer(props) {
            $7d4b3049fd9aa463$var$_classCallCheck(this, BootstrapTableContainer);
            var _this = $7d4b3049fd9aa463$var$_possibleConstructorReturn(this, (BootstrapTableContainer.__proto__ || Object.getPrototypeOf(BootstrapTableContainer)).call(this, props));
            _this.DataContext = (0, $7d4b3049fd9aa463$var$_dataContext2.default)();
            if (props.registerExposedAPI) {
                var exposedAPIEmitter = new $7d4b3049fd9aa463$var$_events2.default();
                exposedAPIEmitter.on("get.table.data", function(payload) {
                    return payload.result = _this.table.getData();
                });
                exposedAPIEmitter.on("get.selected.rows", function(payload) {
                    return payload.result = _this.selectionContext.getSelected();
                });
                exposedAPIEmitter.on("get.filtered.rows", function(payload) {
                    if (_this.searchContext) payload.result = _this.searchContext.getSearched();
                    else if (_this.filterContext) payload.result = _this.filterContext.getFiltered();
                    else payload.result = _this.table.getData();
                });
                props.registerExposedAPI(exposedAPIEmitter);
            }
            if (props.columns.filter(function(col) {
                return col.sort;
            }).length > 0) _this.SortContext = (0, $7d4b3049fd9aa463$var$_sortContext2.default)($7d4b3049fd9aa463$var$_operators2.default, _this.isRemoteSort, _this.handleRemoteSortChange);
            if (props.columnToggle || props.columns.filter(function(col) {
                return col.hidden;
            }).length > 0) _this.ColumnManagementContext = (0, $7d4b3049fd9aa463$var$_columnContext2.default)();
            if (props.selectRow) _this.SelectionContext = $7d4b3049fd9aa463$var$_selectionContext2.default;
            if (props.expandRow) _this.RowExpandContext = $7d4b3049fd9aa463$var$_rowExpandContext2.default;
            if (props.cellEdit && props.cellEdit.createContext) _this.CellEditContext = props.cellEdit.createContext($7d4b3049fd9aa463$var$_utils2.default, $7d4b3049fd9aa463$var$_operators2.default, _this.isRemoteCellEdit, _this.handleRemoteCellChange);
            if (props.filter) _this.FilterContext = props.filter.createContext($7d4b3049fd9aa463$var$_utils2.default, _this.isRemoteFiltering, _this.handleRemoteFilterChange);
            if (props.pagination) _this.PaginationContext = props.pagination.createContext();
            if (props.search && props.search.searchContext) _this.SearchContext = props.search.searchContext($7d4b3049fd9aa463$var$_utils2.default, _this.isRemoteSearch, _this.handleRemoteSearchChange);
            if (props.setDependencyModules) props.setDependencyModules($7d4b3049fd9aa463$var$_utils2.default);
            if (props.setPaginationRemoteEmitter) props.setPaginationRemoteEmitter(_this.remoteEmitter);
            return _this;
        }
        $7d4b3049fd9aa463$var$_createClass(BootstrapTableContainer, [
            {
                key: "UNSAFE_componentWillReceiveProps",
                value: function UNSAFE_componentWillReceiveProps(nextProps) {
                    if (nextProps.columns.filter(function(col) {
                        return col.sort;
                    }).length <= 0) this.SortContext = null;
                    else if (!this.SortContext) this.SortContext = (0, $7d4b3049fd9aa463$var$_sortContext2.default)($7d4b3049fd9aa463$var$_operators2.default, this.isRemoteSort, this.handleRemoteSortChange);
                    if (!nextProps.pagination && this.props.pagination) this.PaginationContext = null;
                    if (nextProps.pagination && !this.props.pagination) this.PaginationContext = nextProps.pagination.createContext(this.isRemotePagination, this.handleRemotePageChange);
                    if (!nextProps.cellEdit && this.props.cellEdit) this.CellEditContext = null;
                    if (nextProps.cellEdit && !this.props.cellEdit) this.CellEditContext = nextProps.cellEdit.createContext($7d4b3049fd9aa463$var$_utils2.default, $7d4b3049fd9aa463$var$_operators2.default, this.isRemoteCellEdit, this.handleRemoteCellChange);
                }
            },
            {
                key: "renderBase",
                value: function renderBase() {
                    var _this2 = this;
                    return function(rootProps, filterProps, searchProps, sortProps, paginationProps, columnToggleProps) {
                        return $7d4b3049fd9aa463$var$_react2.default.createElement(Base, $7d4b3049fd9aa463$var$_extends({
                            ref: function ref(n) {
                                return _this2.table = n;
                            }
                        }, _this2.props, sortProps, filterProps, searchProps, paginationProps, columnToggleProps, {
                            data: rootProps.getData(filterProps, searchProps, sortProps, paginationProps)
                        }));
                    };
                }
            },
            {
                key: "renderWithColumnManagementCtx",
                value: function renderWithColumnManagementCtx(base, baseProps) {
                    var _this3 = this;
                    return function(rootProps, filterProps, searchProps, sortProps, paginationProps) {
                        return $7d4b3049fd9aa463$var$_react2.default.createElement(_this3.ColumnManagementContext.Provider, $7d4b3049fd9aa463$var$_extends({}, baseProps, {
                            toggles: _this3.props.columnToggle ? _this3.props.columnToggle.toggles : null
                        }), $7d4b3049fd9aa463$var$_react2.default.createElement(_this3.ColumnManagementContext.Consumer, null, function(columnToggleProps) {
                            return base(rootProps, filterProps, searchProps, sortProps, paginationProps, columnToggleProps);
                        }));
                    };
                }
            },
            {
                key: "renderWithSelectionCtx",
                value: function renderWithSelectionCtx(base, baseProps) {
                    var _this4 = this;
                    return function(rootProps, filterProps, searchProps, sortProps, paginationProps) {
                        return $7d4b3049fd9aa463$var$_react2.default.createElement(_this4.SelectionContext.Provider, $7d4b3049fd9aa463$var$_extends({}, baseProps, {
                            ref: function ref(n) {
                                return _this4.selectionContext = n;
                            },
                            selectRow: _this4.props.selectRow,
                            data: rootProps.getData(filterProps, searchProps, sortProps, paginationProps)
                        }), base(rootProps, filterProps, searchProps, sortProps, paginationProps));
                    };
                }
            },
            {
                key: "renderWithRowExpandCtx",
                value: function renderWithRowExpandCtx(base, baseProps) {
                    var _this5 = this;
                    return function(rootProps, filterProps, searchProps, sortProps, paginationProps) {
                        return $7d4b3049fd9aa463$var$_react2.default.createElement(_this5.RowExpandContext.Provider, $7d4b3049fd9aa463$var$_extends({}, baseProps, {
                            ref: function ref(n) {
                                return _this5.rowExpandContext = n;
                            },
                            expandRow: _this5.props.expandRow,
                            data: rootProps.getData(filterProps, searchProps, sortProps, paginationProps)
                        }), base(rootProps, filterProps, searchProps, sortProps, paginationProps));
                    };
                }
            },
            {
                key: "renderWithPaginationCtx",
                value: function renderWithPaginationCtx(base) {
                    var _this6 = this;
                    return function(rootProps, filterProps, searchProps, sortProps) {
                        return $7d4b3049fd9aa463$var$_react2.default.createElement(_this6.PaginationContext.Provider, {
                            ref: function ref(n) {
                                return _this6.paginationContext = n;
                            },
                            pagination: _this6.props.pagination,
                            data: rootProps.getData(filterProps, searchProps, sortProps),
                            bootstrap4: _this6.props.bootstrap4,
                            isRemotePagination: _this6.isRemotePagination,
                            remoteEmitter: _this6.remoteEmitter,
                            onDataSizeChange: _this6.props.onDataSizeChange,
                            tableId: _this6.props.id
                        }, $7d4b3049fd9aa463$var$_react2.default.createElement(_this6.PaginationContext.Consumer, null, function(paginationProps) {
                            return base(rootProps, filterProps, searchProps, sortProps, paginationProps);
                        }));
                    };
                }
            },
            {
                key: "renderWithSortCtx",
                value: function renderWithSortCtx(base, baseProps) {
                    var _this7 = this;
                    return function(rootProps, filterProps, searchProps) {
                        return $7d4b3049fd9aa463$var$_react2.default.createElement(_this7.SortContext.Provider, $7d4b3049fd9aa463$var$_extends({}, baseProps, {
                            ref: function ref(n) {
                                return _this7.sortContext = n;
                            },
                            defaultSorted: _this7.props.defaultSorted,
                            defaultSortDirection: _this7.props.defaultSortDirection,
                            sort: _this7.props.sort,
                            data: rootProps.getData(filterProps, searchProps)
                        }), $7d4b3049fd9aa463$var$_react2.default.createElement(_this7.SortContext.Consumer, null, function(sortProps) {
                            return base(rootProps, filterProps, searchProps, sortProps);
                        }));
                    };
                }
            },
            {
                key: "renderWithSearchCtx",
                value: function renderWithSearchCtx(base, baseProps) {
                    var _this8 = this;
                    return function(rootProps, filterProps) {
                        return $7d4b3049fd9aa463$var$_react2.default.createElement(_this8.SearchContext.Provider, $7d4b3049fd9aa463$var$_extends({}, baseProps, {
                            ref: function ref(n) {
                                return _this8.searchContext = n;
                            },
                            data: rootProps.getData(filterProps),
                            searchText: _this8.props.search.searchText,
                            dataChangeListener: _this8.props.dataChangeListener
                        }), $7d4b3049fd9aa463$var$_react2.default.createElement(_this8.SearchContext.Consumer, null, function(searchProps) {
                            return base(rootProps, filterProps, searchProps);
                        }));
                    };
                }
            },
            {
                key: "renderWithFilterCtx",
                value: function renderWithFilterCtx(base, baseProps) {
                    var _this9 = this;
                    return function(rootProps) {
                        return $7d4b3049fd9aa463$var$_react2.default.createElement(_this9.FilterContext.Provider, $7d4b3049fd9aa463$var$_extends({}, baseProps, {
                            ref: function ref(n) {
                                return _this9.filterContext = n;
                            },
                            data: rootProps.getData(),
                            filter: _this9.props.filter.options || {},
                            dataChangeListener: _this9.props.dataChangeListener
                        }), $7d4b3049fd9aa463$var$_react2.default.createElement(_this9.FilterContext.Consumer, null, function(filterProps) {
                            return base(rootProps, filterProps);
                        }));
                    };
                }
            },
            {
                key: "renderWithCellEditCtx",
                value: function renderWithCellEditCtx(base, baseProps) {
                    var _this10 = this;
                    return function(rootProps) {
                        return $7d4b3049fd9aa463$var$_react2.default.createElement(_this10.CellEditContext.Provider, $7d4b3049fd9aa463$var$_extends({}, baseProps, {
                            ref: function ref(n) {
                                return _this10.cellEditContext = n;
                            },
                            selectRow: _this10.props.selectRow,
                            cellEdit: _this10.props.cellEdit,
                            data: rootProps.getData()
                        }), base(rootProps));
                    };
                }
            },
            {
                key: "render",
                value: function render() {
                    var _props = this.props, keyField = _props.keyField, columns = _props.columns, bootstrap4 = _props.bootstrap4;
                    var baseProps = {
                        keyField: keyField,
                        columns: columns
                    };
                    var base = this.renderBase();
                    if (this.ColumnManagementContext) base = this.renderWithColumnManagementCtx(base, baseProps);
                    if (this.SelectionContext) base = this.renderWithSelectionCtx(base, baseProps);
                    if (this.RowExpandContext) base = this.renderWithRowExpandCtx(base, baseProps);
                    if (this.PaginationContext) base = this.renderWithPaginationCtx(base, baseProps);
                    if (this.SortContext) base = this.renderWithSortCtx(base, baseProps);
                    if (this.SearchContext) base = this.renderWithSearchCtx(base, baseProps);
                    if (this.FilterContext) base = this.renderWithFilterCtx(base, baseProps);
                    if (this.CellEditContext) base = this.renderWithCellEditCtx(base, baseProps);
                    return $7d4b3049fd9aa463$var$_react2.default.createElement($il2Gx.BootstrapContext.Provider, {
                        value: {
                            bootstrap4: bootstrap4
                        }
                    }, $7d4b3049fd9aa463$var$_react2.default.createElement(this.DataContext.Provider, $7d4b3049fd9aa463$var$_extends({}, baseProps, {
                        data: this.props.data
                    }), $7d4b3049fd9aa463$var$_react2.default.createElement(this.DataContext.Consumer, null, base)));
                }
            }
        ]);
        return BootstrapTableContainer;
    }((0, $7d4b3049fd9aa463$var$_remoteResolver3.default)($acw62.Component));
};
module.exports.default = $7d4b3049fd9aa463$var$withContext;

});
parcelRegister("7etJZ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $5440e9199a418654$var$R = typeof Reflect === "object" ? Reflect : null;
var $5440e9199a418654$var$ReflectApply = $5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.apply === "function" ? $5440e9199a418654$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $5440e9199a418654$var$ReflectOwnKeys;
if ($5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.ownKeys === "function") $5440e9199a418654$var$ReflectOwnKeys = $5440e9199a418654$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $5440e9199a418654$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $5440e9199a418654$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $5440e9199a418654$var$EventEmitter() {
    $5440e9199a418654$var$EventEmitter.init.call(this);
}
module.exports = $5440e9199a418654$var$EventEmitter;
module.exports.once = $5440e9199a418654$var$once;
// Backwards-compat with node 0.10.x
$5440e9199a418654$var$EventEmitter.EventEmitter = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$var$EventEmitter.prototype._events = undefined;
$5440e9199a418654$var$EventEmitter.prototype._eventsCount = 0;
$5440e9199a418654$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $5440e9199a418654$var$defaultMaxListeners = 10;
function $5440e9199a418654$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($5440e9199a418654$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $5440e9199a418654$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $5440e9199a418654$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $5440e9199a418654$var$defaultMaxListeners = arg;
    }
});
$5440e9199a418654$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$5440e9199a418654$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $5440e9199a418654$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $5440e9199a418654$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $5440e9199a418654$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$5440e9199a418654$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $5440e9199a418654$var$_getMaxListeners(this);
};
$5440e9199a418654$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $5440e9199a418654$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $5440e9199a418654$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$5440e9199a418654$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $5440e9199a418654$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $5440e9199a418654$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $5440e9199a418654$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $5440e9199a418654$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$5440e9199a418654$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, false);
};
$5440e9199a418654$var$EventEmitter.prototype.on = $5440e9199a418654$var$EventEmitter.prototype.addListener;
$5440e9199a418654$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, true);
};
function $5440e9199a418654$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $5440e9199a418654$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $5440e9199a418654$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$5440e9199a418654$var$EventEmitter.prototype.once = function once(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.on(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.prependListener(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$5440e9199a418654$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $5440e9199a418654$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $5440e9199a418654$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.off = $5440e9199a418654$var$EventEmitter.prototype.removeListener;
$5440e9199a418654$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $5440e9199a418654$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $5440e9199a418654$var$unwrapListeners(evlistener) : $5440e9199a418654$var$arrayClone(evlistener, evlistener.length);
}
$5440e9199a418654$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, true);
};
$5440e9199a418654$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, false);
};
$5440e9199a418654$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $5440e9199a418654$var$listenerCount.call(emitter, type);
};
$5440e9199a418654$var$EventEmitter.prototype.listenerCount = $5440e9199a418654$var$listenerCount;
function $5440e9199a418654$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$5440e9199a418654$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $5440e9199a418654$var$ReflectOwnKeys(this._events) : [];
};
function $5440e9199a418654$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $5440e9199a418654$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $5440e9199a418654$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $5440e9199a418654$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("dkFeH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $9b4d213a5dbaba38$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $9b4d213a5dbaba38$var$_react2 = $9b4d213a5dbaba38$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");
var $9b4d213a5dbaba38$var$_propTypes2 = $9b4d213a5dbaba38$var$_interopRequireDefault($c9Z8w);
function $9b4d213a5dbaba38$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9b4d213a5dbaba38$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9b4d213a5dbaba38$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $9b4d213a5dbaba38$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint camelcase: 0 */ 
module.exports.default = function() {
    var DataContext = $9b4d213a5dbaba38$var$_react2.default.createContext();
    var DataProvider = function(_Component) {
        $9b4d213a5dbaba38$var$_inherits(DataProvider, _Component);
        function DataProvider() {
            var _ref;
            var _temp, _this, _ret;
            $9b4d213a5dbaba38$var$_classCallCheck(this, DataProvider);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $9b4d213a5dbaba38$var$_possibleConstructorReturn(this, (_ref = DataProvider.__proto__ || Object.getPrototypeOf(DataProvider)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                data: _this.props.data
            }, _this.getData = function(filterProps, searchProps, sortProps, paginationProps) {
                if (paginationProps) return paginationProps.data;
                else if (sortProps) return sortProps.data;
                else if (searchProps) return searchProps.data;
                else if (filterProps) return filterProps.data;
                return _this.props.data;
            }, _temp), $9b4d213a5dbaba38$var$_possibleConstructorReturn(_this, _ret);
        }
        $9b4d213a5dbaba38$var$_createClass(DataProvider, [
            {
                key: "UNSAFE_componentWillReceiveProps",
                value: function UNSAFE_componentWillReceiveProps(nextProps) {
                    this.setState(function() {
                        return {
                            data: nextProps.data
                        };
                    });
                }
            },
            {
                key: "render",
                value: function render() {
                    return $9b4d213a5dbaba38$var$_react2.default.createElement(DataContext.Provider, {
                        value: {
                            data: this.state.data,
                            getData: this.getData
                        }
                    }, this.props.children);
                }
            }
        ]);
        return DataProvider;
    }($acw62.Component);
    DataProvider.propTypes = {
        data: $9b4d213a5dbaba38$var$_propTypes2.default.array.isRequired,
        children: $9b4d213a5dbaba38$var$_propTypes2.default.node.isRequired
    };
    return {
        Provider: DataProvider,
        Consumer: DataContext.Consumer
    };
};

});

parcelRegister("gwirB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $c06df127f3d62405$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $c06df127f3d62405$var$_react2 = $c06df127f3d62405$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");
var $c06df127f3d62405$var$_propTypes2 = $c06df127f3d62405$var$_interopRequireDefault($c9Z8w);
function $c06df127f3d62405$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c06df127f3d62405$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c06df127f3d62405$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $c06df127f3d62405$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint react/prop-types: 0 */ 
/* eslint react/prefer-stateless-function: 0 */ module.exports.default = function() {
    var ColumnManagementContext = $c06df127f3d62405$var$_react2.default.createContext();
    var ColumnManagementProvider = function(_React$Component) {
        $c06df127f3d62405$var$_inherits(ColumnManagementProvider, _React$Component);
        function ColumnManagementProvider() {
            $c06df127f3d62405$var$_classCallCheck(this, ColumnManagementProvider);
            return $c06df127f3d62405$var$_possibleConstructorReturn(this, (ColumnManagementProvider.__proto__ || Object.getPrototypeOf(ColumnManagementProvider)).apply(this, arguments));
        }
        $c06df127f3d62405$var$_createClass(ColumnManagementProvider, [
            {
                key: "render",
                value: function render() {
                    var toggleColumn = void 0;
                    var _props = this.props, columns = _props.columns, toggles = _props.toggles;
                    if (toggles) toggleColumn = columns.filter(function(column) {
                        return toggles[column.dataField];
                    });
                    else toggleColumn = columns.filter(function(column) {
                        return !column.hidden;
                    });
                    return $c06df127f3d62405$var$_react2.default.createElement(ColumnManagementContext.Provider, {
                        value: {
                            columns: toggleColumn
                        }
                    }, this.props.children);
                }
            }
        ]);
        return ColumnManagementProvider;
    }($c06df127f3d62405$var$_react2.default.Component);
    ColumnManagementProvider.propTypes = {
        columns: $c06df127f3d62405$var$_propTypes2.default.array.isRequired,
        toggles: $c06df127f3d62405$var$_propTypes2.default.object
    };
    ColumnManagementProvider.defaultProps = {
        toggles: null
    };
    return {
        Provider: ColumnManagementProvider,
        Consumer: ColumnManagementContext.Consumer
    };
};

});

parcelRegister("gfzf0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $bd49622b6449ac65$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $bd49622b6449ac65$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $bd49622b6449ac65$var$_react2 = $bd49622b6449ac65$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");
var $bd49622b6449ac65$var$_propTypes2 = $bd49622b6449ac65$var$_interopRequireDefault($c9Z8w);

var $jVgbO = parcelRequire("jVgbO");
var $bd49622b6449ac65$var$_const2 = $bd49622b6449ac65$var$_interopRequireDefault($jVgbO);
function $bd49622b6449ac65$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $bd49622b6449ac65$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $bd49622b6449ac65$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $bd49622b6449ac65$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint camelcase: 0 */ 
/* eslint react/require-default-props: 0 */ module.exports.default = function(dataOperator, isRemoteSort, handleSortChange) {
    var SortContext = $bd49622b6449ac65$var$_react2.default.createContext();
    var SortProvider = function(_React$Component) {
        $bd49622b6449ac65$var$_inherits(SortProvider, _React$Component);
        function SortProvider(props) {
            $bd49622b6449ac65$var$_classCallCheck(this, SortProvider);
            var _this = $bd49622b6449ac65$var$_possibleConstructorReturn(this, (SortProvider.__proto__ || Object.getPrototypeOf(SortProvider)).call(this, props));
            _initialiseProps.call(_this);
            var sortOrder = void 0;
            var sortColumn = void 0;
            var defaultSorted = props.defaultSorted, defaultSortDirection = props.defaultSortDirection, sort = props.sort;
            if (defaultSorted && defaultSorted.length > 0) {
                sortOrder = defaultSorted[0].order || defaultSortDirection;
                sortColumn = _this.initSort(defaultSorted[0].dataField, sortOrder);
            } else if (sort && sort.dataField && sort.order) {
                sortOrder = sort.order;
                sortColumn = _this.initSort(sort.dataField, sortOrder);
            }
            _this.state = {
                sortOrder: sortOrder,
                sortColumn: sortColumn
            };
            return _this;
        }
        $bd49622b6449ac65$var$_createClass(SortProvider, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    var _state = this.state, sortOrder = _state.sortOrder, sortColumn = _state.sortColumn;
                    if (isRemoteSort() && sortOrder && sortColumn) handleSortChange(sortColumn.dataField, sortOrder);
                }
            },
            {
                key: "UNSAFE_componentWillReceiveProps",
                value: function UNSAFE_componentWillReceiveProps(nextProps) {
                    var sort = nextProps.sort, columns = nextProps.columns;
                    if (sort && sort.dataField && sort.order) this.setState({
                        sortOrder: sort.order,
                        sortColumn: columns.find(function(col) {
                            return col.dataField === sort.dataField;
                        })
                    });
                }
            },
            {
                key: "initSort",
                value: function initSort(sortField, sortOrder) {
                    var sortColumn = void 0;
                    var columns = this.props.columns;
                    var sortColumns = columns.filter(function(col) {
                        return col.dataField === sortField;
                    });
                    if (sortColumns.length > 0) {
                        sortColumn = sortColumns[0];
                        if (sortColumn.onSort) sortColumn.onSort(sortField, sortOrder);
                    }
                    return sortColumn;
                }
            },
            {
                key: "render",
                value: function render() {
                    var data = this.props.data;
                    var sort = this.props.sort;
                    var _state2 = this.state, sortOrder = _state2.sortOrder, sortColumn = _state2.sortColumn;
                    if (!isRemoteSort() && sortColumn) {
                        var sortFunc = sortColumn.sortFunc ? sortColumn.sortFunc : sort && sort.sortFunc;
                        data = dataOperator.sort(data, sortOrder, $bd49622b6449ac65$var$_extends({}, sortColumn, {
                            sortFunc: sortFunc
                        }));
                    }
                    return $bd49622b6449ac65$var$_react2.default.createElement(SortContext.Provider, {
                        value: {
                            data: data,
                            sortOrder: sortOrder,
                            onSort: this.handleSort,
                            sortField: sortColumn ? sortColumn.dataField : null
                        }
                    }, this.props.children);
                }
            }
        ]);
        return SortProvider;
    }($bd49622b6449ac65$var$_react2.default.Component);
    SortProvider.propTypes = {
        data: $bd49622b6449ac65$var$_propTypes2.default.array.isRequired,
        columns: $bd49622b6449ac65$var$_propTypes2.default.array.isRequired,
        children: $bd49622b6449ac65$var$_propTypes2.default.node.isRequired,
        defaultSorted: $bd49622b6449ac65$var$_propTypes2.default.arrayOf($bd49622b6449ac65$var$_propTypes2.default.shape({
            dataField: $bd49622b6449ac65$var$_propTypes2.default.string.isRequired,
            order: $bd49622b6449ac65$var$_propTypes2.default.oneOf([
                $bd49622b6449ac65$var$_const2.default.SORT_DESC,
                $bd49622b6449ac65$var$_const2.default.SORT_ASC
            ]).isRequired
        })),
        sort: $bd49622b6449ac65$var$_propTypes2.default.shape({
            dataField: $bd49622b6449ac65$var$_propTypes2.default.string,
            order: $bd49622b6449ac65$var$_propTypes2.default.oneOf([
                $bd49622b6449ac65$var$_const2.default.SORT_DESC,
                $bd49622b6449ac65$var$_const2.default.SORT_ASC
            ]),
            sortFunc: $bd49622b6449ac65$var$_propTypes2.default.func
        }),
        defaultSortDirection: $bd49622b6449ac65$var$_propTypes2.default.oneOf([
            $bd49622b6449ac65$var$_const2.default.SORT_DESC,
            $bd49622b6449ac65$var$_const2.default.SORT_ASC
        ])
    };
    var _initialiseProps = function _initialiseProps() {
        var _this2 = this;
        this.handleSort = function(column) {
            var sortOrder = dataOperator.nextOrder(column, _this2.state, _this2.props.defaultSortDirection);
            if (column.onSort) column.onSort(column.dataField, sortOrder);
            if (isRemoteSort()) handleSortChange(column.dataField, sortOrder);
            _this2.setState(function() {
                return {
                    sortOrder: sortOrder,
                    sortColumn: column
                };
            });
        };
    };
    return {
        Provider: SortProvider,
        Consumer: SortContext.Consumer
    };
};

});

parcelRegister("kJe5n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $f172efc37568e2d8$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $7etJZ = parcelRequire("7etJZ");
var $f172efc37568e2d8$var$_events2 = $f172efc37568e2d8$var$_interopRequireDefault($7etJZ);

var $dQ68B = parcelRequire("dQ68B");
var $f172efc37568e2d8$var$_utils2 = $f172efc37568e2d8$var$_interopRequireDefault($dQ68B);
function $f172efc37568e2d8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f172efc37568e2d8$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f172efc37568e2d8$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $f172efc37568e2d8$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
module.exports.default = function(ExtendBase) {
    return function(_ExtendBase) {
        $f172efc37568e2d8$var$_inherits(RemoteResolver, _ExtendBase);
        function RemoteResolver(props) {
            $f172efc37568e2d8$var$_classCallCheck(this, RemoteResolver);
            var _this = $f172efc37568e2d8$var$_possibleConstructorReturn(this, (RemoteResolver.__proto__ || Object.getPrototypeOf(RemoteResolver)).call(this, props));
            _this.getNewestState = function() {
                var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var sortOrder = void 0;
                var sortField = void 0;
                var page = void 0;
                var sizePerPage = void 0;
                var searchText = void 0;
                var filters = {};
                if (_this.sortContext) {
                    sortOrder = _this.sortContext.state.sortOrder;
                    sortField = _this.sortContext.state.sortColumn ? _this.sortContext.state.sortColumn.dataField : null;
                }
                if (_this.filterContext) filters = _this.filterContext.currFilters;
                if (_this.paginationContext) {
                    page = _this.paginationContext.currPage;
                    sizePerPage = _this.paginationContext.currSizePerPage;
                }
                if (_this.searchContext) searchText = _this.props.search.searchText;
                return $f172efc37568e2d8$var$_extends({
                    sortOrder: sortOrder,
                    sortField: sortField,
                    filters: filters,
                    page: page,
                    sizePerPage: sizePerPage,
                    searchText: searchText
                }, state, {
                    data: _this.props.data
                });
            };
            _this.isRemoteSearch = function() {
                var remote = _this.props.remote;
                return remote === true || $f172efc37568e2d8$var$_utils2.default.isObject(remote) && remote.search || _this.isRemotePagination();
            };
            _this.isRemotePagination = function() {
                var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var remote = _this.props.remote;
                e.result = remote === true || $f172efc37568e2d8$var$_utils2.default.isObject(remote) && remote.pagination;
                return e.result;
            };
            _this.isRemoteFiltering = function() {
                var remote = _this.props.remote;
                return remote === true || $f172efc37568e2d8$var$_utils2.default.isObject(remote) && remote.filter || _this.isRemotePagination();
            };
            _this.isRemoteSort = function() {
                var remote = _this.props.remote;
                return remote === true || $f172efc37568e2d8$var$_utils2.default.isObject(remote) && remote.sort || _this.isRemotePagination();
            };
            _this.isRemoteCellEdit = function() {
                var remote = _this.props.remote;
                return remote === true || $f172efc37568e2d8$var$_utils2.default.isObject(remote) && remote.cellEdit;
            };
            _this.handleRemotePageChange = function(page, sizePerPage) {
                _this.props.onTableChange("pagination", _this.getNewestState({
                    page: page,
                    sizePerPage: sizePerPage
                }));
            };
            _this.handleRemoteFilterChange = function(filters) {
                var newState = {
                    filters: filters
                };
                if (_this.isRemotePagination()) {
                    var options = _this.props.pagination.options || {};
                    newState.page = $f172efc37568e2d8$var$_utils2.default.isDefined(options.pageStartIndex) ? options.pageStartIndex : 1;
                }
                _this.props.onTableChange("filter", _this.getNewestState(newState));
            };
            _this.handleRemoteSortChange = function(sortField, sortOrder) {
                _this.props.onTableChange("sort", _this.getNewestState({
                    sortField: sortField,
                    sortOrder: sortOrder
                }));
            };
            _this.handleRemoteCellChange = function(rowId, dataField, newValue) {
                var cellEdit = {
                    rowId: rowId,
                    dataField: dataField,
                    newValue: newValue
                };
                _this.props.onTableChange("cellEdit", _this.getNewestState({
                    cellEdit: cellEdit
                }));
            };
            _this.handleRemoteSearchChange = function(searchText) {
                _this.props.onTableChange("search", _this.getNewestState({
                    searchText: searchText
                }));
            };
            _this.remoteEmitter = new $f172efc37568e2d8$var$_events2.default();
            _this.remoteEmitter.on("paginationChange", _this.handleRemotePageChange);
            _this.remoteEmitter.on("isRemotePagination", _this.isRemotePagination);
            return _this;
        }
        return RemoteResolver;
    }(ExtendBase);
};

});



parcelRegister("20w5V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PaginationTotalStandalone = module.exports.SizePerPageDropdownStandalone = module.exports.PaginationListStandalone = module.exports.PaginationProvider = undefined;

var $acw62 = parcelRequire("acw62");
var $17647a30223e0d11$var$_react2 = $17647a30223e0d11$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");
var $17647a30223e0d11$var$_propTypes2 = $17647a30223e0d11$var$_interopRequireDefault($c9Z8w);

var $8lElD = parcelRequire("8lElD");
var $17647a30223e0d11$var$_stateContext2 = $17647a30223e0d11$var$_interopRequireDefault($8lElD);

var $anuTd = parcelRequire("anuTd");
var $17647a30223e0d11$var$_dataContext2 = $17647a30223e0d11$var$_interopRequireDefault($anuTd);

var $25TJx = parcelRequire("25TJx");
var $17647a30223e0d11$var$_paginationListStandalone2 = $17647a30223e0d11$var$_interopRequireDefault($25TJx);

var $5Fs90 = parcelRequire("5Fs90");
var $17647a30223e0d11$var$_sizePerPageDropdownStandalone2 = $17647a30223e0d11$var$_interopRequireDefault($5Fs90);

var $3py5L = parcelRequire("3py5L");
var $17647a30223e0d11$var$_paginationTotalStandalone2 = $17647a30223e0d11$var$_interopRequireDefault($3py5L);
function $17647a30223e0d11$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.default = function() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return {
        createContext: $17647a30223e0d11$var$_dataContext2.default,
        options: options
    };
};
var $17647a30223e0d11$var$_createBaseContext = (0, $17647a30223e0d11$var$_stateContext2.default)(), $17647a30223e0d11$var$Provider = $17647a30223e0d11$var$_createBaseContext.Provider, $17647a30223e0d11$var$Consumer = $17647a30223e0d11$var$_createBaseContext.Consumer;
var $17647a30223e0d11$var$CustomizableProvider = function CustomizableProvider(props) {
    return $17647a30223e0d11$var$_react2.default.createElement($17647a30223e0d11$var$Provider, props, $17647a30223e0d11$var$_react2.default.createElement($17647a30223e0d11$var$Consumer, null, function(paginationProps) {
        return props.children(paginationProps);
    }));
};
$17647a30223e0d11$var$CustomizableProvider.propTypes = {
    children: $17647a30223e0d11$var$_propTypes2.default.func.isRequired
};
var $17647a30223e0d11$var$PaginationProvider = module.exports.PaginationProvider = $17647a30223e0d11$var$CustomizableProvider;
module.exports.PaginationListStandalone = $17647a30223e0d11$var$_paginationListStandalone2.default;
module.exports.SizePerPageDropdownStandalone = $17647a30223e0d11$var$_sizePerPageDropdownStandalone2.default;
module.exports.PaginationTotalStandalone = $17647a30223e0d11$var$_paginationTotalStandalone2.default;

});
parcelRegister("8lElD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $613f9522d4695df5$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $613f9522d4695df5$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $613f9522d4695df5$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $613f9522d4695df5$var$_react2 = $613f9522d4695df5$var$_interopRequireDefault($acw62);

var $7etJZ = parcelRequire("7etJZ");
var $613f9522d4695df5$var$_events2 = $613f9522d4695df5$var$_interopRequireDefault($7etJZ);

var $lL9M3 = parcelRequire("lL9M3");
var $613f9522d4695df5$var$_const2 = $613f9522d4695df5$var$_interopRequireDefault($lL9M3);

var $hJr03 = parcelRequire("hJr03");
function $613f9522d4695df5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $613f9522d4695df5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $613f9522d4695df5$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $613f9522d4695df5$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint react/prop-types: 0 */ 
/* eslint react/require-default-props: 0 */ /* eslint no-lonely-if: 0 */ /* eslint camelcase: 0 */ var $613f9522d4695df5$var$StateContext = $613f9522d4695df5$var$_react2.default.createContext();
var $613f9522d4695df5$var$StateProvider = function(_React$Component) {
    $613f9522d4695df5$var$_inherits(StateProvider, _React$Component);
    function StateProvider(props) {
        $613f9522d4695df5$var$_classCallCheck(this, StateProvider);
        var _this = $613f9522d4695df5$var$_possibleConstructorReturn(this, (StateProvider.__proto__ || Object.getPrototypeOf(StateProvider)).call(this, props));
        $613f9522d4695df5$var$_initialiseProps.call(_this);
        _this.handleChangePage = _this.handleChangePage.bind(_this);
        _this.handleDataSizeChange = _this.handleDataSizeChange.bind(_this);
        _this.handleChangeSizePerPage = _this.handleChangeSizePerPage.bind(_this);
        var currPage = void 0;
        var currSizePerPage = void 0;
        var options = props.pagination.options;
        var sizePerPageList = options.sizePerPageList || $613f9522d4695df5$var$_const2.default.SIZE_PER_PAGE_LIST;
        // initialize current page
        if (typeof options.page !== "undefined") currPage = options.page;
        else if (typeof options.pageStartIndex !== "undefined") currPage = options.pageStartIndex;
        else currPage = $613f9522d4695df5$var$_const2.default.PAGE_START_INDEX;
        // initialize current sizePerPage
        if (typeof options.sizePerPage !== "undefined") currSizePerPage = options.sizePerPage;
        else if ($613f9522d4695df5$var$_typeof(sizePerPageList[0]) === "object") currSizePerPage = sizePerPageList[0].value;
        else currSizePerPage = sizePerPageList[0];
        _this.currPage = currPage;
        _this.dataSize = options.totalSize;
        _this.currSizePerPage = currSizePerPage;
        _this.dataChangeListener = new $613f9522d4695df5$var$_events2.default();
        _this.dataChangeListener.on("filterChanged", _this.handleDataSizeChange);
        return _this;
    }
    $613f9522d4695df5$var$_createClass(StateProvider, [
        {
            key: "UNSAFE_componentWillReceiveProps",
            value: function UNSAFE_componentWillReceiveProps(nextProps) {
                var custom = nextProps.pagination.options.custom;
                // user should align the page when the page is not fit to the data size when remote enable
                if (this.isRemotePagination() || custom) {
                    if (typeof nextProps.pagination.options.page !== "undefined") this.currPage = nextProps.pagination.options.page;
                    if (typeof nextProps.pagination.options.sizePerPage !== "undefined") this.currSizePerPage = nextProps.pagination.options.sizePerPage;
                    if (typeof nextProps.pagination.options.totalSize !== "undefined") this.dataSize = nextProps.pagination.options.totalSize;
                }
            }
        },
        {
            key: "handleDataSizeChange",
            value: function handleDataSizeChange(newDataSize) {
                var options = this.props.pagination.options;
                var pageStartIndex = typeof options.pageStartIndex === "undefined" ? $613f9522d4695df5$var$_const2.default.PAGE_START_INDEX : options.pageStartIndex;
                this.currPage = (0, $hJr03.alignPage)(newDataSize, this.dataSize, this.currPage, this.currSizePerPage, pageStartIndex);
                this.dataSize = newDataSize;
                this.forceUpdate();
            }
        },
        {
            key: "handleChangePage",
            value: function handleChangePage(currPage) {
                var currSizePerPage = this.currSizePerPage;
                var options = this.props.pagination.options;
                if (options.onPageChange) options.onPageChange(currPage, currSizePerPage);
                this.currPage = currPage;
                if (this.isRemotePagination()) {
                    this.getPaginationRemoteEmitter().emit("paginationChange", currPage, currSizePerPage);
                    return;
                }
                this.forceUpdate();
            }
        },
        {
            key: "handleChangeSizePerPage",
            value: function handleChangeSizePerPage(currSizePerPage, currPage) {
                var options = this.props.pagination.options;
                if (options.onSizePerPageChange) options.onSizePerPageChange(currSizePerPage, currPage);
                this.currPage = currPage;
                this.currSizePerPage = currSizePerPage;
                if (this.isRemotePagination()) {
                    this.getPaginationRemoteEmitter().emit("paginationChange", currPage, currSizePerPage);
                    return;
                }
                this.forceUpdate();
            }
        },
        {
            key: "render",
            value: function render() {
                var paginationProps = this.getPaginationProps();
                var pagination = $613f9522d4695df5$var$_extends({}, this.props.pagination, {
                    options: paginationProps
                });
                return $613f9522d4695df5$var$_react2.default.createElement($613f9522d4695df5$var$StateContext.Provider, {
                    value: {
                        paginationProps: paginationProps,
                        paginationTableProps: {
                            pagination: pagination,
                            setPaginationRemoteEmitter: this.setPaginationRemoteEmitter,
                            dataChangeListener: this.dataChangeListener
                        }
                    }
                }, this.props.children);
            }
        }
    ]);
    return StateProvider;
}($613f9522d4695df5$var$_react2.default.Component);
var $613f9522d4695df5$var$_initialiseProps = function _initialiseProps() {
    var _this2 = this;
    this.getPaginationProps = function() {
        var _props = _this2.props, options = _props.pagination.options, bootstrap4 = _props.bootstrap4, tableId = _props.tableId;
        var currPage = _this2.currPage, currSizePerPage = _this2.currSizePerPage, dataSize = _this2.dataSize;
        var withFirstAndLast = typeof options.withFirstAndLast === "undefined" ? $613f9522d4695df5$var$_const2.default.With_FIRST_AND_LAST : options.withFirstAndLast;
        var alwaysShowAllBtns = typeof options.alwaysShowAllBtns === "undefined" ? $613f9522d4695df5$var$_const2.default.SHOW_ALL_PAGE_BTNS : options.alwaysShowAllBtns;
        var hideSizePerPage = typeof options.hideSizePerPage === "undefined" ? $613f9522d4695df5$var$_const2.default.HIDE_SIZE_PER_PAGE : options.hideSizePerPage;
        var hidePageListOnlyOnePage = typeof options.hidePageListOnlyOnePage === "undefined" ? $613f9522d4695df5$var$_const2.default.HIDE_PAGE_LIST_ONLY_ONE_PAGE : options.hidePageListOnlyOnePage;
        var pageStartIndex = typeof options.pageStartIndex === "undefined" ? $613f9522d4695df5$var$_const2.default.PAGE_START_INDEX : options.pageStartIndex;
        return $613f9522d4695df5$var$_extends({}, options, {
            bootstrap4: bootstrap4,
            tableId: tableId,
            page: currPage,
            sizePerPage: currSizePerPage,
            pageStartIndex: pageStartIndex,
            hidePageListOnlyOnePage: hidePageListOnlyOnePage,
            hideSizePerPage: hideSizePerPage,
            alwaysShowAllBtns: alwaysShowAllBtns,
            withFirstAndLast: withFirstAndLast,
            dataSize: dataSize,
            sizePerPageList: options.sizePerPageList || $613f9522d4695df5$var$_const2.default.SIZE_PER_PAGE_LIST,
            paginationSize: options.paginationSize || $613f9522d4695df5$var$_const2.default.PAGINATION_SIZE,
            showTotal: options.showTotal,
            pageListRenderer: options.pageListRenderer,
            pageButtonRenderer: options.pageButtonRenderer,
            sizePerPageRenderer: options.sizePerPageRenderer,
            paginationTotalRenderer: options.paginationTotalRenderer,
            sizePerPageOptionRenderer: options.sizePerPageOptionRenderer,
            firstPageText: options.firstPageText || $613f9522d4695df5$var$_const2.default.FIRST_PAGE_TEXT,
            prePageText: options.prePageText || $613f9522d4695df5$var$_const2.default.PRE_PAGE_TEXT,
            nextPageText: options.nextPageText || $613f9522d4695df5$var$_const2.default.NEXT_PAGE_TEXT,
            lastPageText: options.lastPageText || $613f9522d4695df5$var$_const2.default.LAST_PAGE_TEXT,
            prePageTitle: options.prePageTitle || $613f9522d4695df5$var$_const2.default.PRE_PAGE_TITLE,
            nextPageTitle: options.nextPageTitle || $613f9522d4695df5$var$_const2.default.NEXT_PAGE_TITLE,
            firstPageTitle: options.firstPageTitle || $613f9522d4695df5$var$_const2.default.FIRST_PAGE_TITLE,
            lastPageTitle: options.lastPageTitle || $613f9522d4695df5$var$_const2.default.LAST_PAGE_TITLE,
            onPageChange: _this2.handleChangePage,
            onSizePerPageChange: _this2.handleChangeSizePerPage
        });
    };
    this.setPaginationRemoteEmitter = function(remoteEmitter) {
        _this2.remoteEmitter = remoteEmitter;
    };
    this.getPaginationRemoteEmitter = function() {
        return _this2.remoteEmitter || _this2.props.remoteEmitter;
    };
    this.isRemotePagination = function() {
        var e = {};
        _this2.remoteEmitter.emit("isRemotePagination", e);
        return e.result;
    };
};
module.exports.default = function() {
    return {
        Provider: $613f9522d4695df5$var$StateProvider,
        Consumer: $613f9522d4695df5$var$StateContext.Consumer
    };
};

});
parcelRegister("lL9M3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = {
    PAGINATION_SIZE: 5,
    PAGE_START_INDEX: 1,
    With_FIRST_AND_LAST: true,
    SHOW_ALL_PAGE_BTNS: false,
    SHOW_TOTAL: false,
    PAGINATION_TOTAL: null,
    FIRST_PAGE_TEXT: "<<",
    PRE_PAGE_TEXT: "<",
    NEXT_PAGE_TEXT: ">",
    LAST_PAGE_TEXT: ">>",
    NEXT_PAGE_TITLE: "next page",
    LAST_PAGE_TITLE: "last page",
    PRE_PAGE_TITLE: "previous page",
    FIRST_PAGE_TITLE: "first page",
    SIZE_PER_PAGE_LIST: [
        10,
        25,
        30,
        50
    ],
    HIDE_SIZE_PER_PAGE: false,
    HIDE_PAGE_LIST_ONLY_ONE_PAGE: false
};

});

parcelRegister("hJr03", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getByCurrPage = module.exports.alignPage = undefined;

var $lL9M3 = parcelRequire("lL9M3");
var $ce8b953acd2e4bfd$var$_const2 = $ce8b953acd2e4bfd$var$_interopRequireDefault($lL9M3);
function $ce8b953acd2e4bfd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $ce8b953acd2e4bfd$var$getNormalizedPage = function getNormalizedPage(page, pageStartIndex) {
    var offset = Math.abs(1 - pageStartIndex);
    return page + offset;
};
var $ce8b953acd2e4bfd$var$endIndex = function endIndex(page, sizePerPage, pageStartIndex) {
    return $ce8b953acd2e4bfd$var$getNormalizedPage(page, pageStartIndex) * sizePerPage - 1;
};
var $ce8b953acd2e4bfd$var$startIndex = function startIndex(end, sizePerPage) {
    return end - (sizePerPage - 1);
};
var $ce8b953acd2e4bfd$var$alignPage = module.exports.alignPage = function alignPage(dataSize, prevDataSize, page, sizePerPage, pageStartIndex) {
    if (prevDataSize < dataSize) return page;
    if (page < pageStartIndex) return pageStartIndex;
    if (dataSize <= 0) return pageStartIndex;
    if (page >= Math.floor(dataSize / sizePerPage) + pageStartIndex && pageStartIndex === 1) return Math.ceil(dataSize / sizePerPage);
    if (page >= Math.floor(dataSize / sizePerPage) && pageStartIndex === 0) {
        var newPage = Math.ceil(dataSize / sizePerPage);
        return newPage - Math.abs($ce8b953acd2e4bfd$var$_const2.default.PAGE_START_INDEX - pageStartIndex);
    }
    return page;
};
var $ce8b953acd2e4bfd$var$getByCurrPage = module.exports.getByCurrPage = function getByCurrPage(data, page, sizePerPage, pageStartIndex) {
    var dataSize = data.length;
    if (!dataSize) return [];
    var end = $ce8b953acd2e4bfd$var$endIndex(page, sizePerPage, pageStartIndex);
    var start = $ce8b953acd2e4bfd$var$startIndex(end, sizePerPage);
    var result = [];
    for(var i = start; i <= end; i += 1){
        result.push(data[i]);
        if (i + 1 === dataSize) break;
    }
    return result;
};

});


parcelRegister("anuTd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $78e403690c2e7f9f$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $78e403690c2e7f9f$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $78e403690c2e7f9f$var$_get = function get(object, property, receiver) {
    if (object === null) object = Function.prototype;
    var desc = Object.getOwnPropertyDescriptor(object, property);
    if (desc === undefined) {
        var parent = Object.getPrototypeOf(object);
        if (parent === null) return undefined;
        else return get(parent, property, receiver);
    } else if ("value" in desc) return desc.value;
    else {
        var getter = desc.get;
        if (getter === undefined) return undefined;
        return getter.call(receiver);
    }
};

var $acw62 = parcelRequire("acw62");
var $78e403690c2e7f9f$var$_react2 = $78e403690c2e7f9f$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");
var $78e403690c2e7f9f$var$_propTypes2 = $78e403690c2e7f9f$var$_interopRequireDefault($c9Z8w);

var $lL9M3 = parcelRequire("lL9M3");
var $78e403690c2e7f9f$var$_const2 = $78e403690c2e7f9f$var$_interopRequireDefault($lL9M3);

var $kpNcy = parcelRequire("kpNcy");
var $78e403690c2e7f9f$var$_pagination2 = $78e403690c2e7f9f$var$_interopRequireDefault($kpNcy);

var $hJr03 = parcelRequire("hJr03");

var $8lElD = parcelRequire("8lElD");
var $78e403690c2e7f9f$var$_stateContext2 = $78e403690c2e7f9f$var$_interopRequireDefault($8lElD);
function $78e403690c2e7f9f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $78e403690c2e7f9f$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $78e403690c2e7f9f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $78e403690c2e7f9f$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $78e403690c2e7f9f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint react/prop-types: 0 */ 
/* eslint react/require-default-props: 0 */ /* eslint no-lonely-if: 0 */ var $78e403690c2e7f9f$var$_createBaseContext = (0, $78e403690c2e7f9f$var$_stateContext2.default)(), $78e403690c2e7f9f$var$Provider = $78e403690c2e7f9f$var$_createBaseContext.Provider;
var $78e403690c2e7f9f$var$PaginationDataContext = $78e403690c2e7f9f$var$_react2.default.createContext();
var $78e403690c2e7f9f$var$PaginationDataProvider = function(_Provider) {
    $78e403690c2e7f9f$var$_inherits(PaginationDataProvider, _Provider);
    function PaginationDataProvider() {
        var _ref;
        var _temp, _this, _ret;
        $78e403690c2e7f9f$var$_classCallCheck(this, PaginationDataProvider);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $78e403690c2e7f9f$var$_possibleConstructorReturn(this, (_ref = PaginationDataProvider.__proto__ || Object.getPrototypeOf(PaginationDataProvider)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.isRemotePagination = function() {
            return _this.props.isRemotePagination();
        }, _this.renderDefaultPagination = function() {
            if (!_this.props.pagination.options.custom) {
                var _this$getPaginationPr = _this.getPaginationProps(), currPage = _this$getPaginationPr.page, currSizePerPage = _this$getPaginationPr.sizePerPage, dataSize = _this$getPaginationPr.dataSize, rest = $78e403690c2e7f9f$var$_objectWithoutProperties(_this$getPaginationPr, [
                    "page",
                    "sizePerPage",
                    "dataSize"
                ]);
                return $78e403690c2e7f9f$var$_react2.default.createElement($78e403690c2e7f9f$var$_pagination2.default, $78e403690c2e7f9f$var$_extends({}, rest, {
                    key: "pagination",
                    dataSize: dataSize || _this.props.data.length,
                    currPage: currPage,
                    currSizePerPage: currSizePerPage
                }));
            }
            return null;
        }, _temp), $78e403690c2e7f9f$var$_possibleConstructorReturn(_this, _ret);
    }
    $78e403690c2e7f9f$var$_createClass(PaginationDataProvider, [
        {
            key: "UNSAFE_componentWillReceiveProps",
            // eslint-disable-next-line camelcase, react/sort-comp
            value: function UNSAFE_componentWillReceiveProps(nextProps) {
                $78e403690c2e7f9f$var$_get(PaginationDataProvider.prototype.__proto__ || Object.getPrototypeOf(PaginationDataProvider.prototype), "UNSAFE_componentWillReceiveProps", this).call(this, nextProps);
                var currSizePerPage = this.currSizePerPage;
                var _nextProps$pagination = nextProps.pagination.options, custom = _nextProps$pagination.custom, onPageChange = _nextProps$pagination.onPageChange;
                var pageStartIndex = typeof nextProps.pagination.options.pageStartIndex !== "undefined" ? nextProps.pagination.options.pageStartIndex : $78e403690c2e7f9f$var$_const2.default.PAGE_START_INDEX;
                // user should align the page when the page is not fit to the data size when remote enable
                if (!this.isRemotePagination() && !custom) {
                    var newPage = (0, $hJr03.alignPage)(nextProps.data.length, this.props.data.length, this.currPage, currSizePerPage, pageStartIndex);
                    if (this.currPage !== newPage) {
                        if (onPageChange) onPageChange(newPage, currSizePerPage);
                        this.currPage = newPage;
                    }
                }
                if (nextProps.onDataSizeChange && nextProps.data.length !== this.props.data.length) nextProps.onDataSizeChange({
                    dataSize: nextProps.data.length
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var data = this.props.data;
                var options = this.props.pagination.options;
                var currPage = this.currPage, currSizePerPage = this.currSizePerPage;
                var pageStartIndex = typeof options.pageStartIndex === "undefined" ? $78e403690c2e7f9f$var$_const2.default.PAGE_START_INDEX : options.pageStartIndex;
                data = this.isRemotePagination() ? data : (0, $hJr03.getByCurrPage)(data, currPage, currSizePerPage, pageStartIndex);
                return $78e403690c2e7f9f$var$_react2.default.createElement($78e403690c2e7f9f$var$PaginationDataContext.Provider, {
                    value: {
                        data: data,
                        setRemoteEmitter: this.setRemoteEmitter
                    }
                }, this.props.children, this.renderDefaultPagination());
            }
        }
    ]);
    return PaginationDataProvider;
}($78e403690c2e7f9f$var$Provider);
$78e403690c2e7f9f$var$PaginationDataProvider.propTypes = {
    data: $78e403690c2e7f9f$var$_propTypes2.default.array.isRequired,
    remoteEmitter: $78e403690c2e7f9f$var$_propTypes2.default.object.isRequired,
    isRemotePagination: $78e403690c2e7f9f$var$_propTypes2.default.func.isRequired
};
module.exports.default = function() {
    return {
        Provider: $78e403690c2e7f9f$var$PaginationDataProvider,
        Consumer: $78e403690c2e7f9f$var$PaginationDataContext.Consumer
    };
};

});
parcelRegister("kpNcy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $edcc4edb4b27774c$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $edcc4edb4b27774c$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $8g1PZ = parcelRequire("8g1PZ");
var $edcc4edb4b27774c$var$_classnames2 = $edcc4edb4b27774c$var$_interopRequireDefault($8g1PZ);

var $acw62 = parcelRequire("acw62");
var $edcc4edb4b27774c$var$_react2 = $edcc4edb4b27774c$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");
var $edcc4edb4b27774c$var$_propTypes2 = $edcc4edb4b27774c$var$_interopRequireDefault($c9Z8w);

var $9pNe0 = parcelRequire("9pNe0");
var $edcc4edb4b27774c$var$_pageResolver3 = $edcc4edb4b27774c$var$_interopRequireDefault($9pNe0);

var $gtC0Q = parcelRequire("gtC0Q");
var $edcc4edb4b27774c$var$_paginationHandler2 = $edcc4edb4b27774c$var$_interopRequireDefault($gtC0Q);

var $8Fqt9 = parcelRequire("8Fqt9");

var $jHBlb = parcelRequire("jHBlb");

var $4xKHY = parcelRequire("4xKHY");

var $lL9M3 = parcelRequire("lL9M3");
var $edcc4edb4b27774c$var$_const2 = $edcc4edb4b27774c$var$_interopRequireDefault($lL9M3);
function $edcc4edb4b27774c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $edcc4edb4b27774c$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $edcc4edb4b27774c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $edcc4edb4b27774c$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $edcc4edb4b27774c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint react/require-default-props: 0 */ 
/* eslint arrow-body-style: 0 */ var $edcc4edb4b27774c$var$Pagination = function(_pageResolver) {
    $edcc4edb4b27774c$var$_inherits(Pagination, _pageResolver);
    function Pagination() {
        $edcc4edb4b27774c$var$_classCallCheck(this, Pagination);
        return $edcc4edb4b27774c$var$_possibleConstructorReturn(this, (Pagination.__proto__ || Object.getPrototypeOf(Pagination)).apply(this, arguments));
    }
    $edcc4edb4b27774c$var$_createClass(Pagination, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, tableId = _props.tableId, currPage = _props.currPage, pageStartIndex = _props.pageStartIndex, showTotal = _props.showTotal, dataSize = _props.dataSize, pageListRenderer = _props.pageListRenderer, pageButtonRenderer = _props.pageButtonRenderer, paginationTotalRenderer = _props.paginationTotalRenderer, hidePageListOnlyOnePage = _props.hidePageListOnlyOnePage, totalPages = _props.totalPages, lastPage = _props.lastPage, onPageChange = _props.onPageChange, sizePerPageList = _props.sizePerPageList, currSizePerPage = _props.currSizePerPage, hideSizePerPage = _props.hideSizePerPage, sizePerPageRenderer = _props.sizePerPageRenderer, sizePerPageOptionRenderer = _props.sizePerPageOptionRenderer, onSizePerPageChange = _props.onSizePerPageChange, bootstrap4 = _props.bootstrap4, rest = $edcc4edb4b27774c$var$_objectWithoutProperties(_props, [
                    "tableId",
                    "currPage",
                    "pageStartIndex",
                    "showTotal",
                    "dataSize",
                    "pageListRenderer",
                    "pageButtonRenderer",
                    "paginationTotalRenderer",
                    "hidePageListOnlyOnePage",
                    "totalPages",
                    "lastPage",
                    "onPageChange",
                    "sizePerPageList",
                    "currSizePerPage",
                    "hideSizePerPage",
                    "sizePerPageRenderer",
                    "sizePerPageOptionRenderer",
                    "onSizePerPageChange",
                    "bootstrap4"
                ]);
                var pages = this.calculatePageStatus(this.calculatePages(totalPages, lastPage), lastPage);
                var pageListClass = (0, $edcc4edb4b27774c$var$_classnames2.default)("react-bootstrap-table-pagination-list", "col-md-6 col-xs-6 col-sm-6 col-lg-6", {
                    "react-bootstrap-table-pagination-list-hidden": hidePageListOnlyOnePage && totalPages === 1
                });
                return $edcc4edb4b27774c$var$_react2.default.createElement("div", {
                    className: "row react-bootstrap-table-pagination"
                }, $edcc4edb4b27774c$var$_react2.default.createElement("div", {
                    className: "col-md-6 col-xs-6 col-sm-6 col-lg-6"
                }, $edcc4edb4b27774c$var$_react2.default.createElement($8Fqt9.SizePerPageDropdownWithAdapter, {
                    bootstrap4: bootstrap4,
                    tableId: tableId,
                    sizePerPageList: sizePerPageList,
                    currSizePerPage: currSizePerPage,
                    hideSizePerPage: hideSizePerPage,
                    sizePerPageRenderer: sizePerPageRenderer,
                    sizePerPageOptionRenderer: sizePerPageOptionRenderer,
                    onSizePerPageChange: onSizePerPageChange
                }), showTotal ? $edcc4edb4b27774c$var$_react2.default.createElement($4xKHY.PaginationTotalWithAdapter, {
                    currPage: currPage,
                    currSizePerPage: currSizePerPage,
                    pageStartIndex: pageStartIndex,
                    dataSize: dataSize,
                    paginationTotalRenderer: paginationTotalRenderer
                }) : null), pageListRenderer ? pageListRenderer({
                    pages: pages,
                    onPageChange: onPageChange
                }) : $edcc4edb4b27774c$var$_react2.default.createElement("div", {
                    className: pageListClass
                }, $edcc4edb4b27774c$var$_react2.default.createElement($jHBlb.PaginationListWithAdapter, $edcc4edb4b27774c$var$_extends({}, rest, {
                    currPage: currPage,
                    currSizePerPage: currSizePerPage,
                    pageStartIndex: pageStartIndex,
                    lastPage: lastPage,
                    totalPages: totalPages,
                    pageButtonRenderer: pageButtonRenderer,
                    onPageChange: onPageChange
                }))));
            }
        }
    ]);
    return Pagination;
}((0, $edcc4edb4b27774c$var$_pageResolver3.default)($acw62.Component));
$edcc4edb4b27774c$var$Pagination.propTypes = {
    dataSize: $edcc4edb4b27774c$var$_propTypes2.default.number.isRequired,
    sizePerPageList: $edcc4edb4b27774c$var$_propTypes2.default.array.isRequired,
    currPage: $edcc4edb4b27774c$var$_propTypes2.default.number.isRequired,
    currSizePerPage: $edcc4edb4b27774c$var$_propTypes2.default.number.isRequired,
    onPageChange: $edcc4edb4b27774c$var$_propTypes2.default.func.isRequired,
    onSizePerPageChange: $edcc4edb4b27774c$var$_propTypes2.default.func.isRequired,
    disablePageTitle: $edcc4edb4b27774c$var$_propTypes2.default.bool,
    pageStartIndex: $edcc4edb4b27774c$var$_propTypes2.default.number,
    paginationSize: $edcc4edb4b27774c$var$_propTypes2.default.number,
    showTotal: $edcc4edb4b27774c$var$_propTypes2.default.bool,
    pageListRenderer: $edcc4edb4b27774c$var$_propTypes2.default.func,
    pageButtonRenderer: $edcc4edb4b27774c$var$_propTypes2.default.func,
    sizePerPageRenderer: $edcc4edb4b27774c$var$_propTypes2.default.func,
    paginationTotalRenderer: $edcc4edb4b27774c$var$_propTypes2.default.func,
    sizePerPageOptionRenderer: $edcc4edb4b27774c$var$_propTypes2.default.func,
    firstPageText: $edcc4edb4b27774c$var$_propTypes2.default.oneOfType([
        $edcc4edb4b27774c$var$_propTypes2.default.string,
        $edcc4edb4b27774c$var$_propTypes2.default.node
    ]),
    prePageText: $edcc4edb4b27774c$var$_propTypes2.default.oneOfType([
        $edcc4edb4b27774c$var$_propTypes2.default.string,
        $edcc4edb4b27774c$var$_propTypes2.default.node
    ]),
    nextPageText: $edcc4edb4b27774c$var$_propTypes2.default.oneOfType([
        $edcc4edb4b27774c$var$_propTypes2.default.string,
        $edcc4edb4b27774c$var$_propTypes2.default.node
    ]),
    lastPageText: $edcc4edb4b27774c$var$_propTypes2.default.oneOfType([
        $edcc4edb4b27774c$var$_propTypes2.default.string,
        $edcc4edb4b27774c$var$_propTypes2.default.node
    ]),
    nextPageTitle: $edcc4edb4b27774c$var$_propTypes2.default.string,
    prePageTitle: $edcc4edb4b27774c$var$_propTypes2.default.string,
    firstPageTitle: $edcc4edb4b27774c$var$_propTypes2.default.string,
    lastPageTitle: $edcc4edb4b27774c$var$_propTypes2.default.string,
    withFirstAndLast: $edcc4edb4b27774c$var$_propTypes2.default.bool,
    alwaysShowAllBtns: $edcc4edb4b27774c$var$_propTypes2.default.bool,
    hideSizePerPage: $edcc4edb4b27774c$var$_propTypes2.default.bool,
    hidePageListOnlyOnePage: $edcc4edb4b27774c$var$_propTypes2.default.bool,
    bootstrap4: $edcc4edb4b27774c$var$_propTypes2.default.bool
};
$edcc4edb4b27774c$var$Pagination.defaultProps = {
    disablePageTitle: false,
    bootstrap4: false,
    pageStartIndex: $edcc4edb4b27774c$var$_const2.default.PAGE_START_INDEX,
    paginationSize: $edcc4edb4b27774c$var$_const2.default.PAGINATION_SIZE,
    withFirstAndLast: $edcc4edb4b27774c$var$_const2.default.With_FIRST_AND_LAST,
    alwaysShowAllBtns: $edcc4edb4b27774c$var$_const2.default.SHOW_ALL_PAGE_BTNS,
    showTotal: $edcc4edb4b27774c$var$_const2.default.SHOW_TOTAL,
    pageListRenderer: null,
    pageButtonRenderer: null,
    sizePerPageRenderer: null,
    paginationTotalRenderer: $edcc4edb4b27774c$var$_const2.default.PAGINATION_TOTAL,
    sizePerPageOptionRenderer: null,
    firstPageText: $edcc4edb4b27774c$var$_const2.default.FIRST_PAGE_TEXT,
    prePageText: $edcc4edb4b27774c$var$_const2.default.PRE_PAGE_TEXT,
    nextPageText: $edcc4edb4b27774c$var$_const2.default.NEXT_PAGE_TEXT,
    lastPageText: $edcc4edb4b27774c$var$_const2.default.LAST_PAGE_TEXT,
    sizePerPageList: $edcc4edb4b27774c$var$_const2.default.SIZE_PER_PAGE_LIST,
    nextPageTitle: $edcc4edb4b27774c$var$_const2.default.NEXT_PAGE_TITLE,
    prePageTitle: $edcc4edb4b27774c$var$_const2.default.PRE_PAGE_TITLE,
    firstPageTitle: $edcc4edb4b27774c$var$_const2.default.FIRST_PAGE_TITLE,
    lastPageTitle: $edcc4edb4b27774c$var$_const2.default.LAST_PAGE_TITLE,
    hideSizePerPage: $edcc4edb4b27774c$var$_const2.default.HIDE_SIZE_PER_PAGE,
    hidePageListOnlyOnePage: $edcc4edb4b27774c$var$_const2.default.HIDE_PAGE_LIST_ONLY_ONE_PAGE
};
module.exports.default = (0, $edcc4edb4b27774c$var$_paginationHandler2.default)($edcc4edb4b27774c$var$Pagination);

});
parcelRegister("9pNe0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $6daca1ea86485e90$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $lL9M3 = parcelRequire("lL9M3");
var $6daca1ea86485e90$var$_const2 = $6daca1ea86485e90$var$_interopRequireDefault($lL9M3);
function $6daca1ea86485e90$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6daca1ea86485e90$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $6daca1ea86485e90$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $6daca1ea86485e90$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint no-mixed-operators: 0 */ 
module.exports.default = function(ExtendBase) {
    return function(_ExtendBase) {
        $6daca1ea86485e90$var$_inherits(PageResolver, _ExtendBase);
        function PageResolver() {
            $6daca1ea86485e90$var$_classCallCheck(this, PageResolver);
            return $6daca1ea86485e90$var$_possibleConstructorReturn(this, (PageResolver.__proto__ || Object.getPrototypeOf(PageResolver)).apply(this, arguments));
        }
        $6daca1ea86485e90$var$_createClass(PageResolver, [
            {
                key: "backToPrevPage",
                value: function backToPrevPage() {
                    var _props = this.props, currPage = _props.currPage, pageStartIndex = _props.pageStartIndex;
                    return currPage - 1 < pageStartIndex ? pageStartIndex : currPage - 1;
                }
            },
            {
                key: "initialState",
                value: function initialState() {
                    var totalPages = this.calculateTotalPage();
                    var lastPage = this.calculateLastPage(totalPages);
                    return {
                        totalPages: totalPages,
                        lastPage: lastPage
                    };
                }
            },
            {
                key: "calculateTotalPage",
                value: function calculateTotalPage() {
                    var sizePerPage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.currSizePerPage;
                    var dataSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props.dataSize;
                    return Math.ceil(dataSize / sizePerPage);
                }
            },
            {
                key: "calculateLastPage",
                value: function calculateLastPage(totalPages) {
                    var pageStartIndex = this.props.pageStartIndex;
                    return pageStartIndex + totalPages - 1;
                }
            },
            {
                key: "calculateFromTo",
                value: function calculateFromTo() {
                    var _props2 = this.props, dataSize = _props2.dataSize, currPage = _props2.currPage, currSizePerPage = _props2.currSizePerPage, pageStartIndex = _props2.pageStartIndex;
                    var offset = Math.abs($6daca1ea86485e90$var$_const2.default.PAGE_START_INDEX - pageStartIndex);
                    var from = (currPage - pageStartIndex) * currSizePerPage;
                    from = dataSize === 0 ? 0 : from + 1;
                    var to = Math.min(currSizePerPage * (currPage + offset), dataSize);
                    if (to > dataSize) to = dataSize;
                    return [
                        from,
                        to
                    ];
                }
            },
            {
                key: "calculatePages",
                value: function calculatePages(totalPages, lastPage) {
                    var _props3 = this.props, currPage = _props3.currPage, paginationSize = _props3.paginationSize, pageStartIndex = _props3.pageStartIndex, withFirstAndLast = _props3.withFirstAndLast, firstPageText = _props3.firstPageText, prePageText = _props3.prePageText, nextPageText = _props3.nextPageText, lastPageText = _props3.lastPageText, alwaysShowAllBtns = _props3.alwaysShowAllBtns;
                    var pages = [];
                    var endPage = totalPages;
                    if (endPage <= 0) return [];
                    var startPage = Math.max(currPage - Math.floor(paginationSize / 2), pageStartIndex);
                    endPage = startPage + paginationSize - 1;
                    if (endPage > lastPage) {
                        endPage = lastPage;
                        startPage = endPage - paginationSize + 1;
                    }
                    if (alwaysShowAllBtns) {
                        if (withFirstAndLast) pages = [
                            firstPageText,
                            prePageText
                        ];
                        else pages = [
                            prePageText
                        ];
                    }
                    if (startPage !== pageStartIndex && totalPages > paginationSize && withFirstAndLast && pages.length === 0) pages = [
                        firstPageText,
                        prePageText
                    ];
                    else if (totalPages > 1 && pages.length === 0) pages = [
                        prePageText
                    ];
                    for(var i = startPage; i <= endPage; i += 1)if (i >= pageStartIndex) pages.push(i);
                    if (alwaysShowAllBtns || endPage <= lastPage && pages.length > 1) pages.push(nextPageText);
                    if (endPage !== lastPage && withFirstAndLast || withFirstAndLast && alwaysShowAllBtns) pages.push(lastPageText);
                    // if ((endPage <= lastPage && pages.length > 1) || alwaysShowAllBtns) {
                    //   pages.push(nextPageText);
                    // }
                    // if (endPage !== lastPage && withFirstAndLast) {
                    //   pages.push(lastPageText);
                    // }
                    return pages;
                }
            },
            {
                key: "calculatePageStatus",
                value: function calculatePageStatus() {
                    var pages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                    var _this2 = this;
                    var lastPage = arguments[1];
                    var disablePageTitle = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                    var _props4 = this.props, currPage = _props4.currPage, pageStartIndex = _props4.pageStartIndex, firstPageText = _props4.firstPageText, prePageText = _props4.prePageText, nextPageText = _props4.nextPageText, lastPageText = _props4.lastPageText, alwaysShowAllBtns = _props4.alwaysShowAllBtns;
                    var isStart = function isStart(page) {
                        return currPage === pageStartIndex && (page === firstPageText || page === prePageText);
                    };
                    var isEnd = function isEnd(page) {
                        return currPage === lastPage && (page === nextPageText || page === lastPageText);
                    };
                    return pages.filter(function(page) {
                        if (alwaysShowAllBtns) return true;
                        return !(isStart(page) || isEnd(page));
                    }).map(function(page) {
                        var title = void 0;
                        var active = page === currPage;
                        var disabled = isStart(page) || isEnd(page);
                        if (page === nextPageText) title = _this2.props.nextPageTitle;
                        else if (page === prePageText) title = _this2.props.prePageTitle;
                        else if (page === firstPageText) title = _this2.props.firstPageTitle;
                        else if (page === lastPageText) title = _this2.props.lastPageTitle;
                        else title = "" + page;
                        var pageResult = {
                            page: page,
                            active: active,
                            disabled: disabled
                        };
                        if (!disablePageTitle) pageResult.title = title;
                        return pageResult;
                    });
                }
            },
            {
                key: "calculateSizePerPageStatus",
                value: function calculateSizePerPageStatus() {
                    var sizePerPageList = this.props.sizePerPageList;
                    return sizePerPageList.map(function(_sizePerPage) {
                        var pageText = typeof _sizePerPage.text !== "undefined" ? _sizePerPage.text : _sizePerPage;
                        var pageNumber = typeof _sizePerPage.value !== "undefined" ? _sizePerPage.value : _sizePerPage;
                        return {
                            text: "" + pageText,
                            page: pageNumber
                        };
                    });
                }
            }
        ]);
        return PageResolver;
    }(ExtendBase);
};

});

parcelRegister("gtC0Q", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $bfecd745a3135b26$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $bfecd745a3135b26$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $bfecd745a3135b26$var$_react2 = $bfecd745a3135b26$var$_interopRequireDefault($acw62);

var $9pNe0 = parcelRequire("9pNe0");
var $bfecd745a3135b26$var$_pageResolver3 = $bfecd745a3135b26$var$_interopRequireDefault($9pNe0);
function $bfecd745a3135b26$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $bfecd745a3135b26$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $bfecd745a3135b26$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $bfecd745a3135b26$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint react/prop-types: 0 */ 
/* eslint camelcase: 0 */ module.exports.default = function(WrappedComponent) {
    return function(_pageResolver) {
        $bfecd745a3135b26$var$_inherits(PaginationHandler, _pageResolver);
        function PaginationHandler(props) {
            $bfecd745a3135b26$var$_classCallCheck(this, PaginationHandler);
            var _this = $bfecd745a3135b26$var$_possibleConstructorReturn(this, (PaginationHandler.__proto__ || Object.getPrototypeOf(PaginationHandler)).call(this, props));
            _this.handleChangePage = _this.handleChangePage.bind(_this);
            _this.handleChangeSizePerPage = _this.handleChangeSizePerPage.bind(_this);
            _this.state = _this.initialState();
            return _this;
        }
        $bfecd745a3135b26$var$_createClass(PaginationHandler, [
            {
                key: "UNSAFE_componentWillReceiveProps",
                value: function UNSAFE_componentWillReceiveProps(nextProps) {
                    var dataSize = nextProps.dataSize, currSizePerPage = nextProps.currSizePerPage;
                    if (currSizePerPage !== this.props.currSizePerPage || dataSize !== this.props.dataSize) {
                        var totalPages = this.calculateTotalPage(currSizePerPage, dataSize);
                        var lastPage = this.calculateLastPage(totalPages);
                        this.setState({
                            totalPages: totalPages,
                            lastPage: lastPage
                        });
                    }
                }
            },
            {
                key: "handleChangeSizePerPage",
                value: function handleChangeSizePerPage(sizePerPage) {
                    var _props = this.props, currSizePerPage = _props.currSizePerPage, onSizePerPageChange = _props.onSizePerPageChange;
                    var selectedSize = typeof sizePerPage === "string" ? parseInt(sizePerPage, 10) : sizePerPage;
                    var currPage = this.props.currPage;
                    if (selectedSize !== currSizePerPage) {
                        var newTotalPages = this.calculateTotalPage(selectedSize);
                        var newLastPage = this.calculateLastPage(newTotalPages);
                        if (currPage > newLastPage) currPage = newLastPage;
                        onSizePerPageChange(selectedSize, currPage);
                    }
                }
            },
            {
                key: "handleChangePage",
                value: function handleChangePage(newPage) {
                    var page = void 0;
                    var _props2 = this.props, currPage = _props2.currPage, pageStartIndex = _props2.pageStartIndex, prePageText = _props2.prePageText, nextPageText = _props2.nextPageText, lastPageText = _props2.lastPageText, firstPageText = _props2.firstPageText, onPageChange = _props2.onPageChange;
                    var lastPage = this.state.lastPage;
                    if (newPage === prePageText) page = this.backToPrevPage();
                    else if (newPage === nextPageText) page = currPage + 1 > lastPage ? lastPage : currPage + 1;
                    else if (newPage === lastPageText) page = lastPage;
                    else if (newPage === firstPageText) page = pageStartIndex;
                    else page = parseInt(newPage, 10);
                    if (page !== currPage) onPageChange(page);
                }
            },
            {
                key: "render",
                value: function render() {
                    return $bfecd745a3135b26$var$_react2.default.createElement(WrappedComponent, $bfecd745a3135b26$var$_extends({}, this.props, {
                        lastPage: this.state.lastPage,
                        totalPages: this.state.totalPages,
                        onPageChange: this.handleChangePage,
                        onSizePerPageChange: this.handleChangeSizePerPage
                    }));
                }
            }
        ]);
        return PaginationHandler;
    }((0, $bfecd745a3135b26$var$_pageResolver3.default)($acw62.Component));
};

});

parcelRegister("8Fqt9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SizePerPageDropdownWithAdapter = undefined;
var $64f6af44b8fa0128$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $64f6af44b8fa0128$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $64f6af44b8fa0128$var$_react2 = $64f6af44b8fa0128$var$_interopRequireDefault($acw62);

var $9pNe0 = parcelRequire("9pNe0");
var $64f6af44b8fa0128$var$_pageResolver3 = $64f6af44b8fa0128$var$_interopRequireDefault($9pNe0);

var $aEHom = parcelRequire("aEHom");
var $64f6af44b8fa0128$var$_sizePerPageDropdown2 = $64f6af44b8fa0128$var$_interopRequireDefault($aEHom);
function $64f6af44b8fa0128$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $64f6af44b8fa0128$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $64f6af44b8fa0128$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $64f6af44b8fa0128$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint react/prop-types: 0 */ 
var $64f6af44b8fa0128$var$sizePerPageDropdownAdapter = function sizePerPageDropdownAdapter(WrappedComponent) {
    return function(_pageResolver) {
        $64f6af44b8fa0128$var$_inherits(SizePerPageDropdownAdapter, _pageResolver);
        function SizePerPageDropdownAdapter(props) {
            $64f6af44b8fa0128$var$_classCallCheck(this, SizePerPageDropdownAdapter);
            var _this = $64f6af44b8fa0128$var$_possibleConstructorReturn(this, (SizePerPageDropdownAdapter.__proto__ || Object.getPrototypeOf(SizePerPageDropdownAdapter)).call(this, props));
            _this.closeDropDown = _this.closeDropDown.bind(_this);
            _this.toggleDropDown = _this.toggleDropDown.bind(_this);
            _this.handleChangeSizePerPage = _this.handleChangeSizePerPage.bind(_this);
            _this.state = {
                dropdownOpen: false
            };
            return _this;
        }
        $64f6af44b8fa0128$var$_createClass(SizePerPageDropdownAdapter, [
            {
                key: "toggleDropDown",
                value: function toggleDropDown() {
                    var dropdownOpen = !this.state.dropdownOpen;
                    this.setState(function() {
                        return {
                            dropdownOpen: dropdownOpen
                        };
                    });
                }
            },
            {
                key: "closeDropDown",
                value: function closeDropDown() {
                    this.setState(function() {
                        return {
                            dropdownOpen: false
                        };
                    });
                }
            },
            {
                key: "handleChangeSizePerPage",
                value: function handleChangeSizePerPage(sizePerPage) {
                    this.props.onSizePerPageChange(sizePerPage);
                    this.closeDropDown();
                }
            },
            {
                key: "render",
                value: function render() {
                    var _props = this.props, tableId = _props.tableId, bootstrap4 = _props.bootstrap4, sizePerPageList = _props.sizePerPageList, currSizePerPage = _props.currSizePerPage, hideSizePerPage = _props.hideSizePerPage, sizePerPageRenderer = _props.sizePerPageRenderer, sizePerPageOptionRenderer = _props.sizePerPageOptionRenderer;
                    var open = this.state.dropdownOpen;
                    if (sizePerPageList.length > 1 && !hideSizePerPage) {
                        if (sizePerPageRenderer) return sizePerPageRenderer({
                            options: this.calculateSizePerPageStatus(),
                            currSizePerPage: "" + currSizePerPage,
                            onSizePerPageChange: this.handleChangeSizePerPage
                        });
                        return $64f6af44b8fa0128$var$_react2.default.createElement(WrappedComponent, $64f6af44b8fa0128$var$_extends({}, this.props, {
                            currSizePerPage: "" + currSizePerPage,
                            options: this.calculateSizePerPageStatus(),
                            optionRenderer: sizePerPageOptionRenderer,
                            onSizePerPageChange: this.handleChangeSizePerPage,
                            onClick: this.toggleDropDown,
                            onBlur: this.closeDropDown,
                            open: open,
                            tableId: tableId,
                            bootstrap4: bootstrap4
                        }));
                    }
                    return null;
                }
            }
        ]);
        return SizePerPageDropdownAdapter;
    }((0, $64f6af44b8fa0128$var$_pageResolver3.default)($acw62.Component));
};
var $64f6af44b8fa0128$var$SizePerPageDropdownWithAdapter = module.exports.SizePerPageDropdownWithAdapter = $64f6af44b8fa0128$var$sizePerPageDropdownAdapter($64f6af44b8fa0128$var$_sizePerPageDropdown2.default);
module.exports.default = $64f6af44b8fa0128$var$sizePerPageDropdownAdapter;

});
parcelRegister("aEHom", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $7c1f4c86e799bbb9$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $acw62 = parcelRequire("acw62");
var $7c1f4c86e799bbb9$var$_react2 = $7c1f4c86e799bbb9$var$_interopRequireDefault($acw62);

var $8g1PZ = parcelRequire("8g1PZ");
var $7c1f4c86e799bbb9$var$_classnames2 = $7c1f4c86e799bbb9$var$_interopRequireDefault($8g1PZ);

var $c9Z8w = parcelRequire("c9Z8w");
var $7c1f4c86e799bbb9$var$_propTypes2 = $7c1f4c86e799bbb9$var$_interopRequireDefault($c9Z8w);

var $fSuIB = parcelRequire("fSuIB");
var $7c1f4c86e799bbb9$var$_sizePerPageOption2 = $7c1f4c86e799bbb9$var$_interopRequireDefault($fSuIB);
function $7c1f4c86e799bbb9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $7c1f4c86e799bbb9$var$sizePerPageDefaultClass = "react-bs-table-sizePerPage-dropdown";
var $7c1f4c86e799bbb9$var$SizePerPageDropDown = function SizePerPageDropDown(props) {
    var open = props.open, tableId = props.tableId, hidden = props.hidden, onClick = props.onClick, onBlur = props.onBlur, options = props.options, className = props.className, variation = props.variation, bootstrap4 = props.bootstrap4, btnContextual = props.btnContextual, optionRenderer = props.optionRenderer, currSizePerPage = props.currSizePerPage, onSizePerPageChange = props.onSizePerPageChange;
    var dropDownStyle = {
        visibility: hidden ? "hidden" : "visible"
    };
    var openClass = open ? "open show" : "";
    var dropdownClasses = (0, $7c1f4c86e799bbb9$var$_classnames2.default)(openClass, $7c1f4c86e799bbb9$var$sizePerPageDefaultClass, variation, className);
    var id = tableId ? tableId + "-pageDropDown" : "pageDropDown";
    return $7c1f4c86e799bbb9$var$_react2.default.createElement("span", {
        style: dropDownStyle,
        className: dropdownClasses
    }, $7c1f4c86e799bbb9$var$_react2.default.createElement("button", {
        id: id,
        type: "button",
        className: "btn " + btnContextual + " dropdown-toggle",
        "data-toggle": "dropdown",
        "aria-expanded": open,
        onClick: onClick,
        onBlur: onBlur
    }, currSizePerPage, " ", bootstrap4 ? null : $7c1f4c86e799bbb9$var$_react2.default.createElement("span", null, $7c1f4c86e799bbb9$var$_react2.default.createElement("span", {
        className: "caret"
    }))), $7c1f4c86e799bbb9$var$_react2.default.createElement("ul", {
        className: "dropdown-menu " + openClass,
        role: "menu",
        "aria-labelledby": id
    }, options.map(function(option) {
        if (optionRenderer) return optionRenderer($7c1f4c86e799bbb9$var$_extends({}, option, {
            onSizePerPageChange: onSizePerPageChange
        }));
        return $7c1f4c86e799bbb9$var$_react2.default.createElement($7c1f4c86e799bbb9$var$_sizePerPageOption2.default, $7c1f4c86e799bbb9$var$_extends({}, option, {
            key: option.text,
            bootstrap4: bootstrap4,
            onSizePerPageChange: onSizePerPageChange
        }));
    })));
};
$7c1f4c86e799bbb9$var$SizePerPageDropDown.propTypes = {
    currSizePerPage: $7c1f4c86e799bbb9$var$_propTypes2.default.string.isRequired,
    options: $7c1f4c86e799bbb9$var$_propTypes2.default.array.isRequired,
    onClick: $7c1f4c86e799bbb9$var$_propTypes2.default.func.isRequired,
    onBlur: $7c1f4c86e799bbb9$var$_propTypes2.default.func.isRequired,
    onSizePerPageChange: $7c1f4c86e799bbb9$var$_propTypes2.default.func.isRequired,
    bootstrap4: $7c1f4c86e799bbb9$var$_propTypes2.default.bool,
    tableId: $7c1f4c86e799bbb9$var$_propTypes2.default.string,
    open: $7c1f4c86e799bbb9$var$_propTypes2.default.bool,
    hidden: $7c1f4c86e799bbb9$var$_propTypes2.default.bool,
    btnContextual: $7c1f4c86e799bbb9$var$_propTypes2.default.string,
    variation: $7c1f4c86e799bbb9$var$_propTypes2.default.oneOf([
        "dropdown",
        "dropup"
    ]),
    className: $7c1f4c86e799bbb9$var$_propTypes2.default.string,
    optionRenderer: $7c1f4c86e799bbb9$var$_propTypes2.default.func
};
$7c1f4c86e799bbb9$var$SizePerPageDropDown.defaultProps = {
    open: false,
    hidden: false,
    btnContextual: "btn-default btn-secondary",
    variation: "dropdown",
    className: "",
    optionRenderer: null,
    bootstrap4: false,
    tableId: null
};
module.exports.default = $7c1f4c86e799bbb9$var$SizePerPageDropDown;

});
parcelRegister("fSuIB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $acw62 = parcelRequire("acw62");
var $b8f3ba380f711baa$var$_react2 = $b8f3ba380f711baa$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");
var $b8f3ba380f711baa$var$_propTypes2 = $b8f3ba380f711baa$var$_interopRequireDefault($c9Z8w);
function $b8f3ba380f711baa$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
/* eslint jsx-a11y/href-no-hash: 0 */ var $b8f3ba380f711baa$var$SizePerPageOption = function SizePerPageOption(_ref) {
    var text = _ref.text, page = _ref.page, onSizePerPageChange = _ref.onSizePerPageChange, bootstrap4 = _ref.bootstrap4;
    return bootstrap4 ? $b8f3ba380f711baa$var$_react2.default.createElement("a", {
        href: "#",
        tabIndex: "-1",
        role: "menuitem",
        className: "dropdown-item",
        "data-page": page,
        onMouseDown: function onMouseDown(e) {
            e.preventDefault();
            onSizePerPageChange(page);
        }
    }, text) : $b8f3ba380f711baa$var$_react2.default.createElement("li", {
        key: text,
        role: "presentation",
        className: "dropdown-item"
    }, $b8f3ba380f711baa$var$_react2.default.createElement("a", {
        href: "#",
        tabIndex: "-1",
        role: "menuitem",
        "data-page": page,
        onMouseDown: function onMouseDown(e) {
            e.preventDefault();
            onSizePerPageChange(page);
        }
    }, text));
};
$b8f3ba380f711baa$var$SizePerPageOption.propTypes = {
    text: $b8f3ba380f711baa$var$_propTypes2.default.string.isRequired,
    page: $b8f3ba380f711baa$var$_propTypes2.default.number.isRequired,
    onSizePerPageChange: $b8f3ba380f711baa$var$_propTypes2.default.func.isRequired,
    bootstrap4: $b8f3ba380f711baa$var$_propTypes2.default.bool
};
$b8f3ba380f711baa$var$SizePerPageOption.defaultProps = {
    bootstrap4: false
};
module.exports.default = $b8f3ba380f711baa$var$SizePerPageOption;

});



parcelRegister("jHBlb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PaginationListWithAdapter = undefined;
var $e57eff932e96383e$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $e57eff932e96383e$var$_react2 = $e57eff932e96383e$var$_interopRequireDefault($acw62);

var $9pNe0 = parcelRequire("9pNe0");
var $e57eff932e96383e$var$_pageResolver3 = $e57eff932e96383e$var$_interopRequireDefault($9pNe0);

var $7Ri2x = parcelRequire("7Ri2x");
var $e57eff932e96383e$var$_paginationList2 = $e57eff932e96383e$var$_interopRequireDefault($7Ri2x);
function $e57eff932e96383e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e57eff932e96383e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e57eff932e96383e$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $e57eff932e96383e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint react/prop-types: 0 */ 
var $e57eff932e96383e$var$paginationListAdapter = function paginationListAdapter(WrappedComponent) {
    return function(_pageResolver) {
        $e57eff932e96383e$var$_inherits(PaginationListAdapter, _pageResolver);
        function PaginationListAdapter() {
            $e57eff932e96383e$var$_classCallCheck(this, PaginationListAdapter);
            return $e57eff932e96383e$var$_possibleConstructorReturn(this, (PaginationListAdapter.__proto__ || Object.getPrototypeOf(PaginationListAdapter)).apply(this, arguments));
        }
        $e57eff932e96383e$var$_createClass(PaginationListAdapter, [
            {
                key: "render",
                value: function render() {
                    var _props = this.props, lastPage = _props.lastPage, totalPages = _props.totalPages, pageButtonRenderer = _props.pageButtonRenderer, onPageChange = _props.onPageChange, disablePageTitle = _props.disablePageTitle, hidePageListOnlyOnePage = _props.hidePageListOnlyOnePage;
                    var pages = this.calculatePageStatus(this.calculatePages(totalPages, lastPage), lastPage, disablePageTitle);
                    if (totalPages === 1 && hidePageListOnlyOnePage) return null;
                    return $e57eff932e96383e$var$_react2.default.createElement(WrappedComponent, {
                        pageButtonRenderer: pageButtonRenderer,
                        onPageChange: onPageChange,
                        pages: pages
                    });
                }
            }
        ]);
        return PaginationListAdapter;
    }((0, $e57eff932e96383e$var$_pageResolver3.default)($acw62.Component));
};
var $e57eff932e96383e$var$PaginationListWithAdapter = module.exports.PaginationListWithAdapter = $e57eff932e96383e$var$paginationListAdapter($e57eff932e96383e$var$_paginationList2.default);
module.exports.default = $e57eff932e96383e$var$paginationListAdapter;

});
parcelRegister("7Ri2x", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $5b8b79fc46b88cd5$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $acw62 = parcelRequire("acw62");
var $5b8b79fc46b88cd5$var$_react2 = $5b8b79fc46b88cd5$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");
var $5b8b79fc46b88cd5$var$_propTypes2 = $5b8b79fc46b88cd5$var$_interopRequireDefault($c9Z8w);

var $ZlFfb = parcelRequire("ZlFfb");
var $5b8b79fc46b88cd5$var$_pageButton2 = $5b8b79fc46b88cd5$var$_interopRequireDefault($ZlFfb);
function $5b8b79fc46b88cd5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $5b8b79fc46b88cd5$var$PaginatonList = function PaginatonList(props) {
    return $5b8b79fc46b88cd5$var$_react2.default.createElement("ul", {
        className: "pagination react-bootstrap-table-page-btns-ul"
    }, props.pages.map(function(pageProps) {
        if (props.pageButtonRenderer) return props.pageButtonRenderer($5b8b79fc46b88cd5$var$_extends({}, pageProps, {
            onPageChange: props.onPageChange
        }));
        return $5b8b79fc46b88cd5$var$_react2.default.createElement($5b8b79fc46b88cd5$var$_pageButton2.default, $5b8b79fc46b88cd5$var$_extends({
            key: pageProps.page
        }, pageProps, {
            onPageChange: props.onPageChange
        }));
    }));
};
$5b8b79fc46b88cd5$var$PaginatonList.propTypes = {
    pages: $5b8b79fc46b88cd5$var$_propTypes2.default.arrayOf($5b8b79fc46b88cd5$var$_propTypes2.default.shape({
        page: $5b8b79fc46b88cd5$var$_propTypes2.default.oneOfType([
            $5b8b79fc46b88cd5$var$_propTypes2.default.node,
            $5b8b79fc46b88cd5$var$_propTypes2.default.number,
            $5b8b79fc46b88cd5$var$_propTypes2.default.string
        ]),
        active: $5b8b79fc46b88cd5$var$_propTypes2.default.bool,
        disable: $5b8b79fc46b88cd5$var$_propTypes2.default.bool,
        title: $5b8b79fc46b88cd5$var$_propTypes2.default.string
    })).isRequired,
    onPageChange: $5b8b79fc46b88cd5$var$_propTypes2.default.func.isRequired,
    pageButtonRenderer: $5b8b79fc46b88cd5$var$_propTypes2.default.func
};
$5b8b79fc46b88cd5$var$PaginatonList.defaultProps = {
    pageButtonRenderer: null
};
module.exports.default = $5b8b79fc46b88cd5$var$PaginatonList;

});
parcelRegister("ZlFfb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $0b8680af0ff5d866$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $8g1PZ = parcelRequire("8g1PZ");
var $0b8680af0ff5d866$var$_classnames2 = $0b8680af0ff5d866$var$_interopRequireDefault($8g1PZ);

var $acw62 = parcelRequire("acw62");
var $0b8680af0ff5d866$var$_react2 = $0b8680af0ff5d866$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");
var $0b8680af0ff5d866$var$_propTypes2 = $0b8680af0ff5d866$var$_interopRequireDefault($c9Z8w);
function $0b8680af0ff5d866$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0b8680af0ff5d866$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $0b8680af0ff5d866$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $0b8680af0ff5d866$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint react/require-default-props: 0 */ 
/* eslint jsx-a11y/href-no-hash: 0 */ var $0b8680af0ff5d866$var$PageButton = function(_Component) {
    $0b8680af0ff5d866$var$_inherits(PageButton, _Component);
    function PageButton(props) {
        $0b8680af0ff5d866$var$_classCallCheck(this, PageButton);
        var _this = $0b8680af0ff5d866$var$_possibleConstructorReturn(this, (PageButton.__proto__ || Object.getPrototypeOf(PageButton)).call(this, props));
        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }
    $0b8680af0ff5d866$var$_createClass(PageButton, [
        {
            key: "handleClick",
            value: function handleClick(e) {
                e.preventDefault();
                this.props.onPageChange(this.props.page);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, page = _props.page, title = _props.title, active = _props.active, disabled = _props.disabled, className = _props.className;
                var classes = (0, $0b8680af0ff5d866$var$_classnames2.default)({
                    active: active,
                    disabled: disabled,
                    "page-item": true
                }, className);
                return $0b8680af0ff5d866$var$_react2.default.createElement("li", {
                    className: classes,
                    title: title
                }, $0b8680af0ff5d866$var$_react2.default.createElement("a", {
                    href: "#",
                    onClick: this.handleClick,
                    className: "page-link"
                }, page));
            }
        }
    ]);
    return PageButton;
}($acw62.Component);
$0b8680af0ff5d866$var$PageButton.propTypes = {
    onPageChange: $0b8680af0ff5d866$var$_propTypes2.default.func.isRequired,
    page: $0b8680af0ff5d866$var$_propTypes2.default.oneOfType([
        $0b8680af0ff5d866$var$_propTypes2.default.node,
        $0b8680af0ff5d866$var$_propTypes2.default.number,
        $0b8680af0ff5d866$var$_propTypes2.default.string
    ]).isRequired,
    active: $0b8680af0ff5d866$var$_propTypes2.default.bool.isRequired,
    disabled: $0b8680af0ff5d866$var$_propTypes2.default.bool.isRequired,
    className: $0b8680af0ff5d866$var$_propTypes2.default.string,
    title: $0b8680af0ff5d866$var$_propTypes2.default.string
};
module.exports.default = $0b8680af0ff5d866$var$PageButton;

});



parcelRegister("4xKHY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PaginationTotalWithAdapter = undefined;
var $34ee79c2386ed967$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i["return"]) _i["return"]();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}();
var $34ee79c2386ed967$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $34ee79c2386ed967$var$_react2 = $34ee79c2386ed967$var$_interopRequireDefault($acw62);

var $9pNe0 = parcelRequire("9pNe0");
var $34ee79c2386ed967$var$_pageResolver3 = $34ee79c2386ed967$var$_interopRequireDefault($9pNe0);

var $3r4fN = parcelRequire("3r4fN");
var $34ee79c2386ed967$var$_paginationTotal2 = $34ee79c2386ed967$var$_interopRequireDefault($3r4fN);
function $34ee79c2386ed967$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $34ee79c2386ed967$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $34ee79c2386ed967$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $34ee79c2386ed967$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint react/prop-types: 0 */ 
var $34ee79c2386ed967$var$paginationTotalAdapter = function paginationTotalAdapter(WrappedComponent) {
    return function(_pageResolver) {
        $34ee79c2386ed967$var$_inherits(PaginationTotalAdapter, _pageResolver);
        function PaginationTotalAdapter() {
            $34ee79c2386ed967$var$_classCallCheck(this, PaginationTotalAdapter);
            return $34ee79c2386ed967$var$_possibleConstructorReturn(this, (PaginationTotalAdapter.__proto__ || Object.getPrototypeOf(PaginationTotalAdapter)).apply(this, arguments));
        }
        $34ee79c2386ed967$var$_createClass(PaginationTotalAdapter, [
            {
                key: "render",
                value: function render() {
                    var _calculateFromTo = this.calculateFromTo(), _calculateFromTo2 = $34ee79c2386ed967$var$_slicedToArray(_calculateFromTo, 2), from = _calculateFromTo2[0], to = _calculateFromTo2[1];
                    return $34ee79c2386ed967$var$_react2.default.createElement(WrappedComponent, {
                        from: from,
                        to: to,
                        dataSize: this.props.dataSize,
                        paginationTotalRenderer: this.props.paginationTotalRenderer
                    });
                }
            }
        ]);
        return PaginationTotalAdapter;
    }((0, $34ee79c2386ed967$var$_pageResolver3.default)($acw62.Component));
};
var $34ee79c2386ed967$var$PaginationTotalWithAdapter = module.exports.PaginationTotalWithAdapter = $34ee79c2386ed967$var$paginationTotalAdapter($34ee79c2386ed967$var$_paginationTotal2.default);
module.exports.default = $34ee79c2386ed967$var$paginationTotalAdapter;

});
parcelRegister("3r4fN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $acw62 = parcelRequire("acw62");
var $2807317217a39586$var$_react2 = $2807317217a39586$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");
var $2807317217a39586$var$_propTypes2 = $2807317217a39586$var$_interopRequireDefault($c9Z8w);
function $2807317217a39586$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $2807317217a39586$var$PaginationTotal = function PaginationTotal(props) {
    if (props.paginationTotalRenderer) return props.paginationTotalRenderer(props.from, props.to, props.dataSize);
    return $2807317217a39586$var$_react2.default.createElement("span", {
        className: "react-bootstrap-table-pagination-total"
    }, "\xa0Showing rows ", props.from, " to\xa0", props.to, " of\xa0", props.dataSize);
};
$2807317217a39586$var$PaginationTotal.propTypes = {
    from: $2807317217a39586$var$_propTypes2.default.number.isRequired,
    to: $2807317217a39586$var$_propTypes2.default.number.isRequired,
    dataSize: $2807317217a39586$var$_propTypes2.default.number.isRequired,
    paginationTotalRenderer: $2807317217a39586$var$_propTypes2.default.func
};
$2807317217a39586$var$PaginationTotal.defaultProps = {
    paginationTotalRenderer: undefined
};
module.exports.default = $2807317217a39586$var$PaginationTotal;

});




parcelRegister("25TJx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $acw62 = parcelRequire("acw62");
var $186747e5c4fb1bc1$var$_react2 = $186747e5c4fb1bc1$var$_interopRequireDefault($acw62);

var $7Ri2x = parcelRequire("7Ri2x");
var $186747e5c4fb1bc1$var$_paginationList2 = $186747e5c4fb1bc1$var$_interopRequireDefault($7Ri2x);

var $3drt2 = parcelRequire("3drt2");
var $186747e5c4fb1bc1$var$_standaloneAdapter2 = $186747e5c4fb1bc1$var$_interopRequireDefault($3drt2);

var $gtC0Q = parcelRequire("gtC0Q");
var $186747e5c4fb1bc1$var$_paginationHandler2 = $186747e5c4fb1bc1$var$_interopRequireDefault($gtC0Q);

var $jHBlb = parcelRequire("jHBlb");
var $186747e5c4fb1bc1$var$_paginationListAdapter2 = $186747e5c4fb1bc1$var$_interopRequireDefault($jHBlb);
function $186747e5c4fb1bc1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $186747e5c4fb1bc1$var$PaginationListStandalone = function PaginationListStandalone(props) {
    return $186747e5c4fb1bc1$var$_react2.default.createElement($186747e5c4fb1bc1$var$_paginationList2.default, props);
};
module.exports.default = (0, $186747e5c4fb1bc1$var$_standaloneAdapter2.default)((0, $186747e5c4fb1bc1$var$_paginationHandler2.default)((0, $186747e5c4fb1bc1$var$_paginationListAdapter2.default)($186747e5c4fb1bc1$var$PaginationListStandalone)));

});
parcelRegister("3drt2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $2577e474cfb64d01$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $acw62 = parcelRequire("acw62");
var $2577e474cfb64d01$var$_react2 = $2577e474cfb64d01$var$_interopRequireDefault($acw62);
function $2577e474cfb64d01$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2577e474cfb64d01$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
} /* eslint react/prop-types: 0 */ 
module.exports.default = function(WrappedComponent) {
    return function(_ref) {
        var page = _ref.page, sizePerPage = _ref.sizePerPage, rest = $2577e474cfb64d01$var$_objectWithoutProperties(_ref, [
            "page",
            "sizePerPage"
        ]);
        return $2577e474cfb64d01$var$_react2.default.createElement(WrappedComponent, $2577e474cfb64d01$var$_extends({}, rest, {
            currPage: page,
            currSizePerPage: sizePerPage
        }));
    };
};

});


parcelRegister("5Fs90", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $acw62 = parcelRequire("acw62");
var $42069cf2561f0d49$var$_react2 = $42069cf2561f0d49$var$_interopRequireDefault($acw62);

var $aEHom = parcelRequire("aEHom");
var $42069cf2561f0d49$var$_sizePerPageDropdown2 = $42069cf2561f0d49$var$_interopRequireDefault($aEHom);

var $3drt2 = parcelRequire("3drt2");
var $42069cf2561f0d49$var$_standaloneAdapter2 = $42069cf2561f0d49$var$_interopRequireDefault($3drt2);

var $gtC0Q = parcelRequire("gtC0Q");
var $42069cf2561f0d49$var$_paginationHandler2 = $42069cf2561f0d49$var$_interopRequireDefault($gtC0Q);

var $8Fqt9 = parcelRequire("8Fqt9");
var $42069cf2561f0d49$var$_sizePerPageDropdownAdapter2 = $42069cf2561f0d49$var$_interopRequireDefault($8Fqt9);
function $42069cf2561f0d49$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $42069cf2561f0d49$var$SizePerPageDropdownStandalone = function SizePerPageDropdownStandalone(props) {
    return $42069cf2561f0d49$var$_react2.default.createElement($42069cf2561f0d49$var$_sizePerPageDropdown2.default, props);
};
module.exports.default = (0, $42069cf2561f0d49$var$_standaloneAdapter2.default)((0, $42069cf2561f0d49$var$_paginationHandler2.default)((0, $42069cf2561f0d49$var$_sizePerPageDropdownAdapter2.default)($42069cf2561f0d49$var$SizePerPageDropdownStandalone)));

});

parcelRegister("3py5L", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $acw62 = parcelRequire("acw62");
var $27be26d7f4208689$var$_react2 = $27be26d7f4208689$var$_interopRequireDefault($acw62);

var $3r4fN = parcelRequire("3r4fN");
var $27be26d7f4208689$var$_paginationTotal2 = $27be26d7f4208689$var$_interopRequireDefault($3r4fN);

var $3drt2 = parcelRequire("3drt2");
var $27be26d7f4208689$var$_standaloneAdapter2 = $27be26d7f4208689$var$_interopRequireDefault($3drt2);

var $4xKHY = parcelRequire("4xKHY");
var $27be26d7f4208689$var$_paginationTotalAdapter2 = $27be26d7f4208689$var$_interopRequireDefault($4xKHY);
function $27be26d7f4208689$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $27be26d7f4208689$var$PaginationTotalStandalone = function PaginationTotalStandalone(props) {
    return $27be26d7f4208689$var$_react2.default.createElement($27be26d7f4208689$var$_paginationTotal2.default, props);
};
module.exports.default = (0, $27be26d7f4208689$var$_standaloneAdapter2.default)((0, $27be26d7f4208689$var$_paginationTotalAdapter2.default)($27be26d7f4208689$var$PaginationTotalStandalone));

});


parcelRegister("dJwER", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.customFilter = module.exports.dateFilter = module.exports.numberFilter = module.exports.multiSelectFilter = module.exports.selectFilter = module.exports.textFilter = module.exports.Comparator = module.exports.FILTER_TYPES = undefined;

var $dWYB8 = parcelRequire("dWYB8");
var $9ff8cf8414897fe8$var$_text2 = $9ff8cf8414897fe8$var$_interopRequireDefault($dWYB8);

var $aedGZ = parcelRequire("aedGZ");
var $9ff8cf8414897fe8$var$_select2 = $9ff8cf8414897fe8$var$_interopRequireDefault($aedGZ);

var $gDAEh = parcelRequire("gDAEh");
var $9ff8cf8414897fe8$var$_multiselect2 = $9ff8cf8414897fe8$var$_interopRequireDefault($gDAEh);

var $2pKWF = parcelRequire("2pKWF");
var $9ff8cf8414897fe8$var$_number2 = $9ff8cf8414897fe8$var$_interopRequireDefault($2pKWF);

var $gto3g = parcelRequire("gto3g");
var $9ff8cf8414897fe8$var$_date2 = $9ff8cf8414897fe8$var$_interopRequireDefault($gto3g);

var $02Mzi = parcelRequire("02Mzi");
var $9ff8cf8414897fe8$var$_context2 = $9ff8cf8414897fe8$var$_interopRequireDefault($02Mzi);

var $8swRD = parcelRequire("8swRD");
var $9ff8cf8414897fe8$var$Comparison = $9ff8cf8414897fe8$var$_interopRequireWildcard($8swRD);

var $loyZr = parcelRequire("loyZr");
function $9ff8cf8414897fe8$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $9ff8cf8414897fe8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.default = function() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return {
        createContext: $9ff8cf8414897fe8$var$_context2.default,
        options: options
    };
};
var $9ff8cf8414897fe8$var$FILTER_TYPES = module.exports.FILTER_TYPES = $loyZr.FILTER_TYPE;
var $9ff8cf8414897fe8$var$Comparator = module.exports.Comparator = $9ff8cf8414897fe8$var$Comparison;
var $9ff8cf8414897fe8$var$textFilter = module.exports.textFilter = function textFilter() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return {
        Filter: $9ff8cf8414897fe8$var$_text2.default,
        props: props
    };
};
var $9ff8cf8414897fe8$var$selectFilter = module.exports.selectFilter = function selectFilter() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return {
        Filter: $9ff8cf8414897fe8$var$_select2.default,
        props: props
    };
};
var $9ff8cf8414897fe8$var$multiSelectFilter = module.exports.multiSelectFilter = function multiSelectFilter() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return {
        Filter: $9ff8cf8414897fe8$var$_multiselect2.default,
        props: props
    };
};
var $9ff8cf8414897fe8$var$numberFilter = module.exports.numberFilter = function numberFilter() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return {
        Filter: $9ff8cf8414897fe8$var$_number2.default,
        props: props
    };
};
var $9ff8cf8414897fe8$var$dateFilter = module.exports.dateFilter = function dateFilter() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return {
        Filter: $9ff8cf8414897fe8$var$_date2.default,
        props: props
    };
};
var $9ff8cf8414897fe8$var$customFilter = module.exports.customFilter = function customFilter() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return {
        props: props
    };
};

});
parcelRegister("dWYB8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $a27fb2a701914473$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $a27fb2a701914473$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $a27fb2a701914473$var$_react2 = $a27fb2a701914473$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");

var $8swRD = parcelRequire("8swRD");

var $loyZr = parcelRequire("loyZr");
function $a27fb2a701914473$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a27fb2a701914473$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $a27fb2a701914473$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a27fb2a701914473$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $a27fb2a701914473$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint react/require-default-props: 0 */ 
/* eslint react/prop-types: 0 */ /* eslint no-return-assign: 0 */ /* eslint camelcase: 0 */ var $a27fb2a701914473$var$TextFilter = function(_Component) {
    $a27fb2a701914473$var$_inherits(TextFilter, _Component);
    function TextFilter(props) {
        $a27fb2a701914473$var$_classCallCheck(this, TextFilter);
        var _this = $a27fb2a701914473$var$_possibleConstructorReturn(this, (TextFilter.__proto__ || Object.getPrototypeOf(TextFilter)).call(this, props));
        _this.filter = _this.filter.bind(_this);
        _this.handleClick = _this.handleClick.bind(_this);
        _this.timeout = null;
        function getDefaultValue() {
            if (props.filterState && typeof props.filterState.filterVal !== "undefined") return props.filterState.filterVal;
            return props.defaultValue;
        }
        _this.state = {
            value: getDefaultValue()
        };
        return _this;
    }
    $a27fb2a701914473$var$_createClass(TextFilter, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this2 = this;
                var _props = this.props, onFilter = _props.onFilter, getFilter = _props.getFilter, column = _props.column;
                var defaultValue = this.input.value;
                if (defaultValue) onFilter(this.props.column, $loyZr.FILTER_TYPE.TEXT, true)(defaultValue);
                // export onFilter function to allow users to access
                if (getFilter) getFilter(function(filterVal) {
                    _this2.setState(function() {
                        return {
                            value: filterVal
                        };
                    });
                    onFilter(column, $loyZr.FILTER_TYPE.TEXT)(filterVal);
                });
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.cleanTimer();
            }
        },
        {
            key: "UNSAFE_componentWillReceiveProps",
            value: function UNSAFE_componentWillReceiveProps(nextProps) {
                if (nextProps.defaultValue !== this.props.defaultValue) this.applyFilter(nextProps.defaultValue);
            }
        },
        {
            key: "filter",
            value: function filter(e) {
                var _this3 = this;
                e.stopPropagation();
                this.cleanTimer();
                var filterValue = e.target.value;
                this.setState(function() {
                    return {
                        value: filterValue
                    };
                });
                this.timeout = setTimeout(function() {
                    _this3.props.onFilter(_this3.props.column, $loyZr.FILTER_TYPE.TEXT)(filterValue);
                }, this.props.delay);
            }
        },
        {
            key: "cleanTimer",
            value: function cleanTimer() {
                if (this.timeout) clearTimeout(this.timeout);
            }
        },
        {
            key: "cleanFiltered",
            value: function cleanFiltered() {
                var value = this.props.defaultValue;
                this.setState(function() {
                    return {
                        value: value
                    };
                });
                this.props.onFilter(this.props.column, $loyZr.FILTER_TYPE.TEXT)(value);
            }
        },
        {
            key: "applyFilter",
            value: function applyFilter(filterText) {
                this.setState(function() {
                    return {
                        value: filterText
                    };
                });
                this.props.onFilter(this.props.column, $loyZr.FILTER_TYPE.TEXT)(filterText);
            }
        },
        {
            key: "handleClick",
            value: function handleClick(e) {
                e.stopPropagation();
                if (this.props.onClick) this.props.onClick(e);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this4 = this;
                var _props2 = this.props, id = _props2.id, placeholder = _props2.placeholder, _props2$column = _props2.column, dataField = _props2$column.dataField, text = _props2$column.text, style = _props2.style, className = _props2.className, onFilter = _props2.onFilter, caseSensitive = _props2.caseSensitive, defaultValue = _props2.defaultValue, getFilter = _props2.getFilter, filterState = _props2.filterState, rest = $a27fb2a701914473$var$_objectWithoutProperties(_props2, [
                    "id",
                    "placeholder",
                    "column",
                    "style",
                    "className",
                    "onFilter",
                    "caseSensitive",
                    "defaultValue",
                    "getFilter",
                    "filterState"
                ]);
                var elmId = "text-filter-column-" + dataField + (id ? "-" + id : "");
                return $a27fb2a701914473$var$_react2.default.createElement("label", {
                    className: "filter-label",
                    htmlFor: elmId
                }, $a27fb2a701914473$var$_react2.default.createElement("span", {
                    className: "sr-only"
                }, "Filter by ", text), $a27fb2a701914473$var$_react2.default.createElement("input", $a27fb2a701914473$var$_extends({}, rest, {
                    ref: function ref(n) {
                        return _this4.input = n;
                    },
                    type: "text",
                    id: elmId,
                    className: "filter text-filter form-control " + className,
                    style: style,
                    onChange: this.filter,
                    onClick: this.handleClick,
                    placeholder: placeholder || "Enter " + text + "...",
                    value: this.state.value
                })));
            }
        }
    ]);
    return TextFilter;
}($acw62.Component);
$a27fb2a701914473$var$TextFilter.propTypes = {
    onFilter: $c9Z8w.PropTypes.func.isRequired,
    column: $c9Z8w.PropTypes.object.isRequired,
    id: $c9Z8w.PropTypes.string,
    filterState: $c9Z8w.PropTypes.object,
    comparator: $c9Z8w.PropTypes.oneOf([
        $8swRD.LIKE,
        $8swRD.EQ
    ]),
    defaultValue: $c9Z8w.PropTypes.string,
    delay: $c9Z8w.PropTypes.number,
    placeholder: $c9Z8w.PropTypes.string,
    style: $c9Z8w.PropTypes.object,
    className: $c9Z8w.PropTypes.string,
    caseSensitive: $c9Z8w.PropTypes.bool,
    getFilter: $c9Z8w.PropTypes.func
};
$a27fb2a701914473$var$TextFilter.defaultProps = {
    delay: $loyZr.FILTER_DELAY,
    filterState: {},
    defaultValue: "",
    caseSensitive: false,
    id: null
};
module.exports.default = $a27fb2a701914473$var$TextFilter;

});
parcelRegister("8swRD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $628a6e5fe3e2f7e0$var$LIKE = module.exports.LIKE = "LIKE";
var $628a6e5fe3e2f7e0$var$EQ = module.exports.EQ = "=";
var $628a6e5fe3e2f7e0$var$NE = module.exports.NE = "!=";
var $628a6e5fe3e2f7e0$var$GT = module.exports.GT = ">";
var $628a6e5fe3e2f7e0$var$GE = module.exports.GE = ">=";
var $628a6e5fe3e2f7e0$var$LT = module.exports.LT = "<";
var $628a6e5fe3e2f7e0$var$LE = module.exports.LE = "<=";

});

parcelRegister("loyZr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $f936fb24093bf7c6$var$FILTER_TYPE = module.exports.FILTER_TYPE = {
    TEXT: "TEXT",
    SELECT: "SELECT",
    MULTISELECT: "MULTISELECT",
    NUMBER: "NUMBER",
    DATE: "DATE"
};
var $f936fb24093bf7c6$var$FILTER_DELAY = module.exports.FILTER_DELAY = 500;

});


parcelRegister("aedGZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $7725d5370bb6ccd4$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $7725d5370bb6ccd4$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $7725d5370bb6ccd4$var$_react2 = $7725d5370bb6ccd4$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");
var $7725d5370bb6ccd4$var$_propTypes2 = $7725d5370bb6ccd4$var$_interopRequireDefault($c9Z8w);

var $8swRD = parcelRequire("8swRD");

var $loyZr = parcelRequire("loyZr");
function $7725d5370bb6ccd4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $7725d5370bb6ccd4$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $7725d5370bb6ccd4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7725d5370bb6ccd4$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $7725d5370bb6ccd4$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint react/require-default-props: 0 */ 
/* eslint no-return-assign: 0 */ /* eslint react/no-unused-prop-types: 0 */ /* eslint class-methods-use-this: 0 */ function $7725d5370bb6ccd4$var$optionsEquals(currOpts, prevOpts) {
    if (Array.isArray(currOpts)) {
        if (currOpts.length === prevOpts.length) {
            for(var i = 0; i < currOpts.length; i += 1){
                if (currOpts[i].value !== prevOpts[i].value || currOpts[i].label !== prevOpts[i].label) return false;
            }
            return true;
        }
        return false;
    }
    var keys = Object.keys(currOpts);
    for(var _i = 0; _i < keys.length; _i += 1){
        if (currOpts[keys[_i]] !== prevOpts[keys[_i]]) return false;
    }
    return Object.keys(currOpts).length === Object.keys(prevOpts).length;
}
function $7725d5370bb6ccd4$var$getOptionValue(options, key) {
    if (Array.isArray(options)) {
        var result = options.filter(function(_ref) {
            var label = _ref.label;
            return label === key;
        }).map(function(_ref2) {
            var value = _ref2.value;
            return value;
        });
        return result[0];
    }
    return options[key];
}
var $7725d5370bb6ccd4$var$SelectFilter = function(_Component) {
    $7725d5370bb6ccd4$var$_inherits(SelectFilter, _Component);
    function SelectFilter(props) {
        $7725d5370bb6ccd4$var$_classCallCheck(this, SelectFilter);
        var _this = $7725d5370bb6ccd4$var$_possibleConstructorReturn(this, (SelectFilter.__proto__ || Object.getPrototypeOf(SelectFilter)).call(this, props));
        _this.filter = _this.filter.bind(_this);
        _this.options = _this.getOptions(props);
        var isSelected = $7725d5370bb6ccd4$var$getOptionValue(_this.options, _this.getDefaultValue()) !== undefined;
        _this.state = {
            isSelected: isSelected
        };
        return _this;
    }
    $7725d5370bb6ccd4$var$_createClass(SelectFilter, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this2 = this;
                var _props = this.props, column = _props.column, onFilter = _props.onFilter, getFilter = _props.getFilter;
                var value = this.selectInput.value;
                if (value && value !== "") onFilter(column, $loyZr.FILTER_TYPE.SELECT, true)(value);
                // export onFilter function to allow users to access
                if (getFilter) getFilter(function(filterVal) {
                    _this2.setState(function() {
                        return {
                            isSelected: filterVal !== ""
                        };
                    });
                    _this2.selectInput.value = filterVal;
                    onFilter(column, $loyZr.FILTER_TYPE.SELECT)(filterVal);
                });
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var needFilter = false;
                var _props2 = this.props, column = _props2.column, onFilter = _props2.onFilter, defaultValue = _props2.defaultValue;
                var nextOptions = this.getOptions(this.props);
                if (defaultValue !== prevProps.defaultValue) needFilter = true;
                else if (!$7725d5370bb6ccd4$var$optionsEquals(nextOptions, this.options)) {
                    this.options = nextOptions;
                    needFilter = true;
                }
                if (needFilter) {
                    var value = this.selectInput.value;
                    if (value) onFilter(column, $loyZr.FILTER_TYPE.SELECT)(value);
                }
            }
        },
        {
            key: "getOptions",
            value: function getOptions(props) {
                return typeof props.options === "function" ? props.options(props.column) : props.options;
            }
        },
        {
            key: "getDefaultValue",
            value: function getDefaultValue() {
                var _props3 = this.props, filterState = _props3.filterState, defaultValue = _props3.defaultValue;
                if (filterState && typeof filterState.filterVal !== "undefined") return filterState.filterVal;
                return defaultValue;
            }
        },
        {
            key: "cleanFiltered",
            value: function cleanFiltered() {
                var value = this.props.defaultValue !== undefined ? this.props.defaultValue : "";
                this.setState(function() {
                    return {
                        isSelected: value !== ""
                    };
                });
                this.selectInput.value = value;
                this.props.onFilter(this.props.column, $loyZr.FILTER_TYPE.SELECT)(value);
            }
        },
        {
            key: "applyFilter",
            value: function applyFilter(value) {
                this.selectInput.value = value;
                this.setState(function() {
                    return {
                        isSelected: value !== ""
                    };
                });
                this.props.onFilter(this.props.column, $loyZr.FILTER_TYPE.SELECT)(value);
            }
        },
        {
            key: "filter",
            value: function filter(e) {
                var value = e.target.value;
                this.setState(function() {
                    return {
                        isSelected: value !== ""
                    };
                });
                this.props.onFilter(this.props.column, $loyZr.FILTER_TYPE.SELECT)(value);
            }
        },
        {
            key: "renderOptions",
            value: function renderOptions() {
                var optionTags = [];
                var options = this.options;
                var _props4 = this.props, placeholder = _props4.placeholder, column = _props4.column, withoutEmptyOption = _props4.withoutEmptyOption;
                if (!withoutEmptyOption) optionTags.push($7725d5370bb6ccd4$var$_react2.default.createElement("option", {
                    key: "-1",
                    value: ""
                }, placeholder || "Select " + column.text + "..."));
                if (Array.isArray(options)) options.forEach(function(_ref3) {
                    var value = _ref3.value, label = _ref3.label;
                    return optionTags.push($7725d5370bb6ccd4$var$_react2.default.createElement("option", {
                        key: value,
                        value: value
                    }, label));
                });
                else Object.keys(options).forEach(function(key) {
                    return optionTags.push($7725d5370bb6ccd4$var$_react2.default.createElement("option", {
                        key: key,
                        value: key
                    }, options[key]));
                });
                return optionTags;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _props5 = this.props, id = _props5.id, style = _props5.style, className = _props5.className, defaultValue = _props5.defaultValue, onFilter = _props5.onFilter, column = _props5.column, options = _props5.options, comparator = _props5.comparator, withoutEmptyOption = _props5.withoutEmptyOption, caseSensitive = _props5.caseSensitive, getFilter = _props5.getFilter, filterState = _props5.filterState, rest = $7725d5370bb6ccd4$var$_objectWithoutProperties(_props5, [
                    "id",
                    "style",
                    "className",
                    "defaultValue",
                    "onFilter",
                    "column",
                    "options",
                    "comparator",
                    "withoutEmptyOption",
                    "caseSensitive",
                    "getFilter",
                    "filterState"
                ]);
                var selectClass = "filter select-filter form-control " + className + " " + (this.state.isSelected ? "" : "placeholder-selected");
                var elmId = "select-filter-column-" + column.dataField + (id ? "-" + id : "");
                return $7725d5370bb6ccd4$var$_react2.default.createElement("label", {
                    className: "filter-label",
                    htmlFor: elmId
                }, $7725d5370bb6ccd4$var$_react2.default.createElement("span", {
                    className: "sr-only"
                }, "Filter by ", column.text), $7725d5370bb6ccd4$var$_react2.default.createElement("select", $7725d5370bb6ccd4$var$_extends({}, rest, {
                    ref: function ref(n) {
                        return _this3.selectInput = n;
                    },
                    id: elmId,
                    style: style,
                    className: selectClass,
                    onChange: this.filter,
                    onClick: function onClick(e) {
                        return e.stopPropagation();
                    },
                    defaultValue: this.getDefaultValue() || ""
                }), this.renderOptions()));
            }
        }
    ]);
    return SelectFilter;
}($acw62.Component);
$7725d5370bb6ccd4$var$SelectFilter.propTypes = {
    onFilter: $7725d5370bb6ccd4$var$_propTypes2.default.func.isRequired,
    column: $7725d5370bb6ccd4$var$_propTypes2.default.object.isRequired,
    id: $7725d5370bb6ccd4$var$_propTypes2.default.string,
    filterState: $7725d5370bb6ccd4$var$_propTypes2.default.object,
    options: $7725d5370bb6ccd4$var$_propTypes2.default.oneOfType([
        $7725d5370bb6ccd4$var$_propTypes2.default.object,
        $7725d5370bb6ccd4$var$_propTypes2.default.array
    ]).isRequired,
    comparator: $7725d5370bb6ccd4$var$_propTypes2.default.oneOf([
        $8swRD.LIKE,
        $8swRD.EQ
    ]),
    placeholder: $7725d5370bb6ccd4$var$_propTypes2.default.string,
    style: $7725d5370bb6ccd4$var$_propTypes2.default.object,
    className: $7725d5370bb6ccd4$var$_propTypes2.default.string,
    withoutEmptyOption: $7725d5370bb6ccd4$var$_propTypes2.default.bool,
    defaultValue: $7725d5370bb6ccd4$var$_propTypes2.default.any,
    caseSensitive: $7725d5370bb6ccd4$var$_propTypes2.default.bool,
    getFilter: $7725d5370bb6ccd4$var$_propTypes2.default.func
};
$7725d5370bb6ccd4$var$SelectFilter.defaultProps = {
    defaultValue: "",
    filterState: {},
    className: "",
    withoutEmptyOption: false,
    comparator: $8swRD.EQ,
    caseSensitive: true,
    id: null
};
module.exports.default = $7725d5370bb6ccd4$var$SelectFilter;

});

parcelRegister("gDAEh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $c1ccb789b57f851a$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $c1ccb789b57f851a$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $c1ccb789b57f851a$var$_react2 = $c1ccb789b57f851a$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");
var $c1ccb789b57f851a$var$_propTypes2 = $c1ccb789b57f851a$var$_interopRequireDefault($c9Z8w);

var $8swRD = parcelRequire("8swRD");

var $loyZr = parcelRequire("loyZr");
function $c1ccb789b57f851a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c1ccb789b57f851a$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $c1ccb789b57f851a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c1ccb789b57f851a$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $c1ccb789b57f851a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint react/require-default-props: 0 */ 
/* eslint no-return-assign: 0 */ /* eslint no-param-reassign: 0 */ /* eslint react/no-unused-prop-types: 0 */ function $c1ccb789b57f851a$var$optionsEquals(currOpts, prevOpts) {
    var keys = Object.keys(currOpts);
    for(var i = 0; i < keys.length; i += 1){
        if (currOpts[keys[i]] !== prevOpts[keys[i]]) return false;
    }
    return Object.keys(currOpts).length === Object.keys(prevOpts).length;
}
var $c1ccb789b57f851a$var$getSelections = function getSelections(container) {
    if (container.selectedOptions) return Array.from(container.selectedOptions).map(function(item) {
        return item.value;
    });
    var selections = [];
    var totalLen = container.options.length;
    for(var i = 0; i < totalLen; i += 1){
        var option = container.options.item(i);
        if (option.selected) selections.push(option.value);
    }
    return selections;
};
var $c1ccb789b57f851a$var$MultiSelectFilter = function(_Component) {
    $c1ccb789b57f851a$var$_inherits(MultiSelectFilter, _Component);
    function MultiSelectFilter(props) {
        $c1ccb789b57f851a$var$_classCallCheck(this, MultiSelectFilter);
        var _this = $c1ccb789b57f851a$var$_possibleConstructorReturn(this, (MultiSelectFilter.__proto__ || Object.getPrototypeOf(MultiSelectFilter)).call(this, props));
        _this.filter = _this.filter.bind(_this);
        _this.applyFilter = _this.applyFilter.bind(_this);
        var isSelected = props.defaultValue.map(function(item) {
            return props.options[item];
        }).length > 0;
        _this.state = {
            isSelected: isSelected
        };
        return _this;
    }
    $c1ccb789b57f851a$var$_createClass(MultiSelectFilter, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this2 = this;
                var getFilter = this.props.getFilter;
                var value = $c1ccb789b57f851a$var$getSelections(this.selectInput);
                if (value && value.length > 0) this.applyFilter(value);
                // export onFilter function to allow users to access
                if (getFilter) getFilter(function(filterVal) {
                    _this2.selectInput.value = filterVal;
                    _this2.applyFilter(filterVal);
                });
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var needFilter = false;
                if (this.props.defaultValue !== prevProps.defaultValue) needFilter = true;
                else if (!$c1ccb789b57f851a$var$optionsEquals(this.props.options, prevProps.options)) needFilter = true;
                if (needFilter) this.applyFilter($c1ccb789b57f851a$var$getSelections(this.selectInput));
            }
        },
        {
            key: "getDefaultValue",
            value: function getDefaultValue() {
                var _props = this.props, filterState = _props.filterState, defaultValue = _props.defaultValue;
                if (filterState && typeof filterState.filterVal !== "undefined") return filterState.filterVal;
                return defaultValue;
            }
        },
        {
            key: "getOptions",
            value: function getOptions() {
                var optionTags = [];
                var _props2 = this.props, options = _props2.options, placeholder = _props2.placeholder, column = _props2.column, withoutEmptyOption = _props2.withoutEmptyOption;
                if (!withoutEmptyOption) optionTags.push($c1ccb789b57f851a$var$_react2.default.createElement("option", {
                    key: "-1",
                    value: ""
                }, placeholder || "Select " + column.text + "..."));
                Object.keys(options).forEach(function(key) {
                    return optionTags.push($c1ccb789b57f851a$var$_react2.default.createElement("option", {
                        key: key,
                        value: key
                    }, options[key]));
                });
                return optionTags;
            }
        },
        {
            key: "cleanFiltered",
            value: function cleanFiltered() {
                var value = this.props.defaultValue !== undefined ? this.props.defaultValue : [];
                this.selectInput.value = value;
                this.applyFilter(value);
            }
        },
        {
            key: "applyFilter",
            value: function applyFilter(value) {
                if (value.length === 1 && value[0] === "") value = [];
                this.setState(function() {
                    return {
                        isSelected: value.length > 0
                    };
                });
                this.props.onFilter(this.props.column, $loyZr.FILTER_TYPE.MULTISELECT)(value);
            }
        },
        {
            key: "filter",
            value: function filter(e) {
                var value = $c1ccb789b57f851a$var$getSelections(e.target);
                this.applyFilter(value);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _props3 = this.props, id = _props3.id, style = _props3.style, className = _props3.className, filterState = _props3.filterState, defaultValue = _props3.defaultValue, onFilter = _props3.onFilter, column = _props3.column, options = _props3.options, comparator = _props3.comparator, withoutEmptyOption = _props3.withoutEmptyOption, caseSensitive = _props3.caseSensitive, getFilter = _props3.getFilter, rest = $c1ccb789b57f851a$var$_objectWithoutProperties(_props3, [
                    "id",
                    "style",
                    "className",
                    "filterState",
                    "defaultValue",
                    "onFilter",
                    "column",
                    "options",
                    "comparator",
                    "withoutEmptyOption",
                    "caseSensitive",
                    "getFilter"
                ]);
                var selectClass = "filter select-filter form-control " + className + " " + (this.state.isSelected ? "" : "placeholder-selected");
                var elmId = "multiselect-filter-column-" + column.dataField + (id ? "-" + id : "");
                return $c1ccb789b57f851a$var$_react2.default.createElement("label", {
                    className: "filter-label",
                    htmlFor: elmId
                }, $c1ccb789b57f851a$var$_react2.default.createElement("span", {
                    className: "sr-only"
                }, "Filter by ", column.text), $c1ccb789b57f851a$var$_react2.default.createElement("select", $c1ccb789b57f851a$var$_extends({}, rest, {
                    ref: function ref(n) {
                        return _this3.selectInput = n;
                    },
                    id: elmId,
                    style: style,
                    multiple: true,
                    className: selectClass,
                    onChange: this.filter,
                    onClick: function onClick(e) {
                        return e.stopPropagation();
                    },
                    defaultValue: this.getDefaultValue()
                }), this.getOptions()));
            }
        }
    ]);
    return MultiSelectFilter;
}($acw62.Component);
$c1ccb789b57f851a$var$MultiSelectFilter.propTypes = {
    onFilter: $c1ccb789b57f851a$var$_propTypes2.default.func.isRequired,
    column: $c1ccb789b57f851a$var$_propTypes2.default.object.isRequired,
    options: $c1ccb789b57f851a$var$_propTypes2.default.object.isRequired,
    id: $c1ccb789b57f851a$var$_propTypes2.default.string,
    filterState: $c1ccb789b57f851a$var$_propTypes2.default.object,
    comparator: $c1ccb789b57f851a$var$_propTypes2.default.oneOf([
        $8swRD.LIKE,
        $8swRD.EQ
    ]),
    placeholder: $c1ccb789b57f851a$var$_propTypes2.default.string,
    style: $c1ccb789b57f851a$var$_propTypes2.default.object,
    className: $c1ccb789b57f851a$var$_propTypes2.default.string,
    withoutEmptyOption: $c1ccb789b57f851a$var$_propTypes2.default.bool,
    defaultValue: $c1ccb789b57f851a$var$_propTypes2.default.array,
    caseSensitive: $c1ccb789b57f851a$var$_propTypes2.default.bool,
    getFilter: $c1ccb789b57f851a$var$_propTypes2.default.func
};
$c1ccb789b57f851a$var$MultiSelectFilter.defaultProps = {
    defaultValue: [],
    filterState: {},
    className: "",
    withoutEmptyOption: false,
    comparator: $8swRD.EQ,
    caseSensitive: true,
    id: null
};
module.exports.default = $c1ccb789b57f851a$var$MultiSelectFilter;

});

parcelRegister("2pKWF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $1c2254ede82bdd20$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $1c2254ede82bdd20$var$_react2 = $1c2254ede82bdd20$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");
var $1c2254ede82bdd20$var$_propTypes2 = $1c2254ede82bdd20$var$_interopRequireDefault($c9Z8w);

var $8swRD = parcelRequire("8swRD");
var $1c2254ede82bdd20$var$Comparator = $1c2254ede82bdd20$var$_interopRequireWildcard($8swRD);

var $loyZr = parcelRequire("loyZr");
function $1c2254ede82bdd20$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $1c2254ede82bdd20$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1c2254ede82bdd20$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1c2254ede82bdd20$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $1c2254ede82bdd20$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint jsx-a11y/no-static-element-interactions: 0 */ 
/* eslint react/require-default-props: 0 */ /* eslint no-return-assign: 0 */ var $1c2254ede82bdd20$var$legalComparators = [
    $1c2254ede82bdd20$var$Comparator.EQ,
    $1c2254ede82bdd20$var$Comparator.NE,
    $1c2254ede82bdd20$var$Comparator.GT,
    $1c2254ede82bdd20$var$Comparator.GE,
    $1c2254ede82bdd20$var$Comparator.LT,
    $1c2254ede82bdd20$var$Comparator.LE
];
var $1c2254ede82bdd20$var$NumberFilter = function(_Component) {
    $1c2254ede82bdd20$var$_inherits(NumberFilter, _Component);
    function NumberFilter(props) {
        $1c2254ede82bdd20$var$_classCallCheck(this, NumberFilter);
        var _this = $1c2254ede82bdd20$var$_possibleConstructorReturn(this, (NumberFilter.__proto__ || Object.getPrototypeOf(NumberFilter)).call(this, props));
        _this.comparators = props.comparators || $1c2254ede82bdd20$var$legalComparators;
        _this.timeout = null;
        var isSelected = props.defaultValue !== undefined && props.defaultValue.number !== undefined;
        if (props.options && isSelected) isSelected = props.options.indexOf(props.defaultValue.number) > -1;
        _this.state = {
            isSelected: isSelected
        };
        _this.onChangeNumber = _this.onChangeNumber.bind(_this);
        _this.onChangeNumberSet = _this.onChangeNumberSet.bind(_this);
        _this.onChangeComparator = _this.onChangeComparator.bind(_this);
        return _this;
    }
    $1c2254ede82bdd20$var$_createClass(NumberFilter, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this2 = this;
                var _props = this.props, column = _props.column, onFilter = _props.onFilter, getFilter = _props.getFilter;
                var comparator = this.numberFilterComparator.value;
                var number = this.numberFilter.value;
                if (comparator && number) onFilter(column, $loyZr.FILTER_TYPE.NUMBER, true)({
                    number: number,
                    comparator: comparator
                });
                // export onFilter function to allow users to access
                if (getFilter) getFilter(function(filterVal) {
                    _this2.setState(function() {
                        return {
                            isSelected: filterVal !== ""
                        };
                    });
                    _this2.numberFilterComparator.value = filterVal.comparator;
                    _this2.numberFilter.value = filterVal.number;
                    onFilter(column, $loyZr.FILTER_TYPE.NUMBER)({
                        number: filterVal.number,
                        comparator: filterVal.comparator
                    });
                });
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                clearTimeout(this.timeout);
            }
        },
        {
            key: "onChangeNumber",
            value: function onChangeNumber(e) {
                var _props2 = this.props, delay = _props2.delay, column = _props2.column, onFilter = _props2.onFilter;
                var comparator = this.numberFilterComparator.value;
                if (comparator === "") return;
                if (this.timeout) clearTimeout(this.timeout);
                var filterValue = e.target.value;
                this.timeout = setTimeout(function() {
                    onFilter(column, $loyZr.FILTER_TYPE.NUMBER)({
                        number: filterValue,
                        comparator: comparator
                    });
                }, delay);
            }
        },
        {
            key: "onChangeNumberSet",
            value: function onChangeNumberSet(e) {
                var _props3 = this.props, column = _props3.column, onFilter = _props3.onFilter;
                var comparator = this.numberFilterComparator.value;
                var value = e.target.value;
                this.setState(function() {
                    return {
                        isSelected: value !== ""
                    };
                });
                // if (comparator === '') {
                //   return;
                // }
                onFilter(column, $loyZr.FILTER_TYPE.NUMBER)({
                    number: value,
                    comparator: comparator
                });
            }
        },
        {
            key: "onChangeComparator",
            value: function onChangeComparator(e) {
                var _props4 = this.props, column = _props4.column, onFilter = _props4.onFilter;
                var value = this.numberFilter.value;
                var comparator = e.target.value;
                // if (value === '') {
                //   return;
                // }
                onFilter(column, $loyZr.FILTER_TYPE.NUMBER)({
                    number: value,
                    comparator: comparator
                });
            }
        },
        {
            key: "getDefaultComparator",
            value: function getDefaultComparator() {
                var _props5 = this.props, defaultValue = _props5.defaultValue, filterState = _props5.filterState;
                if (filterState && filterState.filterVal) return filterState.filterVal.comparator;
                if (defaultValue && defaultValue.comparator) return defaultValue.comparator;
                return "";
            }
        },
        {
            key: "getDefaultValue",
            value: function getDefaultValue() {
                var _props6 = this.props, defaultValue = _props6.defaultValue, filterState = _props6.filterState;
                if (filterState && filterState.filterVal) return filterState.filterVal.number;
                if (defaultValue && defaultValue.number) return defaultValue.number;
                return "";
            }
        },
        {
            key: "getComparatorOptions",
            value: function getComparatorOptions() {
                var optionTags = [];
                var withoutEmptyComparatorOption = this.props.withoutEmptyComparatorOption;
                if (!withoutEmptyComparatorOption) optionTags.push($1c2254ede82bdd20$var$_react2.default.createElement("option", {
                    key: "-1"
                }));
                for(var i = 0; i < this.comparators.length; i += 1)optionTags.push($1c2254ede82bdd20$var$_react2.default.createElement("option", {
                    key: i,
                    value: this.comparators[i]
                }, this.comparators[i]));
                return optionTags;
            }
        },
        {
            key: "getNumberOptions",
            value: function getNumberOptions() {
                var optionTags = [];
                var _props7 = this.props, options = _props7.options, column = _props7.column, withoutEmptyNumberOption = _props7.withoutEmptyNumberOption;
                if (!withoutEmptyNumberOption) optionTags.push($1c2254ede82bdd20$var$_react2.default.createElement("option", {
                    key: "-1",
                    value: ""
                }, this.props.placeholder || "Select " + column.text + "..."));
                for(var i = 0; i < options.length; i += 1)optionTags.push($1c2254ede82bdd20$var$_react2.default.createElement("option", {
                    key: i,
                    value: options[i]
                }, options[i]));
                return optionTags;
            }
        },
        {
            key: "applyFilter",
            value: function applyFilter(filterObj) {
                var _props8 = this.props, column = _props8.column, onFilter = _props8.onFilter;
                var number = filterObj.number, comparator = filterObj.comparator;
                this.setState(function() {
                    return {
                        isSelected: number !== ""
                    };
                });
                this.numberFilterComparator.value = comparator;
                this.numberFilter.value = number;
                onFilter(column, $loyZr.FILTER_TYPE.NUMBER)({
                    number: number,
                    comparator: comparator
                });
            }
        },
        {
            key: "cleanFiltered",
            value: function cleanFiltered() {
                var _props9 = this.props, column = _props9.column, onFilter = _props9.onFilter, defaultValue = _props9.defaultValue;
                var value = defaultValue ? defaultValue.number : "";
                var comparator = defaultValue ? defaultValue.comparator : "";
                this.setState(function() {
                    return {
                        isSelected: value !== ""
                    };
                });
                this.numberFilterComparator.value = comparator;
                this.numberFilter.value = value;
                onFilter(column, $loyZr.FILTER_TYPE.NUMBER)({
                    number: value,
                    comparator: comparator
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var isSelected = this.state.isSelected;
                var _props10 = this.props, id = _props10.id, column = _props10.column, options = _props10.options, style = _props10.style, className = _props10.className, numberStyle = _props10.numberStyle, numberClassName = _props10.numberClassName, comparatorStyle = _props10.comparatorStyle, comparatorClassName = _props10.comparatorClassName, placeholder = _props10.placeholder;
                var selectClass = "\n      select-filter \n      number-filter-input \n      form-control \n      " + numberClassName + " \n      " + (!isSelected ? "placeholder-selected" : "") + "\n    ";
                var comparatorElmId = "number-filter-comparator-" + column.dataField + (id ? "-" + id : "");
                var inputElmId = "number-filter-column-" + column.dataField + (id ? "-" + id : "");
                return $1c2254ede82bdd20$var$_react2.default.createElement("div", {
                    onClick: function onClick(e) {
                        return e.stopPropagation();
                    },
                    className: "filter number-filter " + className,
                    style: style
                }, $1c2254ede82bdd20$var$_react2.default.createElement("label", {
                    className: "filter-label",
                    htmlFor: comparatorElmId
                }, $1c2254ede82bdd20$var$_react2.default.createElement("span", {
                    className: "sr-only"
                }, "Filter comparator"), $1c2254ede82bdd20$var$_react2.default.createElement("select", {
                    ref: function ref(n) {
                        return _this3.numberFilterComparator = n;
                    },
                    style: comparatorStyle,
                    id: comparatorElmId,
                    className: "number-filter-comparator form-control " + comparatorClassName,
                    onChange: this.onChangeComparator,
                    defaultValue: this.getDefaultComparator()
                }, this.getComparatorOptions())), options ? $1c2254ede82bdd20$var$_react2.default.createElement("label", {
                    className: "filter-label",
                    htmlFor: inputElmId
                }, $1c2254ede82bdd20$var$_react2.default.createElement("span", {
                    className: "sr-only"
                }, "Select " + column.text), $1c2254ede82bdd20$var$_react2.default.createElement("select", {
                    ref: function ref(n) {
                        return _this3.numberFilter = n;
                    },
                    id: inputElmId,
                    style: numberStyle,
                    className: selectClass,
                    onChange: this.onChangeNumberSet,
                    defaultValue: this.getDefaultValue()
                }, this.getNumberOptions())) : $1c2254ede82bdd20$var$_react2.default.createElement("label", {
                    htmlFor: inputElmId
                }, $1c2254ede82bdd20$var$_react2.default.createElement("span", {
                    className: "sr-only"
                }, "Enter " + column.text), $1c2254ede82bdd20$var$_react2.default.createElement("input", {
                    ref: function ref(n) {
                        return _this3.numberFilter = n;
                    },
                    id: inputElmId,
                    type: "number",
                    style: numberStyle,
                    className: "number-filter-input form-control " + numberClassName,
                    placeholder: placeholder || "Enter " + column.text + "...",
                    onChange: this.onChangeNumber,
                    defaultValue: this.getDefaultValue()
                })));
            }
        }
    ]);
    return NumberFilter;
}($acw62.Component);
$1c2254ede82bdd20$var$NumberFilter.propTypes = {
    onFilter: $1c2254ede82bdd20$var$_propTypes2.default.func.isRequired,
    column: $1c2254ede82bdd20$var$_propTypes2.default.object.isRequired,
    id: $1c2254ede82bdd20$var$_propTypes2.default.string,
    filterState: $1c2254ede82bdd20$var$_propTypes2.default.object,
    options: $1c2254ede82bdd20$var$_propTypes2.default.arrayOf($1c2254ede82bdd20$var$_propTypes2.default.number),
    defaultValue: $1c2254ede82bdd20$var$_propTypes2.default.shape({
        number: $1c2254ede82bdd20$var$_propTypes2.default.oneOfType([
            $1c2254ede82bdd20$var$_propTypes2.default.string,
            $1c2254ede82bdd20$var$_propTypes2.default.number
        ]),
        comparator: $1c2254ede82bdd20$var$_propTypes2.default.oneOf([].concat($1c2254ede82bdd20$var$legalComparators, [
            ""
        ]))
    }),
    delay: $1c2254ede82bdd20$var$_propTypes2.default.number,
    /* eslint consistent-return: 0 */ comparators: function comparators(props, propName) {
        if (!props[propName]) return;
        for(var i = 0; i < props[propName].length; i += 1){
            var comparatorIsValid = false;
            for(var j = 0; j < $1c2254ede82bdd20$var$legalComparators.length; j += 1)if ($1c2254ede82bdd20$var$legalComparators[j] === props[propName][i] || props[propName][i] === "") {
                comparatorIsValid = true;
                break;
            }
            if (!comparatorIsValid) return new Error("Number comparator provided is not supported.\n          Use only " + $1c2254ede82bdd20$var$legalComparators);
        }
    },
    placeholder: $1c2254ede82bdd20$var$_propTypes2.default.string,
    withoutEmptyComparatorOption: $1c2254ede82bdd20$var$_propTypes2.default.bool,
    withoutEmptyNumberOption: $1c2254ede82bdd20$var$_propTypes2.default.bool,
    style: $1c2254ede82bdd20$var$_propTypes2.default.object,
    className: $1c2254ede82bdd20$var$_propTypes2.default.string,
    comparatorStyle: $1c2254ede82bdd20$var$_propTypes2.default.object,
    comparatorClassName: $1c2254ede82bdd20$var$_propTypes2.default.string,
    numberStyle: $1c2254ede82bdd20$var$_propTypes2.default.object,
    numberClassName: $1c2254ede82bdd20$var$_propTypes2.default.string,
    getFilter: $1c2254ede82bdd20$var$_propTypes2.default.func
};
$1c2254ede82bdd20$var$NumberFilter.defaultProps = {
    delay: $loyZr.FILTER_DELAY,
    options: undefined,
    defaultValue: {
        number: undefined,
        comparator: ""
    },
    filterState: {},
    withoutEmptyComparatorOption: false,
    withoutEmptyNumberOption: false,
    comparators: $1c2254ede82bdd20$var$legalComparators,
    placeholder: undefined,
    style: undefined,
    className: "",
    comparatorStyle: undefined,
    comparatorClassName: "",
    numberStyle: undefined,
    numberClassName: "",
    id: null
};
module.exports.default = $1c2254ede82bdd20$var$NumberFilter;

});

parcelRegister("gto3g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $bfe202ec5d9a2c2e$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $bfe202ec5d9a2c2e$var$_react2 = $bfe202ec5d9a2c2e$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");

var $8swRD = parcelRequire("8swRD");
var $bfe202ec5d9a2c2e$var$Comparator = $bfe202ec5d9a2c2e$var$_interopRequireWildcard($8swRD);

var $loyZr = parcelRequire("loyZr");
function $bfe202ec5d9a2c2e$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $bfe202ec5d9a2c2e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $bfe202ec5d9a2c2e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $bfe202ec5d9a2c2e$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $bfe202ec5d9a2c2e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint react/require-default-props: 0 */ 
/* eslint jsx-a11y/no-static-element-interactions: 0 */ /* eslint no-return-assign: 0 */ /* eslint prefer-template: 0 */ var $bfe202ec5d9a2c2e$var$legalComparators = [
    $bfe202ec5d9a2c2e$var$Comparator.EQ,
    $bfe202ec5d9a2c2e$var$Comparator.NE,
    $bfe202ec5d9a2c2e$var$Comparator.GT,
    $bfe202ec5d9a2c2e$var$Comparator.GE,
    $bfe202ec5d9a2c2e$var$Comparator.LT,
    $bfe202ec5d9a2c2e$var$Comparator.LE
];
function $bfe202ec5d9a2c2e$var$dateParser(d) {
    return d.getUTCFullYear() + "-" + ("0" + (d.getUTCMonth() + 1)).slice(-2) + "-" + ("0" + d.getUTCDate()).slice(-2);
}
var $bfe202ec5d9a2c2e$var$DateFilter = function(_Component) {
    $bfe202ec5d9a2c2e$var$_inherits(DateFilter, _Component);
    function DateFilter(props) {
        $bfe202ec5d9a2c2e$var$_classCallCheck(this, DateFilter);
        var _this = $bfe202ec5d9a2c2e$var$_possibleConstructorReturn(this, (DateFilter.__proto__ || Object.getPrototypeOf(DateFilter)).call(this, props));
        _this.timeout = null;
        _this.comparators = props.comparators || $bfe202ec5d9a2c2e$var$legalComparators;
        _this.applyFilter = _this.applyFilter.bind(_this);
        _this.onChangeDate = _this.onChangeDate.bind(_this);
        _this.onChangeComparator = _this.onChangeComparator.bind(_this);
        return _this;
    }
    $bfe202ec5d9a2c2e$var$_createClass(DateFilter, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this2 = this;
                var getFilter = this.props.getFilter;
                var comparator = this.dateFilterComparator.value;
                var date = this.inputDate.value;
                if (comparator && date) this.applyFilter(date, comparator, true);
                // export onFilter function to allow users to access
                if (getFilter) getFilter(function(filterVal) {
                    var nullableFilterVal = filterVal || {
                        date: null,
                        comparator: null
                    };
                    _this2.dateFilterComparator.value = nullableFilterVal.comparator;
                    _this2.inputDate.value = nullableFilterVal.date ? $bfe202ec5d9a2c2e$var$dateParser(nullableFilterVal.date) : null;
                    _this2.applyFilter(nullableFilterVal.date, nullableFilterVal.comparator);
                });
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.timeout) clearTimeout(this.timeout);
            }
        },
        {
            key: "onChangeDate",
            value: function onChangeDate(e) {
                var comparator = this.dateFilterComparator.value;
                var filterValue = e.target.value;
                this.applyFilter(filterValue, comparator);
            }
        },
        {
            key: "onChangeComparator",
            value: function onChangeComparator(e) {
                var value = this.inputDate.value;
                var comparator = e.target.value;
                this.applyFilter(value, comparator);
            }
        },
        {
            key: "getComparatorOptions",
            value: function getComparatorOptions() {
                var optionTags = [];
                var withoutEmptyComparatorOption = this.props.withoutEmptyComparatorOption;
                if (!withoutEmptyComparatorOption) optionTags.push($bfe202ec5d9a2c2e$var$_react2.default.createElement("option", {
                    key: "-1"
                }));
                for(var i = 0; i < this.comparators.length; i += 1)optionTags.push($bfe202ec5d9a2c2e$var$_react2.default.createElement("option", {
                    key: i,
                    value: this.comparators[i]
                }, this.comparators[i]));
                return optionTags;
            }
        },
        {
            key: "getDefaultComparator",
            value: function getDefaultComparator() {
                var _props = this.props, defaultValue = _props.defaultValue, filterState = _props.filterState;
                if (filterState && filterState.filterVal) return filterState.filterVal.comparator;
                if (defaultValue && defaultValue.comparator) return defaultValue.comparator;
                return "";
            }
        },
        {
            key: "getDefaultDate",
            value: function getDefaultDate() {
                // Set the appropriate format for the input type=date, i.e. "YYYY-MM-DD"
                var _props2 = this.props, defaultValue = _props2.defaultValue, filterState = _props2.filterState;
                if (filterState && filterState.filterVal && filterState.filterVal.date) return $bfe202ec5d9a2c2e$var$dateParser(filterState.filterVal.date);
                if (defaultValue && defaultValue.date) return $bfe202ec5d9a2c2e$var$dateParser(new Date(defaultValue.date));
                return "";
            }
        },
        {
            key: "applyFilter",
            value: function applyFilter(value, comparator, isInitial) {
                // if (!comparator || !value) {
                //  return;
                // }
                var _props3 = this.props, column = _props3.column, onFilter = _props3.onFilter, delay = _props3.delay;
                var execute = function execute() {
                    // Incoming value should always be a string, and the defaultDate
                    // above is implemented as an empty string, so we can just check for that.
                    // instead of parsing an invalid Date. The filter function will interpret
                    // null as an empty date field
                    var date = value === "" ? null : new Date(value);
                    onFilter(column, $loyZr.FILTER_TYPE.DATE, isInitial)({
                        date: date,
                        comparator: comparator
                    });
                };
                if (delay) this.timeout = setTimeout(function() {
                    execute();
                }, delay);
                else execute();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _props4 = this.props, id = _props4.id, placeholder = _props4.placeholder, _props4$column = _props4.column, dataField = _props4$column.dataField, text = _props4$column.text, style = _props4.style, comparatorStyle = _props4.comparatorStyle, dateStyle = _props4.dateStyle, className = _props4.className, comparatorClassName = _props4.comparatorClassName, dateClassName = _props4.dateClassName;
                var comparatorElmId = "date-filter-comparator-" + dataField + (id ? "-" + id : "");
                var inputElmId = "date-filter-column-" + dataField + (id ? "-" + id : "");
                return $bfe202ec5d9a2c2e$var$_react2.default.createElement("div", {
                    onClick: function onClick(e) {
                        return e.stopPropagation();
                    },
                    className: "filter date-filter " + className,
                    style: style
                }, $bfe202ec5d9a2c2e$var$_react2.default.createElement("label", {
                    className: "filter-label",
                    htmlFor: comparatorElmId
                }, $bfe202ec5d9a2c2e$var$_react2.default.createElement("span", {
                    className: "sr-only"
                }, "Filter comparator"), $bfe202ec5d9a2c2e$var$_react2.default.createElement("select", {
                    ref: function ref(n) {
                        return _this3.dateFilterComparator = n;
                    },
                    id: comparatorElmId,
                    style: comparatorStyle,
                    className: "date-filter-comparator form-control " + comparatorClassName,
                    onChange: this.onChangeComparator,
                    defaultValue: this.getDefaultComparator()
                }, this.getComparatorOptions())), $bfe202ec5d9a2c2e$var$_react2.default.createElement("label", {
                    htmlFor: inputElmId
                }, $bfe202ec5d9a2c2e$var$_react2.default.createElement("span", {
                    className: "sr-only"
                }, "Enter $", text), $bfe202ec5d9a2c2e$var$_react2.default.createElement("input", {
                    ref: function ref(n) {
                        return _this3.inputDate = n;
                    },
                    id: inputElmId,
                    className: "filter date-filter-input form-control " + dateClassName,
                    style: dateStyle,
                    type: "date",
                    onChange: this.onChangeDate,
                    placeholder: placeholder || "Enter " + text + "...",
                    defaultValue: this.getDefaultDate()
                })));
            }
        }
    ]);
    return DateFilter;
}($acw62.Component);
$bfe202ec5d9a2c2e$var$DateFilter.propTypes = {
    onFilter: $c9Z8w.PropTypes.func.isRequired,
    column: $c9Z8w.PropTypes.object.isRequired,
    id: $c9Z8w.PropTypes.string,
    filterState: $c9Z8w.PropTypes.object,
    delay: $c9Z8w.PropTypes.number,
    defaultValue: $c9Z8w.PropTypes.shape({
        date: $c9Z8w.PropTypes.oneOfType([
            $c9Z8w.PropTypes.object
        ]),
        comparator: $c9Z8w.PropTypes.oneOf([].concat($bfe202ec5d9a2c2e$var$legalComparators, [
            ""
        ]))
    }),
    /* eslint consistent-return: 0 */ comparators: function comparators(props, propName) {
        if (!props[propName]) return;
        for(var i = 0; i < props[propName].length; i += 1){
            var comparatorIsValid = false;
            for(var j = 0; j < $bfe202ec5d9a2c2e$var$legalComparators.length; j += 1)if ($bfe202ec5d9a2c2e$var$legalComparators[j] === props[propName][i] || props[propName][i] === "") {
                comparatorIsValid = true;
                break;
            }
            if (!comparatorIsValid) return new Error("Date comparator provided is not supported.\n          Use only " + $bfe202ec5d9a2c2e$var$legalComparators);
        }
    },
    placeholder: $c9Z8w.PropTypes.string,
    withoutEmptyComparatorOption: $c9Z8w.PropTypes.bool,
    style: $c9Z8w.PropTypes.object,
    comparatorStyle: $c9Z8w.PropTypes.object,
    dateStyle: $c9Z8w.PropTypes.object,
    className: $c9Z8w.PropTypes.string,
    comparatorClassName: $c9Z8w.PropTypes.string,
    dateClassName: $c9Z8w.PropTypes.string,
    getFilter: $c9Z8w.PropTypes.func
};
$bfe202ec5d9a2c2e$var$DateFilter.defaultProps = {
    delay: 0,
    defaultValue: {
        date: undefined,
        comparator: ""
    },
    filterState: {},
    withoutEmptyComparatorOption: false,
    comparators: $bfe202ec5d9a2c2e$var$legalComparators,
    placeholder: undefined,
    style: undefined,
    className: "",
    comparatorStyle: undefined,
    comparatorClassName: "",
    dateStyle: undefined,
    dateClassName: "",
    id: null
};
module.exports.default = $bfe202ec5d9a2c2e$var$DateFilter;

});

parcelRegister("02Mzi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $0085dca8803fc930$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $0085dca8803fc930$var$_react2 = $0085dca8803fc930$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");
var $0085dca8803fc930$var$_propTypes2 = $0085dca8803fc930$var$_interopRequireDefault($c9Z8w);

var $7xZvr = parcelRequire("7xZvr");

var $8swRD = parcelRequire("8swRD");

var $loyZr = parcelRequire("loyZr");
function $0085dca8803fc930$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0085dca8803fc930$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0085dca8803fc930$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $0085dca8803fc930$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $0085dca8803fc930$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} /* eslint react/prop-types: 0 */ 
/* eslint react/require-default-props: 0 */ /* eslint camelcase: 0 */ module.exports.default = function(_, isRemoteFiltering, handleFilterChange) {
    var FilterContext = $0085dca8803fc930$var$_react2.default.createContext();
    var FilterProvider = function(_React$Component) {
        $0085dca8803fc930$var$_inherits(FilterProvider, _React$Component);
        function FilterProvider(props) {
            $0085dca8803fc930$var$_classCallCheck(this, FilterProvider);
            var _this = $0085dca8803fc930$var$_possibleConstructorReturn(this, (FilterProvider.__proto__ || Object.getPrototypeOf(FilterProvider)).call(this, props));
            _this.currFilters = {};
            _this.clearFilters = {};
            _this.onFilter = _this.onFilter.bind(_this);
            _this.doFilter = _this.doFilter.bind(_this);
            _this.onExternalFilter = _this.onExternalFilter.bind(_this);
            _this.data = props.data;
            _this.isEmitDataChange = false;
            return _this;
        }
        $0085dca8803fc930$var$_createClass(FilterProvider, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if (isRemoteFiltering() && Object.keys(this.currFilters).length > 0) handleFilterChange(this.currFilters);
                }
            },
            {
                key: "onFilter",
                value: function onFilter(column, filterType) {
                    var _this2 = this;
                    var initialize = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                    return function(filterVal) {
                        // watch out here if migration to context API, #334
                        var currFilters = Object.assign({}, _this2.currFilters);
                        _this2.clearFilters = {};
                        var dataField = column.dataField, filter = column.filter;
                        var needClearFilters = !_.isDefined(filterVal) || filterVal === "" || filterVal.length === 0;
                        if (needClearFilters) {
                            delete currFilters[dataField];
                            _this2.clearFilters = $0085dca8803fc930$var$_defineProperty({}, dataField, {
                                clear: true,
                                filterVal: filterVal
                            });
                        } else {
                            // select default comparator is EQ, others are LIKE
                            var _filter$props = filter.props, _filter$props$compara = _filter$props.comparator, comparator = _filter$props$compara === undefined ? filterType === $loyZr.FILTER_TYPE.SELECT ? $8swRD.EQ : $8swRD.LIKE : _filter$props$compara, _filter$props$caseSen = _filter$props.caseSensitive, caseSensitive = _filter$props$caseSen === undefined ? false : _filter$props$caseSen;
                            currFilters[dataField] = {
                                filterVal: filterVal,
                                filterType: filterType,
                                comparator: comparator,
                                caseSensitive: caseSensitive
                            };
                        }
                        _this2.currFilters = currFilters;
                        if (isRemoteFiltering()) {
                            if (!initialize) handleFilterChange(_this2.currFilters);
                            return;
                        }
                        _this2.doFilter(_this2.props);
                    };
                }
            },
            {
                key: "onExternalFilter",
                value: function onExternalFilter(column, filterType) {
                    var _this3 = this;
                    return function(value) {
                        _this3.onFilter(column, filterType)(value);
                    };
                }
            },
            {
                key: "getFiltered",
                value: function getFiltered() {
                    return this.data;
                }
            },
            {
                key: "UNSAFE_componentWillReceiveProps",
                value: function UNSAFE_componentWillReceiveProps(nextProps) {
                    // let nextData = nextProps.data;
                    if (!isRemoteFiltering() && !_.isEqual(nextProps.data, this.data)) this.doFilter(nextProps, this.isEmitDataChange);
                    else this.data = nextProps.data;
                }
            },
            {
                key: "doFilter",
                value: function doFilter(props) {
                    var ignoreEmitDataChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                    var dataChangeListener = props.dataChangeListener, data = props.data, columns = props.columns, filter = props.filter;
                    var result = (0, $7xZvr.filters)(data, columns, _)(this.currFilters, this.clearFilters);
                    if (filter.afterFilter) filter.afterFilter(result, this.currFilters);
                    this.data = result;
                    if (dataChangeListener && !ignoreEmitDataChange) {
                        this.isEmitDataChange = true;
                        dataChangeListener.emit("filterChanged", result.length);
                    } else {
                        this.isEmitDataChange = false;
                        this.forceUpdate();
                    }
                }
            },
            {
                key: "render",
                value: function render() {
                    return $0085dca8803fc930$var$_react2.default.createElement(FilterContext.Provider, {
                        value: {
                            data: this.data,
                            onFilter: this.onFilter,
                            onExternalFilter: this.onExternalFilter,
                            currFilters: this.currFilters
                        }
                    }, this.props.children);
                }
            }
        ]);
        return FilterProvider;
    }($0085dca8803fc930$var$_react2.default.Component);
    FilterProvider.propTypes = {
        data: $0085dca8803fc930$var$_propTypes2.default.array.isRequired,
        columns: $0085dca8803fc930$var$_propTypes2.default.array.isRequired,
        dataChangeListener: $0085dca8803fc930$var$_propTypes2.default.object
    };
    return {
        Provider: FilterProvider,
        Consumer: FilterContext.Consumer
    };
};

});
parcelRegister("7xZvr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.filters = module.exports.filterFactory = module.exports.filterByArray = module.exports.filterByDate = module.exports.filterByNumber = module.exports.filterByText = undefined;
var $57eb534f4f420e77$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $57eb534f4f420e77$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
}; /* eslint eqeqeq: 0 */ 

var $loyZr = parcelRequire("loyZr");

var $8swRD = parcelRequire("8swRD");
var $57eb534f4f420e77$var$filterByText = module.exports.filterByText = function filterByText(_) {
    return function(data, dataField, _ref, customFilterValue) {
        var _ref$filterVal = _ref.filterVal, userInput = _ref$filterVal === undefined ? "" : _ref$filterVal, _ref$comparator = _ref.comparator, comparator = _ref$comparator === undefined ? $8swRD.LIKE : _ref$comparator, caseSensitive = _ref.caseSensitive;
        // make sure filter value to be a string
        var filterVal = userInput.toString();
        return data.filter(function(row) {
            var cell = _.get(row, dataField);
            if (customFilterValue) cell = customFilterValue(cell, row);
            var cellStr = _.isDefined(cell) ? cell.toString() : "";
            if (comparator === $8swRD.EQ) return cellStr === filterVal;
            if (caseSensitive) return cellStr.includes(filterVal);
            return cellStr.toLocaleUpperCase().indexOf(filterVal.toLocaleUpperCase()) !== -1;
        });
    };
};
var $57eb534f4f420e77$var$filterByNumber = module.exports.filterByNumber = function filterByNumber(_) {
    return function(data, dataField, _ref2, customFilterValue) {
        var _ref2$filterVal = _ref2.filterVal, comparator = _ref2$filterVal.comparator, number = _ref2$filterVal.number;
        return data.filter(function(row) {
            if (number === "" || !comparator) return true;
            var cell = _.get(row, dataField);
            if (customFilterValue) cell = customFilterValue(cell, row);
            switch(comparator){
                case $8swRD.EQ:
                    return cell == number;
                case $8swRD.GT:
                    return cell > number;
                case $8swRD.GE:
                    return cell >= number;
                case $8swRD.LT:
                    return cell < number;
                case $8swRD.LE:
                    return cell <= number;
                case $8swRD.NE:
                    return cell != number;
                default:
                    console.error("Number comparator provided is not supported");
                    return true;
            }
        });
    };
};
var $57eb534f4f420e77$var$filterByDate = module.exports.filterByDate = function filterByDate(_) {
    return function(data, dataField, _ref3, customFilterValue) {
        var _ref3$filterVal = _ref3.filterVal, comparator = _ref3$filterVal.comparator, date = _ref3$filterVal.date;
        if (!date || !comparator) return data;
        var filterDate = date.getUTCDate();
        var filterMonth = date.getUTCMonth();
        var filterYear = date.getUTCFullYear();
        return data.filter(function(row) {
            var valid = true;
            var cell = _.get(row, dataField);
            if (customFilterValue) cell = customFilterValue(cell, row);
            if ((typeof cell === "undefined" ? "undefined" : $57eb534f4f420e77$var$_typeof(cell)) !== "object") cell = new Date(cell);
            var targetDate = cell.getUTCDate();
            var targetMonth = cell.getUTCMonth();
            var targetYear = cell.getUTCFullYear();
            switch(comparator){
                case $8swRD.EQ:
                    if (filterDate !== targetDate || filterMonth !== targetMonth || filterYear !== targetYear) valid = false;
                    break;
                case $8swRD.GT:
                    if (cell <= date) valid = false;
                    break;
                case $8swRD.GE:
                    if (targetYear < filterYear) valid = false;
                    else if (targetYear === filterYear && targetMonth < filterMonth) valid = false;
                    else if (targetYear === filterYear && targetMonth === filterMonth && targetDate < filterDate) valid = false;
                    break;
                case $8swRD.LT:
                    if (cell >= date) valid = false;
                    break;
                case $8swRD.LE:
                    if (targetYear > filterYear) valid = false;
                    else if (targetYear === filterYear && targetMonth > filterMonth) valid = false;
                    else if (targetYear === filterYear && targetMonth === filterMonth && targetDate > filterDate) valid = false;
                    break;
                case $8swRD.NE:
                    if (filterDate === targetDate && filterMonth === targetMonth && filterYear === targetYear) valid = false;
                    break;
                default:
                    console.error("Date comparator provided is not supported");
                    break;
            }
            return valid;
        });
    };
};
var $57eb534f4f420e77$var$filterByArray = module.exports.filterByArray = function filterByArray(_) {
    return function(data, dataField, _ref4) {
        var filterVal = _ref4.filterVal, comparator = _ref4.comparator;
        if (filterVal.length === 0) return data;
        var refinedFilterVal = filterVal.filter(function(x) {
            return _.isDefined(x);
        }).map(function(x) {
            return x.toString();
        });
        return data.filter(function(row) {
            var cell = _.get(row, dataField);
            var cellStr = _.isDefined(cell) ? cell.toString() : "";
            if (comparator === $8swRD.EQ) return refinedFilterVal.indexOf(cellStr) !== -1;
            cellStr = cellStr.toLocaleUpperCase();
            return refinedFilterVal.some(function(item) {
                return cellStr.indexOf(item.toLocaleUpperCase()) !== -1;
            });
        });
    };
};
var $57eb534f4f420e77$var$filterFactory = module.exports.filterFactory = function filterFactory(_) {
    return function(filterType) {
        switch(filterType){
            case $loyZr.FILTER_TYPE.MULTISELECT:
                return $57eb534f4f420e77$var$filterByArray(_);
            case $loyZr.FILTER_TYPE.NUMBER:
                return $57eb534f4f420e77$var$filterByNumber(_);
            case $loyZr.FILTER_TYPE.DATE:
                return $57eb534f4f420e77$var$filterByDate(_);
            case $loyZr.FILTER_TYPE.TEXT:
            case $loyZr.FILTER_TYPE.SELECT:
            default:
                // Use `text` filter as default filter
                return $57eb534f4f420e77$var$filterByText(_);
        }
    };
};
var $57eb534f4f420e77$var$filters = module.exports.filters = function filters(data, columns, _) {
    return function(currFilters) {
        var clearFilters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var factory = $57eb534f4f420e77$var$filterFactory(_);
        var filterState = $57eb534f4f420e77$var$_extends({}, clearFilters, currFilters);
        var result = data;
        var filterFn = void 0;
        Object.keys(filterState).forEach(function(dataField) {
            var currentResult = void 0;
            var filterValue = void 0;
            var customFilter = void 0;
            for(var i = 0; i < columns.length; i += 1)if (columns[i].dataField === dataField) {
                filterValue = columns[i].filterValue;
                if (columns[i].filter) customFilter = columns[i].filter.props.onFilter;
                break;
            }
            if (clearFilters[dataField] && customFilter) {
                currentResult = customFilter(clearFilters[dataField].filterVal, result);
                if (typeof currentResult !== "undefined") result = currentResult;
            } else {
                var filterObj = filterState[dataField];
                filterFn = factory(filterObj.filterType);
                if (customFilter) currentResult = customFilter(filterObj.filterVal, result);
                if (typeof currentResult === "undefined") result = filterFn(result, dataField, filterObj, filterValue);
                else result = currentResult;
            }
        });
        return result;
    };
};

});



parcelRegister("kBJxW", function(module, exports) {

$parcel$export(module.exports, "nanoid", () => $f00a97eed1786a48$export$ac4959f4f1338dfc);

var $kT1FK = parcelRequire("kT1FK");
let $f00a97eed1786a48$export$4385e60b38654f68 = (bytes)=>crypto.getRandomValues(new Uint8Array(bytes));
let $f00a97eed1786a48$export$a5cee9e955a615e5 = (alphabet, size, getRandom)=>{
    let mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
    let step = -~(1.6 * mask * size / alphabet.length);
    return ()=>{
        let id = "";
        while(true){
            let bytes = getRandom(step);
            let j = step;
            while(j--){
                id += alphabet[bytes[j] & mask] || "";
                if (id.length === size) return id;
            }
        }
    };
};
let $f00a97eed1786a48$export$62e99e5c9f473d7f = (alphabet, size)=>$f00a97eed1786a48$export$a5cee9e955a615e5(alphabet, size, $f00a97eed1786a48$export$4385e60b38654f68);
let $f00a97eed1786a48$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let bytes = crypto.getRandomValues(new Uint8Array(size));
    while(size--){
        let byte = bytes[size] & 63;
        if (byte < 36) id += byte.toString(36);
        else if (byte < 62) id += (byte - 26).toString(36).toUpperCase();
        else if (byte < 63) id += "_";
        else id += "-";
    }
    return id;
};

});
parcelRegister("kT1FK", function(module, exports) {
let $f34a3dcdc8494601$export$2b646eea95309f00 = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";

});


parcelRegister("4L5iB", function(module, exports) {

$parcel$export(module.exports, "CustomInput", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("7jSYQ")))));
$parcel$export(module.exports, "Input", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("bOVu2")))));

var $gludr = parcelRequire("gludr");

var $7jSYQ = parcelRequire("7jSYQ");

var $bOVu2 = parcelRequire("bOVu2");

});
parcelRegister("gludr", function(module, exports) {
"use strict";
var $be660bc138f019db$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $be660bc138f019db$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $be660bc138f019db$var$react_1 = $be660bc138f019db$var$__importDefault((parcelRequire("acw62")));

var $e8lFn = parcelRequire("e8lFn");
const $be660bc138f019db$var$Label = (props)=>{
    const { dataLwtId: dataLwtId } = props, restProps = $be660bc138f019db$var$__rest(props, [
        "dataLwtId"
    ]);
    return $be660bc138f019db$var$react_1.default.createElement($e8lFn.default, Object.assign({
        "data-lwt-id": dataLwtId
    }, restProps));
};
module.exports.default = $be660bc138f019db$var$Label;

});

parcelRegister("7jSYQ", function(module, exports) {
"use strict";
var $5544f4b4289c6f75$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $5544f4b4289c6f75$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $5544f4b4289c6f75$var$react_1 = $5544f4b4289c6f75$var$__importDefault((parcelRequire("acw62")));

var $awZuS = parcelRequire("awZuS");
const $5544f4b4289c6f75$var$CustomInput = (props)=>{
    const { dataLwtId: dataLwtId } = props, restProps = $5544f4b4289c6f75$var$__rest(props, [
        "dataLwtId"
    ]);
    return $5544f4b4289c6f75$var$react_1.default.createElement($awZuS.default, Object.assign({
        "data-lwt-id": dataLwtId
    }, restProps));
};
module.exports.default = $5544f4b4289c6f75$var$CustomInput;

});

parcelRegister("bOVu2", function(module, exports) {
"use strict";
var $89b0f4419e621472$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $89b0f4419e621472$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $89b0f4419e621472$var$react_1 = $89b0f4419e621472$var$__importDefault((parcelRequire("acw62")));

var $giAV6 = parcelRequire("giAV6");
const $89b0f4419e621472$var$numberFormat = new Intl.NumberFormat();
const $89b0f4419e621472$var$Input = (props)=>{
    const { dataLwtId: dataLwtId, type: type, allowCommas: allowCommas, decimalLimit: decimalLimit } = props, rest = $89b0f4419e621472$var$__rest(props, [
        "dataLwtId",
        "type",
        "allowCommas",
        "decimalLimit"
    ]);
    const checkCommas = allowCommas && type === "number";
    let internalType = type;
    const decimalDigits = decimalLimit ? `{0,${decimalLimit}}` : "*";
    const reg = new RegExp(`^-?[\\d,]*\\.?\\d${decimalDigits}$`);
    if (checkCommas) {
        internalType = "text";
        if (!rest.step) rest.step = "any";
    }
    const onBlur = (e)=>{
        if (checkCommas) {
            const inputEvent = e.target;
            const value = inputEvent.value !== "" ? $89b0f4419e621472$var$numberFormat.format(+inputEvent.value.split(",").join("")) : "";
            setNativeValue(inputEvent, value);
            inputEvent.dispatchEvent(new Event("input", {
                bubbles: true
            }));
        }
        if (props.onBlur) props.onBlur(e);
    };
    const onPaste = (e)=>{
        if (checkCommas) {
            const inputEvent = e.target;
            const value = inputEvent.value + e.clipboardData.getData("text/plain");
            if (!isValidNumericInput(value)) e.preventDefault();
        }
        if (props.onPaste) props.onPaste(e);
    };
    const onKeyDown = (e)=>{
        if (checkCommas) {
            const validKeys = [
                37,
                39,
                8,
                46,
                9 // tab
            ];
            if (validKeys.some((k)=>k === e.keyCode)) return;
            const inputEvent = e.target;
            const index = +(inputEvent.selectionStart || 0);
            const value = inputEvent.value.substring(0, index) + e.key + inputEvent.value.substring(index);
            if (!isValidNumericInput(value)) e.preventDefault();
        }
        if (props.onKeyDown) props.onKeyDown(e);
    };
    const isValidNumericInput = (value)=>reg.test(value);
    // facebook's suggestion on programmatically updating input element:
    // https://github.com/facebook/react/issues/10135#issuecomment-314441175
    const setNativeValue = (element, value)=>{
        var _a, _b;
        const valueSetter = (_a = Object.getOwnPropertyDescriptor(element, "value")) === null || _a === void 0 ? void 0 : _a.set;
        const prototype = Object.getPrototypeOf(element);
        const prototypeValueSetter = (_b = Object.getOwnPropertyDescriptor(prototype, "value")) === null || _b === void 0 ? void 0 : _b.set;
        if (valueSetter && prototypeValueSetter && valueSetter !== prototypeValueSetter) prototypeValueSetter.call(element, value);
        else if (valueSetter) valueSetter.call(element, value);
    };
    return $89b0f4419e621472$var$react_1.default.createElement($giAV6.default, Object.assign({
        "data-lwt-id": dataLwtId,
        type: internalType
    }, rest, {
        onPaste: onPaste,
        onBlur: onBlur,
        onKeyDown: onKeyDown
    }));
};
$89b0f4419e621472$var$Input.defaultProps = {
    allowCommas: true
};
module.exports.default = $89b0f4419e621472$var$Input;

});


parcelRegister("9SWta", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7326830318371647$export$2e2bcd8739ae039);

var $bL2Zm = parcelRequire("bL2Zm");
var $7326830318371647$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($bL2Zm)));

});
parcelRegister("bL2Zm", function(module, exports) {
"use strict";
var $88f6670308dc100a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $88f6670308dc100a$var$react_1 = $88f6670308dc100a$var$__importDefault((parcelRequire("acw62")));

const $88f6670308dc100a$var$react_select_1 = $88f6670308dc100a$var$__importDefault((parcelRequire("a21V2")));

const $88f6670308dc100a$var$creatable_1 = $88f6670308dc100a$var$__importDefault((parcelRequire("fcvsF")));
const $88f6670308dc100a$var$Select = (props)=>{
    const { dataLwtId: dataLwtId, isCreatable: isCreatable, styles: styles, ...restProps } = props;
    const customStyles = styles || {
        control: (base, state)=>({
                ...base,
                color: state.isFocused ? "#495057" : base.color,
                backgroundColor: state.isFocused ? "#fff" : base.backgroundColor,
                borderColor: state.isFocused ? "#5dbaed" : base.borderColor,
                outline: state.isFocused ? 0 : base.outline,
                boxShadow: state.isFocused ? "0 0 0 0.2rem rgba(20, 125, 183, 0.25)" : base.boxShadow,
                "&:hover": {
                    borderColor: state.isFocused ? "#5dbaed" : base.borderColor
                }
            })
    };
    const select = isCreatable ? $88f6670308dc100a$var$react_1.default.createElement($88f6670308dc100a$var$creatable_1.default, {
        styles: customStyles,
        ...restProps
    }) : $88f6670308dc100a$var$react_1.default.createElement($88f6670308dc100a$var$react_select_1.default, {
        styles: customStyles,
        ...restProps
    });
    return $88f6670308dc100a$var$react_1.default.createElement("div", {
        "data-lwt-id": dataLwtId
    }, select);
};
$88f6670308dc100a$var$Select.defaultProps = {
    closeMenuOnSelect: true,
    hideSelectedOptions: false,
    isClearable: true,
    isCreatable: false,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isSearchable: true
};
module.exports.default = $88f6670308dc100a$var$Select;

});


parcelRegister("6Ml1B", function(module, exports) {
"use strict";
var $4ef788e2ded14955$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4ef788e2ded14955$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $4ef788e2ded14955$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $4ef788e2ded14955$var$__createBinding(result, mod, k);
    }
    $4ef788e2ded14955$var$__setModuleDefault(result, mod);
    return result;
};
var $4ef788e2ded14955$var$__rest = module.exports && module.exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
var $4ef788e2ded14955$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useIsFirstRender = void 0;

const $4ef788e2ded14955$var$react_1 = $4ef788e2ded14955$var$__importStar((parcelRequire("acw62")));

const $4ef788e2ded14955$var$classnames_1 = $4ef788e2ded14955$var$__importDefault((parcelRequire("8g1PZ")));
parcelRequire("4L5iB");
var $bOVu2 = parcelRequire("bOVu2");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");
const $4ef788e2ded14955$var$useIsFirstRender = ()=>{
    const isFirstRender = (0, $4ef788e2ded14955$var$react_1.useRef)(true);
    (0, $4ef788e2ded14955$var$react_1.useEffect)(()=>{
        isFirstRender.current = false;
    }, []);
    return isFirstRender.current;
};
module.exports.useIsFirstRender = $4ef788e2ded14955$var$useIsFirstRender;
const $4ef788e2ded14955$var$getAsNumber = (val, datatype)=>{
    return datatype === "number" && !isNaN(parseFloat(val)) && isFinite(Number(val)) ? parseFloat(val) : val;
};
const $4ef788e2ded14955$var$EditableCell = (props)=>{
    const { disabled: disabled, datatype: datatype, inputProps: inputProps, wrapperClasses: wrapperClasses, wrapperStyle: wrapperStyle, applyButtonProps: applyButtonProps, resetButtonProps: resetButtonProps, dataLwtId: dataLwtId, onChange: onChange, onBlur: onBlur } = props;
    const { id: inputId, type: type, className: className, originalValue: originalValue, updatedValue: updatedValue, programmaticValue: programmaticValue, resetToProgrammaticValue: resetToProgrammaticValue, disabled: inputDisabled, formatValue: formatValue, formatValueOnBlur: formatValueOnBlur, displayAppliedCheck: displayAppliedCheck, valueApplied: valueApplied, setInitialValueFromField: // eslint-disable-next-line no-unused-vars,@typescript-eslint/no-unused-vars
    setInitialValueFromField, disableWhen: disableWhen, isInvalid: isInvalid } = inputProps, inputPropsRest = $4ef788e2ded14955$var$__rest(inputProps, [
        "id",
        "type",
        "className",
        "originalValue",
        "updatedValue",
        "programmaticValue",
        "resetToProgrammaticValue",
        "disabled",
        "formatValue",
        "formatValueOnBlur",
        "displayAppliedCheck",
        "valueApplied",
        "setInitialValueFromField",
        "disableWhen",
        "isInvalid"
    ]);
    const isFirstRender = (0, module.exports.useIsFirstRender)();
    const initialState = {
        disabled: disabled,
        inputState: {
            disabled: disableWhen && disableWhen(originalValue) || inputDisabled,
            displayAppliedCheckClass: valueApplied || false,
            disableWhen: disableWhen
        },
        applyState: {
            hidden: applyButtonProps === null || applyButtonProps === void 0 ? void 0 : applyButtonProps.hidden,
            disabled: (applyButtonProps === null || applyButtonProps === void 0 ? void 0 : applyButtonProps.disableWhen) && (applyButtonProps === null || applyButtonProps === void 0 ? void 0 : applyButtonProps.disableWhen(updatedValue)) || (applyButtonProps === null || applyButtonProps === void 0 ? void 0 : applyButtonProps.disabled),
            disableWhen: applyButtonProps === null || applyButtonProps === void 0 ? void 0 : applyButtonProps.disableWhen
        },
        resetState: {
            hidden: resetButtonProps === null || resetButtonProps === void 0 ? void 0 : resetButtonProps.hidden,
            disabled: (resetButtonProps === null || resetButtonProps === void 0 ? void 0 : resetButtonProps.forceEnable) && $4ef788e2ded14955$var$getAsNumber(updatedValue, datatype || "") !== programmaticValue ? false : resetToProgrammaticValue && $4ef788e2ded14955$var$getAsNumber(updatedValue, datatype || "") === programmaticValue || !resetToProgrammaticValue && (resetButtonProps === null || resetButtonProps === void 0 ? void 0 : resetButtonProps.disabled)
        },
        values: {
            originalValue: originalValue,
            inputValue: formatValue ? formatValue(updatedValue) : updatedValue,
            appliedValue: applyButtonProps && !valueApplied ? undefined : $4ef788e2ded14955$var$getAsNumber(formatValue ? formatValue(updatedValue) : updatedValue, datatype || ""),
            programmaticValue: programmaticValue,
            valueChanged: true
        }
    };
    const [state, setState] = (0, $4ef788e2ded14955$var$react_1.useState)(initialState);
    const handleApplyClick = ()=>{
        setState((prevState)=>{
            const appliedValue = $4ef788e2ded14955$var$getAsNumber(formatValue ? formatValue(prevState.values.inputValue) : prevState.values.inputValue, datatype || "");
            if (prevState.applyState.disableWhen && prevState.applyState.disableWhen(appliedValue)) return Object.assign(Object.assign({}, prevState), {
                applyState: Object.assign(Object.assign({}, prevState.applyState), {
                    disabled: true
                }),
                values: Object.assign(Object.assign({}, prevState.values), {
                    inputValue: formatValue ? formatValue(prevState.values.inputValue) : prevState.values.inputValue
                })
            });
            else return Object.assign(Object.assign({}, prevState), {
                disabled: false,
                inputState: Object.assign(Object.assign({}, prevState.inputState), {
                    disabled: true,
                    displayAppliedCheckClass: displayAppliedCheck ? !prevState.inputState.displayAppliedCheckClass : prevState.inputState.displayAppliedCheckClass
                }),
                applyState: Object.assign(Object.assign({}, prevState.applyState), {
                    hidden: applyButtonProps ? !prevState.applyState.hidden : prevState.applyState.hidden,
                    disabled: true
                }),
                resetState: Object.assign(Object.assign({}, prevState.resetState), {
                    hidden: applyButtonProps ? !prevState.resetState.hidden : prevState.resetState.hidden,
                    disabled: resetButtonProps ? false : prevState.resetState.disabled
                }),
                values: Object.assign(Object.assign({}, prevState.values), {
                    inputValue: formatValue ? formatValue(prevState.values.inputValue) : prevState.values.inputValue,
                    appliedValue: appliedValue,
                    valueChanged: true,
                    manualChange: false
                })
            });
        });
    };
    const handleResetClick = ()=>{
        setState((prevState)=>{
            const resetToValue = resetToProgrammaticValue ? prevState.values.programmaticValue : prevState.values.originalValue;
            return Object.assign(Object.assign({}, prevState), {
                inputState: Object.assign(Object.assign({}, prevState.inputState), {
                    disabled: applyButtonProps ? false : prevState.inputState.disabled,
                    displayAppliedCheckClass: displayAppliedCheck ? !prevState.inputState.displayAppliedCheckClass : prevState.inputState.displayAppliedCheckClass
                }),
                applyState: Object.assign(Object.assign({}, prevState.applyState), {
                    hidden: applyButtonProps ? !prevState.applyState.hidden : prevState.applyState.hidden,
                    disabled: applyButtonProps ? false : prevState.applyState.disableWhen && prevState.applyState.disableWhen(resetToValue) || prevState.applyState.disabled
                }),
                resetState: Object.assign(Object.assign({}, prevState.resetState), {
                    hidden: applyButtonProps ? !prevState.resetState.hidden : prevState.resetState.hidden,
                    disabled: true
                }),
                values: Object.assign(Object.assign({}, prevState.values), {
                    inputValue: formatValue ? formatValue(resetToValue) : resetToValue,
                    appliedValue: applyButtonProps ? undefined : $4ef788e2ded14955$var$getAsNumber(formatValue ? formatValue(resetToValue) : resetToValue, datatype || ""),
                    valueChanged: true,
                    manualChange: false
                })
            });
        });
    };
    const handleResetMouseEnter = ()=>{
        !state.resetState.disabled && !applyButtonProps && setState((prevState)=>Object.assign(Object.assign({}, prevState), {
                resetState: Object.assign(Object.assign({}, prevState.resetState), {
                    cancelBlur: true
                })
            }));
    };
    const handleResetMouseLeave = ()=>{
        !state.resetState.disabled && !applyButtonProps && setState((prevState)=>Object.assign(Object.assign({}, prevState), {
                resetState: Object.assign(Object.assign({}, prevState.resetState), {
                    cancelBlur: false
                })
            }));
    };
    const handleChange = (e)=>{
        const inputValue = $4ef788e2ded14955$var$getAsNumber(e.currentTarget.value, datatype || "");
        const appliedValue = $4ef788e2ded14955$var$getAsNumber(formatValue ? formatValue(e.currentTarget.value) : e.currentTarget.value, datatype || "");
        setState((prevState)=>Object.assign(Object.assign({}, prevState), {
                applyState: Object.assign(Object.assign({}, prevState.applyState), {
                    disabled: prevState.applyState.disableWhen && prevState.applyState.disableWhen(appliedValue) || false
                }),
                resetState: Object.assign(Object.assign({}, prevState.resetState), {
                    disabled: !applyButtonProps && resetButtonProps ? false : prevState.resetState.disabled
                }),
                values: Object.assign(Object.assign({}, prevState.values), {
                    inputValue: formatValue && !formatValueOnBlur ? formatValue(inputValue) : inputValue,
                    appliedValue: !applyButtonProps ? appliedValue : prevState.values.appliedValue,
                    valueChanged: true,
                    manualChange: true
                })
            }));
    };
    const handleBlur = (e)=>{
        if (applyButtonProps) return;
        const value = $4ef788e2ded14955$var$getAsNumber(datatype === "number" ? e.currentTarget.value || "0" : e.currentTarget.value, datatype || "");
        setState((prevState)=>Object.assign(Object.assign({}, prevState), {
                values: Object.assign(Object.assign({}, prevState.values), {
                    inputValue: formatValue && formatValueOnBlur ? formatValue(value) : prevState.values.inputValue
                })
            }));
        !state.resetState.cancelBlur && onBlur && onBlur(state.values.appliedValue);
    };
    const showWrapper = wrapperClasses && wrapperStyle;
    const inputClasses = (0, $4ef788e2ded14955$var$classnames_1.default)(className, state.inputState.displayAppliedCheckClass && "is-valid-check", isInvalid && "is-invalid");
    const applyProps = applyButtonProps ? Object.assign(Object.assign({}, applyButtonProps), {
        className: (0, $4ef788e2ded14955$var$classnames_1.default)(applyButtonProps.className, state.applyState.hidden && "d-none"),
        onClick: handleApplyClick,
        disabled: state.applyState.disabled
    }) : undefined;
    applyProps && delete applyProps.disableWhen;
    const resetProps = resetButtonProps ? Object.assign(Object.assign({}, resetButtonProps), {
        className: (0, $4ef788e2ded14955$var$classnames_1.default)(resetButtonProps.className, state.resetState.hidden && "d-none"),
        onClick: handleResetClick,
        disabled: state.resetState.disabled,
        onMouseEnter: handleResetMouseEnter,
        onMouseLeave: handleResetMouseLeave
    }) : undefined;
    resetProps && delete resetProps.forceEnable;
    // Here the value of the cell has changed, so we want to call back (onChange) on SchemaTable and have its state
    // updated, as well as the state of the cell
    (0, $4ef788e2ded14955$var$react_1.useEffect)(()=>{
        !isFirstRender && state.values.valueChanged && onChange && onChange({
            disabled: state.disabled,
            inputProps: {
                disabled: state.inputState.disabled,
                valueApplied: state.inputState.displayAppliedCheckClass,
                appliedValue: state.values.appliedValue,
                originalValue: originalValue,
                programmaticValue: state.values.programmaticValue,
                programmaticChange: false
            },
            applyButtonProps: applyButtonProps && {
                hidden: state.applyState.hidden,
                disabled: state.applyState.disabled
            },
            resetButtonProps: resetButtonProps && {
                hidden: state.resetState.hidden,
                disabled: state.resetState.disabled
            }
        }, !state.values.manualChange);
    }, [
        state.values.appliedValue
    ]);
    (0, $4ef788e2ded14955$var$react_1.useEffect)(()=>{
        if (!isFirstRender) {
            initialState.values.valueChanged = false;
            setState(initialState);
        }
    }, [
        applyButtonProps === null || applyButtonProps === void 0 ? void 0 : applyButtonProps.disabled,
        applyButtonProps === null || applyButtonProps === void 0 ? void 0 : applyButtonProps.hidden,
        resetButtonProps === null || resetButtonProps === void 0 ? void 0 : resetButtonProps.disabled,
        resetButtonProps === null || resetButtonProps === void 0 ? void 0 : resetButtonProps.hidden,
        resetButtonProps === null || resetButtonProps === void 0 ? void 0 : resetButtonProps.forceEnable,
        inputProps === null || inputProps === void 0 ? void 0 : inputProps.disabled,
        inputProps === null || inputProps === void 0 ? void 0 : inputProps.valueApplied
    ]);
    (0, $4ef788e2ded14955$var$react_1.useEffect)(()=>{
        !isFirstRender && setState((prevState)=>Object.assign(Object.assign({}, prevState), {
                disabled: disabled,
                inputState: Object.assign(Object.assign({}, prevState.inputState), {
                    disabled: inputDisabled
                })
            }));
    }, [
        disabled,
        inputDisabled
    ]);
    const wrapperContent = $4ef788e2ded14955$var$react_1.default.createElement($4ef788e2ded14955$var$react_1.default.Fragment, null, $4ef788e2ded14955$var$react_1.default.createElement($bOVu2.default, Object.assign({}, inputPropsRest, {
        id: inputId,
        type: type || "text",
        className: inputClasses,
        disabled: state.inputState.disabled,
        value: state.values.inputValue,
        onBlur: handleBlur,
        onChange: handleChange
    })), applyButtonProps && $4ef788e2ded14955$var$react_1.default.createElement($6thlO.default, Object.assign({
        dataLwtId: `${dataLwtId}-apply-button`
    }, applyProps)), resetButtonProps && $4ef788e2ded14955$var$react_1.default.createElement($6thlO.default, Object.assign({
        dataLwtId: `${dataLwtId}-reset-button`
    }, resetProps)));
    return showWrapper ? $4ef788e2ded14955$var$react_1.default.createElement("div", {
        className: wrapperClasses,
        style: wrapperStyle,
        "data-lwt-id": dataLwtId
    }, wrapperContent) : $4ef788e2ded14955$var$react_1.default.createElement($4ef788e2ded14955$var$react_1.default.Fragment, null, wrapperContent);
};
module.exports.default = $4ef788e2ded14955$var$EditableCell;

});

parcelRegister("dfFfy", function(module, exports) {
"use strict";
var $9a5cac6fe4d4a780$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $9a5cac6fe4d4a780$var$react_1 = $9a5cac6fe4d4a780$var$__importDefault((parcelRequire("acw62")));

var $dJwER = parcelRequire("dJwER");

const $9a5cac6fe4d4a780$var$date_picker_1 = $9a5cac6fe4d4a780$var$__importDefault((parcelRequire("4CDen")));
const $9a5cac6fe4d4a780$var$DatePickerFilter = (props)=>{
    const { onFilter: onFilter, dataLwtId: dataLwtId, datePickerProps: datePickerProps } = props;
    const onChange = (selectedDate)=>{
        // If a user selected date is passed, set the comparator to equal.
        // Otherwise, when no selected date is available, the empty comparator forces all rows to tbe displayed.
        const compare = selectedDate ? $dJwER.Comparator.EQ : "";
        // selectedDate is a string representation of the user selected date that is sent to the backend.
        // We need to use a date type below.
        onFilter && onFilter({
            date: new Date(selectedDate),
            comparator: compare
        });
    };
    return $9a5cac6fe4d4a780$var$react_1.default.createElement($9a5cac6fe4d4a780$var$date_picker_1.default, Object.assign({
        onChange: onChange,
        "data-lwt-id": dataLwtId
    }, datePickerProps));
};
module.exports.default = $9a5cac6fe4d4a780$var$DatePickerFilter;

});
parcelRegister("4CDen", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $35d9247bd252a8ad$export$2e2bcd8739ae039);

var $h5bJX = parcelRequire("h5bJX");
var $35d9247bd252a8ad$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($h5bJX)));

});
parcelRegister("h5bJX", function(module, exports) {
"use strict";
var $c6fc02ae45ba30c4$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c6fc02ae45ba30c4$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $c6fc02ae45ba30c4$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c6fc02ae45ba30c4$var$__createBinding(result, mod, k);
    }
    $c6fc02ae45ba30c4$var$__setModuleDefault(result, mod);
    return result;
};
var $c6fc02ae45ba30c4$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $c6fc02ae45ba30c4$var$react_1 = $c6fc02ae45ba30c4$var$__importStar((parcelRequire("acw62")));

const $c6fc02ae45ba30c4$var$react_datepicker_1 = $c6fc02ae45ba30c4$var$__importDefault((parcelRequire("25wyV")));

var $6IhJz = parcelRequire("6IhJz");
var $cFZfS = parcelRequire("cFZfS");

const $c6fc02ae45ba30c4$var$classnames_1 = $c6fc02ae45ba30c4$var$__importDefault((parcelRequire("8g1PZ")));


class $c6fc02ae45ba30c4$var$DatePicker extends $c6fc02ae45ba30c4$var$react_1.Component {
    constructor(props){
        super(props);
        this.handleDivChange = (event)=>{
            let selectedDate;
            let backEndDateValue;
            if (event && event.target) {
                let inputEvent = event.target;
                const displayDate = new Date(inputEvent.value);
                if (!(0, $cFZfS.default)(displayDate) || $c6fc02ae45ba30c4$var$DatePicker.isYearGreaterThan10000(displayDate)) {
                    event.preventDefault();
                    return;
                }
                if (displayDate) {
                    if (!isNaN(displayDate.getTime())) {
                        selectedDate = displayDate;
                        backEndDateValue = (0, $6IhJz.default)(selectedDate, this.state.backEndFormat);
                    } else {
                        selectedDate = this.state.selectedDate;
                        backEndDateValue = this.state.selectedDate && (0, $6IhJz.default)(this.state.selectedDate, this.state.backEndFormat);
                    }
                } else selectedDate = null;
                this.changeState(selectedDate, backEndDateValue);
            }
        };
        this.handleChange = (date)=>{
            if (date && $c6fc02ae45ba30c4$var$DatePicker.isYearGreaterThan10000(date)) return;
            const backEndDateValue = date ? (0, $6IhJz.default)(date, this.state.backEndFormat) : undefined;
            this.changeState(date, backEndDateValue);
        };
        this.changeState = (selectedDate, backEndDateValue)=>{
            this.setState({
                selectedDate: selectedDate
            }, ()=>{
                if (this.props.onChange) this.props.onChange(backEndDateValue);
            });
        };
        const value = this.props.value && $c6fc02ae45ba30c4$var$DatePicker.formatDate(this.props.value);
        this.state = {
            selectedDate: value ? new Date(value.includes("T") ? value.replace(/T.+/, "") : value) : null,
            placeholderText: this.props.placeholderText ? this.props.placeholderText : this.props.displayFormat ? this.props.displayFormat : "MM/DD/YYYY",
            className: this.props.className ? this.props.className : "form-control",
            classNameContainer: this.props.fullWidth ? "react-datepicker-full-width" : "",
            displayFormat: this.props.displayFormat ? this.props.displayFormat : "MM/dd/yyyy",
            backEndFormat: this.props.backEndFormat ? this.props.backEndFormat : "yyyy-MM-dd"
        };
    }
    static formatDate(date) {
        return date.replace(/-/g, "/").replace(/\./g, "/");
    }
    static isYearGreaterThan10000(date) {
        return Math.round(date.getFullYear() / 10000) > 0;
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState((prevState)=>{
            const value = nextProps.value && $c6fc02ae45ba30c4$var$DatePicker.formatDate(nextProps.value);
            const date = value && new Date(value.includes("T") ? value.replace(/T.+/, "") : value) || undefined;
            const className = (0, $c6fc02ae45ba30c4$var$classnames_1.default)(nextProps.className, prevState.className.indexOf("form-control") !== -1 && "form-control");
            return Object.assign(Object.assign({}, prevState), {
                selectedDate: date !== undefined && !isNaN(date.getTime()) ? date : this.state.selectedDate,
                className: className,
                classNameContainer: this.props.fullWidth ? "react-datepicker-full-width" : ""
            });
        });
    }
    render() {
        return $c6fc02ae45ba30c4$var$react_1.default.createElement("div", {
            "data-lwt-id": this.props.dataLwtId,
            className: this.state.classNameContainer,
            onChange: this.handleDivChange,
            onClick: (e)=>e.stopPropagation()
        }, $c6fc02ae45ba30c4$var$react_1.default.createElement($c6fc02ae45ba30c4$var$react_datepicker_1.default, {
            className: this.state.className,
            selected: this.state.selectedDate,
            onChange: this.handleChange,
            isClearable: !this.props.readOnly,
            dateFormat: this.state.displayFormat,
            placeholderText: this.state.placeholderText,
            onBlur: this.props.onBlur,
            onFocus: this.props.onFocus,
            readOnly: this.props.readOnly
        }));
    }
}
module.exports.default = $c6fc02ae45ba30c4$var$DatePicker;

});
parcelRegister("25wyV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getDefaultLocale", () => $18554e9a4ab03c83$export$f09106e7c6677ec5);
$parcel$export(module.exports, "registerLocale", () => $18554e9a4ab03c83$export$bab6a7822cc1e2cd);
$parcel$export(module.exports, "setDefaultLocale", () => $18554e9a4ab03c83$export$a1a5025df4e9ba34);
$parcel$export(module.exports, "CalendarContainer", () => $18554e9a4ab03c83$export$946daa762919616e);
$parcel$export(module.exports, "default", () => $18554e9a4ab03c83$export$2e2bcd8739ae039);

var $acw62 = parcelRequire("acw62");


var $8g1PZ = parcelRequire("8g1PZ");

var $9BdaM = parcelRequire("9BdaM");

var $cFZfS = parcelRequire("cFZfS");

var $6IhJz = parcelRequire("6IhJz");

var $bTSG2 = parcelRequire("bTSG2");

var $kehhj = parcelRequire("kehhj");

var $6OX6Q = parcelRequire("6OX6Q");

var $2MTnF = parcelRequire("2MTnF");

var $eqWMS = parcelRequire("eqWMS");

var $kbDwl = parcelRequire("kbDwl");



var $4irF8 = parcelRequire("4irF8");

var $lDduA = parcelRequire("lDduA");

var $lXe7Q = parcelRequire("lXe7Q");

var $4UG1B = parcelRequire("4UG1B");

var $6fhf3 = parcelRequire("6fhf3");

var $aABJG = parcelRequire("aABJG");

var $kjLiX = parcelRequire("kjLiX");

var $34ylv = parcelRequire("34ylv");

var $eZOMj = parcelRequire("eZOMj");

var $4UeRq = parcelRequire("4UeRq");

var $knAHj = parcelRequire("knAHj");

var $2SwgK = parcelRequire("2SwgK");

var $d0W11 = parcelRequire("d0W11");

var $6mdUF = parcelRequire("6mdUF");

var $gpyWg = parcelRequire("gpyWg");

var $cZ2kT = parcelRequire("cZ2kT");

var $3lKFD = parcelRequire("3lKFD");

var $8v9st = parcelRequire("8v9st");

var $6atcA = parcelRequire("6atcA");

var $lm2ga = parcelRequire("lm2ga");

var $1Whvr = parcelRequire("1Whvr");

var $e4h6L = parcelRequire("e4h6L");

var $1MaHn = parcelRequire("1MaHn");

var $cJfMa = parcelRequire("cJfMa");

var $7yBDJ = parcelRequire("7yBDJ");

var $5E40x = parcelRequire("5E40x");

var $6eIgt = parcelRequire("6eIgt");

var $75XN4 = parcelRequire("75XN4");


var $gd5RE = parcelRequire("gd5RE");

var $hjw1k = parcelRequire("hjw1k");

var $b27pX = parcelRequire("b27pX");

var $R4xmB = parcelRequire("R4xmB");

var $baBa1 = parcelRequire("baBa1");

var $4YTY5 = parcelRequire("4YTY5");

var $gDwFN = parcelRequire("gDwFN");

var $gdr0J = parcelRequire("gdr0J");

var $auRgN = parcelRequire("auRgN");

var $hL3CS = parcelRequire("hL3CS");

var $8j0J5 = parcelRequire("8j0J5");
var $3cbhK = parcelRequire("3cbhK");
var $6KgD0 = parcelRequire("6KgD0");
var $18554e9a4ab03c83$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $18554e9a4ab03c83$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $18554e9a4ab03c83$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $18554e9a4ab03c83$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $18554e9a4ab03c83$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $18554e9a4ab03c83$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
// ** Date Constructors **
function $18554e9a4ab03c83$var$newDate(value) {
    var d = value ? (0, $gdr0J.default)(value) : new Date();
    return $18554e9a4ab03c83$var$isValid(d) ? d : null;
}
function $18554e9a4ab03c83$var$parseDate(value, dateFormat, locale, strictParsing) {
    var parsedDate = null;
    var localeObject = $18554e9a4ab03c83$var$getLocaleObject(locale);
    var strictParsingValueMatch = true;
    if (Array.isArray(dateFormat)) {
        dateFormat.forEach(function(df) {
            var tryParseDate = (0, $auRgN.default)(value, df, new Date(), localeObject);
            if (strictParsing) strictParsingValueMatch = $18554e9a4ab03c83$var$isValid(tryParseDate) && value === (0, $6IhJz.default)(tryParseDate, df, {
                awareOfUnicodeTokens: true
            });
            if ($18554e9a4ab03c83$var$isValid(tryParseDate) && strictParsingValueMatch) parsedDate = tryParseDate;
        });
        return parsedDate;
    }
    parsedDate = (0, $auRgN.default)(value, dateFormat, new Date(), localeObject);
    if (strictParsing) strictParsingValueMatch = $18554e9a4ab03c83$var$isValid(parsedDate) && value === (0, $6IhJz.default)(parsedDate, dateFormat, {
        awareOfUnicodeTokens: true
    });
    else if (!$18554e9a4ab03c83$var$isValid(parsedDate)) parsedDate = new Date(value);
    return $18554e9a4ab03c83$var$isValid(parsedDate) && strictParsingValueMatch ? parsedDate : null;
}
function $18554e9a4ab03c83$var$isValid(date) {
    return (0, $cFZfS.default)(date) && (0, $baBa1.default)(date, new Date("1/1/1000"));
}
// ** Date Formatting **
function $18554e9a4ab03c83$var$formatDate(date, formatStr, locale) {
    if (locale === "en") return (0, $6IhJz.default)(date, formatStr, {
        awareOfUnicodeTokens: true
    });
    var localeObj = $18554e9a4ab03c83$var$getLocaleObject(locale);
    if (locale && !localeObj) console.warn('A locale object was not found for the provided string ["' + locale + '"].');
    if (!localeObj && !!$18554e9a4ab03c83$export$f09106e7c6677ec5() && !!$18554e9a4ab03c83$var$getLocaleObject($18554e9a4ab03c83$export$f09106e7c6677ec5())) localeObj = $18554e9a4ab03c83$var$getLocaleObject($18554e9a4ab03c83$export$f09106e7c6677ec5());
    return (0, $6IhJz.default)(date, formatStr, {
        locale: localeObj ? localeObj : null,
        awareOfUnicodeTokens: true
    });
}
function $18554e9a4ab03c83$var$safeDateFormat(date, _ref) {
    var dateFormat = _ref.dateFormat, locale = _ref.locale;
    return date && $18554e9a4ab03c83$var$formatDate(date, Array.isArray(dateFormat) ? dateFormat[0] : dateFormat, locale) || "";
}
// ** Date Setters **
function $18554e9a4ab03c83$var$setTime(date, _ref2) {
    var _ref2$hour = _ref2.hour, hour = _ref2$hour === undefined ? 0 : _ref2$hour, _ref2$minute = _ref2.minute, minute = _ref2$minute === undefined ? 0 : _ref2$minute, _ref2$second = _ref2.second, second = _ref2$second === undefined ? 0 : _ref2$second;
    return (0, $gpyWg.default)((0, $6mdUF.default)((0, $d0W11.default)(date, second), minute), hour);
}
function $18554e9a4ab03c83$var$getWeek(date) {
    var firstDayOfYear = (0, $1MaHn.default)(date, 1);
    if (!$18554e9a4ab03c83$var$isSameYear((0, $75XN4.default)(date), date)) return 1;
    return (0, $e4h6L.default)(date, (0, $6eIgt.default)(date)) + 1;
}
function $18554e9a4ab03c83$var$getDayOfWeekCode(day, locale) {
    return $18554e9a4ab03c83$var$formatDate(day, "ddd", locale);
}
// *** Start of ***
function $18554e9a4ab03c83$var$getStartOfDay(date) {
    return (0, $cJfMa.default)(date);
}
function $18554e9a4ab03c83$var$getStartOfWeek(date, locale) {
    var localeObj = locale ? $18554e9a4ab03c83$var$getLocaleObject(locale) : $18554e9a4ab03c83$var$getLocaleObject($18554e9a4ab03c83$export$f09106e7c6677ec5());
    return (0, $7yBDJ.default)(date, {
        locale: localeObj
    });
}
function $18554e9a4ab03c83$var$getStartOfMonth(date) {
    return (0, $5E40x.default)(date);
}
function $18554e9a4ab03c83$var$getStartOfToday() {
    return (0, $cJfMa.default)($18554e9a4ab03c83$var$newDate());
}
// *** End of ***
function $18554e9a4ab03c83$var$isSameYear(date1, date2) {
    if (date1 && date2) return (0, $R4xmB.default)(date1, date2);
    else return !date1 && !date2;
}
function $18554e9a4ab03c83$var$isSameMonth(date1, date2) {
    if (date1 && date2) return (0, $b27pX.default)(date1, date2);
    else return !date1 && !date2;
}
function $18554e9a4ab03c83$var$isSameDay(date1, date2) {
    if (date1 && date2) return (0, $hjw1k.default)(date1, date2);
    else return !date1 && !date2;
}
function $18554e9a4ab03c83$var$isEqual(date1, date2) {
    if (date1 && date2) return (0, $gd5RE.default)(date1, date2);
    else return !date1 && !date2;
}
function $18554e9a4ab03c83$var$isDayInRange(day, startDate, endDate) {
    var valid = void 0;
    try {
        valid = (0, $gDwFN.default)(day, {
            start: startDate,
            end: endDate
        });
    } catch (err) {
        valid = false;
    }
    return valid;
}
// *** Diffing ***
// ** Date Localization **
function $18554e9a4ab03c83$export$bab6a7822cc1e2cd(localeName, localeData) {
    var scope = typeof window !== "undefined" ? window : $parcel$global;
    if (!scope.__localeData__) scope.__localeData__ = {};
    scope.__localeData__[localeName] = localeData;
}
function $18554e9a4ab03c83$export$a1a5025df4e9ba34(localeName) {
    var scope = typeof window !== "undefined" ? window : $parcel$global;
    scope.__localeId__ = localeName;
}
function $18554e9a4ab03c83$export$f09106e7c6677ec5() {
    var scope = typeof window !== "undefined" ? window : $parcel$global;
    return scope.__localeId__;
}
function $18554e9a4ab03c83$var$getLocaleObject(localeSpec) {
    if (typeof localeSpec === "string") {
        // Treat it as a locale name registered by registerLocale
        var scope = typeof window !== "undefined" ? window : $parcel$global;
        return scope.__localeData__ ? scope.__localeData__[localeSpec] : null;
    } else // Treat it as a raw date-fns locale object
    return localeSpec;
}
function $18554e9a4ab03c83$var$getFormattedWeekdayInLocale(date, formatFunc, locale) {
    return formatFunc($18554e9a4ab03c83$var$formatDate(date, "EEEE", locale));
}
function $18554e9a4ab03c83$var$getWeekdayMinInLocale(date, locale) {
    return $18554e9a4ab03c83$var$formatDate(date, "EEEEEE", locale);
}
function $18554e9a4ab03c83$var$getWeekdayShortInLocale(date, locale) {
    return $18554e9a4ab03c83$var$formatDate(date, "EEE", locale);
}
function $18554e9a4ab03c83$var$getMonthInLocale(month, locale) {
    return $18554e9a4ab03c83$var$formatDate((0, $cZ2kT.default)($18554e9a4ab03c83$var$newDate(), month), "LLLL", locale);
}
function $18554e9a4ab03c83$var$getMonthShortInLocale(month, locale) {
    return $18554e9a4ab03c83$var$formatDate((0, $cZ2kT.default)($18554e9a4ab03c83$var$newDate(), month), "LLL", locale);
}
// ** Utils for some components **
function $18554e9a4ab03c83$var$isDayDisabled(day) {
    var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, minDate = _ref3.minDate, maxDate = _ref3.maxDate, excludeDates = _ref3.excludeDates, includeDates = _ref3.includeDates, filterDate = _ref3.filterDate;
    return $18554e9a4ab03c83$var$isOutOfBounds(day, {
        minDate: minDate,
        maxDate: maxDate
    }) || excludeDates && excludeDates.some(function(excludeDate) {
        return $18554e9a4ab03c83$var$isSameDay(day, excludeDate);
    }) || includeDates && !includeDates.some(function(includeDate) {
        return $18554e9a4ab03c83$var$isSameDay(day, includeDate);
    }) || filterDate && !filterDate($18554e9a4ab03c83$var$newDate(day)) || false;
}
function $18554e9a4ab03c83$var$isMonthinRange(startDate, endDate, m, day) {
    var startDateYear = (0, $knAHj.default)(startDate);
    var startDateMonth = (0, $4UeRq.default)(startDate);
    var endDateYear = (0, $knAHj.default)(endDate);
    var endDateMonth = (0, $4UeRq.default)(endDate);
    var dayYear = (0, $knAHj.default)(day);
    if (startDateYear === endDateYear && startDateYear === dayYear) return startDateMonth <= m && m <= endDateMonth;
    else if (startDateYear < endDateYear) return dayYear === startDateYear && startDateMonth <= m || dayYear === endDateYear && endDateMonth >= m || dayYear < endDateYear && dayYear > startDateYear;
}
function $18554e9a4ab03c83$var$isOutOfBounds(day) {
    var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, minDate = _ref4.minDate, maxDate = _ref4.maxDate;
    return minDate && (0, $lm2ga.default)(day, minDate) < 0 || maxDate && (0, $lm2ga.default)(day, maxDate) > 0;
}
function $18554e9a4ab03c83$var$isTimeDisabled(time, disabledTimes) {
    var l = disabledTimes.length;
    for(var i = 0; i < l; i++){
        if ((0, $kjLiX.default)(disabledTimes[i]) === (0, $kjLiX.default)(time) && (0, $aABJG.default)(disabledTimes[i]) === (0, $aABJG.default)(time)) return true;
    }
    return false;
}
function $18554e9a4ab03c83$var$isTimeInDisabledRange(time, _ref5) {
    var minTime = _ref5.minTime, maxTime = _ref5.maxTime;
    if (!minTime || !maxTime) throw new Error("Both minTime and maxTime props required");
    var base = $18554e9a4ab03c83$var$newDate();
    var baseTime = (0, $gpyWg.default)((0, $6mdUF.default)(base, (0, $aABJG.default)(time)), (0, $kjLiX.default)(time));
    var min$$1 = (0, $gpyWg.default)((0, $6mdUF.default)(base, (0, $aABJG.default)(minTime)), (0, $kjLiX.default)(minTime));
    var max$$1 = (0, $gpyWg.default)((0, $6mdUF.default)(base, (0, $aABJG.default)(maxTime)), (0, $kjLiX.default)(maxTime));
    var valid = void 0;
    try {
        valid = !(0, $gDwFN.default)(baseTime, {
            start: min$$1,
            end: max$$1
        });
    } catch (err) {
        valid = false;
    }
    return valid;
}
function $18554e9a4ab03c83$var$monthDisabledBefore(day) {
    var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, minDate = _ref6.minDate, includeDates = _ref6.includeDates;
    var previousMonth = (0, $lXe7Q.default)(day, 1);
    return minDate && (0, $1Whvr.default)(minDate, previousMonth) > 0 || includeDates && includeDates.every(function(includeDate) {
        return (0, $1Whvr.default)(includeDate, previousMonth) > 0;
    }) || false;
}
function $18554e9a4ab03c83$var$monthDisabledAfter(day) {
    var _ref7 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, maxDate = _ref7.maxDate, includeDates = _ref7.includeDates;
    var nextMonth = (0, $eqWMS.default)(day, 1);
    return maxDate && (0, $1Whvr.default)(nextMonth, maxDate) > 0 || includeDates && includeDates.every(function(includeDate) {
        return (0, $1Whvr.default)(nextMonth, includeDate) > 0;
    }) || false;
}
function $18554e9a4ab03c83$var$getEffectiveMinDate(_ref8) {
    var minDate = _ref8.minDate, includeDates = _ref8.includeDates;
    if (includeDates && minDate) {
        var minDates = includeDates.filter(function(includeDate) {
            return (0, $lm2ga.default)(includeDate, minDate) >= 0;
        });
        return (0, $8v9st.default)(minDates);
    } else if (includeDates) return (0, $8v9st.default)(includeDates);
    else return minDate;
}
function $18554e9a4ab03c83$var$getEffectiveMaxDate(_ref9) {
    var maxDate = _ref9.maxDate, includeDates = _ref9.includeDates;
    if (includeDates && maxDate) {
        var maxDates = includeDates.filter(function(includeDate) {
            return (0, $lm2ga.default)(includeDate, maxDate) <= 0;
        });
        return (0, $6atcA.default)(maxDates);
    } else if (includeDates) return (0, $6atcA.default)(includeDates);
    else return maxDate;
}
function $18554e9a4ab03c83$var$getHightLightDaysMap() {
    var highlightDates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var defaultClassName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "react-datepicker__day--highlighted";
    var dateClasses = new Map();
    for(var i = 0, len = highlightDates.length; i < len; i++){
        var obj = highlightDates[i];
        if ((0, $9BdaM.default)(obj)) {
            var key = $18554e9a4ab03c83$var$formatDate(obj, "MM.dd.yyyy");
            var classNamesArr = dateClasses.get(key) || [];
            if (!classNamesArr.includes(defaultClassName)) {
                classNamesArr.push(defaultClassName);
                dateClasses.set(key, classNamesArr);
            }
        } else if ((typeof obj === "undefined" ? "undefined" : $18554e9a4ab03c83$var$_typeof(obj)) === "object") {
            var keys = Object.keys(obj);
            var className = keys[0];
            var arrOfDates = obj[keys[0]];
            if (typeof className === "string" && arrOfDates.constructor === Array) for(var k = 0, _len = arrOfDates.length; k < _len; k++){
                var _key = $18554e9a4ab03c83$var$formatDate(arrOfDates[k], "MM.dd.yyyy");
                var _classNamesArr = dateClasses.get(_key) || [];
                if (!_classNamesArr.includes(className)) {
                    _classNamesArr.push(className);
                    dateClasses.set(_key, _classNamesArr);
                }
            }
        }
    }
    return dateClasses;
}
function $18554e9a4ab03c83$var$timesToInjectAfter(startOfDay$$1, currentTime, currentMultiplier, intervals, injectedTimes) {
    var l = injectedTimes.length;
    var times = [];
    for(var i = 0; i < l; i++){
        var injectedTime = (0, $bTSG2.default)((0, $kehhj.default)(startOfDay$$1, (0, $kjLiX.default)(injectedTimes[i])), (0, $aABJG.default)(injectedTimes[i]));
        var nextTime = (0, $bTSG2.default)(startOfDay$$1, (currentMultiplier + 1) * intervals);
        if ((0, $baBa1.default)(injectedTime, currentTime) && (0, $4YTY5.default)(injectedTime, nextTime)) times.push(injectedTimes[i]);
    }
    return times;
}
function $18554e9a4ab03c83$var$addZero(i) {
    if (i < 10) i = "0" + i;
    return i;
}
function $18554e9a4ab03c83$var$generateYears(year, noOfYear, minDate, maxDate) {
    var list = [];
    for(var i = 0; i < 2 * noOfYear + 1; i++){
        var newYear = year + noOfYear - i;
        var isInRange = true;
        if (minDate) isInRange = (0, $knAHj.default)(minDate) <= newYear;
        if (maxDate && isInRange) isInRange = (0, $knAHj.default)(maxDate) >= newYear;
        if (isInRange) list.push(newYear);
    }
    return list;
}
var $18554e9a4ab03c83$var$YearDropdownOptions = function(_React$Component) {
    $18554e9a4ab03c83$var$inherits(YearDropdownOptions, _React$Component);
    function YearDropdownOptions(props) {
        $18554e9a4ab03c83$var$classCallCheck(this, YearDropdownOptions);
        var _this = $18554e9a4ab03c83$var$possibleConstructorReturn(this, _React$Component.call(this, props));
        _this.renderOptions = function() {
            var selectedYear = _this.props.year;
            var options = _this.state.yearsList.map(function(year) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: selectedYear === year ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
                    key: year,
                    ref: year,
                    onClick: _this.onChange.bind(_this, year)
                }, selectedYear === year ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    className: "react-datepicker__year-option--selected"
                }, "\u2713") : "", year);
            });
            var minYear = _this.props.minDate ? (0, $knAHj.default)(_this.props.minDate) : null;
            var maxYear = _this.props.maxDate ? (0, $knAHj.default)(_this.props.maxDate) : null;
            if (!maxYear || !_this.state.yearsList.find(function(year) {
                return year === maxYear;
            })) options.unshift((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "react-datepicker__year-option",
                ref: "upcoming",
                key: "upcoming",
                onClick: _this.incrementYears
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
                className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"
            })));
            if (!minYear || !_this.state.yearsList.find(function(year) {
                return year === minYear;
            })) options.push((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "react-datepicker__year-option",
                ref: "previous",
                key: "previous",
                onClick: _this.decrementYears
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
                className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"
            })));
            return options;
        };
        _this.onChange = function(year) {
            _this.props.onChange(year);
        };
        _this.handleClickOutside = function() {
            _this.props.onCancel();
        };
        _this.shiftYears = function(amount) {
            var years = _this.state.yearsList.map(function(year) {
                return year + amount;
            });
            _this.setState({
                yearsList: years
            });
        };
        _this.incrementYears = function() {
            return _this.shiftYears(1);
        };
        _this.decrementYears = function() {
            return _this.shiftYears(-1);
        };
        var yearDropdownItemNumber = props.yearDropdownItemNumber, scrollableYearDropdown = props.scrollableYearDropdown;
        var noOfYear = yearDropdownItemNumber || (scrollableYearDropdown ? 10 : 5);
        _this.state = {
            yearsList: $18554e9a4ab03c83$var$generateYears(_this.props.year, noOfYear, _this.props.minDate, _this.props.maxDate)
        };
        return _this;
    }
    YearDropdownOptions.prototype.render = function render() {
        var dropdownClass = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
            "react-datepicker__year-dropdown": true,
            "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: dropdownClass
        }, this.renderOptions());
    };
    return YearDropdownOptions;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
var $18554e9a4ab03c83$var$WrappedYearDropdownOptions = (0, $hL3CS.default)($18554e9a4ab03c83$var$YearDropdownOptions);
var $18554e9a4ab03c83$var$YearDropdown = function(_React$Component) {
    $18554e9a4ab03c83$var$inherits(YearDropdown, _React$Component);
    function YearDropdown() {
        var _temp, _this, _ret;
        $18554e9a4ab03c83$var$classCallCheck(this, YearDropdown);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $18554e9a4ab03c83$var$possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.state = {
            dropdownVisible: false
        }, _this.renderSelectOptions = function() {
            var minYear = _this.props.minDate ? (0, $knAHj.default)(_this.props.minDate) : 1900;
            var maxYear = _this.props.maxDate ? (0, $knAHj.default)(_this.props.maxDate) : 2100;
            var options = [];
            for(var i = minYear; i <= maxYear; i++)options.push((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
                key: i,
                value: i
            }, i));
            return options;
        }, _this.onSelectChange = function(e) {
            _this.onChange(e.target.value);
        }, _this.renderSelectMode = function() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("select", {
                value: _this.props.year,
                className: "react-datepicker__year-select",
                onChange: _this.onSelectChange
            }, _this.renderSelectOptions());
        }, _this.renderReadView = function(visible) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: "read",
                style: {
                    visibility: visible ? "visible" : "hidden"
                },
                className: "react-datepicker__year-read-view",
                onClick: function onClick(event) {
                    return _this.toggleDropdown(event);
                }
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: "react-datepicker__year-read-view--down-arrow"
            }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: "react-datepicker__year-read-view--selected-year"
            }, _this.props.year));
        }, _this.renderDropdown = function() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($18554e9a4ab03c83$var$WrappedYearDropdownOptions, {
                key: "dropdown",
                ref: "options",
                year: _this.props.year,
                onChange: _this.onChange,
                onCancel: _this.toggleDropdown,
                minDate: _this.props.minDate,
                maxDate: _this.props.maxDate,
                scrollableYearDropdown: _this.props.scrollableYearDropdown,
                yearDropdownItemNumber: _this.props.yearDropdownItemNumber
            });
        }, _this.renderScrollMode = function() {
            var dropdownVisible = _this.state.dropdownVisible;
            var result = [
                _this.renderReadView(!dropdownVisible)
            ];
            if (dropdownVisible) result.unshift(_this.renderDropdown());
            return result;
        }, _this.onChange = function(year) {
            _this.toggleDropdown();
            if (year === _this.props.year) return;
            _this.props.onChange(year);
        }, _this.toggleDropdown = function(event) {
            _this.setState({
                dropdownVisible: !_this.state.dropdownVisible
            }, function() {
                if (_this.props.adjustDateOnChange) _this.handleYearChange(_this.props.date, event);
            });
        }, _this.handleYearChange = function(date, event) {
            _this.onSelect(date, event);
            _this.setOpen();
        }, _this.onSelect = function(date, event) {
            if (_this.props.onSelect) _this.props.onSelect(date, event);
        }, _this.setOpen = function() {
            if (_this.props.setOpen) _this.props.setOpen(true);
        }, _temp), $18554e9a4ab03c83$var$possibleConstructorReturn(_this, _ret);
    }
    YearDropdown.prototype.render = function render() {
        var renderedDropdown = void 0;
        switch(this.props.dropdownMode){
            case "scroll":
                renderedDropdown = this.renderScrollMode();
                break;
            case "select":
                renderedDropdown = this.renderSelectMode();
                break;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--" + this.props.dropdownMode
        }, renderedDropdown);
    };
    return YearDropdown;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
var $18554e9a4ab03c83$var$MonthDropdownOptions = function(_React$Component) {
    $18554e9a4ab03c83$var$inherits(MonthDropdownOptions, _React$Component);
    function MonthDropdownOptions() {
        var _temp, _this, _ret;
        $18554e9a4ab03c83$var$classCallCheck(this, MonthDropdownOptions);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $18554e9a4ab03c83$var$possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.renderOptions = function() {
            return _this.props.monthNames.map(function(month, i) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: _this.props.month === i ? "react-datepicker__month-option --selected_month" : "react-datepicker__month-option",
                    key: month,
                    ref: month,
                    onClick: _this.onChange.bind(_this, i)
                }, _this.props.month === i ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    className: "react-datepicker__month-option--selected"
                }, "\u2713") : "", month);
            });
        }, _this.onChange = function(month) {
            return _this.props.onChange(month);
        }, _this.handleClickOutside = function() {
            return _this.props.onCancel();
        }, _temp), $18554e9a4ab03c83$var$possibleConstructorReturn(_this, _ret);
    }
    MonthDropdownOptions.prototype.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "react-datepicker__month-dropdown"
        }, this.renderOptions());
    };
    return MonthDropdownOptions;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
var $18554e9a4ab03c83$var$WrappedMonthDropdownOptions = (0, $hL3CS.default)($18554e9a4ab03c83$var$MonthDropdownOptions);
var $18554e9a4ab03c83$var$MonthDropdown = function(_React$Component) {
    $18554e9a4ab03c83$var$inherits(MonthDropdown, _React$Component);
    function MonthDropdown() {
        var _temp, _this, _ret;
        $18554e9a4ab03c83$var$classCallCheck(this, MonthDropdown);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $18554e9a4ab03c83$var$possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.state = {
            dropdownVisible: false
        }, _this.renderSelectOptions = function(monthNames) {
            return monthNames.map(function(M, i) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
                    key: i,
                    value: i
                }, M);
            });
        }, _this.renderSelectMode = function(monthNames) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("select", {
                value: _this.props.month,
                className: "react-datepicker__month-select",
                onChange: function onChange(e) {
                    return _this.onChange(e.target.value);
                }
            }, _this.renderSelectOptions(monthNames));
        }, _this.renderReadView = function(visible, monthNames) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: "read",
                style: {
                    visibility: visible ? "visible" : "hidden"
                },
                className: "react-datepicker__month-read-view",
                onClick: _this.toggleDropdown
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: "react-datepicker__month-read-view--down-arrow"
            }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: "react-datepicker__month-read-view--selected-month"
            }, monthNames[_this.props.month]));
        }, _this.renderDropdown = function(monthNames) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($18554e9a4ab03c83$var$WrappedMonthDropdownOptions, {
                key: "dropdown",
                ref: "options",
                month: _this.props.month,
                monthNames: monthNames,
                onChange: _this.onChange,
                onCancel: _this.toggleDropdown
            });
        }, _this.renderScrollMode = function(monthNames) {
            var dropdownVisible = _this.state.dropdownVisible;
            var result = [
                _this.renderReadView(!dropdownVisible, monthNames)
            ];
            if (dropdownVisible) result.unshift(_this.renderDropdown(monthNames));
            return result;
        }, _this.onChange = function(month) {
            _this.toggleDropdown();
            if (month !== _this.props.month) _this.props.onChange(month);
        }, _this.toggleDropdown = function() {
            return _this.setState({
                dropdownVisible: !_this.state.dropdownVisible
            });
        }, _temp), $18554e9a4ab03c83$var$possibleConstructorReturn(_this, _ret);
    }
    MonthDropdown.prototype.render = function render() {
        var _this2 = this;
        var monthNames = [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map(this.props.useShortMonthInDropdown ? function(M) {
            return $18554e9a4ab03c83$var$getMonthShortInLocale(M, _this2.props.locale);
        } : function(M) {
            return $18554e9a4ab03c83$var$getMonthInLocale(M, _this2.props.locale);
        });
        var renderedDropdown = void 0;
        switch(this.props.dropdownMode){
            case "scroll":
                renderedDropdown = this.renderScrollMode(monthNames);
                break;
            case "select":
                renderedDropdown = this.renderSelectMode(monthNames);
                break;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--" + this.props.dropdownMode
        }, renderedDropdown);
    };
    return MonthDropdown;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
function $18554e9a4ab03c83$var$generateMonthYears(minDate, maxDate) {
    var list = [];
    var currDate = $18554e9a4ab03c83$var$getStartOfMonth(minDate);
    var lastDate = $18554e9a4ab03c83$var$getStartOfMonth(maxDate);
    while(!(0, $baBa1.default)(currDate, lastDate)){
        list.push($18554e9a4ab03c83$var$newDate(currDate));
        currDate = (0, $eqWMS.default)(currDate, 1);
    }
    return list;
}
var $18554e9a4ab03c83$var$MonthYearDropdownOptions = function(_React$Component) {
    $18554e9a4ab03c83$var$inherits(MonthYearDropdownOptions, _React$Component);
    function MonthYearDropdownOptions(props) {
        $18554e9a4ab03c83$var$classCallCheck(this, MonthYearDropdownOptions);
        var _this = $18554e9a4ab03c83$var$possibleConstructorReturn(this, _React$Component.call(this, props));
        _this.renderOptions = function() {
            return _this.state.monthYearsList.map(function(monthYear) {
                var monthYearPoint = (0, $2SwgK.default)(monthYear);
                var isSameMonthYear = $18554e9a4ab03c83$var$isSameYear(_this.props.date, monthYear) && $18554e9a4ab03c83$var$isSameMonth(_this.props.date, monthYear);
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: isSameMonthYear ? "react-datepicker__month-year-option --selected_month-year" : "react-datepicker__month-year-option",
                    key: monthYearPoint,
                    ref: monthYearPoint,
                    onClick: _this.onChange.bind(_this, monthYearPoint)
                }, isSameMonthYear ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    className: "react-datepicker__month-year-option--selected"
                }, "\u2713") : "", $18554e9a4ab03c83$var$formatDate(monthYear, _this.props.dateFormat));
            });
        };
        _this.onChange = function(monthYear) {
            return _this.props.onChange(monthYear);
        };
        _this.handleClickOutside = function() {
            _this.props.onCancel();
        };
        _this.state = {
            monthYearsList: $18554e9a4ab03c83$var$generateMonthYears(_this.props.minDate, _this.props.maxDate)
        };
        return _this;
    }
    MonthYearDropdownOptions.prototype.render = function render() {
        var dropdownClass = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))({
            "react-datepicker__month-year-dropdown": true,
            "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: dropdownClass
        }, this.renderOptions());
    };
    return MonthYearDropdownOptions;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
var $18554e9a4ab03c83$var$WrappedMonthYearDropdownOptions = (0, $hL3CS.default)($18554e9a4ab03c83$var$MonthYearDropdownOptions);
var $18554e9a4ab03c83$var$MonthYearDropdown = function(_React$Component) {
    $18554e9a4ab03c83$var$inherits(MonthYearDropdown, _React$Component);
    function MonthYearDropdown() {
        var _temp, _this, _ret;
        $18554e9a4ab03c83$var$classCallCheck(this, MonthYearDropdown);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $18554e9a4ab03c83$var$possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.state = {
            dropdownVisible: false
        }, _this.renderSelectOptions = function() {
            var currDate = $18554e9a4ab03c83$var$getStartOfMonth(_this.props.minDate);
            var lastDate = $18554e9a4ab03c83$var$getStartOfMonth(_this.props.maxDate);
            var options = [];
            while(!(0, $baBa1.default)(currDate, lastDate)){
                var timepoint = (0, $2SwgK.default)(currDate);
                options.push((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("option", {
                    key: timepoint,
                    value: timepoint
                }, $18554e9a4ab03c83$var$formatDate(currDate, _this.props.dateFormat, _this.props.locale)));
                currDate = (0, $eqWMS.default)(currDate, 1);
            }
            return options;
        }, _this.onSelectChange = function(e) {
            _this.onChange(e.target.value);
        }, _this.renderSelectMode = function() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("select", {
                value: (0, $2SwgK.default)($18554e9a4ab03c83$var$getStartOfMonth(_this.props.date)),
                className: "react-datepicker__month-year-select",
                onChange: _this.onSelectChange
            }, _this.renderSelectOptions());
        }, _this.renderReadView = function(visible) {
            var yearMonth = $18554e9a4ab03c83$var$formatDate(_this.props.date, _this.props.dateFormat, _this.props.locale);
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: "read",
                style: {
                    visibility: visible ? "visible" : "hidden"
                },
                className: "react-datepicker__month-year-read-view",
                onClick: function onClick(event) {
                    return _this.toggleDropdown(event);
                }
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: "react-datepicker__month-year-read-view--down-arrow"
            }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: "react-datepicker__month-year-read-view--selected-month-year"
            }, yearMonth));
        }, _this.renderDropdown = function() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($18554e9a4ab03c83$var$WrappedMonthYearDropdownOptions, {
                key: "dropdown",
                ref: "options",
                date: _this.props.date,
                dateFormat: _this.props.dateFormat,
                onChange: _this.onChange,
                onCancel: _this.toggleDropdown,
                minDate: _this.props.minDate,
                maxDate: _this.props.maxDate,
                scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown
            });
        }, _this.renderScrollMode = function() {
            var dropdownVisible = _this.state.dropdownVisible;
            var result = [
                _this.renderReadView(!dropdownVisible)
            ];
            if (dropdownVisible) result.unshift(_this.renderDropdown());
            return result;
        }, _this.onChange = function(monthYearPoint) {
            _this.toggleDropdown();
            var changedDate = $18554e9a4ab03c83$var$newDate(parseInt(monthYearPoint));
            if ($18554e9a4ab03c83$var$isSameYear(_this.props.date, changedDate) && $18554e9a4ab03c83$var$isSameMonth(_this.props.date, changedDate)) return;
            _this.props.onChange(changedDate);
        }, _this.toggleDropdown = function() {
            return _this.setState({
                dropdownVisible: !_this.state.dropdownVisible
            });
        }, _temp), $18554e9a4ab03c83$var$possibleConstructorReturn(_this, _ret);
    }
    MonthYearDropdown.prototype.render = function render() {
        var renderedDropdown = void 0;
        switch(this.props.dropdownMode){
            case "scroll":
                renderedDropdown = this.renderScrollMode();
                break;
            case "select":
                renderedDropdown = this.renderSelectMode();
                break;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--" + this.props.dropdownMode
        }, renderedDropdown);
    };
    return MonthYearDropdown;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
var $18554e9a4ab03c83$var$Day = function(_React$Component) {
    $18554e9a4ab03c83$var$inherits(Day, _React$Component);
    function Day() {
        var _temp, _this, _ret;
        $18554e9a4ab03c83$var$classCallCheck(this, Day);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $18554e9a4ab03c83$var$possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.handleClick = function(event) {
            if (!_this.isDisabled() && _this.props.onClick) _this.props.onClick(event);
        }, _this.handleMouseEnter = function(event) {
            if (!_this.isDisabled() && _this.props.onMouseEnter) _this.props.onMouseEnter(event);
        }, _this.isSameDay = function(other) {
            return $18554e9a4ab03c83$var$isSameDay(_this.props.day, other);
        }, _this.isKeyboardSelected = function() {
            return !_this.props.disabledKeyboardNavigation && !_this.props.inline && !_this.isSameDay(_this.props.selected) && _this.isSameDay(_this.props.preSelection);
        }, _this.isDisabled = function() {
            return $18554e9a4ab03c83$var$isDayDisabled(_this.props.day, _this.props);
        }, _this.getHighLightedClass = function(defaultClassName) {
            var _this$props = _this.props, day = _this$props.day, highlightDates = _this$props.highlightDates;
            if (!highlightDates) return false;
            // Looking for className in the Map of {'day string, 'className'}
            var dayStr = $18554e9a4ab03c83$var$formatDate(day, "MM.dd.yyyy");
            return highlightDates.get(dayStr);
        }, _this.isInRange = function() {
            var _this$props2 = _this.props, day = _this$props2.day, startDate = _this$props2.startDate, endDate = _this$props2.endDate;
            if (!startDate || !endDate) return false;
            return $18554e9a4ab03c83$var$isDayInRange(day, startDate, endDate);
        }, _this.isInSelectingRange = function() {
            var _this$props3 = _this.props, day = _this$props3.day, selectsStart = _this$props3.selectsStart, selectsEnd = _this$props3.selectsEnd, selectingDate = _this$props3.selectingDate, startDate = _this$props3.startDate, endDate = _this$props3.endDate;
            if (!(selectsStart || selectsEnd) || !selectingDate || _this.isDisabled()) return false;
            if (selectsStart && endDate && ((0, $4YTY5.default)(selectingDate, endDate) || $18554e9a4ab03c83$var$isEqual(selectingDate, endDate))) return $18554e9a4ab03c83$var$isDayInRange(day, selectingDate, endDate);
            if (selectsEnd && startDate && ((0, $baBa1.default)(selectingDate, startDate) || $18554e9a4ab03c83$var$isEqual(selectingDate, startDate))) return $18554e9a4ab03c83$var$isDayInRange(day, startDate, selectingDate);
            return false;
        }, _this.isSelectingRangeStart = function() {
            if (!_this.isInSelectingRange()) return false;
            var _this$props4 = _this.props, day = _this$props4.day, selectingDate = _this$props4.selectingDate, startDate = _this$props4.startDate, selectsStart = _this$props4.selectsStart;
            if (selectsStart) return $18554e9a4ab03c83$var$isSameDay(day, selectingDate);
            else return $18554e9a4ab03c83$var$isSameDay(day, startDate);
        }, _this.isSelectingRangeEnd = function() {
            if (!_this.isInSelectingRange()) return false;
            var _this$props5 = _this.props, day = _this$props5.day, selectingDate = _this$props5.selectingDate, endDate = _this$props5.endDate, selectsEnd = _this$props5.selectsEnd;
            if (selectsEnd) return $18554e9a4ab03c83$var$isSameDay(day, selectingDate);
            else return $18554e9a4ab03c83$var$isSameDay(day, endDate);
        }, _this.isRangeStart = function() {
            var _this$props6 = _this.props, day = _this$props6.day, startDate = _this$props6.startDate, endDate = _this$props6.endDate;
            if (!startDate || !endDate) return false;
            return $18554e9a4ab03c83$var$isSameDay(startDate, day);
        }, _this.isRangeEnd = function() {
            var _this$props7 = _this.props, day = _this$props7.day, startDate = _this$props7.startDate, endDate = _this$props7.endDate;
            if (!startDate || !endDate) return false;
            return $18554e9a4ab03c83$var$isSameDay(endDate, day);
        }, _this.isWeekend = function() {
            var weekday = (0, $34ylv.default)(_this.props.day);
            return weekday === 0 || weekday === 6;
        }, _this.isOutsideMonth = function() {
            return _this.props.month !== undefined && _this.props.month !== (0, $4UeRq.default)(_this.props.day);
        }, _this.getClassNames = function(date) {
            var dayClassName = _this.props.dayClassName ? _this.props.dayClassName(date) : undefined;
            return (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("react-datepicker__day", dayClassName, "react-datepicker__day--" + $18554e9a4ab03c83$var$getDayOfWeekCode(_this.props.day), {
                "react-datepicker__day--disabled": _this.isDisabled(),
                "react-datepicker__day--selected": _this.isSameDay(_this.props.selected),
                "react-datepicker__day--keyboard-selected": _this.isKeyboardSelected(),
                "react-datepicker__day--range-start": _this.isRangeStart(),
                "react-datepicker__day--range-end": _this.isRangeEnd(),
                "react-datepicker__day--in-range": _this.isInRange(),
                "react-datepicker__day--in-selecting-range": _this.isInSelectingRange(),
                "react-datepicker__day--selecting-range-start": _this.isSelectingRangeStart(),
                "react-datepicker__day--selecting-range-end": _this.isSelectingRangeEnd(),
                "react-datepicker__day--today": _this.isSameDay($18554e9a4ab03c83$var$newDate()),
                "react-datepicker__day--weekend": _this.isWeekend(),
                "react-datepicker__day--outside-month": _this.isOutsideMonth()
            }, _this.getHighLightedClass("react-datepicker__day--highlighted"));
        }, _temp), $18554e9a4ab03c83$var$possibleConstructorReturn(_this, _ret);
    }
    Day.prototype.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: this.getClassNames(this.props.day),
            onClick: this.handleClick,
            onMouseEnter: this.handleMouseEnter,
            "aria-label": "day-" + (0, $eZOMj.default)(this.props.day),
            role: "option"
        }, this.props.renderDayContents ? this.props.renderDayContents((0, $eZOMj.default)(this.props.day), this.props.day) : (0, $eZOMj.default)(this.props.day));
    };
    return Day;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
var $18554e9a4ab03c83$var$WeekNumber = function(_React$Component) {
    $18554e9a4ab03c83$var$inherits(WeekNumber, _React$Component);
    function WeekNumber() {
        var _temp, _this, _ret;
        $18554e9a4ab03c83$var$classCallCheck(this, WeekNumber);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $18554e9a4ab03c83$var$possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.handleClick = function(event) {
            if (_this.props.onClick) _this.props.onClick(event);
        }, _temp), $18554e9a4ab03c83$var$possibleConstructorReturn(_this, _ret);
    }
    WeekNumber.prototype.render = function render() {
        var weekNumberClasses = {
            "react-datepicker__week-number": true,
            "react-datepicker__week-number--clickable": !!this.props.onClick
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(weekNumberClasses),
            "aria-label": "week-" + this.props.weekNumber,
            onClick: this.handleClick
        }, this.props.weekNumber);
    };
    return WeekNumber;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
var $18554e9a4ab03c83$var$Week = function(_React$Component) {
    $18554e9a4ab03c83$var$inherits(Week, _React$Component);
    function Week() {
        var _temp, _this, _ret;
        $18554e9a4ab03c83$var$classCallCheck(this, Week);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $18554e9a4ab03c83$var$possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.handleDayClick = function(day, event) {
            if (_this.props.onDayClick) _this.props.onDayClick(day, event);
        }, _this.handleDayMouseEnter = function(day) {
            if (_this.props.onDayMouseEnter) _this.props.onDayMouseEnter(day);
        }, _this.handleWeekClick = function(day, weekNumber, event) {
            if (typeof _this.props.onWeekSelect === "function") _this.props.onWeekSelect(day, weekNumber, event);
            if (_this.props.shouldCloseOnSelect) _this.props.setOpen(false);
        }, _this.formatWeekNumber = function(date) {
            if (_this.props.formatWeekNumber) return _this.props.formatWeekNumber(date);
            return $18554e9a4ab03c83$var$getWeek(date);
        }, _this.renderDays = function() {
            var startOfWeek$$1 = $18554e9a4ab03c83$var$getStartOfWeek(_this.props.day, _this.props.locale);
            var days = [];
            var weekNumber = _this.formatWeekNumber(startOfWeek$$1);
            if (_this.props.showWeekNumber) {
                var onClickAction = _this.props.onWeekSelect ? _this.handleWeekClick.bind(_this, startOfWeek$$1, weekNumber) : undefined;
                days.push((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($18554e9a4ab03c83$var$WeekNumber, {
                    key: "W",
                    weekNumber: weekNumber,
                    onClick: onClickAction
                }));
            }
            return days.concat([
                0,
                1,
                2,
                3,
                4,
                5,
                6
            ].map(function(offset) {
                var day = (0, $6OX6Q.default)(startOfWeek$$1, offset);
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($18554e9a4ab03c83$var$Day, {
                    key: offset,
                    day: day,
                    month: _this.props.month,
                    onClick: _this.handleDayClick.bind(_this, day),
                    onMouseEnter: _this.handleDayMouseEnter.bind(_this, day),
                    minDate: _this.props.minDate,
                    maxDate: _this.props.maxDate,
                    excludeDates: _this.props.excludeDates,
                    includeDates: _this.props.includeDates,
                    inline: _this.props.inline,
                    highlightDates: _this.props.highlightDates,
                    selectingDate: _this.props.selectingDate,
                    filterDate: _this.props.filterDate,
                    preSelection: _this.props.preSelection,
                    selected: _this.props.selected,
                    selectsStart: _this.props.selectsStart,
                    selectsEnd: _this.props.selectsEnd,
                    startDate: _this.props.startDate,
                    endDate: _this.props.endDate,
                    dayClassName: _this.props.dayClassName,
                    renderDayContents: _this.props.renderDayContents,
                    disabledKeyboardNavigation: _this.props.disabledKeyboardNavigation
                });
            }));
        }, _temp), $18554e9a4ab03c83$var$possibleConstructorReturn(_this, _ret);
    }
    Week.prototype.render = function render() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "react-datepicker__week"
        }, this.renderDays());
    };
    $18554e9a4ab03c83$var$createClass(Week, null, [
        {
            key: "defaultProps",
            get: function get$$1() {
                return {
                    shouldCloseOnSelect: true
                };
            }
        }
    ]);
    return Week;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
var $18554e9a4ab03c83$var$FIXED_HEIGHT_STANDARD_WEEK_COUNT = 6;
var $18554e9a4ab03c83$var$Month = function(_React$Component) {
    $18554e9a4ab03c83$var$inherits(Month, _React$Component);
    function Month() {
        var _temp, _this, _ret;
        $18554e9a4ab03c83$var$classCallCheck(this, Month);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $18554e9a4ab03c83$var$possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.handleDayClick = function(day, event) {
            if (_this.props.onDayClick) _this.props.onDayClick(day, event, _this.props.orderInDisplay);
        }, _this.handleDayMouseEnter = function(day) {
            if (_this.props.onDayMouseEnter) _this.props.onDayMouseEnter(day);
        }, _this.handleMouseLeave = function() {
            if (_this.props.onMouseLeave) _this.props.onMouseLeave();
        }, _this.isWeekInMonth = function(startOfWeek$$1) {
            var day = _this.props.day;
            var endOfWeek$$1 = (0, $6OX6Q.default)(startOfWeek$$1, 6);
            return $18554e9a4ab03c83$var$isSameMonth(startOfWeek$$1, day) || $18554e9a4ab03c83$var$isSameMonth(endOfWeek$$1, day);
        }, _this.renderWeeks = function() {
            var weeks = [];
            var isFixedHeight = _this.props.fixedHeight;
            var currentWeekStart = $18554e9a4ab03c83$var$getStartOfWeek($18554e9a4ab03c83$var$getStartOfMonth(_this.props.day), _this.props.locale);
            var i = 0;
            var breakAfterNextPush = false;
            while(true){
                weeks.push((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($18554e9a4ab03c83$var$Week, {
                    key: i,
                    day: currentWeekStart,
                    month: (0, $4UeRq.default)(_this.props.day),
                    onDayClick: _this.handleDayClick,
                    onDayMouseEnter: _this.handleDayMouseEnter,
                    onWeekSelect: _this.props.onWeekSelect,
                    formatWeekNumber: _this.props.formatWeekNumber,
                    locale: _this.props.locale,
                    minDate: _this.props.minDate,
                    maxDate: _this.props.maxDate,
                    excludeDates: _this.props.excludeDates,
                    includeDates: _this.props.includeDates,
                    inline: _this.props.inline,
                    highlightDates: _this.props.highlightDates,
                    selectingDate: _this.props.selectingDate,
                    filterDate: _this.props.filterDate,
                    preSelection: _this.props.preSelection,
                    selected: _this.props.selected,
                    selectsStart: _this.props.selectsStart,
                    selectsEnd: _this.props.selectsEnd,
                    showWeekNumber: _this.props.showWeekNumbers,
                    startDate: _this.props.startDate,
                    endDate: _this.props.endDate,
                    dayClassName: _this.props.dayClassName,
                    setOpen: _this.props.setOpen,
                    shouldCloseOnSelect: _this.props.shouldCloseOnSelect,
                    disabledKeyboardNavigation: _this.props.disabledKeyboardNavigation,
                    renderDayContents: _this.props.renderDayContents
                }));
                if (breakAfterNextPush) break;
                i++;
                currentWeekStart = (0, $2MTnF.default)(currentWeekStart, 1);
                // If one of these conditions is true, we will either break on this week
                // or break on the next week
                var isFixedAndFinalWeek = isFixedHeight && i >= $18554e9a4ab03c83$var$FIXED_HEIGHT_STANDARD_WEEK_COUNT;
                var isNonFixedAndOutOfMonth = !isFixedHeight && !_this.isWeekInMonth(currentWeekStart);
                if (isFixedAndFinalWeek || isNonFixedAndOutOfMonth) {
                    if (_this.props.peekNextMonth) breakAfterNextPush = true;
                    else break;
                }
            }
            return weeks;
        }, _this.onMonthClick = function(e, m) {
            _this.handleDayClick($18554e9a4ab03c83$var$getStartOfMonth((0, $cZ2kT.default)(_this.props.day, m), e));
        }, _this.getMonthClassNames = function(m) {
            var _this$props = _this.props, day = _this$props.day, startDate = _this$props.startDate, endDate = _this$props.endDate, selected = _this$props.selected, minDate = _this$props.minDate, maxDate = _this$props.maxDate;
            return (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("react-datepicker__month-text", "react-datepicker__month-" + m, {
                "react-datepicker__month--disabled": minDate && maxDate && !$18554e9a4ab03c83$var$isMonthinRange(minDate, maxDate, m, day),
                "react-datepicker__month--selected": (0, $4UeRq.default)(day) === m && (0, $knAHj.default)(day) === (0, $knAHj.default)(selected),
                "react-datepicker__month--in-range": $18554e9a4ab03c83$var$isMonthinRange(startDate, endDate, m, day)
            });
        }, _this.renderMonths = function() {
            var months = [
                [
                    0,
                    1,
                    2
                ],
                [
                    3,
                    4,
                    5
                ],
                [
                    6,
                    7,
                    8
                ],
                [
                    9,
                    10,
                    11
                ]
            ];
            return months.map(function(month, i) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: "react-datepicker__month-wrapper",
                    key: i
                }, month.map(function(m, j) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                        key: j,
                        onClick: function onClick(ev) {
                            _this.onMonthClick(ev.target, m);
                        },
                        className: _this.getMonthClassNames(m)
                    }, $18554e9a4ab03c83$var$getMonthShortInLocale(m, _this.props.locale));
                }));
            });
        }, _this.getClassNames = function() {
            var _this$props2 = _this.props, selectingDate = _this$props2.selectingDate, selectsStart = _this$props2.selectsStart, selectsEnd = _this$props2.selectsEnd, showMonthYearPicker = _this$props2.showMonthYearPicker;
            return (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("react-datepicker__month", {
                "react-datepicker__month--selecting-range": selectingDate && (selectsStart || selectsEnd)
            }, {
                "react-datepicker__monthPicker": showMonthYearPicker
            });
        }, _temp), $18554e9a4ab03c83$var$possibleConstructorReturn(_this, _ret);
    }
    Month.prototype.render = function render() {
        var showMonthYearPicker = this.props.showMonthYearPicker;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: this.getClassNames(),
            onMouseLeave: this.handleMouseLeave,
            role: "listbox",
            "aria-label": "month-" + $18554e9a4ab03c83$var$formatDate(this.props.day, "yyyy-MM")
        }, showMonthYearPicker ? this.renderMonths() : this.renderWeeks());
    };
    return Month;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
var $18554e9a4ab03c83$var$Time = function(_React$Component) {
    $18554e9a4ab03c83$var$inherits(Time, _React$Component);
    function Time() {
        var _temp, _this, _ret;
        $18554e9a4ab03c83$var$classCallCheck(this, Time);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $18554e9a4ab03c83$var$possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.state = {
            height: null
        }, _this.handleClick = function(time) {
            if ((_this.props.minTime || _this.props.maxTime) && $18554e9a4ab03c83$var$isTimeInDisabledRange(time, _this.props) || _this.props.excludeTimes && $18554e9a4ab03c83$var$isTimeDisabled(time, _this.props.excludeTimes) || _this.props.includeTimes && !$18554e9a4ab03c83$var$isTimeDisabled(time, _this.props.includeTimes)) return;
            _this.props.onChange(time);
        }, _this.liClasses = function(time, currH, currM) {
            var classes = [
                "react-datepicker__time-list-item"
            ];
            if (currH === (0, $kjLiX.default)(time) && currM === (0, $aABJG.default)(time)) classes.push("react-datepicker__time-list-item--selected");
            if ((_this.props.minTime || _this.props.maxTime) && $18554e9a4ab03c83$var$isTimeInDisabledRange(time, _this.props) || _this.props.excludeTimes && $18554e9a4ab03c83$var$isTimeDisabled(time, _this.props.excludeTimes) || _this.props.includeTimes && !$18554e9a4ab03c83$var$isTimeDisabled(time, _this.props.includeTimes)) classes.push("react-datepicker__time-list-item--disabled");
            if (_this.props.injectTimes && ((0, $kjLiX.default)(time) * 60 + (0, $aABJG.default)(time)) % _this.props.intervals !== 0) classes.push("react-datepicker__time-list-item--injected");
            return classes.join(" ");
        }, _this.renderTimes = function() {
            var times = [];
            var format$$1 = _this.props.format ? _this.props.format : "p";
            var intervals = _this.props.intervals;
            var activeTime = _this.props.selected ? _this.props.selected : $18554e9a4ab03c83$var$newDate();
            var currH = (0, $kjLiX.default)(activeTime);
            var currM = (0, $aABJG.default)(activeTime);
            var base = $18554e9a4ab03c83$var$getStartOfDay($18554e9a4ab03c83$var$newDate());
            var multiplier = 1440 / intervals;
            var sortedInjectTimes = _this.props.injectTimes && _this.props.injectTimes.sort(function(a, b) {
                return a - b;
            });
            for(var i = 0; i < multiplier; i++){
                var currentTime = (0, $bTSG2.default)(base, i * intervals);
                times.push(currentTime);
                if (sortedInjectTimes) {
                    var timesToInject = $18554e9a4ab03c83$var$timesToInjectAfter(base, currentTime, i, intervals, sortedInjectTimes);
                    times = times.concat(timesToInject);
                }
            }
            return times.map(function(time, i) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                    key: i,
                    onClick: _this.handleClick.bind(_this, time),
                    className: _this.liClasses(time, currH, currM),
                    ref: function ref(li) {
                        if (currH === (0, $kjLiX.default)(time) && currM === (0, $aABJG.default)(time) || currH === (0, $kjLiX.default)(time) && !_this.centerLi) _this.centerLi = li;
                    }
                }, $18554e9a4ab03c83$var$formatDate(time, format$$1));
            });
        }, _temp), $18554e9a4ab03c83$var$possibleConstructorReturn(_this, _ret);
    }
    Time.prototype.componentDidMount = function componentDidMount() {
        // code to ensure selected time will always be in focus within time window when it first appears
        this.list.scrollTop = Time.calcCenterPosition(this.props.monthRef ? this.props.monthRef.clientHeight - this.header.clientHeight : this.list.clientHeight, this.centerLi);
        if (this.props.monthRef && this.header) this.setState({
            height: this.props.monthRef.clientHeight - this.header.clientHeight
        });
    };
    Time.prototype.render = function render() {
        var _this2 = this;
        var height = this.state.height;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "react-datepicker__time-container " + (this.props.todayButton ? "react-datepicker__time-container--with-today-button" : "")
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "react-datepicker__header react-datepicker__header--time",
            ref: function ref(header) {
                _this2.header = header;
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "react-datepicker-time__header"
        }, this.props.timeCaption)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "react-datepicker__time"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "react-datepicker__time-box"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
            className: "react-datepicker__time-list",
            ref: function ref(list) {
                _this2.list = list;
            },
            style: height ? {
                height: height
            } : {}
        }, this.renderTimes.bind(this)()))));
    };
    $18554e9a4ab03c83$var$createClass(Time, null, [
        {
            key: "defaultProps",
            get: function get$$1() {
                return {
                    intervals: 30,
                    onTimeChange: function onTimeChange() {},
                    todayButton: null,
                    timeCaption: "Time"
                };
            }
        }
    ]);
    return Time;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$18554e9a4ab03c83$var$Time.calcCenterPosition = function(listHeight, centerLiRef) {
    return centerLiRef.offsetTop - (listHeight / 2 - centerLiRef.clientHeight / 2);
};
var $18554e9a4ab03c83$var$inputTime = function(_React$Component) {
    $18554e9a4ab03c83$var$inherits(inputTime, _React$Component);
    function inputTime(props) {
        $18554e9a4ab03c83$var$classCallCheck(this, inputTime);
        var _this = $18554e9a4ab03c83$var$possibleConstructorReturn(this, _React$Component.call(this, props));
        _this.onTimeChange = function(time) {
            _this.setState({
                time: time
            });
            var date = new Date();
            date.setHours(time.split(":")[0]);
            date.setMinutes(time.split(":")[1]);
            _this.props.onChange(date);
        };
        _this.state = {
            time: _this.props.timeString
        };
        return _this;
    }
    inputTime.prototype.render = function render() {
        var _this2 = this;
        var time = this.state.time;
        var timeString = this.props.timeString;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "react-datepicker__input-time-container"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "react-datepicker-time__caption"
        }, this.props.timeInputLabel), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "react-datepicker-time__input-container"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "react-datepicker-time__input"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
            type: "time",
            className: "react-datepicker-time__input",
            placeholder: "Time",
            name: "time-input",
            required: true,
            value: time,
            onChange: function onChange(ev) {
                _this2.onTimeChange(ev.target.value || timeString);
            }
        }))));
    };
    return inputTime;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
function $18554e9a4ab03c83$export$946daa762919616e(_ref) {
    var className = _ref.className, children = _ref.children, _ref$arrowProps = _ref.arrowProps, arrowProps = _ref$arrowProps === undefined ? {} : _ref$arrowProps;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $18554e9a4ab03c83$var$_extends({
        className: "react-datepicker__triangle"
    }, arrowProps)), children);
}
var $18554e9a4ab03c83$var$DROPDOWN_FOCUS_CLASSNAMES = [
    "react-datepicker__year-select",
    "react-datepicker__month-select",
    "react-datepicker__month-year-select"
];
var $18554e9a4ab03c83$var$isDropdownSelect = function isDropdownSelect() {
    var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var classNames = (element.className || "").split(/\s+/);
    return $18554e9a4ab03c83$var$DROPDOWN_FOCUS_CLASSNAMES.some(function(testClassname) {
        return classNames.indexOf(testClassname) >= 0;
    });
};
var $18554e9a4ab03c83$var$Calendar = function(_React$Component) {
    $18554e9a4ab03c83$var$inherits(Calendar, _React$Component);
    $18554e9a4ab03c83$var$createClass(Calendar, null, [
        {
            key: "defaultProps",
            get: function get$$1() {
                return {
                    onDropdownFocus: function onDropdownFocus() {},
                    monthsShown: 1,
                    monthSelectedIn: 0,
                    forceShowMonthNavigation: false,
                    timeCaption: "Time",
                    previousYearButtonLabel: "Previous Year",
                    nextYearButtonLabel: "Next Year",
                    previousMonthButtonLabel: "Previous Month",
                    nextMonthButtonLabel: "Next Month"
                };
            }
        }
    ]);
    function Calendar(props) {
        $18554e9a4ab03c83$var$classCallCheck(this, Calendar);
        var _this = $18554e9a4ab03c83$var$possibleConstructorReturn(this, _React$Component.call(this, props));
        _this.handleClickOutside = function(event) {
            _this.props.onClickOutside(event);
        };
        _this.handleDropdownFocus = function(event) {
            if ($18554e9a4ab03c83$var$isDropdownSelect(event.target)) _this.props.onDropdownFocus();
        };
        _this.getDateInView = function() {
            var _this$props = _this.props, preSelection = _this$props.preSelection, selected = _this$props.selected, openToDate = _this$props.openToDate;
            var minDate = $18554e9a4ab03c83$var$getEffectiveMinDate(_this.props);
            var maxDate = $18554e9a4ab03c83$var$getEffectiveMaxDate(_this.props);
            var current = $18554e9a4ab03c83$var$newDate();
            var initialDate = openToDate || selected || preSelection;
            if (initialDate) return initialDate;
            else {
                if (minDate && (0, $4YTY5.default)(current, minDate)) return minDate;
                else if (maxDate && (0, $baBa1.default)(current, maxDate)) return maxDate;
            }
            return current;
        };
        _this.increaseMonth = function() {
            _this.setState({
                date: (0, $eqWMS.default)(_this.state.date, 1)
            }, function() {
                return _this.handleMonthChange(_this.state.date);
            });
        };
        _this.decreaseMonth = function() {
            _this.setState({
                date: (0, $lXe7Q.default)(_this.state.date, 1)
            }, function() {
                return _this.handleMonthChange(_this.state.date);
            });
        };
        _this.handleDayClick = function(day, event, monthSelectedIn) {
            return _this.props.onSelect(day, event, monthSelectedIn);
        };
        _this.handleDayMouseEnter = function(day) {
            _this.setState({
                selectingDate: day
            });
            _this.props.onDayMouseEnter && _this.props.onDayMouseEnter(day);
        };
        _this.handleMonthMouseLeave = function() {
            _this.setState({
                selectingDate: null
            });
            _this.props.onMonthMouseLeave && _this.props.onMonthMouseLeave();
        };
        _this.handleYearChange = function(date) {
            if (_this.props.onYearChange) _this.props.onYearChange(date);
        };
        _this.handleMonthChange = function(date) {
            if (_this.props.onMonthChange) _this.props.onMonthChange(date);
            if (_this.props.adjustDateOnChange) {
                if (_this.props.onSelect) _this.props.onSelect(date);
                if (_this.props.setOpen) _this.props.setOpen(true);
            }
        };
        _this.handleMonthYearChange = function(date) {
            _this.handleYearChange(date);
            _this.handleMonthChange(date);
        };
        _this.changeYear = function(year) {
            _this.setState({
                date: (0, $3lKFD.default)(_this.state.date, year)
            }, function() {
                return _this.handleYearChange(_this.state.date);
            });
        };
        _this.changeMonth = function(month) {
            _this.setState({
                date: (0, $cZ2kT.default)(_this.state.date, month)
            }, function() {
                return _this.handleMonthChange(_this.state.date);
            });
        };
        _this.changeMonthYear = function(monthYear) {
            _this.setState({
                date: (0, $3lKFD.default)((0, $cZ2kT.default)(_this.state.date, (0, $4UeRq.default)(monthYear)), (0, $knAHj.default)(monthYear))
            }, function() {
                return _this.handleMonthYearChange(_this.state.date);
            });
        };
        _this.header = function() {
            var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.date;
            var startOfWeek$$1 = $18554e9a4ab03c83$var$getStartOfWeek(date, _this.props.locale);
            var dayNames = [];
            if (_this.props.showWeekNumbers) dayNames.push((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: "W",
                className: "react-datepicker__day-name"
            }, _this.props.weekLabel || "#"));
            return dayNames.concat([
                0,
                1,
                2,
                3,
                4,
                5,
                6
            ].map(function(offset) {
                var day = (0, $6OX6Q.default)(startOfWeek$$1, offset);
                var weekDayName = _this.formatWeekday(day, _this.props.locale);
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    key: offset,
                    className: "react-datepicker__day-name"
                }, weekDayName);
            }));
        };
        _this.formatWeekday = function(day, locale) {
            if (_this.props.formatWeekDay) return $18554e9a4ab03c83$var$getFormattedWeekdayInLocale(day, _this.props.formatWeekDay, locale);
            return _this.props.useWeekdaysShort ? $18554e9a4ab03c83$var$getWeekdayShortInLocale(day, locale) : $18554e9a4ab03c83$var$getWeekdayMinInLocale(day, locale);
        };
        _this.decreaseYear = function() {
            _this.setState({
                date: (0, $4UG1B.default)(_this.state.date, 1)
            }, function() {
                return _this.handleYearChange(_this.state.date);
            });
        };
        _this.renderPreviousButton = function() {
            if (_this.props.renderCustomHeader) return;
            var allPrevDaysDisabled = $18554e9a4ab03c83$var$monthDisabledBefore(_this.state.date, _this.props);
            if (!_this.props.forceShowMonthNavigation && !_this.props.showDisabledMonthNavigation && allPrevDaysDisabled || _this.props.showTimeSelectOnly) return;
            var classes = [
                "react-datepicker__navigation",
                "react-datepicker__navigation--previous"
            ];
            var clickHandler = _this.decreaseMonth;
            if (_this.props.showMonthYearPicker) clickHandler = _this.decreaseYear;
            if (allPrevDaysDisabled && _this.props.showDisabledMonthNavigation) {
                classes.push("react-datepicker__navigation--previous--disabled");
                clickHandler = null;
            }
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                type: "button",
                className: classes.join(" "),
                onClick: clickHandler
            }, _this.props.showMonthYearPicker ? _this.props.previousYearButtonLabel : _this.props.previousMonthButtonLabel);
        };
        _this.increaseYear = function() {
            _this.setState({
                date: (0, $kbDwl.default)(_this.state.date, 1)
            }, function() {
                return _this.handleYearChange(_this.state.date);
            });
        };
        _this.renderNextButton = function() {
            if (_this.props.renderCustomHeader) return;
            var allNextDaysDisabled = $18554e9a4ab03c83$var$monthDisabledAfter(_this.state.date, _this.props);
            if (!_this.props.forceShowMonthNavigation && !_this.props.showDisabledMonthNavigation && allNextDaysDisabled || _this.props.showTimeSelectOnly) return;
            var classes = [
                "react-datepicker__navigation",
                "react-datepicker__navigation--next"
            ];
            if (_this.props.showTimeSelect) classes.push("react-datepicker__navigation--next--with-time");
            if (_this.props.todayButton) classes.push("react-datepicker__navigation--next--with-today-button");
            var clickHandler = _this.increaseMonth;
            if (_this.props.showMonthYearPicker) clickHandler = _this.increaseYear;
            if (allNextDaysDisabled && _this.props.showDisabledMonthNavigation) {
                classes.push("react-datepicker__navigation--next--disabled");
                clickHandler = null;
            }
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                type: "button",
                className: classes.join(" "),
                onClick: clickHandler
            }, _this.props.showMonthYearPicker ? _this.props.nextYearButtonLabel : _this.props.nextMonthButtonLabel);
        };
        _this.renderCurrentMonth = function() {
            var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.date;
            var classes = [
                "react-datepicker__current-month"
            ];
            if (_this.props.showYearDropdown) classes.push("react-datepicker__current-month--hasYearDropdown");
            if (_this.props.showMonthDropdown) classes.push("react-datepicker__current-month--hasMonthDropdown");
            if (_this.props.showMonthYearDropdown) classes.push("react-datepicker__current-month--hasMonthYearDropdown");
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: classes.join(" ")
            }, $18554e9a4ab03c83$var$formatDate(date, _this.props.dateFormat, _this.props.locale));
        };
        _this.renderYearDropdown = function() {
            var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            if (!_this.props.showYearDropdown || overrideHide) return;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($18554e9a4ab03c83$var$YearDropdown, {
                adjustDateOnChange: _this.props.adjustDateOnChange,
                date: _this.state.date,
                onSelect: _this.props.onSelect,
                setOpen: _this.props.setOpen,
                dropdownMode: _this.props.dropdownMode,
                onChange: _this.changeYear,
                minDate: _this.props.minDate,
                maxDate: _this.props.maxDate,
                year: (0, $knAHj.default)(_this.state.date),
                scrollableYearDropdown: _this.props.scrollableYearDropdown,
                yearDropdownItemNumber: _this.props.yearDropdownItemNumber
            });
        };
        _this.renderMonthDropdown = function() {
            var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            if (!_this.props.showMonthDropdown || overrideHide) return;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($18554e9a4ab03c83$var$MonthDropdown, {
                dropdownMode: _this.props.dropdownMode,
                locale: _this.props.locale,
                onChange: _this.changeMonth,
                month: (0, $4UeRq.default)(_this.state.date),
                useShortMonthInDropdown: _this.props.useShortMonthInDropdown
            });
        };
        _this.renderMonthYearDropdown = function() {
            var overrideHide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            if (!_this.props.showMonthYearDropdown || overrideHide) return;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($18554e9a4ab03c83$var$MonthYearDropdown, {
                dropdownMode: _this.props.dropdownMode,
                locale: _this.props.locale,
                dateFormat: _this.props.dateFormat,
                onChange: _this.changeMonthYear,
                minDate: _this.props.minDate,
                maxDate: _this.props.maxDate,
                date: _this.state.date,
                scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown
            });
        };
        _this.renderTodayButton = function() {
            if (!_this.props.todayButton || _this.props.showTimeSelectOnly) return;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "react-datepicker__today-button",
                onClick: function onClick(e) {
                    return _this.props.onSelect($18554e9a4ab03c83$var$getStartOfToday(), e);
                }
            }, _this.props.todayButton);
        };
        _this.renderDefaultHeader = function(_ref) {
            var monthDate = _ref.monthDate, i = _ref.i;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "react-datepicker__header"
            }, _this.renderCurrentMonth(monthDate), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--" + _this.props.dropdownMode,
                onFocus: _this.handleDropdownFocus
            }, _this.renderMonthDropdown(i !== 0), _this.renderMonthYearDropdown(i !== 0), _this.renderYearDropdown(i !== 0)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "react-datepicker__day-names"
            }, _this.header(monthDate)));
        };
        _this.renderCustomHeader = function(_ref2) {
            var monthDate = _ref2.monthDate, i = _ref2.i;
            if (i !== 0) return null;
            var prevMonthButtonDisabled = $18554e9a4ab03c83$var$monthDisabledBefore(_this.state.date, _this.props);
            var nextMonthButtonDisabled = $18554e9a4ab03c83$var$monthDisabledAfter(_this.state.date, _this.props);
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "react-datepicker__header react-datepicker__header--custom",
                onFocus: _this.props.onDropdownFocus
            }, _this.props.renderCustomHeader($18554e9a4ab03c83$var$_extends({}, _this.state, {
                changeMonth: _this.changeMonth,
                changeYear: _this.changeYear,
                decreaseMonth: _this.decreaseMonth,
                increaseMonth: _this.increaseMonth,
                prevMonthButtonDisabled: prevMonthButtonDisabled,
                nextMonthButtonDisabled: nextMonthButtonDisabled
            })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "react-datepicker__day-names"
            }, _this.header(monthDate)));
        };
        _this.renderYearHeader = function() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "react-datepicker__header react-datepicker-year-header"
            }, (0, $knAHj.default)(_this.state.date));
        };
        _this.renderMonths = function() {
            if (_this.props.showTimeSelectOnly) return;
            var monthList = [];
            for(var i = 0; i < _this.props.monthsShown; ++i){
                var monthsToAdd = i - _this.props.monthSelectedIn;
                var monthDate = (0, $eqWMS.default)(_this.state.date, monthsToAdd);
                var monthKey = "month-" + i;
                monthList.push((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    key: monthKey,
                    ref: function ref(div) {
                        _this.monthContainer = div;
                    },
                    className: "react-datepicker__month-container"
                }, !_this.props.showMonthYearPicker ? _this.props.renderCustomHeader ? _this.renderCustomHeader({
                    monthDate: monthDate,
                    i: i
                }) : _this.renderDefaultHeader({
                    monthDate: monthDate,
                    i: i
                }) : _this.renderYearHeader({
                    monthDate: monthDate,
                    i: i
                }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($18554e9a4ab03c83$var$Month, {
                    onChange: _this.changeMonthYear,
                    day: monthDate,
                    dayClassName: _this.props.dayClassName,
                    onDayClick: _this.handleDayClick,
                    onDayMouseEnter: _this.handleDayMouseEnter,
                    onMouseLeave: _this.handleMonthMouseLeave,
                    onWeekSelect: _this.props.onWeekSelect,
                    orderInDisplay: i,
                    formatWeekNumber: _this.props.formatWeekNumber,
                    locale: _this.props.locale,
                    minDate: _this.props.minDate,
                    maxDate: _this.props.maxDate,
                    excludeDates: _this.props.excludeDates,
                    highlightDates: _this.props.highlightDates,
                    selectingDate: _this.state.selectingDate,
                    includeDates: _this.props.includeDates,
                    inline: _this.props.inline,
                    fixedHeight: _this.props.fixedHeight,
                    filterDate: _this.props.filterDate,
                    preSelection: _this.props.preSelection,
                    selected: _this.props.selected,
                    selectsStart: _this.props.selectsStart,
                    selectsEnd: _this.props.selectsEnd,
                    showWeekNumbers: _this.props.showWeekNumbers,
                    startDate: _this.props.startDate,
                    endDate: _this.props.endDate,
                    peekNextMonth: _this.props.peekNextMonth,
                    setOpen: _this.props.setOpen,
                    shouldCloseOnSelect: _this.props.shouldCloseOnSelect,
                    renderDayContents: _this.props.renderDayContents,
                    disabledKeyboardNavigation: _this.props.disabledKeyboardNavigation,
                    showMonthYearPicker: _this.props.showMonthYearPicker
                })));
            }
            return monthList;
        };
        _this.renderTimeSection = function() {
            if (_this.props.showTimeSelect && (_this.state.monthContainer || _this.props.showTimeSelectOnly)) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($18554e9a4ab03c83$var$Time, {
                selected: _this.props.selected,
                onChange: _this.props.onTimeChange,
                format: _this.props.timeFormat,
                includeTimes: _this.props.includeTimes,
                intervals: _this.props.timeIntervals,
                minTime: _this.props.minTime,
                maxTime: _this.props.maxTime,
                excludeTimes: _this.props.excludeTimes,
                timeCaption: _this.props.timeCaption,
                todayButton: _this.props.todayButton,
                showMonthDropdown: _this.props.showMonthDropdown,
                showMonthYearDropdown: _this.props.showMonthYearDropdown,
                showYearDropdown: _this.props.showYearDropdown,
                withPortal: _this.props.withPortal,
                monthRef: _this.state.monthContainer,
                injectTimes: _this.props.injectTimes
            });
        };
        _this.renderInputTimeSection = function() {
            var time = new Date(_this.props.selected);
            var timeString = $18554e9a4ab03c83$var$addZero(time.getHours()) + ":" + $18554e9a4ab03c83$var$addZero(time.getMinutes());
            if (_this.props.showTimeInput) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($18554e9a4ab03c83$var$inputTime, {
                timeString: timeString,
                timeInputLabel: _this.props.timeInputLabel,
                onChange: _this.props.onTimeChange
            });
        };
        _this.state = {
            date: _this.getDateInView(),
            selectingDate: null,
            monthContainer: null
        };
        return _this;
    }
    Calendar.prototype.componentDidMount = function componentDidMount() {
        var _this2 = this;
        // monthContainer height is needed in time component
        // to determine the height for the ul in the time component
        // setState here so height is given after final component
        // layout is rendered
        if (this.props.showTimeSelect) this.assignMonthContainer = function() {
            _this2.setState({
                monthContainer: _this2.monthContainer
            });
        }();
    };
    Calendar.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.preSelection && !$18554e9a4ab03c83$var$isSameDay(this.props.preSelection, prevProps.preSelection)) this.setState({
            date: this.props.preSelection
        });
        else if (this.props.openToDate && !$18554e9a4ab03c83$var$isSameDay(this.props.openToDate, prevProps.openToDate)) this.setState({
            date: this.props.openToDate
        });
    };
    Calendar.prototype.render = function render() {
        var Container = this.props.container || $18554e9a4ab03c83$export$946daa762919616e;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Container, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("react-datepicker", this.props.className, {
                "react-datepicker--time-only": this.props.showTimeSelectOnly
            })
        }, this.renderPreviousButton(), this.renderNextButton(), this.renderMonths(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.props.children);
    };
    return Calendar;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
var $18554e9a4ab03c83$var$PopperComponent = function(_React$Component) {
    $18554e9a4ab03c83$var$inherits(PopperComponent, _React$Component);
    function PopperComponent() {
        $18554e9a4ab03c83$var$classCallCheck(this, PopperComponent);
        return $18554e9a4ab03c83$var$possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }
    PopperComponent.prototype.render = function render() {
        var _props = this.props, className = _props.className, hidePopper = _props.hidePopper, popperComponent = _props.popperComponent, popperModifiers = _props.popperModifiers, popperPlacement = _props.popperPlacement, popperProps = _props.popperProps, targetComponent = _props.targetComponent;
        var popper = void 0;
        if (!hidePopper) {
            var classes = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("react-datepicker-popper", className);
            popper = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $3cbhK.default), $18554e9a4ab03c83$var$_extends({
                modifiers: popperModifiers,
                placement: popperPlacement
            }, popperProps), function(_ref) {
                var ref = _ref.ref, style = _ref.style, placement = _ref.placement, arrowProps = _ref.arrowProps;
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", $18554e9a4ab03c83$var$_extends({
                    ref: ref,
                    style: style
                }, {
                    className: classes,
                    "data-placement": placement
                }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(popperComponent, {
                    arrowProps: arrowProps
                }));
            });
        }
        if (this.props.popperContainer) popper = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(this.props.popperContainer, {}, popper);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8j0J5.default), null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $6KgD0.default), null, function(_ref2) {
            var ref = _ref2.ref;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                ref: ref,
                className: "react-datepicker-wrapper"
            }, targetComponent);
        }), popper);
    };
    $18554e9a4ab03c83$var$createClass(PopperComponent, null, [
        {
            key: "defaultProps",
            get: function get$$1() {
                return {
                    hidePopper: true,
                    popperModifiers: {
                        preventOverflow: {
                            enabled: true,
                            escapeWithReference: true,
                            boundariesElement: "viewport"
                        }
                    },
                    popperProps: {},
                    popperPlacement: "bottom-start"
                };
            }
        }
    ]);
    return PopperComponent;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
var $18554e9a4ab03c83$var$outsideClickIgnoreClass = "react-datepicker-ignore-onclickoutside";
var $18554e9a4ab03c83$var$WrappedCalendar = (0, $hL3CS.default)($18554e9a4ab03c83$var$Calendar);
// Compares dates year+month combinations
function $18554e9a4ab03c83$var$hasPreSelectionChanged(date1, date2) {
    if (date1 && date2) return (0, $4UeRq.default)(date1) !== (0, $4UeRq.default)(date2) || (0, $knAHj.default)(date1) !== (0, $knAHj.default)(date2);
    return date1 !== date2;
}
/**
 * General datepicker component.
 */ var $18554e9a4ab03c83$var$INPUT_ERR_1 = "Date input not valid.";
var $18554e9a4ab03c83$var$DatePicker = function(_React$Component) {
    $18554e9a4ab03c83$var$inherits(DatePicker, _React$Component);
    $18554e9a4ab03c83$var$createClass(DatePicker, null, [
        {
            key: "defaultProps",
            get: function get$$1() {
                return {
                    allowSameDay: false,
                    dateFormat: "MM/dd/yyyy",
                    dateFormatCalendar: "LLLL yyyy",
                    onChange: function onChange() {},
                    disabled: false,
                    disabledKeyboardNavigation: false,
                    dropdownMode: "scroll",
                    onFocus: function onFocus() {},
                    onBlur: function onBlur() {},
                    onKeyDown: function onKeyDown() {},
                    onInputClick: function onInputClick() {},
                    onSelect: function onSelect() {},
                    onClickOutside: function onClickOutside$$1() {},
                    onMonthChange: function onMonthChange() {},
                    preventOpenOnFocus: false,
                    onYearChange: function onYearChange() {},
                    onInputError: function onInputError() {},
                    monthsShown: 1,
                    readOnly: false,
                    withPortal: false,
                    shouldCloseOnSelect: true,
                    showTimeSelect: false,
                    showTimeInput: false,
                    showMonthYearPicker: false,
                    strictParsing: false,
                    timeIntervals: 30,
                    timeCaption: "Time",
                    previousMonthButtonLabel: "Previous Month",
                    nextMonthButtonLabel: "Next month",
                    timeInputLabel: "Time",
                    renderDayContents: function renderDayContents(date) {
                        return date;
                    },
                    inlineFocusSelectedMonth: false
                };
            }
        }
    ]);
    function DatePicker(props) {
        $18554e9a4ab03c83$var$classCallCheck(this, DatePicker);
        var _this = $18554e9a4ab03c83$var$possibleConstructorReturn(this, _React$Component.call(this, props));
        _this.getPreSelection = function() {
            return _this.props.openToDate ? _this.props.openToDate : _this.props.selectsEnd && _this.props.startDate ? _this.props.startDate : _this.props.selectsStart && _this.props.endDate ? _this.props.endDate : $18554e9a4ab03c83$var$newDate();
        };
        _this.calcInitialState = function() {
            var defaultPreSelection = _this.getPreSelection();
            var minDate = $18554e9a4ab03c83$var$getEffectiveMinDate(_this.props);
            var maxDate = $18554e9a4ab03c83$var$getEffectiveMaxDate(_this.props);
            var boundedPreSelection = minDate && (0, $4YTY5.default)(defaultPreSelection, minDate) ? minDate : maxDate && (0, $baBa1.default)(defaultPreSelection, maxDate) ? maxDate : defaultPreSelection;
            return {
                open: _this.props.startOpen || false,
                preventFocus: false,
                preSelection: _this.props.selected ? _this.props.selected : boundedPreSelection,
                // transforming highlighted days (perhaps nested array)
                // to flat Map for faster access in day.jsx
                highlightDates: $18554e9a4ab03c83$var$getHightLightDaysMap(_this.props.highlightDates),
                focused: false
            };
        };
        _this.clearPreventFocusTimeout = function() {
            if (_this.preventFocusTimeout) clearTimeout(_this.preventFocusTimeout);
        };
        _this.setFocus = function() {
            if (_this.input && _this.input.focus) _this.input.focus();
        };
        _this.setBlur = function() {
            if (_this.input && _this.input.blur) _this.input.blur();
            _this.cancelFocusInput();
        };
        _this.setOpen = function(open) {
            var skipSetBlur = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            _this.setState({
                open: open,
                preSelection: open && _this.state.open ? _this.state.preSelection : _this.calcInitialState().preSelection,
                lastPreSelectChange: $18554e9a4ab03c83$var$PRESELECT_CHANGE_VIA_NAVIGATE
            }, function() {
                if (!open) _this.setState(function(prev) {
                    return {
                        focused: skipSetBlur ? prev.focused : false
                    };
                }, function() {
                    !skipSetBlur && _this.setBlur();
                    _this.setState({
                        inputValue: null
                    });
                });
            });
        };
        _this.inputOk = function() {
            return (0, $9BdaM.default)(_this.state.preSelection);
        };
        _this.isCalendarOpen = function() {
            return _this.props.open === undefined ? _this.state.open && !_this.props.disabled && !_this.props.readOnly : _this.props.open;
        };
        _this.handleFocus = function(event) {
            if (!_this.state.preventFocus) {
                _this.props.onFocus(event);
                if (!_this.props.preventOpenOnFocus && !_this.props.readOnly) _this.setOpen(true);
            }
            _this.setState({
                focused: true
            });
        };
        _this.cancelFocusInput = function() {
            clearTimeout(_this.inputFocusTimeout);
            _this.inputFocusTimeout = null;
        };
        _this.deferFocusInput = function() {
            _this.cancelFocusInput();
            _this.inputFocusTimeout = setTimeout(function() {
                return _this.setFocus();
            }, 1);
        };
        _this.handleDropdownFocus = function() {
            _this.cancelFocusInput();
        };
        _this.handleBlur = function(event) {
            if (_this.state.open && !_this.props.withPortal && !_this.props.showTimeInput) _this.deferFocusInput();
            else _this.props.onBlur(event);
            _this.setState({
                focused: false
            });
        };
        _this.handleCalendarClickOutside = function(event) {
            if (!_this.props.inline) _this.setOpen(false);
            _this.props.onClickOutside(event);
            if (_this.props.withPortal) event.preventDefault();
        };
        _this.handleChange = function() {
            for(var _len = arguments.length, allArgs = Array(_len), _key = 0; _key < _len; _key++)allArgs[_key] = arguments[_key];
            var event = allArgs[0];
            if (_this.props.onChangeRaw) {
                _this.props.onChangeRaw.apply(_this, allArgs);
                if (typeof event.isDefaultPrevented !== "function" || event.isDefaultPrevented()) return;
            }
            _this.setState({
                inputValue: event.target.value,
                lastPreSelectChange: $18554e9a4ab03c83$var$PRESELECT_CHANGE_VIA_INPUT
            });
            var date = $18554e9a4ab03c83$var$parseDate(event.target.value, _this.props.dateFormat, _this.props.locale, _this.props.strictParsing);
            if (date || !event.target.value) _this.setSelected(date, event, true);
        };
        _this.handleSelect = function(date, event, monthSelectedIn) {
            // Preventing onFocus event to fix issue
            // https://github.com/Hacker0x01/react-datepicker/issues/628
            _this.setState({
                preventFocus: true
            }, function() {
                _this.preventFocusTimeout = setTimeout(function() {
                    return _this.setState({
                        preventFocus: false
                    });
                }, 50);
                return _this.preventFocusTimeout;
            });
            _this.setSelected(date, event, undefined, monthSelectedIn);
            if (!_this.props.shouldCloseOnSelect || _this.props.showTimeSelect) _this.setPreSelection(date);
            else if (!_this.props.inline) _this.setOpen(false);
        };
        _this.setSelected = function(date, event, keepInput, monthSelectedIn) {
            var changedDate = date;
            if (changedDate !== null && $18554e9a4ab03c83$var$isDayDisabled(changedDate, _this.props)) {
                if ($18554e9a4ab03c83$var$isOutOfBounds(changedDate, _this.props)) {
                    _this.props.onChange(date, event);
                    _this.props.onSelect(changedDate, event);
                }
                return;
            }
            if (!$18554e9a4ab03c83$var$isEqual(_this.props.selected, changedDate) || _this.props.allowSameDay) {
                if (changedDate !== null) {
                    if (_this.props.selected) {
                        var selected = _this.props.selected;
                        if (keepInput) selected = $18554e9a4ab03c83$var$newDate(changedDate);
                        changedDate = $18554e9a4ab03c83$var$setTime(changedDate, {
                            hour: (0, $kjLiX.default)(selected),
                            minute: (0, $aABJG.default)(selected),
                            second: (0, $6fhf3.default)(selected)
                        });
                    }
                    if (!_this.props.inline) _this.setState({
                        preSelection: changedDate
                    });
                    if (_this.props.inline && _this.props.monthsShown > 1 && !_this.props.inlineFocusSelectedMonth) _this.setState({
                        monthSelectedIn: monthSelectedIn
                    });
                }
                _this.props.onChange(changedDate, event);
            }
            _this.props.onSelect(changedDate, event);
            if (!keepInput) _this.setState({
                inputValue: null
            });
        };
        _this.setPreSelection = function(date) {
            var hasMinDate = typeof _this.props.minDate !== "undefined";
            var hasMaxDate = typeof _this.props.maxDate !== "undefined";
            var isValidDateSelection = true;
            if (date) {
                if (hasMinDate && hasMaxDate) isValidDateSelection = $18554e9a4ab03c83$var$isDayInRange(date, _this.props.minDate, _this.props.maxDate);
                else if (hasMinDate) isValidDateSelection = (0, $baBa1.default)(date, _this.props.minDate);
                else if (hasMaxDate) isValidDateSelection = (0, $4YTY5.default)(date, _this.props.maxDate);
            }
            if (isValidDateSelection) _this.setState({
                preSelection: date
            });
        };
        _this.handleTimeChange = function(time) {
            var selected = _this.props.selected ? _this.props.selected : _this.getPreSelection();
            var changedDate = $18554e9a4ab03c83$var$setTime(selected, {
                hour: (0, $kjLiX.default)(time),
                minute: (0, $aABJG.default)(time)
            });
            _this.setState({
                preSelection: changedDate
            });
            _this.props.onChange(changedDate);
            if (_this.props.shouldCloseOnSelect) _this.setOpen(false);
            if (_this.props.showTimeInput) _this.setOpen(true);
            _this.setState({
                inputValue: null
            });
        };
        _this.onInputClick = function() {
            if (!_this.props.disabled && !_this.props.readOnly) _this.setOpen(true);
            _this.props.onInputClick();
        };
        _this.onInputKeyDown = function(event) {
            _this.props.onKeyDown(event);
            var eventKey = event.key;
            if (!_this.state.open && !_this.props.inline && !_this.props.preventOpenOnFocus) {
                if (eventKey === "ArrowDown" || eventKey === "ArrowUp") _this.onInputClick();
                return;
            }
            var copy = $18554e9a4ab03c83$var$newDate(_this.state.preSelection);
            if (eventKey === "Enter") {
                event.preventDefault();
                if (_this.inputOk() && _this.state.lastPreSelectChange === $18554e9a4ab03c83$var$PRESELECT_CHANGE_VIA_NAVIGATE) {
                    _this.handleSelect(copy, event);
                    !_this.props.shouldCloseOnSelect && _this.setPreSelection(copy);
                } else _this.setOpen(false);
            } else if (eventKey === "Escape") {
                event.preventDefault();
                _this.setOpen(false);
                if (!_this.inputOk()) _this.props.onInputError({
                    code: 1,
                    msg: $18554e9a4ab03c83$var$INPUT_ERR_1
                });
            } else if (eventKey === "Tab") _this.setOpen(false, true);
            else if (!_this.props.disabledKeyboardNavigation) {
                var newSelection = void 0;
                switch(eventKey){
                    case "ArrowLeft":
                        newSelection = (0, $4irF8.default)(copy, 1);
                        break;
                    case "ArrowRight":
                        newSelection = (0, $6OX6Q.default)(copy, 1);
                        break;
                    case "ArrowUp":
                        newSelection = (0, $lDduA.default)(copy, 1);
                        break;
                    case "ArrowDown":
                        newSelection = (0, $2MTnF.default)(copy, 1);
                        break;
                    case "PageUp":
                        newSelection = (0, $lXe7Q.default)(copy, 1);
                        break;
                    case "PageDown":
                        newSelection = (0, $eqWMS.default)(copy, 1);
                        break;
                    case "Home":
                        newSelection = (0, $4UG1B.default)(copy, 1);
                        break;
                    case "End":
                        newSelection = (0, $kbDwl.default)(copy, 1);
                        break;
                }
                if (!newSelection) {
                    if (_this.props.onInputError) _this.props.onInputError({
                        code: 1,
                        msg: $18554e9a4ab03c83$var$INPUT_ERR_1
                    });
                    return; // Let the input component handle this keydown
                }
                event.preventDefault();
                _this.setState({
                    lastPreSelectChange: $18554e9a4ab03c83$var$PRESELECT_CHANGE_VIA_NAVIGATE
                });
                if (_this.props.adjustDateOnChange) _this.setSelected(newSelection);
                _this.setPreSelection(newSelection);
            }
        };
        _this.onClearClick = function(event) {
            if (event) {
                if (event.preventDefault) event.preventDefault();
            }
            _this.props.onChange(null, event);
            _this.setState({
                inputValue: null
            });
        };
        _this.clear = function() {
            _this.onClearClick();
        };
        _this.renderCalendar = function() {
            if (!_this.props.inline && !_this.isCalendarOpen()) return null;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($18554e9a4ab03c83$var$WrappedCalendar, {
                ref: function ref(elem) {
                    _this.calendar = elem;
                },
                locale: _this.props.locale,
                adjustDateOnChange: _this.props.adjustDateOnChange,
                setOpen: _this.setOpen,
                shouldCloseOnSelect: _this.props.shouldCloseOnSelect,
                dateFormat: _this.props.dateFormatCalendar,
                useWeekdaysShort: _this.props.useWeekdaysShort,
                formatWeekDay: _this.props.formatWeekDay,
                dropdownMode: _this.props.dropdownMode,
                selected: _this.props.selected,
                preSelection: _this.state.preSelection,
                onSelect: _this.handleSelect,
                onWeekSelect: _this.props.onWeekSelect,
                openToDate: _this.props.openToDate,
                minDate: _this.props.minDate,
                maxDate: _this.props.maxDate,
                selectsStart: _this.props.selectsStart,
                selectsEnd: _this.props.selectsEnd,
                startDate: _this.props.startDate,
                endDate: _this.props.endDate,
                excludeDates: _this.props.excludeDates,
                filterDate: _this.props.filterDate,
                onClickOutside: _this.handleCalendarClickOutside,
                formatWeekNumber: _this.props.formatWeekNumber,
                highlightDates: _this.state.highlightDates,
                includeDates: _this.props.includeDates,
                includeTimes: _this.props.includeTimes,
                injectTimes: _this.props.injectTimes,
                inline: _this.props.inline,
                peekNextMonth: _this.props.peekNextMonth,
                showMonthDropdown: _this.props.showMonthDropdown,
                useShortMonthInDropdown: _this.props.useShortMonthInDropdown,
                showMonthYearDropdown: _this.props.showMonthYearDropdown,
                showWeekNumbers: _this.props.showWeekNumbers,
                showYearDropdown: _this.props.showYearDropdown,
                withPortal: _this.props.withPortal,
                forceShowMonthNavigation: _this.props.forceShowMonthNavigation,
                showDisabledMonthNavigation: _this.props.showDisabledMonthNavigation,
                scrollableYearDropdown: _this.props.scrollableYearDropdown,
                scrollableMonthYearDropdown: _this.props.scrollableMonthYearDropdown,
                todayButton: _this.props.todayButton,
                weekLabel: _this.props.weekLabel,
                outsideClickIgnoreClass: $18554e9a4ab03c83$var$outsideClickIgnoreClass,
                fixedHeight: _this.props.fixedHeight,
                monthsShown: _this.props.monthsShown,
                monthSelectedIn: _this.state.monthSelectedIn,
                onDropdownFocus: _this.handleDropdownFocus,
                onMonthChange: _this.props.onMonthChange,
                onYearChange: _this.props.onYearChange,
                dayClassName: _this.props.dayClassName,
                showTimeSelect: _this.props.showTimeSelect,
                showTimeSelectOnly: _this.props.showTimeSelectOnly,
                onTimeChange: _this.handleTimeChange,
                timeFormat: _this.props.timeFormat,
                timeIntervals: _this.props.timeIntervals,
                minTime: _this.props.minTime,
                maxTime: _this.props.maxTime,
                excludeTimes: _this.props.excludeTimes,
                timeCaption: _this.props.timeCaption,
                className: _this.props.calendarClassName,
                container: _this.props.calendarContainer,
                yearDropdownItemNumber: _this.props.yearDropdownItemNumber,
                previousMonthButtonLabel: _this.props.previousMonthButtonLabel,
                nextMonthButtonLabel: _this.props.nextMonthButtonLabel,
                timeInputLabel: _this.props.timeInputLabel,
                disabledKeyboardNavigation: _this.props.disabledKeyboardNavigation,
                renderCustomHeader: _this.props.renderCustomHeader,
                popperProps: _this.props.popperProps,
                renderDayContents: _this.props.renderDayContents,
                onDayMouseEnter: _this.props.onDayMouseEnter,
                onMonthMouseLeave: _this.props.onMonthMouseLeave,
                showTimeInput: _this.props.showTimeInput,
                showMonthYearPicker: _this.props.showMonthYearPicker
            }, _this.props.children);
        };
        _this.renderDateInput = function() {
            var _classnames, _React$cloneElement;
            var className = (0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(_this.props.className, (_classnames = {}, _classnames[$18554e9a4ab03c83$var$outsideClickIgnoreClass] = _this.state.open, _classnames));
            var customInput = _this.props.customInput || (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("input", {
                type: "text"
            });
            var customInputRef = _this.props.customInputRef || "ref";
            var inputValue = typeof _this.props.value === "string" ? _this.props.value : typeof _this.state.inputValue === "string" ? _this.state.inputValue : $18554e9a4ab03c83$var$safeDateFormat(_this.props.selected, _this.props);
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(customInput, (_React$cloneElement = {}, _React$cloneElement[customInputRef] = function(input) {
                _this.input = input;
            }, _React$cloneElement.value = inputValue, _React$cloneElement.onBlur = _this.handleBlur, _React$cloneElement.onChange = _this.handleChange, _React$cloneElement.onClick = _this.onInputClick, _React$cloneElement.onFocus = _this.handleFocus, _React$cloneElement.onKeyDown = _this.onInputKeyDown, _React$cloneElement.id = _this.props.id, _React$cloneElement.name = _this.props.name, _React$cloneElement.autoFocus = _this.props.autoFocus, _React$cloneElement.placeholder = _this.props.placeholderText, _React$cloneElement.disabled = _this.props.disabled, _React$cloneElement.autoComplete = _this.props.autoComplete, _React$cloneElement.className = className, _React$cloneElement.title = _this.props.title, _React$cloneElement.readOnly = _this.props.readOnly, _React$cloneElement.required = _this.props.required, _React$cloneElement.tabIndex = _this.props.tabIndex, _React$cloneElement));
        };
        _this.renderClearButton = function() {
            if (_this.props.isClearable && _this.props.selected != null) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                type: "button",
                className: "react-datepicker__close-icon",
                onClick: _this.onClearClick,
                title: _this.props.clearButtonTitle,
                tabIndex: -1
            });
            else return null;
        };
        _this.state = _this.calcInitialState();
        return _this;
    }
    DatePicker.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        if (prevProps.inline && $18554e9a4ab03c83$var$hasPreSelectionChanged(prevProps.selected, this.props.selected)) this.setPreSelection(this.props.selected);
        if (this.state.monthSelectedIn !== undefined && prevProps.monthsShown !== this.props.monthsShown) this.setState({
            monthSelectedIn: 0
        });
        if (prevProps.highlightDates !== this.props.highlightDates) this.setState({
            highlightDates: $18554e9a4ab03c83$var$getHightLightDaysMap(this.props.highlightDates)
        });
        if (!prevState.focused && !$18554e9a4ab03c83$var$isEqual(prevProps.selected, this.props.selected)) this.setState({
            inputValue: null
        });
    };
    DatePicker.prototype.componentWillUnmount = function componentWillUnmount() {
        this.clearPreventFocusTimeout();
    };
    DatePicker.prototype.render = function render() {
        var calendar = this.renderCalendar();
        if (this.props.inline && !this.props.withPortal) return calendar;
        if (this.props.withPortal) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, !this.props.inline ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "react-datepicker__input-container"
        }, this.renderDateInput(), this.renderClearButton()) : null, this.state.open || this.props.inline ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "react-datepicker__portal"
        }, calendar) : null);
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($18554e9a4ab03c83$var$PopperComponent, {
            className: this.props.popperClassName,
            hidePopper: !this.isCalendarOpen(),
            popperModifiers: this.props.popperModifiers,
            targetComponent: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "react-datepicker__input-container"
            }, this.renderDateInput(), this.renderClearButton()),
            popperContainer: this.props.popperContainer,
            popperComponent: calendar,
            popperPlacement: this.props.popperPlacement,
            popperProps: this.props.popperProps
        });
    };
    return DatePicker;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
var $18554e9a4ab03c83$var$PRESELECT_CHANGE_VIA_INPUT = "input";
var $18554e9a4ab03c83$var$PRESELECT_CHANGE_VIA_NAVIGATE = "navigate";
var $18554e9a4ab03c83$export$2e2bcd8739ae039 = $18554e9a4ab03c83$var$DatePicker;

});
parcelRegister("1MaHn", function(module, exports) {

$parcel$export(module.exports, "default", () => $14b292ac50f57a2d$export$2e2bcd8739ae039);

var $esGEx = parcelRequire("esGEx");

var $gdr0J = parcelRequire("gdr0J");

var $4LmDH = parcelRequire("4LmDH");
function $14b292ac50f57a2d$export$2e2bcd8739ae039(dirtyDate, dirtyDayOfYear) {
    (0, $4LmDH.default)(2, arguments);
    var date = (0, $gdr0J.default)(dirtyDate);
    var dayOfYear = (0, $esGEx.default)(dirtyDayOfYear);
    date.setMonth(0);
    date.setDate(dayOfYear);
    return date;
}

});







parcelRegister("94MZK", function(module, exports) {

$parcel$export(module.exports, "default", () => $5601e1f2b7fc0ff2$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4fGPb = parcelRequire("4fGPb");

var $7hEbZ = parcelRequire("7hEbZ");

var $aTLkh = parcelRequire("aTLkh");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");
var $c5PmB = parcelRequire("c5PmB");

var $ghmpR = parcelRequire("ghmpR");

var $7tOHe = parcelRequire("7tOHe");

var $59GDU = parcelRequire("59GDU");

var $bGkwn = parcelRequire("bGkwn");

var $awF4Z = parcelRequire("awF4Z");

var $cstaF = parcelRequire("cstaF");

var $24YIE = parcelRequire("24YIE");
const $5601e1f2b7fc0ff2$var$AgentCard = (props)=>{
    const [chartMode, setChartMode] = (0, $acw62.useState)((0, $bGkwn.chartModes).VOLUME);
    const [chartData, setChartData] = (0, $acw62.useState)(null);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(true);
    const sortChartData = (data)=>data.sort((a, b)=>a.month > b.month ? 1 : -1);
    (0, $acw62.useEffect)(()=>{
        if (!props.selectedAgent.agentId || !props.mlsId) {
            setChartData(undefined);
            return;
        }
        const loadChartData = async ()=>{
            setIsLoading(true);
            const data = await (0, $24YIE.getAgentHistory)({
                agentId: props.selectedAgent.agentId,
                mlsId: props.mlsId
            });
            sortChartData(data);
            setChartData(data);
            setIsLoading(false);
        };
        const handleErrorInFutureTicket = (e)=>e; // todo - add error handling
        loadChartData().catch(handleErrorInFutureTicket);
    }, [
        props.selectedAgent.agentId,
        props.mlsId
    ]);
    const bodyProps = {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "d-flex h-100",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ghmpR.default), {
                    ...props,
                    className: "px-0"
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fGPb.Link), {
                    id: `agent-detail-link-${props.selectedAgent.agentId}`,
                    className: "btn text-primary ml-auto p-0 d-flex align-items-center view-profile-icon bg-none",
                    to: `/agent-detail?id=${props.selectedAgent.agentId}&module=${props.module}`,
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "d-flex flex-column",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aTLkh.default), {
                                dataLwtId: "profile-icon",
                                iconName: "person"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "mt-2",
                                children: "View Profile"
                            })
                        ]
                    })
                })
            ]
        })
    };
    const handleChartModeClick = (modeToSet)=>{
        setChartMode(modeToSet);
    };
    const getTimePeriod = ()=>(0, $cstaF.TimePeriods)[(0, $cstaF.agentProductionTerms).last12Months];
    let chartTable, chartGraph;
    if (isLoading) {
        chartTable = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {});
        chartGraph = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {});
    } else {
        const timePeriod = getTimePeriod();
        const dataIndexes = (0, $bGkwn.getChartDataIndexes)({
            timePeriod: timePeriod,
            chartData: chartData
        });
        const { getSumTotal: getSumTotal, labelTotal: labelTotal, getFormattedAmount: getFormattedAmount, labelAmountChange: labelAmountChange } = (0, $bGkwn.getOverviewChartTableParams)(chartMode);
        const totals = (0, $bGkwn.getChartTotals)({
            chartData: chartData,
            dataIndexes: dataIndexes,
            getSumTotal: getSumTotal
        });
        const overviewChartTableProps = {
            totals: totals,
            timePeriod: timePeriod,
            chartData: chartData,
            dataIndexes: dataIndexes,
            labelTotal: labelTotal,
            getFormattedAmount: getFormattedAmount,
            labelAmountChange: labelAmountChange
        };
        const graphProps = {
            chartData: chartData || [],
            timePeriod: timePeriod,
            dataIndexes: dataIndexes
        };
        chartTable = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $awF4Z.OverviewChartTable), {
            ...overviewChartTableProps
        });
        chartGraph = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $59GDU.OverviewChartGraph), {
            ...graphProps
        });
    }
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7hEbZ.default), {
                dataLwtId: "agent-card",
                bodyProps: bodyProps,
                className: `w-100 ${!!props.border && "border-0"}`,
                raised: !!props.raised,
                rounded: true
            }),
            chartTable,
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "position-relative chart-container mt-3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($c5PmB))), {
                        dataLwtId: "button-group-volume-units",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                                dataLwtId: "btn-volume",
                                size: "xs",
                                color: chartMode === (0, $bGkwn.chartModes).VOLUME ? "primary" : "",
                                onClick: ()=>handleChartModeClick((0, $bGkwn.chartModes).VOLUME),
                                children: [
                                    " ",
                                    (0, $cstaF.buttonTerms).volume
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                                dataLwtId: "btn-units",
                                size: "xs",
                                color: chartMode === (0, $bGkwn.chartModes).UNITS ? "primary" : "",
                                onClick: ()=>handleChartModeClick((0, $bGkwn.chartModes).UNITS),
                                children: [
                                    " ",
                                    (0, $cstaF.buttonTerms).units
                                ]
                            })
                        ]
                    }),
                    chartGraph
                ]
            })
        ]
    });
};
var $5601e1f2b7fc0ff2$export$2e2bcd8739ae039 = $5601e1f2b7fc0ff2$var$AgentCard;

});
parcelRegister("ghmpR", function(module, exports) {

$parcel$export(module.exports, "default", () => $730dff6962c374a6$export$2e2bcd8739ae039);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $gHbmO = parcelRequire("gHbmO");
const $730dff6962c374a6$var$AgentNameBlock = ({ selectedAgent: selectedAgent, nameBold: nameBold })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "d-flex",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                    className: `mb-0 pb-0 ${nameBold ? "font-weight-bold" : ""}`,
                    children: selectedAgent?.agentName
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "max-content mb-0 helix-heading helix-gray-6",
                    children: (0, $gHbmO.toTitleCase)(selectedAgent?.officeName)
                })
            ]
        })
    });
};
$730dff6962c374a6$var$AgentNameBlock.propTypes = {
    selectedAgent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        agentName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        officeName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    }),
    nameBold: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
var $730dff6962c374a6$export$2e2bcd8739ae039 = $730dff6962c374a6$var$AgentNameBlock;

});
parcelRegister("gHbmO", function(module, exports) {

$parcel$export(module.exports, "getReplacedTemplate", () => $c2797abc95612fb3$export$867187d810f13155);
$parcel$export(module.exports, "toTitleCase", () => $c2797abc95612fb3$export$f06f8b3003f18927);
const $c2797abc95612fb3$export$867187d810f13155 = (template, substitutions)=>{
    if (!substitutions?.length) return template;
    let result = `${template}`;
    substitutions.forEach((s)=>{
        result = result.replaceAll(s.searchText, s.replaceWith);
    });
    return result;
};
const $c2797abc95612fb3$export$f06f8b3003f18927 = (str)=>{
    if (typeof str !== "string") return "";
    return str.toLowerCase().replace(/\b\w/g, (char)=>char.toUpperCase());
};

});


parcelRegister("59GDU", function(module, exports) {

$parcel$export(module.exports, "OverviewChartGraph", () => $12a8c5c0cefe2a33$export$fa8aea0387ad4ea);

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $3r6bj = parcelRequire("3r6bj");

var $htzEo = parcelRequire("htzEo");

var $bGkwn = parcelRequire("bGkwn");

var $cstaF = parcelRequire("cstaF");

var $g3CkB = parcelRequire("g3CkB");

var $ivaD7 = parcelRequire("ivaD7");

var $7jSpM = parcelRequire("7jSpM");

var $bA5Mi = parcelRequire("bA5Mi");

var $eHBjM = parcelRequire("eHBjM");

var $c9Z8w = parcelRequire("c9Z8w");

var $jUjGS = parcelRequire("jUjGS");
const $12a8c5c0cefe2a33$export$fa8aea0387ad4ea = (props)=>{
    const { chartData: chartData, dataIndexes: dataIndexes, dataPointFormatter: dataPointFormatter, yAxisTitle: yAxisTitle, yAxisFormatter: yAxisFormatter, graphMode: graphMode, isShowColumnLabels: isShowColumnLabels, listMapper: listMapper, sellMapper: sellMapper, countYAxisTicks: countYAxisTicks, handleClickChartGraph: handleClickChartGraph, currentTabIndex: currentTabIndex } = props;
    const isPDFLoading = (0, $bA5Mi.usePDFStore)((state)=>state.downloadModalStatus.isPDFLoading);
    const CONTAINER_WIDTH_MAX = "100%";
    const MINIMUM_COLUMN_WIDTH_IN_PIXELS = 85;
    const [state, setState] = (0, $acw62.useState)({
        windowWidth: window.innerWidth,
        widthGraph: CONTAINER_WIDTH_MAX,
        styleContainer: {}
    });
    const graphData = (0, $bGkwn.getOverviewGraphData)({
        chartData: chartData,
        dataIndexes: dataIndexes,
        listMapper: listMapper,
        sellMapper: sellMapper
    });
    const countColumns = graphData.xAxisLabels.length;
    const widthGraphContent = countColumns * MINIMUM_COLUMN_WIDTH_IN_PIXELS;
    (0, $acw62.useEffect)(()=>{
        const handleResize = (e)=>(0, $ivaD7.setStateData)("windowWidth", e.target.innerWidth, setState);
        window.addEventListener("resize", handleResize, true);
        return ()=>window.removeEventListener("resize", handleResize, true);
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (widthGraphContent <= window.innerWidth) setState((prevState)=>({
                ...prevState,
                widthGraph: CONTAINER_WIDTH_MAX,
                styleContainer: {
                    maxWidth: CONTAINER_WIDTH_MAX
                }
            }));
        else setState((prevState)=>({
                ...prevState,
                widthGraph: widthGraphContent.toString(),
                styleContainer: {
                    maxWidth: "none"
                }
            }));
    }, [
        widthGraphContent
    ]);
    const dataPointGroups = [
        {
            name: (0, $cstaF.agentProductionTerms).listSideSold,
            data: graphData.listSideSoldValues
        },
        {
            name: (0, $cstaF.agentProductionTerms).sellSideSold,
            data: graphData.sellSideSoldValues
        }
    ];
    const colors = [
        (0, $jUjGS.COLOR_PRIMARY_GREEN),
        (0, $jUjGS.COLOR_SECONDARY_GREEN)
    ];
    const fontFamily = '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"';
    const getToolTipHeader = (dataPointIndex, graphInfo)=>{
        const labelColumnXAxis = graphInfo.globals.labels[dataPointIndex];
        const dateColumn = (0, $g3CkB.OverviewGraphLabelMaker).getDateMonthFromGraphLabel(labelColumnXAxis);
        return (0, $htzEo.getFormattedDate)(dateColumn, "MMMM yyyy");
    };
    const getTooltipContent = (series, dataPointIndex, graphInfo)=>{
        const amountList = series[0][dataPointIndex];
        const amountSell = series[1][dataPointIndex];
        const tooltipHeader = getToolTipHeader(dataPointIndex, graphInfo);
        return `<div class='arrow_box volume-chart-tooltip'>
		<div class='header'> 
			${tooltipHeader}
		</div> 
		<div class='body'>
			<div class='items'>
				<span class='bullet' style='background-color: ${0, $jUjGS.COLOR_SECONDARY_GREEN}'></span> 
					${dataPointFormatter(amountSell)} <br />
				<span class='bullet' style='background-color: ${0, $jUjGS.COLOR_PRIMARY_GREEN}'></span> 
					${dataPointFormatter(amountList)}
			</div>
		 	<div class='total'>Total: ${dataPointFormatter(amountSell + amountList)}</div>
			</div>
		</div>`;
    };
    const getColumnLabel = (graphMode, dataPointIndex)=>{
        let value, formatter;
        if (graphMode === (0, $bGkwn.chartModes).UNITS) {
            value = graphData?.formattedData[dataPointIndex].totalUnits;
            formatter = (0, $htzEo.getUngroupedMax1Decimals);
        } else {
            value = graphData?.formattedData[dataPointIndex].totalVolume;
            formatter = (0, $htzEo.getCompactDollars);
        }
        if (value === 0) return "";
        return formatter(value);
    };
    const getChartOptions = (isPDF)=>({
            chart: {
                animations: {
                    enabled: false
                },
                type: "bar",
                stacked: true,
                toolbar: {
                    show: false
                },
                fontFamily: fontFamily,
                noData: {
                    text: (0, $cstaF.agentProductionTerms).noDataForSelectedAgent
                },
                zoom: {
                    enabled: false
                },
                events: {
                    dataPointSelection: (event, chartContext, config)=>{
                        const selectedChartIndex = config.dataPointIndex;
                        handleClickChartGraph(config.w.globals.labels[selectedChartIndex]);
                    },
                    dataPointMouseEnter: (0, $7jSpM.dataPointMouseOverStyler)
                }
            },
            responsive: [
                {
                    breakpoint: 480,
                    options: {
                        legend: {
                            position: "left",
                            offsetX: -10,
                            offsetY: 0
                        }
                    }
                }
            ],
            plotOptions: {
                bar: {
                    horizontal: false,
                    borderRadius: 1,
                    columnWidth: "40px",
                    dataLabels: {
                        position: "top",
                        hideOverflowingLabels: false
                    }
                }
            },
            dataLabels: {
                enabled: isShowColumnLabels,
                enabledOnSeries: [
                    1
                ],
                textAnchor: "middle",
                formatter: (_, { dataPointIndex: dataPointIndex })=>getColumnLabel(graphMode, dataPointIndex),
                style: {
                    fontSize: isPDF ? "20px" : undefined,
                    fontFamily: "Helvetica, Arial, sans-serif",
                    fontWeight: "bold",
                    colors: [
                        "#212529"
                    ]
                },
                offsetY: -30
            },
            xaxis: {
                type: "category",
                categories: graphData.xAxisLabels,
                labels: {
                    style: {
                        fontSize: isPDF ? "20px" : undefined,
                        colors: isPDF ? "#000" : "#6B7280",
                        capitalize: true
                    }
                }
            },
            yaxis: {
                tickAmount: countYAxisTicks,
                labels: {
                    formatter: yAxisFormatter,
                    style: {
                        fontWeight: 400,
                        fontSize: isPDF ? "20px" : undefined,
                        colors: isPDF ? "#000" : "#6B7280"
                    }
                },
                title: {
                    text: yAxisTitle,
                    style: {
                        fontSize: "24px",
                        fontWeight: "normal"
                    },
                    offsetX: -5
                }
            },
            tooltip: {
                custom: ({ series: series, dataPointIndex: dataPointIndex, w: graphInfo })=>{
                    return getTooltipContent(series, dataPointIndex, graphInfo);
                }
            },
            legend: {
                markers: {
                    fillColors: colors,
                    width: 15,
                    height: 15,
                    radius: 10
                },
                fontFamily: fontFamily,
                itemMargin: {
                    horizontal: 10
                },
                onItemClick: {
                    toggleDataSeries: false
                },
                position: "top",
                offsetX: 0,
                horizontalAlign: "left",
                fontSize: "16px"
            },
            fill: {
                opacity: 1,
                colors: colors
            }
        });
    const isShowEmptyState = chartData === undefined;
    const classContainer = state.widthGraph === CONTAINER_WIDTH_MAX ? "" : "tableOverflow";
    const chartProps = {
        options: getChartOptions(),
        series: dataPointGroups,
        type: "bar",
        height: 500,
        width: state.widthGraph
    };
    const pdfChartProps = {
        ...chartProps,
        options: getChartOptions(isPDFLoading)
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: state.styleContainer,
        className: classContainer,
        children: isShowEmptyState ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "mt-3",
            children: (0, $cstaF.agentProductionTerms).searchReturnedNoResults
        }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    id: "production-chart-graph",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3r6bj))), {
                        ...chartProps
                    })
                }),
                isPDFLoading && currentTabIndex === (0, $eHBjM.agentProfileTabs).PRODUCTION && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "pdf-chart-agent-profile chart-capture-area",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3r6bj))), {
                        ...pdfChartProps
                    })
                })
            ]
        })
    });
};
$12a8c5c0cefe2a33$export$fa8aea0387ad4ea.propTypes = {
    chartData: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    countYAxisTicks: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    currentTabIndex: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    dataIndexes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    dataPointFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    graphMode: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    handleClickChartGraph: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    isShowColumnLabels: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    listMapper: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    sellMapper: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    timePeriod: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    yAxisFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    yAxisTitle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};

});
parcelRegister("3r6bj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: !0
});
var $2808b0382c8a2798$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
    return typeof e;
} : function(e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
}, $2808b0382c8a2798$var$_extends = Object.assign || function(e) {
    for(var t = 1; t < arguments.length; t++){
        var r = arguments[t];
        for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
}, $2808b0382c8a2798$var$_createClass = function() {
    function n(e, t) {
        for(var r = 0; r < t.length; r++){
            var n = t[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
        }
    }
    return function(e, t, r) {
        return t && n(e.prototype, t), r && n(e, r), e;
    };
}();

var $fIdQt = parcelRequire("fIdQt");
var $2808b0382c8a2798$var$_apexcharts2 = $2808b0382c8a2798$var$_interopRequireDefault($fIdQt);

var $acw62 = parcelRequire("acw62");
var $2808b0382c8a2798$var$_react2 = $2808b0382c8a2798$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");
var $2808b0382c8a2798$var$_propTypes2 = $2808b0382c8a2798$var$_interopRequireDefault($c9Z8w);
function $2808b0382c8a2798$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function $2808b0382c8a2798$var$_defineProperty(e, t, r) {
    return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = r, e;
}
function $2808b0382c8a2798$var$_objectWithoutProperties(e, t) {
    var r = {};
    for(var n in e)0 <= t.indexOf(n) || Object.prototype.hasOwnProperty.call(e, n) && (r[n] = e[n]);
    return r;
}
function $2808b0382c8a2798$var$_classCallCheck(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function $2808b0382c8a2798$var$_possibleConstructorReturn(e, t) {
    if (!e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !t || "object" != typeof t && "function" != typeof t ? e : t;
}
function $2808b0382c8a2798$var$_inherits(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
        constructor: {
            value: e,
            enumerable: !1,
            writable: !0,
            configurable: !0
        }
    }), t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t);
}
window.ApexCharts = $2808b0382c8a2798$var$_apexcharts2.default;
var $2808b0382c8a2798$var$Charts = function() {
    function r(e) {
        $2808b0382c8a2798$var$_classCallCheck(this, r);
        var t = $2808b0382c8a2798$var$_possibleConstructorReturn(this, (r.__proto__ || Object.getPrototypeOf(r)).call(this, e));
        return $2808b0382c8a2798$var$_react2.default.createRef ? t.chartRef = $2808b0382c8a2798$var$_react2.default.createRef() : t.setRef = function(e) {
            return t.chartRef = e;
        }, t.chart = null, t;
    }
    return $2808b0382c8a2798$var$_inherits(r, $acw62.Component), $2808b0382c8a2798$var$_createClass(r, [
        {
            key: "render",
            value: function() {
                var e = $2808b0382c8a2798$var$_objectWithoutProperties(this.props, []);
                return $2808b0382c8a2798$var$_react2.default.createElement("div", $2808b0382c8a2798$var$_extends({
                    ref: $2808b0382c8a2798$var$_react2.default.createRef ? this.chartRef : this.setRef
                }, e));
            }
        },
        {
            key: "componentDidMount",
            value: function() {
                var e = $2808b0382c8a2798$var$_react2.default.createRef ? this.chartRef.current : this.chartRef;
                this.chart = new $2808b0382c8a2798$var$_apexcharts2.default(e, this.getConfig()), this.chart.render();
            }
        },
        {
            key: "getConfig",
            value: function() {
                var e = this.props, t = e.type, r = e.height, n = e.width, o = e.series, i = e.options, a = {
                    chart: {
                        type: t,
                        height: r,
                        width: n
                    },
                    series: o
                };
                return this.extend(i, a);
            }
        },
        {
            key: "isObject",
            value: function(e) {
                return e && "object" === (void 0 === e ? "undefined" : $2808b0382c8a2798$var$_typeof(e)) && !Array.isArray(e) && null != e;
            }
        },
        {
            key: "extend",
            value: function(t, r) {
                var n = this;
                "function" != typeof Object.assign && (Object.assign = function(e) {
                    if (null == e) throw new TypeError("Cannot convert undefined or null to object");
                    for(var t = Object(e), r = 1; r < arguments.length; r++){
                        var n = arguments[r];
                        if (null != n) for(var o in n)n.hasOwnProperty(o) && (t[o] = n[o]);
                    }
                    return t;
                });
                var o = Object.assign({}, t);
                return this.isObject(t) && this.isObject(r) && Object.keys(r).forEach(function(e) {
                    n.isObject(r[e]) && e in t ? o[e] = n.extend(t[e], r[e]) : Object.assign(o, $2808b0382c8a2798$var$_defineProperty({}, e, r[e]));
                }), o;
            }
        },
        {
            key: "componentDidUpdate",
            value: function(e) {
                if (!this.chart) return null;
                var t = this.props, r = t.options, n = t.series, o = t.height, i = t.width, a = JSON.stringify(e.options), s = JSON.stringify(e.series), c = JSON.stringify(r), u = JSON.stringify(n);
                a === c && s === u && o === e.height && i === e.width || (s === u ? this.chart.updateOptions(this.getConfig()) : a === c && o === e.height && i === e.width ? this.chart.updateSeries(n) : this.chart.updateOptions(this.getConfig()));
            }
        },
        {
            key: "componentWillUnmount",
            value: function() {
                this.chart && "function" == typeof this.chart.destroy && this.chart.destroy();
            }
        }
    ]), r;
}();
(module.exports.default = $2808b0382c8a2798$var$Charts).propTypes = {
    type: $2808b0382c8a2798$var$_propTypes2.default.string.isRequired,
    width: $2808b0382c8a2798$var$_propTypes2.default.any,
    height: $2808b0382c8a2798$var$_propTypes2.default.any,
    series: $2808b0382c8a2798$var$_propTypes2.default.array.isRequired,
    options: $2808b0382c8a2798$var$_propTypes2.default.object.isRequired
}, $2808b0382c8a2798$var$Charts.defaultProps = {
    type: "line",
    width: "100%",
    height: "auto"
};

});
parcelRegister("fIdQt", function(module, exports) {
/*!
 * ApexCharts v3.33.1
 * (c) 2018-2022 ApexCharts
 * Released under the MIT License.
 */ "use strict";
function $b705b473d3ec9641$var$t(t, e) {
    var i = Object.keys(t);
    if (Object.getOwnPropertySymbols) {
        var a = Object.getOwnPropertySymbols(t);
        e && (a = a.filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        })), i.push.apply(i, a);
    }
    return i;
}
function $b705b473d3ec9641$var$e(e) {
    for(var i = 1; i < arguments.length; i++){
        var a = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $b705b473d3ec9641$var$t(Object(a), !0).forEach(function(t) {
            $b705b473d3ec9641$var$o(e, t, a[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(a)) : $b705b473d3ec9641$var$t(Object(a)).forEach(function(t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(a, t));
        });
    }
    return e;
}
function $b705b473d3ec9641$var$i(t) {
    return ($b705b473d3ec9641$var$i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
        return typeof t;
    } : function(t) {
        return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
    })(t);
}
function $b705b473d3ec9641$var$a(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function $b705b473d3ec9641$var$s(t, e) {
    for(var i = 0; i < e.length; i++){
        var a = e[i];
        a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(t, a.key, a);
    }
}
function $b705b473d3ec9641$var$r(t, e, i) {
    return e && $b705b473d3ec9641$var$s(t.prototype, e), i && $b705b473d3ec9641$var$s(t, i), t;
}
function $b705b473d3ec9641$var$o(t, e, i) {
    return e in t ? Object.defineProperty(t, e, {
        value: i,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : t[e] = i, t;
}
function $b705b473d3ec9641$var$n(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), e && $b705b473d3ec9641$var$h(t, e);
}
function $b705b473d3ec9641$var$l(t) {
    return ($b705b473d3ec9641$var$l = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    })(t);
}
function $b705b473d3ec9641$var$h(t, e) {
    return ($b705b473d3ec9641$var$h = Object.setPrototypeOf || function(t, e) {
        return t.__proto__ = e, t;
    })(t, e);
}
function $b705b473d3ec9641$var$c(t, e) {
    if (e && ("object" == typeof e || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return function(t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
    }(t);
}
function $b705b473d3ec9641$var$d(t) {
    var e = function() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
        } catch (t) {
            return !1;
        }
    }();
    return function() {
        var i, a = $b705b473d3ec9641$var$l(t);
        if (e) {
            var s = $b705b473d3ec9641$var$l(this).constructor;
            i = Reflect.construct(a, arguments, s);
        } else i = a.apply(this, arguments);
        return $b705b473d3ec9641$var$c(this, i);
    };
}
function $b705b473d3ec9641$var$g(t) {
    return function(t) {
        if (Array.isArray(t)) return $b705b473d3ec9641$var$u(t);
    }(t) || function(t) {
        if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
    }(t) || function(t, e) {
        if (!t) return;
        if ("string" == typeof t) return $b705b473d3ec9641$var$u(t, e);
        var i = Object.prototype.toString.call(t).slice(8, -1);
        "Object" === i && t.constructor && (i = t.constructor.name);
        if ("Map" === i || "Set" === i) return Array.from(t);
        if ("Arguments" === i || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)) return $b705b473d3ec9641$var$u(t, e);
    }(t) || function() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }();
}
function $b705b473d3ec9641$var$u(t, e) {
    (null == e || e > t.length) && (e = t.length);
    for(var i = 0, a = new Array(e); i < e; i++)a[i] = t[i];
    return a;
}
var $b705b473d3ec9641$var$p = function() {
    function t() {
        $b705b473d3ec9641$var$a(this, t);
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "shadeRGBColor",
            value: function(t, e) {
                var i = e.split(","), a = t < 0 ? 0 : 255, s = t < 0 ? -1 * t : t, r = parseInt(i[0].slice(4), 10), o = parseInt(i[1], 10), n = parseInt(i[2], 10);
                return "rgb(" + (Math.round((a - r) * s) + r) + "," + (Math.round((a - o) * s) + o) + "," + (Math.round((a - n) * s) + n) + ")";
            }
        },
        {
            key: "shadeHexColor",
            value: function(t, e) {
                var i = parseInt(e.slice(1), 16), a = t < 0 ? 0 : 255, s = t < 0 ? -1 * t : t, r = i >> 16, o = i >> 8 & 255, n = 255 & i;
                return "#" + (16777216 + 65536 * (Math.round((a - r) * s) + r) + 256 * (Math.round((a - o) * s) + o) + (Math.round((a - n) * s) + n)).toString(16).slice(1);
            }
        },
        {
            key: "shadeColor",
            value: function(e, i) {
                return t.isColorHex(i) ? this.shadeHexColor(e, i) : this.shadeRGBColor(e, i);
            }
        }
    ], [
        {
            key: "bind",
            value: function(t, e) {
                return function() {
                    return t.apply(e, arguments);
                };
            }
        },
        {
            key: "isObject",
            value: function(t) {
                return t && "object" === $b705b473d3ec9641$var$i(t) && !Array.isArray(t) && null != t;
            }
        },
        {
            key: "is",
            value: function(t, e) {
                return Object.prototype.toString.call(e) === "[object " + t + "]";
            }
        },
        {
            key: "listToArray",
            value: function(t) {
                var e, i = [];
                for(e = 0; e < t.length; e++)i[e] = t[e];
                return i;
            }
        },
        {
            key: "extend",
            value: function(t, e) {
                var i = this;
                "function" != typeof Object.assign && (Object.assign = function(t) {
                    if (null == t) throw new TypeError("Cannot convert undefined or null to object");
                    for(var e = Object(t), i = 1; i < arguments.length; i++){
                        var a = arguments[i];
                        if (null != a) for(var s in a)a.hasOwnProperty(s) && (e[s] = a[s]);
                    }
                    return e;
                });
                var a = Object.assign({}, t);
                return this.isObject(t) && this.isObject(e) && Object.keys(e).forEach(function(s) {
                    i.isObject(e[s]) && s in t ? a[s] = i.extend(t[s], e[s]) : Object.assign(a, $b705b473d3ec9641$var$o({}, s, e[s]));
                }), a;
            }
        },
        {
            key: "extendArray",
            value: function(e, i) {
                var a = [];
                return e.map(function(e) {
                    a.push(t.extend(i, e));
                }), e = a;
            }
        },
        {
            key: "monthMod",
            value: function(t) {
                return t % 12;
            }
        },
        {
            key: "clone",
            value: function(e) {
                if (t.is("Array", e)) {
                    for(var a = [], s = 0; s < e.length; s++)a[s] = this.clone(e[s]);
                    return a;
                }
                if (t.is("Null", e)) return null;
                if (t.is("Date", e)) return e;
                if ("object" === $b705b473d3ec9641$var$i(e)) {
                    var r = {};
                    for(var o in e)e.hasOwnProperty(o) && (r[o] = this.clone(e[o]));
                    return r;
                }
                return e;
            }
        },
        {
            key: "log10",
            value: function(t) {
                return Math.log(t) / Math.LN10;
            }
        },
        {
            key: "roundToBase10",
            value: function(t) {
                return Math.pow(10, Math.floor(Math.log10(t)));
            }
        },
        {
            key: "roundToBase",
            value: function(t, e) {
                return Math.pow(e, Math.floor(Math.log(t) / Math.log(e)));
            }
        },
        {
            key: "parseNumber",
            value: function(t) {
                return null === t ? t : parseFloat(t);
            }
        },
        {
            key: "randomId",
            value: function() {
                return (Math.random() + 1).toString(36).substring(4);
            }
        },
        {
            key: "noExponents",
            value: function(t) {
                var e = String(t).split(/[eE]/);
                if (1 === e.length) return e[0];
                var i = "", a = t < 0 ? "-" : "", s = e[0].replace(".", ""), r = Number(e[1]) + 1;
                if (r < 0) {
                    for(i = a + "0."; r++;)i += "0";
                    return i + s.replace(/^-/, "");
                }
                for(r -= s.length; r--;)i += "0";
                return s + i;
            }
        },
        {
            key: "getDimensions",
            value: function(t) {
                var e = getComputedStyle(t, null), i = t.clientHeight, a = t.clientWidth;
                return i -= parseFloat(e.paddingTop) + parseFloat(e.paddingBottom), [
                    a -= parseFloat(e.paddingLeft) + parseFloat(e.paddingRight),
                    i
                ];
            }
        },
        {
            key: "getBoundingClientRect",
            value: function(t) {
                var e = t.getBoundingClientRect();
                return {
                    top: e.top,
                    right: e.right,
                    bottom: e.bottom,
                    left: e.left,
                    width: t.clientWidth,
                    height: t.clientHeight,
                    x: e.left,
                    y: e.top
                };
            }
        },
        {
            key: "getLargestStringFromArr",
            value: function(t) {
                return t.reduce(function(t, e) {
                    return Array.isArray(e) && (e = e.reduce(function(t, e) {
                        return t.length > e.length ? t : e;
                    })), t.length > e.length ? t : e;
                }, 0);
            }
        },
        {
            key: "hexToRgba",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "#999999", e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : .6;
                "#" !== t.substring(0, 1) && (t = "#999999");
                var i = t.replace("#", "");
                i = i.match(new RegExp("(.{" + i.length / 3 + "})", "g"));
                for(var a = 0; a < i.length; a++)i[a] = parseInt(1 === i[a].length ? i[a] + i[a] : i[a], 16);
                return void 0 !== e && i.push(e), "rgba(" + i.join(",") + ")";
            }
        },
        {
            key: "getOpacityFromRGBA",
            value: function(t) {
                return parseFloat(t.replace(/^.*,(.+)\)/, "$1"));
            }
        },
        {
            key: "rgb2hex",
            value: function(t) {
                return (t = t.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i)) && 4 === t.length ? "#" + ("0" + parseInt(t[1], 10).toString(16)).slice(-2) + ("0" + parseInt(t[2], 10).toString(16)).slice(-2) + ("0" + parseInt(t[3], 10).toString(16)).slice(-2) : "";
            }
        },
        {
            key: "isColorHex",
            value: function(t) {
                return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)|(^#[0-9A-F]{8}$)/i.test(t);
            }
        },
        {
            key: "getPolygonPos",
            value: function(t, e) {
                for(var i = [], a = 2 * Math.PI / e, s = 0; s < e; s++){
                    var r = {};
                    r.x = t * Math.sin(s * a), r.y = -t * Math.cos(s * a), i.push(r);
                }
                return i;
            }
        },
        {
            key: "polarToCartesian",
            value: function(t, e, i, a) {
                var s = (a - 90) * Math.PI / 180;
                return {
                    x: t + i * Math.cos(s),
                    y: e + i * Math.sin(s)
                };
            }
        },
        {
            key: "escapeString",
            value: function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "x", i = t.toString().slice();
                return i = i.replace(/[` ~!@#$%^&*()_|+\-=?;:'",.<>{}[\]\\/]/gi, e);
            }
        },
        {
            key: "negToZero",
            value: function(t) {
                return t < 0 ? 0 : t;
            }
        },
        {
            key: "moveIndexInArray",
            value: function(t, e, i) {
                if (i >= t.length) for(var a = i - t.length + 1; a--;)t.push(void 0);
                return t.splice(i, 0, t.splice(e, 1)[0]), t;
            }
        },
        {
            key: "extractNumber",
            value: function(t) {
                return parseFloat(t.replace(/[^\d.]*/g, ""));
            }
        },
        {
            key: "findAncestor",
            value: function(t, e) {
                for(; (t = t.parentElement) && !t.classList.contains(e););
                return t;
            }
        },
        {
            key: "setELstyles",
            value: function(t, e) {
                for(var i in e)e.hasOwnProperty(i) && (t.style.key = e[i]);
            }
        },
        {
            key: "isNumber",
            value: function(t) {
                return !isNaN(t) && parseFloat(Number(t)) === t && !isNaN(parseInt(t, 10));
            }
        },
        {
            key: "isFloat",
            value: function(t) {
                return Number(t) === t && t % 1 != 0;
            }
        },
        {
            key: "isSafari",
            value: function() {
                return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            }
        },
        {
            key: "isFirefox",
            value: function() {
                return navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
            }
        },
        {
            key: "isIE11",
            value: function() {
                if (-1 !== window.navigator.userAgent.indexOf("MSIE") || window.navigator.appVersion.indexOf("Trident/") > -1) return !0;
            }
        },
        {
            key: "isIE",
            value: function() {
                var t = window.navigator.userAgent, e = t.indexOf("MSIE ");
                if (e > 0) return parseInt(t.substring(e + 5, t.indexOf(".", e)), 10);
                if (t.indexOf("Trident/") > 0) {
                    var i = t.indexOf("rv:");
                    return parseInt(t.substring(i + 3, t.indexOf(".", i)), 10);
                }
                var a = t.indexOf("Edge/");
                return a > 0 && parseInt(t.substring(a + 5, t.indexOf(".", a)), 10);
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$f = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.ctx = e, this.w = e.w, this.setEasingFunctions();
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "setEasingFunctions",
            value: function() {
                var t;
                if (!this.w.globals.easing) {
                    switch(this.w.config.chart.animations.easing){
                        case "linear":
                            t = "-";
                            break;
                        case "easein":
                            t = "<";
                            break;
                        case "easeout":
                            t = ">";
                            break;
                        case "easeinout":
                            t = "<>";
                            break;
                        case "swing":
                            t = function(t) {
                                var e = 1.70158;
                                return (t -= 1) * t * ((e + 1) * t + e) + 1;
                            };
                            break;
                        case "bounce":
                            t = function(t) {
                                return t < 1 / 2.75 ? 7.5625 * t * t : t < 2 / 2.75 ? 7.5625 * (t -= 1.5 / 2.75) * t + .75 : t < 2.5 / 2.75 ? 7.5625 * (t -= 2.25 / 2.75) * t + .9375 : 7.5625 * (t -= 2.625 / 2.75) * t + .984375;
                            };
                            break;
                        case "elastic":
                            t = function(t) {
                                return t === !!t ? t : Math.pow(2, -10 * t) * Math.sin((t - .075) * (2 * Math.PI) / .3) + 1;
                            };
                            break;
                        default:
                            t = "<>";
                    }
                    this.w.globals.easing = t;
                }
            }
        },
        {
            key: "animateLine",
            value: function(t, e, i, a) {
                t.attr(e).animate(a).attr(i);
            }
        },
        {
            key: "animateMarker",
            value: function(t, e, i, a, s, r) {
                e || (e = 0), t.attr({
                    r: e,
                    width: e,
                    height: e
                }).animate(a, s).attr({
                    r: i,
                    width: i.width,
                    height: i.height
                }).afterAll(function() {
                    r();
                });
            }
        },
        {
            key: "animateCircle",
            value: function(t, e, i, a, s) {
                t.attr({
                    r: e.r,
                    cx: e.cx,
                    cy: e.cy
                }).animate(a, s).attr({
                    r: i.r,
                    cx: i.cx,
                    cy: i.cy
                });
            }
        },
        {
            key: "animateRect",
            value: function(t, e, i, a, s) {
                t.attr(e).animate(a).attr(i).afterAll(function() {
                    return s();
                });
            }
        },
        {
            key: "animatePathsGradually",
            value: function(t) {
                var e = t.el, i = t.realIndex, a = t.j, s = t.fill, r = t.pathFrom, o = t.pathTo, n = t.speed, l = t.delay, h = this.w, c = 0;
                h.config.chart.animations.animateGradually.enabled && (c = h.config.chart.animations.animateGradually.delay), h.config.chart.animations.dynamicAnimation.enabled && h.globals.dataChanged && "bar" !== h.config.chart.type && (c = 0), this.morphSVG(e, i, a, "line" !== h.config.chart.type || h.globals.comboCharts ? s : "stroke", r, o, n, l * c);
            }
        },
        {
            key: "showDelayedElements",
            value: function() {
                this.w.globals.delayedElements.forEach(function(t) {
                    t.el.classList.remove("apexcharts-element-hidden");
                });
            }
        },
        {
            key: "animationCompleted",
            value: function(t) {
                var e = this.w;
                e.globals.animationEnded || (e.globals.animationEnded = !0, this.showDelayedElements(), "function" == typeof e.config.chart.events.animationEnd && e.config.chart.events.animationEnd(this.ctx, {
                    el: t,
                    w: e
                }));
            }
        },
        {
            key: "morphSVG",
            value: function(t, e, i, a, s, r, o, n) {
                var l = this, h = this.w;
                s || (s = t.attr("pathFrom")), r || (r = t.attr("pathTo"));
                var c = function(t) {
                    return "radar" === h.config.chart.type && (o = 1), "M 0 ".concat(h.globals.gridHeight);
                };
                (!s || s.indexOf("undefined") > -1 || s.indexOf("NaN") > -1) && (s = c()), (!r || r.indexOf("undefined") > -1 || r.indexOf("NaN") > -1) && (r = c()), h.globals.shouldAnimate || (o = 1), t.plot(s).animate(1, h.globals.easing, n).plot(s).animate(o, h.globals.easing, n).plot(r).afterAll(function() {
                    $b705b473d3ec9641$var$p.isNumber(i) ? i === h.globals.series[h.globals.maxValsInArrayIndex].length - 2 && h.globals.shouldAnimate && l.animationCompleted(t) : "none" !== a && h.globals.shouldAnimate && (!h.globals.comboCharts && e === h.globals.series.length - 1 || h.globals.comboCharts) && l.animationCompleted(t), l.showDelayedElements();
                });
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$x = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "getDefaultFilter",
            value: function(t, e) {
                var i = this.w;
                t.unfilter(!0), (new window.SVG.Filter).size("120%", "180%", "-5%", "-40%"), "none" !== i.config.states.normal.filter ? this.applyFilter(t, e, i.config.states.normal.filter.type, i.config.states.normal.filter.value) : i.config.chart.dropShadow.enabled && this.dropShadow(t, i.config.chart.dropShadow, e);
            }
        },
        {
            key: "addNormalFilter",
            value: function(t, e) {
                var i = this.w;
                i.config.chart.dropShadow.enabled && !t.node.classList.contains("apexcharts-marker") && this.dropShadow(t, i.config.chart.dropShadow, e);
            }
        },
        {
            key: "addLightenFilter",
            value: function(t, e, i) {
                var a = this, s = this.w, r = i.intensity;
                t.unfilter(!0);
                new window.SVG.Filter;
                t.filter(function(t) {
                    var i = s.config.chart.dropShadow;
                    (i.enabled ? a.addShadow(t, e, i) : t).componentTransfer({
                        rgb: {
                            type: "linear",
                            slope: 1.5,
                            intercept: r
                        }
                    });
                }), t.filterer.node.setAttribute("filterUnits", "userSpaceOnUse"), this._scaleFilterSize(t.filterer.node);
            }
        },
        {
            key: "addDarkenFilter",
            value: function(t, e, i) {
                var a = this, s = this.w, r = i.intensity;
                t.unfilter(!0);
                new window.SVG.Filter;
                t.filter(function(t) {
                    var i = s.config.chart.dropShadow;
                    (i.enabled ? a.addShadow(t, e, i) : t).componentTransfer({
                        rgb: {
                            type: "linear",
                            slope: r
                        }
                    });
                }), t.filterer.node.setAttribute("filterUnits", "userSpaceOnUse"), this._scaleFilterSize(t.filterer.node);
            }
        },
        {
            key: "applyFilter",
            value: function(t, e, i) {
                var a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : .5;
                switch(i){
                    case "none":
                        this.addNormalFilter(t, e);
                        break;
                    case "lighten":
                        this.addLightenFilter(t, e, {
                            intensity: a
                        });
                        break;
                    case "darken":
                        this.addDarkenFilter(t, e, {
                            intensity: a
                        });
                }
            }
        },
        {
            key: "addShadow",
            value: function(t, e, i) {
                var a = i.blur, s = i.top, r = i.left, o = i.color, n = i.opacity, l = t.flood(Array.isArray(o) ? o[e] : o, n).composite(t.sourceAlpha, "in").offset(r, s).gaussianBlur(a).merge(t.source);
                return t.blend(t.source, l);
            }
        },
        {
            key: "dropShadow",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, a = e.top, s = e.left, r = e.blur, o = e.color, n = e.opacity, l = e.noUserSpaceOnUse, h = this.w;
                return t.unfilter(!0), $b705b473d3ec9641$var$p.isIE() && "radialBar" === h.config.chart.type || (o = Array.isArray(o) ? o[i] : o, t.filter(function(t) {
                    var e = null;
                    e = $b705b473d3ec9641$var$p.isSafari() || $b705b473d3ec9641$var$p.isFirefox() || $b705b473d3ec9641$var$p.isIE() ? t.flood(o, n).composite(t.sourceAlpha, "in").offset(s, a).gaussianBlur(r) : t.flood(o, n).composite(t.sourceAlpha, "in").offset(s, a).gaussianBlur(r).merge(t.source), t.blend(t.source, e);
                }), l || t.filterer.node.setAttribute("filterUnits", "userSpaceOnUse"), this._scaleFilterSize(t.filterer.node)), t;
            }
        },
        {
            key: "setSelectionFilter",
            value: function(t, e, i) {
                var a = this.w;
                if (void 0 !== a.globals.selectedDataPoints[e] && a.globals.selectedDataPoints[e].indexOf(i) > -1) {
                    t.node.setAttribute("selected", !0);
                    var s = a.config.states.active.filter;
                    "none" !== s && this.applyFilter(t, e, s.type, s.value);
                }
            }
        },
        {
            key: "_scaleFilterSize",
            value: function(t) {
                !function(e) {
                    for(var i in e)e.hasOwnProperty(i) && t.setAttribute(i, e[i]);
                }({
                    width: "200%",
                    height: "200%",
                    x: "-50%",
                    y: "-50%"
                });
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$b = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "drawLine",
            value: function(t, e, i, a) {
                var s = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : "#a8a8a8", r = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : 0, o = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : null, n = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : "butt", l = this.w, h = l.globals.dom.Paper.line().attr({
                    x1: t,
                    y1: e,
                    x2: i,
                    y2: a,
                    stroke: s,
                    "stroke-dasharray": r,
                    "stroke-width": o,
                    "stroke-linecap": n
                });
                return h;
            }
        },
        {
            key: "drawRect",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 0, a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0, s = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0, r = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : "#fefefe", o = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : 1, n = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : null, l = arguments.length > 8 && void 0 !== arguments[8] ? arguments[8] : null, h = arguments.length > 9 && void 0 !== arguments[9] ? arguments[9] : 0, c = this.w, d = c.globals.dom.Paper.rect();
                return d.attr({
                    x: t,
                    y: e,
                    width: i > 0 ? i : 0,
                    height: a > 0 ? a : 0,
                    rx: s,
                    ry: s,
                    opacity: o,
                    "stroke-width": null !== n ? n : 0,
                    stroke: null !== l ? l : "none",
                    "stroke-dasharray": h
                }), d.node.setAttribute("fill", r), d;
            }
        },
        {
            key: "drawPolygon",
            value: function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "#e1e1e1", i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 1, a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "none", s = this.w, r = s.globals.dom.Paper.polygon(t).attr({
                    fill: a,
                    stroke: e,
                    "stroke-width": i
                });
                return r;
            }
        },
        {
            key: "drawCircle",
            value: function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, i = this.w;
                t < 0 && (t = 0);
                var a = i.globals.dom.Paper.circle(2 * t);
                return null !== e && a.attr(e), a;
            }
        },
        {
            key: "drawPath",
            value: function(t) {
                var e = t.d, i = void 0 === e ? "" : e, a = t.stroke, s = void 0 === a ? "#a8a8a8" : a, r = t.strokeWidth, o = void 0 === r ? 1 : r, n = t.fill, l = t.fillOpacity, h = void 0 === l ? 1 : l, c = t.strokeOpacity, d = void 0 === c ? 1 : c, g = t.classes, u = t.strokeLinecap, p = void 0 === u ? null : u, f = t.strokeDashArray, x = void 0 === f ? 0 : f, b = this.w;
                return null === p && (p = b.config.stroke.lineCap), (i.indexOf("undefined") > -1 || i.indexOf("NaN") > -1) && (i = "M 0 ".concat(b.globals.gridHeight)), b.globals.dom.Paper.path(i).attr({
                    fill: n,
                    "fill-opacity": h,
                    stroke: s,
                    "stroke-opacity": d,
                    "stroke-linecap": p,
                    "stroke-width": o,
                    "stroke-dasharray": x,
                    class: g
                });
            }
        },
        {
            key: "group",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, e = this.w, i = e.globals.dom.Paper.group();
                return null !== t && i.attr(t), i;
            }
        },
        {
            key: "move",
            value: function(t, e) {
                var i = [
                    "M",
                    t,
                    e
                ].join(" ");
                return i;
            }
        },
        {
            key: "line",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, a = null;
                return null === i ? a = [
                    "L",
                    t,
                    e
                ].join(" ") : "H" === i ? a = [
                    "H",
                    t
                ].join(" ") : "V" === i && (a = [
                    "V",
                    e
                ].join(" ")), a;
            }
        },
        {
            key: "curve",
            value: function(t, e, i, a, s, r) {
                var o = [
                    "C",
                    t,
                    e,
                    i,
                    a,
                    s,
                    r
                ].join(" ");
                return o;
            }
        },
        {
            key: "quadraticCurve",
            value: function(t, e, i, a) {
                return [
                    "Q",
                    t,
                    e,
                    i,
                    a
                ].join(" ");
            }
        },
        {
            key: "arc",
            value: function(t, e, i, a, s, r, o) {
                var n = arguments.length > 7 && void 0 !== arguments[7] && arguments[7], l = "A";
                n && (l = "a");
                var h = [
                    l,
                    t,
                    e,
                    i,
                    a,
                    s,
                    r,
                    o
                ].join(" ");
                return h;
            }
        },
        {
            key: "renderPaths",
            value: function(t) {
                var i, a = t.j, s = t.realIndex, r = t.pathFrom, o = t.pathTo, n = t.stroke, l = t.strokeWidth, h = t.strokeLinecap, c = t.fill, d = t.animationDelay, g = t.initialSpeed, u = t.dataChangeSpeed, p = t.className, b = t.shouldClipToGrid, v = void 0 === b || b, m = t.bindEventsOnPaths, y = void 0 === m || m, w = t.drawShadow, k = void 0 === w || w, A = this.w, S = new $b705b473d3ec9641$var$x(this.ctx), C = new $b705b473d3ec9641$var$f(this.ctx), L = this.w.config.chart.animations.enabled, P = L && this.w.config.chart.animations.dynamicAnimation.enabled, T = !!(L && !A.globals.resized || P && A.globals.dataChanged && A.globals.shouldAnimate);
                T ? i = r : (i = o, A.globals.animationEnded = !0);
                var M = A.config.stroke.dashArray, I = 0;
                I = Array.isArray(M) ? M[s] : A.config.stroke.dashArray;
                var z = this.drawPath({
                    d: i,
                    stroke: n,
                    strokeWidth: l,
                    fill: c,
                    fillOpacity: 1,
                    classes: p,
                    strokeLinecap: h,
                    strokeDashArray: I
                });
                if (z.attr("index", s), v && z.attr({
                    "clip-path": "url(#gridRectMask".concat(A.globals.cuid, ")")
                }), "none" !== A.config.states.normal.filter.type) S.getDefaultFilter(z, s);
                else if (A.config.chart.dropShadow.enabled && k && (!A.config.chart.dropShadow.enabledOnSeries || A.config.chart.dropShadow.enabledOnSeries && -1 !== A.config.chart.dropShadow.enabledOnSeries.indexOf(s))) {
                    var X = A.config.chart.dropShadow;
                    S.dropShadow(z, X, s);
                }
                y && (z.node.addEventListener("mouseenter", this.pathMouseEnter.bind(this, z)), z.node.addEventListener("mouseleave", this.pathMouseLeave.bind(this, z)), z.node.addEventListener("mousedown", this.pathMouseDown.bind(this, z))), z.attr({
                    pathTo: o,
                    pathFrom: r
                });
                var E = {
                    el: z,
                    j: a,
                    realIndex: s,
                    pathFrom: r,
                    pathTo: o,
                    fill: c,
                    strokeWidth: l,
                    delay: d
                };
                return !L || A.globals.resized || A.globals.dataChanged ? !A.globals.resized && A.globals.dataChanged || C.showDelayedElements() : C.animatePathsGradually($b705b473d3ec9641$var$e($b705b473d3ec9641$var$e({}, E), {}, {
                    speed: g
                })), A.globals.dataChanged && P && T && C.animatePathsGradually($b705b473d3ec9641$var$e($b705b473d3ec9641$var$e({}, E), {}, {
                    speed: u
                })), z;
            }
        },
        {
            key: "drawPattern",
            value: function(t, e, i) {
                var a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : "#a8a8a8", s = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 0, r = this.w, o = r.globals.dom.Paper.pattern(e, i, function(r) {
                    "horizontalLines" === t ? r.line(0, 0, i, 0).stroke({
                        color: a,
                        width: s + 1
                    }) : "verticalLines" === t ? r.line(0, 0, 0, e).stroke({
                        color: a,
                        width: s + 1
                    }) : "slantedLines" === t ? r.line(0, 0, e, i).stroke({
                        color: a,
                        width: s
                    }) : "squares" === t ? r.rect(e, i).fill("none").stroke({
                        color: a,
                        width: s
                    }) : "circles" === t && r.circle(e).fill("none").stroke({
                        color: a,
                        width: s
                    });
                });
                return o;
            }
        },
        {
            key: "drawGradient",
            value: function(t, e, i, a, s) {
                var r, o = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : null, n = arguments.length > 6 && void 0 !== arguments[6] ? arguments[6] : null, l = arguments.length > 7 && void 0 !== arguments[7] ? arguments[7] : null, h = arguments.length > 8 && void 0 !== arguments[8] ? arguments[8] : 0, c = this.w;
                e.length < 9 && 0 === e.indexOf("#") && (e = $b705b473d3ec9641$var$p.hexToRgba(e, a)), i.length < 9 && 0 === i.indexOf("#") && (i = $b705b473d3ec9641$var$p.hexToRgba(i, s));
                var d = 0, g = 1, u = 1, f = null;
                null !== n && (d = void 0 !== n[0] ? n[0] / 100 : 0, g = void 0 !== n[1] ? n[1] / 100 : 1, u = void 0 !== n[2] ? n[2] / 100 : 1, f = void 0 !== n[3] ? n[3] / 100 : null);
                var x = !("donut" !== c.config.chart.type && "pie" !== c.config.chart.type && "polarArea" !== c.config.chart.type && "bubble" !== c.config.chart.type);
                if (r = null === l || 0 === l.length ? c.globals.dom.Paper.gradient(x ? "radial" : "linear", function(t) {
                    t.at(d, e, a), t.at(g, i, s), t.at(u, i, s), null !== f && t.at(f, e, a);
                }) : c.globals.dom.Paper.gradient(x ? "radial" : "linear", function(t) {
                    (Array.isArray(l[h]) ? l[h] : l).forEach(function(e) {
                        t.at(e.offset / 100, e.color, e.opacity);
                    });
                }), x) {
                    var b = c.globals.gridWidth / 2, v = c.globals.gridHeight / 2;
                    "bubble" !== c.config.chart.type ? r.attr({
                        gradientUnits: "userSpaceOnUse",
                        cx: b,
                        cy: v,
                        r: o
                    }) : r.attr({
                        cx: .5,
                        cy: .5,
                        r: .8,
                        fx: .2,
                        fy: .2
                    });
                } else "vertical" === t ? r.from(0, 0).to(0, 1) : "diagonal" === t ? r.from(0, 0).to(1, 1) : "horizontal" === t ? r.from(0, 1).to(1, 1) : "diagonal2" === t && r.from(1, 0).to(0, 1);
                return r;
            }
        },
        {
            key: "drawText",
            value: function(t) {
                var e, i = t.x, a = t.y, s = t.text, r = t.textAnchor, o = t.fontSize, n = t.fontFamily, l = t.fontWeight, h = t.foreColor, c = t.opacity, d = t.cssClass, g = void 0 === d ? "" : d, u = t.isPlainText, p = void 0 === u || u, f = this.w;
                return void 0 === s && (s = ""), r || (r = "start"), h && h.length || (h = f.config.chart.foreColor), n = n || f.config.chart.fontFamily, l = l || "regular", (e = Array.isArray(s) ? f.globals.dom.Paper.text(function(t) {
                    for(var e = 0; e < s.length; e++)0 === e ? t.tspan(s[e]) : t.tspan(s[e]).newLine();
                }) : p ? f.globals.dom.Paper.plain(s) : f.globals.dom.Paper.text(function(t) {
                    return t.tspan(s);
                })).attr({
                    x: i,
                    y: a,
                    "text-anchor": r,
                    "dominant-baseline": "auto",
                    "font-size": o,
                    "font-family": n,
                    "font-weight": l,
                    fill: h,
                    class: "apexcharts-text " + g
                }), e.node.style.fontFamily = n, e.node.style.opacity = c, e;
            }
        },
        {
            key: "drawMarker",
            value: function(t, e, i) {
                t = t || 0;
                var a = i.pSize || 0, s = null;
                if ("square" === i.shape || "rect" === i.shape) {
                    var r = void 0 === i.pRadius ? a / 2 : i.pRadius;
                    null !== e && a || (a = 0, r = 0);
                    var o = 1.2 * a + r, n = this.drawRect(o, o, o, o, r);
                    n.attr({
                        x: t - o / 2,
                        y: e - o / 2,
                        cx: t,
                        cy: e,
                        class: i.class ? i.class : "",
                        fill: i.pointFillColor,
                        "fill-opacity": i.pointFillOpacity ? i.pointFillOpacity : 1,
                        stroke: i.pointStrokeColor,
                        "stroke-width": i.pointStrokeWidth ? i.pointStrokeWidth : 0,
                        "stroke-opacity": i.pointStrokeOpacity ? i.pointStrokeOpacity : 1
                    }), s = n;
                } else "circle" !== i.shape && i.shape || ($b705b473d3ec9641$var$p.isNumber(e) || (a = 0, e = 0), s = this.drawCircle(a, {
                    cx: t,
                    cy: e,
                    class: i.class ? i.class : "",
                    stroke: i.pointStrokeColor,
                    fill: i.pointFillColor,
                    "fill-opacity": i.pointFillOpacity ? i.pointFillOpacity : 1,
                    "stroke-width": i.pointStrokeWidth ? i.pointStrokeWidth : 0,
                    "stroke-opacity": i.pointStrokeOpacity ? i.pointStrokeOpacity : 1
                }));
                return s;
            }
        },
        {
            key: "pathMouseEnter",
            value: function(t, e) {
                var i = this.w, a = new $b705b473d3ec9641$var$x(this.ctx), s = parseInt(t.node.getAttribute("index"), 10), r = parseInt(t.node.getAttribute("j"), 10);
                if ("function" == typeof i.config.chart.events.dataPointMouseEnter && i.config.chart.events.dataPointMouseEnter(e, this.ctx, {
                    seriesIndex: s,
                    dataPointIndex: r,
                    w: i
                }), this.ctx.events.fireEvent("dataPointMouseEnter", [
                    e,
                    this.ctx,
                    {
                        seriesIndex: s,
                        dataPointIndex: r,
                        w: i
                    }
                ]), ("none" === i.config.states.active.filter.type || "true" !== t.node.getAttribute("selected")) && "none" !== i.config.states.hover.filter.type && !i.globals.isTouchDevice) {
                    var o = i.config.states.hover.filter;
                    a.applyFilter(t, s, o.type, o.value);
                }
            }
        },
        {
            key: "pathMouseLeave",
            value: function(t, e) {
                var i = this.w, a = new $b705b473d3ec9641$var$x(this.ctx), s = parseInt(t.node.getAttribute("index"), 10), r = parseInt(t.node.getAttribute("j"), 10);
                "function" == typeof i.config.chart.events.dataPointMouseLeave && i.config.chart.events.dataPointMouseLeave(e, this.ctx, {
                    seriesIndex: s,
                    dataPointIndex: r,
                    w: i
                }), this.ctx.events.fireEvent("dataPointMouseLeave", [
                    e,
                    this.ctx,
                    {
                        seriesIndex: s,
                        dataPointIndex: r,
                        w: i
                    }
                ]), "none" !== i.config.states.active.filter.type && "true" === t.node.getAttribute("selected") || "none" !== i.config.states.hover.filter.type && a.getDefaultFilter(t, s);
            }
        },
        {
            key: "pathMouseDown",
            value: function(t, e) {
                var i = this.w, a = new $b705b473d3ec9641$var$x(this.ctx), s = parseInt(t.node.getAttribute("index"), 10), r = parseInt(t.node.getAttribute("j"), 10), o = "false";
                if ("true" === t.node.getAttribute("selected")) {
                    if (t.node.setAttribute("selected", "false"), i.globals.selectedDataPoints[s].indexOf(r) > -1) {
                        var n = i.globals.selectedDataPoints[s].indexOf(r);
                        i.globals.selectedDataPoints[s].splice(n, 1);
                    }
                } else {
                    if (!i.config.states.active.allowMultipleDataPointsSelection && i.globals.selectedDataPoints.length > 0) {
                        i.globals.selectedDataPoints = [];
                        var l = i.globals.dom.Paper.select(".apexcharts-series path").members, h = i.globals.dom.Paper.select(".apexcharts-series circle, .apexcharts-series rect").members, c = function(t) {
                            Array.prototype.forEach.call(t, function(t) {
                                t.node.setAttribute("selected", "false"), a.getDefaultFilter(t, s);
                            });
                        };
                        c(l), c(h);
                    }
                    t.node.setAttribute("selected", "true"), o = "true", void 0 === i.globals.selectedDataPoints[s] && (i.globals.selectedDataPoints[s] = []), i.globals.selectedDataPoints[s].push(r);
                }
                if ("true" === o) {
                    var d = i.config.states.active.filter;
                    "none" !== d && a.applyFilter(t, s, d.type, d.value);
                } else "none" !== i.config.states.active.filter.type && a.getDefaultFilter(t, s);
                "function" == typeof i.config.chart.events.dataPointSelection && i.config.chart.events.dataPointSelection(e, this.ctx, {
                    selectedDataPoints: i.globals.selectedDataPoints,
                    seriesIndex: s,
                    dataPointIndex: r,
                    w: i
                }), e && this.ctx.events.fireEvent("dataPointSelection", [
                    e,
                    this.ctx,
                    {
                        selectedDataPoints: i.globals.selectedDataPoints,
                        seriesIndex: s,
                        dataPointIndex: r,
                        w: i
                    }
                ]);
            }
        },
        {
            key: "rotateAroundCenter",
            value: function(t) {
                var e = {};
                return t && "function" == typeof t.getBBox && (e = t.getBBox()), {
                    x: e.x + e.width / 2,
                    y: e.y + e.height / 2
                };
            }
        },
        {
            key: "getTextRects",
            value: function(t, e, i, a) {
                var s = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4], r = this.w, o = this.drawText({
                    x: -200,
                    y: -200,
                    text: t,
                    textAnchor: "start",
                    fontSize: e,
                    fontFamily: i,
                    foreColor: "#fff",
                    opacity: 0
                });
                a && o.attr("transform", a), r.globals.dom.Paper.add(o);
                var n = o.bbox();
                return s || (n = o.node.getBoundingClientRect()), o.remove(), {
                    width: n.width,
                    height: n.height
                };
            }
        },
        {
            key: "placeTextWithEllipsis",
            value: function(t, e, i) {
                if ("function" == typeof t.getComputedTextLength && (t.textContent = e, e.length > 0 && t.getComputedTextLength() >= i / 1.1)) {
                    for(var a = e.length - 3; a > 0; a -= 3)if (t.getSubStringLength(0, a) <= i / 1.1) return void (t.textContent = e.substring(0, a) + "...");
                    t.textContent = ".";
                }
            }
        }
    ], [
        {
            key: "setAttrs",
            value: function(t, e) {
                for(var i in e)e.hasOwnProperty(i) && t.setAttribute(i, e[i]);
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$v = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.w = e.w, this.annoCtx = e;
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "setOrientations",
            value: function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, i = this.w;
                if ("vertical" === t.label.orientation) {
                    var a = null !== e ? e : 0, s = i.globals.dom.baseEl.querySelector(".apexcharts-xaxis-annotations .apexcharts-xaxis-annotation-label[rel='".concat(a, "']"));
                    if (null !== s) {
                        var r = s.getBoundingClientRect();
                        s.setAttribute("x", parseFloat(s.getAttribute("x")) - r.height + 4), "top" === t.label.position ? s.setAttribute("y", parseFloat(s.getAttribute("y")) + r.width) : s.setAttribute("y", parseFloat(s.getAttribute("y")) - r.width);
                        var o = this.annoCtx.graphics.rotateAroundCenter(s), n = o.x, l = o.y;
                        s.setAttribute("transform", "rotate(-90 ".concat(n, " ").concat(l, ")"));
                    }
                }
            }
        },
        {
            key: "addBackgroundToAnno",
            value: function(t, e) {
                var i = this.w;
                if (!t || void 0 === e.label.text || void 0 !== e.label.text && !String(e.label.text).trim()) return null;
                var a = i.globals.dom.baseEl.querySelector(".apexcharts-grid").getBoundingClientRect(), s = t.getBoundingClientRect(), r = e.label.style.padding.left, o = e.label.style.padding.right, n = e.label.style.padding.top, l = e.label.style.padding.bottom;
                "vertical" === e.label.orientation && (n = e.label.style.padding.left, l = e.label.style.padding.right, r = e.label.style.padding.top, o = e.label.style.padding.bottom);
                var h = s.left - a.left - r, c = s.top - a.top - n, d = this.annoCtx.graphics.drawRect(h - i.globals.barPadForNumericAxis, c, s.width + r + o, s.height + n + l, e.label.borderRadius, e.label.style.background, 1, e.label.borderWidth, e.label.borderColor, 0);
                return e.id && d.node.classList.add($b705b473d3ec9641$var$p.escapeString(e.id)), d;
            }
        },
        {
            key: "annotationsBackground",
            value: function() {
                var t = this, e = this.w, i = function(i, a, s) {
                    var r = e.globals.dom.baseEl.querySelector(".apexcharts-".concat(s, "-annotations .apexcharts-").concat(s, "-annotation-label[rel='").concat(a, "']"));
                    if (r) {
                        var o = r.parentNode, n = t.addBackgroundToAnno(r, i);
                        n && (o.insertBefore(n.node, r), i.label.mouseEnter && n.node.addEventListener("mouseenter", i.label.mouseEnter.bind(t, i)), i.label.mouseLeave && n.node.addEventListener("mouseleave", i.label.mouseLeave.bind(t, i)));
                    }
                };
                e.config.annotations.xaxis.map(function(t, e) {
                    i(t, e, "xaxis");
                }), e.config.annotations.yaxis.map(function(t, e) {
                    i(t, e, "yaxis");
                }), e.config.annotations.points.map(function(t, e) {
                    i(t, e, "point");
                });
            }
        },
        {
            key: "getStringX",
            value: function(t) {
                var e = this.w, i = t;
                e.config.xaxis.convertedCatToNumeric && e.globals.categoryLabels.length && (t = e.globals.categoryLabels.indexOf(t) + 1);
                var a = e.globals.labels.indexOf(t), s = e.globals.dom.baseEl.querySelector(".apexcharts-xaxis-texts-g text:nth-child(" + (a + 1) + ")");
                return s && (i = parseFloat(s.getAttribute("x"))), i;
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$m = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.w = e.w, this.annoCtx = e, this.invertAxis = this.annoCtx.invertAxis;
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "addXaxisAnnotation",
            value: function(t, e, i) {
                var a = this.w, s = this.invertAxis ? a.globals.minY : a.globals.minX, r = this.invertAxis ? a.globals.maxY : a.globals.maxX, o = this.invertAxis ? a.globals.yRange[0] : a.globals.xRange, n = (t.x - s) / (o / a.globals.gridWidth);
                this.annoCtx.inversedReversedAxis && (n = (r - t.x) / (o / a.globals.gridWidth));
                var l = t.label.text;
                "category" !== a.config.xaxis.type && !a.config.xaxis.convertedCatToNumeric || this.invertAxis || a.globals.dataFormatXNumeric || (n = this.annoCtx.helpers.getStringX(t.x));
                var h = t.strokeDashArray;
                if ($b705b473d3ec9641$var$p.isNumber(n)) {
                    if (null === t.x2 || void 0 === t.x2) {
                        var c = this.annoCtx.graphics.drawLine(n + t.offsetX, 0 + t.offsetY, n + t.offsetX, a.globals.gridHeight + t.offsetY, t.borderColor, h, t.borderWidth);
                        e.appendChild(c.node), t.id && c.node.classList.add(t.id);
                    } else {
                        var d = (t.x2 - s) / (o / a.globals.gridWidth);
                        if (this.annoCtx.inversedReversedAxis && (d = (r - t.x2) / (o / a.globals.gridWidth)), "category" !== a.config.xaxis.type && !a.config.xaxis.convertedCatToNumeric || this.invertAxis || a.globals.dataFormatXNumeric || (d = this.annoCtx.helpers.getStringX(t.x2)), d < n) {
                            var g = n;
                            n = d, d = g;
                        }
                        var u = this.annoCtx.graphics.drawRect(n + t.offsetX, 0 + t.offsetY, d - n, a.globals.gridHeight + t.offsetY, 0, t.fillColor, t.opacity, 1, t.borderColor, h);
                        u.node.classList.add("apexcharts-annotation-rect"), u.attr("clip-path", "url(#gridRectMask".concat(a.globals.cuid, ")")), e.appendChild(u.node), t.id && u.node.classList.add(t.id);
                    }
                    var f = "top" === t.label.position ? 4 : a.globals.gridHeight, x = this.annoCtx.graphics.getTextRects(l, parseFloat(t.label.style.fontSize)), b = this.annoCtx.graphics.drawText({
                        x: n + t.label.offsetX,
                        y: f + t.label.offsetY - ("vertical" === t.label.orientation ? "top" === t.label.position ? x.width / 2 - 12 : -x.width / 2 : 0),
                        text: l,
                        textAnchor: t.label.textAnchor,
                        fontSize: t.label.style.fontSize,
                        fontFamily: t.label.style.fontFamily,
                        fontWeight: t.label.style.fontWeight,
                        foreColor: t.label.style.color,
                        cssClass: "apexcharts-xaxis-annotation-label ".concat(t.label.style.cssClass, " ").concat(t.id ? t.id : "")
                    });
                    b.attr({
                        rel: i
                    }), e.appendChild(b.node), this.annoCtx.helpers.setOrientations(t, i);
                }
            }
        },
        {
            key: "drawXAxisAnnotations",
            value: function() {
                var t = this, e = this.w, i = this.annoCtx.graphics.group({
                    class: "apexcharts-xaxis-annotations"
                });
                return e.config.annotations.xaxis.map(function(e, a) {
                    t.addXaxisAnnotation(e, i.node, a);
                }), i;
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$y = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "getStackedSeriesTotals",
            value: function() {
                var t = this.w, e = [];
                if (0 === t.globals.series.length) return e;
                for(var i = 0; i < t.globals.series[t.globals.maxValsInArrayIndex].length; i++){
                    for(var a = 0, s = 0; s < t.globals.series.length; s++)void 0 !== t.globals.series[s][i] && (a += t.globals.series[s][i]);
                    e.push(a);
                }
                return t.globals.stackedSeriesTotals = e, e;
            }
        },
        {
            key: "getSeriesTotalByIndex",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                return null === t ? this.w.config.series.reduce(function(t, e) {
                    return t + e;
                }, 0) : this.w.globals.series[t].reduce(function(t, e) {
                    return t + e;
                }, 0);
            }
        },
        {
            key: "isSeriesNull",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                return 0 === (null === t ? this.w.config.series.filter(function(t) {
                    return null !== t;
                }) : this.w.config.series[t].data.filter(function(t) {
                    return null !== t;
                })).length;
            }
        },
        {
            key: "seriesHaveSameValues",
            value: function(t) {
                return this.w.globals.series[t].every(function(t, e, i) {
                    return t === i[0];
                });
            }
        },
        {
            key: "getCategoryLabels",
            value: function(t) {
                var e = this.w, i = t.slice();
                return e.config.xaxis.convertedCatToNumeric && (i = t.map(function(t, i) {
                    return e.config.xaxis.labels.formatter(t - e.globals.minX + 1);
                })), i;
            }
        },
        {
            key: "getLargestSeries",
            value: function() {
                var t = this.w;
                t.globals.maxValsInArrayIndex = t.globals.series.map(function(t) {
                    return t.length;
                }).indexOf(Math.max.apply(Math, t.globals.series.map(function(t) {
                    return t.length;
                })));
            }
        },
        {
            key: "getLargestMarkerSize",
            value: function() {
                var t = this.w, e = 0;
                return t.globals.markers.size.forEach(function(t) {
                    e = Math.max(e, t);
                }), t.globals.markers.largestSize = e, e;
            }
        },
        {
            key: "getSeriesTotals",
            value: function() {
                var t = this.w;
                t.globals.seriesTotals = t.globals.series.map(function(t, e) {
                    var i = 0;
                    if (Array.isArray(t)) for(var a = 0; a < t.length; a++)i += t[a];
                    else i += t;
                    return i;
                });
            }
        },
        {
            key: "getSeriesTotalsXRange",
            value: function(t, e) {
                var i = this.w;
                return i.globals.series.map(function(a, s) {
                    for(var r = 0, o = 0; o < a.length; o++)i.globals.seriesX[s][o] > t && i.globals.seriesX[s][o] < e && (r += a[o]);
                    return r;
                });
            }
        },
        {
            key: "getPercentSeries",
            value: function() {
                var t = this.w;
                t.globals.seriesPercent = t.globals.series.map(function(e, i) {
                    var a = [];
                    if (Array.isArray(e)) for(var s = 0; s < e.length; s++){
                        var r = t.globals.stackedSeriesTotals[s], o = 0;
                        r && (o = 100 * e[s] / r), a.push(o);
                    }
                    else {
                        var n = 100 * e / t.globals.seriesTotals.reduce(function(t, e) {
                            return t + e;
                        }, 0);
                        a.push(n);
                    }
                    return a;
                });
            }
        },
        {
            key: "getCalculatedRatios",
            value: function() {
                var t, e, i, a, s = this.w.globals, r = [], o = 0, n = [], l = .1, h = 0;
                if (s.yRange = [], s.isMultipleYAxis) for(var c = 0; c < s.minYArr.length; c++)s.yRange.push(Math.abs(s.minYArr[c] - s.maxYArr[c])), n.push(0);
                else s.yRange.push(Math.abs(s.minY - s.maxY));
                s.xRange = Math.abs(s.maxX - s.minX), s.zRange = Math.abs(s.maxZ - s.minZ);
                for(var d = 0; d < s.yRange.length; d++)r.push(s.yRange[d] / s.gridHeight);
                if (e = s.xRange / s.gridWidth, i = Math.abs(s.initialMaxX - s.initialMinX) / s.gridWidth, t = s.yRange / s.gridWidth, a = s.xRange / s.gridHeight, (o = s.zRange / s.gridHeight * 16) || (o = 1), s.minY !== Number.MIN_VALUE && 0 !== Math.abs(s.minY) && (s.hasNegs = !0), s.isMultipleYAxis) {
                    n = [];
                    for(var g = 0; g < r.length; g++)n.push(-s.minYArr[g] / r[g]);
                } else n.push(-s.minY / r[0]), s.minY !== Number.MIN_VALUE && 0 !== Math.abs(s.minY) && (l = -s.minY / t, h = s.minX / e);
                return {
                    yRatio: r,
                    invertedYRatio: t,
                    zRatio: o,
                    xRatio: e,
                    initialXRatio: i,
                    invertedXRatio: a,
                    baseLineInvertedY: l,
                    baseLineY: n,
                    baseLineX: h
                };
            }
        },
        {
            key: "getLogSeries",
            value: function(t) {
                var e = this, i = this.w;
                return i.globals.seriesLog = t.map(function(t, a) {
                    return i.config.yaxis[a] && i.config.yaxis[a].logarithmic ? t.map(function(t) {
                        return null === t ? null : e.getLogVal(t, a);
                    }) : t;
                }), i.globals.invalidLogScale ? t : i.globals.seriesLog;
            }
        },
        {
            key: "getLogVal",
            value: function(t, e) {
                var i = this.w, a = (Math.log(t) - Math.log(i.globals.minYArr[e])) / (Math.log(i.globals.maxYArr[e]) - Math.log(i.globals.minYArr[e]));
                return isNaN(a) ? t : a;
            }
        },
        {
            key: "getLogYRatios",
            value: function(t) {
                var e = this, i = this.w, a = this.w.globals;
                return a.yLogRatio = t.slice(), a.logYRange = a.yRange.map(function(t, s) {
                    if (i.config.yaxis[s] && e.w.config.yaxis[s].logarithmic) {
                        var r, o = -Number.MAX_VALUE, n = Number.MIN_VALUE;
                        return a.seriesLog.forEach(function(t, e) {
                            t.forEach(function(t) {
                                i.config.yaxis[e] && i.config.yaxis[e].logarithmic && (o = Math.max(t, o), n = Math.min(t, n));
                            });
                        }), r = Math.pow(a.yRange[s], Math.abs(n - o) / a.yRange[s]), a.yLogRatio[s] = r / a.gridHeight, r;
                    }
                }), a.invalidLogScale ? t.slice() : a.yLogRatio;
            }
        }
    ], [
        {
            key: "checkComboSeries",
            value: function(t) {
                var e = !1, i = 0, a = 0;
                return t.length && void 0 !== t[0].type && t.forEach(function(t) {
                    "bar" !== t.type && "column" !== t.type && "candlestick" !== t.type && "boxPlot" !== t.type || i++, void 0 !== t.type && a++;
                }), a > 0 && (e = !0), {
                    comboBarCount: i,
                    comboCharts: e
                };
            }
        },
        {
            key: "extendArrayProps",
            value: function(t, e, i) {
                return e.yaxis && (e = t.extendYAxis(e, i)), e.annotations && (e.annotations.yaxis && (e = t.extendYAxisAnnotations(e)), e.annotations.xaxis && (e = t.extendXAxisAnnotations(e)), e.annotations.points && (e = t.extendPointAnnotations(e))), e;
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$w = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.w = e.w, this.annoCtx = e;
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "addYaxisAnnotation",
            value: function(t, e, i) {
                var a, s = this.w, r = t.strokeDashArray, o = this._getY1Y2("y1", t), n = t.label.text;
                if (null === t.y2 || void 0 === t.y2) {
                    var l = this.annoCtx.graphics.drawLine(0 + t.offsetX, o + t.offsetY, this._getYAxisAnnotationWidth(t), o + t.offsetY, t.borderColor, r, t.borderWidth);
                    e.appendChild(l.node), t.id && l.node.classList.add(t.id);
                } else {
                    if ((a = this._getY1Y2("y2", t)) > o) {
                        var h = o;
                        o = a, a = h;
                    }
                    var c = this.annoCtx.graphics.drawRect(0 + t.offsetX, a + t.offsetY, this._getYAxisAnnotationWidth(t), o - a, 0, t.fillColor, t.opacity, 1, t.borderColor, r);
                    c.node.classList.add("apexcharts-annotation-rect"), c.attr("clip-path", "url(#gridRectMask".concat(s.globals.cuid, ")")), e.appendChild(c.node), t.id && c.node.classList.add(t.id);
                }
                var d = "right" === t.label.position ? s.globals.gridWidth : 0, g = this.annoCtx.graphics.drawText({
                    x: d + t.label.offsetX,
                    y: (null != a ? a : o) + t.label.offsetY - 3,
                    text: n,
                    textAnchor: t.label.textAnchor,
                    fontSize: t.label.style.fontSize,
                    fontFamily: t.label.style.fontFamily,
                    fontWeight: t.label.style.fontWeight,
                    foreColor: t.label.style.color,
                    cssClass: "apexcharts-yaxis-annotation-label ".concat(t.label.style.cssClass, " ").concat(t.id ? t.id : "")
                });
                g.attr({
                    rel: i
                }), e.appendChild(g.node);
            }
        },
        {
            key: "_getY1Y2",
            value: function(t, e) {
                var i, a = "y1" === t ? e.y : e.y2, s = this.w;
                if (this.annoCtx.invertAxis) {
                    var r = s.globals.labels.indexOf(a);
                    s.config.xaxis.convertedCatToNumeric && (r = s.globals.categoryLabels.indexOf(a));
                    var o = s.globals.dom.baseEl.querySelector(".apexcharts-yaxis-texts-g text:nth-child(" + (r + 1) + ")");
                    o && (i = parseFloat(o.getAttribute("y")));
                } else {
                    var n;
                    if (s.config.yaxis[e.yAxisIndex].logarithmic) n = (a = new $b705b473d3ec9641$var$y(this.annoCtx.ctx).getLogVal(a, e.yAxisIndex)) / s.globals.yLogRatio[e.yAxisIndex];
                    else n = (a - s.globals.minYArr[e.yAxisIndex]) / (s.globals.yRange[e.yAxisIndex] / s.globals.gridHeight);
                    i = s.globals.gridHeight - n, s.config.yaxis[e.yAxisIndex] && s.config.yaxis[e.yAxisIndex].reversed && (i = n);
                }
                return i;
            }
        },
        {
            key: "_getYAxisAnnotationWidth",
            value: function(t) {
                var e = this.w;
                e.globals.gridWidth;
                return (t.width.indexOf("%") > -1 ? e.globals.gridWidth * parseInt(t.width, 10) / 100 : parseInt(t.width, 10)) + t.offsetX;
            }
        },
        {
            key: "drawYAxisAnnotations",
            value: function() {
                var t = this, e = this.w, i = this.annoCtx.graphics.group({
                    class: "apexcharts-yaxis-annotations"
                });
                return e.config.annotations.yaxis.map(function(e, a) {
                    t.addYaxisAnnotation(e, i.node, a);
                }), i;
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$k = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.w = e.w, this.annoCtx = e;
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "addPointAnnotation",
            value: function(t, e, i) {
                var a = this.w, s = 0, r = 0, o = 0;
                this.annoCtx.invertAxis && console.warn("Point annotation is not supported in horizontal bar charts.");
                var n = parseFloat(t.y);
                if ("string" == typeof t.x || "category" === a.config.xaxis.type || a.config.xaxis.convertedCatToNumeric) {
                    var l = a.globals.labels.indexOf(t.x);
                    a.config.xaxis.convertedCatToNumeric && (l = a.globals.categoryLabels.indexOf(t.x)), s = this.annoCtx.helpers.getStringX(t.x), null === t.y && (n = a.globals.series[t.seriesIndex][l]);
                } else s = (t.x - a.globals.minX) / (a.globals.xRange / a.globals.gridWidth);
                for(var h, c = [], d = 0, g = 0; g <= t.seriesIndex; g++){
                    var u = a.config.yaxis[g].seriesName;
                    if (u) for(var f = g + 1; f <= t.seriesIndex; f++)a.config.yaxis[f].seriesName === u && -1 === c.indexOf(u) && (d++, c.push(u));
                }
                if (a.config.yaxis[t.yAxisIndex].logarithmic) h = (n = new $b705b473d3ec9641$var$y(this.annoCtx.ctx).getLogVal(n, t.yAxisIndex)) / a.globals.yLogRatio[t.yAxisIndex];
                else {
                    var x = t.yAxisIndex + d;
                    h = (n - a.globals.minYArr[x]) / (a.globals.yRange[x] / a.globals.gridHeight);
                }
                if (r = a.globals.gridHeight - h - parseFloat(t.label.style.fontSize) - t.marker.size, o = a.globals.gridHeight - h, a.config.yaxis[t.yAxisIndex] && a.config.yaxis[t.yAxisIndex].reversed && (r = h + parseFloat(t.label.style.fontSize) + t.marker.size, o = h), $b705b473d3ec9641$var$p.isNumber(s)) {
                    var b = {
                        pSize: t.marker.size,
                        pointStrokeWidth: t.marker.strokeWidth,
                        pointFillColor: t.marker.fillColor,
                        pointStrokeColor: t.marker.strokeColor,
                        shape: t.marker.shape,
                        pRadius: t.marker.radius,
                        class: "apexcharts-point-annotation-marker ".concat(t.marker.cssClass, " ").concat(t.id ? t.id : "")
                    }, v = this.annoCtx.graphics.drawMarker(s + t.marker.offsetX, o + t.marker.offsetY, b);
                    e.appendChild(v.node);
                    var m = t.label.text ? t.label.text : "", w = this.annoCtx.graphics.drawText({
                        x: s + t.label.offsetX,
                        y: r + t.label.offsetY,
                        text: m,
                        textAnchor: t.label.textAnchor,
                        fontSize: t.label.style.fontSize,
                        fontFamily: t.label.style.fontFamily,
                        fontWeight: t.label.style.fontWeight,
                        foreColor: t.label.style.color,
                        cssClass: "apexcharts-point-annotation-label ".concat(t.label.style.cssClass, " ").concat(t.id ? t.id : "")
                    });
                    if (w.attr({
                        rel: i
                    }), e.appendChild(w.node), t.customSVG.SVG) {
                        var k = this.annoCtx.graphics.group({
                            class: "apexcharts-point-annotations-custom-svg " + t.customSVG.cssClass
                        });
                        k.attr({
                            transform: "translate(".concat(s + t.customSVG.offsetX, ", ").concat(r + t.customSVG.offsetY, ")")
                        }), k.node.innerHTML = t.customSVG.SVG, e.appendChild(k.node);
                    }
                    if (t.image.path) {
                        var A = t.image.width ? t.image.width : 20, S = t.image.height ? t.image.height : 20;
                        v = this.annoCtx.addImage({
                            x: s + t.image.offsetX - A / 2,
                            y: r + t.image.offsetY - S / 2,
                            width: A,
                            height: S,
                            path: t.image.path,
                            appendTo: ".apexcharts-point-annotations"
                        });
                    }
                    t.mouseEnter && v.node.addEventListener("mouseenter", t.mouseEnter.bind(this, t)), t.mouseLeave && v.node.addEventListener("mouseleave", t.mouseLeave.bind(this, t));
                }
            }
        },
        {
            key: "drawPointAnnotations",
            value: function() {
                var t = this, e = this.w, i = this.annoCtx.graphics.group({
                    class: "apexcharts-point-annotations"
                });
                return e.config.annotations.points.map(function(e, a) {
                    t.addPointAnnotation(e, i.node, a);
                }), i;
            }
        }
    ]), t;
}();
var $b705b473d3ec9641$var$A = {
    name: "en",
    options: {
        months: [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ],
        shortMonths: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
        ],
        days: [
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ],
        shortDays: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat"
        ],
        toolbar: {
            exportToSVG: "Download SVG",
            exportToPNG: "Download PNG",
            exportToCSV: "Download CSV",
            menu: "Menu",
            selection: "Selection",
            selectionZoom: "Selection Zoom",
            zoomIn: "Zoom In",
            zoomOut: "Zoom Out",
            pan: "Panning",
            reset: "Reset Zoom"
        }
    }
}, $b705b473d3ec9641$var$S = function() {
    function t() {
        $b705b473d3ec9641$var$a(this, t), this.yAxis = {
            show: !0,
            showAlways: !1,
            showForNullSeries: !0,
            seriesName: void 0,
            opposite: !1,
            reversed: !1,
            logarithmic: !1,
            logBase: 10,
            tickAmount: void 0,
            forceNiceScale: !1,
            max: void 0,
            min: void 0,
            floating: !1,
            decimalsInFloat: void 0,
            labels: {
                show: !0,
                minWidth: 0,
                maxWidth: 160,
                offsetX: 0,
                offsetY: 0,
                align: void 0,
                rotate: 0,
                padding: 20,
                style: {
                    colors: [],
                    fontSize: "11px",
                    fontWeight: 400,
                    fontFamily: void 0,
                    cssClass: ""
                },
                formatter: void 0
            },
            axisBorder: {
                show: !1,
                color: "#e0e0e0",
                width: 1,
                offsetX: 0,
                offsetY: 0
            },
            axisTicks: {
                show: !1,
                color: "#e0e0e0",
                width: 6,
                offsetX: 0,
                offsetY: 0
            },
            title: {
                text: void 0,
                rotate: -90,
                offsetY: 0,
                offsetX: 0,
                style: {
                    color: void 0,
                    fontSize: "11px",
                    fontWeight: 900,
                    fontFamily: void 0,
                    cssClass: ""
                }
            },
            tooltip: {
                enabled: !1,
                offsetX: 0
            },
            crosshairs: {
                show: !0,
                position: "front",
                stroke: {
                    color: "#b6b6b6",
                    width: 1,
                    dashArray: 0
                }
            }
        }, this.pointAnnotation = {
            id: void 0,
            x: 0,
            y: null,
            yAxisIndex: 0,
            seriesIndex: 0,
            mouseEnter: void 0,
            mouseLeave: void 0,
            marker: {
                size: 4,
                fillColor: "#fff",
                strokeWidth: 2,
                strokeColor: "#333",
                shape: "circle",
                offsetX: 0,
                offsetY: 0,
                radius: 2,
                cssClass: ""
            },
            label: {
                borderColor: "#c2c2c2",
                borderWidth: 1,
                borderRadius: 2,
                text: void 0,
                textAnchor: "middle",
                offsetX: 0,
                offsetY: 0,
                mouseEnter: void 0,
                mouseLeave: void 0,
                style: {
                    background: "#fff",
                    color: void 0,
                    fontSize: "11px",
                    fontFamily: void 0,
                    fontWeight: 400,
                    cssClass: "",
                    padding: {
                        left: 5,
                        right: 5,
                        top: 2,
                        bottom: 2
                    }
                }
            },
            customSVG: {
                SVG: void 0,
                cssClass: void 0,
                offsetX: 0,
                offsetY: 0
            },
            image: {
                path: void 0,
                width: 20,
                height: 20,
                offsetX: 0,
                offsetY: 0
            }
        }, this.yAxisAnnotation = {
            id: void 0,
            y: 0,
            y2: null,
            strokeDashArray: 1,
            fillColor: "#c2c2c2",
            borderColor: "#c2c2c2",
            borderWidth: 1,
            opacity: .3,
            offsetX: 0,
            offsetY: 0,
            width: "100%",
            yAxisIndex: 0,
            label: {
                borderColor: "#c2c2c2",
                borderWidth: 1,
                borderRadius: 2,
                text: void 0,
                textAnchor: "end",
                position: "right",
                offsetX: 0,
                offsetY: -3,
                mouseEnter: void 0,
                mouseLeave: void 0,
                style: {
                    background: "#fff",
                    color: void 0,
                    fontSize: "11px",
                    fontFamily: void 0,
                    fontWeight: 400,
                    cssClass: "",
                    padding: {
                        left: 5,
                        right: 5,
                        top: 2,
                        bottom: 2
                    }
                }
            }
        }, this.xAxisAnnotation = {
            id: void 0,
            x: 0,
            x2: null,
            strokeDashArray: 1,
            fillColor: "#c2c2c2",
            borderColor: "#c2c2c2",
            borderWidth: 1,
            opacity: .3,
            offsetX: 0,
            offsetY: 0,
            label: {
                borderColor: "#c2c2c2",
                borderWidth: 1,
                borderRadius: 2,
                text: void 0,
                textAnchor: "middle",
                orientation: "vertical",
                position: "top",
                offsetX: 0,
                offsetY: 0,
                mouseEnter: void 0,
                mouseLeave: void 0,
                style: {
                    background: "#fff",
                    color: void 0,
                    fontSize: "11px",
                    fontFamily: void 0,
                    fontWeight: 400,
                    cssClass: "",
                    padding: {
                        left: 5,
                        right: 5,
                        top: 2,
                        bottom: 2
                    }
                }
            }
        }, this.text = {
            x: 0,
            y: 0,
            text: "",
            textAnchor: "start",
            foreColor: void 0,
            fontSize: "13px",
            fontFamily: void 0,
            fontWeight: 400,
            appendTo: ".apexcharts-annotations",
            backgroundColor: "transparent",
            borderColor: "#c2c2c2",
            borderRadius: 0,
            borderWidth: 0,
            paddingLeft: 4,
            paddingRight: 4,
            paddingTop: 2,
            paddingBottom: 2
        };
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "init",
            value: function() {
                return {
                    annotations: {
                        position: "front",
                        yaxis: [
                            this.yAxisAnnotation
                        ],
                        xaxis: [
                            this.xAxisAnnotation
                        ],
                        points: [
                            this.pointAnnotation
                        ],
                        texts: [],
                        images: [],
                        shapes: []
                    },
                    chart: {
                        animations: {
                            enabled: !0,
                            easing: "easeinout",
                            speed: 800,
                            animateGradually: {
                                delay: 150,
                                enabled: !0
                            },
                            dynamicAnimation: {
                                enabled: !0,
                                speed: 350
                            }
                        },
                        background: "transparent",
                        locales: [
                            $b705b473d3ec9641$var$A
                        ],
                        defaultLocale: "en",
                        dropShadow: {
                            enabled: !1,
                            enabledOnSeries: void 0,
                            top: 2,
                            left: 2,
                            blur: 4,
                            color: "#000",
                            opacity: .35
                        },
                        events: {
                            animationEnd: void 0,
                            beforeMount: void 0,
                            mounted: void 0,
                            updated: void 0,
                            click: void 0,
                            mouseMove: void 0,
                            mouseLeave: void 0,
                            legendClick: void 0,
                            markerClick: void 0,
                            selection: void 0,
                            dataPointSelection: void 0,
                            dataPointMouseEnter: void 0,
                            dataPointMouseLeave: void 0,
                            beforeZoom: void 0,
                            beforeResetZoom: void 0,
                            zoomed: void 0,
                            scrolled: void 0,
                            brushScrolled: void 0
                        },
                        foreColor: "#373d3f",
                        fontFamily: "Helvetica, Arial, sans-serif",
                        height: "auto",
                        parentHeightOffset: 15,
                        redrawOnParentResize: !0,
                        redrawOnWindowResize: !0,
                        id: void 0,
                        group: void 0,
                        offsetX: 0,
                        offsetY: 0,
                        selection: {
                            enabled: !1,
                            type: "x",
                            fill: {
                                color: "#24292e",
                                opacity: .1
                            },
                            stroke: {
                                width: 1,
                                color: "#24292e",
                                opacity: .4,
                                dashArray: 3
                            },
                            xaxis: {
                                min: void 0,
                                max: void 0
                            },
                            yaxis: {
                                min: void 0,
                                max: void 0
                            }
                        },
                        sparkline: {
                            enabled: !1
                        },
                        brush: {
                            enabled: !1,
                            autoScaleYaxis: !0,
                            target: void 0
                        },
                        stacked: !1,
                        stackType: "normal",
                        toolbar: {
                            show: !0,
                            offsetX: 0,
                            offsetY: 0,
                            tools: {
                                download: !0,
                                selection: !0,
                                zoom: !0,
                                zoomin: !0,
                                zoomout: !0,
                                pan: !0,
                                reset: !0,
                                customIcons: []
                            },
                            export: {
                                csv: {
                                    filename: void 0,
                                    columnDelimiter: ",",
                                    headerCategory: "category",
                                    headerValue: "value",
                                    dateFormatter: function(t) {
                                        return new Date(t).toDateString();
                                    }
                                },
                                png: {
                                    filename: void 0
                                },
                                svg: {
                                    filename: void 0
                                }
                            },
                            autoSelected: "zoom"
                        },
                        type: "line",
                        width: "100%",
                        zoom: {
                            enabled: !0,
                            type: "x",
                            autoScaleYaxis: !1,
                            zoomedArea: {
                                fill: {
                                    color: "#90CAF9",
                                    opacity: .4
                                },
                                stroke: {
                                    color: "#0D47A1",
                                    opacity: .4,
                                    width: 1
                                }
                            }
                        }
                    },
                    plotOptions: {
                        area: {
                            fillTo: "origin"
                        },
                        bar: {
                            horizontal: !1,
                            columnWidth: "70%",
                            barHeight: "70%",
                            distributed: !1,
                            borderRadius: 0,
                            rangeBarOverlap: !0,
                            rangeBarGroupRows: !1,
                            colors: {
                                ranges: [],
                                backgroundBarColors: [],
                                backgroundBarOpacity: 1,
                                backgroundBarRadius: 0
                            },
                            dataLabels: {
                                position: "top",
                                maxItems: 100,
                                hideOverflowingLabels: !0,
                                orientation: "horizontal"
                            }
                        },
                        bubble: {
                            minBubbleRadius: void 0,
                            maxBubbleRadius: void 0
                        },
                        candlestick: {
                            colors: {
                                upward: "#00B746",
                                downward: "#EF403C"
                            },
                            wick: {
                                useFillColor: !0
                            }
                        },
                        boxPlot: {
                            colors: {
                                upper: "#00E396",
                                lower: "#008FFB"
                            }
                        },
                        heatmap: {
                            radius: 2,
                            enableShades: !0,
                            shadeIntensity: .5,
                            reverseNegativeShade: !1,
                            distributed: !1,
                            useFillColorAsStroke: !1,
                            colorScale: {
                                inverse: !1,
                                ranges: [],
                                min: void 0,
                                max: void 0
                            }
                        },
                        treemap: {
                            enableShades: !0,
                            shadeIntensity: .5,
                            distributed: !1,
                            reverseNegativeShade: !1,
                            useFillColorAsStroke: !1,
                            colorScale: {
                                inverse: !1,
                                ranges: [],
                                min: void 0,
                                max: void 0
                            }
                        },
                        radialBar: {
                            inverseOrder: !1,
                            startAngle: 0,
                            endAngle: 360,
                            offsetX: 0,
                            offsetY: 0,
                            hollow: {
                                margin: 5,
                                size: "50%",
                                background: "transparent",
                                image: void 0,
                                imageWidth: 150,
                                imageHeight: 150,
                                imageOffsetX: 0,
                                imageOffsetY: 0,
                                imageClipped: !0,
                                position: "front",
                                dropShadow: {
                                    enabled: !1,
                                    top: 0,
                                    left: 0,
                                    blur: 3,
                                    color: "#000",
                                    opacity: .5
                                }
                            },
                            track: {
                                show: !0,
                                startAngle: void 0,
                                endAngle: void 0,
                                background: "#f2f2f2",
                                strokeWidth: "97%",
                                opacity: 1,
                                margin: 5,
                                dropShadow: {
                                    enabled: !1,
                                    top: 0,
                                    left: 0,
                                    blur: 3,
                                    color: "#000",
                                    opacity: .5
                                }
                            },
                            dataLabels: {
                                show: !0,
                                name: {
                                    show: !0,
                                    fontSize: "16px",
                                    fontFamily: void 0,
                                    fontWeight: 600,
                                    color: void 0,
                                    offsetY: 0,
                                    formatter: function(t) {
                                        return t;
                                    }
                                },
                                value: {
                                    show: !0,
                                    fontSize: "14px",
                                    fontFamily: void 0,
                                    fontWeight: 400,
                                    color: void 0,
                                    offsetY: 16,
                                    formatter: function(t) {
                                        return t + "%";
                                    }
                                },
                                total: {
                                    show: !1,
                                    label: "Total",
                                    fontSize: "16px",
                                    fontWeight: 600,
                                    fontFamily: void 0,
                                    color: void 0,
                                    formatter: function(t) {
                                        return t.globals.seriesTotals.reduce(function(t, e) {
                                            return t + e;
                                        }, 0) / t.globals.series.length + "%";
                                    }
                                }
                            }
                        },
                        pie: {
                            customScale: 1,
                            offsetX: 0,
                            offsetY: 0,
                            startAngle: 0,
                            endAngle: 360,
                            expandOnClick: !0,
                            dataLabels: {
                                offset: 0,
                                minAngleToShowLabel: 10
                            },
                            donut: {
                                size: "65%",
                                background: "transparent",
                                labels: {
                                    show: !1,
                                    name: {
                                        show: !0,
                                        fontSize: "16px",
                                        fontFamily: void 0,
                                        fontWeight: 600,
                                        color: void 0,
                                        offsetY: -10,
                                        formatter: function(t) {
                                            return t;
                                        }
                                    },
                                    value: {
                                        show: !0,
                                        fontSize: "20px",
                                        fontFamily: void 0,
                                        fontWeight: 400,
                                        color: void 0,
                                        offsetY: 10,
                                        formatter: function(t) {
                                            return t;
                                        }
                                    },
                                    total: {
                                        show: !1,
                                        showAlways: !1,
                                        label: "Total",
                                        fontSize: "16px",
                                        fontWeight: 400,
                                        fontFamily: void 0,
                                        color: void 0,
                                        formatter: function(t) {
                                            return t.globals.seriesTotals.reduce(function(t, e) {
                                                return t + e;
                                            }, 0);
                                        }
                                    }
                                }
                            }
                        },
                        polarArea: {
                            rings: {
                                strokeWidth: 1,
                                strokeColor: "#e8e8e8"
                            },
                            spokes: {
                                strokeWidth: 1,
                                connectorColors: "#e8e8e8"
                            }
                        },
                        radar: {
                            size: void 0,
                            offsetX: 0,
                            offsetY: 0,
                            polygons: {
                                strokeWidth: 1,
                                strokeColors: "#e8e8e8",
                                connectorColors: "#e8e8e8",
                                fill: {
                                    colors: void 0
                                }
                            }
                        }
                    },
                    colors: void 0,
                    dataLabels: {
                        enabled: !0,
                        enabledOnSeries: void 0,
                        formatter: function(t) {
                            return null !== t ? t : "";
                        },
                        textAnchor: "middle",
                        distributed: !1,
                        offsetX: 0,
                        offsetY: 0,
                        style: {
                            fontSize: "12px",
                            fontFamily: void 0,
                            fontWeight: 600,
                            colors: void 0
                        },
                        background: {
                            enabled: !0,
                            foreColor: "#fff",
                            borderRadius: 2,
                            padding: 4,
                            opacity: .9,
                            borderWidth: 1,
                            borderColor: "#fff",
                            dropShadow: {
                                enabled: !1,
                                top: 1,
                                left: 1,
                                blur: 1,
                                color: "#000",
                                opacity: .45
                            }
                        },
                        dropShadow: {
                            enabled: !1,
                            top: 1,
                            left: 1,
                            blur: 1,
                            color: "#000",
                            opacity: .45
                        }
                    },
                    fill: {
                        type: "solid",
                        colors: void 0,
                        opacity: .85,
                        gradient: {
                            shade: "dark",
                            type: "horizontal",
                            shadeIntensity: .5,
                            gradientToColors: void 0,
                            inverseColors: !0,
                            opacityFrom: 1,
                            opacityTo: 1,
                            stops: [
                                0,
                                50,
                                100
                            ],
                            colorStops: []
                        },
                        image: {
                            src: [],
                            width: void 0,
                            height: void 0
                        },
                        pattern: {
                            style: "squares",
                            width: 6,
                            height: 6,
                            strokeWidth: 2
                        }
                    },
                    forecastDataPoints: {
                        count: 0,
                        fillOpacity: .5,
                        strokeWidth: void 0,
                        dashArray: 4
                    },
                    grid: {
                        show: !0,
                        borderColor: "#e0e0e0",
                        strokeDashArray: 0,
                        position: "back",
                        xaxis: {
                            lines: {
                                show: !1
                            }
                        },
                        yaxis: {
                            lines: {
                                show: !0
                            }
                        },
                        row: {
                            colors: void 0,
                            opacity: .5
                        },
                        column: {
                            colors: void 0,
                            opacity: .5
                        },
                        padding: {
                            top: 0,
                            right: 10,
                            bottom: 0,
                            left: 12
                        }
                    },
                    labels: [],
                    legend: {
                        show: !0,
                        showForSingleSeries: !1,
                        showForNullSeries: !0,
                        showForZeroSeries: !0,
                        floating: !1,
                        position: "bottom",
                        horizontalAlign: "center",
                        inverseOrder: !1,
                        fontSize: "12px",
                        fontFamily: void 0,
                        fontWeight: 400,
                        width: void 0,
                        height: void 0,
                        formatter: void 0,
                        tooltipHoverFormatter: void 0,
                        offsetX: -20,
                        offsetY: 4,
                        customLegendItems: [],
                        labels: {
                            colors: void 0,
                            useSeriesColors: !1
                        },
                        markers: {
                            width: 12,
                            height: 12,
                            strokeWidth: 0,
                            fillColors: void 0,
                            strokeColor: "#fff",
                            radius: 12,
                            customHTML: void 0,
                            offsetX: 0,
                            offsetY: 0,
                            onClick: void 0
                        },
                        itemMargin: {
                            horizontal: 5,
                            vertical: 2
                        },
                        onItemClick: {
                            toggleDataSeries: !0
                        },
                        onItemHover: {
                            highlightDataSeries: !0
                        }
                    },
                    markers: {
                        discrete: [],
                        size: 0,
                        colors: void 0,
                        strokeColors: "#fff",
                        strokeWidth: 2,
                        strokeOpacity: .9,
                        strokeDashArray: 0,
                        fillOpacity: 1,
                        shape: "circle",
                        width: 8,
                        height: 8,
                        radius: 2,
                        offsetX: 0,
                        offsetY: 0,
                        onClick: void 0,
                        onDblClick: void 0,
                        showNullDataPoints: !0,
                        hover: {
                            size: void 0,
                            sizeOffset: 3
                        }
                    },
                    noData: {
                        text: void 0,
                        align: "center",
                        verticalAlign: "middle",
                        offsetX: 0,
                        offsetY: 0,
                        style: {
                            color: void 0,
                            fontSize: "14px",
                            fontFamily: void 0
                        }
                    },
                    responsive: [],
                    series: void 0,
                    states: {
                        normal: {
                            filter: {
                                type: "none",
                                value: 0
                            }
                        },
                        hover: {
                            filter: {
                                type: "lighten",
                                value: .1
                            }
                        },
                        active: {
                            allowMultipleDataPointsSelection: !1,
                            filter: {
                                type: "darken",
                                value: .5
                            }
                        }
                    },
                    title: {
                        text: void 0,
                        align: "left",
                        margin: 5,
                        offsetX: 0,
                        offsetY: 0,
                        floating: !1,
                        style: {
                            fontSize: "14px",
                            fontWeight: 900,
                            fontFamily: void 0,
                            color: void 0
                        }
                    },
                    subtitle: {
                        text: void 0,
                        align: "left",
                        margin: 5,
                        offsetX: 0,
                        offsetY: 30,
                        floating: !1,
                        style: {
                            fontSize: "12px",
                            fontWeight: 400,
                            fontFamily: void 0,
                            color: void 0
                        }
                    },
                    stroke: {
                        show: !0,
                        curve: "smooth",
                        lineCap: "butt",
                        width: 2,
                        colors: void 0,
                        dashArray: 0
                    },
                    tooltip: {
                        enabled: !0,
                        enabledOnSeries: void 0,
                        shared: !0,
                        followCursor: !1,
                        intersect: !1,
                        inverseOrder: !1,
                        custom: void 0,
                        fillSeriesColor: !1,
                        theme: "light",
                        style: {
                            fontSize: "12px",
                            fontFamily: void 0
                        },
                        onDatasetHover: {
                            highlightDataSeries: !1
                        },
                        x: {
                            show: !0,
                            format: "dd MMM",
                            formatter: void 0
                        },
                        y: {
                            formatter: void 0,
                            title: {
                                formatter: function(t) {
                                    return t ? t + ": " : "";
                                }
                            }
                        },
                        z: {
                            formatter: void 0,
                            title: "Size: "
                        },
                        marker: {
                            show: !0,
                            fillColors: void 0
                        },
                        items: {
                            display: "flex"
                        },
                        fixed: {
                            enabled: !1,
                            position: "topRight",
                            offsetX: 0,
                            offsetY: 0
                        }
                    },
                    xaxis: {
                        type: "category",
                        categories: [],
                        convertedCatToNumeric: !1,
                        offsetX: 0,
                        offsetY: 0,
                        overwriteCategories: void 0,
                        labels: {
                            show: !0,
                            rotate: -45,
                            rotateAlways: !1,
                            hideOverlappingLabels: !0,
                            trim: !1,
                            minHeight: void 0,
                            maxHeight: 120,
                            showDuplicates: !0,
                            style: {
                                colors: [],
                                fontSize: "12px",
                                fontWeight: 400,
                                fontFamily: void 0,
                                cssClass: ""
                            },
                            offsetX: 0,
                            offsetY: 0,
                            format: void 0,
                            formatter: void 0,
                            datetimeUTC: !0,
                            datetimeFormatter: {
                                year: "yyyy",
                                month: "MMM 'yy",
                                day: "dd MMM",
                                hour: "HH:mm",
                                minute: "HH:mm:ss",
                                second: "HH:mm:ss"
                            }
                        },
                        axisBorder: {
                            show: !0,
                            color: "#e0e0e0",
                            width: "100%",
                            height: 1,
                            offsetX: 0,
                            offsetY: 0
                        },
                        axisTicks: {
                            show: !0,
                            color: "#e0e0e0",
                            height: 6,
                            offsetX: 0,
                            offsetY: 0
                        },
                        tickAmount: void 0,
                        tickPlacement: "on",
                        min: void 0,
                        max: void 0,
                        range: void 0,
                        floating: !1,
                        decimalsInFloat: void 0,
                        position: "bottom",
                        title: {
                            text: void 0,
                            offsetX: 0,
                            offsetY: 0,
                            style: {
                                color: void 0,
                                fontSize: "12px",
                                fontWeight: 900,
                                fontFamily: void 0,
                                cssClass: ""
                            }
                        },
                        crosshairs: {
                            show: !0,
                            width: 1,
                            position: "back",
                            opacity: .9,
                            stroke: {
                                color: "#b6b6b6",
                                width: 1,
                                dashArray: 3
                            },
                            fill: {
                                type: "solid",
                                color: "#B1B9C4",
                                gradient: {
                                    colorFrom: "#D8E3F0",
                                    colorTo: "#BED1E6",
                                    stops: [
                                        0,
                                        100
                                    ],
                                    opacityFrom: .4,
                                    opacityTo: .5
                                }
                            },
                            dropShadow: {
                                enabled: !1,
                                left: 0,
                                top: 0,
                                blur: 1,
                                opacity: .4
                            }
                        },
                        tooltip: {
                            enabled: !0,
                            offsetY: 0,
                            formatter: void 0,
                            style: {
                                fontSize: "12px",
                                fontFamily: void 0
                            }
                        }
                    },
                    yaxis: this.yAxis,
                    theme: {
                        mode: "light",
                        palette: "palette1",
                        monochrome: {
                            enabled: !1,
                            color: "#008FFB",
                            shadeTo: "light",
                            shadeIntensity: .65
                        }
                    }
                };
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$C = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.ctx = e, this.w = e.w, this.graphics = new $b705b473d3ec9641$var$b(this.ctx), this.w.globals.isBarHorizontal && (this.invertAxis = !0), this.helpers = new $b705b473d3ec9641$var$v(this), this.xAxisAnnotations = new $b705b473d3ec9641$var$m(this), this.yAxisAnnotations = new $b705b473d3ec9641$var$w(this), this.pointsAnnotations = new $b705b473d3ec9641$var$k(this), this.w.globals.isBarHorizontal && this.w.config.yaxis[0].reversed && (this.inversedReversedAxis = !0), this.xDivision = this.w.globals.gridWidth / this.w.globals.dataPoints;
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "drawAxesAnnotations",
            value: function() {
                var t = this.w;
                if (t.globals.axisCharts) {
                    for(var e = this.yAxisAnnotations.drawYAxisAnnotations(), i = this.xAxisAnnotations.drawXAxisAnnotations(), a = this.pointsAnnotations.drawPointAnnotations(), s = t.config.chart.animations.enabled, r = [
                        e,
                        i,
                        a
                    ], o = [
                        i.node,
                        e.node,
                        a.node
                    ], n = 0; n < 3; n++)t.globals.dom.elGraphical.add(r[n]), !s || t.globals.resized || t.globals.dataChanged || "scatter" !== t.config.chart.type && "bubble" !== t.config.chart.type && t.globals.dataPoints > 1 && o[n].classList.add("apexcharts-element-hidden"), t.globals.delayedElements.push({
                        el: o[n],
                        index: 0
                    });
                    this.helpers.annotationsBackground();
                }
            }
        },
        {
            key: "drawImageAnnos",
            value: function() {
                var t = this;
                this.w.config.annotations.images.map(function(e, i) {
                    t.addImage(e, i);
                });
            }
        },
        {
            key: "drawTextAnnos",
            value: function() {
                var t = this;
                this.w.config.annotations.texts.map(function(e, i) {
                    t.addText(e, i);
                });
            }
        },
        {
            key: "addXaxisAnnotation",
            value: function(t, e, i) {
                this.xAxisAnnotations.addXaxisAnnotation(t, e, i);
            }
        },
        {
            key: "addYaxisAnnotation",
            value: function(t, e, i) {
                this.yAxisAnnotations.addYaxisAnnotation(t, e, i);
            }
        },
        {
            key: "addPointAnnotation",
            value: function(t, e, i) {
                this.pointsAnnotations.addPointAnnotation(t, e, i);
            }
        },
        {
            key: "addText",
            value: function(t, e) {
                var i = t.x, a = t.y, s = t.text, r = t.textAnchor, o = t.foreColor, n = t.fontSize, l = t.fontFamily, h = t.fontWeight, c = t.cssClass, d = t.backgroundColor, g = t.borderWidth, u = t.strokeDashArray, p = t.borderRadius, f = t.borderColor, x = t.appendTo, b = void 0 === x ? ".apexcharts-annotations" : x, v = t.paddingLeft, m = void 0 === v ? 4 : v, y = t.paddingRight, w = void 0 === y ? 4 : y, k = t.paddingBottom, A = void 0 === k ? 2 : k, S = t.paddingTop, C = void 0 === S ? 2 : S, L = this.w, P = this.graphics.drawText({
                    x: i,
                    y: a,
                    text: s,
                    textAnchor: r || "start",
                    fontSize: n || "12px",
                    fontWeight: h || "regular",
                    fontFamily: l || L.config.chart.fontFamily,
                    foreColor: o || L.config.chart.foreColor,
                    cssClass: c
                }), T = L.globals.dom.baseEl.querySelector(b);
                T && T.appendChild(P.node);
                var M = P.bbox();
                if (s) {
                    var I = this.graphics.drawRect(M.x - m, M.y - C, M.width + m + w, M.height + A + C, p, d || "transparent", 1, g, f, u);
                    T.insertBefore(I.node, P.node);
                }
            }
        },
        {
            key: "addImage",
            value: function(t, e) {
                var i = this.w, a = t.path, s = t.x, r = void 0 === s ? 0 : s, o = t.y, n = void 0 === o ? 0 : o, l = t.width, h = void 0 === l ? 20 : l, c = t.height, d = void 0 === c ? 20 : c, g = t.appendTo, u = void 0 === g ? ".apexcharts-annotations" : g, p = i.globals.dom.Paper.image(a);
                p.size(h, d).move(r, n);
                var f = i.globals.dom.baseEl.querySelector(u);
                return f && f.appendChild(p.node), p;
            }
        },
        {
            key: "addXaxisAnnotationExternal",
            value: function(t, e, i) {
                return this.addAnnotationExternal({
                    params: t,
                    pushToMemory: e,
                    context: i,
                    type: "xaxis",
                    contextMethod: i.addXaxisAnnotation
                }), i;
            }
        },
        {
            key: "addYaxisAnnotationExternal",
            value: function(t, e, i) {
                return this.addAnnotationExternal({
                    params: t,
                    pushToMemory: e,
                    context: i,
                    type: "yaxis",
                    contextMethod: i.addYaxisAnnotation
                }), i;
            }
        },
        {
            key: "addPointAnnotationExternal",
            value: function(t, e, i) {
                return void 0 === this.invertAxis && (this.invertAxis = i.w.globals.isBarHorizontal), this.addAnnotationExternal({
                    params: t,
                    pushToMemory: e,
                    context: i,
                    type: "point",
                    contextMethod: i.addPointAnnotation
                }), i;
            }
        },
        {
            key: "addAnnotationExternal",
            value: function(t) {
                var e = t.params, i = t.pushToMemory, a = t.context, s = t.type, r = t.contextMethod, o = a, n = o.w, l = n.globals.dom.baseEl.querySelector(".apexcharts-".concat(s, "-annotations")), h = l.childNodes.length + 1, c = new $b705b473d3ec9641$var$S, d = Object.assign({}, "xaxis" === s ? c.xAxisAnnotation : "yaxis" === s ? c.yAxisAnnotation : c.pointAnnotation), g = $b705b473d3ec9641$var$p.extend(d, e);
                switch(s){
                    case "xaxis":
                        this.addXaxisAnnotation(g, l, h);
                        break;
                    case "yaxis":
                        this.addYaxisAnnotation(g, l, h);
                        break;
                    case "point":
                        this.addPointAnnotation(g, l, h);
                }
                var u = n.globals.dom.baseEl.querySelector(".apexcharts-".concat(s, "-annotations .apexcharts-").concat(s, "-annotation-label[rel='").concat(h, "']")), f = this.helpers.addBackgroundToAnno(u, g);
                return f && l.insertBefore(f.node, u), i && n.globals.memory.methodsToExec.push({
                    context: o,
                    id: g.id ? g.id : $b705b473d3ec9641$var$p.randomId(),
                    method: r,
                    label: "addAnnotation",
                    params: e
                }), a;
            }
        },
        {
            key: "clearAnnotations",
            value: function(t) {
                var e = t.w, i = e.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxis-annotations, .apexcharts-xaxis-annotations, .apexcharts-point-annotations");
                e.globals.memory.methodsToExec.map(function(t, i) {
                    "addText" !== t.label && "addAnnotation" !== t.label || e.globals.memory.methodsToExec.splice(i, 1);
                }), i = $b705b473d3ec9641$var$p.listToArray(i), Array.prototype.forEach.call(i, function(t) {
                    for(; t.firstChild;)t.removeChild(t.firstChild);
                });
            }
        },
        {
            key: "removeAnnotation",
            value: function(t, e) {
                var i = t.w, a = i.globals.dom.baseEl.querySelectorAll(".".concat(e));
                a && (i.globals.memory.methodsToExec.map(function(t, a) {
                    t.id === e && i.globals.memory.methodsToExec.splice(a, 1);
                }), Array.prototype.forEach.call(a, function(t) {
                    t.parentElement.removeChild(t);
                }));
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$L = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.ctx = e, this.w = e.w, this.opts = null, this.seriesIndex = 0;
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "clippedImgArea",
            value: function(t) {
                var e = this.w, i = e.config, a = parseInt(e.globals.gridWidth, 10), s = parseInt(e.globals.gridHeight, 10), r = a > s ? a : s, o = t.image, n = 0, l = 0;
                void 0 === t.width && void 0 === t.height ? void 0 !== i.fill.image.width && void 0 !== i.fill.image.height ? (n = i.fill.image.width + 1, l = i.fill.image.height) : (n = r + 1, l = r) : (n = t.width, l = t.height);
                var h = document.createElementNS(e.globals.SVGNS, "pattern");
                $b705b473d3ec9641$var$b.setAttrs(h, {
                    id: t.patternID,
                    patternUnits: t.patternUnits ? t.patternUnits : "userSpaceOnUse",
                    width: n + "px",
                    height: l + "px"
                });
                var c = document.createElementNS(e.globals.SVGNS, "image");
                h.appendChild(c), c.setAttributeNS(window.SVG.xlink, "href", o), $b705b473d3ec9641$var$b.setAttrs(c, {
                    x: 0,
                    y: 0,
                    preserveAspectRatio: "none",
                    width: n + "px",
                    height: l + "px"
                }), c.style.opacity = t.opacity, e.globals.dom.elDefs.node.appendChild(h);
            }
        },
        {
            key: "getSeriesIndex",
            value: function(t) {
                var e = this.w;
                return ("bar" === e.config.chart.type || "rangeBar" === e.config.chart.type) && e.config.plotOptions.bar.distributed || "heatmap" === e.config.chart.type || "treemap" === e.config.chart.type ? this.seriesIndex = t.seriesNumber : this.seriesIndex = t.seriesNumber % e.globals.series.length, this.seriesIndex;
            }
        },
        {
            key: "fillPath",
            value: function(t) {
                var e = this.w;
                this.opts = t;
                var i, a, s, r = this.w.config;
                this.seriesIndex = this.getSeriesIndex(t);
                var o = this.getFillColors()[this.seriesIndex];
                void 0 !== e.globals.seriesColors[this.seriesIndex] && (o = e.globals.seriesColors[this.seriesIndex]), "function" == typeof o && (o = o({
                    seriesIndex: this.seriesIndex,
                    dataPointIndex: t.dataPointIndex,
                    value: t.value,
                    w: e
                }));
                var n = this.getFillType(this.seriesIndex), l = Array.isArray(r.fill.opacity) ? r.fill.opacity[this.seriesIndex] : r.fill.opacity;
                t.color && (o = t.color);
                var h = o;
                if (-1 === o.indexOf("rgb") ? o.length < 9 && (h = $b705b473d3ec9641$var$p.hexToRgba(o, l)) : o.indexOf("rgba") > -1 && (l = $b705b473d3ec9641$var$p.getOpacityFromRGBA(o)), t.opacity && (l = t.opacity), "pattern" === n && (a = this.handlePatternFill(a, o, l, h)), "gradient" === n && (s = this.handleGradientFill(o, l, this.seriesIndex)), "image" === n) {
                    var c = r.fill.image.src, d = t.patternID ? t.patternID : "";
                    this.clippedImgArea({
                        opacity: l,
                        image: Array.isArray(c) ? t.seriesNumber < c.length ? c[t.seriesNumber] : c[0] : c,
                        width: t.width ? t.width : void 0,
                        height: t.height ? t.height : void 0,
                        patternUnits: t.patternUnits,
                        patternID: "pattern".concat(e.globals.cuid).concat(t.seriesNumber + 1).concat(d)
                    }), i = "url(#pattern".concat(e.globals.cuid).concat(t.seriesNumber + 1).concat(d, ")");
                } else i = "gradient" === n ? s : "pattern" === n ? a : h;
                return t.solid && (i = h), i;
            }
        },
        {
            key: "getFillType",
            value: function(t) {
                var e = this.w;
                return Array.isArray(e.config.fill.type) ? e.config.fill.type[t] : e.config.fill.type;
            }
        },
        {
            key: "getFillColors",
            value: function() {
                var t = this.w, e = t.config, i = this.opts, a = [];
                return t.globals.comboCharts ? "line" === t.config.series[this.seriesIndex].type ? Array.isArray(t.globals.stroke.colors) ? a = t.globals.stroke.colors : a.push(t.globals.stroke.colors) : Array.isArray(t.globals.fill.colors) ? a = t.globals.fill.colors : a.push(t.globals.fill.colors) : "line" === e.chart.type ? Array.isArray(t.globals.stroke.colors) ? a = t.globals.stroke.colors : a.push(t.globals.stroke.colors) : Array.isArray(t.globals.fill.colors) ? a = t.globals.fill.colors : a.push(t.globals.fill.colors), void 0 !== i.fillColors && (a = [], Array.isArray(i.fillColors) ? a = i.fillColors.slice() : a.push(i.fillColors)), a;
            }
        },
        {
            key: "handlePatternFill",
            value: function(t, e, i, a) {
                var s = this.w.config, r = this.opts, o = new $b705b473d3ec9641$var$b(this.ctx), n = void 0 === s.fill.pattern.strokeWidth ? Array.isArray(s.stroke.width) ? s.stroke.width[this.seriesIndex] : s.stroke.width : Array.isArray(s.fill.pattern.strokeWidth) ? s.fill.pattern.strokeWidth[this.seriesIndex] : s.fill.pattern.strokeWidth, l = e;
                Array.isArray(s.fill.pattern.style) ? t = void 0 !== s.fill.pattern.style[r.seriesNumber] ? o.drawPattern(s.fill.pattern.style[r.seriesNumber], s.fill.pattern.width, s.fill.pattern.height, l, n, i) : a : t = o.drawPattern(s.fill.pattern.style, s.fill.pattern.width, s.fill.pattern.height, l, n, i);
                return t;
            }
        },
        {
            key: "handleGradientFill",
            value: function(t, e, i) {
                var a, s = this.w.config, r = this.opts, o = new $b705b473d3ec9641$var$b(this.ctx), n = new $b705b473d3ec9641$var$p, l = s.fill.gradient.type, h = t, c = void 0 === s.fill.gradient.opacityFrom ? e : Array.isArray(s.fill.gradient.opacityFrom) ? s.fill.gradient.opacityFrom[i] : s.fill.gradient.opacityFrom;
                h.indexOf("rgba") > -1 && (c = $b705b473d3ec9641$var$p.getOpacityFromRGBA(h));
                var d = void 0 === s.fill.gradient.opacityTo ? e : Array.isArray(s.fill.gradient.opacityTo) ? s.fill.gradient.opacityTo[i] : s.fill.gradient.opacityTo;
                if (void 0 === s.fill.gradient.gradientToColors || 0 === s.fill.gradient.gradientToColors.length) a = "dark" === s.fill.gradient.shade ? n.shadeColor(-1 * parseFloat(s.fill.gradient.shadeIntensity), t.indexOf("rgb") > -1 ? $b705b473d3ec9641$var$p.rgb2hex(t) : t) : n.shadeColor(parseFloat(s.fill.gradient.shadeIntensity), t.indexOf("rgb") > -1 ? $b705b473d3ec9641$var$p.rgb2hex(t) : t);
                else if (s.fill.gradient.gradientToColors[r.seriesNumber]) {
                    var g = s.fill.gradient.gradientToColors[r.seriesNumber];
                    a = g, g.indexOf("rgba") > -1 && (d = $b705b473d3ec9641$var$p.getOpacityFromRGBA(g));
                } else a = t;
                if (s.fill.gradient.inverseColors) {
                    var u = h;
                    h = a, a = u;
                }
                return h.indexOf("rgb") > -1 && (h = $b705b473d3ec9641$var$p.rgb2hex(h)), a.indexOf("rgb") > -1 && (a = $b705b473d3ec9641$var$p.rgb2hex(a)), o.drawGradient(l, h, a, c, d, r.size, s.fill.gradient.stops, s.fill.gradient.colorStops, i);
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$P = function() {
    function t(e, i) {
        $b705b473d3ec9641$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "setGlobalMarkerSize",
            value: function() {
                var t = this.w;
                if (t.globals.markers.size = Array.isArray(t.config.markers.size) ? t.config.markers.size : [
                    t.config.markers.size
                ], t.globals.markers.size.length > 0) {
                    if (t.globals.markers.size.length < t.globals.series.length + 1) for(var e = 0; e <= t.globals.series.length; e++)void 0 === t.globals.markers.size[e] && t.globals.markers.size.push(t.globals.markers.size[0]);
                } else t.globals.markers.size = t.config.series.map(function(e) {
                    return t.config.markers.size;
                });
            }
        },
        {
            key: "plotChartMarkers",
            value: function(t, e, i, a) {
                var s, r = arguments.length > 4 && void 0 !== arguments[4] && arguments[4], o = this.w, n = e, l = t, h = null, c = new $b705b473d3ec9641$var$b(this.ctx);
                if ((o.globals.markers.size[e] > 0 || r) && (h = c.group({
                    class: r ? "" : "apexcharts-series-markers"
                })).attr("clip-path", "url(#gridRectMarkerMask".concat(o.globals.cuid, ")")), Array.isArray(l.x)) for(var d = 0; d < l.x.length; d++){
                    var g = i;
                    1 === i && 0 === d && (g = 0), 1 === i && 1 === d && (g = 1);
                    var u = "apexcharts-marker";
                    "line" !== o.config.chart.type && "area" !== o.config.chart.type || o.globals.comboCharts || o.config.tooltip.intersect || (u += " no-pointer-events");
                    var f = Array.isArray(o.config.markers.size) ? o.globals.markers.size[e] > 0 : o.config.markers.size > 0;
                    if (f || r) {
                        $b705b473d3ec9641$var$p.isNumber(l.y[d]) ? u += " w".concat($b705b473d3ec9641$var$p.randomId()) : u = "apexcharts-nullpoint";
                        var v = this.getMarkerConfig({
                            cssClass: u,
                            seriesIndex: e,
                            dataPointIndex: g
                        });
                        o.config.series[n].data[g] && (o.config.series[n].data[g].fillColor && (v.pointFillColor = o.config.series[n].data[g].fillColor), o.config.series[n].data[g].strokeColor && (v.pointStrokeColor = o.config.series[n].data[g].strokeColor)), a && (v.pSize = a), (s = c.drawMarker(l.x[d], l.y[d], v)).attr("rel", g), s.attr("j", g), s.attr("index", e), s.node.setAttribute("default-marker-size", v.pSize);
                        var m = new $b705b473d3ec9641$var$x(this.ctx);
                        m.setSelectionFilter(s, e, g), this.addEvents(s), h && h.add(s);
                    } else void 0 === o.globals.pointsArray[e] && (o.globals.pointsArray[e] = []), o.globals.pointsArray[e].push([
                        l.x[d],
                        l.y[d]
                    ]);
                }
                return h;
            }
        },
        {
            key: "getMarkerConfig",
            value: function(t) {
                var e = t.cssClass, i = t.seriesIndex, a = t.dataPointIndex, s = void 0 === a ? null : a, r = t.finishRadius, o = void 0 === r ? null : r, n = this.w, l = this.getMarkerStyle(i), h = n.globals.markers.size[i], c = n.config.markers;
                return null !== s && c.discrete.length && c.discrete.map(function(t) {
                    t.seriesIndex === i && t.dataPointIndex === s && (l.pointStrokeColor = t.strokeColor, l.pointFillColor = t.fillColor, h = t.size, l.pointShape = t.shape);
                }), {
                    pSize: null === o ? h : o,
                    pRadius: c.radius,
                    width: Array.isArray(c.width) ? c.width[i] : c.width,
                    height: Array.isArray(c.height) ? c.height[i] : c.height,
                    pointStrokeWidth: Array.isArray(c.strokeWidth) ? c.strokeWidth[i] : c.strokeWidth,
                    pointStrokeColor: l.pointStrokeColor,
                    pointFillColor: l.pointFillColor,
                    shape: l.pointShape || (Array.isArray(c.shape) ? c.shape[i] : c.shape),
                    class: e,
                    pointStrokeOpacity: Array.isArray(c.strokeOpacity) ? c.strokeOpacity[i] : c.strokeOpacity,
                    pointStrokeDashArray: Array.isArray(c.strokeDashArray) ? c.strokeDashArray[i] : c.strokeDashArray,
                    pointFillOpacity: Array.isArray(c.fillOpacity) ? c.fillOpacity[i] : c.fillOpacity,
                    seriesIndex: i
                };
            }
        },
        {
            key: "addEvents",
            value: function(t) {
                var e = this.w, i = new $b705b473d3ec9641$var$b(this.ctx);
                t.node.addEventListener("mouseenter", i.pathMouseEnter.bind(this.ctx, t)), t.node.addEventListener("mouseleave", i.pathMouseLeave.bind(this.ctx, t)), t.node.addEventListener("mousedown", i.pathMouseDown.bind(this.ctx, t)), t.node.addEventListener("click", e.config.markers.onClick), t.node.addEventListener("dblclick", e.config.markers.onDblClick), t.node.addEventListener("touchstart", i.pathMouseDown.bind(this.ctx, t), {
                    passive: !0
                });
            }
        },
        {
            key: "getMarkerStyle",
            value: function(t) {
                var e = this.w, i = e.globals.markers.colors, a = e.config.markers.strokeColor || e.config.markers.strokeColors;
                return {
                    pointStrokeColor: Array.isArray(a) ? a[t] : a,
                    pointFillColor: Array.isArray(i) ? i[t] : i
                };
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$T = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.ctx = e, this.w = e.w, this.initialAnim = this.w.config.chart.animations.enabled, this.dynamicAnim = this.initialAnim && this.w.config.chart.animations.dynamicAnimation.enabled;
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "draw",
            value: function(t, e, i) {
                var a = this.w, s = new $b705b473d3ec9641$var$b(this.ctx), r = i.realIndex, o = i.pointsPos, n = i.zRatio, l = i.elParent, h = s.group({
                    class: "apexcharts-series-markers apexcharts-series-".concat(a.config.chart.type)
                });
                if (h.attr("clip-path", "url(#gridRectMarkerMask".concat(a.globals.cuid, ")")), Array.isArray(o.x)) for(var c = 0; c < o.x.length; c++){
                    var d = e + 1, g = !0;
                    0 === e && 0 === c && (d = 0), 0 === e && 1 === c && (d = 1);
                    var u = 0, p = a.globals.markers.size[r];
                    if (n !== 1 / 0) {
                        p = a.globals.seriesZ[r][d] / n;
                        var f = a.config.plotOptions.bubble;
                        f.minBubbleRadius && p < f.minBubbleRadius && (p = f.minBubbleRadius), f.maxBubbleRadius && p > f.maxBubbleRadius && (p = f.maxBubbleRadius);
                    }
                    a.config.chart.animations.enabled || (u = p);
                    var x = o.x[c], v = o.y[c];
                    if (u = u || 0, null !== v && void 0 !== a.globals.series[r][d] || (g = !1), g) {
                        var m = this.drawPoint(x, v, u, p, r, d, e);
                        h.add(m);
                    }
                    l.add(h);
                }
            }
        },
        {
            key: "drawPoint",
            value: function(t, e, i, a, s, r, o) {
                var n = this.w, l = s, h = new $b705b473d3ec9641$var$f(this.ctx), c = new $b705b473d3ec9641$var$x(this.ctx), d = new $b705b473d3ec9641$var$L(this.ctx), g = new $b705b473d3ec9641$var$P(this.ctx), u = new $b705b473d3ec9641$var$b(this.ctx), p = g.getMarkerConfig({
                    cssClass: "apexcharts-marker",
                    seriesIndex: l,
                    dataPointIndex: r,
                    finishRadius: "bubble" === n.config.chart.type || n.globals.comboCharts && n.config.series[s] && "bubble" === n.config.series[s].type ? a : null
                });
                a = p.pSize;
                var v, m = d.fillPath({
                    seriesNumber: s,
                    dataPointIndex: r,
                    color: p.pointFillColor,
                    patternUnits: "objectBoundingBox",
                    value: n.globals.series[s][o]
                });
                if ("circle" === p.shape ? v = u.drawCircle(i) : "square" !== p.shape && "rect" !== p.shape || (v = u.drawRect(0, 0, p.width - p.pointStrokeWidth / 2, p.height - p.pointStrokeWidth / 2, p.pRadius)), n.config.series[l].data[r] && n.config.series[l].data[r].fillColor && (m = n.config.series[l].data[r].fillColor), v.attr({
                    x: t - p.width / 2 - p.pointStrokeWidth / 2,
                    y: e - p.height / 2 - p.pointStrokeWidth / 2,
                    cx: t,
                    cy: e,
                    fill: m,
                    "fill-opacity": p.pointFillOpacity,
                    stroke: p.pointStrokeColor,
                    r: a,
                    "stroke-width": p.pointStrokeWidth,
                    "stroke-dasharray": p.pointStrokeDashArray,
                    "stroke-opacity": p.pointStrokeOpacity
                }), n.config.chart.dropShadow.enabled) {
                    var y = n.config.chart.dropShadow;
                    c.dropShadow(v, y, s);
                }
                if (!this.initialAnim || n.globals.dataChanged || n.globals.resized) n.globals.animationEnded = !0;
                else {
                    var w = n.config.chart.animations.speed;
                    h.animateMarker(v, 0, "circle" === p.shape ? a : {
                        width: p.width,
                        height: p.height
                    }, w, n.globals.easing, function() {
                        window.setTimeout(function() {
                            h.animationCompleted(v);
                        }, 100);
                    });
                }
                if (n.globals.dataChanged && "circle" === p.shape) {
                    if (this.dynamicAnim) {
                        var k, A, S, C, T = n.config.chart.animations.dynamicAnimation.speed;
                        null != (C = n.globals.previousPaths[s] && n.globals.previousPaths[s][o]) && (k = C.x, A = C.y, S = void 0 !== C.r ? C.r : a);
                        for(var M = 0; M < n.globals.collapsedSeries.length; M++)n.globals.collapsedSeries[M].index === s && (T = 1, a = 0);
                        0 === t && 0 === e && (a = 0), h.animateCircle(v, {
                            cx: k,
                            cy: A,
                            r: S
                        }, {
                            cx: t,
                            cy: e,
                            r: a
                        }, T, n.globals.easing);
                    } else v.attr({
                        r: a
                    });
                }
                return v.attr({
                    rel: r,
                    j: r,
                    index: s,
                    "default-marker-size": a
                }), c.setSelectionFilter(v, s, r), g.addEvents(v), v.node.classList.add("apexcharts-marker"), v;
            }
        },
        {
            key: "centerTextInBubble",
            value: function(t) {
                var e = this.w;
                return {
                    y: t += parseInt(e.config.dataLabels.style.fontSize, 10) / 4
                };
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$M = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "dataLabelsCorrection",
            value: function(t, e, i, a, s, r, o) {
                var n = this.w, l = !1, h = new $b705b473d3ec9641$var$b(this.ctx).getTextRects(i, o), c = h.width, d = h.height;
                e < 0 && (e = 0), e > n.globals.gridHeight + d && (e = n.globals.gridHeight + d / 2), void 0 === n.globals.dataLabelsRects[a] && (n.globals.dataLabelsRects[a] = []), n.globals.dataLabelsRects[a].push({
                    x: t,
                    y: e,
                    width: c,
                    height: d
                });
                var g = n.globals.dataLabelsRects[a].length - 2, u = void 0 !== n.globals.lastDrawnDataLabelsIndexes[a] ? n.globals.lastDrawnDataLabelsIndexes[a][n.globals.lastDrawnDataLabelsIndexes[a].length - 1] : 0;
                if (void 0 !== n.globals.dataLabelsRects[a][g]) {
                    var p = n.globals.dataLabelsRects[a][u];
                    (t > p.x + p.width + 2 || e > p.y + p.height + 2 || t + c < p.x) && (l = !0);
                }
                return (0 === s || r) && (l = !0), {
                    x: t,
                    y: e,
                    textRects: h,
                    drawnextLabel: l
                };
            }
        },
        {
            key: "drawDataLabel",
            value: function(t, e, i) {
                var a = this, s = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : 2, r = this.w, o = new $b705b473d3ec9641$var$b(this.ctx), n = r.config.dataLabels, l = 0, h = 0, c = i, d = null;
                if (!n.enabled || !Array.isArray(t.x)) return d;
                d = o.group({
                    class: "apexcharts-data-labels"
                });
                for(var g = 0; g < t.x.length; g++)if (l = t.x[g] + n.offsetX, h = t.y[g] + n.offsetY + s, !isNaN(l)) {
                    1 === i && 0 === g && (c = 0), 1 === i && 1 === g && (c = 1);
                    var u = r.globals.series[e][c], p = "", f = function(t) {
                        return r.config.dataLabels.formatter(t, {
                            ctx: a.ctx,
                            seriesIndex: e,
                            dataPointIndex: c,
                            w: r
                        });
                    };
                    if ("bubble" === r.config.chart.type) {
                        p = f(u = r.globals.seriesZ[e][c]), h = t.y[g];
                        var x = new $b705b473d3ec9641$var$T(this.ctx), v = x.centerTextInBubble(h, e, c);
                        h = v.y;
                    } else void 0 !== u && (p = f(u));
                    this.plotDataLabelsText({
                        x: l,
                        y: h,
                        text: p,
                        i: e,
                        j: c,
                        parent: d,
                        offsetCorrection: !0,
                        dataLabelsConfig: r.config.dataLabels
                    });
                }
                return d;
            }
        },
        {
            key: "plotDataLabelsText",
            value: function(t) {
                var e = this.w, i = new $b705b473d3ec9641$var$b(this.ctx), a = t.x, s = t.y, r = t.i, o = t.j, n = t.text, l = t.textAnchor, h = t.fontSize, c = t.parent, d = t.dataLabelsConfig, g = t.color, u = t.alwaysDrawDataLabel, p = t.offsetCorrection;
                if (!(Array.isArray(e.config.dataLabels.enabledOnSeries) && e.config.dataLabels.enabledOnSeries.indexOf(r) < 0)) {
                    var f = {
                        x: a,
                        y: s,
                        drawnextLabel: !0,
                        textRects: null
                    };
                    p && (f = this.dataLabelsCorrection(a, s, n, r, o, u, parseInt(d.style.fontSize, 10))), e.globals.zoomed || (a = f.x, s = f.y), f.textRects && (a < -10 - f.textRects.width || a > e.globals.gridWidth + f.textRects.width + 10) && (n = "");
                    var v = e.globals.dataLabels.style.colors[r];
                    (("bar" === e.config.chart.type || "rangeBar" === e.config.chart.type) && e.config.plotOptions.bar.distributed || e.config.dataLabels.distributed) && (v = e.globals.dataLabels.style.colors[o]), "function" == typeof v && (v = v({
                        series: e.globals.series,
                        seriesIndex: r,
                        dataPointIndex: o,
                        w: e
                    })), g && (v = g);
                    var m = d.offsetX, y = d.offsetY;
                    if ("bar" !== e.config.chart.type && "rangeBar" !== e.config.chart.type || (m = 0, y = 0), f.drawnextLabel) {
                        var w = i.drawText({
                            width: 100,
                            height: parseInt(d.style.fontSize, 10),
                            x: a + m,
                            y: s + y,
                            foreColor: v,
                            textAnchor: l || d.textAnchor,
                            text: n,
                            fontSize: h || d.style.fontSize,
                            fontFamily: d.style.fontFamily,
                            fontWeight: d.style.fontWeight || "normal"
                        });
                        if (w.attr({
                            class: "apexcharts-datalabel",
                            cx: a,
                            cy: s
                        }), d.dropShadow.enabled) {
                            var k = d.dropShadow;
                            new $b705b473d3ec9641$var$x(this.ctx).dropShadow(w, k);
                        }
                        c.add(w), void 0 === e.globals.lastDrawnDataLabelsIndexes[r] && (e.globals.lastDrawnDataLabelsIndexes[r] = []), e.globals.lastDrawnDataLabelsIndexes[r].push(o);
                    }
                }
            }
        },
        {
            key: "addBackgroundToDataLabel",
            value: function(t, e) {
                var i = this.w, a = i.config.dataLabels.background, s = a.padding, r = a.padding / 2, o = e.width, n = e.height, l = new $b705b473d3ec9641$var$b(this.ctx).drawRect(e.x - s, e.y - r / 2, o + 2 * s, n + r, a.borderRadius, "transparent" === i.config.chart.background ? "#fff" : i.config.chart.background, a.opacity, a.borderWidth, a.borderColor);
                a.dropShadow.enabled && new $b705b473d3ec9641$var$x(this.ctx).dropShadow(l, a.dropShadow);
                return l;
            }
        },
        {
            key: "dataLabelsBackground",
            value: function() {
                var t = this.w;
                if ("bubble" !== t.config.chart.type) for(var e = t.globals.dom.baseEl.querySelectorAll(".apexcharts-datalabels text"), i = 0; i < e.length; i++){
                    var a = e[i], s = a.getBBox(), r = null;
                    if (s.width && s.height && (r = this.addBackgroundToDataLabel(a, s)), r) {
                        a.parentNode.insertBefore(r.node, a);
                        var o = a.getAttribute("fill");
                        t.config.chart.animations.enabled && !t.globals.resized && !t.globals.dataChanged ? r.animate().attr({
                            fill: o
                        }) : r.attr({
                            fill: o
                        }), a.setAttribute("fill", t.config.dataLabels.background.foreColor);
                    }
                }
            }
        },
        {
            key: "bringForward",
            value: function() {
                for(var t = this.w, e = t.globals.dom.baseEl.querySelectorAll(".apexcharts-datalabels"), i = t.globals.dom.baseEl.querySelector(".apexcharts-plot-series:last-child"), a = 0; a < e.length; a++)i && i.insertBefore(e[a], i.nextSibling);
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$I = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.w = e.w, this.barCtx = e;
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "handleBarDataLabels",
            value: function(t) {
                var e = t.x, i = t.y, a = t.y1, s = t.y2, r = t.i, o = t.j, n = t.realIndex, l = t.series, h = t.barHeight, c = t.barWidth, d = t.barYPosition, g = t.visibleSeries, u = t.renderedPath, p = this.w, f = new $b705b473d3ec9641$var$b(this.barCtx.ctx), x = Array.isArray(this.barCtx.strokeWidth) ? this.barCtx.strokeWidth[n] : this.barCtx.strokeWidth, v = e + parseFloat(c * g), m = i + parseFloat(h * g);
                p.globals.isXNumeric && !p.globals.isBarHorizontal && (v = e + parseFloat(c * (g + 1)), m = i + parseFloat(h * (g + 1)) - x);
                var y = e, w = i, k = {}, A = p.config.dataLabels, S = this.barCtx.barOptions.dataLabels;
                void 0 !== d && this.barCtx.isRangeBar && (m = d, w = d);
                var C = A.offsetX, L = A.offsetY, P = {
                    width: 0,
                    height: 0
                };
                if (p.config.dataLabels.enabled) {
                    var T = this.barCtx.series[r][o];
                    P = f.getTextRects(p.globals.yLabelFormatters[0](T), parseFloat(A.style.fontSize));
                }
                var M = {
                    x: e,
                    y: i,
                    i: r,
                    j: o,
                    renderedPath: u,
                    bcx: v,
                    bcy: m,
                    barHeight: h,
                    barWidth: c,
                    textRects: P,
                    strokeWidth: x,
                    dataLabelsX: y,
                    dataLabelsY: w,
                    barDataLabelsConfig: S,
                    offX: C,
                    offY: L
                };
                return k = this.barCtx.isHorizontal ? this.calculateBarsDataLabelsPosition(M) : this.calculateColumnsDataLabelsPosition(M), u.attr({
                    cy: k.bcy,
                    cx: k.bcx,
                    j: o,
                    val: l[r][o],
                    barHeight: h,
                    barWidth: c
                }), this.drawCalculatedDataLabels({
                    x: k.dataLabelsX,
                    y: k.dataLabelsY,
                    val: this.barCtx.isRangeBar ? [
                        a,
                        s
                    ] : l[r][o],
                    i: n,
                    j: o,
                    barWidth: c,
                    barHeight: h,
                    textRects: P,
                    dataLabelsConfig: A
                });
            }
        },
        {
            key: "calculateColumnsDataLabelsPosition",
            value: function(t) {
                var e, i = this.w, a = t.i, s = t.j, r = t.y, o = t.bcx, n = t.barWidth, l = t.barHeight, h = t.textRects, c = t.dataLabelsY, d = t.barDataLabelsConfig, g = t.strokeWidth, u = t.offX, p = t.offY;
                l = Math.abs(l);
                var f = "vertical" === i.config.plotOptions.bar.dataLabels.orientation;
                o -= g / 2;
                var x = i.globals.gridWidth / i.globals.dataPoints;
                if (e = i.globals.isXNumeric ? o - n / 2 + u : o - x + n / 2 + u, f) e = e + h.height / 2 - g / 2 - 2;
                var b = this.barCtx.series[a][s] < 0, v = r;
                switch(this.barCtx.isReversed && (v = r - l + (b ? 2 * l : 0), r -= l), d.position){
                    case "center":
                        c = f ? b ? v + l / 2 + p : v + l / 2 - p : b ? v - l / 2 + h.height / 2 + p : v + l / 2 + h.height / 2 - p;
                        break;
                    case "bottom":
                        c = f ? b ? v + l + p : v + l - p : b ? v - l + h.height + g + p : v + l - h.height / 2 + g - p;
                        break;
                    case "top":
                        c = f ? b ? v + p : v - p : b ? v - h.height / 2 - p : v + h.height + p;
                }
                return i.config.chart.stacked || (c < 0 ? c = 0 + g : c + h.height / 3 > i.globals.gridHeight && (c = i.globals.gridHeight - g)), {
                    bcx: o,
                    bcy: r,
                    dataLabelsX: e,
                    dataLabelsY: c
                };
            }
        },
        {
            key: "calculateBarsDataLabelsPosition",
            value: function(t) {
                var e = this.w, i = t.x, a = t.i, s = t.j, r = t.bcy, o = t.barHeight, n = t.barWidth, l = t.textRects, h = t.dataLabelsX, c = t.strokeWidth, d = t.barDataLabelsConfig, g = t.offX, u = t.offY, p = e.globals.gridHeight / e.globals.dataPoints;
                n = Math.abs(n);
                var f = r - (this.barCtx.isRangeBar ? 0 : p) + o / 2 + l.height / 2 + u - 3, x = this.barCtx.series[a][s] < 0, b = i;
                switch(this.barCtx.isReversed && (b = i + n - (x ? 2 * n : 0), i = e.globals.gridWidth - n), d.position){
                    case "center":
                        h = x ? b + n / 2 - g : Math.max(l.width / 2, b - n / 2) + g;
                        break;
                    case "bottom":
                        h = x ? b + n - c - Math.round(l.width / 2) - g : b - n + c + Math.round(l.width / 2) + g;
                        break;
                    case "top":
                        h = x ? b - c + Math.round(l.width / 2) - g : b - c - Math.round(l.width / 2) + g;
                }
                return e.config.chart.stacked || (h < 0 ? h = h + l.width + c : h + l.width / 2 > e.globals.gridWidth && (h = e.globals.gridWidth - l.width - c)), {
                    bcx: i,
                    bcy: r,
                    dataLabelsX: h,
                    dataLabelsY: f
                };
            }
        },
        {
            key: "drawCalculatedDataLabels",
            value: function(t) {
                var i = t.x, a = t.y, s = t.val, r = t.i, o = t.j, n = t.textRects, l = t.barHeight, h = t.barWidth, c = t.dataLabelsConfig, d = this.w, g = "rotate(0)";
                "vertical" === d.config.plotOptions.bar.dataLabels.orientation && (g = "rotate(-90, ".concat(i, ", ").concat(a, ")"));
                var u = new $b705b473d3ec9641$var$M(this.barCtx.ctx), p = new $b705b473d3ec9641$var$b(this.barCtx.ctx), f = c.formatter, x = null, v = d.globals.collapsedSeriesIndices.indexOf(r) > -1;
                if (c.enabled && !v) {
                    x = p.group({
                        class: "apexcharts-data-labels",
                        transform: g
                    });
                    var m = "";
                    void 0 !== s && (m = f(s, {
                        seriesIndex: r,
                        dataPointIndex: o,
                        w: d
                    }));
                    var y = d.globals.series[r][o] < 0, w = d.config.plotOptions.bar.dataLabels.position;
                    if ("vertical" === d.config.plotOptions.bar.dataLabels.orientation && ("top" === w && (c.textAnchor = y ? "end" : "start"), "center" === w && (c.textAnchor = "middle"), "bottom" === w && (c.textAnchor = y ? "end" : "start")), this.barCtx.isRangeBar && this.barCtx.barOptions.dataLabels.hideOverflowingLabels) h < p.getTextRects(m, parseFloat(c.style.fontSize)).width && (m = "");
                    d.config.chart.stacked && this.barCtx.barOptions.dataLabels.hideOverflowingLabels && (this.barCtx.isHorizontal ? n.width / 1.6 > Math.abs(h) && (m = "") : n.height / 1.6 > Math.abs(l) && (m = ""));
                    var k = $b705b473d3ec9641$var$e({}, c);
                    this.barCtx.isHorizontal && s < 0 && ("start" === c.textAnchor ? k.textAnchor = "end" : "end" === c.textAnchor && (k.textAnchor = "start")), u.plotDataLabelsText({
                        x: i,
                        y: a,
                        text: m,
                        i: r,
                        j: o,
                        parent: x,
                        dataLabelsConfig: k,
                        alwaysDrawDataLabel: !0,
                        offsetCorrection: !0
                    });
                }
                return x;
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$z = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.ctx = e, this.w = e.w, this.legendInactiveClass = "legend-mouseover-inactive";
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "getAllSeriesEls",
            value: function() {
                return this.w.globals.dom.baseEl.getElementsByClassName("apexcharts-series");
            }
        },
        {
            key: "getSeriesByName",
            value: function(t) {
                return this.w.globals.dom.baseEl.querySelector(".apexcharts-inner .apexcharts-series[seriesName='".concat($b705b473d3ec9641$var$p.escapeString(t), "']"));
            }
        },
        {
            key: "isSeriesHidden",
            value: function(t) {
                var e = this.getSeriesByName(t), i = parseInt(e.getAttribute("data:realIndex"), 10);
                return {
                    isHidden: e.classList.contains("apexcharts-series-collapsed"),
                    realIndex: i
                };
            }
        },
        {
            key: "addCollapsedClassToSeries",
            value: function(t, e) {
                var i = this.w;
                function a(i) {
                    for(var a = 0; a < i.length; a++)i[a].index === e && t.node.classList.add("apexcharts-series-collapsed");
                }
                a(i.globals.collapsedSeries), a(i.globals.ancillaryCollapsedSeries);
            }
        },
        {
            key: "toggleSeries",
            value: function(t) {
                var e = this.isSeriesHidden(t);
                return this.ctx.legend.legendHelpers.toggleDataSeries(e.realIndex, e.isHidden), e.isHidden;
            }
        },
        {
            key: "showSeries",
            value: function(t) {
                var e = this.isSeriesHidden(t);
                e.isHidden && this.ctx.legend.legendHelpers.toggleDataSeries(e.realIndex, !0);
            }
        },
        {
            key: "hideSeries",
            value: function(t) {
                var e = this.isSeriesHidden(t);
                e.isHidden || this.ctx.legend.legendHelpers.toggleDataSeries(e.realIndex, !1);
            }
        },
        {
            key: "resetSeries",
            value: function() {
                var t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0], e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2], a = this.w, s = $b705b473d3ec9641$var$p.clone(a.globals.initialSeries);
                a.globals.previousPaths = [], i ? (a.globals.collapsedSeries = [], a.globals.ancillaryCollapsedSeries = [], a.globals.collapsedSeriesIndices = [], a.globals.ancillaryCollapsedSeriesIndices = []) : s = this.emptyCollapsedSeries(s), a.config.series = s, t && (e && (a.globals.zoomed = !1, this.ctx.updateHelpers.revertDefaultAxisMinMax()), this.ctx.updateHelpers._updateSeries(s, a.config.chart.animations.dynamicAnimation.enabled));
            }
        },
        {
            key: "emptyCollapsedSeries",
            value: function(t) {
                for(var e = this.w, i = 0; i < t.length; i++)e.globals.collapsedSeriesIndices.indexOf(i) > -1 && (t[i].data = []);
                return t;
            }
        },
        {
            key: "toggleSeriesOnHover",
            value: function(t, e) {
                var i = this.w;
                e || (e = t.target);
                var a = i.globals.dom.baseEl.querySelectorAll(".apexcharts-series, .apexcharts-datalabels");
                if ("mousemove" === t.type) {
                    var s = parseInt(e.getAttribute("rel"), 10) - 1, r = null, o = null;
                    i.globals.axisCharts || "radialBar" === i.config.chart.type ? i.globals.axisCharts ? (r = i.globals.dom.baseEl.querySelector(".apexcharts-series[data\\:realIndex='".concat(s, "']")), o = i.globals.dom.baseEl.querySelector(".apexcharts-datalabels[data\\:realIndex='".concat(s, "']"))) : r = i.globals.dom.baseEl.querySelector(".apexcharts-series[rel='".concat(s + 1, "']")) : r = i.globals.dom.baseEl.querySelector(".apexcharts-series[rel='".concat(s + 1, "'] path"));
                    for(var n = 0; n < a.length; n++)a[n].classList.add(this.legendInactiveClass);
                    null !== r && (i.globals.axisCharts || r.parentNode.classList.remove(this.legendInactiveClass), r.classList.remove(this.legendInactiveClass), null !== o && o.classList.remove(this.legendInactiveClass));
                } else if ("mouseout" === t.type) for(var l = 0; l < a.length; l++)a[l].classList.remove(this.legendInactiveClass);
            }
        },
        {
            key: "highlightRangeInSeries",
            value: function(t, e) {
                var i = this, a = this.w, s = a.globals.dom.baseEl.getElementsByClassName("apexcharts-heatmap-rect"), r = function(t) {
                    for(var e = 0; e < s.length; e++)s[e].classList[t](i.legendInactiveClass);
                };
                if ("mousemove" === t.type) {
                    var o = parseInt(e.getAttribute("rel"), 10) - 1;
                    r("add"), function(t) {
                        for(var e = 0; e < s.length; e++){
                            var a = parseInt(s[e].getAttribute("val"), 10);
                            a >= t.from && a <= t.to && s[e].classList.remove(i.legendInactiveClass);
                        }
                    }(a.config.plotOptions.heatmap.colorScale.ranges[o]);
                } else "mouseout" === t.type && r("remove");
            }
        },
        {
            key: "getActiveConfigSeriesIndex",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] && arguments[0], e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "asc", i = this.w, a = 0;
                if (i.config.series.length > 1) {
                    for(var s = i.config.series.map(function(e, a) {
                        var s = !1;
                        return t && (s = "bar" === i.config.series[a].type || "column" === i.config.series[a].type), e.data && e.data.length > 0 && !s ? a : -1;
                    }), r = "asc" === e ? 0 : s.length - 1; "asc" === e ? r < s.length : r >= 0; "asc" === e ? r++ : r--)if (-1 !== s[r]) {
                        a = s[r];
                        break;
                    }
                }
                return a;
            }
        },
        {
            key: "getPreviousPaths",
            value: function() {
                var t = this.w;
                function e(e, i, a) {
                    for(var s = e[i].childNodes, r = {
                        type: a,
                        paths: [],
                        realIndex: e[i].getAttribute("data:realIndex")
                    }, o = 0; o < s.length; o++)if (s[o].hasAttribute("pathTo")) {
                        var n = s[o].getAttribute("pathTo");
                        r.paths.push({
                            d: n
                        });
                    }
                    t.globals.previousPaths.push(r);
                }
                t.globals.previousPaths = [];
                [
                    "line",
                    "area",
                    "bar",
                    "rangebar",
                    "candlestick",
                    "radar"
                ].forEach(function(i) {
                    for(var a, s = (a = i, t.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(a, "-series .apexcharts-series"))), r = 0; r < s.length; r++)e(s, r, i);
                }), this.handlePrevBubbleScatterPaths("bubble"), this.handlePrevBubbleScatterPaths("scatter");
                var i = t.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(t.config.chart.type, " .apexcharts-series"));
                if (i.length > 0) for(var a = function(e) {
                    for(var i = t.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(t.config.chart.type, " .apexcharts-series[data\\:realIndex='").concat(e, "'] rect")), a = [], s = function(t) {
                        var e = function(e) {
                            return i[t].getAttribute(e);
                        }, s = {
                            x: parseFloat(e("x")),
                            y: parseFloat(e("y")),
                            width: parseFloat(e("width")),
                            height: parseFloat(e("height"))
                        };
                        a.push({
                            rect: s,
                            color: i[t].getAttribute("color")
                        });
                    }, r = 0; r < i.length; r++)s(r);
                    t.globals.previousPaths.push(a);
                }, s = 0; s < i.length; s++)a(s);
                t.globals.axisCharts || (t.globals.previousPaths = t.globals.series);
            }
        },
        {
            key: "handlePrevBubbleScatterPaths",
            value: function(t) {
                var e = this.w, i = e.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(t, "-series .apexcharts-series"));
                if (i.length > 0) for(var a = 0; a < i.length; a++){
                    for(var s = e.globals.dom.baseEl.querySelectorAll(".apexcharts-".concat(t, "-series .apexcharts-series[data\\:realIndex='").concat(a, "'] circle")), r = [], o = 0; o < s.length; o++)r.push({
                        x: s[o].getAttribute("cx"),
                        y: s[o].getAttribute("cy"),
                        r: s[o].getAttribute("r")
                    });
                    e.globals.previousPaths.push(r);
                }
            }
        },
        {
            key: "clearPreviousPaths",
            value: function() {
                var t = this.w;
                t.globals.previousPaths = [], t.globals.allSeriesCollapsed = !1;
            }
        },
        {
            key: "handleNoData",
            value: function() {
                var t = this.w, e = t.config.noData, i = new $b705b473d3ec9641$var$b(this.ctx), a = t.globals.svgWidth / 2, s = t.globals.svgHeight / 2, r = "middle";
                if (t.globals.noData = !0, t.globals.animationEnded = !0, "left" === e.align ? (a = 10, r = "start") : "right" === e.align && (a = t.globals.svgWidth - 10, r = "end"), "top" === e.verticalAlign ? s = 50 : "bottom" === e.verticalAlign && (s = t.globals.svgHeight - 50), a += e.offsetX, s = s + parseInt(e.style.fontSize, 10) + 2 + e.offsetY, void 0 !== e.text && "" !== e.text) {
                    var o = i.drawText({
                        x: a,
                        y: s,
                        text: e.text,
                        textAnchor: r,
                        fontSize: e.style.fontSize,
                        fontFamily: e.style.fontFamily,
                        foreColor: e.style.color,
                        opacity: 1,
                        class: "apexcharts-text-nodata"
                    });
                    t.globals.dom.Paper.add(o);
                }
            }
        },
        {
            key: "setNullSeriesToZeroValues",
            value: function(t) {
                for(var e = this.w, i = 0; i < t.length; i++)if (0 === t[i].length) for(var a = 0; a < t[e.globals.maxValsInArrayIndex].length; a++)t[i].push(0);
                return t;
            }
        },
        {
            key: "hasAllSeriesEqualX",
            value: function() {
                for(var t = !0, e = this.w, i = this.filteredSeriesX(), a = 0; a < i.length - 1; a++)if (i[a][0] !== i[a + 1][0]) {
                    t = !1;
                    break;
                }
                return e.globals.allSeriesHasEqualX = t, t;
            }
        },
        {
            key: "filteredSeriesX",
            value: function() {
                var t = this.w.globals.seriesX.map(function(t) {
                    return t.length > 0 ? t : [];
                });
                return t;
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$X = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.w = e.w, this.barCtx = e;
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "initVariables",
            value: function(t) {
                var e = this.w;
                this.barCtx.series = t, this.barCtx.totalItems = 0, this.barCtx.seriesLen = 0, this.barCtx.visibleI = -1, this.barCtx.visibleItems = 1;
                for(var i = 0; i < t.length; i++)if (t[i].length > 0 && (this.barCtx.seriesLen = this.barCtx.seriesLen + 1, this.barCtx.totalItems += t[i].length), e.globals.isXNumeric) for(var a = 0; a < t[i].length; a++)e.globals.seriesX[i][a] > e.globals.minX && e.globals.seriesX[i][a] < e.globals.maxX && this.barCtx.visibleItems++;
                else this.barCtx.visibleItems = e.globals.dataPoints;
                0 === this.barCtx.seriesLen && (this.barCtx.seriesLen = 1), this.barCtx.zeroSerieses = [], this.barCtx.radiusOnSeriesNumber = t.length - 1, e.globals.comboCharts || this.checkZeroSeries({
                    series: t
                });
            }
        },
        {
            key: "initialPositions",
            value: function() {
                var t, e, i, a, s, r, o, n, l = this.w, h = l.globals.dataPoints;
                this.barCtx.isRangeBar && (h = l.globals.labels.length);
                var c = this.barCtx.seriesLen;
                if (l.config.plotOptions.bar.rangeBarGroupRows && (c = 1), this.barCtx.isHorizontal) s = (i = l.globals.gridHeight / h) / c, l.globals.isXNumeric && (s = (i = l.globals.gridHeight / this.barCtx.totalItems) / this.barCtx.seriesLen), s = s * parseInt(this.barCtx.barOptions.barHeight, 10) / 100, n = this.barCtx.baseLineInvertedY + l.globals.padHorizontal + (this.barCtx.isReversed ? l.globals.gridWidth : 0) - (this.barCtx.isReversed ? 2 * this.barCtx.baseLineInvertedY : 0), e = (i - s * this.barCtx.seriesLen) / 2;
                else {
                    if (a = l.globals.gridWidth / this.barCtx.visibleItems, l.config.xaxis.convertedCatToNumeric && (a = l.globals.gridWidth / l.globals.dataPoints), r = a / this.barCtx.seriesLen * parseInt(this.barCtx.barOptions.columnWidth, 10) / 100, l.globals.isXNumeric) {
                        var d = this.barCtx.xRatio;
                        l.config.xaxis.convertedCatToNumeric && (d = this.barCtx.initialXRatio), l.globals.minXDiff && .5 !== l.globals.minXDiff && l.globals.minXDiff / d > 0 && (a = l.globals.minXDiff / d), (r = a / this.barCtx.seriesLen * parseInt(this.barCtx.barOptions.columnWidth, 10) / 100) < 1 && (r = 1);
                    }
                    o = l.globals.gridHeight - this.barCtx.baseLineY[this.barCtx.yaxisIndex] - (this.barCtx.isReversed ? l.globals.gridHeight : 0) + (this.barCtx.isReversed ? 2 * this.barCtx.baseLineY[this.barCtx.yaxisIndex] : 0), t = l.globals.padHorizontal + (a - r * this.barCtx.seriesLen) / 2;
                }
                return {
                    x: t,
                    y: e,
                    yDivision: i,
                    xDivision: a,
                    barHeight: s,
                    barWidth: r,
                    zeroH: o,
                    zeroW: n
                };
            }
        },
        {
            key: "getPathFillColor",
            value: function(t, e, i, a) {
                var s = this.w, r = new $b705b473d3ec9641$var$L(this.barCtx.ctx), o = null, n = this.barCtx.barOptions.distributed ? i : e;
                this.barCtx.barOptions.colors.ranges.length > 0 && this.barCtx.barOptions.colors.ranges.map(function(a) {
                    t[e][i] >= a.from && t[e][i] <= a.to && (o = a.color);
                });
                return s.config.series[e].data[i] && s.config.series[e].data[i].fillColor && (o = s.config.series[e].data[i].fillColor), r.fillPath({
                    seriesNumber: this.barCtx.barOptions.distributed ? n : a,
                    dataPointIndex: i,
                    color: o,
                    value: t[e][i]
                });
            }
        },
        {
            key: "getStrokeWidth",
            value: function(t, e, i) {
                var a = 0, s = this.w;
                return void 0 === this.barCtx.series[t][e] || null === this.barCtx.series[t][e] ? this.barCtx.isNullValue = !0 : this.barCtx.isNullValue = !1, s.config.stroke.show && (this.barCtx.isNullValue || (a = Array.isArray(this.barCtx.strokeWidth) ? this.barCtx.strokeWidth[i] : this.barCtx.strokeWidth)), a;
            }
        },
        {
            key: "barBackground",
            value: function(t) {
                var e = t.j, i = t.i, a = t.x1, s = t.x2, r = t.y1, o = t.y2, n = t.elSeries, l = this.w, h = new $b705b473d3ec9641$var$b(this.barCtx.ctx), c = new $b705b473d3ec9641$var$z(this.barCtx.ctx).getActiveConfigSeriesIndex();
                if (this.barCtx.barOptions.colors.backgroundBarColors.length > 0 && c === i) {
                    e >= this.barCtx.barOptions.colors.backgroundBarColors.length && (e -= this.barCtx.barOptions.colors.backgroundBarColors.length);
                    var d = this.barCtx.barOptions.colors.backgroundBarColors[e], g = h.drawRect(void 0 !== a ? a : 0, void 0 !== r ? r : 0, void 0 !== s ? s : l.globals.gridWidth, void 0 !== o ? o : l.globals.gridHeight, this.barCtx.barOptions.colors.backgroundBarRadius, d, this.barCtx.barOptions.colors.backgroundBarOpacity);
                    n.add(g), g.node.classList.add("apexcharts-backgroundBar");
                }
            }
        },
        {
            key: "getColumnPaths",
            value: function(t) {
                var e = t.barWidth, i = t.barXPosition, a = t.yRatio, s = t.y1, r = t.y2, o = t.strokeWidth, n = t.series, l = t.realIndex, h = t.i, c = t.j, d = t.w, g = new $b705b473d3ec9641$var$b(this.barCtx.ctx);
                (o = Array.isArray(o) ? o[l] : o) || (o = 0);
                var u = {
                    barWidth: e,
                    strokeWidth: o,
                    yRatio: a,
                    barXPosition: i,
                    y1: s,
                    y2: r
                }, p = this.getRoundedBars(d, u, n, h, c), f = i, x = i + e, v = g.move(f, s), m = g.move(f, s), y = g.line(x - o, s);
                return d.globals.previousPaths.length > 0 && (m = this.barCtx.getPreviousPath(l, c, !1)), v = v + g.line(f, p.y2) + p.pathWithRadius + g.line(x - o, p.y2) + y + y + "z", m = m + g.line(f, s) + y + y + y + y + y + g.line(f, s), d.config.chart.stacked && (this.barCtx.yArrj.push(p.y2), this.barCtx.yArrjF.push(Math.abs(s - p.y2)), this.barCtx.yArrjVal.push(this.barCtx.series[h][c])), {
                    pathTo: v,
                    pathFrom: m
                };
            }
        },
        {
            key: "getBarpaths",
            value: function(t) {
                var e = t.barYPosition, i = t.barHeight, a = t.x1, s = t.x2, r = t.strokeWidth, o = t.series, n = t.realIndex, l = t.i, h = t.j, c = t.w, d = new $b705b473d3ec9641$var$b(this.barCtx.ctx);
                (r = Array.isArray(r) ? r[n] : r) || (r = 0);
                var g = {
                    barHeight: i,
                    strokeWidth: r,
                    barYPosition: e,
                    x2: s,
                    x1: a
                }, u = this.getRoundedBars(c, g, o, l, h), p = d.move(a, e), f = d.move(a, e);
                c.globals.previousPaths.length > 0 && (f = this.barCtx.getPreviousPath(n, h, !1));
                var x = e, v = e + i, m = d.line(a, v - r);
                return p = p + d.line(u.x2, x) + u.pathWithRadius + d.line(u.x2, v - r) + m + m + "z", f = f + d.line(a, x) + m + m + m + m + m + d.line(a, x), c.config.chart.stacked && (this.barCtx.xArrj.push(u.x2), this.barCtx.xArrjF.push(Math.abs(a - u.x2)), this.barCtx.xArrjVal.push(this.barCtx.series[l][h])), {
                    pathTo: p,
                    pathFrom: f
                };
            }
        },
        {
            key: "getRoundedBars",
            value: function(t, e, i, a, s) {
                var r = new $b705b473d3ec9641$var$b(this.barCtx.ctx), o = 0, n = t.config.plotOptions.bar.borderRadius, l = Array.isArray(n);
                l ? o = n[a > n.length - 1 ? n.length - 1 : a] : o = n;
                if (t.config.chart.stacked && i.length > 1 && a !== this.barCtx.radiusOnSeriesNumber && !l && (o = 0), this.barCtx.isHorizontal) {
                    var h = "", c = e.x2;
                    if (Math.abs(e.x1 - e.x2) < o && (o = Math.abs(e.x1 - e.x2)), void 0 !== i[a][s] || null !== i[a][s]) {
                        var d = this.barCtx.isReversed ? i[a][s] > 0 : i[a][s] < 0;
                        d && (o *= -1), c -= o, h = r.quadraticCurve(c + o, e.barYPosition, c + o, e.barYPosition + (d ? -1 * o : o)) + r.line(c + o, e.barYPosition + e.barHeight - e.strokeWidth - (d ? -1 * o : o)) + r.quadraticCurve(c + o, e.barYPosition + e.barHeight - e.strokeWidth, c, e.barYPosition + e.barHeight - e.strokeWidth);
                    }
                    return {
                        pathWithRadius: h,
                        x2: c
                    };
                }
                var g = "", u = e.y2;
                if (Math.abs(e.y1 - e.y2) < o && (o = Math.abs(e.y1 - e.y2)), void 0 !== i[a][s] || null !== i[a][s]) {
                    var p = i[a][s] < 0;
                    p && (o *= -1), u += o, g = r.quadraticCurve(e.barXPosition, u - o, e.barXPosition + (p ? -1 * o : o), u - o) + r.line(e.barXPosition + e.barWidth - e.strokeWidth - (p ? -1 * o : o), u - o) + r.quadraticCurve(e.barXPosition + e.barWidth - e.strokeWidth, u - o, e.barXPosition + e.barWidth - e.strokeWidth, u);
                }
                return {
                    pathWithRadius: g,
                    y2: u
                };
            }
        },
        {
            key: "checkZeroSeries",
            value: function(t) {
                for(var e = t.series, i = this.w, a = 0; a < e.length; a++){
                    for(var s = 0, r = 0; r < e[i.globals.maxValsInArrayIndex].length; r++)s += e[a][r];
                    0 === s && this.barCtx.zeroSerieses.push(a);
                }
                for(var o = e.length - 1; o >= 0; o--)this.barCtx.zeroSerieses.indexOf(o) > -1 && o === this.radiusOnSeriesNumber && (this.barCtx.radiusOnSeriesNumber -= 1);
                for(var n = e.length - 1; n >= 0; n--)i.globals.collapsedSeriesIndices.indexOf(this.barCtx.radiusOnSeriesNumber) > -1 && (this.barCtx.radiusOnSeriesNumber -= 1);
            }
        },
        {
            key: "getXForValue",
            value: function(t, e) {
                var i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2], a = i ? e : null;
                return null != t && (a = e + t / this.barCtx.invertedYRatio - 2 * (this.barCtx.isReversed ? t / this.barCtx.invertedYRatio : 0)), a;
            }
        },
        {
            key: "getYForValue",
            value: function(t, e) {
                var i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2], a = i ? e : null;
                return null != t && (a = e - t / this.barCtx.yRatio[this.barCtx.yaxisIndex] + 2 * (this.barCtx.isReversed ? t / this.barCtx.yRatio[this.barCtx.yaxisIndex] : 0)), a;
            }
        },
        {
            key: "getGoalValues",
            value: function(t, e, i, a, s) {
                var r = this, n = this.w, l = [];
                return n.globals.seriesGoals[a] && n.globals.seriesGoals[a][s] && Array.isArray(n.globals.seriesGoals[a][s]) && n.globals.seriesGoals[a][s].forEach(function(a) {
                    var s;
                    l.push(($b705b473d3ec9641$var$o(s = {}, t, "x" === t ? r.getXForValue(a.value, e, !1) : r.getYForValue(a.value, i, !1)), $b705b473d3ec9641$var$o(s, "attrs", a), s));
                }), l;
            }
        },
        {
            key: "drawGoalLine",
            value: function(t) {
                var e = t.barXPosition, i = t.barYPosition, a = t.goalX, s = t.goalY, r = t.barWidth, o = t.barHeight, n = new $b705b473d3ec9641$var$b(this.barCtx.ctx), l = n.group({
                    className: "apexcharts-bar-goals-groups"
                }), h = null;
                return this.barCtx.isHorizontal ? Array.isArray(a) && a.forEach(function(t) {
                    var e = void 0 !== t.attrs.strokeHeight ? t.attrs.strokeHeight : o / 2, a = i + e + o / 2;
                    h = n.drawLine(t.x, a - 2 * e, t.x, a, t.attrs.strokeColor ? t.attrs.strokeColor : void 0, t.attrs.strokeDashArray, t.attrs.strokeWidth ? t.attrs.strokeWidth : 2, t.attrs.strokeLineCap), l.add(h);
                }) : Array.isArray(s) && s.forEach(function(t) {
                    var i = void 0 !== t.attrs.strokeWidth ? t.attrs.strokeWidth : r / 2, a = e + i + r / 2;
                    h = n.drawLine(a - 2 * i, t.y, a, t.y, t.attrs.strokeColor ? t.attrs.strokeColor : void 0, t.attrs.strokeDashArray, t.attrs.strokeHeight ? t.attrs.strokeHeight : 2, t.attrs.strokeLineCap), l.add(h);
                }), l;
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$E = function() {
    function t(e, i) {
        $b705b473d3ec9641$var$a(this, t), this.ctx = e, this.w = e.w;
        var s = this.w;
        this.barOptions = s.config.plotOptions.bar, this.isHorizontal = this.barOptions.horizontal, this.strokeWidth = s.config.stroke.width, this.isNullValue = !1, this.isRangeBar = s.globals.seriesRangeBar.length && this.isHorizontal, this.xyRatios = i, null !== this.xyRatios && (this.xRatio = i.xRatio, this.initialXRatio = i.initialXRatio, this.yRatio = i.yRatio, this.invertedXRatio = i.invertedXRatio, this.invertedYRatio = i.invertedYRatio, this.baseLineY = i.baseLineY, this.baseLineInvertedY = i.baseLineInvertedY), this.yaxisIndex = 0, this.seriesLen = 0, this.barHelpers = new $b705b473d3ec9641$var$X(this);
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "draw",
            value: function(t, i) {
                var a = this.w, s = new $b705b473d3ec9641$var$b(this.ctx), r = new $b705b473d3ec9641$var$y(this.ctx, a);
                t = r.getLogSeries(t), this.series = t, this.yRatio = r.getLogYRatios(this.yRatio), this.barHelpers.initVariables(t);
                var o = s.group({
                    class: "apexcharts-bar-series apexcharts-plot-series"
                });
                a.config.dataLabels.enabled && this.totalItems > this.barOptions.dataLabels.maxItems && console.warn("WARNING: DataLabels are enabled but there are too many to display. This may cause performance issue when rendering.");
                for(var n = 0, l = 0; n < t.length; n++, l++){
                    var h, c, d, g, u = void 0, f = void 0, x = [], v = [], m = a.globals.comboCharts ? i[n] : n, w = s.group({
                        class: "apexcharts-series",
                        rel: n + 1,
                        seriesName: $b705b473d3ec9641$var$p.escapeString(a.globals.seriesNames[m]),
                        "data:realIndex": m
                    });
                    this.ctx.series.addCollapsedClassToSeries(w, m), t[n].length > 0 && (this.visibleI = this.visibleI + 1);
                    var k = 0, A = 0;
                    this.yRatio.length > 1 && (this.yaxisIndex = m), this.isReversed = a.config.yaxis[this.yaxisIndex] && a.config.yaxis[this.yaxisIndex].reversed;
                    var S = this.barHelpers.initialPositions();
                    f = S.y, k = S.barHeight, c = S.yDivision, g = S.zeroW, u = S.x, A = S.barWidth, h = S.xDivision, d = S.zeroH, this.horizontal || v.push(u + A / 2);
                    for(var C = s.group({
                        class: "apexcharts-datalabels",
                        "data:realIndex": m
                    }), L = s.group({
                        class: "apexcharts-bar-goals-markers",
                        style: "pointer-events: none"
                    }), P = 0; P < a.globals.dataPoints; P++){
                        var T = this.barHelpers.getStrokeWidth(n, P, m), M = null, I = {
                            indexes: {
                                i: n,
                                j: P,
                                realIndex: m,
                                bc: l
                            },
                            x: u,
                            y: f,
                            strokeWidth: T,
                            elSeries: w
                        };
                        this.isHorizontal ? (M = this.drawBarPaths($b705b473d3ec9641$var$e($b705b473d3ec9641$var$e({}, I), {}, {
                            barHeight: k,
                            zeroW: g,
                            yDivision: c
                        })), A = this.series[n][P] / this.invertedYRatio) : (M = this.drawColumnPaths($b705b473d3ec9641$var$e($b705b473d3ec9641$var$e({}, I), {}, {
                            xDivision: h,
                            barWidth: A,
                            zeroH: d
                        })), k = this.series[n][P] / this.yRatio[this.yaxisIndex]);
                        var z = this.barHelpers.drawGoalLine({
                            barXPosition: M.barXPosition,
                            barYPosition: M.barYPosition,
                            goalX: M.goalX,
                            goalY: M.goalY,
                            barHeight: k,
                            barWidth: A
                        });
                        z && L.add(z), f = M.y, u = M.x, P > 0 && v.push(u + A / 2), x.push(f);
                        var X = this.barHelpers.getPathFillColor(t, n, P, m);
                        this.renderSeries({
                            realIndex: m,
                            pathFill: X,
                            j: P,
                            i: n,
                            pathFrom: M.pathFrom,
                            pathTo: M.pathTo,
                            strokeWidth: T,
                            elSeries: w,
                            x: u,
                            y: f,
                            series: t,
                            barHeight: k,
                            barWidth: A,
                            elDataLabelsWrap: C,
                            elGoalsMarkers: L,
                            visibleSeries: this.visibleI,
                            type: "bar"
                        });
                    }
                    a.globals.seriesXvalues[m] = v, a.globals.seriesYvalues[m] = x, o.add(w);
                }
                return o;
            }
        },
        {
            key: "renderSeries",
            value: function(t) {
                var e = t.realIndex, i = t.pathFill, a = t.lineFill, s = t.j, r = t.i, o = t.pathFrom, n = t.pathTo, l = t.strokeWidth, h = t.elSeries, c = t.x, d = t.y, g = t.y1, u = t.y2, p = t.series, f = t.barHeight, v = t.barWidth, m = t.barYPosition, y = t.elDataLabelsWrap, w = t.elGoalsMarkers, k = t.visibleSeries, A = t.type, S = this.w, C = new $b705b473d3ec9641$var$b(this.ctx);
                a || (a = this.barOptions.distributed ? S.globals.stroke.colors[s] : S.globals.stroke.colors[e]), S.config.series[r].data[s] && S.config.series[r].data[s].strokeColor && (a = S.config.series[r].data[s].strokeColor), this.isNullValue && (i = "none");
                var L = s / S.config.chart.animations.animateGradually.delay * (S.config.chart.animations.speed / S.globals.dataPoints) / 2.4, P = C.renderPaths({
                    i: r,
                    j: s,
                    realIndex: e,
                    pathFrom: o,
                    pathTo: n,
                    stroke: a,
                    strokeWidth: l,
                    strokeLineCap: S.config.stroke.lineCap,
                    fill: i,
                    animationDelay: L,
                    initialSpeed: S.config.chart.animations.speed,
                    dataChangeSpeed: S.config.chart.animations.dynamicAnimation.speed,
                    className: "apexcharts-".concat(A, "-area")
                });
                P.attr("clip-path", "url(#gridRectMask".concat(S.globals.cuid, ")"));
                var T = S.config.forecastDataPoints;
                T.count > 0 && s >= S.globals.dataPoints - T.count && (P.node.setAttribute("stroke-dasharray", T.dashArray), P.node.setAttribute("stroke-width", T.strokeWidth), P.node.setAttribute("fill-opacity", T.fillOpacity)), void 0 !== g && void 0 !== u && (P.attr("data-range-y1", g), P.attr("data-range-y2", u)), new $b705b473d3ec9641$var$x(this.ctx).setSelectionFilter(P, e, s), h.add(P);
                var M = new $b705b473d3ec9641$var$I(this).handleBarDataLabels({
                    x: c,
                    y: d,
                    y1: g,
                    y2: u,
                    i: r,
                    j: s,
                    series: p,
                    realIndex: e,
                    barHeight: f,
                    barWidth: v,
                    barYPosition: m,
                    renderedPath: P,
                    visibleSeries: k
                });
                return null !== M && y.add(M), h.add(y), w && h.add(w), h;
            }
        },
        {
            key: "drawBarPaths",
            value: function(t) {
                var e = t.indexes, i = t.barHeight, a = t.strokeWidth, s = t.zeroW, r = t.x, o = t.y, n = t.yDivision, l = t.elSeries, h = this.w, c = e.i, d = e.j;
                h.globals.isXNumeric && (o = (h.globals.seriesX[c][d] - h.globals.minX) / this.invertedXRatio - i);
                var g = o + i * this.visibleI;
                r = this.barHelpers.getXForValue(this.series[c][d], s);
                var u = this.barHelpers.getBarpaths({
                    barYPosition: g,
                    barHeight: i,
                    x1: s,
                    x2: r,
                    strokeWidth: a,
                    series: this.series,
                    realIndex: e.realIndex,
                    i: c,
                    j: d,
                    w: h
                });
                return h.globals.isXNumeric || (o += n), this.barHelpers.barBackground({
                    j: d,
                    i: c,
                    y1: g - i * this.visibleI,
                    y2: i * this.seriesLen,
                    elSeries: l
                }), {
                    pathTo: u.pathTo,
                    pathFrom: u.pathFrom,
                    x: r,
                    y: o,
                    goalX: this.barHelpers.getGoalValues("x", s, null, c, d),
                    barYPosition: g
                };
            }
        },
        {
            key: "drawColumnPaths",
            value: function(t) {
                var e = t.indexes, i = t.x, a = t.y, s = t.xDivision, r = t.barWidth, o = t.zeroH, n = t.strokeWidth, l = t.elSeries, h = this.w, c = e.realIndex, d = e.i, g = e.j, u = e.bc;
                if (h.globals.isXNumeric) {
                    var p = c;
                    h.globals.seriesX[c].length || (p = h.globals.maxValsInArrayIndex), i = (h.globals.seriesX[p][g] - h.globals.minX) / this.xRatio - r * this.seriesLen / 2;
                }
                var f = i + r * this.visibleI;
                a = this.barHelpers.getYForValue(this.series[d][g], o);
                var x = this.barHelpers.getColumnPaths({
                    barXPosition: f,
                    barWidth: r,
                    y1: o,
                    y2: a,
                    strokeWidth: n,
                    series: this.series,
                    realIndex: e.realIndex,
                    i: d,
                    j: g,
                    w: h
                });
                return h.globals.isXNumeric || (i += s), this.barHelpers.barBackground({
                    bc: u,
                    j: g,
                    i: d,
                    x1: f - n / 2 - r * this.visibleI,
                    x2: r * this.seriesLen + n / 2,
                    elSeries: l
                }), {
                    pathTo: x.pathTo,
                    pathFrom: x.pathFrom,
                    x: i,
                    y: a,
                    goalY: this.barHelpers.getGoalValues("y", null, o, d, g),
                    barXPosition: f
                };
            }
        },
        {
            key: "getPreviousPath",
            value: function(t, e) {
                for(var i, a = this.w, s = 0; s < a.globals.previousPaths.length; s++){
                    var r = a.globals.previousPaths[s];
                    r.paths && r.paths.length > 0 && parseInt(r.realIndex, 10) === parseInt(t, 10) && void 0 !== a.globals.previousPaths[s].paths[e] && (i = a.globals.previousPaths[s].paths[e].d);
                }
                return i;
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$Y = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.ctx = e, this.w = e.w, this.months31 = [
            1,
            3,
            5,
            7,
            8,
            10,
            12
        ], this.months30 = [
            2,
            4,
            6,
            9,
            11
        ], this.daysCntOfYear = [
            0,
            31,
            59,
            90,
            120,
            151,
            181,
            212,
            243,
            273,
            304,
            334
        ];
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "isValidDate",
            value: function(t) {
                return !isNaN(this.parseDate(t));
            }
        },
        {
            key: "getTimeStamp",
            value: function(t) {
                return Date.parse(t) ? this.w.config.xaxis.labels.datetimeUTC ? new Date(new Date(t).toISOString().substr(0, 25)).getTime() : new Date(t).getTime() : t;
            }
        },
        {
            key: "getDate",
            value: function(t) {
                return this.w.config.xaxis.labels.datetimeUTC ? new Date(new Date(t).toUTCString()) : new Date(t);
            }
        },
        {
            key: "parseDate",
            value: function(t) {
                var e = Date.parse(t);
                if (!isNaN(e)) return this.getTimeStamp(t);
                var i = Date.parse(t.replace(/-/g, "/").replace(/[a-z]+/gi, " "));
                return i = this.getTimeStamp(i);
            }
        },
        {
            key: "parseDateWithTimezone",
            value: function(t) {
                return Date.parse(t.replace(/-/g, "/").replace(/[a-z]+/gi, " "));
            }
        },
        {
            key: "formatDate",
            value: function(t, e) {
                var i = this.w.globals.locale, a = this.w.config.xaxis.labels.datetimeUTC, s = [
                    "\0"
                ].concat($b705b473d3ec9641$var$g(i.months)), r = [
                    "\x01"
                ].concat($b705b473d3ec9641$var$g(i.shortMonths)), o = [
                    "\x02"
                ].concat($b705b473d3ec9641$var$g(i.days)), n = [
                    "\x03"
                ].concat($b705b473d3ec9641$var$g(i.shortDays));
                function l(t, e) {
                    var i = t + "";
                    for(e = e || 2; i.length < e;)i = "0" + i;
                    return i;
                }
                var h = a ? t.getUTCFullYear() : t.getFullYear();
                e = (e = (e = e.replace(/(^|[^\\])yyyy+/g, "$1" + h)).replace(/(^|[^\\])yy/g, "$1" + h.toString().substr(2, 2))).replace(/(^|[^\\])y/g, "$1" + h);
                var c = (a ? t.getUTCMonth() : t.getMonth()) + 1;
                e = (e = (e = (e = e.replace(/(^|[^\\])MMMM+/g, "$1" + s[0])).replace(/(^|[^\\])MMM/g, "$1" + r[0])).replace(/(^|[^\\])MM/g, "$1" + l(c))).replace(/(^|[^\\])M/g, "$1" + c);
                var d = a ? t.getUTCDate() : t.getDate();
                e = (e = (e = (e = e.replace(/(^|[^\\])dddd+/g, "$1" + o[0])).replace(/(^|[^\\])ddd/g, "$1" + n[0])).replace(/(^|[^\\])dd/g, "$1" + l(d))).replace(/(^|[^\\])d/g, "$1" + d);
                var u = a ? t.getUTCHours() : t.getHours(), p = u > 12 ? u - 12 : 0 === u ? 12 : u;
                e = (e = (e = (e = e.replace(/(^|[^\\])HH+/g, "$1" + l(u))).replace(/(^|[^\\])H/g, "$1" + u)).replace(/(^|[^\\])hh+/g, "$1" + l(p))).replace(/(^|[^\\])h/g, "$1" + p);
                var f = a ? t.getUTCMinutes() : t.getMinutes();
                e = (e = e.replace(/(^|[^\\])mm+/g, "$1" + l(f))).replace(/(^|[^\\])m/g, "$1" + f);
                var x = a ? t.getUTCSeconds() : t.getSeconds();
                e = (e = e.replace(/(^|[^\\])ss+/g, "$1" + l(x))).replace(/(^|[^\\])s/g, "$1" + x);
                var b = a ? t.getUTCMilliseconds() : t.getMilliseconds();
                e = e.replace(/(^|[^\\])fff+/g, "$1" + l(b, 3)), b = Math.round(b / 10), e = e.replace(/(^|[^\\])ff/g, "$1" + l(b)), b = Math.round(b / 10);
                var v = u < 12 ? "AM" : "PM";
                e = (e = (e = e.replace(/(^|[^\\])f/g, "$1" + b)).replace(/(^|[^\\])TT+/g, "$1" + v)).replace(/(^|[^\\])T/g, "$1" + v.charAt(0));
                var m = v.toLowerCase();
                e = (e = e.replace(/(^|[^\\])tt+/g, "$1" + m)).replace(/(^|[^\\])t/g, "$1" + m.charAt(0));
                var y = -t.getTimezoneOffset(), w = a || !y ? "Z" : y > 0 ? "+" : "-";
                if (!a) {
                    var k = (y = Math.abs(y)) % 60;
                    w += l(Math.floor(y / 60)) + ":" + l(k);
                }
                e = e.replace(/(^|[^\\])K/g, "$1" + w);
                var A = (a ? t.getUTCDay() : t.getDay()) + 1;
                return e = (e = (e = (e = (e = e.replace(new RegExp(o[0], "g"), o[A])).replace(new RegExp(n[0], "g"), n[A])).replace(new RegExp(s[0], "g"), s[c])).replace(new RegExp(r[0], "g"), r[c])).replace(/\\(.)/g, "$1");
            }
        },
        {
            key: "getTimeUnitsfromTimestamp",
            value: function(t, e, i) {
                var a = this.w;
                void 0 !== a.config.xaxis.min && (t = a.config.xaxis.min), void 0 !== a.config.xaxis.max && (e = a.config.xaxis.max);
                var s = this.getDate(t), r = this.getDate(e), o = this.formatDate(s, "yyyy MM dd HH mm ss fff").split(" "), n = this.formatDate(r, "yyyy MM dd HH mm ss fff").split(" ");
                return {
                    minMillisecond: parseInt(o[6], 10),
                    maxMillisecond: parseInt(n[6], 10),
                    minSecond: parseInt(o[5], 10),
                    maxSecond: parseInt(n[5], 10),
                    minMinute: parseInt(o[4], 10),
                    maxMinute: parseInt(n[4], 10),
                    minHour: parseInt(o[3], 10),
                    maxHour: parseInt(n[3], 10),
                    minDate: parseInt(o[2], 10),
                    maxDate: parseInt(n[2], 10),
                    minMonth: parseInt(o[1], 10) - 1,
                    maxMonth: parseInt(n[1], 10) - 1,
                    minYear: parseInt(o[0], 10),
                    maxYear: parseInt(n[0], 10)
                };
            }
        },
        {
            key: "isLeapYear",
            value: function(t) {
                return t % 4 == 0 && t % 100 != 0 || t % 400 == 0;
            }
        },
        {
            key: "calculcateLastDaysOfMonth",
            value: function(t, e, i) {
                return this.determineDaysOfMonths(t, e) - i;
            }
        },
        {
            key: "determineDaysOfYear",
            value: function(t) {
                var e = 365;
                return this.isLeapYear(t) && (e = 366), e;
            }
        },
        {
            key: "determineRemainingDaysOfYear",
            value: function(t, e, i) {
                var a = this.daysCntOfYear[e] + i;
                return e > 1 && this.isLeapYear() && a++, a;
            }
        },
        {
            key: "determineDaysOfMonths",
            value: function(t, e) {
                var i = 30;
                switch(t = $b705b473d3ec9641$var$p.monthMod(t), !0){
                    case this.months30.indexOf(t) > -1:
                        2 === t && (i = this.isLeapYear(e) ? 29 : 28);
                        break;
                    case this.months31.indexOf(t) > -1:
                    default:
                        i = 31;
                }
                return i;
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$F = function(t) {
    $b705b473d3ec9641$var$n(s, $b705b473d3ec9641$var$E);
    var i = $b705b473d3ec9641$var$d(s);
    function s() {
        return $b705b473d3ec9641$var$a(this, s), i.apply(this, arguments);
    }
    return $b705b473d3ec9641$var$r(s, [
        {
            key: "draw",
            value: function(t, i) {
                var a = this.w, s = new $b705b473d3ec9641$var$b(this.ctx);
                this.rangeBarOptions = this.w.config.plotOptions.rangeBar, this.series = t, this.seriesRangeStart = a.globals.seriesRangeStart, this.seriesRangeEnd = a.globals.seriesRangeEnd, this.barHelpers.initVariables(t);
                for(var r = s.group({
                    class: "apexcharts-rangebar-series apexcharts-plot-series"
                }), o = 0; o < t.length; o++){
                    var n, l, h, c = void 0, d = void 0, g = void 0, u = a.globals.comboCharts ? i[o] : o, f = s.group({
                        class: "apexcharts-series",
                        seriesName: $b705b473d3ec9641$var$p.escapeString(a.globals.seriesNames[u]),
                        rel: o + 1,
                        "data:realIndex": u
                    });
                    this.ctx.series.addCollapsedClassToSeries(f, u), t[o].length > 0 && (this.visibleI = this.visibleI + 1);
                    var x = 0, v = 0;
                    this.yRatio.length > 1 && (this.yaxisIndex = u);
                    var m = this.barHelpers.initialPositions();
                    d = m.y, h = m.zeroW, c = m.x, v = m.barWidth, n = m.xDivision, l = m.zeroH;
                    for(var y = s.group({
                        class: "apexcharts-datalabels",
                        "data:realIndex": u
                    }), w = s.group({
                        class: "apexcharts-rangebar-goals-markers",
                        style: "pointer-events: none"
                    }), k = 0; k < a.globals.dataPoints; k++){
                        var A = this.barHelpers.getStrokeWidth(o, k, u), S = this.seriesRangeStart[o][k], C = this.seriesRangeEnd[o][k], L = null, P = null, T = {
                            x: c,
                            y: d,
                            strokeWidth: A,
                            elSeries: f
                        };
                        if (g = m.yDivision, x = m.barHeight, this.isHorizontal) {
                            P = d + x * this.visibleI;
                            var M = this.seriesLen;
                            a.config.plotOptions.bar.rangeBarGroupRows && (M = 1);
                            var I = (g - x * M) / 2;
                            if (void 0 === a.config.series[o].data[k]) break;
                            if (a.config.series[o].data[k].x) {
                                var z = this.detectOverlappingBars({
                                    i: o,
                                    j: k,
                                    barYPosition: P,
                                    srty: I,
                                    barHeight: x,
                                    yDivision: g,
                                    initPositions: m
                                });
                                x = z.barHeight, P = z.barYPosition;
                            }
                            v = (L = this.drawRangeBarPaths($b705b473d3ec9641$var$e({
                                indexes: {
                                    i: o,
                                    j: k,
                                    realIndex: u
                                },
                                barHeight: x,
                                barYPosition: P,
                                zeroW: h,
                                yDivision: g,
                                y1: S,
                                y2: C
                            }, T))).barWidth;
                        } else x = (L = this.drawRangeColumnPaths($b705b473d3ec9641$var$e({
                            indexes: {
                                i: o,
                                j: k,
                                realIndex: u
                            },
                            zeroH: l,
                            barWidth: v,
                            xDivision: n
                        }, T))).barHeight;
                        var X = this.barHelpers.drawGoalLine({
                            barXPosition: L.barXPosition,
                            barYPosition: P,
                            goalX: L.goalX,
                            goalY: L.goalY,
                            barHeight: x,
                            barWidth: v
                        });
                        X && w.add(X), d = L.y, c = L.x;
                        var E = this.barHelpers.getPathFillColor(t, o, k, u), Y = a.globals.stroke.colors[u];
                        this.renderSeries({
                            realIndex: u,
                            pathFill: E,
                            lineFill: Y,
                            j: k,
                            i: o,
                            x: c,
                            y: d,
                            y1: S,
                            y2: C,
                            pathFrom: L.pathFrom,
                            pathTo: L.pathTo,
                            strokeWidth: A,
                            elSeries: f,
                            series: t,
                            barHeight: x,
                            barYPosition: P,
                            barWidth: v,
                            elDataLabelsWrap: y,
                            elGoalsMarkers: w,
                            visibleSeries: this.visibleI,
                            type: "rangebar"
                        });
                    }
                    r.add(f);
                }
                return r;
            }
        },
        {
            key: "detectOverlappingBars",
            value: function(t) {
                var e = t.i, i = t.j, a = t.barYPosition, s = t.srty, r = t.barHeight, o = t.yDivision, n = t.initPositions, l = this.w, h = [], c = l.config.series[e].data[i].rangeName, d = l.config.series[e].data[i].x, g = l.globals.labels.indexOf(d), u = l.globals.seriesRangeBar[e].findIndex(function(t) {
                    return t.x === d && t.overlaps.length > 0;
                });
                return a = l.config.plotOptions.bar.rangeBarGroupRows ? s + o * g : s + r * this.visibleI + o * g, u > -1 && !l.config.plotOptions.bar.rangeBarOverlap && (h = l.globals.seriesRangeBar[e][u].overlaps).indexOf(c) > -1 && (a = (r = n.barHeight / h.length) * this.visibleI + o * (100 - parseInt(this.barOptions.barHeight, 10)) / 100 / 2 + r * (this.visibleI + h.indexOf(c)) + o * g), {
                    barYPosition: a,
                    barHeight: r
                };
            }
        },
        {
            key: "drawRangeColumnPaths",
            value: function(t) {
                var e = t.indexes, i = t.x;
                t.strokeWidth;
                var a = t.xDivision, s = t.barWidth, r = t.zeroH, o = this.w, n = e.i, l = e.j, h = this.yRatio[this.yaxisIndex], c = e.realIndex, d = this.getRangeValue(c, l), g = Math.min(d.start, d.end), u = Math.max(d.start, d.end);
                o.globals.isXNumeric && (i = (o.globals.seriesX[n][l] - o.globals.minX) / this.xRatio - s / 2);
                var p = i + s * this.visibleI;
                void 0 === this.series[n][l] || null === this.series[n][l] ? g = r : (g = r - g / h, u = r - u / h);
                var f = Math.abs(u - g), x = this.barHelpers.getColumnPaths({
                    barXPosition: p,
                    barWidth: s,
                    y1: g,
                    y2: u,
                    strokeWidth: this.strokeWidth,
                    series: this.seriesRangeEnd,
                    realIndex: e.realIndex,
                    i: c,
                    j: l,
                    w: o
                });
                return o.globals.isXNumeric || (i += a), {
                    pathTo: x.pathTo,
                    pathFrom: x.pathFrom,
                    barHeight: f,
                    x: i,
                    y: u,
                    goalY: this.barHelpers.getGoalValues("y", null, r, n, l),
                    barXPosition: p
                };
            }
        },
        {
            key: "drawRangeBarPaths",
            value: function(t) {
                var e = t.indexes, i = t.y, a = t.y1, s = t.y2, r = t.yDivision, o = t.barHeight, n = t.barYPosition, l = t.zeroW, h = this.w, c = l + a / this.invertedYRatio, d = l + s / this.invertedYRatio, g = Math.abs(d - c), u = this.barHelpers.getBarpaths({
                    barYPosition: n,
                    barHeight: o,
                    x1: c,
                    x2: d,
                    strokeWidth: this.strokeWidth,
                    series: this.seriesRangeEnd,
                    i: e.realIndex,
                    realIndex: e.realIndex,
                    j: e.j,
                    w: h
                });
                return h.globals.isXNumeric || (i += r), {
                    pathTo: u.pathTo,
                    pathFrom: u.pathFrom,
                    barWidth: g,
                    x: d,
                    goalX: this.barHelpers.getGoalValues("x", l, null, e.realIndex, e.j),
                    y: i
                };
            }
        },
        {
            key: "getRangeValue",
            value: function(t, e) {
                var i = this.w;
                return {
                    start: i.globals.seriesRangeStart[t][e],
                    end: i.globals.seriesRangeEnd[t][e]
                };
            }
        },
        {
            key: "getTooltipValues",
            value: function(t) {
                var e = t.ctx, i = t.seriesIndex, a = t.dataPointIndex, s = t.y1, r = t.y2, o = t.w, n = o.globals.seriesRangeStart[i][a], l = o.globals.seriesRangeEnd[i][a], h = o.globals.labels[a], c = o.config.series[i].name ? o.config.series[i].name : "", d = o.config.tooltip.y.formatter, g = o.config.tooltip.y.title.formatter, u = {
                    w: o,
                    seriesIndex: i,
                    dataPointIndex: a,
                    start: n,
                    end: l
                };
                "function" == typeof g && (c = g(c, u)), Number.isFinite(s) && Number.isFinite(r) && (n = s, l = r, o.config.series[i].data[a].x && (h = o.config.series[i].data[a].x + ":"), "function" == typeof d && (h = d(h, u)));
                var p = "", f = "", x = o.globals.colors[i];
                if (void 0 === o.config.tooltip.x.formatter) {
                    if ("datetime" === o.config.xaxis.type) {
                        var b = new $b705b473d3ec9641$var$Y(e);
                        p = b.formatDate(b.getDate(n), o.config.tooltip.x.format), f = b.formatDate(b.getDate(l), o.config.tooltip.x.format);
                    } else p = n, f = l;
                } else p = o.config.tooltip.x.formatter(n), f = o.config.tooltip.x.formatter(l);
                return {
                    start: n,
                    end: l,
                    startVal: p,
                    endVal: f,
                    ylabel: h,
                    color: x,
                    seriesName: c
                };
            }
        },
        {
            key: "buildCustomTooltipHTML",
            value: function(t) {
                var e = t.color, i = t.seriesName;
                return '<div class="apexcharts-tooltip-rangebar"><div> <span class="series-name" style="color: ' + e + '">' + (i || "") + '</span></div><div> <span class="category">' + t.ylabel + ' </span> <span class="value start-value">' + t.start + '</span> <span class="separator">-</span> <span class="value end-value">' + t.end + "</span></div></div>";
            }
        }
    ]), s;
}(), $b705b473d3ec9641$var$R = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.opts = e;
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "line",
            value: function() {
                return {
                    chart: {
                        animations: {
                            easing: "swing"
                        }
                    },
                    dataLabels: {
                        enabled: !1
                    },
                    stroke: {
                        width: 5,
                        curve: "straight"
                    },
                    markers: {
                        size: 0,
                        hover: {
                            sizeOffset: 6
                        }
                    },
                    xaxis: {
                        crosshairs: {
                            width: 1
                        }
                    }
                };
            }
        },
        {
            key: "sparkline",
            value: function(t) {
                this.opts.yaxis[0].show = !1, this.opts.yaxis[0].title.text = "", this.opts.yaxis[0].axisBorder.show = !1, this.opts.yaxis[0].axisTicks.show = !1, this.opts.yaxis[0].floating = !0;
                return $b705b473d3ec9641$var$p.extend(t, {
                    grid: {
                        show: !1,
                        padding: {
                            left: 0,
                            right: 0,
                            top: 0,
                            bottom: 0
                        }
                    },
                    legend: {
                        show: !1
                    },
                    xaxis: {
                        labels: {
                            show: !1
                        },
                        tooltip: {
                            enabled: !1
                        },
                        axisBorder: {
                            show: !1
                        },
                        axisTicks: {
                            show: !1
                        }
                    },
                    chart: {
                        toolbar: {
                            show: !1
                        },
                        zoom: {
                            enabled: !1
                        }
                    },
                    dataLabels: {
                        enabled: !1
                    }
                });
            }
        },
        {
            key: "bar",
            value: function() {
                return {
                    chart: {
                        stacked: !1,
                        animations: {
                            easing: "swing"
                        }
                    },
                    plotOptions: {
                        bar: {
                            dataLabels: {
                                position: "center"
                            }
                        }
                    },
                    dataLabels: {
                        style: {
                            colors: [
                                "#fff"
                            ]
                        },
                        background: {
                            enabled: !1
                        }
                    },
                    stroke: {
                        width: 0,
                        lineCap: "round"
                    },
                    fill: {
                        opacity: .85
                    },
                    legend: {
                        markers: {
                            shape: "square",
                            radius: 2,
                            size: 8
                        }
                    },
                    tooltip: {
                        shared: !1,
                        intersect: !0
                    },
                    xaxis: {
                        tooltip: {
                            enabled: !1
                        },
                        tickPlacement: "between",
                        crosshairs: {
                            width: "barWidth",
                            position: "back",
                            fill: {
                                type: "gradient"
                            },
                            dropShadow: {
                                enabled: !1
                            },
                            stroke: {
                                width: 0
                            }
                        }
                    }
                };
            }
        },
        {
            key: "candlestick",
            value: function() {
                var t = this;
                return {
                    stroke: {
                        width: 1,
                        colors: [
                            "#333"
                        ]
                    },
                    fill: {
                        opacity: 1
                    },
                    dataLabels: {
                        enabled: !1
                    },
                    tooltip: {
                        shared: !0,
                        custom: function(e) {
                            var i = e.seriesIndex, a = e.dataPointIndex, s = e.w;
                            return t._getBoxTooltip(s, i, a, [
                                "Open",
                                "High",
                                "",
                                "Low",
                                "Close"
                            ], "candlestick");
                        }
                    },
                    states: {
                        active: {
                            filter: {
                                type: "none"
                            }
                        }
                    },
                    xaxis: {
                        crosshairs: {
                            width: 1
                        }
                    }
                };
            }
        },
        {
            key: "boxPlot",
            value: function() {
                var t = this;
                return {
                    chart: {
                        animations: {
                            dynamicAnimation: {
                                enabled: !1
                            }
                        }
                    },
                    stroke: {
                        width: 1,
                        colors: [
                            "#24292e"
                        ]
                    },
                    dataLabels: {
                        enabled: !1
                    },
                    tooltip: {
                        shared: !0,
                        custom: function(e) {
                            var i = e.seriesIndex, a = e.dataPointIndex, s = e.w;
                            return t._getBoxTooltip(s, i, a, [
                                "Minimum",
                                "Q1",
                                "Median",
                                "Q3",
                                "Maximum"
                            ], "boxPlot");
                        }
                    },
                    markers: {
                        size: 5,
                        strokeWidth: 1,
                        strokeColors: "#111"
                    },
                    xaxis: {
                        crosshairs: {
                            width: 1
                        }
                    }
                };
            }
        },
        {
            key: "rangeBar",
            value: function() {
                return {
                    stroke: {
                        width: 0,
                        lineCap: "square"
                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 0,
                            dataLabels: {
                                position: "center"
                            }
                        }
                    },
                    dataLabels: {
                        enabled: !1,
                        formatter: function(t, e) {
                            e.ctx;
                            var i = e.seriesIndex, a = e.dataPointIndex, s = e.w, r = s.globals.seriesRangeStart[i][a];
                            return s.globals.seriesRangeEnd[i][a] - r;
                        },
                        background: {
                            enabled: !1
                        },
                        style: {
                            colors: [
                                "#fff"
                            ]
                        }
                    },
                    tooltip: {
                        shared: !1,
                        followCursor: !0,
                        custom: function(t) {
                            return t.w.config.plotOptions && t.w.config.plotOptions.bar && t.w.config.plotOptions.bar.horizontal ? function(t) {
                                var e = new $b705b473d3ec9641$var$F(t.ctx, null), i = e.getTooltipValues(t), a = i.color, s = i.seriesName, r = i.ylabel, o = i.startVal, n = i.endVal;
                                return e.buildCustomTooltipHTML({
                                    color: a,
                                    seriesName: s,
                                    ylabel: r,
                                    start: o,
                                    end: n
                                });
                            }(t) : function(t) {
                                var e = new $b705b473d3ec9641$var$F(t.ctx, null), i = e.getTooltipValues(t), a = i.color, s = i.seriesName, r = i.ylabel, o = i.start, n = i.end;
                                return e.buildCustomTooltipHTML({
                                    color: a,
                                    seriesName: s,
                                    ylabel: r,
                                    start: o,
                                    end: n
                                });
                            }(t);
                        }
                    },
                    xaxis: {
                        tickPlacement: "between",
                        tooltip: {
                            enabled: !1
                        },
                        crosshairs: {
                            stroke: {
                                width: 0
                            }
                        }
                    }
                };
            }
        },
        {
            key: "area",
            value: function() {
                return {
                    stroke: {
                        width: 4
                    },
                    fill: {
                        type: "gradient",
                        gradient: {
                            inverseColors: !1,
                            shade: "light",
                            type: "vertical",
                            opacityFrom: .65,
                            opacityTo: .5,
                            stops: [
                                0,
                                100,
                                100
                            ]
                        }
                    },
                    markers: {
                        size: 0,
                        hover: {
                            sizeOffset: 6
                        }
                    },
                    tooltip: {
                        followCursor: !1
                    }
                };
            }
        },
        {
            key: "brush",
            value: function(t) {
                return $b705b473d3ec9641$var$p.extend(t, {
                    chart: {
                        toolbar: {
                            autoSelected: "selection",
                            show: !1
                        },
                        zoom: {
                            enabled: !1
                        }
                    },
                    dataLabels: {
                        enabled: !1
                    },
                    stroke: {
                        width: 1
                    },
                    tooltip: {
                        enabled: !1
                    },
                    xaxis: {
                        tooltip: {
                            enabled: !1
                        }
                    }
                });
            }
        },
        {
            key: "stacked100",
            value: function(t) {
                t.dataLabels = t.dataLabels || {}, t.dataLabels.formatter = t.dataLabels.formatter || void 0;
                var e = t.dataLabels.formatter;
                return t.yaxis.forEach(function(e, i) {
                    t.yaxis[i].min = 0, t.yaxis[i].max = 100;
                }), "bar" === t.chart.type && (t.dataLabels.formatter = e || function(t) {
                    return "number" == typeof t && t ? t.toFixed(0) + "%" : t;
                }), t;
            }
        },
        {
            key: "convertCatToNumeric",
            value: function(t) {
                return t.xaxis.convertedCatToNumeric = !0, t;
            }
        },
        {
            key: "convertCatToNumericXaxis",
            value: function(t, e, i) {
                t.xaxis.type = "numeric", t.xaxis.labels = t.xaxis.labels || {}, t.xaxis.labels.formatter = t.xaxis.labels.formatter || function(t) {
                    return $b705b473d3ec9641$var$p.isNumber(t) ? Math.floor(t) : t;
                };
                var a = t.xaxis.labels.formatter, s = t.xaxis.categories && t.xaxis.categories.length ? t.xaxis.categories : t.labels;
                return i && i.length && (s = i.map(function(t) {
                    return Array.isArray(t) ? t : String(t);
                })), s && s.length && (t.xaxis.labels.formatter = function(t) {
                    return $b705b473d3ec9641$var$p.isNumber(t) ? a(s[Math.floor(t) - 1]) : a(t);
                }), t.xaxis.categories = [], t.labels = [], t.xaxis.tickAmount = t.xaxis.tickAmount || "dataPoints", t;
            }
        },
        {
            key: "bubble",
            value: function() {
                return {
                    dataLabels: {
                        style: {
                            colors: [
                                "#fff"
                            ]
                        }
                    },
                    tooltip: {
                        shared: !1,
                        intersect: !0
                    },
                    xaxis: {
                        crosshairs: {
                            width: 0
                        }
                    },
                    fill: {
                        type: "solid",
                        gradient: {
                            shade: "light",
                            inverse: !0,
                            shadeIntensity: .55,
                            opacityFrom: .4,
                            opacityTo: .8
                        }
                    }
                };
            }
        },
        {
            key: "scatter",
            value: function() {
                return {
                    dataLabels: {
                        enabled: !1
                    },
                    tooltip: {
                        shared: !1,
                        intersect: !0
                    },
                    markers: {
                        size: 6,
                        strokeWidth: 1,
                        hover: {
                            sizeOffset: 2
                        }
                    }
                };
            }
        },
        {
            key: "heatmap",
            value: function() {
                return {
                    chart: {
                        stacked: !1
                    },
                    fill: {
                        opacity: 1
                    },
                    dataLabels: {
                        style: {
                            colors: [
                                "#fff"
                            ]
                        }
                    },
                    stroke: {
                        colors: [
                            "#fff"
                        ]
                    },
                    tooltip: {
                        followCursor: !0,
                        marker: {
                            show: !1
                        },
                        x: {
                            show: !1
                        }
                    },
                    legend: {
                        position: "top",
                        markers: {
                            shape: "square",
                            size: 10,
                            offsetY: 2
                        }
                    },
                    grid: {
                        padding: {
                            right: 20
                        }
                    }
                };
            }
        },
        {
            key: "treemap",
            value: function() {
                return {
                    chart: {
                        zoom: {
                            enabled: !1
                        }
                    },
                    dataLabels: {
                        style: {
                            fontSize: 14,
                            fontWeight: 600,
                            colors: [
                                "#fff"
                            ]
                        }
                    },
                    stroke: {
                        show: !0,
                        width: 2,
                        colors: [
                            "#fff"
                        ]
                    },
                    legend: {
                        show: !1
                    },
                    fill: {
                        gradient: {
                            stops: [
                                0,
                                100
                            ]
                        }
                    },
                    tooltip: {
                        followCursor: !0,
                        x: {
                            show: !1
                        }
                    },
                    grid: {
                        padding: {
                            left: 0,
                            right: 0
                        }
                    },
                    xaxis: {
                        crosshairs: {
                            show: !1
                        },
                        tooltip: {
                            enabled: !1
                        }
                    }
                };
            }
        },
        {
            key: "pie",
            value: function() {
                return {
                    chart: {
                        toolbar: {
                            show: !1
                        }
                    },
                    plotOptions: {
                        pie: {
                            donut: {
                                labels: {
                                    show: !1
                                }
                            }
                        }
                    },
                    dataLabels: {
                        formatter: function(t) {
                            return t.toFixed(1) + "%";
                        },
                        style: {
                            colors: [
                                "#fff"
                            ]
                        },
                        background: {
                            enabled: !1
                        },
                        dropShadow: {
                            enabled: !0
                        }
                    },
                    stroke: {
                        colors: [
                            "#fff"
                        ]
                    },
                    fill: {
                        opacity: 1,
                        gradient: {
                            shade: "light",
                            stops: [
                                0,
                                100
                            ]
                        }
                    },
                    tooltip: {
                        theme: "dark",
                        fillSeriesColor: !0
                    },
                    legend: {
                        position: "right"
                    }
                };
            }
        },
        {
            key: "donut",
            value: function() {
                return {
                    chart: {
                        toolbar: {
                            show: !1
                        }
                    },
                    dataLabels: {
                        formatter: function(t) {
                            return t.toFixed(1) + "%";
                        },
                        style: {
                            colors: [
                                "#fff"
                            ]
                        },
                        background: {
                            enabled: !1
                        },
                        dropShadow: {
                            enabled: !0
                        }
                    },
                    stroke: {
                        colors: [
                            "#fff"
                        ]
                    },
                    fill: {
                        opacity: 1,
                        gradient: {
                            shade: "light",
                            shadeIntensity: .35,
                            stops: [
                                80,
                                100
                            ],
                            opacityFrom: 1,
                            opacityTo: 1
                        }
                    },
                    tooltip: {
                        theme: "dark",
                        fillSeriesColor: !0
                    },
                    legend: {
                        position: "right"
                    }
                };
            }
        },
        {
            key: "polarArea",
            value: function() {
                return this.opts.yaxis[0].tickAmount = this.opts.yaxis[0].tickAmount ? this.opts.yaxis[0].tickAmount : 6, {
                    chart: {
                        toolbar: {
                            show: !1
                        }
                    },
                    dataLabels: {
                        formatter: function(t) {
                            return t.toFixed(1) + "%";
                        },
                        enabled: !1
                    },
                    stroke: {
                        show: !0,
                        width: 2
                    },
                    fill: {
                        opacity: .7
                    },
                    tooltip: {
                        theme: "dark",
                        fillSeriesColor: !0
                    },
                    legend: {
                        position: "right"
                    }
                };
            }
        },
        {
            key: "radar",
            value: function() {
                return this.opts.yaxis[0].labels.offsetY = this.opts.yaxis[0].labels.offsetY ? this.opts.yaxis[0].labels.offsetY : 6, {
                    dataLabels: {
                        enabled: !1,
                        style: {
                            fontSize: "11px"
                        }
                    },
                    stroke: {
                        width: 2
                    },
                    markers: {
                        size: 3,
                        strokeWidth: 1,
                        strokeOpacity: 1
                    },
                    fill: {
                        opacity: .2
                    },
                    tooltip: {
                        shared: !1,
                        intersect: !0,
                        followCursor: !0
                    },
                    grid: {
                        show: !1
                    },
                    xaxis: {
                        labels: {
                            formatter: function(t) {
                                return t;
                            },
                            style: {
                                colors: [
                                    "#a8a8a8"
                                ],
                                fontSize: "11px"
                            }
                        },
                        tooltip: {
                            enabled: !1
                        },
                        crosshairs: {
                            show: !1
                        }
                    }
                };
            }
        },
        {
            key: "radialBar",
            value: function() {
                return {
                    chart: {
                        animations: {
                            dynamicAnimation: {
                                enabled: !0,
                                speed: 800
                            }
                        },
                        toolbar: {
                            show: !1
                        }
                    },
                    fill: {
                        gradient: {
                            shade: "dark",
                            shadeIntensity: .4,
                            inverseColors: !1,
                            type: "diagonal2",
                            opacityFrom: 1,
                            opacityTo: 1,
                            stops: [
                                70,
                                98,
                                100
                            ]
                        }
                    },
                    legend: {
                        show: !1,
                        position: "right"
                    },
                    tooltip: {
                        enabled: !1,
                        fillSeriesColor: !0
                    }
                };
            }
        },
        {
            key: "_getBoxTooltip",
            value: function(t, e, i, a, s) {
                var r = t.globals.seriesCandleO[e][i], o = t.globals.seriesCandleH[e][i], n = t.globals.seriesCandleM[e][i], l = t.globals.seriesCandleL[e][i], h = t.globals.seriesCandleC[e][i];
                return t.config.series[e].type && t.config.series[e].type !== s ? '<div class="apexcharts-custom-tooltip">\n          '.concat(t.config.series[e].name ? t.config.series[e].name : "series-" + (e + 1), ": <strong>").concat(t.globals.series[e][i], "</strong>\n        </div>") : '<div class="apexcharts-tooltip-box apexcharts-tooltip-'.concat(t.config.chart.type, '">') + "<div>".concat(a[0], ': <span class="value">') + r + "</span></div>" + "<div>".concat(a[1], ': <span class="value">') + o + "</span></div>" + (n ? "<div>".concat(a[2], ': <span class="value">') + n + "</span></div>" : "") + "<div>".concat(a[3], ': <span class="value">') + l + "</span></div>" + "<div>".concat(a[4], ': <span class="value">') + h + "</span></div></div>";
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$H = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.opts = e;
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "init",
            value: function(t) {
                var e = t.responsiveOverride, a = this.opts, s = new $b705b473d3ec9641$var$S, r = new $b705b473d3ec9641$var$R(a);
                this.chartType = a.chart.type, "histogram" === this.chartType && (a.chart.type = "bar", a = $b705b473d3ec9641$var$p.extend({
                    plotOptions: {
                        bar: {
                            columnWidth: "99.99%"
                        }
                    }
                }, a)), a = this.extendYAxis(a), a = this.extendAnnotations(a);
                var o = s.init(), n = {};
                if (a && "object" === $b705b473d3ec9641$var$i(a)) {
                    var l = {};
                    l = -1 !== [
                        "line",
                        "area",
                        "bar",
                        "candlestick",
                        "boxPlot",
                        "rangeBar",
                        "histogram",
                        "bubble",
                        "scatter",
                        "heatmap",
                        "treemap",
                        "pie",
                        "polarArea",
                        "donut",
                        "radar",
                        "radialBar"
                    ].indexOf(a.chart.type) ? r[a.chart.type]() : r.line(), a.chart.brush && a.chart.brush.enabled && (l = r.brush(l)), a.chart.stacked && "100%" === a.chart.stackType && (a = r.stacked100(a)), this.checkForDarkTheme(window.Apex), this.checkForDarkTheme(a), a.xaxis = a.xaxis || window.Apex.xaxis || {}, e || (a.xaxis.convertedCatToNumeric = !1), ((a = this.checkForCatToNumericXAxis(this.chartType, l, a)).chart.sparkline && a.chart.sparkline.enabled || window.Apex.chart && window.Apex.chart.sparkline && window.Apex.chart.sparkline.enabled) && (l = r.sparkline(l)), n = $b705b473d3ec9641$var$p.extend(o, l);
                }
                var h = $b705b473d3ec9641$var$p.extend(n, window.Apex);
                return o = $b705b473d3ec9641$var$p.extend(h, a), o = this.handleUserInputErrors(o);
            }
        },
        {
            key: "checkForCatToNumericXAxis",
            value: function(t, e, i) {
                var a = new $b705b473d3ec9641$var$R(i), s = ("bar" === t || "boxPlot" === t) && i.plotOptions && i.plotOptions.bar && i.plotOptions.bar.horizontal, r = "pie" === t || "polarArea" === t || "donut" === t || "radar" === t || "radialBar" === t || "heatmap" === t, o = "datetime" !== i.xaxis.type && "numeric" !== i.xaxis.type, n = i.xaxis.tickPlacement ? i.xaxis.tickPlacement : e.xaxis && e.xaxis.tickPlacement;
                return s || r || !o || "between" === n || (i = a.convertCatToNumeric(i)), i;
            }
        },
        {
            key: "extendYAxis",
            value: function(t, e) {
                var i = new $b705b473d3ec9641$var$S;
                (void 0 === t.yaxis || !t.yaxis || Array.isArray(t.yaxis) && 0 === t.yaxis.length) && (t.yaxis = {}), t.yaxis.constructor !== Array && window.Apex.yaxis && window.Apex.yaxis.constructor !== Array && (t.yaxis = $b705b473d3ec9641$var$p.extend(t.yaxis, window.Apex.yaxis)), t.yaxis.constructor !== Array ? t.yaxis = [
                    $b705b473d3ec9641$var$p.extend(i.yAxis, t.yaxis)
                ] : t.yaxis = $b705b473d3ec9641$var$p.extendArray(t.yaxis, i.yAxis);
                var a = !1;
                t.yaxis.forEach(function(t) {
                    t.logarithmic && (a = !0);
                });
                var s = t.series;
                return e && !s && (s = e.config.series), a && s.length !== t.yaxis.length && s.length && (t.yaxis = s.map(function(e, a) {
                    if (e.name || (s[a].name = "series-".concat(a + 1)), t.yaxis[a]) return t.yaxis[a].seriesName = s[a].name, t.yaxis[a];
                    var r = $b705b473d3ec9641$var$p.extend(i.yAxis, t.yaxis[0]);
                    return r.show = !1, r;
                })), a && s.length > 1 && s.length !== t.yaxis.length && console.warn("A multi-series logarithmic chart should have equal number of series and y-axes. Please make sure to equalize both."), t;
            }
        },
        {
            key: "extendAnnotations",
            value: function(t) {
                return void 0 === t.annotations && (t.annotations = {}, t.annotations.yaxis = [], t.annotations.xaxis = [], t.annotations.points = []), t = this.extendYAxisAnnotations(t), t = this.extendXAxisAnnotations(t), t = this.extendPointAnnotations(t);
            }
        },
        {
            key: "extendYAxisAnnotations",
            value: function(t) {
                var e = new $b705b473d3ec9641$var$S;
                return t.annotations.yaxis = $b705b473d3ec9641$var$p.extendArray(void 0 !== t.annotations.yaxis ? t.annotations.yaxis : [], e.yAxisAnnotation), t;
            }
        },
        {
            key: "extendXAxisAnnotations",
            value: function(t) {
                var e = new $b705b473d3ec9641$var$S;
                return t.annotations.xaxis = $b705b473d3ec9641$var$p.extendArray(void 0 !== t.annotations.xaxis ? t.annotations.xaxis : [], e.xAxisAnnotation), t;
            }
        },
        {
            key: "extendPointAnnotations",
            value: function(t) {
                var e = new $b705b473d3ec9641$var$S;
                return t.annotations.points = $b705b473d3ec9641$var$p.extendArray(void 0 !== t.annotations.points ? t.annotations.points : [], e.pointAnnotation), t;
            }
        },
        {
            key: "checkForDarkTheme",
            value: function(t) {
                t.theme && "dark" === t.theme.mode && (t.tooltip || (t.tooltip = {}), "light" !== t.tooltip.theme && (t.tooltip.theme = "dark"), t.chart.foreColor || (t.chart.foreColor = "#f6f7f8"), t.chart.background || (t.chart.background = "#424242"), t.theme.palette || (t.theme.palette = "palette4"));
            }
        },
        {
            key: "handleUserInputErrors",
            value: function(t) {
                var e = t;
                if (e.tooltip.shared && e.tooltip.intersect) throw new Error("tooltip.shared cannot be enabled when tooltip.intersect is true. Turn off any other option by setting it to false.");
                if ("bar" === e.chart.type && e.plotOptions.bar.horizontal) {
                    if (e.yaxis.length > 1) throw new Error("Multiple Y Axis for bars are not supported. Switch to column chart by setting plotOptions.bar.horizontal=false");
                    e.yaxis[0].reversed && (e.yaxis[0].opposite = !0), e.xaxis.tooltip.enabled = !1, e.yaxis[0].tooltip.enabled = !1, e.chart.zoom.enabled = !1;
                }
                return "bar" !== e.chart.type && "rangeBar" !== e.chart.type || e.tooltip.shared && "barWidth" === e.xaxis.crosshairs.width && e.series.length > 1 && (e.xaxis.crosshairs.width = "tickWidth"), "candlestick" !== e.chart.type && "boxPlot" !== e.chart.type || e.yaxis[0].reversed && (console.warn("Reversed y-axis in ".concat(e.chart.type, " chart is not supported.")), e.yaxis[0].reversed = !1), e;
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$D = function() {
    function t() {
        $b705b473d3ec9641$var$a(this, t);
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "initGlobalVars",
            value: function(t) {
                t.series = [], t.seriesCandleO = [], t.seriesCandleH = [], t.seriesCandleM = [], t.seriesCandleL = [], t.seriesCandleC = [], t.seriesRangeStart = [], t.seriesRangeEnd = [], t.seriesRangeBar = [], t.seriesPercent = [], t.seriesGoals = [], t.seriesX = [], t.seriesZ = [], t.seriesNames = [], t.seriesTotals = [], t.seriesLog = [], t.seriesColors = [], t.stackedSeriesTotals = [], t.seriesXvalues = [], t.seriesYvalues = [], t.labels = [], t.categoryLabels = [], t.timescaleLabels = [], t.noLabelsProvided = !1, t.resizeTimer = null, t.selectionResizeTimer = null, t.delayedElements = [], t.pointsArray = [], t.dataLabelsRects = [], t.isXNumeric = !1, t.xaxisLabelsCount = 0, t.skipLastTimelinelabel = !1, t.skipFirstTimelinelabel = !1, t.isDataXYZ = !1, t.isMultiLineX = !1, t.isMultipleYAxis = !1, t.maxY = -Number.MAX_VALUE, t.minY = Number.MIN_VALUE, t.minYArr = [], t.maxYArr = [], t.maxX = -Number.MAX_VALUE, t.minX = Number.MAX_VALUE, t.initialMaxX = -Number.MAX_VALUE, t.initialMinX = Number.MAX_VALUE, t.maxDate = 0, t.minDate = Number.MAX_VALUE, t.minZ = Number.MAX_VALUE, t.maxZ = -Number.MAX_VALUE, t.minXDiff = Number.MAX_VALUE, t.yAxisScale = [], t.xAxisScale = null, t.xAxisTicksPositions = [], t.yLabelsCoords = [], t.yTitleCoords = [], t.barPadForNumericAxis = 0, t.padHorizontal = 0, t.xRange = 0, t.yRange = [], t.zRange = 0, t.dataPoints = 0, t.xTickAmount = 0;
            }
        },
        {
            key: "globalVars",
            value: function(t) {
                return {
                    chartID: null,
                    cuid: null,
                    events: {
                        beforeMount: [],
                        mounted: [],
                        updated: [],
                        clicked: [],
                        selection: [],
                        dataPointSelection: [],
                        zoomed: [],
                        scrolled: []
                    },
                    colors: [],
                    clientX: null,
                    clientY: null,
                    fill: {
                        colors: []
                    },
                    stroke: {
                        colors: []
                    },
                    dataLabels: {
                        style: {
                            colors: []
                        }
                    },
                    radarPolygons: {
                        fill: {
                            colors: []
                        }
                    },
                    markers: {
                        colors: [],
                        size: t.markers.size,
                        largestSize: 0
                    },
                    animationEnded: !1,
                    isTouchDevice: "ontouchstart" in window || navigator.msMaxTouchPoints,
                    isDirty: !1,
                    isExecCalled: !1,
                    initialConfig: null,
                    initialSeries: [],
                    lastXAxis: [],
                    lastYAxis: [],
                    columnSeries: null,
                    labels: [],
                    timescaleLabels: [],
                    noLabelsProvided: !1,
                    allSeriesCollapsed: !1,
                    collapsedSeries: [],
                    collapsedSeriesIndices: [],
                    ancillaryCollapsedSeries: [],
                    ancillaryCollapsedSeriesIndices: [],
                    risingSeries: [],
                    dataFormatXNumeric: !1,
                    capturedSeriesIndex: -1,
                    capturedDataPointIndex: -1,
                    selectedDataPoints: [],
                    goldenPadding: 35,
                    invalidLogScale: !1,
                    ignoreYAxisIndexes: [],
                    yAxisSameScaleIndices: [],
                    maxValsInArrayIndex: 0,
                    radialSize: 0,
                    selection: void 0,
                    zoomEnabled: "zoom" === t.chart.toolbar.autoSelected && t.chart.toolbar.tools.zoom && t.chart.zoom.enabled,
                    panEnabled: "pan" === t.chart.toolbar.autoSelected && t.chart.toolbar.tools.pan,
                    selectionEnabled: "selection" === t.chart.toolbar.autoSelected && t.chart.toolbar.tools.selection,
                    yaxis: null,
                    mousedown: !1,
                    lastClientPosition: {},
                    visibleXRange: void 0,
                    yValueDecimal: 0,
                    total: 0,
                    SVGNS: "http://www.w3.org/2000/svg",
                    svgWidth: 0,
                    svgHeight: 0,
                    noData: !1,
                    locale: {},
                    dom: {},
                    memory: {
                        methodsToExec: []
                    },
                    shouldAnimate: !0,
                    skipLastTimelinelabel: !1,
                    skipFirstTimelinelabel: !1,
                    delayedElements: [],
                    axisCharts: !0,
                    isDataXYZ: !1,
                    resized: !1,
                    resizeTimer: null,
                    comboCharts: !1,
                    dataChanged: !1,
                    previousPaths: [],
                    allSeriesHasEqualX: !0,
                    pointsArray: [],
                    dataLabelsRects: [],
                    lastDrawnDataLabelsIndexes: [],
                    hasNullValues: !1,
                    easing: null,
                    zoomed: !1,
                    gridWidth: 0,
                    gridHeight: 0,
                    rotateXLabels: !1,
                    defaultLabels: !1,
                    xLabelFormatter: void 0,
                    yLabelFormatters: [],
                    xaxisTooltipFormatter: void 0,
                    ttKeyFormatter: void 0,
                    ttVal: void 0,
                    ttZFormatter: void 0,
                    LINE_HEIGHT_RATIO: 1.618,
                    xAxisLabelsHeight: 0,
                    xAxisLabelsWidth: 0,
                    yAxisLabelsWidth: 0,
                    scaleX: 1,
                    scaleY: 1,
                    translateX: 0,
                    translateY: 0,
                    translateYAxisX: [],
                    yAxisWidths: [],
                    translateXAxisY: 0,
                    translateXAxisX: 0,
                    tooltip: null
                };
            }
        },
        {
            key: "init",
            value: function(t) {
                var e = this.globalVars(t);
                return this.initGlobalVars(e), e.initialConfig = $b705b473d3ec9641$var$p.extend({}, t), e.initialSeries = $b705b473d3ec9641$var$p.clone(t.series), e.lastXAxis = $b705b473d3ec9641$var$p.clone(e.initialConfig.xaxis), e.lastYAxis = $b705b473d3ec9641$var$p.clone(e.initialConfig.yaxis), e;
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$N = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.opts = e;
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "init",
            value: function() {
                var t = new $b705b473d3ec9641$var$H(this.opts).init({
                    responsiveOverride: !1
                });
                return {
                    config: t,
                    globals: (new $b705b473d3ec9641$var$D).init(t)
                };
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$O = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.ctx = e, this.w = e.w, this.twoDSeries = [], this.threeDSeries = [], this.twoDSeriesX = [], this.seriesGoals = [], this.coreUtils = new $b705b473d3ec9641$var$y(this.ctx);
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "isMultiFormat",
            value: function() {
                return this.isFormatXY() || this.isFormat2DArray();
            }
        },
        {
            key: "isFormatXY",
            value: function() {
                var t = this.w.config.series.slice(), e = new $b705b473d3ec9641$var$z(this.ctx);
                if (this.activeSeriesIndex = e.getActiveConfigSeriesIndex(), void 0 !== t[this.activeSeriesIndex].data && t[this.activeSeriesIndex].data.length > 0 && null !== t[this.activeSeriesIndex].data[0] && void 0 !== t[this.activeSeriesIndex].data[0].x && null !== t[this.activeSeriesIndex].data[0]) return !0;
            }
        },
        {
            key: "isFormat2DArray",
            value: function() {
                var t = this.w.config.series.slice(), e = new $b705b473d3ec9641$var$z(this.ctx);
                if (this.activeSeriesIndex = e.getActiveConfigSeriesIndex(), void 0 !== t[this.activeSeriesIndex].data && t[this.activeSeriesIndex].data.length > 0 && void 0 !== t[this.activeSeriesIndex].data[0] && null !== t[this.activeSeriesIndex].data[0] && t[this.activeSeriesIndex].data[0].constructor === Array) return !0;
            }
        },
        {
            key: "handleFormat2DArray",
            value: function(t, e) {
                for(var i = this.w.config, a = this.w.globals, s = "boxPlot" === i.chart.type || "boxPlot" === i.series[e].type, r = 0; r < t[e].data.length; r++)if (void 0 !== t[e].data[r][1] && (Array.isArray(t[e].data[r][1]) && 4 === t[e].data[r][1].length && !s ? this.twoDSeries.push($b705b473d3ec9641$var$p.parseNumber(t[e].data[r][1][3])) : t[e].data[r].length >= 5 ? this.twoDSeries.push($b705b473d3ec9641$var$p.parseNumber(t[e].data[r][4])) : this.twoDSeries.push($b705b473d3ec9641$var$p.parseNumber(t[e].data[r][1])), a.dataFormatXNumeric = !0), "datetime" === i.xaxis.type) {
                    var o = new Date(t[e].data[r][0]);
                    o = new Date(o).getTime(), this.twoDSeriesX.push(o);
                } else this.twoDSeriesX.push(t[e].data[r][0]);
                for(var n = 0; n < t[e].data.length; n++)void 0 !== t[e].data[n][2] && (this.threeDSeries.push(t[e].data[n][2]), a.isDataXYZ = !0);
            }
        },
        {
            key: "handleFormatXY",
            value: function(t, e) {
                var i = this.w.config, a = this.w.globals, s = new $b705b473d3ec9641$var$Y(this.ctx), r = e;
                a.collapsedSeriesIndices.indexOf(e) > -1 && (r = this.activeSeriesIndex);
                for(var o = 0; o < t[e].data.length; o++)void 0 !== t[e].data[o].y && (Array.isArray(t[e].data[o].y) ? this.twoDSeries.push($b705b473d3ec9641$var$p.parseNumber(t[e].data[o].y[t[e].data[o].y.length - 1])) : this.twoDSeries.push($b705b473d3ec9641$var$p.parseNumber(t[e].data[o].y))), void 0 !== t[e].data[o].goals && Array.isArray(t[e].data[o].goals) ? (void 0 === this.seriesGoals[e] && (this.seriesGoals[e] = []), this.seriesGoals[e].push(t[e].data[o].goals)) : (void 0 === this.seriesGoals[e] && (this.seriesGoals[e] = []), this.seriesGoals[e].push(null));
                for(var n = 0; n < t[r].data.length; n++){
                    var l = "string" == typeof t[r].data[n].x, h = Array.isArray(t[r].data[n].x), c = !h && !!s.isValidDate(t[r].data[n].x.toString());
                    if (l || c) {
                        if (l || i.xaxis.convertedCatToNumeric) {
                            var d = a.isBarHorizontal && a.isRangeData;
                            "datetime" !== i.xaxis.type || d ? (this.fallbackToCategory = !0, this.twoDSeriesX.push(t[r].data[n].x)) : this.twoDSeriesX.push(s.parseDate(t[r].data[n].x));
                        } else "datetime" === i.xaxis.type ? this.twoDSeriesX.push(s.parseDate(t[r].data[n].x.toString())) : (a.dataFormatXNumeric = !0, a.isXNumeric = !0, this.twoDSeriesX.push(parseFloat(t[r].data[n].x)));
                    } else h ? (this.fallbackToCategory = !0, this.twoDSeriesX.push(t[r].data[n].x)) : (a.isXNumeric = !0, a.dataFormatXNumeric = !0, this.twoDSeriesX.push(t[r].data[n].x));
                }
                if (t[e].data[0] && void 0 !== t[e].data[0].z) {
                    for(var g = 0; g < t[e].data.length; g++)this.threeDSeries.push(t[e].data[g].z);
                    a.isDataXYZ = !0;
                }
            }
        },
        {
            key: "handleRangeData",
            value: function(t, e) {
                var i = this.w.globals, a = {};
                return this.isFormat2DArray() ? a = this.handleRangeDataFormat("array", t, e) : this.isFormatXY() && (a = this.handleRangeDataFormat("xy", t, e)), i.seriesRangeStart.push(a.start), i.seriesRangeEnd.push(a.end), i.seriesRangeBar.push(a.rangeUniques), i.seriesRangeBar.forEach(function(t, e) {
                    t && t.forEach(function(t, e) {
                        t.y.forEach(function(e, i) {
                            for(var a = 0; a < t.y.length; a++)if (i !== a) {
                                var s = e.y1, r = e.y2, o = t.y[a].y1;
                                s <= t.y[a].y2 && o <= r && (t.overlaps.indexOf(e.rangeName) < 0 && t.overlaps.push(e.rangeName), t.overlaps.indexOf(t.y[a].rangeName) < 0 && t.overlaps.push(t.y[a].rangeName));
                            }
                        });
                    });
                }), a;
            }
        },
        {
            key: "handleCandleStickBoxData",
            value: function(t, e) {
                var i = this.w.globals, a = {};
                return this.isFormat2DArray() ? a = this.handleCandleStickBoxDataFormat("array", t, e) : this.isFormatXY() && (a = this.handleCandleStickBoxDataFormat("xy", t, e)), i.seriesCandleO[e] = a.o, i.seriesCandleH[e] = a.h, i.seriesCandleM[e] = a.m, i.seriesCandleL[e] = a.l, i.seriesCandleC[e] = a.c, a;
            }
        },
        {
            key: "handleRangeDataFormat",
            value: function(t, e, i) {
                var a = [], s = [], r = e[i].data.filter(function(t, e, i) {
                    return e === i.findIndex(function(e) {
                        return e.x === t.x;
                    });
                }).map(function(t, e) {
                    return {
                        x: t.x,
                        overlaps: [],
                        y: []
                    };
                }), o = "Please provide [Start, End] values in valid format. Read more https://apexcharts.com/docs/series/#rangecharts", n = new $b705b473d3ec9641$var$z(this.ctx).getActiveConfigSeriesIndex();
                if ("array" === t) {
                    if (2 !== e[n].data[0][1].length) throw new Error(o);
                    for(var l = 0; l < e[i].data.length; l++)a.push(e[i].data[l][1][0]), s.push(e[i].data[l][1][1]);
                } else if ("xy" === t) {
                    if (2 !== e[n].data[0].y.length) throw new Error(o);
                    for(var h = function(t) {
                        var o = $b705b473d3ec9641$var$p.randomId(), n = e[i].data[t].x, l = {
                            y1: e[i].data[t].y[0],
                            y2: e[i].data[t].y[1],
                            rangeName: o
                        };
                        e[i].data[t].rangeName = o;
                        var h = r.findIndex(function(t) {
                            return t.x === n;
                        });
                        r[h].y.push(l), a.push(l.y1), s.push(l.y2);
                    }, c = 0; c < e[i].data.length; c++)h(c);
                }
                return {
                    start: a,
                    end: s,
                    rangeUniques: r
                };
            }
        },
        {
            key: "handleCandleStickBoxDataFormat",
            value: function(t, e, i) {
                var a = this.w, s = "boxPlot" === a.config.chart.type || "boxPlot" === a.config.series[i].type, r = [], o = [], n = [], l = [], h = [];
                if ("array" === t) {
                    if (s && 6 === e[i].data[0].length || !s && 5 === e[i].data[0].length) for(var c = 0; c < e[i].data.length; c++)r.push(e[i].data[c][1]), o.push(e[i].data[c][2]), s ? (n.push(e[i].data[c][3]), l.push(e[i].data[c][4]), h.push(e[i].data[c][5])) : (l.push(e[i].data[c][3]), h.push(e[i].data[c][4]));
                    else for(var d = 0; d < e[i].data.length; d++)Array.isArray(e[i].data[d][1]) && (r.push(e[i].data[d][1][0]), o.push(e[i].data[d][1][1]), s ? (n.push(e[i].data[d][1][2]), l.push(e[i].data[d][1][3]), h.push(e[i].data[d][1][4])) : (l.push(e[i].data[d][1][2]), h.push(e[i].data[d][1][3])));
                } else if ("xy" === t) for(var g = 0; g < e[i].data.length; g++)Array.isArray(e[i].data[g].y) && (r.push(e[i].data[g].y[0]), o.push(e[i].data[g].y[1]), s ? (n.push(e[i].data[g].y[2]), l.push(e[i].data[g].y[3]), h.push(e[i].data[g].y[4])) : (l.push(e[i].data[g].y[2]), h.push(e[i].data[g].y[3])));
                return {
                    o: r,
                    h: o,
                    m: n,
                    l: l,
                    c: h
                };
            }
        },
        {
            key: "parseDataAxisCharts",
            value: function(t) {
                var e = this, i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : this.ctx, a = this.w.config, s = this.w.globals, r = new $b705b473d3ec9641$var$Y(i), o = a.labels.length > 0 ? a.labels.slice() : a.xaxis.categories.slice();
                s.isRangeBar = "rangeBar" === a.chart.type && s.isBarHorizontal;
                for(var n = function() {
                    for(var t = 0; t < o.length; t++)if ("string" == typeof o[t]) {
                        if (!r.isValidDate(o[t])) throw new Error("You have provided invalid Date format. Please provide a valid JavaScript Date");
                        e.twoDSeriesX.push(r.parseDate(o[t]));
                    } else e.twoDSeriesX.push(o[t]);
                }, l = 0; l < t.length; l++){
                    if (this.twoDSeries = [], this.twoDSeriesX = [], this.threeDSeries = [], void 0 === t[l].data) return void console.error("It is a possibility that you may have not included 'data' property in series.");
                    if ("rangeBar" !== a.chart.type && "rangeArea" !== a.chart.type && "rangeBar" !== t[l].type && "rangeArea" !== t[l].type || (s.isRangeData = !0, this.handleRangeData(t, l)), this.isMultiFormat()) this.isFormat2DArray() ? this.handleFormat2DArray(t, l) : this.isFormatXY() && this.handleFormatXY(t, l), "candlestick" !== a.chart.type && "candlestick" !== t[l].type && "boxPlot" !== a.chart.type && "boxPlot" !== t[l].type || this.handleCandleStickBoxData(t, l), s.series.push(this.twoDSeries), s.labels.push(this.twoDSeriesX), s.seriesX.push(this.twoDSeriesX), s.seriesGoals = this.seriesGoals, l !== this.activeSeriesIndex || this.fallbackToCategory || (s.isXNumeric = !0);
                    else {
                        "datetime" === a.xaxis.type ? (s.isXNumeric = !0, n(), s.seriesX.push(this.twoDSeriesX)) : "numeric" === a.xaxis.type && (s.isXNumeric = !0, o.length > 0 && (this.twoDSeriesX = o, s.seriesX.push(this.twoDSeriesX))), s.labels.push(this.twoDSeriesX);
                        var h = t[l].data.map(function(t) {
                            return $b705b473d3ec9641$var$p.parseNumber(t);
                        });
                        s.series.push(h);
                    }
                    s.seriesZ.push(this.threeDSeries), void 0 !== t[l].name ? s.seriesNames.push(t[l].name) : s.seriesNames.push("series-" + parseInt(l + 1, 10)), void 0 !== t[l].color ? s.seriesColors.push(t[l].color) : s.seriesColors.push(void 0);
                }
                return this.w;
            }
        },
        {
            key: "parseDataNonAxisCharts",
            value: function(t) {
                var e = this.w.globals, i = this.w.config;
                e.series = t.slice(), e.seriesNames = i.labels.slice();
                for(var a = 0; a < e.series.length; a++)void 0 === e.seriesNames[a] && e.seriesNames.push("series-" + (a + 1));
                return this.w;
            }
        },
        {
            key: "handleExternalLabelsData",
            value: function(t) {
                var e = this.w.config, i = this.w.globals;
                if (e.xaxis.categories.length > 0) i.labels = e.xaxis.categories;
                else if (e.labels.length > 0) i.labels = e.labels.slice();
                else if (this.fallbackToCategory) {
                    if (i.labels = i.labels[0], i.seriesRangeBar.length && (i.seriesRangeBar.map(function(t) {
                        t.forEach(function(t) {
                            i.labels.indexOf(t.x) < 0 && t.x && i.labels.push(t.x);
                        });
                    }), i.labels = i.labels.filter(function(t, e, i) {
                        return i.indexOf(t) === e;
                    })), e.xaxis.convertedCatToNumeric) new $b705b473d3ec9641$var$R(e).convertCatToNumericXaxis(e, this.ctx, i.seriesX[0]), this._generateExternalLabels(t);
                } else this._generateExternalLabels(t);
            }
        },
        {
            key: "_generateExternalLabels",
            value: function(t) {
                var e = this.w.globals, i = this.w.config, a = [];
                if (e.axisCharts) {
                    if (e.series.length > 0) {
                        if (this.isFormatXY()) for(var s = i.series.map(function(t, e) {
                            return t.data.filter(function(t, e, i) {
                                return i.findIndex(function(e) {
                                    return e.x === t.x;
                                }) === e;
                            });
                        }), r = s.reduce(function(t, e, i, a) {
                            return a[t].length > e.length ? t : i;
                        }, 0), o = 0; o < s[r].length; o++)a.push(o + 1);
                        else for(var n = 0; n < e.series[e.maxValsInArrayIndex].length; n++)a.push(n + 1);
                    }
                    e.seriesX = [];
                    for(var l = 0; l < t.length; l++)e.seriesX.push(a);
                    e.isXNumeric = !0;
                }
                if (0 === a.length) {
                    a = e.axisCharts ? [] : e.series.map(function(t, e) {
                        return e + 1;
                    });
                    for(var h = 0; h < t.length; h++)e.seriesX.push(a);
                }
                e.labels = a, i.xaxis.convertedCatToNumeric && (e.categoryLabels = a.map(function(t) {
                    return i.xaxis.labels.formatter(t);
                })), e.noLabelsProvided = !0;
            }
        },
        {
            key: "parseData",
            value: function(t) {
                var e = this.w, i = e.config, a = e.globals;
                if (this.excludeCollapsedSeriesInYAxis(), this.fallbackToCategory = !1, this.ctx.core.resetGlobals(), this.ctx.core.isMultipleY(), a.axisCharts ? this.parseDataAxisCharts(t) : this.parseDataNonAxisCharts(t), this.coreUtils.getLargestSeries(), "bar" === i.chart.type && i.chart.stacked) {
                    var s = new $b705b473d3ec9641$var$z(this.ctx);
                    a.series = s.setNullSeriesToZeroValues(a.series);
                }
                this.coreUtils.getSeriesTotals(), a.axisCharts && this.coreUtils.getStackedSeriesTotals(), this.coreUtils.getPercentSeries(), a.dataFormatXNumeric || a.isXNumeric && ("numeric" !== i.xaxis.type || 0 !== i.labels.length || 0 !== i.xaxis.categories.length) || this.handleExternalLabelsData(t);
                for(var r = this.coreUtils.getCategoryLabels(a.labels), o = 0; o < r.length; o++)if (Array.isArray(r[o])) {
                    a.isMultiLineX = !0;
                    break;
                }
            }
        },
        {
            key: "excludeCollapsedSeriesInYAxis",
            value: function() {
                var t = this, e = this.w;
                e.globals.ignoreYAxisIndexes = e.globals.collapsedSeries.map(function(i, a) {
                    if (t.w.globals.isMultipleYAxis && !e.config.chart.stacked) return i.index;
                });
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$W = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.ctx = e, this.w = e.w, this.tooltipKeyFormat = "dd MMM";
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "xLabelFormat",
            value: function(t, e, i, a) {
                var s = this.w;
                if ("datetime" === s.config.xaxis.type && void 0 === s.config.xaxis.labels.formatter && void 0 === s.config.tooltip.x.formatter) {
                    var r = new $b705b473d3ec9641$var$Y(this.ctx);
                    return r.formatDate(r.getDate(e), s.config.tooltip.x.format);
                }
                return t(e, i, a);
            }
        },
        {
            key: "defaultGeneralFormatter",
            value: function(t) {
                return Array.isArray(t) ? t.map(function(t) {
                    return t;
                }) : t;
            }
        },
        {
            key: "defaultYFormatter",
            value: function(t, e, i) {
                var a = this.w;
                return $b705b473d3ec9641$var$p.isNumber(t) && (t = 0 !== a.globals.yValueDecimal ? t.toFixed(void 0 !== e.decimalsInFloat ? e.decimalsInFloat : a.globals.yValueDecimal) : a.globals.maxYArr[i] - a.globals.minYArr[i] < 5 ? t.toFixed(1) : t.toFixed(0)), t;
            }
        },
        {
            key: "setLabelFormatters",
            value: function() {
                var t = this, e = this.w;
                return e.globals.xaxisTooltipFormatter = function(e) {
                    return t.defaultGeneralFormatter(e);
                }, e.globals.ttKeyFormatter = function(e) {
                    return t.defaultGeneralFormatter(e);
                }, e.globals.ttZFormatter = function(t) {
                    return t;
                }, e.globals.legendFormatter = function(e) {
                    return t.defaultGeneralFormatter(e);
                }, void 0 !== e.config.xaxis.labels.formatter ? e.globals.xLabelFormatter = e.config.xaxis.labels.formatter : e.globals.xLabelFormatter = function(t) {
                    if ($b705b473d3ec9641$var$p.isNumber(t)) {
                        if (!e.config.xaxis.convertedCatToNumeric && "numeric" === e.config.xaxis.type) {
                            if ($b705b473d3ec9641$var$p.isNumber(e.config.xaxis.decimalsInFloat)) return t.toFixed(e.config.xaxis.decimalsInFloat);
                            var i = e.globals.maxX - e.globals.minX;
                            return i > 0 && i < 100 ? t.toFixed(1) : t.toFixed(0);
                        }
                        if (e.globals.isBarHorizontal) {
                            if (e.globals.maxY - e.globals.minYArr < 4) return t.toFixed(1);
                        }
                        return t.toFixed(0);
                    }
                    return t;
                }, "function" == typeof e.config.tooltip.x.formatter ? e.globals.ttKeyFormatter = e.config.tooltip.x.formatter : e.globals.ttKeyFormatter = e.globals.xLabelFormatter, "function" == typeof e.config.xaxis.tooltip.formatter && (e.globals.xaxisTooltipFormatter = e.config.xaxis.tooltip.formatter), (Array.isArray(e.config.tooltip.y) || void 0 !== e.config.tooltip.y.formatter) && (e.globals.ttVal = e.config.tooltip.y), void 0 !== e.config.tooltip.z.formatter && (e.globals.ttZFormatter = e.config.tooltip.z.formatter), void 0 !== e.config.legend.formatter && (e.globals.legendFormatter = e.config.legend.formatter), e.config.yaxis.forEach(function(i, a) {
                    void 0 !== i.labels.formatter ? e.globals.yLabelFormatters[a] = i.labels.formatter : e.globals.yLabelFormatters[a] = function(s) {
                        return e.globals.xyCharts ? Array.isArray(s) ? s.map(function(e) {
                            return t.defaultYFormatter(e, i, a);
                        }) : t.defaultYFormatter(s, i, a) : s;
                    };
                }), e.globals;
            }
        },
        {
            key: "heatmapLabelFormatters",
            value: function() {
                var t = this.w;
                if ("heatmap" === t.config.chart.type) {
                    t.globals.yAxisScale[0].result = t.globals.seriesNames.slice();
                    var e = t.globals.seriesNames.reduce(function(t, e) {
                        return t.length > e.length ? t : e;
                    }, 0);
                    t.globals.yAxisScale[0].niceMax = e, t.globals.yAxisScale[0].niceMin = e;
                }
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$B = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "getLabel",
            value: function(t, e, i, a) {
                var s = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : [], r = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : "12px", o = this.w, n = void 0 === t[a] ? "" : t[a], l = n, h = o.globals.xLabelFormatter, c = o.config.xaxis.labels.formatter, d = !1, g = new $b705b473d3ec9641$var$W(this.ctx), u = n;
                l = g.xLabelFormat(h, n, u, {
                    i: a,
                    dateFormatter: new $b705b473d3ec9641$var$Y(this.ctx).formatDate,
                    w: o
                }), void 0 !== c && (l = c(n, t[a], {
                    i: a,
                    dateFormatter: new $b705b473d3ec9641$var$Y(this.ctx).formatDate,
                    w: o
                }));
                var p = function(t) {
                    var i = null;
                    return e.forEach(function(t) {
                        "month" === t.unit ? i = "year" : "day" === t.unit ? i = "month" : "hour" === t.unit ? i = "day" : "minute" === t.unit && (i = "hour");
                    }), i === t;
                };
                e.length > 0 ? (d = p(e[a].unit), i = e[a].position, l = e[a].value) : "datetime" === o.config.xaxis.type && void 0 === c && (l = ""), void 0 === l && (l = ""), l = Array.isArray(l) ? l : l.toString();
                var f = new $b705b473d3ec9641$var$b(this.ctx), x = {};
                x = o.globals.rotateXLabels ? f.getTextRects(l, parseInt(r, 10), null, "rotate(".concat(o.config.xaxis.labels.rotate, " 0 0)"), !1) : f.getTextRects(l, parseInt(r, 10));
                var v = !o.config.xaxis.labels.showDuplicates && this.ctx.timeScale;
                return !Array.isArray(l) && (0 === l.indexOf("NaN") || 0 === l.toLowerCase().indexOf("invalid") || l.toLowerCase().indexOf("infinity") >= 0 || s.indexOf(l) >= 0 && v) && (l = ""), {
                    x: i,
                    text: l,
                    textRect: x,
                    isBold: d
                };
            }
        },
        {
            key: "checkLabelBasedOnTickamount",
            value: function(t, e, i) {
                var a = this.w, s = a.config.xaxis.tickAmount;
                return "dataPoints" === s && (s = Math.round(a.globals.gridWidth / 120)), s > i || t % Math.round(i / (s + 1)) == 0 || (e.text = ""), e;
            }
        },
        {
            key: "checkForOverflowingLabels",
            value: function(t, e, i, a, s) {
                var r = this.w;
                if (0 === t && r.globals.skipFirstTimelinelabel && (e.text = ""), t === i - 1 && r.globals.skipLastTimelinelabel && (e.text = ""), r.config.xaxis.labels.hideOverlappingLabels && a.length > 0) {
                    var o = s[s.length - 1];
                    e.x < o.textRect.width / (r.globals.rotateXLabels ? Math.abs(r.config.xaxis.labels.rotate) / 12 : 1.01) + o.x && (e.text = "");
                }
                return e;
            }
        },
        {
            key: "checkForReversedLabels",
            value: function(t, e) {
                var i = this.w;
                return i.config.yaxis[t] && i.config.yaxis[t].reversed && e.reverse(), e;
            }
        },
        {
            key: "isYAxisHidden",
            value: function(t) {
                var e = this.w, i = new $b705b473d3ec9641$var$y(this.ctx);
                return !e.config.yaxis[t].show || !e.config.yaxis[t].showForNullSeries && i.isSeriesNull(t) && -1 === e.globals.collapsedSeriesIndices.indexOf(t);
            }
        },
        {
            key: "getYAxisForeColor",
            value: function(t, e) {
                var i = this.w;
                return Array.isArray(t) && i.globals.yAxisScale[e] && this.ctx.theme.pushExtraColors(t, i.globals.yAxisScale[e].result.length, !1), t;
            }
        },
        {
            key: "drawYAxisTicks",
            value: function(t, e, i, a, s, r, o) {
                var n = this.w, l = new $b705b473d3ec9641$var$b(this.ctx), h = n.globals.translateY;
                if (a.show && e > 0) {
                    !0 === n.config.yaxis[s].opposite && (t += a.width);
                    for(var c = e; c >= 0; c--){
                        var d = h + e / 10 + n.config.yaxis[s].labels.offsetY - 1;
                        n.globals.isBarHorizontal && (d = r * c), "heatmap" === n.config.chart.type && (d += r / 2);
                        var g = l.drawLine(t + i.offsetX - a.width + a.offsetX, d + a.offsetY, t + i.offsetX + a.offsetX, d + a.offsetY, a.color);
                        o.add(g), h += r;
                    }
                }
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$V = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "scaleSvgNode",
            value: function(t, e) {
                var i = parseFloat(t.getAttributeNS(null, "width")), a = parseFloat(t.getAttributeNS(null, "height"));
                t.setAttributeNS(null, "width", i * e), t.setAttributeNS(null, "height", a * e), t.setAttributeNS(null, "viewBox", "0 0 " + i + " " + a);
            }
        },
        {
            key: "fixSvgStringForIe11",
            value: function(t) {
                if (!$b705b473d3ec9641$var$p.isIE11()) return t.replace(/&nbsp;/g, "&#160;");
                var e = 0, i = t.replace(/xmlns="http:\/\/www.w3.org\/2000\/svg"/g, function(t) {
                    return 2 === ++e ? 'xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:svgjs="http://svgjs.dev"' : t;
                });
                return i = (i = i.replace(/xmlns:NS\d+=""/g, "")).replace(/NS\d+:(\w+:\w+=")/g, "$1");
            }
        },
        {
            key: "getSvgString",
            value: function(t) {
                var e = this.w.globals.dom.Paper.svg();
                if (1 !== t) {
                    var i = this.w.globals.dom.Paper.node.cloneNode(!0);
                    this.scaleSvgNode(i, t), e = (new XMLSerializer).serializeToString(i);
                }
                return this.fixSvgStringForIe11(e);
            }
        },
        {
            key: "cleanup",
            value: function() {
                var t = this.w, e = t.globals.dom.baseEl.getElementsByClassName("apexcharts-xcrosshairs"), i = t.globals.dom.baseEl.getElementsByClassName("apexcharts-ycrosshairs"), a = t.globals.dom.baseEl.querySelectorAll(".apexcharts-zoom-rect, .apexcharts-selection-rect");
                Array.prototype.forEach.call(a, function(t) {
                    t.setAttribute("width", 0);
                }), e && e[0] && (e[0].setAttribute("x", -500), e[0].setAttribute("x1", -500), e[0].setAttribute("x2", -500)), i && i[0] && (i[0].setAttribute("y", -100), i[0].setAttribute("y1", -100), i[0].setAttribute("y2", -100));
            }
        },
        {
            key: "svgUrl",
            value: function() {
                this.cleanup();
                var t = this.getSvgString(), e = new Blob([
                    t
                ], {
                    type: "image/svg+xml;charset=utf-8"
                });
                return URL.createObjectURL(e);
            }
        },
        {
            key: "dataURI",
            value: function(t) {
                var e = this;
                return new Promise(function(i) {
                    var a = e.w, s = t ? t.scale || t.width / a.globals.svgWidth : 1;
                    e.cleanup();
                    var r = document.createElement("canvas");
                    r.width = a.globals.svgWidth * s, r.height = parseInt(a.globals.dom.elWrap.style.height, 10) * s;
                    var o = "transparent" === a.config.chart.background ? "#fff" : a.config.chart.background, n = r.getContext("2d");
                    n.fillStyle = o, n.fillRect(0, 0, r.width * s, r.height * s);
                    var l = e.getSvgString(s);
                    if (window.canvg && $b705b473d3ec9641$var$p.isIE11()) {
                        var h = window.canvg.Canvg.fromString(n, l, {
                            ignoreClear: !0,
                            ignoreDimensions: !0
                        });
                        h.start();
                        var c = r.msToBlob();
                        h.stop(), i({
                            blob: c
                        });
                    } else {
                        var d = "data:image/svg+xml," + encodeURIComponent(l), g = new Image;
                        g.crossOrigin = "anonymous", g.onload = function() {
                            if (n.drawImage(g, 0, 0), r.msToBlob) {
                                var t = r.msToBlob();
                                i({
                                    blob: t
                                });
                            } else {
                                var e = r.toDataURL("image/png");
                                i({
                                    imgURI: e
                                });
                            }
                        }, g.src = d;
                    }
                });
            }
        },
        {
            key: "exportToSVG",
            value: function() {
                this.triggerDownload(this.svgUrl(), this.w.config.chart.toolbar.export.svg.filename, ".svg");
            }
        },
        {
            key: "exportToPng",
            value: function() {
                var t = this;
                this.dataURI().then(function(e) {
                    var i = e.imgURI, a = e.blob;
                    a ? navigator.msSaveOrOpenBlob(a, t.w.globals.chartID + ".png") : t.triggerDownload(i, t.w.config.chart.toolbar.export.png.filename, ".png");
                });
            }
        },
        {
            key: "exportToCSV",
            value: function(t) {
                var e = this, i = t.series, a = t.columnDelimiter, s = t.lineDelimiter, r = void 0 === s ? "\n" : s, o = this.w, n = [], l = [], h = "", c = new $b705b473d3ec9641$var$O(this.ctx), d = new $b705b473d3ec9641$var$B(this.ctx), g = function(t) {
                    var i = "";
                    if (o.globals.axisCharts) {
                        if ("category" === o.config.xaxis.type || o.config.xaxis.convertedCatToNumeric) {
                            if (o.globals.isBarHorizontal) {
                                var s = o.globals.yLabelFormatters[0], r = new $b705b473d3ec9641$var$z(e.ctx).getActiveConfigSeriesIndex();
                                i = s(o.globals.labels[t], {
                                    seriesIndex: r,
                                    dataPointIndex: t,
                                    w: o
                                });
                            } else i = d.getLabel(o.globals.labels, o.globals.timescaleLabels, 0, t).text;
                        }
                        "datetime" === o.config.xaxis.type && (o.config.xaxis.categories.length ? i = o.config.xaxis.categories[t] : o.config.labels.length && (i = o.config.labels[t]));
                    } else i = o.config.labels[t];
                    return Array.isArray(i) && (i = i.join(" ")), $b705b473d3ec9641$var$p.isNumber(i) ? i : i.split(a).join("");
                };
                n.push(o.config.chart.toolbar.export.csv.headerCategory), i.map(function(t, e) {
                    var i = t.name ? t.name : "series-".concat(e);
                    o.globals.axisCharts && n.push(i.split(a).join("") ? i.split(a).join("") : "series-".concat(e));
                }), o.globals.axisCharts || (n.push(o.config.chart.toolbar.export.csv.headerValue), l.push(n.join(a))), i.map(function(t, e) {
                    o.globals.axisCharts ? function(t, e) {
                        if (n.length && 0 === e && l.push(n.join(a)), t.data && t.data.length) for(var s = 0; s < t.data.length; s++){
                            n = [];
                            var r = g(s);
                            if (r || (c.isFormatXY() ? r = i[e].data[s].x : c.isFormat2DArray() && (r = i[e].data[s] ? i[e].data[s][0] : "")), 0 === e) {
                                n.push((d = r, "datetime" === o.config.xaxis.type && String(d).length >= 10 ? o.config.chart.toolbar.export.csv.dateFormatter(r) : $b705b473d3ec9641$var$p.isNumber(r) ? r : r.split(a).join("")));
                                for(var h = 0; h < o.globals.series.length; h++)n.push(o.globals.series[h][s]);
                            }
                            ("candlestick" === o.config.chart.type || t.type && "candlestick" === t.type) && (n.pop(), n.push(o.globals.seriesCandleO[e][s]), n.push(o.globals.seriesCandleH[e][s]), n.push(o.globals.seriesCandleL[e][s]), n.push(o.globals.seriesCandleC[e][s])), ("boxPlot" === o.config.chart.type || t.type && "boxPlot" === t.type) && (n.pop(), n.push(o.globals.seriesCandleO[e][s]), n.push(o.globals.seriesCandleH[e][s]), n.push(o.globals.seriesCandleM[e][s]), n.push(o.globals.seriesCandleL[e][s]), n.push(o.globals.seriesCandleC[e][s])), "rangeBar" === o.config.chart.type && (n.pop(), n.push(o.globals.seriesRangeStart[e][s]), n.push(o.globals.seriesRangeEnd[e][s])), n.length && l.push(n.join(a));
                        }
                        var d;
                    }(t, e) : ((n = []).push(o.globals.labels[e].split(a).join("")), n.push(o.globals.series[e]), l.push(n.join(a)));
                }), h += l.join(r), this.triggerDownload("data:text/csv; charset=utf-8," + encodeURIComponent("\uFEFF" + h), o.config.chart.toolbar.export.csv.filename, ".csv");
            }
        },
        {
            key: "triggerDownload",
            value: function(t, e, i) {
                var a = document.createElement("a");
                a.href = t, a.download = (e || this.w.globals.chartID) + i, document.body.appendChild(a), a.click(), document.body.removeChild(a);
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$G = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.ctx = e, this.w = e.w;
        var i = this.w;
        this.axesUtils = new $b705b473d3ec9641$var$B(e), this.xaxisLabels = i.globals.labels.slice(), i.globals.timescaleLabels.length > 0 && !i.globals.isBarHorizontal && (this.xaxisLabels = i.globals.timescaleLabels.slice()), i.config.xaxis.overwriteCategories && (this.xaxisLabels = i.config.xaxis.overwriteCategories), this.drawnLabels = [], this.drawnLabelsRects = [], "top" === i.config.xaxis.position ? this.offY = 0 : this.offY = i.globals.gridHeight + 1, this.offY = this.offY + i.config.xaxis.axisBorder.offsetY, this.isCategoryBarHorizontal = "bar" === i.config.chart.type && i.config.plotOptions.bar.horizontal, this.xaxisFontSize = i.config.xaxis.labels.style.fontSize, this.xaxisFontFamily = i.config.xaxis.labels.style.fontFamily, this.xaxisForeColors = i.config.xaxis.labels.style.colors, this.xaxisBorderWidth = i.config.xaxis.axisBorder.width, this.isCategoryBarHorizontal && (this.xaxisBorderWidth = i.config.yaxis[0].axisBorder.width.toString()), this.xaxisBorderWidth.indexOf("%") > -1 ? this.xaxisBorderWidth = i.globals.gridWidth * parseInt(this.xaxisBorderWidth, 10) / 100 : this.xaxisBorderWidth = parseInt(this.xaxisBorderWidth, 10), this.xaxisBorderHeight = i.config.xaxis.axisBorder.height, this.yaxis = i.config.yaxis[0];
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "drawXaxis",
            value: function() {
                var t, e = this, i = this.w, a = new $b705b473d3ec9641$var$b(this.ctx), s = a.group({
                    class: "apexcharts-xaxis",
                    transform: "translate(".concat(i.config.xaxis.offsetX, ", ").concat(i.config.xaxis.offsetY, ")")
                }), r = a.group({
                    class: "apexcharts-xaxis-texts-g",
                    transform: "translate(".concat(i.globals.translateXAxisX, ", ").concat(i.globals.translateXAxisY, ")")
                });
                s.add(r);
                for(var o = i.globals.padHorizontal, n = [], l = 0; l < this.xaxisLabels.length; l++)n.push(this.xaxisLabels[l]);
                var h = n.length;
                if (i.globals.isXNumeric) {
                    var c = h > 1 ? h - 1 : h;
                    t = i.globals.gridWidth / c, o = o + t / 2 + i.config.xaxis.labels.offsetX;
                } else t = i.globals.gridWidth / n.length, o = o + t + i.config.xaxis.labels.offsetX;
                for(var d = function(s) {
                    var l = o - t / 2 + i.config.xaxis.labels.offsetX;
                    0 === s && 1 === h && t / 2 === o && 1 === i.globals.dataPoints && (l = i.globals.gridWidth / 2);
                    var c = e.axesUtils.getLabel(n, i.globals.timescaleLabels, l, s, e.drawnLabels, e.xaxisFontSize), d = 28;
                    i.globals.rotateXLabels && (d = 22);
                    if ((c = void 0 !== i.config.xaxis.tickAmount && "dataPoints" !== i.config.xaxis.tickAmount && "datetime" !== i.config.xaxis.type ? e.axesUtils.checkLabelBasedOnTickamount(s, c, h) : e.axesUtils.checkForOverflowingLabels(s, c, h, e.drawnLabels, e.drawnLabelsRects)).text && i.globals.xaxisLabelsCount++, i.config.xaxis.labels.show) {
                        var g = a.drawText({
                            x: c.x,
                            y: e.offY + i.config.xaxis.labels.offsetY + d - ("top" === i.config.xaxis.position ? i.globals.xAxisHeight + i.config.xaxis.axisTicks.height - 2 : 0),
                            text: c.text,
                            textAnchor: "middle",
                            fontWeight: c.isBold ? 600 : i.config.xaxis.labels.style.fontWeight,
                            fontSize: e.xaxisFontSize,
                            fontFamily: e.xaxisFontFamily,
                            foreColor: Array.isArray(e.xaxisForeColors) ? i.config.xaxis.convertedCatToNumeric ? e.xaxisForeColors[i.globals.minX + s - 1] : e.xaxisForeColors[s] : e.xaxisForeColors,
                            isPlainText: !1,
                            cssClass: "apexcharts-xaxis-label " + i.config.xaxis.labels.style.cssClass
                        });
                        r.add(g);
                        var u = document.createElementNS(i.globals.SVGNS, "title");
                        u.textContent = Array.isArray(c.text) ? c.text.join(" ") : c.text, g.node.appendChild(u), "" !== c.text && (e.drawnLabels.push(c.text), e.drawnLabelsRects.push(c));
                    }
                    o += t;
                }, g = 0; g <= h - 1; g++)d(g);
                if (void 0 !== i.config.xaxis.title.text) {
                    var u = a.group({
                        class: "apexcharts-xaxis-title"
                    }), p = a.drawText({
                        x: i.globals.gridWidth / 2 + i.config.xaxis.title.offsetX,
                        y: this.offY + parseFloat(this.xaxisFontSize) + i.globals.xAxisLabelsHeight + i.config.xaxis.title.offsetY,
                        text: i.config.xaxis.title.text,
                        textAnchor: "middle",
                        fontSize: i.config.xaxis.title.style.fontSize,
                        fontFamily: i.config.xaxis.title.style.fontFamily,
                        fontWeight: i.config.xaxis.title.style.fontWeight,
                        foreColor: i.config.xaxis.title.style.color,
                        cssClass: "apexcharts-xaxis-title-text " + i.config.xaxis.title.style.cssClass
                    });
                    u.add(p), s.add(u);
                }
                if (i.config.xaxis.axisBorder.show) {
                    var f = i.globals.barPadForNumericAxis, x = a.drawLine(i.globals.padHorizontal + i.config.xaxis.axisBorder.offsetX - f, this.offY, this.xaxisBorderWidth + f, this.offY, i.config.xaxis.axisBorder.color, 0, this.xaxisBorderHeight);
                    s.add(x);
                }
                return s;
            }
        },
        {
            key: "drawXaxisInversed",
            value: function(t) {
                var e, i, a = this, s = this.w, r = new $b705b473d3ec9641$var$b(this.ctx), o = s.config.yaxis[0].opposite ? s.globals.translateYAxisX[t] : 0, n = r.group({
                    class: "apexcharts-yaxis apexcharts-xaxis-inversed",
                    rel: t
                }), l = r.group({
                    class: "apexcharts-yaxis-texts-g apexcharts-xaxis-inversed-texts-g",
                    transform: "translate(" + o + ", 0)"
                });
                n.add(l);
                var h = [];
                if (s.config.yaxis[t].show) for(var c = 0; c < this.xaxisLabels.length; c++)h.push(this.xaxisLabels[c]);
                e = s.globals.gridHeight / h.length, i = -e / 2.2;
                var d = s.globals.yLabelFormatters[0], g = s.config.yaxis[0].labels;
                if (g.show) for(var u = function(o) {
                    var n = void 0 === h[o] ? "" : h[o];
                    n = d(n, {
                        seriesIndex: t,
                        dataPointIndex: o,
                        w: s
                    });
                    var c = a.axesUtils.getYAxisForeColor(g.style.colors, t), u = 0;
                    Array.isArray(n) && (u = n.length / 2 * parseInt(g.style.fontSize, 10));
                    var p = r.drawText({
                        x: g.offsetX - 15,
                        y: i + e + g.offsetY - u,
                        text: n,
                        textAnchor: a.yaxis.opposite ? "start" : "end",
                        foreColor: Array.isArray(c) ? c[o] : c,
                        fontSize: g.style.fontSize,
                        fontFamily: g.style.fontFamily,
                        fontWeight: g.style.fontWeight,
                        isPlainText: !1,
                        cssClass: "apexcharts-yaxis-label " + g.style.cssClass
                    });
                    l.add(p);
                    var f = document.createElementNS(s.globals.SVGNS, "title");
                    if (f.textContent = Array.isArray(n) ? n.join(" ") : n, p.node.appendChild(f), 0 !== s.config.yaxis[t].labels.rotate) {
                        var x = r.rotateAroundCenter(p.node);
                        p.node.setAttribute("transform", "rotate(".concat(s.config.yaxis[t].labels.rotate, " 0 ").concat(x.y, ")"));
                    }
                    i += e;
                }, p = 0; p <= h.length - 1; p++)u(p);
                if (void 0 !== s.config.yaxis[0].title.text) {
                    var f = r.group({
                        class: "apexcharts-yaxis-title apexcharts-xaxis-title-inversed",
                        transform: "translate(" + o + ", 0)"
                    }), x = r.drawText({
                        x: 0,
                        y: s.globals.gridHeight / 2,
                        text: s.config.yaxis[0].title.text,
                        textAnchor: "middle",
                        foreColor: s.config.yaxis[0].title.style.color,
                        fontSize: s.config.yaxis[0].title.style.fontSize,
                        fontWeight: s.config.yaxis[0].title.style.fontWeight,
                        fontFamily: s.config.yaxis[0].title.style.fontFamily,
                        cssClass: "apexcharts-yaxis-title-text " + s.config.yaxis[0].title.style.cssClass
                    });
                    f.add(x), n.add(f);
                }
                var v = 0;
                this.isCategoryBarHorizontal && s.config.yaxis[0].opposite && (v = s.globals.gridWidth);
                var m = s.config.xaxis.axisBorder;
                if (m.show) {
                    var y = r.drawLine(s.globals.padHorizontal + m.offsetX + v, 1 + m.offsetY, s.globals.padHorizontal + m.offsetX + v, s.globals.gridHeight + m.offsetY, m.color, 0);
                    n.add(y);
                }
                return s.config.yaxis[0].axisTicks.show && this.axesUtils.drawYAxisTicks(v, h.length, s.config.yaxis[0].axisBorder, s.config.yaxis[0].axisTicks, 0, e, n), n;
            }
        },
        {
            key: "drawXaxisTicks",
            value: function(t, e) {
                var i = this.w, a = t;
                if (!(t < 0 || t - 2 > i.globals.gridWidth)) {
                    var s = this.offY + i.config.xaxis.axisTicks.offsetY, r = s + i.config.xaxis.axisTicks.height;
                    if ("top" === i.config.xaxis.position && (r = s - i.config.xaxis.axisTicks.height), i.config.xaxis.axisTicks.show) {
                        var o = new $b705b473d3ec9641$var$b(this.ctx).drawLine(t + i.config.xaxis.axisTicks.offsetX, s + i.config.xaxis.offsetY, a + i.config.xaxis.axisTicks.offsetX, r + i.config.xaxis.offsetY, i.config.xaxis.axisTicks.color);
                        e.add(o), o.node.classList.add("apexcharts-xaxis-tick");
                    }
                }
            }
        },
        {
            key: "getXAxisTicksPositions",
            value: function() {
                var t = this.w, e = [], i = this.xaxisLabels.length, a = t.globals.padHorizontal;
                if (t.globals.timescaleLabels.length > 0) for(var s = 0; s < i; s++)a = this.xaxisLabels[s].position, e.push(a);
                else for(var r = i, o = 0; o < r; o++){
                    var n = r;
                    t.globals.isXNumeric && "bar" !== t.config.chart.type && (n -= 1), a += t.globals.gridWidth / n, e.push(a);
                }
                return e;
            }
        },
        {
            key: "xAxisLabelCorrections",
            value: function() {
                var t = this.w, e = new $b705b473d3ec9641$var$b(this.ctx), i = t.globals.dom.baseEl.querySelector(".apexcharts-xaxis-texts-g"), a = t.globals.dom.baseEl.querySelectorAll(".apexcharts-xaxis-texts-g text"), s = t.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxis-inversed text"), r = t.globals.dom.baseEl.querySelectorAll(".apexcharts-xaxis-inversed-texts-g text tspan");
                if (t.globals.rotateXLabels || t.config.xaxis.labels.rotateAlways) for(var o = 0; o < a.length; o++){
                    var n = e.rotateAroundCenter(a[o]);
                    n.y = n.y - 1, n.x = n.x + 1, a[o].setAttribute("transform", "rotate(".concat(t.config.xaxis.labels.rotate, " ").concat(n.x, " ").concat(n.y, ")")), a[o].setAttribute("text-anchor", "end");
                    i.setAttribute("transform", "translate(0, ".concat(-10, ")"));
                    var l = a[o].childNodes;
                    t.config.xaxis.labels.trim && Array.prototype.forEach.call(l, function(i) {
                        e.placeTextWithEllipsis(i, i.textContent, t.globals.xAxisLabelsHeight - ("bottom" === t.config.legend.position ? 20 : 10));
                    });
                }
                else !function() {
                    for(var i = t.globals.gridWidth / (t.globals.labels.length + 1), s = 0; s < a.length; s++){
                        var r = a[s].childNodes;
                        t.config.xaxis.labels.trim && "datetime" !== t.config.xaxis.type && Array.prototype.forEach.call(r, function(t) {
                            e.placeTextWithEllipsis(t, t.textContent, i);
                        });
                    }
                }();
                if (s.length > 0) {
                    var h = s[s.length - 1].getBBox(), c = s[0].getBBox();
                    h.x < -20 && s[s.length - 1].parentNode.removeChild(s[s.length - 1]), c.x + c.width > t.globals.gridWidth && !t.globals.isBarHorizontal && s[0].parentNode.removeChild(s[0]);
                    for(var d = 0; d < r.length; d++)e.placeTextWithEllipsis(r[d], r[d].textContent, t.config.yaxis[0].labels.maxWidth - 2 * parseFloat(t.config.yaxis[0].title.style.fontSize) - 20);
                }
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$_ = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.ctx = e, this.w = e.w;
        var i = this.w;
        this.xaxisLabels = i.globals.labels.slice(), this.axesUtils = new $b705b473d3ec9641$var$B(e), this.isRangeBar = i.globals.seriesRangeBar.length, i.globals.timescaleLabels.length > 0 && (this.xaxisLabels = i.globals.timescaleLabels.slice());
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "drawGridArea",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, e = this.w, i = new $b705b473d3ec9641$var$b(this.ctx);
                null === t && (t = i.group({
                    class: "apexcharts-grid"
                }));
                var a = i.drawLine(e.globals.padHorizontal, 1, e.globals.padHorizontal, e.globals.gridHeight, "transparent"), s = i.drawLine(e.globals.padHorizontal, e.globals.gridHeight, e.globals.gridWidth, e.globals.gridHeight, "transparent");
                return t.add(s), t.add(a), t;
            }
        },
        {
            key: "drawGrid",
            value: function() {
                var t = null;
                return this.w.globals.axisCharts && (t = this.renderGrid(), this.drawGridArea(t.el)), t;
            }
        },
        {
            key: "createGridMask",
            value: function() {
                var t = this.w, e = t.globals, i = new $b705b473d3ec9641$var$b(this.ctx), a = Array.isArray(t.config.stroke.width) ? 0 : t.config.stroke.width;
                if (Array.isArray(t.config.stroke.width)) {
                    var s = 0;
                    t.config.stroke.width.forEach(function(t) {
                        s = Math.max(s, t);
                    }), a = s;
                }
                e.dom.elGridRectMask = document.createElementNS(e.SVGNS, "clipPath"), e.dom.elGridRectMask.setAttribute("id", "gridRectMask".concat(e.cuid)), e.dom.elGridRectMarkerMask = document.createElementNS(e.SVGNS, "clipPath"), e.dom.elGridRectMarkerMask.setAttribute("id", "gridRectMarkerMask".concat(e.cuid)), e.dom.elForecastMask = document.createElementNS(e.SVGNS, "clipPath"), e.dom.elForecastMask.setAttribute("id", "forecastMask".concat(e.cuid)), e.dom.elNonForecastMask = document.createElementNS(e.SVGNS, "clipPath"), e.dom.elNonForecastMask.setAttribute("id", "nonForecastMask".concat(e.cuid));
                var r = t.config.chart.type, o = 0, n = 0;
                ("bar" === r || "rangeBar" === r || "candlestick" === r || "boxPlot" === r || t.globals.comboBarCount > 0) && t.globals.isXNumeric && !t.globals.isBarHorizontal && (o = t.config.grid.padding.left, n = t.config.grid.padding.right, e.barPadForNumericAxis > o && (o = e.barPadForNumericAxis, n = e.barPadForNumericAxis)), e.dom.elGridRect = i.drawRect(-a / 2 - o - 2, -a / 2, e.gridWidth + a + n + o + 4, e.gridHeight + a, 0, "#fff"), new $b705b473d3ec9641$var$y(this).getLargestMarkerSize();
                var l = t.globals.markers.largestSize + 1;
                e.dom.elGridRectMarker = i.drawRect(2 * -l, 2 * -l, e.gridWidth + 4 * l, e.gridHeight + 4 * l, 0, "#fff"), e.dom.elGridRectMask.appendChild(e.dom.elGridRect.node), e.dom.elGridRectMarkerMask.appendChild(e.dom.elGridRectMarker.node);
                var h = e.dom.baseEl.querySelector("defs");
                h.appendChild(e.dom.elGridRectMask), h.appendChild(e.dom.elForecastMask), h.appendChild(e.dom.elNonForecastMask), h.appendChild(e.dom.elGridRectMarkerMask);
            }
        },
        {
            key: "_drawGridLines",
            value: function(t) {
                var e = t.i, i = t.x1, a = t.y1, s = t.x2, r = t.y2, o = t.xCount, n = t.parent, l = this.w;
                0 === e && l.globals.skipFirstTimelinelabel || e === o - 1 && l.globals.skipLastTimelinelabel && !l.config.xaxis.labels.formatter || "radar" === l.config.chart.type || (l.config.grid.xaxis.lines.show && this._drawGridLine({
                    x1: i,
                    y1: a,
                    x2: s,
                    y2: r,
                    parent: n
                }), new $b705b473d3ec9641$var$G(this.ctx).drawXaxisTicks(i, this.elg));
            }
        },
        {
            key: "_drawGridLine",
            value: function(t) {
                var e = t.x1, i = t.y1, a = t.x2, s = t.y2, r = t.parent, o = this.w, n = r.node.classList.contains("apexcharts-gridlines-horizontal"), l = o.config.grid.strokeDashArray, h = o.globals.barPadForNumericAxis, c = new $b705b473d3ec9641$var$b(this).drawLine(e - (n ? h : 0), i, a + (n ? h : 0), s, o.config.grid.borderColor, l);
                c.node.classList.add("apexcharts-gridline"), r.add(c);
            }
        },
        {
            key: "_drawGridBandRect",
            value: function(t) {
                var e = t.c, i = t.x1, a = t.y1, s = t.x2, r = t.y2, o = t.type, n = this.w, l = new $b705b473d3ec9641$var$b(this.ctx), h = n.globals.barPadForNumericAxis;
                if ("column" !== o || "datetime" !== n.config.xaxis.type) {
                    var c = n.config.grid[o].colors[e], d = l.drawRect(i - ("row" === o ? h : 0), a, s + ("row" === o ? 2 * h : 0), r, 0, c, n.config.grid[o].opacity);
                    this.elg.add(d), d.attr("clip-path", "url(#gridRectMask".concat(n.globals.cuid, ")")), d.node.classList.add("apexcharts-grid-".concat(o));
                }
            }
        },
        {
            key: "_drawXYLines",
            value: function(t) {
                var e = this, i = t.xCount, a = t.tickAmount, s = this.w;
                if (s.config.grid.xaxis.lines.show || s.config.xaxis.axisTicks.show) {
                    var r, o = s.globals.padHorizontal, n = s.globals.gridHeight;
                    s.globals.timescaleLabels.length ? function(t) {
                        for(var a = t.xC, s = t.x1, r = t.y1, o = t.x2, n = t.y2, l = 0; l < a; l++)s = e.xaxisLabels[l].position, o = e.xaxisLabels[l].position, e._drawGridLines({
                            i: l,
                            x1: s,
                            y1: r,
                            x2: o,
                            y2: n,
                            xCount: i,
                            parent: e.elgridLinesV
                        });
                    }({
                        xC: i,
                        x1: o,
                        y1: 0,
                        x2: r,
                        y2: n
                    }) : (s.globals.isXNumeric && (i = s.globals.xAxisScale.result.length), s.config.xaxis.convertedCatToNumeric && (i = s.globals.xaxisLabelsCount), function(t) {
                        var a = t.xC, r = t.x1, o = t.y1, n = t.x2, l = t.y2;
                        if (void 0 !== s.config.xaxis.tickAmount && "dataPoints" !== s.config.xaxis.tickAmount) s.globals.dom.baseEl.querySelectorAll(".apexcharts-text.apexcharts-xaxis-label tspan:not(:empty)").forEach(function(t, a) {
                            var s = t.getBBox();
                            e._drawGridLines({
                                i: a,
                                x1: s.x + s.width / 2,
                                y1: o,
                                x2: s.x + s.width / 2,
                                y2: l,
                                xCount: i,
                                parent: e.elgridLinesV
                            });
                        });
                        else for(var h = 0; h < a + (s.globals.isXNumeric ? 0 : 1); h++)0 === h && 1 === a && 1 === s.globals.dataPoints && (n = r = s.globals.gridWidth / 2), e._drawGridLines({
                            i: h,
                            x1: r,
                            y1: o,
                            x2: n,
                            y2: l,
                            xCount: i,
                            parent: e.elgridLinesV
                        }), n = r += s.globals.gridWidth / (s.globals.isXNumeric ? a - 1 : a);
                    }({
                        xC: i,
                        x1: o,
                        y1: 0,
                        x2: r,
                        y2: n
                    }));
                }
                if (s.config.grid.yaxis.lines.show) {
                    var l = 0, h = 0, c = s.globals.gridWidth, d = a + 1;
                    this.isRangeBar && (d = s.globals.labels.length);
                    for(var g = 0; g < d + (this.isRangeBar ? 1 : 0); g++)this._drawGridLine({
                        x1: 0,
                        y1: l,
                        x2: c,
                        y2: h,
                        parent: this.elgridLinesH
                    }), h = l += s.globals.gridHeight / (this.isRangeBar ? d : a);
                }
            }
        },
        {
            key: "_drawInvertedXYLines",
            value: function(t) {
                var e = t.xCount, i = this.w;
                if (i.config.grid.xaxis.lines.show || i.config.xaxis.axisTicks.show) for(var a, s = i.globals.padHorizontal, r = i.globals.gridHeight, o = 0; o < e + 1; o++)i.config.grid.xaxis.lines.show && this._drawGridLine({
                    x1: s,
                    y1: 0,
                    x2: a,
                    y2: r,
                    parent: this.elgridLinesV
                }), new $b705b473d3ec9641$var$G(this.ctx).drawXaxisTicks(s, this.elg), a = s = s + i.globals.gridWidth / e + .3;
                if (i.config.grid.yaxis.lines.show) for(var n = 0, l = 0, h = i.globals.gridWidth, c = 0; c < i.globals.dataPoints + 1; c++)this._drawGridLine({
                    x1: 0,
                    y1: n,
                    x2: h,
                    y2: l,
                    parent: this.elgridLinesH
                }), l = n += i.globals.gridHeight / i.globals.dataPoints;
            }
        },
        {
            key: "renderGrid",
            value: function() {
                var t = this.w, e = new $b705b473d3ec9641$var$b(this.ctx);
                this.elg = e.group({
                    class: "apexcharts-grid"
                }), this.elgridLinesH = e.group({
                    class: "apexcharts-gridlines-horizontal"
                }), this.elgridLinesV = e.group({
                    class: "apexcharts-gridlines-vertical"
                }), this.elg.add(this.elgridLinesH), this.elg.add(this.elgridLinesV), t.config.grid.show || (this.elgridLinesV.hide(), this.elgridLinesH.hide());
                for(var i, a = t.globals.yAxisScale.length ? t.globals.yAxisScale[0].result.length - 1 : 5, s = 0; s < t.globals.series.length && (void 0 !== t.globals.yAxisScale[s] && (a = t.globals.yAxisScale[s].result.length - 1), !(a > 2)); s++);
                return !t.globals.isBarHorizontal || this.isRangeBar ? (i = this.xaxisLabels.length, this.isRangeBar && (a = t.globals.labels.length, t.config.xaxis.tickAmount && t.config.xaxis.labels.formatter && (i = t.config.xaxis.tickAmount)), this._drawXYLines({
                    xCount: i,
                    tickAmount: a
                })) : (i = a, a = t.globals.xTickAmount, this._drawInvertedXYLines({
                    xCount: i,
                    tickAmount: a
                })), this.drawGridBands(i, a), {
                    el: this.elg,
                    xAxisTickWidth: t.globals.gridWidth / i
                };
            }
        },
        {
            key: "drawGridBands",
            value: function(t, e) {
                var i = this.w;
                if (void 0 !== i.config.grid.row.colors && i.config.grid.row.colors.length > 0) for(var a = 0, s = i.globals.gridHeight / e, r = i.globals.gridWidth, o = 0, n = 0; o < e; o++, n++)n >= i.config.grid.row.colors.length && (n = 0), this._drawGridBandRect({
                    c: n,
                    x1: 0,
                    y1: a,
                    x2: r,
                    y2: s,
                    type: "row"
                }), a += i.globals.gridHeight / e;
                if (void 0 !== i.config.grid.column.colors && i.config.grid.column.colors.length > 0) for(var l = i.globals.isBarHorizontal || "category" !== i.config.xaxis.type && !i.config.xaxis.convertedCatToNumeric ? t : t - 1, h = i.globals.padHorizontal, c = i.globals.padHorizontal + i.globals.gridWidth / l, d = i.globals.gridHeight, g = 0, u = 0; g < t; g++, u++)u >= i.config.grid.column.colors.length && (u = 0), this._drawGridBandRect({
                    c: u,
                    x1: h,
                    y1: 0,
                    x2: c,
                    y2: d,
                    type: "column"
                }), h += i.globals.gridWidth / l;
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$j = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "niceScale",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 10, a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : 0, s = arguments.length > 4 ? arguments[4] : void 0, r = this.w, o = Math.abs(e - t);
                if ("dataPoints" === (i = this._adjustTicksForSmallRange(i, a, o)) && (i = r.globals.dataPoints - 1), t === Number.MIN_VALUE && 0 === e || !$b705b473d3ec9641$var$p.isNumber(t) && !$b705b473d3ec9641$var$p.isNumber(e) || t === Number.MIN_VALUE && e === -Number.MAX_VALUE) {
                    t = 0, e = i;
                    var n = this.linearScale(t, e, i);
                    return n;
                }
                t > e ? (console.warn("axis.min cannot be greater than axis.max"), e = t + .1) : t === e && (t = 0 === t ? 0 : t - .5, e = 0 === e ? 2 : e + .5);
                var l = [];
                o < 1 && s && ("candlestick" === r.config.chart.type || "candlestick" === r.config.series[a].type || "boxPlot" === r.config.chart.type || "boxPlot" === r.config.series[a].type || r.globals.isRangeData) && (e *= 1.01);
                var h = i + 1;
                h < 2 ? h = 2 : h > 2 && (h -= 2);
                var c = o / h, d = Math.floor($b705b473d3ec9641$var$p.log10(c)), g = Math.pow(10, d), u = Math.round(c / g);
                u < 1 && (u = 1);
                var f = u * g, x = f * Math.floor(t / f), b = f * Math.ceil(e / f), v = x;
                if (s && o > 2) {
                    for(; l.push(v), !((v += f) > b););
                    return {
                        result: l,
                        niceMin: l[0],
                        niceMax: l[l.length - 1]
                    };
                }
                var m = t;
                (l = []).push(m);
                for(var y = Math.abs(e - t) / i, w = 0; w <= i; w++)m += y, l.push(m);
                return l[l.length - 2] >= e && l.pop(), {
                    result: l,
                    niceMin: l[0],
                    niceMax: l[l.length - 1]
                };
            }
        },
        {
            key: "linearScale",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 10, a = arguments.length > 3 ? arguments[3] : void 0, s = Math.abs(e - t);
                "dataPoints" === (i = this._adjustTicksForSmallRange(i, a, s)) && (i = this.w.globals.dataPoints - 1);
                var r = s / i;
                i === Number.MAX_VALUE && (i = 10, r = 1);
                for(var o = [], n = t; i >= 0;)o.push(n), n += r, i -= 1;
                return {
                    result: o,
                    niceMin: o[0],
                    niceMax: o[o.length - 1]
                };
            }
        },
        {
            key: "logarithmicScale",
            value: function(t, e, i) {
                for(var a = [], s = Math.ceil(Math.log(e) / Math.log(i)) + 1, r = 0; r < s; r++)a.push(Math.pow(i, r));
                return 0 === t && a.unshift(t), {
                    result: a,
                    niceMin: a[0],
                    niceMax: a[a.length - 1]
                };
            }
        },
        {
            key: "_adjustTicksForSmallRange",
            value: function(t, e, i) {
                var a = t;
                if (void 0 !== e && this.w.config.yaxis[e].labels.formatter && void 0 === this.w.config.yaxis[e].tickAmount) {
                    var s = this.w.config.yaxis[e].labels.formatter(1);
                    $b705b473d3ec9641$var$p.isNumber(Number(s)) && !$b705b473d3ec9641$var$p.isFloat(s) && (a = Math.ceil(i));
                }
                return a < t ? a : t;
            }
        },
        {
            key: "setYScaleForIndex",
            value: function(t, e, i) {
                var a = this.w.globals, s = this.w.config, r = a.isBarHorizontal ? s.xaxis : s.yaxis[t];
                void 0 === a.yAxisScale[t] && (a.yAxisScale[t] = []);
                var o = Math.abs(i - e);
                if (r.logarithmic && o <= 5 && (a.invalidLogScale = !0), r.logarithmic && o > 5) a.allSeriesCollapsed = !1, a.yAxisScale[t] = this.logarithmicScale(e, i, r.logBase);
                else if (i !== -Number.MAX_VALUE && $b705b473d3ec9641$var$p.isNumber(i)) {
                    if (a.allSeriesCollapsed = !1, void 0 === r.min && void 0 === r.max || r.forceNiceScale) {
                        var n = void 0 === s.yaxis[t].max && void 0 === s.yaxis[t].min || s.yaxis[t].forceNiceScale;
                        a.yAxisScale[t] = this.niceScale(e, i, r.tickAmount ? r.tickAmount : o < 5 && o > 1 ? o + 1 : 5, t, n);
                    } else a.yAxisScale[t] = this.linearScale(e, i, r.tickAmount, t);
                } else a.yAxisScale[t] = this.linearScale(0, 5, 5);
            }
        },
        {
            key: "setXScale",
            value: function(t, e) {
                var i = this.w, a = i.globals, s = i.config.xaxis, r = Math.abs(e - t);
                return e !== -Number.MAX_VALUE && $b705b473d3ec9641$var$p.isNumber(e) ? a.xAxisScale = this.linearScale(t, e, s.tickAmount ? s.tickAmount : r < 5 && r > 1 ? r + 1 : 5, 0) : a.xAxisScale = this.linearScale(0, 5, 5), a.xAxisScale;
            }
        },
        {
            key: "setMultipleYScales",
            value: function() {
                var t = this, e = this.w.globals, i = this.w.config, a = e.minYArr.concat([]), s = e.maxYArr.concat([]), r = [];
                i.yaxis.forEach(function(e, o) {
                    var n = o;
                    i.series.forEach(function(t, i) {
                        t.name === e.seriesName && (n = i, o !== i ? r.push({
                            index: i,
                            similarIndex: o,
                            alreadyExists: !0
                        }) : r.push({
                            index: i
                        }));
                    });
                    var l = a[n], h = s[n];
                    t.setYScaleForIndex(o, l, h);
                }), this.sameScaleInMultipleAxes(a, s, r);
            }
        },
        {
            key: "sameScaleInMultipleAxes",
            value: function(t, e, i) {
                var a = this, s = this.w.config, r = this.w.globals, o = [];
                i.forEach(function(t) {
                    t.alreadyExists && (void 0 === o[t.index] && (o[t.index] = []), o[t.index].push(t.index), o[t.index].push(t.similarIndex));
                }), r.yAxisSameScaleIndices = o, o.forEach(function(t, e) {
                    o.forEach(function(i, a) {
                        var s, r;
                        e !== a && (s = t, r = i, s.filter(function(t) {
                            return -1 !== r.indexOf(t);
                        })).length > 0 && (o[e] = o[e].concat(o[a]));
                    });
                });
                var n = o.map(function(t) {
                    return t.filter(function(e, i) {
                        return t.indexOf(e) === i;
                    });
                }).map(function(t) {
                    return t.sort();
                });
                o = o.filter(function(t) {
                    return !!t;
                });
                var l = n.slice(), h = l.map(function(t) {
                    return JSON.stringify(t);
                });
                l = l.filter(function(t, e) {
                    return h.indexOf(JSON.stringify(t)) === e;
                });
                var c = [], d = [];
                t.forEach(function(t, i) {
                    l.forEach(function(a, s) {
                        a.indexOf(i) > -1 && (void 0 === c[s] && (c[s] = [], d[s] = []), c[s].push({
                            key: i,
                            value: t
                        }), d[s].push({
                            key: i,
                            value: e[i]
                        }));
                    });
                });
                var g = Array.apply(null, Array(l.length)).map(Number.prototype.valueOf, Number.MIN_VALUE), u = Array.apply(null, Array(l.length)).map(Number.prototype.valueOf, -Number.MAX_VALUE);
                c.forEach(function(t, e) {
                    t.forEach(function(t, i) {
                        g[e] = Math.min(t.value, g[e]);
                    });
                }), d.forEach(function(t, e) {
                    t.forEach(function(t, i) {
                        u[e] = Math.max(t.value, u[e]);
                    });
                }), t.forEach(function(t, e) {
                    d.forEach(function(t, i) {
                        var o = g[i], n = u[i];
                        s.chart.stacked && (n = 0, t.forEach(function(t, e) {
                            t.value !== -Number.MAX_VALUE && (n += t.value), o !== Number.MIN_VALUE && (o += c[i][e].value);
                        })), t.forEach(function(i, l) {
                            t[l].key === e && (void 0 !== s.yaxis[e].min && (o = "function" == typeof s.yaxis[e].min ? s.yaxis[e].min(r.minY) : s.yaxis[e].min), void 0 !== s.yaxis[e].max && (n = "function" == typeof s.yaxis[e].max ? s.yaxis[e].max(r.maxY) : s.yaxis[e].max), a.setYScaleForIndex(e, o, n));
                        });
                    });
                });
            }
        },
        {
            key: "autoScaleY",
            value: function(t, e, i) {
                t || (t = this);
                var a = t.w;
                if (a.globals.isMultipleYAxis || a.globals.collapsedSeries.length) return console.warn("autoScaleYaxis is not supported in a multi-yaxis chart."), e;
                var s = a.globals.seriesX[0], r = a.config.chart.stacked;
                return e.forEach(function(t, o) {
                    for(var n = 0, l = 0; l < s.length; l++)if (s[l] >= i.xaxis.min) {
                        n = l;
                        break;
                    }
                    var h, c, d = a.globals.minYArr[o], g = a.globals.maxYArr[o], u = a.globals.stackedSeriesTotals;
                    a.globals.series.forEach(function(o, l) {
                        var p = o[n];
                        r ? (p = u[n], h = c = p, u.forEach(function(t, e) {
                            s[e] <= i.xaxis.max && s[e] >= i.xaxis.min && (t > c && null !== t && (c = t), o[e] < h && null !== o[e] && (h = o[e]));
                        })) : (h = c = p, o.forEach(function(t, e) {
                            if (s[e] <= i.xaxis.max && s[e] >= i.xaxis.min) {
                                var r = t, o = t;
                                a.globals.series.forEach(function(i, a) {
                                    null !== t && (r = Math.min(i[e], r), o = Math.max(i[e], o));
                                }), o > c && null !== o && (c = o), r < h && null !== r && (h = r);
                            }
                        })), void 0 === h && void 0 === c && (h = d, c = g), (c *= c < 0 ? .9 : 1.1) < 0 && c < g && (c = g), (h *= h < 0 ? 1.1 : .9) < 0 && h > d && (h = d), e.length > 1 ? (e[l].min = void 0 === t.min ? h : t.min, e[l].max = void 0 === t.max ? c : t.max) : (e[0].min = void 0 === t.min ? h : t.min, e[0].max = void 0 === t.max ? c : t.max);
                    });
                }), e;
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$U = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.ctx = e, this.w = e.w, this.scales = new $b705b473d3ec9641$var$j(e);
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "init",
            value: function() {
                this.setYRange(), this.setXRange(), this.setZRange();
            }
        },
        {
            key: "getMinYMaxY",
            value: function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : Number.MAX_VALUE, i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : -Number.MAX_VALUE, a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null, s = this.w.config, r = this.w.globals, o = -Number.MAX_VALUE, n = Number.MIN_VALUE;
                null === a && (a = t + 1);
                var l = r.series, h = l, c = l;
                "candlestick" === s.chart.type ? (h = r.seriesCandleL, c = r.seriesCandleH) : "boxPlot" === s.chart.type ? (h = r.seriesCandleO, c = r.seriesCandleC) : r.isRangeData && (h = r.seriesRangeStart, c = r.seriesRangeEnd);
                for(var d = t; d < a; d++){
                    r.dataPoints = Math.max(r.dataPoints, l[d].length), r.categoryLabels.length && (r.dataPoints = r.categoryLabels.filter(function(t) {
                        return void 0 !== t;
                    }).length);
                    for(var g = 0; g < r.series[d].length; g++){
                        var u = l[d][g];
                        null !== u && $b705b473d3ec9641$var$p.isNumber(u) ? (void 0 !== c[d][g] && (o = Math.max(o, c[d][g]), e = Math.min(e, c[d][g])), void 0 !== h[d][g] && (e = Math.min(e, h[d][g]), i = Math.max(i, h[d][g])), "candlestick" !== this.w.config.chart.type && "boxPlot" !== this.w.config.chart.type || (void 0 !== r.seriesCandleC[d][g] && (o = Math.max(o, r.seriesCandleO[d][g]), o = Math.max(o, r.seriesCandleH[d][g]), o = Math.max(o, r.seriesCandleL[d][g]), o = Math.max(o, r.seriesCandleC[d][g]), "boxPlot" === this.w.config.chart.type && (o = Math.max(o, r.seriesCandleM[d][g]))), !s.series[d].type || "candlestick" === s.series[d].type && "boxPlot" === s.series[d].type || (o = Math.max(o, r.series[d][g]), e = Math.min(e, r.series[d][g])), i = o), r.seriesGoals[d] && r.seriesGoals[d][g] && Array.isArray(r.seriesGoals[d][g]) && r.seriesGoals[d][g].forEach(function(t) {
                            n !== Number.MIN_VALUE && (n = Math.min(n, t.value), e = n), o = Math.max(o, t.value), i = o;
                        }), $b705b473d3ec9641$var$p.isFloat(u) && (u = $b705b473d3ec9641$var$p.noExponents(u), r.yValueDecimal = Math.max(r.yValueDecimal, u.toString().split(".")[1].length)), n > h[d][g] && h[d][g] < 0 && (n = h[d][g])) : r.hasNullValues = !0;
                    }
                }
                return "rangeBar" === s.chart.type && r.seriesRangeStart.length && r.isBarHorizontal && (n = e), "bar" === s.chart.type && (n < 0 && o < 0 && (o = 0), n === Number.MIN_VALUE && (n = 0)), {
                    minY: n,
                    maxY: o,
                    lowestY: e,
                    highestY: i
                };
            }
        },
        {
            key: "setYRange",
            value: function() {
                var t = this.w.globals, e = this.w.config;
                t.maxY = -Number.MAX_VALUE, t.minY = Number.MIN_VALUE;
                var i = Number.MAX_VALUE;
                if (t.isMultipleYAxis) for(var a = 0; a < t.series.length; a++){
                    var s = this.getMinYMaxY(a, i, null, a + 1);
                    t.minYArr.push(s.minY), t.maxYArr.push(s.maxY), i = s.lowestY;
                }
                var r = this.getMinYMaxY(0, i, null, t.series.length);
                if (t.minY = r.minY, t.maxY = r.maxY, i = r.lowestY, e.chart.stacked && this._setStackedMinMax(), ("line" === e.chart.type || "area" === e.chart.type || "candlestick" === e.chart.type || "boxPlot" === e.chart.type || "rangeBar" === e.chart.type && !t.isBarHorizontal) && t.minY === Number.MIN_VALUE && i !== -Number.MAX_VALUE && i !== t.maxY) {
                    var o = t.maxY - i;
                    (i >= 0 && i <= 10 || void 0 !== e.yaxis[0].min || void 0 !== e.yaxis[0].max) && (o = 0), t.minY = i - 5 * o / 100, i > 0 && t.minY < 0 && (t.minY = 0), t.maxY = t.maxY + 5 * o / 100;
                }
                if (e.yaxis.forEach(function(e, i) {
                    void 0 !== e.max && ("number" == typeof e.max ? t.maxYArr[i] = e.max : "function" == typeof e.max && (t.maxYArr[i] = e.max(t.isMultipleYAxis ? t.maxYArr[i] : t.maxY)), t.maxY = t.maxYArr[i]), void 0 !== e.min && ("number" == typeof e.min ? t.minYArr[i] = e.min : "function" == typeof e.min && (t.minYArr[i] = e.min(t.isMultipleYAxis ? t.minYArr[i] === Number.MIN_VALUE ? 0 : t.minYArr[i] : t.minY)), t.minY = t.minYArr[i]);
                }), t.isBarHorizontal) [
                    "min",
                    "max"
                ].forEach(function(i) {
                    void 0 !== e.xaxis[i] && "number" == typeof e.xaxis[i] && ("min" === i ? t.minY = e.xaxis[i] : t.maxY = e.xaxis[i]);
                });
                return t.isMultipleYAxis ? (this.scales.setMultipleYScales(), t.minY = i, t.yAxisScale.forEach(function(e, i) {
                    t.minYArr[i] = e.niceMin, t.maxYArr[i] = e.niceMax;
                })) : (this.scales.setYScaleForIndex(0, t.minY, t.maxY), t.minY = t.yAxisScale[0].niceMin, t.maxY = t.yAxisScale[0].niceMax, t.minYArr[0] = t.yAxisScale[0].niceMin, t.maxYArr[0] = t.yAxisScale[0].niceMax), {
                    minY: t.minY,
                    maxY: t.maxY,
                    minYArr: t.minYArr,
                    maxYArr: t.maxYArr,
                    yAxisScale: t.yAxisScale
                };
            }
        },
        {
            key: "setXRange",
            value: function() {
                var t = this.w.globals, e = this.w.config, i = "numeric" === e.xaxis.type || "datetime" === e.xaxis.type || "category" === e.xaxis.type && !t.noLabelsProvided || t.noLabelsProvided || t.isXNumeric;
                if (t.isXNumeric && function() {
                    for(var e = 0; e < t.series.length; e++)if (t.labels[e]) for(var i = 0; i < t.labels[e].length; i++)null !== t.labels[e][i] && $b705b473d3ec9641$var$p.isNumber(t.labels[e][i]) && (t.maxX = Math.max(t.maxX, t.labels[e][i]), t.initialMaxX = Math.max(t.maxX, t.labels[e][i]), t.minX = Math.min(t.minX, t.labels[e][i]), t.initialMinX = Math.min(t.minX, t.labels[e][i]));
                }(), t.noLabelsProvided && 0 === e.xaxis.categories.length && (t.maxX = t.labels[t.labels.length - 1], t.initialMaxX = t.labels[t.labels.length - 1], t.minX = 1, t.initialMinX = 1), t.isXNumeric || t.noLabelsProvided || t.dataFormatXNumeric) {
                    var a;
                    if (void 0 === e.xaxis.tickAmount ? (a = Math.round(t.svgWidth / 150), "numeric" === e.xaxis.type && t.dataPoints < 30 && (a = t.dataPoints - 1), a > t.dataPoints && 0 !== t.dataPoints && (a = t.dataPoints - 1)) : "dataPoints" === e.xaxis.tickAmount ? (t.series.length > 1 && (a = t.series[t.maxValsInArrayIndex].length - 1), t.isXNumeric && (a = t.maxX - t.minX - 1)) : a = e.xaxis.tickAmount, t.xTickAmount = a, void 0 !== e.xaxis.max && "number" == typeof e.xaxis.max && (t.maxX = e.xaxis.max), void 0 !== e.xaxis.min && "number" == typeof e.xaxis.min && (t.minX = e.xaxis.min), void 0 !== e.xaxis.range && (t.minX = t.maxX - e.xaxis.range), t.minX !== Number.MAX_VALUE && t.maxX !== -Number.MAX_VALUE) {
                        if (e.xaxis.convertedCatToNumeric && !t.dataFormatXNumeric) {
                            for(var s = [], r = t.minX - 1; r < t.maxX; r++)s.push(r + 1);
                            t.xAxisScale = {
                                result: s,
                                niceMin: s[0],
                                niceMax: s[s.length - 1]
                            };
                        } else t.xAxisScale = this.scales.setXScale(t.minX, t.maxX);
                    } else t.xAxisScale = this.scales.linearScale(1, a, a), t.noLabelsProvided && t.labels.length > 0 && (t.xAxisScale = this.scales.linearScale(1, t.labels.length, a - 1), t.seriesX = t.labels.slice());
                    i && (t.labels = t.xAxisScale.result.slice());
                }
                return t.isBarHorizontal && t.labels.length && (t.xTickAmount = t.labels.length), this._handleSingleDataPoint(), this._getMinXDiff(), {
                    minX: t.minX,
                    maxX: t.maxX
                };
            }
        },
        {
            key: "setZRange",
            value: function() {
                var t = this.w.globals;
                if (t.isDataXYZ) {
                    for(var e = 0; e < t.series.length; e++)if (void 0 !== t.seriesZ[e]) for(var i = 0; i < t.seriesZ[e].length; i++)null !== t.seriesZ[e][i] && $b705b473d3ec9641$var$p.isNumber(t.seriesZ[e][i]) && (t.maxZ = Math.max(t.maxZ, t.seriesZ[e][i]), t.minZ = Math.min(t.minZ, t.seriesZ[e][i]));
                }
            }
        },
        {
            key: "_handleSingleDataPoint",
            value: function() {
                var t = this.w.globals, e = this.w.config;
                if (t.minX === t.maxX) {
                    var i = new $b705b473d3ec9641$var$Y(this.ctx);
                    if ("datetime" === e.xaxis.type) {
                        var a = i.getDate(t.minX);
                        e.xaxis.labels.datetimeUTC ? a.setUTCDate(a.getUTCDate() - 2) : a.setDate(a.getDate() - 2), t.minX = new Date(a).getTime();
                        var s = i.getDate(t.maxX);
                        e.xaxis.labels.datetimeUTC ? s.setUTCDate(s.getUTCDate() + 2) : s.setDate(s.getDate() + 2), t.maxX = new Date(s).getTime();
                    } else ("numeric" === e.xaxis.type || "category" === e.xaxis.type && !t.noLabelsProvided) && (t.minX = t.minX - 2, t.initialMinX = t.minX, t.maxX = t.maxX + 2, t.initialMaxX = t.maxX);
                }
            }
        },
        {
            key: "_getMinXDiff",
            value: function() {
                var t = this.w.globals;
                t.isXNumeric && t.seriesX.forEach(function(e, i) {
                    1 === e.length && e.push(t.seriesX[t.maxValsInArrayIndex][t.seriesX[t.maxValsInArrayIndex].length - 1]);
                    var a = e.slice();
                    a.sort(function(t, e) {
                        return t - e;
                    }), a.forEach(function(e, i) {
                        if (i > 0) {
                            var s = e - a[i - 1];
                            s > 0 && (t.minXDiff = Math.min(s, t.minXDiff));
                        }
                    }), 1 !== t.dataPoints && t.minXDiff !== Number.MAX_VALUE || (t.minXDiff = .5);
                });
            }
        },
        {
            key: "_setStackedMinMax",
            value: function() {
                var t = this.w.globals, e = [], i = [];
                if (t.series.length) for(var a = 0; a < t.series[t.maxValsInArrayIndex].length; a++)for(var s = 0, r = 0, o = 0; o < t.series.length; o++)null !== t.series[o][a] && $b705b473d3ec9641$var$p.isNumber(t.series[o][a]) && (t.series[o][a] > 0 ? s = s + parseFloat(t.series[o][a]) + 1e-4 : r += parseFloat(t.series[o][a])), o === t.series.length - 1 && (e.push(s), i.push(r));
                for(var n = 0; n < e.length; n++)t.maxY = Math.max(t.maxY, e[n]), t.minY = Math.min(t.minY, i[n]);
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$q = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.ctx = e, this.w = e.w;
        var i = this.w;
        this.xaxisFontSize = i.config.xaxis.labels.style.fontSize, this.axisFontFamily = i.config.xaxis.labels.style.fontFamily, this.xaxisForeColors = i.config.xaxis.labels.style.colors, this.isCategoryBarHorizontal = "bar" === i.config.chart.type && i.config.plotOptions.bar.horizontal, this.xAxisoffX = 0, "bottom" === i.config.xaxis.position && (this.xAxisoffX = i.globals.gridHeight), this.drawnLabels = [], this.axesUtils = new $b705b473d3ec9641$var$B(e);
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "drawYaxis",
            value: function(t) {
                var e = this, i = this.w, a = new $b705b473d3ec9641$var$b(this.ctx), s = i.config.yaxis[t].labels.style, r = s.fontSize, o = s.fontFamily, n = s.fontWeight, l = a.group({
                    class: "apexcharts-yaxis",
                    rel: t,
                    transform: "translate(" + i.globals.translateYAxisX[t] + ", 0)"
                });
                if (this.axesUtils.isYAxisHidden(t)) return l;
                var h = a.group({
                    class: "apexcharts-yaxis-texts-g"
                });
                l.add(h);
                var c = i.globals.yAxisScale[t].result.length - 1, d = i.globals.gridHeight / c, g = i.globals.translateY, u = i.globals.yLabelFormatters[t], p = i.globals.yAxisScale[t].result.slice();
                p = this.axesUtils.checkForReversedLabels(t, p);
                var f = "";
                if (i.config.yaxis[t].labels.show) for(var x = function(l) {
                    var x = p[l];
                    x = u(x, l, i);
                    var b = i.config.yaxis[t].labels.padding;
                    i.config.yaxis[t].opposite && 0 !== i.config.yaxis.length && (b *= -1);
                    var v = e.axesUtils.getYAxisForeColor(s.colors, t), m = a.drawText({
                        x: b,
                        y: g + c / 10 + i.config.yaxis[t].labels.offsetY + 1,
                        text: x,
                        textAnchor: i.config.yaxis[t].opposite ? "start" : "end",
                        fontSize: r,
                        fontFamily: o,
                        fontWeight: n,
                        foreColor: Array.isArray(v) ? v[l] : v,
                        isPlainText: !1,
                        cssClass: "apexcharts-yaxis-label " + s.cssClass
                    });
                    l === c && (f = m), h.add(m);
                    var y = document.createElementNS(i.globals.SVGNS, "title");
                    if (y.textContent = Array.isArray(x) ? x.join(" ") : x, m.node.appendChild(y), 0 !== i.config.yaxis[t].labels.rotate) {
                        var w = a.rotateAroundCenter(f.node), k = a.rotateAroundCenter(m.node);
                        m.node.setAttribute("transform", "rotate(".concat(i.config.yaxis[t].labels.rotate, " ").concat(w.x, " ").concat(k.y, ")"));
                    }
                    g += d;
                }, v = c; v >= 0; v--)x(v);
                if (void 0 !== i.config.yaxis[t].title.text) {
                    var m = a.group({
                        class: "apexcharts-yaxis-title"
                    }), y = 0;
                    i.config.yaxis[t].opposite && (y = i.globals.translateYAxisX[t]);
                    var w = a.drawText({
                        x: y,
                        y: i.globals.gridHeight / 2 + i.globals.translateY + i.config.yaxis[t].title.offsetY,
                        text: i.config.yaxis[t].title.text,
                        textAnchor: "end",
                        foreColor: i.config.yaxis[t].title.style.color,
                        fontSize: i.config.yaxis[t].title.style.fontSize,
                        fontWeight: i.config.yaxis[t].title.style.fontWeight,
                        fontFamily: i.config.yaxis[t].title.style.fontFamily,
                        cssClass: "apexcharts-yaxis-title-text " + i.config.yaxis[t].title.style.cssClass
                    });
                    m.add(w), l.add(m);
                }
                var k = i.config.yaxis[t].axisBorder, A = 31 + k.offsetX;
                if (i.config.yaxis[t].opposite && (A = -31 - k.offsetX), k.show) {
                    var S = a.drawLine(A, i.globals.translateY + k.offsetY - 2, A, i.globals.gridHeight + i.globals.translateY + k.offsetY + 2, k.color, 0, k.width);
                    l.add(S);
                }
                return i.config.yaxis[t].axisTicks.show && this.axesUtils.drawYAxisTicks(A, c, k, i.config.yaxis[t].axisTicks, t, d, l), l;
            }
        },
        {
            key: "drawYaxisInversed",
            value: function(t) {
                var e = this.w, i = new $b705b473d3ec9641$var$b(this.ctx), a = i.group({
                    class: "apexcharts-xaxis apexcharts-yaxis-inversed"
                }), s = i.group({
                    class: "apexcharts-xaxis-texts-g",
                    transform: "translate(".concat(e.globals.translateXAxisX, ", ").concat(e.globals.translateXAxisY, ")")
                });
                a.add(s);
                var r = e.globals.yAxisScale[t].result.length - 1, o = e.globals.gridWidth / r + .1, n = o + e.config.xaxis.labels.offsetX, l = e.globals.xLabelFormatter, h = e.globals.yAxisScale[t].result.slice(), c = e.globals.timescaleLabels;
                c.length > 0 && (this.xaxisLabels = c.slice(), r = (h = c.slice()).length), h = this.axesUtils.checkForReversedLabels(t, h);
                var d = c.length;
                if (e.config.xaxis.labels.show) for(var g = d ? 0 : r; d ? g < d : g >= 0; d ? g++ : g--){
                    var u = h[g];
                    u = l(u, g, e);
                    var p = e.globals.gridWidth + e.globals.padHorizontal - (n - o + e.config.xaxis.labels.offsetX);
                    if (c.length) {
                        var f = this.axesUtils.getLabel(h, c, p, g, this.drawnLabels, this.xaxisFontSize);
                        p = f.x, u = f.text, this.drawnLabels.push(f.text), 0 === g && e.globals.skipFirstTimelinelabel && (u = ""), g === h.length - 1 && e.globals.skipLastTimelinelabel && (u = "");
                    }
                    var x = i.drawText({
                        x: p,
                        y: this.xAxisoffX + e.config.xaxis.labels.offsetY + 30 - ("top" === e.config.xaxis.position ? e.globals.xAxisHeight + e.config.xaxis.axisTicks.height - 2 : 0),
                        text: u,
                        textAnchor: "middle",
                        foreColor: Array.isArray(this.xaxisForeColors) ? this.xaxisForeColors[t] : this.xaxisForeColors,
                        fontSize: this.xaxisFontSize,
                        fontFamily: this.xaxisFontFamily,
                        fontWeight: e.config.xaxis.labels.style.fontWeight,
                        isPlainText: !1,
                        cssClass: "apexcharts-xaxis-label " + e.config.xaxis.labels.style.cssClass
                    });
                    s.add(x), x.tspan(u);
                    var v = document.createElementNS(e.globals.SVGNS, "title");
                    v.textContent = u, x.node.appendChild(v), n += o;
                }
                return this.inversedYAxisTitleText(a), this.inversedYAxisBorder(a), a;
            }
        },
        {
            key: "inversedYAxisBorder",
            value: function(t) {
                var e = this.w, i = new $b705b473d3ec9641$var$b(this.ctx), a = e.config.xaxis.axisBorder;
                if (a.show) {
                    var s = 0;
                    "bar" === e.config.chart.type && e.globals.isXNumeric && (s -= 15);
                    var r = i.drawLine(e.globals.padHorizontal + s + a.offsetX, this.xAxisoffX, e.globals.gridWidth, this.xAxisoffX, a.color, 0, a.height);
                    t.add(r);
                }
            }
        },
        {
            key: "inversedYAxisTitleText",
            value: function(t) {
                var e = this.w, i = new $b705b473d3ec9641$var$b(this.ctx);
                if (void 0 !== e.config.xaxis.title.text) {
                    var a = i.group({
                        class: "apexcharts-xaxis-title apexcharts-yaxis-title-inversed"
                    }), s = i.drawText({
                        x: e.globals.gridWidth / 2 + e.config.xaxis.title.offsetX,
                        y: this.xAxisoffX + parseFloat(this.xaxisFontSize) + parseFloat(e.config.xaxis.title.style.fontSize) + e.config.xaxis.title.offsetY + 20,
                        text: e.config.xaxis.title.text,
                        textAnchor: "middle",
                        fontSize: e.config.xaxis.title.style.fontSize,
                        fontFamily: e.config.xaxis.title.style.fontFamily,
                        fontWeight: e.config.xaxis.title.style.fontWeight,
                        foreColor: e.config.xaxis.title.style.color,
                        cssClass: "apexcharts-xaxis-title-text " + e.config.xaxis.title.style.cssClass
                    });
                    a.add(s), t.add(a);
                }
            }
        },
        {
            key: "yAxisTitleRotate",
            value: function(t, e) {
                var i = this.w, a = new $b705b473d3ec9641$var$b(this.ctx), s = {
                    width: 0,
                    height: 0
                }, r = {
                    width: 0,
                    height: 0
                }, o = i.globals.dom.baseEl.querySelector(" .apexcharts-yaxis[rel='".concat(t, "'] .apexcharts-yaxis-texts-g"));
                null !== o && (s = o.getBoundingClientRect());
                var n = i.globals.dom.baseEl.querySelector(".apexcharts-yaxis[rel='".concat(t, "'] .apexcharts-yaxis-title text"));
                if (null !== n && (r = n.getBoundingClientRect()), null !== n) {
                    var l = this.xPaddingForYAxisTitle(t, s, r, e);
                    n.setAttribute("x", l.xPos - (e ? 10 : 0));
                }
                if (null !== n) {
                    var h = a.rotateAroundCenter(n);
                    n.setAttribute("transform", "rotate(".concat(e ? -1 * i.config.yaxis[t].title.rotate : i.config.yaxis[t].title.rotate, " ").concat(h.x, " ").concat(h.y, ")"));
                }
            }
        },
        {
            key: "xPaddingForYAxisTitle",
            value: function(t, e, i, a) {
                var s = this.w, r = 0, o = 0, n = 10;
                return void 0 === s.config.yaxis[t].title.text || t < 0 ? {
                    xPos: o,
                    padd: 0
                } : (a ? (o = e.width + s.config.yaxis[t].title.offsetX + i.width / 2 + n / 2, 0 === (r += 1) && (o -= n / 2)) : (o = -1 * e.width + s.config.yaxis[t].title.offsetX + n / 2 + i.width / 2, s.globals.isBarHorizontal && (n = 25, o = -1 * e.width - s.config.yaxis[t].title.offsetX - n)), {
                    xPos: o,
                    padd: n
                });
            }
        },
        {
            key: "setYAxisXPosition",
            value: function(t, e) {
                var i = this.w, a = 0, s = 0, r = 18, o = 1;
                i.config.yaxis.length > 1 && (this.multipleYs = !0), i.config.yaxis.map(function(n, l) {
                    var h = i.globals.ignoreYAxisIndexes.indexOf(l) > -1 || !n.show || n.floating || 0 === t[l].width, c = t[l].width + e[l].width;
                    n.opposite ? i.globals.isBarHorizontal ? (s = i.globals.gridWidth + i.globals.translateX - 1, i.globals.translateYAxisX[l] = s - n.labels.offsetX) : (s = i.globals.gridWidth + i.globals.translateX + o, h || (o = o + c + 20), i.globals.translateYAxisX[l] = s - n.labels.offsetX + 20) : (a = i.globals.translateX - r, h || (r = r + c + 20), i.globals.translateYAxisX[l] = a + n.labels.offsetX);
                });
            }
        },
        {
            key: "setYAxisTextAlignments",
            value: function() {
                var t = this.w, e = t.globals.dom.baseEl.getElementsByClassName("apexcharts-yaxis");
                (e = $b705b473d3ec9641$var$p.listToArray(e)).forEach(function(e, i) {
                    var a = t.config.yaxis[i];
                    if (a && void 0 !== a.labels.align) {
                        var s = t.globals.dom.baseEl.querySelector(".apexcharts-yaxis[rel='".concat(i, "'] .apexcharts-yaxis-texts-g")), r = t.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxis[rel='".concat(i, "'] .apexcharts-yaxis-label"));
                        r = $b705b473d3ec9641$var$p.listToArray(r);
                        var o = s.getBoundingClientRect();
                        "left" === a.labels.align ? (r.forEach(function(t, e) {
                            t.setAttribute("text-anchor", "start");
                        }), a.opposite || s.setAttribute("transform", "translate(-".concat(o.width, ", 0)"))) : "center" === a.labels.align ? (r.forEach(function(t, e) {
                            t.setAttribute("text-anchor", "middle");
                        }), s.setAttribute("transform", "translate(".concat(o.width / 2 * (a.opposite ? 1 : -1), ", 0)"))) : "right" === a.labels.align && (r.forEach(function(t, e) {
                            t.setAttribute("text-anchor", "end");
                        }), a.opposite && s.setAttribute("transform", "translate(".concat(o.width, ", 0)")));
                    }
                });
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$Z = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.ctx = e, this.w = e.w, this.documentEvent = $b705b473d3ec9641$var$p.bind(this.documentEvent, this);
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "addEventListener",
            value: function(t, e) {
                var i = this.w;
                i.globals.events.hasOwnProperty(t) ? i.globals.events[t].push(e) : i.globals.events[t] = [
                    e
                ];
            }
        },
        {
            key: "removeEventListener",
            value: function(t, e) {
                var i = this.w;
                if (i.globals.events.hasOwnProperty(t)) {
                    var a = i.globals.events[t].indexOf(e);
                    -1 !== a && i.globals.events[t].splice(a, 1);
                }
            }
        },
        {
            key: "fireEvent",
            value: function(t, e) {
                var i = this.w;
                if (i.globals.events.hasOwnProperty(t)) {
                    e && e.length || (e = []);
                    for(var a = i.globals.events[t], s = a.length, r = 0; r < s; r++)a[r].apply(null, e);
                }
            }
        },
        {
            key: "setupEventHandlers",
            value: function() {
                var t = this, e = this.w, i = this.ctx, a = e.globals.dom.baseEl.querySelector(e.globals.chartClass);
                this.ctx.eventList.forEach(function(t) {
                    a.addEventListener(t, function(t) {
                        var a = Object.assign({}, e, {
                            seriesIndex: e.globals.capturedSeriesIndex,
                            dataPointIndex: e.globals.capturedDataPointIndex
                        });
                        "mousemove" === t.type || "touchmove" === t.type ? "function" == typeof e.config.chart.events.mouseMove && e.config.chart.events.mouseMove(t, i, a) : "mouseleave" === t.type || "touchleave" === t.type ? "function" == typeof e.config.chart.events.mouseLeave && e.config.chart.events.mouseLeave(t, i, a) : ("mouseup" === t.type && 1 === t.which || "touchend" === t.type) && ("function" == typeof e.config.chart.events.click && e.config.chart.events.click(t, i, a), i.ctx.events.fireEvent("click", [
                            t,
                            i,
                            a
                        ]));
                    }, {
                        capture: !1,
                        passive: !0
                    });
                }), this.ctx.eventList.forEach(function(i) {
                    e.globals.dom.baseEl.addEventListener(i, t.documentEvent, {
                        passive: !0
                    });
                }), this.ctx.core.setupBrushHandler();
            }
        },
        {
            key: "documentEvent",
            value: function(t) {
                var e = this.w, i = t.target.className;
                if ("click" === t.type) {
                    var a = e.globals.dom.baseEl.querySelector(".apexcharts-menu");
                    a && a.classList.contains("apexcharts-menu-open") && "apexcharts-menu-icon" !== i && a.classList.remove("apexcharts-menu-open");
                }
                e.globals.clientX = "touchmove" === t.type ? t.touches[0].clientX : t.clientX, e.globals.clientY = "touchmove" === t.type ? t.touches[0].clientY : t.clientY;
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$$ = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "setCurrentLocaleValues",
            value: function(t) {
                var e = this.w.config.chart.locales;
                window.Apex.chart && window.Apex.chart.locales && window.Apex.chart.locales.length > 0 && (e = this.w.config.chart.locales.concat(window.Apex.chart.locales));
                var i = e.filter(function(e) {
                    return e.name === t;
                })[0];
                if (!i) throw new Error("Wrong locale name provided. Please make sure you set the correct locale name in options");
                var a = $b705b473d3ec9641$var$p.extend($b705b473d3ec9641$var$A, i);
                this.w.globals.locale = a.options;
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$J = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "drawAxis",
            value: function(t, e) {
                var i, a, s = this.w.globals, r = this.w.config, o = new $b705b473d3ec9641$var$G(this.ctx), n = new $b705b473d3ec9641$var$q(this.ctx);
                s.axisCharts && "radar" !== t && (s.isBarHorizontal ? (a = n.drawYaxisInversed(0), i = o.drawXaxisInversed(0), s.dom.elGraphical.add(i), s.dom.elGraphical.add(a)) : (i = o.drawXaxis(), s.dom.elGraphical.add(i), r.yaxis.map(function(t, e) {
                    -1 === s.ignoreYAxisIndexes.indexOf(e) && (a = n.drawYaxis(e), s.dom.Paper.add(a));
                })));
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$Q = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "drawXCrosshairs",
            value: function() {
                var t = this.w, e = new $b705b473d3ec9641$var$b(this.ctx), i = new $b705b473d3ec9641$var$x(this.ctx), a = t.config.xaxis.crosshairs.fill.gradient, s = t.config.xaxis.crosshairs.dropShadow, r = t.config.xaxis.crosshairs.fill.type, o = a.colorFrom, n = a.colorTo, l = a.opacityFrom, h = a.opacityTo, c = a.stops, d = s.enabled, g = s.left, u = s.top, f = s.blur, v = s.color, m = s.opacity, y = t.config.xaxis.crosshairs.fill.color;
                if (t.config.xaxis.crosshairs.show) {
                    "gradient" === r && (y = e.drawGradient("vertical", o, n, l, h, null, c, null));
                    var w = e.drawRect();
                    1 === t.config.xaxis.crosshairs.width && (w = e.drawLine());
                    var k = t.globals.gridHeight;
                    (!$b705b473d3ec9641$var$p.isNumber(k) || k < 0) && (k = 0);
                    var A = t.config.xaxis.crosshairs.width;
                    (!$b705b473d3ec9641$var$p.isNumber(A) || A < 0) && (A = 0), w.attr({
                        class: "apexcharts-xcrosshairs",
                        x: 0,
                        y: 0,
                        y2: k,
                        width: A,
                        height: k,
                        fill: y,
                        filter: "none",
                        "fill-opacity": t.config.xaxis.crosshairs.opacity,
                        stroke: t.config.xaxis.crosshairs.stroke.color,
                        "stroke-width": t.config.xaxis.crosshairs.stroke.width,
                        "stroke-dasharray": t.config.xaxis.crosshairs.stroke.dashArray
                    }), d && (w = i.dropShadow(w, {
                        left: g,
                        top: u,
                        blur: f,
                        color: v,
                        opacity: m
                    })), t.globals.dom.elGraphical.add(w);
                }
            }
        },
        {
            key: "drawYCrosshairs",
            value: function() {
                var t = this.w, e = new $b705b473d3ec9641$var$b(this.ctx), i = t.config.yaxis[0].crosshairs, a = t.globals.barPadForNumericAxis;
                if (t.config.yaxis[0].crosshairs.show) {
                    var s = e.drawLine(-a, 0, t.globals.gridWidth + a, 0, i.stroke.color, i.stroke.dashArray, i.stroke.width);
                    s.attr({
                        class: "apexcharts-ycrosshairs"
                    }), t.globals.dom.elGraphical.add(s);
                }
                var r = e.drawLine(-a, 0, t.globals.gridWidth + a, 0, i.stroke.color, 0, 0);
                r.attr({
                    class: "apexcharts-ycrosshairs-hidden"
                }), t.globals.dom.elGraphical.add(r);
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$K = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "checkResponsiveConfig",
            value: function(t) {
                var e = this, i = this.w, a = i.config;
                if (0 !== a.responsive.length) {
                    var s = a.responsive.slice();
                    s.sort(function(t, e) {
                        return t.breakpoint > e.breakpoint ? 1 : e.breakpoint > t.breakpoint ? -1 : 0;
                    }).reverse();
                    var r = new $b705b473d3ec9641$var$H({}), o = function() {
                        var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, a = s[0].breakpoint, o = window.innerWidth > 0 ? window.innerWidth : screen.width;
                        if (o > a) {
                            var n = $b705b473d3ec9641$var$y.extendArrayProps(r, i.globals.initialConfig, i);
                            t = $b705b473d3ec9641$var$p.extend(n, t), t = $b705b473d3ec9641$var$p.extend(i.config, t), e.overrideResponsiveOptions(t);
                        } else for(var l = 0; l < s.length; l++)o < s[l].breakpoint && (t = $b705b473d3ec9641$var$y.extendArrayProps(r, s[l].options, i), t = $b705b473d3ec9641$var$p.extend(i.config, t), e.overrideResponsiveOptions(t));
                    };
                    if (t) {
                        var n = $b705b473d3ec9641$var$y.extendArrayProps(r, t, i);
                        n = $b705b473d3ec9641$var$p.extend(i.config, n), o(n = $b705b473d3ec9641$var$p.extend(n, t));
                    } else o({});
                }
            }
        },
        {
            key: "overrideResponsiveOptions",
            value: function(t) {
                var e = new $b705b473d3ec9641$var$H(t).init({
                    responsiveOverride: !0
                });
                this.w.config = e;
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$tt = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.ctx = e, this.colors = [], this.w = e.w;
        var i = this.w;
        this.isColorFn = !1, this.isHeatmapDistributed = "treemap" === i.config.chart.type && i.config.plotOptions.treemap.distributed || "heatmap" === i.config.chart.type && i.config.plotOptions.heatmap.distributed, this.isBarDistributed = i.config.plotOptions.bar.distributed && ("bar" === i.config.chart.type || "rangeBar" === i.config.chart.type);
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "init",
            value: function() {
                this.setDefaultColors();
            }
        },
        {
            key: "setDefaultColors",
            value: function() {
                var t = this, e = this.w, i = new $b705b473d3ec9641$var$p;
                if (e.globals.dom.elWrap.classList.add("apexcharts-theme-".concat(e.config.theme.mode)), void 0 === e.config.colors ? e.globals.colors = this.predefined() : (e.globals.colors = e.config.colors, Array.isArray(e.config.colors) && e.config.colors.length > 0 && "function" == typeof e.config.colors[0] && (e.globals.colors = e.config.series.map(function(i, a) {
                    var s = e.config.colors[a];
                    return s || (s = e.config.colors[0]), "function" == typeof s ? (t.isColorFn = !0, s({
                        value: e.globals.axisCharts ? e.globals.series[a][0] ? e.globals.series[a][0] : 0 : e.globals.series[a],
                        seriesIndex: a,
                        dataPointIndex: a,
                        w: e
                    })) : s;
                }))), e.globals.seriesColors.map(function(t, i) {
                    t && (e.globals.colors[i] = t);
                }), e.config.theme.monochrome.enabled) {
                    var a = [], s = e.globals.series.length;
                    (this.isBarDistributed || this.isHeatmapDistributed) && (s = e.globals.series[0].length * e.globals.series.length);
                    for(var r = e.config.theme.monochrome.color, o = 1 / (s / e.config.theme.monochrome.shadeIntensity), n = e.config.theme.monochrome.shadeTo, l = 0, h = 0; h < s; h++){
                        var c = void 0;
                        "dark" === n ? (c = i.shadeColor(-1 * l, r), l += o) : (c = i.shadeColor(l, r), l += o), a.push(c);
                    }
                    e.globals.colors = a.slice();
                }
                var d = e.globals.colors.slice();
                this.pushExtraColors(e.globals.colors);
                [
                    "fill",
                    "stroke"
                ].forEach(function(i) {
                    void 0 === e.config[i].colors ? e.globals[i].colors = t.isColorFn ? e.config.colors : d : e.globals[i].colors = e.config[i].colors.slice(), t.pushExtraColors(e.globals[i].colors);
                }), void 0 === e.config.dataLabels.style.colors ? e.globals.dataLabels.style.colors = d : e.globals.dataLabels.style.colors = e.config.dataLabels.style.colors.slice(), this.pushExtraColors(e.globals.dataLabels.style.colors, 50), void 0 === e.config.plotOptions.radar.polygons.fill.colors ? e.globals.radarPolygons.fill.colors = [
                    "dark" === e.config.theme.mode ? "#424242" : "none"
                ] : e.globals.radarPolygons.fill.colors = e.config.plotOptions.radar.polygons.fill.colors.slice(), this.pushExtraColors(e.globals.radarPolygons.fill.colors, 20), void 0 === e.config.markers.colors ? e.globals.markers.colors = d : e.globals.markers.colors = e.config.markers.colors.slice(), this.pushExtraColors(e.globals.markers.colors);
            }
        },
        {
            key: "pushExtraColors",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, a = this.w, s = e || a.globals.series.length;
                if (null === i && (i = this.isBarDistributed || this.isHeatmapDistributed || "heatmap" === a.config.chart.type && a.config.plotOptions.heatmap.colorScale.inverse), i && a.globals.series.length && (s = a.globals.series[a.globals.maxValsInArrayIndex].length * a.globals.series.length), t.length < s) for(var r = s - t.length, o = 0; o < r; o++)t.push(t[o]);
            }
        },
        {
            key: "updateThemeOptions",
            value: function(t) {
                t.chart = t.chart || {}, t.tooltip = t.tooltip || {};
                var e = t.theme.mode || "light", i = t.theme.palette ? t.theme.palette : "dark" === e ? "palette4" : "palette1", a = t.chart.foreColor ? t.chart.foreColor : "dark" === e ? "#f6f7f8" : "#373d3f";
                return t.tooltip.theme = e, t.chart.foreColor = a, t.theme.palette = i, t;
            }
        },
        {
            key: "predefined",
            value: function() {
                switch(this.w.config.theme.palette){
                    case "palette1":
                        this.colors = [
                            "#008FFB",
                            "#00E396",
                            "#FEB019",
                            "#FF4560",
                            "#775DD0"
                        ];
                        break;
                    case "palette2":
                        this.colors = [
                            "#3f51b5",
                            "#03a9f4",
                            "#4caf50",
                            "#f9ce1d",
                            "#FF9800"
                        ];
                        break;
                    case "palette3":
                        this.colors = [
                            "#33b2df",
                            "#546E7A",
                            "#d4526e",
                            "#13d8aa",
                            "#A5978B"
                        ];
                        break;
                    case "palette4":
                        this.colors = [
                            "#4ecdc4",
                            "#c7f464",
                            "#81D4FA",
                            "#fd6a6a",
                            "#546E7A"
                        ];
                        break;
                    case "palette5":
                        this.colors = [
                            "#2b908f",
                            "#f9a3a4",
                            "#90ee7e",
                            "#fa4443",
                            "#69d2e7"
                        ];
                        break;
                    case "palette6":
                        this.colors = [
                            "#449DD1",
                            "#F86624",
                            "#EA3546",
                            "#662E9B",
                            "#C5D86D"
                        ];
                        break;
                    case "palette7":
                        this.colors = [
                            "#D7263D",
                            "#1B998B",
                            "#2E294E",
                            "#F46036",
                            "#E2C044"
                        ];
                        break;
                    case "palette8":
                        this.colors = [
                            "#662E9B",
                            "#F86624",
                            "#F9C80E",
                            "#EA3546",
                            "#43BCCD"
                        ];
                        break;
                    case "palette9":
                        this.colors = [
                            "#5C4742",
                            "#A5978B",
                            "#8D5B4C",
                            "#5A2A27",
                            "#C4BBAF"
                        ];
                        break;
                    case "palette10":
                        this.colors = [
                            "#A300D6",
                            "#7D02EB",
                            "#5653FE",
                            "#2983FF",
                            "#00B1F2"
                        ];
                        break;
                    default:
                        this.colors = [
                            "#008FFB",
                            "#00E396",
                            "#FEB019",
                            "#FF4560",
                            "#775DD0"
                        ];
                }
                return this.colors;
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$et = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "draw",
            value: function() {
                this.drawTitleSubtitle("title"), this.drawTitleSubtitle("subtitle");
            }
        },
        {
            key: "drawTitleSubtitle",
            value: function(t) {
                var e = this.w, i = "title" === t ? e.config.title : e.config.subtitle, a = e.globals.svgWidth / 2, s = i.offsetY, r = "middle";
                if ("left" === i.align ? (a = 10, r = "start") : "right" === i.align && (a = e.globals.svgWidth - 10, r = "end"), a += i.offsetX, s = s + parseInt(i.style.fontSize, 10) + i.margin / 2, void 0 !== i.text) {
                    var o = new $b705b473d3ec9641$var$b(this.ctx).drawText({
                        x: a,
                        y: s,
                        text: i.text,
                        textAnchor: r,
                        fontSize: i.style.fontSize,
                        fontFamily: i.style.fontFamily,
                        fontWeight: i.style.fontWeight,
                        foreColor: i.style.color,
                        opacity: 1
                    });
                    o.node.setAttribute("class", "apexcharts-".concat(t, "-text")), e.globals.dom.Paper.add(o);
                }
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$it = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.w = e.w, this.dCtx = e;
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "getTitleSubtitleCoords",
            value: function(t) {
                var e = this.w, i = 0, a = 0, s = "title" === t ? e.config.title.floating : e.config.subtitle.floating, r = e.globals.dom.baseEl.querySelector(".apexcharts-".concat(t, "-text"));
                if (null !== r && !s) {
                    var o = r.getBoundingClientRect();
                    i = o.width, a = e.globals.axisCharts ? o.height + 5 : o.height;
                }
                return {
                    width: i,
                    height: a
                };
            }
        },
        {
            key: "getLegendsRect",
            value: function() {
                var t = this.w, e = t.globals.dom.baseEl.querySelector(".apexcharts-legend");
                t.config.legend.height || "top" !== t.config.legend.position && "bottom" !== t.config.legend.position || (e.style.maxHeight = t.globals.svgHeight / 2 + "px");
                var i = Object.assign({}, $b705b473d3ec9641$var$p.getBoundingClientRect(e));
                return null !== e && !t.config.legend.floating && t.config.legend.show ? this.dCtx.lgRect = {
                    x: i.x,
                    y: i.y,
                    height: i.height,
                    width: 0 === i.height ? 0 : i.width
                } : this.dCtx.lgRect = {
                    x: 0,
                    y: 0,
                    height: 0,
                    width: 0
                }, "left" !== t.config.legend.position && "right" !== t.config.legend.position || 1.5 * this.dCtx.lgRect.width > t.globals.svgWidth && (this.dCtx.lgRect.width = t.globals.svgWidth / 1.5), this.dCtx.lgRect;
            }
        },
        {
            key: "getLargestStringFromMultiArr",
            value: function(t, e) {
                var i = t;
                if (this.w.globals.isMultiLineX) {
                    var a = e.map(function(t, e) {
                        return Array.isArray(t) ? t.length : 1;
                    }), s = Math.max.apply(Math, $b705b473d3ec9641$var$g(a));
                    i = e[a.indexOf(s)];
                }
                return i;
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$at = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.w = e.w, this.dCtx = e;
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "getxAxisLabelsCoords",
            value: function() {
                var t, e = this.w, i = e.globals.labels.slice();
                if (e.config.xaxis.convertedCatToNumeric && 0 === i.length && (i = e.globals.categoryLabels), e.globals.timescaleLabels.length > 0) {
                    var a = this.getxAxisTimeScaleLabelsCoords();
                    t = {
                        width: a.width,
                        height: a.height
                    }, e.globals.rotateXLabels = !1;
                } else {
                    this.dCtx.lgWidthForSideLegends = "left" !== e.config.legend.position && "right" !== e.config.legend.position || e.config.legend.floating ? 0 : this.dCtx.lgRect.width;
                    var s = e.globals.xLabelFormatter, r = $b705b473d3ec9641$var$p.getLargestStringFromArr(i), o = this.dCtx.dimHelpers.getLargestStringFromMultiArr(r, i);
                    e.globals.isBarHorizontal && (o = r = e.globals.yAxisScale[0].result.reduce(function(t, e) {
                        return t.length > e.length ? t : e;
                    }, 0));
                    var n = new $b705b473d3ec9641$var$W(this.dCtx.ctx), l = r;
                    r = n.xLabelFormat(s, r, l, {
                        i: void 0,
                        dateFormatter: new $b705b473d3ec9641$var$Y(this.dCtx.ctx).formatDate,
                        w: e
                    }), o = n.xLabelFormat(s, o, l, {
                        i: void 0,
                        dateFormatter: new $b705b473d3ec9641$var$Y(this.dCtx.ctx).formatDate,
                        w: e
                    }), (e.config.xaxis.convertedCatToNumeric && void 0 === r || "" === String(r).trim()) && (o = r = "1");
                    var h = new $b705b473d3ec9641$var$b(this.dCtx.ctx), c = h.getTextRects(r, e.config.xaxis.labels.style.fontSize), d = c;
                    if (r !== o && (d = h.getTextRects(o, e.config.xaxis.labels.style.fontSize)), (t = {
                        width: c.width >= d.width ? c.width : d.width,
                        height: c.height >= d.height ? c.height : d.height
                    }).width * i.length > e.globals.svgWidth - this.dCtx.lgWidthForSideLegends - this.dCtx.yAxisWidth - this.dCtx.gridPad.left - this.dCtx.gridPad.right && 0 !== e.config.xaxis.labels.rotate || e.config.xaxis.labels.rotateAlways) {
                        if (!e.globals.isBarHorizontal) {
                            e.globals.rotateXLabels = !0;
                            var g = function(t) {
                                return h.getTextRects(t, e.config.xaxis.labels.style.fontSize, e.config.xaxis.labels.style.fontFamily, "rotate(".concat(e.config.xaxis.labels.rotate, " 0 0)"), !1);
                            };
                            c = g(r), r !== o && (d = g(o)), t.height = (c.height > d.height ? c.height : d.height) / 1.5, t.width = c.width > d.width ? c.width : d.width;
                        }
                    } else e.globals.rotateXLabels = !1;
                }
                return e.config.xaxis.labels.show || (t = {
                    width: 0,
                    height: 0
                }), {
                    width: t.width,
                    height: t.height
                };
            }
        },
        {
            key: "getxAxisTitleCoords",
            value: function() {
                var t = this.w, e = 0, i = 0;
                if (void 0 !== t.config.xaxis.title.text) {
                    var a = new $b705b473d3ec9641$var$b(this.dCtx.ctx).getTextRects(t.config.xaxis.title.text, t.config.xaxis.title.style.fontSize);
                    e = a.width, i = a.height;
                }
                return {
                    width: e,
                    height: i
                };
            }
        },
        {
            key: "getxAxisTimeScaleLabelsCoords",
            value: function() {
                var t, e = this.w;
                this.dCtx.timescaleLabels = e.globals.timescaleLabels.slice();
                var i = this.dCtx.timescaleLabels.map(function(t) {
                    return t.value;
                }), a = i.reduce(function(t, e) {
                    return void 0 === t ? (console.error("You have possibly supplied invalid Date format. Please supply a valid JavaScript Date"), 0) : t.length > e.length ? t : e;
                }, 0);
                return 1.05 * (t = new $b705b473d3ec9641$var$b(this.dCtx.ctx).getTextRects(a, e.config.xaxis.labels.style.fontSize)).width * i.length > e.globals.gridWidth && 0 !== e.config.xaxis.labels.rotate && (e.globals.overlappingXLabels = !0), t;
            }
        },
        {
            key: "additionalPaddingXLabels",
            value: function(t) {
                var e = this, i = this.w, a = i.globals, s = i.config, r = s.xaxis.type, o = t.width;
                a.skipLastTimelinelabel = !1, a.skipFirstTimelinelabel = !1;
                var n = i.config.yaxis[0].opposite && i.globals.isBarHorizontal, l = function(t, n) {
                    (function(t) {
                        return -1 !== a.collapsedSeriesIndices.indexOf(t);
                    })(n) || function(t) {
                        if (e.dCtx.timescaleLabels && e.dCtx.timescaleLabels.length) {
                            var n = e.dCtx.timescaleLabels[0], l = e.dCtx.timescaleLabels[e.dCtx.timescaleLabels.length - 1].position + o / 1.75 - e.dCtx.yAxisWidthRight, h = n.position - o / 1.75 + e.dCtx.yAxisWidthLeft, c = "right" === i.config.legend.position && e.dCtx.lgRect.width > 0 ? e.dCtx.lgRect.width : 0;
                            l > a.svgWidth - a.translateX - c && (a.skipLastTimelinelabel = !0), h < -(t.show && !t.floating || "bar" !== s.chart.type && "candlestick" !== s.chart.type && "rangeBar" !== s.chart.type && "boxPlot" !== s.chart.type ? 10 : o / 1.75) && (a.skipFirstTimelinelabel = !0);
                        } else "datetime" === r ? e.dCtx.gridPad.right < o && !a.rotateXLabels && (a.skipLastTimelinelabel = !0) : "datetime" !== r && e.dCtx.gridPad.right < o / 2 - e.dCtx.yAxisWidthRight && !a.rotateXLabels && !i.config.xaxis.labels.trim && ("between" !== i.config.xaxis.tickPlacement || i.globals.isBarHorizontal) && (e.dCtx.xPadRight = o / 2 + 1);
                    }(t);
                };
                s.yaxis.forEach(function(t, i) {
                    n ? (e.dCtx.gridPad.left < o && (e.dCtx.xPadLeft = o / 2 + 1), e.dCtx.xPadRight = o / 2 + 1) : l(t, i);
                });
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$st = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.w = e.w, this.dCtx = e;
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "getyAxisLabelsCoords",
            value: function() {
                var t = this, e = this.w, i = [], a = 10, s = new $b705b473d3ec9641$var$B(this.dCtx.ctx);
                return e.config.yaxis.map(function(r, o) {
                    var n = e.globals.yAxisScale[o], l = 0;
                    if (!s.isYAxisHidden(o) && r.labels.show && void 0 !== r.labels.minWidth && (l = r.labels.minWidth), !s.isYAxisHidden(o) && r.labels.show && n.result.length) {
                        var h = e.globals.yLabelFormatters[o], c = n.niceMin === Number.MIN_VALUE ? 0 : n.niceMin, d = String(c).length > String(n.niceMax).length ? c : n.niceMax, g = h(d, {
                            seriesIndex: o,
                            dataPointIndex: -1,
                            w: e
                        }), u = g;
                        if (void 0 !== g && 0 !== g.length || (g = d), e.globals.isBarHorizontal) {
                            a = 0;
                            var f = e.globals.labels.slice();
                            g = h(g = $b705b473d3ec9641$var$p.getLargestStringFromArr(f), {
                                seriesIndex: o,
                                dataPointIndex: -1,
                                w: e
                            }), u = t.dCtx.dimHelpers.getLargestStringFromMultiArr(g, f);
                        }
                        var x = new $b705b473d3ec9641$var$b(t.dCtx.ctx), v = "rotate(".concat(r.labels.rotate, " 0 0)"), m = x.getTextRects(g, r.labels.style.fontSize, r.labels.style.fontFamily, v, !1), y = m;
                        g !== u && (y = x.getTextRects(u, r.labels.style.fontSize, r.labels.style.fontFamily, v, !1)), i.push({
                            width: (l > y.width || l > m.width ? l : y.width > m.width ? y.width : m.width) + a,
                            height: y.height > m.height ? y.height : m.height
                        });
                    } else i.push({
                        width: 0,
                        height: 0
                    });
                }), i;
            }
        },
        {
            key: "getyAxisTitleCoords",
            value: function() {
                var t = this, e = this.w, i = [];
                return e.config.yaxis.map(function(e, a) {
                    if (e.show && void 0 !== e.title.text) {
                        var s = new $b705b473d3ec9641$var$b(t.dCtx.ctx), r = "rotate(".concat(e.title.rotate, " 0 0)"), o = s.getTextRects(e.title.text, e.title.style.fontSize, e.title.style.fontFamily, r, !1);
                        i.push({
                            width: o.width,
                            height: o.height
                        });
                    } else i.push({
                        width: 0,
                        height: 0
                    });
                }), i;
            }
        },
        {
            key: "getTotalYAxisWidth",
            value: function() {
                var t = this.w, e = 0, i = 0, a = 0, s = t.globals.yAxisScale.length > 1 ? 10 : 0, r = new $b705b473d3ec9641$var$B(this.dCtx.ctx), o = function(o, n) {
                    var l = t.config.yaxis[n].floating, h = 0;
                    o.width > 0 && !l ? (h = o.width + s, function(e) {
                        return t.globals.ignoreYAxisIndexes.indexOf(e) > -1;
                    }(n) && (h = h - o.width - s)) : h = l || r.isYAxisHidden(n) ? 0 : 5, t.config.yaxis[n].opposite ? a += h : i += h, e += h;
                };
                return t.globals.yLabelsCoords.map(function(t, e) {
                    o(t, e);
                }), t.globals.yTitleCoords.map(function(t, e) {
                    o(t, e);
                }), t.globals.isBarHorizontal && !t.config.yaxis[0].floating && (e = t.globals.yLabelsCoords[0].width + t.globals.yTitleCoords[0].width + 15), this.dCtx.yAxisWidthLeft = i, this.dCtx.yAxisWidthRight = a, e;
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$rt = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.w = e.w, this.dCtx = e;
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "gridPadForColumnsInNumericAxis",
            value: function(t) {
                var e = this.w;
                if (e.globals.noData || e.globals.allSeriesCollapsed) return 0;
                var i = function(t) {
                    return "bar" === t || "rangeBar" === t || "candlestick" === t || "boxPlot" === t;
                }, a = e.config.chart.type, s = 0, r = i(a) ? e.config.series.length : 1;
                if (e.globals.comboBarCount > 0 && (r = e.globals.comboBarCount), e.globals.collapsedSeries.forEach(function(t) {
                    i(t.type) && (r -= 1);
                }), e.config.chart.stacked && (r = 1), (i(a) || e.globals.comboBarCount > 0) && e.globals.isXNumeric && !e.globals.isBarHorizontal && r > 0) {
                    var o, n, l = Math.abs(e.globals.initialMaxX - e.globals.initialMinX);
                    l <= 3 && (l = e.globals.dataPoints), o = l / t, e.globals.minXDiff && e.globals.minXDiff / o > 0 && (n = e.globals.minXDiff / o), n > t / 2 && (n /= 2), (s = n / r * parseInt(e.config.plotOptions.bar.columnWidth, 10) / 100) < 1 && (s = 1), s = s / (r > 1 ? 1 : 1.5) + 5, e.globals.barPadForNumericAxis = s;
                }
                return s;
            }
        },
        {
            key: "gridPadFortitleSubtitle",
            value: function() {
                var t = this, e = this.w, i = e.globals, a = this.dCtx.isSparkline || !e.globals.axisCharts ? 0 : 10;
                [
                    "title",
                    "subtitle"
                ].forEach(function(i) {
                    void 0 !== e.config[i].text ? a += e.config[i].margin : a += t.dCtx.isSparkline || !e.globals.axisCharts ? 0 : 5;
                }), !e.config.legend.show || "bottom" !== e.config.legend.position || e.config.legend.floating || e.globals.axisCharts || (a += 10);
                var s = this.dCtx.dimHelpers.getTitleSubtitleCoords("title"), r = this.dCtx.dimHelpers.getTitleSubtitleCoords("subtitle");
                i.gridHeight = i.gridHeight - s.height - r.height - a, i.translateY = i.translateY + s.height + r.height + a;
            }
        },
        {
            key: "setGridXPosForDualYAxis",
            value: function(t, e) {
                var i = this.w, a = new $b705b473d3ec9641$var$B(this.dCtx.ctx);
                i.config.yaxis.map(function(s, r) {
                    -1 !== i.globals.ignoreYAxisIndexes.indexOf(r) || s.floating || a.isYAxisHidden(r) || (s.opposite && (i.globals.translateX = i.globals.translateX - (e[r].width + t[r].width) - parseInt(i.config.yaxis[r].labels.style.fontSize, 10) / 1.2 - 12), i.globals.translateX < 2 && (i.globals.translateX = 2));
                });
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$ot = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.ctx = e, this.w = e.w, this.lgRect = {}, this.yAxisWidth = 0, this.yAxisWidthLeft = 0, this.yAxisWidthRight = 0, this.xAxisHeight = 0, this.isSparkline = this.w.config.chart.sparkline.enabled, this.dimHelpers = new $b705b473d3ec9641$var$it(this), this.dimYAxis = new $b705b473d3ec9641$var$st(this), this.dimXAxis = new $b705b473d3ec9641$var$at(this), this.dimGrid = new $b705b473d3ec9641$var$rt(this), this.lgWidthForSideLegends = 0, this.gridPad = this.w.config.grid.padding, this.xPadRight = 0, this.xPadLeft = 0;
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "plotCoords",
            value: function() {
                var t = this.w.globals;
                this.lgRect = this.dimHelpers.getLegendsRect(), t.axisCharts ? this.setDimensionsForAxisCharts() : this.setDimensionsForNonAxisCharts(), this.dimGrid.gridPadFortitleSubtitle(), t.gridHeight = t.gridHeight - this.gridPad.top - this.gridPad.bottom, t.gridWidth = t.gridWidth - this.gridPad.left - this.gridPad.right - this.xPadRight - this.xPadLeft;
                var e = this.dimGrid.gridPadForColumnsInNumericAxis(t.gridWidth);
                t.gridWidth = t.gridWidth - 2 * e, t.translateX = t.translateX + this.gridPad.left + this.xPadLeft + (e > 0 ? e + 4 : 0), t.translateY = t.translateY + this.gridPad.top;
            }
        },
        {
            key: "setDimensionsForAxisCharts",
            value: function() {
                var t = this, e = this.w, i = e.globals, a = this.dimYAxis.getyAxisLabelsCoords(), s = this.dimYAxis.getyAxisTitleCoords();
                e.globals.yLabelsCoords = [], e.globals.yTitleCoords = [], e.config.yaxis.map(function(t, i) {
                    e.globals.yLabelsCoords.push({
                        width: a[i].width,
                        index: i
                    }), e.globals.yTitleCoords.push({
                        width: s[i].width,
                        index: i
                    });
                }), this.yAxisWidth = this.dimYAxis.getTotalYAxisWidth();
                var r = this.dimXAxis.getxAxisLabelsCoords(), o = this.dimXAxis.getxAxisTitleCoords();
                this.conditionalChecksForAxisCoords(r, o), i.translateXAxisY = e.globals.rotateXLabels ? this.xAxisHeight / 8 : -4, i.translateXAxisX = e.globals.rotateXLabels && e.globals.isXNumeric && e.config.xaxis.labels.rotate <= -45 ? -this.xAxisWidth / 4 : 0, e.globals.isBarHorizontal && (i.rotateXLabels = !1, i.translateXAxisY = parseInt(e.config.xaxis.labels.style.fontSize, 10) / 1.5 * -1), i.translateXAxisY = i.translateXAxisY + e.config.xaxis.labels.offsetY, i.translateXAxisX = i.translateXAxisX + e.config.xaxis.labels.offsetX;
                var n = this.yAxisWidth, l = this.xAxisHeight;
                i.xAxisLabelsHeight = this.xAxisHeight - o.height, i.xAxisLabelsWidth = this.xAxisWidth, i.xAxisHeight = this.xAxisHeight;
                var h = 10;
                ("radar" === e.config.chart.type || this.isSparkline) && (n = 0, l = i.goldenPadding), this.isSparkline && (this.lgRect = {
                    height: 0,
                    width: 0
                }), (this.isSparkline || "treemap" === e.config.chart.type) && (n = 0, l = 0, h = 0), this.isSparkline || this.dimXAxis.additionalPaddingXLabels(r);
                var c = function() {
                    i.translateX = n, i.gridHeight = i.svgHeight - t.lgRect.height - l - (t.isSparkline || "treemap" === e.config.chart.type ? 0 : e.globals.rotateXLabels ? 10 : 15), i.gridWidth = i.svgWidth - n;
                };
                switch("top" === e.config.xaxis.position && (h = i.xAxisHeight - e.config.xaxis.axisTicks.height - 5), e.config.legend.position){
                    case "bottom":
                        i.translateY = h, c();
                        break;
                    case "top":
                        i.translateY = this.lgRect.height + h, c();
                        break;
                    case "left":
                        i.translateY = h, i.translateX = this.lgRect.width + n, i.gridHeight = i.svgHeight - l - 12, i.gridWidth = i.svgWidth - this.lgRect.width - n;
                        break;
                    case "right":
                        i.translateY = h, i.translateX = n, i.gridHeight = i.svgHeight - l - 12, i.gridWidth = i.svgWidth - this.lgRect.width - n - 5;
                        break;
                    default:
                        throw new Error("Legend position not supported");
                }
                this.dimGrid.setGridXPosForDualYAxis(s, a), new $b705b473d3ec9641$var$q(this.ctx).setYAxisXPosition(a, s);
            }
        },
        {
            key: "setDimensionsForNonAxisCharts",
            value: function() {
                var t = this.w, e = t.globals, i = t.config, a = 0;
                t.config.legend.show && !t.config.legend.floating && (a = 20);
                var s = "pie" === i.chart.type || "polarArea" === i.chart.type || "donut" === i.chart.type ? "pie" : "radialBar", r = i.plotOptions[s].offsetY, o = i.plotOptions[s].offsetX;
                if (!i.legend.show || i.legend.floating) return e.gridHeight = e.svgHeight - i.grid.padding.left + i.grid.padding.right, e.gridWidth = e.gridHeight, e.translateY = r, void (e.translateX = o + (e.svgWidth - e.gridWidth) / 2);
                switch(i.legend.position){
                    case "bottom":
                        e.gridHeight = e.svgHeight - this.lgRect.height - e.goldenPadding, e.gridWidth = e.svgWidth, e.translateY = r - 10, e.translateX = o + (e.svgWidth - e.gridWidth) / 2;
                        break;
                    case "top":
                        e.gridHeight = e.svgHeight - this.lgRect.height - e.goldenPadding, e.gridWidth = e.svgWidth, e.translateY = this.lgRect.height + r + 10, e.translateX = o + (e.svgWidth - e.gridWidth) / 2;
                        break;
                    case "left":
                        e.gridWidth = e.svgWidth - this.lgRect.width - a, e.gridHeight = "auto" !== i.chart.height ? e.svgHeight : e.gridWidth, e.translateY = r, e.translateX = o + this.lgRect.width + a;
                        break;
                    case "right":
                        e.gridWidth = e.svgWidth - this.lgRect.width - a - 5, e.gridHeight = "auto" !== i.chart.height ? e.svgHeight : e.gridWidth, e.translateY = r, e.translateX = o + 10;
                        break;
                    default:
                        throw new Error("Legend position not supported");
                }
            }
        },
        {
            key: "conditionalChecksForAxisCoords",
            value: function(t, e) {
                var i = this.w, a = t.height + e.height, s = i.globals.isMultiLineX ? 1.2 : i.globals.LINE_HEIGHT_RATIO, r = i.globals.rotateXLabels ? 22 : 10, o = i.globals.rotateXLabels && "bottom" === i.config.legend.position ? 10 : 0;
                this.xAxisHeight = a * s + r + o, this.xAxisWidth = t.width, this.xAxisHeight - e.height > i.config.xaxis.labels.maxHeight && (this.xAxisHeight = i.config.xaxis.labels.maxHeight), i.config.xaxis.labels.minHeight && this.xAxisHeight < i.config.xaxis.labels.minHeight && (this.xAxisHeight = i.config.xaxis.labels.minHeight), i.config.xaxis.floating && (this.xAxisHeight = 0);
                var n = 0, l = 0;
                i.config.yaxis.forEach(function(t) {
                    n += t.labels.minWidth, l += t.labels.maxWidth;
                }), this.yAxisWidth < n && (this.yAxisWidth = n), this.yAxisWidth > l && (this.yAxisWidth = l);
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$nt = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.w = e.w, this.lgCtx = e;
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "getLegendStyles",
            value: function() {
                var t = document.createElement("style");
                t.setAttribute("type", "text/css");
                var e = document.createTextNode("	\n    	\n      .apexcharts-legend {	\n        display: flex;	\n        overflow: auto;	\n        padding: 0 10px;	\n      }	\n      .apexcharts-legend.apx-legend-position-bottom, .apexcharts-legend.apx-legend-position-top {	\n        flex-wrap: wrap	\n      }	\n      .apexcharts-legend.apx-legend-position-right, .apexcharts-legend.apx-legend-position-left {	\n        flex-direction: column;	\n        bottom: 0;	\n      }	\n      .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-left, .apexcharts-legend.apx-legend-position-top.apexcharts-align-left, .apexcharts-legend.apx-legend-position-right, .apexcharts-legend.apx-legend-position-left {	\n        justify-content: flex-start;	\n      }	\n      .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-center, .apexcharts-legend.apx-legend-position-top.apexcharts-align-center {	\n        justify-content: center;  	\n      }	\n      .apexcharts-legend.apx-legend-position-bottom.apexcharts-align-right, .apexcharts-legend.apx-legend-position-top.apexcharts-align-right {	\n        justify-content: flex-end;	\n      }	\n      .apexcharts-legend-series {	\n        cursor: pointer;	\n        line-height: normal;	\n      }	\n      .apexcharts-legend.apx-legend-position-bottom .apexcharts-legend-series, .apexcharts-legend.apx-legend-position-top .apexcharts-legend-series{	\n        display: flex;	\n        align-items: center;	\n      }	\n      .apexcharts-legend-text {	\n        position: relative;	\n        font-size: 14px;	\n      }	\n      .apexcharts-legend-text *, .apexcharts-legend-marker * {	\n        pointer-events: none;	\n      }	\n      .apexcharts-legend-marker {	\n        position: relative;	\n        display: inline-block;	\n        cursor: pointer;	\n        margin-right: 3px;	\n        border-style: solid;\n      }	\n      	\n      .apexcharts-legend.apexcharts-align-right .apexcharts-legend-series, .apexcharts-legend.apexcharts-align-left .apexcharts-legend-series{	\n        display: inline-block;	\n      }	\n      .apexcharts-legend-series.apexcharts-no-click {	\n        cursor: auto;	\n      }	\n      .apexcharts-legend .apexcharts-hidden-zero-series, .apexcharts-legend .apexcharts-hidden-null-series {	\n        display: none !important;	\n      }	\n      .apexcharts-inactive-legend {	\n        opacity: 0.45;	\n      }");
                return t.appendChild(e), t;
            }
        },
        {
            key: "getLegendBBox",
            value: function() {
                var t = this.w.globals.dom.baseEl.querySelector(".apexcharts-legend").getBoundingClientRect(), e = t.width;
                return {
                    clwh: t.height,
                    clww: e
                };
            }
        },
        {
            key: "appendToForeignObject",
            value: function() {
                var t = this.w.globals;
                t.dom.elLegendForeign = document.createElementNS(t.SVGNS, "foreignObject");
                var e = t.dom.elLegendForeign;
                e.setAttribute("x", 0), e.setAttribute("y", 0), e.setAttribute("width", t.svgWidth), e.setAttribute("height", t.svgHeight), t.dom.elLegendWrap.setAttribute("xmlns", "http://www.w3.org/1999/xhtml"), e.appendChild(t.dom.elLegendWrap), e.appendChild(this.getLegendStyles()), t.dom.Paper.node.insertBefore(e, t.dom.elGraphical.node);
            }
        },
        {
            key: "toggleDataSeries",
            value: function(t, e) {
                var i = this, a = this.w;
                if (a.globals.axisCharts || "radialBar" === a.config.chart.type) {
                    a.globals.resized = !0;
                    var s = null, r = null;
                    if (a.globals.risingSeries = [], a.globals.axisCharts ? (s = a.globals.dom.baseEl.querySelector(".apexcharts-series[data\\:realIndex='".concat(t, "']")), r = parseInt(s.getAttribute("data:realIndex"), 10)) : (s = a.globals.dom.baseEl.querySelector(".apexcharts-series[rel='".concat(t + 1, "']")), r = parseInt(s.getAttribute("rel"), 10) - 1), e) [
                        {
                            cs: a.globals.collapsedSeries,
                            csi: a.globals.collapsedSeriesIndices
                        },
                        {
                            cs: a.globals.ancillaryCollapsedSeries,
                            csi: a.globals.ancillaryCollapsedSeriesIndices
                        }
                    ].forEach(function(t) {
                        i.riseCollapsedSeries(t.cs, t.csi, r);
                    });
                    else this.hideSeries({
                        seriesEl: s,
                        realIndex: r
                    });
                } else {
                    var o = a.globals.dom.Paper.select(" .apexcharts-series[rel='".concat(t + 1, "'] path")), n = a.config.chart.type;
                    if ("pie" === n || "polarArea" === n || "donut" === n) {
                        var l = a.config.plotOptions.pie.donut.labels;
                        new $b705b473d3ec9641$var$b(this.lgCtx.ctx).pathMouseDown(o.members[0], null), this.lgCtx.ctx.pie.printDataLabelsInner(o.members[0].node, l);
                    }
                    o.fire("click");
                }
            }
        },
        {
            key: "hideSeries",
            value: function(t) {
                var e = t.seriesEl, i = t.realIndex, a = this.w, s = $b705b473d3ec9641$var$p.clone(a.config.series);
                if (a.globals.axisCharts) {
                    var r = !1;
                    if (a.config.yaxis[i] && a.config.yaxis[i].show && a.config.yaxis[i].showAlways && (r = !0, a.globals.ancillaryCollapsedSeriesIndices.indexOf(i) < 0 && (a.globals.ancillaryCollapsedSeries.push({
                        index: i,
                        data: s[i].data.slice(),
                        type: e.parentNode.className.baseVal.split("-")[1]
                    }), a.globals.ancillaryCollapsedSeriesIndices.push(i))), !r) {
                        a.globals.collapsedSeries.push({
                            index: i,
                            data: s[i].data.slice(),
                            type: e.parentNode.className.baseVal.split("-")[1]
                        }), a.globals.collapsedSeriesIndices.push(i);
                        var o = a.globals.risingSeries.indexOf(i);
                        a.globals.risingSeries.splice(o, 1);
                    }
                } else a.globals.collapsedSeries.push({
                    index: i,
                    data: s[i]
                }), a.globals.collapsedSeriesIndices.push(i);
                for(var n = e.childNodes, l = 0; l < n.length; l++)n[l].classList.contains("apexcharts-series-markers-wrap") && (n[l].classList.contains("apexcharts-hide") ? n[l].classList.remove("apexcharts-hide") : n[l].classList.add("apexcharts-hide"));
                a.globals.allSeriesCollapsed = a.globals.collapsedSeries.length === a.config.series.length, s = this._getSeriesBasedOnCollapsedState(s), this.lgCtx.ctx.updateHelpers._updateSeries(s, a.config.chart.animations.dynamicAnimation.enabled);
            }
        },
        {
            key: "riseCollapsedSeries",
            value: function(t, e, i) {
                var a = this.w, s = $b705b473d3ec9641$var$p.clone(a.config.series);
                if (t.length > 0) {
                    for(var r = 0; r < t.length; r++)t[r].index === i && (a.globals.axisCharts ? (s[i].data = t[r].data.slice(), t.splice(r, 1), e.splice(r, 1), a.globals.risingSeries.push(i)) : (s[i] = t[r].data, t.splice(r, 1), e.splice(r, 1), a.globals.risingSeries.push(i)));
                    s = this._getSeriesBasedOnCollapsedState(s), this.lgCtx.ctx.updateHelpers._updateSeries(s, a.config.chart.animations.dynamicAnimation.enabled);
                }
            }
        },
        {
            key: "_getSeriesBasedOnCollapsedState",
            value: function(t) {
                var e = this.w;
                return e.globals.axisCharts ? t.forEach(function(i, a) {
                    e.globals.collapsedSeriesIndices.indexOf(a) > -1 && (t[a].data = []);
                }) : t.forEach(function(i, a) {
                    e.globals.collapsedSeriesIndices.indexOf(a) > -1 && (t[a] = 0);
                }), t;
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$lt = function() {
    function t(e, i) {
        $b705b473d3ec9641$var$a(this, t), this.ctx = e, this.w = e.w, this.onLegendClick = this.onLegendClick.bind(this), this.onLegendHovered = this.onLegendHovered.bind(this), this.isBarsDistributed = "bar" === this.w.config.chart.type && this.w.config.plotOptions.bar.distributed && 1 === this.w.config.series.length, this.legendHelpers = new $b705b473d3ec9641$var$nt(this);
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "init",
            value: function() {
                var t = this.w, e = t.globals, i = t.config;
                if ((i.legend.showForSingleSeries && 1 === e.series.length || this.isBarsDistributed || e.series.length > 1 || !e.axisCharts) && i.legend.show) {
                    for(; e.dom.elLegendWrap.firstChild;)e.dom.elLegendWrap.removeChild(e.dom.elLegendWrap.firstChild);
                    this.drawLegends(), $b705b473d3ec9641$var$p.isIE11() ? document.getElementsByTagName("head")[0].appendChild(this.legendHelpers.getLegendStyles()) : this.legendHelpers.appendToForeignObject(), "bottom" === i.legend.position || "top" === i.legend.position ? this.legendAlignHorizontal() : "right" !== i.legend.position && "left" !== i.legend.position || this.legendAlignVertical();
                }
            }
        },
        {
            key: "drawLegends",
            value: function() {
                var t = this, e = this.w, i = e.config.legend.fontFamily, a = e.globals.seriesNames, s = e.globals.colors.slice();
                if ("heatmap" === e.config.chart.type) {
                    var r = e.config.plotOptions.heatmap.colorScale.ranges;
                    a = r.map(function(t) {
                        return t.name ? t.name : t.from + " - " + t.to;
                    }), s = r.map(function(t) {
                        return t.color;
                    });
                } else this.isBarsDistributed && (a = e.globals.labels.slice());
                e.config.legend.customLegendItems.length && (a = e.config.legend.customLegendItems);
                for(var o = e.globals.legendFormatter, n = e.config.legend.inverseOrder, l = n ? a.length - 1 : 0; n ? l >= 0 : l <= a.length - 1; n ? l-- : l++){
                    var h = o(a[l], {
                        seriesIndex: l,
                        w: e
                    }), c = !1, d = !1;
                    if (e.globals.collapsedSeries.length > 0) for(var g = 0; g < e.globals.collapsedSeries.length; g++)e.globals.collapsedSeries[g].index === l && (c = !0);
                    if (e.globals.ancillaryCollapsedSeriesIndices.length > 0) for(var u = 0; u < e.globals.ancillaryCollapsedSeriesIndices.length; u++)e.globals.ancillaryCollapsedSeriesIndices[u] === l && (d = !0);
                    var f = document.createElement("span");
                    f.classList.add("apexcharts-legend-marker");
                    var x = e.config.legend.markers.offsetX, v = e.config.legend.markers.offsetY, m = e.config.legend.markers.height, w = e.config.legend.markers.width, k = e.config.legend.markers.strokeWidth, A = e.config.legend.markers.strokeColor, S = e.config.legend.markers.radius, C = f.style;
                    C.background = s[l], C.color = s[l], C.setProperty("background", s[l], "important"), e.config.legend.markers.fillColors && e.config.legend.markers.fillColors[l] && (C.background = e.config.legend.markers.fillColors[l]), void 0 !== e.globals.seriesColors[l] && (C.background = e.globals.seriesColors[l], C.color = e.globals.seriesColors[l]), C.height = Array.isArray(m) ? parseFloat(m[l]) + "px" : parseFloat(m) + "px", C.width = Array.isArray(w) ? parseFloat(w[l]) + "px" : parseFloat(w) + "px", C.left = (Array.isArray(x) ? parseFloat(x[l]) : parseFloat(x)) + "px", C.top = (Array.isArray(v) ? parseFloat(v[l]) : parseFloat(v)) + "px", C.borderWidth = Array.isArray(k) ? k[l] : k, C.borderColor = Array.isArray(A) ? A[l] : A, C.borderRadius = Array.isArray(S) ? parseFloat(S[l]) + "px" : parseFloat(S) + "px", e.config.legend.markers.customHTML && (Array.isArray(e.config.legend.markers.customHTML) ? e.config.legend.markers.customHTML[l] && (f.innerHTML = e.config.legend.markers.customHTML[l]()) : f.innerHTML = e.config.legend.markers.customHTML()), $b705b473d3ec9641$var$b.setAttrs(f, {
                        rel: l + 1,
                        "data:collapsed": c || d
                    }), (c || d) && f.classList.add("apexcharts-inactive-legend");
                    var L = document.createElement("div"), P = document.createElement("span");
                    P.classList.add("apexcharts-legend-text"), P.innerHTML = Array.isArray(h) ? h.join(" ") : h;
                    var T = e.config.legend.labels.useSeriesColors ? e.globals.colors[l] : e.config.legend.labels.colors;
                    T || (T = e.config.chart.foreColor), P.style.color = T, P.style.fontSize = parseFloat(e.config.legend.fontSize) + "px", P.style.fontWeight = e.config.legend.fontWeight, P.style.fontFamily = i || e.config.chart.fontFamily, $b705b473d3ec9641$var$b.setAttrs(P, {
                        rel: l + 1,
                        i: l,
                        "data:default-text": encodeURIComponent(h),
                        "data:collapsed": c || d
                    }), L.appendChild(f), L.appendChild(P);
                    var M = new $b705b473d3ec9641$var$y(this.ctx);
                    if (!e.config.legend.showForZeroSeries) 0 === M.getSeriesTotalByIndex(l) && M.seriesHaveSameValues(l) && !M.isSeriesNull(l) && -1 === e.globals.collapsedSeriesIndices.indexOf(l) && -1 === e.globals.ancillaryCollapsedSeriesIndices.indexOf(l) && L.classList.add("apexcharts-hidden-zero-series");
                    e.config.legend.showForNullSeries || M.isSeriesNull(l) && -1 === e.globals.collapsedSeriesIndices.indexOf(l) && -1 === e.globals.ancillaryCollapsedSeriesIndices.indexOf(l) && L.classList.add("apexcharts-hidden-null-series"), e.globals.dom.elLegendWrap.appendChild(L), e.globals.dom.elLegendWrap.classList.add("apexcharts-align-".concat(e.config.legend.horizontalAlign)), e.globals.dom.elLegendWrap.classList.add("apx-legend-position-" + e.config.legend.position), L.classList.add("apexcharts-legend-series"), L.style.margin = "".concat(e.config.legend.itemMargin.vertical, "px ").concat(e.config.legend.itemMargin.horizontal, "px"), e.globals.dom.elLegendWrap.style.width = e.config.legend.width ? e.config.legend.width + "px" : "", e.globals.dom.elLegendWrap.style.height = e.config.legend.height ? e.config.legend.height + "px" : "", $b705b473d3ec9641$var$b.setAttrs(L, {
                        rel: l + 1,
                        seriesName: $b705b473d3ec9641$var$p.escapeString(a[l]),
                        "data:collapsed": c || d
                    }), (c || d) && L.classList.add("apexcharts-inactive-legend"), e.config.legend.onItemClick.toggleDataSeries || L.classList.add("apexcharts-no-click");
                }
                e.globals.dom.elWrap.addEventListener("click", t.onLegendClick, !0), e.config.legend.onItemHover.highlightDataSeries && 0 === e.config.legend.customLegendItems.length && (e.globals.dom.elWrap.addEventListener("mousemove", t.onLegendHovered, !0), e.globals.dom.elWrap.addEventListener("mouseout", t.onLegendHovered, !0));
            }
        },
        {
            key: "setLegendWrapXY",
            value: function(t, e) {
                var i = this.w, a = i.globals.dom.baseEl.querySelector(".apexcharts-legend"), s = a.getBoundingClientRect(), r = 0, o = 0;
                if ("bottom" === i.config.legend.position) o += i.globals.svgHeight - s.height / 2;
                else if ("top" === i.config.legend.position) {
                    var n = new $b705b473d3ec9641$var$ot(this.ctx), l = n.dimHelpers.getTitleSubtitleCoords("title").height, h = n.dimHelpers.getTitleSubtitleCoords("subtitle").height;
                    o = o + (l > 0 ? l - 10 : 0) + (h > 0 ? h - 10 : 0);
                }
                a.style.position = "absolute", r = r + t + i.config.legend.offsetX, o = o + e + i.config.legend.offsetY, a.style.left = r + "px", a.style.top = o + "px", "bottom" === i.config.legend.position ? (a.style.top = "auto", a.style.bottom = 5 - i.config.legend.offsetY + "px") : "right" === i.config.legend.position && (a.style.left = "auto", a.style.right = 25 + i.config.legend.offsetX + "px");
                [
                    "width",
                    "height"
                ].forEach(function(t) {
                    a.style[t] && (a.style[t] = parseInt(i.config.legend[t], 10) + "px");
                });
            }
        },
        {
            key: "legendAlignHorizontal",
            value: function() {
                var t = this.w;
                t.globals.dom.baseEl.querySelector(".apexcharts-legend").style.right = 0;
                var e = this.legendHelpers.getLegendBBox(), i = new $b705b473d3ec9641$var$ot(this.ctx), a = i.dimHelpers.getTitleSubtitleCoords("title"), s = i.dimHelpers.getTitleSubtitleCoords("subtitle"), r = 0;
                "bottom" === t.config.legend.position ? r = -e.clwh / 1.8 : "top" === t.config.legend.position && (r = a.height + s.height + t.config.title.margin + t.config.subtitle.margin - 10), this.setLegendWrapXY(20, r);
            }
        },
        {
            key: "legendAlignVertical",
            value: function() {
                var t = this.w, e = this.legendHelpers.getLegendBBox(), i = 0;
                "left" === t.config.legend.position && (i = 20), "right" === t.config.legend.position && (i = t.globals.svgWidth - e.clww - 10), this.setLegendWrapXY(i, 20);
            }
        },
        {
            key: "onLegendHovered",
            value: function(t) {
                var e = this.w, i = t.target.classList.contains("apexcharts-legend-text") || t.target.classList.contains("apexcharts-legend-marker");
                if ("heatmap" === e.config.chart.type || this.isBarsDistributed) {
                    if (i) {
                        var a = parseInt(t.target.getAttribute("rel"), 10) - 1;
                        this.ctx.events.fireEvent("legendHover", [
                            this.ctx,
                            a,
                            this.w
                        ]), new $b705b473d3ec9641$var$z(this.ctx).highlightRangeInSeries(t, t.target);
                    }
                } else !t.target.classList.contains("apexcharts-inactive-legend") && i && new $b705b473d3ec9641$var$z(this.ctx).toggleSeriesOnHover(t, t.target);
            }
        },
        {
            key: "onLegendClick",
            value: function(t) {
                var e = this.w;
                if (!e.config.legend.customLegendItems.length && (t.target.classList.contains("apexcharts-legend-text") || t.target.classList.contains("apexcharts-legend-marker"))) {
                    var i = parseInt(t.target.getAttribute("rel"), 10) - 1, a = "true" === t.target.getAttribute("data:collapsed"), s = this.w.config.chart.events.legendClick;
                    "function" == typeof s && s(this.ctx, i, this.w), this.ctx.events.fireEvent("legendClick", [
                        this.ctx,
                        i,
                        this.w
                    ]);
                    var r = this.w.config.legend.markers.onClick;
                    "function" == typeof r && t.target.classList.contains("apexcharts-legend-marker") && (r(this.ctx, i, this.w), this.ctx.events.fireEvent("legendMarkerClick", [
                        this.ctx,
                        i,
                        this.w
                    ])), "treemap" !== e.config.chart.type && "heatmap" !== e.config.chart.type && !this.isBarsDistributed && e.config.legend.onItemClick.toggleDataSeries && this.legendHelpers.toggleDataSeries(i, a);
                }
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$ht = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.ctx = e, this.w = e.w;
        var i = this.w;
        this.ev = this.w.config.chart.events, this.selectedClass = "apexcharts-selected", this.localeValues = this.w.globals.locale.toolbar, this.minX = i.globals.minX, this.maxX = i.globals.maxX;
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "createToolbar",
            value: function() {
                var t = this, e = this.w, i = function() {
                    return document.createElement("div");
                }, a = i();
                if (a.setAttribute("class", "apexcharts-toolbar"), a.style.top = e.config.chart.toolbar.offsetY + "px", a.style.right = 3 - e.config.chart.toolbar.offsetX + "px", e.globals.dom.elWrap.appendChild(a), this.elZoom = i(), this.elZoomIn = i(), this.elZoomOut = i(), this.elPan = i(), this.elSelection = i(), this.elZoomReset = i(), this.elMenuIcon = i(), this.elMenu = i(), this.elCustomIcons = [], this.t = e.config.chart.toolbar.tools, Array.isArray(this.t.customIcons)) for(var s = 0; s < this.t.customIcons.length; s++)this.elCustomIcons.push(i());
                var r = [], o = function(i, a, s) {
                    var o = i.toLowerCase();
                    t.t[o] && e.config.chart.zoom.enabled && r.push({
                        el: a,
                        icon: "string" == typeof t.t[o] ? t.t[o] : s,
                        title: t.localeValues[i],
                        class: "apexcharts-".concat(o, "-icon")
                    });
                };
                o("zoomIn", this.elZoomIn, '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">\n    <path d="M0 0h24v24H0z" fill="none"/>\n    <path d="M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>\n</svg>\n'), o("zoomOut", this.elZoomOut, '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">\n    <path d="M0 0h24v24H0z" fill="none"/>\n    <path d="M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>\n</svg>\n');
                var n = function(i) {
                    t.t[i] && e.config.chart[i].enabled && r.push({
                        el: "zoom" === i ? t.elZoom : t.elSelection,
                        icon: "string" == typeof t.t[i] ? t.t[i] : "zoom" === i ? '<svg xmlns="http://www.w3.org/2000/svg" fill="#000000" height="24" viewBox="0 0 24 24" width="24">\n    <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>\n    <path d="M0 0h24v24H0V0z" fill="none"/>\n    <path d="M12 10h-2v2H9v-2H7V9h2V7h1v2h2v1z"/>\n</svg>' : '<svg fill="#6E8192" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M0 0h24v24H0z" fill="none"/>\n    <path d="M3 5h2V3c-1.1 0-2 .9-2 2zm0 8h2v-2H3v2zm4 8h2v-2H7v2zM3 9h2V7H3v2zm10-6h-2v2h2V3zm6 0v2h2c0-1.1-.9-2-2-2zM5 21v-2H3c0 1.1.9 2 2 2zm-2-4h2v-2H3v2zM9 3H7v2h2V3zm2 18h2v-2h-2v2zm8-8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zm0-12h2V7h-2v2zm0 8h2v-2h-2v2zm-4 4h2v-2h-2v2zm0-16h2V3h-2v2z"/>\n</svg>',
                        title: t.localeValues["zoom" === i ? "selectionZoom" : "selection"],
                        class: e.globals.isTouchDevice ? "apexcharts-element-hidden" : "apexcharts-".concat(i, "-icon")
                    });
                };
                n("zoom"), n("selection"), this.t.pan && e.config.chart.zoom.enabled && r.push({
                    el: this.elPan,
                    icon: "string" == typeof this.t.pan ? this.t.pan : '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" height="24" viewBox="0 0 24 24" width="24">\n    <defs>\n        <path d="M0 0h24v24H0z" id="a"/>\n    </defs>\n    <clipPath id="b">\n        <use overflow="visible" xlink:href="#a"/>\n    </clipPath>\n    <path clip-path="url(#b)" d="M23 5.5V20c0 2.2-1.8 4-4 4h-7.3c-1.08 0-2.1-.43-2.85-1.19L1 14.83s1.26-1.23 1.3-1.25c.22-.19.49-.29.79-.29.22 0 .42.06.6.16.04.01 4.31 2.46 4.31 2.46V4c0-.83.67-1.5 1.5-1.5S11 3.17 11 4v7h1V1.5c0-.83.67-1.5 1.5-1.5S15 .67 15 1.5V11h1V2.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V11h1V5.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5z"/>\n</svg>',
                    title: this.localeValues.pan,
                    class: e.globals.isTouchDevice ? "apexcharts-element-hidden" : "apexcharts-pan-icon"
                }), o("reset", this.elZoomReset, '<svg fill="#000000" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">\n    <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>\n    <path d="M0 0h24v24H0z" fill="none"/>\n</svg>'), this.t.download && r.push({
                    el: this.elMenuIcon,
                    icon: "string" == typeof this.t.download ? this.t.download : '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="none" d="M0 0h24v24H0V0z"/><path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"/></svg>',
                    title: this.localeValues.menu,
                    class: "apexcharts-menu-icon"
                });
                for(var l = 0; l < this.elCustomIcons.length; l++)r.push({
                    el: this.elCustomIcons[l],
                    icon: this.t.customIcons[l].icon,
                    title: this.t.customIcons[l].title,
                    index: this.t.customIcons[l].index,
                    class: "apexcharts-toolbar-custom-icon " + this.t.customIcons[l].class
                });
                r.forEach(function(t, e) {
                    t.index && $b705b473d3ec9641$var$p.moveIndexInArray(r, e, t.index);
                });
                for(var h = 0; h < r.length; h++)$b705b473d3ec9641$var$b.setAttrs(r[h].el, {
                    class: r[h].class,
                    title: r[h].title
                }), r[h].el.innerHTML = r[h].icon, a.appendChild(r[h].el);
                this._createHamburgerMenu(a), e.globals.zoomEnabled ? this.elZoom.classList.add(this.selectedClass) : e.globals.panEnabled ? this.elPan.classList.add(this.selectedClass) : e.globals.selectionEnabled && this.elSelection.classList.add(this.selectedClass), this.addToolbarEventListeners();
            }
        },
        {
            key: "_createHamburgerMenu",
            value: function(t) {
                this.elMenuItems = [], t.appendChild(this.elMenu), $b705b473d3ec9641$var$b.setAttrs(this.elMenu, {
                    class: "apexcharts-menu"
                });
                var e = [
                    {
                        name: "exportSVG",
                        title: this.localeValues.exportToSVG
                    },
                    {
                        name: "exportPNG",
                        title: this.localeValues.exportToPNG
                    },
                    {
                        name: "exportCSV",
                        title: this.localeValues.exportToCSV
                    }
                ];
                this.w.globals.allSeriesHasEqualX || e.splice(2, 1);
                for(var i = 0; i < e.length; i++)this.elMenuItems.push(document.createElement("div")), this.elMenuItems[i].innerHTML = e[i].title, $b705b473d3ec9641$var$b.setAttrs(this.elMenuItems[i], {
                    class: "apexcharts-menu-item ".concat(e[i].name),
                    title: e[i].title
                }), this.elMenu.appendChild(this.elMenuItems[i]);
            }
        },
        {
            key: "addToolbarEventListeners",
            value: function() {
                var t = this;
                this.elZoomReset.addEventListener("click", this.handleZoomReset.bind(this)), this.elSelection.addEventListener("click", this.toggleZoomSelection.bind(this, "selection")), this.elZoom.addEventListener("click", this.toggleZoomSelection.bind(this, "zoom")), this.elZoomIn.addEventListener("click", this.handleZoomIn.bind(this)), this.elZoomOut.addEventListener("click", this.handleZoomOut.bind(this)), this.elPan.addEventListener("click", this.togglePanning.bind(this)), this.elMenuIcon.addEventListener("click", this.toggleMenu.bind(this)), this.elMenuItems.forEach(function(e) {
                    e.classList.contains("exportSVG") ? e.addEventListener("click", t.handleDownload.bind(t, "svg")) : e.classList.contains("exportPNG") ? e.addEventListener("click", t.handleDownload.bind(t, "png")) : e.classList.contains("exportCSV") && e.addEventListener("click", t.handleDownload.bind(t, "csv"));
                });
                for(var e = 0; e < this.t.customIcons.length; e++)this.elCustomIcons[e].addEventListener("click", this.t.customIcons[e].click.bind(this, this.ctx, this.ctx.w));
            }
        },
        {
            key: "toggleZoomSelection",
            value: function(t) {
                this.ctx.getSyncedCharts().forEach(function(e) {
                    e.ctx.toolbar.toggleOtherControls();
                    var i = "selection" === t ? e.ctx.toolbar.elSelection : e.ctx.toolbar.elZoom, a = "selection" === t ? "selectionEnabled" : "zoomEnabled";
                    e.w.globals[a] = !e.w.globals[a], i.classList.contains(e.ctx.toolbar.selectedClass) ? i.classList.remove(e.ctx.toolbar.selectedClass) : i.classList.add(e.ctx.toolbar.selectedClass);
                });
            }
        },
        {
            key: "getToolbarIconsReference",
            value: function() {
                var t = this.w;
                this.elZoom || (this.elZoom = t.globals.dom.baseEl.querySelector(".apexcharts-zoom-icon")), this.elPan || (this.elPan = t.globals.dom.baseEl.querySelector(".apexcharts-pan-icon")), this.elSelection || (this.elSelection = t.globals.dom.baseEl.querySelector(".apexcharts-selection-icon"));
            }
        },
        {
            key: "enableZoomPanFromToolbar",
            value: function(t) {
                this.toggleOtherControls(), "pan" === t ? this.w.globals.panEnabled = !0 : this.w.globals.zoomEnabled = !0;
                var e = "pan" === t ? this.elPan : this.elZoom, i = "pan" === t ? this.elZoom : this.elPan;
                e && e.classList.add(this.selectedClass), i && i.classList.remove(this.selectedClass);
            }
        },
        {
            key: "togglePanning",
            value: function() {
                this.ctx.getSyncedCharts().forEach(function(t) {
                    t.ctx.toolbar.toggleOtherControls(), t.w.globals.panEnabled = !t.w.globals.panEnabled, t.ctx.toolbar.elPan.classList.contains(t.ctx.toolbar.selectedClass) ? t.ctx.toolbar.elPan.classList.remove(t.ctx.toolbar.selectedClass) : t.ctx.toolbar.elPan.classList.add(t.ctx.toolbar.selectedClass);
                });
            }
        },
        {
            key: "toggleOtherControls",
            value: function() {
                var t = this, e = this.w;
                e.globals.panEnabled = !1, e.globals.zoomEnabled = !1, e.globals.selectionEnabled = !1, this.getToolbarIconsReference(), [
                    this.elPan,
                    this.elSelection,
                    this.elZoom
                ].forEach(function(e) {
                    e && e.classList.remove(t.selectedClass);
                });
            }
        },
        {
            key: "handleZoomIn",
            value: function() {
                var t = this.w;
                t.globals.isRangeBar && (this.minX = t.globals.minY, this.maxX = t.globals.maxY);
                var e = (this.minX + this.maxX) / 2, i = (this.minX + e) / 2, a = (this.maxX + e) / 2, s = this._getNewMinXMaxX(i, a);
                t.globals.disableZoomIn || this.zoomUpdateOptions(s.minX, s.maxX);
            }
        },
        {
            key: "handleZoomOut",
            value: function() {
                var t = this.w;
                if (t.globals.isRangeBar && (this.minX = t.globals.minY, this.maxX = t.globals.maxY), !("datetime" === t.config.xaxis.type && new Date(this.minX).getUTCFullYear() < 1e3)) {
                    var e = (this.minX + this.maxX) / 2, i = this.minX - (e - this.minX), a = this.maxX - (e - this.maxX), s = this._getNewMinXMaxX(i, a);
                    t.globals.disableZoomOut || this.zoomUpdateOptions(s.minX, s.maxX);
                }
            }
        },
        {
            key: "_getNewMinXMaxX",
            value: function(t, e) {
                var i = this.w.config.xaxis.convertedCatToNumeric;
                return {
                    minX: i ? Math.floor(t) : t,
                    maxX: i ? Math.floor(e) : e
                };
            }
        },
        {
            key: "zoomUpdateOptions",
            value: function(t, e) {
                var i = this.w;
                if (void 0 !== t || void 0 !== e) {
                    if (!(i.config.xaxis.convertedCatToNumeric && (t < 1 && (t = 1, e = i.globals.dataPoints), e - t < 2))) {
                        var a = {
                            min: t,
                            max: e
                        }, s = this.getBeforeZoomRange(a);
                        s && (a = s.xaxis);
                        var r = {
                            xaxis: a
                        }, o = $b705b473d3ec9641$var$p.clone(i.globals.initialConfig.yaxis);
                        if (i.config.chart.zoom.autoScaleYaxis) o = new $b705b473d3ec9641$var$j(this.ctx).autoScaleY(this.ctx, o, {
                            xaxis: a
                        });
                        i.config.chart.group || (r.yaxis = o), this.w.globals.zoomed = !0, this.ctx.updateHelpers._updateOptions(r, !1, this.w.config.chart.animations.dynamicAnimation.enabled), this.zoomCallback(a, o);
                    }
                } else this.handleZoomReset();
            }
        },
        {
            key: "zoomCallback",
            value: function(t, e) {
                "function" == typeof this.ev.zoomed && this.ev.zoomed(this.ctx, {
                    xaxis: t,
                    yaxis: e
                });
            }
        },
        {
            key: "getBeforeZoomRange",
            value: function(t, e) {
                var i = null;
                return "function" == typeof this.ev.beforeZoom && (i = this.ev.beforeZoom(this, {
                    xaxis: t,
                    yaxis: e
                })), i;
            }
        },
        {
            key: "toggleMenu",
            value: function() {
                var t = this;
                window.setTimeout(function() {
                    t.elMenu.classList.contains("apexcharts-menu-open") ? t.elMenu.classList.remove("apexcharts-menu-open") : t.elMenu.classList.add("apexcharts-menu-open");
                }, 0);
            }
        },
        {
            key: "handleDownload",
            value: function(t) {
                var e = this.w, i = new $b705b473d3ec9641$var$V(this.ctx);
                switch(t){
                    case "svg":
                        i.exportToSVG(this.ctx);
                        break;
                    case "png":
                        i.exportToPng(this.ctx);
                        break;
                    case "csv":
                        i.exportToCSV({
                            series: e.config.series,
                            columnDelimiter: e.config.chart.toolbar.export.csv.columnDelimiter
                        });
                }
            }
        },
        {
            key: "handleZoomReset",
            value: function(t) {
                this.ctx.getSyncedCharts().forEach(function(t) {
                    var e = t.w;
                    if (e.globals.lastXAxis.min = void 0, e.globals.lastXAxis.max = void 0, t.updateHelpers.revertDefaultAxisMinMax(), "function" == typeof e.config.chart.events.beforeResetZoom) {
                        var i = e.config.chart.events.beforeResetZoom(t, e);
                        i && t.updateHelpers.revertDefaultAxisMinMax(i);
                    }
                    "function" == typeof e.config.chart.events.zoomed && t.ctx.toolbar.zoomCallback({
                        min: e.config.xaxis.min,
                        max: e.config.xaxis.max
                    }), e.globals.zoomed = !1;
                    var a = t.ctx.series.emptyCollapsedSeries($b705b473d3ec9641$var$p.clone(e.globals.initialSeries));
                    t.updateHelpers._updateSeries(a, e.config.chart.animations.dynamicAnimation.enabled);
                });
            }
        },
        {
            key: "destroy",
            value: function() {
                this.elZoom = null, this.elZoomIn = null, this.elZoomOut = null, this.elPan = null, this.elSelection = null, this.elZoomReset = null, this.elMenuIcon = null;
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$ct = function(t) {
    $b705b473d3ec9641$var$n(i, $b705b473d3ec9641$var$ht);
    var e = $b705b473d3ec9641$var$d(i);
    function i(t) {
        var s;
        return $b705b473d3ec9641$var$a(this, i), (s = e.call(this, t)).ctx = t, s.w = t.w, s.dragged = !1, s.graphics = new $b705b473d3ec9641$var$b(s.ctx), s.eventList = [
            "mousedown",
            "mouseleave",
            "mousemove",
            "touchstart",
            "touchmove",
            "mouseup",
            "touchend"
        ], s.clientX = 0, s.clientY = 0, s.startX = 0, s.endX = 0, s.dragX = 0, s.startY = 0, s.endY = 0, s.dragY = 0, s.moveDirection = "none", s;
    }
    return $b705b473d3ec9641$var$r(i, [
        {
            key: "init",
            value: function(t) {
                var e = this, i = t.xyRatios, a = this.w, s = this;
                this.xyRatios = i, this.zoomRect = this.graphics.drawRect(0, 0, 0, 0), this.selectionRect = this.graphics.drawRect(0, 0, 0, 0), this.gridRect = a.globals.dom.baseEl.querySelector(".apexcharts-grid"), this.zoomRect.node.classList.add("apexcharts-zoom-rect"), this.selectionRect.node.classList.add("apexcharts-selection-rect"), a.globals.dom.elGraphical.add(this.zoomRect), a.globals.dom.elGraphical.add(this.selectionRect), "x" === a.config.chart.selection.type ? this.slDraggableRect = this.selectionRect.draggable({
                    minX: 0,
                    minY: 0,
                    maxX: a.globals.gridWidth,
                    maxY: a.globals.gridHeight
                }).on("dragmove", this.selectionDragging.bind(this, "dragging")) : "y" === a.config.chart.selection.type ? this.slDraggableRect = this.selectionRect.draggable({
                    minX: 0,
                    maxX: a.globals.gridWidth
                }).on("dragmove", this.selectionDragging.bind(this, "dragging")) : this.slDraggableRect = this.selectionRect.draggable().on("dragmove", this.selectionDragging.bind(this, "dragging")), this.preselectedSelection(), this.hoverArea = a.globals.dom.baseEl.querySelector("".concat(a.globals.chartClass, " .apexcharts-svg")), this.hoverArea.classList.add("apexcharts-zoomable"), this.eventList.forEach(function(t) {
                    e.hoverArea.addEventListener(t, s.svgMouseEvents.bind(s, i), {
                        capture: !1,
                        passive: !0
                    });
                });
            }
        },
        {
            key: "destroy",
            value: function() {
                this.slDraggableRect && (this.slDraggableRect.draggable(!1), this.slDraggableRect.off(), this.selectionRect.off()), this.selectionRect = null, this.zoomRect = null, this.gridRect = null;
            }
        },
        {
            key: "svgMouseEvents",
            value: function(t, e) {
                var i = this.w, a = this, s = this.ctx.toolbar, r = i.globals.zoomEnabled ? i.config.chart.zoom.type : i.config.chart.selection.type, o = i.config.chart.toolbar.autoSelected;
                if (e.shiftKey ? (this.shiftWasPressed = !0, s.enableZoomPanFromToolbar("pan" === o ? "zoom" : "pan")) : this.shiftWasPressed && (s.enableZoomPanFromToolbar(o), this.shiftWasPressed = !1), e.target) {
                    var n, l = e.target.classList;
                    if (e.target.parentNode && null !== e.target.parentNode && (n = e.target.parentNode.classList), !(l.contains("apexcharts-selection-rect") || l.contains("apexcharts-legend-marker") || l.contains("apexcharts-legend-text") || n && n.contains("apexcharts-toolbar"))) {
                        if (a.clientX = "touchmove" === e.type || "touchstart" === e.type ? e.touches[0].clientX : "touchend" === e.type ? e.changedTouches[0].clientX : e.clientX, a.clientY = "touchmove" === e.type || "touchstart" === e.type ? e.touches[0].clientY : "touchend" === e.type ? e.changedTouches[0].clientY : e.clientY, "mousedown" === e.type && 1 === e.which) {
                            var h = a.gridRect.getBoundingClientRect();
                            a.startX = a.clientX - h.left, a.startY = a.clientY - h.top, a.dragged = !1, a.w.globals.mousedown = !0;
                        }
                        if (("mousemove" === e.type && 1 === e.which || "touchmove" === e.type) && (a.dragged = !0, i.globals.panEnabled ? (i.globals.selection = null, a.w.globals.mousedown && a.panDragging({
                            context: a,
                            zoomtype: r,
                            xyRatios: t
                        })) : (a.w.globals.mousedown && i.globals.zoomEnabled || a.w.globals.mousedown && i.globals.selectionEnabled) && (a.selection = a.selectionDrawing({
                            context: a,
                            zoomtype: r
                        }))), "mouseup" === e.type || "touchend" === e.type || "mouseleave" === e.type) {
                            var c = a.gridRect.getBoundingClientRect();
                            a.w.globals.mousedown && (a.endX = a.clientX - c.left, a.endY = a.clientY - c.top, a.dragX = Math.abs(a.endX - a.startX), a.dragY = Math.abs(a.endY - a.startY), (i.globals.zoomEnabled || i.globals.selectionEnabled) && a.selectionDrawn({
                                context: a,
                                zoomtype: r
                            }), i.globals.panEnabled && i.config.xaxis.convertedCatToNumeric && a.delayedPanScrolled()), i.globals.zoomEnabled && a.hideSelectionRect(this.selectionRect), a.dragged = !1, a.w.globals.mousedown = !1;
                        }
                        this.makeSelectionRectDraggable();
                    }
                }
            }
        },
        {
            key: "makeSelectionRectDraggable",
            value: function() {
                var t = this.w;
                if (this.selectionRect) {
                    var e = this.selectionRect.node.getBoundingClientRect();
                    e.width > 0 && e.height > 0 && this.slDraggableRect.selectize({
                        points: "l, r",
                        pointSize: 8,
                        pointType: "rect"
                    }).resize({
                        constraint: {
                            minX: 0,
                            minY: 0,
                            maxX: t.globals.gridWidth,
                            maxY: t.globals.gridHeight
                        }
                    }).on("resizing", this.selectionDragging.bind(this, "resizing"));
                }
            }
        },
        {
            key: "preselectedSelection",
            value: function() {
                var t = this.w, e = this.xyRatios;
                if (!t.globals.zoomEnabled) {
                    if (void 0 !== t.globals.selection && null !== t.globals.selection) this.drawSelectionRect(t.globals.selection);
                    else if (void 0 !== t.config.chart.selection.xaxis.min && void 0 !== t.config.chart.selection.xaxis.max) {
                        var i = (t.config.chart.selection.xaxis.min - t.globals.minX) / e.xRatio, a = {
                            x: i,
                            y: 0,
                            width: t.globals.gridWidth - (t.globals.maxX - t.config.chart.selection.xaxis.max) / e.xRatio - i,
                            height: t.globals.gridHeight,
                            translateX: 0,
                            translateY: 0,
                            selectionEnabled: !0
                        };
                        this.drawSelectionRect(a), this.makeSelectionRectDraggable(), "function" == typeof t.config.chart.events.selection && t.config.chart.events.selection(this.ctx, {
                            xaxis: {
                                min: t.config.chart.selection.xaxis.min,
                                max: t.config.chart.selection.xaxis.max
                            },
                            yaxis: {}
                        });
                    }
                }
            }
        },
        {
            key: "drawSelectionRect",
            value: function(t) {
                var e = t.x, i = t.y, a = t.width, s = t.height, r = t.translateX, o = void 0 === r ? 0 : r, n = t.translateY, l = void 0 === n ? 0 : n, h = this.w, c = this.zoomRect, d = this.selectionRect;
                if (this.dragged || null !== h.globals.selection) {
                    var g = {
                        transform: "translate(" + o + ", " + l + ")"
                    };
                    h.globals.zoomEnabled && this.dragged && (a < 0 && (a = 1), c.attr({
                        x: e,
                        y: i,
                        width: a,
                        height: s,
                        fill: h.config.chart.zoom.zoomedArea.fill.color,
                        "fill-opacity": h.config.chart.zoom.zoomedArea.fill.opacity,
                        stroke: h.config.chart.zoom.zoomedArea.stroke.color,
                        "stroke-width": h.config.chart.zoom.zoomedArea.stroke.width,
                        "stroke-opacity": h.config.chart.zoom.zoomedArea.stroke.opacity
                    }), $b705b473d3ec9641$var$b.setAttrs(c.node, g)), h.globals.selectionEnabled && (d.attr({
                        x: e,
                        y: i,
                        width: a > 0 ? a : 0,
                        height: s > 0 ? s : 0,
                        fill: h.config.chart.selection.fill.color,
                        "fill-opacity": h.config.chart.selection.fill.opacity,
                        stroke: h.config.chart.selection.stroke.color,
                        "stroke-width": h.config.chart.selection.stroke.width,
                        "stroke-dasharray": h.config.chart.selection.stroke.dashArray,
                        "stroke-opacity": h.config.chart.selection.stroke.opacity
                    }), $b705b473d3ec9641$var$b.setAttrs(d.node, g));
                }
            }
        },
        {
            key: "hideSelectionRect",
            value: function(t) {
                t && t.attr({
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                });
            }
        },
        {
            key: "selectionDrawing",
            value: function(t) {
                var e = t.context, i = t.zoomtype, a = this.w, s = e, r = this.gridRect.getBoundingClientRect(), o = s.startX - 1, n = s.startY, l = !1, h = !1, c = s.clientX - r.left - o, d = s.clientY - r.top - n, g = {};
                return Math.abs(c + o) > a.globals.gridWidth ? c = a.globals.gridWidth - o : s.clientX - r.left < 0 && (c = o), o > s.clientX - r.left && (l = !0, c = Math.abs(c)), n > s.clientY - r.top && (h = !0, d = Math.abs(d)), g = "x" === i ? {
                    x: l ? o - c : o,
                    y: 0,
                    width: c,
                    height: a.globals.gridHeight
                } : "y" === i ? {
                    x: 0,
                    y: h ? n - d : n,
                    width: a.globals.gridWidth,
                    height: d
                } : {
                    x: l ? o - c : o,
                    y: h ? n - d : n,
                    width: c,
                    height: d
                }, s.drawSelectionRect(g), s.selectionDragging("resizing"), g;
            }
        },
        {
            key: "selectionDragging",
            value: function(t, e) {
                var i = this, a = this.w, s = this.xyRatios, r = this.selectionRect, o = 0;
                "resizing" === t && (o = 30);
                var n = function(t) {
                    return parseFloat(r.node.getAttribute(t));
                }, l = {
                    x: n("x"),
                    y: n("y"),
                    width: n("width"),
                    height: n("height")
                };
                a.globals.selection = l, "function" == typeof a.config.chart.events.selection && a.globals.selectionEnabled && (clearTimeout(this.w.globals.selectionResizeTimer), this.w.globals.selectionResizeTimer = window.setTimeout(function() {
                    var t = i.gridRect.getBoundingClientRect(), e = r.node.getBoundingClientRect(), o = {
                        xaxis: {
                            min: a.globals.xAxisScale.niceMin + (e.left - t.left) * s.xRatio,
                            max: a.globals.xAxisScale.niceMin + (e.right - t.left) * s.xRatio
                        },
                        yaxis: {
                            min: a.globals.yAxisScale[0].niceMin + (t.bottom - e.bottom) * s.yRatio[0],
                            max: a.globals.yAxisScale[0].niceMax - (e.top - t.top) * s.yRatio[0]
                        }
                    };
                    a.config.chart.events.selection(i.ctx, o), a.config.chart.brush.enabled && void 0 !== a.config.chart.events.brushScrolled && a.config.chart.events.brushScrolled(i.ctx, o);
                }, o));
            }
        },
        {
            key: "selectionDrawn",
            value: function(t) {
                var e = t.context, i = t.zoomtype, a = this.w, s = e, r = this.xyRatios, o = this.ctx.toolbar;
                if (s.startX > s.endX) {
                    var n = s.startX;
                    s.startX = s.endX, s.endX = n;
                }
                if (s.startY > s.endY) {
                    var l = s.startY;
                    s.startY = s.endY, s.endY = l;
                }
                var h = void 0, c = void 0;
                a.globals.isRangeBar ? (h = a.globals.yAxisScale[0].niceMin + s.startX * r.invertedYRatio, c = a.globals.yAxisScale[0].niceMin + s.endX * r.invertedYRatio) : (h = a.globals.xAxisScale.niceMin + s.startX * r.xRatio, c = a.globals.xAxisScale.niceMin + s.endX * r.xRatio);
                var d = [], g = [];
                if (a.config.yaxis.forEach(function(t, e) {
                    d.push(a.globals.yAxisScale[e].niceMax - r.yRatio[e] * s.startY), g.push(a.globals.yAxisScale[e].niceMax - r.yRatio[e] * s.endY);
                }), s.dragged && (s.dragX > 10 || s.dragY > 10) && h !== c) {
                    if (a.globals.zoomEnabled) {
                        var u = $b705b473d3ec9641$var$p.clone(a.globals.initialConfig.yaxis), f = $b705b473d3ec9641$var$p.clone(a.globals.initialConfig.xaxis);
                        if (a.globals.zoomed = !0, a.config.xaxis.convertedCatToNumeric && (h = Math.floor(h), c = Math.floor(c), h < 1 && (h = 1, c = a.globals.dataPoints), c - h < 2 && (c = h + 1)), "xy" !== i && "x" !== i || (f = {
                            min: h,
                            max: c
                        }), "xy" !== i && "y" !== i || u.forEach(function(t, e) {
                            u[e].min = g[e], u[e].max = d[e];
                        }), a.config.chart.zoom.autoScaleYaxis) {
                            var x = new $b705b473d3ec9641$var$j(s.ctx);
                            u = x.autoScaleY(s.ctx, u, {
                                xaxis: f
                            });
                        }
                        if (o) {
                            var b = o.getBeforeZoomRange(f, u);
                            b && (f = b.xaxis ? b.xaxis : f, u = b.yaxis ? b.yaxis : u);
                        }
                        var v = {
                            xaxis: f
                        };
                        a.config.chart.group || (v.yaxis = u), s.ctx.updateHelpers._updateOptions(v, !1, s.w.config.chart.animations.dynamicAnimation.enabled), "function" == typeof a.config.chart.events.zoomed && o.zoomCallback(f, u);
                    } else if (a.globals.selectionEnabled) {
                        var m, y = null;
                        m = {
                            min: h,
                            max: c
                        }, "xy" !== i && "y" !== i || (y = $b705b473d3ec9641$var$p.clone(a.config.yaxis)).forEach(function(t, e) {
                            y[e].min = g[e], y[e].max = d[e];
                        }), a.globals.selection = s.selection, "function" == typeof a.config.chart.events.selection && a.config.chart.events.selection(s.ctx, {
                            xaxis: m,
                            yaxis: y
                        });
                    }
                }
            }
        },
        {
            key: "panDragging",
            value: function(t) {
                var e = t.context, i = this.w, a = e;
                if (void 0 !== i.globals.lastClientPosition.x) {
                    var s = i.globals.lastClientPosition.x - a.clientX, r = i.globals.lastClientPosition.y - a.clientY;
                    Math.abs(s) > Math.abs(r) && s > 0 ? this.moveDirection = "left" : Math.abs(s) > Math.abs(r) && s < 0 ? this.moveDirection = "right" : Math.abs(r) > Math.abs(s) && r > 0 ? this.moveDirection = "up" : Math.abs(r) > Math.abs(s) && r < 0 && (this.moveDirection = "down");
                }
                i.globals.lastClientPosition = {
                    x: a.clientX,
                    y: a.clientY
                };
                var o = i.globals.isRangeBar ? i.globals.minY : i.globals.minX, n = i.globals.isRangeBar ? i.globals.maxY : i.globals.maxX;
                i.config.xaxis.convertedCatToNumeric || a.panScrolled(o, n);
            }
        },
        {
            key: "delayedPanScrolled",
            value: function() {
                var t = this.w, e = t.globals.minX, i = t.globals.maxX, a = (t.globals.maxX - t.globals.minX) / 2;
                "left" === this.moveDirection ? (e = t.globals.minX + a, i = t.globals.maxX + a) : "right" === this.moveDirection && (e = t.globals.minX - a, i = t.globals.maxX - a), e = Math.floor(e), i = Math.floor(i), this.updateScrolledChart({
                    xaxis: {
                        min: e,
                        max: i
                    }
                }, e, i);
            }
        },
        {
            key: "panScrolled",
            value: function(t, e) {
                var i = this.w, a = this.xyRatios, s = $b705b473d3ec9641$var$p.clone(i.globals.initialConfig.yaxis), r = a.xRatio, o = i.globals.minX, n = i.globals.maxX;
                i.globals.isRangeBar && (r = a.invertedYRatio, o = i.globals.minY, n = i.globals.maxY), "left" === this.moveDirection ? (t = o + i.globals.gridWidth / 15 * r, e = n + i.globals.gridWidth / 15 * r) : "right" === this.moveDirection && (t = o - i.globals.gridWidth / 15 * r, e = n - i.globals.gridWidth / 15 * r), i.globals.isRangeBar || (t < i.globals.initialMinX || e > i.globals.initialMaxX) && (t = o, e = n);
                var l = {
                    min: t,
                    max: e
                };
                i.config.chart.zoom.autoScaleYaxis && (s = new $b705b473d3ec9641$var$j(this.ctx).autoScaleY(this.ctx, s, {
                    xaxis: l
                }));
                var h = {
                    xaxis: {
                        min: t,
                        max: e
                    }
                };
                i.config.chart.group || (h.yaxis = s), this.updateScrolledChart(h, t, e);
            }
        },
        {
            key: "updateScrolledChart",
            value: function(t, e, i) {
                var a = this.w;
                this.ctx.updateHelpers._updateOptions(t, !1, !1), "function" == typeof a.config.chart.events.scrolled && a.config.chart.events.scrolled(this.ctx, {
                    xaxis: {
                        min: e,
                        max: i
                    }
                });
            }
        }
    ]), i;
}(), $b705b473d3ec9641$var$dt = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.w = e.w, this.ttCtx = e, this.ctx = e.ctx;
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "getNearestValues",
            value: function(t) {
                var e = t.hoverArea, i = t.elGrid, a = t.clientX, s = t.clientY, r = this.w, o = i.getBoundingClientRect(), n = o.width, l = o.height, h = n / (r.globals.dataPoints - 1), c = l / r.globals.dataPoints, d = this.hasBars();
                !r.globals.comboCharts && !d || r.config.xaxis.convertedCatToNumeric || (h = n / r.globals.dataPoints);
                var g = a - o.left - r.globals.barPadForNumericAxis, u = s - o.top;
                g < 0 || u < 0 || g > n || u > l ? (e.classList.remove("hovering-zoom"), e.classList.remove("hovering-pan")) : r.globals.zoomEnabled ? (e.classList.remove("hovering-pan"), e.classList.add("hovering-zoom")) : r.globals.panEnabled && (e.classList.remove("hovering-zoom"), e.classList.add("hovering-pan"));
                var f = Math.round(g / h), x = Math.floor(u / c);
                d && !r.config.xaxis.convertedCatToNumeric && (f = Math.ceil(g / h), f -= 1);
                for(var b, v = null, m = null, y = [], w = 0; w < r.globals.seriesXvalues.length; w++)y.push([
                    r.globals.seriesXvalues[w][0] - 1e-6
                ].concat(r.globals.seriesXvalues[w]));
                if (y = y.map(function(t) {
                    return t.filter(function(t) {
                        return t;
                    });
                }), b = r.globals.seriesYvalues.map(function(t) {
                    return t.filter(function(t) {
                        return $b705b473d3ec9641$var$p.isNumber(t);
                    });
                }), r.globals.isXNumeric) {
                    var k = this.ttCtx.getElGrid().getBoundingClientRect(), A = g * (k.width / n), S = u * (k.height / l);
                    v = (m = this.closestInMultiArray(A, S, y, b)).index, f = m.j, null !== v && (y = r.globals.seriesXvalues[v], f = (m = this.closestInArray(A, y)).index);
                }
                return r.globals.capturedSeriesIndex = null === v ? -1 : v, (!f || f < 1) && (f = 0), r.globals.isBarHorizontal ? r.globals.capturedDataPointIndex = x : r.globals.capturedDataPointIndex = f, {
                    capturedSeries: v,
                    j: r.globals.isBarHorizontal ? x : f,
                    hoverX: g,
                    hoverY: u
                };
            }
        },
        {
            key: "closestInMultiArray",
            value: function(t, e, i, a) {
                var s = this.w, r = 0, o = null, n = -1;
                s.globals.series.length > 1 ? r = this.getFirstActiveXArray(i) : o = 0;
                var l = a[r][0], h = i[r][0], c = Math.abs(t - h), d = Math.abs(e - l), g = d + c;
                return a.map(function(s, r) {
                    s.map(function(s, l) {
                        var h = Math.abs(e - a[r][l]), u = Math.abs(t - i[r][l]), p = u + h;
                        p < g && (g = p, c = u, d = h, o = r, n = l);
                    });
                }), {
                    index: o,
                    j: n
                };
            }
        },
        {
            key: "getFirstActiveXArray",
            value: function(t) {
                for(var e = this.w, i = 0, a = t.map(function(t, e) {
                    return t.length > 0 ? e : -1;
                }), s = 0; s < a.length; s++)if (-1 !== a[s] && -1 === e.globals.collapsedSeriesIndices.indexOf(s) && -1 === e.globals.ancillaryCollapsedSeriesIndices.indexOf(s)) {
                    i = a[s];
                    break;
                }
                return i;
            }
        },
        {
            key: "closestInArray",
            value: function(t, e) {
                for(var i = e[0], a = null, s = Math.abs(t - i), r = 0; r < e.length; r++){
                    var o = Math.abs(t - e[r]);
                    o < s && (s = o, a = r);
                }
                return {
                    index: a
                };
            }
        },
        {
            key: "isXoverlap",
            value: function(t) {
                var e = [], i = this.w.globals.seriesX.filter(function(t) {
                    return void 0 !== t[0];
                });
                if (i.length > 0) for(var a = 0; a < i.length - 1; a++)void 0 !== i[a][t] && void 0 !== i[a + 1][t] && i[a][t] !== i[a + 1][t] && e.push("unEqual");
                return 0 === e.length;
            }
        },
        {
            key: "isInitialSeriesSameLen",
            value: function() {
                for(var t = !0, e = this.w.globals.initialSeries, i = 0; i < e.length - 1; i++)if (e[i].data.length !== e[i + 1].data.length) {
                    t = !1;
                    break;
                }
                return t;
            }
        },
        {
            key: "getBarsHeight",
            value: function(t) {
                return $b705b473d3ec9641$var$g(t).reduce(function(t, e) {
                    return t + e.getBBox().height;
                }, 0);
            }
        },
        {
            key: "getElMarkers",
            value: function() {
                return this.w.globals.dom.baseEl.querySelectorAll(" .apexcharts-series-markers");
            }
        },
        {
            key: "getAllMarkers",
            value: function() {
                var t = this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series-markers-wrap");
                (t = $b705b473d3ec9641$var$g(t)).sort(function(t, e) {
                    return Number(e.getAttribute("data:realIndex")) < Number(t.getAttribute("data:realIndex")) ? 0 : -1;
                });
                var e = [];
                return t.forEach(function(t) {
                    e.push(t.querySelector(".apexcharts-marker"));
                }), e;
            }
        },
        {
            key: "hasMarkers",
            value: function() {
                return this.getElMarkers().length > 0;
            }
        },
        {
            key: "getElBars",
            value: function() {
                return this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-bar-series,  .apexcharts-candlestick-series, .apexcharts-boxPlot-series, .apexcharts-rangebar-series");
            }
        },
        {
            key: "hasBars",
            value: function() {
                return this.getElBars().length > 0;
            }
        },
        {
            key: "getHoverMarkerSize",
            value: function(t) {
                var e = this.w, i = e.config.markers.hover.size;
                return void 0 === i && (i = e.globals.markers.size[t] + e.config.markers.hover.sizeOffset), i;
            }
        },
        {
            key: "toggleAllTooltipSeriesGroups",
            value: function(t) {
                var e = this.w, i = this.ttCtx;
                0 === i.allTooltipSeriesGroups.length && (i.allTooltipSeriesGroups = e.globals.dom.baseEl.querySelectorAll(".apexcharts-tooltip-series-group"));
                for(var a = i.allTooltipSeriesGroups, s = 0; s < a.length; s++)"enable" === t ? (a[s].classList.add("apexcharts-active"), a[s].style.display = e.config.tooltip.items.display) : (a[s].classList.remove("apexcharts-active"), a[s].style.display = "none");
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$gt = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.w = e.w, this.ctx = e.ctx, this.ttCtx = e, this.tooltipUtil = new $b705b473d3ec9641$var$dt(e);
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "drawSeriesTexts",
            value: function(t) {
                var e = t.shared, i = void 0 === e || e, a = t.ttItems, s = t.i, r = void 0 === s ? 0 : s, o = t.j, n = void 0 === o ? null : o, l = t.y1, h = t.y2, c = t.e, d = this.w;
                void 0 !== d.config.tooltip.custom ? this.handleCustomTooltip({
                    i: r,
                    j: n,
                    y1: l,
                    y2: h,
                    w: d
                }) : this.toggleActiveInactiveSeries(i);
                var g = this.getValuesToPrint({
                    i: r,
                    j: n
                });
                this.printLabels({
                    i: r,
                    j: n,
                    values: g,
                    ttItems: a,
                    shared: i,
                    e: c
                });
                var u = this.ttCtx.getElTooltip();
                this.ttCtx.tooltipRect.ttWidth = u.getBoundingClientRect().width, this.ttCtx.tooltipRect.ttHeight = u.getBoundingClientRect().height;
            }
        },
        {
            key: "printLabels",
            value: function(t) {
                var i, a = this, s = t.i, r = t.j, o = t.values, n = t.ttItems, l = t.shared, h = t.e, c = this.w, d = [], g = function(t) {
                    return c.globals.seriesGoals[t] && c.globals.seriesGoals[t][r] && Array.isArray(c.globals.seriesGoals[t][r]);
                }, u = o.xVal, p = o.zVal, f = o.xAxisTTVal, x = "", b = c.globals.colors[s];
                null !== r && c.config.plotOptions.bar.distributed && (b = c.globals.colors[r]);
                for(var v = function(t, o) {
                    var v = a.getFormatters(s);
                    x = a.getSeriesName({
                        fn: v.yLbTitleFormatter,
                        index: s,
                        seriesIndex: s,
                        j: r
                    }), "treemap" === c.config.chart.type && (x = v.yLbTitleFormatter(String(c.config.series[s].data[r].x), {
                        series: c.globals.series,
                        seriesIndex: s,
                        dataPointIndex: r,
                        w: c
                    }));
                    var m = c.config.tooltip.inverseOrder ? o : t;
                    if (c.globals.axisCharts) {
                        var y = function(t) {
                            return v.yLbFormatter(c.globals.series[t][r], {
                                series: c.globals.series,
                                seriesIndex: t,
                                dataPointIndex: r,
                                w: c
                            });
                        };
                        l ? (v = a.getFormatters(m), x = a.getSeriesName({
                            fn: v.yLbTitleFormatter,
                            index: m,
                            seriesIndex: s,
                            j: r
                        }), b = c.globals.colors[m], i = y(m), g(m) && (d = c.globals.seriesGoals[m][r].map(function(t) {
                            return {
                                attrs: t,
                                val: v.yLbFormatter(t.value, {
                                    seriesIndex: m,
                                    dataPointIndex: r,
                                    w: c
                                })
                            };
                        }))) : (h && h.target && h.target.getAttribute("fill") && (b = h.target.getAttribute("fill")), i = y(s), g(s) && Array.isArray(c.globals.seriesGoals[s][r]) && (d = c.globals.seriesGoals[s][r].map(function(t) {
                            return {
                                attrs: t,
                                val: v.yLbFormatter(t.value, {
                                    seriesIndex: s,
                                    dataPointIndex: r,
                                    w: c
                                })
                            };
                        })));
                    }
                    null === r && (i = v.yLbFormatter(c.globals.series[s], $b705b473d3ec9641$var$e($b705b473d3ec9641$var$e({}, c), {}, {
                        seriesIndex: s,
                        dataPointIndex: s
                    }))), a.DOMHandling({
                        i: s,
                        t: m,
                        j: r,
                        ttItems: n,
                        values: {
                            val: i,
                            goalVals: d,
                            xVal: u,
                            xAxisTTVal: f,
                            zVal: p
                        },
                        seriesName: x,
                        shared: l,
                        pColor: b
                    });
                }, m = 0, y = c.globals.series.length - 1; m < c.globals.series.length; m++, y--)v(m, y);
            }
        },
        {
            key: "getFormatters",
            value: function(t) {
                var e, i = this.w, a = i.globals.yLabelFormatters[t];
                return void 0 !== i.globals.ttVal ? Array.isArray(i.globals.ttVal) ? (a = i.globals.ttVal[t] && i.globals.ttVal[t].formatter, e = i.globals.ttVal[t] && i.globals.ttVal[t].title && i.globals.ttVal[t].title.formatter) : (a = i.globals.ttVal.formatter, "function" == typeof i.globals.ttVal.title.formatter && (e = i.globals.ttVal.title.formatter)) : e = i.config.tooltip.y.title.formatter, "function" != typeof a && (a = i.globals.yLabelFormatters[0] ? i.globals.yLabelFormatters[0] : function(t) {
                    return t;
                }), "function" != typeof e && (e = function(t) {
                    return t;
                }), {
                    yLbFormatter: a,
                    yLbTitleFormatter: e
                };
            }
        },
        {
            key: "getSeriesName",
            value: function(t) {
                var e = t.fn, i = t.index, a = t.seriesIndex, s = t.j, r = this.w;
                return e(String(r.globals.seriesNames[i]), {
                    series: r.globals.series,
                    seriesIndex: a,
                    dataPointIndex: s,
                    w: r
                });
            }
        },
        {
            key: "DOMHandling",
            value: function(t) {
                t.i;
                var e = t.t, i = t.j, a = t.ttItems, s = t.values, r = t.seriesName, o = t.shared, n = t.pColor, l = this.w, h = this.ttCtx, c = s.val, d = s.goalVals, g = s.xVal, u = s.xAxisTTVal, p = s.zVal, f = null;
                f = a[e].children, l.config.tooltip.fillSeriesColor && (a[e].style.backgroundColor = n, f[0].style.display = "none"), h.showTooltipTitle && (null === h.tooltipTitle && (h.tooltipTitle = l.globals.dom.baseEl.querySelector(".apexcharts-tooltip-title")), h.tooltipTitle.innerHTML = g), h.isXAxisTooltipEnabled && (h.xaxisTooltipText.innerHTML = "" !== u ? u : g);
                var x = a[e].querySelector(".apexcharts-tooltip-text-y-label");
                x && (x.innerHTML = r || "");
                var b = a[e].querySelector(".apexcharts-tooltip-text-y-value");
                b && (b.innerHTML = void 0 !== c ? c : ""), f[0] && f[0].classList.contains("apexcharts-tooltip-marker") && (l.config.tooltip.marker.fillColors && Array.isArray(l.config.tooltip.marker.fillColors) && (n = l.config.tooltip.marker.fillColors[e]), f[0].style.backgroundColor = n), l.config.tooltip.marker.show || (f[0].style.display = "none");
                var v = a[e].querySelector(".apexcharts-tooltip-text-goals-label"), m = a[e].querySelector(".apexcharts-tooltip-text-goals-value");
                if (d.length && l.globals.seriesGoals[e]) {
                    var y = function() {
                        var t = "<div >", e = "<div>";
                        d.forEach(function(i, a) {
                            t += ' <div style="display: flex"><span class="apexcharts-tooltip-marker" style="background-color: '.concat(i.attrs.strokeColor, '; height: 3px; border-radius: 0; top: 5px;"></span> ').concat(i.attrs.name, "</div>"), e += "<div>".concat(i.val, "</div>");
                        }), v.innerHTML = t + "</div>", m.innerHTML = e + "</div>";
                    };
                    o ? l.globals.seriesGoals[e][i] && Array.isArray(l.globals.seriesGoals[e][i]) ? y() : (v.innerHTML = "", m.innerHTML = "") : y();
                } else v.innerHTML = "", m.innerHTML = "";
                null !== p && (a[e].querySelector(".apexcharts-tooltip-text-z-label").innerHTML = l.config.tooltip.z.title, a[e].querySelector(".apexcharts-tooltip-text-z-value").innerHTML = void 0 !== p ? p : "");
                o && f[0] && (null == c || l.globals.ancillaryCollapsedSeriesIndices.indexOf(e) > -1 || l.globals.collapsedSeriesIndices.indexOf(e) > -1 ? f[0].parentNode.style.display = "none" : f[0].parentNode.style.display = l.config.tooltip.items.display);
            }
        },
        {
            key: "toggleActiveInactiveSeries",
            value: function(t) {
                var e = this.w;
                if (t) this.tooltipUtil.toggleAllTooltipSeriesGroups("enable");
                else {
                    this.tooltipUtil.toggleAllTooltipSeriesGroups("disable");
                    var i = e.globals.dom.baseEl.querySelector(".apexcharts-tooltip-series-group");
                    i && (i.classList.add("apexcharts-active"), i.style.display = e.config.tooltip.items.display);
                }
            }
        },
        {
            key: "getValuesToPrint",
            value: function(t) {
                var e = t.i, i = t.j, a = this.w, s = this.ctx.series.filteredSeriesX(), r = "", o = "", n = null, l = null, h = {
                    series: a.globals.series,
                    seriesIndex: e,
                    dataPointIndex: i,
                    w: a
                }, c = a.globals.ttZFormatter;
                null === i ? l = a.globals.series[e] : a.globals.isXNumeric && "treemap" !== a.config.chart.type ? (r = s[e][i], 0 === s[e].length && (r = s[this.tooltipUtil.getFirstActiveXArray(s)][i])) : r = void 0 !== a.globals.labels[i] ? a.globals.labels[i] : "";
                var d = r;
                a.globals.isXNumeric && "datetime" === a.config.xaxis.type ? r = new $b705b473d3ec9641$var$W(this.ctx).xLabelFormat(a.globals.ttKeyFormatter, d, d, {
                    i: void 0,
                    dateFormatter: new $b705b473d3ec9641$var$Y(this.ctx).formatDate,
                    w: this.w
                }) : r = a.globals.isBarHorizontal ? a.globals.yLabelFormatters[0](d, h) : a.globals.xLabelFormatter(d, h);
                return void 0 !== a.config.tooltip.x.formatter && (r = a.globals.ttKeyFormatter(d, h)), a.globals.seriesZ.length > 0 && a.globals.seriesZ[e].length > 0 && (n = c(a.globals.seriesZ[e][i], a)), o = "function" == typeof a.config.xaxis.tooltip.formatter ? a.globals.xaxisTooltipFormatter(d, h) : r, {
                    val: Array.isArray(l) ? l.join(" ") : l,
                    xVal: Array.isArray(r) ? r.join(" ") : r,
                    xAxisTTVal: Array.isArray(o) ? o.join(" ") : o,
                    zVal: n
                };
            }
        },
        {
            key: "handleCustomTooltip",
            value: function(t) {
                var e = t.i, i = t.j, a = t.y1, s = t.y2, r = t.w, o = this.ttCtx.getElTooltip(), n = r.config.tooltip.custom;
                Array.isArray(n) && n[e] && (n = n[e]), o.innerHTML = n({
                    ctx: this.ctx,
                    series: r.globals.series,
                    seriesIndex: e,
                    dataPointIndex: i,
                    y1: a,
                    y2: s,
                    w: r
                });
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$ut = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.ttCtx = e, this.ctx = e.ctx, this.w = e.w;
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "moveXCrosshairs",
            value: function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, i = this.ttCtx, a = this.w, s = i.getElXCrosshairs(), r = t - i.xcrosshairsWidth / 2, o = a.globals.labels.slice().length;
                if (null !== e && (r = a.globals.gridWidth / o * e), null === s || a.globals.isBarHorizontal || (s.setAttribute("x", r), s.setAttribute("x1", r), s.setAttribute("x2", r), s.setAttribute("y2", a.globals.gridHeight), s.classList.add("apexcharts-active")), r < 0 && (r = 0), r > a.globals.gridWidth && (r = a.globals.gridWidth), i.isXAxisTooltipEnabled) {
                    var n = r;
                    "tickWidth" !== a.config.xaxis.crosshairs.width && "barWidth" !== a.config.xaxis.crosshairs.width || (n = r + i.xcrosshairsWidth / 2), this.moveXAxisTooltip(n);
                }
            }
        },
        {
            key: "moveYCrosshairs",
            value: function(t) {
                var e = this.ttCtx;
                null !== e.ycrosshairs && $b705b473d3ec9641$var$b.setAttrs(e.ycrosshairs, {
                    y1: t,
                    y2: t
                }), null !== e.ycrosshairsHidden && $b705b473d3ec9641$var$b.setAttrs(e.ycrosshairsHidden, {
                    y1: t,
                    y2: t
                });
            }
        },
        {
            key: "moveXAxisTooltip",
            value: function(t) {
                var e = this.w, i = this.ttCtx;
                if (null !== i.xaxisTooltip && 0 !== i.xcrosshairsWidth) {
                    i.xaxisTooltip.classList.add("apexcharts-active");
                    var a = i.xaxisOffY + e.config.xaxis.tooltip.offsetY + e.globals.translateY + 1 + e.config.xaxis.offsetY;
                    if (t -= i.xaxisTooltip.getBoundingClientRect().width / 2, !isNaN(t)) {
                        t += e.globals.translateX;
                        var s;
                        s = new $b705b473d3ec9641$var$b(this.ctx).getTextRects(i.xaxisTooltipText.innerHTML), i.xaxisTooltipText.style.minWidth = s.width + "px", i.xaxisTooltip.style.left = t + "px", i.xaxisTooltip.style.top = a + "px";
                    }
                }
            }
        },
        {
            key: "moveYAxisTooltip",
            value: function(t) {
                var e = this.w, i = this.ttCtx;
                null === i.yaxisTTEls && (i.yaxisTTEls = e.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxistooltip"));
                var a = parseInt(i.ycrosshairsHidden.getAttribute("y1"), 10), s = e.globals.translateY + a, r = i.yaxisTTEls[t].getBoundingClientRect().height, o = e.globals.translateYAxisX[t] - 2;
                e.config.yaxis[t].opposite && (o -= 26), s -= r / 2, -1 === e.globals.ignoreYAxisIndexes.indexOf(t) ? (i.yaxisTTEls[t].classList.add("apexcharts-active"), i.yaxisTTEls[t].style.top = s + "px", i.yaxisTTEls[t].style.left = o + e.config.yaxis[t].tooltip.offsetX + "px") : i.yaxisTTEls[t].classList.remove("apexcharts-active");
            }
        },
        {
            key: "moveTooltip",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, a = this.w, s = this.ttCtx, r = s.getElTooltip(), o = s.tooltipRect, n = null !== i ? parseFloat(i) : 1, l = parseFloat(t) + n + 5, h = parseFloat(e) + n / 2;
                if (l > a.globals.gridWidth / 2 && (l = l - o.ttWidth - n - 15), l > a.globals.gridWidth - o.ttWidth - 10 && (l = a.globals.gridWidth - o.ttWidth), l < -20 && (l = -20), a.config.tooltip.followCursor) {
                    var c = s.getElGrid(), d = c.getBoundingClientRect();
                    h = s.e.clientY + a.globals.translateY - d.top - o.ttHeight / 2;
                } else a.globals.isBarHorizontal || (o.ttHeight / 2 + h > a.globals.gridHeight && (h = a.globals.gridHeight - o.ttHeight + a.globals.translateY), h < 0 && (h = 0));
                isNaN(l) || (l += a.globals.translateX, r.style.left = l + "px", r.style.top = h + "px");
            }
        },
        {
            key: "moveMarkers",
            value: function(t, e) {
                var i = this.w, a = this.ttCtx;
                if (i.globals.markers.size[t] > 0) for(var s = i.globals.dom.baseEl.querySelectorAll(" .apexcharts-series[data\\:realIndex='".concat(t, "'] .apexcharts-marker")), r = 0; r < s.length; r++)parseInt(s[r].getAttribute("rel"), 10) === e && (a.marker.resetPointsSize(), a.marker.enlargeCurrentPoint(e, s[r]));
                else a.marker.resetPointsSize(), this.moveDynamicPointOnHover(e, t);
            }
        },
        {
            key: "moveDynamicPointOnHover",
            value: function(t, e) {
                var i, a, s = this.w, r = this.ttCtx, o = s.globals.pointsArray, n = r.tooltipUtil.getHoverMarkerSize(e), l = s.config.series[e].type;
                if (!l || "column" !== l && "candlestick" !== l && "boxPlot" !== l) {
                    i = o[e][t][0], a = o[e][t][1] ? o[e][t][1] : 0;
                    var h = s.globals.dom.baseEl.querySelector(".apexcharts-series[data\\:realIndex='".concat(e, "'] .apexcharts-series-markers circle"));
                    h && a < s.globals.gridHeight && a > 0 && (h.setAttribute("r", n), h.setAttribute("cx", i), h.setAttribute("cy", a)), this.moveXCrosshairs(i), r.fixedTooltip || this.moveTooltip(i, a, n);
                }
            }
        },
        {
            key: "moveDynamicPointsOnHover",
            value: function(t) {
                var e, i = this.ttCtx, a = i.w, s = 0, r = 0, o = a.globals.pointsArray;
                e = new $b705b473d3ec9641$var$z(this.ctx).getActiveConfigSeriesIndex(!0);
                var n = i.tooltipUtil.getHoverMarkerSize(e);
                o[e] && (s = o[e][t][0], r = o[e][t][1]);
                var l = i.tooltipUtil.getAllMarkers();
                if (null !== l) for(var h = 0; h < a.globals.series.length; h++){
                    var c = o[h];
                    if (a.globals.comboCharts && void 0 === c && l.splice(h, 0, null), c && c.length) {
                        var d = o[h][t][1];
                        l[h].setAttribute("cx", s), null !== d && !isNaN(d) && d < a.globals.gridHeight + n && d + n > 0 ? (l[h] && l[h].setAttribute("r", n), l[h] && l[h].setAttribute("cy", d)) : l[h] && l[h].setAttribute("r", 0);
                    }
                }
                if (this.moveXCrosshairs(s), !i.fixedTooltip) {
                    var g = r || a.globals.gridHeight;
                    this.moveTooltip(s, g, n);
                }
            }
        },
        {
            key: "moveStickyTooltipOverBars",
            value: function(t) {
                var e = this.w, i = this.ttCtx, a = e.globals.columnSeries ? e.globals.columnSeries.length : e.globals.series.length, s = a >= 2 && a % 2 == 0 ? Math.floor(a / 2) : Math.floor(a / 2) + 1;
                e.globals.isBarHorizontal && (s = new $b705b473d3ec9641$var$z(this.ctx).getActiveConfigSeriesIndex(!1, "desc") + 1);
                var r = e.globals.dom.baseEl.querySelector(".apexcharts-bar-series .apexcharts-series[rel='".concat(s, "'] path[j='").concat(t, "'], .apexcharts-candlestick-series .apexcharts-series[rel='").concat(s, "'] path[j='").concat(t, "'], .apexcharts-boxPlot-series .apexcharts-series[rel='").concat(s, "'] path[j='").concat(t, "'], .apexcharts-rangebar-series .apexcharts-series[rel='").concat(s, "'] path[j='").concat(t, "']")), o = r ? parseFloat(r.getAttribute("cx")) : 0, n = r ? parseFloat(r.getAttribute("cy")) : 0, l = r ? parseFloat(r.getAttribute("barWidth")) : 0, h = r ? parseFloat(r.getAttribute("barHeight")) : 0, c = i.getElGrid().getBoundingClientRect(), d = r.classList.contains("apexcharts-candlestick-area") || r.classList.contains("apexcharts-boxPlot-area");
                if (e.globals.isXNumeric ? (r && !d && (o -= a % 2 != 0 ? l / 2 : 0), r && d && e.globals.comboCharts && (o -= l / 2)) : e.globals.isBarHorizontal || (o = i.xAxisTicksPositions[t - 1] + i.dataPointsDividedWidth / 2, isNaN(o) && (o = i.xAxisTicksPositions[t] - i.dataPointsDividedWidth / 2)), e.globals.isBarHorizontal ? n += h / 3 : n = i.e.clientY - c.top - i.tooltipRect.ttHeight / 2, e.globals.isBarHorizontal || this.moveXCrosshairs(o), !i.fixedTooltip) {
                    var g = n || e.globals.gridHeight;
                    this.moveTooltip(o, g);
                }
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$pt = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.w = e.w, this.ttCtx = e, this.ctx = e.ctx, this.tooltipPosition = new $b705b473d3ec9641$var$ut(e);
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "drawDynamicPoints",
            value: function() {
                var t = this.w, e = new $b705b473d3ec9641$var$b(this.ctx), i = new $b705b473d3ec9641$var$P(this.ctx), a = t.globals.dom.baseEl.querySelectorAll(".apexcharts-series");
                a = $b705b473d3ec9641$var$g(a), t.config.chart.stacked && a.sort(function(t, e) {
                    return parseFloat(t.getAttribute("data:realIndex")) - parseFloat(e.getAttribute("data:realIndex"));
                });
                for(var s = 0; s < a.length; s++){
                    var r = a[s].querySelector(".apexcharts-series-markers-wrap");
                    if (null !== r) {
                        var o = void 0, n = "apexcharts-marker w".concat((Math.random() + 1).toString(36).substring(4));
                        "line" !== t.config.chart.type && "area" !== t.config.chart.type || t.globals.comboCharts || t.config.tooltip.intersect || (n += " no-pointer-events");
                        var l = i.getMarkerConfig({
                            cssClass: n,
                            seriesIndex: Number(r.getAttribute("data:realIndex"))
                        });
                        (o = e.drawMarker(0, 0, l)).node.setAttribute("default-marker-size", 0);
                        var h = document.createElementNS(t.globals.SVGNS, "g");
                        h.classList.add("apexcharts-series-markers"), h.appendChild(o.node), r.appendChild(h);
                    }
                }
            }
        },
        {
            key: "enlargeCurrentPoint",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null, s = this.w;
                "bubble" !== s.config.chart.type && this.newPointSize(t, e);
                var r = e.getAttribute("cx"), o = e.getAttribute("cy");
                if (null !== i && null !== a && (r = i, o = a), this.tooltipPosition.moveXCrosshairs(r), !this.fixedTooltip) {
                    if ("radar" === s.config.chart.type) {
                        var n = this.ttCtx.getElGrid(), l = n.getBoundingClientRect();
                        r = this.ttCtx.e.clientX - l.left;
                    }
                    this.tooltipPosition.moveTooltip(r, o, s.config.markers.hover.size);
                }
            }
        },
        {
            key: "enlargePoints",
            value: function(t) {
                for(var e = this.w, i = this, a = this.ttCtx, s = t, r = e.globals.dom.baseEl.querySelectorAll(".apexcharts-series:not(.apexcharts-series-collapsed) .apexcharts-marker"), o = e.config.markers.hover.size, n = 0; n < r.length; n++){
                    var l = r[n].getAttribute("rel"), h = r[n].getAttribute("index");
                    if (void 0 === o && (o = e.globals.markers.size[h] + e.config.markers.hover.sizeOffset), s === parseInt(l, 10)) {
                        i.newPointSize(s, r[n]);
                        var c = r[n].getAttribute("cx"), d = r[n].getAttribute("cy");
                        i.tooltipPosition.moveXCrosshairs(c), a.fixedTooltip || i.tooltipPosition.moveTooltip(c, d, o);
                    } else i.oldPointSize(r[n]);
                }
            }
        },
        {
            key: "newPointSize",
            value: function(t, e) {
                var i = this.w, a = i.config.markers.hover.size, s = 0 === t ? e.parentNode.firstChild : e.parentNode.lastChild;
                if ("0" !== s.getAttribute("default-marker-size")) {
                    var r = parseInt(s.getAttribute("index"), 10);
                    void 0 === a && (a = i.globals.markers.size[r] + i.config.markers.hover.sizeOffset), a < 0 && (a = 0), s.setAttribute("r", a);
                }
            }
        },
        {
            key: "oldPointSize",
            value: function(t) {
                var e = parseFloat(t.getAttribute("default-marker-size"));
                t.setAttribute("r", e);
            }
        },
        {
            key: "resetPointsSize",
            value: function() {
                for(var t = this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series:not(.apexcharts-series-collapsed) .apexcharts-marker"), e = 0; e < t.length; e++){
                    var i = parseFloat(t[e].getAttribute("default-marker-size"));
                    $b705b473d3ec9641$var$p.isNumber(i) && i >= 0 ? t[e].setAttribute("r", i) : t[e].setAttribute("r", 0);
                }
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$ft = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.w = e.w, this.ttCtx = e;
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "getAttr",
            value: function(t, e) {
                return parseFloat(t.target.getAttribute(e));
            }
        },
        {
            key: "handleHeatTreeTooltip",
            value: function(t) {
                var e = t.e, i = t.opt, a = t.x, s = t.y, r = t.type, o = this.ttCtx, n = this.w;
                if (e.target.classList.contains("apexcharts-".concat(r, "-rect"))) {
                    var l = this.getAttr(e, "i"), h = this.getAttr(e, "j"), c = this.getAttr(e, "cx"), d = this.getAttr(e, "cy"), g = this.getAttr(e, "width"), u = this.getAttr(e, "height");
                    if (o.tooltipLabels.drawSeriesTexts({
                        ttItems: i.ttItems,
                        i: l,
                        j: h,
                        shared: !1,
                        e: e
                    }), n.globals.capturedSeriesIndex = l, n.globals.capturedDataPointIndex = h, a = c + o.tooltipRect.ttWidth / 2 + g, s = d + o.tooltipRect.ttHeight / 2 - u / 2, o.tooltipPosition.moveXCrosshairs(c + g / 2), a > n.globals.gridWidth / 2 && (a = c - o.tooltipRect.ttWidth / 2 + g), o.w.config.tooltip.followCursor) {
                        var p = n.globals.dom.elWrap.getBoundingClientRect();
                        a = n.globals.clientX - p.left - (a > n.globals.gridWidth / 2 ? o.tooltipRect.ttWidth : 0), s = n.globals.clientY - p.top;
                    }
                }
                return {
                    x: a,
                    y: s
                };
            }
        },
        {
            key: "handleMarkerTooltip",
            value: function(t) {
                var e, i, a = t.e, s = t.opt, r = t.x, o = t.y, n = this.w, l = this.ttCtx;
                if (a.target.classList.contains("apexcharts-marker")) {
                    var h = parseInt(s.paths.getAttribute("cx"), 10), c = parseInt(s.paths.getAttribute("cy"), 10), d = parseFloat(s.paths.getAttribute("val"));
                    if (i = parseInt(s.paths.getAttribute("rel"), 10), e = parseInt(s.paths.parentNode.parentNode.parentNode.getAttribute("rel"), 10) - 1, l.intersect) {
                        var g = $b705b473d3ec9641$var$p.findAncestor(s.paths, "apexcharts-series");
                        g && (e = parseInt(g.getAttribute("data:realIndex"), 10));
                    }
                    if (l.tooltipLabels.drawSeriesTexts({
                        ttItems: s.ttItems,
                        i: e,
                        j: i,
                        shared: !l.showOnIntersect && n.config.tooltip.shared,
                        e: a
                    }), "mouseup" === a.type && l.markerClick(a, e, i), n.globals.capturedSeriesIndex = e, n.globals.capturedDataPointIndex = i, r = h, o = c + n.globals.translateY - 1.4 * l.tooltipRect.ttHeight, l.w.config.tooltip.followCursor) {
                        var u = l.getElGrid().getBoundingClientRect();
                        o = l.e.clientY + n.globals.translateY - u.top;
                    }
                    d < 0 && (o = c), l.marker.enlargeCurrentPoint(i, s.paths, r, o);
                }
                return {
                    x: r,
                    y: o
                };
            }
        },
        {
            key: "handleBarTooltip",
            value: function(t) {
                var e, i, a = t.e, s = t.opt, r = this.w, o = this.ttCtx, n = o.getElTooltip(), l = 0, h = 0, c = 0, d = this.getBarTooltipXY({
                    e: a,
                    opt: s
                });
                e = d.i;
                var g = d.barHeight, u = d.j;
                r.globals.capturedSeriesIndex = e, r.globals.capturedDataPointIndex = u, r.globals.isBarHorizontal && o.tooltipUtil.hasBars() || !r.config.tooltip.shared ? (h = d.x, c = d.y, i = Array.isArray(r.config.stroke.width) ? r.config.stroke.width[e] : r.config.stroke.width, l = h) : r.globals.comboCharts || r.config.tooltip.shared || (l /= 2), isNaN(c) ? c = r.globals.svgHeight - o.tooltipRect.ttHeight : c < 0 && (c = 0);
                var p = parseInt(s.paths.parentNode.getAttribute("data:realIndex"), 10), f = r.globals.isMultipleYAxis ? r.config.yaxis[p] && r.config.yaxis[p].reversed : r.config.yaxis[0].reversed;
                if (h + o.tooltipRect.ttWidth > r.globals.gridWidth && !f ? h -= o.tooltipRect.ttWidth : h < 0 && (h = 0), o.w.config.tooltip.followCursor) {
                    var x = o.getElGrid().getBoundingClientRect();
                    c = o.e.clientY - x.top;
                }
                null === o.tooltip && (o.tooltip = r.globals.dom.baseEl.querySelector(".apexcharts-tooltip")), r.config.tooltip.shared || (r.globals.comboBarCount > 0 ? o.tooltipPosition.moveXCrosshairs(l + i / 2) : o.tooltipPosition.moveXCrosshairs(l)), !o.fixedTooltip && (!r.config.tooltip.shared || r.globals.isBarHorizontal && o.tooltipUtil.hasBars()) && (f && (h -= o.tooltipRect.ttWidth) < 0 && (h = 0), !f || r.globals.isBarHorizontal && o.tooltipUtil.hasBars() || (c = c + g - 2 * (r.globals.series[e][u] < 0 ? g : 0)), o.tooltipRect.ttHeight + c > r.globals.gridHeight ? c = r.globals.gridHeight - o.tooltipRect.ttHeight + r.globals.translateY : (c = c + r.globals.translateY - o.tooltipRect.ttHeight / 2) < 0 && (c = 0), n.style.left = h + r.globals.translateX + "px", n.style.top = c + "px");
            }
        },
        {
            key: "getBarTooltipXY",
            value: function(t) {
                var e = t.e, i = t.opt, a = this.w, s = null, r = this.ttCtx, o = 0, n = 0, l = 0, h = 0, c = 0, d = e.target.classList;
                if (d.contains("apexcharts-bar-area") || d.contains("apexcharts-candlestick-area") || d.contains("apexcharts-boxPlot-area") || d.contains("apexcharts-rangebar-area")) {
                    var g = e.target, u = g.getBoundingClientRect(), p = i.elGrid.getBoundingClientRect(), f = u.height;
                    c = u.height;
                    var x = u.width, b = parseInt(g.getAttribute("cx"), 10), v = parseInt(g.getAttribute("cy"), 10);
                    h = parseFloat(g.getAttribute("barWidth"));
                    var m = "touchmove" === e.type ? e.touches[0].clientX : e.clientX;
                    s = parseInt(g.getAttribute("j"), 10), o = parseInt(g.parentNode.getAttribute("rel"), 10) - 1;
                    var y = g.getAttribute("data-range-y1"), w = g.getAttribute("data-range-y2");
                    a.globals.comboCharts && (o = parseInt(g.parentNode.getAttribute("data:realIndex"), 10)), r.tooltipLabels.drawSeriesTexts({
                        ttItems: i.ttItems,
                        i: o,
                        j: s,
                        y1: y ? parseInt(y, 10) : null,
                        y2: w ? parseInt(w, 10) : null,
                        shared: !r.showOnIntersect && a.config.tooltip.shared,
                        e: e
                    }), a.config.tooltip.followCursor ? a.globals.isBarHorizontal ? (n = m - p.left + 15, l = v - r.dataPointsDividedHeight + f / 2 - r.tooltipRect.ttHeight / 2) : (n = a.globals.isXNumeric ? b - x / 2 : b - r.dataPointsDividedWidth + x / 2, l = e.clientY - p.top - r.tooltipRect.ttHeight / 2 - 15) : a.globals.isBarHorizontal ? ((n = b) < r.xyRatios.baseLineInvertedY && (n = b - r.tooltipRect.ttWidth), l = v - r.dataPointsDividedHeight + f / 2 - r.tooltipRect.ttHeight / 2) : (n = a.globals.isXNumeric ? b - x / 2 : b - r.dataPointsDividedWidth + x / 2, l = v);
                }
                return {
                    x: n,
                    y: l,
                    barHeight: c,
                    barWidth: h,
                    i: o,
                    j: s
                };
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$xt = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.w = e.w, this.ttCtx = e;
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "drawXaxisTooltip",
            value: function() {
                var t = this.w, e = this.ttCtx, i = "bottom" === t.config.xaxis.position;
                e.xaxisOffY = i ? t.globals.gridHeight + 1 : -t.globals.xAxisHeight - t.config.xaxis.axisTicks.height + 3;
                var a = i ? "apexcharts-xaxistooltip apexcharts-xaxistooltip-bottom" : "apexcharts-xaxistooltip apexcharts-xaxistooltip-top", s = t.globals.dom.elWrap;
                e.isXAxisTooltipEnabled && null === t.globals.dom.baseEl.querySelector(".apexcharts-xaxistooltip") && (e.xaxisTooltip = document.createElement("div"), e.xaxisTooltip.setAttribute("class", a + " apexcharts-theme-" + t.config.tooltip.theme), s.appendChild(e.xaxisTooltip), e.xaxisTooltipText = document.createElement("div"), e.xaxisTooltipText.classList.add("apexcharts-xaxistooltip-text"), e.xaxisTooltipText.style.fontFamily = t.config.xaxis.tooltip.style.fontFamily || t.config.chart.fontFamily, e.xaxisTooltipText.style.fontSize = t.config.xaxis.tooltip.style.fontSize, e.xaxisTooltip.appendChild(e.xaxisTooltipText));
            }
        },
        {
            key: "drawYaxisTooltip",
            value: function() {
                for(var t = this.w, e = this.ttCtx, i = function(i) {
                    var a = t.config.yaxis[i].opposite || t.config.yaxis[i].crosshairs.opposite;
                    e.yaxisOffX = a ? t.globals.gridWidth + 1 : 1;
                    var s = "apexcharts-yaxistooltip apexcharts-yaxistooltip-".concat(i, a ? " apexcharts-yaxistooltip-right" : " apexcharts-yaxistooltip-left");
                    t.globals.yAxisSameScaleIndices.map(function(e, a) {
                        e.map(function(e, a) {
                            a === i && (s += t.config.yaxis[a].show ? " " : " apexcharts-yaxistooltip-hidden");
                        });
                    });
                    var r = t.globals.dom.elWrap;
                    null === t.globals.dom.baseEl.querySelector(".apexcharts-yaxistooltip apexcharts-yaxistooltip-".concat(i)) && (e.yaxisTooltip = document.createElement("div"), e.yaxisTooltip.setAttribute("class", s + " apexcharts-theme-" + t.config.tooltip.theme), r.appendChild(e.yaxisTooltip), 0 === i && (e.yaxisTooltipText = []), e.yaxisTooltipText[i] = document.createElement("div"), e.yaxisTooltipText[i].classList.add("apexcharts-yaxistooltip-text"), e.yaxisTooltip.appendChild(e.yaxisTooltipText[i]));
                }, a = 0; a < t.config.yaxis.length; a++)i(a);
            }
        },
        {
            key: "setXCrosshairWidth",
            value: function() {
                var t = this.w, e = this.ttCtx, i = e.getElXCrosshairs();
                if (e.xcrosshairsWidth = parseInt(t.config.xaxis.crosshairs.width, 10), t.globals.comboCharts) {
                    var a = t.globals.dom.baseEl.querySelector(".apexcharts-bar-area");
                    if (null !== a && "barWidth" === t.config.xaxis.crosshairs.width) {
                        var s = parseFloat(a.getAttribute("barWidth"));
                        e.xcrosshairsWidth = s;
                    } else if ("tickWidth" === t.config.xaxis.crosshairs.width) {
                        var r = t.globals.labels.length;
                        e.xcrosshairsWidth = t.globals.gridWidth / r;
                    }
                } else if ("tickWidth" === t.config.xaxis.crosshairs.width) {
                    var o = t.globals.labels.length;
                    e.xcrosshairsWidth = t.globals.gridWidth / o;
                } else if ("barWidth" === t.config.xaxis.crosshairs.width) {
                    var n = t.globals.dom.baseEl.querySelector(".apexcharts-bar-area");
                    if (null !== n) {
                        var l = parseFloat(n.getAttribute("barWidth"));
                        e.xcrosshairsWidth = l;
                    } else e.xcrosshairsWidth = 1;
                }
                t.globals.isBarHorizontal && (e.xcrosshairsWidth = 0), null !== i && e.xcrosshairsWidth > 0 && i.setAttribute("width", e.xcrosshairsWidth);
            }
        },
        {
            key: "handleYCrosshair",
            value: function() {
                var t = this.w, e = this.ttCtx;
                e.ycrosshairs = t.globals.dom.baseEl.querySelector(".apexcharts-ycrosshairs"), e.ycrosshairsHidden = t.globals.dom.baseEl.querySelector(".apexcharts-ycrosshairs-hidden");
            }
        },
        {
            key: "drawYaxisTooltipText",
            value: function(t, e, i) {
                var a = this.ttCtx, s = this.w, r = s.globals.yLabelFormatters[t];
                if (a.yaxisTooltips[t]) {
                    var o = a.getElGrid().getBoundingClientRect(), n = (e - o.top) * i.yRatio[t], l = s.globals.maxYArr[t] - s.globals.minYArr[t], h = s.globals.minYArr[t] + (l - n);
                    a.tooltipPosition.moveYCrosshairs(e - o.top), a.yaxisTooltipText[t].innerHTML = r(h), a.tooltipPosition.moveYAxisTooltip(t);
                }
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$bt = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.ctx = e, this.w = e.w;
        var i = this.w;
        this.tConfig = i.config.tooltip, this.tooltipUtil = new $b705b473d3ec9641$var$dt(this), this.tooltipLabels = new $b705b473d3ec9641$var$gt(this), this.tooltipPosition = new $b705b473d3ec9641$var$ut(this), this.marker = new $b705b473d3ec9641$var$pt(this), this.intersect = new $b705b473d3ec9641$var$ft(this), this.axesTooltip = new $b705b473d3ec9641$var$xt(this), this.showOnIntersect = this.tConfig.intersect, this.showTooltipTitle = this.tConfig.x.show, this.fixedTooltip = this.tConfig.fixed.enabled, this.xaxisTooltip = null, this.yaxisTTEls = null, this.isBarShared = !i.globals.isBarHorizontal && this.tConfig.shared, this.lastHoverTime = Date.now();
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "getElTooltip",
            value: function(t) {
                return t || (t = this), t.w.globals.dom.baseEl ? t.w.globals.dom.baseEl.querySelector(".apexcharts-tooltip") : null;
            }
        },
        {
            key: "getElXCrosshairs",
            value: function() {
                return this.w.globals.dom.baseEl.querySelector(".apexcharts-xcrosshairs");
            }
        },
        {
            key: "getElGrid",
            value: function() {
                return this.w.globals.dom.baseEl.querySelector(".apexcharts-grid");
            }
        },
        {
            key: "drawTooltip",
            value: function(t) {
                var e = this.w;
                this.xyRatios = t, this.isXAxisTooltipEnabled = e.config.xaxis.tooltip.enabled && e.globals.axisCharts, this.yaxisTooltips = e.config.yaxis.map(function(t, i) {
                    return !!(t.show && t.tooltip.enabled && e.globals.axisCharts);
                }), this.allTooltipSeriesGroups = [], e.globals.axisCharts || (this.showTooltipTitle = !1);
                var i = document.createElement("div");
                if (i.classList.add("apexcharts-tooltip"), i.classList.add("apexcharts-theme-".concat(this.tConfig.theme)), e.globals.dom.elWrap.appendChild(i), e.globals.axisCharts) {
                    this.axesTooltip.drawXaxisTooltip(), this.axesTooltip.drawYaxisTooltip(), this.axesTooltip.setXCrosshairWidth(), this.axesTooltip.handleYCrosshair();
                    var a = new $b705b473d3ec9641$var$G(this.ctx);
                    this.xAxisTicksPositions = a.getXAxisTicksPositions();
                }
                if (!e.globals.comboCharts && !this.tConfig.intersect && "rangeBar" !== e.config.chart.type || this.tConfig.shared || (this.showOnIntersect = !0), 0 !== e.config.markers.size && 0 !== e.globals.markers.largestSize || this.marker.drawDynamicPoints(this), e.globals.collapsedSeries.length !== e.globals.series.length) {
                    this.dataPointsDividedHeight = e.globals.gridHeight / e.globals.dataPoints, this.dataPointsDividedWidth = e.globals.gridWidth / e.globals.dataPoints, this.showTooltipTitle && (this.tooltipTitle = document.createElement("div"), this.tooltipTitle.classList.add("apexcharts-tooltip-title"), this.tooltipTitle.style.fontFamily = this.tConfig.style.fontFamily || e.config.chart.fontFamily, this.tooltipTitle.style.fontSize = this.tConfig.style.fontSize, i.appendChild(this.tooltipTitle));
                    var s = e.globals.series.length;
                    (e.globals.xyCharts || e.globals.comboCharts) && this.tConfig.shared && (s = this.showOnIntersect ? 1 : e.globals.series.length), this.legendLabels = e.globals.dom.baseEl.querySelectorAll(".apexcharts-legend-text"), this.ttItems = this.createTTElements(s), this.addSVGEvents();
                }
            }
        },
        {
            key: "createTTElements",
            value: function(t) {
                for(var e = this, i = this.w, a = [], s = this.getElTooltip(), r = function(r) {
                    var o = document.createElement("div");
                    o.classList.add("apexcharts-tooltip-series-group"), o.style.order = i.config.tooltip.inverseOrder ? t - r : r + 1, e.tConfig.shared && e.tConfig.enabledOnSeries && Array.isArray(e.tConfig.enabledOnSeries) && e.tConfig.enabledOnSeries.indexOf(r) < 0 && o.classList.add("apexcharts-tooltip-series-group-hidden");
                    var n = document.createElement("span");
                    n.classList.add("apexcharts-tooltip-marker"), n.style.backgroundColor = i.globals.colors[r], o.appendChild(n);
                    var l = document.createElement("div");
                    l.classList.add("apexcharts-tooltip-text"), l.style.fontFamily = e.tConfig.style.fontFamily || i.config.chart.fontFamily, l.style.fontSize = e.tConfig.style.fontSize, [
                        "y",
                        "goals",
                        "z"
                    ].forEach(function(t) {
                        var e = document.createElement("div");
                        e.classList.add("apexcharts-tooltip-".concat(t, "-group"));
                        var i = document.createElement("span");
                        i.classList.add("apexcharts-tooltip-text-".concat(t, "-label")), e.appendChild(i);
                        var a = document.createElement("span");
                        a.classList.add("apexcharts-tooltip-text-".concat(t, "-value")), e.appendChild(a), l.appendChild(e);
                    }), o.appendChild(l), s.appendChild(o), a.push(o);
                }, o = 0; o < t; o++)r(o);
                return a;
            }
        },
        {
            key: "addSVGEvents",
            value: function() {
                var t = this.w, e = t.config.chart.type, i = this.getElTooltip(), a = !("bar" !== e && "candlestick" !== e && "boxPlot" !== e && "rangeBar" !== e), s = "area" === e || "line" === e || "scatter" === e || "bubble" === e || "radar" === e, r = t.globals.dom.Paper.node, o = this.getElGrid();
                o && (this.seriesBound = o.getBoundingClientRect());
                var n, l = [], h = [], c = {
                    hoverArea: r,
                    elGrid: o,
                    tooltipEl: i,
                    tooltipY: l,
                    tooltipX: h,
                    ttItems: this.ttItems
                };
                if (t.globals.axisCharts && (s ? n = t.globals.dom.baseEl.querySelectorAll(".apexcharts-series[data\\:longestSeries='true'] .apexcharts-marker") : a ? n = t.globals.dom.baseEl.querySelectorAll(".apexcharts-series .apexcharts-bar-area, .apexcharts-series .apexcharts-candlestick-area, .apexcharts-series .apexcharts-boxPlot-area, .apexcharts-series .apexcharts-rangebar-area") : "heatmap" !== e && "treemap" !== e || (n = t.globals.dom.baseEl.querySelectorAll(".apexcharts-series .apexcharts-heatmap, .apexcharts-series .apexcharts-treemap")), n && n.length)) for(var d = 0; d < n.length; d++)l.push(n[d].getAttribute("cy")), h.push(n[d].getAttribute("cx"));
                if (t.globals.xyCharts && !this.showOnIntersect || t.globals.comboCharts && !this.showOnIntersect || a && this.tooltipUtil.hasBars() && this.tConfig.shared) this.addPathsEventListeners([
                    r
                ], c);
                else if (a && !t.globals.comboCharts || s && this.showOnIntersect) this.addDatapointEventsListeners(c);
                else if (!t.globals.axisCharts || "heatmap" === e || "treemap" === e) {
                    var g = t.globals.dom.baseEl.querySelectorAll(".apexcharts-series");
                    this.addPathsEventListeners(g, c);
                }
                if (this.showOnIntersect) {
                    var u = t.globals.dom.baseEl.querySelectorAll(".apexcharts-line-series .apexcharts-marker, .apexcharts-area-series .apexcharts-marker");
                    u.length > 0 && this.addPathsEventListeners(u, c), this.tooltipUtil.hasBars() && !this.tConfig.shared && this.addDatapointEventsListeners(c);
                }
            }
        },
        {
            key: "drawFixedTooltipRect",
            value: function() {
                var t = this.w, e = this.getElTooltip(), i = e.getBoundingClientRect(), a = i.width + 10, s = i.height + 10, r = this.tConfig.fixed.offsetX, o = this.tConfig.fixed.offsetY, n = this.tConfig.fixed.position.toLowerCase();
                return n.indexOf("right") > -1 && (r = r + t.globals.svgWidth - a + 10), n.indexOf("bottom") > -1 && (o = o + t.globals.svgHeight - s - 10), e.style.left = r + "px", e.style.top = o + "px", {
                    x: r,
                    y: o,
                    ttWidth: a,
                    ttHeight: s
                };
            }
        },
        {
            key: "addDatapointEventsListeners",
            value: function(t) {
                var e = this.w.globals.dom.baseEl.querySelectorAll(".apexcharts-series-markers .apexcharts-marker, .apexcharts-bar-area, .apexcharts-candlestick-area, .apexcharts-boxPlot-area, .apexcharts-rangebar-area");
                this.addPathsEventListeners(e, t);
            }
        },
        {
            key: "addPathsEventListeners",
            value: function(t, e) {
                for(var i = this, a = function(a) {
                    var s = {
                        paths: t[a],
                        tooltipEl: e.tooltipEl,
                        tooltipY: e.tooltipY,
                        tooltipX: e.tooltipX,
                        elGrid: e.elGrid,
                        hoverArea: e.hoverArea,
                        ttItems: e.ttItems
                    };
                    [
                        "mousemove",
                        "mouseup",
                        "touchmove",
                        "mouseout",
                        "touchend"
                    ].map(function(e) {
                        return t[a].addEventListener(e, i.onSeriesHover.bind(i, s), {
                            capture: !1,
                            passive: !0
                        });
                    });
                }, s = 0; s < t.length; s++)a(s);
            }
        },
        {
            key: "onSeriesHover",
            value: function(t, e) {
                var i = this, a = Date.now() - this.lastHoverTime;
                a >= 100 ? this.seriesHover(t, e) : (clearTimeout(this.seriesHoverTimeout), this.seriesHoverTimeout = setTimeout(function() {
                    i.seriesHover(t, e);
                }, 100 - a));
            }
        },
        {
            key: "seriesHover",
            value: function(t, e) {
                var i = this;
                this.lastHoverTime = Date.now();
                var a = [], s = this.w;
                s.config.chart.group && (a = this.ctx.getGroupedCharts()), s.globals.axisCharts && (s.globals.minX === -1 / 0 && s.globals.maxX === 1 / 0 || 0 === s.globals.dataPoints) || (a.length ? a.forEach(function(a) {
                    var s = i.getElTooltip(a), r = {
                        paths: t.paths,
                        tooltipEl: s,
                        tooltipY: t.tooltipY,
                        tooltipX: t.tooltipX,
                        elGrid: t.elGrid,
                        hoverArea: t.hoverArea,
                        ttItems: a.w.globals.tooltip.ttItems
                    };
                    a.w.globals.minX === i.w.globals.minX && a.w.globals.maxX === i.w.globals.maxX && a.w.globals.tooltip.seriesHoverByContext({
                        chartCtx: a,
                        ttCtx: a.w.globals.tooltip,
                        opt: r,
                        e: e
                    });
                }) : this.seriesHoverByContext({
                    chartCtx: this.ctx,
                    ttCtx: this.w.globals.tooltip,
                    opt: t,
                    e: e
                }));
            }
        },
        {
            key: "seriesHoverByContext",
            value: function(t) {
                var e = t.chartCtx, i = t.ttCtx, a = t.opt, s = t.e, r = e.w, o = this.getElTooltip();
                if (o) {
                    if (i.tooltipRect = {
                        x: 0,
                        y: 0,
                        ttWidth: o.getBoundingClientRect().width,
                        ttHeight: o.getBoundingClientRect().height
                    }, i.e = s, i.tooltipUtil.hasBars() && !r.globals.comboCharts && !i.isBarShared) {
                        if (this.tConfig.onDatasetHover.highlightDataSeries) new $b705b473d3ec9641$var$z(e).toggleSeriesOnHover(s, s.target.parentNode);
                    }
                    i.fixedTooltip && i.drawFixedTooltipRect(), r.globals.axisCharts ? i.axisChartsTooltips({
                        e: s,
                        opt: a,
                        tooltipRect: i.tooltipRect
                    }) : i.nonAxisChartsTooltips({
                        e: s,
                        opt: a,
                        tooltipRect: i.tooltipRect
                    });
                }
            }
        },
        {
            key: "axisChartsTooltips",
            value: function(t) {
                var e, i, a = t.e, s = t.opt, r = this.w, o = s.elGrid.getBoundingClientRect(), n = "touchmove" === a.type ? a.touches[0].clientX : a.clientX, l = "touchmove" === a.type ? a.touches[0].clientY : a.clientY;
                if (this.clientY = l, this.clientX = n, r.globals.capturedSeriesIndex = -1, r.globals.capturedDataPointIndex = -1, l < o.top || l > o.top + o.height) this.handleMouseOut(s);
                else {
                    if (Array.isArray(this.tConfig.enabledOnSeries) && !r.config.tooltip.shared) {
                        var h = parseInt(s.paths.getAttribute("index"), 10);
                        if (this.tConfig.enabledOnSeries.indexOf(h) < 0) return void this.handleMouseOut(s);
                    }
                    var c = this.getElTooltip(), d = this.getElXCrosshairs(), g = r.globals.xyCharts || "bar" === r.config.chart.type && !r.globals.isBarHorizontal && this.tooltipUtil.hasBars() && this.tConfig.shared || r.globals.comboCharts && this.tooltipUtil.hasBars();
                    if ("mousemove" === a.type || "touchmove" === a.type || "mouseup" === a.type) {
                        if (r.globals.collapsedSeries.length + r.globals.ancillaryCollapsedSeries.length === r.globals.series.length) return;
                        null !== d && d.classList.add("apexcharts-active");
                        var u = this.yaxisTooltips.filter(function(t) {
                            return !0 === t;
                        });
                        if (null !== this.ycrosshairs && u.length && this.ycrosshairs.classList.add("apexcharts-active"), g && !this.showOnIntersect) this.handleStickyTooltip(a, n, l, s);
                        else if ("heatmap" === r.config.chart.type || "treemap" === r.config.chart.type) {
                            var p = this.intersect.handleHeatTreeTooltip({
                                e: a,
                                opt: s,
                                x: e,
                                y: i,
                                type: r.config.chart.type
                            });
                            e = p.x, i = p.y, c.style.left = e + "px", c.style.top = i + "px";
                        } else this.tooltipUtil.hasBars() && this.intersect.handleBarTooltip({
                            e: a,
                            opt: s
                        }), this.tooltipUtil.hasMarkers() && this.intersect.handleMarkerTooltip({
                            e: a,
                            opt: s,
                            x: e,
                            y: i
                        });
                        if (this.yaxisTooltips.length) for(var f = 0; f < r.config.yaxis.length; f++)this.axesTooltip.drawYaxisTooltipText(f, l, this.xyRatios);
                        s.tooltipEl.classList.add("apexcharts-active");
                    } else "mouseout" !== a.type && "touchend" !== a.type || this.handleMouseOut(s);
                }
            }
        },
        {
            key: "nonAxisChartsTooltips",
            value: function(t) {
                var e = t.e, i = t.opt, a = t.tooltipRect, s = this.w, r = i.paths.getAttribute("rel"), o = this.getElTooltip(), n = s.globals.dom.elWrap.getBoundingClientRect();
                if ("mousemove" === e.type || "touchmove" === e.type) {
                    o.classList.add("apexcharts-active"), this.tooltipLabels.drawSeriesTexts({
                        ttItems: i.ttItems,
                        i: parseInt(r, 10) - 1,
                        shared: !1
                    });
                    var l = s.globals.clientX - n.left - a.ttWidth / 2, h = s.globals.clientY - n.top - a.ttHeight - 10;
                    if (o.style.left = l + "px", o.style.top = h + "px", s.config.legend.tooltipHoverFormatter) {
                        var c = r - 1, d = (0, s.config.legend.tooltipHoverFormatter)(this.legendLabels[c].getAttribute("data:default-text"), {
                            seriesIndex: c,
                            dataPointIndex: c,
                            w: s
                        });
                        this.legendLabels[c].innerHTML = d;
                    }
                } else "mouseout" !== e.type && "touchend" !== e.type || (o.classList.remove("apexcharts-active"), s.config.legend.tooltipHoverFormatter && this.legendLabels.forEach(function(t) {
                    var e = t.getAttribute("data:default-text");
                    t.innerHTML = decodeURIComponent(e);
                }));
            }
        },
        {
            key: "handleStickyTooltip",
            value: function(t, e, i, a) {
                var s = this.w, r = this.tooltipUtil.getNearestValues({
                    context: this,
                    hoverArea: a.hoverArea,
                    elGrid: a.elGrid,
                    clientX: e,
                    clientY: i
                }), o = r.j, n = r.capturedSeries, l = a.elGrid.getBoundingClientRect();
                r.hoverX < 0 || r.hoverX > l.width ? this.handleMouseOut(a) : null !== n ? this.handleStickyCapturedSeries(t, n, a, o) : (this.tooltipUtil.isXoverlap(o) || s.globals.isBarHorizontal) && this.create(t, this, 0, o, a.ttItems);
            }
        },
        {
            key: "handleStickyCapturedSeries",
            value: function(t, e, i, a) {
                var s = this.w;
                if (!this.tConfig.shared && null === s.globals.series[e][a]) return void this.handleMouseOut(i);
                void 0 !== s.globals.series[e][a] ? this.tConfig.shared && this.tooltipUtil.isXoverlap(a) && this.tooltipUtil.isInitialSeriesSameLen() ? this.create(t, this, e, a, i.ttItems) : this.create(t, this, e, a, i.ttItems, !1) : this.tooltipUtil.isXoverlap(a) && this.create(t, this, 0, a, i.ttItems);
            }
        },
        {
            key: "deactivateHoverFilter",
            value: function() {
                for(var t = this.w, e = new $b705b473d3ec9641$var$b(this.ctx), i = t.globals.dom.Paper.select(".apexcharts-bar-area"), a = 0; a < i.length; a++)e.pathMouseLeave(i[a]);
            }
        },
        {
            key: "handleMouseOut",
            value: function(t) {
                var e = this.w, i = this.getElXCrosshairs();
                if (t.tooltipEl.classList.remove("apexcharts-active"), this.deactivateHoverFilter(), "bubble" !== e.config.chart.type && this.marker.resetPointsSize(), null !== i && i.classList.remove("apexcharts-active"), null !== this.ycrosshairs && this.ycrosshairs.classList.remove("apexcharts-active"), this.isXAxisTooltipEnabled && this.xaxisTooltip.classList.remove("apexcharts-active"), this.yaxisTooltips.length) {
                    null === this.yaxisTTEls && (this.yaxisTTEls = e.globals.dom.baseEl.querySelectorAll(".apexcharts-yaxistooltip"));
                    for(var a = 0; a < this.yaxisTTEls.length; a++)this.yaxisTTEls[a].classList.remove("apexcharts-active");
                }
                e.config.legend.tooltipHoverFormatter && this.legendLabels.forEach(function(t) {
                    var e = t.getAttribute("data:default-text");
                    t.innerHTML = decodeURIComponent(e);
                });
            }
        },
        {
            key: "markerClick",
            value: function(t, e, i) {
                var a = this.w;
                "function" == typeof a.config.chart.events.markerClick && a.config.chart.events.markerClick(t, this.ctx, {
                    seriesIndex: e,
                    dataPointIndex: i,
                    w: a
                }), this.ctx.events.fireEvent("markerClick", [
                    t,
                    this.ctx,
                    {
                        seriesIndex: e,
                        dataPointIndex: i,
                        w: a
                    }
                ]);
            }
        },
        {
            key: "create",
            value: function(t, e, i, a, s) {
                var r = arguments.length > 5 && void 0 !== arguments[5] ? arguments[5] : null, o = this.w, n = e;
                "mouseup" === t.type && this.markerClick(t, i, a), null === r && (r = this.tConfig.shared);
                var l = this.tooltipUtil.hasMarkers(), h = this.tooltipUtil.getElBars();
                if (o.config.legend.tooltipHoverFormatter) {
                    var c = o.config.legend.tooltipHoverFormatter, d = Array.from(this.legendLabels);
                    d.forEach(function(t) {
                        var e = t.getAttribute("data:default-text");
                        t.innerHTML = decodeURIComponent(e);
                    });
                    for(var g = 0; g < d.length; g++){
                        var u = d[g], p = parseInt(u.getAttribute("i"), 10), f = decodeURIComponent(u.getAttribute("data:default-text")), x = c(f, {
                            seriesIndex: r ? p : i,
                            dataPointIndex: a,
                            w: o
                        });
                        if (r) u.innerHTML = o.globals.collapsedSeriesIndices.indexOf(p) < 0 ? x : f;
                        else if (u.innerHTML = p === i ? x : f, i === p) break;
                    }
                }
                if (r) {
                    if (n.tooltipLabels.drawSeriesTexts({
                        ttItems: s,
                        i: i,
                        j: a,
                        shared: !this.showOnIntersect && this.tConfig.shared
                    }), l && (o.globals.markers.largestSize > 0 ? n.marker.enlargePoints(a) : n.tooltipPosition.moveDynamicPointsOnHover(a)), this.tooltipUtil.hasBars() && (this.barSeriesHeight = this.tooltipUtil.getBarsHeight(h), this.barSeriesHeight > 0)) {
                        var v = new $b705b473d3ec9641$var$b(this.ctx), m = o.globals.dom.Paper.select(".apexcharts-bar-area[j='".concat(a, "']"));
                        this.deactivateHoverFilter(), this.tooltipPosition.moveStickyTooltipOverBars(a);
                        for(var y = 0; y < m.length; y++)v.pathMouseEnter(m[y]);
                    }
                } else n.tooltipLabels.drawSeriesTexts({
                    shared: !1,
                    ttItems: s,
                    i: i,
                    j: a
                }), this.tooltipUtil.hasBars() && n.tooltipPosition.moveStickyTooltipOverBars(a), l && n.tooltipPosition.moveMarkers(i, a);
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$vt = function(t) {
    $b705b473d3ec9641$var$n(s, $b705b473d3ec9641$var$E);
    var i = $b705b473d3ec9641$var$d(s);
    function s() {
        return $b705b473d3ec9641$var$a(this, s), i.apply(this, arguments);
    }
    return $b705b473d3ec9641$var$r(s, [
        {
            key: "draw",
            value: function(t, i) {
                var a = this, s = this.w;
                this.graphics = new $b705b473d3ec9641$var$b(this.ctx), this.bar = new $b705b473d3ec9641$var$E(this.ctx, this.xyRatios);
                var r = new $b705b473d3ec9641$var$y(this.ctx, s);
                t = r.getLogSeries(t), this.yRatio = r.getLogYRatios(this.yRatio), this.barHelpers.initVariables(t), "100%" === s.config.chart.stackType && (t = s.globals.seriesPercent.slice()), this.series = t, this.totalItems = 0, this.prevY = [], this.prevX = [], this.prevYF = [], this.prevXF = [], this.prevYVal = [], this.prevXVal = [], this.xArrj = [], this.xArrjF = [], this.xArrjVal = [], this.yArrj = [], this.yArrjF = [], this.yArrjVal = [];
                for(var o = 0; o < t.length; o++)t[o].length > 0 && (this.totalItems += t[o].length);
                for(var n = this.graphics.group({
                    class: "apexcharts-bar-series apexcharts-plot-series"
                }), l = 0, h = 0, c = function(r, o) {
                    var c = void 0, d = void 0, g = void 0, u = void 0, f = [], x = [], b = s.globals.comboCharts ? i[r] : r;
                    a.yRatio.length > 1 && (a.yaxisIndex = b), a.isReversed = s.config.yaxis[a.yaxisIndex] && s.config.yaxis[a.yaxisIndex].reversed;
                    var v = a.graphics.group({
                        class: "apexcharts-series",
                        seriesName: $b705b473d3ec9641$var$p.escapeString(s.globals.seriesNames[b]),
                        rel: r + 1,
                        "data:realIndex": b
                    });
                    a.ctx.series.addCollapsedClassToSeries(v, b);
                    var m = a.graphics.group({
                        class: "apexcharts-datalabels",
                        "data:realIndex": b
                    }), y = 0, w = 0, k = a.initialPositions(l, h, c, d, g, u);
                    h = k.y, y = k.barHeight, d = k.yDivision, u = k.zeroW, l = k.x, w = k.barWidth, c = k.xDivision, g = k.zeroH, a.yArrj = [], a.yArrjF = [], a.yArrjVal = [], a.xArrj = [], a.xArrjF = [], a.xArrjVal = [], 1 === a.prevY.length && a.prevY[0].every(function(t) {
                        return isNaN(t);
                    }) && (a.prevY[0] = a.prevY[0].map(function(t) {
                        return g;
                    }), a.prevYF[0] = a.prevYF[0].map(function(t) {
                        return 0;
                    }));
                    for(var A = 0; A < s.globals.dataPoints; A++){
                        var S = a.barHelpers.getStrokeWidth(r, A, b), C = {
                            indexes: {
                                i: r,
                                j: A,
                                realIndex: b,
                                bc: o
                            },
                            strokeWidth: S,
                            x: l,
                            y: h,
                            elSeries: v
                        }, L = null;
                        a.isHorizontal ? (L = a.drawStackedBarPaths($b705b473d3ec9641$var$e($b705b473d3ec9641$var$e({}, C), {}, {
                            zeroW: u,
                            barHeight: y,
                            yDivision: d
                        })), w = a.series[r][A] / a.invertedYRatio) : (L = a.drawStackedColumnPaths($b705b473d3ec9641$var$e($b705b473d3ec9641$var$e({}, C), {}, {
                            xDivision: c,
                            barWidth: w,
                            zeroH: g
                        })), y = a.series[r][A] / a.yRatio[a.yaxisIndex]), h = L.y, l = L.x, f.push(l), x.push(h);
                        var P = a.barHelpers.getPathFillColor(t, r, A, b);
                        v = a.renderSeries({
                            realIndex: b,
                            pathFill: P,
                            j: A,
                            i: r,
                            pathFrom: L.pathFrom,
                            pathTo: L.pathTo,
                            strokeWidth: S,
                            elSeries: v,
                            x: l,
                            y: h,
                            series: t,
                            barHeight: y,
                            barWidth: w,
                            elDataLabelsWrap: m,
                            type: "bar",
                            visibleSeries: 0
                        });
                    }
                    s.globals.seriesXvalues[b] = f, s.globals.seriesYvalues[b] = x, a.prevY.push(a.yArrj), a.prevYF.push(a.yArrjF), a.prevYVal.push(a.yArrjVal), a.prevX.push(a.xArrj), a.prevXF.push(a.xArrjF), a.prevXVal.push(a.xArrjVal), n.add(v);
                }, d = 0, g = 0; d < t.length; d++, g++)c(d, g);
                return n;
            }
        },
        {
            key: "initialPositions",
            value: function(t, e, i, a, s, r) {
                var o, n, l = this.w;
                return this.isHorizontal ? (o = (o = a = l.globals.gridHeight / l.globals.dataPoints) * parseInt(l.config.plotOptions.bar.barHeight, 10) / 100, r = this.baseLineInvertedY + l.globals.padHorizontal + (this.isReversed ? l.globals.gridWidth : 0) - (this.isReversed ? 2 * this.baseLineInvertedY : 0), e = (a - o) / 2) : (n = i = l.globals.gridWidth / l.globals.dataPoints, n = l.globals.isXNumeric && l.globals.dataPoints > 1 ? (i = l.globals.minXDiff / this.xRatio) * parseInt(this.barOptions.columnWidth, 10) / 100 : n * parseInt(l.config.plotOptions.bar.columnWidth, 10) / 100, s = this.baseLineY[this.yaxisIndex] + (this.isReversed ? l.globals.gridHeight : 0) - (this.isReversed ? 2 * this.baseLineY[this.yaxisIndex] : 0), t = l.globals.padHorizontal + (i - n) / 2), {
                    x: t,
                    y: e,
                    yDivision: a,
                    xDivision: i,
                    barHeight: o,
                    barWidth: n,
                    zeroH: s,
                    zeroW: r
                };
            }
        },
        {
            key: "drawStackedBarPaths",
            value: function(t) {
                for(var e, i = t.indexes, a = t.barHeight, s = t.strokeWidth, r = t.zeroW, o = t.x, n = t.y, l = t.yDivision, h = t.elSeries, c = this.w, d = n, g = i.i, u = i.j, p = 0, f = 0; f < this.prevXF.length; f++)p += this.prevXF[f][u];
                if (g > 0) {
                    var x = r;
                    this.prevXVal[g - 1][u] < 0 ? x = this.series[g][u] >= 0 ? this.prevX[g - 1][u] + p - 2 * (this.isReversed ? p : 0) : this.prevX[g - 1][u] : this.prevXVal[g - 1][u] >= 0 && (x = this.series[g][u] >= 0 ? this.prevX[g - 1][u] : this.prevX[g - 1][u] - p + 2 * (this.isReversed ? p : 0)), e = x;
                } else e = r;
                o = null === this.series[g][u] ? e : e + this.series[g][u] / this.invertedYRatio - 2 * (this.isReversed ? this.series[g][u] / this.invertedYRatio : 0);
                var b = this.barHelpers.getBarpaths({
                    barYPosition: d,
                    barHeight: a,
                    x1: e,
                    x2: o,
                    strokeWidth: s,
                    series: this.series,
                    realIndex: i.realIndex,
                    i: g,
                    j: u,
                    w: c
                });
                return this.barHelpers.barBackground({
                    j: u,
                    i: g,
                    y1: d,
                    y2: a,
                    elSeries: h
                }), n += l, {
                    pathTo: b.pathTo,
                    pathFrom: b.pathFrom,
                    x: o,
                    y: n
                };
            }
        },
        {
            key: "drawStackedColumnPaths",
            value: function(t) {
                var e = t.indexes, i = t.x, a = t.y, s = t.xDivision, r = t.barWidth, o = t.zeroH;
                t.strokeWidth;
                var n = t.elSeries, l = this.w, h = e.i, c = e.j, d = e.bc;
                if (l.globals.isXNumeric) {
                    var g = l.globals.seriesX[h][c];
                    g || (g = 0), i = (g - l.globals.minX) / this.xRatio - r / 2;
                }
                for(var u, p = i, f = 0, x = 0; x < this.prevYF.length; x++)f += isNaN(this.prevYF[x][c]) ? 0 : this.prevYF[x][c];
                if (h > 0 && !l.globals.isXNumeric || h > 0 && l.globals.isXNumeric && l.globals.seriesX[h - 1][c] === l.globals.seriesX[h][c]) {
                    var b, v, m = Math.min(this.yRatio.length + 1, h + 1);
                    if (void 0 !== this.prevY[h - 1]) {
                        for(var y = 1; y < m; y++)if (!isNaN(this.prevY[h - y][c])) {
                            v = this.prevY[h - y][c];
                            break;
                        }
                    }
                    for(var w = 1; w < m; w++){
                        if (this.prevYVal[h - w][c] < 0) {
                            b = this.series[h][c] >= 0 ? v - f + 2 * (this.isReversed ? f : 0) : v;
                            break;
                        }
                        if (this.prevYVal[h - w][c] >= 0) {
                            b = this.series[h][c] >= 0 ? v : v + f - 2 * (this.isReversed ? f : 0);
                            break;
                        }
                    }
                    void 0 === b && (b = l.globals.gridHeight), u = this.prevYF[0].every(function(t) {
                        return 0 === t;
                    }) && this.prevYF.slice(1, h).every(function(t) {
                        return t.every(function(t) {
                            return isNaN(t);
                        });
                    }) ? l.globals.gridHeight - o : b;
                } else u = l.globals.gridHeight - o;
                a = u - this.series[h][c] / this.yRatio[this.yaxisIndex] + 2 * (this.isReversed ? this.series[h][c] / this.yRatio[this.yaxisIndex] : 0);
                var k = this.barHelpers.getColumnPaths({
                    barXPosition: p,
                    barWidth: r,
                    y1: u,
                    y2: a,
                    yRatio: this.yRatio[this.yaxisIndex],
                    strokeWidth: this.strokeWidth,
                    series: this.series,
                    realIndex: e.realIndex,
                    i: h,
                    j: c,
                    w: l
                });
                return this.barHelpers.barBackground({
                    bc: d,
                    j: c,
                    i: h,
                    x1: p,
                    x2: r,
                    elSeries: n
                }), i += s, {
                    pathTo: k.pathTo,
                    pathFrom: k.pathFrom,
                    x: l.globals.isXNumeric ? i - s : i,
                    y: a
                };
            }
        }
    ]), s;
}(), $b705b473d3ec9641$var$mt = function(t) {
    $b705b473d3ec9641$var$n(s, $b705b473d3ec9641$var$E);
    var i = $b705b473d3ec9641$var$d(s);
    function s() {
        return $b705b473d3ec9641$var$a(this, s), i.apply(this, arguments);
    }
    return $b705b473d3ec9641$var$r(s, [
        {
            key: "draw",
            value: function(t, i) {
                var a = this, s = this.w, r = new $b705b473d3ec9641$var$b(this.ctx), o = new $b705b473d3ec9641$var$L(this.ctx);
                this.candlestickOptions = this.w.config.plotOptions.candlestick, this.boxOptions = this.w.config.plotOptions.boxPlot, this.isHorizontal = s.config.plotOptions.bar.horizontal;
                var n = new $b705b473d3ec9641$var$y(this.ctx, s);
                t = n.getLogSeries(t), this.series = t, this.yRatio = n.getLogYRatios(this.yRatio), this.barHelpers.initVariables(t);
                for(var l = r.group({
                    class: "apexcharts-".concat(s.config.chart.type, "-series apexcharts-plot-series")
                }), h = function(n) {
                    a.isBoxPlot = "boxPlot" === s.config.chart.type || "boxPlot" === s.config.series[n].type;
                    var h, c, d, g, u = void 0, f = void 0, x = [], b = [], v = s.globals.comboCharts ? i[n] : n, m = r.group({
                        class: "apexcharts-series",
                        seriesName: $b705b473d3ec9641$var$p.escapeString(s.globals.seriesNames[v]),
                        rel: n + 1,
                        "data:realIndex": v
                    });
                    a.ctx.series.addCollapsedClassToSeries(m, v), t[n].length > 0 && (a.visibleI = a.visibleI + 1);
                    var y, w;
                    a.yRatio.length > 1 && (a.yaxisIndex = v);
                    var k = a.barHelpers.initialPositions();
                    f = k.y, y = k.barHeight, c = k.yDivision, g = k.zeroW, u = k.x, w = k.barWidth, h = k.xDivision, d = k.zeroH, b.push(u + w / 2);
                    for(var A = r.group({
                        class: "apexcharts-datalabels",
                        "data:realIndex": v
                    }), S = function(i) {
                        var r = a.barHelpers.getStrokeWidth(n, i, v), l = null, p = {
                            indexes: {
                                i: n,
                                j: i,
                                realIndex: v
                            },
                            x: u,
                            y: f,
                            strokeWidth: r,
                            elSeries: m
                        };
                        l = a.isHorizontal ? a.drawHorizontalBoxPaths($b705b473d3ec9641$var$e($b705b473d3ec9641$var$e({}, p), {}, {
                            yDivision: c,
                            barHeight: y,
                            zeroW: g
                        })) : a.drawVerticalBoxPaths($b705b473d3ec9641$var$e($b705b473d3ec9641$var$e({}, p), {}, {
                            xDivision: h,
                            barWidth: w,
                            zeroH: d
                        })), f = l.y, u = l.x, i > 0 && b.push(u + w / 2), x.push(f), l.pathTo.forEach(function(e, h) {
                            var c = !a.isBoxPlot && a.candlestickOptions.wick.useFillColor ? l.color[h] : s.globals.stroke.colors[n], d = o.fillPath({
                                seriesNumber: v,
                                dataPointIndex: i,
                                color: l.color[h],
                                value: t[n][i]
                            });
                            a.renderSeries({
                                realIndex: v,
                                pathFill: d,
                                lineFill: c,
                                j: i,
                                i: n,
                                pathFrom: l.pathFrom,
                                pathTo: e,
                                strokeWidth: r,
                                elSeries: m,
                                x: u,
                                y: f,
                                series: t,
                                barHeight: y,
                                barWidth: w,
                                elDataLabelsWrap: A,
                                visibleSeries: a.visibleI,
                                type: s.config.chart.type
                            });
                        });
                    }, C = 0; C < s.globals.dataPoints; C++)S(C);
                    s.globals.seriesXvalues[v] = b, s.globals.seriesYvalues[v] = x, l.add(m);
                }, c = 0; c < t.length; c++)h(c);
                return l;
            }
        },
        {
            key: "drawVerticalBoxPaths",
            value: function(t) {
                var e = t.indexes, i = t.x;
                t.y;
                var a = t.xDivision, s = t.barWidth, r = t.zeroH, o = t.strokeWidth, n = this.w, l = new $b705b473d3ec9641$var$b(this.ctx), h = e.i, c = e.j, d = !0, g = n.config.plotOptions.candlestick.colors.upward, u = n.config.plotOptions.candlestick.colors.downward, p = "";
                this.isBoxPlot && (p = [
                    this.boxOptions.colors.lower,
                    this.boxOptions.colors.upper
                ]);
                var f = this.yRatio[this.yaxisIndex], x = e.realIndex, v = this.getOHLCValue(x, c), m = r, y = r;
                v.o > v.c && (d = !1);
                var w = Math.min(v.o, v.c), k = Math.max(v.o, v.c), A = v.m;
                n.globals.isXNumeric && (i = (n.globals.seriesX[x][c] - n.globals.minX) / this.xRatio - s / 2);
                var S = i + s * this.visibleI;
                void 0 === this.series[h][c] || null === this.series[h][c] ? (w = r, k = r) : (w = r - w / f, k = r - k / f, m = r - v.h / f, y = r - v.l / f, A = r - v.m / f);
                var C = l.move(S, r), L = l.move(S + s / 2, w);
                return n.globals.previousPaths.length > 0 && (L = this.getPreviousPath(x, c, !0)), C = this.isBoxPlot ? [
                    l.move(S, w) + l.line(S + s / 2, w) + l.line(S + s / 2, m) + l.line(S + s / 4, m) + l.line(S + s - s / 4, m) + l.line(S + s / 2, m) + l.line(S + s / 2, w) + l.line(S + s, w) + l.line(S + s, A) + l.line(S, A) + l.line(S, w + o / 2),
                    l.move(S, A) + l.line(S + s, A) + l.line(S + s, k) + l.line(S + s / 2, k) + l.line(S + s / 2, y) + l.line(S + s - s / 4, y) + l.line(S + s / 4, y) + l.line(S + s / 2, y) + l.line(S + s / 2, k) + l.line(S, k) + l.line(S, A) + "z"
                ] : [
                    l.move(S, k) + l.line(S + s / 2, k) + l.line(S + s / 2, m) + l.line(S + s / 2, k) + l.line(S + s, k) + l.line(S + s, w) + l.line(S + s / 2, w) + l.line(S + s / 2, y) + l.line(S + s / 2, w) + l.line(S, w) + l.line(S, k - o / 2)
                ], L += l.move(S, w), n.globals.isXNumeric || (i += a), {
                    pathTo: C,
                    pathFrom: L,
                    x: i,
                    y: k,
                    barXPosition: S,
                    color: this.isBoxPlot ? p : d ? [
                        g
                    ] : [
                        u
                    ]
                };
            }
        },
        {
            key: "drawHorizontalBoxPaths",
            value: function(t) {
                var e = t.indexes;
                t.x;
                var i = t.y, a = t.yDivision, s = t.barHeight, r = t.zeroW, o = t.strokeWidth, n = this.w, l = new $b705b473d3ec9641$var$b(this.ctx), h = e.i, c = e.j, d = this.boxOptions.colors.lower;
                this.isBoxPlot && (d = [
                    this.boxOptions.colors.lower,
                    this.boxOptions.colors.upper
                ]);
                var g = this.invertedYRatio, u = e.realIndex, p = this.getOHLCValue(u, c), f = r, x = r, v = Math.min(p.o, p.c), m = Math.max(p.o, p.c), y = p.m;
                n.globals.isXNumeric && (i = (n.globals.seriesX[u][c] - n.globals.minX) / this.invertedXRatio - s / 2);
                var w = i + s * this.visibleI;
                void 0 === this.series[h][c] || null === this.series[h][c] ? (v = r, m = r) : (v = r + v / g, m = r + m / g, f = r + p.h / g, x = r + p.l / g, y = r + p.m / g);
                var k = l.move(r, w), A = l.move(v, w + s / 2);
                return n.globals.previousPaths.length > 0 && (A = this.getPreviousPath(u, c, !0)), k = [
                    l.move(v, w) + l.line(v, w + s / 2) + l.line(f, w + s / 2) + l.line(f, w + s / 2 - s / 4) + l.line(f, w + s / 2 + s / 4) + l.line(f, w + s / 2) + l.line(v, w + s / 2) + l.line(v, w + s) + l.line(y, w + s) + l.line(y, w) + l.line(v + o / 2, w),
                    l.move(y, w) + l.line(y, w + s) + l.line(m, w + s) + l.line(m, w + s / 2) + l.line(x, w + s / 2) + l.line(x, w + s - s / 4) + l.line(x, w + s / 4) + l.line(x, w + s / 2) + l.line(m, w + s / 2) + l.line(m, w) + l.line(y, w) + "z"
                ], A += l.move(v, w), n.globals.isXNumeric || (i += a), {
                    pathTo: k,
                    pathFrom: A,
                    x: m,
                    y: i,
                    barYPosition: w,
                    color: d
                };
            }
        },
        {
            key: "getOHLCValue",
            value: function(t, e) {
                var i = this.w;
                return {
                    o: this.isBoxPlot ? i.globals.seriesCandleH[t][e] : i.globals.seriesCandleO[t][e],
                    h: this.isBoxPlot ? i.globals.seriesCandleO[t][e] : i.globals.seriesCandleH[t][e],
                    m: i.globals.seriesCandleM[t][e],
                    l: this.isBoxPlot ? i.globals.seriesCandleC[t][e] : i.globals.seriesCandleL[t][e],
                    c: this.isBoxPlot ? i.globals.seriesCandleL[t][e] : i.globals.seriesCandleC[t][e]
                };
            }
        }
    ]), s;
}(), $b705b473d3ec9641$var$yt = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "checkColorRange",
            value: function() {
                var t = this.w, e = !1, i = t.config.plotOptions[t.config.chart.type];
                return i.colorScale.ranges.length > 0 && i.colorScale.ranges.map(function(t, i) {
                    t.from <= 0 && (e = !0);
                }), e;
            }
        },
        {
            key: "getShadeColor",
            value: function(t, e, i, a) {
                var s = this.w, r = 1, o = s.config.plotOptions[t].shadeIntensity, n = this.determineColor(t, e, i);
                s.globals.hasNegs || a ? r = s.config.plotOptions[t].reverseNegativeShade ? n.percent < 0 ? n.percent / 100 * (1.25 * o) : (1 - n.percent / 100) * (1.25 * o) : n.percent <= 0 ? 1 - (1 + n.percent / 100) * o : (1 - n.percent / 100) * o : (r = 1 - n.percent / 100, "treemap" === t && (r = (1 - n.percent / 100) * (1.25 * o)));
                var l = n.color, h = new $b705b473d3ec9641$var$p;
                return s.config.plotOptions[t].enableShades && (l = "dark" === this.w.config.theme.mode ? $b705b473d3ec9641$var$p.hexToRgba(h.shadeColor(-1 * r, n.color), s.config.fill.opacity) : $b705b473d3ec9641$var$p.hexToRgba(h.shadeColor(r, n.color), s.config.fill.opacity)), {
                    color: l,
                    colorProps: n
                };
            }
        },
        {
            key: "determineColor",
            value: function(t, e, i) {
                var a = this.w, s = a.globals.series[e][i], r = a.config.plotOptions[t], o = r.colorScale.inverse ? i : e;
                r.distributed && "treemap" === a.config.chart.type && (o = i);
                var n = a.globals.colors[o], l = null, h = Math.min.apply(Math, $b705b473d3ec9641$var$g(a.globals.series[e])), c = Math.max.apply(Math, $b705b473d3ec9641$var$g(a.globals.series[e]));
                r.distributed || "heatmap" !== t || (h = a.globals.minY, c = a.globals.maxY), void 0 !== r.colorScale.min && (h = r.colorScale.min < a.globals.minY ? r.colorScale.min : a.globals.minY, c = r.colorScale.max > a.globals.maxY ? r.colorScale.max : a.globals.maxY);
                var d = Math.abs(c) + Math.abs(h), u = 100 * s / (0 === d ? d - 1e-6 : d);
                r.colorScale.ranges.length > 0 && r.colorScale.ranges.map(function(t, e) {
                    if (s >= t.from && s <= t.to) {
                        n = t.color, l = t.foreColor ? t.foreColor : null, h = t.from, c = t.to;
                        var i = Math.abs(c) + Math.abs(h);
                        u = 100 * s / (0 === i ? i - 1e-6 : i);
                    }
                });
                return {
                    color: n,
                    foreColor: l,
                    percent: u
                };
            }
        },
        {
            key: "calculateDataLabels",
            value: function(t) {
                var e = t.text, i = t.x, a = t.y, s = t.i, r = t.j, o = t.colorProps, n = t.fontSize, l = this.w.config.dataLabels, h = new $b705b473d3ec9641$var$b(this.ctx), c = new $b705b473d3ec9641$var$M(this.ctx), d = null;
                if (l.enabled) {
                    d = h.group({
                        class: "apexcharts-data-labels"
                    });
                    var g = l.offsetX, u = l.offsetY, p = i + g, f = a + parseFloat(l.style.fontSize) / 3 + u;
                    c.plotDataLabelsText({
                        x: p,
                        y: f,
                        text: e,
                        i: s,
                        j: r,
                        color: o.foreColor,
                        parent: d,
                        fontSize: n,
                        dataLabelsConfig: l
                    });
                }
                return d;
            }
        },
        {
            key: "addListeners",
            value: function(t) {
                var e = new $b705b473d3ec9641$var$b(this.ctx);
                t.node.addEventListener("mouseenter", e.pathMouseEnter.bind(this, t)), t.node.addEventListener("mouseleave", e.pathMouseLeave.bind(this, t)), t.node.addEventListener("mousedown", e.pathMouseDown.bind(this, t));
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$wt = function() {
    function t(e, i) {
        $b705b473d3ec9641$var$a(this, t), this.ctx = e, this.w = e.w, this.xRatio = i.xRatio, this.yRatio = i.yRatio, this.dynamicAnim = this.w.config.chart.animations.dynamicAnimation, this.helpers = new $b705b473d3ec9641$var$yt(e), this.rectRadius = this.w.config.plotOptions.heatmap.radius, this.strokeWidth = this.w.config.stroke.show ? this.w.config.stroke.width : 0;
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "draw",
            value: function(t) {
                var e = this.w, i = new $b705b473d3ec9641$var$b(this.ctx), a = i.group({
                    class: "apexcharts-heatmap"
                });
                a.attr("clip-path", "url(#gridRectMask".concat(e.globals.cuid, ")"));
                var s = e.globals.gridWidth / e.globals.dataPoints, r = e.globals.gridHeight / e.globals.series.length, o = 0, n = !1;
                this.negRange = this.helpers.checkColorRange();
                var l = t.slice();
                e.config.yaxis[0].reversed && (n = !0, l.reverse());
                for(var h = n ? 0 : l.length - 1; n ? h < l.length : h >= 0; n ? h++ : h--){
                    var c = i.group({
                        class: "apexcharts-series apexcharts-heatmap-series",
                        seriesName: $b705b473d3ec9641$var$p.escapeString(e.globals.seriesNames[h]),
                        rel: h + 1,
                        "data:realIndex": h
                    });
                    if (this.ctx.series.addCollapsedClassToSeries(c, h), e.config.chart.dropShadow.enabled) {
                        var d = e.config.chart.dropShadow;
                        new $b705b473d3ec9641$var$x(this.ctx).dropShadow(c, d, h);
                    }
                    for(var g = 0, u = e.config.plotOptions.heatmap.shadeIntensity, f = 0; f < l[h].length; f++){
                        var v = this.helpers.getShadeColor(e.config.chart.type, h, f, this.negRange), m = v.color, y = v.colorProps;
                        if ("image" === e.config.fill.type) m = new $b705b473d3ec9641$var$L(this.ctx).fillPath({
                            seriesNumber: h,
                            dataPointIndex: f,
                            opacity: e.globals.hasNegs ? y.percent < 0 ? 1 - (1 + y.percent / 100) : u + y.percent / 100 : y.percent / 100,
                            patternID: $b705b473d3ec9641$var$p.randomId(),
                            width: e.config.fill.image.width ? e.config.fill.image.width : s,
                            height: e.config.fill.image.height ? e.config.fill.image.height : r
                        });
                        var w = this.rectRadius, k = i.drawRect(g, o, s, r, w);
                        if (k.attr({
                            cx: g,
                            cy: o
                        }), k.node.classList.add("apexcharts-heatmap-rect"), c.add(k), k.attr({
                            fill: m,
                            i: h,
                            index: h,
                            j: f,
                            val: l[h][f],
                            "stroke-width": this.strokeWidth,
                            stroke: e.config.plotOptions.heatmap.useFillColorAsStroke ? m : e.globals.stroke.colors[0],
                            color: m
                        }), this.helpers.addListeners(k), e.config.chart.animations.enabled && !e.globals.dataChanged) {
                            var A = 1;
                            e.globals.resized || (A = e.config.chart.animations.speed), this.animateHeatMap(k, g, o, s, r, A);
                        }
                        if (e.globals.dataChanged) {
                            var S = 1;
                            if (this.dynamicAnim.enabled && e.globals.shouldAnimate) {
                                S = this.dynamicAnim.speed;
                                var C = e.globals.previousPaths[h] && e.globals.previousPaths[h][f] && e.globals.previousPaths[h][f].color;
                                C || (C = "rgba(255, 255, 255, 0)"), this.animateHeatColor(k, $b705b473d3ec9641$var$p.isColorHex(C) ? C : $b705b473d3ec9641$var$p.rgb2hex(C), $b705b473d3ec9641$var$p.isColorHex(m) ? m : $b705b473d3ec9641$var$p.rgb2hex(m), S);
                            }
                        }
                        var P = (0, e.config.dataLabels.formatter)(e.globals.series[h][f], {
                            value: e.globals.series[h][f],
                            seriesIndex: h,
                            dataPointIndex: f,
                            w: e
                        }), T = this.helpers.calculateDataLabels({
                            text: P,
                            x: g + s / 2,
                            y: o + r / 2,
                            i: h,
                            j: f,
                            colorProps: y,
                            series: l
                        });
                        null !== T && c.add(T), g += s;
                    }
                    o += r, a.add(c);
                }
                var M = e.globals.yAxisScale[0].result.slice();
                e.config.yaxis[0].reversed ? M.unshift("") : M.push(""), e.globals.yAxisScale[0].result = M;
                var I = e.globals.gridHeight / e.globals.series.length;
                return e.config.yaxis[0].labels.offsetY = -I / 2, a;
            }
        },
        {
            key: "animateHeatMap",
            value: function(t, e, i, a, s, r) {
                var o = new $b705b473d3ec9641$var$f(this.ctx);
                o.animateRect(t, {
                    x: e + a / 2,
                    y: i + s / 2,
                    width: 0,
                    height: 0
                }, {
                    x: e,
                    y: i,
                    width: a,
                    height: s
                }, r, function() {
                    o.animationCompleted(t);
                });
            }
        },
        {
            key: "animateHeatColor",
            value: function(t, e, i, a) {
                t.attr({
                    fill: e
                }).animate(a).attr({
                    fill: i
                });
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$kt = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "drawYAxisTexts",
            value: function(t, e, i, a) {
                var s = this.w, r = s.config.yaxis[0], o = s.globals.yLabelFormatters[0];
                return new $b705b473d3ec9641$var$b(this.ctx).drawText({
                    x: t + r.labels.offsetX,
                    y: e + r.labels.offsetY,
                    text: o(a, i),
                    textAnchor: "middle",
                    fontSize: r.labels.style.fontSize,
                    fontFamily: r.labels.style.fontFamily,
                    foreColor: Array.isArray(r.labels.style.colors) ? r.labels.style.colors[i] : r.labels.style.colors
                });
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$At = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.ctx = e, this.w = e.w;
        var i = this.w;
        this.chartType = this.w.config.chart.type, this.initialAnim = this.w.config.chart.animations.enabled, this.dynamicAnim = this.initialAnim && this.w.config.chart.animations.dynamicAnimation.enabled, this.animBeginArr = [
            0
        ], this.animDur = 0, this.donutDataLabels = this.w.config.plotOptions.pie.donut.labels, this.lineColorArr = void 0 !== i.globals.stroke.colors ? i.globals.stroke.colors : i.globals.colors, this.defaultSize = Math.min(i.globals.gridWidth, i.globals.gridHeight), this.centerY = this.defaultSize / 2, this.centerX = i.globals.gridWidth / 2, "radialBar" === i.config.chart.type ? this.fullAngle = 360 : this.fullAngle = Math.abs(i.config.plotOptions.pie.endAngle - i.config.plotOptions.pie.startAngle), this.initialAngle = i.config.plotOptions.pie.startAngle % this.fullAngle, i.globals.radialSize = this.defaultSize / 2.05 - i.config.stroke.width - (i.config.chart.sparkline.enabled ? 0 : i.config.chart.dropShadow.blur), this.donutSize = i.globals.radialSize * parseInt(i.config.plotOptions.pie.donut.size, 10) / 100, this.maxY = 0, this.sliceLabels = [], this.sliceSizes = [], this.prevSectorAngleArr = [];
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "draw",
            value: function(t) {
                var e = this, i = this.w, a = new $b705b473d3ec9641$var$b(this.ctx);
                if (this.ret = a.group({
                    class: "apexcharts-pie"
                }), i.globals.noData) return this.ret;
                for(var s = 0, r = 0; r < t.length; r++)s += $b705b473d3ec9641$var$p.negToZero(t[r]);
                var o = [], n = a.group();
                0 === s && (s = 1e-5), t.forEach(function(t) {
                    e.maxY = Math.max(e.maxY, t);
                }), i.config.yaxis[0].max && (this.maxY = i.config.yaxis[0].max), "back" === i.config.grid.position && "polarArea" === this.chartType && this.drawPolarElements(this.ret);
                for(var l = 0; l < t.length; l++){
                    var h = this.fullAngle * $b705b473d3ec9641$var$p.negToZero(t[l]) / s;
                    o.push(h), "polarArea" === this.chartType ? (o[l] = this.fullAngle / t.length, this.sliceSizes.push(i.globals.radialSize * t[l] / this.maxY)) : this.sliceSizes.push(i.globals.radialSize);
                }
                if (i.globals.dataChanged) {
                    for(var c, d = 0, g = 0; g < i.globals.previousPaths.length; g++)d += $b705b473d3ec9641$var$p.negToZero(i.globals.previousPaths[g]);
                    for(var u = 0; u < i.globals.previousPaths.length; u++)c = this.fullAngle * $b705b473d3ec9641$var$p.negToZero(i.globals.previousPaths[u]) / d, this.prevSectorAngleArr.push(c);
                }
                this.donutSize < 0 && (this.donutSize = 0);
                var f = i.config.plotOptions.pie.customScale, x = i.globals.gridWidth / 2, v = i.globals.gridHeight / 2, m = x - i.globals.gridWidth / 2 * f, y = v - i.globals.gridHeight / 2 * f;
                if ("donut" === this.chartType) {
                    var w = a.drawCircle(this.donutSize);
                    w.attr({
                        cx: this.centerX,
                        cy: this.centerY,
                        fill: i.config.plotOptions.pie.donut.background ? i.config.plotOptions.pie.donut.background : "transparent"
                    }), n.add(w);
                }
                var k = this.drawArcs(o, t);
                if (this.sliceLabels.forEach(function(t) {
                    k.add(t);
                }), n.attr({
                    transform: "translate(".concat(m, ", ").concat(y, ") scale(").concat(f, ")")
                }), n.add(k), this.ret.add(n), this.donutDataLabels.show) {
                    var A = this.renderInnerDataLabels(this.donutDataLabels, {
                        hollowSize: this.donutSize,
                        centerX: this.centerX,
                        centerY: this.centerY,
                        opacity: this.donutDataLabels.show,
                        translateX: m,
                        translateY: y
                    });
                    this.ret.add(A);
                }
                return "front" === i.config.grid.position && "polarArea" === this.chartType && this.drawPolarElements(this.ret), this.ret;
            }
        },
        {
            key: "drawArcs",
            value: function(t, e) {
                var i = this.w, a = new $b705b473d3ec9641$var$x(this.ctx), s = new $b705b473d3ec9641$var$b(this.ctx), r = new $b705b473d3ec9641$var$L(this.ctx), o = s.group({
                    class: "apexcharts-slices"
                }), n = this.initialAngle, l = this.initialAngle, h = this.initialAngle, c = this.initialAngle;
                this.strokeWidth = i.config.stroke.show ? i.config.stroke.width : 0;
                for(var d = 0; d < t.length; d++){
                    var g = s.group({
                        class: "apexcharts-series apexcharts-pie-series",
                        seriesName: $b705b473d3ec9641$var$p.escapeString(i.globals.seriesNames[d]),
                        rel: d + 1,
                        "data:realIndex": d
                    });
                    o.add(g), l = c, h = (n = h) + t[d], c = l + this.prevSectorAngleArr[d];
                    var u = h < n ? this.fullAngle + h - n : h - n, f = r.fillPath({
                        seriesNumber: d,
                        size: this.sliceSizes[d],
                        value: e[d]
                    }), v = this.getChangedPath(l, c), m = s.drawPath({
                        d: v,
                        stroke: Array.isArray(this.lineColorArr) ? this.lineColorArr[d] : this.lineColorArr,
                        strokeWidth: 0,
                        fill: f,
                        fillOpacity: i.config.fill.opacity,
                        classes: "apexcharts-pie-area apexcharts-".concat(this.chartType.toLowerCase(), "-slice-").concat(d)
                    });
                    if (m.attr({
                        index: 0,
                        j: d
                    }), a.setSelectionFilter(m, 0, d), i.config.chart.dropShadow.enabled) {
                        var y = i.config.chart.dropShadow;
                        a.dropShadow(m, y, d);
                    }
                    this.addListeners(m, this.donutDataLabels), $b705b473d3ec9641$var$b.setAttrs(m.node, {
                        "data:angle": u,
                        "data:startAngle": n,
                        "data:strokeWidth": this.strokeWidth,
                        "data:value": e[d]
                    });
                    var w = {
                        x: 0,
                        y: 0
                    };
                    "pie" === this.chartType || "polarArea" === this.chartType ? w = $b705b473d3ec9641$var$p.polarToCartesian(this.centerX, this.centerY, i.globals.radialSize / 1.25 + i.config.plotOptions.pie.dataLabels.offset, (n + u / 2) % this.fullAngle) : "donut" === this.chartType && (w = $b705b473d3ec9641$var$p.polarToCartesian(this.centerX, this.centerY, (i.globals.radialSize + this.donutSize) / 2 + i.config.plotOptions.pie.dataLabels.offset, (n + u / 2) % this.fullAngle)), g.add(m);
                    var k = 0;
                    if (!this.initialAnim || i.globals.resized || i.globals.dataChanged ? this.animBeginArr.push(0) : (0 === (k = u / this.fullAngle * i.config.chart.animations.speed) && (k = 1), this.animDur = k + this.animDur, this.animBeginArr.push(this.animDur)), this.dynamicAnim && i.globals.dataChanged ? this.animatePaths(m, {
                        size: this.sliceSizes[d],
                        endAngle: h,
                        startAngle: n,
                        prevStartAngle: l,
                        prevEndAngle: c,
                        animateStartingPos: !0,
                        i: d,
                        animBeginArr: this.animBeginArr,
                        shouldSetPrevPaths: !0,
                        dur: i.config.chart.animations.dynamicAnimation.speed
                    }) : this.animatePaths(m, {
                        size: this.sliceSizes[d],
                        endAngle: h,
                        startAngle: n,
                        i: d,
                        totalItems: t.length - 1,
                        animBeginArr: this.animBeginArr,
                        dur: k
                    }), i.config.plotOptions.pie.expandOnClick && "polarArea" !== this.chartType && m.click(this.pieClicked.bind(this, d)), void 0 !== i.globals.selectedDataPoints[0] && i.globals.selectedDataPoints[0].indexOf(d) > -1 && this.pieClicked(d), i.config.dataLabels.enabled) {
                        var A = w.x, S = w.y, C = 100 * u / this.fullAngle + "%";
                        if (0 !== u && i.config.plotOptions.pie.dataLabels.minAngleToShowLabel < t[d]) {
                            var P = i.config.dataLabels.formatter;
                            void 0 !== P && (C = P(i.globals.seriesPercent[d][0], {
                                seriesIndex: d,
                                w: i
                            }));
                            var T = i.globals.dataLabels.style.colors[d], M = s.group({
                                class: "apexcharts-datalabels"
                            }), I = s.drawText({
                                x: A,
                                y: S,
                                text: C,
                                textAnchor: "middle",
                                fontSize: i.config.dataLabels.style.fontSize,
                                fontFamily: i.config.dataLabels.style.fontFamily,
                                fontWeight: i.config.dataLabels.style.fontWeight,
                                foreColor: T
                            });
                            if (M.add(I), i.config.dataLabels.dropShadow.enabled) {
                                var z = i.config.dataLabels.dropShadow;
                                a.dropShadow(I, z);
                            }
                            I.node.classList.add("apexcharts-pie-label"), i.config.chart.animations.animate && !1 === i.globals.resized && (I.node.classList.add("apexcharts-pie-label-delay"), I.node.style.animationDelay = i.config.chart.animations.speed / 940 + "s"), this.sliceLabels.push(M);
                        }
                    }
                }
                return o;
            }
        },
        {
            key: "addListeners",
            value: function(t, e) {
                var i = new $b705b473d3ec9641$var$b(this.ctx);
                t.node.addEventListener("mouseenter", i.pathMouseEnter.bind(this, t)), t.node.addEventListener("mouseleave", i.pathMouseLeave.bind(this, t)), t.node.addEventListener("mouseleave", this.revertDataLabelsInner.bind(this, t.node, e)), t.node.addEventListener("mousedown", i.pathMouseDown.bind(this, t)), this.donutDataLabels.total.showAlways || (t.node.addEventListener("mouseenter", this.printDataLabelsInner.bind(this, t.node, e)), t.node.addEventListener("mousedown", this.printDataLabelsInner.bind(this, t.node, e)));
            }
        },
        {
            key: "animatePaths",
            value: function(t, e) {
                var i = this.w, a = e.endAngle < e.startAngle ? this.fullAngle + e.endAngle - e.startAngle : e.endAngle - e.startAngle, s = a, r = e.startAngle, o = e.startAngle;
                void 0 !== e.prevStartAngle && void 0 !== e.prevEndAngle && (r = e.prevEndAngle, s = e.prevEndAngle < e.prevStartAngle ? this.fullAngle + e.prevEndAngle - e.prevStartAngle : e.prevEndAngle - e.prevStartAngle), e.i === i.config.series.length - 1 && (a + o > this.fullAngle ? e.endAngle = e.endAngle - (a + o) : a + o < this.fullAngle && (e.endAngle = e.endAngle + (this.fullAngle - (a + o)))), a === this.fullAngle && (a = this.fullAngle - .01), this.animateArc(t, r, o, a, s, e);
            }
        },
        {
            key: "animateArc",
            value: function(t, e, i, a, s, r) {
                var o, n = this, l = this.w, h = new $b705b473d3ec9641$var$f(this.ctx), c = r.size;
                (isNaN(e) || isNaN(s)) && (e = i, s = a, r.dur = 0);
                var d = a, g = i, u = e < i ? this.fullAngle + e - i : e - i;
                l.globals.dataChanged && r.shouldSetPrevPaths && r.prevEndAngle && (o = n.getPiePath({
                    me: n,
                    startAngle: r.prevStartAngle,
                    angle: r.prevEndAngle < r.prevStartAngle ? this.fullAngle + r.prevEndAngle - r.prevStartAngle : r.prevEndAngle - r.prevStartAngle,
                    size: c
                }), t.attr({
                    d: o
                })), 0 !== r.dur ? t.animate(r.dur, l.globals.easing, r.animBeginArr[r.i]).afterAll(function() {
                    "pie" !== n.chartType && "donut" !== n.chartType && "polarArea" !== n.chartType || this.animate(l.config.chart.animations.dynamicAnimation.speed).attr({
                        "stroke-width": n.strokeWidth
                    }), r.i === l.config.series.length - 1 && h.animationCompleted(t);
                }).during(function(l) {
                    d = u + (a - u) * l, r.animateStartingPos && (d = s + (a - s) * l, g = e - s + (i - (e - s)) * l), o = n.getPiePath({
                        me: n,
                        startAngle: g,
                        angle: d,
                        size: c
                    }), t.node.setAttribute("data:pathOrig", o), t.attr({
                        d: o
                    });
                }) : (o = n.getPiePath({
                    me: n,
                    startAngle: g,
                    angle: a,
                    size: c
                }), r.isTrack || (l.globals.animationEnded = !0), t.node.setAttribute("data:pathOrig", o), t.attr({
                    d: o,
                    "stroke-width": n.strokeWidth
                }));
            }
        },
        {
            key: "pieClicked",
            value: function(t) {
                var e, i = this.w, a = this, s = a.sliceSizes[t] + (i.config.plotOptions.pie.expandOnClick ? 4 : 0), r = i.globals.dom.Paper.select(".apexcharts-".concat(a.chartType.toLowerCase(), "-slice-").concat(t)).members[0];
                if ("true" !== r.attr("data:pieClicked")) {
                    var o = i.globals.dom.baseEl.getElementsByClassName("apexcharts-pie-area");
                    Array.prototype.forEach.call(o, function(t) {
                        t.setAttribute("data:pieClicked", "false");
                        var e = t.getAttribute("data:pathOrig");
                        t.setAttribute("d", e);
                    }), r.attr("data:pieClicked", "true");
                    var n = parseInt(r.attr("data:startAngle"), 10), l = parseInt(r.attr("data:angle"), 10);
                    e = a.getPiePath({
                        me: a,
                        startAngle: n,
                        angle: l,
                        size: s
                    }), 360 !== l && r.plot(e);
                } else {
                    r.attr({
                        "data:pieClicked": "false"
                    }), this.revertDataLabelsInner(r.node, this.donutDataLabels);
                    var h = r.attr("data:pathOrig");
                    r.attr({
                        d: h
                    });
                }
            }
        },
        {
            key: "getChangedPath",
            value: function(t, e) {
                var i = "";
                return this.dynamicAnim && this.w.globals.dataChanged && (i = this.getPiePath({
                    me: this,
                    startAngle: t,
                    angle: e - t,
                    size: this.size
                })), i;
            }
        },
        {
            key: "getPiePath",
            value: function(t) {
                var e = t.me, i = t.startAngle, a = t.angle, s = t.size, r = i, o = Math.PI * (r - 90) / 180, n = a + i;
                Math.ceil(n) >= this.fullAngle + this.w.config.plotOptions.pie.startAngle % this.fullAngle && (n = this.fullAngle + this.w.config.plotOptions.pie.startAngle % this.fullAngle - .01), Math.ceil(n) > this.fullAngle && (n -= this.fullAngle);
                var l = Math.PI * (n - 90) / 180, h = e.centerX + s * Math.cos(o), c = e.centerY + s * Math.sin(o), d = e.centerX + s * Math.cos(l), g = e.centerY + s * Math.sin(l), u = $b705b473d3ec9641$var$p.polarToCartesian(e.centerX, e.centerY, e.donutSize, n), f = $b705b473d3ec9641$var$p.polarToCartesian(e.centerX, e.centerY, e.donutSize, r), x = a > 180 ? 1 : 0, b = [
                    "M",
                    h,
                    c,
                    "A",
                    s,
                    s,
                    0,
                    x,
                    1,
                    d,
                    g
                ];
                return "donut" === e.chartType ? [].concat(b, [
                    "L",
                    u.x,
                    u.y,
                    "A",
                    e.donutSize,
                    e.donutSize,
                    0,
                    x,
                    0,
                    f.x,
                    f.y,
                    "L",
                    h,
                    c,
                    "z"
                ]).join(" ") : "pie" === e.chartType || "polarArea" === e.chartType ? [].concat(b, [
                    "L",
                    e.centerX,
                    e.centerY,
                    "L",
                    h,
                    c
                ]).join(" ") : [].concat(b).join(" ");
            }
        },
        {
            key: "drawPolarElements",
            value: function(t) {
                var e = this.w, i = new $b705b473d3ec9641$var$j(this.ctx), a = new $b705b473d3ec9641$var$b(this.ctx), s = new $b705b473d3ec9641$var$kt(this.ctx), r = a.group(), o = a.group(), n = i.niceScale(0, Math.ceil(this.maxY), e.config.yaxis[0].tickAmount, 0, !0), l = n.result.reverse(), h = n.result.length;
                this.maxY = n.niceMax;
                for(var c = e.globals.radialSize, d = c / (h - 1), g = 0; g < h - 1; g++){
                    var u = a.drawCircle(c);
                    if (u.attr({
                        cx: this.centerX,
                        cy: this.centerY,
                        fill: "none",
                        "stroke-width": e.config.plotOptions.polarArea.rings.strokeWidth,
                        stroke: e.config.plotOptions.polarArea.rings.strokeColor
                    }), e.config.yaxis[0].show) {
                        var p = s.drawYAxisTexts(this.centerX, this.centerY - c + parseInt(e.config.yaxis[0].labels.style.fontSize, 10) / 2, g, l[g]);
                        o.add(p);
                    }
                    r.add(u), c -= d;
                }
                this.drawSpokes(t), t.add(r), t.add(o);
            }
        },
        {
            key: "renderInnerDataLabels",
            value: function(t, e) {
                var i = this.w, a = new $b705b473d3ec9641$var$b(this.ctx), s = a.group({
                    class: "apexcharts-datalabels-group",
                    transform: "translate(".concat(e.translateX ? e.translateX : 0, ", ").concat(e.translateY ? e.translateY : 0, ") scale(").concat(i.config.plotOptions.pie.customScale, ")")
                }), r = t.total.show;
                s.node.style.opacity = e.opacity;
                var o, n, l = e.centerX, h = e.centerY;
                o = void 0 === t.name.color ? i.globals.colors[0] : t.name.color;
                var c = t.name.fontSize, d = t.name.fontFamily, g = t.name.fontWeight;
                n = void 0 === t.value.color ? i.config.chart.foreColor : t.value.color;
                var u = t.value.formatter, p = "", f = "";
                if (r ? (o = t.total.color, c = t.total.fontSize, d = t.total.fontFamily, g = t.total.fontWeight, f = t.total.label, p = t.total.formatter(i)) : 1 === i.globals.series.length && (p = u(i.globals.series[0], i), f = i.globals.seriesNames[0]), f && (f = t.name.formatter(f, t.total.show, i)), t.name.show) {
                    var x = a.drawText({
                        x: l,
                        y: h + parseFloat(t.name.offsetY),
                        text: f,
                        textAnchor: "middle",
                        foreColor: o,
                        fontSize: c,
                        fontWeight: g,
                        fontFamily: d
                    });
                    x.node.classList.add("apexcharts-datalabel-label"), s.add(x);
                }
                if (t.value.show) {
                    var v = t.name.show ? parseFloat(t.value.offsetY) + 16 : t.value.offsetY, m = a.drawText({
                        x: l,
                        y: h + v,
                        text: p,
                        textAnchor: "middle",
                        foreColor: n,
                        fontWeight: t.value.fontWeight,
                        fontSize: t.value.fontSize,
                        fontFamily: t.value.fontFamily
                    });
                    m.node.classList.add("apexcharts-datalabel-value"), s.add(m);
                }
                return s;
            }
        },
        {
            key: "printInnerLabels",
            value: function(t, e, i, a) {
                var s, r = this.w;
                a ? s = void 0 === t.name.color ? r.globals.colors[parseInt(a.parentNode.getAttribute("rel"), 10) - 1] : t.name.color : r.globals.series.length > 1 && t.total.show && (s = t.total.color);
                var o = r.globals.dom.baseEl.querySelector(".apexcharts-datalabel-label"), n = r.globals.dom.baseEl.querySelector(".apexcharts-datalabel-value");
                i = (0, t.value.formatter)(i, r), a || "function" != typeof t.total.formatter || (i = t.total.formatter(r));
                var l = e === t.total.label;
                e = t.name.formatter(e, l, r), null !== o && (o.textContent = e), null !== n && (n.textContent = i), null !== o && (o.style.fill = s);
            }
        },
        {
            key: "printDataLabelsInner",
            value: function(t, e) {
                var i = this.w, a = t.getAttribute("data:value"), s = i.globals.seriesNames[parseInt(t.parentNode.getAttribute("rel"), 10) - 1];
                i.globals.series.length > 1 && this.printInnerLabels(e, s, a, t);
                var r = i.globals.dom.baseEl.querySelector(".apexcharts-datalabels-group");
                null !== r && (r.style.opacity = 1);
            }
        },
        {
            key: "drawSpokes",
            value: function(t) {
                var e = this, i = this.w, a = new $b705b473d3ec9641$var$b(this.ctx), s = i.config.plotOptions.polarArea.spokes;
                if (0 !== s.strokeWidth) {
                    for(var r = [], o = 360 / i.globals.series.length, n = 0; n < i.globals.series.length; n++)r.push($b705b473d3ec9641$var$p.polarToCartesian(this.centerX, this.centerY, i.globals.radialSize, i.config.plotOptions.pie.startAngle + o * n));
                    r.forEach(function(i, r) {
                        var o = a.drawLine(i.x, i.y, e.centerX, e.centerY, Array.isArray(s.connectorColors) ? s.connectorColors[r] : s.connectorColors);
                        t.add(o);
                    });
                }
            }
        },
        {
            key: "revertDataLabelsInner",
            value: function(t, e, i) {
                var a = this, s = this.w, r = s.globals.dom.baseEl.querySelector(".apexcharts-datalabels-group"), o = !1, n = s.globals.dom.baseEl.getElementsByClassName("apexcharts-pie-area"), l = function(t) {
                    var i = t.makeSliceOut, s = t.printLabel;
                    Array.prototype.forEach.call(n, function(t) {
                        "true" === t.getAttribute("data:pieClicked") && (i && (o = !0), s && a.printDataLabelsInner(t, e));
                    });
                };
                if (l({
                    makeSliceOut: !0,
                    printLabel: !1
                }), e.total.show && s.globals.series.length > 1) o && !e.total.showAlways ? l({
                    makeSliceOut: !1,
                    printLabel: !0
                }) : this.printInnerLabels(e, e.total.label, e.total.formatter(s));
                else if (l({
                    makeSliceOut: !1,
                    printLabel: !0
                }), !o) {
                    if (s.globals.selectedDataPoints.length && s.globals.series.length > 1) {
                        if (s.globals.selectedDataPoints[0].length > 0) {
                            var h = s.globals.selectedDataPoints[0], c = s.globals.dom.baseEl.querySelector(".apexcharts-".concat(this.chartType.toLowerCase(), "-slice-").concat(h));
                            this.printDataLabelsInner(c, e);
                        } else r && s.globals.selectedDataPoints.length && 0 === s.globals.selectedDataPoints[0].length && (r.style.opacity = 0);
                    } else r && s.globals.series.length > 1 && (r.style.opacity = 0);
                }
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$St = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.ctx = e, this.w = e.w, this.chartType = this.w.config.chart.type, this.initialAnim = this.w.config.chart.animations.enabled, this.dynamicAnim = this.initialAnim && this.w.config.chart.animations.dynamicAnimation.enabled, this.animDur = 0;
        var i = this.w;
        this.graphics = new $b705b473d3ec9641$var$b(this.ctx), this.lineColorArr = void 0 !== i.globals.stroke.colors ? i.globals.stroke.colors : i.globals.colors, this.defaultSize = i.globals.svgHeight < i.globals.svgWidth ? i.globals.gridHeight + 1.5 * i.globals.goldenPadding : i.globals.gridWidth, this.isLog = i.config.yaxis[0].logarithmic, this.coreUtils = new $b705b473d3ec9641$var$y(this.ctx), this.maxValue = this.isLog ? this.coreUtils.getLogVal(i.globals.maxY, 0) : i.globals.maxY, this.minValue = this.isLog ? this.coreUtils.getLogVal(this.w.globals.minY, 0) : i.globals.minY, this.polygons = i.config.plotOptions.radar.polygons, this.strokeWidth = i.config.stroke.show ? i.config.stroke.width : 0, this.size = this.defaultSize / 2.1 - this.strokeWidth - i.config.chart.dropShadow.blur, i.config.xaxis.labels.show && (this.size = this.size - i.globals.xAxisLabelsWidth / 1.75), void 0 !== i.config.plotOptions.radar.size && (this.size = i.config.plotOptions.radar.size), this.dataRadiusOfPercent = [], this.dataRadius = [], this.angleArr = [], this.yaxisLabelsTextsPos = [];
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "draw",
            value: function(t) {
                var i = this, a = this.w, s = new $b705b473d3ec9641$var$L(this.ctx), r = [], o = new $b705b473d3ec9641$var$M(this.ctx);
                t.length && (this.dataPointsLen = t[a.globals.maxValsInArrayIndex].length), this.disAngle = 2 * Math.PI / this.dataPointsLen;
                var n = a.globals.gridWidth / 2, l = a.globals.gridHeight / 2, h = n + a.config.plotOptions.radar.offsetX, c = l + a.config.plotOptions.radar.offsetY, d = this.graphics.group({
                    class: "apexcharts-radar-series apexcharts-plot-series",
                    transform: "translate(".concat(h || 0, ", ").concat(c || 0, ")")
                }), g = [], u = null, f = null;
                if (this.yaxisLabels = this.graphics.group({
                    class: "apexcharts-yaxis"
                }), t.forEach(function(t, n) {
                    var l = t.length === a.globals.dataPoints, h = i.graphics.group().attr({
                        class: "apexcharts-series",
                        "data:longestSeries": l,
                        seriesName: $b705b473d3ec9641$var$p.escapeString(a.globals.seriesNames[n]),
                        rel: n + 1,
                        "data:realIndex": n
                    });
                    i.dataRadiusOfPercent[n] = [], i.dataRadius[n] = [], i.angleArr[n] = [], t.forEach(function(t, e) {
                        var a = Math.abs(i.maxValue - i.minValue);
                        t += Math.abs(i.minValue), i.isLog && (t = i.coreUtils.getLogVal(t, 0)), i.dataRadiusOfPercent[n][e] = t / a, i.dataRadius[n][e] = i.dataRadiusOfPercent[n][e] * i.size, i.angleArr[n][e] = e * i.disAngle;
                    }), g = i.getDataPointsPos(i.dataRadius[n], i.angleArr[n]);
                    var c = i.createPaths(g, {
                        x: 0,
                        y: 0
                    });
                    u = i.graphics.group({
                        class: "apexcharts-series-markers-wrap apexcharts-element-hidden"
                    }), f = i.graphics.group({
                        class: "apexcharts-datalabels",
                        "data:realIndex": n
                    }), a.globals.delayedElements.push({
                        el: u.node,
                        index: n
                    });
                    var d = {
                        i: n,
                        realIndex: n,
                        animationDelay: n,
                        initialSpeed: a.config.chart.animations.speed,
                        dataChangeSpeed: a.config.chart.animations.dynamicAnimation.speed,
                        className: "apexcharts-radar",
                        shouldClipToGrid: !1,
                        bindEventsOnPaths: !1,
                        stroke: a.globals.stroke.colors[n],
                        strokeLineCap: a.config.stroke.lineCap
                    }, b = null;
                    a.globals.previousPaths.length > 0 && (b = i.getPreviousPath(n));
                    for(var v = 0; v < c.linePathsTo.length; v++){
                        var m = i.graphics.renderPaths($b705b473d3ec9641$var$e($b705b473d3ec9641$var$e({}, d), {}, {
                            pathFrom: null === b ? c.linePathsFrom[v] : b,
                            pathTo: c.linePathsTo[v],
                            strokeWidth: Array.isArray(i.strokeWidth) ? i.strokeWidth[n] : i.strokeWidth,
                            fill: "none",
                            drawShadow: !1
                        }));
                        h.add(m);
                        var y = s.fillPath({
                            seriesNumber: n
                        }), w = i.graphics.renderPaths($b705b473d3ec9641$var$e($b705b473d3ec9641$var$e({}, d), {}, {
                            pathFrom: null === b ? c.areaPathsFrom[v] : b,
                            pathTo: c.areaPathsTo[v],
                            strokeWidth: 0,
                            fill: y,
                            drawShadow: !1
                        }));
                        if (a.config.chart.dropShadow.enabled) {
                            var k = new $b705b473d3ec9641$var$x(i.ctx), A = a.config.chart.dropShadow;
                            k.dropShadow(w, Object.assign({}, A, {
                                noUserSpaceOnUse: !0
                            }), n);
                        }
                        h.add(w);
                    }
                    t.forEach(function(t, s) {
                        var r = new $b705b473d3ec9641$var$P(i.ctx).getMarkerConfig({
                            cssClass: "apexcharts-marker",
                            seriesIndex: n,
                            dataPointIndex: s
                        }), l = i.graphics.drawMarker(g[s].x, g[s].y, r);
                        l.attr("rel", s), l.attr("j", s), l.attr("index", n), l.node.setAttribute("default-marker-size", r.pSize);
                        var c = i.graphics.group({
                            class: "apexcharts-series-markers"
                        });
                        c && c.add(l), u.add(c), h.add(u);
                        var d = a.config.dataLabels;
                        if (d.enabled) {
                            var p = d.formatter(a.globals.series[n][s], {
                                seriesIndex: n,
                                dataPointIndex: s,
                                w: a
                            });
                            o.plotDataLabelsText({
                                x: g[s].x,
                                y: g[s].y,
                                text: p,
                                textAnchor: "middle",
                                i: n,
                                j: n,
                                parent: f,
                                offsetCorrection: !1,
                                dataLabelsConfig: $b705b473d3ec9641$var$e({}, d)
                            });
                        }
                        h.add(f);
                    }), r.push(h);
                }), this.drawPolygons({
                    parent: d
                }), a.config.xaxis.labels.show) {
                    var b = this.drawXAxisTexts();
                    d.add(b);
                }
                return r.forEach(function(t) {
                    d.add(t);
                }), d.add(this.yaxisLabels), d;
            }
        },
        {
            key: "drawPolygons",
            value: function(t) {
                for(var e = this, i = this.w, a = t.parent, s = new $b705b473d3ec9641$var$kt(this.ctx), r = i.globals.yAxisScale[0].result.reverse(), o = r.length, n = [], l = this.size / (o - 1), h = 0; h < o; h++)n[h] = l * h;
                n.reverse();
                var c = [], d = [];
                n.forEach(function(t, i) {
                    var a = $b705b473d3ec9641$var$p.getPolygonPos(t, e.dataPointsLen), s = "";
                    a.forEach(function(t, a) {
                        if (0 === i) {
                            var r = e.graphics.drawLine(t.x, t.y, 0, 0, Array.isArray(e.polygons.connectorColors) ? e.polygons.connectorColors[a] : e.polygons.connectorColors);
                            d.push(r);
                        }
                        0 === a && e.yaxisLabelsTextsPos.push({
                            x: t.x,
                            y: t.y
                        }), s += t.x + "," + t.y + " ";
                    }), c.push(s);
                }), c.forEach(function(t, s) {
                    var r = e.polygons.strokeColors, o = e.polygons.strokeWidth, n = e.graphics.drawPolygon(t, Array.isArray(r) ? r[s] : r, Array.isArray(o) ? o[s] : o, i.globals.radarPolygons.fill.colors[s]);
                    a.add(n);
                }), d.forEach(function(t) {
                    a.add(t);
                }), i.config.yaxis[0].show && this.yaxisLabelsTextsPos.forEach(function(t, i) {
                    var a = s.drawYAxisTexts(t.x, t.y, i, r[i]);
                    e.yaxisLabels.add(a);
                });
            }
        },
        {
            key: "drawXAxisTexts",
            value: function() {
                var t = this, i = this.w, a = i.config.xaxis.labels, s = this.graphics.group({
                    class: "apexcharts-xaxis"
                }), r = $b705b473d3ec9641$var$p.getPolygonPos(this.size, this.dataPointsLen);
                return i.globals.labels.forEach(function(o, n) {
                    var l = i.config.xaxis.labels.formatter, h = new $b705b473d3ec9641$var$M(t.ctx);
                    if (r[n]) {
                        var c = t.getTextPos(r[n], t.size), d = l(o, {
                            seriesIndex: -1,
                            dataPointIndex: n,
                            w: i
                        });
                        h.plotDataLabelsText({
                            x: c.newX,
                            y: c.newY,
                            text: d,
                            textAnchor: c.textAnchor,
                            i: n,
                            j: n,
                            parent: s,
                            color: Array.isArray(a.style.colors) && a.style.colors[n] ? a.style.colors[n] : "#a8a8a8",
                            dataLabelsConfig: $b705b473d3ec9641$var$e({
                                textAnchor: c.textAnchor,
                                dropShadow: {
                                    enabled: !1
                                }
                            }, a),
                            offsetCorrection: !1
                        });
                    }
                }), s;
            }
        },
        {
            key: "createPaths",
            value: function(t, e) {
                var i = this, a = [], s = [], r = [], o = [];
                if (t.length) {
                    s = [
                        this.graphics.move(e.x, e.y)
                    ], o = [
                        this.graphics.move(e.x, e.y)
                    ];
                    var n = this.graphics.move(t[0].x, t[0].y), l = this.graphics.move(t[0].x, t[0].y);
                    t.forEach(function(e, a) {
                        n += i.graphics.line(e.x, e.y), l += i.graphics.line(e.x, e.y), a === t.length - 1 && (n += "Z", l += "Z");
                    }), a.push(n), r.push(l);
                }
                return {
                    linePathsFrom: s,
                    linePathsTo: a,
                    areaPathsFrom: o,
                    areaPathsTo: r
                };
            }
        },
        {
            key: "getTextPos",
            value: function(t, e) {
                var i = "middle", a = t.x, s = t.y;
                return Math.abs(t.x) >= 10 ? t.x > 0 ? (i = "start", a += 10) : t.x < 0 && (i = "end", a -= 10) : i = "middle", Math.abs(t.y) >= e - 10 && (t.y < 0 ? s -= 10 : t.y > 0 && (s += 10)), {
                    textAnchor: i,
                    newX: a,
                    newY: s
                };
            }
        },
        {
            key: "getPreviousPath",
            value: function(t) {
                for(var e = this.w, i = null, a = 0; a < e.globals.previousPaths.length; a++){
                    var s = e.globals.previousPaths[a];
                    s.paths.length > 0 && parseInt(s.realIndex, 10) === parseInt(t, 10) && void 0 !== e.globals.previousPaths[a].paths[0] && (i = e.globals.previousPaths[a].paths[0].d);
                }
                return i;
            }
        },
        {
            key: "getDataPointsPos",
            value: function(t, e) {
                var i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : this.dataPointsLen;
                t = t || [], e = e || [];
                for(var a = [], s = 0; s < i; s++){
                    var r = {};
                    r.x = t[s] * Math.sin(e[s]), r.y = -t[s] * Math.cos(e[s]), a.push(r);
                }
                return a;
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$Ct = function(t) {
    $b705b473d3ec9641$var$n(i, $b705b473d3ec9641$var$At);
    var e = $b705b473d3ec9641$var$d(i);
    function i(t) {
        var s;
        $b705b473d3ec9641$var$a(this, i), (s = e.call(this, t)).ctx = t, s.w = t.w, s.animBeginArr = [
            0
        ], s.animDur = 0;
        var r = s.w;
        return s.startAngle = r.config.plotOptions.radialBar.startAngle, s.endAngle = r.config.plotOptions.radialBar.endAngle, s.totalAngle = Math.abs(r.config.plotOptions.radialBar.endAngle - r.config.plotOptions.radialBar.startAngle), s.trackStartAngle = r.config.plotOptions.radialBar.track.startAngle, s.trackEndAngle = r.config.plotOptions.radialBar.track.endAngle, s.donutDataLabels = s.w.config.plotOptions.radialBar.dataLabels, s.radialDataLabels = s.donutDataLabels, s.trackStartAngle || (s.trackStartAngle = s.startAngle), s.trackEndAngle || (s.trackEndAngle = s.endAngle), 360 === s.endAngle && (s.endAngle = 359.99), s.margin = parseInt(r.config.plotOptions.radialBar.track.margin, 10), s;
    }
    return $b705b473d3ec9641$var$r(i, [
        {
            key: "draw",
            value: function(t) {
                var e = this.w, i = new $b705b473d3ec9641$var$b(this.ctx), a = i.group({
                    class: "apexcharts-radialbar"
                });
                if (e.globals.noData) return a;
                var s = i.group(), r = this.defaultSize / 2, o = e.globals.gridWidth / 2, n = this.defaultSize / 2.05;
                e.config.chart.sparkline.enabled || (n = n - e.config.stroke.width - e.config.chart.dropShadow.blur);
                var l = e.globals.fill.colors;
                if (e.config.plotOptions.radialBar.track.show) {
                    var h = this.drawTracks({
                        size: n,
                        centerX: o,
                        centerY: r,
                        colorArr: l,
                        series: t
                    });
                    s.add(h);
                }
                var c = this.drawArcs({
                    size: n,
                    centerX: o,
                    centerY: r,
                    colorArr: l,
                    series: t
                }), d = 360;
                e.config.plotOptions.radialBar.startAngle < 0 && (d = this.totalAngle);
                var g = (360 - d) / 360;
                if (e.globals.radialSize = n - n * g, this.radialDataLabels.value.show) {
                    var u = Math.max(this.radialDataLabels.value.offsetY, this.radialDataLabels.name.offsetY);
                    e.globals.radialSize += u * g;
                }
                return s.add(c.g), "front" === e.config.plotOptions.radialBar.hollow.position && (c.g.add(c.elHollow), c.dataLabels && c.g.add(c.dataLabels)), a.add(s), a;
            }
        },
        {
            key: "drawTracks",
            value: function(t) {
                var e = this.w, i = new $b705b473d3ec9641$var$b(this.ctx), a = i.group({
                    class: "apexcharts-tracks"
                }), s = new $b705b473d3ec9641$var$x(this.ctx), r = new $b705b473d3ec9641$var$L(this.ctx), o = this.getStrokeWidth(t);
                t.size = t.size - o / 2;
                for(var n = 0; n < t.series.length; n++){
                    var l = i.group({
                        class: "apexcharts-radialbar-track apexcharts-track"
                    });
                    a.add(l), l.attr({
                        rel: n + 1
                    }), t.size = t.size - o - this.margin;
                    var h = e.config.plotOptions.radialBar.track, c = r.fillPath({
                        seriesNumber: 0,
                        size: t.size,
                        fillColors: Array.isArray(h.background) ? h.background[n] : h.background,
                        solid: !0
                    }), d = this.trackStartAngle, g = this.trackEndAngle;
                    Math.abs(g) + Math.abs(d) >= 360 && (g = 360 - Math.abs(this.startAngle) - .1);
                    var u = i.drawPath({
                        d: "",
                        stroke: c,
                        strokeWidth: o * parseInt(h.strokeWidth, 10) / 100,
                        fill: "none",
                        strokeOpacity: h.opacity,
                        classes: "apexcharts-radialbar-area"
                    });
                    if (h.dropShadow.enabled) {
                        var p = h.dropShadow;
                        s.dropShadow(u, p);
                    }
                    l.add(u), u.attr("id", "apexcharts-radialbarTrack-" + n), this.animatePaths(u, {
                        centerX: t.centerX,
                        centerY: t.centerY,
                        endAngle: g,
                        startAngle: d,
                        size: t.size,
                        i: n,
                        totalItems: 2,
                        animBeginArr: 0,
                        dur: 0,
                        isTrack: !0,
                        easing: e.globals.easing
                    });
                }
                return a;
            }
        },
        {
            key: "drawArcs",
            value: function(t) {
                var e = this.w, i = new $b705b473d3ec9641$var$b(this.ctx), a = new $b705b473d3ec9641$var$L(this.ctx), s = new $b705b473d3ec9641$var$x(this.ctx), r = i.group(), o = this.getStrokeWidth(t);
                t.size = t.size - o / 2;
                var n = e.config.plotOptions.radialBar.hollow.background, l = t.size - o * t.series.length - this.margin * t.series.length - o * parseInt(e.config.plotOptions.radialBar.track.strokeWidth, 10) / 100 / 2, h = l - e.config.plotOptions.radialBar.hollow.margin;
                void 0 !== e.config.plotOptions.radialBar.hollow.image && (n = this.drawHollowImage(t, r, l, n));
                var c = this.drawHollow({
                    size: h,
                    centerX: t.centerX,
                    centerY: t.centerY,
                    fill: n || "transparent"
                });
                if (e.config.plotOptions.radialBar.hollow.dropShadow.enabled) {
                    var d = e.config.plotOptions.radialBar.hollow.dropShadow;
                    s.dropShadow(c, d);
                }
                var g = 1;
                !this.radialDataLabels.total.show && e.globals.series.length > 1 && (g = 0);
                var u = null;
                this.radialDataLabels.show && (u = this.renderInnerDataLabels(this.radialDataLabels, {
                    hollowSize: l,
                    centerX: t.centerX,
                    centerY: t.centerY,
                    opacity: g
                })), "back" === e.config.plotOptions.radialBar.hollow.position && (r.add(c), u && r.add(u));
                var f = !1;
                e.config.plotOptions.radialBar.inverseOrder && (f = !0);
                for(var v = f ? t.series.length - 1 : 0; f ? v >= 0 : v < t.series.length; f ? v-- : v++){
                    var m = i.group({
                        class: "apexcharts-series apexcharts-radial-series",
                        seriesName: $b705b473d3ec9641$var$p.escapeString(e.globals.seriesNames[v])
                    });
                    r.add(m), m.attr({
                        rel: v + 1,
                        "data:realIndex": v
                    }), this.ctx.series.addCollapsedClassToSeries(m, v), t.size = t.size - o - this.margin;
                    var y = a.fillPath({
                        seriesNumber: v,
                        size: t.size,
                        value: t.series[v]
                    }), w = this.startAngle, k = void 0, A = $b705b473d3ec9641$var$p.negToZero(t.series[v] > 100 ? 100 : t.series[v]) / 100, S = Math.round(this.totalAngle * A) + this.startAngle, C = void 0;
                    e.globals.dataChanged && (k = this.startAngle, C = Math.round(this.totalAngle * $b705b473d3ec9641$var$p.negToZero(e.globals.previousPaths[v]) / 100) + k), Math.abs(S) + Math.abs(w) >= 360 && (S -= .01), Math.abs(C) + Math.abs(k) >= 360 && (C -= .01);
                    var P = S - w, T = Array.isArray(e.config.stroke.dashArray) ? e.config.stroke.dashArray[v] : e.config.stroke.dashArray, M = i.drawPath({
                        d: "",
                        stroke: y,
                        strokeWidth: o,
                        fill: "none",
                        fillOpacity: e.config.fill.opacity,
                        classes: "apexcharts-radialbar-area apexcharts-radialbar-slice-" + v,
                        strokeDashArray: T
                    });
                    if ($b705b473d3ec9641$var$b.setAttrs(M.node, {
                        "data:angle": P,
                        "data:value": t.series[v]
                    }), e.config.chart.dropShadow.enabled) {
                        var I = e.config.chart.dropShadow;
                        s.dropShadow(M, I, v);
                    }
                    s.setSelectionFilter(M, 0, v), this.addListeners(M, this.radialDataLabels), m.add(M), M.attr({
                        index: 0,
                        j: v
                    });
                    var z = 0;
                    !this.initialAnim || e.globals.resized || e.globals.dataChanged || (z = e.config.chart.animations.speed), e.globals.dataChanged && (z = e.config.chart.animations.dynamicAnimation.speed), this.animDur = z / (1.2 * t.series.length) + this.animDur, this.animBeginArr.push(this.animDur), this.animatePaths(M, {
                        centerX: t.centerX,
                        centerY: t.centerY,
                        endAngle: S,
                        startAngle: w,
                        prevEndAngle: C,
                        prevStartAngle: k,
                        size: t.size,
                        i: v,
                        totalItems: 2,
                        animBeginArr: this.animBeginArr,
                        dur: z,
                        shouldSetPrevPaths: !0,
                        easing: e.globals.easing
                    });
                }
                return {
                    g: r,
                    elHollow: c,
                    dataLabels: u
                };
            }
        },
        {
            key: "drawHollow",
            value: function(t) {
                var e = new $b705b473d3ec9641$var$b(this.ctx).drawCircle(2 * t.size);
                return e.attr({
                    class: "apexcharts-radialbar-hollow",
                    cx: t.centerX,
                    cy: t.centerY,
                    r: t.size,
                    fill: t.fill
                }), e;
            }
        },
        {
            key: "drawHollowImage",
            value: function(t, e, i, a) {
                var s = this.w, r = new $b705b473d3ec9641$var$L(this.ctx), o = $b705b473d3ec9641$var$p.randomId(), n = s.config.plotOptions.radialBar.hollow.image;
                if (s.config.plotOptions.radialBar.hollow.imageClipped) r.clippedImgArea({
                    width: i,
                    height: i,
                    image: n,
                    patternID: "pattern".concat(s.globals.cuid).concat(o)
                }), a = "url(#pattern".concat(s.globals.cuid).concat(o, ")");
                else {
                    var l = s.config.plotOptions.radialBar.hollow.imageWidth, h = s.config.plotOptions.radialBar.hollow.imageHeight;
                    if (void 0 === l && void 0 === h) {
                        var c = s.globals.dom.Paper.image(n).loaded(function(e) {
                            this.move(t.centerX - e.width / 2 + s.config.plotOptions.radialBar.hollow.imageOffsetX, t.centerY - e.height / 2 + s.config.plotOptions.radialBar.hollow.imageOffsetY);
                        });
                        e.add(c);
                    } else {
                        var d = s.globals.dom.Paper.image(n).loaded(function(e) {
                            this.move(t.centerX - l / 2 + s.config.plotOptions.radialBar.hollow.imageOffsetX, t.centerY - h / 2 + s.config.plotOptions.radialBar.hollow.imageOffsetY), this.size(l, h);
                        });
                        e.add(d);
                    }
                }
                return a;
            }
        },
        {
            key: "getStrokeWidth",
            value: function(t) {
                var e = this.w;
                return t.size * (100 - parseInt(e.config.plotOptions.radialBar.hollow.size, 10)) / 100 / (t.series.length + 1) - this.margin;
            }
        }
    ]), i;
}(), $b705b473d3ec9641$var$Lt = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.w = e.w, this.lineCtx = e;
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "sameValueSeriesFix",
            value: function(t, e) {
                var i = this.w;
                if ("line" === i.config.chart.type && ("gradient" === i.config.fill.type || "gradient" === i.config.fill.type[t]) && new $b705b473d3ec9641$var$y(this.lineCtx.ctx, i).seriesHaveSameValues(t)) {
                    var a = e[t].slice();
                    a[a.length - 1] = a[a.length - 1] + 1e-6, e[t] = a;
                }
                return e;
            }
        },
        {
            key: "calculatePoints",
            value: function(t) {
                var e = t.series, i = t.realIndex, a = t.x, s = t.y, r = t.i, o = t.j, n = t.prevY, l = this.w, h = [], c = [];
                if (0 === o) {
                    var d = this.lineCtx.categoryAxisCorrection + l.config.markers.offsetX;
                    l.globals.isXNumeric && (d = (l.globals.seriesX[i][0] - l.globals.minX) / this.lineCtx.xRatio + l.config.markers.offsetX), h.push(d), c.push($b705b473d3ec9641$var$p.isNumber(e[r][0]) ? n + l.config.markers.offsetY : null), h.push(a + l.config.markers.offsetX), c.push($b705b473d3ec9641$var$p.isNumber(e[r][o + 1]) ? s + l.config.markers.offsetY : null);
                } else h.push(a + l.config.markers.offsetX), c.push($b705b473d3ec9641$var$p.isNumber(e[r][o + 1]) ? s + l.config.markers.offsetY : null);
                return {
                    x: h,
                    y: c
                };
            }
        },
        {
            key: "checkPreviousPaths",
            value: function(t) {
                for(var e = t.pathFromLine, i = t.pathFromArea, a = t.realIndex, s = this.w, r = 0; r < s.globals.previousPaths.length; r++){
                    var o = s.globals.previousPaths[r];
                    ("line" === o.type || "area" === o.type) && o.paths.length > 0 && parseInt(o.realIndex, 10) === parseInt(a, 10) && ("line" === o.type ? (this.lineCtx.appendPathFrom = !1, e = s.globals.previousPaths[r].paths[0].d) : "area" === o.type && (this.lineCtx.appendPathFrom = !1, i = s.globals.previousPaths[r].paths[0].d, s.config.stroke.show && s.globals.previousPaths[r].paths[1] && (e = s.globals.previousPaths[r].paths[1].d)));
                }
                return {
                    pathFromLine: e,
                    pathFromArea: i
                };
            }
        },
        {
            key: "determineFirstPrevY",
            value: function(t) {
                var e = t.i, i = t.series, a = t.prevY, s = t.lineYPosition, r = this.w;
                if (void 0 !== i[e][0]) a = (s = r.config.chart.stacked && e > 0 ? this.lineCtx.prevSeriesY[e - 1][0] : this.lineCtx.zeroY) - i[e][0] / this.lineCtx.yRatio[this.lineCtx.yaxisIndex] + 2 * (this.lineCtx.isReversed ? i[e][0] / this.lineCtx.yRatio[this.lineCtx.yaxisIndex] : 0);
                else if (r.config.chart.stacked && e > 0 && void 0 === i[e][0]) {
                    for(var o = e - 1; o >= 0; o--)if (null !== i[o][0] && void 0 !== i[o][0]) {
                        a = s = this.lineCtx.prevSeriesY[o][0];
                        break;
                    }
                }
                return {
                    prevY: a,
                    lineYPosition: s
                };
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$Pt = function() {
    function t(e, i, s) {
        $b705b473d3ec9641$var$a(this, t), this.ctx = e, this.w = e.w, this.xyRatios = i, this.pointsChart = !("bubble" !== this.w.config.chart.type && "scatter" !== this.w.config.chart.type) || s, this.scatter = new $b705b473d3ec9641$var$T(this.ctx), this.noNegatives = this.w.globals.minX === Number.MAX_VALUE, this.lineHelpers = new $b705b473d3ec9641$var$Lt(this), this.markers = new $b705b473d3ec9641$var$P(this.ctx), this.prevSeriesY = [], this.categoryAxisCorrection = 0, this.yaxisIndex = 0;
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "draw",
            value: function(t, e, i) {
                var a = this.w, s = new $b705b473d3ec9641$var$b(this.ctx), r = a.globals.comboCharts ? e : a.config.chart.type, o = s.group({
                    class: "apexcharts-".concat(r, "-series apexcharts-plot-series")
                }), n = new $b705b473d3ec9641$var$y(this.ctx, a);
                this.yRatio = this.xyRatios.yRatio, this.zRatio = this.xyRatios.zRatio, this.xRatio = this.xyRatios.xRatio, this.baseLineY = this.xyRatios.baseLineY, t = n.getLogSeries(t), this.yRatio = n.getLogYRatios(this.yRatio);
                for(var l = [], h = 0; h < t.length; h++){
                    t = this.lineHelpers.sameValueSeriesFix(h, t);
                    var c = a.globals.comboCharts ? i[h] : h;
                    this._initSerieVariables(t, h, c);
                    var d = [], g = [], u = a.globals.padHorizontal + this.categoryAxisCorrection;
                    this.ctx.series.addCollapsedClassToSeries(this.elSeries, c), a.globals.isXNumeric && a.globals.seriesX.length > 0 && (u = (a.globals.seriesX[c][0] - a.globals.minX) / this.xRatio), g.push(u);
                    var p, f = u, x = f, v = this.zeroY;
                    v = this.lineHelpers.determineFirstPrevY({
                        i: h,
                        series: t,
                        prevY: v,
                        lineYPosition: 0
                    }).prevY, d.push(v), p = v;
                    var m = this._calculatePathsFrom({
                        series: t,
                        i: h,
                        realIndex: c,
                        prevX: x,
                        prevY: v
                    }), w = this._iterateOverDataPoints({
                        series: t,
                        realIndex: c,
                        i: h,
                        x: u,
                        y: 1,
                        pX: f,
                        pY: p,
                        pathsFrom: m,
                        linePaths: [],
                        areaPaths: [],
                        seriesIndex: i,
                        lineYPosition: 0,
                        xArrj: g,
                        yArrj: d
                    });
                    this._handlePaths({
                        type: r,
                        realIndex: c,
                        i: h,
                        paths: w
                    }), this.elSeries.add(this.elPointsMain), this.elSeries.add(this.elDataLabelsWrap), l.push(this.elSeries);
                }
                if (a.config.chart.stacked) for(var k = l.length; k > 0; k--)o.add(l[k - 1]);
                else for(var A = 0; A < l.length; A++)o.add(l[A]);
                return o;
            }
        },
        {
            key: "_initSerieVariables",
            value: function(t, e, i) {
                var a = this.w, s = new $b705b473d3ec9641$var$b(this.ctx);
                this.xDivision = a.globals.gridWidth / (a.globals.dataPoints - ("on" === a.config.xaxis.tickPlacement ? 1 : 0)), this.strokeWidth = Array.isArray(a.config.stroke.width) ? a.config.stroke.width[i] : a.config.stroke.width, this.yRatio.length > 1 && (this.yaxisIndex = i), this.isReversed = a.config.yaxis[this.yaxisIndex] && a.config.yaxis[this.yaxisIndex].reversed, this.zeroY = a.globals.gridHeight - this.baseLineY[this.yaxisIndex] - (this.isReversed ? a.globals.gridHeight : 0) + (this.isReversed ? 2 * this.baseLineY[this.yaxisIndex] : 0), this.areaBottomY = this.zeroY, (this.zeroY > a.globals.gridHeight || "end" === a.config.plotOptions.area.fillTo) && (this.areaBottomY = a.globals.gridHeight), this.categoryAxisCorrection = this.xDivision / 2, this.elSeries = s.group({
                    class: "apexcharts-series",
                    seriesName: $b705b473d3ec9641$var$p.escapeString(a.globals.seriesNames[i])
                }), this.elPointsMain = s.group({
                    class: "apexcharts-series-markers-wrap",
                    "data:realIndex": i
                }), this.elDataLabelsWrap = s.group({
                    class: "apexcharts-datalabels",
                    "data:realIndex": i
                });
                var r = t[e].length === a.globals.dataPoints;
                this.elSeries.attr({
                    "data:longestSeries": r,
                    rel: e + 1,
                    "data:realIndex": i
                }), this.appendPathFrom = !0;
            }
        },
        {
            key: "_calculatePathsFrom",
            value: function(t) {
                var e, i, a, s, r = t.series, o = t.i, n = t.realIndex, l = t.prevX, h = t.prevY, c = this.w, d = new $b705b473d3ec9641$var$b(this.ctx);
                if (null === r[o][0]) {
                    for(var g = 0; g < r[o].length; g++)if (null !== r[o][g]) {
                        l = this.xDivision * g, h = this.zeroY - r[o][g] / this.yRatio[this.yaxisIndex], e = d.move(l, h), i = d.move(l, this.areaBottomY);
                        break;
                    }
                } else e = d.move(l, h), i = d.move(l, this.areaBottomY) + d.line(l, h);
                if (a = d.move(-1, this.zeroY) + d.line(-1, this.zeroY), s = d.move(-1, this.zeroY) + d.line(-1, this.zeroY), c.globals.previousPaths.length > 0) {
                    var u = this.lineHelpers.checkPreviousPaths({
                        pathFromLine: a,
                        pathFromArea: s,
                        realIndex: n
                    });
                    a = u.pathFromLine, s = u.pathFromArea;
                }
                return {
                    prevX: l,
                    prevY: h,
                    linePath: e,
                    areaPath: i,
                    pathFromLine: a,
                    pathFromArea: s
                };
            }
        },
        {
            key: "_handlePaths",
            value: function(t) {
                var i = t.type, a = t.realIndex, s = t.i, r = t.paths, o = this.w, n = new $b705b473d3ec9641$var$b(this.ctx), l = new $b705b473d3ec9641$var$L(this.ctx);
                this.prevSeriesY.push(r.yArrj), o.globals.seriesXvalues[a] = r.xArrj, o.globals.seriesYvalues[a] = r.yArrj;
                var h = o.config.forecastDataPoints;
                if (h.count > 0) {
                    var c = o.globals.seriesXvalues[a][o.globals.seriesXvalues[a].length - h.count - 1], d = n.drawRect(c, 0, o.globals.gridWidth, o.globals.gridHeight, 0);
                    o.globals.dom.elForecastMask.appendChild(d.node);
                    var g = n.drawRect(0, 0, c, o.globals.gridHeight, 0);
                    o.globals.dom.elNonForecastMask.appendChild(g.node);
                }
                this.pointsChart || o.globals.delayedElements.push({
                    el: this.elPointsMain.node,
                    index: a
                });
                var u = {
                    i: s,
                    realIndex: a,
                    animationDelay: s,
                    initialSpeed: o.config.chart.animations.speed,
                    dataChangeSpeed: o.config.chart.animations.dynamicAnimation.speed,
                    className: "apexcharts-".concat(i)
                };
                if ("area" === i) for(var p = l.fillPath({
                    seriesNumber: a
                }), f = 0; f < r.areaPaths.length; f++){
                    var x = n.renderPaths($b705b473d3ec9641$var$e($b705b473d3ec9641$var$e({}, u), {}, {
                        pathFrom: r.pathFromArea,
                        pathTo: r.areaPaths[f],
                        stroke: "none",
                        strokeWidth: 0,
                        strokeLineCap: null,
                        fill: p
                    }));
                    this.elSeries.add(x);
                }
                if (o.config.stroke.show && !this.pointsChart) {
                    var v = null;
                    v = "line" === i ? l.fillPath({
                        seriesNumber: a,
                        i: s
                    }) : o.globals.stroke.colors[a];
                    for(var m = 0; m < r.linePaths.length; m++){
                        var y = $b705b473d3ec9641$var$e($b705b473d3ec9641$var$e({}, u), {}, {
                            pathFrom: r.pathFromLine,
                            pathTo: r.linePaths[m],
                            stroke: v,
                            strokeWidth: this.strokeWidth,
                            strokeLineCap: o.config.stroke.lineCap,
                            fill: "none"
                        }), w = n.renderPaths(y);
                        if (this.elSeries.add(w), h.count > 0) {
                            var k = n.renderPaths(y);
                            k.node.setAttribute("stroke-dasharray", h.dashArray), h.strokeWidth && k.node.setAttribute("stroke-width", h.strokeWidth), this.elSeries.add(k), k.attr("clip-path", "url(#forecastMask".concat(o.globals.cuid, ")")), w.attr("clip-path", "url(#nonForecastMask".concat(o.globals.cuid, ")"));
                        }
                    }
                }
            }
        },
        {
            key: "_iterateOverDataPoints",
            value: function(t) {
                for(var e = t.series, i = t.realIndex, a = t.i, s = t.x, r = t.y, o = t.pX, n = t.pY, l = t.pathsFrom, h = t.linePaths, c = t.areaPaths, d = t.seriesIndex, g = t.lineYPosition, u = t.xArrj, f = t.yArrj, x = this.w, v = new $b705b473d3ec9641$var$b(this.ctx), m = this.yRatio, y = l.prevY, w = l.linePath, k = l.areaPath, A = l.pathFromLine, S = l.pathFromArea, C = $b705b473d3ec9641$var$p.isNumber(x.globals.minYArr[i]) ? x.globals.minYArr[i] : x.globals.minY, L = x.globals.dataPoints > 1 ? x.globals.dataPoints - 1 : x.globals.dataPoints, P = 0; P < L; P++){
                    var T = void 0 === e[a][P + 1] || null === e[a][P + 1];
                    if (x.globals.isXNumeric) {
                        var M = x.globals.seriesX[i][P + 1];
                        void 0 === x.globals.seriesX[i][P + 1] && (M = x.globals.seriesX[i][L - 1]), s = (M - x.globals.minX) / this.xRatio;
                    } else s += this.xDivision;
                    if (x.config.chart.stacked) {
                        if (a > 0 && x.globals.collapsedSeries.length < x.config.series.length - 1) g = this.prevSeriesY[function(t) {
                            for(var e = t, i = 0; i < x.globals.series.length; i++)if (x.globals.collapsedSeriesIndices.indexOf(t) > -1) {
                                e--;
                                break;
                            }
                            return e >= 0 ? e : 0;
                        }(a - 1)][P + 1];
                        else g = this.zeroY;
                    } else g = this.zeroY;
                    r = T ? g - C / m[this.yaxisIndex] + 2 * (this.isReversed ? C / m[this.yaxisIndex] : 0) : g - e[a][P + 1] / m[this.yaxisIndex] + 2 * (this.isReversed ? e[a][P + 1] / m[this.yaxisIndex] : 0), u.push(s), f.push(r);
                    var I = this.lineHelpers.calculatePoints({
                        series: e,
                        x: s,
                        y: r,
                        realIndex: i,
                        i: a,
                        j: P,
                        prevY: y
                    }), z = this._createPaths({
                        series: e,
                        i: a,
                        realIndex: i,
                        j: P,
                        x: s,
                        y: r,
                        pX: o,
                        pY: n,
                        linePath: w,
                        areaPath: k,
                        linePaths: h,
                        areaPaths: c,
                        seriesIndex: d
                    });
                    c = z.areaPaths, h = z.linePaths, o = z.pX, n = z.pY, k = z.areaPath, w = z.linePath, this.appendPathFrom && (A += v.line(s, this.zeroY), S += v.line(s, this.zeroY)), this.handleNullDataPoints(e, I, a, P, i), this._handleMarkersAndLabels({
                        pointsPos: I,
                        series: e,
                        x: s,
                        y: r,
                        prevY: y,
                        i: a,
                        j: P,
                        realIndex: i
                    });
                }
                return {
                    yArrj: f,
                    xArrj: u,
                    pathFromArea: S,
                    areaPaths: c,
                    pathFromLine: A,
                    linePaths: h
                };
            }
        },
        {
            key: "_handleMarkersAndLabels",
            value: function(t) {
                var e = t.pointsPos;
                t.series, t.x, t.y, t.prevY;
                var i = t.i, a = t.j, s = t.realIndex, r = this.w, o = new $b705b473d3ec9641$var$M(this.ctx);
                if (this.pointsChart) this.scatter.draw(this.elSeries, a, {
                    realIndex: s,
                    pointsPos: e,
                    zRatio: this.zRatio,
                    elParent: this.elPointsMain
                });
                else {
                    r.globals.series[i].length > 1 && this.elPointsMain.node.classList.add("apexcharts-element-hidden");
                    var n = this.markers.plotChartMarkers(e, s, a + 1);
                    null !== n && this.elPointsMain.add(n);
                }
                var l = o.drawDataLabel(e, s, a + 1, null);
                null !== l && this.elDataLabelsWrap.add(l);
            }
        },
        {
            key: "_createPaths",
            value: function(t) {
                var e = t.series, i = t.i, a = t.realIndex, s = t.j, r = t.x, o = t.y, n = t.pX, l = t.pY, h = t.linePath, c = t.areaPath, d = t.linePaths, g = t.areaPaths, u = t.seriesIndex, p = this.w, f = new $b705b473d3ec9641$var$b(this.ctx), x = p.config.stroke.curve, v = this.areaBottomY;
                if (Array.isArray(p.config.stroke.curve) && (x = Array.isArray(u) ? p.config.stroke.curve[u[i]] : p.config.stroke.curve[i]), "smooth" === x) {
                    var m = .35 * (r - n);
                    p.globals.hasNullValues ? (null !== e[i][s] && (null !== e[i][s + 1] ? (h = f.move(n, l) + f.curve(n + m, l, r - m, o, r + 1, o), c = f.move(n + 1, l) + f.curve(n + m, l, r - m, o, r + 1, o) + f.line(r, v) + f.line(n, v) + "z") : (h = f.move(n, l), c = f.move(n, l) + "z")), d.push(h), g.push(c)) : (h += f.curve(n + m, l, r - m, o, r, o), c += f.curve(n + m, l, r - m, o, r, o)), n = r, l = o, s === e[i].length - 2 && (c = c + f.curve(n, l, r, o, r, v) + f.move(r, o) + "z", p.globals.hasNullValues || (d.push(h), g.push(c)));
                } else {
                    if (null === e[i][s + 1]) {
                        h += f.move(r, o);
                        var y = p.globals.isXNumeric ? (p.globals.seriesX[a][s] - p.globals.minX) / this.xRatio : r - this.xDivision;
                        c = c + f.line(y, v) + f.move(r, o) + "z";
                    }
                    null === e[i][s] && (h += f.move(r, o), c += f.move(r, v)), "stepline" === x ? (h = h + f.line(r, null, "H") + f.line(null, o, "V"), c = c + f.line(r, null, "H") + f.line(null, o, "V")) : "straight" === x && (h += f.line(r, o), c += f.line(r, o)), s === e[i].length - 2 && (c = c + f.line(r, v) + f.move(r, o) + "z", d.push(h), g.push(c));
                }
                return {
                    linePaths: d,
                    areaPaths: g,
                    pX: n,
                    pY: l,
                    linePath: h,
                    areaPath: c
                };
            }
        },
        {
            key: "handleNullDataPoints",
            value: function(t, e, i, a, s) {
                var r = this.w;
                if (null === t[i][a] && r.config.markers.showNullDataPoints || 1 === t[i].length) {
                    var o = this.markers.plotChartMarkers(e, s, a + 1, this.strokeWidth - r.config.markers.strokeWidth / 2, !0);
                    null !== o && this.elPointsMain.add(o);
                }
            }
        }
    ]), t;
}();
window.TreemapSquared = {}, window.TreemapSquared.generate = function() {
    function t(e, i, a, s) {
        this.xoffset = e, this.yoffset = i, this.height = s, this.width = a, this.shortestEdge = function() {
            return Math.min(this.height, this.width);
        }, this.getCoordinates = function(t) {
            var e, i = [], a = this.xoffset, s = this.yoffset, o = r(t) / this.height, n = r(t) / this.width;
            if (this.width >= this.height) for(e = 0; e < t.length; e++)i.push([
                a,
                s,
                a + o,
                s + t[e] / o
            ]), s += t[e] / o;
            else for(e = 0; e < t.length; e++)i.push([
                a,
                s,
                a + t[e] / n,
                s + n
            ]), a += t[e] / n;
            return i;
        }, this.cutArea = function(e) {
            var i;
            if (this.width >= this.height) {
                var a = e / this.height, s = this.width - a;
                i = new t(this.xoffset + a, this.yoffset, s, this.height);
            } else {
                var r = e / this.width, o = this.height - r;
                i = new t(this.xoffset, this.yoffset + r, this.width, o);
            }
            return i;
        };
    }
    function e(e, a, s, o, n) {
        return o = void 0 === o ? 0 : o, n = void 0 === n ? 0 : n, function(t) {
            var e, i, a = [];
            for(e = 0; e < t.length; e++)for(i = 0; i < t[e].length; i++)a.push(t[e][i]);
            return a;
        }(i(function(t, e) {
            var i, a = [], s = e / r(t);
            for(i = 0; i < t.length; i++)a[i] = t[i] * s;
            return a;
        }(e, a * s), [], new t(o, n, a, s), []));
    }
    function i(t, e, s, o) {
        var n, l, h;
        if (0 !== t.length) return n = s.shortestEdge(), function(t, e, i) {
            var s;
            if (0 === t.length) return !0;
            (s = t.slice()).push(e);
            var r = a(t, i), o = a(s, i);
            return r >= o;
        }(e, l = t[0], n) ? (e.push(l), i(t.slice(1), e, s, o)) : (h = s.cutArea(r(e), o), o.push(s.getCoordinates(e)), i(t, [], h, o)), o;
        o.push(s.getCoordinates(e));
    }
    function a(t, e) {
        var i = Math.min.apply(Math, t), a = Math.max.apply(Math, t), s = r(t);
        return Math.max(Math.pow(e, 2) * a / Math.pow(s, 2), Math.pow(s, 2) / (Math.pow(e, 2) * i));
    }
    function s(t) {
        return t && t.constructor === Array;
    }
    function r(t) {
        var e, i = 0;
        for(e = 0; e < t.length; e++)i += t[e];
        return i;
    }
    function o(t) {
        var e, i = 0;
        if (s(t[0])) for(e = 0; e < t.length; e++)i += o(t[e]);
        else i = r(t);
        return i;
    }
    return function t(i, a, r, n, l) {
        n = void 0 === n ? 0 : n, l = void 0 === l ? 0 : l;
        var h, c, d = [], g = [];
        if (s(i[0])) {
            for(c = 0; c < i.length; c++)d[c] = o(i[c]);
            for(h = e(d, a, r, n, l), c = 0; c < i.length; c++)g.push(t(i[c], h[c][2] - h[c][0], h[c][3] - h[c][1], h[c][0], h[c][1]));
        } else g = e(i, a, r, n, l);
        return g;
    };
}();
var $b705b473d3ec9641$var$Tt, $b705b473d3ec9641$var$Mt, $b705b473d3ec9641$var$It = function() {
    function t(e, i) {
        $b705b473d3ec9641$var$a(this, t), this.ctx = e, this.w = e.w, this.strokeWidth = this.w.config.stroke.width, this.helpers = new $b705b473d3ec9641$var$yt(e), this.dynamicAnim = this.w.config.chart.animations.dynamicAnimation, this.labels = [];
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "draw",
            value: function(t) {
                var e = this, i = this.w, a = new $b705b473d3ec9641$var$b(this.ctx), s = new $b705b473d3ec9641$var$L(this.ctx), r = a.group({
                    class: "apexcharts-treemap"
                });
                if (i.globals.noData) return r;
                var o = [];
                return t.forEach(function(t) {
                    var e = t.map(function(t) {
                        return Math.abs(t);
                    });
                    o.push(e);
                }), this.negRange = this.helpers.checkColorRange(), i.config.series.forEach(function(t, i) {
                    t.data.forEach(function(t) {
                        Array.isArray(e.labels[i]) || (e.labels[i] = []), e.labels[i].push(t.x);
                    });
                }), window.TreemapSquared.generate(o, i.globals.gridWidth, i.globals.gridHeight).forEach(function(o, n) {
                    var l = a.group({
                        class: "apexcharts-series apexcharts-treemap-series",
                        seriesName: $b705b473d3ec9641$var$p.escapeString(i.globals.seriesNames[n]),
                        rel: n + 1,
                        "data:realIndex": n
                    });
                    if (i.config.chart.dropShadow.enabled) {
                        var h = i.config.chart.dropShadow;
                        new $b705b473d3ec9641$var$x(e.ctx).dropShadow(r, h, n);
                    }
                    var c = a.group({
                        class: "apexcharts-data-labels"
                    });
                    o.forEach(function(r, o) {
                        var h = r[0], c = r[1], d = r[2], g = r[3], u = a.drawRect(h, c, d - h, g - c, 0, "#fff", 1, e.strokeWidth, i.config.plotOptions.treemap.useFillColorAsStroke ? f : i.globals.stroke.colors[n]);
                        u.attr({
                            cx: h,
                            cy: c,
                            index: n,
                            i: n,
                            j: o,
                            width: d - h,
                            height: g - c
                        });
                        var p = e.helpers.getShadeColor(i.config.chart.type, n, o, e.negRange), f = p.color;
                        void 0 !== i.config.series[n].data[o] && i.config.series[n].data[o].fillColor && (f = i.config.series[n].data[o].fillColor);
                        var x = s.fillPath({
                            color: f,
                            seriesNumber: n,
                            dataPointIndex: o
                        });
                        u.node.classList.add("apexcharts-treemap-rect"), u.attr({
                            fill: x
                        }), e.helpers.addListeners(u);
                        var b = {
                            x: h + (d - h) / 2,
                            y: c + (g - c) / 2,
                            width: 0,
                            height: 0
                        }, v = {
                            x: h,
                            y: c,
                            width: d - h,
                            height: g - c
                        };
                        if (i.config.chart.animations.enabled && !i.globals.dataChanged) {
                            var m = 1;
                            i.globals.resized || (m = i.config.chart.animations.speed), e.animateTreemap(u, b, v, m);
                        }
                        if (i.globals.dataChanged) {
                            var y = 1;
                            e.dynamicAnim.enabled && i.globals.shouldAnimate && (y = e.dynamicAnim.speed, i.globals.previousPaths[n] && i.globals.previousPaths[n][o] && i.globals.previousPaths[n][o].rect && (b = i.globals.previousPaths[n][o].rect), e.animateTreemap(u, b, v, y));
                        }
                        var w = e.getFontSize(r), k = i.config.dataLabels.formatter(e.labels[n][o], {
                            value: i.globals.series[n][o],
                            seriesIndex: n,
                            dataPointIndex: o,
                            w: i
                        }), A = e.helpers.calculateDataLabels({
                            text: k,
                            x: (h + d) / 2,
                            y: (c + g) / 2 + e.strokeWidth / 2 + w / 3,
                            i: n,
                            j: o,
                            colorProps: p,
                            fontSize: w,
                            series: t
                        });
                        i.config.dataLabels.enabled && A && e.rotateToFitLabel(A, k, h, c, d, g), l.add(u), null !== A && l.add(A);
                    }), l.add(c), r.add(l);
                }), r;
            }
        },
        {
            key: "getFontSize",
            value: function(t) {
                var e = this.w;
                var i, a, s, r, o = function t(e) {
                    var i, a = 0;
                    if (Array.isArray(e[0])) for(i = 0; i < e.length; i++)a += t(e[i]);
                    else for(i = 0; i < e.length; i++)a += e[i].length;
                    return a;
                }(this.labels) / function t(e) {
                    var i, a = 0;
                    if (Array.isArray(e[0])) for(i = 0; i < e.length; i++)a += t(e[i]);
                    else for(i = 0; i < e.length; i++)a += 1;
                    return a;
                }(this.labels);
                return i = t[2] - t[0], a = t[3] - t[1], s = i * a, r = Math.pow(s, .5), Math.min(r / o, parseInt(e.config.dataLabels.style.fontSize, 10));
            }
        },
        {
            key: "rotateToFitLabel",
            value: function(t, e, i, a, s, r) {
                var o = new $b705b473d3ec9641$var$b(this.ctx), n = o.getTextRects(e);
                if (n.width + 5 > s - i && n.width <= r - a) {
                    var l = o.rotateAroundCenter(t.node);
                    t.node.setAttribute("transform", "rotate(-90 ".concat(l.x, " ").concat(l.y, ")"));
                }
            }
        },
        {
            key: "animateTreemap",
            value: function(t, e, i, a) {
                var s = new $b705b473d3ec9641$var$f(this.ctx);
                s.animateRect(t, {
                    x: e.x,
                    y: e.y,
                    width: e.width,
                    height: e.height
                }, {
                    x: i.x,
                    y: i.y,
                    width: i.width,
                    height: i.height
                }, a, function() {
                    s.animationCompleted(t);
                });
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$zt = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.ctx = e, this.w = e.w, this.timeScaleArray = [], this.utc = this.w.config.xaxis.labels.datetimeUTC;
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "calculateTimeScaleTicks",
            value: function(t, i) {
                var a = this, s = this.w;
                if (s.globals.allSeriesCollapsed) return s.globals.labels = [], s.globals.timescaleLabels = [], [];
                var r = new $b705b473d3ec9641$var$Y(this.ctx), o = (i - t) / 864e5;
                this.determineInterval(o), s.globals.disableZoomIn = !1, s.globals.disableZoomOut = !1, o < .00011574074074074075 ? s.globals.disableZoomIn = !0 : o > 5e4 && (s.globals.disableZoomOut = !0);
                var n = r.getTimeUnitsfromTimestamp(t, i, this.utc), l = s.globals.gridWidth / o, h = l / 24, c = h / 60, d = c / 60, g = Math.floor(24 * o), u = Math.floor(1440 * o), p = Math.floor(86400 * o), f = Math.floor(o), x = Math.floor(o / 30), b = Math.floor(o / 365), v = {
                    minMillisecond: n.minMillisecond,
                    minSecond: n.minSecond,
                    minMinute: n.minMinute,
                    minHour: n.minHour,
                    minDate: n.minDate,
                    minMonth: n.minMonth,
                    minYear: n.minYear
                }, m = {
                    firstVal: v,
                    currentMillisecond: v.minMillisecond,
                    currentSecond: v.minSecond,
                    currentMinute: v.minMinute,
                    currentHour: v.minHour,
                    currentMonthDate: v.minDate,
                    currentDate: v.minDate,
                    currentMonth: v.minMonth,
                    currentYear: v.minYear,
                    daysWidthOnXAxis: l,
                    hoursWidthOnXAxis: h,
                    minutesWidthOnXAxis: c,
                    secondsWidthOnXAxis: d,
                    numberOfSeconds: p,
                    numberOfMinutes: u,
                    numberOfHours: g,
                    numberOfDays: f,
                    numberOfMonths: x,
                    numberOfYears: b
                };
                switch(this.tickInterval){
                    case "years":
                        this.generateYearScale(m);
                        break;
                    case "months":
                    case "half_year":
                        this.generateMonthScale(m);
                        break;
                    case "months_days":
                    case "months_fortnight":
                    case "days":
                    case "week_days":
                        this.generateDayScale(m);
                        break;
                    case "hours":
                        this.generateHourScale(m);
                        break;
                    case "minutes_fives":
                    case "minutes":
                        this.generateMinuteScale(m);
                        break;
                    case "seconds_tens":
                    case "seconds_fives":
                    case "seconds":
                        this.generateSecondScale(m);
                }
                var y = this.timeScaleArray.map(function(t) {
                    var i = {
                        position: t.position,
                        unit: t.unit,
                        year: t.year,
                        day: t.day ? t.day : 1,
                        hour: t.hour ? t.hour : 0,
                        month: t.month + 1
                    };
                    return "month" === t.unit ? $b705b473d3ec9641$var$e($b705b473d3ec9641$var$e({}, i), {}, {
                        day: 1,
                        value: t.value + 1
                    }) : "day" === t.unit || "hour" === t.unit ? $b705b473d3ec9641$var$e($b705b473d3ec9641$var$e({}, i), {}, {
                        value: t.value
                    }) : "minute" === t.unit ? $b705b473d3ec9641$var$e($b705b473d3ec9641$var$e({}, i), {}, {
                        value: t.value,
                        minute: t.value
                    }) : "second" === t.unit ? $b705b473d3ec9641$var$e($b705b473d3ec9641$var$e({}, i), {}, {
                        value: t.value,
                        minute: t.minute,
                        second: t.second
                    }) : t;
                });
                return y.filter(function(t) {
                    var e = 1, i = Math.ceil(s.globals.gridWidth / 120), r = t.value;
                    void 0 !== s.config.xaxis.tickAmount && (i = s.config.xaxis.tickAmount), y.length > i && (e = Math.floor(y.length / i));
                    var o = !1, n = !1;
                    switch(a.tickInterval){
                        case "years":
                            "year" === t.unit && (o = !0);
                            break;
                        case "half_year":
                            e = 7, "year" === t.unit && (o = !0);
                            break;
                        case "months":
                            e = 1, "year" === t.unit && (o = !0);
                            break;
                        case "months_fortnight":
                            e = 15, "year" !== t.unit && "month" !== t.unit || (o = !0), 30 === r && (n = !0);
                            break;
                        case "months_days":
                            e = 10, "month" === t.unit && (o = !0), 30 === r && (n = !0);
                            break;
                        case "week_days":
                            e = 8, "month" === t.unit && (o = !0);
                            break;
                        case "days":
                            e = 1, "month" === t.unit && (o = !0);
                            break;
                        case "hours":
                            "day" === t.unit && (o = !0);
                            break;
                        case "minutes_fives":
                            r % 5 != 0 && (n = !0);
                            break;
                        case "seconds_tens":
                            r % 10 != 0 && (n = !0);
                            break;
                        case "seconds_fives":
                            r % 5 != 0 && (n = !0);
                    }
                    if ("hours" === a.tickInterval || "minutes_fives" === a.tickInterval || "seconds_tens" === a.tickInterval || "seconds_fives" === a.tickInterval) {
                        if (!n) return !0;
                    } else if ((r % e == 0 || o) && !n) return !0;
                });
            }
        },
        {
            key: "recalcDimensionsBasedOnFormat",
            value: function(t, e) {
                var i = this.w, a = this.formatDates(t), s = this.removeOverlappingTS(a);
                i.globals.timescaleLabels = s.slice(), new $b705b473d3ec9641$var$ot(this.ctx).plotCoords();
            }
        },
        {
            key: "determineInterval",
            value: function(t) {
                var e = 24 * t, i = 60 * e;
                switch(!0){
                    case t / 365 > 5:
                        this.tickInterval = "years";
                        break;
                    case t > 800:
                        this.tickInterval = "half_year";
                        break;
                    case t > 180:
                        this.tickInterval = "months";
                        break;
                    case t > 90:
                        this.tickInterval = "months_fortnight";
                        break;
                    case t > 60:
                        this.tickInterval = "months_days";
                        break;
                    case t > 30:
                        this.tickInterval = "week_days";
                        break;
                    case t > 2:
                        this.tickInterval = "days";
                        break;
                    case e > 2.4:
                        this.tickInterval = "hours";
                        break;
                    case i > 15:
                        this.tickInterval = "minutes_fives";
                        break;
                    case i > 5:
                        this.tickInterval = "minutes";
                        break;
                    case i > 1:
                        this.tickInterval = "seconds_tens";
                        break;
                    case 60 * i > 20:
                        this.tickInterval = "seconds_fives";
                        break;
                    default:
                        this.tickInterval = "seconds";
                }
            }
        },
        {
            key: "generateYearScale",
            value: function(t) {
                var e = t.firstVal, i = t.currentMonth, a = t.currentYear, s = t.daysWidthOnXAxis, r = t.numberOfYears, o = e.minYear, n = 0, l = new $b705b473d3ec9641$var$Y(this.ctx), h = "year";
                if (e.minDate > 1 || e.minMonth > 0) {
                    var c = l.determineRemainingDaysOfYear(e.minYear, e.minMonth, e.minDate);
                    n = (l.determineDaysOfYear(e.minYear) - c + 1) * s, o = e.minYear + 1, this.timeScaleArray.push({
                        position: n,
                        value: o,
                        unit: h,
                        year: o,
                        month: $b705b473d3ec9641$var$p.monthMod(i + 1)
                    });
                } else 1 === e.minDate && 0 === e.minMonth && this.timeScaleArray.push({
                    position: n,
                    value: o,
                    unit: h,
                    year: a,
                    month: $b705b473d3ec9641$var$p.monthMod(i + 1)
                });
                for(var d = o, g = n, u = 0; u < r; u++)d++, g = l.determineDaysOfYear(d - 1) * s + g, this.timeScaleArray.push({
                    position: g,
                    value: d,
                    unit: h,
                    year: d,
                    month: 1
                });
            }
        },
        {
            key: "generateMonthScale",
            value: function(t) {
                var e = t.firstVal, i = t.currentMonthDate, a = t.currentMonth, s = t.currentYear, r = t.daysWidthOnXAxis, o = t.numberOfMonths, n = a, l = 0, h = new $b705b473d3ec9641$var$Y(this.ctx), c = "month", d = 0;
                if (e.minDate > 1) {
                    l = (h.determineDaysOfMonths(a + 1, e.minYear) - i + 1) * r, n = $b705b473d3ec9641$var$p.monthMod(a + 1);
                    var g = s + d, u = $b705b473d3ec9641$var$p.monthMod(n), f = n;
                    0 === n && (c = "year", f = g, u = 1, g += d += 1), this.timeScaleArray.push({
                        position: l,
                        value: f,
                        unit: c,
                        year: g,
                        month: u
                    });
                } else this.timeScaleArray.push({
                    position: l,
                    value: n,
                    unit: c,
                    year: s,
                    month: $b705b473d3ec9641$var$p.monthMod(a)
                });
                for(var x = n + 1, b = l, v = 0, m = 1; v < o; v++, m++){
                    0 === (x = $b705b473d3ec9641$var$p.monthMod(x)) ? (c = "year", d += 1) : c = "month";
                    var y = this._getYear(s, x, d);
                    b = h.determineDaysOfMonths(x, y) * r + b;
                    var w = 0 === x ? y : x;
                    this.timeScaleArray.push({
                        position: b,
                        value: w,
                        unit: c,
                        year: y,
                        month: 0 === x ? 1 : x
                    }), x++;
                }
            }
        },
        {
            key: "generateDayScale",
            value: function(t) {
                var e = t.firstVal, i = t.currentMonth, a = t.currentYear, s = t.hoursWidthOnXAxis, r = t.numberOfDays, o = new $b705b473d3ec9641$var$Y(this.ctx), n = "day", l = e.minDate + 1, h = l, c = function(t, e, i) {
                    return t > o.determineDaysOfMonths(e + 1, i) ? (h = 1, n = "month", g = e += 1, e) : e;
                }, d = (24 - e.minHour) * s, g = l, u = c(h, i, a);
                0 === e.minHour && 1 === e.minDate ? (d = 0, g = $b705b473d3ec9641$var$p.monthMod(e.minMonth), n = "month", h = e.minDate, r++) : 1 !== e.minDate && 0 === e.minHour && 0 === e.minMinute && (d = 0, l = e.minDate, g = l, u = c(h = l, i, a)), this.timeScaleArray.push({
                    position: d,
                    value: g,
                    unit: n,
                    year: this._getYear(a, u, 0),
                    month: $b705b473d3ec9641$var$p.monthMod(u),
                    day: h
                });
                for(var f = d, x = 0; x < r; x++){
                    n = "day", u = c(h += 1, u, this._getYear(a, u, 0));
                    var b = this._getYear(a, u, 0);
                    f = 24 * s + f;
                    var v = 1 === h ? $b705b473d3ec9641$var$p.monthMod(u) : h;
                    this.timeScaleArray.push({
                        position: f,
                        value: v,
                        unit: n,
                        year: b,
                        month: $b705b473d3ec9641$var$p.monthMod(u),
                        day: v
                    });
                }
            }
        },
        {
            key: "generateHourScale",
            value: function(t) {
                var e = t.firstVal, i = t.currentDate, a = t.currentMonth, s = t.currentYear, r = t.minutesWidthOnXAxis, o = t.numberOfHours, n = new $b705b473d3ec9641$var$Y(this.ctx), l = "hour", h = function(t, e) {
                    return t > n.determineDaysOfMonths(e + 1, s) && (x = 1, e += 1), {
                        month: e,
                        date: x
                    };
                }, c = function(t, e) {
                    return t > n.determineDaysOfMonths(e + 1, s) ? e += 1 : e;
                }, d = 60 - (e.minMinute + e.minSecond / 60), g = d * r, u = e.minHour + 1, f = u + 1;
                60 === d && (g = 0, f = (u = e.minHour) + 1);
                var x = i, b = c(x, a);
                this.timeScaleArray.push({
                    position: g,
                    value: u,
                    unit: l,
                    day: x,
                    hour: f,
                    year: s,
                    month: $b705b473d3ec9641$var$p.monthMod(b)
                });
                for(var v = g, m = 0; m < o; m++){
                    if (l = "hour", f >= 24) f = 0, l = "day", b = h(x += 1, b).month, b = c(x, b);
                    var y = this._getYear(s, b, 0);
                    v = 0 === f && 0 === m ? d * r : 60 * r + v;
                    var w = 0 === f ? x : f;
                    this.timeScaleArray.push({
                        position: v,
                        value: w,
                        unit: l,
                        hour: f,
                        day: x,
                        year: y,
                        month: $b705b473d3ec9641$var$p.monthMod(b)
                    }), f++;
                }
            }
        },
        {
            key: "generateMinuteScale",
            value: function(t) {
                for(var e = t.currentMillisecond, i = t.currentSecond, a = t.currentMinute, s = t.currentHour, r = t.currentDate, o = t.currentMonth, n = t.currentYear, l = t.minutesWidthOnXAxis, h = t.secondsWidthOnXAxis, c = t.numberOfMinutes, d = a + 1, g = r, u = o, f = n, x = s, b = (60 - i - e / 1e3) * h, v = 0; v < c; v++)d >= 60 && (d = 0, 24 === (x += 1) && (x = 0)), this.timeScaleArray.push({
                    position: b,
                    value: d,
                    unit: "minute",
                    hour: x,
                    minute: d,
                    day: g,
                    year: this._getYear(f, u, 0),
                    month: $b705b473d3ec9641$var$p.monthMod(u)
                }), b += l, d++;
            }
        },
        {
            key: "generateSecondScale",
            value: function(t) {
                for(var e = t.currentMillisecond, i = t.currentSecond, a = t.currentMinute, s = t.currentHour, r = t.currentDate, o = t.currentMonth, n = t.currentYear, l = t.secondsWidthOnXAxis, h = t.numberOfSeconds, c = i + 1, d = a, g = r, u = o, f = n, x = s, b = (1e3 - e) / 1e3 * l, v = 0; v < h; v++)c >= 60 && (c = 0, ++d >= 60 && (d = 0, 24 === ++x && (x = 0))), this.timeScaleArray.push({
                    position: b,
                    value: c,
                    unit: "second",
                    hour: x,
                    minute: d,
                    second: c,
                    day: g,
                    year: this._getYear(f, u, 0),
                    month: $b705b473d3ec9641$var$p.monthMod(u)
                }), b += l, c++;
            }
        },
        {
            key: "createRawDateString",
            value: function(t, e) {
                var i = t.year;
                return 0 === t.month && (t.month = 1), i += "-" + ("0" + t.month.toString()).slice(-2), "day" === t.unit ? i += "day" === t.unit ? "-" + ("0" + e).slice(-2) : "-01" : i += "-" + ("0" + (t.day ? t.day : "1")).slice(-2), "hour" === t.unit ? i += "hour" === t.unit ? "T" + ("0" + e).slice(-2) : "T00" : i += "T" + ("0" + (t.hour ? t.hour : "0")).slice(-2), "minute" === t.unit ? i += ":" + ("0" + e).slice(-2) : i += ":" + (t.minute ? ("0" + t.minute).slice(-2) : "00"), "second" === t.unit ? i += ":" + ("0" + e).slice(-2) : i += ":00", this.utc && (i += ".000Z"), i;
            }
        },
        {
            key: "formatDates",
            value: function(t) {
                var e = this, i = this.w;
                return t.map(function(t) {
                    var a = t.value.toString(), s = new $b705b473d3ec9641$var$Y(e.ctx), r = e.createRawDateString(t, a), o = s.getDate(s.parseDate(r));
                    if (e.utc || (o = s.getDate(s.parseDateWithTimezone(r))), void 0 === i.config.xaxis.labels.format) {
                        var n = "dd MMM", l = i.config.xaxis.labels.datetimeFormatter;
                        "year" === t.unit && (n = l.year), "month" === t.unit && (n = l.month), "day" === t.unit && (n = l.day), "hour" === t.unit && (n = l.hour), "minute" === t.unit && (n = l.minute), "second" === t.unit && (n = l.second), a = s.formatDate(o, n);
                    } else a = s.formatDate(o, i.config.xaxis.labels.format);
                    return {
                        dateString: r,
                        position: t.position,
                        value: a,
                        unit: t.unit,
                        year: t.year,
                        month: t.month
                    };
                });
            }
        },
        {
            key: "removeOverlappingTS",
            value: function(t) {
                var e, i = this, a = new $b705b473d3ec9641$var$b(this.ctx), s = !1;
                t.length > 0 && t[0].value && t.every(function(e) {
                    return e.value.length === t[0].value.length;
                }) && (s = !0, e = a.getTextRects(t[0].value).width);
                var r = 0, o = t.map(function(o, n) {
                    if (n > 0 && i.w.config.xaxis.labels.hideOverlappingLabels) {
                        var l = s ? e : a.getTextRects(t[r].value).width, h = t[r].position;
                        return o.position > h + l + 10 ? (r = n, o) : null;
                    }
                    return o;
                });
                return o = o.filter(function(t) {
                    return null !== t;
                });
            }
        },
        {
            key: "_getYear",
            value: function(t, e, i) {
                return t + Math.floor(e / 12) + i;
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$Xt = function() {
    function t(e, i) {
        $b705b473d3ec9641$var$a(this, t), this.ctx = i, this.w = i.w, this.el = e;
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "setupElements",
            value: function() {
                var t = this.w.globals, e = this.w.config, i = e.chart.type;
                t.axisCharts = [
                    "line",
                    "area",
                    "bar",
                    "rangeBar",
                    "candlestick",
                    "boxPlot",
                    "scatter",
                    "bubble",
                    "radar",
                    "heatmap",
                    "treemap"
                ].indexOf(i) > -1, t.xyCharts = [
                    "line",
                    "area",
                    "bar",
                    "rangeBar",
                    "candlestick",
                    "boxPlot",
                    "scatter",
                    "bubble"
                ].indexOf(i) > -1, t.isBarHorizontal = ("bar" === e.chart.type || "rangeBar" === e.chart.type || "boxPlot" === e.chart.type) && e.plotOptions.bar.horizontal, t.chartClass = ".apexcharts" + t.chartID, t.dom.baseEl = this.el, t.dom.elWrap = document.createElement("div"), $b705b473d3ec9641$var$b.setAttrs(t.dom.elWrap, {
                    id: t.chartClass.substring(1),
                    class: "apexcharts-canvas " + t.chartClass.substring(1)
                }), this.el.appendChild(t.dom.elWrap), t.dom.Paper = new window.SVG.Doc(t.dom.elWrap), t.dom.Paper.attr({
                    class: "apexcharts-svg",
                    "xmlns:data": "ApexChartsNS",
                    transform: "translate(".concat(e.chart.offsetX, ", ").concat(e.chart.offsetY, ")")
                }), t.dom.Paper.node.style.background = e.chart.background, this.setSVGDimensions(), t.dom.elGraphical = t.dom.Paper.group().attr({
                    class: "apexcharts-inner apexcharts-graphical"
                }), t.dom.elAnnotations = t.dom.Paper.group().attr({
                    class: "apexcharts-annotations"
                }), t.dom.elDefs = t.dom.Paper.defs(), t.dom.elLegendWrap = document.createElement("div"), t.dom.elLegendWrap.classList.add("apexcharts-legend"), t.dom.elWrap.appendChild(t.dom.elLegendWrap), t.dom.Paper.add(t.dom.elGraphical), t.dom.elGraphical.add(t.dom.elDefs);
            }
        },
        {
            key: "plotChartType",
            value: function(t, e) {
                var i = this.w, a = i.config, s = i.globals, r = {
                    series: [],
                    i: []
                }, o = {
                    series: [],
                    i: []
                }, n = {
                    series: [],
                    i: []
                }, l = {
                    series: [],
                    i: []
                }, h = {
                    series: [],
                    i: []
                }, c = {
                    series: [],
                    i: []
                }, d = {
                    series: [],
                    i: []
                };
                s.series.map(function(e, g) {
                    var u = 0;
                    void 0 !== t[g].type ? ("column" === t[g].type || "bar" === t[g].type ? (s.series.length > 1 && a.plotOptions.bar.horizontal && console.warn("Horizontal bars are not supported in a mixed/combo chart. Please turn off `plotOptions.bar.horizontal`"), h.series.push(e), h.i.push(g), u++, i.globals.columnSeries = h.series) : "area" === t[g].type ? (o.series.push(e), o.i.push(g), u++) : "line" === t[g].type ? (r.series.push(e), r.i.push(g), u++) : "scatter" === t[g].type ? (n.series.push(e), n.i.push(g)) : "bubble" === t[g].type ? (l.series.push(e), l.i.push(g), u++) : "candlestick" === t[g].type ? (c.series.push(e), c.i.push(g), u++) : "boxPlot" === t[g].type ? (d.series.push(e), d.i.push(g), u++) : console.warn("You have specified an unrecognized chart type. Available types for this property are line/area/column/bar/scatter/bubble"), u > 1 && (s.comboCharts = !0)) : (r.series.push(e), r.i.push(g));
                });
                var g = new $b705b473d3ec9641$var$Pt(this.ctx, e), u = new $b705b473d3ec9641$var$mt(this.ctx, e);
                this.ctx.pie = new $b705b473d3ec9641$var$At(this.ctx);
                var p = new $b705b473d3ec9641$var$Ct(this.ctx);
                this.ctx.rangeBar = new $b705b473d3ec9641$var$F(this.ctx, e);
                var f = new $b705b473d3ec9641$var$St(this.ctx), x = [];
                if (s.comboCharts) {
                    if (o.series.length > 0 && x.push(g.draw(o.series, "area", o.i)), h.series.length > 0) {
                        if (i.config.chart.stacked) {
                            var b = new $b705b473d3ec9641$var$vt(this.ctx, e);
                            x.push(b.draw(h.series, h.i));
                        } else this.ctx.bar = new $b705b473d3ec9641$var$E(this.ctx, e), x.push(this.ctx.bar.draw(h.series, h.i));
                    }
                    if (r.series.length > 0 && x.push(g.draw(r.series, "line", r.i)), c.series.length > 0 && x.push(u.draw(c.series, c.i)), d.series.length > 0 && x.push(u.draw(d.series, d.i)), n.series.length > 0) {
                        var v = new $b705b473d3ec9641$var$Pt(this.ctx, e, !0);
                        x.push(v.draw(n.series, "scatter", n.i));
                    }
                    if (l.series.length > 0) {
                        var m = new $b705b473d3ec9641$var$Pt(this.ctx, e, !0);
                        x.push(m.draw(l.series, "bubble", l.i));
                    }
                } else switch(a.chart.type){
                    case "line":
                        x = g.draw(s.series, "line");
                        break;
                    case "area":
                        x = g.draw(s.series, "area");
                        break;
                    case "bar":
                        if (a.chart.stacked) x = new $b705b473d3ec9641$var$vt(this.ctx, e).draw(s.series);
                        else this.ctx.bar = new $b705b473d3ec9641$var$E(this.ctx, e), x = this.ctx.bar.draw(s.series);
                        break;
                    case "candlestick":
                        x = new $b705b473d3ec9641$var$mt(this.ctx, e).draw(s.series);
                        break;
                    case "boxPlot":
                        x = new $b705b473d3ec9641$var$mt(this.ctx, e).draw(s.series);
                        break;
                    case "rangeBar":
                        x = this.ctx.rangeBar.draw(s.series);
                        break;
                    case "heatmap":
                        x = new $b705b473d3ec9641$var$wt(this.ctx, e).draw(s.series);
                        break;
                    case "treemap":
                        x = new $b705b473d3ec9641$var$It(this.ctx, e).draw(s.series);
                        break;
                    case "pie":
                    case "donut":
                    case "polarArea":
                        x = this.ctx.pie.draw(s.series);
                        break;
                    case "radialBar":
                        x = p.draw(s.series);
                        break;
                    case "radar":
                        x = f.draw(s.series);
                        break;
                    default:
                        x = g.draw(s.series);
                }
                return x;
            }
        },
        {
            key: "setSVGDimensions",
            value: function() {
                var t = this.w.globals, e = this.w.config;
                t.svgWidth = e.chart.width, t.svgHeight = e.chart.height;
                var i = $b705b473d3ec9641$var$p.getDimensions(this.el), a = e.chart.width.toString().split(/[0-9]+/g).pop();
                "%" === a ? $b705b473d3ec9641$var$p.isNumber(i[0]) && (0 === i[0].width && (i = $b705b473d3ec9641$var$p.getDimensions(this.el.parentNode)), t.svgWidth = i[0] * parseInt(e.chart.width, 10) / 100) : "px" !== a && "" !== a || (t.svgWidth = parseInt(e.chart.width, 10));
                var s = e.chart.height.toString().split(/[0-9]+/g).pop();
                if ("auto" !== t.svgHeight && "" !== t.svgHeight) {
                    if ("%" === s) {
                        var r = $b705b473d3ec9641$var$p.getDimensions(this.el.parentNode);
                        t.svgHeight = r[1] * parseInt(e.chart.height, 10) / 100;
                    } else t.svgHeight = parseInt(e.chart.height, 10);
                } else t.axisCharts ? t.svgHeight = t.svgWidth / 1.61 : t.svgHeight = t.svgWidth / 1.2;
                if (t.svgWidth < 0 && (t.svgWidth = 0), t.svgHeight < 0 && (t.svgHeight = 0), $b705b473d3ec9641$var$b.setAttrs(t.dom.Paper.node, {
                    width: t.svgWidth,
                    height: t.svgHeight
                }), "%" !== s) {
                    var o = e.chart.sparkline.enabled ? 0 : t.axisCharts ? e.chart.parentHeightOffset : 0;
                    t.dom.Paper.node.parentNode.parentNode.style.minHeight = t.svgHeight + o + "px";
                }
                t.dom.elWrap.style.width = t.svgWidth + "px", t.dom.elWrap.style.height = t.svgHeight + "px";
            }
        },
        {
            key: "shiftGraphPosition",
            value: function() {
                var t = this.w.globals, e = t.translateY, i = {
                    transform: "translate(" + t.translateX + ", " + e + ")"
                };
                $b705b473d3ec9641$var$b.setAttrs(t.dom.elGraphical.node, i);
            }
        },
        {
            key: "resizeNonAxisCharts",
            value: function() {
                var t = this.w, e = t.globals, i = 0, a = t.config.chart.sparkline.enabled ? 1 : 15;
                a += t.config.grid.padding.bottom, "top" !== t.config.legend.position && "bottom" !== t.config.legend.position || !t.config.legend.show || t.config.legend.floating || (i = new $b705b473d3ec9641$var$lt(this.ctx).legendHelpers.getLegendBBox().clwh + 10);
                var s = t.globals.dom.baseEl.querySelector(".apexcharts-radialbar, .apexcharts-pie"), r = 2.05 * t.globals.radialSize;
                if (s && !t.config.chart.sparkline.enabled && 0 !== t.config.plotOptions.radialBar.startAngle) {
                    var o = $b705b473d3ec9641$var$p.getBoundingClientRect(s);
                    r = o.bottom;
                    var n = o.bottom - o.top;
                    r = Math.max(2.05 * t.globals.radialSize, n);
                }
                var l = r + e.translateY + i + a;
                e.dom.elLegendForeign && e.dom.elLegendForeign.setAttribute("height", l), e.dom.elWrap.style.height = l + "px", $b705b473d3ec9641$var$b.setAttrs(e.dom.Paper.node, {
                    height: l
                }), e.dom.Paper.node.parentNode.parentNode.style.minHeight = l + "px";
            }
        },
        {
            key: "coreCalculations",
            value: function() {
                new $b705b473d3ec9641$var$U(this.ctx).init();
            }
        },
        {
            key: "resetGlobals",
            value: function() {
                var t = this, e = function() {
                    return t.w.config.series.map(function(t) {
                        return [];
                    });
                }, i = new $b705b473d3ec9641$var$D, a = this.w.globals;
                i.initGlobalVars(a), a.seriesXvalues = e(), a.seriesYvalues = e();
            }
        },
        {
            key: "isMultipleY",
            value: function() {
                if (this.w.config.yaxis.constructor === Array && this.w.config.yaxis.length > 1) return this.w.globals.isMultipleYAxis = !0, !0;
            }
        },
        {
            key: "xySettings",
            value: function() {
                var t = null, e = this.w;
                if (e.globals.axisCharts) {
                    if ("back" === e.config.xaxis.crosshairs.position) new $b705b473d3ec9641$var$Q(this.ctx).drawXCrosshairs();
                    if ("back" === e.config.yaxis[0].crosshairs.position) new $b705b473d3ec9641$var$Q(this.ctx).drawYCrosshairs();
                    if ("datetime" === e.config.xaxis.type && void 0 === e.config.xaxis.labels.formatter) {
                        this.ctx.timeScale = new $b705b473d3ec9641$var$zt(this.ctx);
                        var i = [];
                        isFinite(e.globals.minX) && isFinite(e.globals.maxX) && !e.globals.isBarHorizontal ? i = this.ctx.timeScale.calculateTimeScaleTicks(e.globals.minX, e.globals.maxX) : e.globals.isBarHorizontal && (i = this.ctx.timeScale.calculateTimeScaleTicks(e.globals.minY, e.globals.maxY)), this.ctx.timeScale.recalcDimensionsBasedOnFormat(i);
                    }
                    t = new $b705b473d3ec9641$var$y(this.ctx).getCalculatedRatios();
                }
                return t;
            }
        },
        {
            key: "updateSourceChart",
            value: function(t) {
                this.ctx.w.globals.selection = void 0, this.ctx.updateHelpers._updateOptions({
                    chart: {
                        selection: {
                            xaxis: {
                                min: t.w.globals.minX,
                                max: t.w.globals.maxX
                            }
                        }
                    }
                }, !1, !1);
            }
        },
        {
            key: "setupBrushHandler",
            value: function() {
                var t = this, i = this.w;
                if (i.config.chart.brush.enabled && "function" != typeof i.config.chart.events.selection) {
                    var a = i.config.chart.brush.targets || [
                        i.config.chart.brush.target
                    ];
                    a.forEach(function(e) {
                        var i = ApexCharts.getChartByID(e);
                        i.w.globals.brushSource = t.ctx, "function" != typeof i.w.config.chart.events.zoomed && (i.w.config.chart.events.zoomed = function() {
                            t.updateSourceChart(i);
                        }), "function" != typeof i.w.config.chart.events.scrolled && (i.w.config.chart.events.scrolled = function() {
                            t.updateSourceChart(i);
                        });
                    }), i.config.chart.events.selection = function(t, s) {
                        a.forEach(function(t) {
                            var a = ApexCharts.getChartByID(t), r = $b705b473d3ec9641$var$p.clone(i.config.yaxis);
                            if (i.config.chart.brush.autoScaleYaxis && 1 === a.w.globals.series.length) {
                                var o = new $b705b473d3ec9641$var$j(a);
                                r = o.autoScaleY(a, r, s);
                            }
                            var n = a.w.config.yaxis.reduce(function(t, i, s) {
                                return [].concat($b705b473d3ec9641$var$g(t), [
                                    $b705b473d3ec9641$var$e($b705b473d3ec9641$var$e({}, a.w.config.yaxis[s]), {}, {
                                        min: r[0].min,
                                        max: r[0].max
                                    })
                                ]);
                            }, []);
                            a.ctx.updateHelpers._updateOptions({
                                xaxis: {
                                    min: s.xaxis.min,
                                    max: s.xaxis.max
                                },
                                yaxis: n
                            }, !1, !1, !1, !1);
                        });
                    };
                }
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$Et = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "_updateOptions",
            value: function(t) {
                var e = this, a = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], s = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2], r = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3], o = arguments.length > 4 && void 0 !== arguments[4] && arguments[4];
                return new Promise(function(n) {
                    var l = [
                        e.ctx
                    ];
                    r && (l = e.ctx.getSyncedCharts()), e.ctx.w.globals.isExecCalled && (l = [
                        e.ctx
                    ], e.ctx.w.globals.isExecCalled = !1), l.forEach(function(r, h) {
                        var c = r.w;
                        return c.globals.shouldAnimate = s, a || (c.globals.resized = !0, c.globals.dataChanged = !0, s && r.series.getPreviousPaths()), t && "object" === $b705b473d3ec9641$var$i(t) && (r.config = new $b705b473d3ec9641$var$H(t), t = $b705b473d3ec9641$var$y.extendArrayProps(r.config, t, c), r.w.globals.chartID !== e.ctx.w.globals.chartID && delete t.series, c.config = $b705b473d3ec9641$var$p.extend(c.config, t), o && (c.globals.lastXAxis = t.xaxis ? $b705b473d3ec9641$var$p.clone(t.xaxis) : [], c.globals.lastYAxis = t.yaxis ? $b705b473d3ec9641$var$p.clone(t.yaxis) : [], c.globals.initialConfig = $b705b473d3ec9641$var$p.extend({}, c.config), c.globals.initialSeries = $b705b473d3ec9641$var$p.clone(c.config.series))), r.update(t).then(function() {
                            h === l.length - 1 && n(r);
                        });
                    });
                });
            }
        },
        {
            key: "_updateSeries",
            value: function(t, e) {
                var i = this, a = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                return new Promise(function(s) {
                    var r, o = i.w;
                    return o.globals.shouldAnimate = e, o.globals.dataChanged = !0, e && i.ctx.series.getPreviousPaths(), o.globals.axisCharts ? (0 === (r = t.map(function(t, e) {
                        return i._extendSeries(t, e);
                    })).length && (r = [
                        {
                            data: []
                        }
                    ]), o.config.series = r) : o.config.series = t.slice(), a && (o.globals.initialSeries = $b705b473d3ec9641$var$p.clone(o.config.series)), i.ctx.update().then(function() {
                        s(i.ctx);
                    });
                });
            }
        },
        {
            key: "_extendSeries",
            value: function(t, i) {
                var a = this.w, s = a.config.series[i];
                return $b705b473d3ec9641$var$e($b705b473d3ec9641$var$e({}, a.config.series[i]), {}, {
                    name: t.name ? t.name : s && s.name,
                    color: t.color ? t.color : s && s.color,
                    type: t.type ? t.type : s && s.type,
                    data: t.data ? t.data : s && s.data
                });
            }
        },
        {
            key: "toggleDataPointSelection",
            value: function(t, e) {
                var i = this.w, a = null, s = ".apexcharts-series[data\\:realIndex='".concat(t, "']");
                return i.globals.axisCharts ? a = i.globals.dom.Paper.select("".concat(s, " path[j='").concat(e, "'], ").concat(s, " circle[j='").concat(e, "'], ").concat(s, " rect[j='").concat(e, "']")).members[0] : void 0 === e && (a = i.globals.dom.Paper.select("".concat(s, " path[j='").concat(t, "']")).members[0], "pie" !== i.config.chart.type && "polarArea" !== i.config.chart.type && "donut" !== i.config.chart.type || this.ctx.pie.pieClicked(t)), a ? (new $b705b473d3ec9641$var$b(this.ctx).pathMouseDown(a, null), a.node ? a.node : null) : (console.warn("toggleDataPointSelection: Element not found"), null);
            }
        },
        {
            key: "forceXAxisUpdate",
            value: function(t) {
                var e = this.w;
                if ([
                    "min",
                    "max"
                ].forEach(function(i) {
                    void 0 !== t.xaxis[i] && (e.config.xaxis[i] = t.xaxis[i], e.globals.lastXAxis[i] = t.xaxis[i]);
                }), t.xaxis.categories && t.xaxis.categories.length && (e.config.xaxis.categories = t.xaxis.categories), e.config.xaxis.convertedCatToNumeric) {
                    var i = new $b705b473d3ec9641$var$R(t);
                    t = i.convertCatToNumericXaxis(t, this.ctx);
                }
                return t;
            }
        },
        {
            key: "forceYAxisUpdate",
            value: function(t) {
                var e = this.w;
                return e.config.chart.stacked && "100%" === e.config.chart.stackType && (Array.isArray(t.yaxis) ? t.yaxis.forEach(function(e, i) {
                    t.yaxis[i].min = 0, t.yaxis[i].max = 100;
                }) : (t.yaxis.min = 0, t.yaxis.max = 100)), t;
            }
        },
        {
            key: "revertDefaultAxisMinMax",
            value: function(t) {
                var e = this, i = this.w, a = i.globals.lastXAxis, s = i.globals.lastYAxis;
                t && t.xaxis && (a = t.xaxis), t && t.yaxis && (s = t.yaxis), i.config.xaxis.min = a.min, i.config.xaxis.max = a.max;
                var r = function(t) {
                    void 0 !== s[t] && (i.config.yaxis[t].min = s[t].min, i.config.yaxis[t].max = s[t].max);
                };
                i.config.yaxis.map(function(t, a) {
                    i.globals.zoomed || void 0 !== s[a] ? r(a) : void 0 !== e.ctx.opts.yaxis[a] && (t.min = e.ctx.opts.yaxis[a].min, t.max = e.ctx.opts.yaxis[a].max);
                });
            }
        }
    ]), t;
}();
$b705b473d3ec9641$var$Tt = "undefined" != typeof window ? window : void 0, $b705b473d3ec9641$var$Mt = function(t, e) {
    var a = (void 0 !== this ? this : t).SVG = function(t) {
        if (a.supported) return t = new a.Doc(t), a.parser.draw || a.prepare(), t;
    };
    if (a.ns = "http://www.w3.org/2000/svg", a.xmlns = "http://www.w3.org/2000/xmlns/", a.xlink = "http://www.w3.org/1999/xlink", a.svgjs = "http://svgjs.dev", a.supported = !0, !a.supported) return !1;
    a.did = 1e3, a.eid = function(t) {
        return "Svgjs" + d(t) + a.did++;
    }, a.create = function(t) {
        var i = e.createElementNS(this.ns, t);
        return i.setAttribute("id", this.eid(t)), i;
    }, a.extend = function() {
        var t, e;
        e = (t = [].slice.call(arguments)).pop();
        for(var i = t.length - 1; i >= 0; i--)if (t[i]) for(var s in e)t[i].prototype[s] = e[s];
        a.Set && a.Set.inherit && a.Set.inherit();
    }, a.invent = function(t) {
        var e = "function" == typeof t.create ? t.create : function() {
            this.constructor.call(this, a.create(t.create));
        };
        return t.inherit && (e.prototype = new t.inherit), t.extend && a.extend(e, t.extend), t.construct && a.extend(t.parent || a.Container, t.construct), e;
    }, a.adopt = function(e) {
        var i;
        return e ? e.instance ? e.instance : ((i = "svg" == e.nodeName ? e.parentNode instanceof t.SVGElement ? new a.Nested : new a.Doc : "linearGradient" == e.nodeName ? new a.Gradient("linear") : "radialGradient" == e.nodeName ? new a.Gradient("radial") : a[d(e.nodeName)] ? new a[d(e.nodeName)] : new a.Element(e)).type = e.nodeName, i.node = e, e.instance = i, i instanceof a.Doc && i.namespace().defs(), i.setData(JSON.parse(e.getAttribute("svgjs:data")) || {}), i) : null;
    }, a.prepare = function() {
        var t = e.getElementsByTagName("body")[0], i = (t ? new a.Doc(t) : a.adopt(e.documentElement).nested()).size(2, 0);
        a.parser = {
            body: t || e.documentElement,
            draw: i.style("opacity:0;position:absolute;left:-100%;top:-100%;overflow:hidden").node,
            poly: i.polyline().node,
            path: i.path().node,
            native: a.create("svg")
        };
    }, a.parser = {
        native: a.create("svg")
    }, e.addEventListener("DOMContentLoaded", function() {
        a.parser.draw || a.prepare();
    }, !1), a.regex = {
        numberAndUnit: /^([+-]?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?)([a-z%]*)$/i,
        hex: /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i,
        rgb: /rgb\((\d+),(\d+),(\d+)\)/,
        reference: /#([a-z0-9\-_]+)/i,
        transforms: /\)\s*,?\s*/,
        whitespace: /\s/g,
        isHex: /^#[a-f0-9]{3,6}$/i,
        isRgb: /^rgb\(/,
        isCss: /[^:]+:[^;]+;?/,
        isBlank: /^(\s+)?$/,
        isNumber: /^[+-]?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i,
        isPercent: /^-?[\d\.]+%$/,
        isImage: /\.(jpg|jpeg|png|gif|svg)(\?[^=]+.*)?/i,
        delimiter: /[\s,]+/,
        hyphen: /([^e])\-/gi,
        pathLetters: /[MLHVCSQTAZ]/gi,
        isPathLetter: /[MLHVCSQTAZ]/i,
        numbersWithDots: /((\d?\.\d+(?:e[+-]?\d+)?)((?:\.\d+(?:e[+-]?\d+)?)+))+/gi,
        dots: /\./g
    }, a.utils = {
        map: function(t, e) {
            for(var i = t.length, a = [], s = 0; s < i; s++)a.push(e(t[s]));
            return a;
        },
        filter: function(t, e) {
            for(var i = t.length, a = [], s = 0; s < i; s++)e(t[s]) && a.push(t[s]);
            return a;
        },
        filterSVGElements: function(e) {
            return this.filter(e, function(e) {
                return e instanceof t.SVGElement;
            });
        }
    }, a.defaults = {
        attrs: {
            "fill-opacity": 1,
            "stroke-opacity": 1,
            "stroke-width": 0,
            "stroke-linejoin": "miter",
            "stroke-linecap": "butt",
            fill: "#000000",
            stroke: "#000000",
            opacity: 1,
            x: 0,
            y: 0,
            cx: 0,
            cy: 0,
            width: 0,
            height: 0,
            r: 0,
            rx: 0,
            ry: 0,
            offset: 0,
            "stop-opacity": 1,
            "stop-color": "#000000",
            "font-size": 16,
            "font-family": "Helvetica, Arial, sans-serif",
            "text-anchor": "start"
        }
    }, a.Color = function(t) {
        var e, s;
        this.r = 0, this.g = 0, this.b = 0, t && ("string" == typeof t ? a.regex.isRgb.test(t) ? (e = a.regex.rgb.exec(t.replace(a.regex.whitespace, "")), this.r = parseInt(e[1]), this.g = parseInt(e[2]), this.b = parseInt(e[3])) : a.regex.isHex.test(t) && (e = a.regex.hex.exec(4 == (s = t).length ? [
            "#",
            s.substring(1, 2),
            s.substring(1, 2),
            s.substring(2, 3),
            s.substring(2, 3),
            s.substring(3, 4),
            s.substring(3, 4)
        ].join("") : s), this.r = parseInt(e[1], 16), this.g = parseInt(e[2], 16), this.b = parseInt(e[3], 16)) : "object" === $b705b473d3ec9641$var$i(t) && (this.r = t.r, this.g = t.g, this.b = t.b));
    }, a.extend(a.Color, {
        toString: function() {
            return this.toHex();
        },
        toHex: function() {
            return "#" + g(this.r) + g(this.g) + g(this.b);
        },
        toRgb: function() {
            return "rgb(" + [
                this.r,
                this.g,
                this.b
            ].join() + ")";
        },
        brightness: function() {
            return this.r / 255 * .3 + this.g / 255 * .59 + this.b / 255 * .11;
        },
        morph: function(t) {
            return this.destination = new a.Color(t), this;
        },
        at: function(t) {
            return this.destination ? (t = t < 0 ? 0 : t > 1 ? 1 : t, new a.Color({
                r: ~~(this.r + (this.destination.r - this.r) * t),
                g: ~~(this.g + (this.destination.g - this.g) * t),
                b: ~~(this.b + (this.destination.b - this.b) * t)
            })) : this;
        }
    }), a.Color.test = function(t) {
        return t += "", a.regex.isHex.test(t) || a.regex.isRgb.test(t);
    }, a.Color.isRgb = function(t) {
        return t && "number" == typeof t.r && "number" == typeof t.g && "number" == typeof t.b;
    }, a.Color.isColor = function(t) {
        return a.Color.isRgb(t) || a.Color.test(t);
    }, a.Array = function(t, e) {
        0 == (t = (t || []).valueOf()).length && e && (t = e.valueOf()), this.value = this.parse(t);
    }, a.extend(a.Array, {
        toString: function() {
            return this.value.join(" ");
        },
        valueOf: function() {
            return this.value;
        },
        parse: function(t) {
            return t = t.valueOf(), Array.isArray(t) ? t : this.split(t);
        }
    }), a.PointArray = function(t, e) {
        a.Array.call(this, t, e || [
            [
                0,
                0
            ]
        ]);
    }, a.PointArray.prototype = new a.Array, a.PointArray.prototype.constructor = a.PointArray;
    for(var s = {
        M: function(t, e, i) {
            return e.x = i.x = t[0], e.y = i.y = t[1], [
                "M",
                e.x,
                e.y
            ];
        },
        L: function(t, e) {
            return e.x = t[0], e.y = t[1], [
                "L",
                t[0],
                t[1]
            ];
        },
        H: function(t, e) {
            return e.x = t[0], [
                "H",
                t[0]
            ];
        },
        V: function(t, e) {
            return e.y = t[0], [
                "V",
                t[0]
            ];
        },
        C: function(t, e) {
            return e.x = t[4], e.y = t[5], [
                "C",
                t[0],
                t[1],
                t[2],
                t[3],
                t[4],
                t[5]
            ];
        },
        Q: function(t, e) {
            return e.x = t[2], e.y = t[3], [
                "Q",
                t[0],
                t[1],
                t[2],
                t[3]
            ];
        },
        Z: function(t, e, i) {
            return e.x = i.x, e.y = i.y, [
                "Z"
            ];
        }
    }, r = "mlhvqtcsaz".split(""), o = 0, n = r.length; o < n; ++o)s[r[o]] = function(t) {
        return function(e, i, a) {
            if ("H" == t) e[0] = e[0] + i.x;
            else if ("V" == t) e[0] = e[0] + i.y;
            else if ("A" == t) e[5] = e[5] + i.x, e[6] = e[6] + i.y;
            else for(var r = 0, o = e.length; r < o; ++r)e[r] = e[r] + (r % 2 ? i.y : i.x);
            if (s && "function" == typeof s[t]) return s[t](e, i, a);
        };
    }(r[o].toUpperCase());
    a.PathArray = function(t, e) {
        a.Array.call(this, t, e || [
            [
                "M",
                0,
                0
            ]
        ]);
    }, a.PathArray.prototype = new a.Array, a.PathArray.prototype.constructor = a.PathArray, a.extend(a.PathArray, {
        toString: function() {
            return function(t) {
                for(var e = 0, i = t.length, a = ""; e < i; e++)a += t[e][0], null != t[e][1] && (a += t[e][1], null != t[e][2] && (a += " ", a += t[e][2], null != t[e][3] && (a += " ", a += t[e][3], a += " ", a += t[e][4], null != t[e][5] && (a += " ", a += t[e][5], a += " ", a += t[e][6], null != t[e][7] && (a += " ", a += t[e][7])))));
                return a + " ";
            }(this.value);
        },
        move: function(t, e) {
            var i = this.bbox();
            return i.x, i.y, this;
        },
        at: function(t) {
            if (!this.destination) return this;
            for(var e = this.value, i = this.destination.value, s = [], r = new a.PathArray, o = 0, n = e.length; o < n; o++){
                s[o] = [
                    e[o][0]
                ];
                for(var l = 1, h = e[o].length; l < h; l++)s[o][l] = e[o][l] + (i[o][l] - e[o][l]) * t;
                "A" === s[o][0] && (s[o][4] = +(0 != s[o][4]), s[o][5] = +(0 != s[o][5]));
            }
            return r.value = s, r;
        },
        parse: function(t) {
            if (t instanceof a.PathArray) return t.valueOf();
            var e, i = {
                M: 2,
                L: 2,
                H: 1,
                V: 1,
                C: 6,
                S: 4,
                Q: 4,
                T: 2,
                A: 7,
                Z: 0
            };
            t = "string" == typeof t ? t.replace(a.regex.numbersWithDots, h).replace(a.regex.pathLetters, " $& ").replace(a.regex.hyphen, "$1 -").trim().split(a.regex.delimiter) : t.reduce(function(t, e) {
                return [].concat.call(t, e);
            }, []);
            var r = [], o = new a.Point, n = new a.Point, l = 0, c = t.length;
            do a.regex.isPathLetter.test(t[l]) ? (e = t[l], ++l) : "M" == e ? e = "L" : "m" == e && (e = "l"), r.push(s[e].call(null, t.slice(l, l += i[e.toUpperCase()]).map(parseFloat), o, n));
            while (c > l);
            return r;
        },
        bbox: function() {
            return a.parser.draw || a.prepare(), a.parser.path.setAttribute("d", this.toString()), a.parser.path.getBBox();
        }
    }), a.Number = a.invent({
        create: function(t, e) {
            this.value = 0, this.unit = e || "", "number" == typeof t ? this.value = isNaN(t) ? 0 : isFinite(t) ? t : t < 0 ? -340000000000000000000000000000000000000 : 34e37 : "string" == typeof t ? (e = t.match(a.regex.numberAndUnit)) && (this.value = parseFloat(e[1]), "%" == e[5] ? this.value /= 100 : "s" == e[5] && (this.value *= 1e3), this.unit = e[5]) : t instanceof a.Number && (this.value = t.valueOf(), this.unit = t.unit);
        },
        extend: {
            toString: function() {
                return ("%" == this.unit ? ~~(1e8 * this.value) / 1e6 : "s" == this.unit ? this.value / 1e3 : this.value) + this.unit;
            },
            toJSON: function() {
                return this.toString();
            },
            valueOf: function() {
                return this.value;
            },
            plus: function(t) {
                return t = new a.Number(t), new a.Number(this + t, this.unit || t.unit);
            },
            minus: function(t) {
                return t = new a.Number(t), new a.Number(this - t, this.unit || t.unit);
            },
            times: function(t) {
                return t = new a.Number(t), new a.Number(this * t, this.unit || t.unit);
            },
            divide: function(t) {
                return t = new a.Number(t), new a.Number(this / t, this.unit || t.unit);
            },
            to: function(t) {
                var e = new a.Number(this);
                return "string" == typeof t && (e.unit = t), e;
            },
            morph: function(t) {
                return this.destination = new a.Number(t), t.relative && (this.destination.value += this.value), this;
            },
            at: function(t) {
                return this.destination ? new a.Number(this.destination).minus(this).times(t).plus(this) : this;
            }
        }
    }), a.Element = a.invent({
        create: function(t) {
            this._stroke = a.defaults.attrs.stroke, this._event = null, this.dom = {}, (this.node = t) && (this.type = t.nodeName, this.node.instance = this, this._stroke = t.getAttribute("stroke") || this._stroke);
        },
        extend: {
            x: function(t) {
                return this.attr("x", t);
            },
            y: function(t) {
                return this.attr("y", t);
            },
            cx: function(t) {
                return null == t ? this.x() + this.width() / 2 : this.x(t - this.width() / 2);
            },
            cy: function(t) {
                return null == t ? this.y() + this.height() / 2 : this.y(t - this.height() / 2);
            },
            move: function(t, e) {
                return this.x(t).y(e);
            },
            center: function(t, e) {
                return this.cx(t).cy(e);
            },
            width: function(t) {
                return this.attr("width", t);
            },
            height: function(t) {
                return this.attr("height", t);
            },
            size: function(t, e) {
                var i = u(this, t, e);
                return this.width(new a.Number(i.width)).height(new a.Number(i.height));
            },
            clone: function(t) {
                this.writeDataToDom();
                var e = x(this.node.cloneNode(!0));
                return t ? t.add(e) : this.after(e), e;
            },
            remove: function() {
                return this.parent() && this.parent().removeElement(this), this;
            },
            replace: function(t) {
                return this.after(t).remove(), t;
            },
            addTo: function(t) {
                return t.put(this);
            },
            putIn: function(t) {
                return t.add(this);
            },
            id: function(t) {
                return this.attr("id", t);
            },
            show: function() {
                return this.style("display", "");
            },
            hide: function() {
                return this.style("display", "none");
            },
            visible: function() {
                return "none" != this.style("display");
            },
            toString: function() {
                return this.attr("id");
            },
            classes: function() {
                var t = this.attr("class");
                return null == t ? [] : t.trim().split(a.regex.delimiter);
            },
            hasClass: function(t) {
                return -1 != this.classes().indexOf(t);
            },
            addClass: function(t) {
                if (!this.hasClass(t)) {
                    var e = this.classes();
                    e.push(t), this.attr("class", e.join(" "));
                }
                return this;
            },
            removeClass: function(t) {
                return this.hasClass(t) && this.attr("class", this.classes().filter(function(e) {
                    return e != t;
                }).join(" ")), this;
            },
            toggleClass: function(t) {
                return this.hasClass(t) ? this.removeClass(t) : this.addClass(t);
            },
            reference: function(t) {
                return a.get(this.attr(t));
            },
            parent: function(e) {
                var i = this;
                if (!i.node.parentNode) return null;
                if (i = a.adopt(i.node.parentNode), !e) return i;
                for(; i && i.node instanceof t.SVGElement;){
                    if ("string" == typeof e ? i.matches(e) : i instanceof e) return i;
                    if (!i.node.parentNode || "#document" == i.node.parentNode.nodeName) return null;
                    i = a.adopt(i.node.parentNode);
                }
            },
            doc: function() {
                return this instanceof a.Doc ? this : this.parent(a.Doc);
            },
            parents: function(t) {
                var e = [], i = this;
                do {
                    if (!(i = i.parent(t)) || !i.node) break;
                    e.push(i);
                }while (i.parent);
                return e;
            },
            matches: function(t) {
                return function(t, e) {
                    return (t.matches || t.matchesSelector || t.msMatchesSelector || t.mozMatchesSelector || t.webkitMatchesSelector || t.oMatchesSelector).call(t, e);
                }(this.node, t);
            },
            native: function() {
                return this.node;
            },
            svg: function(t) {
                var i = e.createElement("svg");
                if (!(t && this instanceof a.Parent)) return i.appendChild(t = e.createElement("svg")), this.writeDataToDom(), t.appendChild(this.node.cloneNode(!0)), i.innerHTML.replace(/^<svg>/, "").replace(/<\/svg>$/, "");
                i.innerHTML = "<svg>" + t.replace(/\n/, "").replace(/<([\w:-]+)([^<]+?)\/>/g, "<$1$2></$1>") + "</svg>";
                for(var s = 0, r = i.firstChild.childNodes.length; s < r; s++)this.node.appendChild(i.firstChild.firstChild);
                return this;
            },
            writeDataToDom: function() {
                return (this.each || this.lines) && (this.each ? this : this.lines()).each(function() {
                    this.writeDataToDom();
                }), this.node.removeAttribute("svgjs:data"), Object.keys(this.dom).length && this.node.setAttribute("svgjs:data", JSON.stringify(this.dom)), this;
            },
            setData: function(t) {
                return this.dom = t, this;
            },
            is: function(t) {
                return function(t, e) {
                    return t instanceof e;
                }(this, t);
            }
        }
    }), a.easing = {
        "-": function(t) {
            return t;
        },
        "<>": function(t) {
            return -Math.cos(t * Math.PI) / 2 + .5;
        },
        ">": function(t) {
            return Math.sin(t * Math.PI / 2);
        },
        "<": function(t) {
            return 1 - Math.cos(t * Math.PI / 2);
        }
    }, a.morph = function(t) {
        return function(e, i) {
            return new a.MorphObj(e, i).at(t);
        };
    }, a.Situation = a.invent({
        create: function(t) {
            this.init = !1, this.reversed = !1, this.reversing = !1, this.duration = new a.Number(t.duration).valueOf(), this.delay = new a.Number(t.delay).valueOf(), this.start = +new Date + this.delay, this.finish = this.start + this.duration, this.ease = t.ease, this.loop = 0, this.loops = !1, this.animations = {}, this.attrs = {}, this.styles = {}, this.transforms = [], this.once = {};
        }
    }), a.FX = a.invent({
        create: function(t) {
            this._target = t, this.situations = [], this.active = !1, this.situation = null, this.paused = !1, this.lastPos = 0, this.pos = 0, this.absPos = 0, this._speed = 1;
        },
        extend: {
            animate: function(t, e, s) {
                "object" === $b705b473d3ec9641$var$i(t) && (e = t.ease, s = t.delay, t = t.duration);
                var r = new a.Situation({
                    duration: t || 1e3,
                    delay: s || 0,
                    ease: a.easing[e || "-"] || e
                });
                return this.queue(r), this;
            },
            target: function(t) {
                return t && t instanceof a.Element ? (this._target = t, this) : this._target;
            },
            timeToAbsPos: function(t) {
                return (t - this.situation.start) / (this.situation.duration / this._speed);
            },
            absPosToTime: function(t) {
                return this.situation.duration / this._speed * t + this.situation.start;
            },
            startAnimFrame: function() {
                this.stopAnimFrame(), this.animationFrame = t.requestAnimationFrame((function() {
                    this.step();
                }).bind(this));
            },
            stopAnimFrame: function() {
                t.cancelAnimationFrame(this.animationFrame);
            },
            start: function() {
                return !this.active && this.situation && (this.active = !0, this.startCurrent()), this;
            },
            startCurrent: function() {
                return this.situation.start = +new Date + this.situation.delay / this._speed, this.situation.finish = this.situation.start + this.situation.duration / this._speed, this.initAnimations().step();
            },
            queue: function(t) {
                return ("function" == typeof t || t instanceof a.Situation) && this.situations.push(t), this.situation || (this.situation = this.situations.shift()), this;
            },
            dequeue: function() {
                return this.stop(), this.situation = this.situations.shift(), this.situation && (this.situation instanceof a.Situation ? this.start() : this.situation.call(this)), this;
            },
            initAnimations: function() {
                var t, e = this.situation;
                if (e.init) return this;
                for(var i in e.animations){
                    t = this.target()[i](), Array.isArray(t) || (t = [
                        t
                    ]), Array.isArray(e.animations[i]) || (e.animations[i] = [
                        e.animations[i]
                    ]);
                    for(var s = t.length; s--;)e.animations[i][s] instanceof a.Number && (t[s] = new a.Number(t[s])), e.animations[i][s] = t[s].morph(e.animations[i][s]);
                }
                for(var i in e.attrs)e.attrs[i] = new a.MorphObj(this.target().attr(i), e.attrs[i]);
                for(var i in e.styles)e.styles[i] = new a.MorphObj(this.target().style(i), e.styles[i]);
                return e.initialTransformation = this.target().matrixify(), e.init = !0, this;
            },
            clearQueue: function() {
                return this.situations = [], this;
            },
            clearCurrent: function() {
                return this.situation = null, this;
            },
            stop: function(t, e) {
                var i = this.active;
                return this.active = !1, e && this.clearQueue(), t && this.situation && (!i && this.startCurrent(), this.atEnd()), this.stopAnimFrame(), this.clearCurrent();
            },
            after: function(t) {
                var e = this.last();
                return this.target().on("finished.fx", function i(a) {
                    a.detail.situation == e && (t.call(this, e), this.off("finished.fx", i));
                }), this._callStart();
            },
            during: function(t) {
                var e = this.last(), i = function(i) {
                    i.detail.situation == e && t.call(this, i.detail.pos, a.morph(i.detail.pos), i.detail.eased, e);
                };
                return this.target().off("during.fx", i).on("during.fx", i), this.after(function() {
                    this.off("during.fx", i);
                }), this._callStart();
            },
            afterAll: function(t) {
                var e = function e(i) {
                    t.call(this), this.off("allfinished.fx", e);
                };
                return this.target().off("allfinished.fx", e).on("allfinished.fx", e), this._callStart();
            },
            last: function() {
                return this.situations.length ? this.situations[this.situations.length - 1] : this.situation;
            },
            add: function(t, e, i) {
                return this.last()[i || "animations"][t] = e, this._callStart();
            },
            step: function(t) {
                var e, i, a;
                t || (this.absPos = this.timeToAbsPos(+new Date)), !1 !== this.situation.loops ? (e = Math.max(this.absPos, 0), i = Math.floor(e), !0 === this.situation.loops || i < this.situation.loops ? (this.pos = e - i, a = this.situation.loop, this.situation.loop = i) : (this.absPos = this.situation.loops, this.pos = 1, a = this.situation.loop - 1, this.situation.loop = this.situation.loops), this.situation.reversing && (this.situation.reversed = this.situation.reversed != Boolean((this.situation.loop - a) % 2))) : (this.absPos = Math.min(this.absPos, 1), this.pos = this.absPos), this.pos < 0 && (this.pos = 0), this.situation.reversed && (this.pos = 1 - this.pos);
                var s = this.situation.ease(this.pos);
                for(var r in this.situation.once)r > this.lastPos && r <= s && (this.situation.once[r].call(this.target(), this.pos, s), delete this.situation.once[r]);
                return this.active && this.target().fire("during", {
                    pos: this.pos,
                    eased: s,
                    fx: this,
                    situation: this.situation
                }), this.situation ? (this.eachAt(), 1 == this.pos && !this.situation.reversed || this.situation.reversed && 0 == this.pos ? (this.stopAnimFrame(), this.target().fire("finished", {
                    fx: this,
                    situation: this.situation
                }), this.situations.length || (this.target().fire("allfinished"), this.situations.length || (this.target().off(".fx"), this.active = !1)), this.active ? this.dequeue() : this.clearCurrent()) : !this.paused && this.active && this.startAnimFrame(), this.lastPos = s, this) : this;
            },
            eachAt: function() {
                var t, e = this, i = this.target(), s = this.situation;
                for(var r in s.animations)t = [].concat(s.animations[r]).map(function(t) {
                    return "string" != typeof t && t.at ? t.at(s.ease(e.pos), e.pos) : t;
                }), i[r].apply(i, t);
                for(var r in s.attrs)t = [
                    r
                ].concat(s.attrs[r]).map(function(t) {
                    return "string" != typeof t && t.at ? t.at(s.ease(e.pos), e.pos) : t;
                }), i.attr.apply(i, t);
                for(var r in s.styles)t = [
                    r
                ].concat(s.styles[r]).map(function(t) {
                    return "string" != typeof t && t.at ? t.at(s.ease(e.pos), e.pos) : t;
                }), i.style.apply(i, t);
                if (s.transforms.length) {
                    t = s.initialTransformation, r = 0;
                    for(var o = s.transforms.length; r < o; r++){
                        var n = s.transforms[r];
                        n instanceof a.Matrix ? t = n.relative ? t.multiply((new a.Matrix).morph(n).at(s.ease(this.pos))) : t.morph(n).at(s.ease(this.pos)) : (n.relative || n.undo(t.extract()), t = t.multiply(n.at(s.ease(this.pos))));
                    }
                    i.matrix(t);
                }
                return this;
            },
            once: function(t, e, i) {
                var a = this.last();
                return i || (t = a.ease(t)), a.once[t] = e, this;
            },
            _callStart: function() {
                return setTimeout((function() {
                    this.start();
                }).bind(this), 0), this;
            }
        },
        parent: a.Element,
        construct: {
            animate: function(t, e, i) {
                return (this.fx || (this.fx = new a.FX(this))).animate(t, e, i);
            },
            delay: function(t) {
                return (this.fx || (this.fx = new a.FX(this))).delay(t);
            },
            stop: function(t, e) {
                return this.fx && this.fx.stop(t, e), this;
            },
            finish: function() {
                return this.fx && this.fx.finish(), this;
            }
        }
    }), a.MorphObj = a.invent({
        create: function(t, e) {
            return a.Color.isColor(e) ? new a.Color(t).morph(e) : a.regex.delimiter.test(t) ? a.regex.pathLetters.test(t) ? new a.PathArray(t).morph(e) : new a.Array(t).morph(e) : a.regex.numberAndUnit.test(e) ? new a.Number(t).morph(e) : (this.value = t, void (this.destination = e));
        },
        extend: {
            at: function(t, e) {
                return e < 1 ? this.value : this.destination;
            },
            valueOf: function() {
                return this.value;
            }
        }
    }), a.extend(a.FX, {
        attr: function(t, e, a) {
            if ("object" === $b705b473d3ec9641$var$i(t)) for(var s in t)this.attr(s, t[s]);
            else this.add(t, e, "attrs");
            return this;
        },
        plot: function(t, e, i, a) {
            return 4 == arguments.length ? this.plot([
                t,
                e,
                i,
                a
            ]) : this.add("plot", new (this.target()).morphArray(t));
        }
    }), a.Box = a.invent({
        create: function(t, e, s, r) {
            if (!("object" !== $b705b473d3ec9641$var$i(t) || t instanceof a.Element)) return a.Box.call(this, null != t.left ? t.left : t.x, null != t.top ? t.top : t.y, t.width, t.height);
            4 == arguments.length && (this.x = t, this.y = e, this.width = s, this.height = r), b(this);
        }
    }), a.BBox = a.invent({
        create: function(t) {
            if (a.Box.apply(this, [].slice.call(arguments)), t instanceof a.Element) {
                var i;
                try {
                    if (!e.documentElement.contains) {
                        for(var s = t.node; s.parentNode;)s = s.parentNode;
                        if (s != e) throw new Error("Element not in the dom");
                    }
                    i = t.node.getBBox();
                } catch (e) {
                    if (t instanceof a.Shape) {
                        a.parser.draw || a.prepare();
                        var r = t.clone(a.parser.draw.instance).show();
                        r && r.node && "function" == typeof r.node.getBBox && (i = r.node.getBBox()), r && "function" == typeof r.remove && r.remove();
                    } else i = {
                        x: t.node.clientLeft,
                        y: t.node.clientTop,
                        width: t.node.clientWidth,
                        height: t.node.clientHeight
                    };
                }
                a.Box.call(this, i);
            }
        },
        inherit: a.Box,
        parent: a.Element,
        construct: {
            bbox: function() {
                return new a.BBox(this);
            }
        }
    }), a.BBox.prototype.constructor = a.BBox, a.Matrix = a.invent({
        create: function(t) {
            var e = f([
                1,
                0,
                0,
                1,
                0,
                0
            ]);
            t = null === t ? e : t instanceof a.Element ? t.matrixify() : "string" == typeof t ? f(t.split(a.regex.delimiter).map(parseFloat)) : 6 == arguments.length ? f([].slice.call(arguments)) : Array.isArray(t) ? f(t) : t && "object" === $b705b473d3ec9641$var$i(t) ? t : e;
            for(var s = m.length - 1; s >= 0; --s)this[m[s]] = null != t[m[s]] ? t[m[s]] : e[m[s]];
        },
        extend: {
            extract: function() {
                var t = p(this, 0, 1);
                p(this, 1, 0);
                var e = 180 / Math.PI * Math.atan2(t.y, t.x) - 90;
                return {
                    x: this.e,
                    y: this.f,
                    transformedX: (this.e * Math.cos(e * Math.PI / 180) + this.f * Math.sin(e * Math.PI / 180)) / Math.sqrt(this.a * this.a + this.b * this.b),
                    transformedY: (this.f * Math.cos(e * Math.PI / 180) + this.e * Math.sin(-e * Math.PI / 180)) / Math.sqrt(this.c * this.c + this.d * this.d),
                    rotation: e,
                    a: this.a,
                    b: this.b,
                    c: this.c,
                    d: this.d,
                    e: this.e,
                    f: this.f,
                    matrix: new a.Matrix(this)
                };
            },
            clone: function() {
                return new a.Matrix(this);
            },
            morph: function(t) {
                return this.destination = new a.Matrix(t), this;
            },
            multiply: function(t) {
                return new a.Matrix(this.native().multiply((function(t) {
                    return t instanceof a.Matrix || (t = new a.Matrix(t)), t;
                })(t).native()));
            },
            inverse: function() {
                return new a.Matrix(this.native().inverse());
            },
            translate: function(t, e) {
                return new a.Matrix(this.native().translate(t || 0, e || 0));
            },
            native: function() {
                for(var t = a.parser.native.createSVGMatrix(), e = m.length - 1; e >= 0; e--)t[m[e]] = this[m[e]];
                return t;
            },
            toString: function() {
                return "matrix(" + v(this.a) + "," + v(this.b) + "," + v(this.c) + "," + v(this.d) + "," + v(this.e) + "," + v(this.f) + ")";
            }
        },
        parent: a.Element,
        construct: {
            ctm: function() {
                return new a.Matrix(this.node.getCTM());
            },
            screenCTM: function() {
                if (this instanceof a.Nested) {
                    var t = this.rect(1, 1), e = t.node.getScreenCTM();
                    return t.remove(), new a.Matrix(e);
                }
                return new a.Matrix(this.node.getScreenCTM());
            }
        }
    }), a.Point = a.invent({
        create: function(t, e) {
            var a;
            a = Array.isArray(t) ? {
                x: t[0],
                y: t[1]
            } : "object" === $b705b473d3ec9641$var$i(t) ? {
                x: t.x,
                y: t.y
            } : null != t ? {
                x: t,
                y: null != e ? e : t
            } : {
                x: 0,
                y: 0
            }, this.x = a.x, this.y = a.y;
        },
        extend: {
            clone: function() {
                return new a.Point(this);
            },
            morph: function(t, e) {
                return this.destination = new a.Point(t, e), this;
            }
        }
    }), a.extend(a.Element, {
        point: function(t, e) {
            return new a.Point(t, e).transform(this.screenCTM().inverse());
        }
    }), a.extend(a.Element, {
        attr: function(t, e, s) {
            if (null == t) {
                for(t = {}, s = (e = this.node.attributes).length - 1; s >= 0; s--)t[e[s].nodeName] = a.regex.isNumber.test(e[s].nodeValue) ? parseFloat(e[s].nodeValue) : e[s].nodeValue;
                return t;
            }
            if ("object" === $b705b473d3ec9641$var$i(t)) for(var r in t)this.attr(r, t[r]);
            else if (null === e) this.node.removeAttribute(t);
            else {
                if (null == e) return null == (e = this.node.getAttribute(t)) ? a.defaults.attrs[t] : a.regex.isNumber.test(e) ? parseFloat(e) : e;
                "stroke-width" == t ? this.attr("stroke", parseFloat(e) > 0 ? this._stroke : null) : "stroke" == t && (this._stroke = e), "fill" != t && "stroke" != t || (a.regex.isImage.test(e) && (e = this.doc().defs().image(e, 0, 0)), e instanceof a.Image && (e = this.doc().defs().pattern(0, 0, function() {
                    this.add(e);
                }))), "number" == typeof e ? e = new a.Number(e) : a.Color.isColor(e) ? e = new a.Color(e) : Array.isArray(e) && (e = new a.Array(e)), "leading" == t ? this.leading && this.leading(e) : "string" == typeof s ? this.node.setAttributeNS(s, t, e.toString()) : this.node.setAttribute(t, e.toString()), !this.rebuild || "font-size" != t && "x" != t || this.rebuild(t, e);
            }
            return this;
        }
    }), a.extend(a.Element, {
        transform: function(t, e) {
            var s;
            return "object" !== $b705b473d3ec9641$var$i(t) ? (s = new a.Matrix(this).extract(), "string" == typeof t ? s[t] : s) : (s = new a.Matrix(this), e = !!e || !!t.relative, null != t.a && (s = e ? s.multiply(new a.Matrix(t)) : new a.Matrix(t)), this.attr("transform", s));
        }
    }), a.extend(a.Element, {
        untransform: function() {
            return this.attr("transform", null);
        },
        matrixify: function() {
            return (this.attr("transform") || "").split(a.regex.transforms).slice(0, -1).map(function(t) {
                var e = t.trim().split("(");
                return [
                    e[0],
                    e[1].split(a.regex.delimiter).map(function(t) {
                        return parseFloat(t);
                    })
                ];
            }).reduce(function(t, e) {
                return "matrix" == e[0] ? t.multiply(f(e[1])) : t[e[0]].apply(t, e[1]);
            }, new a.Matrix);
        },
        toParent: function(t) {
            if (this == t) return this;
            var e = this.screenCTM(), i = t.screenCTM().inverse();
            return this.addTo(t).untransform().transform(i.multiply(e)), this;
        },
        toDoc: function() {
            return this.toParent(this.doc());
        }
    }), a.Transformation = a.invent({
        create: function(t, e) {
            if (arguments.length > 1 && "boolean" != typeof e) return this.constructor.call(this, [].slice.call(arguments));
            if (Array.isArray(t)) for(var a = 0, s = this.arguments.length; a < s; ++a)this[this.arguments[a]] = t[a];
            else if (t && "object" === $b705b473d3ec9641$var$i(t)) for(a = 0, s = this.arguments.length; a < s; ++a)this[this.arguments[a]] = t[this.arguments[a]];
            this.inversed = !1, !0 === e && (this.inversed = !0);
        }
    }), a.Translate = a.invent({
        parent: a.Matrix,
        inherit: a.Transformation,
        create: function(t, e) {
            this.constructor.apply(this, [].slice.call(arguments));
        },
        extend: {
            arguments: [
                "transformedX",
                "transformedY"
            ],
            method: "translate"
        }
    }), a.extend(a.Element, {
        style: function(t, e) {
            if (0 == arguments.length) return this.node.style.cssText || "";
            if (arguments.length < 2) {
                if ("object" === $b705b473d3ec9641$var$i(t)) for(var s in t)this.style(s, t[s]);
                else {
                    if (!a.regex.isCss.test(t)) return this.node.style[c(t)];
                    for(t = t.split(/\s*;\s*/).filter(function(t) {
                        return !!t;
                    }).map(function(t) {
                        return t.split(/\s*:\s*/);
                    }); e = t.pop();)this.style(e[0], e[1]);
                }
            } else this.node.style[c(t)] = null === e || a.regex.isBlank.test(e) ? "" : e;
            return this;
        }
    }), a.Parent = a.invent({
        create: function(t) {
            this.constructor.call(this, t);
        },
        inherit: a.Element,
        extend: {
            children: function() {
                return a.utils.map(a.utils.filterSVGElements(this.node.childNodes), function(t) {
                    return a.adopt(t);
                });
            },
            add: function(t, e) {
                return null == e ? this.node.appendChild(t.node) : t.node != this.node.childNodes[e] && this.node.insertBefore(t.node, this.node.childNodes[e]), this;
            },
            put: function(t, e) {
                return this.add(t, e), t;
            },
            has: function(t) {
                return this.index(t) >= 0;
            },
            index: function(t) {
                return [].slice.call(this.node.childNodes).indexOf(t.node);
            },
            get: function(t) {
                return a.adopt(this.node.childNodes[t]);
            },
            first: function() {
                return this.get(0);
            },
            last: function() {
                return this.get(this.node.childNodes.length - 1);
            },
            each: function(t, e) {
                for(var i = this.children(), s = 0, r = i.length; s < r; s++)i[s] instanceof a.Element && t.apply(i[s], [
                    s,
                    i
                ]), e && i[s] instanceof a.Container && i[s].each(t, e);
                return this;
            },
            removeElement: function(t) {
                return this.node.removeChild(t.node), this;
            },
            clear: function() {
                for(; this.node.hasChildNodes();)this.node.removeChild(this.node.lastChild);
                return delete this._defs, this;
            },
            defs: function() {
                return this.doc().defs();
            }
        }
    }), a.extend(a.Parent, {
        ungroup: function(t, e) {
            return 0 === e || this instanceof a.Defs || this.node == a.parser.draw || (t = t || (this instanceof a.Doc ? this : this.parent(a.Parent)), e = e || 1 / 0, this.each(function() {
                return this instanceof a.Defs ? this : this instanceof a.Parent ? this.ungroup(t, e - 1) : this.toParent(t);
            }), this.node.firstChild || this.remove()), this;
        },
        flatten: function(t, e) {
            return this.ungroup(t, e);
        }
    }), a.Container = a.invent({
        create: function(t) {
            this.constructor.call(this, t);
        },
        inherit: a.Parent
    }), a.ViewBox = a.invent({
        parent: a.Container,
        construct: {}
    }), [
        "click",
        "dblclick",
        "mousedown",
        "mouseup",
        "mouseover",
        "mouseout",
        "mousemove",
        "touchstart",
        "touchmove",
        "touchleave",
        "touchend",
        "touchcancel"
    ].forEach(function(t) {
        a.Element.prototype[t] = function(e) {
            return a.on(this.node, t, e), this;
        };
    }), a.listeners = [], a.handlerMap = [], a.listenerId = 0, a.on = function(t, e, i, s, r) {
        var o = i.bind(s || t.instance || t), n = (a.handlerMap.indexOf(t) + 1 || a.handlerMap.push(t)) - 1, l = e.split(".")[0], h = e.split(".")[1] || "*";
        a.listeners[n] = a.listeners[n] || {}, a.listeners[n][l] = a.listeners[n][l] || {}, a.listeners[n][l][h] = a.listeners[n][l][h] || {}, i._svgjsListenerId || (i._svgjsListenerId = ++a.listenerId), a.listeners[n][l][h][i._svgjsListenerId] = o, t.addEventListener(l, o, r || {
            passive: !0
        });
    }, a.off = function(t, e, i) {
        var s = a.handlerMap.indexOf(t), r = e && e.split(".")[0], o = e && e.split(".")[1], n = "";
        if (-1 != s) {
            if (i) {
                if ("function" == typeof i && (i = i._svgjsListenerId), !i) return;
                a.listeners[s][r] && a.listeners[s][r][o || "*"] && (t.removeEventListener(r, a.listeners[s][r][o || "*"][i], !1), delete a.listeners[s][r][o || "*"][i]);
            } else if (o && r) {
                if (a.listeners[s][r] && a.listeners[s][r][o]) {
                    for(var l in a.listeners[s][r][o])a.off(t, [
                        r,
                        o
                    ].join("."), l);
                    delete a.listeners[s][r][o];
                }
            } else if (o) for(var h in a.listeners[s])for(var n in a.listeners[s][h])o === n && a.off(t, [
                h,
                o
            ].join("."));
            else if (r) {
                if (a.listeners[s][r]) {
                    for(var n in a.listeners[s][r])a.off(t, [
                        r,
                        n
                    ].join("."));
                    delete a.listeners[s][r];
                }
            } else {
                for(var h in a.listeners[s])a.off(t, h);
                delete a.listeners[s], delete a.handlerMap[s];
            }
        }
    }, a.extend(a.Element, {
        on: function(t, e, i, s) {
            return a.on(this.node, t, e, i, s), this;
        },
        off: function(t, e) {
            return a.off(this.node, t, e), this;
        },
        fire: function(e, i) {
            return e instanceof t.Event ? this.node.dispatchEvent(e) : this.node.dispatchEvent(e = new a.CustomEvent(e, {
                detail: i,
                cancelable: !0
            })), this._event = e, this;
        },
        event: function() {
            return this._event;
        }
    }), a.Defs = a.invent({
        create: "defs",
        inherit: a.Container
    }), a.G = a.invent({
        create: "g",
        inherit: a.Container,
        extend: {
            x: function(t) {
                return null == t ? this.transform("x") : this.transform({
                    x: t - this.x()
                }, !0);
            }
        },
        construct: {
            group: function() {
                return this.put(new a.G);
            }
        }
    }), a.Doc = a.invent({
        create: function(t) {
            t && ("svg" == (t = "string" == typeof t ? e.getElementById(t) : t).nodeName ? this.constructor.call(this, t) : (this.constructor.call(this, a.create("svg")), t.appendChild(this.node), this.size("100%", "100%")), this.namespace().defs());
        },
        inherit: a.Container,
        extend: {
            namespace: function() {
                return this.attr({
                    xmlns: a.ns,
                    version: "1.1"
                }).attr("xmlns:xlink", a.xlink, a.xmlns).attr("xmlns:svgjs", a.svgjs, a.xmlns);
            },
            defs: function() {
                var t;
                return this._defs || ((t = this.node.getElementsByTagName("defs")[0]) ? this._defs = a.adopt(t) : this._defs = new a.Defs, this.node.appendChild(this._defs.node)), this._defs;
            },
            parent: function() {
                return this.node.parentNode && "#document" != this.node.parentNode.nodeName ? this.node.parentNode : null;
            },
            remove: function() {
                return this.parent() && this.parent().removeChild(this.node), this;
            },
            clear: function() {
                for(; this.node.hasChildNodes();)this.node.removeChild(this.node.lastChild);
                return delete this._defs, a.parser.draw && !a.parser.draw.parentNode && this.node.appendChild(a.parser.draw), this;
            },
            clone: function(t) {
                this.writeDataToDom();
                var e = this.node, i = x(e.cloneNode(!0));
                return t ? (t.node || t).appendChild(i.node) : e.parentNode.insertBefore(i.node, e.nextSibling), i;
            }
        }
    }), a.extend(a.Element, {}), a.Gradient = a.invent({
        create: function(t) {
            this.constructor.call(this, a.create(t + "Gradient")), this.type = t;
        },
        inherit: a.Container,
        extend: {
            at: function(t, e, i) {
                return this.put(new a.Stop).update(t, e, i);
            },
            update: function(t) {
                return this.clear(), "function" == typeof t && t.call(this, this), this;
            },
            fill: function() {
                return "url(#" + this.id() + ")";
            },
            toString: function() {
                return this.fill();
            },
            attr: function(t, e, i) {
                return "transform" == t && (t = "gradientTransform"), a.Container.prototype.attr.call(this, t, e, i);
            }
        },
        construct: {
            gradient: function(t, e) {
                return this.defs().gradient(t, e);
            }
        }
    }), a.extend(a.Gradient, a.FX, {
        from: function(t, e) {
            return "radial" == (this._target || this).type ? this.attr({
                fx: new a.Number(t),
                fy: new a.Number(e)
            }) : this.attr({
                x1: new a.Number(t),
                y1: new a.Number(e)
            });
        },
        to: function(t, e) {
            return "radial" == (this._target || this).type ? this.attr({
                cx: new a.Number(t),
                cy: new a.Number(e)
            }) : this.attr({
                x2: new a.Number(t),
                y2: new a.Number(e)
            });
        }
    }), a.extend(a.Defs, {
        gradient: function(t, e) {
            return this.put(new a.Gradient(t)).update(e);
        }
    }), a.Stop = a.invent({
        create: "stop",
        inherit: a.Element,
        extend: {
            update: function(t) {
                return ("number" == typeof t || t instanceof a.Number) && (t = {
                    offset: arguments[0],
                    color: arguments[1],
                    opacity: arguments[2]
                }), null != t.opacity && this.attr("stop-opacity", t.opacity), null != t.color && this.attr("stop-color", t.color), null != t.offset && this.attr("offset", new a.Number(t.offset)), this;
            }
        }
    }), a.Pattern = a.invent({
        create: "pattern",
        inherit: a.Container,
        extend: {
            fill: function() {
                return "url(#" + this.id() + ")";
            },
            update: function(t) {
                return this.clear(), "function" == typeof t && t.call(this, this), this;
            },
            toString: function() {
                return this.fill();
            },
            attr: function(t, e, i) {
                return "transform" == t && (t = "patternTransform"), a.Container.prototype.attr.call(this, t, e, i);
            }
        },
        construct: {
            pattern: function(t, e, i) {
                return this.defs().pattern(t, e, i);
            }
        }
    }), a.extend(a.Defs, {
        pattern: function(t, e, i) {
            return this.put(new a.Pattern).update(i).attr({
                x: 0,
                y: 0,
                width: t,
                height: e,
                patternUnits: "userSpaceOnUse"
            });
        }
    }), a.Shape = a.invent({
        create: function(t) {
            this.constructor.call(this, t);
        },
        inherit: a.Element
    }), a.Symbol = a.invent({
        create: "symbol",
        inherit: a.Container,
        construct: {
            symbol: function() {
                return this.put(new a.Symbol);
            }
        }
    }), a.Use = a.invent({
        create: "use",
        inherit: a.Shape,
        extend: {
            element: function(t, e) {
                return this.attr("href", (e || "") + "#" + t, a.xlink);
            }
        },
        construct: {
            use: function(t, e) {
                return this.put(new a.Use).element(t, e);
            }
        }
    }), a.Rect = a.invent({
        create: "rect",
        inherit: a.Shape,
        construct: {
            rect: function(t, e) {
                return this.put(new a.Rect).size(t, e);
            }
        }
    }), a.Circle = a.invent({
        create: "circle",
        inherit: a.Shape,
        construct: {
            circle: function(t) {
                return this.put(new a.Circle).rx(new a.Number(t).divide(2)).move(0, 0);
            }
        }
    }), a.extend(a.Circle, a.FX, {
        rx: function(t) {
            return this.attr("r", t);
        },
        ry: function(t) {
            return this.rx(t);
        }
    }), a.Ellipse = a.invent({
        create: "ellipse",
        inherit: a.Shape,
        construct: {
            ellipse: function(t, e) {
                return this.put(new a.Ellipse).size(t, e).move(0, 0);
            }
        }
    }), a.extend(a.Ellipse, a.Rect, a.FX, {
        rx: function(t) {
            return this.attr("rx", t);
        },
        ry: function(t) {
            return this.attr("ry", t);
        }
    }), a.extend(a.Circle, a.Ellipse, {
        x: function(t) {
            return null == t ? this.cx() - this.rx() : this.cx(t + this.rx());
        },
        y: function(t) {
            return null == t ? this.cy() - this.ry() : this.cy(t + this.ry());
        },
        cx: function(t) {
            return null == t ? this.attr("cx") : this.attr("cx", t);
        },
        cy: function(t) {
            return null == t ? this.attr("cy") : this.attr("cy", t);
        },
        width: function(t) {
            return null == t ? 2 * this.rx() : this.rx(new a.Number(t).divide(2));
        },
        height: function(t) {
            return null == t ? 2 * this.ry() : this.ry(new a.Number(t).divide(2));
        },
        size: function(t, e) {
            var i = u(this, t, e);
            return this.rx(new a.Number(i.width).divide(2)).ry(new a.Number(i.height).divide(2));
        }
    }), a.Line = a.invent({
        create: "line",
        inherit: a.Shape,
        extend: {
            array: function() {
                return new a.PointArray([
                    [
                        this.attr("x1"),
                        this.attr("y1")
                    ],
                    [
                        this.attr("x2"),
                        this.attr("y2")
                    ]
                ]);
            },
            plot: function(t, e, i, s) {
                return null == t ? this.array() : (t = void 0 !== e ? {
                    x1: t,
                    y1: e,
                    x2: i,
                    y2: s
                } : new a.PointArray(t).toLine(), this.attr(t));
            },
            move: function(t, e) {
                return this.attr(this.array().move(t, e).toLine());
            },
            size: function(t, e) {
                var i = u(this, t, e);
                return this.attr(this.array().size(i.width, i.height).toLine());
            }
        },
        construct: {
            line: function(t, e, i, s) {
                return a.Line.prototype.plot.apply(this.put(new a.Line), null != t ? [
                    t,
                    e,
                    i,
                    s
                ] : [
                    0,
                    0,
                    0,
                    0
                ]);
            }
        }
    }), a.Polyline = a.invent({
        create: "polyline",
        inherit: a.Shape,
        construct: {
            polyline: function(t) {
                return this.put(new a.Polyline).plot(t || new a.PointArray);
            }
        }
    }), a.Polygon = a.invent({
        create: "polygon",
        inherit: a.Shape,
        construct: {
            polygon: function(t) {
                return this.put(new a.Polygon).plot(t || new a.PointArray);
            }
        }
    }), a.extend(a.Polyline, a.Polygon, {
        array: function() {
            return this._array || (this._array = new a.PointArray(this.attr("points")));
        },
        plot: function(t) {
            return null == t ? this.array() : this.clear().attr("points", "string" == typeof t ? t : this._array = new a.PointArray(t));
        },
        clear: function() {
            return delete this._array, this;
        },
        move: function(t, e) {
            return this.attr("points", this.array().move(t, e));
        },
        size: function(t, e) {
            var i = u(this, t, e);
            return this.attr("points", this.array().size(i.width, i.height));
        }
    }), a.extend(a.Line, a.Polyline, a.Polygon, {
        morphArray: a.PointArray,
        x: function(t) {
            return null == t ? this.bbox().x : this.move(t, this.bbox().y);
        },
        y: function(t) {
            return null == t ? this.bbox().y : this.move(this.bbox().x, t);
        },
        width: function(t) {
            var e = this.bbox();
            return null == t ? e.width : this.size(t, e.height);
        },
        height: function(t) {
            var e = this.bbox();
            return null == t ? e.height : this.size(e.width, t);
        }
    }), a.Path = a.invent({
        create: "path",
        inherit: a.Shape,
        extend: {
            morphArray: a.PathArray,
            array: function() {
                return this._array || (this._array = new a.PathArray(this.attr("d")));
            },
            plot: function(t) {
                return null == t ? this.array() : this.clear().attr("d", "string" == typeof t ? t : this._array = new a.PathArray(t));
            },
            clear: function() {
                return delete this._array, this;
            }
        },
        construct: {
            path: function(t) {
                return this.put(new a.Path).plot(t || new a.PathArray);
            }
        }
    }), a.Image = a.invent({
        create: "image",
        inherit: a.Shape,
        extend: {
            load: function(e) {
                if (!e) return this;
                var i = this, s = new t.Image;
                return a.on(s, "load", function() {
                    a.off(s);
                    var t = i.parent(a.Pattern);
                    null !== t && (0 == i.width() && 0 == i.height() && i.size(s.width, s.height), t && 0 == t.width() && 0 == t.height() && t.size(i.width(), i.height()), "function" == typeof i._loaded && i._loaded.call(i, {
                        width: s.width,
                        height: s.height,
                        ratio: s.width / s.height,
                        url: e
                    }));
                }), a.on(s, "error", function(t) {
                    a.off(s), "function" == typeof i._error && i._error.call(i, t);
                }), this.attr("href", s.src = this.src = e, a.xlink);
            },
            loaded: function(t) {
                return this._loaded = t, this;
            },
            error: function(t) {
                return this._error = t, this;
            }
        },
        construct: {
            image: function(t, e, i) {
                return this.put(new a.Image).load(t).size(e || 0, i || e || 0);
            }
        }
    }), a.Text = a.invent({
        create: function() {
            this.constructor.call(this, a.create("text")), this.dom.leading = new a.Number(1.3), this._rebuild = !0, this._build = !1, this.attr("font-family", a.defaults.attrs["font-family"]);
        },
        inherit: a.Shape,
        extend: {
            x: function(t) {
                return null == t ? this.attr("x") : this.attr("x", t);
            },
            text: function(t) {
                if (void 0 === t) {
                    t = "";
                    for(var e = this.node.childNodes, i = 0, s = e.length; i < s; ++i)0 != i && 3 != e[i].nodeType && 1 == a.adopt(e[i]).dom.newLined && (t += "\n"), t += e[i].textContent;
                    return t;
                }
                if (this.clear().build(!0), "function" == typeof t) t.call(this, this);
                else {
                    i = 0;
                    for(var r = (t = t.split("\n")).length; i < r; i++)this.tspan(t[i]).newLine();
                }
                return this.build(!1).rebuild();
            },
            size: function(t) {
                return this.attr("font-size", t).rebuild();
            },
            leading: function(t) {
                return null == t ? this.dom.leading : (this.dom.leading = new a.Number(t), this.rebuild());
            },
            lines: function() {
                var t = (this.textPath && this.textPath() || this).node, e = a.utils.map(a.utils.filterSVGElements(t.childNodes), function(t) {
                    return a.adopt(t);
                });
                return new a.Set(e);
            },
            rebuild: function(t) {
                if ("boolean" == typeof t && (this._rebuild = t), this._rebuild) {
                    var e = this, i = 0, s = this.dom.leading * new a.Number(this.attr("font-size"));
                    this.lines().each(function() {
                        this.dom.newLined && (e.textPath() || this.attr("x", e.attr("x")), "\n" == this.text() ? i += s : (this.attr("dy", s + i), i = 0));
                    }), this.fire("rebuild");
                }
                return this;
            },
            build: function(t) {
                return this._build = !!t, this;
            },
            setData: function(t) {
                return this.dom = t, this.dom.leading = new a.Number(t.leading || 1.3), this;
            }
        },
        construct: {
            text: function(t) {
                return this.put(new a.Text).text(t);
            },
            plain: function(t) {
                return this.put(new a.Text).plain(t);
            }
        }
    }), a.Tspan = a.invent({
        create: "tspan",
        inherit: a.Shape,
        extend: {
            text: function(t) {
                return null == t ? this.node.textContent + (this.dom.newLined ? "\n" : "") : ("function" == typeof t ? t.call(this, this) : this.plain(t), this);
            },
            dx: function(t) {
                return this.attr("dx", t);
            },
            dy: function(t) {
                return this.attr("dy", t);
            },
            newLine: function() {
                var t = this.parent(a.Text);
                return this.dom.newLined = !0, this.dy(t.dom.leading * t.attr("font-size")).attr("x", t.x());
            }
        }
    }), a.extend(a.Text, a.Tspan, {
        plain: function(t) {
            return !1 === this._build && this.clear(), this.node.appendChild(e.createTextNode(t)), this;
        },
        tspan: function(t) {
            var e = (this.textPath && this.textPath() || this).node, i = new a.Tspan;
            return !1 === this._build && this.clear(), e.appendChild(i.node), i.text(t);
        },
        clear: function() {
            for(var t = (this.textPath && this.textPath() || this).node; t.hasChildNodes();)t.removeChild(t.lastChild);
            return this;
        },
        length: function() {
            return this.node.getComputedTextLength();
        }
    }), a.TextPath = a.invent({
        create: "textPath",
        inherit: a.Parent,
        parent: a.Text,
        construct: {
            morphArray: a.PathArray,
            array: function() {
                var t = this.track();
                return t ? t.array() : null;
            },
            plot: function(t) {
                var e = this.track(), i = null;
                return e && (i = e.plot(t)), null == t ? i : this;
            },
            track: function() {
                var t = this.textPath();
                if (t) return t.reference("href");
            },
            textPath: function() {
                if (this.node.firstChild && "textPath" == this.node.firstChild.nodeName) return a.adopt(this.node.firstChild);
            }
        }
    }), a.Nested = a.invent({
        create: function() {
            this.constructor.call(this, a.create("svg")), this.style("overflow", "visible");
        },
        inherit: a.Container,
        construct: {
            nested: function() {
                return this.put(new a.Nested);
            }
        }
    });
    var l = {
        stroke: [
            "color",
            "width",
            "opacity",
            "linecap",
            "linejoin",
            "miterlimit",
            "dasharray",
            "dashoffset"
        ],
        fill: [
            "color",
            "opacity",
            "rule"
        ],
        prefix: function(t, e) {
            return "color" == e ? t : t + "-" + e;
        }
    };
    function h(t, e, i, s) {
        return i + s.replace(a.regex.dots, " .");
    }
    function c(t) {
        return t.toLowerCase().replace(/-(.)/g, function(t, e) {
            return e.toUpperCase();
        });
    }
    function d(t) {
        return t.charAt(0).toUpperCase() + t.slice(1);
    }
    function g(t) {
        var e = t.toString(16);
        return 1 == e.length ? "0" + e : e;
    }
    function u(t, e, i) {
        if (null == e || null == i) {
            var a = t.bbox();
            null == e ? e = a.width / a.height * i : null == i && (i = a.height / a.width * e);
        }
        return {
            width: e,
            height: i
        };
    }
    function p(t, e, i) {
        return {
            x: e * t.a + i * t.c + 0,
            y: e * t.b + i * t.d + 0
        };
    }
    function f(t) {
        return {
            a: t[0],
            b: t[1],
            c: t[2],
            d: t[3],
            e: t[4],
            f: t[5]
        };
    }
    function x(e) {
        for(var i = e.childNodes.length - 1; i >= 0; i--)e.childNodes[i] instanceof t.SVGElement && x(e.childNodes[i]);
        return a.adopt(e).id(a.eid(e.nodeName));
    }
    function b(t) {
        return null == t.x && (t.x = 0, t.y = 0, t.width = 0, t.height = 0), t.w = t.width, t.h = t.height, t.x2 = t.x + t.width, t.y2 = t.y + t.height, t.cx = t.x + t.width / 2, t.cy = t.y + t.height / 2, t;
    }
    function v(t) {
        return Math.abs(t) > 1e-37 ? t : 0;
    }
    [
        "fill",
        "stroke"
    ].forEach(function(t) {
        var e = {};
        e[t] = function(e) {
            if (void 0 === e) return this;
            if ("string" == typeof e || a.Color.isRgb(e) || e && "function" == typeof e.fill) this.attr(t, e);
            else for(var i = l[t].length - 1; i >= 0; i--)null != e[l[t][i]] && this.attr(l.prefix(t, l[t][i]), e[l[t][i]]);
            return this;
        }, a.extend(a.Element, a.FX, e);
    }), a.extend(a.Element, a.FX, {
        translate: function(t, e) {
            return this.transform({
                x: t,
                y: e
            });
        },
        matrix: function(t) {
            return this.attr("transform", new a.Matrix(6 == arguments.length ? [].slice.call(arguments) : t));
        },
        opacity: function(t) {
            return this.attr("opacity", t);
        },
        dx: function(t) {
            return this.x(new a.Number(t).plus(this instanceof a.FX ? 0 : this.x()), !0);
        },
        dy: function(t) {
            return this.y(new a.Number(t).plus(this instanceof a.FX ? 0 : this.y()), !0);
        }
    }), a.extend(a.Path, {
        length: function() {
            return this.node.getTotalLength();
        },
        pointAt: function(t) {
            return this.node.getPointAtLength(t);
        }
    }), a.Set = a.invent({
        create: function(t) {
            Array.isArray(t) ? this.members = t : this.clear();
        },
        extend: {
            add: function() {
                for(var t = [].slice.call(arguments), e = 0, i = t.length; e < i; e++)this.members.push(t[e]);
                return this;
            },
            remove: function(t) {
                var e = this.index(t);
                return e > -1 && this.members.splice(e, 1), this;
            },
            each: function(t) {
                for(var e = 0, i = this.members.length; e < i; e++)t.apply(this.members[e], [
                    e,
                    this.members
                ]);
                return this;
            },
            clear: function() {
                return this.members = [], this;
            },
            length: function() {
                return this.members.length;
            },
            has: function(t) {
                return this.index(t) >= 0;
            },
            index: function(t) {
                return this.members.indexOf(t);
            },
            get: function(t) {
                return this.members[t];
            },
            first: function() {
                return this.get(0);
            },
            last: function() {
                return this.get(this.members.length - 1);
            },
            valueOf: function() {
                return this.members;
            }
        },
        construct: {
            set: function(t) {
                return new a.Set(t);
            }
        }
    }), a.FX.Set = a.invent({
        create: function(t) {
            this.set = t;
        }
    }), a.Set.inherit = function() {
        var t = [];
        for(var e in a.Shape.prototype)"function" == typeof a.Shape.prototype[e] && "function" != typeof a.Set.prototype[e] && t.push(e);
        for(var e in t.forEach(function(t) {
            a.Set.prototype[t] = function() {
                for(var e = 0, i = this.members.length; e < i; e++)this.members[e] && "function" == typeof this.members[e][t] && this.members[e][t].apply(this.members[e], arguments);
                return "animate" == t ? this.fx || (this.fx = new a.FX.Set(this)) : this;
            };
        }), t = [], a.FX.prototype)"function" == typeof a.FX.prototype[e] && "function" != typeof a.FX.Set.prototype[e] && t.push(e);
        t.forEach(function(t) {
            a.FX.Set.prototype[t] = function() {
                for(var e = 0, i = this.set.members.length; e < i; e++)this.set.members[e].fx[t].apply(this.set.members[e].fx, arguments);
                return this;
            };
        });
    }, a.extend(a.Element, {}), a.extend(a.Element, {
        remember: function(t, e) {
            if ("object" === $b705b473d3ec9641$var$i(arguments[0])) for(var a in t)this.remember(a, t[a]);
            else {
                if (1 == arguments.length) return this.memory()[t];
                this.memory()[t] = e;
            }
            return this;
        },
        forget: function() {
            if (0 == arguments.length) this._memory = {};
            else for(var t = arguments.length - 1; t >= 0; t--)delete this.memory()[arguments[t]];
            return this;
        },
        memory: function() {
            return this._memory || (this._memory = {});
        }
    }), a.get = function(t) {
        var i = e.getElementById(function(t) {
            var e = (t || "").toString().match(a.regex.reference);
            if (e) return e[1];
        }(t) || t);
        return a.adopt(i);
    }, a.select = function(t, i) {
        return new a.Set(a.utils.map((i || e).querySelectorAll(t), function(t) {
            return a.adopt(t);
        }));
    }, a.extend(a.Parent, {
        select: function(t) {
            return a.select(t, this.node);
        }
    });
    var m = "abcdef".split("");
    if ("function" != typeof t.CustomEvent) {
        var y = function(t, i) {
            i = i || {
                bubbles: !1,
                cancelable: !1,
                detail: void 0
            };
            var a = e.createEvent("CustomEvent");
            return a.initCustomEvent(t, i.bubbles, i.cancelable, i.detail), a;
        };
        y.prototype = t.Event.prototype, a.CustomEvent = y;
    } else a.CustomEvent = t.CustomEvent;
    return a;
}, "function" == typeof define && define.amd ? define(function() {
    return $b705b473d3ec9641$var$Mt($b705b473d3ec9641$var$Tt, $b705b473d3ec9641$var$Tt.document);
}) : "object" === $b705b473d3ec9641$var$i(module.exports) && true ? module.exports = $b705b473d3ec9641$var$Tt.document ? $b705b473d3ec9641$var$Mt($b705b473d3ec9641$var$Tt, $b705b473d3ec9641$var$Tt.document) : function(t) {
    return $b705b473d3ec9641$var$Mt(t, t.document);
} : $b705b473d3ec9641$var$Tt.SVG = $b705b473d3ec9641$var$Mt($b705b473d3ec9641$var$Tt, $b705b473d3ec9641$var$Tt.document), /*! svg.filter.js - v2.0.2 - 2016-02-24
* https://github.com/wout/svg.filter.js
* Copyright (c) 2016 Wout Fierens; Licensed MIT */ (function() {
    SVG.Filter = SVG.invent({
        create: "filter",
        inherit: SVG.Parent,
        extend: {
            source: "SourceGraphic",
            sourceAlpha: "SourceAlpha",
            background: "BackgroundImage",
            backgroundAlpha: "BackgroundAlpha",
            fill: "FillPaint",
            stroke: "StrokePaint",
            autoSetIn: !0,
            put: function(t, e) {
                return this.add(t, e), !t.attr("in") && this.autoSetIn && t.attr("in", this.source), t.attr("result") || t.attr("result", t), t;
            },
            blend: function(t, e, i) {
                return this.put(new SVG.BlendEffect(t, e, i));
            },
            colorMatrix: function(t, e) {
                return this.put(new SVG.ColorMatrixEffect(t, e));
            },
            convolveMatrix: function(t) {
                return this.put(new SVG.ConvolveMatrixEffect(t));
            },
            componentTransfer: function(t) {
                return this.put(new SVG.ComponentTransferEffect(t));
            },
            composite: function(t, e, i) {
                return this.put(new SVG.CompositeEffect(t, e, i));
            },
            flood: function(t, e) {
                return this.put(new SVG.FloodEffect(t, e));
            },
            offset: function(t, e) {
                return this.put(new SVG.OffsetEffect(t, e));
            },
            image: function(t) {
                return this.put(new SVG.ImageEffect(t));
            },
            merge: function() {
                var t = [
                    void 0
                ];
                for(var e in arguments)t.push(arguments[e]);
                return this.put(new (SVG.MergeEffect.bind.apply(SVG.MergeEffect, t)));
            },
            gaussianBlur: function(t, e) {
                return this.put(new SVG.GaussianBlurEffect(t, e));
            },
            morphology: function(t, e) {
                return this.put(new SVG.MorphologyEffect(t, e));
            },
            diffuseLighting: function(t, e, i) {
                return this.put(new SVG.DiffuseLightingEffect(t, e, i));
            },
            displacementMap: function(t, e, i, a, s) {
                return this.put(new SVG.DisplacementMapEffect(t, e, i, a, s));
            },
            specularLighting: function(t, e, i, a) {
                return this.put(new SVG.SpecularLightingEffect(t, e, i, a));
            },
            tile: function() {
                return this.put(new SVG.TileEffect);
            },
            turbulence: function(t, e, i, a, s) {
                return this.put(new SVG.TurbulenceEffect(t, e, i, a, s));
            },
            toString: function() {
                return "url(#" + this.attr("id") + ")";
            }
        }
    }), SVG.extend(SVG.Defs, {
        filter: function(t) {
            var e = this.put(new SVG.Filter);
            return "function" == typeof t && t.call(e, e), e;
        }
    }), SVG.extend(SVG.Container, {
        filter: function(t) {
            return this.defs().filter(t);
        }
    }), SVG.extend(SVG.Element, SVG.G, SVG.Nested, {
        filter: function(t) {
            return this.filterer = t instanceof SVG.Element ? t : this.doc().filter(t), this.doc() && this.filterer.doc() !== this.doc() && this.doc().defs().add(this.filterer), this.attr("filter", this.filterer), this.filterer;
        },
        unfilter: function(t) {
            return this.filterer && !0 === t && this.filterer.remove(), delete this.filterer, this.attr("filter", null);
        }
    }), SVG.Effect = SVG.invent({
        create: function() {
            this.constructor.call(this);
        },
        inherit: SVG.Element,
        extend: {
            in: function(t) {
                return null == t ? this.parent() && this.parent().select('[result="' + this.attr("in") + '"]').get(0) || this.attr("in") : this.attr("in", t);
            },
            result: function(t) {
                return null == t ? this.attr("result") : this.attr("result", t);
            },
            toString: function() {
                return this.result();
            }
        }
    }), SVG.ParentEffect = SVG.invent({
        create: function() {
            this.constructor.call(this);
        },
        inherit: SVG.Parent,
        extend: {
            in: function(t) {
                return null == t ? this.parent() && this.parent().select('[result="' + this.attr("in") + '"]').get(0) || this.attr("in") : this.attr("in", t);
            },
            result: function(t) {
                return null == t ? this.attr("result") : this.attr("result", t);
            },
            toString: function() {
                return this.result();
            }
        }
    });
    var t = {
        blend: function(t, e) {
            return this.parent() && this.parent().blend(this, t, e);
        },
        colorMatrix: function(t, e) {
            return this.parent() && this.parent().colorMatrix(t, e).in(this);
        },
        convolveMatrix: function(t) {
            return this.parent() && this.parent().convolveMatrix(t).in(this);
        },
        componentTransfer: function(t) {
            return this.parent() && this.parent().componentTransfer(t).in(this);
        },
        composite: function(t, e) {
            return this.parent() && this.parent().composite(this, t, e);
        },
        flood: function(t, e) {
            return this.parent() && this.parent().flood(t, e);
        },
        offset: function(t, e) {
            return this.parent() && this.parent().offset(t, e).in(this);
        },
        image: function(t) {
            return this.parent() && this.parent().image(t);
        },
        merge: function() {
            return this.parent() && this.parent().merge.apply(this.parent(), [
                this
            ].concat(arguments));
        },
        gaussianBlur: function(t, e) {
            return this.parent() && this.parent().gaussianBlur(t, e).in(this);
        },
        morphology: function(t, e) {
            return this.parent() && this.parent().morphology(t, e).in(this);
        },
        diffuseLighting: function(t, e, i) {
            return this.parent() && this.parent().diffuseLighting(t, e, i).in(this);
        },
        displacementMap: function(t, e, i, a) {
            return this.parent() && this.parent().displacementMap(this, t, e, i, a);
        },
        specularLighting: function(t, e, i, a) {
            return this.parent() && this.parent().specularLighting(t, e, i, a).in(this);
        },
        tile: function() {
            return this.parent() && this.parent().tile().in(this);
        },
        turbulence: function(t, e, i, a, s) {
            return this.parent() && this.parent().turbulence(t, e, i, a, s).in(this);
        }
    };
    SVG.extend(SVG.Effect, t), SVG.extend(SVG.ParentEffect, t), SVG.ChildEffect = SVG.invent({
        create: function() {
            this.constructor.call(this);
        },
        inherit: SVG.Element,
        extend: {
            in: function(t) {
                this.attr("in", t);
            }
        }
    });
    var e = {
        blend: function(t, e, i) {
            this.attr({
                in: t,
                in2: e,
                mode: i || "normal"
            });
        },
        colorMatrix: function(t, e) {
            "matrix" == t && (e = s(e)), this.attr({
                type: t,
                values: void 0 === e ? null : e
            });
        },
        convolveMatrix: function(t) {
            t = s(t), this.attr({
                order: Math.sqrt(t.split(" ").length),
                kernelMatrix: t
            });
        },
        composite: function(t, e, i) {
            this.attr({
                in: t,
                in2: e,
                operator: i
            });
        },
        flood: function(t, e) {
            this.attr("flood-color", t), null != e && this.attr("flood-opacity", e);
        },
        offset: function(t, e) {
            this.attr({
                dx: t,
                dy: e
            });
        },
        image: function(t) {
            this.attr("href", t, SVG.xlink);
        },
        displacementMap: function(t, e, i, a, s) {
            this.attr({
                in: t,
                in2: e,
                scale: i,
                xChannelSelector: a,
                yChannelSelector: s
            });
        },
        gaussianBlur: function(t, e) {
            null != t || null != e ? this.attr("stdDeviation", r(Array.prototype.slice.call(arguments))) : this.attr("stdDeviation", "0 0");
        },
        morphology: function(t, e) {
            this.attr({
                operator: t,
                radius: e
            });
        },
        tile: function() {},
        turbulence: function(t, e, i, a, s) {
            this.attr({
                numOctaves: e,
                seed: i,
                stitchTiles: a,
                baseFrequency: t,
                type: s
            });
        }
    }, i = {
        merge: function() {
            var t;
            if (arguments[0] instanceof SVG.Set) {
                var e = this;
                arguments[0].each(function(t) {
                    this instanceof SVG.MergeNode ? e.put(this) : (this instanceof SVG.Effect || this instanceof SVG.ParentEffect) && e.put(new SVG.MergeNode(this));
                });
            } else {
                t = Array.isArray(arguments[0]) ? arguments[0] : arguments;
                for(var i = 0; i < t.length; i++)t[i] instanceof SVG.MergeNode ? this.put(t[i]) : this.put(new SVG.MergeNode(t[i]));
            }
        },
        componentTransfer: function(t) {
            if (this.rgb = new SVG.Set, [
                "r",
                "g",
                "b",
                "a"
            ].forEach((function(t) {
                this[t] = new SVG["Func" + t.toUpperCase()]("identity"), this.rgb.add(this[t]), this.node.appendChild(this[t].node);
            }).bind(this)), t) for(var e in t.rgb && ([
                "r",
                "g",
                "b"
            ].forEach((function(e) {
                this[e].attr(t.rgb);
            }).bind(this)), delete t.rgb), t)this[e].attr(t[e]);
        },
        diffuseLighting: function(t, e, i) {
            this.attr({
                surfaceScale: t,
                diffuseConstant: e,
                kernelUnitLength: i
            });
        },
        specularLighting: function(t, e, i, a) {
            this.attr({
                surfaceScale: t,
                diffuseConstant: e,
                specularExponent: i,
                kernelUnitLength: a
            });
        }
    }, a = {
        distantLight: function(t, e) {
            this.attr({
                azimuth: t,
                elevation: e
            });
        },
        pointLight: function(t, e, i) {
            this.attr({
                x: t,
                y: e,
                z: i
            });
        },
        spotLight: function(t, e, i, a, s, r) {
            this.attr({
                x: t,
                y: e,
                z: i,
                pointsAtX: a,
                pointsAtY: s,
                pointsAtZ: r
            });
        },
        mergeNode: function(t) {
            this.attr("in", t);
        }
    };
    function s(t) {
        return Array.isArray(t) && (t = new SVG.Array(t)), t.toString().replace(/^\s+/, "").replace(/\s+$/, "").replace(/\s+/g, " ");
    }
    function r(t) {
        if (!Array.isArray(t)) return t;
        for(var e = 0, i = t.length, a = []; e < i; e++)a.push(t[e]);
        return a.join(" ");
    }
    function o() {
        var t = function() {};
        for(var e in "function" == typeof arguments[arguments.length - 1] && (t = arguments[arguments.length - 1], Array.prototype.splice.call(arguments, arguments.length - 1, 1)), arguments)for(var i in arguments[e])t(arguments[e][i], i, arguments[e]);
    }
    [
        "r",
        "g",
        "b",
        "a"
    ].forEach(function(t) {
        a["Func" + t.toUpperCase()] = function(t) {
            switch(this.attr("type", t), t){
                case "table":
                    this.attr("tableValues", arguments[1]);
                    break;
                case "linear":
                    this.attr("slope", arguments[1]), this.attr("intercept", arguments[2]);
                    break;
                case "gamma":
                    this.attr("amplitude", arguments[1]), this.attr("exponent", arguments[2]), this.attr("offset", arguments[2]);
            }
        };
    }), o(e, function(t, e) {
        var i = e.charAt(0).toUpperCase() + e.slice(1);
        SVG[i + "Effect"] = SVG.invent({
            create: function() {
                this.constructor.call(this, SVG.create("fe" + i)), t.apply(this, arguments), this.result(this.attr("id") + "Out");
            },
            inherit: SVG.Effect,
            extend: {}
        });
    }), o(i, function(t, e) {
        var i = e.charAt(0).toUpperCase() + e.slice(1);
        SVG[i + "Effect"] = SVG.invent({
            create: function() {
                this.constructor.call(this, SVG.create("fe" + i)), t.apply(this, arguments), this.result(this.attr("id") + "Out");
            },
            inherit: SVG.ParentEffect,
            extend: {}
        });
    }), o(a, function(t, e) {
        var i = e.charAt(0).toUpperCase() + e.slice(1);
        SVG[i] = SVG.invent({
            create: function() {
                this.constructor.call(this, SVG.create("fe" + i)), t.apply(this, arguments);
            },
            inherit: SVG.ChildEffect,
            extend: {}
        });
    }), SVG.extend(SVG.MergeEffect, {
        in: function(t) {
            return t instanceof SVG.MergeNode ? this.add(t, 0) : this.add(new SVG.MergeNode(t), 0), this;
        }
    }), SVG.extend(SVG.CompositeEffect, SVG.BlendEffect, SVG.DisplacementMapEffect, {
        in2: function(t) {
            return null == t ? this.parent() && this.parent().select('[result="' + this.attr("in2") + '"]').get(0) || this.attr("in2") : this.attr("in2", t);
        }
    }), SVG.filter = {
        sepiatone: [
            .343,
            .669,
            .119,
            0,
            0,
            .249,
            .626,
            .13,
            0,
            0,
            .172,
            .334,
            .111,
            0,
            0,
            0,
            0,
            0,
            1,
            0
        ]
    };
}).call(void 0), function() {
    function t(t, s, r, o, n, l, h) {
        for(var c = t.slice(s, r || h), d = o.slice(n, l || h), g = 0, u = {
            pos: [
                0,
                0
            ],
            start: [
                0,
                0
            ]
        }, p = {
            pos: [
                0,
                0
            ],
            start: [
                0,
                0
            ]
        };;){
            if (c[g] = e.call(u, c[g]), d[g] = e.call(p, d[g]), c[g][0] != d[g][0] || "M" == c[g][0] || "A" == c[g][0] && (c[g][4] != d[g][4] || c[g][5] != d[g][5]) ? (Array.prototype.splice.apply(c, [
                g,
                1
            ].concat(a.call(u, c[g]))), Array.prototype.splice.apply(d, [
                g,
                1
            ].concat(a.call(p, d[g])))) : (c[g] = i.call(u, c[g]), d[g] = i.call(p, d[g])), ++g == c.length && g == d.length) break;
            g == c.length && c.push([
                "C",
                u.pos[0],
                u.pos[1],
                u.pos[0],
                u.pos[1],
                u.pos[0],
                u.pos[1]
            ]), g == d.length && d.push([
                "C",
                p.pos[0],
                p.pos[1],
                p.pos[0],
                p.pos[1],
                p.pos[0],
                p.pos[1]
            ]);
        }
        return {
            start: c,
            dest: d
        };
    }
    function e(t) {
        switch(t[0]){
            case "z":
            case "Z":
                t[0] = "L", t[1] = this.start[0], t[2] = this.start[1];
                break;
            case "H":
                t[0] = "L", t[2] = this.pos[1];
                break;
            case "V":
                t[0] = "L", t[2] = t[1], t[1] = this.pos[0];
                break;
            case "T":
                t[0] = "Q", t[3] = t[1], t[4] = t[2], t[1] = this.reflection[1], t[2] = this.reflection[0];
                break;
            case "S":
                t[0] = "C", t[6] = t[4], t[5] = t[3], t[4] = t[2], t[3] = t[1], t[2] = this.reflection[1], t[1] = this.reflection[0];
        }
        return t;
    }
    function i(t) {
        var e = t.length;
        return this.pos = [
            t[e - 2],
            t[e - 1]
        ], -1 != "SCQT".indexOf(t[0]) && (this.reflection = [
            2 * this.pos[0] - t[e - 4],
            2 * this.pos[1] - t[e - 3]
        ]), t;
    }
    function a(t) {
        var e = [
            t
        ];
        switch(t[0]){
            case "M":
                return this.pos = this.start = [
                    t[1],
                    t[2]
                ], e;
            case "L":
                t[5] = t[3] = t[1], t[6] = t[4] = t[2], t[1] = this.pos[0], t[2] = this.pos[1];
                break;
            case "Q":
                t[6] = t[4], t[5] = t[3], t[4] = 1 * t[4] / 3 + 2 * t[2] / 3, t[3] = 1 * t[3] / 3 + 2 * t[1] / 3, t[2] = 1 * this.pos[1] / 3 + 2 * t[2] / 3, t[1] = 1 * this.pos[0] / 3 + 2 * t[1] / 3;
                break;
            case "A":
                t = (e = function(t, e) {
                    var i, a, s, r, o, n, l, h, c, d, g, u, p, f, x, b, v, m, y, w, k, A, S, C, L, P, T = Math.abs(e[1]), M = Math.abs(e[2]), I = e[3] % 360, z = e[4], X = e[5], E = e[6], Y = e[7], F = new SVG.Point(t), R = new SVG.Point(E, Y), H = [];
                    if (0 === T || 0 === M || F.x === R.x && F.y === R.y) return [
                        [
                            "C",
                            F.x,
                            F.y,
                            R.x,
                            R.y,
                            R.x,
                            R.y
                        ]
                    ];
                    i = new SVG.Point((F.x - R.x) / 2, (F.y - R.y) / 2).transform((new SVG.Matrix).rotate(I)), (a = i.x * i.x / (T * T) + i.y * i.y / (M * M)) > 1 && (T *= a = Math.sqrt(a), M *= a);
                    s = (new SVG.Matrix).rotate(I).scale(1 / T, 1 / M).rotate(-I), F = F.transform(s), R = R.transform(s), r = [
                        R.x - F.x,
                        R.y - F.y
                    ], n = r[0] * r[0] + r[1] * r[1], o = Math.sqrt(n), r[0] /= o, r[1] /= o, l = n < 4 ? Math.sqrt(1 - n / 4) : 0, z === X && (l *= -1);
                    h = new SVG.Point((R.x + F.x) / 2 + l * -r[1], (R.y + F.y) / 2 + l * r[0]), c = new SVG.Point(F.x - h.x, F.y - h.y), d = new SVG.Point(R.x - h.x, R.y - h.y), g = Math.acos(c.x / Math.sqrt(c.x * c.x + c.y * c.y)), c.y < 0 && (g *= -1);
                    u = Math.acos(d.x / Math.sqrt(d.x * d.x + d.y * d.y)), d.y < 0 && (u *= -1);
                    X && g > u && (u += 2 * Math.PI);
                    !X && g < u && (u -= 2 * Math.PI);
                    for(f = Math.ceil(2 * Math.abs(g - u) / Math.PI), b = [], v = g, p = (u - g) / f, x = 4 * Math.tan(p / 4) / 3, k = 0; k <= f; k++)y = Math.cos(v), m = Math.sin(v), w = new SVG.Point(h.x + y, h.y + m), b[k] = [
                        new SVG.Point(w.x + x * m, w.y - x * y),
                        w,
                        new SVG.Point(w.x - x * m, w.y + x * y)
                    ], v += p;
                    for(b[0][0] = b[0][1].clone(), b[b.length - 1][2] = b[b.length - 1][1].clone(), s = (new SVG.Matrix).rotate(I).scale(T, M).rotate(-I), k = 0, A = b.length; k < A; k++)b[k][0] = b[k][0].transform(s), b[k][1] = b[k][1].transform(s), b[k][2] = b[k][2].transform(s);
                    for(k = 1, A = b.length; k < A; k++)S = (w = b[k - 1][2]).x, C = w.y, L = (w = b[k][0]).x, P = w.y, E = (w = b[k][1]).x, Y = w.y, H.push([
                        "C",
                        S,
                        C,
                        L,
                        P,
                        E,
                        Y
                    ]);
                    return H;
                }(this.pos, t))[0];
        }
        return t[0] = "C", this.pos = [
            t[5],
            t[6]
        ], this.reflection = [
            2 * t[5] - t[3],
            2 * t[6] - t[4]
        ], e;
    }
    function s(t, e) {
        if (!1 === e) return !1;
        for(var i = e, a = t.length; i < a; ++i)if ("M" == t[i][0]) return i;
        return !1;
    }
    SVG.extend(SVG.PathArray, {
        morph: function(e) {
            for(var i = this.value, a = this.parse(e), r = 0, o = 0, n = !1, l = !1; !1 !== r || !1 !== o;){
                var h;
                n = s(i, !1 !== r && r + 1), l = s(a, !1 !== o && o + 1), !1 === r && (r = 0 == (h = new SVG.PathArray(c.start).bbox()).height || 0 == h.width ? i.push(i[0]) - 1 : i.push([
                    "M",
                    h.x + h.width / 2,
                    h.y + h.height / 2
                ]) - 1), !1 === o && (o = 0 == (h = new SVG.PathArray(c.dest).bbox()).height || 0 == h.width ? a.push(a[0]) - 1 : a.push([
                    "M",
                    h.x + h.width / 2,
                    h.y + h.height / 2
                ]) - 1);
                var c = t(i, r, n, a, o, l);
                i = i.slice(0, r).concat(c.start, !1 === n ? [] : i.slice(n)), a = a.slice(0, o).concat(c.dest, !1 === l ? [] : a.slice(l)), r = !1 !== n && r + c.start.length, o = !1 !== l && o + c.dest.length;
            }
            return this.value = i, this.destination = new SVG.PathArray, this.destination.value = a, this;
        }
    });
}(), /*! svg.draggable.js - v2.2.2 - 2019-01-08
* https://github.com/svgdotjs/svg.draggable.js
* Copyright (c) 2019 Wout Fierens; Licensed MIT */ (function() {
    function t(t) {
        t.remember("_draggable", this), this.el = t;
    }
    t.prototype.init = function(t, e) {
        var i = this;
        this.constraint = t, this.value = e, this.el.on("mousedown.drag", function(t) {
            i.start(t);
        }), this.el.on("touchstart.drag", function(t) {
            i.start(t);
        });
    }, t.prototype.transformPoint = function(t, e) {
        var i = (t = t || window.event).changedTouches && t.changedTouches[0] || t;
        return this.p.x = i.clientX - (e || 0), this.p.y = i.clientY, this.p.matrixTransform(this.m);
    }, t.prototype.getBBox = function() {
        var t = this.el.bbox();
        return this.el instanceof SVG.Nested && (t = this.el.rbox()), (this.el instanceof SVG.G || this.el instanceof SVG.Use || this.el instanceof SVG.Nested) && (t.x = this.el.x(), t.y = this.el.y()), t;
    }, t.prototype.start = function(t) {
        if ("click" != t.type && "mousedown" != t.type && "mousemove" != t.type || 1 == (t.which || t.buttons)) {
            var e = this;
            if (this.el.fire("beforedrag", {
                event: t,
                handler: this
            }), !this.el.event().defaultPrevented) {
                t.preventDefault(), t.stopPropagation(), this.parent = this.parent || this.el.parent(SVG.Nested) || this.el.parent(SVG.Doc), this.p = this.parent.node.createSVGPoint(), this.m = this.el.node.getScreenCTM().inverse();
                var i, a = this.getBBox();
                if (this.el instanceof SVG.Text) switch(i = this.el.node.getComputedTextLength(), this.el.attr("text-anchor")){
                    case "middle":
                        i /= 2;
                        break;
                    case "start":
                        i = 0;
                }
                this.startPoints = {
                    point: this.transformPoint(t, i),
                    box: a,
                    transform: this.el.transform()
                }, SVG.on(window, "mousemove.drag", function(t) {
                    e.drag(t);
                }), SVG.on(window, "touchmove.drag", function(t) {
                    e.drag(t);
                }), SVG.on(window, "mouseup.drag", function(t) {
                    e.end(t);
                }), SVG.on(window, "touchend.drag", function(t) {
                    e.end(t);
                }), this.el.fire("dragstart", {
                    event: t,
                    p: this.startPoints.point,
                    m: this.m,
                    handler: this
                });
            }
        }
    }, t.prototype.drag = function(t) {
        var e = this.getBBox(), i = this.transformPoint(t), a = this.startPoints.box.x + i.x - this.startPoints.point.x, s = this.startPoints.box.y + i.y - this.startPoints.point.y, r = this.constraint, o = i.x - this.startPoints.point.x, n = i.y - this.startPoints.point.y;
        if (this.el.fire("dragmove", {
            event: t,
            p: i,
            m: this.m,
            handler: this
        }), this.el.event().defaultPrevented) return i;
        if ("function" == typeof r) {
            var l = r.call(this.el, a, s, this.m);
            "boolean" == typeof l && (l = {
                x: l,
                y: l
            }), !0 === l.x ? this.el.x(a) : !1 !== l.x && this.el.x(l.x), !0 === l.y ? this.el.y(s) : !1 !== l.y && this.el.y(l.y);
        } else "object" == typeof r && (null != r.minX && a < r.minX ? o = (a = r.minX) - this.startPoints.box.x : null != r.maxX && a > r.maxX - e.width && (o = (a = r.maxX - e.width) - this.startPoints.box.x), null != r.minY && s < r.minY ? n = (s = r.minY) - this.startPoints.box.y : null != r.maxY && s > r.maxY - e.height && (n = (s = r.maxY - e.height) - this.startPoints.box.y), null != r.snapToGrid && (a -= a % r.snapToGrid, s -= s % r.snapToGrid, o -= o % r.snapToGrid, n -= n % r.snapToGrid), this.el instanceof SVG.G ? this.el.matrix(this.startPoints.transform).transform({
            x: o,
            y: n
        }, !0) : this.el.move(a, s));
        return i;
    }, t.prototype.end = function(t) {
        var e = this.drag(t);
        this.el.fire("dragend", {
            event: t,
            p: e,
            m: this.m,
            handler: this
        }), SVG.off(window, "mousemove.drag"), SVG.off(window, "touchmove.drag"), SVG.off(window, "mouseup.drag"), SVG.off(window, "touchend.drag");
    }, SVG.extend(SVG.Element, {
        draggable: function(e, i) {
            "function" != typeof e && "object" != typeof e || (i = e, e = !0);
            var a = this.remember("_draggable") || new t(this);
            return (e = void 0 === e || e) ? a.init(i || {}, e) : (this.off("mousedown.drag"), this.off("touchstart.drag")), this;
        }
    });
}).call(void 0), function() {
    function t(t) {
        this.el = t, t.remember("_selectHandler", this), this.pointSelection = {
            isSelected: !1
        }, this.rectSelection = {
            isSelected: !1
        }, this.pointsList = {
            lt: [
                0,
                0
            ],
            rt: [
                "width",
                0
            ],
            rb: [
                "width",
                "height"
            ],
            lb: [
                0,
                "height"
            ],
            t: [
                "width",
                0
            ],
            r: [
                "width",
                "height"
            ],
            b: [
                "width",
                "height"
            ],
            l: [
                0,
                "height"
            ]
        }, this.pointCoord = function(t, e, i) {
            var a = "string" != typeof t ? t : e[t];
            return i ? a / 2 : a;
        }, this.pointCoords = function(t, e) {
            var i = this.pointsList[t];
            return {
                x: this.pointCoord(i[0], e, "t" === t || "b" === t),
                y: this.pointCoord(i[1], e, "r" === t || "l" === t)
            };
        };
    }
    t.prototype.init = function(t, e) {
        var i = this.el.bbox();
        this.options = {};
        var a = this.el.selectize.defaults.points;
        for(var s in this.el.selectize.defaults)this.options[s] = this.el.selectize.defaults[s], void 0 !== e[s] && (this.options[s] = e[s]);
        var r = [
            "points",
            "pointsExclude"
        ];
        for(var s in r){
            var o = this.options[r[s]];
            "string" == typeof o ? o = o.length > 0 ? o.split(/\s*,\s*/i) : [] : "boolean" == typeof o && "points" === r[s] && (o = o ? a : []), this.options[r[s]] = o;
        }
        this.options.points = [
            a,
            this.options.points
        ].reduce(function(t, e) {
            return t.filter(function(t) {
                return e.indexOf(t) > -1;
            });
        }), this.options.points = [
            this.options.points,
            this.options.pointsExclude
        ].reduce(function(t, e) {
            return t.filter(function(t) {
                return e.indexOf(t) < 0;
            });
        }), this.parent = this.el.parent(), this.nested = this.nested || this.parent.group(), this.nested.matrix(new SVG.Matrix(this.el).translate(i.x, i.y)), this.options.deepSelect && -1 !== [
            "line",
            "polyline",
            "polygon"
        ].indexOf(this.el.type) ? this.selectPoints(t) : this.selectRect(t), this.observe(), this.cleanup();
    }, t.prototype.selectPoints = function(t) {
        return this.pointSelection.isSelected = t, this.pointSelection.set || (this.pointSelection.set = this.parent.set(), this.drawPoints()), this;
    }, t.prototype.getPointArray = function() {
        var t = this.el.bbox();
        return this.el.array().valueOf().map(function(e) {
            return [
                e[0] - t.x,
                e[1] - t.y
            ];
        });
    }, t.prototype.drawPoints = function() {
        for(var t = this, e = this.getPointArray(), i = 0, a = e.length; i < a; ++i){
            var s = function(e) {
                return function(i) {
                    (i = i || window.event).preventDefault ? i.preventDefault() : i.returnValue = !1, i.stopPropagation();
                    var a = i.pageX || i.touches[0].pageX, s = i.pageY || i.touches[0].pageY;
                    t.el.fire("point", {
                        x: a,
                        y: s,
                        i: e,
                        event: i
                    });
                };
            }(i), r = this.drawPoint(e[i][0], e[i][1]).addClass(this.options.classPoints).addClass(this.options.classPoints + "_point").on("touchstart", s).on("mousedown", s);
            this.pointSelection.set.add(r);
        }
    }, t.prototype.drawPoint = function(t, e) {
        var i = this.options.pointType;
        switch(i){
            case "circle":
                return this.drawCircle(t, e);
            case "rect":
                return this.drawRect(t, e);
            default:
                if ("function" == typeof i) return i.call(this, t, e);
                throw new Error("Unknown " + i + " point type!");
        }
    }, t.prototype.drawCircle = function(t, e) {
        return this.nested.circle(this.options.pointSize).center(t, e);
    }, t.prototype.drawRect = function(t, e) {
        return this.nested.rect(this.options.pointSize, this.options.pointSize).center(t, e);
    }, t.prototype.updatePointSelection = function() {
        var t = this.getPointArray();
        this.pointSelection.set.each(function(e) {
            this.cx() === t[e][0] && this.cy() === t[e][1] || this.center(t[e][0], t[e][1]);
        });
    }, t.prototype.updateRectSelection = function() {
        var t = this, e = this.el.bbox();
        if (this.rectSelection.set.get(0).attr({
            width: e.width,
            height: e.height
        }), this.options.points.length && this.options.points.map(function(i, a) {
            var s = t.pointCoords(i, e);
            t.rectSelection.set.get(a + 1).center(s.x, s.y);
        }), this.options.rotationPoint) {
            var i = this.rectSelection.set.length();
            this.rectSelection.set.get(i - 1).center(e.width / 2, 20);
        }
    }, t.prototype.selectRect = function(t) {
        var e = this, i = this.el.bbox();
        function a(t) {
            return function(i) {
                (i = i || window.event).preventDefault ? i.preventDefault() : i.returnValue = !1, i.stopPropagation();
                var a = i.pageX || i.touches[0].pageX, s = i.pageY || i.touches[0].pageY;
                e.el.fire(t, {
                    x: a,
                    y: s,
                    event: i
                });
            };
        }
        if (this.rectSelection.isSelected = t, this.rectSelection.set = this.rectSelection.set || this.parent.set(), this.rectSelection.set.get(0) || this.rectSelection.set.add(this.nested.rect(i.width, i.height).addClass(this.options.classRect)), this.options.points.length && this.rectSelection.set.length() < 2) this.options.points.map(function(t, s) {
            var r = e.pointCoords(t, i), o = e.drawPoint(r.x, r.y).attr("class", e.options.classPoints + "_" + t).on("mousedown", a(t)).on("touchstart", a(t));
            e.rectSelection.set.add(o);
        }), this.rectSelection.set.each(function() {
            this.addClass(e.options.classPoints);
        });
        if (this.options.rotationPoint && (this.options.points && !this.rectSelection.set.get(9) || !this.options.points && !this.rectSelection.set.get(1))) {
            var s = function(t) {
                (t = t || window.event).preventDefault ? t.preventDefault() : t.returnValue = !1, t.stopPropagation();
                var i = t.pageX || t.touches[0].pageX, a = t.pageY || t.touches[0].pageY;
                e.el.fire("rot", {
                    x: i,
                    y: a,
                    event: t
                });
            }, r = this.drawPoint(i.width / 2, 20).attr("class", this.options.classPoints + "_rot").on("touchstart", s).on("mousedown", s);
            this.rectSelection.set.add(r);
        }
    }, t.prototype.handler = function() {
        var t = this.el.bbox();
        this.nested.matrix(new SVG.Matrix(this.el).translate(t.x, t.y)), this.rectSelection.isSelected && this.updateRectSelection(), this.pointSelection.isSelected && this.updatePointSelection();
    }, t.prototype.observe = function() {
        var t = this;
        if (MutationObserver) {
            if (this.rectSelection.isSelected || this.pointSelection.isSelected) this.observerInst = this.observerInst || new MutationObserver(function() {
                t.handler();
            }), this.observerInst.observe(this.el.node, {
                attributes: !0
            });
            else try {
                this.observerInst.disconnect(), delete this.observerInst;
            } catch (t) {}
        } else this.el.off("DOMAttrModified.select"), (this.rectSelection.isSelected || this.pointSelection.isSelected) && this.el.on("DOMAttrModified.select", function() {
            t.handler();
        });
    }, t.prototype.cleanup = function() {
        !this.rectSelection.isSelected && this.rectSelection.set && (this.rectSelection.set.each(function() {
            this.remove();
        }), this.rectSelection.set.clear(), delete this.rectSelection.set), !this.pointSelection.isSelected && this.pointSelection.set && (this.pointSelection.set.each(function() {
            this.remove();
        }), this.pointSelection.set.clear(), delete this.pointSelection.set), this.pointSelection.isSelected || this.rectSelection.isSelected || (this.nested.remove(), delete this.nested);
    }, SVG.extend(SVG.Element, {
        selectize: function(e, i) {
            return "object" == typeof e && (i = e, e = !0), (this.remember("_selectHandler") || new t(this)).init(void 0 === e || e, i || {}), this;
        }
    }), SVG.Element.prototype.selectize.defaults = {
        points: [
            "lt",
            "rt",
            "rb",
            "lb",
            "t",
            "r",
            "b",
            "l"
        ],
        pointsExclude: [],
        classRect: "svg_select_boundingRect",
        classPoints: "svg_select_points",
        pointSize: 7,
        rotationPoint: !0,
        deepSelect: !1,
        pointType: "circle"
    };
}(), function() {
    (function() {
        function t(t) {
            t.remember("_resizeHandler", this), this.el = t, this.parameters = {}, this.lastUpdateCall = null, this.p = t.doc().node.createSVGPoint();
        }
        t.prototype.transformPoint = function(t, e, i) {
            return this.p.x = t - (this.offset.x - window.pageXOffset), this.p.y = e - (this.offset.y - window.pageYOffset), this.p.matrixTransform(i || this.m);
        }, t.prototype._extractPosition = function(t) {
            return {
                x: null != t.clientX ? t.clientX : t.touches[0].clientX,
                y: null != t.clientY ? t.clientY : t.touches[0].clientY
            };
        }, t.prototype.init = function(t) {
            var e = this;
            if (this.stop(), "stop" !== t) {
                for(var i in this.options = {}, this.el.resize.defaults)this.options[i] = this.el.resize.defaults[i], void 0 !== t[i] && (this.options[i] = t[i]);
                this.el.on("lt.resize", function(t) {
                    e.resize(t || window.event);
                }), this.el.on("rt.resize", function(t) {
                    e.resize(t || window.event);
                }), this.el.on("rb.resize", function(t) {
                    e.resize(t || window.event);
                }), this.el.on("lb.resize", function(t) {
                    e.resize(t || window.event);
                }), this.el.on("t.resize", function(t) {
                    e.resize(t || window.event);
                }), this.el.on("r.resize", function(t) {
                    e.resize(t || window.event);
                }), this.el.on("b.resize", function(t) {
                    e.resize(t || window.event);
                }), this.el.on("l.resize", function(t) {
                    e.resize(t || window.event);
                }), this.el.on("rot.resize", function(t) {
                    e.resize(t || window.event);
                }), this.el.on("point.resize", function(t) {
                    e.resize(t || window.event);
                }), this.update();
            }
        }, t.prototype.stop = function() {
            return this.el.off("lt.resize"), this.el.off("rt.resize"), this.el.off("rb.resize"), this.el.off("lb.resize"), this.el.off("t.resize"), this.el.off("r.resize"), this.el.off("b.resize"), this.el.off("l.resize"), this.el.off("rot.resize"), this.el.off("point.resize"), this;
        }, t.prototype.resize = function(t) {
            var e = this;
            this.m = this.el.node.getScreenCTM().inverse(), this.offset = {
                x: window.pageXOffset,
                y: window.pageYOffset
            };
            var i = this._extractPosition(t.detail.event);
            if (this.parameters = {
                type: this.el.type,
                p: this.transformPoint(i.x, i.y),
                x: t.detail.x,
                y: t.detail.y,
                box: this.el.bbox(),
                rotation: this.el.transform().rotation
            }, "text" === this.el.type && (this.parameters.fontSize = this.el.attr()["font-size"]), void 0 !== t.detail.i) {
                var a = this.el.array().valueOf();
                this.parameters.i = t.detail.i, this.parameters.pointCoords = [
                    a[t.detail.i][0],
                    a[t.detail.i][1]
                ];
            }
            switch(t.type){
                case "lt":
                    this.calc = function(t, e) {
                        var i = this.snapToGrid(t, e);
                        if (this.parameters.box.width - i[0] > 0 && this.parameters.box.height - i[1] > 0) {
                            if ("text" === this.parameters.type) return this.el.move(this.parameters.box.x + i[0], this.parameters.box.y), void this.el.attr("font-size", this.parameters.fontSize - i[0]);
                            i = this.checkAspectRatio(i), this.el.move(this.parameters.box.x + i[0], this.parameters.box.y + i[1]).size(this.parameters.box.width - i[0], this.parameters.box.height - i[1]);
                        }
                    };
                    break;
                case "rt":
                    this.calc = function(t, e) {
                        var i = this.snapToGrid(t, e, 2);
                        if (this.parameters.box.width + i[0] > 0 && this.parameters.box.height - i[1] > 0) {
                            if ("text" === this.parameters.type) return this.el.move(this.parameters.box.x - i[0], this.parameters.box.y), void this.el.attr("font-size", this.parameters.fontSize + i[0]);
                            i = this.checkAspectRatio(i, !0), this.el.move(this.parameters.box.x, this.parameters.box.y + i[1]).size(this.parameters.box.width + i[0], this.parameters.box.height - i[1]);
                        }
                    };
                    break;
                case "rb":
                    this.calc = function(t, e) {
                        var i = this.snapToGrid(t, e, 0);
                        if (this.parameters.box.width + i[0] > 0 && this.parameters.box.height + i[1] > 0) {
                            if ("text" === this.parameters.type) return this.el.move(this.parameters.box.x - i[0], this.parameters.box.y), void this.el.attr("font-size", this.parameters.fontSize + i[0]);
                            i = this.checkAspectRatio(i), this.el.move(this.parameters.box.x, this.parameters.box.y).size(this.parameters.box.width + i[0], this.parameters.box.height + i[1]);
                        }
                    };
                    break;
                case "lb":
                    this.calc = function(t, e) {
                        var i = this.snapToGrid(t, e, 1);
                        if (this.parameters.box.width - i[0] > 0 && this.parameters.box.height + i[1] > 0) {
                            if ("text" === this.parameters.type) return this.el.move(this.parameters.box.x + i[0], this.parameters.box.y), void this.el.attr("font-size", this.parameters.fontSize - i[0]);
                            i = this.checkAspectRatio(i, !0), this.el.move(this.parameters.box.x + i[0], this.parameters.box.y).size(this.parameters.box.width - i[0], this.parameters.box.height + i[1]);
                        }
                    };
                    break;
                case "t":
                    this.calc = function(t, e) {
                        var i = this.snapToGrid(t, e, 2);
                        if (this.parameters.box.height - i[1] > 0) {
                            if ("text" === this.parameters.type) return;
                            this.el.move(this.parameters.box.x, this.parameters.box.y + i[1]).height(this.parameters.box.height - i[1]);
                        }
                    };
                    break;
                case "r":
                    this.calc = function(t, e) {
                        var i = this.snapToGrid(t, e, 0);
                        if (this.parameters.box.width + i[0] > 0) {
                            if ("text" === this.parameters.type) return;
                            this.el.move(this.parameters.box.x, this.parameters.box.y).width(this.parameters.box.width + i[0]);
                        }
                    };
                    break;
                case "b":
                    this.calc = function(t, e) {
                        var i = this.snapToGrid(t, e, 0);
                        if (this.parameters.box.height + i[1] > 0) {
                            if ("text" === this.parameters.type) return;
                            this.el.move(this.parameters.box.x, this.parameters.box.y).height(this.parameters.box.height + i[1]);
                        }
                    };
                    break;
                case "l":
                    this.calc = function(t, e) {
                        var i = this.snapToGrid(t, e, 1);
                        if (this.parameters.box.width - i[0] > 0) {
                            if ("text" === this.parameters.type) return;
                            this.el.move(this.parameters.box.x + i[0], this.parameters.box.y).width(this.parameters.box.width - i[0]);
                        }
                    };
                    break;
                case "rot":
                    this.calc = function(t, e) {
                        var i = t + this.parameters.p.x, a = e + this.parameters.p.y, s = Math.atan2(this.parameters.p.y - this.parameters.box.y - this.parameters.box.height / 2, this.parameters.p.x - this.parameters.box.x - this.parameters.box.width / 2), r = Math.atan2(a - this.parameters.box.y - this.parameters.box.height / 2, i - this.parameters.box.x - this.parameters.box.width / 2), o = this.parameters.rotation + 180 * (r - s) / Math.PI + this.options.snapToAngle / 2;
                        this.el.center(this.parameters.box.cx, this.parameters.box.cy).rotate(o - o % this.options.snapToAngle, this.parameters.box.cx, this.parameters.box.cy);
                    };
                    break;
                case "point":
                    this.calc = function(t, e) {
                        var i = this.snapToGrid(t, e, this.parameters.pointCoords[0], this.parameters.pointCoords[1]), a = this.el.array().valueOf();
                        a[this.parameters.i][0] = this.parameters.pointCoords[0] + i[0], a[this.parameters.i][1] = this.parameters.pointCoords[1] + i[1], this.el.plot(a);
                    };
            }
            this.el.fire("resizestart", {
                dx: this.parameters.x,
                dy: this.parameters.y,
                event: t
            }), SVG.on(window, "touchmove.resize", function(t) {
                e.update(t || window.event);
            }), SVG.on(window, "touchend.resize", function() {
                e.done();
            }), SVG.on(window, "mousemove.resize", function(t) {
                e.update(t || window.event);
            }), SVG.on(window, "mouseup.resize", function() {
                e.done();
            });
        }, t.prototype.update = function(t) {
            if (t) {
                var e = this._extractPosition(t), i = this.transformPoint(e.x, e.y), a = i.x - this.parameters.p.x, s = i.y - this.parameters.p.y;
                this.lastUpdateCall = [
                    a,
                    s
                ], this.calc(a, s), this.el.fire("resizing", {
                    dx: a,
                    dy: s,
                    event: t
                });
            } else this.lastUpdateCall && this.calc(this.lastUpdateCall[0], this.lastUpdateCall[1]);
        }, t.prototype.done = function() {
            this.lastUpdateCall = null, SVG.off(window, "mousemove.resize"), SVG.off(window, "mouseup.resize"), SVG.off(window, "touchmove.resize"), SVG.off(window, "touchend.resize"), this.el.fire("resizedone");
        }, t.prototype.snapToGrid = function(t, e, i, a) {
            var s;
            return void 0 !== a ? s = [
                (i + t) % this.options.snapToGrid,
                (a + e) % this.options.snapToGrid
            ] : (i = null == i ? 3 : i, s = [
                (this.parameters.box.x + t + (1 & i ? 0 : this.parameters.box.width)) % this.options.snapToGrid,
                (this.parameters.box.y + e + (2 & i ? 0 : this.parameters.box.height)) % this.options.snapToGrid
            ]), t < 0 && (s[0] -= this.options.snapToGrid), e < 0 && (s[1] -= this.options.snapToGrid), t -= Math.abs(s[0]) < this.options.snapToGrid / 2 ? s[0] : s[0] - (t < 0 ? -this.options.snapToGrid : this.options.snapToGrid), e -= Math.abs(s[1]) < this.options.snapToGrid / 2 ? s[1] : s[1] - (e < 0 ? -this.options.snapToGrid : this.options.snapToGrid), this.constraintToBox(t, e, i, a);
        }, t.prototype.constraintToBox = function(t, e, i, a) {
            var s, r, o = this.options.constraint || {};
            return void 0 !== a ? (s = i, r = a) : (s = this.parameters.box.x + (1 & i ? 0 : this.parameters.box.width), r = this.parameters.box.y + (2 & i ? 0 : this.parameters.box.height)), void 0 !== o.minX && s + t < o.minX && (t = o.minX - s), void 0 !== o.maxX && s + t > o.maxX && (t = o.maxX - s), void 0 !== o.minY && r + e < o.minY && (e = o.minY - r), void 0 !== o.maxY && r + e > o.maxY && (e = o.maxY - r), [
                t,
                e
            ];
        }, t.prototype.checkAspectRatio = function(t, e) {
            if (!this.options.saveAspectRatio) return t;
            var i = t.slice(), a = this.parameters.box.width / this.parameters.box.height, s = this.parameters.box.width + t[0], r = this.parameters.box.height - t[1], o = s / r;
            return o < a ? (i[1] = s / a - this.parameters.box.height, e && (i[1] = -i[1])) : o > a && (i[0] = this.parameters.box.width - r * a, e && (i[0] = -i[0])), i;
        }, SVG.extend(SVG.Element, {
            resize: function(e) {
                return (this.remember("_resizeHandler") || new t(this)).init(e || {}), this;
            }
        }), SVG.Element.prototype.resize.defaults = {
            snapToAngle: .1,
            snapToGrid: 1,
            constraint: {},
            saveAspectRatio: !1
        };
    }).call(this);
}(), void 0 === window.Apex && (window.Apex = {});
var $b705b473d3ec9641$var$Yt = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "initModules",
            value: function() {
                this.ctx.publicMethods = [
                    "updateOptions",
                    "updateSeries",
                    "appendData",
                    "appendSeries",
                    "toggleSeries",
                    "showSeries",
                    "hideSeries",
                    "setLocale",
                    "resetSeries",
                    "zoomX",
                    "toggleDataPointSelection",
                    "dataURI",
                    "addXaxisAnnotation",
                    "addYaxisAnnotation",
                    "addPointAnnotation",
                    "clearAnnotations",
                    "removeAnnotation",
                    "paper",
                    "destroy"
                ], this.ctx.eventList = [
                    "click",
                    "mousedown",
                    "mousemove",
                    "mouseleave",
                    "touchstart",
                    "touchmove",
                    "touchleave",
                    "mouseup",
                    "touchend"
                ], this.ctx.animations = new $b705b473d3ec9641$var$f(this.ctx), this.ctx.axes = new $b705b473d3ec9641$var$J(this.ctx), this.ctx.core = new $b705b473d3ec9641$var$Xt(this.ctx.el, this.ctx), this.ctx.config = new $b705b473d3ec9641$var$H({}), this.ctx.data = new $b705b473d3ec9641$var$O(this.ctx), this.ctx.grid = new $b705b473d3ec9641$var$_(this.ctx), this.ctx.graphics = new $b705b473d3ec9641$var$b(this.ctx), this.ctx.coreUtils = new $b705b473d3ec9641$var$y(this.ctx), this.ctx.crosshairs = new $b705b473d3ec9641$var$Q(this.ctx), this.ctx.events = new $b705b473d3ec9641$var$Z(this.ctx), this.ctx.exports = new $b705b473d3ec9641$var$V(this.ctx), this.ctx.localization = new $b705b473d3ec9641$var$$(this.ctx), this.ctx.options = new $b705b473d3ec9641$var$S, this.ctx.responsive = new $b705b473d3ec9641$var$K(this.ctx), this.ctx.series = new $b705b473d3ec9641$var$z(this.ctx), this.ctx.theme = new $b705b473d3ec9641$var$tt(this.ctx), this.ctx.formatters = new $b705b473d3ec9641$var$W(this.ctx), this.ctx.titleSubtitle = new $b705b473d3ec9641$var$et(this.ctx), this.ctx.legend = new $b705b473d3ec9641$var$lt(this.ctx), this.ctx.toolbar = new $b705b473d3ec9641$var$ht(this.ctx), this.ctx.dimensions = new $b705b473d3ec9641$var$ot(this.ctx), this.ctx.updateHelpers = new $b705b473d3ec9641$var$Et(this.ctx), this.ctx.zoomPanSelection = new $b705b473d3ec9641$var$ct(this.ctx), this.ctx.w.globals.tooltip = new $b705b473d3ec9641$var$bt(this.ctx);
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$Ft = function() {
    function t(e) {
        $b705b473d3ec9641$var$a(this, t), this.ctx = e, this.w = e.w;
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "clear",
            value: function(t) {
                var e = t.isUpdating;
                this.ctx.zoomPanSelection && this.ctx.zoomPanSelection.destroy(), this.ctx.toolbar && this.ctx.toolbar.destroy(), this.ctx.animations = null, this.ctx.axes = null, this.ctx.annotations = null, this.ctx.core = null, this.ctx.data = null, this.ctx.grid = null, this.ctx.series = null, this.ctx.responsive = null, this.ctx.theme = null, this.ctx.formatters = null, this.ctx.titleSubtitle = null, this.ctx.legend = null, this.ctx.dimensions = null, this.ctx.options = null, this.ctx.crosshairs = null, this.ctx.zoomPanSelection = null, this.ctx.updateHelpers = null, this.ctx.toolbar = null, this.ctx.localization = null, this.ctx.w.globals.tooltip = null, this.clearDomElements({
                    isUpdating: e
                });
            }
        },
        {
            key: "killSVG",
            value: function(t) {
                t.each(function(t, e) {
                    this.removeClass("*"), this.off(), this.stop();
                }, !0), t.ungroup(), t.clear();
            }
        },
        {
            key: "clearDomElements",
            value: function(t) {
                var e = this, i = t.isUpdating, a = this.w.globals.dom.Paper.node;
                a.parentNode && a.parentNode.parentNode && !i && (a.parentNode.parentNode.style.minHeight = "unset");
                var s = this.w.globals.dom.baseEl;
                s && this.ctx.eventList.forEach(function(t) {
                    s.removeEventListener(t, e.ctx.events.documentEvent);
                });
                var r = this.w.globals.dom;
                if (null !== this.ctx.el) for(; this.ctx.el.firstChild;)this.ctx.el.removeChild(this.ctx.el.firstChild);
                this.killSVG(r.Paper), r.Paper.remove(), r.elWrap = null, r.elGraphical = null, r.elAnnotations = null, r.elLegendWrap = null, r.baseEl = null, r.elGridRect = null, r.elGridRectMask = null, r.elGridRectMarkerMask = null, r.elForecastMask = null, r.elNonForecastMask = null, r.elDefs = null;
            }
        }
    ]), t;
}(), $b705b473d3ec9641$var$Rt = new WeakMap;
var $b705b473d3ec9641$var$Ht = function() {
    function t(e, i) {
        $b705b473d3ec9641$var$a(this, t), this.opts = i, this.ctx = this, this.w = new $b705b473d3ec9641$var$N(i).init(), this.el = e, this.w.globals.cuid = $b705b473d3ec9641$var$p.randomId(), this.w.globals.chartID = this.w.config.chart.id ? $b705b473d3ec9641$var$p.escapeString(this.w.config.chart.id) : this.w.globals.cuid, new $b705b473d3ec9641$var$Yt(this).initModules(), this.create = $b705b473d3ec9641$var$p.bind(this.create, this), this.windowResizeHandler = this._windowResizeHandler.bind(this), this.parentResizeHandler = this._parentResizeCallback.bind(this);
    }
    return $b705b473d3ec9641$var$r(t, [
        {
            key: "render",
            value: function() {
                var t = this;
                return new Promise(function(e, i) {
                    if (null !== t.el) {
                        void 0 === Apex._chartInstances && (Apex._chartInstances = []), t.w.config.chart.id && Apex._chartInstances.push({
                            id: t.w.globals.chartID,
                            group: t.w.config.chart.group,
                            chart: t
                        }), t.setLocale(t.w.config.chart.defaultLocale);
                        var a = t.w.config.chart.events.beforeMount;
                        if ("function" == typeof a && a(t, t.w), t.events.fireEvent("beforeMount", [
                            t,
                            t.w
                        ]), window.addEventListener("resize", t.windowResizeHandler), h = t.el.parentNode, c = t.parentResizeHandler, d = !1, g = new ResizeObserver(function(t) {
                            d && c.call(h, t), d = !0;
                        }), h.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? Array.from(h.children).forEach(function(t) {
                            return g.observe(t);
                        }) : g.observe(h), $b705b473d3ec9641$var$Rt.set(c, g), !t.css) {
                            var s = t.el.getRootNode && t.el.getRootNode(), r = $b705b473d3ec9641$var$p.is("ShadowRoot", s), o = t.el.ownerDocument, n = o.getElementById("apexcharts-css");
                            !r && n || (t.css = document.createElement("style"), t.css.id = "apexcharts-css", t.css.textContent = '.apexcharts-canvas {\n  position: relative;\n  user-select: none;\n  /* cannot give overflow: hidden as it will crop tooltips which overflow outside chart area */\n}\n\n\n/* scrollbar is not visible by default for legend, hence forcing the visibility */\n.apexcharts-canvas ::-webkit-scrollbar {\n  -webkit-appearance: none;\n  width: 6px;\n}\n\n.apexcharts-canvas ::-webkit-scrollbar-thumb {\n  border-radius: 4px;\n  background-color: rgba(0, 0, 0, .5);\n  box-shadow: 0 0 1px rgba(255, 255, 255, .5);\n  -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, .5);\n}\n\n\n.apexcharts-inner {\n  position: relative;\n}\n\n.apexcharts-text tspan {\n  font-family: inherit;\n}\n\n.legend-mouseover-inactive {\n  transition: 0.15s ease all;\n  opacity: 0.20;\n}\n\n.apexcharts-series-collapsed {\n  opacity: 0;\n}\n\n.apexcharts-tooltip {\n  border-radius: 5px;\n  box-shadow: 2px 2px 6px -4px #999;\n  cursor: default;\n  font-size: 14px;\n  left: 62px;\n  opacity: 0;\n  pointer-events: none;\n  position: absolute;\n  top: 20px;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  white-space: nowrap;\n  z-index: 12;\n  transition: 0.15s ease all;\n}\n\n.apexcharts-tooltip.apexcharts-active {\n  opacity: 1;\n  transition: 0.15s ease all;\n}\n\n.apexcharts-tooltip.apexcharts-theme-light {\n  border: 1px solid #e3e3e3;\n  background: rgba(255, 255, 255, 0.96);\n}\n\n.apexcharts-tooltip.apexcharts-theme-dark {\n  color: #fff;\n  background: rgba(30, 30, 30, 0.8);\n}\n\n.apexcharts-tooltip * {\n  font-family: inherit;\n}\n\n\n.apexcharts-tooltip-title {\n  padding: 6px;\n  font-size: 15px;\n  margin-bottom: 4px;\n}\n\n.apexcharts-tooltip.apexcharts-theme-light .apexcharts-tooltip-title {\n  background: #ECEFF1;\n  border-bottom: 1px solid #ddd;\n}\n\n.apexcharts-tooltip.apexcharts-theme-dark .apexcharts-tooltip-title {\n  background: rgba(0, 0, 0, 0.7);\n  border-bottom: 1px solid #333;\n}\n\n.apexcharts-tooltip-text-y-value,\n.apexcharts-tooltip-text-goals-value,\n.apexcharts-tooltip-text-z-value {\n  display: inline-block;\n  font-weight: 600;\n  margin-left: 5px;\n}\n\n.apexcharts-tooltip-title:empty,\n.apexcharts-tooltip-text-y-label:empty,\n.apexcharts-tooltip-text-y-value:empty,\n.apexcharts-tooltip-text-goals-label:empty,\n.apexcharts-tooltip-text-goals-value:empty,\n.apexcharts-tooltip-text-z-value:empty {\n  display: none;\n}\n\n.apexcharts-tooltip-text-y-value,\n.apexcharts-tooltip-text-goals-value,\n.apexcharts-tooltip-text-z-value {\n  font-weight: 600;\n}\n\n.apexcharts-tooltip-text-goals-label, \n.apexcharts-tooltip-text-goals-value {\n  padding: 6px 0 5px;\n}\n\n.apexcharts-tooltip-goals-group, \n.apexcharts-tooltip-text-goals-label, \n.apexcharts-tooltip-text-goals-value {\n  display: flex;\n}\n.apexcharts-tooltip-text-goals-label:not(:empty),\n.apexcharts-tooltip-text-goals-value:not(:empty) {\n  margin-top: -6px;\n}\n\n.apexcharts-tooltip-marker {\n  width: 12px;\n  height: 12px;\n  position: relative;\n  top: 0px;\n  margin-right: 10px;\n  border-radius: 50%;\n}\n\n.apexcharts-tooltip-series-group {\n  padding: 0 10px;\n  display: none;\n  text-align: left;\n  justify-content: left;\n  align-items: center;\n}\n\n.apexcharts-tooltip-series-group.apexcharts-active .apexcharts-tooltip-marker {\n  opacity: 1;\n}\n\n.apexcharts-tooltip-series-group.apexcharts-active,\n.apexcharts-tooltip-series-group:last-child {\n  padding-bottom: 4px;\n}\n\n.apexcharts-tooltip-series-group-hidden {\n  opacity: 0;\n  height: 0;\n  line-height: 0;\n  padding: 0 !important;\n}\n\n.apexcharts-tooltip-y-group {\n  padding: 6px 0 5px;\n}\n\n.apexcharts-tooltip-box, .apexcharts-custom-tooltip {\n  padding: 4px 8px;\n}\n\n.apexcharts-tooltip-boxPlot {\n  display: flex;\n  flex-direction: column-reverse;\n}\n\n.apexcharts-tooltip-box>div {\n  margin: 4px 0;\n}\n\n.apexcharts-tooltip-box span.value {\n  font-weight: bold;\n}\n\n.apexcharts-tooltip-rangebar {\n  padding: 5px 8px;\n}\n\n.apexcharts-tooltip-rangebar .category {\n  font-weight: 600;\n  color: #777;\n}\n\n.apexcharts-tooltip-rangebar .series-name {\n  font-weight: bold;\n  display: block;\n  margin-bottom: 5px;\n}\n\n.apexcharts-xaxistooltip {\n  opacity: 0;\n  padding: 9px 10px;\n  pointer-events: none;\n  color: #373d3f;\n  font-size: 13px;\n  text-align: center;\n  border-radius: 2px;\n  position: absolute;\n  z-index: 10;\n  background: #ECEFF1;\n  border: 1px solid #90A4AE;\n  transition: 0.15s ease all;\n}\n\n.apexcharts-xaxistooltip.apexcharts-theme-dark {\n  background: rgba(0, 0, 0, 0.7);\n  border: 1px solid rgba(0, 0, 0, 0.5);\n  color: #fff;\n}\n\n.apexcharts-xaxistooltip:after,\n.apexcharts-xaxistooltip:before {\n  left: 50%;\n  border: solid transparent;\n  content: " ";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none;\n}\n\n.apexcharts-xaxistooltip:after {\n  border-color: rgba(236, 239, 241, 0);\n  border-width: 6px;\n  margin-left: -6px;\n}\n\n.apexcharts-xaxistooltip:before {\n  border-color: rgba(144, 164, 174, 0);\n  border-width: 7px;\n  margin-left: -7px;\n}\n\n.apexcharts-xaxistooltip-bottom:after,\n.apexcharts-xaxistooltip-bottom:before {\n  bottom: 100%;\n}\n\n.apexcharts-xaxistooltip-top:after,\n.apexcharts-xaxistooltip-top:before {\n  top: 100%;\n}\n\n.apexcharts-xaxistooltip-bottom:after {\n  border-bottom-color: #ECEFF1;\n}\n\n.apexcharts-xaxistooltip-bottom:before {\n  border-bottom-color: #90A4AE;\n}\n\n.apexcharts-xaxistooltip-bottom.apexcharts-theme-dark:after {\n  border-bottom-color: rgba(0, 0, 0, 0.5);\n}\n\n.apexcharts-xaxistooltip-bottom.apexcharts-theme-dark:before {\n  border-bottom-color: rgba(0, 0, 0, 0.5);\n}\n\n.apexcharts-xaxistooltip-top:after {\n  border-top-color: #ECEFF1\n}\n\n.apexcharts-xaxistooltip-top:before {\n  border-top-color: #90A4AE;\n}\n\n.apexcharts-xaxistooltip-top.apexcharts-theme-dark:after {\n  border-top-color: rgba(0, 0, 0, 0.5);\n}\n\n.apexcharts-xaxistooltip-top.apexcharts-theme-dark:before {\n  border-top-color: rgba(0, 0, 0, 0.5);\n}\n\n.apexcharts-xaxistooltip.apexcharts-active {\n  opacity: 1;\n  transition: 0.15s ease all;\n}\n\n.apexcharts-yaxistooltip {\n  opacity: 0;\n  padding: 4px 10px;\n  pointer-events: none;\n  color: #373d3f;\n  font-size: 13px;\n  text-align: center;\n  border-radius: 2px;\n  position: absolute;\n  z-index: 10;\n  background: #ECEFF1;\n  border: 1px solid #90A4AE;\n}\n\n.apexcharts-yaxistooltip.apexcharts-theme-dark {\n  background: rgba(0, 0, 0, 0.7);\n  border: 1px solid rgba(0, 0, 0, 0.5);\n  color: #fff;\n}\n\n.apexcharts-yaxistooltip:after,\n.apexcharts-yaxistooltip:before {\n  top: 50%;\n  border: solid transparent;\n  content: " ";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none;\n}\n\n.apexcharts-yaxistooltip:after {\n  border-color: rgba(236, 239, 241, 0);\n  border-width: 6px;\n  margin-top: -6px;\n}\n\n.apexcharts-yaxistooltip:before {\n  border-color: rgba(144, 164, 174, 0);\n  border-width: 7px;\n  margin-top: -7px;\n}\n\n.apexcharts-yaxistooltip-left:after,\n.apexcharts-yaxistooltip-left:before {\n  left: 100%;\n}\n\n.apexcharts-yaxistooltip-right:after,\n.apexcharts-yaxistooltip-right:before {\n  right: 100%;\n}\n\n.apexcharts-yaxistooltip-left:after {\n  border-left-color: #ECEFF1;\n}\n\n.apexcharts-yaxistooltip-left:before {\n  border-left-color: #90A4AE;\n}\n\n.apexcharts-yaxistooltip-left.apexcharts-theme-dark:after {\n  border-left-color: rgba(0, 0, 0, 0.5);\n}\n\n.apexcharts-yaxistooltip-left.apexcharts-theme-dark:before {\n  border-left-color: rgba(0, 0, 0, 0.5);\n}\n\n.apexcharts-yaxistooltip-right:after {\n  border-right-color: #ECEFF1;\n}\n\n.apexcharts-yaxistooltip-right:before {\n  border-right-color: #90A4AE;\n}\n\n.apexcharts-yaxistooltip-right.apexcharts-theme-dark:after {\n  border-right-color: rgba(0, 0, 0, 0.5);\n}\n\n.apexcharts-yaxistooltip-right.apexcharts-theme-dark:before {\n  border-right-color: rgba(0, 0, 0, 0.5);\n}\n\n.apexcharts-yaxistooltip.apexcharts-active {\n  opacity: 1;\n}\n\n.apexcharts-yaxistooltip-hidden {\n  display: none;\n}\n\n.apexcharts-xcrosshairs,\n.apexcharts-ycrosshairs {\n  pointer-events: none;\n  opacity: 0;\n  transition: 0.15s ease all;\n}\n\n.apexcharts-xcrosshairs.apexcharts-active,\n.apexcharts-ycrosshairs.apexcharts-active {\n  opacity: 1;\n  transition: 0.15s ease all;\n}\n\n.apexcharts-ycrosshairs-hidden {\n  opacity: 0;\n}\n\n.apexcharts-selection-rect {\n  cursor: move;\n}\n\n.svg_select_boundingRect, .svg_select_points_rot {\n  pointer-events: none;\n  opacity: 0;\n  visibility: hidden;\n}\n.apexcharts-selection-rect + g .svg_select_boundingRect,\n.apexcharts-selection-rect + g .svg_select_points_rot {\n  opacity: 0;\n  visibility: hidden;\n}\n\n.apexcharts-selection-rect + g .svg_select_points_l,\n.apexcharts-selection-rect + g .svg_select_points_r {\n  cursor: ew-resize;\n  opacity: 1;\n  visibility: visible;\n}\n\n.svg_select_points {\n  fill: #efefef;\n  stroke: #333;\n  rx: 2;\n}\n\n.apexcharts-svg.apexcharts-zoomable.hovering-zoom {\n  cursor: crosshair\n}\n\n.apexcharts-svg.apexcharts-zoomable.hovering-pan {\n  cursor: move\n}\n\n.apexcharts-zoom-icon,\n.apexcharts-zoomin-icon,\n.apexcharts-zoomout-icon,\n.apexcharts-reset-icon,\n.apexcharts-pan-icon,\n.apexcharts-selection-icon,\n.apexcharts-menu-icon,\n.apexcharts-toolbar-custom-icon {\n  cursor: pointer;\n  width: 20px;\n  height: 20px;\n  line-height: 24px;\n  color: #6E8192;\n  text-align: center;\n}\n\n.apexcharts-zoom-icon svg,\n.apexcharts-zoomin-icon svg,\n.apexcharts-zoomout-icon svg,\n.apexcharts-reset-icon svg,\n.apexcharts-menu-icon svg {\n  fill: #6E8192;\n}\n\n.apexcharts-selection-icon svg {\n  fill: #444;\n  transform: scale(0.76)\n}\n\n.apexcharts-theme-dark .apexcharts-zoom-icon svg,\n.apexcharts-theme-dark .apexcharts-zoomin-icon svg,\n.apexcharts-theme-dark .apexcharts-zoomout-icon svg,\n.apexcharts-theme-dark .apexcharts-reset-icon svg,\n.apexcharts-theme-dark .apexcharts-pan-icon svg,\n.apexcharts-theme-dark .apexcharts-selection-icon svg,\n.apexcharts-theme-dark .apexcharts-menu-icon svg,\n.apexcharts-theme-dark .apexcharts-toolbar-custom-icon svg {\n  fill: #f3f4f5;\n}\n\n.apexcharts-canvas .apexcharts-zoom-icon.apexcharts-selected svg,\n.apexcharts-canvas .apexcharts-selection-icon.apexcharts-selected svg,\n.apexcharts-canvas .apexcharts-reset-zoom-icon.apexcharts-selected svg {\n  fill: #008FFB;\n}\n\n.apexcharts-theme-light .apexcharts-selection-icon:not(.apexcharts-selected):hover svg,\n.apexcharts-theme-light .apexcharts-zoom-icon:not(.apexcharts-selected):hover svg,\n.apexcharts-theme-light .apexcharts-zoomin-icon:hover svg,\n.apexcharts-theme-light .apexcharts-zoomout-icon:hover svg,\n.apexcharts-theme-light .apexcharts-reset-icon:hover svg,\n.apexcharts-theme-light .apexcharts-menu-icon:hover svg {\n  fill: #333;\n}\n\n.apexcharts-selection-icon,\n.apexcharts-menu-icon {\n  position: relative;\n}\n\n.apexcharts-reset-icon {\n  margin-left: 5px;\n}\n\n.apexcharts-zoom-icon,\n.apexcharts-reset-icon,\n.apexcharts-menu-icon {\n  transform: scale(0.85);\n}\n\n.apexcharts-zoomin-icon,\n.apexcharts-zoomout-icon {\n  transform: scale(0.7)\n}\n\n.apexcharts-zoomout-icon {\n  margin-right: 3px;\n}\n\n.apexcharts-pan-icon {\n  transform: scale(0.62);\n  position: relative;\n  left: 1px;\n  top: 0px;\n}\n\n.apexcharts-pan-icon svg {\n  fill: #fff;\n  stroke: #6E8192;\n  stroke-width: 2;\n}\n\n.apexcharts-pan-icon.apexcharts-selected svg {\n  stroke: #008FFB;\n}\n\n.apexcharts-pan-icon:not(.apexcharts-selected):hover svg {\n  stroke: #333;\n}\n\n.apexcharts-toolbar {\n  position: absolute;\n  z-index: 11;\n  max-width: 176px;\n  text-align: right;\n  border-radius: 3px;\n  padding: 0px 6px 2px 6px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.apexcharts-menu {\n  background: #fff;\n  position: absolute;\n  top: 100%;\n  border: 1px solid #ddd;\n  border-radius: 3px;\n  padding: 3px;\n  right: 10px;\n  opacity: 0;\n  min-width: 110px;\n  transition: 0.15s ease all;\n  pointer-events: none;\n}\n\n.apexcharts-menu.apexcharts-menu-open {\n  opacity: 1;\n  pointer-events: all;\n  transition: 0.15s ease all;\n}\n\n.apexcharts-menu-item {\n  padding: 6px 7px;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.apexcharts-theme-light .apexcharts-menu-item:hover {\n  background: #eee;\n}\n\n.apexcharts-theme-dark .apexcharts-menu {\n  background: rgba(0, 0, 0, 0.7);\n  color: #fff;\n}\n\n@media screen and (min-width: 768px) {\n  .apexcharts-canvas:hover .apexcharts-toolbar {\n    opacity: 1;\n  }\n}\n\n.apexcharts-datalabel.apexcharts-element-hidden {\n  opacity: 0;\n}\n\n.apexcharts-pie-label,\n.apexcharts-datalabels,\n.apexcharts-datalabel,\n.apexcharts-datalabel-label,\n.apexcharts-datalabel-value {\n  cursor: default;\n  pointer-events: none;\n}\n\n.apexcharts-pie-label-delay {\n  opacity: 0;\n  animation-name: opaque;\n  animation-duration: 0.3s;\n  animation-fill-mode: forwards;\n  animation-timing-function: ease;\n}\n\n.apexcharts-canvas .apexcharts-element-hidden {\n  opacity: 0;\n}\n\n.apexcharts-hide .apexcharts-series-points {\n  opacity: 0;\n}\n\n.apexcharts-gridline,\n.apexcharts-annotation-rect,\n.apexcharts-tooltip .apexcharts-marker,\n.apexcharts-area-series .apexcharts-area,\n.apexcharts-line,\n.apexcharts-zoom-rect,\n.apexcharts-toolbar svg,\n.apexcharts-area-series .apexcharts-series-markers .apexcharts-marker.no-pointer-events,\n.apexcharts-line-series .apexcharts-series-markers .apexcharts-marker.no-pointer-events,\n.apexcharts-radar-series path,\n.apexcharts-radar-series polygon {\n  pointer-events: none;\n}\n\n\n/* markers */\n\n.apexcharts-marker {\n  transition: 0.15s ease all;\n}\n\n@keyframes opaque {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n\n/* Resize generated styles */\n\n@keyframes resizeanim {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 0;\n  }\n}\n\n.resize-triggers {\n  animation: 1ms resizeanim;\n  visibility: hidden;\n  opacity: 0;\n}\n\n.resize-triggers,\n.resize-triggers>div,\n.contract-trigger:before {\n  content: " ";\n  display: block;\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  overflow: hidden;\n}\n\n.resize-triggers>div {\n  background: #eee;\n  overflow: auto;\n}\n\n.contract-trigger:before {\n  width: 200%;\n  height: 200%;\n}', r ? s.prepend(t.css) : o.head.appendChild(t.css));
                        }
                        var l = t.create(t.w.config.series, {});
                        if (!l) return e(t);
                        t.mount(l).then(function() {
                            "function" == typeof t.w.config.chart.events.mounted && t.w.config.chart.events.mounted(t, t.w), t.events.fireEvent("mounted", [
                                t,
                                t.w
                            ]), e(l);
                        }).catch(function(t) {
                            i(t);
                        });
                    } else i(new Error("Element not found"));
                    var h, c, d, g;
                });
            }
        },
        {
            key: "create",
            value: function(t, e) {
                var i = this.w;
                new $b705b473d3ec9641$var$Yt(this).initModules();
                var a = this.w.globals;
                (a.noData = !1, a.animationEnded = !1, this.responsive.checkResponsiveConfig(e), i.config.xaxis.convertedCatToNumeric) && new $b705b473d3ec9641$var$R(i.config).convertCatToNumericXaxis(i.config, this.ctx);
                if (null === this.el) return a.animationEnded = !0, null;
                if (this.core.setupElements(), "treemap" === i.config.chart.type && (i.config.grid.show = !1, i.config.yaxis[0].show = !1), 0 === a.svgWidth) return a.animationEnded = !0, null;
                var s = $b705b473d3ec9641$var$y.checkComboSeries(t);
                a.comboCharts = s.comboCharts, a.comboBarCount = s.comboBarCount;
                var r = t.every(function(t) {
                    return t.data && 0 === t.data.length;
                });
                (0 === t.length || r) && this.series.handleNoData(), this.events.setupEventHandlers(), this.data.parseData(t), this.theme.init(), new $b705b473d3ec9641$var$P(this).setGlobalMarkerSize(), this.formatters.setLabelFormatters(), this.titleSubtitle.draw(), a.noData && a.collapsedSeries.length !== a.series.length && !i.config.legend.showForSingleSeries || this.legend.init(), this.series.hasAllSeriesEqualX(), a.axisCharts && (this.core.coreCalculations(), "category" !== i.config.xaxis.type && this.formatters.setLabelFormatters(), this.ctx.toolbar.minX = i.globals.minX, this.ctx.toolbar.maxX = i.globals.maxX), this.formatters.heatmapLabelFormatters(), this.dimensions.plotCoords();
                var o = this.core.xySettings();
                this.grid.createGridMask();
                var n = this.core.plotChartType(t, o), l = new $b705b473d3ec9641$var$M(this);
                l.bringForward(), i.config.dataLabels.background.enabled && l.dataLabelsBackground(), this.core.shiftGraphPosition();
                var h = {
                    plot: {
                        left: i.globals.translateX,
                        top: i.globals.translateY,
                        width: i.globals.gridWidth,
                        height: i.globals.gridHeight
                    }
                };
                return {
                    elGraph: n,
                    xyRatios: o,
                    elInner: i.globals.dom.elGraphical,
                    dimensions: h
                };
            }
        },
        {
            key: "mount",
            value: function() {
                var t = this, e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, i = this, a = i.w;
                return new Promise(function(s, r) {
                    if (null === i.el) return r(new Error("Not enough data to display or target element not found"));
                    (null === e || a.globals.allSeriesCollapsed) && i.series.handleNoData(), "treemap" !== a.config.chart.type && i.axes.drawAxis(a.config.chart.type, e.xyRatios), i.grid = new $b705b473d3ec9641$var$_(i);
                    var o = i.grid.drawGrid();
                    i.annotations = new $b705b473d3ec9641$var$C(i), i.annotations.drawImageAnnos(), i.annotations.drawTextAnnos(), "back" === a.config.grid.position && o && a.globals.dom.elGraphical.add(o.el);
                    var n = new $b705b473d3ec9641$var$G(t.ctx), l = new $b705b473d3ec9641$var$q(t.ctx);
                    if (null !== o && (n.xAxisLabelCorrections(o.xAxisTickWidth), l.setYAxisTextAlignments(), a.config.yaxis.map(function(t, e) {
                        -1 === a.globals.ignoreYAxisIndexes.indexOf(e) && l.yAxisTitleRotate(e, t.opposite);
                    })), "back" === a.config.annotations.position && (a.globals.dom.Paper.add(a.globals.dom.elAnnotations), i.annotations.drawAxesAnnotations()), Array.isArray(e.elGraph)) for(var h = 0; h < e.elGraph.length; h++)a.globals.dom.elGraphical.add(e.elGraph[h]);
                    else a.globals.dom.elGraphical.add(e.elGraph);
                    if ("front" === a.config.grid.position && o && a.globals.dom.elGraphical.add(o.el), "front" === a.config.xaxis.crosshairs.position && i.crosshairs.drawXCrosshairs(), "front" === a.config.yaxis[0].crosshairs.position && i.crosshairs.drawYCrosshairs(), "front" === a.config.annotations.position && (a.globals.dom.Paper.add(a.globals.dom.elAnnotations), i.annotations.drawAxesAnnotations()), !a.globals.noData) {
                        if (a.config.tooltip.enabled && !a.globals.noData && i.w.globals.tooltip.drawTooltip(e.xyRatios), a.globals.axisCharts && (a.globals.isXNumeric || a.config.xaxis.convertedCatToNumeric || a.globals.isRangeBar)) (a.config.chart.zoom.enabled || a.config.chart.selection && a.config.chart.selection.enabled || a.config.chart.pan && a.config.chart.pan.enabled) && i.zoomPanSelection.init({
                            xyRatios: e.xyRatios
                        });
                        else {
                            var c = a.config.chart.toolbar.tools;
                            [
                                "zoom",
                                "zoomin",
                                "zoomout",
                                "selection",
                                "pan",
                                "reset"
                            ].forEach(function(t) {
                                c[t] = !1;
                            });
                        }
                        a.config.chart.toolbar.show && !a.globals.allSeriesCollapsed && i.toolbar.createToolbar();
                    }
                    a.globals.memory.methodsToExec.length > 0 && a.globals.memory.methodsToExec.forEach(function(t) {
                        t.method(t.params, !1, t.context);
                    }), a.globals.axisCharts || a.globals.noData || i.core.resizeNonAxisCharts(), s(i);
                });
            }
        },
        {
            key: "destroy",
            value: function() {
                var t, e;
                window.removeEventListener("resize", this.windowResizeHandler), this.el.parentNode, t = this.parentResizeHandler, (e = $b705b473d3ec9641$var$Rt.get(t)) && (e.disconnect(), $b705b473d3ec9641$var$Rt.delete(t));
                var i = this.w.config.chart.id;
                i && Apex._chartInstances.forEach(function(t, e) {
                    t.id === $b705b473d3ec9641$var$p.escapeString(i) && Apex._chartInstances.splice(e, 1);
                }), new $b705b473d3ec9641$var$Ft(this.ctx).clear({
                    isUpdating: !1
                });
            }
        },
        {
            key: "updateOptions",
            value: function(t) {
                var e = this, i = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], a = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2], s = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3], r = !(arguments.length > 4 && void 0 !== arguments[4]) || arguments[4], o = this.w;
                return o.globals.selection = void 0, t.series && (this.series.resetSeries(!1, !0, !1), t.series.length && t.series[0].data && (t.series = t.series.map(function(t, i) {
                    return e.updateHelpers._extendSeries(t, i);
                })), this.updateHelpers.revertDefaultAxisMinMax()), t.xaxis && (t = this.updateHelpers.forceXAxisUpdate(t)), t.yaxis && (t = this.updateHelpers.forceYAxisUpdate(t)), o.globals.collapsedSeriesIndices.length > 0 && this.series.clearPreviousPaths(), t.theme && (t = this.theme.updateThemeOptions(t)), this.updateHelpers._updateOptions(t, i, a, s, r);
            }
        },
        {
            key: "updateSeries",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
                return this.series.resetSeries(!1), this.updateHelpers.revertDefaultAxisMinMax(), this.updateHelpers._updateSeries(t, e, i);
            }
        },
        {
            key: "appendSeries",
            value: function(t) {
                var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2], a = this.w.config.series.slice();
                return a.push(t), this.series.resetSeries(!1), this.updateHelpers.revertDefaultAxisMinMax(), this.updateHelpers._updateSeries(a, e, i);
            }
        },
        {
            key: "appendData",
            value: function(t) {
                var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = this;
                i.w.globals.dataChanged = !0, i.series.getPreviousPaths();
                for(var a = i.w.config.series.slice(), s = 0; s < a.length; s++)if (null !== t[s] && void 0 !== t[s]) for(var r = 0; r < t[s].data.length; r++)a[s].data.push(t[s].data[r]);
                return i.w.config.series = a, e && (i.w.globals.initialSeries = $b705b473d3ec9641$var$p.clone(i.w.config.series)), this.update();
            }
        },
        {
            key: "update",
            value: function(t) {
                var e = this;
                return new Promise(function(i, a) {
                    new $b705b473d3ec9641$var$Ft(e.ctx).clear({
                        isUpdating: !0
                    });
                    var s = e.create(e.w.config.series, t);
                    if (!s) return i(e);
                    e.mount(s).then(function() {
                        "function" == typeof e.w.config.chart.events.updated && e.w.config.chart.events.updated(e, e.w), e.events.fireEvent("updated", [
                            e,
                            e.w
                        ]), e.w.globals.isDirty = !0, i(e);
                    }).catch(function(t) {
                        a(t);
                    });
                });
            }
        },
        {
            key: "getSyncedCharts",
            value: function() {
                var t = this.getGroupedCharts(), e = [
                    this
                ];
                return t.length && (e = [], t.forEach(function(t) {
                    e.push(t);
                })), e;
            }
        },
        {
            key: "getGroupedCharts",
            value: function() {
                var t = this;
                return Apex._chartInstances.filter(function(t) {
                    if (t.group) return !0;
                }).map(function(e) {
                    return t.w.config.chart.group === e.group ? e.chart : t;
                });
            }
        },
        {
            key: "toggleSeries",
            value: function(t) {
                return this.series.toggleSeries(t);
            }
        },
        {
            key: "highlightSeriesOnLegendHover",
            value: function(t, e) {
                return this.series.toggleSeriesOnHover(t, e);
            }
        },
        {
            key: "showSeries",
            value: function(t) {
                this.series.showSeries(t);
            }
        },
        {
            key: "hideSeries",
            value: function(t) {
                this.series.hideSeries(t);
            }
        },
        {
            key: "resetSeries",
            value: function() {
                var t = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0], e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                this.series.resetSeries(t, e);
            }
        },
        {
            key: "addEventListener",
            value: function(t, e) {
                this.events.addEventListener(t, e);
            }
        },
        {
            key: "removeEventListener",
            value: function(t, e) {
                this.events.removeEventListener(t, e);
            }
        },
        {
            key: "addXaxisAnnotation",
            value: function(t) {
                var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0, a = this;
                i && (a = i), a.annotations.addXaxisAnnotationExternal(t, e, a);
            }
        },
        {
            key: "addYaxisAnnotation",
            value: function(t) {
                var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0, a = this;
                i && (a = i), a.annotations.addYaxisAnnotationExternal(t, e, a);
            }
        },
        {
            key: "addPointAnnotation",
            value: function(t) {
                var e = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : void 0, a = this;
                i && (a = i), a.annotations.addPointAnnotationExternal(t, e, a);
            }
        },
        {
            key: "clearAnnotations",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : void 0, e = this;
                t && (e = t), e.annotations.clearAnnotations(e);
            }
        },
        {
            key: "removeAnnotation",
            value: function(t) {
                var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0, i = this;
                e && (i = e), i.annotations.removeAnnotation(i, t);
            }
        },
        {
            key: "getChartArea",
            value: function() {
                return this.w.globals.dom.baseEl.querySelector(".apexcharts-inner");
            }
        },
        {
            key: "getSeriesTotalXRange",
            value: function(t, e) {
                return this.coreUtils.getSeriesTotalsXRange(t, e);
            }
        },
        {
            key: "getHighestValueInSeries",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, e = new $b705b473d3ec9641$var$U(this.ctx);
                return e.getMinYMaxY(t).highestY;
            }
        },
        {
            key: "getLowestValueInSeries",
            value: function() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, e = new $b705b473d3ec9641$var$U(this.ctx);
                return e.getMinYMaxY(t).lowestY;
            }
        },
        {
            key: "getSeriesTotal",
            value: function() {
                return this.w.globals.seriesTotals;
            }
        },
        {
            key: "toggleDataPointSelection",
            value: function(t, e) {
                return this.updateHelpers.toggleDataPointSelection(t, e);
            }
        },
        {
            key: "zoomX",
            value: function(t, e) {
                this.ctx.toolbar.zoomUpdateOptions(t, e);
            }
        },
        {
            key: "setLocale",
            value: function(t) {
                this.localization.setCurrentLocaleValues(t);
            }
        },
        {
            key: "dataURI",
            value: function(t) {
                return new $b705b473d3ec9641$var$V(this.ctx).dataURI(t);
            }
        },
        {
            key: "paper",
            value: function() {
                return this.w.globals.dom.Paper;
            }
        },
        {
            key: "_parentResizeCallback",
            value: function() {
                this.w.globals.animationEnded && this.w.config.chart.redrawOnParentResize && this._windowResize();
            }
        },
        {
            key: "_windowResize",
            value: function() {
                var t = this;
                clearTimeout(this.w.globals.resizeTimer), this.w.globals.resizeTimer = window.setTimeout(function() {
                    t.w.globals.resized = !0, t.w.globals.dataChanged = !1, t.ctx.update();
                }, 150);
            }
        },
        {
            key: "_windowResizeHandler",
            value: function() {
                var t = this.w.config.chart.redrawOnWindowResize;
                "function" == typeof t && (t = t()), t && this._windowResize();
            }
        }
    ], [
        {
            key: "getChartByID",
            value: function(t) {
                var e = $b705b473d3ec9641$var$p.escapeString(t), i = Apex._chartInstances.filter(function(t) {
                    return t.id === e;
                })[0];
                return i && i.chart;
            }
        },
        {
            key: "initOnLoad",
            value: function() {
                for(var e = document.querySelectorAll("[data-apexcharts]"), i = 0; i < e.length; i++)new t(e[i], JSON.parse(e[i].getAttribute("data-options"))).render();
            }
        },
        {
            key: "exec",
            value: function(t, e) {
                var i = this.getChartByID(t);
                if (i) {
                    i.w.globals.isExecCalled = !0;
                    var a = null;
                    if (-1 !== i.publicMethods.indexOf(e)) {
                        for(var s = arguments.length, r = new Array(s > 2 ? s - 2 : 0), o = 2; o < s; o++)r[o - 2] = arguments[o];
                        a = i[e].apply(i, r);
                    }
                    return a;
                }
            }
        },
        {
            key: "merge",
            value: function(t, e) {
                return $b705b473d3ec9641$var$p.extend(t, e);
            }
        }
    ]), t;
}();
module.exports = $b705b473d3ec9641$var$Ht;

});


parcelRegister("bGkwn", function(module, exports) {

$parcel$export(module.exports, "getChartDataIndexes", () => $88138910352f8ef0$export$617f64f483048c50);
$parcel$export(module.exports, "getChartTotals", () => $88138910352f8ef0$export$eb5d248e814fd308);
$parcel$export(module.exports, "getOverviewGraphData", () => $88138910352f8ef0$export$afe7aea2dfbd979f);
$parcel$export(module.exports, "chartModes", () => $88138910352f8ef0$export$f6baab38465cf543);
$parcel$export(module.exports, "getOverviewGraphProps", () => $88138910352f8ef0$export$91c109bd4aa3b83d);
$parcel$export(module.exports, "getOverviewChartTableParams", () => $88138910352f8ef0$export$3fe91dbac6b32dcb);
$parcel$export(module.exports, "calculateChartData", () => $88138910352f8ef0$export$28d811830c2037b3);

var $g3CkB = parcelRequire("g3CkB");

var $cstaF = parcelRequire("cstaF");

var $htzEo = parcelRequire("htzEo");
const $88138910352f8ef0$var$getCountMonthsToPreviousQuarter = (date)=>{
    const monthOfYear = new Date(date).getMonth() + 1;
    return monthOfYear % 3 || 3;
};
const $88138910352f8ef0$export$617f64f483048c50 = ({ chartData: chartData, timePeriod: timePeriod })=>{
    let lastPeriodStart, lastPeriodFinish, prevPeriodStart, prevPeriodFinish;
    if (!chartData || chartData?.length === 0 || !timePeriod) return null;
    const indexLastItem = chartData.length - 1;
    lastPeriodFinish = indexLastItem;
    const dateLastItem = new Date(chartData[indexLastItem].month);
    const currentMonthIndex = dateLastItem.getMonth();
    switch(timePeriod){
        case (0, $cstaF.TimePeriods).MTD:
            lastPeriodStart = lastPeriodFinish;
            prevPeriodFinish = lastPeriodStart - 1;
            prevPeriodStart = prevPeriodFinish;
            break;
        case (0, $cstaF.TimePeriods).QTD:
            const countMonthsToPreviousQuarter = $88138910352f8ef0$var$getCountMonthsToPreviousQuarter(dateLastItem);
            prevPeriodFinish = lastPeriodFinish - countMonthsToPreviousQuarter;
            prevPeriodStart = prevPeriodFinish - 2;
            lastPeriodStart = prevPeriodStart + 3;
            break;
        case (0, $cstaF.TimePeriods).YTD:
            lastPeriodStart = lastPeriodFinish - currentMonthIndex;
            prevPeriodStart = lastPeriodStart - 12;
            prevPeriodFinish = prevPeriodStart + currentMonthIndex;
            break;
        case (0, $cstaF.TimePeriods)[(0, $cstaF.agentProductionTerms).lastMonth]:
            lastPeriodFinish = indexLastItem - 1;
            lastPeriodStart = lastPeriodFinish;
            prevPeriodStart = lastPeriodStart - 1;
            prevPeriodFinish = prevPeriodStart;
            break;
        case (0, $cstaF.TimePeriods)[(0, $cstaF.agentProductionTerms).last6Months]:
            lastPeriodStart = lastPeriodFinish - 5;
            prevPeriodStart = lastPeriodStart - 6;
            prevPeriodFinish = prevPeriodStart + 5;
            break;
        case (0, $cstaF.TimePeriods)[(0, $cstaF.agentProductionTerms).last12Months]:
            lastPeriodStart = lastPeriodFinish - 11;
            prevPeriodFinish = lastPeriodStart - 1;
            prevPeriodStart = prevPeriodFinish - 11;
            break;
        case (0, $cstaF.TimePeriods)[(0, $cstaF.agentProductionTerms).last24Months]:
            lastPeriodStart = 0;
            break;
    }
    return {
        lastPeriodStart: lastPeriodStart,
        lastPeriodFinish: lastPeriodFinish,
        prevPeriodStart: prevPeriodStart,
        prevPeriodFinish: prevPeriodFinish
    };
};
const $88138910352f8ef0$export$5be842cdea571620 = (prev, current)=>prev + current.totalVolume;
const $88138910352f8ef0$export$28df90d94ad5e0fd = (prev, current)=>prev + current.totalUnits;
const $88138910352f8ef0$export$eb5d248e814fd308 = ({ chartData: chartData, dataIndexes: dataIndexes, getSumTotal: getSumTotal })=>{
    const totalLastPeriod = chartData?.slice(dataIndexes.lastPeriodStart, dataIndexes.lastPeriodFinish + 1).reduce(getSumTotal, 0);
    const totalPrevPeriod = chartData?.slice(dataIndexes.prevPeriodStart, dataIndexes.prevPeriodFinish + 1).reduce(getSumTotal, 0);
    const amountChange = totalLastPeriod - totalPrevPeriod;
    const percentChange = amountChange / totalPrevPeriod * 100;
    return {
        totalLastPeriod: totalLastPeriod,
        totalPrevPeriod: totalPrevPeriod,
        amountChange: amountChange,
        percentChange: percentChange
    };
};
const $88138910352f8ef0$export$afe7aea2dfbd979f = ({ chartData: chartData, dataIndexes: dataIndexes, listMapper: listMapper, sellMapper: sellMapper })=>{
    let xAxisLabels, listSideSoldValues, sellSideSoldValues, formattedData;
    const dataToMap = chartData?.slice(dataIndexes.lastPeriodStart, dataIndexes.lastPeriodFinish + 1);
    xAxisLabels = dataToMap?.map((d)=>(0, $g3CkB.OverviewGraphLabelMaker).getLabelDate(d));
    listSideSoldValues = dataToMap?.map(listMapper);
    sellSideSoldValues = dataToMap?.map(sellMapper);
    formattedData = dataToMap?.map((d)=>d);
    return {
        xAxisLabels: xAxisLabels,
        listSideSoldValues: listSideSoldValues,
        sellSideSoldValues: sellSideSoldValues,
        formattedData: formattedData
    };
};
const $88138910352f8ef0$export$f6baab38465cf543 = Object.freeze({
    VOLUME: "volume",
    UNITS: "units"
});
const $88138910352f8ef0$export$91c109bd4aa3b83d = (props)=>{
    const { graphMode: graphMode, chartData: chartData, timePeriod: timePeriod, dataIndexes: dataIndexes, widthPixelsOutsideGraph: widthPixelsOutsideGraph } = props;
    let dataPointFormatter, yAxisTitle, yAxisFormatter, listMapper, sellMapper, countYAxisTicks;
    if (graphMode === $88138910352f8ef0$export$f6baab38465cf543.VOLUME) {
        dataPointFormatter = (0, $htzEo.getCurrencyFormat);
        yAxisTitle = (0, $cstaF.agentProductionTerms).dollarsInMillions;
        yAxisFormatter = (value)=>(0, $htzEo.getFullNumbers)(value / 1000000);
        listMapper = (d)=>d.listVolume;
        sellMapper = (d)=>d.sellVolume;
        countYAxisTicks = 16;
    } else if (graphMode === $88138910352f8ef0$export$f6baab38465cf543.UNITS) {
        dataPointFormatter = (0, $htzEo.getFullNumbers);
        yAxisTitle = (0, $cstaF.agentProductionTerms).numberUnits;
        yAxisFormatter = (0, $htzEo.getFullNumbers);
        listMapper = (d)=>d.listUnits;
        sellMapper = (d)=>d.sellUnits;
        countYAxisTicks = 12;
    }
    return {
        chartData: chartData || [],
        timePeriod: timePeriod,
        dataIndexes: dataIndexes,
        dataPointFormatter: dataPointFormatter,
        yAxisFormatter: yAxisFormatter,
        yAxisTitle: yAxisTitle,
        listMapper: listMapper,
        sellMapper: sellMapper,
        countYAxisTicks: countYAxisTicks,
        widthPixelsOutsideGraph: widthPixelsOutsideGraph,
        graphMode: graphMode
    };
};
const $88138910352f8ef0$export$3fe91dbac6b32dcb = (chartMode)=>{
    let labelTotal, getSumTotal, getFormattedAmount, labelAmountChange;
    if (chartMode === $88138910352f8ef0$export$f6baab38465cf543.VOLUME) {
        getSumTotal = $88138910352f8ef0$export$5be842cdea571620;
        labelTotal = (0, $cstaF.agentProductionTerms).totalVolume;
        getFormattedAmount = (0, $htzEo.getCurrencyFormat);
        labelAmountChange = (0, $cstaF.agentProductionTerms).dollarChange;
    } else if (chartMode === $88138910352f8ef0$export$f6baab38465cf543.UNITS) {
        getSumTotal = $88138910352f8ef0$export$28df90d94ad5e0fd;
        labelTotal = (0, $cstaF.agentProductionTerms).totalUnits;
        getFormattedAmount = (value)=>value;
        labelAmountChange = (0, $cstaF.agentProductionTerms).unitsChange;
    }
    return {
        getSumTotal: getSumTotal,
        labelTotal: labelTotal,
        getFormattedAmount: getFormattedAmount,
        labelAmountChange: labelAmountChange
    };
};
const $88138910352f8ef0$export$28d811830c2037b3 = (data)=>{
    if (!data?.monthlyProductions) return [];
    return [
        ...data?.monthlyProductions
    ].sort((a, b)=>a.month > b.month ? 1 : -1);
};

});


parcelRegister("awF4Z", function(module, exports) {

$parcel$export(module.exports, "OverviewChartTable", () => $7a9cc20f34605613$export$d168a49bca558330);

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("7hEbZ");
var $iDoBR = parcelRequire("iDoBR");
var $7hEbZ = parcelRequire("7hEbZ");

var $htzEo = parcelRequire("htzEo");

var $g3CkB = parcelRequire("g3CkB");

var $cstaF = parcelRequire("cstaF");
const $7a9cc20f34605613$export$d168a49bca558330 = ({ totals: totals, timePeriod: timePeriod, chartData: chartData, dataIndexes: dataIndexes, labelTotal: labelTotal, getFormattedAmount: getFormattedAmount, labelAmountChange: labelAmountChange })=>{
    if (!totals) return null;
    const labels = (0, $g3CkB.getOverviewChartTableLabels)({
        timePeriod: timePeriod,
        chartData: chartData,
        dataIndexes: dataIndexes
    });
    const amountTrendArrow = (0, $g3CkB.getTrendArrow)(totals.amountChange);
    const pctChangeTrendArrow = isNaN(totals.percentChange) ? null : (0, $g3CkB.getTrendArrow)(totals.percentChange);
    const lastPeriod = getFormattedAmount(totals.totalLastPeriod);
    const prevPeriod = getFormattedAmount(totals.totalPrevPeriod);
    const amountChange = getFormattedAmount(totals.amountChange);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($iDoBR))), {
            dataLwtId: "overview-chart-card",
            type: "group",
            className: "text-center border rounded mt-3",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h6", {
                    className: "text-center w-100 p bold py-2 mb-0 card-header border-0",
                    children: labelTotal
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7hEbZ.default), {
                    dataLwtId: "overview-chart-table-last-period",
                    body: true,
                    className: "border-0 pt-2",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "mb-0 text-nowrap mb-0 bold dot-dot-dot",
                            title: lastPeriod,
                            children: lastPeriod
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "small text-muted dot-dot-dot",
                            children: [
                                labels.labelLastPeriod,
                                " (",
                                labels.dateRangeLast,
                                ")"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7hEbZ.default), {
                    dataLwtId: "overview-chart-table-prev-period",
                    body: true,
                    className: "border-0 pt-2",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "mb-0 text-nowrap mb-0 bold dot-dot-dot",
                            title: prevPeriod,
                            children: prevPeriod
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "small text-muted dot-dot-dot",
                            children: [
                                labels.labelPrevPeriod,
                                " (",
                                labels.dateRangePrev,
                                ")"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7hEbZ.default), {
                    dataLwtId: "overview-chart-table-amt-change",
                    body: true,
                    className: "border-0 pt-2",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            className: "mb-0 text-nowrap mb-0 bold dot-dot-dot",
                            title: amountChange,
                            children: [
                                amountChange,
                                amountTrendArrow
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "small text-muted",
                            children: labelAmountChange
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $7hEbZ.default), {
                    dataLwtId: "overview-chart-table-pct-change",
                    body: true,
                    className: "border-0 pt-2",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            className: "mb-0 text-nowrap mb-0 bold dot-dot-dot",
                            children: [
                                (0, $htzEo.percentChangeFormatter)(totals.percentChange),
                                pctChangeTrendArrow
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "small text-muted",
                            children: (0, $cstaF.agentProductionTerms).pctChange
                        })
                    ]
                })
            ]
        })
    });
};

});



parcelRegister("iDZyd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CSVLink = module.exports.CSVDownload = undefined;

var $4PsY7 = parcelRequire("4PsY7");
var $d92b9d369506fb2d$var$_Download2 = $d92b9d369506fb2d$var$_interopRequireDefault($4PsY7);

var $hitSI = parcelRequire("hitSI");
var $d92b9d369506fb2d$var$_Link2 = $d92b9d369506fb2d$var$_interopRequireDefault($hitSI);
function $d92b9d369506fb2d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $d92b9d369506fb2d$var$CSVDownload = module.exports.CSVDownload = $d92b9d369506fb2d$var$_Download2.default;
var $d92b9d369506fb2d$var$CSVLink = module.exports.CSVLink = $d92b9d369506fb2d$var$_Link2.default;

});
parcelRegister("4PsY7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $3842656c6218d15c$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $3842656c6218d15c$var$_react2 = $3842656c6218d15c$var$_interopRequireDefault($acw62);

var $j9xoe = parcelRequire("j9xoe");

var $aHb3j = parcelRequire("aHb3j");
function $3842656c6218d15c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3842656c6218d15c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3842656c6218d15c$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $3842656c6218d15c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $3842656c6218d15c$var$defaultProps = {
    target: "_blank"
};
var $3842656c6218d15c$var$CSVDownload = function(_React$Component) {
    $3842656c6218d15c$var$_inherits(CSVDownload, _React$Component);
    function CSVDownload(props) {
        $3842656c6218d15c$var$_classCallCheck(this, CSVDownload);
        var _this = $3842656c6218d15c$var$_possibleConstructorReturn(this, (CSVDownload.__proto__ || Object.getPrototypeOf(CSVDownload)).call(this, props));
        _this.state = {};
        return _this;
    }
    $3842656c6218d15c$var$_createClass(CSVDownload, [
        {
            key: "buildURI",
            value: function buildURI() {
                return $j9xoe.buildURI.apply(undefined, arguments);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _props = this.props, data = _props.data, headers = _props.headers, separator = _props.separator, enclosingCharacter = _props.enclosingCharacter, uFEFF = _props.uFEFF, target = _props.target, specs = _props.specs, replace = _props.replace;
                this.state.page = window.open(this.buildURI(data, uFEFF, headers, separator, enclosingCharacter), target, specs, replace);
            }
        },
        {
            key: "getWindow",
            value: function getWindow() {
                return this.state.page;
            }
        },
        {
            key: "render",
            value: function render() {
                return null;
            }
        }
    ]);
    return CSVDownload;
}($3842656c6218d15c$var$_react2.default.Component);
$3842656c6218d15c$var$CSVDownload.defaultProps = Object.assign($aHb3j.defaultProps, $3842656c6218d15c$var$defaultProps);
$3842656c6218d15c$var$CSVDownload.propTypes = $aHb3j.propTypes;
module.exports.default = $3842656c6218d15c$var$CSVDownload;

});
parcelRegister("j9xoe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $df18c21dfc7573c5$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $df18c21dfc7573c5$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
var $df18c21dfc7573c5$var$isSafari = module.exports.isSafari = function isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
};
var $df18c21dfc7573c5$var$isJsons = module.exports.isJsons = function isJsons(array) {
    return Array.isArray(array) && array.every(function(row) {
        return (typeof row === "undefined" ? "undefined" : $df18c21dfc7573c5$var$_typeof(row)) === "object" && !(row instanceof Array);
    });
};
var $df18c21dfc7573c5$var$isArrays = module.exports.isArrays = function isArrays(array) {
    return Array.isArray(array) && array.every(function(row) {
        return Array.isArray(row);
    });
};
var $df18c21dfc7573c5$var$jsonsHeaders = module.exports.jsonsHeaders = function jsonsHeaders(array) {
    return Array.from(array.map(function(json) {
        return Object.keys(json);
    }).reduce(function(a, b) {
        return new Set([].concat($df18c21dfc7573c5$var$_toConsumableArray(a), $df18c21dfc7573c5$var$_toConsumableArray(b)));
    }, []));
};
var $df18c21dfc7573c5$var$jsons2arrays = module.exports.jsons2arrays = function jsons2arrays(jsons, headers) {
    headers = headers || $df18c21dfc7573c5$var$jsonsHeaders(jsons);
    var headerLabels = headers;
    var headerKeys = headers;
    if ($df18c21dfc7573c5$var$isJsons(headers)) {
        headerLabels = headers.map(function(header) {
            return header.label;
        });
        headerKeys = headers.map(function(header) {
            return header.key;
        });
    }
    var data = jsons.map(function(object) {
        return headerKeys.map(function(header) {
            return $df18c21dfc7573c5$var$getHeaderValue(header, object);
        });
    });
    return [
        headerLabels
    ].concat($df18c21dfc7573c5$var$_toConsumableArray(data));
};
var $df18c21dfc7573c5$var$getHeaderValue = module.exports.getHeaderValue = function getHeaderValue(property, obj) {
    var foundValue = property.replace(/\[([^\]]+)]/g, ".$1").split(".").reduce(function(o, p, i, arr) {
        var value = o[p];
        if (value === undefined || value === null) arr.splice(1);
        else return value;
    }, obj);
    return foundValue === undefined ? property in obj ? obj[property] : "" : foundValue;
};
var $df18c21dfc7573c5$var$elementOrEmpty = module.exports.elementOrEmpty = function elementOrEmpty(element) {
    return typeof element === "undefined" || element === null ? "" : element;
};
var $df18c21dfc7573c5$var$joiner = module.exports.joiner = function joiner(data) {
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ",";
    var enclosingCharacter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '"';
    return data.filter(function(e) {
        return e;
    }).map(function(row) {
        return row.map(function(element) {
            return $df18c21dfc7573c5$var$elementOrEmpty(element);
        }).map(function(column) {
            return "" + enclosingCharacter + column + enclosingCharacter;
        }).join(separator);
    }).join("\n");
};
var $df18c21dfc7573c5$var$arrays2csv = module.exports.arrays2csv = function arrays2csv(data, headers, separator, enclosingCharacter) {
    return $df18c21dfc7573c5$var$joiner(headers ? [
        headers
    ].concat($df18c21dfc7573c5$var$_toConsumableArray(data)) : data, separator, enclosingCharacter);
};
var $df18c21dfc7573c5$var$jsons2csv = module.exports.jsons2csv = function jsons2csv(data, headers, separator, enclosingCharacter) {
    return $df18c21dfc7573c5$var$joiner($df18c21dfc7573c5$var$jsons2arrays(data, headers), separator, enclosingCharacter);
};
var $df18c21dfc7573c5$var$string2csv = module.exports.string2csv = function string2csv(data, headers, separator, enclosingCharacter) {
    return headers ? headers.join(separator) + "\n" + data : data.replace(/"/g, '""');
};
var $df18c21dfc7573c5$var$toCSV = module.exports.toCSV = function toCSV(data, headers, separator, enclosingCharacter) {
    if ($df18c21dfc7573c5$var$isJsons(data)) return $df18c21dfc7573c5$var$jsons2csv(data, headers, separator, enclosingCharacter);
    if ($df18c21dfc7573c5$var$isArrays(data)) return $df18c21dfc7573c5$var$arrays2csv(data, headers, separator, enclosingCharacter);
    if (typeof data === "string") return $df18c21dfc7573c5$var$string2csv(data, headers, separator);
    throw new TypeError('Data should be a "String", "Array of arrays" OR "Array of objects" ');
};
var $df18c21dfc7573c5$var$buildURI = module.exports.buildURI = function buildURI(data, uFEFF, headers, separator, enclosingCharacter) {
    var csv = $df18c21dfc7573c5$var$toCSV(data, headers, separator, enclosingCharacter);
    var type = $df18c21dfc7573c5$var$isSafari() ? "application/csv" : "text/csv";
    var blob = new Blob([
        uFEFF ? "\uFEFF" : "",
        csv
    ], {
        type: type
    });
    var dataURI = "data:" + type + ";charset=utf-8," + (uFEFF ? "\uFEFF" : "") + csv;
    var URL = window.URL || window.webkitURL;
    return typeof URL.createObjectURL === "undefined" ? dataURI : URL.createObjectURL(blob);
};

});

parcelRegister("aHb3j", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PropsNotForwarded = module.exports.defaultProps = module.exports.propTypes = undefined;

var $acw62 = parcelRequire("acw62");
var $7c967e561d3c5435$var$_react2 = $7c967e561d3c5435$var$_interopRequireDefault($acw62);

var $c9Z8w = parcelRequire("c9Z8w");
function $7c967e561d3c5435$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $7c967e561d3c5435$var$propTypes = module.exports.propTypes = {
    data: (0, $c9Z8w.oneOfType)([
        $c9Z8w.string,
        $c9Z8w.array,
        $c9Z8w.func
    ]).isRequired,
    headers: $c9Z8w.array,
    target: $c9Z8w.string,
    separator: $c9Z8w.string,
    filename: $c9Z8w.string,
    uFEFF: $c9Z8w.bool,
    onClick: $c9Z8w.func,
    asyncOnClick: $c9Z8w.bool,
    enclosingCharacter: $c9Z8w.string
};
var $7c967e561d3c5435$var$defaultProps = module.exports.defaultProps = {
    separator: ",",
    filename: "generatedBy_react-csv.csv",
    uFEFF: true,
    asyncOnClick: false,
    enclosingCharacter: '"'
};
var $7c967e561d3c5435$var$PropsNotForwarded = module.exports.PropsNotForwarded = [
    "data",
    "headers"
];

});


parcelRegister("hitSI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $c97b4bf8bada9b7e$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $c97b4bf8bada9b7e$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $acw62 = parcelRequire("acw62");
var $c97b4bf8bada9b7e$var$_react2 = $c97b4bf8bada9b7e$var$_interopRequireDefault($acw62);

var $j9xoe = parcelRequire("j9xoe");

var $aHb3j = parcelRequire("aHb3j");
function $c97b4bf8bada9b7e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c97b4bf8bada9b7e$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $c97b4bf8bada9b7e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c97b4bf8bada9b7e$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $c97b4bf8bada9b7e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $c97b4bf8bada9b7e$var$CSVLink = function(_React$Component) {
    $c97b4bf8bada9b7e$var$_inherits(CSVLink, _React$Component);
    function CSVLink(props) {
        $c97b4bf8bada9b7e$var$_classCallCheck(this, CSVLink);
        var _this = $c97b4bf8bada9b7e$var$_possibleConstructorReturn(this, (CSVLink.__proto__ || Object.getPrototypeOf(CSVLink)).call(this, props));
        _this.buildURI = _this.buildURI.bind(_this);
        return _this;
    }
    $c97b4bf8bada9b7e$var$_createClass(CSVLink, [
        {
            key: "buildURI",
            value: function buildURI() {
                return $j9xoe.buildURI.apply(undefined, arguments);
            }
        },
        {
            key: "handleLegacy",
            value: function handleLegacy(event) {
                var isAsync = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
                if (window.navigator.msSaveOrOpenBlob) {
                    event.preventDefault();
                    var _props = this.props, data = _props.data, headers = _props.headers, separator = _props.separator, filename = _props.filename, enclosingCharacter = _props.enclosingCharacter, uFEFF = _props.uFEFF;
                    var csvData = isAsync && typeof data === "function" ? data() : data;
                    var blob = new Blob([
                        uFEFF ? "\uFEFF" : "",
                        (0, $j9xoe.toCSV)(csvData, headers, separator, enclosingCharacter)
                    ]);
                    window.navigator.msSaveBlob(blob, filename);
                    return false;
                }
            }
        },
        {
            key: "handleAsyncClick",
            value: function handleAsyncClick(event) {
                var _this2 = this;
                var done = function done(proceed) {
                    if (proceed === false) {
                        event.preventDefault();
                        return;
                    }
                    _this2.handleLegacy(event, true);
                };
                this.props.onClick(event, done);
            }
        },
        {
            key: "handleSyncClick",
            value: function handleSyncClick(event) {
                var stopEvent = this.props.onClick(event) === false;
                if (stopEvent) {
                    event.preventDefault();
                    return;
                }
                this.handleLegacy(event);
            }
        },
        {
            key: "handleClick",
            value: function handleClick() {
                var _this3 = this;
                return function(event) {
                    if (typeof _this3.props.onClick === "function") return _this3.props.asyncOnClick ? _this3.handleAsyncClick(event) : _this3.handleSyncClick(event);
                    _this3.handleLegacy(event);
                };
            }
        },
        {
            key: "render",
            value: function render() {
                var _this4 = this;
                var _props2 = this.props, data = _props2.data, headers = _props2.headers, separator = _props2.separator, filename = _props2.filename, uFEFF = _props2.uFEFF, children = _props2.children, onClick = _props2.onClick, asyncOnClick = _props2.asyncOnClick, enclosingCharacter = _props2.enclosingCharacter, rest = $c97b4bf8bada9b7e$var$_objectWithoutProperties(_props2, [
                    "data",
                    "headers",
                    "separator",
                    "filename",
                    "uFEFF",
                    "children",
                    "onClick",
                    "asyncOnClick",
                    "enclosingCharacter"
                ]);
                var isNodeEnvironment = typeof window === "undefined";
                var href = isNodeEnvironment ? "" : this.buildURI(data, uFEFF, headers, separator, enclosingCharacter);
                return $c97b4bf8bada9b7e$var$_react2.default.createElement("a", $c97b4bf8bada9b7e$var$_extends({
                    download: filename
                }, rest, {
                    ref: function ref(link) {
                        return _this4.link = link;
                    },
                    target: "_self",
                    href: href,
                    onClick: this.handleClick()
                }), children);
            }
        }
    ]);
    return CSVLink;
}($c97b4bf8bada9b7e$var$_react2.default.Component);
$c97b4bf8bada9b7e$var$CSVLink.defaultProps = $aHb3j.defaultProps;
$c97b4bf8bada9b7e$var$CSVLink.propTypes = $aHb3j.propTypes;
module.exports.default = $c97b4bf8bada9b7e$var$CSVLink;

});


parcelRegister("kTdhz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $f3533f4e1617466f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "CardContainer", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("b8s22")))));
$parcel$export(module.exports, "CardLink", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("c1qWV")))));

var $13RYN = parcelRequire("13RYN");

var $b8s22 = parcelRequire("b8s22");

var $c1qWV = parcelRequire("c1qWV");
var $f3533f4e1617466f$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($13RYN)));

});
parcelRegister("13RYN", function(module, exports) {
"use strict";
var $0c5ff176cee39f53$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $0c5ff176cee39f53$var$react_1 = $0c5ff176cee39f53$var$__importDefault((parcelRequire("acw62")));

const $0c5ff176cee39f53$var$classnames_1 = $0c5ff176cee39f53$var$__importDefault((parcelRequire("8g1PZ")));

var $jNrfC = parcelRequire("jNrfC");
var $f0QE7 = parcelRequire("f0QE7");
var $2kvLT = parcelRequire("2kvLT");
var $dzhiy = parcelRequire("dzhiy");
var $kTCAc = parcelRequire("kTCAc");
var $8dIk9 = parcelRequire("8dIk9");
var $jGcDw = parcelRequire("jGcDw");
var $6965A = parcelRequire("6965A");
const $0c5ff176cee39f53$var$Card = (props)=>{
    const { className: className, inverse: inverse, color: color, rounded: rounded, raised: raised, isSelected: isSelected, headerProps: headerProps, footerProps: footerProps, imgProps: imgProps, bodyProps: bodyProps, imgOverlayProps: imgOverlayProps, children: children, dataLwtId: dataLwtId, ...restProps } = props;
    const classes = (0, $0c5ff176cee39f53$var$classnames_1.default)(isSelected ? "selected" : false, inverse ? "text-white" : false, raised ? "card-raised" : false, rounded ? "rounded" : false, color ? `bg-${color}` : false, className);
    // suppressing the unknown prop warning that occurs when trying to pass in the
    //  'dataLwtId' into the `CardBody` component.
    //  If more warnings occur, we may need to extend this solution to other components
    let bodyDataLwtId;
    if (bodyProps) {
        bodyDataLwtId = bodyProps.dataLwtId;
        delete bodyProps.dataLwtId;
    }
    return $0c5ff176cee39f53$var$react_1.default.createElement($jNrfC.default, {
        className: classes,
        "data-lwt-id": dataLwtId,
        ...restProps
    }, headerProps && $0c5ff176cee39f53$var$react_1.default.createElement($dzhiy.default, {
        "data-lwt-id": headerProps.dataLwtId,
        ...headerProps
    }, headerProps.children), imgProps && imgProps.top && $0c5ff176cee39f53$var$react_1.default.createElement($kTCAc.default, {
        "data-lwt-id": imgProps.dataLwtId,
        ...imgProps
    }), bodyProps && $0c5ff176cee39f53$var$react_1.default.createElement($0c5ff176cee39f53$var$react_1.default.Fragment, null, $0c5ff176cee39f53$var$react_1.default.createElement($f0QE7.default, {
        "data-lwt-id": bodyDataLwtId,
        ...bodyProps
    }, bodyProps.title && $0c5ff176cee39f53$var$react_1.default.createElement($6965A.default, {
        "data-lwt-id": bodyProps.title.dataLwtId,
        ...bodyProps.title
    }, bodyProps.title), bodyProps.subtitle && $0c5ff176cee39f53$var$react_1.default.createElement($jGcDw.default, {
        "data-lwt-id": bodyProps.subtitle.dataLwtId,
        ...bodyProps.subtitle
    }, bodyProps.subtitle), !bodyProps.noIndentOnChildren && $0c5ff176cee39f53$var$react_1.default.createElement($0c5ff176cee39f53$var$react_1.default.Fragment, null, bodyProps.children, children)), bodyProps.noIndentOnChildren && $0c5ff176cee39f53$var$react_1.default.createElement($0c5ff176cee39f53$var$react_1.default.Fragment, null, bodyProps.children, children)), !bodyProps && children, imgProps && imgProps.bottom && $0c5ff176cee39f53$var$react_1.default.createElement($kTCAc.default, {
        "data-lwt-id": imgProps.dataLwtId,
        ...imgProps
    }), footerProps && $0c5ff176cee39f53$var$react_1.default.createElement($2kvLT.default, {
        "data-lwt-id": footerProps.dataLwtId,
        ...footerProps
    }, footerProps.children), imgOverlayProps && $0c5ff176cee39f53$var$react_1.default.createElement($8dIk9.default, {
        "data-lwt-id": imgOverlayProps.dataLwtId,
        ...imgOverlayProps
    }, imgOverlayProps.title && $0c5ff176cee39f53$var$react_1.default.createElement($6965A.default, {
        "data-lwt-id": imgOverlayProps.title.dataLwtId,
        ...imgOverlayProps.title
    }, imgOverlayProps.title), imgOverlayProps.subtitle && $0c5ff176cee39f53$var$react_1.default.createElement($jGcDw.default, {
        "data-lwt-id": imgOverlayProps.subtitle.dataLwtId,
        ...imgOverlayProps.subtitle
    }, imgOverlayProps.subtitle), imgOverlayProps.children));
};
module.exports.default = $0c5ff176cee39f53$var$Card;

});

parcelRegister("b8s22", function(module, exports) {
"use strict";
var $81b62f997228f12a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $81b62f997228f12a$var$react_1 = $81b62f997228f12a$var$__importDefault((parcelRequire("acw62")));

var $l3UGE = parcelRequire("l3UGE");
var $2Z9ZS = parcelRequire("2Z9ZS");
var $1z99I = parcelRequire("1z99I");
const $81b62f997228f12a$var$CardContainer = (props)=>{
    const { type: //
    type, cardGroupProps: cardGroupProps, cardDeckProps: cardDeckProps, cardColumnProps: cardColumnProps, children: children, className: className, dataLwtId: dataLwtId } = props;
    switch(type){
        case "columns":
            return $81b62f997228f12a$var$react_1.default.createElement($l3UGE.default, {
                className: className,
                "data-lwt-id": dataLwtId,
                ...cardColumnProps
            }, children);
        case "deck":
            return $81b62f997228f12a$var$react_1.default.createElement($2Z9ZS.default, {
                className: className,
                "data-lwt-id": dataLwtId,
                ...cardDeckProps
            }, children);
        case "group":
            return $81b62f997228f12a$var$react_1.default.createElement($1z99I.default, {
                className: className,
                "data-lwt-id": dataLwtId,
                ...cardGroupProps
            }, children);
        default:
            return $81b62f997228f12a$var$react_1.default.createElement("div", {
                "data-lwt-id": dataLwtId
            }, children);
    }
};
module.exports.default = $81b62f997228f12a$var$CardContainer;

});

parcelRegister("c1qWV", function(module, exports) {
"use strict";
var $8c0a7b9fc9019f7a$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

const $8c0a7b9fc9019f7a$var$react_1 = $8c0a7b9fc9019f7a$var$__importDefault((parcelRequire("acw62")));

var $3pVem = parcelRequire("3pVem");
const $8c0a7b9fc9019f7a$var$CardLink = (props)=>{
    return $8c0a7b9fc9019f7a$var$react_1.default.createElement($3pVem.default, {
        "data-lwt-id": props.dataLwtId,
        ...props
    });
};
module.exports.default = $8c0a7b9fc9019f7a$var$CardLink;

});



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $4fGPb = parcelRequire("4fGPb");
var $kfZjc = parcelRequire("kfZjc");

var $2z9GT = parcelRequire("2z9GT");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $kfZjc = parcelRequire("kfZjc");

var $2z9GT = parcelRequire("2z9GT");
var $7cfebb07fea135c2$exports = {};
"use strict";
var $7cfebb07fea135c2$var$__createBinding = $7cfebb07fea135c2$exports && $7cfebb07fea135c2$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $7cfebb07fea135c2$var$__setModuleDefault = $7cfebb07fea135c2$exports && $7cfebb07fea135c2$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $7cfebb07fea135c2$var$__importStar = $7cfebb07fea135c2$exports && $7cfebb07fea135c2$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $7cfebb07fea135c2$var$__createBinding(result, mod, k);
    }
    $7cfebb07fea135c2$var$__setModuleDefault(result, mod);
    return result;
};
var $7cfebb07fea135c2$var$__importDefault = $7cfebb07fea135c2$exports && $7cfebb07fea135c2$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($7cfebb07fea135c2$exports, "__esModule", {
    value: true
});

const $7cfebb07fea135c2$var$react_1 = $7cfebb07fea135c2$var$__importStar((parcelRequire("acw62")));

const $7cfebb07fea135c2$var$classnames_1 = $7cfebb07fea135c2$var$__importDefault((parcelRequire("8g1PZ")));

const $7cfebb07fea135c2$var$Container_1 = $7cfebb07fea135c2$var$__importDefault((parcelRequire("6aFEg")));

const $7cfebb07fea135c2$var$breadcrumb_1 = $7cfebb07fea135c2$var$__importDefault((parcelRequire("41wKJ")));

const $7cfebb07fea135c2$var$side_menu_1 = $7cfebb07fea135c2$var$__importDefault((parcelRequire("6OSul")));

const $7cfebb07fea135c2$var$footer_1 = $7cfebb07fea135c2$var$__importDefault((parcelRequire("9FCZ6")));

const $7cfebb07fea135c2$var$loader_1 = $7cfebb07fea135c2$var$__importDefault((parcelRequire("7tOHe")));

const $7cfebb07fea135c2$var$Navbar = $7cfebb07fea135c2$var$react_1.default.lazy(()=>Promise.resolve().then(function() {
        return (parcelRequire("3XgFA"));
    }).then((res)=>$7cfebb07fea135c2$var$__importStar(res)));
const $7cfebb07fea135c2$var$Page = (props)=>{
    const { showNavbar: showNavbar, navbarProps: navbarProps, showSideMenu: showSideMenu, sideMenuProps: sideMenuProps, showFooter: showFooter, showBreadcrumb: showBreadcrumb, breadcrumbProps: breadcrumbProps, fluid: fluid, hero: hero, white: white, dataLwtId: dataLwtId } = props;
    const layoutClasses = (0, $7cfebb07fea135c2$var$classnames_1.default)(!showSideMenu ? "flex-column" : null, !hero ? "mt-4" : null, fluid && white ? "bg-white" : null, fluid && hero ? "pt-0" : null);
    const isSSR = typeof window === "undefined";
    return $7cfebb07fea135c2$var$react_1.default.createElement("div", {
        className: "component-wrapper",
        "data-lwt-id": dataLwtId
    }, !isSSR && showNavbar && navbarProps && $7cfebb07fea135c2$var$react_1.default.createElement($7cfebb07fea135c2$var$react_1.Suspense, {
        fallback: $7cfebb07fea135c2$var$react_1.default.createElement($7cfebb07fea135c2$var$loader_1.default, null)
    }, $7cfebb07fea135c2$var$react_1.default.createElement($7cfebb07fea135c2$var$Navbar, {
        ...navbarProps
    })), $7cfebb07fea135c2$var$react_1.default.createElement($7cfebb07fea135c2$var$Container_1.default, {
        id: "content-wrapper",
        fluid: fluid,
        className: layoutClasses,
        white: white
    }, showSideMenu && sideMenuProps && $7cfebb07fea135c2$var$react_1.default.createElement($7cfebb07fea135c2$var$side_menu_1.default, {
        ...sideMenuProps
    }), showBreadcrumb && breadcrumbProps && $7cfebb07fea135c2$var$react_1.default.createElement($7cfebb07fea135c2$var$breadcrumb_1.default, {
        ...breadcrumbProps
    }), props.children), showFooter && $7cfebb07fea135c2$var$react_1.default.createElement($7cfebb07fea135c2$var$footer_1.default, null));
};
$7cfebb07fea135c2$exports.default = $7cfebb07fea135c2$var$Page;


var $219bd90e679fe86d$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($7cfebb07fea135c2$exports)));


parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $f61ig = parcelRequire("f61ig");
parcelRequire("amkL4");
var $3QXz5 = parcelRequire("3QXz5");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $kfZjc = parcelRequire("kfZjc");

var $acw62 = parcelRequire("acw62");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $c68f212e045945ca$export$71511d61b312f219(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
typeof SuppressedError === "function" && SuppressedError;



var $acw62 = parcelRequire("acw62");
const $57af67c4e5d036b3$export$9d6bb52e86a5b54b = (_a)=>{
    var { icon: icon, className: className } = _a, rest = (0, $c68f212e045945ca$export$71511d61b312f219)(_a, [
        "icon",
        "className"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, icon(Object.assign({
        className: className
    }, rest)));
};


var $c761e69c8e58189a$exports = {};

$c761e69c8e58189a$exports = (parcelRequire("k27Ff"));



var $1u0KT = parcelRequire("1u0KT");

var $c9Z8w = parcelRequire("c9Z8w");

var $acw62 = parcelRequire("acw62");
var $066b951a13b27288$exports = {};
"use strict";

$066b951a13b27288$exports = (parcelRequire("6ST83"));


function $c58a6a23b79e0f91$var$t(t) {
    return "object" == typeof t && null != t && 1 === t.nodeType;
}
function $c58a6a23b79e0f91$var$e(t, e) {
    return (!e || "hidden" !== t) && "visible" !== t && "clip" !== t;
}
function $c58a6a23b79e0f91$var$n(t, n) {
    if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
        var r = getComputedStyle(t, null);
        return $c58a6a23b79e0f91$var$e(r.overflowY, n) || $c58a6a23b79e0f91$var$e(r.overflowX, n) || function(t) {
            var e = function(t) {
                if (!t.ownerDocument || !t.ownerDocument.defaultView) return null;
                try {
                    return t.ownerDocument.defaultView.frameElement;
                } catch (t) {
                    return null;
                }
            }(t);
            return !!e && (e.clientHeight < t.scrollHeight || e.clientWidth < t.scrollWidth);
        }(t);
    }
    return !1;
}
function $c58a6a23b79e0f91$var$r(t, e, n, r, i, o, l, d) {
    return o < t && l > e || o > t && l < e ? 0 : o <= t && d <= n || l >= e && d >= n ? o - t - r : l > e && d < n || o < t && d > n ? l - e + i : 0;
}
var $c58a6a23b79e0f91$export$2e2bcd8739ae039 = function(e, i) {
    var o = window, l = i.scrollMode, d = i.block, f = i.inline, h = i.boundary, u = i.skipOverflowHiddenElements, s = "function" == typeof h ? h : function(t) {
        return t !== h;
    };
    if (!$c58a6a23b79e0f91$var$t(e)) throw new TypeError("Invalid target");
    for(var a, c, g = document.scrollingElement || document.documentElement, p = [], m = e; $c58a6a23b79e0f91$var$t(m) && s(m);){
        if ((m = null == (c = (a = m).parentElement) ? a.getRootNode().host || null : c) === g) {
            p.push(m);
            break;
        }
        null != m && m === document.body && $c58a6a23b79e0f91$var$n(m) && !$c58a6a23b79e0f91$var$n(document.documentElement) || null != m && $c58a6a23b79e0f91$var$n(m, u) && p.push(m);
    }
    for(var w = o.visualViewport ? o.visualViewport.width : innerWidth, v = o.visualViewport ? o.visualViewport.height : innerHeight, W = window.scrollX || pageXOffset, H = window.scrollY || pageYOffset, b = e.getBoundingClientRect(), y = b.height, E = b.width, M = b.top, V = b.right, x = b.bottom, I = b.left, C = "start" === d || "nearest" === d ? M : "end" === d ? x : M + y / 2, R = "center" === f ? I + E / 2 : "end" === f ? V : I, T = [], k = 0; k < p.length; k++){
        var B = p[k], D = B.getBoundingClientRect(), O = D.height, X = D.width, Y = D.top, L = D.right, S = D.bottom, j = D.left;
        if ("if-needed" === l && M >= 0 && I >= 0 && x <= v && V <= w && M >= Y && x <= S && I >= j && V <= L) return T;
        var N = getComputedStyle(B), q = parseInt(N.borderLeftWidth, 10), z = parseInt(N.borderTopWidth, 10), A = parseInt(N.borderRightWidth, 10), F = parseInt(N.borderBottomWidth, 10), G = 0, J = 0, K = "offsetWidth" in B ? B.offsetWidth - B.clientWidth - q - A : 0, P = "offsetHeight" in B ? B.offsetHeight - B.clientHeight - z - F : 0, Q = "offsetWidth" in B ? 0 === B.offsetWidth ? 0 : X / B.offsetWidth : 0, U = "offsetHeight" in B ? 0 === B.offsetHeight ? 0 : O / B.offsetHeight : 0;
        if (g === B) G = "start" === d ? C : "end" === d ? C - v : "nearest" === d ? $c58a6a23b79e0f91$var$r(H, H + v, v, z, F, H + C, H + C + y, y) : C - v / 2, J = "start" === f ? R : "center" === f ? R - w / 2 : "end" === f ? R - w : $c58a6a23b79e0f91$var$r(W, W + w, w, q, A, W + R, W + R + E, E), G = Math.max(0, G + H), J = Math.max(0, J + W);
        else {
            G = "start" === d ? C - Y - z : "end" === d ? C - S + F + P : "nearest" === d ? $c58a6a23b79e0f91$var$r(Y, S, O, z, F + P, C, C + y, y) : C - (Y + O / 2) + P / 2, J = "start" === f ? R - j - q : "center" === f ? R - (j + X / 2) + K / 2 : "end" === f ? R - L + A + K : $c58a6a23b79e0f91$var$r(j, L, X, q, A + K, R, R + E, E);
            var Z = B.scrollLeft, $ = B.scrollTop;
            C += $ - (G = Math.max(0, Math.min($ + G / U, B.scrollHeight - O / U + P))), R += Z - (J = Math.max(0, Math.min(Z + J / Q, B.scrollWidth - X / Q + K)));
        }
        T.push({
            el: B,
            top: G,
            left: J
        });
    }
    return T;
};


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92
};


let $6260541dc56be833$var$idCounter = 0;
/**
 * Accepts a parameter and returns it if it's a function
 * or a noop function if it's not. This allows us to
 * accept a callback, but not worry about it if it's not
 * passed.
 * @param {Function} cb the callback
 * @return {Function} a function
 */ function $6260541dc56be833$var$cbToCb(cb) {
    return typeof cb === "function" ? cb : $6260541dc56be833$var$noop;
}
function $6260541dc56be833$var$noop() {}
/**
 * Scroll node into view if necessary
 * @param {HTMLElement} node the element that should scroll into view
 * @param {HTMLElement} menuNode the menu element of the component
 */ function $6260541dc56be833$var$scrollIntoView(node, menuNode) {
    if (!node) return;
    const actions = (0, $c58a6a23b79e0f91$export$2e2bcd8739ae039)(node, {
        boundary: menuNode,
        block: "nearest",
        scrollMode: "if-needed"
    });
    actions.forEach((_ref)=>{
        let { el: el, top: top, left: left } = _ref;
        el.scrollTop = top;
        el.scrollLeft = left;
    });
}
/**
 * @param {HTMLElement} parent the parent node
 * @param {HTMLElement} child the child node
 * @param {Window} environment The window context where downshift renders.
 * @return {Boolean} whether the parent is the child or the child is in the parent
 */ function $6260541dc56be833$var$isOrContainsNode(parent, child, environment) {
    const result = parent === child || child instanceof environment.Node && parent.contains && parent.contains(child);
    return result;
}
/**
 * Simple debounce implementation. Will call the given
 * function once after the time given has passed since
 * it was last called.
 * @param {Function} fn the function to call after the time
 * @param {Number} time the time to wait
 * @return {Function} the debounced function
 */ function $6260541dc56be833$var$debounce(fn, time) {
    let timeoutId;
    function cancel() {
        if (timeoutId) clearTimeout(timeoutId);
    }
    function wrapper() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        cancel();
        timeoutId = setTimeout(()=>{
            timeoutId = null;
            fn(...args);
        }, time);
    }
    wrapper.cancel = cancel;
    return wrapper;
}
/**
 * This is intended to be used to compose event handlers.
 * They are executed in order until one of them sets
 * `event.preventDownshiftDefault = true`.
 * @param {...Function} fns the event handler functions
 * @return {Function} the event handler to add to an element
 */ function $6260541dc56be833$var$callAllEventHandlers() {
    for(var _len2 = arguments.length, fns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)fns[_key2] = arguments[_key2];
    return function(event) {
        for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
        return fns.some((fn)=>{
            if (fn) fn(event, ...args);
            return event.preventDownshiftDefault || event.hasOwnProperty("nativeEvent") && event.nativeEvent.preventDownshiftDefault;
        });
    };
}
function $6260541dc56be833$var$handleRefs() {
    for(var _len4 = arguments.length, refs = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)refs[_key4] = arguments[_key4];
    return (node)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(node);
            else if (ref) ref.current = node;
        });
    };
}
/**
 * This generates a unique ID for an instance of Downshift
 * @return {String} the unique ID
 */ function $6260541dc56be833$var$generateId() {
    return String($6260541dc56be833$var$idCounter++);
}
/**
 * Resets idCounter to 0. Used for SSR.
 */ function $6260541dc56be833$export$4fba683129f6ab1e() {
    $6260541dc56be833$var$idCounter = 0;
}
/**
 * Default implementation for status message. Only added when menu is open.
 * Will specify if there are results in the list, and if so, how many,
 * and what keys are relevant.
 *
 * @param {Object} param the downshift state and other relevant properties
 * @return {String} the a11y status message
 */ function $6260541dc56be833$var$getA11yStatusMessage$1(_ref2) {
    let { isOpen: isOpen, resultCount: resultCount, previousResultCount: previousResultCount } = _ref2;
    if (!isOpen) return "";
    if (!resultCount) return "No results are available.";
    if (resultCount !== previousResultCount) return `${resultCount} result${resultCount === 1 ? " is" : "s are"} available, use up and down arrow keys to navigate. Press Enter key to select.`;
    return "";
}
/**
 * Takes an argument and if it's an array, returns the first item in the array
 * otherwise returns the argument
 * @param {*} arg the maybe-array
 * @param {*} defaultValue the value if arg is falsey not defined
 * @return {*} the arg or it's first item
 */ function $6260541dc56be833$var$unwrapArray(arg, defaultValue) {
    arg = Array.isArray(arg) ? /* istanbul ignore next (preact) */ arg[0] : arg;
    if (!arg && defaultValue) return defaultValue;
    else return arg;
}
/**
 * @param {Object} element (P)react element
 * @return {Boolean} whether it's a DOM element
 */ function $6260541dc56be833$var$isDOMElement(element) {
    return typeof element.type === "string";
}
/**
 * @param {Object} element (P)react element
 * @return {Object} the props
 */ function $6260541dc56be833$var$getElementProps(element) {
    return element.props;
}
/**
 * Throws a helpful error message for required properties. Useful
 * to be used as a default in destructuring or object params.
 * @param {String} fnName the function name
 * @param {String} propName the prop name
 */ function $6260541dc56be833$var$requiredProp(fnName, propName) {
    // eslint-disable-next-line no-console
    console.error(`The property "${propName}" is required in "${fnName}"`);
}
const $6260541dc56be833$var$stateKeys = [
    "highlightedIndex",
    "inputValue",
    "isOpen",
    "selectedItem",
    "type"
];
/**
 * @param {Object} state the state object
 * @return {Object} state that is relevant to downshift
 */ function $6260541dc56be833$var$pickState(state) {
    if (state === void 0) state = {};
    const result = {};
    $6260541dc56be833$var$stateKeys.forEach((k)=>{
        if (state.hasOwnProperty(k)) result[k] = state[k];
    });
    return result;
}
/**
 * This will perform a shallow merge of the given state object
 * with the state coming from props
 * (for the controlled component scenario)
 * This is used in state updater functions so they're referencing
 * the right state regardless of where it comes from.
 *
 * @param {Object} state The state of the component/hook.
 * @param {Object} props The props that may contain controlled values.
 * @returns {Object} The merged controlled state.
 */ function $6260541dc56be833$var$getState(state, props) {
    return Object.keys(state).reduce((prevState, key)=>{
        prevState[key] = $6260541dc56be833$var$isControlledProp(props, key) ? props[key] : state[key];
        return prevState;
    }, {});
}
/**
 * This determines whether a prop is a "controlled prop" meaning it is
 * state which is controlled by the outside of this component rather
 * than within this component.
 *
 * @param {Object} props The props that may contain controlled values.
 * @param {String} key the key to check
 * @return {Boolean} whether it is a controlled controlled prop
 */ function $6260541dc56be833$var$isControlledProp(props, key) {
    return props[key] !== undefined;
}
/**
 * Normalizes the 'key' property of a KeyboardEvent in IE/Edge
 * @param {Object} event a keyboardEvent object
 * @return {String} keyboard key
 */ function $6260541dc56be833$var$normalizeArrowKey(event) {
    const { key: key, keyCode: keyCode } = event;
    /* istanbul ignore next (ie) */ if (keyCode >= 37 && keyCode <= 40 && key.indexOf("Arrow") !== 0) return `Arrow${key}`;
    return key;
}
/**
 * Simple check if the value passed is object literal
 * @param {*} obj any things
 * @return {Boolean} whether it's object literal
 */ function $6260541dc56be833$var$isPlainObject(obj) {
    return Object.prototype.toString.call(obj) === "[object Object]";
}
/**
 * Returns the new index in the list, in a circular way. If next value is out of bonds from the total,
 * it will wrap to either 0 or itemCount - 1.
 *
 * @param {number} moveAmount Number of positions to move. Negative to move backwards, positive forwards.
 * @param {number} baseIndex The initial position to move from.
 * @param {number} itemCount The total number of items.
 * @param {Function} getItemNodeFromIndex Used to check if item is disabled.
 * @param {boolean} circular Specify if navigation is circular. Default is true.
 * @returns {number} The new index after the move.
 */ function $6260541dc56be833$var$getNextWrappingIndex(moveAmount, baseIndex, itemCount, getItemNodeFromIndex, circular) {
    if (circular === void 0) circular = true;
    if (itemCount === 0) return -1;
    const itemsLastIndex = itemCount - 1;
    if (typeof baseIndex !== "number" || baseIndex < 0 || baseIndex >= itemCount) baseIndex = moveAmount > 0 ? -1 : itemsLastIndex + 1;
    let newIndex = baseIndex + moveAmount;
    if (newIndex < 0) newIndex = circular ? itemsLastIndex : 0;
    else if (newIndex > itemsLastIndex) newIndex = circular ? 0 : itemsLastIndex;
    const nonDisabledNewIndex = $6260541dc56be833$var$getNextNonDisabledIndex(moveAmount, newIndex, itemCount, getItemNodeFromIndex, circular);
    if (nonDisabledNewIndex === -1) return baseIndex >= itemCount ? -1 : baseIndex;
    return nonDisabledNewIndex;
}
/**
 * Returns the next index in the list of an item that is not disabled.
 *
 * @param {number} moveAmount Number of positions to move. Negative to move backwards, positive forwards.
 * @param {number} baseIndex The initial position to move from.
 * @param {number} itemCount The total number of items.
 * @param {Function} getItemNodeFromIndex Used to check if item is disabled.
 * @param {boolean} circular Specify if navigation is circular. Default is true.
 * @returns {number} The new index. Returns baseIndex if item is not disabled. Returns next non-disabled item otherwise. If no non-disabled found it will return -1.
 */ function $6260541dc56be833$var$getNextNonDisabledIndex(moveAmount, baseIndex, itemCount, getItemNodeFromIndex, circular) {
    const currentElementNode = getItemNodeFromIndex(baseIndex);
    if (!currentElementNode || !currentElementNode.hasAttribute("disabled")) return baseIndex;
    if (moveAmount > 0) for(let index = baseIndex + 1; index < itemCount; index++){
        if (!getItemNodeFromIndex(index).hasAttribute("disabled")) return index;
    }
    else for(let index = baseIndex - 1; index >= 0; index--){
        if (!getItemNodeFromIndex(index).hasAttribute("disabled")) return index;
    }
    if (circular) return moveAmount > 0 ? $6260541dc56be833$var$getNextNonDisabledIndex(1, 0, itemCount, getItemNodeFromIndex, false) : $6260541dc56be833$var$getNextNonDisabledIndex(-1, itemCount - 1, itemCount, getItemNodeFromIndex, false);
    return -1;
}
/**
 * Checks if event target is within the downshift elements.
 *
 * @param {EventTarget} target Target to check.
 * @param {HTMLElement[]} downshiftElements The elements that form downshift (list, toggle button etc).
 * @param {Window} environment The window context where downshift renders.
 * @param {boolean} checkActiveElement Whether to also check activeElement.
 *
 * @returns {boolean} Whether or not the target is within downshift elements.
 */ function $6260541dc56be833$var$targetWithinDownshift(target, downshiftElements, environment, checkActiveElement) {
    if (checkActiveElement === void 0) checkActiveElement = true;
    return downshiftElements.some((contextNode)=>contextNode && ($6260541dc56be833$var$isOrContainsNode(contextNode, target, environment) || checkActiveElement && $6260541dc56be833$var$isOrContainsNode(contextNode, environment.document.activeElement, environment)));
} // eslint-disable-next-line import/no-mutable-exports
let $6260541dc56be833$var$validateControlledUnchanged = $6260541dc56be833$var$noop;
var $6260541dc56be833$var$state, $6260541dc56be833$var$prevProps, $6260541dc56be833$var$nextProps, $6260541dc56be833$var$propKey;
const $6260541dc56be833$var$cleanupStatus = $6260541dc56be833$var$debounce((documentProp)=>{
    $6260541dc56be833$var$getStatusDiv(documentProp).textContent = "";
}, 500);
/**
 * @param {String} status the status message
 * @param {Object} documentProp document passed by the user.
 */ function $6260541dc56be833$var$setStatus(status, documentProp) {
    const div = $6260541dc56be833$var$getStatusDiv(documentProp);
    if (!status) return;
    div.textContent = status;
    $6260541dc56be833$var$cleanupStatus(documentProp);
}
/**
 * Get the status node or create it if it does not already exist.
 * @param {Object} documentProp document passed by the user.
 * @return {HTMLElement} the status node.
 */ function $6260541dc56be833$var$getStatusDiv(documentProp) {
    if (documentProp === void 0) documentProp = document;
    let statusDiv = documentProp.getElementById("a11y-status-message");
    if (statusDiv) return statusDiv;
    statusDiv = documentProp.createElement("div");
    statusDiv.setAttribute("id", "a11y-status-message");
    statusDiv.setAttribute("role", "status");
    statusDiv.setAttribute("aria-live", "polite");
    statusDiv.setAttribute("aria-relevant", "additions text");
    Object.assign(statusDiv.style, {
        border: "0",
        clip: "rect(0 0 0 0)",
        height: "1px",
        margin: "-1px",
        overflow: "hidden",
        padding: "0",
        position: "absolute",
        width: "1px"
    });
    documentProp.body.appendChild(statusDiv);
    return statusDiv;
}
const $6260541dc56be833$var$unknown = 0;
const $6260541dc56be833$var$mouseUp = 1;
const $6260541dc56be833$var$itemMouseEnter = 2;
const $6260541dc56be833$var$keyDownArrowUp = 3;
const $6260541dc56be833$var$keyDownArrowDown = 4;
const $6260541dc56be833$var$keyDownEscape = 5;
const $6260541dc56be833$var$keyDownEnter = 6;
const $6260541dc56be833$var$keyDownHome = 7;
const $6260541dc56be833$var$keyDownEnd = 8;
const $6260541dc56be833$var$clickItem = 9;
const $6260541dc56be833$var$blurInput = 10;
const $6260541dc56be833$var$changeInput = 11;
const $6260541dc56be833$var$keyDownSpaceButton = 12;
const $6260541dc56be833$var$clickButton = 13;
const $6260541dc56be833$var$blurButton = 14;
const $6260541dc56be833$var$controlledPropUpdatedSelectedItem = 15;
const $6260541dc56be833$var$touchEnd = 16;
var $6260541dc56be833$var$stateChangeTypes$3 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    unknown: $6260541dc56be833$var$unknown,
    mouseUp: $6260541dc56be833$var$mouseUp,
    itemMouseEnter: $6260541dc56be833$var$itemMouseEnter,
    keyDownArrowUp: $6260541dc56be833$var$keyDownArrowUp,
    keyDownArrowDown: $6260541dc56be833$var$keyDownArrowDown,
    keyDownEscape: $6260541dc56be833$var$keyDownEscape,
    keyDownEnter: $6260541dc56be833$var$keyDownEnter,
    keyDownHome: $6260541dc56be833$var$keyDownHome,
    keyDownEnd: $6260541dc56be833$var$keyDownEnd,
    clickItem: $6260541dc56be833$var$clickItem,
    blurInput: $6260541dc56be833$var$blurInput,
    changeInput: $6260541dc56be833$var$changeInput,
    keyDownSpaceButton: $6260541dc56be833$var$keyDownSpaceButton,
    clickButton: $6260541dc56be833$var$clickButton,
    blurButton: $6260541dc56be833$var$blurButton,
    controlledPropUpdatedSelectedItem: $6260541dc56be833$var$controlledPropUpdatedSelectedItem,
    touchEnd: $6260541dc56be833$var$touchEnd
});
/* eslint camelcase:0 */ const $6260541dc56be833$var$Downshift = /*#__PURE__*/ (()=>{
    class Downshift extends (0, $acw62.Component) {
        constructor(_props){
            var _this;
            super(_props);
            _this = this;
            this.id = this.props.id || `downshift-${$6260541dc56be833$var$generateId()}`;
            this.menuId = this.props.menuId || `${this.id}-menu`;
            this.labelId = this.props.labelId || `${this.id}-label`;
            this.inputId = this.props.inputId || `${this.id}-input`;
            this.getItemId = this.props.getItemId || ((index)=>`${this.id}-item-${index}`);
            this.input = null;
            this.items = [];
            this.itemCount = null;
            this.previousResultCount = 0;
            this.timeoutIds = [];
            this.internalSetTimeout = (fn, time)=>{
                const id = setTimeout(()=>{
                    this.timeoutIds = this.timeoutIds.filter((i)=>i !== id);
                    fn();
                }, time);
                this.timeoutIds.push(id);
            };
            this.setItemCount = (count)=>{
                this.itemCount = count;
            };
            this.unsetItemCount = ()=>{
                this.itemCount = null;
            };
            this.setHighlightedIndex = function(highlightedIndex, otherStateToSet) {
                if (highlightedIndex === void 0) highlightedIndex = _this.props.defaultHighlightedIndex;
                if (otherStateToSet === void 0) otherStateToSet = {};
                otherStateToSet = $6260541dc56be833$var$pickState(otherStateToSet);
                _this.internalSetState({
                    highlightedIndex: highlightedIndex,
                    ...otherStateToSet
                });
            };
            this.clearSelection = (cb)=>{
                this.internalSetState({
                    selectedItem: null,
                    inputValue: "",
                    highlightedIndex: this.props.defaultHighlightedIndex,
                    isOpen: this.props.defaultIsOpen
                }, cb);
            };
            this.selectItem = (item, otherStateToSet, cb)=>{
                otherStateToSet = $6260541dc56be833$var$pickState(otherStateToSet);
                this.internalSetState({
                    isOpen: this.props.defaultIsOpen,
                    highlightedIndex: this.props.defaultHighlightedIndex,
                    selectedItem: item,
                    inputValue: this.props.itemToString(item),
                    ...otherStateToSet
                }, cb);
            };
            this.selectItemAtIndex = (itemIndex, otherStateToSet, cb)=>{
                const item = this.items[itemIndex];
                if (item == null) return;
                this.selectItem(item, otherStateToSet, cb);
            };
            this.selectHighlightedItem = (otherStateToSet, cb)=>{
                return this.selectItemAtIndex(this.getState().highlightedIndex, otherStateToSet, cb);
            };
            this.internalSetState = (stateToSet, cb)=>{
                let isItemSelected, onChangeArg;
                const onStateChangeArg = {};
                const isStateToSetFunction = typeof stateToSet === "function"; // we want to call `onInputValueChange` before the `setState` call
                // so someone controlling the `inputValue` state gets notified of
                // the input change as soon as possible. This avoids issues with
                // preserving the cursor position.
                // See https://github.com/downshift-js/downshift/issues/217 for more info.
                if (!isStateToSetFunction && stateToSet.hasOwnProperty("inputValue")) this.props.onInputValueChange(stateToSet.inputValue, {
                    ...this.getStateAndHelpers(),
                    ...stateToSet
                });
                return this.setState((state)=>{
                    state = this.getState(state);
                    let newStateToSet = isStateToSetFunction ? stateToSet(state) : stateToSet; // Your own function that could modify the state that will be set.
                    newStateToSet = this.props.stateReducer(state, newStateToSet); // checks if an item is selected, regardless of if it's different from
                    // what was selected before
                    // used to determine if onSelect and onChange callbacks should be called
                    isItemSelected = newStateToSet.hasOwnProperty("selectedItem"); // this keeps track of the object we want to call with setState
                    const nextState = {}; // this is just used to tell whether the state changed
                    // and we're trying to update that state. OR if the selection has changed and we're
                    // trying to update the selection
                    if (isItemSelected && newStateToSet.selectedItem !== state.selectedItem) onChangeArg = newStateToSet.selectedItem;
                    newStateToSet.type = newStateToSet.type || $6260541dc56be833$var$unknown;
                    Object.keys(newStateToSet).forEach((key)=>{
                        // onStateChangeArg should only have the state that is
                        // actually changing
                        if (state[key] !== newStateToSet[key]) onStateChangeArg[key] = newStateToSet[key];
                         // the type is useful for the onStateChangeArg
                        // but we don't actually want to set it in internal state.
                        // this is an undocumented feature for now... Not all internalSetState
                        // calls support it and I'm not certain we want them to yet.
                        // But it enables users controlling the isOpen state to know when
                        // the isOpen state changes due to mouseup events which is quite handy.
                        if (key === "type") return;
                        newStateToSet[key]; // if it's coming from props, then we don't care to set it internally
                        if (!$6260541dc56be833$var$isControlledProp(this.props, key)) nextState[key] = newStateToSet[key];
                    }); // if stateToSet is a function, then we weren't able to call onInputValueChange
                    // earlier, so we'll call it now that we know what the inputValue state will be.
                    if (isStateToSetFunction && newStateToSet.hasOwnProperty("inputValue")) this.props.onInputValueChange(newStateToSet.inputValue, {
                        ...this.getStateAndHelpers(),
                        ...newStateToSet
                    });
                    return nextState;
                }, ()=>{
                    // call the provided callback if it's a function
                    $6260541dc56be833$var$cbToCb(cb)(); // only call the onStateChange and onChange callbacks if
                    // we have relevant information to pass them.
                    const hasMoreStateThanType = Object.keys(onStateChangeArg).length > 1;
                    if (hasMoreStateThanType) this.props.onStateChange(onStateChangeArg, this.getStateAndHelpers());
                    if (isItemSelected) this.props.onSelect(stateToSet.selectedItem, this.getStateAndHelpers());
                    if (onChangeArg !== undefined) this.props.onChange(onChangeArg, this.getStateAndHelpers());
                     // this is currently undocumented and therefore subject to change
                    // We'll try to not break it, but just be warned.
                    this.props.onUserAction(onStateChangeArg, this.getStateAndHelpers());
                });
            };
            this.rootRef = (node)=>this._rootNode = node;
            this.getRootProps = function(_temp, _temp2) {
                let { refKey: refKey = "ref", ref: ref, ...rest } = _temp === void 0 ? {} : _temp;
                let { suppressRefError: suppressRefError = false } = _temp2 === void 0 ? {} : _temp2;
                // this is used in the render to know whether the user has called getRootProps.
                // It uses that to know whether to apply the props automatically
                _this.getRootProps.called = true;
                _this.getRootProps.refKey = refKey;
                _this.getRootProps.suppressRefError = suppressRefError;
                const { isOpen: isOpen } = _this.getState();
                return {
                    [refKey]: $6260541dc56be833$var$handleRefs(ref, _this.rootRef),
                    role: "combobox",
                    "aria-expanded": isOpen,
                    "aria-haspopup": "listbox",
                    "aria-owns": isOpen ? _this.menuId : null,
                    "aria-labelledby": _this.labelId,
                    ...rest
                };
            };
            this.keyDownHandlers = {
                ArrowDown (event) {
                    event.preventDefault();
                    if (this.getState().isOpen) {
                        const amount = event.shiftKey ? 5 : 1;
                        this.moveHighlightedIndex(amount, {
                            type: $6260541dc56be833$var$keyDownArrowDown
                        });
                    } else this.internalSetState({
                        isOpen: true,
                        type: $6260541dc56be833$var$keyDownArrowDown
                    }, ()=>{
                        const itemCount = this.getItemCount();
                        if (itemCount > 0) {
                            const { highlightedIndex: highlightedIndex } = this.getState();
                            const nextHighlightedIndex = $6260541dc56be833$var$getNextWrappingIndex(1, highlightedIndex, itemCount, (index)=>this.getItemNodeFromIndex(index));
                            this.setHighlightedIndex(nextHighlightedIndex, {
                                type: $6260541dc56be833$var$keyDownArrowDown
                            });
                        }
                    });
                },
                ArrowUp (event) {
                    event.preventDefault();
                    if (this.getState().isOpen) {
                        const amount = event.shiftKey ? -5 : -1;
                        this.moveHighlightedIndex(amount, {
                            type: $6260541dc56be833$var$keyDownArrowUp
                        });
                    } else this.internalSetState({
                        isOpen: true,
                        type: $6260541dc56be833$var$keyDownArrowUp
                    }, ()=>{
                        const itemCount = this.getItemCount();
                        if (itemCount > 0) {
                            const { highlightedIndex: highlightedIndex } = this.getState();
                            const nextHighlightedIndex = $6260541dc56be833$var$getNextWrappingIndex(-1, highlightedIndex, itemCount, (index)=>this.getItemNodeFromIndex(index));
                            this.setHighlightedIndex(nextHighlightedIndex, {
                                type: $6260541dc56be833$var$keyDownArrowUp
                            });
                        }
                    });
                },
                Enter (event) {
                    if (event.which === 229) return;
                    const { isOpen: isOpen, highlightedIndex: highlightedIndex } = this.getState();
                    if (isOpen && highlightedIndex != null) {
                        event.preventDefault();
                        const item = this.items[highlightedIndex];
                        const itemNode = this.getItemNodeFromIndex(highlightedIndex);
                        if (item == null || itemNode && itemNode.hasAttribute("disabled")) return;
                        this.selectHighlightedItem({
                            type: $6260541dc56be833$var$keyDownEnter
                        });
                    }
                },
                Escape (event) {
                    event.preventDefault();
                    this.reset({
                        type: $6260541dc56be833$var$keyDownEscape,
                        ...!this.state.isOpen && {
                            selectedItem: null,
                            inputValue: ""
                        }
                    });
                }
            };
            this.buttonKeyDownHandlers = {
                ...this.keyDownHandlers,
                " " (event) {
                    event.preventDefault();
                    this.toggleMenu({
                        type: $6260541dc56be833$var$keyDownSpaceButton
                    });
                }
            };
            this.inputKeyDownHandlers = {
                ...this.keyDownHandlers,
                Home (event) {
                    const { isOpen: isOpen } = this.getState();
                    if (!isOpen) return;
                    event.preventDefault();
                    const itemCount = this.getItemCount();
                    if (itemCount <= 0 || !isOpen) return;
                     // get next non-disabled starting downwards from 0 if that's disabled.
                    const newHighlightedIndex = $6260541dc56be833$var$getNextNonDisabledIndex(1, 0, itemCount, (index)=>this.getItemNodeFromIndex(index), false);
                    this.setHighlightedIndex(newHighlightedIndex, {
                        type: $6260541dc56be833$var$keyDownHome
                    });
                },
                End (event) {
                    const { isOpen: isOpen } = this.getState();
                    if (!isOpen) return;
                    event.preventDefault();
                    const itemCount = this.getItemCount();
                    if (itemCount <= 0 || !isOpen) return;
                     // get next non-disabled starting upwards from last index if that's disabled.
                    const newHighlightedIndex = $6260541dc56be833$var$getNextNonDisabledIndex(-1, itemCount - 1, itemCount, (index)=>this.getItemNodeFromIndex(index), false);
                    this.setHighlightedIndex(newHighlightedIndex, {
                        type: $6260541dc56be833$var$keyDownEnd
                    });
                }
            };
            this.getToggleButtonProps = function(_temp3) {
                let { onClick: onClick, onPress: onPress, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onBlur: onBlur, ...rest } = _temp3 === void 0 ? {} : _temp3;
                const { isOpen: isOpen } = _this.getState();
                const enabledEventHandlers = {
                    onClick: $6260541dc56be833$var$callAllEventHandlers(onClick, _this.buttonHandleClick),
                    onKeyDown: $6260541dc56be833$var$callAllEventHandlers(onKeyDown, _this.buttonHandleKeyDown),
                    onKeyUp: $6260541dc56be833$var$callAllEventHandlers(onKeyUp, _this.buttonHandleKeyUp),
                    onBlur: $6260541dc56be833$var$callAllEventHandlers(onBlur, _this.buttonHandleBlur)
                };
                const eventHandlers = rest.disabled ? {} : enabledEventHandlers;
                return {
                    type: "button",
                    role: "button",
                    "aria-label": isOpen ? "close menu" : "open menu",
                    "aria-haspopup": true,
                    "data-toggle": true,
                    ...eventHandlers,
                    ...rest
                };
            };
            this.buttonHandleKeyUp = (event)=>{
                // Prevent click event from emitting in Firefox
                event.preventDefault();
            };
            this.buttonHandleKeyDown = (event)=>{
                const key = $6260541dc56be833$var$normalizeArrowKey(event);
                if (this.buttonKeyDownHandlers[key]) this.buttonKeyDownHandlers[key].call(this, event);
            };
            this.buttonHandleClick = (event)=>{
                event.preventDefault(); // handle odd case for Safari and Firefox which
                // don't give the button the focus properly.
                /* istanbul ignore if (can't reasonably test this) */ if (this.props.environment.document.activeElement === this.props.environment.document.body) event.target.focus();
                 // to simplify testing components that use downshift, we'll not wrap this in a setTimeout
                // Ensure that toggle of menu occurs after the potential blur event in iOS
                this.internalSetTimeout(()=>this.toggleMenu({
                        type: $6260541dc56be833$var$clickButton
                    }));
            };
            this.buttonHandleBlur = (event)=>{
                const blurTarget = event.target; // Save blur target for comparison with activeElement later
                // Need setTimeout, so that when the user presses Tab, the activeElement is the next focused element, not body element
                this.internalSetTimeout(()=>{
                    if (!this.isMouseDown && (this.props.environment.document.activeElement == null || this.props.environment.document.activeElement.id !== this.inputId) && this.props.environment.document.activeElement !== blurTarget // Do nothing if we refocus the same element again (to solve issue in Safari on iOS)
                    ) this.reset({
                        type: $6260541dc56be833$var$blurButton
                    });
                });
            };
            this.getLabelProps = (props)=>{
                return {
                    htmlFor: this.inputId,
                    id: this.labelId,
                    ...props
                };
            };
            this.getInputProps = function(_temp4) {
                let { onKeyDown: onKeyDown, onBlur: onBlur, onChange: onChange, onInput: onInput, onChangeText: onChangeText, ...rest } = _temp4 === void 0 ? {} : _temp4;
                let onChangeKey;
                let eventHandlers = {};
                onChangeKey = "onChange";
                const { inputValue: inputValue, isOpen: isOpen, highlightedIndex: highlightedIndex } = _this.getState();
                if (!rest.disabled) eventHandlers = {
                    [onChangeKey]: $6260541dc56be833$var$callAllEventHandlers(onChange, onInput, _this.inputHandleChange),
                    onKeyDown: $6260541dc56be833$var$callAllEventHandlers(onKeyDown, _this.inputHandleKeyDown),
                    onBlur: $6260541dc56be833$var$callAllEventHandlers(onBlur, _this.inputHandleBlur)
                };
                return {
                    "aria-autocomplete": "list",
                    "aria-activedescendant": isOpen && typeof highlightedIndex === "number" && highlightedIndex >= 0 ? _this.getItemId(highlightedIndex) : null,
                    "aria-controls": isOpen ? _this.menuId : null,
                    "aria-labelledby": _this.labelId,
                    // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
                    // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
                    autoComplete: "off",
                    value: inputValue,
                    id: _this.inputId,
                    ...eventHandlers,
                    ...rest
                };
            };
            this.inputHandleKeyDown = (event)=>{
                const key = $6260541dc56be833$var$normalizeArrowKey(event);
                if (key && this.inputKeyDownHandlers[key]) this.inputKeyDownHandlers[key].call(this, event);
            };
            this.inputHandleChange = (event)=>{
                this.internalSetState({
                    type: $6260541dc56be833$var$changeInput,
                    isOpen: true,
                    inputValue: event.target.value,
                    highlightedIndex: this.props.defaultHighlightedIndex
                });
            };
            this.inputHandleBlur = ()=>{
                // Need setTimeout, so that when the user presses Tab, the activeElement is the next focused element, not the body element
                this.internalSetTimeout(()=>{
                    const downshiftButtonIsActive = this.props.environment.document && !!this.props.environment.document.activeElement && !!this.props.environment.document.activeElement.dataset && this.props.environment.document.activeElement.dataset.toggle && this._rootNode && this._rootNode.contains(this.props.environment.document.activeElement);
                    if (!this.isMouseDown && !downshiftButtonIsActive) this.reset({
                        type: $6260541dc56be833$var$blurInput
                    });
                });
            };
            this.menuRef = (node)=>{
                this._menuNode = node;
            };
            this.getMenuProps = function(_temp5, _temp6) {
                let { refKey: refKey = "ref", ref: ref, ...props } = _temp5 === void 0 ? {} : _temp5;
                let { suppressRefError: suppressRefError = false } = _temp6 === void 0 ? {} : _temp6;
                _this.getMenuProps.called = true;
                _this.getMenuProps.refKey = refKey;
                _this.getMenuProps.suppressRefError = suppressRefError;
                return {
                    [refKey]: $6260541dc56be833$var$handleRefs(ref, _this.menuRef),
                    role: "listbox",
                    "aria-labelledby": props && props["aria-label"] ? null : _this.labelId,
                    id: _this.menuId,
                    ...props
                };
            };
            this.getItemProps = function(_temp7) {
                let { onMouseMove: onMouseMove, onMouseDown: onMouseDown, onClick: onClick, onPress: onPress, index: index, item: item, ...rest } = _temp7 === void 0 ? {} : _temp7;
                if (index === undefined) {
                    _this.items.push(item);
                    index = _this.items.indexOf(item);
                } else _this.items[index] = item;
                const onSelectKey = "onClick";
                const customClickHandler = onClick;
                const enabledEventHandlers = {
                    // onMouseMove is used over onMouseEnter here. onMouseMove
                    // is only triggered on actual mouse movement while onMouseEnter
                    // can fire on DOM changes, interrupting keyboard navigation
                    onMouseMove: $6260541dc56be833$var$callAllEventHandlers(onMouseMove, ()=>{
                        if (index === _this.getState().highlightedIndex) return;
                        _this.setHighlightedIndex(index, {
                            type: $6260541dc56be833$var$itemMouseEnter
                        }); // We never want to manually scroll when changing state based
                        // on `onMouseMove` because we will be moving the element out
                        // from under the user which is currently scrolling/moving the
                        // cursor
                        _this.avoidScrolling = true;
                        _this.internalSetTimeout(()=>_this.avoidScrolling = false, 250);
                    }),
                    onMouseDown: $6260541dc56be833$var$callAllEventHandlers(onMouseDown, (event)=>{
                        // This prevents the activeElement from being changed
                        // to the item so it can remain with the current activeElement
                        // which is a more common use case.
                        event.preventDefault();
                    }),
                    [onSelectKey]: $6260541dc56be833$var$callAllEventHandlers(customClickHandler, ()=>{
                        _this.selectItemAtIndex(index, {
                            type: $6260541dc56be833$var$clickItem
                        });
                    })
                }; // Passing down the onMouseDown handler to prevent redirect
                // of the activeElement if clicking on disabled items
                const eventHandlers = rest.disabled ? {
                    onMouseDown: enabledEventHandlers.onMouseDown
                } : enabledEventHandlers;
                return {
                    id: _this.getItemId(index),
                    role: "option",
                    "aria-selected": _this.getState().highlightedIndex === index,
                    ...eventHandlers,
                    ...rest
                };
            };
            this.clearItems = ()=>{
                this.items = [];
            };
            this.reset = function(otherStateToSet, cb) {
                if (otherStateToSet === void 0) otherStateToSet = {};
                otherStateToSet = $6260541dc56be833$var$pickState(otherStateToSet);
                _this.internalSetState((_ref)=>{
                    let { selectedItem: selectedItem } = _ref;
                    return {
                        isOpen: _this.props.defaultIsOpen,
                        highlightedIndex: _this.props.defaultHighlightedIndex,
                        inputValue: _this.props.itemToString(selectedItem),
                        ...otherStateToSet
                    };
                }, cb);
            };
            this.toggleMenu = function(otherStateToSet, cb) {
                if (otherStateToSet === void 0) otherStateToSet = {};
                otherStateToSet = $6260541dc56be833$var$pickState(otherStateToSet);
                _this.internalSetState((_ref2)=>{
                    let { isOpen: isOpen } = _ref2;
                    return {
                        isOpen: !isOpen,
                        ...isOpen && {
                            highlightedIndex: _this.props.defaultHighlightedIndex
                        },
                        ...otherStateToSet
                    };
                }, ()=>{
                    const { isOpen: isOpen, highlightedIndex: highlightedIndex } = _this.getState();
                    if (isOpen) {
                        if (_this.getItemCount() > 0 && typeof highlightedIndex === "number") _this.setHighlightedIndex(highlightedIndex, otherStateToSet);
                    }
                    $6260541dc56be833$var$cbToCb(cb)();
                });
            };
            this.openMenu = (cb)=>{
                this.internalSetState({
                    isOpen: true
                }, cb);
            };
            this.closeMenu = (cb)=>{
                this.internalSetState({
                    isOpen: false
                }, cb);
            };
            this.updateStatus = $6260541dc56be833$var$debounce(()=>{
                const state = this.getState();
                const item = this.items[state.highlightedIndex];
                const resultCount = this.getItemCount();
                const status = this.props.getA11yStatusMessage({
                    itemToString: this.props.itemToString,
                    previousResultCount: this.previousResultCount,
                    resultCount: resultCount,
                    highlightedItem: item,
                    ...state
                });
                this.previousResultCount = resultCount;
                $6260541dc56be833$var$setStatus(status, this.props.environment.document);
            }, 200);
            // fancy destructuring + defaults + aliases
            // this basically says each value of state should either be set to
            // the initial value or the default value if the initial value is not provided
            const { defaultHighlightedIndex: defaultHighlightedIndex, initialHighlightedIndex: _highlightedIndex = defaultHighlightedIndex, defaultIsOpen: defaultIsOpen, initialIsOpen: _isOpen = defaultIsOpen, initialInputValue: _inputValue = "", initialSelectedItem: _selectedItem = null } = this.props;
            const _state = this.getState({
                highlightedIndex: _highlightedIndex,
                isOpen: _isOpen,
                inputValue: _inputValue,
                selectedItem: _selectedItem
            });
            if (_state.selectedItem != null && this.props.initialInputValue === undefined) _state.inputValue = this.props.itemToString(_state.selectedItem);
            this.state = _state;
        }
        /**
     * Clear all running timeouts
     */ internalClearTimeouts() {
            this.timeoutIds.forEach((id)=>{
                clearTimeout(id);
            });
            this.timeoutIds = [];
        }
        /**
     * Gets the state based on internal state or props
     * If a state value is passed via props, then that
     * is the value given, otherwise it's retrieved from
     * stateToMerge
     *
     * @param {Object} stateToMerge defaults to this.state
     * @return {Object} the state
     */ getState(stateToMerge) {
            if (stateToMerge === void 0) stateToMerge = this.state;
            return $6260541dc56be833$var$getState(stateToMerge, this.props);
        }
        getItemCount() {
            // things read better this way. They're in priority order:
            // 1. `this.itemCount`
            // 2. `this.props.itemCount`
            // 3. `this.items.length`
            let itemCount = this.items.length;
            if (this.itemCount != null) itemCount = this.itemCount;
            else if (this.props.itemCount !== undefined) itemCount = this.props.itemCount;
            return itemCount;
        }
        getItemNodeFromIndex(index) {
            return this.props.environment.document.getElementById(this.getItemId(index));
        }
        scrollHighlightedItemIntoView() {
            /* istanbul ignore else (react-native) */ {
                const node = this.getItemNodeFromIndex(this.getState().highlightedIndex);
                this.props.scrollIntoView(node, this._menuNode);
            }
        }
        moveHighlightedIndex(amount, otherStateToSet) {
            const itemCount = this.getItemCount();
            const { highlightedIndex: highlightedIndex } = this.getState();
            if (itemCount > 0) {
                const nextHighlightedIndex = $6260541dc56be833$var$getNextWrappingIndex(amount, highlightedIndex, itemCount, (index)=>this.getItemNodeFromIndex(index));
                this.setHighlightedIndex(nextHighlightedIndex, otherStateToSet);
            }
        }
        getStateAndHelpers() {
            const { highlightedIndex: highlightedIndex, inputValue: inputValue, selectedItem: selectedItem, isOpen: isOpen } = this.getState();
            const { itemToString: itemToString } = this.props;
            const { id: id } = this;
            const { getRootProps: getRootProps, getToggleButtonProps: getToggleButtonProps, getLabelProps: getLabelProps, getMenuProps: getMenuProps, getInputProps: getInputProps, getItemProps: getItemProps, openMenu: openMenu, closeMenu: closeMenu, toggleMenu: toggleMenu, selectItem: selectItem, selectItemAtIndex: selectItemAtIndex, selectHighlightedItem: selectHighlightedItem, setHighlightedIndex: setHighlightedIndex, clearSelection: clearSelection, clearItems: clearItems, reset: reset, setItemCount: setItemCount, unsetItemCount: unsetItemCount, internalSetState: setState } = this;
            return {
                getRootProps: // prop getters
                getRootProps,
                getToggleButtonProps: getToggleButtonProps,
                getLabelProps: getLabelProps,
                getMenuProps: getMenuProps,
                getInputProps: getInputProps,
                getItemProps: getItemProps,
                reset: // actions
                reset,
                openMenu: openMenu,
                closeMenu: closeMenu,
                toggleMenu: toggleMenu,
                selectItem: selectItem,
                selectItemAtIndex: selectItemAtIndex,
                selectHighlightedItem: selectHighlightedItem,
                setHighlightedIndex: setHighlightedIndex,
                clearSelection: clearSelection,
                clearItems: clearItems,
                setItemCount: setItemCount,
                unsetItemCount: unsetItemCount,
                setState: setState,
                itemToString: // props
                itemToString,
                id: // derived
                id,
                highlightedIndex: // state
                highlightedIndex,
                inputValue: inputValue,
                isOpen: isOpen,
                selectedItem: selectedItem
            };
        }
        componentDidMount() {
            /* istanbul ignore if (react-native) */ {
                // this.isMouseDown helps us track whether the mouse is currently held down.
                // This is useful when the user clicks on an item in the list, but holds the mouse
                // down long enough for the list to disappear (because the blur event fires on the input)
                // this.isMouseDown is used in the blur handler on the input to determine whether the blur event should
                // trigger hiding the menu.
                const onMouseDown = ()=>{
                    this.isMouseDown = true;
                };
                const onMouseUp = (event)=>{
                    this.isMouseDown = false; // if the target element or the activeElement is within a downshift node
                    // then we don't want to reset downshift
                    const contextWithinDownshift = $6260541dc56be833$var$targetWithinDownshift(event.target, [
                        this._rootNode,
                        this._menuNode
                    ], this.props.environment);
                    if (!contextWithinDownshift && this.getState().isOpen) this.reset({
                        type: $6260541dc56be833$var$mouseUp
                    }, ()=>this.props.onOuterClick(this.getStateAndHelpers()));
                }; // Touching an element in iOS gives focus and hover states, but touching out of
                // the element will remove hover, and persist the focus state, resulting in the
                // blur event not being triggered.
                // this.isTouchMove helps us track whether the user is tapping or swiping on a touch screen.
                // If the user taps outside of Downshift, the component should be reset,
                // but not if the user is swiping
                const onTouchStart = ()=>{
                    this.isTouchMove = false;
                };
                const onTouchMove = ()=>{
                    this.isTouchMove = true;
                };
                const onTouchEnd = (event)=>{
                    const contextWithinDownshift = $6260541dc56be833$var$targetWithinDownshift(event.target, [
                        this._rootNode,
                        this._menuNode
                    ], this.props.environment, false);
                    if (!this.isTouchMove && !contextWithinDownshift && this.getState().isOpen) this.reset({
                        type: $6260541dc56be833$var$touchEnd
                    }, ()=>this.props.onOuterClick(this.getStateAndHelpers()));
                };
                const { environment: environment } = this.props;
                environment.addEventListener("mousedown", onMouseDown);
                environment.addEventListener("mouseup", onMouseUp);
                environment.addEventListener("touchstart", onTouchStart);
                environment.addEventListener("touchmove", onTouchMove);
                environment.addEventListener("touchend", onTouchEnd);
                this.cleanup = ()=>{
                    this.internalClearTimeouts();
                    this.updateStatus.cancel();
                    environment.removeEventListener("mousedown", onMouseDown);
                    environment.removeEventListener("mouseup", onMouseUp);
                    environment.removeEventListener("touchstart", onTouchStart);
                    environment.removeEventListener("touchmove", onTouchMove);
                    environment.removeEventListener("touchend", onTouchEnd);
                };
            }
        }
        shouldScroll(prevState, prevProps) {
            const { highlightedIndex: currentHighlightedIndex } = this.props.highlightedIndex === undefined ? this.getState() : this.props;
            const { highlightedIndex: prevHighlightedIndex } = prevProps.highlightedIndex === undefined ? prevState : prevProps;
            const scrollWhenOpen = currentHighlightedIndex && this.getState().isOpen && !prevState.isOpen;
            const scrollWhenNavigating = currentHighlightedIndex !== prevHighlightedIndex;
            return scrollWhenOpen || scrollWhenNavigating;
        }
        componentDidUpdate(prevProps, prevState) {
            if ($6260541dc56be833$var$isControlledProp(this.props, "selectedItem") && this.props.selectedItemChanged(prevProps.selectedItem, this.props.selectedItem)) this.internalSetState({
                type: $6260541dc56be833$var$controlledPropUpdatedSelectedItem,
                inputValue: this.props.itemToString(this.props.selectedItem)
            });
            if (!this.avoidScrolling && this.shouldScroll(prevState, prevProps)) this.scrollHighlightedItemIntoView();
            this.updateStatus();
        }
        componentWillUnmount() {
            this.cleanup(); // avoids memory leak
        }
        render() {
            const children = $6260541dc56be833$var$unwrapArray(this.props.children, $6260541dc56be833$var$noop); // because the items are rerendered every time we call the children
            // we clear this out each render and it will be populated again as
            // getItemProps is called.
            this.clearItems(); // we reset this so we know whether the user calls getRootProps during
            // this render. If they do then we don't need to do anything,
            // if they don't then we need to clone the element they return and
            // apply the props for them.
            this.getRootProps.called = false;
            this.getRootProps.refKey = undefined;
            this.getRootProps.suppressRefError = undefined; // we do something similar for getMenuProps
            this.getMenuProps.called = false;
            this.getMenuProps.refKey = undefined;
            this.getMenuProps.suppressRefError = undefined; // we do something similar for getLabelProps
            this.getLabelProps.called = false; // and something similar for getInputProps
            this.getInputProps.called = false;
            const element = $6260541dc56be833$var$unwrapArray(children(this.getStateAndHelpers()));
            if (!element) return null;
            if (this.getRootProps.called || this.props.suppressRefError) return element;
            else if ($6260541dc56be833$var$isDOMElement(element)) // they didn't apply the root props, but we can clone
            // this and apply the props ourselves
            return /*#__PURE__*/ (0, $acw62.cloneElement)(element, this.getRootProps($6260541dc56be833$var$getElementProps(element)));
            /* istanbul ignore next */ return undefined;
        }
    }
    Downshift.defaultProps = {
        defaultHighlightedIndex: null,
        defaultIsOpen: false,
        getA11yStatusMessage: $6260541dc56be833$var$getA11yStatusMessage$1,
        itemToString: (i)=>{
            if (i == null) return "";
            return String(i);
        },
        onStateChange: $6260541dc56be833$var$noop,
        onInputValueChange: $6260541dc56be833$var$noop,
        onUserAction: $6260541dc56be833$var$noop,
        onChange: $6260541dc56be833$var$noop,
        onSelect: $6260541dc56be833$var$noop,
        onOuterClick: $6260541dc56be833$var$noop,
        selectedItemChanged: (prevItem, item)=>prevItem !== item,
        environment: /* istanbul ignore next (ssr) */ typeof window === "undefined" ? {} : window,
        stateReducer: (state, stateToSet)=>stateToSet,
        suppressRefError: false,
        scrollIntoView: $6260541dc56be833$var$scrollIntoView
    };
    Downshift.stateChangeTypes = $6260541dc56be833$var$stateChangeTypes$3;
    return Downshift;
})();
var $6260541dc56be833$export$2e2bcd8739ae039 = $6260541dc56be833$var$Downshift;
function $6260541dc56be833$var$validateGetMenuPropsCalledCorrectly(node, _ref3) {
    let { refKey: refKey } = _ref3;
    if (!node) // eslint-disable-next-line no-console
    console.error(`downshift: The ref prop "${refKey}" from getMenuProps was not applied correctly on your menu element.`);
}
function $6260541dc56be833$var$validateGetRootPropsCalledCorrectly(element, _ref4) {
    let { refKey: refKey } = _ref4;
    const refKeySpecified = refKey !== "ref";
    const isComposite = !$6260541dc56be833$var$isDOMElement(element);
    if (isComposite && !refKeySpecified && !(0, $066b951a13b27288$exports.isForwardRef)(element)) // eslint-disable-next-line no-console
    console.error("downshift: You returned a non-DOM element. You must specify a refKey in getRootProps");
    else if (!isComposite && refKeySpecified) // eslint-disable-next-line no-console
    console.error(`downshift: You returned a DOM element. You should not specify a refKey in getRootProps. You specified "${refKey}"`);
    if (!(0, $066b951a13b27288$exports.isForwardRef)(element) && !$6260541dc56be833$var$getElementProps(element)[refKey]) // eslint-disable-next-line no-console
    console.error(`downshift: You must apply the ref prop "${refKey}" from getRootProps onto your root element.`);
}
const $6260541dc56be833$var$dropdownDefaultStateValues = {
    highlightedIndex: -1,
    isOpen: false,
    selectedItem: null,
    inputValue: ""
};
function $6260541dc56be833$var$callOnChangeProps(action, state, newState) {
    const { props: props, type: type } = action;
    const changes = {};
    Object.keys(state).forEach((key)=>{
        $6260541dc56be833$var$invokeOnChangeHandler(key, action, state, newState);
        if (newState[key] !== state[key]) changes[key] = newState[key];
    });
    if (props.onStateChange && Object.keys(changes).length) props.onStateChange({
        type: type,
        ...changes
    });
}
function $6260541dc56be833$var$invokeOnChangeHandler(key, action, state, newState) {
    const { props: props, type: type } = action;
    const handler = `on${$6260541dc56be833$var$capitalizeString(key)}Change`;
    if (props[handler] && newState[key] !== undefined && newState[key] !== state[key]) props[handler]({
        type: type,
        ...newState
    });
}
/**
 * Default state reducer that returns the changes.
 *
 * @param {Object} s state.
 * @param {Object} a action with changes.
 * @returns {Object} changes.
 */ function $6260541dc56be833$var$stateReducer(s, a) {
    return a.changes;
}
/**
 * Returns a message to be added to aria-live region when item is selected.
 *
 * @param {Object} selectionParameters Parameters required to build the message.
 * @returns {string} The a11y message.
 */ function $6260541dc56be833$var$getA11ySelectionMessage(selectionParameters) {
    const { selectedItem: selectedItem, itemToString: itemToStringLocal } = selectionParameters;
    return selectedItem ? `${itemToStringLocal(selectedItem)} has been selected.` : "";
}
/**
 * Debounced call for updating the a11y message.
 */ const $6260541dc56be833$var$updateA11yStatus = $6260541dc56be833$var$debounce((getA11yMessage, document1)=>{
    $6260541dc56be833$var$setStatus(getA11yMessage(), document1);
}, 200); // istanbul ignore next
const $6260541dc56be833$var$useIsomorphicLayoutEffect = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined" ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
function $6260541dc56be833$var$useElementIds(_ref) {
    let { id: id = `downshift-${$6260541dc56be833$var$generateId()}`, labelId: labelId, menuId: menuId, getItemId: getItemId, toggleButtonId: toggleButtonId, inputId: inputId } = _ref;
    const elementIdsRef = (0, $acw62.useRef)({
        labelId: labelId || `${id}-label`,
        menuId: menuId || `${id}-menu`,
        getItemId: getItemId || ((index)=>`${id}-item-${index}`),
        toggleButtonId: toggleButtonId || `${id}-toggle-button`,
        inputId: inputId || `${id}-input`
    });
    return elementIdsRef.current;
}
function $6260541dc56be833$var$getItemIndex(index, item, items) {
    if (index !== undefined) return index;
    if (items.length === 0) return -1;
    return items.indexOf(item);
}
function $6260541dc56be833$var$itemToString(item) {
    return item ? String(item) : "";
}
function $6260541dc56be833$var$isAcceptedCharacterKey(key) {
    return /^\S{1}$/.test(key);
}
function $6260541dc56be833$var$capitalizeString(string) {
    return `${string.slice(0, 1).toUpperCase()}${string.slice(1)}`;
}
function $6260541dc56be833$var$useLatestRef(val) {
    const ref = (0, $acw62.useRef)(val); // technically this is not "concurrent mode safe" because we're manipulating
    // the value during render (so it's not idempotent). However, the places this
    // hook is used is to support memoizing callbacks which will be called
    // *during* render, so we need the latest values *during* render.
    // If not for this, then we'd probably want to use useLayoutEffect instead.
    ref.current = val;
    return ref;
}
/**
 * Computes the controlled state using a the previous state, props,
 * two reducers, one from downshift and an optional one from the user.
 * Also calls the onChange handlers for state values that have changed.
 *
 * @param {Function} reducer Reducer function from downshift.
 * @param {Object} initialState Initial state of the hook.
 * @param {Object} props The hook props.
 * @returns {Array} An array with the state and an action dispatcher.
 */ function $6260541dc56be833$var$useEnhancedReducer(reducer, initialState, props) {
    const prevStateRef = (0, $acw62.useRef)();
    const actionRef = (0, $acw62.useRef)();
    const enhancedReducer = (0, $acw62.useCallback)((state, action)=>{
        actionRef.current = action;
        state = $6260541dc56be833$var$getState(state, action.props);
        const changes = reducer(state, action);
        const newState = action.props.stateReducer(state, {
            ...action,
            changes: changes
        });
        return newState;
    }, [
        reducer
    ]);
    const [state, dispatch] = (0, $acw62.useReducer)(enhancedReducer, initialState);
    const propsRef = $6260541dc56be833$var$useLatestRef(props);
    const dispatchWithProps = (0, $acw62.useCallback)((action)=>dispatch({
            props: propsRef.current,
            ...action
        }), [
        propsRef
    ]);
    const action = actionRef.current;
    (0, $acw62.useEffect)(()=>{
        if (action && prevStateRef.current && prevStateRef.current !== state) $6260541dc56be833$var$callOnChangeProps(action, $6260541dc56be833$var$getState(prevStateRef.current, action.props), state);
        prevStateRef.current = state;
    }, [
        state,
        props,
        action
    ]);
    return [
        state,
        dispatchWithProps
    ];
}
/**
 * Wraps the useEnhancedReducer and applies the controlled prop values before
 * returning the new state.
 *
 * @param {Function} reducer Reducer function from downshift.
 * @param {Object} initialState Initial state of the hook.
 * @param {Object} props The hook props.
 * @returns {Array} An array with the state and an action dispatcher.
 */ function $6260541dc56be833$var$useControlledReducer$1(reducer, initialState, props) {
    const [state, dispatch] = $6260541dc56be833$var$useEnhancedReducer(reducer, initialState, props);
    return [
        $6260541dc56be833$var$getState(state, props),
        dispatch
    ];
}
const $6260541dc56be833$var$defaultProps$3 = {
    itemToString: $6260541dc56be833$var$itemToString,
    stateReducer: $6260541dc56be833$var$stateReducer,
    getA11ySelectionMessage: $6260541dc56be833$var$getA11ySelectionMessage,
    scrollIntoView: $6260541dc56be833$var$scrollIntoView,
    circularNavigation: false,
    environment: /* istanbul ignore next (ssr) */ typeof window === "undefined" ? {} : window
};
function $6260541dc56be833$var$getDefaultValue$1(props, propKey, defaultStateValues) {
    if (defaultStateValues === void 0) defaultStateValues = $6260541dc56be833$var$dropdownDefaultStateValues;
    const defaultValue = props[`default${$6260541dc56be833$var$capitalizeString(propKey)}`];
    if (defaultValue !== undefined) return defaultValue;
    return defaultStateValues[propKey];
}
function $6260541dc56be833$var$getInitialValue$1(props, propKey, defaultStateValues) {
    if (defaultStateValues === void 0) defaultStateValues = $6260541dc56be833$var$dropdownDefaultStateValues;
    const value = props[propKey];
    if (value !== undefined) return value;
    const initialValue = props[`initial${$6260541dc56be833$var$capitalizeString(propKey)}`];
    if (initialValue !== undefined) return initialValue;
    return $6260541dc56be833$var$getDefaultValue$1(props, propKey, defaultStateValues);
}
function $6260541dc56be833$var$getInitialState$2(props) {
    const selectedItem = $6260541dc56be833$var$getInitialValue$1(props, "selectedItem");
    const isOpen = $6260541dc56be833$var$getInitialValue$1(props, "isOpen");
    const highlightedIndex = $6260541dc56be833$var$getInitialValue$1(props, "highlightedIndex");
    const inputValue = $6260541dc56be833$var$getInitialValue$1(props, "inputValue");
    return {
        highlightedIndex: highlightedIndex < 0 && selectedItem && isOpen ? props.items.indexOf(selectedItem) : highlightedIndex,
        isOpen: isOpen,
        selectedItem: selectedItem,
        inputValue: inputValue
    };
}
function $6260541dc56be833$var$getHighlightedIndexOnOpen(props, state, offset, getItemNodeFromIndex) {
    const { items: items, initialHighlightedIndex: initialHighlightedIndex, defaultHighlightedIndex: defaultHighlightedIndex } = props;
    const { selectedItem: selectedItem, highlightedIndex: highlightedIndex } = state;
    if (items.length === 0) return -1;
     // initialHighlightedIndex will give value to highlightedIndex on initial state only.
    if (initialHighlightedIndex !== undefined && highlightedIndex === initialHighlightedIndex) return initialHighlightedIndex;
    if (defaultHighlightedIndex !== undefined) return defaultHighlightedIndex;
    if (selectedItem) {
        if (offset === 0) return items.indexOf(selectedItem);
        return $6260541dc56be833$var$getNextWrappingIndex(offset, items.indexOf(selectedItem), items.length, getItemNodeFromIndex, false);
    }
    if (offset === 0) return -1;
    return offset < 0 ? items.length - 1 : 0;
}
/**
 * Reuse the movement tracking of mouse and touch events.
 *
 * @param {boolean} isOpen Whether the dropdown is open or not.
 * @param {Array<Object>} downshiftElementRefs Downshift element refs to track movement (toggleButton, menu etc.)
 * @param {Object} environment Environment where component/hook exists.
 * @param {Function} handleBlur Handler on blur from mouse or touch.
 * @returns {Object} Ref containing whether mouseDown or touchMove event is happening
 */ function $6260541dc56be833$var$useMouseAndTouchTracker(isOpen, downshiftElementRefs, environment, handleBlur) {
    const mouseAndTouchTrackersRef = (0, $acw62.useRef)({
        isMouseDown: false,
        isTouchMove: false
    });
    (0, $acw62.useEffect)(()=>{
        // The same strategy for checking if a click occurred inside or outside downsift
        // as in downshift.js.
        const onMouseDown = ()=>{
            mouseAndTouchTrackersRef.current.isMouseDown = true;
        };
        const onMouseUp = (event)=>{
            mouseAndTouchTrackersRef.current.isMouseDown = false;
            if (isOpen && !$6260541dc56be833$var$targetWithinDownshift(event.target, downshiftElementRefs.map((ref)=>ref.current), environment)) handleBlur();
        };
        const onTouchStart = ()=>{
            mouseAndTouchTrackersRef.current.isTouchMove = false;
        };
        const onTouchMove = ()=>{
            mouseAndTouchTrackersRef.current.isTouchMove = true;
        };
        const onTouchEnd = (event)=>{
            if (isOpen && !mouseAndTouchTrackersRef.current.isTouchMove && !$6260541dc56be833$var$targetWithinDownshift(event.target, downshiftElementRefs.map((ref)=>ref.current), environment, false)) handleBlur();
        };
        environment.addEventListener("mousedown", onMouseDown);
        environment.addEventListener("mouseup", onMouseUp);
        environment.addEventListener("touchstart", onTouchStart);
        environment.addEventListener("touchmove", onTouchMove);
        environment.addEventListener("touchend", onTouchEnd);
        return function cleanup() {
            environment.removeEventListener("mousedown", onMouseDown);
            environment.removeEventListener("mouseup", onMouseUp);
            environment.removeEventListener("touchstart", onTouchStart);
            environment.removeEventListener("touchmove", onTouchMove);
            environment.removeEventListener("touchend", onTouchEnd);
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isOpen,
        environment
    ]);
    return mouseAndTouchTrackersRef;
}
/* istanbul ignore next */ // eslint-disable-next-line import/no-mutable-exports
let $6260541dc56be833$var$useGetterPropsCalledChecker = ()=>$6260541dc56be833$var$noop;
function $6260541dc56be833$var$useA11yMessageSetter(getA11yMessage, dependencyArray, _ref2) {
    let { isInitialMount: isInitialMount, highlightedIndex: highlightedIndex, items: items, environment: environment, ...rest } = _ref2;
    // Sets a11y status message on changes in state.
    (0, $acw62.useEffect)(()=>{
        if (isInitialMount || false) return;
        $6260541dc56be833$var$updateA11yStatus(()=>getA11yMessage({
                highlightedIndex: highlightedIndex,
                highlightedItem: items[highlightedIndex],
                resultCount: items.length,
                ...rest
            }), environment.document); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencyArray);
}
function $6260541dc56be833$var$useScrollIntoView(_ref3) {
    let { highlightedIndex: highlightedIndex, isOpen: isOpen, itemRefs: itemRefs, getItemNodeFromIndex: getItemNodeFromIndex, menuElement: menuElement, scrollIntoView: scrollIntoViewProp } = _ref3;
    // used not to scroll on highlight by mouse.
    const shouldScrollRef = (0, $acw62.useRef)(true); // Scroll on highlighted item if change comes from keyboard.
    $6260541dc56be833$var$useIsomorphicLayoutEffect(()=>{
        if (highlightedIndex < 0 || !isOpen || !Object.keys(itemRefs.current).length) return;
        if (shouldScrollRef.current === false) shouldScrollRef.current = true;
        else scrollIntoViewProp(getItemNodeFromIndex(highlightedIndex), menuElement);
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        highlightedIndex
    ]);
    return shouldScrollRef;
} // eslint-disable-next-line import/no-mutable-exports
let $6260541dc56be833$var$useControlPropsValidator = $6260541dc56be833$var$noop;
var $6260541dc56be833$var$_ref4;
/* eslint-disable complexity */ function $6260541dc56be833$var$downshiftCommonReducer(state, action, stateChangeTypes) {
    const { type: type, props: props } = action;
    let changes;
    switch(type){
        case stateChangeTypes.ItemMouseMove:
            changes = {
                highlightedIndex: action.disabled ? -1 : action.index
            };
            break;
        case stateChangeTypes.MenuMouseLeave:
            changes = {
                highlightedIndex: -1
            };
            break;
        case stateChangeTypes.ToggleButtonClick:
        case stateChangeTypes.FunctionToggleMenu:
            changes = {
                isOpen: !state.isOpen,
                highlightedIndex: state.isOpen ? -1 : $6260541dc56be833$var$getHighlightedIndexOnOpen(props, state, 0)
            };
            break;
        case stateChangeTypes.FunctionOpenMenu:
            changes = {
                isOpen: true,
                highlightedIndex: $6260541dc56be833$var$getHighlightedIndexOnOpen(props, state, 0)
            };
            break;
        case stateChangeTypes.FunctionCloseMenu:
            changes = {
                isOpen: false
            };
            break;
        case stateChangeTypes.FunctionSetHighlightedIndex:
            changes = {
                highlightedIndex: action.highlightedIndex
            };
            break;
        case stateChangeTypes.FunctionSetInputValue:
            changes = {
                inputValue: action.inputValue
            };
            break;
        case stateChangeTypes.FunctionReset:
            changes = {
                highlightedIndex: $6260541dc56be833$var$getDefaultValue$1(props, "highlightedIndex"),
                isOpen: $6260541dc56be833$var$getDefaultValue$1(props, "isOpen"),
                selectedItem: $6260541dc56be833$var$getDefaultValue$1(props, "selectedItem"),
                inputValue: $6260541dc56be833$var$getDefaultValue$1(props, "inputValue")
            };
            break;
        default:
            throw new Error("Reducer called without proper action type.");
    }
    return {
        ...state,
        ...changes
    };
}
/* eslint-enable complexity */ function $6260541dc56be833$var$getItemIndexByCharacterKey(_a) {
    var keysSoFar = _a.keysSoFar, highlightedIndex = _a.highlightedIndex, items = _a.items, itemToString = _a.itemToString, getItemNodeFromIndex = _a.getItemNodeFromIndex;
    var lowerCasedKeysSoFar = keysSoFar.toLowerCase();
    for(var index = 0; index < items.length; index++){
        var offsetIndex = (index + highlightedIndex + 1) % items.length;
        var item = items[offsetIndex];
        if (item !== undefined && itemToString(item).toLowerCase().startsWith(lowerCasedKeysSoFar)) {
            var element = getItemNodeFromIndex(offsetIndex);
            if (!(element === null || element === void 0 ? void 0 : element.hasAttribute("disabled"))) return offsetIndex;
        }
    }
    return highlightedIndex;
}
var $6260541dc56be833$var$propTypes$2 = {
    items: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array.isRequired,
    itemToString: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    getA11yStatusMessage: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    getA11ySelectionMessage: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    circularNavigation: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    highlightedIndex: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    defaultHighlightedIndex: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    initialHighlightedIndex: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    defaultIsOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    initialIsOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    selectedItem: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    initialSelectedItem: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    defaultSelectedItem: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    labelId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    menuId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    getItemId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    toggleButtonId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    stateReducer: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onSelectedItemChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onHighlightedIndexChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onStateChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onIsOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    environment: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        addEventListener: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        removeEventListener: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        document: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            getElementById: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            activeElement: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
            body: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any
        })
    })
};
/**
 * Default implementation for status message. Only added when menu is open.
 * Will specift if there are results in the list, and if so, how many,
 * and what keys are relevant.
 *
 * @param {Object} param the downshift state and other relevant properties
 * @return {String} the a11y status message
 */ function $6260541dc56be833$var$getA11yStatusMessage(_a) {
    var isOpen = _a.isOpen, resultCount = _a.resultCount, previousResultCount = _a.previousResultCount;
    if (!isOpen) return "";
    if (!resultCount) return "No results are available.";
    if (resultCount !== previousResultCount) return "".concat(resultCount, " result").concat(resultCount === 1 ? " is" : "s are", " available, use up and down arrow keys to navigate. Press Enter or Space Bar keys to select.");
    return "";
}
var $6260541dc56be833$var$defaultProps$2 = (0, $5c96a02c592fcff1$export$18ce0697a983be9b)((0, $5c96a02c592fcff1$export$18ce0697a983be9b)({}, $6260541dc56be833$var$defaultProps$3), {
    getA11yStatusMessage: $6260541dc56be833$var$getA11yStatusMessage
});
// eslint-disable-next-line import/no-mutable-exports
var $6260541dc56be833$var$validatePropTypes$2 = $6260541dc56be833$var$noop;
const $6260541dc56be833$var$MenuKeyDownArrowDown = 0;
const $6260541dc56be833$var$MenuKeyDownArrowUp = 1;
const $6260541dc56be833$var$MenuKeyDownEscape = 2;
const $6260541dc56be833$var$MenuKeyDownHome = 3;
const $6260541dc56be833$var$MenuKeyDownEnd = 4;
const $6260541dc56be833$var$MenuKeyDownEnter = 5;
const $6260541dc56be833$var$MenuKeyDownSpaceButton = 6;
const $6260541dc56be833$var$MenuKeyDownCharacter = 7;
const $6260541dc56be833$var$MenuBlur = 8;
const $6260541dc56be833$var$MenuMouseLeave$1 = 9;
const $6260541dc56be833$var$ItemMouseMove$1 = 10;
const $6260541dc56be833$var$ItemClick$1 = 11;
const $6260541dc56be833$var$ToggleButtonClick$1 = 12;
const $6260541dc56be833$var$ToggleButtonKeyDownArrowDown = 13;
const $6260541dc56be833$var$ToggleButtonKeyDownArrowUp = 14;
const $6260541dc56be833$var$ToggleButtonKeyDownCharacter = 15;
const $6260541dc56be833$var$FunctionToggleMenu$1 = 16;
const $6260541dc56be833$var$FunctionOpenMenu$1 = 17;
const $6260541dc56be833$var$FunctionCloseMenu$1 = 18;
const $6260541dc56be833$var$FunctionSetHighlightedIndex$1 = 19;
const $6260541dc56be833$var$FunctionSelectItem$1 = 20;
const $6260541dc56be833$var$FunctionSetInputValue$1 = 21;
const $6260541dc56be833$var$FunctionReset$2 = 22;
var $6260541dc56be833$var$stateChangeTypes$2 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    MenuKeyDownArrowDown: $6260541dc56be833$var$MenuKeyDownArrowDown,
    MenuKeyDownArrowUp: $6260541dc56be833$var$MenuKeyDownArrowUp,
    MenuKeyDownEscape: $6260541dc56be833$var$MenuKeyDownEscape,
    MenuKeyDownHome: $6260541dc56be833$var$MenuKeyDownHome,
    MenuKeyDownEnd: $6260541dc56be833$var$MenuKeyDownEnd,
    MenuKeyDownEnter: $6260541dc56be833$var$MenuKeyDownEnter,
    MenuKeyDownSpaceButton: $6260541dc56be833$var$MenuKeyDownSpaceButton,
    MenuKeyDownCharacter: $6260541dc56be833$var$MenuKeyDownCharacter,
    MenuBlur: $6260541dc56be833$var$MenuBlur,
    MenuMouseLeave: $6260541dc56be833$var$MenuMouseLeave$1,
    ItemMouseMove: $6260541dc56be833$var$ItemMouseMove$1,
    ItemClick: $6260541dc56be833$var$ItemClick$1,
    ToggleButtonClick: $6260541dc56be833$var$ToggleButtonClick$1,
    ToggleButtonKeyDownArrowDown: $6260541dc56be833$var$ToggleButtonKeyDownArrowDown,
    ToggleButtonKeyDownArrowUp: $6260541dc56be833$var$ToggleButtonKeyDownArrowUp,
    ToggleButtonKeyDownCharacter: $6260541dc56be833$var$ToggleButtonKeyDownCharacter,
    FunctionToggleMenu: $6260541dc56be833$var$FunctionToggleMenu$1,
    FunctionOpenMenu: $6260541dc56be833$var$FunctionOpenMenu$1,
    FunctionCloseMenu: $6260541dc56be833$var$FunctionCloseMenu$1,
    FunctionSetHighlightedIndex: $6260541dc56be833$var$FunctionSetHighlightedIndex$1,
    FunctionSelectItem: $6260541dc56be833$var$FunctionSelectItem$1,
    FunctionSetInputValue: $6260541dc56be833$var$FunctionSetInputValue$1,
    FunctionReset: $6260541dc56be833$var$FunctionReset$2
});
/* eslint-disable complexity */ function $6260541dc56be833$var$downshiftSelectReducer(state, action) {
    const { type: type, props: props, shiftKey: shiftKey } = action;
    let changes;
    switch(type){
        case $6260541dc56be833$var$ItemClick$1:
            changes = {
                isOpen: $6260541dc56be833$var$getDefaultValue$1(props, "isOpen"),
                highlightedIndex: $6260541dc56be833$var$getDefaultValue$1(props, "highlightedIndex"),
                selectedItem: props.items[action.index]
            };
            break;
        case $6260541dc56be833$var$ToggleButtonKeyDownCharacter:
            {
                const lowercasedKey = action.key;
                const inputValue = `${state.inputValue}${lowercasedKey}`;
                const itemIndex = $6260541dc56be833$var$getItemIndexByCharacterKey({
                    keysSoFar: inputValue,
                    highlightedIndex: state.selectedItem ? props.items.indexOf(state.selectedItem) : -1,
                    items: props.items,
                    itemToString: props.itemToString,
                    getItemNodeFromIndex: action.getItemNodeFromIndex
                });
                changes = {
                    inputValue: inputValue,
                    ...itemIndex >= 0 && {
                        selectedItem: props.items[itemIndex]
                    }
                };
            }
            break;
        case $6260541dc56be833$var$ToggleButtonKeyDownArrowDown:
            changes = {
                highlightedIndex: $6260541dc56be833$var$getHighlightedIndexOnOpen(props, state, 1, action.getItemNodeFromIndex),
                isOpen: true
            };
            break;
        case $6260541dc56be833$var$ToggleButtonKeyDownArrowUp:
            changes = {
                highlightedIndex: $6260541dc56be833$var$getHighlightedIndexOnOpen(props, state, -1, action.getItemNodeFromIndex),
                isOpen: true
            };
            break;
        case $6260541dc56be833$var$MenuKeyDownEnter:
        case $6260541dc56be833$var$MenuKeyDownSpaceButton:
            changes = {
                isOpen: $6260541dc56be833$var$getDefaultValue$1(props, "isOpen"),
                highlightedIndex: $6260541dc56be833$var$getDefaultValue$1(props, "highlightedIndex"),
                ...state.highlightedIndex >= 0 && {
                    selectedItem: props.items[state.highlightedIndex]
                }
            };
            break;
        case $6260541dc56be833$var$MenuKeyDownHome:
            changes = {
                highlightedIndex: $6260541dc56be833$var$getNextNonDisabledIndex(1, 0, props.items.length, action.getItemNodeFromIndex, false)
            };
            break;
        case $6260541dc56be833$var$MenuKeyDownEnd:
            changes = {
                highlightedIndex: $6260541dc56be833$var$getNextNonDisabledIndex(-1, props.items.length - 1, props.items.length, action.getItemNodeFromIndex, false)
            };
            break;
        case $6260541dc56be833$var$MenuKeyDownEscape:
            changes = {
                isOpen: false,
                highlightedIndex: -1
            };
            break;
        case $6260541dc56be833$var$MenuBlur:
            changes = {
                isOpen: false,
                highlightedIndex: -1
            };
            break;
        case $6260541dc56be833$var$MenuKeyDownCharacter:
            {
                const lowercasedKey = action.key;
                const inputValue = `${state.inputValue}${lowercasedKey}`;
                const highlightedIndex = $6260541dc56be833$var$getItemIndexByCharacterKey({
                    keysSoFar: inputValue,
                    highlightedIndex: state.highlightedIndex,
                    items: props.items,
                    itemToString: props.itemToString,
                    getItemNodeFromIndex: action.getItemNodeFromIndex
                });
                changes = {
                    inputValue: inputValue,
                    ...highlightedIndex >= 0 && {
                        highlightedIndex: highlightedIndex
                    }
                };
            }
            break;
        case $6260541dc56be833$var$MenuKeyDownArrowDown:
            changes = {
                highlightedIndex: $6260541dc56be833$var$getNextWrappingIndex(shiftKey ? 5 : 1, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, props.circularNavigation)
            };
            break;
        case $6260541dc56be833$var$MenuKeyDownArrowUp:
            changes = {
                highlightedIndex: $6260541dc56be833$var$getNextWrappingIndex(shiftKey ? -5 : -1, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, props.circularNavigation)
            };
            break;
        case $6260541dc56be833$var$FunctionSelectItem$1:
            changes = {
                selectedItem: action.selectedItem
            };
            break;
        default:
            return $6260541dc56be833$var$downshiftCommonReducer(state, action, $6260541dc56be833$var$stateChangeTypes$2);
    }
    return {
        ...state,
        ...changes
    };
}
/* eslint-enable complexity */ /* eslint-disable max-statements */ $6260541dc56be833$export$e64b2f635402ca43.stateChangeTypes = $6260541dc56be833$var$stateChangeTypes$2;
function $6260541dc56be833$export$e64b2f635402ca43(userProps) {
    if (userProps === void 0) userProps = {};
    $6260541dc56be833$var$validatePropTypes$2(userProps, $6260541dc56be833$export$e64b2f635402ca43); // Props defaults and destructuring.
    const props = {
        ...$6260541dc56be833$var$defaultProps$2,
        ...userProps
    };
    const { items: items, scrollIntoView: scrollIntoView, environment: environment, initialIsOpen: initialIsOpen, defaultIsOpen: defaultIsOpen, itemToString: itemToString, getA11ySelectionMessage: getA11ySelectionMessage, getA11yStatusMessage: getA11yStatusMessage } = props; // Initial state depending on controlled props.
    const initialState = $6260541dc56be833$var$getInitialState$2(props);
    const [state, dispatch] = $6260541dc56be833$var$useControlledReducer$1($6260541dc56be833$var$downshiftSelectReducer, initialState, props);
    const { isOpen: isOpen, highlightedIndex: highlightedIndex, selectedItem: selectedItem, inputValue: inputValue } = state; // Element efs.
    const toggleButtonRef = (0, $acw62.useRef)(null);
    const menuRef = (0, $acw62.useRef)(null);
    const itemRefs = (0, $acw62.useRef)({}); // used not to trigger menu blur action in some scenarios.
    const shouldBlurRef = (0, $acw62.useRef)(true); // used to keep the inputValue clearTimeout object between renders.
    const clearTimeoutRef = (0, $acw62.useRef)(null); // prevent id re-generation between renders.
    const elementIds = $6260541dc56be833$var$useElementIds(props); // used to keep track of how many items we had on previous cycle.
    const previousResultCountRef = (0, $acw62.useRef)();
    const isInitialMountRef = (0, $acw62.useRef)(true); // utility callback to get item element.
    const latest = $6260541dc56be833$var$useLatestRef({
        state: state,
        props: props
    }); // Some utils.
    const getItemNodeFromIndex = (0, $acw62.useCallback)((index)=>itemRefs.current[elementIds.getItemId(index)], [
        elementIds
    ]); // Effects.
    // Sets a11y status message on changes in state.
    $6260541dc56be833$var$useA11yMessageSetter(getA11yStatusMessage, [
        isOpen,
        highlightedIndex,
        inputValue,
        items
    ], {
        isInitialMount: isInitialMountRef.current,
        previousResultCount: previousResultCountRef.current,
        items: items,
        environment: environment,
        itemToString: itemToString,
        ...state
    }); // Sets a11y status message on changes in selectedItem.
    $6260541dc56be833$var$useA11yMessageSetter(getA11ySelectionMessage, [
        selectedItem
    ], {
        isInitialMount: isInitialMountRef.current,
        previousResultCount: previousResultCountRef.current,
        items: items,
        environment: environment,
        itemToString: itemToString,
        ...state
    }); // Scroll on highlighted item if change comes from keyboard.
    const shouldScrollRef = $6260541dc56be833$var$useScrollIntoView({
        menuElement: menuRef.current,
        highlightedIndex: highlightedIndex,
        isOpen: isOpen,
        itemRefs: itemRefs,
        scrollIntoView: scrollIntoView,
        getItemNodeFromIndex: getItemNodeFromIndex
    }); // Sets cleanup for the keysSoFar callback, debounded after 500ms.
    (0, $acw62.useEffect)(()=>{
        // init the clean function here as we need access to dispatch.
        clearTimeoutRef.current = $6260541dc56be833$var$debounce((outerDispatch)=>{
            outerDispatch({
                type: $6260541dc56be833$var$FunctionSetInputValue$1,
                inputValue: ""
            });
        }, 500); // Cancel any pending debounced calls on mount
        return ()=>{
            clearTimeoutRef.current.cancel();
        };
    }, []); // Invokes the keysSoFar callback set up above.
    (0, $acw62.useEffect)(()=>{
        if (!inputValue) return;
        clearTimeoutRef.current(dispatch);
    }, [
        dispatch,
        inputValue
    ]);
    $6260541dc56be833$var$useControlPropsValidator({
        isInitialMount: isInitialMountRef.current,
        props: props,
        state: state
    });
    /* Controls the focus on the menu or the toggle button. */ (0, $acw62.useEffect)(()=>{
        // Don't focus menu on first render.
        if (isInitialMountRef.current) {
            // Unless it was initialised as open.
            if ((initialIsOpen || defaultIsOpen || isOpen) && menuRef.current) menuRef.current.focus();
            return;
        } // Focus menu on open.
        if (isOpen) {
            // istanbul ignore else
            if (menuRef.current) menuRef.current.focus();
            return;
        } // Focus toggleButton on close, but not if it was closed with (Shift+)Tab.
        if (environment.document.activeElement === menuRef.current) // istanbul ignore else
        {
            if (toggleButtonRef.current) {
                shouldBlurRef.current = false;
                toggleButtonRef.current.focus();
            }
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isOpen
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isInitialMountRef.current) return;
        previousResultCountRef.current = items.length;
    }); // Add mouse/touch events to document.
    const mouseAndTouchTrackersRef = $6260541dc56be833$var$useMouseAndTouchTracker(isOpen, [
        menuRef,
        toggleButtonRef
    ], environment, ()=>{
        dispatch({
            type: $6260541dc56be833$var$MenuBlur
        });
    });
    const setGetterPropCallInfo = $6260541dc56be833$var$useGetterPropsCalledChecker("getMenuProps", "getToggleButtonProps"); // Make initial ref false.
    (0, $acw62.useEffect)(()=>{
        isInitialMountRef.current = false;
    }, []); // Reset itemRefs on close.
    (0, $acw62.useEffect)(()=>{
        if (!isOpen) itemRefs.current = {};
    }, [
        isOpen
    ]); // Event handler functions.
    const toggleButtonKeyDownHandlers = (0, $acw62.useMemo)(()=>({
            ArrowDown (event) {
                event.preventDefault();
                dispatch({
                    type: $6260541dc56be833$var$ToggleButtonKeyDownArrowDown,
                    getItemNodeFromIndex: getItemNodeFromIndex,
                    shiftKey: event.shiftKey
                });
            },
            ArrowUp (event) {
                event.preventDefault();
                dispatch({
                    type: $6260541dc56be833$var$ToggleButtonKeyDownArrowUp,
                    getItemNodeFromIndex: getItemNodeFromIndex,
                    shiftKey: event.shiftKey
                });
            }
        }), [
        dispatch,
        getItemNodeFromIndex
    ]);
    const menuKeyDownHandlers = (0, $acw62.useMemo)(()=>({
            ArrowDown (event) {
                event.preventDefault();
                dispatch({
                    type: $6260541dc56be833$var$MenuKeyDownArrowDown,
                    getItemNodeFromIndex: getItemNodeFromIndex,
                    shiftKey: event.shiftKey
                });
            },
            ArrowUp (event) {
                event.preventDefault();
                dispatch({
                    type: $6260541dc56be833$var$MenuKeyDownArrowUp,
                    getItemNodeFromIndex: getItemNodeFromIndex,
                    shiftKey: event.shiftKey
                });
            },
            Home (event) {
                event.preventDefault();
                dispatch({
                    type: $6260541dc56be833$var$MenuKeyDownHome,
                    getItemNodeFromIndex: getItemNodeFromIndex
                });
            },
            End (event) {
                event.preventDefault();
                dispatch({
                    type: $6260541dc56be833$var$MenuKeyDownEnd,
                    getItemNodeFromIndex: getItemNodeFromIndex
                });
            },
            Escape () {
                dispatch({
                    type: $6260541dc56be833$var$MenuKeyDownEscape
                });
            },
            Enter (event) {
                event.preventDefault();
                dispatch({
                    type: $6260541dc56be833$var$MenuKeyDownEnter
                });
            },
            " " (event) {
                event.preventDefault();
                dispatch({
                    type: $6260541dc56be833$var$MenuKeyDownSpaceButton
                });
            }
        }), [
        dispatch,
        getItemNodeFromIndex
    ]); // Action functions.
    const toggleMenu = (0, $acw62.useCallback)(()=>{
        dispatch({
            type: $6260541dc56be833$var$FunctionToggleMenu$1
        });
    }, [
        dispatch
    ]);
    const closeMenu = (0, $acw62.useCallback)(()=>{
        dispatch({
            type: $6260541dc56be833$var$FunctionCloseMenu$1
        });
    }, [
        dispatch
    ]);
    const openMenu = (0, $acw62.useCallback)(()=>{
        dispatch({
            type: $6260541dc56be833$var$FunctionOpenMenu$1
        });
    }, [
        dispatch
    ]);
    const setHighlightedIndex = (0, $acw62.useCallback)((newHighlightedIndex)=>{
        dispatch({
            type: $6260541dc56be833$var$FunctionSetHighlightedIndex$1,
            highlightedIndex: newHighlightedIndex
        });
    }, [
        dispatch
    ]);
    const selectItem = (0, $acw62.useCallback)((newSelectedItem)=>{
        dispatch({
            type: $6260541dc56be833$var$FunctionSelectItem$1,
            selectedItem: newSelectedItem
        });
    }, [
        dispatch
    ]);
    const reset = (0, $acw62.useCallback)(()=>{
        dispatch({
            type: $6260541dc56be833$var$FunctionReset$2
        });
    }, [
        dispatch
    ]);
    const setInputValue = (0, $acw62.useCallback)((newInputValue)=>{
        dispatch({
            type: $6260541dc56be833$var$FunctionSetInputValue$1,
            inputValue: newInputValue
        });
    }, [
        dispatch
    ]); // Getter functions.
    const getLabelProps = (0, $acw62.useCallback)((labelProps)=>({
            id: elementIds.labelId,
            htmlFor: elementIds.toggleButtonId,
            ...labelProps
        }), [
        elementIds
    ]);
    const getMenuProps = (0, $acw62.useCallback)(function(_temp, _temp2) {
        let { onMouseLeave: onMouseLeave, refKey: refKey = "ref", onKeyDown: onKeyDown, onBlur: onBlur, ref: ref, ...rest } = _temp === void 0 ? {} : _temp;
        let { suppressRefError: suppressRefError = false } = _temp2 === void 0 ? {} : _temp2;
        const latestState = latest.current.state;
        const menuHandleKeyDown = (event)=>{
            const key = $6260541dc56be833$var$normalizeArrowKey(event);
            if (key && menuKeyDownHandlers[key]) menuKeyDownHandlers[key](event);
            else if ($6260541dc56be833$var$isAcceptedCharacterKey(key)) dispatch({
                type: $6260541dc56be833$var$MenuKeyDownCharacter,
                key: key,
                getItemNodeFromIndex: getItemNodeFromIndex
            });
        };
        const menuHandleBlur = ()=>{
            // if the blur was a result of selection, we don't trigger this action.
            if (shouldBlurRef.current === false) {
                shouldBlurRef.current = true;
                return;
            }
            const shouldBlur = !mouseAndTouchTrackersRef.current.isMouseDown;
            /* istanbul ignore else */ if (shouldBlur) dispatch({
                type: $6260541dc56be833$var$MenuBlur
            });
        };
        const menuHandleMouseLeave = ()=>{
            dispatch({
                type: $6260541dc56be833$var$MenuMouseLeave$1
            });
        };
        setGetterPropCallInfo("getMenuProps", suppressRefError, refKey, menuRef);
        return {
            [refKey]: $6260541dc56be833$var$handleRefs(ref, (menuNode)=>{
                menuRef.current = menuNode;
            }),
            id: elementIds.menuId,
            role: "listbox",
            "aria-labelledby": elementIds.labelId,
            tabIndex: -1,
            ...latestState.isOpen && latestState.highlightedIndex > -1 && {
                "aria-activedescendant": elementIds.getItemId(latestState.highlightedIndex)
            },
            onMouseLeave: $6260541dc56be833$var$callAllEventHandlers(onMouseLeave, menuHandleMouseLeave),
            onKeyDown: $6260541dc56be833$var$callAllEventHandlers(onKeyDown, menuHandleKeyDown),
            onBlur: $6260541dc56be833$var$callAllEventHandlers(onBlur, menuHandleBlur),
            ...rest
        };
    }, [
        dispatch,
        latest,
        menuKeyDownHandlers,
        mouseAndTouchTrackersRef,
        setGetterPropCallInfo,
        elementIds,
        getItemNodeFromIndex
    ]);
    const getToggleButtonProps = (0, $acw62.useCallback)(function(_temp3, _temp4) {
        let { onClick: onClick, onKeyDown: onKeyDown, refKey: refKey = "ref", ref: ref, ...rest } = _temp3 === void 0 ? {} : _temp3;
        let { suppressRefError: suppressRefError = false } = _temp4 === void 0 ? {} : _temp4;
        const toggleButtonHandleClick = ()=>{
            dispatch({
                type: $6260541dc56be833$var$ToggleButtonClick$1
            });
        };
        const toggleButtonHandleKeyDown = (event)=>{
            const key = $6260541dc56be833$var$normalizeArrowKey(event);
            if (key && toggleButtonKeyDownHandlers[key]) toggleButtonKeyDownHandlers[key](event);
            else if ($6260541dc56be833$var$isAcceptedCharacterKey(key)) dispatch({
                type: $6260541dc56be833$var$ToggleButtonKeyDownCharacter,
                key: key,
                getItemNodeFromIndex: getItemNodeFromIndex
            });
        };
        const toggleProps = {
            [refKey]: $6260541dc56be833$var$handleRefs(ref, (toggleButtonNode)=>{
                toggleButtonRef.current = toggleButtonNode;
            }),
            id: elementIds.toggleButtonId,
            "aria-haspopup": "listbox",
            "aria-expanded": latest.current.state.isOpen,
            "aria-labelledby": `${elementIds.labelId} ${elementIds.toggleButtonId}`,
            ...rest
        };
        if (!rest.disabled) {
            toggleProps.onClick = $6260541dc56be833$var$callAllEventHandlers(onClick, toggleButtonHandleClick);
            toggleProps.onKeyDown = $6260541dc56be833$var$callAllEventHandlers(onKeyDown, toggleButtonHandleKeyDown);
        }
        setGetterPropCallInfo("getToggleButtonProps", suppressRefError, refKey, toggleButtonRef);
        return toggleProps;
    }, [
        dispatch,
        latest,
        toggleButtonKeyDownHandlers,
        setGetterPropCallInfo,
        elementIds,
        getItemNodeFromIndex
    ]);
    const getItemProps = (0, $acw62.useCallback)(function(_temp5) {
        let { item: item, index: index, onMouseMove: onMouseMove, onClick: onClick, refKey: refKey = "ref", ref: ref, disabled: disabled, ...rest } = _temp5 === void 0 ? {} : _temp5;
        const { state: latestState, props: latestProps } = latest.current;
        const itemHandleMouseMove = ()=>{
            if (index === latestState.highlightedIndex) return;
            shouldScrollRef.current = false;
            dispatch({
                type: $6260541dc56be833$var$ItemMouseMove$1,
                index: index,
                disabled: disabled
            });
        };
        const itemHandleClick = ()=>{
            dispatch({
                type: $6260541dc56be833$var$ItemClick$1,
                index: index
            });
        };
        const itemIndex = $6260541dc56be833$var$getItemIndex(index, item, latestProps.items);
        if (itemIndex < 0) throw new Error("Pass either item or item index in getItemProps!");
        const itemProps = {
            disabled: disabled,
            role: "option",
            "aria-selected": `${itemIndex === latestState.highlightedIndex}`,
            id: elementIds.getItemId(itemIndex),
            [refKey]: $6260541dc56be833$var$handleRefs(ref, (itemNode)=>{
                if (itemNode) itemRefs.current[elementIds.getItemId(itemIndex)] = itemNode;
            }),
            ...rest
        };
        if (!disabled) itemProps.onClick = $6260541dc56be833$var$callAllEventHandlers(onClick, itemHandleClick);
        itemProps.onMouseMove = $6260541dc56be833$var$callAllEventHandlers(onMouseMove, itemHandleMouseMove);
        return itemProps;
    }, [
        dispatch,
        latest,
        shouldScrollRef,
        elementIds
    ]);
    return {
        getToggleButtonProps: // prop getters.
        getToggleButtonProps,
        getLabelProps: getLabelProps,
        getMenuProps: getMenuProps,
        getItemProps: getItemProps,
        toggleMenu: // actions.
        toggleMenu,
        openMenu: openMenu,
        closeMenu: closeMenu,
        setHighlightedIndex: setHighlightedIndex,
        selectItem: selectItem,
        reset: reset,
        setInputValue: setInputValue,
        highlightedIndex: // state.
        highlightedIndex,
        isOpen: isOpen,
        selectedItem: selectedItem,
        inputValue: inputValue
    };
}
const $6260541dc56be833$var$InputKeyDownArrowDown = 0;
const $6260541dc56be833$var$InputKeyDownArrowUp = 1;
const $6260541dc56be833$var$InputKeyDownEscape = 2;
const $6260541dc56be833$var$InputKeyDownHome = 3;
const $6260541dc56be833$var$InputKeyDownEnd = 4;
const $6260541dc56be833$var$InputKeyDownEnter = 5;
const $6260541dc56be833$var$InputChange = 6;
const $6260541dc56be833$var$InputBlur = 7;
const $6260541dc56be833$var$MenuMouseLeave = 8;
const $6260541dc56be833$var$ItemMouseMove = 9;
const $6260541dc56be833$var$ItemClick = 10;
const $6260541dc56be833$var$ToggleButtonClick = 11;
const $6260541dc56be833$var$FunctionToggleMenu = 12;
const $6260541dc56be833$var$FunctionOpenMenu = 13;
const $6260541dc56be833$var$FunctionCloseMenu = 14;
const $6260541dc56be833$var$FunctionSetHighlightedIndex = 15;
const $6260541dc56be833$var$FunctionSelectItem = 16;
const $6260541dc56be833$var$FunctionSetInputValue = 17;
const $6260541dc56be833$var$FunctionReset$1 = 18;
const $6260541dc56be833$var$ControlledPropUpdatedSelectedItem = 19;
var $6260541dc56be833$var$stateChangeTypes$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    InputKeyDownArrowDown: $6260541dc56be833$var$InputKeyDownArrowDown,
    InputKeyDownArrowUp: $6260541dc56be833$var$InputKeyDownArrowUp,
    InputKeyDownEscape: $6260541dc56be833$var$InputKeyDownEscape,
    InputKeyDownHome: $6260541dc56be833$var$InputKeyDownHome,
    InputKeyDownEnd: $6260541dc56be833$var$InputKeyDownEnd,
    InputKeyDownEnter: $6260541dc56be833$var$InputKeyDownEnter,
    InputChange: $6260541dc56be833$var$InputChange,
    InputBlur: $6260541dc56be833$var$InputBlur,
    MenuMouseLeave: $6260541dc56be833$var$MenuMouseLeave,
    ItemMouseMove: $6260541dc56be833$var$ItemMouseMove,
    ItemClick: $6260541dc56be833$var$ItemClick,
    ToggleButtonClick: $6260541dc56be833$var$ToggleButtonClick,
    FunctionToggleMenu: $6260541dc56be833$var$FunctionToggleMenu,
    FunctionOpenMenu: $6260541dc56be833$var$FunctionOpenMenu,
    FunctionCloseMenu: $6260541dc56be833$var$FunctionCloseMenu,
    FunctionSetHighlightedIndex: $6260541dc56be833$var$FunctionSetHighlightedIndex,
    FunctionSelectItem: $6260541dc56be833$var$FunctionSelectItem,
    FunctionSetInputValue: $6260541dc56be833$var$FunctionSetInputValue,
    FunctionReset: $6260541dc56be833$var$FunctionReset$1,
    ControlledPropUpdatedSelectedItem: $6260541dc56be833$var$ControlledPropUpdatedSelectedItem
});
function $6260541dc56be833$var$getInitialState$1(props) {
    const initialState = $6260541dc56be833$var$getInitialState$2(props);
    const { selectedItem: selectedItem } = initialState;
    let { inputValue: inputValue } = initialState;
    if (inputValue === "" && selectedItem && props.defaultInputValue === undefined && props.initialInputValue === undefined && props.inputValue === undefined) inputValue = props.itemToString(selectedItem);
    return {
        ...initialState,
        inputValue: inputValue
    };
}
const $6260541dc56be833$var$propTypes$1 = {
    items: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array.isRequired,
    itemToString: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    getA11yStatusMessage: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    getA11ySelectionMessage: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    circularNavigation: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    highlightedIndex: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    defaultHighlightedIndex: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    initialHighlightedIndex: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    defaultIsOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    initialIsOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    selectedItem: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    initialSelectedItem: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    defaultSelectedItem: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    inputValue: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    defaultInputValue: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    initialInputValue: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    labelId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    menuId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    getItemId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    inputId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    toggleButtonId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    stateReducer: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onSelectedItemChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onHighlightedIndexChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onStateChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onIsOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onInputValueChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    environment: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        addEventListener: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        removeEventListener: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        document: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            getElementById: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            activeElement: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
            body: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any
        })
    })
};
/**
 * The useCombobox version of useControlledReducer, which also
 * checks if the controlled prop selectedItem changed between
 * renders. If so, it will also update inputValue with its
 * string equivalent. It uses the common useEnhancedReducer to
 * compute the rest of the state.
 *
 * @param {Function} reducer Reducer function from downshift.
 * @param {Object} initialState Initial state of the hook.
 * @param {Object} props The hook props.
 * @returns {Array} An array with the state and an action dispatcher.
 */ function $6260541dc56be833$var$useControlledReducer(reducer, initialState, props) {
    const previousSelectedItemRef = (0, $acw62.useRef)();
    const [state, dispatch] = $6260541dc56be833$var$useEnhancedReducer(reducer, initialState, props); // ToDo: if needed, make same approach as selectedItemChanged from Downshift.
    (0, $acw62.useEffect)(()=>{
        if ($6260541dc56be833$var$isControlledProp(props, "selectedItem")) {
            if (previousSelectedItemRef.current !== props.selectedItem) dispatch({
                type: $6260541dc56be833$var$ControlledPropUpdatedSelectedItem,
                inputValue: props.itemToString(props.selectedItem)
            });
            previousSelectedItemRef.current = state.selectedItem === previousSelectedItemRef.current ? props.selectedItem : state.selectedItem;
        }
    });
    return [
        $6260541dc56be833$var$getState(state, props),
        dispatch
    ];
} // eslint-disable-next-line import/no-mutable-exports
let $6260541dc56be833$var$validatePropTypes$1 = $6260541dc56be833$var$noop;
var $6260541dc56be833$var$options, $6260541dc56be833$var$caller;
const $6260541dc56be833$var$defaultProps$1 = {
    ...$6260541dc56be833$var$defaultProps$3,
    getA11yStatusMessage: $6260541dc56be833$var$getA11yStatusMessage$1,
    circularNavigation: true
};
/* eslint-disable complexity */ function $6260541dc56be833$var$downshiftUseComboboxReducer(state, action) {
    const { type: type, props: props, shiftKey: shiftKey } = action;
    let changes;
    switch(type){
        case $6260541dc56be833$var$ItemClick:
            changes = {
                isOpen: $6260541dc56be833$var$getDefaultValue$1(props, "isOpen"),
                highlightedIndex: $6260541dc56be833$var$getDefaultValue$1(props, "highlightedIndex"),
                selectedItem: props.items[action.index],
                inputValue: props.itemToString(props.items[action.index])
            };
            break;
        case $6260541dc56be833$var$InputKeyDownArrowDown:
            if (state.isOpen) changes = {
                highlightedIndex: $6260541dc56be833$var$getNextWrappingIndex(shiftKey ? 5 : 1, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, props.circularNavigation)
            };
            else changes = {
                highlightedIndex: $6260541dc56be833$var$getHighlightedIndexOnOpen(props, state, 1, action.getItemNodeFromIndex),
                isOpen: props.items.length >= 0
            };
            break;
        case $6260541dc56be833$var$InputKeyDownArrowUp:
            if (state.isOpen) changes = {
                highlightedIndex: $6260541dc56be833$var$getNextWrappingIndex(shiftKey ? -5 : -1, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, props.circularNavigation)
            };
            else changes = {
                highlightedIndex: $6260541dc56be833$var$getHighlightedIndexOnOpen(props, state, -1, action.getItemNodeFromIndex),
                isOpen: props.items.length >= 0
            };
            break;
        case $6260541dc56be833$var$InputKeyDownEnter:
            changes = {
                ...state.isOpen && state.highlightedIndex >= 0 && {
                    selectedItem: props.items[state.highlightedIndex],
                    isOpen: $6260541dc56be833$var$getDefaultValue$1(props, "isOpen"),
                    highlightedIndex: $6260541dc56be833$var$getDefaultValue$1(props, "highlightedIndex"),
                    inputValue: props.itemToString(props.items[state.highlightedIndex])
                }
            };
            break;
        case $6260541dc56be833$var$InputKeyDownEscape:
            changes = {
                isOpen: false,
                highlightedIndex: -1,
                ...!state.isOpen && {
                    selectedItem: null,
                    inputValue: ""
                }
            };
            break;
        case $6260541dc56be833$var$InputKeyDownHome:
            changes = {
                highlightedIndex: $6260541dc56be833$var$getNextNonDisabledIndex(1, 0, props.items.length, action.getItemNodeFromIndex, false)
            };
            break;
        case $6260541dc56be833$var$InputKeyDownEnd:
            changes = {
                highlightedIndex: $6260541dc56be833$var$getNextNonDisabledIndex(-1, props.items.length - 1, props.items.length, action.getItemNodeFromIndex, false)
            };
            break;
        case $6260541dc56be833$var$InputBlur:
            changes = {
                isOpen: false,
                highlightedIndex: -1,
                ...state.highlightedIndex >= 0 && action.selectItem && {
                    selectedItem: props.items[state.highlightedIndex],
                    inputValue: props.itemToString(props.items[state.highlightedIndex])
                }
            };
            break;
        case $6260541dc56be833$var$InputChange:
            changes = {
                isOpen: true,
                highlightedIndex: $6260541dc56be833$var$getDefaultValue$1(props, "highlightedIndex"),
                inputValue: action.inputValue
            };
            break;
        case $6260541dc56be833$var$FunctionSelectItem:
            changes = {
                selectedItem: action.selectedItem,
                inputValue: props.itemToString(action.selectedItem)
            };
            break;
        case $6260541dc56be833$var$ControlledPropUpdatedSelectedItem:
            changes = {
                inputValue: action.inputValue
            };
            break;
        default:
            return $6260541dc56be833$var$downshiftCommonReducer(state, action, $6260541dc56be833$var$stateChangeTypes$1);
    }
    return {
        ...state,
        ...changes
    };
}
/* eslint-enable complexity */ /* eslint-disable max-statements */ $6260541dc56be833$export$7a023a466c03eb3d.stateChangeTypes = $6260541dc56be833$var$stateChangeTypes$1;
function $6260541dc56be833$export$7a023a466c03eb3d(userProps) {
    if (userProps === void 0) userProps = {};
    $6260541dc56be833$var$validatePropTypes$1(userProps, $6260541dc56be833$export$7a023a466c03eb3d); // Props defaults and destructuring.
    const props = {
        ...$6260541dc56be833$var$defaultProps$1,
        ...userProps
    };
    const { initialIsOpen: initialIsOpen, defaultIsOpen: defaultIsOpen, items: items, scrollIntoView: scrollIntoView, environment: environment, getA11yStatusMessage: getA11yStatusMessage, getA11ySelectionMessage: getA11ySelectionMessage, itemToString: itemToString } = props; // Initial state depending on controlled props.
    const initialState = $6260541dc56be833$var$getInitialState$1(props);
    const [state, dispatch] = $6260541dc56be833$var$useControlledReducer($6260541dc56be833$var$downshiftUseComboboxReducer, initialState, props);
    const { isOpen: isOpen, highlightedIndex: highlightedIndex, selectedItem: selectedItem, inputValue: inputValue } = state; // Element refs.
    const menuRef = (0, $acw62.useRef)(null);
    const itemRefs = (0, $acw62.useRef)({});
    const inputRef = (0, $acw62.useRef)(null);
    const toggleButtonRef = (0, $acw62.useRef)(null);
    const comboboxRef = (0, $acw62.useRef)(null);
    const isInitialMountRef = (0, $acw62.useRef)(true); // prevent id re-generation between renders.
    const elementIds = $6260541dc56be833$var$useElementIds(props); // used to keep track of how many items we had on previous cycle.
    const previousResultCountRef = (0, $acw62.useRef)(); // utility callback to get item element.
    const latest = $6260541dc56be833$var$useLatestRef({
        state: state,
        props: props
    });
    const getItemNodeFromIndex = (0, $acw62.useCallback)((index)=>itemRefs.current[elementIds.getItemId(index)], [
        elementIds
    ]); // Effects.
    // Sets a11y status message on changes in state.
    $6260541dc56be833$var$useA11yMessageSetter(getA11yStatusMessage, [
        isOpen,
        highlightedIndex,
        inputValue,
        items
    ], {
        isInitialMount: isInitialMountRef.current,
        previousResultCount: previousResultCountRef.current,
        items: items,
        environment: environment,
        itemToString: itemToString,
        ...state
    }); // Sets a11y status message on changes in selectedItem.
    $6260541dc56be833$var$useA11yMessageSetter(getA11ySelectionMessage, [
        selectedItem
    ], {
        isInitialMount: isInitialMountRef.current,
        previousResultCount: previousResultCountRef.current,
        items: items,
        environment: environment,
        itemToString: itemToString,
        ...state
    }); // Scroll on highlighted item if change comes from keyboard.
    const shouldScrollRef = $6260541dc56be833$var$useScrollIntoView({
        menuElement: menuRef.current,
        highlightedIndex: highlightedIndex,
        isOpen: isOpen,
        itemRefs: itemRefs,
        scrollIntoView: scrollIntoView,
        getItemNodeFromIndex: getItemNodeFromIndex
    });
    $6260541dc56be833$var$useControlPropsValidator({
        isInitialMount: isInitialMountRef.current,
        props: props,
        state: state
    }); // Focus the input on first render if required.
    (0, $acw62.useEffect)(()=>{
        const focusOnOpen = initialIsOpen || defaultIsOpen || isOpen;
        if (focusOnOpen && inputRef.current) inputRef.current.focus();
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (isInitialMountRef.current) return;
        previousResultCountRef.current = items.length;
    }); // Add mouse/touch events to document.
    const mouseAndTouchTrackersRef = $6260541dc56be833$var$useMouseAndTouchTracker(isOpen, [
        comboboxRef,
        menuRef,
        toggleButtonRef
    ], environment, ()=>{
        dispatch({
            type: $6260541dc56be833$var$InputBlur,
            selectItem: false
        });
    });
    const setGetterPropCallInfo = $6260541dc56be833$var$useGetterPropsCalledChecker("getInputProps", "getComboboxProps", "getMenuProps"); // Make initial ref false.
    (0, $acw62.useEffect)(()=>{
        isInitialMountRef.current = false;
    }, []); // Reset itemRefs on close.
    (0, $acw62.useEffect)(()=>{
        if (!isOpen) itemRefs.current = {};
    }, [
        isOpen
    ]);
    /* Event handler functions */ const inputKeyDownHandlers = (0, $acw62.useMemo)(()=>({
            ArrowDown (event) {
                event.preventDefault();
                dispatch({
                    type: $6260541dc56be833$var$InputKeyDownArrowDown,
                    shiftKey: event.shiftKey,
                    getItemNodeFromIndex: getItemNodeFromIndex
                });
            },
            ArrowUp (event) {
                event.preventDefault();
                dispatch({
                    type: $6260541dc56be833$var$InputKeyDownArrowUp,
                    shiftKey: event.shiftKey,
                    getItemNodeFromIndex: getItemNodeFromIndex
                });
            },
            Home (event) {
                if (!latest.current.state.isOpen) return;
                event.preventDefault();
                dispatch({
                    type: $6260541dc56be833$var$InputKeyDownHome,
                    getItemNodeFromIndex: getItemNodeFromIndex
                });
            },
            End (event) {
                if (!latest.current.state.isOpen) return;
                event.preventDefault();
                dispatch({
                    type: $6260541dc56be833$var$InputKeyDownEnd,
                    getItemNodeFromIndex: getItemNodeFromIndex
                });
            },
            Escape (event) {
                const latestState = latest.current.state;
                if (latestState.isOpen || latestState.inputValue || latestState.selectedItem || latestState.highlightedIndex > -1) {
                    event.preventDefault();
                    dispatch({
                        type: $6260541dc56be833$var$InputKeyDownEscape
                    });
                }
            },
            Enter (event) {
                const latestState = latest.current.state; // if closed or no highlighted index, do nothing.
                if (!latestState.isOpen || latestState.highlightedIndex < 0 || event.which === 229 // if IME composing, wait for next Enter keydown event.
                ) return;
                event.preventDefault();
                dispatch({
                    type: $6260541dc56be833$var$InputKeyDownEnter,
                    getItemNodeFromIndex: getItemNodeFromIndex
                });
            }
        }), [
        dispatch,
        latest,
        getItemNodeFromIndex
    ]); // Getter props.
    const getLabelProps = (0, $acw62.useCallback)((labelProps)=>({
            id: elementIds.labelId,
            htmlFor: elementIds.inputId,
            ...labelProps
        }), [
        elementIds
    ]);
    const getMenuProps = (0, $acw62.useCallback)(function(_temp, _temp2) {
        let { onMouseLeave: onMouseLeave, refKey: refKey = "ref", ref: ref, ...rest } = _temp === void 0 ? {} : _temp;
        let { suppressRefError: suppressRefError = false } = _temp2 === void 0 ? {} : _temp2;
        setGetterPropCallInfo("getMenuProps", suppressRefError, refKey, menuRef);
        return {
            [refKey]: $6260541dc56be833$var$handleRefs(ref, (menuNode)=>{
                menuRef.current = menuNode;
            }),
            id: elementIds.menuId,
            role: "listbox",
            "aria-labelledby": elementIds.labelId,
            onMouseLeave: $6260541dc56be833$var$callAllEventHandlers(onMouseLeave, ()=>{
                dispatch({
                    type: $6260541dc56be833$var$MenuMouseLeave
                });
            }),
            ...rest
        };
    }, [
        dispatch,
        setGetterPropCallInfo,
        elementIds
    ]);
    const getItemProps = (0, $acw62.useCallback)(function(_temp3) {
        let { item: item, index: index, refKey: refKey = "ref", ref: ref, onMouseMove: onMouseMove, onMouseDown: onMouseDown, onClick: onClick, onPress: onPress, disabled: disabled, ...rest } = _temp3 === void 0 ? {} : _temp3;
        const { props: latestProps, state: latestState } = latest.current;
        const itemIndex = $6260541dc56be833$var$getItemIndex(index, item, latestProps.items);
        if (itemIndex < 0) throw new Error("Pass either item or item index in getItemProps!");
        const onSelectKey = "onClick";
        const customClickHandler = onClick;
        const itemHandleMouseMove = ()=>{
            if (index === latestState.highlightedIndex) return;
            shouldScrollRef.current = false;
            dispatch({
                type: $6260541dc56be833$var$ItemMouseMove,
                index: index,
                disabled: disabled
            });
        };
        const itemHandleClick = ()=>{
            dispatch({
                type: $6260541dc56be833$var$ItemClick,
                index: index
            });
        };
        const itemHandleMouseDown = (e)=>e.preventDefault();
        return {
            [refKey]: $6260541dc56be833$var$handleRefs(ref, (itemNode)=>{
                if (itemNode) itemRefs.current[elementIds.getItemId(itemIndex)] = itemNode;
            }),
            disabled: disabled,
            role: "option",
            "aria-selected": `${itemIndex === latestState.highlightedIndex}`,
            id: elementIds.getItemId(itemIndex),
            ...!disabled && {
                [onSelectKey]: $6260541dc56be833$var$callAllEventHandlers(customClickHandler, itemHandleClick)
            },
            onMouseMove: $6260541dc56be833$var$callAllEventHandlers(onMouseMove, itemHandleMouseMove),
            onMouseDown: $6260541dc56be833$var$callAllEventHandlers(onMouseDown, itemHandleMouseDown),
            ...rest
        };
    }, [
        dispatch,
        latest,
        shouldScrollRef,
        elementIds
    ]);
    const getToggleButtonProps = (0, $acw62.useCallback)(function(_temp4) {
        let { onClick: onClick, onPress: onPress, refKey: refKey = "ref", ref: ref, ...rest } = _temp4 === void 0 ? {} : _temp4;
        const toggleButtonHandleClick = ()=>{
            dispatch({
                type: $6260541dc56be833$var$ToggleButtonClick
            });
            if (!latest.current.state.isOpen && inputRef.current) inputRef.current.focus();
        };
        return {
            [refKey]: $6260541dc56be833$var$handleRefs(ref, (toggleButtonNode)=>{
                toggleButtonRef.current = toggleButtonNode;
            }),
            id: elementIds.toggleButtonId,
            tabIndex: -1,
            ...!rest.disabled && {
                onClick: $6260541dc56be833$var$callAllEventHandlers(onClick, toggleButtonHandleClick)
            },
            ...rest
        };
    }, [
        dispatch,
        latest,
        elementIds
    ]);
    const getInputProps = (0, $acw62.useCallback)(function(_temp5, _temp6) {
        let { onKeyDown: onKeyDown, onChange: onChange, onInput: onInput, onBlur: onBlur, onChangeText: onChangeText, refKey: refKey = "ref", ref: ref, ...rest } = _temp5 === void 0 ? {} : _temp5;
        let { suppressRefError: suppressRefError = false } = _temp6 === void 0 ? {} : _temp6;
        setGetterPropCallInfo("getInputProps", suppressRefError, refKey, inputRef);
        const latestState = latest.current.state;
        const inputHandleKeyDown = (event)=>{
            const key = $6260541dc56be833$var$normalizeArrowKey(event);
            if (key && inputKeyDownHandlers[key]) inputKeyDownHandlers[key](event);
        };
        const inputHandleChange = (event)=>{
            dispatch({
                type: $6260541dc56be833$var$InputChange,
                inputValue: event.target.value
            });
        };
        const inputHandleBlur = ()=>{
            /* istanbul ignore else */ if (latestState.isOpen && !mouseAndTouchTrackersRef.current.isMouseDown) dispatch({
                type: $6260541dc56be833$var$InputBlur,
                selectItem: true
            });
        };
        /* istanbul ignore next (preact) */ const onChangeKey = "onChange";
        let eventHandlers = {};
        if (!rest.disabled) eventHandlers = {
            [onChangeKey]: $6260541dc56be833$var$callAllEventHandlers(onChange, onInput, inputHandleChange),
            onKeyDown: $6260541dc56be833$var$callAllEventHandlers(onKeyDown, inputHandleKeyDown),
            onBlur: $6260541dc56be833$var$callAllEventHandlers(onBlur, inputHandleBlur)
        };
        return {
            [refKey]: $6260541dc56be833$var$handleRefs(ref, (inputNode)=>{
                inputRef.current = inputNode;
            }),
            id: elementIds.inputId,
            "aria-autocomplete": "list",
            "aria-controls": elementIds.menuId,
            ...latestState.isOpen && latestState.highlightedIndex > -1 && {
                "aria-activedescendant": elementIds.getItemId(latestState.highlightedIndex)
            },
            "aria-labelledby": elementIds.labelId,
            // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
            // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
            autoComplete: "off",
            value: latestState.inputValue,
            ...eventHandlers,
            ...rest
        };
    }, [
        dispatch,
        inputKeyDownHandlers,
        latest,
        mouseAndTouchTrackersRef,
        setGetterPropCallInfo,
        elementIds
    ]);
    const getComboboxProps = (0, $acw62.useCallback)(function(_temp7, _temp8) {
        let { refKey: refKey = "ref", ref: ref, ...rest } = _temp7 === void 0 ? {} : _temp7;
        let { suppressRefError: suppressRefError = false } = _temp8 === void 0 ? {} : _temp8;
        setGetterPropCallInfo("getComboboxProps", suppressRefError, refKey, comboboxRef);
        return {
            [refKey]: $6260541dc56be833$var$handleRefs(ref, (comboboxNode)=>{
                comboboxRef.current = comboboxNode;
            }),
            role: "combobox",
            "aria-haspopup": "listbox",
            "aria-owns": elementIds.menuId,
            "aria-expanded": latest.current.state.isOpen,
            ...rest
        };
    }, [
        latest,
        setGetterPropCallInfo,
        elementIds
    ]); // returns
    const toggleMenu = (0, $acw62.useCallback)(()=>{
        dispatch({
            type: $6260541dc56be833$var$FunctionToggleMenu
        });
    }, [
        dispatch
    ]);
    const closeMenu = (0, $acw62.useCallback)(()=>{
        dispatch({
            type: $6260541dc56be833$var$FunctionCloseMenu
        });
    }, [
        dispatch
    ]);
    const openMenu = (0, $acw62.useCallback)(()=>{
        dispatch({
            type: $6260541dc56be833$var$FunctionOpenMenu
        });
    }, [
        dispatch
    ]);
    const setHighlightedIndex = (0, $acw62.useCallback)((newHighlightedIndex)=>{
        dispatch({
            type: $6260541dc56be833$var$FunctionSetHighlightedIndex,
            highlightedIndex: newHighlightedIndex
        });
    }, [
        dispatch
    ]);
    const selectItem = (0, $acw62.useCallback)((newSelectedItem)=>{
        dispatch({
            type: $6260541dc56be833$var$FunctionSelectItem,
            selectedItem: newSelectedItem
        });
    }, [
        dispatch
    ]);
    const setInputValue = (0, $acw62.useCallback)((newInputValue)=>{
        dispatch({
            type: $6260541dc56be833$var$FunctionSetInputValue,
            inputValue: newInputValue
        });
    }, [
        dispatch
    ]);
    const reset = (0, $acw62.useCallback)(()=>{
        dispatch({
            type: $6260541dc56be833$var$FunctionReset$1
        });
    }, [
        dispatch
    ]);
    return {
        getItemProps: // prop getters.
        getItemProps,
        getLabelProps: getLabelProps,
        getMenuProps: getMenuProps,
        getInputProps: getInputProps,
        getComboboxProps: getComboboxProps,
        getToggleButtonProps: getToggleButtonProps,
        toggleMenu: // actions.
        toggleMenu,
        openMenu: openMenu,
        closeMenu: closeMenu,
        setHighlightedIndex: setHighlightedIndex,
        setInputValue: setInputValue,
        selectItem: selectItem,
        reset: reset,
        highlightedIndex: // state.
        highlightedIndex,
        isOpen: isOpen,
        selectedItem: selectedItem,
        inputValue: inputValue
    };
}
const $6260541dc56be833$var$defaultStateValues = {
    activeIndex: -1,
    selectedItems: []
};
/**
 * Returns the initial value for a state key in the following order:
 * 1. controlled prop, 2. initial prop, 3. default prop, 4. default
 * value from Downshift.
 *
 * @param {Object} props Props passed to the hook.
 * @param {string} propKey Props key to generate the value for.
 * @returns {any} The initial value for that prop.
 */ function $6260541dc56be833$var$getInitialValue(props, propKey) {
    return $6260541dc56be833$var$getInitialValue$1(props, propKey, $6260541dc56be833$var$defaultStateValues);
}
/**
 * Returns the default value for a state key in the following order:
 * 1. controlled prop, 2. default prop, 3. default value from Downshift.
 *
 * @param {Object} props Props passed to the hook.
 * @param {string} propKey Props key to generate the value for.
 * @returns {any} The initial value for that prop.
 */ function $6260541dc56be833$var$getDefaultValue(props, propKey) {
    return $6260541dc56be833$var$getDefaultValue$1(props, propKey, $6260541dc56be833$var$defaultStateValues);
}
/**
 * Gets the initial state based on the provided props. It uses initial, default
 * and controlled props related to state in order to compute the initial value.
 *
 * @param {Object} props Props passed to the hook.
 * @returns {Object} The initial state.
 */ function $6260541dc56be833$var$getInitialState(props) {
    const activeIndex = $6260541dc56be833$var$getInitialValue(props, "activeIndex");
    const selectedItems = $6260541dc56be833$var$getInitialValue(props, "selectedItems");
    return {
        activeIndex: activeIndex,
        selectedItems: selectedItems
    };
}
/**
 * Returns true if dropdown keydown operation is permitted. Should not be
 * allowed on keydown with modifier keys (ctrl, alt, shift, meta), on
 * input element with text content that is either highlighted or selection
 * cursor is not at the starting position.
 *
 * @param {KeyboardEvent} event The event from keydown.
 * @returns {boolean} Whether the operation is allowed.
 */ function $6260541dc56be833$var$isKeyDownOperationPermitted(event) {
    if (event.shiftKey || event.metaKey || event.ctrlKey || event.altKey) return false;
    const element = event.target;
    if (element instanceof HTMLInputElement && // if element is a text input
    element.value !== "" && // and cursor is either not at the start or is currently highlighting text.
    (element.selectionStart !== 0 || element.selectionEnd !== 0)) return false;
    return true;
}
/**
 * Returns a message to be added to aria-live region when item is removed.
 *
 * @param {Object} selectionParameters Parameters required to build the message.
 * @returns {string} The a11y message.
 */ function $6260541dc56be833$var$getA11yRemovalMessage(selectionParameters) {
    const { removedSelectedItem: removedSelectedItem, itemToString: itemToStringLocal } = selectionParameters;
    return `${itemToStringLocal(removedSelectedItem)} has been removed.`;
}
const $6260541dc56be833$var$propTypes = {
    selectedItems: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    initialSelectedItems: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    defaultSelectedItems: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    itemToString: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    getA11yRemovalMessage: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    stateReducer: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    activeIndex: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    initialActiveIndex: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    defaultActiveIndex: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    onActiveIndexChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onSelectedItemsChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    keyNavigationNext: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    keyNavigationPrevious: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    environment: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        addEventListener: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        removeEventListener: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
        document: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
            getElementById: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
            activeElement: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
            body: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any
        })
    })
};
const $6260541dc56be833$var$defaultProps = {
    itemToString: $6260541dc56be833$var$defaultProps$3.itemToString,
    stateReducer: $6260541dc56be833$var$defaultProps$3.stateReducer,
    environment: $6260541dc56be833$var$defaultProps$3.environment,
    getA11yRemovalMessage: $6260541dc56be833$var$getA11yRemovalMessage,
    keyNavigationNext: "ArrowRight",
    keyNavigationPrevious: "ArrowLeft"
}; // eslint-disable-next-line import/no-mutable-exports
let $6260541dc56be833$var$validatePropTypes = $6260541dc56be833$var$noop;
var $6260541dc56be833$var$options1, $6260541dc56be833$var$caller1;
const $6260541dc56be833$var$SelectedItemClick = 0;
const $6260541dc56be833$var$SelectedItemKeyDownDelete = 1;
const $6260541dc56be833$var$SelectedItemKeyDownBackspace = 2;
const $6260541dc56be833$var$SelectedItemKeyDownNavigationNext = 3;
const $6260541dc56be833$var$SelectedItemKeyDownNavigationPrevious = 4;
const $6260541dc56be833$var$DropdownKeyDownNavigationPrevious = 5;
const $6260541dc56be833$var$DropdownKeyDownBackspace = 6;
const $6260541dc56be833$var$DropdownClick = 7;
const $6260541dc56be833$var$FunctionAddSelectedItem = 8;
const $6260541dc56be833$var$FunctionRemoveSelectedItem = 9;
const $6260541dc56be833$var$FunctionSetSelectedItems = 10;
const $6260541dc56be833$var$FunctionSetActiveIndex = 11;
const $6260541dc56be833$var$FunctionReset = 12;
var $6260541dc56be833$var$stateChangeTypes = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    SelectedItemClick: $6260541dc56be833$var$SelectedItemClick,
    SelectedItemKeyDownDelete: $6260541dc56be833$var$SelectedItemKeyDownDelete,
    SelectedItemKeyDownBackspace: $6260541dc56be833$var$SelectedItemKeyDownBackspace,
    SelectedItemKeyDownNavigationNext: $6260541dc56be833$var$SelectedItemKeyDownNavigationNext,
    SelectedItemKeyDownNavigationPrevious: $6260541dc56be833$var$SelectedItemKeyDownNavigationPrevious,
    DropdownKeyDownNavigationPrevious: $6260541dc56be833$var$DropdownKeyDownNavigationPrevious,
    DropdownKeyDownBackspace: $6260541dc56be833$var$DropdownKeyDownBackspace,
    DropdownClick: $6260541dc56be833$var$DropdownClick,
    FunctionAddSelectedItem: $6260541dc56be833$var$FunctionAddSelectedItem,
    FunctionRemoveSelectedItem: $6260541dc56be833$var$FunctionRemoveSelectedItem,
    FunctionSetSelectedItems: $6260541dc56be833$var$FunctionSetSelectedItems,
    FunctionSetActiveIndex: $6260541dc56be833$var$FunctionSetActiveIndex,
    FunctionReset: $6260541dc56be833$var$FunctionReset
});
/* eslint-disable complexity */ function $6260541dc56be833$var$downshiftMultipleSelectionReducer(state, action) {
    const { type: type, index: index, props: props, selectedItem: selectedItem } = action;
    const { activeIndex: activeIndex, selectedItems: selectedItems } = state;
    let changes;
    switch(type){
        case $6260541dc56be833$var$SelectedItemClick:
            changes = {
                activeIndex: index
            };
            break;
        case $6260541dc56be833$var$SelectedItemKeyDownNavigationPrevious:
            changes = {
                activeIndex: activeIndex - 1 < 0 ? 0 : activeIndex - 1
            };
            break;
        case $6260541dc56be833$var$SelectedItemKeyDownNavigationNext:
            changes = {
                activeIndex: activeIndex + 1 >= selectedItems.length ? -1 : activeIndex + 1
            };
            break;
        case $6260541dc56be833$var$SelectedItemKeyDownBackspace:
        case $6260541dc56be833$var$SelectedItemKeyDownDelete:
            {
                let newActiveIndex = activeIndex;
                if (selectedItems.length === 1) newActiveIndex = -1;
                else if (activeIndex === selectedItems.length - 1) newActiveIndex = selectedItems.length - 2;
                changes = {
                    selectedItems: [
                        ...selectedItems.slice(0, activeIndex),
                        ...selectedItems.slice(activeIndex + 1)
                    ],
                    activeIndex: newActiveIndex
                };
                break;
            }
        case $6260541dc56be833$var$DropdownKeyDownNavigationPrevious:
            changes = {
                activeIndex: selectedItems.length - 1
            };
            break;
        case $6260541dc56be833$var$DropdownKeyDownBackspace:
            changes = {
                selectedItems: selectedItems.slice(0, selectedItems.length - 1)
            };
            break;
        case $6260541dc56be833$var$FunctionAddSelectedItem:
            changes = {
                selectedItems: [
                    ...selectedItems,
                    selectedItem
                ]
            };
            break;
        case $6260541dc56be833$var$DropdownClick:
            changes = {
                activeIndex: -1
            };
            break;
        case $6260541dc56be833$var$FunctionRemoveSelectedItem:
            {
                let newActiveIndex = activeIndex;
                const selectedItemIndex = selectedItems.indexOf(selectedItem);
                if (selectedItemIndex >= 0) {
                    if (selectedItems.length === 1) newActiveIndex = -1;
                    else if (selectedItemIndex === selectedItems.length - 1) newActiveIndex = selectedItems.length - 2;
                    changes = {
                        selectedItems: [
                            ...selectedItems.slice(0, selectedItemIndex),
                            ...selectedItems.slice(selectedItemIndex + 1)
                        ],
                        activeIndex: newActiveIndex
                    };
                }
                break;
            }
        case $6260541dc56be833$var$FunctionSetSelectedItems:
            {
                const { selectedItems: newSelectedItems } = action;
                changes = {
                    selectedItems: newSelectedItems
                };
                break;
            }
        case $6260541dc56be833$var$FunctionSetActiveIndex:
            {
                const { activeIndex: newActiveIndex } = action;
                changes = {
                    activeIndex: newActiveIndex
                };
                break;
            }
        case $6260541dc56be833$var$FunctionReset:
            changes = {
                activeIndex: $6260541dc56be833$var$getDefaultValue(props, "activeIndex"),
                selectedItems: $6260541dc56be833$var$getDefaultValue(props, "selectedItems")
            };
            break;
        default:
            throw new Error("Reducer called without proper action type.");
    }
    return {
        ...state,
        ...changes
    };
}
$6260541dc56be833$export$134e7e7faed1473a.stateChangeTypes = $6260541dc56be833$var$stateChangeTypes;
function $6260541dc56be833$export$134e7e7faed1473a(userProps) {
    if (userProps === void 0) userProps = {};
    $6260541dc56be833$var$validatePropTypes(userProps, $6260541dc56be833$export$134e7e7faed1473a); // Props defaults and destructuring.
    const props = {
        ...$6260541dc56be833$var$defaultProps,
        ...userProps
    };
    const { getA11yRemovalMessage: getA11yRemovalMessage, itemToString: itemToString, environment: environment, keyNavigationNext: keyNavigationNext, keyNavigationPrevious: keyNavigationPrevious } = props; // Reducer init.
    const [state, dispatch] = $6260541dc56be833$var$useControlledReducer$1($6260541dc56be833$var$downshiftMultipleSelectionReducer, $6260541dc56be833$var$getInitialState(props), props);
    const { activeIndex: activeIndex, selectedItems: selectedItems } = state; // Refs.
    const isInitialMountRef = (0, $acw62.useRef)(true);
    const dropdownRef = (0, $acw62.useRef)(null);
    const previousSelectedItemsRef = (0, $acw62.useRef)(selectedItems);
    const selectedItemRefs = (0, $acw62.useRef)();
    selectedItemRefs.current = [];
    const latest = $6260541dc56be833$var$useLatestRef({
        state: state,
        props: props
    }); // Effects.
    /* Sets a11y status message on changes in selectedItem. */ (0, $acw62.useEffect)(()=>{
        if (isInitialMountRef.current) return;
        if (selectedItems.length < previousSelectedItemsRef.current.length) {
            const removedSelectedItem = previousSelectedItemsRef.current.find((item)=>selectedItems.indexOf(item) < 0);
            $6260541dc56be833$var$setStatus(getA11yRemovalMessage({
                itemToString: itemToString,
                resultCount: selectedItems.length,
                removedSelectedItem: removedSelectedItem,
                activeIndex: activeIndex,
                activeSelectedItem: selectedItems[activeIndex]
            }), environment.document);
        }
        previousSelectedItemsRef.current = selectedItems; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedItems.length
    ]); // Sets focus on active item.
    (0, $acw62.useEffect)(()=>{
        if (isInitialMountRef.current) return;
        if (activeIndex === -1 && dropdownRef.current) dropdownRef.current.focus();
        else if (selectedItemRefs.current[activeIndex]) selectedItemRefs.current[activeIndex].focus();
    }, [
        activeIndex
    ]);
    $6260541dc56be833$var$useControlPropsValidator({
        isInitialMount: isInitialMountRef.current,
        props: props,
        state: state
    });
    const setGetterPropCallInfo = $6260541dc56be833$var$useGetterPropsCalledChecker("getDropdownProps"); // Make initial ref false.
    (0, $acw62.useEffect)(()=>{
        isInitialMountRef.current = false;
    }, []); // Event handler functions.
    const selectedItemKeyDownHandlers = (0, $acw62.useMemo)(()=>({
            [keyNavigationPrevious] () {
                dispatch({
                    type: $6260541dc56be833$var$SelectedItemKeyDownNavigationPrevious
                });
            },
            [keyNavigationNext] () {
                dispatch({
                    type: $6260541dc56be833$var$SelectedItemKeyDownNavigationNext
                });
            },
            Delete () {
                dispatch({
                    type: $6260541dc56be833$var$SelectedItemKeyDownDelete
                });
            },
            Backspace () {
                dispatch({
                    type: $6260541dc56be833$var$SelectedItemKeyDownBackspace
                });
            }
        }), [
        dispatch,
        keyNavigationNext,
        keyNavigationPrevious
    ]);
    const dropdownKeyDownHandlers = (0, $acw62.useMemo)(()=>({
            [keyNavigationPrevious] (event) {
                if ($6260541dc56be833$var$isKeyDownOperationPermitted(event)) dispatch({
                    type: $6260541dc56be833$var$DropdownKeyDownNavigationPrevious
                });
            },
            Backspace (event) {
                if ($6260541dc56be833$var$isKeyDownOperationPermitted(event)) dispatch({
                    type: $6260541dc56be833$var$DropdownKeyDownBackspace
                });
            }
        }), [
        dispatch,
        keyNavigationPrevious
    ]); // Getter props.
    const getSelectedItemProps = (0, $acw62.useCallback)(function(_temp) {
        let { refKey: refKey = "ref", ref: ref, onClick: onClick, onKeyDown: onKeyDown, selectedItem: selectedItem, index: index, ...rest } = _temp === void 0 ? {} : _temp;
        const { state: latestState } = latest.current;
        const itemIndex = $6260541dc56be833$var$getItemIndex(index, selectedItem, latestState.selectedItems);
        if (itemIndex < 0) throw new Error("Pass either selectedItem or index in getSelectedItemProps!");
        const selectedItemHandleClick = ()=>{
            dispatch({
                type: $6260541dc56be833$var$SelectedItemClick,
                index: index
            });
        };
        const selectedItemHandleKeyDown = (event)=>{
            const key = $6260541dc56be833$var$normalizeArrowKey(event);
            if (key && selectedItemKeyDownHandlers[key]) selectedItemKeyDownHandlers[key](event);
        };
        return {
            [refKey]: $6260541dc56be833$var$handleRefs(ref, (selectedItemNode)=>{
                if (selectedItemNode) selectedItemRefs.current.push(selectedItemNode);
            }),
            tabIndex: index === latestState.activeIndex ? 0 : -1,
            onClick: $6260541dc56be833$var$callAllEventHandlers(onClick, selectedItemHandleClick),
            onKeyDown: $6260541dc56be833$var$callAllEventHandlers(onKeyDown, selectedItemHandleKeyDown),
            ...rest
        };
    }, [
        dispatch,
        latest,
        selectedItemKeyDownHandlers
    ]);
    const getDropdownProps = (0, $acw62.useCallback)(function(_temp2, _temp3) {
        let { refKey: refKey = "ref", ref: ref, onKeyDown: onKeyDown, onClick: onClick, preventKeyAction: preventKeyAction = false, ...rest } = _temp2 === void 0 ? {} : _temp2;
        let { suppressRefError: suppressRefError = false } = _temp3 === void 0 ? {} : _temp3;
        setGetterPropCallInfo("getDropdownProps", suppressRefError, refKey, dropdownRef);
        const dropdownHandleKeyDown = (event)=>{
            const key = $6260541dc56be833$var$normalizeArrowKey(event);
            if (key && dropdownKeyDownHandlers[key]) dropdownKeyDownHandlers[key](event);
        };
        const dropdownHandleClick = ()=>{
            dispatch({
                type: $6260541dc56be833$var$DropdownClick
            });
        };
        return {
            [refKey]: $6260541dc56be833$var$handleRefs(ref, (dropdownNode)=>{
                if (dropdownNode) dropdownRef.current = dropdownNode;
            }),
            ...!preventKeyAction && {
                onKeyDown: $6260541dc56be833$var$callAllEventHandlers(onKeyDown, dropdownHandleKeyDown),
                onClick: $6260541dc56be833$var$callAllEventHandlers(onClick, dropdownHandleClick)
            },
            ...rest
        };
    }, [
        dispatch,
        dropdownKeyDownHandlers,
        setGetterPropCallInfo
    ]); // returns
    const addSelectedItem = (0, $acw62.useCallback)((selectedItem)=>{
        dispatch({
            type: $6260541dc56be833$var$FunctionAddSelectedItem,
            selectedItem: selectedItem
        });
    }, [
        dispatch
    ]);
    const removeSelectedItem = (0, $acw62.useCallback)((selectedItem)=>{
        dispatch({
            type: $6260541dc56be833$var$FunctionRemoveSelectedItem,
            selectedItem: selectedItem
        });
    }, [
        dispatch
    ]);
    const setSelectedItems = (0, $acw62.useCallback)((newSelectedItems)=>{
        dispatch({
            type: $6260541dc56be833$var$FunctionSetSelectedItems,
            selectedItems: newSelectedItems
        });
    }, [
        dispatch
    ]);
    const setActiveIndex = (0, $acw62.useCallback)((newActiveIndex)=>{
        dispatch({
            type: $6260541dc56be833$var$FunctionSetActiveIndex,
            activeIndex: newActiveIndex
        });
    }, [
        dispatch
    ]);
    const reset = (0, $acw62.useCallback)(()=>{
        dispatch({
            type: $6260541dc56be833$var$FunctionReset
        });
    }, [
        dispatch
    ]);
    return {
        getSelectedItemProps: getSelectedItemProps,
        getDropdownProps: getDropdownProps,
        addSelectedItem: addSelectedItem,
        removeSelectedItem: removeSelectedItem,
        setSelectedItems: setSelectedItems,
        setActiveIndex: setActiveIndex,
        reset: reset,
        selectedItems: selectedItems,
        activeIndex: activeIndex
    };
}



var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $3tUi5 = parcelRequire("3tUi5");

var $ai2Pb = parcelRequire("ai2Pb");

var $acw62 = parcelRequire("acw62");
var $b31ffd1dcc183d4f$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $b31ffd1dcc183d4f$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === "function") {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $b31ffd1dcc183d4f$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === "function") return $b31ffd1dcc183d4f$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $b31ffd1dcc183d4f$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $b31ffd1dcc183d4f$export$700979bc83e7db82 = typeof window !== "undefined" && window.document && window.document.createElement ? $acw62.useLayoutEffect : $acw62.useEffect;


var $015b708b39a59435$var$EMPTY_MODIFIERS = [];
var $015b708b39a59435$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $acw62.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || "bottom",
        strategy: options.strategy || "absolute",
        modifiers: options.modifiers || $015b708b39a59435$var$EMPTY_MODIFIERS
    };
    var _React$useState = $acw62.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: "0",
                top: "0"
            },
            arrow: {
                position: "absolute"
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $acw62.useMemo(function() {
        return {
            name: "updateState",
            enabled: true,
            phase: "write",
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $1u0KT.flushSync(function() {
                    setState({
                        styles: (0, $b31ffd1dcc183d4f$export$5150077fc2e7c662)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $b31ffd1dcc183d4f$export$5150077fc2e7c662)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                "computeStyles"
            ]
        };
    }, []);
    var popperOptions = $acw62.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: "applyStyles",
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $acw62.useRef();
    (0, $b31ffd1dcc183d4f$export$700979bc83e7db82)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $b31ffd1dcc183d4f$export$700979bc83e7db82)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $3tUi5.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};



var $6ZWSX = parcelRequire("6ZWSX");
var $1c94395e3d071205$exports = {};
"use strict";
var $1c94395e3d071205$var$__importDefault = $1c94395e3d071205$exports && $1c94395e3d071205$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($1c94395e3d071205$exports, "__esModule", {
    value: true
});
$1c94395e3d071205$exports.useDropdownMenu = void 0;
var $f1e2c3332c7ea992$exports = {};
"use strict";
Object.defineProperty($f1e2c3332c7ea992$exports, "__esModule", {
    value: true
});

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $3tUi5 = parcelRequire("3tUi5");

var $ai2Pb = parcelRequire("ai2Pb");

var $acw62 = parcelRequire("acw62");
var $4cf48453bcc82962$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $4cf48453bcc82962$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === "function") {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $4cf48453bcc82962$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === "function") return $4cf48453bcc82962$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $4cf48453bcc82962$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $4cf48453bcc82962$export$700979bc83e7db82 = typeof window !== "undefined" && window.document && window.document.createElement ? $acw62.useLayoutEffect : $acw62.useEffect;


var $9925b47318cee574$var$EMPTY_MODIFIERS = [];
var $9925b47318cee574$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $acw62.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || "bottom",
        strategy: options.strategy || "absolute",
        modifiers: options.modifiers || $9925b47318cee574$var$EMPTY_MODIFIERS
    };
    var _React$useState = $acw62.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: "0",
                top: "0"
            },
            arrow: {
                position: "absolute"
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $acw62.useMemo(function() {
        return {
            name: "updateState",
            enabled: true,
            phase: "write",
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $1u0KT.flushSync(function() {
                    setState({
                        styles: (0, $4cf48453bcc82962$export$5150077fc2e7c662)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $4cf48453bcc82962$export$5150077fc2e7c662)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                "computeStyles"
            ]
        };
    }, []);
    var popperOptions = $acw62.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: "applyStyles",
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $acw62.useRef();
    (0, $4cf48453bcc82962$export$700979bc83e7db82)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $4cf48453bcc82962$export$700979bc83e7db82)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $3tUi5.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};



const $f1e2c3332c7ea992$var$useDropdownMenu = ({ items: items, placement: placement = "bottom-start", itemToString: itemToString = (item)=>item, offset: offset = [
    0,
    10
], loopItemsOnKeyDown: loopItemsOnKeyDown = true, closeMenuOnLastItem: closeMenuOnLastItem = false, closeMenuOnFirstItem: closeMenuOnFirstItem = false, resetSelectedItemOnClose: resetSelectedItemOnClose = false })=>{
    const referenceElement = (0, $acw62.useRef)(null);
    const popperElement = (0, $acw62.useRef)(null);
    const modifiers = (0, $acw62.useMemo)(()=>[
            {
                name: "sameWidth",
                enabled: true,
                fn: ({ state: state })=>{
                    state.styles.popper.width = `${state.rects.reference.width}px`;
                },
                phase: "beforeWrite",
                requires: [
                    "computeStyles"
                ]
            },
            {
                name: "offset",
                options: {
                    offset: offset
                }
            }
        ], []);
    const { styles: styles, attributes: attributes, update: update } = (0, $9925b47318cee574$export$f4d5bf230a36dd6e)(referenceElement.current, popperElement.current, {
        placement: placement,
        modifiers: modifiers
    });
    const stateReducer = (state, actionAndChanges)=>{
        const { type: type, changes: changes } = actionAndChanges;
        switch(type){
            case $6260541dc56be833$export$e64b2f635402ca43.stateChangeTypes.MenuKeyDownArrowDown:
                if (closeMenuOnLastItem && state.highlightedIndex === items.length - 1) return Object.assign(Object.assign({}, changes), {
                    isOpen: false
                });
                if (state.highlightedIndex === items.length - 1 && loopItemsOnKeyDown) {
                    let newHighlightedIndex = 0;
                    //if the first item is a header set the highlighted index to 1
                    if (items[0].header) newHighlightedIndex = 1;
                    return Object.assign(Object.assign({}, changes), {
                        isOpen: true,
                        highlightedIndex: newHighlightedIndex
                    });
                }
                return Object.assign(Object.assign({}, changes), {
                    isOpen: true
                });
            case $6260541dc56be833$export$e64b2f635402ca43.stateChangeTypes.MenuKeyDownArrowUp:
                if (closeMenuOnFirstItem && state.highlightedIndex === 0) return Object.assign(Object.assign({}, changes), {
                    isOpen: false,
                    highlightedIndex: -1
                });
                // if the first item is a header and the user is on the first
                // item, set the highlighted index to the last item
                if (state.highlightedIndex === 1 && items[0].header && loopItemsOnKeyDown) return Object.assign(Object.assign({}, changes), {
                    isOpen: true,
                    highlightedIndex: items.length - 1
                });
                if (state.highlightedIndex === 0 && loopItemsOnKeyDown) return Object.assign(Object.assign({}, changes), {
                    isOpen: true,
                    highlightedIndex: items.length - 1
                });
                return Object.assign(Object.assign({}, changes), {
                    isOpen: true
                });
            case $6260541dc56be833$export$e64b2f635402ca43.stateChangeTypes.MenuKeyDownEnter:
            case $6260541dc56be833$export$e64b2f635402ca43.stateChangeTypes.MenuKeyDownSpaceButton:
                if (items[state.highlightedIndex] && items[state.highlightedIndex].menuItems) return Object.assign(Object.assign({}, changes), {
                    highlightedIndex: state.highlightedIndex,
                    isOpen: true
                });
                if (type === $6260541dc56be833$export$e64b2f635402ca43.stateChangeTypes.MenuKeyDownEnter) {
                    if (items[state.highlightedIndex] && items[state.highlightedIndex].onClick) items[state.highlightedIndex].onClick();
                }
                if (resetSelectedItemOnClose) return Object.assign(Object.assign({}, changes), {
                    isOpen: false,
                    selectedItem: -1,
                    highlightedIndex: -1
                });
                return Object.assign({}, changes);
            case $6260541dc56be833$export$e64b2f635402ca43.stateChangeTypes.ItemClick:
                if (items[state.highlightedIndex] && items[state.highlightedIndex].onClick) items[state.highlightedIndex].onClick();
                if (resetSelectedItemOnClose) return Object.assign(Object.assign({}, changes), {
                    isOpen: false,
                    selectedItem: -1,
                    highlightedIndex: -1
                });
                return Object.assign({}, changes);
            default:
                return changes; // otherwise business as usual.
        }
    };
    const { isOpen: isOpen, getToggleButtonProps: getToggleButtonProps, getMenuProps: getMenuProps, highlightedIndex: highlightedIndex, selectedItem: selectedItem, getItemProps: getItemProps, openMenu: openMenu } = (0, $6260541dc56be833$export$e64b2f635402ca43)({
        items: items,
        itemToString: itemToString,
        stateReducer: stateReducer
    });
    (0, $acw62.useEffect)(()=>{
        update && update();
    }, [
        isOpen
    ]);
    (0, $acw62.useEffect)(()=>{
        setTimeout(()=>{
            var _a;
            const activeId = (_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.id;
            if (activeId === null || activeId === void 0 ? void 0 : activeId.includes("pendo")) openMenu();
        }, 0);
    }, [
        isOpen
    ]);
    return {
        isOpen: isOpen,
        getToggleButtonProps: getToggleButtonProps,
        getMenuProps: getMenuProps,
        highlightedIndex: highlightedIndex,
        selectedItem: selectedItem,
        getItemProps: getItemProps,
        setReferenceElement: (element)=>{
            referenceElement.current = element;
        },
        setPopperElement: (element)=>{
            popperElement.current = element;
        },
        attributes: attributes,
        styles: styles,
        update: update
    };
};
$f1e2c3332c7ea992$exports.default = $f1e2c3332c7ea992$var$useDropdownMenu;


Object.defineProperty($1c94395e3d071205$exports, "useDropdownMenu", {
    enumerable: true,
    get: function() {
        return $1c94395e3d071205$var$__importDefault($f1e2c3332c7ea992$exports).default;
    }
});



var $ayMG0 = parcelRequire("ayMG0");
function $f2ccb2ae3c8742b7$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $f2ccb2ae3c8742b7$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $f2ccb2ae3c8742b7$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f2ccb2ae3c8742b7$export$2e2bcd8739ae039 = $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37;



var $acw62 = parcelRequire("acw62");
// TYPES
// UTILS
const $f8b865b18d670cc6$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in window;
function $f8b865b18d670cc6$export$8793edee2d425525() {
    return undefined;
}
function $f8b865b18d670cc6$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $f8b865b18d670cc6$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $f8b865b18d670cc6$export$acaf96a27438246b(array1, array2) {
    return array1.filter((x)=>!array2.includes(x));
}
function $f8b865b18d670cc6$export$224e3b7078227b8a(array, index, value) {
    const copy = array.slice(0);
    copy[index] = value;
    return copy;
}
function $f8b865b18d670cc6$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $f8b865b18d670cc6$export$8a11fbc2c8ea08fd(arg1, arg2, arg3) {
    if (!$f8b865b18d670cc6$export$aaae5295ec3351c9(arg1)) return arg1;
    if (typeof arg2 === "function") return {
        ...arg3,
        queryKey: arg1,
        queryFn: arg2
    };
    return {
        ...arg2,
        queryKey: arg1
    };
}
function $f8b865b18d670cc6$export$b646c531ea475334(arg1, arg2, arg3) {
    if ($f8b865b18d670cc6$export$aaae5295ec3351c9(arg1)) {
        if (typeof arg2 === "function") return {
            ...arg3,
            mutationKey: arg1,
            mutationFn: arg2
        };
        return {
            ...arg2,
            mutationKey: arg1
        };
    }
    if (typeof arg1 === "function") return {
        ...arg2,
        mutationFn: arg1
    };
    return {
        ...arg1
    };
}
function $f8b865b18d670cc6$export$18e8f4b987e6c111(arg1, arg2, arg3) {
    return $f8b865b18d670cc6$export$aaae5295ec3351c9(arg1) ? [
        {
            ...arg2,
            queryKey: arg1
        },
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $f8b865b18d670cc6$export$42387eeaac09cf54(arg1, arg2, arg3) {
    return $f8b865b18d670cc6$export$aaae5295ec3351c9(arg1) ? [
        {
            ...arg2,
            mutationKey: arg1
        },
        arg3
    ] : [
        arg1 || {},
        arg2
    ];
}
function $f8b865b18d670cc6$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if ($f8b865b18d670cc6$export$aaae5295ec3351c9(queryKey)) {
        if (exact) {
            if (query.queryHash !== $f8b865b18d670cc6$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$f8b865b18d670cc6$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (typeof fetchStatus !== "undefined" && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $f8b865b18d670cc6$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, fetching: fetching, predicate: predicate, mutationKey: mutationKey } = filters;
    if ($f8b865b18d670cc6$export$aaae5295ec3351c9(mutationKey)) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($f8b865b18d670cc6$export$5fcb678681417b54(mutation.options.mutationKey) !== $f8b865b18d670cc6$export$5fcb678681417b54(mutationKey)) return false;
        } else if (!$f8b865b18d670cc6$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (typeof fetching === "boolean" && mutation.state.status === "loading" !== fetching) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $f8b865b18d670cc6$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || $f8b865b18d670cc6$export$5fcb678681417b54;
    return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 * Hashes the value into a stable hash.
 */ function $f8b865b18d670cc6$export$5fcb678681417b54(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$f8b865b18d670cc6$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
/**
 * Checks if key `b` partially matches with key `a`.
 */ function $f8b865b18d670cc6$export$2f07189bb9fa26a7(a, b) {
    return $f8b865b18d670cc6$export$3bc9138b70293839(a, b);
}
/**
 * Checks if `b` partially matches with `a`.
 */ function $f8b865b18d670cc6$export$3bc9138b70293839(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return !Object.keys(b).some((key)=>!$f8b865b18d670cc6$export$3bc9138b70293839(a[key], b[key]));
    return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */ function $f8b865b18d670cc6$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    const array = $f8b865b18d670cc6$export$7a8558113332b71e(a) && $f8b865b18d670cc6$export$7a8558113332b71e(b);
    if (array || $f8b865b18d670cc6$export$53b83ca8eaab0383(a) && $f8b865b18d670cc6$export$53b83ca8eaab0383(b)) {
        const aSize = array ? a.length : Object.keys(a).length;
        const bItems = array ? b : Object.keys(b);
        const bSize = bItems.length;
        const copy = array ? [] : {};
        let equalItems = 0;
        for(let i = 0; i < bSize; i++){
            const key = array ? i : bItems[i];
            copy[key] = $f8b865b18d670cc6$export$77a71fc411098696(a[key], b[key]);
            if (copy[key] === a[key]) equalItems++;
        }
        return aSize === bSize && equalItems === aSize ? a : copy;
    }
    return b;
}
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */ function $f8b865b18d670cc6$export$3e67810a3f0e9f1c(a, b) {
    if (a && !b || b && !a) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $f8b865b18d670cc6$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
} // Copied from: https://github.com/jonschlinkert/is-plain-object
function $f8b865b18d670cc6$export$53b83ca8eaab0383(o) {
    if (!$f8b865b18d670cc6$var$hasObjectPrototype(o)) return false;
     // If has modified constructor
    const ctor = o.constructor;
    if (typeof ctor === "undefined") return true;
     // If has modified prototype
    const prot = ctor.prototype;
    if (!$f8b865b18d670cc6$var$hasObjectPrototype(prot)) return false;
     // If constructor does not have an Object-specific method
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
     // Most likely a plain Object
    return true;
}
function $f8b865b18d670cc6$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $f8b865b18d670cc6$export$aaae5295ec3351c9(value) {
    return Array.isArray(value);
}
function $f8b865b18d670cc6$export$e6127cc7fe7395c3(value) {
    return value instanceof Error;
}
function $f8b865b18d670cc6$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        setTimeout(resolve, timeout);
    });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */ function $f8b865b18d670cc6$export$4304cb76768ca134(callback) {
    $f8b865b18d670cc6$export$e772c8ff12451969(0).then(callback);
}
function $f8b865b18d670cc6$export$382ca5d13a8f252c() {
    if (typeof AbortController === "function") return new AbortController();
    return;
}
function $f8b865b18d670cc6$export$17619bac5b909b23(prevData, data, options) {
    // Use prev data if an isDataEqual function is defined and returns `true`
    if (options.isDataEqual != null && options.isDataEqual(prevData, data)) return prevData;
    else if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) // Structurally share data between prev and new data if needed
    return $f8b865b18d670cc6$export$77a71fc411098696(prevData, data);
    return data;
}




const $9bd79d53e26c8f96$export$1cf3d545f2d4635c = console;



function $9c9aacadc80c6826$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    const batch = (callback)=>{
        let result;
        transactions++;
        try {
            result = callback();
        } finally{
            transactions--;
            if (!transactions) flush();
        }
        return result;
    };
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else (0, $f8b865b18d670cc6$export$4304cb76768ca134)(()=>{
            notifyFn(callback);
        });
    };
    /**
   * All calls to the wrapped function will be batched.
   */ const batchCalls = (callback)=>{
        return (...args)=>{
            schedule(()=>{
                callback(...args);
            });
        };
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) (0, $f8b865b18d670cc6$export$4304cb76768ca134)(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */ const setNotifyFunction = (fn)=>{
        notifyFn = fn;
    };
    /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */ const setBatchNotifyFunction = (fn)=>{
        batchNotifyFn = fn;
    };
    return {
        batch: batch,
        batchCalls: batchCalls,
        schedule: schedule,
        setNotifyFunction: setNotifyFunction,
        setBatchNotifyFunction: setBatchNotifyFunction
    };
} // SINGLETON
const $9c9aacadc80c6826$export$520687f44db6e1ab = $9c9aacadc80c6826$export$316a8efd03cd1458();


class $29a2986ef88e4ed5$export$d26086b469ecdbcc {
    constructor(){
        this.listeners = new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        const identity = {
            listener: listener
        };
        this.listeners.add(identity);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(identity);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
}



class $2a29005856faa11a$export$86f1af424b2ca4de extends (0, $29a2986ef88e4ed5$export$d26086b469ecdbcc) {
    constructor(){
        super();
        this.setup = (onFocus)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, $f8b865b18d670cc6$export$6acf61af03e62db) && window.addEventListener) {
                const listener = ()=>onFocus(); // Listen to visibillitychange and focus
                window.addEventListener("visibilitychange", listener, false);
                window.addEventListener("focus", listener, false);
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    window.removeEventListener("visibilitychange", listener);
                    window.removeEventListener("focus", listener);
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        });
    }
    setFocused(focused) {
        const changed = this.focused !== focused;
        if (changed) {
            this.focused = focused;
            this.onFocus();
        }
    }
    onFocus() {
        this.listeners.forEach(({ listener: listener })=>{
            listener();
        });
    }
    isFocused() {
        if (typeof this.focused === "boolean") return this.focused;
         // document global can be unavailable in react native
        if (typeof document === "undefined") return true;
        return [
            undefined,
            "visible",
            "prerender"
        ].includes(document.visibilityState);
    }
}
const $2a29005856faa11a$export$6bf54661be5b02cf = new $2a29005856faa11a$export$86f1af424b2ca4de();




const $bdda8765d46ccf87$var$onlineEvents = [
    "online",
    "offline"
];
class $bdda8765d46ccf87$export$58774fb55d5ff7fc extends (0, $29a2986ef88e4ed5$export$d26086b469ecdbcc) {
    constructor(){
        super();
        this.setup = (onOnline)=>{
            // addEventListener does not exist in React Native, but window does
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            if (!(0, $f8b865b18d670cc6$export$6acf61af03e62db) && window.addEventListener) {
                const listener = ()=>onOnline(); // Listen to online
                $bdda8765d46ccf87$var$onlineEvents.forEach((event)=>{
                    window.addEventListener(event, listener, false);
                });
                return ()=>{
                    // Be sure to unsubscribe if a new handler is set
                    $bdda8765d46ccf87$var$onlineEvents.forEach((event)=>{
                        window.removeEventListener(event, listener);
                    });
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.cleanup) this.setEventListener(this.setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$cleanup;
            (_this$cleanup = this.cleanup) == null || _this$cleanup.call(this);
            this.cleanup = undefined;
        }
    }
    setEventListener(setup) {
        var _this$cleanup2;
        this.setup = setup;
        (_this$cleanup2 = this.cleanup) == null || _this$cleanup2.call(this);
        this.cleanup = setup((online)=>{
            if (typeof online === "boolean") this.setOnline(online);
            else this.onOnline();
        });
    }
    setOnline(online) {
        const changed = this.online !== online;
        if (changed) {
            this.online = online;
            this.onOnline();
        }
    }
    onOnline() {
        this.listeners.forEach(({ listener: listener })=>{
            listener();
        });
    }
    isOnline() {
        if (typeof this.online === "boolean") return this.online;
        if (typeof navigator === "undefined" || typeof navigator.onLine === "undefined") return true;
        return navigator.onLine;
    }
}
const $bdda8765d46ccf87$export$b113e788b2dd3fdc = new $bdda8765d46ccf87$export$58774fb55d5ff7fc();



function $cd25260720ff3eef$var$defaultRetryDelay(failureCount) {
    return Math.min(1000 * 2 ** failureCount, 30000);
}
function $cd25260720ff3eef$export$61b92f63f30245cf(networkMode) {
    return (networkMode != null ? networkMode : "online") === "online" ? (0, $bdda8765d46ccf87$export$b113e788b2dd3fdc).isOnline() : true;
}
class $cd25260720ff3eef$export$a8430ed4188f35a9 {
    constructor(options){
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
}
function $cd25260720ff3eef$export$986cc6445c1d323(value) {
    return value instanceof $cd25260720ff3eef$export$a8430ed4188f35a9;
}
function $cd25260720ff3eef$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let isResolved = false;
    let continueFn;
    let promiseResolve;
    let promiseReject;
    const promise = new Promise((outerResolve, outerReject)=>{
        promiseResolve = outerResolve;
        promiseReject = outerReject;
    });
    const cancel = (cancelOptions)=>{
        if (!isResolved) {
            reject(new $cd25260720ff3eef$export$a8430ed4188f35a9(cancelOptions));
            config.abort == null || config.abort();
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const shouldPause = ()=>!(0, $2a29005856faa11a$export$6bf54661be5b02cf).isFocused() || config.networkMode !== "always" && !(0, $bdda8765d46ccf87$export$b113e788b2dd3fdc).isOnline();
    const resolve = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onSuccess == null || config.onSuccess(value);
            continueFn == null || continueFn();
            promiseResolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved) {
            isResolved = true;
            config.onError == null || config.onError(value);
            continueFn == null || continueFn();
            promiseReject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            continueFn = (value)=>{
                const canContinue = isResolved || !shouldPause();
                if (canContinue) continueResolve(value);
                return canContinue;
            };
            config.onPause == null || config.onPause();
        }).then(()=>{
            continueFn = undefined;
            if (!isResolved) config.onContinue == null || config.onContinue();
        });
    }; // Create loop function
    const run = ()=>{
        // Do nothing if already resolved
        if (isResolved) return;
        let promiseOrValue; // Execute query
        try {
            promiseOrValue = config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _config$retry, _config$retryDelay;
            // Stop if the fetch is already resolved
            if (isResolved) return;
             // Do we need to retry the request?
            const retry = (_config$retry = config.retry) != null ? _config$retry : 3;
            const retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : $cd25260720ff3eef$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                // We are done if the query does not need to be retried
                reject(error);
                return;
            }
            failureCount++; // Notify on fail
            config.onFail == null || config.onFail(failureCount, error); // Delay
            (0, $f8b865b18d670cc6$export$e772c8ff12451969)(delay) // Pause if the document is not visible or when the device is offline
            .then(()=>{
                if (shouldPause()) return pause();
                return;
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    }; // Start loop
    if ($cd25260720ff3eef$export$61b92f63f30245cf(config.networkMode)) run();
    else pause().then(run);
    return {
        promise: promise,
        cancel: cancel,
        continue: ()=>{
            const didContinue = continueFn == null ? void 0 : continueFn();
            return didContinue ? promise : Promise.resolve();
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry
    };
}



class $3141b454c0d4745f$export$e09608847fcc8c59 {
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $f8b865b18d670cc6$export$e539f754e934e270)(this.cacheTime)) this.gcTimeout = setTimeout(()=>{
            this.optionalRemove();
        }, this.cacheTime);
    }
    updateCacheTime(newCacheTime) {
        // Default to 5 minutes (Infinity for server-side) if no cache time is set
        this.cacheTime = Math.max(this.cacheTime || 0, newCacheTime != null ? newCacheTime : (0, $f8b865b18d670cc6$export$6acf61af03e62db) ? Infinity : 300000);
    }
    clearGcTimeout() {
        if (this.gcTimeout) {
            clearTimeout(this.gcTimeout);
            this.gcTimeout = undefined;
        }
    }
}


// CLASS
class $e66552176030227e$export$62297b13309008b2 extends (0, $3141b454c0d4745f$export$e09608847fcc8c59) {
    constructor(config){
        super();
        this.abortSignalConsumed = false;
        this.defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.cache = config.cache;
        this.logger = config.logger || (0, $9bd79d53e26c8f96$export$1cf3d545f2d4635c);
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.initialState = config.state || $e66552176030227e$var$getDefaultState(this.options);
        this.state = this.initialState;
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    setOptions(options) {
        this.options = {
            ...this.defaultOptions,
            ...options
        };
        this.updateCacheTime(this.options.cacheTime);
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") this.cache.remove(this);
    }
    setData(newData, options) {
        const data = (0, $f8b865b18d670cc6$export$17619bac5b909b23)(this.state.data, newData, this.options); // Set data and mark it as cached
        this.dispatch({
            data: data,
            type: "success",
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        this.dispatch({
            type: "setState",
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        var _this$retryer;
        const promise = this.promise;
        (_this$retryer = this.retryer) == null || _this$retryer.cancel(options);
        return promise ? promise.then((0, $f8b865b18d670cc6$export$8793edee2d425525)).catch((0, $f8b865b18d670cc6$export$8793edee2d425525)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState(this.initialState);
    }
    isActive() {
        return this.observers.some((observer)=>observer.options.enabled !== false);
    }
    isDisabled() {
        return this.getObserversCount() > 0 && !this.isActive();
    }
    isStale() {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some((observer)=>observer.getCurrentResult().isStale);
    }
    isStaleByTime(staleTime = 0) {
        return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0, $f8b865b18d670cc6$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _this$retryer2;
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer2 = this.retryer) == null || _this$retryer2.continue();
    }
    onOnline() {
        var _this$retryer3;
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        if (observer) observer.refetch({
            cancelRefetch: false
        });
         // Continue fetch if currently paused
        (_this$retryer3 = this.retryer) == null || _this$retryer3.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer); // Stop the query from being garbage collected
            this.clearGcTimeout();
            this.cache.notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                // If the transport layer does not support cancellation
                // we'll let the query continue so the result can be cached
                if (this.retryer) {
                    if (this.abortSignalConsumed) this.retryer.cancel({
                        revert: true
                    });
                    else this.retryer.cancelRetry();
                }
                this.scheduleGc();
            }
            this.cache.notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) this.dispatch({
            type: "invalidate"
        });
    }
    fetch(options, fetchOptions) {
        var _this$options$behavio, _context$fetchOptions;
        if (this.state.fetchStatus !== "idle") {
            if (this.state.dataUpdatedAt && fetchOptions != null && fetchOptions.cancelRefetch) // Silently cancel current fetch if the user wants to cancel refetches
            this.cancel({
                silent: true
            });
            else if (this.promise) {
                var _this$retryer4;
                // make sure that retries that were potentially cancelled due to unmounts can continue
                (_this$retryer4 = this.retryer) == null || _this$retryer4.continueRetry(); // Return current promise if we are already fetching
                return this.promise;
            }
        } // Update config if passed, otherwise the config from the last execution is used
        if (options) this.setOptions(options);
         // Use the options from the first observer with a query function if no function is found.
        // This can happen when the query is hydrated or created with setQueryData.
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = (0, $f8b865b18d670cc6$export$382ca5d13a8f252c)(); // Create query function context
        const queryFnContext = {
            queryKey: this.queryKey,
            pageParam: undefined,
            meta: this.meta
        }; // Adds an enumerable signal property to the object that
        // which sets abortSignalConsumed to true when the signal
        // is read.
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    if (abortController) {
                        this.abortSignalConsumed = true;
                        return abortController.signal;
                    }
                    return undefined;
                }
            });
        };
        addSignalProperty(queryFnContext); // Create fetch function
        const fetchFn = ()=>{
            if (!this.options.queryFn) return Promise.reject("Missing queryFn for queryKey '" + this.options.queryHash + "'");
            this.abortSignalConsumed = false;
            return this.options.queryFn(queryFnContext);
        }; // Trigger behavior hook
        const context = {
            fetchOptions: fetchOptions,
            options: this.options,
            queryKey: this.queryKey,
            state: this.state,
            fetchFn: fetchFn
        };
        addSignalProperty(context);
        (_this$options$behavio = this.options.behavior) == null || _this$options$behavio.onFetch(context); // Store state in case the current fetch needs to be reverted
        this.revertState = this.state; // Set to fetching state if not already in it
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
            var _context$fetchOptions2;
            this.dispatch({
                type: "fetch",
                meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
            });
        }
        const onError = (error)=>{
            // Optimistically update state if needed
            if (!((0, $cd25260720ff3eef$export$986cc6445c1d323)(error) && error.silent)) this.dispatch({
                type: "error",
                error: error
            });
            if (!(0, $cd25260720ff3eef$export$986cc6445c1d323)(error)) {
                var _this$cache$config$on, _this$cache$config, _this$cache$config$on2, _this$cache$config2;
                // Notify cache callback
                (_this$cache$config$on = (_this$cache$config = this.cache.config).onError) == null || _this$cache$config$on.call(_this$cache$config, error, this);
                (_this$cache$config$on2 = (_this$cache$config2 = this.cache.config).onSettled) == null || _this$cache$config$on2.call(_this$cache$config2, this.state.data, error, this);
            }
            if (!this.isFetchingOptimistic) // Schedule query gc after fetching
            this.scheduleGc();
            this.isFetchingOptimistic = false;
        }; // Try to fetch the data
        this.retryer = (0, $cd25260720ff3eef$export$2cbd00fe8a2c8d85)({
            fn: context.fetchFn,
            abort: abortController == null ? void 0 : abortController.abort.bind(abortController),
            onSuccess: (data)=>{
                var _this$cache$config$on3, _this$cache$config3, _this$cache$config$on4, _this$cache$config4;
                if (typeof data === "undefined") {
                    onError(new Error(this.queryHash + " data is undefined"));
                    return;
                }
                this.setData(data); // Notify cache callback
                (_this$cache$config$on3 = (_this$cache$config3 = this.cache.config).onSuccess) == null || _this$cache$config$on3.call(_this$cache$config3, data, this);
                (_this$cache$config$on4 = (_this$cache$config4 = this.cache.config).onSettled) == null || _this$cache$config$on4.call(_this$cache$config4, data, this.state.error, this);
                if (!this.isFetchingOptimistic) // Schedule query gc after fetching
                this.scheduleGc();
                this.isFetchingOptimistic = false;
            },
            onError: onError,
            onFail: (failureCount, error)=>{
                this.dispatch({
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                this.dispatch({
                    type: "pause"
                });
            },
            onContinue: ()=>{
                this.dispatch({
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode
        });
        this.promise = this.retryer.promise;
        return this.promise;
    }
    dispatch(action) {
        const reducer = (state)=>{
            var _action$meta, _action$dataUpdatedAt;
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        fetchFailureCount: action.failureCount,
                        fetchFailureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        fetchStatus: "paused"
                    };
                case "continue":
                    return {
                        ...state,
                        fetchStatus: "fetching"
                    };
                case "fetch":
                    return {
                        ...state,
                        fetchFailureCount: 0,
                        fetchFailureReason: null,
                        fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
                        fetchStatus: (0, $cd25260720ff3eef$export$61b92f63f30245cf)(this.options.networkMode) ? "fetching" : "paused",
                        ...!state.dataUpdatedAt && {
                            error: null,
                            status: "loading"
                        }
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        dataUpdateCount: state.dataUpdateCount + 1,
                        dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
                        error: null,
                        isInvalidated: false,
                        status: "success",
                        ...!action.manual && {
                            fetchStatus: "idle",
                            fetchFailureCount: 0,
                            fetchFailureReason: null
                        }
                    };
                case "error":
                    const error = action.error;
                    if ((0, $cd25260720ff3eef$export$986cc6445c1d323)(error) && error.revert && this.revertState) return {
                        ...this.revertState,
                        fetchStatus: "idle"
                    };
                    return {
                        ...state,
                        error: error,
                        errorUpdateCount: state.errorUpdateCount + 1,
                        errorUpdatedAt: Date.now(),
                        fetchFailureCount: state.fetchFailureCount + 1,
                        fetchFailureReason: error,
                        fetchStatus: "idle",
                        status: "error"
                    };
                case "invalidate":
                    return {
                        ...state,
                        isInvalidated: true
                    };
                case "setState":
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onQueryUpdate(action);
            });
            this.cache.notify({
                query: this,
                type: "updated",
                action: action
            });
        });
    }
}
function $e66552176030227e$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = typeof data !== "undefined";
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "loading",
        fetchStatus: "idle"
    };
}




// CLASS
class $013b25af9cb1d94e$export$5dde0cd941da8468 extends (0, $29a2986ef88e4ed5$export$d26086b469ecdbcc) {
    constructor(config){
        super();
        this.config = config || {};
        this.queries = [];
        this.queriesMap = {};
    }
    build(client, options, state) {
        var _options$queryHash;
        const queryKey = options.queryKey;
        const queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0, $f8b865b18d670cc6$export$cc90ca97bc0d73fd)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $e66552176030227e$export$62297b13309008b2)({
                cache: this,
                logger: client.getLogger(),
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!this.queriesMap[query.queryHash]) {
            this.queriesMap[query.queryHash] = query;
            this.queries.push(query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = this.queriesMap[query.queryHash];
        if (queryInMap) {
            query.destroy();
            this.queries = this.queries.filter((x)=>x !== query);
            if (queryInMap === query) delete this.queriesMap[query.queryHash];
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    clear() {
        (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>{
            this.queries.forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return this.queriesMap[queryHash];
    }
    getAll() {
        return this.queries;
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ find(arg1, arg2) {
        const [filters] = (0, $f8b865b18d670cc6$export$18e8f4b987e6c111)(arg1, arg2);
        if (typeof filters.exact === "undefined") filters.exact = true;
        return this.queries.find((query)=>(0, $f8b865b18d670cc6$export$c5d1efe363797780)(filters, query));
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ findAll(arg1, arg2) {
        const [filters] = (0, $f8b865b18d670cc6$export$18e8f4b987e6c111)(arg1, arg2);
        return Object.keys(filters).length > 0 ? this.queries.filter((query)=>(0, $f8b865b18d670cc6$export$c5d1efe363797780)(filters, query)) : this.queries;
    }
    notify(event) {
        (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach(({ listener: listener })=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>{
            this.queries.forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>{
            this.queries.forEach((query)=>{
                query.onOnline();
            });
        });
    }
}







// CLASS
class $da939cdf983103e1$export$17b8b19c814bcf56 extends (0, $3141b454c0d4745f$export$e09608847fcc8c59) {
    constructor(config){
        super();
        this.defaultOptions = config.defaultOptions;
        this.mutationId = config.mutationId;
        this.mutationCache = config.mutationCache;
        this.logger = config.logger || (0, $9bd79d53e26c8f96$export$1cf3d545f2d4635c);
        this.observers = [];
        this.state = config.state || $da939cdf983103e1$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = {
            ...this.defaultOptions,
            ...options
        };
        this.updateCacheTime(this.options.cacheTime);
    }
    get meta() {
        return this.options.meta;
    }
    setState(state) {
        this.dispatch({
            type: "setState",
            state: state
        });
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer); // Stop the mutation from being garbage collected
            this.clearGcTimeout();
            this.mutationCache.notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        this.observers = this.observers.filter((x)=>x !== observer);
        this.scheduleGc();
        this.mutationCache.notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!this.observers.length) {
            if (this.state.status === "loading") this.scheduleGc();
            else this.mutationCache.remove(this);
        }
    }
    continue() {
        var _this$retryer$continu, _this$retryer;
        return (_this$retryer$continu = (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.continue()) != null ? _this$retryer$continu : this.execute();
    }
    async execute() {
        const executeMutation = ()=>{
            var _this$options$retry;
            this.retryer = (0, $cd25260720ff3eef$export$2cbd00fe8a2c8d85)({
                fn: ()=>{
                    if (!this.options.mutationFn) return Promise.reject("No mutationFn found");
                    return this.options.mutationFn(this.state.variables);
                },
                onFail: (failureCount, error)=>{
                    this.dispatch({
                        type: "failed",
                        failureCount: failureCount,
                        error: error
                    });
                },
                onPause: ()=>{
                    this.dispatch({
                        type: "pause"
                    });
                },
                onContinue: ()=>{
                    this.dispatch({
                        type: "continue"
                    });
                },
                retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
                retryDelay: this.options.retryDelay,
                networkMode: this.options.networkMode
            });
            return this.retryer.promise;
        };
        const restored = this.state.status === "loading";
        try {
            var _this$mutationCache$c3, _this$mutationCache$c4, _this$options$onSucce, _this$options2, _this$mutationCache$c5, _this$mutationCache$c6, _this$options$onSettl, _this$options3;
            if (!restored) {
                var _this$mutationCache$c, _this$mutationCache$c2, _this$options$onMutat, _this$options;
                this.dispatch({
                    type: "loading",
                    variables: this.options.variables
                }); // Notify cache callback
                await ((_this$mutationCache$c = (_this$mutationCache$c2 = this.mutationCache.config).onMutate) == null ? void 0 : _this$mutationCache$c.call(_this$mutationCache$c2, this.state.variables, this));
                const context = await ((_this$options$onMutat = (_this$options = this.options).onMutate) == null ? void 0 : _this$options$onMutat.call(_this$options, this.state.variables));
                if (context !== this.state.context) this.dispatch({
                    type: "loading",
                    context: context,
                    variables: this.state.variables
                });
            }
            const data = await executeMutation(); // Notify cache callback
            await ((_this$mutationCache$c3 = (_this$mutationCache$c4 = this.mutationCache.config).onSuccess) == null ? void 0 : _this$mutationCache$c3.call(_this$mutationCache$c4, data, this.state.variables, this.state.context, this));
            await ((_this$options$onSucce = (_this$options2 = this.options).onSuccess) == null ? void 0 : _this$options$onSucce.call(_this$options2, data, this.state.variables, this.state.context)); // Notify cache callback
            await ((_this$mutationCache$c5 = (_this$mutationCache$c6 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c5.call(_this$mutationCache$c6, data, null, this.state.variables, this.state.context, this));
            await ((_this$options$onSettl = (_this$options3 = this.options).onSettled) == null ? void 0 : _this$options$onSettl.call(_this$options3, data, null, this.state.variables, this.state.context));
            this.dispatch({
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                var _this$mutationCache$c7, _this$mutationCache$c8, _this$options$onError, _this$options4, _this$mutationCache$c9, _this$mutationCache$c10, _this$options$onSettl2, _this$options5;
                // Notify cache callback
                await ((_this$mutationCache$c7 = (_this$mutationCache$c8 = this.mutationCache.config).onError) == null ? void 0 : _this$mutationCache$c7.call(_this$mutationCache$c8, error, this.state.variables, this.state.context, this));
                await ((_this$options$onError = (_this$options4 = this.options).onError) == null ? void 0 : _this$options$onError.call(_this$options4, error, this.state.variables, this.state.context)); // Notify cache callback
                await ((_this$mutationCache$c9 = (_this$mutationCache$c10 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c9.call(_this$mutationCache$c10, undefined, error, this.state.variables, this.state.context, this));
                await ((_this$options$onSettl2 = (_this$options5 = this.options).onSettled) == null ? void 0 : _this$options$onSettl2.call(_this$options5, undefined, error, this.state.variables, this.state.context));
                throw error;
            } finally{
                this.dispatch({
                    type: "error",
                    error: error
                });
            }
        }
    }
    dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        failureCount: action.failureCount,
                        failureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        isPaused: true
                    };
                case "continue":
                    return {
                        ...state,
                        isPaused: false
                    };
                case "loading":
                    return {
                        ...state,
                        context: action.context,
                        data: undefined,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        isPaused: !(0, $cd25260720ff3eef$export$61b92f63f30245cf)(this.options.networkMode),
                        status: "loading",
                        variables: action.variables
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        status: "success",
                        isPaused: false
                    };
                case "error":
                    return {
                        ...state,
                        data: undefined,
                        error: action.error,
                        failureCount: state.failureCount + 1,
                        failureReason: action.error,
                        isPaused: false,
                        status: "error"
                    };
                case "setState":
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onMutationUpdate(action);
            });
            this.mutationCache.notify({
                mutation: this,
                type: "updated",
                action: action
            });
        });
    }
}
function $da939cdf983103e1$export$a1659b54bac3252a() {
    return {
        context: undefined,
        data: undefined,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: undefined
    };
}




// CLASS
class $cc7bef81aaa407d7$export$1fcfd9a244434844 extends (0, $29a2986ef88e4ed5$export$d26086b469ecdbcc) {
    constructor(config){
        super();
        this.config = config || {};
        this.mutations = [];
        this.mutationId = 0;
    }
    build(client, options, state) {
        const mutation = new (0, $da939cdf983103e1$export$17b8b19c814bcf56)({
            mutationCache: this,
            logger: client.getLogger(),
            mutationId: ++this.mutationId,
            options: client.defaultMutationOptions(options),
            state: state,
            defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        this.mutations.push(mutation);
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    remove(mutation) {
        this.mutations = this.mutations.filter((x)=>x !== mutation);
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    clear() {
        (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>{
            this.mutations.forEach((mutation)=>{
                this.remove(mutation);
            });
        });
    }
    getAll() {
        return this.mutations;
    }
    find(filters) {
        if (typeof filters.exact === "undefined") filters.exact = true;
        return this.mutations.find((mutation)=>(0, $f8b865b18d670cc6$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    findAll(filters) {
        return this.mutations.filter((mutation)=>(0, $f8b865b18d670cc6$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    notify(event) {
        (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach(({ listener: listener })=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        var _this$resuming;
        this.resuming = ((_this$resuming = this.resuming) != null ? _this$resuming : Promise.resolve()).then(()=>{
            const pausedMutations = this.mutations.filter((x)=>x.state.isPaused);
            return (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>pausedMutations.reduce((promise, mutation)=>promise.then(()=>mutation.continue().catch((0, $f8b865b18d670cc6$export$8793edee2d425525))), Promise.resolve()));
        }).then(()=>{
            this.resuming = undefined;
        });
        return this.resuming;
    }
}





function $2fb8e98898cdca1c$export$84470d1367601e8d() {
    return {
        onFetch: (context)=>{
            context.fetchFn = ()=>{
                var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;
                const refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
                const fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
                const pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
                const isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === "forward";
                const isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === "backward";
                const oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
                const oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
                let newPageParams = oldPageParams;
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, "signal", {
                        enumerable: true,
                        get: ()=>{
                            var _context$signal;
                            if ((_context$signal = context.signal) != null && _context$signal.aborted) cancelled = true;
                            else {
                                var _context$signal2;
                                (_context$signal2 = context.signal) == null || _context$signal2.addEventListener("abort", ()=>{
                                    cancelled = true;
                                });
                            }
                            return context.signal;
                        }
                    });
                }; // Get query function
                const queryFn = context.options.queryFn || (()=>Promise.reject("Missing queryFn for queryKey '" + context.options.queryHash + "'"));
                const buildNewPages = (pages, param, page, previous)=>{
                    newPageParams = previous ? [
                        param,
                        ...newPageParams
                    ] : [
                        ...newPageParams,
                        param
                    ];
                    return previous ? [
                        page,
                        ...pages
                    ] : [
                        ...pages,
                        page
                    ];
                }; // Create function to fetch a page
                const fetchPage = (pages, manual, param, previous)=>{
                    if (cancelled) return Promise.reject("Cancelled");
                    if (typeof param === "undefined" && !manual && pages.length) return Promise.resolve(pages);
                    const queryFnContext = {
                        queryKey: context.queryKey,
                        pageParam: param,
                        meta: context.options.meta
                    };
                    addSignalProperty(queryFnContext);
                    const queryFnResult = queryFn(queryFnContext);
                    const promise = Promise.resolve(queryFnResult).then((page)=>buildNewPages(pages, param, page, previous));
                    return promise;
                };
                let promise; // Fetch first page?
                if (!oldPages.length) promise = fetchPage([]);
                else if (isFetchingNextPage) {
                    const manual = typeof pageParam !== "undefined";
                    const param = manual ? pageParam : $2fb8e98898cdca1c$export$1186159d57de7255(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param);
                } else if (isFetchingPreviousPage) {
                    const manual = typeof pageParam !== "undefined";
                    const param = manual ? pageParam : $2fb8e98898cdca1c$export$48efda17d8ac7ac7(context.options, oldPages);
                    promise = fetchPage(oldPages, manual, param, true);
                } else {
                    newPageParams = [];
                    const manual = typeof context.options.getNextPageParam === "undefined";
                    const shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page
                    promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages
                    for(let i = 1; i < oldPages.length; i++)promise = promise.then((pages)=>{
                        const shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;
                        if (shouldFetchNextPage) {
                            const param = manual ? oldPageParams[i] : $2fb8e98898cdca1c$export$1186159d57de7255(context.options, pages);
                            return fetchPage(pages, manual, param);
                        }
                        return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
                    });
                }
                const finalPromise = promise.then((pages)=>({
                        pages: pages,
                        pageParams: newPageParams
                    }));
                return finalPromise;
            };
        }
    };
}
function $2fb8e98898cdca1c$export$1186159d57de7255(options, pages) {
    return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function $2fb8e98898cdca1c$export$48efda17d8ac7ac7(options, pages) {
    return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
/**
 * Checks if there is a next page.
 * Returns `undefined` if it cannot be determined.
 */ function $2fb8e98898cdca1c$export$b9c88add8b8b5e6a(options, pages) {
    if (options.getNextPageParam && Array.isArray(pages)) {
        const nextPageParam = $2fb8e98898cdca1c$export$1186159d57de7255(options, pages);
        return typeof nextPageParam !== "undefined" && nextPageParam !== null && nextPageParam !== false;
    }
    return;
}
/**
 * Checks if there is a previous page.
 * Returns `undefined` if it cannot be determined.
 */ function $2fb8e98898cdca1c$export$db1663b730a8e6e4(options, pages) {
    if (options.getPreviousPageParam && Array.isArray(pages)) {
        const previousPageParam = $2fb8e98898cdca1c$export$48efda17d8ac7ac7(options, pages);
        return typeof previousPageParam !== "undefined" && previousPageParam !== null && previousPageParam !== false;
    }
    return;
}



// CLASS
class $993a0f6ad9d6681b$export$405d0624ed55a03f {
    constructor(config = {}){
        this.queryCache = config.queryCache || new (0, $013b25af9cb1d94e$export$5dde0cd941da8468)();
        this.mutationCache = config.mutationCache || new (0, $cc7bef81aaa407d7$export$1fcfd9a244434844)();
        this.logger = config.logger || (0, $9bd79d53e26c8f96$export$1cf3d545f2d4635c);
        this.defaultOptions = config.defaultOptions || {};
        this.queryDefaults = [];
        this.mutationDefaults = [];
        this.mountCount = 0;
    }
    mount() {
        this.mountCount++;
        if (this.mountCount !== 1) return;
        this.unsubscribeFocus = (0, $2a29005856faa11a$export$6bf54661be5b02cf).subscribe(()=>{
            if ((0, $2a29005856faa11a$export$6bf54661be5b02cf).isFocused()) {
                this.resumePausedMutations();
                this.queryCache.onFocus();
            }
        });
        this.unsubscribeOnline = (0, $bdda8765d46ccf87$export$b113e788b2dd3fdc).subscribe(()=>{
            if ((0, $bdda8765d46ccf87$export$b113e788b2dd3fdc).isOnline()) {
                this.resumePausedMutations();
                this.queryCache.onOnline();
            }
        });
    }
    unmount() {
        var _this$unsubscribeFocu, _this$unsubscribeOnli;
        this.mountCount--;
        if (this.mountCount !== 0) return;
        (_this$unsubscribeFocu = this.unsubscribeFocus) == null || _this$unsubscribeFocu.call(this);
        this.unsubscribeFocus = undefined;
        (_this$unsubscribeOnli = this.unsubscribeOnline) == null || _this$unsubscribeOnli.call(this);
        this.unsubscribeOnline = undefined;
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ isFetching(arg1, arg2) {
        const [filters] = (0, $f8b865b18d670cc6$export$18e8f4b987e6c111)(arg1, arg2);
        filters.fetchStatus = "fetching";
        return this.queryCache.findAll(filters).length;
    }
    isMutating(filters) {
        return this.mutationCache.findAll({
            ...filters,
            fetching: true
        }).length;
    }
    /**
   * @deprecated This method will accept only queryKey in the next major version.
   */ getQueryData(queryKey, filters) {
        var _this$queryCache$find;
        return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ ensureQueryData(arg1, arg2, arg3) {
        const parsedOptions = (0, $f8b865b18d670cc6$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        const cachedData = this.getQueryData(parsedOptions.queryKey);
        return cachedData ? Promise.resolve(cachedData) : this.fetchQuery(parsedOptions);
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ getQueriesData(queryKeyOrFilters) {
        return this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const query = this.queryCache.find(queryKey);
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, $f8b865b18d670cc6$export$7f095f455ad5af3f)(updater, prevData);
        if (typeof data === "undefined") return undefined;
        const parsedOptions = (0, $f8b865b18d670cc6$export$8a11fbc2c8ea08fd)(queryKey);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions);
        return this.queryCache.build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ setQueriesData(queryKeyOrFilters, updater, options) {
        return (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>this.getQueryCache().findAll(queryKeyOrFilters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey, /**
   * @deprecated This filters will be removed in the next major version.
   */ filters) {
        var _this$queryCache$find2;
        return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ removeQueries(arg1, arg2) {
        const [filters] = (0, $f8b865b18d670cc6$export$18e8f4b987e6c111)(arg1, arg2);
        const queryCache = this.queryCache;
        (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ resetQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $f8b865b18d670cc6$export$18e8f4b987e6c111)(arg1, arg2, arg3);
        const queryCache = this.queryCache;
        const refetchFilters = {
            type: "active",
            ...filters
        };
        return (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries(refetchFilters, options);
        });
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ cancelQueries(arg1, arg2, arg3) {
        const [filters, cancelOptions = {}] = (0, $f8b865b18d670cc6$export$18e8f4b987e6c111)(arg1, arg2, arg3);
        if (typeof cancelOptions.revert === "undefined") cancelOptions.revert = true;
        const promises = (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>this.queryCache.findAll(filters).map((query)=>query.cancel(cancelOptions)));
        return Promise.all(promises).then((0, $f8b865b18d670cc6$export$8793edee2d425525)).catch((0, $f8b865b18d670cc6$export$8793edee2d425525));
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ invalidateQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $f8b865b18d670cc6$export$18e8f4b987e6c111)(arg1, arg2, arg3);
        return (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>{
            var _ref, _filters$refetchType;
            this.queryCache.findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters.refetchType === "none") return Promise.resolve();
            const refetchFilters = {
                ...filters,
                type: (_ref = (_filters$refetchType = filters.refetchType) != null ? _filters$refetchType : filters.type) != null ? _ref : "active"
            };
            return this.refetchQueries(refetchFilters, options);
        });
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ refetchQueries(arg1, arg2, arg3) {
        const [filters, options] = (0, $f8b865b18d670cc6$export$18e8f4b987e6c111)(arg1, arg2, arg3);
        const promises = (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>this.queryCache.findAll(filters).filter((query)=>!query.isDisabled()).map((query)=>{
                var _options$cancelRefetc;
                return query.fetch(undefined, {
                    ...options,
                    cancelRefetch: (_options$cancelRefetc = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc : true,
                    meta: {
                        refetchPage: filters.refetchPage
                    }
                });
            }));
        let promise = Promise.all(promises).then((0, $f8b865b18d670cc6$export$8793edee2d425525));
        if (!(options != null && options.throwOnError)) promise = promise.catch((0, $f8b865b18d670cc6$export$8793edee2d425525));
        return promise;
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ fetchQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, $f8b865b18d670cc6$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        const defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652
        if (typeof defaultedOptions.retry === "undefined") defaultedOptions.retry = false;
        const query = this.queryCache.build(this, defaultedOptions);
        return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ prefetchQuery(arg1, arg2, arg3) {
        return this.fetchQuery(arg1, arg2, arg3).then((0, $f8b865b18d670cc6$export$8793edee2d425525)).catch((0, $f8b865b18d670cc6$export$8793edee2d425525));
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ fetchInfiniteQuery(arg1, arg2, arg3) {
        const parsedOptions = (0, $f8b865b18d670cc6$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
        parsedOptions.behavior = (0, $2fb8e98898cdca1c$export$84470d1367601e8d)();
        return this.fetchQuery(parsedOptions);
    }
    /**
   * @deprecated This method should be used with only one object argument.
   */ prefetchInfiniteQuery(arg1, arg2, arg3) {
        return this.fetchInfiniteQuery(arg1, arg2, arg3).then((0, $f8b865b18d670cc6$export$8793edee2d425525)).catch((0, $f8b865b18d670cc6$export$8793edee2d425525));
    }
    resumePausedMutations() {
        return this.mutationCache.resumePausedMutations();
    }
    getQueryCache() {
        return this.queryCache;
    }
    getMutationCache() {
        return this.mutationCache;
    }
    getLogger() {
        return this.logger;
    }
    getDefaultOptions() {
        return this.defaultOptions;
    }
    setDefaultOptions(options) {
        this.defaultOptions = options;
    }
    setQueryDefaults(queryKey, options) {
        const result = this.queryDefaults.find((x)=>(0, $f8b865b18d670cc6$export$5fcb678681417b54)(queryKey) === (0, $f8b865b18d670cc6$export$5fcb678681417b54)(x.queryKey));
        if (result) result.defaultOptions = options;
        else this.queryDefaults.push({
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        if (!queryKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.queryDefaults.find((x)=>(0, $f8b865b18d670cc6$export$2f07189bb9fa26a7)(queryKey, x.queryKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    setMutationDefaults(mutationKey, options) {
        const result = this.mutationDefaults.find((x)=>(0, $f8b865b18d670cc6$export$5fcb678681417b54)(mutationKey) === (0, $f8b865b18d670cc6$export$5fcb678681417b54)(x.mutationKey));
        if (result) result.defaultOptions = options;
        else this.mutationDefaults.push({
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        if (!mutationKey) return undefined;
         // Get the first matching defaults
        const firstMatchingDefaults = this.mutationDefaults.find((x)=>(0, $f8b865b18d670cc6$export$2f07189bb9fa26a7)(mutationKey, x.mutationKey)); // Additional checks and error in dev mode
        return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
    }
    defaultQueryOptions(options) {
        if (options != null && options._defaulted) return options;
        const defaultedOptions = {
            ...this.defaultOptions.queries,
            ...this.getQueryDefaults(options == null ? void 0 : options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash && defaultedOptions.queryKey) defaultedOptions.queryHash = (0, $f8b865b18d670cc6$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
         // dependent default values
        if (typeof defaultedOptions.refetchOnReconnect === "undefined") defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (typeof defaultedOptions.useErrorBoundary === "undefined") defaultedOptions.useErrorBoundary = !!defaultedOptions.suspense;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options != null && options._defaulted) return options;
        return {
            ...this.defaultOptions.mutations,
            ...this.getMutationDefaults(options == null ? void 0 : options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        this.queryCache.clear();
        this.mutationCache.clear();
    }
}


var $acw62 = parcelRequire("acw62");
"use client";
const $0126047dd734bc33$export$2fba198b5b2e37fa = /*#__PURE__*/ $acw62.createContext(undefined);
const $0126047dd734bc33$var$QueryClientSharingContext = /*#__PURE__*/ $acw62.createContext(false); // If we are given a context, we will use it.
// Otherwise, if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.
function $0126047dd734bc33$var$getQueryClientContext(context, contextSharing) {
    if (context) return context;
    if (contextSharing && typeof window !== "undefined") {
        if (!window.ReactQueryClientContext) window.ReactQueryClientContext = $0126047dd734bc33$export$2fba198b5b2e37fa;
        return window.ReactQueryClientContext;
    }
    return $0126047dd734bc33$export$2fba198b5b2e37fa;
}
const $0126047dd734bc33$export$22e77b9572c4fded = ({ context: context } = {})=>{
    const queryClient = $acw62.useContext($0126047dd734bc33$var$getQueryClientContext(context, $acw62.useContext($0126047dd734bc33$var$QueryClientSharingContext)));
    if (!queryClient) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return queryClient;
};
const $0126047dd734bc33$export$45604f0cc8ae667b = ({ client: client, children: children, context: context, contextSharing: contextSharing = false })=>{
    $acw62.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    const Context = $0126047dd734bc33$var$getQueryClientContext(context, contextSharing);
    return /*#__PURE__*/ $acw62.createElement($0126047dd734bc33$var$QueryClientSharingContext.Provider, {
        value: !context && contextSharing
    }, /*#__PURE__*/ $acw62.createElement(Context.Provider, {
        value: client
    }, children));
};


var $acw62 = parcelRequire("acw62");




// CLASS
class $d72b95cae394c51c$export$d3c1860ee66f291a extends (0, $29a2986ef88e4ed5$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        this.client = client;
        this.setOptions(options);
        this.bindMethods();
        this.updateResult();
    }
    bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    }
    setOptions(options) {
        var _this$currentMutation;
        const prevOptions = this.options;
        this.options = this.client.defaultMutationOptions(options);
        if (!(0, $f8b865b18d670cc6$export$3e67810a3f0e9f1c)(prevOptions, this.options)) this.client.getMutationCache().notify({
            type: "observerOptionsUpdated",
            mutation: this.currentMutation,
            observer: this
        });
        (_this$currentMutation = this.currentMutation) == null || _this$currentMutation.setOptions(this.options);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            var _this$currentMutation2;
            (_this$currentMutation2 = this.currentMutation) == null || _this$currentMutation2.removeObserver(this);
        }
    }
    onMutationUpdate(action) {
        this.updateResult(); // Determine which callbacks to trigger
        const notifyOptions = {
            listeners: true
        };
        if (action.type === "success") notifyOptions.onSuccess = true;
        else if (action.type === "error") notifyOptions.onError = true;
        this.notify(notifyOptions);
    }
    getCurrentResult() {
        return this.currentResult;
    }
    reset() {
        this.currentMutation = undefined;
        this.updateResult();
        this.notify({
            listeners: true
        });
    }
    mutate(variables, options) {
        this.mutateOptions = options;
        if (this.currentMutation) this.currentMutation.removeObserver(this);
        this.currentMutation = this.client.getMutationCache().build(this.client, {
            ...this.options,
            variables: typeof variables !== "undefined" ? variables : this.options.variables
        });
        this.currentMutation.addObserver(this);
        return this.currentMutation.execute();
    }
    updateResult() {
        const state = this.currentMutation ? this.currentMutation.state : (0, $da939cdf983103e1$export$a1659b54bac3252a)();
        const isLoading = state.status === "loading";
        const result = {
            ...state,
            isLoading: isLoading,
            isPending: isLoading,
            isSuccess: state.status === "success",
            isError: state.status === "error",
            isIdle: state.status === "idle",
            mutate: this.mutate,
            reset: this.reset
        };
        this.currentResult = result;
    }
    notify(options) {
        (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>{
            // First trigger the mutate callbacks
            if (this.mutateOptions && this.hasListeners()) {
                if (options.onSuccess) {
                    var _this$mutateOptions$o, _this$mutateOptions, _this$mutateOptions$o2, _this$mutateOptions2;
                    (_this$mutateOptions$o = (_this$mutateOptions = this.mutateOptions).onSuccess) == null || _this$mutateOptions$o.call(_this$mutateOptions, this.currentResult.data, this.currentResult.variables, this.currentResult.context);
                    (_this$mutateOptions$o2 = (_this$mutateOptions2 = this.mutateOptions).onSettled) == null || _this$mutateOptions$o2.call(_this$mutateOptions2, this.currentResult.data, null, this.currentResult.variables, this.currentResult.context);
                } else if (options.onError) {
                    var _this$mutateOptions$o3, _this$mutateOptions3, _this$mutateOptions$o4, _this$mutateOptions4;
                    (_this$mutateOptions$o3 = (_this$mutateOptions3 = this.mutateOptions).onError) == null || _this$mutateOptions$o3.call(_this$mutateOptions3, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
                    (_this$mutateOptions$o4 = (_this$mutateOptions4 = this.mutateOptions).onSettled) == null || _this$mutateOptions$o4.call(_this$mutateOptions4, undefined, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
                }
            } // Then trigger the listeners
            if (options.listeners) this.listeners.forEach(({ listener: listener })=>{
                listener(this.currentResult);
            });
        });
    }
}



var $hfliI = parcelRequire("hfliI");
"use client";
const $cb54322a339eb896$export$306c0aa65ff9ec16 = (0, $hfliI.useSyncExternalStore);



function $a6837397414c8694$export$2072f68e6c3507cf(_useErrorBoundary, params) {
    // Allow useErrorBoundary function to override throwing behavior on a per-error basis
    if (typeof _useErrorBoundary === "function") return _useErrorBoundary(...params);
    return !!_useErrorBoundary;
}


"use client";
function $cb7b7c348969488c$export$609860bf8b0084c(arg1, arg2, arg3) {
    const options = (0, $f8b865b18d670cc6$export$b646c531ea475334)(arg1, arg2, arg3);
    const queryClient = (0, $0126047dd734bc33$export$22e77b9572c4fded)({
        context: options.context
    });
    const [observer] = $acw62.useState(()=>new (0, $d72b95cae394c51c$export$d3c1860ee66f291a)(queryClient, options));
    $acw62.useEffect(()=>{
        observer.setOptions(options);
    }, [
        observer,
        options
    ]);
    const result = (0, $cb54322a339eb896$export$306c0aa65ff9ec16)($acw62.useCallback((onStoreChange)=>observer.subscribe((0, $9c9aacadc80c6826$export$520687f44db6e1ab).batchCalls(onStoreChange)), [
        observer
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    const mutate = $acw62.useCallback((variables, mutateOptions)=>{
        observer.mutate(variables, mutateOptions).catch($cb7b7c348969488c$var$noop);
    }, [
        observer
    ]);
    if (result.error && (0, $a6837397414c8694$export$2072f68e6c3507cf)(observer.options.useErrorBoundary, [
        result.error
    ])) throw result.error;
    return {
        ...result,
        mutate: mutate,
        mutateAsync: result.mutate
    };
} // eslint-disable-next-line @typescript-eslint/no-empty-function
function $cb7b7c348969488c$var$noop() {}






class $d07b9a140ad50c23$export$a06cf8c0066f0d4c extends (0, $29a2986ef88e4ed5$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        this.client = client;
        this.options = options;
        this.trackedProps = new Set();
        this.selectError = null;
        this.bindMethods();
        this.setOptions(options);
    }
    bindMethods() {
        this.remove = this.remove.bind(this);
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            this.currentQuery.addObserver(this);
            if ($d07b9a140ad50c23$var$shouldFetchOnMount(this.currentQuery, this.options)) this.executeFetch();
            this.updateTimers();
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $d07b9a140ad50c23$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $d07b9a140ad50c23$var$shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = new Set();
        this.clearStaleTimeout();
        this.clearRefetchInterval();
        this.currentQuery.removeObserver(this);
    }
    setOptions(options, notifyOptions) {
        const prevOptions = this.options;
        const prevQuery = this.currentQuery;
        this.options = this.client.defaultQueryOptions(options);
        if (!(0, $f8b865b18d670cc6$export$3e67810a3f0e9f1c)(prevOptions, this.options)) this.client.getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: this.currentQuery,
            observer: this
        });
        if (typeof this.options.enabled !== "undefined" && typeof this.options.enabled !== "boolean") throw new Error("Expected enabled to be a boolean");
         // Keep previous query key if the user does not supply one
        if (!this.options.queryKey) this.options.queryKey = prevOptions.queryKey;
        this.updateQuery();
        const mounted = this.hasListeners(); // Fetch if there are subscribers
        if (mounted && $d07b9a140ad50c23$var$shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) this.executeFetch();
         // Update result
        this.updateResult(notifyOptions); // Update stale interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) this.updateStaleTimeout();
        const nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed
        if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) this.updateRefetchInterval(nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = this.client.getQueryCache().build(this.client, options);
        const result = this.createResult(query, options);
        if ($d07b9a140ad50c23$var$shouldAssignObserverCurrentProperties(this, result, options)) {
            // this assigns the optimistic result to the current Observer
            // because if the query function changes, useQuery will be performing
            // an effect where it would fetch again.
            // When the fetch finishes, we perform a deep data cloning in order
            // to reuse objects references. This deep data clone is performed against
            // the `observer.currentResult.data` property
            // When QueryKey changes, we refresh the query and get new `optimistic`
            // result, while we leave the `observer.currentResult`, so when new data
            // arrives, it finds the old `observer.currentResult` which is related
            // to the old QueryKey. Which means that currentResult and selectData are
            // out of sync already.
            // To solve this, we move the cursor of the currentResult everytime
            // an observer reads an optimistic value.
            // When keeping the previous data, the result doesn't change until new
            // data arrives.
            this.currentResult = result;
            this.currentResultOptions = this.options;
            this.currentResultState = this.currentQuery.state;
        }
        return result;
    }
    getCurrentResult() {
        return this.currentResult;
    }
    trackResult(result) {
        const trackedResult = {};
        Object.keys(result).forEach((key)=>{
            Object.defineProperty(trackedResult, key, {
                configurable: false,
                enumerable: true,
                get: ()=>{
                    this.trackedProps.add(key);
                    return result[key];
                }
            });
        });
        return trackedResult;
    }
    getCurrentQuery() {
        return this.currentQuery;
    }
    remove() {
        this.client.getQueryCache().remove(this.currentQuery);
    }
    refetch({ refetchPage: refetchPage, ...options } = {}) {
        return this.fetch({
            ...options,
            meta: {
                refetchPage: refetchPage
            }
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = this.client.defaultQueryOptions(options);
        const query = this.client.getQueryCache().build(this.client, defaultedOptions);
        query.isFetchingOptimistic = true;
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        var _fetchOptions$cancelR;
        return this.executeFetch({
            ...fetchOptions,
            cancelRefetch: (_fetchOptions$cancelR = fetchOptions.cancelRefetch) != null ? _fetchOptions$cancelR : true
        }).then(()=>{
            this.updateResult();
            return this.currentResult;
        });
    }
    executeFetch(fetchOptions) {
        // Make sure we reference the latest query as the current one might have been removed
        this.updateQuery(); // Fetch
        let promise = this.currentQuery.fetch(this.options, fetchOptions);
        if (!(fetchOptions != null && fetchOptions.throwOnError)) promise = promise.catch((0, $f8b865b18d670cc6$export$8793edee2d425525));
        return promise;
    }
    updateStaleTimeout() {
        this.clearStaleTimeout();
        if ((0, $f8b865b18d670cc6$export$6acf61af03e62db) || this.currentResult.isStale || !(0, $f8b865b18d670cc6$export$e539f754e934e270)(this.options.staleTime)) return;
        const time = (0, $f8b865b18d670cc6$export$811b83d62bcf47f0)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
        // To mitigate this issue we always add 1 ms to the timeout.
        const timeout = time + 1;
        this.staleTimeoutId = setTimeout(()=>{
            if (!this.currentResult.isStale) this.updateResult();
        }, timeout);
    }
    computeRefetchInterval() {
        var _this$options$refetch;
        return typeof this.options.refetchInterval === "function" ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
    }
    updateRefetchInterval(nextInterval) {
        this.clearRefetchInterval();
        this.currentRefetchInterval = nextInterval;
        if ((0, $f8b865b18d670cc6$export$6acf61af03e62db) || this.options.enabled === false || !(0, $f8b865b18d670cc6$export$e539f754e934e270)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) return;
        this.refetchIntervalId = setInterval(()=>{
            if (this.options.refetchIntervalInBackground || (0, $2a29005856faa11a$export$6bf54661be5b02cf).isFocused()) this.executeFetch();
        }, this.currentRefetchInterval);
    }
    updateTimers() {
        this.updateStaleTimeout();
        this.updateRefetchInterval(this.computeRefetchInterval());
    }
    clearStaleTimeout() {
        if (this.staleTimeoutId) {
            clearTimeout(this.staleTimeoutId);
            this.staleTimeoutId = undefined;
        }
    }
    clearRefetchInterval() {
        if (this.refetchIntervalId) {
            clearInterval(this.refetchIntervalId);
            this.refetchIntervalId = undefined;
        }
    }
    createResult(query, options) {
        const prevQuery = this.currentQuery;
        const prevOptions = this.options;
        const prevResult = this.currentResult;
        const prevResultState = this.currentResultState;
        const prevResultOptions = this.currentResultOptions;
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
        const prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
        const { state: state } = query;
        let { dataUpdatedAt: dataUpdatedAt, error: error, errorUpdatedAt: errorUpdatedAt, fetchStatus: fetchStatus, status: status } = state;
        let isPreviousData = false;
        let isPlaceholderData = false;
        let data; // Optimistically set result in fetching state if needed
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $d07b9a140ad50c23$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $d07b9a140ad50c23$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) {
                fetchStatus = (0, $cd25260720ff3eef$export$61b92f63f30245cf)(query.options.networkMode) ? "fetching" : "paused";
                if (!dataUpdatedAt) status = "loading";
            }
            if (options._optimisticResults === "isRestoring") fetchStatus = "idle";
        } // Keep previous data if needed
        if (options.keepPreviousData && !state.dataUpdatedAt && prevQueryResult != null && prevQueryResult.isSuccess && status !== "error") {
            data = prevQueryResult.data;
            dataUpdatedAt = prevQueryResult.dataUpdatedAt;
            status = prevQueryResult.status;
            isPreviousData = true;
        } else if (options.select && typeof state.data !== "undefined") {
            // Memoize select result
            if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) data = this.selectResult;
            else try {
                this.selectFn = options.select;
                data = options.select(state.data);
                data = (0, $f8b865b18d670cc6$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, data, options);
                this.selectResult = data;
                this.selectError = null;
            } catch (selectError) {
                this.selectError = selectError;
            }
        } else data = state.data;
         // Show placeholder data if needed
        if (typeof options.placeholderData !== "undefined" && typeof data === "undefined" && status === "loading") {
            let placeholderData; // Memoize placeholder data
            if (prevResult != null && prevResult.isPlaceholderData && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) placeholderData = prevResult.data;
            else {
                placeholderData = typeof options.placeholderData === "function" ? options.placeholderData() : options.placeholderData;
                if (options.select && typeof placeholderData !== "undefined") try {
                    placeholderData = options.select(placeholderData);
                    this.selectError = null;
                } catch (selectError) {
                    this.selectError = selectError;
                }
            }
            if (typeof placeholderData !== "undefined") {
                status = "success";
                data = (0, $f8b865b18d670cc6$export$17619bac5b909b23)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if (this.selectError) {
            error = this.selectError;
            data = this.selectResult;
            errorUpdatedAt = Date.now();
            status = "error";
        }
        const isFetching = fetchStatus === "fetching";
        const isLoading = status === "loading";
        const isError = status === "error";
        const result = {
            status: status,
            fetchStatus: fetchStatus,
            isLoading: isLoading,
            isSuccess: status === "success",
            isError: isError,
            isInitialLoading: isLoading && isFetching,
            data: data,
            dataUpdatedAt: dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: state.fetchFailureCount,
            failureReason: state.fetchFailureReason,
            errorUpdateCount: state.errorUpdateCount,
            isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
            isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isLoading,
            isLoadingError: isError && state.dataUpdatedAt === 0,
            isPaused: fetchStatus === "paused",
            isPlaceholderData: isPlaceholderData,
            isPreviousData: isPreviousData,
            isRefetchError: isError && state.dataUpdatedAt !== 0,
            isStale: $d07b9a140ad50c23$var$isStale(query, options),
            refetch: this.refetch,
            remove: this.remove
        };
        return result;
    }
    updateResult(notifyOptions) {
        const prevResult = this.currentResult;
        const nextResult = this.createResult(this.currentQuery, this.options);
        this.currentResultState = this.currentQuery.state;
        this.currentResultOptions = this.options; // Only notify and update result if something has changed
        if ((0, $f8b865b18d670cc6$export$3e67810a3f0e9f1c)(nextResult, prevResult)) return;
        this.currentResult = nextResult; // Determine which callbacks to trigger
        const defaultNotifyOptions = {
            cache: true
        };
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !this.trackedProps.size) return true;
            const includedProps = new Set(notifyOnChangePropsValue != null ? notifyOnChangePropsValue : this.trackedProps);
            if (this.options.useErrorBoundary) includedProps.add("error");
            return Object.keys(this.currentResult).some((key)=>{
                const typedKey = key;
                const changed = this.currentResult[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && shouldNotifyListeners()) defaultNotifyOptions.listeners = true;
        this.notify({
            ...defaultNotifyOptions,
            ...notifyOptions
        });
    }
    updateQuery() {
        const query = this.client.getQueryCache().build(this.client, this.options);
        if (query === this.currentQuery) return;
        const prevQuery = this.currentQuery;
        this.currentQuery = query;
        this.currentQueryInitialState = query.state;
        this.previousQueryResult = this.currentResult;
        if (this.hasListeners()) {
            prevQuery == null || prevQuery.removeObserver(this);
            query.addObserver(this);
        }
    }
    onQueryUpdate(action) {
        const notifyOptions = {};
        if (action.type === "success") notifyOptions.onSuccess = !action.manual;
        else if (action.type === "error" && !(0, $cd25260720ff3eef$export$986cc6445c1d323)(action.error)) notifyOptions.onError = true;
        this.updateResult(notifyOptions);
        if (this.hasListeners()) this.updateTimers();
    }
    notify(notifyOptions) {
        (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batch(()=>{
            // First trigger the configuration callbacks
            if (notifyOptions.onSuccess) {
                var _this$options$onSucce, _this$options, _this$options$onSettl, _this$options2;
                (_this$options$onSucce = (_this$options = this.options).onSuccess) == null || _this$options$onSucce.call(_this$options, this.currentResult.data);
                (_this$options$onSettl = (_this$options2 = this.options).onSettled) == null || _this$options$onSettl.call(_this$options2, this.currentResult.data, null);
            } else if (notifyOptions.onError) {
                var _this$options$onError, _this$options3, _this$options$onSettl2, _this$options4;
                (_this$options$onError = (_this$options3 = this.options).onError) == null || _this$options$onError.call(_this$options3, this.currentResult.error);
                (_this$options$onSettl2 = (_this$options4 = this.options).onSettled) == null || _this$options$onSettl2.call(_this$options4, undefined, this.currentResult.error);
            } // Then trigger the listeners
            if (notifyOptions.listeners) this.listeners.forEach(({ listener: listener })=>{
                listener(this.currentResult);
            });
             // Then the cache listeners
            if (notifyOptions.cache) this.client.getQueryCache().notify({
                query: this.currentQuery,
                type: "observerResultsUpdated"
            });
        });
    }
}
function $d07b9a140ad50c23$var$shouldLoadOnMount(query, options) {
    return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === "error" && options.retryOnMount === false);
}
function $d07b9a140ad50c23$var$shouldFetchOnMount(query, options) {
    return $d07b9a140ad50c23$var$shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && $d07b9a140ad50c23$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $d07b9a140ad50c23$var$shouldFetchOn(query, options, field) {
    if (options.enabled !== false) {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && $d07b9a140ad50c23$var$isStale(query, options);
    }
    return false;
}
function $d07b9a140ad50c23$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== "error") && $d07b9a140ad50c23$var$isStale(query, options);
}
function $d07b9a140ad50c23$var$isStale(query, options) {
    return query.isStaleByTime(options.staleTime);
} // this function would decide if we will update the observer's 'current'
// properties after an optimistic reading via getOptimisticResult
function $d07b9a140ad50c23$var$shouldAssignObserverCurrentProperties(observer, optimisticResult, options) {
    // it is important to keep this condition like this for three reasons:
    // 1. It will get removed in the v5
    // 2. it reads: don't update the properties if we want to keep the previous
    // data.
    // 3. The opposite condition (!options.keepPreviousData) would fallthrough
    // and will result in a bad decision
    if (options.keepPreviousData) return false;
     // this means we want to put some placeholder data when pending and queryKey
    // changed.
    if (options.placeholderData !== undefined) // re-assign properties only if current data is placeholder data
    // which means that data did not arrive yet, so, if there is some cached data
    // we need to "prepare" to receive it
    return optimisticResult.isPlaceholderData;
     // if the newly created result isn't what the observer is holding as current,
    // then we'll need to update the properties as well
    if (!(0, $f8b865b18d670cc6$export$3e67810a3f0e9f1c)(observer.getCurrentResult(), optimisticResult)) return true;
     // basically, just keep previous properties if nothing changed
    return false;
}



class $b0ecc900a9d29037$export$85d960eb3ab339c8 extends (0, $d07b9a140ad50c23$export$a06cf8c0066f0d4c) {
    // Type override
    // Type override
    // Type override
    // eslint-disable-next-line @typescript-eslint/no-useless-constructor
    constructor(client, options){
        super(client, options);
    }
    bindMethods() {
        super.bindMethods();
        this.fetchNextPage = this.fetchNextPage.bind(this);
        this.fetchPreviousPage = this.fetchPreviousPage.bind(this);
    }
    setOptions(options, notifyOptions) {
        super.setOptions({
            ...options,
            behavior: (0, $2fb8e98898cdca1c$export$84470d1367601e8d)()
        }, notifyOptions);
    }
    getOptimisticResult(options) {
        options.behavior = (0, $2fb8e98898cdca1c$export$84470d1367601e8d)();
        return super.getOptimisticResult(options);
    }
    fetchNextPage({ pageParam: pageParam, ...options } = {}) {
        return this.fetch({
            ...options,
            meta: {
                fetchMore: {
                    direction: "forward",
                    pageParam: pageParam
                }
            }
        });
    }
    fetchPreviousPage({ pageParam: pageParam, ...options } = {}) {
        return this.fetch({
            ...options,
            meta: {
                fetchMore: {
                    direction: "backward",
                    pageParam: pageParam
                }
            }
        });
    }
    createResult(query, options) {
        var _state$fetchMeta, _state$fetchMeta$fetc, _state$fetchMeta2, _state$fetchMeta2$fet, _state$data, _state$data2;
        const { state: state } = query;
        const result = super.createResult(query, options);
        const { isFetching: isFetching, isRefetching: isRefetching } = result;
        const isFetchingNextPage = isFetching && ((_state$fetchMeta = state.fetchMeta) == null ? void 0 : (_state$fetchMeta$fetc = _state$fetchMeta.fetchMore) == null ? void 0 : _state$fetchMeta$fetc.direction) === "forward";
        const isFetchingPreviousPage = isFetching && ((_state$fetchMeta2 = state.fetchMeta) == null ? void 0 : (_state$fetchMeta2$fet = _state$fetchMeta2.fetchMore) == null ? void 0 : _state$fetchMeta2$fet.direction) === "backward";
        return {
            ...result,
            fetchNextPage: this.fetchNextPage,
            fetchPreviousPage: this.fetchPreviousPage,
            hasNextPage: (0, $2fb8e98898cdca1c$export$b9c88add8b8b5e6a)(options, (_state$data = state.data) == null ? void 0 : _state$data.pages),
            hasPreviousPage: (0, $2fb8e98898cdca1c$export$db1663b730a8e6e4)(options, (_state$data2 = state.data) == null ? void 0 : _state$data2.pages),
            isFetchingNextPage: isFetchingNextPage,
            isFetchingPreviousPage: isFetchingPreviousPage,
            isRefetching: isRefetching && !isFetchingNextPage && !isFetchingPreviousPage
        };
    }
}



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
"use client";
function $d8c18f57bc93d04e$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
const $d8c18f57bc93d04e$var$QueryErrorResetBoundaryContext = /*#__PURE__*/ $acw62.createContext($d8c18f57bc93d04e$var$createValue()); // HOOK
const $d8c18f57bc93d04e$export$50dfac555130cafd = ()=>$acw62.useContext($d8c18f57bc93d04e$var$QueryErrorResetBoundaryContext); // COMPONENT
const $d8c18f57bc93d04e$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $acw62.useState(()=>$d8c18f57bc93d04e$var$createValue());
    return /*#__PURE__*/ $acw62.createElement($d8c18f57bc93d04e$var$QueryErrorResetBoundaryContext.Provider, {
        value: value
    }, typeof children === "function" ? children(value) : children);
};




var $acw62 = parcelRequire("acw62");
"use client";
const $d73410633d0f0f28$var$IsRestoringContext = /*#__PURE__*/ $acw62.createContext(false);
const $d73410633d0f0f28$export$4da0178d6b5f553 = ()=>$acw62.useContext($d73410633d0f0f28$var$IsRestoringContext);
const $d73410633d0f0f28$export$593807d4e94f9621 = $d73410633d0f0f28$var$IsRestoringContext.Provider;



var $acw62 = parcelRequire("acw62");

"use client";
const $2cae4142f68cd6ce$export$ae8adb3de3d77633 = (options, errorResetBoundary)=>{
    if (options.suspense || options.useErrorBoundary) // Prevent retrying failed query if the error boundary has not been reset yet
    {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
const $2cae4142f68cd6ce$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $acw62.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
const $2cae4142f68cd6ce$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, useErrorBoundary: useErrorBoundary, query: query })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && (0, $a6837397414c8694$export$2072f68e6c3507cf)(useErrorBoundary, [
        result.error,
        query
    ]);
};


/**
 * Ensures minimum staleTime and cacheTime values when suspense is enabled.
 * Despite the name, this function guards both staleTime and cacheTime to prevent
 * infinite re-render loops with synchronous queries.
 *
 * @deprecated in v5 - replaced by ensureSuspenseTimers
 */ const $bf865f1d403d5a28$export$2c40a591ad2dafb1 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) {
        // Always set stale time when using suspense to prevent
        // fetching again when directly mounting after suspending
        if (typeof defaultedOptions.staleTime !== "number") defaultedOptions.staleTime = 1000;
        if (typeof defaultedOptions.cacheTime === "number") defaultedOptions.cacheTime = Math.max(defaultedOptions.cacheTime, 1000);
    }
};
const $bf865f1d403d5a28$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
const $bf865f1d403d5a28$export$88d3586dfed64df9 = (defaultedOptions, result, isRestoring)=>(defaultedOptions == null ? void 0 : defaultedOptions.suspense) && $bf865f1d403d5a28$export$e0a3f29513afe430(result, isRestoring);
const $bf865f1d403d5a28$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).then(({ data: data })=>{
        defaultedOptions.onSuccess == null || defaultedOptions.onSuccess(data);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(data, null);
    }).catch((error)=>{
        errorResetBoundary.clearReset();
        defaultedOptions.onError == null || defaultedOptions.onError(error);
        defaultedOptions.onSettled == null || defaultedOptions.onSettled(undefined, error);
    });


"use client";
function $ede1b94721233a5e$export$fff0865807e996c5(options, Observer) {
    const queryClient = (0, $0126047dd734bc33$export$22e77b9572c4fded)({
        context: options.context
    });
    const isRestoring = (0, $d73410633d0f0f28$export$4da0178d6b5f553)();
    const errorResetBoundary = (0, $d8c18f57bc93d04e$export$50dfac555130cafd)();
    const defaultedOptions = queryClient.defaultQueryOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic"; // Include callbacks in batch renders
    if (defaultedOptions.onError) defaultedOptions.onError = (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batchCalls(defaultedOptions.onError);
    if (defaultedOptions.onSuccess) defaultedOptions.onSuccess = (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batchCalls(defaultedOptions.onSuccess);
    if (defaultedOptions.onSettled) defaultedOptions.onSettled = (0, $9c9aacadc80c6826$export$520687f44db6e1ab).batchCalls(defaultedOptions.onSettled);
    (0, $bf865f1d403d5a28$export$2c40a591ad2dafb1)(defaultedOptions);
    (0, $2cae4142f68cd6ce$export$ae8adb3de3d77633)(defaultedOptions, errorResetBoundary);
    (0, $2cae4142f68cd6ce$export$b2b17ca3a1fb0229)(errorResetBoundary);
    const [observer] = $acw62.useState(()=>new Observer(queryClient, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    (0, $cb54322a339eb896$export$306c0aa65ff9ec16)($acw62.useCallback((onStoreChange)=>{
        const unsubscribe = isRestoring ? ()=>undefined : observer.subscribe((0, $9c9aacadc80c6826$export$520687f44db6e1ab).batchCalls(onStoreChange)); // Update result to make sure we did not miss any query updates
        // between creating the observer and subscribing to it.
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        isRestoring
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $acw62.useEffect(()=>{
        // Do not notify on updates because of changes in the options because
        // these changes should already be reflected in the optimistic result.
        observer.setOptions(defaultedOptions, {
            listeners: false
        });
    }, [
        defaultedOptions,
        observer
    ]); // Handle suspense
    if ((0, $bf865f1d403d5a28$export$88d3586dfed64df9)(defaultedOptions, result, isRestoring)) throw (0, $bf865f1d403d5a28$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary);
     // Handle error boundary
    if ((0, $2cae4142f68cd6ce$export$1fbcf724762d607)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        useErrorBoundary: defaultedOptions.useErrorBoundary,
        query: observer.getCurrentQuery()
    })) throw result.error;
     // Handle result property usage tracking
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}


function $49e5d0d3c0767cab$export$f0c363610218880b(options) {
    return (0, $ede1b94721233a5e$export$fff0865807e996c5)({
        ...options,
        enabled: true,
        suspense: true,
        useErrorBoundary: true,
        networkMode: "always"
    }, (0, $b0ecc900a9d29037$export$85d960eb3ab339c8));
}



function $064d639e6ac3b119$export$5bf2755c0a009e74(options) {
    return (0, $ede1b94721233a5e$export$fff0865807e996c5)({
        ...options,
        enabled: true,
        useErrorBoundary: true,
        suspense: true,
        placeholderData: undefined,
        networkMode: "always",
        onSuccess: undefined,
        onError: undefined,
        onSettled: undefined
    }, (0, $d07b9a140ad50c23$export$a06cf8c0066f0d4c));
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $aeea79589311cc56$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $aeea79589311cc56$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
typeof SuppressedError === "function" && SuppressedError;



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $3tUi5 = parcelRequire("3tUi5");

var $ai2Pb = parcelRequire("ai2Pb");

var $acw62 = parcelRequire("acw62");
var $78c5ba78da2328d1$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $78c5ba78da2328d1$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === "function") {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $78c5ba78da2328d1$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === "function") return $78c5ba78da2328d1$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $78c5ba78da2328d1$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $78c5ba78da2328d1$export$700979bc83e7db82 = typeof window !== "undefined" && window.document && window.document.createElement ? $acw62.useLayoutEffect : $acw62.useEffect;


var $782bb25833d911d5$var$EMPTY_MODIFIERS = [];
var $782bb25833d911d5$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $acw62.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || "bottom",
        strategy: options.strategy || "absolute",
        modifiers: options.modifiers || $782bb25833d911d5$var$EMPTY_MODIFIERS
    };
    var _React$useState = $acw62.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: "0",
                top: "0"
            },
            arrow: {
                position: "absolute"
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $acw62.useMemo(function() {
        return {
            name: "updateState",
            enabled: true,
            phase: "write",
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $1u0KT.flushSync(function() {
                    setState({
                        styles: (0, $78c5ba78da2328d1$export$5150077fc2e7c662)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $78c5ba78da2328d1$export$5150077fc2e7c662)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                "computeStyles"
            ]
        };
    }, []);
    var popperOptions = $acw62.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: "applyStyles",
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $acw62.useRef();
    (0, $78c5ba78da2328d1$export$700979bc83e7db82)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $78c5ba78da2328d1$export$700979bc83e7db82)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $3tUi5.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};


const $0d74dc5469b28b13$export$2e2bcd8739ae039 = ({ items: items, placement: placement = "bottom-start", itemToString: itemToString = (item)=>item, offset: offset = [
    0,
    10
], resetSelectedItemOnClose: resetSelectedItemOnClose = false, popperModifiers: popperModifiers, strategy: strategy = "absolute", interactive: interactive = false, onMenuClickOutside: onMenuClickOutside, onChange: onChange, id: id })=>{
    const [referenceElement, setReferenceElement] = (0, $acw62.useState)(null);
    const [popperElement, setPopperElement] = (0, $acw62.useState)(null);
    const selectedItemRef = (0, $acw62.useRef)(-1);
    const [selectedItemIndex, setSelectedItemIndex] = (0, $acw62.useState)(-1);
    const [keydownFired, setKeydownFired] = (0, $acw62.useState)(false);
    const [forceClose, setForceClose] = (0, $acw62.useState)(false);
    const itemClicked = (0, $acw62.useRef)(false);
    const getPopperModifiers = ()=>{
        return popperModifiers && popperModifiers.length > 0 ? popperModifiers : [];
    };
    const modifiers = (0, $acw62.useMemo)(()=>[
            {
                name: "sameWidth",
                enabled: true,
                fn: ({ state: state })=>{
                    state.styles.popper.width = `${state.rects.reference.width}px`;
                },
                phase: "beforeWrite",
                requires: [
                    "computeStyles"
                ]
            },
            {
                name: "offset",
                options: {
                    offset: offset
                }
            },
            ...getPopperModifiers()
        ], []);
    const { styles: styles, attributes: attributes, update: update } = (0, $782bb25833d911d5$export$f4d5bf230a36dd6e)(referenceElement, popperElement, {
        placement: placement,
        strategy: strategy,
        modifiers: modifiers
    });
    const stateReducer = (state, actionAndChanges)=>{
        const { type: type, changes: changes } = actionAndChanges;
        switch(type){
            case (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.MenuKeyDownArrowDown:
                if (state.highlightedIndex === items.length - 1 && items[0]) {
                    // check if first item is a section header
                    const highlightedIndex = items[0].sectionHeader ? 1 : items[0].disabled ? 1 : 0;
                    return Object.assign(Object.assign({}, changes), {
                        isOpen: true,
                        highlightedIndex: highlightedIndex
                    });
                }
                return Object.assign(Object.assign({}, changes), {
                    isOpen: true
                });
            case (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.MenuKeyDownArrowUp:
                if (state.highlightedIndex === 0) return Object.assign(Object.assign({}, changes), {
                    isOpen: true,
                    highlightedIndex: items.length - 1
                });
                return Object.assign(Object.assign({}, changes), {
                    isOpen: true
                });
            case (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.MenuKeyDownEnter:
            case (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.MenuKeyDownSpaceButton:
                {
                    const activeElement = document.activeElement;
                    if (activeElement && (activeElement.tagName === "INPUT" || activeElement.tagName === "TEXTAREA")) {
                        // programatically enter the space in the input
                        if (type === (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.MenuKeyDownSpaceButton) {
                            // insert a space at the correct location
                            const activeElementAsInput = activeElement;
                            const value = activeElementAsInput.value;
                            const selectionStart = activeElementAsInput.selectionStart;
                            const selectionEnd = activeElementAsInput.selectionEnd;
                            if (selectionStart && selectionEnd) {
                                const newValue = `${value.substring(0, selectionStart)} ${value.substring(selectionEnd)}`;
                                activeElementAsInput.value = newValue;
                                activeElementAsInput.selectionStart = selectionStart + 1;
                                activeElementAsInput.selectionEnd = selectionStart + 1;
                            }
                            // if the whole value is selected then add replace the whole value with a space
                            if (selectionStart === 0 && selectionEnd === value.length) {
                                activeElementAsInput.value = " ";
                                activeElementAsInput.selectionStart = 1;
                                activeElementAsInput.selectionEnd = 1;
                            }
                        }
                        return state; // Prevent default behavior and allow space key to register in input
                    }
                    if (interactive && state.isOpen) {
                        setKeydownFired(true);
                        setSelectedItemIndex(state.highlightedIndex);
                        if (type === (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.MenuKeyDownEnter) {
                            if (items[state.highlightedIndex] && items[state.highlightedIndex].onClick) items[state.highlightedIndex].onClick(items[state.highlightedIndex]);
                        }
                        return Object.assign(Object.assign({}, changes), {
                            highlightedIndex: state.highlightedIndex,
                            isOpen: true
                        });
                    }
                    if (items[state.highlightedIndex] && items[state.highlightedIndex].menuItems) return Object.assign(Object.assign({}, changes), {
                        highlightedIndex: state.highlightedIndex,
                        isOpen: true
                    });
                    const indexId = `[data-item-index="${state.highlightedIndex}"]`;
                    // using popper element instead of reference in case popper is created through a portal
                    if (state.highlightedIndex === -1) return Object.assign({}, changes);
                    const itemElement = popperElement === null || popperElement === void 0 ? void 0 : popperElement.querySelector(indexId);
                    if (!itemElement) throw new Error(`[useDropdownMenu]: unable to retrieve itemElement with prop '${indexId}'`);
                    // this is to fix an issue with strict mode
                    // istanbul ignore next
                    if (selectedItemRef.current === state.highlightedIndex) {
                        selectedItemRef.current = -1;
                        return Object.assign({}, changes);
                    }
                    if (type === (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.MenuKeyDownEnter) {
                        if (items[state.highlightedIndex] && items[state.highlightedIndex].onClick) items[state.highlightedIndex].onClick(items[state.highlightedIndex]);
                    }
                    selectedItemRef.current = state.highlightedIndex;
                    // find the selected item element see if it has a a tag if so then click it by attribute data-item-index
                    if (itemElement) {
                        const aTag = itemElement.querySelector("a");
                        if (aTag) aTag.click();
                    }
                    if (resetSelectedItemOnClose) return Object.assign(Object.assign({}, changes), {
                        isOpen: false,
                        selectedItem: -1,
                        highlightedIndex: -1
                    });
                    return Object.assign({}, changes);
                }
            case (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.ItemClick:
                if (itemClicked.current) {
                    itemClicked.current = false;
                    if (interactive && state.isOpen) return Object.assign(Object.assign({}, changes), {
                        isOpen: true,
                        highlightedIndex: state.highlightedIndex
                    });
                    return Object.assign({}, changes);
                }
                if (interactive && state.isOpen) {
                    setSelectedItemIndex(state.highlightedIndex);
                    return Object.assign(Object.assign({}, changes), {
                        highlightedIndex: state.highlightedIndex,
                        isOpen: true
                    });
                }
                if (state.highlightedIndex === -1) return Object.assign({}, changes);
                selectedItemRef.current = state.highlightedIndex;
                return Object.assign({}, changes);
            case (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.MenuKeyDownEscape:
                return Object.assign(Object.assign({}, changes), {
                    isOpen: false
                });
            case (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.MenuBlur:
                // if the focused element is not a child of the menu then close the menu
                if (forceClose && state.isOpen) return Object.assign(Object.assign({}, changes), {
                    isOpen: false
                });
                if (interactive && state.isOpen) {
                    itemClicked.current = true;
                    setSelectedItemIndex(-1);
                    return Object.assign(Object.assign({}, changes), {
                        highlightedIndex: state.highlightedIndex,
                        isOpen: true,
                        selectedItem: null
                    });
                }
                setSelectedItemIndex(-1);
                return Object.assign(Object.assign({}, changes), {
                    selectedItem: null
                });
            case (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.MenuKeyDownCharacter:
            case (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.FunctionSetInputValue:
                // if the active element is a input or textarea then do nothing
                if (document.activeElement && [
                    "INPUT",
                    "TEXTAREA"
                ].includes(document.activeElement.tagName) && interactive) return {
                    isOpen: true
                };
                return Object.assign({}, changes);
            default:
                return changes; // otherwise business as usual.
        }
    };
    const { isOpen: isOpen, getToggleButtonProps: getToggleButtonProps, getMenuProps: getMenuProps, highlightedIndex: highlightedIndex, selectedItem: selectedItem, getItemProps: getItemProps, closeMenu: closeMenu, openMenu: openMenu } = (0, $6260541dc56be833$export$e64b2f635402ca43)({
        items: items,
        itemToString: itemToString,
        stateReducer: stateReducer,
        id: id !== null && id !== void 0 ? id : undefined,
        menuId: id ? `${id}-menu` : undefined,
        onSelectedItemChange: (changes)=>{
            onChange && onChange(Object.assign({}, changes.selectedItem));
        }
    });
    const isElementInMenu = (element)=>{
        if (element === popperElement) return true;
        if (element.parentElement) return isElementInMenu(element.parentElement);
        return false;
    };
    const isInReferenceElement = (element)=>{
        if (element === referenceElement) return true;
        if (element.parentElement) return isInReferenceElement(element.parentElement);
        return false;
    };
    const handleOpen = ()=>{
        openMenu();
    };
    const handleClickOutside = (event)=>{
        var _a, _b, _c, _d, _e, _f;
        if (interactive && !isElementInMenu(event.target) && isOpen && event.target !== referenceElement && !isInReferenceElement(event.target)) {
            if ((_b = (_a = event === null || event === void 0 ? void 0 : event.srcElement) === null || _a === void 0 ? void 0 : _a.id) === null || _b === void 0 ? void 0 : _b.includes("pendo-guide-container")) return;
            if ((_d = (_c = event === null || event === void 0 ? void 0 : event.srcElement) === null || _c === void 0 ? void 0 : _c.className) === null || _d === void 0 ? void 0 : _d.includes("react-datepicker")) return;
            onMenuClickOutside && onMenuClickOutside();
            setForceClose(true);
            closeMenu();
        } else {
            if ((_f = (_e = event === null || event === void 0 ? void 0 : event.srcElement) === null || _e === void 0 ? void 0 : _e.id) === null || _f === void 0 ? void 0 : _f.includes("pendo-guide-container")) return;
            setForceClose(false);
        }
    };
    (0, $acw62.useEffect)(()=>{
        document.addEventListener("click", handleClickOutside);
        document.addEventListener("focus", handleClickOutside, true);
        return ()=>{
            document.removeEventListener("click", handleClickOutside);
            document.removeEventListener("focus", handleClickOutside, true);
        };
    }, [
        interactive,
        isOpen,
        popperElement,
        forceClose,
        referenceElement
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!selectedItem) return;
        const indexOf = items.findIndex((item)=>item.id === selectedItem.id);
        if (selectedItemIndex === indexOf && interactive) setSelectedItemIndex(-1);
    }, [
        selectedItem,
        selectedItemIndex,
        interactive
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!selectedItem) return;
        const indexOf = items.findIndex((item)=>item.id === selectedItem.id);
        if (isOpen && keydownFired && indexOf == selectedItemIndex) {
            setKeydownFired(false);
            setSelectedItemIndex(1);
        }
    }, [
        isOpen,
        keydownFired,
        selectedItem,
        selectedItemIndex
    ]);
    return {
        isOpen: isOpen,
        getToggleButtonProps: getToggleButtonProps,
        getMenuProps: getMenuProps,
        highlightedIndex: highlightedIndex,
        selectedItem: selectedItem,
        getItemProps: (_a)=>{
            var { index: index } = _a, rest = (0, $aeea79589311cc56$export$3c9a16f847548506)(_a, [
                "index"
            ]);
            return Object.assign({
                "data-item-index": index
            }, getItemProps(Object.assign(Object.assign({}, rest), {
                index: index
            })));
        },
        setReferenceElement: setReferenceElement,
        setPopperElement: setPopperElement,
        attributes: attributes,
        styles: styles,
        update: update,
        closeMenu: closeMenu,
        openMenu: handleOpen
    };
};




var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");
const $adf6dff0470831cb$export$5c8a2f763c06db40 = (0, $lmFrL.default).div`
    position: relative;
    background-color: ${({ theme: theme })=>{
    var _a;
    return theme.dropdownMenu ? (_a = theme.dropdownMenu) === null || _a === void 0 ? void 0 : _a.backgroundColor : "#fff";
}};
    border-radius: 4px;
    overflow: hidden;
    z-index: 10;
    display: ${({ $isOpen: $isOpen })=>$isOpen ? "block" : "none"};

    // at a small display set the width to 100%
    @media (max-width: 600px) {
        width: calc(100vw - 3px) !important;
        max-width: calc(100vw - 32px);
    }
    ${({ $width: $width })=>$width && (0, $lmFrL.css)`
            width: ${$width}!important;
        `}
    ${({ $maxWidth: $maxWidth })=>$maxWidth && (0, $lmFrL.css)`
            max-width: ${$maxWidth};
        `}
    ${({ $height: $height })=>$height && (0, $lmFrL.css)`
            height: ${$height};
            overflow: auto;
        `}
    ${({ $maxHeight: $maxHeight })=>$maxHeight && (0, $lmFrL.css)`
            max-height: ${$maxHeight};
            overflow: auto;
        `}


    ${({ $isOpen: $isOpen, theme: theme, $condensedMenu: $condensedMenu })=>{
    var _a;
    return $isOpen && (0, $lmFrL.css)`
            box-shadow: ${({ theme: theme })=>{
        var _a;
        return theme.dropdownMenu ? (_a = theme.dropdownMenu) === null || _a === void 0 ? void 0 : _a.boxShadow : "0px 0px 1px rgba(0, 0, 0, 0.2), 0px 4px 8px rgba(0, 0, 0, 0.1)";
    }};
            padding: 8px;
            position: relative;
            z-index: 10;
            li:not(.divider) {
                box-sizing: border-box;
                border-radius: 6px;
                color: inherit;
                display: block;
                text-decoration: none;
                margin-bottom: 2px;
                font-size: ${$condensedMenu ? "12px" : "14px"};
                &:not(.disabled):not(.section-header):not(.divider):hover {
                    cursor: pointer;
                }
                .menu-item-content-wrapper {
                    padding: ${$condensedMenu ? "4px 8px" : "8px"};
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    // increase the padding on mobile to make the touch target bigger
                    @media (max-width: 600px) {
                        padding: 12px 16px;
                    }
                    .helix-dropdown-menu-item__label {
                        text-align: left;
                    }
                    .helix-dropdown-menu-item__active-icon {
                        display: flex;
                        align-items: center;
                        svg,
                        svg path {
                            fill: #2563eb;
                        }
                    }
                    .helix-icon.checkmark-outlined {
                        fill: #2563eb;
                        path {
                            fill: #2563eb;
                        }
                    }
                }
                a {
                    box-sizing: border-box;
                    border-radius: 6px;
                    color: inherit;
                    width: 100%;
                    display: block;
                    text-decoration: none;
                }
                &.highlighted {
                    background-color: ${theme.dropdownMenuItem ? (_a = theme.dropdownMenuItem) === null || _a === void 0 ? void 0 : _a.highlightColor : "#e5e7eb"};
                }
            }
        `;
}}
    &:focus-within {
        outline: none;
    }
    ul {
        padding: 0;
        margin: 0;
        list-style: none;
        &:focus-visible {
            outline: none;
        }
        li {
            &:not(.divider):not(.section-header):not(.disabled) {
                cursor: pointer !important;
            }
            &.disabled {
                .label,
                .description,
                svg,
                .helix-dropdown-menu-item__label {
                    opacity: 0.3;
                }
            }
            &.selected-item {
                outline-width: 0;
                background-color: ${({ theme: theme })=>{
    var _a;
    return theme.dropdownMenuItem ? (_a = theme.dropdownMenuItem) === null || _a === void 0 ? void 0 : _a.selectedColor : "#E5E7EB";
}};
            }
        }
        .divider {
            margin: ${({ $condensedMenu: $condensedMenu })=>$condensedMenu ? "6px 0" : "4px 0"};
        }
        .section-header {
            text-transform: uppercase;
            font-size: 12px;
            color: ${({ theme: theme })=>{
    var _a;
    return theme.dropdownMenu ? (_a = theme.dropdownMenu) === null || _a === void 0 ? void 0 : _a.sectionHeaderColor : "#4B5563";
}};
            letter-spacing: 0.1em;
            padding-top: 0;
        }
        .description {
            color: ${({ theme: theme })=>{
    var _a;
    return theme.dropdownMenuItem ? (_a = theme.dropdownMenuItem) === null || _a === void 0 ? void 0 : _a.descriptionFontColor : "4B5563";
}};
            font-size: 12px;
        }
        + ul {
            margin-left: 16px;
            @media screen and (max-width: ${({ theme: theme })=>{
    var _a;
    return theme.breakPoints ? (_a = theme.breakPoints) === null || _a === void 0 ? void 0 : _a.small : "576px";
}}) {
                margin-left: 0;
                margin-top: 16px;
            }
        }
    }
    .empty-state {
        padding: 16px;
        text-align: center;
    }
    &.helix-dropdown-badge-menu .menu-item-content-wrapper {
        display: grid !important;
        gap: 8px;
        grid-template-columns: 1fr 20px;
    }
`;
const $adf6dff0470831cb$export$c5fc081be042a37a = (0, $lmFrL.default).li`
    color: ${({ theme: theme })=>{
    var _a, _b;
    return (_b = (_a = theme.colors) === null || _a === void 0 ? void 0 : _a.gray) === null || _b === void 0 ? void 0 : _b[900];
}};
    list-style: none;
    ${({ $noWrap: $noWrap })=>$noWrap && (0, $lmFrL.css)`
            white-space: nowrap;
        `}
    label {
        pointer-events: none;
    }
    .menu-item-content-wrapper {
        > div {
            width: 100%;
            align-items: center;
            display: flex;
        }
    }
    ${({ $sectionHeader: $sectionHeader })=>$sectionHeader && (0, $lmFrL.css)`
            text-transform: uppercase;
            font-size: 12px !important;
            letter-spacing: 0.04em;
            padding-top: 0;
            font-weight: 600;
            &:hover {
                cursor: default !important;
            }
        `}

    ${({ $hasIcon: $hasIcon })=>{
    if ($hasIcon) return (0, $lmFrL.css)`
                .menu-item-content-wrapper {
                    justify-content: flex-start;
                    gap: 8px;
                    > div {
                        justify-content: flex-start;
                        gap: 8px;
                    }
                }
            `;
}}
    
    ${({ $divider: $divider })=>$divider && (0, $lmFrL.css)`
            padding: 0;
            margin: 0;
            overflow: hidden;
            border-top: 1px solid ${({ theme: theme })=>{
        var _a, _b;
        return (_b = (_a = theme.colors) === null || _a === void 0 ? void 0 : _a.gray) === null || _b === void 0 ? void 0 : _b[200];
    }};
            .menu-item-content-wrapper {
                display: none !important;
            }
        `}

    
    &.helix-btn {
        padding: 0;
        margin-top: 8px;
    }
`;


const $226f3b208fa61acf$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((_a, ref)=>{
    var { children: children, isOpen: isOpen, maxWidth: maxWidth, width: width, condensedMenu: condensedMenu, height: height } = _a, rest = (0, $aeea79589311cc56$export$3c9a16f847548506)(_a, [
        "children",
        "isOpen",
        "maxWidth",
        "width",
        "condensedMenu",
        "height"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $adf6dff0470831cb$export$5c8a2f763c06db40), Object.assign({
        ref: ref,
        "$isOpen": isOpen,
        "$maxWidth": maxWidth,
        "$width": width,
        "$height": height,
        "$maxHeight": height,
        "$condensedMenu": condensedMenu
    }, rest), children);
});
$226f3b208fa61acf$export$2e2bcd8739ae039.displayName = "DropdownMenu";






var $acw62 = parcelRequire("acw62");

const $1b2d250ae462e916$export$2e2bcd8739ae039 = (_a)=>{
    var { menuItem: menuItem, highlightedIndex: highlightedIndex, index: index, getItemProps: getItemProps, children: children, hasIcon: hasIcon = true, checked: checked = false, className: className, noWrap: noWrap } = _a, rest = (0, $aeea79589311cc56$export$3c9a16f847548506)(_a, [
        "menuItem",
        "highlightedIndex",
        "index",
        "getItemProps",
        "children",
        "hasIcon",
        "checked",
        "className",
        "noWrap"
    ]);
    if (!menuItem) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $adf6dff0470831cb$export$c5fc081be042a37a), Object.assign({
        "$sectionHeader": menuItem.sectionHeader,
        "$divider": menuItem.divider,
        "$hasIcon": hasIcon,
        "$noWrap": noWrap,
        className: `${index === highlightedIndex ? `highlighted ${className}` : className}
    ${menuItem.disabled ? " disabled" : ""}
${menuItem.divider ? " divider" : ""}
    `,
        "data-item-index": index
    }, rest, getItemProps({
        item: menuItem,
        disabled: menuItem.disabled || menuItem.divider || menuItem.sectionHeader,
        index: index,
        onClick: (event)=>{
            menuItem.onClick && menuItem.onClick(menuItem, event);
        }
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "menu-item-content-wrapper"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, children), checked && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
        icon: (0, $c761e69c8e58189a$exports.checkmark)
    })));
};
$1b2d250ae462e916$export$2e2bcd8739ae039.__DROPDOWN_MENU_ITEM__ = true; // 👈 special marker


const $c4eeb9c976cd472c$export$da284981347a9aea = (0, $acw62.forwardRef)(({ children: children, placement: placement = "bottom-start", interactive: interactive = false, onMenuClickOutside: onMenuClickOutside, width: width, menuOpen: menuOpen, offset: offset = [
    0,
    4
], className: className = "" }, ref)=>{
    const [dropdownItems, setDropdownMenuItems] = (0, $acw62.useState)([]);
    const [isMounted, setIsMounted] = (0, $acw62.useState)(false);
    const { isOpen: isOpen, getToggleButtonProps: getToggleButtonProps, getMenuProps: getMenuProps, highlightedIndex: highlightedIndex, getItemProps: getItemProps, setReferenceElement: setReferenceElement, setPopperElement: setPopperElement, attributes: attributes, styles: styles, closeMenu: closeMenu, openMenu: openMenu, update: update } = (0, $0d74dc5469b28b13$export$2e2bcd8739ae039)({
        placement: placement,
        offset: offset,
        items: dropdownItems,
        interactive: interactive,
        onMenuClickOutside: onMenuClickOutside,
        // istanbul ignore next
        itemToString: (item)=>item.label ? item.label : ""
    });
    const getDropdownMenuProps = ()=>{
        var _a;
        const menu = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray(children).find((child)=>{
            var _a, _b, _c;
            if (((_a = child === null || child === void 0 ? void 0 : child.type) === null || _a === void 0 ? void 0 : _a.displayName) === "DropdownMenu" || ((_c = (_b = child === null || child === void 0 ? void 0 : child.props) === null || _b === void 0 ? void 0 : _b.originalType) === null || _c === void 0 ? void 0 : _c.displayName) === "DropdownMenu") return child;
            return null;
        });
        return (_a = menu === null || menu === void 0 ? void 0 : menu.props) !== null && _a !== void 0 ? _a : {};
    };
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            api: {
                close: ()=>closeMenu(),
                open: ()=>openMenu(),
                setReferenceElement: (element)=>setReferenceElement(element),
                getToggleButtonProps: ()=>getToggleButtonProps(),
                update: ()=>update && isMounted && update()
            }
        }), [
        setReferenceElement,
        update,
        isMounted
    ]);
    const updateDropdownMenuItems = ()=>(0, $aeea79589311cc56$export$1050f835b63b671e)(void 0, void 0, void 0, function*() {
            const items = [];
            const search = (children)=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(children, (child)=>{
                    var _a, _b, _c, _d;
                    if (((_a = child === null || child === void 0 ? void 0 : child.type) === null || _a === void 0 ? void 0 : _a.displayName) === "DropdownMenuItem" || ((_c = (_b = child === null || child === void 0 ? void 0 : child.props) === null || _b === void 0 ? void 0 : _b.originalType) === null || _c === void 0 ? void 0 : _c.displayName) === "DropdownMenuItem" || ((_d = child === null || child === void 0 ? void 0 : child.type) === null || _d === void 0 ? void 0 : _d.__DROPDOWN_MENU_ITEM__)) {
                        const optionalProps = {};
                        if (child.props.divider) {
                            optionalProps["divider"] = true;
                            optionalProps["disabled"] = true;
                        }
                        if (child.props.sectionHeader) {
                            optionalProps["sectionHeader"] = true;
                            optionalProps["disabled"] = true;
                        }
                        if (child.props.hidden) return;
                        items.push(Object.assign({
                            id: child.props.id,
                            label: child.props.textLabel,
                            onClick: child.props.onClick ? child.props.onClick : null,
                            checked: child.props.checked,
                            disabled: child.props.disabled,
                            className: child.props.className
                        }, optionalProps));
                    } else if (child && child.props && child.props.children) search(child.props.children); // Recursively search nested children
                });
            };
            yield search(children);
            setDropdownMenuItems(items);
        });
    // Recursive function to render children, handling both items and non-items
    const renderChildren = (children)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(children, (child, index)=>{
            var _a, _b, _c, _d, _e;
            if (((_a = child === null || child === void 0 ? void 0 : child.type) === null || _a === void 0 ? void 0 : _a.displayName) === "DropdownMenuItem" || ((_c = (_b = child === null || child === void 0 ? void 0 : child.props) === null || _b === void 0 ? void 0 : _b.originalType) === null || _c === void 0 ? void 0 : _c.displayName) === "DropdownMenuItem" || ((_d = child === null || child === void 0 ? void 0 : child.type) === null || _d === void 0 ? void 0 : _d.__DROPDOWN_MENU_ITEM__)) {
                // Find the corresponding item from the dropdown items
                const dropdownItem = dropdownItems.find((item)=>item.id === child.props.id);
                const calulatedIndex = dropdownItems.indexOf(dropdownItem);
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1b2d250ae462e916$export$2e2bcd8739ae039), Object.assign({
                    highlightedIndex: highlightedIndex,
                    index: calulatedIndex,
                    menuItem: dropdownItem,
                    key: (dropdownItem === null || dropdownItem === void 0 ? void 0 : dropdownItem.id) || calulatedIndex,
                    getItemProps: getItemProps,
                    closeMenu: closeMenu,
                    checked: dropdownItem === null || dropdownItem === void 0 ? void 0 : dropdownItem.checked,
                    className: dropdownItem === null || dropdownItem === void 0 ? void 0 : dropdownItem.className
                }, child.props), child.props.children);
            } else if ((_e = child === null || child === void 0 ? void 0 : child.props) === null || _e === void 0 ? void 0 : _e.children) // If the child has nested children, render recursively
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(child, {
                children: renderChildren(child.props.children) // Recursively render nested children
            });
            else // Otherwise, render non-MenuItem elements directly (keeping their props)
            return child;
        });
    };
    (0, $acw62.useEffect)(()=>{
        setIsMounted(true);
    }, []);
    (0, $acw62.useEffect)(()=>{
        updateDropdownMenuItems();
        update && update();
    }, [
        children
    ]);
    (0, $acw62.useEffect)(()=>{
        if (menuOpen) setTimeout(()=>{
            openMenu();
        }, 0);
    }, [
        menuOpen,
        update
    ]);
    (0, $acw62.useEffect)(()=>{
        update && update();
    }, [
        isOpen,
        update
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({}, getToggleButtonProps())), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $226f3b208fa61acf$export$2e2bcd8739ae039), Object.assign({
        maxWidth: "300px",
        width: width ? width : "fit-content",
        ref: setPopperElement,
        isOpen: isOpen,
        style: styles.popper
    }, getDropdownMenuProps, {
        condensedMenu: getDropdownMenuProps().menuStyle === "condensed"
    }, attributes.popper, {
        className: className
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({}, getMenuProps({})), renderChildren(children))));
});
$c4eeb9c976cd472c$export$da284981347a9aea.displayName = "DropdownMenu";


var $acw62 = parcelRequire("acw62");
// eslint-disable-next-line no-empty-pattern
const $eee3ff3bb45e443d$export$2e2bcd8739ae039 = ({})=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
};
$eee3ff3bb45e443d$export$2e2bcd8739ae039.displayName = "DropdownMenuItem";




var $1d43c7fb5c1d248f$exports = {};

$1d43c7fb5c1d248f$exports = (parcelRequire("jGr7B"));




var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $3tUi5 = parcelRequire("3tUi5");

var $ai2Pb = parcelRequire("ai2Pb");

var $acw62 = parcelRequire("acw62");
var $d026fc203c805f30$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $d026fc203c805f30$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === "function") {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $d026fc203c805f30$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === "function") return $d026fc203c805f30$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $d026fc203c805f30$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $d026fc203c805f30$export$700979bc83e7db82 = typeof window !== "undefined" && window.document && window.document.createElement ? $acw62.useLayoutEffect : $acw62.useEffect;


var $e169569e40659ffd$var$EMPTY_MODIFIERS = [];
var $e169569e40659ffd$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $acw62.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || "bottom",
        strategy: options.strategy || "absolute",
        modifiers: options.modifiers || $e169569e40659ffd$var$EMPTY_MODIFIERS
    };
    var _React$useState = $acw62.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: "0",
                top: "0"
            },
            arrow: {
                position: "absolute"
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $acw62.useMemo(function() {
        return {
            name: "updateState",
            enabled: true,
            phase: "write",
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $1u0KT.flushSync(function() {
                    setState({
                        styles: (0, $d026fc203c805f30$export$5150077fc2e7c662)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $d026fc203c805f30$export$5150077fc2e7c662)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                "computeStyles"
            ]
        };
    }, []);
    var popperOptions = $acw62.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: "applyStyles",
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $acw62.useRef();
    (0, $d026fc203c805f30$export$700979bc83e7db82)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $d026fc203c805f30$export$700979bc83e7db82)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $3tUi5.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};



var $lmFrL = parcelRequire("lmFrL");
const $1db4338e1374f86e$export$fcac8f3adec6f9ce = (0, $lmFrL.default).div`
    // css arrow
    position: absolute;
    width: 0;
    height: 0;
    &:before {
        content: '';
        position: absolute;
        border-style: solid;
        border-width: 6px 6px 6px 0;
        border-color: transparent ${({ theme: theme })=>{
    var _a;
    return (_a = theme.tooltip) === null || _a === void 0 ? void 0 : _a.backgroundColor;
}} transparent transparent;
    }
`;
const $1db4338e1374f86e$export$353e9bd501be795b = (0, $lmFrL.default).div`
    background-color: ${({ theme: theme })=>{
    var _a;
    return (_a = theme.tooltip) === null || _a === void 0 ? void 0 : _a.backgroundColor;
}};
    color: ${({ theme: theme })=>{
    var _a;
    return (_a = theme.tooltip) === null || _a === void 0 ? void 0 : _a.textColor;
}};
    padding: 6px;
    border-radius: 4px;
    font-weight: 400;
    line-height: 16px;
    font-size: 12px;
    opacity: 1;
    transition: opacity 0.2s ease-in-out;
    z-index: 1070;
    ${({ $isOpening: $isOpening })=>$isOpening && (0, $lmFrL.css)`
            opacity: 1;
        `}

    // arrow positioning
  &[data-popper-placement^="top"] > {
        ${$1db4338e1374f86e$export$fcac8f3adec6f9ce} {
            bottom: 0px;
            &::before {
                border-width: 0 6px 6px 6px;
                left: -5px;
                border-color: transparent transparent ${({ theme: theme })=>{
    var _a;
    return (_a = theme.tooltip) === null || _a === void 0 ? void 0 : _a.backgroundColor;
}} transparent;
                rotate: 180deg;
            }
        }
    }
    &[data-popper-placement^='bottom'] > {
        ${$1db4338e1374f86e$export$fcac8f3adec6f9ce} {
            top: -6px;
            &::before {
                left: -5px;
                border-width: 0 6px 6px 6px;
                border-color: transparent transparent ${({ theme: theme })=>{
    var _a;
    return (_a = theme.tooltip) === null || _a === void 0 ? void 0 : _a.backgroundColor;
}} transparent;
            }
        }
    }
    &[data-popper-placement^='left'] > {
        ${$1db4338e1374f86e$export$fcac8f3adec6f9ce} {
            right: 0px;
            &::before {
                border-width: 6px 0 6px 6px;
                top: -5px;
                border-color: transparent transparent transparent ${({ theme: theme })=>{
    var _a;
    return (_a = theme.tooltip) === null || _a === void 0 ? void 0 : _a.backgroundColor;
}};
            }
        }
    }
    &[data-popper-placement^='right'] > {
        ${$1db4338e1374f86e$export$fcac8f3adec6f9ce} {
            left: -6px;
            &::before {
                border-width: 6px 6px 6px 0;
                top: -5px;
                border-color: transparent ${({ theme: theme })=>{
    var _a;
    return (_a = theme.tooltip) === null || _a === void 0 ? void 0 : _a.backgroundColor;
}} transparent transparent;
            }
        }
    }
    // arrow visibility
    [data-popper-reference-hidden='true'] > {
        ${$1db4338e1374f86e$export$fcac8f3adec6f9ce} {
            visibility: hidden;
        }
    }
`;


const $eebc07e282037d65$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((_a, ref)=>{
    var { placement: placement = "auto", children: children, target: target, autoHide: autoHide = true, popperModifiers: popperModifiers, theme: theme, popperOptions: popperOptions = {
        strategy: "absolute"
    }, usePortal: usePortal } = _a, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "placement",
        "children",
        "target",
        "autoHide",
        "popperModifiers",
        "theme",
        "popperOptions",
        "usePortal"
    ]);
    const [referenceElement, setReferenceElement] = (0, $acw62.useState)(null);
    const [popperElement, setPopperElement] = (0, $acw62.useState)(null);
    const [arrowElement, setArrowElement] = (0, $acw62.useState)(null);
    const [open, setOpen] = (0, $acw62.useState)(false);
    const [mounted, setMounted] = (0, $acw62.useState)(false);
    const [isOpening, setIsOpening] = (0, $acw62.useState)(false);
    const tooltipHovered = (0, $acw62.useRef)(false);
    const getPopperModifiers = ()=>{
        return popperModifiers && popperModifiers.length > 0 ? popperModifiers : [];
    };
    const { styles: styles, attributes: attributes } = (0, $e169569e40659ffd$export$f4d5bf230a36dd6e)(referenceElement, popperElement, Object.assign(Object.assign({
        placement: placement
    }, popperOptions), {
        modifiers: [
            {
                name: "offset",
                options: {
                    offset: [
                        0,
                        8
                    ]
                }
            },
            {
                name: "arrow",
                options: {
                    element: arrowElement
                }
            },
            ...getPopperModifiers()
        ]
    }));
    const handleMouseEnterPopover = ()=>{
        if (autoHide) return;
        tooltipHovered.current = true;
    };
    const handleMouseLeavePopover = ()=>{
        if (autoHide) return;
        setIsOpening(false);
        tooltipHovered.current = false;
        setTimeout(()=>{
            setOpen(false);
        }, 200);
    };
    const handleMouseEnter = ()=>{
        setOpen(true);
        setIsOpening(true);
    };
    const handleMouseLeave = ()=>{
        setTimeout(()=>{
            if (!tooltipHovered.current) {
                setIsOpening(false);
                setTimeout(()=>{
                    setOpen(false);
                }, 200);
            }
        }, 100);
    };
    const handleKeyDown = (e)=>{
        if (e.key === "Escape") setOpen(false);
    };
    (0, $acw62.useEffect)(()=>{
        if (!target || typeof target !== "object" && typeof target !== "string") return;
        const targetAsMutableRef = target;
        const targetElement = typeof target === "object" ? targetAsMutableRef.current ? target === null || target === void 0 ? void 0 : target.current : target : document.getElementById(target);
        if (!targetElement) return;
        setReferenceElement(targetElement);
        if (!mounted) return;
        targetElement.addEventListener("mouseenter", handleMouseEnter);
        targetElement.addEventListener("mouseleave", handleMouseLeave);
        targetElement.addEventListener("focus", handleMouseEnter);
        targetElement.addEventListener("blur", handleMouseLeave);
        targetElement.addEventListener("keydown", handleKeyDown);
        return ()=>{
            targetElement.removeEventListener("mouseenter", handleMouseEnter);
            targetElement.removeEventListener("mouseleave", handleMouseLeave);
            targetElement.removeEventListener("focus", handleMouseEnter);
            targetElement.removeEventListener("blur", handleMouseLeave);
            targetElement.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        target,
        mounted
    ]);
    (0, $acw62.useEffect)(()=>{
        setMounted(true);
        return ()=>{
            setMounted(false);
        };
    }, []);
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            api: {
                open: ()=>{
                    setOpen(true);
                },
                close: ()=>{
                    setOpen(false);
                },
                toggle: ()=>{
                    setOpen(!open);
                }
            }
        }));
    const tooltipElement = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1db4338e1374f86e$export$353e9bd501be795b), Object.assign({
        ref: setPopperElement,
        style: styles.popper,
        "$isOpening": isOpening,
        onMouseEnter: ()=>handleMouseEnterPopover(),
        onMouseLeave: ()=>handleMouseLeavePopover(),
        theme: theme,
        role: "tooltip"
    }, attributes.popper, rest), children, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1db4338e1374f86e$export$fcac8f3adec6f9ce), {
        ref: setArrowElement,
        style: styles.arrow
    }));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, isOpening && (usePortal ? (0, $1u0KT.createPortal)(tooltipElement, document.body) : tooltipElement));
});
$eebc07e282037d65$export$2e2bcd8739ae039.displayName = "Tooltip";




var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $3tUi5 = parcelRequire("3tUi5");

var $ai2Pb = parcelRequire("ai2Pb");

var $acw62 = parcelRequire("acw62");
var $f86dedfa1e832185$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $f86dedfa1e832185$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === "function") {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $f86dedfa1e832185$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === "function") return $f86dedfa1e832185$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $f86dedfa1e832185$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $f86dedfa1e832185$export$700979bc83e7db82 = typeof window !== "undefined" && window.document && window.document.createElement ? $acw62.useLayoutEffect : $acw62.useEffect;


var $2cea0c1ecf37b588$var$EMPTY_MODIFIERS = [];
var $2cea0c1ecf37b588$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $acw62.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || "bottom",
        strategy: options.strategy || "absolute",
        modifiers: options.modifiers || $2cea0c1ecf37b588$var$EMPTY_MODIFIERS
    };
    var _React$useState = $acw62.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: "0",
                top: "0"
            },
            arrow: {
                position: "absolute"
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $acw62.useMemo(function() {
        return {
            name: "updateState",
            enabled: true,
            phase: "write",
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $1u0KT.flushSync(function() {
                    setState({
                        styles: (0, $f86dedfa1e832185$export$5150077fc2e7c662)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $f86dedfa1e832185$export$5150077fc2e7c662)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                "computeStyles"
            ]
        };
    }, []);
    var popperOptions = $acw62.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: "applyStyles",
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $acw62.useRef();
    (0, $f86dedfa1e832185$export$700979bc83e7db82)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $f86dedfa1e832185$export$700979bc83e7db82)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $3tUi5.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};



var $lmFrL = parcelRequire("lmFrL");
const $5bb7fcc51b32c32f$var$setSize = (size)=>{
    switch(size){
        case "sm":
            return (0, $lmFrL.css)`
                width: 100px;
            `;
        case "md":
            return (0, $lmFrL.css)`
                width: 200px;
            `;
        case "lg":
            return (0, $lmFrL.css)`
                width: 275px;
            `;
        case "xl":
            return (0, $lmFrL.css)`
                width: 348px;
            `;
        case "auto":
        default:
            return (0, $lmFrL.css)`
                width: ${size ? size : "auto"};
                ${size ? `max-width: ${size}` : ""}
            `;
    }
};
const $5bb7fcc51b32c32f$export$5cc9a0f6611ab993 = (0, $lmFrL.default).div`
    background-color: white;
    box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.2), 0px 4px 8px rgba(0, 0, 0, 0.1);
    padding: 16px;
    border-radius: 6px;
    ${({ $popperSize: $popperSize })=>$5bb7fcc51b32c32f$var$setSize($popperSize || "auto")}
    max-width: 350px;
    opacity: 1;
    display: ${({ $isOpen: $isOpen })=>$isOpen ? "block" : "none"};
    transition: opacity 0.2s ease-in-out;
    ${({ $isOpening: $isOpening })=>$isOpening && (0, $lmFrL.css)`
            opacity: 1;
        `}

    &[data-popper-reference-hidden="true"] {
        visibility: hidden;
        pointer-events: none;
    }
    z-index: 3;
`;
const $5bb7fcc51b32c32f$export$b78ed1090e7ed98b = (0, $lmFrL.default).div`
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 8px;
`;


const $64b135e6156ff8db$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((_a, ref)=>{
    var { placement: placement = "auto", children: children, target: target, title: title, popperModifiers: popperModifiers, popperOptions: popperOptions = {
        strategy: "absolute"
    }, usePortal: usePortal, trigger: trigger = "focus", interactive: interactive, dataLwtId: dataLwtId, className: className, size: size = "auto", style: style, stayOpen: stayOpen = false } = _a, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "placement",
        "children",
        "target",
        "title",
        "popperModifiers",
        "popperOptions",
        "usePortal",
        "trigger",
        "interactive",
        "dataLwtId",
        "className",
        "size",
        "style",
        "stayOpen"
    ]);
    const [referenceElement, setReferenceElement] = (0, $acw62.useState)(null);
    const [popperElement, setPopperElement] = (0, $acw62.useState)(null);
    const [open, setOpen] = (0, $acw62.useState)(false);
    const [isOpening, setIsOpening] = (0, $acw62.useState)(false);
    const popoverInner = (0, $acw62.useRef)(null);
    const popoverClicked = (0, $acw62.useRef)(false);
    const getPopperModifiers = ()=>{
        return popperModifiers && popperModifiers.length > 0 ? popperModifiers : [];
    };
    const { styles: styles, attributes: attributes, update: update } = (0, $2cea0c1ecf37b588$export$f4d5bf230a36dd6e)(referenceElement, popperElement, Object.assign(Object.assign({
        placement: placement
    }, popperOptions), {
        modifiers: [
            {
                name: "offset",
                options: {
                    offset: [
                        0,
                        8
                    ]
                }
            },
            ...getPopperModifiers()
        ]
    }));
    const openPopover = ()=>{
        setOpen(true);
        setIsOpening(true);
    };
    const closePopover = ()=>{
        setIsOpening(false);
        setTimeout(()=>{
            setOpen(false);
        }, 200);
    };
    const handleMouseEnter = ()=>{
        openPopover();
    };
    const handleMouseLeave = ()=>{
        closePopover();
    };
    const togglePopover = ()=>{
        if (open) closePopover();
        else openPopover();
    };
    const handleClick = ()=>{
        togglePopover();
    };
    const handleOutsideClick = (e)=>{
        const targetNode = e.target;
        // get the classList of the target node
        const classList = targetNode.classList;
        // check if any of the classes start with 'react-datepicker'
        const isDatePicker = Array.from(classList).some((className)=>className.startsWith("react-datepicker"));
        // if the target is a date picker return
        if (isDatePicker && interactive) return;
        if (popoverInner.current && popoverInner.current.parentNode === e.target) return;
        if (referenceElement && popoverInner.current && !referenceElement.contains(e.target) && !popoverInner.current.contains(e.target) && !popoverInner.current.contains(document.activeElement)) closePopover();
    };
    const handleBlur = (e)=>{
        if (popoverClicked.current || interactive) return;
        // if the that was focused is the reference element,
        // or the popover itself, or is a child of the popover, do nothing
        if (referenceElement && popoverInner.current && (referenceElement.contains(e.relatedTarget) || popoverInner.current.contains(e.relatedTarget))) return;
        closePopover();
    };
    const handlePopoverClick = (e)=>{
        popoverClicked.current = true;
    };
    const handleSafariClick = ()=>{
        // if the browser is safari and the button is clicked focus the button
        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
        if (isSafari) {
            // if the reference element already has focus return
            if (referenceElement === document.activeElement || open) return;
            referenceElement === null || referenceElement === void 0 || referenceElement.focus();
        }
    };
    (0, $acw62.useEffect)(()=>{
        var _a;
        if (target) {
            const targetElement = typeof target === "string" ? document.getElementById(target) : target.current;
            setReferenceElement(targetElement);
            if (targetElement) {
                if (trigger === "hover") {
                    // add mouse enter and mouse leave event listeners
                    targetElement.addEventListener("mouseenter", handleMouseEnter);
                    targetElement.addEventListener("mouseleave", handleMouseLeave);
                    return ()=>{
                        targetElement.removeEventListener("mouseenter", handleMouseEnter);
                        targetElement.removeEventListener("mouseleave", handleMouseLeave);
                    };
                }
                if (trigger === "click") {
                    targetElement.addEventListener("click", handleClick);
                    document.addEventListener("click", handleOutsideClick);
                    return ()=>{
                        targetElement.removeEventListener("click", handleClick);
                        document.removeEventListener("click", handleOutsideClick);
                    };
                }
                if (trigger === "focus") {
                    targetElement.addEventListener("focus", handleClick);
                    targetElement.addEventListener("blur", handleBlur);
                    referenceElement === null || referenceElement === void 0 || referenceElement.addEventListener("click", handleSafariClick);
                    (_a = popoverInner.current) === null || _a === void 0 || _a.addEventListener("click", handlePopoverClick);
                    document.addEventListener("click", handleOutsideClick);
                    return ()=>{
                        var _a;
                        targetElement.removeEventListener("focus", handleClick);
                        targetElement.removeEventListener("blur", handleBlur);
                        (_a = popoverInner.current) === null || _a === void 0 || _a.removeEventListener("click", handlePopoverClick);
                        referenceElement === null || referenceElement === void 0 || referenceElement.removeEventListener("click", handleSafariClick);
                        document.removeEventListener("click", handleOutsideClick);
                    };
                }
            }
        }
    }, [
        target,
        open,
        trigger,
        referenceElement
    ]);
    (0, $acw62.useEffect)(()=>{
        if (update) update();
    }, [
        update,
        open
    ]);
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            api: {
                open: ()=>{
                    openPopover();
                },
                close: ()=>{
                    closePopover();
                },
                toggle: ()=>{
                    togglePopover();
                }
            }
        }));
    const optionalProps = {};
    if (dataLwtId) optionalProps["data-lwt-id"] = dataLwtId;
    const clonedChildren = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(children, (child)=>{
        // if the child is a string or number return it
        if (typeof child === "string" || typeof child === "number") return child;
        if (child && child.type && child.type.displayName === "DatePicker" || child && child.__docgenInfo && child.__docgenInfo.type.displayName === "DatePicker") return child;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(child)) return (0, $acw62.cloneElement)(child, {
            open: open
        });
        return child;
    });
    const popoverElement = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5bb7fcc51b32c32f$export$5cc9a0f6611ab993), Object.assign({
        className: `helix-popover ${className ? className : ""}`,
        ref: setPopperElement,
        style: Object.assign(Object.assign({}, style), styles.popper),
        "$isOpening": isOpening || stayOpen,
        "$isOpen": open || stayOpen,
        "$popperSize": size
    }, optionalProps, rest, attributes.popper), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: popoverInner
    }, title && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $5bb7fcc51b32c32f$export$b78ed1090e7ed98b), null, title), clonedChildren));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, usePortal ? (0, $1u0KT.createPortal)(popoverElement, document.body) : popoverElement);
});
$64b135e6156ff8db$export$2e2bcd8739ae039.displayName = "Popover";






var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");
const $1b0211606bd6b0bd$export$8863cf9d79cd26ad = (0, $lmFrL.default).div`
    display: flex;
    justify-content: center;
    overflow: auto;
    position: fixed;
    z-index: 1051;
    inset: 0;

    ${({ modalLargerThanOverlay: modalLargerThanOverlay })=>!modalLargerThanOverlay && (0, $lmFrL.css)`
            align-items: center;
        `}
    padding: 34px 16px;

    .helix-modal__gradient {
        position: absolute;
        left: 0;
        right: 16px; // Prevents overlap with scrollbar
        bottom: 0;
        height: 84px;
        pointer-events: none;
        background: linear-gradient(to top, rgba(255, 255, 255, 1) 5%, rgba(255, 255, 255, 0) 100%);
        z-index: 2;
    }
`;
const $1b0211606bd6b0bd$export$47f426cc93e497b4 = (0, $lmFrL.default).div`
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.2);

    @keyframes overlayAnimateIn {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }

    @keyframes overlayAnimateOut {
        from {
            opacity: 1;
        }
        to {
            opacity: 0;
        }
    }

    &.animate-in,
    &.animate-out {
        animation-duration: 0.45s;
        animation-fill-mode: forwards;
    }

    &.animate-in {
        animation-name: overlayAnimateIn;
    }

    &.animate-out {
        animation-name: overlayAnimateOut;
    }
`;
const $1b0211606bd6b0bd$export$81645ce662b26656 = (0, $lmFrL.default).div`
    background: ${({ theme: theme })=>{
    var _a;
    return (_a = theme.modal) === null || _a === void 0 ? void 0 : _a.backgroundColor;
}};
    border-radius: 8px;
    box-shadow: ${({ theme: theme })=>{
    var _a;
    return (_a = theme.modal) === null || _a === void 0 ? void 0 : _a.boxShadow;
}};
    display: flex;
    flex-flow: column;
    max-width: 500px;
    height: fit-content;
    position: relative;
    z-index: 1;
    max-height: 100%;
    ${({ size: size })=>size === "lg" && (0, $lmFrL.css)`
            width: 800px;
            max-width: 100%;
        `}

    // on small screen sizes set the max width to 100% to make sure the modal is always full width
    @media (max-width: ${({ theme: theme })=>{
    var _a;
    return (_a = theme.breakPoints) === null || _a === void 0 ? void 0 : _a.small;
}}) {
        max-width: 100%;
        width: 100%;
    }

    @keyframes modalContentAnimateIn {
        from {
            opacity: 0;
            margin-top: -100px;
        }
        to {
            opacity: 1;
            margin-top: 0px;
        }
    }

    @keyframes modalContentAnimateOut {
        from {
            opacity: 1;
            margin-top: 0px;
        }
        to {
            opacity: 0;
            margin-top: -100px;
        }
    }

    &.animate-in,
    &.animate-out {
        animation-duration: 0.45s;
        animation-fill-mode: forwards;
    }

    &.animate-in {
        animation-name: modalContentAnimateIn;
    }

    &.animate-out {
        animation-name: modalContentAnimateOut;
    }
`;
const $1b0211606bd6b0bd$export$d16d4758aede78d8 = (0, $lmFrL.default).div`
    display: flex;
    flex: 1;
    padding: 32px 34px 16px 34px;
    flex-grow: 0;
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        margin: 0;
    }

    .helix-modal__header-content {
        flex: 1 1;
    }
`;
const $1b0211606bd6b0bd$export$1333621ab58907ab = (0, $lmFrL.default).div`
    flex: 1;
    padding: 16px 34px 24px 34px;
    overflow: auto;
`;
const $1b0211606bd6b0bd$export$466f612e40ab59db = (0, $lmFrL.default).div`
    flex: 1;
    padding: 24px 34px;
    display: flex;
    flex-grow: 0;
    .helix-modal__footer-buttons {
        display: flex;
        flex: 1;
        justify-content: flex-end;
        button + button {
            margin-left: 12px;
        }
    }
`;


const $fa2b6a3504678b01$var$ModalContext = (0, $acw62.createContext)({
    hideCloseButton: false,
    autoFocusCloseButton: true,
    onClose: ()=>{
    /* noop */ }
});
function $fa2b6a3504678b01$export$2b77a92f1a5ad772(_a) {
    var { show: show, size: size = "default", dataLwtId: dataLwtId, hideCloseButton: hideCloseButton = false, autoFocusCloseButton: autoFocusCloseButton = true, onCloseAnimationComplete: onCloseAnimationComplete, onClose: onClose, children: children, className: className } = _a, props = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "show",
        "size",
        "dataLwtId",
        "hideCloseButton",
        "autoFocusCloseButton",
        "onCloseAnimationComplete",
        "onClose",
        "children",
        "className"
    ]);
    const contentRef = (0, $acw62.useRef)(null);
    const overlayRef = (0, $acw62.useRef)(null);
    const [visible, setVisible] = (0, $acw62.useState)(show !== null && show !== void 0 ? show : false);
    const [modalLargerThanOverlay, setModalLargerThanOverlay] = (0, $acw62.useState)(false);
    const onCloseRef = (0, $acw62.useRef)(onClose);
    (0, $acw62.useEffect)(()=>{
        onCloseRef.current = onClose;
    }, [
        onClose
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!show && !visible) return;
        const handleKeydown = (e)=>{
            var _a;
            if (e.key === "Escape") (_a = onCloseRef.current) === null || _a === void 0 || _a.call(onCloseRef);
            if (e.key === "Tab" && contentRef.current) {
                const focusableElements = contentRef.current.querySelectorAll("button, [href], input, select, textarea, [tabindex]:not([tabindex='-1'])");
                const firstElement = focusableElements[0];
                const lastElement = focusableElements[focusableElements.length - 1];
                if (e.shiftKey) // Reverse tabbing
                {
                    if (document.activeElement === firstElement) {
                        lastElement.focus();
                        e.preventDefault();
                    }
                } else // Forward tabbing
                if (document.activeElement === lastElement) {
                    firstElement.focus();
                    e.preventDefault();
                }
            }
        };
        document.body.addEventListener("keydown", handleKeydown);
        return ()=>{
            document.body.removeEventListener("keydown", handleKeydown);
        };
    }, [
        show,
        visible
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!show && !visible) return;
        const handleResize = ()=>{
            if (contentRef.current && overlayRef.current) {
                const modalHeight = contentRef.current.clientHeight;
                const overlayHeight = overlayRef.current.clientHeight;
                setModalLargerThanOverlay(modalHeight > overlayHeight);
            }
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, [
        show,
        visible
    ]);
    (0, $acw62.useEffect)(()=>{
        if (show) setVisible(true);
    }, [
        show
    ]);
    if (!visible && !show) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($fa2b6a3504678b01$var$ModalContext.Provider, {
        value: {
            onClose: onClose,
            hideCloseButton: hideCloseButton,
            autoFocusCloseButton: autoFocusCloseButton
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1b0211606bd6b0bd$export$8863cf9d79cd26ad), {
        modalLargerThanOverlay: modalLargerThanOverlay
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1b0211606bd6b0bd$export$47f426cc93e497b4), {
        ref: overlayRef,
        className: `helix-modal-overlay ${show ? "animate-in" : "animate-out"}`,
        onAnimationEnd: ()=>{
            if (!show) {
                setVisible(false);
                onCloseAnimationComplete === null || onCloseAnimationComplete === void 0 || onCloseAnimationComplete();
            }
        }
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1b0211606bd6b0bd$export$81645ce662b26656), Object.assign({
        size: size,
        ref: contentRef,
        role: "dialog",
        "aria-modal": "true",
        "data-lwt-id": dataLwtId,
        className: `helix-modal helix-modal-content ${show ? "animate-in" : "animate-out"} ${className ? className : ""}`
    }, props), children)));
}
function $fa2b6a3504678b01$export$f50a68e3694789ee(_a) {
    var { children: children } = _a, props = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "children"
    ]);
    const closeButtonRef = (0, $acw62.useRef)(null);
    const { onClose: onClose, autoFocusCloseButton: autoFocusCloseButton, hideCloseButton: hideCloseButton } = (0, $acw62.useContext)($fa2b6a3504678b01$var$ModalContext);
    (0, $acw62.useEffect)(()=>{
        var _a;
        if (autoFocusCloseButton && !hideCloseButton) (_a = closeButtonRef.current) === null || _a === void 0 || _a.focus();
    }, [
        autoFocusCloseButton,
        hideCloseButton
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1b0211606bd6b0bd$export$d16d4758aede78d8), Object.assign({}, props), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "helix-modal__header-content"
    }, children), !hideCloseButton && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: "helix-btn helix-btn--ghost helix-btn--small helix-btn--icon-btn",
        "aria-label": "Close",
        onClick: onClose,
        ref: closeButtonRef,
        type: "button",
        "data-helix-close": "true"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
        icon: (0, $c761e69c8e58189a$exports.x)
    })));
}
function $fa2b6a3504678b01$export$cb540d8b0ef7906c(_a) {
    var { children: children } = _a, props = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "children"
    ]);
    const bodyRef = (0, $acw62.useRef)(null);
    const [bodyHasScrollbar, setBodyHasScrollbar] = (0, $acw62.useState)(false);
    const [atBottom, setAtBottom] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        const checkForScrollbar = ()=>{
            if (bodyRef.current) setBodyHasScrollbar(bodyRef.current.scrollHeight > bodyRef.current.clientHeight);
        };
        checkForScrollbar();
        window.addEventListener("resize", checkForScrollbar);
        return ()=>{
            window.removeEventListener("resize", checkForScrollbar);
        };
    }, [
        children
    ]);
    (0, $acw62.useEffect)(()=>{
        const handleScroll = ()=>{
            if (bodyRef.current) {
                const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = bodyRef.current;
                setAtBottom(scrollTop + clientHeight >= scrollHeight - 1);
            }
        };
        const body = bodyRef.current;
        if (body) {
            body.addEventListener("scroll", handleScroll);
            // Initial check
            handleScroll();
        }
        return ()=>{
            if (body) body.removeEventListener("scroll", handleScroll);
        };
    }, [
        bodyHasScrollbar,
        children
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            position: "relative",
            overflow: "hidden",
            display: "flex"
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1b0211606bd6b0bd$export$1333621ab58907ab), Object.assign({}, props, {
        ref: bodyRef
    }), children), bodyHasScrollbar && !atBottom && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "helix-modal__gradient"
    }));
}
function $fa2b6a3504678b01$export$519437715052e656(_a) {
    var { children: children } = _a, props = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "children"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $1b0211606bd6b0bd$export$466f612e40ab59db), Object.assign({}, props), children);
}



var $1u0KT = parcelRequire("1u0KT");

class $ffb8fedbdc425da8$export$f2e832acab1bdd79 extends Error {
    code;
    message;
    details;
    constructor(t, a, n){
        super(a), this.code = t, this.message = a, this.details = n, this.name = "ApiError";
    }
}
async function $ffb8fedbdc425da8$var$I({ accessToken: e, serviceUrl: t, pathname: a, method: n = "GET", params: l, headers: r = new Headers() }) {
    const s = $ffb8fedbdc425da8$var$ve("notifications", t), o = new URL(a.toString().replace(/^\/+/, ""), s);
    let c;
    if (l) {
        if (!n || n === "GET") for (const [u, p] of Object.entries(l))p != null && (Array.isArray(p) && typeof p[0] == "object" ? p.forEach((C)=>{
            for (const [G, j] of Object.entries(C))j != null && o.searchParams.append(`${u}[][${G}]`, String(j));
        }) : Array.isArray(p) ? p.forEach((C)=>{
            C != null && o.searchParams.append(`${u}[]`, String(C));
        }) : o.searchParams.append(u, String(p)));
        else c = JSON.stringify(l);
    }
    r.set("Accept", "application/json"), r.set("Content-Type", "application/json"), e && r.set("Authorization", `Bearer ${e}`);
    const h = await fetch(o, {
        method: n,
        headers: r,
        body: c
    }), m = await h.json();
    if (!h.ok) throw m.code && m.message ? new $ffb8fedbdc425da8$export$f2e832acab1bdd79(m.code, m.message, m.details?.[0]) : new $ffb8fedbdc425da8$export$f2e832acab1bdd79(500, m.message || "Internal Server Error");
    return {
        res: h,
        json: m
    };
}
async function $ffb8fedbdc425da8$export$12cd1ccdbaac8618(e) {
    return (await $ffb8fedbdc425da8$var$I({
        ...e,
        pathname: `/api/v1${e.pathname}`
    })).json;
}
async function $ffb8fedbdc425da8$var$be(e) {
    const t = await $ffb8fedbdc425da8$var$I({
        ...e,
        pathname: `/api/v1${e.pathname}`
    });
    return {
        data: t.json,
        meta: $ffb8fedbdc425da8$var$Ne(t.res.headers)
    };
}
function $ffb8fedbdc425da8$var$Ne(e) {
    const t = e.get("x-next-page"), a = t == null || t === "" ? null : Number.isNaN(Number(t)) ? t : Number.isInteger(Number(t)) ? Number(t) : null;
    return {
        totalCount: e.get("x-total-count") ? Number(e.get("x-total-count")) : null,
        totalPages: e.get("x-total-pages") ? Number(e.get("x-total-pages")) : null,
        currentPage: e.get("x-current-page") ? Number(e.get("x-current-page")) : null,
        currentCount: e.get("x-current-count") ? Number(e.get("x-current-count")) : null,
        pageSize: e.get("x-page-size") ? Number(e.get("x-page-size")) : null,
        nextPage: a,
        prevPage: e.get("x-prev-page") ? Number(e.get("x-prev-page")) : null
    };
}
function $ffb8fedbdc425da8$var$ve(e, t = window.location.href) {
    const a = e.endsWith(".api") ? e : `${e}.api`;
    let n;
    try {
        n = new URL(t);
    } catch  {
        return `https://${a}.lwolf.com`;
    }
    const l = n.hostname, r = n.port, s = l.split(".");
    let o = "";
    s.includes("dev") ? o = "dev" : s.includes("stg") || s.includes("staging") ? o = "stg" : s.includes("pre") && (o = "pre");
    let c = "";
    return s.includes("localhost") ? c = "localhost" : s.includes("local") && (c = "local"), c === "localhost" ? `http://${l}${r ? `:${r}` : ""}` : `https://${[
        a,
        c,
        o,
        "lwolf",
        "com"
    ].filter(Boolean).join(".")}${c === "local" && r ? `:${r}` : ""}`;
}
class $ffb8fedbdc425da8$var$w extends (0, $acw62.Component) {
    constructor(t){
        super(t), this.state = {
            hasError: !1,
            error: null
        };
    }
    static getDerivedStateFromError(t) {
        return {
            hasError: !0,
            error: t
        };
    }
    render() {
        return this.state.hasError ? this.props.fallback instanceof Function ? /* @__PURE__ */ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: this.props.fallback({
                error: this.state.error || new Error("Unknown Error")
            })
        }) : /* @__PURE__ */ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: this.props.fallback || /* @__PURE__ */ (0, $ayMG0.jsx)("div", {
                role: "alert",
                className: "helix-body helix-text-red-500",
                children: this.state.error?.message || "Unknown Error"
            })
        }) : this.props.children;
    }
}
function $ffb8fedbdc425da8$var$U({ fullScreen: e, backdrop: t }) {
    return /* @__PURE__ */ (0, $ayMG0.jsxs)("div", {
        "data-testid": "loader",
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("helix-loader", {
            "helix-loader--fixed": e
        }),
        children: [
            t && /* @__PURE__ */ (0, $ayMG0.jsx)("div", {
                "data-testid": "loader-backdrop",
                className: "helix-loader__backdrop"
            }),
            /* @__PURE__ */ (0, $ayMG0.jsx)("div", {
                "data-testid": "loader-inner",
                className: "helix-loader__inner"
            })
        ]
    });
}
const $ffb8fedbdc425da8$var$_e = "_container_1ie47_1", $ffb8fedbdc425da8$var$we = {
    container: $ffb8fedbdc425da8$var$_e
}, $ffb8fedbdc425da8$var$L = (0, $acw62.createContext)({
    accessToken: "",
    serviceUrl: "https://notifications.api.lwolf.com"
});
function $ffb8fedbdc425da8$export$53d5ca6c3f53e109({ pageSize: e = 20, accessToken: t, serviceUrl: a, refetchInterval: n, showUnreadOnly: l = !1 }) {
    return (0, $49e5d0d3c0767cab$export$f0c363610218880b)({
        getNextPageParam: (r)=>{
            if (typeof r.meta.nextPage == "number") return r.meta.nextPage - 1;
            if (typeof r.meta.nextPage == "string") return r.meta.nextPage;
        },
        queryKey: [
            "notifications",
            l,
            n,
            e,
            t,
            a
        ],
        refetchInterval: n,
        queryFn: ({ pageParam: r })=>$ffb8fedbdc425da8$var$be({
                accessToken: t,
                serviceUrl: a,
                pathname: "/notifications",
                params: {
                    unread: l,
                    $top: e,
                    $skip: typeof r == "string" ? r : e * (r || 0)
                }
            })
    });
}
function $ffb8fedbdc425da8$var$y() {
    const e = (0, $acw62.useContext)($ffb8fedbdc425da8$var$L);
    if (!e) throw new Error("useNotificationsProvider must be used within a NotificationsProvider");
    return e;
}
function $ffb8fedbdc425da8$export$1a743cba80e0934() {
    const e = (0, $0126047dd734bc33$export$22e77b9572c4fded)();
    return (0, $cb7b7c348969488c$export$609860bf8b0084c)({
        mutationKey: [
            "markAsRead"
        ],
        mutationFn: ({ accessToken: t, serviceUrl: a, ids: n })=>$ffb8fedbdc425da8$export$12cd1ccdbaac8618({
                accessToken: t,
                serviceUrl: a,
                method: "POST",
                pathname: "/notifications/mark_as_read",
                params: {
                    ids: n
                }
            }),
        onMutate: async ({ ids: t })=>{
            await e.cancelQueries({
                queryKey: [
                    "notifications"
                ]
            });
            const a = e.getQueriesData({
                queryKey: [
                    "notifications"
                ]
            });
            return a.forEach(([n, l])=>{
                if (l) {
                    if (Array.isArray(l)) {
                        const r = l.map((s)=>t.includes(s.id) ? {
                                ...s,
                                readAt: Date.now().toString()
                            } : s);
                        e.setQueryData(n, r);
                    } else t.includes(l.id) && e.setQueryData(n, {
                        ...l,
                        readAt: Date.now().toString()
                    });
                }
            }), {
                previousNotifications: a
            };
        },
        onError: (t, a, n)=>{
            n?.previousNotifications && n.previousNotifications.forEach(([l, r])=>{
                e.setQueryData(l, r);
            });
        },
        onSettled: ()=>{
            e.invalidateQueries({
                queryKey: [
                    "notifications"
                ]
            });
        }
    });
}
function $ffb8fedbdc425da8$export$260f26ae22e9adc1() {
    const e = (0, $0126047dd734bc33$export$22e77b9572c4fded)();
    return (0, $cb7b7c348969488c$export$609860bf8b0084c)({
        mutationKey: [
            "markAsUnread"
        ],
        mutationFn: ({ accessToken: t, serviceUrl: a, ids: n })=>$ffb8fedbdc425da8$export$12cd1ccdbaac8618({
                accessToken: t,
                serviceUrl: a,
                method: "POST",
                pathname: "/notifications/mark_as_unread",
                params: {
                    ids: n
                }
            }),
        onMutate: async ({ ids: t })=>{
            await e.cancelQueries({
                queryKey: [
                    "notifications"
                ]
            });
            const a = e.getQueriesData({
                queryKey: [
                    "notifications"
                ]
            });
            return a.forEach(([n, l])=>{
                if (l) {
                    if (Array.isArray(l)) {
                        const r = l.map((s)=>t.includes(s.id) ? {
                                ...s,
                                readAt: null
                            } : s);
                        e.setQueryData(n, r);
                    } else t.includes(l.id) && e.setQueryData(n, {
                        ...l,
                        readAt: null
                    });
                }
            }), {
                previousNotifications: a
            };
        },
        onError: (t, a, n)=>{
            n?.previousNotifications && n.previousNotifications.forEach(([l, r])=>{
                e.setQueryData(l, r);
            });
        },
        onSettled: ()=>{
            e.invalidateQueries({
                queryKey: [
                    "notifications"
                ]
            });
        }
    });
}
function $ffb8fedbdc425da8$var$Ce({ showUnreadOnly: e, pollingInterval: t }) {
    const { accessToken: a, serviceUrl: n } = $ffb8fedbdc425da8$var$y(), { hasNextPage: l, fetchNextPage: r, isFetchingNextPage: s } = $ffb8fedbdc425da8$export$53d5ca6c3f53e109({
        accessToken: a,
        serviceUrl: n,
        showUnreadOnly: e,
        refetchInterval: t
    });
    return /* @__PURE__ */ (0, $ayMG0.jsx)("div", {
        className: "helix-p-4 helix-border-top helix-d-flex helix-justify--center helix-bg-white helix-position--relative helix-w-100-percent",
        children: l ? /* @__PURE__ */ (0, $ayMG0.jsx)("button", {
            disabled: s,
            className: "helix-btn helix-btn--link",
            onClick: ()=>r(),
            children: s ? "Loading..." : "Load more"
        }) : /* @__PURE__ */ (0, $ayMG0.jsx)("div", {
            className: "helix-bg-gray-100 helix-py-3 helix-px-6 helix-border-radius--md helix-text--center",
            children: /* @__PURE__ */ (0, $ayMG0.jsxs)("p", {
                className: "helix-body helix-text-gray-600",
                children: [
                    "That's all your ",
                    e && /* @__PURE__ */ (0, $ayMG0.jsx)("strong", {
                        children: "unread"
                    }),
                    " ",
                    "notifications from the past 30 days."
                ]
            })
        })
    });
}
const $ffb8fedbdc425da8$var$$e = "_container_1xj9f_1", $ffb8fedbdc425da8$var$Se = "_empty_1xj9f_17", $ffb8fedbdc425da8$var$A = {
    container: $ffb8fedbdc425da8$var$$e,
    empty: $ffb8fedbdc425da8$var$Se,
    "switch-control": "_switch-control_1xj9f_25"
};
function $ffb8fedbdc425da8$var$Ae({ showUnreadOnly: e, pollingInterval: t, onSettingsClick: a }) {
    const { accessToken: n, serviceUrl: l } = $ffb8fedbdc425da8$var$y(), { data: r } = $ffb8fedbdc425da8$export$53d5ca6c3f53e109({
        accessToken: n,
        serviceUrl: l,
        showUnreadOnly: e,
        refetchInterval: t
    }), s = r.pages.flatMap((u)=>u.data), { mutate: o, isPending: c } = $ffb8fedbdc425da8$export$1a743cba80e0934(), [h, m] = (0, $acw62.useState)(null);
    return /* @__PURE__ */ (0, $ayMG0.jsxs)("div", {
        ref: h?.api?.setReferenceElement,
        children: [
            /* @__PURE__ */ (0, $ayMG0.jsx)("button", {
                className: "helix-btn helix-btn--ghost helix-btn--small",
                ...h?.api?.getToggleButtonProps(),
                children: /* @__PURE__ */ (0, $ayMG0.jsx)((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
                    icon: (0, $c761e69c8e58189a$exports.more_horizontal),
                    className: "helix-svg-fill--gray-600"
                })
            }),
            /* @__PURE__ */ (0, $ayMG0.jsxs)((0, $c4eeb9c976cd472c$export$da284981347a9aea), {
                ref: m,
                children: [
                    /* @__PURE__ */ (0, $ayMG0.jsxs)((0, $eee3ff3bb45e443d$export$2e2bcd8739ae039), {
                        id: "markAllAsRead",
                        textLabel: "Mark all as read",
                        onClick: ()=>{
                            o({
                                accessToken: n,
                                serviceUrl: l,
                                ids: [
                                    ...s,
                                    ...s.flatMap((u)=>u.children || [])
                                ].filter((u)=>!u.readAt).map((u)=>u.id)
                            });
                        },
                        children: [
                            "Mark all as read",
                            c && /* @__PURE__ */ (0, $ayMG0.jsx)((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
                                icon: (0, $c761e69c8e58189a$exports.spinner),
                                className: "helix-svg-fill--gray-600 helix-spin"
                            })
                        ]
                    }),
                    /* @__PURE__ */ (0, $ayMG0.jsx)((0, $eee3ff3bb45e443d$export$2e2bcd8739ae039), {
                        id: "divider",
                        textLabel: "divider",
                        divider: !0
                    }),
                    /* @__PURE__ */ (0, $ayMG0.jsx)((0, $eee3ff3bb45e443d$export$2e2bcd8739ae039), {
                        id: "settings",
                        textLabel: "settings",
                        onClick: a,
                        children: "Settings"
                    })
                ]
            })
        ]
    });
}
function $ffb8fedbdc425da8$var$Pe() {
    return /* @__PURE__ */ (0, $ayMG0.jsx)("button", {
        disabled: !0,
        className: "helix-btn helix-btn--ghost helix-btn--small",
        children: /* @__PURE__ */ (0, $ayMG0.jsx)((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
            icon: (0, $c761e69c8e58189a$exports.more_horizontal),
            className: "helix-svg-fill--gray-600"
        })
    });
}
function $ffb8fedbdc425da8$var$Ee({ showUnreadOnly: e, setShowUnreadOnly: t, pollingInterval: a, onSettingsClick: n }) {
    return /* @__PURE__ */ (0, $ayMG0.jsxs)("div", {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)($ffb8fedbdc425da8$var$A.container, "helix-d-flex helix-align--center helix-justify--between helix-border-bottom helix-bg-white"),
        children: [
            /* @__PURE__ */ (0, $ayMG0.jsx)("h1", {
                className: "helix-display-x-small",
                children: "What's New"
            }),
            /* @__PURE__ */ (0, $ayMG0.jsxs)("div", {
                className: "helix-d-flex helix-align--center helix-gap-2",
                children: [
                    /* @__PURE__ */ (0, $ayMG0.jsx)("div", {
                        className: "helix-switch helix-switch--small",
                        children: /* @__PURE__ */ (0, $ayMG0.jsxs)("label", {
                            children: [
                                /* @__PURE__ */ (0, $ayMG0.jsx)("span", {
                                    className: "helix-switch__label helix-text-gray-600",
                                    children: "Only show unread"
                                }),
                                /* @__PURE__ */ (0, $ayMG0.jsx)("input", {
                                    onChange: (l)=>t?.(l.target.checked),
                                    type: "checkbox",
                                    defaultChecked: e
                                }),
                                /* @__PURE__ */ (0, $ayMG0.jsx)("div", {
                                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)($ffb8fedbdc425da8$var$A["switch-control"], "helix-switch__control")
                                })
                            ]
                        })
                    }),
                    /* @__PURE__ */ (0, $ayMG0.jsx)($ffb8fedbdc425da8$var$w, {
                        fallback: /* @__PURE__ */ (0, $ayMG0.jsx)("div", {
                            className: $ffb8fedbdc425da8$var$A.empty
                        }),
                        children: /* @__PURE__ */ (0, $ayMG0.jsx)((0, $acw62.Suspense), {
                            fallback: /* @__PURE__ */ (0, $ayMG0.jsx)($ffb8fedbdc425da8$var$Pe, {}),
                            children: /* @__PURE__ */ (0, $ayMG0.jsx)($ffb8fedbdc425da8$var$Ae, {
                                showUnreadOnly: e,
                                pollingInterval: a,
                                onSettingsClick: n
                            })
                        })
                    })
                ]
            })
        ]
    });
}
const $ffb8fedbdc425da8$var$Me = "_content_1qg5v_1", $ffb8fedbdc425da8$var$je = "_button_1qg5v_15", $ffb8fedbdc425da8$var$D = {
    content: $ffb8fedbdc425da8$var$Me,
    button: $ffb8fedbdc425da8$var$je
};
function $ffb8fedbdc425da8$var$Qe({ notifications: e }) {
    const [t, a] = (0, $acw62.useState)(!1), [n, l] = (0, $acw62.useState)(0), r = (0, $acw62.useRef)(null), s = (o)=>{
        r.current && l(o ? 0 : r.current.scrollHeight), a(!o);
    };
    return e.length ? /* @__PURE__ */ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /* @__PURE__ */ (0, $ayMG0.jsx)("div", {
                className: $ffb8fedbdc425da8$var$D.content,
                ref: r,
                style: {
                    height: n,
                    opacity: t ? 1 : 0
                },
                children: e.map((o)=>/* @__PURE__ */ (0, $ayMG0.jsx)($ffb8fedbdc425da8$var$z, {
                        notification: o,
                        isChildren: !0
                    }, o.id))
            }),
            /* @__PURE__ */ (0, $ayMG0.jsxs)("button", {
                onClick: ()=>s(t),
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)($ffb8fedbdc425da8$var$D.button, "helix-btn helix-btn--ghost helix-text-gray-600 helix-text--sm helix-body"),
                children: [
                    /* @__PURE__ */ (0, $ayMG0.jsx)((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
                        className: "helix-bg-gray-200 helix-svg-fill--gray-600 helix-border-radius--lg",
                        icon: t ? (0, $c761e69c8e58189a$exports.chevron_small_up) : (0, $c761e69c8e58189a$exports.chevron_small_down)
                    }),
                    t ? "Show less" : `Show ${e.length} more`
                ]
            })
        ]
    }) : null;
}
const $ffb8fedbdc425da8$var$Te = "_container_1uaz1_1", $ffb8fedbdc425da8$var$De = {
    container: $ffb8fedbdc425da8$var$Te
}, $ffb8fedbdc425da8$var$qe = {
    bell: (0, $c761e69c8e58189a$exports.bell),
    comment: (0, $c761e69c8e58189a$exports.comment),
    heart: (0, $c761e69c8e58189a$exports.heart),
    star: (0, $c761e69c8e58189a$exports.star),
    tags: (0, $c761e69c8e58189a$exports.tags),
    mention: (0, $c761e69c8e58189a$exports.email),
    email: (0, $c761e69c8e58189a$exports.email),
    user: (0, $c761e69c8e58189a$exports.user),
    clock: (0, $c761e69c8e58189a$exports.clock),
    dollar_bill: (0, $c761e69c8e58189a$exports.dollar_bill)
};
function $ffb8fedbdc425da8$var$O(e) {
    return e ? $ffb8fedbdc425da8$var$qe[e] || (0, $c761e69c8e58189a$exports.bell) : null;
}
function $ffb8fedbdc425da8$var$Fe({ type: e = "bell" }) {
    const t = $ffb8fedbdc425da8$var$O(e);
    return t ? /* @__PURE__ */ (0, $ayMG0.jsx)("div", {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)($ffb8fedbdc425da8$var$De.container, "helix-d-flex helix-align--center helix-justify--center"),
        children: /* @__PURE__ */ (0, $ayMG0.jsx)((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
            icon: t,
            className: "helix-svg-fill--gray-600"
        })
    }) : null;
}
const $ffb8fedbdc425da8$var$Ke = "_container_1b1o3_1", $ffb8fedbdc425da8$var$Re = {
    container: $ffb8fedbdc425da8$var$Ke
};
function $ffb8fedbdc425da8$var$Ie({ subject: e }) {
    const t = $ffb8fedbdc425da8$var$O(e.icon_key);
    return /* @__PURE__ */ (0, $ayMG0.jsxs)("a", {
        href: e.url,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)($ffb8fedbdc425da8$var$Re.container, "helix-d-flex helix-align--center helix-justify--between helix-border helix-border-radius--sm helix-px-2"),
        children: [
            /* @__PURE__ */ (0, $ayMG0.jsxs)("div", {
                className: "helix-d-flex helix-align--center helix-gap-2",
                children: [
                    t && /* @__PURE__ */ (0, $ayMG0.jsx)((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
                        icon: t,
                        className: "helix-svg-fill--gray-600"
                    }),
                    /* @__PURE__ */ (0, $ayMG0.jsx)("div", {
                        className: "helix-body--strong helix-text-gray-900",
                        children: e.title
                    })
                ]
            }),
            /* @__PURE__ */ (0, $ayMG0.jsx)((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
                icon: (0, $1d43c7fb5c1d248f$exports.circle_arrow_right),
                className: "helix-svg-fill--gray-600"
            })
        ]
    });
}
const $ffb8fedbdc425da8$var$q = {
    "notification-list-item": "_notification-list-item_1xu1t_1",
    "notification-list-item-info": "_notification-list-item-info_1xu1t_9"
}, $ffb8fedbdc425da8$var$Ue = "_reaction_1viu7_1", $ffb8fedbdc425da8$var$Le = {
    reaction: $ffb8fedbdc425da8$var$Ue
};
function $ffb8fedbdc425da8$var$He({ reactions: e }) {
    return e?.length ? /* @__PURE__ */ (0, $ayMG0.jsx)("div", {
        className: "helix-flex-1 helix-d-flex helix-gap-5",
        children: e?.map((t)=>/* @__PURE__ */ (0, $ayMG0.jsx)("a", {
                href: t.url || "#",
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)($ffb8fedbdc425da8$var$Le.reaction, "helix-body--strong helix-text-brand helix-mt-2"),
                children: t.label
            }, t.url))
    }) : null;
}
const $ffb8fedbdc425da8$var$Oe = "_container_ikk65_1", $ffb8fedbdc425da8$var$ze = "_wrapper_ikk65_17", $ffb8fedbdc425da8$var$Be = "_dot_ikk65_55", $ffb8fedbdc425da8$var$P = {
    container: $ffb8fedbdc425da8$var$Oe,
    wrapper: $ffb8fedbdc425da8$var$ze,
    dot: $ffb8fedbdc425da8$var$Be
};
function $ffb8fedbdc425da8$var$Ge({ notification: e }) {
    const { accessToken: t, serviceUrl: a } = $ffb8fedbdc425da8$var$y(), { mutate: n } = $ffb8fedbdc425da8$export$1a743cba80e0934(), { mutate: l } = $ffb8fedbdc425da8$export$260f26ae22e9adc1(), [r, s] = (0, $acw62.useState)(null), o = e.children?.every((u)=>u.readAt) ? "read" : e.children?.some((u)=>u.readAt) ? "mixed" : "unread", c = e.children?.length ? e.readAt ? o === "read" ? "read" : "mixed" : o === "unread" ? "unread" : "mixed" : e.readAt ? "read" : "unread", h = e.readAt ? "unread" : "read", m = e.children?.length ? {
        ...r?.api?.getToggleButtonProps()
    } : {
        onClick: ()=>{
            h === "unread" ? l({
                accessToken: t,
                serviceUrl: a,
                ids: [
                    e.id
                ]
            }) : n({
                accessToken: t,
                serviceUrl: a,
                ids: [
                    e.id
                ]
            });
        }
    };
    return /* @__PURE__ */ (0, $ayMG0.jsx)("div", {
        className: $ffb8fedbdc425da8$var$P.container,
        children: /* @__PURE__ */ (0, $ayMG0.jsxs)("div", {
            ref: r?.api?.setReferenceElement,
            children: [
                /* @__PURE__ */ (0, $ayMG0.jsx)("div", {
                    className: $ffb8fedbdc425da8$var$P.wrapper,
                    id: `tooltip-trigger-${e.id}`,
                    "aria-describedby": "tooltip-id",
                    tabIndex: 0,
                    ...m,
                    children: /* @__PURE__ */ (0, $ayMG0.jsx)("div", {
                        style: {
                            background: c === "mixed" ? "linear-gradient(to right, white 50%, var(--helix-brand) 50%)" : void 0,
                            border: c === "mixed" ? "1px solid var(--helix-brand)" : void 0
                        },
                        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)($ffb8fedbdc425da8$var$P.dot, {
                            "helix-bg-gray-300": c === "read",
                            "helix-bg-brand": c === "unread"
                        })
                    })
                }),
                /* @__PURE__ */ (0, $ayMG0.jsxs)((0, $eebc07e282037d65$export$2e2bcd8739ae039), {
                    target: `tooltip-trigger-${e.id}`,
                    placement: "left",
                    popperModifiers: [
                        {
                            name: "offset",
                            options: {
                                offset: [
                                    0,
                                    8
                                ]
                            }
                        }
                    ],
                    children: [
                        "Mark as ",
                        h
                    ]
                }),
                /* @__PURE__ */ (0, $ayMG0.jsxs)((0, $c4eeb9c976cd472c$export$da284981347a9aea), {
                    ref: s,
                    placement: "bottom-end",
                    children: [
                        /* @__PURE__ */ (0, $ayMG0.jsxs)((0, $eee3ff3bb45e443d$export$2e2bcd8739ae039), {
                            id: "markGroupAsRead",
                            textLabel: "Mark group as read",
                            onClick: ()=>{
                                h === "unread" ? l({
                                    accessToken: t,
                                    serviceUrl: a,
                                    ids: [
                                        e.id,
                                        ...e.children?.map((u)=>u.id) || []
                                    ]
                                }) : n({
                                    accessToken: t,
                                    serviceUrl: a,
                                    ids: [
                                        e.id,
                                        ...e.children?.map((u)=>u.id) || []
                                    ]
                                });
                            },
                            children: [
                                "Mark group as ",
                                h
                            ]
                        }),
                        /* @__PURE__ */ (0, $ayMG0.jsxs)((0, $eee3ff3bb45e443d$export$2e2bcd8739ae039), {
                            id: "markAsRead",
                            textLabel: "Mark as read",
                            onClick: ()=>{
                                h === "unread" ? l({
                                    accessToken: t,
                                    serviceUrl: a,
                                    ids: [
                                        e.id
                                    ]
                                }) : n({
                                    accessToken: t,
                                    serviceUrl: a,
                                    ids: [
                                        e.id
                                    ]
                                });
                            },
                            children: [
                                "Mark as ",
                                h
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
const $ffb8fedbdc425da8$var$We = "_container_18plv_1", $ffb8fedbdc425da8$var$Je = {
    container: $ffb8fedbdc425da8$var$We
};
function $ffb8fedbdc425da8$var$Ve({ time: e }) {
    return e ? /* @__PURE__ */ (0, $ayMG0.jsx)("div", {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)($ffb8fedbdc425da8$var$Je.container, "helix-small helix-text-gray-500"),
        children: $ffb8fedbdc425da8$var$Ye($ffb8fedbdc425da8$var$Xe(new Date(e)))
    }) : null;
}
function $ffb8fedbdc425da8$var$Xe(e) {
    const t = /* @__PURE__ */ new Date(), a = new Date(e), n = Math.floor((a.getTime() - t.getTime()) / 1e3), l = new Intl.RelativeTimeFormat(void 0, {
        numeric: "auto"
    }), r = [
        [
            "year",
            31536000
        ],
        [
            "month",
            2592000
        ],
        [
            "week",
            604800
        ],
        [
            "day",
            86400
        ],
        [
            "hour",
            3600
        ],
        [
            "minute",
            60
        ],
        [
            "second",
            1
        ]
    ];
    for (const [s, o] of r){
        const c = Math.round(n / o);
        if (Math.abs(c) >= 1) return l.format(c, s);
    }
    return "just now";
}
function $ffb8fedbdc425da8$var$Ye(e) {
    return e.replace("about", "").replace(" minutes ", " min ").replace("1 minute ", "1m ").replace("less than a minute ago", "now");
}
function $ffb8fedbdc425da8$var$z({ notification: e, isChildren: t }) {
    return /* @__PURE__ */ (0, $ayMG0.jsxs)("div", {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)($ffb8fedbdc425da8$var$q["notification-list-item"], "notification-list-item", {
            "is-children helix-p-0": t
        }),
        children: [
            /* @__PURE__ */ (0, $ayMG0.jsxs)("div", {
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)($ffb8fedbdc425da8$var$q["notification-list-item-info"], "helix-d-flex helix-gap-4 helix-pr-7 helix-border-radius--sm"),
                children: [
                    /* @__PURE__ */ (0, $ayMG0.jsx)($ffb8fedbdc425da8$var$Fe, {
                        type: e.icon
                    }),
                    /* @__PURE__ */ (0, $ayMG0.jsxs)("div", {
                        className: "helix-flex-1",
                        children: [
                            /* @__PURE__ */ (0, $ayMG0.jsxs)("div", {
                                className: "helix-d-flex helix-align--center helix-justify--between helix-position--relative helix-gap-2",
                                children: [
                                    /* @__PURE__ */ (0, $ayMG0.jsx)("p", {
                                        className: "helix-body--strong helix-text-gray-900",
                                        children: e.summary
                                    }),
                                    /* @__PURE__ */ (0, $ayMG0.jsx)($ffb8fedbdc425da8$var$Ve, {
                                        time: e.createdAt
                                    }),
                                    /* @__PURE__ */ (0, $ayMG0.jsx)($ffb8fedbdc425da8$var$Ge, {
                                        notification: e
                                    })
                                ]
                            }),
                            /* @__PURE__ */ (0, $ayMG0.jsx)("p", {
                                className: "helix-body helix-text-gray-900 helix-mt-2",
                                children: e.content
                            }),
                            /* @__PURE__ */ (0, $ayMG0.jsx)($ffb8fedbdc425da8$var$He, {
                                reactions: e.reactions
                            })
                        ]
                    })
                ]
            }),
            !!e.children?.length && /* @__PURE__ */ (0, $ayMG0.jsx)($ffb8fedbdc425da8$var$Qe, {
                notifications: e.children || []
            }),
            e.subject && !t && /* @__PURE__ */ (0, $ayMG0.jsx)("div", {
                className: "helix-mt-3 helix-ml-7",
                children: /* @__PURE__ */ (0, $ayMG0.jsx)($ffb8fedbdc425da8$var$Ie, {
                    subject: e.subject
                })
            })
        ]
    });
}
function $ffb8fedbdc425da8$var$Ze({ showUnreadOnly: e, pollingInterval: t }) {
    const { accessToken: a, serviceUrl: n } = $ffb8fedbdc425da8$var$y(), { data: l } = $ffb8fedbdc425da8$export$53d5ca6c3f53e109({
        accessToken: a,
        serviceUrl: n,
        showUnreadOnly: e,
        refetchInterval: t
    }), s = l.pages.flatMap((o)=>o.data).reduce((o, c)=>({
            ...o,
            [c.topic || "other"]: [
                ...o[c.topic || "other"] || [],
                c
            ]
        }), {});
    return /* @__PURE__ */ (0, $ayMG0.jsx)("div", {
        className: "helix-flex-1",
        children: Object.entries(s).map(([, o])=>{
            const c = o.at(0), h = o.slice(1);
            return c ? (c.children = h, /* @__PURE__ */ (0, $ayMG0.jsx)($ffb8fedbdc425da8$var$z, {
                notification: c
            }, c.id)) : null;
        })
    });
}
function $ffb8fedbdc425da8$export$3bc74ddc2b09afd({ showUnreadOnly: e, setShowUnreadOnly: t, onSettingsClick: a, pollingInterval: n }) {
    return /* @__PURE__ */ (0, $ayMG0.jsxs)("div", {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)($ffb8fedbdc425da8$var$we.container, "helix-border-radius--md helix-bg-white"),
        children: [
            /* @__PURE__ */ (0, $ayMG0.jsx)($ffb8fedbdc425da8$var$Ee, {
                showUnreadOnly: e,
                setShowUnreadOnly: t,
                pollingInterval: n,
                onSettingsClick: a
            }),
            /* @__PURE__ */ (0, $ayMG0.jsx)($ffb8fedbdc425da8$var$w, {
                fallback: ({ error: l })=>/* @__PURE__ */ (0, $ayMG0.jsx)("div", {
                        className: "helix-body helix-text-red-500 helix-py-4 helix-px-6",
                        children: l.message || "Error loading notifications"
                    }),
                children: /* @__PURE__ */ (0, $ayMG0.jsx)((0, $acw62.Suspense), {
                    fallback: /* @__PURE__ */ (0, $ayMG0.jsx)("div", {
                        className: "helix-p-4",
                        children: /* @__PURE__ */ (0, $ayMG0.jsx)($ffb8fedbdc425da8$var$U, {})
                    }),
                    children: /* @__PURE__ */ (0, $ayMG0.jsx)($ffb8fedbdc425da8$var$Ze, {
                        showUnreadOnly: e,
                        pollingInterval: n
                    })
                })
            }),
            /* @__PURE__ */ (0, $ayMG0.jsx)($ffb8fedbdc425da8$var$w, {
                fallback: /* @__PURE__ */ (0, $ayMG0.jsx)("div", {}),
                children: /* @__PURE__ */ (0, $ayMG0.jsx)((0, $acw62.Suspense), {
                    children: /* @__PURE__ */ (0, $ayMG0.jsx)($ffb8fedbdc425da8$var$Ce, {
                        showUnreadOnly: e,
                        pollingInterval: n
                    })
                })
            })
        ]
    });
}
function $ffb8fedbdc425da8$export$9ea89744f796ad7c({ accessToken: e, serviceUrl: t }) {
    return (0, $064d639e6ac3b119$export$5bf2755c0a009e74)({
        queryKey: [
            "channels",
            e,
            t
        ],
        queryFn: ()=>$ffb8fedbdc425da8$export$12cd1ccdbaac8618({
                accessToken: e,
                serviceUrl: t,
                pathname: "/channels"
            })
    });
}
const $ffb8fedbdc425da8$var$tt = "_container_1na7o_1", $ffb8fedbdc425da8$var$it = "_modal_1na7o_19", $ffb8fedbdc425da8$var$nt = "_panel_1na7o_39", $ffb8fedbdc425da8$var$$ = {
    container: $ffb8fedbdc425da8$var$tt,
    modal: $ffb8fedbdc425da8$var$it,
    panel: $ffb8fedbdc425da8$var$nt,
    "panel-header": "_panel-header_1na7o_83"
}, $ffb8fedbdc425da8$var$rt = "_container_1c93q_1", $ffb8fedbdc425da8$var$at = {
    container: $ffb8fedbdc425da8$var$rt
};
function $ffb8fedbdc425da8$var$lt({ header: e, children: t }) {
    return /* @__PURE__ */ (0, $ayMG0.jsxs)("div", {
        className: $ffb8fedbdc425da8$var$at.container,
        children: [
            /* @__PURE__ */ (0, $ayMG0.jsx)("h3", {
                className: "helix-display-x-small helix-px-3 helix-text--capitalize",
                children: e
            }),
            t
        ]
    });
}
const $ffb8fedbdc425da8$var$ot = "_container_136iy_1", $ffb8fedbdc425da8$var$st = {
    container: $ffb8fedbdc425da8$var$ot
};
function $ffb8fedbdc425da8$var$ct({ onClose: e }) {
    return /* @__PURE__ */ (0, $ayMG0.jsxs)("div", {
        className: $ffb8fedbdc425da8$var$st.container,
        children: [
            /* @__PURE__ */ (0, $ayMG0.jsxs)("button", {
                className: "helix-body--strong",
                onClick: e,
                children: [
                    /* @__PURE__ */ (0, $ayMG0.jsx)((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
                        icon: (0, $c761e69c8e58189a$exports.chevron_left)
                    }),
                    /* @__PURE__ */ (0, $ayMG0.jsx)("div", {
                        children: "Exit"
                    })
                ]
            }),
            /* @__PURE__ */ (0, $ayMG0.jsx)("h2", {
                className: "helix-heading",
                children: "Notification Settings"
            })
        ]
    });
}
function $ffb8fedbdc425da8$var$dt({ header: e, ...t }) {
    return /* @__PURE__ */ (0, $ayMG0.jsxs)("div", {
        children: [
            /* @__PURE__ */ (0, $ayMG0.jsx)("p", {
                className: "helix-subheading header-text helix-px-3 helix-mb-2",
                children: e
            }),
            /* @__PURE__ */ (0, $ayMG0.jsx)("ul", {
                className: "helix-list-group",
                ...t
            })
        ]
    });
}
function $ffb8fedbdc425da8$export$2ed9627edc26d6d1({ accessToken: e, serviceUrl: t }) {
    return (0, $064d639e6ac3b119$export$5bf2755c0a009e74)({
        queryKey: [
            "channelPreferences",
            e,
            t
        ],
        queryFn: ()=>$ffb8fedbdc425da8$export$12cd1ccdbaac8618({
                accessToken: e,
                serviceUrl: t,
                pathname: "/channel_preferences"
            })
    });
}
function $ffb8fedbdc425da8$export$7f0298a8c10e46cc() {
    const e = (0, $0126047dd734bc33$export$22e77b9572c4fded)();
    return (0, $cb7b7c348969488c$export$609860bf8b0084c)({
        mutationKey: [
            "updateChannelPreference"
        ],
        mutationFn: ({ channelId: t, channelPreferenceId: a, enabled: n, accessToken: l, serviceUrl: r })=>$ffb8fedbdc425da8$export$12cd1ccdbaac8618({
                accessToken: l,
                serviceUrl: r,
                pathname: `/channel_preferences/${t}`,
                method: "PUT",
                params: {
                    channel_id: t,
                    channel_preference_id: a,
                    enabled: n
                }
            }),
        onMutate: async ({ channelPreferenceId: t, enabled: a })=>{
            await e.cancelQueries({
                queryKey: [
                    "channelPreferences"
                ]
            });
            const n = e.getQueriesData({
                queryKey: [
                    "channelPreferences"
                ]
            });
            return n.forEach(([l, r])=>{
                if (r) {
                    if (Array.isArray(r)) {
                        const s = r.map((o)=>o.id === t ? {
                                ...o,
                                enabled: a
                            } : o);
                        e.setQueryData(l, s);
                    } else r.id === t && e.setQueryData(l, {
                        ...r,
                        enabled: a
                    });
                }
            }), {
                previousChannelPreferences: n
            };
        },
        onError: (t, a, n)=>{
            n?.previousChannelPreferences && n.previousChannelPreferences.forEach(([l, r])=>{
                e.setQueryData(l, r);
            });
        },
        onSettled: ()=>{
            e.invalidateQueries({
                queryKey: [
                    "channelPreferences"
                ]
            }), e.invalidateQueries({
                queryKey: [
                    "channels"
                ]
            });
        }
    });
}
function $ffb8fedbdc425da8$var$ft({ channel: e, onError: t }) {
    const { accessToken: a, serviceUrl: n } = $ffb8fedbdc425da8$var$y(), { data: l } = $ffb8fedbdc425da8$export$9ea89744f796ad7c({
        accessToken: a,
        serviceUrl: n
    }), { data: r } = $ffb8fedbdc425da8$export$2ed9627edc26d6d1({
        accessToken: a,
        serviceUrl: n
    }), { mutate: s } = $ffb8fedbdc425da8$export$7f0298a8c10e46cc(), c = l.filter((u)=>u.topic.id === e.topic.id).find((u)=>u.destination === e.destination), h = r.find((u)=>u.channelId === c?.id), m = !c;
    return /* @__PURE__ */ (0, $ayMG0.jsx)("div", {
        className: "helix-checkbox",
        style: {
            userSelect: m ? "none" : "auto",
            visibility: m ? "hidden" : "visible"
        },
        children: /* @__PURE__ */ (0, $ayMG0.jsxs)("label", {
            children: [
                /* @__PURE__ */ (0, $ayMG0.jsx)("input", {
                    type: "checkbox",
                    checked: h?.enabled ?? c?.enabled ?? !1,
                    onChange: (u)=>{
                        t(null), s({
                            accessToken: a,
                            serviceUrl: n,
                            channelId: e.id,
                            channelPreferenceId: h?.id,
                            enabled: u.target.checked
                        }, {
                            onError: (p)=>{
                                t(p);
                            }
                        });
                    }
                }),
                /* @__PURE__ */ (0, $ayMG0.jsx)("div", {
                    className: "helix-checkbox__input"
                })
            ]
        })
    });
}
function $ffb8fedbdc425da8$var$mt({ channels: e, onError: t }) {
    const a = e.filter((r)=>r.destination === "feed"), n = e.filter((r)=>r.destination === "email"), l = [
        ...a,
        ...n
    ];
    return /* @__PURE__ */ (0, $ayMG0.jsx)("div", {
        className: "helix-d-flex helix-gap-5",
        children: l.map((r)=>/* @__PURE__ */ (0, $ayMG0.jsx)($ffb8fedbdc425da8$var$ft, {
                channel: r,
                onError: t
            }, r.id))
    });
}
const $ffb8fedbdc425da8$var$xt = "_container_zptpo_1", $ffb8fedbdc425da8$var$pt = {
    container: $ffb8fedbdc425da8$var$xt
};
function $ffb8fedbdc425da8$var$gt({ topic: e, channels: t }) {
    const [a, n] = (0, $acw62.useState)(null);
    return /* @__PURE__ */ (0, $ayMG0.jsxs)("div", {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)($ffb8fedbdc425da8$var$pt.container, "helix-d-flex helix-flex--column helix-gap-1 helix-pl-3 helix-py-2 helix-border-radius--sm"),
        children: [
            /* @__PURE__ */ (0, $ayMG0.jsxs)("div", {
                className: "helix-d-flex helix-align--center helix-justify--between",
                children: [
                    /* @__PURE__ */ (0, $ayMG0.jsx)("div", {
                        className: "helix-body",
                        children: e
                    }),
                    /* @__PURE__ */ (0, $ayMG0.jsx)($ffb8fedbdc425da8$var$mt, {
                        channels: t,
                        onError: n
                    })
                ]
            }),
            a && /* @__PURE__ */ (0, $ayMG0.jsx)("div", {
                className: "helix-body helix-text-red-500",
                children: a.message
            })
        ]
    });
}
function $ffb8fedbdc425da8$export$502c662bdea2dee({ onClose: e }) {
    return (0, $acw62.useEffect)(()=>(document.body.style.overflow = "hidden", ()=>{
            document.body.style.overflow = "auto";
        }), []), (0, $1u0KT.createPortal)(/* @__PURE__ */ (0, $ayMG0.jsx)("div", {
        className: $ffb8fedbdc425da8$var$$.container,
        children: /* @__PURE__ */ (0, $ayMG0.jsx)((0, $fa2b6a3504678b01$export$2b77a92f1a5ad772), {
            className: $ffb8fedbdc425da8$var$$.modal,
            show: !0,
            onClose: ()=>e(),
            children: /* @__PURE__ */ (0, $ayMG0.jsxs)("div", {
                className: "helix-d-flex helix-flex--column helix-align--middle",
                children: [
                    /* @__PURE__ */ (0, $ayMG0.jsx)($ffb8fedbdc425da8$var$ct, {
                        onClose: ()=>e()
                    }),
                    /* @__PURE__ */ (0, $ayMG0.jsx)("div", {
                        className: "helix-py-5",
                        children: /* @__PURE__ */ (0, $ayMG0.jsxs)("div", {
                            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)($ffb8fedbdc425da8$var$$.panel, "helix-card"),
                            children: [
                                /* @__PURE__ */ (0, $ayMG0.jsxs)("div", {
                                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)($ffb8fedbdc425da8$var$$["panel-header"], "helix-d-flex helix-align--center helix-justify--space-between"),
                                    children: [
                                        /* @__PURE__ */ (0, $ayMG0.jsx)("div", {
                                            className: "helix-subheading header-text",
                                            children: "Activity"
                                        }),
                                        /* @__PURE__ */ (0, $ayMG0.jsxs)("div", {
                                            className: "helix-d-flex helix-gap-4",
                                            children: [
                                                /* @__PURE__ */ (0, $ayMG0.jsx)("div", {
                                                    className: "helix-subheading header-text",
                                                    children: "feed"
                                                }),
                                                /* @__PURE__ */ (0, $ayMG0.jsx)("div", {
                                                    className: "helix-subheading header-text",
                                                    children: "email"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /* @__PURE__ */ (0, $ayMG0.jsx)("div", {
                                    className: "helix-d-flex helix-flex--column helix-gap-6",
                                    children: /* @__PURE__ */ (0, $ayMG0.jsx)($ffb8fedbdc425da8$var$w, {
                                        children: /* @__PURE__ */ (0, $ayMG0.jsx)((0, $acw62.Suspense), {
                                            fallback: /* @__PURE__ */ (0, $ayMG0.jsx)($ffb8fedbdc425da8$var$U, {}),
                                            children: /* @__PURE__ */ (0, $ayMG0.jsx)($ffb8fedbdc425da8$var$bt, {})
                                        })
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    }), document.body);
}
function $ffb8fedbdc425da8$var$bt() {
    const { accessToken: e, serviceUrl: t } = $ffb8fedbdc425da8$var$y(), { data: a } = $ffb8fedbdc425da8$export$9ea89744f796ad7c({
        accessToken: e,
        serviceUrl: t
    }), n = a.reduce((l, r)=>{
        const s = l[r.topic.module_label] || {}, o = s[r.topic.group_label] || {};
        return o[r.topic.label] = o[r.topic.label] || [], o[r.topic.label].push(r), s[r.topic.group_label] = o, {
            ...l,
            [r.topic.module_label]: s
        };
    }, {});
    return /* @__PURE__ */ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: Object.entries(n).map(([l, r])=>/* @__PURE__ */ (0, $ayMG0.jsx)($ffb8fedbdc425da8$var$lt, {
                header: l,
                children: Object.entries(r).map(([s, o])=>/* @__PURE__ */ (0, $ayMG0.jsx)($ffb8fedbdc425da8$var$dt, {
                        header: s,
                        children: Object.entries(o).map(([c, h])=>/* @__PURE__ */ (0, $ayMG0.jsx)($ffb8fedbdc425da8$var$gt, {
                                topic: c,
                                channels: h
                            }, c))
                    }, s))
            }, l))
    });
}
const $ffb8fedbdc425da8$var$Nt = "_popover_1o2xi_1", $ffb8fedbdc425da8$var$vt = {
    popover: $ffb8fedbdc425da8$var$Nt
}, $ffb8fedbdc425da8$var$_t = new (0, $993a0f6ad9d6681b$export$405d0624ed55a03f)({
    defaultOptions: {
        queries: {
            retry: !1,
            refetchOnWindowFocus: !1
        }
    }
});
function $ffb8fedbdc425da8$export$ca1c7da642902c6e({ accessToken: e, serviceUrl: t, queryClient: a, useQueryProvider: n = !0, children: l }) {
    return /* @__PURE__ */ (0, $ayMG0.jsx)($ffb8fedbdc425da8$var$L.Provider, {
        value: {
            accessToken: e,
            serviceUrl: t
        },
        children: n ? /* @__PURE__ */ (0, $ayMG0.jsx)((0, $0126047dd734bc33$export$45604f0cc8ae667b), {
            client: a ?? $ffb8fedbdc425da8$var$_t,
            children: l
        }) : /* @__PURE__ */ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: l
        })
    });
}
const $ffb8fedbdc425da8$var$kt = "_button_1bax8_1", $ffb8fedbdc425da8$var$Ct = {
    button: $ffb8fedbdc425da8$var$kt
};
function $ffb8fedbdc425da8$var$$t({ id: e, className: t, children: a, showUnreadOnly: n, pollingInterval: l, ...r }) {
    return /* @__PURE__ */ (0, $ayMG0.jsx)("button", {
        id: e || "notifications",
        "aria-label": "Toggle Notifications Feed",
        ...r,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)($ffb8fedbdc425da8$var$Ct.button, t, {
            "helix-d-inline-flex": !a
        }),
        children: /* @__PURE__ */ (0, $ayMG0.jsx)($ffb8fedbdc425da8$var$w, {
            fallback: /* @__PURE__ */ (0, $ayMG0.jsx)((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
                icon: (0, $c761e69c8e58189a$exports.bell)
            }),
            children: /* @__PURE__ */ (0, $ayMG0.jsx)((0, $acw62.Suspense), {
                fallback: a || /* @__PURE__ */ (0, $ayMG0.jsx)((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
                    icon: (0, $c761e69c8e58189a$exports.bell)
                }),
                children: a || /* @__PURE__ */ (0, $ayMG0.jsx)($ffb8fedbdc425da8$var$St, {
                    showUnreadOnly: n,
                    pollingInterval: l
                })
            })
        })
    });
}
function $ffb8fedbdc425da8$var$St({ showUnreadOnly: e, pollingInterval: t }) {
    const { accessToken: a, serviceUrl: n } = $ffb8fedbdc425da8$var$y(), { data: l } = $ffb8fedbdc425da8$export$53d5ca6c3f53e109({
        accessToken: a,
        serviceUrl: n,
        showUnreadOnly: e,
        refetchInterval: t
    }), s = l.pages.flatMap((o)=>o.data).some((o)=>!o.readAt);
    return /* @__PURE__ */ (0, $ayMG0.jsx)((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
        icon: s ? (0, $c761e69c8e58189a$exports.bell_notification) : (0, $c761e69c8e58189a$exports.bell)
    });
}
function $ffb8fedbdc425da8$export$36ba2f559d49a8f6({ accessToken: e, serviceUrl: t, pollingInterval: a, ...n }) {
    const [l, r] = (0, $acw62.useState)(!1), [s, o] = (0, $acw62.useState)(!1);
    return /* @__PURE__ */ (0, $ayMG0.jsxs)($ffb8fedbdc425da8$export$ca1c7da642902c6e, {
        accessToken: e,
        serviceUrl: t,
        children: [
            /* @__PURE__ */ (0, $ayMG0.jsx)($ffb8fedbdc425da8$var$$t, {
                ...n,
                showUnreadOnly: l,
                pollingInterval: a
            }),
            /* @__PURE__ */ (0, $ayMG0.jsx)((0, $64b135e6156ff8db$export$2e2bcd8739ae039), {
                target: n.id || "notifications",
                placement: "bottom-end",
                interactive: !0,
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)($ffb8fedbdc425da8$var$vt.popover, "helix-p-0"),
                children: /* @__PURE__ */ (0, $ayMG0.jsx)($ffb8fedbdc425da8$export$3bc74ddc2b09afd, {
                    showUnreadOnly: l,
                    setShowUnreadOnly: r,
                    pollingInterval: a,
                    onSettingsClick: ()=>o(!0)
                })
            }),
            s && /* @__PURE__ */ (0, $ayMG0.jsx)($ffb8fedbdc425da8$export$502c662bdea2dee, {
                onClose: ()=>o(!1)
            })
        ]
    });
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ function $847bf9dc758b6d61$var$__rest$1(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $847bf9dc758b6d61$var$__awaiter$1(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
typeof SuppressedError === "function" && SuppressedError;
/* eslint-disable max-len */ // Centralized mock data for ClientSwitcher and SidebarNav
const $847bf9dc758b6d61$var$mockClients = [
    {
        clientId: "client-1",
        name: "Acme Corporation",
        clientType: "Brokerage",
        appIds: [
            "crm",
            "con"
        ]
    },
    {
        clientId: "client-2",
        name: "Clark Kent",
        clientType: "User",
        appIds: [
            "as",
            "ca",
            "con",
            "cm",
            "cs",
            "crm",
            "ecom",
            "ess",
            "hsb",
            "hss",
            "ld",
            "lp",
            "pbg",
            "sch",
            "tw",
            "xam",
            "xbm"
        ]
    },
    {
        clientId: "client-3",
        name: "Demo Company Ltd",
        clientType: "Brokerage",
        appIds: [
            "crm",
            "con"
        ]
    }
];
const $847bf9dc758b6d61$var$mockAppConnections = [
    {
        appId: "crm",
        clientId: "client-2",
        platformClient: true,
        name: "Relationships"
    },
    {
        appId: "con",
        clientId: "client-2",
        platformClient: true,
        name: "Contacts"
    },
    {
        appId: "ca",
        clientId: "client-2",
        platformClient: true,
        name: "Cloud Attract"
    },
    {
        appId: "cs",
        clientId: "client-2",
        platformClient: true,
        name: "Cloud Streams"
    },
    {
        appId: "zfp",
        clientId: null,
        name: "zipForm Instance 1"
    },
    {
        appId: "zfp",
        clientId: null,
        name: "zipForm Instance 2"
    },
    {
        appId: "zfp",
        clientId: null,
        name: "zipForm Instance 3"
    },
    {
        appId: "bov",
        clientId: null,
        name: "H4322"
    },
    {
        appId: "bov",
        clientId: null,
        name: "A3234"
    },
    {
        appId: "bov",
        clientId: null,
        name: "C3245F"
    },
    {
        appId: "xbm",
        clientId: null,
        name: "Broker Metrics"
    },
    {
        appId: "xbm",
        clientId: null,
        name: "Broker Metrics 2"
    },
    {
        appId: "cm",
        clientId: "client-2",
        platformClient: true,
        name: "Cloud MLX"
    },
    {
        appId: "xam",
        clientId: "client-2",
        platformClient: true,
        name: "AgentMetrics"
    },
    {
        appId: "ecom",
        clientId: "client-2",
        platformClient: true,
        name: "E-commerce"
    },
    {
        appId: "hsb",
        clientId: "client-2",
        platformClient: true,
        name: "Boost"
    },
    {
        appId: "hss",
        clientId: "client-2",
        platformClient: true,
        name: "Spacio"
    },
    {
        appId: "pbg",
        clientId: "client-2",
        platformClient: true,
        name: "Front Office"
    },
    {
        appId: "sch",
        clientId: "client-2",
        platformClient: true,
        name: "Schedules"
    },
    {
        appId: "tw",
        clientId: "client-2",
        platformClient: true,
        name: "Transact"
    },
    {
        appId: "as",
        clientId: "client-2",
        platformClient: true,
        name: "Authentisign"
    },
    {
        appId: "lp",
        clientId: "client-2",
        platformClient: true,
        name: "Leads+"
    }
];
const $847bf9dc758b6d61$var$mockAppData = [
    {
        version: 11,
        createdTimestamp: "2023-06-15T17:41:14.972Z",
        modifiedTimestamp: "2025-09-24T19:00:03.493Z",
        active: true,
        supportsBranding: true,
        config: {
            name: "Relationships",
            description: "Automated lead and client engagement",
            icon: "person_frame",
            login: {
                url: "https://crm.dev.lwolf.com",
                params: {
                    redirectAfterLogin: "r",
                    userId: "crmUserId"
                }
            }
        },
        id: "crm"
    },
    {
        version: 4,
        createdTimestamp: "2023-06-15T17:41:14.972Z",
        modifiedTimestamp: "2025-09-24T19:00:03.493Z",
        active: true,
        supportsBranding: true,
        config: {
            name: "Transact",
            description: "Start, manage and close deals",
            icon: "transaction_workflow",
            login: {
                url: "https://transact-workflow.dev.lwolf.com/auth",
                params: {
                    redirectAfterLogin: "redirectUrl",
                    userId: "twUserId"
                }
            }
        },
        id: "tw"
    },
    {
        version: 2,
        createdTimestamp: "2025-05-23T20:14:58.941Z",
        modifiedTimestamp: "2025-07-11T15:03:29.402Z",
        active: true,
        supportsBranding: false,
        config: {
            name: "Foundation",
            description: "Access market and business analytics",
            icon: "line_chart_loop",
            hidden: true,
            login: {
                url: "https://foundation.dev.lwolf.com",
                params: {
                    redirectAfterLogin: "redirect"
                }
            },
            promotion: {
                url: "https://foundation.dev.lwolf.com",
                skipPfmAuth: true
            }
        },
        id: "fdn"
    },
    {
        version: 1,
        createdTimestamp: "2023-06-15T17:41:14.972Z",
        modifiedTimestamp: "2023-06-15T17:41:14.972Z",
        active: true,
        supportsBranding: false,
        config: {
            name: "Cloud MLX",
            description: "Search for and share MLS listings",
            icon: "search_home",
            login: {
                url: "",
                params: {
                    token: "",
                    redirectAfterLogin: "",
                    userId: "cmUserId"
                }
            },
            connect: {
                url: ""
            }
        },
        id: "cm"
    },
    {
        version: 1,
        createdTimestamp: "2023-06-15T17:41:14.972Z",
        modifiedTimestamp: "2023-06-15T17:41:14.972Z",
        active: true,
        supportsBranding: false,
        config: {
            name: "Cloud Streams",
            description: "Set up MLS listing alerts",
            icon: "bell",
            login: {
                url: "",
                params: {
                    token: "",
                    redirectAfterLogin: "",
                    userId: "csUserId"
                }
            },
            connect: {
                url: ""
            }
        },
        id: "cs"
    },
    {
        version: 4,
        createdTimestamp: "2024-05-06T19:14:36.538Z",
        modifiedTimestamp: "2025-09-29T15:39:54.569Z",
        active: true,
        supportsBranding: false,
        config: {
            name: "Schedules",
            description: "Manage your scheduled events and tasks",
            hidden: true,
            login: {
                url: "https://schedules.dev.lwolf.com",
                params: {
                    redirectAfterLogin: "redirectUrl"
                }
            }
        },
        id: "sch"
    },
    {
        version: 4,
        createdTimestamp: "2024-11-22T21:30:52.588Z",
        modifiedTimestamp: "2024-12-30T17:30:12.208Z",
        active: true,
        supportsBranding: false,
        config: {
            name: "AgentMetrics",
            description: "Access market and business analytics",
            icon: "line_chart_loop",
            login: {
                url: "https://agentmetrics.dev.lwolf.com/auth",
                params: {
                    token: "token",
                    redirectAfterLogin: "redirect",
                    postData: true
                }
            }
        },
        id: "xam"
    },
    {
        version: 8,
        createdTimestamp: "2024-02-02T21:23:43.703Z",
        modifiedTimestamp: "2024-07-12T15:39:39.529Z",
        active: true,
        supportsBranding: false,
        config: {
            name: "BrokerMetrics",
            description: "Access market and business analytics",
            icon: "line_chart_loop",
            login: {
                url: "https://brokermetrics.dev.lwolf.com/auth",
                params: {
                    redirectAfterLogin: "redirect",
                    userId: "xbmUserId"
                }
            },
            connect: {
                url: "https://brokermetrics.dev.lwolf.com/connect"
            }
        },
        id: "xbm"
    },
    {
        version: 7,
        createdTimestamp: "2024-02-20T19:07:46.968Z",
        modifiedTimestamp: "2026-02-06T20:00:10.046Z",
        active: true,
        supportsBranding: false,
        config: {
            name: "Front Office",
            description: "Websites and automated marketing",
            icon: "person_frame",
            login: {
                url: "https://frontoffice.dev.lwolf.com/lw_login",
                params: {
                    token: "jwt",
                    redirectAfterLogin: "redirect_to",
                    userId: ""
                }
            }
        },
        id: "pbg"
    },
    {
        version: 2,
        createdTimestamp: "2025-05-22T18:19:14.336Z",
        modifiedTimestamp: "2025-09-05T16:13:24.228Z",
        active: true,
        supportsBranding: false,
        config: {
            name: "Leads+",
            description: "Find leads and clients",
            icon: "funnel_person",
            login: {
                params: {
                    redirectAfterLogin: "redirect"
                }
            }
        },
        id: "lp"
    },
    {
        version: 1,
        createdTimestamp: "2025-06-11T19:45:29.000Z",
        modifiedTimestamp: "2025-06-11T19:45:33.000Z",
        active: true,
        supportsBranding: false,
        config: {
            name: "Test Platform App",
            description: "Test Platform App",
            icon: "megaphone",
            login: {
                url: "https://d35clwvlbw7g8z.cloudfront.net/auth",
                params: {
                    token: "token",
                    redirectAfterLogin: "redirect"
                }
            },
            promotion: {
                url: "http://localhost:5173/auth",
                params: {
                    token: "token"
                }
            }
        },
        id: "test"
    },
    {
        version: 1,
        createdTimestamp: "2023-06-15T17:41:14.972Z",
        modifiedTimestamp: "2023-06-15T17:41:14.972Z",
        active: true,
        supportsBranding: false,
        config: {
            name: "Cloud CMA",
            description: "Create, schedule, and send CMAs",
            icon: "home_compare",
            login: {
                url: "http://localhost:3000/api/v1/platform_login",
                params: {
                    token: "token",
                    redirectAfterLogin: "r",
                    userId: "ccUserId"
                }
            },
            connect: {
                url: "http://localhost:3000/connect/lone_wolf"
            }
        },
        id: "cc"
    },
    {
        version: 4,
        createdTimestamp: "2023-06-15T17:41:14.972Z",
        modifiedTimestamp: "2023-10-18T20:57:41.254Z",
        active: true,
        supportsBranding: false,
        config: {
            name: "Back Office",
            description: "Manage back office and accounting",
            icon: "screen_percentage",
            login: {
                url: "https://backoffice.dev.lwolf.com",
                params: {
                    token: "lwa_token",
                    redirectAfterLogin: "redirect",
                    memberId: "bovMemberId",
                    clientId: "bovClientId"
                }
            }
        },
        id: "bov"
    },
    {
        version: 2,
        createdTimestamp: "2023-06-15T17:41:14.972Z",
        modifiedTimestamp: "2024-01-04T19:18:58.845Z",
        active: true,
        supportsBranding: false,
        config: {
            name: "Authentisign",
            description: "Create and complete eSignatures",
            icon: "signature",
            login: {
                url: "https://cloud.dev.authentisign.com/AutoInitSSO",
                params: {
                    token: "id_token",
                    redirectAfterLogin: "redirect_uri",
                    userId: "asUserId"
                }
            }
        },
        id: "as"
    },
    {
        version: 2,
        createdTimestamp: "2023-06-15T17:41:14.972Z",
        modifiedTimestamp: "2024-01-04T19:18:58.845Z",
        active: true,
        supportsBranding: false,
        config: {
            name: "Spacio",
            description: "Run digital open house sign-ins",
            icon: "open_door",
            login: {
                url: "",
                params: {
                    token: "lwtoken",
                    redirectAfterLogin: "redirect",
                    userId: "hssUserId"
                }
            },
            connect: {
                url: ""
            }
        },
        id: "hss"
    },
    {
        version: 7,
        createdTimestamp: "2023-06-15T17:41:14.972Z",
        modifiedTimestamp: "2024-03-07T19:53:13.076Z",
        active: true,
        supportsBranding: false,
        config: {
            name: "LionDesk",
            description: "Nurture leads with CRM and marketing",
            icon: "cog_person",
            login: {
                url: "https://authentication.stg.liondesk.info/api/v1/sso/validate-ul-token/",
                params: {
                    token: "token",
                    redirectAfterLogin: "ref",
                    userId: "ldUserId"
                }
            },
            connect: {
                url: "http://accounts.lvh.me:8083/signin?ref=http%3A%2F%2Faccounts.lvh.me%3A8083%2Fconnect-lone-wolf-account"
            }
        },
        id: "ld"
    },
    {
        version: 4,
        createdTimestamp: "2023-06-15T17:41:14.972Z",
        modifiedTimestamp: "2024-11-26T21:00:47.260Z",
        active: true,
        supportsBranding: false,
        config: {
            name: "zipForm",
            description: "Start, manage, and close deals",
            icon: "arrows_exchange",
            login: {
                url: "https://dev.zipformplus.com/services/UnifiedLogin.ashx",
                postData: true,
                params: {
                    token: "lwaToken",
                    redirectAfterLogin: "redirect",
                    userId: "zfpUserId"
                }
            }
        },
        id: "zfp"
    },
    {
        version: 7,
        createdTimestamp: "2023-06-15T17:41:14.972Z",
        modifiedTimestamp: "2024-11-26T21:00:47.267Z",
        active: true,
        supportsBranding: false,
        config: {
            name: "TransactionDesk",
            description: "Start, manage, and close deals",
            icon: "arrows_exchange",
            login: {
                url: "https://td2.dev.transactiondesk.com/external/unifiedlogin.ashx",
                postData: true,
                params: {
                    token: "lwaToken",
                    redirectAfterLogin: "redirect",
                    userId: "tdUserId"
                }
            }
        },
        id: "td"
    },
    {
        version: 3,
        createdTimestamp: "2024-01-24T15:10:33.078Z",
        modifiedTimestamp: "2025-09-24T19:00:03.493Z",
        active: true,
        supportsBranding: false,
        config: {
            name: "Contacts",
            description: "Manage all your contacts in one place",
            icon: "user",
            login: {
                url: "https://contacts.dev.lwolf.com",
                params: {
                    redirectAfterLogin: "",
                    userId: "csUserId"
                }
            }
        },
        id: "con"
    },
    {
        version: 2,
        createdTimestamp: "2023-06-15T17:41:14.972Z",
        modifiedTimestamp: "2024-01-04T19:18:58.845Z",
        active: true,
        supportsBranding: false,
        config: {
            name: "Cloud Attract",
            description: "Create custom landing pages for CMAs",
            icon: "screen_percentage",
            login: {
                url: "http://localhost:3300/api/v1/platform_login",
                params: {
                    token: "token",
                    redirectAfterLogin: "",
                    userId: "caUserId"
                }
            },
            connect: {
                url: "http://localhost:3300/connect/lone_wolf"
            }
        },
        id: "ca"
    },
    {
        version: 1,
        createdTimestamp: "2025-05-23T14:20:46.666Z",
        modifiedTimestamp: "2025-05-23T14:20:46.666Z",
        active: true,
        supportsBranding: false,
        config: {
            name: "E-commerce",
            description: "E-commerce",
            hidden: true,
            login: {
                url: "https://ecommerce.dev.lwolf.com",
                params: {
                    redirectAfterLogin: "redirect"
                }
            },
            promotion: {
                url: "https://ecommerce.dev.lwolf.com"
            }
        },
        id: "ecom"
    },
    {
        version: 3,
        createdTimestamp: "2023-06-15T17:41:14.972Z",
        modifiedTimestamp: "2025-06-18T15:53:55.511Z",
        active: true,
        supportsBranding: false,
        config: {
            name: "Boost",
            description: "Create and manage digital ads",
            icon: "megaphone",
            login: {
                url: "",
                params: {
                    token: "lwtoken",
                    redirectAfterLogin: "redirect",
                    userId: "hsbUserId"
                }
            },
            promotion: {
                url: "",
                params: {
                    token: "lwtoken"
                }
            }
        },
        id: "hsb"
    }
];
function $847bf9dc758b6d61$var$styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") return;
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) head.insertBefore(style, head.firstChild);
        else head.appendChild(style);
    } else head.appendChild(style);
    if (style.styleSheet) style.styleSheet.cssText = css;
    else style.appendChild(document.createTextNode(css));
}
var $847bf9dc758b6d61$var$css_248z$9 = ".SidebarNav-module_sidebar-nav__client-switcher__picker__L1Cmf{align-items:center;background-color:transparent;border:none;cursor:pointer;display:flex;font-size:14px;font-weight:600;gap:8px;white-space:nowrap}.SidebarNav-module_sidebar-nav-container--collapsed__UbfHl .SidebarNav-module_sidebar-nav__client-switcher__picker__L1Cmf{display:none}.SidebarNav-module_sidebar-nav__client-switcher__logo__BLWWE img{height:32px;width:32px}.SidebarNav-module_sidebar-nav__client-switcher__user__0toOM{flex:1;text-align:left}.SidebarNav-module_sidebar-nav__client-switcher__chevron__aLwd-{height:16px;width:16px}.SidebarNav-module_sidebar-nav__collapse-button__LTBf9{align-items:center;background-color:#fff;border:none;border-radius:50%;bottom:-16px;box-shadow:0 0 1px 0 rgba(0,0,0,.2),0 1px 2px 0 rgba(0,0,0,.1);cursor:pointer;display:flex;height:26px;justify-content:center;left:22px;position:absolute;transition:all .2s ease;width:26px;z-index:100}.SidebarNav-module_sidebar-nav__collapse-button__LTBf9:hover{background-color:var(--helix-brand-pale);color:var(--helix-brand)}.SidebarNav-module_sidebar-nav__collapse-button__LTBf9:focus{outline:2px solid var(--helix-brand);outline-offset:2px}.SidebarNav-module_sidebar-nav__collapse-button__LTBf9 .SidebarNav-module_sidebar-nav__collapse-button__icon__S1cYO{height:12px;width:12px}.SidebarNav-module_sidebar-nav-container__GtxjQ{background-color:#fff;transition:width .3s ease;width:300px}.SidebarNav-module_sidebar-nav-container__GtxjQ.SidebarNav-module_sidebar-nav-container--collapsed__UbfHl{width:68px}.SidebarNav-module_sidebar-nav-container__GtxjQ.SidebarNav-module_sidebar-nav-container--no-apps__2yYLy,.SidebarNav-module_sidebar-nav-container__GtxjQ.SidebarNav-module_sidebar-nav-container--no-apps__2yYLy.SidebarNav-module_sidebar-nav-container--collapsed__UbfHl{width:0}.SidebarNav-module_sidebar-nav-container__GtxjQ.SidebarNav-module_sidebar-nav-container--no-apps__2yYLy .SidebarNav-module_sidebar-nav__X7jOJ{border-right:none}.SidebarNav-module_sidebar-nav__X7jOJ{border-right:1px solid #e5e5e5;display:flex;flex-direction:column;flex-shrink:0;height:calc(100vh - 68px);list-style:none;margin:0;overflow:hidden;padding:0}.SidebarNav-module_sidebar-nav__X7jOJ .SidebarNav-module_sidebar-nav__panels__O5Q-n{display:flex;flex:1;flex-direction:row;height:100%;position:relative}.SidebarNav-module_sidebar-nav__X7jOJ .SidebarNav-module_sidebar-nav__panels__O5Q-n .SidebarNav-module_sidebar-nav__main__bc-hJ{align-items:center;border-right:1px solid #e5e5e5;display:flex;flex-direction:column;gap:16px;height:100%;max-width:68px;min-width:68px;overflow-y:auto;padding:32px 12px 12px;position:relative;scrollbar-width:none;width:68px;-ms-overflow-style:none}.SidebarNav-module_sidebar-nav__X7jOJ .SidebarNav-module_sidebar-nav__panels__O5Q-n .SidebarNav-module_sidebar-nav__main__bc-hJ .SidebarNav-module_sidebar-nav__item__xDiJL{align-items:center;background-color:transparent;border:none;border-radius:8px;color:#374151;cursor:pointer;display:flex;flex-direction:column;font-size:14px;font-size:10px;font-weight:500;gap:8px;padding:4px;text-transform:uppercase}.SidebarNav-module_sidebar-nav__X7jOJ .SidebarNav-module_sidebar-nav__panels__O5Q-n .SidebarNav-module_sidebar-nav__main__bc-hJ .SidebarNav-module_sidebar-nav__item__xDiJL:hover:not(.SidebarNav-module_sidebar-nav__item--active__sD3RE){background-color:var(--helix-brand-pale);color:var(--helix-brand)}.SidebarNav-module_sidebar-nav__X7jOJ .SidebarNav-module_sidebar-nav__panels__O5Q-n .SidebarNav-module_sidebar-nav__main__bc-hJ .SidebarNav-module_sidebar-nav__item__xDiJL:hover:not(.SidebarNav-module_sidebar-nav__item--active__sD3RE) svg path{fill:var(--helix-brand)}.SidebarNav-module_sidebar-nav__X7jOJ .SidebarNav-module_sidebar-nav__panels__O5Q-n .SidebarNav-module_sidebar-nav__main__bc-hJ .SidebarNav-module_sidebar-nav__item__xDiJL img{border-radius:6px}.SidebarNav-module_sidebar-nav__X7jOJ .SidebarNav-module_sidebar-nav__panels__O5Q-n .SidebarNav-module_sidebar-nav__main__bc-hJ .SidebarNav-module_sidebar-nav__item__xDiJL:focus{outline:2px solid var(--helix-brand);outline-offset:2px}.SidebarNav-module_sidebar-nav__X7jOJ .SidebarNav-module_sidebar-nav__panels__O5Q-n .SidebarNav-module_sidebar-nav__main__bc-hJ .SidebarNav-module_sidebar-nav__item__xDiJL.SidebarNav-module_sidebar-nav__item--active__sD3RE{background-color:var(--helix-brand-light);color:var(--helix-brand-pale);font-weight:600}.SidebarNav-module_sidebar-nav__X7jOJ .SidebarNav-module_sidebar-nav__panels__O5Q-n .SidebarNav-module_sidebar-nav__main__bc-hJ .SidebarNav-module_sidebar-nav__item__xDiJL.SidebarNav-module_sidebar-nav__item--active__sD3RE svg path{fill:#fff}.SidebarNav-module_sidebar-nav__X7jOJ .SidebarNav-module_sidebar-nav__panels__O5Q-n .SidebarNav-module_sidebar-nav__main__bc-hJ .SidebarNav-module_sidebar-nav__item__xDiJL .SidebarNav-module_sidebar-nav__item__icon__AvhW6{align-items:center;display:flex;height:28px;justify-content:center;width:28px}.SidebarNav-module_sidebar-nav__X7jOJ .SidebarNav-module_sidebar-nav__panels__O5Q-n .SidebarNav-module_sidebar-nav__main__bc-hJ .SidebarNav-module_sidebar-nav__item__xDiJL .SidebarNav-module_sidebar-nav__item__icon__AvhW6 svg{height:28px;width:28px}.SidebarNav-module_sidebar-nav-container--collapsed__UbfHl .SidebarNav-module_sidebar-nav__X7jOJ .SidebarNav-module_sidebar-nav__panels__O5Q-n .SidebarNav-module_sidebar-nav__main__bc-hJ .SidebarNav-module_sidebar-nav__item__xDiJL .SidebarNav-module_sidebar-nav__item__text__9T0M7{display:none}.SidebarNav-module_sidebar-nav__X7jOJ .SidebarNav-module_sidebar-nav__panels__O5Q-n .SidebarNav-module_sidebar-nav__main__bc-hJ .SidebarNav-module_sidebar-nav__item__xDiJL.SidebarNav-module_sidebar-nav__item--skeleton__ocwDB{background-color:transparent;cursor:default;pointer-events:none}.SidebarNav-module_sidebar-nav__X7jOJ .SidebarNav-module_sidebar-nav__panels__O5Q-n .SidebarNav-module_sidebar-nav__main__bc-hJ .SidebarNav-module_sidebar-nav__item__xDiJL.SidebarNav-module_sidebar-nav__item--skeleton__ocwDB:hover{background-color:transparent;color:inherit}.SidebarNav-module_sidebar-nav__X7jOJ .SidebarNav-module_sidebar-nav__panels__O5Q-n .SidebarNav-module_sidebar-nav__main__bc-hJ .SidebarNav-module_sidebar-nav__item__xDiJL.SidebarNav-module_sidebar-nav__item--skeleton__ocwDB:hover svg path{fill:inherit}.SidebarNav-module_sidebar-nav__X7jOJ .SidebarNav-module_sidebar-nav__panels__O5Q-n .SidebarNav-module_sidebar-nav__main__bc-hJ .SidebarNav-module_sidebar-nav__item__xDiJL.SidebarNav-module_sidebar-nav__item--apps__-W6ee{background-color:var(--helix-gray-100);margin-top:20px}.SidebarNav-module_sidebar-nav__X7jOJ .SidebarNav-module_sidebar-nav__panels__O5Q-n .SidebarNav-module_sidebar-nav__main__bc-hJ .SidebarNav-module_sidebar-nav__item__xDiJL.SidebarNav-module_sidebar-nav__item--apps__-W6ee:hover{background-color:var(--helix-gray-100)}.SidebarNav-module_sidebar-nav__X7jOJ .SidebarNav-module_sidebar-nav__panels__O5Q-n .SidebarNav-module_sidebar-nav__secondary__dZ-xl{display:flex;flex:1;flex-direction:column;height:100%;overflow:hidden;position:relative;width:calc(100% - 60px)}.SidebarNav-module_sidebar-nav-container--collapsed__UbfHl .SidebarNav-module_sidebar-nav__X7jOJ .SidebarNav-module_sidebar-nav__panels__O5Q-n .SidebarNav-module_sidebar-nav__secondary__dZ-xl{display:none;width:0}.SidebarNav-module_sidebar-nav__X7jOJ .SidebarNav-module_sidebar-nav__panels__O5Q-n .SidebarNav-module_sidebar-nav__secondary__dZ-xl .SidebarNav-module_sidebar-nav__secondary__header__uvG96{align-items:center;color:var(--helix-gray-900);display:flex;font-size:12px;font-size:16px;font-weight:600;justify-content:space-between;line-height:22px;margin-bottom:4px;margin-top:4px;padding:12px}.SidebarNav-module_sidebar-nav__X7jOJ .SidebarNav-module_sidebar-nav__panels__O5Q-n .SidebarNav-module_sidebar-nav__secondary__dZ-xl .SidebarNav-module_sidebar-nav__links__nlLkV{display:flex;flex-direction:column;gap:4px;overflow-y:auto;padding:4px 16px;scrollbar-width:none;-ms-overflow-style:none}.SidebarNav-module_sidebar-nav__X7jOJ .SidebarNav-module_sidebar-nav__panels__O5Q-n .SidebarNav-module_sidebar-nav__secondary__dZ-xl .SidebarNav-module_sidebar-nav__links__nlLkV::-webkit-scrollbar{display:none}.SidebarNav-module_sidebar-nav__X7jOJ .SidebarNav-module_sidebar-nav__panels__O5Q-n .SidebarNav-module_sidebar-nav__secondary__dZ-xl .SidebarNav-module_sidebar-nav__links__nlLkV .SidebarNav-module_sidebar-nav-item__9cvhp{display:flex}.SidebarNav-module_sidebar-nav__X7jOJ .SidebarNav-module_sidebar-nav__panels__O5Q-n .SidebarNav-module_sidebar-nav__secondary__dZ-xl .SidebarNav-module_sidebar-nav__links__nlLkV .SidebarNav-module_sidebar-nav-item__9cvhp a{align-items:center;border-radius:6px;color:var(--helix-gray-600);display:flex;flex-shrink:0;font-size:14px;font-weight:600;justify-content:space-between;line-height:20px;padding:8px;text-decoration:none;width:100%}.SidebarNav-module_sidebar-nav__X7jOJ .SidebarNav-module_sidebar-nav__panels__O5Q-n .SidebarNav-module_sidebar-nav__secondary__dZ-xl .SidebarNav-module_sidebar-nav__links__nlLkV .SidebarNav-module_sidebar-nav-item__9cvhp a.SidebarNav-module_sidebar-nav__link--active__GEicU{background-color:var(--helix-brand-pale);color:var(--helix-brand)}.SidebarNav-module_sidebar-nav__X7jOJ .SidebarNav-module_sidebar-nav__panels__O5Q-n .SidebarNav-module_sidebar-nav__secondary__dZ-xl .SidebarNav-module_sidebar-nav__links__nlLkV .SidebarNav-module_sidebar-nav-item__9cvhp a:hover{background-color:var(--helix-brand-pale);color:var(--helix-brand);text-decoration:none}.SidebarNav-module_sidebar-nav__X7jOJ .SidebarNav-module_sidebar-nav__panels__O5Q-n .SidebarNav-module_sidebar-nav__secondary__dZ-xl .SidebarNav-module_sidebar-nav__links__nlLkV .SidebarNav-module_sidebar-nav-item__9cvhp a:focus{outline:2px solid var(--helix-brand);outline-offset:2px}.SidebarNav-module_sidebar-nav__X7jOJ .SidebarNav-module_sidebar-nav__panels__O5Q-n .SidebarNav-module_sidebar-nav__secondary__dZ-xl .SidebarNav-module_sidebar-nav__links__nlLkV .SidebarNav-module_sidebar-nav-item__9cvhp a .SidebarNav-module_sidebar-nav__link__count__KdbH4{align-items:center;border:1px solid var(--helix-gray-200);border-radius:4px;color:var(--helix-primary);display:flex;font-size:12px;justify-content:center;padding:2px 6px}.SidebarNav-module_sidebar-nav__X7jOJ .SidebarNav-module_sidebar-nav__panels__O5Q-n .SidebarNav-module_sidebar-nav__secondary__dZ-xl .SidebarNav-module_sidebar-nav__links__nlLkV .SidebarNav-module_sidebar-nav-item__9cvhp.SidebarNav-module_active__6jC-x a{background-color:var(--helix-brand-pale);color:var(--helix-brand)!important}.SidebarNav-module_sidebar-nav__X7jOJ .SidebarNav-module_sidebar-nav__panels__O5Q-n hr{border:none;border-top:1px solid #e5e5e5;margin:0;width:100%}@keyframes SidebarNav-module_skeleton-pulse__ohHUb{0%{opacity:1}50%{opacity:.6}to{opacity:1}}.SidebarNav-module_sidebar-nav__skeleton-icon__hWGt7{animation:SidebarNav-module_skeleton-pulse__ohHUb 1.5s ease-in-out infinite;background-color:var(--helix-gray-200);border-radius:4px;height:28px;width:28px}.SidebarNav-module_helix-application-header__wHNXX{align-items:center;background-color:#fff;border-bottom:1px solid #e5e5e5;display:flex;height:68px;padding:0 16px;position:relative;width:100%}.SidebarNav-module_helix-application-header__btn__ufoWV{align-items:center;background-color:transparent;border:none;border-radius:6px;color:inherit;display:inline-flex;flex:0 0 auto;padding:8px!important}.SidebarNav-module_helix-application-header__btn__ufoWV:hover{background-color:var(--helix-brand-pale);color:var(--helix-brand)}.SidebarNav-module_helix-application-header__btn__ufoWV:hover svg path{fill:var(--helix-brand)!important}.SidebarNav-module_helix-application-header__btn__ufoWV:focus{outline:2px solid var(--helix-brand);outline-offset:2px}.SidebarNav-module_helix-application-header__btn__ufoWV:focus svg path{fill:var(--helix-brand)!important}.SidebarNav-module_helix-application-header__btn__ufoWV[aria-expanded=true]{background-color:var(--helix-gray-200);color:var(--helix-brand)}.helix-unified-nav_help-link[aria-expanded=true]{background-color:transparent!important;color:inherit!important}.helix-unified-nav_help-link[aria-expanded=true] svg path{fill:currentColor!important}.SidebarNav-module_sidebar-nav__client-switcher__dropdown-menu__nL9dm{background-color:#fff;border:1px solid #ccc;border-radius:4px;box-shadow:0 2px 8px rgba(0,0,0,.15);min-width:200px;opacity:0;pointer-events:none;position:absolute;transition:opacity .2s ease,transform .2s ease;z-index:1000}.SidebarNav-module_sidebar-nav__client-switcher__dropdown-menu__nL9dm:focus{outline:none}.SidebarNav-module_sidebar-nav__client-switcher__dropdown-menu__nL9dm.SidebarNav-module_open__38iIR{opacity:1;pointer-events:auto}.SidebarNav-module_sidebar-nav__client-switcher__dropdown-menu__nL9dm.SidebarNav-module_bottom__bVrKA{margin-top:8px;transform:translateY(-8px)}.SidebarNav-module_sidebar-nav__client-switcher__dropdown-menu__nL9dm.SidebarNav-module_bottom__bVrKA.SidebarNav-module_open__38iIR{transform:translateY(0)}.SidebarNav-module_sidebar-nav__client-switcher__dropdown-menu__nL9dm.SidebarNav-module_top__If2Sq{margin-bottom:8px;transform:translateY(8px)}.SidebarNav-module_sidebar-nav__client-switcher__dropdown-menu__nL9dm.SidebarNav-module_top__If2Sq.SidebarNav-module_open__38iIR{transform:translateY(0)}.SidebarNav-module_sidebar-nav__client-switcher__dropdown-menu__nL9dm.SidebarNav-module_right__GulWj{margin-left:8px;transform:translateX(-8px)}.SidebarNav-module_sidebar-nav__client-switcher__dropdown-menu__nL9dm.SidebarNav-module_right__GulWj.SidebarNav-module_open__38iIR{transform:translateX(0)}.SidebarNav-module_sidebar-nav__client-switcher__dropdown-menu__nL9dm.SidebarNav-module_left__fhifk{margin-right:8px;transform:translateX(8px)}.SidebarNav-module_sidebar-nav__client-switcher__dropdown-menu__nL9dm.SidebarNav-module_left__fhifk.SidebarNav-module_open__38iIR{transform:translateX(0)}.SidebarNav-module_sidebar-nav__client-switcher__dropdown-menu__nL9dm ul{list-style:none;margin:0;padding:8px}.SidebarNav-module_sidebar-nav__client-switcher__dropdown-menu__nL9dm .SidebarNav-module_sidebar-nav__client-switcher__section-separator__yLoM2{background-color:#e5e5e5;height:1px;margin:8px 0}.SidebarNav-module_sidebar-nav__client-switcher__dropdown-menu__nL9dm .SidebarNav-module_sidebar-nav__client-switcher__section-header__FSXae{color:#4b5563;font-size:12px;letter-spacing:.1em;padding:8px;text-transform:uppercase}.SidebarNav-module_sidebar-nav__client-switcher__dropdown-menu__nL9dm .SidebarNav-module_sidebar-nav__client-switcher__dropdown-item__1etIZ{border-radius:4px;cursor:pointer;margin-bottom:2px;padding:8px 12px}.SidebarNav-module_sidebar-nav__client-switcher__dropdown-menu__nL9dm .SidebarNav-module_sidebar-nav__client-switcher__dropdown-item__1etIZ.SidebarNav-module_sidebar-nav__client-switcher__dropdown-item--highlighted__1QDl9,.SidebarNav-module_sidebar-nav__client-switcher__dropdown-menu__nL9dm .SidebarNav-module_sidebar-nav__client-switcher__dropdown-item__1etIZ.SidebarNav-module_sidebar-nav__client-switcher__dropdown-item--selected-client__8xywa,.SidebarNav-module_sidebar-nav__client-switcher__dropdown-menu__nL9dm .SidebarNav-module_sidebar-nav__client-switcher__dropdown-item__1etIZ:hover{background-color:var(--helix-brand-pale);color:var(--helix-brand)}.SidebarNav-module_sidebar-nav__client-switcher__dropdown-menu__nL9dm .SidebarNav-module_sidebar-nav__client-switcher__client-menu-item__Feie3{align-items:center;display:flex;gap:8px}.SidebarNav-module_sidebar-nav__client-switcher__dropdown-menu__nL9dm .SidebarNav-module_sidebar-nav__client-switcher__client-avatar__AnRxt{border-radius:12px;height:24px;object-fit:cover;width:24px}.SidebarNav-module_sidebar-nav__client-switcher__dropdown-menu__nL9dm .SidebarNav-module_sidebar-nav__client-switcher__client-text__K8kNx{display:flex;flex:1;flex-direction:column;gap:2px}.SidebarNav-module_sidebar-nav__client-switcher__dropdown-menu__nL9dm .SidebarNav-module_sidebar-nav__client-switcher__item-label__OUE9-{color:#374151;font-size:14px;font-weight:500}.SidebarNav-module_sidebar-nav__client-switcher__dropdown-menu__nL9dm .SidebarNav-module_sidebar-nav__client-switcher__description__ffKuf{color:#6b7280;font-size:12px}.SidebarNav-module_sidebar-nav__client-switcher__dropdown-menu__nL9dm .SidebarNav-module_sidebar-nav__client-switcher__client-right__Yp-xB{align-items:center;display:flex}.SidebarNav-module_sidebar-nav__client-switcher__dropdown-menu__nL9dm .SidebarNav-module_sidebar-nav__client-switcher__checkmark__Iu7T7{color:var(--helix-brand);font-weight:700}.SidebarNav-module_sidebar-nav__client-switcher__dropdown-menu__nL9dm .SidebarNav-module_sidebar-nav__client-switcher__switch-link__2q50g{color:var(--helix-brand);font-size:12px;font-weight:500}.SidebarNav-module_sidebar-nav__client-switcher__dropdown-menu__nL9dm .SidebarNav-module_sidebar-nav__client-switcher__app-menu-item__TU8G-{align-items:center;display:flex;gap:8px}.SidebarNav-module_sidebar-nav__client-switcher__dropdown-menu__nL9dm .SidebarNav-module_sidebar-nav__client-switcher__app-icon__X1jvd{height:24px;object-fit:cover;width:24px}.SidebarNav-module_sidebar-nav__client-switcher__dropdown-menu__nL9dm .SidebarNav-module_sidebar-nav__client-switcher__app-text__mKJPg{display:flex;flex:1;flex-direction:column;gap:2px}.SidebarNav-module_sidebar-nav__bottom__0ygS2{align-items:center;border-top:1px solid #e5e5e5;display:flex;justify-content:center;padding:16px 0}.SidebarNav-module_sidebar-nav__add-button__GOA8K{align-items:center;background-color:var(--helix-gray-100);border:none;border-radius:12px;cursor:pointer;display:flex;justify-content:center;padding:8px;transition:background-color .2s ease}.SidebarNav-module_sidebar-nav__add-button__GOA8K:hover{background-color:var(--helix-gray-100)}.SidebarNav-module_sidebar-nav__add-icon__gNZCe{fill:var(--helix-brand);height:24px;width:24px}.SidebarNav-module_sidebar-nav__secondary__dZ-xl{scrollbar-width:none;-ms-overflow-style:none}.SidebarNav-module_sidebar-nav__secondary__dZ-xl::-webkit-scrollbar{display:none}";
var $847bf9dc758b6d61$var$SidebarNavStyles = {
    "sidebar-nav-container--collapsed": "SidebarNav-module_sidebar-nav-container--collapsed__UbfHl",
    "sidebar-nav__collapse-button": "SidebarNav-module_sidebar-nav__collapse-button__LTBf9",
    "sidebar-nav__collapse-button__icon": "SidebarNav-module_sidebar-nav__collapse-button__icon__S1cYO",
    "sidebar-nav-container": "SidebarNav-module_sidebar-nav-container__GtxjQ",
    "sidebar-nav-container--no-apps": "SidebarNav-module_sidebar-nav-container--no-apps__2yYLy",
    "sidebar-nav": "SidebarNav-module_sidebar-nav__X7jOJ",
    "sidebar-nav__panels": "SidebarNav-module_sidebar-nav__panels__O5Q-n",
    "sidebar-nav__main": "SidebarNav-module_sidebar-nav__main__bc-hJ",
    "sidebar-nav__item": "SidebarNav-module_sidebar-nav__item__xDiJL",
    "sidebar-nav__item--active": "SidebarNav-module_sidebar-nav__item--active__sD3RE",
    "sidebar-nav__item__icon": "SidebarNav-module_sidebar-nav__item__icon__AvhW6",
    "sidebar-nav__item--skeleton": "SidebarNav-module_sidebar-nav__item--skeleton__ocwDB",
    "sidebar-nav__item--apps": "SidebarNav-module_sidebar-nav__item--apps__-W6ee",
    "sidebar-nav__secondary": "SidebarNav-module_sidebar-nav__secondary__dZ-xl",
    "sidebar-nav__secondary__header": "SidebarNav-module_sidebar-nav__secondary__header__uvG96",
    "sidebar-nav__links": "SidebarNav-module_sidebar-nav__links__nlLkV",
    "sidebar-nav-item": "SidebarNav-module_sidebar-nav-item__9cvhp",
    "active": "SidebarNav-module_active__6jC-x",
    "sidebar-nav__skeleton-icon": "SidebarNav-module_sidebar-nav__skeleton-icon__hWGt7",
    "helix-application-header": "SidebarNav-module_helix-application-header__wHNXX",
    "helix-application-header__btn": "SidebarNav-module_helix-application-header__btn__ufoWV"
};
$847bf9dc758b6d61$var$styleInject($847bf9dc758b6d61$var$css_248z$9);
var $847bf9dc758b6d61$var$css_248z$8 = '.Tooltip-module_helix-tooltip__nQCem{background-color:var(--helix-tooltip-background,#333);border-radius:4px;color:var(--helix-tooltip-text,#fff);font-size:12px;font-weight:400;line-height:16px;opacity:0;padding:6px;position:relative;transition:opacity .4s ease-in-out .2s;z-index:1070}.Tooltip-module_is-open__rTdhe{opacity:1}.Tooltip-module_helix-tooltip__arrow__OPEuy{height:0;position:absolute;width:0}.Tooltip-module_helix-tooltip__arrow__OPEuy:before{border-color:transparent var(--helix-tooltip-background,#333) transparent transparent;border-style:solid;border-width:6px 6px 6px 0;content:"";position:absolute}.Tooltip-module_helix-tooltip__nQCem[data-popper-placement^=top] .Tooltip-module_helix-tooltip__arrow__OPEuy{bottom:0}.Tooltip-module_helix-tooltip__nQCem[data-popper-placement^=top] .Tooltip-module_helix-tooltip__arrow__OPEuy:before{border-color:transparent transparent var(--helix-tooltip-background,#333) transparent;border-width:0 6px 6px;left:-5px;transform:rotate(180deg)}.Tooltip-module_helix-tooltip__nQCem[data-popper-placement^=bottom] .Tooltip-module_helix-tooltip__arrow__OPEuy{top:-6px}.Tooltip-module_helix-tooltip__nQCem[data-popper-placement^=bottom] .Tooltip-module_helix-tooltip__arrow__OPEuy:before{border-color:transparent transparent var(--helix-tooltip-background,#333) transparent;border-width:0 6px 6px;left:-5px}.Tooltip-module_helix-tooltip__nQCem[data-popper-placement^=left] .Tooltip-module_helix-tooltip__arrow__OPEuy{right:0}.Tooltip-module_helix-tooltip__nQCem[data-popper-placement^=left] .Tooltip-module_helix-tooltip__arrow__OPEuy:before{border-color:transparent transparent transparent var(--helix-tooltip-background,#333);border-width:6px 0 6px 6px;top:-5px}.Tooltip-module_helix-tooltip__nQCem[data-popper-placement^=right] .Tooltip-module_helix-tooltip__arrow__OPEuy{left:-6px}.Tooltip-module_helix-tooltip__nQCem[data-popper-placement^=right] .Tooltip-module_helix-tooltip__arrow__OPEuy:before{border-color:transparent var(--helix-tooltip-background,#333) transparent transparent;border-width:6px 6px 6px 0;top:-5px}.Tooltip-module_helix-tooltip__nQCem[data-popper-reference-hidden=true] .Tooltip-module_helix-tooltip__arrow__OPEuy{visibility:hidden}\n/*# sourceMappingURL=data:application/json;base64,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 */';
var $847bf9dc758b6d61$var$scss = {
    "helix-tooltip": "Tooltip-module_helix-tooltip__nQCem",
    "is-open": "Tooltip-module_is-open__rTdhe",
    "helix-tooltip__arrow": "Tooltip-module_helix-tooltip__arrow__OPEuy"
};
$847bf9dc758b6d61$var$styleInject($847bf9dc758b6d61$var$css_248z$8);
const $847bf9dc758b6d61$var$ToolTip = (0, $acw62.forwardRef)((_a, ref)=>{
    var _b, _c;
    var { placement: placement = "auto", children: children, target: target, autoHide: autoHide = true, popperModifiers: popperModifiers, theme: theme, popperOptions: popperOptions = {
        strategy: "absolute"
    }, usePortal: usePortal } = _a, rest = $847bf9dc758b6d61$var$__rest$1(_a, [
        "placement",
        "children",
        "target",
        "autoHide",
        "popperModifiers",
        "theme",
        "popperOptions",
        "usePortal"
    ]);
    const [referenceElement, setReferenceElement] = (0, $acw62.useState)(null);
    const [popperElement, setPopperElement] = (0, $acw62.useState)(null);
    const [arrowElement, setArrowElement] = (0, $acw62.useState)(null);
    const [open, setOpen] = (0, $acw62.useState)(false);
    const [mounted, setMounted] = (0, $acw62.useState)(false);
    const [isOpening, setIsOpening] = (0, $acw62.useState)(false);
    const tooltipHovered = (0, $acw62.useRef)(false);
    const getPopperModifiers = ()=>{
        return popperModifiers && popperModifiers.length > 0 ? popperModifiers : [];
    };
    const { styles: popperStyles, attributes: attributes } = (0, $015b708b39a59435$export$f4d5bf230a36dd6e)(referenceElement, popperElement, Object.assign(Object.assign({
        placement: placement
    }, popperOptions), {
        modifiers: [
            {
                name: "offset",
                options: {
                    offset: [
                        0,
                        8
                    ]
                }
            },
            {
                name: "arrow",
                options: {
                    element: arrowElement
                }
            },
            ...getPopperModifiers()
        ]
    }));
    const handleMouseEnterPopover = ()=>{
        if (autoHide) return;
        tooltipHovered.current = true;
    };
    const handleMouseLeavePopover = ()=>{
        if (autoHide) return;
        setIsOpening(false);
        tooltipHovered.current = false;
        setTimeout(()=>{
            setOpen(false);
        }, 200);
    };
    const handleMouseEnter = ()=>{
        setOpen(true);
        setIsOpening(true);
    };
    const handleMouseLeave = ()=>{
        setTimeout(()=>{
            if (!tooltipHovered.current) {
                setIsOpening(false);
                setTimeout(()=>{
                    setOpen(false);
                }, 200);
            }
        }, 100);
    };
    const handleKeyDown = (e)=>{
        if (e.key === "Escape") setOpen(false);
    };
    const handleScroll = ()=>{
        setOpen(false);
        setIsOpening(false);
    };
    (0, $acw62.useEffect)(()=>{
        if (!target || typeof target !== "object" && typeof target !== "string") return;
        const targetAsMutableRef = target;
        const targetElement = typeof target === "object" ? targetAsMutableRef.current ? target === null || target === void 0 ? void 0 : target.current : target : document.getElementById(target);
        if (!targetElement) return;
        setReferenceElement(targetElement);
        if (!mounted) return;
        // Delay event listener attachment to prevent immediate mouseenter on page load
        const timeoutId = setTimeout(()=>{
            targetElement.addEventListener("mouseenter", handleMouseEnter);
            targetElement.addEventListener("mouseleave", handleMouseLeave);
            targetElement.addEventListener("focus", handleMouseEnter);
            targetElement.addEventListener("blur", handleMouseLeave);
            targetElement.addEventListener("keydown", handleKeyDown);
            // Add scroll listeners to close tooltip on scroll
            window.addEventListener("scroll", handleScroll, true);
            document.addEventListener("scroll", handleScroll, true);
        }, 200);
        return ()=>{
            clearTimeout(timeoutId);
            targetElement.removeEventListener("mouseenter", handleMouseEnter);
            targetElement.removeEventListener("mouseleave", handleMouseLeave);
            targetElement.removeEventListener("focus", handleMouseEnter);
            targetElement.removeEventListener("blur", handleMouseLeave);
            targetElement.removeEventListener("keydown", handleKeyDown);
            // Remove scroll listeners
            window.removeEventListener("scroll", handleScroll, true);
            document.removeEventListener("scroll", handleScroll, true);
        };
    }, [
        target,
        mounted
    ]);
    (0, $acw62.useEffect)(()=>{
        setMounted(true);
        return ()=>{
            setMounted(false);
        };
    }, []);
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            api: {
                open: ()=>{
                    setOpen(true);
                },
                close: ()=>{
                    setOpen(false);
                },
                toggle: ()=>{
                    setOpen(!open);
                }
            }
        }));
    const cssVars = {
        "--helix-tooltip-background": theme && ((_b = theme.tooltip) === null || _b === void 0 ? void 0 : _b.backgroundColor) || undefined,
        "--helix-tooltip-text": theme && ((_c = theme.tooltip) === null || _c === void 0 ? void 0 : _c.textColor) || undefined
    };
    const tooltipElement = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        ref: setPopperElement,
        className: [
            $847bf9dc758b6d61$var$scss["helix-tooltip"],
            isOpening && open ? $847bf9dc758b6d61$var$scss["is-open"] : ""
        ].filter(Boolean).join(" "),
        style: Object.assign(Object.assign({}, popperStyles.popper || {}), cssVars),
        onMouseEnter: ()=>handleMouseEnterPopover(),
        onMouseLeave: ()=>handleMouseLeavePopover(),
        role: "tooltip"
    }, attributes.popper, rest), children, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: setArrowElement,
        className: $847bf9dc758b6d61$var$scss["helix-tooltip__arrow"],
        style: popperStyles.arrow
    }));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, open && (usePortal ? (0, $1u0KT.createPortal)(tooltipElement, document.body) : tooltipElement));
});
$847bf9dc758b6d61$var$ToolTip.displayName = "Tooltip";
const $847bf9dc758b6d61$var$apiDomains = {
    dev: "https://platform.api.dev.lwolf.com",
    stg: "https://platform.api.stg.lwolf.com",
    pre: "https://platform.api.pre.lwolf.com",
    prod: "https://platform.api.lwolf.com"
};
const $847bf9dc758b6d61$var$useBranding = ({ environment: environment = "dev", localStorageTokenKey: localStorageTokenKey = "lwaToken", userToken: userToken = "", activeClientId: activeClientId = "" })=>{
    let brandingCache = null;
    const [branding, setBranding] = (0, $acw62.useState)(brandingCache);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    // New format: lwaToken_{env.}lwolf.com
    const newTokenCookieName = environment === "prod" ? "lwaToken_lwolf.com" : `lwaToken_${environment}.lwolf.com`;
    // Fallback format: lwaToken@@{env.}lwolf.com
    const fallbackTokenCookieName = environment === "prod" ? "lwaToken@@lwolf.com" : `lwaToken@@${environment}.lwolf.com`;
    const getTokenFromCookie = ()=>{
        if (!document || !document.cookie) return "";
        const cookies = document.cookie.split(";");
        // First try the new format
        const newFormatCookie = cookies.find((item)=>item.trim().startsWith(newTokenCookieName));
        if (newFormatCookie) return newFormatCookie.split("=")[1] || "";
        // Fall back to the old format
        const fallbackCookie = cookies.find((item)=>item.trim().startsWith(fallbackTokenCookieName));
        if (fallbackCookie) return fallbackCookie.split("=")[1] || "";
        return "";
    };
    const tokenCookie = getTokenFromCookie();
    const getUserToken = ()=>{
        // get the token from the local storage or the cookie or the userToken
        return typeof window !== "undefined" ? window.localStorage.getItem(localStorageTokenKey) || tokenCookie || userToken : "";
    };
    const token = getUserToken();
    const APIEndPoint = `${$847bf9dc758b6d61$var$apiDomains[environment]}/v1/clients/${activeClientId}/branding`;
    const fetchBranding = ()=>$847bf9dc758b6d61$var$__awaiter$1(void 0, void 0, void 0, function*() {
            try {
                setIsLoading(true);
                const res = yield fetch(APIEndPoint, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                if (!res.ok) console.log(`Failed to fetch branding: ${res.status}`);
                const data = yield res.json();
                brandingCache = data;
                setBranding(data);
            } catch (error) {
                console.error(error);
            } finally{
                setIsLoading(false);
            }
        });
    (0, $acw62.useEffect)(()=>{
        if (!activeClientId || branding) return;
        fetchBranding();
    }, [
        environment,
        activeClientId
    ]);
    return {
        branding: branding,
        setBranding: setBranding,
        isLoading: isLoading
    };
};
const $847bf9dc758b6d61$var$SidebarNavbarContext = (0, $acw62.createContext)({
    localStorageTokenKey: "lwaToken"
});
const $847bf9dc758b6d61$export$a90fbcf8ec455384 = $847bf9dc758b6d61$var$SidebarNavbarContext.Consumer;
const $847bf9dc758b6d61$export$fb39bcb53ef4b84d = ({ environment: environment, localStorageTokenKey: localStorageTokenKey = "lwaToken", applicationCode: applicationCode, children: children, platformService: platformService, useMockData: useMockData = false, userToken: userToken, activeClientId: activeClientId })=>{
    const [currentApplicationName, setCurrentApplicationName] = (0, $acw62.useState)("");
    const [currentAppConnections, setCurrentAppConnections] = (0, $acw62.useState)();
    const [appConnectionsFull, setAppConnectionsFull] = (0, $acw62.useState)([]);
    const [appData, setAppData] = (0, $acw62.useState)([]);
    const [lwaClients, setLwaClients] = (0, $acw62.useState)([]);
    const [clientsAsConnections, setClientsAsConnections] = (0, $acw62.useState)([]);
    const [platformDataLoading, setPlatformDataLoading] = (0, $acw62.useState)(true);
    const [activeClientIdState, setActiveClientIdState] = (0, $acw62.useState)(activeClientId);
    const [userMenuItems, setUserMenuItems] = (0, $acw62.useState)([]);
    const [userMenuLocation, setUserMenuLocation] = (0, $acw62.useState)("");
    const [userMenuLinkWrapper, setUserMenuLinkWrapper] = (0, $acw62.useState)(null);
    const [userInfo, setUserInfo] = (0, $acw62.useState)(null);
    // Use the useBranding hook for branding state
    const { branding: branding, setBranding: setBranding, isLoading: brandingLoading } = $847bf9dc758b6d61$var$useBranding({
        environment: environment,
        localStorageTokenKey: localStorageTokenKey,
        userToken: userToken,
        activeClientId: activeClientId
    });
    // Fetch platform service data
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const fetchPlatformData = ()=>$847bf9dc758b6d61$var$__awaiter$1(void 0, void 0, void 0, function*() {
                if (useMockData) {
                    setPlatformDataLoading(false);
                    return;
                }
                if (!platformService) return;
                try {
                    setPlatformDataLoading(true);
                    const [appDataResult, lwaClientsResult, clientsAsConnectionsResult, connectionsResult] = yield Promise.all([
                        platformService.getAppData(),
                        platformService.getLwaClients(),
                        platformService.getClientsAsConnections(),
                        platformService.getConnections()
                    ]);
                    // Filter out hidden apps
                    const appDataFiltered = appDataResult === null || appDataResult === void 0 ? void 0 : appDataResult.filter((app)=>!app.config.hidden);
                    setAppData(appDataFiltered || []);
                    setLwaClients(lwaClientsResult || []);
                    setClientsAsConnections(clientsAsConnectionsResult || []);
                    const activeClientIdFromPlatform = yield platformService.getActiveClientId();
                    if (activeClientIdFromPlatform) setActiveClientIdState && setActiveClientIdState(activeClientIdFromPlatform);
                    if (activeClientId && !activeClientIdFromPlatform && platformService.setLastActiveClientId && typeof platformService.setLastActiveClientId === "function") yield platformService.setLastActiveClientId(activeClientId !== null && activeClientId !== void 0 ? activeClientId : "").catch((error)=>{
                        console.error("Error setting last active client ID:", error);
                    });
                    else console.warn("setLastActiveClientId method not available on platformService");
                    // Filter connections to only include apps that exist in appDataFiltered
                    const filteredConnections = connectionsResult === null || connectionsResult === void 0 ? void 0 : connectionsResult.filter((connection)=>appDataFiltered === null || appDataFiltered === void 0 ? void 0 : appDataFiltered.some((app)=>app.id === connection.appId));
                    setCurrentAppConnections(filteredConnections);
                    setAppConnectionsFull(connectionsResult);
                } catch (error) {
                    console.error("Error loading platform data:", error);
                } finally{
                    setPlatformDataLoading(false);
                }
            });
        fetchPlatformData();
    }, [
        platformService,
        useMockData
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($847bf9dc758b6d61$var$SidebarNavbarContext.Provider, {
        value: {
            activeClientId: activeClientIdState,
            setActiveClientId: setActiveClientIdState,
            environment: environment,
            localStorageTokenKey: localStorageTokenKey,
            applicationCode: applicationCode,
            platformService: platformService,
            applicationName: currentApplicationName,
            setApplicationName: setCurrentApplicationName,
            appConnections: currentAppConnections,
            setAppConnections: setCurrentAppConnections,
            appConnectionsFull: appConnectionsFull,
            setAppConnectionsFull: setAppConnectionsFull,
            appData: appData,
            lwaClients: lwaClients,
            clientsAsConnections: clientsAsConnections,
            platformDataLoading: platformDataLoading,
            useMockData: useMockData,
            mockClients: $847bf9dc758b6d61$var$mockClients,
            mockAppConnections: $847bf9dc758b6d61$var$mockAppConnections,
            mockAppData: $847bf9dc758b6d61$var$mockAppData,
            setUserMenuItems: setUserMenuItems,
            setUserMenuLocation: setUserMenuLocation,
            setUserMenuLinkWrapper: setUserMenuLinkWrapper,
            setUserInfo: setUserInfo,
            userToken: userToken,
            branding: branding,
            setBranding: setBranding,
            brandingLoading: brandingLoading
        }
    }, children);
};
const $847bf9dc758b6d61$var$buildProductLaunchUrl$1 = (env, connection, luParamValue)=>{
    // env should be one of: dev, stg, pre, prod
    // For prod, omit the env part: https://platform.lwolf.com
    // For others: https://platform.{env}.lwolf.com
    const baseUrl = env === "prod" ? "https://platform.lwolf.com" : `https://platform.${env}.lwolf.com`;
    let url;
    if (connection.platformClient && connection.clientId === null) {
        const platformClientConnection = connection;
        url = `${baseUrl}/product/launch?a=${platformClientConnection.appId}`;
    } else if (connection.platformClient) {
        const platformClientConnection = connection;
        url = `${baseUrl}/product/launch?a=${platformClientConnection.appId}&ac=${platformClientConnection.clientId}`;
    } else if (connection.clientId != null) {
        const clientConnection = connection;
        url = `${baseUrl}/product/launch?a=${clientConnection.appId}&c=${clientConnection.clientId}&m=${clientConnection.memberId}`;
    } else if (connection.userId != null) {
        const userConnection = connection;
        url = `${baseUrl}/product/launch?a=${userConnection.appId}&u=${userConnection.userId}`;
    } else url = `${baseUrl}/product/launch?a=${connection.appId}`;
    return url;
};
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $847bf9dc758b6d61$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $847bf9dc758b6d61$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, [])).next());
    });
}
typeof SuppressedError === "function" && SuppressedError;
const $847bf9dc758b6d61$var$useDropdownMenu$1 = ({ items: items, placement: placement = "bottom-start", itemToString: itemToString = (item)=>item, offset: offset = [
    0,
    10
], resetSelectedItemOnClose: resetSelectedItemOnClose = false, popperModifiers: popperModifiers, strategy: strategy = "absolute", interactive: interactive = false, onMenuClickOutside: onMenuClickOutside, onChange: onChange, id: id })=>{
    const [referenceElement, setReferenceElement] = (0, $acw62.useState)(null);
    const [popperElement, setPopperElement] = (0, $acw62.useState)(null);
    const selectedItemRef = (0, $acw62.useRef)(-1);
    const [selectedItemIndex, setSelectedItemIndex] = (0, $acw62.useState)(-1);
    const [keydownFired, setKeydownFired] = (0, $acw62.useState)(false);
    const [forceClose, setForceClose] = (0, $acw62.useState)(false);
    const itemClicked = (0, $acw62.useRef)(false);
    const getPopperModifiers = ()=>{
        return popperModifiers && popperModifiers.length > 0 ? popperModifiers : [];
    };
    const modifiers = (0, $acw62.useMemo)(()=>[
            {
                name: "sameWidth",
                enabled: true,
                fn: ({ state: state })=>{
                    state.styles.popper.width = `${state.rects.reference.width}px`;
                },
                phase: "beforeWrite",
                requires: [
                    "computeStyles"
                ]
            },
            {
                name: "offset",
                options: {
                    offset: offset
                }
            },
            ...getPopperModifiers()
        ], []);
    const { styles: styles, attributes: attributes, update: update } = (0, $015b708b39a59435$export$f4d5bf230a36dd6e)(referenceElement, popperElement, {
        placement: placement,
        strategy: strategy,
        modifiers: modifiers
    });
    const stateReducer = (state, actionAndChanges)=>{
        const { type: type, changes: changes } = actionAndChanges;
        switch(type){
            case (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.MenuKeyDownArrowDown:
                if (state.highlightedIndex === items.length - 1 && items[0]) {
                    // check if first item is a section header
                    const highlightedIndex = items[0].sectionHeader ? 1 : items[0].disabled ? 1 : 0;
                    return Object.assign(Object.assign({}, changes), {
                        isOpen: true,
                        highlightedIndex: highlightedIndex
                    });
                }
                return Object.assign(Object.assign({}, changes), {
                    isOpen: true
                });
            case (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.MenuKeyDownArrowUp:
                if (state.highlightedIndex === 0) return Object.assign(Object.assign({}, changes), {
                    isOpen: true,
                    highlightedIndex: items.length - 1
                });
                return Object.assign(Object.assign({}, changes), {
                    isOpen: true
                });
            case (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.MenuKeyDownEnter:
            case (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.MenuKeyDownSpaceButton:
                {
                    const activeElement = document.activeElement;
                    if (activeElement && (activeElement.tagName === "INPUT" || activeElement.tagName === "TEXTAREA")) {
                        // programatically enter the space in the input
                        if (type === (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.MenuKeyDownSpaceButton) {
                            // insert a space at the correct location
                            const activeElementAsInput = activeElement;
                            const value = activeElementAsInput.value;
                            const selectionStart = activeElementAsInput.selectionStart;
                            const selectionEnd = activeElementAsInput.selectionEnd;
                            if (selectionStart && selectionEnd) {
                                const newValue = `${value.substring(0, selectionStart)} ${value.substring(selectionEnd)}`;
                                activeElementAsInput.value = newValue;
                                activeElementAsInput.selectionStart = selectionStart + 1;
                                activeElementAsInput.selectionEnd = selectionStart + 1;
                            }
                            // if the whole value is selected then add replace the whole value with a space
                            if (selectionStart === 0 && selectionEnd === value.length) {
                                activeElementAsInput.value = " ";
                                activeElementAsInput.selectionStart = 1;
                                activeElementAsInput.selectionEnd = 1;
                            }
                        }
                        return state; // Prevent default behavior and allow space key to register in input
                    }
                    if (interactive && state.isOpen) {
                        setKeydownFired(true);
                        setSelectedItemIndex(state.highlightedIndex);
                        if (type === (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.MenuKeyDownEnter) {
                            if (items[state.highlightedIndex] && items[state.highlightedIndex].onClick) items[state.highlightedIndex].onClick(items[state.highlightedIndex]);
                        }
                        return Object.assign(Object.assign({}, changes), {
                            highlightedIndex: state.highlightedIndex,
                            isOpen: true
                        });
                    }
                    if (items[state.highlightedIndex] && items[state.highlightedIndex].menuItems) return Object.assign(Object.assign({}, changes), {
                        highlightedIndex: state.highlightedIndex,
                        isOpen: true
                    });
                    const indexId = `[data-item-index="${state.highlightedIndex}"]`;
                    // using popper element instead of reference in case popper is created through a portal
                    if (state.highlightedIndex === -1) return Object.assign({}, changes);
                    const itemElement = popperElement === null || popperElement === void 0 ? void 0 : popperElement.querySelector(indexId);
                    if (!itemElement) throw new Error(`[useDropdownMenu]: unable to retrieve itemElement with prop '${indexId}'`);
                    // this is to fix an issue with strict mode
                    // istanbul ignore next
                    if (selectedItemRef.current === state.highlightedIndex) {
                        selectedItemRef.current = -1;
                        return Object.assign({}, changes);
                    }
                    if (type === (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.MenuKeyDownEnter) {
                        if (items[state.highlightedIndex] && items[state.highlightedIndex].onClick) items[state.highlightedIndex].onClick(items[state.highlightedIndex]);
                    }
                    selectedItemRef.current = state.highlightedIndex;
                    // find the selected item element see if it has a a tag if so then click it by attribute data-item-index
                    if (itemElement) {
                        const aTag = itemElement.querySelector("a");
                        if (aTag) aTag.click();
                    }
                    if (resetSelectedItemOnClose) return Object.assign(Object.assign({}, changes), {
                        isOpen: false,
                        selectedItem: -1,
                        highlightedIndex: -1
                    });
                    return Object.assign({}, changes);
                }
            case (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.ItemClick:
                if (itemClicked.current) {
                    itemClicked.current = false;
                    if (interactive && state.isOpen) return Object.assign(Object.assign({}, changes), {
                        isOpen: true,
                        highlightedIndex: state.highlightedIndex
                    });
                    return Object.assign({}, changes);
                }
                if (interactive && state.isOpen) {
                    setSelectedItemIndex(state.highlightedIndex);
                    return Object.assign(Object.assign({}, changes), {
                        highlightedIndex: state.highlightedIndex,
                        isOpen: true
                    });
                }
                if (state.highlightedIndex === -1) return Object.assign({}, changes);
                selectedItemRef.current = state.highlightedIndex;
                return Object.assign({}, changes);
            case (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.MenuKeyDownEscape:
                return Object.assign(Object.assign({}, changes), {
                    isOpen: false
                });
            case (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.MenuBlur:
                // if the focused element is not a child of the menu then close the menu
                if (forceClose && state.isOpen) return Object.assign(Object.assign({}, changes), {
                    isOpen: false
                });
                if (interactive && state.isOpen) {
                    itemClicked.current = true;
                    setSelectedItemIndex(-1);
                    return Object.assign(Object.assign({}, changes), {
                        highlightedIndex: state.highlightedIndex,
                        isOpen: true,
                        selectedItem: null
                    });
                }
                setSelectedItemIndex(-1);
                return Object.assign(Object.assign({}, changes), {
                    selectedItem: null
                });
            case (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.MenuKeyDownCharacter:
            case (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.FunctionSetInputValue:
                // if the active element is a input or textarea then do nothing
                if (document.activeElement && [
                    "INPUT",
                    "TEXTAREA"
                ].includes(document.activeElement.tagName) && interactive) return {
                    isOpen: true
                };
                return Object.assign({}, changes);
            default:
                return changes; // otherwise business as usual.
        }
    };
    const { isOpen: isOpen, getToggleButtonProps: getToggleButtonProps, getMenuProps: getMenuProps, highlightedIndex: highlightedIndex, selectedItem: selectedItem, getItemProps: getItemProps, closeMenu: closeMenu, openMenu: openMenu } = (0, $6260541dc56be833$export$e64b2f635402ca43)({
        items: items,
        itemToString: itemToString,
        stateReducer: stateReducer,
        id: id !== null && id !== void 0 ? id : undefined,
        menuId: id ? `${id}-menu` : undefined,
        onSelectedItemChange: (changes)=>{
            onChange && onChange(Object.assign({}, changes.selectedItem));
        }
    });
    const isElementInMenu = (element)=>{
        if (element === popperElement) return true;
        if (element.parentElement) return isElementInMenu(element.parentElement);
        return false;
    };
    const isInReferenceElement = (element)=>{
        if (element === referenceElement) return true;
        if (element.parentElement) return isInReferenceElement(element.parentElement);
        return false;
    };
    const handleOpen = ()=>{
        openMenu();
    };
    const handleClickOutside = (event)=>{
        var _a, _b, _c, _d, _e, _f;
        if (interactive && !isElementInMenu(event.target) && isOpen && event.target !== referenceElement && !isInReferenceElement(event.target)) {
            if ((_b = (_a = event === null || event === void 0 ? void 0 : event.srcElement) === null || _a === void 0 ? void 0 : _a.id) === null || _b === void 0 ? void 0 : _b.includes("pendo-guide-container")) return;
            if ((_d = (_c = event === null || event === void 0 ? void 0 : event.srcElement) === null || _c === void 0 ? void 0 : _c.className) === null || _d === void 0 ? void 0 : _d.includes("react-datepicker")) return;
            onMenuClickOutside && onMenuClickOutside();
            setForceClose(true);
            closeMenu();
        } else {
            if ((_f = (_e = event === null || event === void 0 ? void 0 : event.srcElement) === null || _e === void 0 ? void 0 : _e.id) === null || _f === void 0 ? void 0 : _f.includes("pendo-guide-container")) return;
            setForceClose(false);
        }
    };
    (0, $acw62.useEffect)(()=>{
        document.addEventListener("click", handleClickOutside);
        document.addEventListener("focus", handleClickOutside, true);
        return ()=>{
            document.removeEventListener("click", handleClickOutside);
            document.removeEventListener("focus", handleClickOutside, true);
        };
    }, [
        interactive,
        isOpen,
        popperElement,
        forceClose,
        referenceElement
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!selectedItem) return;
        const indexOf = items.findIndex((item)=>item.id === selectedItem.id);
        if (selectedItemIndex === indexOf && interactive) setSelectedItemIndex(-1);
    }, [
        selectedItem,
        selectedItemIndex,
        interactive
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!selectedItem) return;
        const indexOf = items.findIndex((item)=>item.id === selectedItem.id);
        if (isOpen && keydownFired && indexOf == selectedItemIndex) {
            setKeydownFired(false);
            setSelectedItemIndex(1);
        }
    }, [
        isOpen,
        keydownFired,
        selectedItem,
        selectedItemIndex
    ]);
    return {
        isOpen: isOpen,
        getToggleButtonProps: getToggleButtonProps,
        getMenuProps: getMenuProps,
        highlightedIndex: highlightedIndex,
        selectedItem: selectedItem,
        getItemProps: (_a)=>{
            var { index: index } = _a, rest = $847bf9dc758b6d61$var$__rest(_a, [
                "index"
            ]);
            return Object.assign({
                "data-item-index": index
            }, getItemProps(Object.assign(Object.assign({}, rest), {
                index: index
            })));
        },
        setReferenceElement: setReferenceElement,
        setPopperElement: setPopperElement,
        attributes: attributes,
        styles: styles,
        update: update,
        closeMenu: closeMenu,
        openMenu: handleOpen
    };
};
var $847bf9dc758b6d61$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
function $847bf9dc758b6d61$var$getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
var $847bf9dc758b6d61$var$classnames = {
    exports: {}
};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ (function(module) {
    /* global define */ (function() {
        var hasOwn = {}.hasOwnProperty;
        function classNames() {
            var classes = "";
            for(var i = 0; i < arguments.length; i++){
                var arg = arguments[i];
                if (arg) classes = appendClass(classes, parseValue(arg));
            }
            return classes;
        }
        function parseValue(arg) {
            if (typeof arg === "string" || typeof arg === "number") return arg;
            if (typeof arg !== "object") return "";
            if (Array.isArray(arg)) return classNames.apply(null, arg);
            if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) return arg.toString();
            var classes = "";
            for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
            return classes;
        }
        function appendClass(value, newClass) {
            if (!newClass) return value;
            if (value) return value + " " + newClass;
            return value + newClass;
        }
        if (module.exports) {
            classNames.default = classNames;
            module.exports = classNames;
        } else window.classNames = classNames;
    })();
})($847bf9dc758b6d61$var$classnames);
var $847bf9dc758b6d61$var$classnamesExports = $847bf9dc758b6d61$var$classnames.exports;
var $847bf9dc758b6d61$var$classNames = /*@__PURE__*/ $847bf9dc758b6d61$var$getDefaultExportFromCjs($847bf9dc758b6d61$var$classnamesExports);
var $847bf9dc758b6d61$var$css_248z$7 = ".DropdownMenu-module_helix-dropdown-menu__Xy2uM{background-color:var(--helix-dropdown-menu-background,#fff);border-radius:4px;overflow:hidden;position:relative;z-index:10}@media (max-width:600px){.DropdownMenu-module_helix-dropdown-menu__Xy2uM{max-width:calc(100vw - 32px);width:calc(100vw - 3px)!important}}.DropdownMenu-module_helix-dropdown-menu__Xy2uM.DropdownMenu-module_open__hnrbq{box-shadow:var(--helix-dropdown-menu-box-shadow,0 0 1px rgba(0,0,0,.2),0 4px 8px rgba(0,0,0,.1));padding:8px;position:relative;z-index:10}.DropdownMenu-module_helix-dropdown-menu__Xy2uM.DropdownMenu-module_open__hnrbq li:not(.DropdownMenu-module_divider__ydHsE){border-radius:6px;box-sizing:border-box;color:inherit;display:block;font-size:14px;margin-bottom:2px;text-decoration:none}.DropdownMenu-module_helix-dropdown-menu__Xy2uM.DropdownMenu-module_open__hnrbq.DropdownMenu-module_condensed__vLOUy li:not(.DropdownMenu-module_divider__ydHsE){font-size:12px}.DropdownMenu-module_helix-dropdown-menu__Xy2uM.DropdownMenu-module_open__hnrbq li:not(.DropdownMenu-module_divider__ydHsE) .DropdownMenu-module_menu-item-content-wrapper__tsHKz{align-items:center;display:flex;justify-content:space-between;padding:8px}.DropdownMenu-module_helix-dropdown-menu__Xy2uM.DropdownMenu-module_open__hnrbq.DropdownMenu-module_condensed__vLOUy li:not(.DropdownMenu-module_divider__ydHsE) .DropdownMenu-module_menu-item-content-wrapper__tsHKz{padding:4px 8px}@media (max-width:600px){.DropdownMenu-module_helix-dropdown-menu__Xy2uM.DropdownMenu-module_open__hnrbq li:not(.DropdownMenu-module_divider__ydHsE) .DropdownMenu-module_menu-item-content-wrapper__tsHKz{padding:12px 16px}}.DropdownMenu-module_helix-dropdown-menu__Xy2uM.DropdownMenu-module_open__hnrbq li:not(.DropdownMenu-module_divider__ydHsE) .DropdownMenu-module_helix-dropdown-menu-item__active-icon__-aRTK{align-items:center;display:flex}.DropdownMenu-module_helix-dropdown-menu__Xy2uM.DropdownMenu-module_open__hnrbq li:not(.DropdownMenu-module_divider__ydHsE).DropdownMenu-module_highlighted__5Vqgy{background-color:var(--helix-dropdown-menu-item-highlight-color,#e5e7eb)}.DropdownMenu-module_helix-dropdown-menu__Xy2uM:focus-within{outline:none}.DropdownMenu-module_helix-dropdown-menu__Xy2uM ul{list-style:none;margin:0;padding:0}.DropdownMenu-module_helix-dropdown-menu__Xy2uM ul li.DropdownMenu-module_disabled__0kFEH:not(.DropdownMenu-module_section-header__kuXEt) .DropdownMenu-module_description__sIQ69,.DropdownMenu-module_helix-dropdown-menu__Xy2uM ul li.DropdownMenu-module_disabled__0kFEH:not(.DropdownMenu-module_section-header__kuXEt) .DropdownMenu-module_helix-dropdown-menu-item__label__ZDnGe,.DropdownMenu-module_helix-dropdown-menu__Xy2uM ul li.DropdownMenu-module_disabled__0kFEH:not(.DropdownMenu-module_section-header__kuXEt) .DropdownMenu-module_label__EzR8Y,.DropdownMenu-module_helix-dropdown-menu__Xy2uM ul li.DropdownMenu-module_disabled__0kFEH:not(.DropdownMenu-module_section-header__kuXEt) svg{opacity:.3}.DropdownMenu-module_helix-dropdown-menu__Xy2uM ul li.DropdownMenu-module_selected-item__-LxZa{background-color:var(--helix-dropdown-menu-item-selected-color,#e5e7eb);outline-width:0}.DropdownMenu-module_helix-dropdown-menu__Xy2uM ul .DropdownMenu-module_divider__ydHsE{margin:4px 0}.DropdownMenu-module_helix-dropdown-menu__Xy2uM ul .DropdownMenu-module_section-header__kuXEt{color:var(--helix-dropdown-menu-section-header,#4b5563);font-size:12px;letter-spacing:.1em;padding-top:0;text-transform:uppercase}.DropdownMenu-module_helix-dropdown-menu__Xy2uM ul .DropdownMenu-module_description__sIQ69{color:var(--helix-dropdown-menu-item-description,#4b5563);font-size:12px}.DropdownMenu-module_helix-dropdown-menu__Xy2uM ul+ul{margin-left:16px}.DropdownMenu-module_helix-dropdown-menu__Xy2uM .DropdownMenu-module_empty-state__AsCs3{padding:16px;text-align:center}.DropdownMenu-module_helix-dropdown-menu__Xy2uM.DropdownMenu-module_helix-dropdown-badge-menu__yNoxU .DropdownMenu-module_menu-item-content-wrapper__tsHKz{display:grid!important;gap:8px;grid-template-columns:1fr 20px}.DropdownMenu-module_helix-dropdown-menu-item__yqdTD{color:var(--helix-dropdown-menu-item-text,#111827);list-style:none}.DropdownMenu-module_helix-dropdown-menu-item__yqdTD.DropdownMenu-module_no-wrap__Vjzjk{white-space:nowrap}.DropdownMenu-module_helix-dropdown-menu-item__yqdTD label{pointer-events:none}.DropdownMenu-module_helix-dropdown-menu-item__yqdTD .DropdownMenu-module_menu-item-content-wrapper__tsHKz>div{align-items:center;display:flex;width:100%}.DropdownMenu-module_helix-dropdown-menu-item__yqdTD.DropdownMenu-module_section-header__kuXEt{font-size:12px!important;font-weight:600;letter-spacing:.04em;padding-top:0;text-transform:uppercase}.DropdownMenu-module_helix-dropdown-menu-item__yqdTD.DropdownMenu-module_has-icon__KpIMF .DropdownMenu-module_menu-item-content-wrapper__tsHKz,.DropdownMenu-module_helix-dropdown-menu-item__yqdTD.DropdownMenu-module_has-icon__KpIMF .DropdownMenu-module_menu-item-content-wrapper__tsHKz>div{gap:8px;justify-content:flex-start}.DropdownMenu-module_helix-dropdown-menu-item__yqdTD.DropdownMenu-module_divider__ydHsE{border-top:1px solid var(--helix-dropdown-menu-divider,#e5e7eb);margin:0;overflow:hidden;padding:0}.DropdownMenu-module_helix-dropdown-menu-item__yqdTD.DropdownMenu-module_divider__ydHsE .DropdownMenu-module_menu-item-content-wrapper__tsHKz{display:none!important}.DropdownMenu-module_helix-dropdown-menu-item__yqdTD.DropdownMenu-module_helix-btn__R4OXD{margin-top:8px;padding:0}.DropdownMenu-module_highlighted__5Vqgy{background-color:var(--helix-dropdown-menu-item-highlight-color,#e5e7eb)}.DropdownMenu-module_disabled__0kFEH:not(.DropdownMenu-module_section-header__kuXEt){opacity:.3}.DropdownMenu-module_divider__ydHsE{margin:4px 0}.DropdownMenu-module_section-header__kuXEt{color:var(--helix-dropdown-menu-section-header,#4b5563);font-size:12px;letter-spacing:.1em;padding-top:0;text-transform:uppercase}.DropdownMenu-module_description__sIQ69{color:var(--helix-dropdown-menu-item-description,#4b5563);font-size:12px}.DropdownMenu-module_no-wrap__Vjzjk{white-space:nowrap}.DropdownMenu-module_selected-item__-LxZa{background-color:var(--helix-dropdown-menu-item-selected-color,#e5e7eb);outline-width:0}.DropdownMenu-module_helix-btn__R4OXD{margin-top:8px;padding:0}\n/*# sourceMappingURL=data:application/json;base64,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 */";
var $847bf9dc758b6d61$var$moduleStyles = {
    "helix-dropdown-menu": "DropdownMenu-module_helix-dropdown-menu__Xy2uM",
    "open": "DropdownMenu-module_open__hnrbq",
    "divider": "DropdownMenu-module_divider__ydHsE",
    "condensed": "DropdownMenu-module_condensed__vLOUy",
    "menu-item-content-wrapper": "DropdownMenu-module_menu-item-content-wrapper__tsHKz",
    "highlighted": "DropdownMenu-module_highlighted__5Vqgy",
    "disabled": "DropdownMenu-module_disabled__0kFEH",
    "section-header": "DropdownMenu-module_section-header__kuXEt",
    "helix-dropdown-menu-item": "DropdownMenu-module_helix-dropdown-menu-item__yqdTD",
    "no-wrap": "DropdownMenu-module_no-wrap__Vjzjk",
    "has-icon": "DropdownMenu-module_has-icon__KpIMF"
};
$847bf9dc758b6d61$var$styleInject($847bf9dc758b6d61$var$css_248z$7);
const $847bf9dc758b6d61$var$DropdownMenu$1 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((_a, ref)=>{
    var { children: children, isOpen: isOpen, maxWidth: maxWidth, width: width, condensedMenu: condensedMenu, height: height, maxHeight: maxHeight, className: className, style: incomingStyle } = _a, restProps = $847bf9dc758b6d61$var$__rest(_a, [
        "children",
        "isOpen",
        "maxWidth",
        "width",
        "condensedMenu",
        "height",
        "maxHeight",
        "className",
        "style"
    ]);
    const wrapperClass = $847bf9dc758b6d61$var$classNames($847bf9dc758b6d61$var$moduleStyles["helix-dropdown-menu"], className, {
        [$847bf9dc758b6d61$var$moduleStyles.open]: isOpen,
        [$847bf9dc758b6d61$var$moduleStyles.condensed]: condensedMenu
    });
    const style = {
        display: isOpen ? "block" : "none",
        width: width || undefined,
        maxWidth: maxWidth || undefined,
        height: height || undefined,
        maxHeight: maxHeight || height || undefined
    };
    const mergedStyle = Object.assign(Object.assign({}, incomingStyle || {}), style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        ref: ref,
        role: "menu",
        className: wrapperClass,
        "aria-hidden": !isOpen,
        style: mergedStyle
    }, restProps), children);
});
$847bf9dc758b6d61$var$DropdownMenu$1.displayName = "DropdownMenu";
const $847bf9dc758b6d61$var$DropdownMenuItem$2 = (_a)=>{
    var { menuItem: menuItem, highlightedIndex: highlightedIndex, index: index, getItemProps: getItemProps, children: children, hasIcon: hasIcon = true, checked: checked = false, className: className, noWrap: noWrap } = _a, rest = $847bf9dc758b6d61$var$__rest(_a, [
        "menuItem",
        "highlightedIndex",
        "index",
        "getItemProps",
        "children",
        "hasIcon",
        "checked",
        "className",
        "noWrap"
    ]);
    if (!menuItem) return null;
    const itemClass = $847bf9dc758b6d61$var$classNames($847bf9dc758b6d61$var$moduleStyles["helix-dropdown-menu-item"], className, {
        [$847bf9dc758b6d61$var$moduleStyles.highlighted]: index === highlightedIndex,
        [$847bf9dc758b6d61$var$moduleStyles.disabled]: !!menuItem.disabled,
        [$847bf9dc758b6d61$var$moduleStyles.divider]: !!menuItem.divider,
        [$847bf9dc758b6d61$var$moduleStyles["section-header"]]: !!menuItem.sectionHeader,
        [$847bf9dc758b6d61$var$moduleStyles["no-wrap"]]: !!noWrap,
        [$847bf9dc758b6d61$var$moduleStyles["has-icon"]]: !!hasIcon
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", Object.assign({
        className: itemClass,
        "data-item-index": index
    }, rest, getItemProps({
        item: menuItem,
        disabled: menuItem.disabled || menuItem.divider || menuItem.sectionHeader,
        index: index,
        onClick: (event)=>{
            menuItem.onClick && menuItem.onClick(menuItem, event);
        }
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $847bf9dc758b6d61$var$moduleStyles["menu-item-content-wrapper"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, children), checked && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
        icon: (0, $c761e69c8e58189a$exports.checkmark)
    })));
};
$847bf9dc758b6d61$var$DropdownMenuItem$2.__DROPDOWN_MENU_ITEM__ = true; // 👈 special marker
const $847bf9dc758b6d61$var$DropdownMenuComponent = (0, $acw62.forwardRef)(({ children: children, placement: placement = "bottom-start", interactive: interactive = false, onMenuClickOutside: onMenuClickOutside, width: width, menuOpen: menuOpen, offset: offset = [
    0,
    4
], className: className = "", maxHeight: maxHeight }, ref)=>{
    const [dropdownItems, setDropdownMenuItems] = (0, $acw62.useState)([]);
    const [isMounted, setIsMounted] = (0, $acw62.useState)(false);
    const { isOpen: isOpen, getToggleButtonProps: getToggleButtonProps, getMenuProps: getMenuProps, highlightedIndex: highlightedIndex, getItemProps: getItemProps, setReferenceElement: setReferenceElement, setPopperElement: setPopperElement, attributes: attributes, styles: styles, closeMenu: closeMenu, openMenu: openMenu, update: update } = $847bf9dc758b6d61$var$useDropdownMenu$1({
        placement: placement,
        offset: offset,
        items: dropdownItems,
        interactive: interactive,
        onMenuClickOutside: onMenuClickOutside,
        // istanbul ignore next
        itemToString: (item)=>item.label ? item.label : ""
    });
    const getDropdownMenuProps = ()=>{
        var _a;
        const menu = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray(children).find((child)=>{
            var _a, _b, _c;
            if (((_a = child === null || child === void 0 ? void 0 : child.type) === null || _a === void 0 ? void 0 : _a.displayName) === "DropdownMenu" || ((_c = (_b = child === null || child === void 0 ? void 0 : child.props) === null || _b === void 0 ? void 0 : _b.originalType) === null || _c === void 0 ? void 0 : _c.displayName) === "DropdownMenu") return child;
            return null;
        });
        return (_a = menu === null || menu === void 0 ? void 0 : menu.props) !== null && _a !== void 0 ? _a : {};
    };
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            api: {
                close: ()=>closeMenu(),
                open: ()=>openMenu(),
                setReferenceElement: (element)=>setReferenceElement(element),
                getToggleButtonProps: ()=>getToggleButtonProps(),
                update: ()=>update && isMounted && update(),
                isOpen: isOpen
            }
        }), [
        setReferenceElement,
        update,
        isMounted,
        isOpen
    ]);
    const updateDropdownMenuItems = ()=>$847bf9dc758b6d61$var$__awaiter(void 0, void 0, void 0, function*() {
            const items = [];
            const search = (children)=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(children, (child)=>{
                    var _a, _b, _c, _d;
                    if (((_a = child === null || child === void 0 ? void 0 : child.type) === null || _a === void 0 ? void 0 : _a.displayName) === "DropdownMenuItem" || ((_c = (_b = child === null || child === void 0 ? void 0 : child.props) === null || _b === void 0 ? void 0 : _b.originalType) === null || _c === void 0 ? void 0 : _c.displayName) === "DropdownMenuItem" || ((_d = child === null || child === void 0 ? void 0 : child.type) === null || _d === void 0 ? void 0 : _d.__DROPDOWN_MENU_ITEM__)) {
                        const optionalProps = {};
                        if (child.props.divider) {
                            optionalProps["divider"] = true;
                            optionalProps["disabled"] = true;
                        }
                        if (child.props.sectionHeader) {
                            optionalProps["sectionHeader"] = true;
                            optionalProps["disabled"] = true;
                        }
                        if (child.props.hidden) return;
                        items.push(Object.assign({
                            id: child.props.id,
                            label: child.props.textLabel,
                            onClick: child.props.onClick ? child.props.onClick : null,
                            checked: child.props.checked,
                            disabled: child.props.disabled,
                            className: child.props.className
                        }, optionalProps));
                    } else if (child && child.props && child.props.children) search(child.props.children); // Recursively search nested children
                });
            };
            yield search(children);
            setDropdownMenuItems(items);
        });
    // Recursive function to render children, handling both items and non-items
    const renderChildren = (children)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(children, (child, index)=>{
            var _a, _b, _c, _d, _e;
            if (((_a = child === null || child === void 0 ? void 0 : child.type) === null || _a === void 0 ? void 0 : _a.displayName) === "DropdownMenuItem" || ((_c = (_b = child === null || child === void 0 ? void 0 : child.props) === null || _b === void 0 ? void 0 : _b.originalType) === null || _c === void 0 ? void 0 : _c.displayName) === "DropdownMenuItem" || ((_d = child === null || child === void 0 ? void 0 : child.type) === null || _d === void 0 ? void 0 : _d.__DROPDOWN_MENU_ITEM__)) {
                // Find the corresponding item from the dropdown items
                const dropdownItem = dropdownItems.find((item)=>item.id === child.props.id);
                const calulatedIndex = dropdownItems.indexOf(dropdownItem);
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($847bf9dc758b6d61$var$DropdownMenuItem$2, Object.assign({
                    highlightedIndex: highlightedIndex,
                    index: calulatedIndex,
                    menuItem: dropdownItem,
                    key: (dropdownItem === null || dropdownItem === void 0 ? void 0 : dropdownItem.id) || calulatedIndex,
                    getItemProps: getItemProps,
                    closeMenu: closeMenu,
                    checked: dropdownItem === null || dropdownItem === void 0 ? void 0 : dropdownItem.checked,
                    className: dropdownItem === null || dropdownItem === void 0 ? void 0 : dropdownItem.className
                }, child.props), child.props.children);
            } else if ((_e = child === null || child === void 0 ? void 0 : child.props) === null || _e === void 0 ? void 0 : _e.children) // If the child has nested children, render recursively
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(child, {
                children: renderChildren(child.props.children) // Recursively render nested children
            });
            else // Otherwise, render non-MenuItem elements directly (keeping their props)
            return child;
        });
    };
    (0, $acw62.useEffect)(()=>{
        setIsMounted(true);
    }, []);
    (0, $acw62.useEffect)(()=>{
        updateDropdownMenuItems();
        update && update();
    }, [
        children
    ]);
    (0, $acw62.useEffect)(()=>{
        if (menuOpen) setTimeout(()=>{
            openMenu();
        }, 0);
    }, [
        menuOpen,
        update
    ]);
    (0, $acw62.useEffect)(()=>{
        update && update();
    }, [
        isOpen,
        update
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({}, getToggleButtonProps())), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($847bf9dc758b6d61$var$DropdownMenu$1, Object.assign({
        maxWidth: "300px",
        width: width ? width : "fit-content",
        ref: setPopperElement,
        isOpen: isOpen,
        style: styles.popper,
        maxHeight: maxHeight
    }, getDropdownMenuProps, {
        condensedMenu: getDropdownMenuProps().menuStyle === "condensed"
    }, attributes.popper, {
        className: className
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({}, getMenuProps({})), renderChildren(children))));
});
$847bf9dc758b6d61$var$DropdownMenuComponent.displayName = "DropdownMenu";
// eslint-disable-next-line no-empty-pattern
const $847bf9dc758b6d61$var$DropdownMenuItem$1 = ({})=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
};
$847bf9dc758b6d61$var$DropdownMenuItem$1.displayName = "DropdownMenuItem";
var $847bf9dc758b6d61$var$css_248z$6 = ".InstanceDropdown-module_sidebar-instance-dropdown__rPicL [role=listbox] :focus,.InstanceDropdown-module_sidebar-instance-dropdown__rPicL [role=listbox]:focus{outline:none}.InstanceDropdown-module_sidebar-instance-dropdown__rPicL [role=listbox] .InstanceDropdown-module_highlighted__tDMs4,.InstanceDropdown-module_sidebar-instance-dropdown__rPicL [role=listbox] li:hover:not(.InstanceDropdown-module_sidebar-instance-dropdown__header__aSjm-){background-color:var(--helix-brand-pale)!important;color:var(--helix-brand)!important}.InstanceDropdown-module_sidebar-instance-dropdown-button__p5qwb[aria-expanded=true] button,.InstanceDropdown-module_sidebar-instance-dropdown-button__p5qwb[aria-expanded=true] button:hover{background-color:var(--helix-gray-200)!important;color:var(--helix-brand)!important}.InstanceDropdown-module_sidebar-instance-dropdown-button__p5qwb[aria-expanded=true] button:hover svg path{fill:#4b5563!important}.InstanceDropdown-module_sidebar-instance-dropdown__header__aSjm-{color:#4b5563!important;font-size:12px!important;font-weight:400!important;letter-spacing:.1em!important;text-transform:uppercase!important}";
var $847bf9dc758b6d61$var$styles$3 = {
    "sidebar-instance-dropdown": "InstanceDropdown-module_sidebar-instance-dropdown__rPicL",
    "sidebar-instance-dropdown__header": "InstanceDropdown-module_sidebar-instance-dropdown__header__aSjm-",
    "sidebar-instance-dropdown-button": "InstanceDropdown-module_sidebar-instance-dropdown-button__p5qwb"
};
$847bf9dc758b6d61$var$styleInject($847bf9dc758b6d61$var$css_248z$6);
const $847bf9dc758b6d61$var$InstanceDropdown = ({ instances: instances, handleProductLaunch: handleProductLaunch, children: children, header: header })=>{
    var _a, _b, _c;
    const [dropdownMenu, setDropdownMenu] = (0, $acw62.useState)(null);
    const isOpen = !!((_a = dropdownMenu === null || dropdownMenu === void 0 ? void 0 : dropdownMenu.api) === null || _a === void 0 ? void 0 : _a.isOpen);
    // Close dropdown when sidebar scrolls
    (0, $acw62.useEffect)(()=>{
        const handleCloseInstanceMenus = ()=>{
            var _a;
            if (isOpen && ((_a = dropdownMenu === null || dropdownMenu === void 0 ? void 0 : dropdownMenu.api) === null || _a === void 0 ? void 0 : _a.close)) dropdownMenu.api.close();
        };
        document.addEventListener("closeInstanceMenus", handleCloseInstanceMenus);
        return ()=>{
            document.removeEventListener("closeInstanceMenus", handleCloseInstanceMenus);
        };
    }, [
        isOpen,
        dropdownMenu
    ]);
    // Sort instances alphabetically by name
    const sortedInstances = [
        ...instances
    ].sort((a, b)=>{
        if (!a.name || !b.name) return 0;
        return a.name.localeCompare(b.name, undefined, {
            sensitivity: "base"
        });
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: (_b = dropdownMenu === null || dropdownMenu === void 0 ? void 0 : dropdownMenu.api) === null || _b === void 0 ? void 0 : _b.setReferenceElement
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({}, (_c = dropdownMenu === null || dropdownMenu === void 0 ? void 0 : dropdownMenu.api) === null || _c === void 0 ? void 0 : _c.getToggleButtonProps(), {
        className: $847bf9dc758b6d61$var$styles$3["sidebar-instance-dropdown-button"]
    }), children(isOpen)), (0, $1u0KT.createPortal)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($847bf9dc758b6d61$var$DropdownMenuComponent, {
        ref: setDropdownMenu,
        placement: "right-start",
        className: $847bf9dc758b6d61$var$styles$3["sidebar-instance-dropdown"]
    }, header && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($847bf9dc758b6d61$var$DropdownMenuItem$1, {
        sectionHeader: true,
        id: "instance-dropdown-header",
        textLabel: "Select Instance",
        className: $847bf9dc758b6d61$var$styles$3["sidebar-instance-dropdown__header"]
    }, header), sortedInstances.map((instance, index)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($847bf9dc758b6d61$var$DropdownMenuItem$1, {
            key: instance.id || index,
            id: `instance-${instance.id || index}`,
            textLabel: instance.name,
            onClick: ()=>handleProductLaunch(instance)
        }, instance.name))), document.body));
};
const $847bf9dc758b6d61$export$6c4845e528748967 = ({ children: children })=>{
    const [isCollapsed, setIsCollapsed] = (0, $acw62.useState)(false);
    const [hoveredMenuItem, setHoveredMenuItem] = (0, $acw62.useState)(null);
    const [availableApps, setAvailableApps] = (0, $acw62.useState)([]);
    const [appMeta, setAppMeta] = (0, $acw62.useState)(null);
    const [allAppMeta, setAllAppMeta] = (0, $acw62.useState)(null);
    const [hasInitialized, setHasInitialized] = (0, $acw62.useState)(false);
    const hasPlatformServiceEverBeenProvided = (0, $acw62.useRef)(false);
    // Dynamically fetch and insert SVGs for each app icon
    (0, $acw62.useEffect)(()=>{
        const fallbackUrl = "https://assets.lwolf.com/lwt-helix/icons/latest/outlined/wolfie.svg";
        const fetchAndInsertSVG = (url, containerId)=>$847bf9dc758b6d61$var$__awaiter$1(void 0, void 0, void 0, function*() {
                try {
                    let response = yield fetch(url);
                    if (!response.ok) // If not found, try fallback
                    response = yield fetch(fallbackUrl);
                    const svg = yield response.text();
                    const container = document.getElementById(containerId);
                    if (container) container.innerHTML = svg;
                } catch (error) {
                    // On any error, try fallback icon
                    try {
                        const response = yield fetch(fallbackUrl);
                        const svg = yield response.text();
                        const container = document.getElementById(containerId);
                        if (container) container.innerHTML = svg;
                    } catch (fallbackError) {
                        console.error("Failed to load fallback icon:", fallbackError);
                    }
                }
            });
        if (availableApps && allAppMeta) availableApps.forEach((app)=>{
            const appMeta = allAppMeta.find((meta)=>meta.code.toLowerCase() === app.appId.toLowerCase());
            const iconUrl = appMeta ? `https://assets.lwolf.com/lwt-helix/icons/latest/products/outlined/${appMeta.icon}.svg` : null;
            const containerId = `icon-container-${app.appId}`;
            if (iconUrl) fetchAndInsertSVG(iconUrl, containerId);
        });
    }, [
        availableApps,
        allAppMeta
    ]);
    const { applicationCode: applicationCode, setApplicationName: setApplicationName, setAppConnections: setAppConnections, appConnections: appConnections, appData: appData, platformDataLoading: platformDataLoading, useMockData: useMockData, mockAppConnections: mockAppConnections, environment: environment, branding: branding, platformService: platformService } = (0, $acw62.useContext)($847bf9dc758b6d61$var$SidebarNavbarContext);
    let { activeClientId: activeClientId } = (0, $acw62.useContext)($847bf9dc758b6d61$var$SidebarNavbarContext);
    if (useMockData) activeClientId = "client-2";
    (0, $acw62.useEffect)(()=>{
        const fetchApplicationMeta = ()=>$847bf9dc758b6d61$var$__awaiter$1(void 0, void 0, void 0, function*() {
                try {
                    const response = yield fetch("https://assets.lwolf.com/json/products/latest.json");
                    const data = yield response.json();
                    const meta = data.find((product)=>product.code === applicationCode);
                    setAppMeta(meta || null);
                    setAllAppMeta(data);
                    if (meta && setApplicationName) setApplicationName(meta.name); // Dynamically update applicationName
                } catch (error) {
                    console.error("Failed to fetch application meta", error);
                    setAppMeta(null);
                }
            });
        fetchApplicationMeta();
    }, [
        applicationCode,
        setApplicationName
    ]);
    const toggleCollapsed = ()=>{
        setIsCollapsed(!isCollapsed);
    };
    const handleMenuItemHover = (itemId)=>{
        if (itemId === "apps") return;
        setHoveredMenuItem(itemId);
    };
    const handleMenuItemLeave = ()=>{
        setHoveredMenuItem(null);
    };
    const [filteredAppData, setFilteredAppData] = (0, $acw62.useState)([]);
    // Use data from context instead of making platform service calls
    // Handle mock mode separately to avoid infinite loops
    (0, $acw62.useEffect)(()=>{
        if (useMockData) {
            // Use centralized mock data (already imported at top)
            setFilteredAppData($847bf9dc758b6d61$var$mockAppData);
            if (typeof setAppConnections === "function") setAppConnections(mockAppConnections);
            setFilteredAppData($847bf9dc758b6d61$var$mockAppData);
            if (typeof setAppConnections === "function") setAppConnections(mockAppConnections);
        }
    }, [
        useMockData
    ]);
    // Handle real data mode
    (0, $acw62.useEffect)(()=>{
        if (!useMockData && appData && appConnections && !platformDataLoading) setFilteredAppData(appData || []);
    }, [
        appData,
        appConnections,
        platformDataLoading,
        useMockData
    ]);
    (0, $acw62.useEffect)(()=>{
        if (appConnections && filteredAppData) {
            const available = appConnections.filter((app)=>app.clientId === activeClientId);
            // Identify legacy apps
            const legacy = appConnections.filter((app)=>!app.platformClient);
            // Filter out legacy apps without app data
            const legacyWithAppData = legacy.filter((app)=>filteredAppData.some((data)=>data.id === app.appId));
            // Group legacy apps by appId
            const groupedLegacy = legacyWithAppData.reduce((acc, curr)=>{
                const { appId: appId } = curr;
                if (!acc[appId]) acc[appId] = [];
                acc[appId].push(curr);
                return acc;
            }, {});
            Object.keys(groupedLegacy).forEach((appId)=>{
                available.push({
                    appId: appId,
                    name: groupedLegacy[appId][0].name,
                    instances: groupedLegacy[appId],
                    isLegacy: appId === "bov" || appId === "xbm" ? false : true
                });
            });
            available.sort((a, b)=>{
                const metaA = allAppMeta ? allAppMeta.find((app)=>app.code.toLowerCase() === a.appId.toLowerCase()) : null;
                const metaB = allAppMeta ? allAppMeta.find((app)=>app.code.toLowerCase() === b.appId.toLowerCase()) : null;
                const nameA = metaA ? metaA.name : a.appId;
                const nameB = metaB ? metaB.name : b.appId;
                return nameA.localeCompare(nameB, undefined, {
                    sensitivity: "base"
                });
            });
            // Add foundation app to the top
            available.unshift({
                id: "foundation",
                appId: "fdn",
                clientId: activeClientId
            });
            setAvailableApps(available);
        }
    }, [
        appConnections,
        activeClientId,
        filteredAppData,
        allAppMeta
    ]);
    const handleProductLaunch = (connection)=>{
        const launchUrl = $847bf9dc758b6d61$var$buildProductLaunchUrl$1(environment !== null && environment !== void 0 ? environment : "dev", connection);
        window.open(launchUrl, "_self");
    };
    const CollapseButton = ({ isCollapsed: isCollapsed, toggleCollapsed: toggleCollapsed, parentRef: parentRef })=>{
        const targetContainer = document.getElementById("helix-application-header") || document.body;
        // Don't render if no valid container exists (e.g., during SSR)
        if (typeof window === "undefined" || !targetContainer) return null;
        return (0, $1u0KT.createPortal)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            className: $847bf9dc758b6d61$var$SidebarNavStyles["sidebar-nav__collapse-button"],
            onClick: toggleCollapsed,
            title: isCollapsed ? "Expand sidebar" : "Collapse sidebar"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
            icon: isCollapsed ? (0, $c761e69c8e58189a$exports.chevron_right) : (0, $c761e69c8e58189a$exports.chevron_left),
            className: $847bf9dc758b6d61$var$SidebarNavStyles["sidebar-nav__collapse-button__icon"]
        })), targetContainer);
    };
    // Pass ref to the parent container
    const parentRef = (0, $acw62.useRef)(null);
    // Close instance menus when sidebar scrolls
    (0, $acw62.useEffect)(()=>{
        const handleSidebarScroll = ()=>{
            // Dispatch custom event to notify InstanceDropdown components to close
            const closeInstanceMenusEvent = new CustomEvent("closeInstanceMenus");
            document.dispatchEvent(closeInstanceMenusEvent);
        };
        // eslint-disable-next-line react/prop-types
        const sidebarElement = parentRef.current;
        if (sidebarElement) {
            // eslint-disable-next-line react/prop-types
            sidebarElement.addEventListener("scroll", handleSidebarScroll);
            return ()=>{
                // eslint-disable-next-line react/prop-types
                sidebarElement.removeEventListener("scroll", handleSidebarScroll);
            };
        }
    }, []);
    !platformDataLoading && availableApps.length;
    // Track if platformService has ever been provided
    (0, $acw62.useEffect)(()=>{
        if (platformService) hasPlatformServiceEverBeenProvided.current = true;
    }, [
        platformService
    ]);
    (0, $acw62.useEffect)(()=>{
        // If we have apps, we're done - show them
        if (availableApps.length > 0) {
            setHasInitialized(true);
            return;
        }
        // If using mock data and loading is complete, we're done
        if (useMockData && !platformDataLoading) {
            setHasInitialized(true);
            return;
        }
        // If platformService was provided and loading is complete, we're done
        if (hasPlatformServiceEverBeenProvided.current && !platformDataLoading) {
            setHasInitialized(true);
            return;
        }
        // If no platformService yet and not using mock data, wait with a grace period
        // This gives time for platformService to be provided before hiding
        if (!platformService && !useMockData && !hasPlatformServiceEverBeenProvided.current) {
            const timeout = setTimeout(()=>{
                // Only hide if platformService still hasn't been provided
                if (!hasPlatformServiceEverBeenProvided.current) setHasInitialized(true);
            }, 2000);
            return ()=>clearTimeout(timeout);
        }
    }, [
        platformDataLoading,
        availableApps,
        useMockData,
        platformService
    ]);
    const showAppsSection = !hasInitialized || availableApps.length > 0;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: `${$847bf9dc758b6d61$var$SidebarNavStyles["sidebar-nav-container"]} ${isCollapsed ? $847bf9dc758b6d61$var$SidebarNavStyles["sidebar-nav-container--collapsed"] : ""} ${!showAppsSection && isCollapsed ? $847bf9dc758b6d61$var$SidebarNavStyles["sidebar-nav-container--no-apps"] : ""}`
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $847bf9dc758b6d61$var$SidebarNavStyles["sidebar-nav"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $847bf9dc758b6d61$var$SidebarNavStyles["sidebar-nav__panels"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(CollapseButton, {
        isCollapsed: isCollapsed,
        toggleCollapsed: toggleCollapsed,
        parentRef: parentRef
    }), showAppsSection && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $847bf9dc758b6d61$var$SidebarNavStyles["sidebar-nav__main"],
        ref: parentRef,
        onMouseLeave: handleMenuItemLeave
    }, platformDataLoading && !useMockData ? // Skeleton loaders for main apps
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, [
        ...Array(3)
    ].map((_, idx)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: `skeleton-app-${idx}`,
            className: `${$847bf9dc758b6d61$var$SidebarNavStyles["sidebar-nav__item"]} ` + `${$847bf9dc758b6d61$var$SidebarNavStyles["sidebar-nav__item--skeleton"]}`,
            disabled: true
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: $847bf9dc758b6d61$var$SidebarNavStyles["sidebar-nav__skeleton-icon"]
        }))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("hr", {
        className: $847bf9dc758b6d61$var$SidebarNavStyles["sidebar-nav__separator"]
    }), [
        ...Array(2)
    ].map((_, idx)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            key: `skeleton-legacy-${idx}`,
            className: `${$847bf9dc758b6d61$var$SidebarNavStyles["sidebar-nav__item"]} ` + `${$847bf9dc758b6d61$var$SidebarNavStyles["sidebar-nav__item--skeleton"]}`,
            disabled: true
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: $847bf9dc758b6d61$var$SidebarNavStyles["sidebar-nav__skeleton-icon"]
        })))) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, availableApps.filter((item)=>!item.isLegacy).map((item)=>{
        var _a, _b, _c, _d;
        const appMeta = allAppMeta ? allAppMeta.find((app)=>app.code.toLowerCase() === item.appId.toLowerCase()) : null;
        // Branding logic
        const shouldApplyBranding = branding && branding.id === activeClientId && ((_a = branding.applications) === null || _a === void 0 ? void 0 : _a[item.appId]);
        const brandedName = shouldApplyBranding ? (_c = (_b = branding.applications) === null || _b === void 0 ? void 0 : _b[item.appId]) === null || _c === void 0 ? void 0 : _c.name : appMeta === null || appMeta === void 0 ? void 0 : appMeta.name;
        const menuButton = (isOpen)=>{
            var _a;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($847bf9dc758b6d61$var$MenuButton, {
                id: item.appId,
                isActive: item.appId.toLowerCase() === (applicationCode === null || applicationCode === void 0 ? void 0 : applicationCode.toLowerCase()),
                isApps: item.appId === "apps",
                iconUrl: shouldApplyBranding ? branding.logoUrl : undefined,
                iconAlt: brandedName,
                onMouseEnter: ()=>handleMenuItemHover(item.appId),
                onMouseLeave: handleMenuItemLeave,
                onClick: ((_a = item.instances) === null || _a === void 0 ? void 0 : _a.length) > 1 ? undefined : ()=>handleProductLaunch(item),
                hasInstances: !!item.instances && item.instances.length > 1,
                isOpen: isOpen,
                shouldApplyBranding: shouldApplyBranding
            });
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
            key: item.appId
        }, ((_d = item.instances) === null || _d === void 0 ? void 0 : _d.length) > 1 ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($847bf9dc758b6d61$var$InstanceDropdown, {
            instances: item.instances,
            handleProductLaunch: handleProductLaunch,
            header: brandedName || item.appId
        }, menuButton) : menuButton(false), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($847bf9dc758b6d61$var$ToolTip, {
            target: item.appId,
            placement: "right",
            usePortal: true
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, brandedName || "Unknown App")));
    }), availableApps.filter((item)=>item.isLegacy).length > 0 && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("hr", {
        className: $847bf9dc758b6d61$var$SidebarNavStyles["sidebar-nav__separator"]
    }), availableApps.filter((item)=>item.isLegacy).map((item)=>{
        var _a, _b, _c, _d;
        const appMeta = allAppMeta ? allAppMeta.find((app)=>app.code.toLowerCase() === item.appId.toLowerCase()) : null;
        // Branding logic
        const shouldApplyBranding = branding && branding.id === activeClientId && ((_a = branding.applications) === null || _a === void 0 ? void 0 : _a[item.appId]);
        const brandedName = shouldApplyBranding ? (_c = (_b = branding.applications) === null || _b === void 0 ? void 0 : _b[item.appId]) === null || _c === void 0 ? void 0 : _c.name : appMeta === null || appMeta === void 0 ? void 0 : appMeta.name;
        const menuButton = (isOpen)=>{
            var _a;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($847bf9dc758b6d61$var$MenuButton, {
                id: item.appId,
                isActive: item.appId.toLowerCase() === (applicationCode === null || applicationCode === void 0 ? void 0 : applicationCode.toLowerCase()),
                isApps: item.appId === "apps",
                iconUrl: shouldApplyBranding ? branding.logoUrl : undefined,
                iconAlt: brandedName,
                onMouseEnter: ()=>handleMenuItemHover(item.appId),
                onMouseLeave: handleMenuItemLeave,
                onClick: ((_a = item.instances) === null || _a === void 0 ? void 0 : _a.length) > 1 ? undefined : ()=>handleProductLaunch(item),
                hasInstances: !!item.instances,
                isOpen: isOpen,
                shouldApplyBranding: shouldApplyBranding
            });
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
            key: item.appId
        }, ((_d = item.instances) === null || _d === void 0 ? void 0 : _d.length) > 1 ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($847bf9dc758b6d61$var$InstanceDropdown, {
            instances: item.instances,
            handleProductLaunch: handleProductLaunch,
            header: brandedName || item.appId
        }, menuButton) : menuButton(false), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($847bf9dc758b6d61$var$ToolTip, {
            target: item.appId,
            placement: "right",
            usePortal: true
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, brandedName || "Unknown App")));
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $847bf9dc758b6d61$var$SidebarNavStyles["sidebar-nav__secondary"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $847bf9dc758b6d61$var$SidebarNavStyles["sidebar-nav__secondary__header"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $847bf9dc758b6d61$var$SidebarNavStyles["sidebar-nav__secondary__header__title"]
    }, (appMeta === null || appMeta === void 0 ? void 0 : appMeta.name) || "Menu")), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $847bf9dc758b6d61$var$SidebarNavStyles["sidebar-nav__links"]
    }, children)))));
};
// MenuButton extracted to avoid hook order issues
const $847bf9dc758b6d61$var$MenuButton = ({ id: id, isActive: isActive, isApps: isApps, iconUrl: iconUrl, iconAlt: iconAlt, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onClick: onClick, hasInstances: hasInstances, isOpen: isOpen, shouldApplyBranding: shouldApplyBranding })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        id: id,
        className: $847bf9dc758b6d61$var$SidebarNavStyles["sidebar-nav__item"] + (isActive ? ` ${$847bf9dc758b6d61$var$SidebarNavStyles["sidebar-nav__item--active"]}` : "") + (isApps ? ` ${$847bf9dc758b6d61$var$SidebarNavStyles["sidebar-nav__item--apps"]}` : ""),
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onClick: onClick,
        style: {
            display: "inline-flex",
            alignItems: "center"
        }
    }, hasInstances && isOpen && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
        icon: (0, $c761e69c8e58189a$exports.chevron_small_down),
        className: $847bf9dc758b6d61$var$SidebarNavStyles["sidebar-nav__item__icon"]
    }), shouldApplyBranding && iconUrl && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: iconUrl,
        alt: iconAlt || "",
        className: $847bf9dc758b6d61$var$SidebarNavStyles["sidebar-nav__item__icon"],
        style: {
            display: isOpen ? "none" : "block",
            width: 24,
            height: 24
        }
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        id: `icon-container-${id}`,
        className: $847bf9dc758b6d61$var$SidebarNavStyles["sidebar-nav__item__icon"],
        style: {
            display: isOpen || shouldApplyBranding ? "none" : "block"
        }
    }));
};
const $847bf9dc758b6d61$export$1f4197d766a5076c = ({ children: children })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("header", {
        id: "helix-application-header",
        className: $847bf9dc758b6d61$var$SidebarNavStyles["helix-application-header"]
    }, children);
};
var $847bf9dc758b6d61$var$Authentication$1 = {};
var $847bf9dc758b6d61$var$JwtPayload$1 = {};
var $847bf9dc758b6d61$var$LwtClaim$1 = {};
var $847bf9dc758b6d61$var$AppsClaim$1 = {};
var $847bf9dc758b6d61$var$BackOfficeClaim$1 = {};
var $847bf9dc758b6d61$var$ClaimWithClientId$1 = {};
var $847bf9dc758b6d61$var$ClaimBase$1 = {};
Object.defineProperty($847bf9dc758b6d61$var$ClaimBase$1, "__esModule", {
    value: true
});
$847bf9dc758b6d61$var$ClaimBase$1.ClaimBase = void 0;
var $847bf9dc758b6d61$var$ClaimBase = /** @class */ function() {
    function ClaimBase() {}
    return ClaimBase;
}();
$847bf9dc758b6d61$var$ClaimBase$1.ClaimBase = $847bf9dc758b6d61$var$ClaimBase;
var $847bf9dc758b6d61$var$__extends$r = $847bf9dc758b6d61$var$commonjsGlobal && $847bf9dc758b6d61$var$commonjsGlobal.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($847bf9dc758b6d61$var$ClaimWithClientId$1, "__esModule", {
    value: true
});
$847bf9dc758b6d61$var$ClaimWithClientId$1.ClaimWithClientId = void 0;
var $847bf9dc758b6d61$var$ClaimBase_1$2 = $847bf9dc758b6d61$var$ClaimBase$1;
var $847bf9dc758b6d61$var$ClaimWithClientId = /** @class */ function(_super) {
    $847bf9dc758b6d61$var$__extends$r(ClaimWithClientId, _super);
    function ClaimWithClientId() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClaimWithClientId.prototype.getClientId = function() {
        return this.cid;
    };
    return ClaimWithClientId;
}($847bf9dc758b6d61$var$ClaimBase_1$2.ClaimBase);
$847bf9dc758b6d61$var$ClaimWithClientId$1.ClaimWithClientId = $847bf9dc758b6d61$var$ClaimWithClientId;
var $847bf9dc758b6d61$var$__extends$q = $847bf9dc758b6d61$var$commonjsGlobal && $847bf9dc758b6d61$var$commonjsGlobal.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($847bf9dc758b6d61$var$BackOfficeClaim$1, "__esModule", {
    value: true
});
$847bf9dc758b6d61$var$BackOfficeClaim$1.BackOfficeClaim = void 0;
var $847bf9dc758b6d61$var$ClaimWithClientId_1$4 = $847bf9dc758b6d61$var$ClaimWithClientId$1;
var $847bf9dc758b6d61$var$BackOfficeClaim = /** @class */ function(_super) {
    $847bf9dc758b6d61$var$__extends$q(BackOfficeClaim, _super);
    function BackOfficeClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BackOfficeClaim.prototype.getMemberId = function() {
        return this.mid;
    };
    BackOfficeClaim.prototype.getOfficeId = function() {
        return this.oid;
    };
    return BackOfficeClaim;
}($847bf9dc758b6d61$var$ClaimWithClientId_1$4.ClaimWithClientId);
$847bf9dc758b6d61$var$BackOfficeClaim$1.BackOfficeClaim = $847bf9dc758b6d61$var$BackOfficeClaim;
var $847bf9dc758b6d61$var$CloudAgentSuiteClaim$1 = {};
var $847bf9dc758b6d61$var$ClaimWithIntegerUserId$1 = {};
var $847bf9dc758b6d61$var$__extends$p = $847bf9dc758b6d61$var$commonjsGlobal && $847bf9dc758b6d61$var$commonjsGlobal.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($847bf9dc758b6d61$var$ClaimWithIntegerUserId$1, "__esModule", {
    value: true
});
$847bf9dc758b6d61$var$ClaimWithIntegerUserId$1.ClaimWithIntegerUserId = void 0;
var $847bf9dc758b6d61$var$ClaimBase_1$1 = $847bf9dc758b6d61$var$ClaimBase$1;
var $847bf9dc758b6d61$var$ClaimWithIntegerUserId = /** @class */ function(_super) {
    $847bf9dc758b6d61$var$__extends$p(ClaimWithIntegerUserId, _super);
    function ClaimWithIntegerUserId() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ClaimWithIntegerUserId.prototype, "userId", {
        get: function() {
            return this.uid;
        },
        enumerable: false,
        configurable: true
    });
    return ClaimWithIntegerUserId;
}($847bf9dc758b6d61$var$ClaimBase_1$1.ClaimBase);
$847bf9dc758b6d61$var$ClaimWithIntegerUserId$1.ClaimWithIntegerUserId = $847bf9dc758b6d61$var$ClaimWithIntegerUserId;
var $847bf9dc758b6d61$var$__extends$o = $847bf9dc758b6d61$var$commonjsGlobal && $847bf9dc758b6d61$var$commonjsGlobal.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($847bf9dc758b6d61$var$CloudAgentSuiteClaim$1, "__esModule", {
    value: true
});
$847bf9dc758b6d61$var$CloudAgentSuiteClaim$1.CloudAgentSuiteClaim = void 0;
var $847bf9dc758b6d61$var$ClaimWithIntegerUserId_1$9 = $847bf9dc758b6d61$var$ClaimWithIntegerUserId$1;
var $847bf9dc758b6d61$var$CloudAgentSuiteClaim = /** @class */ function(_super) {
    $847bf9dc758b6d61$var$__extends$o(CloudAgentSuiteClaim, _super);
    function CloudAgentSuiteClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CloudAgentSuiteClaim;
}($847bf9dc758b6d61$var$ClaimWithIntegerUserId_1$9.ClaimWithIntegerUserId);
$847bf9dc758b6d61$var$CloudAgentSuiteClaim$1.CloudAgentSuiteClaim = $847bf9dc758b6d61$var$CloudAgentSuiteClaim;
var $847bf9dc758b6d61$var$HomeSpotterBoostClaim$1 = {};
var $847bf9dc758b6d61$var$__extends$n = $847bf9dc758b6d61$var$commonjsGlobal && $847bf9dc758b6d61$var$commonjsGlobal.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($847bf9dc758b6d61$var$HomeSpotterBoostClaim$1, "__esModule", {
    value: true
});
$847bf9dc758b6d61$var$HomeSpotterBoostClaim$1.HomeSpotterBoostClaim = void 0;
var $847bf9dc758b6d61$var$ClaimWithIntegerUserId_1$8 = $847bf9dc758b6d61$var$ClaimWithIntegerUserId$1;
var $847bf9dc758b6d61$var$HomeSpotterBoostClaim = /** @class */ function(_super) {
    $847bf9dc758b6d61$var$__extends$n(HomeSpotterBoostClaim, _super);
    function HomeSpotterBoostClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return HomeSpotterBoostClaim;
}($847bf9dc758b6d61$var$ClaimWithIntegerUserId_1$8.ClaimWithIntegerUserId);
$847bf9dc758b6d61$var$HomeSpotterBoostClaim$1.HomeSpotterBoostClaim = $847bf9dc758b6d61$var$HomeSpotterBoostClaim;
var $847bf9dc758b6d61$var$HomeSpotterConnectClaim$1 = {};
var $847bf9dc758b6d61$var$__extends$m = $847bf9dc758b6d61$var$commonjsGlobal && $847bf9dc758b6d61$var$commonjsGlobal.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($847bf9dc758b6d61$var$HomeSpotterConnectClaim$1, "__esModule", {
    value: true
});
$847bf9dc758b6d61$var$HomeSpotterConnectClaim$1.HomeSpotterConnectClaim = void 0;
var $847bf9dc758b6d61$var$ClaimWithIntegerUserId_1$7 = $847bf9dc758b6d61$var$ClaimWithIntegerUserId$1;
var $847bf9dc758b6d61$var$HomeSpotterConnectClaim = /** @class */ function(_super) {
    $847bf9dc758b6d61$var$__extends$m(HomeSpotterConnectClaim, _super);
    function HomeSpotterConnectClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return HomeSpotterConnectClaim;
}($847bf9dc758b6d61$var$ClaimWithIntegerUserId_1$7.ClaimWithIntegerUserId);
$847bf9dc758b6d61$var$HomeSpotterConnectClaim$1.HomeSpotterConnectClaim = $847bf9dc758b6d61$var$HomeSpotterConnectClaim;
var $847bf9dc758b6d61$var$HomeSpotterSpacioClaim$1 = {};
var $847bf9dc758b6d61$var$ClaimWithStringUserId$1 = {};
var $847bf9dc758b6d61$var$__extends$l = $847bf9dc758b6d61$var$commonjsGlobal && $847bf9dc758b6d61$var$commonjsGlobal.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($847bf9dc758b6d61$var$ClaimWithStringUserId$1, "__esModule", {
    value: true
});
$847bf9dc758b6d61$var$ClaimWithStringUserId$1.ClaimWithStringUserId = void 0;
var $847bf9dc758b6d61$var$ClaimBase_1 = $847bf9dc758b6d61$var$ClaimBase$1;
var $847bf9dc758b6d61$var$ClaimWithStringUserId = /** @class */ function(_super) {
    $847bf9dc758b6d61$var$__extends$l(ClaimWithStringUserId, _super);
    function ClaimWithStringUserId() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ClaimWithStringUserId.prototype, "userId", {
        get: function() {
            return this.uid;
        },
        enumerable: false,
        configurable: true
    });
    return ClaimWithStringUserId;
}($847bf9dc758b6d61$var$ClaimBase_1.ClaimBase);
$847bf9dc758b6d61$var$ClaimWithStringUserId$1.ClaimWithStringUserId = $847bf9dc758b6d61$var$ClaimWithStringUserId;
var $847bf9dc758b6d61$var$__extends$k = $847bf9dc758b6d61$var$commonjsGlobal && $847bf9dc758b6d61$var$commonjsGlobal.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($847bf9dc758b6d61$var$HomeSpotterSpacioClaim$1, "__esModule", {
    value: true
});
$847bf9dc758b6d61$var$HomeSpotterSpacioClaim$1.HomeSpotterSpacioClaim = void 0;
var $847bf9dc758b6d61$var$ClaimWithStringUserId_1$9 = $847bf9dc758b6d61$var$ClaimWithStringUserId$1;
var $847bf9dc758b6d61$var$HomeSpotterSpacioClaim = /** @class */ function(_super) {
    $847bf9dc758b6d61$var$__extends$k(HomeSpotterSpacioClaim, _super);
    function HomeSpotterSpacioClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return HomeSpotterSpacioClaim;
}($847bf9dc758b6d61$var$ClaimWithStringUserId_1$9.ClaimWithStringUserId);
$847bf9dc758b6d61$var$HomeSpotterSpacioClaim$1.HomeSpotterSpacioClaim = $847bf9dc758b6d61$var$HomeSpotterSpacioClaim;
var $847bf9dc758b6d61$var$LionDeskClaim$1 = {};
var $847bf9dc758b6d61$var$__extends$j = $847bf9dc758b6d61$var$commonjsGlobal && $847bf9dc758b6d61$var$commonjsGlobal.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($847bf9dc758b6d61$var$LionDeskClaim$1, "__esModule", {
    value: true
});
$847bf9dc758b6d61$var$LionDeskClaim$1.LionDeskClaim = void 0;
var $847bf9dc758b6d61$var$ClaimWithIntegerUserId_1$6 = $847bf9dc758b6d61$var$ClaimWithIntegerUserId$1;
var $847bf9dc758b6d61$var$LionDeskClaim = /** @class */ function(_super) {
    $847bf9dc758b6d61$var$__extends$j(LionDeskClaim, _super);
    function LionDeskClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return LionDeskClaim;
}($847bf9dc758b6d61$var$ClaimWithIntegerUserId_1$6.ClaimWithIntegerUserId);
$847bf9dc758b6d61$var$LionDeskClaim$1.LionDeskClaim = $847bf9dc758b6d61$var$LionDeskClaim;
var $847bf9dc758b6d61$var$PropertybaseBackOfficeClaim$1 = {};
var $847bf9dc758b6d61$var$__extends$i = $847bf9dc758b6d61$var$commonjsGlobal && $847bf9dc758b6d61$var$commonjsGlobal.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($847bf9dc758b6d61$var$PropertybaseBackOfficeClaim$1, "__esModule", {
    value: true
});
$847bf9dc758b6d61$var$PropertybaseBackOfficeClaim$1.PropertybaseBackOfficeClaim = void 0;
var $847bf9dc758b6d61$var$ClaimWithClientId_1$3 = $847bf9dc758b6d61$var$ClaimWithClientId$1;
var $847bf9dc758b6d61$var$PropertybaseBackOfficeClaim = /** @class */ function(_super) {
    $847bf9dc758b6d61$var$__extends$i(PropertybaseBackOfficeClaim, _super);
    function PropertybaseBackOfficeClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertybaseBackOfficeClaim.prototype.getMemberId = function() {
        return this.mid;
    };
    return PropertybaseBackOfficeClaim;
}($847bf9dc758b6d61$var$ClaimWithClientId_1$3.ClaimWithClientId);
$847bf9dc758b6d61$var$PropertybaseBackOfficeClaim$1.PropertybaseBackOfficeClaim = $847bf9dc758b6d61$var$PropertybaseBackOfficeClaim;
var $847bf9dc758b6d61$var$PropertybaseBoldLeadsClaim$1 = {};
var $847bf9dc758b6d61$var$__extends$h = $847bf9dc758b6d61$var$commonjsGlobal && $847bf9dc758b6d61$var$commonjsGlobal.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($847bf9dc758b6d61$var$PropertybaseBoldLeadsClaim$1, "__esModule", {
    value: true
});
$847bf9dc758b6d61$var$PropertybaseBoldLeadsClaim$1.PropertybaseBoldLeadsClaim = void 0;
var $847bf9dc758b6d61$var$ClaimWithIntegerUserId_1$5 = $847bf9dc758b6d61$var$ClaimWithIntegerUserId$1;
var $847bf9dc758b6d61$var$PropertybaseBoldLeadsClaim = /** @class */ function(_super) {
    $847bf9dc758b6d61$var$__extends$h(PropertybaseBoldLeadsClaim, _super);
    function PropertybaseBoldLeadsClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PropertybaseBoldLeadsClaim;
}($847bf9dc758b6d61$var$ClaimWithIntegerUserId_1$5.ClaimWithIntegerUserId);
$847bf9dc758b6d61$var$PropertybaseBoldLeadsClaim$1.PropertybaseBoldLeadsClaim = $847bf9dc758b6d61$var$PropertybaseBoldLeadsClaim;
var $847bf9dc758b6d61$var$PropertybaseGoClaim$1 = {};
var $847bf9dc758b6d61$var$__extends$g = $847bf9dc758b6d61$var$commonjsGlobal && $847bf9dc758b6d61$var$commonjsGlobal.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($847bf9dc758b6d61$var$PropertybaseGoClaim$1, "__esModule", {
    value: true
});
$847bf9dc758b6d61$var$PropertybaseGoClaim$1.PropertybaseGoClaim = void 0;
var $847bf9dc758b6d61$var$ClaimWithIntegerUserId_1$4 = $847bf9dc758b6d61$var$ClaimWithIntegerUserId$1;
var $847bf9dc758b6d61$var$PropertybaseGoClaim = /** @class */ function(_super) {
    $847bf9dc758b6d61$var$__extends$g(PropertybaseGoClaim, _super);
    function PropertybaseGoClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PropertybaseGoClaim;
}($847bf9dc758b6d61$var$ClaimWithIntegerUserId_1$4.ClaimWithIntegerUserId);
$847bf9dc758b6d61$var$PropertybaseGoClaim$1.PropertybaseGoClaim = $847bf9dc758b6d61$var$PropertybaseGoClaim;
var $847bf9dc758b6d61$var$SalesforceClaim$1 = {};
var $847bf9dc758b6d61$var$__extends$f = $847bf9dc758b6d61$var$commonjsGlobal && $847bf9dc758b6d61$var$commonjsGlobal.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($847bf9dc758b6d61$var$SalesforceClaim$1, "__esModule", {
    value: true
});
$847bf9dc758b6d61$var$SalesforceClaim$1.SalesforceClaim = void 0;
var $847bf9dc758b6d61$var$ClaimWithClientId_1$2 = $847bf9dc758b6d61$var$ClaimWithClientId$1;
var $847bf9dc758b6d61$var$SalesforceClaim = /** @class */ function(_super) {
    $847bf9dc758b6d61$var$__extends$f(SalesforceClaim, _super);
    function SalesforceClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SalesforceClaim.prototype.getMemberId = function() {
        return this.mid;
    };
    return SalesforceClaim;
}($847bf9dc758b6d61$var$ClaimWithClientId_1$2.ClaimWithClientId);
$847bf9dc758b6d61$var$SalesforceClaim$1.SalesforceClaim = $847bf9dc758b6d61$var$SalesforceClaim;
var $847bf9dc758b6d61$var$TransactionDeskClaim$1 = {};
var $847bf9dc758b6d61$var$__extends$e = $847bf9dc758b6d61$var$commonjsGlobal && $847bf9dc758b6d61$var$commonjsGlobal.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($847bf9dc758b6d61$var$TransactionDeskClaim$1, "__esModule", {
    value: true
});
$847bf9dc758b6d61$var$TransactionDeskClaim$1.TransactionDeskClaim = void 0;
var $847bf9dc758b6d61$var$ClaimWithStringUserId_1$8 = $847bf9dc758b6d61$var$ClaimWithStringUserId$1;
var $847bf9dc758b6d61$var$TransactionDeskClaim = /** @class */ function(_super) {
    $847bf9dc758b6d61$var$__extends$e(TransactionDeskClaim, _super);
    function TransactionDeskClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TransactionDeskClaim;
}($847bf9dc758b6d61$var$ClaimWithStringUserId_1$8.ClaimWithStringUserId);
$847bf9dc758b6d61$var$TransactionDeskClaim$1.TransactionDeskClaim = $847bf9dc758b6d61$var$TransactionDeskClaim;
var $847bf9dc758b6d61$var$TerradatumAergoClaim$1 = {};
var $847bf9dc758b6d61$var$__extends$d = $847bf9dc758b6d61$var$commonjsGlobal && $847bf9dc758b6d61$var$commonjsGlobal.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($847bf9dc758b6d61$var$TerradatumAergoClaim$1, "__esModule", {
    value: true
});
$847bf9dc758b6d61$var$TerradatumAergoClaim$1.TerradatumAergoClaim = void 0;
var $847bf9dc758b6d61$var$ClaimWithStringUserId_1$7 = $847bf9dc758b6d61$var$ClaimWithStringUserId$1;
var $847bf9dc758b6d61$var$TerradatumAergoClaim = /** @class */ function(_super) {
    $847bf9dc758b6d61$var$__extends$d(TerradatumAergoClaim, _super);
    function TerradatumAergoClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TerradatumAergoClaim;
}($847bf9dc758b6d61$var$ClaimWithStringUserId_1$7.ClaimWithStringUserId);
$847bf9dc758b6d61$var$TerradatumAergoClaim$1.TerradatumAergoClaim = $847bf9dc758b6d61$var$TerradatumAergoClaim;
var $847bf9dc758b6d61$var$TerradatumAgentMetricsClaim$1 = {};
var $847bf9dc758b6d61$var$__extends$c = $847bf9dc758b6d61$var$commonjsGlobal && $847bf9dc758b6d61$var$commonjsGlobal.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($847bf9dc758b6d61$var$TerradatumAgentMetricsClaim$1, "__esModule", {
    value: true
});
$847bf9dc758b6d61$var$TerradatumAgentMetricsClaim$1.TerradatumAgentMetricsClaim = void 0;
var $847bf9dc758b6d61$var$ClaimWithStringUserId_1$6 = $847bf9dc758b6d61$var$ClaimWithStringUserId$1;
var $847bf9dc758b6d61$var$TerradatumAgentMetricsClaim = /** @class */ function(_super) {
    $847bf9dc758b6d61$var$__extends$c(TerradatumAgentMetricsClaim, _super);
    function TerradatumAgentMetricsClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TerradatumAgentMetricsClaim;
}($847bf9dc758b6d61$var$ClaimWithStringUserId_1$6.ClaimWithStringUserId);
$847bf9dc758b6d61$var$TerradatumAgentMetricsClaim$1.TerradatumAgentMetricsClaim = $847bf9dc758b6d61$var$TerradatumAgentMetricsClaim;
var $847bf9dc758b6d61$var$XBrokerMetricsClaim$1 = {};
var $847bf9dc758b6d61$var$__extends$b = $847bf9dc758b6d61$var$commonjsGlobal && $847bf9dc758b6d61$var$commonjsGlobal.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($847bf9dc758b6d61$var$XBrokerMetricsClaim$1, "__esModule", {
    value: true
});
$847bf9dc758b6d61$var$XBrokerMetricsClaim$1.XBrokerMetricsClaim = void 0;
var $847bf9dc758b6d61$var$ClaimWithStringUserId_1$5 = $847bf9dc758b6d61$var$ClaimWithStringUserId$1;
var $847bf9dc758b6d61$var$XBrokerMetricsClaim = /** @class */ function(_super) {
    $847bf9dc758b6d61$var$__extends$b(XBrokerMetricsClaim, _super);
    function XBrokerMetricsClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return XBrokerMetricsClaim;
}($847bf9dc758b6d61$var$ClaimWithStringUserId_1$5.ClaimWithStringUserId);
$847bf9dc758b6d61$var$XBrokerMetricsClaim$1.XBrokerMetricsClaim = $847bf9dc758b6d61$var$XBrokerMetricsClaim;
var $847bf9dc758b6d61$var$TerradatumListingHomeRunClaim$1 = {};
var $847bf9dc758b6d61$var$__extends$a = $847bf9dc758b6d61$var$commonjsGlobal && $847bf9dc758b6d61$var$commonjsGlobal.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($847bf9dc758b6d61$var$TerradatumListingHomeRunClaim$1, "__esModule", {
    value: true
});
$847bf9dc758b6d61$var$TerradatumListingHomeRunClaim$1.TerradatumListingHomeRunClaim = void 0;
var $847bf9dc758b6d61$var$ClaimWithStringUserId_1$4 = $847bf9dc758b6d61$var$ClaimWithStringUserId$1;
var $847bf9dc758b6d61$var$TerradatumListingHomeRunClaim = /** @class */ function(_super) {
    $847bf9dc758b6d61$var$__extends$a(TerradatumListingHomeRunClaim, _super);
    function TerradatumListingHomeRunClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TerradatumListingHomeRunClaim;
}($847bf9dc758b6d61$var$ClaimWithStringUserId_1$4.ClaimWithStringUserId);
$847bf9dc758b6d61$var$TerradatumListingHomeRunClaim$1.TerradatumListingHomeRunClaim = $847bf9dc758b6d61$var$TerradatumListingHomeRunClaim;
var $847bf9dc758b6d61$var$TerradatumVScreenClaim$1 = {};
var $847bf9dc758b6d61$var$__extends$9 = $847bf9dc758b6d61$var$commonjsGlobal && $847bf9dc758b6d61$var$commonjsGlobal.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($847bf9dc758b6d61$var$TerradatumVScreenClaim$1, "__esModule", {
    value: true
});
$847bf9dc758b6d61$var$TerradatumVScreenClaim$1.TerradatumVScreenClaim = void 0;
var $847bf9dc758b6d61$var$ClaimWithStringUserId_1$3 = $847bf9dc758b6d61$var$ClaimWithStringUserId$1;
var $847bf9dc758b6d61$var$TerradatumVScreenClaim = /** @class */ function(_super) {
    $847bf9dc758b6d61$var$__extends$9(TerradatumVScreenClaim, _super);
    function TerradatumVScreenClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TerradatumVScreenClaim;
}($847bf9dc758b6d61$var$ClaimWithStringUserId_1$3.ClaimWithStringUserId);
$847bf9dc758b6d61$var$TerradatumVScreenClaim$1.TerradatumVScreenClaim = $847bf9dc758b6d61$var$TerradatumVScreenClaim;
var $847bf9dc758b6d61$var$WolfConnectClaim$1 = {};
var $847bf9dc758b6d61$var$__extends$8 = $847bf9dc758b6d61$var$commonjsGlobal && $847bf9dc758b6d61$var$commonjsGlobal.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($847bf9dc758b6d61$var$WolfConnectClaim$1, "__esModule", {
    value: true
});
$847bf9dc758b6d61$var$WolfConnectClaim$1.WolfConnectClaim = void 0;
var $847bf9dc758b6d61$var$ClaimWithClientId_1$1 = $847bf9dc758b6d61$var$ClaimWithClientId$1;
var $847bf9dc758b6d61$var$WolfConnectClaim = /** @class */ function(_super) {
    $847bf9dc758b6d61$var$__extends$8(WolfConnectClaim, _super);
    function WolfConnectClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WolfConnectClaim.prototype.getMemberId = function() {
        return this.mid;
    };
    return WolfConnectClaim;
}($847bf9dc758b6d61$var$ClaimWithClientId_1$1.ClaimWithClientId);
$847bf9dc758b6d61$var$WolfConnectClaim$1.WolfConnectClaim = $847bf9dc758b6d61$var$WolfConnectClaim;
var $847bf9dc758b6d61$var$ZipFormPlusClaim$1 = {};
var $847bf9dc758b6d61$var$__extends$7 = $847bf9dc758b6d61$var$commonjsGlobal && $847bf9dc758b6d61$var$commonjsGlobal.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($847bf9dc758b6d61$var$ZipFormPlusClaim$1, "__esModule", {
    value: true
});
$847bf9dc758b6d61$var$ZipFormPlusClaim$1.ZipFormPlusClaim = void 0;
var $847bf9dc758b6d61$var$ClaimWithStringUserId_1$2 = $847bf9dc758b6d61$var$ClaimWithStringUserId$1;
var $847bf9dc758b6d61$var$ZipFormPlusClaim = /** @class */ function(_super) {
    $847bf9dc758b6d61$var$__extends$7(ZipFormPlusClaim, _super);
    function ZipFormPlusClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ZipFormPlusClaim;
}($847bf9dc758b6d61$var$ClaimWithStringUserId_1$2.ClaimWithStringUserId);
$847bf9dc758b6d61$var$ZipFormPlusClaim$1.ZipFormPlusClaim = $847bf9dc758b6d61$var$ZipFormPlusClaim;
var $847bf9dc758b6d61$var$AuthentisignClaim$1 = {};
var $847bf9dc758b6d61$var$__extends$6 = $847bf9dc758b6d61$var$commonjsGlobal && $847bf9dc758b6d61$var$commonjsGlobal.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($847bf9dc758b6d61$var$AuthentisignClaim$1, "__esModule", {
    value: true
});
$847bf9dc758b6d61$var$AuthentisignClaim$1.AuthentisignClaim = void 0;
var $847bf9dc758b6d61$var$ClaimWithStringUserId_1$1 = $847bf9dc758b6d61$var$ClaimWithStringUserId$1;
var $847bf9dc758b6d61$var$AuthentisignClaim = /** @class */ function(_super) {
    $847bf9dc758b6d61$var$__extends$6(AuthentisignClaim, _super);
    function AuthentisignClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AuthentisignClaim;
}($847bf9dc758b6d61$var$ClaimWithStringUserId_1$1.ClaimWithStringUserId);
$847bf9dc758b6d61$var$AuthentisignClaim$1.AuthentisignClaim = $847bf9dc758b6d61$var$AuthentisignClaim;
var $847bf9dc758b6d61$var$BackOfficeV4Claim$1 = {};
var $847bf9dc758b6d61$var$__extends$5 = $847bf9dc758b6d61$var$commonjsGlobal && $847bf9dc758b6d61$var$commonjsGlobal.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($847bf9dc758b6d61$var$BackOfficeV4Claim$1, "__esModule", {
    value: true
});
$847bf9dc758b6d61$var$BackOfficeV4Claim$1.BackOfficeV4Claim = void 0;
var $847bf9dc758b6d61$var$ClaimWithClientId_1 = $847bf9dc758b6d61$var$ClaimWithClientId$1;
var $847bf9dc758b6d61$var$BackOfficeV4Claim = /** @class */ function(_super) {
    $847bf9dc758b6d61$var$__extends$5(BackOfficeV4Claim, _super);
    function BackOfficeV4Claim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BackOfficeV4Claim.prototype.getMemberId = function() {
        return this.mid;
    };
    BackOfficeV4Claim.prototype.getOfficeId = function() {
        return this.oid;
    };
    return BackOfficeV4Claim;
}($847bf9dc758b6d61$var$ClaimWithClientId_1.ClaimWithClientId);
$847bf9dc758b6d61$var$BackOfficeV4Claim$1.BackOfficeV4Claim = $847bf9dc758b6d61$var$BackOfficeV4Claim;
var $847bf9dc758b6d61$var$CloudAttractClaim$1 = {};
var $847bf9dc758b6d61$var$__extends$4 = $847bf9dc758b6d61$var$commonjsGlobal && $847bf9dc758b6d61$var$commonjsGlobal.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($847bf9dc758b6d61$var$CloudAttractClaim$1, "__esModule", {
    value: true
});
$847bf9dc758b6d61$var$CloudAttractClaim$1.CloudAttractClaim = void 0;
var $847bf9dc758b6d61$var$ClaimWithIntegerUserId_1$3 = $847bf9dc758b6d61$var$ClaimWithIntegerUserId$1;
var $847bf9dc758b6d61$var$CloudAttractClaim = /** @class */ function(_super) {
    $847bf9dc758b6d61$var$__extends$4(CloudAttractClaim, _super);
    function CloudAttractClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CloudAttractClaim;
}($847bf9dc758b6d61$var$ClaimWithIntegerUserId_1$3.ClaimWithIntegerUserId);
$847bf9dc758b6d61$var$CloudAttractClaim$1.CloudAttractClaim = $847bf9dc758b6d61$var$CloudAttractClaim;
var $847bf9dc758b6d61$var$CloudCMAClaim$1 = {};
var $847bf9dc758b6d61$var$__extends$3 = $847bf9dc758b6d61$var$commonjsGlobal && $847bf9dc758b6d61$var$commonjsGlobal.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($847bf9dc758b6d61$var$CloudCMAClaim$1, "__esModule", {
    value: true
});
$847bf9dc758b6d61$var$CloudCMAClaim$1.CloudCMAClaim = void 0;
var $847bf9dc758b6d61$var$ClaimWithIntegerUserId_1$2 = $847bf9dc758b6d61$var$ClaimWithIntegerUserId$1;
var $847bf9dc758b6d61$var$CloudCMAClaim = /** @class */ function(_super) {
    $847bf9dc758b6d61$var$__extends$3(CloudCMAClaim, _super);
    function CloudCMAClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CloudCMAClaim;
}($847bf9dc758b6d61$var$ClaimWithIntegerUserId_1$2.ClaimWithIntegerUserId);
$847bf9dc758b6d61$var$CloudCMAClaim$1.CloudCMAClaim = $847bf9dc758b6d61$var$CloudCMAClaim;
var $847bf9dc758b6d61$var$CloudMLXClaim$1 = {};
var $847bf9dc758b6d61$var$__extends$2 = $847bf9dc758b6d61$var$commonjsGlobal && $847bf9dc758b6d61$var$commonjsGlobal.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($847bf9dc758b6d61$var$CloudMLXClaim$1, "__esModule", {
    value: true
});
$847bf9dc758b6d61$var$CloudMLXClaim$1.CloudMLXClaim = void 0;
var $847bf9dc758b6d61$var$ClaimWithIntegerUserId_1$1 = $847bf9dc758b6d61$var$ClaimWithIntegerUserId$1;
var $847bf9dc758b6d61$var$CloudMLXClaim = /** @class */ function(_super) {
    $847bf9dc758b6d61$var$__extends$2(CloudMLXClaim, _super);
    function CloudMLXClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CloudMLXClaim;
}($847bf9dc758b6d61$var$ClaimWithIntegerUserId_1$1.ClaimWithIntegerUserId);
$847bf9dc758b6d61$var$CloudMLXClaim$1.CloudMLXClaim = $847bf9dc758b6d61$var$CloudMLXClaim;
var $847bf9dc758b6d61$var$CloudStreamsClaim$1 = {};
var $847bf9dc758b6d61$var$__extends$1 = $847bf9dc758b6d61$var$commonjsGlobal && $847bf9dc758b6d61$var$commonjsGlobal.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($847bf9dc758b6d61$var$CloudStreamsClaim$1, "__esModule", {
    value: true
});
$847bf9dc758b6d61$var$CloudStreamsClaim$1.CloudStreamsClaim = void 0;
var $847bf9dc758b6d61$var$ClaimWithIntegerUserId_1 = $847bf9dc758b6d61$var$ClaimWithIntegerUserId$1;
var $847bf9dc758b6d61$var$CloudStreamsClaim = /** @class */ function(_super) {
    $847bf9dc758b6d61$var$__extends$1(CloudStreamsClaim, _super);
    function CloudStreamsClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CloudStreamsClaim;
}($847bf9dc758b6d61$var$ClaimWithIntegerUserId_1.ClaimWithIntegerUserId);
$847bf9dc758b6d61$var$CloudStreamsClaim$1.CloudStreamsClaim = $847bf9dc758b6d61$var$CloudStreamsClaim;
var $847bf9dc758b6d61$var$TransactWorkflowClaim$1 = {};
var $847bf9dc758b6d61$var$__extends = $847bf9dc758b6d61$var$commonjsGlobal && $847bf9dc758b6d61$var$commonjsGlobal.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($847bf9dc758b6d61$var$TransactWorkflowClaim$1, "__esModule", {
    value: true
});
$847bf9dc758b6d61$var$TransactWorkflowClaim$1.TransactWorkflowClaim = void 0;
var $847bf9dc758b6d61$var$ClaimWithStringUserId_1 = $847bf9dc758b6d61$var$ClaimWithStringUserId$1;
var $847bf9dc758b6d61$var$TransactWorkflowClaim = /** @class */ function(_super) {
    $847bf9dc758b6d61$var$__extends(TransactWorkflowClaim, _super);
    function TransactWorkflowClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TransactWorkflowClaim;
}($847bf9dc758b6d61$var$ClaimWithStringUserId_1.ClaimWithStringUserId);
$847bf9dc758b6d61$var$TransactWorkflowClaim$1.TransactWorkflowClaim = $847bf9dc758b6d61$var$TransactWorkflowClaim;
Object.defineProperty($847bf9dc758b6d61$var$AppsClaim$1, "__esModule", {
    value: true
});
$847bf9dc758b6d61$var$AppsClaim$1.AppsClaim = void 0;
var $847bf9dc758b6d61$var$BackOfficeClaim_1 = $847bf9dc758b6d61$var$BackOfficeClaim$1;
var $847bf9dc758b6d61$var$CloudAgentSuiteClaim_1 = $847bf9dc758b6d61$var$CloudAgentSuiteClaim$1;
var $847bf9dc758b6d61$var$HomeSpotterBoostClaim_1 = $847bf9dc758b6d61$var$HomeSpotterBoostClaim$1;
var $847bf9dc758b6d61$var$HomeSpotterConnectClaim_1 = $847bf9dc758b6d61$var$HomeSpotterConnectClaim$1;
var $847bf9dc758b6d61$var$HomeSpotterSpacioClaim_1 = $847bf9dc758b6d61$var$HomeSpotterSpacioClaim$1;
var $847bf9dc758b6d61$var$LionDeskClaim_1 = $847bf9dc758b6d61$var$LionDeskClaim$1;
var $847bf9dc758b6d61$var$PropertybaseBackOfficeClaim_1 = $847bf9dc758b6d61$var$PropertybaseBackOfficeClaim$1;
var $847bf9dc758b6d61$var$PropertybaseBoldLeadsClaim_1 = $847bf9dc758b6d61$var$PropertybaseBoldLeadsClaim$1;
var $847bf9dc758b6d61$var$PropertybaseGoClaim_1 = $847bf9dc758b6d61$var$PropertybaseGoClaim$1;
var $847bf9dc758b6d61$var$SalesforceClaim_1 = $847bf9dc758b6d61$var$SalesforceClaim$1;
var $847bf9dc758b6d61$var$TransactionDeskClaim_1 = $847bf9dc758b6d61$var$TransactionDeskClaim$1;
var $847bf9dc758b6d61$var$TerradatumAergoClaim_1 = $847bf9dc758b6d61$var$TerradatumAergoClaim$1;
var $847bf9dc758b6d61$var$TerradatumAgentMetricsClaim_1 = $847bf9dc758b6d61$var$TerradatumAgentMetricsClaim$1;
var $847bf9dc758b6d61$var$XBrokerMetricsClaim_1 = $847bf9dc758b6d61$var$XBrokerMetricsClaim$1;
var $847bf9dc758b6d61$var$TerradatumListingHomeRunClaim_1 = $847bf9dc758b6d61$var$TerradatumListingHomeRunClaim$1;
var $847bf9dc758b6d61$var$TerradatumVScreenClaim_1 = $847bf9dc758b6d61$var$TerradatumVScreenClaim$1;
var $847bf9dc758b6d61$var$WolfConnectClaim_1 = $847bf9dc758b6d61$var$WolfConnectClaim$1;
var $847bf9dc758b6d61$var$ZipFormPlusClaim_1 = $847bf9dc758b6d61$var$ZipFormPlusClaim$1;
var $847bf9dc758b6d61$var$AuthentisignClaim_1 = $847bf9dc758b6d61$var$AuthentisignClaim$1;
var $847bf9dc758b6d61$var$BackOfficeV4Claim_1 = $847bf9dc758b6d61$var$BackOfficeV4Claim$1;
var $847bf9dc758b6d61$var$CloudAttractClaim_1 = $847bf9dc758b6d61$var$CloudAttractClaim$1;
var $847bf9dc758b6d61$var$CloudCMAClaim_1 = $847bf9dc758b6d61$var$CloudCMAClaim$1;
var $847bf9dc758b6d61$var$CloudMLXClaim_1 = $847bf9dc758b6d61$var$CloudMLXClaim$1;
var $847bf9dc758b6d61$var$CloudStreamsClaim_1 = $847bf9dc758b6d61$var$CloudStreamsClaim$1;
var $847bf9dc758b6d61$var$TransactWorkflowClaim_1 = $847bf9dc758b6d61$var$TransactWorkflowClaim$1;
var $847bf9dc758b6d61$var$AppsClaim = /** @class */ function() {
    function AppsClaim() {}
    AppsClaim.prototype.populate = function(appsClaimObject) {
        this.as = this.createApplicationClaim($847bf9dc758b6d61$var$AuthentisignClaim_1.AuthentisignClaim, appsClaimObject, "as");
        this.bo = this.createApplicationClaim($847bf9dc758b6d61$var$BackOfficeClaim_1.BackOfficeClaim, appsClaimObject, "bo");
        this.bov = this.createApplicationClaim($847bf9dc758b6d61$var$BackOfficeV4Claim_1.BackOfficeV4Claim, appsClaimObject, "bov");
        this.cas = this.createApplicationClaim($847bf9dc758b6d61$var$CloudAgentSuiteClaim_1.CloudAgentSuiteClaim, appsClaimObject, "cas");
        this.ca = this.createApplicationClaim($847bf9dc758b6d61$var$CloudAttractClaim_1.CloudAttractClaim, appsClaimObject, "ca");
        this.cc = this.createApplicationClaim($847bf9dc758b6d61$var$CloudCMAClaim_1.CloudCMAClaim, appsClaimObject, "cc");
        this.cm = this.createApplicationClaim($847bf9dc758b6d61$var$CloudMLXClaim_1.CloudMLXClaim, appsClaimObject, "cm");
        this.cs = this.createApplicationClaim($847bf9dc758b6d61$var$CloudStreamsClaim_1.CloudStreamsClaim, appsClaimObject, "cs");
        this.hsb = this.createApplicationClaim($847bf9dc758b6d61$var$HomeSpotterBoostClaim_1.HomeSpotterBoostClaim, appsClaimObject, "hsb");
        this.hsc = this.createApplicationClaim($847bf9dc758b6d61$var$HomeSpotterConnectClaim_1.HomeSpotterConnectClaim, appsClaimObject, "hsc");
        this.hss = this.createApplicationClaim($847bf9dc758b6d61$var$HomeSpotterSpacioClaim_1.HomeSpotterSpacioClaim, appsClaimObject, "hss");
        this.ld = this.createApplicationClaim($847bf9dc758b6d61$var$LionDeskClaim_1.LionDeskClaim, appsClaimObject, "ld");
        this.pbb = this.createApplicationClaim($847bf9dc758b6d61$var$PropertybaseBackOfficeClaim_1.PropertybaseBackOfficeClaim, appsClaimObject, "pbb");
        this.pbl = this.createApplicationClaim($847bf9dc758b6d61$var$PropertybaseBoldLeadsClaim_1.PropertybaseBoldLeadsClaim, appsClaimObject, "pbl");
        this.pbg = this.createApplicationClaim($847bf9dc758b6d61$var$PropertybaseGoClaim_1.PropertybaseGoClaim, appsClaimObject, "pbg");
        this.sf = this.createApplicationClaim($847bf9dc758b6d61$var$SalesforceClaim_1.SalesforceClaim, appsClaimObject, "sf");
        this.tra = this.createApplicationClaim($847bf9dc758b6d61$var$TerradatumAergoClaim_1.TerradatumAergoClaim, appsClaimObject, "tra");
        this.trr = this.createApplicationClaim($847bf9dc758b6d61$var$TerradatumAgentMetricsClaim_1.TerradatumAgentMetricsClaim, appsClaimObject, "trr");
        this.trl = this.createApplicationClaim($847bf9dc758b6d61$var$TerradatumListingHomeRunClaim_1.TerradatumListingHomeRunClaim, appsClaimObject, "trl");
        this.td = this.createApplicationClaim($847bf9dc758b6d61$var$TransactionDeskClaim_1.TransactionDeskClaim, appsClaimObject, "td");
        this.tw = this.createApplicationClaim($847bf9dc758b6d61$var$TransactWorkflowClaim_1.TransactWorkflowClaim, appsClaimObject, "tw");
        this.trv = this.createApplicationClaim($847bf9dc758b6d61$var$TerradatumVScreenClaim_1.TerradatumVScreenClaim, appsClaimObject, "trv");
        this.wc = this.createApplicationClaim($847bf9dc758b6d61$var$WolfConnectClaim_1.WolfConnectClaim, appsClaimObject, "wc");
        this.xbm = this.createApplicationClaim($847bf9dc758b6d61$var$XBrokerMetricsClaim_1.XBrokerMetricsClaim, appsClaimObject, "xbm");
        this.zfp = this.createApplicationClaim($847bf9dc758b6d61$var$ZipFormPlusClaim_1.ZipFormPlusClaim, appsClaimObject, "zfp");
    };
    AppsClaim.prototype.createApplicationClaim = function(claimType, appsClaimObject, claimPropertyName) {
        var claimObject;
        if (appsClaimObject[claimPropertyName]) {
            claimObject = new claimType();
            Object.assign(claimObject, appsClaimObject[claimPropertyName]);
        }
        return claimObject;
    };
    AppsClaim.prototype.getAuthentisignClaim = function() {
        return this.as;
    };
    AppsClaim.prototype.getBackOfficeClaim = function() {
        return this.bo;
    };
    AppsClaim.prototype.getBackOfficeV4Claim = function() {
        return this.bov;
    };
    AppsClaim.prototype.getCloudAgentSuiteClaim = function() {
        return this.cas;
    };
    AppsClaim.prototype.getCloudAttractClaim = function() {
        return this.ca;
    };
    AppsClaim.prototype.getCloudCMAClaim = function() {
        return this.cc;
    };
    AppsClaim.prototype.getCloudMLXClaim = function() {
        return this.cm;
    };
    AppsClaim.prototype.getCloudStreamsClaim = function() {
        return this.cs;
    };
    AppsClaim.prototype.getHomeSpotterBoostClaim = function() {
        return this.hsb;
    };
    AppsClaim.prototype.getHomeSpotterConnectClaim = function() {
        return this.hsc;
    };
    AppsClaim.prototype.getHomeSpotterSpacioClaim = function() {
        return this.hss;
    };
    AppsClaim.prototype.getLionDeskClaim = function() {
        return this.ld;
    };
    AppsClaim.prototype.getPropertybaseBackOfficeClaim = function() {
        return this.pbb;
    };
    AppsClaim.prototype.getPropertybaseBoldLeadsClaim = function() {
        return this.pbl;
    };
    AppsClaim.prototype.getPropertybaseGoClaim = function() {
        return this.pbg;
    };
    AppsClaim.prototype.getSalesforceClaim = function() {
        return this.sf;
    };
    AppsClaim.prototype.getTerradatumAergoClaim = function() {
        return this.tra;
    };
    AppsClaim.prototype.getTerradatumAgentMetricsClaim = function() {
        return this.trr;
    };
    AppsClaim.prototype.getTerradatumListingHomeRunClaim = function() {
        return this.trl;
    };
    AppsClaim.prototype.getTerradatumVScreenClaim = function() {
        return this.trv;
    };
    AppsClaim.prototype.getTransactionDeskClaim = function() {
        return this.td;
    };
    AppsClaim.prototype.getTransactWorkflowClaim = function() {
        return this.tw;
    };
    AppsClaim.prototype.getWolfConnectClaim = function() {
        return this.wc;
    };
    AppsClaim.prototype.getXBrokerMetricsClaim = function() {
        return this.xbm;
    };
    AppsClaim.prototype.getZipFormPlusClaim = function() {
        return this.zfp;
    };
    return AppsClaim;
}();
$847bf9dc758b6d61$var$AppsClaim$1.AppsClaim = $847bf9dc758b6d61$var$AppsClaim;
var $847bf9dc758b6d61$var$IdentityProvidersClaim$1 = {};
var $847bf9dc758b6d61$var$IdentityProviderClaim$1 = {};
Object.defineProperty($847bf9dc758b6d61$var$IdentityProviderClaim$1, "__esModule", {
    value: true
});
$847bf9dc758b6d61$var$IdentityProviderClaim$1.IdentityProviderClaim = void 0;
var $847bf9dc758b6d61$var$IdentityProviderClaim = /** @class */ function() {
    function IdentityProviderClaim() {}
    IdentityProviderClaim.prototype.getIssuedAtTime = function() {
        return this.iat;
    };
    IdentityProviderClaim.prototype.getExpirationTime = function() {
        return this.exp;
    };
    return IdentityProviderClaim;
}();
$847bf9dc758b6d61$var$IdentityProviderClaim$1.IdentityProviderClaim = $847bf9dc758b6d61$var$IdentityProviderClaim;
Object.defineProperty($847bf9dc758b6d61$var$IdentityProvidersClaim$1, "__esModule", {
    value: true
});
$847bf9dc758b6d61$var$IdentityProvidersClaim$1.IdentityProvidersClaim = void 0;
var $847bf9dc758b6d61$var$IdentityProviderClaim_1 = $847bf9dc758b6d61$var$IdentityProviderClaim$1;
var $847bf9dc758b6d61$var$IdentityProvidersClaim = /** @class */ function() {
    function IdentityProvidersClaim() {}
    IdentityProvidersClaim.prototype.populate = function(idpsClaimObject) {
        var _this = this;
        Object.keys(idpsClaimObject).forEach(function(idp) {
            _this[idp] = new $847bf9dc758b6d61$var$IdentityProviderClaim_1.IdentityProviderClaim();
            Object.assign(_this[idp], idpsClaimObject[idp]);
        });
    };
    IdentityProvidersClaim.prototype.get = function(idp) {
        return this[idp];
    };
    return IdentityProvidersClaim;
}();
$847bf9dc758b6d61$var$IdentityProvidersClaim$1.IdentityProvidersClaim = $847bf9dc758b6d61$var$IdentityProvidersClaim;
var $847bf9dc758b6d61$var$ClientClaim$1 = {};
var $847bf9dc758b6d61$var$ApplicationsClaim$1 = {};
Object.defineProperty($847bf9dc758b6d61$var$ApplicationsClaim$1, "__esModule", {
    value: true
});
$847bf9dc758b6d61$var$ApplicationsClaim$1.ApplicationsClaim = void 0;
var $847bf9dc758b6d61$var$ApplicationsClaim = /** @class */ function() {
    function ApplicationsClaim() {}
    ApplicationsClaim.prototype.populate = function(pfmAppsClaimObject) {
        var _this = this;
        Object.keys(pfmAppsClaimObject).forEach(function(code) {
            _this[code] = pfmAppsClaimObject[code];
        });
    };
    ApplicationsClaim.prototype.getCodes = function() {
        return Object.keys(this);
    };
    ApplicationsClaim.prototype.getModuleCodes = function(code) {
        return this[code];
    };
    return ApplicationsClaim;
}();
$847bf9dc758b6d61$var$ApplicationsClaim$1.ApplicationsClaim = $847bf9dc758b6d61$var$ApplicationsClaim;
var $847bf9dc758b6d61$var$ExternalSystemsClaim$1 = {};
var $847bf9dc758b6d61$var$ExternalSystemClaim$1 = {};
Object.defineProperty($847bf9dc758b6d61$var$ExternalSystemClaim$1, "__esModule", {
    value: true
});
$847bf9dc758b6d61$var$ExternalSystemClaim$1.ExternalSystemClaim = void 0;
var $847bf9dc758b6d61$var$ExternalSystemClaim = /** @class */ function() {
    function ExternalSystemClaim() {}
    ExternalSystemClaim.prototype.getNumber = function() {
        return this.num;
    };
    return ExternalSystemClaim;
}();
$847bf9dc758b6d61$var$ExternalSystemClaim$1.ExternalSystemClaim = $847bf9dc758b6d61$var$ExternalSystemClaim;
Object.defineProperty($847bf9dc758b6d61$var$ExternalSystemsClaim$1, "__esModule", {
    value: true
});
$847bf9dc758b6d61$var$ExternalSystemsClaim$1.ExternalSystemsClaim = void 0;
var $847bf9dc758b6d61$var$ExternalSystemClaim_1 = $847bf9dc758b6d61$var$ExternalSystemClaim$1;
var $847bf9dc758b6d61$var$ExternalSystemsClaim = /** @class */ function() {
    function ExternalSystemsClaim() {}
    ExternalSystemsClaim.prototype.populate = function(pfmExtClaimObject) {
        var _this = this;
        Object.keys(pfmExtClaimObject).forEach(function(code) {
            _this[code] = new $847bf9dc758b6d61$var$ExternalSystemClaim_1.ExternalSystemClaim();
            Object.assign(_this[code], pfmExtClaimObject[code]);
        });
    };
    ExternalSystemsClaim.prototype.getCodes = function() {
        return Object.keys(this);
    };
    ExternalSystemsClaim.prototype.getExternalSystem = function(code) {
        return this[code];
    };
    return ExternalSystemsClaim;
}();
$847bf9dc758b6d61$var$ExternalSystemsClaim$1.ExternalSystemsClaim = $847bf9dc758b6d61$var$ExternalSystemsClaim;
Object.defineProperty($847bf9dc758b6d61$var$ClientClaim$1, "__esModule", {
    value: true
});
$847bf9dc758b6d61$var$ClientClaim$1.ClientClaim = void 0;
var $847bf9dc758b6d61$var$ApplicationsClaim_1 = $847bf9dc758b6d61$var$ApplicationsClaim$1;
var $847bf9dc758b6d61$var$ExternalSystemsClaim_1 = $847bf9dc758b6d61$var$ExternalSystemsClaim$1;
var $847bf9dc758b6d61$var$ClientClaim = /** @class */ function() {
    function ClientClaim() {}
    ClientClaim.prototype.populate = function(platformClientObject) {
        if (platformClientObject.apps) {
            this.apps = new $847bf9dc758b6d61$var$ApplicationsClaim_1.ApplicationsClaim();
            this.apps.populate(platformClientObject.apps);
            delete platformClientObject.apps;
        }
        if (platformClientObject.ext) {
            this.ext = new $847bf9dc758b6d61$var$ExternalSystemsClaim_1.ExternalSystemsClaim();
            this.ext.populate(platformClientObject.ext);
            delete platformClientObject.ext;
        }
        Object.assign(this, platformClientObject);
    };
    ClientClaim.prototype.getId = function() {
        return this.cid;
    };
    ClientClaim.prototype.getType = function() {
        return this.ctp;
    };
    ClientClaim.prototype.getRoleId = function() {
        return this.rid;
    };
    ClientClaim.prototype.getOfficeId = function() {
        return this.oid;
    };
    ClientClaim.prototype.getBrokerageId = function() {
        return this.bid;
    };
    ClientClaim.prototype.getUserId = function() {
        return this.uid;
    };
    ClientClaim.prototype.getApplications = function() {
        return this.apps;
    };
    ClientClaim.prototype.getExternalSystems = function() {
        return this.ext;
    };
    ClientClaim.prototype.isUserClient = function() {
        return this.ctp === ClientClaim.CLIENT_TYPE_USER;
    };
    ClientClaim.CLIENT_TYPE_USER = "User";
    return ClientClaim;
}();
$847bf9dc758b6d61$var$ClientClaim$1.ClientClaim = $847bf9dc758b6d61$var$ClientClaim;
Object.defineProperty($847bf9dc758b6d61$var$LwtClaim$1, "__esModule", {
    value: true
});
$847bf9dc758b6d61$var$LwtClaim$1.LwtClaim = void 0;
var $847bf9dc758b6d61$var$AppsClaim_1 = $847bf9dc758b6d61$var$AppsClaim$1;
var $847bf9dc758b6d61$var$IdentityProvidersClaim_1 = $847bf9dc758b6d61$var$IdentityProvidersClaim$1;
var $847bf9dc758b6d61$var$ClientClaim_1 = $847bf9dc758b6d61$var$ClientClaim$1;
var $847bf9dc758b6d61$var$LwtUserType;
(function(LwtUserType) {
    LwtUserType["INTERNAL"] = "I";
    LwtUserType["CLIENT"] = "C";
    LwtUserType["APP"] = "A";
    LwtUserType["SERVICE"] = "S";
})($847bf9dc758b6d61$var$LwtUserType || ($847bf9dc758b6d61$var$LwtUserType = {}));
var $847bf9dc758b6d61$var$LwtClaim = /** @class */ function() {
    function LwtClaim() {
        this.utp = $847bf9dc758b6d61$var$LwtUserType.CLIENT;
        this.pfmAuth = false;
    }
    LwtClaim.prototype.populate = function(lwtClaimObject) {
        var _this = this;
        if (lwtClaimObject.pfm) {
            this.pfm = [];
            lwtClaimObject.pfm.forEach(function(pfmClient) {
                var _a;
                var platformClient = new $847bf9dc758b6d61$var$ClientClaim_1.ClientClaim();
                platformClient.populate(pfmClient);
                (_a = _this.pfm) === null || _a === void 0 || _a.push(platformClient);
            });
            delete lwtClaimObject.pfm;
        }
        if (lwtClaimObject.apps) {
            this.apps = new $847bf9dc758b6d61$var$AppsClaim_1.AppsClaim();
            this.apps.populate(lwtClaimObject.apps);
            delete lwtClaimObject.apps;
        }
        if (lwtClaimObject.idps) {
            this.idps = new $847bf9dc758b6d61$var$IdentityProvidersClaim_1.IdentityProvidersClaim();
            this.idps.populate(lwtClaimObject.idps);
            delete lwtClaimObject.idps;
        }
        Object.assign(this, lwtClaimObject);
    };
    LwtClaim.prototype.isInternalToken = function() {
        return this.utp === $847bf9dc758b6d61$var$LwtUserType.INTERNAL;
    };
    LwtClaim.prototype.isClientToken = function() {
        return this.utp === $847bf9dc758b6d61$var$LwtUserType.CLIENT;
    };
    LwtClaim.prototype.isAppToken = function() {
        return this.utp === $847bf9dc758b6d61$var$LwtUserType.APP;
    };
    LwtClaim.prototype.isServiceToken = function() {
        return this.utp === $847bf9dc758b6d61$var$LwtUserType.SERVICE;
    };
    LwtClaim.prototype.getUserId = function() {
        return this.uid;
    };
    LwtClaim.prototype.getUserType = function() {
        return this.utp;
    };
    LwtClaim.prototype.getSessionId = function() {
        return this.sid;
    };
    LwtClaim.prototype.getGroups = function() {
        return this.groups;
    };
    LwtClaim.prototype.getClients = function() {
        return this.pfm;
    };
    LwtClaim.prototype.getAppsClaim = function() {
        return this.apps;
    };
    LwtClaim.prototype.getIdentityProvidersClaim = function() {
        return this.idps;
    };
    LwtClaim.prototype.getPersonalClient = function() {
        var _a;
        return (_a = this.pfm) === null || _a === void 0 ? void 0 : _a.find(function(client) {
            return client.getType() === "User";
        });
    };
    LwtClaim.prototype.getPfmAuth = function() {
        return this.pfmAuth;
    };
    return LwtClaim;
}();
$847bf9dc758b6d61$var$LwtClaim$1.LwtClaim = $847bf9dc758b6d61$var$LwtClaim;
Object.defineProperty($847bf9dc758b6d61$var$JwtPayload$1, "__esModule", {
    value: true
});
$847bf9dc758b6d61$var$JwtPayload$1.JwtPayload = void 0;
var $847bf9dc758b6d61$var$LwtClaim_1 = $847bf9dc758b6d61$var$LwtClaim$1;
var $847bf9dc758b6d61$var$JwtPayload = /** @class */ function() {
    function JwtPayload() {}
    JwtPayload.prototype.populate = function(parsedClaims) {
        if (!!parsedClaims["http://lwt"]) {
            this.lwt = new $847bf9dc758b6d61$var$LwtClaim_1.LwtClaim();
            this.lwt.populate(parsedClaims["http://lwt"]);
            delete parsedClaims["http://lwt"];
        }
        Object.assign(this, parsedClaims);
    };
    JwtPayload.prototype.getIssuer = function() {
        return this.iss;
    };
    JwtPayload.prototype.getSubject = function() {
        return this.sub;
    };
    JwtPayload.prototype.getAudience = function() {
        return this.aud;
    };
    JwtPayload.prototype.getFirstName = function() {
        return this.given_name;
    };
    JwtPayload.prototype.getLastName = function() {
        return this.family_name;
    };
    JwtPayload.prototype.getNickname = function() {
        return this.nickname;
    };
    JwtPayload.prototype.getName = function() {
        return this.name;
    };
    JwtPayload.prototype.getEmail = function() {
        return this.email;
    };
    JwtPayload.prototype.getIssuedAtTime = function() {
        return this.iat;
    };
    JwtPayload.prototype.getExpirationTime = function() {
        return this.exp;
    };
    JwtPayload.prototype.getPicture = function() {
        return this.picture;
    };
    JwtPayload.prototype.getLwtClaim = function() {
        return this.lwt;
    };
    JwtPayload.prototype.getEmailVerified = function() {
        return this.email_verified;
    };
    return JwtPayload;
}();
$847bf9dc758b6d61$var$JwtPayload$1.JwtPayload = $847bf9dc758b6d61$var$JwtPayload;
Object.defineProperty($847bf9dc758b6d61$var$Authentication$1, "__esModule", {
    value: true
});
var $847bf9dc758b6d61$var$buffer_1 = (0, (/*@__PURE__*/$parcel$interopDefault($6ZWSX)));
var $847bf9dc758b6d61$var$JwtPayload_1 = $847bf9dc758b6d61$var$JwtPayload$1;
var $847bf9dc758b6d61$var$Authentication = /** @class */ function() {
    function Authentication() {
        this.parseToken = function(token) {
            var _a, _b;
            var jwtPayload;
            var base64 = (_b = (_a = token === null || token === void 0 ? void 0 : token.split(".")[1]) === null || _a === void 0 ? void 0 : _a.replace(/-/g, "+")) === null || _b === void 0 ? void 0 : _b.replace(/_/g, "/");
            if (base64) {
                var parsedClaims = JSON.parse($847bf9dc758b6d61$var$buffer_1.Buffer.from(base64, "base64").toString());
                jwtPayload = new $847bf9dc758b6d61$var$JwtPayload_1.JwtPayload();
                jwtPayload.populate(parsedClaims);
            }
            return jwtPayload;
        };
    }
    return Authentication;
}();
var $847bf9dc758b6d61$var$_default = $847bf9dc758b6d61$var$Authentication$1.default = new $847bf9dc758b6d61$var$Authentication;
var $847bf9dc758b6d61$var$css_248z$5 = '.ClientSwitcher-module_client-picker__info-icon__KZiux{align-items:center;cursor:pointer;display:inline-flex;margin-left:6px;vertical-align:middle}.ClientSwitcher-module_client-picker__tooltip__dPRGh{background-color:rgba(17,24,39,.8);border-radius:4px;box-shadow:0 2px 8px rgba(0,0,0,.15);color:#fff;font-size:12px;font-weight:400;line-height:16px;max-width:200px;min-width:180px;opacity:1;padding:6px;pointer-events:none;position:absolute;transition:opacity .2s ease-in-out;white-space:pre-line;z-index:1070}.ClientSwitcher-module_client-picker__tooltip__dPRGh[data-placement^=top]{margin-bottom:6px}.ClientSwitcher-module_client-picker__tooltip__dPRGh[data-placement^=top]>.ClientSwitcher-module_client-picker__tooltip-arrow__XlNe8{bottom:-6px;left:50%;transform:translateX(-50%)}.ClientSwitcher-module_client-picker__tooltip__dPRGh[data-placement^=top]>.ClientSwitcher-module_client-picker__tooltip-arrow__XlNe8:before{border-color:rgba(17,24,39,.8) transparent transparent;border-width:6px 6px 0;left:0;top:0;transform:none}.ClientSwitcher-module_client-picker__tooltip__dPRGh[data-placement^=bottom]{margin-top:6px}.ClientSwitcher-module_client-picker__tooltip__dPRGh[data-placement^=bottom]>.ClientSwitcher-module_client-picker__tooltip-arrow__XlNe8{left:50%;top:-6px;transform:translateX(-50%)}.ClientSwitcher-module_client-picker__tooltip__dPRGh[data-placement^=bottom]>.ClientSwitcher-module_client-picker__tooltip-arrow__XlNe8:before{border-color:transparent transparent rgba(17,24,39,.8);border-width:0 6px 6px;left:0;top:0;transform:none}.ClientSwitcher-module_client-picker__tooltip__dPRGh[data-placement^=left]>.ClientSwitcher-module_client-picker__tooltip-arrow__XlNe8{right:-6px;top:50%;transform:translateY(-50%)}.ClientSwitcher-module_client-picker__tooltip__dPRGh[data-placement^=left]>.ClientSwitcher-module_client-picker__tooltip-arrow__XlNe8:before{border-color:transparent transparent transparent rgba(17,24,39,.8);border-width:6px 0 6px 6px;left:0;top:0;transform:none}.ClientSwitcher-module_client-picker__tooltip__dPRGh[data-placement^=right]>.ClientSwitcher-module_client-picker__tooltip-arrow__XlNe8{left:-6px;top:50%;transform:translateY(-50%)}.ClientSwitcher-module_client-picker__tooltip__dPRGh[data-placement^=right]>.ClientSwitcher-module_client-picker__tooltip-arrow__XlNe8:before{border-color:transparent rgba(17,24,39,.8) transparent transparent;border-width:6px 6px 6px 0;left:0;top:0;transform:none}.ClientSwitcher-module_client-picker__tooltip-arrow__XlNe8{display:block;height:12px;pointer-events:none;position:absolute;width:12px}.ClientSwitcher-module_client-picker__tooltip-arrow__XlNe8:before{border-style:solid;content:"";display:block;height:0;position:absolute;width:0}.ClientSwitcher-module_client-picker__container__w6lz5{position:relative}.ClientSwitcher-module_client-picker__button__AYSVm{align-items:center;background-color:transparent;border:none;border-radius:6px;cursor:pointer;display:flex;font-size:14px;font-weight:600;gap:8px;max-width:250px;overflow:hidden;padding:4px;white-space:nowrap}.ClientSwitcher-module_client-picker__button__AYSVm:focus{outline:2px solid var(--helix-brand);outline-offset:2px}.ClientSwitcher-module_client-picker__button__AYSVm:hover{background-color:var(--helix-brand-pale);color:var(--helix-brand)}.ClientSwitcher-module_client-picker__button__AYSVm[aria-expanded=true]{background-color:var(--helix-gray-200);color:var(--helix-brand)}.ClientSwitcher-module_client-picker__info__ikCgt{align-items:flex-start;display:flex;flex-direction:column;line-height:1.3;margin:0 8px}.ClientSwitcher-module_client-picker__product-name__lXSKS{color:var(--helix-gray-900);font-weight:600}.ClientSwitcher-module_client-picker__client__on-MH{color:var(--helix-gray-600);font-size:12px;font-weight:400;max-width:150px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ClientSwitcher-module_client-picker__dropdown-menu__LbGis{min-width:280px;width:280px;z-index:9999}.ClientSwitcher-module_client-picker__section-header__oBNlW,.ClientSwitcher-module_client-picker__section-separator__2W-I1{pointer-events:none}.ClientSwitcher-module_client-picker__logo__B2Ek-{display:flex}.ClientSwitcher-module_client-picker__logo__B2Ek- img{height:32px;width:32px}.ClientSwitcher-module_client-picker__dropdown-menu__LbGis{background-color:#fff;border-radius:4px;box-shadow:0 0 1px rgba(0,0,0,.2),0 4px 8px rgba(0,0,0,.1);max-height:calc(100vh - 80px);min-width:200px;opacity:0;overflow-y:auto;pointer-events:none;position:absolute;transition:opacity .2s ease,transform .2s ease;z-index:1000}.ClientSwitcher-module_client-picker__dropdown-menu__LbGis:focus{outline:none}.ClientSwitcher-module_client-picker__dropdown-menu__LbGis.ClientSwitcher-module_open__UFQyP{opacity:1;pointer-events:auto}.ClientSwitcher-module_client-picker__dropdown-menu__LbGis.ClientSwitcher-module_bottom__8-PSz{margin-top:8px;transform:translateY(-8px)}.ClientSwitcher-module_client-picker__dropdown-menu__LbGis.ClientSwitcher-module_bottom__8-PSz.ClientSwitcher-module_open__UFQyP{transform:translateY(0)}.ClientSwitcher-module_client-picker__dropdown-menu__LbGis.ClientSwitcher-module_top__2gAoC{margin-bottom:8px;transform:translateY(8px)}.ClientSwitcher-module_client-picker__dropdown-menu__LbGis.ClientSwitcher-module_top__2gAoC.ClientSwitcher-module_open__UFQyP{transform:translateY(0)}.ClientSwitcher-module_client-picker__dropdown-menu__LbGis.ClientSwitcher-module_right__LQQWr{margin-left:8px;transform:translateX(-8px)}.ClientSwitcher-module_client-picker__dropdown-menu__LbGis.ClientSwitcher-module_right__LQQWr.ClientSwitcher-module_open__UFQyP{transform:translateX(0)}.ClientSwitcher-module_client-picker__dropdown-menu__LbGis.ClientSwitcher-module_left__T0vnc{margin-right:8px;transform:translateX(8px)}.ClientSwitcher-module_client-picker__dropdown-menu__LbGis.ClientSwitcher-module_left__T0vnc.ClientSwitcher-module_open__UFQyP{transform:translateX(0)}.ClientSwitcher-module_client-picker__dropdown-menu__LbGis ul{list-style:none;margin:0;padding:16px 8px 8px}.ClientSwitcher-module_client-picker__dropdown-menu__LbGis.client-picker__dropdown-menu--no-client-header ul{padding-top:8px}.ClientSwitcher-module_client-picker__dropdown-menu__LbGis .ClientSwitcher-module_client-picker__section-separator__2W-I1{background-color:#e5e5e5;height:1px;margin:8px 0}.ClientSwitcher-module_client-picker__dropdown-menu__LbGis .ClientSwitcher-module_client-picker__section-header__oBNlW{color:#4b5563;font-size:12px;letter-spacing:.1em;padding:8px;text-transform:uppercase}.ClientSwitcher-module_client-picker__dropdown-menu__LbGis .ClientSwitcher-module_client-picker__dropdown-item__Fko3W{border-radius:4px;cursor:pointer;display:flex;margin-bottom:2px;padding:8px 12px}.ClientSwitcher-module_client-picker__dropdown-menu__LbGis .ClientSwitcher-module_client-picker__dropdown-item__Fko3W.ClientSwitcher-module_client-picker__dropdown-item--highlighted__pUYpx,.ClientSwitcher-module_client-picker__dropdown-menu__LbGis .ClientSwitcher-module_client-picker__dropdown-item__Fko3W.ClientSwitcher-module_client-picker__dropdown-item--selected-client__35zgP,.ClientSwitcher-module_client-picker__dropdown-menu__LbGis .ClientSwitcher-module_client-picker__dropdown-item__Fko3W:hover{background-color:var(--helix-brand-pale);color:var(--helix-brand)}.ClientSwitcher-module_client-picker__dropdown-menu__LbGis .ClientSwitcher-module_client-picker__dropdown-item__Fko3W .ClientSwitcher-module_client-picker__dropdown-item__Fko3W{cursor:pointer}.ClientSwitcher-module_client-picker__dropdown-menu__LbGis .ClientSwitcher-module_client-picker__dropdown-item__Fko3W .ClientSwitcher-module_client-picker__dropdown-item--skeleton__UbG-1{cursor:default}.ClientSwitcher-module_client-picker__dropdown-menu__LbGis .ClientSwitcher-module_client-picker__client-menu-item__OzzvY{align-items:center;display:flex;flex:1;gap:8px}.ClientSwitcher-module_client-picker__dropdown-menu__LbGis .ClientSwitcher-module_client-picker__client-menu-item__OzzvY .checkmark-outlined path{fill:var(--helix-brand)}.ClientSwitcher-module_client-picker__dropdown-menu__LbGis .ClientSwitcher-module_client-picker__client-avatar__AYcZq{border-radius:12px;height:24px;object-fit:cover;width:24px}.ClientSwitcher-module_client-picker__dropdown-menu__LbGis .ClientSwitcher-module_client-picker__client-text__xq0zB{display:flex;flex:1;flex-direction:column;gap:1px}.ClientSwitcher-module_client-picker__dropdown-menu__LbGis .ClientSwitcher-module_client-picker__item-label__LMyAS{color:#374151;display:flex;flex-wrap:wrap;font-size:14px;font-weight:500;line-height:1.2}.ClientSwitcher-module_client-picker__dropdown-menu__LbGis .ClientSwitcher-module_client-picker__item-label__LMyAS .ClientSwitcher-module_client-picker__label-name__Q-nq5{flex:1}.ClientSwitcher-module_client-picker__dropdown-menu__LbGis .ClientSwitcher-module_client-picker__item-label__LMyAS .ClientSwitcher-module_client-picker__label-name--centered__LRfdf{margin-top:4px}.ClientSwitcher-module_client-picker__dropdown-menu__LbGis .ClientSwitcher-module_client-picker__description__c-CU3{color:#6b7280;font-size:12px;line-height:1.2}.ClientSwitcher-module_client-picker__dropdown-menu__LbGis .ClientSwitcher-module_client-picker__client-right__Q1T06{align-items:center;display:flex}.ClientSwitcher-module_client-picker__dropdown-menu__LbGis .ClientSwitcher-module_client-picker__checkmark__ClGVD{color:var(--helix-brand);font-weight:700}.ClientSwitcher-module_client-picker__dropdown-menu__LbGis .ClientSwitcher-module_client-picker__checkmark-svg__36Htz{align-items:center;display:flex}.ClientSwitcher-module_client-picker__dropdown-menu__LbGis .ClientSwitcher-module_client-picker__switch-link__lycgB{color:var(--helix-brand);font-size:12px;font-weight:500}.ClientSwitcher-module_client-picker__dropdown-menu__LbGis .ClientSwitcher-module_client-picker__app-menu-item__gCQpQ{align-items:flex-start;display:flex;flex:1;gap:8px}.ClientSwitcher-module_client-picker__dropdown-menu__LbGis .ClientSwitcher-module_client-picker__app-icon__n6wzi{height:24px;object-fit:cover;width:24px}.ClientSwitcher-module_client-picker__dropdown-menu__LbGis .ClientSwitcher-module_client-picker__app-text__e9CRS{display:flex;flex:1;flex-direction:column;gap:2px}.ClientSwitcher-module_client-picker__skeleton-avatar__NE1Ff{background:#e5e7eb;border-radius:12px;height:24px;width:24px}.ClientSwitcher-module_client-picker__skeleton-icon__iwkv-{background:#e5e7eb;border-radius:4px;height:24px;width:24px}.ClientSwitcher-module_client-picker__skeleton-label__sZPtA{background:#e5e7eb;border-radius:4px;display:block;height:16px;width:80px}.ClientSwitcher-module_client-picker__skeleton-description__gnrZN{background:#e5e7eb;border-radius:4px;display:block;height:12px;margin-top:2px;width:40px}.ClientSwitcher-module_client-picker__skeleton-product-description__q2jUf{background:#e5e7eb;border-radius:4px;display:block;height:12px;margin-top:2px;width:60px}.ClientSwitcher-module_client-picker__skeleton-switch__S95RN{background:#e5e7eb;border-radius:4px;display:block;height:16px;width:32px}.ClientSwitcher-module_client-picker__client-preview-container__tAkf-{background-color:var(--helix-gray-50);border:1px solid var(--helix-gray-200);border-radius:4px;margin:4px 0}.ClientSwitcher-module_client-picker__client-preview__noxeE{pointer-events:none}.ClientSwitcher-module_client-picker__preview-trigger__VLHGJ{align-items:center;background-color:transparent;border-radius:4px;cursor:pointer;display:flex;gap:8px;padding:8px 12px;pointer-events:auto;transition:background-color .2s ease}.ClientSwitcher-module_client-picker__preview-trigger__VLHGJ:hover{background-color:var(--helix-gray-200)}.ClientSwitcher-module_client-picker__preview-trigger--highlighted__TjKCl{background-color:var(--helix-gray-200);outline-offset:-2px}.ClientSwitcher-module_client-picker__preview-avatars__KrMnu{align-items:center;display:flex;position:relative}.ClientSwitcher-module_client-picker__preview-avatar__xmJAX{border:1px solid var(--helix-gray-400);border-radius:50%;height:20px;margin-left:-6px;position:relative;width:20px}.ClientSwitcher-module_client-picker__preview-avatar__xmJAX:first-child{margin-left:0}.ClientSwitcher-module_client-picker__preview-count-icon__yNw5j{color:#fff;height:10px;width:10px}.ClientSwitcher-module_client-picker__preview-icon__KyFVB{align-items:center;background-color:var(--helix-gray-300);border-radius:50%;display:flex;height:20px;justify-content:center;width:20px}.ClientSwitcher-module_client-picker__preview-user-icon__TSNml{color:var(--helix-gray-600);height:12px;width:12px}.ClientSwitcher-module_client-picker__preview-label__xbI1P{color:var(--helix-gray-600);flex:1;font-size:12px;font-weight:500}.ClientSwitcher-module_client-picker__preview-chevron__1o5wu{height:12px;transform:rotate(0deg);transition:transform .2s ease;width:12px}.ClientSwitcher-module_client-picker__preview-chevron--expanded__DGswI{transform:rotate(180deg)}.ClientSwitcher-module_client-picker__expanded-client-item__xlJvm:hover{background-color:var(--helix-brand-pale);color:var(--helix-brand)}.ClientSwitcher-module_client-picker__expanded-client-item--selected__GCO5I{background-color:#f0f7f1}.ClientSwitcher-module_client-picker__expanded-client__sKB4w{align-items:center;display:flex;gap:12px;padding:8px 16px}.ClientSwitcher-module_client-picker__expanded-avatar__-gkyP{border:1px solid #e5e5e5;border-radius:50%;height:28px;width:28px}.ClientSwitcher-module_client-picker__expanded-text__4WTLx{display:flex;flex:1;flex-direction:column;gap:2px}.ClientSwitcher-module_client-picker__expanded-name__YuHr2{color:var(--helix-gray-900);font-size:13px;font-weight:500}.ClientSwitcher-module_client-picker__expanded-type__1KUfd{color:var(--helix-gray-500);font-size:11px}.ClientSwitcher-module_client-picker__expanded-checkmark__4ejXa{color:#28a745;font-size:14px;font-weight:600}.ClientSwitcher-module_client-picker__expanded-clients__5jQpK{margin-top:4px;padding:0 8px 8px}.ClientSwitcher-module_client-picker__expanded-client-item__xlJvm{border-radius:4px;cursor:pointer;margin-bottom:2px;padding:8px 12px;pointer-events:auto}.ClientSwitcher-module_client-picker__expanded-client-item--highlighted__RxUYK,.ClientSwitcher-module_client-picker__expanded-client-item--selected__GCO5I,.ClientSwitcher-module_client-picker__expanded-client-item__xlJvm:hover{background-color:var(--helix-brand-pale);color:var(--helix-brand)}.client-picker__legacy-instance{z-index:10000!important}.ClientSwitcher-module_application_header_user__0n1nk{border-radius:50%;margin-left:8px;padding:0}';
var $847bf9dc758b6d61$var$styles$2 = {
    "client-picker__info-icon": "ClientSwitcher-module_client-picker__info-icon__KZiux",
    "client-picker__tooltip": "ClientSwitcher-module_client-picker__tooltip__dPRGh",
    "client-picker__tooltip-arrow": "ClientSwitcher-module_client-picker__tooltip-arrow__XlNe8",
    "client-picker__container": "ClientSwitcher-module_client-picker__container__w6lz5",
    "client-picker__button": "ClientSwitcher-module_client-picker__button__AYSVm",
    "client-picker__info": "ClientSwitcher-module_client-picker__info__ikCgt",
    "client-picker__product-name": "ClientSwitcher-module_client-picker__product-name__lXSKS",
    "client-picker__client": "ClientSwitcher-module_client-picker__client__on-MH",
    "client-picker__dropdown-menu": "ClientSwitcher-module_client-picker__dropdown-menu__LbGis",
    "client-picker__section-header": "ClientSwitcher-module_client-picker__section-header__oBNlW",
    "client-picker__section-separator": "ClientSwitcher-module_client-picker__section-separator__2W-I1",
    "client-picker__logo": "ClientSwitcher-module_client-picker__logo__B2Ek-",
    "open": "ClientSwitcher-module_open__UFQyP",
    "bottom": "ClientSwitcher-module_bottom__8-PSz",
    "top": "ClientSwitcher-module_top__2gAoC",
    "right": "ClientSwitcher-module_right__LQQWr",
    "left": "ClientSwitcher-module_left__T0vnc",
    "client-picker__dropdown-item": "ClientSwitcher-module_client-picker__dropdown-item__Fko3W",
    "client-picker__dropdown-item--highlighted": "ClientSwitcher-module_client-picker__dropdown-item--highlighted__pUYpx",
    "client-picker__dropdown-item--selected-client": "ClientSwitcher-module_client-picker__dropdown-item--selected-client__35zgP",
    "client-picker__dropdown-item--skeleton": "ClientSwitcher-module_client-picker__dropdown-item--skeleton__UbG-1",
    "client-picker__client-menu-item": "ClientSwitcher-module_client-picker__client-menu-item__OzzvY",
    "client-picker__client-avatar": "ClientSwitcher-module_client-picker__client-avatar__AYcZq",
    "client-picker__client-text": "ClientSwitcher-module_client-picker__client-text__xq0zB",
    "client-picker__item-label": "ClientSwitcher-module_client-picker__item-label__LMyAS",
    "client-picker__label-name": "ClientSwitcher-module_client-picker__label-name__Q-nq5",
    "client-picker__label-name--centered": "ClientSwitcher-module_client-picker__label-name--centered__LRfdf",
    "client-picker__description": "ClientSwitcher-module_client-picker__description__c-CU3",
    "client-picker__client-right": "ClientSwitcher-module_client-picker__client-right__Q1T06",
    "client-picker__checkmark": "ClientSwitcher-module_client-picker__checkmark__ClGVD",
    "client-picker__checkmark-svg": "ClientSwitcher-module_client-picker__checkmark-svg__36Htz",
    "client-picker__switch-link": "ClientSwitcher-module_client-picker__switch-link__lycgB",
    "client-picker__app-menu-item": "ClientSwitcher-module_client-picker__app-menu-item__gCQpQ",
    "client-picker__app-icon": "ClientSwitcher-module_client-picker__app-icon__n6wzi",
    "client-picker__app-text": "ClientSwitcher-module_client-picker__app-text__e9CRS",
    "client-picker__skeleton-avatar": "ClientSwitcher-module_client-picker__skeleton-avatar__NE1Ff",
    "client-picker__skeleton-icon": "ClientSwitcher-module_client-picker__skeleton-icon__iwkv-",
    "client-picker__skeleton-label": "ClientSwitcher-module_client-picker__skeleton-label__sZPtA",
    "client-picker__skeleton-description": "ClientSwitcher-module_client-picker__skeleton-description__gnrZN",
    "client-picker__skeleton-product-description": "ClientSwitcher-module_client-picker__skeleton-product-description__q2jUf",
    "client-picker__skeleton-switch": "ClientSwitcher-module_client-picker__skeleton-switch__S95RN",
    "client-picker__client-preview-container": "ClientSwitcher-module_client-picker__client-preview-container__tAkf-",
    "client-picker__client-preview": "ClientSwitcher-module_client-picker__client-preview__noxeE",
    "client-picker__preview-trigger": "ClientSwitcher-module_client-picker__preview-trigger__VLHGJ",
    "client-picker__preview-trigger--highlighted": "ClientSwitcher-module_client-picker__preview-trigger--highlighted__TjKCl",
    "client-picker__preview-avatars": "ClientSwitcher-module_client-picker__preview-avatars__KrMnu",
    "client-picker__preview-avatar": "ClientSwitcher-module_client-picker__preview-avatar__xmJAX",
    "client-picker__preview-count-icon": "ClientSwitcher-module_client-picker__preview-count-icon__yNw5j",
    "client-picker__preview-icon": "ClientSwitcher-module_client-picker__preview-icon__KyFVB",
    "client-picker__preview-user-icon": "ClientSwitcher-module_client-picker__preview-user-icon__TSNml",
    "client-picker__preview-label": "ClientSwitcher-module_client-picker__preview-label__xbI1P",
    "client-picker__preview-chevron": "ClientSwitcher-module_client-picker__preview-chevron__1o5wu",
    "client-picker__preview-chevron--expanded": "ClientSwitcher-module_client-picker__preview-chevron--expanded__DGswI",
    "client-picker__expanded-client-item": "ClientSwitcher-module_client-picker__expanded-client-item__xlJvm",
    "client-picker__expanded-client-item--selected": "ClientSwitcher-module_client-picker__expanded-client-item--selected__GCO5I",
    "client-picker__expanded-client": "ClientSwitcher-module_client-picker__expanded-client__sKB4w",
    "client-picker__expanded-avatar": "ClientSwitcher-module_client-picker__expanded-avatar__-gkyP",
    "client-picker__expanded-text": "ClientSwitcher-module_client-picker__expanded-text__4WTLx",
    "client-picker__expanded-name": "ClientSwitcher-module_client-picker__expanded-name__YuHr2",
    "client-picker__expanded-type": "ClientSwitcher-module_client-picker__expanded-type__1KUfd",
    "client-picker__expanded-checkmark": "ClientSwitcher-module_client-picker__expanded-checkmark__4ejXa",
    "client-picker__expanded-clients": "ClientSwitcher-module_client-picker__expanded-clients__5jQpK",
    "client-picker__expanded-client-item--highlighted": "ClientSwitcher-module_client-picker__expanded-client-item--highlighted__RxUYK",
    "application_header_user": "ClientSwitcher-module_application_header_user__0n1nk"
};
$847bf9dc758b6d61$var$styleInject($847bf9dc758b6d61$var$css_248z$5);
const $847bf9dc758b6d61$var$CustomTooltip = ({ content: content, children: children })=>{
    const [open, setOpen] = (0, $acw62.useState)(false);
    const [coords, setCoords] = (0, $acw62.useState)({
        left: 0,
        top: 0,
        placement: "right"
    });
    const iconRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (open && iconRef.current) {
            const rect = iconRef.current.getBoundingClientRect();
            const tooltipWidth = 200;
            const tooltipHeight = 40;
            const margin = 8;
            const vw = window.innerWidth;
            const vh = window.innerHeight;
            // Try right
            if (rect.right + margin + tooltipWidth < vw) setCoords({
                left: rect.right + margin + window.scrollX,
                top: rect.top + rect.height / 2 + window.scrollY,
                placement: "right"
            });
            else if (rect.left - margin - tooltipWidth > 0) // Try left
            setCoords({
                left: rect.left - margin - tooltipWidth + window.scrollX,
                top: rect.top + rect.height / 2 + window.scrollY,
                placement: "left"
            });
            else if (rect.bottom + margin + tooltipHeight < vh) // Try bottom
            setCoords({
                left: rect.left + rect.width / 2 + window.scrollX,
                top: rect.bottom + margin + window.scrollY,
                placement: "bottom"
            });
            else // Default to top
            setCoords({
                left: rect.left + rect.width / 2 + window.scrollX,
                top: rect.top - margin - tooltipHeight + window.scrollY,
                placement: "top"
            });
        }
    }, [
        open
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            position: "relative",
            display: "inline-block"
        },
        onMouseEnter: ()=>setOpen(true),
        onMouseLeave: ()=>setOpen(false),
        ref: iconRef
    }, children, open && coords && typeof document !== "undefined" ? (0, $1u0KT.createPortal)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: [
            $847bf9dc758b6d61$var$styles$2["client-picker__tooltip"],
            $847bf9dc758b6d61$var$styles$2["client-picker__tooltip--visible"]
        ].join(" "),
        style: {
            left: coords.left,
            top: coords.top,
            transform: coords.placement === "right" ? "translateY(-50%)" : coords.placement === "left" ? "translateY(-50%)" : coords.placement === "top" ? "translate(-50%, -100%)" : "translate(-50%, 0)"
        },
        "data-placement": coords.placement,
        role: "tooltip"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: $847bf9dc758b6d61$var$styles$2["client-picker__tooltip-arrow"]
    }), content), document.body) : null);
};
const $847bf9dc758b6d61$var$useDropdownMenu = ({ placement: placement = "auto", onSelect: onSelect, items: items, highlightFirst: highlightFirst = false })=>{
    const [isOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [highlightedIndex, setHighlightedIndex] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [calculatedPlacement, setCalculatedPlacement] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState("bottom");
    const buttonRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const menuRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Calculate optimal placement when auto is selected
    const calculatePlacement = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        if (placement !== "auto" || !buttonRef.current) return placement;
        const buttonRect = buttonRef.current.getBoundingClientRect();
        const viewport = {
            width: window.innerWidth,
            height: window.innerHeight
        };
        const spaceBelow = viewport.height - buttonRect.bottom;
        const spaceAbove = buttonRect.top;
        const spaceRight = viewport.width - buttonRect.right;
        const spaceLeft = buttonRect.left;
        // Assume menu dimensions (we could measure these dynamically)
        const menuHeight = 120; // Approximate height
        const menuWidth = 160;
        // Prefer bottom first, then top, then sides
        if (spaceBelow >= menuHeight) return "bottom";
        if (spaceAbove >= menuHeight) return "top";
        if (spaceRight >= menuWidth) return "right";
        if (spaceLeft >= menuWidth) return "left";
        // Fallback to bottom if no good option
        return "bottom";
    }, [
        placement
    ]);
    // Update calculated placement when menu opens or placement prop changes
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (isOpen) setCalculatedPlacement(calculatePlacement());
    }, [
        isOpen,
        calculatePlacement
    ]);
    const handleToggle = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((highlightFirstParam)=>{
        const newIsOpen = !isOpen;
        setIsOpen(newIsOpen);
        // Reset highlighted index when closing, or set to first item if requested
        if (!newIsOpen) setHighlightedIndex(null);
        else if (highlightFirstParam !== undefined ? highlightFirstParam : highlightFirst) setHighlightedIndex(0);
    }, [
        isOpen,
        highlightFirst
    ]);
    // When the menu is open, focus on the menu but don't highlight first item
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        var _a;
        if (isOpen) (_a = menuRef.current) === null || _a === void 0 || _a.focus();
    }, [
        isOpen
    ]);
    const handleKeyDown = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((event)=>{
        var _a, _b;
        if (!isOpen) return;
        switch(event.key){
            case "ArrowDown":
                event.preventDefault();
                setHighlightedIndex((prev)=>prev === null ? 0 : prev === items.length - 1 ? 0 : prev + 1);
                break;
            case "ArrowUp":
                event.preventDefault();
                setHighlightedIndex((prev)=>prev === null ? items.length - 1 : prev === 0 ? items.length - 1 : prev - 1);
                break;
            case "Home":
                event.preventDefault();
                setHighlightedIndex(0);
                break;
            case "End":
                event.preventDefault();
                setHighlightedIndex(items.length - 1);
                break;
            case "Enter":
            case " ":
                event.preventDefault();
                if (highlightedIndex !== null && onSelect) onSelect(highlightedIndex, items[highlightedIndex]);
                setIsOpen(false);
                setHighlightedIndex(null);
                (_a = buttonRef.current) === null || _a === void 0 || _a.focus();
                break;
            case "Escape":
                event.preventDefault();
                setIsOpen(false);
                setHighlightedIndex(null);
                (_b = buttonRef.current) === null || _b === void 0 || _b.focus();
                break;
        }
    }, [
        isOpen,
        highlightedIndex,
        items,
        onSelect
    ]);
    return {
        isOpen: isOpen,
        highlightedIndex: highlightedIndex,
        calculatedPlacement: calculatedPlacement,
        buttonRef: buttonRef,
        menuRef: menuRef,
        handleToggle: handleToggle,
        handleKeyDown: handleKeyDown,
        setHighlightedIndex: setHighlightedIndex
    };
};
const $847bf9dc758b6d61$var$launchProductForClient = (env, connection, appId, fallbackUrl, originalHandleToggle, setExpandedLegacyApp, setSubmenuHighlightedIndex, activeClientId, platformService)=>{
    var _a;
    if (connection) platformService.launchApp(connection);
    else if (fallbackUrl) window.open(fallbackUrl, "_self");
    else {
        // Redirect to foundation homepage if no access, include active client id if available
        let acId = activeClientId;
        if (!acId && typeof window !== "undefined") acId = (_a = window.__NAVBAR_CONTEXT__) === null || _a === void 0 ? void 0 : _a.activeClientId;
        if (!acId && typeof globalThis !== "undefined") acId = globalThis.activeClientId;
        const acParam = acId ? `?ac=${encodeURIComponent(acId)}` : "";
        let foundationUrl;
        if ((env || "dev") === "prod") foundationUrl = `https://foundation.lwolf.com/${acParam}`;
        else foundationUrl = `https://foundation.${env || "dev"}.lwolf.com/${acParam}`;
        window.open(foundationUrl, "_self");
    }
    if (typeof originalHandleToggle === "function") originalHandleToggle();
};
const $847bf9dc758b6d61$var$buildProductLaunchUrl = (env, connection, luParamValue)=>{
    // env should be one of: dev, stg, pre, prod
    // For prod, omit the env part: https://platform.lwolf.com
    // For others: https://platform.{env}.lwolf.com
    const baseUrl = env === "prod" ? "https://platform.lwolf.com" : `https://platform.${env}.lwolf.com`;
    let url;
    if (connection.platformClient && connection.clientId === null) {
        const platformClientConnection = connection;
        url = `${baseUrl}/product/launch?a=${platformClientConnection.appId}`;
    } else if (connection.platformClient) {
        const platformClientConnection = connection;
        url = `${baseUrl}/product/launch?a=${platformClientConnection.appId}&ac=${platformClientConnection.clientId}`;
    } else if (connection.clientId != null) {
        const clientConnection = connection;
        url = `${baseUrl}/product/launch?a=${clientConnection.appId}&c=${clientConnection.clientId}&m=${clientConnection.memberId}`;
    } else if (connection.userId != null) {
        const userConnection = connection;
        url = `${baseUrl}/product/launch?a=${userConnection.appId}&u=${userConnection.userId}`;
    } else url = `${baseUrl}/product/launch?a=${connection.appId}`;
    return url;
};
// Helper function to get UI text based on language from token
const $847bf9dc758b6d61$var$getUIText = (token)=>{
    let isFrench = false;
    if (token) try {
        // First try using the Authentication library
        const parsedToken = $847bf9dc758b6d61$var$_default.parseToken(token);
        const lwtClaim = parsedToken === null || parsedToken === void 0 ? void 0 : parsedToken.getLwtClaim();
        const language = lwtClaim === null || lwtClaim === void 0 ? void 0 : lwtClaim.lng;
        isFrench = language && language.startsWith("fr");
    } catch (error) {
        // Fallback: Manual JWT parsing with base64url conversion
        try {
            const tokenParts = token.split(".");
            if (tokenParts.length === 3) {
                // Convert from base64url to base64
                let payload = tokenParts[1].replace(/-/g, "+").replace(/_/g, "/");
                // Fix base64 padding if needed
                while(payload.length % 4)payload += "=";
                const decoded = atob(payload);
                const tokenData = JSON.parse(decoded);
                const lwtClaim = tokenData["http://lwt"];
                const language = lwtClaim === null || lwtClaim === void 0 ? void 0 : lwtClaim.lng;
                isFrench = language && language.startsWith("fr");
            }
        } catch (fallbackError) {
        // Ignore fallback parsing errors - just default to English
        }
    }
    return {
        clients: isFrench ? "Clients" : "Clients",
        products: isFrench ? "Produits" : "Products",
        legacyProducts: isFrench ? "Produits H\xe9rit\xe9s" : "Legacy Products",
        personal: isFrench ? "Personnel" : "Personal",
        brokerage: isFrench ? "Courtage" : "Brokerage",
        switch: isFrench ? "Basculer" : "Switch",
        moreClientsSingular: isFrench ? "1 client de plus" : "1 More Client",
        moreClientsPlural: isFrench ? "clients de plus" : "More Clients"
    };
};
// Build applicationMeta and applicationCodeToName from products.json
const $847bf9dc758b6d61$var$applicationMeta = {};
const $847bf9dc758b6d61$var$applicationCodeToName = {};
// Fetch product data from remote JSON
const $847bf9dc758b6d61$var$fetchProductData = (token)=>$847bf9dc758b6d61$var$__awaiter$1(void 0, void 0, void 0, function*() {
        try {
            // Check for French language in token
            let productUrl = "https://assets.lwolf.com/json/products/latest.json";
            if (token) try {
                const parsedToken = $847bf9dc758b6d61$var$_default.parseToken(token);
                const lwtClaim = (parsedToken === null || parsedToken === void 0 ? void 0 : parsedToken.getLwtClaim()) || null;
                const language = lwtClaim.lng;
                if (language && language.startsWith("fr")) productUrl = "https://assets.lwolf.com/json/products/latest-fr.json";
            } catch (tokenError) {
                console.warn("Error parsing token for language detection:", tokenError);
                // Fallback: Manual JWT parsing with base64url conversion
                try {
                    const tokenParts = token.split(".");
                    if (tokenParts.length === 3) {
                        // Convert from base64url to base64
                        let payload = tokenParts[1].replace(/-/g, "+").replace(/_/g, "/");
                        // Fix base64 padding if needed
                        while(payload.length % 4)payload += "=";
                        const decoded = atob(payload);
                        const tokenData = JSON.parse(decoded);
                        const lwtClaim = tokenData["http://lwt"];
                        const language = lwtClaim === null || lwtClaim === void 0 ? void 0 : lwtClaim.lng;
                        if (language && language.startsWith("fr")) productUrl = "https://assets.lwolf.com/json/products/latest-fr.json";
                    }
                } catch (fallbackError) {
                    console.warn("Fallback token parsing also failed:", fallbackError);
                }
            }
            // Clear previous data to ensure language switch updates
            Object.keys($847bf9dc758b6d61$var$applicationMeta).forEach((key)=>delete $847bf9dc758b6d61$var$applicationMeta[key]);
            Object.keys($847bf9dc758b6d61$var$applicationCodeToName).forEach((key)=>delete $847bf9dc758b6d61$var$applicationCodeToName[key]);
            const response = yield fetch(productUrl);
            if (!response.ok) throw new Error("Network response was not ok");
            const data = yield response.json();
            // Build applicationMeta and applicationCodeToName from fetched data
            data.forEach((product)=>{
                $847bf9dc758b6d61$var$applicationMeta[product.code] = {
                    iconUrl: `https://assets.lwolf.com/lwt-helix/icons/latest/products/outlined/${product.icon}.svg`,
                    description: product.description || "",
                    url: "",
                    tooltip: product.tooltip || ""
                };
                $847bf9dc758b6d61$var$applicationCodeToName[product.code] = product.name || product.code;
            });
        } catch (error) {
            console.error("Error fetching product data:", error);
        }
    });
// Mock data for documentation/storybook
// mock data now imported from mockData.ts
const $847bf9dc758b6d61$export$b9df65f7f957b5de = ({ onClientChange: onClientChange, onProductChange: onProductChange })=>{
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    const { environment: environment, localStorageTokenKey: localStorageTokenKey, applicationCode: applicationCode, logoImageUrl: logoImageUrl, applicationName: applicationName, useMockData: useMockData, userToken: userToken, appData: contextAppData, lwaClients: contextLwaClients, clientsAsConnections: contextClientsAsConnections, appConnections: contextAppConnections, appConnectionsFull: contextAppConnectionsFull, platformDataLoading: platformDataLoading, branding: branding, platformService: platformService } = (0, $acw62.useContext)($847bf9dc758b6d61$var$SidebarNavbarContext);
    let activeClientId = (0, $acw62.useContext)($847bf9dc758b6d61$var$SidebarNavbarContext).activeClientId;
    // Force activeClientId to 'client-2' when using mock data
    if (useMockData) activeClientId = "client-2";
    const logo = logoImageUrl ? logoImageUrl : "https://assets.lwolf.com/img/lw-logo-dark.svg";
    // Configuration: Number of clients to show before overflow
    // Show both clients if exactly 2, otherwise show 1 + overflow
    const MAIN_CLIENTS_DISPLAY_COUNT = 1;
    // Domain mapping for different environments
    const lwDomains = {
        dev: "dev.lwolf.com",
        stg: "stg.lwolf.com",
        pre: "pre.lwolf.com",
        prod: "lwolf.com"
    };
    // Token cookie name formats
    const newTokenCookieName = environment === "prod" ? "lwaToken_lwolf.com" : `lwaToken_${environment}.lwolf.com`;
    const fallbackTokenCookieName = environment === "prod" ? "lwaToken@@lwolf.com" : `lwaToken@@${environment}.lwolf.com`;
    const getTokenFromCookie = ()=>{
        if (!document || !document.cookie) return "";
        const cookies = document.cookie.split(";");
        // First try the new format
        const newFormatCookie = cookies.find((item)=>item.trim().startsWith(newTokenCookieName + "="));
        if (newFormatCookie) {
            const token = newFormatCookie.split("=")[1] || "";
            return token;
        }
        // Fall back to the old format
        const fallbackCookie = cookies.find((item)=>item.trim().startsWith(fallbackTokenCookieName + "="));
        if (fallbackCookie) {
            const token = fallbackCookie.split("=")[1] || "";
            return token;
        }
        return "";
    };
    const getUserToken = ()=>{
        // get the token from the local storage or the cookie or the userToken
        return typeof window !== "undefined" ? window.localStorage.getItem(localStorageTokenKey) || getTokenFromCookie() || userToken || "" : userToken || "";
    };
    const [token, setToken] = (0, $acw62.useState)("");
    // Effect to handle delayed cookie loading
    (0, $acw62.useEffect)(()=>{
        const initialToken = getUserToken();
        setToken(initialToken);
        // If no token found initially, retry after a short delay
        if (!initialToken) {
            const retryTimer = setTimeout(()=>{
                const retryToken = getUserToken();
                if (retryToken) setToken(retryToken);
            }, 1000); // Retry after 1 second
            return ()=>clearTimeout(retryTimer);
        }
    }, []);
    const lwDomain = lwDomains[environment || "dev"] || lwDomains["dev"];
    const [clients, setClients] = (0, $acw62.useState)([]);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(true);
    const [dropdownPosition, setDropdownPosition] = (0, $acw62.useState)({
        top: 0,
        left: 0
    });
    const [selectedClient, setSelectedClient] = (0, $acw62.useState)("");
    const [isClientPreviewExpanded, setIsClientPreviewExpanded] = (0, $acw62.useState)(false);
    const [expandedLegacyApp, setExpandedLegacyApp] = (0, $acw62.useState)(null);
    const [legacyAppSubmenuPosition, setLegacyAppSubmenuPosition] = (0, $acw62.useState)({
        top: 0,
        left: 0
    });
    const [submenuHighlightedIndex, setSubmenuHighlightedIndex] = (0, $acw62.useState)(0);
    const [announceText, setAnnounceText] = (0, $acw62.useState)("");
    // Clear announcement after a delay to prevent stale announcements
    (0, $acw62.useEffect)(()=>{
        if (announceText) {
            const timeout = setTimeout(()=>{
                setAnnounceText("");
            }, 1500);
            return ()=>clearTimeout(timeout);
        }
    }, [
        announceText
    ]);
    const [appData, setAppData] = (0, $acw62.useState)([]);
    const [appConnections, setAppConnections] = (0, $acw62.useState)([]);
    const [appConnectionsFull, setAppConnectionsFull] = (0, $acw62.useState)([]);
    const appConnectionsFullRef = (0, $acw62.useRef)([]);
    // Keep ref in sync with state
    (0, $acw62.useEffect)(()=>{
        appConnectionsFullRef.current = appConnectionsFull;
    }, [
        appConnectionsFull
    ]);
    // Shared client click handler to avoid duplication
    const handleClientClick = (client)=>$847bf9dc758b6d61$var$__awaiter$1(void 0, void 0, void 0, function*() {
            const clientLabel = client.label || client.name;
            const clientId = client.clientId || client.id;
            setSelectedClient(clientLabel);
            if (onClientChange) onClientChange(client);
            if (applicationCode) {
                const connection = appConnectionsFullRef.current.find((conn)=>conn.clientId === clientId && conn.appId === applicationCode);
                if (connection) $847bf9dc758b6d61$var$launchProductForClient(environment || "dev", connection, applicationCode, "", originalHandleToggle, null, null, clientId, platformService);
                else {
                    // Redirect to foundation homepage if no access
                    let foundationUrl;
                    if ((environment || "dev") === "prod") {
                        const acParam = clientId ? `ac=${encodeURIComponent(clientId)}` : "";
                        foundationUrl = `https://foundation.lwolf.com/${acParam ? `?${acParam}` : ""}`;
                    } else {
                        const acParam = clientId ? `ac=${encodeURIComponent(clientId)}` : "";
                        foundationUrl = `https://foundation.${environment || "dev"}.lwolf.com/${acParam ? `?${acParam}` : ""}`;
                    }
                    window.open(foundationUrl, "_self");
                }
            } else if (typeof originalHandleToggle === "function") originalHandleToggle();
        });
    // Load product data on component mount (skip when using mock data)
    (0, $acw62.useEffect)(()=>{
        $847bf9dc758b6d61$var$fetchProductData(token);
    }, [
        useMockData,
        token
    ]);
    // Merge app data URLs with products.json data
    const getApplicationMeta = (appId)=>{
        var _a, _b;
        const productMeta = $847bf9dc758b6d61$var$applicationMeta[appId] || {};
        const appMeta = appData.find((app)=>app.id === appId);
        return Object.assign(Object.assign({}, productMeta), {
            url: ((_b = (_a = appMeta === null || appMeta === void 0 ? void 0 : appMeta.config) === null || _a === void 0 ? void 0 : _a.login) === null || _b === void 0 ? void 0 : _b.url) || ""
        });
    };
    const translateClientType = (clientType, uiText)=>{
        const lowerType = clientType.toLowerCase();
        if (lowerType === "personal" || lowerType === "user") return uiText.personal;
        if (lowerType === "brokerage") return uiText.brokerage;
        return clientType; // Return original if no translation found
    };
    const getAppsSection = ()=>{
        try {
            // Use mock data for documentation/storybook
            if (useMockData) {
                const uiText = $847bf9dc758b6d61$var$getUIText(token);
                setAppData($847bf9dc758b6d61$var$mockAppData);
                setAppConnections($847bf9dc758b6d61$var$mockAppConnections);
                setAppConnectionsFull($847bf9dc758b6d61$var$mockAppConnections);
                // Process mock clients similar to real data
                const mappedClients = $847bf9dc758b6d61$var$mockClients.map((client, idx)=>({
                        label: client.name,
                        clientType: translateClientType(client.clientType === "User" ? "Personal" : client.clientType, uiText),
                        appIds: client.appIds,
                        clientId: client.clientId,
                        onClick: ()=>handleClientClick({
                                clientId: client.clientId,
                                id: client.clientId,
                                name: client.name,
                                label: client.name
                            }),
                        id: client.clientId
                    }));
                setClients(mappedClients);
                setIsLoading(false);
                return;
            }
            // Use data from context instead of making platform service calls
            setAppData(contextAppData || []);
            setAppConnections(contextAppConnections || []);
            setAppConnectionsFull(contextAppConnectionsFull || []);
            // Group by clientId
            // Start with all lwaClients to ensure we don't miss any clients
            const grouped = (contextLwaClients === null || contextLwaClients === void 0 ? void 0 : contextLwaClients.reduce((acc, curr)=>{
                acc[curr.clientId] = {
                    clientId: curr.clientId,
                    name: curr.name || curr.clientId,
                    clientType: curr.clientType || "",
                    appIds: []
                };
                return acc;
            }, {})) || {};
            // Add app connections to existing clients
            contextClientsAsConnections === null || contextClientsAsConnections === void 0 || contextClientsAsConnections.forEach((curr)=>{
                const { clientId: clientId, name: name, appId: appId } = curr;
                if (!grouped[clientId]) {
                    // This shouldn't happen if lwaClients is properly populated, but handle it just in case
                    const lwa = contextLwaClients === null || contextLwaClients === void 0 ? void 0 : contextLwaClients.find((c)=>c.clientId === clientId);
                    grouped[clientId] = {
                        clientId: clientId,
                        name: name,
                        clientType: (lwa === null || lwa === void 0 ? void 0 : lwa.clientType) || "",
                        appIds: []
                    };
                } else // Update name if it's provided in apiClients
                if (name) grouped[clientId].name = name;
                grouped[clientId].appIds.push(appId);
            });
            // Map to menu item format
            const mappedClients = Object.values(grouped || {}).map((client, idx)=>{
                const uiText = $847bf9dc758b6d61$var$getUIText(token);
                // Attach clientId directly for later use
                const mappedClient = {
                    label: client.name || client.clientId || `Client ${idx + 1}`,
                    clientType: translateClientType(client.clientType === "User" ? "Personal" : client.clientType || "", uiText),
                    appIds: client.appIds,
                    clientId: client.clientId,
                    onClick: ()=>handleClientClick({
                            clientId: client.clientId,
                            id: client.clientId,
                            name: client.name || client.clientId || `Client ${idx + 1}`,
                            label: client.name || client.clientId || `Client ${idx + 1}`
                        }),
                    id: client.clientId
                };
                return mappedClient;
            });
            // Use only real clients (sorting will be done dynamically)
            const allClients = [
                ...mappedClients
            ];
            setClients(allClients);
        } catch (error) {
            console.error("Error loading clients:", error);
        } finally{
            setIsLoading(false);
        }
    };
    // Handle mock mode separately to avoid infinite loops
    (0, $acw62.useEffect)(()=>{
        if (useMockData) getAppsSection();
    }, [
        useMockData
    ]);
    // Handle real data mode
    (0, $acw62.useEffect)(()=>{
        if (!useMockData && token && !platformDataLoading) getAppsSection();
    }, [
        token,
        platformDataLoading,
        contextAppData,
        contextLwaClients,
        contextClientsAsConnections,
        contextAppConnections,
        useMockData
    ]);
    // Set default selected client when clients are loaded (only on initial load)
    const didInit = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        if (clients.length > 0 && !selectedClient) {
            let newClient = null;
            if (useMockData) // Always set client-2 (Personal) as default when using mock data
            newClient = clients.find((c)=>c.clientId === "client-2") || clients[0];
            else // First try to find client by activeClientId
            newClient = (activeClientId ? clients.find((c)=>c.id === activeClientId) : null) || clients[0];
            if (newClient && typeof newClient.label === "string") {
                setSelectedClient(newClient.label);
                if (didInit.current) {
                    if (onClientChange) onClientChange(newClient);
                }
                didInit.current = true;
            }
        }
    }, [
        clients,
        activeClientId,
        useMockData,
        onClientChange
    ]);
    // (moved below after isOpen/originalHandleToggle declaration)
    // Create sorted clients with activeClientId always at top (ignore selectedClient for sorting)
    const sortedClients = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (clients.length === 0) return [];
        return [
            ...clients
        ].sort((a, b)=>{
            // Always prioritize the activeClientId (client it was loaded with) at the top
            if (activeClientId) {
                if (a.id === activeClientId && b.id !== activeClientId) return -1;
                if (b.id === activeClientId && a.id !== activeClientId) return 1;
            }
            return 0;
        });
    }, [
        clients,
        activeClientId
    ]);
    // Find the active client object (the client the app was loaded with)
    // Fallback to first client if activeClientId doesn't match any client
    const activeClientObj = (activeClientId ? sortedClients.find((c)=>c.id === activeClientId) : null) || sortedClients[0];
    const appIds = activeClientObj === null || activeClientObj === void 0 ? void 0 : activeClientObj.appIds.filter((appId)=>appConnections.some((conn)=>conn.appId === appId));
    // Build the applications for the active client (always use activeClientId, not selectedClient)
    const activeClientApps = (appIds || []).map((appId)=>{
        var _a, _b, _c, _d;
        const meta = getApplicationMeta(appId);
        const brandingConnection = appConnections.find((conn)=>conn.appId === appId && conn.clientId === (activeClientObj === null || activeClientObj === void 0 ? void 0 : activeClientObj.id));
        // Only apply branding if this is for the correct client and app combination
        const shouldApplyBranding = (activeClientObj === null || activeClientObj === void 0 ? void 0 : activeClientObj.id) === (branding === null || branding === void 0 ? void 0 : branding.id) && ((_a = branding === null || branding === void 0 ? void 0 : branding.applications) === null || _a === void 0 ? void 0 : _a[appId]);
        const customName = ((_b = brandingConnection === null || brandingConnection === void 0 ? void 0 : brandingConnection.branding) === null || _b === void 0 ? void 0 : _b.appName) || (shouldApplyBranding ? (_d = (_c = branding === null || branding === void 0 ? void 0 : branding.applications) === null || _c === void 0 ? void 0 : _c[appId]) === null || _d === void 0 ? void 0 : _d.name : null);
        const connection = appConnectionsFull.find((conn)=>conn.appId === appId && conn.clientId === (activeClientObj === null || activeClientObj === void 0 ? void 0 : activeClientObj.id));
        return {
            label: customName || $847bf9dc758b6d61$var$applicationCodeToName[appId] || appId,
            iconUrl: (shouldApplyBranding ? branding === null || branding === void 0 ? void 0 : branding.logoUrl : null) || meta.iconUrl || "https://assets.lwolf.com/lwt-helix/icons/latest/outlined/wolfie.svg",
            description: meta.description || "",
            url: connection ? $847bf9dc758b6d61$var$buildProductLaunchUrl(environment || "dev", connection) : meta.url || "",
            appId: appId,
            onClick: ()=>{
                $847bf9dc758b6d61$var$launchProductForClient(environment || "dev", connection, appId, meta.url, null, null, null, activeClientId !== null && activeClientId !== void 0 ? activeClientId : "", platformService);
            }
        };
    });
    // Build personal apps - apps from appConnections that aren't attached to any specific client
    const personalApps = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        // Get all appIds that are already assigned to specific clients
        const clientAppIds = new Set(sortedClients.flatMap((client)=>client.appIds || []));
        // Find apps in appConnections that aren't in any client's appIds
        const standaloneApps = appConnections.filter((conn)=>conn.appId && !clientAppIds.has(conn.appId));
        // remove any apps that have an id of just bo
        const removeBOApps = standaloneApps.filter((app)=>app.appId && app.appId !== "bo");
        // Group by appId
        const groupedApps = removeBOApps.reduce((acc, conn)=>{
            if (!acc[conn.appId]) acc[conn.appId] = [];
            acc[conn.appId].push(conn);
            return acc;
        }, {});
        // Create grouped app items
        return Object.entries(groupedApps).map(([appId, connections])=>{
            var _a, _b, _c;
            const meta = getApplicationMeta(appId);
            const appName = $847bf9dc758b6d61$var$applicationCodeToName[appId] || appId;
            const connectionArray = connections;
            const instanceNames = connectionArray.map((conn)=>conn.name || conn.clientId).sort((a, b)=>a.localeCompare(b, undefined, {
                    sensitivity: "base"
                }));
            const count = connectionArray.length;
            // Use the first connection for URL building (or could offer per-instance launch)
            const firstConnection = connectionArray[0];
            appConnections.find((conn)=>conn.appId === appId && conn.clientId === (firstConnection === null || firstConnection === void 0 ? void 0 : firstConnection.clientId));
            // Only apply branding if this is for the correct client and app combination
            const shouldApplyBranding = (firstConnection === null || firstConnection === void 0 ? void 0 : firstConnection.clientId) === (branding === null || branding === void 0 ? void 0 : branding.id) && ((_a = branding === null || branding === void 0 ? void 0 : branding.applications) === null || _a === void 0 ? void 0 : _a[appId]);
            return {
                label: (shouldApplyBranding ? (_c = (_b = branding === null || branding === void 0 ? void 0 : branding.applications) === null || _b === void 0 ? void 0 : _b[appId]) === null || _c === void 0 ? void 0 : _c.name : null) || appName,
                iconUrl: (shouldApplyBranding ? branding === null || branding === void 0 ? void 0 : branding.logoUrl : null) || meta.iconUrl || "https://assets.lwolf.com/lwt-helix/icons/latest/outlined/wolfie.svg",
                description: meta.description || "",
                url: firstConnection ? $847bf9dc758b6d61$var$buildProductLaunchUrl(environment || "dev", firstConnection) : meta.url || "",
                count: count,
                instances: instanceNames,
                appId: appId,
                onClick: ()=>{
                    $847bf9dc758b6d61$var$launchProductForClient(environment || "dev", firstConnection, appId, meta.url, null, null, null, activeClientId || "", platformService);
                }
            };
        });
    }, [
        appConnections,
        sortedClients,
        lwDomain,
        branding
    ]);
    // Combine clients and products into a single array for dropdown navigation
    // If only one personal client, hide client list and show only products
    const combinedItems = [];
    const isSinglePersonalClient = sortedClients.length === 1 && (sortedClients[0].clientType === "Personal" || sortedClients[0].clientType === "User");
    // Get UI text based on language
    const uiText = $847bf9dc758b6d61$var$getUIText(token);
    if (!isSinglePersonalClient && sortedClients.length > 0) {
        combinedItems.push({
            type: "header",
            label: uiText.clients
        });
        // Show both clients if exactly 2, otherwise show first client + overflow
        const mainClientsCount = sortedClients.length === 2 ? 2 : MAIN_CLIENTS_DISPLAY_COUNT;
        const mainClients = sortedClients.slice(0, mainClientsCount);
        mainClients.forEach((client)=>{
            combinedItems.push({
                type: "client",
                label: client.label,
                clientType: client.clientType,
                appIds: client.appIds,
                id: client.id
            });
        });
    }
    let bovApp = null;
    let xbmApp = null;
    let filteredPersonalApps = personalApps;
    // Extract bov app
    const bovIndex = filteredPersonalApps.findIndex((app)=>app.appId === "bov");
    if (bovIndex !== -1) {
        const bov = personalApps[bovIndex];
        bovApp = {
            label: $847bf9dc758b6d61$var$applicationCodeToName["bov"] || "bov",
            iconUrl: ((_a = $847bf9dc758b6d61$var$applicationMeta["bov"]) === null || _a === void 0 ? void 0 : _a.iconUrl) || bov.iconUrl,
            description: ((_b = $847bf9dc758b6d61$var$applicationMeta["bov"]) === null || _b === void 0 ? void 0 : _b.description) || bov.description || "",
            url: bov.url,
            onClick: bov.onClick,
            appId: "bov",
            count: bov.count,
            instances: bov.instances,
            alwaysShowTooltip: ((_c = $847bf9dc758b6d61$var$applicationMeta["bov"]) === null || _c === void 0 ? void 0 : _c.alwaysShowTooltip) ? true : false
        };
        filteredPersonalApps = [
            ...filteredPersonalApps.slice(0, bovIndex),
            ...filteredPersonalApps.slice(bovIndex + 1)
        ];
    }
    // Extract xbm app
    const xbmIndex = filteredPersonalApps.findIndex((app)=>app.appId === "xbm");
    if (xbmIndex !== -1) {
        const xbm = filteredPersonalApps[xbmIndex];
        xbmApp = {
            label: $847bf9dc758b6d61$var$applicationCodeToName["xbm"] || "xbm",
            iconUrl: ((_d = $847bf9dc758b6d61$var$applicationMeta["xbm"]) === null || _d === void 0 ? void 0 : _d.iconUrl) || xbm.iconUrl,
            description: ((_e = $847bf9dc758b6d61$var$applicationMeta["xbm"]) === null || _e === void 0 ? void 0 : _e.description) || xbm.description || "",
            url: xbm.url,
            onClick: xbm.onClick,
            appId: "xbm",
            count: xbm.count,
            instances: xbm.instances,
            alwaysShowTooltip: ((_f = $847bf9dc758b6d61$var$applicationMeta["xbm"]) === null || _f === void 0 ? void 0 : _f.alwaysShowTooltip) ? true : false
        };
        filteredPersonalApps = [
            ...filteredPersonalApps.slice(0, xbmIndex),
            ...filteredPersonalApps.slice(xbmIndex + 1)
        ];
    }
    if (activeClientApps.length > 0 || personalApps.length > 0) {
        if (!isSinglePersonalClient) combinedItems.push({
            type: "separator"
        });
        combinedItems.push({
            type: "header",
            label: uiText.products
        });
        // Find if fdn is in provisioned apps
        const fdnIndex = activeClientApps.findIndex((app)=>app.label === ($847bf9dc758b6d61$var$applicationCodeToName["fdn"] || "fdn") || app.appId === "fdn");
        let foundationApp = null;
        let filteredApps = [];
        if (fdnIndex !== -1) {
            // Foundation is provisioned, float it to the top
            foundationApp = Object.assign(Object.assign({}, activeClientApps[fdnIndex]), {
                appId: "fdn"
            });
            filteredApps = [
                ...activeClientApps.slice(0, fdnIndex),
                ...activeClientApps.slice(fdnIndex + 1)
            ];
        } else {
            // Foundation is not provisioned, hardcode it
            const foundationMeta = getApplicationMeta("fdn");
            // Use explicit activeClientId if available, fallback to activeClientObj?.id
            const clientIdForFoundation = activeClientId || (activeClientObj === null || activeClientObj === void 0 ? void 0 : activeClientObj.id) || "";
            const baseFoundationUrl = foundationMeta.url || (environment === "prod" ? "https://foundation.lwolf.com/" : `https://foundation.${environment || "dev"}.lwolf.com/`);
            const foundationUrl = `${baseFoundationUrl}${baseFoundationUrl.includes("?") ? "&" : "?"}ac=${clientIdForFoundation}`;
            const foundationBrandingConnection = appConnections.find((conn)=>conn.appId === "fdn" && conn.clientId === (activeClientObj === null || activeClientObj === void 0 ? void 0 : activeClientObj.id));
            const shouldApplyFoundationBranding = (activeClientObj === null || activeClientObj === void 0 ? void 0 : activeClientObj.id) === (foundationBrandingConnection === null || foundationBrandingConnection === void 0 ? void 0 : foundationBrandingConnection.clientId) && ((_g = branding === null || branding === void 0 ? void 0 : branding.applications) === null || _g === void 0 ? void 0 : _g["fdn"]);
            foundationApp = {
                label: (shouldApplyFoundationBranding ? (_j = (_h = branding === null || branding === void 0 ? void 0 : branding.applications) === null || _h === void 0 ? void 0 : _h["fdn"]) === null || _j === void 0 ? void 0 : _j.name : null) || $847bf9dc758b6d61$var$applicationCodeToName["fdn"] || "Foundation",
                iconUrl: (shouldApplyFoundationBranding ? branding === null || branding === void 0 ? void 0 : branding.logoUrl : null) || foundationMeta.iconUrl || "https://assets.lwolf.com/lwt-helix/icons/latest/products/outlined/foundation.svg",
                description: foundationMeta.description || "",
                url: foundationUrl,
                onClick: ()=>{
                    window.open(foundationUrl, "_self");
                },
                appId: "fdn"
            };
            filteredApps = [
                ...activeClientApps
            ];
        }
        // Collect all main products (excluding Foundation) for alphabetical sorting
        const allMainProducts = [];
        // Filter out xam from active client apps if both xam and xbm are present
        let processedActiveClientApps = [
            ...filteredApps
        ];
        const hasXam = (_k = activeClientObj === null || activeClientObj === void 0 ? void 0 : activeClientObj.appIds) === null || _k === void 0 ? void 0 : _k.includes("xam");
        const hasXbm = personalApps.some((app)=>app.appId === "xbm");
        if (hasXam && hasXbm) processedActiveClientApps = processedActiveClientApps.filter((app)=>!(app.label === $847bf9dc758b6d61$var$applicationCodeToName["xam"] || app.label === "xam"));
        // Add active client apps
        processedActiveClientApps.forEach((app)=>{
            allMainProducts.push(app);
        });
        // Add bov if present
        if (bovApp) allMainProducts.push(bovApp);
        // Add xbm if present
        if (xbmApp) allMainProducts.push(xbmApp);
        // Sort all main products alphabetically by label
        const sortedMainProducts = allMainProducts.sort((a, b)=>a.label.localeCompare(b.label, undefined, {
                sensitivity: "base"
            }));
        // Always push Foundation first
        if (foundationApp) combinedItems.push({
            type: "product",
            label: foundationApp.label,
            iconUrl: foundationApp.iconUrl,
            description: foundationApp.description,
            url: foundationApp.url,
            onClick: foundationApp.onClick,
            tooltip: ((_l = $847bf9dc758b6d61$var$applicationMeta["fdn"]) === null || _l === void 0 ? void 0 : _l.tooltip) || "",
            alwaysShowTooltip: ((_m = $847bf9dc758b6d61$var$applicationMeta["fdn"]) === null || _m === void 0 ? void 0 : _m.alwaysShowTooltip) ? true : false,
            id: foundationApp.appId,
            appId: foundationApp.appId
        });
        // Then add all other products in alphabetical order
        sortedMainProducts.forEach((app)=>{
            var _a, _b;
            combinedItems.push({
                type: "product",
                label: app.label,
                iconUrl: app.iconUrl,
                description: app.description,
                url: app.url,
                onClick: app.onClick,
                count: app.count,
                instances: app.instances,
                appId: app.appId,
                id: app.appId,
                tooltip: app.appId ? ((_a = $847bf9dc758b6d61$var$applicationMeta[app.appId]) === null || _a === void 0 ? void 0 : _a.tooltip) || "" : "",
                alwaysShowTooltip: app.appId ? ((_b = $847bf9dc758b6d61$var$applicationMeta[app.appId]) === null || _b === void 0 ? void 0 : _b.alwaysShowTooltip) ? true : false : false
            });
        });
    // Use filteredPersonalApps for legacy section below
    }
    // Always show legacy (personal) apps regardless of active client
    if (filteredPersonalApps.length > 0) {
        combinedItems.push({
            type: "separator"
        });
        combinedItems.push({
            type: "header",
            label: uiText.legacyProducts
        });
        // Sort legacy products alphabetically by label
        const sortedPersonalApps = [
            ...filteredPersonalApps
        ].sort((a, b)=>{
            const labelA = $847bf9dc758b6d61$var$applicationCodeToName[a.appId] || a.appId;
            const labelB = $847bf9dc758b6d61$var$applicationCodeToName[b.appId] || b.appId;
            return labelA.localeCompare(labelB, undefined, {
                sensitivity: "base"
            });
        });
        sortedPersonalApps.forEach((app)=>{
            var _a, _b, _c, _d;
            combinedItems.push({
                type: "product",
                label: $847bf9dc758b6d61$var$applicationCodeToName[app.appId] || app.appId,
                iconUrl: ((_a = $847bf9dc758b6d61$var$applicationMeta[app.appId]) === null || _a === void 0 ? void 0 : _a.iconUrl) || app.iconUrl,
                description: ((_b = $847bf9dc758b6d61$var$applicationMeta[app.appId]) === null || _b === void 0 ? void 0 : _b.description) || app.description || "",
                url: app.url,
                onClick: app.onClick,
                count: app.count,
                instances: app.instances,
                appId: app.appId,
                id: app.appId,
                tooltip: ((_c = $847bf9dc758b6d61$var$applicationMeta[app.appId]) === null || _c === void 0 ? void 0 : _c.tooltip) || "",
                alwaysShowTooltip: ((_d = $847bf9dc758b6d61$var$applicationMeta[app.appId]) === null || _d === void 0 ? void 0 : _d.alwaysShowTooltip) ? true : false
            });
        });
    }
    // Close submenu when clicking outside
    (0, $acw62.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            const target = event.target;
            // Exclude clicks on any element in the legacy instance menu (by class)
            if (target.closest(".client-picker__legacy-instance")) return;
            if (expandedLegacyApp && !target.closest(".client-picker__dropdown") && !target.closest('[data-selectable="true"]') && !target.closest(".client-picker__legacy-instance")) setExpandedLegacyApp(null);
        };
        if (expandedLegacyApp) {
            document.addEventListener("mousedown", handleClickOutside);
            return ()=>document.removeEventListener("mousedown", handleClickOutside);
        }
    }, [
        expandedLegacyApp
    ]);
    const handleLegacyAppClick = (appId, instances, event)=>{
        if (instances.length > 1) {
            event.stopPropagation();
            const rect = event.currentTarget.getBoundingClientRect();
            // Estimate submenu dimensions
            const submenuWidth = 200;
            const submenuHeight = instances.length * 44 + 16; // Approximate height per item + padding
            // Calculate viewport dimensions
            const viewportWidth = window.innerWidth;
            const viewportHeight = window.innerHeight;
            // Default position (below and aligned left)
            let top = rect.bottom + 4;
            let left = rect.left;
            // Check if submenu would go off the right edge
            if (left + submenuWidth > viewportWidth) left = rect.right - submenuWidth; // Align right edge of submenu with right edge of item
            // Check if submenu would go off the left edge
            if (left < 0) left = 8; // Small margin from viewport edge
            // Check if submenu would go off the bottom edge
            if (top + submenuHeight > viewportHeight) top = rect.top - submenuHeight - 4; // Position above the item
            // Check if submenu would go off the top edge
            if (top < 0) top = 8; // Small margin from viewport top
            setLegacyAppSubmenuPosition({
                top: top,
                left: left
            });
            setExpandedLegacyApp(expandedLegacyApp === appId ? null : appId);
        } else {
            // Single instance, navigate directly
            const instance = instances[0];
            const url = `https://${instance.subdomain}.${instance.domain}`;
            window.open(url, "_self");
            originalHandleToggle();
            setExpandedLegacyApp(null);
        }
    };
    const handleSelect = (index, id, label)=>{
        // Handle special keyboard navigation cases
        if (id === "__PREVIEW_TOGGLE__") {
            setIsClientPreviewExpanded(!isClientPreviewExpanded);
            const action = !isClientPreviewExpanded ? "expanded" : "collapsed";
            setAnnounceText(`Client overflow section ${action}`);
            return;
        }
        if (id.startsWith("__OVERFLOW_")) {
            const clientId = id.replace("__OVERFLOW_", "").replace("__", "");
            const client = clients.find((c)=>c.id === clientId);
            if (client) {
                setSelectedClient(client.label);
                setAnnounceText(`Switched to client: ${client.label}`);
            }
            setIsClientPreviewExpanded(false);
            return;
        }
        // Handle regular combined items - find by ID
        const selectedItem = combinedItems.find((item)=>(item.type === "client" || item.type === "product") && item.id === id);
        if (selectedItem) {
            if (selectedItem.type === "client") {
                setSelectedClient(selectedItem.label);
                setAnnounceText(`Switched to client: ${selectedItem.label}`);
                // Fire onClientChange callback if provided
                const clientObj = clients.find((c)=>c.id === selectedItem.id);
                if (onClientChange && clientObj) onClientChange(clientObj);
                // Close the dropdown after client selection
                originalHandleToggle();
            } else if (selectedItem.type === "product") {
                setAnnounceText(`Launching application: ${selectedItem.label}`);
                // Fire onProductChange callback if provided
                if (onProductChange) onProductChange(selectedItem);
                if (selectedItem.onClick) selectedItem.onClick();
            }
        // Ignore selection for headers and separators
        }
    };
    // Custom key handler to override default dropdown behavior for preview toggle
    const customHandleKeyDown = (event)=>$847bf9dc758b6d61$var$__awaiter$1(void 0, void 0, void 0, function*() {
            var _r;
            const selectableItems = [];
            // Build the same selectable items array as in useDropdownMenu
            combinedItems.forEach((itm)=>{
                if (itm.type === "client") selectableItems.push(itm.id || itm.label);
            });
            const mainClientsCount = clients.length === 2 ? 2 : MAIN_CLIENTS_DISPLAY_COUNT;
            if (clients.length > mainClientsCount) {
                selectableItems.push("__PREVIEW_TOGGLE__");
                if (isClientPreviewExpanded) clients.slice(mainClientsCount).forEach((client)=>{
                    selectableItems.push(`__OVERFLOW_${client.id}__`);
                });
            }
            combinedItems.forEach((itm)=>{
                if (itm.type === "product") selectableItems.push(itm.id || itm.appId || itm.label);
            });
            // Check if current highlighted item is preview toggle
            const currentItem = selectableItems[highlightedIndex];
            if ((event.key === "Enter" || event.key === " ") && currentItem === "__PREVIEW_TOGGLE__") {
                event.preventDefault();
                event.stopPropagation();
                setIsClientPreviewExpanded(!isClientPreviewExpanded);
                return;
            }
            // For overflow clients, handle them but allow dropdown to close
            if ((event.key === "Enter" || event.key === " ") && (currentItem === null || currentItem === void 0 ? void 0 : currentItem.startsWith("__OVERFLOW_"))) {
                event.preventDefault();
                const clientId = currentItem.replace("__OVERFLOW_", "").replace("__", "");
                // Find the client by ID
                const client = clients.find((c)=>c.id === clientId);
                if (client) yield handleClientClick(client);
                setIsClientPreviewExpanded(false);
                // Let the dropdown close naturally
                handleKeyDown(event);
                return;
            }
            // Handle legacy app keyboard navigation
            if (currentItem) {
                const legacyAppItem = personalApps.find((app)=>app.appId === currentItem);
                if (legacyAppItem && legacyAppItem.count > 1) {
                    if (event.key === "ArrowDown" && !expandedLegacyApp) {
                        // Open submenu when down arrow is pressed on legacy app
                        event.preventDefault();
                        event.stopPropagation();
                        // Find the currently highlighted element
                        const selectableElements = (_r = menuRef.current) === null || _r === void 0 ? void 0 : _r.querySelectorAll('[data-selectable="true"]');
                        const highlightedElement = selectableElements === null || selectableElements === void 0 ? void 0 : selectableElements[highlightedIndex];
                        if (highlightedElement) {
                            const rect = highlightedElement.getBoundingClientRect();
                            const viewportWidth = window.innerWidth;
                            const viewportHeight = window.innerHeight;
                            const submenuWidth = 200;
                            const submenuHeight = legacyAppItem.instances.length * 44 + 16;
                            // Default position (below and aligned left)
                            let top = rect.bottom + 4;
                            let left = rect.left;
                            // Check viewport boundaries and adjust position
                            if (left + submenuWidth > viewportWidth) left = rect.right - submenuWidth;
                            if (left < 0) left = 8;
                            if (top + submenuHeight > viewportHeight) top = rect.top - submenuHeight - 4;
                            if (top < 0) top = 8;
                            setLegacyAppSubmenuPosition({
                                top: top,
                                left: left
                            });
                            setExpandedLegacyApp(legacyAppItem.appId);
                            setSubmenuHighlightedIndex(0); // Start with first item highlighted
                            setAnnounceText(`Opened ${legacyAppItem.label} submenu with ${legacyAppItem.instances.length} instances. Use arrow keys to navigate, Enter to select.`);
                        }
                        return;
                    } else if ((event.key === "Enter" || event.key === " ") && expandedLegacyApp === legacyAppItem.appId) {
                        // Enter/Space on expanded legacy app should select first instance
                        event.preventDefault();
                        event.stopPropagation();
                        const selectedInstance = legacyAppItem.instances[submenuHighlightedIndex];
                        // Find the connection for this legacy app and instance
                        const connection = appConnections.find((conn)=>conn.appId === legacyAppItem.appId && (conn.name === selectedInstance || conn.clientId === selectedInstance));
                        if (connection) {
                            const url = $847bf9dc758b6d61$var$buildProductLaunchUrl(environment || "dev", connection);
                            window.open(url, "_self");
                            originalHandleToggle();
                            setExpandedLegacyApp(null);
                            setSubmenuHighlightedIndex(0);
                        }
                        return;
                    }
                }
            }
            // Handle submenu navigation
            if (expandedLegacyApp) {
                const expandedApp = personalApps.find((app)=>app.appId === expandedLegacyApp);
                if (expandedApp) {
                    if (event.key === "ArrowDown") {
                        event.preventDefault();
                        event.stopPropagation();
                        if (submenuHighlightedIndex < expandedApp.instances.length - 1) // Navigate down within submenu
                        setSubmenuHighlightedIndex(submenuHighlightedIndex + 1);
                        else {
                            // At last item, close submenu and move to next main item
                            setExpandedLegacyApp(null);
                            setSubmenuHighlightedIndex(0);
                            handleKeyDown(event);
                        }
                        return;
                    } else if (event.key === "ArrowUp") {
                        event.preventDefault();
                        event.stopPropagation();
                        if (submenuHighlightedIndex > 0) // Navigate up within submenu
                        setSubmenuHighlightedIndex(submenuHighlightedIndex - 1);
                        else {
                            // At first item, close submenu and return to main menu
                            setExpandedLegacyApp(null);
                            setSubmenuHighlightedIndex(0);
                        }
                        return;
                    } else if (event.key === "Enter" || event.key === " ") {
                        // Select highlighted instance
                        event.preventDefault();
                        event.stopPropagation();
                        const selectedInstance = expandedApp.instances[submenuHighlightedIndex];
                        // Find the connection for this legacy app and instance
                        const connection = appConnections.find((conn)=>conn.appId === expandedLegacyApp && (conn.name === selectedInstance || conn.clientId === selectedInstance));
                        if (connection) {
                            const url = $847bf9dc758b6d61$var$buildProductLaunchUrl(environment || "dev", connection);
                            window.open(url, "_self");
                            originalHandleToggle();
                            setExpandedLegacyApp(null);
                            setSubmenuHighlightedIndex(0);
                        }
                        return;
                    } else if (event.key === "Escape") {
                        // Close submenu on Escape
                        event.preventDefault();
                        event.stopPropagation();
                        setExpandedLegacyApp(null);
                        setSubmenuHighlightedIndex(0);
                        return;
                    }
                }
            }
            // Use the default handler for all other cases
            handleKeyDown(event);
        });
    const { isOpen: isOpen, highlightedIndex: highlightedIndex, calculatedPlacement: calculatedPlacement, buttonRef: buttonRef, menuRef: menuRef, handleToggle: originalHandleToggle, handleKeyDown: handleKeyDown } = $847bf9dc758b6d61$var$useDropdownMenu({
        placement: "bottom",
        onSelect: handleSelect,
        highlightFirst: true,
        // Only include selectable items for navigation
        items: (()=>{
            const selectableItems = [];
            // Add main clients first (first 2)
            combinedItems.forEach((item)=>{
                if (item.type === "client") selectableItems.push(item.id || item.label);
            });
            // Add preview toggle right after main clients if there are overflow clients
            const mainClientsCount = sortedClients.length === 2 ? 2 : MAIN_CLIENTS_DISPLAY_COUNT;
            if (sortedClients.length > mainClientsCount) {
                selectableItems.push("__PREVIEW_TOGGLE__");
                // Add overflow clients when expanded
                if (isClientPreviewExpanded) sortedClients.slice(mainClientsCount).forEach((client)=>{
                    selectableItems.push(`__OVERFLOW_${client.id}__`);
                });
            }
            // Add products last
            combinedItems.forEach((item)=>{
                if (item.type === "product") selectableItems.push(item.id || item.appId || item.label);
            });
            return selectableItems;
        })()
    });
    // Close instance menu when main dropdown scrolls
    (0, $acw62.useEffect)(()=>{
        const handleMainMenuScroll = ()=>{
            if (expandedLegacyApp) {
                setExpandedLegacyApp(null);
                setSubmenuHighlightedIndex(0);
            }
        };
        if (isOpen && expandedLegacyApp && menuRef.current) {
            menuRef.current.addEventListener("scroll", handleMainMenuScroll);
            return ()=>{
                if (menuRef.current) menuRef.current.removeEventListener("scroll", handleMainMenuScroll);
            };
        }
    }, [
        isOpen,
        expandedLegacyApp
    ]);
    // Handle clicks outside the dropdown to close it
    (0, $acw62.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            // Exclude clicks on legacy app instance text (do not close menu)
            let el = event.target;
            while(el){
                if (el.classList && el.classList.contains($847bf9dc758b6d61$var$styles$2["client-picker__app-text"])) return; // Don't close menu if clicking on legacy app instance text
                el = el.parentElement;
            }
            if (isOpen && buttonRef.current && menuRef.current && !buttonRef.current.contains(event.target) && !menuRef.current.contains(event.target)) {
                setIsClientPreviewExpanded(false);
                originalHandleToggle(); // Close the dropdown
            }
        };
        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
            return ()=>{
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }
    }, [
        isOpen,
        originalHandleToggle
    ]);
    // Scroll to highlighted item during keyboard navigation and announce it
    (0, $acw62.useEffect)(()=>{
        var _a, _b, _c;
        if (!isOpen || highlightedIndex === null || !menuRef.current) return;
        // Find all selectable elements in the dropdown
        const selectableElements = menuRef.current.querySelectorAll('[data-selectable="true"]');
        const targetElement = selectableElements[highlightedIndex];
        if (targetElement) {
            // Scroll the dropdown container to bring the target element into view
            const menuContainer = menuRef.current;
            const targetRect = targetElement.getBoundingClientRect();
            const containerRect = menuContainer.getBoundingClientRect();
            // Calculate if the element is outside the visible area
            const elementTop = targetRect.top - containerRect.top + menuContainer.scrollTop;
            const elementBottom = elementTop + targetRect.height;
            const visibleTop = menuContainer.scrollTop;
            const visibleBottom = visibleTop + menuContainer.clientHeight;
            // Scroll if element is not fully visible
            if (elementTop < visibleTop) // Element is above visible area
            menuContainer.scrollTop = elementTop - 10; // 10px padding
            else if (elementBottom > visibleBottom) // Element is below visible area
            menuContainer.scrollTop = elementBottom - menuContainer.clientHeight + 10;
            // Announce the highlighted item with more context
            const ariaLabel = targetElement.getAttribute("aria-label");
            const itemText = (_a = targetElement.textContent) === null || _a === void 0 ? void 0 : _a.trim();
            if (ariaLabel) // Use aria-label if available
            setAnnounceText(ariaLabel);
            else if (itemText) {
                // Determine item type and add context
                const isClientItem = (_b = targetElement.closest('[role="menuitem"]')) === null || _b === void 0 ? void 0 : _b.querySelector(".client-picker__client-menu-item");
                const isProductItem = (_c = targetElement.closest('[role="menuitem"]')) === null || _c === void 0 ? void 0 : _c.querySelector(".client-picker__app-menu-item");
                if (isClientItem) setAnnounceText(`Client: ${itemText}`);
                else if (isProductItem) setAnnounceText(`Application: ${itemText}`);
                else setAnnounceText(itemText);
            }
        }
    }, [
        isOpen,
        highlightedIndex
    ]);
    const handleToggle = ()=>{
        if (buttonRef.current) {
            const rect = buttonRef.current.getBoundingClientRect();
            setDropdownPosition({
                top: rect.bottom + window.scrollY + 10,
                left: rect.left + window.scrollX
            });
        }
        // Close the client preview when toggling main dropdown
        if (isOpen) {
            setIsClientPreviewExpanded(false);
            setAnnounceText("Client picker menu closed");
        } else setAnnounceText(`Client picker menu opened. ${combinedItems.length} items available. Use arrow keys to navigate.`);
        originalHandleToggle();
    };
    const handleButtonKeyDown = (event)=>{
        if (event.key === "ArrowDown" && !isOpen) {
            event.preventDefault();
            handleToggle();
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $847bf9dc758b6d61$var$styles$2["client-picker__container"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        ref: buttonRef,
        className: $847bf9dc758b6d61$var$styles$2["client-picker__button"],
        onClick: handleToggle,
        onKeyDown: handleButtonKeyDown,
        "aria-haspopup": "menu",
        "aria-expanded": isOpen,
        "aria-label": `Client picker: ${activeClientObj === null || activeClientObj === void 0 ? void 0 : activeClientObj.label}. ${applicationName}`
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $847bf9dc758b6d61$var$styles$2["client-picker__logo"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: logo,
        alt: "Logo"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $847bf9dc758b6d61$var$styles$2["client-picker__info"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $847bf9dc758b6d61$var$styles$2["client-picker__product-name"]
    }, applicationName), clients.length > 1 && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $847bf9dc758b6d61$var$styles$2["client-picker__client"]
    }, activeClientObj === null || activeClientObj === void 0 ? void 0 : activeClientObj.label)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
        icon: (0, $c761e69c8e58189a$exports.app_grid),
        className: $847bf9dc758b6d61$var$styles$2["client-picker__chevron"]
    })), isOpen && (0, $1u0KT.createPortal)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: menuRef,
        className: $847bf9dc758b6d61$var$styles$2["client-picker__dropdown-menu"] + (isSinglePersonalClient ? " client-picker__dropdown-menu--no-client-header" : "") + " " + $847bf9dc758b6d61$var$styles$2[calculatedPlacement] + " " + $847bf9dc758b6d61$var$styles$2.open,
        tabIndex: 0,
        onKeyDown: customHandleKeyDown,
        role: "menu",
        "aria-label": "Client and application menu",
        style: {
            top: dropdownPosition.top,
            left: dropdownPosition.left,
            minWidth: 320
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", null, isLoading ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, [
        ...Array(2)
    ].map((_, idx)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: "skeleton-client-" + idx,
            className: $847bf9dc758b6d61$var$styles$2["client-picker__dropdown-item"] + " " + $847bf9dc758b6d61$var$styles$2["client-picker__dropdown-item--skeleton"]
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: $847bf9dc758b6d61$var$styles$2["client-picker__client-menu-item"]
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: $847bf9dc758b6d61$var$styles$2["client-picker__client-text"]
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: $847bf9dc758b6d61$var$styles$2["client-picker__skeleton-label"]
        }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: $847bf9dc758b6d61$var$styles$2["client-picker__skeleton-description"]
        })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: $847bf9dc758b6d61$var$styles$2["client-picker__client-right"]
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: $847bf9dc758b6d61$var$styles$2["client-picker__skeleton-switch"]
        }))))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        className: $847bf9dc758b6d61$var$styles$2["client-picker__section-separator"]
    }), [
        ...Array(2)
    ].map((_, idx)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: "skeleton-product-" + idx,
            className: $847bf9dc758b6d61$var$styles$2["client-picker__dropdown-item"] + " " + $847bf9dc758b6d61$var$styles$2["client-picker__dropdown-item--skeleton"]
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: $847bf9dc758b6d61$var$styles$2["client-picker__app-menu-item"]
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: $847bf9dc758b6d61$var$styles$2["client-picker__skeleton-icon"]
        }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: $847bf9dc758b6d61$var$styles$2["client-picker__app-text"]
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: $847bf9dc758b6d61$var$styles$2["client-picker__skeleton-label"]
        }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: $847bf9dc758b6d61$var$styles$2["client-picker__skeleton-product-description"]
        })))))) : combinedItems.map((item, index)=>{
        var _a;
        // Create selectable items array for navigation mapping (same order as above)
        const selectableItems = [];
        // Add main clients first
        combinedItems.forEach((itm)=>{
            if (itm.type === "client") selectableItems.push(itm.id || itm.label);
        });
        // Add preview toggle after main clients
        const mainClientsCount = clients.length === 2 ? 2 : MAIN_CLIENTS_DISPLAY_COUNT;
        if (clients.length > mainClientsCount) {
            selectableItems.push("__PREVIEW_TOGGLE__");
            if (isClientPreviewExpanded) clients.slice(mainClientsCount).forEach((client)=>{
                selectableItems.push(`__OVERFLOW_${client.id}__`);
            });
        }
        // Add products last
        combinedItems.forEach((itm)=>{
            if (itm.type === "product") selectableItems.push(itm.id || itm.appId || itm.label);
        });
        let isHighlighted = false;
        let isSelected = false;
        // Check if current item is highlighted
        if (item.type === "client" || item.type === "product") {
            const itemId = item.type === "client" ? item.id : item.id || item.appId;
            const navIndex = selectableItems.indexOf(itemId || item.label);
            isHighlighted = highlightedIndex === navIndex;
            // Use activeClientObj.id to determine selection for consistency
            if (item.type === "client") isSelected = item.id === (activeClientObj === null || activeClientObj === void 0 ? void 0 : activeClientObj.id);
        }
        if (item.type === "header" && item.label === "Clients" || item.type === "header" && item.label === "Products") return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
        if (item.type === "header") return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: "header-" + item.label,
            className: $847bf9dc758b6d61$var$styles$2["client-picker__section-header"]
        }, item.label);
        if (item.type === "separator") return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: "separator-" + index,
            className: $847bf9dc758b6d61$var$styles$2["client-picker__section-separator"]
        });
        // Render client preview after the first client but before the first separator
        if (item.type === "client") {
            // Check if this is the first client in the combinedItems
            const firstClientIndex = combinedItems.findIndex((item)=>item.type === "client");
            const isFirstClient = index === firstClientIndex;
            const mainClientsCount = sortedClients.length === 2 ? 2 : MAIN_CLIENTS_DISPLAY_COUNT;
            const clientPreview = sortedClients.length > mainClientsCount ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                key: "client-preview",
                className: $847bf9dc758b6d61$var$styles$2["client-picker__client-preview-container"]
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: $847bf9dc758b6d61$var$styles$2["client-picker__client-preview"]
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: `${$847bf9dc758b6d61$var$styles$2["client-picker__preview-trigger"]} ${(()=>{
                    const selectableItems = [];
                    // Add main clients first
                    combinedItems.forEach((itm)=>{
                        if (itm.type === "client") selectableItems.push(itm.label);
                    });
                    // Preview toggle comes right after main clients
                    const previewToggleIndex = selectableItems.length;
                    return highlightedIndex === previewToggleIndex ? $847bf9dc758b6d61$var$styles$2["client-picker__preview-trigger--highlighted"] : "";
                })()}`,
                "data-selectable": "true",
                onClick: (e)=>{
                    e.stopPropagation();
                    setIsClientPreviewExpanded(!isClientPreviewExpanded);
                }
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: $847bf9dc758b6d61$var$styles$2["client-picker__preview-icon"]
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
                icon: (0, $c761e69c8e58189a$exports.agent),
                className: $847bf9dc758b6d61$var$styles$2["client-picker__preview-user-icon"]
            })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: $847bf9dc758b6d61$var$styles$2["client-picker__preview-label"]
            }, (()=>{
                const mainClientsCount = sortedClients.length === 2 ? 2 : MAIN_CLIENTS_DISPLAY_COUNT;
                const overflowCount = sortedClients.length - mainClientsCount;
                return overflowCount === 1 ? uiText.moreClientsSingular : `${overflowCount} ${uiText.moreClientsPlural}`;
            })()), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
                icon: (0, $c761e69c8e58189a$exports.chevron_small_down),
                className: `${$847bf9dc758b6d61$var$styles$2["client-picker__preview-chevron"]} ${isClientPreviewExpanded ? $847bf9dc758b6d61$var$styles$2["client-picker__preview-chevron--expanded"] : ""}`
            })), isClientPreviewExpanded && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: $847bf9dc758b6d61$var$styles$2["client-picker__expanded-clients"]
            }, (()=>{
                const mainClientsCount = sortedClients.length === 2 ? 2 : MAIN_CLIENTS_DISPLAY_COUNT;
                return sortedClients.slice(mainClientsCount);
            })().map((client, clientIndex)=>{
                const isClientSelected = client.id === (activeClientObj === null || activeClientObj === void 0 ? void 0 : activeClientObj.id);
                // Calculate highlight index for overflow client
                const selectableItems = [];
                // Add main clients first
                combinedItems.forEach((itm)=>{
                    if (itm.type === "client") selectableItems.push(itm.label);
                });
                // Add preview toggle
                selectableItems.push("__PREVIEW_TOGGLE__");
                // Overflow client index comes after preview toggle
                const overflowIndex = selectableItems.length + clientIndex;
                const isOverflowHighlighted = highlightedIndex === overflowIndex;
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    key: `expanded-${client.label}`,
                    className: `${$847bf9dc758b6d61$var$styles$2["client-picker__expanded-client-item"]} ${isClientSelected ? $847bf9dc758b6d61$var$styles$2["client-picker__expanded-client-item--selected"] : ""} ${isOverflowHighlighted ? $847bf9dc758b6d61$var$styles$2["client-picker__expanded-client-item--highlighted"] : ""}`,
                    "data-selectable": "true",
                    onClick: (e)=>$847bf9dc758b6d61$var$__awaiter$1(void 0, void 0, void 0, function*() {
                            e.stopPropagation();
                            setIsClientPreviewExpanded(false);
                            yield handleClientClick(client);
                        })
                }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: $847bf9dc758b6d61$var$styles$2["client-picker__client-menu-item"]
                }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: $847bf9dc758b6d61$var$styles$2["client-picker__client-text"]
                }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    className: $847bf9dc758b6d61$var$styles$2["client-picker__item-label"]
                }, client.label), client.clientType && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    className: $847bf9dc758b6d61$var$styles$2["client-picker__description"]
                }, client.clientType)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: $847bf9dc758b6d61$var$styles$2["client-picker__client-right"]
                }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    className: $847bf9dc758b6d61$var$styles$2["client-picker__switch-link"]
                }, uiText.switch))));
            })))) : null;
            // Return both the client item and the preview (if applicable)
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                key: `client-and-preview-${index}`
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                className: `${$847bf9dc758b6d61$var$styles$2["client-picker__dropdown-item"]}${isHighlighted ? ` ${$847bf9dc758b6d61$var$styles$2["client-picker__dropdown-item--highlighted"]}` : ""}${isSelected ? ` ${$847bf9dc758b6d61$var$styles$2["client-picker__dropdown-item--selected-client"]}` : ""}`,
                "data-selectable": "true",
                role: "menuitem",
                "aria-label": `Switch to client: ${item.label}${item.clientType ? `, ${item.clientType}` : ""}`,
                onClick: ()=>{
                    // Use the mapped client's onClick for correct launch logic
                    const client = clients.find((c)=>c.id === item.id);
                    if (client && typeof client.onClick === "function") client.onClick();
                    else handleSelect(index, item.id || (client === null || client === void 0 ? void 0 : client.id) || "", item.label);
                }
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: $847bf9dc758b6d61$var$styles$2["client-picker__client-menu-item"]
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: $847bf9dc758b6d61$var$styles$2["client-picker__client-text"]
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: $847bf9dc758b6d61$var$styles$2["client-picker__item-label"]
            }, item.label), item.clientType && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: $847bf9dc758b6d61$var$styles$2["client-picker__description"]
            }, item.clientType)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: $847bf9dc758b6d61$var$styles$2["client-picker__client-right"]
            }, isSelected ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: $847bf9dc758b6d61$var$styles$2["client-picker__checkmark"]
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
                icon: (0, $c761e69c8e58189a$exports.checkmark)
            })) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: $847bf9dc758b6d61$var$styles$2["client-picker__switch-link"]
            }, uiText.switch)))), isFirstClient && clientPreview);
        }
        if (item.type === "product") {
            const productItem = item;
            // For XBM, only show badge if count > 1, for others show if count >= 1
            const isLegacyApp = productItem.appId === "xbm" ? productItem.count && productItem.count > 1 : productItem.count && productItem.count >= 1;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                key: productItem.label,
                className: `${$847bf9dc758b6d61$var$styles$2["client-picker__dropdown-item"]}${isHighlighted ? ` ${$847bf9dc758b6d61$var$styles$2["client-picker__dropdown-item--highlighted"]}` : ""}`,
                "data-selectable": "true",
                role: "menuitem",
                "aria-label": `${productItem.label}${isLegacyApp ? ` - ${productItem.count} instances available` : ""}`,
                "aria-haspopup": isLegacyApp ? "menu" : undefined,
                "aria-expanded": isLegacyApp && expandedLegacyApp === productItem.appId ? "true" : undefined,
                onClick: (e)=>{
                    handleSelect(index, productItem.id || productItem.appId || "", productItem.label);
                }
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: $847bf9dc758b6d61$var$styles$2["client-picker__app-menu-item"]
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
                src: productItem.iconUrl,
                alt: productItem.label,
                className: $847bf9dc758b6d61$var$styles$2["client-picker__app-icon"],
                onError: (e)=>{
                    const target = e.target;
                    target.src = "https://assets.lwolf.com/lwt-helix/icons/latest/outlined/wolfie.svg";
                }
            }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: $847bf9dc758b6d61$var$styles$2["client-picker__app-text"],
                style: {
                    flex: 1
                }
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: $847bf9dc758b6d61$var$styles$2["client-picker__item-label"]
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: `${$847bf9dc758b6d61$var$styles$2["client-picker__label-name"]} ${!productItem.description ? $847bf9dc758b6d61$var$styles$2["client-picker__label-name--centered"] : ""}`
            }, productItem.label), productItem.tooltip && productItem.tooltip.trim() && (clients.length > 1 || productItem.alwaysShowTooltip) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($847bf9dc758b6d61$var$CustomTooltip, {
                content: productItem.tooltip
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: $847bf9dc758b6d61$var$styles$2["client-picker__info-icon"]
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
                icon: (0, $c761e69c8e58189a$exports.circle_info)
            })))), productItem.description && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: $847bf9dc758b6d61$var$styles$2["client-picker__description"]
            }, productItem.description), isLegacyApp && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: "helix-badge helix-badge--inverted helix-badge--tiny",
                style: {
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    marginTop: "4px",
                    width: "fit-content",
                    cursor: "pointer"
                },
                "aria-label": `Show ${productItem.count} instances of ${productItem.label}`,
                onClick: (e)=>{
                    var _a;
                    e.preventDefault();
                    e.stopPropagation();
                    if (((_a = productItem.instances) === null || _a === void 0 ? void 0 : _a.length) === 1) {
                        // If only one instance, click the main li
                        const instance = productItem.instances[0];
                        const legacyApp = personalApps.find((app)=>app.appId === productItem.appId);
                        const connection = legacyApp && appConnections.find((conn)=>conn.appId === productItem.appId && (conn.name === instance || conn.clientId === instance)) || null;
                        if (connection) {
                            const url = $847bf9dc758b6d61$var$buildProductLaunchUrl(environment || "dev", connection);
                            window.open(url, "_self");
                            originalHandleToggle();
                        }
                        return;
                    }
                    if (productItem.instances) handleLegacyAppClick(productItem.appId, productItem.instances, e);
                },
                onKeyDown: (e)=>{
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        e.stopPropagation();
                        if (productItem.instances) {
                            // Synthesize a MouseEvent for compatibility
                            const mouseEvent = Object.assign(Object.assign({}, e), {
                                preventDefault: e.preventDefault.bind(e),
                                stopPropagation: e.stopPropagation.bind(e)
                            });
                            handleLegacyAppClick(productItem.appId, productItem.instances, mouseEvent);
                        }
                    }
                }
            }, ((_a = productItem.instances) === null || _a === void 0 ? void 0 : _a[0]) || productItem.count, productItem.count && productItem.count > 1 && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
                icon: (0, $c761e69c8e58189a$exports.chevron_small_down),
                style: {
                    width: "12px",
                    height: "12px"
                }
            })))));
        }
        return null;
    }))), document.body), expandedLegacyApp && (0, $1u0KT.createPortal)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: `${$847bf9dc758b6d61$var$styles$2["client-picker__dropdown-menu"]} ${$847bf9dc758b6d61$var$styles$2.open} client-picker__legacy-instance`,
        role: "menu",
        "aria-label": `${(_o = personalApps.find((app)=>app.appId === expandedLegacyApp)) === null || _o === void 0 ? void 0 : _o.label} instances`,
        style: {
            position: "fixed",
            top: `${legacyAppSubmenuPosition.top}px`,
            left: `${legacyAppSubmenuPosition.left}px`,
            zIndex: 1001,
            minWidth: "200px"
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", null, (_q = (_p = personalApps.find((app)=>app.appId === expandedLegacyApp)) === null || _p === void 0 ? void 0 : _p.instances) === null || _q === void 0 ? void 0 : _q.slice().sort((a, b)=>{
        const nameA = typeof a === "object" && a.name ? a.name : String(a);
        const nameB = typeof b === "object" && b.name ? b.name : String(b);
        return nameA.localeCompare(nameB, undefined, {
            sensitivity: "base"
        });
    }).map((instance, index)=>{
        // Find the connection for this legacy app and client
        const legacyApp = personalApps.find((app)=>app.appId === expandedLegacyApp);
        const connection = legacyApp && appConnections.find((conn)=>conn.appId === expandedLegacyApp && (conn.name === instance || conn.clientId === instance)) || null;
        const url = connection ? $847bf9dc758b6d61$var$buildProductLaunchUrl(environment || "dev", connection) : "";
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: `${expandedLegacyApp}-${index}`
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
            href: url,
            className: `${$847bf9dc758b6d61$var$styles$2["client-picker__dropdown-item"]} ${submenuHighlightedIndex === index ? $847bf9dc758b6d61$var$styles$2["client-picker__dropdown-item--highlighted"] : ""}`,
            role: "menuitem",
            "aria-label": `Open ${instance} instance`,
            onClick: (e)=>{
                if (url) {
                    e.preventDefault();
                    window.open(url, "_self");
                    originalHandleToggle();
                    setExpandedLegacyApp(null);
                    setSubmenuHighlightedIndex(0);
                }
            },
            style: {
                textDecoration: "none"
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: $847bf9dc758b6d61$var$styles$2["client-picker__app-menu-item"]
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: $847bf9dc758b6d61$var$styles$2["client-picker__app-text"]
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: $847bf9dc758b6d61$var$styles$2["client-picker__item-label"],
            style: {
                color: "#374151"
            }
        }, instance)))));
    }))), document.body), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "status",
        "aria-live": "assertive",
        "aria-atomic": "true",
        className: "sr-only",
        style: {
            position: "absolute",
            left: "-10000px",
            width: "1px",
            height: "1px",
            padding: "0",
            margin: "0",
            overflow: "hidden",
            clipPath: "inset(50%)",
            whiteSpace: "nowrap",
            border: "0"
        }
    }, announceText), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-live": "polite",
        "aria-atomic": "false",
        className: "sr-only",
        style: {
            position: "absolute",
            left: "-10000px",
            width: "1px",
            height: "1px",
            padding: "0",
            margin: "0",
            overflow: "hidden",
            clipPath: "inset(50%)",
            whiteSpace: "nowrap",
            border: "0"
        }
    }, isOpen && `Client picker menu with ${combinedItems.filter((item)=>item.type === "client" || item.type === "product").length} items`));
};
$847bf9dc758b6d61$export$b9df65f7f957b5de.displayName = "ClientSwitcher";
const $847bf9dc758b6d61$export$1e8e95432f1f72fa = ({ children: children, active: active })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: `2222 ${$847bf9dc758b6d61$var$SidebarNavStyles["sidebar-nav-item"]} ${active ? $847bf9dc758b6d61$var$SidebarNavStyles["active"] : ""}`
    }, children);
};
$847bf9dc758b6d61$export$1e8e95432f1f72fa.displayName = "SidebarNavItem";
var $847bf9dc758b6d61$var$css_248z$4 = ".DropdownMenu-module_dropdownMenu__O72Vz{background-color:#fff;border-radius:4px;display:none;min-width:128px;overflow:hidden;position:relative;width:fit-content!important;z-index:1}.DropdownMenu-module_dropdownMenu__O72Vz.DropdownMenu-module_isOpen__CKQls{box-shadow:0 0 1px rgba(0,0,0,.2),0 4px 8px rgba(0,0,0,.1);box-sizing:border-box;display:block;padding:8px}.DropdownMenu-module_dropdownMenu__O72Vz.DropdownMenu-module_isOpen__CKQls li:not(.DropdownMenu-module_divider__ydHsE){border-radius:6px;box-sizing:border-box;color:#111827;display:block;font-size:14px;font-weight:400;margin-bottom:2px;text-decoration:none}.DropdownMenu-module_dropdownMenu__O72Vz.DropdownMenu-module_isOpen__CKQls li:not(.DropdownMenu-module_divider__ydHsE) .DropdownMenu-module_menuItemContentWrapper__8f2v-,.DropdownMenu-module_dropdownMenu__O72Vz.DropdownMenu-module_isOpen__CKQls li:not(.DropdownMenu-module_divider__ydHsE) a{padding:8px}.DropdownMenu-module_dropdownMenu__O72Vz.DropdownMenu-module_isOpen__CKQls li:not(.DropdownMenu-module_divider__ydHsE) a{border-radius:6px;box-sizing:border-box;color:inherit;display:flex;justify-content:space-between;text-decoration:none;white-space:nowrap}.DropdownMenu-module_dropdownMenu__O72Vz.DropdownMenu-module_isOpen__CKQls li:not(.DropdownMenu-module_divider__ydHsE).DropdownMenu-module_highlighted__5Vqgy{background-color:var(--helix-brand-pale);color:var(--helix-brand)}.DropdownMenu-module_dropdownMenu__O72Vz.DropdownMenu-module_isOpen__CKQls li:not(.DropdownMenu-module_divider__ydHsE).DropdownMenu-module_disabled__0kFEH{cursor:pointer;opacity:.5;pointer-events:none}.DropdownMenu-module_dropdownMenu__O72Vz.DropdownMenu-module_isOpen__CKQls li:not(.DropdownMenu-module_divider__ydHsE) .DropdownMenu-module_dropdownMenuItemContent__ulFBB{align-items:center;display:grid;gap:12px;grid-template-columns:1fr 20px;justify-content:space-between}.DropdownMenu-module_dropdownMenu__O72Vz.DropdownMenu-module_isOpen__CKQls li:not(.DropdownMenu-module_divider__ydHsE) .DropdownMenu-module_dropdownMenuItemContent__ulFBB .DropdownMenu-module_checkmarkOutlined__nMUi0,.DropdownMenu-module_dropdownMenu__O72Vz.DropdownMenu-module_isOpen__CKQls li:not(.DropdownMenu-module_divider__ydHsE) .DropdownMenu-module_dropdownMenuItemContent__ulFBB .DropdownMenu-module_checkmarkOutlined__nMUi0 path{fill:#2563eb!important}.DropdownMenu-module_dropdownMenu__O72Vz:focus-within{outline:none}.DropdownMenu-module_dropdownMenu__O72Vz ul{list-style:none;margin:0;padding:0}.DropdownMenu-module_dropdownMenu__O72Vz ul.DropdownMenu-module_inNavbar__edmiI{max-height:calc(100vh - 150px);overflow:auto}.DropdownMenu-module_dropdownMenu__O72Vz ul:focus-visible{outline:none}.DropdownMenu-module_dropdownMenu__O72Vz ul li:not(.DropdownMenu-module_divider__ydHsE):not(.DropdownMenu-module_sectionHeader__g46Zn):not(.DropdownMenu-module_disabled__0kFEH):not(.DropdownMenu-module_itemReadOnly__oHhTy){cursor:pointer}.DropdownMenu-module_dropdownMenu__O72Vz ul li{display:flex}.DropdownMenu-module_dropdownMenu__O72Vz ul li .DropdownMenu-module_menuItemContentWrapper__8f2v-{align-items:center;display:flex;flex:1 1;justify-content:space-between}.DropdownMenu-module_dropdownMenu__O72Vz ul li .DropdownMenu-module_menuItemContentWrapper__8f2v- .DropdownMenu-module_menuItemLabel__gCJap{flex:1 1}.DropdownMenu-module_dropdownMenu__O72Vz ul li.DropdownMenu-module_disabled__0kFEH .DropdownMenu-module_menuItemContentWrapper__8f2v- :not(.DropdownMenu-module_notActive__SqC-K) .DropdownMenu-module_description__sIQ69,.DropdownMenu-module_dropdownMenu__O72Vz ul li.DropdownMenu-module_disabled__0kFEH .DropdownMenu-module_menuItemContentWrapper__8f2v- :not(.DropdownMenu-module_notActive__SqC-K) .DropdownMenu-module_label__EzR8Y,.DropdownMenu-module_dropdownMenu__O72Vz ul li:disabled .DropdownMenu-module_menuItemContentWrapper__8f2v- :not(.DropdownMenu-module_notActive__SqC-K) .DropdownMenu-module_description__sIQ69,.DropdownMenu-module_dropdownMenu__O72Vz ul li:disabled .DropdownMenu-module_menuItemContentWrapper__8f2v- :not(.DropdownMenu-module_notActive__SqC-K) .DropdownMenu-module_label__EzR8Y{opacity:.6}.DropdownMenu-module_dropdownMenu__O72Vz ul li.DropdownMenu-module_selectedItem__YdDjO{background-color:#e5e7eb;outline-width:0}.DropdownMenu-module_dropdownMenu__O72Vz ul li.DropdownMenu-module_active__65Hbo{background-color:#e5e7eb;color:#111827}.DropdownMenu-module_dropdownMenu__O72Vz ul li.DropdownMenu-module_itemReadOnly__oHhTy{cursor:pointer;pointer-events:none}.DropdownMenu-module_dropdownMenu__O72Vz ul .DropdownMenu-module_divider__ydHsE{border-top:1px solid #e5e7eb;margin:6px 0;overflow:hidden;padding:0}.DropdownMenu-module_dropdownMenu__O72Vz ul .DropdownMenu-module_sectionHeader__g46Zn{color:#4b5563;font-size:12px!important;letter-spacing:.1em;padding:8px;text-transform:uppercase}.DropdownMenu-module_dropdownMenu__O72Vz ul .DropdownMenu-module_sectionHeader__g46Zn .DropdownMenu-module_menuItemContentWrapper__8f2v-{padding:0}.DropdownMenu-module_dropdownMenu__O72Vz ul .DropdownMenu-module_description__sIQ69{color:#4b5563;font-size:12px}.DropdownMenu-module_dropdownMenu__O72Vz ul+ul{margin-left:16px}@media screen and (max-width:576px){.DropdownMenu-module_dropdownMenu__O72Vz ul+ul{margin-left:0;margin-top:16px}}.DropdownMenu-module_dropdownMenu__O72Vz .DropdownMenu-module_emptyState__8SMYv{padding:8px;text-align:center}";
var $847bf9dc758b6d61$var$DropdownStyles = {
    "dropdownMenu": "DropdownMenu-module_dropdownMenu__O72Vz",
    "isOpen": "DropdownMenu-module_isOpen__CKQls",
    "divider": "DropdownMenu-module_divider__ydHsE",
    "menuItemContentWrapper": "DropdownMenu-module_menuItemContentWrapper__8f2v-",
    "highlighted": "DropdownMenu-module_highlighted__5Vqgy",
    "disabled": "DropdownMenu-module_disabled__0kFEH",
    "dropdownMenuItemContent": "DropdownMenu-module_dropdownMenuItemContent__ulFBB",
    "inNavbar": "DropdownMenu-module_inNavbar__edmiI",
    "sectionHeader": "DropdownMenu-module_sectionHeader__g46Zn",
    "itemReadOnly": "DropdownMenu-module_itemReadOnly__oHhTy",
    "active": "DropdownMenu-module_active__65Hbo"
};
$847bf9dc758b6d61$var$styleInject($847bf9dc758b6d61$var$css_248z$4);
const $847bf9dc758b6d61$var$DropdownMenu = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function menu(props, ref) {
    const { children: children, isOpen: isOpen, maxWidth: maxWidth, width: width, inNavbar: inNavbar = false, usePortal: usePortal = false, buttonRef: buttonRef, className: className } = props, rest = $847bf9dc758b6d61$var$__rest$1(props, [
        "children",
        "isOpen",
        "maxWidth",
        "width",
        "inNavbar",
        "usePortal",
        "buttonRef",
        "className"
    ]);
    const [menuStyles, setMenuStyles] = (0, $acw62.useState)({});
    (0, $acw62.useEffect)(()=>{
        console.log("DropdownMenu useEffect triggered", {
            usePortal: usePortal,
            isOpen: isOpen,
            buttonRef: buttonRef
        });
        if (usePortal && isOpen && (buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current)) {
            const buttonRect = buttonRef.current.getBoundingClientRect();
            setMenuStyles({
                position: "absolute",
                top: `${buttonRect.bottom + window.scrollY}px`,
                left: `${buttonRect.left + window.scrollX}px`,
                width: width || "auto",
                maxWidth: maxWidth || "none"
            });
        }
    }, [
        usePortal,
        isOpen,
        buttonRef,
        width,
        maxWidth
    ]);
    const classNames = `${$847bf9dc758b6d61$var$DropdownStyles.dropdownMenu} ${isOpen ? $847bf9dc758b6d61$var$DropdownStyles.isOpen : ""} ${inNavbar ? $847bf9dc758b6d61$var$DropdownStyles.inNavbar : ""} ${className || ""}`;
    if (typeof document === "undefined") return null;
    const menuContent = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        ref: ref,
        className: classNames,
        style: usePortal ? menuStyles : undefined
    }, rest), children);
    if (usePortal) return (0, $1u0KT.createPortal)(menuContent, document.body);
    return menuContent;
});
var $847bf9dc758b6d61$var$css_248z$3 = ".NavbarUserMenu-module_helixIcon__aisL1 path:not(.NavbarUserMenu-module_alert-dot__YKYog){fill:currentColor!important}.NavbarUserMenu-module_helixApplicationUserAvatar__a31Sd{align-items:center;border-radius:50%;display:flex;height:32px;object-position:center center;overflow:hidden;width:32px}.NavbarUserMenu-module_helixApplicationUserAvatar__a31Sd img{height:32px;object-fit:cover;width:32px}.NavbarUserMenu-module_helixApplicationUserAvatarButton__FkbQZ{border:2px solid transparent;border-radius:50%;margin-left:8px;padding:0}.NavbarUserMenu-module_helixApplicationUserAvatarButton__FkbQZ.NavbarUserMenu-module_active__7ZMwF{border:2px solid var(--helix-brand)}.NavbarUserMenu-module_helixApplicationUserAvatarButton__FkbQZ:focus{border:2px solid var(--helix-brand);outline:2px solid var(--helix-brand)}.NavbarUserMenu-module_helixApplicationUserAvatarButton__FkbQZ:hover{border:2px solid var(--helix-brand)}";
var $847bf9dc758b6d61$var$userMenuStyles = {
    "helixApplicationUserAvatar": "NavbarUserMenu-module_helixApplicationUserAvatar__a31Sd",
    "helixApplicationUserAvatarButton": "NavbarUserMenu-module_helixApplicationUserAvatarButton__FkbQZ"
};
$847bf9dc758b6d61$var$styleInject($847bf9dc758b6d61$var$css_248z$3);
var $847bf9dc758b6d61$var$css_248z$2 = ".NavbarBadge-module_navbarBadge__p6A9W{align-items:center;border-radius:99px;box-sizing:border-box;display:inline-flex;flex:0 0 24px;font-size:11px;font-weight:600;justify-content:center;margin-left:6px;padding:2px 6px;vertical-align:baseline;white-space:nowrap}.NavbarBadge-module_navbarBadge__p6A9W.NavbarBadge-module_dark__3IaKJ{background-color:#d1d5db;color:#1f2937}.NavbarBadge-module_navbarBadge__p6A9W.NavbarBadge-module_light__ARkYH{background-color:#374151;color:#f3f4f6}";
var $847bf9dc758b6d61$var$styles$1 = {
    "navbarBadge": "NavbarBadge-module_navbarBadge__p6A9W",
    "dark": "NavbarBadge-module_dark__3IaKJ",
    "light": "NavbarBadge-module_light__ARkYH"
};
$847bf9dc758b6d61$var$styleInject($847bf9dc758b6d61$var$css_248z$2);
const $847bf9dc758b6d61$var$NavbarBadge = (_a)=>{
    var { children: children, isDark: isDark = false } = _a, props = $847bf9dc758b6d61$var$__rest$1(_a, [
        "children",
        "isDark"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", Object.assign({
        className: `${$847bf9dc758b6d61$var$styles$1.navbarBadge} ${isDark ? $847bf9dc758b6d61$var$styles$1.dark : $847bf9dc758b6d61$var$styles$1.light}`
    }, props), children);
};
$847bf9dc758b6d61$var$NavbarBadge.displayName = "NavbarBadge";
const $847bf9dc758b6d61$var$getTarget = (menuItem)=>{
    return menuItem.target ? {
        target: menuItem.target
    } : {};
};
const $847bf9dc758b6d61$var$getTargetSimple = (target)=>{
    return target ? {
        target: target
    } : {};
};
const $847bf9dc758b6d61$var$clickDropdownItem = (e, menuRef)=>{
    var _a;
    if (e.key === "Enter") {
        const items = (_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.children;
        const array = Array.from(items);
        const item = array.filter((node)=>node.classList.contains("highlighted"));
        const link = item[0].getElementsByTagName("A");
        if (link[0]) link[0].click();
    }
};
const $847bf9dc758b6d61$var$DropdownMenuItem = (_a)=>{
    var { menuItem: menuItem, highlightedIndex: highlightedIndex, index: index, getItemProps: getItemProps, itemFormatter: itemFormatter, linkWrapper: linkWrapper, itemVisible: itemVisible, className: className, onClick: onClick, useChildrenInProps: useChildrenInProps = false, useCheckmarkActive: useCheckmarkActive = false } = _a, rest = $847bf9dc758b6d61$var$__rest$1(_a, [
        "menuItem",
        "highlightedIndex",
        "index",
        "getItemProps",
        "itemFormatter",
        "linkWrapper",
        "itemVisible",
        "className",
        "onClick",
        "useChildrenInProps",
        "useCheckmarkActive"
    ]);
    const activeCheckmark = useCheckmarkActive && (menuItem.active || menuItem.defaultOption) ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
        icon: (0, $c761e69c8e58189a$exports.checkmark)
    }) : null;
    const itemContent = (menuItem)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: $847bf9dc758b6d61$var$DropdownStyles.dropdownMenuItemContent
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, typeof menuItem.label === "function" ? menuItem.label(menuItem) : menuItem.label, menuItem.badge && menuItem.badge.label !== undefined && !menuItem.badge.hidden && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($847bf9dc758b6d61$var$NavbarBadge, null, menuItem.badge.label)), activeCheckmark));
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", Object.assign({
        className: `${index === highlightedIndex ? $847bf9dc758b6d61$var$DropdownStyles.highlighted : ""} ${menuItem.disabled ? $847bf9dc758b6d61$var$DropdownStyles.disabled : ""} ${menuItem.active && !useCheckmarkActive ? $847bf9dc758b6d61$var$DropdownStyles.active : ""} ${menuItem.divider ? $847bf9dc758b6d61$var$DropdownStyles.divider : ""} ${menuItem.header ? `${$847bf9dc758b6d61$var$DropdownStyles.sectionHeader} ${$847bf9dc758b6d61$var$DropdownStyles.sectionHeaderBold}` : ""} ${menuItem.readOnly ? $847bf9dc758b6d61$var$DropdownStyles.itemReadOnly : ""} ${className}`
    }, rest, getItemProps({
        item: menuItem,
        disabled: menuItem.disabled || itemVisible || menuItem.divider || menuItem.header,
        index: index,
        onClick: (e)=>{
            onClick && onClick(e);
        },
        id: typeof menuItem.label === "string" && menuItem.label ? `dropdown-menu-item-${menuItem.label.replace(/ /g, "-").toLowerCase()}` : undefined
    })), menuItem.url ? menuItem.disabled ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $847bf9dc758b6d61$var$DropdownStyles.menuItemContentWrapper
    }, itemFormatter ? itemFormatter(menuItem) : itemContent(menuItem)) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, linkWrapper ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(linkWrapper({
        item: menuItem,
        props: {}
    }), {
        children: itemContent(menuItem)
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", Object.assign({
        href: menuItem.url
    }, $847bf9dc758b6d61$var$getTarget(menuItem)), itemFormatter ? itemFormatter(menuItem) : itemContent(menuItem))) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $847bf9dc758b6d61$var$DropdownStyles.menuItemContentWrapper
    }, itemFormatter ? itemFormatter(menuItem) : itemContent(menuItem)));
};
var $847bf9dc758b6d61$var$css_248z$1 = ".Avatar-module_helix-avatar__xv1rN{align-items:center;background-color:var(--helix-avatar-bg,var(--helix-gray-400,#9ca3af));color:var(--helix-avatar-text,var(--helix-black,#000));display:inline-flex;font-weight:600;justify-content:center;overflow:hidden;text-transform:uppercase}.Avatar-module_helix-avatar--size-xx-tiny__wB6UQ{font-size:8px;height:18px;width:18px;--avatar-svg-scale:0.55}.Avatar-module_helix-avatar--size-x-tiny__7EqN0{font-size:10px;height:24px;width:24px;--avatar-svg-scale:0.75}.Avatar-module_helix-avatar--size-tiny__55dc4{font-size:14px;height:32px;width:32px;--avatar-svg-scale:1}.Avatar-module_helix-avatar--size-small__oZ5zh{font-size:20px;height:48px;width:48px;--avatar-svg-scale:1.5}.Avatar-module_helix-avatar--size-medium__pvx5Q{font-size:24px;height:60px;width:60px;--avatar-svg-scale:1.9}.Avatar-module_helix-avatar--size-large__tgdAD{font-size:38px;height:90px;width:90px;--avatar-svg-scale:2.8}.Avatar-module_helix-avatar--size-x-large__HeZID{font-size:48px;height:120px;width:120px;--avatar-svg-scale:3.75}.Avatar-module_helix-avatar--size-xx-large__ayaHy{font-size:58px;height:150px;width:150px;--avatar-svg-scale:4.7}.Avatar-module_helix-avatar--shape-round__Rvb-n{border-radius:50%}.Avatar-module_helix-avatar--shape-rounded__QGSam{border-radius:10px}.Avatar-module_helix-avatar--shape-rounded__QGSam.Avatar-module_helix-avatar--size-xx-tiny__wB6UQ{border-radius:2px}.Avatar-module_helix-avatar--shape-rounded__QGSam.Avatar-module_helix-avatar--size-x-tiny__7EqN0{border-radius:4px}.Avatar-module_helix-avatar--shape-rounded__QGSam.Avatar-module_helix-avatar--size-tiny__55dc4{border-radius:6px}.Avatar-module_helix-avatar--shape-rounded__QGSam.Avatar-module_helix-avatar--size-small__oZ5zh{border-radius:8px}.Avatar-module_helix-avatar--shape-rounded__QGSam.Avatar-module_helix-avatar--size-medium__pvx5Q{border-radius:10px}.Avatar-module_helix-avatar--shape-rounded__QGSam.Avatar-module_helix-avatar--size-large__tgdAD{border-radius:12px}.Avatar-module_helix-avatar--shape-rounded__QGSam.Avatar-module_helix-avatar--size-x-large__HeZID{border-radius:14px}.Avatar-module_helix-avatar--shape-rounded__QGSam.Avatar-module_helix-avatar--size-xx-large__ayaHy{border-radius:16px}.Avatar-module_helix-avatar__xv1rN img{display:block;height:100%;object-fit:cover;width:100%}.Avatar-module_helix-avatar__xv1rN svg{transform:scale(var(--avatar-svg-scale,1))}.Avatar-module_helix-avatar__xv1rN svg path{fill:var(--helix-avatar-icon,var(--helix-white,#fff))}.Avatar-module_helix-avatar__icon__-9Heb{align-items:center;display:inline-flex;justify-content:center}";
var $847bf9dc758b6d61$var$styles = {
    "helix-avatar": "Avatar-module_helix-avatar__xv1rN",
    "helix-avatar--size-xx-tiny": "Avatar-module_helix-avatar--size-xx-tiny__wB6UQ",
    "helix-avatar--size-x-tiny": "Avatar-module_helix-avatar--size-x-tiny__7EqN0",
    "helix-avatar--size-tiny": "Avatar-module_helix-avatar--size-tiny__55dc4",
    "helix-avatar--size-small": "Avatar-module_helix-avatar--size-small__oZ5zh",
    "helix-avatar--size-medium": "Avatar-module_helix-avatar--size-medium__pvx5Q",
    "helix-avatar--size-large": "Avatar-module_helix-avatar--size-large__tgdAD",
    "helix-avatar--size-x-large": "Avatar-module_helix-avatar--size-x-large__HeZID",
    "helix-avatar--size-xx-large": "Avatar-module_helix-avatar--size-xx-large__ayaHy",
    "helix-avatar--shape-round": "Avatar-module_helix-avatar--shape-round__Rvb-n",
    "helix-avatar--shape-rounded": "Avatar-module_helix-avatar--shape-rounded__QGSam",
    "helix-avatar__icon": "Avatar-module_helix-avatar__icon__-9Heb"
};
$847bf9dc758b6d61$var$styleInject($847bf9dc758b6d61$var$css_248z$1);
const $847bf9dc758b6d61$var$Avatar = (_a)=>{
    var { children: children, size: size = "medium", dataLwtId: dataLwtId, className: className, name: name, shape: shape = "round", useIcon: useIcon = false, icon: icon = (0, $c761e69c8e58189a$exports.agent) } = _a, rest = $847bf9dc758b6d61$var$__rest$1(_a, [
        "children",
        "size",
        "dataLwtId",
        "className",
        "name",
        "shape",
        "useIcon",
        "icon"
    ]);
    const classNameList = $847bf9dc758b6d61$var$classNames($847bf9dc758b6d61$var$styles["helix-avatar"], $847bf9dc758b6d61$var$styles[`helix-avatar--size-${size}`], $847bf9dc758b6d61$var$styles[`helix-avatar--shape-${shape}`], className);
    const generateInitials = (name)=>{
        const names = name.split(" ");
        if (names.length === 1) return names[0].charAt(0);
        return names[0].charAt(0) + names[names.length - 1].charAt(0);
    };
    const generateContent = ()=>{
        if (name && !children && !useIcon) return generateInitials(name);
        if (useIcon && !children) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
            icon: icon,
            className: $847bf9dc758b6d61$var$styles["helix-avatar__icon"]
        });
        return children;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        "data-lwt-id": dataLwtId,
        className: classNameList
    }, rest), generateContent());
};
$847bf9dc758b6d61$var$Avatar.displayName = "Avatar";
const $847bf9dc758b6d61$export$72d0b49a56703654 = (_a)=>{
    var { menuItems: menuItems = [], dataLwtId: dataLwtId = "navbar-user-menu", className: className, linkWrapper: linkWrapper, user: user, location: location, id: id } = _a, rest = $847bf9dc758b6d61$var$__rest$1(_a, [
        "menuItems",
        "dataLwtId",
        "className",
        "linkWrapper",
        "user",
        "location",
        "id"
    ]);
    const { isOpen: isOpen, getToggleButtonProps: getToggleButtonProps, getMenuProps: getMenuProps, highlightedIndex: highlightedIndex, getItemProps: getItemProps, setReferenceElement: setReferenceElement, setPopperElement: setPopperElement, attributes: attributes, styles: styles } = (0, $1c94395e3d071205$exports.useDropdownMenu)({
        placement: "bottom-end",
        items: menuItems,
        resetSelectedItemOnClose: true,
        itemToString: (item)=>item.label ? item.label : "",
        offset: [
            0,
            8
        ]
    });
    const menuRef = (0, $acw62.useRef)(null);
    const isActive = ()=>{
        return menuItems ? menuItems.filter((item)=>item.active).length > 0 || location && menuItems.filter((item)=>item.url === (location === null || location === void 0 ? void 0 : location.pathname)).length > 0 : false;
    };
    const handleKeyDown = (e)=>{
        $847bf9dc758b6d61$var$clickDropdownItem(e, menuRef);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        ref: setReferenceElement,
        className: `helix-unified-nav__additional-nav-item helix-unified-nav__additional-user-menu-toggle ${className ? className : ""} ${$847bf9dc758b6d61$var$userMenuStyles.helixUnifiedNavAdditionalUserMenuToggle}`,
        "data-lwt-id": dataLwtId
    }, rest), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", Object.assign({}, getToggleButtonProps({
        id: id || "navbar-user-menu-toggle"
    }), {
        "aria-label": "User Menu",
        className: `${$847bf9dc758b6d61$var$userMenuStyles.helixApplicationUserAvatarButton} ${isActive() ? "active" : ""} ${$847bf9dc758b6d61$var$userMenuStyles.helixUnifiedNavUserAvatar}`
    }), (user === null || user === void 0 ? void 0 : user.avatarURL) ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $847bf9dc758b6d61$var$userMenuStyles.helixApplicationUserAvatar
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: user.avatarURL,
        alt: "avatar"
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($847bf9dc758b6d61$var$Avatar, {
        name: (user === null || user === void 0 ? void 0 : user.name) || "",
        size: "tiny"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($847bf9dc758b6d61$var$DropdownMenu, Object.assign({
        inNavbar: true,
        maxWidth: "300px",
        ref: setPopperElement,
        isOpen: isOpen,
        style: styles.popper,
        className: "helix-unified-nav__user-dropdown-menu"
    }, attributes.popper), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", Object.assign({}, getMenuProps({
        onKeyDown: (e)=>handleKeyDown(e),
        ref: (ref)=>menuRef.current = ref
    })), menuItems && menuItems.length > 0 && menuItems.map((item, index)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($847bf9dc758b6d61$var$DropdownMenuItem, {
            menuItem: item,
            index: index,
            linkWrapper: linkWrapper,
            highlightedIndex: highlightedIndex,
            getItemProps: getItemProps,
            key: `${item.label}${index}`,
            className: location && location.pathname === item.url ? "active" : ""
        })))));
};
const $847bf9dc758b6d61$var$NavbarHelpDropdownMenu = ({ menuItems: menuItems, dataLwtId: dataLwtId, className: className, linkWrapper: linkWrapper, location: location, hideHelpHeader: hideHelpHeader = false, maxWidth: maxWidth = "300px" })=>{
    const { isOpen: isOpen, getToggleButtonProps: getToggleButtonProps, getMenuProps: getMenuProps, highlightedIndex: highlightedIndex, getItemProps: getItemProps, setReferenceElement: setReferenceElement, setPopperElement: setPopperElement, attributes: attributes, styles: styles } = (0, $1c94395e3d071205$exports.useDropdownMenu)({
        placement: "bottom-end",
        items: menuItems,
        itemToString: (item)=>item.label ? item.label : "",
        offset: [
            0,
            8
        ],
        resetSelectedItemOnClose: true
    });
    const menuRef = (0, $acw62.useRef)(null);
    const handleKeyDown = (e)=>{
        $847bf9dc758b6d61$var$clickDropdownItem(e, menuRef);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: `helix-unified-nav__additional-nav-item helix-unified-nav__additional-help-link ${className ? className : ""}`,
        ref: setReferenceElement,
        "data-lwt-id": dataLwtId
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", Object.assign({}, getToggleButtonProps(), {
        "aria-label": "Help Menu",
        className: `${$847bf9dc758b6d61$var$SidebarNavStyles["helix-application-header__btn"]} ${""} `,
        id: "helix-unified-nav_help-link"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
        icon: (0, $c761e69c8e58189a$exports.circle_question)
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($847bf9dc758b6d61$var$DropdownMenu, Object.assign({
        inNavbar: true,
        maxWidth: maxWidth,
        ref: setPopperElement,
        isOpen: isOpen,
        style: styles.popper,
        className: "helix-unified-nav__user-dropdown-menu"
    }, attributes.popper), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", Object.assign({}, getMenuProps({
        onKeyDown: (e)=>handleKeyDown(e),
        ref: (ref)=>menuRef.current = ref
    })), isOpen && menuItems.length > 0 && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, !hideHelpHeader && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        className: `${$847bf9dc758b6d61$var$DropdownStyles.sectionHeader} ${$847bf9dc758b6d61$var$DropdownStyles.sectionHeaderBold}`
    }, "Help"), menuItems.map((item, index)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($847bf9dc758b6d61$var$DropdownMenuItem, {
            menuItem: item,
            index: index,
            linkWrapper: linkWrapper,
            highlightedIndex: highlightedIndex,
            getItemProps: getItemProps,
            className: location && location.pathname === item.url ? "active" : "",
            key: `${item.label}${index}`
        }))))));
};
const $847bf9dc758b6d61$export$5b5b7a56b116efb5 = ({ url: url, dataLwtId: dataLwtId = "navbar-help-link", className: className, linkWrapper: linkWrapper, menuItems: menuItems, menuItemsLinkWrapper: menuItemsLinkWrapper, location: location, target: target, hideHelpHeader: hideHelpHeader = false, dropdownMenuMaxWidth: dropdownMenuMaxWidth })=>{
    if (menuItems) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($847bf9dc758b6d61$var$NavbarHelpDropdownMenu, {
        location: location,
        menuItems: menuItems,
        dataLwtId: dataLwtId,
        linkWrapper: menuItemsLinkWrapper,
        hideHelpHeader: hideHelpHeader,
        maxWidth: dropdownMenuMaxWidth
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: ` ${className ? className : ""}`,
        "data-lwt-id": dataLwtId
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, url ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, linkWrapper ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(linkWrapper({
        url: url,
        props: {
            className: `${$847bf9dc758b6d61$var$SidebarNavStyles["helix-application-header__btn"]}`
        },
        label: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
            icon: (0, $c761e69c8e58189a$exports.circle_question)
        })
    }), {
        className: `${$847bf9dc758b6d61$var$SidebarNavStyles["helix-application-header__btn"]}`,
        id: "helix-unified-nav_help-link",
        "aria-label": "Help"
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", Object.assign({
        href: url,
        className: `${$847bf9dc758b6d61$var$SidebarNavStyles["helix-application-header__btn"]}`
    }, $847bf9dc758b6d61$var$getTargetSimple(target), {
        "aria-label": "Help",
        id: "helix-unified-nav_help-link"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
        icon: (0, $c761e69c8e58189a$exports.circle_question)
    }))) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: `${$847bf9dc758b6d61$var$SidebarNavStyles["helix-application-header__btn"]}`,
        "aria-label": "Help",
        id: "helix-unified-nav_help-link"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
        icon: (0, $c761e69c8e58189a$exports.circle_question)
    })))));
};
var $847bf9dc758b6d61$var$css_248z = "._container_1qfbf_1{max-height:90vh;max-width:512px;overflow-x:hidden;overflow-y:overlay;width:100%}._container_1x4c1_1{height:60px;padding:16px 24px;position:sticky;top:0;z-index:1}._container_1x4c1_1 ._empty_1x4c1_9:empty{display:none}._switch-control_1x4c1_13{margin-right:0!important}._content_hzvjq_1{overflow:hidden;transition:all .4s ease,opacity .4s ease}._button_hzvjq_8{align-items:center;display:flex;gap:20px;margin-bottom:8px;margin-left:4px;margin-top:8px;padding-left:8px;padding-right:8px}._button_hzvjq_8 svg{height:24px;width:24px}._container_rl39j_1{background-color:var(--helix-gray-50);border-radius:50%;flex-shrink:0;height:32px;width:32px}._container_19qk1_1{cursor:pointer;max-height:36px;min-height:36px}._container_19qk1_1:hover{background-color:var(--helix-gray-50);text-decoration:none}._container_19qk1_1>svg{height:20px;width:20px}._notification-list-item_khick_1{padding:16px}._notification-list-item-info_khick_5{padding:8px}._notification-list-item-info_khick_5:hover{background-color:var(--helix-gray-50)}._reaction_1op37_1{cursor:pointer}._reaction_1op37_1:hover{text-decoration:none}._container_1l9cn_1{display:flex;justify-content:flex-end;position:absolute;right:-32px;width:50%}._wrapper_1l9cn_9{align-items:center;background-color:#fff;border-radius:50%;box-sizing:border-box;cursor:pointer;display:flex;height:24px;justify-content:center;max-width:24px;min-width:24px;position:relative}._wrapper_1l9cn_9:hover{background-color:var(--helix-gray-50);box-shadow:0 0 2px #0000004d}._dot_1l9cn_28{border-radius:50%;height:8px;width:8px}._container_1sd8v_1{margin-top:3px;text-align:right;white-space:nowrap}._container_rmsgc_1 .helix-modal-overlay{display:none}._container_rmsgc_1>div{padding:0!important}._container_rmsgc_1>div,._modal_rmsgc_10{background-color:var(--helix-gray-50)!important}._modal_rmsgc_10{animation:none!important;border-radius:0!important;box-shadow:none!important;max-width:unset!important;transition:none!important;width:100%!important}._panel_rmsgc_20{padding:24px 12px;width:640px}._panel_rmsgc_20 .header-text{color:var(--helix-gray-500);text-transform:uppercase}._panel-header_rmsgc_30{align-items:center;border-bottom:1px solid var(--helix-gray-200);display:flex;justify-content:space-between;margin:0 12px 16px;padding-bottom:12px}._container_15ak9_1{display:flex;flex-direction:column;gap:24px}._container_15ak9_1 p:first-letter{text-transform:uppercase}._container_kb9xx_1{align-items:center;background-color:var(--helix-white);box-shadow:0 0 1px #0003;display:flex;justify-content:center;padding:19px;position:sticky;top:0;width:100%;z-index:1}._container_kb9xx_1 button{background-color:transparent;border:none;color:var(--helix-brand);cursor:pointer;display:flex;gap:12px;left:10px;position:absolute;top:50%;transform:translateY(-50%)}._container_kb9xx_1 button:focus{border-radius:4px;outline:2px solid var(--helix-brand)}._container_kb9xx_1 button svg path{fill:currentColor}._container_1akkk_1:hover{background-color:var(--helix-gray-100)}._popover_1ez3e_1{max-width:512px!important;width:100%!important}._button_wz7lb_1{appearance:none;background:none;border:none;cursor:pointer;margin:0;padding:0}";
$847bf9dc758b6d61$var$styleInject($847bf9dc758b6d61$var$css_248z);
const $847bf9dc758b6d61$export$b08a5e252ace2ba = (_a)=>{
    var { dataLwtId: dataLwtId = "navbar-notification-menu", lwtToken: lwtToken, baseUrl: baseUrl, className: className, pollingInterval: pollingInterval = 60000, onClick: onClick } = _a, rest = $847bf9dc758b6d61$var$__rest$1(_a, [
        "dataLwtId",
        "lwtToken",
        "baseUrl",
        "className",
        "pollingInterval",
        "onClick"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        className: `${className ? className : ""}`,
        "data-lwt-id": dataLwtId,
        onClick: (e)=>onClick && onClick(e)
    }, rest), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ffb8fedbdc425da8$export$36ba2f559d49a8f6), {
        accessToken: lwtToken,
        serviceUrl: baseUrl,
        pollingInterval: pollingInterval,
        "aria-label": "Notifications",
        className: `${$847bf9dc758b6d61$var$SidebarNavStyles["helix-application-header__btn"]} ${$847bf9dc758b6d61$var$SidebarNavStyles["helix-application-header__btn--notifications"]}`
    }));
};


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $026ca1316ca073a2$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $026ca1316ca073a2$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
typeof SuppressedError === "function" && SuppressedError;



var $acw62 = parcelRequire("acw62");
var $ea13dab1c811432a$exports = {};
"use strict";
Object.defineProperty($ea13dab1c811432a$exports, "__esModule", {
    value: true
});

var $6ZWSX = parcelRequire("6ZWSX");
var $a0f1a624334da46f$exports = {};
"use strict";
Object.defineProperty($a0f1a624334da46f$exports, "__esModule", {
    value: true
});
$a0f1a624334da46f$exports.JwtPayload = void 0;
var $3ada592c5c2caf10$exports = {};
"use strict";
Object.defineProperty($3ada592c5c2caf10$exports, "__esModule", {
    value: true
});
$3ada592c5c2caf10$exports.LwtClaim = void 0;
var $7f1bf4f1cd4bb4e6$exports = {};
"use strict";
Object.defineProperty($7f1bf4f1cd4bb4e6$exports, "__esModule", {
    value: true
});
$7f1bf4f1cd4bb4e6$exports.AppsClaim = void 0;
var $9abdc419272f044c$exports = {};
"use strict";
var $9abdc419272f044c$var$__extends = $9abdc419272f044c$exports && $9abdc419272f044c$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($9abdc419272f044c$exports, "__esModule", {
    value: true
});
$9abdc419272f044c$exports.BackOfficeClaim = void 0;
var $6e00c3c65151ee48$exports = {};
"use strict";
var $6e00c3c65151ee48$var$__extends = $6e00c3c65151ee48$exports && $6e00c3c65151ee48$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($6e00c3c65151ee48$exports, "__esModule", {
    value: true
});
$6e00c3c65151ee48$exports.ClaimWithClientId = void 0;
var $e66646a5a3742a99$exports = {};
"use strict";
Object.defineProperty($e66646a5a3742a99$exports, "__esModule", {
    value: true
});
$e66646a5a3742a99$exports.ClaimBase = void 0;
var $e66646a5a3742a99$var$ClaimBase = /** @class */ function() {
    function ClaimBase() {}
    return ClaimBase;
}();
$e66646a5a3742a99$exports.ClaimBase = $e66646a5a3742a99$var$ClaimBase;


var $6e00c3c65151ee48$var$ClaimWithClientId = /** @class */ function(_super) {
    $6e00c3c65151ee48$var$__extends(ClaimWithClientId, _super);
    function ClaimWithClientId() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClaimWithClientId.prototype.getClientId = function() {
        return this.cid;
    };
    return ClaimWithClientId;
}($e66646a5a3742a99$exports.ClaimBase);
$6e00c3c65151ee48$exports.ClaimWithClientId = $6e00c3c65151ee48$var$ClaimWithClientId;


var $9abdc419272f044c$var$BackOfficeClaim = /** @class */ function(_super) {
    $9abdc419272f044c$var$__extends(BackOfficeClaim, _super);
    function BackOfficeClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BackOfficeClaim.prototype.getMemberId = function() {
        return this.mid;
    };
    BackOfficeClaim.prototype.getOfficeId = function() {
        return this.oid;
    };
    return BackOfficeClaim;
}($6e00c3c65151ee48$exports.ClaimWithClientId);
$9abdc419272f044c$exports.BackOfficeClaim = $9abdc419272f044c$var$BackOfficeClaim;


var $0725a63358a022cb$exports = {};
"use strict";
var $0725a63358a022cb$var$__extends = $0725a63358a022cb$exports && $0725a63358a022cb$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($0725a63358a022cb$exports, "__esModule", {
    value: true
});
$0725a63358a022cb$exports.CloudAgentSuiteClaim = void 0;
var $e9b3d0d8244ee15b$exports = {};
"use strict";
var $e9b3d0d8244ee15b$var$__extends = $e9b3d0d8244ee15b$exports && $e9b3d0d8244ee15b$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($e9b3d0d8244ee15b$exports, "__esModule", {
    value: true
});
$e9b3d0d8244ee15b$exports.ClaimWithIntegerUserId = void 0;

var $e9b3d0d8244ee15b$var$ClaimWithIntegerUserId = /** @class */ function(_super) {
    $e9b3d0d8244ee15b$var$__extends(ClaimWithIntegerUserId, _super);
    function ClaimWithIntegerUserId() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ClaimWithIntegerUserId.prototype, "userId", {
        get: function() {
            return this.uid;
        },
        enumerable: false,
        configurable: true
    });
    return ClaimWithIntegerUserId;
}($e66646a5a3742a99$exports.ClaimBase);
$e9b3d0d8244ee15b$exports.ClaimWithIntegerUserId = $e9b3d0d8244ee15b$var$ClaimWithIntegerUserId;


var $0725a63358a022cb$var$CloudAgentSuiteClaim = /** @class */ function(_super) {
    $0725a63358a022cb$var$__extends(CloudAgentSuiteClaim, _super);
    function CloudAgentSuiteClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CloudAgentSuiteClaim;
}($e9b3d0d8244ee15b$exports.ClaimWithIntegerUserId);
$0725a63358a022cb$exports.CloudAgentSuiteClaim = $0725a63358a022cb$var$CloudAgentSuiteClaim;


var $1cd8c2f529c7c082$exports = {};
"use strict";
var $1cd8c2f529c7c082$var$__extends = $1cd8c2f529c7c082$exports && $1cd8c2f529c7c082$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($1cd8c2f529c7c082$exports, "__esModule", {
    value: true
});
$1cd8c2f529c7c082$exports.HomeSpotterBoostClaim = void 0;

var $1cd8c2f529c7c082$var$HomeSpotterBoostClaim = /** @class */ function(_super) {
    $1cd8c2f529c7c082$var$__extends(HomeSpotterBoostClaim, _super);
    function HomeSpotterBoostClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return HomeSpotterBoostClaim;
}($e9b3d0d8244ee15b$exports.ClaimWithIntegerUserId);
$1cd8c2f529c7c082$exports.HomeSpotterBoostClaim = $1cd8c2f529c7c082$var$HomeSpotterBoostClaim;


var $0e764ce704e92364$exports = {};
"use strict";
var $0e764ce704e92364$var$__extends = $0e764ce704e92364$exports && $0e764ce704e92364$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($0e764ce704e92364$exports, "__esModule", {
    value: true
});
$0e764ce704e92364$exports.HomeSpotterConnectClaim = void 0;

var $0e764ce704e92364$var$HomeSpotterConnectClaim = /** @class */ function(_super) {
    $0e764ce704e92364$var$__extends(HomeSpotterConnectClaim, _super);
    function HomeSpotterConnectClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return HomeSpotterConnectClaim;
}($e9b3d0d8244ee15b$exports.ClaimWithIntegerUserId);
$0e764ce704e92364$exports.HomeSpotterConnectClaim = $0e764ce704e92364$var$HomeSpotterConnectClaim;


var $b20b9539dd742c37$exports = {};
"use strict";
var $b20b9539dd742c37$var$__extends = $b20b9539dd742c37$exports && $b20b9539dd742c37$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($b20b9539dd742c37$exports, "__esModule", {
    value: true
});
$b20b9539dd742c37$exports.HomeSpotterSpacioClaim = void 0;
var $c28f4e0eecefe55b$exports = {};
"use strict";
var $c28f4e0eecefe55b$var$__extends = $c28f4e0eecefe55b$exports && $c28f4e0eecefe55b$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($c28f4e0eecefe55b$exports, "__esModule", {
    value: true
});
$c28f4e0eecefe55b$exports.ClaimWithStringUserId = void 0;

var $c28f4e0eecefe55b$var$ClaimWithStringUserId = /** @class */ function(_super) {
    $c28f4e0eecefe55b$var$__extends(ClaimWithStringUserId, _super);
    function ClaimWithStringUserId() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ClaimWithStringUserId.prototype, "userId", {
        get: function() {
            return this.uid;
        },
        enumerable: false,
        configurable: true
    });
    return ClaimWithStringUserId;
}($e66646a5a3742a99$exports.ClaimBase);
$c28f4e0eecefe55b$exports.ClaimWithStringUserId = $c28f4e0eecefe55b$var$ClaimWithStringUserId;


var $b20b9539dd742c37$var$HomeSpotterSpacioClaim = /** @class */ function(_super) {
    $b20b9539dd742c37$var$__extends(HomeSpotterSpacioClaim, _super);
    function HomeSpotterSpacioClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return HomeSpotterSpacioClaim;
}($c28f4e0eecefe55b$exports.ClaimWithStringUserId);
$b20b9539dd742c37$exports.HomeSpotterSpacioClaim = $b20b9539dd742c37$var$HomeSpotterSpacioClaim;


var $ab5916d34083b59b$exports = {};
"use strict";
var $ab5916d34083b59b$var$__extends = $ab5916d34083b59b$exports && $ab5916d34083b59b$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($ab5916d34083b59b$exports, "__esModule", {
    value: true
});
$ab5916d34083b59b$exports.LionDeskClaim = void 0;

var $ab5916d34083b59b$var$LionDeskClaim = /** @class */ function(_super) {
    $ab5916d34083b59b$var$__extends(LionDeskClaim, _super);
    function LionDeskClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return LionDeskClaim;
}($e9b3d0d8244ee15b$exports.ClaimWithIntegerUserId);
$ab5916d34083b59b$exports.LionDeskClaim = $ab5916d34083b59b$var$LionDeskClaim;


var $314a928ad41254d0$exports = {};
"use strict";
var $314a928ad41254d0$var$__extends = $314a928ad41254d0$exports && $314a928ad41254d0$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($314a928ad41254d0$exports, "__esModule", {
    value: true
});
$314a928ad41254d0$exports.PropertybaseBackOfficeClaim = void 0;

var $314a928ad41254d0$var$PropertybaseBackOfficeClaim = /** @class */ function(_super) {
    $314a928ad41254d0$var$__extends(PropertybaseBackOfficeClaim, _super);
    function PropertybaseBackOfficeClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertybaseBackOfficeClaim.prototype.getMemberId = function() {
        return this.mid;
    };
    return PropertybaseBackOfficeClaim;
}($6e00c3c65151ee48$exports.ClaimWithClientId);
$314a928ad41254d0$exports.PropertybaseBackOfficeClaim = $314a928ad41254d0$var$PropertybaseBackOfficeClaim;


var $9dc461c945dd7f36$exports = {};
"use strict";
var $9dc461c945dd7f36$var$__extends = $9dc461c945dd7f36$exports && $9dc461c945dd7f36$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($9dc461c945dd7f36$exports, "__esModule", {
    value: true
});
$9dc461c945dd7f36$exports.PropertybaseBoldLeadsClaim = void 0;

var $9dc461c945dd7f36$var$PropertybaseBoldLeadsClaim = /** @class */ function(_super) {
    $9dc461c945dd7f36$var$__extends(PropertybaseBoldLeadsClaim, _super);
    function PropertybaseBoldLeadsClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PropertybaseBoldLeadsClaim;
}($e9b3d0d8244ee15b$exports.ClaimWithIntegerUserId);
$9dc461c945dd7f36$exports.PropertybaseBoldLeadsClaim = $9dc461c945dd7f36$var$PropertybaseBoldLeadsClaim;


var $0bda6999d61522e8$exports = {};
"use strict";
var $0bda6999d61522e8$var$__extends = $0bda6999d61522e8$exports && $0bda6999d61522e8$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($0bda6999d61522e8$exports, "__esModule", {
    value: true
});
$0bda6999d61522e8$exports.PropertybaseGoClaim = void 0;

var $0bda6999d61522e8$var$PropertybaseGoClaim = /** @class */ function(_super) {
    $0bda6999d61522e8$var$__extends(PropertybaseGoClaim, _super);
    function PropertybaseGoClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PropertybaseGoClaim;
}($e9b3d0d8244ee15b$exports.ClaimWithIntegerUserId);
$0bda6999d61522e8$exports.PropertybaseGoClaim = $0bda6999d61522e8$var$PropertybaseGoClaim;


var $beb86539c2da83bd$exports = {};
"use strict";
var $beb86539c2da83bd$var$__extends = $beb86539c2da83bd$exports && $beb86539c2da83bd$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($beb86539c2da83bd$exports, "__esModule", {
    value: true
});
$beb86539c2da83bd$exports.SalesforceClaim = void 0;

var $beb86539c2da83bd$var$SalesforceClaim = /** @class */ function(_super) {
    $beb86539c2da83bd$var$__extends(SalesforceClaim, _super);
    function SalesforceClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SalesforceClaim.prototype.getMemberId = function() {
        return this.mid;
    };
    return SalesforceClaim;
}($6e00c3c65151ee48$exports.ClaimWithClientId);
$beb86539c2da83bd$exports.SalesforceClaim = $beb86539c2da83bd$var$SalesforceClaim;


var $fdf9774bc5a66564$exports = {};
"use strict";
var $fdf9774bc5a66564$var$__extends = $fdf9774bc5a66564$exports && $fdf9774bc5a66564$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($fdf9774bc5a66564$exports, "__esModule", {
    value: true
});
$fdf9774bc5a66564$exports.TransactionDeskClaim = void 0;

var $fdf9774bc5a66564$var$TransactionDeskClaim = /** @class */ function(_super) {
    $fdf9774bc5a66564$var$__extends(TransactionDeskClaim, _super);
    function TransactionDeskClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TransactionDeskClaim;
}($c28f4e0eecefe55b$exports.ClaimWithStringUserId);
$fdf9774bc5a66564$exports.TransactionDeskClaim = $fdf9774bc5a66564$var$TransactionDeskClaim;


var $4f9b292513b9e853$exports = {};
"use strict";
var $4f9b292513b9e853$var$__extends = $4f9b292513b9e853$exports && $4f9b292513b9e853$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($4f9b292513b9e853$exports, "__esModule", {
    value: true
});
$4f9b292513b9e853$exports.TerradatumAergoClaim = void 0;

var $4f9b292513b9e853$var$TerradatumAergoClaim = /** @class */ function(_super) {
    $4f9b292513b9e853$var$__extends(TerradatumAergoClaim, _super);
    function TerradatumAergoClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TerradatumAergoClaim;
}($c28f4e0eecefe55b$exports.ClaimWithStringUserId);
$4f9b292513b9e853$exports.TerradatumAergoClaim = $4f9b292513b9e853$var$TerradatumAergoClaim;


var $cb8b81ababfc35a4$exports = {};
"use strict";
var $cb8b81ababfc35a4$var$__extends = $cb8b81ababfc35a4$exports && $cb8b81ababfc35a4$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($cb8b81ababfc35a4$exports, "__esModule", {
    value: true
});
$cb8b81ababfc35a4$exports.TerradatumAgentMetricsClaim = void 0;

var $cb8b81ababfc35a4$var$TerradatumAgentMetricsClaim = /** @class */ function(_super) {
    $cb8b81ababfc35a4$var$__extends(TerradatumAgentMetricsClaim, _super);
    function TerradatumAgentMetricsClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TerradatumAgentMetricsClaim;
}($c28f4e0eecefe55b$exports.ClaimWithStringUserId);
$cb8b81ababfc35a4$exports.TerradatumAgentMetricsClaim = $cb8b81ababfc35a4$var$TerradatumAgentMetricsClaim;


var $4e8bd5508bc2f5e7$exports = {};
"use strict";
var $4e8bd5508bc2f5e7$var$__extends = $4e8bd5508bc2f5e7$exports && $4e8bd5508bc2f5e7$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($4e8bd5508bc2f5e7$exports, "__esModule", {
    value: true
});
$4e8bd5508bc2f5e7$exports.XBrokerMetricsClaim = void 0;

var $4e8bd5508bc2f5e7$var$XBrokerMetricsClaim = /** @class */ function(_super) {
    $4e8bd5508bc2f5e7$var$__extends(XBrokerMetricsClaim, _super);
    function XBrokerMetricsClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return XBrokerMetricsClaim;
}($c28f4e0eecefe55b$exports.ClaimWithStringUserId);
$4e8bd5508bc2f5e7$exports.XBrokerMetricsClaim = $4e8bd5508bc2f5e7$var$XBrokerMetricsClaim;


var $dc20fae16c1adfd9$exports = {};
"use strict";
var $dc20fae16c1adfd9$var$__extends = $dc20fae16c1adfd9$exports && $dc20fae16c1adfd9$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($dc20fae16c1adfd9$exports, "__esModule", {
    value: true
});
$dc20fae16c1adfd9$exports.TerradatumListingHomeRunClaim = void 0;

var $dc20fae16c1adfd9$var$TerradatumListingHomeRunClaim = /** @class */ function(_super) {
    $dc20fae16c1adfd9$var$__extends(TerradatumListingHomeRunClaim, _super);
    function TerradatumListingHomeRunClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TerradatumListingHomeRunClaim;
}($c28f4e0eecefe55b$exports.ClaimWithStringUserId);
$dc20fae16c1adfd9$exports.TerradatumListingHomeRunClaim = $dc20fae16c1adfd9$var$TerradatumListingHomeRunClaim;


var $e97c5cf306b9a1ef$exports = {};
"use strict";
var $e97c5cf306b9a1ef$var$__extends = $e97c5cf306b9a1ef$exports && $e97c5cf306b9a1ef$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($e97c5cf306b9a1ef$exports, "__esModule", {
    value: true
});
$e97c5cf306b9a1ef$exports.TerradatumVScreenClaim = void 0;

var $e97c5cf306b9a1ef$var$TerradatumVScreenClaim = /** @class */ function(_super) {
    $e97c5cf306b9a1ef$var$__extends(TerradatumVScreenClaim, _super);
    function TerradatumVScreenClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TerradatumVScreenClaim;
}($c28f4e0eecefe55b$exports.ClaimWithStringUserId);
$e97c5cf306b9a1ef$exports.TerradatumVScreenClaim = $e97c5cf306b9a1ef$var$TerradatumVScreenClaim;


var $4fdd60b4eec46749$exports = {};
"use strict";
var $4fdd60b4eec46749$var$__extends = $4fdd60b4eec46749$exports && $4fdd60b4eec46749$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($4fdd60b4eec46749$exports, "__esModule", {
    value: true
});
$4fdd60b4eec46749$exports.WolfConnectClaim = void 0;

var $4fdd60b4eec46749$var$WolfConnectClaim = /** @class */ function(_super) {
    $4fdd60b4eec46749$var$__extends(WolfConnectClaim, _super);
    function WolfConnectClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WolfConnectClaim.prototype.getMemberId = function() {
        return this.mid;
    };
    return WolfConnectClaim;
}($6e00c3c65151ee48$exports.ClaimWithClientId);
$4fdd60b4eec46749$exports.WolfConnectClaim = $4fdd60b4eec46749$var$WolfConnectClaim;


var $549cc20d663e8194$exports = {};
"use strict";
var $549cc20d663e8194$var$__extends = $549cc20d663e8194$exports && $549cc20d663e8194$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($549cc20d663e8194$exports, "__esModule", {
    value: true
});
$549cc20d663e8194$exports.ZipFormPlusClaim = void 0;

var $549cc20d663e8194$var$ZipFormPlusClaim = /** @class */ function(_super) {
    $549cc20d663e8194$var$__extends(ZipFormPlusClaim, _super);
    function ZipFormPlusClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ZipFormPlusClaim;
}($c28f4e0eecefe55b$exports.ClaimWithStringUserId);
$549cc20d663e8194$exports.ZipFormPlusClaim = $549cc20d663e8194$var$ZipFormPlusClaim;


var $c8d313b0e38314f5$exports = {};
"use strict";
var $c8d313b0e38314f5$var$__extends = $c8d313b0e38314f5$exports && $c8d313b0e38314f5$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($c8d313b0e38314f5$exports, "__esModule", {
    value: true
});
$c8d313b0e38314f5$exports.AuthentisignClaim = void 0;

var $c8d313b0e38314f5$var$AuthentisignClaim = /** @class */ function(_super) {
    $c8d313b0e38314f5$var$__extends(AuthentisignClaim, _super);
    function AuthentisignClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return AuthentisignClaim;
}($c28f4e0eecefe55b$exports.ClaimWithStringUserId);
$c8d313b0e38314f5$exports.AuthentisignClaim = $c8d313b0e38314f5$var$AuthentisignClaim;


var $101bb400fa0fcbb3$exports = {};
"use strict";
var $101bb400fa0fcbb3$var$__extends = $101bb400fa0fcbb3$exports && $101bb400fa0fcbb3$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($101bb400fa0fcbb3$exports, "__esModule", {
    value: true
});
$101bb400fa0fcbb3$exports.BackOfficeV4Claim = void 0;

var $101bb400fa0fcbb3$var$BackOfficeV4Claim = /** @class */ function(_super) {
    $101bb400fa0fcbb3$var$__extends(BackOfficeV4Claim, _super);
    function BackOfficeV4Claim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BackOfficeV4Claim.prototype.getMemberId = function() {
        return this.mid;
    };
    BackOfficeV4Claim.prototype.getOfficeId = function() {
        return this.oid;
    };
    return BackOfficeV4Claim;
}($6e00c3c65151ee48$exports.ClaimWithClientId);
$101bb400fa0fcbb3$exports.BackOfficeV4Claim = $101bb400fa0fcbb3$var$BackOfficeV4Claim;


var $16da9b85397551a1$exports = {};
"use strict";
var $16da9b85397551a1$var$__extends = $16da9b85397551a1$exports && $16da9b85397551a1$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($16da9b85397551a1$exports, "__esModule", {
    value: true
});
$16da9b85397551a1$exports.CloudAttractClaim = void 0;

var $16da9b85397551a1$var$CloudAttractClaim = /** @class */ function(_super) {
    $16da9b85397551a1$var$__extends(CloudAttractClaim, _super);
    function CloudAttractClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CloudAttractClaim;
}($e9b3d0d8244ee15b$exports.ClaimWithIntegerUserId);
$16da9b85397551a1$exports.CloudAttractClaim = $16da9b85397551a1$var$CloudAttractClaim;


var $84312dac2f9f92a9$exports = {};
"use strict";
var $84312dac2f9f92a9$var$__extends = $84312dac2f9f92a9$exports && $84312dac2f9f92a9$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($84312dac2f9f92a9$exports, "__esModule", {
    value: true
});
$84312dac2f9f92a9$exports.CloudCMAClaim = void 0;

var $84312dac2f9f92a9$var$CloudCMAClaim = /** @class */ function(_super) {
    $84312dac2f9f92a9$var$__extends(CloudCMAClaim, _super);
    function CloudCMAClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CloudCMAClaim;
}($e9b3d0d8244ee15b$exports.ClaimWithIntegerUserId);
$84312dac2f9f92a9$exports.CloudCMAClaim = $84312dac2f9f92a9$var$CloudCMAClaim;


var $59b1f98649a9c2f7$exports = {};
"use strict";
var $59b1f98649a9c2f7$var$__extends = $59b1f98649a9c2f7$exports && $59b1f98649a9c2f7$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($59b1f98649a9c2f7$exports, "__esModule", {
    value: true
});
$59b1f98649a9c2f7$exports.CloudMLXClaim = void 0;

var $59b1f98649a9c2f7$var$CloudMLXClaim = /** @class */ function(_super) {
    $59b1f98649a9c2f7$var$__extends(CloudMLXClaim, _super);
    function CloudMLXClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CloudMLXClaim;
}($e9b3d0d8244ee15b$exports.ClaimWithIntegerUserId);
$59b1f98649a9c2f7$exports.CloudMLXClaim = $59b1f98649a9c2f7$var$CloudMLXClaim;


var $33937dc0cea5ab60$exports = {};
"use strict";
var $33937dc0cea5ab60$var$__extends = $33937dc0cea5ab60$exports && $33937dc0cea5ab60$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($33937dc0cea5ab60$exports, "__esModule", {
    value: true
});
$33937dc0cea5ab60$exports.CloudStreamsClaim = void 0;

var $33937dc0cea5ab60$var$CloudStreamsClaim = /** @class */ function(_super) {
    $33937dc0cea5ab60$var$__extends(CloudStreamsClaim, _super);
    function CloudStreamsClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CloudStreamsClaim;
}($e9b3d0d8244ee15b$exports.ClaimWithIntegerUserId);
$33937dc0cea5ab60$exports.CloudStreamsClaim = $33937dc0cea5ab60$var$CloudStreamsClaim;


var $a1ae322379438b3b$exports = {};
"use strict";
var $a1ae322379438b3b$var$__extends = $a1ae322379438b3b$exports && $a1ae322379438b3b$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
Object.defineProperty($a1ae322379438b3b$exports, "__esModule", {
    value: true
});
$a1ae322379438b3b$exports.TransactWorkflowClaim = void 0;

var $a1ae322379438b3b$var$TransactWorkflowClaim = /** @class */ function(_super) {
    $a1ae322379438b3b$var$__extends(TransactWorkflowClaim, _super);
    function TransactWorkflowClaim() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return TransactWorkflowClaim;
}($c28f4e0eecefe55b$exports.ClaimWithStringUserId);
$a1ae322379438b3b$exports.TransactWorkflowClaim = $a1ae322379438b3b$var$TransactWorkflowClaim;


var $7f1bf4f1cd4bb4e6$var$AppsClaim = /** @class */ function() {
    function AppsClaim() {}
    AppsClaim.prototype.populate = function(appsClaimObject) {
        this.as = this.createApplicationClaim($c8d313b0e38314f5$exports.AuthentisignClaim, appsClaimObject, "as");
        this.bo = this.createApplicationClaim($9abdc419272f044c$exports.BackOfficeClaim, appsClaimObject, "bo");
        this.bov = this.createApplicationClaim($101bb400fa0fcbb3$exports.BackOfficeV4Claim, appsClaimObject, "bov");
        this.cas = this.createApplicationClaim($0725a63358a022cb$exports.CloudAgentSuiteClaim, appsClaimObject, "cas");
        this.ca = this.createApplicationClaim($16da9b85397551a1$exports.CloudAttractClaim, appsClaimObject, "ca");
        this.cc = this.createApplicationClaim($84312dac2f9f92a9$exports.CloudCMAClaim, appsClaimObject, "cc");
        this.cm = this.createApplicationClaim($59b1f98649a9c2f7$exports.CloudMLXClaim, appsClaimObject, "cm");
        this.cs = this.createApplicationClaim($33937dc0cea5ab60$exports.CloudStreamsClaim, appsClaimObject, "cs");
        this.hsb = this.createApplicationClaim($1cd8c2f529c7c082$exports.HomeSpotterBoostClaim, appsClaimObject, "hsb");
        this.hsc = this.createApplicationClaim($0e764ce704e92364$exports.HomeSpotterConnectClaim, appsClaimObject, "hsc");
        this.hss = this.createApplicationClaim($b20b9539dd742c37$exports.HomeSpotterSpacioClaim, appsClaimObject, "hss");
        this.ld = this.createApplicationClaim($ab5916d34083b59b$exports.LionDeskClaim, appsClaimObject, "ld");
        this.pbb = this.createApplicationClaim($314a928ad41254d0$exports.PropertybaseBackOfficeClaim, appsClaimObject, "pbb");
        this.pbl = this.createApplicationClaim($9dc461c945dd7f36$exports.PropertybaseBoldLeadsClaim, appsClaimObject, "pbl");
        this.pbg = this.createApplicationClaim($0bda6999d61522e8$exports.PropertybaseGoClaim, appsClaimObject, "pbg");
        this.sf = this.createApplicationClaim($beb86539c2da83bd$exports.SalesforceClaim, appsClaimObject, "sf");
        this.tra = this.createApplicationClaim($4f9b292513b9e853$exports.TerradatumAergoClaim, appsClaimObject, "tra");
        this.trr = this.createApplicationClaim($cb8b81ababfc35a4$exports.TerradatumAgentMetricsClaim, appsClaimObject, "trr");
        this.trl = this.createApplicationClaim($dc20fae16c1adfd9$exports.TerradatumListingHomeRunClaim, appsClaimObject, "trl");
        this.td = this.createApplicationClaim($fdf9774bc5a66564$exports.TransactionDeskClaim, appsClaimObject, "td");
        this.tw = this.createApplicationClaim($a1ae322379438b3b$exports.TransactWorkflowClaim, appsClaimObject, "tw");
        this.trv = this.createApplicationClaim($e97c5cf306b9a1ef$exports.TerradatumVScreenClaim, appsClaimObject, "trv");
        this.wc = this.createApplicationClaim($4fdd60b4eec46749$exports.WolfConnectClaim, appsClaimObject, "wc");
        this.xbm = this.createApplicationClaim($4e8bd5508bc2f5e7$exports.XBrokerMetricsClaim, appsClaimObject, "xbm");
        this.zfp = this.createApplicationClaim($549cc20d663e8194$exports.ZipFormPlusClaim, appsClaimObject, "zfp");
    };
    AppsClaim.prototype.createApplicationClaim = function(claimType, appsClaimObject, claimPropertyName) {
        var claimObject;
        if (appsClaimObject[claimPropertyName]) {
            claimObject = new claimType();
            Object.assign(claimObject, appsClaimObject[claimPropertyName]);
        }
        return claimObject;
    };
    AppsClaim.prototype.getAuthentisignClaim = function() {
        return this.as;
    };
    AppsClaim.prototype.getBackOfficeClaim = function() {
        return this.bo;
    };
    AppsClaim.prototype.getBackOfficeV4Claim = function() {
        return this.bov;
    };
    AppsClaim.prototype.getCloudAgentSuiteClaim = function() {
        return this.cas;
    };
    AppsClaim.prototype.getCloudAttractClaim = function() {
        return this.ca;
    };
    AppsClaim.prototype.getCloudCMAClaim = function() {
        return this.cc;
    };
    AppsClaim.prototype.getCloudMLXClaim = function() {
        return this.cm;
    };
    AppsClaim.prototype.getCloudStreamsClaim = function() {
        return this.cs;
    };
    AppsClaim.prototype.getHomeSpotterBoostClaim = function() {
        return this.hsb;
    };
    AppsClaim.prototype.getHomeSpotterConnectClaim = function() {
        return this.hsc;
    };
    AppsClaim.prototype.getHomeSpotterSpacioClaim = function() {
        return this.hss;
    };
    AppsClaim.prototype.getLionDeskClaim = function() {
        return this.ld;
    };
    AppsClaim.prototype.getPropertybaseBackOfficeClaim = function() {
        return this.pbb;
    };
    AppsClaim.prototype.getPropertybaseBoldLeadsClaim = function() {
        return this.pbl;
    };
    AppsClaim.prototype.getPropertybaseGoClaim = function() {
        return this.pbg;
    };
    AppsClaim.prototype.getSalesforceClaim = function() {
        return this.sf;
    };
    AppsClaim.prototype.getTerradatumAergoClaim = function() {
        return this.tra;
    };
    AppsClaim.prototype.getTerradatumAgentMetricsClaim = function() {
        return this.trr;
    };
    AppsClaim.prototype.getTerradatumListingHomeRunClaim = function() {
        return this.trl;
    };
    AppsClaim.prototype.getTerradatumVScreenClaim = function() {
        return this.trv;
    };
    AppsClaim.prototype.getTransactionDeskClaim = function() {
        return this.td;
    };
    AppsClaim.prototype.getTransactWorkflowClaim = function() {
        return this.tw;
    };
    AppsClaim.prototype.getWolfConnectClaim = function() {
        return this.wc;
    };
    AppsClaim.prototype.getXBrokerMetricsClaim = function() {
        return this.xbm;
    };
    AppsClaim.prototype.getZipFormPlusClaim = function() {
        return this.zfp;
    };
    return AppsClaim;
}();
$7f1bf4f1cd4bb4e6$exports.AppsClaim = $7f1bf4f1cd4bb4e6$var$AppsClaim;


var $8ad8547c84d4f30c$exports = {};
"use strict";
Object.defineProperty($8ad8547c84d4f30c$exports, "__esModule", {
    value: true
});
$8ad8547c84d4f30c$exports.IdentityProvidersClaim = void 0;
var $8e35fcc5b4972e8b$exports = {};
"use strict";
Object.defineProperty($8e35fcc5b4972e8b$exports, "__esModule", {
    value: true
});
$8e35fcc5b4972e8b$exports.IdentityProviderClaim = void 0;
var $8e35fcc5b4972e8b$var$IdentityProviderClaim = /** @class */ function() {
    function IdentityProviderClaim() {}
    IdentityProviderClaim.prototype.getIssuedAtTime = function() {
        return this.iat;
    };
    IdentityProviderClaim.prototype.getExpirationTime = function() {
        return this.exp;
    };
    return IdentityProviderClaim;
}();
$8e35fcc5b4972e8b$exports.IdentityProviderClaim = $8e35fcc5b4972e8b$var$IdentityProviderClaim;


var $8ad8547c84d4f30c$var$IdentityProvidersClaim = /** @class */ function() {
    function IdentityProvidersClaim() {}
    IdentityProvidersClaim.prototype.populate = function(idpsClaimObject) {
        var _this = this;
        Object.keys(idpsClaimObject).forEach(function(idp) {
            _this[idp] = new $8e35fcc5b4972e8b$exports.IdentityProviderClaim();
            Object.assign(_this[idp], idpsClaimObject[idp]);
        });
    };
    IdentityProvidersClaim.prototype.get = function(idp) {
        return this[idp];
    };
    return IdentityProvidersClaim;
}();
$8ad8547c84d4f30c$exports.IdentityProvidersClaim = $8ad8547c84d4f30c$var$IdentityProvidersClaim;


var $882b6114857818e3$exports = {};
"use strict";
Object.defineProperty($882b6114857818e3$exports, "__esModule", {
    value: true
});
$882b6114857818e3$exports.ClientClaim = void 0;
var $e53d43b14cc862be$exports = {};
"use strict";
Object.defineProperty($e53d43b14cc862be$exports, "__esModule", {
    value: true
});
$e53d43b14cc862be$exports.ApplicationsClaim = void 0;
var $e53d43b14cc862be$var$ApplicationsClaim = /** @class */ function() {
    function ApplicationsClaim() {}
    ApplicationsClaim.prototype.populate = function(pfmAppsClaimObject) {
        var _this = this;
        Object.keys(pfmAppsClaimObject).forEach(function(code) {
            _this[code] = pfmAppsClaimObject[code];
        });
    };
    ApplicationsClaim.prototype.getCodes = function() {
        return Object.keys(this);
    };
    ApplicationsClaim.prototype.getModuleCodes = function(code) {
        return this[code];
    };
    return ApplicationsClaim;
}();
$e53d43b14cc862be$exports.ApplicationsClaim = $e53d43b14cc862be$var$ApplicationsClaim;


var $236bc877f36c1c4f$exports = {};
"use strict";
Object.defineProperty($236bc877f36c1c4f$exports, "__esModule", {
    value: true
});
$236bc877f36c1c4f$exports.ExternalSystemsClaim = void 0;
var $da4ed44c2a312577$exports = {};
"use strict";
Object.defineProperty($da4ed44c2a312577$exports, "__esModule", {
    value: true
});
$da4ed44c2a312577$exports.ExternalSystemClaim = void 0;
var $da4ed44c2a312577$var$ExternalSystemClaim = /** @class */ function() {
    function ExternalSystemClaim() {}
    ExternalSystemClaim.prototype.getNumber = function() {
        return this.num;
    };
    return ExternalSystemClaim;
}();
$da4ed44c2a312577$exports.ExternalSystemClaim = $da4ed44c2a312577$var$ExternalSystemClaim;


var $236bc877f36c1c4f$var$ExternalSystemsClaim = /** @class */ function() {
    function ExternalSystemsClaim() {}
    ExternalSystemsClaim.prototype.populate = function(pfmExtClaimObject) {
        var _this = this;
        Object.keys(pfmExtClaimObject).forEach(function(code) {
            _this[code] = new $da4ed44c2a312577$exports.ExternalSystemClaim();
            Object.assign(_this[code], pfmExtClaimObject[code]);
        });
    };
    ExternalSystemsClaim.prototype.getCodes = function() {
        return Object.keys(this);
    };
    ExternalSystemsClaim.prototype.getExternalSystem = function(code) {
        return this[code];
    };
    return ExternalSystemsClaim;
}();
$236bc877f36c1c4f$exports.ExternalSystemsClaim = $236bc877f36c1c4f$var$ExternalSystemsClaim;


var $882b6114857818e3$var$ClientClaim = /** @class */ function() {
    function ClientClaim() {}
    ClientClaim.prototype.populate = function(platformClientObject) {
        if (platformClientObject.apps) {
            this.apps = new $e53d43b14cc862be$exports.ApplicationsClaim();
            this.apps.populate(platformClientObject.apps);
            delete platformClientObject.apps;
        }
        if (platformClientObject.ext) {
            this.ext = new $236bc877f36c1c4f$exports.ExternalSystemsClaim();
            this.ext.populate(platformClientObject.ext);
            delete platformClientObject.ext;
        }
        Object.assign(this, platformClientObject);
    };
    ClientClaim.prototype.getId = function() {
        return this.cid;
    };
    ClientClaim.prototype.getType = function() {
        return this.ctp;
    };
    ClientClaim.prototype.getRoleId = function() {
        return this.rid;
    };
    ClientClaim.prototype.getOfficeId = function() {
        return this.oid;
    };
    ClientClaim.prototype.getBrokerageId = function() {
        return this.bid;
    };
    ClientClaim.prototype.getUserId = function() {
        return this.uid;
    };
    ClientClaim.prototype.getApplications = function() {
        return this.apps;
    };
    ClientClaim.prototype.getExternalSystems = function() {
        return this.ext;
    };
    ClientClaim.prototype.isUserClient = function() {
        return this.ctp === ClientClaim.CLIENT_TYPE_USER;
    };
    ClientClaim.CLIENT_TYPE_USER = "User";
    return ClientClaim;
}();
$882b6114857818e3$exports.ClientClaim = $882b6114857818e3$var$ClientClaim;


var $3020f80ccc48a51b$exports = {};
"use strict";
Object.defineProperty($3020f80ccc48a51b$exports, "__esModule", {
    value: true
});
$3020f80ccc48a51b$exports.ActClaim = void 0;
var $3020f80ccc48a51b$var$ActClaim = /** @class */ function() {
    function ActClaim() {}
    ActClaim.prototype.populate = function(actClaimObject) {
        Object.assign(this, actClaimObject);
    };
    ActClaim.prototype.getUserId = function() {
        return this.uid;
    };
    ActClaim.prototype.getName = function() {
        return this.name;
    };
    ActClaim.prototype.getEmail = function() {
        return this.email;
    };
    return ActClaim;
}();
$3020f80ccc48a51b$exports.ActClaim = $3020f80ccc48a51b$var$ActClaim;


var $3ada592c5c2caf10$var$LwtUserType;
(function(LwtUserType) {
    LwtUserType["INTERNAL"] = "I";
    LwtUserType["CLIENT"] = "C";
    LwtUserType["APP"] = "A";
    LwtUserType["SERVICE"] = "S";
})($3ada592c5c2caf10$var$LwtUserType || ($3ada592c5c2caf10$var$LwtUserType = {}));
var $3ada592c5c2caf10$var$LwtClaim = /** @class */ function() {
    function LwtClaim() {
        this.utp = $3ada592c5c2caf10$var$LwtUserType.CLIENT;
        this.pfmAuth = false;
        this.lng = "en-US";
    }
    LwtClaim.prototype.populate = function(lwtClaimObject) {
        var _this = this;
        if (lwtClaimObject.pfm) {
            this.pfm = [];
            lwtClaimObject.pfm.forEach(function(pfmClient) {
                var _a;
                var platformClient = new $882b6114857818e3$exports.ClientClaim();
                platformClient.populate(pfmClient);
                (_a = _this.pfm) === null || _a === void 0 || _a.push(platformClient);
            });
            delete lwtClaimObject.pfm;
        }
        if (lwtClaimObject.apps) {
            this.apps = new $7f1bf4f1cd4bb4e6$exports.AppsClaim();
            this.apps.populate(lwtClaimObject.apps);
            delete lwtClaimObject.apps;
        }
        if (lwtClaimObject.idps) {
            this.idps = new $8ad8547c84d4f30c$exports.IdentityProvidersClaim();
            this.idps.populate(lwtClaimObject.idps);
            delete lwtClaimObject.idps;
        }
        if (lwtClaimObject.act) {
            this.act = new $3020f80ccc48a51b$exports.ActClaim();
            this.act.populate(lwtClaimObject.act);
            delete lwtClaimObject.act;
        }
        Object.assign(this, lwtClaimObject);
    };
    LwtClaim.prototype.isInternalToken = function() {
        return this.utp === $3ada592c5c2caf10$var$LwtUserType.INTERNAL;
    };
    LwtClaim.prototype.isClientToken = function() {
        return this.utp === $3ada592c5c2caf10$var$LwtUserType.CLIENT;
    };
    LwtClaim.prototype.isAppToken = function() {
        return this.utp === $3ada592c5c2caf10$var$LwtUserType.APP;
    };
    LwtClaim.prototype.isServiceToken = function() {
        return this.utp === $3ada592c5c2caf10$var$LwtUserType.SERVICE;
    };
    LwtClaim.prototype.getUserId = function() {
        return this.uid;
    };
    LwtClaim.prototype.getUserType = function() {
        return this.utp;
    };
    LwtClaim.prototype.getSessionId = function() {
        return this.sid;
    };
    LwtClaim.prototype.getGroups = function() {
        return this.groups;
    };
    LwtClaim.prototype.getClients = function() {
        return this.pfm;
    };
    LwtClaim.prototype.getAppsClaim = function() {
        return this.apps;
    };
    LwtClaim.prototype.getIdentityProvidersClaim = function() {
        return this.idps;
    };
    LwtClaim.prototype.getActClaim = function() {
        return this.act;
    };
    LwtClaim.prototype.getPersonalClient = function() {
        var _a;
        return (_a = this.pfm) === null || _a === void 0 ? void 0 : _a.find(function(client) {
            return client.getType() === "User";
        });
    };
    LwtClaim.prototype.getPfmAuth = function() {
        return this.pfmAuth;
    };
    LwtClaim.prototype.getLanguageCode = function() {
        return this.lng;
    };
    return LwtClaim;
}();
$3ada592c5c2caf10$exports.LwtClaim = $3ada592c5c2caf10$var$LwtClaim;


var $a0f1a624334da46f$var$JwtPayload = /** @class */ function() {
    function JwtPayload() {}
    JwtPayload.prototype.populate = function(parsedClaims) {
        if (parsedClaims["http://lwt"]) {
            this.lwt = new $3ada592c5c2caf10$exports.LwtClaim();
            this.lwt.populate(parsedClaims["http://lwt"]);
            delete parsedClaims["http://lwt"];
        }
        Object.assign(this, parsedClaims);
    };
    JwtPayload.prototype.getIssuer = function() {
        return this.iss;
    };
    JwtPayload.prototype.getSubject = function() {
        return this.sub;
    };
    JwtPayload.prototype.getAudience = function() {
        return this.aud;
    };
    JwtPayload.prototype.getFirstName = function() {
        return this.given_name;
    };
    JwtPayload.prototype.getLastName = function() {
        return this.family_name;
    };
    JwtPayload.prototype.getNickname = function() {
        return this.nickname;
    };
    JwtPayload.prototype.getName = function() {
        return this.name;
    };
    JwtPayload.prototype.getEmail = function() {
        return this.email;
    };
    JwtPayload.prototype.getIssuedAtTime = function() {
        return this.iat;
    };
    JwtPayload.prototype.getExpirationTime = function() {
        return this.exp;
    };
    JwtPayload.prototype.getPicture = function() {
        return this.picture;
    };
    JwtPayload.prototype.getLwtClaim = function() {
        return this.lwt;
    };
    JwtPayload.prototype.getEmailVerified = function() {
        return this.email_verified;
    };
    JwtPayload.prototype.getZoneInfo = function() {
        return this.zoneinfo;
    };
    JwtPayload.prototype.isImpersonationToken = function() {
        var _a;
        var actClaim = (_a = this.lwt) === null || _a === void 0 ? void 0 : _a.getActClaim();
        return !!actClaim && !!actClaim.getUserId();
    };
    return JwtPayload;
}();
$a0f1a624334da46f$exports.JwtPayload = $a0f1a624334da46f$var$JwtPayload;


var $ea13dab1c811432a$var$Authentication = /** @class */ function() {
    function Authentication() {
        this.parseToken = function(token) {
            var _a, _b;
            var jwtPayload;
            var base64 = (_b = (_a = token === null || token === void 0 ? void 0 : token.split(".")[1]) === null || _a === void 0 ? void 0 : _a.replace(/-/g, "+")) === null || _b === void 0 ? void 0 : _b.replace(/_/g, "/");
            if (base64) {
                var parsedClaims = JSON.parse($6ZWSX.Buffer.from(base64, "base64").toString());
                jwtPayload = new $a0f1a624334da46f$exports.JwtPayload();
                jwtPayload.populate(parsedClaims);
            }
            return jwtPayload;
        };
    }
    return Authentication;
}();
$ea13dab1c811432a$exports.default = new $ea13dab1c811432a$var$Authentication();


const $c4b052ef371b1621$var$apiDomains = {
    dev: "https://platform.api.dev.lwolf.com",
    stg: "https://platform.api.stg.lwolf.com",
    pre: "https://platform.api.pre.lwolf.com",
    prod: "https://platform.api.lwolf.com"
};
const $c4b052ef371b1621$export$2e2bcd8739ae039 = ({ gtmContainerId: // GTM-TW6R356J for when you want to publish to the dev environment
gtmContainerId = "GTM-TW6R356J", applicationCode: applicationCode = "", environment: environment = "dev", localStorageTokenKey: localStorageTokenKey = "lwaToken", userToken: // eslint-disable-next-line max-len
userToken = "", activeClientId: activeClientId = "" })=>{
    var _a, _b, _c, _d;
    const [dataLayerCreated, setDataLayerCreated] = (0, $acw62.useState)(false);
    const [dataLayer, setDataLayer] = (0, $acw62.useState)({
        application: {
            code: applicationCode
        }
    });
    // create a random dataLayer name
    const dataLayerName = (0, $acw62.useMemo)(()=>`dataLayer_${Math.random().toString(36).substring(7)}`, []);
    // New format: lwaToken_{env.}lwolf.com
    const newTokenCookieName = environment === "prod" ? "lwaToken_lwolf.com" : `lwaToken_${environment}.lwolf.com`;
    // Fallback format: lwaToken@@{env.}lwolf.com
    const fallbackTokenCookieName = environment === "prod" ? "lwaToken@@lwolf.com" : `lwaToken@@${environment}.lwolf.com`;
    const getTokenFromCookie = ()=>{
        if (!document || !document.cookie) return "";
        const cookies = document.cookie.split(";");
        // First try the new format
        const newFormatCookie = cookies.find((item)=>item.trim().startsWith(newTokenCookieName));
        if (newFormatCookie) return newFormatCookie.split("=")[1] || "";
        // Fall back to the old format
        const fallbackCookie = cookies.find((item)=>item.trim().startsWith(fallbackTokenCookieName));
        if (fallbackCookie) return fallbackCookie.split("=")[1] || "";
        return "";
    };
    const tokenCookie = getTokenFromCookie();
    const getUserToken = ()=>{
        // get the token from the local storage or the cookie or the userToken
        return typeof window !== "undefined" ? window.localStorage.getItem(localStorageTokenKey) || tokenCookie || userToken : "";
    };
    const token = getUserToken();
    const clients = token ? ((_b = (_a = (0, (/*@__PURE__*/$parcel$interopDefault($ea13dab1c811432a$exports))).parseToken(token)) === null || _a === void 0 ? void 0 : _a.getLwtClaim()) === null || _b === void 0 ? void 0 : _b.getClients()) || [] : [];
    const user = clients ? activeClientId ? clients.find((item)=>item.getId() === activeClientId) : clients.find((item)=>item.getType() === "User") : undefined;
    const userId = (user === null || user === void 0 ? void 0 : user.getUserId()) || ((_d = (_c = (0, (/*@__PURE__*/$parcel$interopDefault($ea13dab1c811432a$exports))).parseToken(token)) === null || _c === void 0 ? void 0 : _c.getLwtClaim()) === null || _d === void 0 ? void 0 : _d.getUserId());
    const mapData = (data)=>{
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        const clientAddress = ((_a = data === null || data === void 0 ? void 0 : data.client) === null || _a === void 0 ? void 0 : _a.clientAddresses[0]) || {};
        const mappedData = {
            account: {
                id: ((_c = (_b = (0, (/*@__PURE__*/$parcel$interopDefault($ea13dab1c811432a$exports))).parseToken(token)) === null || _b === void 0 ? void 0 : _b.getLwtClaim()) === null || _c === void 0 ? void 0 : _c.getUserId()) || "",
                name: ((_d = (0, (/*@__PURE__*/$parcel$interopDefault($ea13dab1c811432a$exports))).parseToken(token)) === null || _d === void 0 ? void 0 : _d.getFirstName()) + " " + ((_e = (0, (/*@__PURE__*/$parcel$interopDefault($ea13dab1c811432a$exports))).parseToken(token)) === null || _e === void 0 ? void 0 : _e.getLastName()),
                emailAddress: ((_f = (0, (/*@__PURE__*/$parcel$interopDefault($ea13dab1c811432a$exports))).parseToken(token)) === null || _f === void 0 ? void 0 : _f.getEmail()) || ""
            }
        };
        // Conditionally include the office information if it exists
        if (data.client) mappedData.client = {
            id: data.client.id || "",
            name: data.client.name || "",
            city: clientAddress.city || "",
            provinceCode: clientAddress.provinceCode || "",
            postalCode: clientAddress.postalCode || "",
            countryCode: clientAddress.countryCode || ""
        };
        mappedData.user = {
            id: data.id || "",
            clientId: data.clientId || "",
            brokerageId: data.brokerageId || "",
            officeId: data.officeId || "",
            name: `${data.firstName || ""} ${data.lastName || ""}`.trim(),
            emailAddress: data.emailAddress || "",
            role: {
                id: ((_g = data === null || data === void 0 ? void 0 : data.role) === null || _g === void 0 ? void 0 : _g.id) || "",
                name: ((_h = data === null || data === void 0 ? void 0 : data.role) === null || _h === void 0 ? void 0 : _h.name) || ""
            },
            products: (_j = data === null || data === void 0 ? void 0 : data.applications) === null || _j === void 0 ? void 0 : _j.map((app)=>({
                    id: app.id || "",
                    name: app.name || ""
                }))
        };
        if (data.office) mappedData.office = {
            id: data.office.id || "",
            clientId: data.office.clientId || "",
            brokerageId: data.office.brokerageId || "",
            name: data.office.name || "",
            city: data.office.city || "",
            provinceCode: data.office.provinceCode || "",
            postalCode: data.office.postalCode || "",
            countryCode: data.office.countryCode || ""
        };
        return mappedData;
    };
    const APIEndPoint = `${$c4b052ef371b1621$var$apiDomains[environment]}/v1/users/${userId}/summary`;
    const fetchData = ()=>(0, $026ca1316ca073a2$export$1050f835b63b671e)(void 0, void 0, void 0, function*() {
            var _e, _f, _g, _h, _j;
            if (!userId) {
                console.log("User Id not found, dataLayer must be sent with the setDataLayer function from the parent component");
                window[dataLayerName] = window[dataLayerName] || [];
                if (dataLayer && dataLayer.user && dataLayer.user.id) setDataLayerCreated(true);
                else return;
                setDataLayer({
                    application: Object.assign({}, dataLayer.application),
                    account: Object.assign({
                        id: ((_f = (_e = (0, (/*@__PURE__*/$parcel$interopDefault($ea13dab1c811432a$exports))).parseToken(token)) === null || _e === void 0 ? void 0 : _e.getLwtClaim()) === null || _f === void 0 ? void 0 : _f.getUserId()) || "",
                        name: ((_g = (0, (/*@__PURE__*/$parcel$interopDefault($ea13dab1c811432a$exports))).parseToken(token)) === null || _g === void 0 ? void 0 : _g.getFirstName()) + " " + ((_h = (0, (/*@__PURE__*/$parcel$interopDefault($ea13dab1c811432a$exports))).parseToken(token)) === null || _h === void 0 ? void 0 : _h.getLastName()),
                        emailAddress: ((_j = (0, (/*@__PURE__*/$parcel$interopDefault($ea13dab1c811432a$exports))).parseToken(token)) === null || _j === void 0 ? void 0 : _j.getEmail()) || ""
                    }, dataLayer.account),
                    user: Object.assign({}, dataLayer.user),
                    client: Object.assign({}, dataLayer.client),
                    office: Object.assign({}, dataLayer.office)
                });
                return;
            }
            if (!token) return console.log("Token not found");
            try {
                const response = yield fetch(APIEndPoint, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                const data = yield response.json();
                window[dataLayerName] = window[dataLayerName] || [];
                setDataLayerCreated(true);
                setDataLayer(Object.assign(Object.assign(Object.assign({}, mapData(data)), dataLayer), {
                    application: Object.assign({}, dataLayer.application),
                    account: Object.assign(Object.assign({}, mapData(data).account), dataLayer.account),
                    user: Object.assign(Object.assign({}, mapData(data).user), dataLayer.user),
                    client: Object.assign(Object.assign({}, mapData(data).client), dataLayer.client),
                    office: Object.assign(Object.assign({}, mapData(data).office), dataLayer.office)
                }));
            } catch (error) {
                console.error(error);
            }
        });
    (0, $acw62.useEffect)(()=>{
        if (dataLayerCreated) return;
        fetchData();
    }, [
        APIEndPoint,
        userId,
        token,
        dataLayer,
        dataLayerCreated,
        dataLayer
    ]);
    (0, $acw62.useEffect)(()=>{
        var _a, _b, _c, _d, _e, _f;
        if (!dataLayerCreated) return;
        if (!dataLayer) return;
        if (!dataLayerName) return;
        if (!token) return;
        // remove the old dataLayer push script
        const oldDataLayerPushScript = document.querySelector("script[data-layer-push]");
        if (oldDataLayerPushScript) document.head.removeChild(oldDataLayerPushScript);
        const dataLayerPushScript = document.createElement("script");
        dataLayerPushScript.setAttribute("data-layer-push", "");
        dataLayerPushScript.innerHTML = `window.${dataLayerName}.push(${JSON.stringify(dataLayer)});`;
        // only add if valid dataLayer
        document.head.appendChild(dataLayerPushScript);
        // Push updated visitor/account data to Pendo if it has already initialized.
        // Field names match the GTM container's Pendo initialization mapping.
        const w = window;
        if ((_b = (_a = w.pendo) === null || _a === void 0 ? void 0 : _a.isReady) === null || _b === void 0 ? void 0 : _b.call(_a)) {
            // Separate known structural keys from any custom fields the caller added.
            // `visitor` is extracted and spread flat so { visitor: { full_name: '...' } }
            // becomes top-level visitor metadata in Pendo rather than a nested object.
            // Any other unknown top-level keys are also spread flat into the visitor.
            const { application: application, account: account, client: client, office: office, user: user, visitor: visitorOverrides } = dataLayer, otherExtraFields = (0, $026ca1316ca073a2$export$3c9a16f847548506)(dataLayer, [
                "application",
                "account",
                "client",
                "office",
                "user",
                "visitor"
            ]);
            w.pendo.identify({
                visitor: Object.assign(Object.assign({
                    id: (user === null || user === void 0 ? void 0 : user.id) || (account === null || account === void 0 ? void 0 : account.id),
                    name: account === null || account === void 0 ? void 0 : account.name,
                    email: account === null || account === void 0 ? void 0 : account.emailAddress,
                    role: (_c = user === null || user === void 0 ? void 0 : user.role) === null || _c === void 0 ? void 0 : _c.name,
                    applicationCode: application === null || application === void 0 ? void 0 : application.code,
                    user_id: user === null || user === void 0 ? void 0 : user.id,
                    user_name: user === null || user === void 0 ? void 0 : user.name,
                    user_role: (_d = user === null || user === void 0 ? void 0 : user.role) === null || _d === void 0 ? void 0 : _d.name,
                    user_roleID: (_e = user === null || user === void 0 ? void 0 : user.role) === null || _e === void 0 ? void 0 : _e.id,
                    user_emailAddress: user === null || user === void 0 ? void 0 : user.emailAddress,
                    user_clientId: user === null || user === void 0 ? void 0 : user.clientId,
                    user_brokerageId: user === null || user === void 0 ? void 0 : user.brokerageId,
                    user_officeId: user === null || user === void 0 ? void 0 : user.officeId,
                    user_products: user === null || user === void 0 ? void 0 : user.products
                }, (_f = visitorOverrides) !== null && _f !== void 0 ? _f : {}), otherExtraFields),
                account: {
                    id: (client === null || client === void 0 ? void 0 : client.id) || (account === null || account === void 0 ? void 0 : account.id),
                    name: client === null || client === void 0 ? void 0 : client.name
                }
            });
        }
    }, [
        dataLayer,
        token,
        dataLayerName,
        dataLayer
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!dataLayerCreated) return;
        if (!token) return;
        if (!dataLayerName) return;
        const tagMangerDataLayerScript = document.createElement("script");
        // create the dataLayer script tag
        tagMangerDataLayerScript.innerHTML = `window.${dataLayerName} = window.${dataLayerName}`;
        // add the dataLayer script tag after the head tag
        document.head.appendChild(tagMangerDataLayerScript);
        // add some sample data to the dataLayer
        const script = document.createElement("script");
        // add a type attribute to the script tag
        script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','${dataLayerName}','${gtmContainerId}');`;
        // add the GTM script after the head tag
        document.head.appendChild(script);
        // add the GTM noscript after the body tag
        const noscript = document.createElement("noscript");
        noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmContainerId}"
height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
        document.body.appendChild(noscript);
    }, [
        gtmContainerId,
        dataLayerCreated,
        token,
        dataLayerName
    ]);
    return {
        dataLayer: dataLayer,
        setDataLayer: setDataLayer
    };
};


var $bea0f3bed29b3a68$exports = {};
"use strict";
var $bea0f3bed29b3a68$var$__importDefault = $bea0f3bed29b3a68$exports && $bea0f3bed29b3a68$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($bea0f3bed29b3a68$exports, "__esModule", {
    value: true
});
$bea0f3bed29b3a68$exports.useWindowWidth = void 0;
var $ba6090674ed11eae$exports = {};
"use strict";
Object.defineProperty($ba6090674ed11eae$exports, "__esModule", {
    value: true
});

var $acw62 = parcelRequire("acw62");
const $ba6090674ed11eae$var$useWindowWidth = ()=>{
    const [windowWidth, setWidowWidth] = (0, $acw62.useState)(0);
    const handleResize = (e)=>{
        setWidowWidth(e.srcElement.innerWidth);
    };
    (0, $acw62.useEffect)(()=>{
        window.addEventListener("resize", handleResize);
        setWidowWidth(window.innerWidth);
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    return {
        windowWidth: windowWidth
    };
};
$ba6090674ed11eae$exports.default = $ba6090674ed11eae$var$useWindowWidth;


Object.defineProperty($bea0f3bed29b3a68$exports, "useWindowWidth", {
    enumerable: true,
    get: function() {
        return $bea0f3bed29b3a68$var$__importDefault($ba6090674ed11eae$exports).default;
    }
});



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");




var $acw62 = parcelRequire("acw62");
const $e7307bc387b4b3a0$var$LanguageContext = (0, $acw62.createContext)(undefined);
const $e7307bc387b4b3a0$export$658731b8fe4aaf5e = ({ initialLanguage: initialLanguage = "en", language: controlledLanguage, onLanguageChange: onLanguageChange, children: children })=>{
    const [internalLanguage, setInternalLanguage] = (0, $acw62.useState)(initialLanguage);
    const isControlled = controlledLanguage !== undefined;
    const language = isControlled ? controlledLanguage : internalLanguage;
    const setLanguage = (lang)=>{
        if (isControlled) onLanguageChange === null || onLanguageChange === void 0 || onLanguageChange(lang);
        else setInternalLanguage(lang);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e7307bc387b4b3a0$var$LanguageContext.Provider, {
        value: {
            language: language,
            setLanguage: setLanguage
        }
    }, children);
};
const $e7307bc387b4b3a0$export$c1fd9f444a3dc711 = ()=>{
    const ctx = (0, $acw62.useContext)($e7307bc387b4b3a0$var$LanguageContext);
    if (!ctx) throw new Error("useLanguage must be used within a LanguageProvider");
    return ctx;
};



/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a3b111119000092b$export$de79e2c695e052f3(element) {
    if ($a3b111119000092b$var$$7215afc6de606d6b$var$supportsPreventScroll()) element.focus({
        preventScroll: true
    });
    else {
        let scrollableElements = $a3b111119000092b$var$$7215afc6de606d6b$var$getScrollableElements(element);
        element.focus();
        $a3b111119000092b$var$$7215afc6de606d6b$var$restoreScrollPosition(scrollableElements);
    }
}
let $a3b111119000092b$var$$7215afc6de606d6b$var$supportsPreventScrollCached = null;
function $a3b111119000092b$var$$7215afc6de606d6b$var$supportsPreventScroll() {
    if ($a3b111119000092b$var$$7215afc6de606d6b$var$supportsPreventScrollCached == null) {
        $a3b111119000092b$var$$7215afc6de606d6b$var$supportsPreventScrollCached = false;
        try {
            let focusElem = document.createElement("div");
            focusElem.focus({
                get preventScroll () {
                    $a3b111119000092b$var$$7215afc6de606d6b$var$supportsPreventScrollCached = true;
                    return true;
                }
            });
        } catch (e) {
        // Ignore
        }
    }
    return $a3b111119000092b$var$$7215afc6de606d6b$var$supportsPreventScrollCached;
}
function $a3b111119000092b$var$$7215afc6de606d6b$var$getScrollableElements(element) {
    let parent = element.parentNode;
    let scrollableElements = [];
    let rootScrollingElement = document.scrollingElement || document.documentElement;
    while(parent instanceof HTMLElement && parent !== rootScrollingElement){
        if (parent.offsetHeight < parent.scrollHeight || parent.offsetWidth < parent.scrollWidth) scrollableElements.push({
            element: parent,
            scrollTop: parent.scrollTop,
            scrollLeft: parent.scrollLeft
        });
        parent = parent.parentNode;
    }
    if (rootScrollingElement instanceof HTMLElement) scrollableElements.push({
        element: rootScrollingElement,
        scrollTop: rootScrollingElement.scrollTop,
        scrollLeft: rootScrollingElement.scrollLeft
    });
    return scrollableElements;
}
function $a3b111119000092b$var$$7215afc6de606d6b$var$restoreScrollPosition(scrollableElements) {
    for (let { element: element, scrollTop: scrollTop, scrollLeft: scrollLeft } of scrollableElements){
        element.scrollTop = scrollTop;
        element.scrollLeft = scrollLeft;
    }
}

const $eef56d26e56a84a0$export$b204af158042fbac = (el)=>{
    var _el_ownerDocument;
    return (_el_ownerDocument = el === null || el === void 0 ? void 0 : el.ownerDocument) !== null && _el_ownerDocument !== void 0 ? _el_ownerDocument : document;
};
const $eef56d26e56a84a0$export$f21a1ffae260145a = (el)=>{
    if (el && "window" in el && el.window === el) return el;
    const doc = $eef56d26e56a84a0$export$b204af158042fbac(el);
    return doc.defaultView || window;
};

/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We store a global list of elements that are currently transitioning,
// mapped to a set of CSS properties that are transitioning for that element.
// This is necessary rather than a simple count of transitions because of browser
// bugs, e.g. Chrome sometimes fires both transitionend and transitioncancel rather
// than one or the other. So we need to track what's actually transitioning so that
// we can ignore these duplicate events.
let $f7303ee4180eaa13$var$$bbed8b41f857bcc0$var$transitionsByElement = new Map();
// A list of callbacks to call once there are no transitioning elements.
let $f7303ee4180eaa13$var$$bbed8b41f857bcc0$var$transitionCallbacks = new Set();
function $f7303ee4180eaa13$var$$bbed8b41f857bcc0$var$setupGlobalEvents() {
    if (typeof window === "undefined") return;
    function isTransitionEvent(event) {
        return "propertyName" in event;
    }
    let onTransitionStart = (e)=>{
        if (!isTransitionEvent(e) || !e.target) return;
        // Add the transitioning property to the list for this element.
        let transitions = $f7303ee4180eaa13$var$$bbed8b41f857bcc0$var$transitionsByElement.get(e.target);
        if (!transitions) {
            transitions = new Set();
            $f7303ee4180eaa13$var$$bbed8b41f857bcc0$var$transitionsByElement.set(e.target, transitions);
            // The transitioncancel event must be registered on the element itself, rather than as a global
            // event. This enables us to handle when the node is deleted from the document while it is transitioning.
            // In that case, the cancel event would have nowhere to bubble to so we need to handle it directly.
            e.target.addEventListener("transitioncancel", onTransitionEnd, {
                once: true
            });
        }
        transitions.add(e.propertyName);
    };
    let onTransitionEnd = (e)=>{
        if (!isTransitionEvent(e) || !e.target) return;
        // Remove property from list of transitioning properties.
        let properties = $f7303ee4180eaa13$var$$bbed8b41f857bcc0$var$transitionsByElement.get(e.target);
        if (!properties) return;
        properties.delete(e.propertyName);
        // If empty, remove transitioncancel event, and remove the element from the list of transitioning elements.
        if (properties.size === 0) {
            e.target.removeEventListener("transitioncancel", onTransitionEnd);
            $f7303ee4180eaa13$var$$bbed8b41f857bcc0$var$transitionsByElement.delete(e.target);
        }
        // If no transitioning elements, call all of the queued callbacks.
        if ($f7303ee4180eaa13$var$$bbed8b41f857bcc0$var$transitionsByElement.size === 0) {
            for (let cb of $f7303ee4180eaa13$var$$bbed8b41f857bcc0$var$transitionCallbacks)cb();
            $f7303ee4180eaa13$var$$bbed8b41f857bcc0$var$transitionCallbacks.clear();
        }
    };
    document.body.addEventListener("transitionrun", onTransitionStart);
    document.body.addEventListener("transitionend", onTransitionEnd);
}
if (typeof document !== "undefined") {
    if (document.readyState !== "loading") $f7303ee4180eaa13$var$$bbed8b41f857bcc0$var$setupGlobalEvents();
    else document.addEventListener("DOMContentLoaded", $f7303ee4180eaa13$var$$bbed8b41f857bcc0$var$setupGlobalEvents);
}
function $f7303ee4180eaa13$export$24490316f764c430(fn) {
    // Wait one frame to see if an animation starts, e.g. a transition on mount.
    requestAnimationFrame(()=>{
        // If no transitions are running, call the function immediately.
        // Otherwise, add it to a list of callbacks to run at the end of the animation.
        if ($f7303ee4180eaa13$var$$bbed8b41f857bcc0$var$transitionsByElement.size === 0) fn();
        else $f7303ee4180eaa13$var$$bbed8b41f857bcc0$var$transitionCallbacks.add(fn);
    });
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $b82880ba168cba95$var$$c87311424ea30a05$var$testUserAgent(re) {
    var _window_navigator_userAgentData;
    if (typeof window === "undefined" || window.navigator == null) return false;
    return ((_window_navigator_userAgentData = window.navigator["userAgentData"]) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.brands.some((brand)=>re.test(brand.brand))) || re.test(window.navigator.userAgent);
}
function $b82880ba168cba95$var$$c87311424ea30a05$var$testPlatform(re) {
    var _window_navigator_userAgentData;
    return typeof window !== "undefined" && window.navigator != null ? re.test(((_window_navigator_userAgentData = window.navigator["userAgentData"]) === null || _window_navigator_userAgentData === void 0 ? void 0 : _window_navigator_userAgentData.platform) || window.navigator.platform) : false;
}
function $b82880ba168cba95$export$9ac100e40613ea10() {
    return $b82880ba168cba95$var$$c87311424ea30a05$var$testPlatform(/^Mac/i);
}
function $b82880ba168cba95$export$186c6964ca17d99() {
    return $b82880ba168cba95$var$$c87311424ea30a05$var$testPlatform(/^iPhone/i);
}
function $b82880ba168cba95$export$7bef049ce92e4224() {
    return $b82880ba168cba95$var$$c87311424ea30a05$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $b82880ba168cba95$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
}
function $b82880ba168cba95$export$fedb369cb70207f1() {
    return $b82880ba168cba95$export$186c6964ca17d99() || $b82880ba168cba95$export$7bef049ce92e4224();
}
function $b82880ba168cba95$export$e1865c3bedcd822b() {
    return $b82880ba168cba95$export$9ac100e40613ea10() || $b82880ba168cba95$export$fedb369cb70207f1();
}
function $b82880ba168cba95$export$78551043582a6a98() {
    return $b82880ba168cba95$var$$c87311424ea30a05$var$testUserAgent(/AppleWebKit/i) && !$b82880ba168cba95$export$6446a186d09e379e();
}
function $b82880ba168cba95$export$6446a186d09e379e() {
    return $b82880ba168cba95$var$$c87311424ea30a05$var$testUserAgent(/Chrome/i);
}
function $b82880ba168cba95$export$a11b0059900ceec8() {
    return $b82880ba168cba95$var$$c87311424ea30a05$var$testUserAgent(/Android/i);
}
function $b82880ba168cba95$export$b7d78993b74f766d() {
    return $b82880ba168cba95$var$$c87311424ea30a05$var$testUserAgent(/Firefox/i);
}


/*
 * Copyright 2022 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $a192045deeaea2b6$export$60278871457622de(event) {
    // JAWS/NVDA with Firefox.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    // Android TalkBack's detail value varies depending on the event listener providing the event so we have specific logic here instead
    // If pointerType is defined, event is from a click listener. For events from mousedown listener, detail === 0 is a sufficient check
    // to detect TalkBack virtual clicks.
    if ((0, $b82880ba168cba95$export$a11b0059900ceec8)() && event.pointerType) return event.type === "click" && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $a192045deeaea2b6$export$29bf1b5f2c56cf63(event) {
    // If the pointer size is zero, then we assume it's from a screen reader.
    // Android TalkBack double tap will sometimes return a event with width and height of 1
    // and pointerType === 'mouse' so we need to check for a specific combination of event attributes.
    // Cannot use "event.pressure === 0" as the sole check due to Safari pointer events always returning pressure === 0
    // instead of .5, see https://bugs.webkit.org/show_bug.cgi?id=206216. event.pointerType === 'mouse' is to distingush
    // Talkback double tap from Windows Firefox touch screen press
    return !(0, $b82880ba168cba95$export$a11b0059900ceec8)() && event.width === 0 && event.height === 0 || event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === "mouse";
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rulesdir/useLayoutEffectRule
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$SSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$defaultContext);
const $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$IsSSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(false);
// This is only used in React < 18.
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$LegacySSRProvider(props) {
    let cur = (0, $acw62.useContext)($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$SSRContext);
    let counter = $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useCounter(cur === $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$defaultContext);
    let [isSSR, setIsSSR] = (0, $acw62.useState)(true);
    let value = (0, $acw62.useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$defaultContext ? "" : `${cur.prefix}-${counter}`,
            current: 0
        }), [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== "undefined") (0, $acw62.useLayoutEffect)(()=>{
        setIsSSR(false);
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$SSRContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
let $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$warnedAboutSSRProvider = false;
function $8afd3bdc2bd65163$export$9f8ac96af4b1b2ae(props) {
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useId"] === "function") {
        if (!$8afd3bdc2bd65163$var$$b5e257d569688ac6$var$warnedAboutSSRProvider) {
            console.warn("In React 18, SSRProvider is not necessary and is a noop. You can remove it from your app.");
            $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$warnedAboutSSRProvider = true;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, props.children);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$LegacySSRProvider, props);
}
let $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$canUseDOM = Boolean(typeof window !== "undefined" && window.document && window.document.createElement);
let $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$componentIds = new WeakMap();
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useCounter(isDisabled = false) {
    let ctx = (0, $acw62.useContext)($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$SSRContext);
    let ref = (0, $acw62.useRef)(null);
    // eslint-disable-next-line rulesdir/pure-render
    if (ref.current === null && !isDisabled) {
        var _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner, _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        // @ts-ignore
        let currentOwner = (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED === void 0 ? void 0 : (_React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner = _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner) === null || _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner === void 0 ? void 0 : _React___SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED_ReactCurrentOwner.current;
        if (currentOwner) {
            let prevComponentValue = $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                ctx.current = prevComponentValue.id;
                $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rulesdir/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rulesdir/pure-render
    return ref.current;
}
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useLegacySSRSafeId(defaultId) {
    let ctx = (0, $acw62.useContext)($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    if (ctx === $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$defaultContext && !$8afd3bdc2bd65163$var$$b5e257d569688ac6$var$canUseDOM) console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
    let counter = $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useCounter(!!defaultId);
    let prefix = `react-aria${ctx.prefix}`;
    return defaultId || `${prefix}-${counter}`;
}
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useModernSSRSafeId(defaultId) {
    // @ts-ignore
    let id = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useId();
    let [didSSR] = (0, $acw62.useState)($8afd3bdc2bd65163$export$535bd6ca7f90a273());
    let prefix = didSSR || false ? "react-aria" : `react-aria${$8afd3bdc2bd65163$var$$b5e257d569688ac6$var$defaultContext.prefix}`;
    return defaultId || `${prefix}-${id}`;
}
const $8afd3bdc2bd65163$export$619500959fc48b26 = typeof (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useId"] === "function" ? $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useModernSSRSafeId : $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$useLegacySSRSafeId;
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$getSnapshot() {
    return false;
}
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$subscribe(onStoreChange) {
    // noop
    return ()=>{};
}
function $8afd3bdc2bd65163$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useSyncExternalStore"] === "function") return (0, (/*@__PURE__*/$parcel$interopDefault($acw62)))["useSyncExternalStore"]($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$subscribe, $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$getSnapshot, $8afd3bdc2bd65163$var$$b5e257d569688ac6$var$getServerSnapshot);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $acw62.useContext)($8afd3bdc2bd65163$var$$b5e257d569688ac6$var$IsSSRContext);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from react.
// Original licensing for the following can be found in the
// NOTICE file in the root directory of this source tree.
// See https://github.com/facebook/react/tree/cc7c1aece46a6b69b41958d731e0fd27c94bfc6c/packages/react-interactions
let $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality = null;
let $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$changeHandlers = new Set();
let $b995f28c9a72ee4c$export$d90243b58daecda7 = new Map(); // We use a map here to support setting event listeners across multiple document objects.
let $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
let $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
// Only Tab or Esc keys will make focus visible on text input elements
const $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS = {
    Tab: true,
    Escape: true
};
function $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, e) {
    for (let handler of $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$changeHandlers)handler(modality, e);
}
/**
 * Helper function to determine if a KeyboardEvent is unmodified and could make keyboard focus styles visible.
 */ function $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$isValidKey(e) {
    // Control and Shift keys trigger when navigating back to the tab with keyboard.
    return !(e.metaKey || !(0, $b82880ba168cba95$export$9ac100e40613ea10)() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleKeyboardEvent(e) {
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
    if ($b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$isValidKey(e)) {
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality = "keyboard";
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$triggerChangeHandlers("keyboard", e);
    }
}
function $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent(e) {
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality = "pointer";
    if (e.type === "mousedown" || e.type === "pointerdown") {
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$triggerChangeHandlers("pointer", e);
    }
}
function $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleClickEvent(e) {
    if ((0, $a192045deeaea2b6$export$60278871457622de)(e)) {
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality = "virtual";
    }
}
function $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleFocusEvent(e) {
    // Firefox fires two extra focus events when the user first clicks into an iframe:
    // first on the window, then on the document. We ignore these events so they don't
    // cause keyboard focus rings to appear.
    if (e.target === window || e.target === document) return;
    // If a focus event occurs without a preceding keyboard or pointer event, switch to virtual modality.
    // This occurs, for example, when navigating a form with the next/previous buttons on iOS.
    if (!$b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus && !$b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently) {
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality = "virtual";
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$triggerChangeHandlers("virtual", e);
    }
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = false;
}
function $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleWindowBlur() {
    // When the window is blurred, reset state. This is necessary when tabbing out of the window,
    // for example, since a subsequent focus event won't be fired.
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = false;
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasBlurredWindowRecently = true;
}
/**
 * Setup global event listeners to control when keyboard focus style should be visible.
 */ function $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element) {
    if (typeof window === "undefined" || $b995f28c9a72ee4c$export$d90243b58daecda7.get((0, $eef56d26e56a84a0$export$f21a1ffae260145a)(element))) return;
    const windowObject = (0, $eef56d26e56a84a0$export$f21a1ffae260145a)(element);
    const documentObject = (0, $eef56d26e56a84a0$export$b204af158042fbac)(element);
    // Programmatic focus() calls shouldn't affect the current input modality.
    // However, we need to detect other cases when a focus event occurs without
    // a preceding user event (e.g. screen reader focus). Overriding the focus
    // method on HTMLElement.prototype is a bit hacky, but works.
    let focus = windowObject.HTMLElement.prototype.focus;
    windowObject.HTMLElement.prototype.focus = function() {
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$hasEventBeforeFocus = true;
        focus.apply(this, arguments);
    };
    documentObject.addEventListener("keydown", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("keyup", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.addEventListener("click", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    // Register focus events on the window so they are sure to happen
    // before React's event listeners (registered on the document).
    windowObject.addEventListener("focus", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.addEventListener("blur", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.addEventListener("pointerdown", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointermove", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("pointerup", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.addEventListener("mousedown", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mousemove", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.addEventListener("mouseup", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    // Add unmount handler
    windowObject.addEventListener("beforeunload", ()=>{
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element);
    }, {
        once: true
    });
    $b995f28c9a72ee4c$export$d90243b58daecda7.set(windowObject, {
        focus: focus
    });
}
const $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking = (element, loadListener)=>{
    const windowObject = (0, $eef56d26e56a84a0$export$f21a1ffae260145a)(element);
    const documentObject = (0, $eef56d26e56a84a0$export$b204af158042fbac)(element);
    if (loadListener) documentObject.removeEventListener("DOMContentLoaded", loadListener);
    if (!$b995f28c9a72ee4c$export$d90243b58daecda7.has(windowObject)) return;
    windowObject.HTMLElement.prototype.focus = $b995f28c9a72ee4c$export$d90243b58daecda7.get(windowObject).focus;
    documentObject.removeEventListener("keydown", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("keyup", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleKeyboardEvent, true);
    documentObject.removeEventListener("click", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleClickEvent, true);
    windowObject.removeEventListener("focus", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleFocusEvent, true);
    windowObject.removeEventListener("blur", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handleWindowBlur, false);
    if (typeof PointerEvent !== "undefined") {
        documentObject.removeEventListener("pointerdown", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointermove", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("pointerup", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    } else {
        documentObject.removeEventListener("mousedown", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mousemove", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
        documentObject.removeEventListener("mouseup", $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$handlePointerEvent, true);
    }
    $b995f28c9a72ee4c$export$d90243b58daecda7.delete(windowObject);
};
function $b995f28c9a72ee4c$export$2f1888112f558a7d(element) {
    const documentObject = (0, $eef56d26e56a84a0$export$b204af158042fbac)(element);
    let loadListener;
    if (documentObject.readyState !== "loading") $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
    else {
        loadListener = ()=>{
            $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents(element);
        };
        documentObject.addEventListener("DOMContentLoaded", loadListener);
    }
    return ()=>$b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$tearDownWindowFocusTracking(element, loadListener);
}
// Server-side rendering does not have the document object defined
// eslint-disable-next-line no-restricted-globals
if (typeof document !== "undefined") $b995f28c9a72ee4c$export$2f1888112f558a7d();
function $b995f28c9a72ee4c$export$b9b3dfddab17db27() {
    return $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality !== "pointer";
}
function $b995f28c9a72ee4c$export$630ff653c5ada6a9() {
    return $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality;
}
function $b995f28c9a72ee4c$export$8397ddfc504fdb9a(modality) {
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality = modality;
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$triggerChangeHandlers(modality, null);
}
function $b995f28c9a72ee4c$export$98e20ec92f614cfe() {
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    let [modality, setModality] = (0, $acw62.useState)($b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality);
    (0, $acw62.useEffect)(()=>{
        let handler = ()=>{
            setModality($b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$currentModality);
        };
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    }, []);
    return (0, $8afd3bdc2bd65163$export$535bd6ca7f90a273)() ? null : modality;
}
const $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$nonTextInputTypes = new Set([
    "checkbox",
    "radio",
    "range",
    "color",
    "file",
    "image",
    "button",
    "submit",
    "reset"
]);
/**
 * If this is attached to text input component, return if the event is a focus event (Tab/Escape keys pressed) so that
 * focus visible style can be properly set.
 */ function $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(isTextInput, modality, e) {
    var _e_target;
    const IHTMLInputElement = typeof window !== "undefined" ? (0, $eef56d26e56a84a0$export$f21a1ffae260145a)(e === null || e === void 0 ? void 0 : e.target).HTMLInputElement : HTMLInputElement;
    const IHTMLTextAreaElement = typeof window !== "undefined" ? (0, $eef56d26e56a84a0$export$f21a1ffae260145a)(e === null || e === void 0 ? void 0 : e.target).HTMLTextAreaElement : HTMLTextAreaElement;
    const IHTMLElement = typeof window !== "undefined" ? (0, $eef56d26e56a84a0$export$f21a1ffae260145a)(e === null || e === void 0 ? void 0 : e.target).HTMLElement : HTMLElement;
    const IKeyboardEvent = typeof window !== "undefined" ? (0, $eef56d26e56a84a0$export$f21a1ffae260145a)(e === null || e === void 0 ? void 0 : e.target).KeyboardEvent : KeyboardEvent;
    isTextInput = isTextInput || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLInputElement && !$b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$nonTextInputTypes.has(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.type) || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLTextAreaElement || (e === null || e === void 0 ? void 0 : e.target) instanceof IHTMLElement && (e === null || e === void 0 ? void 0 : e.target.isContentEditable);
    return !(isTextInput && modality === "keyboard" && e instanceof IKeyboardEvent && !$b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$FOCUS_VISIBLE_INPUT_KEYS[e.key]);
}
function $b995f28c9a72ee4c$export$ffd9e5021c1fb2d6(props = {}) {
    let { isTextInput: isTextInput, autoFocus: autoFocus } = props;
    let [isFocusVisibleState, setFocusVisible] = (0, $acw62.useState)(autoFocus || $b995f28c9a72ee4c$export$b9b3dfddab17db27());
    $b995f28c9a72ee4c$export$ec71b4b83ac08ec3((isFocusVisible)=>{
        setFocusVisible(isFocusVisible);
    }, [
        isTextInput
    ], {
        isTextInput: isTextInput
    });
    return {
        isFocusVisible: isFocusVisibleState
    };
}
function $b995f28c9a72ee4c$export$ec71b4b83ac08ec3(fn, deps, opts) {
    $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$setupGlobalFocusEvents();
    (0, $acw62.useEffect)(()=>{
        let handler = (modality, e)=>{
            if (!$b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$isKeyboardFocusEvent(!!(opts === null || opts === void 0 ? void 0 : opts.isTextInput), modality, e)) return;
            fn($b995f28c9a72ee4c$export$b9b3dfddab17db27());
        };
        $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$changeHandlers.add(handler);
        return ()=>{
            $b995f28c9a72ee4c$var$$507fabe10e71c6fb$var$changeHandlers.delete(handler);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
}


/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $b92af0002e176fee$export$80f3e147d781571c(element) {
    // If the user is interacting with a virtual cursor, e.g. screen reader, then
    // wait until after any animated transitions that are currently occurring on
    // the page before shifting focus. This avoids issues with VoiceOver on iOS
    // causing the page to scroll when moving focus if the element is transitioning
    // from off the screen.
    const ownerDocument = (0, $eef56d26e56a84a0$export$b204af158042fbac)(element);
    if ((0, $b995f28c9a72ee4c$export$630ff653c5ada6a9)() === "virtual") {
        let lastFocusedElement = ownerDocument.activeElement;
        (0, $f7303ee4180eaa13$export$24490316f764c430)(()=>{
            // If focus did not move and the element is still in the document, focus it.
            if (ownerDocument.activeElement === lastFocusedElement && element.isConnected) (0, $a3b111119000092b$export$de79e2c695e052f3)(element);
        });
    } else (0, $a3b111119000092b$export$de79e2c695e052f3)(element);
}



/*
 * Copyright 2021 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ function $94fbac57294f148e$var$$645f2e67b85a24c9$var$isStyleVisible(element) {
    const windowObject = (0, $eef56d26e56a84a0$export$f21a1ffae260145a)(element);
    if (!(element instanceof windowObject.HTMLElement) && !(element instanceof windowObject.SVGElement)) return false;
    let { display: display, visibility: visibility } = element.style;
    let isVisible = display !== "none" && visibility !== "hidden" && visibility !== "collapse";
    if (isVisible) {
        const { getComputedStyle: getComputedStyle } = element.ownerDocument.defaultView;
        let { display: computedDisplay, visibility: computedVisibility } = getComputedStyle(element);
        isVisible = computedDisplay !== "none" && computedVisibility !== "hidden" && computedVisibility !== "collapse";
    }
    return isVisible;
}
function $94fbac57294f148e$var$$645f2e67b85a24c9$var$isAttributeVisible(element, childElement) {
    return !element.hasAttribute("hidden") && // Ignore HiddenSelect when tree walking.
    !element.hasAttribute("data-react-aria-prevent-focus") && (element.nodeName === "DETAILS" && childElement && childElement.nodeName !== "SUMMARY" ? element.hasAttribute("open") : true);
}
function $94fbac57294f148e$export$e989c0fffaa6b27a(element, childElement) {
    return element.nodeName !== "#comment" && $94fbac57294f148e$var$$645f2e67b85a24c9$var$isStyleVisible(element) && $94fbac57294f148e$var$$645f2e67b85a24c9$var$isAttributeVisible(element, childElement) && (!element.parentElement || $94fbac57294f148e$export$e989c0fffaa6b27a(element.parentElement, element));
}



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $3581f530a27f457c$export$e5c5a5f917a5871c = typeof document !== "undefined" ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect : ()=>{};



var $acw62 = parcelRequire("acw62");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ const $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$FocusContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
let $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope = null;
function $b27e9acf8b86f3f1$export$20e40289641fbbb6(props) {
    let { children: children, contain: contain, restoreFocus: restoreFocus, autoFocus: autoFocus } = props;
    let startRef = (0, $acw62.useRef)(null);
    let endRef = (0, $acw62.useRef)(null);
    let scopeRef = (0, $acw62.useRef)([]);
    let { parentNode: parentNode } = (0, $acw62.useContext)($b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$FocusContext) || {};
    // Create a tree node here so we can add children to it even before it is added to the tree.
    let node = (0, $acw62.useMemo)(()=>new $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: scopeRef
        }), [
        scopeRef
    ]);
    (0, $3581f530a27f457c$export$e5c5a5f917a5871c)(()=>{
        // If a new scope mounts outside the active scope, (e.g. DialogContainer launched from a menu),
        // use the active scope as the parent instead of the parent from context. Layout effects run bottom
        // up, so if the parent is not yet added to the tree, don't do this. Only the outer-most FocusScope
        // that is being added should get the activeScope as its parent.
        let parent = parentNode || $b27e9acf8b86f3f1$export$d06fae2ee68b101e.root;
        if ($b27e9acf8b86f3f1$export$d06fae2ee68b101e.getTreeNode(parent.scopeRef) && $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope && !$b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isAncestorScope($b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope, parent.scopeRef)) {
            let activeNode = $b27e9acf8b86f3f1$export$d06fae2ee68b101e.getTreeNode($b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope);
            if (activeNode) parent = activeNode;
        }
        // Add the node to the parent, and to the tree.
        parent.addChild(node);
        $b27e9acf8b86f3f1$export$d06fae2ee68b101e.addNode(node);
    }, [
        node,
        parentNode
    ]);
    (0, $3581f530a27f457c$export$e5c5a5f917a5871c)(()=>{
        let node = $b27e9acf8b86f3f1$export$d06fae2ee68b101e.getTreeNode(scopeRef);
        if (node) node.contain = !!contain;
    }, [
        contain
    ]);
    (0, $3581f530a27f457c$export$e5c5a5f917a5871c)(()=>{
        var _startRef_current;
        // Find all rendered nodes between the sentinels and add them to the scope.
        let node = (_startRef_current = startRef.current) === null || _startRef_current === void 0 ? void 0 : _startRef_current.nextSibling;
        let nodes = [];
        while(node && node !== endRef.current){
            nodes.push(node);
            node = node.nextSibling;
        }
        scopeRef.current = nodes;
    }, [
        children
    ]);
    $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restoreFocus, contain);
    $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$useFocusContainment(scopeRef, contain);
    $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain);
    $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus);
    (0, $acw62.useEffect)(()=>{
        const activeElement = (0, $eef56d26e56a84a0$export$b204af158042fbac)(scopeRef.current ? scopeRef.current[0] : undefined).activeElement;
        let scope = null;
        if ($b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInScope(activeElement, scopeRef.current)) {
            // We need to traverse the focusScope tree and find the bottom most scope that
            // contains the active element and set that as the activeScope.
            for (let node of $b27e9acf8b86f3f1$export$d06fae2ee68b101e.traverse())if (node.scopeRef && $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInScope(activeElement, node.scopeRef.current)) scope = node;
            if (scope === $b27e9acf8b86f3f1$export$d06fae2ee68b101e.getTreeNode(scopeRef)) $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope = scope.scopeRef;
        }
    }, [
        scopeRef
    ]);
    (0, $3581f530a27f457c$export$e5c5a5f917a5871c)(()=>{
        return ()=>{
            var _focusScopeTree_getTreeNode_parent, _focusScopeTree_getTreeNode;
            var _focusScopeTree_getTreeNode_parent_scopeRef;
            // Scope may have been re-parented.
            let parentScope = (_focusScopeTree_getTreeNode_parent_scopeRef = (_focusScopeTree_getTreeNode = $b27e9acf8b86f3f1$export$d06fae2ee68b101e.getTreeNode(scopeRef)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : (_focusScopeTree_getTreeNode_parent = _focusScopeTree_getTreeNode.parent) === null || _focusScopeTree_getTreeNode_parent === void 0 ? void 0 : _focusScopeTree_getTreeNode_parent.scopeRef) !== null && _focusScopeTree_getTreeNode_parent_scopeRef !== void 0 ? _focusScopeTree_getTreeNode_parent_scopeRef : null;
            if ((scopeRef === $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope || $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isAncestorScope(scopeRef, $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope)) && (!parentScope || $b27e9acf8b86f3f1$export$d06fae2ee68b101e.getTreeNode(parentScope))) $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope = parentScope;
            $b27e9acf8b86f3f1$export$d06fae2ee68b101e.removeTreeNode(scopeRef);
        };
    }, [
        scopeRef
    ]);
    let focusManager = (0, $acw62.useMemo)(()=>$b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$createFocusManagerForScope(scopeRef), []);
    let value = (0, $acw62.useMemo)(()=>({
            focusManager: focusManager,
            parentNode: node
        }), [
        node,
        focusManager
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$FocusContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-focus-scope-start": true,
        hidden: true,
        ref: startRef
    }), children, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        "data-focus-scope-end": true,
        hidden: true,
        ref: endRef
    }));
}
function $b27e9acf8b86f3f1$export$10c5169755ce7bd7() {
    var _useContext;
    return (_useContext = (0, $acw62.useContext)($b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$FocusContext)) === null || _useContext === void 0 ? void 0 : _useContext.focusManager;
}
function $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$createFocusManagerForScope(scopeRef) {
    return {
        focusNext (opts = {}) {
            let scope = scopeRef.current;
            let { from: from, tabbable: tabbable, wrap: wrap, accept: accept } = opts;
            let node = from || (0, $eef56d26e56a84a0$export$b204af158042fbac)(scope[0]).activeElement;
            let sentinel = scope[0].previousElementSibling;
            let scopeRoot = $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $b27e9acf8b86f3f1$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = sentinel;
                nextNode = walker.nextNode();
            }
            if (nextNode) $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = {}) {
            let scope = scopeRef.current;
            let { from: from, tabbable: tabbable, wrap: wrap, accept: accept } = opts;
            let node = from || (0, $eef56d26e56a84a0$export$b204af158042fbac)(scope[0]).activeElement;
            let sentinel = scope[scope.length - 1].nextElementSibling;
            let scopeRoot = $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $b27e9acf8b86f3f1$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInScope(node, scope) ? node : sentinel;
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = sentinel;
                previousNode = walker.previousNode();
            }
            if (previousNode) $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        },
        focusFirst (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable, accept: accept } = opts;
            let scopeRoot = $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $b27e9acf8b86f3f1$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[0].previousElementSibling;
            let nextNode = walker.nextNode();
            if (nextNode) $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = {}) {
            let scope = scopeRef.current;
            let { tabbable: tabbable, accept: accept } = opts;
            let scopeRoot = $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $b27e9acf8b86f3f1$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: tabbable,
                accept: accept
            }, scope);
            walker.currentNode = scope[scope.length - 1].nextElementSibling;
            let previousNode = walker.previousNode();
            if (previousNode) $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode;
        }
    };
}
const $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusableElements = [
    "input:not([disabled]):not([type=hidden])",
    "select:not([disabled])",
    "textarea:not([disabled])",
    "button:not([disabled])",
    "a[href]",
    "area[href]",
    "summary",
    "iframe",
    "object",
    "embed",
    "audio[controls]",
    "video[controls]",
    "[contenteditable]"
];
const $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR = $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusableElements.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
$b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusableElements.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR = $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusableElements.join(':not([hidden]):not([tabindex="-1"]),');
function $b27e9acf8b86f3f1$export$4c063cf1350e6fed(element) {
    return element.matches($b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR);
}
function $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$getScopeRoot(scope) {
    return scope[0].parentElement;
}
function $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) {
    let scope = $b27e9acf8b86f3f1$export$d06fae2ee68b101e.getTreeNode($b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.contain) return false;
        scope = scope.parent;
    }
    return true;
}
function $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$useFocusContainment(scopeRef, contain) {
    let focusedNode = (0, $acw62.useRef)();
    let raf = (0, $acw62.useRef)();
    (0, $3581f530a27f457c$export$e5c5a5f917a5871c)(()=>{
        let scope = scopeRef.current;
        if (!contain) {
            // if contain was changed, then we should cancel any ongoing waits to pull focus back into containment
            if (raf.current) {
                cancelAnimationFrame(raf.current);
                raf.current = undefined;
            }
            return;
        }
        const ownerDocument = (0, $eef56d26e56a84a0$export$b204af158042fbac)(scope ? scope[0] : undefined);
        // Handle the Tab key to contain focus within the scope
        let onKeyDown = (e)=>{
            if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey || !$b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) || e.isComposing) return;
            let focusedElement = ownerDocument.activeElement;
            let scope = scopeRef.current;
            if (!scope || !$b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInScope(focusedElement, scope)) return;
            let scopeRoot = $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$getScopeRoot(scope);
            let walker = $b27e9acf8b86f3f1$export$2d6ec8fc375ceafa(scopeRoot, {
                tabbable: true
            }, scope);
            if (!focusedElement) return;
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nextElement) {
                walker.currentNode = e.shiftKey ? scope[scope.length - 1].nextElementSibling : scope[0].previousElementSibling;
                nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            }
            e.preventDefault();
            if (nextElement) $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusElement(nextElement, true);
        };
        let onFocus = (e)=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope || $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isAncestorScope($b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope, scopeRef)) && $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInScope(e.target, scopeRef.current)) {
                $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope = scopeRef;
                focusedNode.current = e.target;
            } else if ($b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInChildScope(e.target, scopeRef)) {
                // If a focus event occurs outside the active scope (e.g. user tabs from browser location bar),
                // restore focus to the previously focused node or the first tabbable element in the active scope.
                if (focusedNode.current) focusedNode.current.focus();
                else if ($b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope && $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope.current) $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusFirstInScope($b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope.current);
            } else if ($b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef)) focusedNode.current = e.target;
        };
        let onBlur = (e)=>{
            // Firefox doesn't shift focus back to the Dialog properly without this
            if (raf.current) cancelAnimationFrame(raf.current);
            raf.current = requestAnimationFrame(()=>{
                // Use document.activeElement instead of e.relatedTarget so we can tell if user clicked into iframe
                if (ownerDocument.activeElement && $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) && !$b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInChildScope(ownerDocument.activeElement, scopeRef)) {
                    $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope = scopeRef;
                    if (ownerDocument.body.contains(e.target)) {
                        var _focusedNode_current;
                        focusedNode.current = e.target;
                        (_focusedNode_current = focusedNode.current) === null || _focusedNode_current === void 0 || _focusedNode_current.focus();
                    } else if ($b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope.current) $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusFirstInScope($b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope.current);
                }
            });
        };
        ownerDocument.addEventListener("keydown", onKeyDown, false);
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusout", onBlur, false));
        return ()=>{
            ownerDocument.removeEventListener("keydown", onKeyDown, false);
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusout", onBlur, false));
        };
    }, [
        scopeRef,
        contain
    ]);
    (0, $3581f530a27f457c$export$e5c5a5f917a5871c)(()=>{
        return ()=>{
            if (raf.current) cancelAnimationFrame(raf.current);
        };
    }, [
        raf
    ]);
}
function $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInAnyScope(element) {
    return $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInChildScope(element);
}
function $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInScope(element, scope) {
    if (!element) return false;
    if (!scope) return false;
    return scope.some((node)=>node.contains(element));
}
function $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInChildScope(element, scope = null) {
    // If the element is within a top layer element (e.g. toasts), always allow moving focus there.
    if (element instanceof Element && element.closest("[data-react-aria-top-layer]")) return true;
    // node.contains in isElementInScope covers child scopes that are also DOM children,
    // but does not cover child scopes in portals.
    for (let { scopeRef: s } of $b27e9acf8b86f3f1$export$d06fae2ee68b101e.traverse($b27e9acf8b86f3f1$export$d06fae2ee68b101e.getTreeNode(scope))){
        if (s && $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInScope(element, s.current)) return true;
    }
    return false;
}
function $b27e9acf8b86f3f1$export$1258395f99bf9cbf(element) {
    return $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInChildScope(element, $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope);
}
function $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isAncestorScope(ancestor, scope) {
    var _focusScopeTree_getTreeNode;
    let parent = (_focusScopeTree_getTreeNode = $b27e9acf8b86f3f1$export$d06fae2ee68b101e.getTreeNode(scope)) === null || _focusScopeTree_getTreeNode === void 0 ? void 0 : _focusScopeTree_getTreeNode.parent;
    while(parent){
        if (parent.scopeRef === ancestor) return true;
        parent = parent.parent;
    }
    return false;
}
function $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusElement(element, scroll = false) {
    if (element != null && !scroll) try {
        (0, $b92af0002e176fee$export$80f3e147d781571c)(element);
    } catch (err) {
    // ignore
    }
    else if (element != null) try {
        element.focus();
    } catch (err) {
    // ignore
    }
}
function $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusFirstInScope(scope, tabbable = true) {
    let sentinel = scope[0].previousElementSibling;
    let scopeRoot = $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$getScopeRoot(scope);
    let walker = $b27e9acf8b86f3f1$export$2d6ec8fc375ceafa(scopeRoot, {
        tabbable: tabbable
    }, scope);
    walker.currentNode = sentinel;
    let nextNode = walker.nextNode();
    // If the scope does not contain a tabbable element, use the first focusable element.
    if (tabbable && !nextNode) {
        scopeRoot = $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$getScopeRoot(scope);
        walker = $b27e9acf8b86f3f1$export$2d6ec8fc375ceafa(scopeRoot, {
            tabbable: false
        }, scope);
        walker.currentNode = sentinel;
        nextNode = walker.nextNode();
    }
    $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusElement(nextNode);
}
function $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$useAutoFocus(scopeRef, autoFocus) {
    const autoFocusRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(autoFocus);
    (0, $acw62.useEffect)(()=>{
        if (autoFocusRef.current) {
            $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope = scopeRef;
            const ownerDocument = (0, $eef56d26e56a84a0$export$b204af158042fbac)(scopeRef.current ? scopeRef.current[0] : undefined);
            if (!$b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope.current) && scopeRef.current) $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusFirstInScope(scopeRef.current);
        }
        autoFocusRef.current = false;
    }, [
        scopeRef
    ]);
}
function $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$useActiveScopeTracker(scopeRef, restore, contain) {
    (0, $3581f530a27f457c$export$e5c5a5f917a5871c)(()=>{
        if (restore || contain) return;
        let scope = scopeRef.current;
        const ownerDocument = (0, $eef56d26e56a84a0$export$b204af158042fbac)(scope ? scope[0] : undefined);
        let onFocus = (e)=>{
            let target = e.target;
            if ($b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInScope(target, scopeRef.current)) $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope = scopeRef;
            else if (!$b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInAnyScope(target)) $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope = null;
        };
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        return ()=>{
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
        };
    }, [
        scopeRef,
        restore,
        contain
    ]);
}
function $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$shouldRestoreFocus(scopeRef) {
    let scope = $b27e9acf8b86f3f1$export$d06fae2ee68b101e.getTreeNode($b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope);
    while(scope && scope.scopeRef !== scopeRef){
        if (scope.nodeToRestore) return false;
        scope = scope.parent;
    }
    return (scope === null || scope === void 0 ? void 0 : scope.scopeRef) === scopeRef;
}
function $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$useRestoreFocus(scopeRef, restoreFocus, contain) {
    // create a ref during render instead of useLayoutEffect so the active element is saved before a child with autoFocus=true mounts.
    // eslint-disable-next-line no-restricted-globals
    const nodeToRestoreRef = (0, $acw62.useRef)(typeof document !== "undefined" ? (0, $eef56d26e56a84a0$export$b204af158042fbac)(scopeRef.current ? scopeRef.current[0] : undefined).activeElement : null);
    (0, $3581f530a27f457c$export$e5c5a5f917a5871c)(()=>{
        let scope = scopeRef.current;
        const ownerDocument = (0, $eef56d26e56a84a0$export$b204af158042fbac)(scope ? scope[0] : undefined);
        if (!restoreFocus || contain) return;
        let onFocus = ()=>{
            // If focusing an element in a child scope of the currently active scope, the child becomes active.
            // Moving out of the active scope to an ancestor is not allowed.
            if ((!$b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope || $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isAncestorScope($b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope, scopeRef)) && $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, scopeRef.current)) $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$activeScope = scopeRef;
        };
        ownerDocument.addEventListener("focusin", onFocus, false);
        scope === null || scope === void 0 || scope.forEach((element)=>element.addEventListener("focusin", onFocus, false));
        return ()=>{
            ownerDocument.removeEventListener("focusin", onFocus, false);
            scope === null || scope === void 0 || scope.forEach((element)=>element.removeEventListener("focusin", onFocus, false));
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        scopeRef,
        contain
    ]);
    (0, $3581f530a27f457c$export$e5c5a5f917a5871c)(()=>{
        const ownerDocument = (0, $eef56d26e56a84a0$export$b204af158042fbac)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        // Handle the Tab key so that tabbing out of the scope goes to the next element
        // after the node that had focus when the scope mounted. This is important when
        // using portals for overlays, so that focus goes to the expected element when
        // tabbing out of the overlay.
        let onKeyDown = (e)=>{
            if (e.key !== "Tab" || e.altKey || e.ctrlKey || e.metaKey || !$b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$shouldContainFocus(scopeRef) || e.isComposing) return;
            let focusedElement = ownerDocument.activeElement;
            if (!$b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInScope(focusedElement, scopeRef.current)) return;
            let treeNode = $b27e9acf8b86f3f1$export$d06fae2ee68b101e.getTreeNode(scopeRef);
            if (!treeNode) return;
            let nodeToRestore = treeNode.nodeToRestore;
            // Create a DOM tree walker that matches all tabbable elements
            let walker = $b27e9acf8b86f3f1$export$2d6ec8fc375ceafa(ownerDocument.body, {
                tabbable: true
            });
            // Find the next tabbable element after the currently focused element
            walker.currentNode = focusedElement;
            let nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
            if (!nodeToRestore || !ownerDocument.body.contains(nodeToRestore) || nodeToRestore === ownerDocument.body) {
                nodeToRestore = undefined;
                treeNode.nodeToRestore = undefined;
            }
            // If there is no next element, or it is outside the current scope, move focus to the
            // next element after the node to restore to instead.
            if ((!nextElement || !$b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInScope(nextElement, scopeRef.current)) && nodeToRestore) {
                walker.currentNode = nodeToRestore;
                // Skip over elements within the scope, in case the scope immediately follows the node to restore.
                do nextElement = e.shiftKey ? walker.previousNode() : walker.nextNode();
                while ($b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInScope(nextElement, scopeRef.current));
                e.preventDefault();
                e.stopPropagation();
                if (nextElement) $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusElement(nextElement, true);
                else // then move focus to the body.
                // Otherwise restore focus to the nodeToRestore (e.g menu within a popover -> tabbing to close the menu should move focus to menu trigger)
                if (!$b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInAnyScope(nodeToRestore)) focusedElement.blur();
                else $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusElement(nodeToRestore, true);
            }
        };
        if (!contain) ownerDocument.addEventListener("keydown", onKeyDown, true);
        return ()=>{
            if (!contain) ownerDocument.removeEventListener("keydown", onKeyDown, true);
        };
    }, [
        scopeRef,
        restoreFocus,
        contain
    ]);
    (0, $3581f530a27f457c$export$e5c5a5f917a5871c)(()=>{
        const ownerDocument = (0, $eef56d26e56a84a0$export$b204af158042fbac)(scopeRef.current ? scopeRef.current[0] : undefined);
        if (!restoreFocus) return;
        let treeNode = $b27e9acf8b86f3f1$export$d06fae2ee68b101e.getTreeNode(scopeRef);
        if (!treeNode) return;
        var _nodeToRestoreRef_current;
        treeNode.nodeToRestore = (_nodeToRestoreRef_current = nodeToRestoreRef.current) !== null && _nodeToRestoreRef_current !== void 0 ? _nodeToRestoreRef_current : undefined;
        return ()=>{
            let treeNode = $b27e9acf8b86f3f1$export$d06fae2ee68b101e.getTreeNode(scopeRef);
            if (!treeNode) return;
            let nodeToRestore = treeNode.nodeToRestore;
            // if we already lost focus to the body and this was the active scope, then we should attempt to restore
            if (restoreFocus && nodeToRestore && // eslint-disable-next-line react-hooks/exhaustive-deps
            ($b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInScope(ownerDocument.activeElement, scopeRef.current) || ownerDocument.activeElement === ownerDocument.body && $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$shouldRestoreFocus(scopeRef))) {
                // freeze the focusScopeTree so it persists after the raf, otherwise during unmount nodes are removed from it
                let clonedTree = $b27e9acf8b86f3f1$export$d06fae2ee68b101e.clone();
                requestAnimationFrame(()=>{
                    // Only restore focus if we've lost focus to the body, the alternative is that focus has been purposefully moved elsewhere
                    if (ownerDocument.activeElement === ownerDocument.body) {
                        // look up the tree starting with our scope to find a nodeToRestore still in the DOM
                        let treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.nodeToRestore && treeNode.nodeToRestore.isConnected) {
                                $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusElement(treeNode.nodeToRestore);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                        // If no nodeToRestore was found, focus the first element in the nearest
                        // ancestor scope that is still in the tree.
                        treeNode = clonedTree.getTreeNode(scopeRef);
                        while(treeNode){
                            if (treeNode.scopeRef && treeNode.scopeRef.current && $b27e9acf8b86f3f1$export$d06fae2ee68b101e.getTreeNode(treeNode.scopeRef)) {
                                $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusFirstInScope(treeNode.scopeRef.current, true);
                                return;
                            }
                            treeNode = treeNode.parent;
                        }
                    }
                });
            }
        };
    }, [
        scopeRef,
        restoreFocus
    ]);
}
function $b27e9acf8b86f3f1$export$2d6ec8fc375ceafa(root, opts, scope) {
    let selector = (opts === null || opts === void 0 ? void 0 : opts.tabbable) ? $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$TABBABLE_ELEMENT_SELECTOR : $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$FOCUSABLE_ELEMENT_SELECTOR;
    let walker = (0, $eef56d26e56a84a0$export$b204af158042fbac)(root).createTreeWalker(root, NodeFilter.SHOW_ELEMENT, {
        acceptNode (node) {
            var _opts_from;
            // Skip nodes inside the starting node.
            if (opts === null || opts === void 0 ? void 0 : (_opts_from = opts.from) === null || _opts_from === void 0 ? void 0 : _opts_from.contains(node)) return NodeFilter.FILTER_REJECT;
            if (node.matches(selector) && (0, $94fbac57294f148e$export$e989c0fffaa6b27a)(node) && (!scope || $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInScope(node, scope)) && (!(opts === null || opts === void 0 ? void 0 : opts.accept) || opts.accept(node))) return NodeFilter.FILTER_ACCEPT;
            return NodeFilter.FILTER_SKIP;
        }
    });
    if (opts === null || opts === void 0 ? void 0 : opts.from) walker.currentNode = opts.from;
    return walker;
}
function $b27e9acf8b86f3f1$export$c5251b9e124bf29(ref, defaultOptions = {}) {
    return {
        focusNext (opts = {}) {
            let root = ref.current;
            if (!root) return null;
            let { from: from, tabbable: tabbable = defaultOptions.tabbable, wrap: wrap = defaultOptions.wrap, accept: accept = defaultOptions.accept } = opts;
            let node = from || (0, $eef56d26e56a84a0$export$b204af158042fbac)(root).activeElement;
            let walker = $b27e9acf8b86f3f1$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if (root.contains(node)) walker.currentNode = node;
            let nextNode = walker.nextNode();
            if (!nextNode && wrap) {
                walker.currentNode = root;
                nextNode = walker.nextNode();
            }
            if (nextNode) $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusPrevious (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { from: from, tabbable: tabbable = defaultOptions.tabbable, wrap: wrap = defaultOptions.wrap, accept: accept = defaultOptions.accept } = opts;
            let node = from || (0, $eef56d26e56a84a0$export$b204af158042fbac)(root).activeElement;
            let walker = $b27e9acf8b86f3f1$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            if (root.contains(node)) walker.currentNode = node;
            else {
                let next = $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$last(walker);
                if (next) $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusElement(next, true);
                return next !== null && next !== void 0 ? next : null;
            }
            let previousNode = walker.previousNode();
            if (!previousNode && wrap) {
                walker.currentNode = root;
                let lastNode = $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$last(walker);
                if (!lastNode) return null;
                previousNode = lastNode;
            }
            if (previousNode) $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusElement(previousNode, true);
            return previousNode !== null && previousNode !== void 0 ? previousNode : null;
        },
        focusFirst (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { tabbable: tabbable = defaultOptions.tabbable, accept: accept = defaultOptions.accept } = opts;
            let walker = $b27e9acf8b86f3f1$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            let nextNode = walker.nextNode();
            if (nextNode) $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusElement(nextNode, true);
            return nextNode;
        },
        focusLast (opts = defaultOptions) {
            let root = ref.current;
            if (!root) return null;
            let { tabbable: tabbable = defaultOptions.tabbable, accept: accept = defaultOptions.accept } = opts;
            let walker = $b27e9acf8b86f3f1$export$2d6ec8fc375ceafa(root, {
                tabbable: tabbable,
                accept: accept
            });
            let next = $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$last(walker);
            if (next) $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$focusElement(next, true);
            return next !== null && next !== void 0 ? next : null;
        }
    };
}
function $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$last(walker) {
    let next = undefined;
    let last;
    do {
        last = walker.lastChild();
        if (last) next = last;
    }while (last);
    return next;
}
class $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$Tree {
    get size() {
        return this.fastMap.size;
    }
    getTreeNode(data) {
        return this.fastMap.get(data);
    }
    addTreeNode(scopeRef, parent, nodeToRestore) {
        let parentNode = this.fastMap.get(parent !== null && parent !== void 0 ? parent : null);
        if (!parentNode) return;
        let node = new $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: scopeRef
        });
        parentNode.addChild(node);
        node.parent = parentNode;
        this.fastMap.set(scopeRef, node);
        if (nodeToRestore) node.nodeToRestore = nodeToRestore;
    }
    addNode(node) {
        this.fastMap.set(node.scopeRef, node);
    }
    removeTreeNode(scopeRef) {
        // never remove the root
        if (scopeRef === null) return;
        let node = this.fastMap.get(scopeRef);
        if (!node) return;
        let parentNode = node.parent;
        // when we remove a scope, check if any sibling scopes are trying to restore focus to something inside the scope we're removing
        // if we are, then replace the siblings restore with the restore from the scope we're removing
        for (let current of this.traverse())if (current !== node && node.nodeToRestore && current.nodeToRestore && node.scopeRef && node.scopeRef.current && $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$isElementInScope(current.nodeToRestore, node.scopeRef.current)) current.nodeToRestore = node.nodeToRestore;
        let children = node.children;
        if (parentNode) {
            parentNode.removeChild(node);
            if (children.size > 0) children.forEach((child)=>parentNode && parentNode.addChild(child));
        }
        this.fastMap.delete(node.scopeRef);
    }
    // Pre Order Depth First
    *traverse(node = this.root) {
        if (node.scopeRef != null) yield node;
        if (node.children.size > 0) for (let child of node.children)yield* this.traverse(child);
    }
    clone() {
        var _node_parent;
        let newTree = new $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$Tree();
        var _node_parent_scopeRef;
        for (let node of this.traverse())newTree.addTreeNode(node.scopeRef, (_node_parent_scopeRef = (_node_parent = node.parent) === null || _node_parent === void 0 ? void 0 : _node_parent.scopeRef) !== null && _node_parent_scopeRef !== void 0 ? _node_parent_scopeRef : null, node.nodeToRestore);
        return newTree;
    }
    constructor(){
        this.fastMap = new Map();
        this.root = new $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$TreeNode({
            scopeRef: null
        });
        this.fastMap.set(null, this.root);
    }
}
class $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$TreeNode {
    addChild(node) {
        this.children.add(node);
        node.parent = this;
    }
    removeChild(node) {
        this.children.delete(node);
        node.parent = undefined;
    }
    constructor(props){
        this.children = new Set();
        this.contain = false;
        this.scopeRef = props.scopeRef;
    }
}
let $b27e9acf8b86f3f1$export$d06fae2ee68b101e = new $b27e9acf8b86f3f1$var$$9bf71ea28793e738$var$Tree();




var $1u0KT = parcelRequire("1u0KT");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $3tUi5 = parcelRequire("3tUi5");

var $ai2Pb = parcelRequire("ai2Pb");

var $acw62 = parcelRequire("acw62");
var $8b212e86ef0abcd9$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $8b212e86ef0abcd9$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === "function") {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $8b212e86ef0abcd9$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === "function") return $8b212e86ef0abcd9$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $8b212e86ef0abcd9$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $8b212e86ef0abcd9$export$700979bc83e7db82 = typeof window !== "undefined" && window.document && window.document.createElement ? $acw62.useLayoutEffect : $acw62.useEffect;


var $5fbf42b40e8ead34$var$EMPTY_MODIFIERS = [];
var $5fbf42b40e8ead34$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $acw62.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || "bottom",
        strategy: options.strategy || "absolute",
        modifiers: options.modifiers || $5fbf42b40e8ead34$var$EMPTY_MODIFIERS
    };
    var _React$useState = $acw62.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: "0",
                top: "0"
            },
            arrow: {
                position: "absolute"
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $acw62.useMemo(function() {
        return {
            name: "updateState",
            enabled: true,
            phase: "write",
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $1u0KT.flushSync(function() {
                    setState({
                        styles: (0, $8b212e86ef0abcd9$export$5150077fc2e7c662)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $8b212e86ef0abcd9$export$5150077fc2e7c662)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                "computeStyles"
            ]
        };
    }, []);
    var popperOptions = $acw62.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: "applyStyles",
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $acw62.useRef();
    (0, $8b212e86ef0abcd9$export$700979bc83e7db82)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $8b212e86ef0abcd9$export$700979bc83e7db82)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $3tUi5.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};




/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $2ad24e75a96deccc$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $2ad24e75a96deccc$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
typeof SuppressedError === "function" && SuppressedError;
const $2ad24e75a96deccc$var$GlobalNavStyles = (0, $lmFrL.createGlobalStyle)`
    .helix-unified-nav__dropdown-menu {
        z-index: 1051;
    }
`;
const $2ad24e75a96deccc$var$NAVBAR_HEIGHT = {
    small: "48px",
    large: "60px"
};
const $2ad24e75a96deccc$var$colors = {
    gray: {
        50: "#f9fafb",
        100: "#f3f4f6",
        200: "#e5e7eb",
        300: "#d1d5db",
        400: "#9ca3af",
        500: "#6b7280",
        600: "#4b5563",
        700: "#374151",
        800: "#1f2937",
        900: " #111827"
    }
};
const $2ad24e75a96deccc$var$StyledNavbarWrapper = (0, $lmFrL.default).header`
    display: flex;
    flex-direction: column;
    box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.2);
`;
const $2ad24e75a96deccc$var$StyledNavbar = (0, $lmFrL.default).div`
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans',
        'Helvetica Neue', sans-serif;
    padding: ${({ $hasExpandIcon: $hasExpandIcon, $reducePaddingLeft: $reducePaddingLeft })=>$hasExpandIcon ? "10px 32px 10px 12px" : $reducePaddingLeft ? "10px 32px 10px 14px" : "10px 32px"};

    font-size: 14px;
    background-color: ${({ $isDark: $isDark })=>$isDark ? "#111827" : "rgba(255, 255, 255, 0.8)"};
    box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.2);
    backdrop-filter: blur(48px);
    box-sizing: border-box;
    display: flex;
    color: ${({ $isDark: $isDark })=>$isDark ? "#F9FAFB" : "#111827"};
    align-items: center;
    z-index: 1050;
    position: relative;
    height: ${({ $variant: $variant })=>$2ad24e75a96deccc$var$NAVBAR_HEIGHT[$variant === "small" ? "small" : "large"]};
    ${({ $fixed: $fixed })=>$fixed && (0, $lmFrL.css)`
            position: fixed;
            left: 0;
            right: 0;
            top: 0;
        `}
    .helix-unified-navbar__logo-wrapper {
        flex: 0;
        width: fit-content;
        display: flex;
        align-items: center;
        &.helix-unified-navbar__logo-wrapper-with-body {
            flex: 0;
        }
        .helix-unified-navbar__logo {
            height: 32px;
            a {
                &:focus {
                    outline: solid 2px ${$2ad24e75a96deccc$var$colors.gray[300]};
                    border-radius: 4px;
                }
            }
        }
        .helix-unified-navbar__application-name {
            white-space: nowrap;
            margin: 0 12px;
            font-weight: 600;
            -webkit-font-smoothing: antialiased;
        }
    }

    .helix-unified-nav__navigation-item {
        display: inline-flex;
        flex: 0 0 auto;
        align-items: center;
        border: none;
        padding: 8px 12px;
        border-radius: 6px;
        background-color: transparent;
        color: ${({ $isDark: $isDark })=>$isDark ? "#F9FAFB" : " #4B5563"};
        font-weight: 600;
        font-size: inherit;
        font-family: inherit;
        text-decoration: none;
        -webkit-font-smoothing: antialiased;
        cursor: pointer;
        &:hover {
            color: ${({ $isDark: $isDark })=>$isDark ? "#F9FAFB" : "#374151"};
            background-color: ${({ $isDark: $isDark })=>$isDark ? "#1F2937" : "#F3F4F6"};
        }
        &.active {
            color: ${({ $isDark: $isDark })=>$isDark ? "#fff" : "#111827"};
            background-color: ${({ $isDark: $isDark })=>$isDark ? "#374151" : "#E5E7EB"};
        }
        &:focus {
            outline: solid 2px ${$2ad24e75a96deccc$var$colors.gray[300]};
            box-sizing: border-box;
        }
        &[disabled],
        &.disabled {
            opacity: 0.5;
            cursor: pointer;
            pointer-events: none;
        }
        &.helix-unified-nav__navigation-item_more {
            i.material-icons {
                font-size: 20px;
            }
        }
    }

    .helix-unified-nav__mobile-menu-trigger,
    .helix-unified-nav__mobile-notification-trigger {
        padding: 8px;
        ${({ $isDark: $isDark })=>$isDark && (0, $lmFrL.css)`
                svg path:not(.alert-dot) {
                    fill: currentColor !important;
                }
            `}
    }

    .helix-unified-nav__mobile-menu-trigger {
    }

    @media screen and (max-width: 576px) {
        padding: 12px;
    }

    .alert-dot {
        fill: ${({ $isDark: $isDark })=>$isDark ? "#F87171" : "#DC2626"}!important;
    }

    a.helix-unified-nav__nav-button-link,
    button.helix-unified-nav__nav-button {
        display: inline-flex;
        flex: 0 0 auto;
        align-items: center;
        border: none;
        padding: 8px;
        border-radius: 6px;
        background-color: transparent;
        color: inherit;
        &.helix-unified-nav__nav-button-drawer {
            margin-right: 8px;
            @media screen and (max-width: 576px) {
                display: none;
            }
            ${({ $isDark: $isDark })=>$isDark && (0, $lmFrL.css)`
                    svg path:not(.alert-dot) {
                        fill: currentColor !important;
                    }
                `}
        }
        &.helix-unified-nav__nav-button-user {
            padding: 0;
            margin-left: 8px;
            border-radius: 50%;
            .helix-unified-nav__user-avatar {
                width: 32px;
                height: 32px;
                border-radius: 50%;
                overflow: hidden;
                display: flex;
                align-items: center;
                object-position: center center;
                img {
                    width: 32px;
                    height: 32px;
                    object-fit: cover;
                }
            }
            &.active {
                border: solid 2px ${({ $isDark: $isDark })=>$isDark ? "#374151" : "#D1D5DB"};
            }
        }
        &:focus {
            outline: solid 2px;
        }

        &.active:not(.helix-unified-nav__nav-button-user) {
            background-color: ${({ $isDark: $isDark })=>$isDark ? "#374151" : "#E5E7EB"};
        }
        &:hover:not(.helix-unified-nav__nav-button-user) {
            background-color: ${({ $isDark: $isDark })=>$isDark ? "#374151" : "#F3F4F6"};
        }
        &:hover {
            text-decoration: none;
        }
        &.primary-text-color {
            color: var(--helix-brand, #236847);
        }
        &.unified-nav__nav-icon-action {
            white-space: nowrap;
            font-weight: 600;
            svg {
                margin-right: 8px;
            }
        }
    }
    ${({ $reducePaddingLeft: $reducePaddingLeft })=>$reducePaddingLeft && (0, $lmFrL.css)`
            .helix-unified-navbar__body {
                flex: unset;
            }
        `}

    // added the following styles to support helix 2 type styles in the navbar

.helix-display-x-large {
        font-size: 48px;
        font-weight: 600;
        line-height: 52px;
        @media screen and (max-width: 768px) {
            font-size: 32px;
            line-height: 35px;
        }
    }

    .helix-display-large {
        font-size: 36px;
        font-weight: 600;
        line-height: 44px;
        @media screen and (max-width: 768px) {
            font-size: 24px;
            line-height: 29px;
        }
    }

    .helix-display-medium {
        font-size: 30px;
        font-weight: 600;
        line-height: 36px;
        @media screen and (max-width: 768px) {
            font-size: 20px;
            line-height: 24px;
        }
    }

    .helix-display-small {
        font-size: 24px;
        font-weight: 600;
        line-height: 30px;
        @media screen and (max-width: 768px) {
            font-size: 16px;
            line-height: 20px;
        }
    }

    .helix-display-x-small {
        font-size: 20px;
        font-weight: 600;
        line-height: 26px;
        @media screen and (max-width: 768px) {
            font-size: 15px;
            line-height: 18px;
        }
    }

    .helix-heading {
        font-size: 16px;
        font-weight: 600;
        line-height: 22px;
        @media screen and (max-width: 768px) {
            font-size: 17px;
            line-height: 24px;
        }
    }

    .helix-subheading {
        font-size: 12px;
        font-weight: 600;
        line-height: 20px;
        @media screen and (max-width: 768px) {
            font-size: 13px;
            line-height: 17px;
        }
    }

    .helix-body {
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        @media screen and (max-width: 768px) {
            font-size: 15px;
            line-height: 20px;
        }
    }

    .helix-body--strong {
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
        @media screen and (max-width: 768px) {
            font-size: 15px;
            line-height: 20px;
        }
    }

    .helix-number {
        font-size: 14px;
        font-weight: 400;
        line-height: 20px;
        font-feature-settings: 'tnum' on, 'lnum' on;
        @media screen and (max-width: 768px) {
            font-size: 15px;
            line-height: 20px;
        }
    }

    .helix-number--strong {
        font-size: 14px;
        font-weight: 600;
        line-height: 20px;
        font-feature-settings: 'tnum' on, 'lnum' on;
        @media screen and (max-width: 768px) {
            font-size: 15px;
            line-height: 20px;
        }
    }

    .helix-small {
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
        @media screen and (max-width: 768px) {
            font-size: 13px;
            line-height: 17px;
        }
    }

    .helix-small--strong {
        font-size: 12px;
        font-weight: 600;
        line-height: 16px;
        @media screen and (max-width: 768px) {
            font-size: 13px;
            line-height: 17px;
        }
    }

    // get each of the gray colors from the theme and create a class for each

    .helix-text-gray-50 {
        color: ${$2ad24e75a96deccc$var$colors.gray[50]};
    }

    .helix-text-gray-100 {
        color: ${$2ad24e75a96deccc$var$colors.gray[100]};
    }

    .helix-text-gray-200 {
        color: ${$2ad24e75a96deccc$var$colors.gray[200]};
    }

    .helix-text-gray-300 {
        color: ${$2ad24e75a96deccc$var$colors.gray[300]};
    }

    .helix-text-gray-400 {
        color: ${$2ad24e75a96deccc$var$colors.gray[400]};
    }

    .helix-text-gray-500 {
        color: ${$2ad24e75a96deccc$var$colors.gray[500]};
    }

    .helix-text-gray-600 {
        color: ${$2ad24e75a96deccc$var$colors.gray[600]};
    }

    .helix-text-gray-700 {
        color: ${$2ad24e75a96deccc$var$colors.gray[700]};
    }

    .helix-text-gray-800 {
        color: ${$2ad24e75a96deccc$var$colors.gray[800]};
    }

    .helix-text-gray-900 {
        color: ${$2ad24e75a96deccc$var$colors.gray[900]};
    }
`;
const $2ad24e75a96deccc$var$StyledNavbarNav = (0, $lmFrL.default).nav`
    display: flex;
    overflow: hidden;
    white-space: nowrap;
    flex: 1 1 auto;
    justify-content: center;
    padding: 3px 0px;
    margin: 0 auto;
    .helix-unified-nav__navigation-items-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
    }
    a.helix-unified-nav__navigation-item {
        text-decoration: none;
    }
    .helix-unified-nav__navigation-item,
    .helix-unified-nav__navigation-item-dropdown-wrapper {
        + .helix-unified-nav__navigation-item,
        + .helix-unified-nav__overflow-button-wrapper,
        + .helix-unified-nav__navigation-item-dropdown-wrapper {
            margin-left: 12px;
        }
        @media screen and (max-width: 576px) {
            padding: 4px 6px;
            + .helix-unified-nav__navigation-item,
            + .helix-unified-nav__overflow-button-wrapper {
                margin-left: 4px;
            }
        }
    }
    .helix-unified-nav__overflow-button-wrapper,
    .helix-unified-nav__navigation-item-dropdown {
        svg {
            margin-left: 8px;
            margin-top: 2px;
            color: inherit;
            path {
                fill: currentColor !important;
            }
        }
    }
    .helix-unified-nav__overflow-button-wrapper {
        display: ${({ $hasOverflowItems: $hasOverflowItems })=>$hasOverflowItems ? "flex" : "none"};
    }
    ul.menu-item-list {
        margin: 0 auto;
        padding: 0;
        list-style: none;
        display: flex;
        justify-content: center;

        li {
            padding: 8px 12px;
            border-radius: 6px;
            &:hover,
            &.active {
                background-color: #f3f4f6;
            }
            &:focus {
                outline: solid 2px ${$2ad24e75a96deccc$var$colors.gray[300]};
            }
            + li {
                margin-left: 8px;
            }
        }
    }

    @media screen and (max-width: 576px) {
        visibility: hidden;
    }
`;
const $2ad24e75a96deccc$var$StyledNavbarBody = (0, $lmFrL.default).div`
    flex: 1 1;
`;
const $2ad24e75a96deccc$var$StyledNavbarAdditionalItems = (0, $lmFrL.default).div`
    margin-left: 12px;
    display: flex;
    flex: 0;
    justify-content: flex-end;
    ${({ $hasNavItems: $hasNavItems })=>!$hasNavItems && (0, $lmFrL.css)`
            justify-content: flex-end;
            align-items: center;
            flex: 1 1;
        `}
    a {
        text-decoration: none;
    }
    .helix-unified-nav__additional-nav-item {
        display: flex;
        align-items: center;
        border-radius: 6px;
        &.active:not(.helix-unified-nav__additional-user-menu-toggle) {
            background-color: ${({ $isDark: $isDark })=>$isDark ? "#374151" : "#E5E7EB"};
        }
        &:hover:not(.helix-unified-nav__additional-user-menu-toggle) {
            background-color: ${({ $isDark: $isDark })=>$isDark ? "#374151" : "#F3F4F6"};
        }
        &:focus {
            outline: solid 2px ${$2ad24e75a96deccc$var$colors.gray[300]};
        }
        i {
            font-size: 24px;
        }
    }

    a.helix-unified-nav__nav-button-link,
    button.helix-unified-nav__nav-button {
        display: inline-flex;
        flex: 0 0 auto;
        align-items: center;
        border: none;
        padding: 8px;
        border-radius: 6px;
        background-color: transparent;
        color: inherit;
        &.helix-unified-nav__nav-button-drawer {
            margin-right: 8px;
            ${({ $isDark: $isDark })=>$isDark && (0, $lmFrL.css)`
                    svg path:not(.alert-dot) {
                        fill: currentColor !important;
                    }
                `}
        }
        &.helix-unified-nav__nav-button-user {
            padding: 0;
            margin-left: 8px;
            border-radius: 50%;
            .helix-unified-nav__user-avatar {
                width: 32px;
                height: 32px;
                border-radius: 50%;
                overflow: hidden;
                display: flex;
                align-items: center;
                object-position: center center;
                img {
                    width: 32px;
                    height: 32px;
                    object-fit: cover;
                }
            }
            &.active {
                border: solid 2px ${({ $isDark: $isDark })=>$isDark ? "#374151" : "#D1D5DB"};
            }
        }
        &:focus {
            outline: solid 2px ${$2ad24e75a96deccc$var$colors.gray[300]};
        }

        &.active:not(.helix-unified-nav__nav-button-user) {
            background-color: ${({ $isDark: $isDark })=>$isDark ? "#374151" : "#E5E7EB"};
        }
        &:hover:not(.helix-unified-nav__nav-button-user) {
            background-color: ${({ $isDark: $isDark })=>$isDark ? "#374151" : "#F3F4F6"};
        }
    }

    ${({ $isDark: $isDark })=>$isDark && (0, $lmFrL.css)`
            svg.helix-icon path:not(.alert-dot) {
                fill: currentColor !important;
            }
        `}

    @media screen and (max-width: 576px) {
        display: none;
    }
`;
const $2ad24e75a96deccc$var$StyledUserMenu = (0, $lmFrL.default).div`
    svg.helix-icon path:not(.alert-dot) {
        fill: currentColor !important;
    }
`;
const $2ad24e75a96deccc$var$StyledNotificationMenu = (0, $lmFrL.default).div``;
const $2ad24e75a96deccc$var$StyledMobileMenu = (0, $lmFrL.default).div`
    display: none;
    margin-left: 12px;
    .helix-unified-nav__navigation-item + .helix-unified-nav__navigation-item {
        margin-left: 12px;
    }
    @media screen and (max-width: 576px) {
        justify-content: flex-end;
        display: flex;
        ${({ $hasNavItems: $hasNavItems })=>!$hasNavItems && (0, $lmFrL.css)`
                flex: 1 1;
            `}
    }
`;
const $2ad24e75a96deccc$var$StyledMobileMenuPanel = (0, $lmFrL.default).div`
    position: fixed;
    height: calc(100vh - 60px);
    left: 0;
    top: 60px;
    right: 0;
    bottom: 0;
    background-color: #fff;
    padding: 8px;
    box-sizing: border-box;
    border-top: 1px solid #e5e7eb;
    overflow: auto;
    .helix-unified-navbar__panel-header {
        font-size: 20px;
        line-height: 26px;
        font-weight: 600;
        margin: 16px 8px;
        display: block;
        color: #111827;
    }
    .helix-unified-navbar__mobile-menu-profile-item {
        padding: 8px;
        display: flex;
        .helix-unified-nav__user-avatar {
            width: 32px;
            height: 32px;
            border-radius: 50%;
            overflow: hidden;
            display: flex;
            align-items: center;
            object-position: center center;
            img {
                width: 32px;
                height: 32px;
                object-fit: cover;
            }
        }
        .helix-unified-navbar__mobile-menu-user-info {
            display: flex;
            flex-flow: column;
            margin-left: 12px;
            color: #111827;
            .helix-unified-navbar__mobile-menu-user-info-name {
                font-weight: 600;
            }
        }
    }

    .helix-unified-navbar__mobile-menu-header {
        display: flex;
        font-weight: 600;
        padding: 8px;
        align-items: center;
        text-transform: uppercase;
        font-size: 12px;
        color: #111827;
    }
    .helix-unified-navbar__mobile-menu-item {
        display: flex;
        margin-bottom: 2px;
        border-radius: 4px;
        &.helix-unified-navbar__mobile-menu-help-item {
            svg {
                margin-right: 8px;
            }
        }
        &.item-read-only {
            cursor: default;
            pointer-events: none;
        }
        &.disabled {
            opacity: 0.5;
            pointer-events: none;
            cursor: default;
        }
        &:focus-within {
            outline: solid 2px ${$2ad24e75a96deccc$var$colors.gray[300]};
        }
        &:focus-within,
        &:hover {
            color: #374151;
            background-color: #f3f4f6;
            text-decoration: none;
        }
        &.active {
            color: #111827;
            background-color: #e5e7eb;
        }

        &.item-read-only {
            cursor: default;
            pointer-events: none;
        }

        .helix-unified-nav__mobile-menu-dropdown-button,
        a,
        .helix-unified-navbar__mobile-menu-notification-item,
        .read-only-item-wrapper {
            width: 100%;
            display: flex;
            align-items: center;
            font-size: inherit;
            text-decoration: none;
            color: #111827;
            font-weight: 400;
            -webkit-font-smoothing: antialiased;
            border-radius: 4px;
            padding: 8px;
            &.helix-unified-navbar__mobile-menu-notification-item {
                font-weight: normal;
            }
            &.helix-unified-nav__mobile-menu-dropdown-toggle {
                display: flex;
                .helix-unified-nav__mobile-menu-label {
                    flex: 1 1;
                    text-align: left;
                }
            }
            &:focus {
                outline: none;
            }
            &.helix-unified-nav__mobile-menu-dropdown--with-badge {
                justify-content: space-between;
            }
            a {
                padding: 0;
            }
            &.read-only-item {
                cursor: default;
                pointer-events: none;
            }
            &.active {
                color: #111827;
                background-color: #e5e7eb;
            }
        }
        button {
            background-color: transparent;
            border: none;
            &:focus {
                color: #374151;
                text-decoration: none;
            }
            &:focus {
                outline: none;
            }
            &.helix-unified-navbar__mobile-menu-item-dropdown {
                svg {
                    margin-left: 8px;
                }
            }
        }
        &.helix-unified-navbar__mobile-sub-menu-item {
            margin-left: 12px;
        }
        .helix-unified-navbar__mobile-menu-divider {
            border-top: 1px solid #e5e7eb;
            margin: 8px 0;
        }
    }
    .empty-state {
        padding: 8px;
        text-align: center;
    }
    .helix-unified-navbar__mobile-menu-notification-item {
        margin: 2px 0;
    }
    hr {
        border-top: 1px solid #e5e7eb;
        margin: 1rem 0;
    }
`;
const $2ad24e75a96deccc$var$StyledCustomDropdownSection = (0, $lmFrL.default).div`
    padding-left: 12px;
`;
/* eslint-disable @typescript-eslint/no-explicit-any */ const $2ad24e75a96deccc$var$NavbarContext = (0, $acw62.createContext)({
    isDark: false,
    logoUrl: "/",
    hideLogo: false,
    navItems: [],
    setNavItems: ()=>null,
    userMenuItems: [],
    setUserMenuItems: ()=>null,
    notificationMenuItems: [],
    setNotificationMenuItems: ()=>null,
    helpUrl: "",
    setHelpUrl: ()=>null,
    helpTarget: "",
    setHelpTarget: ()=>null,
    helpMenuItems: [],
    setHelpMenuItems: ()=>null,
    location: "",
    setLocation: ()=>null,
    helpMenuLocation: "",
    setHelpMenuLocation: ()=>null,
    userMenuLocation: "",
    setUserMenuLocation: ()=>null,
    showAlertIconBadge: false,
    setShowAlertIconBadge: ()=>null,
    notificationItemFormatter: ()=>null,
    setNotificationItemFormatter: ()=>null,
    noNotificationMessage: "",
    setNoNotificationMessage: ()=>null,
    hasBody: false,
    setHasBody: ()=>null,
    hasAdditionalNavItems: false,
    setHasAdditionalNavItems: ()=>null,
    hasNotificationMenu: false,
    setHasNotificationMenu: ()=>null,
    navbarLinkWrapper: null,
    setNavbarLinkWrapper: ()=>null,
    helpItemLinkWrapper: undefined,
    setHelpItemLinkWrapper: ()=>null,
    helpDropdownItemLinkWrapper: undefined,
    setHelpDropdownItemLinkWrapper: ()=>null,
    userMenuLinkWrapper: undefined,
    setUserMenuLinkWrapper: ()=>null,
    notificationMenuLinkWrapper: undefined,
    setNotificationMenuLinkWrapper: ()=>null,
    userInfo: null,
    setUserInfo: ()=>null,
    dropdownsExpandedByDefault: false,
    setDropdownsExpandedByDefault: ()=>null,
    appSwitcherItems: [],
    setAppSwitcherItems: ()=>null,
    showMobileMenu: false,
    setShowMobileMenu: ()=>null,
    showMobileNotifications: false,
    setShowMobileNotifications: ()=>null,
    showMobileApplicationSwitcher: false,
    setShowMobileApplicationSwitcher: ()=>null,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    notificationMenuOnClick: ()=>{},
    setNotificationMenuOnClick: ()=>null,
    customMobileMenu: null,
    hideHelpMenuHeader: false,
    setHideHelpMenuHeader: ()=>null,
    appInstancesOpen: [],
    setAppInstancesOpen: ()=>null,
    appSwitcherLinkWrapper: undefined,
    setAppSwitcherLinkWrapper: ()=>null,
    launchpadUrl: "",
    setLaunchpadUrl: ()=>null,
    logoImageUrl: "",
    setLogoImageUrl: ()=>null,
    applicationName: "TransactionDesk",
    setApplicationName: ()=>null,
    environment: "dev",
    localStorageTokenKey: "lwaToken"
});
$2ad24e75a96deccc$var$NavbarContext.Consumer;
const $2ad24e75a96deccc$var$NavbarProvider = ({ children: children, isDark: isDark, logoUrl: logoUrl, hideLogo: hideLogo, customMobileMenu: customMobileMenu, isMobileMenuOpen: isMobileMenuOpen, onMobileMenuToggle: onMobileMenuToggle, applicationName: applicationName = "", activeClientId: activeClientId = "", environment: environment, localStorageTokenKey: localStorageTokenKey = "lwaToken", applicationCode: applicationCode, platformService: platformService })=>{
    const [navItems, setNavItems] = (0, $acw62.useState)([]);
    const [helpUrl, setHelpUrl] = (0, $acw62.useState)("");
    const [helpTarget, setHelpTarget] = (0, $acw62.useState)("");
    const [helpMenuItems, setHelpMenuItems] = (0, $acw62.useState)([]);
    const [userMenuItems, setUserMenuItems] = (0, $acw62.useState)([]);
    const [appSwitcherItems, setAppSwitcherItems] = (0, $acw62.useState)([]);
    const [location, setLocation] = (0, $acw62.useState)("");
    const [helpMenuLocation, setHelpMenuLocation] = (0, $acw62.useState)("");
    const [userMenuLocation, setUserMenuLocation] = (0, $acw62.useState)("");
    const [notificationMenuItems, setNotificationMenuItems] = (0, $acw62.useState)(null);
    const [showAlertIconBadge, setShowAlertIconBadge] = (0, $acw62.useState)(false);
    const [showMobileNotifications, setShowMobileNotifications] = (0, $acw62.useState)(false);
    const [showMobileMenu, setShowMobileMenu] = (0, $acw62.useState)(isMobileMenuOpen);
    const [showMobileApplicationSwitcher, setShowMobileApplicationSwitcher] = (0, $acw62.useState)(false);
    const [notificationItemFormatter, setNotificationItemFormatter] = (0, $acw62.useState)(null);
    const [noNotificationMessage, setNoNotificationMessage] = (0, $acw62.useState)("");
    const [hasBody, setHasBody] = (0, $acw62.useState)(false);
    const [hasAdditionalNavItems, setHasAdditionalNavItems] = (0, $acw62.useState)(false);
    const [hasNotificationMenu, setHasNotificationMenu] = (0, $acw62.useState)(false);
    const [navbarLinkWrapper, setNavbarLinkWrapper] = (0, $acw62.useState)(null);
    const [helpItemLinkWrapper, setHelpItemLinkWrapper] = (0, $acw62.useState)(null);
    const [helpDropdownItemLinkWrapper, setHelpDropdownItemLinkWrapper] = (0, $acw62.useState)(null);
    const [notificationMenuLinkWrapper, setNotificationMenuLinkWrapper] = (0, $acw62.useState)(null);
    const [userMenuLinkWrapper, setUserMenuLinkWrapper] = (0, $acw62.useState)(null);
    const [userInfo, setUserInfo] = (0, $acw62.useState)(null);
    const [dropdownsExpandedByDefault, setDropdownsExpandedByDefault] = (0, $acw62.useState)(false);
    const [notificationMenuOnClick, setNotificationMenuOnClick] = (0, $acw62.useState)(null);
    const [hideHelpMenuHeader, setHideHelpMenuHeader] = (0, $acw62.useState)(false);
    const [appInstancesOpen, setAppInstancesOpen] = (0, $acw62.useState)([]);
    const [appSwitcherLinkWrapper, setAppSwitcherLinkWrapper] = (0, $acw62.useState)(null);
    const [launchpadUrl, setLaunchpadUrl] = (0, $acw62.useState)("");
    const [applicationNameState, setApplicationName] = (0, $acw62.useState)(applicationName);
    const [activeClientIdState, setActiveClientId] = (0, $acw62.useState)(activeClientId);
    const [brandingLoading, setBrandingLoading] = (0, $acw62.useState)(false);
    const [logoImageUrl, setLogoImageUrl] = (0, $acw62.useState)("");
    (0, $acw62.useEffect)(()=>{
        setShowMobileMenu(isMobileMenuOpen);
    }, [
        isMobileMenuOpen
    ]);
    const isMounted = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        if (!isMounted.current) {
            isMounted.current = true;
            return;
        }
        onMobileMenuToggle && onMobileMenuToggle(showMobileMenu);
    }, [
        showMobileMenu
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarContext.Provider, {
        value: {
            isDark: isDark,
            logoUrl: logoUrl,
            hideLogo: hideLogo,
            navItems: navItems,
            setNavItems: setNavItems,
            userMenuItems: userMenuItems,
            setUserMenuItems: setUserMenuItems,
            notificationMenuItems: notificationMenuItems,
            setNotificationMenuItems: setNotificationMenuItems,
            helpUrl: helpUrl,
            setHelpUrl: setHelpUrl,
            helpTarget: helpTarget,
            setHelpTarget: setHelpTarget,
            helpMenuItems: helpMenuItems,
            setHelpMenuItems: setHelpMenuItems,
            location: location,
            setLocation: setLocation,
            helpMenuLocation: helpMenuLocation,
            setHelpMenuLocation: setHelpMenuLocation,
            userMenuLocation: userMenuLocation,
            setUserMenuLocation: setUserMenuLocation,
            showAlertIconBadge: showAlertIconBadge,
            setShowAlertIconBadge: setShowAlertIconBadge,
            notificationItemFormatter: notificationItemFormatter,
            setNotificationItemFormatter: setNotificationItemFormatter,
            noNotificationMessage: noNotificationMessage,
            setNoNotificationMessage: setNoNotificationMessage,
            hasBody: hasBody,
            setHasBody: setHasBody,
            hasAdditionalNavItems: hasAdditionalNavItems,
            setHasAdditionalNavItems: setHasAdditionalNavItems,
            hasNotificationMenu: hasNotificationMenu,
            setHasNotificationMenu: setHasNotificationMenu,
            userMenuLinkWrapper: userMenuLinkWrapper,
            setUserMenuLinkWrapper: setUserMenuLinkWrapper,
            helpItemLinkWrapper: helpItemLinkWrapper,
            setHelpItemLinkWrapper: setHelpItemLinkWrapper,
            helpDropdownItemLinkWrapper: helpDropdownItemLinkWrapper,
            setHelpDropdownItemLinkWrapper: setHelpDropdownItemLinkWrapper,
            navbarLinkWrapper: navbarLinkWrapper,
            setNavbarLinkWrapper: setNavbarLinkWrapper,
            notificationMenuLinkWrapper: notificationMenuLinkWrapper,
            setNotificationMenuLinkWrapper: setNotificationMenuLinkWrapper,
            userInfo: userInfo,
            setUserInfo: setUserInfo,
            dropdownsExpandedByDefault: dropdownsExpandedByDefault,
            setDropdownsExpandedByDefault: setDropdownsExpandedByDefault,
            appSwitcherItems: appSwitcherItems,
            setAppSwitcherItems: setAppSwitcherItems,
            showMobileMenu: showMobileMenu,
            setShowMobileMenu: setShowMobileMenu,
            showMobileNotifications: showMobileNotifications,
            setShowMobileNotifications: setShowMobileNotifications,
            showMobileApplicationSwitcher: showMobileApplicationSwitcher,
            setShowMobileApplicationSwitcher: setShowMobileApplicationSwitcher,
            notificationMenuOnClick: notificationMenuOnClick,
            setNotificationMenuOnClick: setNotificationMenuOnClick,
            customMobileMenu: customMobileMenu,
            hideHelpMenuHeader: hideHelpMenuHeader,
            setHideHelpMenuHeader: setHideHelpMenuHeader,
            appInstancesOpen: appInstancesOpen,
            setAppInstancesOpen: setAppInstancesOpen,
            appSwitcherLinkWrapper: appSwitcherLinkWrapper,
            setAppSwitcherLinkWrapper: setAppSwitcherLinkWrapper,
            launchpadUrl: launchpadUrl,
            setLaunchpadUrl: setLaunchpadUrl,
            logoImageUrl: logoImageUrl,
            setLogoImageUrl: setLogoImageUrl,
            applicationName: applicationNameState,
            setApplicationName: setApplicationName,
            brandingLoading: brandingLoading,
            setBrandingLoading: setBrandingLoading,
            activeClientId: activeClientIdState,
            setActiveClientId: setActiveClientId,
            environment: environment,
            localStorageTokenKey: localStorageTokenKey,
            applicationCode: applicationCode,
            platformService: platformService
        }
    }, children);
};
/* eslint-disable max-len */ const $2ad24e75a96deccc$var$bellIcon = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    className: "helix-icon alert_bell",
    xmlns: "http://www.w3.org/2000/svg"
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25 8.75C4.25 5.57436 6.82436 3 10 3C13.1756 3 15.75 5.57436 15.75 8.75V10.0368C15.75 11.0058 16.0368 11.9532 16.5743 12.7594L17.624 14.334C17.7775 14.5641 17.7918 14.86 17.6613 15.1039C17.5307 15.3478 17.2766 15.5 17 15.5H12.7388C12.6125 16.9016 11.4345 18 10 18C8.56549 18 7.38752 16.9016 7.26121 15.5H3C2.7234 15.5 2.46926 15.3478 2.33875 15.1039C2.20823 14.86 2.22254 14.5641 2.37596 14.334L3.42568 12.7594C3.96318 11.9532 4.25 11.0058 4.25 10.0368V8.75ZM8.77501 15.5C8.89082 16.0706 9.39526 16.5 10 16.5C10.6047 16.5 11.1092 16.0706 11.225 15.5H8.77501ZM10 4.5C7.65279 4.5 5.75 6.40279 5.75 8.75V10.0368C5.75 11.302 5.37552 12.5388 4.67375 13.5915L4.40139 14H15.5986L15.3263 13.5915C14.6245 12.5388 14.25 11.302 14.25 10.0368V8.75C14.25 6.40279 12.3472 4.5 10 4.5Z",
    fill: "#4B5563"
}));
const $2ad24e75a96deccc$var$open_door = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true"
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M10 10.75C10 11.1642 9.66421 11.5 9.25 11.5C8.83579 11.5 8.5 11.1642 8.5 10.75C8.5 10.3357 8.83579 9.99995 9.25 9.99995C9.66421 9.99995 10 10.3357 10 10.75Z",
    fill: "#4B5563"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25 4.99994C4.25 4.03344 5.0335 3.24994 6 3.24994H13C13.9665 3.24994 14.75 4.03344 14.75 4.99994V16.2499H16C16.4142 16.2499 16.75 16.5857 16.75 16.9999C16.75 17.4142 16.4142 17.7499 16 17.7499H3C2.58579 17.7499 2.25 17.4142 2.25 16.9999C2.25 16.5857 2.58579 16.2499 3 16.2499H4.25V4.99994ZM5.75 16.2499H10.75V4.74994H6C5.86193 4.74994 5.75 4.86187 5.75 4.99994V16.2499ZM12.25 4.74994V16.2499H13.25V4.99994C13.25 4.86187 13.1381 4.74994 13 4.74994H12.25Z",
    fill: "#4B5563"
}));
const $2ad24e75a96deccc$var$bellNotificationIcon = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    className: "helix-icon alert_bell_badge",
    xmlns: "http://www.w3.org/2000/svg"
}, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6444 7.64744C15.7137 8.00428 15.75 8.3729 15.75 8.75V10.0368C15.75 11.0058 16.0368 11.9532 16.5743 12.7594L17.624 14.334C17.7775 14.5641 17.7918 14.86 17.6613 15.1039C17.5307 15.3478 17.2766 15.5 17 15.5H12.7388C12.6125 16.9016 11.4345 18 10 18C8.56549 18 7.38752 16.9016 7.26121 15.5H3C2.7234 15.5 2.46926 15.3478 2.33875 15.1039C2.20823 14.86 2.22254 14.5641 2.37596 14.334L3.42568 12.7594C3.96318 11.9532 4.25 11.0058 4.25 10.0368V8.75C4.25 5.57436 6.82436 3 10 3C10.042 3 10.0839 3.00045 10.1257 3.00135C10.0436 3.32056 10 3.65519 10 4C10 4.16937 10.0105 4.33628 10.031 4.50011C10.0206 4.50004 10.0103 4.5 10 4.5C7.65279 4.5 5.75 6.40279 5.75 8.75V10.0368C5.75 11.302 5.37552 12.5388 4.67375 13.5915L4.40139 14H15.5986L15.3263 13.5915C14.6245 12.5388 14.25 11.302 14.25 10.0368V8.75C14.25 8.49264 14.2271 8.24063 14.1833 7.99588C14.7022 7.97247 15.1954 7.8502 15.6444 7.64744ZM10 16.5C9.39526 16.5 8.89082 16.0706 8.77501 15.5H11.225C11.1092 16.0706 10.6047 16.5 10 16.5Z",
    fill: "#4B5563"
}), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
    d: "M17 4C17 5.65685 15.6569 7 14 7C12.3431 7 11 5.65685 11 4C11 2.34315 12.3431 1 14 1C15.6569 1 17 2.34315 17 4Z",
    fill: "#DC2626",
    className: "alert-dot"
}));
const $2ad24e75a96deccc$var$circleQuestionIcon = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
    icon: (0, $c761e69c8e58189a$exports.circle_question)
});
const $2ad24e75a96deccc$var$compareIcon = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
    icon: (0, $c761e69c8e58189a$exports.home_compare)
});
const $2ad24e75a96deccc$var$closeIcon = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
    icon: (0, $c761e69c8e58189a$exports.x)
});
const $2ad24e75a96deccc$var$chevronSmallDownIcon = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
    icon: (0, $c761e69c8e58189a$exports.chevron_small_down)
});
const $2ad24e75a96deccc$var$chevronSmallUpIcon = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
    icon: (0, $c761e69c8e58189a$exports.chevron_small_up)
});
const $2ad24e75a96deccc$var$chevronSmallRightIcon = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
    icon: (0, $c761e69c8e58189a$exports.chevron_small_right)
});
const $2ad24e75a96deccc$var$searchUserIcon = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
    icon: (0, $c761e69c8e58189a$exports.search_user)
});
const $2ad24e75a96deccc$var$arrowsExchangeIcon = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
    icon: (0, $c761e69c8e58189a$exports.arrows_exchange)
});
const $2ad24e75a96deccc$var$bankInstitutionIcon = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
    icon: (0, $c761e69c8e58189a$exports.building_bank)
});
const $2ad24e75a96deccc$var$arrowChartLineIcon = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
    icon: (0, $c761e69c8e58189a$exports.arrow_chart_line)
});
const $2ad24e75a96deccc$var$drawerOpenIcon = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
    icon: (0, $c761e69c8e58189a$exports.drawer_open)
});
const $2ad24e75a96deccc$var$drawerCloseIcon = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
    icon: (0, $c761e69c8e58189a$exports.drawer_close)
});
const $2ad24e75a96deccc$var$checkmarkIcon = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
    icon: (0, $c761e69c8e58189a$exports.checkmark)
});
const $2ad24e75a96deccc$var$icons = {
    arrow_left: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
        icon: (0, $c761e69c8e58189a$exports.arrow_left)
    }),
    close: $2ad24e75a96deccc$var$closeIcon,
    x: $2ad24e75a96deccc$var$closeIcon,
    menu: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
        icon: (0, $c761e69c8e58189a$exports.menu)
    }),
    alert: $2ad24e75a96deccc$var$bellIcon,
    bell: $2ad24e75a96deccc$var$bellIcon,
    alert_badge: $2ad24e75a96deccc$var$bellNotificationIcon,
    bell_notification: $2ad24e75a96deccc$var$bellNotificationIcon,
    question_help: $2ad24e75a96deccc$var$circleQuestionIcon,
    circle_question: $2ad24e75a96deccc$var$circleQuestionIcon,
    dropdown_open: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
        icon: (0, $c761e69c8e58189a$exports.chevron_small_down)
    }),
    chevron_small_down: $2ad24e75a96deccc$var$chevronSmallDownIcon,
    dropdown_open_inverted: $2ad24e75a96deccc$var$chevronSmallUpIcon,
    chevron_small_up: $2ad24e75a96deccc$var$chevronSmallUpIcon,
    dropdown_closed: $2ad24e75a96deccc$var$chevronSmallRightIcon,
    chevron_small_right: $2ad24e75a96deccc$var$chevronSmallRightIcon,
    compare: $2ad24e75a96deccc$var$compareIcon,
    home_compare: $2ad24e75a96deccc$var$compareIcon,
    megaphone: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
        icon: (0, $c761e69c8e58189a$exports.megaphone)
    }),
    agent: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
        icon: (0, $c761e69c8e58189a$exports.agent)
    }),
    tenant_screening: $2ad24e75a96deccc$var$searchUserIcon,
    search_user: $2ad24e75a96deccc$var$searchUserIcon,
    transaction: $2ad24e75a96deccc$var$arrowsExchangeIcon,
    arrows_exchange: $2ad24e75a96deccc$var$arrowsExchangeIcon,
    bank_institution: $2ad24e75a96deccc$var$bankInstitutionIcon,
    building_bank: $2ad24e75a96deccc$var$bankInstitutionIcon,
    stats: $2ad24e75a96deccc$var$arrowChartLineIcon,
    arrow_chart_line: $2ad24e75a96deccc$var$arrowChartLineIcon,
    home_chart: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
        icon: (0, $c761e69c8e58189a$exports.home_chart)
    }),
    open_drawer: $2ad24e75a96deccc$var$drawerOpenIcon,
    drawer_open: $2ad24e75a96deccc$var$drawerOpenIcon,
    close_drawer: $2ad24e75a96deccc$var$drawerCloseIcon,
    drawer_close: $2ad24e75a96deccc$var$drawerCloseIcon,
    search: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
        icon: (0, $c761e69c8e58189a$exports.search)
    }),
    cards: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
        icon: (0, $c761e69c8e58189a$exports.cards)
    }),
    app_grid: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
        icon: (0, $c761e69c8e58189a$exports.app_grid)
    }),
    cog_person: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
        icon: (0, $c761e69c8e58189a$exports.cog_person)
    }),
    funnel_person: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
        icon: (0, $c761e69c8e58189a$exports.funnel_person)
    }),
    house_mobile: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
        icon: (0, $c761e69c8e58189a$exports.house_mobile)
    }),
    sign_in_ground: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
        icon: (0, $c761e69c8e58189a$exports.sign_in_ground)
    }),
    document_signed: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
        icon: (0, $c761e69c8e58189a$exports.document_signed)
    }),
    workspace: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
        icon: (0, $c761e69c8e58189a$exports.workspace)
    }),
    store: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
        icon: (0, $c761e69c8e58189a$exports.store)
    }),
    line_chart: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
        icon: (0, $c761e69c8e58189a$exports.line_chart)
    }),
    screen_percentage: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
        icon: (0, $c761e69c8e58189a$exports.screen_percentage)
    }),
    screen_bar_chart: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
        icon: (0, $c761e69c8e58189a$exports.screen_bar_chart)
    }),
    circle_user_checkmark: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
        icon: (0, $c761e69c8e58189a$exports.circle_user_checkmark)
    }),
    percentage: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
        icon: (0, $c761e69c8e58189a$exports.percentage)
    }),
    search_home: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
        icon: (0, $c761e69c8e58189a$exports.search_home)
    }),
    open_door: $2ad24e75a96deccc$var$open_door,
    signature: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
        icon: (0, $c761e69c8e58189a$exports.signature)
    }),
    banking_reconciliation: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
        icon: (0, $c761e69c8e58189a$exports.banking_reconciliation)
    }),
    transaction_workflow: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
        icon: (0, $c761e69c8e58189a$exports.transaction_workflow)
    }),
    magnet: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
        icon: (0, $c761e69c8e58189a$exports.magnet)
    }),
    user: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
        icon: (0, $c761e69c8e58189a$exports.user)
    }),
    line_chart_loop: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
        icon: (0, $c761e69c8e58189a$exports.line_chart_loop)
    }),
    person_frame: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
        icon: (0, $c761e69c8e58189a$exports.person_frame)
    }),
    checkmark: $2ad24e75a96deccc$var$checkmarkIcon
};
const $2ad24e75a96deccc$var$NavbarHelixIcon = ({ iconName: iconName })=>{
    return $2ad24e75a96deccc$var$icons[iconName] || null;
};
const $2ad24e75a96deccc$var$NavbarExpandButton = ({ expandIconActive: expandIconActive, onExpandIconClick: onExpandIconClick })=>{
    const { setShowMobileApplicationSwitcher: setShowMobileApplicationSwitcher, setShowMobileNotifications: setShowMobileNotifications, setShowMobileMenu: setShowMobileMenu } = (0, $acw62.useContext)($2ad24e75a96deccc$var$NavbarContext);
    const handleNavbarExpandButtonClick = ()=>{
        onExpandIconClick && onExpandIconClick();
        setShowMobileApplicationSwitcher(false);
        setShowMobileNotifications(false);
        setShowMobileMenu(false);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        "aria-label": expandIconActive ? "Collapse" : "Expand",
        className: "helix-unified-nav__nav-button helix-unified-nav__nav-button-drawer",
        onClick: ()=>handleNavbarExpandButtonClick()
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarHelixIcon, {
        iconName: expandIconActive ? "close_drawer" : "open_drawer"
    }));
};
var $2ad24e75a96deccc$var$classnames = {
    exports: {}
};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ (function(module) {
    /* global define */ (function() {
        var hasOwn = {}.hasOwnProperty;
        function classNames() {
            var classes = "";
            for(var i = 0; i < arguments.length; i++){
                var arg = arguments[i];
                if (arg) classes = appendClass(classes, parseValue(arg));
            }
            return classes;
        }
        function parseValue(arg) {
            if (typeof arg === "string" || typeof arg === "number") return arg;
            if (typeof arg !== "object") return "";
            if (Array.isArray(arg)) return classNames.apply(null, arg);
            if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) return arg.toString();
            var classes = "";
            for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
            return classes;
        }
        function appendClass(value, newClass) {
            if (!newClass) return value;
            if (value) return value + " " + newClass;
            return value + newClass;
        }
        if (module.exports) {
            classNames.default = classNames;
            module.exports = classNames;
        } else window.classNames = classNames;
    })();
})($2ad24e75a96deccc$var$classnames);
var $2ad24e75a96deccc$var$classNames = $2ad24e75a96deccc$var$classnames.exports;
function $2ad24e75a96deccc$var$styleInject(css, ref) {
    if (ref === void 0) ref = {};
    var insertAt = ref.insertAt;
    if (!css || typeof document === "undefined") return;
    var head = document.head || document.getElementsByTagName("head")[0];
    var style = document.createElement("style");
    style.type = "text/css";
    if (insertAt === "top") {
        if (head.firstChild) head.insertBefore(style, head.firstChild);
        else head.appendChild(style);
    } else head.appendChild(style);
    if (style.styleSheet) style.styleSheet.cssText = css;
    else style.appendChild(document.createTextNode(css));
}
var $2ad24e75a96deccc$var$css_248z$3 = ".Alert-module_helix-alert__Z0CGc{align-items:center;background-color:var(--helix-alert-bg,#f5f5f5);border:1px solid transparent;color:var(--helix-alert-text,#111);display:flex;flex:1 1 auto;font-size:14px;justify-content:center;opacity:1;padding:18px;transition:opacity .3s ease-in-out}.Alert-module_helix-alert--dismissing__JnRfY{opacity:0}.Alert-module_helix-alert--secondary__1b6yj{--helix-alert-bg:var(--helix-gray-50,#f5f5f5);--helix-alert-text:var(--helix-gray-900,#1f2937);--helix-alert-border:var(--helix-gray-200,#e5e7eb);--helix-alert-icon:var(--helix-gray-600,#1f2937)}.Alert-module_helix-alert--success__zobYI{--helix-alert-bg:var(--helix-green-50,#ecfdf5);--helix-alert-text:var(--helix-green-900,#064e3b);--helix-alert-border:var(--helix-green-100,#bbf7d0);--helix-alert-icon:var(--helix-green-600,#064e3b)}.Alert-module_helix-alert--warning__qGTSW{--helix-alert-bg:var(--helix-yellow-50,#fff7ed);--helix-alert-text:var(--helix-yellow-900,#92400e);--helix-alert-border:var(--helix-yellow-100,#ffedd5);--helix-alert-icon:var(--helix-yellow-600,#92400e)}.Alert-module_helix-alert--danger__b9D5P{--helix-alert-bg:var(--helix-red-50,#fff1f2);--helix-alert-text:var(--helix-red-900,#7f1d1d);--helix-alert-border:var(--helix-red-100,#fecaca);--helix-alert-icon:var(--helix-red-600,#7f1d1d)}.Alert-module_helix-alert--info__71bdw{--helix-alert-bg:var(--helix-blue-50,#eff6ff);--helix-alert-text:var(--helix-blue-900,#1e3a8a);--helix-alert-border:var(--helix-blue-100,#bfdbfe);--helix-alert-icon:var(--helix-blue-600,#1e3a8a)}.Alert-module_helix-alert__label-text__4-Pfd{font-weight:600;margin-right:6px}.Alert-module_helix-alert__icon__bAuhH{align-items:center;display:inline-flex;justify-content:center;margin-right:12px}.Alert-module_helix-alert__content__L4YQy{align-items:center;display:flex;flex:1 1 auto;justify-content:center}.Alert-module_helix-alert__message__oYln0{flex:1 1 auto;text-align:center}.Alert-module_helix-alert__close__ivIT7{align-items:center;appearance:none;-webkit-appearance:none;background-color:transparent;border:none;border-radius:4px;cursor:pointer;display:flex;margin-left:auto}.Alert-module_helix-alert__close__ivIT7:focus{outline:solid 2px var(--helix-brand)}.Alert-module_helix-alert__Z0CGc path,.Alert-module_helix-alert__Z0CGc svg{fill:var(--helix-alert-icon)!important}.Alert-module_helix-alert__close__ivIT7 path,.Alert-module_helix-alert__close__ivIT7 svg{fill:var(--helix-alert-text)!important}\n/*# sourceMappingURL=data:application/json;base64,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 */";
var $2ad24e75a96deccc$var$styles$2 = {
    "helix-alert": "Alert-module_helix-alert__Z0CGc",
    "helix-alert--dismissing": "Alert-module_helix-alert--dismissing__JnRfY",
    "helix-alert--secondary": "Alert-module_helix-alert--secondary__1b6yj",
    "helix-alert--success": "Alert-module_helix-alert--success__zobYI",
    "helix-alert--warning": "Alert-module_helix-alert--warning__qGTSW",
    "helix-alert--danger": "Alert-module_helix-alert--danger__b9D5P",
    "helix-alert--info": "Alert-module_helix-alert--info__71bdw",
    "helix-alert__label-text": "Alert-module_helix-alert__label-text__4-Pfd",
    "helix-alert__icon": "Alert-module_helix-alert__icon__bAuhH",
    "helix-alert__content": "Alert-module_helix-alert__content__L4YQy",
    "helix-alert__message": "Alert-module_helix-alert__message__oYln0",
    "helix-alert__close": "Alert-module_helix-alert__close__ivIT7"
};
$2ad24e75a96deccc$var$styleInject($2ad24e75a96deccc$var$css_248z$3);
const $2ad24e75a96deccc$var$translations$1 = {
    en: {
        close: "Close",
        typeLabels: {
            secondary: "Notice",
            success: "Success",
            warning: "Warning",
            danger: "Danger",
            info: "Information"
        }
    },
    fr: {
        close: "Fermer",
        typeLabels: {
            secondary: "Avis",
            success: "Succ\xe8s",
            warning: "Avertissement",
            danger: "Danger",
            info: "Information"
        }
    }
};
const $2ad24e75a96deccc$var$Alert = (0, $acw62.forwardRef)((_a, ref)=>{
    var _b, _c, _d;
    var { type: type = "secondary", dataLwtId: dataLwtId, label: label, children: children, className: className, dismissible: dismissible = true, onDismiss: onDismiss, isOpen: isOpen = true, labels: labels, locale: locale } = _a, rest = $2ad24e75a96deccc$var$__rest(_a, [
        "type",
        "dataLwtId",
        "label",
        "children",
        "className",
        "dismissible",
        "onDismiss",
        "isOpen",
        "labels",
        "locale"
    ]);
    const [show, setShow] = (0, $acw62.useState)(isOpen);
    const [dismissing, setDismissing] = (0, $acw62.useState)(false);
    const optionalProps = {};
    if (dataLwtId) optionalProps["data-lwt-id"] = dataLwtId;
    let providerLocale;
    try {
        const ctx = (0, $e7307bc387b4b3a0$export$c1fd9f444a3dc711)();
        providerLocale = ctx === null || ctx === void 0 ? void 0 : ctx.language;
    } catch (e) {
        providerLocale = undefined;
    }
    const effectiveLocale = locale || providerLocale || "en";
    const t = (_b = $2ad24e75a96deccc$var$translations$1[effectiveLocale]) !== null && _b !== void 0 ? _b : $2ad24e75a96deccc$var$translations$1.en;
    const closeLabel = (_c = labels === null || labels === void 0 ? void 0 : labels.close) !== null && _c !== void 0 ? _c : t.close;
    (_d = labels === null || labels === void 0 ? void 0 : labels.typeLabel) !== null && _d !== void 0 ? _d : t.typeLabels[type];
    // returning timeout to allow for clean up if used within a useEffect
    const dismiss = ()=>{
        setDismissing(true);
        const timeout = setTimeout(()=>{
            setShow(false);
        }, 300);
        if (onDismiss) onDismiss();
        return timeout;
    };
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            api: {
                dismiss: dismiss
            }
        }));
    (0, $acw62.useEffect)(()=>{
        if (isOpen) {
            setDismissing(false);
            setShow(isOpen);
        } else {
            const timeout = dismiss();
            return ()=>clearTimeout(timeout);
        }
    }, [
        isOpen
    ]);
    const getIcon = ()=>{
        switch(type){
            case "info":
                return 0, $1d43c7fb5c1d248f$exports.circle_info;
            case "success":
                return 0, $1d43c7fb5c1d248f$exports.circle_checkmark;
            case "danger":
                return 0, $1d43c7fb5c1d248f$exports.diamond_exclamation;
            case "secondary":
            default:
                return 0, $1d43c7fb5c1d248f$exports.warning;
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, show && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        role: "alert",
        "aria-live": "assertive",
        "aria-atomic": "true"
    }, optionalProps, rest, {
        className: $2ad24e75a96deccc$var$classNames($2ad24e75a96deccc$var$styles$2["helix-alert"], $2ad24e75a96deccc$var$styles$2[`helix-alert--${type}`], {
            [$2ad24e75a96deccc$var$styles$2["helix-alert--dismissing"]]: dismissing
        }, className)
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $2ad24e75a96deccc$var$styles$2["helix-alert__content"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "helix-d-inline-flex"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: $2ad24e75a96deccc$var$styles$2["helix-alert__icon"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
        icon: getIcon(),
        "aria-hidden": "true"
    })), label && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: $2ad24e75a96deccc$var$styles$2["helix-alert__label-text"]
    }, label, ":"), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $2ad24e75a96deccc$var$styles$2["helix-alert__message"]
    }, children))), dismissible && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        type: "button",
        className: $2ad24e75a96deccc$var$styles$2["helix-alert__close"],
        onClick: dismiss,
        "aria-label": closeLabel
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
        icon: (0, $c761e69c8e58189a$exports.x),
        "aria-hidden": "true"
    }))));
});
$2ad24e75a96deccc$var$Alert.displayName = "Alert";
const $2ad24e75a96deccc$var$StyledImpersonationAlert = (0, $lmFrL.default)($2ad24e75a96deccc$var$Alert)`
    position: relative;

    ${({ $fixed: $fixed, $variant: $variant })=>$fixed && (0, $lmFrL.css)`
            margin-top: ${$2ad24e75a96deccc$var$NAVBAR_HEIGHT[$variant === "small" ? "small" : "large"]};
        `}

    .helix-btn {
        position: absolute;
        right: 32px;
        top: 50%;
        transform: translateY(-50%);
    }

    @media screen and (max-width: 768px) {
        .helix-btn {
            position: static;
            transform: none;
        }
    }
`;
const $2ad24e75a96deccc$var$NavbarImpersonationBanner = ({ fixed: fixed = false, variant: variant = "large" })=>{
    var _a, _b, _c, _d;
    const { platformService: platformService } = (0, $acw62.useContext)($2ad24e75a96deccc$var$NavbarContext);
    let parsedToken;
    try {
        const token = platformService === null || platformService === void 0 ? void 0 : platformService.validateAndGetToken();
        parsedToken = (0, (/*@__PURE__*/$parcel$interopDefault($ea13dab1c811432a$exports))).parseToken(token);
    } catch (e) {
        parsedToken = undefined;
    }
    if (!(parsedToken === null || parsedToken === void 0 ? void 0 : parsedToken.isImpersonationToken())) return null;
    const actorName = (_b = (_a = parsedToken === null || parsedToken === void 0 ? void 0 : parsedToken.getLwtClaim()) === null || _a === void 0 ? void 0 : _a.getActClaim()) === null || _b === void 0 ? void 0 : _b.getName();
    const actorEmail = (_d = (_c = parsedToken === null || parsedToken === void 0 ? void 0 : parsedToken.getLwtClaim()) === null || _c === void 0 ? void 0 : _c.getActClaim()) === null || _d === void 0 ? void 0 : _d.getEmail();
    const firstName = parsedToken === null || parsedToken === void 0 ? void 0 : parsedToken.getFirstName();
    const lastName = parsedToken === null || parsedToken === void 0 ? void 0 : parsedToken.getLastName();
    const email = parsedToken === null || parsedToken === void 0 ? void 0 : parsedToken.getEmail();
    const match = lastName === null || lastName === void 0 ? void 0 : lastName.match(/on behalf of (.+)\)/);
    const fullName = match ? match[1] : firstName;
    const bannerLabel = "Impersonation Active";
    const bannerMessage = " is signed in on behalf of ";
    const exitButton = "Exit Impersonation";
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$StyledImpersonationAlert, {
        "$fixed": fixed,
        "$variant": variant,
        type: "danger",
        dismissible: false,
        label: bannerLabel
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "helix-d-flex"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "helix-text--bold"
    }, " ", actorName !== null && actorName !== void 0 ? actorName : actorEmail), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, " ", bannerMessage, " "), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "helix-text--bold"
    }, " ", fullName !== null && fullName !== void 0 ? fullName : email)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: "helix-btn helix-btn--danger",
        onClick: ()=>platformService === null || platformService === void 0 ? void 0 : platformService.logout()
    }, exitButton)));
};
$2ad24e75a96deccc$var$NavbarImpersonationBanner.displayName = "NavbarImpersonationBanner";
const $2ad24e75a96deccc$var$lwLogoLightUrl = "https://assets.lwolf.com/img/lw-logo-light.svg";
const $2ad24e75a96deccc$var$lwLogoDarkUrl = "https://assets.lwolf.com/img/lw-logo-dark.svg";
const $2ad24e75a96deccc$var$lwLogoFallbackUrl = "https://assets.lwolf.com/img/lw-logo.png";
const $2ad24e75a96deccc$var$NavbarLogo = ({ linkWrapper: linkWrapper, appSwitcher: appSwitcher, brandingLoading: brandingLoading, applicationName: applicationName, hasClientSwitcher: hasClientSwitcher })=>{
    const { isDark: isDark, logoUrl: logoUrl, hideLogo: hideLogo, hasBody: hasBody, logoImageUrl: logoImageUrl } = (0, $acw62.useContext)($2ad24e75a96deccc$var$NavbarContext);
    const logo = logoImageUrl ? logoImageUrl : isDark ? $2ad24e75a96deccc$var$lwLogoLightUrl : $2ad24e75a96deccc$var$lwLogoDarkUrl;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: `helix-unified-navbar__logo-wrapper ${hasBody ? "helix-unified-navbar__logo-wrapper-with-body" : ""}`
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, !hideLogo && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "helix-unified-navbar__logo"
    }, logoUrl ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, linkWrapper ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(linkWrapper({
        url: logoUrl,
        logo: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
            className: "logo logo-light",
            src: logo,
            onError: (event)=>{
                const imageEvent = event.target;
                imageEvent.src = imageEvent.src === logo ? $2ad24e75a96deccc$var$lwLogoFallbackUrl : "";
            },
            alt: "Lone Wolf",
            width: "32",
            height: "32"
        })
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
        href: logoUrl
    }, brandingLoading ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        style: {
            width: "32px",
            height: "32px",
            backgroundColor: "transparent"
        }
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        className: "logo logo-light",
        src: logo,
        onError: (event)=>{
            const imageEvent = event.target;
            imageEvent.src = imageEvent.src === logo ? $2ad24e75a96deccc$var$lwLogoFallbackUrl : "";
        },
        alt: "Lone Wolf",
        width: "32",
        height: "32"
    }))) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        className: "logo logo-light",
        src: logo,
        onError: (event)=>{
            const imageEvent = event.target;
            imageEvent.src = imageEvent.src === logo ? $2ad24e75a96deccc$var$lwLogoFallbackUrl : "";
        },
        alt: "Lone Wolf",
        width: "32",
        height: "32"
    })), appSwitcher ? appSwitcher : applicationName && !hasClientSwitcher && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "helix-unified-navbar__application-name"
    }, applicationName)));
};
/* eslint-disable max-len */ const $2ad24e75a96deccc$var$ProfileIcon = ({ width: width = "32", height: height = "32" })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("svg", {
        width: width,
        height: height,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
        fill: "#9CA3AF"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.23199 20.0107C9.23199 17.3803 11.3643 15.248 13.9947 15.248H18.0053C20.6357 15.248 22.768 17.3803 22.768 20.0107V23.0187C22.768 23.434 22.4313 23.7707 22.016 23.7707H9.98399C9.56868 23.7707 9.23199 23.434 9.23199 23.0187V20.0107ZM13.9947 16.752C12.1949 16.752 10.736 18.2109 10.736 20.0107V22.2667H21.264V20.0107C21.264 18.2109 19.805 16.752 18.0053 16.752H13.9947Z",
        fill: "white"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.24 10.9867C12.24 8.91006 13.9234 7.22665 16 7.22665C18.0766 7.22665 19.76 8.91006 19.76 10.9867V11.9893C19.76 14.0659 18.0766 15.7493 16 15.7493C13.9234 15.7493 12.24 14.0659 12.24 11.9893V10.9867ZM16 8.73065C14.754 8.73065 13.744 9.7407 13.744 10.9867V11.9893C13.744 13.2353 14.754 14.2453 16 14.2453C17.2459 14.2453 18.256 13.2353 18.256 11.9893V10.9867C18.256 9.7407 17.2459 8.73065 16 8.73065Z",
        fill: "white"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("path", {
        d: "M17.0027 19.5093C17.0027 19.2324 17.2271 19.008 17.504 19.008H19.5093C19.7862 19.008 20.0107 19.2324 20.0107 19.5093C20.0107 19.7862 19.7862 20.0107 19.5093 20.0107H17.504C17.2271 20.0107 17.0027 19.7862 17.0027 19.5093Z",
        fill: "white"
    }));
};
const $2ad24e75a96deccc$var$NavbarMobileNotifications = ()=>{
    const { notificationMenuItems: notificationMenuItems, notificationItemFormatter: notificationItemFormatter, noNotificationMessage: noNotificationMessage, notificationMenuLinkWrapper: notificationMenuLinkWrapper } = (0, $acw62.useContext)($2ad24e75a96deccc$var$NavbarContext);
    const focusManager = (0, $b27e9acf8b86f3f1$export$10c5169755ce7bd7)();
    const notificationItems = (0, $acw62.useRef)([]);
    const handleKeyDown = (e)=>{
        if (!focusManager) return;
        switch(e.key){
            case "ArrowDown":
                e.preventDefault();
                focusManager.focusNext({
                    wrap: true
                });
                break;
            case "ArrowUp":
                e.preventDefault();
                focusManager.focusPrevious({
                    wrap: true
                });
                break;
            case "End":
                e.preventDefault();
                focusManager.focusLast({});
                break;
            case "Home":
                e.preventDefault();
                focusManager.focusFirst({});
                break;
        }
    };
    const optionalProps = (e)=>{
        const optionalProps = {};
        if (e && !e.querySelector("a")) optionalProps.tabIndex = 0;
        return optionalProps;
    };
    (0, $acw62.useEffect)(()=>{
        if (notificationItems.current[0]) notificationItems.current[0].focus();
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "helix-unified-navbar__panel-header"
    }, "Notifications"), notificationMenuItems && notificationMenuItems.length > 0 ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
    notificationMenuItems.map((item, index)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: `mobile-notification-item-${index}`,
            className: "helix-unified-navbar__mobile-menu-item"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", Object.assign({
            ref: (ref)=>notificationItems.current.push(ref),
            onKeyDown: (e)=>handleKeyDown(e),
            className: "helix-unified-navbar__mobile-menu-notification-item"
        }, optionalProps(notificationItems.current[index])), notificationMenuLinkWrapper ? notificationMenuLinkWrapper({
            item: item,
            props: {}
        }) : notificationItemFormatter ? notificationItemFormatter(item) : item.label))) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "empty-state"
    }, noNotificationMessage));
};
const $2ad24e75a96deccc$var$getTarget = (menuItem)=>{
    return menuItem.target ? {
        target: menuItem.target
    } : {};
};
const $2ad24e75a96deccc$var$getTargetSimple = (target)=>{
    return target ? {
        target: target
    } : {};
};
const $2ad24e75a96deccc$var$clickDropdownItem = (e, menuRef)=>{
    var _a;
    if (e.key === "Enter") {
        const items = (_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.children;
        const array = Array.from(items);
        const item = array.filter((node)=>node.classList.contains("highlighted"));
        const link = item[0].getElementsByTagName("A");
        if (link[0]) link[0].click();
    }
};
const $2ad24e75a96deccc$var$checkIfChildIsA = (linkWrapper, navItem)=>{
    return linkWrapper && linkWrapper({
        item: navItem,
        props: {}
    }).props && linkWrapper({
        item: navItem,
        props: {}
    }).props.children && linkWrapper({
        item: navItem,
        props: {}
    }).props.children.type && linkWrapper({
        item: navItem,
        props: {}
    }).props.children.type === "a";
};
const $2ad24e75a96deccc$var$StyledNavbarBadge = (0, $lmFrL.default).span`
    display: inline-flex;
    padding: 2px 6px;
    font-size: 11px;
    font-weight: 600;
    justify-content: center;
    align-items: center;
    white-space: nowrap;
    box-sizing: border-box;
    vertical-align: baseline;
    border-radius: 99px;
    flex: 0 0 24px;
    background-color: ${({ $isDark: $isDark })=>$isDark ? "#D1D5DB" : "#374151"};
    color: ${({ $isDark: $isDark })=>$isDark ? "#1F2937" : "#f3f4f6"};
    margin-left: 6px;
`;
const $2ad24e75a96deccc$var$NavbarBadge = (_a)=>{
    var { children: children, isDark: isDark = false } = _a, props = $2ad24e75a96deccc$var$__rest(_a, [
        "children",
        "isDark"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$StyledNavbarBadge, Object.assign({
        "$isDark": isDark
    }, props), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children));
};
$2ad24e75a96deccc$var$NavbarBadge.displayName = "NavbarBadge";
/* eslint-disable max-len */ const $2ad24e75a96deccc$var$NavbarMobileMenuItem = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function menuItem(props, ref) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const { item: item, location: location, onClick: onClick, linkWrapper: linkWrapper, isOpen: isOpen } = props;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const focusManager = (0, $b27e9acf8b86f3f1$export$10c5169755ce7bd7)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { setShowMobileMenu: setShowMobileMenu } = (0, $acw62.useContext)($2ad24e75a96deccc$var$NavbarContext);
    const handleKeyDown = (e)=>{
        if (!focusManager) return;
        switch(e.key){
            case "ArrowDown":
                e.preventDefault();
                focusManager.focusNext({
                    wrap: true
                });
                break;
            case "ArrowUp":
                e.preventDefault();
                focusManager.focusPrevious({
                    wrap: true
                });
                break;
            case "End":
                e.preventDefault();
                focusManager.focusLast({});
                break;
            case "Home":
                e.preventDefault();
                focusManager.focusFirst({});
                break;
        }
    };
    const handleClick = (e, item, isButton)=>{
        if (isButton) item.menuItems ? onClick && onClick(e) : item.onClick();
        if (!item.menuItems) setShowMobileMenu(false);
    };
    if (item.header) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, item.label);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, item.onClick || item.menuItems ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        disabled: item.disabled,
        ref: ref,
        onKeyDown: (e)=>handleKeyDown(e),
        className: `${item.url === location || item.active || item.activePathname === location || item.menuItems && item.menuItems.filter((item)=>item.active).length > 0 || item.menuItems && item.menuItems.filter((item)=>item.activePathname && item.activePathname === location).length > 0 || item.menuItems && item.menuItems.filter((item)=>item.url === location).length > 0 ? "active" : ""}
                    helix-unified-nav__mobile-menu-dropdown-button
                 ${item.menuItems ? "helix-unified-nav__mobile-menu-dropdown-toggle" : ""} ${item.badge && item.badge.label !== undefined && !item.badge.hidden ? "helix-unified-nav__mobile-menu-dropdown--with-badge" : ""}`,
        onClick: (e)=>handleClick(e, item, true)
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "helix-unified-nav__mobile-menu-label"
    }, item.label), item.badge && item.badge.label !== undefined && !item.badge.hidden && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarBadge, null, item.badge.label), item.menuItems && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarHelixIcon, {
        iconName: !isOpen ? "dropdown_closed" : "dropdown_open"
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, linkWrapper ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(linkWrapper({
        item: item,
        props: {
            disabled: item.disabled,
            className: item.url === location || item.active || item.activePathname === location ? `active ${item.badge && item.badge.label !== undefined && !item.badge.hidden ? "helix-unified-nav__mobile-menu-dropdown--with-badge" : ""}` : `${item.badge && item.badge.label !== undefined && !item.badge.hidden ? "helix-unified-nav__mobile-menu-dropdown--with-badge" : ""}`,
            onClick: (e)=>handleClick(e, item, false),
            onKeyDown: (e)=>handleKeyDown(e)
        }
    }), {
        ref: ref,
        disabled: item.disabled,
        className: item.url === location || item.active || item.activePathname === location ? `active ${item.badge && item.badge.label !== undefined && !item.badge.hidden ? "helix-unified-nav__mobile-menu-dropdown--with-badge" : ""}` : `${item.badge && item.badge.label !== undefined && !item.badge.hidden ? "helix-unified-nav__mobile-menu-dropdown--with-badge" : ""}`,
        onKeyDown: (e)=>handleKeyDown(e),
        onClick: (e)=>handleClick(e, item, false),
        children: $2ad24e75a96deccc$var$checkIfChildIsA(linkWrapper, menuItem) ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement((_b = linkWrapper({
            item: menuItem,
            props: Object.assign(Object.assign({}, (_a = linkWrapper({
                item: item,
                props: {
                    disabled: item.disabled,
                    className: `
                                                            ${item.badge && item.badge.label !== undefined && !item.badge.hidden ? "helix-unified-nav__mobile-menu-dropdown--with-badge" : ""}
                                                                ${item.url === location || item.active || item.activePathname === location ? "helix-unified-nav__navigation-item active" : "helix-unified-nav__navigation-item"}`
                }
            })) === null || _a === void 0 ? void 0 : _a.props), {
                disabled: item.disabled,
                className: `
                                                    ${item.badge && item.badge.label !== undefined && !item.badge.hidden ? "helix-unified-nav__mobile-menu-dropdown--with-badge" : ""}
                                                        ${item.url === location || item.active || item.activePathname === location ? "helix-unified-nav__navigation-item active" : "helix-unified-nav__navigation-item"}`
            })
        })) === null || _b === void 0 ? void 0 : _b.props.children, {
            children: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (_d = linkWrapper({
                item: item,
                props: Object.assign(Object.assign({}, (_c = linkWrapper({
                    item: item,
                    props: {
                        disabled: item.disabled,
                        className: `
                                                                            ${item.badge && item.badge.label !== undefined && !item.badge.hidden ? "helix-unified-nav__mobile-menu-dropdown--with-badge" : ""}
                                                                                ${item.url === location || item.active || item.activePathname === location ? "helix-unified-nav__navigation-item active" : "helix-unified-nav__navigation-item"}`
                    }
                })) === null || _c === void 0 ? void 0 : _c.props), {
                    disabled: item.disabled,
                    className: `
                                                                    ${item.badge && item.badge.label !== undefined && !item.badge.hidden ? "helix-unified-nav__mobile-menu-dropdown--with-badge" : ""}
                                                                        ${item.url === location || item.active || item.activePathname === location ? "helix-unified-nav__navigation-item active" : "helix-unified-nav__navigation-item"}`
                })
            })) === null || _d === void 0 ? void 0 : _d.props.children.props.children, item.badge && item.badge.label !== undefined && !item.badge.hidden && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarBadge, null, item.badge.label))
        }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, ((_e = linkWrapper({
            item: item,
            props: {}
        })) === null || _e === void 0 ? void 0 : _e.props) && ((_f = linkWrapper({
            item: item,
            props: {}
        })) === null || _f === void 0 ? void 0 : _f.props.children) && ((_h = linkWrapper({
            item: item,
            props: Object.assign(Object.assign({}, (_g = linkWrapper({
                item: item,
                props: {
                    disabled: item.disabled,
                    className: item.url === location || item.active || item.activePathname === location ? "helix-unified-nav__navigation-item active" : "helix-unified-nav__navigation-item"
                }
            })) === null || _g === void 0 ? void 0 : _g.props), {
                disabled: item.disabled,
                className: item.url === location || item.active || item.activePathname === location ? "helix-unified-nav__navigation-item active" : "helix-unified-nav__navigation-item"
            })
        })) === null || _h === void 0 ? void 0 : _h.props.children), item.badge && item.badge.label !== undefined && !item.badge.hidden && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarBadge, null, item.badge.label))
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, item.readOnly ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "read-only-item-wrapper"
    }, typeof item.label === "function" ? item.label(item) : item.label, item.badge && item.badge.label !== undefined && !item.badge.hidden && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarBadge, null, item.badge.label), ":") : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", Object.assign({
        className: `${item.badge && item.badge.label !== undefined && !item.badge.hidden ? `helix-unified-nav__mobile-menu-dropdown--with-badge ${item.disabled ? "disabled" : ""} ${item.readOnly ? "read-only-item" : ""}` : `${item.readOnly ? "read-only-item" : ""}`}`,
        ref: ref,
        onKeyDown: (e)=>handleKeyDown(e),
        href: item.url,
        onClick: (e)=>{
            if (item.disabled) {
                e.preventDefault();
                return;
            }
            handleClick(e, item, false);
        }
    }, $2ad24e75a96deccc$var$getTarget(item)), typeof item.label === "function" ? item.label(item) : item.label, item.badge && item.badge.label !== undefined && !item.badge.hidden && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarBadge, null, item.badge.label)))));
});
const $2ad24e75a96deccc$var$NavbarMobileMenuToggleButton = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(({ menuOpen: menuOpen, setMenuOpen: setMenuOpen }, ref)=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const focusManager = (0, $b27e9acf8b86f3f1$export$10c5169755ce7bd7)();
    const handleKeyDown = (e)=>{
        if (!focusManager) return;
        switch(e.key){
            case "ArrowDown":
                e.preventDefault();
                focusManager.focusNext({
                    wrap: true
                });
                break;
            case "ArrowUp":
                e.preventDefault();
                focusManager.focusPrevious({
                    wrap: true
                });
                break;
            case "End":
                e.preventDefault();
                focusManager.focusLast({});
                break;
            case "Home":
                e.preventDefault();
                focusManager.focusFirst({});
                break;
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        ref: ref,
        "aria-label": menuOpen ? "Close menu" : "Open menu",
        className: `helix-unified-nav__navigation-item helix-unified-nav__mobile-menu-trigger ${menuOpen ? "active" : ""}`,
        onKeyDown: (e)=>handleKeyDown(e),
        onClick: ()=>{
            setMenuOpen();
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarHelixIcon, {
        iconName: menuOpen ? "close" : "menu"
    }));
});
$2ad24e75a96deccc$var$NavbarMobileMenuToggleButton.displayName = "NavbarMobileMenuToggleButton";
const $2ad24e75a96deccc$var$NavbarMobileHelpItem = (props)=>{
    const { helpUrl: helpUrl, linkWrapper: linkWrapper, target: target } = props;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const focusManager = (0, $b27e9acf8b86f3f1$export$10c5169755ce7bd7)();
    const { setShowMobileMenu: setShowMobileMenu } = (0, $acw62.useContext)($2ad24e75a96deccc$var$NavbarContext);
    const handleKeyDown = (e)=>{
        if (!focusManager) return;
        switch(e.key){
            case "ArrowDown":
                e.preventDefault();
                focusManager.focusNext({
                    wrap: true
                });
                break;
            case "ArrowUp":
                e.preventDefault();
                focusManager.focusPrevious({
                    wrap: true
                });
                break;
            case "End":
                e.preventDefault();
                focusManager.focusLast({});
                break;
            case "Home":
                e.preventDefault();
                focusManager.focusFirst({});
                break;
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "helix-unified-navbar__mobile-menu-item helix-unified-navbar__mobile-menu-help-item"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, linkWrapper ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(linkWrapper({
        url: helpUrl,
        props: {
            onKeyDown: (e)=>handleKeyDown(e),
            onClick: (e)=>{
                setShowMobileMenu(false);
            }
        },
        label: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarHelixIcon, {
            iconName: "question_help"
        }), " Help")
    }), {
        onKeyDown: (e)=>handleKeyDown(e),
        onClick: (e)=>{
            setShowMobileMenu(false);
        }
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", Object.assign({
        onKeyDown: (e)=>handleKeyDown(e),
        href: helpUrl,
        onClick: (e)=>{
            setShowMobileMenu(false);
        }
    }, $2ad24e75a96deccc$var$getTargetSimple(target)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarHelixIcon, {
        iconName: "question_help"
    }), " Help"))));
};
const $2ad24e75a96deccc$var$NotificationIcon = ({ showAlertBadge: showAlertBadge })=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarHelixIcon, {
        iconName: showAlertBadge ? "alert_badge" : "alert"
    });
};
/* eslint-disable react-hooks/rules-of-hooks */ const $2ad24e75a96deccc$var$NavbarMobileMenuNotificationToggleButton = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function toggleButton({ setMenuOpen: setMenuOpen, menuOpen: menuOpen }, ref) {
    const focusManager = (0, $b27e9acf8b86f3f1$export$10c5169755ce7bd7)();
    const { showAlertIconBadge: showAlertIconBadge, notificationMenuOnClick: notificationMenuOnClick } = (0, $acw62.useContext)($2ad24e75a96deccc$var$NavbarContext);
    const handleKeyDown = (e)=>{
        if (!focusManager) return;
        switch(e.key){
            case "ArrowDown":
                e.preventDefault();
                focusManager.focusNext({
                    wrap: true
                });
                break;
            case "ArrowUp":
                e.preventDefault();
                focusManager.focusPrevious({
                    wrap: true
                });
                break;
            case "End":
                e.preventDefault();
                focusManager.focusLast({});
                break;
            case "Home":
                e.preventDefault();
                focusManager.focusFirst({});
                break;
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        ref: ref,
        "aria-label": menuOpen ? "Close menu" : "Open menu",
        className: `helix-unified-nav__navigation-item helix-unified-nav__mobile-notification-trigger ${menuOpen ? "active" : ""}`,
        onKeyDown: (e)=>handleKeyDown(e),
        onClick: (e)=>{
            setMenuOpen();
            notificationMenuOnClick && notificationMenuOnClick(e);
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NotificationIcon, {
        showAlertBadge: showAlertIconBadge
    }));
});
/* eslint-disable max-len */ const $2ad24e75a96deccc$var$NavbarMobileMenu = ()=>{
    const { navItems: navItems, helpUrl: helpUrl, helpTarget: helpTarget, userMenuItems: userMenuItems, helpMenuItems: helpMenuItems, location: location, isDark: isDark, notificationMenuItems: notificationMenuItems, navbarLinkWrapper: navbarLinkWrapper, helpItemLinkWrapper: helpItemLinkWrapper, userMenuLinkWrapper: userMenuLinkWrapper, userInfo: userInfo, dropdownsExpandedByDefault: dropdownsExpandedByDefault, showMobileMenu: showMobileMenu, setShowMobileMenu: setShowMobileMenu, showMobileNotifications: showMobileNotifications, setShowMobileNotifications: setShowMobileNotifications, setShowMobileApplicationSwitcher: setShowMobileApplicationSwitcher, hasNotificationMenu: hasNotificationMenu, hasBody: hasBody, customMobileMenu: customMobileMenu, helpMenuLocation: helpMenuLocation, userMenuLocation: userMenuLocation, hideHelpMenuHeader: hideHelpMenuHeader } = (0, $acw62.useContext)($2ad24e75a96deccc$var$NavbarContext);
    const toggleMenuButton = (0, $acw62.useRef)(null);
    const toggleNotificationsButton = (0, $acw62.useRef)(null);
    const [subMenusVisible, setSubMenusVisible] = (0, $acw62.useState)([]);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const menuItems = (0, $acw62.useRef)([]);
    const handleKeyDown = (e)=>{
        if (e.key === "Escape") {
            if (showMobileMenu) {
                setShowMobileMenu(false);
                if (toggleMenuButton && toggleMenuButton.current) toggleMenuButton.current.focus();
            }
            if (showMobileNotifications) {
                setShowMobileNotifications(false);
                if (toggleNotificationsButton && toggleNotificationsButton.current) toggleNotificationsButton.current.focus();
            }
        }
    };
    const toggleSubMenu = (item)=>{
        let copyOfMenuVisible = [
            ...subMenusVisible
        ];
        if (copyOfMenuVisible.indexOf(item.label) === -1) copyOfMenuVisible.push(item.label);
        else copyOfMenuVisible = copyOfMenuVisible.filter((menuItem)=>menuItem !== item.label);
        setSubMenusVisible(copyOfMenuVisible);
    };
    (0, $acw62.useEffect)(()=>{
        if (showMobileMenu && menuItems.current && menuItems.current[0] && menuItems.current[0].focus) menuItems.current[0].focus();
        else menuItems.current = [];
    }, [
        showMobileMenu
    ]);
    (0, $acw62.useEffect)(()=>{
        window.addEventListener("keydown", handleKeyDown);
        return ()=>{
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        showMobileMenu,
        showMobileNotifications
    ]);
    const checkIfDropdownsExpandedByDefault = (label)=>{
        return dropdownsExpandedByDefault ? subMenusVisible.indexOf(label) === -1 : subMenusVisible.indexOf(label) > -1;
    };
    const toggleMobileMenuPanel = ()=>{
        setShowMobileMenu(!showMobileMenu);
        setShowMobileNotifications(false);
        setShowMobileApplicationSwitcher(false);
    };
    const toggleNotificationMenu = ()=>{
        setShowMobileNotifications(!showMobileNotifications);
        setShowMobileMenu(false);
        setShowMobileApplicationSwitcher(false);
    };
    (0, $acw62.useEffect)(()=>{
        navItems.map((menuItem)=>{
            if (menuItem.menuItems) menuItem.menuItems.map((subItem)=>{
                if (subItem.url && subItem.url === location) setSubMenusVisible((prev)=>{
                    if (menuItem.label && prev.indexOf(menuItem.label) === -1) prev.push(menuItem.label);
                    else return prev.filter((item)=>item !== menuItem.label);
                    return prev;
                });
            });
        });
    }, [
        navItems,
        location
    ]);
    if (navItems.length > 0 || userMenuItems.length > 0 || helpMenuItems.length > 0 || helpUrl) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$StyledMobileMenu, {
        "data-lwt-id": "navbar-mobile-menu",
        "$hasNavItems": navItems.length > 0 || hasBody
    }, hasNotificationMenu && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarMobileMenuNotificationToggleButton, {
        ref: toggleNotificationsButton,
        menuOpen: showMobileNotifications,
        setMenuOpen: toggleNotificationMenu
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarMobileMenuToggleButton, {
        ref: toggleMenuButton,
        menuOpen: showMobileMenu,
        setMenuOpen: toggleMobileMenuPanel
    }), showMobileNotifications && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$StyledMobileMenuPanel, {
        "$isDark": isDark
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarMobileNotifications, null)), showMobileMenu && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$StyledMobileMenuPanel, {
        "$isDark": isDark
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, customMobileMenu && customMobileMenu, navItems.map((item, navItemIndex)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
            key: `mobile-nav-item-nav-item-${navItemIndex}`
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: `helix-unified-navbar__mobile-menu-item ${item.disabled ? "disabled" : ""} ${item.menuItems ? "helix-unified-navbar__mobile-menu-item-dropdown" : ""} ${item.url === location ? "active" : ""}`
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarMobileMenuItem, {
            isOpen: checkIfDropdownsExpandedByDefault(item.label),
            linkWrapper: navbarLinkWrapper,
            ref: (ref)=>{
                if (menuItems.current && menuItems.current.indexOf(ref) === -1 && ref) menuItems.current.push(ref);
            },
            onClick: ()=>toggleSubMenu(item),
            location: location,
            item: item
        })), item.menuItems && checkIfDropdownsExpandedByDefault(item.label) && item.menuItems.map((menuItem, subMenuIndex)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                key: `mobile-nav-item-submenu-item-${subMenuIndex}`,
                className: `${menuItem.header ? "helix-unified-navbar__mobile-menu-header" : "helix-unified-navbar__mobile-menu-item helix-unified-navbar__mobile-sub-menu-item"} ${menuItem.url === location ? "active" : ""} ${menuItem.disabled ? "disabled" : ""}
                                                 ${item.readOnly ? "item-read-only" : ""}
                                                `
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarMobileMenuItem, {
                linkWrapper: navbarLinkWrapper,
                ref: (ref)=>{
                    if (menuItems.current && menuItems.current.indexOf(ref) > -1 && ref) menuItems.current.push(ref);
                },
                location: location,
                item: menuItem
            }))))), (customMobileMenu || navItems.length > 0) && (helpUrl || notificationMenuItems || userMenuItems.length > 0) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("hr", {
        className: "helix-unified-navbar__mobile-menu-divider"
    }), helpUrl && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarMobileHelpItem, {
        linkWrapper: helpItemLinkWrapper,
        helpUrl: helpUrl,
        target: helpTarget
    }), helpMenuItems && helpMenuItems.length > 0 && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, !hideHelpMenuHeader && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "helix-unified-navbar__mobile-menu-header"
    }, "Help"), helpMenuItems.map((item, userIndex)=>{
        if (item.divider) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("hr", {
            key: `mobile-help-item-divider-${userIndex}`,
            className: "helix-unified-navbar__mobile-menu-divider"
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: `mobile-help-item-${userIndex}`,
            className: `helix-unified-navbar__mobile-menu-item ${helpMenuLocation === item.url ? "active" : ""}`
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarMobileMenuItem, {
            linkWrapper: userMenuLinkWrapper,
            item: item
        }));
    })), helpMenuItems.length > 0 && (helpUrl || notificationMenuItems || helpMenuItems) || helpUrl && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("hr", {
        className: "helix-unified-navbar__mobile-menu-divider"
    }), userMenuItems.length > 0 && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "helix-unified-navbar__mobile-menu-profile-item"
    }, (userInfo === null || userInfo === void 0 ? void 0 : userInfo.avatarURL) ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "helix-unified-nav__user-avatar"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: userInfo.avatarURL,
        alt: "avatar"
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$ProfileIcon, null), " ", userInfo && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "helix-unified-navbar__mobile-menu-user-info"
    }, userInfo.name && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "helix-unified-navbar__mobile-menu-user-info-name"
    }, userInfo.name), userInfo.email && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "helix-unified-navbar__mobile-menu-user-info-email"
    }, userInfo.email))), userMenuItems.map((item, userIndex)=>{
        if (item.divider) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("hr", {
            key: `mobile-user-item-divider-${userIndex}`,
            className: "helix-unified-navbar__mobile-menu-divider"
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: `mobile-user-item-${userIndex}`,
            className: `helix-unified-navbar__mobile-menu-item ${userMenuLocation === item.url ? "active" : ""}  ${item.readOnly ? "item-read-only" : ""}`
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarMobileMenuItem, {
            linkWrapper: userMenuLinkWrapper,
            item: item
        }));
    })))));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
};
const $2ad24e75a96deccc$var$apiDomains = {
    dev: "https://platform.api.dev.lwolf.com",
    stg: "https://platform.api.stg.lwolf.com",
    pre: "https://platform.api.pre.lwolf.com",
    prod: "https://platform.api.lwolf.com"
};
// Module scope so this survives component remount
const $2ad24e75a96deccc$var$brandingCache = new Map();
const $2ad24e75a96deccc$var$inflight = new Map();
const $2ad24e75a96deccc$var$useBranding = ({ environment: environment = "dev", localStorageTokenKey: localStorageTokenKey = "lwaToken", userToken: userToken = "", activeClientId: activeClientId = "" })=>{
    const [branding, setBranding] = (0, $acw62.useState)(()=>{
        var _a;
        return (_a = $2ad24e75a96deccc$var$brandingCache.get(activeClientId)) !== null && _a !== void 0 ? _a : null;
    });
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    // New format: lwaToken_{env.}lwolf.com
    const newTokenCookieName = environment === "prod" ? "lwaToken_lwolf.com" : `lwaToken_${environment}.lwolf.com`;
    // Fallback format: lwaToken@@{env.}lwolf.com
    const fallbackTokenCookieName = environment === "prod" ? "lwaToken@@lwolf.com" : `lwaToken@@${environment}.lwolf.com`;
    const getTokenFromCookie = ()=>{
        if (!document || !document.cookie) return "";
        const cookies = document.cookie.split(";");
        // First try the new format
        const newFormatCookie = cookies.find((item)=>item.trim().startsWith(newTokenCookieName));
        if (newFormatCookie) return newFormatCookie.split("=")[1] || "";
        // Fall back to the old format
        const fallbackCookie = cookies.find((item)=>item.trim().startsWith(fallbackTokenCookieName));
        if (fallbackCookie) return fallbackCookie.split("=")[1] || "";
        return "";
    };
    const tokenCookie = getTokenFromCookie();
    const getUserToken = ()=>{
        // get the token from the local storage or the cookie or the userToken
        return typeof window !== "undefined" ? window.localStorage.getItem(localStorageTokenKey) || tokenCookie || userToken : "";
    };
    const token = getUserToken();
    const APIEndPoint = `${$2ad24e75a96deccc$var$apiDomains[environment]}/v1/clients/${activeClientId}/branding`;
    const fetchBranding = ()=>{
        const existing = $2ad24e75a96deccc$var$inflight.get(activeClientId);
        if (existing) return existing;
        const request = (()=>$2ad24e75a96deccc$var$__awaiter(void 0, void 0, void 0, function*() {
                try {
                    const res = yield fetch(APIEndPoint, {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    });
                    const data = res.ok ? yield res.json().catch(()=>null) : null;
                    if (!res.ok) console.log(`Failed to fetch branding: ${res.status}`);
                    $2ad24e75a96deccc$var$brandingCache.set(activeClientId, data);
                    return data;
                } catch (error) {
                    console.error(error);
                    $2ad24e75a96deccc$var$brandingCache.set(activeClientId, null);
                    return null;
                } finally{
                    $2ad24e75a96deccc$var$inflight.delete(activeClientId);
                }
            }))();
        $2ad24e75a96deccc$var$inflight.set(activeClientId, request);
        return request;
    };
    (0, $acw62.useEffect)(()=>{
        var _a;
        if (!activeClientId) return;
        if ($2ad24e75a96deccc$var$brandingCache.has(activeClientId)) {
            setBranding((_a = $2ad24e75a96deccc$var$brandingCache.get(activeClientId)) !== null && _a !== void 0 ? _a : null);
            return;
        }
        let cancelled = false;
        setIsLoading(true);
        fetchBranding().then((data)=>{
            if (cancelled) return;
            setBranding(data);
            setIsLoading(false);
        });
        return ()=>{
            cancelled = true;
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        environment,
        activeClientId
    ]);
    return {
        branding: branding,
        setBranding: setBranding,
        isLoading: isLoading
    };
};
const $2ad24e75a96deccc$export$42cfbb80f7861e77 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((_a, ref)=>{
    var { applicationName: applicationName, logoUrl: logoUrl = "/", children: children, isDark: isDark = false, fixed: fixed = false, className: className, dataLwtId: dataLwtId, hideLogo: hideLogo = false, hideLogoOnMobile: hideLogoOnMobile = false, variant: variant = "large", logoLinkWrapper: logoLinkWrapper, onExpandIconClick: onExpandIconClick, expandIconActive: expandIconActive, customMobileMenu: customMobileMenu, mobileMenuOpen: mobileMenuOpen = false, onMobileMenuToggle: onMobileMenuToggle, applicationCode: applicationCode, environment: environment = "dev", localStorageTokenKey: localStorageTokenKey = "lwaToken", token: token, activeClientId: activeClientId, logoImageUrl: logoImageUrl, brandingApplicationCode: brandingApplicationCode, disablePendo: disablePendo = false, platformService: platformService } = _a, rest = $2ad24e75a96deccc$var$__rest(_a, [
        "applicationName",
        "logoUrl",
        "children",
        "isDark",
        "fixed",
        "className",
        "dataLwtId",
        "hideLogo",
        "hideLogoOnMobile",
        "variant",
        "logoLinkWrapper",
        "onExpandIconClick",
        "expandIconActive",
        "customMobileMenu",
        "mobileMenuOpen",
        "onMobileMenuToggle",
        "applicationCode",
        "environment",
        "localStorageTokenKey",
        "token",
        "activeClientId",
        "logoImageUrl",
        "brandingApplicationCode",
        "disablePendo",
        "platformService"
    ]);
    const { windowWidth: windowWidth } = (0, $bea0f3bed29b3a68$exports.useWindowWidth)();
    let reactChildren = children;
    const ReactChildrenArrayFirst = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray(children)[0];
    // if the first child is a fragment check its children
    if ((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.count(children) === 1 && ReactChildrenArrayFirst.type === (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment) reactChildren = ReactChildrenArrayFirst.props.children;
    const hasClientPicker = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray(reactChildren).some((child)=>child && child.type && child.type.displayName === "ClientPicker" || child && child.props && child.props.originalType && child.props.originalType.displayName === "ClientPicker");
    const hasClientSwitcher = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray(reactChildren).some((child)=>child && child.type && child.type.displayName === "ClientSwitcher" || child && child.props && child.props.originalType && child.props.originalType.displayName === "ClientSwitcher");
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarProvider, {
        environment: environment,
        hideLogo: hideLogo || hideLogoOnMobile && windowWidth < 576 || hasClientPicker || hasClientSwitcher,
        logoUrl: logoUrl,
        localStorageTokenKey: localStorageTokenKey,
        isDark: isDark,
        isMobileMenuOpen: mobileMenuOpen,
        customMobileMenu: customMobileMenu,
        onMobileMenuToggle: (isOpen)=>onMobileMenuToggle && onMobileMenuToggle(isOpen),
        activeClientId: activeClientId,
        applicationCode: applicationCode,
        platformService: platformService
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarInner, Object.assign({
        applicationName: applicationName,
        logoUrl: logoUrl,
        isDark: isDark,
        fixed: fixed,
        className: className,
        dataLwtId: dataLwtId,
        hideLogo: hideLogo,
        hideLogoOnMobile: hideLogoOnMobile,
        variant: variant,
        logoLinkWrapper: logoLinkWrapper,
        onExpandIconClick: onExpandIconClick,
        expandIconActive: expandIconActive,
        customMobileMenu: customMobileMenu,
        mobileMenuOpen: mobileMenuOpen,
        onMobileMenuToggle: onMobileMenuToggle,
        applicationCode: applicationCode,
        environment: environment,
        localStorageTokenKey: localStorageTokenKey,
        token: token,
        activeClientId: activeClientId,
        logoImageUrl: logoImageUrl,
        brandingApplicationCode: brandingApplicationCode,
        disablePendo: disablePendo,
        platformService: platformService,
        ref: ref
    }, rest), children));
});
const $2ad24e75a96deccc$var$NavbarInner = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((_a, ref)=>{
    var _b, _c, _d;
    var { applicationName: applicationName, logoUrl: logoUrl = "/", children: children, isDark: isDark = false, fixed: fixed = false, className: className, dataLwtId: dataLwtId, hideLogo: hideLogo = false, hideLogoOnMobile: hideLogoOnMobile = false, variant: variant = "large", logoLinkWrapper: logoLinkWrapper, onExpandIconClick: onExpandIconClick, expandIconActive: expandIconActive, customMobileMenu: customMobileMenu, mobileMenuOpen: mobileMenuOpen = false, onMobileMenuToggle: onMobileMenuToggle, applicationCode: applicationCode, environment: environment = "dev", localStorageTokenKey: localStorageTokenKey = "lwaToken", token: token, logoImageUrl: logoImageUrl, brandingApplicationCode: brandingApplicationCode, disablePendo: disablePendo = false } = _a, rest = $2ad24e75a96deccc$var$__rest(_a, [
        "applicationName",
        "logoUrl",
        "children",
        "isDark",
        "fixed",
        "className",
        "dataLwtId",
        "hideLogo",
        "hideLogoOnMobile",
        "variant",
        "logoLinkWrapper",
        "onExpandIconClick",
        "expandIconActive",
        "customMobileMenu",
        "mobileMenuOpen",
        "onMobileMenuToggle",
        "applicationCode",
        "environment",
        "localStorageTokenKey",
        "token",
        "logoImageUrl",
        "brandingApplicationCode",
        "disablePendo"
    ]);
    const { setBrandingLoading: setBrandingLoading, setLogoImageUrl: setLogoImageUrl, setApplicationName: setApplicationName, activeClientId: activeClientId } = (0, $acw62.useContext)($2ad24e75a96deccc$var$NavbarContext);
    const { branding: branding, isLoading: isLoading } = $2ad24e75a96deccc$var$useBranding({
        environment: environment,
        activeClientId: activeClientId
    });
    (0, $acw62.useEffect)(()=>{
        setBrandingLoading && setBrandingLoading(isLoading);
    }, [
        isLoading,
        setBrandingLoading
    ]);
    (0, $acw62.useEffect)(()=>{
        if (branding === null || branding === void 0 ? void 0 : branding.logoUrl) setLogoImageUrl && setLogoImageUrl(branding.logoUrl);
        else setLogoImageUrl && setLogoImageUrl(logoImageUrl || "");
    }, [
        branding,
        setLogoImageUrl
    ]);
    const gtmResult = (0, $c4b052ef371b1621$export$2e2bcd8739ae039)({
        gtmContainerId: disablePendo ? "" : "GTM-TW6R356J",
        applicationCode: applicationCode,
        environment: environment,
        localStorageTokenKey: localStorageTokenKey,
        userToken: token,
        activeClientId: activeClientId
    });
    // Extract dataLayer and setDataLayer with fallbacks
    const dataLayer = !disablePendo && applicationCode ? gtmResult.dataLayer : null;
    const setDataLayer = (_b = !disablePendo && (gtmResult === null || gtmResult === void 0 ? void 0 : gtmResult.setDataLayer)) !== null && _b !== void 0 ? _b : ()=>{
    // No-op: Pendo is disabled or not initialized when applicationCode is not provided
    };
    // use imperative handle to pass the dataLayer to the parent component and the setDataLayer function
    (0, $acw62.useImperativeHandle)(ref, ()=>{
        return {
            dataLayer: dataLayer,
            setDataLayer: setDataLayer
        };
    }, [
        dataLayer,
        setDataLayer
    ]);
    const applicationNameFromBranding = branding && (brandingApplicationCode || applicationCode) && ((_d = (_c = branding === null || branding === void 0 ? void 0 : branding.applications) === null || _c === void 0 ? void 0 : _c[(brandingApplicationCode === null || brandingApplicationCode === void 0 ? void 0 : brandingApplicationCode.toLocaleLowerCase()) || (applicationCode === null || applicationCode === void 0 ? void 0 : applicationCode.toLocaleLowerCase()) || ""]) === null || _d === void 0 ? void 0 : _d.name) ? branding.applications[(brandingApplicationCode === null || brandingApplicationCode === void 0 ? void 0 : brandingApplicationCode.toLocaleLowerCase()) || (applicationCode === null || applicationCode === void 0 ? void 0 : applicationCode.toLocaleLowerCase()) || ""].name : "";
    (0, $acw62.useEffect)(()=>{
        if (hideLogo) setApplicationName && setApplicationName("");
        else if (applicationNameFromBranding) setApplicationName && setApplicationName(applicationNameFromBranding);
        else setApplicationName && setApplicationName(applicationName);
    }, [
        hideLogo,
        applicationNameFromBranding,
        setApplicationName,
        applicationName
    ]);
    let reactChildren = children;
    const ReactChildrenArrayFirst = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray(children)[0];
    // if the first child is a fragment check its children
    if ((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.count(children) === 1 && ReactChildrenArrayFirst.type === (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment) reactChildren = ReactChildrenArrayFirst.props.children;
    const appSwitcher = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray(reactChildren).filter((child)=>child && child.type && child.type.displayName && child.type.displayName === "ApplicationSwitcher" || child && child.props && child.props.originalType && child.props.originalType.displayName === "ApplicationSwitcher")[0];
    const hasBothNavbarBodyAndNavbarNavigationBar = ()=>{
        const navbarBody = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray(reactChildren).filter((child)=>child && child.type && child.type.displayName && child.type.displayName === "NavbarBody" || child && child.props && child.props.originalType && child.props.originalType.displayName === "NavbarBody")[0];
        const navbarNavigationBar = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray(reactChildren).filter((child)=>child && child.type && child.type.displayName && child.type.displayName === "NavbarNavigationBar" || child && child.props && child.props.originalType && child.props.originalType.displayName === "NavbarNavigationBar")[0];
        return navbarBody && navbarNavigationBar;
    };
    // ...inside the Navbar component...
    const hasClientPicker = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray(reactChildren).some((child)=>child && child.type && child.type.displayName === "ClientPicker" || child && child.props && child.props.originalType && child.props.originalType.displayName === "ClientPicker");
    const hasClientSwitcher = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray(reactChildren).some((child)=>child && child.type && child.type.displayName === "ClientSwitcher" || child && child.props && child.props.originalType && child.props.originalType.displayName === "ClientSwitcher");
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$GlobalNavStyles, null), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$StyledNavbarWrapper, {
        className: `helix-unified-nav__nav ${className ? className : ""}`,
        "data-lwt-id": dataLwtId
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$StyledNavbar, Object.assign({
        "$fixed": fixed,
        "$variant": variant,
        "$isDark": isDark,
        "$hasExpandIcon": onExpandIconClick ? true : false,
        "$reducePaddingLeft": hasBothNavbarBodyAndNavbarNavigationBar()
    }, rest), onExpandIconClick && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarExpandButton, {
        expandIconActive: expandIconActive,
        onExpandIconClick: onExpandIconClick
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarLogo, {
        brandingLoading: isLoading,
        appSwitcher: appSwitcher,
        hasClientSwitcher: hasClientPicker || hasClientSwitcher,
        applicationName: hideLogo ? "" : applicationNameFromBranding || applicationName,
        linkWrapper: logoLinkWrapper
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(reactChildren, (child)=>{
        if (child && child.type && child.type.displayName && child.type.displayName !== "ApplicationSwitcher") return child;
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarMobileMenu, null)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarImpersonationBanner, {
        fixed: fixed,
        variant: variant
    })));
});
$2ad24e75a96deccc$export$42cfbb80f7861e77.displayName = "Navbar";
$2ad24e75a96deccc$var$NavbarInner.displayName = "NavbarInner";
const $2ad24e75a96deccc$var$StyledDropdownMenu = (0, $lmFrL.default).div`
    position: relative;
    background-color: #fff;
    border-radius: 4px;
    overflow: hidden;
    min-width: 128px;
    ${({ width: width })=>width ? (0, $lmFrL.css)`
                  width: ${width}!important;
              ` : (0, $lmFrL.css)`
                  width: fit-content !important;
              `}
    ${({ maxWidth: maxWidth })=>maxWidth && (0, $lmFrL.css)`
            max-width: ${maxWidth};
        `}
        display: ${({ isOpen: isOpen })=>isOpen ? "block" : "none"};
    ${({ isOpen: isOpen })=>isOpen && (0, $lmFrL.css)`
            box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.2), 0px 4px 8px rgba(0, 0, 0, 0.1);
            padding: 8px;
            box-sizing: border-box;
            li:not(.divider) {
                box-sizing: border-box;
                border-radius: 6px;
                display: block;
                text-decoration: none;
                margin-bottom: 2px;
                color: #111827;
                font-weight: 400;
                font-size: 14px;
                a,
                .menu-item-content-wrapper {
                    padding: 8px;
                }
                a {
                    box-sizing: border-box;
                    border-radius: 6px;
                    color: inherit;
                    display: flex;
                    justify-content: space-between;
                    text-decoration: none;
                    white-space: nowrap;
                }
                &.helix-unified-nav__notification-menu-item a {
                    white-space: initial;
                }

                &.highlighted {
                    background-color: #f3f4f6;
                }
                &.helix-dropdown-menu__overflow-dropdown-item {
                    display: flex;
                    align-items: center;
                }
                &.helix-dropdown-menu__sub-menu-item {
                    padding-left: 16px;

                    &--closed {
                        display: none;
                    }
                }

                &.disabled {
                    opacity: 0.5;
                    cursor: pointer;
                    pointer-events: none;
                }

                .dropdown-menu-item-content {
                    display: grid;
                    align-items: center;
                    justify-content: space-between;
                    grid-template-columns: 1fr 20px;
                    gap: 12px;
                    flex: 1 1;
                    .checkmark-outlined {
                        fill: #2563eb !important;
                        path {
                            fill: #2563eb !important;
                        }
                    }
                }
            }
        `}
    &:focus-within {
        outline: none;
    }
    ul {
        padding: 0;
        margin: 0;
        list-style: none;
        ${({ inNavbar: inNavbar })=>inNavbar && (0, $lmFrL.css)`
                max-height: calc(100vh - 150px);
                overflow: auto;
            `}
        &:focus-visible {
            outline: none;
        }
        li {
            &:not(.divider):not(.section-header):not(.disabled):not(.item-read-only) {
                cursor: pointer;
            }
            display: flex;
            .menu-item-content-wrapper {
                display: flex;
                flex: 1 1;
                justify-content: space-between;
                align-items: center;
                .menu-item-label {
                    flex: 1 1;
                }
            }
            &.disabled .menu-item-content-wrapper,
            &:disabled .menu-item-content-wrapper {
                *:not(.not-active) {
                    .label,
                    .description {
                        opacity: 0.6;
                    }
                }
            }
            &.selected-item {
                outline-width: 0;
                background-color: #e5e7eb;
            }
            &.active {
                color: #111827;
                background-color: #e5e7eb;
            }
            &.item-read-only {
                cursor: pointer;
                pointer-events: none;
            }
        }
        .divider {
            padding: 0;
            margin: 6px 0;
            overflow: hidden;
            border-top: 1px solid #e5e7eb;
        }
        .section-header {
            text-transform: uppercase;
            font-size: 12px;
            color: #4b5563;
            letter-spacing: 0.1em;
            padding: 8px;
            &.section-header-bold {
                font-weight: 600;
            }
            .menu-item-content-wrapper {
                padding: 0;
            }
        }
        .description {
            color: #4b5563;
            font-size: 12px;
        }
        + ul {
            margin-left: 16px;
            @media screen and (max-width: 576px) {
                margin-left: 0;
                margin-top: 16px;
            }
        }
    }
    .empty-state {
        padding: 8px;
        text-align: center;
    }
`;
const $2ad24e75a96deccc$var$DropdownMenu = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef(function menu(props, ref) {
    // eslint-disable-next-line react/prop-types
    const { children: children, isOpen: isOpen, maxWidth: maxWidth, width: width, inNavbar: inNavbar = false, className: className } = props, rest = $2ad24e75a96deccc$var$__rest(props, [
        "children",
        "isOpen",
        "maxWidth",
        "width",
        "inNavbar",
        "className"
    ]);
    const { isDark: isDark } = (0, $acw62.useContext)($2ad24e75a96deccc$var$NavbarContext);
    const classNames = `helix-unified-nav__dropdown-menu ${className ? className : ""}`;
    if (typeof document === "undefined") return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, $1u0KT.createPortal)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$StyledDropdownMenu, Object.assign({
        ref: ref,
        isOpen: isOpen,
        maxWidth: maxWidth,
        width: width,
        isDark: isDark,
        inNavbar: inNavbar,
        className: classNames
    }, rest), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children)), document.body));
});
/* eslint-disable @typescript-eslint/no-explicit-any */ const $2ad24e75a96deccc$var$useDropdownMenu$1 = ({ items: items, placement: placement = "bottom-start", itemToString: itemToString = (item)=>item, offset: offset = [
    0,
    10
], loopItemsOnKeyDown: loopItemsOnKeyDown = true, closeMenuOnLastItem: closeMenuOnLastItem = false, closeMenuOnFirstItem: closeMenuOnFirstItem = false, resetSelectedItemOnClose: resetSelectedItemOnClose = false })=>{
    const referenceElement = (0, $acw62.useRef)(null);
    const popperElement = (0, $acw62.useRef)(null);
    const modifiers = (0, $acw62.useMemo)(()=>[
            {
                name: "sameWidth",
                enabled: true,
                fn: ({ state: state })=>{
                    state.styles.popper.width = `${state.rects.reference.width}px`;
                },
                phase: "beforeWrite",
                requires: [
                    "computeStyles"
                ]
            },
            {
                name: "offset",
                options: {
                    offset: offset
                }
            }
        ], []);
    const { styles: styles, attributes: attributes, update: update } = (0, $5fbf42b40e8ead34$export$f4d5bf230a36dd6e)(referenceElement.current, popperElement.current, {
        placement: placement,
        modifiers: modifiers
    });
    const stateReducer = (state, actionAndChanges)=>{
        const { type: type, changes: changes } = actionAndChanges;
        switch(type){
            case (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.MenuKeyDownArrowDown:
                if (closeMenuOnLastItem && state.highlightedIndex === items.length - 1) return Object.assign(Object.assign({}, changes), {
                    isOpen: false
                });
                if (state.highlightedIndex === items.length - 1 && loopItemsOnKeyDown) {
                    let newHighlightedIndex = 0;
                    //if the first item is a header set the highlighted index to 1
                    if (items[0].header) newHighlightedIndex = 1;
                    return Object.assign(Object.assign({}, changes), {
                        isOpen: true,
                        highlightedIndex: newHighlightedIndex
                    });
                }
                return Object.assign(Object.assign({}, changes), {
                    isOpen: true
                });
            case (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.MenuKeyDownArrowUp:
                if (closeMenuOnFirstItem && state.highlightedIndex === 0) return Object.assign(Object.assign({}, changes), {
                    isOpen: false,
                    highlightedIndex: -1
                });
                // if the first item is a header and the user is on the first
                // item, set the highlighted index to the last item
                if (state.highlightedIndex === 1 && items[0].header && loopItemsOnKeyDown) return Object.assign(Object.assign({}, changes), {
                    isOpen: true,
                    highlightedIndex: items.length - 1
                });
                if (state.highlightedIndex === 0 && loopItemsOnKeyDown) return Object.assign(Object.assign({}, changes), {
                    isOpen: true,
                    highlightedIndex: items.length - 1
                });
                return Object.assign(Object.assign({}, changes), {
                    isOpen: true
                });
            case (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.MenuKeyDownEnter:
            case (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.MenuKeyDownSpaceButton:
                if (items[state.highlightedIndex] && items[state.highlightedIndex].menuItems) return Object.assign(Object.assign({}, changes), {
                    highlightedIndex: state.highlightedIndex,
                    isOpen: true
                });
                if (type === (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.MenuKeyDownEnter) {
                    if (items[state.highlightedIndex] && items[state.highlightedIndex].onClick) items[state.highlightedIndex].onClick();
                }
                if (resetSelectedItemOnClose) return Object.assign(Object.assign({}, changes), {
                    isOpen: false,
                    selectedItem: -1,
                    highlightedIndex: -1
                });
                return Object.assign({}, changes);
            case (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.ItemClick:
                if (items[state.highlightedIndex] && items[state.highlightedIndex].onClick) items[state.highlightedIndex].onClick();
                if (resetSelectedItemOnClose) return Object.assign(Object.assign({}, changes), {
                    isOpen: false,
                    selectedItem: -1,
                    highlightedIndex: -1
                });
                return Object.assign({}, changes);
            default:
                return changes; // otherwise business as usual.
        }
    };
    const { isOpen: isOpen, getToggleButtonProps: getToggleButtonProps, getMenuProps: getMenuProps, highlightedIndex: highlightedIndex, selectedItem: selectedItem, getItemProps: getItemProps, openMenu: openMenu } = (0, $6260541dc56be833$export$e64b2f635402ca43)({
        items: items,
        itemToString: itemToString,
        stateReducer: stateReducer
    });
    (0, $acw62.useEffect)(()=>{
        update && update();
    }, [
        isOpen
    ]);
    (0, $acw62.useEffect)(()=>{
        setTimeout(()=>{
            var _a;
            const activeId = (_a = document.activeElement) === null || _a === void 0 ? void 0 : _a.id;
            if (activeId === null || activeId === void 0 ? void 0 : activeId.includes("pendo")) openMenu();
        }, 0);
    }, [
        isOpen
    ]);
    return {
        isOpen: isOpen,
        getToggleButtonProps: getToggleButtonProps,
        getMenuProps: getMenuProps,
        highlightedIndex: highlightedIndex,
        selectedItem: selectedItem,
        getItemProps: getItemProps,
        setReferenceElement: (element)=>{
            referenceElement.current = element;
        },
        setPopperElement: (element)=>{
            popperElement.current = element;
        },
        attributes: attributes,
        styles: styles,
        update: update
    };
};
const $2ad24e75a96deccc$var$DropdownMenuItem = (_a)=>{
    var _b, _c, _d, _e, _f, _g, _h, _j;
    var { menuItem: menuItem, highlightedIndex: highlightedIndex, index: index, getItemProps: getItemProps, itemFormatter: itemFormatter, linkWrapper: linkWrapper, itemVisible: itemVisible, className: className, onClick: onClick, useChildrenInProps: useChildrenInProps = false, useCheckmarkActive: useCheckmarkActive = false } = _a, rest = $2ad24e75a96deccc$var$__rest(_a, [
        "menuItem",
        "highlightedIndex",
        "index",
        "getItemProps",
        "itemFormatter",
        "linkWrapper",
        "itemVisible",
        "className",
        "onClick",
        "useChildrenInProps",
        "useCheckmarkActive"
    ]);
    const activeCheckmark = useCheckmarkActive && (menuItem.active || menuItem.defaultOption) ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
        icon: (0, $c761e69c8e58189a$exports.checkmark)
    }) : null;
    const itemContent = (menuItem)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "dropdown-menu-item-content"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, typeof menuItem.label === "function" ? menuItem.label(menuItem) : menuItem.label, menuItem.badge && menuItem.badge.label !== undefined && !menuItem.badge.hidden && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarBadge, null, menuItem.badge.label)), activeCheckmark));
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", Object.assign({
        className: `${index === highlightedIndex ? "highlighted" : ""}
    ${menuItem.disabled ? " disabled" : ""} ${menuItem.active && !useCheckmarkActive ? "active" : ""} ${menuItem.divider ? "divider" : ""} ${menuItem.header ? "section-header section-header-bold" : ""} 
            ${menuItem.readOnly ? "item-read-only" : ""}
            ${className}
    `
    }, rest, getItemProps({
        item: menuItem,
        disabled: menuItem.disabled || itemVisible || menuItem.divider || menuItem.header,
        index: index,
        onClick: (e)=>{
            onClick && onClick(e);
        },
        id: typeof menuItem.label === "string" && menuItem.label ? "dropdown-menu-item-" + menuItem.label.replace(/ /g, "-").toLowerCase() : undefined
    })), menuItem.url ? menuItem.disabled ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "menu-item-content-wrapper"
    }, itemFormatter ? itemFormatter(menuItem) : itemContent(menuItem)) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, linkWrapper ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(linkWrapper({
        item: menuItem,
        props: {}
    }), {
        children: $2ad24e75a96deccc$var$checkIfChildIsA(linkWrapper, menuItem) ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement((_c = linkWrapper({
            item: menuItem,
            props: Object.assign({}, (_b = linkWrapper({
                item: menuItem,
                props: {
                    children: useChildrenInProps ? itemContent(menuItem) : null
                }
            })) === null || _b === void 0 ? void 0 : _b.props)
        })) === null || _c === void 0 ? void 0 : _c.props.children, {
            children: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (_e = linkWrapper({
                item: menuItem,
                props: Object.assign({}, (_d = linkWrapper({
                    item: menuItem,
                    props: {
                        children: useChildrenInProps ? itemContent(menuItem) : null
                    }
                })) === null || _d === void 0 ? void 0 : _d.props)
            })) === null || _e === void 0 ? void 0 : _e.props.children.props.children, menuItem.badge && menuItem.badge.label !== undefined && !menuItem.badge.hidden && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarBadge, null, menuItem.badge.label))
        }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, ((_f = linkWrapper({
            item: menuItem,
            props: {
                children: useChildrenInProps ? itemContent(menuItem) : null
            }
        })) === null || _f === void 0 ? void 0 : _f.props) && ((_g = linkWrapper({
            item: menuItem,
            props: {
                children: useChildrenInProps ? itemContent(menuItem) : null
            }
        })) === null || _g === void 0 ? void 0 : _g.props.children) && ((_j = linkWrapper({
            item: menuItem,
            props: Object.assign({}, (_h = linkWrapper({
                item: menuItem,
                props: {
                    children: useChildrenInProps ? itemContent(menuItem) : null
                }
            })) === null || _h === void 0 ? void 0 : _h.props)
        })) === null || _j === void 0 ? void 0 : _j.props.children), menuItem.badge && menuItem.badge.label !== undefined && !menuItem.badge.hidden && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarBadge, null, menuItem.badge.label))
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", Object.assign({
        href: menuItem.url
    }, $2ad24e75a96deccc$var$getTarget(menuItem)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, itemFormatter ? itemFormatter(menuItem) : itemContent(menuItem)))) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "menu-item-content-wrapper"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, " ", itemFormatter ? itemFormatter(menuItem) : itemContent(menuItem))));
};
/* eslint-disable @typescript-eslint/no-explicit-any */ const $2ad24e75a96deccc$var$NavbarDropdownNavItem = ({ navItem: navItem, linkWrapper: linkWrapper, location: location })=>{
    const { isOpen: isOpen, getToggleButtonProps: getToggleButtonProps, getMenuProps: getMenuProps, highlightedIndex: highlightedIndex, getItemProps: getItemProps, setReferenceElement: setReferenceElement, setPopperElement: setPopperElement, attributes: attributes, styles: styles } = $2ad24e75a96deccc$var$useDropdownMenu$1({
        placement: "bottom-end",
        items: navItem.menuItems,
        resetSelectedItemOnClose: true,
        itemToString: (item)=>item.label ? item.label : "",
        offset: [
            0,
            8
        ]
    });
    const menuRef = (0, $acw62.useRef)(null);
    const isActive = ()=>{
        if (navItem.menuItems) return navItem.menuItems.filter((item)=>item.url === location.pathname).length > 0 || navItem.menuItems.filter((item)=>item.active).length > 0 || navItem.menuItems.filter((item)=>item.activePathname === location.pathname).length > 0 || navItem.active;
        return navItem.url === location.pathname || navItem.active;
    };
    const handleKeyDown = (e)=>{
        $2ad24e75a96deccc$var$clickDropdownItem(e, menuRef);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "helix-unified-nav__navigation-item-dropdown-wrapper"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", Object.assign({}, getToggleButtonProps({
        ref: setReferenceElement,
        id: "nav-item-dropdown-" + navItem.label.replace(/ /g, "-")
    }), {
        disabled: navItem.disabled,
        className: isActive() ? "helix-unified-nav__navigation-item helix-unified-nav__navigation-item-dropdown active" : "helix-unified-nav__navigation-item helix-unified-nav__navigation-item-dropdown"
    }), navItem.label, " ", (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarHelixIcon, {
        iconName: "dropdown_open"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$DropdownMenu, Object.assign({
        maxWidth: "300px",
        ref: setPopperElement,
        isOpen: isOpen,
        style: styles.popper,
        className: "helix-unified-nav__notification-dropdown-menu"
    }, attributes.popper), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", Object.assign({}, getMenuProps({
        onKeyDown: (e)=>handleKeyDown(e),
        ref: (ref)=>menuRef.current = ref,
        id: "nav-item-dropdown-" + navItem.label.replace(/ /g, "-") + "-menu"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, navItem.menuItems && navItem.menuItems.map((menuItem, index)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$DropdownMenuItem, {
            className: `${menuItem.url === location.pathname || menuItem.activePathname && menuItem.activePathname === location.pathname || menuItem.active || menuItem.activePathname === location.pathname ? "selected-item" : ""}`,
            menuItem: menuItem,
            highlightedIndex: highlightedIndex,
            index: index,
            linkWrapper: linkWrapper,
            getItemProps: getItemProps,
            key: `${menuItem.label}${index}`
        }))))));
};
const $2ad24e75a96deccc$var$NavbarMenuItem = (_a)=>{
    var { menuItem: menuItem, highlightedIndex: highlightedIndex, index: index, location: location, getItemProps: getItemProps, itemFormatter: itemFormatter, linkWrapper: linkWrapper, className: className, menuOpen: menuOpen } = _a, rest = $2ad24e75a96deccc$var$__rest(_a, [
        "menuItem",
        "highlightedIndex",
        "index",
        "location",
        "getItemProps",
        "itemFormatter",
        "linkWrapper",
        "className",
        "menuOpen"
    ]);
    const [isOpen, setIsOpen] = (0, $acw62.useState)(false);
    const menuRef = (0, $acw62.useRef)(null);
    const useCheckmarkActive = false;
    const activeCheckmark = null;
    const formatMenuItem = ()=>itemFormatter ? itemFormatter(menuItem) : menuItem.label;
    const itemContent = (menuItem)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "dropdown-menu-item-content"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, menuItem.label, menuItem.badge && menuItem.badge.label !== undefined && !menuItem.badge.hidden && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarBadge, null, menuItem.badge.label)), activeCheckmark));
    };
    const renderDropdownItem = (dropdownItem, dropdownIndex, isChild = false)=>{
        var _a, _b, _c, _d, _e, _f, _g, _h;
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", Object.assign({
            key: dropdownIndex,
            className: `
                ${dropdownIndex === highlightedIndex ? "highlighted" : ""}
                ${dropdownItem.active && !useCheckmarkActive ? "active" : ""} 
                ${dropdownItem.divider ? "divider" : ""} 
                ${dropdownItem.header ? "section-header section-header-bold" : ""} 
                ${isChild ? "helix-dropdown-menu__sub-menu-item" : ""}
                ${dropdownItem.disabled ? " disabled" : ""} 
                ${isChild && !isOpen ? "helix-dropdown-menu__sub-menu-item--closed" : ""}
                ${dropdownItem.url && dropdownItem.url === (location === null || location === void 0 ? void 0 : location.pathname) || dropdownItem.active || dropdownItem.activePathname && dropdownItem.activePathname === (location === null || location === void 0 ? void 0 : location.pathname) ? "selected-item" : ""}
                ${className ? className : ""}
            `
        }, rest, getItemProps({
            item: dropdownItem,
            disabled: dropdownItem.disabled || isChild && !isOpen || dropdownItem.divider || dropdownItem.header,
            index: dropdownIndex,
            ref: (ref)=>menuRef.current = ref,
            id: dropdownItem.label ? "navbar-menu-item-" + dropdownItem.label.replace(/ /g, "-").toLocaleLowerCase() : undefined
        })), dropdownItem.url ? dropdownItem.disabled ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "menu-item-content-wrapper"
        }, itemFormatter ? itemFormatter(dropdownItem) : dropdownItem.label) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, linkWrapper ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(linkWrapper({
            item: dropdownItem,
            props: {}
        }), {
            children: $2ad24e75a96deccc$var$checkIfChildIsA(linkWrapper, dropdownItem) ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement((_b = linkWrapper({
                item: dropdownItem,
                props: Object.assign({}, (_a = linkWrapper({
                    item: dropdownItem,
                    props: {
                        children: null
                    }
                })) === null || _a === void 0 ? void 0 : _a.props)
            })) === null || _b === void 0 ? void 0 : _b.props.children, {
                children: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (_d = linkWrapper({
                    item: dropdownItem,
                    props: Object.assign({}, (_c = linkWrapper({
                        item: dropdownItem,
                        props: {
                            children: null
                        }
                    })) === null || _c === void 0 ? void 0 : _c.props)
                })) === null || _d === void 0 ? void 0 : _d.props.children.props.children, dropdownItem.badge && dropdownItem.badge.label !== undefined && !dropdownItem.badge.hidden && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarBadge, null, dropdownItem.badge.label))
            }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, ((_e = linkWrapper({
                item: dropdownItem,
                props: {
                    children: null
                }
            })) === null || _e === void 0 ? void 0 : _e.props) && ((_f = linkWrapper({
                item: dropdownItem,
                props: {
                    children: null
                }
            })) === null || _f === void 0 ? void 0 : _f.props.children) && ((_h = linkWrapper({
                item: dropdownItem,
                props: Object.assign({}, (_g = linkWrapper({
                    item: dropdownItem,
                    props: {
                        children: null
                    }
                })) === null || _g === void 0 ? void 0 : _g.props)
            })) === null || _h === void 0 ? void 0 : _h.props.children), dropdownItem.badge && dropdownItem.badge.label !== undefined && !dropdownItem.badge.hidden && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarBadge, null, dropdownItem.badge.label))
        }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", Object.assign({
            href: dropdownItem.url
        }, $2ad24e75a96deccc$var$getTarget(dropdownItem)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, itemFormatter ? itemFormatter(dropdownItem) : itemContent(dropdownItem)))) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "menu-item-content-wrapper"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, " ", itemFormatter ? itemFormatter(dropdownItem) : itemContent(dropdownItem))));
    };
    (0, $acw62.useEffect)(()=>{
        if (menuItem.toggleDropdown !== undefined) setIsOpen((prev)=>!prev);
    }, [
        menuItem.toggleDropdown
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, menuItem.menuItems ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", Object.assign({
        className: `
                            ${menuItem.menuItems ? "helix-dropdown-menu__overflow-dropdown-item" : ""} 
                            ${index === highlightedIndex ? "highlighted" : ""}
                            ${menuItem.disabled ? " disabled" : ""} 
                            ${className ? className : ""}`
    }, rest, getItemProps({
        item: menuItem,
        disabled: menuItem.disabled,
        index: index,
        id: menuItem.label ? "navbar-menu-item-" + menuItem.label.replace(/ /g, "-").toLocaleLowerCase() : undefined
    }), {
        onClick: ()=>setIsOpen((prev)=>!prev)
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "menu-item-content-wrapper"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "menu-item-label"
    }, menuItem.url && !menuItem.disabled ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, linkWrapper && menuItem == undefined ? linkWrapper({
        item: menuItem
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
        href: menuItem.url
    }, formatMenuItem())) : formatMenuItem()), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarHelixIcon, {
        iconName: isOpen ? "dropdown_open" : "dropdown_closed"
    }))), menuItem.menuItems.map((dropdownItem, dropdownIndex)=>renderDropdownItem(dropdownItem, index + dropdownIndex + 1, true))) : renderDropdownItem(menuItem, index));
};
/* eslint-disable max-len */ const $2ad24e75a96deccc$export$1b39242710ff4744 = ({ moreLabel: moreLabel = "More", navItems: navItems = [], location: location = {
    pathname: ""
}, hideMoreDropdownArrow: hideMoreDropdownArrow = false, dataLwtId: dataLwtId = "navbar-navigation-bar", className: className, linkWrapper: linkWrapper, dropdownsExpandedByDefault: dropdownsExpandedByDefault = false })=>{
    const navigationBarRef = (0, $acw62.useRef)({});
    const overflowMenuButton = (0, $acw62.useRef)(null);
    const itemsWrapperRef = (0, $acw62.useRef)({});
    const moreButtonWrapperRef = (0, $acw62.useRef)({});
    const { isDark: isDark, setNavItems: setNavItems, setLocation: setLocation, setNavbarLinkWrapper: setNavbarLinkWrapper, setDropdownsExpandedByDefault: setDropdownsExpandedByDefault, hasAdditionalNavItems: hasAdditionalNavItems } = (0, $acw62.useContext)($2ad24e75a96deccc$var$NavbarContext);
    const [collections, setCollections] = (0, $acw62.useState)({
        items: navItems,
        overflowItems: []
    });
    const menuRef = (0, $acw62.useRef)(null);
    const lastItemWidth = (0, $acw62.useRef)(undefined);
    const totalItemsWidth = (0, $acw62.useRef)(0);
    // flat list of menu items needed for downshift. this same list is needed when selecting by `highlightedIndex`
    const getFlattenedOverflowItems = ()=>collections.overflowItems.some((item)=>item === null || item === void 0 ? void 0 : item.menuItems) ? collections.overflowItems.reduce((acc, val)=>{
            acc.push(val);
            if (val === null || val === void 0 ? void 0 : val.menuItems) acc.push(...val.menuItems);
            return acc;
        }, []) : collections.overflowItems;
    const { isOpen: isOpen, getToggleButtonProps: getToggleButtonProps, getMenuProps: getMenuProps, highlightedIndex: highlightedIndex, getItemProps: getItemProps, setReferenceElement: setReferenceElement, setPopperElement: setPopperElement, attributes: attributes, styles: styles } = (0, $1c94395e3d071205$exports.useDropdownMenu)({
        placement: "bottom-end",
        items: getFlattenedOverflowItems(),
        itemToString: (item)=>item.label ? item.label : "",
        resetSelectedItemOnClose: true,
        offset: [
            0,
            8
        ]
    });
    const shiftIntoOverflowItems = ()=>{
        var _a;
        lastItemWidth.current = getFullWidth((_a = itemsWrapperRef === null || itemsWrapperRef === void 0 ? void 0 : itemsWrapperRef.current) === null || _a === void 0 ? void 0 : _a.lastElementChild);
        const newColl = copyCollections();
        newColl.overflowItems.unshift(newColl.items[newColl.items.length - 1]);
        newColl.items.pop();
        setCollections(newColl);
    };
    const shiftIntoItems = ()=>{
        var _a;
        const newColl = copyCollections();
        newColl.items.push(newColl.overflowItems[0]);
        newColl.overflowItems.shift();
        setCollections(newColl);
        lastItemWidth.current = getFullWidth((_a = itemsWrapperRef === null || itemsWrapperRef === void 0 ? void 0 : itemsWrapperRef.current) === null || _a === void 0 ? void 0 : _a.lastElementChild);
    };
    const copyCollections = ()=>{
        return {
            items: [
                ...collections.items
            ],
            overflowItems: [
                ...collections.overflowItems
            ]
        };
    };
    const isOverflowing = ()=>navigationBarRef.current && navigationBarRef.current.offsetWidth < navigationBarRef.current.scrollWidth;
    const isUnderflowing = ()=>{
        var _a;
        return navigationBarRef.current && totalItemsWidth.current + ((_a = lastItemWidth === null || lastItemWidth === void 0 ? void 0 : lastItemWidth.current) !== null && _a !== void 0 ? _a : 0) < navigationBarRef.current.scrollWidth;
    };
    const updateItems = ()=>{
        if (!(navigationBarRef === null || navigationBarRef === void 0 ? void 0 : navigationBarRef.current) || (lastItemWidth === null || lastItemWidth === void 0 ? void 0 : lastItemWidth.current) === 0) return;
        if ((collections === null || collections === void 0 ? void 0 : collections.items.length) > 0 && isOverflowing()) shiftIntoOverflowItems();
        else if ((collections === null || collections === void 0 ? void 0 : collections.overflowItems.length) > 0 && isUnderflowing()) shiftIntoItems();
    };
    const handleDropdownToggleKeydown = (e)=>{
        if (e.key === "Enter" || e.key === " ") {
            e.stopPropagation();
            e.preventDefault();
            const menuItem = getFlattenedOverflowItems()[highlightedIndex];
            menuItem.toggleDropdown = !menuItem.toggleDropdown;
        }
        $2ad24e75a96deccc$var$clickDropdownItem(e, menuRef);
    };
    const navItemProps = (navItem)=>{
        return {
            disabled: navItem.disabled,
            className: navItem.url === location.pathname || navItem.active || navItem.activePathname === location.pathname ? "helix-unified-nav__navigation-item active" : "helix-unified-nav__navigation-item"
        };
    };
    const linkWrapperElement = (navItem)=>{
        var _a, _b;
        return linkWrapper ? (_b = linkWrapper({
            item: navItem,
            props: Object.assign(Object.assign({}, (_a = linkWrapper({
                item: navItem,
                props: navItemProps(navItem)
            })) === null || _a === void 0 ? void 0 : _a.props), {
                disabled: navItem.disabled,
                className: navItem.url === location.pathname || navItem.active || navItem.activePathname === location.pathname ? "helix-unified-nav__navigation-item active" : "helix-unified-nav__navigation-item"
            })
        })) === null || _b === void 0 ? void 0 : _b.props.children : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
    };
    const getFullWidth = (element)=>{
        var _a;
        if (!element || element === null) return undefined;
        const laststyle = window.getComputedStyle(element);
        const margin = parseFloat(laststyle.marginLeft) + parseFloat(laststyle.marginRight);
        const width = ((_a = element.offsetWidth) !== null && _a !== void 0 ? _a : 0) + margin;
        return isNaN(width) ? 0 : width;
    };
    (0, $acw62.useEffect)(()=>{
        setNavItems([
            ...navItems
        ]);
        setCollections({
            items: navItems,
            overflowItems: []
        });
    }, [
        navItems
    ]);
    (0, $acw62.useEffect)(()=>{
        setLocation(location.pathname);
    }, [
        location
    ]);
    (0, $acw62.useEffect)(()=>{
        if (linkWrapper) setNavbarLinkWrapper(()=>linkWrapper);
    }, [
        linkWrapper
    ]);
    (0, $acw62.useEffect)(()=>{
        setDropdownsExpandedByDefault(dropdownsExpandedByDefault);
    }, [
        dropdownsExpandedByDefault
    ]);
    (0, $acw62.useEffect)(()=>{
        var _a;
        const moreButtonSize = (_a = getFullWidth(moreButtonWrapperRef.current)) !== null && _a !== void 0 ? _a : 0;
        totalItemsWidth.current = Array.from(itemsWrapperRef.current.children).map((e)=>{
            var _a;
            return (_a = getFullWidth(e)) !== null && _a !== void 0 ? _a : 0;
        }).reduce((acc, curr)=>acc + curr, 0) + moreButtonSize;
        updateItems();
        // Limiting the rate of update calls to every 25ms
        // until no resizing has occurred after 100ms
        let timeout;
        let interval = undefined;
        const listener = ()=>{
            // reset timer since window is still resizing
            clearTimeout(timeout);
            timeout = setTimeout(()=>{
                // no resizing in the last 100ms so stop periodic update
                clearInterval(interval);
                interval = undefined;
                updateItems();
            }, 100);
            // call update every 25ms if not started
            !interval && (interval = setInterval(()=>updateItems(), 25));
        };
        window.addEventListener("resize", listener);
        return ()=>{
            clearTimeout(timeout);
            clearInterval(interval);
            window.removeEventListener("resize", listener);
        };
    }, [
        collections
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$StyledNavbarNav, {
        ref: navigationBarRef,
        "$isDark": isDark,
        "$hasAdditionalNavItems": hasAdditionalNavItems,
        "$hasOverflowItems": collections.overflowItems.length > 0,
        className: `helix-unified-nav__navigation ${className ? className : ""}`,
        "data-lwt-id": dataLwtId
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: itemsWrapperRef,
        className: "helix-unified-nav__navigation-items-wrapper"
    }, collections.items.map((navItem)=>{
        var _a, _b;
        return navItem && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
            key: `nav-bar-item-${navItem.label}`
        }, navItem.menuItems ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarDropdownNavItem, {
            location: location,
            linkWrapper: linkWrapper,
            navItem: navItem
        }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
            key: `nav-bar-item-${navItem.label}`
        }, navItem.onClick ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
            className: navItem.url === location.pathname || navItem.active || navItem.activePathname === location.pathname ? "helix-unified-nav__navigation-item active" : "helix-unified-nav__navigation-item",
            disabled: navItem.disabled,
            onClick: (e)=>navItem.onClick && navItem.onClick(e)
        }, navItem.label, navItem.badge && navItem.badge.label !== undefined && !navItem.badge.hidden && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarBadge, {
            isDark: isDark
        }, navItem.badge.label)) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, linkWrapper ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(linkWrapper({
            item: navItem,
            props: {
                disabled: navItem.disabled,
                className: navItem.url === location.pathname || navItem.active || navItem.activePathname === location.pathname ? "helix-unified-nav__navigation-item active" : "helix-unified-nav__navigation-item"
            }
        }), {
            disabled: navItem.disabled,
            className: navItem.url === location.pathname || navItem.active || navItem.activePathname === location.pathname ? "helix-unified-nav__navigation-item active" : "helix-unified-nav__navigation-item",
            children: $2ad24e75a96deccc$var$checkIfChildIsA(linkWrapper, navItem) ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(linkWrapperElement(navItem), {
                children: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (_b = linkWrapper({
                    item: navItem,
                    props: Object.assign({}, (_a = linkWrapper({
                        item: navItem,
                        props: navItemProps(navItem)
                    })) === null || _a === void 0 ? void 0 : _a.props)
                })) === null || _b === void 0 ? void 0 : _b.props.children.props.children, navItem.badge && navItem.badge.label !== undefined && !navItem.badge.hidden && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarBadge, null, navItem.badge.label))
            }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, linkWrapperElement(navItem), navItem.badge && navItem.badge.label !== undefined && !navItem.badge.hidden && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarBadge, null, navItem.badge.label))
        }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", Object.assign({
            href: navItem.url,
            key: `nav-bar-item-${navItem.label}`,
            className: navItem.url === location.pathname || navItem.active || navItem.activePathname === location.pathname ? `helix-unified-nav__navigation-item active ${navItem.disabled ? "disabled" : ""}` : `helix-unified-nav__navigation-item ${navItem.disabled ? "disabled" : ""}`,
            onClick: (e)=>{
                if (navItem.disabled) {
                    e.preventDefault();
                    return;
                }
                navItem.onClick && navItem.onClick(e);
            }
        }, $2ad24e75a96deccc$var$getTarget(navItem)), navItem.label, navItem.badge && navItem.badge.label && !navItem.badge.hidden && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarBadge, {
            isDark: isDark
        }, navItem.badge.label))))));
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "helix-unified-nav__overflow-button-wrapper",
        ref: (ref)=>{
            moreButtonWrapperRef.current = ref;
            setReferenceElement(ref);
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", Object.assign({
        className: "helix-unified-nav__navigation-item helix-unified-nav__navigation-item_more"
    }, getToggleButtonProps({
        ref: overflowMenuButton
    }, {
        suppressRefError: true
    })), moreLabel, !hideMoreDropdownArrow && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarHelixIcon, {
        iconName: "dropdown_open"
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$DropdownMenu, Object.assign({
        inNavbar: true,
        maxWidth: "300px",
        ref: setPopperElement,
        isOpen: isOpen && collections.overflowItems.length > 0,
        className: "helix-unified-nav__overflow-dropdown-menu",
        style: styles.popper
    }, attributes.popper), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", Object.assign({}, getMenuProps({
        onKeyDown: (e)=>handleDropdownToggleKeydown(e),
        ref: (ref)=>menuRef.current = ref
    }, {
        suppressRefError: true
    })), collections.overflowItems.map((overflowItem, index)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarMenuItem, {
            menuOpen: isOpen,
            linkWrapper: linkWrapper,
            key: `${overflowItem.label}${index}`,
            menuItem: overflowItem,
            highlightedIndex: highlightedIndex,
            index: index + collections.overflowItems.filter((overflowItem, oIndex)=>overflowItem.menuItems && oIndex < index).reduce((acc, cur)=>{
                var _a, _b;
                return acc + ((_b = (_a = cur.menuItems) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0);
            }, 0),
            location: location,
            getItemProps: getItemProps
        })))));
};
$2ad24e75a96deccc$export$1b39242710ff4744.displayName = "NavbarNavigationBar";
const $2ad24e75a96deccc$export$7fc3f68d5abe597e = (_a)=>{
    var { children: children, dataLwtId: dataLwtId = "navbar-body", className: className } = _a, rest = $2ad24e75a96deccc$var$__rest(_a, [
        "children",
        "dataLwtId",
        "className"
    ]);
    const { setHasBody: setHasBody } = (0, $acw62.useContext)($2ad24e75a96deccc$var$NavbarContext);
    (0, $acw62.useEffect)(()=>{
        setHasBody(true);
        return ()=>{
            setHasBody(false);
        };
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$StyledNavbarBody, Object.assign({
        className: `helix-unified-navbar__body ${className ? className : ""}`,
        "data-lwt-id": dataLwtId
    }, rest), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children));
};
$2ad24e75a96deccc$export$7fc3f68d5abe597e.displayName = "NavbarBody";
const $2ad24e75a96deccc$export$eb9291b5cfed8fe1 = (_a)=>{
    var { children: children, dataLwtId: dataLwtId = "navbar-additional-items" } = _a, rest = $2ad24e75a96deccc$var$__rest(_a, [
        "children",
        "dataLwtId"
    ]);
    const { isDark: isDark, navItems: navItems, hasBody: hasBody, setHasAdditionalNavItems: setHasAdditionalNavItems } = (0, $acw62.useContext)($2ad24e75a96deccc$var$NavbarContext);
    (0, $acw62.useEffect)(()=>{
        setHasAdditionalNavItems(true);
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$StyledNavbarAdditionalItems, Object.assign({
        "$isDark": isDark,
        className: "helix-unified-nav__additional-items",
        "data-lwt-id": dataLwtId,
        "$hasNavItems": navItems.length > 0 || hasBody
    }, rest), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children));
};
$2ad24e75a96deccc$export$eb9291b5cfed8fe1.displayName = "NavbarAdditionalItems";
var $2ad24e75a96deccc$var$css_248z$2 = ".Avatar-module_helix-avatar__2hlDj{display:inline-flex;align-items:center;justify-content:center;overflow:hidden;background-color:var(--helix-avatar-bg,var(--helix-gray-400,#9ca3af));color:var(--helix-avatar-text,var(--helix-black,#000));font-weight:600;text-transform:uppercase}.Avatar-module_helix-avatar--size-xx-tiny__3Xwzm{width:18px;height:18px;font-size:8px;--avatar-svg-scale:0.55}.Avatar-module_helix-avatar--size-x-tiny__3OUyu{width:24px;height:24px;font-size:10px;--avatar-svg-scale:0.75}.Avatar-module_helix-avatar--size-tiny__2pnoA{width:32px;height:32px;font-size:14px;--avatar-svg-scale:1}.Avatar-module_helix-avatar--size-small__1H8UT{width:48px;height:48px;font-size:20px;--avatar-svg-scale:1.5}.Avatar-module_helix-avatar--size-medium__eK33w{width:60px;height:60px;font-size:24px;--avatar-svg-scale:1.9}.Avatar-module_helix-avatar--size-large__1RSH-{width:90px;height:90px;font-size:38px;--avatar-svg-scale:2.8}.Avatar-module_helix-avatar--size-x-large__3SNzw{width:120px;height:120px;font-size:48px;--avatar-svg-scale:3.75}.Avatar-module_helix-avatar--size-xx-large__1FKWR{width:150px;height:150px;font-size:58px;--avatar-svg-scale:4.7}.Avatar-module_helix-avatar--shape-round__3dgGU{border-radius:50%}.Avatar-module_helix-avatar--shape-rounded__3GlxE{border-radius:10px}.Avatar-module_helix-avatar--shape-rounded__3GlxE.Avatar-module_helix-avatar--size-xx-tiny__3Xwzm{border-radius:2px}.Avatar-module_helix-avatar--shape-rounded__3GlxE.Avatar-module_helix-avatar--size-x-tiny__3OUyu{border-radius:4px}.Avatar-module_helix-avatar--shape-rounded__3GlxE.Avatar-module_helix-avatar--size-tiny__2pnoA{border-radius:6px}.Avatar-module_helix-avatar--shape-rounded__3GlxE.Avatar-module_helix-avatar--size-small__1H8UT{border-radius:8px}.Avatar-module_helix-avatar--shape-rounded__3GlxE.Avatar-module_helix-avatar--size-medium__eK33w{border-radius:10px}.Avatar-module_helix-avatar--shape-rounded__3GlxE.Avatar-module_helix-avatar--size-large__1RSH-{border-radius:12px}.Avatar-module_helix-avatar--shape-rounded__3GlxE.Avatar-module_helix-avatar--size-x-large__3SNzw{border-radius:14px}.Avatar-module_helix-avatar--shape-rounded__3GlxE.Avatar-module_helix-avatar--size-xx-large__1FKWR{border-radius:16px}.Avatar-module_helix-avatar__2hlDj img{width:100%;height:100%;object-fit:cover;display:block}.Avatar-module_helix-avatar__2hlDj svg{transform:scale(var(--avatar-svg-scale,1))}.Avatar-module_helix-avatar__2hlDj svg path{fill:var(--helix-avatar-icon,var(--helix-white,#fff))}.Avatar-module_helix-avatar__icon__3qdYc{display:inline-flex;align-items:center;justify-content:center}";
var $2ad24e75a96deccc$var$styles$1 = {
    "helix-avatar": "Avatar-module_helix-avatar__2hlDj",
    "helix-avatar--size-xx-tiny": "Avatar-module_helix-avatar--size-xx-tiny__3Xwzm",
    "helix-avatar--size-x-tiny": "Avatar-module_helix-avatar--size-x-tiny__3OUyu",
    "helix-avatar--size-tiny": "Avatar-module_helix-avatar--size-tiny__2pnoA",
    "helix-avatar--size-small": "Avatar-module_helix-avatar--size-small__1H8UT",
    "helix-avatar--size-medium": "Avatar-module_helix-avatar--size-medium__eK33w",
    "helix-avatar--size-large": "Avatar-module_helix-avatar--size-large__1RSH-",
    "helix-avatar--size-x-large": "Avatar-module_helix-avatar--size-x-large__3SNzw",
    "helix-avatar--size-xx-large": "Avatar-module_helix-avatar--size-xx-large__1FKWR",
    "helix-avatar--shape-round": "Avatar-module_helix-avatar--shape-round__3dgGU",
    "helix-avatar--shape-rounded": "Avatar-module_helix-avatar--shape-rounded__3GlxE",
    "helix-avatar__icon": "Avatar-module_helix-avatar__icon__3qdYc"
};
$2ad24e75a96deccc$var$styleInject($2ad24e75a96deccc$var$css_248z$2);
const $2ad24e75a96deccc$var$translations = {
    en: {
        avatarLabel: "Avatar"
    },
    fr: {
        avatarLabel: "Avatar"
    }
};
const $2ad24e75a96deccc$var$Avatar = (_a)=>{
    var _b, _c;
    var { children: children, size: size = "medium", dataLwtId: dataLwtId, className: className, name: name, shape: shape = "round", useIcon: useIcon = false, icon: icon = (0, $c761e69c8e58189a$exports.agent), labels: labels, locale: locale } = _a, rest = $2ad24e75a96deccc$var$__rest(_a, [
        "children",
        "size",
        "dataLwtId",
        "className",
        "name",
        "shape",
        "useIcon",
        "icon",
        "labels",
        "locale"
    ]);
    let providerLocale;
    try {
        const ctx = (0, $e7307bc387b4b3a0$export$c1fd9f444a3dc711)();
        providerLocale = ctx === null || ctx === void 0 ? void 0 : ctx.language;
    } catch (e) {
        providerLocale = undefined;
    }
    const effectiveLocale = locale || providerLocale || "en";
    const t = (_b = $2ad24e75a96deccc$var$translations[effectiveLocale]) !== null && _b !== void 0 ? _b : $2ad24e75a96deccc$var$translations.en;
    const accessibleLabel = (_c = name !== null && name !== void 0 ? name : labels === null || labels === void 0 ? void 0 : labels.avatarLabel) !== null && _c !== void 0 ? _c : t.avatarLabel;
    const classNameList = $2ad24e75a96deccc$var$classNames($2ad24e75a96deccc$var$styles$1["helix-avatar"], $2ad24e75a96deccc$var$styles$1[`helix-avatar--size-${size}`], $2ad24e75a96deccc$var$styles$1[`helix-avatar--shape-${shape}`], className);
    const generateInitials = (name)=>{
        const names = name.split(" ");
        if (names.length === 1) return names[0].charAt(0);
        return names[0].charAt(0) + names[names.length - 1].charAt(0);
    };
    const generateContent = ()=>{
        if (name && !children && !useIcon) return generateInitials(name);
        if (useIcon && !children) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
            icon: icon,
            className: $2ad24e75a96deccc$var$styles$1["helix-avatar__icon"],
            "aria-hidden": "true"
        });
        return children;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        "data-lwt-id": dataLwtId,
        "aria-label": accessibleLabel
    }, rest, {
        role: "img",
        className: classNameList
    }), generateContent());
};
$2ad24e75a96deccc$var$Avatar.displayName = "Avatar";
const $2ad24e75a96deccc$export$927225dd45e68b72 = (_a)=>{
    var { menuItems: menuItems = [], dataLwtId: dataLwtId = "navbar-user-menu", className: className, linkWrapper: linkWrapper, user: user, location: location, id: id, useIcon: useIcon = false } = _a, rest = $2ad24e75a96deccc$var$__rest(_a, [
        "menuItems",
        "dataLwtId",
        "className",
        "linkWrapper",
        "user",
        "location",
        "id",
        "useIcon"
    ]);
    const { isOpen: isOpen, getToggleButtonProps: getToggleButtonProps, getMenuProps: getMenuProps, highlightedIndex: highlightedIndex, getItemProps: getItemProps, setReferenceElement: setReferenceElement, setPopperElement: setPopperElement, attributes: attributes, styles: styles } = (0, $1c94395e3d071205$exports.useDropdownMenu)({
        placement: "bottom-end",
        items: menuItems,
        resetSelectedItemOnClose: true,
        itemToString: (item)=>{
            const nodeToString = (node)=>{
                var _a;
                if (node == null) return "";
                if (typeof node === "string" || typeof node === "number") return String(node);
                if (Array.isArray(node)) return node.map(nodeToString).join("");
                if ((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(node)) {
                    const children = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray((_a = node.props) === null || _a === void 0 ? void 0 : _a.children);
                    return children.map(nodeToString).join("");
                }
                if (typeof node === "function") // Try calling simple render functions (safe when they don't use hooks).
                try {
                    const res = node();
                    if (res === node) return "";
                    return nodeToString(res);
                } catch (err) {
                    return node.name || "";
                }
                // Fallback for other types
                try {
                    return String(node);
                } catch (_b) {
                    return "";
                }
            };
            if (!item) return "";
            if (typeof item === "string") return item;
            const label = item.label;
            return nodeToString(label);
        },
        offset: [
            0,
            8
        ]
    });
    const { setUserMenuItems: setUserMenuItems, setUserMenuLocation: setUserMenuLocation, setUserMenuLinkWrapper: setUserMenuLinkWrapper, setUserInfo: setUserInfo } = (0, $acw62.useContext)($2ad24e75a96deccc$var$NavbarContext);
    const menuRef = (0, $acw62.useRef)(null);
    const [imageError, setImageError] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        // Reset image error state when avatarURL changes
        if (user === null || user === void 0 ? void 0 : user.avatarURL) setImageError(false);
    }, [
        user === null || user === void 0 ? void 0 : user.avatarURL
    ]);
    (0, $acw62.useEffect)(()=>{
        setUserMenuItems(menuItems);
    }, [
        menuItems
    ]);
    (0, $acw62.useEffect)(()=>{
        if (user && setUserInfo) setUserInfo(user);
    }, [
        user
    ]);
    (0, $acw62.useEffect)(()=>{
        if (linkWrapper) setUserMenuLinkWrapper(()=>linkWrapper);
    }, [
        linkWrapper
    ]);
    (0, $acw62.useEffect)(()=>{
        if (location && location.pathname) setUserMenuLocation(location.pathname);
    }, [
        location
    ]);
    const isActive = ()=>{
        return menuItems ? menuItems.filter((item)=>item.active).length > 0 || location && menuItems.filter((item)=>item.url === (location === null || location === void 0 ? void 0 : location.pathname)).length > 0 : false;
    };
    const handleKeyDown = (e)=>{
        $2ad24e75a96deccc$var$clickDropdownItem(e, menuRef);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$StyledUserMenu, Object.assign({
        ref: setReferenceElement,
        className: `helix-unified-nav__additional-nav-item helix-unified-nav__additional-user-menu-toggle ${className ? className : ""}`,
        "data-lwt-id": dataLwtId
    }, rest), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", Object.assign({}, getToggleButtonProps({
        id: id || "navbar-user-menu-toggle"
    }), {
        "aria-label": "User Menu",
        className: `helix-unified-nav__nav-button helix-unified-nav__nav-button-user ${isActive() ? "active" : ""}`
    }), useIcon ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$ProfileIcon, null) : (user === null || user === void 0 ? void 0 : user.name) ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$Avatar, {
        name: user.name,
        size: "tiny"
    }) : (user === null || user === void 0 ? void 0 : user.avatarURL) && !imageError ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "helix-unified-nav__user-avatar"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: user.avatarURL,
        alt: "avatar",
        onError: ()=>setImageError(true)
    })) : (user === null || user === void 0 ? void 0 : user.name) ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$Avatar, {
        name: user.name,
        size: "tiny"
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$ProfileIcon, null)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$DropdownMenu, Object.assign({
        inNavbar: true,
        maxWidth: "300px",
        ref: setPopperElement,
        isOpen: isOpen,
        style: styles.popper,
        className: "helix-unified-nav__user-dropdown-menu"
    }, attributes.popper), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", Object.assign({}, getMenuProps({
        onKeyDown: (e)=>handleKeyDown(e),
        ref: (ref)=>menuRef.current = ref
    })), menuItems && menuItems.length > 0 && menuItems.map((item, index)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$DropdownMenuItem, {
            menuItem: item,
            index: index,
            linkWrapper: linkWrapper,
            highlightedIndex: highlightedIndex,
            getItemProps: getItemProps,
            key: `${item.label}${index}`,
            className: location && location.pathname === item.url ? "active" : ""
        })))));
};
var $2ad24e75a96deccc$var$css_248z$1 = "._container_1ie47_1{width:100%;max-width:512px;overflow-y:overlay;overflow-x:hidden;max-height:90vh}._container_1xj9f_1{height:60px;padding:16px 24px;position:sticky;top:0;z-index:1}._container_1xj9f_1 ._empty_1xj9f_17:empty{display:none}._switch-control_1xj9f_25{margin-right:0!important}._content_1qg5v_1{transition:all .4s ease,opacity .4s ease;overflow:hidden}._button_1qg5v_15{gap:20px;margin-top:8px;margin-bottom:8px;margin-left:4px;padding-left:8px;padding-right:8px;display:flex;align-items:center}._button_1qg5v_15 svg{width:24px;height:24px}._container_1uaz1_1{width:32px;height:32px;flex-shrink:0;border-radius:50%;background-color:var(--helix-gray-50)}._container_1b1o3_1{min-height:36px;max-height:36px;cursor:pointer}._container_1b1o3_1:hover{text-decoration:none;background-color:var(--helix-gray-50)}._container_1b1o3_1>svg{height:20px;width:20px}._notification-list-item_1xu1t_1{padding:16px}._notification-list-item-info_1xu1t_9{padding:8px}._notification-list-item-info_1xu1t_9:hover{background-color:var(--helix-gray-50)}._reaction_1viu7_1{cursor:pointer}._reaction_1viu7_1:hover{text-decoration:none}._container_ikk65_1{position:absolute;right:-32px;display:flex;width:50%;justify-content:flex-end}._wrapper_ikk65_17{display:flex;justify-content:center;align-items:center;min-width:24px;max-width:24px;height:24px;border-radius:50%;box-sizing:border-box;position:relative;background-color:#fff;cursor:pointer}._wrapper_ikk65_17:hover{box-shadow:0 0 2px rgba(0,0,0,.30196078431372547);background-color:var(--helix-gray-50)}._dot_ikk65_55{width:8px;height:8px;border-radius:50%}._container_18plv_1{margin-top:3px;text-align:right;white-space:nowrap}._container_1na7o_1 .helix-modal-overlay{display:none}._container_1na7o_1>div{padding:0!important}._container_1na7o_1>div,._modal_1na7o_19{background-color:var(--helix-gray-50)!important}._modal_1na7o_19{width:100%!important;max-width:unset!important;border-radius:0!important;box-shadow:none!important;transition:none!important;animation:none!important}._panel_1na7o_39{width:640px;padding:24px 12px}@media (max-width:768px){._panel_1na7o_39{width:calc(100vw - 48px)}}@media (max-width:480px){._panel_1na7o_39{width:calc(100vw - 24px)}}._panel_1na7o_39 .header-text{text-transform:uppercase;color:var(--helix-gray-500)}._panel-header_1na7o_83{display:flex;align-items:center;justify-content:space-between;padding-bottom:12px;margin:0 12px 16px;border-bottom:1px solid var(--helix-gray-200)}._container_1c93q_1{display:flex;flex-direction:column;gap:24px}._container_1c93q_1 p:first-letter{text-transform:uppercase}._container_136iy_1{width:100%;display:flex;align-items:center;justify-content:center;position:sticky;top:0;z-index:1;padding:19px;background-color:var(--helix-white);box-shadow:0 0 1px rgba(0,0,0,.2)}._container_136iy_1 button{border:none;background-color:transparent;cursor:pointer;position:absolute;left:10px;top:50%;transform:translateY(-50%);display:flex;gap:12px;color:var(--helix-brand)}._container_136iy_1 button:focus{outline:2px solid var(--helix-brand);border-radius:4px}._container_136iy_1 button svg path{fill:currentColor}._container_zptpo_1:hover{background-color:var(--helix-gray-100)}._popover_1o2xi_1{max-width:512px!important;width:100%!important}._button_1bax8_1{appearance:none;background:none;border:none;cursor:pointer;padding:0;margin:0}";
$2ad24e75a96deccc$var$styleInject($2ad24e75a96deccc$var$css_248z$1);
const $2ad24e75a96deccc$export$1fa7a266c0bf5ddd = (_a)=>{
    var { dataLwtId: dataLwtId = "navbar-notification-menu", lwtToken: lwtToken, baseUrl: baseUrl, className: className, pollingInterval: pollingInterval = 60000, onClick: onClick } = _a, rest = $2ad24e75a96deccc$var$__rest(_a, [
        "dataLwtId",
        "lwtToken",
        "baseUrl",
        "className",
        "pollingInterval",
        "onClick"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$StyledNotificationMenu, Object.assign({
        "$isDark": false,
        className: `helix-unified-nav__additional-nav-item helix-unified-nav__additional-notification-toggle ${className ? className : ""}`,
        "data-lwt-id": dataLwtId,
        onClick: (e)=>onClick && onClick(e)
    }, rest), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $ffb8fedbdc425da8$export$36ba2f559d49a8f6), {
        accessToken: lwtToken,
        serviceUrl: baseUrl,
        pollingInterval: pollingInterval,
        "aria-label": "Notifications",
        className: "helix-unified-nav__nav-button helix-unified-nav__nav-button-notifications"
    }));
};
/* eslint-disable max-len */ const $2ad24e75a96deccc$var$StyledApplicationSwitcher = (0, $lmFrL.default).div`
    .helix-unified-nav__navigation-item {
        :hover,
        &.active {
            background-color: transparent;
        }
    }
    .helix-unified-nav__navigation-item {
        svg {
            margin-left: 8px;
            ${({ $isDark: $isDark })=>$isDark && (0, $lmFrL.css)`
                    path {
                        fill: currentColor !important;
                    }
                `}
        }
    }

    .helix-app-switcher__mobile-trigger {
        display: none;
        @media screen and (max-width: 576px) {
            display: block;
        }
    }

    .helix-unified-nav__application-name {
        @media screen and (max-width: 576px) {
            display: none;
        }
    }

    .helix-unified-nav__application-switcher-product-name {
        font-weight: 600;
        -webkit-font-smoothing: antialiased;
        color: ${({ $isDark: $isDark })=>$isDark ? "inherit" : "#111827"};
        white-space: nowrap;
        font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans',
            'Helvetica Neue', sans-serif;
    }

    button:not(.helix-app-switcher__item-badge-dropdown) {
        &:not(.helix-unified-nav__navigation-item):not(.helix-unified-nav__app-switcher-panel-section-item) {
            display: inline-flex;
            flex: 0 0 auto;
            align-items: center;
            background-color: transparent;
            border: none;
            padding: 8px 0;
            color: inherit;
        }
    }

    .helix-unified-nav__app-switcher-panel-section-item {
        display: inline-flex;
        flex: 0 0 auto;
        align-items: center;
        background-color: transparent;
        border: none;
        color: inherit;
        a {
            color: inherit;

            &:hover {
                text-decoration: none !important;
            }
        }
        &:hover {
            text-decoration: none !important;
        }
    }

    .helix-unified-nav__app-switcher-panel {
        padding: 12px;
        .helix-unified-nav__app-switcher-panel-section {
            margin-bottom: 12px !important;
            &:last-child {
                margin-bottom: 0;
            }
        }
        .helix-unified-nav__app-switcher-panel-section-name {
            font-style: normal;
            font-weight: 600;
            font-size: 12px;
            line-height: 16px;
            letter-spacing: 0.04em;
            padding: 8px;
            text-transform: uppercase;
        }
        .helix-unified-nav__app-switcher-panel-section-item {
            padding: 8px;
            display: flex;
            width: 100%;
            justify-content: flex-start;
            align-items: flex-start;
            text-align: left;
            border-radius: 6px;
            &:hover,
            &:focus {
                background-color: #f3f4f6;
            }
            &:focus {
                outline: solid 2px #60a5fa;
            }
            &.selected-item {
                outline-width: 0;
                background-color: #f3f4f6;
            }
            .helix-unified-nav__app-switcher-panel-section-item-content-wrapper {
                flex: 1 1;
                padding-right: 8px;
                display: flex;
                .helix-unified-nav__app-switcher-panel-item-icon {
                    margin-right: 8px;
                }
                .helix-unified-nav__app-switcher-panel-item-content-container {
                    display: flex;
                    flex: 1 1;
                    @media screen and (max-width: 319px) {
                        flex-flow: column;
                    }
                    .helix-unified-nav__app-switcher-panel-item-content {
                        flex: 1 1;

                        .helix-unified-nav__app-switcher-panel-item-label {
                            font-weight: 600;
                            font-size: 14px;
                            line-height: 20px;
                        }
                        .helix-unified-nav__app-switcher-panel-item-description {
                            font-weight: 600;
                            font-size: 14px;
                            line-height: 20px;
                            font-weight: normal;
                            font-size: 12px;
                            line-height: 16px;
                            color: #4b5563;
                        }
                    }
                }
            }
            &.not-active {
                .helix-unified-nav__app-switcher-panel-item-content {
                    opacity: 0.6;
                }
            }

            .helix-unified-nav__app-switcher-panel-item-not-active {
                background-color: #111827;
                padding: 3px 6px;
                display: flex;
                align-items: center;
                font-size: 11px;
                border-radius: 20px;
                color: #f3f4f6;
                float: right;
                height: fit-content;
                @media screen and (max-width: 319px) {
                    width: fit-content;
                    margin-top: 4px;
                }
            }
        }
    }
`;
const $2ad24e75a96deccc$var$StyledBarDropDownMenu = (0, $lmFrL.default)($2ad24e75a96deccc$var$DropdownMenu)`
    max-height: calc(100vh - 80px);
    overflow: auto;
    .helix-unified-nav__application-switcher-section {
        flex: 1 1;
        .label {
            font-weight: 600;
        }
    }
    .helix-unified-nav__application-switcher-section-list {
        display: flex;
        flex-direction: column;
    }

    .helix-unified-nav__application-switcher-sections-wrapper {
        display: flex;
    }

    .helix-unified-nav__application-switcher-section--launchpad {
        cursor: default !important;
        display: flex !important;
        justify-content: center;
        align-items: center;
        border-radius: 0 !important;
        flex: 1 1 100%;
        border-top: solid 1px #e5e7eb;
        padding-top: 6px;
        margin-top: 4px;
        font-size: 14px;
        .menu-item-content-wrapper {
            padding: 0 !important;
            a {
                padding: 8px !important;
            }
        }
        &:hover {
            a {
                background-color: transparent !important;
            }
        }

        a {
            display: flex;
            justify-content: center;
            align-items: center;
            color: inherit;
            padding: 8px !important;
            border-radius: 6px;
            &:hover {
                background-color: #f3f4f6 !important;
                text-decoration: none !important;
            }
        }

        &.highlighted {
            background-color: transparent !important;
            a {
                background-color: #f3f4f6;
            }
        }
        .helix-navbar__application-switcher-launchpad-item__label {
            font-weight: 600;
            margin-left: 8px;
        }
        .helix-navbar__application-switcher-launchpad-item__description {
            font-weight: 400;
            margin-left: 12px;
            color: #4b5563;
        }
    }

    @media screen and (max-width: 576px) {
        visibility: hidden;
    }
`;
const $2ad24e75a96deccc$var$StyledAppItem = (0, $lmFrL.default).li`
    display: grid;
    grid-template-columns: 16px 1fr;
    gap: 16px;
    .menu-item-content-wrapper {
        flex-flow: row;
        display: flex;
        align-items: flex-start !important;
        .helix-app-switcher__item-icon {
            margin-right: 8px;
            display: flex;
        }
        .menu-item-content {
            display: flex;
            flex-flow: column;
            flex: 1 1;
            .label {
                flex: 1 1;
            }
        }
        a {
            padding: 0 !important;
            width: 100%;
            display: flex;
        }
    }
    .not-active {
        background-color: #111827;
        padding: 3px 6px;
        display: flex;
        align-items: center;
        font-size: 11px;
        border-radius: 20px;
        color: #f3f4f6;
        float: right;
    }
`;
(0, $lmFrL.default).div`
    display: flex;
    flex-flow: column;
    align-items: flex-start;
    margin-bottom: 2px;
`;
(0, $lmFrL.default).div`
    display: flex;
    flex-flow: column;
    align-items: flex-start;
    width: 100%;
    a {
        color: inherit;
        padding: 8px 8px 8px 24px;
        width: 100%;
        border-radius: 6px;
        text-decoration: none;
        &:hover,
        &:focus {
            background-color: #f3f4f6;
        }
    }
`;
const $2ad24e75a96deccc$var$StyledAppInstanceBadgeDropdownWrapper = (0, $lmFrL.default).div`
    display: inline-block;
`;
const $2ad24e75a96deccc$var$StyledAppInstanceBadgeDropdown = (0, $lmFrL.default).span`
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 99px;
    background-color: #e5e7eb;
    font-size: 12px;
    font-weight: 400;
    color: #1f2937;
    padding: 2px 8px;
    margin-top: 4px;
    width: fit-content;
    white-space: nowrap;
    border: none;
    svg {
        margin-left: 8px;
    }
`;
const $2ad24e75a96deccc$var$ApplicationSwitcherAppInstanceDropdown$1 = ({ setPopperElement: setPopperElement, isOpenInstance: isOpenInstance, styles: styles, attributes: attributes, getMenuProps: getMenuProps, setAppInstancesOpen: setAppInstancesOpen, item: item, highlightedIndexMenu: highlightedIndexMenu, menuRef: menuRef, setHighlightedIndex: setHighlightedIndex, highlightedIndex: highlightedIndex, getItemPropsMenu: getItemPropsMenu })=>{
    const { appSwitcherLinkWrapper: appSwitcherLinkWrapper } = (0, $acw62.useContext)($2ad24e75a96deccc$var$NavbarContext);
    const dropdownMenuRef = (0, $acw62.useRef)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$DropdownMenu, Object.assign({
        inNavbar: true,
        maxWidth: "300px",
        ref: setPopperElement,
        isOpen: isOpenInstance,
        className: "helix-unified-nav__overflow-dropdown-menu",
        style: Object.assign(Object.assign({}, styles.popper), {
            zIndex: 1052
        })
    }, attributes.popper), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", Object.assign({}, getMenuProps({
        ref: dropdownMenuRef,
        onKeyDown: (e)=>{
            switch(e.key){
                case "Escape":
                    e.preventDefault();
                    setAppInstancesOpen([]);
                    break;
                case "ArrowDown":
                    e.preventDefault();
                    // if active item is last item in list
                    // close menu
                    if (item.appInstances && highlightedIndexMenu === item.appInstances.length - 1) {
                        if (menuRef) {
                            const menu = menuRef.childNodes[0];
                            if (menu) setTimeout(()=>{
                                setAppInstancesOpen([]);
                                menu.focus();
                                setHighlightedIndex && highlightedIndex && setHighlightedIndex(highlightedIndex + 1);
                            });
                        }
                    }
                    break;
                case "ArrowUp":
                    e.preventDefault();
                    // if active item is first item in list
                    // close menu
                    if (highlightedIndexMenu === 0) {
                        if (menuRef) {
                            const menu = menuRef.childNodes[0];
                            if (menu) setTimeout(()=>{
                                setAppInstancesOpen([]);
                                menu.focus();
                                setHighlightedIndex && highlightedIndex && setHighlightedIndex(highlightedIndex);
                            });
                        }
                    }
                    break;
                case "Enter":
                    e.preventDefault();
                    // stop event propagation
                    e.stopPropagation();
                    // if has url click the link
                    if (dropdownMenuRef && dropdownMenuRef.current && item.appInstances && item.appInstances[highlightedIndexMenu].url) {
                        // find the dom element and click it
                        const link = dropdownMenuRef.current.querySelectorAll("a")[highlightedIndexMenu];
                        if (link) link.click();
                    }
                    setTimeout(()=>{
                        setAppInstancesOpen([]);
                        if (menuRef) {
                            const menu = menuRef.childNodes[0];
                            if (menu) menu.focus();
                        }
                    });
                    break;
                case "Home":
                case "End":
                    e.stopPropagation();
                    e.preventDefault();
                    break;
            }
        }
    }, {
        suppressRefError: true
    })), item.appInstances && item.appInstances.map((appInstance, index)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$DropdownMenuItem, {
            getItemProps: getItemPropsMenu,
            index: index,
            highlightedIndex: highlightedIndexMenu,
            key: `${appInstance.label}_${appInstance.url}_${index}`,
            menuItem: appInstance,
            linkWrapper: appSwitcherLinkWrapper,
            useChildrenInProps: true,
            useCheckmarkActive: true,
            onClick: (e)=>{
                e.stopPropagation();
                setAppInstancesOpen([]);
            }
        }))));
};
$2ad24e75a96deccc$var$ApplicationSwitcherAppInstanceDropdown$1.displayName = "ApplicationSwitcherAppInstanceDropdown";
/* eslint-disable max-len */ const $2ad24e75a96deccc$var$ApplicationSwitcherAppInstanceDropdown = ({ item: item, getAppItems: getAppItems, menuRef: menuRef, setHighlightedIndex: setHighlightedIndex, highlightedIndex: highlightedIndex, usePortal: usePortal = false })=>{
    const { isOpen: isOpenInstance, getToggleButtonProps: getToggleButtonProps, getMenuProps: getMenuProps, highlightedIndex: highlightedIndexMenu, getItemProps: getItemPropsMenu, setReferenceElement: setReferenceElement, setPopperElement: setPopperElement, attributes: attributes, styles: styles } = (0, $1c94395e3d071205$exports.useDropdownMenu)({
        placement: "bottom-end",
        items: item.appInstances ? item.appInstances : [],
        itemToString: (item)=>item.label ? item.label : "",
        offset: [
            0,
            8
        ],
        loopItemsOnKeyDown: false,
        closeMenuOnLastItem: true,
        closeMenuOnFirstItem: true,
        resetSelectedItemOnClose: true
    });
    const itemIndex = getAppItems ? getAppItems().indexOf(item) : -1;
    const { setAppInstancesOpen: setAppInstancesOpen } = (0, $acw62.useContext)($2ad24e75a96deccc$var$NavbarContext);
    const getDropdownLabel = ()=>{
        if (item.appInstances && item.appInstances.length > 0) {
            // return the first app instance label that is the default Option
            const defaultAppInstance = item.appInstances.find((appInstance)=>appInstance.defaultOption);
            if (defaultAppInstance) return defaultAppInstance.label;
            else return item.appInstances[0].label;
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$StyledAppInstanceBadgeDropdownWrapper, {
        ref: setReferenceElement
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$StyledAppInstanceBadgeDropdown, Object.assign({
        className: "helix-app-switcher__item-badge-dropdown",
        tabIndex: -1
    }, getToggleButtonProps({
        onClick: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            setAppInstancesOpen((instanceOpen)=>{
                // if instanceOpen includes item index remove it else add it
                if (instanceOpen && instanceOpen.includes(itemIndex)) return instanceOpen.filter((index)=>index !== itemIndex);
                else return [
                    ...instanceOpen,
                    itemIndex
                ];
            });
        },
        onKeyDown: (e)=>{
            if (e.key === "Enter" || e.key === "ArrowDown") {
                e.preventDefault();
                e.stopPropagation();
                setAppInstancesOpen((instanceOpen)=>{
                    // if instanceOpen includes item index remove it
                    // else add it
                    if (instanceOpen && instanceOpen.includes(itemIndex) && !isOpenInstance) return [];
                    else {
                        if (instanceOpen && !instanceOpen.includes(itemIndex)) return [
                            ...instanceOpen,
                            itemIndex
                        ];
                    }
                });
            }
        }
    }, {
        suppressRefError: true
    })), getDropdownLabel(), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarHelixIcon, {
        iconName: "dropdown_open"
    })), usePortal ? (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).createPortal((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$ApplicationSwitcherAppInstanceDropdown$1, {
        setPopperElement: setPopperElement,
        isOpenInstance: isOpenInstance,
        getMenuProps: getMenuProps,
        highlightedIndexMenu: highlightedIndexMenu,
        getItemPropsMenu: getItemPropsMenu,
        item: item,
        menuRef: menuRef,
        setHighlightedIndex: setHighlightedIndex,
        highlightedIndex: highlightedIndex,
        attributes: attributes,
        styles: styles,
        setAppInstancesOpen: setAppInstancesOpen
    }), document.body) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$ApplicationSwitcherAppInstanceDropdown$1, {
        setPopperElement: setPopperElement,
        isOpenInstance: isOpenInstance,
        getMenuProps: getMenuProps,
        highlightedIndexMenu: highlightedIndexMenu,
        getItemPropsMenu: getItemPropsMenu,
        item: item,
        menuRef: menuRef,
        setHighlightedIndex: setHighlightedIndex,
        highlightedIndex: highlightedIndex,
        attributes: attributes,
        styles: styles,
        setAppInstancesOpen: setAppInstancesOpen
    }));
};
$2ad24e75a96deccc$var$ApplicationSwitcherAppInstanceDropdown.displayName = "ApplicationSwitcherAppInstanceDropdown";
const $2ad24e75a96deccc$var$strings = {
    manageAppsAndSettings: "Home"
};
/* eslint-disable max-len */ const $2ad24e75a96deccc$var$ApplicationSwitcherMobilePanel = ({ applicationName: applicationName })=>{
    const { isDark: isDark, appSwitcherItems: appSwitcherItems, showMobileApplicationSwitcher: showMobileApplicationSwitcher, setShowMobileApplicationSwitcher: setShowMobileApplicationSwitcher, setShowMobileMenu: setShowMobileMenu, setShowMobileNotifications: setShowMobileNotifications, appSwitcherLinkWrapper: appSwitcherLinkWrapper, launchpadUrl: launchpadUrl } = (0, $acw62.useContext)($2ad24e75a96deccc$var$NavbarContext);
    const appSectionLinkItem = (sectionItem)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "helix-unified-nav__app-switcher-panel-section-item-content-wrapper"
        }, (sectionItem.icon || sectionItem.iconUrl) && (sectionItem.iconUrl ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "helix-unified-nav__app-switcher-panel-item-icon"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
            src: sectionItem.iconUrl,
            alt: sectionItem.label,
            width: 20,
            height: 20
        })) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "helix-unified-nav__app-switcher-panel-item-icon"
        }, typeof sectionItem.icon === "string" ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarHelixIcon, {
            iconName: sectionItem.icon
        }) : sectionItem.icon)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "helix-unified-nav__app-switcher-panel-item-content-container"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "helix-unified-nav__app-switcher-panel-item-content"
        }, sectionItem.label && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "helix-unified-nav__app-switcher-panel-item-label"
        }, sectionItem.label), sectionItem.description && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "helix-unified-nav__app-switcher-panel-item-description"
        }, sectionItem.description), sectionItem.appInstances && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$ApplicationSwitcherAppInstanceDropdown, {
            item: sectionItem
        }))), sectionItem.notActive && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "helix-unified-nav__app-switcher-panel-item-not-active"
        }, "Try it free")));
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "helix-unified-nav__application-name"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: `helix-unified-nav__navigation-item ${showMobileApplicationSwitcher ? "active" : ""}`,
        onClick: ()=>{
            setShowMobileMenu(false);
            setShowMobileNotifications(false);
            setShowMobileApplicationSwitcher(!showMobileApplicationSwitcher);
        },
        style: {
            position: "relative"
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "helix-unified-nav__application-switcher-product-name"
    }, applicationName), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarHelixIcon, {
        iconName: "dropdown_open"
    }))), showMobileApplicationSwitcher && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$StyledMobileMenuPanel, {
        className: "helix-unified-nav__app-switcher-panel",
        "$isDark": isDark
    }, appSwitcherItems.map((section, sectionIndex)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            key: `app-switch-mobile-section-${sectionIndex}`
        }, section.sectionItems && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "helix-unified-nav__app-switcher-panel-section"
        }, section.sectionName && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "helix-unified-nav__app-switcher-panel-section-name"
        }, section.sectionName), section.sectionItems.length > 0 && section.sectionItems.map((sectionItem, sectionItemIndex)=>sectionItem.url ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                key: `app-switch-mobile-section-item-${sectionItemIndex}`
            }, appSwitcherLinkWrapper ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: "helix-unified-nav__app-switcher-panel-section-item"
            }, appSwitcherLinkWrapper({
                item: sectionItem,
                props: {
                    children: appSectionLinkItem(sectionItem)
                }
            })) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
                key: `app-switch-mobile-section-item-${sectionItemIndex}`,
                href: sectionItem.url,
                target: sectionItem.target ? sectionItem.target : "_self",
                className: "helix-unified-nav__app-switcher-panel-section-item"
            }, appSectionLinkItem(sectionItem))) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
                onClick: ()=>sectionItem.onClick && sectionItem.onClick(),
                key: `app-switch-mobile-section-item-${sectionItemIndex}`,
                disabled: sectionItem.disabled,
                className: `helix-unified-nav__app-switcher-panel-section-item ${sectionItem.notActive ? "not-active" : ""} ${sectionItem.selected ? "selected-item" : ""}`
            }, appSectionLinkItem(sectionItem)))))), launchpadUrl && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("hr", {
        className: "helix-unified-navbar__mobile-menu-divider"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "helix-unified-nav__app-switcher-panel-section"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
        href: launchpadUrl,
        className: "helix-unified-nav__app-switcher-panel-section-item"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "helix-unified-nav__app-switcher-panel-section-item-content-wrapper"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "helix-unified-nav__app-switcher-panel-item-icon"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarHelixIcon, {
        iconName: "app_grid"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "helix-unified-nav__app-switcher-panel-item-content-container"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "helix-unified-nav__app-switcher-panel-item-content"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "helix-unified-nav__app-switcher-panel-item-label"
    }, $2ad24e75a96deccc$var$strings.manageAppsAndSettings)))))))));
};
const $2ad24e75a96deccc$var$ApplicationSwitcherMenuItem = (_a)=>{
    var { item: item, getAppItems: getAppItems, highlightedIndex: highlightedIndex, getItemProps: getItemProps, appSections: appSections, sectionIndex: sectionIndex, menuRef: menuRef, setHighlightedIndex: setHighlightedIndex, globalIndex: globalIndex } = _a, rest = $2ad24e75a96deccc$var$__rest(_a, [
        "item",
        "getAppItems",
        "highlightedIndex",
        "getItemProps",
        "appSections",
        "sectionIndex",
        "menuRef",
        "setHighlightedIndex",
        "globalIndex"
    ]);
    const { isDark: isDark, appSwitcherLinkWrapper: appSwitcherLinkWrapper } = (0, $acw62.useContext)($2ad24e75a96deccc$var$NavbarContext);
    const appItem = ()=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (item.icon || item.iconUrl) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "helix-app-switcher__item-icon"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, !item.iconUrl && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, typeof item.icon === "string" ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarHelixIcon, {
            iconName: item.icon
        }) : item.icon), item.iconUrl && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
            src: item.iconUrl,
            alt: item.label,
            width: 20,
            height: 20
        }))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: "menu-item-content"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "label"
        }, item.label), item.notActive && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "not-active"
        }, "Try it free")), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: "description"
        }, item.description), item.appInstances && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$ApplicationSwitcherAppInstanceDropdown, {
            menuRef: menuRef,
            highlightedIndex: highlightedIndex,
            setHighlightedIndex: setHighlightedIndex,
            item: item,
            usePortal: true,
            getAppItems: getAppItems
        }))));
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$StyledAppItem, Object.assign({
        isDark: isDark,
        className: `${highlightedIndex === globalIndex ? "highlighted" : ""} ${item.divider ? "divider" : ""} ${item.selected ? "selected-item" : ""} ${item.divider || item.notActive || item.disabled ? "disabled" : ""}`
    }, getItemProps({
        disabled: item.divider || item.disabled,
        item: appSections[sectionIndex],
        index: globalIndex
    }), rest), !item.divider && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "menu-item-content-wrapper"
    }, item.url ? appSwitcherLinkWrapper ? appSwitcherLinkWrapper({
        item: item,
        props: {
            children: appItem()
        }
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
        href: item.url,
        target: item.target
    }, appItem()) : appItem())));
};
$2ad24e75a96deccc$var$ApplicationSwitcherMenuItem.displayName = "ApplicationSwitcherMenuItem";
const $2ad24e75a96deccc$var$ApplicationSwitcherLaunchpadItem = ({ url: url, numberOfColumns: numberOfColumns, labels: labels })=>{
    var _a;
    const label = (_a = labels === null || labels === void 0 ? void 0 : labels.home) !== null && _a !== void 0 ? _a : $2ad24e75a96deccc$var$strings.manageAppsAndSettings;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, numberOfColumns > 1 ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
        href: url
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarHelixIcon, {
        iconName: "app_grid"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "helix-navbar__application-switcher-launchpad-item__label"
    }, label)) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$StyledAppItem, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "menu-item-content-wrapper"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
        href: url
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "helix-app-switcher__item-icon"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarHelixIcon, {
        iconName: "app_grid"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "menu-item-content"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "helix-navbar__application-switcher-launchpad-item__label"
    }, label))))));
};
$2ad24e75a96deccc$var$ApplicationSwitcherLaunchpadItem.displayName = "ApplicationSwitcherLaunchpadItem";
const $2ad24e75a96deccc$export$c910c7d8922dd51e = ({ onSelectedItemChanged: onSelectedItemChanged, applicationName: applicationName = "", className: className, dataLwtId: dataLwtId = "navbar-application-switcher", appSections: appSections, linkWrapper: linkWrapper, launchpadUrl: launchpadUrl, preventItemClick: preventItemClick, labels: labels })=>{
    const [referenceElement, setReferenceElement] = (0, $acw62.useState)(null);
    const [popperElement, setPopperElement] = (0, $acw62.useState)(null);
    const [allSectionItems, setAllSectionItems] = (0, $acw62.useState)([]);
    const { windowWidth: windowWidth } = (0, $bea0f3bed29b3a68$exports.useWindowWidth)();
    const { isDark: isDark, setAppSwitcherItems: setAppSwitcherItems, showMobileApplicationSwitcher: showMobileApplicationSwitcher, setShowMobileApplicationSwitcher: setShowMobileApplicationSwitcher, appInstancesOpen: appInstancesOpen, setAppInstancesOpen: setAppInstancesOpen, setAppSwitcherLinkWrapper: setAppSwitcherLinkWrapper, setLaunchpadUrl: setLaunchpadUrl, appSwitcherItems: appSwitcherItems, applicationName: stateApplicationName, brandingLoading: brandingLoading } = (0, $acw62.useContext)($2ad24e75a96deccc$var$NavbarContext);
    const focusManager = (0, $b27e9acf8b86f3f1$export$10c5169755ce7bd7)();
    const handleKeyDown = (e)=>{
        if (!focusManager) return;
        switch(e.key){
            case "ArrowDown":
                e.preventDefault();
                focusManager.focusNext({
                    wrap: true
                });
                break;
            case "ArrowUp":
                e.preventDefault();
                focusManager.focusPrevious({
                    wrap: true
                });
                break;
            case "End":
                e.preventDefault();
                focusManager.focusLast({});
                break;
            case "Home":
                e.preventDefault();
                focusManager.focusFirst({});
                break;
        }
    };
    const modifiers = (0, $acw62.useMemo)(()=>[
            {
                name: "offset",
                options: {
                    offset: [
                        0,
                        8
                    ]
                }
            },
            {
                name: "flip",
                enabled: false
            }
        ], []);
    const { styles: styles, attributes: attributes, update: update } = (0, $5fbf42b40e8ead34$export$f4d5bf230a36dd6e)(referenceElement, popperElement, {
        placement: "bottom-start",
        modifiers: modifiers
    });
    const stateReducer = (state, actionAndChanges)=>{
        const { type: type, changes: changes } = actionAndChanges;
        switch(type){
            case (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.MenuKeyDownArrowDown:
                {
                    const selectedItemNode = document.querySelectorAll(".helix-unified-nav__application-switcher-section-list li");
                    // filter out lis with className section-header
                    const selectedItemNodeArray = Array.from(selectedItemNode).filter((child)=>!child.classList.contains("section-header"))[state.highlightedIndex];
                    const appItem = allSectionItems[state.highlightedIndex];
                    // if appItem has appInstances, then open the appInstances menu
                    if (appItem && appItem.appInstances && appItem.appInstances.length > 0 && appInstancesOpen.length === 0) {
                        // focus on the button with the class .helix-app-switcher__item-badge-dropdown
                        const button = selectedItemNodeArray.querySelector(".helix-app-switcher__item-badge-dropdown");
                        if (button) {
                            button.focus();
                            button.click();
                        }
                        return {
                            isOpen: true,
                            highlightedIndex: state.highlightedIndex
                        };
                    }
                    if (appInstancesOpen.length > 0) return {
                        isOpen: true,
                        highlightedIndex: state.highlightedIndex
                    };
                    const highlightedIndex = state.highlightedIndex + 1;
                    if (highlightedIndex === allSectionItems.length) return Object.assign(Object.assign({}, changes), {
                        isOpen: true,
                        highlightedIndex: 0
                    });
                    return Object.assign(Object.assign({}, changes), {
                        isOpen: true
                    });
                }
            case (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.MenuKeyDownArrowUp:
                if (state.highlightedIndex === 0) return Object.assign(Object.assign({}, changes), {
                    isOpen: true,
                    highlightedIndex: allSectionItems.length - 1
                });
                if (appInstancesOpen && appInstancesOpen.length > 0) return {
                    isOpen: true,
                    highlightedIndex: state.highlightedIndex
                };
                return Object.assign(Object.assign({}, changes), {
                    isOpen: true
                });
            case (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.MenuKeyDownEnter:
                {
                    const appItem = allSectionItems[state.highlightedIndex];
                    if (appItem && appItem.onClick && appInstancesOpen && appInstancesOpen.length === 0) appItem.onClick();
                    if (appItem && appItem.url && appItem.url !== "") {
                        // find the li with the class .highlighted and click on the anchor tag
                        const selectedItemNode = document.querySelectorAll(".helix-unified-nav__application-switcher-section-list li");
                        // filter out lis with className section-header
                        const selectedItemNodeArray = Array.from(selectedItemNode).filter((child)=>!child.classList.contains("section-header"))[state.highlightedIndex];
                        if (selectedItemNodeArray) {
                            const anchor = selectedItemNodeArray.querySelector("a");
                            if (anchor) anchor.click();
                        }
                        const launchpadItem = document.querySelector(".helix-unified-nav__application-switcher-section--launchpad");
                        if (launchpadItem && appItem.label === "Launchpad") {
                            const launchpadLink = launchpadItem.querySelector("a");
                            if (launchpadLink) launchpadLink.click();
                        }
                    }
                    if (state.highlightedIndex !== null && appItem && appItem.appInstances && appItem.appInstances.length > 0) return Object.assign(Object.assign({}, changes), {
                        highlightedIndex: state.highlightedIndex,
                        isOpen: true
                    });
                    return Object.assign({}, changes);
                }
            case (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.ItemClick:
                {
                    const appItem = allSectionItems[state.highlightedIndex];
                    if (appItem && preventItemClick && preventItemClick(appItem)) {
                        // if the item icludes an a tag, prevent the default action
                        const selectedItemNode = document.querySelectorAll(".helix-unified-nav__application-switcher-section-list li");
                        // filter out lis with className section-header
                        const selectedItemNodeArray = Array.from(selectedItemNode).filter((child)=>!child.classList.contains("section-header"))[state.highlightedIndex];
                        if (selectedItemNodeArray) {
                            const anchor = selectedItemNodeArray.querySelector("a");
                            if (anchor) {
                                // get the anchor element and preventDefault and stop propagation
                                // set the href to javascript:void(0)
                                anchor.href = "javascript:void(0)";
                                // then after the event is done, set the href back to the original value
                                setTimeout(()=>{
                                    anchor.href = appItem.url ? appItem.url : "";
                                }, 0);
                            }
                        }
                        return {
                            isOpen: true,
                            highlightedIndex: -1,
                            selectedItem: null
                        };
                    }
                    if (appItem && appItem.onClick && appInstancesOpen && appInstancesOpen.length === 0) appItem.onClick();
                    if (state.highlightedIndex !== null && appItem && appItem.appInstances && appItem.appInstances.length > 0) return Object.assign(Object.assign({}, changes), {
                        highlightedIndex: state.highlightedIndex,
                        isOpen: true
                    });
                    return Object.assign({}, changes);
                }
            case (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.MenuBlur:
                {
                    const appItem = allSectionItems[state.highlightedIndex];
                    if (state.highlightedIndex !== null && appItem && appItem.appInstances && appItem.appInstances.length > 0) return Object.assign(Object.assign({}, changes), {
                        highlightedIndex: state.highlightedIndex,
                        isOpen: true
                    });
                    return Object.assign({}, changes);
                }
            case (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.MenuKeyDownEscape:
                if (appInstancesOpen && appInstancesOpen.length > 0) {
                    const menu = popperElement === null || popperElement === void 0 ? void 0 : popperElement.childNodes[0];
                    menu.focus();
                    return Object.assign(Object.assign({}, changes), {
                        highlightedIndex: state.highlightedIndex,
                        isOpen: true
                    });
                }
                return Object.assign(Object.assign({}, changes), {
                    isOpen: false
                });
            default:
                return changes; // otherwise business as usual.
        }
    };
    const itemToString = (item)=>item.label ? item.label : "";
    const switchAppSectionTypes = ()=>$2ad24e75a96deccc$var$__awaiter(void 0, void 0, void 0, function*() {
            return typeof appSections === "function" ? yield appSections() : appSections;
        });
    const getAppItems = ()=>$2ad24e75a96deccc$var$__awaiter(void 0, void 0, void 0, function*() {
            const sectionItems = [];
            const appSectionType = yield switchAppSectionTypes();
            appSectionType.map((item)=>{
                item.sectionItems.map((sectionItem)=>{
                    sectionItems.push(sectionItem);
                });
            });
            if (launchpadUrl) sectionItems.push({
                label: "Launchpad",
                url: launchpadUrl
            });
            setAllSectionItems(sectionItems);
        });
    const updateAppSwitcherItems = ()=>$2ad24e75a96deccc$var$__awaiter(void 0, void 0, void 0, function*() {
            const items = yield switchAppSectionTypes();
            setAppSwitcherItems(items);
        });
    const { isOpen: isOpen, getToggleButtonProps: getToggleButtonProps, getMenuProps: getMenuProps, getItemProps: getItemProps, highlightedIndex: highlightedIndex, setHighlightedIndex: setHighlightedIndex } = (0, $6260541dc56be833$export$e64b2f635402ca43)({
        items: allSectionItems,
        itemToString: itemToString,
        stateReducer: stateReducer,
        defaultHighlightedIndex: -1
    });
    const handleClickOutsideMobile = (e)=>{
        if (showMobileApplicationSwitcher) {
            if (e.target.closest(".helix-unified-nav__application-switcher")) return;
            setShowMobileApplicationSwitcher(false);
        }
    };
    const handleKeyDownWindow = (e)=>{
        if (e.key === "Escape") {
            if (showMobileApplicationSwitcher) setShowMobileApplicationSwitcher(false);
        }
    };
    (0, $acw62.useEffect)(()=>{
        if (appSections) {
            updateAppSwitcherItems();
            getAppItems();
        }
    }, [
        appSections
    ]);
    (0, $acw62.useEffect)(()=>{
        window.addEventListener("keydown", handleKeyDownWindow);
        window.addEventListener("click", handleClickOutsideMobile);
        return ()=>{
            window.removeEventListener("keydown", handleKeyDownWindow);
            window.removeEventListener("click", handleClickOutsideMobile);
        };
    }, [
        showMobileApplicationSwitcher
    ]);
    (0, $acw62.useEffect)(()=>{
        setAppSwitcherLinkWrapper(()=>linkWrapper);
    }, [
        linkWrapper
    ]);
    (0, $acw62.useEffect)(()=>{
        if (launchpadUrl) setLaunchpadUrl(launchpadUrl);
    }, [
        launchpadUrl
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!isOpen) setAppInstancesOpen([]);
        update && update();
    }, [
        isOpen,
        update
    ]);
    let globalIndex = 0;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$StyledApplicationSwitcher, {
        className: `helix-unified-nav__application-switcher ${className ? className : ""}`,
        "$isDark": isDark,
        "data-lwt-id": dataLwtId
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "helix-app-switcher__mobile-trigger"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$ApplicationSwitcherMobilePanel, {
        applicationName: stateApplicationName || applicationName
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "helix-unified-nav__application-name",
        ref: setReferenceElement
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", Object.assign({}, getToggleButtonProps({
        onKeyDown: (e)=>handleKeyDown(e)
    }), {
        className: `helix-unified-nav__navigation-item ${isOpen ? "active" : ""}`,
        style: {
            position: "relative"
        }
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "helix-unified-nav__application-switcher-product-name"
    }, brandingLoading ? "" : stateApplicationName || applicationName), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarHelixIcon, {
        iconName: "dropdown_open"
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$StyledBarDropDownMenu, Object.assign({
        ref: setPopperElement,
        isOpen: isOpen,
        style: styles.popper,
        "$numberOfColumns": appSections.length
    }, attributes.popper), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", Object.assign({
        className: "helix-unified-nav__application-switcher-section-list"
    }, getMenuProps({
        onKeyDown: (e)=>$2ad24e75a96deccc$var$__awaiter(void 0, void 0, void 0, function*() {
                switch(e.key){
                    case "ArrowRight":
                        e.preventDefault();
                        if (windowWidth < 576) return false;
                        appSwitcherItems.map((section, sectionIndex)=>{
                            const itemIndex = section.sectionItems.indexOf(allSectionItems[highlightedIndex]);
                            if (itemIndex > -1) {
                                const rightItemIndex = allSectionItems.indexOf(appSections[sectionIndex + 1] ? appSections[sectionIndex + 1].sectionItems[itemIndex] : 0);
                                if (rightItemIndex > -1) setHighlightedIndex(rightItemIndex);
                                else {
                                    const nextColumnIndex = allSectionItems.indexOf(appSections[0].sectionItems[itemIndex]);
                                    if (nextColumnIndex > -1) {
                                        // If there is no item directly on the right
                                        //  select the last item in the next column
                                        if (nextColumnIndex === highlightedIndex) {
                                            const nextColumnFirstItemIndex = allSectionItems.indexOf(appSections[sectionIndex + 1].sectionItems[appSections[sectionIndex + 1].sectionItems.length - 1]);
                                            setHighlightedIndex(nextColumnFirstItemIndex);
                                        } else // Select the item item in the first column with the same
                                        //  position of the item that the key down event happened on
                                        setHighlightedIndex(nextColumnIndex);
                                    } else {
                                        // If there are no items in the first
                                        // column at the same position
                                        // select the first item in the first column
                                        const firstItemLastRow = allSectionItems.indexOf(appSections[0].sectionItems[0]);
                                        // Select the first item in the first column
                                        setHighlightedIndex(firstItemLastRow);
                                    }
                                }
                            }
                        });
                        break;
                    case "ArrowLeft":
                        e.preventDefault();
                        if (windowWidth < 576) return false;
                        appSwitcherItems.map((section, sectionIndex)=>{
                            const itemIndex = section.sectionItems.indexOf(allSectionItems[highlightedIndex]);
                            if (itemIndex > -1) {
                                const leftItemIndex = allSectionItems.indexOf(appSections[sectionIndex - 1] ? appSections[sectionIndex - 1].sectionItems[itemIndex] : 0);
                                if (leftItemIndex > -1) setHighlightedIndex(leftItemIndex);
                                else {
                                    const lastColumnIndex = allSectionItems.indexOf(appSections[appSections.length - 1].sectionItems[itemIndex]);
                                    if (lastColumnIndex > -1) {
                                        // If there is no item directly on the left
                                        //  select the last item in the next column
                                        if (lastColumnIndex === highlightedIndex) {
                                            const nextColumnFirstItemIndex = allSectionItems.indexOf(appSections[sectionIndex - 1].sectionItems[appSections[sectionIndex - 1].sectionItems.length - 1]);
                                            setHighlightedIndex(nextColumnFirstItemIndex);
                                        } else // Select the item item in the last column with the
                                        //  same position of the item that the key
                                        //  down event happened on
                                        setHighlightedIndex(lastColumnIndex);
                                    } else {
                                        // If there are no items in the last column at the same position
                                        // select the last item in the last column
                                        const firstItemLastRow = allSectionItems.indexOf(appSections[appSections.length - 1].sectionItems[appSections[appSections.length - 1].sectionItems.length - 1]);
                                        setHighlightedIndex(firstItemLastRow);
                                    }
                                }
                            }
                        });
                        break;
                }
            })
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "helix-unified-nav__application-switcher-sections-wrapper"
    }, appSwitcherItems.map((section, sectionIndex)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", {
            key: sectionIndex,
            className: "helix-unified-nav__application-switcher-section"
        }, section.sectionName && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            className: "section-header"
        }, section.sectionName), section.sectionItems.map((item, index)=>{
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$ApplicationSwitcherMenuItem, {
                globalIndex: globalIndex++,
                setHighlightedIndex: setHighlightedIndex,
                menuRef: popperElement,
                key: `${item.label}${sectionIndex}${index}`,
                getAppItems: ()=>allSectionItems,
                item: item,
                id: `app-switcher-item-${sectionIndex}-${index}`,
                appSections: appSwitcherItems,
                highlightedIndex: highlightedIndex,
                sectionIndex: sectionIndex,
                getItemProps: getItemProps,
                "data-item-index": index
            });
        })))), launchpadUrl && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        className: `helix-unified-nav__application-switcher-section--launchpad ${allSectionItems.length - 1 === highlightedIndex ? "highlighted" : ""}`
    }, getItemProps({
        item: {
            label: "Manage"
        },
        index: allSectionItems.length > 0 ? allSectionItems.length - 1 : 0
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$ApplicationSwitcherLaunchpadItem, {
        labels: labels,
        numberOfColumns: appSections.length,
        url: launchpadUrl
    }))))));
};
$2ad24e75a96deccc$export$c910c7d8922dd51e.displayName = "ApplicationSwitcher";
const $2ad24e75a96deccc$var$NavbarHelpDropdownMenu = ({ menuItems: menuItems, dataLwtId: dataLwtId, className: className, linkWrapper: linkWrapper, location: location, hideHelpHeader: hideHelpHeader = false, maxWidth: maxWidth = "300px" })=>{
    const { isOpen: isOpen, getToggleButtonProps: getToggleButtonProps, getMenuProps: getMenuProps, highlightedIndex: highlightedIndex, getItemProps: getItemProps, setReferenceElement: setReferenceElement, setPopperElement: setPopperElement, attributes: attributes, styles: styles } = (0, $1c94395e3d071205$exports.useDropdownMenu)({
        placement: "bottom-end",
        items: menuItems,
        itemToString: (item)=>item.label ? item.label : "",
        offset: [
            0,
            8
        ],
        resetSelectedItemOnClose: true
    });
    const { helpMenuLocation: helpMenuLocation } = (0, $acw62.useContext)($2ad24e75a96deccc$var$NavbarContext);
    const menuRef = (0, $acw62.useRef)(null);
    const isActive = ()=>{
        return menuItems ? menuItems.filter((item)=>item.active).length > 0 || menuItems.filter((item)=>item.url === helpMenuLocation).length > 0 : false;
    };
    const handleKeyDown = (e)=>{
        $2ad24e75a96deccc$var$clickDropdownItem(e, menuRef);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: `helix-unified-nav__additional-nav-item helix-unified-nav__additional-help-link ${className ? className : ""}`,
        ref: setReferenceElement,
        "data-lwt-id": dataLwtId
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", Object.assign({}, getToggleButtonProps(), {
        "aria-label": "Help Menu",
        className: `helix-unified-nav__nav-button helix-unified-nav__nav-button-help ${isActive() ? "active" : ""} `,
        id: "helix-unified-nav_help-link"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarHelixIcon, {
        iconName: "question_help"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$DropdownMenu, Object.assign({
        inNavbar: true,
        maxWidth: maxWidth,
        ref: setPopperElement,
        isOpen: isOpen,
        style: styles.popper,
        className: "helix-unified-nav__user-dropdown-menu"
    }, attributes.popper), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", Object.assign({}, getMenuProps({
        onKeyDown: (e)=>handleKeyDown(e),
        ref: (ref)=>menuRef.current = ref
    })), isOpen && menuItems.length > 0 && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, !hideHelpHeader && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        className: "section-header section-header-bold"
    }, "Help"), menuItems.map((item, index)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$DropdownMenuItem, {
            menuItem: item,
            index: index,
            linkWrapper: linkWrapper,
            highlightedIndex: highlightedIndex,
            getItemProps: getItemProps,
            className: location && location.pathname === item.url ? "active" : "",
            key: `${item.label}${index}`
        }))))));
};
const $2ad24e75a96deccc$export$7012db33ae0df864 = ({ url: url, dataLwtId: dataLwtId = "navbar-help-link", className: className, linkWrapper: linkWrapper, menuItems: menuItems, menuItemsLinkWrapper: menuItemsLinkWrapper, location: location, target: target, hideHelpHeader: hideHelpHeader = false, dropdownMenuMaxWidth: dropdownMenuMaxWidth })=>{
    const { setHelpUrl: setHelpUrl, setHelpMenuLocation: setHelpMenuLocation, setHelpItemLinkWrapper: setHelpItemLinkWrapper, setHelpDropdownItemLinkWrapper: setHelpDropdownItemLinkWrapper, setHelpMenuItems: setHelpMenuItems, setHelpTarget: setHelpTarget, setHideHelpMenuHeader: setHideHelpMenuHeader } = (0, $acw62.useContext)($2ad24e75a96deccc$var$NavbarContext);
    (0, $acw62.useEffect)(()=>{
        if (url) setHelpUrl(url);
    }, [
        url
    ]);
    (0, $acw62.useEffect)(()=>{
        if (linkWrapper) setHelpItemLinkWrapper(()=>linkWrapper);
    }, [
        linkWrapper
    ]);
    (0, $acw62.useEffect)(()=>{
        if (menuItems) setHelpMenuItems(menuItems);
    }, [
        menuItems
    ]);
    (0, $acw62.useEffect)(()=>{
        if (menuItemsLinkWrapper) setHelpDropdownItemLinkWrapper(()=>menuItemsLinkWrapper);
    }, [
        menuItemsLinkWrapper
    ]);
    (0, $acw62.useEffect)(()=>{
        if (location && location.pathname) setHelpMenuLocation(location.pathname);
        if (target) setHelpTarget(target);
    }, [
        location,
        target
    ]);
    (0, $acw62.useEffect)(()=>{
        setHideHelpMenuHeader(hideHelpHeader);
    }, [
        hideHelpHeader
    ]);
    if (menuItems) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarHelpDropdownMenu, {
        location: location,
        menuItems: menuItems,
        dataLwtId: dataLwtId,
        linkWrapper: menuItemsLinkWrapper,
        hideHelpHeader: hideHelpHeader,
        maxWidth: dropdownMenuMaxWidth
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: `helix-unified-nav__additional-nav-item helix-unified-nav__additional-help-link ${className ? className : ""}`,
        "data-lwt-id": dataLwtId
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, url ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, linkWrapper ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(linkWrapper({
        url: url,
        props: {
            className: "helix-unified-nav__nav-button-link"
        },
        label: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarHelixIcon, {
            iconName: "question_help"
        })
    }), {
        className: "helix-unified-nav__nav-button-link",
        id: "helix-unified-nav_help-link",
        "aria-label": "Help"
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", Object.assign({
        href: url,
        className: "helix-unified-nav__nav-button-link"
    }, $2ad24e75a96deccc$var$getTargetSimple(target), {
        "aria-label": "Help",
        id: "helix-unified-nav_help-link"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarHelixIcon, {
        iconName: "question_help"
    }))) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        className: "helix-unified-nav__nav-button helix-unified-nav__nav-button-help",
        "aria-label": "Help",
        id: "helix-unified-nav_help-link"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarHelixIcon, {
        iconName: "question_help"
    })))));
};
const $2ad24e75a96deccc$export$e41abd62d2a46102 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>{
    const { children: children, active: active = false, disabled: disabled, readOnly: readOnly } = props, rest = $2ad24e75a96deccc$var$__rest(props, [
        "children",
        "active",
        "disabled",
        "readOnly"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        ref: ref,
        className: `helix-unified-navbar__mobile-menu-item ${disabled ? "disabled" : ""} ${active ? "active" : ""} ${readOnly ? "item-read-only" : ""}`
    }, rest), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children));
});
$2ad24e75a96deccc$export$e41abd62d2a46102.displayName = "NavbarCustomMobileMenuItem";
const $2ad24e75a96deccc$export$44a8a237367639f9 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((props, ref)=>{
    const { children: children, label: label, isOpen: isOpen = false, onClick: onClick } = props, rest = $2ad24e75a96deccc$var$__rest(props, [
        "children",
        "label",
        "isOpen",
        "onClick"
    ]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [menuOpen, setMenuOpen] = (0, $acw62.useState)(isOpen ? isOpen : false);
    const handleClick = (e)=>{
        if (onClick) onClick(e);
        else setMenuOpen(!menuOpen);
    };
    (0, $acw62.useEffect)(()=>{
        setMenuOpen(isOpen);
    }, [
        isOpen
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({
        ref: ref,
        className: "helix-unified-navbar__mobile-menu-item"
    }, rest), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "button",
        tabIndex: 0,
        onClick: (e)=>handleClick(e),
        onKeyDown: (e)=>{
            if (e.key === "Enter") handleClick(e);
        },
        className: "helix-unified-nav__mobile-menu-dropdown-button  \r\n                 helix-unified-nav__mobile-menu-dropdown-toggle"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "helix-unified-nav__mobile-menu-label"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, label)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$NavbarHelixIcon, {
        iconName: !menuOpen ? "dropdown_closed" : "dropdown_open"
    }))), menuOpen && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$StyledCustomDropdownSection, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(children, (child)=>{
        if (child && child.type && (child.type.displayName === "NavbarCustomMobileMenuItem" || child.type.displayName === "NavbarCustomMobileMenuItemDropdown")) return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(child, {
            className: `helix-unified-navbar__mobile-sub-menu-item-custom 
                                    helix-unified-navbar__mobile-menu-item ${child.props && child.props.className ? child.props.className : ""} ${child.props && child.props.active ? "active" : ""}`
        });
        return child;
    })));
});
$2ad24e75a96deccc$export$44a8a237367639f9.displayName = "NavbarCustomMobileMenuItemDropdown";
const $2ad24e75a96deccc$export$fb616c67fe64a6b = (_a)=>{
    var { icon: icon, onClick: onClick, linkWrapper: linkWrapper, children: children, url: url, target: target = "_self" } = _a, rest = $2ad24e75a96deccc$var$__rest(_a, [
        "icon",
        "onClick",
        "linkWrapper",
        "children",
        "url",
        "target"
    ]);
    const innerContent = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, icon, children);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, linkWrapper ? linkWrapper({
        children: innerContent,
        props: {
            className: "helix-unified-nav__nav-button-link unified-nav__nav-icon-action primary-text-color"
        }
    }) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, url ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", Object.assign({
        // eslint-disable-next-line max-len
        className: "helix-unified-nav__nav-button-link unified-nav__nav-icon-action primary-text-color",
        href: url,
        target: target
    }, rest), innerContent) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", Object.assign({
        className: "helix-unified-nav__nav-button unified-nav__nav-icon-action primary-text-color",
        onClick: onClick
    }, rest), innerContent)));
};
$2ad24e75a96deccc$export$fb616c67fe64a6b.displayName = "NavbarIconAction";
var $2ad24e75a96deccc$var$css_248z = '.ClientSwitcher-module_client-picker__info-icon__zuJN1{margin-left:6px;vertical-align:middle;display:inline-flex;align-items:center;cursor:pointer}.ClientSwitcher-module_client-picker__tooltip__QU5lN{background-color:rgba(17,24,39,.8);color:#fff;padding:6px;border-radius:4px;font-weight:400;line-height:16px;font-size:12px;opacity:1;transition:opacity .2s ease-in-out;z-index:1070;min-width:180px;white-space:pre-line;box-shadow:0 2px 8px rgba(0,0,0,.15);pointer-events:none;max-width:200px;position:absolute}.ClientSwitcher-module_client-picker__tooltip__QU5lN[data-placement^=top]{margin-bottom:6px}.ClientSwitcher-module_client-picker__tooltip__QU5lN[data-placement^=top]>.ClientSwitcher-module_client-picker__tooltip-arrow__26NQr{bottom:-6px;left:50%;transform:translateX(-50%)}.ClientSwitcher-module_client-picker__tooltip__QU5lN[data-placement^=top]>.ClientSwitcher-module_client-picker__tooltip-arrow__26NQr:before{border-width:6px 6px 0;border-color:rgba(17,24,39,.8) transparent transparent;left:0;top:0;transform:none}.ClientSwitcher-module_client-picker__tooltip__QU5lN[data-placement^=bottom]{margin-top:6px}.ClientSwitcher-module_client-picker__tooltip__QU5lN[data-placement^=bottom]>.ClientSwitcher-module_client-picker__tooltip-arrow__26NQr{top:-6px;left:50%;transform:translateX(-50%)}.ClientSwitcher-module_client-picker__tooltip__QU5lN[data-placement^=bottom]>.ClientSwitcher-module_client-picker__tooltip-arrow__26NQr:before{border-width:0 6px 6px;border-color:transparent transparent rgba(17,24,39,.8);left:0;top:0;transform:none}.ClientSwitcher-module_client-picker__tooltip__QU5lN[data-placement^=left]>.ClientSwitcher-module_client-picker__tooltip-arrow__26NQr{right:-6px;top:50%;transform:translateY(-50%)}.ClientSwitcher-module_client-picker__tooltip__QU5lN[data-placement^=left]>.ClientSwitcher-module_client-picker__tooltip-arrow__26NQr:before{border-width:6px 0 6px 6px;border-color:transparent transparent transparent rgba(17,24,39,.8);left:0;top:0;transform:none}.ClientSwitcher-module_client-picker__tooltip__QU5lN[data-placement^=right]>.ClientSwitcher-module_client-picker__tooltip-arrow__26NQr{left:-6px;top:50%;transform:translateY(-50%)}.ClientSwitcher-module_client-picker__tooltip__QU5lN[data-placement^=right]>.ClientSwitcher-module_client-picker__tooltip-arrow__26NQr:before{border-width:6px 6px 6px 0;border-color:transparent rgba(17,24,39,.8) transparent transparent;left:0;top:0;transform:none}.ClientSwitcher-module_client-picker__tooltip-arrow__26NQr{width:12px;height:12px;position:absolute;pointer-events:none;display:block}.ClientSwitcher-module_client-picker__tooltip-arrow__26NQr:before{content:"";display:block;width:0;height:0;border-style:solid;position:absolute}.ClientSwitcher-module_client-picker__container__1ryeT{position:relative}.ClientSwitcher-module_client-picker__button__2e80Y{display:flex;align-items:center;gap:8px;font-size:14px;font-weight:600;white-space:nowrap;background-color:transparent;border:none;cursor:pointer;border-radius:6px;padding:4px;max-width:250px;overflow:hidden}.ClientSwitcher-module_client-picker__button__2e80Y:focus{outline:2px solid #d1d5db}.ClientSwitcher-module_client-picker__button__2e80Y:hover{background-color:var(--helix-brand-pale)}.ClientSwitcher-module_client-picker__button__2e80Y[aria-expanded=true]{background-color:var(--helix-gray-200)}.ClientSwitcher-module_client-picker__info__2yLaM{display:flex;flex-direction:column;align-items:flex-start;margin:0 8px;line-height:1.3}.ClientSwitcher-module_client-picker__product-name__XM_ZB{font-weight:600;color:var(--helix-gray-900)}.ClientSwitcher-module_client-picker__client__25MJE{font-weight:400;color:var(--helix-gray-600);font-size:12px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;max-width:150px}.ClientSwitcher-module_client-picker__dropdown-menu__C4IO8{z-index:9999;min-width:280px;width:280px}.ClientSwitcher-module_client-picker__section-header__3uzR6,.ClientSwitcher-module_client-picker__section-separator__26jUX{pointer-events:none}.ClientSwitcher-module_client-picker__logo__1AXAW img{height:32px;width:32px}.ClientSwitcher-module_client-picker__dropdown-menu__C4IO8{position:absolute;background-color:#fff;box-shadow:0 0 1px rgba(0,0,0,.2),0 4px 8px rgba(0,0,0,.1);border-radius:4px;min-width:200px;z-index:1000;opacity:0;pointer-events:none;transition:opacity .2s ease,transform .2s ease;max-height:calc(100vh - 80px);overflow-y:auto}.ClientSwitcher-module_client-picker__dropdown-menu__C4IO8:focus{outline:none}.ClientSwitcher-module_client-picker__dropdown-menu__C4IO8.ClientSwitcher-module_open__3WK5e{opacity:1;pointer-events:auto}.ClientSwitcher-module_client-picker__dropdown-menu__C4IO8.ClientSwitcher-module_bottom__3gyGT{margin-top:8px;transform:translateY(-8px)}.ClientSwitcher-module_client-picker__dropdown-menu__C4IO8.ClientSwitcher-module_bottom__3gyGT.ClientSwitcher-module_open__3WK5e{transform:translateY(0)}.ClientSwitcher-module_client-picker__dropdown-menu__C4IO8.ClientSwitcher-module_top__QK7vS{margin-bottom:8px;transform:translateY(8px)}.ClientSwitcher-module_client-picker__dropdown-menu__C4IO8.ClientSwitcher-module_top__QK7vS.ClientSwitcher-module_open__3WK5e{transform:translateY(0)}.ClientSwitcher-module_client-picker__dropdown-menu__C4IO8.ClientSwitcher-module_right__1gXsx{margin-left:8px;transform:translateX(-8px)}.ClientSwitcher-module_client-picker__dropdown-menu__C4IO8.ClientSwitcher-module_right__1gXsx.ClientSwitcher-module_open__3WK5e{transform:translateX(0)}.ClientSwitcher-module_client-picker__dropdown-menu__C4IO8.ClientSwitcher-module_left__184eT{margin-right:8px;transform:translateX(8px)}.ClientSwitcher-module_client-picker__dropdown-menu__C4IO8.ClientSwitcher-module_left__184eT.ClientSwitcher-module_open__3WK5e{transform:translateX(0)}.ClientSwitcher-module_client-picker__dropdown-menu__C4IO8 ul{list-style:none;margin:0;padding:16px 8px 8px}.ClientSwitcher-module_client-picker__dropdown-menu__C4IO8.client-picker__dropdown-menu--no-client-header ul{padding-top:8px}.ClientSwitcher-module_client-picker__dropdown-menu__C4IO8 .ClientSwitcher-module_client-picker__section-separator__26jUX{height:1px;background-color:#e5e5e5;margin:8px 0}.ClientSwitcher-module_client-picker__dropdown-menu__C4IO8 .ClientSwitcher-module_client-picker__section-header__3uzR6{text-transform:uppercase;font-size:12px;color:#4b5563;letter-spacing:.1em;padding:8px}.ClientSwitcher-module_client-picker__dropdown-menu__C4IO8 .ClientSwitcher-module_client-picker__dropdown-item__1rQPn{padding:8px 12px;cursor:pointer;border-radius:4px;margin-bottom:2px}.ClientSwitcher-module_client-picker__dropdown-menu__C4IO8 .ClientSwitcher-module_client-picker__dropdown-item__1rQPn.ClientSwitcher-module_client-picker__dropdown-item--highlighted__pn-Eq,.ClientSwitcher-module_client-picker__dropdown-menu__C4IO8 .ClientSwitcher-module_client-picker__dropdown-item__1rQPn:hover{background-color:var(--helix-brand-pale)}.ClientSwitcher-module_client-picker__dropdown-menu__C4IO8 .ClientSwitcher-module_client-picker__dropdown-item__1rQPn.ClientSwitcher-module_client-picker__dropdown-item--selected-client__1gj8Y{background-color:var(--helix-brand-pale);color:var(--helix-brand)}.ClientSwitcher-module_client-picker__dropdown-menu__C4IO8 .ClientSwitcher-module_client-picker__dropdown-item__1rQPn .ClientSwitcher-module_client-picker__dropdown-item__1rQPn{cursor:pointer}.ClientSwitcher-module_client-picker__dropdown-menu__C4IO8 .ClientSwitcher-module_client-picker__dropdown-item__1rQPn .ClientSwitcher-module_client-picker__dropdown-item--skeleton__3OJsk{cursor:default}.ClientSwitcher-module_client-picker__dropdown-menu__C4IO8 .ClientSwitcher-module_client-picker__client-menu-item__h5lcs{display:flex;align-items:center;gap:8px}.ClientSwitcher-module_client-picker__dropdown-menu__C4IO8 .ClientSwitcher-module_client-picker__client-avatar__G-9cs{width:24px;height:24px;border-radius:12px;object-fit:cover}.ClientSwitcher-module_client-picker__dropdown-menu__C4IO8 .ClientSwitcher-module_client-picker__client-text__3WLDG{flex:1;display:flex;flex-direction:column;gap:1px}.ClientSwitcher-module_client-picker__dropdown-menu__C4IO8 .ClientSwitcher-module_client-picker__item-label__3ycr7{font-size:14px;font-weight:500;color:#374151;line-height:1.2;display:flex;flex-wrap:wrap}.ClientSwitcher-module_client-picker__dropdown-menu__C4IO8 .ClientSwitcher-module_client-picker__item-label__3ycr7 a,.ClientSwitcher-module_client-picker__dropdown-menu__C4IO8 .ClientSwitcher-module_client-picker__item-label__3ycr7:hover{text-decoration:none}.ClientSwitcher-module_client-picker__dropdown-menu__C4IO8 .ClientSwitcher-module_client-picker__item-label__3ycr7 .ClientSwitcher-module_client-picker__label-name__jYu79{flex:1}.ClientSwitcher-module_client-picker__dropdown-menu__C4IO8 .ClientSwitcher-module_client-picker__item-label__3ycr7 .ClientSwitcher-module_client-picker__label-name--centered__1SdOc{margin-top:4px}.ClientSwitcher-module_client-picker__dropdown-menu__C4IO8 .ClientSwitcher-module_client-picker__description__Rip6g{font-size:12px;color:#6b7280;line-height:1.2}.ClientSwitcher-module_client-picker__dropdown-menu__C4IO8 .ClientSwitcher-module_client-picker__client-right__1L4XP{display:flex;align-items:center}.ClientSwitcher-module_client-picker__dropdown-menu__C4IO8 .ClientSwitcher-module_client-picker__checkmark__c74vs{color:var(--helix-brand);font-weight:700}.ClientSwitcher-module_client-picker__dropdown-menu__C4IO8 .ClientSwitcher-module_client-picker__checkmark-svg__1HKzS{display:flex;align-items:center}.ClientSwitcher-module_client-picker__dropdown-menu__C4IO8 .ClientSwitcher-module_client-picker__switch-link__zLump{font-size:12px;color:var(--helix-brand);font-weight:500}.ClientSwitcher-module_client-picker__dropdown-menu__C4IO8 .ClientSwitcher-module_client-picker__app-menu-item__QThxb{display:flex;align-items:flex-start;gap:8px;text-decoration:none}.ClientSwitcher-module_client-picker__dropdown-menu__C4IO8 .ClientSwitcher-module_client-picker__app-icon__2LoaT{width:24px;height:24px;object-fit:cover}.ClientSwitcher-module_client-picker__dropdown-menu__C4IO8 .ClientSwitcher-module_client-picker__app-text__s3K4h{flex:1;display:flex;flex-direction:column;gap:2px;justify-content:center}.ClientSwitcher-module_client-picker__skeleton-avatar__2wMjs{background:#e5e7eb;width:24px;height:24px;border-radius:12px}.ClientSwitcher-module_client-picker__skeleton-icon__2dM1B{background:#e5e7eb;width:24px;height:24px;border-radius:4px}.ClientSwitcher-module_client-picker__skeleton-label__3IGxv{background:#e5e7eb;height:16px;width:80px;display:block;border-radius:4px}.ClientSwitcher-module_client-picker__skeleton-description__3hgWn{background:#e5e7eb;height:12px;width:40px;display:block;border-radius:4px;margin-top:2px}.ClientSwitcher-module_client-picker__skeleton-product-description__2VmBh{background:#e5e7eb;height:12px;width:60px;display:block;border-radius:4px;margin-top:2px}.ClientSwitcher-module_client-picker__skeleton-switch__TiXl0{background:#e5e7eb;height:16px;width:32px;display:block;border-radius:4px}.ClientSwitcher-module_client-picker__client-preview-container__3FUXR{background-color:var(--helix-gray-50);border-radius:4px;margin:4px 0;border:1px solid var(--helix-gray-200)}.ClientSwitcher-module_client-picker__client-preview__1s1gM{pointer-events:none}.ClientSwitcher-module_client-picker__preview-trigger__yhGdm{display:flex;align-items:center;gap:8px;padding:8px 12px;background-color:transparent;border-radius:4px;cursor:pointer;transition:background-color .2s ease;pointer-events:auto}.ClientSwitcher-module_client-picker__preview-trigger__yhGdm:hover{background-color:var(--helix-gray-200)}.ClientSwitcher-module_client-picker__preview-trigger--highlighted__3oQ2E{background-color:var(--helix-gray-200);outline-offset:-2px}.ClientSwitcher-module_client-picker__preview-avatars__3RM-G{display:flex;align-items:center;position:relative}.ClientSwitcher-module_client-picker__preview-avatar__1WITT{width:20px;height:20px;border-radius:50%;border:1px solid var(--helix-gray-400);margin-left:-6px;position:relative}.ClientSwitcher-module_client-picker__preview-avatar__1WITT:first-child{margin-left:0}.ClientSwitcher-module_client-picker__preview-count-icon__3wYkO{width:10px;height:10px;color:#fff}.ClientSwitcher-module_client-picker__preview-icon__29kYs{display:flex;align-items:center;justify-content:center;width:20px;height:20px;border-radius:50%;background-color:var(--helix-gray-300)}.ClientSwitcher-module_client-picker__preview-user-icon__2JjWs{width:12px;height:12px;color:var(--helix-gray-600)}.ClientSwitcher-module_client-picker__preview-label__2N7xG{flex:1;font-size:12px;font-weight:500;color:var(--helix-gray-600)}.ClientSwitcher-module_client-picker__preview-chevron__2xeJ6{width:12px;height:12px;transform:rotate(0deg);transition:transform .2s ease}.ClientSwitcher-module_client-picker__preview-chevron--expanded__3sJjS{transform:rotate(180deg)}.ClientSwitcher-module_client-picker__expanded-client-item__21s48:hover{background-color:var(--helix-brand-pale)}.ClientSwitcher-module_client-picker__expanded-client__19lGf{display:flex;align-items:center;gap:12px;padding:8px 16px}.ClientSwitcher-module_client-picker__expanded-avatar__38zhy{width:28px;height:28px;border-radius:50%;border:1px solid #e5e5e5}.ClientSwitcher-module_client-picker__expanded-text__FKo-1{flex:1;display:flex;flex-direction:column;gap:2px}.ClientSwitcher-module_client-picker__expanded-name__1g7oX{font-size:13px;font-weight:500;color:var(--helix-gray-900)}.ClientSwitcher-module_client-picker__expanded-type__1kqJ_{font-size:11px;color:var(--helix-gray-500)}.ClientSwitcher-module_client-picker__expanded-checkmark__1v9gW{color:#28a745;font-weight:600;font-size:14px}.ClientSwitcher-module_client-picker__expanded-clients__3Ax2H{margin-top:4px;padding:0 8px 8px}.ClientSwitcher-module_client-picker__expanded-client-item__21s48{padding:8px 12px;cursor:pointer;border-radius:4px;margin-bottom:2px;pointer-events:auto}.ClientSwitcher-module_client-picker__expanded-client-item--highlighted__1CNys,.ClientSwitcher-module_client-picker__expanded-client-item__21s48:hover{background-color:var(--helix-brand-pale)}.ClientSwitcher-module_client-picker__expanded-client-item--selected__wfV3t{background-color:var(--helix-brand-pale);color:var(--helix-brand)}.client-picker__legacy-instance{z-index:1051!important}';
var $2ad24e75a96deccc$var$styles = {
    "client-picker__info-icon": "ClientSwitcher-module_client-picker__info-icon__zuJN1",
    "client-picker__tooltip": "ClientSwitcher-module_client-picker__tooltip__QU5lN",
    "client-picker__tooltip-arrow": "ClientSwitcher-module_client-picker__tooltip-arrow__26NQr",
    "client-picker__container": "ClientSwitcher-module_client-picker__container__1ryeT",
    "client-picker__button": "ClientSwitcher-module_client-picker__button__2e80Y",
    "client-picker__info": "ClientSwitcher-module_client-picker__info__2yLaM",
    "client-picker__product-name": "ClientSwitcher-module_client-picker__product-name__XM_ZB",
    "client-picker__client": "ClientSwitcher-module_client-picker__client__25MJE",
    "client-picker__dropdown-menu": "ClientSwitcher-module_client-picker__dropdown-menu__C4IO8",
    "client-picker__section-header": "ClientSwitcher-module_client-picker__section-header__3uzR6",
    "client-picker__section-separator": "ClientSwitcher-module_client-picker__section-separator__26jUX",
    "client-picker__logo": "ClientSwitcher-module_client-picker__logo__1AXAW",
    "open": "ClientSwitcher-module_open__3WK5e",
    "bottom": "ClientSwitcher-module_bottom__3gyGT",
    "top": "ClientSwitcher-module_top__QK7vS",
    "right": "ClientSwitcher-module_right__1gXsx",
    "left": "ClientSwitcher-module_left__184eT",
    "client-picker__dropdown-item": "ClientSwitcher-module_client-picker__dropdown-item__1rQPn",
    "client-picker__dropdown-item--highlighted": "ClientSwitcher-module_client-picker__dropdown-item--highlighted__pn-Eq",
    "client-picker__dropdown-item--selected-client": "ClientSwitcher-module_client-picker__dropdown-item--selected-client__1gj8Y",
    "client-picker__dropdown-item--skeleton": "ClientSwitcher-module_client-picker__dropdown-item--skeleton__3OJsk",
    "client-picker__client-menu-item": "ClientSwitcher-module_client-picker__client-menu-item__h5lcs",
    "client-picker__client-avatar": "ClientSwitcher-module_client-picker__client-avatar__G-9cs",
    "client-picker__client-text": "ClientSwitcher-module_client-picker__client-text__3WLDG",
    "client-picker__item-label": "ClientSwitcher-module_client-picker__item-label__3ycr7",
    "client-picker__label-name": "ClientSwitcher-module_client-picker__label-name__jYu79",
    "client-picker__label-name--centered": "ClientSwitcher-module_client-picker__label-name--centered__1SdOc",
    "client-picker__description": "ClientSwitcher-module_client-picker__description__Rip6g",
    "client-picker__client-right": "ClientSwitcher-module_client-picker__client-right__1L4XP",
    "client-picker__checkmark": "ClientSwitcher-module_client-picker__checkmark__c74vs",
    "client-picker__checkmark-svg": "ClientSwitcher-module_client-picker__checkmark-svg__1HKzS",
    "client-picker__switch-link": "ClientSwitcher-module_client-picker__switch-link__zLump",
    "client-picker__app-menu-item": "ClientSwitcher-module_client-picker__app-menu-item__QThxb",
    "client-picker__app-icon": "ClientSwitcher-module_client-picker__app-icon__2LoaT",
    "client-picker__app-text": "ClientSwitcher-module_client-picker__app-text__s3K4h",
    "client-picker__skeleton-avatar": "ClientSwitcher-module_client-picker__skeleton-avatar__2wMjs",
    "client-picker__skeleton-icon": "ClientSwitcher-module_client-picker__skeleton-icon__2dM1B",
    "client-picker__skeleton-label": "ClientSwitcher-module_client-picker__skeleton-label__3IGxv",
    "client-picker__skeleton-description": "ClientSwitcher-module_client-picker__skeleton-description__3hgWn",
    "client-picker__skeleton-product-description": "ClientSwitcher-module_client-picker__skeleton-product-description__2VmBh",
    "client-picker__skeleton-switch": "ClientSwitcher-module_client-picker__skeleton-switch__TiXl0",
    "client-picker__client-preview-container": "ClientSwitcher-module_client-picker__client-preview-container__3FUXR",
    "client-picker__client-preview": "ClientSwitcher-module_client-picker__client-preview__1s1gM",
    "client-picker__preview-trigger": "ClientSwitcher-module_client-picker__preview-trigger__yhGdm",
    "client-picker__preview-trigger--highlighted": "ClientSwitcher-module_client-picker__preview-trigger--highlighted__3oQ2E",
    "client-picker__preview-avatars": "ClientSwitcher-module_client-picker__preview-avatars__3RM-G",
    "client-picker__preview-avatar": "ClientSwitcher-module_client-picker__preview-avatar__1WITT",
    "client-picker__preview-count-icon": "ClientSwitcher-module_client-picker__preview-count-icon__3wYkO",
    "client-picker__preview-icon": "ClientSwitcher-module_client-picker__preview-icon__29kYs",
    "client-picker__preview-user-icon": "ClientSwitcher-module_client-picker__preview-user-icon__2JjWs",
    "client-picker__preview-label": "ClientSwitcher-module_client-picker__preview-label__2N7xG",
    "client-picker__preview-chevron": "ClientSwitcher-module_client-picker__preview-chevron__2xeJ6",
    "client-picker__preview-chevron--expanded": "ClientSwitcher-module_client-picker__preview-chevron--expanded__3sJjS",
    "client-picker__expanded-client-item": "ClientSwitcher-module_client-picker__expanded-client-item__21s48",
    "client-picker__expanded-client-item--selected": "ClientSwitcher-module_client-picker__expanded-client-item--selected__wfV3t",
    "client-picker__expanded-client": "ClientSwitcher-module_client-picker__expanded-client__19lGf",
    "client-picker__expanded-avatar": "ClientSwitcher-module_client-picker__expanded-avatar__38zhy",
    "client-picker__expanded-text": "ClientSwitcher-module_client-picker__expanded-text__FKo-1",
    "client-picker__expanded-name": "ClientSwitcher-module_client-picker__expanded-name__1g7oX",
    "client-picker__expanded-type": "ClientSwitcher-module_client-picker__expanded-type__1kqJ_",
    "client-picker__expanded-checkmark": "ClientSwitcher-module_client-picker__expanded-checkmark__1v9gW",
    "client-picker__expanded-clients": "ClientSwitcher-module_client-picker__expanded-clients__3Ax2H",
    "client-picker__expanded-client-item--highlighted": "ClientSwitcher-module_client-picker__expanded-client-item--highlighted__1CNys"
};
$2ad24e75a96deccc$var$styleInject($2ad24e75a96deccc$var$css_248z);
const $2ad24e75a96deccc$var$CustomTooltip = ({ content: content, children: children })=>{
    const [open, setOpen] = (0, $acw62.useState)(false);
    const [coords, setCoords] = (0, $acw62.useState)({
        left: 0,
        top: 0,
        placement: "right"
    });
    const iconRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (open && iconRef.current) {
            const rect = iconRef.current.getBoundingClientRect();
            const tooltipWidth = 200;
            const tooltipHeight = 40;
            const margin = 8;
            const vw = window.innerWidth;
            const vh = window.innerHeight;
            // Try right
            if (rect.right + margin + tooltipWidth < vw) setCoords({
                left: rect.right + margin + window.scrollX,
                top: rect.top + rect.height / 2 + window.scrollY,
                placement: "right"
            });
            else if (rect.left - margin - tooltipWidth > 0) // Try left
            setCoords({
                left: rect.left - margin - tooltipWidth + window.scrollX,
                top: rect.top + rect.height / 2 + window.scrollY,
                placement: "left"
            });
            else if (rect.bottom + margin + tooltipHeight < vh) // Try bottom
            setCoords({
                left: rect.left + rect.width / 2 + window.scrollX,
                top: rect.bottom + margin + window.scrollY,
                placement: "bottom"
            });
            else // Default to top
            setCoords({
                left: rect.left + rect.width / 2 + window.scrollX,
                top: rect.top - margin - tooltipHeight + window.scrollY,
                placement: "top"
            });
        }
    }, [
        open
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        style: {
            position: "relative",
            display: "inline-block"
        },
        onMouseEnter: ()=>setOpen(true),
        onMouseLeave: ()=>setOpen(false),
        ref: iconRef
    }, children, open && coords && typeof document !== "undefined" ? (0, $1u0KT.createPortal)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: [
            $2ad24e75a96deccc$var$styles["client-picker__tooltip"],
            $2ad24e75a96deccc$var$styles["client-picker__tooltip--visible"]
        ].join(" "),
        style: {
            left: coords.left,
            top: coords.top,
            transform: coords.placement === "right" ? "translateY(-50%)" : coords.placement === "left" ? "translateY(-50%)" : coords.placement === "top" ? "translate(-50%, -100%)" : "translate(-50%, 0)"
        },
        "data-placement": coords.placement,
        role: "tooltip"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: $2ad24e75a96deccc$var$styles["client-picker__tooltip-arrow"]
    }), content), document.body) : null);
};
const $2ad24e75a96deccc$var$useDropdownMenu = ({ placement: placement = "auto", onSelect: onSelect, items: items, highlightFirst: highlightFirst = false })=>{
    const [isOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [highlightedIndex, setHighlightedIndex] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const [calculatedPlacement, setCalculatedPlacement] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState("bottom");
    const buttonRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    const menuRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(null);
    // Calculate optimal placement when auto is selected
    const calculatePlacement = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>{
        if (placement !== "auto" || !buttonRef.current) return placement;
        const buttonRect = buttonRef.current.getBoundingClientRect();
        const viewport = {
            width: window.innerWidth,
            height: window.innerHeight
        };
        const spaceBelow = viewport.height - buttonRect.bottom;
        const spaceAbove = buttonRect.top;
        const spaceRight = viewport.width - buttonRect.right;
        const spaceLeft = buttonRect.left;
        // Assume menu dimensions (we could measure these dynamically)
        const menuHeight = 120; // Approximate height
        const menuWidth = 160;
        // Prefer bottom first, then top, then sides
        if (spaceBelow >= menuHeight) return "bottom";
        if (spaceAbove >= menuHeight) return "top";
        if (spaceRight >= menuWidth) return "right";
        if (spaceLeft >= menuWidth) return "left";
        // Fallback to bottom if no good option
        return "bottom";
    }, [
        placement
    ]);
    // Update calculated placement when menu opens or placement prop changes
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (isOpen) setCalculatedPlacement(calculatePlacement());
    }, [
        isOpen,
        calculatePlacement
    ]);
    const handleToggle = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((highlightFirstParam)=>{
        const newIsOpen = !isOpen;
        setIsOpen(newIsOpen);
        // Reset highlighted index when closing, or set to first item if requested
        if (!newIsOpen) setHighlightedIndex(null);
        else if (highlightFirstParam !== undefined ? highlightFirstParam : highlightFirst) setHighlightedIndex(0);
    }, [
        isOpen,
        highlightFirst
    ]);
    // When the menu is open, focus on the menu but don't highlight first item
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        var _a;
        if (isOpen) (_a = menuRef.current) === null || _a === void 0 || _a.focus();
    }, [
        isOpen
    ]);
    const handleKeyDown = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((event)=>{
        var _a, _b;
        if (!isOpen) return;
        switch(event.key){
            case "ArrowDown":
                event.preventDefault();
                setHighlightedIndex((prev)=>prev === null ? 0 : prev === items.length - 1 ? 0 : prev + 1);
                break;
            case "ArrowUp":
                event.preventDefault();
                setHighlightedIndex((prev)=>prev === null ? items.length - 1 : prev === 0 ? items.length - 1 : prev - 1);
                break;
            case "Home":
                event.preventDefault();
                setHighlightedIndex(0);
                break;
            case "End":
                event.preventDefault();
                setHighlightedIndex(items.length - 1);
                break;
            case "Enter":
            case " ":
                event.preventDefault();
                if (highlightedIndex !== null && onSelect) onSelect(highlightedIndex, items[highlightedIndex]);
                setIsOpen(false);
                setHighlightedIndex(null);
                (_a = buttonRef.current) === null || _a === void 0 || _a.focus();
                break;
            case "Escape":
                event.preventDefault();
                setIsOpen(false);
                setHighlightedIndex(null);
                (_b = buttonRef.current) === null || _b === void 0 || _b.focus();
                break;
        }
    }, [
        isOpen,
        highlightedIndex,
        items,
        onSelect
    ]);
    return {
        isOpen: isOpen,
        highlightedIndex: highlightedIndex,
        calculatedPlacement: calculatedPlacement,
        buttonRef: buttonRef,
        menuRef: menuRef,
        handleToggle: handleToggle,
        handleKeyDown: handleKeyDown,
        setHighlightedIndex: setHighlightedIndex
    };
};
const $2ad24e75a96deccc$var$launchProductForClient = (env, connection, appId, fallbackUrl, originalHandleToggle, setExpandedLegacyApp, setSubmenuHighlightedIndex, activeClientId, platformService)=>{
    var _a;
    if (connection) platformService.launchApp(connection);
    else if (fallbackUrl) window.open(fallbackUrl, "_self");
    else {
        // Redirect to foundation homepage if no access, include active client id if available
        let acId = activeClientId;
        if (!acId && typeof window !== "undefined") acId = (_a = window.__NAVBAR_CONTEXT__) === null || _a === void 0 ? void 0 : _a.activeClientId;
        if (!acId && typeof globalThis !== "undefined") acId = globalThis.activeClientId;
        const acParam = acId ? `?ac=${encodeURIComponent(acId)}` : "";
        let foundationUrl;
        if ((env || "dev") === "prod") foundationUrl = `https://foundation.lwolf.com/${acParam}`;
        else foundationUrl = `https://foundation.${env || "dev"}.lwolf.com/${acParam}`;
        window.open(foundationUrl, "_self");
    }
    if (typeof originalHandleToggle === "function") originalHandleToggle();
    if (typeof setExpandedLegacyApp === "function") setExpandedLegacyApp(null);
    if (typeof setSubmenuHighlightedIndex === "function") setSubmenuHighlightedIndex(0);
};
const $2ad24e75a96deccc$var$buildProductLaunchUrl = (env, connection, luParamValue)=>{
    // env should be one of: dev, stg, pre, prod
    // For prod, omit the env part: https://platform.lwolf.com
    // For others: https://platform.{env}.lwolf.com
    const baseUrl = env === "prod" ? "https://platform.lwolf.com" : `https://platform.${env}.lwolf.com`;
    let url;
    if (connection.platformClient && connection.clientId === null) {
        const platformClientConnection = connection;
        url = `${baseUrl}/product/launch?a=${platformClientConnection.appId}`;
    } else if (connection.platformClient) {
        const platformClientConnection = connection;
        url = `${baseUrl}/product/launch?a=${platformClientConnection.appId}&ac=${platformClientConnection.clientId}`;
    } else if (connection.clientId != null) {
        const clientConnection = connection;
        url = `${baseUrl}/product/launch?a=${clientConnection.appId}&c=${clientConnection.clientId}&m=${clientConnection.memberId}`;
    } else if (connection.userId != null) {
        const userConnection = connection;
        url = `${baseUrl}/product/launch?a=${userConnection.appId}&u=${userConnection.userId}`;
    } else url = `${baseUrl}/product/launch?a=${connection.appId}`;
    if (luParamValue && env === "dev") url = `${url}&lu=${luParamValue}`;
    return url;
};
// Helper function to get UI text based on language from token
const $2ad24e75a96deccc$var$getUIText = (token)=>{
    let isFrench = true;
    if (token) try {
        // First try using the Authentication library
        const parsedToken = (0, (/*@__PURE__*/$parcel$interopDefault($ea13dab1c811432a$exports))).parseToken(token);
        const lwtClaim = parsedToken === null || parsedToken === void 0 ? void 0 : parsedToken.getLwtClaim();
        const language = lwtClaim === null || lwtClaim === void 0 ? void 0 : lwtClaim.lng;
        isFrench = language && language.startsWith("fr");
    } catch (error) {
        // Fallback: Manual JWT parsing with base64url conversion
        try {
            const tokenParts = token.split(".");
            if (tokenParts.length === 3) {
                // Convert from base64url to base64
                let payload = tokenParts[1].replace(/-/g, "+").replace(/_/g, "/");
                // Fix base64 padding if needed
                while(payload.length % 4)payload += "=";
                const decoded = atob(payload);
                const tokenData = JSON.parse(decoded);
                const lwtClaim = tokenData["http://lwt"];
                const language = lwtClaim === null || lwtClaim === void 0 ? void 0 : lwtClaim.lng;
                isFrench = language && language.startsWith("fr");
            }
        } catch (fallbackError) {
        // Ignore fallback parsing errors - just default to English
        }
    }
    return {
        clients: isFrench ? "Clients" : "Clients",
        products: isFrench ? "Produits" : "Products",
        legacyProducts: isFrench ? "Produits H\xe9rit\xe9s" : "Legacy Products",
        personal: isFrench ? "Personnel" : "Personal",
        brokerage: isFrench ? "Courtage" : "Brokerage",
        switch: isFrench ? "Basculer" : "Switch",
        moreClientsSingular: isFrench ? "1 client de plus" : "1 More Client",
        moreClientsPlural: isFrench ? "clients de plus" : "More Clients"
    };
};
// Build applicationMeta and applicationCodeToName from products.json
const $2ad24e75a96deccc$var$applicationMeta = {};
const $2ad24e75a96deccc$var$applicationCodeToName = {};
// Fetch product data from remote JSON
const $2ad24e75a96deccc$var$fetchProductData = (token)=>$2ad24e75a96deccc$var$__awaiter(void 0, void 0, void 0, function*() {
        try {
            // Check for French language in token
            let productUrl = "https://assets.lwolf.com/json/products/latest.json";
            if (token) try {
                // First try using the Authentication library
                const parsedToken = (0, (/*@__PURE__*/$parcel$interopDefault($ea13dab1c811432a$exports))).parseToken(token);
                const lwtClaim = (parsedToken === null || parsedToken === void 0 ? void 0 : parsedToken.getLwtClaim()) || null;
                const language = lwtClaim === null || lwtClaim === void 0 ? void 0 : lwtClaim.lng;
                if (language && language.startsWith("fr")) productUrl = "https://assets.lwolf.com/json/products/latest-fr.json";
            } catch (tokenError) {
                console.warn("Error parsing token for language detection:", tokenError);
                // Fallback: Manual JWT parsing with base64url conversion
                try {
                    const tokenParts = token.split(".");
                    if (tokenParts.length === 3) {
                        // Convert from base64url to base64
                        let payload = tokenParts[1].replace(/-/g, "+").replace(/_/g, "/");
                        // Fix base64 padding if needed
                        while(payload.length % 4)payload += "=";
                        const decoded = atob(payload);
                        const tokenData = JSON.parse(decoded);
                        const lwtClaim = tokenData["http://lwt"];
                        const language = lwtClaim === null || lwtClaim === void 0 ? void 0 : lwtClaim.lng;
                        if (language && language.startsWith("fr")) productUrl = "https://assets.lwolf.com/json/products/latest-fr.json";
                    }
                } catch (fallbackError) {
                    console.warn("Fallback token parsing also failed:", fallbackError);
                }
            }
            // Clear previous data to ensure language switch updates
            Object.keys($2ad24e75a96deccc$var$applicationMeta).forEach((key)=>delete $2ad24e75a96deccc$var$applicationMeta[key]);
            Object.keys($2ad24e75a96deccc$var$applicationCodeToName).forEach((key)=>delete $2ad24e75a96deccc$var$applicationCodeToName[key]);
            const response = yield fetch(productUrl);
            if (!response.ok) throw new Error("Network response was not ok");
            const data = yield response.json();
            // Build applicationMeta and applicationCodeToName from fetched data
            data.forEach((product)=>{
                $2ad24e75a96deccc$var$applicationMeta[product.code] = {
                    iconUrl: `https://assets.lwolf.com/lwt-helix/icons/latest/products/outlined/${product.icon}.svg`,
                    description: product.description || "",
                    url: "",
                    tooltip: product.tooltip || ""
                };
                $2ad24e75a96deccc$var$applicationCodeToName[product.code] = product.name || product.code;
            });
        } catch (error) {
            console.error("Error fetching product data:", error);
        }
    });
// Mock data for documentation/storybook
const $2ad24e75a96deccc$var$mockClients = [
    {
        clientId: "client-1",
        name: "Acme Corporation",
        clientType: "Brokerage",
        appIds: [
            "crm",
            "con"
        ]
    },
    {
        clientId: "client-2",
        name: "Clark Kent",
        clientType: "User",
        appIds: [
            "as",
            "ca",
            "con",
            "cm",
            "cs",
            "crm",
            "ecom",
            "ess",
            "hsb",
            "hss",
            "ld",
            "lp",
            "pbg",
            "sch",
            "tw",
            "xam",
            "xbm"
        ]
    },
    {
        clientId: "client-3",
        name: "Demo Company Ltd",
        clientType: "Brokerage",
        appIds: [
            "crm",
            "con"
        ]
    }
];
const $2ad24e75a96deccc$var$mockAppConnections = [
    {
        appId: "crm",
        clientId: "client-2",
        platformClient: true,
        name: "Relationships"
    },
    {
        appId: "con",
        clientId: "client-2",
        platformClient: true,
        name: "Contacts"
    },
    {
        appId: "ca",
        clientId: "client-2",
        platformClient: true,
        name: "Cloud Attract"
    },
    {
        appId: "cs",
        clientId: "client-2",
        platformClient: true,
        name: "Cloud Streams"
    },
    {
        appId: "zfp",
        clientId: "client-2",
        name: "zipForm Instance 1"
    },
    {
        appId: "zfp",
        clientId: "client-2",
        name: "zipForm Instance 2"
    },
    {
        appId: "zfp",
        clientId: "client-2",
        name: "zipForm Instance 3"
    },
    {
        appId: "bov",
        clientId: "client-2",
        name: "Back Office Instance 1"
    },
    {
        appId: "xbm",
        clientId: "client-2",
        name: "Broker Metrics"
    },
    {
        appId: "xbm",
        clientId: "client-2",
        name: "Broker Metrics 2"
    },
    {
        appId: "cm",
        clientId: "client-2",
        platformClient: true,
        name: "Cloud MLX"
    },
    {
        appId: "xam",
        clientId: "client-2",
        platformClient: true,
        name: "AgentMetrics"
    },
    {
        appId: "ecom",
        clientId: "client-2",
        platformClient: true,
        name: "E-commerce"
    },
    {
        appId: "hsb",
        clientId: "client-2",
        platformClient: true,
        name: "Boost"
    },
    {
        appId: "hss",
        clientId: "client-2",
        platformClient: true,
        name: "Spacio"
    },
    {
        appId: "pbg",
        clientId: "client-2",
        platformClient: true,
        name: "Front Office"
    },
    {
        appId: "sch",
        clientId: "client-2",
        platformClient: true,
        name: "Schedules"
    },
    {
        appId: "tw",
        clientId: "client-2",
        platformClient: true,
        name: "Transact"
    },
    {
        appId: "as",
        clientId: "client-2",
        platformClient: true,
        name: "Authentisign"
    },
    {
        appId: "lp",
        clientId: "client-2",
        platformClient: true,
        name: "Leads+"
    }
];
const $2ad24e75a96deccc$var$mockAppData = [
    {
        id: "fdn",
        config: {
            login: {
                url: "https://foundation.lwolf.com"
            }
        }
    },
    {
        id: "crm",
        config: {
            login: {
                url: "https://crm.lwolf.com"
            }
        }
    },
    {
        id: "con",
        config: {
            login: {
                url: "https://contacts.lwolf.com"
            }
        }
    },
    {
        id: "xbm",
        config: {
            login: {
                url: "https://brokermetrics.lwolf.com"
            }
        }
    },
    {
        id: "cc",
        config: {
            login: {
                url: "https://cloudattracts.lwolf.com"
            }
        }
    }
];
const $2ad24e75a96deccc$export$b9df65f7f957b5de = ({ platformService: platformService, userToken: userToken, useMockData: useMockData = false, onClientChange: onClientChange, onProductChange: onProductChange, fallbackToActiveClientIdParam: fallbackToActiveClientIdParam = false })=>{
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    const { environment: environment, localStorageTokenKey: localStorageTokenKey, applicationCode: applicationCode, logoImageUrl: logoImageUrl, applicationName: applicationName, setActiveClientId: setActiveClientId } = (0, $acw62.useContext)($2ad24e75a96deccc$var$NavbarContext);
    let activeClientId = (0, $acw62.useContext)($2ad24e75a96deccc$var$NavbarContext).activeClientId;
    // Force activeClientId to 'client-2' when using mock data
    if (useMockData) activeClientId = "client-2";
    const logo = logoImageUrl ? logoImageUrl : "https://assets.lwolf.com/img/lw-logo-dark.svg";
    // Configuration: Number of clients to show before overflow
    // Show both clients if exactly 2, otherwise show 1 + overflow
    const MAIN_CLIENTS_DISPLAY_COUNT = 1;
    // Domain mapping for different environments
    const lwDomains = {
        dev: "dev.lwolf.com",
        stg: "stg.lwolf.com",
        pre: "pre.lwolf.com",
        prod: "lwolf.com"
    };
    // Token cookie name formats
    const newTokenCookieName = environment === "prod" ? "lwaToken_lwolf.com" : `lwaToken_${environment}.lwolf.com`;
    const fallbackTokenCookieName = environment === "prod" ? "lwaToken@@lwolf.com" : `lwaToken@@${environment}.lwolf.com`;
    const getTokenFromCookie = ()=>{
        if (!document || !document.cookie) return "";
        const cookies = document.cookie.split(";");
        // First try the new format
        const newFormatCookie = cookies.find((item)=>item.trim().startsWith(newTokenCookieName + "="));
        if (newFormatCookie) {
            const token = newFormatCookie.split("=")[1] || "";
            return token;
        }
        // Fall back to the old format
        const fallbackCookie = cookies.find((item)=>item.trim().startsWith(fallbackTokenCookieName + "="));
        if (fallbackCookie) {
            const token = fallbackCookie.split("=")[1] || "";
            return token;
        }
        return "";
    };
    const getUserToken = ()=>{
        // get the token from the local storage or the cookie or the userToken
        return typeof window !== "undefined" ? window.localStorage.getItem(localStorageTokenKey) || getTokenFromCookie() || userToken || "" : userToken || "";
    };
    const [token, setToken] = (0, $acw62.useState)("");
    // Effect to handle delayed cookie loading
    (0, $acw62.useEffect)(()=>{
        const initialToken = getUserToken();
        setToken(initialToken);
        // If no token found initially, retry after a short delay
        if (!initialToken) {
            const retryTimer = setTimeout(()=>{
                const retryToken = getUserToken();
                if (retryToken) setToken(retryToken);
            }, 1000); // Retry after 1 second
            return ()=>clearTimeout(retryTimer);
        }
    }, []);
    const lwDomain = lwDomains[environment || "dev"] || lwDomains["dev"];
    const [clients, setClients] = (0, $acw62.useState)([]);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(true);
    const [dropdownPosition, setDropdownPosition] = (0, $acw62.useState)({
        top: 0,
        left: 0
    });
    const [selectedClient, setSelectedClient] = (0, $acw62.useState)("");
    const [isClientPreviewExpanded, setIsClientPreviewExpanded] = (0, $acw62.useState)(false);
    const [expandedLegacyApp, setExpandedLegacyApp] = (0, $acw62.useState)(null);
    const [legacyAppSubmenuPosition, setLegacyAppSubmenuPosition] = (0, $acw62.useState)({
        top: 0,
        left: 0
    });
    const [submenuHighlightedIndex, setSubmenuHighlightedIndex] = (0, $acw62.useState)(0);
    const [announceText, setAnnounceText] = (0, $acw62.useState)("");
    // Clear announcement after a delay to prevent stale announcements
    (0, $acw62.useEffect)(()=>{
        if (announceText) {
            const timeout = setTimeout(()=>{
                setAnnounceText("");
            }, 1500);
            return ()=>clearTimeout(timeout);
        }
    }, [
        announceText
    ]);
    const [appData, setAppData] = (0, $acw62.useState)([]);
    const [appConnections, setAppConnections] = (0, $acw62.useState)([]);
    const [appConnectionsFull, setAppConnectionsFull] = (0, $acw62.useState)([]); // includes connections for hidden apps
    const appConnectionsFullRef = (0, $acw62.useRef)([]);
    // Keep ref in sync with state
    (0, $acw62.useEffect)(()=>{
        appConnectionsFullRef.current = appConnectionsFull;
    }, [
        appConnectionsFull
    ]);
    // Shared client click handler to avoid duplication
    const handleClientClick = (client)=>$2ad24e75a96deccc$var$__awaiter(void 0, void 0, void 0, function*() {
            const clientLabel = client.label || client.name;
            const clientId = client.clientId || client.id;
            setSelectedClient(clientLabel);
            // Save active client ID to platform services
            if (platformService && typeof platformService.setLastActiveClientId === "function") try {
                yield platformService.setLastActiveClientId(clientId);
            } catch (error) {
                console.warn("Failed to save active client ID:", error);
            }
            if (onClientChange) onClientChange(client);
            if (applicationCode) {
                const connection = appConnectionsFullRef.current.find((conn)=>conn.clientId === clientId && conn.appId === applicationCode);
                if (connection) $2ad24e75a96deccc$var$launchProductForClient(environment || "dev", connection, applicationCode, undefined, originalHandleToggle, null, null, clientId, platformService);
                else {
                    // If the clientId is not present in the token, redirect to launch page to refresh it
                    const clientsInToken = yield platformService === null || platformService === void 0 ? void 0 : platformService.getClientsInToken();
                    if (!clientsInToken.some((client)=>client.getId() === clientId)) {
                        const baseUrl = environment === "prod" ? "https://platform.lwolf.com" : `https://platform.${environment || "dev"}.lwolf.com`;
                        const launchFoundationUrl = `${baseUrl}/product/launch?a=fdn&ac=${clientId}`;
                        window.open(launchFoundationUrl, "_self");
                        return;
                    }
                    // Redirect to foundation homepage if no access
                    let foundationUrl;
                    if ((environment || "dev") === "prod") {
                        const acParam = clientId ? `ac=${encodeURIComponent(clientId)}` : "";
                        foundationUrl = `https://foundation.lwolf.com/${acParam ? `?${acParam}` : ""}`;
                    } else {
                        const acParam = clientId ? `ac=${encodeURIComponent(clientId)}` : "";
                        foundationUrl = `https://foundation.${environment || "dev"}.lwolf.com/${acParam ? `?${acParam}` : ""}`;
                    }
                    window.open(foundationUrl, "_self");
                }
            } else if (typeof originalHandleToggle === "function") originalHandleToggle();
        });
    // Load product data on component mount (skip when using mock data)
    (0, $acw62.useEffect)(()=>{
        $2ad24e75a96deccc$var$fetchProductData(token);
    }, [
        useMockData,
        token
    ]);
    // Get branding data for custom product icons (skip when using mock data)
    const { branding: branding } = $2ad24e75a96deccc$var$useBranding({
        environment: environment || "dev",
        localStorageTokenKey: localStorageTokenKey,
        userToken: useMockData ? "" : token,
        activeClientId: useMockData ? "" : activeClientId // Pass empty activeClientId when using mock data
    });
    // Merge app data URLs with products.json data
    const getApplicationMeta = (appId)=>{
        var _a, _b;
        const productMeta = $2ad24e75a96deccc$var$applicationMeta[appId] || {};
        const appMeta = appData.find((app)=>app.id === appId);
        return Object.assign(Object.assign({}, productMeta), {
            url: ((_b = (_a = appMeta === null || appMeta === void 0 ? void 0 : appMeta.config) === null || _a === void 0 ? void 0 : _a.login) === null || _b === void 0 ? void 0 : _b.url) || ""
        });
    };
    // Add helper function to translate client types
    const translateClientType = (clientType, uiText)=>{
        const lowerType = clientType.toLowerCase();
        if (lowerType === "personal" || lowerType === "user") return uiText.personal;
        if (lowerType === "brokerage") return uiText.brokerage;
        return clientType; // Return original if no translation found
    };
    const getAppsSection = ()=>$2ad24e75a96deccc$var$__awaiter(void 0, void 0, void 0, function*() {
            try {
                // If no token and not using mock data, turn off loading and return
                if (!token && !useMockData) {
                    console.warn("No token available, skipping client data loading");
                    setIsLoading(false);
                    return;
                }
                // Use mock data for documentation/storybook
                if (useMockData) {
                    const uiText = $2ad24e75a96deccc$var$getUIText(token);
                    setAppData($2ad24e75a96deccc$var$mockAppData);
                    setAppConnections($2ad24e75a96deccc$var$mockAppConnections);
                    setAppConnectionsFull($2ad24e75a96deccc$var$mockAppConnections);
                    // Process mock clients similar to real data
                    const mappedClients = $2ad24e75a96deccc$var$mockClients.map((client, idx)=>({
                            label: client.name,
                            clientType: translateClientType(client.clientType === "User" ? "Personal" : client.clientType, uiText),
                            appIds: client.appIds,
                            clientId: client.clientId,
                            onClick: ()=>{
                                setSelectedClient(client.name);
                                if (onClientChange) onClientChange(client);
                                if (applicationCode) {
                                    const connection = $2ad24e75a96deccc$var$mockAppConnections.find((conn)=>conn.clientId === client.clientId && conn.appId === applicationCode);
                                    $2ad24e75a96deccc$var$launchProductForClient(environment || "dev", connection, applicationCode, undefined, originalHandleToggle, null, null, client.clientId, platformService);
                                } else if (typeof originalHandleToggle === "function") originalHandleToggle();
                            },
                            id: client.clientId
                        }));
                    setClients(mappedClients);
                    setIsLoading(false);
                    return;
                }
                const appDataResult = yield platformService.getAppData();
                const activeClientIdFromPlatform = yield platformService.getActiveClientId();
                // if there is no active client id from the platform, default to the one from context (which may be from cookie/localStorage)
                if (activeClientIdFromPlatform) setActiveClientId && setActiveClientId(activeClientIdFromPlatform);
                if (activeClientId && activeClientIdFromPlatform && activeClientId !== activeClientIdFromPlatform && fallbackToActiveClientIdParam) setActiveClientId && setActiveClientId(activeClientId);
                if (activeClientId && !activeClientIdFromPlatform && platformService.setLastActiveClientId && typeof platformService.setLastActiveClientId === "function") yield platformService.setLastActiveClientId(activeClientId !== null && activeClientId !== void 0 ? activeClientId : "").catch((error)=>{
                    console.error("Error setting last active client ID:", error);
                });
                else console.warn("setLastActiveClientId method not available on platformService");
                // filter out any hidden apps
                const appDataFiltered = appDataResult.filter((app)=>!app.config.hidden);
                setAppData(appDataFiltered);
                const lwaClients = yield platformService.getLwaClients();
                const apiClients = yield platformService.getClientsAsConnections();
                const appConnectionsResult = yield platformService.getConnections();
                const clientsSummary = yield platformService.getClientsSummary();
                // Filter appConnectionsResult to include only items that exist in appDataFiltered
                const filteredAppConnectionsResult = appConnectionsResult.filter((connection)=>appDataFiltered.some((app)=>app.id === connection.appId));
                // if any of the data is missing or empty skip processing and just set clients to an empty array to avoid breaking the component
                if (!appDataResult || appDataResult.length === 0 || !appConnectionsResult || appConnectionsResult.length === 0) {
                    console.warn("Missing app data or app connections, skipping client processing");
                    setClients([]);
                    setIsLoading(false);
                    return;
                }
                setAppConnectionsFull(appConnectionsResult);
                setAppConnections(filteredAppConnectionsResult);
                // Group by clientId
                // Start with all lwaClients to ensure we don't miss any clients
                const grouped = lwaClients.reduce((acc, curr)=>{
                    var _a;
                    acc[curr.clientId] = {
                        clientId: curr.clientId,
                        name: curr.name || ((_a = clientsSummary === null || clientsSummary === void 0 ? void 0 : clientsSummary.find((c)=>c.id === curr.clientId)) === null || _a === void 0 ? void 0 : _a.name) || "",
                        clientType: curr.clientType || "",
                        appIds: []
                    };
                    return acc;
                }, {});
                // Add app connections to existing clients
                apiClients.forEach((curr)=>{
                    var _a;
                    const { clientId: clientId, name: name, appId: appId } = curr;
                    if (!grouped[clientId]) {
                        // This shouldn't happen if lwaClients is properly populated, but handle it just in case
                        const lwa = lwaClients.find((c)=>c.clientId === clientId);
                        grouped[clientId] = {
                            clientId: clientId,
                            name: name || ((_a = clientsSummary === null || clientsSummary === void 0 ? void 0 : clientsSummary.find((c)=>c.clientId === clientId)) === null || _a === void 0 ? void 0 : _a.name) || "",
                            clientType: (lwa === null || lwa === void 0 ? void 0 : lwa.clientType) || "",
                            appIds: []
                        };
                    } else // Update name if it's provided in apiClients
                    if (name) grouped[clientId].name = name;
                    grouped[clientId].appIds.push(appId);
                });
                // Map to menu item format - NOW that we have appConnectionsResult populated
                const mappedClients = Object.values(grouped).map((client, idx)=>{
                    const uiText = $2ad24e75a96deccc$var$getUIText(token);
                    // Attach clientId directly for later use
                    const mappedClient = {
                        label: client.name || client.clientId || `Client ${idx + 1}`,
                        clientType: translateClientType(client.clientType === "User" ? "Personal" : client.clientType || "", uiText),
                        appIds: client.appIds,
                        clientId: client.clientId,
                        onClick: ()=>handleClientClick({
                                clientId: client.clientId,
                                id: client.clientId,
                                name: client.name || client.clientId || `Client ${idx + 1}`,
                                label: client.name || client.clientId || `Client ${idx + 1}`
                            }),
                        id: client.clientId
                    };
                    return mappedClient;
                });
                // Use only real clients (sorting will be done dynamically)
                const allClients = [
                    ...mappedClients
                ];
                setClients(allClients);
            } catch (error) {
                console.error("Error loading clients:", error);
            } finally{
                setIsLoading(false);
            }
        });
    (0, $acw62.useEffect)(()=>{
        // Call getAppsSection when we have a token OR when using mock data
        if (token || useMockData) getAppsSection();
        else setIsLoading(false);
    }, [
        token,
        useMockData
    ]);
    // Set default selected client when clients are loaded (only on initial load)
    const didInit = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        if (clients.length > 0 && !selectedClient) {
            let newClient = null;
            if (useMockData) // Always set client-2 (Personal) as default when using mock data
            newClient = clients.find((c)=>c.clientId === "client-2") || clients[0];
            else // First try to find client by activeClientId
            newClient = (activeClientId ? clients.find((c)=>c.id === activeClientId) : null) || clients[0];
            if (newClient && typeof newClient.label === "string") {
                setSelectedClient(newClient.label);
                if (didInit.current) {
                    if (onClientChange) onClientChange(newClient);
                }
                didInit.current = true;
            }
        }
    }, [
        clients,
        activeClientId,
        useMockData,
        onClientChange
    ]);
    // (moved below after isOpen/originalHandleToggle declaration)
    // Create sorted clients with activeClientId always at top (ignore selectedClient for sorting)
    const sortedClients = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        if (clients.length === 0) return [];
        return [
            ...clients
        ].sort((a, b)=>{
            // Always prioritize the activeClientId (client it was loaded with) at the top
            if (activeClientId) {
                if (a.id === activeClientId && b.id !== activeClientId) return -1;
                if (b.id === activeClientId && a.id !== activeClientId) return 1;
            }
            return 0;
        });
    }, [
        clients,
        activeClientId
    ]);
    // Find the active client object (the client the app was loaded with)
    // Fallback to first client if activeClientId doesn't match any client
    const activeClientObj = (activeClientId ? sortedClients.find((c)=>c.id === activeClientId) : null) || sortedClients[0];
    const appIds = activeClientObj === null || activeClientObj === void 0 ? void 0 : activeClientObj.appIds.filter((appId)=>appConnections.some((conn)=>conn.appId === appId));
    // Build the applications for the active client (always use activeClientId, not selectedClient)
    const activeClientApps = (appIds || []).map((appId)=>{
        var _a, _b, _c, _d, _e;
        const meta = getApplicationMeta(appId);
        const brandingConnection = appConnections.find((conn)=>conn.appId === appId && conn.clientId === (activeClientObj === null || activeClientObj === void 0 ? void 0 : activeClientObj.id));
        // Only apply branding if this is for the correct client and app combination
        const shouldApplyBranding = (activeClientObj === null || activeClientObj === void 0 ? void 0 : activeClientObj.id) === (branding === null || branding === void 0 ? void 0 : branding.id) && ((_a = branding === null || branding === void 0 ? void 0 : branding.applications) === null || _a === void 0 ? void 0 : _a[appId]);
        const customName = ((_b = brandingConnection === null || brandingConnection === void 0 ? void 0 : brandingConnection.branding) === null || _b === void 0 ? void 0 : _b.appName) || (shouldApplyBranding ? (_d = (_c = branding === null || branding === void 0 ? void 0 : branding.applications) === null || _c === void 0 ? void 0 : _c[appId]) === null || _d === void 0 ? void 0 : _d.name : null);
        const connection = appConnections.find((conn)=>conn.appId === appId && conn.clientId === (activeClientObj === null || activeClientObj === void 0 ? void 0 : activeClientObj.id));
        return {
            label: customName || $2ad24e75a96deccc$var$applicationCodeToName[appId] || appId,
            iconUrl: ((_e = brandingConnection === null || brandingConnection === void 0 ? void 0 : brandingConnection.branding) === null || _e === void 0 ? void 0 : _e.logoUrl) || (shouldApplyBranding ? branding === null || branding === void 0 ? void 0 : branding.logoUrl : null) || meta.iconUrl || "https://assets.lwolf.com/lwt-helix/icons/latest/outlined/wolfie.svg",
            description: meta.description || "",
            url: connection ? $2ad24e75a96deccc$var$buildProductLaunchUrl(environment || "dev", connection) : meta.url || "",
            appId: appId,
            onClick: ()=>{
                $2ad24e75a96deccc$var$launchProductForClient(environment || "dev", connection, appId, meta.url, null, null, null, activeClientId, platformService);
            }
        };
    });
    // Build personal apps - apps from appConnections that aren't attached to any specific client
    const personalApps = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>{
        // Get all appIds that are already assigned to specific clients
        const clientAppIds = new Set(sortedClients.flatMap((client)=>client.appIds || []));
        // Find apps in appConnections that aren't in any client's appIds
        const standaloneApps = appConnections.filter((conn)=>conn.appId && !clientAppIds.has(conn.appId));
        // remove any apps that have an id of just bo
        const removeBOApps = standaloneApps.filter((app)=>app.appId && app.appId !== "bo");
        // Group by appId
        const groupedApps = removeBOApps.reduce((acc, conn)=>{
            if (!acc[conn.appId]) acc[conn.appId] = [];
            acc[conn.appId].push(conn);
            return acc;
        }, {});
        // Create grouped app items
        return Object.entries(groupedApps).map(([appId, connections])=>{
            var _a, _b, _c, _d;
            const meta = getApplicationMeta(appId);
            const appName = $2ad24e75a96deccc$var$applicationCodeToName[appId] || appId;
            const connectionArray = connections;
            const instanceNames = connectionArray.map((conn)=>conn.name || conn.clientId);
            const count = connectionArray.length;
            // Use the first connection for URL building (or could offer per-instance launch)
            const firstConnection = connectionArray[0];
            const brandingConnection = appConnections.find((conn)=>conn.appId === appId && conn.clientId === (firstConnection === null || firstConnection === void 0 ? void 0 : firstConnection.clientId));
            // Only apply branding if this is for the correct client and app combination
            const shouldApplyBranding = (firstConnection === null || firstConnection === void 0 ? void 0 : firstConnection.clientId) === (branding === null || branding === void 0 ? void 0 : branding.id) && ((_a = branding === null || branding === void 0 ? void 0 : branding.applications) === null || _a === void 0 ? void 0 : _a[appId]);
            return {
                label: (shouldApplyBranding ? (_c = (_b = branding === null || branding === void 0 ? void 0 : branding.applications) === null || _b === void 0 ? void 0 : _b[appId]) === null || _c === void 0 ? void 0 : _c.name : null) || appName,
                iconUrl: ((_d = brandingConnection === null || brandingConnection === void 0 ? void 0 : brandingConnection.branding) === null || _d === void 0 ? void 0 : _d.logoUrl) || (shouldApplyBranding ? branding === null || branding === void 0 ? void 0 : branding.logoUrl : null) || meta.iconUrl || "https://assets.lwolf.com/lwt-helix/icons/latest/outlined/wolfie.svg",
                description: meta.description || "",
                url: firstConnection ? $2ad24e75a96deccc$var$buildProductLaunchUrl(environment || "dev", firstConnection) : meta.url || "",
                count: count,
                instances: [
                    ...instanceNames
                ].sort((a, b)=>a.localeCompare(b)),
                appId: appId,
                onClick: ()=>{
                    $2ad24e75a96deccc$var$launchProductForClient(environment || "dev", firstConnection, appId, meta.url, null, null, null, activeClientId, platformService);
                }
            };
        });
    }, [
        appConnections,
        sortedClients,
        lwDomain,
        branding
    ]);
    // Combine clients and products into a single array for dropdown navigation
    // If only one personal client, hide client list and show only products
    const combinedItems = [];
    const isSinglePersonalClient = sortedClients.length === 1 && (sortedClients[0].clientType === "Personal" || sortedClients[0].clientType === "User");
    // Get UI text based on language
    const uiText = $2ad24e75a96deccc$var$getUIText(token);
    if (!isSinglePersonalClient && sortedClients.length > 0) {
        combinedItems.push({
            type: "header",
            label: uiText.clients
        });
        // Show both clients if exactly 2, otherwise show first client + overflow
        const mainClientsCount = sortedClients.length === 2 ? 2 : MAIN_CLIENTS_DISPLAY_COUNT;
        const mainClients = sortedClients.slice(0, mainClientsCount);
        mainClients.forEach((client)=>{
            combinedItems.push({
                type: "client",
                label: client.label,
                clientType: client.clientType,
                appIds: client.appIds,
                id: client.id
            });
        });
    }
    let bovApp = null;
    let xbmApp = null;
    let filteredPersonalApps = personalApps;
    // Extract bov app
    const bovIndex = filteredPersonalApps.findIndex((app)=>app.appId === "bov");
    if (bovIndex !== -1) {
        const bov = personalApps[bovIndex];
        bovApp = {
            label: $2ad24e75a96deccc$var$applicationCodeToName["bov"] || "bov",
            iconUrl: ((_a = $2ad24e75a96deccc$var$applicationMeta["bov"]) === null || _a === void 0 ? void 0 : _a.iconUrl) || bov.iconUrl,
            description: ((_b = $2ad24e75a96deccc$var$applicationMeta["bov"]) === null || _b === void 0 ? void 0 : _b.description) || bov.description || "",
            url: bov.url,
            onClick: bov.onClick,
            appId: "bov",
            count: bov.count,
            instances: [
                ...bov.instances || []
            ].sort((a, b)=>a.localeCompare(b)),
            alwaysShowTooltip: ((_c = $2ad24e75a96deccc$var$applicationMeta["bov"]) === null || _c === void 0 ? void 0 : _c.alwaysShowTooltip) ? true : false
        };
        filteredPersonalApps = [
            ...filteredPersonalApps.slice(0, bovIndex),
            ...filteredPersonalApps.slice(bovIndex + 1)
        ];
    }
    // Extract xbm app
    const xbmIndex = filteredPersonalApps.findIndex((app)=>app.appId === "xbm");
    if (xbmIndex !== -1) {
        const xbm = filteredPersonalApps[xbmIndex];
        xbmApp = {
            label: $2ad24e75a96deccc$var$applicationCodeToName["xbm"] || "xbm",
            iconUrl: ((_d = $2ad24e75a96deccc$var$applicationMeta["xbm"]) === null || _d === void 0 ? void 0 : _d.iconUrl) || xbm.iconUrl,
            description: ((_e = $2ad24e75a96deccc$var$applicationMeta["xbm"]) === null || _e === void 0 ? void 0 : _e.description) || xbm.description || "",
            url: xbm.url,
            onClick: xbm.onClick,
            appId: "xbm",
            count: xbm.count,
            instances: [
                ...xbm.instances || []
            ].sort((a, b)=>a.localeCompare(b)),
            alwaysShowTooltip: ((_f = $2ad24e75a96deccc$var$applicationMeta["xbm"]) === null || _f === void 0 ? void 0 : _f.alwaysShowTooltip) ? true : false
        };
        filteredPersonalApps = [
            ...filteredPersonalApps.slice(0, xbmIndex),
            ...filteredPersonalApps.slice(xbmIndex + 1)
        ];
    }
    if (!isSinglePersonalClient && sortedClients.length > 0) combinedItems.push({
        type: "separator"
    });
    // Find if fdn is in provisioned apps
    const fdnIndex = activeClientApps.findIndex((app)=>app.label === ($2ad24e75a96deccc$var$applicationCodeToName["fdn"] || "fdn") || app.appId === "fdn");
    let foundationApp = null;
    let filteredApps = [];
    if (fdnIndex !== -1) {
        // Foundation is provisioned, float it to the top
        const foundationBrandingConn = appConnections.find((conn)=>conn.appId === "fdn" && conn.clientId === (activeClientObj === null || activeClientObj === void 0 ? void 0 : activeClientObj.id));
        foundationApp = Object.assign(Object.assign({}, activeClientApps[fdnIndex]), {
            appId: "fdn",
            iconUrl: ((_g = foundationBrandingConn === null || foundationBrandingConn === void 0 ? void 0 : foundationBrandingConn.branding) === null || _g === void 0 ? void 0 : _g.logoUrl) || activeClientApps[fdnIndex].iconUrl
        });
        filteredApps = [
            ...activeClientApps.slice(0, fdnIndex),
            ...activeClientApps.slice(fdnIndex + 1)
        ];
    } else {
        // Foundation is not provisioned, hardcode it
        const foundationMeta = getApplicationMeta("fdn");
        // Use explicit activeClientId if available, fallback to activeClientObj?.id
        const clientIdForFoundation = activeClientId || (activeClientObj === null || activeClientObj === void 0 ? void 0 : activeClientObj.id) || "";
        const baseFoundationUrl = foundationMeta.url || (environment === "prod" ? "https://foundation.lwolf.com/" : `https://foundation.${environment || "dev"}.lwolf.com/`);
        const foundationUrl = `${baseFoundationUrl}${baseFoundationUrl.includes("?") ? "&" : "?"}ac=${clientIdForFoundation}`;
        const foundationBrandingConnection = appConnections.find((conn)=>conn.appId === "fdn" && conn.clientId === (activeClientObj === null || activeClientObj === void 0 ? void 0 : activeClientObj.id));
        const shouldApplyFoundationBranding = (activeClientObj === null || activeClientObj === void 0 ? void 0 : activeClientObj.id) === (foundationBrandingConnection === null || foundationBrandingConnection === void 0 ? void 0 : foundationBrandingConnection.clientId) && ((_h = branding === null || branding === void 0 ? void 0 : branding.applications) === null || _h === void 0 ? void 0 : _h["fdn"]);
        foundationApp = {
            label: $2ad24e75a96deccc$var$applicationCodeToName["fdn"] || "Foundation",
            iconUrl: ((_j = foundationBrandingConnection === null || foundationBrandingConnection === void 0 ? void 0 : foundationBrandingConnection.branding) === null || _j === void 0 ? void 0 : _j.logoUrl) || (shouldApplyFoundationBranding ? branding === null || branding === void 0 ? void 0 : branding.logoUrl : null) || foundationMeta.iconUrl || "https://assets.lwolf.com/lwt-helix/icons/latest/products/outlined/foundation.svg",
            description: foundationMeta.description || "",
            url: foundationUrl,
            onClick: ()=>{
                window.open(foundationUrl, "_self");
            },
            appId: "fdn"
        };
        filteredApps = [
            ...activeClientApps
        ];
    }
    // Collect all main products (excluding Foundation) for alphabetical sorting
    const allMainProducts = [];
    // Add active client apps
    filteredApps.forEach((app)=>{
        allMainProducts.push(app);
    });
    // Add bov if present
    if (bovApp) allMainProducts.push(bovApp);
    // Add xbm if present
    if (xbmApp) allMainProducts.push(xbmApp);
    // Sort all main products alphabetically by label
    const sortedMainProducts = allMainProducts.sort((a, b)=>a.label.localeCompare(b.label, undefined, {
            sensitivity: "base"
        }));
    // Always push Foundation first
    if (foundationApp) combinedItems.push({
        type: "product",
        label: foundationApp.label,
        iconUrl: foundationApp.iconUrl,
        description: foundationApp.description,
        url: foundationApp.url,
        onClick: foundationApp.onClick,
        tooltip: ((_k = $2ad24e75a96deccc$var$applicationMeta["fdn"]) === null || _k === void 0 ? void 0 : _k.tooltip) || "",
        alwaysShowTooltip: ((_l = $2ad24e75a96deccc$var$applicationMeta["fdn"]) === null || _l === void 0 ? void 0 : _l.alwaysShowTooltip) ? true : false,
        id: foundationApp.appId,
        appId: foundationApp.appId
    });
    // Then add all other products in alphabetical order
    sortedMainProducts.forEach((app)=>{
        var _a, _b;
        combinedItems.push({
            type: "product",
            label: app.label,
            iconUrl: app.iconUrl,
            description: app.description,
            url: app.url,
            onClick: app.onClick,
            count: app.count,
            instances: [
                ...app.instances || []
            ].sort((a, b)=>a.localeCompare(b)),
            appId: app.appId,
            id: app.appId,
            tooltip: app.appId ? ((_a = $2ad24e75a96deccc$var$applicationMeta[app.appId]) === null || _a === void 0 ? void 0 : _a.tooltip) || "" : "",
            alwaysShowTooltip: app.appId ? ((_b = $2ad24e75a96deccc$var$applicationMeta[app.appId]) === null || _b === void 0 ? void 0 : _b.alwaysShowTooltip) ? true : false : false
        });
    });
    // Use filteredPersonalApps for legacy section below
    // Always show legacy (personal) apps regardless of active client
    if (filteredPersonalApps.length > 0) {
        combinedItems.push({
            type: "separator"
        });
        combinedItems.push({
            type: "header",
            label: uiText.legacyProducts
        });
        // Sort legacy products alphabetically by label
        const sortedPersonalApps = [
            ...filteredPersonalApps
        ].sort((a, b)=>{
            const labelA = $2ad24e75a96deccc$var$applicationCodeToName[a.appId] || a.appId;
            const labelB = $2ad24e75a96deccc$var$applicationCodeToName[b.appId] || b.appId;
            return labelA.localeCompare(labelB, undefined, {
                sensitivity: "base"
            });
        });
        sortedPersonalApps.forEach((app)=>{
            var _a, _b, _c, _d;
            combinedItems.push({
                type: "product",
                label: $2ad24e75a96deccc$var$applicationCodeToName[app.appId] || app.appId,
                iconUrl: ((_a = $2ad24e75a96deccc$var$applicationMeta[app.appId]) === null || _a === void 0 ? void 0 : _a.iconUrl) || app.iconUrl,
                description: ((_b = $2ad24e75a96deccc$var$applicationMeta[app.appId]) === null || _b === void 0 ? void 0 : _b.description) || app.description || "",
                url: app.url,
                onClick: app.onClick,
                count: app.count,
                instances: [
                    ...app.instances || []
                ].sort((a, b)=>a.localeCompare(b)),
                appId: app.appId,
                id: app.appId,
                tooltip: ((_c = $2ad24e75a96deccc$var$applicationMeta[app.appId]) === null || _c === void 0 ? void 0 : _c.tooltip) || "",
                alwaysShowTooltip: ((_d = $2ad24e75a96deccc$var$applicationMeta[app.appId]) === null || _d === void 0 ? void 0 : _d.alwaysShowTooltip) ? true : false
            });
        });
    }
    const handleLegacyAppClick = (appId, instances, event)=>{
        if (instances.length > 1) {
            event.stopPropagation();
            const rect = event.currentTarget.getBoundingClientRect();
            // Estimate submenu dimensions
            const submenuWidth = 200;
            const submenuHeight = instances.length * 44 + 16; // Approximate height per item + padding
            // Calculate viewport dimensions
            const viewportWidth = window.innerWidth;
            const viewportHeight = window.innerHeight;
            // Default position (below and aligned left)
            let top = rect.bottom + 4;
            let left = rect.left;
            // Check if submenu would go off the right edge
            if (left + submenuWidth > viewportWidth) left = rect.right - submenuWidth; // Align right edge of submenu with right edge of item
            // Check if submenu would go off the left edge
            if (left < 0) left = 8; // Small margin from viewport edge
            // Check if submenu would go off the bottom edge
            if (top + submenuHeight > viewportHeight) top = rect.top - submenuHeight - 4; // Position above the item
            // Check if submenu would go off the top edge
            if (top < 0) top = 8; // Small margin from viewport top
            setLegacyAppSubmenuPosition({
                top: top,
                left: left
            });
            setExpandedLegacyApp(expandedLegacyApp === appId ? null : appId);
        } else {
            // Single instance, navigate directly
            const instance = instances[0];
            const url = `https://${instance.subdomain}.${instance.domain}`;
            window.open(url, "_self");
            originalHandleToggle();
            setExpandedLegacyApp(null);
        }
    };
    const handleSelect = (index, id, label)=>{
        // Handle special keyboard navigation cases
        if (id === "__PREVIEW_TOGGLE__") {
            setIsClientPreviewExpanded(!isClientPreviewExpanded);
            const action = !isClientPreviewExpanded ? "expanded" : "collapsed";
            setAnnounceText(`Client overflow section ${action}`);
            return;
        }
        if (id.startsWith("__OVERFLOW_")) {
            const clientId = id.replace("__OVERFLOW_", "").replace("__", "");
            const client = clients.find((c)=>c.id === clientId);
            if (client) {
                setSelectedClient(client.label);
                setAnnounceText(`Switched to client: ${client.label}`);
            }
            setIsClientPreviewExpanded(false);
            return;
        }
        // Handle regular combined items - find by ID
        const selectedItem = combinedItems.find((item)=>(item.type === "client" || item.type === "product") && item.id === id);
        if (selectedItem) {
            if (selectedItem.type === "client") {
                setSelectedClient(selectedItem.label);
                setAnnounceText(`Switched to client: ${selectedItem.label}`);
                // Fire onClientChange callback if provided
                const clientObj = clients.find((c)=>c.id === selectedItem.id);
                if (onClientChange && clientObj) onClientChange(clientObj);
                // Close the dropdown after client selection
                originalHandleToggle();
            } else if (selectedItem.type === "product") {
                setAnnounceText(`Launching application: ${selectedItem.label}`);
                // Fire onProductChange callback if provided
                if (onProductChange) onProductChange(selectedItem);
                if (selectedItem.onClick) selectedItem.onClick();
            }
        // Ignore selection for headers and separators
        }
    };
    // Custom key handler to override default dropdown behavior for preview toggle
    const customHandleKeyDown = (event)=>$2ad24e75a96deccc$var$__awaiter(void 0, void 0, void 0, function*() {
            var _q;
            const selectableItems = [];
            // Build the same selectable items array as in useDropdownMenu
            combinedItems.forEach((itm)=>{
                if (itm.type === "client") selectableItems.push(itm.id || itm.label);
            });
            const mainClientsCount = clients.length === 2 ? 2 : MAIN_CLIENTS_DISPLAY_COUNT;
            if (clients.length > mainClientsCount) {
                selectableItems.push("__PREVIEW_TOGGLE__");
                if (isClientPreviewExpanded) clients.slice(mainClientsCount).forEach((client)=>{
                    selectableItems.push(`__OVERFLOW_${client.id}__`);
                });
            }
            combinedItems.forEach((itm)=>{
                if (itm.type === "product") selectableItems.push(itm.id || itm.appId || itm.label);
            });
            // Check if current highlighted item is preview toggle
            const currentItem = selectableItems[highlightedIndex];
            if ((event.key === "Enter" || event.key === " ") && currentItem === "__PREVIEW_TOGGLE__") {
                event.preventDefault();
                event.stopPropagation();
                setIsClientPreviewExpanded(!isClientPreviewExpanded);
                return;
            }
            // For overflow clients, handle them but allow dropdown to close
            if ((event.key === "Enter" || event.key === " ") && (currentItem === null || currentItem === void 0 ? void 0 : currentItem.startsWith("__OVERFLOW_"))) {
                event.preventDefault();
                const clientId = currentItem.replace("__OVERFLOW_", "").replace("__", "");
                // Find the client by ID
                const client = clients.find((c)=>c.id === clientId);
                if (client) yield handleClientClick(client);
                setIsClientPreviewExpanded(false);
                // Let the dropdown close naturally
                handleKeyDown(event);
                return;
            }
            // Handle legacy app keyboard navigation
            if (currentItem) {
                const legacyAppItem = personalApps.find((app)=>app.appId === currentItem);
                if (legacyAppItem && legacyAppItem.count > 1) {
                    if (event.key === "ArrowDown" && !expandedLegacyApp) {
                        // Open submenu when down arrow is pressed on legacy app
                        event.preventDefault();
                        event.stopPropagation();
                        // Find the currently highlighted element
                        const selectableElements = (_q = menuRef.current) === null || _q === void 0 ? void 0 : _q.querySelectorAll('[data-selectable="true"]');
                        const highlightedElement = selectableElements === null || selectableElements === void 0 ? void 0 : selectableElements[highlightedIndex];
                        if (highlightedElement) {
                            const rect = highlightedElement.getBoundingClientRect();
                            const viewportWidth = window.innerWidth;
                            const viewportHeight = window.innerHeight;
                            const submenuWidth = 200;
                            // Sort instances alphabetically for submenu
                            const sortedInstances = [
                                ...legacyAppItem.instances || []
                            ].sort((a, b)=>a.localeCompare(b));
                            const submenuHeight = sortedInstances.length * 44 + 16;
                            // Default position (below and aligned left)
                            let top = rect.bottom + 4;
                            let left = rect.left;
                            // Check viewport boundaries and adjust position
                            if (left + submenuWidth > viewportWidth) left = rect.right - submenuWidth;
                            if (left < 0) left = 8;
                            if (top + submenuHeight > viewportHeight) top = rect.top - submenuHeight - 4;
                            if (top < 0) top = 8;
                            setLegacyAppSubmenuPosition({
                                top: top,
                                left: left
                            });
                            setExpandedLegacyApp(legacyAppItem.appId);
                            setSubmenuHighlightedIndex(0); // Start with first item highlighted
                            setAnnounceText(`Opened ${legacyAppItem.label} submenu with ${legacyAppItem.instances.length} instances. Use arrow keys to navigate, Enter to select.`);
                        }
                        return;
                    } else if ((event.key === "Enter" || event.key === " ") && expandedLegacyApp === legacyAppItem.appId) {
                        // Enter/Space on expanded legacy app should select first instance
                        event.preventDefault();
                        event.stopPropagation();
                        const sortedInstances = [
                            ...legacyAppItem.instances || []
                        ].sort((a, b)=>a.localeCompare(b));
                        const selectedInstance = sortedInstances[submenuHighlightedIndex];
                        // Find the connection for this legacy app and instance
                        const connection = appConnections.find((conn)=>conn.appId === legacyAppItem.appId && (conn.name === selectedInstance || conn.clientId === selectedInstance));
                        if (connection) {
                            const url = $2ad24e75a96deccc$var$buildProductLaunchUrl(environment || "dev", connection);
                            window.open(url, "_self");
                            originalHandleToggle();
                            setExpandedLegacyApp(null);
                            setSubmenuHighlightedIndex(0);
                        }
                        return;
                    }
                }
            }
            // Handle submenu navigation
            if (expandedLegacyApp) {
                const expandedApp = personalApps.find((app)=>app.appId === expandedLegacyApp);
                if (expandedApp) {
                    // Sort instances alphabetically for submenu navigation
                    const sortedInstances = [
                        ...expandedApp.instances || []
                    ].sort((a, b)=>a.localeCompare(b));
                    if (event.key === "ArrowDown") {
                        event.preventDefault();
                        event.stopPropagation();
                        if (submenuHighlightedIndex < sortedInstances.length - 1) // Navigate down within submenu
                        setSubmenuHighlightedIndex(submenuHighlightedIndex + 1);
                        else {
                            // At last item, close submenu and move to next main item
                            setExpandedLegacyApp(null);
                            setSubmenuHighlightedIndex(0);
                            handleKeyDown(event);
                        }
                        return;
                    } else if (event.key === "ArrowUp") {
                        event.preventDefault();
                        event.stopPropagation();
                        if (submenuHighlightedIndex > 0) // Navigate up within submenu
                        setSubmenuHighlightedIndex(submenuHighlightedIndex - 1);
                        else {
                            // At first item, close submenu and return to main menu
                            setExpandedLegacyApp(null);
                            setSubmenuHighlightedIndex(0);
                        }
                        return;
                    } else if (event.key === "Enter" || event.key === " ") {
                        // Select highlighted instance
                        event.preventDefault();
                        event.stopPropagation();
                        const selectedInstance = sortedInstances[submenuHighlightedIndex];
                        // Find the connection for this legacy app and instance
                        const connection = appConnections.find((conn)=>conn.appId === expandedLegacyApp && (conn.name === selectedInstance || conn.clientId === selectedInstance));
                        if (connection) {
                            const url = $2ad24e75a96deccc$var$buildProductLaunchUrl(environment || "dev", connection);
                            window.open(url, "_self");
                            originalHandleToggle();
                            setExpandedLegacyApp(null);
                            setSubmenuHighlightedIndex(0);
                        }
                        return;
                    } else if (event.key === "Escape") {
                        // Close submenu on Escape
                        event.preventDefault();
                        event.stopPropagation();
                        setExpandedLegacyApp(null);
                        setSubmenuHighlightedIndex(0);
                        return;
                    }
                }
            }
            // Use the default handler for all other cases
            handleKeyDown(event);
        });
    const { isOpen: isOpen, highlightedIndex: highlightedIndex, calculatedPlacement: calculatedPlacement, buttonRef: buttonRef, menuRef: menuRef, handleToggle: originalHandleToggle, handleKeyDown: handleKeyDown } = $2ad24e75a96deccc$var$useDropdownMenu({
        placement: "bottom",
        onSelect: handleSelect,
        highlightFirst: true,
        // Only include selectable items for navigation
        items: (()=>{
            const selectableItems = [];
            // Add main clients first (first 2)
            combinedItems.forEach((item)=>{
                if (item.type === "client") selectableItems.push(item.id || item.label);
            });
            // Add preview toggle right after main clients if there are overflow clients
            const mainClientsCount = sortedClients.length === 2 ? 2 : MAIN_CLIENTS_DISPLAY_COUNT;
            if (sortedClients.length > mainClientsCount) {
                selectableItems.push("__PREVIEW_TOGGLE__");
                // Add overflow clients when expanded
                if (isClientPreviewExpanded) sortedClients.slice(mainClientsCount).forEach((client)=>{
                    selectableItems.push(`__OVERFLOW_${client.id}__`);
                });
            }
            // Add products last
            combinedItems.forEach((item)=>{
                if (item.type === "product") selectableItems.push(item.id || item.appId || item.label);
            });
            return selectableItems;
        })()
    });
    // Close submenu when clicking outside
    (0, $acw62.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            const target = event.target;
            // Exclude clicks on any element in the legacy instance menu (by class)
            if (target.closest(".client-picker__legacy-instance")) return;
            if (expandedLegacyApp && !target.closest(".client-picker__dropdown") && !target.closest('[data-selectable="true"]') && !target.closest(".client-picker__legacy-instance")) setExpandedLegacyApp(null);
        };
        if (expandedLegacyApp) {
            document.addEventListener("mousedown", handleClickOutside);
            return ()=>document.removeEventListener("mousedown", handleClickOutside);
        }
    }, [
        expandedLegacyApp
    ]);
    // Close instance menu when main dropdown scrolls
    (0, $acw62.useEffect)(()=>{
        const handleMainMenuScroll = ()=>{
            if (expandedLegacyApp) {
                setExpandedLegacyApp(null);
                setSubmenuHighlightedIndex(0);
            }
        };
        if (isOpen && expandedLegacyApp && menuRef.current) {
            menuRef.current.addEventListener("scroll", handleMainMenuScroll);
            return ()=>{
                if (menuRef.current) menuRef.current.removeEventListener("scroll", handleMainMenuScroll);
            };
        }
    }, [
        isOpen,
        expandedLegacyApp
    ]);
    // Handle clicks outside the dropdown to close it
    (0, $acw62.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            // Exclude clicks on legacy app instance text (do not close menu)
            let el = event.target;
            while(el){
                if (el.classList && el.classList.contains($2ad24e75a96deccc$var$styles["client-picker__app-text"])) return; // Don't close menu if clicking on legacy app instance text
                el = el.parentElement;
            }
            // Check if click is within the legacy instance submenu
            const target = event.target;
            if (target.closest(".client-picker__legacy-instance")) return; // Don't close main menu if clicking on instance submenu
            if (isOpen && buttonRef.current && menuRef.current && !buttonRef.current.contains(event.target) && !menuRef.current.contains(event.target)) {
                setIsClientPreviewExpanded(false);
                originalHandleToggle(); // Close the dropdown
            }
        };
        if (isOpen) {
            document.addEventListener("mousedown", handleClickOutside);
            return ()=>{
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }
    }, [
        isOpen,
        originalHandleToggle
    ]);
    // Scroll to highlighted item during keyboard navigation and announce it
    (0, $acw62.useEffect)(()=>{
        var _a, _b, _c;
        if (!isOpen || highlightedIndex === null || !menuRef.current) return;
        // Find all selectable elements in the dropdown
        const selectableElements = menuRef.current.querySelectorAll('[data-selectable="true"]');
        const targetElement = selectableElements[highlightedIndex];
        if (targetElement) {
            // Scroll the dropdown container to bring the target element into view
            const menuContainer = menuRef.current;
            const targetRect = targetElement.getBoundingClientRect();
            const containerRect = menuContainer.getBoundingClientRect();
            // Calculate if the element is outside the visible area
            const elementTop = targetRect.top - containerRect.top + menuContainer.scrollTop;
            const elementBottom = elementTop + targetRect.height;
            const visibleTop = menuContainer.scrollTop;
            const visibleBottom = visibleTop + menuContainer.clientHeight;
            // Scroll if element is not fully visible
            if (elementTop < visibleTop) // Element is above visible area
            menuContainer.scrollTop = elementTop - 10; // 10px padding
            else if (elementBottom > visibleBottom) // Element is below visible area
            menuContainer.scrollTop = elementBottom - menuContainer.clientHeight + 10;
            // Announce the highlighted item with more context
            const ariaLabel = targetElement.getAttribute("aria-label");
            const itemText = (_a = targetElement.textContent) === null || _a === void 0 ? void 0 : _a.trim();
            if (ariaLabel) // Use aria-label if available
            setAnnounceText(ariaLabel);
            else if (itemText) {
                // Determine item type and add context
                const isClientItem = (_b = targetElement.closest('[role="menuitem"]')) === null || _b === void 0 ? void 0 : _b.querySelector(".client-picker__client-menu-item");
                const isProductItem = (_c = targetElement.closest('[role="menuitem"]')) === null || _c === void 0 ? void 0 : _c.querySelector(".client-picker__app-menu-item");
                if (isClientItem) setAnnounceText(`Client: ${itemText}`);
                else if (isProductItem) setAnnounceText(`Application: ${itemText}`);
                else setAnnounceText(itemText);
            }
        }
    }, [
        isOpen,
        highlightedIndex
    ]);
    const handleToggle = ()=>{
        if (buttonRef.current) {
            const rect = buttonRef.current.getBoundingClientRect();
            setDropdownPosition({
                top: rect.bottom + window.scrollY + 10,
                left: rect.left + window.scrollX
            });
        }
        // Close the client preview when toggling main dropdown
        if (isOpen) {
            setIsClientPreviewExpanded(false);
            setAnnounceText("Client picker menu closed");
        } else setAnnounceText(`Client picker menu opened. ${combinedItems.length} items available. Use arrow keys to navigate.`);
        originalHandleToggle();
    };
    const handleButtonKeyDown = (event)=>{
        if (event.key === "ArrowDown" && !isOpen) {
            event.preventDefault();
            handleToggle();
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $2ad24e75a96deccc$var$styles["client-picker__container"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", {
        ref: buttonRef,
        className: $2ad24e75a96deccc$var$styles["client-picker__button"],
        onClick: handleToggle,
        onKeyDown: handleButtonKeyDown,
        "aria-haspopup": "menu",
        "aria-expanded": isOpen,
        "aria-label": `Client picker: ${activeClientObj === null || activeClientObj === void 0 ? void 0 : activeClientObj.label}. ${applicationName}`
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $2ad24e75a96deccc$var$styles["client-picker__logo"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
        src: logo,
        alt: "Logo"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $2ad24e75a96deccc$var$styles["client-picker__info"]
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $2ad24e75a96deccc$var$styles["client-picker__product-name"]
    }, applicationName), clients.length > 1 && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: $2ad24e75a96deccc$var$styles["client-picker__client"]
    }, activeClientObj === null || activeClientObj === void 0 ? void 0 : activeClientObj.label)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
        icon: (0, $c761e69c8e58189a$exports.app_grid),
        className: $2ad24e75a96deccc$var$styles["client-picker__chevron"]
    })), isOpen && (0, $1u0KT.createPortal)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: menuRef,
        className: $2ad24e75a96deccc$var$styles["client-picker__dropdown-menu"] + (isSinglePersonalClient ? " client-picker__dropdown-menu--no-client-header" : "") + " " + $2ad24e75a96deccc$var$styles[calculatedPlacement] + " " + $2ad24e75a96deccc$var$styles.open,
        tabIndex: 0,
        onKeyDown: customHandleKeyDown,
        role: "menu",
        "aria-label": "Client and application menu",
        style: {
            top: dropdownPosition.top,
            left: dropdownPosition.left,
            minWidth: 320
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", null, isLoading ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, [
        ...Array(2)
    ].map((_, idx)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: "skeleton-client-" + idx,
            className: $2ad24e75a96deccc$var$styles["client-picker__dropdown-item"] + " " + $2ad24e75a96deccc$var$styles["client-picker__dropdown-item--skeleton"]
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: $2ad24e75a96deccc$var$styles["client-picker__client-menu-item"]
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: $2ad24e75a96deccc$var$styles["client-picker__client-text"]
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: $2ad24e75a96deccc$var$styles["client-picker__skeleton-label"]
        }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: $2ad24e75a96deccc$var$styles["client-picker__skeleton-description"]
        })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: $2ad24e75a96deccc$var$styles["client-picker__client-right"]
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: $2ad24e75a96deccc$var$styles["client-picker__skeleton-switch"]
        }))))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
        className: $2ad24e75a96deccc$var$styles["client-picker__section-separator"]
    }), [
        ...Array(2)
    ].map((_, idx)=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: "skeleton-product-" + idx,
            className: $2ad24e75a96deccc$var$styles["client-picker__dropdown-item"] + " " + $2ad24e75a96deccc$var$styles["client-picker__dropdown-item--skeleton"]
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: $2ad24e75a96deccc$var$styles["client-picker__app-menu-item"]
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: $2ad24e75a96deccc$var$styles["client-picker__skeleton-icon"]
        }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: $2ad24e75a96deccc$var$styles["client-picker__app-text"]
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: $2ad24e75a96deccc$var$styles["client-picker__skeleton-label"]
        }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: $2ad24e75a96deccc$var$styles["client-picker__skeleton-product-description"]
        })))))) : combinedItems.map((item, index)=>{
        var _a;
        // Create selectable items array for navigation mapping (same order as above)
        const selectableItems = [];
        // Add main clients first
        combinedItems.forEach((itm)=>{
            if (itm.type === "client") selectableItems.push(itm.id || itm.label);
        });
        // Add preview toggle after main clients
        const mainClientsCount = clients.length === 2 ? 2 : MAIN_CLIENTS_DISPLAY_COUNT;
        if (clients.length > mainClientsCount) {
            selectableItems.push("__PREVIEW_TOGGLE__");
            if (isClientPreviewExpanded) clients.slice(mainClientsCount).forEach((client)=>{
                selectableItems.push(`__OVERFLOW_${client.id}__`);
            });
        }
        // Add products last
        combinedItems.forEach((itm)=>{
            if (itm.type === "product") selectableItems.push(itm.id || itm.appId || itm.label);
        });
        let isHighlighted = false;
        let isSelected = false;
        // Check if current item is highlighted
        if (item.type === "client" || item.type === "product") {
            const itemId = item.type === "client" ? item.id : item.id || item.appId;
            const navIndex = selectableItems.indexOf(itemId || item.label);
            isHighlighted = highlightedIndex === navIndex;
            // Use activeClientObj.id to determine selection for consistency
            if (item.type === "client") isSelected = item.id === (activeClientObj === null || activeClientObj === void 0 ? void 0 : activeClientObj.id);
        }
        if (item.type === "header" && item.label === "Clients") return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
        if (item.type === "header") return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: "header-" + item.label,
            className: $2ad24e75a96deccc$var$styles["client-picker__section-header"]
        }, item.label);
        if (item.type === "separator") return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: "separator-" + index,
            className: $2ad24e75a96deccc$var$styles["client-picker__section-separator"]
        });
        // Render client preview after the first client but before the first separator
        if (item.type === "client") {
            // Check if this is the first client in the combinedItems
            const firstClientIndex = combinedItems.findIndex((item)=>item.type === "client");
            const isFirstClient = index === firstClientIndex;
            const mainClientsCount = sortedClients.length === 2 ? 2 : MAIN_CLIENTS_DISPLAY_COUNT;
            const clientPreview = sortedClients.length > mainClientsCount ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                key: "client-preview",
                className: $2ad24e75a96deccc$var$styles["client-picker__client-preview-container"]
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: $2ad24e75a96deccc$var$styles["client-picker__client-preview"]
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: `${$2ad24e75a96deccc$var$styles["client-picker__preview-trigger"]} ${(()=>{
                    const selectableItems = [];
                    // Add main clients first
                    combinedItems.forEach((itm)=>{
                        if (itm.type === "client") selectableItems.push(itm.label);
                    });
                    // Preview toggle comes right after main clients
                    const previewToggleIndex = selectableItems.length;
                    return highlightedIndex === previewToggleIndex ? $2ad24e75a96deccc$var$styles["client-picker__preview-trigger--highlighted"] : "";
                })()}`,
                "data-selectable": "true",
                onClick: (e)=>{
                    e.stopPropagation();
                    setIsClientPreviewExpanded(!isClientPreviewExpanded);
                }
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: $2ad24e75a96deccc$var$styles["client-picker__preview-icon"]
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
                icon: (0, $c761e69c8e58189a$exports.agent),
                className: $2ad24e75a96deccc$var$styles["client-picker__preview-user-icon"]
            })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: $2ad24e75a96deccc$var$styles["client-picker__preview-label"]
            }, (()=>{
                const mainClientsCount = sortedClients.length === 2 ? 2 : MAIN_CLIENTS_DISPLAY_COUNT;
                const overflowCount = sortedClients.length - mainClientsCount;
                return overflowCount === 1 ? uiText.moreClientsSingular : `${overflowCount} ${uiText.moreClientsPlural}`;
            })()), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
                icon: (0, $c761e69c8e58189a$exports.chevron_small_down),
                className: `${$2ad24e75a96deccc$var$styles["client-picker__preview-chevron"]} ${isClientPreviewExpanded ? $2ad24e75a96deccc$var$styles["client-picker__preview-chevron--expanded"] : ""}`
            })), isClientPreviewExpanded && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: $2ad24e75a96deccc$var$styles["client-picker__expanded-clients"]
            }, (()=>{
                const mainClientsCount = sortedClients.length === 2 ? 2 : MAIN_CLIENTS_DISPLAY_COUNT;
                return sortedClients.slice(mainClientsCount);
            })().map((client, clientIndex)=>{
                const isClientSelected = client.id === (activeClientObj === null || activeClientObj === void 0 ? void 0 : activeClientObj.id);
                // Calculate highlight index for overflow client
                const selectableItems = [];
                // Add main clients first
                combinedItems.forEach((itm)=>{
                    if (itm.type === "client") selectableItems.push(itm.label);
                });
                // Add preview toggle
                selectableItems.push("__PREVIEW_TOGGLE__");
                // Overflow client index comes after preview toggle
                const overflowIndex = selectableItems.length + clientIndex;
                const isOverflowHighlighted = highlightedIndex === overflowIndex;
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    key: `expanded-${client.label}`,
                    className: `${$2ad24e75a96deccc$var$styles["client-picker__expanded-client-item"]} ${isClientSelected ? $2ad24e75a96deccc$var$styles["client-picker__expanded-client-item--selected"] : ""} ${isOverflowHighlighted ? $2ad24e75a96deccc$var$styles["client-picker__expanded-client-item--highlighted"] : ""}`,
                    "data-selectable": "true",
                    onClick: (e)=>$2ad24e75a96deccc$var$__awaiter(void 0, void 0, void 0, function*() {
                            e.stopPropagation();
                            setIsClientPreviewExpanded(false);
                            yield handleClientClick(client);
                        })
                }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: $2ad24e75a96deccc$var$styles["client-picker__client-menu-item"]
                }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: $2ad24e75a96deccc$var$styles["client-picker__client-text"]
                }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    className: $2ad24e75a96deccc$var$styles["client-picker__item-label"]
                }, client.label), client.clientType && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    className: $2ad24e75a96deccc$var$styles["client-picker__description"]
                }, client.clientType)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                    className: $2ad24e75a96deccc$var$styles["client-picker__client-right"]
                }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                    className: $2ad24e75a96deccc$var$styles["client-picker__switch-link"]
                }, uiText.switch))));
            })))) : null;
            // Return both the client item and the preview (if applicable)
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                key: `client-and-preview-${index}`
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                className: `${$2ad24e75a96deccc$var$styles["client-picker__dropdown-item"]}${isHighlighted ? ` ${$2ad24e75a96deccc$var$styles["client-picker__dropdown-item--highlighted"]}` : ""}${isSelected ? ` ${$2ad24e75a96deccc$var$styles["client-picker__dropdown-item--selected-client"]}` : ""}`,
                "data-selectable": "true",
                role: "menuitem",
                "aria-label": `Switch to client: ${item.label}${item.clientType ? `, ${item.clientType}` : ""}`,
                onClick: ()=>{
                    // Use the mapped client's onClick for correct launch logic
                    const client = clients.find((c)=>c.id === item.id);
                    if (client && typeof client.onClick === "function") client.onClick();
                    else handleSelect(index, item.id || (client === null || client === void 0 ? void 0 : client.id) || "", item.label);
                }
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: $2ad24e75a96deccc$var$styles["client-picker__client-menu-item"]
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: $2ad24e75a96deccc$var$styles["client-picker__client-text"]
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: $2ad24e75a96deccc$var$styles["client-picker__item-label"]
            }, item.label), item.clientType && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: $2ad24e75a96deccc$var$styles["client-picker__description"]
            }, item.clientType)), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: $2ad24e75a96deccc$var$styles["client-picker__client-right"]
            }, isSelected ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: $2ad24e75a96deccc$var$styles["client-picker__checkmark"]
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
                icon: (0, $c761e69c8e58189a$exports.checkmark)
            })) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: $2ad24e75a96deccc$var$styles["client-picker__switch-link"]
            }, uiText.switch)))), isFirstClient && clientPreview);
        }
        if (item.type === "product") {
            const productItem = item;
            // For XBM, only show badge if count > 1, for others show if count >= 1
            const isLegacyApp = productItem.appId === "xbm" ? productItem.count && productItem.count > 1 : productItem.count && productItem.count >= 1;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
                key: productItem.label,
                className: `${$2ad24e75a96deccc$var$styles["client-picker__dropdown-item"]}${isHighlighted ? ` ${$2ad24e75a96deccc$var$styles["client-picker__dropdown-item--highlighted"]}` : ""}`,
                "data-selectable": "true",
                role: "menuitem",
                "aria-label": `${productItem.label}${isLegacyApp ? ` - ${productItem.count} instances available` : ""}`,
                "aria-haspopup": isLegacyApp ? "menu" : undefined,
                "aria-expanded": isLegacyApp && expandedLegacyApp === productItem.appId ? "true" : undefined,
                onClick: (e)=>{
                    handleSelect(index, productItem.id || productItem.appId || "", productItem.label);
                }
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: $2ad24e75a96deccc$var$styles["client-picker__app-menu-item"]
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("img", {
                src: productItem.iconUrl,
                alt: productItem.label,
                className: $2ad24e75a96deccc$var$styles["client-picker__app-icon"],
                onError: (e)=>{
                    const target = e.target;
                    target.src = "https://assets.lwolf.com/lwt-helix/icons/latest/outlined/wolfie.svg";
                }
            }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                className: $2ad24e75a96deccc$var$styles["client-picker__app-text"],
                style: {
                    flex: 1
                }
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: $2ad24e75a96deccc$var$styles["client-picker__item-label"]
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: `${$2ad24e75a96deccc$var$styles["client-picker__label-name"]} ${!productItem.description ? $2ad24e75a96deccc$var$styles["client-picker__label-name--centered"] : ""}`
            }, productItem.label), productItem.tooltip && productItem.tooltip.trim() && (clients.length > 1 || productItem.alwaysShowTooltip) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($2ad24e75a96deccc$var$CustomTooltip, {
                content: productItem.tooltip
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: $2ad24e75a96deccc$var$styles["client-picker__info-icon"]
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
                icon: (0, $c761e69c8e58189a$exports.circle_info)
            })))), productItem.description && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: $2ad24e75a96deccc$var$styles["client-picker__description"]
            }, productItem.description), isLegacyApp && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
                className: "helix-badge helix-badge--inverted helix-badge--tiny",
                style: {
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    marginTop: "4px",
                    width: "fit-content",
                    cursor: "pointer"
                },
                "aria-label": `Show ${productItem.count} instances of ${productItem.label}`,
                onClick: (e)=>{
                    var _a;
                    e.preventDefault();
                    e.stopPropagation();
                    if (((_a = productItem.instances) === null || _a === void 0 ? void 0 : _a.length) === 1) {
                        // If only one instance, click the main li
                        const instance = productItem.instances[0];
                        const legacyApp = personalApps.find((app)=>app.appId === productItem.appId);
                        const connection = legacyApp && appConnections.find((conn)=>conn.appId === productItem.appId && (conn.name === instance || conn.clientId === instance)) || null;
                        if (connection) {
                            const url = $2ad24e75a96deccc$var$buildProductLaunchUrl(environment || "dev", connection);
                            window.open(url, "_self");
                            originalHandleToggle();
                        }
                        return;
                    }
                    if (productItem.instances) handleLegacyAppClick(productItem.appId, productItem.instances, e);
                },
                onKeyDown: (e)=>{
                    if (e.key === "Enter" || e.key === " ") {
                        e.preventDefault();
                        e.stopPropagation();
                        if (productItem.instances) {
                            // Synthesize a MouseEvent for compatibility
                            const mouseEvent = Object.assign(Object.assign({}, e), {
                                preventDefault: e.preventDefault.bind(e),
                                stopPropagation: e.stopPropagation.bind(e)
                            });
                            handleLegacyAppClick(productItem.appId, productItem.instances, mouseEvent);
                        }
                    }
                }
            }, ((_a = productItem.instances) === null || _a === void 0 ? void 0 : _a[0]) || productItem.count, productItem.count && productItem.count > 1 && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
                icon: (0, $c761e69c8e58189a$exports.chevron_small_down),
                style: {
                    width: "12px",
                    height: "12px"
                }
            })))));
        }
        return null;
    }))), document.body), expandedLegacyApp && (0, $1u0KT.createPortal)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: `${$2ad24e75a96deccc$var$styles["client-picker__dropdown-menu"]} ${$2ad24e75a96deccc$var$styles.open} client-picker__legacy-instance`,
        role: "menu",
        "aria-label": `${(_m = personalApps.find((app)=>app.appId === expandedLegacyApp)) === null || _m === void 0 ? void 0 : _m.label} instances`,
        style: {
            position: "fixed",
            top: `${legacyAppSubmenuPosition.top}px`,
            left: `${legacyAppSubmenuPosition.left}px`,
            zIndex: 1001,
            minWidth: "200px"
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("ul", null, (_p = (_o = personalApps.find((app)=>app.appId === expandedLegacyApp)) === null || _o === void 0 ? void 0 : _o.instances) === null || _p === void 0 ? void 0 : _p.map((instance, index)=>{
        // Find the connection for this legacy app and client
        const legacyApp = personalApps.find((app)=>app.appId === expandedLegacyApp);
        const connection = legacyApp && appConnections.find((conn)=>conn.appId === expandedLegacyApp && (conn.name === instance || conn.clientId === instance)) || null;
        const url = connection ? $2ad24e75a96deccc$var$buildProductLaunchUrl(environment || "dev", connection) : "#";
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("li", {
            key: `${expandedLegacyApp}-${index}`,
            className: `${$2ad24e75a96deccc$var$styles["client-picker__dropdown-item"]} ${submenuHighlightedIndex === index ? $2ad24e75a96deccc$var$styles["client-picker__dropdown-item--highlighted"] : ""}`,
            role: "menuitem"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("a", {
            href: url,
            className: $2ad24e75a96deccc$var$styles["client-picker__app-menu-item"],
            "aria-label": `Open ${instance} instance`,
            onClick: (e)=>{
                e.preventDefault();
                if (connection) {
                    window.open(url, "_self");
                    originalHandleToggle();
                    setExpandedLegacyApp(null);
                    setSubmenuHighlightedIndex(0);
                }
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
            className: $2ad24e75a96deccc$var$styles["client-picker__app-text"]
        }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            className: $2ad24e75a96deccc$var$styles["client-picker__item-label"]
        }, instance))));
    }))), document.body), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        role: "status",
        "aria-live": "assertive",
        "aria-atomic": "true",
        className: "sr-only",
        style: {
            position: "absolute",
            left: "-10000px",
            width: "1px",
            height: "1px",
            padding: "0",
            margin: "0",
            overflow: "hidden",
            clipPath: "inset(50%)",
            whiteSpace: "nowrap",
            border: "0"
        }
    }, announceText), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        "aria-live": "polite",
        "aria-atomic": "false",
        className: "sr-only",
        style: {
            position: "absolute",
            left: "-10000px",
            width: "1px",
            height: "1px",
            padding: "0",
            margin: "0",
            overflow: "hidden",
            clipPath: "inset(50%)",
            whiteSpace: "nowrap",
            border: "0"
        }
    }, isOpen && `Client picker menu with ${combinedItems.filter((item)=>item.type === "client" || item.type === "product").length} items`));
};
$2ad24e75a96deccc$export$b9df65f7f957b5de.displayName = "ClientSwitcher";



var $90ISC = parcelRequire("90ISC");

var $7AubO = parcelRequire("7AubO");

var $cghEn = parcelRequire("cghEn");

var $dI25G = parcelRequire("dI25G");

var $eOjgM = parcelRequire("eOjgM");

var $f6CJ4 = parcelRequire("f6CJ4");

var $dDBOF = parcelRequire("dDBOF");

var $dDBOF = parcelRequire("dDBOF");
const $1db408ae6f3392f7$export$cbeeb6000269f21c = Object.freeze({
    [(0, $dDBOF.appNames).XAM]: {
        headerLabel: (0, $dDBOF.appLabels)[(0, $dDBOF.appNames).XAM]
    },
    [(0, $dDBOF.appNames).XBM]: {
        headerLabel: (0, $dDBOF.appLabels)[(0, $dDBOF.appNames).XBM]
    }
});



var $7D4kr = parcelRequire("7D4kr");

var $70q5f = parcelRequire("70q5f");

var $cstaF = parcelRequire("cstaF");

var $7D4kr = parcelRequire("7D4kr");

var $g7mFm = parcelRequire("g7mFm");

var $cstaF = parcelRequire("cstaF");

var $cL3O2 = parcelRequire("cL3O2");

var $bLQRh = parcelRequire("bLQRh");

var $1PiL9 = parcelRequire("1PiL9");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $eOjgM = parcelRequire("eOjgM");

var $dI25G = parcelRequire("dI25G");

var $htzEo = parcelRequire("htzEo");

var $bLQRh = parcelRequire("bLQRh");
const $bba15588af6043b8$var$iconProps = (icon, iconName)=>{
    return {
        icon: icon,
        title: `${iconName} icon`,
        className: "align-middle"
    };
};
const $bba15588af6043b8$var$icons = {
    increase: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
        ...$bba15588af6043b8$var$iconProps((0, $eOjgM.caret_up), "up")
    }),
    decrease: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
        ...$bba15588af6043b8$var$iconProps((0, $eOjgM.caret_down), "down")
    })
};
const $bba15588af6043b8$var$getCellStyling = (value)=>{
    if (!isFinite(value)) return {
        className: null,
        icon: null
    };
    if (value > 0) return {
        className: "ag-cell-increase-value",
        icon: $bba15588af6043b8$var$icons.increase
    };
    if (value < 0) return {
        className: "ag-cell-decrease-value",
        icon: $bba15588af6043b8$var$icons.decrease
    };
    return {
        className: null,
        icon: null
    };
};
const $bba15588af6043b8$var$getCellWithIcon = (value, format)=>{
    if (!value) return null;
    const getValue = format === (0, $bLQRh.terms).custom ? value.data : value;
    const getFormatter = format === (0, $bLQRh.terms).custom ? value.formatter : format;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
        className: $bba15588af6043b8$var$getCellStyling(getValue).className,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                children: getFormatter(getValue)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                children: $bba15588af6043b8$var$getCellStyling(getValue).icon
            })
        ]
    });
};
const $bba15588af6043b8$export$cc0e79d2a41dc68a = {
    percentage: (props)=>$bba15588af6043b8$var$getCellWithIcon(props.value, (0, $htzEo.formatOneDecimalPercentageWithMultiplier)),
    custom: (props)=>$bba15588af6043b8$var$getCellWithIcon(props.value, (0, $bLQRh.terms).custom),
    status: (props)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
            className: "d-flex align-items-center",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "status-ellipse mr-2",
                    style: {
                        background: `${props.data.color}`
                    }
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    children: props.value
                })
            ]
        });
    }
};
const $bba15588af6043b8$export$cba1bf9c04305cea = {
    columnDefault: {
        cellClass: "ag-cell-general-key-info",
        headerClass: "ag-cell-key-info-header font-weight-bold",
        suppressHeaderMenuButton: true,
        minWidth: 200,
        flex: 1
    },
    columnNumber: {
        headerClass: "ag-cell-key-info-header align-top no-wrap header-number",
        cellClass: "ag-cell-general-key-info text-right",
        suppressHeaderMenuButton: true,
        minWidth: 200,
        flex: 1
    }
};


const $03d403fa8ed96844$export$c0f6db12d479e12e = Object.freeze({
    [(0, $1PiL9.marketDynamicsColumns).status.id]: {
        field: (0, $1PiL9.marketDynamicsColumns).status.id,
        headerName: (0, $1PiL9.marketDynamicsColumns).status.label,
        ...(0, $bba15588af6043b8$export$cba1bf9c04305cea).columnDefault,
        cellRenderer: (0, $bba15588af6043b8$export$cc0e79d2a41dc68a).status
    },
    [(0, $1PiL9.marketDynamicsColumns).beginPeriod.id]: {
        field: (0, $1PiL9.marketDynamicsColumns).beginPeriod.field,
        ...(0, $bba15588af6043b8$export$cba1bf9c04305cea).columnNumber
    },
    [(0, $1PiL9.marketDynamicsColumns).endPeriod.id]: {
        field: (0, $1PiL9.marketDynamicsColumns).endPeriod.field,
        ...(0, $bba15588af6043b8$export$cba1bf9c04305cea).columnNumber
    },
    [(0, $1PiL9.marketDynamicsColumns).periodChange.id]: {
        field: (0, $1PiL9.marketDynamicsColumns).periodChange.id,
        headerName: (0, $1PiL9.marketDynamicsColumns).periodChange.label,
        ...(0, $bba15588af6043b8$export$cba1bf9c04305cea).columnNumber
    },
    [(0, $1PiL9.marketDynamicsColumns).periodPercentChange.id]: {
        field: (0, $1PiL9.marketDynamicsColumns).periodPercentChange.id,
        headerName: (0, $1PiL9.marketDynamicsColumns).periodPercentChange.label,
        ...(0, $bba15588af6043b8$export$cba1bf9c04305cea).columnNumber,
        cellRenderer: (0, $bba15588af6043b8$export$cc0e79d2a41dc68a).percentage
    },
    [(0, $1PiL9.marketDynamicsColumns).totalChange.id]: {
        field: (0, $1PiL9.marketDynamicsColumns).totalChange.id,
        headerName: (0, $1PiL9.marketDynamicsColumns).totalChange.label,
        ...(0, $bba15588af6043b8$export$cba1bf9c04305cea).columnNumber
    },
    [(0, $1PiL9.marketDynamicsColumns).totalPercentChange.id]: {
        field: (0, $1PiL9.marketDynamicsColumns).totalPercentChange.id,
        headerName: (0, $1PiL9.marketDynamicsColumns).totalPercentChange.label,
        ...(0, $bba15588af6043b8$export$cba1bf9c04305cea).columnNumber,
        cellRenderer: (0, $bba15588af6043b8$export$cc0e79d2a41dc68a).percentage
    },
    [(0, $1PiL9.marketDynamicsColumns).changeValue.id]: {
        field: (0, $1PiL9.marketDynamicsColumns).changeValue.id,
        headerName: (0, $1PiL9.marketDynamicsColumns).changeValue.label,
        ...(0, $bba15588af6043b8$export$cba1bf9c04305cea).columnNumber,
        cellRenderer: (0, $bba15588af6043b8$export$cc0e79d2a41dc68a).custom
    },
    [(0, $1PiL9.marketDynamicsColumns).changeValuePercentage.id]: {
        field: (0, $1PiL9.marketDynamicsColumns).changeValuePercentage.id,
        headerName: (0, $1PiL9.marketDynamicsColumns).changeValuePercentage.label,
        ...(0, $bba15588af6043b8$export$cba1bf9c04305cea).columnNumber,
        cellRenderer: (0, $bba15588af6043b8$export$cc0e79d2a41dc68a).percentage
    },
    [(0, $1PiL9.marketDynamicsColumns).previousWeeksAvg.id]: {
        field: (0, $1PiL9.marketDynamicsColumns).previousWeeksAvg.id,
        headerName: (0, $1PiL9.marketDynamicsColumns).previousWeeksAvg.label,
        ...(0, $bba15588af6043b8$export$cba1bf9c04305cea).columnNumber
    },
    [(0, $1PiL9.marketDynamicsColumns).lastWeeksAvg.id]: {
        field: (0, $1PiL9.marketDynamicsColumns).lastWeeksAvg.id,
        headerName: (0, $1PiL9.marketDynamicsColumns).lastWeeksAvg.label,
        ...(0, $bba15588af6043b8$export$cba1bf9c04305cea).columnNumber
    },
    [(0, $1PiL9.marketDynamicsColumns).changeAvg.id]: {
        field: (0, $1PiL9.marketDynamicsColumns).changeAvg.id,
        headerName: (0, $1PiL9.marketDynamicsColumns).changeAvg.label,
        ...(0, $bba15588af6043b8$export$cba1bf9c04305cea).columnNumber,
        cellRenderer: (0, $bba15588af6043b8$export$cc0e79d2a41dc68a).custom
    },
    [(0, $1PiL9.marketDynamicsColumns).changeAvgPercentage.id]: {
        field: (0, $1PiL9.marketDynamicsColumns).changeAvgPercentage.id,
        headerName: (0, $1PiL9.marketDynamicsColumns).changeAvgPercentage.label,
        ...(0, $bba15588af6043b8$export$cba1bf9c04305cea).columnNumber,
        cellRenderer: (0, $bba15588af6043b8$export$cc0e79d2a41dc68a).percentage
    }
});



var $6IhJz = parcelRequire("6IhJz");
var $4UeRq = parcelRequire("4UeRq");
var $knAHj = parcelRequire("knAHj");

var $htzEo = parcelRequire("htzEo");

var $bLQRh = parcelRequire("bLQRh");

var $4fYAk = parcelRequire("4fYAk");

var $4VY3C = parcelRequire("4VY3C");

var $cstaF = parcelRequire("cstaF");

var $2DB2D = parcelRequire("2DB2D");

var $bmWW5 = parcelRequire("bmWW5");
const $f04533a6b7242ef6$var$STACKED_BAR_WIDTH = 2;
const $f04533a6b7242ef6$export$d1e5b04bb29aee87 = (checkedStatusOptions, data)=>{
    const radioRemoved = checkedStatusOptions.filter((x)=>!x.isRadio);
    return radioRemoved.map(({ keyField: keyField })=>({
            data: data?.map((item)=>item[keyField] ?? 0) ?? []
        }));
};
const $f04533a6b7242ef6$export$dd620a434769eadb = (data)=>data?.map((item, index)=>{
        const date = new Date(item.timePeriodStart);
        const month = (0, $6IhJz.default)(date, "MM");
        const shouldRenderYear = index === 0 || index === data.length - 1 || month === "01";
        return item && (0, $htzEo.getMonthlyFormatted)(date, shouldRenderYear);
    }) ?? [];
const $f04533a6b7242ef6$export$e602ca0a77aa6266 = (data)=>data?.map((item, index)=>item && (0, $htzEo.getQuarterFormatted)(item.timePeriodStart, $f04533a6b7242ef6$export$4c1aa2b3929c8c18(index, data) ? (0, $htzEo.formattedQuarterWithYear) : (0, $htzEo.quarterNumber))) ?? [];
const $f04533a6b7242ef6$export$60212ba4e96057c9 = (date)=>({
        dayOfMonth: (0, $htzEo.getTwoDigitDayOfMonth)(date),
        month: (0, $4UeRq.default)(date),
        year: (0, $knAHj.default)(date),
        formattedMonth: (0, $6IhJz.default)(date, "MMM"),
        formattedYear: (0, $6IhJz.default)(date, "yy")
    });
const $f04533a6b7242ef6$export$4c1aa2b3929c8c18 = (index, data)=>index === 0 || index === data.length - 1;
const $f04533a6b7242ef6$export$a74c6b1d7748b62b = (data)=>data?.map((item, index)=>{
        const prevDate = index !== 0 && new Date(data[index - 1].timePeriodStart);
        const date = new Date(item.timePeriodStart);
        const isFirstOrLastItem = $f04533a6b7242ef6$export$4c1aa2b3929c8c18(index, data);
        const dateObject = $f04533a6b7242ef6$export$60212ba4e96057c9(date);
        const { month: prevMonth, year: prevYear } = prevDate && $f04533a6b7242ef6$export$60212ba4e96057c9(prevDate);
        const hasChangedMonth = dateObject.month !== prevMonth;
        const hasChangedYear = dateObject.year !== prevYear;
        const shouldShowYear = hasChangedYear || isFirstOrLastItem;
        if (isFirstOrLastItem || hasChangedMonth) return (0, $htzEo.formattedWeekWithMonthAndYear)(dateObject, shouldShowYear);
        return item && (0, $htzEo.getWeeklyFormatted)(date);
    }) ?? [];
const $f04533a6b7242ef6$export$c5345ac482c7c12d = (dataPointIndex, seriesIndex, w, selectedPeriodComparison, selectedBeginIndex, selectedEndIndex, intervalType, isOverview, timePeriod)=>{
    const is6MonthsSearch = (0, $cstaF.marketDynamicsTimePeriods)[(0, $cstaF.marketDynamicsTerms).months6Weekly] === timePeriod;
    if (isOverview || is6MonthsSearch) return (0, $bLQRh.marketDynamicsColors).bars[seriesIndex];
    const data = w.config.series[0].data;
    if (intervalType === (0, $bLQRh.terms).weekOf) {
        if ($f04533a6b7242ef6$export$4c1aa2b3929c8c18(dataPointIndex, data)) return (0, $bLQRh.marketDynamicsColors).bars[seriesIndex];
        return (0, $bLQRh.marketDynamicsColors).barsTransparency[seriesIndex];
    }
    if (selectedPeriodComparison === (0, $bLQRh.periodKeys).wholeTimePeriod) {
        if (dataPointIndex >= selectedBeginIndex && dataPointIndex <= selectedEndIndex) return (0, $bLQRh.marketDynamicsColors).bars[seriesIndex];
        return (0, $bLQRh.marketDynamicsColors).barsTransparency[seriesIndex];
    }
    if (dataPointIndex === selectedBeginIndex || dataPointIndex === selectedEndIndex) return (0, $bLQRh.marketDynamicsColors).bars[seriesIndex];
    return (0, $bLQRh.marketDynamicsColors).barsTransparency[seriesIndex];
};
const $f04533a6b7242ef6$export$55382f732810ce34 = ({ barCount: barCount, chartRowCount: chartRowCount, isStacked: isStacked })=>{
    if (isStacked) return (0, $htzEo.formatPercent)(chartRowCount * $f04533a6b7242ef6$var$STACKED_BAR_WIDTH);
    return (0, $htzEo.formatPercent)(chartRowCount * barCount);
};
const $f04533a6b7242ef6$export$14e49c3a0d832ed8 = (handleBarClick)=>(config)=>{
        handleBarClick(config.dataPointIndex);
    };
const $f04533a6b7242ef6$export$ab850d5420cc66e4 = (dataPointMouseOverStyler)=>(event, chartContext, config)=>{
        dataPointMouseOverStyler(event, chartContext, config);
    };
const $f04533a6b7242ef6$export$8c54458430be6d1d = ({ checkedStatusOptionsLength: checkedStatusOptionsLength, dataLength: dataLength, getBarWidth: getBarWidth, isStacked: isStacked })=>{
    return getBarWidth({
        barCount: checkedStatusOptionsLength,
        chartRowCount: dataLength,
        isStacked: isStacked
    });
};
const $f04533a6b7242ef6$export$7a0f33e8df10bd94 = ({ config: config, data: data })=>config?.groupConfig?.chart?.xaxis?.categories(data) ?? [];
const $f04533a6b7242ef6$export$226f10599a2e6ac8 = ({ getBeginVsEndMonthColors: getBeginVsEndMonthColors, highHexColor: highHexColor, intervalType: intervalType, isOverview: isOverview, lowHexColor: lowHexColor, selectedBeginIndex: selectedBeginIndex, selectedEndIndex: selectedEndIndex, selectedPeriodComparison: selectedPeriodComparison, threshold: threshold, overviewStatus: overviewStatus, timePeriod: timePeriod })=>{
    if (isOverview && overviewStatus.currentTab === (0, $4fYAk.tabIndex).inventory) return [
        ({ value: value })=>value < threshold ? lowHexColor : highHexColor
    ];
    return [
        ({ dataPointIndex: dataPointIndex, seriesIndex: seriesIndex, w: w })=>getBeginVsEndMonthColors(dataPointIndex, seriesIndex, w, selectedPeriodComparison, selectedBeginIndex, selectedEndIndex, intervalType, isOverview, timePeriod)
    ];
};
const $f04533a6b7242ef6$export$400ba1fb68260b90 = ({ config: config, data: data, getChartTooltipContent: getChartTooltipContent, marketDynamicsColors: marketDynamicsColors })=>({ series: series, dataPointIndex: dataPointIndex })=>getChartTooltipContent(data, series, dataPointIndex, marketDynamicsColors.bars, config);
const $f04533a6b7242ef6$export$d2312e68e1f5ad00 = ({ chartLabelStyles: chartLabelStyles, checkedStatusOptions: checkedStatusOptions, config: config, data: data, dataPointMouseOverStyler: dataPointMouseOverStyler, fontFamily: fontFamily, getBeginVsEndMonthColors: getBeginVsEndMonthColors, getChartTooltipContent: getChartTooltipContent, handleBarClick: handleBarClick, handleDataPointMouseEnter: handleDataPointMouseEnter, handleDataPointSelection: handleDataPointSelection, highHexColor: highHexColor, intervalType: intervalType, isOverview: isOverview, isStacked: isStacked, lowHexColor: lowHexColor, overviewStatus: overviewStatus, selectedBeginIndex: selectedBeginIndex, selectedEndIndex: selectedEndIndex, selectedPeriodComparison: selectedPeriodComparison, threshold: threshold, xAxisLegends: xAxisLegends, auxHexColor: auxHexColor, isPDFChart: isPDFChart, timePeriod: timePeriod })=>({
        chart: {
            animations: {
                enabled: !isPDFChart
            },
            borderRadiusWhenStacked: "last",
            fontFamily: fontFamily,
            toolbar: {
                show: false
            },
            stacked: isStacked,
            events: {
                dataPointSelection: (event, chartContext, config)=>handleDataPointSelection(handleBarClick)(config),
                dataPointMouseEnter: handleDataPointMouseEnter(dataPointMouseOverStyler)
            }
        },
        dataLabels: {
            enabled: false
        },
        plotOptions: {
            bar: {
                horizontal: false,
                borderRaidusApplication: "end",
                borderRadius: 3,
                columnWidth: $f04533a6b7242ef6$export$8c54458430be6d1d({
                    checkedStatusOptionsLength: checkedStatusOptions?.length,
                    dataLength: data?.length ?? [],
                    getBarWidth: $f04533a6b7242ef6$export$55382f732810ce34,
                    isStacked: isStacked
                })
            }
        },
        xaxis: {
            categories: $f04533a6b7242ef6$export$7a0f33e8df10bd94({
                config: config,
                data: data
            }),
            labels: {
                style: isPDFChart ? (0, $bmWW5.pdfChartLabelStyles) : chartLabelStyles
            }
        },
        yaxis: {
            ...config?.listingConfig?.chart?.yAxis,
            labels: {
                ...config?.listingConfig?.chart?.yAxis?.labels,
                style: isPDFChart ? (0, $bmWW5.pdfChartLabelStyles) : chartLabelStyles
            },
            title: {
                ...config?.listingConfig?.chart?.yAxis?.title,
                style: isPDFChart ? (0, $bmWW5.pdfChartTitleStyles) : ""
            }
        },
        fill: {
            colors: $f04533a6b7242ef6$export$226f10599a2e6ac8({
                isOverview: isOverview,
                threshold: threshold,
                lowHexColor: lowHexColor,
                highHexColor: highHexColor,
                getBeginVsEndMonthColors: getBeginVsEndMonthColors,
                overviewStatus: overviewStatus,
                selectedPeriodComparison: selectedPeriodComparison,
                selectedBeginIndex: selectedBeginIndex,
                selectedEndIndex: selectedEndIndex,
                intervalType: intervalType,
                timePeriod: timePeriod
            })
        },
        legend: {
            show: isOverview,
            inverseOrder: false,
            customLegendItems: xAxisLegends || [],
            markers: {
                fillColors: [
                    lowHexColor,
                    highHexColor,
                    ...overviewStatus.currentTab !== (0, $4fYAk.tabIndex).inventory ? [
                        auxHexColor
                    ] : []
                ],
                width: 15,
                height: 15,
                radius: 10
            },
            fontFamily: fontFamily,
            itemMargin: {
                horizontal: 10
            },
            onItemClick: {
                toggleDataSeries: false
            },
            position: "bottom",
            horizontalAlign: "center",
            showForSingleSeries: true,
            labels: {
                colors: "#4B5563"
            },
            ...isPDFChart ? {
                fontSize: "16px"
            } : {}
        },
        stroke: {
            colors: [
                "transparent"
            ],
            width: 5
        },
        tooltip: {
            custom: $f04533a6b7242ef6$export$400ba1fb68260b90({
                data: data,
                marketDynamicsColors: $bLQRh.marketDynamicsColors,
                config: config,
                getChartTooltipContent: getChartTooltipContent
            })
        },
        grid: {
            yaxis: {
                lines: {
                    show: false
                }
            }
        }
    });
const $f04533a6b7242ef6$export$67934fe35b0cb3b0 = (text, keyFactor)=>{
    const firefoxGap = (navigator?.userAgent?.toLowerCase()?.includes("firefox") ? 1.18 : 1) * keyFactor;
    // Hack: values in the regexps contains english so they are not localized.
    const patterns = [
        {
            regex: /^\$\d{3}\.\d[kMB]/,
            multiplier: 4.8
        },
        {
            regex: /^\$\d{2}\.\d[kMB]/,
            multiplier: 5.5
        },
        {
            regex: /^\$\d{1}\.\d[kMB]/,
            multiplier: 5.5
        },
        {
            regex: /^\$\d{3}[kMB]/,
            multiplier: 5.5
        },
        {
            regex: /^\$\d{2}[kMB]/,
            multiplier: 5.5
        },
        {
            regex: /\$\d{3} /,
            multiplier: 6.2
        },
        {
            regex: /\$\d{2} /,
            multiplier: 6
        },
        {
            regex: /^\d{2}\.\d\%/,
            multiplier: 5.3
        },
        {
            regex: /^\d{3}\.\d\%/,
            multiplier: 4.9
        },
        {
            regex: /^\d{3}\.\d{1} $/,
            multiplier: 5
        },
        {
            regex: /^\d{2}\.\d{1} $/,
            multiplier: 5.2
        },
        {
            regex: /^\d{1}\.\d{1} $/,
            multiplier: 5.7
        },
        {
            regex: /^\d{3},\d{3}\.\d /,
            multiplier: 4.4
        },
        {
            regex: /^\d{2},\d{3}\.\d /,
            multiplier: 4.5
        },
        {
            regex: /^\d{1},\d{3}\.\d /,
            multiplier: 4.5
        },
        {
            regex: /^\d{3} Days/,
            multiplier: 5
        },
        {
            regex: /^\d{2} Days/,
            multiplier: 4.9
        },
        {
            regex: /^\d{1} Days/,
            multiplier: 5.4
        },
        {
            regex: /^\d{2}\.\d Months/,
            multiplier: 4.4
        },
        {
            regex: /^\d{1}\.\d Months/,
            multiplier: 4.5
        }
    ];
    for (const { regex: regex, multiplier: multiplier } of patterns){
        if (regex.test(text)) return text.padStart(text.length * multiplier * firefoxGap, " \xa0");
    }
    return text;
};
const $f04533a6b7242ef6$export$872649a079dabedf = (chartData, card, timePeriod)=>{
    const { formatter: formatter, labelUnitType: labelUnitType = "", keyField: keyField, chartFormatter: chartFormatter = formatter, chartUnitType: chartUnitType = labelUnitType, chartDataFormatter: chartDataFormatter } = card;
    const beginningPeriodData = chartData[0]?.[keyField] ?? 0;
    const endPeriodData = chartData[1]?.[keyField] ?? 0;
    const formattedBeginningPeriodData = (0, $4VY3C.default)(chartDataFormatter) ? chartDataFormatter(beginningPeriodData) : beginningPeriodData;
    const formattedEndPeriodData = (0, $4VY3C.default)(chartDataFormatter) ? chartDataFormatter(endPeriodData) : endPeriodData;
    return {
        series: [
            {
                data: [
                    formattedBeginningPeriodData,
                    formattedEndPeriodData
                ]
            }
        ],
        height: 110,
        colors: [
            (0, $bLQRh.barChartColors).first,
            (0, $bLQRh.barChartColors).second
        ],
        options: {
            grid: {
                show: false,
                yaxis: {
                    lines: {
                        show: false
                    }
                },
                xaxis: {
                    lines: {
                        show: false
                    }
                },
                padding: {
                    left: -20,
                    top: -40,
                    bottom: 0,
                    right: 100
                }
            },
            colors: [
                (0, $bLQRh.barChartColors).first,
                (0, $bLQRh.barChartColors).second
            ],
            chart: {
                height: 50,
                background: (0, $bLQRh.barChartColors).pureWhite,
                animations: {
                    enabled: false
                },
                type: "bar",
                stacked: true,
                toolbar: {
                    show: false
                },
                zoom: {
                    enabled: false
                }
            },
            responsive: [
                {
                    breakpoint: 480,
                    options: {
                        legend: {
                            position: "left",
                            offsetX: -10,
                            offsetY: 0
                        }
                    }
                }
            ],
            plotOptions: {
                bar: {
                    horizontal: true,
                    barHeight: "20%",
                    borderRadiusApplication: "end",
                    borderRadius: 3,
                    columnWidth: "30%",
                    dataLabels: {
                        position: "top"
                    },
                    distributed: true
                }
            },
            dataLabels: {
                enabled: true,
                style: {
                    colors: [
                        (0, $bLQRh.barChartColors).grayShadow
                    ]
                },
                formatter: (value)=>$f04533a6b7242ef6$export$67934fe35b0cb3b0(`${chartFormatter(value)} ${chartUnitType}`, (0, $2DB2D.cardKeyFactors)[keyField])
            },
            xaxis: {
                labels: {
                    show: false
                },
                axisBorder: {
                    show: false
                },
                axisTicks: {
                    show: false
                }
            },
            yaxis: {
                labels: {
                    show: false
                },
                axisBorder: {
                    show: false
                }
            },
            legend: {
                inverseOrder: false,
                customLegendItems: [
                    (0, $2DB2D.formatterByTimePeriod)[timePeriod]?.(chartData[0]?.timePeriodStart).toUpperCase(),
                    (0, $2DB2D.formatterByTimePeriod)[timePeriod]?.(chartData[1]?.timePeriodStart).toUpperCase()
                ],
                markers: {
                    width: 15,
                    height: 15,
                    radius: 10,
                    fillColors: [
                        (0, $bLQRh.barChartColors).first,
                        (0, $bLQRh.barChartColors).second
                    ]
                },
                itemMargin: {
                    horizontal: 10
                },
                onItemClick: {
                    toggleDataSeries: false
                },
                position: "bottom",
                horizontalAlign: "left",
                showForSingleSeries: true,
                fontSize: "12px",
                offsetY: -20,
                offsetX: -40
            },
            fill: {
                opacity: 1,
                colors: [
                    (0, $bLQRh.barChartColors).first,
                    (0, $bLQRh.barChartColors).second
                ]
            },
            states: {
                hover: {
                    filter: "none"
                }
            },
            tooltip: {
                enabled: false
            }
        }
    };
};
const $f04533a6b7242ef6$export$8e90c65715766165 = (chartData, card, timePeriod, isInventory)=>{
    const { formatter: formatter, labelUnitType: labelUnitType = "", keyField: keyField, chartFormatter: chartFormatter = formatter, chartUnitType: chartUnitType = labelUnitType, chartDataFormatter: chartDataFormatter } = card;
    const beginningPeriodData = chartData[0]?.[keyField] ?? 0;
    const endPeriodData = chartData[1]?.[keyField] ?? 0;
    const formattedBeginningPeriodData = (0, $4VY3C.default)(chartDataFormatter) ? chartDataFormatter(beginningPeriodData) : beginningPeriodData;
    const formattedEndPeriodData = (0, $4VY3C.default)(chartDataFormatter) ? chartDataFormatter(endPeriodData) : endPeriodData;
    return {
        series: [
            {
                data: [
                    formattedBeginningPeriodData,
                    formattedEndPeriodData
                ]
            }
        ],
        height: isInventory ? 350 : 110,
        colors: [
            (0, $bLQRh.barChartColors).first,
            (0, $bLQRh.barChartColors).second
        ],
        options: {
            grid: {
                show: false,
                yaxis: {
                    lines: {
                        show: false
                    }
                },
                xaxis: {
                    lines: {
                        show: false
                    }
                },
                padding: {
                    left: -20,
                    top: -40,
                    bottom: 0,
                    right: 100
                }
            },
            colors: [
                (0, $bLQRh.barChartColors).first,
                (0, $bLQRh.barChartColors).second
            ],
            chart: {
                height: 50,
                background: (0, $bLQRh.barChartColors).pureWhite,
                animations: {
                    enabled: false
                },
                type: "bar",
                stacked: true,
                toolbar: {
                    show: false
                },
                zoom: {
                    enabled: false
                }
            },
            responsive: [
                {
                    breakpoint: 480,
                    options: {
                        legend: {
                            position: "left",
                            offsetX: -10,
                            offsetY: 0
                        }
                    }
                }
            ],
            plotOptions: {
                bar: {
                    horizontal: true,
                    barHeight: isInventory ? "10%" : "20%",
                    borderRadiusApplication: "end",
                    borderRadius: 3,
                    columnWidth: "30%",
                    dataLabels: {
                        position: "top"
                    },
                    distributed: true
                }
            },
            dataLabels: {
                enabled: true,
                style: {
                    colors: [
                        (0, $bLQRh.barChartColors).grayShadow
                    ],
                    fontSize: "18px"
                },
                formatter: (value)=>$f04533a6b7242ef6$export$67934fe35b0cb3b0(`${chartFormatter(value)} ${chartUnitType}`, (0, $2DB2D.cardKeyFactors)[keyField])
            },
            xaxis: {
                labels: {
                    show: false
                },
                axisBorder: {
                    show: false
                },
                axisTicks: {
                    show: false
                }
            },
            yaxis: {
                labels: {
                    show: false
                },
                axisBorder: {
                    show: false
                }
            },
            legend: {
                inverseOrder: false,
                customLegendItems: [
                    (0, $2DB2D.formatterByTimePeriod)[timePeriod]?.(chartData[0]?.timePeriodStart).toUpperCase(),
                    (0, $2DB2D.formatterByTimePeriod)[timePeriod]?.(chartData[1]?.timePeriodStart).toUpperCase()
                ],
                markers: {
                    width: 15,
                    height: 15,
                    radius: 10,
                    fillColors: [
                        (0, $bLQRh.barChartColors).first,
                        (0, $bLQRh.barChartColors).second
                    ]
                },
                itemMargin: {
                    horizontal: 10
                },
                onItemClick: {
                    toggleDataSeries: false
                },
                position: "bottom",
                horizontalAlign: "left",
                showForSingleSeries: true,
                fontSize: "20px",
                offsetY: -20,
                offsetX: -40
            },
            fill: {
                opacity: 1,
                colors: [
                    (0, $bLQRh.barChartColors).first,
                    (0, $bLQRh.barChartColors).second
                ]
            },
            states: {
                hover: {
                    filter: "none"
                }
            },
            tooltip: {
                enabled: false
            }
        }
    };
};



var $1PiL9 = parcelRequire("1PiL9");

var $htzEo = parcelRequire("htzEo");

var $98ROn = parcelRequire("98ROn");
const $4121db94f506a2d6$var$generalConfig = {
    chart: {
        xaxis: {
            categories: (0, $f04533a6b7242ef6$export$e602ca0a77aa6266)
        }
    },
    columnSettings: {
        label: (0, $bLQRh.terms).quarter,
        keyField: (0, $1PiL9.marketDynamicsColumns).timePeriodStart.id,
        valueFormatter: (v)=>(0, $htzEo.quarterNumYearFormat)(v.value),
        ...(0, $98ROn.colSettings).textSm
    },
    periodSelection: true,
    keyInfo: {
        beginVsEndMonth: [
            (0, $03d403fa8ed96844$export$c0f6db12d479e12e).status,
            (0, $03d403fa8ed96844$export$c0f6db12d479e12e).beginPeriod,
            (0, $03d403fa8ed96844$export$c0f6db12d479e12e).endPeriod,
            (0, $03d403fa8ed96844$export$c0f6db12d479e12e).changeValue,
            (0, $03d403fa8ed96844$export$c0f6db12d479e12e).changeValuePercentage
        ],
        wholeTimePeriod: [
            (0, $03d403fa8ed96844$export$c0f6db12d479e12e).status,
            (0, $03d403fa8ed96844$export$c0f6db12d479e12e).periodChange,
            (0, $03d403fa8ed96844$export$c0f6db12d479e12e).periodPercentChange,
            (0, $03d403fa8ed96844$export$c0f6db12d479e12e).totalChange,
            (0, $03d403fa8ed96844$export$c0f6db12d479e12e).totalPercentChange
        ]
    }
};
const $4121db94f506a2d6$export$ddfaedac8a416ec9 = [
    {
        group: (0, $bLQRh.terms).price,
        ...$4121db94f506a2d6$var$generalConfig,
        options: [
            {
                ...(0, $cL3O2.listingViews).medianPrice,
                radioButtons: [
                    "beginVsEndMonth",
                    "wholeTimePeriod"
                ]
            },
            {
                ...(0, $cL3O2.listingViews).soldAvgVsMedianPrice
            },
            (0, $cL3O2.listingViews).avgSpOpComparison,
            (0, $cL3O2.listingViews).avgSpLpComparison,
            (0, $cL3O2.listingViews).avgSpOpAllProperties,
            (0, $cL3O2.listingViews).avg$Sqft
        ]
    },
    {
        group: (0, $bLQRh.terms).supplyAmpDemand,
        ...$4121db94f506a2d6$var$generalConfig,
        options: [
            (0, $cL3O2.listingViews).supplyAmpDemandNumUnits
        ]
    },
    {
        group: (0, $bLQRh.terms).salesRate,
        ...$4121db94f506a2d6$var$generalConfig,
        options: [
            (0, $cL3O2.listingViews).avgDomCdom,
            (0, $cL3O2.listingViews).salesAbsorption
        ]
    }
];



var $cL3O2 = parcelRequire("cL3O2");

var $bLQRh = parcelRequire("bLQRh");



var $1PiL9 = parcelRequire("1PiL9");

var $htzEo = parcelRequire("htzEo");

var $98ROn = parcelRequire("98ROn");
const $c7ca41bed72364b1$var$generalConfig = {
    chart: {
        xaxis: {
            categories: (0, $f04533a6b7242ef6$export$dd620a434769eadb)
        }
    },
    columnSettings: {
        label: (0, $bLQRh.terms).month,
        keyField: (0, $1PiL9.marketDynamicsColumns).timePeriodStart.id,
        valueFormatter: (v)=>(0, $htzEo.shortMonthAndYearFormat)(v.value),
        ...(0, $98ROn.colSettings).textSm
    },
    periodSelection: true,
    keyInfo: {
        beginVsEndMonth: [
            (0, $03d403fa8ed96844$export$c0f6db12d479e12e).status,
            (0, $03d403fa8ed96844$export$c0f6db12d479e12e).beginPeriod,
            (0, $03d403fa8ed96844$export$c0f6db12d479e12e).endPeriod,
            (0, $03d403fa8ed96844$export$c0f6db12d479e12e).changeValue,
            (0, $03d403fa8ed96844$export$c0f6db12d479e12e).changeValuePercentage
        ],
        wholeTimePeriod: [
            (0, $03d403fa8ed96844$export$c0f6db12d479e12e).status,
            (0, $03d403fa8ed96844$export$c0f6db12d479e12e).periodChange,
            (0, $03d403fa8ed96844$export$c0f6db12d479e12e).periodPercentChange,
            (0, $03d403fa8ed96844$export$c0f6db12d479e12e).totalChange,
            (0, $03d403fa8ed96844$export$c0f6db12d479e12e).totalPercentChange
        ]
    }
};
const $c7ca41bed72364b1$export$e65e3c28a9b7d37c = [
    {
        group: (0, $bLQRh.terms).price,
        ...$c7ca41bed72364b1$var$generalConfig,
        options: [
            (0, $cL3O2.listingViews).medianPrice,
            (0, $cL3O2.listingViews).soldAvgVsMedianPrice,
            (0, $cL3O2.listingViews).avgSpOpComparison,
            (0, $cL3O2.listingViews).avgSpLpComparison,
            (0, $cL3O2.listingViews).avgSpOpAllProperties,
            (0, $cL3O2.listingViews).avg$Sqft
        ]
    },
    {
        group: (0, $bLQRh.terms).supplyAmpDemand,
        ...$c7ca41bed72364b1$var$generalConfig,
        options: [
            (0, $cL3O2.listingViews).supplyAmpDemandNumUnits,
            (0, $cL3O2.listingViews).forSaleVsFsldm
        ]
    },
    {
        group: (0, $bLQRh.terms).salesRate,
        ...$c7ca41bed72364b1$var$generalConfig,
        options: [
            (0, $cL3O2.listingViews).monthlySupplyOfInventory,
            (0, $cL3O2.listingViews).avgDomCdom,
            (0, $cL3O2.listingViews).salesAbsorption,
            (0, $cL3O2.listingViews).cdomBreakout
        ]
    }
];



var $cL3O2 = parcelRequire("cL3O2");

var $bLQRh = parcelRequire("bLQRh");



var $1PiL9 = parcelRequire("1PiL9");

var $htzEo = parcelRequire("htzEo");

var $98ROn = parcelRequire("98ROn");
const $1ab9a48decdd7d5d$var$generalConfig = {
    chart: {
        xaxis: {
            categories: (0, $f04533a6b7242ef6$export$dd620a434769eadb)
        }
    },
    columnSettings: {
        label: (0, $bLQRh.terms).month,
        keyField: (0, $1PiL9.marketDynamicsColumns).timePeriodStart.id,
        valueFormatter: (v)=>(0, $htzEo.shortMonthAndYearFormat)(v.value),
        ...(0, $98ROn.colSettings).textSm
    },
    periodSelection: true,
    keyInfo: {
        beginVsEndMonth: [
            (0, $03d403fa8ed96844$export$c0f6db12d479e12e).status,
            (0, $03d403fa8ed96844$export$c0f6db12d479e12e).beginPeriod,
            (0, $03d403fa8ed96844$export$c0f6db12d479e12e).endPeriod,
            (0, $03d403fa8ed96844$export$c0f6db12d479e12e).changeValue,
            (0, $03d403fa8ed96844$export$c0f6db12d479e12e).changeValuePercentage
        ],
        wholeTimePeriod: [
            (0, $03d403fa8ed96844$export$c0f6db12d479e12e).status,
            (0, $03d403fa8ed96844$export$c0f6db12d479e12e).periodChange,
            (0, $03d403fa8ed96844$export$c0f6db12d479e12e).periodPercentChange,
            (0, $03d403fa8ed96844$export$c0f6db12d479e12e).totalChange,
            (0, $03d403fa8ed96844$export$c0f6db12d479e12e).totalPercentChange
        ]
    }
};
const $1ab9a48decdd7d5d$export$62ea1eaba003a5b5 = [
    {
        group: (0, $bLQRh.terms).price,
        ...$1ab9a48decdd7d5d$var$generalConfig,
        options: [
            (0, $cL3O2.listingViews).medianPrice,
            (0, $cL3O2.listingViews).soldAvgVsMedianPrice,
            (0, $cL3O2.listingViews).avgSpOpComparison,
            (0, $cL3O2.listingViews).avgSpLpComparison,
            (0, $cL3O2.listingViews).avgSpOpAllProperties,
            (0, $cL3O2.listingViews).avg$Sqft
        ]
    },
    {
        group: (0, $bLQRh.terms).supplyAmpDemand,
        ...$1ab9a48decdd7d5d$var$generalConfig,
        options: [
            (0, $cL3O2.listingViews).supplyAmpDemandNumUnits,
            (0, $cL3O2.listingViews).forSaleVsFsldm
        ]
    },
    {
        group: (0, $bLQRh.terms).salesRate,
        ...$1ab9a48decdd7d5d$var$generalConfig,
        options: [
            (0, $cL3O2.listingViews).monthlySupplyOfInventory,
            (0, $cL3O2.listingViews).avgDomCdom,
            (0, $cL3O2.listingViews).salesAbsorption,
            (0, $cL3O2.listingViews).cdomBreakout
        ]
    }
];



var $cL3O2 = parcelRequire("cL3O2");

var $ikyhZ = parcelRequire("ikyhZ");

var $bLQRh = parcelRequire("bLQRh");



var $1PiL9 = parcelRequire("1PiL9");

var $htzEo = parcelRequire("htzEo");

var $98ROn = parcelRequire("98ROn");
const $329df5ca34b9e776$var$generalConfig = {
    chart: {
        xaxis: {
            categories: (0, $f04533a6b7242ef6$export$a74c6b1d7748b62b)
        }
    },
    columnSettings: {
        label: (0, $bLQRh.terms).weekOf,
        keyField: (0, $1PiL9.marketDynamicsColumns).timePeriodStart.id,
        valueFormatter: (v)=>(0, $htzEo.shortDateFormat)(v.value),
        ...(0, $98ROn.colSettings).textSm
    },
    periodSelection: false,
    keyInfo: {
        beginVsEndMonth: [
            (0, $03d403fa8ed96844$export$c0f6db12d479e12e).status,
            (0, $03d403fa8ed96844$export$c0f6db12d479e12e).previousWeeksAvg,
            (0, $03d403fa8ed96844$export$c0f6db12d479e12e).lastWeeksAvg,
            (0, $03d403fa8ed96844$export$c0f6db12d479e12e).changeAvg,
            (0, $03d403fa8ed96844$export$c0f6db12d479e12e).changeAvgPercentage
        ]
    }
};
const $329df5ca34b9e776$export$f594d43204426b4e = [
    {
        group: (0, $bLQRh.terms).price,
        ...$329df5ca34b9e776$var$generalConfig,
        options: [
            (0, $cL3O2.listingViews).medianPrice
        ]
    },
    {
        group: (0, $bLQRh.terms).supplyAmpDemand,
        ...$329df5ca34b9e776$var$generalConfig,
        options: [
            {
                ...(0, $cL3O2.listingViews).supplyAmpDemandNumUnits,
                statusOptions: {
                    groups: [
                        {
                            options: (0, $cL3O2.listingViews).supplyAmpDemandNumUnits.statusOptions.groups[0].options.map((status)=>{
                                if (status.id === (0, $ikyhZ.listingStatuses).forSale.id || status.id === (0, $ikyhZ.listingStatuses).underContract.id) return {
                                    ...status,
                                    isDefault: false
                                };
                                return status;
                            })
                        }
                    ]
                },
                tableSettings: {
                    ...(0, $cL3O2.listingViews).supplyAmpDemandNumUnits.tableSettings,
                    tables: [
                        {
                            ...(0, $cL3O2.listingViews).supplyAmpDemandNumUnits.tableSettings.tables[0]
                        },
                        {
                            col: (0, $1PiL9.marketDynamicsColumns).newUnits,
                            colDef: (0, $98ROn.colSettings).numberSmInteger,
                            statusId: (0, $ikyhZ.listingStatuses).newListings.id
                        },
                        {
                            col: (0, $1PiL9.marketDynamicsColumns).forSaleUnits,
                            colDef: (0, $98ROn.colSettings).numberSmInteger,
                            statusId: (0, $ikyhZ.listingStatuses).forSale.id
                        },
                        {
                            col: (0, $1PiL9.marketDynamicsColumns).ucUnits,
                            colDef: (0, $98ROn.colSettings).numberSmInteger,
                            statusId: (0, $ikyhZ.listingStatuses).underContract.id
                        },
                        {
                            col: (0, $1PiL9.marketDynamicsColumns).soldUnits,
                            colDef: (0, $98ROn.colSettings).numberSmInteger,
                            statusId: (0, $ikyhZ.listingStatuses).sold.id
                        },
                        {
                            col: (0, $1PiL9.marketDynamicsColumns).expUnits,
                            colDef: (0, $98ROn.colSettings).numberSmInteger,
                            statusId: (0, $ikyhZ.listingStatuses).expired.id
                        }
                    ]
                }
            }
        ]
    },
    {
        group: (0, $bLQRh.terms).salesRate,
        ...$329df5ca34b9e776$var$generalConfig,
        options: [
            {
                ...(0, $cL3O2.listingViews).underContractUc
            },
            (0, $cL3O2.listingViews).salesAbsorption
        ]
    }
];



var $htzEo = parcelRequire("htzEo");
const $8a7be9347dd0737e$export$35767bc2eeba0585 = {
    [(0, $cstaF.marketDynamicsTimePeriods)[(0, $cstaF.marketDynamicsTerms).years3Quarterly]]: (0, $4121db94f506a2d6$export$ddfaedac8a416ec9),
    [(0, $cstaF.marketDynamicsTimePeriods)[(0, $cstaF.marketDynamicsTerms).years2Monthly]]: (0, $c7ca41bed72364b1$export$e65e3c28a9b7d37c),
    [(0, $cstaF.marketDynamicsTimePeriods)[(0, $cstaF.marketDynamicsTerms).years1Monthly]]: (0, $1ab9a48decdd7d5d$export$62ea1eaba003a5b5),
    [(0, $cstaF.marketDynamicsTimePeriods)[(0, $cstaF.marketDynamicsTerms).months6Weekly]]: (0, $329df5ca34b9e776$export$f594d43204426b4e)
};
const $8a7be9347dd0737e$export$8cc07aea50a1000a = {
    [(0, $cstaF.marketDynamicsTerms).years3Quarterly]: (0, $htzEo.quarterNumYearFormat),
    [(0, $cstaF.marketDynamicsTerms).years2Monthly]: (0, $htzEo.shortMonthAndYearFormat),
    [(0, $cstaF.marketDynamicsTerms).years1Monthly]: (0, $htzEo.shortMonthAndYearFormat),
    [(0, $cstaF.marketDynamicsTerms).months6Weekly]: (0, $htzEo.shortDateFormat)
};


const $18f2156a0a365b8a$export$9b0e41b6f651db4b = [
    (0, $g7mFm.officeBreakdownRoute),
    (0, $g7mFm.listingsBreakdownRoute)
];
const $18f2156a0a365b8a$export$799cac59bce08f6 = ({ route: route, title: title, backBtnTitle: backBtnTitle })=>{
    return ({
        [(0, $g7mFm.officeBreakdownRoute)]: (0, $7D4kr.createNavConfig)((0, $cstaF.marketDynamicsTerms).marketDynamics, (context)=>(0, $7D4kr.formatPeriodTitle)(context.period?.timePeriodStart, (0, $8a7be9347dd0737e$export$8cc07aea50a1000a)[title])),
        [(0, $g7mFm.listingsBreakdownRoute)]: (0, $7D4kr.createNavConfig)((0, $cstaF.marketDynamicsTerms).marketDynamics, (context)=>(0, $7D4kr.formatPeriodTitle)(context.period?.timePeriodStart, (0, $8a7be9347dd0737e$export$8cc07aea50a1000a)[title])),
        [(0, $g7mFm.officeListingsRoute)]: (0, $7D4kr.createNavConfig)((0, $cstaF.searchTerms).offices, (0, $7D4kr.constant)(title)),
        [(0, $cstaF.searchRoutes).agentsGainedBreakdown]: (0, $7D4kr.createNavConfig)(backBtnTitle || (0, $cstaF.searchTerms).agentMovement, (0, $7D4kr.constant)(title)),
        [(0, $cstaF.searchRoutes).officeListBreakdown]: (0, $7D4kr.createNavConfig)((0, $cstaF.searchTerms).agentMovement, (0, $7D4kr.constant)(title))
    })[route];
};



var $cstaF = parcelRequire("cstaF");

var $4EYT7 = parcelRequire("4EYT7");

var $dDBOF = parcelRequire("dDBOF");

var $7D4kr = parcelRequire("7D4kr");

var $c7dF9 = parcelRequire("c7dF9");

var $7AubO = parcelRequire("7AubO");

var $cghEn = parcelRequire("cghEn");
const $c8257d18c4a1050f$var$talentUrl = `${(0, $7AubO.getEndpoint)((0, $7AubO.TALENT))}/auth`;
const $c8257d18c4a1050f$var$getProficiencyMetricsNavItemsByApp = (navTo)=>({
        [(0, $dDBOF.appNames).XAM]: undefined,
        [(0, $dDBOF.appNames).XBM]: {
            label: (0, $cstaF.agentProductionTerms).proficiencyMetrics,
            menuItems: [
                {
                    label: (0, $cstaF.searchTerms).searchBy,
                    header: true
                },
                {
                    label: (0, $cstaF.searchTypes)[(0, $cstaF.searchRoutes).transactions].title,
                    onClick: ()=>{
                        navTo((0, $cstaF.searchRoutes).transactions, (0, $cstaF.modules).proficiencyMetrics.transactions);
                    },
                    activePathname: (0, $cstaF.searchRoutes).transactions
                },
                {
                    label: (0, $cstaF.searchTypes)[(0, $cstaF.searchRoutes).officeName].title,
                    onClick: ()=>navTo((0, $cstaF.searchRoutes).officeName, (0, $cstaF.modules).proficiencyMetrics.offices),
                    activePathname: (0, $cstaF.searchRoutes).officeName
                },
                {
                    label: (0, $cstaF.searchTypes)[(0, $cstaF.searchRoutes).agentName].title,
                    onClick: ()=>navTo((0, $cstaF.searchRoutes).agentName, (0, $cstaF.modules).proficiencyMetrics.agents),
                    activePathname: (0, $cstaF.searchRoutes).agentName
                },
                {
                    label: (0, $cstaF.searchTypes)[(0, $cstaF.searchRoutes).agentMovement].title,
                    onClick: ()=>navTo((0, $cstaF.searchRoutes).agentMovement, (0, $cstaF.modules).proficiencyMetrics.agentMovement),
                    activePathname: (0, $cstaF.searchRoutes).agentMovement
                },
                {
                    label: (0, $cstaF.searchTypes)[(0, $cstaF.searchRoutes).savedAgents].title,
                    onClick: ()=>navTo((0, $cstaF.searchRoutes).savedAgents, (0, $cstaF.modules).proficiencyMetrics.savedAgents),
                    activePathname: (0, $cstaF.searchRoutes).savedAgents
                },
                {
                    label: (0, $cstaF.searchTypes)[(0, $cstaF.searchRoutes).suggestedAgents].title,
                    onClick: ()=>navTo((0, $cstaF.searchRoutes).suggestedAgents, (0, $cstaF.modules).proficiencyMetrics.suggestedAgents),
                    activePathname: (0, $cstaF.searchRoutes).suggestedAgents
                }
            ]
        }
    });
const $c8257d18c4a1050f$var$getAgentProductionNavItemsByApp = (navTo)=>({
        [(0, $dDBOF.appNames).XAM]: {
            label: (0, $cstaF.agentProductionTerms).agentProduction,
            onClick: ()=>navTo((0, $c7dF9.Routes).AGENT_PRODUCTION.BASE, (0, $cstaF.moduleNames).agentProduction),
            activePathname: (0, $c7dF9.Routes).AGENT_PRODUCTION.BASE
        },
        [(0, $dDBOF.appNames).XBM]: undefined
    });
const $c8257d18c4a1050f$var$getMarketShareNavItemsByApp = (navTo)=>({
        [(0, $dDBOF.appNames).XAM]: {
            label: (0, $cstaF.marketShareTerms).marketShare,
            menuItems: [
                {
                    label: (0, $cstaF.searchTerms).searchBy,
                    header: true
                },
                {
                    label: (0, $cstaF.searchTypes)[(0, $cstaF.searchRoutes).totals].title,
                    onClick: ()=>navTo((0, $cstaF.searchRoutes).totals, (0, $cstaF.modules).marketShare.totals),
                    activePathname: (0, $cstaF.searchRoutes).totals
                }
            ]
        },
        [(0, $dDBOF.appNames).XBM]: {
            label: (0, $cstaF.marketShareTerms).marketShare,
            menuItems: [
                {
                    label: (0, $cstaF.searchTerms).searchBy,
                    header: true
                },
                {
                    label: (0, $cstaF.searchTypes)[(0, $cstaF.searchRoutes).totals].title,
                    onClick: ()=>navTo((0, $cstaF.searchRoutes).totals, (0, $cstaF.modules).marketShare.totals),
                    activePathname: (0, $cstaF.searchRoutes).totals
                },
                {
                    label: (0, $cstaF.searchTypes)[(0, $cstaF.searchRoutes).coverage].title,
                    onClick: ()=>navTo((0, $cstaF.searchRoutes).coverage, (0, $cstaF.modules).marketShare.coverage),
                    activePathname: (0, $cstaF.searchRoutes).coverage
                }
            ]
        }
    });
const $c8257d18c4a1050f$var$getMarketDynamicsNavItems = (navTo)=>({
        label: (0, $cstaF.marketDynamicsTerms).marketDynamics,
        onClick: ()=>navTo((0, $c7dF9.Routes).MARKET_DYNAMICS.BASE, (0, $cstaF.moduleNames).marketDynamics),
        activePathname: (0, $c7dF9.Routes).MARKET_DYNAMICS.BASE
    });
const $c8257d18c4a1050f$var$getDashboardNavItems = (navTo)=>({
        label: (0, $4EYT7.terms).dashboard,
        onClick: ()=>navTo((0, $c7dF9.Routes).HOME.DASHBOARD, (0, $cstaF.moduleNames).dashboard),
        activePathname: (0, $c7dF9.Routes).HOME.DASHBOARD
    });
const $c8257d18c4a1050f$export$3bf6da68760a4cf0 = (lwaClients, appCode)=>lwaClients?.find((client)=>client.applications?.some((application)=>application.code === appCode))?.clientId;
const $c8257d18c4a1050f$var$getTalentNavItem = (lwaClients)=>{
    const talentClientId = $c8257d18c4a1050f$export$3bf6da68760a4cf0(lwaClients, (0, $cghEn.BMT_APP_KEY));
    if (!talentClientId) return {
        label: (0, $7D4kr.talentTerms).talent,
        menuItems: [
            {
                label: (0, $7D4kr.talentTerms).tryTalent,
                url: (0, $7D4kr.TALENT_MARKETING_URL),
                target: "_blank"
            }
        ]
    };
    return {
        label: (0, $7D4kr.talentTerms).talent,
        menuItems: [
            {
                label: (0, $7D4kr.talentTerms).tryTalent,
                url: `${$c8257d18c4a1050f$var$talentUrl}?ac=${encodeURIComponent(talentClientId)}`,
                target: "_blank"
            }
        ]
    };
};
const $c8257d18c4a1050f$export$7d00983a04b3bc19 = (navTo, isLegacyUser)=>[
        {
            url: "",
            label: (0, $cstaF.navTerms).myProfile,
            onClick: ()=>navTo("/my-profile")
        },
        // {
        //     url: `${getEndpoint(ID_SITE)}/auth/realms/terradatum/login-actions/reset-credentials?client_id=aergo&tab_id=txRDXnWXhc0`,
        //     label: 'Reset Password'
        // },
        // LWA users sign out via the platform service's universal logout instead (see UniversalNavBar).
        ...isLegacyUser ? [
            {
                url: "#",
                label: (0, $cstaF.navTerms).signOut,
                onClick: ()=>(0, $7D4kr.navigateToLogout)()
            }
        ] : []
    ];
const $c8257d18c4a1050f$export$bffb664247d74229 = async ({ isLegacyUser: isLegacyUser, tokenInfo: tokenInfo, platformService: platformService, userItems: userItems })=>{
    if (isLegacyUser) return {
        userMenuProps: tokenInfo,
        menuItems: userItems || []
    };
    if (!platformService) return undefined;
    const navbarUserMenuProps = await platformService.getNavbarUserMenuProps({
        menuItems: userItems
    });
    if (!navbarUserMenuProps) return undefined;
    return {
        userMenuProps: navbarUserMenuProps.user,
        menuItems: navbarUserMenuProps.menuItems || []
    };
};
const $c8257d18c4a1050f$export$b344df7b232ea070 = [
    {
        url: "https://www.lwolf.com/services/training/new-brokermetrics",
        label: (0, $7D4kr.helpItemLabels).WEBINARS_TRAINING,
        target: "_blank"
    },
    {
        url: "https://lonewolf.my.site.com/s/brokermetrics-video-library",
        label: (0, $7D4kr.helpItemLabels).VIDEO_LIBRARY,
        target: "_blank"
    },
    {
        url: "https://lwolf.force.com/s/article/BMPM-Proficiency-Metrics-FAQs",
        label: (0, $7D4kr.helpItemLabels).HELP_GUIDES_FAQS,
        target: "_blank"
    }
];
const $c8257d18c4a1050f$export$d06a4cb77a922f24 = ({ allowedModules: allowedModules, navTo: navTo, isAgentProductionEnabled: isAgentProductionEnabled, isDashboardEnabled: isDashboardEnabled, isLegacyUser: isLegacyUser, isTalentEnabled: isTalentEnabled, lwaClients: lwaClients })=>{
    const updatedNavItems = [];
    if (isDashboardEnabled) updatedNavItems.push($c8257d18c4a1050f$var$getDashboardNavItems(navTo));
    if ((0, $dDBOF.runningApp) === (0, $dDBOF.appNames).XBM && !isLegacyUser && isTalentEnabled) updatedNavItems.push($c8257d18c4a1050f$var$getTalentNavItem(lwaClients));
    if (!allowedModules?.length || allowedModules.includes((0, $cstaF.moduleNames).proficiencyMetrics)) updatedNavItems.push($c8257d18c4a1050f$var$getProficiencyMetricsNavItemsByApp(navTo)[0, $dDBOF.runningApp]);
    if (allowedModules?.includes((0, $cstaF.moduleNames).agentProduction) && isAgentProductionEnabled) updatedNavItems.push($c8257d18c4a1050f$var$getAgentProductionNavItemsByApp(navTo)[0, $dDBOF.runningApp]);
    if (allowedModules?.includes((0, $cstaF.moduleNames).marketShare)) updatedNavItems.push($c8257d18c4a1050f$var$getMarketShareNavItemsByApp(navTo)[0, $dDBOF.runningApp]);
    if (allowedModules?.includes((0, $cstaF.moduleNames).marketDynamics)) updatedNavItems.push($c8257d18c4a1050f$var$getMarketDynamicsNavItems(navTo));
    return updatedNavItems;
};
const $c8257d18c4a1050f$export$cbd12ebcc216e09a = ({ product: product, userProducts: userProducts, isSavedAgents: isSavedAgents = false, isLegacyUser: isLegacyUser = false })=>{
    const routeByProducts = {
        [(0, $cstaF.moduleNames).proficiencyMetrics]: (0, $c7dF9.Routes).PROF_METRICS.BASE,
        [(0, $cstaF.moduleNames).marketShare]: (0, $c7dF9.Routes).MARKET_SHARE.BASE,
        [(0, $cstaF.moduleNames).marketDynamics]: (0, $c7dF9.Routes).MARKET_DYNAMICS.BASE
    };
    if (isLegacyUser && isSavedAgents) return (0, $c7dF9.Routes).PROF_METRICS.BASE + (0, $c7dF9.Routes).PROF_METRICS.SAVED_AGENTS;
    if (isLegacyUser) return (0, $c7dF9.Routes).PROF_METRICS.BASE;
    if (isSavedAgents && userProducts?.includes(product)) return (0, $c7dF9.Routes).PROF_METRICS.BASE + (0, $c7dF9.Routes).PROF_METRICS.SAVED_AGENTS;
    if (userProducts?.includes(product)) return routeByProducts[product];
    return userProducts && userProducts.length > 0 ? routeByProducts[userProducts[0]] : undefined;
};



var $cstaF = parcelRequire("cstaF");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $cstaF = parcelRequire("cstaF");
const $427648052aee8357$export$a6584158f9e495c0 = (value)=>{
    switch(value){
        case "A":
            return (0, $cstaF.listingStatus).active;
        case "P":
            return (0, $cstaF.listingStatus).pending;
        case "C":
            return (0, $cstaF.listingStatus).contingent;
        case "S":
            return (0, $cstaF.listingStatus).sold;
        default:
            return "";
    }
};



var $htzEo = parcelRequire("htzEo");

var $cstaF = parcelRequire("cstaF");
const $5f95247c68892fb4$export$42035f545ecd5428 = (description, value = "-", code, hasDetail)=>{
    return {
        description: description,
        value: value,
        code: code,
        hasDetail: hasDetail
    };
};
const $5f95247c68892fb4$export$a702574b38ecbcc8 = (listInfo)=>{
    const propertyStatus = (0, $427648052aee8357$export$a6584158f9e495c0)(listInfo.status);
    const orgPriceListPrice = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            listInfo.originalPrice && (0, $htzEo.getCurrencyFormat)(listInfo.originalPrice),
            "\xa0/\xa0",
            listInfo.listPrice && (0, $htzEo.getCurrencyFormat)(listInfo.listPrice)
        ]
    });
    const rows = [];
    rows.push($5f95247c68892fb4$export$42035f545ecd5428((0, $cstaF.agentProductionTerms).mlsNumber, listInfo.mlsNumber || ""));
    rows.push($5f95247c68892fb4$export$42035f545ecd5428((0, $cstaF.agentProductionTerms).status, propertyStatus || ""));
    rows.push($5f95247c68892fb4$export$42035f545ecd5428((0, $cstaF.agentProductionTerms).propertyType, listInfo.propertyType || ""));
    rows.push($5f95247c68892fb4$export$42035f545ecd5428((0, $cstaF.agentProductionTerms).propertySubType, listInfo.propertySubType || ""));
    rows.push($5f95247c68892fb4$export$42035f545ecd5428((0, $cstaF.agentProductionTerms).price, listInfo.price ? (0, $htzEo.getCurrencyFormat)(listInfo.price) : (0, $htzEo.getCurrencyFormat)(listInfo.listPrice)));
    rows.push($5f95247c68892fb4$export$42035f545ecd5428((0, $cstaF.agentProductionTerms).orgPriceListPrice, orgPriceListPrice || ""));
    rows.push($5f95247c68892fb4$export$42035f545ecd5428((0, $cstaF.agentProductionTerms).bankProperty, (0, $htzEo.boolToShortString)(listInfo.bankInvolvement) || ""));
    rows.push($5f95247c68892fb4$export$42035f545ecd5428((0, $cstaF.agentProductionTerms).domCdom, `${listInfo.dom}/${listInfo.cdom}` || ""));
    rows.push($5f95247c68892fb4$export$42035f545ecd5428((0, $cstaF.agentProductionTerms).taxId, listInfo.taxId || ""));
    rows.push($5f95247c68892fb4$export$42035f545ecd5428((0, $cstaF.agentProductionTerms).listAgent, listInfo.listAgentName, listInfo.listAgentId?.agentCode || ""));
    rows.push($5f95247c68892fb4$export$42035f545ecd5428((0, $cstaF.agentProductionTerms).coListAgent, listInfo.coListAgentName, listInfo.coListAgentId?.agentCode || ""));
    rows.push($5f95247c68892fb4$export$42035f545ecd5428((0, $cstaF.agentProductionTerms).sellAgent, listInfo.sellAgentName, listInfo.sellAgentId?.agentCode || ""));
    rows.push($5f95247c68892fb4$export$42035f545ecd5428((0, $cstaF.agentProductionTerms).coSellAgent, listInfo.coSellAgentName, listInfo.coSellAgentId?.agentCode || ""));
    rows.push($5f95247c68892fb4$export$42035f545ecd5428((0, $cstaF.agentProductionTerms).listOffice, listInfo.listOfficeName, listInfo.listOfficeId?.officeCode || ""));
    rows.push($5f95247c68892fb4$export$42035f545ecd5428((0, $cstaF.agentProductionTerms).coListOffice, listInfo.coListOfficeName, listInfo.coListOfficeId?.officeCode || ""));
    rows.push($5f95247c68892fb4$export$42035f545ecd5428((0, $cstaF.agentProductionTerms).sellOffice, listInfo.sellOfficeName, listInfo.sellOfficeId?.officeCode || ""));
    rows.push($5f95247c68892fb4$export$42035f545ecd5428((0, $cstaF.agentProductionTerms).coSellOffice, listInfo.coSellOfficeName, listInfo.coSellOfficeId?.officeCode || ""));
    rows[rows.length - 1].isLastRow = true;
    return rows;
};
const $5f95247c68892fb4$export$fd64a1f33de3651a = (propertyInfo)=>{
    const rows = [];
    rows.push($5f95247c68892fb4$export$42035f545ecd5428((0, $cstaF.agentProductionTerms).bedrooms, propertyInfo.bedrooms || ""));
    rows.push($5f95247c68892fb4$export$42035f545ecd5428((0, $cstaF.agentProductionTerms).fullBaths, propertyInfo.fullBaths || ""));
    rows.push($5f95247c68892fb4$export$42035f545ecd5428((0, $cstaF.agentProductionTerms).partialBaths, propertyInfo.partialBaths || ""));
    rows.push($5f95247c68892fb4$export$42035f545ecd5428((0, $cstaF.agentProductionTerms).squareFeet, propertyInfo.sqFt ? (0, $htzEo.formatVolumeOrDays)(propertyInfo.sqFt) : ""));
    rows.push($5f95247c68892fb4$export$42035f545ecd5428((0, $cstaF.agentProductionTerms).lotSizeSqft, propertyInfo.lotSize ? (0, $htzEo.formatVolumeOrDays)(propertyInfo.lotSize) : ""));
    rows.push($5f95247c68892fb4$export$42035f545ecd5428((0, $cstaF.agentProductionTerms).acres, propertyInfo.acres ? (0, $htzEo.formatUnitOrPercentage)(propertyInfo.acres) : ""));
    rows.push($5f95247c68892fb4$export$42035f545ecd5428((0, $cstaF.agentProductionTerms).mlsArea, propertyInfo.mlsArea || ""));
    rows.push($5f95247c68892fb4$export$42035f545ecd5428((0, $cstaF.agentProductionTerms).subdivision, propertyInfo.subdivision || ""));
    rows.push($5f95247c68892fb4$export$42035f545ecd5428((0, $cstaF.agentProductionTerms).mapCode, propertyInfo.mapCode || ""));
    rows.push($5f95247c68892fb4$export$42035f545ecd5428((0, $cstaF.agentProductionTerms).yearBuilt, propertyInfo.yearBuilt || ""));
    rows.push($5f95247c68892fb4$export$42035f545ecd5428((0, $cstaF.agentProductionTerms).newConstruction, propertyInfo.newConstruction || propertyInfo.constructionType || ""));
    rows[rows.length - 1].isLastRow = true;
    return rows;
};
const $5f95247c68892fb4$export$c84a608021307b6c = (officeDetails)=>{
    const rows = [];
    rows.push($5f95247c68892fb4$export$42035f545ecd5428((0, $cstaF.agentProductionTerms).brokerID, officeDetails.data.brokerId));
    rows.push($5f95247c68892fb4$export$42035f545ecd5428((0, $cstaF.agentProductionTerms).officeId, officeDetails.data.officeId));
    rows.push($5f95247c68892fb4$export$42035f545ecd5428((0, $cstaF.agentProductionTerms).mls, officeDetails.data.mls));
    rows.push($5f95247c68892fb4$export$42035f545ecd5428((0, $cstaF.agentProductionTerms).responsibleMember, officeDetails.data.responsibleMember));
    rows.push($5f95247c68892fb4$export$42035f545ecd5428((0, $cstaF.agentProductionTerms).mlsIDs, officeDetails.data.mlsId));
    rows.push($5f95247c68892fb4$export$42035f545ecd5428((0, $cstaF.agentProductionTerms).producingAgents, officeDetails.data.producingAgents));
    rows[rows.length - 1].isLastRow = true;
    return rows;
};
const $5f95247c68892fb4$export$34fd9c81845a7922 = (officeDetails)=>{
    const rows = [];
    rows.push($5f95247c68892fb4$export$42035f545ecd5428((0, $cstaF.agentProductionTerms).officeName, officeDetails.data.officeName));
    rows.push($5f95247c68892fb4$export$42035f545ecd5428((0, $cstaF.agentProductionTerms).officeAddress, officeDetails.data.streetName1));
    rows.push($5f95247c68892fb4$export$42035f545ecd5428((0, $cstaF.agentProductionTerms).officePhone, officeDetails.data.phoneList[0].phoneNumber));
    rows.push($5f95247c68892fb4$export$42035f545ecd5428((0, $cstaF.agentProductionTerms).officeEmail, officeDetails.data.emailAddress));
    rows.push($5f95247c68892fb4$export$42035f545ecd5428((0, $cstaF.agentProductionTerms).memberType, officeDetails.data.memberType));
    rows.push($5f95247c68892fb4$export$42035f545ecd5428((0, $cstaF.agentProductionTerms).status, officeDetails.data.status));
    rows[rows.length - 1].isLastRow = true;
    return rows;
};



var $hQz0O = parcelRequire("hQz0O");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $cstaF = parcelRequire("cstaF");


var $htzEo = parcelRequire("htzEo");
const $7ea0df6fe6bf1196$var$getRow = (description, value = "-", code, hasDetail)=>{
    return {
        description: description,
        value: value,
        code: code,
        hasDetail: hasDetail
    };
};
const $7ea0df6fe6bf1196$var$getGridRow = (description, value = "", isAltData)=>{
    return {
        description: description,
        value: value,
        isAltData: isAltData
    };
};
const $7ea0df6fe6bf1196$export$db38a458d09d5450 = (officeInfo)=>{
    const address = `${officeInfo.streetName1 ? officeInfo.streetName1 + ", " : ""}${officeInfo.city ? officeInfo.city + ", " : ""}${officeInfo.stateCode ?? ""} ${officeInfo.zipCode ?? ""}`;
    return address.trim() || "-";
};
const $7ea0df6fe6bf1196$var$getPhoneNumbers = (phones)=>{
    if (!phones || phones.length === 0) return "-";
    return phones.map((phone)=>{
        return {
            description: phone.phoneType,
            value: phone.phoneNumber
        };
    });
};
const $7ea0df6fe6bf1196$export$533db429d2c2033d = [
    (0, $cstaF.agentProductionTerms).listAgent,
    (0, $cstaF.agentProductionTerms).coListAgent,
    (0, $cstaF.agentProductionTerms).sellAgent,
    (0, $cstaF.agentProductionTerms).coSellAgent
];
const $7ea0df6fe6bf1196$export$4e67d6f29dad3fab = (data)=>{
    return {
        [(0, $cstaF.agentProductionTerms).listOffice]: {
            idValue: data.listOfficeId.officeCode,
            entry: (0, $cstaF.agentProductionTerms).listOffice,
            mlsId: data.listOfficeId.mlsId
        },
        [(0, $cstaF.agentProductionTerms).coListOffice]: {
            idValue: data.coListOfficeId.officeCode,
            entry: (0, $cstaF.agentProductionTerms).coListOffice,
            mlsId: data.coListOfficeId.mlsId
        },
        [(0, $cstaF.agentProductionTerms).sellOffice]: {
            idValue: data.sellOfficeId.officeCode,
            entry: (0, $cstaF.agentProductionTerms).sellOffice,
            mlsId: data.sellOfficeId.mlsId
        },
        [(0, $cstaF.agentProductionTerms).coSellOffice]: {
            idValue: data.coSellOfficeId.officeCode,
            entry: (0, $cstaF.agentProductionTerms).coSellOffice,
            mlsId: data.coSellOfficeId.mlsId
        },
        [(0, $cstaF.agentProductionTerms).listAgent]: {
            idValue: data.listAgentId.agentCode,
            entry: (0, $cstaF.agentProductionTerms).listAgent,
            mlsId: data.listAgentId.mlsId
        },
        [(0, $cstaF.agentProductionTerms).coListAgent]: {
            idValue: data.coListAgentId.agentCode,
            entry: (0, $cstaF.agentProductionTerms).coListAgent,
            mlsId: data.coListAgentId.mlsId
        },
        [(0, $cstaF.agentProductionTerms).sellAgent]: {
            idValue: data.sellAgentId.agentCode,
            entry: (0, $cstaF.agentProductionTerms).sellAgent,
            mlsId: data.sellAgentId.mlsId
        },
        [(0, $cstaF.agentProductionTerms).coSellAgent]: {
            idValue: data.coSellAgentId.agentCode,
            entry: (0, $cstaF.agentProductionTerms).coSellAgent,
            mlsId: data.coSellAgentId.mlsId
        }
    };
};
const $7ea0df6fe6bf1196$export$5a6d863506628af2 = (detailInfo, mlsId)=>{
    if (!detailInfo) return [];
    const rows = [];
    rows.push($7ea0df6fe6bf1196$var$getRow((0, $cstaF.agentProductionTerms).brokerID, detailInfo.brokerId));
    rows.push($7ea0df6fe6bf1196$var$getRow((0, $cstaF.agentProductionTerms).officeId, detailInfo.officeId));
    rows.push($7ea0df6fe6bf1196$var$getRow((0, $cstaF.agentProductionTerms).mls, mlsId));
    rows.push($7ea0df6fe6bf1196$var$getRow((0, $cstaF.agentProductionTerms).responsibleMember, detailInfo.responsibleMember));
    rows.push($7ea0df6fe6bf1196$var$getRow((0, $cstaF.agentProductionTerms).mlsIDs, detailInfo.totalAgents));
    rows.push($7ea0df6fe6bf1196$var$getRow((0, $cstaF.agentProductionTerms).producingAgents, detailInfo.producingAgents));
    rows.push($7ea0df6fe6bf1196$var$getRow((0, $cstaF.agentProductionTerms).officeName, detailInfo.officeName));
    rows.push($7ea0df6fe6bf1196$var$getRow((0, $cstaF.agentProductionTerms).emailAddress, detailInfo.emailAddress));
    rows.push($7ea0df6fe6bf1196$var$getRow((0, $cstaF.agentProductionTerms).memberType, detailInfo.memberType));
    rows.push($7ea0df6fe6bf1196$var$getRow((0, $cstaF.agentProductionTerms).status, detailInfo.status));
    rows.push($7ea0df6fe6bf1196$var$getRow((0, $cstaF.agentProductionTerms).businessAddress, $7ea0df6fe6bf1196$export$db38a458d09d5450(detailInfo)));
    rows.push($7ea0df6fe6bf1196$var$getGridRow((0, $cstaF.agentProductionTerms).phoneNumbers, $7ea0df6fe6bf1196$var$getPhoneNumbers(detailInfo.phoneList), true));
    rows[rows.length - 1].isLastRow = true;
    return rows;
};
const $7ea0df6fe6bf1196$export$80a7b78180eee4fe = (agentInfo, officeInfo)=>{
    if (!agentInfo || !officeInfo) return [];
    const rows = [];
    const altAddress = agentInfo?.addressList.length > 0 && agentInfo?.addressList.map((address)=>{
        return {
            ...address,
            value: $7ea0df6fe6bf1196$export$db38a458d09d5450(address)
        };
    });
    const altPhones = agentInfo?.phoneList.length > 0 && agentInfo?.phoneList.map((phone)=>{
        return {
            ...phone,
            value: phone.phoneNumber
        };
    });
    rows.push($7ea0df6fe6bf1196$var$getRow((0, $cstaF.agentProductionTerms).agentId, agentInfo.agentId));
    rows.push($7ea0df6fe6bf1196$var$getRow((0, $cstaF.agentProductionTerms).name, `${agentInfo.firstName} ${agentInfo.lastName}`));
    rows.push($7ea0df6fe6bf1196$var$getRow((0, $cstaF.agentProductionTerms).officeId, officeInfo.officeId));
    rows.push($7ea0df6fe6bf1196$var$getRow((0, $cstaF.agentProductionTerms).officeName, officeInfo.officeName));
    rows.push($7ea0df6fe6bf1196$var$getRow((0, $cstaF.agentProductionTerms).businessAddress, $7ea0df6fe6bf1196$export$db38a458d09d5450(officeInfo)));
    rows.push($7ea0df6fe6bf1196$var$getGridRow((0, $cstaF.agentProductionTerms).phoneNumbers, $7ea0df6fe6bf1196$var$getPhoneNumbers(officeInfo.phoneList), true));
    rows.push($7ea0df6fe6bf1196$var$getRow((0, $cstaF.agentProductionTerms).emailAddress, agentInfo.emailAddress));
    rows.push($7ea0df6fe6bf1196$var$getGridRow((0, $cstaF.agentProductionTerms).alternateAddress, altAddress, true));
    rows.push($7ea0df6fe6bf1196$var$getGridRow((0, $cstaF.agentProductionTerms).alternatePhoneNumbers, altPhones, true));
    rows[rows.length - 1].isLastRow = true;
    return rows;
};
const $7ea0df6fe6bf1196$export$a702574b38ecbcc8 = (listInfo)=>{
    const propertyStatus = (0, $427648052aee8357$export$a6584158f9e495c0)(listInfo.status);
    const orgPriceListPrice = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            listInfo.originalPrice && (0, $htzEo.getCurrencyFormat)(listInfo.originalPrice),
            "\xa0/\xa0",
            listInfo.listPrice && (0, $htzEo.getCurrencyFormat)(listInfo.listPrice)
        ]
    });
    const rows = [];
    rows.push($7ea0df6fe6bf1196$var$getRow((0, $cstaF.agentProductionTerms).mlsNumber, listInfo.mlsNumber));
    rows.push($7ea0df6fe6bf1196$var$getRow((0, $cstaF.agentProductionTerms).status, propertyStatus));
    rows.push($7ea0df6fe6bf1196$var$getRow((0, $cstaF.agentProductionTerms).propertyType, listInfo.propertyType));
    rows.push($7ea0df6fe6bf1196$var$getRow((0, $cstaF.agentProductionTerms).propertySubType, listInfo.propertySubType));
    rows.push($7ea0df6fe6bf1196$var$getRow((0, $cstaF.agentProductionTerms).price, listInfo.price ? (0, $htzEo.getCurrencyFormat)(listInfo.price) : (0, $htzEo.getCurrencyFormat)(listInfo.listPrice)));
    rows.push($7ea0df6fe6bf1196$var$getRow((0, $cstaF.agentProductionTerms).orgPriceListPrice, orgPriceListPrice));
    rows.push($7ea0df6fe6bf1196$var$getRow((0, $cstaF.agentProductionTerms).bankProperty, (0, $htzEo.boolToShortString)(listInfo.bankInvolvement)));
    rows.push($7ea0df6fe6bf1196$var$getRow((0, $cstaF.agentProductionTerms).domCdom, `${listInfo.dom}/${listInfo.cdom}`));
    rows.push($7ea0df6fe6bf1196$var$getRow((0, $cstaF.agentProductionTerms).taxId, listInfo.taxId));
    rows.push($7ea0df6fe6bf1196$var$getRow((0, $cstaF.agentProductionTerms).listAgent, listInfo.listAgentName, listInfo.listAgentId?.agentCode, true));
    rows.push($7ea0df6fe6bf1196$var$getRow((0, $cstaF.agentProductionTerms).coListAgent, listInfo.coListAgentName, listInfo.coListAgentId?.agentCode, true));
    rows.push($7ea0df6fe6bf1196$var$getRow((0, $cstaF.agentProductionTerms).sellAgent, listInfo.sellAgentName, listInfo.sellAgentId?.agentCode, true));
    rows.push($7ea0df6fe6bf1196$var$getRow((0, $cstaF.agentProductionTerms).coSellAgent, listInfo.coSellAgentName, listInfo.coSellAgentId?.agentCode, true));
    rows.push($7ea0df6fe6bf1196$var$getRow((0, $cstaF.agentProductionTerms).listOffice, listInfo.listOfficeName, listInfo.listOfficeId?.officeCode, true));
    rows.push($7ea0df6fe6bf1196$var$getRow((0, $cstaF.agentProductionTerms).coListOffice, listInfo.coListOfficeName, listInfo.coListOfficeId?.officeCode, true));
    rows.push($7ea0df6fe6bf1196$var$getRow((0, $cstaF.agentProductionTerms).sellOffice, listInfo.sellOfficeName, listInfo.sellOfficeId?.officeCode, true));
    rows.push($7ea0df6fe6bf1196$var$getRow((0, $cstaF.agentProductionTerms).coSellOffice, listInfo.coSellOfficeName, listInfo.coSellOfficeId?.officeCode, true));
    rows[rows.length - 1].isLastRow = true;
    return rows;
};
const $7ea0df6fe6bf1196$export$fd64a1f33de3651a = (propertyInfo)=>{
    const rows = [];
    rows.push($7ea0df6fe6bf1196$var$getRow((0, $cstaF.agentProductionTerms).bedrooms, propertyInfo.bedrooms || 0));
    rows.push($7ea0df6fe6bf1196$var$getRow((0, $cstaF.agentProductionTerms).fullBaths, propertyInfo.fullBaths || 0));
    rows.push($7ea0df6fe6bf1196$var$getRow((0, $cstaF.agentProductionTerms).partialBaths, propertyInfo.partialBaths || 0));
    rows.push($7ea0df6fe6bf1196$var$getRow((0, $cstaF.agentProductionTerms).squareFeet, propertyInfo.sqFt && (0, $htzEo.formatVolumeOrDays)(propertyInfo.sqFt)));
    rows.push($7ea0df6fe6bf1196$var$getRow((0, $cstaF.agentProductionTerms).lotSize, propertyInfo.lotSize && (0, $htzEo.formatVolumeOrDays)(propertyInfo.lotSize)));
    rows.push($7ea0df6fe6bf1196$var$getRow((0, $cstaF.agentProductionTerms).acres, propertyInfo.acres && (0, $htzEo.formatUnitOrPercentage)(propertyInfo.acres)));
    rows.push($7ea0df6fe6bf1196$var$getRow((0, $cstaF.agentProductionTerms).mlsArea, propertyInfo.mlsArea));
    rows.push($7ea0df6fe6bf1196$var$getRow((0, $cstaF.agentProductionTerms).subdivision, propertyInfo.subdivision));
    rows.push($7ea0df6fe6bf1196$var$getRow((0, $cstaF.agentProductionTerms).mapCode, propertyInfo.mapCode));
    rows.push($7ea0df6fe6bf1196$var$getRow((0, $cstaF.agentProductionTerms).yearBuilt, propertyInfo.yearBuilt));
    rows.push($7ea0df6fe6bf1196$var$getRow((0, $cstaF.agentProductionTerms).newConstruction, propertyInfo.newConstruction || propertyInfo.constructionType));
    rows[rows.length - 1].isLastRow = true;
    return rows;
};


const $1fa46cf08ea2571a$export$4cf4f9869242a323 = (location)=>location === (0, $cstaF.searchRoutes).officeListBreakdown;
const $1fa46cf08ea2571a$export$57f655b15acb7f3c = (indicators, selectedOfficeListSearch)=>{
    const agentsGained = indicators.find((i)=>i?.key === (0, $hQz0O.indicatorsSettingsByKeyName).otherAgentsGained.id)?.value;
    const agentsLost = indicators.find((i)=>i?.key === (0, $hQz0O.indicatorsSettingsByKeyName).otherAgentsLost.id)?.value;
    if (isNaN(agentsGained) || isNaN(agentsLost)) return "";
    const agentsDiff = agentsGained - agentsLost;
    const officeTitle = !!selectedOfficeListSearch ? selectedOfficeListSearch?.name : (0, $hQz0O.terms).selectedOfficeOrOffices;
    if (agentsDiff === 0) return (0, $hQz0O.terms).getZeroAgents(officeTitle);
    if (agentsDiff < 0) return (0, $hQz0O.terms).getShrunkByAgents(officeTitle, agentsDiff * -1);
    return (0, $hQz0O.terms).getGrewByAgents(officeTitle, agentsDiff);
};
const $1fa46cf08ea2571a$export$17a9970356c0cb59 = (officeDetails)=>{
    const rows = [];
    rows.push((0, $5f95247c68892fb4$export$42035f545ecd5428)((0, $cstaF.agentProductionTerms).brokerID, officeDetails.brokerId));
    rows.push((0, $5f95247c68892fb4$export$42035f545ecd5428)((0, $cstaF.agentProductionTerms).officeId, officeDetails.officeId));
    rows.push((0, $5f95247c68892fb4$export$42035f545ecd5428)((0, $cstaF.agentProductionTerms).mls, officeDetails.mls));
    rows.push((0, $5f95247c68892fb4$export$42035f545ecd5428)((0, $cstaF.agentProductionTerms).responsibleMember, officeDetails.responsibleMember));
    rows.push((0, $5f95247c68892fb4$export$42035f545ecd5428)((0, $cstaF.agentProductionTerms).mlsIDs, officeDetails.totalAgents));
    rows.push((0, $5f95247c68892fb4$export$42035f545ecd5428)((0, $cstaF.agentProductionTerms).producingAgents, officeDetails.producingAgents));
    rows.push((0, $5f95247c68892fb4$export$42035f545ecd5428)((0, $cstaF.agentProductionTerms).officeName, officeDetails.officeName));
    rows.push((0, $5f95247c68892fb4$export$42035f545ecd5428)((0, $cstaF.agentProductionTerms).emailAddress, officeDetails.emailAddress));
    rows.push((0, $5f95247c68892fb4$export$42035f545ecd5428)((0, $cstaF.agentProductionTerms).memberType, officeDetails.memberType));
    rows.push((0, $5f95247c68892fb4$export$42035f545ecd5428)((0, $cstaF.agentProductionTerms).status, officeDetails.status));
    rows.push((0, $5f95247c68892fb4$export$42035f545ecd5428)((0, $cstaF.agentProductionTerms).businessAddress, (0, $7ea0df6fe6bf1196$export$db38a458d09d5450)(officeDetails)));
    rows.push((0, $5f95247c68892fb4$export$42035f545ecd5428)((0, $cstaF.agentProductionTerms).businessPhone, officeDetails.phoneList?.[0].phoneNumber));
    rows[rows.length - 1].isLastRow = true;
    return rows;
};



var $hQz0O = parcelRequire("hQz0O");

var $EHEsI = parcelRequire("EHEsI");
var $kQGD1 = parcelRequire("kQGD1");

var $afgje = parcelRequire("afgje");

var $foHRp = parcelRequire("foHRp");

var $dKmGr = parcelRequire("dKmGr");

var $7dWrG = parcelRequire("7dWrG");
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $aba72bca88e8fb79$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
var $aba72bca88e8fb79$export$2e2bcd8739ae039 = $aba72bca88e8fb79$var$baseSortBy;



var $hb0cD = parcelRequire("hb0cD");

var $1WN0o = parcelRequire("1WN0o");
/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $4e9fb044178c3f3f$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = (0, $1WN0o.default)(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = (0, $1WN0o.default)(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
var $4e9fb044178c3f3f$export$2e2bcd8739ae039 = $4e9fb044178c3f3f$var$compareAscending;


/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $81fbd8ca42830c28$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = (0, $4e9fb044178c3f3f$export$2e2bcd8739ae039)(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == "desc" ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
var $81fbd8ca42830c28$export$2e2bcd8739ae039 = $81fbd8ca42830c28$var$compareMultiple;



var $jSR8v = parcelRequire("jSR8v");

var $hf0C9 = parcelRequire("hf0C9");
/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $03f974da62a26b46$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = (0, $afgje.default)(iteratees, function(iteratee) {
        if ((0, $hf0C9.default)(iteratee)) return function(value) {
            return (0, $foHRp.default)(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        (0, $jSR8v.default)
    ];
    var index = -1;
    iteratees = (0, $afgje.default)(iteratees, (0, $hb0cD.default)((0, $dKmGr.default)));
    var result = (0, $7dWrG.default)(collection, function(value, key, collection) {
        var criteria = (0, $afgje.default)(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            "criteria": criteria,
            "index": ++index,
            "value": value
        };
    });
    return (0, $aba72bca88e8fb79$export$2e2bcd8739ae039)(result, function(object, other) {
        return (0, $81fbd8ca42830c28$export$2e2bcd8739ae039)(object, other, orders);
    });
}
var $03f974da62a26b46$export$2e2bcd8739ae039 = $03f974da62a26b46$var$baseOrderBy;



var $exqIp = parcelRequire("exqIp");

var $lvgV1 = parcelRequire("lvgV1");

var $lAOUf = parcelRequire("lAOUf");

var $cBYZY = parcelRequire("cBYZY");

var $iYDsF = parcelRequire("iYDsF");
/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $b595f01ffac528e8$var$isIterateeCall(value, index, object) {
    if (!(0, $iYDsF.default)(object)) return false;
    var type = typeof index;
    if (type == "number" ? (0, $lAOUf.default)(object) && (0, $cBYZY.default)(index, object.length) : type == "string" && index in object) return (0, $lvgV1.default)(object[index], value);
    return false;
}
var $b595f01ffac528e8$export$2e2bcd8739ae039 = $b595f01ffac528e8$var$isIterateeCall;


/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $7d000bb06f6c7a0a$var$sortBy = (0, $exqIp.default)(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && (0, $b595f01ffac528e8$export$2e2bcd8739ae039)(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && (0, $b595f01ffac528e8$export$2e2bcd8739ae039)(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return (0, $03f974da62a26b46$export$2e2bcd8739ae039)(collection, (0, $kQGD1.default)(iteratees, 1), []);
});
var $7d000bb06f6c7a0a$export$2e2bcd8739ae039 = $7d000bb06f6c7a0a$var$sortBy;



var $cstaF = parcelRequire("cstaF");

var $53A0d = parcelRequire("53A0d");


"use client";
function $6f7384520c92f99a$export$dd0a697e1782aedd(arg1, arg2, arg3) {
    const parsedOptions = (0, $f8b865b18d670cc6$export$8a11fbc2c8ea08fd)(arg1, arg2, arg3);
    return (0, $ede1b94721233a5e$export$fff0865807e996c5)(parsedOptions, (0, $d07b9a140ad50c23$export$a06cf8c0066f0d4c));
}



var $b9LXY = parcelRequire("b9LXY");

var $7AubO = parcelRequire("7AubO");

var $dDBOF = parcelRequire("dDBOF");
function $4862a4c3c2140fd6$export$4536ea3a6fa70195(enabled = true) {
    const result = (0, $6f7384520c92f99a$export$dd0a697e1782aedd)({
        queryKey: [
            "platformService"
        ],
        queryFn: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($b9LXY))).initialize({
                lwDomain: (0, $7AubO.getEndpoint)((0, $7AubO.PLATFORM_DOMAIN)),
                appId: (0, $dDBOF.appIdByAppName)[0, $dDBOF.runningApp],
                lwaOnly: true,
                luParamSupplier: ()=>(0, $7AubO.getEndpoint)((0, $7AubO.PLATFORM_LOCAL_LAUNCH)),
                logRocket: {
                    enabled: true,
                    suppressInternalUsers: false
                }
            }),
        enabled: enabled,
        staleTime: Infinity,
        cacheTime: Infinity,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        retry: 3
    });
    return result;
}


const $4b4e4bde66bae2d5$var$UniversalNavBar = (props)=>{
    const history = (0, $kfZjc.useHistory)();
    const location = (0, $kfZjc.useLocation)();
    const { userItems: userItems, helpItems: helpItems, children: children } = props;
    const [userMenuProps, setUserMenuProps] = (0, $acw62.useState)({});
    // Seeded with userItems (not []) so the menu isn't empty while platformService.
    // getNavbarUserMenuProps() is still resolving -- matches the pre-ticket behavior of
    // rendering userItems directly, for LWA users during that window.
    const [menuItems, setMenuItems] = (0, $acw62.useState)(userItems || []);
    const { selectedBreakdownOffice: selectedBreakdownOffice, resetBreakdowns: resetBreakdowns, setSelectedBreakdownTab: setSelectedBreakdownTab, setSelectedOfficeListSearch: setSelectedOfficeListSearch, timeFrameTitle: timeFrameTitle, loadedCriteriaOfficesIds: loadedCriteriaOfficesIds } = (0, $90ISC.useSearchStore)((state)=>({
            selectedBreakdownOffice: state[state.selectedModule]?.breakdowns?.selectedBreakdownOffice ?? {},
            resetBreakdowns: state.resetBreakdowns,
            selectedModule: state.selectedModule,
            setSelectedBreakdownTab: state.setSelectedBreakdownTab,
            setSelectedOfficeListSearch: state.setSelectedOfficeListSearch,
            timeFrameTitle: state[state.selectedModule]?.timeFrameTitle?.mainTitle,
            loadedCriteriaOfficesIds: state[state.selectedModule]?.loadedSearchCriteria?.realEstateDatasourceIdsWithFilters?.find((mls)=>mls.realEstateDatasourceId === state[state.selectedModule]?.selectedMls?.mlsId)?.idFiltering?.[0]?.idValues
        }));
    const { backNavbarTitle: backNavbarTitle, backLinkTitle: backLinkTitle, handleBackNavigation: handleBackNavigation, officeLists: officeLists, pendoDataLayers: pendoDataLayers, setBackLinkTitle: setBackLinkTitle, setBackNavbarTitle: setBackNavbarTitle } = (0, $90ISC.useCommonStore)((state)=>({
            backNavbarTitle: state.backNavbar.title,
            backLinkTitle: state.backNavbar.backLinkTitle,
            handleBackNavigation: state.handleBackNavigation,
            officeLists: state.officeLists,
            pendoDataLayers: state.pendoDataLayers,
            setBackLinkTitle: state.setBackLinkTitle,
            setBackNavbarTitle: state.setBackNavbarTitle
        }));
    const { selectedBreakdownPeriod: selectedBreakdownPeriod, tableView: tableView } = (0, $70q5f.useMarketDynamicsStore)((state)=>({
            tableView: state.tableView,
            selectedBreakdownPeriod: state.selectedBreakdownPeriod
        }));
    const { activeClientId: activeClientId, tokenType: tokenType, tokenInfo: tokenInfo, isLegacyUser: isLegacyUser } = (0, $f6CJ4.useAuthStore)((state)=>({
            activeClientId: state.activeClientId,
            tokenType: state.tokenType,
            tokenInfo: state.tokenInfo,
            isLegacyUser: state.isLegacyUser
        }));
    const isLWAAuthenticated = tokenType === (0, $cghEn.tokenTypes).LWA;
    const { data: platformService, isLoading: isPlatformServiceLoading } = (0, $4862a4c3c2140fd6$export$4536ea3a6fa70195)(isLWAAuthenticated);
    const currentOfficeList = officeLists?.find((list)=>(0, $EHEsI.default)((0, $7d000bb06f6c7a0a$export$2e2bcd8739ae039)(list.officeIds), (0, $7d000bb06f6c7a0a$export$2e2bcd8739ae039)(loadedCriteriaOfficesIds)));
    (0, $acw62.useEffect)(()=>{
        const checkPendoReady = ()=>{
            if (window?.pendo) window.pendo.updateOptions(pendoDataLayers);
            else setTimeout(checkPendoReady, 50);
        };
        checkPendoReady();
    }, [
        pendoDataLayers
    ]);
    (0, $acw62.useEffect)(()=>{
        setSelectedOfficeListSearch(currentOfficeList);
        const officesListNavTitle = currentOfficeList?.name || (0, $hQz0O.terms).selectedOffices;
        const breakdownNavbarTitle = (0, $1fa46cf08ea2571a$export$4cf4f9869242a323)(window.location.pathname) ? officesListNavTitle : selectedBreakdownOffice?.name;
        const backBtnTitle = location.state?.fromOfficeBreakdownAndGrowthTab && (0, $hQz0O.terms).officeBreakdownAndGrowth;
        const config = (0, $18f2156a0a365b8a$export$799cac59bce08f6)({
            route: location.pathname,
            title: (0, $18f2156a0a365b8a$export$9b0e41b6f651db4b).includes(location.pathname) ? timeFrameTitle : breakdownNavbarTitle,
            backBtnTitle: backBtnTitle
        });
        if (!config) return;
        setBackLinkTitle(config.backLinkTitle);
        const title = config.getBackNavbarTitle({
            period: selectedBreakdownPeriod,
            tableView: tableView
        });
        if (title) setBackNavbarTitle(title);
    }, [
        location.pathname,
        timeFrameTitle,
        selectedBreakdownOffice?.name,
        currentOfficeList
    ]);
    const handleBackBtn = ()=>{
        if (location.state?.fromOfficeBreakdownAndGrowthTab) {
            handleBackNavigation(location.pathname, history, (0, $cstaF.searchRoutes).officeListBreakdown);
            setSelectedBreakdownTab((0, $53A0d.OFFICE_BRKDWN_GROWTH_TAB_INDEX));
            return;
        }
        handleBackNavigation(location.pathname, history);
        resetBreakdowns();
    };
    const showBackNavBar = (0, $7D4kr.routesToShowBackNavBar).includes(window.location.pathname);
    // App.js builds userItems inline on every render (a fresh array/onClick closures each
    // time), so depending on the array itself would re-run this effect -- and re-hit
    // platformService.getNavbarUserMenuProps() -- on every App re-render. Depend on the
    // labels instead; the effect body below still uses the current userItems value.
    const userItemLabels = userItems?.map((item)=>item.label).join("|");
    (0, $acw62.useEffect)(()=>{
        let cancelled = false;
        // The platform service builds the universal Sign Out item (and Manage Account) for
        // LWA users when there's an active token, then appends our own custom items after it.
        (0, $c8257d18c4a1050f$export$bffb664247d74229)({
            isLegacyUser: isLegacyUser,
            tokenInfo: tokenInfo,
            platformService: platformService,
            userItems: userItems
        }).then((result)=>{
            if (cancelled) return;
            if (result) {
                setUserMenuProps(result.userMenuProps);
                setMenuItems(result.menuItems);
                return;
            }
            // menuItems falls back to userItems (e.g. "My Profile") rather than leaving the
            // menu empty -- that has clear precedent, the pre-ticket code always rendered
            // userItems directly. userMenuProps is left alone here: unlike menuItems, it
            // never had a userItems-based fallback before this ticket, and tokenInfo (the raw
            // decoded JWT) isn't guaranteed to match the shape platformService's own resolved
            // user object has, which is what NavbarUserMenu actually expects for LWA users.
            setMenuItems(userItems || []);
        });
        return ()=>{
            cancelled = true;
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps -- userItemLabels stands in for userItems, see comment above
    }, [
        isLegacyUser,
        tokenInfo,
        platformService,
        userItemLabels
    ]);
    const BackNavBar = ()=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2ad24e75a96deccc$export$42cfbb80f7861e77), {
            dataLwtId: "xbmNav",
            location: location,
            hideLogo: true,
            environment: (0, $7AubO.runningEnv)?.toLocaleLowerCase(),
            platformService: platformService,
            ...(0, $dDBOF.isAgentMetrics) && {
                activeClientId: activeClientId
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2ad24e75a96deccc$export$7fc3f68d5abe597e), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2ad24e75a96deccc$export$fb616c67fe64a6b), {
                        onClick: handleBackBtn,
                        icon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                            className: "header-back-button",
                            icon: (0, $eOjgM.chevron_left)
                        }),
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "helix-brand-color",
                            children: backLinkTitle
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2ad24e75a96deccc$export$7fc3f68d5abe597e), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "helix-body--strong",
                        children: backNavbarTitle
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2ad24e75a96deccc$export$eb9291b5cfed8fe1), {
                    className: "navbar-additonal-items",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2ad24e75a96deccc$export$7012db33ae0df864), {
                            menuItems: helpItems || [],
                            hideHelpHeader: "true"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2ad24e75a96deccc$export$927225dd45e68b72), {
                            menuItems: menuItems,
                            user: userMenuProps
                        })
                    ]
                })
            ]
        });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $847bf9dc758b6d61$export$fb39bcb53ef4b84d), {
        activeClientId: activeClientId || undefined,
        environment: (0, $7AubO.runningEnv)?.toLowerCase() || "dev",
        applicationCode: (0, $dDBOF.appIdByAppName)[0, $dDBOF.runningApp] || "xbm",
        platformService: !isLegacyUser ? platformService : undefined,
        useMockData: false,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: `helix-d-flex helix-flex-direction--column${isLegacyUser ? " legacy-layout" : ""}`,
            style: {
                height: "100vh"
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    id: "helix-application-header",
                    style: {
                        position: "relative",
                        flexShrink: 0,
                        zIndex: 2
                    },
                    children: showBackNavBar ? /*#__PURE__*/ (0, $ayMG0.jsx)(BackNavBar, {}) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2ad24e75a96deccc$export$42cfbb80f7861e77), {
                        dataLwtId: "xbmNav",
                        applicationCode: (0, $dDBOF.appIdByAppName)[0, $dDBOF.runningApp],
                        applicationName: (0, $1db408ae6f3392f7$export$cbeeb6000269f21c)[0, $dDBOF.runningApp]?.headerLabel,
                        environment: (0, $7AubO.runningEnv)?.toLocaleLowerCase() || "dev",
                        platformService: platformService,
                        style: {
                            width: "100%"
                        },
                        children: [
                            platformService && !isPlatformServiceLoading && isLWAAuthenticated && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2ad24e75a96deccc$export$b9df65f7f957b5de), {
                                platformService: platformService
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $2ad24e75a96deccc$export$eb9291b5cfed8fe1), {
                                className: "navbar-additonal-items",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2ad24e75a96deccc$export$7012db33ae0df864), {
                                        menuItems: helpItems || [],
                                        hideHelpHeader: "true"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2ad24e75a96deccc$export$927225dd45e68b72), {
                                        menuItems: menuItems,
                                        user: userMenuProps
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "helix-flex-1 helix-d-flex helix-overflow--hidden",
                    children: children
                })
            ]
        })
    });
};
$4b4e4bde66bae2d5$var$UniversalNavBar.propTypes = {
    userItems: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    helpItems: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node
};
var $4b4e4bde66bae2d5$export$2e2bcd8739ae039 = $4b4e4bde66bae2d5$var$UniversalNavBar;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $kfZjc = parcelRequire("kfZjc");


var $dI25G = parcelRequire("dI25G");

var $eOjgM = parcelRequire("eOjgM");

var $7D4kr = parcelRequire("7D4kr");

var $cstaF = parcelRequire("cstaF");

var $90ISC = parcelRequire("90ISC");
// The ApplicationLayout wraps the entire application with the Helix Sidebar Navigation,
// it provides the navigation structure for both XBM and XAM users.
const $ffd7ca5b192a402e$var$ApplicationLayout = ({ children: children, navItems: navItems })=>{
    const location = (0, $kfZjc.useLocation)();
    const [sidebarNavItems, setSidebarNavItems] = (0, $acw62.useState)([]);
    const sidebarContainerRef = (0, $acw62.useRef)(null);
    const selectedModule = (0, $90ISC.useSearchStore)((state)=>state.selectedModule);
    const setIsSideNavExpanded = (0, $90ISC.useCommonStore)((state)=>state.setIsSideNavExpanded);
    (0, $acw62.useEffect)(()=>{
        const container = sidebarContainerRef.current;
        if (!container) return;
        const observer = new MutationObserver(()=>{
            const navContainer = container.querySelector('[class*="sidebar-nav-container"]');
            if (!navContainer) return;
            const isCollapsed = [
                ...navContainer.classList
            ].some((c)=>c.includes("collapsed"));
            setIsSideNavExpanded(!isCollapsed);
        });
        observer.observe(container, {
            subtree: true,
            attributes: true,
            attributeFilter: [
                "class"
            ]
        });
        return ()=>observer.disconnect();
    }, []);
    const shouldShowNavBar = !(0, $7D4kr.routesToHideNavBar).includes(location.pathname);
    // Convert nav items to sidebar nav items format, flatten all items with headers and indentation.
    (0, $acw62.useEffect)(()=>{
        if (!navItems) return;
        const convertedItems = [];
        const excludeHeaders = [
            "Dashboard",
            "Agent Production"
        ];
        navItems.forEach((item, index)=>{
            if (!item) return;
            // Add the section header only if not excluded
            if (!excludeHeaders.includes(item.label)) convertedItems.push({
                id: `header-${index}`,
                text: item.label,
                isHeader: true
            });
            if (item.menuItems) // Add all children with their indentation
            item.menuItems.forEach((menuItem, menuIndex)=>{
                if (!menuItem.header) // Regular menu items
                convertedItems.push({
                    id: `item-${index}-${menuIndex}`,
                    text: menuItem.label,
                    onClick: menuItem.onClick,
                    url: menuItem.url,
                    target: menuItem.target,
                    active: location.pathname === menuItem.activePathname || (0, $cstaF.moduleRoutes)[selectedModule] === menuItem.activePathname,
                    isChild: !excludeHeaders.includes(item.label)
                });
            });
            else // Single nav item, add as child under its own header (if header was added)
            convertedItems.push({
                id: `item-${index}`,
                text: item.label,
                onClick: item.onClick,
                active: location.pathname === item.activePathname || (0, $cstaF.moduleRoutes)[selectedModule] === item.activePathname,
                isChild: !excludeHeaders.includes(item.label)
            });
        });
        setSidebarNavItems(convertedItems);
    }, [
        navItems,
        location.pathname,
        selectedModule
    ]);
    if (!shouldShowNavBar) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: children ?? null
    });
    const renderSideNavSectionHeader = (item)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "sidebar-nav-section-header helix-text--sm helix-text--bold helix-text--uppercase",
            style: {
                marginTop: "10px"
            },
            children: item.text
        }, item.id);
    const renderSideNavItem = (item)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $847bf9dc758b6d61$export$1e8e95432f1f72fa), {
            active: item.active,
            className: item.isChild ? "sidebar-nav-child-item" : "",
            children: item.url ? /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                href: item.url,
                target: item.target,
                rel: "noopener noreferrer",
                className: "sidebar-nav-external-link",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: item.text
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                        icon: (0, $eOjgM.launch),
                        className: "sidebar-nav-external-link-icon"
                    })
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                href: "#",
                onClick: (e)=>{
                    e.preventDefault();
                    item.onClick && item.onClick();
                },
                children: item.text
            })
        }, item.id);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "helix-d-flex helix-flex-1 helix-overflow--hidden",
        children: [
            sidebarNavItems.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "sidebar-container",
                ref: sidebarContainerRef,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $847bf9dc758b6d61$export$6c4845e528748967), {
                    children: sidebarNavItems.map((item)=>{
                        return item.isHeader ? renderSideNavSectionHeader(item) : renderSideNavItem(item);
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "helix-flex-1 helix-d-flex helix-flex-direction--column helix-overflow--auto application-content",
                children: children ?? null
            })
        ]
    });
};
$ffd7ca5b192a402e$var$ApplicationLayout.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    navItems: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array
};
var $ffd7ca5b192a402e$export$2e2bcd8739ae039 = $ffd7ca5b192a402e$var$ApplicationLayout;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $kfZjc = parcelRequire("kfZjc");
var $3ecb7368762fc268$exports = {};

$parcel$export($3ecb7368762fc268$exports, "extract", () => $3ecb7368762fc268$export$f9380c9a627682d3, (v) => $3ecb7368762fc268$export$f9380c9a627682d3 = v);
$parcel$export($3ecb7368762fc268$exports, "parse", () => $3ecb7368762fc268$export$98e6a39c04603d36, (v) => $3ecb7368762fc268$export$98e6a39c04603d36 = v);
$parcel$export($3ecb7368762fc268$exports, "stringify", () => $3ecb7368762fc268$export$fac44ee5b035f737, (v) => $3ecb7368762fc268$export$fac44ee5b035f737 = v);
$parcel$export($3ecb7368762fc268$exports, "parseUrl", () => $3ecb7368762fc268$export$7a5253c0f62e0150, (v) => $3ecb7368762fc268$export$7a5253c0f62e0150 = v);
$parcel$export($3ecb7368762fc268$exports, "stringifyUrl", () => $3ecb7368762fc268$export$a8c1621ea79325d3, (v) => $3ecb7368762fc268$export$a8c1621ea79325d3 = v);
$parcel$export($3ecb7368762fc268$exports, "pick", () => $3ecb7368762fc268$export$357523c63a2253b9, (v) => $3ecb7368762fc268$export$357523c63a2253b9 = v);
$parcel$export($3ecb7368762fc268$exports, "exclude", () => $3ecb7368762fc268$export$44c361b8ec72ef7f, (v) => $3ecb7368762fc268$export$44c361b8ec72ef7f = v);
var $3ecb7368762fc268$export$f9380c9a627682d3;
var $3ecb7368762fc268$export$98e6a39c04603d36;
var $3ecb7368762fc268$export$fac44ee5b035f737;
var $3ecb7368762fc268$export$7a5253c0f62e0150;
var $3ecb7368762fc268$export$a8c1621ea79325d3;
var $3ecb7368762fc268$export$357523c63a2253b9;
var $3ecb7368762fc268$export$44c361b8ec72ef7f;
"use strict";
var $2854ab6fe5249e91$exports = {};
"use strict";
$2854ab6fe5249e91$exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);


var $40bbc24beab9f9b8$exports = {};
"use strict";
var $40bbc24beab9f9b8$var$token = "%[a-f0-9]{2}";
var $40bbc24beab9f9b8$var$singleMatcher = new RegExp("(" + $40bbc24beab9f9b8$var$token + ")|([^%]+?)", "gi");
var $40bbc24beab9f9b8$var$multiMatcher = new RegExp("(" + $40bbc24beab9f9b8$var$token + ")+", "gi");
function $40bbc24beab9f9b8$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(""))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $40bbc24beab9f9b8$var$decodeComponents(left), $40bbc24beab9f9b8$var$decodeComponents(right));
}
function $40bbc24beab9f9b8$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($40bbc24beab9f9b8$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $40bbc24beab9f9b8$var$decodeComponents(tokens, i).join("");
            tokens = input.match($40bbc24beab9f9b8$var$singleMatcher) || [];
        }
        return input;
    }
}
function $40bbc24beab9f9b8$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        "%FE%FF": "\uFFFD\uFFFD",
        "%FF%FE": "\uFFFD\uFFFD"
    };
    var match = $40bbc24beab9f9b8$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $40bbc24beab9f9b8$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $40bbc24beab9f9b8$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap["%C2"] = "\uFFFD";
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, "g"), replaceMap[key]);
    }
    return input;
}
$40bbc24beab9f9b8$exports = function(encodedURI) {
    if (typeof encodedURI !== "string") throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof encodedURI + "`");
    try {
        encodedURI = encodedURI.replace(/\+/g, " ");
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $40bbc24beab9f9b8$var$customDecodeURIComponent(encodedURI);
    }
};


var $08bd16383ca1ef3d$exports = {};
"use strict";
$08bd16383ca1ef3d$exports = (string, separator)=>{
    if (!(typeof string === "string" && typeof separator === "string")) throw new TypeError("Expected the arguments to be of type `string`");
    if (separator === "") return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};


var $36fe9d1ef26e3f64$exports = {};
"use strict";
$36fe9d1ef26e3f64$exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};


const $3ecb7368762fc268$var$isNullOrUndefined = (value)=>value === null || value === undefined;
const $3ecb7368762fc268$var$encodeFragmentIdentifier = Symbol("encodeFragmentIdentifier");
function $3ecb7368762fc268$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case "index":
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $3ecb7368762fc268$var$encode(key, options),
                            "[",
                            index,
                            "]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $3ecb7368762fc268$var$encode(key, options),
                            "[",
                            $3ecb7368762fc268$var$encode(index, options),
                            "]=",
                            $3ecb7368762fc268$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "bracket":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $3ecb7368762fc268$var$encode(key, options),
                            "[]"
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $3ecb7368762fc268$var$encode(key, options),
                            "[]=",
                            $3ecb7368762fc268$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "colon-list-separator":
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        [
                            $3ecb7368762fc268$var$encode(key, options),
                            ":list="
                        ].join("")
                    ];
                    return [
                        ...result,
                        [
                            $3ecb7368762fc268$var$encode(key, options),
                            ":list=",
                            $3ecb7368762fc268$var$encode(value, options)
                        ].join("")
                    ];
                };
        case "comma":
        case "separator":
        case "bracket-separator":
            {
                const keyValueSep = options.arrayFormat === "bracket-separator" ? "[]=" : "=";
                return (key)=>(result, value)=>{
                        if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                        // Translate null to an empty string so that it doesn't serialize as 'null'
                        value = value === null ? "" : value;
                        if (result.length === 0) return [
                            [
                                $3ecb7368762fc268$var$encode(key, options),
                                keyValueSep,
                                $3ecb7368762fc268$var$encode(value, options)
                            ].join("")
                        ];
                        return [
                            [
                                result,
                                $3ecb7368762fc268$var$encode(value, options)
                            ].join(options.arrayFormatSeparator)
                        ];
                    };
            }
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === "") return result;
                    if (value === null) return [
                        ...result,
                        $3ecb7368762fc268$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $3ecb7368762fc268$var$encode(key, options),
                            "=",
                            $3ecb7368762fc268$var$encode(value, options)
                        ].join("")
                    ];
                };
    }
}
function $3ecb7368762fc268$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case "index":
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case "bracket":
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "colon-list-separator":
            return (key, value, accumulator)=>{
                result = /(:list)$/.exec(key);
                key = key.replace(/:list$/, "");
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case "comma":
        case "separator":
            return (key, value, accumulator)=>{
                const isArray = typeof value === "string" && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === "string" && !isArray && $3ecb7368762fc268$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $3ecb7368762fc268$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$3ecb7368762fc268$var$decode(item, options)) : value === null ? value : $3ecb7368762fc268$var$decode(value, options);
                accumulator[key] = newValue;
            };
        case "bracket-separator":
            return (key, value, accumulator)=>{
                const isArray = /(\[\])$/.test(key);
                key = key.replace(/\[\]$/, "");
                if (!isArray) {
                    accumulator[key] = value ? $3ecb7368762fc268$var$decode(value, options) : value;
                    return;
                }
                const arrayValue = value === null ? [] : value.split(options.arrayFormatSeparator).map((item)=>$3ecb7368762fc268$var$decode(item, options));
                if (accumulator[key] === undefined) {
                    accumulator[key] = arrayValue;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], arrayValue);
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $3ecb7368762fc268$var$validateArrayFormatSeparator(value) {
    if (typeof value !== "string" || value.length !== 1) throw new TypeError("arrayFormatSeparator must be single character string");
}
function $3ecb7368762fc268$var$encode(value, options) {
    if (options.encode) return options.strict ? $2854ab6fe5249e91$exports(value) : encodeURIComponent(value);
    return value;
}
function $3ecb7368762fc268$var$decode(value, options) {
    if (options.decode) return $40bbc24beab9f9b8$exports(value);
    return value;
}
function $3ecb7368762fc268$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === "object") return $3ecb7368762fc268$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $3ecb7368762fc268$var$removeHash(input) {
    const hashStart = input.indexOf("#");
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $3ecb7368762fc268$var$getHash(url) {
    let hash = "";
    const hashStart = url.indexOf("#");
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $3ecb7368762fc268$var$extract(input) {
    input = $3ecb7368762fc268$var$removeHash(input);
    const queryStart = input.indexOf("?");
    if (queryStart === -1) return "";
    return input.slice(queryStart + 1);
}
function $3ecb7368762fc268$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === "string" && value.trim() !== "") value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === "true" || value.toLowerCase() === "false")) value = value.toLowerCase() === "true";
    return value;
}
function $3ecb7368762fc268$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: "none",
        arrayFormatSeparator: ",",
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $3ecb7368762fc268$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $3ecb7368762fc268$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== "string") return ret;
    query = query.trim().replace(/^[?#&]/, "");
    if (!query) return ret;
    for (const param of query.split("&")){
        if (param === "") continue;
        let [key, value] = $08bd16383ca1ef3d$exports(options.decode ? param.replace(/\+/g, " ") : param, "=");
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            "comma",
            "separator",
            "bracket-separator"
        ].includes(options.arrayFormat) ? value : $3ecb7368762fc268$var$decode(value, options);
        formatter($3ecb7368762fc268$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === "object" && value !== null) for (const k of Object.keys(value))value[k] = $3ecb7368762fc268$var$parseValue(value[k], options);
        else ret[key] = $3ecb7368762fc268$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === "object" && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $3ecb7368762fc268$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$3ecb7368762fc268$export$f9380c9a627682d3 = $3ecb7368762fc268$var$extract;
$3ecb7368762fc268$export$98e6a39c04603d36 = $3ecb7368762fc268$var$parse;
$3ecb7368762fc268$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return "";
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: "none",
        arrayFormatSeparator: ","
    }, options);
    $3ecb7368762fc268$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $3ecb7368762fc268$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === "";
    const formatter = $3ecb7368762fc268$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return "";
        if (value === null) return $3ecb7368762fc268$var$encode(key, options);
        if (Array.isArray(value)) {
            if (value.length === 0 && options.arrayFormat === "bracket-separator") return $3ecb7368762fc268$var$encode(key, options) + "[]";
            return value.reduce(formatter(key), []).join("&");
        }
        return $3ecb7368762fc268$var$encode(key, options) + "=" + $3ecb7368762fc268$var$encode(value, options);
    }).filter((x)=>x.length > 0).join("&");
};
$3ecb7368762fc268$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $08bd16383ca1ef3d$exports(url, "#");
    return Object.assign({
        url: url_.split("?")[0] || "",
        query: $3ecb7368762fc268$var$parse($3ecb7368762fc268$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $3ecb7368762fc268$var$decode(hash, options)
    } : {});
};
$3ecb7368762fc268$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true,
        [$3ecb7368762fc268$var$encodeFragmentIdentifier]: true
    }, options);
    const url = $3ecb7368762fc268$var$removeHash(object.url).split("?")[0] || "";
    const queryFromUrl = $3ecb7368762fc268$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $3ecb7368762fc268$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $3ecb7368762fc268$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $3ecb7368762fc268$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${options[$3ecb7368762fc268$var$encodeFragmentIdentifier] ? $3ecb7368762fc268$var$encode(object.fragmentIdentifier, options) : object.fragmentIdentifier}`;
    return `${url}${queryString}${hash}`;
};
$3ecb7368762fc268$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true,
        [$3ecb7368762fc268$var$encodeFragmentIdentifier]: false
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $3ecb7368762fc268$export$7a5253c0f62e0150(input, options);
    return $3ecb7368762fc268$export$a8c1621ea79325d3({
        url: url,
        query: $36fe9d1ef26e3f64$exports(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$3ecb7368762fc268$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $3ecb7368762fc268$export$357523c63a2253b9(input, exclusionFilter, options);
};


var $b385e67aba3a5e43$exports = {};
"use strict";
var $b385e67aba3a5e43$var$__createBinding = $b385e67aba3a5e43$exports && $b385e67aba3a5e43$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b385e67aba3a5e43$var$__setModuleDefault = $b385e67aba3a5e43$exports && $b385e67aba3a5e43$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $b385e67aba3a5e43$var$__importStar = $b385e67aba3a5e43$exports && $b385e67aba3a5e43$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $b385e67aba3a5e43$var$__createBinding(result, mod, k);
    }
    $b385e67aba3a5e43$var$__setModuleDefault(result, mod);
    return result;
};
var $b385e67aba3a5e43$var$__importDefault = $b385e67aba3a5e43$exports && $b385e67aba3a5e43$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($b385e67aba3a5e43$exports, "__esModule", {
    value: true
});

const $b385e67aba3a5e43$var$react_1 = $b385e67aba3a5e43$var$__importStar((parcelRequire("acw62")));

var $7oK46 = parcelRequire("7oK46");
var $8WMG5 = parcelRequire("8WMG5");
var $8nd05 = parcelRequire("8nd05");

var $g7ajw = parcelRequire("g7ajw");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $acw62 = parcelRequire("acw62");
var $8309cc2c57bc36c2$export$5a5d356ca5f10a0a = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({});



var $e9hDx = parcelRequire("e9hDx");
var $1a8a5fcf8877efe0$var$propTypes = {
    tag: (0, $e9hDx.tagPropType),
    activeTab: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $1a8a5fcf8877efe0$var$defaultProps = {
    tag: "div"
};
var $1a8a5fcf8877efe0$var$TabContent = /*#__PURE__*/ function(_Component) {
    (0, $g7ajw.default)(TabContent, _Component);
    TabContent.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.activeTab !== nextProps.activeTab) return {
            activeTab: nextProps.activeTab
        };
        return null;
    };
    function TabContent(props) {
        var _this;
        _this = _Component.call(this, props) || this;
        _this.state = {
            activeTab: _this.props.activeTab
        };
        return _this;
    }
    var _proto = TabContent.prototype;
    _proto.render = function render() {
        var _this$props = this.props, className = _this$props.className, cssModule = _this$props.cssModule, Tag = _this$props.tag;
        var attributes = (0, $e9hDx.omit)(this.props, Object.keys($1a8a5fcf8877efe0$var$propTypes));
        var classes = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("tab-content", className), cssModule);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8309cc2c57bc36c2$export$5a5d356ca5f10a0a).Provider, {
            value: {
                activeTabId: this.state.activeTab
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({}, attributes, {
            className: classes
        })));
    };
    return TabContent;
}((0, $acw62.Component));
var $1a8a5fcf8877efe0$export$2e2bcd8739ae039 = $1a8a5fcf8877efe0$var$TabContent;
$1a8a5fcf8877efe0$var$TabContent.propTypes = $1a8a5fcf8877efe0$var$propTypes;
$1a8a5fcf8877efe0$var$TabContent.defaultProps = $1a8a5fcf8877efe0$var$defaultProps;


var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");


var $e9hDx = parcelRequire("e9hDx");
var $03c0b09bde5a227c$var$propTypes = {
    tag: (0, $e9hDx.tagPropType),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    tabId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any
};
var $03c0b09bde5a227c$var$defaultProps = {
    tag: "div"
};
function $03c0b09bde5a227c$export$2e2bcd8739ae039(props) {
    var className = props.className, cssModule = props.cssModule, tabId = props.tabId, Tag = props.tag, attributes = (0, $1En50.default)(props, [
        "className",
        "cssModule",
        "tabId",
        "tag"
    ]);
    var getClasses = function getClasses(activeTabId) {
        return (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))("tab-pane", className, {
            active: tabId === activeTabId
        }), cssModule);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $8309cc2c57bc36c2$export$5a5d356ca5f10a0a).Consumer, null, function(_ref) {
        var activeTabId = _ref.activeTabId;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({}, attributes, {
            className: getClasses(activeTabId)
        }));
    });
}
$03c0b09bde5a227c$export$2e2bcd8739ae039.propTypes = $03c0b09bde5a227c$var$propTypes;
$03c0b09bde5a227c$export$2e2bcd8739ae039.defaultProps = $03c0b09bde5a227c$var$defaultProps;



const $b385e67aba3a5e43$var$nav_1 = $b385e67aba3a5e43$var$__importDefault((parcelRequire("g1G2y")));

const $b385e67aba3a5e43$var$card_1 = $b385e67aba3a5e43$var$__importDefault((parcelRequire("7hEbZ")));

const $b385e67aba3a5e43$var$classnames_1 = $b385e67aba3a5e43$var$__importDefault((parcelRequire("8g1PZ")));
const $b385e67aba3a5e43$var$Tab = (props)=>{
    const { items: items, className: className, currentIndex: currentIndex, vertical: vertical, navSize: navSize, contentSize: contentSize, setCurrentIndex: setCurrentIndex, dataLwtId: dataLwtId, cardProps: cardProps, card: card, ...attributes } = props;
    const [activeTab, setActiveTab] = (0, $b385e67aba3a5e43$var$react_1.useState)(currentIndex);
    const tabs = [];
    const panes = [];
    const toggle = (index = 0)=>{
        if (activeTab !== index) {
            setCurrentIndex && setCurrentIndex(index);
            setActiveTab(index);
        }
    };
    (0, $b385e67aba3a5e43$var$react_1.useEffect)(()=>{
        let didCancel = false;
        if (!didCancel && currentIndex !== activeTab) toggle(currentIndex);
        return ()=>{
            didCancel = true;
        };
    }, [
        currentIndex
    ]);
    const navSizeClass = vertical ? `col-${navSize}` : "";
    const paneSizeClass = vertical ? `col-${contentSize}` : "";
    items.forEach((item, index)=>{
        tabs.push($b385e67aba3a5e43$var$react_1.default.createElement($7oK46.default, {
            key: index
        }, $b385e67aba3a5e43$var$react_1.default.createElement($8WMG5.default, {
            href: "#",
            className: (0, $b385e67aba3a5e43$var$classnames_1.default)({
                active: activeTab === index
            }),
            onClick: ()=>{
                toggle(index);
            }
        }, item.title)));
        panes.push($b385e67aba3a5e43$var$react_1.default.createElement($03c0b09bde5a227c$export$2e2bcd8739ae039, {
            className: (0, $b385e67aba3a5e43$var$classnames_1.default)("tab-pane", item.content.className || ""),
            tabId: index,
            key: index
        }, item.content.jsx));
    });
    let tmpCardProps = cardProps;
    if (card) {
        if (!tmpCardProps) tmpCardProps = {};
        if (!tmpCardProps.headerProps) tmpCardProps.headerProps = {
            dataLwtId: `card-header-${dataLwtId}`
        };
        tmpCardProps.headerProps.children = $b385e67aba3a5e43$var$react_1.default.createElement("div", {
            className: navSizeClass
        }, $b385e67aba3a5e43$var$react_1.default.createElement($b385e67aba3a5e43$var$nav_1.default, {
            ...attributes,
            className: className,
            card: true,
            vertical: vertical,
            tag: "ul"
        }, tabs));
        tmpCardProps.headerProps.bodyProps = {
            children: $b385e67aba3a5e43$var$react_1.default.createElement("div", {
                className: paneSizeClass
            }, $b385e67aba3a5e43$var$react_1.default.createElement($1a8a5fcf8877efe0$export$2e2bcd8739ae039, {
                activeTab: activeTab
            }, panes))
        };
    }
    return $b385e67aba3a5e43$var$react_1.default.createElement($b385e67aba3a5e43$var$react_1.default.Fragment, null, $b385e67aba3a5e43$var$react_1.default.createElement("div", {
        className: vertical ? "row" : "",
        "data-lwt-id": dataLwtId
    }, card && $b385e67aba3a5e43$var$react_1.default.createElement($b385e67aba3a5e43$var$card_1.default, {
        ...tmpCardProps
    }), !card && $b385e67aba3a5e43$var$react_1.default.createElement($b385e67aba3a5e43$var$react_1.default.Fragment, null, $b385e67aba3a5e43$var$react_1.default.createElement("div", {
        className: navSizeClass
    }, $b385e67aba3a5e43$var$react_1.default.createElement($b385e67aba3a5e43$var$nav_1.default, {
        ...attributes,
        className: className,
        vertical: vertical,
        tag: "ul"
    }, tabs)), $b385e67aba3a5e43$var$react_1.default.createElement("div", {
        className: paneSizeClass
    }, $b385e67aba3a5e43$var$react_1.default.createElement($1a8a5fcf8877efe0$export$2e2bcd8739ae039, {
        activeTab: activeTab
    }, panes)))));
};
$b385e67aba3a5e43$var$Tab.defaultProps = {
    currentIndex: 0,
    navSize: 3,
    contentSize: 9
};
$b385e67aba3a5e43$exports.default = $b385e67aba3a5e43$var$Tab;


var $8f390b0d641c1be9$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($b385e67aba3a5e43$exports)));



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
var $4177e0bd3f905432$exports = {};
"use strict";
var $4177e0bd3f905432$var$__createBinding = $4177e0bd3f905432$exports && $4177e0bd3f905432$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $4177e0bd3f905432$var$__setModuleDefault = $4177e0bd3f905432$exports && $4177e0bd3f905432$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $4177e0bd3f905432$var$__importStar = $4177e0bd3f905432$exports && $4177e0bd3f905432$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $4177e0bd3f905432$var$__createBinding(result, mod, k);
    }
    $4177e0bd3f905432$var$__setModuleDefault(result, mod);
    return result;
};
var $4177e0bd3f905432$var$__importDefault = $4177e0bd3f905432$exports && $4177e0bd3f905432$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($4177e0bd3f905432$exports, "__esModule", {
    value: true
});

/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable no-prototype-builtins */ const $4177e0bd3f905432$var$react_1 = $4177e0bd3f905432$var$__importStar((parcelRequire("acw62")));

const $4177e0bd3f905432$var$core_1 = $4177e0bd3f905432$var$__importStar((parcelRequire("1royG")));

const $4177e0bd3f905432$var$immutability_helper_1 = $4177e0bd3f905432$var$__importDefault((parcelRequire("428tW")));

var $jWEnY = parcelRequire("jWEnY");

const $4177e0bd3f905432$var$RowField_1 = $4177e0bd3f905432$var$__importDefault((parcelRequire("dTdPZ")));

const $4177e0bd3f905432$var$Field_1 = $4177e0bd3f905432$var$__importDefault((parcelRequire("kKOgc")));

const $4177e0bd3f905432$var$TitleField_1 = $4177e0bd3f905432$var$__importDefault((parcelRequire("1UlbJ")));

const $4177e0bd3f905432$var$ArrayField_1 = $4177e0bd3f905432$var$__importDefault((parcelRequire("h9179")));

const $4177e0bd3f905432$var$SchemaField_1 = $4177e0bd3f905432$var$__importDefault((parcelRequire("76zRy")));

const $4177e0bd3f905432$var$BaseInput_1 = $4177e0bd3f905432$var$__importDefault((parcelRequire("8n5Wo")));

const $4177e0bd3f905432$var$CustomInput_1 = $4177e0bd3f905432$var$__importDefault((parcelRequire("doAVW")));

const $4177e0bd3f905432$var$SearchField_1 = $4177e0bd3f905432$var$__importDefault((parcelRequire("86V0K")));

const $4177e0bd3f905432$var$Radio_1 = $4177e0bd3f905432$var$__importDefault((parcelRequire("5yshQ")));

const $4177e0bd3f905432$var$DatePicker_1 = $4177e0bd3f905432$var$__importDefault((parcelRequire("dNig3")));
const $4177e0bd3f905432$var$formFields = {
    TitleField: $4177e0bd3f905432$var$TitleField_1.default,
    SchemaField: $4177e0bd3f905432$var$SchemaField_1.default,
    row: $4177e0bd3f905432$var$RowField_1.default
};
const $4177e0bd3f905432$var$widgets = {
    BaseInput: $4177e0bd3f905432$var$BaseInput_1.default,
    CustomInput: $4177e0bd3f905432$var$CustomInput_1.default,
    CustomSearchField: $4177e0bd3f905432$var$SearchField_1.default,
    CustomRadio: $4177e0bd3f905432$var$Radio_1.default,
    CustomDatePicker: $4177e0bd3f905432$var$DatePicker_1.default
};
class $4177e0bd3f905432$var$BaseForm extends $4177e0bd3f905432$var$react_1.Component {
    constructor(props){
        super(props);
        const rowified = (0, $jWEnY.rowify)(props.schema, props.uiSchema || {}, props.formData);
        this.state = {
            schema: rowified.schema,
            uiSchema: rowified.uiSchema,
            formData: rowified.formData
        };
        this.validate = this.validate.bind(this);
        this.transformErrors = this.transformErrors.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onError = this.onError.bind(this);
        this.toggleEditing = this.toggleEditing.bind(this);
        this.autofill = this.autofill.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.onFocus = this.onFocus.bind(this);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        const rowified = (0, $jWEnY.rowify)(nextProps.schema, nextProps.uiSchema || {}, nextProps.formData);
        this.setState((prevState)=>Object.assign(Object.assign(Object.assign({}, prevState), rowified), {
                formContext: !nextProps.hasOwnProperty("readMode") ? prevState.formContext : (0, $4177e0bd3f905432$var$immutability_helper_1.default)(prevState.formContext, {
                    readMode: {
                        $set: nextProps.readMode
                    }
                })
            }));
    }
    componentDidMount() {
        const { hideValidationMessages: hideValidationMessages = false } = Object.assign({}, $4177e0bd3f905432$var$core_1.utils.getUiOptions(this.props.uiSchema || {}));
        this.setState((prevState)=>Object.assign(Object.assign({}, prevState), {
                formContext: {
                    readMode: this.props.readMode,
                    editing: [],
                    toggleEditing: this.toggleEditing,
                    autofill: this.autofill,
                    searchFieldMap: this.props.searchFieldMap,
                    hideValidationMessages: hideValidationMessages
                }
            }));
    }
    autofill(id, fields) {
        const tokens = id.split("_");
        // remove root
        tokens.splice(0, 1);
        // remove widget leaf level and row level
        tokens.pop();
        tokens.pop();
        let formData = this.state.formData;
        let widgetData;
        // build widget data so that it only contains the formData of the widget being autofilled
        // this will only include the widget row level and the leaf level
        // it will make it easy to find properties (leaf nodes) to update on any row of the widget
        tokens.forEach((token)=>{
            widgetData = widgetData ? widgetData[token] : formData[token];
        });
        const updateFormData = (key)=>{
            // find what row of the widget the property (leaf nodes) to update belongs to
            Object.keys(widgetData).some((level1)=>{
                if (widgetData[level1].hasOwnProperty(key)) {
                    tokens.push(level1);
                    tokens.push(key);
                    return true;
                }
                return false;
            });
            // at this point, tokens contains the full path to the property to be updated
            // so we use that to build the spec for the immutability-helper update function
            const spec = tokens.reduceRight((accumulator, token)=>({
                    [token]: accumulator
                }), {
                $set: fields[key]
            });
            formData = (0, $4177e0bd3f905432$var$immutability_helper_1.default)(formData, spec);
            // remove the widget path to the property just updated
            tokens.pop();
            tokens.pop();
        };
        Object.keys(fields).forEach(updateFormData);
        this.setState((prevState)=>Object.assign(Object.assign({}, prevState), {
                formData: formData
            }));
    }
    toggleEditing(id) {
        let formContext;
        const index = this.state.formContext.editing.indexOf(id);
        if (index === -1) formContext = (0, $4177e0bd3f905432$var$immutability_helper_1.default)(this.state.formContext, {
            editing: {
                $push: [
                    id
                ]
            }
        });
        else formContext = (0, $4177e0bd3f905432$var$immutability_helper_1.default)(this.state.formContext, {
            editing: {
                $splice: [
                    [
                        index,
                        1
                    ]
                ]
            }
        });
        this.setState((prevState)=>Object.assign(Object.assign({}, prevState), {
                formContext: formContext
            }));
    }
    validate(formData, errors) {
        if (this.props.validate) {
            const data = this.state.uiSchema.hasOwnProperty("lwolf:rows") ? (0, $jWEnY.stripRows)(formData) : Object.assign({}, formData);
            const map = (0, $jWEnY.getSchemaPathsMap)(this.state.schema);
            this.props.validate(data, map, errors, this.state.uiSchema);
        }
        return errors;
    }
    transformErrors(errors) {
        let finalErrors = [];
        const uiSchema = this.state.uiSchema;
        errors.forEach((error)=>{
            const customMessages = Object.assign({}, this.props.customErrorMessages);
            customMessages && Object.keys(customMessages).every((key)=>{
                if (error.name === key) {
                    switch(key){
                        case "format":
                            if (typeof customMessages[key] === "object" && customMessages[key].constructor === Array) {
                                const index = customMessages[key].findIndex((entry)=>entry.format === error.params.format);
                                error.message = customMessages[key][index].message;
                            }
                            break;
                        case "maximum":
                        case "minimum":
                            error.message = customMessages[key].replace(/{(limit)}/g, error.params.limit);
                            break;
                        default:
                            error.message = customMessages[key];
                            break;
                    }
                    error.stack = `${error.property} ${error.message}`;
                    // We don't need to check again for te same error message
                    delete customMessages[key];
                    // We found the error message we want to override, so we break the loop.
                    return false;
                }
                return true;
            });
            const pathArray = error.property.replace(/\[.\]/g, "").split(".");
            pathArray.shift();
            const propertyUiSchema = $jWEnY.Util.getObjectByStringArray(uiSchema, pathArray);
            error.message = error.message.replace(/{(field)}/g, propertyUiSchema["ui:title"]);
            error.stack = error.stack.replace(/{(field)}/g, propertyUiSchema["ui:title"]);
            finalErrors.push(error);
        });
        if (this.props.transformErrors) finalErrors = this.props.transformErrors(finalErrors);
        return finalErrors;
    }
    onChange(e) {
        if (this.props.onChange) {
            const event = Object.assign({}, e);
            event.formData = (0, $jWEnY.stripRows)(event.formData);
            this.props.onChange(event);
        } else this.setState((prevState)=>Object.assign(Object.assign({}, prevState), {
                formData: e.formData
            }));
    }
    onSubmit(e) {
        if (this.props.onSubmit) this.props.onSubmit((0, $jWEnY.stripRows)(e.formData));
    }
    onError(errors) {
        if (this.props.onError) this.props.onError(errors.map((error)=>{
            const colonIndex = error.stack.indexOf(":");
            return {
                property: error.stack.slice(0, colonIndex),
                message: error.stack.slice(colonIndex + 2)
            };
        }));
    }
    onBlur(id, value) {
        if (this.props.onBlur) this.props.onBlur(id, value, this.state.formData);
    }
    onFocus(id, value) {
        if (this.props.onFocus) this.props.onFocus(id, value, this.state.formData);
    }
    render() {
        const formWidgets = this.props.widgets !== undefined && this.props.widgets !== null ? Object.assign($4177e0bd3f905432$var$widgets, this.props.widgets) : $4177e0bd3f905432$var$widgets;
        const { liveValidate: liveValidate, showErrorList: showErrorList, noHtml5Validate: noHtml5Validate, ErrorList: ErrorList } = this.props;
        return $4177e0bd3f905432$var$react_1.default.createElement($4177e0bd3f905432$var$core_1.default, Object.assign({}, this.props, {
            schema: this.state.schema,
            uiSchema: this.state.uiSchema,
            formData: this.state.formData,
            formContext: this.state.formContext,
            fields: $4177e0bd3f905432$var$formFields,
            widgets: formWidgets,
            FieldTemplate: $4177e0bd3f905432$var$Field_1.default,
            ArrayFieldTemplate: $4177e0bd3f905432$var$ArrayField_1.default,
            onChange: this.onChange,
            onSubmit: this.onSubmit,
            onError: this.onError,
            validate: this.validate,
            liveValidate: liveValidate || false,
            showErrorList: showErrorList || false,
            noHtml5Validate: noHtml5Validate || true,
            transformErrors: this.transformErrors,
            onBlur: this.onBlur,
            onFocus: this.onFocus,
            ErrorList: ErrorList,
            "data-lwt-id": this.props.dataLwtId
        }), !this.props.saveButtonJsx && $4177e0bd3f905432$var$react_1.default.createElement("div", {
            className: "text-center",
            style: {
                display: this.props.saveButtonRef ? "none" : "block"
            }
        }, $4177e0bd3f905432$var$react_1.default.createElement("button", {
            ref: this.props.saveButtonRef,
            type: "submit",
            className: [
                "btn",
                "btn-primary",
                this.props.isBtnLarge && "btn-lg"
            ].join(" ")
        }, this.props.btnText || "Save", $4177e0bd3f905432$var$react_1.default.createElement("div", {
            className: "ripple-container"
        }))), this.props.saveButtonJsx);
    }
}
$4177e0bd3f905432$exports.default = $4177e0bd3f905432$var$BaseForm;



var $jWEnY = parcelRequire("jWEnY");
var $438ef3d2b6ca6b51$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($4177e0bd3f905432$exports)));


const $fdb0026fc8f95a85$export$723ef55b3d9ae5bb = {
    type: "object",
    properties: {
        firstName: {
            type: "string"
        },
        lastName: {
            type: "string"
        },
        username: {
            type: "string"
        },
        email: {
            type: "string"
        }
    }
};
const $fdb0026fc8f95a85$export$1866de92eb642143 = {
    firstName: {
        "ui:autofocus": "true",
        "lwolf:classNames": "col-md-6",
        classNames: "form-group",
        "ui:title": "First Name",
        "ui:disabled": true
    },
    lastName: {
        "lwolf:classNames": "col-md-6",
        classNames: "form-group",
        "ui:title": "Last Name",
        "ui:disabled": true
    },
    username: {
        "lwolf:classNames": "col-md-12",
        classNames: "form-group",
        "ui:title": "Username",
        "ui:disabled": true
    },
    email: {
        "lwolf:classNames": "col-md-12",
        classNames: "form-group",
        "ui:title": "Email",
        "ui:disabled": true
    },
    "ui:order": [
        "*"
    ],
    "lwolf:rows": [
        [
            "firstName",
            "lastName"
        ],
        [
            "username"
        ],
        [
            "email"
        ]
    ]
};


const $51f50db272fd6afd$var$Account = (props)=>{
    const { profile: profile } = props;
    const [formData, setFormData] = (0, $acw62.useState)({});
    const saveButtonRef = (0, $acw62.useRef)(); // will be used to implement the save functionality at a later date
    (0, $acw62.useEffect)(()=>{
        profile && setFormData(profile);
    }, [
        profile
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $438ef3d2b6ca6b51$export$2e2bcd8739ae039), {
            dataLwtId: "account-form",
            schema: (0, $fdb0026fc8f95a85$export$723ef55b3d9ae5bb),
            uiSchema: (0, $fdb0026fc8f95a85$export$1866de92eb642143),
            saveButtonRef: saveButtonRef,
            formData: formData
        })
    });
};
var $51f50db272fd6afd$export$2e2bcd8739ae039 = $51f50db272fd6afd$var$Account;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("fHiKR");
var $5txPe = parcelRequire("5txPe");
parcelRequire("87zV1");
var $6Twau = parcelRequire("6Twau");

var $dI25G = parcelRequire("dI25G");

var $eOjgM = parcelRequire("eOjgM");

var $f61ig = parcelRequire("f61ig");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $8U25g = parcelRequire("8U25g");

var $4TPr9 = parcelRequire("4TPr9");
parcelRequire("fHiKR");
var $5txPe = parcelRequire("5txPe");
var $kN5vy = parcelRequire("kN5vy");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $ivaD7 = parcelRequire("ivaD7");
const $204d6c3adb207317$export$f009deba905428bb = (mlsList)=>{
    if (!mlsList.length) return;
    return mlsList.filter((mls)=>mls.isActive).sort((a, b)=>a.shortDescription.toLowerCase().localeCompare(b.shortDescription.toLowerCase())).map((mls)=>({
            label: `(${mls.shortDescription}) ${mls.longDescription}`,
            value: mls
        }));
};



var $90ISC = parcelRequire("90ISC");

var $7tOHe = parcelRequire("7tOHe");

var $jeANf = parcelRequire("jeANf");

var $cstaF = parcelRequire("cstaF");
parcelRequire("amkL4");
var $3QXz5 = parcelRequire("3QXz5");
var $cb6b9b6cca50f16e$exports = {};
"use strict";
function $cb6b9b6cca50f16e$var$_interopDefault(e) {
    return e && "object" == typeof e && "default" in e ? e.default : e;
}
Object.defineProperty($cb6b9b6cca50f16e$exports, "__esModule", {
    value: !0
});

var $kfZjc = parcelRequire("kfZjc");

var $cb6b9b6cca50f16e$var$React = $cb6b9b6cca50f16e$var$_interopDefault((parcelRequire("acw62")));

var $3np4r = parcelRequire("3np4r");


!(parcelRequire("c9Z8w")), (parcelRequire("9RYKL"));

var $cb6b9b6cca50f16e$var$invariant = $cb6b9b6cca50f16e$var$_interopDefault((parcelRequire("bv4qN")));
function $cb6b9b6cca50f16e$var$_extends() {
    return ($cb6b9b6cca50f16e$var$_extends = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var r = arguments[t];
            for(var o in r)Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
        }
        return e;
    }).apply(this, arguments);
}
function $cb6b9b6cca50f16e$var$_inheritsLoose(e, t) {
    e.prototype = Object.create(t.prototype), $cb6b9b6cca50f16e$var$_setPrototypeOf(e.prototype.constructor = e, t);
}
function $cb6b9b6cca50f16e$var$_setPrototypeOf(e, t) {
    return ($cb6b9b6cca50f16e$var$_setPrototypeOf = Object.setPrototypeOf || function(e, t) {
        return e.__proto__ = t, e;
    })(e, t);
}
function $cb6b9b6cca50f16e$var$_objectWithoutPropertiesLoose(e, t) {
    if (null == e) return {};
    var r, o, n = {}, a = Object.keys(e);
    for(o = 0; o < a.length; o++)r = a[o], 0 <= t.indexOf(r) || (n[r] = e[r]);
    return n;
}
var $cb6b9b6cca50f16e$var$BrowserRouter = function(n) {
    function e() {
        for(var e, t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
        return (e = n.call.apply(n, [
            this
        ].concat(r)) || this).history = $3np4r.createBrowserHistory(e.props), e;
    }
    return $cb6b9b6cca50f16e$var$_inheritsLoose(e, n), e.prototype.render = function() {
        return $cb6b9b6cca50f16e$var$React.createElement($kfZjc.Router, {
            history: this.history,
            children: this.props.children
        });
    }, e;
}($cb6b9b6cca50f16e$var$React.Component), $cb6b9b6cca50f16e$var$HashRouter = function(n) {
    function e() {
        for(var e, t = arguments.length, r = new Array(t), o = 0; o < t; o++)r[o] = arguments[o];
        return (e = n.call.apply(n, [
            this
        ].concat(r)) || this).history = $3np4r.createHashHistory(e.props), e;
    }
    return $cb6b9b6cca50f16e$var$_inheritsLoose(e, n), e.prototype.render = function() {
        return $cb6b9b6cca50f16e$var$React.createElement($kfZjc.Router, {
            history: this.history,
            children: this.props.children
        });
    }, e;
}($cb6b9b6cca50f16e$var$React.Component), $cb6b9b6cca50f16e$var$resolveToLocation = function(e, t) {
    return "function" == typeof e ? e(t) : e;
}, $cb6b9b6cca50f16e$var$normalizeToLocation = function(e, t) {
    return "string" == typeof e ? $3np4r.createLocation(e, null, null, t) : e;
}, $cb6b9b6cca50f16e$var$forwardRefShim = function(e) {
    return e;
}, $cb6b9b6cca50f16e$var$forwardRef = $cb6b9b6cca50f16e$var$React.forwardRef;
function $cb6b9b6cca50f16e$var$isModifiedEvent(e) {
    return !!(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
}
void 0 === $cb6b9b6cca50f16e$var$forwardRef && ($cb6b9b6cca50f16e$var$forwardRef = $cb6b9b6cca50f16e$var$forwardRefShim);
var $cb6b9b6cca50f16e$var$LinkAnchor = $cb6b9b6cca50f16e$var$forwardRef(function(e, t) {
    var r = e.innerRef, o = e.navigate, n = e.onClick, a = $cb6b9b6cca50f16e$var$_objectWithoutPropertiesLoose(e, [
        "innerRef",
        "navigate",
        "onClick"
    ]), i = a.target, c = $cb6b9b6cca50f16e$var$_extends({}, a, {
        onClick: function(t) {
            try {
                n && n(t);
            } catch (e) {
                throw t.preventDefault(), e;
            }
            t.defaultPrevented || 0 !== t.button || i && "_self" !== i || $cb6b9b6cca50f16e$var$isModifiedEvent(t) || (t.preventDefault(), o());
        }
    });
    return c.ref = $cb6b9b6cca50f16e$var$forwardRefShim !== $cb6b9b6cca50f16e$var$forwardRef && t || r, $cb6b9b6cca50f16e$var$React.createElement("a", c);
}), $cb6b9b6cca50f16e$var$Link = $cb6b9b6cca50f16e$var$forwardRef(function(e, a) {
    var t = e.component, i = void 0 === t ? $cb6b9b6cca50f16e$var$LinkAnchor : t, c = e.replace, u = e.to, f = e.innerRef, s = $cb6b9b6cca50f16e$var$_objectWithoutPropertiesLoose(e, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return $cb6b9b6cca50f16e$var$React.createElement($kfZjc.__RouterContext.Consumer, null, function(r) {
        r || $cb6b9b6cca50f16e$var$invariant(!1);
        var o = r.history, e = $cb6b9b6cca50f16e$var$normalizeToLocation($cb6b9b6cca50f16e$var$resolveToLocation(u, r.location), r.location), t = e ? o.createHref(e) : "", n = $cb6b9b6cca50f16e$var$_extends({}, s, {
            href: t,
            navigate: function() {
                var e = $cb6b9b6cca50f16e$var$resolveToLocation(u, r.location), t = $3np4r.createPath(r.location) === $3np4r.createPath($cb6b9b6cca50f16e$var$normalizeToLocation(e));
                (c || t ? o.replace : o.push)(e);
            }
        });
        return $cb6b9b6cca50f16e$var$forwardRefShim !== $cb6b9b6cca50f16e$var$forwardRef ? n.ref = a || f : n.innerRef = f, $cb6b9b6cca50f16e$var$React.createElement(i, n);
    });
}), $cb6b9b6cca50f16e$var$forwardRefShim$1 = function(e) {
    return e;
}, $cb6b9b6cca50f16e$var$forwardRef$1 = $cb6b9b6cca50f16e$var$React.forwardRef;
function $cb6b9b6cca50f16e$var$joinClassnames() {
    for(var e = arguments.length, t = new Array(e), r = 0; r < e; r++)t[r] = arguments[r];
    return t.filter(function(e) {
        return e;
    }).join(" ");
}
void 0 === $cb6b9b6cca50f16e$var$forwardRef$1 && ($cb6b9b6cca50f16e$var$forwardRef$1 = $cb6b9b6cca50f16e$var$forwardRefShim$1);
var $cb6b9b6cca50f16e$var$NavLink = $cb6b9b6cca50f16e$var$forwardRef$1(function(e, s) {
    var t = e["aria-current"], l = void 0 === t ? "page" : t, r = e.activeClassName, p = void 0 === r ? "active" : r, R = e.activeStyle, h = e.className, y = e.exact, d = e.isActive, m = e.location, v = e.sensitive, b = e.strict, P = e.style, w = e.to, x = e.innerRef, g = $cb6b9b6cca50f16e$var$_objectWithoutPropertiesLoose(e, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return $cb6b9b6cca50f16e$var$React.createElement($kfZjc.__RouterContext.Consumer, null, function(e) {
        e || $cb6b9b6cca50f16e$var$invariant(!1);
        var t = m || e.location, r = $cb6b9b6cca50f16e$var$normalizeToLocation($cb6b9b6cca50f16e$var$resolveToLocation(w, t), t), o = r.pathname, n = o && o.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1"), a = n ? $kfZjc.matchPath(t.pathname, {
            path: n,
            exact: y,
            sensitive: v,
            strict: b
        }) : null, i = !!(d ? d(a, t) : a), c = "function" == typeof h ? h(i) : h, u = "function" == typeof P ? P(i) : P;
        i && (c = $cb6b9b6cca50f16e$var$joinClassnames(c, p), u = $cb6b9b6cca50f16e$var$_extends({}, u, R));
        var f = $cb6b9b6cca50f16e$var$_extends({
            "aria-current": i && l || null,
            className: c,
            style: u,
            to: r
        }, g);
        return $cb6b9b6cca50f16e$var$forwardRefShim$1 !== $cb6b9b6cca50f16e$var$forwardRef$1 ? f.ref = s || x : f.innerRef = x, $cb6b9b6cca50f16e$var$React.createElement($cb6b9b6cca50f16e$var$Link, f);
    });
});
Object.defineProperty($cb6b9b6cca50f16e$exports, "MemoryRouter", {
    enumerable: !0,
    get: function() {
        return $kfZjc.MemoryRouter;
    }
}), Object.defineProperty($cb6b9b6cca50f16e$exports, "Prompt", {
    enumerable: !0,
    get: function() {
        return $kfZjc.Prompt;
    }
}), Object.defineProperty($cb6b9b6cca50f16e$exports, "Redirect", {
    enumerable: !0,
    get: function() {
        return $kfZjc.Redirect;
    }
}), Object.defineProperty($cb6b9b6cca50f16e$exports, "Route", {
    enumerable: !0,
    get: function() {
        return $kfZjc.Route;
    }
}), Object.defineProperty($cb6b9b6cca50f16e$exports, "Router", {
    enumerable: !0,
    get: function() {
        return $kfZjc.Router;
    }
}), Object.defineProperty($cb6b9b6cca50f16e$exports, "StaticRouter", {
    enumerable: !0,
    get: function() {
        return $kfZjc.StaticRouter;
    }
}), Object.defineProperty($cb6b9b6cca50f16e$exports, "Switch", {
    enumerable: !0,
    get: function() {
        return $kfZjc.Switch;
    }
}), Object.defineProperty($cb6b9b6cca50f16e$exports, "generatePath", {
    enumerable: !0,
    get: function() {
        return $kfZjc.generatePath;
    }
}), Object.defineProperty($cb6b9b6cca50f16e$exports, "matchPath", {
    enumerable: !0,
    get: function() {
        return $kfZjc.matchPath;
    }
}), Object.defineProperty($cb6b9b6cca50f16e$exports, "useHistory", {
    enumerable: !0,
    get: function() {
        return $kfZjc.useHistory;
    }
}), Object.defineProperty($cb6b9b6cca50f16e$exports, "useLocation", {
    enumerable: !0,
    get: function() {
        return $kfZjc.useLocation;
    }
}), Object.defineProperty($cb6b9b6cca50f16e$exports, "useParams", {
    enumerable: !0,
    get: function() {
        return $kfZjc.useParams;
    }
}), Object.defineProperty($cb6b9b6cca50f16e$exports, "useRouteMatch", {
    enumerable: !0,
    get: function() {
        return $kfZjc.useRouteMatch;
    }
}), Object.defineProperty($cb6b9b6cca50f16e$exports, "withRouter", {
    enumerable: !0,
    get: function() {
        return $kfZjc.withRouter;
    }
}), $cb6b9b6cca50f16e$exports.BrowserRouter = $cb6b9b6cca50f16e$var$BrowserRouter, $cb6b9b6cca50f16e$exports.HashRouter = $cb6b9b6cca50f16e$var$HashRouter, $cb6b9b6cca50f16e$exports.Link = $cb6b9b6cca50f16e$var$Link, $cb6b9b6cca50f16e$exports.NavLink = $cb6b9b6cca50f16e$var$NavLink;



var $f6CJ4 = parcelRequire("f6CJ4");

var $5NVz0 = parcelRequire("5NVz0");

var $bBJbW = parcelRequire("bBJbW");

var $c9Z8w = parcelRequire("c9Z8w");
const $6442aa249f054a6a$var$Validation = ({ isMyProfile: isMyProfile })=>{
    const history = (0, $cb6b9b6cca50f16e$exports.useHistory)();
    const [state, setState] = (0, $acw62.useState)({
        mlsList: [],
        selectedMlsOption: {
            label: (0, $8U25g.terms).selectYourMls,
            value: null
        },
        isFormValid: false,
        isLoading: false,
        isAgentCreated: false,
        toastProps: null
    });
    const { getMlsList: getMlsList } = (0, $90ISC.useSearchStore)((state)=>({
            getMlsList: state.getMlsList
        }));
    const { isXamUserValidated: isXamUserValidated, setIsXamUserValidated: setIsXamUserValidated } = (0, $f6CJ4.useAuthStore)((state)=>({
            isXamUserValidated: state.isXamUserValidated,
            setIsXamUserValidated: state.setIsXamUserValidated
        }));
    (0, $acw62.useEffect)(()=>{
        if (isXamUserValidated) history.replace("/market-share/totals", {});
        const getMlsData = async ()=>{
            const mlsList = await getMlsList();
            if (mlsList?.error) return;
            (0, $ivaD7.setStateData)("mlsList", mlsList, setState);
        };
        getMlsData();
    }, []);
    (0, $acw62.useEffect)(()=>{
        const isValid = state.selectedMlsOption?.value?.mlsId && state.agentId?.trim().length > 0;
        (0, $ivaD7.setStateData)("isFormValid", isValid, setState);
    }, [
        state.selectedMlsOption,
        state.agentId
    ]);
    const handleOptionsChange = (option)=>{
        (0, $ivaD7.setStateData)("selectedMlsOption", option, setState);
    };
    const handleAgentIdChange = (agentId)=>(0, $ivaD7.setStateData)("agentId", agentId, setState);
    const handleSaveAndContinue = async ()=>{
        (0, $ivaD7.setStateData)("isLoading", true, setState);
        const agentList = [
            {
                mlsId: state.selectedMlsOption?.value?.mlsId,
                agentId: state.agentId
            }
        ];
        const validationResult = await (0, $5NVz0.getAgentInfo)(agentList);
        const activeAgentsOffices = validationResult.length > 0 && validationResult.filter((agent)=>agent.isAgentActive);
        if (!activeAgentsOffices?.length || activeAgentsOffices?.length === 0) (0, $jeANf.showToast)((0, $jeANf.toastTypes).error, (0, $cstaF.toastMessages).error.agentNotValidated, setState);
        else try {
            const response = await (0, $bBJbW.createAgent)(state.agentId, state.selectedMlsOption?.value?.mlsId.toString());
            if (!response?.error && response !== 409) {
                (0, $ivaD7.setStateData)("isAgentCreated", true, setState);
                setIsXamUserValidated(true);
                history.replace("/market-share/totals", {
                    fromValidation: true
                });
            } else (0, $jeANf.showToast)((0, $jeANf.toastTypes).error, (0, $cstaF.toastMessages).error.agentNotValidated, setState);
        } catch (error) {
            console.error("Error creating agent:", error);
            (0, $jeANf.showToast)((0, $jeANf.toastTypes).error, (0, $cstaF.toastMessages).error.agentNotValidated, setState);
        }
        (0, $ivaD7.setStateData)("isLoading", false, setState);
    };
    const mlsOptions = state.mlsList?.length ? (0, $204d6c3adb207317$export$f009deba905428bb)(state.mlsList) : [];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "validation-wrapper",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: `${!isMyProfile && "raised-border p-5 mt-5"} bg-white d-flex flex-column align-items-center`,
                children: [
                    !isMyProfile ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "text-center mb-3",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                                height: "40",
                                src: "//assets.lwolf.com/img/lw-logo-dark.svg",
                                alt: "Logo",
                                className: "mb-5"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                                children: (0, $8U25g.terms).thankYou
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                children: (0, $8U25g.terms).welcomeMessage
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                        className: "mb-4",
                        children: (0, $8U25g.terms).connectYourMls
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "w-75",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "mb-3",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kN5vy))), {
                                        dataLwtId: "mls-associations-label",
                                        className: "font-weight-bold",
                                        children: (0, $8U25g.terms).yourMLSassociation
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4TPr9.default), {
                                        dataLwtId: "mls-associations",
                                        isClearable: false,
                                        onChange: handleOptionsChange,
                                        options: mlsOptions,
                                        value: state.selectedMlsOption,
                                        isDisabled: state.isAgentCreated
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kN5vy))), {
                                        dataLwtId: "mls-associations-label",
                                        className: "font-weight-bold",
                                        children: (0, $8U25g.terms).mlsAgentId
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5txPe))), {
                                        dataLwtId: "agent-id",
                                        onChange: (e)=>handleAgentIdChange(e.target.value.toUpperCase()),
                                        maxLength: 50,
                                        placeholder: (0, $8U25g.terms).enterYourMlsAgentId,
                                        value: state.agentId,
                                        className: "ucase-ph-mixed",
                                        disabled: state.isAgentCreated
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "w-100 d-flex justify-content-center",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                                    dataLwtId: "validation-agent-metrics-form",
                                    className: "btn btn-primary save-continue-button w-100",
                                    disabled: !state.isFormValid || state.isAgentCreated,
                                    onClick: !isMyProfile && handleSaveAndContinue,
                                    children: state.isLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "py-3",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {})
                                    }) : (0, $8U25g.terms).saveAndContinue
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3QXz5))), {
                position: "toast-bottom-right",
                dataLwtId: "validation-toast",
                toastProps: state.toastProps
            })
        ]
    });
};
$6442aa249f054a6a$var$Validation.propTypes = {
    isMyProfile: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
var $6442aa249f054a6a$export$2e2bcd8739ae039 = $6442aa249f054a6a$var$Validation;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $dI25G = parcelRequire("dI25G");

var $ajR31 = parcelRequire("ajR31");

var $cstaF = parcelRequire("cstaF");

var $c9Z8w = parcelRequire("c9Z8w");
const $0691761fbe7b4864$export$bdb223f4212816b6 = ({ setModal: setModal })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "connect-mls d-flex justify-content-end pb-3",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
            dataLwtId: "connect-mls-button",
            size: "sm",
            color: "light",
            className: "d-inline-flex",
            onClick: ()=>setModal(true),
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                    icon: (0, $ajR31.add),
                    className: "helix-brand-color"
                }),
                (0, $cstaF.buttonTerms).connectMls
            ]
        })
    });
};
$0691761fbe7b4864$export$bdb223f4212816b6.propTypes = {
    setModal: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};



var $kLrt8 = parcelRequire("kLrt8");
const $e849fd5ea30dde24$var$MLS = (props)=>{
    const { mlsList: mlsList } = props;
    const [filteredMlsList, setFilteredMlsList] = (0, $acw62.useState)();
    const [showValidationModal, setShowValidationModal] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        mlsList && setFilteredMlsList(mlsList);
    }, [
        mlsList
    ]);
    const featureToggles = (0, $kLrt8.useFeatureToggles)();
    const filterMLS = (event)=>{
        const searchText = event.target.value;
        setFilteredMlsList(mlsList.filter((mls)=>mls.shortDescription.toLowerCase().startsWith(searchText.toLowerCase()) || mls.longDescription.toLowerCase().startsWith(searchText.toLowerCase())));
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    minWidth: "300px"
                },
                children: [
                    featureToggles.connectMls.isEnabled && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0691761fbe7b4864$export$bdb223f4212816b6), {
                        setModal: setShowValidationModal
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6Twau))), {
                        dataLwtId: "InputGroup",
                        style: {
                            height: "36px"
                        },
                        prependAddonProps: [
                            {
                                textProps: {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                                        icon: (0, $eOjgM.search),
                                        className: "align-top",
                                        title: "search icon"
                                    })
                                }
                            }
                        ],
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5txPe))), {
                            dataLwtId: "mlsSearch",
                            onChange: filterMLS,
                            placeholder: "Search MLS name"
                        })
                    })
                ]
            }),
            filteredMlsList && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    minWidth: "300px"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                        className: "mt-2",
                        children: "MLS NAME"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("ul", {
                        className: "mls-list",
                        children: filteredMlsList.map((mls)=>{
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)("li", {
                                className: !mls.isActive && "text-muted",
                                children: [
                                    mls.shortDescription,
                                    " (",
                                    mls.longDescription,
                                    ")",
                                    !mls.isActive && " (INACTIVE)"
                                ]
                            }, mls.shortDescription);
                        })
                    })
                ]
            }),
            featureToggles.connectMls.isEnabled && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f61ig.default), {
                onClose: ()=>setShowValidationModal(false),
                show: showValidationModal,
                showFooter: false,
                title: " ",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6442aa249f054a6a$export$2e2bcd8739ae039), {
                    isMyProfile: true
                })
            })
        ]
    });
};
var $e849fd5ea30dde24$export$2e2bcd8739ae039 = $e849fd5ea30dde24$var$MLS;



var $ivaD7 = parcelRequire("ivaD7");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4TPr9 = parcelRequire("4TPr9");
parcelRequire("fHiKR");
var $5txPe = parcelRequire("5txPe");
var $kN5vy = parcelRequire("kN5vy");
parcelRequire("87zV1");
var $6Twau = parcelRequire("6Twau");
var $8f727079b1eb391f$exports = {};
"use strict";
var $8f727079b1eb391f$var$__importDefault = $8f727079b1eb391f$exports && $8f727079b1eb391f$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($8f727079b1eb391f$exports, "__esModule", {
    value: true
});

const $8f727079b1eb391f$var$react_1 = $8f727079b1eb391f$var$__importDefault((parcelRequire("acw62")));

const $8f727079b1eb391f$var$classnames_1 = $8f727079b1eb391f$var$__importDefault((parcelRequire("8g1PZ")));
const $8f727079b1eb391f$var$Badge = (props)=>{
    const { className: className, color: color, combo: combo, notification: notification, dataLwtId: dataLwtId, ...attributes } = props;
    const classes = (0, $8f727079b1eb391f$var$classnames_1.default)(className, "badge", "badge-" + color, combo ? "badge-combo" : false, notification ? "badge-notification" : false);
    return $8f727079b1eb391f$var$react_1.default.createElement("span", {
        "data-lwt-id": dataLwtId,
        ...attributes,
        className: classes
    });
};
$8f727079b1eb391f$var$Badge.defaultProps = {
    color: "secondary",
    combo: false,
    notification: false,
    children: "badge"
};
$8f727079b1eb391f$exports.default = $8f727079b1eb391f$var$Badge;


var $9f9e73b9dd3c1949$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($8f727079b1eb391f$exports)));



var $dI25G = parcelRequire("dI25G");

var $eOjgM = parcelRequire("eOjgM");

var $90ISC = parcelRequire("90ISC");

var $cstaF = parcelRequire("cstaF");

var $dlZsJ = parcelRequire("dlZsJ");
const $87e7792856d13934$var$OfficeTab = (props)=>{
    const { mlsList: mlsList } = props;
    const [mlsOptions, setMlsOptions] = (0, $acw62.useState)();
    const [officeList, setOfficeList] = (0, $acw62.useState)();
    const [selectedMls, setSelectedMls] = (0, $acw62.useState)({});
    const [searchText, setSearchText] = (0, $acw62.useState)(undefined);
    const { profile: profile, officeInfo: officeInfo, getOfficeInfo: getOfficeInfo, getAgentInfo: getAgentInfo, agentInfo: agentInfo } = (0, $90ISC.useCommonStore)((state)=>({
            profile: state.profile,
            officeInfo: state.officeInfo,
            getOfficeInfo: state.getOfficeInfo,
            getAgentInfo: state.getAgentInfo
        }));
    (0, $acw62.useEffect)(()=>{
        if (mlsList) {
            const selectOptions = mlsList.map((mls)=>({
                    id: mls.mlsId,
                    value: mls.shortDescription,
                    label: mls.longDescription
                }));
            setMlsOptions(selectOptions);
            setSelectedMls(selectOptions[0]);
        }
    }, [
        mlsList
    ]);
    (0, $acw62.useEffect)(()=>{
        const fetchOfficeOrAgentInfo = async ()=>{
            if (!profile) return;
            if (profile.accessibleOfficeList?.length) // BME user
            await getOfficeInfo(profile.accessibleOfficeList);
            else //  BMO user
            await getAgentInfo(profile.agentList);
        };
        fetchOfficeOrAgentInfo();
    }, [
        profile
    ]);
    (0, $acw62.useEffect)(()=>{
        const fetchOfficeInfo = async ()=>{
            if (!agentInfo || !agentInfo.length) return;
            await getOfficeInfo(agentInfo.map((agent)=>agent.office));
        };
        fetchOfficeInfo();
    }, [
        agentInfo
    ]);
    (0, $acw62.useEffect)(()=>{
        officeInfo?.length && setOfficeList([
            ...officeInfo
        ].sort((a, b)=>a.name.toUpperCase().localeCompare(b.name.toUpperCase())));
    }, [
        officeInfo
    ]);
    const filterOffice = (event)=>{
        setSearchText(event.target.value.toUpperCase());
    };
    const handleChange = (event)=>{
        setSelectedMls(event);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            minWidth: "300px"
        },
        children: [
            mlsList && !mlsList?.length && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    " You do not have an MLS associated with your account. Please contact our Customer Support at ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                        href: `mailto:${(0, $cstaF.emails).terradatumSupport}`,
                        children: (0, $cstaF.emails).terradatumSupport
                    }),
                    " or call ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                        href: "tel:888.212.4793",
                        children: "888-212-4793"
                    }),
                    "."
                ]
            }),
            !!mlsOptions?.length && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kN5vy))), {
                        dataLwtId: "mls-select-label",
                        for: "mls-select",
                        children: "MLS"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4TPr9.default), {
                        dataLwtId: "mls-select",
                        id: "mls-select",
                        className: "mb-2 w-100",
                        type: "select",
                        value: selectedMls,
                        onChange: handleChange,
                        placeholder: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                                    icon: (0, $eOjgM.search),
                                    className: "align-top mr-1",
                                    title: "search icon"
                                }),
                                "Select an MLS"
                            ]
                        }),
                        options: mlsOptions,
                        matchFrom: "start",
                        autoFocus: true,
                        isClearable: false
                    }),
                    !officeList?.length ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {}) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6Twau))), {
                                dataLwtId: "InputGroup",
                                style: {
                                    height: "36px"
                                },
                                prependAddonProps: [
                                    {
                                        textProps: {
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                                                icon: (0, $eOjgM.search),
                                                className: "align-top mr-1",
                                                title: "search icon"
                                            })
                                        }
                                    }
                                ],
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5txPe))), {
                                    dataLwtId: "officeSearch",
                                    onChange: filterOffice,
                                    placeholder: "Search Office Name or ID"
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    width: "100%",
                                    maxHeight: "278px",
                                    overflow: "auto",
                                    borderTop: "1px solid #ccc",
                                    marginTop: "1rem"
                                },
                                children: officeList.filter((o)=>o.mlsOfficeId.mlsId === selectedMls.id).filter((o)=>!searchText || o.name.toUpperCase().startsWith(searchText) || o.mlsOfficeId.officeId.toUpperCase().startsWith(searchText)).map((o)=>{
                                    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            style: {
                                                marginTop: "1rem"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "font-weight-bold",
                                                    children: [
                                                        o.name,
                                                        !o.isOfficeActive && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9f9e73b9dd3c1949$export$2e2bcd8739ae039), {
                                                            color: "info",
                                                            className: "ml-2",
                                                            children: "Inactive"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    children: (0, $dlZsJ.getCommaSeparatedTextByKeyFields)(o?.address, [
                                                        "street1",
                                                        "city",
                                                        "stateCode",
                                                        "zipCode"
                                                    ])
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    children: [
                                                        "Office ID: ",
                                                        o.mlsOfficeId.officeId,
                                                        " ",
                                                        o.phoneList && o.phoneList.length ? `| ${o.phoneList[0].phoneNumber}` : ""
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                    children: selectedMls.label
                                                })
                                            ]
                                        })
                                    });
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $87e7792856d13934$export$2e2bcd8739ae039 = $87e7792856d13934$var$OfficeTab;



var $90ISC = parcelRequire("90ISC");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $aTLkh = parcelRequire("aTLkh");

var $4TPr9 = parcelRequire("4TPr9");

var $dI25G = parcelRequire("dI25G");

var $eOjgM = parcelRequire("eOjgM");
parcelRequire("amkL4");
var $3QXz5 = parcelRequire("3QXz5");

var $cstaF = parcelRequire("cstaF");

var $acw62 = parcelRequire("acw62");

var $ae040 = parcelRequire("ae040");

var $90ISC = parcelRequire("90ISC");
const $1dffa5e53ec16a5b$export$2459d7680d93fd8e = ()=>{
    const { mlsList: mlsList, userInfo: userInfo, membership: membership } = (0, $90ISC.useCommonStore)(({ mlsList: mlsList, userInfo: userInfo, membership: membership })=>({
            mlsList: mlsList,
            userInfo: userInfo,
            membership: membership
        }));
    const mlsListOptions = (0, $acw62.useMemo)(()=>{
        const currentMlsList = mlsList || membership;
        return !!currentMlsList?.length && currentMlsList.filter((mls)=>mls.isActive).map((mls)=>({
                value: mls,
                label: `(${mls.shortDescription}) ${mls.longDescription}`
            }));
    }, [
        mlsList,
        membership
    ]);
    const defaultMlsOption = mlsListOptions[0];
    const initialState = {
        isSaveButtonDisabled: true,
        newCompSetName: undefined
    };
    const [state, setState] = (0, $acw62.useState)({
        ...initialState
    });
    const { selectedMls: selectedMls, getComparisonSetsByUser: getComparisonSetsByUser, handleMlsChange: handleMlsChange, buildComparisonSetOptions: buildComparisonSetOptions, selectedComparisonSet: selectedComparisonSet, getSelectedComparisonSetOfficesList: getSelectedComparisonSetOfficesList, comparisonSets: comparisonSets, hasLoadedComparisonSets: hasLoadedComparisonSets } = (0, $ae040.useComparisonSetsStore)((state)=>({
            getComparisonSetsByUser: state.getComparisonSetsByUser,
            handleMlsChange: state.handleMlsChange,
            buildComparisonSetOptions: state.buildComparisonSetOptions,
            selectedComparisonSet: state.selectedComparisonSet,
            getSelectedComparisonSetOfficesList: state.getSelectedComparisonSetOfficesList,
            comparisonSets: state.comparisonSets,
            hasLoadedComparisonSets: state.hasLoadedComparisonSets
        }));
    (0, $acw62.useEffect)(()=>{
        if (selectedMls) return;
        handleMlsChange(defaultMlsOption);
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!userInfo?.id) return;
        if (hasLoadedComparisonSets) return;
        getComparisonSetsByUser(userInfo.id);
    }, [
        userInfo?.id,
        hasLoadedComparisonSets
    ]);
    (0, $acw62.useEffect)(()=>{
        buildComparisonSetOptions();
    }, [
        comparisonSets
    ]);
    (0, $acw62.useEffect)(()=>{
        getSelectedComparisonSetOfficesList();
    }, [
        selectedComparisonSet
    ]);
    return {
        state: state,
        setState: setState,
        mlsListOptions: mlsListOptions,
        defaultMlsOption: defaultMlsOption
    };
};



var $ae040 = parcelRequire("ae040");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $f61ig = parcelRequire("f61ig");

var $cstaF = parcelRequire("cstaF");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
parcelRequire("fHiKR");
var $5txPe = parcelRequire("5txPe");

var $cstaF = parcelRequire("cstaF");

var $1ujWz = parcelRequire("1ujWz");

var $4TPr9 = parcelRequire("4TPr9");

var $ae040 = parcelRequire("ae040");
const $1eeb2670b34ee70d$export$c50bc281c682c03d = ({ isEdit: isEdit, shouldShowMlsList: shouldShowMlsList, mlsListOptions: mlsListOptions, defaultMlsOption: defaultMlsOption, setState: setState, setSelectedMls: setSelectedMls })=>{
    const { handleComparisonSetNameChange: handleComparisonSetNameChange, selectedComparisonSet: selectedComparisonSet, setNewCompSetName: setNewCompSetName } = (0, $ae040.useComparisonSetsStore)((state)=>({
            handleComparisonSetNameChange: state.handleComparisonSetNameChange,
            handleMlsChange: state.handleMlsChange,
            selectedComparisonSet: state.selectedComparisonSet,
            setNewCompSetName: state.setNewCompSetName
        }));
    (0, $acw62.useEffect)(()=>{
        if (!isEdit) {
            setNewCompSetName(undefined);
            return;
        }
        setNewCompSetName(selectedComparisonSet?.name);
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "d-flex flex-column justify-content-center",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "font-weight-bold mb-1",
                    children: (0, $cstaF.marketShareTerms).comparisonSetName
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5txPe))), {
                    dataLwtId: "comparison-set-name",
                    name: "comparison-set-name",
                    placeholder: (0, $cstaF.marketShareTerms).newComparisonSet,
                    type: "text",
                    maxLength: (0, $1ujWz.NAME_MAX_LENGTH),
                    onChange: (e)=>{
                        handleComparisonSetNameChange(e, setState);
                    },
                    defaultValue: isEdit ? selectedComparisonSet.name : null
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                    className: "mt-1",
                    children: isEdit ? (0, $cstaF.marketShareTerms).editComparisonSetDescription : (0, $cstaF.marketShareTerms).addComparisonSetDescription
                }),
                shouldShowMlsList ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "font-weight-bold mt-4 mb-1",
                            children: (0, $cstaF.searchTerms).mls
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4TPr9.default), {
                            dataLwtId: "mls-list",
                            options: mlsListOptions,
                            onChange: setSelectedMls,
                            defaultValue: defaultMlsOption,
                            isClearable: false
                        })
                    ]
                }) : null
            ]
        })
    });
};
$1eeb2670b34ee70d$export$c50bc281c682c03d.propTypes = {
    isEdit: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    shouldShowMlsList: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    mlsListOptions: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    defaultMlsOption: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    setState: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    setSelectedMls: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $ae040 = parcelRequire("ae040");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $cstaF = parcelRequire("cstaF");
const $2f0408219699e9dd$export$b7dc9c209b6d89c3 = ({ isSaveButtonDisabled: isSaveButtonDisabled, setState: setState, defaultMlsOption: defaultMlsOption, isEdit: isEdit, selectedMls: selectedMls })=>{
    const { comparisonSets: comparisonSets, handleSaveComparisonSet: handleSaveComparisonSet, toggleModal: toggleModal, selectedComparisonSet: selectedComparisonSet, newCompSetName: newCompSetName } = (0, $ae040.useComparisonSetsStore)((state)=>({
            comparisonSets: state.comparisonSets,
            handleSaveComparisonSet: state.handleSaveComparisonSet,
            toggleModal: state.toggleModal,
            selectedComparisonSet: state.selectedComparisonSet,
            newCompSetName: state.newCompSetName
        }));
    (0, $acw62.useEffect)(()=>{
        const isSaveDisabledOnEdit = newCompSetName === selectedComparisonSet?.name;
        const isSaveDisabledOnCreate = !newCompSetName || newCompSetName.trim() === "";
        const isSaveButtonDisabled = isEdit ? isSaveDisabledOnEdit : isSaveDisabledOnCreate;
        setState((prevState)=>({
                ...prevState,
                isSaveButtonDisabled: isSaveButtonDisabled
            }));
    }, [
        selectedComparisonSet,
        newCompSetName
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                dataLwtId: "cancel",
                color: "secondary",
                onClick: ()=>{
                    toggleModal(false, (0, $cstaF.comparisonSetsModals).SAVE);
                },
                children: (0, $cstaF.buttonTerms).cancel
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                dataLwtId: "save",
                color: "primary",
                onClick: ()=>{
                    handleSaveComparisonSet({
                        setState: setState,
                        defaultMlsOption: defaultMlsOption,
                        comparisonSets: comparisonSets,
                        isEdit: isEdit,
                        selectedMls: selectedMls
                    });
                },
                disabled: isSaveButtonDisabled,
                children: (0, $cstaF.buttonTerms).save
            })
        ]
    });
};
$2f0408219699e9dd$export$b7dc9c209b6d89c3.propTypes = {
    isSaveButtonDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).boolean,
    defaultMlsOption: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    setState: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    isEdit: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    selectedMls: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};



var $ae040 = parcelRequire("ae040");
const $51a2f2df4ae57eae$export$fd16d00ec718efe3 = ({ isSaveButtonDisabled: isSaveButtonDisabled, mlsListOptions: mlsListOptions, defaultMlsOption: defaultMlsOption, setState: setState, selectedMls: selectedMls, setSelectedMls: setSelectedMls })=>{
    const saveModal = (0, $cstaF.comparisonSetsModals).SAVE;
    const { shouldShowSaveModal: shouldShowSaveModal, toggleModal: toggleModal } = (0, $ae040.useComparisonSetsStore)((state)=>({
            shouldShowSaveModal: state.shouldShowByModal[saveModal],
            toggleModal: state.toggleModal
        }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f61ig.default), {
        dataLwtId: "new-comparison-set-modal",
        onClose: ()=>{
            toggleModal(false, saveModal);
        },
        title: (0, $cstaF.marketShareTerms).addNewComparisonSet,
        show: shouldShowSaveModal,
        size: "md",
        buttons: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0408219699e9dd$export$b7dc9c209b6d89c3), {
            isSaveButtonDisabled: isSaveButtonDisabled,
            setState: setState,
            defaultMlsOption: defaultMlsOption,
            isEdit: false,
            selectedMls: selectedMls
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1eeb2670b34ee70d$export$c50bc281c682c03d), {
            shouldShowMlsList: true,
            mlsListOptions: mlsListOptions,
            defaultMlsOption: defaultMlsOption,
            setState: setState,
            setSelectedMls: setSelectedMls
        })
    });
};
$51a2f2df4ae57eae$export$fd16d00ec718efe3.propTypes = {
    isSaveButtonDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).boolean,
    mlsListOptions: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    defaultMlsOption: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    setState: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    selectedMls: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    setSelectedMls: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $cstaF = parcelRequire("cstaF");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $aTLkh = parcelRequire("aTLkh");

var $ae040 = parcelRequire("ae040");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $f61ig = parcelRequire("f61ig");

var $cstaF = parcelRequire("cstaF");

var $ae040 = parcelRequire("ae040");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $ae040 = parcelRequire("ae040");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $cstaF = parcelRequire("cstaF");
const $1556e0b73aa03012$export$ae837f3390f056ab = ({ setState: setState })=>{
    const { addedOffices: addedOffices, officeGroupName: officeGroupName, comparisonSets: comparisonSets, handleSaveOfficeGroups: handleSaveOfficeGroups, selectedComparisonSet: selectedComparisonSet, toggleModal: toggleModal, selectedMls: selectedMls, clearState: clearState, isOfficeGroupEdit: isOfficeGroupEdit, getIsOfficeGroupSaveBtnDisabled: getIsOfficeGroupSaveBtnDisabled } = (0, $ae040.useComparisonSetsStore)((state)=>({
            addedOffices: state.addedOffices,
            officeGroupName: state.officeGroupName,
            handleSaveOfficeGroups: state.handleSaveOfficeGroups,
            selectedComparisonSet: state.selectedComparisonSet,
            toggleModal: state.toggleModal,
            comparisonSets: state.comparisonSets,
            selectedMls: state.selectedMls,
            clearState: state.clearState,
            isOfficeGroupEdit: state.isOfficeGroupEdit,
            getIsOfficeGroupSaveBtnDisabled: state.getIsOfficeGroupSaveBtnDisabled
        }));
    const handleSave = ()=>{
        const offices = addedOffices.map((office)=>({
                officeId: office.officeId
            }));
        const groups = [
            {
                name: officeGroupName.trim(),
                offices: offices
            }
        ];
        const mlsDescription = selectedComparisonSet.shortDescription || selectedMls?.value.shortDescription;
        const groupLabel = `${officeGroupName} (${mlsDescription})`;
        handleSaveOfficeGroups({
            comparisonSets: comparisonSets,
            selectedComparisonSet: selectedComparisonSet,
            groupLabel: groupLabel,
            groups: groups,
            setState: setState
        });
    };
    const showOfficeGroupDeleteModal = ()=>{
        toggleModal(true, (0, $cstaF.comparisonSetsModals).DELETE_OFFICE_GROUP);
        clearState();
    };
    const closeOfficeGroupModal = ()=>{
        toggleModal(false, (0, $cstaF.comparisonSetsModals).OFFICE_GROUP);
        clearState();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "d-flex justify-content-between w-100",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                dataLwtId: "delete-comp-set-office-group",
                color: "danger",
                onClick: showOfficeGroupDeleteModal,
                disabled: !isOfficeGroupEdit,
                children: (0, $cstaF.buttonTerms).delete
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                        dataLwtId: "cancel-comp-set-office-group",
                        color: "secondary",
                        onClick: closeOfficeGroupModal,
                        children: (0, $cstaF.buttonTerms).cancel
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                        dataLwtId: "save-comp-set-office-group",
                        color: "primary",
                        onClick: handleSave,
                        disabled: getIsOfficeGroupSaveBtnDisabled(),
                        children: (0, $cstaF.buttonTerms).save
                    })
                ]
            })
        ]
    });
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("fHiKR");
var $5txPe = parcelRequire("5txPe");

var $acw62 = parcelRequire("acw62");

var $1ujWz = parcelRequire("1ujWz");

var $cstaF = parcelRequire("cstaF");

var $ae040 = parcelRequire("ae040");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $hdbmc = parcelRequire("hdbmc");

var $ae040 = parcelRequire("ae040");

var $3RdAS = parcelRequire("3RdAS");

var $1ujWz = parcelRequire("1ujWz");

var $94cVo = parcelRequire("94cVo");

var $ivaD7 = parcelRequire("ivaD7");
const $f8c93effe1a162ba$export$2227739de6bd579f = ()=>{
    const { addedOffices: addedOffices, setAddedOffices: setAddedOffices, selectedComparisonSet: selectedComparisonSet, selectedComparisonSetOfficesList: selectedComparisonSetOfficesList, isOfficeGroupEdit: isOfficeGroupEdit } = (0, $ae040.useComparisonSetsStore)((state)=>({
            addedOffices: state.addedOffices,
            setAddedOffices: state.setAddedOffices,
            selectedComparisonSet: state.selectedComparisonSet,
            selectedComparisonSetOfficesList: state.selectedComparisonSetOfficesList,
            isOfficeGroupEdit: state.isOfficeGroupEdit
        }));
    const offices = (0, $acw62.useMemo)(()=>(0, $1ujWz.buildInitialAvailableOffices)(selectedComparisonSet, selectedComparisonSetOfficesList), [
        selectedComparisonSet,
        selectedComparisonSetOfficesList
    ]);
    const [state, setState] = (0, $acw62.useState)({
        availableOffices: offices ?? [],
        displayedOffices: offices ?? [],
        checkedAvailableOffices: [],
        checkedAddedOffices: []
    });
    const addOffices = (officesToAdd)=>{
        const officeIds = officesToAdd.map((office)=>office.officeId);
        const availableOffices = state.availableOffices.filter((office)=>!officeIds.includes(office.officeId));
        const availableOfficeIds = availableOffices.map((office)=>office.officeId);
        const newlyAddedOffices = isOfficeGroupEdit ? (0, $94cVo.getSortedObjectByProp)([
            ...addedOffices,
            ...officesToAdd
        ], "officeName") : offices.filter((office)=>!availableOfficeIds.includes(office.officeId));
        setState((state)=>({
                ...state,
                availableOffices: availableOffices
            }));
        setAddedOffices(newlyAddedOffices);
    };
    const addAll = ()=>{
        addOffices(state.displayedOffices);
        (0, $ivaD7.setStateData)("checkedAvailableOffices", [], setState);
    };
    const removeAddedOffices = (officesToRemove)=>{
        const officeIds = officesToRemove.map((office)=>office.officeId);
        const filteredAddedOffices = addedOffices.filter((office)=>!officeIds.includes(office.officeId));
        const addedOfficesIds = filteredAddedOffices.map((office)=>office.officeId);
        const availableOffices = isOfficeGroupEdit ? (0, $94cVo.getSortedObjectByProp)([
            ...state.availableOffices,
            ...officesToRemove
        ], "officeName") : offices.filter((office)=>!addedOfficesIds.includes(office.officeId));
        setState((state)=>({
                ...state,
                availableOffices: availableOffices
            }));
        setAddedOffices(filteredAddedOffices);
    };
    const removeAll = ()=>{
        removeAddedOffices(addedOffices);
        (0, $ivaD7.setStateData)("checkedAddedOffices", [], setState);
    };
    const setCheckedAvailableOffices = (offices)=>{
        (0, $ivaD7.setStateData)("checkedAvailableOffices", offices, setState);
    };
    const setCheckedAddedOffices = (offices)=>{
        (0, $ivaD7.setStateData)("checkedAddedOffices", offices, setState);
    };
    const moveRight = ()=>{
        if (!state.checkedAvailableOffices || state.checkedAvailableOffices.length === 0) return;
        addOffices(state.checkedAvailableOffices);
        (0, $ivaD7.setStateData)("checkedAvailableOffices", [], setState);
    };
    const moveLeft = ()=>{
        if (!state.checkedAddedOffices || state.checkedAddedOffices.length === 0) return;
        removeAddedOffices(state.checkedAddedOffices);
        (0, $ivaD7.setStateData)("checkedAddedOffices", [], setState);
    };
    const renderedAvailableItems = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hdbmc.AvailableOfficeTable), {
        addOffices: (offices)=>addOffices(offices),
        availableOffices: state.availableOffices,
        hasAvailableOffices: state.availableOffices?.length,
        hasColumnFilters: true,
        setDisplayedOffices: (displayedOffices)=>setState((prevState)=>({
                    ...prevState,
                    displayedOffices: displayedOffices
                })),
        setCheckedAvailableOffices: setCheckedAvailableOffices,
        checkedOffices: state.checkedAvailableOffices
    });
    const renderedAddedItems = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $hdbmc.AddedOfficeTable), {
        addedOffices: addedOffices,
        removeOffices: (offices)=>removeAddedOffices(offices),
        setCheckedAddedOffices: setCheckedAddedOffices
    });
    (0, $acw62.useEffect)(()=>{
        if (!offices?.length) return;
        setState((state)=>({
                ...state,
                availableOffices: offices
            }));
    }, [
        selectedComparisonSetOfficesList
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3RdAS.default), {
        isAddAllDisabled: !state.availableOffices?.length || !state.displayedOffices?.length,
        selectedItems: addedOffices,
        renderedAvailableItems: renderedAvailableItems,
        renderedAddedItems: renderedAddedItems,
        addAll: addAll,
        removeAll: removeAll,
        availableWidth: "60%",
        addedWidth: "38%",
        shouldHideSaveAsListButton: true,
        addSelected: moveRight,
        removeSelected: moveLeft,
        checkedAddedOffices: state.checkedAddedOffices,
        checkedAvailableOffices: state.checkedAvailableOffices
    });
};


const $51b0056c9bebe75e$export$777dcf16f0eb160c = ()=>{
    const { officeGroupName: officeGroupName, setOfficeGroupName: setOfficeGroupName, isOfficeGroupEdit: isOfficeGroupEdit, selectedOfficeGroup: selectedOfficeGroup } = (0, $ae040.useComparisonSetsStore)((state)=>({
            officeGroupName: state.officeGroupName,
            setOfficeGroupName: state.setOfficeGroupName,
            isOfficeGroupEdit: state.isOfficeGroupEdit,
            selectedOfficeGroup: state.selectedOfficeGroup
        }));
    (0, $acw62.useEffect)(()=>{
        if (!isOfficeGroupEdit) return;
        setOfficeGroupName(selectedOfficeGroup.name);
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "d-flex flex-column justify-content-center",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "font-weight-bold mb-1",
                    children: (0, $cstaF.marketShareTerms).officeGroupName
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5txPe))), {
                    dataLwtId: "new-office-group",
                    name: "new-office-group",
                    placeholder: (0, $cstaF.marketShareTerms).newOfficeGroup,
                    type: "text",
                    maxLength: (0, $1ujWz.NAME_MAX_LENGTH),
                    onChange: (e)=>setOfficeGroupName(e.target?.value),
                    value: officeGroupName
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                    className: "my-1",
                    children: (0, $cstaF.marketShareTerms).addNewGroupDescription
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f8c93effe1a162ba$export$2227739de6bd579f), {})
            ]
        })
    });
};



parcelRequire("amkL4");
var $3QXz5 = parcelRequire("3QXz5");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $f61ig = parcelRequire("f61ig");

var $cstaF = parcelRequire("cstaF");

var $ae040 = parcelRequire("ae040");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $7tOHe = parcelRequire("7tOHe");
const $977993c1d995116e$export$750f6b006edcfad0 = ({ setState: setState })=>{
    const { shouldShowDeleteModal: shouldShowDeleteModal, toggleModal: toggleModal, selectedComparisonSet: selectedComparisonSet, selectedOfficeGroup: selectedOfficeGroup, deleteOfficeGroup: deleteOfficeGroup, isLoading: isLoading } = (0, $ae040.useComparisonSetsStore)((state)=>({
            shouldShowDeleteModal: state.shouldShowByModal[(0, $cstaF.comparisonSetsModals).DELETE_OFFICE_GROUP],
            toggleModal: state.toggleModal,
            selectedComparisonSet: state.selectedComparisonSet,
            selectedOfficeGroup: state.selectedOfficeGroup,
            deleteOfficeGroup: state.deleteOfficeGroup,
            isLoading: state.isLoading
        }));
    const closeOfficeGroupDeleteModal = ()=>toggleModal(false, (0, $cstaF.comparisonSetsModals).DELETE_OFFICE_GROUP);
    const handleDelete = ()=>{
        deleteOfficeGroup(selectedComparisonSet, selectedOfficeGroup, setState);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f61ig.default), {
        dataLwtId: "delete-comparison-set-modal",
        onClose: closeOfficeGroupDeleteModal,
        title: /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
            className: "modal-title-md modal-title-wrap",
            children: (0, $cstaF.marketShareTerms).getDeleteOfficeGroup(selectedOfficeGroup?.name)
        }),
        show: shouldShowDeleteModal,
        size: "md",
        buttons: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "d-flex justify-content-end",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                    dataLwtId: "cancel",
                    color: "secondary",
                    onClick: closeOfficeGroupDeleteModal,
                    disabled: isLoading,
                    children: (0, $cstaF.buttonTerms).cancel
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                    dataLwtId: "delete-ok",
                    color: "primary",
                    onClick: handleDelete,
                    disabled: isLoading,
                    children: (0, $cstaF.buttonTerms).ok
                })
            ]
        }),
        children: isLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {}) : null
    });
};


const $fa4d11eb73ac029a$export$5e08000804cf3fa6 = ()=>{
    const officeGroupModal = (0, $cstaF.comparisonSetsModals).OFFICE_GROUP;
    const { setState: csSetState, state: csState } = (0, $1dffa5e53ec16a5b$export$2459d7680d93fd8e)();
    const { shouldShowSaveModal: shouldShowSaveModal, toggleModal: toggleModal, clearState: clearState, isOfficeGroupEdit: isOfficeGroupEdit } = (0, $ae040.useComparisonSetsStore)((state)=>({
            shouldShowSaveModal: state.shouldShowByModal[officeGroupModal],
            toggleModal: state.toggleModal,
            clearState: state.clearState,
            isOfficeGroupEdit: state.isOfficeGroupEdit
        }));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f61ig.default), {
                dataLwtId: "new-office-group-modal",
                onClose: ()=>{
                    toggleModal(false, officeGroupModal);
                    clearState();
                },
                title: isOfficeGroupEdit ? (0, $cstaF.marketShareTerms).editOfficeGroup : (0, $cstaF.marketShareTerms).addNewOfficeGroup,
                show: shouldShowSaveModal,
                size: "xl",
                buttons: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1556e0b73aa03012$export$ae837f3390f056ab), {
                    setState: csSetState
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $51b0056c9bebe75e$export$777dcf16f0eb160c), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3QXz5))), {
                position: "toast-bottom-right",
                dataLwtId: "office-group-toast",
                toastProps: csState.toastProps
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $977993c1d995116e$export$750f6b006edcfad0), {
                setState: csSetState
            })
        ]
    });
};



var $dI25G = parcelRequire("dI25G");

var $eOjgM = parcelRequire("eOjgM");
const $de65f5fa0f203598$var$OfficeGroups = ()=>{
    const { selectedComparisonSet: selectedComparisonSet, selectedMls: selectedMls, handleOfficeGroupsAdd: handleOfficeGroupsAdd, handleOfficeGroupsEdit: handleOfficeGroupsEdit, handleOfficeGroupsDelete: handleOfficeGroupsDelete } = (0, $ae040.useComparisonSetsStore)((state)=>({
            selectedComparisonSet: state.selectedComparisonSet,
            selectedMls: state.selectedMls,
            handleOfficeGroupsAdd: state.handleOfficeGroupsAdd,
            handleOfficeGroupsEdit: state.handleOfficeGroupsEdit,
            handleOfficeGroupsDelete: state.handleOfficeGroupsDelete
        }));
    const hasGroups = selectedComparisonSet?.groups?.length;
    const officeGroupsMap = selectedComparisonSet?.groups?.map((officeGroup)=>{
        const mlsDescription = selectedComparisonSet.shortDescription || selectedMls?.value?.shortDescription;
        const scrollMarginClass = selectedComparisonSet?.groups.length < 11 ? "mr-5" : "mr-4";
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: `d-flex justify-content-between mb-3 ${scrollMarginClass}`,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "btn-link clickable w-100",
                    onClick: ()=>handleOfficeGroupsEdit(officeGroup),
                    children: `${officeGroup.name} (${mlsDescription})`
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                    icon: (0, $eOjgM.trash_can),
                    title: "remove office group icon",
                    className: "clickable",
                    onClick: ()=>handleOfficeGroupsDelete(officeGroup)
                })
            ]
        }, officeGroup.name);
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "d-flex align-items-center my-4 justify-content-between",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                        children: (0, $cstaF.marketShareTerms).officeGroup
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                        dataLwtId: "new-office-group",
                        size: "sm",
                        color: "light",
                        className: "mb-1 text-capitalize d-inline-flex align-items-center",
                        id: "new-office-group",
                        onClick: handleOfficeGroupsAdd,
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aTLkh.default), {
                                className: "mr-1 text-primary",
                                iconName: "add_circle",
                                dataLwtId: "add-icon"
                            }),
                            (0, $cstaF.buttonTerms).newGroup
                        ]
                    })
                ]
            }),
            hasGroups ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                id: "office-group-list-container",
                children: officeGroupsMap
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "helix-card mt-5",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "text-center",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "font-weight-bold mb-0",
                            children: (0, $cstaF.marketShareTerms).noneAdded
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: (0, $cstaF.marketShareTerms).addOfficeGroupMessage
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fa4d11eb73ac029a$export$5e08000804cf3fa6), {})
        ]
    });
};
var $de65f5fa0f203598$export$2e2bcd8739ae039 = $de65f5fa0f203598$var$OfficeGroups;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $f61ig = parcelRequire("f61ig");

var $cstaF = parcelRequire("cstaF");



var $ae040 = parcelRequire("ae040");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $f61ig = parcelRequire("f61ig");

var $cstaF = parcelRequire("cstaF");

var $ae040 = parcelRequire("ae040");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $90ISC = parcelRequire("90ISC");

var $7tOHe = parcelRequire("7tOHe");
const $93e228745d9b0ba9$export$294e00a1ee3e3456 = ({ setState: setState })=>{
    const deleteModal = (0, $cstaF.comparisonSetsModals).DELETE;
    const { shouldShowEditModal: shouldShowEditModal, toggleModal: toggleModal, selectedComparisonSet: selectedComparisonSet, deleteComparisonSet: deleteComparisonSet, isLoading: isLoading } = (0, $ae040.useComparisonSetsStore)((state)=>({
            shouldShowEditModal: state.shouldShowByModal[deleteModal],
            toggleModal: state.toggleModal,
            selectedComparisonSet: state.selectedComparisonSet,
            deleteComparisonSet: state.deleteComparisonSet,
            isLoading: state.isLoading
        }));
    const userInfo = (0, $90ISC.useCommonStore)((state)=>state.userInfo);
    const handleDelete = ()=>deleteComparisonSet(selectedComparisonSet, userInfo.id, setState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $f61ig.default), {
        dataLwtId: "delete-comparison-set-modal",
        onClose: ()=>toggleModal(false, deleteModal),
        title: /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
            className: "modal-title-md modal-title-wrap",
            children: (0, $cstaF.marketShareTerms).getDeleteComparisonSet(selectedComparisonSet?.name)
        }),
        show: shouldShowEditModal,
        size: "md",
        buttons: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "d-flex justify-content-end",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                    dataLwtId: "cancel",
                    color: "secondary",
                    onClick: ()=>toggleModal(false, (0, $cstaF.comparisonSetsModals).DELETE),
                    disabled: isLoading,
                    children: (0, $cstaF.buttonTerms).cancel
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                    dataLwtId: "delete-ok",
                    color: "primary",
                    onClick: handleDelete,
                    disabled: isLoading,
                    children: (0, $cstaF.buttonTerms).ok
                })
            ]
        }),
        children: [
            isLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {}) : null,
            (0, $cstaF.marketShareTerms).deleteComparisonSetDescription
        ]
    });
};


const $d987e26a3f4425cd$export$eb2bd571a33ee45a = ({ defaultMlsOption: defaultMlsOption, state: state, setState: setState, selectedMls: selectedMls })=>{
    const editModal = (0, $cstaF.comparisonSetsModals).EDIT;
    const { shouldShowEditModal: shouldShowEditModal, toggleModal: toggleModal } = (0, $ae040.useComparisonSetsStore)((state)=>({
            shouldShowEditModal: state.shouldShowByModal[editModal],
            toggleModal: state.toggleModal
        }));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            " ",
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f61ig.default), {
                dataLwtId: "edit-comparison-set-modal",
                onClose: ()=>{
                    toggleModal(false, editModal);
                },
                title: (0, $cstaF.marketShareTerms).editComparisonSet,
                show: shouldShowEditModal,
                size: "md",
                buttons: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "d-flex w-100",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                            dataLwtId: "delete-comp-set",
                            color: "danger",
                            className: "mr-auto",
                            onClick: ()=>{
                                toggleModal(true, (0, $cstaF.comparisonSetsModals).DELETE);
                            },
                            children: (0, $cstaF.buttonTerms).delete
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f0408219699e9dd$export$b7dc9c209b6d89c3), {
                            isSaveButtonDisabled: state.isSaveButtonDisabled,
                            setState: setState,
                            defaultMlsOption: defaultMlsOption,
                            isEdit: true,
                            selectedMls: selectedMls
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1eeb2670b34ee70d$export$c50bc281c682c03d), {
                    isEdit: true,
                    shouldShowMlsList: false,
                    setState: setState
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $93e228745d9b0ba9$export$294e00a1ee3e3456), {
                setState: setState
            })
        ]
    });
};
$d987e26a3f4425cd$export$eb2bd571a33ee45a.propTypes = {
    defaultMlsOption: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    state: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    setState: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    selectedMls: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};



var $90ISC = parcelRequire("90ISC");

var $1ujWz = parcelRequire("1ujWz");
const $88aedea088ff4a8f$var$ComparisonSets = ()=>{
    const { state: state, setState: setState, mlsListOptions: mlsListOptions, defaultMlsOption: defaultMlsOption } = (0, $1dffa5e53ec16a5b$export$2459d7680d93fd8e)();
    const { toggleModal: toggleModal, handleSelectedComparisonSet: handleSelectedComparisonSet, selectedComparisonSet: selectedComparisonSet, comparisonSetListOptions: comparisonSetListOptions, handleMlsChange: handleMlsChange } = (0, $ae040.useComparisonSetsStore)((state)=>({
            handleMlsChange: state.handleMlsChange,
            toggleModal: state.toggleModal,
            handleSelectedComparisonSet: state.handleSelectedComparisonSet,
            selectedComparisonSet: state.selectedComparisonSet,
            comparisonSetListOptions: state.comparisonSetListOptions
        }));
    const { mlsList: mlsList } = (0, $90ISC.useCommonStore)((state)=>({
            mlsList: state.mlsList
        }));
    const handleCompSetChange = (value)=>{
        handleSelectedComparisonSet(value);
        const mlsToSet = (0, $1ujWz.getMlsToSet)(mlsList, value);
        handleMlsChange(mlsToSet);
    };
    const [selectedMls, setSelectedMls] = (0, $acw62.useState)(defaultMlsOption);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "m-auto text-center",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        children: (0, $cstaF.marketShareTerms).manageComparisonSets
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        children: (0, $cstaF.marketShareTerms).comparisonSetsDescription
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "bg-white raised-border p-3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "d-flex align-items-center justify-content-between",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                                children: (0, $cstaF.marketShareTerms).comparisonSets
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                                dataLwtId: "new-comparison-set",
                                size: "sm",
                                color: "light",
                                className: "mb-1 text-capitalize d-inline-flex align-items-center",
                                id: "new-comparison-set",
                                onClick: ()=>{
                                    toggleModal(true, (0, $cstaF.comparisonSetsModals).SAVE);
                                    setSelectedMls(defaultMlsOption);
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aTLkh.default), {
                                        className: "mr-1 text-primary",
                                        iconName: "add_circle",
                                        dataLwtId: "add-icon"
                                    }),
                                    (0, $cstaF.buttonTerms).newSet
                                ]
                            })
                        ]
                    }),
                    comparisonSetListOptions?.length ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "d-flex align-items-center",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4TPr9.default), {
                                        dataLwtId: "comparison-sets",
                                        className: "w-100 mr-2",
                                        options: comparisonSetListOptions,
                                        value: selectedComparisonSet,
                                        isClearable: false,
                                        onChange: (value)=>handleCompSetChange(value)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                                        icon: (0, $eOjgM.pencil),
                                        title: "edit icon",
                                        className: "clickable align-top mr-1",
                                        onClick: ()=>{
                                            toggleModal(true, (0, $cstaF.comparisonSetsModals).EDIT);
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $de65f5fa0f203598$export$2e2bcd8739ae039), {})
                        ]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "helix-card mt-5",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "text-center",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "font-weight-bold mb-0",
                                    children: (0, $cstaF.marketShareTerms).noneAdded
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    children: (0, $cstaF.marketShareTerms).addComparisonSetMessage
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $51a2f2df4ae57eae$export$fd16d00ec718efe3), {
                        isSaveButtonDisabled: state.isSaveButtonDisabled,
                        mlsListOptions: mlsListOptions,
                        defaultMlsOption: defaultMlsOption,
                        setState: setState,
                        selectedMls: selectedMls,
                        setSelectedMls: setSelectedMls
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d987e26a3f4425cd$export$eb2bd571a33ee45a), {
                        defaultMlsOption: defaultMlsOption,
                        state: state,
                        setState: setState,
                        selectedMls: (0, $1ujWz.getMlsToSet)(mlsList, selectedComparisonSet)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3QXz5))), {
                position: "toast-bottom-right",
                dataLwtId: "save-list-toasts",
                toastProps: state.toastProps
            })
        ]
    });
};
var $88aedea088ff4a8f$export$2e2bcd8739ae039 = $88aedea088ff4a8f$var$ComparisonSets;



var $cstaF = parcelRequire("cstaF");
const $cc1d18490928ae85$export$8a21ba990ca4a7cb = Object.freeze({
    notifications: "Notifications",
    notificationsIntro: "Edit your notification settings",
    notificationsBrokerUpdates: "Broker Metrics Updates",
    savedAgents: "Saved Agents",
    notificationsSavedAgentsDescription: "While my campaign is active, send me a summary of the activity and engagement for Saved Agents.",
    receiveNotifications: "Receive Notifications",
    saveChanges: "Save Changes",
    weekly: "Weekly",
    every2Weeks: "Every 2 weeks",
    monthly: "Monthly",
    quarterly: "Quarterly",
    never: "Never",
    fortnightly: "Fortnightly"
});
const $cc1d18490928ae85$export$a5ab5bba1b0ec67 = Object.freeze({
    label: $cc1d18490928ae85$export$8a21ba990ca4a7cb.never,
    value: "Never"
});
const $cc1d18490928ae85$export$8b285f7d3d2706d7 = [
    {
        label: $cc1d18490928ae85$export$8a21ba990ca4a7cb.weekly,
        value: "Weekly"
    },
    {
        label: $cc1d18490928ae85$export$8a21ba990ca4a7cb.every2Weeks,
        value: "Fortnightly"
    },
    {
        label: $cc1d18490928ae85$export$8a21ba990ca4a7cb.monthly,
        value: "Monthly"
    },
    {
        label: $cc1d18490928ae85$export$8a21ba990ca4a7cb.quarterly,
        value: "Quarterly"
    },
    $cc1d18490928ae85$export$a5ab5bba1b0ec67
];
const $cc1d18490928ae85$export$d59a45c4e8ad9012 = Object.freeze([
    "Fortnightly_0",
    "Fortnightly_1"
]);



var $cghEn = parcelRequire("cghEn");

var $f6CJ4 = parcelRequire("f6CJ4");

var $kLrt8 = parcelRequire("kLrt8");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $dI25G = parcelRequire("dI25G");

var $eOjgM = parcelRequire("eOjgM");
const $65b0c1d519376a85$export$1d684649f71e1271 = {
    MAX_WIDTH: 290,
    MAX_HEIGHT: 50
};
const $65b0c1d519376a85$export$6b04f01ce1d4998e = {
    branding: "Branding",
    profileTabTitle: (appName)=>`Logo for ${appName} PDF Reports`,
    profileTabDescription: "Insert a logo that you would like to include in your PDF reports.",
    addLogoButton: "Add Logo",
    updateLogoButton: "Update Logo",
    removeLogoButton: "Remove Logo",
    profileTabFileTitle: "File size and accepted formats",
    profileTabFileDescription: `Only one file can be uploaded. The size limit is 2MB. Recommended width: ${$65b0c1d519376a85$export$1d684649f71e1271.MAX_WIDTH}px, height: ${$65b0c1d519376a85$export$1d684649f71e1271.MAX_HEIGHT}px. Accepted file formats include .jpg, and .png.`,
    addLogo: "Add your Logo",
    removeLogoModal: {
        title: "Remove Logo",
        body: "Removing the logo will exclude it from generated PDF reports. Add a logo to ensure it appears on your PDFs.",
        cancelButton: "Cancel",
        confirmButton: "Ok"
    },
    updateLogoModal: {
        title: "Update Logo",
        body: "Uploading this logo will replace your current logo. Are you sure you want to proceed?",
        cancelButton: "Cancel",
        confirmButton: "Ok"
    },
    errorMessages: {
        logoDeleteError: "Error deleting logo:",
        logoUploadError: "Error uploading logo:"
    }
};
const $65b0c1d519376a85$export$215845906c120e7a = {
    maxLogoFileSizeInBytes: 2097152,
    allowedLogoFileTypes: [
        ".jpg",
        ".jpeg",
        ".png"
    ],
    maxNumberOfLogoFiles: 1
};



var $f61ig = parcelRequire("f61ig");

var $dDBOF = parcelRequire("dDBOF");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
var $8533a48c212344aa$exports = {};

var $acw62 = parcelRequire("acw62");
var $3057def7761e7268$exports = {};
"use strict";

$3057def7761e7268$exports = (parcelRequire("jsC5X"));


var $1a3078987c6b1ca7$exports = {};

var $c9Z8w = parcelRequire("c9Z8w");

var $8jN3b = parcelRequire("8jN3b");
var $1a3078987c6b1ca7$require$UppyCore = $8jN3b.Uppy;
const $1a3078987c6b1ca7$var$uppy = $c9Z8w.instanceOf($1a3078987c6b1ca7$require$UppyCore).isRequired; // A list of plugins to mount inside this component.
const $1a3078987c6b1ca7$var$plugins = $c9Z8w.arrayOf($c9Z8w.string); // Language strings for this component.
const $1a3078987c6b1ca7$var$locale = $c9Z8w.shape({
    strings: $c9Z8w.object,
    // eslint-disable-line react/forbid-prop-types
    pluralize: $c9Z8w.func
}); // List of meta fields for the editor in the Dashboard.
const $1a3078987c6b1ca7$var$metaField = $c9Z8w.shape({
    id: $c9Z8w.string.isRequired,
    name: $c9Z8w.string.isRequired,
    placeholder: $c9Z8w.string
});
const $1a3078987c6b1ca7$var$metaFields = $c9Z8w.oneOfType([
    $c9Z8w.arrayOf($1a3078987c6b1ca7$var$metaField),
    $c9Z8w.func
]); // A size in pixels (number) or with some other unit (string).
const $1a3078987c6b1ca7$var$cssSize = $c9Z8w.oneOfType([
    $c9Z8w.string,
    $c9Z8w.number
]); // Common props for dashboardy components (Dashboard and DashboardModal).
const $1a3078987c6b1ca7$var$dashboard = {
    uppy: $1a3078987c6b1ca7$var$uppy,
    inline: $c9Z8w.bool,
    plugins: $1a3078987c6b1ca7$var$plugins,
    width: $1a3078987c6b1ca7$var$cssSize,
    height: $1a3078987c6b1ca7$var$cssSize,
    showProgressDetails: $c9Z8w.bool,
    hideUploadButton: $c9Z8w.bool,
    hideProgressAfterFinish: $c9Z8w.bool,
    note: $c9Z8w.string,
    metaFields: $1a3078987c6b1ca7$var$metaFields,
    proudlyDisplayPoweredByUppy: $c9Z8w.bool,
    disableStatusBar: $c9Z8w.bool,
    disableInformer: $c9Z8w.bool,
    disableThumbnailGenerator: $c9Z8w.bool,
    // pass-through to ThumbnailGenerator
    thumbnailWidth: $c9Z8w.number,
    locale: $1a3078987c6b1ca7$var$locale
};
$1a3078987c6b1ca7$exports = {
    uppy: $1a3078987c6b1ca7$var$uppy,
    locale: $1a3078987c6b1ca7$var$locale,
    dashboard: $1a3078987c6b1ca7$var$dashboard
};


var $8533a48c212344aa$require$basePropTypes = $1a3078987c6b1ca7$exports.dashboard;
var $31f21c585362b3f2$exports = {};
// List taken from React.HTMLAttributes supported properties:
// https://unpkg.com/@types/react@17.0.22/index.d.ts:1821
const $31f21c585362b3f2$var$reactSupportedHtmlAttr = [
    "defaultChecked",
    "defaultValue",
    "suppressContentEditableWarning",
    "suppressHydrationWarning",
    "dangerouslySetInnerHTML",
    "accessKey",
    "className",
    "contentEditable",
    "contextMenu",
    "dir",
    "draggable",
    "hidden",
    "id",
    "lang",
    "placeholder",
    "slot",
    "spellCheck",
    "style",
    "tabIndex",
    "title",
    "translate",
    "radioGroup",
    "role",
    "about",
    "datatype",
    "inlist",
    "prefix",
    "property",
    "resource",
    "typeof",
    "vocab",
    "autoCapitalize",
    "autoCorrect",
    "autoSave",
    "color",
    "itemProp",
    "itemScope",
    "itemType",
    "itemID",
    "itemRef",
    "results",
    "security",
    "unselectable",
    "inputMode",
    "is",
    "onCopy",
    "onCopyCapture",
    "onCut",
    "onCutCapture",
    "onPaste",
    "onPasteCapture",
    "onCompositionEnd",
    "onCompositionEndCapture",
    "onCompositionStart",
    "onCompositionStartCapture",
    "onCompositionUpdate",
    "onCompositionUpdateCapture",
    "onFocus",
    "onFocusCapture",
    "onBlur",
    "onBlurCapture",
    "onChange",
    "onChangeCapture",
    "onBeforeInput",
    "onBeforeInputCapture",
    "onInput",
    "onInputCapture",
    "onReset",
    "onResetCapture",
    "onSubmit",
    "onSubmitCapture",
    "onInvalid",
    "onInvalidCapture",
    "onLoad",
    "onLoadCapture",
    "onError",
    "onErrorCapture",
    // Keyboard Events
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyPress",
    "onKeyPressCapture",
    "onKeyUp",
    "onKeyUpCapture",
    "onAbort",
    "onAbortCapture",
    "onCanPlay",
    "onCanPlayCapture",
    "onCanPlayThrough",
    "onCanPlayThroughCapture",
    "onDurationChange",
    "onDurationChangeCapture",
    "onEmptied",
    "onEmptiedCapture",
    "onEncrypted",
    "onEncryptedCapture",
    "onEnded",
    "onEndedCapture",
    "onLoadedData",
    "onLoadedDataCapture",
    "onLoadedMetadata",
    "onLoadedMetadataCapture",
    "onLoadStart",
    "onLoadStartCapture",
    "onPause",
    "onPauseCapture",
    "onPlay",
    "onPlayCapture",
    "onPlaying",
    "onPlayingCapture",
    "onProgress",
    "onProgressCapture",
    "onRateChange",
    "onRateChangeCapture",
    "onSeeked",
    "onSeekedCapture",
    "onSeeking",
    "onSeekingCapture",
    "onStalled",
    "onStalledCapture",
    "onSuspend",
    "onSuspendCapture",
    "onTimeUpdate",
    "onTimeUpdateCapture",
    "onVolumeChange",
    "onVolumeChangeCapture",
    "onWaiting",
    "onWaitingCapture",
    "onAuxClick",
    "onAuxClickCapture",
    "onClick",
    "onClickCapture",
    "onContextMenu",
    "onContextMenuCapture",
    "onDoubleClick",
    "onDoubleClickCapture",
    "onDrag",
    "onDragCapture",
    "onDragEnd",
    "onDragEndCapture",
    "onDragEnter",
    "onDragEnterCapture",
    "onDragExit",
    "onDragExitCapture",
    "onDragLeave",
    "onDragLeaveCapture",
    "onDragOver",
    "onDragOverCapture",
    "onDragStart",
    "onDragStartCapture",
    "onDrop",
    "onDropCapture",
    "onMouseDown",
    "onMouseDownCapture",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseMove",
    "onMouseMoveCapture",
    "onMouseOut",
    "onMouseOutCapture",
    "onMouseOver",
    "onMouseOverCapture",
    "onMouseUp",
    "onMouseUpCapture",
    "onSelect",
    "onSelectCapture",
    "onTouchCancel",
    "onTouchCancelCapture",
    "onTouchEnd",
    "onTouchEndCapture",
    "onTouchMove",
    "onTouchMoveCapture",
    "onTouchStart",
    "onTouchStartCapture",
    "onPointerDown",
    "onPointerDownCapture",
    "onPointerMove",
    "onPointerMoveCapture",
    "onPointerUp",
    "onPointerUpCapture",
    "onPointerCancel",
    "onPointerCancelCapture",
    "onPointerEnter",
    "onPointerEnterCapture",
    "onPointerLeave",
    "onPointerLeaveCapture",
    "onPointerOver",
    "onPointerOverCapture",
    "onPointerOut",
    "onPointerOutCapture",
    "onGotPointerCapture",
    "onGotPointerCaptureCapture",
    "onLostPointerCapture",
    "onLostPointerCaptureCapture",
    "onScroll",
    "onScrollCapture",
    "onWheel",
    "onWheelCapture",
    "onAnimationStart",
    "onAnimationStartCapture",
    "onAnimationEnd",
    "onAnimationEndCapture",
    "onAnimationIteration",
    "onAnimationIterationCapture",
    "onTransitionEnd",
    "onTransitionEndCapture"
];
const $31f21c585362b3f2$var$validHTMLAttribute = /^(aria-|data-)/;
const $31f21c585362b3f2$var$getHTMLProps = (props)=>{
    // Gets all the React props
    return Object.fromEntries(Object.entries(props).filter((_ref)=>{
        let [key] = _ref;
        return $31f21c585362b3f2$var$validHTMLAttribute.test(key) || $31f21c585362b3f2$var$reactSupportedHtmlAttr.includes(key);
    }));
};
$31f21c585362b3f2$exports = $31f21c585362b3f2$var$getHTMLProps;


var $91c67133b5e6cf5f$exports = {};
"use strict"; // TODO: replace with `Object.hasOwn` when dropping support for older browsers.
const $91c67133b5e6cf5f$var$hasOwn = (obj, key)=>Object.prototype.hasOwnProperty.call(obj, key);
$91c67133b5e6cf5f$exports = function nonHtmlPropsHaveChanged(component, prevProps) {
    return Object.keys(component.props) // TODO: replace `validProps` with an exported `Symbol('htmlProps')`.
    .some((key)=>!$91c67133b5e6cf5f$var$hasOwn(component.validProps, key) && component.props[key] !== prevProps[key]);
};


const $8533a48c212344aa$var$h = $acw62.createElement;
/**
 * React Component that renders a Dashboard for an Uppy instance. This component
 * renders the Dashboard inline, so you can put it anywhere you want.
 */ class $8533a48c212344aa$var$Dashboard extends $acw62.Component {
    componentDidMount() {
        this.installPlugin();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.uppy !== this.props.uppy) {
            this.uninstallPlugin(prevProps);
            this.installPlugin();
        } else if ($91c67133b5e6cf5f$exports(this, prevProps)) {
            const options = {
                ...this.props,
                target: this.container
            };
            delete options.uppy;
            this.plugin.setOptions(options);
        }
    }
    componentWillUnmount() {
        this.uninstallPlugin();
    }
    installPlugin() {
        const { uppy: uppy } = this.props;
        const options = {
            id: "react:Dashboard",
            ...this.props,
            target: this.container
        };
        delete options.uppy;
        uppy.use($3057def7761e7268$exports, options);
        this.plugin = uppy.getPlugin(options.id);
    }
    uninstallPlugin(props) {
        if (props === void 0) props = this.props;
        const { uppy: uppy } = props;
        uppy.removePlugin(this.plugin);
    }
    render() {
        // TODO: stop exposing `validProps` as a public property and rename it to `htmlProps`
        this.validProps = $31f21c585362b3f2$exports(this.props);
        return $8533a48c212344aa$var$h("div", {
            className: "uppy-Container",
            ref: (container)=>{
                this.container = container;
            },
            ...this.validProps
        });
    }
}
$8533a48c212344aa$var$Dashboard.propTypes = $8533a48c212344aa$require$basePropTypes;
$8533a48c212344aa$var$Dashboard.defaultProps = {
    inline: true
};
$8533a48c212344aa$exports = $8533a48c212344aa$var$Dashboard;


var $b261578d7b6a45f0$exports = {};

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");


var $b261578d7b6a45f0$require$basePropTypes = $1a3078987c6b1ca7$exports.dashboard;


const $b261578d7b6a45f0$var$h = $acw62.createElement;
/**
 * React Component that renders a Dashboard for an Uppy instance in a Modal
 * dialog. Visibility of the Modal is toggled using the `open` prop.
 */ class $b261578d7b6a45f0$var$DashboardModal extends $acw62.Component {
    componentDidMount() {
        this.installPlugin();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.uppy !== this.props.uppy) {
            this.uninstallPlugin(prevProps);
            this.installPlugin();
        } else if ($91c67133b5e6cf5f$exports(this, prevProps)) {
            const options = {
                ...this.props,
                onRequestCloseModal: this.props.onRequestClose
            };
            delete options.uppy;
            this.plugin.setOptions(options);
        }
        if (prevProps.open && !this.props.open) this.plugin.closeModal();
        else if (!prevProps.open && this.props.open) this.plugin.openModal();
    }
    componentWillUnmount() {
        this.uninstallPlugin();
    }
    installPlugin() {
        const { uppy: uppy } = this.props;
        const options = {
            id: "react:DashboardModal",
            ...this.props,
            onRequestCloseModal: this.props.onRequestClose
        };
        if (!options.target) options.target = this.container;
        delete options.uppy;
        uppy.use($3057def7761e7268$exports, options);
        this.plugin = uppy.getPlugin(options.id);
        if (this.props.open) this.plugin.openModal();
    }
    uninstallPlugin(props) {
        if (props === void 0) props = this.props;
        const { uppy: uppy } = props;
        uppy.removePlugin(this.plugin);
    }
    render() {
        // TODO: stop exposing `validProps` as a public property and rename it to `htmlProps`
        this.validProps = $31f21c585362b3f2$exports(this.props);
        return $b261578d7b6a45f0$var$h("div", {
            className: "uppy-Container",
            ref: (container)=>{
                this.container = container;
            },
            ...this.validProps
        });
    }
}
$b261578d7b6a45f0$var$DashboardModal.propTypes = {
    target: typeof window !== "undefined" ? $c9Z8w.instanceOf(window.HTMLElement) : $c9Z8w.any,
    open: $c9Z8w.bool,
    onRequestClose: $c9Z8w.func,
    closeModalOnClickOutside: $c9Z8w.bool,
    disablePageScrollWhenModalOpen: $c9Z8w.bool,
    ...$b261578d7b6a45f0$require$basePropTypes
};
$b261578d7b6a45f0$exports = $b261578d7b6a45f0$var$DashboardModal;


var $b1346abbed023a2d$exports = {};

var $acw62 = parcelRequire("acw62");
var $909341d5d3de7a4b$exports = {};
"use strict";

$909341d5d3de7a4b$exports = (parcelRequire("9H7xy"));





const $b1346abbed023a2d$var$h = $acw62.createElement;
/**
 * React component that renders an area in which files can be dropped to be
 * uploaded.
 */ class $b1346abbed023a2d$var$DragDrop extends $acw62.Component {
    componentDidMount() {
        this.installPlugin();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.uppy !== this.props.uppy) {
            this.uninstallPlugin(prevProps);
            this.installPlugin();
        } else if ($91c67133b5e6cf5f$exports(this, prevProps)) {
            const options = {
                ...this.props,
                target: this.container
            };
            delete options.uppy;
            this.plugin.setOptions(options);
        }
    }
    componentWillUnmount() {
        this.uninstallPlugin();
    }
    installPlugin() {
        const { uppy: uppy } = this.props;
        const options = {
            id: "react:DragDrop",
            ...this.props,
            target: this.container
        };
        delete options.uppy;
        uppy.use($909341d5d3de7a4b$exports, options);
        this.plugin = uppy.getPlugin(options.id);
    }
    uninstallPlugin(props) {
        if (props === void 0) props = this.props;
        const { uppy: uppy } = props;
        uppy.removePlugin(this.plugin);
    }
    render() {
        // TODO: stop exposing `validProps` as a public property and rename it to `htmlProps`
        this.validProps = $31f21c585362b3f2$exports(this.props);
        return $b1346abbed023a2d$var$h("div", {
            className: "uppy-Container",
            ref: (container)=>{
                this.container = container;
            },
            ...this.validProps
        });
    }
}
$b1346abbed023a2d$var$DragDrop.propTypes = {
    uppy: $1a3078987c6b1ca7$exports.uppy,
    locale: $1a3078987c6b1ca7$exports.locale
};
$b1346abbed023a2d$var$DragDrop.defaultProps = {};
$b1346abbed023a2d$exports = $b1346abbed023a2d$var$DragDrop;


var $897db680338c717f$exports = {};

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
var $d8afea65639aa8b4$exports = {};
"use strict";

$d8afea65639aa8b4$exports = (parcelRequire("fe7OG"));



var $897db680338c717f$require$uppyPropType = $1a3078987c6b1ca7$exports.uppy;


const $897db680338c717f$var$h = $acw62.createElement;
/**
 * React component that renders a progress bar at the top of the page.
 */ class $897db680338c717f$var$ProgressBar extends $acw62.Component {
    componentDidMount() {
        this.installPlugin();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.uppy !== this.props.uppy) {
            this.uninstallPlugin(prevProps);
            this.installPlugin();
        } else if ($91c67133b5e6cf5f$exports(this, prevProps)) {
            const options = {
                ...this.props,
                target: this.container
            };
            delete options.uppy;
            this.plugin.setOptions(options);
        }
    }
    componentWillUnmount() {
        this.uninstallPlugin();
    }
    installPlugin() {
        const { uppy: uppy } = this.props;
        const options = {
            id: "react:ProgressBar",
            ...this.props,
            target: this.container
        };
        delete options.uppy;
        uppy.use($d8afea65639aa8b4$exports, options);
        this.plugin = uppy.getPlugin(options.id);
    }
    uninstallPlugin(props) {
        if (props === void 0) props = this.props;
        const { uppy: uppy } = props;
        uppy.removePlugin(this.plugin);
    }
    render() {
        // TODO: stop exposing `validProps` as a public property and rename it to `htmlProps`
        this.validProps = $31f21c585362b3f2$exports(this.props);
        return $897db680338c717f$var$h("div", {
            className: "uppy-Container",
            ref: (container)=>{
                this.container = container;
            },
            ...this.validProps
        });
    }
}
$897db680338c717f$var$ProgressBar.propTypes = {
    uppy: $897db680338c717f$require$uppyPropType,
    fixed: $c9Z8w.bool,
    hideAfterFinish: $c9Z8w.bool
};
$897db680338c717f$var$ProgressBar.defaultProps = {};
$897db680338c717f$exports = $897db680338c717f$var$ProgressBar;


var $bb1e8b4d77fe6aac$exports = {};

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $bnV4R = parcelRequire("bnV4R");

var $bb1e8b4d77fe6aac$require$uppyPropType = $1a3078987c6b1ca7$exports.uppy;


const $bb1e8b4d77fe6aac$var$h = $acw62.createElement;
/**
 * React component that renders a status bar containing upload progress and speed,
 * processing progress and pause/resume/cancel controls.
 */ class $bb1e8b4d77fe6aac$var$StatusBar extends $acw62.Component {
    componentDidMount() {
        this.installPlugin();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.uppy !== this.props.uppy) {
            this.uninstallPlugin(prevProps);
            this.installPlugin();
        } else if ($91c67133b5e6cf5f$exports(this, prevProps)) {
            const options = {
                ...this.props,
                target: this.container
            };
            delete options.uppy;
            this.plugin.setOptions(options);
        }
    }
    componentWillUnmount() {
        this.uninstallPlugin();
    }
    installPlugin() {
        const { uppy: uppy } = this.props;
        const options = {
            id: "react:StatusBar",
            ...this.props,
            target: this.container
        };
        delete options.uppy;
        uppy.use($bnV4R, options);
        this.plugin = uppy.getPlugin(options.id);
    }
    uninstallPlugin(props) {
        if (props === void 0) props = this.props;
        const { uppy: uppy } = props;
        uppy.removePlugin(this.plugin);
    }
    render() {
        // TODO: stop exposing `validProps` as a public property and rename it to `htmlProps`
        this.validProps = $31f21c585362b3f2$exports(this.props);
        return $bb1e8b4d77fe6aac$var$h("div", {
            className: "uppy-Container",
            ref: (container)=>{
                this.container = container;
            },
            ...this.validProps
        });
    }
}
$bb1e8b4d77fe6aac$var$StatusBar.propTypes = {
    uppy: $bb1e8b4d77fe6aac$require$uppyPropType,
    hideAfterFinish: $c9Z8w.bool,
    showProgressDetails: $c9Z8w.bool
};
$bb1e8b4d77fe6aac$var$StatusBar.defaultProps = {};
$bb1e8b4d77fe6aac$exports = $bb1e8b4d77fe6aac$var$StatusBar;


var $fd39cab0c62274fa$exports = {};

var $c9Z8w = parcelRequire("c9Z8w");

var $acw62 = parcelRequire("acw62");
var $dbb8dca40ed01bf8$exports = {};
"use strict";

$dbb8dca40ed01bf8$exports = (parcelRequire("jS2Ts"));



const $fd39cab0c62274fa$var$h = $acw62.createElement;
/**
 * React component that renders an area in which files can be dropped to be
 * uploaded.
 */ class $fd39cab0c62274fa$var$FileInput extends $acw62.Component {
    componentDidMount() {
        this.installPlugin();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.uppy !== this.props.uppy) {
            this.uninstallPlugin(prevProps);
            this.installPlugin();
        }
    }
    componentWillUnmount() {
        this.uninstallPlugin();
    }
    installPlugin() {
        const { uppy: uppy } = this.props;
        const options = {
            id: "react:FileInput",
            ...this.props,
            target: this.container
        };
        delete options.uppy;
        uppy.use($dbb8dca40ed01bf8$exports, options);
        this.plugin = uppy.getPlugin(options.id);
    }
    uninstallPlugin(props) {
        if (props === void 0) props = this.props;
        const { uppy: uppy } = props;
        uppy.removePlugin(this.plugin);
    }
    render() {
        return $fd39cab0c62274fa$var$h("div", {
            className: "uppy-Container",
            ref: (container)=>{
                this.container = container;
            }
        });
    }
}
$fd39cab0c62274fa$var$FileInput.propTypes = {
    uppy: $1a3078987c6b1ca7$exports.uppy,
    locale: $1a3078987c6b1ca7$exports.locale,
    pretty: $c9Z8w.bool,
    inputName: $c9Z8w.string
};
$fd39cab0c62274fa$var$FileInput.defaultProps = {};
$fd39cab0c62274fa$exports = $fd39cab0c62274fa$var$FileInput;


var $e42be7707620cea8$exports = {};

var $acw62 = parcelRequire("acw62");
var $e42be7707620cea8$require$useEffect = $acw62.useEffect;
var $e42be7707620cea8$require$useRef = $acw62.useRef;

var $8jN3b = parcelRequire("8jN3b");
var $e42be7707620cea8$require$UppyCore = $8jN3b.Uppy;
$e42be7707620cea8$exports = function useUppy(factory) {
    if (typeof factory !== "function") throw new TypeError("useUppy: expected a function that returns a new Uppy instance");
    const uppy = $e42be7707620cea8$require$useRef(undefined);
    if (uppy.current === undefined) {
        uppy.current = factory();
        if (!(uppy.current instanceof $e42be7707620cea8$require$UppyCore)) throw new TypeError(`useUppy: factory function must return an Uppy instance, got ${typeof uppy.current}`);
    }
    $e42be7707620cea8$require$useEffect(()=>{
        return ()=>{
            uppy.current.close({
                reason: "unmount"
            });
            uppy.current = undefined;
        };
    }, [
        uppy
    ]);
    return uppy.current;
};





var $8jN3b = parcelRequire("8jN3b");
var $031d3ed277981e1d$exports = {};
"use strict";

var $4Kuwt = parcelRequire("4Kuwt");
var $c96b27e1ad914fc3$exports = {};
"use strict";
/**
 * Manages communications with Companion
 */ Object.defineProperty($c96b27e1ad914fc3$exports, "__esModule", {
    value: true
});
$c96b27e1ad914fc3$exports.Socket = $c96b27e1ad914fc3$exports.SearchProvider = $c96b27e1ad914fc3$exports.RequestClient = $c96b27e1ad914fc3$exports.Provider = void 0;
var $231abe6217ec0291$exports = {};
"use strict";
let $231abe6217ec0291$var$_Symbol$for;
function $231abe6217ec0291$var$_classPrivateFieldLooseBase(receiver, privateKey) {
    if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) throw new TypeError("attempted to use private field on non-instance");
    return receiver;
}
var $231abe6217ec0291$var$id = 0;
function $231abe6217ec0291$var$_classPrivateFieldLooseKey(name) {
    return "__private_" + $231abe6217ec0291$var$id++ + "_" + name;
}
var $60e473d132045414$exports = {};
"use strict";
var $25f952e3561be0e1$exports = {};
"use strict";
class $25f952e3561be0e1$var$NetworkError extends Error {
    constructor(error, xhr){
        if (xhr === void 0) xhr = null;
        super(`This looks like a network error, the endpoint might be blocked by an internet provider or a firewall.`);
        this.cause = error;
        this.isNetworkError = true;
        this.request = xhr;
    }
}
$25f952e3561be0e1$exports = $25f952e3561be0e1$var$NetworkError;


/**
 * Wrapper around window.fetch that throws a NetworkError when appropriate
 */ function $60e473d132045414$var$fetchWithNetworkError() {
    return fetch(...arguments).catch((err)=>{
        if (err.name === "AbortError") throw err;
        else throw new $25f952e3561be0e1$exports(err);
    });
}
$60e473d132045414$exports = $60e473d132045414$var$fetchWithNetworkError;


var $84794fa09056b321$exports = {};
"use strict";

var $7sGce = parcelRequire("7sGce");
class $84794fa09056b321$var$ErrorWithCause extends Error {
    constructor(message, options){
        if (options === void 0) options = {};
        super(message);
        this.cause = options.cause;
        if (this.cause && $7sGce(this.cause, "isNetworkError")) this.isNetworkError = this.cause.isNetworkError;
    }
}
$84794fa09056b321$exports = $84794fa09056b321$var$ErrorWithCause;


var $07d211e7eaad990d$exports = {};
"use strict";
class $07d211e7eaad990d$var$AuthError extends Error {
    constructor(){
        super("Authorization required");
        this.name = "AuthError";
        this.isAuthError = true;
    }
}
$07d211e7eaad990d$exports = $07d211e7eaad990d$var$AuthError;


const $231abe6217ec0291$var$packageJson = {
    "version": "2.2.2"
}; // Remove the trailing slash so we can always safely append /xyz.
function $231abe6217ec0291$var$stripSlash(url) {
    return url.replace(/\/$/, "");
}
async function $231abe6217ec0291$var$handleJSONResponse(res) {
    if (res.status === 401) throw new $07d211e7eaad990d$exports();
    const jsonPromise = res.json();
    if (res.status < 200 || res.status > 300) {
        let errMsg = `Failed request with status: ${res.status}. ${res.statusText}`;
        try {
            const errData = await jsonPromise;
            errMsg = errData.message ? `${errMsg} message: ${errData.message}` : errMsg;
            errMsg = errData.requestId ? `${errMsg} request-Id: ${errData.requestId}` : errMsg;
        } finally{
            // eslint-disable-next-line no-unsafe-finally
            throw new Error(errMsg);
        }
    }
    return jsonPromise;
}
var $231abe6217ec0291$var$_companionHeaders = /*#__PURE__*/ $231abe6217ec0291$var$_classPrivateFieldLooseKey("companionHeaders");
var $231abe6217ec0291$var$_getPostResponseFunc = /*#__PURE__*/ $231abe6217ec0291$var$_classPrivateFieldLooseKey("getPostResponseFunc");
var $231abe6217ec0291$var$_getUrl = /*#__PURE__*/ $231abe6217ec0291$var$_classPrivateFieldLooseKey("getUrl");
var $231abe6217ec0291$var$_errorHandler = /*#__PURE__*/ $231abe6217ec0291$var$_classPrivateFieldLooseKey("errorHandler");
$231abe6217ec0291$var$_Symbol$for = Symbol.for("uppy test: getCompanionHeaders");
class $231abe6217ec0291$var$RequestClient {
    constructor(uppy, opts){
        Object.defineProperty(this, $231abe6217ec0291$var$_errorHandler, {
            value: $231abe6217ec0291$var$_errorHandler2
        });
        Object.defineProperty(this, $231abe6217ec0291$var$_getUrl, {
            value: $231abe6217ec0291$var$_getUrl2
        });
        Object.defineProperty(this, $231abe6217ec0291$var$_companionHeaders, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $231abe6217ec0291$var$_getPostResponseFunc, {
            writable: true,
            value: (skip)=>(response)=>skip ? response : this.onReceiveResponse(response)
        });
        this.uppy = uppy;
        this.opts = opts;
        this.onReceiveResponse = this.onReceiveResponse.bind(this);
        this.allowedHeaders = [
            "accept",
            "content-type",
            "uppy-auth-token"
        ];
        this.preflightDone = false;
        $231abe6217ec0291$var$_classPrivateFieldLooseBase(this, $231abe6217ec0291$var$_companionHeaders)[$231abe6217ec0291$var$_companionHeaders] = opts == null ? void 0 : opts.companionHeaders;
    }
    setCompanionHeaders(headers) {
        $231abe6217ec0291$var$_classPrivateFieldLooseBase(this, $231abe6217ec0291$var$_companionHeaders)[$231abe6217ec0291$var$_companionHeaders] = headers;
    }
    [$231abe6217ec0291$var$_Symbol$for]() {
        return $231abe6217ec0291$var$_classPrivateFieldLooseBase(this, $231abe6217ec0291$var$_companionHeaders)[$231abe6217ec0291$var$_companionHeaders];
    }
    get hostname() {
        const { companion: companion } = this.uppy.getState();
        const host = this.opts.companionUrl;
        return $231abe6217ec0291$var$stripSlash(companion && companion[host] ? companion[host] : host);
    }
    headers() {
        return Promise.resolve({
            ...$231abe6217ec0291$var$RequestClient.defaultHeaders,
            ...$231abe6217ec0291$var$_classPrivateFieldLooseBase(this, $231abe6217ec0291$var$_companionHeaders)[$231abe6217ec0291$var$_companionHeaders]
        });
    }
    onReceiveResponse(response) {
        const state = this.uppy.getState();
        const companion = state.companion || {};
        const host = this.opts.companionUrl;
        const { headers: headers } = response; // Store the self-identified domain name for the Companion instance we just hit.
        if (headers.has("i-am") && headers.get("i-am") !== companion[host]) this.uppy.setState({
            companion: {
                ...companion,
                [host]: headers.get("i-am")
            }
        });
        return response;
    }
    preflight(path) {
        if (this.preflightDone) return Promise.resolve(this.allowedHeaders.slice());
        return fetch($231abe6217ec0291$var$_classPrivateFieldLooseBase(this, $231abe6217ec0291$var$_getUrl)[$231abe6217ec0291$var$_getUrl](path), {
            method: "OPTIONS"
        }).then((response)=>{
            if (response.headers.has("access-control-allow-headers")) this.allowedHeaders = response.headers.get("access-control-allow-headers").split(",").map((headerName)=>headerName.trim().toLowerCase());
            this.preflightDone = true;
            return this.allowedHeaders.slice();
        }).catch((err)=>{
            this.uppy.log(`[CompanionClient] unable to make preflight request ${err}`, "warning");
            this.preflightDone = true;
            return this.allowedHeaders.slice();
        });
    }
    preflightAndHeaders(path) {
        return Promise.all([
            this.preflight(path),
            this.headers()
        ]).then((_ref)=>{
            let [allowedHeaders, headers] = _ref;
            // filter to keep only allowed Headers
            Object.keys(headers).forEach((header)=>{
                if (!allowedHeaders.includes(header.toLowerCase())) {
                    this.uppy.log(`[CompanionClient] excluding disallowed header ${header}`);
                    delete headers[header]; // eslint-disable-line no-param-reassign
                }
            });
            return headers;
        });
    }
    get(path, skipPostResponse) {
        const method = "get";
        return this.preflightAndHeaders(path).then((headers)=>$60e473d132045414$exports($231abe6217ec0291$var$_classPrivateFieldLooseBase(this, $231abe6217ec0291$var$_getUrl)[$231abe6217ec0291$var$_getUrl](path), {
                method: method,
                headers: headers,
                credentials: this.opts.companionCookiesRule || "same-origin"
            })).then($231abe6217ec0291$var$_classPrivateFieldLooseBase(this, $231abe6217ec0291$var$_getPostResponseFunc)[$231abe6217ec0291$var$_getPostResponseFunc](skipPostResponse)).then($231abe6217ec0291$var$handleJSONResponse).catch($231abe6217ec0291$var$_classPrivateFieldLooseBase(this, $231abe6217ec0291$var$_errorHandler)[$231abe6217ec0291$var$_errorHandler](method, path));
    }
    post(path, data, skipPostResponse) {
        const method = "post";
        return this.preflightAndHeaders(path).then((headers)=>$60e473d132045414$exports($231abe6217ec0291$var$_classPrivateFieldLooseBase(this, $231abe6217ec0291$var$_getUrl)[$231abe6217ec0291$var$_getUrl](path), {
                method: method,
                headers: headers,
                credentials: this.opts.companionCookiesRule || "same-origin",
                body: JSON.stringify(data)
            })).then($231abe6217ec0291$var$_classPrivateFieldLooseBase(this, $231abe6217ec0291$var$_getPostResponseFunc)[$231abe6217ec0291$var$_getPostResponseFunc](skipPostResponse)).then($231abe6217ec0291$var$handleJSONResponse).catch($231abe6217ec0291$var$_classPrivateFieldLooseBase(this, $231abe6217ec0291$var$_errorHandler)[$231abe6217ec0291$var$_errorHandler](method, path));
    }
    delete(path, data, skipPostResponse) {
        const method = "delete";
        return this.preflightAndHeaders(path).then((headers)=>$60e473d132045414$exports(`${this.hostname}/${path}`, {
                method: method,
                headers: headers,
                credentials: this.opts.companionCookiesRule || "same-origin",
                body: data ? JSON.stringify(data) : null
            })).then($231abe6217ec0291$var$_classPrivateFieldLooseBase(this, $231abe6217ec0291$var$_getPostResponseFunc)[$231abe6217ec0291$var$_getPostResponseFunc](skipPostResponse)).then($231abe6217ec0291$var$handleJSONResponse).catch($231abe6217ec0291$var$_classPrivateFieldLooseBase(this, $231abe6217ec0291$var$_errorHandler)[$231abe6217ec0291$var$_errorHandler](method, path));
    }
}
function $231abe6217ec0291$var$_getUrl2(url) {
    if (/^(https?:|)\/\//.test(url)) return url;
    return `${this.hostname}/${url}`;
}
function $231abe6217ec0291$var$_errorHandler2(method, path) {
    return (err)=>{
        var _err;
        if (!((_err = err) != null && _err.isAuthError)) // eslint-disable-next-line no-param-reassign
        err = new $84794fa09056b321$exports(`Could not ${method} ${$231abe6217ec0291$var$_classPrivateFieldLooseBase(this, $231abe6217ec0291$var$_getUrl)[$231abe6217ec0291$var$_getUrl](path)}`, {
            cause: err
        });
        return Promise.reject(err);
    };
}
$231abe6217ec0291$var$RequestClient.VERSION = $231abe6217ec0291$var$packageJson.version;
$231abe6217ec0291$var$RequestClient.defaultHeaders = {
    Accept: "application/json",
    "Content-Type": "application/json",
    "Uppy-Versions": `@uppy/companion-client=${$231abe6217ec0291$var$RequestClient.VERSION}`
};
$231abe6217ec0291$exports = $231abe6217ec0291$var$RequestClient;


$c96b27e1ad914fc3$exports.RequestClient = $231abe6217ec0291$exports;
var $7d95025c5a5c8c37$exports = {};
"use strict";
var $baf924b7e38f735d$exports = {};
"use strict";
/**
 * This module serves as an Async wrapper for LocalStorage
 */ Object.defineProperty($baf924b7e38f735d$exports, "__esModule", {
    value: true
});
$baf924b7e38f735d$exports.getItem = $baf924b7e38f735d$var$getItem;
$baf924b7e38f735d$exports.removeItem = $baf924b7e38f735d$var$removeItem;
$baf924b7e38f735d$exports.setItem = $baf924b7e38f735d$var$setItem;
function $baf924b7e38f735d$var$setItem(key, value) {
    return new Promise((resolve)=>{
        localStorage.setItem(key, value);
        resolve();
    });
}
function $baf924b7e38f735d$var$getItem(key) {
    return Promise.resolve(localStorage.getItem(key));
}
function $baf924b7e38f735d$var$removeItem(key) {
    return new Promise((resolve)=>{
        localStorage.removeItem(key);
        resolve();
    });
}



const $7d95025c5a5c8c37$var$getName = (id)=>{
    return id.split("-").map((s)=>s.charAt(0).toUpperCase() + s.slice(1)).join(" ");
};
class $7d95025c5a5c8c37$var$Provider extends $231abe6217ec0291$exports {
    constructor(uppy, opts){
        super(uppy, opts);
        this.provider = opts.provider;
        this.id = this.provider;
        this.name = this.opts.name || $7d95025c5a5c8c37$var$getName(this.id);
        this.pluginId = this.opts.pluginId;
        this.tokenKey = `companion-${this.pluginId}-auth-token`;
        this.companionKeysParams = this.opts.companionKeysParams;
        this.preAuthToken = null;
    }
    headers() {
        return Promise.all([
            super.headers(),
            this.getAuthToken()
        ]).then((_ref)=>{
            let [headers, token] = _ref;
            const authHeaders = {};
            if (token) authHeaders["uppy-auth-token"] = token;
            if (this.companionKeysParams) authHeaders["uppy-credentials-params"] = btoa(JSON.stringify({
                params: this.companionKeysParams
            }));
            return {
                ...headers,
                ...authHeaders
            };
        });
    }
    onReceiveResponse(response) {
        response = super.onReceiveResponse(response); // eslint-disable-line no-param-reassign
        const plugin = this.uppy.getPlugin(this.pluginId);
        const oldAuthenticated = plugin.getPluginState().authenticated;
        const authenticated = oldAuthenticated ? response.status !== 401 : response.status < 400;
        plugin.setPluginState({
            authenticated: authenticated
        });
        return response;
    }
    setAuthToken(token) {
        return this.uppy.getPlugin(this.pluginId).storage.setItem(this.tokenKey, token);
    }
    getAuthToken() {
        return this.uppy.getPlugin(this.pluginId).storage.getItem(this.tokenKey);
    }
    /**
   * Ensure we have a preauth token if necessary. Attempts to fetch one if we don't,
   * or rejects if loading one fails.
   */ async ensurePreAuth() {
        if (this.companionKeysParams && !this.preAuthToken) {
            await this.fetchPreAuthToken();
            if (!this.preAuthToken) throw new Error("Could not load authentication data required for third-party login. Please try again later.");
        }
    }
    authUrl(queries) {
        if (queries === void 0) queries = {};
        const params = new URLSearchParams(queries);
        if (this.preAuthToken) params.set("uppyPreAuthToken", this.preAuthToken);
        return `${this.hostname}/${this.id}/connect?${params}`;
    }
    fileUrl(id) {
        return `${this.hostname}/${this.id}/get/${id}`;
    }
    async fetchPreAuthToken() {
        if (!this.companionKeysParams) return;
        try {
            const res = await this.post(`${this.id}/preauth/`, {
                params: this.companionKeysParams
            });
            this.preAuthToken = res.token;
        } catch (err) {
            this.uppy.log(`[CompanionClient] unable to fetch preAuthToken ${err}`, "warning");
        }
    }
    list(directory) {
        return this.get(`${this.id}/list/${directory || ""}`);
    }
    logout() {
        return this.get(`${this.id}/logout`).then((response)=>Promise.all([
                response,
                this.uppy.getPlugin(this.pluginId).storage.removeItem(this.tokenKey)
            ])).then((_ref2)=>{
            let [response] = _ref2;
            return response;
        });
    }
    static initPlugin(plugin, opts, defaultOpts) {
        /* eslint-disable no-param-reassign */ plugin.type = "acquirer";
        plugin.files = [];
        if (defaultOpts) plugin.opts = {
            ...defaultOpts,
            ...opts
        };
        if (opts.serverUrl || opts.serverPattern) throw new Error("`serverUrl` and `serverPattern` have been renamed to `companionUrl` and `companionAllowedHosts` respectively in the 0.30.5 release. Please consult the docs (for example, https://uppy.io/docs/instagram/ for the Instagram plugin) and use the updated options.`");
        if (opts.companionAllowedHosts) {
            const pattern = opts.companionAllowedHosts; // validate companionAllowedHosts param
            if (typeof pattern !== "string" && !Array.isArray(pattern) && !(pattern instanceof RegExp)) throw new TypeError(`${plugin.id}: the option "companionAllowedHosts" must be one of string, Array, RegExp`);
            plugin.opts.companionAllowedHosts = pattern;
        } else if (/^(?!https?:\/\/).*$/i.test(opts.companionUrl)) // does not start with https://
        plugin.opts.companionAllowedHosts = `https://${opts.companionUrl.replace(/^\/\//, "")}`;
        else plugin.opts.companionAllowedHosts = new URL(opts.companionUrl).origin;
        plugin.storage = plugin.opts.storage || $baf924b7e38f735d$exports;
    /* eslint-enable no-param-reassign */ }
}
$7d95025c5a5c8c37$exports = $7d95025c5a5c8c37$var$Provider;


$c96b27e1ad914fc3$exports.Provider = $7d95025c5a5c8c37$exports;
var $4049db9e7b85e232$exports = {};
"use strict";

const $4049db9e7b85e232$var$getName = (id)=>{
    return id.split("-").map((s)=>s.charAt(0).toUpperCase() + s.slice(1)).join(" ");
};
class $4049db9e7b85e232$var$SearchProvider extends $231abe6217ec0291$exports {
    constructor(uppy, opts){
        super(uppy, opts);
        this.provider = opts.provider;
        this.id = this.provider;
        this.name = this.opts.name || $4049db9e7b85e232$var$getName(this.id);
        this.pluginId = this.opts.pluginId;
    }
    fileUrl(id) {
        return `${this.hostname}/search/${this.id}/get/${id}`;
    }
    search(text, queries) {
        return this.get(`search/${this.id}/list?q=${encodeURIComponent(text)}${queries ? `&${queries}` : ""}`);
    }
}
$4049db9e7b85e232$exports = $4049db9e7b85e232$var$SearchProvider;


$c96b27e1ad914fc3$exports.SearchProvider = $4049db9e7b85e232$exports;
var $a7198bfe5dc325b9$exports = {};
"use strict";
let $a7198bfe5dc325b9$var$_Symbol$for, $a7198bfe5dc325b9$var$_Symbol$for2;
function $a7198bfe5dc325b9$var$_classPrivateFieldLooseBase(receiver, privateKey) {
    if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) throw new TypeError("attempted to use private field on non-instance");
    return receiver;
}
var $a7198bfe5dc325b9$var$id = 0;
function $a7198bfe5dc325b9$var$_classPrivateFieldLooseKey(name) {
    return "__private_" + $a7198bfe5dc325b9$var$id++ + "_" + name;
}

var $5E2ck = parcelRequire("5E2ck");
var $a7198bfe5dc325b9$var$_queued = /*#__PURE__*/ $a7198bfe5dc325b9$var$_classPrivateFieldLooseKey("queued");
var $a7198bfe5dc325b9$var$_emitter = /*#__PURE__*/ $a7198bfe5dc325b9$var$_classPrivateFieldLooseKey("emitter");
var $a7198bfe5dc325b9$var$_isOpen = /*#__PURE__*/ $a7198bfe5dc325b9$var$_classPrivateFieldLooseKey("isOpen");
var $a7198bfe5dc325b9$var$_socket = /*#__PURE__*/ $a7198bfe5dc325b9$var$_classPrivateFieldLooseKey("socket");
var $a7198bfe5dc325b9$var$_handleMessage = /*#__PURE__*/ $a7198bfe5dc325b9$var$_classPrivateFieldLooseKey("handleMessage");
$a7198bfe5dc325b9$var$_Symbol$for = Symbol.for("uppy test: getSocket");
$a7198bfe5dc325b9$var$_Symbol$for2 = Symbol.for("uppy test: getQueued");
class $a7198bfe5dc325b9$var$UppySocket {
    constructor(opts){
        Object.defineProperty(this, $a7198bfe5dc325b9$var$_queued, {
            writable: true,
            value: []
        });
        Object.defineProperty(this, $a7198bfe5dc325b9$var$_emitter, {
            writable: true,
            value: $5E2ck()
        });
        Object.defineProperty(this, $a7198bfe5dc325b9$var$_isOpen, {
            writable: true,
            value: false
        });
        Object.defineProperty(this, $a7198bfe5dc325b9$var$_socket, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $a7198bfe5dc325b9$var$_handleMessage, {
            writable: true,
            value: (e)=>{
                try {
                    const message = JSON.parse(e.data);
                    this.emit(message.action, message.payload);
                } catch (err) {
                    // TODO: use a more robust error handler.
                    console.log(err); // eslint-disable-line no-console
                }
            }
        });
        this.opts = opts;
        if (!opts || opts.autoOpen !== false) this.open();
    }
    get isOpen() {
        return $a7198bfe5dc325b9$var$_classPrivateFieldLooseBase(this, $a7198bfe5dc325b9$var$_isOpen)[$a7198bfe5dc325b9$var$_isOpen];
    }
    [$a7198bfe5dc325b9$var$_Symbol$for]() {
        return $a7198bfe5dc325b9$var$_classPrivateFieldLooseBase(this, $a7198bfe5dc325b9$var$_socket)[$a7198bfe5dc325b9$var$_socket];
    }
    [$a7198bfe5dc325b9$var$_Symbol$for2]() {
        return $a7198bfe5dc325b9$var$_classPrivateFieldLooseBase(this, $a7198bfe5dc325b9$var$_queued)[$a7198bfe5dc325b9$var$_queued];
    }
    open() {
        $a7198bfe5dc325b9$var$_classPrivateFieldLooseBase(this, $a7198bfe5dc325b9$var$_socket)[$a7198bfe5dc325b9$var$_socket] = new WebSocket(this.opts.target);
        $a7198bfe5dc325b9$var$_classPrivateFieldLooseBase(this, $a7198bfe5dc325b9$var$_socket)[$a7198bfe5dc325b9$var$_socket].onopen = ()=>{
            $a7198bfe5dc325b9$var$_classPrivateFieldLooseBase(this, $a7198bfe5dc325b9$var$_isOpen)[$a7198bfe5dc325b9$var$_isOpen] = true;
            while($a7198bfe5dc325b9$var$_classPrivateFieldLooseBase(this, $a7198bfe5dc325b9$var$_queued)[$a7198bfe5dc325b9$var$_queued].length > 0 && $a7198bfe5dc325b9$var$_classPrivateFieldLooseBase(this, $a7198bfe5dc325b9$var$_isOpen)[$a7198bfe5dc325b9$var$_isOpen]){
                const first = $a7198bfe5dc325b9$var$_classPrivateFieldLooseBase(this, $a7198bfe5dc325b9$var$_queued)[$a7198bfe5dc325b9$var$_queued].shift();
                this.send(first.action, first.payload);
            }
        };
        $a7198bfe5dc325b9$var$_classPrivateFieldLooseBase(this, $a7198bfe5dc325b9$var$_socket)[$a7198bfe5dc325b9$var$_socket].onclose = ()=>{
            $a7198bfe5dc325b9$var$_classPrivateFieldLooseBase(this, $a7198bfe5dc325b9$var$_isOpen)[$a7198bfe5dc325b9$var$_isOpen] = false;
        };
        $a7198bfe5dc325b9$var$_classPrivateFieldLooseBase(this, $a7198bfe5dc325b9$var$_socket)[$a7198bfe5dc325b9$var$_socket].onmessage = $a7198bfe5dc325b9$var$_classPrivateFieldLooseBase(this, $a7198bfe5dc325b9$var$_handleMessage)[$a7198bfe5dc325b9$var$_handleMessage];
    }
    close() {
        var _classPrivateFieldLoo;
        (_classPrivateFieldLoo = $a7198bfe5dc325b9$var$_classPrivateFieldLooseBase(this, $a7198bfe5dc325b9$var$_socket)[$a7198bfe5dc325b9$var$_socket]) == null || _classPrivateFieldLoo.close();
    }
    send(action, payload) {
        // attach uuid
        if (!$a7198bfe5dc325b9$var$_classPrivateFieldLooseBase(this, $a7198bfe5dc325b9$var$_isOpen)[$a7198bfe5dc325b9$var$_isOpen]) {
            $a7198bfe5dc325b9$var$_classPrivateFieldLooseBase(this, $a7198bfe5dc325b9$var$_queued)[$a7198bfe5dc325b9$var$_queued].push({
                action: action,
                payload: payload
            });
            return;
        }
        $a7198bfe5dc325b9$var$_classPrivateFieldLooseBase(this, $a7198bfe5dc325b9$var$_socket)[$a7198bfe5dc325b9$var$_socket].send(JSON.stringify({
            action: action,
            payload: payload
        }));
    }
    on(action, handler) {
        $a7198bfe5dc325b9$var$_classPrivateFieldLooseBase(this, $a7198bfe5dc325b9$var$_emitter)[$a7198bfe5dc325b9$var$_emitter].on(action, handler);
    }
    emit(action, payload) {
        $a7198bfe5dc325b9$var$_classPrivateFieldLooseBase(this, $a7198bfe5dc325b9$var$_emitter)[$a7198bfe5dc325b9$var$_emitter].emit(action, payload);
    }
    once(action, handler) {
        $a7198bfe5dc325b9$var$_classPrivateFieldLooseBase(this, $a7198bfe5dc325b9$var$_emitter)[$a7198bfe5dc325b9$var$_emitter].once(action, handler);
    }
}
$a7198bfe5dc325b9$exports = $a7198bfe5dc325b9$var$UppySocket;


$c96b27e1ad914fc3$exports.Socket = $a7198bfe5dc325b9$exports;


var $e9e08aa686829a96$exports = {};
"use strict";
Object.defineProperty($e9e08aa686829a96$exports, "__esModule", {
    value: true
});
$e9e08aa686829a96$exports.internalRateLimitedQueue = $e9e08aa686829a96$exports.RateLimitedQueue = void 0;
function $e9e08aa686829a96$var$_classPrivateFieldLooseBase(receiver, privateKey) {
    if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) throw new TypeError("attempted to use private field on non-instance");
    return receiver;
}
var $e9e08aa686829a96$var$id = 0;
function $e9e08aa686829a96$var$_classPrivateFieldLooseKey(name) {
    return "__private_" + $e9e08aa686829a96$var$id++ + "_" + name;
}
function $e9e08aa686829a96$var$createCancelError() {
    return new Error("Cancelled");
}
var $e9e08aa686829a96$var$_activeRequests = /*#__PURE__*/ $e9e08aa686829a96$var$_classPrivateFieldLooseKey("activeRequests");
var $e9e08aa686829a96$var$_queuedHandlers = /*#__PURE__*/ $e9e08aa686829a96$var$_classPrivateFieldLooseKey("queuedHandlers");
var $e9e08aa686829a96$var$_paused = /*#__PURE__*/ $e9e08aa686829a96$var$_classPrivateFieldLooseKey("paused");
var $e9e08aa686829a96$var$_pauseTimer = /*#__PURE__*/ $e9e08aa686829a96$var$_classPrivateFieldLooseKey("pauseTimer");
var $e9e08aa686829a96$var$_downLimit = /*#__PURE__*/ $e9e08aa686829a96$var$_classPrivateFieldLooseKey("downLimit");
var $e9e08aa686829a96$var$_upperLimit = /*#__PURE__*/ $e9e08aa686829a96$var$_classPrivateFieldLooseKey("upperLimit");
var $e9e08aa686829a96$var$_rateLimitingTimer = /*#__PURE__*/ $e9e08aa686829a96$var$_classPrivateFieldLooseKey("rateLimitingTimer");
var $e9e08aa686829a96$var$_call = /*#__PURE__*/ $e9e08aa686829a96$var$_classPrivateFieldLooseKey("call");
var $e9e08aa686829a96$var$_queueNext = /*#__PURE__*/ $e9e08aa686829a96$var$_classPrivateFieldLooseKey("queueNext");
var $e9e08aa686829a96$var$_next = /*#__PURE__*/ $e9e08aa686829a96$var$_classPrivateFieldLooseKey("next");
var $e9e08aa686829a96$var$_queue = /*#__PURE__*/ $e9e08aa686829a96$var$_classPrivateFieldLooseKey("queue");
var $e9e08aa686829a96$var$_dequeue = /*#__PURE__*/ $e9e08aa686829a96$var$_classPrivateFieldLooseKey("dequeue");
var $e9e08aa686829a96$var$_resume = /*#__PURE__*/ $e9e08aa686829a96$var$_classPrivateFieldLooseKey("resume");
var $e9e08aa686829a96$var$_increaseLimit = /*#__PURE__*/ $e9e08aa686829a96$var$_classPrivateFieldLooseKey("increaseLimit");
class $e9e08aa686829a96$var$RateLimitedQueue {
    constructor(limit){
        Object.defineProperty(this, $e9e08aa686829a96$var$_dequeue, {
            value: $e9e08aa686829a96$var$_dequeue2
        });
        Object.defineProperty(this, $e9e08aa686829a96$var$_queue, {
            value: $e9e08aa686829a96$var$_queue2
        });
        Object.defineProperty(this, $e9e08aa686829a96$var$_next, {
            value: $e9e08aa686829a96$var$_next2
        });
        Object.defineProperty(this, $e9e08aa686829a96$var$_queueNext, {
            value: $e9e08aa686829a96$var$_queueNext2
        });
        Object.defineProperty(this, $e9e08aa686829a96$var$_call, {
            value: $e9e08aa686829a96$var$_call2
        });
        Object.defineProperty(this, $e9e08aa686829a96$var$_activeRequests, {
            writable: true,
            value: 0
        });
        Object.defineProperty(this, $e9e08aa686829a96$var$_queuedHandlers, {
            writable: true,
            value: []
        });
        Object.defineProperty(this, $e9e08aa686829a96$var$_paused, {
            writable: true,
            value: false
        });
        Object.defineProperty(this, $e9e08aa686829a96$var$_pauseTimer, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $e9e08aa686829a96$var$_downLimit, {
            writable: true,
            value: 1
        });
        Object.defineProperty(this, $e9e08aa686829a96$var$_upperLimit, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $e9e08aa686829a96$var$_rateLimitingTimer, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $e9e08aa686829a96$var$_resume, {
            writable: true,
            value: ()=>this.resume()
        });
        Object.defineProperty(this, $e9e08aa686829a96$var$_increaseLimit, {
            writable: true,
            value: ()=>{
                if ($e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_paused)[$e9e08aa686829a96$var$_paused]) {
                    $e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_rateLimitingTimer)[$e9e08aa686829a96$var$_rateLimitingTimer] = setTimeout($e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_increaseLimit)[$e9e08aa686829a96$var$_increaseLimit], 0);
                    return;
                }
                $e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_downLimit)[$e9e08aa686829a96$var$_downLimit] = this.limit;
                this.limit = Math.ceil(($e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_upperLimit)[$e9e08aa686829a96$var$_upperLimit] + $e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_downLimit)[$e9e08aa686829a96$var$_downLimit]) / 2);
                for(let i = $e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_downLimit)[$e9e08aa686829a96$var$_downLimit]; i <= this.limit; i++)$e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_queueNext)[$e9e08aa686829a96$var$_queueNext]();
                if ($e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_upperLimit)[$e9e08aa686829a96$var$_upperLimit] - $e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_downLimit)[$e9e08aa686829a96$var$_downLimit] > 3) $e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_rateLimitingTimer)[$e9e08aa686829a96$var$_rateLimitingTimer] = setTimeout($e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_increaseLimit)[$e9e08aa686829a96$var$_increaseLimit], 2000);
                else $e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_downLimit)[$e9e08aa686829a96$var$_downLimit] = Math.floor($e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_downLimit)[$e9e08aa686829a96$var$_downLimit] / 2);
            }
        });
        if (typeof limit !== "number" || limit === 0) this.limit = Infinity;
        else this.limit = limit;
    }
    run(fn, queueOptions) {
        if (!$e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_paused)[$e9e08aa686829a96$var$_paused] && $e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_activeRequests)[$e9e08aa686829a96$var$_activeRequests] < this.limit) return $e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_call)[$e9e08aa686829a96$var$_call](fn);
        return $e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_queue)[$e9e08aa686829a96$var$_queue](fn, queueOptions);
    }
    wrapPromiseFunction(fn, queueOptions) {
        var _this = this;
        return function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            let queuedRequest;
            const outerPromise = new Promise((resolve, reject)=>{
                queuedRequest = _this.run(()=>{
                    let cancelError;
                    let innerPromise;
                    try {
                        innerPromise = Promise.resolve(fn(...args));
                    } catch (err) {
                        innerPromise = Promise.reject(err);
                    }
                    innerPromise.then((result)=>{
                        if (cancelError) reject(cancelError);
                        else {
                            queuedRequest.done();
                            resolve(result);
                        }
                    }, (err)=>{
                        if (cancelError) reject(cancelError);
                        else {
                            queuedRequest.done();
                            reject(err);
                        }
                    });
                    return ()=>{
                        cancelError = $e9e08aa686829a96$var$createCancelError();
                    };
                }, queueOptions);
            });
            outerPromise.abort = ()=>{
                queuedRequest.abort();
            };
            return outerPromise;
        };
    }
    resume() {
        $e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_paused)[$e9e08aa686829a96$var$_paused] = false;
        clearTimeout($e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_pauseTimer)[$e9e08aa686829a96$var$_pauseTimer]);
        for(let i = 0; i < this.limit; i++)$e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_queueNext)[$e9e08aa686829a96$var$_queueNext]();
    }
    /**
   * Freezes the queue for a while or indefinitely.
   *
   * @param {number | null } [duration] Duration for the pause to happen, in milliseconds.
   *                                    If omitted, the queue won't resume automatically.
   */ pause(duration) {
        if (duration === void 0) duration = null;
        $e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_paused)[$e9e08aa686829a96$var$_paused] = true;
        clearTimeout($e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_pauseTimer)[$e9e08aa686829a96$var$_pauseTimer]);
        if (duration != null) $e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_pauseTimer)[$e9e08aa686829a96$var$_pauseTimer] = setTimeout($e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_resume)[$e9e08aa686829a96$var$_resume], duration);
    }
    /**
   * Pauses the queue for a duration, and lower the limit of concurrent requests
   * when the queue resumes. When the queue resumes, it tries to progressively
   * increase the limit in `this.#increaseLimit` until another call is made to
   * `this.rateLimit`.
   * Call this function when using the RateLimitedQueue for network requests and
   * the remote server responds with 429 HTTP code.
   *
   * @param {number} duration in milliseconds.
   */ rateLimit(duration) {
        clearTimeout($e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_rateLimitingTimer)[$e9e08aa686829a96$var$_rateLimitingTimer]);
        this.pause(duration);
        if (this.limit > 1 && Number.isFinite(this.limit)) {
            $e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_upperLimit)[$e9e08aa686829a96$var$_upperLimit] = this.limit - 1;
            this.limit = $e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_downLimit)[$e9e08aa686829a96$var$_downLimit];
            $e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_rateLimitingTimer)[$e9e08aa686829a96$var$_rateLimitingTimer] = setTimeout($e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_increaseLimit)[$e9e08aa686829a96$var$_increaseLimit], duration);
        }
    }
    get isPaused() {
        return $e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_paused)[$e9e08aa686829a96$var$_paused];
    }
}
$e9e08aa686829a96$exports.RateLimitedQueue = $e9e08aa686829a96$var$RateLimitedQueue;
function $e9e08aa686829a96$var$_call2(fn) {
    $e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_activeRequests)[$e9e08aa686829a96$var$_activeRequests] += 1;
    let done = false;
    let cancelActive;
    try {
        cancelActive = fn();
    } catch (err) {
        $e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_activeRequests)[$e9e08aa686829a96$var$_activeRequests] -= 1;
        throw err;
    }
    return {
        abort: ()=>{
            if (done) return;
            done = true;
            $e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_activeRequests)[$e9e08aa686829a96$var$_activeRequests] -= 1;
            cancelActive();
            $e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_queueNext)[$e9e08aa686829a96$var$_queueNext]();
        },
        done: ()=>{
            if (done) return;
            done = true;
            $e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_activeRequests)[$e9e08aa686829a96$var$_activeRequests] -= 1;
            $e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_queueNext)[$e9e08aa686829a96$var$_queueNext]();
        }
    };
}
function $e9e08aa686829a96$var$_queueNext2() {
    // Do it soon but not immediately, this allows clearing out the entire queue synchronously
    // one by one without continuously _advancing_ it (and starting new tasks before immediately
    // aborting them)
    queueMicrotask(()=>$e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_next)[$e9e08aa686829a96$var$_next]());
}
function $e9e08aa686829a96$var$_next2() {
    if ($e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_paused)[$e9e08aa686829a96$var$_paused] || $e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_activeRequests)[$e9e08aa686829a96$var$_activeRequests] >= this.limit) return;
    if ($e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_queuedHandlers)[$e9e08aa686829a96$var$_queuedHandlers].length === 0) return;
     // Dispatch the next request, and update the abort/done handlers
    // so that cancelling it does the Right Thing (and doesn't just try
    // to dequeue an already-running request).
    const next = $e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_queuedHandlers)[$e9e08aa686829a96$var$_queuedHandlers].shift();
    const handler = $e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_call)[$e9e08aa686829a96$var$_call](next.fn);
    next.abort = handler.abort;
    next.done = handler.done;
}
function $e9e08aa686829a96$var$_queue2(fn, options) {
    if (options === void 0) options = {};
    const handler = {
        fn: fn,
        priority: options.priority || 0,
        abort: ()=>{
            $e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_dequeue)[$e9e08aa686829a96$var$_dequeue](handler);
        },
        done: ()=>{
            throw new Error("Cannot mark a queued request as done: this indicates a bug");
        }
    };
    const index = $e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_queuedHandlers)[$e9e08aa686829a96$var$_queuedHandlers].findIndex((other)=>{
        return handler.priority > other.priority;
    });
    if (index === -1) $e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_queuedHandlers)[$e9e08aa686829a96$var$_queuedHandlers].push(handler);
    else $e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_queuedHandlers)[$e9e08aa686829a96$var$_queuedHandlers].splice(index, 0, handler);
    return handler;
}
function $e9e08aa686829a96$var$_dequeue2(handler) {
    const index = $e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_queuedHandlers)[$e9e08aa686829a96$var$_queuedHandlers].indexOf(handler);
    if (index !== -1) $e9e08aa686829a96$var$_classPrivateFieldLooseBase(this, $e9e08aa686829a96$var$_queuedHandlers)[$e9e08aa686829a96$var$_queuedHandlers].splice(index, 1);
}
const $e9e08aa686829a96$var$internalRateLimitedQueue = Symbol("__queue");
$e9e08aa686829a96$exports.internalRateLimitedQueue = $e9e08aa686829a96$var$internalRateLimitedQueue;



var $7Vc9T = parcelRequire("7Vc9T");
var $902d716efc9cbfc2$exports = {};
"use strict";

var $eMXxl = parcelRequire("eMXxl");
function $902d716efc9cbfc2$var$emitSocketProgress(uploader, progressData, file) {
    const { progress: progress, bytesUploaded: bytesUploaded, bytesTotal: bytesTotal } = progressData;
    if (progress) {
        uploader.uppy.log(`Upload progress: ${progress}`);
        uploader.uppy.emit("upload-progress", file, {
            uploader: uploader,
            bytesUploaded: bytesUploaded,
            bytesTotal: bytesTotal
        });
    }
}
$902d716efc9cbfc2$exports = $eMXxl($902d716efc9cbfc2$var$emitSocketProgress, 300, {
    leading: true,
    trailing: true
});


var $6cbe13326f7078be$exports = {};
"use strict";
function $6cbe13326f7078be$var$getSocketHost(url) {
    // get the host domain
    const regex = /^(?:https?:\/\/|\/\/)?(?:[^@\n]+@)?(?:www\.)?([^\n]+)/i;
    const host = regex.exec(url)[1];
    const socketProtocol = /^http:\/\//i.test(url) ? "ws" : "wss";
    return `${socketProtocol}://${host}`;
}
$6cbe13326f7078be$exports = $6cbe13326f7078be$var$getSocketHost;


var $cf2f85f9e33c0866$exports = {};
"use strict";
function $cf2f85f9e33c0866$var$settle(promises) {
    const resolutions = [];
    const rejections = [];
    function resolved(value) {
        resolutions.push(value);
    }
    function rejected(error) {
        rejections.push(error);
    }
    const wait = Promise.all(promises.map((promise)=>promise.then(resolved, rejected)));
    return wait.then(()=>{
        return {
            successful: resolutions,
            failed: rejections
        };
    });
}
$cf2f85f9e33c0866$exports = $cf2f85f9e33c0866$var$settle;


var $0ec9e6f48df9bac4$exports = {};
"use strict";
function $0ec9e6f48df9bac4$var$_classPrivateFieldLooseBase(receiver, privateKey) {
    if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) throw new TypeError("attempted to use private field on non-instance");
    return receiver;
}
var $0ec9e6f48df9bac4$var$id = 0;
function $0ec9e6f48df9bac4$var$_classPrivateFieldLooseKey(name) {
    return "__private_" + $0ec9e6f48df9bac4$var$id++ + "_" + name;
}
var $0ec9e6f48df9bac4$var$_emitter = /*#__PURE__*/ $0ec9e6f48df9bac4$var$_classPrivateFieldLooseKey("emitter");
var $0ec9e6f48df9bac4$var$_events = /*#__PURE__*/ $0ec9e6f48df9bac4$var$_classPrivateFieldLooseKey("events");
class $0ec9e6f48df9bac4$var$EventTracker {
    constructor(emitter){
        Object.defineProperty(this, $0ec9e6f48df9bac4$var$_emitter, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $0ec9e6f48df9bac4$var$_events, {
            writable: true,
            value: []
        });
        $0ec9e6f48df9bac4$var$_classPrivateFieldLooseBase(this, $0ec9e6f48df9bac4$var$_emitter)[$0ec9e6f48df9bac4$var$_emitter] = emitter;
    }
    on(event, fn) {
        $0ec9e6f48df9bac4$var$_classPrivateFieldLooseBase(this, $0ec9e6f48df9bac4$var$_events)[$0ec9e6f48df9bac4$var$_events].push([
            event,
            fn
        ]);
        return $0ec9e6f48df9bac4$var$_classPrivateFieldLooseBase(this, $0ec9e6f48df9bac4$var$_emitter)[$0ec9e6f48df9bac4$var$_emitter].on(event, fn);
    }
    remove() {
        for (const [event, fn] of $0ec9e6f48df9bac4$var$_classPrivateFieldLooseBase(this, $0ec9e6f48df9bac4$var$_events)[$0ec9e6f48df9bac4$var$_events].splice(0))$0ec9e6f48df9bac4$var$_classPrivateFieldLooseBase(this, $0ec9e6f48df9bac4$var$_emitter)[$0ec9e6f48df9bac4$var$_emitter].off(event, fn);
    }
}
/**
 * Create a wrapper around an event emitter with a `remove` method to remove
 * all events that were added using the wrapped emitter.
 */ $0ec9e6f48df9bac4$exports = $0ec9e6f48df9bac4$var$EventTracker;


var $f86f2d7b95aede93$exports = {};
"use strict";
function $f86f2d7b95aede93$var$_classPrivateFieldLooseBase(receiver, privateKey) {
    if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) throw new TypeError("attempted to use private field on non-instance");
    return receiver;
}
var $f86f2d7b95aede93$var$id = 0;
function $f86f2d7b95aede93$var$_classPrivateFieldLooseKey(name) {
    return "__private_" + $f86f2d7b95aede93$var$id++ + "_" + name;
}
var $f86f2d7b95aede93$var$_aliveTimer = /*#__PURE__*/ $f86f2d7b95aede93$var$_classPrivateFieldLooseKey("aliveTimer");
var $f86f2d7b95aede93$var$_isDone = /*#__PURE__*/ $f86f2d7b95aede93$var$_classPrivateFieldLooseKey("isDone");
var $f86f2d7b95aede93$var$_onTimedOut = /*#__PURE__*/ $f86f2d7b95aede93$var$_classPrivateFieldLooseKey("onTimedOut");
var $f86f2d7b95aede93$var$_timeout = /*#__PURE__*/ $f86f2d7b95aede93$var$_classPrivateFieldLooseKey("timeout");
/**
 * Helper to abort upload requests if there has not been any progress for `timeout` ms.
 * Create an instance using `timer = new ProgressTimeout(10000, onTimeout)`
 * Call `timer.progress()` to signal that there has been progress of any kind.
 * Call `timer.done()` when the upload has completed.
 */ class $f86f2d7b95aede93$var$ProgressTimeout {
    constructor(timeout, timeoutHandler){
        Object.defineProperty(this, $f86f2d7b95aede93$var$_aliveTimer, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $f86f2d7b95aede93$var$_isDone, {
            writable: true,
            value: false
        });
        Object.defineProperty(this, $f86f2d7b95aede93$var$_onTimedOut, {
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, $f86f2d7b95aede93$var$_timeout, {
            writable: true,
            value: void 0
        });
        $f86f2d7b95aede93$var$_classPrivateFieldLooseBase(this, $f86f2d7b95aede93$var$_timeout)[$f86f2d7b95aede93$var$_timeout] = timeout;
        $f86f2d7b95aede93$var$_classPrivateFieldLooseBase(this, $f86f2d7b95aede93$var$_onTimedOut)[$f86f2d7b95aede93$var$_onTimedOut] = timeoutHandler;
    }
    progress() {
        // Some browsers fire another progress event when the upload is
        // cancelled, so we have to ignore progress after the timer was
        // told to stop.
        if ($f86f2d7b95aede93$var$_classPrivateFieldLooseBase(this, $f86f2d7b95aede93$var$_isDone)[$f86f2d7b95aede93$var$_isDone]) return;
        if ($f86f2d7b95aede93$var$_classPrivateFieldLooseBase(this, $f86f2d7b95aede93$var$_timeout)[$f86f2d7b95aede93$var$_timeout] > 0) {
            clearTimeout($f86f2d7b95aede93$var$_classPrivateFieldLooseBase(this, $f86f2d7b95aede93$var$_aliveTimer)[$f86f2d7b95aede93$var$_aliveTimer]);
            $f86f2d7b95aede93$var$_classPrivateFieldLooseBase(this, $f86f2d7b95aede93$var$_aliveTimer)[$f86f2d7b95aede93$var$_aliveTimer] = setTimeout($f86f2d7b95aede93$var$_classPrivateFieldLooseBase(this, $f86f2d7b95aede93$var$_onTimedOut)[$f86f2d7b95aede93$var$_onTimedOut], $f86f2d7b95aede93$var$_classPrivateFieldLooseBase(this, $f86f2d7b95aede93$var$_timeout)[$f86f2d7b95aede93$var$_timeout]);
        }
    }
    done() {
        if (!$f86f2d7b95aede93$var$_classPrivateFieldLooseBase(this, $f86f2d7b95aede93$var$_isDone)[$f86f2d7b95aede93$var$_isDone]) {
            clearTimeout($f86f2d7b95aede93$var$_classPrivateFieldLooseBase(this, $f86f2d7b95aede93$var$_aliveTimer)[$f86f2d7b95aede93$var$_aliveTimer]);
            $f86f2d7b95aede93$var$_classPrivateFieldLooseBase(this, $f86f2d7b95aede93$var$_aliveTimer)[$f86f2d7b95aede93$var$_aliveTimer] = null;
            $f86f2d7b95aede93$var$_classPrivateFieldLooseBase(this, $f86f2d7b95aede93$var$_isDone)[$f86f2d7b95aede93$var$_isDone] = true;
        }
    }
}
$f86f2d7b95aede93$exports = $f86f2d7b95aede93$var$ProgressTimeout;



var $9dcf43d32b415c4f$exports = {};
"use strict";
function $9dcf43d32b415c4f$var$isNetworkError(xhr) {
    if (!xhr) return false;
    return xhr.readyState !== 0 && xhr.readyState !== 4 || xhr.status === 0;
}
$9dcf43d32b415c4f$exports = $9dcf43d32b415c4f$var$isNetworkError;


const $031d3ed277981e1d$var$packageJson = {
    "version": "2.1.3"
};
var $2989f7b1791006a8$exports = {};
"use strict";
$2989f7b1791006a8$exports = {
    strings: {
        // Shown in the Informer if an upload is being canceled because it stalled for too long.
        timedOut: "Upload stalled for %{seconds} seconds, aborting."
    }
};


function $031d3ed277981e1d$var$buildResponseError(xhr, err) {
    let error = err; // No error message
    if (!error) error = new Error("Upload error"); // Got an error message string
    if (typeof error === "string") error = new Error(error); // Got something else
    if (!(error instanceof Error)) error = Object.assign(new Error("Upload error"), {
        data: error
    });
    if ($9dcf43d32b415c4f$exports(xhr)) {
        error = new $25f952e3561be0e1$exports(error, xhr);
        return error;
    }
    error.request = xhr;
    return error;
}
/**
 * Set `data.type` in the blob to `file.meta.type`,
 * because we might have detected a more accurate file type in Uppy
 * https://stackoverflow.com/a/50875615
 *
 * @param {object} file File object with `data`, `size` and `meta` properties
 * @returns {object} blob updated with the new `type` set from `file.meta.type`
 */ function $031d3ed277981e1d$var$setTypeInBlob(file) {
    const dataWithUpdatedType = file.data.slice(0, file.data.size, file.meta.type);
    return dataWithUpdatedType;
}
class $031d3ed277981e1d$var$XHRUpload extends $7Vc9T {
    // eslint-disable-next-line global-require
    constructor(uppy, opts){
        super(uppy, opts);
        this.type = "uploader";
        this.id = this.opts.id || "XHRUpload";
        this.title = "XHRUpload";
        this.defaultLocale = $2989f7b1791006a8$exports; // Default options
        const defaultOptions = {
            formData: true,
            fieldName: opts.bundle ? "files[]" : "file",
            method: "post",
            metaFields: null,
            responseUrlFieldName: "url",
            bundle: false,
            headers: {},
            timeout: 30000,
            limit: 5,
            withCredentials: false,
            responseType: "",
            /**
       * @param {string} responseText the response body string
       */ getResponseData (responseText) {
                let parsedResponse = {};
                try {
                    parsedResponse = JSON.parse(responseText);
                } catch (err) {
                    uppy.log(err);
                }
                return parsedResponse;
            },
            /**
       *
       * @param {string} _ the response body string
       * @param {XMLHttpRequest | respObj} response the response object (XHR or similar)
       */ getResponseError (_, response) {
                let error = new Error("Upload error");
                if ($9dcf43d32b415c4f$exports(response)) error = new $25f952e3561be0e1$exports(error, response);
                return error;
            },
            /**
       * Check if the response from the upload endpoint indicates that the upload was successful.
       *
       * @param {number} status the response status code
       */ validateStatus (status) {
                return status >= 200 && status < 300;
            }
        };
        this.opts = {
            ...defaultOptions,
            ...opts
        };
        this.i18nInit();
        this.handleUpload = this.handleUpload.bind(this); // Simultaneous upload limiting is shared across all uploads with this plugin.
        if ($e9e08aa686829a96$exports.internalRateLimitedQueue in this.opts) this.requests = this.opts[$e9e08aa686829a96$exports.internalRateLimitedQueue];
        else this.requests = new $e9e08aa686829a96$exports.RateLimitedQueue(this.opts.limit);
        if (this.opts.bundle && !this.opts.formData) throw new Error("`opts.formData` must be true when `opts.bundle` is enabled.");
        this.uploaderEvents = Object.create(null);
    }
    getOptions(file) {
        const overrides = this.uppy.getState().xhrUpload;
        const { headers: headers } = this.opts;
        const opts = {
            ...this.opts,
            ...overrides || {},
            ...file.xhrUpload || {},
            headers: {}
        }; // Support for `headers` as a function, only in the XHRUpload settings.
        // Options set by other plugins in Uppy state or on the files themselves are still merged in afterward.
        //
        // ```js
        // headers: (file) => ({ expires: file.meta.expires })
        // ```
        if (typeof headers === "function") opts.headers = headers(file);
        else Object.assign(opts.headers, this.opts.headers);
        if (overrides) Object.assign(opts.headers, overrides.headers);
        if (file.xhrUpload) Object.assign(opts.headers, file.xhrUpload.headers);
        return opts;
    }
    addMetadata(formData, meta, opts) {
        const metaFields = Array.isArray(opts.metaFields) ? opts.metaFields : Object.keys(meta); // Send along all fields by default.
        metaFields.forEach((item)=>{
            formData.append(item, meta[item]);
        });
    }
    createFormDataUpload(file, opts) {
        const formPost = new FormData();
        this.addMetadata(formPost, file.meta, opts);
        const dataWithUpdatedType = $031d3ed277981e1d$var$setTypeInBlob(file);
        if (file.name) formPost.append(opts.fieldName, dataWithUpdatedType, file.meta.name);
        else formPost.append(opts.fieldName, dataWithUpdatedType);
        return formPost;
    }
    createBundledUpload(files, opts) {
        const formPost = new FormData();
        const { meta: meta } = this.uppy.getState();
        this.addMetadata(formPost, meta, opts);
        files.forEach((file)=>{
            const options = this.getOptions(file);
            const dataWithUpdatedType = $031d3ed277981e1d$var$setTypeInBlob(file);
            if (file.name) formPost.append(options.fieldName, dataWithUpdatedType, file.name);
            else formPost.append(options.fieldName, dataWithUpdatedType);
        });
        return formPost;
    }
    upload(file, current, total) {
        const opts = this.getOptions(file);
        this.uppy.log(`uploading ${current} of ${total}`);
        return new Promise((resolve, reject)=>{
            this.uppy.emit("upload-started", file);
            const data = opts.formData ? this.createFormDataUpload(file, opts) : file.data;
            const xhr = new XMLHttpRequest();
            this.uploaderEvents[file.id] = new $0ec9e6f48df9bac4$exports(this.uppy);
            let queuedRequest;
            const timer = new $f86f2d7b95aede93$exports(opts.timeout, ()=>{
                xhr.abort();
                queuedRequest.done();
                const error = new Error(this.i18n("timedOut", {
                    seconds: Math.ceil(opts.timeout / 1000)
                }));
                this.uppy.emit("upload-error", file, error);
                reject(error);
            });
            const id = (0, $4Kuwt.nanoid)();
            xhr.upload.addEventListener("loadstart", ()=>{
                this.uppy.log(`[XHRUpload] ${id} started`);
            });
            xhr.upload.addEventListener("progress", (ev)=>{
                this.uppy.log(`[XHRUpload] ${id} progress: ${ev.loaded} / ${ev.total}`); // Begin checking for timeouts when progress starts, instead of loading,
                // to avoid timing out requests on browser concurrency queue
                timer.progress();
                if (ev.lengthComputable) this.uppy.emit("upload-progress", file, {
                    uploader: this,
                    bytesUploaded: ev.loaded,
                    bytesTotal: ev.total
                });
            });
            xhr.addEventListener("load", ()=>{
                this.uppy.log(`[XHRUpload] ${id} finished`);
                timer.done();
                queuedRequest.done();
                if (this.uploaderEvents[file.id]) {
                    this.uploaderEvents[file.id].remove();
                    this.uploaderEvents[file.id] = null;
                }
                if (opts.validateStatus(xhr.status, xhr.responseText, xhr)) {
                    const body = opts.getResponseData(xhr.responseText, xhr);
                    const uploadURL = body[opts.responseUrlFieldName];
                    const uploadResp = {
                        status: xhr.status,
                        body: body,
                        uploadURL: uploadURL
                    };
                    this.uppy.emit("upload-success", file, uploadResp);
                    if (uploadURL) this.uppy.log(`Download ${file.name} from ${uploadURL}`);
                    return resolve(file);
                }
                const body = opts.getResponseData(xhr.responseText, xhr);
                const error = $031d3ed277981e1d$var$buildResponseError(xhr, opts.getResponseError(xhr.responseText, xhr));
                const response = {
                    status: xhr.status,
                    body: body
                };
                this.uppy.emit("upload-error", file, error, response);
                return reject(error);
            });
            xhr.addEventListener("error", ()=>{
                this.uppy.log(`[XHRUpload] ${id} errored`);
                timer.done();
                queuedRequest.done();
                if (this.uploaderEvents[file.id]) {
                    this.uploaderEvents[file.id].remove();
                    this.uploaderEvents[file.id] = null;
                }
                const error = $031d3ed277981e1d$var$buildResponseError(xhr, opts.getResponseError(xhr.responseText, xhr));
                this.uppy.emit("upload-error", file, error);
                return reject(error);
            });
            xhr.open(opts.method.toUpperCase(), opts.endpoint, true); // IE10 does not allow setting `withCredentials` and `responseType`
            // before `open()` is called.
            xhr.withCredentials = opts.withCredentials;
            if (opts.responseType !== "") xhr.responseType = opts.responseType;
            queuedRequest = this.requests.run(()=>{
                this.uppy.emit("upload-started", file); // When using an authentication system like JWT, the bearer token goes as a header. This
                // header needs to be fresh each time the token is refreshed so computing and setting the
                // headers just before the upload starts enables this kind of authentication to work properly.
                // Otherwise, half-way through the list of uploads the token could be stale and the upload would fail.
                const currentOpts = this.getOptions(file);
                Object.keys(currentOpts.headers).forEach((header)=>{
                    xhr.setRequestHeader(header, currentOpts.headers[header]);
                });
                xhr.send(data);
                return ()=>{
                    timer.done();
                    xhr.abort();
                };
            });
            this.onFileRemove(file.id, ()=>{
                queuedRequest.abort();
                reject(new Error("File removed"));
            });
            this.onCancelAll(file.id, (_ref)=>{
                let { reason: reason } = _ref;
                if (reason === "user") queuedRequest.abort();
                reject(new Error("Upload cancelled"));
            });
        });
    }
    uploadRemote(file) {
        const opts = this.getOptions(file);
        return new Promise((resolve, reject)=>{
            this.uppy.emit("upload-started", file);
            const fields = {};
            const metaFields = Array.isArray(opts.metaFields) ? opts.metaFields // Send along all fields by default.
             : Object.keys(file.meta);
            metaFields.forEach((name)=>{
                fields[name] = file.meta[name];
            });
            const Client = file.remote.providerOptions.provider ? $c96b27e1ad914fc3$exports.Provider : $c96b27e1ad914fc3$exports.RequestClient;
            const client = new Client(this.uppy, file.remote.providerOptions);
            client.post(file.remote.url, {
                ...file.remote.body,
                endpoint: opts.endpoint,
                size: file.data.size,
                fieldname: opts.fieldName,
                metadata: fields,
                httpMethod: opts.method,
                useFormData: opts.formData,
                headers: opts.headers
            }).then((res)=>{
                const { token: token } = res;
                const host = $6cbe13326f7078be$exports(file.remote.companionUrl);
                const socket = new $c96b27e1ad914fc3$exports.Socket({
                    target: `${host}/api/${token}`,
                    autoOpen: false
                });
                this.uploaderEvents[file.id] = new $0ec9e6f48df9bac4$exports(this.uppy);
                let queuedRequest;
                this.onFileRemove(file.id, ()=>{
                    socket.send("cancel", {});
                    queuedRequest.abort();
                    resolve(`upload ${file.id} was removed`);
                });
                this.onCancelAll(file.id, function(_temp) {
                    let { reason: reason } = _temp === void 0 ? {} : _temp;
                    if (reason === "user") {
                        socket.send("cancel", {});
                        queuedRequest.abort();
                    }
                    resolve(`upload ${file.id} was canceled`);
                });
                this.onRetry(file.id, ()=>{
                    socket.send("pause", {});
                    socket.send("resume", {});
                });
                this.onRetryAll(file.id, ()=>{
                    socket.send("pause", {});
                    socket.send("resume", {});
                });
                socket.on("progress", (progressData)=>$902d716efc9cbfc2$exports(this, progressData, file));
                socket.on("success", (data)=>{
                    const body = opts.getResponseData(data.response.responseText, data.response);
                    const uploadURL = body[opts.responseUrlFieldName];
                    const uploadResp = {
                        status: data.response.status,
                        body: body,
                        uploadURL: uploadURL
                    };
                    this.uppy.emit("upload-success", file, uploadResp);
                    queuedRequest.done();
                    if (this.uploaderEvents[file.id]) {
                        this.uploaderEvents[file.id].remove();
                        this.uploaderEvents[file.id] = null;
                    }
                    return resolve();
                });
                socket.on("error", (errData)=>{
                    const resp = errData.response;
                    const error = resp ? opts.getResponseError(resp.responseText, resp) : Object.assign(new Error(errData.error.message), {
                        cause: errData.error
                    });
                    this.uppy.emit("upload-error", file, error);
                    queuedRequest.done();
                    if (this.uploaderEvents[file.id]) {
                        this.uploaderEvents[file.id].remove();
                        this.uploaderEvents[file.id] = null;
                    }
                    reject(error);
                });
                queuedRequest = this.requests.run(()=>{
                    socket.open();
                    if (file.isPaused) socket.send("pause", {});
                    return ()=>socket.close();
                });
            }).catch((err)=>{
                this.uppy.emit("upload-error", file, err);
                reject(err);
            });
        });
    }
    uploadBundle(files) {
        return new Promise((resolve, reject)=>{
            const { endpoint: endpoint } = this.opts;
            const { method: method } = this.opts;
            const optsFromState = this.uppy.getState().xhrUpload;
            const formData = this.createBundledUpload(files, {
                ...this.opts,
                ...optsFromState || {}
            });
            const xhr = new XMLHttpRequest();
            const emitError = (error)=>{
                files.forEach((file)=>{
                    this.uppy.emit("upload-error", file, error);
                });
            };
            const timer = new $f86f2d7b95aede93$exports(this.opts.timeout, ()=>{
                xhr.abort();
                const error = new Error(this.i18n("timedOut", {
                    seconds: Math.ceil(this.opts.timeout / 1000)
                }));
                emitError(error);
                reject(error);
            });
            xhr.upload.addEventListener("loadstart", ()=>{
                this.uppy.log("[XHRUpload] started uploading bundle");
                timer.progress();
            });
            xhr.upload.addEventListener("progress", (ev)=>{
                timer.progress();
                if (!ev.lengthComputable) return;
                files.forEach((file)=>{
                    this.uppy.emit("upload-progress", file, {
                        uploader: this,
                        bytesUploaded: ev.loaded / ev.total * file.size,
                        bytesTotal: file.size
                    });
                });
            });
            xhr.addEventListener("load", (ev)=>{
                timer.done();
                if (this.opts.validateStatus(ev.target.status, xhr.responseText, xhr)) {
                    const body = this.opts.getResponseData(xhr.responseText, xhr);
                    const uploadResp = {
                        status: ev.target.status,
                        body: body
                    };
                    files.forEach((file)=>{
                        this.uppy.emit("upload-success", file, uploadResp);
                    });
                    return resolve();
                }
                const error = this.opts.getResponseError(xhr.responseText, xhr) || new Error("Upload error");
                error.request = xhr;
                emitError(error);
                return reject(error);
            });
            xhr.addEventListener("error", ()=>{
                timer.done();
                const error = this.opts.getResponseError(xhr.responseText, xhr) || new Error("Upload error");
                emitError(error);
                return reject(error);
            });
            this.uppy.on("cancel-all", function(_temp2) {
                let { reason: reason } = _temp2 === void 0 ? {} : _temp2;
                if (reason !== "user") return;
                timer.done();
                xhr.abort();
            });
            xhr.open(method.toUpperCase(), endpoint, true); // IE10 does not allow setting `withCredentials` and `responseType`
            // before `open()` is called.
            xhr.withCredentials = this.opts.withCredentials;
            if (this.opts.responseType !== "") xhr.responseType = this.opts.responseType;
            Object.keys(this.opts.headers).forEach((header)=>{
                xhr.setRequestHeader(header, this.opts.headers[header]);
            });
            xhr.send(formData);
            files.forEach((file)=>{
                this.uppy.emit("upload-started", file);
            });
        });
    }
    uploadFiles(files) {
        const promises = files.map((file, i)=>{
            const current = parseInt(i, 10) + 1;
            const total = files.length;
            if (file.error) return Promise.reject(new Error(file.error));
            if (file.isRemote) return this.uploadRemote(file, current, total);
            return this.upload(file, current, total);
        });
        return $cf2f85f9e33c0866$exports(promises);
    }
    onFileRemove(fileID, cb) {
        this.uploaderEvents[fileID].on("file-removed", (file)=>{
            if (fileID === file.id) cb(file.id);
        });
    }
    onRetry(fileID, cb) {
        this.uploaderEvents[fileID].on("upload-retry", (targetFileID)=>{
            if (fileID === targetFileID) cb();
        });
    }
    onRetryAll(fileID, cb) {
        this.uploaderEvents[fileID].on("retry-all", ()=>{
            if (!this.uppy.getFile(fileID)) return;
            cb();
        });
    }
    onCancelAll(fileID, eventHandler) {
        var _this = this;
        this.uploaderEvents[fileID].on("cancel-all", function() {
            if (!_this.uppy.getFile(fileID)) return;
            eventHandler(...arguments);
        });
    }
    handleUpload(fileIDs) {
        if (fileIDs.length === 0) {
            this.uppy.log("[XHRUpload] No files to upload!");
            return Promise.resolve();
        } // No limit configured by the user, and no RateLimitedQueue passed in by a "parent" plugin
        // (basically just AwsS3) using the internal symbol
        if (this.opts.limit === 0 && !this.opts[$e9e08aa686829a96$exports.internalRateLimitedQueue]) this.uppy.log("[XHRUpload] When uploading multiple files at once, consider setting the `limit` option (to `10` for example), to limit the number of concurrent uploads, which helps prevent memory and network issues: https://uppy.io/docs/xhr-upload/#limit-0", "warning");
        this.uppy.log("[XHRUpload] Uploading...");
        const files = fileIDs.map((fileID)=>this.uppy.getFile(fileID));
        if (this.opts.bundle) {
            // if bundle: true, we don’t support remote uploads
            const isSomeFileRemote = files.some((file)=>file.isRemote);
            if (isSomeFileRemote) throw new Error("Can\u2019t upload remote files when the `bundle: true` option is set");
            if (typeof this.opts.headers === "function") throw new TypeError("`headers` may not be a function when the `bundle: true` option is set");
            return this.uploadBundle(files);
        }
        return this.uploadFiles(files).then(()=>null);
    }
    install() {
        if (this.opts.bundle) {
            const { capabilities: capabilities } = this.uppy.getState();
            this.uppy.setState({
                capabilities: {
                    ...capabilities,
                    individualCancellation: false
                }
            });
        }
        this.uppy.addUploader(this.handleUpload);
    }
    uninstall() {
        if (this.opts.bundle) {
            const { capabilities: capabilities } = this.uppy.getState();
            this.uppy.setState({
                capabilities: {
                    ...capabilities,
                    individualCancellation: true
                }
            });
        }
        this.uppy.removeUploader(this.handleUpload);
    }
}
$031d3ed277981e1d$var$XHRUpload.VERSION = $031d3ed277981e1d$var$packageJson.version;
$031d3ed277981e1d$exports = $031d3ed277981e1d$var$XHRUpload;


var $7cdd43a8348cbbaa$exports = {};
"use strict";

$7cdd43a8348cbbaa$exports = (parcelRequire("468Vt"));






var $c9Z8w = parcelRequire("c9Z8w");
const $5e58ced5415932fc$var$Dropzone = (dropZoneProps)=>{
    const { dataLwtId: dataLwtId, maxFileSizeInBytes: maxFileSizeInBytes, maxNumberOfFiles: maxNumberOfFiles, minNumberOfFiles: minNumberOfFiles, allowedFileTypes: allowedFileTypes, autoProceed: autoProceed, dropFilesMessage: dropFilesMessage, endpoint: endpoint, fileMetadata: fileMetadata, headers: headers, onFileAdded: onFileAdded, onFileRemoved: onFileRemoved, onSuccess: onSuccess, onFailure: onFailure, onBeforeFileAdded: onBeforeFileAdded, uppyRef: uppyRef, onEditorStart: onEditorStart, onEditorCancel: onEditorCancel, onEditorComplete: onEditorComplete, imageEditorOptions: imageEditorOptions, onUpload: onUpload, ...restProps } = dropZoneProps;
    (0, $acw62.useEffect)(()=>{
        if (fileMetadata && fileMetadata.id) uppy.setFileMeta(fileMetadata.id, fileMetadata.metadata ? fileMetadata.metadata : {});
    }, [
        fileMetadata
    ]);
    (0, $acw62.useEffect)(()=>{
        return ()=>{
            uppy.cancelAll();
        };
    }, []);
    const defaultEditorActions = {
        revert: false,
        rotate: false,
        flip: false,
        zoomIn: true,
        zoomOut: true,
        cropSquare: true,
        cropWidescreen: true,
        cropWidescreenVertical: true,
        granularRotate: false,
        ...imageEditorOptions?.actions
    };
    const defaultCropperOption = {
        background: true,
        croppedCanvasOptions: {},
        ...imageEditorOptions?.cropperOptions
    };
    // using a memo to fix an issue when listening to an event that may cause a rerender
    // https://github.com/transloadit/uppy/issues/2473
    const uppy = (0, $acw62.useMemo)(()=>{
        const newUppy = new (0, $8jN3b.Uppy)({
            debug: false,
            autoProceed: autoProceed,
            restrictions: {
                maxFileSize: maxFileSizeInBytes,
                maxNumberOfFiles: maxNumberOfFiles,
                minNumberOfFiles: minNumberOfFiles,
                allowedFileTypes: allowedFileTypes
            },
            onBeforeFileAdded (currentFile, files) {
                if (onBeforeFileAdded) return onBeforeFileAdded(currentFile, files);
            }
        });
        if (endpoint) newUppy.use((0, (/*@__PURE__*/$parcel$interopDefault($031d3ed277981e1d$exports))), {
            endpoint: endpoint,
            formData: true
        });
        newUppy.on("upload", ()=>{
            if (onUpload) {
                onUpload(uppy.getFiles());
                return;
            }
            if (headers) newUppy.getPlugin("XHRUpload")?.setOptions({
                headers: headers
            });
        }).on("file-added", (file)=>{
            if (onFileAdded) onFileAdded(file);
        }).on("file-removed", (file)=>{
            if (onFileRemoved) onFileRemoved(file);
        }).on("complete", (result)=>{
            if (result.successful && onSuccess) onSuccess(result.successful);
            if (result.failed && onFailure) onFailure(result.failed);
        }).use((0, (/*@__PURE__*/$parcel$interopDefault($7cdd43a8348cbbaa$exports))), {
            actions: defaultEditorActions,
            cropperOptions: {
                ...defaultCropperOption,
                croppedCanvasOptions: {
                    ...defaultCropperOption.croppedCanvasOptions
                }
            }
        }).on("file-editor:start", (file)=>{
            if (onEditorStart) onEditorStart(file);
        }).on("file-editor:complete", (file)=>{
            if (onEditorComplete) onEditorComplete(file);
        }).on("file-editor:cancel", (file)=>{
            if (onEditorCancel) onEditorCancel(file);
        });
        return newUppy;
    }, [
        autoProceed,
        maxFileSizeInBytes,
        maxNumberOfFiles,
        minNumberOfFiles,
        allowedFileTypes,
        onBeforeFileAdded,
        endpoint,
        headers,
        onUpload,
        onFileAdded,
        onFileRemoved,
        onSuccess,
        onFailure,
        onEditorStart,
        onEditorComplete,
        onEditorCancel,
        imageEditorOptions
    ]);
    (0, $acw62.useImperativeHandle)(uppyRef, ()=>({
            upload: uppy.upload,
            addFile: (file)=>uppy.addFile({
                    data: file
                }),
            removeFile: (file)=>uppy.removeFile(file.id),
            reset: ()=>uppy.reset(),
            getFiles: ()=>uppy.getFiles()
        }));
    const locale = {
        strings: {}
    };
    if (dropFilesMessage) locale.strings["dropPaste"] = dropFilesMessage;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        "data-lwt-id": dataLwtId,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8533a48c212344aa$exports))), {
            uppy: uppy,
            proudlyDisplayPoweredByUppy: false,
            locale: locale,
            ...restProps
        })
    });
};
$5e58ced5415932fc$var$Dropzone.propTypes = {
    dataLwtId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    maxFileSizeInBytes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    maxNumberOfFiles: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    minNumberOfFiles: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    allowedFileTypes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string),
    autoProceed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    dropFilesMessage: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    endpoint: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    fileMetadata: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    headers: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    onFileAdded: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onFileRemoved: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onFailure: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onBeforeFileAdded: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    uppyRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        current: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    }),
    onEditorStart: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onEditorCancel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onEditorComplete: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    imageEditorOptions: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        actions: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        cropperOptions: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    }),
    onUpload: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};
var $5e58ced5415932fc$export$2e2bcd8739ae039 = $5e58ced5415932fc$var$Dropzone;



var $acw62 = parcelRequire("acw62");

var $ivaD7 = parcelRequire("ivaD7");

var $bA5Mi = parcelRequire("bA5Mi");

var $gdi0Z = parcelRequire("gdi0Z");

const $f9b71c6f90c5d461$export$ad467ed61de25388 = ({ uppyFile: uppyFile, targetWidth: targetWidth, targetHeight: targetHeight })=>new Promise((resolve, reject)=>{
        const img = new Image();
        const objectUrl = URL.createObjectURL(uppyFile.data);
        img.src = objectUrl;
        const IMAGE_QUALITY_MULTIPLIER = 2;
        img.onload = ()=>{
            const maxWidth = targetWidth * IMAGE_QUALITY_MULTIPLIER;
            const maxHeight = targetHeight * IMAGE_QUALITY_MULTIPLIER;
            let { width: width, height: height } = img;
            const scale = Math.min(maxWidth / width, maxHeight / height, 1);
            const newWidth = Math.round(width * scale);
            const newHeight = Math.round(height * scale);
            const canvas = document.createElement("canvas");
            canvas.width = newWidth;
            canvas.height = newHeight;
            const ctx = canvas.getContext("2d");
            ctx.imageSmoothingEnabled = true;
            ctx.imageSmoothingQuality = "high";
            ctx.drawImage(img, 0, 0, newWidth, newHeight);
            const base64String = canvas.toDataURL("image/png");
            URL.revokeObjectURL(objectUrl);
            resolve(base64String);
        };
        img.onerror = (error)=>{
            URL.revokeObjectURL(objectUrl);
            reject(error);
        };
    });
const $f9b71c6f90c5d461$export$db698a0459e913af = (dataURL, maxWidth = (0, $65b0c1d519376a85$export$1d684649f71e1271).MAX_WIDTH, maxHeight = (0, $65b0c1d519376a85$export$1d684649f71e1271).MAX_HEIGHT, callback)=>{
    const img = new Image();
    img.onload = ()=>{
        const scale = Math.min(maxWidth / img.width, maxHeight / img.height, 1);
        const newWidth = Math.round(img.width * scale);
        const newHeight = Math.round(img.height * scale);
        const canvas = document.createElement("canvas");
        canvas.width = newWidth;
        canvas.height = newHeight;
        const ctx = canvas.getContext("2d");
        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = "high";
        ctx.drawImage(img, 0, 0, newWidth, newHeight);
        const resizedDataURL = canvas.toDataURL("image/png");
        callback(resizedDataURL);
    };
    img.src = dataURL;
};
const $f9b71c6f90c5d461$export$b14043f1eab0b4a4 = (dataURL, maxWidth = (0, $65b0c1d519376a85$export$1d684649f71e1271).MAX_WIDTH, maxHeight = (0, $65b0c1d519376a85$export$1d684649f71e1271).MAX_HEIGHT)=>new Promise((resolve, reject)=>{
        const img = new Image();
        img.onload = ()=>{
            const scale = Math.min(maxWidth / img.width, maxHeight / img.height, 1);
            const newWidth = Math.round(img.width * scale);
            const newHeight = Math.round(img.height * scale);
            const canvas = document.createElement("canvas");
            canvas.width = newWidth;
            canvas.height = newHeight;
            const ctx = canvas.getContext("2d");
            ctx.imageSmoothingEnabled = true;
            ctx.imageSmoothingQuality = "high";
            ctx.drawImage(img, 0, 0, newWidth, newHeight);
            resolve(canvas.toDataURL("image/png"));
        };
        img.onerror = reject;
        img.src = dataURL;
    });




var $jeANf = parcelRequire("jeANf");

var $cstaF = parcelRequire("cstaF");
const $71fe8bde76e649ac$export$195d991fd12d59e5 = ()=>{
    const uploaderRef = (0, $acw62.useRef)();
    const [state, setState] = (0, $acw62.useState)({
        shouldShowLogoUploader: false,
        shouldShowRemoveLogoModal: false,
        shouldShowUpdateLogoModal: false,
        isLogoLoading: false,
        isUploaderLoading: false,
        isDeletingLogo: false,
        isUpdatingLogo: false,
        toastProps: undefined,
        pendingUploadFile: null
    });
    const { fetchLogo: fetchLogo, setLogoSrc: setLogoSrc, logoSrc: logoSrc } = (0, $bA5Mi.usePDFStore)((state)=>({
            fetchLogo: state.fetchLogo,
            setLogoSrc: state.setLogoSrc,
            logoSrc: state.logoSrc
        }));
    const setShouldShowLogoUploader = (value)=>(0, $ivaD7.setStateData)("shouldShowLogoUploader", value, setState);
    const setShouldShowRemoveLogoModal = (value)=>(0, $ivaD7.setStateData)("shouldShowRemoveLogoModal", value, setState);
    const setShouldShowUpdateLogoModal = (value)=>(0, $ivaD7.setStateData)("shouldShowUpdateLogoModal", value, setState);
    const setIsLogoLoading = (value)=>(0, $ivaD7.setStateData)("isLogoLoading", value, setState);
    const setIsUploaderLoading = (value)=>(0, $ivaD7.setStateData)("isUploaderLoading", value, setState);
    const setIsDeletingLogo = (value)=>(0, $ivaD7.setStateData)("isDeletingLogo", value, setState);
    const setIsUpdatingLogo = (value)=>(0, $ivaD7.setStateData)("isUpdatingLogo", value, setState);
    const setPendingUploadFile = (value)=>(0, $ivaD7.setStateData)("pendingUploadFile", value, setState);
    const setters = {
        setShouldShowLogoUploader: setShouldShowLogoUploader,
        setShouldShowRemoveLogoModal: setShouldShowRemoveLogoModal,
        setShouldShowUpdateLogoModal: setShouldShowUpdateLogoModal,
        setIsLogoLoading: setIsLogoLoading,
        setIsUploaderLoading: setIsUploaderLoading,
        setIsDeletingLogo: setIsDeletingLogo,
        setIsUpdatingLogo: setIsUpdatingLogo,
        setPendingUploadFile: setPendingUploadFile
    };
    (0, $acw62.useEffect)(()=>{
        if (state.shouldShowLogoUploader) return;
        const loadLogo = async ()=>{
            setIsLogoLoading(true);
            await fetchLogo();
            setIsLogoLoading(false);
        };
        loadLogo();
    }, [
        state.shouldShowLogoUploader
    ]);
    const handleOnLogoUpload = async (files)=>{
        if (files.length !== 1) return;
        if (logoSrc) {
            setPendingUploadFile(files[0]);
            setShouldShowUpdateLogoModal(true);
            return;
        }
        await uploadLogoProcess(files[0]);
    };
    const uploadLogoProcess = async (uppyFile)=>{
        try {
            setIsUploaderLoading(true);
            setIsUpdatingLogo(true);
            const base64ResizedUppyFile = await (0, $f9b71c6f90c5d461$export$ad467ed61de25388)({
                uppyFile: uppyFile,
                targetWidth: (0, $65b0c1d519376a85$export$1d684649f71e1271).MAX_WIDTH,
                targetHeight: (0, $65b0c1d519376a85$export$1d684649f71e1271).MAX_HEIGHT
            });
            const base64ResizedUppyString = base64ResizedUppyFile.split(",")[1];
            const response = await (0, $gdi0Z.uploadLogo)(base64ResizedUppyString);
            if (!response?.url) {
                setShouldShowUpdateLogoModal(false);
                throw new Error(response.error || `HTTP Error: ${response}`);
            }
            const processImage = async ()=>{
                try {
                    const resizedDataURL = await (0, $f9b71c6f90c5d461$export$b14043f1eab0b4a4)(base64ResizedUppyFile);
                    return resizedDataURL;
                } catch (err) {
                    console.error("Resize failed:", err);
                }
            };
            const imageUrlForBrandingPage = await processImage();
            setLogoSrc(imageUrlForBrandingPage);
            setShouldShowLogoUploader(false);
            setShouldShowUpdateLogoModal(false);
            (0, $jeANf.showToast)((0, $jeANf.toastTypes).success, (0, $cstaF.toastMessages).success.brandingLogo, setState);
        } catch (error) {
            console.error((0, $65b0c1d519376a85$export$6b04f01ce1d4998e).errorMessages.logoUploadError, error);
            (0, $jeANf.showToast)((0, $jeANf.toastTypes).error, (0, $cstaF.toastMessages).error.brandingLogo, setState);
        } finally{
            setIsUploaderLoading(false);
            setIsUpdatingLogo(false);
        }
    };
    const handleConfirmUpdateLogo = async ()=>{
        if (state.pendingUploadFile) {
            await uploadLogoProcess(state.pendingUploadFile);
            setPendingUploadFile(null);
        }
    };
    const handleRemoveLogo = async ()=>{
        try {
            setIsDeletingLogo(true);
            const response = await (0, $gdi0Z.deleteLogo)();
            setShouldShowRemoveLogoModal(false);
            if (response?.success !== "true") throw new Error(response.error || `HTTP Error: ${response}`);
            setLogoSrc(undefined);
            (0, $jeANf.showToast)((0, $jeANf.toastTypes).success, (0, $cstaF.toastMessages).success.brandingLogoDelete, setState);
        } catch (error) {
            console.error((0, $65b0c1d519376a85$export$6b04f01ce1d4998e).errorMessages.logoDeleteError, error);
            (0, $jeANf.showToast)((0, $jeANf.toastTypes).error, (0, $cstaF.toastMessages).error.brandingLogoDelete, setState);
        } finally{
            setIsDeletingLogo(false);
        }
    };
    return {
        uploaderRef: uploaderRef,
        state: state,
        setters: setters,
        handleOnLogoUpload: handleOnLogoUpload,
        handleRemoveLogo: handleRemoveLogo,
        handleConfirmUpdateLogo: handleConfirmUpdateLogo,
        logoSrc: logoSrc
    };
};



var $7tOHe = parcelRequire("7tOHe");
parcelRequire("amkL4");
var $3QXz5 = parcelRequire("3QXz5");
const $b969ca1697052b0a$export$b662907948aa9c7a = ()=>{
    const { uploaderRef: uploaderRef, state: { shouldShowLogoUploader: shouldShowLogoUploader, shouldShowRemoveLogoModal: shouldShowRemoveLogoModal, shouldShowUpdateLogoModal: shouldShowUpdateLogoModal, isLogoLoading: isLogoLoading, isUploaderLoading: isUploaderLoading, isDeletingLogo: isDeletingLogo, isUpdatingLogo: isUpdatingLogo, toastProps: toastProps }, setters: { setShouldShowLogoUploader: setShouldShowLogoUploader, setShouldShowRemoveLogoModal: setShouldShowRemoveLogoModal, setShouldShowUpdateLogoModal: setShouldShowUpdateLogoModal }, handleOnLogoUpload: handleOnLogoUpload, handleRemoveLogo: handleRemoveLogo, handleConfirmUpdateLogo: handleConfirmUpdateLogo, logoSrc: logoSrc } = (0, $71fe8bde76e649ac$export$195d991fd12d59e5)();
    const removeLogoModalContent = /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "text-center",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
            children: (0, $65b0c1d519376a85$export$6b04f01ce1d4998e).removeLogoModal.body
        })
    });
    const updateLogoModalContent = /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "text-center",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
            children: (0, $65b0c1d519376a85$export$6b04f01ce1d4998e).updateLogoModal.body
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "d-flex flex-column align-items-center text-center",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h6", {
                className: "font-weight-bold text-start",
                children: (0, $65b0c1d519376a85$export$6b04f01ce1d4998e).profileTabTitle((0, $dDBOF.appLabels)[0, $dDBOF.runningApp])
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                children: (0, $65b0c1d519376a85$export$6b04f01ce1d4998e).profileTabDescription
            }),
            !logoSrc ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                className: "branding-logo mb-4 p-2 ",
                height: 120,
                width: 120,
                icon: (0, $eOjgM.building_modern)
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mb-4 d-flex align-items-center justify-content-center",
                children: isLogoLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    id: "branding-logo",
                    src: logoSrc
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "d-flex flex-row",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                        onClick: ()=>setShouldShowLogoUploader(true),
                        children: logoSrc ? (0, $65b0c1d519376a85$export$6b04f01ce1d4998e).updateLogoButton : (0, $65b0c1d519376a85$export$6b04f01ce1d4998e).addLogoButton
                    }),
                    logoSrc && /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                        onClick: ()=>setShouldShowRemoveLogoModal(true),
                        children: (0, $65b0c1d519376a85$export$6b04f01ce1d4998e).removeLogoButton
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "font-weight-bold mt-4",
                children: (0, $65b0c1d519376a85$export$6b04f01ce1d4998e).profileTabFileTitle
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                children: (0, $65b0c1d519376a85$export$6b04f01ce1d4998e).profileTabFileDescription
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f61ig.default), {
                size: "sm",
                title: (0, $65b0c1d519376a85$export$6b04f01ce1d4998e).addLogo,
                show: shouldShowLogoUploader,
                onClose: ()=>setShouldShowLogoUploader(false),
                buttons: [],
                children: isUploaderLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "branding-loader-container",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {})
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5e58ced5415932fc$export$2e2bcd8739ae039), {
                    dataLwtId: "branding-logo-uploader",
                    onUpload: handleOnLogoUpload,
                    uppyRef: uploaderRef,
                    autoProceed: false,
                    allowedFileTypes: (0, $65b0c1d519376a85$export$215845906c120e7a).allowedLogoFileTypes,
                    maxFileSizeInBytes: (0, $65b0c1d519376a85$export$215845906c120e7a).maxLogoFileSizeInBytes,
                    maxNumberOfFiles: (0, $65b0c1d519376a85$export$215845906c120e7a).maxNumberOfLogoFiles,
                    autoOpenFileEditor: true,
                    imageEditorOptions: {
                        actions: {
                            cropSquare: false,
                            cropWidescreen: false,
                            cropWidescreenVertical: false
                        }
                    },
                    plugins: [
                        "ImageEditor"
                    ]
                })
            }, "branding-logo-uploader"),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f61ig.default), {
                size: "sm",
                title: (0, $65b0c1d519376a85$export$6b04f01ce1d4998e).removeLogoModal.title,
                show: shouldShowRemoveLogoModal,
                onClose: ()=>!isDeletingLogo && setShouldShowRemoveLogoModal(false),
                buttons: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                            dataLwtId: "cancel-remove-logo",
                            color: "secondary",
                            disabled: isDeletingLogo,
                            onClick: ()=>setShouldShowRemoveLogoModal(false),
                            children: (0, $65b0c1d519376a85$export$6b04f01ce1d4998e).removeLogoModal.cancelButton
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                            dataLwtId: "confirm-remove-logo",
                            color: "primary",
                            disabled: isDeletingLogo,
                            onClick: handleRemoveLogo,
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "d-flex justify-content-center align-items-center xs-spinner",
                                children: [
                                    isDeletingLogo && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {}),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "pl-2 pr-1 m-0",
                                        children: (0, $65b0c1d519376a85$export$6b04f01ce1d4998e).removeLogoModal.confirmButton
                                    })
                                ]
                            })
                        })
                    ]
                }),
                children: removeLogoModalContent
            }, "branding-remove-logo-modal"),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f61ig.default), {
                size: "sm",
                title: (0, $65b0c1d519376a85$export$6b04f01ce1d4998e).updateLogoModal.title,
                show: shouldShowUpdateLogoModal,
                onClose: ()=>!isUpdatingLogo && setShouldShowUpdateLogoModal(false),
                buttons: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                            dataLwtId: "cancel-update-logo",
                            color: "secondary",
                            disabled: isUpdatingLogo,
                            onClick: ()=>setShouldShowUpdateLogoModal(false),
                            children: (0, $65b0c1d519376a85$export$6b04f01ce1d4998e).updateLogoModal.cancelButton
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                            dataLwtId: "confirm-update-logo",
                            color: "primary",
                            disabled: isUpdatingLogo,
                            onClick: handleConfirmUpdateLogo,
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "d-flex justify-content-center align-items-center xs-spinner",
                                children: [
                                    isUpdatingLogo && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {}),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                        className: "pl-2 pr-1 m-0",
                                        children: (0, $65b0c1d519376a85$export$6b04f01ce1d4998e).updateLogoModal.confirmButton
                                    })
                                ]
                            })
                        })
                    ]
                }),
                children: updateLogoModalContent
            }, "branding-update-logo-modal"),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3QXz5))), {
                position: "toast-bottom-right",
                dataLwtId: "branding-logo-toast",
                toastProps: toastProps
            })
        ]
    });
};



var $c9Z8w = parcelRequire("c9Z8w");


var $c7dF9 = parcelRequire("c7dF9");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $4TPr9 = parcelRequire("4TPr9");
parcelRequire("fHiKR");
var $1BYDb = parcelRequire("1BYDb");
var $kN5vy = parcelRequire("kN5vy");
parcelRequire("2OwWq");
var $7kkwd = parcelRequire("7kkwd");


var $7tOHe = parcelRequire("7tOHe");
parcelRequire("amkL4");
var $3QXz5 = parcelRequire("3QXz5");

var $jeANf = parcelRequire("jeANf");


var $cstaF = parcelRequire("cstaF");

var $24YIE = parcelRequire("24YIE");
const $8b994b6d939386c8$export$bdf060f8502bcfbd = async ()=>{
    return await (0, $24YIE.newSendApiRequest)("Settings_read", [], 20000);
};
const $8b994b6d939386c8$export$fd993a94a7fb0c16 = async (selectedFrequency, hasSetting, id)=>{
    const response = await (0, $24YIE.newSendApiRequest)("Setting_save", [
        {
            parameter: "setting",
            value: JSON.stringify({
                ...hasSetting && {
                    "id": id
                },
                "setting": 1,
                "value": selectedFrequency.value
            })
        }
    ], 20000);
    if (response?.error || typeof response === "number") throw new Error(response?.error?.message || (0, $cstaF.toastMessages).error.saveFailed);
    return response;
};



const $3c2ca0ed1cfe6d27$export$d476ee5008a9dcb3 = ()=>{
    return (0, $6f7384520c92f99a$export$dd0a697e1782aedd)({
        queryKey: [
            "notificationSettings"
        ],
        queryFn: (0, $8b994b6d939386c8$export$bdf060f8502bcfbd),
        select: (response)=>{
            const frequencyValue = response.EmailNotificationFrequency?.value;
            const normalizedValue = (0, $cc1d18490928ae85$export$d59a45c4e8ad9012).includes(frequencyValue) ? (0, $cc1d18490928ae85$export$8a21ba990ca4a7cb).fortnightly : frequencyValue;
            const frequencyOption = (0, $cc1d18490928ae85$export$8b285f7d3d2706d7).find((opt)=>opt.value === normalizedValue) || (0, $cc1d18490928ae85$export$a5ab5bba1b0ec67);
            const isChecked = frequencyValue !== undefined && frequencyValue !== (0, $cc1d18490928ae85$export$a5ab5bba1b0ec67).value;
            const id = response.EmailNotificationFrequency?.id;
            return {
                checkbox: isChecked,
                frequency: frequencyOption,
                hasSettings: frequencyValue !== undefined,
                id: id
            };
        }
    });
};
const $3c2ca0ed1cfe6d27$export$52d32442adb19140 = ()=>{
    const queryClient = (0, $0126047dd734bc33$export$22e77b9572c4fded)();
    return (0, $cb7b7c348969488c$export$609860bf8b0084c)({
        mutationFn: ({ selectedFrequency: selectedFrequency, hasSettings: hasSettings, id: id })=>(0, $8b994b6d939386c8$export$fd993a94a7fb0c16)(selectedFrequency, hasSettings, id),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: [
                    "notificationSettings"
                ]
            });
        }
    });
};



var $cstaF = parcelRequire("cstaF");
const $daa4f64ab4d47b4f$var$Notifications = ()=>{
    const { data: initialState, isLoading: isLoading, isFetching: isFetching } = (0, $3c2ca0ed1cfe6d27$export$d476ee5008a9dcb3)();
    const saveSettings = (0, $3c2ca0ed1cfe6d27$export$52d32442adb19140)();
    const [toast, setToast] = (0, $acw62.useState)({
        toastProps: null
    });
    const [savedAgentsChecked, setSavedAgentsChecked] = (0, $acw62.useState)(false);
    const [selectedFrequency, setSelectedFrequency] = (0, $acw62.useState)((0, $cc1d18490928ae85$export$a5ab5bba1b0ec67));
    (0, $acw62.useEffect)(()=>{
        if (initialState) {
            setSavedAgentsChecked(initialState.checkbox);
            setSelectedFrequency(initialState.frequency);
        }
    }, [
        initialState
    ]);
    const isChanged = initialState && (savedAgentsChecked !== initialState.checkbox || selectedFrequency.value !== initialState.frequency.value);
    const handleFrequencyChange = (option)=>{
        const newFrequency = option || (0, $cc1d18490928ae85$export$a5ab5bba1b0ec67);
        setSelectedFrequency(newFrequency);
        setSavedAgentsChecked(newFrequency.value !== (0, $cc1d18490928ae85$export$a5ab5bba1b0ec67).value);
    };
    const handleSavedAgentsChecked = (e)=>{
        setSavedAgentsChecked(e?.target?.checked);
        if (!e?.target?.checked) setSelectedFrequency((0, $cc1d18490928ae85$export$a5ab5bba1b0ec67));
    };
    const handleSave = ()=>{
        saveSettings.mutate({
            selectedFrequency: selectedFrequency,
            hasSettings: initialState?.hasSettings,
            id: initialState?.id
        }, {
            onSuccess: ()=>(0, $jeANf.showToast)((0, $jeANf.toastTypes).success, (0, $cstaF.toastMessages).success.successfullySaved, setToast),
            onError: ()=>(0, $jeANf.showToast)((0, $jeANf.toastTypes).error, (0, $cstaF.toastMessages).error.saveFailed, setToast)
        });
    };
    if (isLoading) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {});
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "p-3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "d-flex align-items-center mb-2",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                            className: "m-0 text-start font-weight-bold",
                            children: (0, $cc1d18490928ae85$export$8a21ba990ca4a7cb).notifications
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "mb-3 text-start text-muted",
                        children: (0, $cc1d18490928ae85$export$8a21ba990ca4a7cb).notificationsIntro
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("h6", {
                            className: "text-start font-weight-bold",
                            children: (0, $cc1d18490928ae85$export$8a21ba990ca4a7cb).notificationsBrokerUpdates
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "row align-items-start pb-0",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "col-md-8 col-xl-9 pl-4",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7kkwd))), {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: "d-flex align-items-start",
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                className: "me-2",
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1BYDb))), {
                                                    dataLwtId: "saved-agents-checkbox",
                                                    id: "saved-agents-checkbox",
                                                    type: "checkbox",
                                                    checked: savedAgentsChecked,
                                                    onClick: handleSavedAgentsChecked,
                                                    disabled: selectedFrequency.value === (0, $cc1d18490928ae85$export$a5ab5bba1b0ec67).value
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                className: "flex-grow-1 text-start",
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "font-weight-bold",
                                                        children: (0, $cc1d18490928ae85$export$8a21ba990ca4a7cb).savedAgents
                                                    }),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                                        className: "text-muted mt-1",
                                                        children: (0, $cc1d18490928ae85$export$8a21ba990ca4a7cb).notificationsSavedAgentsDescription
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "col-md-4 col-xl-3 text-start",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($7kkwd))), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kN5vy))), {
                                            className: "font-weight-bold text-start d-block mb-2",
                                            dataLwtId: "lbl-receive-notifications",
                                            children: (0, $cc1d18490928ae85$export$8a21ba990ca4a7cb).receiveNotifications
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4TPr9.default), {
                                            dataLwtId: "notifications-frequency-select",
                                            options: (0, $cc1d18490928ae85$export$8b285f7d3d2706d7),
                                            value: selectedFrequency,
                                            onChange: handleFrequencyChange,
                                            placeholder: selectedFrequency.label,
                                            isClearable: false
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("hr", {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "d-flex justify-content-end",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                            dataLwtId: "save-notification-settings",
                            color: "primary",
                            disabled: !isChanged || saveSettings.isPending || isFetching,
                            onClick: handleSave,
                            children: (0, $cc1d18490928ae85$export$8a21ba990ca4a7cb).saveChanges
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3QXz5))), {
                dataLwtId: "toast",
                toastProps: toast.toastProps,
                position: "toast-bottom-right"
            })
        ]
    });
};
var $daa4f64ab4d47b4f$export$2e2bcd8739ae039 = $daa4f64ab4d47b4f$var$Notifications;


const $414de6bd784de6b8$var$Profile = ({ userAccounts: userAccounts, isMarketShareAllowed: isMarketShareAllowed })=>{
    const [state, setState] = (0, $acw62.useState)({});
    const history = (0, $kfZjc.useHistory)();
    const featureToggles = (0, $kLrt8.useFeatureToggles)();
    const defaultSortFunction = (a, b)=>a.shortDescription.localeCompare(b.shortDescription);
    const { membership: membership } = (0, $90ISC.useCommonStore)(({ membership: membership })=>({
            membership: membership
        }));
    const { tokenInfo: tokenInfo, tokenType: tokenType } = (0, $f6CJ4.useAuthStore)((state)=>({
            tokenInfo: state.tokenInfo,
            tokenType: state.tokenType
        }));
    const ownerId = tokenType && (0, $cghEn.getOwnerIdByTokenInfo)[tokenType](tokenInfo);
    const toggleActiveTab = (index)=>{
        const items = getTabItems();
        const selectedItem = items[index];
        if (selectedItem.title === (0, $cc1d18490928ae85$export$8a21ba990ca4a7cb).notifications) {
            history.push((0, $c7dF9.Routes).MY_PROFILE.BASE + (0, $c7dF9.Routes).MY_PROFILE.NOTIFICATIONS);
            return;
        }
        let searchParams = new URLSearchParams(history.location.search);
        searchParams.set("selectedTab", index);
        history.push({
            pathname: (0, $c7dF9.Routes).MY_PROFILE.BASE,
            search: searchParams.toString()
        });
    };
    (0, $acw62.useEffect)(()=>{
        if (!tokenInfo || !tokenType) return;
        setState({
            ...state,
            profile: {
                id: ownerId,
                firstName: userAccounts ? userAccounts.user.firstName : tokenInfo.given_name,
                lastName: userAccounts ? userAccounts.user.lastName : tokenInfo.family_name,
                username: (0, $cghEn.userNameByTokenType)(tokenInfo)[tokenType],
                email: userAccounts ? userAccounts.user.email : tokenInfo.email
            }
        });
    }, [
        tokenInfo,
        tokenType
    ]);
    (0, $acw62.useEffect)(()=>{
        if (membership?.length) {
            const mlsList = [
                ...membership
            ].sort(defaultSortFunction);
            (0, $ivaD7.setStateData)("mlsList", mlsList, setState);
            // We could progressively switch from the local state to this
            (0, $90ISC.useCommonStore).setState({
                mlsList: mlsList
            });
        }
    }, [
        membership
    ]);
    (0, $acw62.useEffect)(()=>{
        const qs = (0, (/*@__PURE__*/$parcel$interopDefault($3ecb7368762fc268$exports))).parse(history.location.search);
        const selectedTab = qs?.selectedTab && parseInt(qs.selectedTab);
        selectedTab && (0, $ivaD7.setStateData)("currentIndex", selectedTab, setState);
    }, []);
    const getActiveTab = ()=>{
        if (history.location.pathname === (0, $c7dF9.Routes).MY_PROFILE.BASE + (0, $c7dF9.Routes).MY_PROFILE.NOTIFICATIONS) {
            if (featureToggles.notifications.isEnabled) return getTabItems().findIndex((item)=>item.title === (0, $cc1d18490928ae85$export$8a21ba990ca4a7cb).notifications) || 0;
            history.replace({
                pathname: "/"
            });
            return;
        }
        const qs = (0, (/*@__PURE__*/$parcel$interopDefault($3ecb7368762fc268$exports))).parse(history.location.search);
        return qs?.selectedTab ? parseInt(qs.selectedTab) : 0;
    };
    const getTabItems = ()=>{
        const items = [
            {
                title: (0, $cstaF.agentProductionTerms).account,
                content: {
                    jsx: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $51f50db272fd6afd$export$2e2bcd8739ae039), {
                        profile: state.profile
                    }),
                    className: "raised-border bg-white p-4"
                }
            },
            {
                title: (0, $cstaF.agentProductionTerms).office,
                content: {
                    jsx: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $87e7792856d13934$export$2e2bcd8739ae039), {
                        profile: state.profile,
                        mlsList: state.mlsList
                    }),
                    className: "raised-border bg-white p-4"
                }
            },
            {
                title: (0, $cstaF.agentProductionTerms).mls,
                content: {
                    jsx: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e849fd5ea30dde24$export$2e2bcd8739ae039), {
                        mlsList: state.mlsList,
                        email: tokenInfo.email
                    }),
                    className: "raised-border bg-white p-4"
                }
            }
        ];
        if (isMarketShareAllowed && featureToggles.comparisonSets.isEnabled) items.push({
            title: (0, $cstaF.marketShareTerms).comparisonSets,
            content: {
                jsx: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $88aedea088ff4a8f$export$2e2bcd8739ae039), {})
            }
        });
        items.push({
            title: (0, $65b0c1d519376a85$export$6b04f01ce1d4998e).branding,
            content: {
                jsx: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b969ca1697052b0a$export$b662907948aa9c7a), {}),
                className: "raised-border bg-white p-4"
            }
        });
        if (featureToggles.notifications.isEnabled) items.push({
            title: (0, $cc1d18490928ae85$export$8a21ba990ca4a7cb).notifications,
            content: {
                jsx: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $daa4f64ab4d47b4f$export$2e2bcd8739ae039), {}),
                className: "raised-border bg-white p-4"
            }
        });
        return items;
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    margin: "15px 10px 0"
                },
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                    className: "text-center mb-0 font-weight-bold",
                    children: (0, $cstaF.navTerms).myProfile
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: {
                    margin: "5px auto",
                    padding: "0 20px"
                },
                className: "col-xl-6 col-lg-7 col-md-8 col-sm-10 col-xs-12",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8f390b0d641c1be9$export$2e2bcd8739ae039), {
                    style: {
                        margin: "5px auto 10px"
                    },
                    tabTextTransform: "none",
                    contentSize: 6,
                    navSize: 6,
                    items: getTabItems(),
                    tabs: true,
                    currentIndex: getActiveTab(),
                    setCurrentIndex: toggleActiveTab
                })
            })
        ]
    });
};
$414de6bd784de6b8$var$Profile.propTypes = {
    userAccounts: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    isMarketShareAllowed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
var $414de6bd784de6b8$export$2e2bcd8739ae039 = $414de6bd784de6b8$var$Profile;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $f3gEZ = parcelRequire("f3gEZ");

var $EHEsI = parcelRequire("EHEsI");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $2Xlz6 = parcelRequire("2Xlz6");

var $4TPr9 = parcelRequire("4TPr9");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $aTLkh = parcelRequire("aTLkh");

var $dI25G = parcelRequire("dI25G");

var $eOjgM = parcelRequire("eOjgM");

var $rMeTm = parcelRequire("rMeTm");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $aTLkh = parcelRequire("aTLkh");

var $kmjbt = parcelRequire("kmjbt");

var $kLrt8 = parcelRequire("kLrt8");

var $cstaF = parcelRequire("cstaF");
const $f463a4dd6d5bfac1$var$Filter = (props)=>{
    const { name: name, id: id, icon: icon, search: search, permanent: permanent, onClick: onClick, disabled: disabled, isFilterHidden: isFilterHidden } = props;
    const featureToggles = (0, $kLrt8.useFeatureToggles)();
    const hasSearchCriteria = (filter)=>{
        let found = false;
        if (search) {
            const mlsId = search?.mlsId;
            const criteriaObj = search.searchCriteria.criteria.realEstateDatasourceIdsWithFilters.find((x)=>x.realEstateDatasourceId === mlsId);
            switch(filter){
                case (0, $cstaF.searchTerms).mlsFilter:
                    found = !!mlsId;
                    break;
                case (0, $cstaF.searchTerms).propTypeFilter:
                    {
                        const propType = criteriaObj?.searchFields?.find((f)=>f.fieldName === filter);
                        found = !!propType && propType?.fieldValues?.length > 0;
                        break;
                    }
                case (0, $cstaF.searchTerms).timeFrameFilter:
                    found = !!search?.searchCriteria?.criteria?.timePeriod;
                    break;
                case (0, $cstaF.searchTerms).areaTypeFilter:
                    {
                        const areaType = criteriaObj?.computedFields?.find((field)=>field.fieldName === (0, $cstaF.searchTerms).areaTypeFilter);
                        found = areaType?.fieldValues?.length > 0;
                        break;
                    }
                case (0, $cstaF.searchTerms).marketAreaFilter:
                    {
                        const marketAreas = criteriaObj?.searchFields?.filter((f)=>(0, $cstaF.areaSearchTypes).includes(f.fieldName));
                        found = !!criteriaObj?.searchAllMLS || !!marketAreas?.length && marketAreas?.some((a)=>a.fieldValues?.length > 0);
                        break;
                    }
                case (0, $cstaF.searchTerms).listingStatusFilter:
                    {
                        const listingStatus = criteriaObj?.computedFields?.find((f)=>f.fieldName === (0, $cstaF.searchTerms).transactionStatus);
                        found = listingStatus?.fieldValues?.length > 0;
                        break;
                    }
                case (0, $cstaF.searchTerms).officesFilter:
                    {
                        const offices = criteriaObj?.idFiltering?.find((f)=>f.idType?.toLowerCase() === (0, $cstaF.searchTerms).officeIdType.toLowerCase());
                        found = offices?.idValues?.length > 0;
                        break;
                    }
                case (0, $cstaF.searchTerms).agentsFilter:
                    {
                        const agents = criteriaObj?.idFiltering?.find((f)=>f.idType?.toLowerCase() === (0, $cstaF.searchTerms).agentIdType.toLowerCase());
                        found = agents?.idValues?.length > 0;
                        break;
                    }
                default:
                    {
                        const filterGroups = (0, $kmjbt.getFilterGroups)({
                            isComparisonSetsEnabled: featureToggles.comparisonSets.isEnabled
                        });
                        const filterMap = filterGroups.find((g)=>g.title === (0, $cstaF.searchTerms).optional)?.filters.find((f)=>f.id === filter);
                        if (filterMap) {
                            const path = filterMap.path.split("/");
                            const searchField = filter === (0, $cstaF.searchTerms).lotSizeFilter ? criteriaObj?.[path[0]]?.find((f)=>f.fieldName === (0, $cstaF.searchTerms).lotSizeAcresFilter || f.fieldName === (0, $cstaF.searchTerms).lotSquareFeetFilter) : criteriaObj?.[path[0]].find((f)=>f.fieldName === path[1]);
                            found = !!searchField?.fieldValues?.length || !!searchField?.fieldMinValue || !!searchField?.fieldMaxValue || !!(criteriaObj?.mlsObjectId && id === (0, $cstaF.searchTerms).comparisonSetFilter);
                        }
                        break;
                    }
            }
        }
        return found;
    };
    return !isFilterHidden && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
            dataLwtId: id,
            block: true,
            size: "sm",
            color: "text",
            className: "mt-1 py-1 text-left text-capitalize",
            disabled: disabled,
            onClick: permanent ? undefined : ()=>onClick(id),
            children: [
                icon,
                name,
                hasSearchCriteria(id) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aTLkh.default), {
                    dataLwtId: `${id}-selected`,
                    className: "float-right text-primary mt-1",
                    iconName: "check"
                })
            ]
        })
    });
};
var $f463a4dd6d5bfac1$export$2e2bcd8739ae039 = $f463a4dd6d5bfac1$var$Filter;



var $cstaF = parcelRequire("cstaF");

var $bxSLe = parcelRequire("bxSLe");

var $57vuM = parcelRequire("57vuM");

var $ivaD7 = parcelRequire("ivaD7");

var $kmjbt = parcelRequire("kmjbt");

var $kLrt8 = parcelRequire("kLrt8");
const $4b36c4354132488b$var$iconProps = (icon, iconName)=>{
    return {
        icon: icon,
        title: `${iconName} icon`,
        className: "align-bottom mr-1"
    };
};
const $4b36c4354132488b$var$icons = {
    mls: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
        ...$4b36c4354132488b$var$iconProps((0, $eOjgM.home_chart), (0, $cstaF.searchTerms).mls)
    }),
    propertyType: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
        ...$4b36c4354132488b$var$iconProps((0, $eOjgM.home), (0, $cstaF.searchTerms).propertyType)
    }),
    areaType: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
        ...$4b36c4354132488b$var$iconProps((0, $eOjgM.map_pin), (0, $cstaF.searchTerms).areaType)
    }),
    timeFrame: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
        ...$4b36c4354132488b$var$iconProps((0, $eOjgM.clock), (0, $cstaF.searchTerms).timeFrame)
    }),
    marketArea: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
        ...$4b36c4354132488b$var$iconProps((0, $eOjgM.map_pin), (0, $cstaF.searchTerms).marketArea)
    }),
    totalVolume: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
        ...$4b36c4354132488b$var$iconProps((0, $eOjgM.coin), (0, $cstaF.searchTerms).totalVolume)
    }),
    soldPriceRange: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
        ...$4b36c4354132488b$var$iconProps((0, $eOjgM.coin), (0, $cstaF.searchTerms).soldPriceRange)
    }),
    priceRange: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
        ...$4b36c4354132488b$var$iconProps((0, $eOjgM.coin), (0, $cstaF.searchTerms).priceRange)
    }),
    totalUnits: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
        ...$4b36c4354132488b$var$iconProps((0, $eOjgM.sign_in_ground), (0, $cstaF.searchTerms).totalUnits)
    }),
    fullBathrooms: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
        ...$4b36c4354132488b$var$iconProps((0, $eOjgM.bathtub), (0, $cstaF.searchTerms).fullBathrooms)
    }),
    bedrooms: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
        ...$4b36c4354132488b$var$iconProps((0, $eOjgM.bed), (0, $cstaF.searchTerms).bedrooms)
    }),
    listingStatus: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
        ...$4b36c4354132488b$var$iconProps((0, $eOjgM.sign_sold), (0, $cstaF.searchTerms).listingStatus)
    }),
    offices: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
        ...$4b36c4354132488b$var$iconProps((0, $eOjgM.building_modern), (0, $cstaF.searchTerms).offices)
    }),
    agents: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
        ...$4b36c4354132488b$var$iconProps((0, $eOjgM.agent), (0, $cstaF.searchTerms).agents)
    }),
    squareFootage: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
        ...$4b36c4354132488b$var$iconProps((0, $eOjgM.box_size), (0, $cstaF.agentProductionTerms).squareFootage)
    }),
    lotSize: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
        ...$4b36c4354132488b$var$iconProps((0, $eOjgM.lot), (0, $cstaF.agentProductionTerms).lotSize)
    }),
    comparisonSet: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
        ...$4b36c4354132488b$var$iconProps((0, $eOjgM.home_compare), (0, $cstaF.searchTerms).comparisonSet)
    }),
    constructionType: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
        ...$4b36c4354132488b$var$iconProps((0, $eOjgM.toolkit), (0, $cstaF.searchTerms).constructionType)
    })
};
const $4b36c4354132488b$var$AddFilters = (props)=>{
    const { toggleFilter: toggleFilter, disabled: disabled, searchObj: searchObj, module: module, mlsMembershipInfo: mlsMembershipInfo } = props;
    const featureToggles = (0, $kLrt8.useFeatureToggles)();
    const [state, setState] = (0, $acw62.useState)({
        isPopoverOpen: false,
        isComparisonSetsEnabled: featureToggles.comparisonSets.isEnabled
    });
    (0, $57vuM.useCloseChip)(state.isPopoverOpen, setState);
    const handleUserKeyPress = (0, $acw62.useCallback)((event)=>{
        const { keyCode: keyCode, target: target } = event;
        if (keyCode === 191 && ![
            "input",
            "select",
            "textarea"
        ].includes(target.tagName.toLowerCase())) {
            togglePopover();
            event.preventDefault();
        }
    }, [
        state.isPopoverOpen
    ]);
    (0, $acw62.useEffect)(()=>{
        if (disabled === false) window.addEventListener("keydown", handleUserKeyPress);
        return ()=>{
            window.removeEventListener("keydown", handleUserKeyPress);
        };
    });
    const togglePopover = ()=>(0, $ivaD7.setStateData)("isPopoverOpen", !state.isPopoverOpen, setState);
    const selectFilter = (filter)=>{
        toggleFilter(filter);
        togglePopover();
    };
    const selectDropdownOption = (e)=>{
        selectFilter(e.value);
    };
    const groupStyles = {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between"
    };
    const formatGroupLabel = (data)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            style: groupStyles,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                children: data.label
            })
        });
    const getIsFilterDisabled = (filter)=>{
        if (filter.id === (0, $cstaF.searchTerms).squareFootageFilter) return !mlsMembershipInfo?.supportsSquareFootage;
        return filter.id === (0, $cstaF.searchTerms).lotSizeFilter && mlsMembershipInfo?.supportsLotSizeAcres === false && mlsMembershipInfo?.supportsLotSizeSqft === false;
    };
    const getMlsNotSupportIconTooltip = (filter)=>{
        if (filter.id === (0, $cstaF.searchTerms).squareFootageFilter || filter.id === (0, $cstaF.searchTerms).lotSizeFilter) {
            if (getIsFilterDisabled(filter)) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        id: `${filter.id}-icon`,
                        className: "d-flex align-items-center",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                            icon: (0, $eOjgM.circle_info)
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $rMeTm.default), {
                            target: `${filter.id}-icon`,
                            children: (0, $cstaF.searchTerms).mlsNotSupportMeasureType(filter.name)
                        })
                    })
                ]
            });
        }
    };
    const filterGroups = (0, $acw62.useMemo)(()=>{
        return (0, $kmjbt.getFilterGroups)({
            isComparisonSetsEnabled: featureToggles.comparisonSets.isEnabled
        });
    }, [
        featureToggles.comparisonSets.isEnabled
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                dataLwtId: "add-filters",
                size: "sm",
                color: "light",
                className: "mb-1 text-capitalize d-inline-flex align-items-center",
                id: "add-filters",
                disabled: disabled,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aTLkh.default), {
                        className: "mr-1 text-primary",
                        iconName: "add_circle",
                        dataLwtId: "add-icon"
                    }),
                    (0, $cstaF.buttonTerms).addFilter
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Xlz6))), {
                target: "add-filters",
                placement: "bottom",
                trigger: "legacy",
                size: "auto",
                isOpen: state.isPopoverOpen,
                toggle: togglePopover,
                disabled: disabled,
                style: {
                    maxHeight: "calc(100vh - 120px)",
                    overflowY: "auto",
                    minWidth: "220px"
                },
                body: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "d-flex mt-1 mb-2",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    className: "mr-auto filter-header",
                                    children: "Shortcut"
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "rounded btn-secondary bg-dark mx-1 d-flex align-items-center justify-content-center",
                                    style: {
                                        width: "1.5em",
                                        height: "1.5em"
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "helix-body--strong",
                                        children: "/"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4TPr9.default), {
                            placeholder: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                                        icon: (0, $eOjgM.search),
                                        className: "align-top mr-2",
                                        title: "search icon"
                                    }),
                                    "Search filters"
                                ]
                            }),
                            isClearable: false,
                            formatGroupLabel: formatGroupLabel,
                            options: filterGroups.map((group)=>{
                                return {
                                    label: group.title,
                                    options: group.filters.filter((f)=>!module || f.modules.includes(module)).map((f)=>({
                                            label: typeof f.name === "object" ? f.name?.[module] || f.id : f.name,
                                            value: f.id
                                        }))
                                };
                            }),
                            className: "mb-2 mt-1",
                            onChange: selectDropdownOption,
                            onlySearchLabel: true,
                            autoFocus: true
                        }),
                        filterGroups.map((group)=>{
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mr-auto filter-header mb-1",
                                        children: group.title
                                    }),
                                    group.filters.filter((filter)=>!module || filter.modules.includes(module)).map((filter)=>{
                                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                            className: "d-flex",
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f463a4dd6d5bfac1$export$2e2bcd8739ae039), {
                                                    id: filter.id,
                                                    name: typeof filter.name === "object" ? filter.name?.[module] || filter.id : filter.name,
                                                    icon: $4b36c4354132488b$var$icons[filter.id],
                                                    search: searchObj,
                                                    onClick: selectFilter,
                                                    permanent: filter.permanent,
                                                    disabled: getIsFilterDisabled(filter),
                                                    mlsMembershipInfo: mlsMembershipInfo,
                                                    isFilterHidden: (0, $kmjbt.getIsFilterHidden)(filter, mlsMembershipInfo)
                                                }),
                                                getMlsNotSupportIconTooltip(filter)
                                            ]
                                        }, filter.id);
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("hr", {
                                        className: "my-2"
                                    })
                                ]
                            }, group.title);
                        })
                    ]
                }),
                ...(0, $bxSLe.popoverModifiers)
            })
        ]
    });
};
var $4b36c4354132488b$export$2e2bcd8739ae039 = $4b36c4354132488b$var$AddFilters;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $f3gEZ = parcelRequire("f3gEZ");

var $3kePu = parcelRequire("3kePu");

var $2Xlz6 = parcelRequire("2Xlz6");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $dI25G = parcelRequire("dI25G");

var $eOjgM = parcelRequire("eOjgM");

var $7ROc5 = parcelRequire("7ROc5");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $dTR92 = parcelRequire("dTR92");

var $aVe6w = parcelRequire("aVe6w");

var $8OVl5 = parcelRequire("8OVl5");

var $afgje = parcelRequire("afgje");

var $hb0cD = parcelRequire("hb0cD");

var $lEs8E = parcelRequire("lEs8E");
/** Used as the size to enable large array optimizations. */ var $571f1dc3a08d57b9$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */ function $571f1dc3a08d57b9$var$baseDifference(array, values, iteratee, comparator) {
    var index = -1, includes = (0, $aVe6w.default), isCommon = true, length = array.length, result = [], valuesLength = values.length;
    if (!length) return result;
    if (iteratee) values = (0, $afgje.default)(values, (0, $hb0cD.default)(iteratee));
    if (comparator) {
        includes = (0, $8OVl5.default);
        isCommon = false;
    } else if (values.length >= $571f1dc3a08d57b9$var$LARGE_ARRAY_SIZE) {
        includes = (0, $lEs8E.default);
        isCommon = false;
        values = new (0, $dTR92.default)(values);
    }
    outer: while(++index < length){
        var value = array[index], computed = iteratee == null ? value : iteratee(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while(valuesIndex--){
                if (values[valuesIndex] === computed) continue outer;
            }
            result.push(value);
        } else if (!includes(values, computed, comparator)) result.push(value);
    }
    return result;
}
var $571f1dc3a08d57b9$export$2e2bcd8739ae039 = $571f1dc3a08d57b9$var$baseDifference;



var $kQGD1 = parcelRequire("kQGD1");

var $exqIp = parcelRequire("exqIp");

var $8Y2y0 = parcelRequire("8Y2y0");
/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */ var $78d6c0fbab3c80a5$var$difference = (0, $exqIp.default)(function(array, values) {
    return (0, $8Y2y0.default)(array) ? (0, $571f1dc3a08d57b9$export$2e2bcd8739ae039)(array, (0, $kQGD1.default)(values, 1, (0, $8Y2y0.default), true)) : [];
});
var $78d6c0fbab3c80a5$export$2e2bcd8739ae039 = $78d6c0fbab3c80a5$var$difference;


var $96LH4 = parcelRequire("96LH4");
var $fpekr = parcelRequire("fpekr");
var $b0dsn = parcelRequire("b0dsn");
var $3kePu = parcelRequire("3kePu");
var $exqIp = parcelRequire("exqIp");

var $afgje = parcelRequire("afgje");

var $4gro2 = parcelRequire("4gro2");
/**
 * This function is like `baseIndexOf` except that it accepts a comparator.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $01ff2778b3c14b4f$var$baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (comparator(array[index], value)) return index;
    }
    return -1;
}
var $01ff2778b3c14b4f$export$2e2bcd8739ae039 = $01ff2778b3c14b4f$var$baseIndexOfWith;



var $hb0cD = parcelRequire("hb0cD");

var $jXStN = parcelRequire("jXStN");
/** Used for built-in method references. */ var $6298a866bdc54318$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $6298a866bdc54318$var$splice = $6298a866bdc54318$var$arrayProto.splice;
/**
 * The base implementation of `_.pullAllBy` without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns `array`.
 */ function $6298a866bdc54318$var$basePullAll(array, values, iteratee, comparator) {
    var indexOf = comparator ? (0, $01ff2778b3c14b4f$export$2e2bcd8739ae039) : (0, $4gro2.default), index = -1, length = values.length, seen = array;
    if (array === values) values = (0, $jXStN.default)(values);
    if (iteratee) seen = (0, $afgje.default)(array, (0, $hb0cD.default)(iteratee));
    while(++index < length){
        var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
        while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
            if (seen !== array) $6298a866bdc54318$var$splice.call(seen, fromIndex, 1);
            $6298a866bdc54318$var$splice.call(array, fromIndex, 1);
        }
    }
    return array;
}
var $6298a866bdc54318$export$2e2bcd8739ae039 = $6298a866bdc54318$var$basePullAll;


/**
 * This method is like `_.pull` except that it accepts an array of values to remove.
 *
 * **Note:** Unlike `_.difference`, this method mutates `array`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Array} values The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pullAll(array, ['a', 'c']);
 * console.log(array);
 * // => ['b', 'b']
 */ function $388ae3915b12347f$var$pullAll(array, values) {
    return array && array.length && values && values.length ? (0, $6298a866bdc54318$export$2e2bcd8739ae039)(array, values) : array;
}
var $388ae3915b12347f$export$2e2bcd8739ae039 = $388ae3915b12347f$var$pullAll;


/**
 * Removes all given values from `array` using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
 * to remove elements from an array by predicate.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {...*} [values] The values to remove.
 * @returns {Array} Returns `array`.
 * @example
 *
 * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
 *
 * _.pull(array, 'a', 'c');
 * console.log(array);
 * // => ['b', 'b']
 */ var $622d416698e0e082$var$pull = (0, $exqIp.default)((0, $388ae3915b12347f$export$2e2bcd8739ae039));
var $622d416698e0e082$export$2e2bcd8739ae039 = $622d416698e0e082$var$pull;


var $jUkRP = parcelRequire("jUkRP");
var $6Vs3L = parcelRequire("6Vs3L");

var $4TPr9 = parcelRequire("4TPr9");
var $64088e28bcd161d0$exports = {};
"use strict";
var $64088e28bcd161d0$var$__importDefault = $64088e28bcd161d0$exports && $64088e28bcd161d0$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($64088e28bcd161d0$exports, "__esModule", {
    value: true
});

const $64088e28bcd161d0$var$react_1 = $64088e28bcd161d0$var$__importDefault((parcelRequire("acw62")));

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $e9hDx = parcelRequire("e9hDx");
var $aca3f02f8a7a0aa6$var$propTypes = {
    tag: (0, $e9hDx.tagPropType),
    flush: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    horizontal: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ])
};
var $aca3f02f8a7a0aa6$var$defaultProps = {
    tag: "ul",
    horizontal: false
};
var $aca3f02f8a7a0aa6$var$getHorizontalClass = function getHorizontalClass(horizontal) {
    if (horizontal === false) return false;
    else if (horizontal === true || horizontal === "xs") return "list-group-horizontal";
    return "list-group-horizontal-" + horizontal;
};
var $aca3f02f8a7a0aa6$var$ListGroup = function ListGroup(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, flush = props.flush, horizontal = props.horizontal, attributes = (0, $1En50.default)(props, [
        "className",
        "cssModule",
        "tag",
        "flush",
        "horizontal"
    ]);
    var classes = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, "list-group", // we only try to apply horizontal classes if flush is false
    flush ? "list-group-flush" : $aca3f02f8a7a0aa6$var$getHorizontalClass(horizontal)), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({}, attributes, {
        className: classes
    }));
};
$aca3f02f8a7a0aa6$var$ListGroup.propTypes = $aca3f02f8a7a0aa6$var$propTypes;
$aca3f02f8a7a0aa6$var$ListGroup.defaultProps = $aca3f02f8a7a0aa6$var$defaultProps;
var $aca3f02f8a7a0aa6$export$2e2bcd8739ae039 = $aca3f02f8a7a0aa6$var$ListGroup;


const $64088e28bcd161d0$var$ListGroup = (props)=>{
    const { children: children, dataLwtId: dataLwtId, ...restProps } = props;
    return $64088e28bcd161d0$var$react_1.default.createElement($aca3f02f8a7a0aa6$export$2e2bcd8739ae039, {
        "data-lwt-id": dataLwtId,
        ...restProps
    }, children);
};
$64088e28bcd161d0$exports.default = $64088e28bcd161d0$var$ListGroup;


var $ab5f68d1dbc8673a$exports = {};
"use strict";
var $ab5f68d1dbc8673a$var$__importDefault = $ab5f68d1dbc8673a$exports && $ab5f68d1dbc8673a$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($ab5f68d1dbc8673a$exports, "__esModule", {
    value: true
});

const $ab5f68d1dbc8673a$var$react_1 = $ab5f68d1dbc8673a$var$__importDefault((parcelRequire("acw62")));

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $e9hDx = parcelRequire("e9hDx");
var $158faec1850f9ddd$var$propTypes = {
    tag: (0, $e9hDx.tagPropType),
    active: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    action: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $158faec1850f9ddd$var$defaultProps = {
    tag: "li"
};
var $158faec1850f9ddd$var$handleDisabledOnClick = function handleDisabledOnClick(e) {
    e.preventDefault();
};
var $158faec1850f9ddd$var$ListGroupItem = function ListGroupItem(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, active = props.active, disabled = props.disabled, action = props.action, color = props.color, attributes = (0, $1En50.default)(props, [
        "className",
        "cssModule",
        "tag",
        "active",
        "disabled",
        "action",
        "color"
    ]);
    var classes = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, active ? "active" : false, disabled ? "disabled" : false, action ? "list-group-item-action" : false, color ? "list-group-item-" + color : false, "list-group-item"), cssModule); // Prevent click event when disabled.
    if (disabled) attributes.onClick = $158faec1850f9ddd$var$handleDisabledOnClick;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({}, attributes, {
        className: classes
    }));
};
$158faec1850f9ddd$var$ListGroupItem.propTypes = $158faec1850f9ddd$var$propTypes;
$158faec1850f9ddd$var$ListGroupItem.defaultProps = $158faec1850f9ddd$var$defaultProps;
var $158faec1850f9ddd$export$2e2bcd8739ae039 = $158faec1850f9ddd$var$ListGroupItem;


var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $e9hDx = parcelRequire("e9hDx");
var $008f73c6ea4fcefd$var$propTypes = {
    tag: (0, $e9hDx.tagPropType),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $008f73c6ea4fcefd$var$defaultProps = {
    tag: "h5"
};
var $008f73c6ea4fcefd$var$ListGroupItemHeading = function ListGroupItemHeading(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, attributes = (0, $1En50.default)(props, [
        "className",
        "cssModule",
        "tag"
    ]);
    var classes = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, "list-group-item-heading"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({}, attributes, {
        className: classes
    }));
};
$008f73c6ea4fcefd$var$ListGroupItemHeading.propTypes = $008f73c6ea4fcefd$var$propTypes;
$008f73c6ea4fcefd$var$ListGroupItemHeading.defaultProps = $008f73c6ea4fcefd$var$defaultProps;
var $008f73c6ea4fcefd$export$2e2bcd8739ae039 = $008f73c6ea4fcefd$var$ListGroupItemHeading;


const $ab5f68d1dbc8673a$var$ListGroupItem = (props)=>{
    const { headerProps: headerProps, children: children, tag: tag, action: action, dataLwtId: dataLwtId, ...restProps } = props;
    let setAction = action;
    if (setAction === undefined && (tag === "button" || tag === "a")) setAction = true;
    return $ab5f68d1dbc8673a$var$react_1.default.createElement($158faec1850f9ddd$export$2e2bcd8739ae039, {
        action: setAction,
        "data-lwt-id": dataLwtId,
        tag: tag,
        ...restProps
    }, headerProps && $ab5f68d1dbc8673a$var$react_1.default.createElement($008f73c6ea4fcefd$export$2e2bcd8739ae039, {
        ...headerProps
    }, headerProps.children), children);
};
$ab5f68d1dbc8673a$exports.default = $ab5f68d1dbc8673a$var$ListGroupItem;


var $14b4f6db1347df90$exports = {};
"use strict";
var $14b4f6db1347df90$var$__importDefault = $14b4f6db1347df90$exports && $14b4f6db1347df90$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($14b4f6db1347df90$exports, "__esModule", {
    value: true
});

const $14b4f6db1347df90$var$react_1 = $14b4f6db1347df90$var$__importDefault((parcelRequire("acw62")));

var $8nd05 = parcelRequire("8nd05");

var $1En50 = parcelRequire("1En50");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8g1PZ = parcelRequire("8g1PZ");

var $e9hDx = parcelRequire("e9hDx");
var $8a810b0b2e40bf51$var$propTypes = {
    tag: (0, $e9hDx.tagPropType),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    cssModule: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $8a810b0b2e40bf51$var$defaultProps = {
    tag: "p"
};
var $8a810b0b2e40bf51$var$ListGroupItemText = function ListGroupItemText(props) {
    var className = props.className, cssModule = props.cssModule, Tag = props.tag, attributes = (0, $1En50.default)(props, [
        "className",
        "cssModule",
        "tag"
    ]);
    var classes = (0, $e9hDx.mapToCssModules)((0, (/*@__PURE__*/$parcel$interopDefault($8g1PZ)))(className, "list-group-item-text"), cssModule);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Tag, (0, $8nd05.default)({}, attributes, {
        className: classes
    }));
};
$8a810b0b2e40bf51$var$ListGroupItemText.propTypes = $8a810b0b2e40bf51$var$propTypes;
$8a810b0b2e40bf51$var$ListGroupItemText.defaultProps = $8a810b0b2e40bf51$var$defaultProps;
var $8a810b0b2e40bf51$export$2e2bcd8739ae039 = $8a810b0b2e40bf51$var$ListGroupItemText;


const $14b4f6db1347df90$var$ListGroupItemText = (props)=>{
    const { children: children, dataLwtId: dataLwtId, ...restProps } = props;
    return $14b4f6db1347df90$var$react_1.default.createElement($8a810b0b2e40bf51$export$2e2bcd8739ae039, {
        ...restProps,
        "data-lwt-id": dataLwtId
    }, children);
};
$14b4f6db1347df90$exports.default = $14b4f6db1347df90$var$ListGroupItemText;




parcelRequire("fHiKR");
var $1BYDb = parcelRequire("1BYDb");

var $dI25G = parcelRequire("dI25G");

var $eOjgM = parcelRequire("eOjgM");

var $cstaF = parcelRequire("cstaF");

var $ivaD7 = parcelRequire("ivaD7");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $32kym = parcelRequire("32kym");

var $cstaF = parcelRequire("cstaF");
const $6705f228a725a1aa$var$LimitedSelectInput = (inputProps)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $32kym.F).Input, {
        ...inputProps,
        maxLength: (0, $cstaF.SEARCH_VALUE_MAX_LENGTH)
    });
var $6705f228a725a1aa$export$2e2bcd8739ae039 = $6705f228a725a1aa$var$LimitedSelectInput;


const $f0cfd8232f8220cd$var$PropertyType = (props)=>{
    const { setPropTypes: setPropTypes, toggleInvalid: toggleInvalid, initialPropTypes: initialPropTypes, module: module, invalid: invalid, propTypes: propTypes } = props;
    const initialState = {
        propTypes: [],
        propTypeHash: {},
        propTypesCount: 0,
        selectedPropTypes: initialPropTypes,
        groupedOptions: [],
        validationMessage: undefined
    };
    const [state, setState] = (0, $acw62.useState)({
        ...initialState
    });
    (0, $acw62.useEffect)(()=>{
        if (module) {
            let propTypeHash = {};
            const groupedOptions = [];
            if (propTypes) {
                $fpekr.default(propTypes, (propType)=>{
                    propTypeHash[propType.classId] = $3kePu.default(propType.types, (t)=>t.typeId);
                    groupedOptions.push({
                        label: propType.longName,
                        options: $3kePu.default(propType.types, (type)=>({
                                value: type.typeId,
                                label: type.longName
                            }))
                    });
                });
                const propTypesCount = $jUkRP.default($96LH4.default(propTypeHash, (x)=>x.length));
                setState({
                    ...state,
                    propTypes: propTypes,
                    propTypeHash: propTypeHash,
                    propTypesCount: propTypesCount,
                    groupedOptions: groupedOptions
                });
            }
        }
    }, [
        propTypes
    ]);
    (0, $acw62.useEffect)(()=>{
        if (state.selectedPropTypes) {
            if (state.selectedPropTypes.length === 0) {
                setState((prevState)=>({
                        ...prevState,
                        validationMessage: (0, $cstaF.validationMessages).propertyTypesNoSelectionError
                    }));
                toggleInvalid();
            } else setState((prevState)=>({
                    ...prevState,
                    validationMessage: undefined
                }));
            setPropTypes(state.selectedPropTypes);
        }
    }, [
        state.selectedPropTypes
    ]);
    const groupStyles = {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between"
    };
    const toggleSelectAll = (e)=>{
        (0, $ivaD7.setStateData)("selectedPropTypes", e.target.checked ? $96LH4.default(state.propTypeHash, (x)=>x) : [], setState);
    };
    const isAllClassTypesSelected = (classId)=>$b0dsn.default(state.propTypeHash[classId], state.selectedPropTypes || []).length === state.propTypeHash[classId].length;
    const toggleClassSelection = (e)=>{
        const classId = e.target.id.split("class-").join("");
        const selectedPropTypes = e.target.checked ? $6Vs3L.default([
            ...state.selectedPropTypes || []
        ], [
            ...state.propTypeHash[classId]
        ]) : $78d6c0fbab3c80a5$export$2e2bcd8739ae039([
            ...state.selectedPropTypes || []
        ], [
            ...state.propTypeHash[classId]
        ]);
        (0, $ivaD7.setStateData)("selectedPropTypes", selectedPropTypes, setState);
    };
    const updateTypeSelection = (typeId, condition)=>{
        let selectedPropTypes = [
            ...state.selectedPropTypes || []
        ];
        if (condition) selectedPropTypes.push(typeId);
        else selectedPropTypes = $622d416698e0e082$export$2e2bcd8739ae039(selectedPropTypes, typeId);
        (0, $ivaD7.setStateData)("selectedPropTypes", selectedPropTypes, setState);
    };
    const toggleTypeSelection = (e)=>{
        const typeId = Number(e.target.id.split("proptype-").join(""));
        const condition = e.target.checked;
        updateTypeSelection(typeId, condition);
    };
    const onTypeSelection = (type)=>{
        const typeId = type.value;
        const condition = !state.selectedPropTypes || state.selectedPropTypes?.indexOf(typeId) === -1;
        updateTypeSelection(typeId, condition);
    };
    const formatGroupLabel = (data)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            style: groupStyles,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                children: data.label
            })
        });
    const propTypesList = ()=>{
        const childItems = (classId, types)=>types.map((type)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ab5f68d1dbc8673a$exports))), {
                    className: "border-0 ml-4 py-1",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1BYDb))), {
                        dataLwtId: type.typeId,
                        type: "checkbox",
                        defaultChecked: true,
                        checked: !!state.selectedPropTypes?.length && state.selectedPropTypes.indexOf(type.typeId) !== -1,
                        label: type.longName,
                        id: `proptype-${type.typeId}`,
                        onClick: toggleTypeSelection
                    })
                }, type.typeId));
        return state.propTypes.map((propType)=>{
            if (propType.types.length > 0) return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ab5f68d1dbc8673a$exports))), {
                        className: "border-0 py-1",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1BYDb))), {
                            dataLwtId: propType.classId,
                            type: "checkbox",
                            defaultChecked: true,
                            checked: isAllClassTypesSelected(propType.classId),
                            label: propType.longName,
                            id: `class-${propType.classId}`,
                            onClick: toggleClassSelection
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($64088e28bcd161d0$exports))), {
                        flush: true,
                        children: childItems(propType.classId, propType.types)
                    })
                ]
            }, propType.classId);
            else return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($64088e28bcd161d0$exports))), {
                    flush: true,
                    children: childItems(propType.classId, propType.types)
                })
            }, propType.types[0]?.typeId ?? propType.classId);
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4TPr9.default), {
                placeholder: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                            icon: (0, $eOjgM.search),
                            className: "align-top mr-1",
                            title: "search icon"
                        }),
                        " Search property types"
                    ]
                }),
                formatGroupLabel: formatGroupLabel,
                options: state.groupedOptions,
                className: "mb-2",
                onChange: onTypeSelection,
                matchFrom: "start",
                autoFocus: true,
                isClearable: false,
                value: null,
                components: {
                    Input: (0, $6705f228a725a1aa$export$2e2bcd8739ae039)
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($64088e28bcd161d0$exports))), {
                flush: true,
                className: "border-0 mb-1",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ab5f68d1dbc8673a$exports))), {
                    className: "border-0 py-1 pb-2",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1BYDb))), {
                        dataLwtId: "select-deselect-all",
                        type: "checkbox",
                        defaultChecked: true,
                        checked: !!state.selectedPropTypes?.length && state.selectedPropTypes.length === state.propTypesCount,
                        label: "Select/Deselect All",
                        id: "select-deselect-all",
                        onClick: toggleSelectAll
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($64088e28bcd161d0$exports))), {
                flush: true,
                style: {
                    maxHeight: "250px",
                    overflowY: "auto"
                },
                className: `form-control ${invalid && "is-invalid"}`,
                children: propTypesList()
            }),
            state.validationMessage && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "text-danger p-2",
                style: {
                    whiteSpace: "pre-wrap"
                },
                children: state.validationMessage
            })
        ]
    });
};
var $f0cfd8232f8220cd$export$2e2bcd8739ae039 = $f0cfd8232f8220cd$var$PropertyType;



var $cstaF = parcelRequire("cstaF");

var $ivaD7 = parcelRequire("ivaD7");

var $bxSLe = parcelRequire("bxSLe");

var $90ISC = parcelRequire("90ISC");

var $57vuM = parcelRequire("57vuM");
const $237b412766c74655$var$PropertyTypeChip = (props)=>{
    const { disabled: disabled, module: module, selectedMls: selectedMls, mlsProps: mlsProps } = props;
    const { search: search, title: title, setSelectedPropTypes: setSelectedPropTypes } = (0, $90ISC.useSearchStore)((state)=>({
            search: state[module]?.search,
            title: state[module]?.propertyTypeTitle,
            setSelectedPropTypes: state.setSelectedPropTypes
        }), (0, $f3gEZ.shallow));
    const initialState = {
        isPopoverOpen: false,
        title: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).propertyTypes)
    };
    const [state, setState] = (0, $acw62.useState)({
        ...initialState
    });
    (0, $57vuM.useCloseChip)(state.isPopoverOpen, setState);
    (0, $acw62.useEffect)(()=>{
        if (selectedMls) {
            const mlsData = {
                ...search?.searchCriteria?.criteria?.realEstateDatasourceIdsWithFilters?.find((mlsItem)=>mlsItem.realEstateDatasourceId === (selectedMls?.mlsId ?? search.mlsId))
            };
            const field = mlsData?.searchFields?.find((searchField)=>searchField.fieldName === "propertyType");
            const selectedPropTypes = field ? $3kePu.default(field.fieldValues, (v)=>Number(v)) : undefined;
            (0, $ivaD7.setStateData)("selectedPropTypes", selectedPropTypes, setState);
        }
    }, [
        search
    ]);
    (0, $acw62.useEffect)(()=>{
        (0, $bxSLe.toggleRunSearchButton)(state.isPopoverOpen);
    }, [
        state.isPopoverOpen
    ]);
    (0, $acw62.useEffect)(()=>{
        (0, $ivaD7.setStateData)("invalid", false, setState);
    }, [
        selectedMls
    ]);
    const togglePopover = ()=>{
        !state.invalid && (0, $ivaD7.setStateData)("isPopoverOpen", !state.isPopoverOpen, setState);
    };
    const toggleInvalid = ()=>{
        (0, $ivaD7.setStateData)("invalid", true, setState);
    };
    const savePropTypes = (propTypes)=>{
        if (propTypes !== state.selectedPropTypes) {
            setSelectedPropTypes(propTypes, mlsProps.propTypes);
            (0, $ivaD7.setStateData)("invalid", false, setState);
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                dataLwtId: "proptype-chip",
                size: "sm",
                color: "secondary",
                className: "mb-1",
                id: "property-type",
                disabled: disabled,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                        icon: (0, $eOjgM.home),
                        ...(0, $7ROc5.chipIconProps),
                        title: "home icon"
                    }),
                    title?.mainTitle
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Xlz6))), {
                target: "property-type",
                placement: "bottom",
                size: "auto",
                trigger: "legacy",
                header: (0, $cstaF.searchTerms).propertyTypes,
                isOpen: state.isPopoverOpen,
                toggle: togglePopover,
                style: {
                    minWidth: "250px"
                },
                body: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f0cfd8232f8220cd$export$2e2bcd8739ae039), {
                    module: module,
                    initialPropTypes: state.selectedPropTypes,
                    setPropTypes: savePropTypes,
                    toggleInvalid: toggleInvalid,
                    invalid: state.invalid,
                    selectedMlsId: selectedMls?.mlsId,
                    propTypes: mlsProps.propTypes
                }),
                disabled: disabled,
                ...(0, $bxSLe.popoverModifiers)
            })
        ]
    });
};
var $237b412766c74655$export$2e2bcd8739ae039 = $237b412766c74655$var$PropertyTypeChip;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $f3gEZ = parcelRequire("f3gEZ");

var $2Xlz6 = parcelRequire("2Xlz6");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $dI25G = parcelRequire("dI25G");

var $eOjgM = parcelRequire("eOjgM");

var $7ROc5 = parcelRequire("7ROc5");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("fHiKR");
var $5txPe = parcelRequire("5txPe");

var $4TPr9 = parcelRequire("4TPr9");

var $dI25G = parcelRequire("dI25G");

var $eOjgM = parcelRequire("eOjgM");

var $ivaD7 = parcelRequire("ivaD7");

var $cstaF = parcelRequire("cstaF");

var $aYbF1 = parcelRequire("aYbF1");

const $8b0a81bc50bec2d3$var$TimeFrame = (props)=>{
    const { timePeriodOptions: timePeriodOptions, selectedTimeFrame: selectedTimeFrame, setTimeFrame: setTimeFrame, validationProps: validationProps, togglePopover: togglePopover } = props;
    let { validationMessage: validationMessage, startDateInvalid: startDateInvalid, endDateInvalid: endDateInvalid } = {
        ...validationProps
    };
    const [state, setState] = (0, $acw62.useState)({
        selectedTimeFrame: selectedTimeFrame,
        isPopoverOpen: false,
        showCustomDateFields: false
    });
    const handleChange = (e)=>{
        setState((prevState)=>({
                ...prevState,
                showCustomDateFields: (0, $aYbF1.isCustomDate)(e.value),
                selectedTimeFrame: {
                    type: e.value
                },
                validationMessage: undefined
            }));
    };
    (0, $acw62.useEffect)(()=>{
        (0, $ivaD7.setStateData)("showCustomDateFields", (0, $aYbF1.isCustomDate)(state.selectedTimeFrame?.type), setState);
        if (state.selectedTimeFrame && state.selectedTimeFrame !== selectedTimeFrame) {
            if (!(0, $aYbF1.isCustomDate)(state.selectedTimeFrame.type)) togglePopover(state.selectedTimeFrame);
            else setTimeFrame(state.selectedTimeFrame);
        }
    }, [
        state.selectedTimeFrame
    ]);
    const changeDate = (e, dateType)=>{
        const nextTimeFrame = {
            ...state.selectedTimeFrame
        };
        if (dateType === "start") nextTimeFrame.startDate = e.currentTarget.value ? e.currentTarget.value : undefined;
        else nextTimeFrame.endDate = e.currentTarget.value ? e.currentTarget.value : undefined;
        (0, $ivaD7.setStateData)("selectedTimeFrame", nextTimeFrame, setState);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        style: {
            minWidth: "200px"
        },
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4TPr9.default), {
                dataLwtId: "time-frame-select",
                className: "mb-2 w-100",
                type: "select",
                value: state.selectedTimeFrame?.type && timePeriodOptions.find((tp)=>tp.value === state.selectedTimeFrame.type),
                onChange: (e)=>handleChange(e),
                placeholder: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                            icon: (0, $eOjgM.search),
                            className: "align-top mr-1",
                            title: "search icon"
                        }),
                        `Select a ${(0, $cstaF.searchTerms).timeFrame}`
                    ]
                }),
                options: timePeriodOptions,
                matchFrom: "start",
                autoFocus: true,
                isClearable: false,
                components: {
                    Input: (0, $6705f228a725a1aa$export$2e2bcd8739ae039)
                }
            }),
            state.showCustomDateFields && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "d-flex",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5txPe))), {
                        dataLwtId: "start-date",
                        className: "d-inline-block",
                        defaultValue: state.selectedTimeFrame.startDate,
                        type: "date",
                        onChange: (e)=>changeDate(e, "start"),
                        invalid: startDateInvalid
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "m-2",
                        children: "-"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5txPe))), {
                        dataLwtId: "end-date",
                        className: "d-inline-block",
                        defaultValue: state.selectedTimeFrame.endDate,
                        type: "date",
                        onChange: (e)=>changeDate(e, "end"),
                        invalid: endDateInvalid
                    })
                ]
            }),
            validationMessage && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "text-danger p-2",
                style: {
                    whiteSpace: "pre-wrap"
                },
                children: validationMessage
            })
        ]
    });
};
var $8b0a81bc50bec2d3$export$2e2bcd8739ae039 = $8b0a81bc50bec2d3$var$TimeFrame;



var $cstaF = parcelRequire("cstaF");

var $ivaD7 = parcelRequire("ivaD7");

var $bxSLe = parcelRequire("bxSLe");

var $75U5M = parcelRequire("75U5M");

var $aYbF1 = parcelRequire("aYbF1");

var $90ISC = parcelRequire("90ISC");

var $57vuM = parcelRequire("57vuM");
const $73b483715bf183b8$var$TimeFrameChip = (props)=>{
    const { disabled: disabled, module: module, selectedMls: selectedMls } = props;
    const { search: search, title: title, setTimePeriod: setTimePeriod } = (0, $90ISC.useSearchStore)((state)=>({
            search: state[module]?.search,
            title: state[module]?.timeFrameTitle,
            setTimePeriod: state.setTimePeriod
        }), (0, $f3gEZ.shallow));
    const { membership: membership, timeIntervals: timeIntervals } = (0, $90ISC.useCommonStore)((state)=>({
            membership: state.membership,
            timeIntervals: state.timeIntervals
        }), (0, $f3gEZ.shallow));
    const initialState = {
        isPopoverOpen: false,
        selectedTimeFrame: undefined,
        title: {
            mainTitle: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).timeFrame)
        }
    };
    const [state, setState] = (0, $acw62.useState)({
        ...initialState,
        mlsMembershipList: []
    });
    (0, $57vuM.useCloseChip)(state.isPopoverOpen, setState);
    (0, $acw62.useEffect)(()=>{
        if (selectedMls) {
            const selectedTimePeriod = search.searchCriteria.criteria.timePeriod;
            if (selectedTimePeriod) {
                const selectedTimeFrame = {
                    type: selectedTimePeriod.intervalType,
                    startDate: selectedTimePeriod.startDate,
                    endDate: selectedTimePeriod.endDate
                };
                (0, $ivaD7.setStateData)("selectedTimeFrame", selectedTimeFrame, setState);
            } else setState((prevState)=>({
                    ...initialState,
                    mlsMembershipList: prevState.mlsMembershipList
                }));
        }
    }, [
        search
    ]);
    (0, $acw62.useEffect)(()=>{
        (0, $bxSLe.toggleRunSearchButton)(state.isPopoverOpen);
    }, [
        state.isPopoverOpen
    ]);
    const togglePopover = (selectedTimeFrame)=>{
        const timeFrame = selectedTimeFrame || state.selectedTimeFrame;
        const hasTimeFrameTypeChanged = selectedTimeFrame && selectedTimeFrame?.type !== state.selectedTimeFrame?.type;
        if (state.isPopoverOpen) {
            if (hasTimeFrameTypeChanged || state.customDateChanged) {
                const nextState = {
                    ...state
                };
                const validationProps = (0, $75U5M.validateTimeFrame)(timeFrame);
                if (validationProps.isValid) {
                    setTimePeriod(timeFrame.type, timeFrame.startDate, timeFrame.endDate, timeIntervals);
                    nextState.validationProps = undefined;
                    nextState.isPopoverOpen = false;
                } else nextState.validationProps = validationProps;
                setState(nextState);
            } else (0, $ivaD7.setStateData)("isPopoverOpen", !state.isPopoverOpen, setState);
        } else (0, $ivaD7.setStateData)("isPopoverOpen", !state.isPopoverOpen, setState);
    };
    const saveTimeFrame = (timeFrame)=>{
        (0, $ivaD7.setStateData)("selectedTimeFrame", timeFrame, setState);
        (0, $ivaD7.setStateData)("customDateChanged", true, setState);
    };
    const timePeriodOptions = selectedMls && membership && (0, $aYbF1.getTimePeriodsByModule)({
        module: module,
        selectedMlsId: selectedMls?.mlsId,
        mlsMembershipList: membership
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                id: "timeframe-chip",
                dataLwtId: "timeframe-chip",
                size: "sm",
                color: "secondary",
                className: "mb-1 text-capitalize",
                onClick: ()=>togglePopover(),
                disabled: disabled,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                        icon: (0, $eOjgM.clock),
                        ...(0, $7ROc5.chipIconProps),
                        title: "time icon"
                    }),
                    title?.mainTitle,
                    title?.subtitle && `: ${title.subtitle}`
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Xlz6))), {
                innerClassName: "helix-heading",
                style: {
                    minWidth: "250px"
                },
                target: "timeframe-chip",
                placement: "bottom",
                size: "auto",
                trigger: "legacy",
                header: (0, $cstaF.searchTerms).timeFrame,
                isOpen: state.isPopoverOpen,
                toggle: ()=>togglePopover(),
                body: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8b0a81bc50bec2d3$export$2e2bcd8739ae039), {
                    initialTimeFrame: state.selectedTimeFrame,
                    setTimeFrame: saveTimeFrame,
                    module: module,
                    togglePopover: (timeFrame)=>togglePopover(timeFrame),
                    validationProps: state.validationProps,
                    selectedTimeFrame: state.selectedTimeFrame,
                    timePeriodOptions: timePeriodOptions
                }),
                disabled: disabled,
                ...(0, $bxSLe.popoverModifiers)
            })
        ]
    });
};
var $73b483715bf183b8$export$2e2bcd8739ae039 = $73b483715bf183b8$var$TimeFrameChip;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $f3gEZ = parcelRequire("f3gEZ");

var $2Xlz6 = parcelRequire("2Xlz6");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $dI25G = parcelRequire("dI25G");

var $eOjgM = parcelRequire("eOjgM");

var $7ROc5 = parcelRequire("7ROc5");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("fHiKR");
var $1BYDb = parcelRequire("1BYDb");

var $cstaF = parcelRequire("cstaF");

var $90ISC = parcelRequire("90ISC");
const $58d158037764c84f$var$ListingStatus = (props)=>{
    const { togglePopover: togglePopover, initialListingStatus: initialListingStatus, module: module } = props;
    const setListingStatus = (0, $90ISC.useSearchStore)((state)=>state.setListingStatus);
    const listingStatuses = module === (0, $cstaF.modules).marketShare.totals ? (0, $cstaF.marketShareListingStatuses) : (0, $cstaF.marketShareListingStatusesCoverage);
    const onChangeValue = (e)=>{
        const listingStatus = e.target.value;
        if (listingStatus && listingStatus !== initialListingStatus) {
            setListingStatus({
                value: listingStatus,
                title: listingStatuses[listingStatus]
            });
            togglePopover();
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: {
            minWidth: "300px"
        },
        onChange: onChangeValue,
        children: Object.keys(listingStatuses).map((s)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1BYDb))), {
                dataLwtId: `status-select-${s}`,
                id: `status-select-${s}`,
                value: s,
                type: "radio",
                name: "listing-status",
                label: listingStatuses[s],
                checked: initialListingStatus === s
            }, s);
        })
    });
};
var $58d158037764c84f$export$2e2bcd8739ae039 = $58d158037764c84f$var$ListingStatus;



var $cstaF = parcelRequire("cstaF");

var $ivaD7 = parcelRequire("ivaD7");

var $bxSLe = parcelRequire("bxSLe");

var $90ISC = parcelRequire("90ISC");

var $57vuM = parcelRequire("57vuM");
const $e2e5378f41681935$var$ListingStatusChip = (props)=>{
    const { disabled: disabled, module: module, selectedMls: selectedMls } = props;
    const { search: search, title: title } = (0, $90ISC.useSearchStore)((state)=>({
            search: state[module]?.search,
            title: state[module]?.listingStatusTitle
        }), (0, $f3gEZ.shallow));
    const initialState = {
        isPopoverOpen: false
    };
    const [state, setState] = (0, $acw62.useState)({
        ...initialState
    });
    (0, $57vuM.useCloseChip)(state.isPopoverOpen, setState);
    (0, $acw62.useEffect)(()=>{
        if (selectedMls) {
            const mls = {
                ...search?.searchCriteria?.criteria?.realEstateDatasourceIdsWithFilters?.find((mls)=>mls.realEstateDatasourceId === search.mlsId)
            };
            const listingStatusCriteria = mls.computedFields.find((searchField)=>searchField.fieldName === (0, $cstaF.searchTerms).transactionStatus);
            (0, $ivaD7.setStateData)("selectedListingStatus", listingStatusCriteria?.fieldValues.length ? listingStatusCriteria.fieldValues[0] : undefined, setState);
        }
    }, [
        search
    ]);
    (0, $acw62.useEffect)(()=>{
        (0, $bxSLe.toggleRunSearchButton)(state.isPopoverOpen);
    }, [
        state.isPopoverOpen
    ]);
    const togglePopover = ()=>(0, $ivaD7.setStateData)("isPopoverOpen", !state.isPopoverOpen, setState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                id: "listing-status-chip",
                dataLwtId: "listing-status-chip",
                size: "sm",
                color: "secondary",
                className: "mb-1 text-capitalize",
                onClick: togglePopover,
                disabled: disabled,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                        icon: (0, $eOjgM.sign_sold),
                        ...(0, $7ROc5.chipIconProps),
                        title: "sold icon"
                    }),
                    title?.mainTitle
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Xlz6))), {
                innerClassName: "helix-heading",
                target: "listing-status-chip",
                placement: "bottom",
                size: "auto",
                trigger: "legacy",
                header: (0, $cstaF.searchTerms).listingStatus,
                isOpen: state?.isPopoverOpen,
                toggle: togglePopover,
                body: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $58d158037764c84f$export$2e2bcd8739ae039), {
                    togglePopover: togglePopover,
                    initialListingStatus: state.selectedListingStatus,
                    module: module
                }),
                disabled: disabled
            })
        ]
    });
};
var $e2e5378f41681935$export$2e2bcd8739ae039 = $e2e5378f41681935$var$ListingStatusChip;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $2Xlz6 = parcelRequire("2Xlz6");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $f61ig = parcelRequire("f61ig");
parcelRequire("amkL4");
var $3QXz5 = parcelRequire("3QXz5");

var $dI25G = parcelRequire("dI25G");

var $eOjgM = parcelRequire("eOjgM");

var $7ROc5 = parcelRequire("7ROc5");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $EHEsI = parcelRequire("EHEsI");
var $6Vs3L = parcelRequire("6Vs3L");

var $f3gEZ = parcelRequire("f3gEZ");

var $4TPr9 = parcelRequire("4TPr9");
parcelRequire("87zV1");
var $6Twau = parcelRequire("6Twau");
parcelRequire("fHiKR");
var $5txPe = parcelRequire("5txPe");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $dI25G = parcelRequire("dI25G");

var $eOjgM = parcelRequire("eOjgM");

var $f61ig = parcelRequire("f61ig");


var $ivaD7 = parcelRequire("ivaD7");

var $cstaF = parcelRequire("cstaF");

var $bwlfW = parcelRequire("bwlfW");

var $3RdAS = parcelRequire("3RdAS");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $2OwWq = parcelRequire("2OwWq");


var $cstaF = parcelRequire("cstaF");
const $0c7e2c31e4cd336c$var$MarketAreasList = (props)=>{
    const { mappedAreas: mappedAreas, allMls: allMls, selectType: selectType } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2OwWq.default), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($64088e28bcd161d0$exports))), {
            flush: true,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "mb-2",
                    style: {
                        paddingBottom: "5px",
                        borderBottom: "1px solid gainsboro"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ab5f68d1dbc8673a$exports))), {
                        tag: "button",
                        active: !!allMls,
                        className: "chip-option",
                        onClick: (e)=>selectType(e, (0, $cstaF.agentProductionTerms).all),
                        children: (0, $cstaF.searchTerms).allMls
                    })
                }),
                mappedAreas && Object.values(mappedAreas)?.map((mappedArea)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ab5f68d1dbc8673a$exports))), {
                            tag: "button",
                            className: "chip-option",
                            onClick: (e)=>selectType(e, mappedArea),
                            children: mappedArea.viewName
                        })
                    }))
            ]
        })
    });
};
var $0c7e2c31e4cd336c$export$2e2bcd8739ae039 = $0c7e2c31e4cd336c$var$MarketAreasList;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $lTyg4 = parcelRequire("lTyg4");

var $4wkSQ = parcelRequire("4wkSQ");

var $5VdmZ = parcelRequire("5VdmZ");

var $hf0C9 = parcelRequire("hf0C9");

var $lAOUf = parcelRequire("lAOUf");

var $f3ZL4 = parcelRequire("f3ZL4");

var $74QAJ = parcelRequire("74QAJ");

var $cmTeE = parcelRequire("cmTeE");
/** `Object#toString` result references. */ var $0077707102ec2f63$var$mapTag = "[object Map]", $0077707102ec2f63$var$setTag = "[object Set]";
/** Used for built-in method references. */ var $0077707102ec2f63$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0077707102ec2f63$var$hasOwnProperty = $0077707102ec2f63$var$objectProto.hasOwnProperty;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function $0077707102ec2f63$var$isEmpty(value) {
    if (value == null) return true;
    if ((0, $lAOUf.default)(value) && ((0, $hf0C9.default)(value) || typeof value == "string" || typeof value.splice == "function" || (0, $f3ZL4.default)(value) || (0, $cmTeE.default)(value) || (0, $5VdmZ.default)(value))) return !value.length;
    var tag = (0, $4wkSQ.default)(value);
    if (tag == $0077707102ec2f63$var$mapTag || tag == $0077707102ec2f63$var$setTag) return !value.size;
    if ((0, $74QAJ.default)(value)) return !(0, $lTyg4.default)(value).length;
    for(var key in value){
        if ($0077707102ec2f63$var$hasOwnProperty.call(value, key)) return false;
    }
    return true;
}
var $0077707102ec2f63$export$2e2bcd8739ae039 = $0077707102ec2f63$var$isEmpty;



var $2OwWq = parcelRequire("2OwWq");
parcelRequire("fHiKR");
var $5txPe = parcelRequire("5txPe");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");
parcelRequire("87zV1");
var $6Twau = parcelRequire("6Twau");


var $dI25G = parcelRequire("dI25G");

var $eOjgM = parcelRequire("eOjgM");

var $ivaD7 = parcelRequire("ivaD7");

var $cstaF = parcelRequire("cstaF");

var $3eK9g = parcelRequire("3eK9g");

var $7ROc5 = parcelRequire("7ROc5");
const $d0969125dc20f8aa$var$CustomMarketAreasList = (props)=>{
    const { mlsId: mlsId, marketAreaLists: marketAreaLists, showEditModal: showEditModal, setSelectedMarketAreaList: setSelectedMarketAreaList, mappedAreas: mappedAreas } = props;
    const [isHovering, setIsHovering] = (0, $acw62.useState)(false);
    const [state, setState] = (0, $acw62.useState)({
        lists: undefined,
        filteredLists: undefined
    });
    (0, $acw62.useEffect)(async ()=>{
        if (mlsId) {
            const lists = marketAreaLists?.filter((list)=>list.mlsId === mlsId).filter((a)=>!(0, $0077707102ec2f63$export$2e2bcd8739ae039)(a.elements));
            lists && (0, $ivaD7.setStateData)("lists", lists, setState);
        }
    }, [
        mlsId,
        marketAreaLists
    ]);
    (0, $acw62.useEffect)(()=>{
        filterLists();
    }, [
        state.lists
    ]);
    const filterLists = (searchText)=>{
        if (state.lists) {
            const filteredLists = searchText ? [
                ...state.lists
            ].filter((a)=>a.name.toLowerCase().includes(searchText.toLowerCase()) || a.elements.fieldTypeName.toLowerCase().startsWith(searchText.toLowerCase())) : [
                ...state.lists
            ];
            (0, $ivaD7.setStateData)("filteredLists", filteredLists, setState);
        }
    };
    const toggleEditIcon = (list)=>{
        setIsHovering(list ? {
            [list.id]: true
        } : {});
    };
    const selectMarketAreaList = (e, list)=>{
        setSelectedMarketAreaList(list);
        e.preventDefault();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: mappedAreas && state.lists && state.lists.length > 0 && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        fontSize: "0.9rem",
                        fontWeight: 600,
                        color: "#687280",
                        textTransform: "uppercase",
                        marginTop: "5px",
                        marginBottom: "5px",
                        paddingTop: "10px",
                        borderTop: "1px solid gainsboro"
                    },
                    children: (0, $cstaF.searchTerms).myMarketLists
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6Twau))), {
                    dataLwtId: "custom-area-filter",
                    style: {
                        height: "38px"
                    },
                    prependAddonProps: [
                        {
                            textProps: {
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                                    icon: (0, $eOjgM.search),
                                    className: "align-top mr-1",
                                    title: "search icon"
                                })
                            }
                        }
                    ],
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5txPe))), {
                        dataLwtId: "custom-area-lists-lookup",
                        onChange: (e)=>filterLists(e.target.value),
                        placeholder: (0, $cstaF.searchTerms).marketAreaFilterPlaceholder
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        maxHeight: "200px",
                        overflowY: "auto",
                        maxWidth: "400px"
                    },
                    className: "mt-2",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2OwWq.default), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($64088e28bcd161d0$exports))), {
                            flush: true,
                            children: state.filteredLists?.map((list)=>{
                                const areaLabel = Object.values(mappedAreas).find((mappedArea)=>(0, $cstaF.areaRequestTypes)[mappedArea.columnName] === list.elements.fieldName)?.viewName;
                                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    onMouseOver: ()=>toggleEditIcon(list),
                                    onMouseOut: ()=>toggleEditIcon(),
                                    style: {
                                        width: "100%",
                                        outlineColor: "transparent",
                                        zIndex: 0,
                                        overflowX: "hidden"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                width: "90%",
                                                float: "left"
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ab5f68d1dbc8673a$exports))), {
                                                className: "chip-option",
                                                tag: "button",
                                                onClick: (e)=>selectMarketAreaList(e, list),
                                                style: {
                                                    whiteSpace: "pre-wrap"
                                                },
                                                children: `${list.name} (${areaLabel})`
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            style: {
                                                width: "10%",
                                                float: "right",
                                                paddingTop: "8.5px",
                                                display: isHovering[list.id] ? "block" : "none"
                                            },
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                                                dataLwtId: `edit-icon-${list.id}`,
                                                size: "sm",
                                                color: "link",
                                                onClick: ()=>showEditModal((0, $3eK9g.modalKeys).dropdown, list.id),
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                                                    icon: (0, $eOjgM.pencil),
                                                    ...(0, $7ROc5.chipIconProps),
                                                    title: "edit icon"
                                                })
                                            })
                                        })
                                    ]
                                });
                            })
                        })
                    })
                })
            ]
        })
    });
};
var $d0969125dc20f8aa$export$2e2bcd8739ae039 = $d0969125dc20f8aa$var$CustomMarketAreasList;



var $3eK9g = parcelRequire("3eK9g");

var $24YIE = parcelRequire("24YIE");

var $dyffq = parcelRequire("dyffq");

var $acw62 = parcelRequire("acw62");


var $3eK9g = parcelRequire("3eK9g");

var $ivaD7 = parcelRequire("ivaD7");

var $cstaF = parcelRequire("cstaF");
const $0f60d77680f0c39c$export$9c3ac15681d96d76 = (a, b)=>{
    return !a.areaValue ? a.areaKey.localeCompare(b.areaKey) : a.areaValue.localeCompare(b.areaValue);
};
const $0f60d77680f0c39c$export$1f275fe14b3136a9 = (a, b)=>{
    return b.soldCount - a.soldCount || $0f60d77680f0c39c$export$9c3ac15681d96d76(a, b);
};
const $0f60d77680f0c39c$export$cfdfc30609038fdd = ({ typeOptions: typeOptions, selectedMarketAreaCriteria: selectedMarketAreaCriteria, mappedAreas: mappedAreas, marketAreaLists: marketAreaLists, filterText: filterText, selectedSortOption: selectedSortOption })=>{
    const initialState = {
        mappedAreas: undefined,
        addedAreas: undefined,
        availableAreas: undefined,
        selectOptions: typeOptions && [
            ...typeOptions
        ],
        showEditModal: {
            [(0, $3eK9g.modalKeys).dropdown]: false,
            [(0, $3eK9g.modalKeys).transfer]: false
        }
    };
    const [state, setState] = (0, $acw62.useState)({
        ...initialState
    });
    (0, $acw62.useEffect)(()=>{
        !state.selectedMarketAreaList && (0, $ivaD7.setStateData)("selectedMarketAreaList", state.selectedMarketAreaCriteria?.savedAreaId && marketAreaLists.find((list)=>list.id === selectedMarketAreaCriteria.savedAreaId), setState);
    }, [
        state.selectedMarketAreaCriteria
    ]);
    (0, $acw62.useEffect)(()=>{
        if (mappedAreas) {
            const smac = selectedMarketAreaCriteria;
            let nextState = {
                ...state,
                availableAreas: smac && mappedAreas[smac.fieldName] ? smac?.fieldValues ? [
                    ...mappedAreas[smac.fieldName].mappedAreas
                ]?.filter((area)=>[
                        "areaKey",
                        "area2Key"
                    ].includes(smac.fieldName) ? !smac.fieldValues.includes(area.areaKey) : !smac.fieldValues.includes(area.areaValue)) : [
                    ...mappedAreas[smac.fieldName].mappedAreas
                ] : [],
                addedAreas: !!smac?.fieldValues?.length && mappedAreas[smac.fieldName].mappedAreas ? [
                    ...mappedAreas[smac.fieldName].mappedAreas
                ]?.filter((area)=>[
                        "areaKey",
                        "area2Key"
                    ].includes(smac.fieldName) ? smac.fieldValues.includes(area.areaKey) : smac.fieldValues.includes(area.areaValue)) : [],
                initialSelectedAreas: smac?.fieldValues && mappedAreas[smac.fieldName] ? [
                    ...mappedAreas[smac.fieldName].mappedAreas
                ]?.filter((area)=>[
                        "areaKey",
                        "area2Key"
                    ].includes(smac.fieldName) ? smac.fieldValues.includes(area.areaKey) : smac.fieldValues.includes(area.areaValue)) : [],
                selectedMarketAreaCriteria: smac
            };
            setState({
                ...nextState
            });
        }
    }, [
        mappedAreas,
        selectedMarketAreaCriteria
    ]);
    (0, $acw62.useEffect)(()=>{
        const updatedOptions = typeOptions ? [
            ...typeOptions
        ] : [];
        if (marketAreaLists?.length && mappedAreas) {
            if (!updatedOptions?.find((group)=>group.label === (0, $cstaF.searchTerms).myMarketLists)) updatedOptions.push({
                label: (0, $cstaF.searchTerms).myMarketLists,
                options: marketAreaLists.filter((area)=>!(0, $0077707102ec2f63$export$2e2bcd8739ae039)(area.elements)).map((list)=>{
                    const areaLabel = Object.values(mappedAreas).find((mappedArea)=>(0, $cstaF.areaRequestTypes)[mappedArea.columnName] === list.elements.fieldName)?.viewName;
                    return {
                        label: `${list.name} (${areaLabel})`,
                        value: list.id
                    };
                })
            });
        }
        (0, $ivaD7.setStateData)("selectOptions", updatedOptions, setState);
    }, [
        marketAreaLists
    ]);
    (0, $acw62.useEffect)(()=>{
        setState((prevState)=>({
                ...prevState,
                filteredAreas: sortList(filterAreas(state.availableAreas)),
                filteredAddedAreas: sortList(filterAreas(state.addedAreas))
            }));
    }, [
        filterText,
        selectedSortOption,
        state.availableAreas,
        state.addedAreas
    ]);
    const filterAreas = (list)=>{
        if (!list) return [];
        if (!filterText) return [
            ...list
        ];
        return [
            ...list
        ]?.filter((a)=>a.areaValue?.toLowerCase().startsWith(filterText?.toLowerCase()) || a.areaKey?.toLowerCase().startsWith(filterText?.toLowerCase()));
    };
    const sortList = (list)=>{
        const sortFunc = selectedSortOption?.value === "soldCount" ? $0f60d77680f0c39c$export$1f275fe14b3136a9 : $0f60d77680f0c39c$export$9c3ac15681d96d76;
        return list && [
            ...list
        ].sort(sortFunc);
    };
    return [
        state,
        setState
    ];
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $32kym = parcelRequire("32kym");

var $dI25G = parcelRequire("dI25G");

var $eOjgM = parcelRequire("eOjgM");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $7ROc5 = parcelRequire("7ROc5");

var $3eK9g = parcelRequire("3eK9g");
const $11eaca119a44f601$var$AreaSelect = (props)=>{
    const { marketAreaLists: marketAreaLists, showEditModal: showEditModal, data: data } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            ...props,
            className: "d-flex flex-column bg-red",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "d-flex saved-list-option",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $32kym.F).Option, {
                        ...props,
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                            className: "flex-grow-1",
                            style: {
                                whiteSpace: "pre-wrap"
                            },
                            children: [
                                " ",
                                data.label,
                                " "
                            ]
                        })
                    }),
                    marketAreaLists?.map((list)=>list.id).includes(data.value) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                        dataLwtId: "edit-market-area-list",
                        size: "xs",
                        color: "light",
                        className: "text-capitalize show-on-parent-hover",
                        id: "edit-area-list",
                        onClick: ()=>showEditModal((0, $3eK9g.modalKeys).dropdown, data.value),
                        style: {
                            marginBottom: "8px",
                            padding: 0,
                            float: "right"
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                            icon: (0, $eOjgM.pencil),
                            ...(0, $7ROc5.chipIconProps),
                            title: "edit icon"
                        })
                    })
                ]
            })
        })
    });
};
$11eaca119a44f601$var$AreaSelect.propTypes = {
    marketAreaLists: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    showEditModal: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    data: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $11eaca119a44f601$export$2e2bcd8739ae039 = $11eaca119a44f601$var$AreaSelect;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
const $5be908a8ed2bdbb1$var$AreaLabel = ({ area: area, key: key })=>{
    return area && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "text-truncate area-label-1",
                children: area.areaKey ? `${area.areaKey} (${area.areaValue})` : area.areaValue
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "area-label-2",
                children: area.soldCount.toLocaleString()
            })
        ]
    }, key);
};
$5be908a8ed2bdbb1$var$AreaLabel.propTypes = {
    area: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    key: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};
var $5be908a8ed2bdbb1$export$2e2bcd8739ae039 = $5be908a8ed2bdbb1$var$AreaLabel;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $8nd05 = parcelRequire("8nd05");

var $hDpcU = parcelRequire("hDpcU");

var $g7ajw = parcelRequire("g7ajw");

var $jk22o = parcelRequire("jk22o");

var $acw62 = parcelRequire("acw62");

var $1En50 = parcelRequire("1En50");
// Animation frame based implementation of setTimeout.
// Inspired by Joe Lambert, https://gist.github.com/joelambert/1002116#file-requesttimeout-js
var $44fd68b3b250de87$var$hasNativePerformanceNow = typeof performance === "object" && typeof performance.now === "function";
var $44fd68b3b250de87$var$now = $44fd68b3b250de87$var$hasNativePerformanceNow ? function() {
    return performance.now();
} : function() {
    return Date.now();
};
function $44fd68b3b250de87$var$cancelTimeout(timeoutID) {
    cancelAnimationFrame(timeoutID.id);
}
function $44fd68b3b250de87$var$requestTimeout(callback, delay) {
    var start = $44fd68b3b250de87$var$now();
    function tick() {
        if ($44fd68b3b250de87$var$now() - start >= delay) callback.call(null);
        else timeoutID.id = requestAnimationFrame(tick);
    }
    var timeoutID = {
        id: requestAnimationFrame(tick)
    };
    return timeoutID;
}
var $44fd68b3b250de87$var$size = -1; // This utility copied from "dom-helpers" package.
function $44fd68b3b250de87$var$getScrollbarSize(recalculate) {
    if (recalculate === void 0) recalculate = false;
    if ($44fd68b3b250de87$var$size === -1 || recalculate) {
        var div = document.createElement("div");
        var style = div.style;
        style.width = "50px";
        style.height = "50px";
        style.overflow = "scroll";
        document.body.appendChild(div);
        $44fd68b3b250de87$var$size = div.offsetWidth - div.clientWidth;
        document.body.removeChild(div);
    }
    return $44fd68b3b250de87$var$size;
}
var $44fd68b3b250de87$var$cachedRTLResult = null; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
// Chrome does not seem to adhere; its scrollLeft values are positive (measured relative to the left).
// Safari's elastic bounce makes detecting this even more complicated wrt potential false positives.
// The safest way to check this is to intentionally set a negative offset,
// and then verify that the subsequent "scroll" event matches the negative offset.
// If it does not match, then we can assume a non-standard RTL scroll implementation.
function $44fd68b3b250de87$var$getRTLOffsetType(recalculate) {
    if (recalculate === void 0) recalculate = false;
    if ($44fd68b3b250de87$var$cachedRTLResult === null || recalculate) {
        var outerDiv = document.createElement("div");
        var outerStyle = outerDiv.style;
        outerStyle.width = "50px";
        outerStyle.height = "50px";
        outerStyle.overflow = "scroll";
        outerStyle.direction = "rtl";
        var innerDiv = document.createElement("div");
        var innerStyle = innerDiv.style;
        innerStyle.width = "100px";
        innerStyle.height = "100px";
        outerDiv.appendChild(innerDiv);
        document.body.appendChild(outerDiv);
        if (outerDiv.scrollLeft > 0) $44fd68b3b250de87$var$cachedRTLResult = "positive-descending";
        else {
            outerDiv.scrollLeft = 1;
            if (outerDiv.scrollLeft === 0) $44fd68b3b250de87$var$cachedRTLResult = "negative";
            else $44fd68b3b250de87$var$cachedRTLResult = "positive-ascending";
        }
        document.body.removeChild(outerDiv);
        return $44fd68b3b250de87$var$cachedRTLResult;
    }
    return $44fd68b3b250de87$var$cachedRTLResult;
}
var $44fd68b3b250de87$var$IS_SCROLLING_DEBOUNCE_INTERVAL = 150;
var $44fd68b3b250de87$var$defaultItemKey = function defaultItemKey(_ref) {
    var columnIndex = _ref.columnIndex, data = _ref.data, rowIndex = _ref.rowIndex;
    return rowIndex + ":" + columnIndex;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.
var $44fd68b3b250de87$var$devWarningsOverscanCount = null;
var $44fd68b3b250de87$var$devWarningsOverscanRowsColumnsCount = null;
var $44fd68b3b250de87$var$devWarningsTagName = null;
function $44fd68b3b250de87$var$createGridComponent(_ref2) {
    var _class;
    var getColumnOffset = _ref2.getColumnOffset, getColumnStartIndexForOffset = _ref2.getColumnStartIndexForOffset, getColumnStopIndexForStartIndex = _ref2.getColumnStopIndexForStartIndex, getColumnWidth = _ref2.getColumnWidth, getEstimatedTotalHeight = _ref2.getEstimatedTotalHeight, getEstimatedTotalWidth = _ref2.getEstimatedTotalWidth, getOffsetForColumnAndAlignment = _ref2.getOffsetForColumnAndAlignment, getOffsetForRowAndAlignment = _ref2.getOffsetForRowAndAlignment, getRowHeight = _ref2.getRowHeight, getRowOffset = _ref2.getRowOffset, getRowStartIndexForOffset = _ref2.getRowStartIndexForOffset, getRowStopIndexForStartIndex = _ref2.getRowStopIndexForStartIndex, initInstanceProps = _ref2.initInstanceProps, shouldResetStyleCacheOnItemSizeChange = _ref2.shouldResetStyleCacheOnItemSizeChange, validateProps = _ref2.validateProps;
    return _class = /*#__PURE__*/ function(_PureComponent) {
        (0, $g7ajw.default)(Grid, _PureComponent);
        // Always use explicit constructor for React components.
        // It produces less code after transpilation. (#26)
        // eslint-disable-next-line no-useless-constructor
        function Grid(props) {
            var _this;
            _this = _PureComponent.call(this, props) || this;
            _this._instanceProps = initInstanceProps(_this.props, (0, $hDpcU.default)(_this));
            _this._resetIsScrollingTimeoutId = null;
            _this._outerRef = void 0;
            _this.state = {
                instance: (0, $hDpcU.default)(_this),
                isScrolling: false,
                horizontalScrollDirection: "forward",
                scrollLeft: typeof _this.props.initialScrollLeft === "number" ? _this.props.initialScrollLeft : 0,
                scrollTop: typeof _this.props.initialScrollTop === "number" ? _this.props.initialScrollTop : 0,
                scrollUpdateWasRequested: false,
                verticalScrollDirection: "forward"
            };
            _this._callOnItemsRendered = void 0;
            _this._callOnItemsRendered = (0, $jk22o.default)(function(overscanColumnStartIndex, overscanColumnStopIndex, overscanRowStartIndex, overscanRowStopIndex, visibleColumnStartIndex, visibleColumnStopIndex, visibleRowStartIndex, visibleRowStopIndex) {
                return _this.props.onItemsRendered({
                    overscanColumnStartIndex: overscanColumnStartIndex,
                    overscanColumnStopIndex: overscanColumnStopIndex,
                    overscanRowStartIndex: overscanRowStartIndex,
                    overscanRowStopIndex: overscanRowStopIndex,
                    visibleColumnStartIndex: visibleColumnStartIndex,
                    visibleColumnStopIndex: visibleColumnStopIndex,
                    visibleRowStartIndex: visibleRowStartIndex,
                    visibleRowStopIndex: visibleRowStopIndex
                });
            });
            _this._callOnScroll = void 0;
            _this._callOnScroll = (0, $jk22o.default)(function(scrollLeft, scrollTop, horizontalScrollDirection, verticalScrollDirection, scrollUpdateWasRequested) {
                return _this.props.onScroll({
                    horizontalScrollDirection: horizontalScrollDirection,
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    verticalScrollDirection: verticalScrollDirection,
                    scrollUpdateWasRequested: scrollUpdateWasRequested
                });
            });
            _this._getItemStyle = void 0;
            _this._getItemStyle = function(rowIndex, columnIndex) {
                var _this$props = _this.props, columnWidth = _this$props.columnWidth, direction = _this$props.direction, rowHeight = _this$props.rowHeight;
                var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && columnWidth, shouldResetStyleCacheOnItemSizeChange && direction, shouldResetStyleCacheOnItemSizeChange && rowHeight);
                var key = rowIndex + ":" + columnIndex;
                var style;
                if (itemStyleCache.hasOwnProperty(key)) style = itemStyleCache[key];
                else {
                    var _offset = getColumnOffset(_this.props, columnIndex, _this._instanceProps);
                    var isRtl = direction === "rtl";
                    itemStyleCache[key] = style = {
                        position: "absolute",
                        left: isRtl ? undefined : _offset,
                        right: isRtl ? _offset : undefined,
                        top: getRowOffset(_this.props, rowIndex, _this._instanceProps),
                        height: getRowHeight(_this.props, rowIndex, _this._instanceProps),
                        width: getColumnWidth(_this.props, columnIndex, _this._instanceProps)
                    };
                }
                return style;
            };
            _this._getItemStyleCache = void 0;
            _this._getItemStyleCache = (0, $jk22o.default)(function(_, __, ___) {
                return {};
            });
            _this._onScroll = function(event) {
                var _event$currentTarget = event.currentTarget, clientHeight = _event$currentTarget.clientHeight, clientWidth = _event$currentTarget.clientWidth, scrollLeft = _event$currentTarget.scrollLeft, scrollTop = _event$currentTarget.scrollTop, scrollHeight = _event$currentTarget.scrollHeight, scrollWidth = _event$currentTarget.scrollWidth;
                _this.setState(function(prevState) {
                    if (prevState.scrollLeft === scrollLeft && prevState.scrollTop === scrollTop) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                    var direction = _this.props.direction; // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
                    // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.
                    var calculatedScrollLeft = scrollLeft;
                    if (direction === "rtl") switch($44fd68b3b250de87$var$getRTLOffsetType()){
                        case "negative":
                            calculatedScrollLeft = -scrollLeft;
                            break;
                        case "positive-descending":
                            calculatedScrollLeft = scrollWidth - clientWidth - scrollLeft;
                            break;
                    }
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    calculatedScrollLeft = Math.max(0, Math.min(calculatedScrollLeft, scrollWidth - clientWidth));
                    var calculatedScrollTop = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
                    return {
                        isScrolling: true,
                        horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? "forward" : "backward",
                        scrollLeft: calculatedScrollLeft,
                        scrollTop: calculatedScrollTop,
                        verticalScrollDirection: prevState.scrollTop < scrollTop ? "forward" : "backward",
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._outerRefSetter = function(ref) {
                var outerRef = _this.props.outerRef;
                _this._outerRef = ref;
                if (typeof outerRef === "function") outerRef(ref);
                else if (outerRef != null && typeof outerRef === "object" && outerRef.hasOwnProperty("current")) outerRef.current = ref;
            };
            _this._resetIsScrollingDebounced = function() {
                if (_this._resetIsScrollingTimeoutId !== null) $44fd68b3b250de87$var$cancelTimeout(_this._resetIsScrollingTimeoutId);
                _this._resetIsScrollingTimeoutId = $44fd68b3b250de87$var$requestTimeout(_this._resetIsScrolling, $44fd68b3b250de87$var$IS_SCROLLING_DEBOUNCE_INTERVAL);
            };
            _this._resetIsScrolling = function() {
                _this._resetIsScrollingTimeoutId = null;
                _this.setState({
                    isScrolling: false
                }, function() {
                    // Clear style cache after state update has been committed.
                    // This way we don't break pure sCU for items that don't use isScrolling param.
                    _this._getItemStyleCache(-1);
                });
            };
            return _this;
        }
        Grid.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            $44fd68b3b250de87$var$validateSharedProps(nextProps, prevState);
            validateProps(nextProps);
            return null;
        };
        var _proto = Grid.prototype;
        _proto.scrollTo = function scrollTo(_ref3) {
            var scrollLeft = _ref3.scrollLeft, scrollTop = _ref3.scrollTop;
            if (scrollLeft !== undefined) scrollLeft = Math.max(0, scrollLeft);
            if (scrollTop !== undefined) scrollTop = Math.max(0, scrollTop);
            this.setState(function(prevState) {
                if (scrollLeft === undefined) scrollLeft = prevState.scrollLeft;
                if (scrollTop === undefined) scrollTop = prevState.scrollTop;
                if (prevState.scrollLeft === scrollLeft && prevState.scrollTop === scrollTop) return null;
                return {
                    horizontalScrollDirection: prevState.scrollLeft < scrollLeft ? "forward" : "backward",
                    scrollLeft: scrollLeft,
                    scrollTop: scrollTop,
                    scrollUpdateWasRequested: true,
                    verticalScrollDirection: prevState.scrollTop < scrollTop ? "forward" : "backward"
                };
            }, this._resetIsScrollingDebounced);
        };
        _proto.scrollToItem = function scrollToItem(_ref4) {
            var _ref4$align = _ref4.align, align = _ref4$align === void 0 ? "auto" : _ref4$align, columnIndex = _ref4.columnIndex, rowIndex = _ref4.rowIndex;
            var _this$props2 = this.props, columnCount = _this$props2.columnCount, height = _this$props2.height, rowCount = _this$props2.rowCount, width = _this$props2.width;
            var _this$state = this.state, scrollLeft = _this$state.scrollLeft, scrollTop = _this$state.scrollTop;
            var scrollbarSize = $44fd68b3b250de87$var$getScrollbarSize();
            if (columnIndex !== undefined) columnIndex = Math.max(0, Math.min(columnIndex, columnCount - 1));
            if (rowIndex !== undefined) rowIndex = Math.max(0, Math.min(rowIndex, rowCount - 1));
            var estimatedTotalHeight = getEstimatedTotalHeight(this.props, this._instanceProps);
            var estimatedTotalWidth = getEstimatedTotalWidth(this.props, this._instanceProps); // The scrollbar size should be considered when scrolling an item into view,
            // to ensure it's fully visible.
            // But we only need to account for its size when it's actually visible.
            var horizontalScrollbarSize = estimatedTotalWidth > width ? scrollbarSize : 0;
            var verticalScrollbarSize = estimatedTotalHeight > height ? scrollbarSize : 0;
            this.scrollTo({
                scrollLeft: columnIndex !== undefined ? getOffsetForColumnAndAlignment(this.props, columnIndex, align, scrollLeft, this._instanceProps, verticalScrollbarSize) : scrollLeft,
                scrollTop: rowIndex !== undefined ? getOffsetForRowAndAlignment(this.props, rowIndex, align, scrollTop, this._instanceProps, horizontalScrollbarSize) : scrollTop
            });
        };
        _proto.componentDidMount = function componentDidMount() {
            var _this$props3 = this.props, initialScrollLeft = _this$props3.initialScrollLeft, initialScrollTop = _this$props3.initialScrollTop;
            if (this._outerRef != null) {
                var outerRef = this._outerRef;
                if (typeof initialScrollLeft === "number") outerRef.scrollLeft = initialScrollLeft;
                if (typeof initialScrollTop === "number") outerRef.scrollTop = initialScrollTop;
            }
            this._callPropsCallbacks();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            var direction = this.props.direction;
            var _this$state2 = this.state, scrollLeft = _this$state2.scrollLeft, scrollTop = _this$state2.scrollTop, scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;
            if (scrollUpdateWasRequested && this._outerRef != null) {
                // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                // So we need to determine which browser behavior we're dealing with, and mimic it.
                var outerRef = this._outerRef;
                if (direction === "rtl") switch($44fd68b3b250de87$var$getRTLOffsetType()){
                    case "negative":
                        outerRef.scrollLeft = -scrollLeft;
                        break;
                    case "positive-ascending":
                        outerRef.scrollLeft = scrollLeft;
                        break;
                    default:
                        var clientWidth = outerRef.clientWidth, scrollWidth = outerRef.scrollWidth;
                        outerRef.scrollLeft = scrollWidth - clientWidth - scrollLeft;
                        break;
                }
                else outerRef.scrollLeft = Math.max(0, scrollLeft);
                outerRef.scrollTop = Math.max(0, scrollTop);
            }
            this._callPropsCallbacks();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            if (this._resetIsScrollingTimeoutId !== null) $44fd68b3b250de87$var$cancelTimeout(this._resetIsScrollingTimeoutId);
        };
        _proto.render = function render() {
            var _this$props4 = this.props, children = _this$props4.children, className = _this$props4.className, columnCount = _this$props4.columnCount, direction = _this$props4.direction, height = _this$props4.height, innerRef = _this$props4.innerRef, innerElementType = _this$props4.innerElementType, innerTagName = _this$props4.innerTagName, itemData = _this$props4.itemData, _this$props4$itemKey = _this$props4.itemKey, itemKey = _this$props4$itemKey === void 0 ? $44fd68b3b250de87$var$defaultItemKey : _this$props4$itemKey, outerElementType = _this$props4.outerElementType, outerTagName = _this$props4.outerTagName, rowCount = _this$props4.rowCount, style = _this$props4.style, useIsScrolling = _this$props4.useIsScrolling, width = _this$props4.width;
            var isScrolling = this.state.isScrolling;
            var _this$_getHorizontalR = this._getHorizontalRangeToRender(), columnStartIndex = _this$_getHorizontalR[0], columnStopIndex = _this$_getHorizontalR[1];
            var _this$_getVerticalRan = this._getVerticalRangeToRender(), rowStartIndex = _this$_getVerticalRan[0], rowStopIndex = _this$_getVerticalRan[1];
            var items = [];
            if (columnCount > 0 && rowCount) {
                for(var _rowIndex = rowStartIndex; _rowIndex <= rowStopIndex; _rowIndex++)for(var _columnIndex = columnStartIndex; _columnIndex <= columnStopIndex; _columnIndex++)items.push((0, $acw62.createElement)(children, {
                    columnIndex: _columnIndex,
                    data: itemData,
                    isScrolling: useIsScrolling ? isScrolling : undefined,
                    key: itemKey({
                        columnIndex: _columnIndex,
                        data: itemData,
                        rowIndex: _rowIndex
                    }),
                    rowIndex: _rowIndex,
                    style: this._getItemStyle(_rowIndex, _columnIndex)
                }));
            } // Read this value AFTER items have been created,
            // So their actual sizes (if variable) are taken into consideration.
            var estimatedTotalHeight = getEstimatedTotalHeight(this.props, this._instanceProps);
            var estimatedTotalWidth = getEstimatedTotalWidth(this.props, this._instanceProps);
            return (0, $acw62.createElement)(outerElementType || outerTagName || "div", {
                className: className,
                onScroll: this._onScroll,
                ref: this._outerRefSetter,
                style: (0, $8nd05.default)({
                    position: "relative",
                    height: height,
                    width: width,
                    overflow: "auto",
                    WebkitOverflowScrolling: "touch",
                    willChange: "transform",
                    direction: direction
                }, style)
            }, (0, $acw62.createElement)(innerElementType || innerTagName || "div", {
                children: items,
                ref: innerRef,
                style: {
                    height: estimatedTotalHeight,
                    pointerEvents: isScrolling ? "none" : undefined,
                    width: estimatedTotalWidth
                }
            }));
        };
        _proto._callPropsCallbacks = function _callPropsCallbacks() {
            var _this$props5 = this.props, columnCount = _this$props5.columnCount, onItemsRendered = _this$props5.onItemsRendered, onScroll = _this$props5.onScroll, rowCount = _this$props5.rowCount;
            if (typeof onItemsRendered === "function") {
                if (columnCount > 0 && rowCount > 0) {
                    var _this$_getHorizontalR2 = this._getHorizontalRangeToRender(), _overscanColumnStartIndex = _this$_getHorizontalR2[0], _overscanColumnStopIndex = _this$_getHorizontalR2[1], _visibleColumnStartIndex = _this$_getHorizontalR2[2], _visibleColumnStopIndex = _this$_getHorizontalR2[3];
                    var _this$_getVerticalRan2 = this._getVerticalRangeToRender(), _overscanRowStartIndex = _this$_getVerticalRan2[0], _overscanRowStopIndex = _this$_getVerticalRan2[1], _visibleRowStartIndex = _this$_getVerticalRan2[2], _visibleRowStopIndex = _this$_getVerticalRan2[3];
                    this._callOnItemsRendered(_overscanColumnStartIndex, _overscanColumnStopIndex, _overscanRowStartIndex, _overscanRowStopIndex, _visibleColumnStartIndex, _visibleColumnStopIndex, _visibleRowStartIndex, _visibleRowStopIndex);
                }
            }
            if (typeof onScroll === "function") {
                var _this$state3 = this.state, _horizontalScrollDirection = _this$state3.horizontalScrollDirection, _scrollLeft = _this$state3.scrollLeft, _scrollTop = _this$state3.scrollTop, _scrollUpdateWasRequested = _this$state3.scrollUpdateWasRequested, _verticalScrollDirection = _this$state3.verticalScrollDirection;
                this._callOnScroll(_scrollLeft, _scrollTop, _horizontalScrollDirection, _verticalScrollDirection, _scrollUpdateWasRequested);
            }
        } // Lazily create and cache item styles while scrolling,
        ;
        _proto._getHorizontalRangeToRender = function _getHorizontalRangeToRender() {
            var _this$props6 = this.props, columnCount = _this$props6.columnCount, overscanColumnCount = _this$props6.overscanColumnCount, overscanColumnsCount = _this$props6.overscanColumnsCount, overscanCount = _this$props6.overscanCount, rowCount = _this$props6.rowCount;
            var _this$state4 = this.state, horizontalScrollDirection = _this$state4.horizontalScrollDirection, isScrolling = _this$state4.isScrolling, scrollLeft = _this$state4.scrollLeft;
            var overscanCountResolved = overscanColumnCount || overscanColumnsCount || overscanCount || 1;
            if (columnCount === 0 || rowCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getColumnStartIndexForOffset(this.props, scrollLeft, this._instanceProps);
            var stopIndex = getColumnStopIndexForStartIndex(this.props, startIndex, scrollLeft, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || horizontalScrollDirection === "backward" ? Math.max(1, overscanCountResolved) : 1;
            var overscanForward = !isScrolling || horizontalScrollDirection === "forward" ? Math.max(1, overscanCountResolved) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(columnCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        _proto._getVerticalRangeToRender = function _getVerticalRangeToRender() {
            var _this$props7 = this.props, columnCount = _this$props7.columnCount, overscanCount = _this$props7.overscanCount, overscanRowCount = _this$props7.overscanRowCount, overscanRowsCount = _this$props7.overscanRowsCount, rowCount = _this$props7.rowCount;
            var _this$state5 = this.state, isScrolling = _this$state5.isScrolling, verticalScrollDirection = _this$state5.verticalScrollDirection, scrollTop = _this$state5.scrollTop;
            var overscanCountResolved = overscanRowCount || overscanRowsCount || overscanCount || 1;
            if (columnCount === 0 || rowCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getRowStartIndexForOffset(this.props, scrollTop, this._instanceProps);
            var stopIndex = getRowStopIndexForStartIndex(this.props, startIndex, scrollTop, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || verticalScrollDirection === "backward" ? Math.max(1, overscanCountResolved) : 1;
            var overscanForward = !isScrolling || verticalScrollDirection === "forward" ? Math.max(1, overscanCountResolved) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(rowCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        return Grid;
    }((0, $acw62.PureComponent)), _class.defaultProps = {
        direction: "ltr",
        itemData: undefined,
        useIsScrolling: false
    }, _class;
}
var $44fd68b3b250de87$var$validateSharedProps = function validateSharedProps(_ref5, _ref6) {
    var children = _ref5.children, direction = _ref5.direction, height = _ref5.height, innerTagName = _ref5.innerTagName, outerTagName = _ref5.outerTagName, overscanColumnsCount = _ref5.overscanColumnsCount, overscanCount = _ref5.overscanCount, overscanRowsCount = _ref5.overscanRowsCount, width = _ref5.width;
    var instance = _ref6.instance;
};
var $44fd68b3b250de87$var$DEFAULT_ESTIMATED_ITEM_SIZE = 50;
var $44fd68b3b250de87$var$getEstimatedTotalHeight = function getEstimatedTotalHeight(_ref, _ref2) {
    var rowCount = _ref.rowCount;
    var rowMetadataMap = _ref2.rowMetadataMap, estimatedRowHeight = _ref2.estimatedRowHeight, lastMeasuredRowIndex = _ref2.lastMeasuredRowIndex;
    var totalSizeOfMeasuredRows = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredRowIndex >= rowCount) lastMeasuredRowIndex = rowCount - 1;
    if (lastMeasuredRowIndex >= 0) {
        var itemMetadata = rowMetadataMap[lastMeasuredRowIndex];
        totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = rowCount - lastMeasuredRowIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedRowHeight;
    return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
};
var $44fd68b3b250de87$var$getEstimatedTotalWidth = function getEstimatedTotalWidth(_ref3, _ref4) {
    var columnCount = _ref3.columnCount;
    var columnMetadataMap = _ref4.columnMetadataMap, estimatedColumnWidth = _ref4.estimatedColumnWidth, lastMeasuredColumnIndex = _ref4.lastMeasuredColumnIndex;
    var totalSizeOfMeasuredRows = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredColumnIndex >= columnCount) lastMeasuredColumnIndex = columnCount - 1;
    if (lastMeasuredColumnIndex >= 0) {
        var itemMetadata = columnMetadataMap[lastMeasuredColumnIndex];
        totalSizeOfMeasuredRows = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = columnCount - lastMeasuredColumnIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedColumnWidth;
    return totalSizeOfMeasuredRows + totalSizeOfUnmeasuredItems;
};
var $44fd68b3b250de87$var$getItemMetadata = function getItemMetadata(itemType, props, index, instanceProps) {
    var itemMetadataMap, itemSize, lastMeasuredIndex;
    if (itemType === "column") {
        itemMetadataMap = instanceProps.columnMetadataMap;
        itemSize = props.columnWidth;
        lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
    } else {
        itemMetadataMap = instanceProps.rowMetadataMap;
        itemSize = props.rowHeight;
        lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
    }
    if (index > lastMeasuredIndex) {
        var offset = 0;
        if (lastMeasuredIndex >= 0) {
            var itemMetadata = itemMetadataMap[lastMeasuredIndex];
            offset = itemMetadata.offset + itemMetadata.size;
        }
        for(var i = lastMeasuredIndex + 1; i <= index; i++){
            var size = itemSize(i);
            itemMetadataMap[i] = {
                offset: offset,
                size: size
            };
            offset += size;
        }
        if (itemType === "column") instanceProps.lastMeasuredColumnIndex = index;
        else instanceProps.lastMeasuredRowIndex = index;
    }
    return itemMetadataMap[index];
};
var $44fd68b3b250de87$var$findNearestItem = function findNearestItem(itemType, props, instanceProps, offset) {
    var itemMetadataMap, lastMeasuredIndex;
    if (itemType === "column") {
        itemMetadataMap = instanceProps.columnMetadataMap;
        lastMeasuredIndex = instanceProps.lastMeasuredColumnIndex;
    } else {
        itemMetadataMap = instanceProps.rowMetadataMap;
        lastMeasuredIndex = instanceProps.lastMeasuredRowIndex;
    }
    var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;
    if (lastMeasuredItemOffset >= offset) // If we've already measured items within this range just use a binary search as it's faster.
    return $44fd68b3b250de87$var$findNearestItemBinarySearch(itemType, props, instanceProps, lastMeasuredIndex, 0, offset);
    else // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
    // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
    // The overall complexity for this approach is O(log n).
    return $44fd68b3b250de87$var$findNearestItemExponentialSearch(itemType, props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
};
var $44fd68b3b250de87$var$findNearestItemBinarySearch = function findNearestItemBinarySearch(itemType, props, instanceProps, high, low, offset) {
    while(low <= high){
        var middle = low + Math.floor((high - low) / 2);
        var currentOffset = $44fd68b3b250de87$var$getItemMetadata(itemType, props, middle, instanceProps).offset;
        if (currentOffset === offset) return middle;
        else if (currentOffset < offset) low = middle + 1;
        else if (currentOffset > offset) high = middle - 1;
    }
    if (low > 0) return low - 1;
    else return 0;
};
var $44fd68b3b250de87$var$findNearestItemExponentialSearch = function findNearestItemExponentialSearch(itemType, props, instanceProps, index, offset) {
    var itemCount = itemType === "column" ? props.columnCount : props.rowCount;
    var interval = 1;
    while(index < itemCount && $44fd68b3b250de87$var$getItemMetadata(itemType, props, index, instanceProps).offset < offset){
        index += interval;
        interval *= 2;
    }
    return $44fd68b3b250de87$var$findNearestItemBinarySearch(itemType, props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
};
var $44fd68b3b250de87$var$getOffsetForIndexAndAlignment = function getOffsetForIndexAndAlignment(itemType, props, index, align, scrollOffset, instanceProps, scrollbarSize) {
    var size = itemType === "column" ? props.width : props.height;
    var itemMetadata = $44fd68b3b250de87$var$getItemMetadata(itemType, props, index, instanceProps); // Get estimated total size after ItemMetadata is computed,
    // To ensure it reflects actual measurements instead of just estimates.
    var estimatedTotalSize = itemType === "column" ? $44fd68b3b250de87$var$getEstimatedTotalWidth(props, instanceProps) : $44fd68b3b250de87$var$getEstimatedTotalHeight(props, instanceProps);
    var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size, itemMetadata.offset));
    var minOffset = Math.max(0, itemMetadata.offset - size + scrollbarSize + itemMetadata.size);
    if (align === "smart") {
        if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = "auto";
        else align = "center";
    }
    switch(align){
        case "start":
            return maxOffset;
        case "end":
            return minOffset;
        case "center":
            return Math.round(minOffset + (maxOffset - minOffset) / 2);
        case "auto":
        default:
            if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
            else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
            // this value can be larger than maxOffset when at the end of the list
            return minOffset;
            else if (scrollOffset < minOffset) return minOffset;
            else return maxOffset;
    }
};
var $44fd68b3b250de87$export$32c206c84102e73c = /*#__PURE__*/ $44fd68b3b250de87$var$createGridComponent({
    getColumnOffset: function getColumnOffset(props, index, instanceProps) {
        return $44fd68b3b250de87$var$getItemMetadata("column", props, index, instanceProps).offset;
    },
    getColumnStartIndexForOffset: function getColumnStartIndexForOffset(props, scrollLeft, instanceProps) {
        return $44fd68b3b250de87$var$findNearestItem("column", props, instanceProps, scrollLeft);
    },
    getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex(props, startIndex, scrollLeft, instanceProps) {
        var columnCount = props.columnCount, width = props.width;
        var itemMetadata = $44fd68b3b250de87$var$getItemMetadata("column", props, startIndex, instanceProps);
        var maxOffset = scrollLeft + width;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < columnCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += $44fd68b3b250de87$var$getItemMetadata("column", props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    getColumnWidth: function getColumnWidth(props, index, instanceProps) {
        return instanceProps.columnMetadataMap[index].size;
    },
    getEstimatedTotalHeight: $44fd68b3b250de87$var$getEstimatedTotalHeight,
    getEstimatedTotalWidth: $44fd68b3b250de87$var$getEstimatedTotalWidth,
    getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
        return $44fd68b3b250de87$var$getOffsetForIndexAndAlignment("column", props, index, align, scrollOffset, instanceProps, scrollbarSize);
    },
    getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment(props, index, align, scrollOffset, instanceProps, scrollbarSize) {
        return $44fd68b3b250de87$var$getOffsetForIndexAndAlignment("row", props, index, align, scrollOffset, instanceProps, scrollbarSize);
    },
    getRowOffset: function getRowOffset(props, index, instanceProps) {
        return $44fd68b3b250de87$var$getItemMetadata("row", props, index, instanceProps).offset;
    },
    getRowHeight: function getRowHeight(props, index, instanceProps) {
        return instanceProps.rowMetadataMap[index].size;
    },
    getRowStartIndexForOffset: function getRowStartIndexForOffset(props, scrollTop, instanceProps) {
        return $44fd68b3b250de87$var$findNearestItem("row", props, instanceProps, scrollTop);
    },
    getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex(props, startIndex, scrollTop, instanceProps) {
        var rowCount = props.rowCount, height = props.height;
        var itemMetadata = $44fd68b3b250de87$var$getItemMetadata("row", props, startIndex, instanceProps);
        var maxOffset = scrollTop + height;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < rowCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += $44fd68b3b250de87$var$getItemMetadata("row", props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    initInstanceProps: function initInstanceProps(props, instance) {
        var _ref5 = props, estimatedColumnWidth = _ref5.estimatedColumnWidth, estimatedRowHeight = _ref5.estimatedRowHeight;
        var instanceProps = {
            columnMetadataMap: {},
            estimatedColumnWidth: estimatedColumnWidth || $44fd68b3b250de87$var$DEFAULT_ESTIMATED_ITEM_SIZE,
            estimatedRowHeight: estimatedRowHeight || $44fd68b3b250de87$var$DEFAULT_ESTIMATED_ITEM_SIZE,
            lastMeasuredColumnIndex: -1,
            lastMeasuredRowIndex: -1,
            rowMetadataMap: {}
        };
        instance.resetAfterColumnIndex = function(columnIndex, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instance.resetAfterIndices({
                columnIndex: columnIndex,
                shouldForceUpdate: shouldForceUpdate
            });
        };
        instance.resetAfterRowIndex = function(rowIndex, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instance.resetAfterIndices({
                rowIndex: rowIndex,
                shouldForceUpdate: shouldForceUpdate
            });
        };
        instance.resetAfterIndices = function(_ref6) {
            var columnIndex = _ref6.columnIndex, rowIndex = _ref6.rowIndex, _ref6$shouldForceUpda = _ref6.shouldForceUpdate, shouldForceUpdate = _ref6$shouldForceUpda === void 0 ? true : _ref6$shouldForceUpda;
            if (typeof columnIndex === "number") instanceProps.lastMeasuredColumnIndex = Math.min(instanceProps.lastMeasuredColumnIndex, columnIndex - 1);
            if (typeof rowIndex === "number") instanceProps.lastMeasuredRowIndex = Math.min(instanceProps.lastMeasuredRowIndex, rowIndex - 1);
             // We could potentially optimize further by only evicting styles after this index,
            // But since styles are only cached while scrolling is in progress-
            // It seems an unnecessary optimization.
            // It's unlikely that resetAfterIndex() will be called while a user is scrolling.
            instance._getItemStyleCache(-1);
            if (shouldForceUpdate) instance.forceUpdate();
        };
        return instanceProps;
    },
    shouldResetStyleCacheOnItemSizeChange: false,
    validateProps: function validateProps(_ref7) {
        var columnWidth = _ref7.columnWidth, rowHeight = _ref7.rowHeight;
    }
});
var $44fd68b3b250de87$var$IS_SCROLLING_DEBOUNCE_INTERVAL$1 = 150;
var $44fd68b3b250de87$var$defaultItemKey$1 = function defaultItemKey(index, data) {
    return index;
}; // In DEV mode, this Set helps us only log a warning once per component instance.
// This avoids spamming the console every time a render happens.
var $44fd68b3b250de87$var$devWarningsDirection = null;
var $44fd68b3b250de87$var$devWarningsTagName$1 = null;
function $44fd68b3b250de87$var$createListComponent(_ref) {
    var _class;
    var getItemOffset = _ref.getItemOffset, getEstimatedTotalSize = _ref.getEstimatedTotalSize, getItemSize = _ref.getItemSize, getOffsetForIndexAndAlignment = _ref.getOffsetForIndexAndAlignment, getStartIndexForOffset = _ref.getStartIndexForOffset, getStopIndexForStartIndex = _ref.getStopIndexForStartIndex, initInstanceProps = _ref.initInstanceProps, shouldResetStyleCacheOnItemSizeChange = _ref.shouldResetStyleCacheOnItemSizeChange, validateProps = _ref.validateProps;
    return _class = /*#__PURE__*/ function(_PureComponent) {
        (0, $g7ajw.default)(List, _PureComponent);
        // Always use explicit constructor for React components.
        // It produces less code after transpilation. (#26)
        // eslint-disable-next-line no-useless-constructor
        function List(props) {
            var _this;
            _this = _PureComponent.call(this, props) || this;
            _this._instanceProps = initInstanceProps(_this.props, (0, $hDpcU.default)(_this));
            _this._outerRef = void 0;
            _this._resetIsScrollingTimeoutId = null;
            _this.state = {
                instance: (0, $hDpcU.default)(_this),
                isScrolling: false,
                scrollDirection: "forward",
                scrollOffset: typeof _this.props.initialScrollOffset === "number" ? _this.props.initialScrollOffset : 0,
                scrollUpdateWasRequested: false
            };
            _this._callOnItemsRendered = void 0;
            _this._callOnItemsRendered = (0, $jk22o.default)(function(overscanStartIndex, overscanStopIndex, visibleStartIndex, visibleStopIndex) {
                return _this.props.onItemsRendered({
                    overscanStartIndex: overscanStartIndex,
                    overscanStopIndex: overscanStopIndex,
                    visibleStartIndex: visibleStartIndex,
                    visibleStopIndex: visibleStopIndex
                });
            });
            _this._callOnScroll = void 0;
            _this._callOnScroll = (0, $jk22o.default)(function(scrollDirection, scrollOffset, scrollUpdateWasRequested) {
                return _this.props.onScroll({
                    scrollDirection: scrollDirection,
                    scrollOffset: scrollOffset,
                    scrollUpdateWasRequested: scrollUpdateWasRequested
                });
            });
            _this._getItemStyle = void 0;
            _this._getItemStyle = function(index) {
                var _this$props = _this.props, direction = _this$props.direction, itemSize = _this$props.itemSize, layout = _this$props.layout;
                var itemStyleCache = _this._getItemStyleCache(shouldResetStyleCacheOnItemSizeChange && itemSize, shouldResetStyleCacheOnItemSizeChange && layout, shouldResetStyleCacheOnItemSizeChange && direction);
                var style;
                if (itemStyleCache.hasOwnProperty(index)) style = itemStyleCache[index];
                else {
                    var _offset = getItemOffset(_this.props, index, _this._instanceProps);
                    var size = getItemSize(_this.props, index, _this._instanceProps); // TODO Deprecate direction "horizontal"
                    var isHorizontal = direction === "horizontal" || layout === "horizontal";
                    var isRtl = direction === "rtl";
                    var offsetHorizontal = isHorizontal ? _offset : 0;
                    itemStyleCache[index] = style = {
                        position: "absolute",
                        left: isRtl ? undefined : offsetHorizontal,
                        right: isRtl ? offsetHorizontal : undefined,
                        top: !isHorizontal ? _offset : 0,
                        height: !isHorizontal ? size : "100%",
                        width: isHorizontal ? size : "100%"
                    };
                }
                return style;
            };
            _this._getItemStyleCache = void 0;
            _this._getItemStyleCache = (0, $jk22o.default)(function(_, __, ___) {
                return {};
            });
            _this._onScrollHorizontal = function(event) {
                var _event$currentTarget = event.currentTarget, clientWidth = _event$currentTarget.clientWidth, scrollLeft = _event$currentTarget.scrollLeft, scrollWidth = _event$currentTarget.scrollWidth;
                _this.setState(function(prevState) {
                    if (prevState.scrollOffset === scrollLeft) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                    var direction = _this.props.direction;
                    var scrollOffset = scrollLeft;
                    if (direction === "rtl") // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // It's also easier for this component if we convert offsets to the same format as they would be in for ltr.
                    // So the simplest solution is to determine which browser behavior we're dealing with, and convert based on it.
                    switch($44fd68b3b250de87$var$getRTLOffsetType()){
                        case "negative":
                            scrollOffset = -scrollLeft;
                            break;
                        case "positive-descending":
                            scrollOffset = scrollWidth - clientWidth - scrollLeft;
                            break;
                    }
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    scrollOffset = Math.max(0, Math.min(scrollOffset, scrollWidth - clientWidth));
                    return {
                        isScrolling: true,
                        scrollDirection: prevState.scrollOffset < scrollLeft ? "forward" : "backward",
                        scrollOffset: scrollOffset,
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._onScrollVertical = function(event) {
                var _event$currentTarget2 = event.currentTarget, clientHeight = _event$currentTarget2.clientHeight, scrollHeight = _event$currentTarget2.scrollHeight, scrollTop = _event$currentTarget2.scrollTop;
                _this.setState(function(prevState) {
                    if (prevState.scrollOffset === scrollTop) // Scroll position may have been updated by cDM/cDU,
                    // In which case we don't need to trigger another render,
                    // And we don't want to update state.isScrolling.
                    return null;
                     // Prevent Safari's elastic scrolling from causing visual shaking when scrolling past bounds.
                    var scrollOffset = Math.max(0, Math.min(scrollTop, scrollHeight - clientHeight));
                    return {
                        isScrolling: true,
                        scrollDirection: prevState.scrollOffset < scrollOffset ? "forward" : "backward",
                        scrollOffset: scrollOffset,
                        scrollUpdateWasRequested: false
                    };
                }, _this._resetIsScrollingDebounced);
            };
            _this._outerRefSetter = function(ref) {
                var outerRef = _this.props.outerRef;
                _this._outerRef = ref;
                if (typeof outerRef === "function") outerRef(ref);
                else if (outerRef != null && typeof outerRef === "object" && outerRef.hasOwnProperty("current")) outerRef.current = ref;
            };
            _this._resetIsScrollingDebounced = function() {
                if (_this._resetIsScrollingTimeoutId !== null) $44fd68b3b250de87$var$cancelTimeout(_this._resetIsScrollingTimeoutId);
                _this._resetIsScrollingTimeoutId = $44fd68b3b250de87$var$requestTimeout(_this._resetIsScrolling, $44fd68b3b250de87$var$IS_SCROLLING_DEBOUNCE_INTERVAL$1);
            };
            _this._resetIsScrolling = function() {
                _this._resetIsScrollingTimeoutId = null;
                _this.setState({
                    isScrolling: false
                }, function() {
                    // Clear style cache after state update has been committed.
                    // This way we don't break pure sCU for items that don't use isScrolling param.
                    _this._getItemStyleCache(-1, null);
                });
            };
            return _this;
        }
        List.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            $44fd68b3b250de87$var$validateSharedProps$1(nextProps, prevState);
            validateProps(nextProps);
            return null;
        };
        var _proto = List.prototype;
        _proto.scrollTo = function scrollTo(scrollOffset) {
            scrollOffset = Math.max(0, scrollOffset);
            this.setState(function(prevState) {
                if (prevState.scrollOffset === scrollOffset) return null;
                return {
                    scrollDirection: prevState.scrollOffset < scrollOffset ? "forward" : "backward",
                    scrollOffset: scrollOffset,
                    scrollUpdateWasRequested: true
                };
            }, this._resetIsScrollingDebounced);
        };
        _proto.scrollToItem = function scrollToItem(index, align) {
            if (align === void 0) align = "auto";
            var itemCount = this.props.itemCount;
            var scrollOffset = this.state.scrollOffset;
            index = Math.max(0, Math.min(index, itemCount - 1));
            this.scrollTo(getOffsetForIndexAndAlignment(this.props, index, align, scrollOffset, this._instanceProps));
        };
        _proto.componentDidMount = function componentDidMount() {
            var _this$props2 = this.props, direction = _this$props2.direction, initialScrollOffset = _this$props2.initialScrollOffset, layout = _this$props2.layout;
            if (typeof initialScrollOffset === "number" && this._outerRef != null) {
                var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"
                if (direction === "horizontal" || layout === "horizontal") outerRef.scrollLeft = initialScrollOffset;
                else outerRef.scrollTop = initialScrollOffset;
            }
            this._callPropsCallbacks();
        };
        _proto.componentDidUpdate = function componentDidUpdate() {
            var _this$props3 = this.props, direction = _this$props3.direction, layout = _this$props3.layout;
            var _this$state = this.state, scrollOffset = _this$state.scrollOffset, scrollUpdateWasRequested = _this$state.scrollUpdateWasRequested;
            if (scrollUpdateWasRequested && this._outerRef != null) {
                var outerRef = this._outerRef; // TODO Deprecate direction "horizontal"
                if (direction === "horizontal" || layout === "horizontal") {
                    if (direction === "rtl") // TRICKY According to the spec, scrollLeft should be negative for RTL aligned elements.
                    // This is not the case for all browsers though (e.g. Chrome reports values as positive, measured relative to the left).
                    // So we need to determine which browser behavior we're dealing with, and mimic it.
                    switch($44fd68b3b250de87$var$getRTLOffsetType()){
                        case "negative":
                            outerRef.scrollLeft = -scrollOffset;
                            break;
                        case "positive-ascending":
                            outerRef.scrollLeft = scrollOffset;
                            break;
                        default:
                            var clientWidth = outerRef.clientWidth, scrollWidth = outerRef.scrollWidth;
                            outerRef.scrollLeft = scrollWidth - clientWidth - scrollOffset;
                            break;
                    }
                    else outerRef.scrollLeft = scrollOffset;
                } else outerRef.scrollTop = scrollOffset;
            }
            this._callPropsCallbacks();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            if (this._resetIsScrollingTimeoutId !== null) $44fd68b3b250de87$var$cancelTimeout(this._resetIsScrollingTimeoutId);
        };
        _proto.render = function render() {
            var _this$props4 = this.props, children = _this$props4.children, className = _this$props4.className, direction = _this$props4.direction, height = _this$props4.height, innerRef = _this$props4.innerRef, innerElementType = _this$props4.innerElementType, innerTagName = _this$props4.innerTagName, itemCount = _this$props4.itemCount, itemData = _this$props4.itemData, _this$props4$itemKey = _this$props4.itemKey, itemKey = _this$props4$itemKey === void 0 ? $44fd68b3b250de87$var$defaultItemKey$1 : _this$props4$itemKey, layout = _this$props4.layout, outerElementType = _this$props4.outerElementType, outerTagName = _this$props4.outerTagName, style = _this$props4.style, useIsScrolling = _this$props4.useIsScrolling, width = _this$props4.width;
            var isScrolling = this.state.isScrolling; // TODO Deprecate direction "horizontal"
            var isHorizontal = direction === "horizontal" || layout === "horizontal";
            var onScroll = isHorizontal ? this._onScrollHorizontal : this._onScrollVertical;
            var _this$_getRangeToRend = this._getRangeToRender(), startIndex = _this$_getRangeToRend[0], stopIndex = _this$_getRangeToRend[1];
            var items = [];
            if (itemCount > 0) for(var _index = startIndex; _index <= stopIndex; _index++)items.push((0, $acw62.createElement)(children, {
                data: itemData,
                key: itemKey(_index, itemData),
                index: _index,
                isScrolling: useIsScrolling ? isScrolling : undefined,
                style: this._getItemStyle(_index)
            }));
             // Read this value AFTER items have been created,
            // So their actual sizes (if variable) are taken into consideration.
            var estimatedTotalSize = getEstimatedTotalSize(this.props, this._instanceProps);
            return (0, $acw62.createElement)(outerElementType || outerTagName || "div", {
                className: className,
                onScroll: onScroll,
                ref: this._outerRefSetter,
                style: (0, $8nd05.default)({
                    position: "relative",
                    height: height,
                    width: width,
                    overflow: "auto",
                    WebkitOverflowScrolling: "touch",
                    willChange: "transform",
                    direction: direction
                }, style)
            }, (0, $acw62.createElement)(innerElementType || innerTagName || "div", {
                children: items,
                ref: innerRef,
                style: {
                    height: isHorizontal ? "100%" : estimatedTotalSize,
                    pointerEvents: isScrolling ? "none" : undefined,
                    width: isHorizontal ? estimatedTotalSize : "100%"
                }
            }));
        };
        _proto._callPropsCallbacks = function _callPropsCallbacks() {
            if (typeof this.props.onItemsRendered === "function") {
                var itemCount = this.props.itemCount;
                if (itemCount > 0) {
                    var _this$_getRangeToRend2 = this._getRangeToRender(), _overscanStartIndex = _this$_getRangeToRend2[0], _overscanStopIndex = _this$_getRangeToRend2[1], _visibleStartIndex = _this$_getRangeToRend2[2], _visibleStopIndex = _this$_getRangeToRend2[3];
                    this._callOnItemsRendered(_overscanStartIndex, _overscanStopIndex, _visibleStartIndex, _visibleStopIndex);
                }
            }
            if (typeof this.props.onScroll === "function") {
                var _this$state2 = this.state, _scrollDirection = _this$state2.scrollDirection, _scrollOffset = _this$state2.scrollOffset, _scrollUpdateWasRequested = _this$state2.scrollUpdateWasRequested;
                this._callOnScroll(_scrollDirection, _scrollOffset, _scrollUpdateWasRequested);
            }
        } // Lazily create and cache item styles while scrolling,
        ;
        _proto._getRangeToRender = function _getRangeToRender() {
            var _this$props5 = this.props, itemCount = _this$props5.itemCount, overscanCount = _this$props5.overscanCount;
            var _this$state3 = this.state, isScrolling = _this$state3.isScrolling, scrollDirection = _this$state3.scrollDirection, scrollOffset = _this$state3.scrollOffset;
            if (itemCount === 0) return [
                0,
                0,
                0,
                0
            ];
            var startIndex = getStartIndexForOffset(this.props, scrollOffset, this._instanceProps);
            var stopIndex = getStopIndexForStartIndex(this.props, startIndex, scrollOffset, this._instanceProps); // Overscan by one item in each direction so that tab/focus works.
            // If there isn't at least one extra item, tab loops back around.
            var overscanBackward = !isScrolling || scrollDirection === "backward" ? Math.max(1, overscanCount) : 1;
            var overscanForward = !isScrolling || scrollDirection === "forward" ? Math.max(1, overscanCount) : 1;
            return [
                Math.max(0, startIndex - overscanBackward),
                Math.max(0, Math.min(itemCount - 1, stopIndex + overscanForward)),
                startIndex,
                stopIndex
            ];
        };
        return List;
    }((0, $acw62.PureComponent)), _class.defaultProps = {
        direction: "ltr",
        itemData: undefined,
        layout: "vertical",
        overscanCount: 2,
        useIsScrolling: false
    }, _class;
} // NOTE: I considered further wrapping individual items with a pure ListItem component.
// This would avoid ever calling the render function for the same index more than once,
// But it would also add the overhead of a lot of components/fibers.
// I assume people already do this (render function returning a class component),
// So my doing it would just unnecessarily double the wrappers.
var $44fd68b3b250de87$var$validateSharedProps$1 = function validateSharedProps(_ref2, _ref3) {
    var children = _ref2.children, direction = _ref2.direction, height = _ref2.height, layout = _ref2.layout, innerTagName = _ref2.innerTagName, outerTagName = _ref2.outerTagName, width = _ref2.width;
    var instance = _ref3.instance;
    var isHorizontal;
};
var $44fd68b3b250de87$var$DEFAULT_ESTIMATED_ITEM_SIZE$1 = 50;
var $44fd68b3b250de87$var$getItemMetadata$1 = function getItemMetadata(props, index, instanceProps) {
    var _ref = props, itemSize = _ref.itemSize;
    var itemMetadataMap = instanceProps.itemMetadataMap, lastMeasuredIndex = instanceProps.lastMeasuredIndex;
    if (index > lastMeasuredIndex) {
        var offset = 0;
        if (lastMeasuredIndex >= 0) {
            var itemMetadata = itemMetadataMap[lastMeasuredIndex];
            offset = itemMetadata.offset + itemMetadata.size;
        }
        for(var i = lastMeasuredIndex + 1; i <= index; i++){
            var size = itemSize(i);
            itemMetadataMap[i] = {
                offset: offset,
                size: size
            };
            offset += size;
        }
        instanceProps.lastMeasuredIndex = index;
    }
    return itemMetadataMap[index];
};
var $44fd68b3b250de87$var$findNearestItem$1 = function findNearestItem(props, instanceProps, offset) {
    var itemMetadataMap = instanceProps.itemMetadataMap, lastMeasuredIndex = instanceProps.lastMeasuredIndex;
    var lastMeasuredItemOffset = lastMeasuredIndex > 0 ? itemMetadataMap[lastMeasuredIndex].offset : 0;
    if (lastMeasuredItemOffset >= offset) // If we've already measured items within this range just use a binary search as it's faster.
    return $44fd68b3b250de87$var$findNearestItemBinarySearch$1(props, instanceProps, lastMeasuredIndex, 0, offset);
    else // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
    // The exponential search avoids pre-computing sizes for the full set of items as a binary search would.
    // The overall complexity for this approach is O(log n).
    return $44fd68b3b250de87$var$findNearestItemExponentialSearch$1(props, instanceProps, Math.max(0, lastMeasuredIndex), offset);
};
var $44fd68b3b250de87$var$findNearestItemBinarySearch$1 = function findNearestItemBinarySearch(props, instanceProps, high, low, offset) {
    while(low <= high){
        var middle = low + Math.floor((high - low) / 2);
        var currentOffset = $44fd68b3b250de87$var$getItemMetadata$1(props, middle, instanceProps).offset;
        if (currentOffset === offset) return middle;
        else if (currentOffset < offset) low = middle + 1;
        else if (currentOffset > offset) high = middle - 1;
    }
    if (low > 0) return low - 1;
    else return 0;
};
var $44fd68b3b250de87$var$findNearestItemExponentialSearch$1 = function findNearestItemExponentialSearch(props, instanceProps, index, offset) {
    var itemCount = props.itemCount;
    var interval = 1;
    while(index < itemCount && $44fd68b3b250de87$var$getItemMetadata$1(props, index, instanceProps).offset < offset){
        index += interval;
        interval *= 2;
    }
    return $44fd68b3b250de87$var$findNearestItemBinarySearch$1(props, instanceProps, Math.min(index, itemCount - 1), Math.floor(index / 2), offset);
};
var $44fd68b3b250de87$var$getEstimatedTotalSize = function getEstimatedTotalSize(_ref2, _ref3) {
    var itemCount = _ref2.itemCount;
    var itemMetadataMap = _ref3.itemMetadataMap, estimatedItemSize = _ref3.estimatedItemSize, lastMeasuredIndex = _ref3.lastMeasuredIndex;
    var totalSizeOfMeasuredItems = 0; // Edge case check for when the number of items decreases while a scroll is in progress.
    // https://github.com/bvaughn/react-window/pull/138
    if (lastMeasuredIndex >= itemCount) lastMeasuredIndex = itemCount - 1;
    if (lastMeasuredIndex >= 0) {
        var itemMetadata = itemMetadataMap[lastMeasuredIndex];
        totalSizeOfMeasuredItems = itemMetadata.offset + itemMetadata.size;
    }
    var numUnmeasuredItems = itemCount - lastMeasuredIndex - 1;
    var totalSizeOfUnmeasuredItems = numUnmeasuredItems * estimatedItemSize;
    return totalSizeOfMeasuredItems + totalSizeOfUnmeasuredItems;
};
var $44fd68b3b250de87$export$d8ac3b6b20be856e = /*#__PURE__*/ $44fd68b3b250de87$var$createListComponent({
    getItemOffset: function getItemOffset(props, index, instanceProps) {
        return $44fd68b3b250de87$var$getItemMetadata$1(props, index, instanceProps).offset;
    },
    getItemSize: function getItemSize(props, index, instanceProps) {
        return instanceProps.itemMetadataMap[index].size;
    },
    getEstimatedTotalSize: $44fd68b3b250de87$var$getEstimatedTotalSize,
    getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(props, index, align, scrollOffset, instanceProps) {
        var direction = props.direction, height = props.height, layout = props.layout, width = props.width; // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === "horizontal" || layout === "horizontal";
        var size = isHorizontal ? width : height;
        var itemMetadata = $44fd68b3b250de87$var$getItemMetadata$1(props, index, instanceProps); // Get estimated total size after ItemMetadata is computed,
        // To ensure it reflects actual measurements instead of just estimates.
        var estimatedTotalSize = $44fd68b3b250de87$var$getEstimatedTotalSize(props, instanceProps);
        var maxOffset = Math.max(0, Math.min(estimatedTotalSize - size, itemMetadata.offset));
        var minOffset = Math.max(0, itemMetadata.offset - size + itemMetadata.size);
        if (align === "smart") {
            if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = "auto";
            else align = "center";
        }
        switch(align){
            case "start":
                return maxOffset;
            case "end":
                return minOffset;
            case "center":
                return Math.round(minOffset + (maxOffset - minOffset) / 2);
            case "auto":
            default:
                if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
                else if (scrollOffset < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getStartIndexForOffset: function getStartIndexForOffset(props, offset, instanceProps) {
        return $44fd68b3b250de87$var$findNearestItem$1(props, instanceProps, offset);
    },
    getStopIndexForStartIndex: function getStopIndexForStartIndex(props, startIndex, scrollOffset, instanceProps) {
        var direction = props.direction, height = props.height, itemCount = props.itemCount, layout = props.layout, width = props.width; // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === "horizontal" || layout === "horizontal";
        var size = isHorizontal ? width : height;
        var itemMetadata = $44fd68b3b250de87$var$getItemMetadata$1(props, startIndex, instanceProps);
        var maxOffset = scrollOffset + size;
        var offset = itemMetadata.offset + itemMetadata.size;
        var stopIndex = startIndex;
        while(stopIndex < itemCount - 1 && offset < maxOffset){
            stopIndex++;
            offset += $44fd68b3b250de87$var$getItemMetadata$1(props, stopIndex, instanceProps).size;
        }
        return stopIndex;
    },
    initInstanceProps: function initInstanceProps(props, instance) {
        var _ref4 = props, estimatedItemSize = _ref4.estimatedItemSize;
        var instanceProps = {
            itemMetadataMap: {},
            estimatedItemSize: estimatedItemSize || $44fd68b3b250de87$var$DEFAULT_ESTIMATED_ITEM_SIZE$1,
            lastMeasuredIndex: -1
        };
        instance.resetAfterIndex = function(index, shouldForceUpdate) {
            if (shouldForceUpdate === void 0) shouldForceUpdate = true;
            instanceProps.lastMeasuredIndex = Math.min(instanceProps.lastMeasuredIndex, index - 1); // We could potentially optimize further by only evicting styles after this index,
            // But since styles are only cached while scrolling is in progress-
            // It seems an unnecessary optimization.
            // It's unlikely that resetAfterIndex() will be called while a user is scrolling.
            instance._getItemStyleCache(-1);
            if (shouldForceUpdate) instance.forceUpdate();
        };
        return instanceProps;
    },
    shouldResetStyleCacheOnItemSizeChange: false,
    validateProps: function validateProps(_ref5) {
        var itemSize = _ref5.itemSize;
    }
});
var $44fd68b3b250de87$export$f331158cccad7361 = /*#__PURE__*/ $44fd68b3b250de87$var$createGridComponent({
    getColumnOffset: function getColumnOffset(_ref, index) {
        var columnWidth = _ref.columnWidth;
        return index * columnWidth;
    },
    getColumnWidth: function getColumnWidth(_ref2, index) {
        var columnWidth = _ref2.columnWidth;
        return columnWidth;
    },
    getRowOffset: function getRowOffset(_ref3, index) {
        var rowHeight = _ref3.rowHeight;
        return index * rowHeight;
    },
    getRowHeight: function getRowHeight(_ref4, index) {
        var rowHeight = _ref4.rowHeight;
        return rowHeight;
    },
    getEstimatedTotalHeight: function getEstimatedTotalHeight(_ref5) {
        var rowCount = _ref5.rowCount, rowHeight = _ref5.rowHeight;
        return rowHeight * rowCount;
    },
    getEstimatedTotalWidth: function getEstimatedTotalWidth(_ref6) {
        var columnCount = _ref6.columnCount, columnWidth = _ref6.columnWidth;
        return columnWidth * columnCount;
    },
    getOffsetForColumnAndAlignment: function getOffsetForColumnAndAlignment(_ref7, columnIndex, align, scrollLeft, instanceProps, scrollbarSize) {
        var columnCount = _ref7.columnCount, columnWidth = _ref7.columnWidth, width = _ref7.width;
        var lastColumnOffset = Math.max(0, columnCount * columnWidth - width);
        var maxOffset = Math.min(lastColumnOffset, columnIndex * columnWidth);
        var minOffset = Math.max(0, columnIndex * columnWidth - width + scrollbarSize + columnWidth);
        if (align === "smart") {
            if (scrollLeft >= minOffset - width && scrollLeft <= maxOffset + width) align = "auto";
            else align = "center";
        }
        switch(align){
            case "start":
                return maxOffset;
            case "end":
                return minOffset;
            case "center":
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(width / 2)) return 0; // near the beginning
                else if (middleOffset > lastColumnOffset + Math.floor(width / 2)) return lastColumnOffset; // near the end
                else return middleOffset;
            case "auto":
            default:
                if (scrollLeft >= minOffset && scrollLeft <= maxOffset) return scrollLeft;
                else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
                // this value can be larger than maxOffset when at the end of the list
                return minOffset;
                else if (scrollLeft < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getOffsetForRowAndAlignment: function getOffsetForRowAndAlignment(_ref8, rowIndex, align, scrollTop, instanceProps, scrollbarSize) {
        var rowHeight = _ref8.rowHeight, height = _ref8.height, rowCount = _ref8.rowCount;
        var lastRowOffset = Math.max(0, rowCount * rowHeight - height);
        var maxOffset = Math.min(lastRowOffset, rowIndex * rowHeight);
        var minOffset = Math.max(0, rowIndex * rowHeight - height + scrollbarSize + rowHeight);
        if (align === "smart") {
            if (scrollTop >= minOffset - height && scrollTop <= maxOffset + height) align = "auto";
            else align = "center";
        }
        switch(align){
            case "start":
                return maxOffset;
            case "end":
                return minOffset;
            case "center":
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(height / 2)) return 0; // near the beginning
                else if (middleOffset > lastRowOffset + Math.floor(height / 2)) return lastRowOffset; // near the end
                else return middleOffset;
            case "auto":
            default:
                if (scrollTop >= minOffset && scrollTop <= maxOffset) return scrollTop;
                else if (minOffset > maxOffset) // Because we only take into account the scrollbar size when calculating minOffset
                // this value can be larger than maxOffset when at the end of the list
                return minOffset;
                else if (scrollTop < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getColumnStartIndexForOffset: function getColumnStartIndexForOffset(_ref9, scrollLeft) {
        var columnWidth = _ref9.columnWidth, columnCount = _ref9.columnCount;
        return Math.max(0, Math.min(columnCount - 1, Math.floor(scrollLeft / columnWidth)));
    },
    getColumnStopIndexForStartIndex: function getColumnStopIndexForStartIndex(_ref10, startIndex, scrollLeft) {
        var columnWidth = _ref10.columnWidth, columnCount = _ref10.columnCount, width = _ref10.width;
        var left = startIndex * columnWidth;
        var numVisibleColumns = Math.ceil((width + scrollLeft - left) / columnWidth);
        return Math.max(0, Math.min(columnCount - 1, startIndex + numVisibleColumns - 1 // -1 is because stop index is inclusive
        ));
    },
    getRowStartIndexForOffset: function getRowStartIndexForOffset(_ref11, scrollTop) {
        var rowHeight = _ref11.rowHeight, rowCount = _ref11.rowCount;
        return Math.max(0, Math.min(rowCount - 1, Math.floor(scrollTop / rowHeight)));
    },
    getRowStopIndexForStartIndex: function getRowStopIndexForStartIndex(_ref12, startIndex, scrollTop) {
        var rowHeight = _ref12.rowHeight, rowCount = _ref12.rowCount, height = _ref12.height;
        var top = startIndex * rowHeight;
        var numVisibleRows = Math.ceil((height + scrollTop - top) / rowHeight);
        return Math.max(0, Math.min(rowCount - 1, startIndex + numVisibleRows - 1 // -1 is because stop index is inclusive
        ));
    },
    initInstanceProps: function initInstanceProps(props) {},
    shouldResetStyleCacheOnItemSizeChange: true,
    validateProps: function validateProps(_ref13) {
        var columnWidth = _ref13.columnWidth, rowHeight = _ref13.rowHeight;
    }
});
var $44fd68b3b250de87$export$ae9e55e1d8a2f4b7 = /*#__PURE__*/ $44fd68b3b250de87$var$createListComponent({
    getItemOffset: function getItemOffset(_ref, index) {
        var itemSize = _ref.itemSize;
        return index * itemSize;
    },
    getItemSize: function getItemSize(_ref2, index) {
        var itemSize = _ref2.itemSize;
        return itemSize;
    },
    getEstimatedTotalSize: function getEstimatedTotalSize(_ref3) {
        var itemCount = _ref3.itemCount, itemSize = _ref3.itemSize;
        return itemSize * itemCount;
    },
    getOffsetForIndexAndAlignment: function getOffsetForIndexAndAlignment(_ref4, index, align, scrollOffset) {
        var direction = _ref4.direction, height = _ref4.height, itemCount = _ref4.itemCount, itemSize = _ref4.itemSize, layout = _ref4.layout, width = _ref4.width;
        // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === "horizontal" || layout === "horizontal";
        var size = isHorizontal ? width : height;
        var lastItemOffset = Math.max(0, itemCount * itemSize - size);
        var maxOffset = Math.min(lastItemOffset, index * itemSize);
        var minOffset = Math.max(0, index * itemSize - size + itemSize);
        if (align === "smart") {
            if (scrollOffset >= minOffset - size && scrollOffset <= maxOffset + size) align = "auto";
            else align = "center";
        }
        switch(align){
            case "start":
                return maxOffset;
            case "end":
                return minOffset;
            case "center":
                // "Centered" offset is usually the average of the min and max.
                // But near the edges of the list, this doesn't hold true.
                var middleOffset = Math.round(minOffset + (maxOffset - minOffset) / 2);
                if (middleOffset < Math.ceil(size / 2)) return 0; // near the beginning
                else if (middleOffset > lastItemOffset + Math.floor(size / 2)) return lastItemOffset; // near the end
                else return middleOffset;
            case "auto":
            default:
                if (scrollOffset >= minOffset && scrollOffset <= maxOffset) return scrollOffset;
                else if (scrollOffset < minOffset) return minOffset;
                else return maxOffset;
        }
    },
    getStartIndexForOffset: function getStartIndexForOffset(_ref5, offset) {
        var itemCount = _ref5.itemCount, itemSize = _ref5.itemSize;
        return Math.max(0, Math.min(itemCount - 1, Math.floor(offset / itemSize)));
    },
    getStopIndexForStartIndex: function getStopIndexForStartIndex(_ref6, startIndex, scrollOffset) {
        var direction = _ref6.direction, height = _ref6.height, itemCount = _ref6.itemCount, itemSize = _ref6.itemSize, layout = _ref6.layout, width = _ref6.width;
        // TODO Deprecate direction "horizontal"
        var isHorizontal = direction === "horizontal" || layout === "horizontal";
        var offset = startIndex * itemSize;
        var size = isHorizontal ? width : height;
        var numVisibleItems = Math.ceil((size + scrollOffset - offset) / itemSize);
        return Math.max(0, Math.min(itemCount - 1, startIndex + numVisibleItems - 1 // -1 is because stop index is inclusive
        ));
    },
    initInstanceProps: function initInstanceProps(props) {},
    shouldResetStyleCacheOnItemSizeChange: true,
    validateProps: function validateProps(_ref7) {
        var itemSize = _ref7.itemSize;
    }
});
// Pulled from react-compat
// https://github.com/developit/preact-compat/blob/7c5de00e7c85e2ffd011bf3af02899b63f699d3a/src/index.js#L349
function $44fd68b3b250de87$var$shallowDiffers(prev, next) {
    for(var attribute in prev){
        if (!(attribute in next)) return true;
    }
    for(var _attribute in next){
        if (prev[_attribute] !== next[_attribute]) return true;
    }
    return false;
}
var $44fd68b3b250de87$var$_excluded = [
    "style"
], $44fd68b3b250de87$var$_excluded2 = [
    "style"
];
// It knows to compare individual style props and ignore the wrapper object.
// See https://reactjs.org/docs/react-api.html#reactmemo
function $44fd68b3b250de87$export$b141efd0b0fb9174(prevProps, nextProps) {
    var prevStyle = prevProps.style, prevRest = (0, $1En50.default)(prevProps, $44fd68b3b250de87$var$_excluded);
    var nextStyle = nextProps.style, nextRest = (0, $1En50.default)(nextProps, $44fd68b3b250de87$var$_excluded2);
    return !$44fd68b3b250de87$var$shallowDiffers(prevStyle, nextStyle) && !$44fd68b3b250de87$var$shallowDiffers(prevRest, nextRest);
}
// It knows to compare individual style props and ignore the wrapper object.
// See https://reactjs.org/docs/react-component.html#shouldcomponentupdate
function $44fd68b3b250de87$export$aa365c903ed149ff(nextProps, nextState) {
    return !$44fd68b3b250de87$export$b141efd0b0fb9174(this.props, nextProps) || $44fd68b3b250de87$var$shallowDiffers(this.state, nextState);
}




var $7tOHe = parcelRequire("7tOHe");
const $33284235ce0634a5$var$AvailableItems = ({ state: state, AvailableAreaRow: AvailableAreaRow })=>{
    return !state.filteredAreas ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($64088e28bcd161d0$exports))), {
        flush: true,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $44fd68b3b250de87$export$ae9e55e1d8a2f4b7), {
            className: "List",
            height: 360,
            itemCount: state.filteredAreas?.length,
            itemSize: 22,
            style: {
                overflowY: "auto",
                overflowX: "hidden",
                height: "370px",
                paddingRight: "1rem"
            },
            children: AvailableAreaRow
        })
    });
};
$33284235ce0634a5$var$AvailableItems.propTypes = {
    state: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    AvailableAreaRow: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).element
};
var $33284235ce0634a5$export$2e2bcd8739ae039 = $33284235ce0634a5$var$AvailableItems;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");



var $cstaF = parcelRequire("cstaF");
const $56f2550dab7b6426$var$AddedItems = ({ state: state, AddedAreaRow: AddedAreaRow })=>{
    return state.filteredAddedAreas?.length ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($64088e28bcd161d0$exports))), {
        flush: true,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $44fd68b3b250de87$export$ae9e55e1d8a2f4b7), {
            className: "List",
            height: 360,
            itemCount: state.filteredAddedAreas.length,
            itemSize: 22,
            style: {
                overflowY: "auto",
                overflowX: "hidden",
                height: "370px",
                paddingRight: "1rem"
            },
            children: AddedAreaRow
        })
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: {
            height: "360px",
            position: "relative"
        },
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            style: {
                top: "45%",
                position: "absolute"
            },
            className: "w-100 text-center",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "font-weight-bold d-block",
                    children: (0, $cstaF.searchTerms).noneAdded
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "text-muted",
                    children: (0, $cstaF.searchTerms).selectItemsFromLeft("areas")
                })
            ]
        })
    });
};
$56f2550dab7b6426$var$AddedItems.propTypes = {
    state: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    AddedAreaRow: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).element
};
var $56f2550dab7b6426$export$2e2bcd8739ae039 = $56f2550dab7b6426$var$AddedItems;



var $cvJqS = parcelRequire("cvJqS");

var $90ISC = parcelRequire("90ISC");

var $f6CJ4 = parcelRequire("f6CJ4");

var $cghEn = parcelRequire("cghEn");

var $dDBOF = parcelRequire("dDBOF");

var $g3CkB = parcelRequire("g3CkB");
const $65bf16ac34ebd808$var$MarketArea = (props)=>{
    const { mlsId: mlsId, marketAreaLists: marketAreaLists, selectedMarketAreaCriteria: selectedMarketAreaCriteria, toggleListModal: toggleListModal, userId: userId, module: module, showToast: showToast, closePopover: closePopover, allMls: allMls, selectedSortOption: selectedSortOption, setSortOption: setSortOption, filterText: filterText, setFilterText: setFilterText, toggleErrorModal: toggleErrorModal, selectedSavedSearch: selectedSavedSearch, mappedAreas: mappedAreas } = props;
    const { setSelectedMarketAreaList: setSelectedMarketAreaList, getSavedSearchList: getSavedSearchList } = (0, $90ISC.useSearchStore)((state)=>({
            setSelectedMarketAreaList: state.setSelectedMarketAreaList,
            getSavedSearchList: state.getSavedSearchList
        }), (0, $f3gEZ.shallow));
    const { getMarketAreaLists: getMarketAreaLists } = (0, $90ISC.useCommonStore)((state)=>({
            getMarketAreaLists: state.getMarketAreaLists
        }), (0, $f3gEZ.shallow));
    const { tokenType: tokenType } = (0, $f6CJ4.useAuthStore)((state)=>({
            tokenType: state.tokenType
        }), (0, $f3gEZ.shallow));
    const [state, setState] = (0, $0f60d77680f0c39c$export$cfdfc30609038fdd)({
        ...props,
        editAreaList: undefined
    });
    const setMarketAreaType = (0, $90ISC.useSearchStore)((state)=>state.setMarketAreaType);
    const setAllMls = (0, $90ISC.useSearchStore)((state)=>state.setAllMls);
    const setSelectedAreas = (0, $90ISC.useSearchStore)((state)=>state.setSelectedAreas);
    const sortOptions = [
        {
            value: (0, $cstaF.sortingTerms).alphaValue,
            label: (0, $cstaF.sortingTerms).alphaLabel
        },
        {
            value: (0, $cstaF.sortingTerms).soldCountValue,
            label: (0, $cstaF.sortingTerms).soldCountLabel
        }
    ];
    const updateSelectedAreas = (selectedAreas, listIsDirty)=>{
        setSelectedAreas({
            fieldName: state.selectedMarketAreaCriteria?.fieldName || state.editAreaList.elements.fieldName,
            selectedAreas: selectedAreas,
            listIsDirty: listIsDirty,
            marketAreaLists: marketAreaLists
        });
    };
    const selectMarketAreaList = (marketAreaList)=>{
        if (marketAreaList) {
            setSelectedMarketAreaList(marketAreaList, selectedSavedSearch);
            setState((prevState)=>({
                    ...prevState,
                    initialList: undefined,
                    listIsDirty: false,
                    selectedMarketAreaList: marketAreaList
                }));
        }
    };
    const refreshLists = async ()=>{
        await getMarketAreaLists(userId);
        await getSavedSearchList(userId, module);
    };
    const selectMarketAreaType = (type)=>{
        setMarketAreaType(type);
    };
    const selectAllMls = ()=>{
        setAllMls();
        closePopover();
    };
    const selectType = (e, type)=>{
        e.preventDefault();
        (0, $ivaD7.setStateData)("selectedMarketAreaList", undefined, setState);
        if (type === (0, $cstaF.agentProductionTerms).all) selectAllMls();
        else selectMarketAreaType(type);
    };
    const handleListChange = (option)=>{
        const optionType = state.selectOptions.find((group)=>group.options.find((opt)=>opt.value === option.value));
        switch(optionType.label){
            case (0, $cstaF.searchTerms).areaOptions:
                selectMarketAreaType(Object.values(mappedAreas).find((mappedArea)=>(0, $cstaF.areaRequestTypes)[mappedArea.columnName] === option.value));
                break;
            case (0, $cstaF.searchTerms).allMls:
                selectAllMls();
                break;
            case (0, $cstaF.searchTerms).myMarketLists:
                selectMarketAreaList(marketAreaLists.find((list)=>list.id === option.value));
                break;
        }
        setState((prevState)=>({
                ...prevState,
                initialSelectedList: undefined,
                selectedMarketAreaList: undefined
            }));
    };
    const handleSortChange = (option)=>{
        setSortOption(option);
    };
    const addAreas = (areasToAdd)=>{
        let listIsDirty = false;
        const addedAreas = state.addedAreas ? [
            ...state.addedAreas
        ] : [];
        const selectedAreas = (0, $6Vs3L.default)(addedAreas, [
            ...areasToAdd
        ]);
        if (selectedAreas.length <= 500) {
            if ((state.selectedMarketAreaCriteria.savedAreaId || state.selectedMarketAreaList) && !(0, $EHEsI.default)(state.initialSelectedAreas, selectedAreas)) {
                listIsDirty = true;
                (0, $ivaD7.setStateData)("initialSelectedList", state.selectedMarketAreaList, setState);
            }
            updateSelectedAreas(selectedAreas, listIsDirty);
            (0, $ivaD7.setStateData)("listIsDirty", listIsDirty, setState);
        } else toggleErrorModal();
    };
    const addAll = ()=>{
        addAreas([
            ...state.filteredAreas
        ]);
    };
    const removeAreas = (areasToRemove)=>{
        let listIsDirty = false;
        const selectedAreas = [
            ...state.addedAreas
        ];
        areasToRemove.forEach((o)=>{
            selectedAreas.splice(selectedAreas.findIndex((area)=>area.areaValue === o.areaValue), 1);
        });
        if ((state.selectedMarketAreaCriteria.savedAreaId || state.selectedMarketAreaList) && !(0, $EHEsI.default)(state.initialSelectedAreas, selectedAreas)) {
            listIsDirty = true;
            (0, $ivaD7.setStateData)("initialSelectedList", state.selectedMarketAreaList, setState);
        }
        updateSelectedAreas(selectedAreas, listIsDirty);
        (0, $ivaD7.setStateData)("listIsDirty", listIsDirty, setState);
    };
    const removeAll = ()=>{
        removeAreas([
            ...state.addedAreas
        ]);
    };
    const AvailableAreaRow = ({ index: index, style: style })=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            style: style,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ab5f68d1dbc8673a$exports))), {
                tag: "button",
                className: "btn-sm p-1",
                onClick: ()=>addAreas([
                        state.filteredAreas[index]
                    ]),
                id: `available-${index}`,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5be908a8ed2bdbb1$export$2e2bcd8739ae039), {
                    area: state.filteredAreas[index]
                }, `available-${index}`)
            })
        });
    };
    AvailableAreaRow.propTypes = {
        index: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    };
    const AddedAreaRow = ({ index: index, style: style })=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            style: style,
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ab5f68d1dbc8673a$exports))), {
                tag: "button",
                className: "btn-sm p-1",
                onClick: ()=>removeAreas([
                        state.filteredAddedAreas[index]
                    ]),
                id: `added-${index}`,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5be908a8ed2bdbb1$export$2e2bcd8739ae039), {
                    area: state.filteredAddedAreas[index]
                }, `added-${index}`)
            })
        });
    AddedAreaRow.propTypes = {
        index: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    };
    const formatGroupLabel = (data)=>{
        return data.label !== (0, $cstaF.searchTerms).allMls && data.options.length >= 1 && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "border-bottom d-flex align-items-center",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "select-options-group-label",
                children: data.label
            })
        });
    };
    const closeEditModal = ()=>{
        setState((prevState)=>({
                ...prevState,
                showEditModal: {
                    [(0, $3eK9g.modalKeys).dropdown]: false,
                    [(0, $3eK9g.modalKeys).transfer]: false
                },
                showOverwriteModal: false,
                showAffectedSavedSearchesModal: false,
                listIsDirty: false
            }));
        setTimeout(()=>toggleListModal(), 1000);
    };
    const showEditModal = (key, listId)=>{
        if (listId) {
            const areaList = marketAreaLists.find((list)=>list.id === listId);
            (0, $ivaD7.setStateData)("editAreaList", areaList, setState);
        }
        if (key) (0, $ivaD7.setStateData)("showEditModal", {
            [key]: true
        }, setState);
        toggleListModal();
    };
    const validateAreaListNameAndSave = async (e, list, newName)=>{
        // if name is not changed, ignore overwrite prompt
        const found = marketAreaLists && marketAreaLists.find((l)=>l.mlsId === mlsId && l.ownerId === userId && l.name.toLowerCase() === list.name.toLowerCase());
        const savedList = {
            ...list,
            application: (0, $dDBOF.runningApp),
            ownerType: (0, $cghEn.ownerTypeByTokenType)[tokenType],
            ownerId: userId,
            mlsId: mlsId,
            elements: state.selectedMarketAreaCriteria || state.editAreaList?.elements
        };
        if (newName && found) setState((prevState)=>({
                ...prevState,
                showOverwriteModal: true,
                overwriteMarketAreaList: found
            }));
        else {
            if (list.id) {
                const response = await (0, $24YIE.getSearchesByAreaId)(list.id);
                if (!response.error) {
                    if (response.savedSearches.length === 0) {
                        if (e.id === (0, $cstaF.buttonTerms).updateButtonId) await updateMarketAreaList(savedList, []);
                    } else {
                        const affectedSavedSearches = updateSavedSearches(response.savedSearches, list, state.selectedMarketAreaCriteria);
                        setState((prevState)=>({
                                ...prevState,
                                affectedSavedSearches: affectedSavedSearches,
                                savedSearchesUpdatePrompt: "save",
                                selectedMarketAreaList: savedList,
                                showAffectedSavedSearchesModal: true
                            }));
                    }
                } else {
                    showToast("error", (0, $cstaF.toastMessages).error.saveList((0, $cstaF.searchTerms).marketArea));
                    closeEditModal();
                }
            } else if (e.id === (0, $cstaF.buttonTerms).saveAsNewButtonId) await saveMarketAreaList({
                ...savedList
            });
        }
    };
    const saveMarketAreaList = async (marketAreaList)=>{
        const savedList = {
            ...marketAreaList,
            elements: state.selectedMarketAreaCriteria ? JSON.stringify({
                ...state.selectedMarketAreaCriteria
            }) : JSON.stringify({
                ...state.editAreaList.elements
            })
        };
        const response = await (0, $24YIE.saveCustomArea)(savedList);
        if (response.id) {
            await refreshLists();
            selectMarketAreaList({
                ...savedList,
                id: response.id,
                elements: state.selectedMarketAreaCriteria || state.editAreaList?.elements,
                areaLabel: state.selectedMarketAreaCriteria?.fieldTypeName || state.editAreaList?.elements.fieldTypeName
            });
            closeEditModal();
            closePopover();
            showToast("success", (0, $cstaF.toastMessages).success.savedListConfirmation((0, $cstaF.searchTerms).marketArea));
        } else if (response.error) {
            console.error(response.error);
            showToast("error", (0, $cstaF.toastMessages).error.saveList((0, $cstaF.searchTerms).marketArea));
        }
    };
    const removeSavedAreaIdFromAffectedSavedSearches = (response)=>{
        const savedSearchesWithoutSavedAreaId = [];
        [
            ...response.savedSearches
        ].forEach((ss)=>{
            ss.savedSearch.searchCriteria.criteria.realEstateDatasourceIdsWithFilters[0].searchFields.forEach((searchField)=>delete searchField.savedAreaId);
            savedSearchesWithoutSavedAreaId.push(ss);
        });
        (0, $ivaD7.setStateData)("affectedSavedSearches", savedSearchesWithoutSavedAreaId, setState);
    };
    const validateSavedSearchesAndDelete = async (list)=>{
        const response = await (0, $24YIE.getSearchesByAreaId)(list.id);
        if (!response.error) {
            if (response.savedSearches.length === 0) await deleteMarketAreaList(list, []);
            else {
                removeSavedAreaIdFromAffectedSavedSearches(response);
                setState((prevState)=>({
                        ...prevState,
                        savedSearchesUpdatePrompt: "delete",
                        selectedMarketAreaList: list,
                        showAffectedSavedSearchesModal: true
                    }));
            }
        } else {
            showToast("error", (0, $cstaF.toastMessages).error.deleteSavedList((0, $cstaF.searchTerms).marketArea));
            closeEditModal();
        }
    };
    const deleteMarketAreaList = async (list, savedSearches)=>{
        const response = await (0, $24YIE.deleteSavedMarketArea)(list.id, savedSearches);
        if (!response.error) {
            let listIsDirty = false;
            if (state.selectedMarketAreaList?.id === list.id) listIsDirty = true;
            const selectedAreas = [
                ...state.addedAreas
            ];
            updateSelectedAreas(selectedAreas, listIsDirty);
            (0, $ivaD7.setStateData)("selectOptions", undefined, setState);
            await refreshLists();
            showToast("success", (0, $cstaF.toastMessages).success.deletedListConfirmation(list.name));
        } else showToast("error", (0, $cstaF.toastMessages).error.deleteSavedList((0, $cstaF.searchTerms).marketArea));
        closeEditModal();
    };
    const toggleOverwriteModal = ()=>{
        (0, $ivaD7.setStateData)("showOverwriteModal", !state.showOverwriteModal, setState);
    };
    const overwriteMarketAreaList = async ()=>{
        const elements = state.editAreaList?.elements ?? state.selectedMarketAreaCriteria;
        const overwriteMarketAreaList = {
            ...state.overwriteMarketAreaList,
            elements: elements
        };
        const response = await (0, $24YIE.getSearchesByAreaId)(state.overwriteMarketAreaList.id);
        if (!response.error) {
            if (response.savedSearches.length === 0) await updateMarketAreaList(overwriteMarketAreaList, []);
            else {
                const affectedSavedSearches = updateSavedSearches(response.savedSearches, state.overwriteMarketAreaList, elements);
                setState((prevState)=>({
                        ...prevState,
                        affectedSavedSearches: affectedSavedSearches,
                        savedSearchesUpdatePrompt: "save",
                        selectedMarketAreaList: overwriteMarketAreaList,
                        showAffectedSavedSearchesModal: true
                    }));
            }
        } else {
            showToast("error", (0, $cstaF.toastMessages).error.saveList((0, $cstaF.searchTerms).marketArea));
            closeEditModal();
        }
    };
    const updateMarketAreaList = async (list, savedSearches)=>{
        const savedList = {
            ...list,
            elements: state?.selectedMarketAreaCriteria || list.elements
        };
        const response = await (0, $24YIE.updateSavedMarketArea)({
            ...savedList,
            elements: JSON.stringify(savedList.elements)
        }, savedSearches);
        if (!response.error) {
            if (state.overwriteMarketAreaList && state.editAreaList) {
                const responseEditedList = await (0, $24YIE.getSearchesByAreaId)(state.editAreaList?.id);
                const affectedSavedSearchesEditedList = updateSavedSearches(responseEditedList.savedSearches, state.editAreaList, state.overwriteMarketAreaList.elements);
                removeSavedAreaIdFromAffectedSavedSearches(responseEditedList);
                await (0, $24YIE.deleteSavedMarketArea)(state.editAreaList.id, affectedSavedSearchesEditedList);
                (0, $ivaD7.setStateData)("overwriteAffectedSavedSearches", false, setState);
            }
            await refreshLists();
            selectMarketAreaList(savedList);
            closeEditModal();
            closePopover();
            showToast("success", (0, $cstaF.toastMessages).success.savedListConfirmation(savedList.name));
        } else showToast("error", (0, $cstaF.toastMessages).error.saveList((0, $cstaF.searchTerms).marketArea));
    };
    const updateSavedSearches = (savedSearches, list, criteria)=>{
        const savedSearchesWithSavedAreaId = [];
        [
            ...savedSearches
        ].forEach((ss)=>{
            let searchFields = ss.savedSearch.searchCriteria.criteria.realEstateDatasourceIdsWithFilters[0].searchFields;
            const searchField = searchFields.find((field)=>field.savedAreaId === list.id);
            if (searchField.fieldName === criteria.fieldName) {
                searchField.fieldValues = criteria.fieldValues;
                if (searchField.fieldName === "areaKey" || searchField.fieldName === "area2Key") searchField.fieldValueDescriptions = criteria.fieldValueDescriptions;
            }
            savedSearchesWithSavedAreaId.push(ss);
        });
        return savedSearchesWithSavedAreaId;
    };
    const continueWithSavedSearchesUpdate = async ()=>{
        if (state.savedSearchesUpdatePrompt === "save") await updateMarketAreaList(state.selectedMarketAreaList, state.affectedSavedSearches);
        else if (state.savedSearchesUpdatePrompt === "delete") await deleteMarketAreaList(state.selectedMarketAreaList, state.affectedSavedSearches);
        (0, $ivaD7.setStateData)("showAffectedSavedSearchesModal", false, setState);
    };
    const filterOptions = (option, rawInput)=>{
        const inputValueLowerCase = rawInput.toLowerCase();
        const regexFieldTypeName = /\((.*?)\)/;
        const matches = option.label.match(regexFieldTypeName);
        if (matches) {
            const fieldName = option.label.split("(")[0].toLowerCase();
            const fieldTypeName = matches[1].toLowerCase();
            return fieldName.includes(inputValueLowerCase) || fieldTypeName.startsWith(inputValueLowerCase);
        }
        return option.label.toLowerCase().includes(inputValueLowerCase);
    };
    const getSelectComponents = ()=>{
        return {
            Option: (props)=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $11eaca119a44f601$export$2e2bcd8739ae039), {
                    ...props,
                    showEditModal: showEditModal,
                    marketAreaLists: marketAreaLists
                });
            }
        };
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            !selectedMarketAreaCriteria ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0c7e2c31e4cd336c$export$2e2bcd8739ae039), {
                        mappedAreas: mappedAreas,
                        selectType: selectType,
                        allMls: allMls
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d0969125dc20f8aa$export$2e2bcd8739ae039), {
                        mlsId: mlsId,
                        marketAreaLists: marketAreaLists,
                        showEditModal: showEditModal,
                        setSelectedMarketAreaList: selectMarketAreaList,
                        mappedAreas: mappedAreas,
                        userId: userId,
                        module: module,
                        showToast: showToast
                    })
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    width: "620px",
                    margin: "9 5.5"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "w-100",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    width: "80%",
                                    float: "left"
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4TPr9.default), {
                                    placeholder: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                                                icon: (0, $eOjgM.search),
                                                className: "align-top mr-1",
                                                title: "search icon"
                                            }),
                                            " ",
                                            (0, $cstaF.searchTerms).searchMarketAreaLists
                                        ]
                                    }),
                                    components: getSelectComponents(),
                                    isClearable: false,
                                    options: state.selectOptions,
                                    onlySearchLabel: true,
                                    formatGroupLabel: formatGroupLabel,
                                    onChange: handleListChange,
                                    filterOption: filterOptions,
                                    value: state.selectOptions ? state.selectedMarketAreaCriteria?.savedAreaId ? state.selectOptions[2]?.options.find((opt)=>opt.value === state.selectedMarketAreaCriteria.savedAreaId) : state.selectedMarketAreaCriteria?.fieldName ? state.selectOptions[1]?.options.find((opt)=>opt.value === state.selectedMarketAreaCriteria.fieldName) : allMls ? state.selectOptions[0][0] : undefined : undefined,
                                    autoFocus: true,
                                    classNamePrefix: "area-list-search",
                                    styles: {
                                        option: (baseStyles, state)=>({
                                                ...baseStyles,
                                                textTransform: "capitalize",
                                                whiteSpace: "pre",
                                                ...(0, $g3CkB.getSelectBrandColorConfig)(state)
                                            }),
                                        singleValue: (baseStyles)=>({
                                                ...baseStyles,
                                                textTransform: "capitalize",
                                                whiteSpace: "pre"
                                            })
                                    }
                                })
                            }),
                            selectedMarketAreaCriteria && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                style: {
                                    float: "right",
                                    width: "19%"
                                },
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4TPr9.default), {
                                    options: sortOptions,
                                    onChange: handleSortChange,
                                    isClearable: false,
                                    isSearchable: false,
                                    defaultValue: selectedSortOption || sortOptions[0],
                                    className: "saved-search-sort"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "w-100 d-inline-block",
                        style: {
                            marginTop: "5px"
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6Twau))), {
                            dataLwtId: "InputGroup",
                            style: {
                                height: "38px"
                            },
                            prependAddonProps: [
                                {
                                    textProps: {
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                                            icon: (0, $eOjgM.search),
                                            className: "align-top mr-1",
                                            title: "search icon"
                                        })
                                    }
                                }
                            ],
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5txPe))), {
                                dataLwtId: "saved-search-lookup",
                                onChange: (e)=>setFilterText(e.target.value),
                                placeholder: "Filter by area name, city, zip code",
                                defaultValue: filterText,
                                maxLength: (0, $cstaF.SEARCH_VALUE_MAX_LENGTH)
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3RdAS.default), {
                        isAddAllDisabled: !state.filteredAreas?.length,
                        availableItems: state.filteredAreas,
                        renderedAvailableItems: (0, $33284235ce0634a5$export$2e2bcd8739ae039)({
                            state: state,
                            AvailableAreaRow: AvailableAreaRow
                        }),
                        renderedAddedItems: (0, $56f2550dab7b6426$export$2e2bcd8739ae039)({
                            state: state,
                            AddedAreaRow: AddedAreaRow
                        }),
                        addAll: addAll,
                        removeAll: removeAll,
                        showEditModal: ()=>showEditModal((0, $3eK9g.modalKeys).transfer),
                        closeEditModal: closeEditModal,
                        modalIsOpen: state.showEditModal[(0, $3eK9g.modalKeys).transfer],
                        selectedList: state.initialSelectedList || state.selectedMarketAreaList,
                        selectedItems: state.filteredAddedAreas,
                        saveList: validateAreaListNameAndSave,
                        updateList: validateAreaListNameAndSave,
                        availableWidth: "45%",
                        addedWidth: "45%",
                        disabled: !state.addedAreas || !state.addedAreas.length,
                        editModalHeader: state.initialSelectedList || state.selectedMarketAreaList ? (0, $cstaF.searchTerms).saveList : (0, $cstaF.searchTerms).saveAsList,
                        idProperty: "id",
                        isDirty: state.listIsDirty
                    })
                ]
            }),
            state.overwriteMarketAreaList && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f61ig.default), {
                title: (0, $cstaF.searchTerms).overwriteMarketAreaHeader,
                // eslint-disable-next-line react/no-children-prop
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cvJqS.OverwriteModalContent), {
                    name: state.overwriteMarketAreaList?.name
                }),
                show: state.showOverwriteModal,
                onClose: toggleOverwriteModal,
                buttons: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                            dataLwtId: "cancel",
                            color: "secondary",
                            onClick: toggleOverwriteModal,
                            children: (0, $cstaF.buttonTerms).cancel
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                            dataLwtId: "save",
                            color: "primary",
                            onClick: overwriteMarketAreaList,
                            children: (0, $cstaF.buttonTerms).ok
                        })
                    ]
                })
            }, "overwrite"),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dyffq.default), {
                showModal: state.showAffectedSavedSearchesModal,
                onClose: ()=>(0, $ivaD7.setStateData)("showAffectedSavedSearchesModal", false, setState),
                onYes: continueWithSavedSearchesUpdate,
                savedSearches: state.affectedSavedSearches,
                list: state.selectedMarketAreaList,
                continuePrompt: state.savedSearchesUpdatePrompt,
                searchType: "Area"
            }),
            state.editAreaList && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bwlfW.default), {
                closeEditModal: closeEditModal,
                modalIsOpen: state.showEditModal["dropdown-edit-list"],
                initialList: state.editAreaList,
                idProperty: "id",
                onSaveNew: validateAreaListNameAndSave,
                onUpdate: validateAreaListNameAndSave,
                onDelete: validateSavedSearchesAndDelete,
                headerContent: (0, $cstaF.searchTerms).editList
            }, (0, $3eK9g.modalKeys).dropdown)
        ]
    });
};
$65bf16ac34ebd808$var$MarketArea.propTypes = {
    mlsId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    marketAreaLists: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    selectedMarketAreaCriteria: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    toggleListModal: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    userId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    module: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    areaTypes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    showToast: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    closePopover: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    allMls: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    selectedSortOption: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    setSortOption: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    filterText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    setFilterText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    toggleErrorModal: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    selectedSavedSearch: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    mappedAreas: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $65bf16ac34ebd808$export$2e2bcd8739ae039 = $65bf16ac34ebd808$var$MarketArea;



var $ivaD7 = parcelRequire("ivaD7");

var $bxSLe = parcelRequire("bxSLe");

var $jeANf = parcelRequire("jeANf");

var $cstaF = parcelRequire("cstaF");

var $90ISC = parcelRequire("90ISC");

var $57vuM = parcelRequire("57vuM");
const $584371c83aa4f220$var$MarketAreaChip = (props)=>{
    const { disabled: disabled, module: module, userId: userId, selectedMls: selectedMls, selectedSavedSearch: selectedSavedSearch, mlsProps: mlsProps } = props;
    const initialState = {
        isPopoverOpen: false,
        title: undefined,
        mlsId: undefined,
        shouldShowErrorModal: false,
        selectedMarketAreaListId: undefined,
        selectedMarketAreas: undefined
    };
    const [state, setState] = (0, $acw62.useState)({
        ...initialState
    });
    (0, $57vuM.useCloseChip)(state.isPopoverOpen, setState, state.isListModalOpen);
    const { search: search, title: title } = (0, $90ISC.useSearchStore)((state)=>({
            search: state[module]?.search,
            title: state[module]?.marketAreaTitle
        }));
    const mappedAreas = mlsProps?.mappedAreas;
    const marketAreaLists = (0, $90ISC.useCommonStore)((state)=>state.marketAreaLists);
    const isMarketDynamics = module === (0, $cstaF.modules).marketDynamics.marketDynamics;
    const popoverHeader = isMarketDynamics ? (0, $cstaF.searchTerms).areaType : (0, $cstaF.searchTerms).marketArea;
    (0, $acw62.useEffect)(()=>{
        if (module && selectedMls && mappedAreas) {
            let options = [
                {
                    label: (0, $cstaF.searchTerms).allMls,
                    options: [
                        {
                            label: (0, $cstaF.searchTerms).allMls,
                            value: (0, $cstaF.agentProductionTerms).all
                        }
                    ]
                }
            ];
            if (mappedAreas) options.push({
                label: (0, $cstaF.searchTerms).areaOptions,
                options: Object.values(mappedAreas).map((mappedArea)=>{
                    return {
                        label: mappedArea.viewName,
                        value: (0, $cstaF.areaRequestTypes)[mappedArea.columnName]
                    };
                })
            });
            setState((prevState)=>({
                    ...prevState,
                    mappedAreas: mappedAreas,
                    options: options
                }));
        }
    }, [
        module,
        selectedMls,
        mappedAreas,
        search
    ]);
    (0, $acw62.useEffect)(()=>{
        if (selectedMls) {
            const mls = {
                ...search?.searchCriteria?.criteria?.realEstateDatasourceIdsWithFilters?.find((mls)=>mls.realEstateDatasourceId === (selectedMls?.mlsId ?? search.mlsId))
            };
            const marketAreas = mls?.searchFields?.find((f)=>(0, $cstaF.areaSearchTypes).includes(f.fieldName));
            setState((prevState)=>({
                    ...prevState,
                    allMLS: !!mls.searchAllMLS,
                    selectedMarketAreaCriteria: marketAreas
                }));
        }
    }, [
        search
    ]);
    (0, $acw62.useEffect)(()=>{
        try {
            marketAreaLists && selectedMls && (0, $ivaD7.setStateData)("marketAreaLists", [
                ...marketAreaLists
            ].filter((list)=>list.mlsId === selectedMls?.mlsId).map((list)=>({
                    ...list,
                    // eslint-disable-next-line no-useless-escape
                    elements: JSON.parse(list.elements.replaceAll('""', ""))
                })), setState);
        } catch (error) {
            console.error(error);
        }
    }, [
        marketAreaLists,
        selectedMls
    ]);
    (0, $acw62.useEffect)(()=>{
        (0, $bxSLe.toggleRunSearchButton)(state.isPopoverOpen);
    }, [
        state.isPopoverOpen
    ]);
    const closePopover = ()=>{
        setState((prevState)=>({
                ...prevState,
                shouldShowErrorModal: false,
                isListModalOpen: false,
                isPopoverOpen: false
            }));
    };
    const setSelectedSortOption = (option)=>{
        (0, $ivaD7.setStateData)("selectedSortOption", option, setState);
    };
    const setFilterText = (filterText)=>{
        (0, $ivaD7.setStateData)("filterText", filterText, setState);
    };
    const togglePopover = async ()=>{
        if (state.isPopoverOpen) {
            if (!state.shouldShowErrorModal && !state.isListModalOpen) (0, $ivaD7.setStateData)("isPopoverOpen", !state.isPopoverOpen, setState);
        } else (0, $ivaD7.setStateData)("isPopoverOpen", !state.isPopoverOpen, setState);
    };
    const toggleErrorModal = ()=>{
        if (state.shouldShowErrorModal) // delay closing the modal until the togglePopover is called
        setTimeout(()=>(0, $ivaD7.setStateData)("shouldShowErrorModal", !state.shouldShowErrorModal, setState), 500);
        else (0, $ivaD7.setStateData)("shouldShowErrorModal", !state.shouldShowErrorModal, setState);
    };
    const toggleListModal = ()=>(0, $ivaD7.setStateData)("isListModalOpen", !state.isListModalOpen, setState);
    const setToastProps = (type, message)=>{
        (0, $jeANf.showToast)(type, message, setState);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                dataLwtId: "area-chip",
                size: "sm",
                color: "secondary",
                className: "mb-1 text-capitalize text-truncate truncated-chip-button",
                id: "location",
                onClick: ()=>togglePopover(),
                disabled: disabled,
                style: {
                    whiteSpace: "pre"
                },
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                        icon: (0, $eOjgM.map_pin),
                        ...(0, $7ROc5.chipIconProps),
                        title: "map-pin icon"
                    }),
                    title?.mainTitle,
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        style: {
                            textTransform: "none"
                        },
                        children: title?.subTitle && `: ${title.subTitle}`
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Xlz6))), {
                innerClassName: "helix-heading",
                target: "location",
                placement: "bottom",
                size: "auto",
                trigger: "legacy",
                header: popoverHeader,
                style: {
                    minWidth: "300px"
                },
                isOpen: state.isPopoverOpen,
                toggle: ()=>togglePopover(),
                body: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $65bf16ac34ebd808$export$2e2bcd8739ae039), {
                                mlsId: selectedMls?.mlsId,
                                marketAreaLists: state.marketAreaLists,
                                selectedMarketAreaCriteria: state.selectedMarketAreaCriteria,
                                userId: userId,
                                module: module,
                                typeOptions: state.options,
                                toggleErrorModal: toggleErrorModal,
                                toggleListModal: toggleListModal,
                                showToast: setToastProps,
                                closePopover: closePopover,
                                allMls: state.allMLS,
                                selectedSortOption: state.selectedSortOption,
                                setSortOption: setSelectedSortOption,
                                filterText: state.filterText,
                                setFilterText: setFilterText,
                                mappedAreas: state.mappedAreas,
                                selectedSavedSearch: selectedSavedSearch
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f61ig.default), {
                            title: "Too many selections",
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                style: {
                                    padding: "0 30px"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        style: {
                                            float: "left",
                                            fontSize: "3rem",
                                            width: "20%"
                                        },
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("i", {
                                            className: "material-icons alert-icon text-danger",
                                            children: "warning"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        children: [
                                            "You have selected too many options. ",
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                            "Please limit your selection to 500."
                                        ]
                                    })
                                ]
                            }),
                            show: state.shouldShowErrorModal,
                            onClose: toggleErrorModal
                        })
                    ]
                }),
                disabled: disabled,
                ...(0, $bxSLe.popoverModifiers)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3QXz5))), {
                position: "toast-bottom-right",
                dataLwtId: "save-list-toasts",
                toastProps: state.toastProps
            })
        ]
    });
};
$584371c83aa4f220$var$MarketAreaChip.propTypes = {
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    module: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    userId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    selectedMlsId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    selectedSavedSearch: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $584371c83aa4f220$export$2e2bcd8739ae039 = $584371c83aa4f220$var$MarketAreaChip;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $f3gEZ = parcelRequire("f3gEZ");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $2Xlz6 = parcelRequire("2Xlz6");

var $dI25G = parcelRequire("dI25G");

var $eOjgM = parcelRequire("eOjgM");

var $ivaD7 = parcelRequire("ivaD7");

var $cstaF = parcelRequire("cstaF");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $2OwWq = parcelRequire("2OwWq");

const $70eaf2cfaa460d2e$var$AreaTypesList = (props)=>{
    const { areaTypes: areaTypes, selectType: selectType, selectedType: selectedType } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2OwWq.default), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($64088e28bcd161d0$exports))), {
            flush: true,
            children: areaTypes.map((areaType)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ab5f68d1dbc8673a$exports))), {
                        tag: "button",
                        // active={selectedType.fieldValues?.includes(areaType.columnName)}
                        value: areaType.columnName,
                        onClick: (e)=>selectType(e, areaType),
                        children: areaType.viewName
                    })
                }, areaType.columnName))
        })
    });
};
var $70eaf2cfaa460d2e$export$2e2bcd8739ae039 = $70eaf2cfaa460d2e$var$AreaTypesList;



var $bxSLe = parcelRequire("bxSLe");

var $90ISC = parcelRequire("90ISC");

var $57vuM = parcelRequire("57vuM");
const $b7a2194575484e2d$var$AreaTypeChip = (props)=>{
    const { disabled: disabled, module: module, selectedMls: selectedMls, mlsProps: mlsProps } = props;
    const { search: search, title: title, setAreaType: setAreaType } = (0, $90ISC.useSearchStore)((state)=>({
            search: state[module]?.search,
            title: state[module]?.areaTypeTitle,
            setAreaType: state.setAreaType
        }), (0, $f3gEZ.shallow));
    const mappedAreas = mlsProps?.mappedAreas;
    const initialState = {
        isPopoverOpen: false,
        title: undefined,
        areaTypes: [],
        selectedType: undefined
    };
    const [state, setState] = (0, $acw62.useState)({
        ...initialState
    });
    (0, $57vuM.useCloseChip)(state.isPopoverOpen, setState);
    (0, $acw62.useEffect)(()=>{
        if (selectedMls) {
            const mls = {
                ...search?.searchCriteria?.criteria?.realEstateDatasourceIdsWithFilters?.find((mls)=>mls.realEstateDatasourceId === (selectedMls?.mlsId ?? search.mlsId))
            };
            const areaTypeCriteria = mls.computedFields.find((searchField)=>searchField.fieldName === "areaType");
            areaTypeCriteria && (0, $ivaD7.setStateData)("selectedType", areaTypeCriteria, setState);
        }
    }, [
        search
    ]);
    (0, $acw62.useEffect)(()=>{
        mappedAreas && (0, $ivaD7.setStateData)("areaTypes", Object.values(mappedAreas).map((area)=>({
                ...area,
                columnName: (0, $cstaF.areaRequestTypes)[area.columnName]
            })), setState);
    }, [
        mappedAreas
    ]);
    const togglePopover = ()=>{
        (0, $ivaD7.setStateData)("isPopoverOpen", !state.isPopoverOpen, setState);
    };
    const handleSelectChange = (e, selectedAreaType)=>{
        const areaType = e.target.value;
        if (state.selectedType !== areaType) {
            setAreaType((0, $cstaF.searchTerms).selectedAreaTypeTitle + selectedAreaType.viewName, selectedAreaType.columnName);
            (0, $ivaD7.setStateData)("selectedType", selectedAreaType.columnName, setState);
        }
        togglePopover();
        e.preventDefault();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                dataLwtId: "areaType-chip",
                size: "sm",
                color: "secondary",
                className: "mb-1 text-capitalize",
                id: "area-type-chip",
                disabled: disabled,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                        icon: (0, $eOjgM.map_pin),
                        className: "align-top mr-1",
                        title: "map-pin icon"
                    }),
                    title?.mainTitle
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Xlz6))), {
                target: "area-type-chip",
                placement: "bottom",
                size: "auto",
                trigger: "legacy",
                header: (0, $cstaF.searchTerms).areaTypePopover,
                style: {
                    minWidth: "300px"
                },
                isOpen: state.isPopoverOpen,
                toggle: ()=>togglePopover(),
                body: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $70eaf2cfaa460d2e$export$2e2bcd8739ae039), {
                    areaTypes: state.areaTypes,
                    selectType: handleSelectChange,
                    selectedType: state.selectedType
                }),
                disabled: disabled,
                ...(0, $bxSLe.popoverModifiers)
            })
        ]
    });
};
var $b7a2194575484e2d$export$2e2bcd8739ae039 = $b7a2194575484e2d$var$AreaTypeChip;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $chB0Q = parcelRequire("chB0Q");

var $cstaF = parcelRequire("cstaF");

var $ivaD7 = parcelRequire("ivaD7");

var $bxSLe = parcelRequire("bxSLe");

var $90ISC = parcelRequire("90ISC");

var $57vuM = parcelRequire("57vuM");

var $cghEn = parcelRequire("cghEn");

var $f6CJ4 = parcelRequire("f6CJ4");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $dI25G = parcelRequire("dI25G");

var $eOjgM = parcelRequire("eOjgM");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");
function $a4fcb45d9fa84e34$export$2e2bcd8739ae039(props) {
    const { id: id, isDisabled: isDisabled, label: label, onClick: onClick, leftIcon: leftIcon, rightIcon: rightIcon } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
        dataLwtId: id,
        size: "sm",
        color: "secondary",
        className: "mb-1 text-capitalize d-inline-flex",
        id: id,
        onClick: onClick,
        disabled: isDisabled,
        children: [
            leftIcon,
            label,
            rightIcon
        ]
    });
}
$a4fcb45d9fa84e34$export$2e2bcd8739ae039.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    leftIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    rightIcon: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $2Xlz6 = parcelRequire("2Xlz6");

var $cstaF = parcelRequire("cstaF");

var $bxSLe = parcelRequire("bxSLe");
function $2afe5e16c747ba36$export$2e2bcd8739ae039(props) {
    const { target: target, title: title, isPopoverOpen: isPopoverOpen, togglePopover: togglePopover, selectedName: selectedName, isDisabled: isDisabled, bodyComponent: bodyComponent } = props;
    const currentSearchDetails = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "pb-2 border-bottom current-search-details",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                className: "my-3 filter-search-header",
                children: title
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "helix-heading text-truncate",
                children: selectedName || (0, $cstaF.searchTerms).unsaved
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Xlz6))), {
        target: target,
        placement: "bottom",
        trigger: "legacy",
        isOpen: isPopoverOpen,
        toggle: togglePopover,
        size: "auto",
        body: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                currentSearchDetails,
                bodyComponent
            ]
        }),
        disabled: isDisabled,
        ...(0, $bxSLe.popoverModifiers)
    });
}
$2afe5e16c747ba36$export$2e2bcd8739ae039.propTypes = {
    target: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    selectedName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    isPopoverOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    togglePopover: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    bodyComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $2OwWq = parcelRequire("2OwWq");

var $4TPr9 = parcelRequire("4TPr9");

var $dI25G = parcelRequire("dI25G");
parcelRequire("fHiKR");
var $5txPe = parcelRequire("5txPe");
parcelRequire("87zV1");
var $6Twau = parcelRequire("6Twau");


var $eOjgM = parcelRequire("eOjgM");

var $ivaD7 = parcelRequire("ivaD7");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $dI25G = parcelRequire("dI25G");


var $eOjgM = parcelRequire("eOjgM");
function $50a64797617f8a2e$export$2e2bcd8739ae039(props) {
    const { savedItem: savedItem, isSelected: isSelected, handleChange: handleChange, editSavedItem: editSavedItem, renderTooltip: renderTooltip, getSavedItemName: getSavedItemName, getSavedItemNotes: getSavedItemNotes } = props;
    const ref = (0, $acw62.useRef)();
    const [isHovering, setIsHovering] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (ref.current && isSelected) ref.current.scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "center"
        });
    }, [
        isSelected
    ]);
    const editIconDisplay = ()=>{
        setIsHovering(true);
    };
    const editIconHide = ()=>{
        setIsHovering(false);
    };
    const openEditModal = (e)=>{
        editSavedItem(savedItem, e);
    };
    const classNameDesc = getSavedItemNotes && getSavedItemNotes(savedItem) ? "edit-icon-container-w-desc" : "";
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            renderTooltip && renderTooltip(savedItem),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                onMouseOver: editIconDisplay,
                onMouseOut: editIconHide,
                className: "saved-search-selection",
                id: `saved-search-${savedItem.id}-tooltip`,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "saved-search-menu-label",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ab5f68d1dbc8673a$exports))), {
                            tag: "button",
                            className: "saved-search-menu-item",
                            active: isSelected,
                            onClick: (e)=>handleChange(e, savedItem.id),
                            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "text-truncate helix-body--strong saved-search-name",
                                        style: {
                                            width: "270px",
                                            whiteSpace: "pre"
                                        },
                                        ref: ref,
                                        children: getSavedItemName(savedItem)
                                    }),
                                    getSavedItemNotes && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "text-truncate helix-small saved-search-desc",
                                        style: {
                                            width: "270px",
                                            whiteSpace: "pre"
                                        },
                                        children: getSavedItemNotes(savedItem)
                                    })
                                ]
                            })
                        })
                    }),
                    typeof savedItem?.id === "number" && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: `valign-container edit-icon-container ${classNameDesc}`,
                        style: {
                            display: isHovering ? "flex" : "none"
                        },
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                            className: "edit-icon-button",
                            dataLwtId: `edit-icon-${savedItem.id}`,
                            size: "sm",
                            color: "link",
                            onClick: openEditModal,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                                icon: (0, $eOjgM.pencil),
                                className: "align-top",
                                title: "edit icon"
                            })
                        })
                    })
                ]
            })
        ]
    });
}
$50a64797617f8a2e$export$2e2bcd8739ae039.propTypes = {
    savedItem: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    isSelected: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    handleChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    editSavedItem: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    renderTooltip: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    getSavedItemName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    getSavedItemNotes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};



var $90ISC = parcelRequire("90ISC");

var $cstaF = parcelRequire("cstaF");

var $eHBjM = parcelRequire("eHBjM");

var $bnHw5 = parcelRequire("bnHw5");
function $b64b47e6134560c0$export$2e2bcd8739ae039(props) {
    const { listTitle: listTitle, NoItemsComponent: NoItemsComponent, initialSelectedItemId: initialSelectedItemId, getSavedItemName: getSavedItemName, getSavedItemNotes: getSavedItemNotes, renderTooltip: renderTooltip, onSelectItem: onSelectItem, savedGroups: savedGroups, handleOpenEditModal: handleOpenEditModal, filterPlaceholder: filterPlaceholder } = props;
    const { selectedModule: selectedModule } = (0, $90ISC.useSearchStore)(({ selectedModule: selectedModule })=>({
            selectedModule: selectedModule
        }));
    const isSavedAgents = selectedModule === (0, $cstaF.modules).proficiencyMetrics.savedAgents;
    const { selectedList: selectedList } = (0, $90ISC.useSavedAgentsStore)((state)=>({
            selectedList: state.selectedListByModule[selectedModule]
        }));
    const sortOptions = [
        {
            value: (0, $cstaF.sortingTerms).recentValue,
            label: (0, $cstaF.sortingTerms).recentLabel
        },
        {
            value: (0, $cstaF.sortingTerms).alphaValue,
            label: (0, $cstaF.sortingTerms).alphaLabel
        },
        {
            value: (0, $cstaF.sortingTerms).updatedValue,
            label: (0, $cstaF.sortingTerms).updatedLabel
        }
    ].filter((opt)=>isSavedAgents || opt.value !== (0, $cstaF.sortingTerms).recentValue);
    const [state, setState] = (0, $acw62.useState)({
        searchText: undefined,
        selectedSortOption: sortOptions[0],
        editableItem: undefined,
        originalItem: undefined,
        overwriteItem: undefined,
        selectedItemId: initialSelectedItemId,
        showEditModal: false,
        showOverwriteModal: false,
        filteredItems: undefined
    });
    const updatedSortFunction = (a, b)=>{
        const getMoreRecentDate = (object)=>{
            // TODO: This should be outsourced to the parent of SavedItemDropdown
            if (object?.updatedTs) return new Date(object.updatedTs);
            return new Date(object?.metadata.lastLoadedTs ? new Date(object.metadata.lastLoadedTs) > new Date(object.metadata.updatedTs) ? object.metadata.lastLoadedTs : object.metadata.updatedTs : object.metadata.updatedTs);
        };
        return getMoreRecentDate(b) - getMoreRecentDate(a);
    };
    const alphaSortFunction = (a, b)=>{
        // TODO: This should be outsourced to the parent of SavedItemDropdown
        const nameA = a?.savedSearch?.searchName || a.name;
        const nameB = b?.savedSearch?.searchName || b.name;
        return nameA.toLowerCase().localeCompare(nameB.toLowerCase(), "en", {
            numeric: true
        });
    };
    const sortFnByOption = {
        [(0, $cstaF.sortingTerms).recentValue]: (0, $bnHw5.recentSortFunction)(selectedList?.agentListId),
        [(0, $cstaF.sortingTerms).alphaValue]: alphaSortFunction,
        [(0, $cstaF.sortingTerms).updatedValue]: updatedSortFunction
    };
    const sortList = (savedList)=>Object.keys(savedList).sort().reduce((obj, key)=>({
                ...obj,
                [key]: savedList[key].sort(sortFnByOption[state.selectedSortOption?.value])
            }), {});
    (0, $acw62.useEffect)(()=>{
        state.selectedItemId !== initialSelectedItemId && onSelectItem(state.selectedItemId);
    }, [
        state.selectedItemId
    ]);
    (0, $acw62.useEffect)(()=>{
        if (savedGroups && Object.keys(savedGroups).length) {
            let filteredItems;
            if (state.searchText) {
                const filteredKeys = Object.keys(savedGroups).filter((mls)=>savedGroups[mls].some((ss)=>(ss?.name || ss.savedSearch.searchName).toLowerCase().startsWith(state.searchText?.toLowerCase())));
                filteredItems = filteredKeys.reduce((obj, key)=>({
                        ...obj,
                        [key]: savedGroups[key].filter((ss)=>(ss?.name || ss.savedSearch.searchName).toLowerCase().startsWith(state.searchText?.toLowerCase()))
                    }), {});
            } else filteredItems = {
                ...savedGroups
            };
            const sorted = sortList(filteredItems);
            const sortedFilteredWithAll = Object.keys(sorted).reduce((acc, mls)=>{
                const currentGroup = sorted[mls];
                acc[mls] = isSavedAgents ? [
                    {
                        id: `all-lists-${currentGroup[0].mlsId}`,
                        name: (0, $eHBjM.favoriteAgentTerms).reservedListName,
                        mlsId: currentGroup[0].mlsId
                    },
                    ...currentGroup
                ] : currentGroup;
                return acc;
            }, {});
            (0, $ivaD7.setStateData)("filteredItems", sortedFilteredWithAll, setState);
        }
    }, [
        state.searchText,
        savedGroups,
        state.selectedSortOption
    ]);
    const handleSortChange = (option)=>{
        (0, $ivaD7.setStateData)("selectedSortOption", option, setState);
    };
    const handleSavedSearchLookup = (event)=>{
        (0, $ivaD7.setStateData)("searchText", event.target.value, setState);
    };
    const handleChange = (e, itemId)=>{
        (0, $90ISC.useSearchStore).setState({
            isManualSearch: true
        });
        (0, $ivaD7.setStateData)("selectedItemId", itemId, setState);
        e.preventDefault();
    };
    const SearchIcon = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
        icon: (0, $eOjgM.search),
        className: "align-top mr-1",
        title: "search icon"
    });
    const hasItems = savedGroups && Object.keys(savedGroups).length > 0;
    const GroupSelect = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "py-3",
            style: {
                maxHeight: "450px",
                overflowY: "auto"
            },
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2OwWq.default), {
                children: Object.keys(state?.filteredItems || {}).map((mls, i)=>{
                    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mb-3 mr-2",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($64088e28bcd161d0$exports))), {
                            flush: true,
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h6", {
                                    className: "filter-header",
                                    children: mls
                                }),
                                state.filteredItems[mls].map((item)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $50a64797617f8a2e$export$2e2bcd8739ae039), {
                                        savedItem: item,
                                        handleChange: handleChange,
                                        isSelected: item.id === selectedList?.agentListId || item.id === state.selectedItemId,
                                        editSavedItem: handleOpenEditModal,
                                        getSavedItemName: getSavedItemName,
                                        getSavedItemNotes: getSavedItemNotes,
                                        renderTooltip: renderTooltip,
                                        handleOpenEditModal: handleOpenEditModal
                                    }, item.id))
                            ]
                        })
                    }, i);
                })
            })
        }, selectedModule);
    const NoSearchesFound = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "text-center py-3",
            children: (0, $cstaF.searchTerms).noSearchesFound
        });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            style: {
                width: "346px"
            },
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                    className: "my-3 filter-search-header",
                    children: listTitle
                }),
                hasItems ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "d-flex",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        width: "70%",
                                        marginRight: "3px"
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6Twau))), {
                                        dataLwtId: "InputGroup",
                                        style: {
                                            height: "38px"
                                        },
                                        prependAddonProps: [
                                            {
                                                key: "search-icon",
                                                textProps: {
                                                    children: SearchIcon
                                                }
                                            }
                                        ],
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5txPe))), {
                                            dataLwtId: "saved-search-lookup",
                                            onChange: handleSavedSearchLookup,
                                            placeholder: filterPlaceholder,
                                            value: state.searchText
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        width: "30%"
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4TPr9.default), {
                                        options: sortOptions,
                                        onChange: handleSortChange,
                                        isClearable: false,
                                        isSearchable: false,
                                        defaultValue: state.selectedSortOption || sortOptions[0],
                                        className: "saved-search-sort"
                                    })
                                })
                            ]
                        }),
                        hasItems ? /*#__PURE__*/ (0, $ayMG0.jsx)(GroupSelect, {}) : /*#__PURE__*/ (0, $ayMG0.jsx)(NoSearchesFound, {})
                    ]
                }) : /*#__PURE__*/ (0, $ayMG0.jsx)(NoItemsComponent, {})
            ]
        })
    });
}
$b64b47e6134560c0$export$2e2bcd8739ae039.propTypes = {
    listTitle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    NoItemsComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    module: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    initialSelectedItemId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    toggleEditMode: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    getSavedItemName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    getSavedItemNotes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    renderTooltip: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onSelectItem: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    savedGroups: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    handleOpenEditModal: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    filterPlaceholder: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};


function $efc857cb3705022a$export$2e2bcd8739ae039(props) {
    const { id: id, isDisabled: isDisabled = false, label: label, selectedName: selectedName, currentTitle: currentTitle, listTitle: listTitle, NoItemsComponent: NoItemsComponent, getSavedItemName: getSavedItemName, getSavedItemMls: getSavedItemMls, initialSelectedItemId: initialSelectedItemId, onSelectItem: onSelectItem, savedGroups: savedGroups, toggleEditMode: toggleEditMode, handleOpenEditModal: handleOpenEditModal, togglePopover: togglePopover, isPopoverOpen: isPopoverOpen, renderTooltip: renderTooltip, getSavedItemNotes: getSavedItemNotes, filterPlaceholder: filterPlaceholder } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                icon: (0, $eOjgM.search),
                className: "align-middle mr-2 mb-2",
                title: "search icon"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a4fcb45d9fa84e34$export$2e2bcd8739ae039), {
                id: id,
                isDisabled: isDisabled,
                label: label,
                onClick: togglePopover,
                rightIcon: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                    icon: (0, $eOjgM.chevron_small_down),
                    className: "metrics-arrow-icon"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2afe5e16c747ba36$export$2e2bcd8739ae039), {
                target: id,
                title: currentTitle,
                isPopoverOpen: isPopoverOpen,
                togglePopover: togglePopover,
                selectedName: selectedName,
                isDisabled: isDisabled,
                bodyComponent: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b64b47e6134560c0$export$2e2bcd8739ae039), {
                    listTitle: listTitle,
                    NoItemsComponent: NoItemsComponent,
                    initialSelectedItemId: initialSelectedItemId,
                    getSavedItemName: getSavedItemName,
                    getSavedItemNotes: getSavedItemNotes,
                    getSavedItemMls: getSavedItemMls,
                    onSelectItem: onSelectItem,
                    toggleEditMode: toggleEditMode,
                    savedGroups: savedGroups,
                    handleOpenEditModal: handleOpenEditModal,
                    renderTooltip: renderTooltip,
                    filterPlaceholder: filterPlaceholder
                })
            })
        ]
    });
}
$efc857cb3705022a$export$2e2bcd8739ae039.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    selectedName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    currentTitle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    listTitle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    NoItemsComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    getSavedItemName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    getSavedItemMls: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    initialSelectedItemId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]),
    onSelectItem: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    savedGroups: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    toggleEditMode: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    handleOpenEditModal: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    togglePopover: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    renderTooltip: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    isPopoverOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    getSavedItemNotes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    filterPlaceholder: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};



var $24YIE = parcelRequire("24YIE");

var $jeANf = parcelRequire("jeANf");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
parcelRequire("3lOdM");
var $e155p = parcelRequire("e155p");
parcelRequire("fHiKR");
var $5txPe = parcelRequire("5txPe");
var $kN5vy = parcelRequire("kN5vy");

var $cstaF = parcelRequire("cstaF");
const $73a77ab96c7f7e86$var$EditModalForm = (props)=>{
    const { search: search, updateSavedSearch: updateSavedSearch } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "mx-3",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($e155p))), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kN5vy))), {
                        dataLwtId: "name-search-label",
                        children: (0, $cstaF.searchTerms).searchName
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5txPe))), {
                        dataLwtId: "name-search",
                        defaultValue: search.savedSearch.searchName,
                        onChange: (e)=>updateSavedSearch("searchName", e.target.value.trim()),
                        maxLength: 80,
                        autoFocus: true
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($e155p))), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kN5vy))), {
                        dataLwtId: "notes-search-label",
                        children: (0, $cstaF.searchTerms).searchDescription
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5txPe))), {
                        dataLwtId: "notes-search",
                        placeholder: (0, $cstaF.searchTerms).searchNotesPlaceholder,
                        defaultValue: search.savedSearch.notes,
                        onChange: (e)=>updateSavedSearch("notes", e.target.value.trim()),
                        maxLength: 80
                    })
                ]
            })
        ]
    });
};
$73a77ab96c7f7e86$var$EditModalForm.propTypes = {
    search: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    updateSavedSearch: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};
var $73a77ab96c7f7e86$export$2e2bcd8739ae039 = $73a77ab96c7f7e86$var$EditModalForm;



var $f61ig = parcelRequire("f61ig");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");
parcelRequire("amkL4");
var $3QXz5 = parcelRequire("3QXz5");

var $rMeTm = parcelRequire("rMeTm");

var $cvJqS = parcelRequire("cvJqS");
const $0051a85cda22910e$var$SavedSearchesChip = (props)=>{
    const { disabled: disabled, module: module, hidden: hidden, userId: userId } = props;
    const initialState = {
        isPopoverOpen: false,
        mlsId: undefined,
        savedSearchGroups: undefined,
        isEditMode: false,
        editableSearch: false,
        originalSearch: undefined,
        savedSearch: undefined,
        showOverwriteModal: false
    };
    const [state, setState] = (0, $acw62.useState)({
        ...initialState
    });
    const [showConfirm, setShowConfirm] = (0, $acw62.useState)(false);
    const toggleConfirm = ()=>{
        setShowConfirm(!showConfirm);
    };
    const { savedSearches: savedSearches, getSavedSearchList: getSavedSearchList, selectedSavedSearch: selectedSavedSearch, setIsLoading: setIsLoading, setIsLoadingSearchData: setIsLoadingSearchData, setSelectedSavedSearch: setSelectedSavedSearch, setSearchStatus: setSearchStatus, resetSearchCriteria: resetSearchCriteria, resetPersistedData: resetPersistedData } = (0, $90ISC.useSearchStore)((state)=>({
            savedSearches: state[module]?.savedSearchList,
            getSavedSearchList: state.getSavedSearchList,
            selectedSavedSearch: state[module]?.selectedSavedSearch,
            setIsLoading: state.setIsLoading,
            setIsLoadingSearchData: state.setIsLoadingSearchData,
            setSelectedSavedSearch: state.setSelectedSavedSearch,
            setSearchStatus: state.setSearchStatus,
            resetSearchCriteria: state.resetSearchCriteria,
            resetPersistedData: state.resetPersistedData
        }));
    (0, $57vuM.useCloseChip)(state.isPopoverOpen, setState);
    const { timeIntervals: timeIntervals, accountInfo: accountInfo, marketAreaLists: marketAreaLists, officeLists: officeLists, agentLists: agentLists, mlsProviders: mlsProviders } = (0, $90ISC.useCommonStore)((state)=>({
            timeIntervals: state.timeIntervals,
            accountInfo: state.accountInfo,
            marketAreaLists: state.marketAreaLists,
            officeLists: state.officeLists,
            agentLists: state.agentLists,
            mlsProviders: state.mlsProviders
        }));
    const { setSelectedListByModule: setSelectedListByModule } = (0, $90ISC.useSavedAgentsStore)((state)=>({
            setSelectedListByModule: state.setSelectedListByModule
        }));
    const { tokenInfo: tokenInfo, tokenType: tokenType } = (0, $f6CJ4.useAuthStore)((state)=>({
            tokenInfo: state.tokenInfo,
            tokenType: state.tokenType
        }));
    const ownerId = tokenType && (0, $cghEn.getOwnerIdByTokenInfo)[tokenType](tokenInfo);
    (0, $acw62.useEffect)(()=>{
        if (!module || !ownerId) return;
        const getSavedSearchListAsync = async ()=>{
            await getSavedSearchList(ownerId, module);
        };
        getSavedSearchListAsync();
    }, [
        module,
        ownerId
    ]);
    (0, $acw62.useEffect)(()=>{
        if (savedSearches?.length > 0 && mlsProviders?.length > 0) {
            const savedSearchGroups = savedSearches.reduce((group, ss)=>{
                const getMlsName = (mlsId)=>{
                    return mlsProviders.find((mls)=>mls.mlsId === mlsId)?.shortDescription;
                };
                const key = getMlsName(ss.savedSearch.mlsId);
                if (!key) // Assume if MLS name is not found, user no longer has perms to
                // the MLS, so don't display saved searches for that MLS
                return group;
                if (!group[key]) group[key] = [];
                group[key].push(ss);
                return group;
            }, {});
            (0, $ivaD7.setStateData)("savedSearchGroups", savedSearchGroups, setState);
        }
    }, [
        savedSearches,
        mlsProviders
    ]);
    (0, $acw62.useEffect)(()=>{
        (0, $bxSLe.toggleRunSearchButton)(state.isPopoverOpen);
    }, [
        state.isPopoverOpen
    ]);
    const openEditModal = (savedSearch)=>{
        setState((prevState)=>({
                ...prevState,
                showEditModal: true,
                editableSearch: {
                    ...savedSearch
                },
                originalSearch: {
                    ...savedSearch
                }
            }));
        toggleEditMode();
    };
    const RenderTooltip = (savedSearch)=>{
        return (savedSearch?.savedSearch?.notes?.length > 40 || savedSearch?.savedSearch?.searchName?.length > 40) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $rMeTm.default), {
                target: `saved-search-${savedSearch?.id}-tooltip`,
                autohide: false,
                innerClassName: "saved-search-tooltip",
                boundariesElement: "window",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "text-left",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "w-100",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "font-weight-bold",
                                children: savedSearch?.savedSearch.searchName
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "w-100 saved-search-tooltip-notes",
                            children: savedSearch?.savedSearch.notes
                        })
                    ]
                })
            })
        });
    };
    const togglePopover = ()=>{
        if (!state.isEditMode) (0, $ivaD7.setStateData)("isPopoverOpen", !state.isPopoverOpen, setState);
    };
    const applySearch = async (savedSearchId)=>{
        if (savedSearchId) {
            togglePopover();
            const savedSearch = (0, $chB0Q.default)(savedSearches?.find((ss)=>ss.id === savedSearchId));
            const selectedMls = {
                ...mlsProviders.find((mls)=>mls.mlsId === savedSearch?.savedSearch?.mlsId)
            };
            (0, $90ISC.useSearchStore).setState({
                isManualSearch: true
            });
            setIsLoading(true);
            setIsLoadingSearchData(true);
            setSelectedListByModule(module, undefined);
            await setSelectedSavedSearch({
                search: savedSearch,
                accountId: accountInfo?.id,
                selectedMls: selectedMls,
                timeIntervals: timeIntervals,
                marketAreaLists: marketAreaLists,
                officeLists: officeLists,
                agentLists: agentLists
            });
            setSearchStatus((0, $cstaF.searchStatuses).run);
            resetPersistedData();
        }
    };
    const NoSavedSearches = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "text-center py-3",
            children: "You don\u2019t have any Saved Searches."
        });
    const getSavedSearchName = (search)=>search?.savedSearch?.searchName;
    const getSavedSearchMlsId = (search)=>search?.savedSearch?.mlsId;
    const getSavedItemNotes = (search)=>search?.savedSearch?.notes;
    const toggleEditMode = ()=>{
        // hack to ensure the togglePopover is called before the editMode is changed
        setTimeout(()=>(0, $ivaD7.setStateData)("isEditMode", !state.isEditMode, setState), 1000);
    };
    const toggleEditModal = ()=>{
        (0, $ivaD7.setStateData)("showEditModal", !state.showEditModal, setState);
        toggleEditMode();
    };
    const saveSearch = async ()=>{
        const editableSearch = state.editableSearch;
        const found = savedSearches && savedSearches.find((ss)=>ss.savedSearch.mlsId === state.editableSearch.savedSearch.mlsId && ss.savedSearch.ownerId === userId && ss.savedSearch.searchName.toLowerCase() === state.editableSearch.savedSearch.searchName.toLowerCase());
        if (found) setState((prevState)=>({
                ...prevState,
                showOverwriteModal: true,
                overwriteSearch: found
            }));
        else {
            const response = await (0, $24YIE.updateSavedSearch)(editableSearch);
            if (!response.error) {
                await getSavedSearchList(userId);
                if (selectedSavedSearch?.id === editableSearch.id) {
                    //update the selectedSearch to show the updated name
                    const selectedMls = {
                        ...mlsProviders.find((mls)=>mls.mlsId === editableSearch.savedSearch.mlsId)
                    };
                    await setSelectedSavedSearch({
                        search: editableSearch,
                        selectedMls: selectedMls,
                        timeIntervals: timeIntervals,
                        marketAreaLists: marketAreaLists,
                        officeLists: officeLists,
                        agentLists: agentLists
                    });
                }
                (0, $jeANf.showToast)("success", (0, $cstaF.toastMessages).success.searchSaved, setState);
                toggleEditModal();
            } else (0, $jeANf.showToast)("error", (0, $cstaF.toastMessages).error.saveSearch, setState);
        }
    };
    const updateSearchDetails = (property, value)=>{
        const updatedSavedSearch = {
            ...state.editableSearch.savedSearch,
            [property]: value
        };
        (0, $ivaD7.setStateData)("editableSearch", {
            ...state.editableSearch,
            savedSearch: updatedSavedSearch
        }, setState);
    };
    const overwriteSearchModalHeader = (0, $cstaF.searchTerms).overwriteSearchHeader;
    const handleOverwriteSearch = async ()=>{
        const savedSearch = {
            ...state.overwriteSearch,
            savedSearch: {
                ...state.overwriteSearch.savedSearch,
                mlsIs: state.editableSearch.savedSearch.mlsId,
                searchCriteria: {
                    ...state.editableSearch.savedSearch.searchCriteria
                },
                searchName: state.editableSearch.savedSearch.searchName,
                notes: state.editableSearch.savedSearch.notes
            }
        };
        setState((prevState)=>({
                ...prevState,
                showEditModal: false,
                showOverwriteModal: false
            }));
        const updateResponse = await (0, $24YIE.updateSavedSearch)(savedSearch);
        let deleteResponse;
        if (state.editableSearch.id !== savedSearch.id) deleteResponse = await (0, $24YIE.deleteSavedSearch)(state.editableSearch.id);
        if (!(updateResponse.error && deleteResponse?.error)) {
            await getSavedSearchList(userId);
            const selectedMls = {
                ...mlsProviders.find((mls)=>mls.mlsId === savedSearch.savedSearch.mlsId)
            };
            await setSelectedSavedSearch({
                search: savedSearch,
                selectedMls: selectedMls,
                timeIntervals: timeIntervals,
                marketAreaLists: marketAreaLists,
                officeLists: officeLists,
                agentLists: agentLists
            });
            (0, $jeANf.showToast)("success", (0, $cstaF.toastMessages).success.searchSaved, setState);
            toggleEditModal();
        } else (0, $jeANf.showToast)("error", (0, $cstaF.toastMessages).error.saveSearch, setState);
    };
    const toggleOverwriteModal = ()=>{
        (0, $ivaD7.setStateData)("showOverwriteModal", !state.showOverwriteModal, setState);
    };
    const ConfirmationContent = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "w-100 text-left pl-2 helix-heading",
            children: (0, $cstaF.searchTerms).confirmDelete
        });
    const handleDeleteClick = async ()=>{
        const savedSearch = state.editableSearch;
        const response = await (0, $24YIE.deleteSavedSearch)(savedSearch.id);
        if (!response.error) {
            const filteredKeys = Object.keys(state.savedSearchGroups).filter((mls)=>state.savedSearchGroups[mls].some((ss)=>ss.id !== savedSearch.id));
            const filteredSearches = filteredKeys.reduce((obj, key)=>({
                    ...obj,
                    [key]: state.savedSearchGroups[key].filter((ss)=>ss.id !== savedSearch.id)
                }), {});
            setState((prevState)=>({
                    ...prevState,
                    savedSearchGroups: filteredSearches
                }));
            if (selectedSavedSearch?.id === savedSearch.id) resetSearchCriteria();
            toggleEditModal();
            (0, $ivaD7.setStateData)("isPopoverOpen", false, setState);
            await getSavedSearchList(userId);
        } else (0, $jeANf.showToast)("error", (0, $cstaF.toastMessages).error.deleteSearch);
    };
    const confirmDelete = async ()=>{
        toggleConfirm();
        await handleDeleteClick();
    };
    const ConfirmationModal = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $f61ig.default), {
            title: "Delete Saved Search?",
            show: showConfirm,
            onClose: toggleConfirm,
            buttons: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                        dataLwtId: "cancel",
                        color: "secondary",
                        onClick: toggleConfirm,
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                        dataLwtId: "ok",
                        color: "danger",
                        style: {
                            color: "white"
                        },
                        onClick: confirmDelete,
                        children: "Delete"
                    })
                ]
            }),
            children: /*#__PURE__*/ (0, $ayMG0.jsx)(ConfirmationContent, {})
        });
    return !hidden && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $efc857cb3705022a$export$2e2bcd8739ae039), {
                id: "saved-searches-chip",
                isDisabled: disabled,
                label: (0, $cstaF.searchTerms).savedSearches,
                selectedName: selectedSavedSearch?.savedSearch?.searchName,
                currentTitle: (0, $cstaF.agentProductionTerms).currentSearch,
                listTitle: (0, $cstaF.searchTerms).savedSearches,
                NoItemsComponent: NoSavedSearches,
                getSavedItemName: getSavedSearchName,
                getSavedItemMls: getSavedSearchMlsId,
                getSavedItemNotes: getSavedItemNotes,
                savedGroups: state.savedSearchGroups,
                initialSelectedItemId: selectedSavedSearch?.id,
                onSelectItem: applySearch,
                toggleEditMode: toggleEditMode,
                handleOpenEditModal: openEditModal,
                togglePopover: togglePopover,
                isPopoverOpen: state.isPopoverOpen,
                renderTooltip: RenderTooltip,
                filterPlaceholder: (0, $cstaF.searchTerms).savedItemsFilterPlaceholder
            }),
            state.editableSearch && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f61ig.default), {
                title: "Edit Saved Search",
                show: state.showEditModal,
                onClose: toggleEditModal,
                buttons: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "w-100",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "float-left",
                            style: {
                                width: "30%",
                                padding: "5px 0 5px 10px"
                            },
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                                dataLwtId: `delete-saved-search-${state.editableSearch?.id}`,
                                onClick: toggleConfirm,
                                id: "delete-link",
                                className: "btn-danger",
                                children: (0, $cstaF.buttonTerms).delete
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "float-right",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                                    dataLwtId: "cancel",
                                    color: "secondary",
                                    onClick: toggleEditModal,
                                    children: (0, $cstaF.buttonTerms).cancel
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                                    dataLwtId: "save",
                                    color: "primary",
                                    onClick: saveSearch,
                                    disabled: !state.originalSearch.savedSearch.notes ? !(state.editableSearch.savedSearch.notes && state.editableSearch.savedSearch.notes !== "" || state.originalSearch.savedSearch.searchName !== state.editableSearch.savedSearch.searchName) : !(state.originalSearch.savedSearch.notes !== state.editableSearch.savedSearch.notes || state.originalSearch.savedSearch.searchName !== state.editableSearch.savedSearch.searchName),
                                    children: (0, $cstaF.buttonTerms).save
                                })
                            ]
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $73a77ab96c7f7e86$export$2e2bcd8739ae039), {
                    search: state.editableSearch,
                    updateSavedSearch: updateSearchDetails
                })
            }),
            state.overwriteSearch && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f61ig.default), {
                title: overwriteSearchModalHeader,
                show: state.showOverwriteModal,
                onClose: toggleOverwriteModal,
                buttons: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                            dataLwtId: "cancel",
                            color: "secondary",
                            onClick: toggleOverwriteModal,
                            children: (0, $cstaF.buttonTerms).cancel
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                            dataLwtId: "save",
                            color: "primary",
                            onClick: handleOverwriteSearch,
                            children: (0, $cstaF.buttonTerms).ok
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cvJqS.OverwriteModalContent), {
                    name: state.editableSearch?.savedSearch?.searchName
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)(ConfirmationModal, {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3QXz5))), {
                position: "toast-bottom-right",
                dataLwtId: "save-search-toasts",
                toastProps: state.toastProps
            })
        ]
    });
};
$0051a85cda22910e$var$SavedSearchesChip.propTypes = {
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    module: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    hidden: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    userId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};
var $0051a85cda22910e$export$2e2bcd8739ae039 = $0051a85cda22910e$var$SavedSearchesChip;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $eHBjM = parcelRequire("eHBjM");

var $aypMh = parcelRequire("aypMh");

var $90ISC = parcelRequire("90ISC");


var $ivaD7 = parcelRequire("ivaD7");

var $bwlfW = parcelRequire("bwlfW");

var $3eK9g = parcelRequire("3eK9g");

var $jeANf = parcelRequire("jeANf");

var $cstaF = parcelRequire("cstaF");

var $lMblH = parcelRequire("lMblH");

var $dyffq = parcelRequire("dyffq");

var $57vuM = parcelRequire("57vuM");
const $3455f847ae26db70$var$SavedAgentListsChip = ()=>{
    const savedAgentsModule = (0, $cstaF.modules).proficiencyMetrics.savedAgents;
    const { selectedList: selectedList, closeEditModal: closeEditModal, validateAgentListNameAndSave: validateAgentListNameAndSave, validateSavedSearchAndDelete: validateSavedSearchAndDelete, continueWithSavedSearchesUpdate: continueWithSavedSearchesUpdate, setSelectedListByModule: setSelectedListByModule, resetPersistedData: resetPersistedData } = (0, $90ISC.useSavedAgentsStore)((state)=>({
            selectedList: state.selectedListByModule[savedAgentsModule],
            closeEditModal: state.closeEditModal,
            validateAgentListNameAndSave: state.validateAgentListNameAndSave,
            validateSavedSearchAndDelete: state.validateSavedSearchAndDelete,
            continueWithSavedSearchesUpdate: state.continueWithSavedSearchesUpdate,
            setSelectedListByModule: state.setSelectedListByModule,
            resetPersistedData: state.resetPersistedData
        }));
    const { agentLists: agentLists, mlsProviders: mlsProviders } = (0, $90ISC.useCommonStore)((state)=>({
            agentLists: state.agentLists,
            mlsProviders: state.mlsProviders
        }));
    const [state, setState] = (0, $acw62.useState)({
        isPopoverOpen: false,
        isEditMode: false,
        savedAgentGroups: {},
        showEditModal: false,
        isListModalOpen: false,
        editAgentList: null,
        selectedAgentList: undefined,
        showAffectedSavedSearchesModal: false,
        affectedSavedSearches: [],
        savedSearchesUpdatePrompt: false
    });
    const { searchSelectedListId: searchSelectedListId } = (0, $90ISC.useSearchStore)((state)=>({
            searchSelectedListId: state[state.selectedModule]?.search?.agentListId
        }));
    (0, $57vuM.useCloseChip)(state.isPopoverOpen, setState);
    const setSearchStoreDefaultTitles = ()=>{
        (0, $90ISC.useSearchStore).setState((state)=>({
                [savedAgentsModule]: {
                    ...state[savedAgentsModule],
                    marketAreaTitle: {
                        mainTitle: `${(0, $cstaF.searchTerms).marketArea}: ${(0, $cstaF.searchTerms).lowerAllMls}`
                    },
                    propertyTypeTitle: {
                        mainTitle: (0, $cstaF.searchTerms).allResidential
                    },
                    timeFrameTitle: {
                        mainTitle: (0, $cstaF.agentProductionTerms).last12Months
                    }
                }
            }));
    };
    (0, $acw62.useEffect)(()=>{
        // Execute default search if there's a selected list
        if (selectedList && searchSelectedListId !== selectedList.agentListId && !state.isLoading) // Update titles directly in search store
        setSearchStoreDefaultTitles();
    }, [
        selectedList
    ]);
    (0, $acw62.useEffect)(()=>{
        let savedAgentGroups = {};
        if (!agentLists?.length > 0 && !mlsProviders?.length > 0) {
            (0, $ivaD7.setStateData)("savedAgentGroups", savedAgentGroups, setState);
            return;
        }
        const getMlsName = (mlsId)=>mlsProviders?.find((mls)=>mls.mlsId === mlsId)?.shortDescription;
        savedAgentGroups = agentLists?.reduce((group, ss)=>{
            const key = getMlsName(ss.mlsId);
            if (!key) // Assume if MLS name is not found, user no longer has perms to
            // the MLS, so don't display saved searches for that MLS
            return group;
            if (!group[key]) group[key] = [];
            group[key].push({
                ...ss,
                id: ss.agentListId
            });
            return group;
        }, {});
        (0, $ivaD7.setStateData)("savedAgentGroups", savedAgentGroups, setState);
    }, [
        agentLists,
        mlsProviders
    ]);
    const togglePopover = ()=>{
        if (!state.isEditMode) (0, $ivaD7.setStateData)("isPopoverOpen", !state.isPopoverOpen, setState);
    };
    const setToastProps = (type, message)=>(0, $jeANf.showToast)(type, message, setState);
    let selectedAgentCriteria, selectedSavedSearch, resetSelectedAgentList; // We need to pass them as undefined in the DeleteAction.
    const handleValidateAgentListNameAndSave = (event, list, newName)=>{
        const args = {
            event: event,
            list: list,
            newName: newName,
            mlsId: list.mlsId,
            selectedAgentCriteria: selectedAgentCriteria,
            state: state,
            setState: setState,
            toggleListModal: toggleListModal,
            userId: list.ownerId,
            selectedSavedSearch: selectedSavedSearch,
            showToast: setToastProps
        };
        validateAgentListNameAndSave(args);
    };
    let resetSelectedAgentListTitle; // We need to pass it as undefined in the DeleteAction.
    const toggleListModal = ()=>{
        setState((prevState)=>{
            return {
                ...prevState,
                editAgentList: null,
                showEditModal: !state.showEditModal
            };
        });
    };
    const handleSelect = (listId)=>{
        if (selectedList?.agentListId === listId) return;
        let agentList;
        if (typeof listId === "string" && listId.includes("all-lists-")) {
            const splitListId = listId.split("-");
            if (splitListId.length < 3 || isNaN(parseInt(splitListId[2], 10))) {
                setToastProps({
                    message: "Invalid list ID format.",
                    type: "error"
                });
                return;
            }
            const mlsId = parseInt(listId.split("-")[2], 10);
            const agentIds = agentLists.filter((agent)=>agent.mlsId === mlsId).map((agent)=>agent.agentIds).flat();
            const uniqueAgentIds = [
                ...new Set(agentIds)
            ];
            agentList = {
                agentListId: listId,
                name: (0, $eHBjM.favoriteAgentTerms).reservedListName,
                mlsId: mlsId,
                agentIds: uniqueAgentIds
            };
        } else agentList = agentLists.find((agent)=>agent.agentListId === listId);
        setSelectedListByModule(savedAgentsModule, agentList);
        resetPersistedData();
        // Update titles directly in search store
        setSearchStoreDefaultTitles();
        (0, $90ISC.useSearchStore).setState({
            isManualSearch: false
        });
        togglePopover();
    };
    const handleEdit = (list, e)=>{
        e.stopPropagation();
        setState((prevState)=>{
            return {
                ...prevState,
                editAgentList: list,
                showEditModal: true
            };
        });
    };
    const getSavedAgentName = (item)=>item.name;
    const getSavedAgentMlsId = (item)=>item.mlsId;
    const NoSavedAgents = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "text-center py-3",
            children: (0, $cstaF.searchTerms).noSavedAgentsLists
        });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $efc857cb3705022a$export$2e2bcd8739ae039), {
                id: "saved-agents-chip",
                label: (0, $aypMh.terms).agentLists,
                selectedName: selectedList?.name,
                currentTitle: (0, $eHBjM.popoverTerms).currentList,
                listTitle: (0, $eHBjM.popoverTerms).savedAgentLists,
                NoItemsComponent: NoSavedAgents,
                getSavedItemName: getSavedAgentName,
                getSavedItemMls: getSavedAgentMlsId,
                initialSelectedItemId: selectedList?.agentListId,
                onSelectItem: handleSelect,
                togglePopover: togglePopover,
                isPopoverOpen: state.isPopoverOpen,
                savedGroups: state.savedAgentGroups,
                handleOpenEditModal: handleEdit,
                filterPlaceholder: (0, $cstaF.searchTerms).nameYourList
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dyffq.default), {
                showModal: state.showAffectedSavedSearchesModal,
                onClose: ()=>(0, $ivaD7.setStateData)("showAffectedSavedSearchesModal", false, setState),
                onYes: ()=>continueWithSavedSearchesUpdate(state.selectedAgentList, state.selectedAgentList.ownerId, selectedSavedSearch, resetSelectedAgentList, state, setState, setToastProps, toggleListModal),
                savedSearches: state.affectedSavedSearches,
                list: state.selectedAgentList,
                continuePrompt: state.savedSearchesUpdatePrompt,
                searchType: "Agent"
            }),
            state.editAgentList && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bwlfW.default), {
                closeEditModal: ()=>closeEditModal(setState, toggleListModal),
                modalIsOpen: state.showEditModal,
                initialList: state.editAgentList,
                idProperty: "agentListId",
                onSaveNew: handleValidateAgentListNameAndSave,
                onUpdate: handleValidateAgentListNameAndSave,
                onDelete: (list)=>validateSavedSearchAndDelete(list, state, setState, selectedList.ownerId, setToastProps, toggleListModal, resetSelectedAgentListTitle),
                headerContent: (0, $cstaF.searchTerms).editList
            }, (0, $3eK9g.modalKeys).dropdown),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lMblH.default), {
                toastProps: state.toastProps
            })
        ]
    });
};
var $3455f847ae26db70$export$2e2bcd8739ae039 = $3455f847ae26db70$var$SavedAgentListsChip;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $2Xlz6 = parcelRequire("2Xlz6");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $dI25G = parcelRequire("dI25G");

var $eOjgM = parcelRequire("eOjgM");

var $7ROc5 = parcelRequire("7ROc5");

var $cstaF = parcelRequire("cstaF");

var $ivaD7 = parcelRequire("ivaD7");

var $bxSLe = parcelRequire("bxSLe");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4TPr9 = parcelRequire("4TPr9");

var $dI25G = parcelRequire("dI25G");

var $eOjgM = parcelRequire("eOjgM");

var $cstaF = parcelRequire("cstaF");

const $f3b0a37b39a4da74$var$MLSSelector = (props)=>{
    const { handleSelectChange: handleSelectChange, mlsProviders: mlsProviders, selectedMlsId: selectedMlsId } = props;
    const customFilter = (option, searchText)=>{
        return `${option.data.shortDescription} (${option.data.longDescription})`.toLowerCase().startsWith(searchText.toLowerCase()) || option.data.longDescription.toLowerCase().startsWith(searchText.toLowerCase());
    };
    const getOptionLabel = (option)=>`${option.shortDescription} (${option.longDescription})`;
    const getOptionValue = (option)=>option.mlsId;
    const selectedValue = selectedMlsId && mlsProviders?.find((option)=>option.mlsId === selectedMlsId);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4TPr9.default), {
        placeholder: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                    icon: (0, $eOjgM.search),
                    className: "align-top mr-1",
                    title: "search icon"
                }),
                (0, $cstaF.searchTerms).searchForItem((0, $cstaF.searchTerms).mls)
            ]
        }),
        openMenuOnFocus: true,
        options: mlsProviders,
        getOptionLabel: getOptionLabel,
        getOptionValue: getOptionValue,
        value: selectedValue,
        filterOption: customFilter,
        className: "w-100 mr-2 mb-2",
        onChange: handleSelectChange,
        autoFocus: true,
        isClearable: false,
        components: {
            Input: (0, $6705f228a725a1aa$export$2e2bcd8739ae039)
        }
    });
};
var $f3b0a37b39a4da74$export$2e2bcd8739ae039 = $f3b0a37b39a4da74$var$MLSSelector;



var $90ISC = parcelRequire("90ISC");
const $6f1aeb3f48cc8fb9$var$MLSSearch = (props)=>{
    const { mlsProviders: mlsProviders, initialMlsId: initialMlsId, module: module, togglePopover: togglePopover } = props;
    const timeIntervals = (0, $90ISC.useCommonStore)((state)=>state.timeIntervals);
    const { resetSearchCriteria: resetSearchCriteria, setSelectedMls: setSelectedMls, resetFiltersState: resetFiltersState } = (0, $90ISC.useSearchStore)((state)=>({
            resetSearchCriteria: state.resetSearchCriteria,
            setSelectedMls: state.setSelectedMls,
            resetFiltersState: state.resetFiltersState
        }));
    const { setSelectedListByModule: setSelectedListByModule } = (0, $90ISC.useSavedAgentsStore)((state)=>({
            setSelectedListByModule: state.setSelectedListByModule
        }));
    const handleSelectChange = async (option)=>{
        const newMlsId = parseInt(option.mlsId);
        if (newMlsId !== initialMlsId) {
            togglePopover();
            resetSearchCriteria();
            setSelectedListByModule(module, undefined);
            await setSelectedMls(mlsProviders.find((mls)=>mls.mlsId === newMlsId), module, timeIntervals);
            resetFiltersState();
        }
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: {
            minWidth: "300px"
        },
        children: mlsProviders?.length > 0 ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f3b0a37b39a4da74$export$2e2bcd8739ae039), {
                handleSelectChange: handleSelectChange,
                mlsProviders: mlsProviders,
                selectedMlsId: initialMlsId
            })
        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "text-danger p-2",
            style: {
                whiteSpace: "pre-wrap"
            },
            children: "You don\u2019t have an associated MLS."
        })
    });
};
var $6f1aeb3f48cc8fb9$export$2e2bcd8739ae039 = $6f1aeb3f48cc8fb9$var$MLSSearch;



var $90ISC = parcelRequire("90ISC");

var $57vuM = parcelRequire("57vuM");
const $3cd9af9ffb7cfa9c$var$MLSChip = (props)=>{
    const { disabled: disabled, module: module, selectedMls: selectedMls } = props;
    const initialState = {
        isPopoverOpen: false,
        title: (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).mls),
        selectedMlsId: undefined
    };
    const [state, setState] = (0, $acw62.useState)({
        ...initialState
    });
    const isSavedAgents = module === (0, $cstaF.modules).proficiencyMetrics.savedAgents;
    (0, $57vuM.useCloseChip)(state.isPopoverOpen, setState);
    const mlsProviders = (0, $90ISC.useCommonStore)((state)=>state.mlsProviders);
    (0, $acw62.useEffect)(()=>{
        setState((prevState)=>({
                ...prevState,
                selectedMlsId: selectedMls?.mlsId,
                title: selectedMls?.shortDescription || (0, $cstaF.searchTerms).selectType((0, $cstaF.searchTerms).mls)
            }));
    }, [
        selectedMls
    ]);
    (0, $acw62.useEffect)(()=>{
        (0, $bxSLe.toggleRunSearchButton)(state.isPopoverOpen);
    }, [
        state.isPopoverOpen
    ]);
    const togglePopover = ()=>(0, $ivaD7.setStateData)("isPopoverOpen", !state.isPopoverOpen, setState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                dataLwtId: "mls-chip",
                size: "sm",
                color: "secondary",
                className: "mb-1 text-capitalize",
                id: "mls-chip",
                disabled: isSavedAgents || disabled,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                        icon: (0, $eOjgM.home_chart),
                        ...(0, $7ROc5.chipIconProps),
                        title: "mls icon"
                    }),
                    state.title
                ]
            }),
            mlsProviders?.length !== 1 && /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Xlz6))), {
                innerClassName: "helix-heading",
                target: "mls-chip",
                placement: "bottom",
                size: "auto",
                trigger: "legacy",
                header: (0, $cstaF.searchTerms).mlsProvider,
                isOpen: state.isPopoverOpen,
                toggle: togglePopover,
                body: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6f1aeb3f48cc8fb9$export$2e2bcd8739ae039), {
                    mlsProviders: mlsProviders,
                    initialMlsId: state.selectedMlsId,
                    module: module,
                    togglePopover: togglePopover
                }),
                disabled: disabled,
                ...(0, $bxSLe.popoverModifiers)
            })
        ]
    });
};
$3cd9af9ffb7cfa9c$var$MLSChip.propTypes = {
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    module: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    selectedMls: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $3cd9af9ffb7cfa9c$export$2e2bcd8739ae039 = $3cd9af9ffb7cfa9c$var$MLSChip;



var $cstaF = parcelRequire("cstaF");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $EHEsI = parcelRequire("EHEsI");

var $kfZjc = parcelRequire("kfZjc");

var $f61ig = parcelRequire("f61ig");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");
parcelRequire("fHiKR");
var $5txPe = parcelRequire("5txPe");
var $kN5vy = parcelRequire("kN5vy");
parcelRequire("3lOdM");
var $e155p = parcelRequire("e155p");
parcelRequire("amkL4");
var $3QXz5 = parcelRequire("3QXz5");

var $ivaD7 = parcelRequire("ivaD7");

var $cstaF = parcelRequire("cstaF");

var $24YIE = parcelRequire("24YIE");

var $jeANf = parcelRequire("jeANf");

var $dlZsJ = parcelRequire("dlZsJ");

var $90ISC = parcelRequire("90ISC");

var $f6CJ4 = parcelRequire("f6CJ4");

var $cghEn = parcelRequire("cghEn");

var $cvJqS = parcelRequire("cvJqS");

var $dDBOF = parcelRequire("dDBOF");
const $5ab4ae6902b785e8$var$SaveSearchModal = (props)=>{
    const { disabled: disabled, searchObj: searchObj, userId: userId, module: module } = props;
    const { savedSearchList: savedSearchList, getSavedSearchList: getSavedSearchList, setSelectedSavedSearch: setSelectedSavedSearch, setSearchStatus: setSearchStatus, resetPersistedData: resetPersistedData, loadedSearchCriteria: loadedSearchCriteria } = (0, $90ISC.useSearchStore)((state)=>({
            savedSearchList: state[module]?.savedSearchList,
            getSavedSearchList: state.getSavedSearchList,
            setSelectedSavedSearch: state.setSelectedSavedSearch,
            setSearchStatus: state.setSearchStatus,
            resetPersistedData: state.resetPersistedData,
            loadedSearchCriteria: state[module]?.loadedSearchCriteria
        }));
    const { timeIntervals: timeIntervals, marketAreaLists: marketAreaLists, officeLists: officeLists, agentLists: agentLists, accountInfo: accountInfo, mlsProviders: mlsProviders } = (0, $90ISC.useCommonStore)((state)=>({
            timeIntervals: state.timeIntervals,
            marketAreaLists: state.marketAreaLists,
            officeLists: state.officeLists,
            accountInfo: state.accountInfo,
            agentLists: state.agentLists,
            mlsProviders: state.mlsProviders
        }));
    const { tokenType: tokenType } = (0, $f6CJ4.useAuthStore)(({ tokenType: tokenType })=>({
            tokenType: tokenType
        }));
    const searchNameRef = (0, $acw62.useRef)();
    const [state, setState] = (0, $acw62.useState)({});
    const location = (0, $kfZjc.useLocation)();
    const updateSearch = (e, prop)=>{
        (0, $ivaD7.setStateData)("saveSearch", {
            ...state.saveSearch,
            [prop]: e.target.value.trim()
        }, setState);
    };
    const saveSearchModalHeader = (0, $cstaF.searchTerms).saveSearchHeader;
    const overwriteSearchModalHeader = (0, $cstaF.searchTerms).overwriteSearchHeader;
    const saveSearchModalContent = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "mx-3",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($e155p))), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kN5vy))), {
                        dataLwtId: "name-search-label",
                        children: (0, $cstaF.searchTerms).nameYourSearch
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5txPe))), {
                        dataLwtId: "name-search",
                        placeholder: (0, $cstaF.searchTerms).searchNamePlaceholder,
                        onChange: (e)=>updateSearch(e, "searchName"),
                        innerRef: searchNameRef,
                        maxLength: 80
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($e155p))), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kN5vy))), {
                        dataLwtId: "notes-search-label",
                        children: (0, $cstaF.searchTerms).describeYourSearch
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5txPe))), {
                        dataLwtId: "notes-search",
                        placeholder: (0, $cstaF.searchTerms).searchNotesPlaceholder,
                        onChange: (e)=>updateSearch(e, "notes"),
                        maxLength: 80
                    })
                ]
            })
        ]
    });
    const toggleSaveModal = ()=>{
        setState((prevState)=>({
                ...prevState,
                showSaveModal: !state.showSaveModal,
                saveSearch: undefined
            }));
    };
    const toggleOverwriteModal = ()=>{
        (0, $ivaD7.setStateData)("showOverwriteModal", !state.showOverwriteModal, setState);
    };
    const saveSearch = ()=>{
        const found = savedSearchList?.find((ss)=>ss.savedSearch.mlsId === searchObj.mlsId && ss.savedSearch.ownerId === userId && ss.savedSearch.searchName.toLowerCase() === state.saveSearch.searchName.toLowerCase());
        if (found) setState((prevState)=>({
                ...prevState,
                showOverwriteModal: true,
                overwriteSearch: found,
                search: {
                    ...searchObj,
                    notes: state.saveSearch.notes || ""
                }
            }));
        else {
            const savedSearch = {
                ...searchObj,
                searchName: state.saveSearch.searchName,
                notes: state.saveSearch.notes,
                application: (0, $dDBOF.runningApp),
                module: (0, $dlZsJ.getParentFromValue)((0, $cstaF.modules), module),
                ownerType: (0, $cghEn.ownerTypeByTokenType)[tokenType],
                ownerId: userId,
                isDefault: false,
                representationCriteria: {},
                searchType: location.pathname === (0, $cstaF.moduleRoutes)[module] ? (0, $cstaF.searchTypes)[location.pathname].type : undefined
            };
            toggleSaveModal();
            (0, $24YIE.saveSavedSearch)(savedSearch).then(async (response)=>{
                if (response.id) {
                    await getSavedSearchList(userId);
                    const savedSearchWithId = {
                        id: response.id,
                        savedSearch: {
                            ...savedSearch
                        }
                    };
                    const selectedMls = {
                        ...mlsProviders.find((mls)=>mls.mlsId === savedSearchWithId.savedSearch.mlsId)
                    };
                    const hasRun = loadedSearchCriteria && (0, $EHEsI.default)(searchObj?.searchCriteria?.criteria, loadedSearchCriteria);
                    await setSelectedSavedSearch({
                        search: savedSearchWithId,
                        selectedMls: selectedMls,
                        timeIntervals: timeIntervals,
                        marketAreaLists: marketAreaLists,
                        accountId: accountInfo?.id,
                        officeLists: officeLists,
                        agentLists: agentLists
                    });
                    if (!hasRun) {
                        (0, $90ISC.useSearchStore).setState({
                            isManualSearch: true
                        });
                        setSearchStatus((0, $cstaF.searchStatuses).run);
                        resetPersistedData();
                    }
                    (0, $jeANf.showToast)("success", (0, $cstaF.toastMessages).success.searchSaved, setState);
                } else if (response.error) (0, $jeANf.showToast)("error", (0, $cstaF.toastMessages).error.saveSearch, setState);
            });
        }
    };
    const handleOverwriteSearch = async ()=>{
        const savedSearch = {
            ...state.overwriteSearch,
            savedSearch: {
                ...state.overwriteSearch.savedSearch,
                mlsId: searchObj.mlsId,
                searchCriteria: {
                    ...searchObj.searchCriteria
                },
                searchName: state.saveSearch.searchName,
                notes: state.saveSearch.notes
            }
        };
        setState((prevState)=>({
                ...prevState,
                showSaveModal: false,
                showOverwriteModal: false
            }));
        (0, $24YIE.updateSavedSearch)(savedSearch).then(async (response)=>{
            if (!response.error) {
                await getSavedSearchList(userId);
                const savedSearchWithId = {
                    id: response.id,
                    ...savedSearch
                };
                const selectedMls = {
                    ...mlsProviders.find((mls)=>mls.mlsId === savedSearchWithId.savedSearch.mlsId)
                };
                await setSelectedSavedSearch({
                    search: savedSearchWithId,
                    selectedMls: selectedMls,
                    timeIntervals: timeIntervals,
                    marketAreaLists: marketAreaLists,
                    accountId: accountInfo?.id,
                    officeLists: officeLists,
                    agentLists: agentLists
                });
                (0, $jeANf.showToast)("success", (0, $cstaF.toastMessages).success.searchSaved, setState);
            } else (0, $jeANf.showToast)("error", (0, $cstaF.toastMessages).error.saveSearch, setState);
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                dataLwtId: "toggle-save-search",
                color: "outline-primary",
                size: "sm",
                disabled: disabled,
                onClick: toggleSaveModal,
                children: (0, $cstaF.buttonTerms).save
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f61ig.default), {
                title: saveSearchModalHeader,
                children: saveSearchModalContent,
                show: state.showSaveModal,
                onClose: toggleSaveModal,
                onOpened: ()=>searchNameRef.current?.focus(),
                buttons: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                            dataLwtId: "cancel",
                            color: "secondary",
                            onClick: toggleSaveModal,
                            children: (0, $cstaF.buttonTerms).cancel
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                            dataLwtId: "save",
                            color: "primary",
                            onClick: saveSearch,
                            disabled: !state.saveSearch?.searchName,
                            children: (0, $cstaF.buttonTerms).save
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f61ig.default), {
                title: overwriteSearchModalHeader,
                show: state.showOverwriteModal,
                onClose: toggleOverwriteModal,
                buttons: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                            dataLwtId: "cancel",
                            color: "secondary",
                            onClick: toggleOverwriteModal,
                            children: (0, $cstaF.buttonTerms).cancel
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                            dataLwtId: "save",
                            color: "primary",
                            onClick: handleOverwriteSearch,
                            children: (0, $cstaF.buttonTerms).ok
                        })
                    ]
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cvJqS.OverwriteModalContent), {
                    name: state.saveSearch?.searchName
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3QXz5))), {
                position: "toast-bottom-right",
                dataLwtId: "save-search-toasts",
                toastProps: state.toastProps
            })
        ]
    });
};
$5ab4ae6902b785e8$var$SaveSearchModal.propTypes = {
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    module: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    searchObj: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    userId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};
var $5ab4ae6902b785e8$export$2e2bcd8739ae039 = $5ab4ae6902b785e8$var$SaveSearchModal;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $cstaF = parcelRequire("cstaF");

var $90ISC = parcelRequire("90ISC");
const $e3b0b517236f9b6b$var$RunSearchButton = (props)=>{
    const { disabled: disabled, module: module } = props;
    const { setSearchStatus: setSearchStatus, shouldAgentNameRerunOnLoad: shouldAgentNameRerunOnLoad, setAgentNameRerunOnLoad: setAgentNameRerunOnLoad, resetPersistedData: resetPersistedData } = (0, $90ISC.useSearchStore)((state)=>({
            setSearchStatus: state.setSearchStatus,
            shouldAgentNameRerunOnLoad: state.shouldAgentNameRerunOnLoad,
            setAgentNameRerunOnLoad: state.setAgentNameRerunOnLoad,
            resetPersistedData: state.resetPersistedData
        }));
    const agentNameSearch = (0, $90ISC.useSearchStore)((state)=>state[(0, $cstaF.modules).proficiencyMetrics.agents]);
    const runSearch = async ()=>{
        (0, $90ISC.useSearchStore).setState({
            isManualSearch: true
        });
        setSearchStatus((0, $cstaF.searchStatuses).run);
        resetPersistedData();
    };
    (0, $acw62.useEffect)(()=>{
        if (module !== (0, $cstaF.modules).proficiencyMetrics.agents) return;
        const searchData = agentNameSearch?.search?.searchCriteria?.criteria?.realEstateDatasourceIdsWithFilters[0];
        const hasSearchMlsId = !!agentNameSearch?.search?.mlsId;
        const hasFieldValues = !!searchData?.searchFields[0]?.fieldValues?.length;
        const hasIntervalType = !!agentNameSearch?.search?.searchCriteria?.criteria?.timePeriod?.intervalType;
        const hasIdValues = !!searchData?.idFiltering[0]?.idValues?.length;
        if (hasSearchMlsId && hasFieldValues && hasIntervalType && hasIdValues && shouldAgentNameRerunOnLoad) {
            setSearchStatus((0, $cstaF.searchStatuses).run);
            setAgentNameRerunOnLoad(false);
        }
    }, [
        module
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
        dataLwtId: "run-search",
        color: "primary",
        size: "sm",
        disabled: disabled,
        onClick: runSearch,
        children: (0, $cstaF.buttonTerms).runSearch
    }, module);
};
var $e3b0b517236f9b6b$export$2e2bcd8739ae039 = $e3b0b517236f9b6b$var$RunSearchButton;



var $bxSLe = parcelRequire("bxSLe");

var $kmjbt = parcelRequire("kmjbt");

var $90ISC = parcelRequire("90ISC");

var $f6CJ4 = parcelRequire("f6CJ4");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $cstaF = parcelRequire("cstaF");

var $c9Z8w = parcelRequire("c9Z8w");
const $2f2184a025c15445$var$ClearSearchButton = ({ isDisabled: isDisabled, onClick: onClick })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
        id: "clearSearchButton",
        className: "bg-dark m-0 btn-sm mr-1 downloadBtn mb-1",
        color: "secondary",
        dataLwtId: "clearSearchButton",
        onClick: onClick,
        disabled: isDisabled,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "d-flex align-items-center justify-content-center",
            children: (0, $cstaF.buttonTerms).clearAll
        })
    });
};
$2f2184a025c15445$var$ClearSearchButton.propTypes = {
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};
var $2f2184a025c15445$export$2e2bcd8739ae039 = $2f2184a025c15445$var$ClearSearchButton;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $f61ig = parcelRequire("f61ig");

var $cstaF = parcelRequire("cstaF");

var $90ISC = parcelRequire("90ISC");
const $a97e6eafa5d72d4c$var$ClearAllModal = (props)=>{
    const { shouldShowModal: shouldShowModal, onClose: onClose } = props;
    const { clearAllSearch: clearAllSearch } = (0, $90ISC.useSearchStore)((state)=>({
            clearAllSearch: state.clearAllSearch
        }));
    const handleClearAllSearch = ()=>{
        clearAllSearch();
        onClose();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f61ig.default), {
        title: (0, $cstaF.searchTerms).clearAllSearchTitle,
        show: shouldShowModal,
        onClose: onClose,
        buttons: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                    dataLwtId: "Cancel",
                    color: "secondary",
                    onClick: onClose,
                    children: (0, $cstaF.buttonTerms).cancel
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                    color: "danger",
                    dataLwtId: "clear",
                    onClick: handleClearAllSearch,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "d-flex align-items-center justify-content-center",
                        children: (0, $cstaF.buttonTerms).clearAll
                    })
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
            className: "clear-all-modal-text",
            children: (0, $cstaF.searchTerms).clearAllSearchMessage
        })
    }, "clear-all");
};
var $a97e6eafa5d72d4c$export$2e2bcd8739ae039 = $a97e6eafa5d72d4c$var$ClearAllModal;



var $cghEn = parcelRequire("cghEn");

var $ae040 = parcelRequire("ae040");

var $kLrt8 = parcelRequire("kLrt8");

const $b0b6e0361604aa18$var$VolumeChip = /*#__PURE__*/ (0, $acw62.lazy)(()=>(parcelRequire("eJKtk")));

const $b0b6e0361604aa18$var$UnitsChip = /*#__PURE__*/ (0, $acw62.lazy)(()=>(parcelRequire("baHpn")));

const $b0b6e0361604aa18$var$BedroomsChip = /*#__PURE__*/ (0, $acw62.lazy)(()=>(parcelRequire("5O42q")));

const $b0b6e0361604aa18$var$SoldPriceChip = /*#__PURE__*/ (0, $acw62.lazy)(()=>(parcelRequire("7mGTg")));

const $b0b6e0361604aa18$var$BathroomsChip = /*#__PURE__*/ (0, $acw62.lazy)(()=>(parcelRequire("5vG8Z")));

const $b0b6e0361604aa18$var$OfficesChip = /*#__PURE__*/ (0, $acw62.lazy)(()=>(parcelRequire("3jw3C")));

const $b0b6e0361604aa18$var$AgentsChip = /*#__PURE__*/ (0, $acw62.lazy)(()=>(parcelRequire("hJLnY")));

const $b0b6e0361604aa18$var$LotSizeChip = /*#__PURE__*/ (0, $acw62.lazy)(()=>(parcelRequire("gHp6Y")));

const $b0b6e0361604aa18$var$SquareFootageChip = /*#__PURE__*/ (0, $acw62.lazy)(()=>(parcelRequire("4LgDK")));

const $b0b6e0361604aa18$var$ComparisonSetChip = /*#__PURE__*/ (0, $acw62.lazy)(()=>(parcelRequire("jKOEt")));

const $b0b6e0361604aa18$var$ConstructionTypeChip = /*#__PURE__*/ (0, $acw62.lazy)(()=>(parcelRequire("40bJv")));
const $b0b6e0361604aa18$var$SearchBar = (props)=>{
    const { module: module, mlsProps: mlsProps } = props;
    const { searchFilters: searchFilters, search: search, selectedMls: selectedMls, updateSearchFilters: updateSearchFilters, resetFilter: resetFilter, loadedSearch: loadedSearch, selectedSavedSearch: selectedSavedSearch } = (0, $90ISC.useSearchStore)((state)=>({
            searchFilters: state[module]?.searchFilters,
            search: state[module]?.search,
            selectedMls: module === (0, $cstaF.modules).proficiencyMetrics.suggestedAgents ? state[module]?.searchOptions?.[state[module]?.currentTabId]?.producers?.mls : state[module]?.selectedMls,
            updateSearchFilters: state.updateSearchFilters,
            resetFilter: state.resetFilter,
            loadedSearch: state[module]?.loadedSearchCriteria,
            selectedSavedSearch: state[module]?.selectedSavedSearch
        }), (0, $f3gEZ.shallow));
    const { userInfo: userInfo, membership: membership, menuIsOpen: menuIsOpen } = (0, $90ISC.useCommonStore)((state)=>({
            membership: state.membership,
            menuIsOpen: state.menuIsOpen,
            userInfo: state.userInfo
        }));
    const { tokenInfo: tokenInfo, tokenType: tokenType } = (0, $f6CJ4.useAuthStore)((state)=>({
            tokenInfo: state.tokenInfo,
            tokenType: state.tokenType
        }));
    const { isLoading: isLoading, isLoadingSearchData: isLoadingSearchData, setIsLoadingSearchData: setIsLoadingSearchData } = (0, $90ISC.useSearchStore)((state)=>({
            isLoading: state.isLoading,
            isLoadingSearchData: state[module]?.isLoadingSearchData,
            setIsLoadingSearchData: state.setIsLoadingSearchData
        }));
    const ownerId = tokenType && (0, $cghEn.getOwnerIdByTokenInfo)[tokenType](tokenInfo);
    const isSuggestedAgents = module === (0, $cstaF.modules).proficiencyMetrics.suggestedAgents;
    const isSavedAgents = module === (0, $cstaF.modules).proficiencyMetrics.savedAgents;
    const chips = {
        savedSearches: isSavedAgents ? (0, $3455f847ae26db70$export$2e2bcd8739ae039) : (0, $0051a85cda22910e$export$2e2bcd8739ae039),
        mls: (0, $3cd9af9ffb7cfa9c$export$2e2bcd8739ae039),
        propertyType: (0, $237b412766c74655$export$2e2bcd8739ae039),
        timeFrame: (0, $73b483715bf183b8$export$2e2bcd8739ae039),
        listingStatus: (0, $e2e5378f41681935$export$2e2bcd8739ae039),
        marketArea: (0, $584371c83aa4f220$export$2e2bcd8739ae039),
        areaType: (0, $b7a2194575484e2d$export$2e2bcd8739ae039),
        offices: $b0b6e0361604aa18$var$OfficesChip,
        agents: $b0b6e0361604aa18$var$AgentsChip,
        totalVolume: $b0b6e0361604aa18$var$VolumeChip,
        soldPriceRange: $b0b6e0361604aa18$var$SoldPriceChip,
        priceRange: $b0b6e0361604aa18$var$SoldPriceChip,
        totalUnits: $b0b6e0361604aa18$var$UnitsChip,
        fullBathrooms: $b0b6e0361604aa18$var$BathroomsChip,
        bedrooms: $b0b6e0361604aa18$var$BedroomsChip,
        lotSize: $b0b6e0361604aa18$var$LotSizeChip,
        squareFootage: $b0b6e0361604aa18$var$SquareFootageChip,
        comparisonSet: $b0b6e0361604aa18$var$ComparisonSetChip,
        constructionType: $b0b6e0361604aa18$var$ConstructionTypeChip
    };
    const { savedSearchFilter: savedSearchFilter, mlsFilter: mlsFilter, propTypeFilter: propTypeFilter, timeFrameFilter: timeFrameFilter, marketAreaFilter: marketAreaFilter, areaTypeFilter: areaTypeFilter, listingStatusFilter: listingStatusFilter, agentsFilter: agentsFilter, officesFilter: officesFilter } = (0, $cstaF.searchTerms);
    const staticFilters = [
        savedSearchFilter,
        mlsFilter,
        propTypeFilter,
        timeFrameFilter,
        marketAreaFilter,
        areaTypeFilter,
        listingStatusFilter,
        officesFilter,
        agentsFilter
    ];
    const [filters, setFilters] = (0, $acw62.useState)();
    const [savedSearchIsDirty, setSavedSearchIsDirty] = (0, $acw62.useState)();
    const [isCriteriaFulfilled, setIsCriteriaFulfilled] = (0, $acw62.useState)(false);
    const [loadedSearchCriteria, setLoadedSearchCriteria] = (0, $acw62.useState)();
    const [mlsMembershipInfo, setMlsMembershipInfo] = (0, $acw62.useState)();
    const [isLoadingState, setIsLoadingState] = (0, $acw62.useState)(false);
    const [isClearAllModalShown, setIsClearAllModalShown] = (0, $acw62.useState)(false);
    const featureToggles = (0, $kLrt8.useFeatureToggles)();
    const { hasLoadedComparisonSets: hasLoadedComparisonSets } = (0, $ae040.useComparisonSetsStore)((state)=>({
            hasLoadedComparisonSets: state.hasLoadedComparisonSets
        }));
    (0, $acw62.useEffect)(()=>{
        if (!userInfo) return;
        if (!featureToggles.comparisonSets.isEnabled) return;
        if (hasLoadedComparisonSets) return;
        (0, $ae040.useComparisonSetsStore).getState().getComparisonSetsByUser(userInfo.id);
    }, [
        userInfo,
        featureToggles.comparisonSets.isEnabled,
        hasLoadedComparisonSets
    ]);
    (0, $acw62.useEffect)(()=>{
        setIsLoadingState(isLoading || isLoadingSearchData);
        if (module !== (0, $cstaF.modules).marketShare.totals && module !== (0, $cstaF.modules).marketShare.coverage && !isSuggestedAgents) setIsLoadingSearchData(isLoading);
    }, [
        isLoading,
        isLoadingSearchData
    ]);
    (0, $acw62.useEffect)(()=>{
        if (searchFilters) {
            const filterGroups = (0, $kmjbt.getFilterGroups)({
                isComparisonSetsEnabled: featureToggles.comparisonSets.isEnabled
            });
            const moduleTypeFilters = filterGroups.map((groups)=>groups.filters).reduce((a, b)=>a.concat(b), []).filter((filter)=>filter.modules.includes(module)).map((filter)=>filter.id);
            const currentModuleFilters = searchFilters.filter((filter)=>filter === "savedSearches" || moduleTypeFilters.includes(filter));
            setFilters(currentModuleFilters);
        }
    }, [
        searchFilters,
        featureToggles.comparisonSets.isEnabled
    ]);
    (0, $acw62.useEffect)(()=>{
        if (membership?.length) {
            const currentMlsMembershipInfo = membership?.find((mls)=>mls.mlsId === selectedMls?.mlsId) || [];
            setMlsMembershipInfo(currentMlsMembershipInfo);
        }
    }, [
        membership,
        selectedMls
    ]);
    (0, $acw62.useEffect)(()=>{
        setLoadedSearchCriteria(loadedSearch);
    }, [
        loadedSearch
    ]);
    const toggleFilter = (filter)=>{
        const updatedFilters = [
            ...filters
        ];
        const filterIndex = updatedFilters.indexOf(filter);
        if (filterIndex >= 0) {
            resetFilterByType(filter);
            !staticFilters.includes(filter) && updatedFilters.splice(filterIndex, 1);
        } else updatedFilters.push(filter);
        updateSearchFilters(updatedFilters);
    };
    const resetFilterByType = (filter)=>{
        resetFilter(filter);
    };
    (0, $acw62.useEffect)(()=>{
        let isDirty;
        if (search?.searchCriteria?.criteria) {
            if (!selectedSavedSearch) isDirty = true;
            else isDirty = !(0, $EHEsI.default)(search?.searchCriteria?.criteria, selectedSavedSearch.savedSearch?.searchCriteria?.criteria);
            setSavedSearchIsDirty(isDirty);
        }
    }, [
        search,
        selectedSavedSearch
    ]);
    const enableSearch = !loadedSearchCriteria || !(0, $EHEsI.default)(search?.searchCriteria?.criteria, loadedSearchCriteria);
    (0, $acw62.useEffect)(()=>{
        const hasCriteriaFullFilled = (0, $bxSLe.hasRequiredCriteria)(search, module);
        setIsCriteriaFulfilled(hasCriteriaFullFilled);
        if (hasCriteriaFullFilled) setIsLoadingState(false);
    }, [
        search,
        module
    ]);
    if (isSuggestedAgents) return null;
    const toggleClearAllModal = ()=>{
        setIsClearAllModalShown((prevState)=>!prevState);
    };
    const hasNoAddFilterButton = [
        (0, $cstaF.modules).proficiencyMetrics.suggestedAgents,
        (0, $cstaF.modules).proficiencyMetrics.agentMovement
    ];
    const hasNoClearAllButton = [
        (0, $cstaF.modules).proficiencyMetrics.suggestedAgents,
        (0, $cstaF.modules).proficiencyMetrics.savedAgents
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "bg-white border-bottom px-3 pt-3 pb-2 sticky-top",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                style: {
                    width: "calc(100% - 160px)",
                    float: "left"
                },
                children: [
                    filters && [
                        ...filters
                    ].map((filter)=>{
                        return /*#__PURE__*/ (0, $acw62.createElement)(chips[filter], {
                            key: filter,
                            disabled: isLoadingState || ![
                                (0, $cstaF.searchTerms).savedSearchFilter,
                                (0, $cstaF.searchTerms).mlsFilter
                            ].includes(filter) && !selectedMls,
                            onClose: !staticFilters.includes(filter) ? ()=>toggleFilter(filter) : undefined,
                            module: module,
                            selectedMls: selectedMls,
                            selectedSavedSearch: selectedSavedSearch,
                            mlsMembershipInfo: mlsMembershipInfo,
                            userId: ownerId,
                            mlsProps: mlsProps
                        });
                    }),
                    !hasNoAddFilterButton.includes(module) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4b36c4354132488b$export$2e2bcd8739ae039), {
                            toggleFilter: toggleFilter,
                            disabled: isLoadingState || !selectedMls,
                            searchObj: search,
                            module: module,
                            mlsMembershipInfo: mlsMembershipInfo
                        })
                    }),
                    !hasNoClearAllButton.includes(module) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f2184a025c15445$export$2e2bcd8739ae039), {
                                onClick: toggleClearAllModal,
                                isDisabled: isLoadingState || !selectedMls
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a97e6eafa5d72d4c$export$2e2bcd8739ae039), {
                                shouldShowModal: isClearAllModalShown,
                                onClose: toggleClearAllModal
                            })
                        ]
                    })
                ]
            }),
            !isSuggestedAgents && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("nav", {
                    className: "align-items-center float-right",
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "h-100 align-items-center float-right",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e3b0b517236f9b6b$export$2e2bcd8739ae039), {
                                disabled: !isCriteriaFulfilled || isLoadingState || !enableSearch || menuIsOpen,
                                module: module,
                                selectedSavedSearch: selectedSavedSearch,
                                userId: ownerId
                            }),
                            module !== (0, $cstaF.modules).proficiencyMetrics.savedAgents && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $5ab4ae6902b785e8$export$2e2bcd8739ae039), {
                                disabled: !isCriteriaFulfilled || !savedSearchIsDirty || isLoadingState || menuIsOpen,
                                userId: ownerId,
                                searchObj: {
                                    ...search
                                },
                                module: module
                            })
                        ]
                    })
                })
            })
        ]
    });
};
$b0b6e0361604aa18$var$SearchBar.propTypes = {
    module: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    mlsProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $b0b6e0361604aa18$export$2e2bcd8739ae039 = $b0b6e0361604aa18$var$SearchBar;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $7tOHe = parcelRequire("7tOHe");


var $f61ig = parcelRequire("f61ig");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");
var $c5PmB = parcelRequire("c5PmB");

var $2Xlz6 = parcelRequire("2Xlz6");
parcelRequire("3PprX");
var $90ODN = parcelRequire("90ODN");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("3lOdM");
var $e155p = parcelRequire("e155p");
parcelRequire("fHiKR");
var $1BYDb = parcelRequire("1BYDb");

var $eHBjM = parcelRequire("eHBjM");

var $cstaF = parcelRequire("cstaF");

var $g3CkB = parcelRequire("g3CkB");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
// getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
// find the complete implementation of crypto (msCrypto) on IE11.
var $bdb38c00972e4ce4$var$getRandomValues = typeof crypto != "undefined" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != "undefined" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto);
var $bdb38c00972e4ce4$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
function $bdb38c00972e4ce4$export$2e2bcd8739ae039() {
    if (!$bdb38c00972e4ce4$var$getRandomValues) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    return $bdb38c00972e4ce4$var$getRandomValues($bdb38c00972e4ce4$var$rnds8);
}


/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $4e9cf6818b44ec25$var$byteToHex = [];
for(var $4e9cf6818b44ec25$var$i = 0; $4e9cf6818b44ec25$var$i < 256; ++$4e9cf6818b44ec25$var$i)$4e9cf6818b44ec25$var$byteToHex[$4e9cf6818b44ec25$var$i] = ($4e9cf6818b44ec25$var$i + 0x100).toString(16).substr(1);
function $4e9cf6818b44ec25$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $4e9cf6818b44ec25$var$byteToHex; // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        "-",
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join("");
}
var $4e9cf6818b44ec25$export$2e2bcd8739ae039 = $4e9cf6818b44ec25$var$bytesToUuid;


function $0e33f58df7d6795a$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == "string") {
        buf = options === "binary" ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || (0, $bdb38c00972e4ce4$export$2e2bcd8739ae039))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || (0, $4e9cf6818b44ec25$export$2e2bcd8739ae039)(rnds);
}
var $0e33f58df7d6795a$export$2e2bcd8739ae039 = $0e33f58df7d6795a$var$v4;


function $dc8851251b4817c5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $dc8851251b4817c5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $dc8851251b4817c5$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $dc8851251b4817c5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $dc8851251b4817c5$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $dc8851251b4817c5$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $dc8851251b4817c5$var$_extends() {
    $dc8851251b4817c5$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dc8851251b4817c5$var$_extends.apply(this, arguments);
}
function $dc8851251b4817c5$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $dc8851251b4817c5$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $dc8851251b4817c5$var$ownKeys(Object(source), true).forEach(function(key) {
            $dc8851251b4817c5$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $dc8851251b4817c5$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $dc8851251b4817c5$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $dc8851251b4817c5$var$_setPrototypeOf(subClass, superClass);
}
function $dc8851251b4817c5$var$_getPrototypeOf(o) {
    $dc8851251b4817c5$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $dc8851251b4817c5$var$_getPrototypeOf(o);
}
function $dc8851251b4817c5$var$_setPrototypeOf(o, p) {
    $dc8851251b4817c5$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $dc8851251b4817c5$var$_setPrototypeOf(o, p);
}
function $dc8851251b4817c5$var$_assertThisInitialized(self1) {
    if (self1 === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self1;
}
function $dc8851251b4817c5$var$_possibleConstructorReturn(self1, call) {
    if (call && (typeof call === "object" || typeof call === "function")) return call;
    return $dc8851251b4817c5$var$_assertThisInitialized(self1);
}
var $dc8851251b4817c5$var$CONSTANT = {
    GLOBAL: {
        HIDE: "__react_tooltip_hide_event",
        REBUILD: "__react_tooltip_rebuild_event",
        SHOW: "__react_tooltip_show_event"
    }
};
/**
 * Static methods for react-tooltip
 */ var $dc8851251b4817c5$var$dispatchGlobalEvent = function dispatchGlobalEvent(eventName, opts) {
    // Compatible with IE
    // @see http://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
    // @see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
    var event;
    if (typeof window.CustomEvent === "function") event = new window.CustomEvent(eventName, {
        detail: opts
    });
    else {
        event = document.createEvent("Event");
        event.initEvent(eventName, false, true, opts);
    }
    window.dispatchEvent(event);
};
function $dc8851251b4817c5$var$staticMethods(target) {
    /**
   * Hide all tooltip
   * @trigger ReactTooltip.hide()
   */ target.hide = function(target) {
        $dc8851251b4817c5$var$dispatchGlobalEvent($dc8851251b4817c5$var$CONSTANT.GLOBAL.HIDE, {
            target: target
        });
    };
    /**
   * Rebuild all tooltip
   * @trigger ReactTooltip.rebuild()
   */ target.rebuild = function() {
        $dc8851251b4817c5$var$dispatchGlobalEvent($dc8851251b4817c5$var$CONSTANT.GLOBAL.REBUILD);
    };
    /**
   * Show specific tooltip
   * @trigger ReactTooltip.show()
   */ target.show = function(target) {
        $dc8851251b4817c5$var$dispatchGlobalEvent($dc8851251b4817c5$var$CONSTANT.GLOBAL.SHOW, {
            target: target
        });
    };
    target.prototype.globalRebuild = function() {
        if (this.mount) {
            this.unbindListener();
            this.bindListener();
        }
    };
    target.prototype.globalShow = function(event) {
        if (this.mount) {
            var hasTarget = event && event.detail && event.detail.target && true || false; // Create a fake event, specific show will limit the type to `solid`
            // only `float` type cares e.clientX e.clientY
            this.showTooltip({
                currentTarget: hasTarget && event.detail.target
            }, true);
        }
    };
    target.prototype.globalHide = function(event) {
        if (this.mount) {
            var hasTarget = event && event.detail && event.detail.target && true || false;
            this.hideTooltip({
                currentTarget: hasTarget && event.detail.target
            }, hasTarget);
        }
    };
}
/**
 * Events that should be bound to the window
 */ function $dc8851251b4817c5$var$windowListener(target) {
    target.prototype.bindWindowEvents = function(resizeHide) {
        // ReactTooltip.hide
        window.removeEventListener($dc8851251b4817c5$var$CONSTANT.GLOBAL.HIDE, this.globalHide);
        window.addEventListener($dc8851251b4817c5$var$CONSTANT.GLOBAL.HIDE, this.globalHide, false); // ReactTooltip.rebuild
        window.removeEventListener($dc8851251b4817c5$var$CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
        window.addEventListener($dc8851251b4817c5$var$CONSTANT.GLOBAL.REBUILD, this.globalRebuild, false); // ReactTooltip.show
        window.removeEventListener($dc8851251b4817c5$var$CONSTANT.GLOBAL.SHOW, this.globalShow);
        window.addEventListener($dc8851251b4817c5$var$CONSTANT.GLOBAL.SHOW, this.globalShow, false); // Resize
        if (resizeHide) {
            window.removeEventListener("resize", this.onWindowResize);
            window.addEventListener("resize", this.onWindowResize, false);
        }
    };
    target.prototype.unbindWindowEvents = function() {
        window.removeEventListener($dc8851251b4817c5$var$CONSTANT.GLOBAL.HIDE, this.globalHide);
        window.removeEventListener($dc8851251b4817c5$var$CONSTANT.GLOBAL.REBUILD, this.globalRebuild);
        window.removeEventListener($dc8851251b4817c5$var$CONSTANT.GLOBAL.SHOW, this.globalShow);
        window.removeEventListener("resize", this.onWindowResize);
    };
    /**
   * invoked by resize event of window
   */ target.prototype.onWindowResize = function() {
        if (!this.mount) return;
        this.hideTooltip();
    };
}
/**
 * Custom events to control showing and hiding of tooltip
 *
 * @attributes
 * - `event` {String}
 * - `eventOff` {String}
 */ var $dc8851251b4817c5$var$checkStatus = function checkStatus(dataEventOff, e) {
    var show = this.state.show;
    var id = this.props.id;
    var isCapture = this.isCapture(e.currentTarget);
    var currentItem = e.currentTarget.getAttribute("currentItem");
    if (!isCapture) e.stopPropagation();
    if (show && currentItem === "true") {
        if (!dataEventOff) this.hideTooltip(e);
    } else {
        e.currentTarget.setAttribute("currentItem", "true");
        $dc8851251b4817c5$var$setUntargetItems(e.currentTarget, this.getTargetArray(id));
        this.showTooltip(e);
    }
};
var $dc8851251b4817c5$var$setUntargetItems = function setUntargetItems(currentTarget, targetArray) {
    for(var i = 0; i < targetArray.length; i++)if (currentTarget !== targetArray[i]) targetArray[i].setAttribute("currentItem", "false");
    else targetArray[i].setAttribute("currentItem", "true");
};
var $dc8851251b4817c5$var$customListeners = {
    id: "9b69f92e-d3fe-498b-b1b4-c5e63a51b0cf",
    set: function set(target, event, listener) {
        if (this.id in target) {
            var map = target[this.id];
            map[event] = listener;
        } else // this is workaround for WeakMap, which is not supported in older browsers, such as IE
        Object.defineProperty(target, this.id, {
            configurable: true,
            value: $dc8851251b4817c5$var$_defineProperty({}, event, listener)
        });
    },
    get: function get(target, event) {
        var map = target[this.id];
        if (map !== undefined) return map[event];
    }
};
function $dc8851251b4817c5$var$customEvent(target) {
    target.prototype.isCustomEvent = function(ele) {
        var event = this.state.event;
        return event || !!ele.getAttribute("data-event");
    };
    /* Bind listener for custom event */ target.prototype.customBindListener = function(ele) {
        var _this = this;
        var _this$state = this.state, event = _this$state.event, eventOff = _this$state.eventOff;
        var dataEvent = ele.getAttribute("data-event") || event;
        var dataEventOff = ele.getAttribute("data-event-off") || eventOff;
        dataEvent.split(" ").forEach(function(event) {
            ele.removeEventListener(event, $dc8851251b4817c5$var$customListeners.get(ele, event));
            var customListener = $dc8851251b4817c5$var$checkStatus.bind(_this, dataEventOff);
            $dc8851251b4817c5$var$customListeners.set(ele, event, customListener);
            ele.addEventListener(event, customListener, false);
        });
        if (dataEventOff) dataEventOff.split(" ").forEach(function(event) {
            ele.removeEventListener(event, _this.hideTooltip);
            ele.addEventListener(event, _this.hideTooltip, false);
        });
    };
    /* Unbind listener for custom event */ target.prototype.customUnbindListener = function(ele) {
        var _this$state2 = this.state, event = _this$state2.event, eventOff = _this$state2.eventOff;
        var dataEvent = event || ele.getAttribute("data-event");
        var dataEventOff = eventOff || ele.getAttribute("data-event-off");
        ele.removeEventListener(dataEvent, $dc8851251b4817c5$var$customListeners.get(ele, event));
        if (dataEventOff) ele.removeEventListener(dataEventOff, this.hideTooltip);
    };
}
/**
 * Util method to judge if it should follow capture model
 */ function $dc8851251b4817c5$var$isCapture(target) {
    target.prototype.isCapture = function(currentTarget) {
        return currentTarget && currentTarget.getAttribute("data-iscapture") === "true" || this.props.isCapture || false;
    };
}
/**
 * Util method to get effect
 */ function $dc8851251b4817c5$var$getEffect(target) {
    target.prototype.getEffect = function(currentTarget) {
        var dataEffect = currentTarget.getAttribute("data-effect");
        return dataEffect || this.props.effect || "float";
    };
}
/**
 * Util method to get effect
 */ var $dc8851251b4817c5$var$makeProxy = function makeProxy(e) {
    var proxy = {};
    for(var key in e)if (typeof e[key] === "function") proxy[key] = e[key].bind(e);
    else proxy[key] = e[key];
    return proxy;
};
var $dc8851251b4817c5$var$bodyListener = function bodyListener(callback, options, e) {
    var _options$respectEffec = options.respectEffect, respectEffect = _options$respectEffec === void 0 ? false : _options$respectEffec, _options$customEvent = options.customEvent, customEvent = _options$customEvent === void 0 ? false : _options$customEvent;
    var id = this.props.id;
    var tip = e.target.getAttribute("data-tip") || null;
    var forId = e.target.getAttribute("data-for") || null;
    var target = e.target;
    if (this.isCustomEvent(target) && !customEvent) return;
    var isTargetBelongsToTooltip = id == null && forId == null || forId === id;
    if (tip != null && (!respectEffect || this.getEffect(target) === "float") && isTargetBelongsToTooltip) {
        var proxy = $dc8851251b4817c5$var$makeProxy(e);
        proxy.currentTarget = target;
        callback(proxy);
    }
};
var $dc8851251b4817c5$var$findCustomEvents = function findCustomEvents(targetArray, dataAttribute) {
    var events = {};
    targetArray.forEach(function(target) {
        var event = target.getAttribute(dataAttribute);
        if (event) event.split(" ").forEach(function(event) {
            return events[event] = true;
        });
    });
    return events;
};
var $dc8851251b4817c5$var$getBody = function getBody() {
    return document.getElementsByTagName("body")[0];
};
function $dc8851251b4817c5$var$bodyMode(target) {
    target.prototype.isBodyMode = function() {
        return !!this.props.bodyMode;
    };
    target.prototype.bindBodyListener = function(targetArray) {
        var _this = this;
        var _this$state = this.state, event = _this$state.event, eventOff = _this$state.eventOff, possibleCustomEvents = _this$state.possibleCustomEvents, possibleCustomEventsOff = _this$state.possibleCustomEventsOff;
        var body = $dc8851251b4817c5$var$getBody();
        var customEvents = $dc8851251b4817c5$var$findCustomEvents(targetArray, "data-event");
        var customEventsOff = $dc8851251b4817c5$var$findCustomEvents(targetArray, "data-event-off");
        if (event != null) customEvents[event] = true;
        if (eventOff != null) customEventsOff[eventOff] = true;
        possibleCustomEvents.split(" ").forEach(function(event) {
            return customEvents[event] = true;
        });
        possibleCustomEventsOff.split(" ").forEach(function(event) {
            return customEventsOff[event] = true;
        });
        this.unbindBodyListener(body);
        var listeners = this.bodyModeListeners = {};
        if (event == null) {
            listeners.mouseover = $dc8851251b4817c5$var$bodyListener.bind(this, this.showTooltip, {});
            listeners.mousemove = $dc8851251b4817c5$var$bodyListener.bind(this, this.updateTooltip, {
                respectEffect: true
            });
            listeners.mouseout = $dc8851251b4817c5$var$bodyListener.bind(this, this.hideTooltip, {});
        }
        for(var _event in customEvents)listeners[_event] = $dc8851251b4817c5$var$bodyListener.bind(this, function(e) {
            var targetEventOff = e.currentTarget.getAttribute("data-event-off") || eventOff;
            $dc8851251b4817c5$var$checkStatus.call(_this, targetEventOff, e);
        }, {
            customEvent: true
        });
        for(var _event2 in customEventsOff)listeners[_event2] = $dc8851251b4817c5$var$bodyListener.bind(this, this.hideTooltip, {
            customEvent: true
        });
        for(var _event3 in listeners)body.addEventListener(_event3, listeners[_event3]);
    };
    target.prototype.unbindBodyListener = function(body) {
        body = body || $dc8851251b4817c5$var$getBody();
        var listeners = this.bodyModeListeners;
        for(var event in listeners)body.removeEventListener(event, listeners[event]);
    };
}
/**
 * Tracking target removing from DOM.
 * It's necessary to hide tooltip when it's target disappears.
 * Otherwise, the tooltip would be shown forever until another target
 * is triggered.
 *
 * If MutationObserver is not available, this feature just doesn't work.
 */ // https://hacks.mozilla.org/2012/05/dom-mutationobserver-reacting-to-dom-changes-without-killing-browser-performance/
var $dc8851251b4817c5$var$getMutationObserverClass = function getMutationObserverClass() {
    return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
};
function $dc8851251b4817c5$var$trackRemoval(target) {
    target.prototype.bindRemovalTracker = function() {
        var _this = this;
        var MutationObserver = $dc8851251b4817c5$var$getMutationObserverClass();
        if (MutationObserver == null) return;
        var observer = new MutationObserver(function(mutations) {
            for(var m1 = 0; m1 < mutations.length; m1++){
                var mutation = mutations[m1];
                for(var m2 = 0; m2 < mutation.removedNodes.length; m2++){
                    var element = mutation.removedNodes[m2];
                    if (element === _this.state.currentTarget) {
                        _this.hideTooltip();
                        return;
                    }
                }
            }
        });
        observer.observe(window.document, {
            childList: true,
            subtree: true
        });
        this.removalTracker = observer;
    };
    target.prototype.unbindRemovalTracker = function() {
        if (this.removalTracker) {
            this.removalTracker.disconnect();
            this.removalTracker = null;
        }
    };
}
/**
 * Calculate the position of tooltip
 *
 * @params
 * - `e` {Event} the event of current mouse
 * - `target` {Element} the currentTarget of the event
 * - `node` {DOM} the react-tooltip object
 * - `place` {String} top / right / bottom / left
 * - `effect` {String} float / solid
 * - `offset` {Object} the offset to default position
 *
 * @return {Object}
 * - `isNewState` {Bool} required
 * - `newState` {Object}
 * - `position` {Object} {left: {Number}, top: {Number}}
 */ function $dc8851251b4817c5$var$getPosition(e, target, node, place, desiredPlace, effect, offset) {
    var _getDimensions = $dc8851251b4817c5$var$getDimensions(node), tipWidth = _getDimensions.width, tipHeight = _getDimensions.height;
    var _getDimensions2 = $dc8851251b4817c5$var$getDimensions(target), targetWidth = _getDimensions2.width, targetHeight = _getDimensions2.height;
    var _getCurrentOffset = $dc8851251b4817c5$var$getCurrentOffset(e, target, effect), mouseX = _getCurrentOffset.mouseX, mouseY = _getCurrentOffset.mouseY;
    var defaultOffset = $dc8851251b4817c5$var$getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight);
    var _calculateOffset = $dc8851251b4817c5$var$calculateOffset(offset), extraOffsetX = _calculateOffset.extraOffsetX, extraOffsetY = _calculateOffset.extraOffsetY;
    var windowWidth = window.innerWidth;
    var windowHeight = window.innerHeight;
    var _getParent = $dc8851251b4817c5$var$getParent(node), parentTop = _getParent.parentTop, parentLeft = _getParent.parentLeft; // Get the edge offset of the tooltip
    var getTipOffsetLeft = function getTipOffsetLeft(place) {
        var offsetX = defaultOffset[place].l;
        return mouseX + offsetX + extraOffsetX;
    };
    var getTipOffsetRight = function getTipOffsetRight(place) {
        var offsetX = defaultOffset[place].r;
        return mouseX + offsetX + extraOffsetX;
    };
    var getTipOffsetTop = function getTipOffsetTop(place) {
        var offsetY = defaultOffset[place].t;
        return mouseY + offsetY + extraOffsetY;
    };
    var getTipOffsetBottom = function getTipOffsetBottom(place) {
        var offsetY = defaultOffset[place].b;
        return mouseY + offsetY + extraOffsetY;
    }; //
    // Functions to test whether the tooltip's sides are inside
    // the client window for a given orientation p
    //
    //  _____________
    // |             | <-- Right side
    // | p = 'left'  |\
    // |             |/  |\
    // |_____________|   |_\  <-- Mouse
    //      / \           |
    //       |
    //       |
    //  Bottom side
    //
    var outsideLeft = function outsideLeft(p) {
        return getTipOffsetLeft(p) < 0;
    };
    var outsideRight = function outsideRight(p) {
        return getTipOffsetRight(p) > windowWidth;
    };
    var outsideTop = function outsideTop(p) {
        return getTipOffsetTop(p) < 0;
    };
    var outsideBottom = function outsideBottom(p) {
        return getTipOffsetBottom(p) > windowHeight;
    }; // Check whether the tooltip with orientation p is completely inside the client window
    var outside = function outside(p) {
        return outsideLeft(p) || outsideRight(p) || outsideTop(p) || outsideBottom(p);
    };
    var inside = function inside(p) {
        return !outside(p);
    };
    var placesList = [
        "top",
        "bottom",
        "left",
        "right"
    ];
    var insideList = [];
    for(var i = 0; i < 4; i++){
        var p = placesList[i];
        if (inside(p)) insideList.push(p);
    }
    var isNewState = false;
    var newPlace;
    var shouldUpdatePlace = desiredPlace !== place;
    if (inside(desiredPlace) && shouldUpdatePlace) {
        isNewState = true;
        newPlace = desiredPlace;
    } else if (insideList.length > 0 && outside(desiredPlace) && outside(place)) {
        isNewState = true;
        newPlace = insideList[0];
    }
    if (isNewState) return {
        isNewState: true,
        newState: {
            place: newPlace
        }
    };
    return {
        isNewState: false,
        position: {
            left: parseInt(getTipOffsetLeft(place) - parentLeft, 10),
            top: parseInt(getTipOffsetTop(place) - parentTop, 10)
        }
    };
}
var $dc8851251b4817c5$var$getDimensions = function getDimensions(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), height = _node$getBoundingClie.height, width = _node$getBoundingClie.width;
    return {
        height: parseInt(height, 10),
        width: parseInt(width, 10)
    };
}; // Get current mouse offset
var $dc8851251b4817c5$var$getCurrentOffset = function getCurrentOffset(e, currentTarget, effect) {
    var boundingClientRect = currentTarget.getBoundingClientRect();
    var targetTop = boundingClientRect.top;
    var targetLeft = boundingClientRect.left;
    var _getDimensions3 = $dc8851251b4817c5$var$getDimensions(currentTarget), targetWidth = _getDimensions3.width, targetHeight = _getDimensions3.height;
    if (effect === "float") return {
        mouseX: e.clientX,
        mouseY: e.clientY
    };
    return {
        mouseX: targetLeft + targetWidth / 2,
        mouseY: targetTop + targetHeight / 2
    };
}; // List all possibility of tooltip final offset
// This is useful in judging if it is necessary for tooltip to switch position when out of window
var $dc8851251b4817c5$var$getDefaultPosition = function getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight) {
    var top;
    var right;
    var bottom;
    var left;
    var disToMouse = 3;
    var triangleHeight = 2;
    var cursorHeight = 12; // Optimize for float bottom only, cause the cursor will hide the tooltip
    if (effect === "float") {
        top = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: -(tipHeight + disToMouse + triangleHeight),
            b: -disToMouse
        };
        bottom = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: disToMouse + cursorHeight,
            b: tipHeight + disToMouse + triangleHeight + cursorHeight
        };
        left = {
            l: -(tipWidth + disToMouse + triangleHeight),
            r: -disToMouse,
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
        right = {
            l: disToMouse,
            r: tipWidth + disToMouse + triangleHeight,
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
    } else if (effect === "solid") {
        top = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: -(targetHeight / 2 + tipHeight + triangleHeight),
            b: -(targetHeight / 2)
        };
        bottom = {
            l: -(tipWidth / 2),
            r: tipWidth / 2,
            t: targetHeight / 2,
            b: targetHeight / 2 + tipHeight + triangleHeight
        };
        left = {
            l: -(tipWidth + targetWidth / 2 + triangleHeight),
            r: -(targetWidth / 2),
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
        right = {
            l: targetWidth / 2,
            r: tipWidth + targetWidth / 2 + triangleHeight,
            t: -(tipHeight / 2),
            b: tipHeight / 2
        };
    }
    return {
        top: top,
        bottom: bottom,
        left: left,
        right: right
    };
}; // Consider additional offset into position calculation
var $dc8851251b4817c5$var$calculateOffset = function calculateOffset(offset) {
    var extraOffsetX = 0;
    var extraOffsetY = 0;
    if (Object.prototype.toString.apply(offset) === "[object String]") offset = JSON.parse(offset.toString().replace(/'/g, '"'));
    for(var key in offset){
        if (key === "top") extraOffsetY -= parseInt(offset[key], 10);
        else if (key === "bottom") extraOffsetY += parseInt(offset[key], 10);
        else if (key === "left") extraOffsetX -= parseInt(offset[key], 10);
        else if (key === "right") extraOffsetX += parseInt(offset[key], 10);
    }
    return {
        extraOffsetX: extraOffsetX,
        extraOffsetY: extraOffsetY
    };
}; // Get the offset of the parent elements
var $dc8851251b4817c5$var$getParent = function getParent(currentTarget) {
    var currentParent = currentTarget;
    while(currentParent){
        var computedStyle = window.getComputedStyle(currentParent); // transform and will-change: transform change the containing block
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_Block
        if (computedStyle.getPropertyValue("transform") !== "none" || computedStyle.getPropertyValue("will-change") === "transform") break;
        currentParent = currentParent.parentElement;
    }
    var parentTop = currentParent && currentParent.getBoundingClientRect().top || 0;
    var parentLeft = currentParent && currentParent.getBoundingClientRect().left || 0;
    return {
        parentTop: parentTop,
        parentLeft: parentLeft
    };
};
/**
 * To get the tooltip content
 * it may comes from data-tip or this.props.children
 * it should support multiline
 *
 * @params
 * - `tip` {String} value of data-tip
 * - `children` {ReactElement} this.props.children
 * - `multiline` {Any} could be Bool(true/false) or String('true'/'false')
 *
 * @return
 * - String or react component
 */ function $dc8851251b4817c5$var$getTipContent(tip, children, getContent, multiline) {
    if (children) return children;
    if (getContent !== undefined && getContent !== null) return getContent; // getContent can be 0, '', etc.
    if (getContent === null) return null; // Tip not exist and children is null or undefined
    var regexp = /<br\s*\/?>/;
    if (!multiline || multiline === "false" || !regexp.test(tip)) // No trim(), so that user can keep their input
    return tip;
     // Multiline tooltip content
    return tip.split(regexp).map(function(d, i) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
            key: i,
            className: "multi-line"
        }, d);
    });
}
/**
 * Support aria- and role in ReactTooltip
 *
 * @params props {Object}
 * @return {Object}
 */ function $dc8851251b4817c5$var$parseAria(props) {
    var ariaObj = {};
    Object.keys(props).filter(function(prop) {
        // aria-xxx and role is acceptable
        return /(^aria-\w+$|^role$)/.test(prop);
    }).forEach(function(prop) {
        ariaObj[prop] = props[prop];
    });
    return ariaObj;
}
/**
 * Convert nodelist to array
 * @see https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/core/createArrayFromMixed.js#L24
 * NodeLists are functions in Safari
 */ function $dc8851251b4817c5$var$nodeListToArray(nodeList) {
    var length = nodeList.length;
    if (nodeList.hasOwnProperty) return Array.prototype.slice.call(nodeList);
    return new Array(length).fill().map(function(index) {
        return nodeList[index];
    });
}
function $dc8851251b4817c5$var$generateUUID() {
    return "t" + (0, $0e33f58df7d6795a$export$2e2bcd8739ae039)();
}
var $dc8851251b4817c5$var$baseCss = '.__react_component_tooltip {\n  border-radius: 3px;\n  display: inline-block;\n  font-size: 13px;\n  left: -999em;\n  opacity: 0;\n  padding: 8px 21px;\n  position: fixed;\n  pointer-events: none;\n  transition: opacity 0.3s ease-out;\n  top: -999em;\n  visibility: hidden;\n  z-index: 999;\n}\n.__react_component_tooltip.allow_hover, .__react_component_tooltip.allow_click {\n  pointer-events: auto;\n}\n.__react_component_tooltip::before, .__react_component_tooltip::after {\n  content: "";\n  width: 0;\n  height: 0;\n  position: absolute;\n}\n.__react_component_tooltip.show {\n  opacity: 0.9;\n  margin-top: 0;\n  margin-left: 0;\n  visibility: visible;\n}\n.__react_component_tooltip.place-top::before {\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  bottom: -8px;\n  left: 50%;\n  margin-left: -10px;\n}\n.__react_component_tooltip.place-bottom::before {\n  border-left: 10px solid transparent;\n  border-right: 10px solid transparent;\n  top: -8px;\n  left: 50%;\n  margin-left: -10px;\n}\n.__react_component_tooltip.place-left::before {\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  right: -8px;\n  top: 50%;\n  margin-top: -5px;\n}\n.__react_component_tooltip.place-right::before {\n  border-top: 6px solid transparent;\n  border-bottom: 6px solid transparent;\n  left: -8px;\n  top: 50%;\n  margin-top: -5px;\n}\n.__react_component_tooltip .multi-line {\n  display: block;\n  padding: 2px 0;\n  text-align: center;\n}';
/**
 * Default pop-up style values (text color, background color).
 */ var $dc8851251b4817c5$var$defaultColors = {
    dark: {
        text: "#fff",
        background: "#222",
        border: "transparent",
        arrow: "#222"
    },
    success: {
        text: "#fff",
        background: "#8DC572",
        border: "transparent",
        arrow: "#8DC572"
    },
    warning: {
        text: "#fff",
        background: "#F0AD4E",
        border: "transparent",
        arrow: "#F0AD4E"
    },
    error: {
        text: "#fff",
        background: "#BE6464",
        border: "transparent",
        arrow: "#BE6464"
    },
    info: {
        text: "#fff",
        background: "#337AB7",
        border: "transparent",
        arrow: "#337AB7"
    },
    light: {
        text: "#222",
        background: "#fff",
        border: "transparent",
        arrow: "#fff"
    }
};
function $dc8851251b4817c5$var$getDefaultPopupColors(type) {
    return $dc8851251b4817c5$var$defaultColors[type] ? $dc8851251b4817c5$var$_objectSpread2({}, $dc8851251b4817c5$var$defaultColors[type]) : undefined;
}
/**
 * Generates the specific tooltip style for use on render.
 */ function $dc8851251b4817c5$var$generateTooltipStyle(uuid, customColors, type, hasBorder) {
    return $dc8851251b4817c5$var$generateStyle(uuid, $dc8851251b4817c5$var$getPopupColors(customColors, type, hasBorder));
}
/**
 * Generates the tooltip style rules based on the element-specified "data-type" property.
 */ function $dc8851251b4817c5$var$generateStyle(uuid, colors) {
    var textColor = colors.text;
    var backgroundColor = colors.background;
    var borderColor = colors.border;
    var arrowColor = colors.arrow;
    return "\n  	.".concat(uuid, " {\n	    color: ").concat(textColor, ";\n	    background: ").concat(backgroundColor, ";\n	    border: 1px solid ").concat(borderColor, ";\n  	}\n\n  	.").concat(uuid, ".place-top {\n        margin-top: -10px;\n    }\n    .").concat(uuid, ".place-top::before {\n        border-top: 8px solid ").concat(borderColor, ";\n    }\n    .").concat(uuid, ".place-top::after {\n        border-left: 8px solid transparent;\n        border-right: 8px solid transparent;\n        bottom: -6px;\n        left: 50%;\n        margin-left: -8px;\n        border-top-color: ").concat(arrowColor, ";\n        border-top-style: solid;\n        border-top-width: 6px;\n    }\n\n    .").concat(uuid, ".place-bottom {\n        margin-top: 10px;\n    }\n    .").concat(uuid, ".place-bottom::before {\n        border-bottom: 8px solid ").concat(borderColor, ";\n    }\n    .").concat(uuid, ".place-bottom::after {\n        border-left: 8px solid transparent;\n        border-right: 8px solid transparent;\n        top: -6px;\n        left: 50%;\n        margin-left: -8px;\n        border-bottom-color: ").concat(arrowColor, ";\n        border-bottom-style: solid;\n        border-bottom-width: 6px;\n    }\n\n    .").concat(uuid, ".place-left {\n        margin-left: -10px;\n    }\n    .").concat(uuid, ".place-left::before {\n        border-left: 8px solid ").concat(borderColor, ";\n    }\n    .").concat(uuid, ".place-left::after {\n        border-top: 5px solid transparent;\n        border-bottom: 5px solid transparent;\n        right: -6px;\n        top: 50%;\n        margin-top: -4px;\n        border-left-color: ").concat(arrowColor, ";\n        border-left-style: solid;\n        border-left-width: 6px;\n    }\n\n    .").concat(uuid, ".place-right {\n        margin-left: 10px;\n    }\n    .").concat(uuid, ".place-right::before {\n        border-right: 8px solid ").concat(borderColor, ";\n    }\n    .").concat(uuid, ".place-right::after {\n        border-top: 5px solid transparent;\n        border-bottom: 5px solid transparent;\n        left: -6px;\n        top: 50%;\n        margin-top: -4px;\n        border-right-color: ").concat(arrowColor, ";\n        border-right-style: solid;\n        border-right-width: 6px;\n    }\n  ");
}
function $dc8851251b4817c5$var$getPopupColors(customColors, type, hasBorder) {
    var textColor = customColors.text;
    var backgroundColor = customColors.background;
    var borderColor = customColors.border;
    var arrowColor = customColors.arrow ? customColors.arrow : customColors.background;
    var colors = $dc8851251b4817c5$var$getDefaultPopupColors(type);
    if (textColor) colors.text = textColor;
    if (backgroundColor) colors.background = backgroundColor;
    if (hasBorder) {
        if (borderColor) colors.border = borderColor;
        else colors.border = type === "light" ? "black" : "white";
    }
    if (arrowColor) colors.arrow = arrowColor;
    return colors;
}
var $dc8851251b4817c5$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {};
function $dc8851251b4817c5$var$createCommonjsModule(fn, module) {
    return module = {
        exports: {}
    }, fn(module, module.exports), module.exports;
}
var $dc8851251b4817c5$var$check = function(it) {
    return it && it.Math == Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $dc8851251b4817c5$var$global_1 = // eslint-disable-next-line es/no-global-this -- safe
$dc8851251b4817c5$var$check(typeof globalThis == "object" && globalThis) || $dc8851251b4817c5$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$dc8851251b4817c5$var$check(typeof self == "object" && self) || $dc8851251b4817c5$var$check(typeof $dc8851251b4817c5$var$commonjsGlobal == "object" && $dc8851251b4817c5$var$commonjsGlobal) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();
var $dc8851251b4817c5$var$fails = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};
// Detect IE8's incomplete defineProperty implementation
var $dc8851251b4817c5$var$descriptors = !$dc8851251b4817c5$var$fails(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] != 7;
});
var $dc8851251b4817c5$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $dc8851251b4817c5$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $dc8851251b4817c5$var$NASHORN_BUG = $dc8851251b4817c5$var$getOwnPropertyDescriptor && !$dc8851251b4817c5$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $dc8851251b4817c5$var$f = $dc8851251b4817c5$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $dc8851251b4817c5$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $dc8851251b4817c5$var$$propertyIsEnumerable;
var $dc8851251b4817c5$var$objectPropertyIsEnumerable = {
    f: $dc8851251b4817c5$var$f
};
var $dc8851251b4817c5$var$createPropertyDescriptor = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};
var $dc8851251b4817c5$var$toString = {}.toString;
var $dc8851251b4817c5$var$classofRaw = function(it) {
    return $dc8851251b4817c5$var$toString.call(it).slice(8, -1);
};
var $dc8851251b4817c5$var$split = "".split;
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var $dc8851251b4817c5$var$indexedObject = $dc8851251b4817c5$var$fails(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !Object("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $dc8851251b4817c5$var$classofRaw(it) == "String" ? $dc8851251b4817c5$var$split.call(it, "") : Object(it);
} : Object;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var $dc8851251b4817c5$var$requireObjectCoercible = function(it) {
    if (it == undefined) throw TypeError("Can't call method on " + it);
    return it;
};
// toObject with fallback for non-array-like ES3 strings
var $dc8851251b4817c5$var$toIndexedObject = function(it) {
    return $dc8851251b4817c5$var$indexedObject($dc8851251b4817c5$var$requireObjectCoercible(it));
};
var $dc8851251b4817c5$var$isObject = function(it) {
    return typeof it === "object" ? it !== null : typeof it === "function";
};
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var $dc8851251b4817c5$var$toPrimitive = function(input, PREFERRED_STRING) {
    if (!$dc8851251b4817c5$var$isObject(input)) return input;
    var fn, val;
    if (PREFERRED_STRING && typeof (fn = input.toString) == "function" && !$dc8851251b4817c5$var$isObject(val = fn.call(input))) return val;
    if (typeof (fn = input.valueOf) == "function" && !$dc8851251b4817c5$var$isObject(val = fn.call(input))) return val;
    if (!PREFERRED_STRING && typeof (fn = input.toString) == "function" && !$dc8851251b4817c5$var$isObject(val = fn.call(input))) return val;
    throw TypeError("Can't convert object to primitive value");
};
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var $dc8851251b4817c5$var$toObject = function(argument) {
    return Object($dc8851251b4817c5$var$requireObjectCoercible(argument));
};
var $dc8851251b4817c5$var$hasOwnProperty = {}.hasOwnProperty;
var $dc8851251b4817c5$var$has = function hasOwn(it, key) {
    return $dc8851251b4817c5$var$hasOwnProperty.call($dc8851251b4817c5$var$toObject(it), key);
};
var $dc8851251b4817c5$var$document$1 = $dc8851251b4817c5$var$global_1.document;
// typeof document.createElement is 'object' in old IE
var $dc8851251b4817c5$var$EXISTS = $dc8851251b4817c5$var$isObject($dc8851251b4817c5$var$document$1) && $dc8851251b4817c5$var$isObject($dc8851251b4817c5$var$document$1.createElement);
var $dc8851251b4817c5$var$documentCreateElement = function(it) {
    return $dc8851251b4817c5$var$EXISTS ? $dc8851251b4817c5$var$document$1.createElement(it) : {};
};
// Thank's IE8 for his funny defineProperty
var $dc8851251b4817c5$var$ie8DomDefine = !$dc8851251b4817c5$var$descriptors && !$dc8851251b4817c5$var$fails(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
    return Object.defineProperty($dc8851251b4817c5$var$documentCreateElement("div"), "a", {
        get: function() {
            return 7;
        }
    }).a != 7;
});
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $dc8851251b4817c5$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $dc8851251b4817c5$var$f$1 = $dc8851251b4817c5$var$descriptors ? $dc8851251b4817c5$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $dc8851251b4817c5$var$toIndexedObject(O);
    P = $dc8851251b4817c5$var$toPrimitive(P, true);
    if ($dc8851251b4817c5$var$ie8DomDefine) try {
        return $dc8851251b4817c5$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($dc8851251b4817c5$var$has(O, P)) return $dc8851251b4817c5$var$createPropertyDescriptor(!$dc8851251b4817c5$var$objectPropertyIsEnumerable.f.call(O, P), O[P]);
};
var $dc8851251b4817c5$var$objectGetOwnPropertyDescriptor = {
    f: $dc8851251b4817c5$var$f$1
};
var $dc8851251b4817c5$var$anObject = function(it) {
    if (!$dc8851251b4817c5$var$isObject(it)) throw TypeError(String(it) + " is not an object");
    return it;
};
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $dc8851251b4817c5$var$$defineProperty = Object.defineProperty;
// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $dc8851251b4817c5$var$f$2 = $dc8851251b4817c5$var$descriptors ? $dc8851251b4817c5$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $dc8851251b4817c5$var$anObject(O);
    P = $dc8851251b4817c5$var$toPrimitive(P, true);
    $dc8851251b4817c5$var$anObject(Attributes);
    if ($dc8851251b4817c5$var$ie8DomDefine) try {
        return $dc8851251b4817c5$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};
var $dc8851251b4817c5$var$objectDefineProperty = {
    f: $dc8851251b4817c5$var$f$2
};
var $dc8851251b4817c5$var$createNonEnumerableProperty = $dc8851251b4817c5$var$descriptors ? function(object, key, value) {
    return $dc8851251b4817c5$var$objectDefineProperty.f(object, key, $dc8851251b4817c5$var$createPropertyDescriptor(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};
var $dc8851251b4817c5$var$setGlobal = function(key, value) {
    try {
        $dc8851251b4817c5$var$createNonEnumerableProperty($dc8851251b4817c5$var$global_1, key, value);
    } catch (error) {
        $dc8851251b4817c5$var$global_1[key] = value;
    }
    return value;
};
var $dc8851251b4817c5$var$SHARED = "__core-js_shared__";
var $dc8851251b4817c5$var$store = $dc8851251b4817c5$var$global_1[$dc8851251b4817c5$var$SHARED] || $dc8851251b4817c5$var$setGlobal($dc8851251b4817c5$var$SHARED, {});
var $dc8851251b4817c5$var$sharedStore = $dc8851251b4817c5$var$store;
var $dc8851251b4817c5$var$functionToString = Function.toString;
// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof $dc8851251b4817c5$var$sharedStore.inspectSource != "function") $dc8851251b4817c5$var$sharedStore.inspectSource = function(it) {
    return $dc8851251b4817c5$var$functionToString.call(it);
};
var $dc8851251b4817c5$var$inspectSource = $dc8851251b4817c5$var$sharedStore.inspectSource;
var $dc8851251b4817c5$var$WeakMap = $dc8851251b4817c5$var$global_1.WeakMap;
var $dc8851251b4817c5$var$nativeWeakMap = typeof $dc8851251b4817c5$var$WeakMap === "function" && /native code/.test($dc8851251b4817c5$var$inspectSource($dc8851251b4817c5$var$WeakMap));
var $dc8851251b4817c5$var$shared = $dc8851251b4817c5$var$createCommonjsModule(function(module) {
    (module.exports = function(key, value) {
        return $dc8851251b4817c5$var$sharedStore[key] || ($dc8851251b4817c5$var$sharedStore[key] = value !== undefined ? value : {});
    })("versions", []).push({
        version: "3.12.1",
        mode: "global",
        copyright: "\xa9 2021 Denis Pushkarev (zloirock.ru)"
    });
});
var $dc8851251b4817c5$var$id = 0;
var $dc8851251b4817c5$var$postfix = Math.random();
var $dc8851251b4817c5$var$uid = function(key) {
    return "Symbol(" + String(key === undefined ? "" : key) + ")_" + (++$dc8851251b4817c5$var$id + $dc8851251b4817c5$var$postfix).toString(36);
};
var $dc8851251b4817c5$var$keys = $dc8851251b4817c5$var$shared("keys");
var $dc8851251b4817c5$var$sharedKey = function(key) {
    return $dc8851251b4817c5$var$keys[key] || ($dc8851251b4817c5$var$keys[key] = $dc8851251b4817c5$var$uid(key));
};
var $dc8851251b4817c5$var$hiddenKeys = {};
var $dc8851251b4817c5$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $dc8851251b4817c5$var$WeakMap$1 = $dc8851251b4817c5$var$global_1.WeakMap;
var $dc8851251b4817c5$var$set, $dc8851251b4817c5$var$get, $dc8851251b4817c5$var$has$1;
var $dc8851251b4817c5$var$enforce = function(it) {
    return $dc8851251b4817c5$var$has$1(it) ? $dc8851251b4817c5$var$get(it) : $dc8851251b4817c5$var$set(it, {});
};
var $dc8851251b4817c5$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$dc8851251b4817c5$var$isObject(it) || (state = $dc8851251b4817c5$var$get(it)).type !== TYPE) throw TypeError("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($dc8851251b4817c5$var$nativeWeakMap || $dc8851251b4817c5$var$sharedStore.state) {
    var $dc8851251b4817c5$var$store$1 = $dc8851251b4817c5$var$sharedStore.state || ($dc8851251b4817c5$var$sharedStore.state = new $dc8851251b4817c5$var$WeakMap$1());
    var $dc8851251b4817c5$var$wmget = $dc8851251b4817c5$var$store$1.get;
    var $dc8851251b4817c5$var$wmhas = $dc8851251b4817c5$var$store$1.has;
    var $dc8851251b4817c5$var$wmset = $dc8851251b4817c5$var$store$1.set;
    $dc8851251b4817c5$var$set = function(it, metadata) {
        if ($dc8851251b4817c5$var$wmhas.call($dc8851251b4817c5$var$store$1, it)) throw new TypeError($dc8851251b4817c5$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $dc8851251b4817c5$var$wmset.call($dc8851251b4817c5$var$store$1, it, metadata);
        return metadata;
    };
    $dc8851251b4817c5$var$get = function(it) {
        return $dc8851251b4817c5$var$wmget.call($dc8851251b4817c5$var$store$1, it) || {};
    };
    $dc8851251b4817c5$var$has$1 = function(it) {
        return $dc8851251b4817c5$var$wmhas.call($dc8851251b4817c5$var$store$1, it);
    };
} else {
    var $dc8851251b4817c5$var$STATE = $dc8851251b4817c5$var$sharedKey("state");
    $dc8851251b4817c5$var$hiddenKeys[$dc8851251b4817c5$var$STATE] = true;
    $dc8851251b4817c5$var$set = function(it, metadata) {
        if ($dc8851251b4817c5$var$has(it, $dc8851251b4817c5$var$STATE)) throw new TypeError($dc8851251b4817c5$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $dc8851251b4817c5$var$createNonEnumerableProperty(it, $dc8851251b4817c5$var$STATE, metadata);
        return metadata;
    };
    $dc8851251b4817c5$var$get = function(it) {
        return $dc8851251b4817c5$var$has(it, $dc8851251b4817c5$var$STATE) ? it[$dc8851251b4817c5$var$STATE] : {};
    };
    $dc8851251b4817c5$var$has$1 = function(it) {
        return $dc8851251b4817c5$var$has(it, $dc8851251b4817c5$var$STATE);
    };
}
var $dc8851251b4817c5$var$internalState = {
    set: $dc8851251b4817c5$var$set,
    get: $dc8851251b4817c5$var$get,
    has: $dc8851251b4817c5$var$has$1,
    enforce: $dc8851251b4817c5$var$enforce,
    getterFor: $dc8851251b4817c5$var$getterFor
};
var $dc8851251b4817c5$var$redefine = $dc8851251b4817c5$var$createCommonjsModule(function(module) {
    var getInternalState = $dc8851251b4817c5$var$internalState.get;
    var enforceInternalState = $dc8851251b4817c5$var$internalState.enforce;
    var TEMPLATE = String(String).split("String");
    (module.exports = function(O, key, value, options) {
        var unsafe = options ? !!options.unsafe : false;
        var simple = options ? !!options.enumerable : false;
        var noTargetGet = options ? !!options.noTargetGet : false;
        var state;
        if (typeof value == "function") {
            if (typeof key == "string" && !$dc8851251b4817c5$var$has(value, "name")) $dc8851251b4817c5$var$createNonEnumerableProperty(value, "name", key);
            state = enforceInternalState(value);
            if (!state.source) state.source = TEMPLATE.join(typeof key == "string" ? key : "");
        }
        if (O === $dc8851251b4817c5$var$global_1) {
            if (simple) O[key] = value;
            else $dc8851251b4817c5$var$setGlobal(key, value);
            return;
        } else if (!unsafe) delete O[key];
        else if (!noTargetGet && O[key]) simple = true;
        if (simple) O[key] = value;
        else $dc8851251b4817c5$var$createNonEnumerableProperty(O, key, value);
    // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
    })(Function.prototype, "toString", function toString() {
        return typeof this == "function" && getInternalState(this).source || $dc8851251b4817c5$var$inspectSource(this);
    });
});
var $dc8851251b4817c5$var$path = $dc8851251b4817c5$var$global_1;
var $dc8851251b4817c5$var$aFunction = function(variable) {
    return typeof variable == "function" ? variable : undefined;
};
var $dc8851251b4817c5$var$getBuiltIn = function(namespace, method) {
    return arguments.length < 2 ? $dc8851251b4817c5$var$aFunction($dc8851251b4817c5$var$path[namespace]) || $dc8851251b4817c5$var$aFunction($dc8851251b4817c5$var$global_1[namespace]) : $dc8851251b4817c5$var$path[namespace] && $dc8851251b4817c5$var$path[namespace][method] || $dc8851251b4817c5$var$global_1[namespace] && $dc8851251b4817c5$var$global_1[namespace][method];
};
var $dc8851251b4817c5$var$ceil = Math.ceil;
var $dc8851251b4817c5$var$floor = Math.floor;
// `ToInteger` abstract operation
// https://tc39.es/ecma262/#sec-tointeger
var $dc8851251b4817c5$var$toInteger = function(argument) {
    return isNaN(argument = +argument) ? 0 : (argument > 0 ? $dc8851251b4817c5$var$floor : $dc8851251b4817c5$var$ceil)(argument);
};
var $dc8851251b4817c5$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var $dc8851251b4817c5$var$toLength = function(argument) {
    return argument > 0 ? $dc8851251b4817c5$var$min($dc8851251b4817c5$var$toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};
var $dc8851251b4817c5$var$max = Math.max;
var $dc8851251b4817c5$var$min$1 = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var $dc8851251b4817c5$var$toAbsoluteIndex = function(index, length) {
    var integer = $dc8851251b4817c5$var$toInteger(index);
    return integer < 0 ? $dc8851251b4817c5$var$max(integer + length, 0) : $dc8851251b4817c5$var$min$1(integer, length);
};
// `Array.prototype.{ indexOf, includes }` methods implementation
var $dc8851251b4817c5$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $dc8851251b4817c5$var$toIndexedObject($this);
        var length = $dc8851251b4817c5$var$toLength(O.length);
        var index = $dc8851251b4817c5$var$toAbsoluteIndex(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
var $dc8851251b4817c5$var$arrayIncludes = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $dc8851251b4817c5$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $dc8851251b4817c5$var$createMethod(false)
};
var $dc8851251b4817c5$var$indexOf = $dc8851251b4817c5$var$arrayIncludes.indexOf;
var $dc8851251b4817c5$var$objectKeysInternal = function(object, names) {
    var O = $dc8851251b4817c5$var$toIndexedObject(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$dc8851251b4817c5$var$has($dc8851251b4817c5$var$hiddenKeys, key) && $dc8851251b4817c5$var$has(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($dc8851251b4817c5$var$has(O, key = names[i++])) ~$dc8851251b4817c5$var$indexOf(result, key) || result.push(key);
    return result;
};
// IE8- don't enum bug keys
var $dc8851251b4817c5$var$enumBugKeys = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];
var $dc8851251b4817c5$var$hiddenKeys$1 = $dc8851251b4817c5$var$enumBugKeys.concat("length", "prototype");
// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $dc8851251b4817c5$var$f$3 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $dc8851251b4817c5$var$objectKeysInternal(O, $dc8851251b4817c5$var$hiddenKeys$1);
};
var $dc8851251b4817c5$var$objectGetOwnPropertyNames = {
    f: $dc8851251b4817c5$var$f$3
};
// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $dc8851251b4817c5$var$f$4 = Object.getOwnPropertySymbols;
var $dc8851251b4817c5$var$objectGetOwnPropertySymbols = {
    f: $dc8851251b4817c5$var$f$4
};
// all object keys, includes non-enumerable and symbols
var $dc8851251b4817c5$var$ownKeys$1 = $dc8851251b4817c5$var$getBuiltIn("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $dc8851251b4817c5$var$objectGetOwnPropertyNames.f($dc8851251b4817c5$var$anObject(it));
    var getOwnPropertySymbols = $dc8851251b4817c5$var$objectGetOwnPropertySymbols.f;
    return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};
var $dc8851251b4817c5$var$copyConstructorProperties = function(target, source) {
    var keys = $dc8851251b4817c5$var$ownKeys$1(source);
    var defineProperty = $dc8851251b4817c5$var$objectDefineProperty.f;
    var getOwnPropertyDescriptor = $dc8851251b4817c5$var$objectGetOwnPropertyDescriptor.f;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$dc8851251b4817c5$var$has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};
var $dc8851251b4817c5$var$replacement = /#|\.prototype\./;
var $dc8851251b4817c5$var$isForced = function(feature, detection) {
    var value = $dc8851251b4817c5$var$data[$dc8851251b4817c5$var$normalize(feature)];
    return value == $dc8851251b4817c5$var$POLYFILL ? true : value == $dc8851251b4817c5$var$NATIVE ? false : typeof detection == "function" ? $dc8851251b4817c5$var$fails(detection) : !!detection;
};
var $dc8851251b4817c5$var$normalize = $dc8851251b4817c5$var$isForced.normalize = function(string) {
    return String(string).replace($dc8851251b4817c5$var$replacement, ".").toLowerCase();
};
var $dc8851251b4817c5$var$data = $dc8851251b4817c5$var$isForced.data = {};
var $dc8851251b4817c5$var$NATIVE = $dc8851251b4817c5$var$isForced.NATIVE = "N";
var $dc8851251b4817c5$var$POLYFILL = $dc8851251b4817c5$var$isForced.POLYFILL = "P";
var $dc8851251b4817c5$var$isForced_1 = $dc8851251b4817c5$var$isForced;
var $dc8851251b4817c5$var$getOwnPropertyDescriptor$1 = $dc8851251b4817c5$var$objectGetOwnPropertyDescriptor.f;
/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/ var $dc8851251b4817c5$var$_export = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $dc8851251b4817c5$var$global_1;
    else if (STATIC) target = $dc8851251b4817c5$var$global_1[TARGET] || $dc8851251b4817c5$var$setGlobal(TARGET, {});
    else target = ($dc8851251b4817c5$var$global_1[TARGET] || {}).prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.noTargetGet) {
            descriptor = $dc8851251b4817c5$var$getOwnPropertyDescriptor$1(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $dc8851251b4817c5$var$isForced_1(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty === typeof targetProperty) continue;
            $dc8851251b4817c5$var$copyConstructorProperties(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $dc8851251b4817c5$var$createNonEnumerableProperty(sourceProperty, "sham", true);
        // extend global
        $dc8851251b4817c5$var$redefine(target, key, sourceProperty, options);
    }
};
var $dc8851251b4817c5$var$aFunction$1 = function(it) {
    if (typeof it != "function") throw TypeError(String(it) + " is not a function");
    return it;
};
// optional / simple context binding
var $dc8851251b4817c5$var$functionBindContext = function(fn, that, length) {
    $dc8851251b4817c5$var$aFunction$1(fn);
    if (that === undefined) return fn;
    switch(length){
        case 0:
            return function() {
                return fn.call(that);
            };
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};
// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var $dc8851251b4817c5$var$isArray = Array.isArray || function isArray(arg) {
    return $dc8851251b4817c5$var$classofRaw(arg) == "Array";
};
var $dc8851251b4817c5$var$engineUserAgent = $dc8851251b4817c5$var$getBuiltIn("navigator", "userAgent") || "";
var $dc8851251b4817c5$var$process = $dc8851251b4817c5$var$global_1.process;
var $dc8851251b4817c5$var$versions = $dc8851251b4817c5$var$process && $dc8851251b4817c5$var$process.versions;
var $dc8851251b4817c5$var$v8 = $dc8851251b4817c5$var$versions && $dc8851251b4817c5$var$versions.v8;
var $dc8851251b4817c5$var$match, $dc8851251b4817c5$var$version;
if ($dc8851251b4817c5$var$v8) {
    $dc8851251b4817c5$var$match = $dc8851251b4817c5$var$v8.split(".");
    $dc8851251b4817c5$var$version = $dc8851251b4817c5$var$match[0] < 4 ? 1 : $dc8851251b4817c5$var$match[0] + $dc8851251b4817c5$var$match[1];
} else if ($dc8851251b4817c5$var$engineUserAgent) {
    $dc8851251b4817c5$var$match = $dc8851251b4817c5$var$engineUserAgent.match(/Edge\/(\d+)/);
    if (!$dc8851251b4817c5$var$match || $dc8851251b4817c5$var$match[1] >= 74) {
        $dc8851251b4817c5$var$match = $dc8851251b4817c5$var$engineUserAgent.match(/Chrome\/(\d+)/);
        if ($dc8851251b4817c5$var$match) $dc8851251b4817c5$var$version = $dc8851251b4817c5$var$match[1];
    }
}
var $dc8851251b4817c5$var$engineV8Version = $dc8851251b4817c5$var$version && +$dc8851251b4817c5$var$version;
/* eslint-disable es/no-symbol -- required for testing */ // eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var $dc8851251b4817c5$var$nativeSymbol = !!Object.getOwnPropertySymbols && !$dc8851251b4817c5$var$fails(function() {
    return !String(Symbol()) || // Chrome 38 Symbol has incorrect toString conversion
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $dc8851251b4817c5$var$engineV8Version && $dc8851251b4817c5$var$engineV8Version < 41;
});
/* eslint-disable es/no-symbol -- required for testing */ var $dc8851251b4817c5$var$useSymbolAsUid = $dc8851251b4817c5$var$nativeSymbol && !Symbol.sham && typeof Symbol.iterator == "symbol";
var $dc8851251b4817c5$var$WellKnownSymbolsStore = $dc8851251b4817c5$var$shared("wks");
var $dc8851251b4817c5$var$Symbol$1 = $dc8851251b4817c5$var$global_1.Symbol;
var $dc8851251b4817c5$var$createWellKnownSymbol = $dc8851251b4817c5$var$useSymbolAsUid ? $dc8851251b4817c5$var$Symbol$1 : $dc8851251b4817c5$var$Symbol$1 && $dc8851251b4817c5$var$Symbol$1.withoutSetter || $dc8851251b4817c5$var$uid;
var $dc8851251b4817c5$var$wellKnownSymbol = function(name) {
    if (!$dc8851251b4817c5$var$has($dc8851251b4817c5$var$WellKnownSymbolsStore, name) || !($dc8851251b4817c5$var$nativeSymbol || typeof $dc8851251b4817c5$var$WellKnownSymbolsStore[name] == "string")) {
        if ($dc8851251b4817c5$var$nativeSymbol && $dc8851251b4817c5$var$has($dc8851251b4817c5$var$Symbol$1, name)) $dc8851251b4817c5$var$WellKnownSymbolsStore[name] = $dc8851251b4817c5$var$Symbol$1[name];
        else $dc8851251b4817c5$var$WellKnownSymbolsStore[name] = $dc8851251b4817c5$var$createWellKnownSymbol("Symbol." + name);
    }
    return $dc8851251b4817c5$var$WellKnownSymbolsStore[name];
};
var $dc8851251b4817c5$var$SPECIES = $dc8851251b4817c5$var$wellKnownSymbol("species");
// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var $dc8851251b4817c5$var$arraySpeciesCreate = function(originalArray, length) {
    var C;
    if ($dc8851251b4817c5$var$isArray(originalArray)) {
        C = originalArray.constructor;
        // cross-realm fallback
        if (typeof C == "function" && (C === Array || $dc8851251b4817c5$var$isArray(C.prototype))) C = undefined;
        else if ($dc8851251b4817c5$var$isObject(C)) {
            C = C[$dc8851251b4817c5$var$SPECIES];
            if (C === null) C = undefined;
        }
    }
    return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};
var $dc8851251b4817c5$var$push = [].push;
// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterOut }` methods implementation
var $dc8851251b4817c5$var$createMethod$1 = function(TYPE) {
    var IS_MAP = TYPE == 1;
    var IS_FILTER = TYPE == 2;
    var IS_SOME = TYPE == 3;
    var IS_EVERY = TYPE == 4;
    var IS_FIND_INDEX = TYPE == 6;
    var IS_FILTER_OUT = TYPE == 7;
    var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
    return function($this, callbackfn, that, specificCreate) {
        var O = $dc8851251b4817c5$var$toObject($this);
        var self1 = $dc8851251b4817c5$var$indexedObject(O);
        var boundFunction = $dc8851251b4817c5$var$functionBindContext(callbackfn, that, 3);
        var length = $dc8851251b4817c5$var$toLength(self1.length);
        var index = 0;
        var create = specificCreate || $dc8851251b4817c5$var$arraySpeciesCreate;
        var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_OUT ? create($this, 0) : undefined;
        var value, result;
        for(; length > index; index++)if (NO_HOLES || index in self1) {
            value = self1[index];
            result = boundFunction(value, index, O);
            if (TYPE) {
                if (IS_MAP) target[index] = result; // map
                else if (result) switch(TYPE){
                    case 3:
                        return true; // some
                    case 5:
                        return value; // find
                    case 6:
                        return index; // findIndex
                    case 2:
                        $dc8851251b4817c5$var$push.call(target, value); // filter
                }
                else switch(TYPE){
                    case 4:
                        return false; // every
                    case 7:
                        $dc8851251b4817c5$var$push.call(target, value); // filterOut
                }
            }
        }
        return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
    };
};
var $dc8851251b4817c5$var$arrayIteration = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: $dc8851251b4817c5$var$createMethod$1(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: $dc8851251b4817c5$var$createMethod$1(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: $dc8851251b4817c5$var$createMethod$1(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: $dc8851251b4817c5$var$createMethod$1(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: $dc8851251b4817c5$var$createMethod$1(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: $dc8851251b4817c5$var$createMethod$1(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: $dc8851251b4817c5$var$createMethod$1(6),
    // `Array.prototype.filterOut` method
    // https://github.com/tc39/proposal-array-filtering
    filterOut: $dc8851251b4817c5$var$createMethod$1(7)
};
// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var $dc8851251b4817c5$var$objectKeys = Object.keys || function keys(O) {
    return $dc8851251b4817c5$var$objectKeysInternal(O, $dc8851251b4817c5$var$enumBugKeys);
};
// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var $dc8851251b4817c5$var$objectDefineProperties = $dc8851251b4817c5$var$descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
    $dc8851251b4817c5$var$anObject(O);
    var keys = $dc8851251b4817c5$var$objectKeys(Properties);
    var length = keys.length;
    var index = 0;
    var key;
    while(length > index)$dc8851251b4817c5$var$objectDefineProperty.f(O, key = keys[index++], Properties[key]);
    return O;
};
var $dc8851251b4817c5$var$html = $dc8851251b4817c5$var$getBuiltIn("document", "documentElement");
var $dc8851251b4817c5$var$GT = ">";
var $dc8851251b4817c5$var$LT = "<";
var $dc8851251b4817c5$var$PROTOTYPE = "prototype";
var $dc8851251b4817c5$var$SCRIPT = "script";
var $dc8851251b4817c5$var$IE_PROTO = $dc8851251b4817c5$var$sharedKey("IE_PROTO");
var $dc8851251b4817c5$var$EmptyConstructor = function() {};
var $dc8851251b4817c5$var$scriptTag = function(content) {
    return $dc8851251b4817c5$var$LT + $dc8851251b4817c5$var$SCRIPT + $dc8851251b4817c5$var$GT + content + $dc8851251b4817c5$var$LT + "/" + $dc8851251b4817c5$var$SCRIPT + $dc8851251b4817c5$var$GT;
};
// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var $dc8851251b4817c5$var$NullProtoObjectViaActiveX = function(activeXDocument) {
    activeXDocument.write($dc8851251b4817c5$var$scriptTag(""));
    activeXDocument.close();
    var temp = activeXDocument.parentWindow.Object;
    activeXDocument = null; // avoid memory leak
    return temp;
};
// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $dc8851251b4817c5$var$NullProtoObjectViaIFrame = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = $dc8851251b4817c5$var$documentCreateElement("iframe");
    var JS = "java" + $dc8851251b4817c5$var$SCRIPT + ":";
    var iframeDocument;
    iframe.style.display = "none";
    $dc8851251b4817c5$var$html.appendChild(iframe);
    // https://github.com/zloirock/core-js/issues/475
    iframe.src = String(JS);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write($dc8851251b4817c5$var$scriptTag("document.F=Object"));
    iframeDocument.close();
    return iframeDocument.F;
};
// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var $dc8851251b4817c5$var$activeXDocument;
var $dc8851251b4817c5$var$NullProtoObject = function() {
    try {
        /* global ActiveXObject -- old IE */ $dc8851251b4817c5$var$activeXDocument = document.domain && new ActiveXObject("htmlfile");
    } catch (error) {}
    $dc8851251b4817c5$var$NullProtoObject = $dc8851251b4817c5$var$activeXDocument ? $dc8851251b4817c5$var$NullProtoObjectViaActiveX($dc8851251b4817c5$var$activeXDocument) : $dc8851251b4817c5$var$NullProtoObjectViaIFrame();
    var length = $dc8851251b4817c5$var$enumBugKeys.length;
    while(length--)delete $dc8851251b4817c5$var$NullProtoObject[$dc8851251b4817c5$var$PROTOTYPE][$dc8851251b4817c5$var$enumBugKeys[length]];
    return $dc8851251b4817c5$var$NullProtoObject();
};
$dc8851251b4817c5$var$hiddenKeys[$dc8851251b4817c5$var$IE_PROTO] = true;
// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
var $dc8851251b4817c5$var$objectCreate = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $dc8851251b4817c5$var$EmptyConstructor[$dc8851251b4817c5$var$PROTOTYPE] = $dc8851251b4817c5$var$anObject(O);
        result = new $dc8851251b4817c5$var$EmptyConstructor();
        $dc8851251b4817c5$var$EmptyConstructor[$dc8851251b4817c5$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$dc8851251b4817c5$var$IE_PROTO] = O;
    } else result = $dc8851251b4817c5$var$NullProtoObject();
    return Properties === undefined ? result : $dc8851251b4817c5$var$objectDefineProperties(result, Properties);
};
var $dc8851251b4817c5$var$UNSCOPABLES = $dc8851251b4817c5$var$wellKnownSymbol("unscopables");
var $dc8851251b4817c5$var$ArrayPrototype = Array.prototype;
// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if ($dc8851251b4817c5$var$ArrayPrototype[$dc8851251b4817c5$var$UNSCOPABLES] == undefined) $dc8851251b4817c5$var$objectDefineProperty.f($dc8851251b4817c5$var$ArrayPrototype, $dc8851251b4817c5$var$UNSCOPABLES, {
    configurable: true,
    value: $dc8851251b4817c5$var$objectCreate(null)
});
// add a key to Array.prototype[@@unscopables]
var $dc8851251b4817c5$var$addToUnscopables = function(key) {
    $dc8851251b4817c5$var$ArrayPrototype[$dc8851251b4817c5$var$UNSCOPABLES][key] = true;
};
var $dc8851251b4817c5$var$$find = $dc8851251b4817c5$var$arrayIteration.find;
var $dc8851251b4817c5$var$FIND = "find";
var $dc8851251b4817c5$var$SKIPS_HOLES = true;
// Shouldn't skip holes
if ($dc8851251b4817c5$var$FIND in []) Array(1)[$dc8851251b4817c5$var$FIND](function() {
    $dc8851251b4817c5$var$SKIPS_HOLES = false;
});
// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$dc8851251b4817c5$var$_export({
    target: "Array",
    proto: true,
    forced: $dc8851251b4817c5$var$SKIPS_HOLES
}, {
    find: function find(callbackfn /* , that = undefined */ ) {
        return $dc8851251b4817c5$var$$find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    }
});
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
$dc8851251b4817c5$var$addToUnscopables($dc8851251b4817c5$var$FIND);
var $dc8851251b4817c5$var$_class, $dc8851251b4817c5$var$_class2, $dc8851251b4817c5$var$_temp;
var $dc8851251b4817c5$var$ReactTooltip = $dc8851251b4817c5$var$staticMethods($dc8851251b4817c5$var$_class = $dc8851251b4817c5$var$windowListener($dc8851251b4817c5$var$_class = $dc8851251b4817c5$var$customEvent($dc8851251b4817c5$var$_class = $dc8851251b4817c5$var$isCapture($dc8851251b4817c5$var$_class = $dc8851251b4817c5$var$getEffect($dc8851251b4817c5$var$_class = $dc8851251b4817c5$var$bodyMode($dc8851251b4817c5$var$_class = $dc8851251b4817c5$var$trackRemoval($dc8851251b4817c5$var$_class = ($dc8851251b4817c5$var$_temp = $dc8851251b4817c5$var$_class2 = /*#__PURE__*/ function(_React$Component) {
    $dc8851251b4817c5$var$_inherits(ReactTooltip, _React$Component);
    $dc8851251b4817c5$var$_createClass(ReactTooltip, null, [
        {
            key: "propTypes",
            get: function get() {
                return {
                    uuid: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
                    place: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    type: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    effect: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    offset: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
                    multiline: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
                    border: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
                    textColor: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    borderColor: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    arrowColor: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    insecure: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
                    "class": (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    html: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
                    delayHide: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
                    delayUpdate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
                    delayShow: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
                    event: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    eventOff: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    isCapture: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
                    globalEventOff: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    getContent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
                    afterShow: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
                    afterHide: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
                    overridePosition: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
                    disable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
                    scrollHide: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
                    resizeHide: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
                    wrapper: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    bodyMode: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
                    possibleCustomEvents: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    possibleCustomEventsOff: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
                    clickable: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
                };
            }
        }
    ]);
    function ReactTooltip(props) {
        var _this;
        $dc8851251b4817c5$var$_classCallCheck(this, ReactTooltip);
        _this = $dc8851251b4817c5$var$_possibleConstructorReturn(this, $dc8851251b4817c5$var$_getPrototypeOf(ReactTooltip).call(this, props));
        _this.state = {
            uuid: props.uuid || $dc8851251b4817c5$var$generateUUID(),
            place: props.place || "top",
            // Direction of tooltip
            desiredPlace: props.place || "top",
            type: "dark",
            // Color theme of tooltip
            effect: "float",
            // float or fixed
            show: false,
            border: false,
            customColors: {},
            offset: {},
            extraClass: "",
            html: false,
            delayHide: 0,
            delayShow: 0,
            event: props.event || null,
            eventOff: props.eventOff || null,
            currentEvent: null,
            // Current mouse event
            currentTarget: null,
            // Current target of mouse event
            ariaProps: $dc8851251b4817c5$var$parseAria(props),
            // aria- and role attributes
            isEmptyTip: false,
            disable: false,
            possibleCustomEvents: props.possibleCustomEvents || "",
            possibleCustomEventsOff: props.possibleCustomEventsOff || "",
            originTooltip: null,
            isMultiline: false
        };
        _this.bind([
            "showTooltip",
            "updateTooltip",
            "hideTooltip",
            "hideTooltipOnScroll",
            "getTooltipContent",
            "globalRebuild",
            "globalShow",
            "globalHide",
            "onWindowResize",
            "mouseOnToolTip"
        ]);
        _this.mount = true;
        _this.delayShowLoop = null;
        _this.delayHideLoop = null;
        _this.delayReshow = null;
        _this.intervalUpdateContent = null;
        return _this;
    }
    /**
   * For unify the bind and unbind listener
   */ $dc8851251b4817c5$var$_createClass(ReactTooltip, [
        {
            key: "bind",
            value: function bind(methodArray) {
                var _this2 = this;
                methodArray.forEach(function(method) {
                    _this2[method] = _this2[method].bind(_this2);
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props = this.props, insecure = _this$props.insecure, resizeHide = _this$props.resizeHide;
                this.bindListener(); // Bind listener for tooltip
                this.bindWindowEvents(resizeHide); // Bind global event for static method
                this.injectStyles(); // Inject styles for each DOM root having tooltip.
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mount = false;
                this.clearTimer();
                this.unbindListener();
                this.removeScrollListener(this.state.currentTarget);
                this.unbindWindowEvents();
            }
        },
        {
            key: "injectStyles",
            value: function injectStyles() {
                var tooltipRef = this.tooltipRef;
                if (!tooltipRef) return;
                var parentNode = tooltipRef.parentNode;
                while(parentNode.parentNode)parentNode = parentNode.parentNode;
                var domRoot;
                switch(parentNode.constructor.name){
                    case "Document":
                    case "HTMLDocument":
                    case undefined:
                        domRoot = parentNode.head;
                        break;
                    case "ShadowRoot":
                    default:
                        domRoot = parentNode;
                        break;
                } // Prevent styles duplication.
                if (!domRoot.querySelector("style[data-react-tooltip]")) {
                    var style = document.createElement("style");
                    style.textContent = $dc8851251b4817c5$var$baseCss;
                    style.setAttribute("data-react-tooltip", "true");
                    domRoot.appendChild(style);
                }
            }
        },
        {
            key: "mouseOnToolTip",
            value: function mouseOnToolTip() {
                var show = this.state.show;
                if (show && this.tooltipRef) {
                    /* old IE or Firefox work around */ if (!this.tooltipRef.matches) {
                        /* old IE work around */ if (this.tooltipRef.msMatchesSelector) this.tooltipRef.matches = this.tooltipRef.msMatchesSelector;
                        else /* old Firefox work around */ this.tooltipRef.matches = this.tooltipRef.mozMatchesSelector;
                    }
                    return this.tooltipRef.matches(":hover");
                }
                return false;
            }
        },
        {
            key: "getTargetArray",
            value: function getTargetArray(id) {
                var targetArray = [];
                var selector;
                if (!id) selector = "[data-tip]:not([data-for])";
                else {
                    var escaped = id.replace(/\\/g, "\\\\").replace(/"/g, '\\"');
                    selector = '[data-tip][data-for="'.concat(escaped, '"]');
                } // Scan document for shadow DOM elements
                $dc8851251b4817c5$var$nodeListToArray(document.getElementsByTagName("*")).filter(function(element) {
                    return element.shadowRoot;
                }).forEach(function(element) {
                    targetArray = targetArray.concat($dc8851251b4817c5$var$nodeListToArray(element.shadowRoot.querySelectorAll(selector)));
                });
                return targetArray.concat($dc8851251b4817c5$var$nodeListToArray(document.querySelectorAll(selector)));
            }
        },
        {
            key: "bindListener",
            value: function bindListener() {
                var _this3 = this;
                var _this$props2 = this.props, id = _this$props2.id, globalEventOff = _this$props2.globalEventOff, isCapture = _this$props2.isCapture;
                var targetArray = this.getTargetArray(id);
                targetArray.forEach(function(target) {
                    if (target.getAttribute("currentItem") === null) target.setAttribute("currentItem", "false");
                    _this3.unbindBasicListener(target);
                    if (_this3.isCustomEvent(target)) _this3.customUnbindListener(target);
                });
                if (this.isBodyMode()) this.bindBodyListener(targetArray);
                else targetArray.forEach(function(target) {
                    var isCaptureMode = _this3.isCapture(target);
                    var effect = _this3.getEffect(target);
                    if (_this3.isCustomEvent(target)) {
                        _this3.customBindListener(target);
                        return;
                    }
                    target.addEventListener("mouseenter", _this3.showTooltip, isCaptureMode);
                    target.addEventListener("focus", _this3.showTooltip, isCaptureMode);
                    if (effect === "float") target.addEventListener("mousemove", _this3.updateTooltip, isCaptureMode);
                    target.addEventListener("mouseleave", _this3.hideTooltip, isCaptureMode);
                    target.addEventListener("blur", _this3.hideTooltip, isCaptureMode);
                });
                 // Global event to hide tooltip
                if (globalEventOff) {
                    window.removeEventListener(globalEventOff, this.hideTooltip);
                    window.addEventListener(globalEventOff, this.hideTooltip, isCapture);
                } // Track removal of targetArray elements from DOM
                this.bindRemovalTracker();
            }
        },
        {
            key: "unbindListener",
            value: function unbindListener() {
                var _this4 = this;
                var _this$props3 = this.props, id = _this$props3.id, globalEventOff = _this$props3.globalEventOff;
                if (this.isBodyMode()) this.unbindBodyListener();
                else {
                    var targetArray = this.getTargetArray(id);
                    targetArray.forEach(function(target) {
                        _this4.unbindBasicListener(target);
                        if (_this4.isCustomEvent(target)) _this4.customUnbindListener(target);
                    });
                }
                if (globalEventOff) window.removeEventListener(globalEventOff, this.hideTooltip);
                this.unbindRemovalTracker();
            }
        },
        {
            key: "unbindBasicListener",
            value: function unbindBasicListener(target) {
                var isCaptureMode = this.isCapture(target);
                target.removeEventListener("mouseenter", this.showTooltip, isCaptureMode);
                target.removeEventListener("mousemove", this.updateTooltip, isCaptureMode);
                target.removeEventListener("mouseleave", this.hideTooltip, isCaptureMode);
            }
        },
        {
            key: "getTooltipContent",
            value: function getTooltipContent() {
                var _this$props4 = this.props, getContent = _this$props4.getContent, children = _this$props4.children; // Generate tooltip content
                var content;
                if (getContent) {
                    if (Array.isArray(getContent)) content = getContent[0] && getContent[0](this.state.originTooltip);
                    else content = getContent(this.state.originTooltip);
                }
                return $dc8851251b4817c5$var$getTipContent(this.state.originTooltip, children, content, this.state.isMultiline);
            }
        },
        {
            key: "isEmptyTip",
            value: function isEmptyTip(placeholder) {
                return typeof placeholder === "string" && placeholder === "" || placeholder === null;
            }
        },
        {
            key: "showTooltip",
            value: function showTooltip(e, isGlobalCall) {
                if (!this.tooltipRef) return;
                if (isGlobalCall) {
                    // Don't trigger other elements belongs to other ReactTooltip
                    var targetArray = this.getTargetArray(this.props.id);
                    var isMyElement = targetArray.some(function(ele) {
                        return ele === e.currentTarget;
                    });
                    if (!isMyElement) return;
                } // Get the tooltip content
                // calculate in this phrase so that tip width height can be detected
                var _this$props5 = this.props, multiline = _this$props5.multiline, getContent = _this$props5.getContent;
                var originTooltip = e.currentTarget.getAttribute("data-tip");
                var isMultiline = e.currentTarget.getAttribute("data-multiline") || multiline || false; // If it is focus event or called by ReactTooltip.show, switch to `solid` effect
                var switchToSolid = e instanceof window.FocusEvent || isGlobalCall; // if it needs to skip adding hide listener to scroll
                var scrollHide = true;
                if (e.currentTarget.getAttribute("data-scroll-hide")) scrollHide = e.currentTarget.getAttribute("data-scroll-hide") === "true";
                else if (this.props.scrollHide != null) scrollHide = this.props.scrollHide;
                 // adding aria-describedby to target to make tooltips read by screen readers
                if (e && e.currentTarget && e.currentTarget.setAttribute) e.currentTarget.setAttribute("aria-describedby", this.state.uuid);
                 // Make sure the correct place is set
                var desiredPlace = e.currentTarget.getAttribute("data-place") || this.props.place || "top";
                var effect = switchToSolid && "solid" || this.getEffect(e.currentTarget);
                var offset = e.currentTarget.getAttribute("data-offset") || this.props.offset || {};
                var result = $dc8851251b4817c5$var$getPosition(e, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);
                if (result.position && this.props.overridePosition) result.position = this.props.overridePosition(result.position, e, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);
                var place = result.isNewState ? result.newState.place : desiredPlace; // To prevent previously created timers from triggering
                this.clearTimer();
                var target = e.currentTarget;
                var reshowDelay = this.state.show ? target.getAttribute("data-delay-update") || this.props.delayUpdate : 0;
                var self1 = this;
                var updateState = function updateState() {
                    self1.setState({
                        originTooltip: originTooltip,
                        isMultiline: isMultiline,
                        desiredPlace: desiredPlace,
                        place: place,
                        type: target.getAttribute("data-type") || self1.props.type || "dark",
                        customColors: {
                            text: target.getAttribute("data-text-color") || self1.props.textColor || null,
                            background: target.getAttribute("data-background-color") || self1.props.backgroundColor || null,
                            border: target.getAttribute("data-border-color") || self1.props.borderColor || null,
                            arrow: target.getAttribute("data-arrow-color") || self1.props.arrowColor || null
                        },
                        effect: effect,
                        offset: offset,
                        html: (target.getAttribute("data-html") ? target.getAttribute("data-html") === "true" : self1.props.html) || false,
                        delayShow: target.getAttribute("data-delay-show") || self1.props.delayShow || 0,
                        delayHide: target.getAttribute("data-delay-hide") || self1.props.delayHide || 0,
                        delayUpdate: target.getAttribute("data-delay-update") || self1.props.delayUpdate || 0,
                        border: (target.getAttribute("data-border") ? target.getAttribute("data-border") === "true" : self1.props.border) || false,
                        extraClass: target.getAttribute("data-class") || self1.props["class"] || self1.props.className || "",
                        disable: (target.getAttribute("data-tip-disable") ? target.getAttribute("data-tip-disable") === "true" : self1.props.disable) || false,
                        currentTarget: target
                    }, function() {
                        if (scrollHide) self1.addScrollListener(self1.state.currentTarget);
                        self1.updateTooltip(e);
                        if (getContent && Array.isArray(getContent)) self1.intervalUpdateContent = setInterval(function() {
                            if (self1.mount) {
                                var _getContent = self1.props.getContent;
                                var placeholder = $dc8851251b4817c5$var$getTipContent(originTooltip, "", _getContent[0](), isMultiline);
                                var isEmptyTip = self1.isEmptyTip(placeholder);
                                self1.setState({
                                    isEmptyTip: isEmptyTip
                                });
                                self1.updatePosition();
                            }
                        }, getContent[1]);
                    });
                }; // If there is no delay call immediately, don't allow events to get in first.
                if (reshowDelay) this.delayReshow = setTimeout(updateState, reshowDelay);
                else updateState();
            }
        },
        {
            key: "updateTooltip",
            value: function updateTooltip(e) {
                var _this5 = this;
                var _this$state = this.state, delayShow = _this$state.delayShow, disable = _this$state.disable;
                var afterShow = this.props.afterShow;
                var placeholder = this.getTooltipContent();
                var eventTarget = e.currentTarget || e.target; // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
                if (this.mouseOnToolTip()) return;
                 // if the tooltip is empty, disable the tooltip
                if (this.isEmptyTip(placeholder) || disable) return;
                var delayTime = !this.state.show ? parseInt(delayShow, 10) : 0;
                var updateState = function updateState() {
                    if (Array.isArray(placeholder) && placeholder.length > 0 || placeholder) {
                        var isInvisible = !_this5.state.show;
                        _this5.setState({
                            currentEvent: e,
                            currentTarget: eventTarget,
                            show: true
                        }, function() {
                            _this5.updatePosition();
                            if (isInvisible && afterShow) afterShow(e);
                        });
                    }
                };
                clearTimeout(this.delayShowLoop);
                if (delayTime) this.delayShowLoop = setTimeout(updateState, delayTime);
                else updateState();
            }
        },
        {
            key: "listenForTooltipExit",
            value: function listenForTooltipExit() {
                var show = this.state.show;
                if (show && this.tooltipRef) this.tooltipRef.addEventListener("mouseleave", this.hideTooltip);
            }
        },
        {
            key: "removeListenerForTooltipExit",
            value: function removeListenerForTooltipExit() {
                var show = this.state.show;
                if (show && this.tooltipRef) this.tooltipRef.removeEventListener("mouseleave", this.hideTooltip);
            }
        },
        {
            key: "hideTooltip",
            value: function hideTooltip(e, hasTarget) {
                var _this6 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
                    isScroll: false
                };
                var disable = this.state.disable;
                var isScroll = options.isScroll;
                var delayHide = isScroll ? 0 : this.state.delayHide;
                var afterHide = this.props.afterHide;
                var placeholder = this.getTooltipContent();
                if (!this.mount) return;
                if (this.isEmptyTip(placeholder) || disable) return; // if the tooltip is empty, disable the tooltip
                if (hasTarget) {
                    // Don't trigger other elements belongs to other ReactTooltip
                    var targetArray = this.getTargetArray(this.props.id);
                    var isMyElement = targetArray.some(function(ele) {
                        return ele === e.currentTarget;
                    });
                    if (!isMyElement || !this.state.show) return;
                } // clean up aria-describedby when hiding tooltip
                if (e && e.currentTarget && e.currentTarget.removeAttribute) e.currentTarget.removeAttribute("aria-describedby");
                var resetState = function resetState() {
                    var isVisible = _this6.state.show; // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
                    if (_this6.mouseOnToolTip()) {
                        _this6.listenForTooltipExit();
                        return;
                    }
                    _this6.removeListenerForTooltipExit();
                    _this6.setState({
                        show: false
                    }, function() {
                        _this6.removeScrollListener(_this6.state.currentTarget);
                        if (isVisible && afterHide) afterHide(e);
                    });
                };
                this.clearTimer();
                if (delayHide) this.delayHideLoop = setTimeout(resetState, parseInt(delayHide, 10));
                else resetState();
            }
        },
        {
            key: "hideTooltipOnScroll",
            value: function hideTooltipOnScroll(event, hasTarget) {
                this.hideTooltip(event, hasTarget, {
                    isScroll: true
                });
            }
        },
        {
            key: "addScrollListener",
            value: function addScrollListener(currentTarget) {
                var isCaptureMode = this.isCapture(currentTarget);
                window.addEventListener("scroll", this.hideTooltipOnScroll, isCaptureMode);
            }
        },
        {
            key: "removeScrollListener",
            value: function removeScrollListener(currentTarget) {
                var isCaptureMode = this.isCapture(currentTarget);
                window.removeEventListener("scroll", this.hideTooltipOnScroll, isCaptureMode);
            } // Calculation the position
        },
        {
            key: "updatePosition",
            value: function updatePosition() {
                var _this7 = this;
                var _this$state2 = this.state, currentEvent = _this$state2.currentEvent, currentTarget = _this$state2.currentTarget, place = _this$state2.place, desiredPlace = _this$state2.desiredPlace, effect = _this$state2.effect, offset = _this$state2.offset;
                var node = this.tooltipRef;
                var result = $dc8851251b4817c5$var$getPosition(currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
                if (result.position && this.props.overridePosition) result.position = this.props.overridePosition(result.position, currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
                if (result.isNewState) // Switch to reverse placement
                return this.setState(result.newState, function() {
                    _this7.updatePosition();
                });
                 // Set tooltip position
                node.style.left = result.position.left + "px";
                node.style.top = result.position.top + "px";
            }
        },
        {
            key: "clearTimer",
            value: function clearTimer() {
                clearTimeout(this.delayShowLoop);
                clearTimeout(this.delayHideLoop);
                clearTimeout(this.delayReshow);
                clearInterval(this.intervalUpdateContent);
            }
        },
        {
            key: "hasCustomColors",
            value: function hasCustomColors() {
                var _this8 = this;
                return Boolean(Object.keys(this.state.customColors).find(function(color) {
                    return color !== "border" && _this8.state.customColors[color];
                }) || this.state.border && this.state.customColors["border"]);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this9 = this;
                var _this$state3 = this.state, extraClass = _this$state3.extraClass, html = _this$state3.html, ariaProps = _this$state3.ariaProps, disable = _this$state3.disable, uuid = _this$state3.uuid;
                var content = this.getTooltipContent();
                var isEmptyTip = this.isEmptyTip(content);
                var style = $dc8851251b4817c5$var$generateTooltipStyle(this.state.uuid, this.state.customColors, this.state.type, this.state.border);
                var tooltipClass = "__react_component_tooltip" + " ".concat(this.state.uuid) + (this.state.show && !disable && !isEmptyTip ? " show" : "") + (this.state.border ? " border" : "") + " place-".concat(this.state.place) + // top, bottom, left, right
                " type-".concat(this.hasCustomColors() ? "custom" : this.state.type) + (this.props.delayUpdate ? " allow_hover" : "") + (this.props.clickable ? " allow_click" : "");
                var Wrapper = this.props.wrapper;
                if (ReactTooltip.supportedWrappers.indexOf(Wrapper) < 0) Wrapper = ReactTooltip.defaultProps.wrapper;
                var wrapperClassName = [
                    tooltipClass,
                    extraClass
                ].filter(Boolean).join(" ");
                if (html) {
                    var htmlContent = "".concat(content, '\n<style aria-hidden="true">').concat(style, "</style>");
                    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Wrapper, $dc8851251b4817c5$var$_extends({
                        className: "".concat(wrapperClassName),
                        id: this.props.id || uuid,
                        ref: function ref(_ref) {
                            return _this9.tooltipRef = _ref;
                        }
                    }, ariaProps, {
                        "data-id": "tooltip",
                        dangerouslySetInnerHTML: {
                            __html: htmlContent
                        }
                    }));
                } else return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Wrapper, $dc8851251b4817c5$var$_extends({
                    className: "".concat(wrapperClassName),
                    id: this.props.id || uuid
                }, ariaProps, {
                    ref: function ref(_ref2) {
                        return _this9.tooltipRef = _ref2;
                    },
                    "data-id": "tooltip"
                }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("style", {
                    dangerouslySetInnerHTML: {
                        __html: style
                    },
                    "aria-hidden": "true"
                }), content);
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var ariaProps = prevState.ariaProps;
                var newAriaProps = $dc8851251b4817c5$var$parseAria(nextProps);
                var isChanged = Object.keys(newAriaProps).some(function(props) {
                    return newAriaProps[props] !== ariaProps[props];
                });
                if (!isChanged) return null;
                return $dc8851251b4817c5$var$_objectSpread2({}, prevState, {
                    ariaProps: newAriaProps
                });
            }
        }
    ]);
    return ReactTooltip;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component), $dc8851251b4817c5$var$_defineProperty($dc8851251b4817c5$var$_class2, "defaultProps", {
    insecure: true,
    resizeHide: true,
    wrapper: "div",
    clickable: false
}), $dc8851251b4817c5$var$_defineProperty($dc8851251b4817c5$var$_class2, "supportedWrappers", [
    "div",
    "span"
]), $dc8851251b4817c5$var$_defineProperty($dc8851251b4817c5$var$_class2, "displayName", "ReactTooltip"), $dc8851251b4817c5$var$_temp)) || $dc8851251b4817c5$var$_class) || $dc8851251b4817c5$var$_class) || $dc8851251b4817c5$var$_class) || $dc8851251b4817c5$var$_class) || $dc8851251b4817c5$var$_class) || $dc8851251b4817c5$var$_class) || $dc8851251b4817c5$var$_class;
var $dc8851251b4817c5$export$2e2bcd8739ae039 = $dc8851251b4817c5$var$ReactTooltip;



var $kZ6Rz = parcelRequire("kZ6Rz");

var $90ISC = parcelRequire("90ISC");

var $fPGDZ = parcelRequire("fPGDZ");

var $9QX0f = parcelRequire("9QX0f");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("3lOdM");
var $1iwUl = parcelRequire("1iwUl");
parcelRequire("2OwWq");
var $7kkwd = parcelRequire("7kkwd");

var $c9Z8w = parcelRequire("c9Z8w");
const $b06b1bf80b877bf2$export$eb9fdd27bd048cac = ({ colProps: colProps, dataTestId: dataTestId, title: title, children: children })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1iwUl))), {
        ...colProps,
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($7kkwd))), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    "data-lwt-id": `lbl-${dataTestId}`,
                    className: "filter-header",
                    children: title
                }),
                children
            ]
        })
    });
$b06b1bf80b877bf2$export$eb9fdd27bd048cac.propTypes = {
    colProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    dataTestId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node.isRequired
};



var $eHBjM = parcelRequire("eHBjM");

var $4tbBr = parcelRequire("4tbBr");
const $284ad4c48753c7ca$export$95c52a4db4b3257a = {
    [(0, $eHBjM.tabModes).OVERVIEW]: {
        allMlsColProps: {
            xs: 12,
            sm: 5,
            md: 5
        },
        newProducerColProps: {
            xs: 12,
            sm: 6,
            md: 6
        },
        coopAgentsColProps: {
            xs: 12,
            sm: 6,
            md: 4
        },
        defaultOfficeInfoColProps: {
            xs: 12,
            sm: 3,
            md: 3
        },
        defaultCurrentPeriodColProps: {
            xs: 12,
            sm: 4,
            md: 4
        }
    },
    [(0, $eHBjM.tabModes).CONTACT_INFORMATION]: {
        newProducerColProps: {
            xs: 12,
            sm: 6,
            md: 4,
            lg: 4
        },
        defaultOfficeInfoColProps: {
            xs: 12,
            sm: 6,
            md: 4,
            lg: 3
        },
        defaultContactInfoColProps: {
            xs: 12,
            sm: 6,
            md: 4,
            lg: 3
        },
        defaultCurrentSearchColProps: {
            xs: 12,
            sm: 6,
            md: 4,
            lg: 2
        }
    },
    [(0, $eHBjM.tabModes).GROWTH_ANALYSIS]: {
        defaultColProps: {
            xs: 12,
            sm: 12,
            md: 4
        }
    },
    [(0, $eHBjM.tabModes).ACTIVITY]: {
        allMlsColProps: {
            xs: 12,
            sm: 5,
            md: 5
        }
    },
    [(0, $eHBjM.tabModes).LISTING_PROFICIENCY]: {
        defaultColProps: {
            xs: 12,
            sm: 4,
            md: 2,
            lg: 2
        },
        officeInfoColProps: {
            xs: 12,
            sm: 4,
            md: 3,
            lg: 2
        },
        noPriceChangeColProps: {
            xs: 12,
            sm: 4,
            md: 2,
            lg: 3
        },
        priceChangeColProps: {
            xs: 12,
            sm: 4,
            md: 3,
            lg: 3
        }
    }
};
const $284ad4c48753c7ca$export$393f8c6def0f8920 = {
    currentPeriod: "current-period",
    last12Months: "last-12-months",
    noPriceChange: "no-price-change",
    officeInfo: "office-info",
    priceChange: "price-change",
    recentCoopTransaction: "recent-coop-transaction",
    totalSell: "total-sell",
    totalList: "total-list",
    units: "units",
    volume: "volume",
    activity: "activity-csv-modal"
};
const $284ad4c48753c7ca$export$d1ea596473543f85 = {
    [(0, $eHBjM.tableViewNames).overview]: {
        getOfficeOptions: (isCoopAgents)=>[
                (0, $eHBjM.overviewToolTips).agentId,
                (0, $eHBjM.overviewToolTips).officeId,
                ...isCoopAgents ? [
                    (0, $eHBjM.overviewToolTips).listingAddress
                ] : [
                    (0, $eHBjM.overviewToolTips).officeAddress
                ]
            ],
        currentTimePeriodOptions: [
            (0, $eHBjM.overviewToolTips).listVolume,
            (0, $eHBjM.overviewToolTips).sellVolume,
            (0, $eHBjM.overviewToolTips).totalVolume,
            (0, $eHBjM.overviewToolTips).listUnits,
            (0, $eHBjM.overviewToolTips).sellUnits,
            (0, $eHBjM.overviewToolTips).totalUnits
        ],
        recentCoopTransactionOptions: [
            (0, $eHBjM.overviewToolTips).listingClosedDate,
            (0, $eHBjM.overviewToolTips).listingSalePrice,
            (0, $eHBjM.overviewToolTips).coopSide,
            (0, $eHBjM.overviewToolTips).totalVolume,
            (0, $eHBjM.overviewToolTips).totalUnits,
            (0, $eHBjM.overviewToolTips).myAgentName
        ],
        getAllMlsOptions: (isIncDecOverview)=>[
                (0, $eHBjM.overviewToolTips).averagePrice,
                (0, $eHBjM.overviewToolTips).last12Spop,
                (0, $eHBjM.overviewToolTips).last12AvgDom,
                ...isIncDecOverview ? [
                    (0, $eHBjM.overviewToolTips).ltmTotalUnitsChange
                ] : [
                    (0, $eHBjM.overviewToolTips).totalUnitsChange
                ],
                ...isIncDecOverview ? [
                    (0, $eHBjM.overviewToolTips).ltmTotalVolumeChange
                ] : [
                    (0, $eHBjM.overviewToolTips).totalVolumeChange
                ],
                (0, $eHBjM.overviewToolTips).last12ListVolume,
                (0, $eHBjM.overviewToolTips).last12SellVolume,
                (0, $eHBjM.overviewToolTips).last12TotalVolume,
                (0, $eHBjM.overviewToolTips).last12ListUnits,
                (0, $eHBjM.overviewToolTips).last12SellUnits,
                (0, $eHBjM.overviewToolTips).last12TotalUnits
            ]
    },
    [(0, $eHBjM.tableViewNames).contactInformation]: {
        officeOptions: [
            (0, $eHBjM.contactToolTips).agentId,
            (0, $eHBjM.contactToolTips).officeId,
            (0, $eHBjM.contactToolTips).officeAddress
        ],
        contactInformationOptions: [
            (0, $eHBjM.contactToolTips).agentPhoneType1,
            (0, $eHBjM.contactToolTips).agentPhone1,
            (0, $eHBjM.contactToolTips).agentPhoneType2,
            (0, $eHBjM.contactToolTips).agentPhone2,
            (0, $eHBjM.contactToolTips).agentPhoneType3,
            (0, $eHBjM.contactToolTips).agentPhone3,
            (0, $eHBjM.contactToolTips).agentEmail,
            (0, $eHBjM.contactToolTips).agentAddress
        ],
        currentSearchOptions: [
            (0, $eHBjM.contactToolTips).totalUnits,
            (0, $eHBjM.contactToolTips).totalVolume
        ],
        allMlsOptions: [
            (0, $eHBjM.contactToolTips).last12TotalUnits,
            (0, $eHBjM.contactToolTips).last12TotalVolume
        ],
        growthOptions: [
            (0, $eHBjM.contactToolTips).totalVolumeChange,
            (0, $eHBjM.contactToolTips).totalVolumeGrowth
        ]
    },
    [(0, $eHBjM.tableViewNames).growthAnalysisL90]: {
        getOfficeOptions: ()=>[
                (0, $eHBjM.growthAnalysisTooltips).officeId,
                (0, $eHBjM.growthAnalysisTooltips).officeAddress
            ],
        getUnitOptions: ()=>[
                (0, $4tbBr.growthAnalysisColumnsL90d).previousPeriodTotalUnits,
                (0, $4tbBr.growthAnalysisColumnsL90d).totalUnits,
                (0, $4tbBr.growthAnalysisColumnsL90d).totalUnitsChange,
                (0, $4tbBr.growthAnalysisColumnsL90d).totalUnitsGrowth
            ],
        getVolumeOptions: ()=>[
                (0, $4tbBr.growthAnalysisColumnsL90d).previousPeriodTotalVolume,
                (0, $4tbBr.growthAnalysisColumnsL90d).totalVolume,
                (0, $4tbBr.growthAnalysisColumnsL90d).totalVolumeChange,
                (0, $4tbBr.growthAnalysisColumnsL90d).totalVolumeGrowth
            ]
    },
    [(0, $eHBjM.tableViewNames).growthAnalysisLtm]: {
        getOfficeOptions: ()=>[
                (0, $eHBjM.growthAnalysisTooltips).officeId,
                (0, $eHBjM.growthAnalysisTooltips).officeAddress
            ],
        getUnitOptions: (isIncDecGrowthAnalysis)=>[
                (0, $eHBjM.growthAnalysisTooltips).ptmTotalUnits,
                (0, $eHBjM.growthAnalysisTooltips).last12TotalUnits,
                ...isIncDecGrowthAnalysis ? [
                    (0, $eHBjM.growthAnalysisTooltips).ltmTotalUnitsChange
                ] : [
                    (0, $eHBjM.growthAnalysisTooltips).totalUnitsChange
                ],
                ...isIncDecGrowthAnalysis ? [
                    (0, $eHBjM.growthAnalysisTooltips).ltmTotalUnitsGrowth
                ] : [
                    (0, $eHBjM.growthAnalysisTooltips).totalUnitsGrowth
                ]
            ],
        getVolumeOptions: (isIncDecGrowthAnalysis)=>[
                (0, $eHBjM.growthAnalysisTooltips).ptmTotalVolume,
                (0, $eHBjM.growthAnalysisTooltips).last12TotalVolume,
                {
                    ...isIncDecGrowthAnalysis ? (0, $eHBjM.growthAnalysisTooltips).ltmTotalVolumeChange : (0, $eHBjM.growthAnalysisTooltips).totalVolumeChange,
                    tip: (0, $eHBjM.growthAnalysisTooltips).totalVolumeChange.tip
                },
                {
                    ...isIncDecGrowthAnalysis ? (0, $eHBjM.growthAnalysisTooltips).ltmTotalVolumeGrowth : (0, $eHBjM.growthAnalysisTooltips).totalVolumeGrowth,
                    tip: (0, $eHBjM.growthAnalysisTooltips).totalVolumeGrowth.tip
                }
            ]
    },
    [(0, $eHBjM.tableViewNames).growthAnalysisYtd]: {
        getOfficeOptions: ()=>[
                (0, $eHBjM.growthAnalysisTooltips).officeId,
                (0, $eHBjM.growthAnalysisTooltips).officeAddress
            ],
        getUnitOptions: ()=>[
                (0, $eHBjM.growthAnalysisTooltips).pytdTotalUnits,
                (0, $eHBjM.growthAnalysisTooltips).lytdTotalUnits,
                {
                    ...(0, $eHBjM.growthAnalysisTooltips).lytdPytdTotalUnitsChange,
                    tip: (0, $eHBjM.growthAnalysisTooltips).lytdPytdTotalUnitsChange.tip
                },
                {
                    ...(0, $eHBjM.growthAnalysisTooltips).lytdPytdTotalUnitsGrowth,
                    tip: (0, $eHBjM.growthAnalysisTooltips).lytdPytdTotalUnitsGrowth.tip
                }
            ],
        getVolumeOptions: ()=>[
                (0, $eHBjM.growthAnalysisTooltips).pytdTotalVolume,
                (0, $eHBjM.growthAnalysisTooltips).lytdTotalVolume,
                (0, $eHBjM.growthAnalysisTooltips).lytdPytdTotalVolumeChange,
                (0, $eHBjM.growthAnalysisTooltips).lytdPytdTotalVolumeGrowth
            ]
    },
    [(0, $eHBjM.tableViewNames).listingProficiency]: {
        officeOptions: [
            (0, $eHBjM.listingProficiencyTooltips).officeId,
            (0, $eHBjM.listingProficiencyTooltips).officeAddress
        ],
        totalSellOptions: [
            (0, $eHBjM.listingProficiencyTooltips).last12SellUnits,
            (0, $eHBjM.listingProficiencyTooltips).last12SellVolume
        ],
        totalListOptions: [
            (0, $eHBjM.listingProficiencyTooltips).last12ListUnits,
            (0, $eHBjM.listingProficiencyTooltips).last12ListVolume
        ],
        noPriceChangeOptions: [
            (0, $eHBjM.listingProficiencyTooltips).noPcLast12ListUnits,
            (0, $eHBjM.listingProficiencyTooltips).noPcLast12ListUnitsPct,
            (0, $eHBjM.listingProficiencyTooltips).noPcLast12ListVolume,
            (0, $eHBjM.listingProficiencyTooltips).noPcLast12ListVolumePct,
            (0, $eHBjM.listingProficiencyTooltips).noPcLast12ListDom,
            (0, $eHBjM.listingProficiencyTooltips).noPcLast12ListCdom,
            (0, $eHBjM.listingProficiencyTooltips).noPcLast12SpOp
        ],
        priceChangeOptions: [
            (0, $eHBjM.listingProficiencyTooltips).pcLast12ListUnits,
            (0, $eHBjM.listingProficiencyTooltips).pcLast12ListUnitsPct,
            (0, $eHBjM.listingProficiencyTooltips).pcLast12ListVolume,
            (0, $eHBjM.listingProficiencyTooltips).pcLast12ListVolumePct,
            (0, $eHBjM.listingProficiencyTooltips).pcLast12ListDom,
            (0, $eHBjM.listingProficiencyTooltips).pcLast12ListCdom,
            (0, $eHBjM.listingProficiencyTooltips).pcLast12ListPcDom,
            (0, $eHBjM.listingProficiencyTooltips).pcLast12ListSpOp,
            (0, $eHBjM.listingProficiencyTooltips).pcLast12ListSpLp,
            (0, $eHBjM.listingProficiencyTooltips).pcLast12ListAvgNumPc
        ]
    },
    [(0, $eHBjM.tableViewNames).incDecGrowthAnalysisLtm]: {
        getOfficeOptions: ()=>[
                (0, $4tbBr.growthAnalysisColumnsLtmIncDec).officeId,
                (0, $4tbBr.growthAnalysisColumnsLtmIncDec).officeAddress
            ],
        getUnitOptions: ()=>[
                (0, $4tbBr.growthAnalysisColumnsLtmIncDec).previousPeriodTotalUnits,
                (0, $4tbBr.growthAnalysisColumnsLtmIncDec).totalUnits,
                (0, $4tbBr.growthAnalysisColumnsLtmIncDec).totalUnitsChange,
                (0, $4tbBr.growthAnalysisColumnsLtmIncDec).totalUnitsGrowth
            ],
        getVolumeOptions: ()=>[
                (0, $4tbBr.growthAnalysisColumnsLtmIncDec).previousPeriodTotalVolume,
                (0, $4tbBr.growthAnalysisColumnsLtmIncDec).totalVolume,
                (0, $4tbBr.growthAnalysisColumnsLtmIncDec).totalVolumeChange,
                (0, $4tbBr.growthAnalysisColumnsLtmIncDec).totalVolumeGrowth
            ]
    },
    [(0, $eHBjM.tableViewNames).incDecGrowthAnalysisYtd]: {
        getOfficeOptions: ()=>[
                (0, $4tbBr.growthAnalysisColumnsYtdIncDec).officeId,
                (0, $4tbBr.growthAnalysisColumnsYtdIncDec).officeAddress
            ],
        getUnitOptions: ()=>[
                (0, $4tbBr.growthAnalysisColumnsYtdIncDec).previousPeriodTotalUnits,
                (0, $4tbBr.growthAnalysisColumnsYtdIncDec).totalUnits,
                (0, $4tbBr.growthAnalysisColumnsYtdIncDec).totalUnitsChange,
                (0, $4tbBr.growthAnalysisColumnsYtdIncDec).totalUnitsGrowth
            ],
        getVolumeOptions: ()=>[
                (0, $4tbBr.growthAnalysisColumnsYtdIncDec).previousPeriodTotalVolume,
                (0, $4tbBr.growthAnalysisColumnsYtdIncDec).totalVolume,
                (0, $4tbBr.growthAnalysisColumnsYtdIncDec).totalVolumeChange,
                (0, $4tbBr.growthAnalysisColumnsYtdIncDec).totalVolumeGrowth
            ]
    },
    [(0, $eHBjM.tableViewNames).activity]: {
        currentTimeOptions: [
            (0, $eHBjM.activityToolTips).officeName,
            (0, $eHBjM.activityToolTips).activity,
            (0, $eHBjM.activityToolTips).side,
            (0, $eHBjM.activityToolTips).date
        ],
        allMlsTransactions: [
            (0, $eHBjM.activityToolTips).listVolume,
            (0, $eHBjM.activityToolTips).sellVolume,
            (0, $eHBjM.activityToolTips).totalVolume
        ]
    }
};



var $c9Z8w = parcelRequire("c9Z8w");
const $f95d14f55cce6ee7$var$AgentsColumns = ({ defaultColumns: defaultColumns, setParentColumnIds: setParentColumnIds, tabMode: tabMode, inputIdPrefix: inputIdPrefix, customSettings: customSettings, skipColumnIdsPersistence: skipColumnIdsPersistence })=>{
    const ref = (0, $acw62.useRef)();
    const { selectedModule: selectedModule, selectedMls: selectedMls, setPMSelectedColumnIds: setPMSelectedColumnIds } = (0, $90ISC.useSearchStore)((state)=>({
            selectedModule: state.selectedModule,
            selectedMls: state[state.selectedModule]?.selectedMls,
            setPMSelectedColumnIds: state.setPMSelectedColumnIds
        }));
    const { selectedList: selectedList } = (0, $90ISC.useSavedAgentsStore)((state)=>({
            selectedList: state.selectedListByModule[selectedModule]
        }));
    const restrictedMlsSettings = (0, $fPGDZ.getMlsRestrictionSettings)(selectedMls?.mlsId || selectedList?.mlsId);
    (0, $acw62.useEffect)(()=>{
        (0, $dc8851251b4817c5$export$2e2bcd8739ae039).rebuild();
    }, []);
    const renderMetricsTooltip = (data)=>{
        const metricDescription = JSON.parse(data);
        return metricDescription?.metricDescription && (0, (/*@__PURE__*/$parcel$interopDefault($kZ6Rz))).renderToString(/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "text-left",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "w-100",
                children: metricDescription.metricDescription
            })
        }));
    };
    const [selectedColumnIds, setSelectedColumnIds] = (0, $acw62.useState)(defaultColumns.flatMap((c)=>c.isDisplayed && !c.parentColumnId ? c.id : []));
    const handleItemClick = (e)=>{
        const item = e.target;
        const clickedColumnId = item.value;
        const revisedSelectedItems = item.checked ? [
            ...selectedColumnIds,
            clickedColumnId
        ] : selectedColumnIds.filter((col)=>col !== clickedColumnId);
        !skipColumnIdsPersistence && setPMSelectedColumnIds(revisedSelectedItems, tabMode, customSettings?.isPeriodLast12Months);
        setSelectedColumnIds(revisedSelectedItems);
        setParentColumnIds(revisedSelectedItems);
    };
    const writeInput = (column, index)=>{
        const foundColumn = selectedColumnIds.find((id)=>id === column.id);
        const elementId = `${inputIdPrefix}${column.id}`;
        const label = (0, $g3CkB.getLabelTextWithDate)(column);
        const tooltipProps = {
            "data-for": "metrics-selector-tooltip",
            "data-tip": JSON.stringify({
                metricDescription: (0, $g3CkB.getTooltipText)(column)
            })
        };
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    ...tooltipProps,
                    ref: ref,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1BYDb))), {
                        dataLwtId: elementId,
                        id: elementId,
                        value: column.id,
                        defaultChecked: foundColumn,
                        disabled: false,
                        type: "checkbox",
                        label: label,
                        onClick: handleItemClick
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dc8851251b4817c5$export$2e2bcd8739ae039), {
                    id: "metrics-selector-tooltip",
                    className: "metrics-selector-tooltip",
                    type: "info",
                    effect: "solid",
                    place: "left",
                    backgroundColor: "black",
                    getContent: renderMetricsTooltip,
                    html: true
                })
            ]
        }, column.id);
    };
    const writeColumn = (rows)=>rows.map((row, index)=>writeInput(row, index));
    const groupsToWrite = [];
    const isNewProducers = customSettings?.currentTabId === (0, $9QX0f.tabs).newProducers.id;
    const isCoopAgents = customSettings?.currentTabId === (0, $9QX0f.tabs).coopAgents.id;
    const isIncDecProducers = customSettings?.currentTabId === (0, $9QX0f.tabs).incProducers.id || customSettings?.currentTabId === (0, $9QX0f.tabs).decProducers.id;
    if (tabMode === (0, $eHBjM.tabModes).OVERVIEW) {
        const { getOfficeOptions: getOfficeOptions, currentTimePeriodOptions: currentTimePeriodOptions, recentCoopTransactionOptions: recentCoopTransactionOptions, getAllMlsOptions: getAllMlsOptions } = (0, $284ad4c48753c7ca$export$d1ea596473543f85)[tabMode];
        const officeOptions = getOfficeOptions(isCoopAgents);
        const allMlsOptions = getAllMlsOptions(isIncDecProducers);
        const { allMlsColProps: allMlsColProps, newProducerColProps: newProducerColProps, coopAgentsColProps: coopAgentsColProps, defaultOfficeInfoColProps: defaultOfficeInfoColProps, defaultCurrentPeriodColProps: defaultCurrentPeriodColProps } = (0, $284ad4c48753c7ca$export$95c52a4db4b3257a)[tabMode];
        const officeInfoColProps = isNewProducers ? newProducerColProps : defaultOfficeInfoColProps;
        const currentPeriodColProps = isNewProducers ? newProducerColProps : defaultCurrentPeriodColProps;
        groupsToWrite.push(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $b06b1bf80b877bf2$export$eb9fdd27bd048cac), {
            colProps: officeInfoColProps,
            dataTestId: (0, $284ad4c48753c7ca$export$393f8c6def0f8920).officeInfo,
            title: (0, $cstaF.agentProductionTerms).officeInformation,
            children: writeColumn(officeOptions)
        }));
        isCoopAgents && groupsToWrite.push(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $b06b1bf80b877bf2$export$eb9fdd27bd048cac), {
            colProps: coopAgentsColProps,
            dataTestId: (0, $284ad4c48753c7ca$export$393f8c6def0f8920).recentCoopTransaction,
            title: (0, $cstaF.agentProductionTerms).recentCoopTransactions,
            children: writeColumn(recentCoopTransactionOptions)
        }));
        !isCoopAgents && groupsToWrite.push(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $b06b1bf80b877bf2$export$eb9fdd27bd048cac), {
            colProps: currentPeriodColProps,
            dataTestId: (0, $284ad4c48753c7ca$export$393f8c6def0f8920).currentPeriod,
            title: (0, $cstaF.agentProductionTerms).currentTimePeriodSearch,
            children: writeColumn(currentTimePeriodOptions)
        }));
        !isNewProducers && groupsToWrite.push(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $b06b1bf80b877bf2$export$eb9fdd27bd048cac), {
            colProps: allMlsColProps,
            dataTestId: (0, $284ad4c48753c7ca$export$393f8c6def0f8920).last12Months,
            title: (0, $cstaF.agentProductionTerms).allMlsTransactionsLast12Months,
            children: writeColumn(allMlsOptions)
        }));
    }
    if (tabMode === (0, $eHBjM.tabModes).CONTACT_INFORMATION) {
        const { officeOptions: officeOptions, contactInformationOptions: contactInformationOptions, currentSearchOptions: currentSearchOptions, allMlsOptions: allMlsOptions, growthOptions: growthOptions } = (0, $284ad4c48753c7ca$export$d1ea596473543f85)[tabMode];
        const { newProducerColProps: newProducerColProps, defaultOfficeInfoColProps: defaultOfficeInfoColProps, defaultContactInfoColProps: defaultContactInfoColProps, defaultCurrentSearchColProps: defaultCurrentSearchColProps } = (0, $284ad4c48753c7ca$export$95c52a4db4b3257a)[tabMode];
        const officeInfoColProps = isNewProducers ? newProducerColProps : defaultOfficeInfoColProps;
        const contactInfoColProps = isNewProducers ? newProducerColProps : defaultContactInfoColProps;
        const currentSearchColProps = isNewProducers ? newProducerColProps : defaultCurrentSearchColProps;
        groupsToWrite.push(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $b06b1bf80b877bf2$export$eb9fdd27bd048cac), {
            colProps: officeInfoColProps,
            dataTestId: (0, $284ad4c48753c7ca$export$393f8c6def0f8920).officeInfo,
            title: (0, $cstaF.agentProductionTerms).officeInformation,
            children: writeColumn(officeOptions)
        }));
        groupsToWrite.push(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $b06b1bf80b877bf2$export$eb9fdd27bd048cac), {
            colProps: contactInfoColProps,
            dataTestId: (0, $284ad4c48753c7ca$export$393f8c6def0f8920).officeInfo,
            title: (0, $cstaF.agentProductionTerms).contactInformation,
            children: writeColumn((0, $fPGDZ.getOptionsByMlsRestriction)(contactInformationOptions, restrictedMlsSettings))
        }));
        groupsToWrite.push(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $b06b1bf80b877bf2$export$eb9fdd27bd048cac), {
            colProps: currentSearchColProps,
            dataTestId: (0, $284ad4c48753c7ca$export$393f8c6def0f8920).officeInfo,
            title: (0, $cstaF.agentProductionTerms).currentSearch,
            children: writeColumn(currentSearchOptions)
        }));
        !isNewProducers && groupsToWrite.push(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $b06b1bf80b877bf2$export$eb9fdd27bd048cac), {
            colProps: defaultCurrentSearchColProps,
            dataTestId: (0, $284ad4c48753c7ca$export$393f8c6def0f8920).officeInfo,
            title: (0, $cstaF.agentProductionTerms).allMlsTransactionsLast12Months,
            children: writeColumn(allMlsOptions)
        }));
        !isNewProducers && groupsToWrite.push(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $b06b1bf80b877bf2$export$eb9fdd27bd048cac), {
            colProps: defaultCurrentSearchColProps,
            dataTestId: (0, $284ad4c48753c7ca$export$393f8c6def0f8920).officeInfo,
            title: (0, $cstaF.agentProductionTerms).growth,
            children: writeColumn(growthOptions)
        }));
    }
    if (tabMode === (0, $eHBjM.tabModes).GROWTH_ANALYSIS) {
        let officeOptions = [];
        let unitOptions = [];
        let volumeOptions = [];
        const { defaultColProps: defaultColProps } = (0, $284ad4c48753c7ca$export$95c52a4db4b3257a)[(0, $eHBjM.tabModes).GROWTH_ANALYSIS];
        const sugAgentsTableViewByPeriod = {
            [(0, $cstaF.agentProductionTerms).last12Months]: (0, $eHBjM.tableViewNames).growthAnalysisLtm,
            [(0, $cstaF.agentProductionTerms).yearToDate]: (0, $eHBjM.tableViewNames).growthAnalysisYtd
        }[customSettings?.growthAnalysisPeriod];
        const incDecTableViewByPeriod = {
            [(0, $cstaF.TimePeriods)[(0, $cstaF.agentProductionTerms).last90Days]]: (0, $eHBjM.tableViewNames).growthAnalysisL90,
            [(0, $cstaF.TimePeriods)[(0, $cstaF.agentProductionTerms).last12Months]]: (0, $eHBjM.tableViewNames).incDecGrowthAnalysisLtm,
            [(0, $cstaF.TimePeriods)[(0, $cstaF.agentProductionTerms).yearToDate]]: (0, $eHBjM.tableViewNames).incDecGrowthAnalysisYtd
        }[customSettings?.growthAnalysisPeriod];
        const defaultTableView = customSettings?.isPeriodLast12Months ? (0, $eHBjM.tableViewNames).growthAnalysisLtm : (0, $eHBjM.tableViewNames).growthAnalysisYtd;
        const growthAnalysisTableView = customSettings?.growthAnalysisPeriod ? isIncDecProducers ? incDecTableViewByPeriod : sugAgentsTableViewByPeriod : defaultTableView;
        const { getOfficeOptions: getOfficeOptions, getUnitOptions: getUnitOptions, getVolumeOptions: getVolumeOptions } = (0, $284ad4c48753c7ca$export$d1ea596473543f85)[growthAnalysisTableView];
        officeOptions = getOfficeOptions();
        unitOptions = getUnitOptions(isIncDecProducers);
        volumeOptions = getVolumeOptions(isIncDecProducers);
        // Values for Col 'md' props target individual columns. They are overridden in the CSS to tighten space b/w columns
        groupsToWrite.push(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $b06b1bf80b877bf2$export$eb9fdd27bd048cac), {
            colProps: defaultColProps,
            dataTestId: (0, $284ad4c48753c7ca$export$393f8c6def0f8920).officeInfo,
            title: (0, $cstaF.agentProductionTerms).officeInformation,
            children: writeColumn(officeOptions)
        }));
        groupsToWrite.push(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $b06b1bf80b877bf2$export$eb9fdd27bd048cac), {
            colProps: defaultColProps,
            dataTestId: (0, $284ad4c48753c7ca$export$393f8c6def0f8920).units,
            title: (0, $cstaF.agentProductionTerms).numberUnits,
            children: writeColumn(unitOptions)
        }));
        groupsToWrite.push(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $b06b1bf80b877bf2$export$eb9fdd27bd048cac), {
            colProps: defaultColProps,
            dataTestId: (0, $284ad4c48753c7ca$export$393f8c6def0f8920).volume,
            title: (0, $cstaF.agentProductionTerms).dollarVolume,
            children: writeColumn(volumeOptions)
        }));
    }
    if (tabMode === (0, $eHBjM.tabModes).LISTING_PROFICIENCY) {
        const { officeOptions: officeOptions, totalSellOptions: totalSellOptions, totalListOptions: totalListOptions, noPriceChangeOptions: noPriceChangeOptions, priceChangeOptions: priceChangeOptions } = (0, $284ad4c48753c7ca$export$d1ea596473543f85)[tabMode];
        const { defaultColProps: defaultColProps, officeInfoColProps: officeInfoColProps, noPriceChangeColProps: noPriceChangeColProps, priceChangeColProps: priceChangeColProps } = (0, $284ad4c48753c7ca$export$95c52a4db4b3257a)[(0, $eHBjM.tabModes).LISTING_PROFICIENCY];
        groupsToWrite.push(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $b06b1bf80b877bf2$export$eb9fdd27bd048cac), {
            colProps: officeInfoColProps,
            dataTestId: (0, $284ad4c48753c7ca$export$393f8c6def0f8920).officeInfo,
            title: (0, $cstaF.agentProductionTerms).officeInformation,
            children: writeColumn(officeOptions)
        }));
        groupsToWrite.push(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $b06b1bf80b877bf2$export$eb9fdd27bd048cac), {
            colProps: defaultColProps,
            dataTestId: (0, $284ad4c48753c7ca$export$393f8c6def0f8920).totalSell,
            title: (0, $cstaF.agentProductionTerms).totalSell,
            children: writeColumn(totalSellOptions)
        }));
        groupsToWrite.push(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $b06b1bf80b877bf2$export$eb9fdd27bd048cac), {
            colProps: defaultColProps,
            dataTestId: (0, $284ad4c48753c7ca$export$393f8c6def0f8920).totalList,
            title: (0, $cstaF.agentProductionTerms).totalList,
            children: writeColumn(totalListOptions)
        }));
        groupsToWrite.push(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $b06b1bf80b877bf2$export$eb9fdd27bd048cac), {
            colProps: noPriceChangeColProps,
            dataTestId: (0, $284ad4c48753c7ca$export$393f8c6def0f8920).noPriceChange,
            title: (0, $cstaF.agentProductionTerms).noPriceChangeListings,
            children: writeColumn(noPriceChangeOptions)
        }));
        groupsToWrite.push(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $b06b1bf80b877bf2$export$eb9fdd27bd048cac), {
            colProps: priceChangeColProps,
            dataTestId: (0, $284ad4c48753c7ca$export$393f8c6def0f8920).priceChange,
            title: (0, $cstaF.agentProductionTerms).priceChangeListings,
            children: writeColumn(priceChangeOptions)
        }));
    }
    if (tabMode === (0, $eHBjM.tabModes).ACTIVITY) {
        const { currentTimeOptions: currentTimeOptions, allMlsTransactions: allMlsTransactions } = (0, $284ad4c48753c7ca$export$d1ea596473543f85)[tabMode];
        const { defaultColProps: defaultColProps } = (0, $284ad4c48753c7ca$export$95c52a4db4b3257a)[(0, $eHBjM.tabModes).ACTIVITY];
        groupsToWrite.push(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $b06b1bf80b877bf2$export$eb9fdd27bd048cac), {
            colProps: defaultColProps,
            dataTestId: (0, $284ad4c48753c7ca$export$393f8c6def0f8920).activity,
            title: (0, $cstaF.agentProductionTerms).currentTimePeriodSearch,
            children: writeColumn(currentTimeOptions)
        }));
        groupsToWrite.push(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $b06b1bf80b877bf2$export$eb9fdd27bd048cac), {
            colProps: defaultColProps,
            dataTestId: (0, $284ad4c48753c7ca$export$393f8c6def0f8920).activity,
            title: (0, $cstaF.agentProductionTerms).allMlsTransactionsLast12Months,
            children: writeColumn(allMlsTransactions)
        }));
    }
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e155p))), {
            children: groupsToWrite.map((group, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
                    children: group
                }, index))
        })
    });
};
$f95d14f55cce6ee7$var$AgentsColumns.propTypes = {
    customSettings: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    defaultColumns: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array.isRequired,
    inputIdPrefix: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    setParentColumnIds: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    tabMode: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    skipColumnIdsPersistence: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
var $f95d14f55cce6ee7$export$2e2bcd8739ae039 = $f95d14f55cce6ee7$var$AgentsColumns;



var $90ISC = parcelRequire("90ISC");

var $c9Z8w = parcelRequire("c9Z8w");

var $fPGDZ = parcelRequire("fPGDZ");
const $41bbbe2b4d964901$var$MetricsSelector = ({ columns: columns, setColumns: setColumns, tabMode: tabMode, customSettings: customSettings })=>{
    const effectiveTabMode = (0, $fPGDZ.getEffectiveTabMode)(tabMode, customSettings?.isPeriodLast12Months);
    const { selectedColumnIds: selectedColumnIds } = (0, $90ISC.useSearchStore)((state)=>({
            selectedColumnIds: state[state.selectedModule]?.selectedColumnIds?.[effectiveTabMode]?.columns
        }));
    const defaultColumns = selectedColumnIds ? columns.map((column)=>({
            ...column,
            isDisplayed: selectedColumnIds.includes(column.id) || selectedColumnIds.includes(column.parentColumnId)
        })) : columns;
    const setSelectedColumnIds = (selectedColumnIds)=>{
        const revisedColumns = [
            ...columns
        ];
        revisedColumns.forEach((column)=>{
            const foundColumn = selectedColumnIds.find((id)=>id === column.id || id === column.parentColumnId);
            column.isDisplayed = !!foundColumn;
        });
        setColumns(revisedColumns);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f95d14f55cce6ee7$export$2e2bcd8739ae039), {
            defaultColumns: defaultColumns,
            tabMode: tabMode,
            inputIdPrefix: "metrics-selector",
            customSettings: customSettings,
            setParentColumnIds: setSelectedColumnIds
        })
    });
};
$41bbbe2b4d964901$var$MetricsSelector.propTypes = {
    columns: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object),
    setColumns: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    tabMode: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    customSettings: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $41bbbe2b4d964901$export$2e2bcd8739ae039 = $41bbbe2b4d964901$var$MetricsSelector;



var $eHBjM = parcelRequire("eHBjM");

var $cstaF = parcelRequire("cstaF");
const $b7c3c7269e122f25$export$f3d4f2f24c1c81cb = {
    modifiers: {
        flip: {
            enabled: false
        }
    }
};


const $ff3174d53694c027$var$AgentsTableControls = ({ isTableSelected: isTableSelected, setIsTableSelected: setIsTableSelected, columns: columns, setColumns: setColumns, tabMode: tabMode, popoverClassName: popoverClassName = "", popoverHeader: popoverHeader = (0, $cstaF.agentProductionTerms).metrics, hasShowHideColumnsButton: hasShowHideColumnsButton, hasTableChartToggle: hasTableChartToggle, isLeftSide: isLeftSide, growthAnalysisPeriod: growthAnalysisPeriod, setGrowthAnalysisPeriod: setGrowthAnalysisPeriod, customSettings: customSettings })=>{
    const [popoverIsOpen, setPopoverIsOpen] = (0, $acw62.useState)(false);
    const togglePopover = ()=>{
        setPopoverIsOpen(!popoverIsOpen);
    };
    let popover;
    if (hasShowHideColumnsButton) popover = /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Xlz6))), {
        innerClassName: "helix-heading",
        target: "btnShowHideMetrics" + tabMode,
        placement: "bottom-end",
        trigger: "legacy",
        size: "auto",
        header: popoverHeader,
        toggle: togglePopover,
        isOpen: popoverIsOpen,
        ...(0, $b7c3c7269e122f25$export$f3d4f2f24c1c81cb),
        className: `metrics-selector ${popoverClassName}`,
        body: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $41bbbe2b4d964901$export$2e2bcd8739ae039), {
            columns: columns,
            setColumns: setColumns,
            tabMode: tabMode,
            customSettings: customSettings
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `w-100 text-right agents-table-controls d-inline-block mb-1 ${popoverClassName}`,
        children: [
            hasShowHideColumnsButton && isTableSelected && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "d-inline-block",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                        dataLwtId: "toggle-metrics-button",
                        size: "sm",
                        className: "ml-auto",
                        id: "btnShowHideMetrics" + tabMode,
                        onClick: togglePopover,
                        children: (0, $cstaF.agentProductionTerms).showHideMetrics
                    }),
                    popover
                ]
            }),
            tabMode === (0, $eHBjM.tabModes).GROWTH_ANALYSIS && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "ml-2 d-inline-block ",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($90ODN))), {
                    dataLwtId: "share-options",
                    toggleProps: {
                        dataLwtId: "no-split-toggle",
                        id: "caret",
                        color: "secondary",
                        caret: true,
                        children: growthAnalysisPeriod,
                        className: "btn btn-sm btn-secondary"
                    },
                    items: [
                        {
                            dataLwtId: "no-split-item1",
                            itemText: (0, $cstaF.agentProductionTerms).last12Months,
                            key: "item_1",
                            onClick: ()=>setGrowthAnalysisPeriod((0, $cstaF.agentProductionTerms).last12Months)
                        },
                        {
                            dataLwtId: "no-split-item2",
                            divider: true,
                            key: "item_2"
                        },
                        {
                            dataLwtId: "no-split-item3",
                            itemText: (0, $cstaF.agentProductionTerms).yearToDate,
                            key: "item_3",
                            onClick: ()=>setGrowthAnalysisPeriod((0, $cstaF.agentProductionTerms).yearToDate)
                        }
                    ],
                    menuProps: {
                        dataLwtId: "share-menu",
                        right: true
                    }
                })
            }),
            hasTableChartToggle && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($c5PmB))), {
                className: "mb-2" + (!isTableSelected && !isLeftSide ? " ml-auto" : ""),
                dataLwtId: "table-controls",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                        dataLwtId: "table-button",
                        size: "sm",
                        onClick: ()=>setIsTableSelected(true),
                        className: `text-uppercase ${isTableSelected ? "active" : ""}`,
                        children: "Table"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                        dataLwtId: "chart-button",
                        size: "sm",
                        onClick: ()=>setIsTableSelected(false),
                        className: `text-uppercase ${isTableSelected ? "" : "active"}`,
                        children: "Chart"
                    })
                ]
            })
        ]
    });
};
$ff3174d53694c027$var$AgentsTableControls.propTypes = {
    isTableShown: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    columns: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object),
    setColumns: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    tabMode: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf(Object.values((0, $eHBjM.tabModes))),
    popoverClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    hasShowHideColumnsButton: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    hasTableChartToggle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
var $ff3174d53694c027$export$2e2bcd8739ae039 = $ff3174d53694c027$var$AgentsTableControls;



var $8NZ49 = parcelRequire("8NZ49");

var $eHBjM = parcelRequire("eHBjM");

var $l05Px = parcelRequire("l05Px");

var $4tbBr = parcelRequire("4tbBr");

var $90ISC = parcelRequire("90ISC");

var $jilhO = parcelRequire("jilhO");

var $aypMh = parcelRequire("aypMh");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");


var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");
const $33f706d0a52b4965$export$6ca0d94343fe1be4 = (0, $lmFrL.default).section`
    // create keyframes for the floating action bar
    @keyframes openFloatingActionBar {
        0% {
            bottom: -100px;
            opacity: 0;
            visibility: hidden;
        }
        80% {
            bottom: 60px;
            opacity: 1;
        }
        100% {
            bottom: 50px;
            opacity: 1;
        }
    }
    @keyframes closeFloatingActionBar {
        0% {
            bottom: 50px;
            opacity: 1;
            visibility: hidden;
        }
        100% {
            bottom: -100px;
            opacity: 0;
        }
    }

    position: fixed;
    left: 50%;
    display: flex;
    visibility: ${({ openingState: openingState })=>openingState === "closed" ? "hidden" : "visible"};
    bottom: ${({ openingState: openingState })=>openingState === "open" ? "50px" : "-100px"};
    // animate the floating action bar
    animation: ${({ openingState: openingState })=>openingState === "opening" ? "openFloatingActionBar 0.2s ease-in-out forwards" : openingState === "closing" ? "closeFloatingActionBar 0.2s ease-in-out forwards" : "none"};
    z-index: 1000;

    transform: translateX(-50%);
    flex-direction: row;
    max-width: calc(100% - 32px);
    width: fit-content;
    align-items: flex-start;
    background: rgba(0, 0, 0, 0.8);
    box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.2), 0px 4px 8px rgba(0, 0, 0, 0.1);
    backdrop-filter: blur(24px);
    border-radius: 12px;
    padding: 8px;
    .helix-floating-action-bar__badge-close-label {
        font-weight: 400;
        font-size: 12px;
        line-height: 16px;
        padding-right: 4px;
        white-space: nowrap;
        color: ${({ theme: theme })=>{
    var _a, _b;
    return (_b = (_a = theme.colors) === null || _a === void 0 ? void 0 : _a.gray) === null || _b === void 0 ? void 0 : _b[200];
}};
    }
`;
const $33f706d0a52b4965$export$1cb06e19255977b = (0, $lmFrL.default).div`
    display: flex;
    overflow: hidden;
`;
const $33f706d0a52b4965$export$c3d3f1205082dd48 = (0, $lmFrL.default).div`
    overflow: hidden;
    display: flex;
    gap: 8px;
    align-items: center;
    &:focus {
        outline: none;
    }
`;
const $33f706d0a52b4965$export$babb72c82316a267 = (0, $lmFrL.default).div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    height: 100%;
    gap: 8px;
`;
const $33f706d0a52b4965$export$b7aa47e99283a364 = (0, $lmFrL.default).button`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 12px;
    flex: none;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 8px;
    color: ${({ theme: theme })=>{
    var _a;
    return (_a = theme.colors) === null || _a === void 0 ? void 0 : _a.white;
}};
    font-weight: 600;
    font-size: 14px;
    box-sizing: border-box;
    line-height: 20px;
    padding: 7px 8px;
    p {
        white-space: nowrap;
    }
    svg path {
        fill: ${({ theme: theme })=>{
    var _a;
    return (_a = theme.colors) === null || _a === void 0 ? void 0 : _a.white;
}};
    }
    &:hover,
    &:focus {
        cursor: pointer;
        background-color: #4e4e4e;
        border: 1px solid #5b5b5b;
        box-shadow: 0px 0px 1px rgba(255, 255, 255, 0.2), 0px 4px 8px rgba(255, 255, 255, 0.1);
        backdrop-filter: blur(24px);
    }
    &:focus {
        outline: none;
    }
`;
const $33f706d0a52b4965$export$4ebef9997ab632a = (0, $lmFrL.default).div`
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 100%;
`;
const $33f706d0a52b4965$export$9aa64a078c634765 = (0, $lmFrL.default).div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background: ${({ theme: theme })=>{
    var _a;
    return (_a = theme.colors) === null || _a === void 0 ? void 0 : _a["brand-light"];
}};
    color: ${({ theme: theme })=>{
    var _a;
    return (_a = theme.colors) === null || _a === void 0 ? void 0 : _a.white;
}};
    font-size: 16px;
    min-width: 25px;
    height: 28px;
    border-radius: 8px;
    padding: 0 8px;
    flex-shrink: 0;
    border: none;
    font-weight: 600;
    margin-left: 4px;
    svg path {
        fill: ${({ theme: theme })=>{
    var _a;
    return (_a = theme.colors) === null || _a === void 0 ? void 0 : _a.white;
}};
        stroke: ${({ theme: theme })=>{
    var _a;
    return (_a = theme.colors) === null || _a === void 0 ? void 0 : _a.white;
}};
    }
`;
const $33f706d0a52b4965$export$24bcaebc6f670c8f = (0, $lmFrL.default).button`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    color: ${({ theme: theme })=>{
    var _a;
    return (_a = theme.colors) === null || _a === void 0 ? void 0 : _a.white;
}};
    font-size: 16px;
    width: 28px;
    height: 28px;
    border-radius: 8px;
    padding: 9px;
    background-color: transparent;
    border: none;
    cursor: pointer;
    span {
        display: flex;
        align-items: center;
        justify-content: center;
    }
    &:hover,
    &:focus {
        background: rgba(255, 255, 255, 0.08);
    }
    svg path {
        fill: ${({ theme: theme })=>{
    var _a;
    return (_a = theme.colors) === null || _a === void 0 ? void 0 : _a.white;
}};
        stroke: ${({ theme: theme })=>{
    var _a;
    return (_a = theme.colors) === null || _a === void 0 ? void 0 : _a.white;
}};
    }
    &:focus {
        outline: none;
    }
`;



var $acw62 = parcelRequire("acw62");
const $02d92cc08424ac42$var$initialState = {
    barVisible: "closed",
    moreItems: [],
    toolbarItems: [],
    activeItem: "",
    hasMoreItems: false,
    moreMenuOpen: false,
    hiddenItemsWidths: [],
    mobileBreakpoint: 768
};
const $02d92cc08424ac42$export$d28a545f4f7481ab = (0, $acw62.createContext)({
    floatingActionBarState: $02d92cc08424ac42$var$initialState,
    dispatchFloatingActionBarState: (value)=>value
});
const $02d92cc08424ac42$var$reducer = (state, action)=>{
    const { type: type, payload: payload } = action;
    switch(type){
        case "ADD_TO_MORE_ITEMS":
            // only add if it doesn't exist in the array
            if (state.moreItems.find((item)=>item.id === payload.id)) return Object.assign({}, state);
            return Object.assign(Object.assign({}, state), {
                moreItems: [
                    payload,
                    ...state.moreItems
                ]
            });
        case "ADD_TO_MORE_ITEMS_FIRST_LOAD":
            return Object.assign(Object.assign({}, state), {
                moreItems: [
                    ...state.moreItems,
                    payload
                ]
            });
        case "REMOVE_FROM_MORE_ITEMS":
            return Object.assign(Object.assign({}, state), {
                moreItems: state.moreItems.filter((item)=>item.id !== payload.id)
            });
        case "SET_TOGGLE_BAR_VISIBILITY":
            return Object.assign(Object.assign({}, state), {
                barVisible: payload
            });
        case "ADD_TO_TOOLBAR_ITEMS":
            if (state.toolbarItems.find((item)=>item.id === payload.id)) return Object.assign({}, state);
            return Object.assign(Object.assign({}, state), {
                toolbarItems: [
                    ...state.toolbarItems,
                    payload
                ]
            });
        case "ADD_TO_TOOLBAR_ITEMS_AT_INDEX":
            {
                const index = payload.index;
                const newToolbarItems = [
                    ...state.toolbarItems
                ];
                newToolbarItems.splice(index, 0, payload.item);
                return Object.assign(Object.assign({}, state), {
                    toolbarItems: newToolbarItems
                });
            }
        case "REMOVE_FROM_TOOLBAR_ITEMS":
            return Object.assign(Object.assign({}, state), {
                toolbarItems: state.toolbarItems.filter((item)=>item.id !== payload.id)
            });
        case "SET_ACTIVE_ITEM":
            return Object.assign(Object.assign({}, state), {
                activeItem: payload
            });
        case "SET_HAS_MORE_ITEMS":
            return Object.assign(Object.assign({}, state), {
                hasMoreItems: payload
            });
        case "SET_MORE_MENU_OPEN":
            return Object.assign(Object.assign({}, state), {
                moreMenuOpen: payload
            });
        case "ADD_HIDDEN_ITEMS_WIDTHS":
            return Object.assign(Object.assign({}, state), {
                hiddenItemsWidths: [
                    ...state.hiddenItemsWidths,
                    payload
                ]
            });
        case "REMOVE_HIDDEN_ITEMS_WIDTHS":
            return Object.assign(Object.assign({}, state), {
                hiddenItemsWidths: state.hiddenItemsWidths.filter((item)=>item.id !== payload.id)
            });
        case "SET_TOOLBAR_ITEM_VISIBILITY":
            return Object.assign(Object.assign({}, state), {
                toolbarItems: state.toolbarItems.map((item)=>{
                    if (item.id === payload.id) return Object.assign(Object.assign({}, item), {
                        visible: payload.visible
                    });
                    return item;
                })
            });
        default:
            return Object.assign({}, state);
    }
};
const $02d92cc08424ac42$export$b1f683f8fbc771ec = ({ children: children, labels: labels })=>{
    const [floatingActionBarState, dispatchFloatingActionBarState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useReducer($02d92cc08424ac42$var$reducer, $02d92cc08424ac42$var$initialState);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($02d92cc08424ac42$export$d28a545f4f7481ab.Provider, {
        value: {
            floatingActionBarState: floatingActionBarState,
            dispatchFloatingActionBarState: dispatchFloatingActionBarState,
            labels: labels
        }
    }, children);
};




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
const $4a83e0424f376680$export$162d9a1f1cb5190c = ()=>{
    const [screenWidth, setScreenWidth] = (0, $acw62.useState)(0);
    const handleResize = (e)=>{
        setScreenWidth(e.srcElement.innerWidth);
    };
    (0, $acw62.useEffect)(()=>{
        window.addEventListener("resize", handleResize);
        setScreenWidth(window.innerWidth);
        return ()=>{
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    return {
        screenWidth: screenWidth
    };
};





var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $3tUi5 = parcelRequire("3tUi5");

var $ai2Pb = parcelRequire("ai2Pb");

var $acw62 = parcelRequire("acw62");
var $99a4c16267298bdd$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $99a4c16267298bdd$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === "function") {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $99a4c16267298bdd$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === "function") return $99a4c16267298bdd$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $99a4c16267298bdd$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $99a4c16267298bdd$export$700979bc83e7db82 = typeof window !== "undefined" && window.document && window.document.createElement ? $acw62.useLayoutEffect : $acw62.useEffect;


var $83ae1b51e5ada323$var$EMPTY_MODIFIERS = [];
var $83ae1b51e5ada323$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $acw62.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || "bottom",
        strategy: options.strategy || "absolute",
        modifiers: options.modifiers || $83ae1b51e5ada323$var$EMPTY_MODIFIERS
    };
    var _React$useState = $acw62.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: "0",
                top: "0"
            },
            arrow: {
                position: "absolute"
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $acw62.useMemo(function() {
        return {
            name: "updateState",
            enabled: true,
            phase: "write",
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $1u0KT.flushSync(function() {
                    setState({
                        styles: (0, $99a4c16267298bdd$export$5150077fc2e7c662)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $99a4c16267298bdd$export$5150077fc2e7c662)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                "computeStyles"
            ]
        };
    }, []);
    var popperOptions = $acw62.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: "applyStyles",
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $acw62.useRef();
    (0, $99a4c16267298bdd$export$700979bc83e7db82)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $99a4c16267298bdd$export$700979bc83e7db82)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $3tUi5.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};



var $lmFrL = parcelRequire("lmFrL");
const $f4c7792df46a2b80$export$fcac8f3adec6f9ce = (0, $lmFrL.default).div`
    // css arrow
    position: absolute;
    width: 0;
    height: 0;
    &:before {
        content: '';
        position: absolute;
        border-style: solid;
        border-width: 6px 6px 6px 0;
        border-color: transparent ${({ theme: theme })=>{
    var _a;
    return (_a = theme.tooltip) === null || _a === void 0 ? void 0 : _a.backgroundColor;
}} transparent transparent;
    }
`;
const $f4c7792df46a2b80$export$353e9bd501be795b = (0, $lmFrL.default).div`
    background-color: ${({ theme: theme })=>{
    var _a;
    return (_a = theme.tooltip) === null || _a === void 0 ? void 0 : _a.backgroundColor;
}};
    color: ${({ theme: theme })=>{
    var _a;
    return (_a = theme.tooltip) === null || _a === void 0 ? void 0 : _a.textColor;
}};
    padding: 6px;
    border-radius: 4px;
    font-weight: 400;
    line-height: 16px;
    font-size: 12px;
    opacity: 1;
    transition: opacity 0.2s ease-in-out;
    z-index: 1070;
    ${({ $isOpening: $isOpening })=>$isOpening && (0, $lmFrL.css)`
            opacity: 1;
        `}

    // arrow positioning
  &[data-popper-placement^="top"] > {
        ${$f4c7792df46a2b80$export$fcac8f3adec6f9ce} {
            bottom: 0px;
            &::before {
                border-width: 0 6px 6px 6px;
                left: -5px;
                border-color: transparent transparent ${({ theme: theme })=>{
    var _a;
    return (_a = theme.tooltip) === null || _a === void 0 ? void 0 : _a.backgroundColor;
}} transparent;
                rotate: 180deg;
            }
        }
    }
    &[data-popper-placement^='bottom'] > {
        ${$f4c7792df46a2b80$export$fcac8f3adec6f9ce} {
            top: -6px;
            &::before {
                left: -5px;
                border-width: 0 6px 6px 6px;
                border-color: transparent transparent ${({ theme: theme })=>{
    var _a;
    return (_a = theme.tooltip) === null || _a === void 0 ? void 0 : _a.backgroundColor;
}} transparent;
            }
        }
    }
    &[data-popper-placement^='left'] > {
        ${$f4c7792df46a2b80$export$fcac8f3adec6f9ce} {
            right: 0px;
            &::before {
                border-width: 6px 0 6px 6px;
                top: -5px;
                border-color: transparent transparent transparent ${({ theme: theme })=>{
    var _a;
    return (_a = theme.tooltip) === null || _a === void 0 ? void 0 : _a.backgroundColor;
}};
            }
        }
    }
    &[data-popper-placement^='right'] > {
        ${$f4c7792df46a2b80$export$fcac8f3adec6f9ce} {
            left: -6px;
            &::before {
                border-width: 6px 6px 6px 0;
                top: -5px;
                border-color: transparent ${({ theme: theme })=>{
    var _a;
    return (_a = theme.tooltip) === null || _a === void 0 ? void 0 : _a.backgroundColor;
}} transparent transparent;
            }
        }
    }
    // arrow visibility
    [data-popper-reference-hidden='true'] > {
        ${$f4c7792df46a2b80$export$fcac8f3adec6f9ce} {
            visibility: hidden;
        }
    }
`;


const $c45479af7dd701b2$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((_a, ref)=>{
    var { placement: placement = "auto", children: children, target: target, autoHide: autoHide = true, popperModifiers: popperModifiers, theme: theme, popperOptions: popperOptions = {
        strategy: "absolute"
    }, usePortal: usePortal } = _a, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "placement",
        "children",
        "target",
        "autoHide",
        "popperModifiers",
        "theme",
        "popperOptions",
        "usePortal"
    ]);
    const [referenceElement, setReferenceElement] = (0, $acw62.useState)(null);
    const [popperElement, setPopperElement] = (0, $acw62.useState)(null);
    const [arrowElement, setArrowElement] = (0, $acw62.useState)(null);
    const [open, setOpen] = (0, $acw62.useState)(false);
    const [mounted, setMounted] = (0, $acw62.useState)(false);
    const [isOpening, setIsOpening] = (0, $acw62.useState)(false);
    const tooltipHovered = (0, $acw62.useRef)(false);
    const getPopperModifiers = ()=>{
        return popperModifiers && popperModifiers.length > 0 ? popperModifiers : [];
    };
    const { styles: styles, attributes: attributes } = (0, $83ae1b51e5ada323$export$f4d5bf230a36dd6e)(referenceElement, popperElement, Object.assign(Object.assign({
        placement: placement
    }, popperOptions), {
        modifiers: [
            {
                name: "offset",
                options: {
                    offset: [
                        0,
                        8
                    ]
                }
            },
            {
                name: "arrow",
                options: {
                    element: arrowElement
                }
            },
            ...getPopperModifiers()
        ]
    }));
    const handleMouseEnterPopover = ()=>{
        if (autoHide) return;
        tooltipHovered.current = true;
    };
    const handleMouseLeavePopover = ()=>{
        if (autoHide) return;
        setIsOpening(false);
        tooltipHovered.current = false;
        setTimeout(()=>{
            setOpen(false);
        }, 200);
    };
    const handleMouseEnter = ()=>{
        setOpen(true);
        setIsOpening(true);
    };
    const handleMouseLeave = ()=>{
        setTimeout(()=>{
            if (!tooltipHovered.current) {
                setIsOpening(false);
                setTimeout(()=>{
                    setOpen(false);
                }, 200);
            }
        }, 100);
    };
    const handleKeyDown = (e)=>{
        if (e.key === "Escape") setOpen(false);
    };
    (0, $acw62.useEffect)(()=>{
        if (!target || typeof target !== "object" && typeof target !== "string") return;
        const targetAsMutableRef = target;
        const targetElement = typeof target === "object" ? targetAsMutableRef.current ? target === null || target === void 0 ? void 0 : target.current : target : document.getElementById(target);
        if (!targetElement) return;
        setReferenceElement(targetElement);
        if (!mounted) return;
        targetElement.addEventListener("mouseenter", handleMouseEnter);
        targetElement.addEventListener("mouseleave", handleMouseLeave);
        targetElement.addEventListener("focus", handleMouseEnter);
        targetElement.addEventListener("blur", handleMouseLeave);
        targetElement.addEventListener("keydown", handleKeyDown);
        return ()=>{
            targetElement.removeEventListener("mouseenter", handleMouseEnter);
            targetElement.removeEventListener("mouseleave", handleMouseLeave);
            targetElement.removeEventListener("focus", handleMouseEnter);
            targetElement.removeEventListener("blur", handleMouseLeave);
            targetElement.removeEventListener("keydown", handleKeyDown);
        };
    }, [
        target,
        mounted
    ]);
    (0, $acw62.useEffect)(()=>{
        setMounted(true);
        return ()=>{
            setMounted(false);
        };
    }, []);
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            api: {
                open: ()=>{
                    setOpen(true);
                },
                close: ()=>{
                    setOpen(false);
                },
                toggle: ()=>{
                    setOpen(!open);
                }
            }
        }));
    const tooltipElement = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f4c7792df46a2b80$export$353e9bd501be795b), Object.assign({
        ref: setPopperElement,
        style: styles.popper,
        "$isOpening": isOpening,
        onMouseEnter: ()=>handleMouseEnterPopover(),
        onMouseLeave: ()=>handleMouseLeavePopover(),
        theme: theme,
        role: "tooltip"
    }, attributes.popper, rest), children, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f4c7792df46a2b80$export$fcac8f3adec6f9ce), {
        ref: setArrowElement,
        style: styles.arrow
    }));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, isOpening && (usePortal ? (0, $1u0KT.createPortal)(tooltipElement, document.body) : tooltipElement));
});
$c45479af7dd701b2$export$2e2bcd8739ae039.displayName = "Tooltip";


const $f21d57b7f42621ec$export$205fdb7061a74757 = (_a)=>{
    var { itemsSelected: itemsSelected } = _a, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "itemsSelected"
    ]);
    const badgeRef = (0, $acw62.useRef)(null);
    const { floatingActionBarState: floatingActionBarState, labels: labels } = (0, $acw62.useContext)((0, $02d92cc08424ac42$export$d28a545f4f7481ab));
    const { screenWidth: screenWidth } = (0, $4a83e0424f376680$export$162d9a1f1cb5190c)();
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c45479af7dd701b2$export$2e2bcd8739ae039), {
        target: badgeRef.current,
        placement: "top"
    }, (labels === null || labels === void 0 ? void 0 : labels.deselectAll) || "Deselect All"), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33f706d0a52b4965$export$9aa64a078c634765), Object.assign({}, rest), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, itemsSelected ? itemsSelected : "")), screenWidth > floatingActionBarState.mobileBreakpoint && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", {
        className: "helix-floating-action-bar__badge-close-label"
    }, (labels === null || labels === void 0 ? void 0 : labels.selected) || "Selected"));
};
$f21d57b7f42621ec$export$205fdb7061a74757.displayName = "FloatingActionBarBadge";




var $acw62 = parcelRequire("acw62");





const $bde7f97280164b51$export$236efa2a1f410bca = (_a)=>{
    var { onDismiss: onDismiss } = _a, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "onDismiss"
    ]);
    const closeButtonRef = (0, $acw62.useRef)(null);
    const { dispatchFloatingActionBarState: dispatchFloatingActionBarState, labels: labels } = (0, $acw62.useContext)((0, $02d92cc08424ac42$export$d28a545f4f7481ab));
    (0, $acw62.useEffect)(()=>{
        var _a;
        dispatchFloatingActionBarState({
            type: "ADD_TO_TOOLBAR_ITEMS",
            payload: {
                id: "close",
                label: "close",
                icon: null,
                el: closeButtonRef.current,
                width: (_a = closeButtonRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth,
                visible: true
            }
        });
    }, [
        closeButtonRef
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c45479af7dd701b2$export$2e2bcd8739ae039), {
        target: closeButtonRef.current,
        placement: "top",
        popperModifiers: [
            {
                name: "offset",
                options: {
                    offset: [
                        0,
                        25
                    ]
                }
            }
        ]
    }, (labels === null || labels === void 0 ? void 0 : labels.deselectAll) || "Deselect All"), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33f706d0a52b4965$export$24bcaebc6f670c8f), Object.assign({
        "aria-label": (labels === null || labels === void 0 ? void 0 : labels.deselectAll) || "Deselect All",
        ref: closeButtonRef,
        tabIndex: -1
    }, rest, {
        onClick: (e)=>{
            onDismiss && onDismiss(e);
        }
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("span", null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
        icon: (0, $c761e69c8e58189a$exports.x_small)
    }))));
};
$bde7f97280164b51$export$236efa2a1f410bca.displayName = "FloatingActionBarCloseButton";


const $90bb4c3809efe1e8$export$2e2bcd8739ae039 = (_a)=>{
    var { children: children, labels: labels } = _a, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "children",
        "labels"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $02d92cc08424ac42$export$b1f683f8fbc771ec), {
        labels: labels
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($90bb4c3809efe1e8$var$FloatingActionBarInner, Object.assign({}, rest), children));
};
const $90bb4c3809efe1e8$var$FloatingActionBarInner = ({ children: children, show: show = false, itemsSelected: itemsSelected = 0, onDismiss: onDismiss })=>{
    var _a;
    const { floatingActionBarState: floatingActionBarState, dispatchFloatingActionBarState: dispatchFloatingActionBarState } = (0, $acw62.useContext)((0, $02d92cc08424ac42$export$d28a545f4f7481ab));
    const [menuItems, setMenuItems] = (0, $acw62.useState)([]);
    const floatingActionBarRef = (0, $acw62.useRef)(null);
    const floatingActionBarOuterRef = (0, $acw62.useRef)(null);
    const firstLoad = (0, $acw62.useRef)(true);
    const floatingActionBarItemContainerRef = (0, $acw62.useRef)(null);
    const moreButtonRef = (0, $acw62.useRef)(null);
    const createArrayFromChildren = (children)=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(children, (child)=>{
            var _a, _b, _c, _d;
            if (((_a = child === null || child === void 0 ? void 0 : child.type) === null || _a === void 0 ? void 0 : _a.displayName) === "FloatingActionBarItem" || ((_c = (_b = child === null || child === void 0 ? void 0 : child.props) === null || _b === void 0 ? void 0 : _b.originalType) === null || _c === void 0 ? void 0 : _c.displayName) === "FloatingActionBarItem") {
                const item = {
                    id: child.props.id,
                    label: child.props.label,
                    icon: child.props.icon,
                    onClick: child.props.onClick
                };
                // if the item is already in the menuItems array then don't add it again
                if (menuItems.find((item)=>item.id === child.props.id)) return;
                setMenuItems((prev)=>[
                        ...prev,
                        item
                    ]);
            } else {
                if (!((_d = child === null || child === void 0 ? void 0 : child.props) === null || _d === void 0 ? void 0 : _d.children)) return;
                createArrayFromChildren(child.props.children);
            }
        });
    };
    // skip test coverage for this line as it has to do with resizing the window
    // istanbul ignore next
    const handleResize = ()=>{
        var _a, _b;
        // get the space before and after the floatingActionBarOuterRef
        const spaceBefore = ((_a = floatingActionBarOuterRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().left) || 0;
        const spaceAfter = window.innerWidth - (((_b = floatingActionBarOuterRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().right) || 0);
        // get the first element in the more items list
        const firstMoreItem = floatingActionBarState.moreItems[0];
        if (!firstMoreItem) return;
        const itemWidthToAddBack = floatingActionBarState.hiddenItemsWidths.find((item)=>item.id === firstMoreItem.id);
        if (!itemWidthToAddBack) return;
        // if there is enough space to move the item back to the toolbar then do so
        if (spaceBefore + spaceAfter > itemWidthToAddBack.width + 20) {
            dispatchFloatingActionBarState({
                type: "REMOVE_FROM_MORE_ITEMS",
                payload: Object.assign({}, firstMoreItem)
            });
            dispatchFloatingActionBarState({
                type: "REMOVE_HIDDEN_ITEMS_WIDTHS",
                payload: {
                    id: firstMoreItem.id
                }
            });
            dispatchFloatingActionBarState({
                type: "SET_TOOLBAR_ITEM_VISIBILITY",
                payload: {
                    id: firstMoreItem.id,
                    visible: true
                }
            });
            return;
        }
    };
    // skip test coverage for this line as it has to do with resizing the window
    /* istanbul ignore next */ const handleIntersection = (entries)=>{
        entries.forEach((entry)=>{
            var _a;
            const entryAsHTMLElement = entry.target;
            const item = floatingActionBarState.toolbarItems.find((item)=>item.id === entryAsHTMLElement.dataset.tagId);
            if (!entry.isIntersecting) {
                if (firstLoad.current) {
                    dispatchFloatingActionBarState({
                        type: "ADD_TO_MORE_ITEMS_FIRST_LOAD",
                        payload: Object.assign({}, item)
                    });
                    return;
                }
                if (!item) return;
                if (floatingActionBarState.hiddenItemsWidths.filter((item)=>item.id === entryAsHTMLElement.dataset.tagId).length > 0) return;
                dispatchFloatingActionBarState({
                    type: "ADD_HIDDEN_ITEMS_WIDTHS",
                    payload: {
                        id: item.id,
                        width: entryAsHTMLElement.offsetWidth
                    }
                });
                dispatchFloatingActionBarState({
                    type: "ADD_TO_MORE_ITEMS",
                    payload: Object.assign(Object.assign({}, item), {
                        onClick: (_a = menuItems.find((menuItem)=>menuItem.id === item.id)) === null || _a === void 0 ? void 0 : _a.onClick
                    })
                });
                dispatchFloatingActionBarState({
                    type: "SET_TOOLBAR_ITEM_VISIBILITY",
                    payload: {
                        id: item.id,
                        visible: false
                    }
                });
            }
        });
        firstLoad.current = false;
    };
    (0, $acw62.useEffect)(()=>{
        if (!show) return;
        if (!floatingActionBarItemContainerRef.current) return;
        const observer = new IntersectionObserver(handleIntersection, {
            root: floatingActionBarRef.current,
            threshold: 1,
            rootMargin: "5%"
        });
        Array.from(floatingActionBarItemContainerRef.current.children).forEach((child)=>{
            const item = child;
            if (item.dataset.tagId) observer.observe(item);
        });
        window.addEventListener("resize", handleResize);
        return ()=>{
            observer.disconnect();
            window.removeEventListener("resize", handleResize);
        };
    }, [
        floatingActionBarItemContainerRef.current,
        floatingActionBarRef.current,
        children,
        moreButtonRef.current,
        (_a = floatingActionBarRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth,
        floatingActionBarState.toolbarItems,
        show
    ]);
    (0, $acw62.useEffect)(()=>{
        createArrayFromChildren(children);
    }, [
        children,
        floatingActionBarState.barVisible
    ]);
    // skip test coverage for this line as it has to do with resizing the window
    /* istanbul ignore next */ (0, $acw62.useEffect)(()=>{
        if (floatingActionBarState.moreItems.length === 0) dispatchFloatingActionBarState({
            type: "SET_HAS_MORE_ITEMS",
            payload: false
        });
        else dispatchFloatingActionBarState({
            type: "SET_HAS_MORE_ITEMS",
            payload: true
        });
    }, [
        floatingActionBarState.moreItems
    ]);
    (0, $acw62.useEffect)(()=>{
        if (show) {
            dispatchFloatingActionBarState({
                type: "SET_TOGGLE_BAR_VISIBILITY",
                payload: "opening"
            });
            if (firstLoad.current) return;
            setTimeout(()=>{
                dispatchFloatingActionBarState({
                    type: "SET_TOGGLE_BAR_VISIBILITY",
                    payload: "open"
                });
            }, 300);
        } else if (!firstLoad.current && floatingActionBarState.barVisible === "open" || floatingActionBarState.barVisible === "opening") {
            dispatchFloatingActionBarState({
                type: "SET_TOGGLE_BAR_VISIBILITY",
                payload: "closing"
            });
            setTimeout(()=>{
                /* istanbul ignore next */ dispatchFloatingActionBarState({
                    type: "SET_TOGGLE_BAR_VISIBILITY",
                    payload: "closed"
                });
            }, 300);
        }
        firstLoad.current = false;
    }, [
        show
    ]);
    const handleKeyDown = (e)=>{
        switch(e.key){
            case "Escape":
                e.preventDefault();
                if (floatingActionBarState.moreMenuOpen) return;
                onDismiss === null || onDismiss === void 0 || onDismiss(e);
                break;
            case "Home":
                {
                    e.preventDefault();
                    // focus the first item
                    const firstItem = floatingActionBarState.toolbarItems[0];
                    const firstId = firstItem === null || firstItem === void 0 ? void 0 : firstItem.id;
                    const firstEl = firstItem === null || firstItem === void 0 ? void 0 : firstItem.el;
                    // if the more is open return
                    if (floatingActionBarState.moreMenuOpen) return;
                    if (firstId && firstEl) {
                        dispatchFloatingActionBarState({
                            type: "SET_ACTIVE_ITEM",
                            payload: firstId
                        });
                        firstEl === null || firstEl === void 0 || firstEl.focus();
                    }
                    break;
                }
            case "End":
                {
                    e.preventDefault();
                    // focus the last item
                    // if the more is open return
                    if (floatingActionBarState.moreMenuOpen) return;
                    const lastItem = floatingActionBarState.toolbarItems[floatingActionBarState.toolbarItems.length - 1];
                    const lastId = lastItem === null || lastItem === void 0 ? void 0 : lastItem.id;
                    const lastEl = lastItem === null || lastItem === void 0 ? void 0 : lastItem.el;
                    if (lastId && lastEl) {
                        dispatchFloatingActionBarState({
                            type: "SET_ACTIVE_ITEM",
                            payload: lastId
                        });
                        lastEl === null || lastEl === void 0 || lastEl.focus();
                    }
                    break;
                }
            case "ArrowLeft":
                {
                    e.preventDefault();
                    // focus the previous item
                    const activeItem = floatingActionBarState.activeItem;
                    const visibleFloatingActionBarItems = floatingActionBarState.toolbarItems.filter((item)=>item.visible);
                    const activeItemIndex = visibleFloatingActionBarItems.findIndex((item)=>item.id === activeItem);
                    const prevItem = visibleFloatingActionBarItems[activeItemIndex - 1];
                    const prevId = prevItem === null || prevItem === void 0 ? void 0 : prevItem.id;
                    const prevEl = prevItem === null || prevItem === void 0 ? void 0 : prevItem.el;
                    // if on the first item, focus the last item
                    if (activeItemIndex === 0) {
                        // if there is a more button, focus that
                        const lastItem = visibleFloatingActionBarItems[visibleFloatingActionBarItems.length - 1];
                        const lastId = lastItem === null || lastItem === void 0 ? void 0 : lastItem.id;
                        const lastEl = lastItem === null || lastItem === void 0 ? void 0 : lastItem.el;
                        if (lastId && lastEl) {
                            dispatchFloatingActionBarState({
                                type: "SET_ACTIVE_ITEM",
                                payload: lastId
                            });
                            lastEl === null || lastEl === void 0 || lastEl.focus();
                        }
                        return;
                    }
                    if (prevId && prevEl) {
                        dispatchFloatingActionBarState({
                            type: "SET_ACTIVE_ITEM",
                            payload: prevId
                        });
                        prevEl === null || prevEl === void 0 || prevEl.focus();
                    }
                    break;
                }
            case "ArrowRight":
                {
                    e.preventDefault();
                    e.stopPropagation();
                    // focus the next item
                    const activeItem = floatingActionBarState.activeItem;
                    const visibleFloatingActionBarItems = floatingActionBarState.toolbarItems.filter((item)=>item.visible);
                    const activeItemIndex = visibleFloatingActionBarItems.findIndex((item)=>item.id === activeItem);
                    const nextItem = visibleFloatingActionBarItems[activeItemIndex + 1];
                    const nextId = nextItem === null || nextItem === void 0 ? void 0 : nextItem.id;
                    const nextEl = nextItem === null || nextItem === void 0 ? void 0 : nextItem.el;
                    // if on the last item, focus the first item
                    if (activeItemIndex === visibleFloatingActionBarItems.length - 1) {
                        const firstItem = visibleFloatingActionBarItems[0];
                        const firstId = firstItem === null || firstItem === void 0 ? void 0 : firstItem.id;
                        const firstEl = firstItem === null || firstItem === void 0 ? void 0 : firstItem.el;
                        if (firstId && firstEl) {
                            dispatchFloatingActionBarState({
                                type: "SET_ACTIVE_ITEM",
                                payload: firstId
                            });
                            firstEl === null || firstEl === void 0 || firstEl.focus();
                        }
                        return;
                    }
                    if (nextId && nextEl) {
                        dispatchFloatingActionBarState({
                            type: "SET_ACTIVE_ITEM",
                            payload: nextId
                        });
                        nextEl === null || nextEl === void 0 || nextEl.focus();
                    }
                    break;
                }
        }
    };
    // get everything before the more button from children
    const getToolbarItemsBeforeMore = ()=>{
        // filter out everything after the item with the display name FloatingActionBarMoreItem
        const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray(children);
        const moreIndex = childrenArray.findIndex((child)=>{
            var _a;
            return ((_a = child === null || child === void 0 ? void 0 : child.type) === null || _a === void 0 ? void 0 : _a.displayName) === "FloatingActionBarMore";
        });
        const toolbarItems = childrenArray.slice(0, moreIndex);
        return moreIndex === -1 ? childrenArray : toolbarItems;
    };
    // get everything after the more button from children
    const getToolbarItemsAfterMore = ()=>{
        // filter out everything after the item with the display name FloatingActionBarMoreItem
        const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray(children);
        const moreIndex = childrenArray.findIndex((child)=>{
            var _a;
            return ((_a = child === null || child === void 0 ? void 0 : child.type) === null || _a === void 0 ? void 0 : _a.displayName) === "FloatingActionBarMore";
        });
        const toolbarItems = childrenArray.slice(moreIndex + 1);
        return toolbarItems;
    };
    const hasMoreMenu = ()=>{
        const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray(children);
        const moreIndex = childrenArray.findIndex((child)=>{
            var _a;
            return ((_a = child === null || child === void 0 ? void 0 : child.type) === null || _a === void 0 ? void 0 : _a.displayName) === "FloatingActionBarMore";
        });
        return moreIndex !== -1;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33f706d0a52b4965$export$6ca0d94343fe1be4), {
        openingState: floatingActionBarState.barVisible,
        className: "helix-floating-action-bar",
        ref: floatingActionBarOuterRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33f706d0a52b4965$export$c3d3f1205082dd48), {
        tabIndex: 0,
        role: "toolbar",
        "aria-hidden": !show,
        "aria-label": "Actions",
        "aria-live": "polite",
        "aria-orientation": "horizontal",
        onKeyDown: handleKeyDown,
        onFocus: (e)=>{
            var _a, _b, _c;
            // if the focus in inside the do nothing
            // if the focused item is a child of the floating action bar, do nothing
            if ((_a = floatingActionBarRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target)) return;
            if (e.target.classList.contains("helix-floating-action-bar__dropdown-menu")) return;
            const firstItem = floatingActionBarState.toolbarItems[0];
            const firstId = firstItem === null || firstItem === void 0 ? void 0 : firstItem.id;
            const firstEl = firstItem === null || firstItem === void 0 ? void 0 : firstItem.el;
            if (floatingActionBarState.activeItem) {
                // focus the active item
                const activeItem = floatingActionBarState.activeItem;
                const activeItemIndex = floatingActionBarState.toolbarItems.findIndex((item)=>item.id === activeItem);
                const activeItemEl = (_b = floatingActionBarState.toolbarItems[activeItemIndex]) === null || _b === void 0 ? void 0 : _b.el;
                const focusedEl = document.activeElement;
                // if active item is more find the more button
                if (activeItem === "More" && focusedEl.tagName !== "UL") {
                    const moreButton = (_c = moreButtonRef.current) === null || _c === void 0 ? void 0 : _c.querySelector("button");
                    moreButton === null || moreButton === void 0 || moreButton.focus();
                    return;
                }
                if ((focusedEl === null || focusedEl === void 0 ? void 0 : focusedEl.tagName) === "BUTTON" || focusedEl.tagName === "UL") return;
                activeItemEl === null || activeItemEl === void 0 || activeItemEl.focus();
                return;
            }
            if (firstId && firstEl) {
                dispatchFloatingActionBarState({
                    type: "SET_ACTIVE_ITEM",
                    payload: firstId
                });
                firstEl === null || firstEl === void 0 || firstEl.focus();
            }
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $f21d57b7f42621ec$export$205fdb7061a74757), {
        itemsSelected: itemsSelected
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33f706d0a52b4965$export$1cb06e19255977b), {
        ref: floatingActionBarRef
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33f706d0a52b4965$export$babb72c82316a267), {
        ref: floatingActionBarItemContainerRef
    }, getToolbarItemsBeforeMore().map((child)=>{
        var _a;
        if (child && ((_a = child === null || child === void 0 ? void 0 : child.type) === null || _a === void 0 ? void 0 : _a.displayName) !== "FloatingActionBarMore") return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(child, {});
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(children, (child, index)=>{
        var _a;
        if (child && ((_a = child === null || child === void 0 ? void 0 : child.type) === null || _a === void 0 ? void 0 : _a.displayName) === "FloatingActionBarMore") {
            if (!child.props.children && floatingActionBarState.moreItems.length === 0) return null;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
                ref: moreButtonRef,
                style: {
                    display: "flex"
                }
            }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(child, Object.assign(Object.assign({}, child.props), {
                index: index
            })));
        }
    }), hasMoreMenu() && getToolbarItemsAfterMore().map((child)=>{
        var _a;
        if (child && ((_a = child === null || child === void 0 ? void 0 : child.type) === null || _a === void 0 ? void 0 : _a.displayName) !== "FloatingActionBarMore") return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(child, {});
    }), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $bde7f97280164b51$export$236efa2a1f410bca), {
        onDismiss: onDismiss
    }))));
};
$90bb4c3809efe1e8$export$2e2bcd8739ae039.displayName = "FloatingActionBar";



var $acw62 = parcelRequire("acw62");





const $196e1ab7d9aee80a$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((_a, ref)=>{
    var _b;
    var { icon: icon, label: label, id: id, tooltip: tooltip, tooltipAlwaysVisible: tooltipAlwaysVisible } = _a, rest = (0, $5c96a02c592fcff1$export$3c9a16f847548506)(_a, [
        "icon",
        "label",
        "id",
        "tooltip",
        "tooltipAlwaysVisible"
    ]);
    const buttonRef = (0, $acw62.useRef)(null);
    const { floatingActionBarState: floatingActionBarState, dispatchFloatingActionBarState: dispatchFloatingActionBarState } = (0, $acw62.useContext)((0, $02d92cc08424ac42$export$d28a545f4f7481ab));
    (0, $acw62.useImperativeHandle)(ref, ()=>buttonRef);
    const { screenWidth: screenWidth } = (0, $4a83e0424f376680$export$162d9a1f1cb5190c)();
    (0, $acw62.useEffect)(()=>{
        var _a;
        dispatchFloatingActionBarState({
            type: "ADD_TO_TOOLBAR_ITEMS",
            payload: {
                id: id,
                label: label,
                icon: icon,
                visible: true,
                el: buttonRef.current,
                width: (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth
            }
        });
    }, [
        icon,
        label,
        id,
        buttonRef
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (tooltip && screenWidth < floatingActionBarState.mobileBreakpoint || tooltipAlwaysVisible) && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c45479af7dd701b2$export$2e2bcd8739ae039), {
        target: buttonRef,
        popperModifiers: [
            {
                name: "offset",
                options: {
                    offset: [
                        0,
                        20
                    ]
                }
            }
        ],
        placement: "top"
    }, tooltip), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $33f706d0a52b4965$export$b7aa47e99283a364), Object.assign({}, rest, {
        ref: buttonRef,
        "data-tag-id": id,
        tabIndex: -1,
        style: {
            display: !((_b = floatingActionBarState.toolbarItems.find((item)=>item.id === id)) === null || _b === void 0 ? void 0 : _b.visible) ? "none" : "flex"
        }
    }), icon && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
        icon: icon,
        "aria-hidden": "true"
    }), label && screenWidth > floatingActionBarState.mobileBreakpoint && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("p", null, label)));
});
$196e1ab7d9aee80a$export$2e2bcd8739ae039.displayName = "FloatingActionBarItem";



var $eOjgM = parcelRequire("eOjgM");
parcelRequire("amkL4");
var $3QXz5 = parcelRequire("3QXz5");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $f61ig = parcelRequire("f61ig");

var $dI25G = parcelRequire("dI25G");

var $eOjgM = parcelRequire("eOjgM");
parcelRequire("fHiKR");
var $1BYDb = parcelRequire("1BYDb");

var $90ISC = parcelRequire("90ISC");

var $eHBjM = parcelRequire("eHBjM");

var $cstaF = parcelRequire("cstaF");

var $jpGV2 = parcelRequire("jpGV2");

var $koMgC = parcelRequire("koMgC");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $f61ig = parcelRequire("f61ig");
parcelRequire("fHiKR");
var $5txPe = parcelRequire("5txPe");

var $eHBjM = parcelRequire("eHBjM");

var $cstaF = parcelRequire("cstaF");

var $90ISC = parcelRequire("90ISC");

var $jeANf = parcelRequire("jeANf");

var $koMgC = parcelRequire("koMgC");
const $6e8dfa467ad3bd19$var$NewAgentListModal = ({ isModalOpen: isModalOpen, onClose: onClose, setShowAddToListModal: setShowAddToListModal, setShowNewListModal: setShowNewListModal, setToastProps: setToastProps })=>{
    const { agentLists: agentLists, createAgentsList: createAgentsList } = (0, $90ISC.useCommonStore)((state)=>({
            agentLists: state.agentLists,
            createAgentsList: state.createAgentsList
        }));
    const { mlsId: mlsId, selectedAgentIds: selectedAgentIds } = (0, $90ISC.useSearchStore)((state)=>({
            mlsId: state[state.selectedModule]?.search?.mlsId,
            selectedAgentIds: (0, $koMgC.getSelectedAgentIds)(state) ?? []
        }));
    const [listName, setListName] = (0, $acw62.useState)("");
    const [isSaveBtnDisable, setIsSaveBtnDisabled] = (0, $acw62.useState)(true);
    const NEW_LIST_MAX_LENGTH = 55;
    const handleClose = ()=>{
        onClose();
        setListName("");
        setIsSaveBtnDisabled(true);
    };
    const onListNameChange = (v)=>{
        const listName = v.target.value;
        setListName(listName);
        setIsSaveBtnDisabled(!listName.trim()?.length);
    };
    const handleSave = async ()=>{
        const trimmedName = listName.trim();
        const isDuplicatedName = agentLists?.filter((l)=>l?.mlsId === mlsId).some((l)=>l?.name?.toLocaleLowerCase() === trimmedName.toLocaleLowerCase() || trimmedName.toLocaleLowerCase() === (0, $eHBjM.favoriteAgentTerms).reservedListName.toLocaleLowerCase());
        if (isDuplicatedName) {
            (0, $jeANf.showToast)((0, $jeANf.toastTypes).error, (0, $eHBjM.favoriteAgentTerms).duplicatedName, setToastProps);
            return;
        }
        try {
            const response = await createAgentsList(mlsId, trimmedName, selectedAgentIds);
            const hasError = !response || response.error;
            if (hasError) (0, $jeANf.showToast)((0, $jeANf.toastTypes).error, (0, $eHBjM.favoriteAgentTerms).unableToCreateList, setToastProps);
            else {
                setListName("");
                setIsSaveBtnDisabled(true);
                (0, $jeANf.showToast)((0, $jeANf.toastTypes).success, (0, $eHBjM.favoriteAgentTerms).agentListCreated(trimmedName), setToastProps);
            }
        } catch (err) {
            (0, $jeANf.showToast)((0, $jeANf.toastTypes).error, (0, $eHBjM.favoriteAgentTerms).unableToCreateList, setToastProps);
        }
        setShowAddToListModal(false);
        setShowNewListModal(false);
    };
    const children = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "font-weight-bold",
                children: (0, $eHBjM.favoriteAgentTerms).newList
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "d-flex align-items-center justify-space-between",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5txPe))), {
                    onChange: onListNameChange,
                    placeholder: (0, $eHBjM.favoriteAgentTerms).typeNewList,
                    value: listName,
                    maxLength: NEW_LIST_MAX_LENGTH
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                children: (0, $eHBjM.favoriteAgentTerms).chooseNameNewList
            })
        ]
    });
    const modalTitle = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "mb-0",
                children: (0, $eHBjM.favoriteAgentTerms).createList
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "modal-subtitle",
                children: (0, $eHBjM.favoriteAgentTerms).selectedAgentsSavedNewList
            })
        ]
    });
    const buttons = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                dataLwtId: "cancel-create-new-agent-list",
                color: "secondary",
                onClick: handleClose,
                children: (0, $cstaF.buttonTerms).cancel
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                className: "d-flex align-items-center justify-content-center",
                color: "primary",
                dataLwtId: "save-create-new-agent-list",
                disabled: isSaveBtnDisable,
                onClick: handleSave,
                children: (0, $cstaF.buttonTerms).save
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f61ig.default), {
        buttons: buttons,
        show: isModalOpen,
        title: modalTitle,
        onClose: handleClose,
        children: children
    });
};
$6e8dfa467ad3bd19$var$NewAgentListModal.propTypes = {
    isModalOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    setShowAddToListModal: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    setShowNewListModal: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    setToastProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};
var $6e8dfa467ad3bd19$export$2e2bcd8739ae039 = $6e8dfa467ad3bd19$var$NewAgentListModal;


const $229f8a8141435165$var$SavedAgentListsModal = ({ shouldShowModal: shouldShowModal, onClose: onClose, selectedCount: selectedCount, setToastProps: setToastProps })=>{
    const { agentLists: agentLists } = (0, $90ISC.useCommonStore)((state)=>({
            agentLists: state.agentLists
        }));
    const { mlsId: mlsId, selectedAgentIds: selectedAgentIds } = (0, $90ISC.useSearchStore)((state)=>({
            mlsId: state[state.selectedModule]?.search?.mlsId,
            selectedAgentIds: (0, $koMgC.getSelectedAgentIds)(state) ?? []
        }));
    const { setSavedAgentList: setSavedAgentList } = (0, $jpGV2.useSavedAgentsStore)((state)=>({
            setSavedAgentList: state.setSavedAgentList
        }));
    const [checkedListIds, setCheckedListIds] = (0, $acw62.useState)({});
    const [isSaveBtnDisable, setIsSaveBtnDisable] = (0, $acw62.useState)(false);
    const [showNewListModal, setShowNewListModal] = (0, $acw62.useState)(false);
    const filteredLists = agentLists?.filter((list)=>list?.mlsId === mlsId) || [];
    const hasLists = filteredLists.length > 0;
    const SAVED_AGENTS_LIST_MAX_LIMIT = 2000;
    (0, $acw62.useEffect)(()=>{
        if (shouldShowModal) {
            setCheckedListIds({});
            setShowNewListModal(false);
        }
    }, [
        shouldShowModal
    ]);
    (0, $acw62.useEffect)(()=>{
        setIsSaveBtnDisable(Object.values(checkedListIds).includes(true));
    }, [
        checkedListIds
    ]);
    const handleClose = ()=>{
        setCheckedListIds({});
        setShowNewListModal(false);
        onClose();
    };
    const handleSave = ()=>{
        const savedAgentListIds = Object.keys(checkedListIds).filter((listId)=>!!checkedListIds[listId]);
        if (isSaveBtnDisable) {
            setSavedAgentList({
                savedAgentListIds: savedAgentListIds,
                selectedCount: selectedCount,
                selectedAgentIds: selectedAgentIds,
                setToastProps: setToastProps
            });
            onClose();
        }
    };
    const handleCheckboxChange = (listId)=>{
        setCheckedListIds((prev)=>({
                ...prev,
                [listId]: !prev[listId]
            }));
    };
    const renderedCheckboxes = filteredLists.map((list)=>{
        const agentListCount = list?.agentIds?.length;
        const { countWithLabel: countWithLabel } = (0, $eHBjM.favoriteAgentTerms).addingContactsTo(agentListCount);
        const label = `${list?.name} (${countWithLabel})`;
        const isDisabled = agentListCount === SAVED_AGENTS_LIST_MAX_LIMIT || agentListCount + selectedCount > SAVED_AGENTS_LIST_MAX_LIMIT;
        return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "pb-3 px-2",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1BYDb))), {
                checked: checkedListIds[list?.agentListId] || false,
                id: `saved-list-${list?.agentListId}`,
                label: label,
                onChange: ()=>handleCheckboxChange(list?.agentListId),
                type: (0, $eHBjM.popoverTerms).checkbox,
                disabled: isDisabled
            })
        }, list?.agentListId);
    });
    const modalButtons = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                dataLwtId: "cancel-saved-agent-lists",
                color: "secondary",
                onClick: handleClose,
                children: (0, $cstaF.buttonTerms).cancel
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                dataLwtId: "save-saved-agent-lists",
                color: "primary",
                onClick: handleSave,
                disabled: !isSaveBtnDisable,
                children: (0, $cstaF.buttonTerms).save
            })
        ]
    });
    const { prefix: prefix, countWithLabel: countWithLabel, suffix: suffix } = (0, $eHBjM.favoriteAgentTerms).addingContactsTo(selectedCount);
    const modalChildren = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "d-flex justify-content-between align-items-center mb-2",
                children: [
                    hasLists ? /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        children: [
                            prefix,
                            " ",
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: "font-weight-bold",
                                children: countWithLabel
                            }),
                            " ",
                            suffix
                        ]
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "font-weight-bold ml-auto mr-3",
                        children: (0, $eHBjM.favoriteAgentTerms).createSavedAgentList
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                        dataLwtId: "new-list-button",
                        color: "secondary",
                        className: "text-capitalize d-flex align-items-center",
                        onClick: ()=>setShowNewListModal(true),
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                                className: "mr-1",
                                icon: (0, $eOjgM.plus),
                                dataLwtId: "new-list-icon"
                            }),
                            (0, $eHBjM.favoriteAgentTerms).newList
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("hr", {
                className: "my-2"
            }),
            hasLists ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "saved-agent-lists-checkboxes overflow-auto",
                children: renderedCheckboxes
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "font-weight-normal",
                children: (0, $eHBjM.favoriteAgentTerms).emptyListDescription
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("hr", {
                className: "my-2"
            })
        ]
    });
    const modalTitle = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "mb-0",
                children: (0, $eHBjM.favoriteAgentTerms).savedAgentListsTitle
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "modal-subtitle",
                children: (0, $eHBjM.favoriteAgentTerms).savedAgentsLimitsToAddMssg
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f61ig.default), {
                buttons: modalButtons,
                onClose: handleClose,
                show: shouldShowModal && !showNewListModal,
                title: modalTitle,
                children: modalChildren
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6e8dfa467ad3bd19$export$2e2bcd8739ae039), {
                isModalOpen: showNewListModal,
                setShowNewListModal: setShowNewListModal,
                onClose: ()=>setShowNewListModal(false),
                setToastProps: setToastProps,
                setShowAddToListModal: onClose
            })
        ]
    });
};
$229f8a8141435165$var$SavedAgentListsModal.propTypes = {
    setToastProps: (0, $c9Z8w.PropTypes).func,
    shouldShowModal: (0, $c9Z8w.PropTypes).bool.isRequired,
    onClose: (0, $c9Z8w.PropTypes).func.isRequired,
    selectedCount: (0, $c9Z8w.PropTypes).number
};
var $229f8a8141435165$export$2e2bcd8739ae039 = $229f8a8141435165$var$SavedAgentListsModal;



var $eHBjM = parcelRequire("eHBjM");
const $0eb783070ef68771$var$AgentsFloatingActionBar = ({ selectedCount: selectedCount, showAddToListModal: showAddToListModal, setShowAddToListModal: setShowAddToListModal, onDismiss: onDismiss, onDownloadClick: onDownloadClick })=>{
    const [toastProps, setToastProps] = (0, $acw62.useState)(null);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $90bb4c3809efe1e8$export$2e2bcd8739ae039), {
                show: !!selectedCount,
                itemsSelected: selectedCount,
                onDismiss: onDismiss,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $196e1ab7d9aee80a$export$2e2bcd8739ae039), {
                        icon: (0, $eOjgM.add_to_list),
                        id: "addToList",
                        label: (0, $eHBjM.favoriteAgentTerms).addToList,
                        onClick: ()=>setShowAddToListModal(true)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $196e1ab7d9aee80a$export$2e2bcd8739ae039), {
                        icon: (0, $eOjgM.inbox),
                        id: "download",
                        label: (0, $eHBjM.favoriteAgentTerms).download,
                        onClick: onDownloadClick
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $229f8a8141435165$export$2e2bcd8739ae039), {
                shouldShowModal: showAddToListModal,
                onClose: ()=>setShowAddToListModal(false),
                selectedCount: selectedCount,
                setToastProps: setToastProps
            }),
            toastProps && /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3QXz5))), {
                dataLwtId: "agents-bulk-add-toast",
                toastProps: toastProps.toastProps,
                position: "toast-bottom-right"
            })
        ]
    });
};
$0eb783070ef68771$var$AgentsFloatingActionBar.propTypes = {
    selectedCount: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired,
    showAddToListModal: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    setShowAddToListModal: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    onDismiss: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onDownloadClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};
var $0eb783070ef68771$export$2e2bcd8739ae039 = $0eb783070ef68771$var$AgentsFloatingActionBar;



var $90ISC = parcelRequire("90ISC");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $d8ad2a4b51964960$exports = {};

$d8ad2a4b51964960$exports = (parcelRequire("iDZyd"));



var $fPGDZ = parcelRequire("fPGDZ");

var $htzEo = parcelRequire("htzEo");

var $eHBjM = parcelRequire("eHBjM");

var $cstaF = parcelRequire("cstaF");

var $4tbBr = parcelRequire("4tbBr");

var $cstaF = parcelRequire("cstaF");

var $eHBjM = parcelRequire("eHBjM");

var $b77Er = parcelRequire("b77Er");

var $htzEo = parcelRequire("htzEo");
const $39c8bb1c22b968df$export$e4d54ccc8b6f7428 = (selectedColumnIds)=>{
    let headers = [];
    if (!selectedColumnIds) return headers;
    const getHeaders = (agentsColumns, headers, selectedColumnIds, label, key)=>{
        const revisedHeaders = [
            ...headers
        ];
        if (!selectedColumnIds.includes(agentsColumns[key].id)) return revisedHeaders;
        revisedHeaders.push({
            label: label,
            key: agentsColumns[key].id
        });
        return revisedHeaders;
    };
    const getHeadersLocal = (headers, label, key)=>{
        return getHeaders((0, $eHBjM.agentsColumns), headers, selectedColumnIds, label, key);
    };
    headers.push({
        label: "First Name",
        key: "firstName"
    }, {
        label: "Last Name",
        key: "lastName"
    }, {
        label: "Office Name",
        key: (0, $eHBjM.agentsColumns).officeName.id
    });
    headers = getHeadersLocal(headers, "Office ID", (0, $eHBjM.agentsColumns).officeId.id);
    selectedColumnIds.includes((0, $eHBjM.agentsColumns).officeAddress.id) && headers.push({
        label: "Office Address",
        key: (0, $eHBjM.agentsColumns).officeAddress.id
    }, {
        label: "Office City",
        key: "officeCity"
    }, {
        label: "Office Zip",
        key: "officeZipCode"
    }, {
        label: "Office County",
        key: "officeCounty"
    });
    const keysToCheck = [];
    const addCheck = (label, key)=>keysToCheck.push({
            label: label,
            key: key
        });
    addCheck("Total Sell # Units", (0, $eHBjM.agentsColumns).last12SellUnits.id);
    addCheck("Total Sell $ Volume", (0, $eHBjM.agentsColumns).last12SellVolume.id);
    addCheck("Total List # Units", (0, $eHBjM.agentsColumns).last12ListUnits.id);
    addCheck("Total List $ Volume", (0, $eHBjM.agentsColumns).last12ListVolume.id);
    addCheck("No PC # Units", (0, $eHBjM.agentsColumns).noPcLast12ListUnits.id);
    addCheck("No PC % of Total Units", (0, $eHBjM.agentsColumns).noPcLast12ListUnitsPct.id);
    addCheck("No PC $ Volume", (0, $eHBjM.agentsColumns).noPcLast12ListVolume.id);
    addCheck("No PC % of Total Volume", (0, $eHBjM.agentsColumns).noPcLast12ListVolumePct.id);
    addCheck("No PC DOM", (0, $eHBjM.agentsColumns).noPcLast12ListDom.id);
    addCheck("No PC CDOM", (0, $eHBjM.agentsColumns).noPcLast12ListCdom.id);
    addCheck("No PC SP/OP", (0, $eHBjM.agentsColumns).noPcLast12SpOp.id);
    addCheck("PC # Units", (0, $eHBjM.agentsColumns).pcLast12ListUnits.id);
    addCheck("PC % of Total Units", (0, $eHBjM.agentsColumns).pcLast12ListUnitsPct.id);
    addCheck("PC $ Volume", (0, $eHBjM.agentsColumns).pcLast12ListVolume.id);
    addCheck("PC % of Total Volume", (0, $eHBjM.agentsColumns).pcLast12ListVolumePct.id);
    addCheck("PC Avg DOM", (0, $eHBjM.agentsColumns).pcLast12ListDom.id);
    addCheck("PC CDOM", (0, $eHBjM.agentsColumns).pcLast12ListCdom.id);
    addCheck("PC DOM", (0, $eHBjM.agentsColumns).pcLast12ListPcDom.id);
    addCheck("PC SP/OP", (0, $eHBjM.agentsColumns).pcLast12ListSpOp.id);
    addCheck("PC SP/LP", (0, $eHBjM.agentsColumns).pcLast12ListSpLp.id);
    addCheck("Avg # PC", (0, $eHBjM.agentsColumns).pcLast12ListAvgNumPc.id);
    keysToCheck.forEach((keyValue)=>{
        headers = getHeadersLocal(headers, keyValue.label, keyValue.key);
    });
    return headers;
};
const $39c8bb1c22b968df$export$9bc591c2e56fccfc = (selectedColumnIds, customSettings)=>{
    let headers = [];
    if (!selectedColumnIds) return headers;
    const getHeaders = (agentsColumns, headers, selectedColumnIds, label, dataKey)=>{
        const revisedHeaders = [
            ...headers
        ];
        if (!selectedColumnIds.includes(agentsColumns[dataKey].id)) return revisedHeaders;
        revisedHeaders.push({
            label: label,
            key: agentsColumns[dataKey].id
        });
        return revisedHeaders;
    };
    const getHeadersLocal = (headers, label, dataKey)=>{
        return getHeaders((0, $eHBjM.agentsColumns), headers, selectedColumnIds, label, dataKey);
    };
    headers = getHeadersLocal(headers, "Agent ID", (0, $eHBjM.agentsColumns).agentId.id, (0, $eHBjM.agentsColumns).agentId.id);
    headers.push({
        label: "First Name",
        key: "firstName"
    }, {
        label: "Last Name",
        key: "lastName"
    }, {
        label: "Office Name",
        key: (0, $eHBjM.agentsColumns).officeName.id
    });
    headers = getHeadersLocal(headers, "Office ID", (0, $eHBjM.agentsColumns).officeId.id, (0, $eHBjM.agentsColumns).officeId.id);
    selectedColumnIds.includes((0, $eHBjM.agentsColumns).officeAddress.id) && headers.push({
        label: "Office Address",
        key: (0, $eHBjM.agentsColumns).officeAddress.id
    }, {
        label: "Office City",
        key: "officeCity"
    }, {
        label: "Office Zip",
        key: "officeZipCode"
    }, {
        label: "Office County",
        key: "officeCounty"
    });
    const keysToCheck = [];
    const timePeriods = (0, $b77Er.getTimeIntervalData)();
    const previousYear = timePeriods?.find((value)=>value.intervalType === "YTD")?.previous.from;
    const currentYear = timePeriods?.find((value)=>value.intervalType === "YTD")?.last.from;
    const addCheck = (label, key, dataKey)=>keysToCheck.push({
            label: label,
            key: key,
            dataKey: dataKey
        });
    // This is for Increasing decreasing producers L90 Days
    if (customSettings?.growthAnalysisPeriod === (0, $cstaF.TimePeriods)[(0, $cstaF.agentProductionTerms).last90Days]) {
        addCheck((0, $4tbBr.growthAnalysisColumnsL90d).previousPeriodTotalUnits.label, (0, $4tbBr.growthAnalysisColumnsL90d).previousPeriodTotalUnits.id, (0, $4tbBr.growthAnalysisColumnsL90d).previousPeriodTotalUnits.id);
        addCheck((0, $4tbBr.growthAnalysisColumnsL90d).totalUnits.label, (0, $4tbBr.growthAnalysisColumnsL90d).totalUnits.id, (0, $4tbBr.growthAnalysisColumnsL90d).totalUnits.id);
        addCheck((0, $4tbBr.growthAnalysisColumnsL90d).totalUnitsChange.label, (0, $4tbBr.growthAnalysisColumnsL90d).totalUnitsChange.id, (0, $4tbBr.growthAnalysisColumnsL90d).totalUnitsChange.id);
        addCheck((0, $4tbBr.growthAnalysisColumnsL90d).totalUnitsGrowth.label, (0, $4tbBr.growthAnalysisColumnsL90d).totalUnitsGrowth.id, (0, $4tbBr.growthAnalysisColumnsL90d).totalUnitsGrowth.id);
        addCheck((0, $4tbBr.growthAnalysisColumnsL90d).previousPeriodTotalVolume.label, (0, $4tbBr.growthAnalysisColumnsL90d).previousPeriodTotalVolume.id, (0, $4tbBr.growthAnalysisColumnsL90d).previousPeriodTotalVolume.id);
        addCheck((0, $4tbBr.growthAnalysisColumnsL90d).totalVolume.label, (0, $4tbBr.growthAnalysisColumnsL90d).totalVolume.id, (0, $4tbBr.growthAnalysisColumnsL90d).totalVolume.id);
        addCheck((0, $4tbBr.growthAnalysisColumnsL90d).totalVolumeChange.label, (0, $4tbBr.growthAnalysisColumnsL90d).totalVolumeChange.id, (0, $4tbBr.growthAnalysisColumnsL90d).totalVolumeChange.id);
        addCheck((0, $4tbBr.growthAnalysisColumnsL90d).totalVolumeGrowth.label, (0, $4tbBr.growthAnalysisColumnsL90d).totalVolumeGrowth.id, (0, $4tbBr.growthAnalysisColumnsL90d).totalVolumeGrowth.id);
    }
    // This is for Increasing decreasing producers LTM
    if (customSettings?.growthAnalysisPeriod === (0, $cstaF.TimePeriods)[(0, $cstaF.agentProductionTerms).last12Months]) {
        addCheck("PTM #", (0, $4tbBr.growthAnalysisColumnsLtmIncDec).previousPeriodTotalUnits.id, (0, $4tbBr.growthAnalysisColumnsLtmIncDec).previousPeriodTotalUnits.id);
        addCheck("LTM #", (0, $4tbBr.growthAnalysisColumnsLtmIncDec).totalUnits.id, (0, $4tbBr.growthAnalysisColumnsLtmIncDec).totalUnits.id);
        addCheck("Change (#)", (0, $4tbBr.growthAnalysisColumnsLtmIncDec).totalUnitsChange.id, (0, $4tbBr.growthAnalysisColumnsLtmIncDec).totalUnitsChange.id);
        addCheck("% Change (#)", (0, $4tbBr.growthAnalysisColumnsLtmIncDec).totalUnitsGrowth.id, (0, $4tbBr.growthAnalysisColumnsLtmIncDec).totalUnitsGrowth.id);
        addCheck("PTM $", (0, $4tbBr.growthAnalysisColumnsLtmIncDec).previousPeriodTotalVolume.id, (0, $4tbBr.growthAnalysisColumnsLtmIncDec).previousPeriodTotalVolume.id);
        addCheck("LTM $", (0, $4tbBr.growthAnalysisColumnsLtmIncDec).totalVolume.id, (0, $4tbBr.growthAnalysisColumnsLtmIncDec).totalVolume.id);
        addCheck("Change ($)", (0, $4tbBr.growthAnalysisColumnsLtmIncDec).totalVolumeChange.id, (0, $4tbBr.growthAnalysisColumnsLtmIncDec).totalVolumeChange.id);
        addCheck("% Change ($)", (0, $4tbBr.growthAnalysisColumnsLtmIncDec).totalVolumeGrowth.id, (0, $4tbBr.growthAnalysisColumnsLtmIncDec).totalVolumeGrowth.id);
    }
    // This is for Increasing decreasing producers YTD
    if (customSettings?.growthAnalysisPeriod === (0, $cstaF.TimePeriods)[(0, $cstaF.agentProductionTerms).yearToDate]) {
        addCheck(`YTD ${(0, $htzEo.yearFormat)(previousYear)} #`, (0, $4tbBr.growthAnalysisColumnsYtdIncDec).previousPeriodTotalUnits.id, (0, $4tbBr.growthAnalysisColumnsYtdIncDec).previousPeriodTotalUnits.id);
        addCheck(`YTD ${(0, $htzEo.yearFormat)(currentYear)} #`, (0, $4tbBr.growthAnalysisColumnsYtdIncDec).totalUnits.id, (0, $4tbBr.growthAnalysisColumnsYtdIncDec).totalUnits.id);
        addCheck("Change (#)", (0, $4tbBr.growthAnalysisColumnsYtdIncDec).totalUnitsChange.id, (0, $4tbBr.growthAnalysisColumnsYtdIncDec).totalUnitsChange.id);
        addCheck("% Change (#)", (0, $4tbBr.growthAnalysisColumnsYtdIncDec).totalUnitsGrowth.id, (0, $4tbBr.growthAnalysisColumnsYtdIncDec).totalUnitsGrowth.id);
        addCheck(`YTD ${(0, $htzEo.yearFormat)(previousYear)} $`, (0, $4tbBr.growthAnalysisColumnsYtdIncDec).previousPeriodTotalVolume.id, (0, $4tbBr.growthAnalysisColumnsYtdIncDec).previousPeriodTotalVolume.id);
        addCheck(`YTD ${(0, $htzEo.yearFormat)(currentYear)} $`, (0, $4tbBr.growthAnalysisColumnsYtdIncDec).totalVolume.id, (0, $4tbBr.growthAnalysisColumnsYtdIncDec).totalVolume.id);
        addCheck((0, $4tbBr.growthAnalysisColumnsYtdIncDec).totalVolumeChange.label, (0, $4tbBr.growthAnalysisColumnsYtdIncDec).totalVolumeChange.id, (0, $4tbBr.growthAnalysisColumnsYtdIncDec).totalVolumeChange.id);
        addCheck((0, $4tbBr.growthAnalysisColumnsYtdIncDec).totalVolumeGrowth.label, (0, $4tbBr.growthAnalysisColumnsYtdIncDec).totalVolumeGrowth.id, (0, $4tbBr.growthAnalysisColumnsYtdIncDec).totalVolumeGrowth.id);
    }
    if (customSettings?.growthAnalysisPeriod === (0, $cstaF.agentProductionTerms).last12Months) {
        addCheck("PTM #", (0, $eHBjM.agentsColumns).ptmNum.id, (0, $eHBjM.agentsColumns).ptmTotalUnits.id);
        addCheck("LTM #", (0, $eHBjM.agentsColumns).ltmNum.id, (0, $eHBjM.agentsColumns).last12TotalUnits.id);
        addCheck("Change (#)", (0, $eHBjM.agentsColumns).changeNum.id, (0, $eHBjM.agentsColumns).totalUnitsChange.id);
        addCheck("% Change (#)", (0, $eHBjM.agentsColumns).pctChangeNum.id, (0, $eHBjM.agentsColumns).totalUnitsGrowth.id);
        addCheck("PTM $", (0, $eHBjM.agentsColumns).ptm$.id, (0, $eHBjM.agentsColumns).ptmTotalVolume.id);
        addCheck("LTM $", (0, $eHBjM.agentsColumns).ltm$.id, (0, $eHBjM.agentsColumns).last12TotalVolume.id);
        addCheck("Change ($)", (0, $eHBjM.agentsColumns).change$.id, (0, $eHBjM.agentsColumns).totalVolumeChange.id);
        addCheck("% Change ($)", (0, $eHBjM.agentsColumns).pctChange$.id, (0, $eHBjM.agentsColumns).totalVolumeGrowth.id);
    }
    if (customSettings?.growthAnalysisPeriod === (0, $cstaF.agentProductionTerms).yearToDate) {
        addCheck(`YTD ${(0, $htzEo.yearFormat)(previousYear)} #`, (0, $eHBjM.agentsColumns).ytdPrevYearNum.id, (0, $eHBjM.agentsColumns).pytdTotalUnits.id);
        addCheck(`YTD ${(0, $htzEo.yearFormat)(currentYear)} #`, (0, $eHBjM.agentsColumns).ytdCurrentYearNum.id, (0, $eHBjM.agentsColumns).lytdTotalUnits.id);
        addCheck("Change (#)", (0, $eHBjM.agentsColumns).changeNum.id, (0, $eHBjM.agentsColumns).lytdPytdTotalUnitsChange.id);
        addCheck("% Change (#)", (0, $eHBjM.agentsColumns).pctChangeNum.id, (0, $eHBjM.agentsColumns).lytdPytdTotalUnitsGrowth.id);
        addCheck(`YTD ${(0, $htzEo.yearFormat)(previousYear)} $`, (0, $eHBjM.agentsColumns).ytdPrevYear$.id, (0, $eHBjM.agentsColumns).pytdTotalVolume.id);
        addCheck(`YTD ${(0, $htzEo.yearFormat)(currentYear)} $`, (0, $eHBjM.agentsColumns).ytdCurrentYear$.id, (0, $eHBjM.agentsColumns).lytdTotalVolume.id);
        addCheck("Change $", (0, $eHBjM.agentsColumns).change$.id, (0, $eHBjM.agentsColumns).lytdPytdTotalVolumeChange.id);
        addCheck("% Change $", (0, $eHBjM.agentsColumns).pctChange$.id, (0, $eHBjM.agentsColumns).lytdPytdTotalVolumeGrowth.id);
    }
    keysToCheck.forEach((keyValue)=>{
        headers = getHeadersLocal(headers, keyValue.label, keyValue.dataKey);
    });
    return headers;
};
const $39c8bb1c22b968df$export$ea07b0a740514bd4 = (selectedAgents, summaryPinnedData)=>{
    const summaryPinnedRow = {
        ...summaryPinnedData,
        firstName: (0, $cstaF.agentProductionTerms).summary
    };
    const agentData = selectedAgents.map((a)=>({
            ...a,
            ...a?.listingClosedDate ? {
                listingClosedDate: (0, $htzEo.shortDateFormatWithSlashes)(a?.listingClosedDate)
            } : {}
        }));
    return [
        ...agentData,
        summaryPinnedRow
    ];
};



var $90ISC = parcelRequire("90ISC");
const $54232d120e33969d$var$AgentsExport = ({ defaultColumns: defaultColumns, selectedAgents: selectedAgents, handleClose: handleClose, tabMode: tabMode, currentSearchDates: currentSearchDates, growthAnalysisPeriod: growthAnalysisPeriod, currentTabId: currentTabId })=>{
    const [selectedColumnIds, setSelectedColumnIds] = (0, $acw62.useState)([
        ...defaultColumns.flatMap((c)=>c.isDisplayed ? c.id : [])
    ]);
    const selectedModule = (0, $90ISC.useSearchStore)((state)=>state.selectedModule);
    const summaryPinnedData = (0, $90ISC.useSearchStore)((state)=>state[selectedModule]?.summaryPinnedData);
    const revisedSelectedAgents = selectedAgents.map((agent)=>({
            ...agent,
            averagePrice: (0, $htzEo.formatVolumeOrDays)(agent.averagePrice, true),
            firstName: agent.agentName.split(" ")[0],
            last12AvgDom: (0, $htzEo.formatVolumeOrDays)(agent.last12AvgDom, true),
            last12ListUnits: (0, $htzEo.formatUnitOrPercentage)(agent.last12ListUnits, true),
            last12ListVolume: (0, $htzEo.formatVolumeOrDays)(agent.last12ListVolume, true),
            last12SellUnits: (0, $htzEo.formatUnitOrPercentage)(agent.last12SellUnits, true),
            last12SellVolume: (0, $htzEo.formatVolumeOrDays)(agent.last12SellVolume, true),
            last12Spop: (0, $htzEo.addPctSymbol)((0, $htzEo.formatUnitOrPercentage)(agent.last12Spop, true)),
            last12TotalUnits: (0, $htzEo.formatUnitOrPercentage)(agent.last12TotalUnits, true),
            last12TotalVolume: (0, $htzEo.formatVolumeOrDays)(agent.last12TotalVolume, true),
            lastName: agent.agentName.split(" ")[1] === undefined ? "" : agent.agentName.split(" ")[1],
            listUnits: (0, $htzEo.formatUnitOrPercentage)(agent.listUnits, true),
            listVolume: (0, $htzEo.formatVolumeOrDays)(agent.listVolume, true),
            lytdPytdTotalUnitsGrowth: (0, $htzEo.addPctSymbol)(agent.lytdPytdTotalUnitsGrowth),
            lytdPytdTotalVolumeGrowth: (0, $htzEo.addPctSymbol)((0, $htzEo.formatUnitOrPercentage)(agent.lytdPytdTotalVolumeGrowth, true)),
            lytdTotalVolume: (0, $htzEo.formatVolumeOrDays)(agent.lytdTotalVolume, true),
            noPcLast12ListCdom: (0, $htzEo.formatVolumeOrDays)(agent.noPcLast12ListCdom, true),
            noPcLast12ListDom: (0, $htzEo.formatVolumeOrDays)(agent.noPcLast12ListDom, true),
            noPcLast12ListUnitsPct: (0, $htzEo.addPctFormatted)(agent?.noPcLast12ListUnitsPct),
            noPcLast12ListVolumePct: (0, $htzEo.addPctFormatted)(agent?.noPcLast12ListVolumePct),
            noPcLast12SpOp: (0, $htzEo.addPctFormatted)(agent?.noPcLast12SpOp),
            pcLast12ListAvgNumPc: (0, $htzEo.formatUnitOrPercentage)(agent.pcLast12ListAvgNumPc, true),
            pcLast12ListCdom: (0, $htzEo.formatVolumeOrDays)(agent.pcLast12ListCdom, true),
            pcLast12ListDom: (0, $htzEo.formatVolumeOrDays)(agent.pcLast12ListDom, true),
            pcLast12ListPcDom: (0, $htzEo.formatVolumeOrDays)(agent.pcLast12ListPcDom, true),
            pcLast12ListSpLp: (0, $htzEo.addPctFormatted)(agent?.pcLast12ListSpLp),
            pcLast12ListSpOp: (0, $htzEo.addPctFormatted)(agent?.pcLast12ListSpOp),
            pcLast12ListUnitsPct: (0, $htzEo.addPctFormatted)(agent?.pcLast12ListUnitsPct),
            pcLast12ListVolumePct: (0, $htzEo.addPctFormatted)(agent?.pcLast12ListVolumePct),
            ptmTotalVolume: (0, $htzEo.formatVolumeOrDays)(agent.ptmTotalVolume, true),
            sellUnits: (0, $htzEo.formatUnitOrPercentage)(agent.sellUnits, true),
            sellVolume: (0, $htzEo.formatVolumeOrDays)(agent.sellVolume, true),
            totalUnits: (0, $htzEo.formatUnitOrPercentage)(agent.totalUnits, true),
            totalUnitsChange: (0, $htzEo.formatUnitOrPercentage)(agent.totalUnitsChange, true),
            totalUnitsGrowth: (0, $htzEo.addPctFormatted)(agent?.totalUnitsGrowth),
            totalVolume: (0, $htzEo.formatVolumeOrDays)(agent.totalVolume, true),
            totalVolumeChange: (0, $htzEo.formatVolumeOrDays)(agent.totalVolumeChange, true),
            totalVolumeGrowth: (0, $htzEo.addPctSymbol)((0, $htzEo.formatUnitOrPercentage)(agent.totalVolumeGrowth, true))
        }));
    const revisedSummaryPinnedData = {
        ...summaryPinnedData,
        last12AvgDom: (0, $htzEo.formatVolumeOrDays)(summaryPinnedData?.last12AvgDom, true),
        last12TotalVolume: (0, $htzEo.formatVolumeOrDays)(summaryPinnedData?.last12TotalVolume, true),
        last12SellVolume: (0, $htzEo.formatVolumeOrDays)(summaryPinnedData?.last12SellVolume, true),
        last12ListVolume: (0, $htzEo.formatVolumeOrDays)(summaryPinnedData?.last12ListVolume, true),
        noPcLast12ListCdom: (0, $htzEo.formatVolumeOrDays)(summaryPinnedData?.noPcLast12ListCdom, true),
        noPcLast12ListDom: (0, $htzEo.formatVolumeOrDays)(summaryPinnedData?.noPcLast12ListDom, true),
        noPcLast12ListVolume: (0, $htzEo.formatVolumeOrDays)(summaryPinnedData?.noPcLast12ListVolume, true),
        noPcLast12ListUnitsPct: (0, $htzEo.addPctFormatted)(summaryPinnedData?.noPcLast12ListUnitsPct),
        noPcLast12SpOp: (0, $htzEo.addPctFormatted)(summaryPinnedData?.noPcLast12SpOp),
        pcLast12ListAvgNumPc: (0, $htzEo.formatUnitOrPercentage)(summaryPinnedData?.pcLast12ListAvgNumPc, true),
        pcLast12ListCdom: (0, $htzEo.formatVolumeOrDays)(summaryPinnedData?.pcLast12ListCdom, true),
        pcLast12ListDom: (0, $htzEo.formatVolumeOrDays)(summaryPinnedData?.pcLast12ListDom, true),
        pcLast12ListPcDom: (0, $htzEo.formatVolumeOrDays)(summaryPinnedData?.pcLast12ListPcDom, true),
        pcLast12ListSpLp: (0, $htzEo.addPctFormatted)(summaryPinnedData?.pcLast12ListSpLp),
        pcLast12ListSpOp: (0, $htzEo.addPctFormatted)(summaryPinnedData?.pcLast12ListSpOp),
        pcLast12ListUnitsPct: (0, $htzEo.addPctFormatted)(summaryPinnedData?.pcLast12ListUnitsPct),
        pcLast12ListVolume: (0, $htzEo.formatVolumeOrDays)(summaryPinnedData?.pcLast12ListVolume, true),
        totalVolume: (0, $htzEo.formatVolumeOrDays)(summaryPinnedData?.totalVolume, true),
        sellVolume: (0, $htzEo.formatVolumeOrDays)(summaryPinnedData?.sellVolume, true),
        listVolume: (0, $htzEo.formatVolumeOrDays)(summaryPinnedData?.listVolume, true)
    };
    let revisedSelectedColumnIds, agentsAndSummaryData;
    switch(tabMode){
        case (0, $eHBjM.tabModes).OVERVIEW:
            agentsAndSummaryData = (0, $39c8bb1c22b968df$export$ea07b0a740514bd4)(revisedSelectedAgents, revisedSummaryPinnedData);
            revisedSelectedColumnIds = selectedColumnIds.concat([
                "firstName",
                "lastName",
                "office"
            ]);
            break;
        case (0, $eHBjM.tabModes).CONTACT_INFORMATION:
            revisedSelectedColumnIds = selectedColumnIds.concat([
                "firstName",
                "lastName",
                "office",
                "city",
                "county",
                "zipCode",
                "county",
                "altZipCode",
                "altCity"
            ]);
            break;
        case (0, $eHBjM.tabModes).GROWTH_ANALYSIS:
            revisedSelectedColumnIds = selectedColumnIds.concat([
                "firstName",
                "lastName",
                "office"
            ]);
            break;
        case (0, $eHBjM.tabModes).LISTING_PROFICIENCY:
            agentsAndSummaryData = (0, $39c8bb1c22b968df$export$ea07b0a740514bd4)(revisedSelectedAgents, revisedSummaryPinnedData);
            revisedSelectedColumnIds = selectedColumnIds.concat([
                "firstName",
                "lastName",
                "office"
            ]);
            break;
    }
    const fileName = (0, $fPGDZ.csvFileNameFormatter)(tabMode);
    const customSettings = {
        growthAnalysisPeriod: growthAnalysisPeriod,
        currentSearchDates: currentSearchDates,
        currentTabId: currentTabId
    };
    const csvHeaders = {
        [(0, $eHBjM.tabModes).ACTIVITY]: (0, $fPGDZ.getActivityCsvHeaders)(selectedColumnIds),
        [(0, $eHBjM.tabModes).OVERVIEW]: (0, $fPGDZ.getOverviewCsvHeaders)(revisedSelectedColumnIds, currentSearchDates, currentTabId),
        [(0, $eHBjM.tabModes).CONTACT_INFORMATION]: (0, $fPGDZ.getContactInfoCsvHeaders)(revisedSelectedColumnIds, currentSearchDates),
        [(0, $eHBjM.tabModes).GROWTH_ANALYSIS]: (0, $39c8bb1c22b968df$export$9bc591c2e56fccfc)(revisedSelectedColumnIds, customSettings),
        [(0, $eHBjM.tabModes).LISTING_PROFICIENCY]: (0, $39c8bb1c22b968df$export$e4d54ccc8b6f7428)(revisedSelectedColumnIds)
    }[tabMode];
    const rankedCsvHeaders = [
        {
            label: (0, $eHBjM.agentsColumns).rank.label,
            key: (0, $eHBjM.agentsColumns).rank.id
        },
        ...csvHeaders
    ];
    const csvLink = (0, $acw62.useRef)();
    const handleCancelClick = ()=>handleClose();
    const handleSubmitClick = ()=>{
        csvLink.current.link.click();
        handleClose();
    };
    const fixedColumnIdsByTabMode = {
        [(0, $eHBjM.tabModes).LISTING_PROFICIENCY]: [
            (0, $eHBjM.agentsColumns).rank.id,
            (0, $eHBjM.agentsColumns).agentId.id,
            (0, $eHBjM.agentsColumns).agentName.id
        ],
        [(0, $eHBjM.tabModes).ACTIVITY]: [
            (0, $eHBjM.agentsColumns).rank.id,
            (0, $eHBjM.agentsColumns).agentName.id
        ]
    };
    const fixedColumnIds = fixedColumnIdsByTabMode[tabMode] ?? [];
    const isSubmitButtonDisabled = selectedColumnIds.filter((id)=>!fixedColumnIds.includes(id)).length === 0;
    const countAgentsText = `${selectedAgents.length} ${selectedAgents.length === 1 ? "agent" : "agents"} selected`;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        id: "agents-export",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "helix-heading",
                children: "Select which agent data to export."
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f95d14f55cce6ee7$export$2e2bcd8739ae039), {
                defaultColumns: defaultColumns,
                inputIdPrefix: "agents-export",
                tabMode: tabMode,
                setParentColumnIds: setSelectedColumnIds,
                customSettings: customSettings,
                skipColumnIdsPersistence: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "text-right",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "d-inline-block mr-2",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "helix-heading",
                            children: countAgentsText
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                        dataLwtId: "btn-agents-export-cancel",
                        onClick: handleCancelClick,
                        children: (0, $cstaF.buttonTerms).cancel
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                        dataLwtId: "btn-agents-export-submit",
                        onClick: handleSubmitClick,
                        color: "primary",
                        disabled: isSubmitButtonDisabled,
                        children: (0, $cstaF.buttonTerms).export
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8ad2a4b51964960$exports.CSVLink), {
                        headers: rankedCsvHeaders,
                        data: agentsAndSummaryData || revisedSelectedAgents,
                        filename: fileName,
                        className: "hidden",
                        ref: csvLink,
                        target: "_blank"
                    })
                ]
            })
        ]
    });
};
$54232d120e33969d$var$AgentsExport.propTypes = {
    defaultColumns: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    selectedAgents: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    handleClose: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    tabMode: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    currentSearchDates: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    growthAnalysisPeriod: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    currentTabId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};
var $54232d120e33969d$export$2e2bcd8739ae039 = $54232d120e33969d$var$AgentsExport;



var $cstaF = parcelRequire("cstaF");

var $aypMh = parcelRequire("aypMh");

var $ivaD7 = parcelRequire("ivaD7");

var $eHBjM = parcelRequire("eHBjM");

var $6IhJz = parcelRequire("6IhJz");

var $cstaF = parcelRequire("cstaF");

var $gHbmO = parcelRequire("gHbmO");
const $2292da915057cb56$export$1a3fc79fb30204b6 = Object.freeze({
    CONTACT: 0,
    TOTAL_SELL: 1,
    TOTAL_LIST: 2,
    NO_PRICE_CHANGE: 3,
    PRICE_CHANGE: 4
});
const $2292da915057cb56$export$359879b5b60b4c62 = ()=>{
    const currentLast12MonthsText = $2292da915057cb56$var$getCurrentLast12MonthsText();
    const substitutions = [];
    substitutions.push({
        searchText: "[LAST_12_MONTHS]",
        replaceWith: (0, $cstaF.agentProductionTerms).last12Months
    });
    substitutions.push({
        searchText: "[CURRENT_LAST_12_MONTHS_RANGE]",
        replaceWith: currentLast12MonthsText
    });
    return (0, $gHbmO.getReplacedTemplate)((0, $cstaF.agentProductionTemplates).headerListSideTransactions, substitutions);
};
const $2292da915057cb56$var$getCurrentLast12MonthsText = ()=>{
    const today = new Date();
    const DATE_FORMAT = "MMM dd, yyyy";
    const formattedLast12MonthsFrom = (0, $6IhJz.default)(new Date(new Date(today.setFullYear(today.getFullYear() - 1)).setDate(1)), DATE_FORMAT);
    const formattedLast12MonthsTo = (0, $6IhJz.default)(new Date(today.getFullYear() + 1, today.getMonth(), 0), DATE_FORMAT);
    return `${formattedLast12MonthsFrom} - ${formattedLast12MonthsTo}`;
};
const $2292da915057cb56$export$7aa1788812152cb5 = ()=>{
    const columns = [
        {
            ...(0, $eHBjM.agentsColumns).rank,
            headerPlacement: $2292da915057cb56$export$1a3fc79fb30204b6.CONTACT
        },
        {
            ...(0, $eHBjM.agentsColumns).agentId,
            headerPlacement: $2292da915057cb56$export$1a3fc79fb30204b6.CONTACT
        },
        {
            ...(0, $eHBjM.agentsColumns).agentName,
            headerPlacement: $2292da915057cb56$export$1a3fc79fb30204b6.CONTACT
        },
        {
            ...(0, $eHBjM.agentsColumns).officeId,
            headerPlacement: $2292da915057cb56$export$1a3fc79fb30204b6.CONTACT
        },
        {
            ...(0, $eHBjM.agentsColumns).officeAddress,
            headerPlacement: $2292da915057cb56$export$1a3fc79fb30204b6.CONTACT
        },
        {
            ...(0, $eHBjM.agentsColumns).officeCity,
            headerPlacement: $2292da915057cb56$export$1a3fc79fb30204b6.CONTACT
        },
        {
            ...(0, $eHBjM.agentsColumns).officeZipCode,
            headerPlacement: $2292da915057cb56$export$1a3fc79fb30204b6.CONTACT
        },
        {
            ...(0, $eHBjM.agentsColumns).officeCounty,
            headerPlacement: $2292da915057cb56$export$1a3fc79fb30204b6.CONTACT
        },
        {
            ...(0, $eHBjM.agentsColumns).last12SellUnits,
            headerPlacement: $2292da915057cb56$export$1a3fc79fb30204b6.TOTAL_SELL
        },
        {
            ...(0, $eHBjM.agentsColumns).last12SellVolume,
            headerPlacement: $2292da915057cb56$export$1a3fc79fb30204b6.TOTAL_SELL
        },
        {
            ...(0, $eHBjM.agentsColumns).last12ListUnits,
            headerPlacement: $2292da915057cb56$export$1a3fc79fb30204b6.TOTAL_LIST
        },
        {
            ...(0, $eHBjM.agentsColumns).last12ListVolume,
            headerPlacement: $2292da915057cb56$export$1a3fc79fb30204b6.TOTAL_LIST
        },
        {
            ...(0, $eHBjM.agentsColumns).noPcLast12ListUnits,
            headerPlacement: $2292da915057cb56$export$1a3fc79fb30204b6.NO_PRICE_CHANGE
        },
        {
            ...(0, $eHBjM.agentsColumns).noPcLast12ListUnitsPct,
            headerPlacement: $2292da915057cb56$export$1a3fc79fb30204b6.NO_PRICE_CHANGE
        },
        {
            ...(0, $eHBjM.agentsColumns).noPcLast12ListVolume,
            headerPlacement: $2292da915057cb56$export$1a3fc79fb30204b6.NO_PRICE_CHANGE
        },
        {
            ...(0, $eHBjM.agentsColumns).noPcLast12ListVolumePct,
            headerPlacement: $2292da915057cb56$export$1a3fc79fb30204b6.NO_PRICE_CHANGE
        },
        {
            ...(0, $eHBjM.agentsColumns).noPcLast12ListDom,
            headerPlacement: $2292da915057cb56$export$1a3fc79fb30204b6.NO_PRICE_CHANGE
        },
        {
            ...(0, $eHBjM.agentsColumns).noPcLast12ListCdom,
            headerPlacement: $2292da915057cb56$export$1a3fc79fb30204b6.NO_PRICE_CHANGE
        },
        {
            ...(0, $eHBjM.agentsColumns).noPcLast12SpOp,
            headerPlacement: $2292da915057cb56$export$1a3fc79fb30204b6.NO_PRICE_CHANGE
        },
        {
            ...(0, $eHBjM.agentsColumns).pcLast12ListUnits,
            headerPlacement: $2292da915057cb56$export$1a3fc79fb30204b6.PRICE_CHANGE
        },
        {
            ...(0, $eHBjM.agentsColumns).pcLast12ListUnitsPct,
            headerPlacement: $2292da915057cb56$export$1a3fc79fb30204b6.PRICE_CHANGE
        },
        {
            ...(0, $eHBjM.agentsColumns).pcLast12ListVolume,
            headerPlacement: $2292da915057cb56$export$1a3fc79fb30204b6.PRICE_CHANGE
        },
        {
            ...(0, $eHBjM.agentsColumns).pcLast12ListVolumePct,
            headerPlacement: $2292da915057cb56$export$1a3fc79fb30204b6.PRICE_CHANGE
        },
        {
            ...(0, $eHBjM.agentsColumns).pcLast12ListDom,
            headerPlacement: $2292da915057cb56$export$1a3fc79fb30204b6.PRICE_CHANGE
        },
        {
            ...(0, $eHBjM.agentsColumns).pcLast12ListCdom,
            headerPlacement: $2292da915057cb56$export$1a3fc79fb30204b6.PRICE_CHANGE
        },
        {
            ...(0, $eHBjM.agentsColumns).pcLast12ListPcDom,
            headerPlacement: $2292da915057cb56$export$1a3fc79fb30204b6.PRICE_CHANGE
        },
        {
            ...(0, $eHBjM.agentsColumns).pcLast12ListSpOp,
            headerPlacement: $2292da915057cb56$export$1a3fc79fb30204b6.PRICE_CHANGE
        },
        {
            ...(0, $eHBjM.agentsColumns).pcLast12ListSpLp,
            headerPlacement: $2292da915057cb56$export$1a3fc79fb30204b6.PRICE_CHANGE
        },
        {
            ...(0, $eHBjM.agentsColumns).pcLast12ListAvgNumPc,
            headerPlacement: $2292da915057cb56$export$1a3fc79fb30204b6.PRICE_CHANGE
        }
    ];
    const columnsToHide = [
        (0, $eHBjM.agentsColumns).officeId,
        (0, $eHBjM.agentsColumns).officeAddress,
        (0, $eHBjM.agentsColumns).officeCity,
        (0, $eHBjM.agentsColumns).officeZipCode,
        (0, $eHBjM.agentsColumns).officeCounty,
        (0, $eHBjM.agentsColumns).last12SellUnits,
        (0, $eHBjM.agentsColumns).last12SellVolume,
        (0, $eHBjM.agentsColumns).last12ListVolume,
        (0, $eHBjM.agentsColumns).noPcLast12ListVolume,
        (0, $eHBjM.agentsColumns).noPcLast12ListVolumePct,
        (0, $eHBjM.agentsColumns).pcLast12ListVolume,
        (0, $eHBjM.agentsColumns).pcLast12ListVolumePct
    ];
    return columns.map((c)=>{
        const isDisplayed = !columnsToHide.some((cth)=>cth.id === c.id);
        return {
            ...c,
            isDisplayed: isDisplayed
        };
    });
};



var $fPGDZ = parcelRequire("fPGDZ");

var $eHBjM = parcelRequire("eHBjM");

var $9QX0f = parcelRequire("9QX0f");
const $ba4fc233a0a159d1$export$6a3b3e40f9ef1478 = (state, setState, selectedView, selectedAgents, currentTabId)=>{
    const handleClose = ()=>{
        (0, $ivaD7.setStateData)("showModal", false, setState);
    };
    const commonModalProps = {
        size: "lg",
        title: (0, $cstaF.agentProductionTerms).exportData,
        showFooter: false,
        onClose: handleClose,
        show: true,
        footerClassName: "",
        dataLwtId: "agent-production-modal"
    };
    const growthAnalysisColumnsByPeriod = {
        [(0, $cstaF.TimePeriods)[(0, $cstaF.agentProductionTerms).last90Days]]: state.growthAnalysisColumnsL90,
        [(0, $cstaF.agentProductionTerms).last12Months]: state.growthAnalysisColumnsLtm,
        [(0, $cstaF.agentProductionTerms).yearToDate]: state.growthAnalysisColumnsYtd,
        [(0, $cstaF.TimePeriods)[(0, $cstaF.agentProductionTerms).last12Months]]: state.growthAnalysisColumnsLtmIncDec,
        [(0, $cstaF.TimePeriods)[(0, $cstaF.agentProductionTerms).yearToDate]]: state.growthAnalysisColumnsYtdIncDec
    }[state.growthAnalysisPeriod];
    const isNewProducers = currentTabId === (0, $9QX0f.tabs).newProducers.id;
    const isCoopAgents = currentTabId === (0, $9QX0f.tabs).coopAgents.id;
    const overviewColumns = isNewProducers ? state.newProducersOverviewColumns : isCoopAgents ? state.coopAgentsOverviewColumns : state.overviewColumns;
    const contactInfoColumns = isNewProducers ? state.newProducersContactInfoColumns : state.contactInfoColumns;
    const buildAgentsExport = ({ defaultColumns: defaultColumns, tabMode: tabMode, ...restProps })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $54232d120e33969d$export$2e2bcd8739ae039), {
            handleClose: handleClose,
            selectedAgents: selectedAgents,
            defaultColumns: defaultColumns,
            tabMode: tabMode,
            currentSearchDates: state.currentSearchDates,
            currentTabId: currentTabId,
            ...restProps
        });
    const tabViews = {
        [(0, $fPGDZ.tabIndexes).OVERVIEW]: {
            ...commonModalProps,
            children: buildAgentsExport({
                defaultColumns: overviewColumns,
                tabMode: (0, $eHBjM.tabModes).OVERVIEW
            })
        },
        [(0, $fPGDZ.tabIndexes).CONTACT_INFORMATION]: {
            ...commonModalProps,
            children: buildAgentsExport({
                defaultColumns: contactInfoColumns,
                tabMode: (0, $eHBjM.tabModes).CONTACT_INFORMATION
            })
        },
        [(0, $fPGDZ.tabIndexes).GROWTH_ANALYSIS]: {
            ...commonModalProps,
            children: buildAgentsExport({
                defaultColumns: growthAnalysisColumnsByPeriod,
                tabMode: (0, $eHBjM.tabModes).GROWTH_ANALYSIS,
                growthAnalysisPeriod: state.growthAnalysisPeriod,
                timeIntervals: state.timeIntervals
            })
        },
        [(0, $fPGDZ.tabIndexes).LISTING_PROFICIENCY]: {
            ...commonModalProps,
            title: (0, $2292da915057cb56$export$359879b5b60b4c62)(),
            children: buildAgentsExport({
                defaultColumns: state.listingProficiencyColumns,
                tabMode: (0, $eHBjM.tabModes).LISTING_PROFICIENCY
            })
        }
    };
    const modalPropsSettingsByView = {
        ...tabViews,
        [(0, $aypMh.views).overview]: {
            ...commonModalProps,
            children: buildAgentsExport({
                defaultColumns: overviewColumns,
                tabMode: (0, $aypMh.views).overview
            })
        },
        [(0, $aypMh.views).contactInformation]: {
            ...commonModalProps,
            children: buildAgentsExport({
                defaultColumns: contactInfoColumns,
                tabMode: (0, $aypMh.views).contactInformation
            })
        },
        [(0, $aypMh.views).growthAnalysis]: {
            ...commonModalProps,
            children: buildAgentsExport({
                defaultColumns: state.growthAnalysisColumns ?? growthAnalysisColumnsByPeriod,
                tabMode: (0, $aypMh.views).growthAnalysis,
                growthAnalysisPeriod: state.growthAnalysisPeriod,
                timeIntervals: state.timeIntervals
            })
        },
        [(0, $aypMh.views).listingProficiency]: {
            ...commonModalProps,
            title: (0, $2292da915057cb56$export$359879b5b60b4c62)(),
            children: buildAgentsExport({
                defaultColumns: state.listingProfColumns,
                tabMode: (0, $aypMh.views).listingProficiency
            })
        },
        [(0, $aypMh.views).activity]: {
            ...commonModalProps,
            title: (0, $cstaF.agentProductionTerms).downloadData,
            children: buildAgentsExport({
                defaultColumns: state.activityColumns,
                tabMode: (0, $aypMh.views).activity
            })
        }
    };
    const modalProps = modalPropsSettingsByView[selectedView];
    const showModal = !!modalProps;
    setState((prevState)=>({
            ...prevState,
            modalProps: modalProps,
            showModal: showModal
        }));
};



var $acw62 = parcelRequire("acw62");

var $90ISC = parcelRequire("90ISC");

var $koMgC = parcelRequire("koMgC");
const $14b4389b323bef2f$export$2bf58a042e4e0b44 = (externalGridRef, onDownload)=>{
    const internalGridRef = (0, $acw62.useRef)();
    const gridRef = externalGridRef || internalGridRef;
    const [showAddToListModal, setShowAddToListModal] = (0, $acw62.useState)(false);
    const [showNewListModal, setShowNewListModal] = (0, $acw62.useState)(false);
    const { selectedCount: selectedCount, clearSelectedAgentIds: clearSelectedAgentIds } = (0, $90ISC.useSearchStore)((state)=>({
            selectedCount: (0, $koMgC.getSelectedAgentIds)(state)?.length ?? 0,
            clearSelectedAgentIds: state.clearSelectedAgentIds
        }));
    const onDownloadRef = (0, $acw62.useRef)(onDownload);
    (0, $acw62.useEffect)(()=>{
        onDownloadRef.current = onDownload;
    }, [
        onDownload
    ]);
    const handleDownloadClick = ()=>{
        const rows = gridRef?.current?.api?.getSelectedRows() ?? [];
        onDownloadRef.current?.(rows);
    };
    const handleDismiss = ()=>{
        gridRef?.current?.api?.deselectAll();
        clearSelectedAgentIds();
    };
    const resetSelection = ()=>{
        setShowAddToListModal(false);
        gridRef?.current?.api?.deselectAll();
        clearSelectedAgentIds();
    };
    return {
        gridRef: gridRef,
        selectedCount: selectedCount,
        showNewListModal: showNewListModal,
        showAddToListModal: showAddToListModal,
        setShowAddToListModal: setShowAddToListModal,
        setShowNewListModal: setShowNewListModal,
        handleDownloadClick: handleDownloadClick,
        handleDismiss: handleDismiss,
        resetSelection: resetSelection
    };
};


const $dd5ce9e8963ca006$export$45df953e4e0cd95b = ({ state: state, setState: setState, selectedView: selectedView })=>{
    const timeIntervals = (0, $90ISC.useCommonStore)((s)=>s.timeIntervals);
    const handleDownload = (selectedAgents)=>{
        (0, $ba4fc233a0a159d1$export$6a3b3e40f9ef1478)({
            ...state,
            listingProfColumns: state.listingProficiencyColumns,
            timeIntervals: timeIntervals
        }, setState, selectedView, selectedAgents, selectedView);
    };
    return (0, $14b4389b323bef2f$export$2bf58a042e4e0b44)(undefined, handleDownload);
};


const $ab5abed591bd149f$var$Overview = (props)=>{
    const { agentData: agentData, chartOptions: chartOptions, chartSchema: chartSchema, currentAgentChart: currentAgentChart, additionalTableHeaders: additionalTableHeaders, columns: columns, setColumns: setColumns, module: module, state: state, setState: setState, isActive: isActive } = props;
    const [isTableSelected, setIsTableSelected] = (0, $acw62.useState)(true);
    const { gridRef: gridRef, selectedCount: selectedCount, showAddToListModal: showAddToListModal, setShowAddToListModal: setShowAddToListModal, handleDismiss: handleDismiss, handleDownloadClick: handleDownloadClick } = (0, $dd5ce9e8963ca006$export$45df953e4e0cd95b)({
        state: state,
        setState: setState,
        selectedView: (0, $aypMh.views).overview
    });
    const selectedModule = (0, $90ISC.useSearchStore)((state)=>state.selectedModule);
    const { summaryPinnedData: summaryPinnedData } = (0, $90ISC.useSearchStore)((state)=>({
            summaryPinnedData: state[selectedModule]?.summaryPinnedData
        }));
    const summaryPinnedConfig = (0, $jilhO.getSummaryPinnedConfig)((0, $aypMh.views).overview);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ff3174d53694c027$export$2e2bcd8739ae039), {
                isTableSelected: isTableSelected,
                setIsTableSelected: setIsTableSelected,
                tabMode: (0, $eHBjM.tabModes).OVERVIEW,
                columns: columns,
                setColumns: setColumns,
                hasShowHideColumnsButton: true,
                hasTableChartToggle: false
            }),
            isTableSelected ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l05Px.default), {
                gridRef: gridRef,
                tableView: (0, $4tbBr.tableViews).overview,
                rowData: agentData,
                columns: columns,
                additionalTableHeaders: additionalTableHeaders,
                tableTitleWithTooltips: (0, $eHBjM.overviewToolTips),
                pinnedBottomRowData: [
                    {
                        ...summaryPinnedData
                    }
                ],
                externalParams: {
                    summaryPinnedConfig: summaryPinnedConfig
                },
                rowSelection: "multiple",
                suppressRowClickSelection: true,
                rowMultiSelectWithClick: true
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8NZ49.default), {
                options: chartOptions,
                schema: chartSchema,
                data: agentData,
                currentAgentChart: currentAgentChart,
                module: module
            }),
            isActive && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0eb783070ef68771$export$2e2bcd8739ae039), {
                selectedCount: selectedCount,
                showAddToListModal: showAddToListModal,
                setShowAddToListModal: setShowAddToListModal,
                onDismiss: handleDismiss,
                onDownloadClick: handleDownloadClick
            })
        ]
    });
};
$ab5abed591bd149f$var$Overview.propTypes = {
    agentData: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object),
    chartOptions: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    chartSchema: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    columns: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object),
    additionalTableHeaders: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object),
    setColumns: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    currentAgentChart: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    module: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    state: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    setState: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    isActive: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
var $ab5abed591bd149f$export$2e2bcd8739ae039 = $ab5abed591bd149f$var$Overview;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");


var $eHBjM = parcelRequire("eHBjM");

var $l05Px = parcelRequire("l05Px");

var $4tbBr = parcelRequire("4tbBr");



var $aypMh = parcelRequire("aypMh");
const $6b203572ebe7b0e2$var$ContactInformation = ({ agentData: agentData, columns: columns, additionalTableHeaders: additionalTableHeaders, setColumns: setColumns, state: state, setState: setState, isActive: isActive })=>{
    const [isTableSelected, setIsTableSelected] = (0, $acw62.useState)(true);
    const { gridRef: gridRef, selectedCount: selectedCount, showAddToListModal: showAddToListModal, setShowAddToListModal: setShowAddToListModal, handleDismiss: handleDismiss, handleDownloadClick: handleDownloadClick } = (0, $dd5ce9e8963ca006$export$45df953e4e0cd95b)({
        state: state,
        setState: setState,
        selectedView: (0, $aypMh.views).contactInformation
    });
    const agentsTableControlsProps = {
        tabMode: (0, $eHBjM.tabModes).CONTACT_INFORMATION,
        hasShowHideColumnsButton: true,
        columns: columns,
        setColumns: setColumns,
        isTableSelected: isTableSelected,
        setIsTableSelected: setIsTableSelected,
        popoverClassName: "contact-information"
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ff3174d53694c027$export$2e2bcd8739ae039), {
                ...agentsTableControlsProps
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l05Px.default), {
                gridRef: gridRef,
                tableView: (0, $4tbBr.tableViews).contactInformation,
                rowData: agentData,
                columns: columns,
                additionalTableHeaders: additionalTableHeaders,
                tableTitleWithTooltips: (0, $eHBjM.contactToolTips),
                rowSelection: "multiple",
                suppressRowClickSelection: true,
                rowMultiSelectWithClick: true
            }),
            isActive && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0eb783070ef68771$export$2e2bcd8739ae039), {
                selectedCount: selectedCount,
                showAddToListModal: showAddToListModal,
                setShowAddToListModal: setShowAddToListModal,
                onDismiss: handleDismiss,
                onDownloadClick: handleDownloadClick
            })
        ]
    });
};
$6b203572ebe7b0e2$var$ContactInformation.propTypes = {
    agentData: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object),
    additionalTableHeaders: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object),
    columns: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object),
    setColumns: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    state: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    setState: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    isActive: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
var $6b203572ebe7b0e2$export$2e2bcd8739ae039 = $6b203572ebe7b0e2$var$ContactInformation;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $cstaF = parcelRequire("cstaF");


var $eHBjM = parcelRequire("eHBjM");

var $7jSpM = parcelRequire("7jSpM");

var $8E8vr = parcelRequire("8E8vr");

var $l05Px = parcelRequire("l05Px");

var $4tbBr = parcelRequire("4tbBr");



var $aypMh = parcelRequire("aypMh");
const $c4d8c3e8dac261fa$var$GrowthAnalysis = ({ agentData: agentData, additionalTableHeadersLtm: additionalTableHeadersLtm, additionalTableHeadersYtd: additionalTableHeadersYtd, growthAnalysisPeriod: growthAnalysisPeriod, setGrowthAnalysisPeriod: setGrowthAnalysisPeriod, ltmColumns: ltmColumns, ytdColumns: ytdColumns, setColumnsLtm: setColumnsLtm, setColumnsYtd: setColumnsYtd, currentSearchDates: currentSearchDates, state: state, setState: setState, isActive: isActive })=>{
    const isPeriodLast12Months = (0, $8E8vr.getIsPeriodLast12Months)(growthAnalysisPeriod);
    const columns = isPeriodLast12Months ? ltmColumns : ytdColumns;
    const { gridRef: gridRef, selectedCount: selectedCount, showAddToListModal: showAddToListModal, setShowAddToListModal: setShowAddToListModal, handleDismiss: handleDismiss, handleDownloadClick: handleDownloadClick } = (0, $dd5ce9e8963ca006$export$45df953e4e0cd95b)({
        state: state,
        setState: setState,
        selectedView: (0, $aypMh.views).growthAnalysis
    });
    (0, $acw62.useEffect)(()=>{
        setGrowthAnalysisPeriod((0, $cstaF.agentProductionTerms).last12Months);
    }, [
        agentData
    ]);
    const setColumnsLocal = (cols)=>{
        if (isPeriodLast12Months) setColumnsLtm(cols);
        else setColumnsYtd(cols);
    };
    const customSettings = {
        isPeriodLast12Months: isPeriodLast12Months,
        currentSearchDates: currentSearchDates
    };
    const classNameContainerLtm = (0, $7jSpM.getClassNameSuppressHeaders)(additionalTableHeadersLtm);
    const classNameContainerYtd = (0, $7jSpM.getClassNameSuppressHeaders)(additionalTableHeadersYtd);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ff3174d53694c027$export$2e2bcd8739ae039), {
                isTableSelected: true,
                tabMode: (0, $eHBjM.tabModes).GROWTH_ANALYSIS,
                columns: columns,
                setColumns: setColumnsLocal,
                hasShowHideColumnsButton: true,
                hasTableChartToggle: false,
                growthAnalysisPeriod: growthAnalysisPeriod,
                setGrowthAnalysisPeriod: setGrowthAnalysisPeriod,
                popoverClassName: "growth-analysis",
                customSettings: customSettings
            }),
            isPeriodLast12Months ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: classNameContainerLtm,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l05Px.default), {
                    gridRef: gridRef,
                    tableView: (0, $4tbBr.tableViews).growthAnalysisLtm,
                    rowData: agentData,
                    columns: columns,
                    additionalTableHeaders: additionalTableHeadersLtm,
                    tableTitleWithTooltips: (0, $eHBjM.growthAnalysisTooltips),
                    rowSelection: "multiple",
                    suppressRowClickSelection: true,
                    rowMultiSelectWithClick: true
                })
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: classNameContainerYtd,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l05Px.default), {
                    gridRef: gridRef,
                    tableView: (0, $4tbBr.tableViews).growthAnalysisYtd,
                    rowData: agentData,
                    columns: columns,
                    additionalTableHeaders: additionalTableHeadersYtd,
                    tableTitleWithTooltips: (0, $eHBjM.growthAnalysisTooltips),
                    rowSelection: "multiple",
                    suppressRowClickSelection: true,
                    rowMultiSelectWithClick: true
                })
            }),
            isActive && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0eb783070ef68771$export$2e2bcd8739ae039), {
                selectedCount: selectedCount,
                showAddToListModal: showAddToListModal,
                setShowAddToListModal: setShowAddToListModal,
                onDismiss: handleDismiss,
                onDownloadClick: handleDownloadClick
            })
        ]
    });
};
$c4d8c3e8dac261fa$var$GrowthAnalysis.propTypes = {
    agentData: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object),
    additionalTableHeadersLtm: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object),
    additionalTableHeadersYtd: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object),
    growthAnalysisPeriod: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    setGrowthAnalysisPeriod: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    ltmColumns: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object),
    ytdColumns: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object),
    setColumnsLtm: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    setColumnsYtd: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    currentSearchDates: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    state: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    setState: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    isActive: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
var $c4d8c3e8dac261fa$export$2e2bcd8739ae039 = $c4d8c3e8dac261fa$var$GrowthAnalysis;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");


var $eHBjM = parcelRequire("eHBjM");


var $l05Px = parcelRequire("l05Px");

var $4tbBr = parcelRequire("4tbBr");

var $90ISC = parcelRequire("90ISC");

var $jilhO = parcelRequire("jilhO");

var $aypMh = parcelRequire("aypMh");


const $3dced25acf3161ee$var$ListingProficiency = ({ agentData: agentData, additionalTableHeaders: additionalTableHeaders, setColumns: setColumns, columns: columns, state: state, setState: setState, isActive: isActive })=>{
    const selectedModule = (0, $90ISC.useSearchStore)((state)=>state.selectedModule);
    const { summaryPinnedData: summaryPinnedData } = (0, $90ISC.useSearchStore)((state)=>({
            summaryPinnedData: state[selectedModule]?.summaryPinnedData
        }));
    const summaryPinnedConfig = (0, $jilhO.getSummaryPinnedConfig)((0, $aypMh.views).listingProficiency);
    const popoverHeader = (0, $2292da915057cb56$export$359879b5b60b4c62)();
    const { gridRef: gridRef, selectedCount: selectedCount, showAddToListModal: showAddToListModal, setShowAddToListModal: setShowAddToListModal, handleDismiss: handleDismiss, handleDownloadClick: handleDownloadClick } = (0, $dd5ce9e8963ca006$export$45df953e4e0cd95b)({
        state: state,
        setState: setState,
        selectedView: (0, $aypMh.views).listingProficiency
    });
    const paramsTableControls = {
        columns: columns,
        setColumns: setColumns,
        tabMode: (0, $eHBjM.tabModes).LISTING_PROFICIENCY,
        popoverClassName: "listing-proficiency",
        popoverHeader: popoverHeader,
        hasShowHideColumnsButton: true,
        isTableSelected: true
    };
    const hasAdditionalTableHeaders = !!additionalTableHeaders.length;
    const classNameContainer = hasAdditionalTableHeaders ? "" : "has-no-superheaders";
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ff3174d53694c027$export$2e2bcd8739ae039), {
                ...paramsTableControls
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: classNameContainer,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l05Px.default), {
                    gridRef: gridRef,
                    tableView: (0, $4tbBr.tableViews).listingProficiency,
                    rowData: agentData,
                    columns: columns,
                    additionalTableHeaders: additionalTableHeaders,
                    tableTitleWithTooltips: (0, $eHBjM.listingProficiencyTooltips),
                    pinnedBottomRowData: [
                        {
                            ...summaryPinnedData
                        }
                    ],
                    externalParams: {
                        summaryPinnedConfig: summaryPinnedConfig
                    },
                    rowSelection: "multiple",
                    suppressRowClickSelection: true,
                    rowMultiSelectWithClick: true
                })
            }),
            isActive && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0eb783070ef68771$export$2e2bcd8739ae039), {
                selectedCount: selectedCount,
                showAddToListModal: showAddToListModal,
                setShowAddToListModal: setShowAddToListModal,
                onDismiss: handleDismiss,
                onDownloadClick: handleDownloadClick
            })
        ]
    });
};
$3dced25acf3161ee$var$ListingProficiency.propTypes = {
    agentData: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object),
    additionalTableHeaders: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object),
    columns: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object),
    setColumns: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    state: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    setState: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    isActive: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
var $3dced25acf3161ee$export$2e2bcd8739ae039 = $3dced25acf3161ee$var$ListingProficiency;



var $fPGDZ = parcelRequire("fPGDZ");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");
var $7735f71d5623fcf5$export$2e2bcd8739ae039 = (handlerAgentChart)=>{
    const [selectedAgentId, setSelectedAgentId] = (0, $acw62.useState)(0);
    const [selectedRow, setSelectedRow] = (0, $acw62.useState)(0);
    const changeSelectedRowColor = (agentId)=>{
        setSelectedAgentId(agentId);
        setSelectedRow(null);
    };
    const handleClickAgentName = (agent)=>{
        handlerAgentChart(agent);
    };
    const chartOptions = {
        id: "chartTableList",
        keyField: "id",
        bootstrap4: true,
        displayCaret: true,
        striped: true,
        bordered: true,
        showFilters: true,
        showColumnBorders: false,
        tableClasses: "table-borderless",
        showPagination: true,
        paginationOptions: {
            sizePerPage: 20,
            page: 1,
            alwaysShowAllBtns: true,
            hideSizePerPage: false,
            sizePerPageList: [
                20,
                50,
                100
            ],
            onPageChange: ()=>{
                setSelectedRow(0);
            }
        },
        rowClasses: (row, rowIndex)=>{
            if (rowIndex === selectedRow) return "table-active";
            if (row.agentId === selectedAgentId) return "table-active";
        },
        noDataIndication: "Your search returned no results"
    };
    const chartSchema = {
        properties: {
            id: {
                type: "string",
                hidden: true
            },
            agentName: {
                type: "string",
                title: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: "Agent Name"
                }),
                filter: "none",
                format: "custom",
                headerClasses: "align-middle",
                headerStyle: {
                    width: "150px",
                    marginLeft: "30px"
                },
                sortValue: (cell, row)=>{
                    const names = cell.split(" ");
                    return names[names.length - 1];
                },
                formatter: (cell, row, index, extraData)=>{
                    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                        onClick: ()=>{
                            changeSelectedRowColor(row.agentId);
                            handleClickAgentName(row);
                        },
                        className: "text-wrap w-max text-left text-capitalize text-decoration-none  border-0 clickable",
                        children: row.agentName
                    });
                }
            }
        }
    };
    return {
        chartOptions: chartOptions,
        chartSchema: chartSchema
    };
};



var $cstaF = parcelRequire("cstaF");

var $eHBjM = parcelRequire("eHBjM");

var $8E8vr = parcelRequire("8E8vr");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $kfZjc = parcelRequire("kfZjc");
parcelRequire("3PprX");
var $90ODN = parcelRequire("90ODN");

var $cstaF = parcelRequire("cstaF");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");
parcelRequire("3PprX");
var $9Qlhi = parcelRequire("9Qlhi");

var $cstaF = parcelRequire("cstaF");
const $933a513fb6babc70$var$ExportShareButtons = (props)=>{
    let exportButton = null;
    const buttonProps = {
        dataLwtId: "export",
        color: "secondary",
        className: "bg-dark export-share-button btn-sm mr-1",
        disabled: props.isExportDisabled,
        hidden: props.isHidden
    };
    if (props.showExportButton) exportButton = /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
        ...buttonProps,
        onClick: props.exportCsv,
        children: (0, $cstaF.buttonTerms).export
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            exportButton,
            props.showShareButton && /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9Qlhi))), {
                className: "export-share-button",
                dataLwtId: "share-options",
                toggleProps: {
                    dataLwtId: "no-split-toggle",
                    id: "caret",
                    color: "secondary",
                    caret: true,
                    children: (0, $cstaF.agentProductionTerms).share,
                    className: "bg-dark btn btn-secondary btn-sm"
                },
                items: [
                    {
                        dataLwtId: "no-split-item1",
                        itemText: (0, $cstaF.agentProductionTerms).downloadPdf,
                        key: "item_1"
                    },
                    {
                        dataLwtId: "no-split-item2",
                        divider: true,
                        key: "item_2"
                    },
                    {
                        dataLwtId: "no-split-item3",
                        itemText: (0, $cstaF.agentProductionTerms).copyShareableLink,
                        key: "item_3"
                    }
                ],
                menuProps: {
                    dataLwtId: "share-menu",
                    right: true
                }
            })
        ]
    });
};
var $933a513fb6babc70$export$2e2bcd8739ae039 = $933a513fb6babc70$var$ExportShareButtons;



var $eHBjM = parcelRequire("eHBjM");

var $90ISC = parcelRequire("90ISC");

var $c9Z8w = parcelRequire("c9Z8w");
const $3c17adf0ba4aae41$var$TitleRow = ({ module: module, showHideAgentsDropdown: showHideAgentsDropdown, ...exportProps })=>{
    const { selectedViewHideAgentsFilter: selectedViewHideAgentsFilter, setViewHideAgentsFilter: setViewHideAgentsFilter, selectedSavedSearch: selectedSavedSearch } = (0, $90ISC.useSearchStore)((state)=>({
            selectedViewHideAgentsFilter: state[module]?.selectedViewHideAgentsFilter,
            setViewHideAgentsFilter: state.setViewHideAgentsFilter,
            selectedSavedSearch: state[module]?.selectedSavedSearch
        }));
    const location = (0, $kfZjc.useLocation)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "row w-100 ml-2 my-2 pr-1 py-0",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mr-auto",
                style: {
                    width: "70%"
                },
                children: selectedSavedSearch ? /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "text-truncate mb-0 my-3 helix-display-small",
                    style: {
                        whiteSpace: "pre"
                    },
                    children: selectedSavedSearch.savedSearch?.searchName
                }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "text-truncate mb-0 helix-display-small",
                            style: {
                                whiteSpace: "pre"
                            },
                            children: (0, $cstaF.searchTerms).newSearch
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("h5", {
                            className: "text-truncate mb-0 helix-heading",
                            style: {
                                whiteSpace: "pre"
                            },
                            children: [
                                (0, $cstaF.searchTypes)[location.pathname].title,
                                " Search"
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "d-flex flex-row-reverse align-items-center",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $933a513fb6babc70$export$2e2bcd8739ae039), {
                        ...exportProps
                    }),
                    showHideAgentsDropdown ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($90ODN))), {
                        dataLwtId: "share-options",
                        toggleProps: {
                            dataLwtId: "no-split-toggle",
                            id: "caret",
                            caret: true,
                            children: selectedViewHideAgentsFilter,
                            className: "bg-dark btn btn-sm btn-secondary mr-2"
                        },
                        items: [
                            {
                                dataLwtId: "no-split-item1",
                                itemText: (0, $eHBjM.viewHideAgentsDropdownLabels).viewHideAgents,
                                key: "item_1",
                                onClick: ()=>setViewHideAgentsFilter(module, (0, $eHBjM.viewHideAgentsDropdownLabels).viewHideAgents)
                            },
                            {
                                dataLwtId: "no-split-item2",
                                divider: true,
                                key: "item_2"
                            },
                            {
                                dataLwtId: "no-split-item3",
                                itemText: (0, $eHBjM.viewHideAgentsDropdownLabels).viewOnlyMyAgents,
                                key: "item_3",
                                onClick: ()=>setViewHideAgentsFilter(module, (0, $eHBjM.viewHideAgentsDropdownLabels).viewOnlyMyAgents)
                            },
                            {
                                dataLwtId: "no-split-item4",
                                divider: true,
                                key: "item_4"
                            },
                            {
                                dataLwtId: "no-split-item5",
                                itemText: (0, $eHBjM.viewHideAgentsDropdownLabels).hideMyAgents,
                                key: "item_5",
                                onClick: ()=>setViewHideAgentsFilter(module, (0, $eHBjM.viewHideAgentsDropdownLabels).hideMyAgents)
                            }
                        ],
                        menuProps: {
                            dataLwtId: "share-menu",
                            right: true
                        }
                    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {})
                ]
            })
        ]
    });
};
$3c17adf0ba4aae41$var$TitleRow.propTypes = {
    module: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    showHideAgentsDropdown: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
var $3c17adf0ba4aae41$export$2e2bcd8739ae039 = $3c17adf0ba4aae41$var$TitleRow;



var $ivaD7 = parcelRequire("ivaD7");

var $dlZsJ = parcelRequire("dlZsJ");


var $b77Er = parcelRequire("b77Er");

var $90ISC = parcelRequire("90ISC");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $cstaF = parcelRequire("cstaF");
const $126e7d6ff1f55059$export$3f0134fa5c63d52e = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "no-search-results font-weight-bold",
                children: (0, $cstaF.agentProductionTerms).noData
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "no-search-results-suggestion",
                children: (0, $cstaF.agentProductionTerms).noDataSuggestion
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");

var $eHBjM = parcelRequire("eHBjM");

var $cstaF = parcelRequire("cstaF");

var $7jSpM = parcelRequire("7jSpM");
const $07235befa2e2f940$export$892433a963901c8 = (columns, agentDataLength, dateRangesText, col1TitlePrefix, tooltips = (0, $eHBjM.overviewToolTips))=>{
    const overviewColumns = (0, $7jSpM.transformSchemaTableColumns)(tooltips, (0, $eHBjM.tabModes).OVERVIEW);
    const additionalAddressColumns = (0, $7jSpM.getAdditionalColumnCount)(columns, overviewColumns?.officeAddress.id);
    const areaColCounter = columns.filter((overviewColumn)=>overviewColumn.headerPlacement === "area" && overviewColumn.isDisplayed).length + additionalAddressColumns;
    const mlsColCounter = columns.filter((overviewColumn)=>overviewColumn.headerPlacement === "mls" && overviewColumn.isDisplayed).length;
    return [
        {
            column1: {
                title: `${col1TitlePrefix || (0, $cstaF.agentProductionTerms).currentSearch} (${dateRangesText.currentSearch.lastIntervalText}: ${dateRangesText.currentSearch.from} - ${dateRangesText.currentSearch.to}) - ${agentDataLength} ${(0, $cstaF.searchTerms).agents}`,
                attrs: {
                    colSpan: 2 + areaColCounter,
                    className: `border border-end-5 text-center ${areaColCounter === 0 ? "d-none" : ""}`
                }
            },
            column2: {
                title: `${(0, $cstaF.agentProductionTerms).allMlsTransactions} ${dateRangesText.allMls.lastIntervalText} (${dateRangesText.allMls.from} - ${dateRangesText.allMls.to})`,
                attrs: {
                    colSpan: areaColCounter === 0 ? 2 + mlsColCounter : mlsColCounter,
                    className: `border text-center ${mlsColCounter === 0 ? "d-none" : ""}`
                }
            }
        }
    ];
};



var $8E8vr = parcelRequire("8E8vr");
const $a7847c85305f76ce$export$6593394e45fc102d = (columns)=>{
    const additionalTableHeaders = (0, $8E8vr.getAdditionalTableHeaders)(columns, [
        "agentName",
        "office"
    ]);
    return additionalTableHeaders;
};



var $cstaF = parcelRequire("cstaF");

var $eHBjM = parcelRequire("eHBjM");

var $fPGDZ = parcelRequire("fPGDZ");

var $7jSpM = parcelRequire("7jSpM");
const $fddbe63d1671f392$export$86d53fa14874f5e0 = (columns, dateRangesText, tooltips = (0, $eHBjM.contactToolTips))=>{
    const contactColumns = (0, $7jSpM.transformSchemaTableColumns)(tooltips, (0, $eHBjM.tabModes).CONTACT_INFORMATION);
    const getCountDisplayedColumns = (headerPlacement)=>columns.filter((c)=>c.isDisplayed && c.headerPlacement === headerPlacement).length;
    const contactColumnsToAlwaysDisplay = [
        "agentName",
        "office"
    ];
    const addHeaderColumn = ({ headerColumns: headerColumns, title: title, colSpan: colSpan, columnObjectName: columnObjectName })=>{
        return {
            ...headerColumns,
            [columnObjectName]: {
                title: title,
                attrs: {
                    colSpan: colSpan,
                    className: "border text-center"
                }
            }
        };
    };
    let headerColumns = {};
    const countDisplayedColumnsContact = getCountDisplayedColumns((0, $fPGDZ.COLUMN_GROUP_CONTACT)) + contactColumnsToAlwaysDisplay.length;
    if (countDisplayedColumnsContact) {
        const additionalAddressColumns = (0, $7jSpM.getAdditionalColumnCount)(columns, contactColumns?.officeAddress.id);
        headerColumns = addHeaderColumn({
            headerColumns: headerColumns,
            title: "Contact",
            colSpan: countDisplayedColumnsContact + additionalAddressColumns,
            columnObjectName: (0, $fPGDZ.COLUMN_GROUP_CONTACT)
        });
    }
    const countDisplayedColumnsSearch = getCountDisplayedColumns((0, $fPGDZ.COLUMN_GROUP_SEARCH));
    if (countDisplayedColumnsSearch) headerColumns = addHeaderColumn({
        headerColumns: headerColumns,
        title: `${(0, $cstaF.agentProductionTerms).currentSearch} (${dateRangesText.currentSearch.lastIntervalText}: ${dateRangesText.currentSearch.from} - ${dateRangesText.currentSearch.to})`,
        colSpan: countDisplayedColumnsSearch,
        columnObjectName: (0, $fPGDZ.COLUMN_GROUP_SEARCH)
    });
    const countDisplayedColumnsMls = getCountDisplayedColumns((0, $fPGDZ.COLUMN_GROUP_MLS));
    if (countDisplayedColumnsMls) headerColumns = addHeaderColumn({
        headerColumns: headerColumns,
        title: `${(0, $cstaF.agentProductionTerms).allMlsTransactions} ${dateRangesText.allMls.lastIntervalText} (${dateRangesText.allMls.from} - ${dateRangesText.allMls.to})`,
        colSpan: countDisplayedColumnsMls,
        columnObjectName: (0, $fPGDZ.COLUMN_GROUP_MLS)
    });
    const countDisplayedColumnsGrowth = getCountDisplayedColumns((0, $fPGDZ.COLUMN_GROUP_GROWTH));
    if (countDisplayedColumnsGrowth) headerColumns = addHeaderColumn({
        headerColumns: headerColumns,
        title: "Growth",
        colSpan: countDisplayedColumnsGrowth,
        columnObjectName: (0, $fPGDZ.COLUMN_GROUP_GROWTH)
    });
    return [
        headerColumns
    ];
};



var $eHBjM = parcelRequire("eHBjM");

var $cstaF = parcelRequire("cstaF");


var $7jSpM = parcelRequire("7jSpM");
const $0b1af5b1a4885ca1$var$getCountDisplayedColumns = (columns, headerPlacement)=>columns?.filter((c)=>c.isDisplayed && c.headerPlacement === headerPlacement).length || 0;
const $0b1af5b1a4885ca1$export$1a74ad8885329fc4 = ({ columns: columns, tooltips: tooltips = (0, $eHBjM.listingProficiencyTooltips) })=>{
    const listingProficiencyColumns = (0, $7jSpM.transformSchemaTableColumns)(tooltips, (0, $eHBjM.tabModes).LISTING_PROFICIENCY);
    const getAdditionalTableHeaders = (columns, contactColumnsToAlwaysDisplay)=>{
        const additionalAddressColumns = (0, $7jSpM.getAdditionalColumnCount)(columns, listingProficiencyColumns?.officeAddress.id);
        const countDisplayedColumnsContact = $0b1af5b1a4885ca1$var$getCountDisplayedColumns(columns, (0, $2292da915057cb56$export$1a3fc79fb30204b6).CONTACT) + contactColumnsToAlwaysDisplay.length + additionalAddressColumns;
        const countDisplayedColumnsTotalSell = $0b1af5b1a4885ca1$var$getCountDisplayedColumns(columns, (0, $2292da915057cb56$export$1a3fc79fb30204b6).TOTAL_SELL);
        const countDisplayedColumnsTotalList = $0b1af5b1a4885ca1$var$getCountDisplayedColumns(columns, (0, $2292da915057cb56$export$1a3fc79fb30204b6).TOTAL_LIST);
        const countDisplayedColumnsNoPriceChange = $0b1af5b1a4885ca1$var$getCountDisplayedColumns(columns, (0, $2292da915057cb56$export$1a3fc79fb30204b6).NO_PRICE_CHANGE);
        const countDisplayedColumnsPriceChange = $0b1af5b1a4885ca1$var$getCountDisplayedColumns(columns, (0, $2292da915057cb56$export$1a3fc79fb30204b6).PRICE_CHANGE);
        const countDisplayedNonContactHeaders = countDisplayedColumnsTotalSell + countDisplayedColumnsTotalList + countDisplayedColumnsPriceChange + countDisplayedColumnsNoPriceChange;
        const headers = [];
        let headersRow2 = {};
        const classHeader = "border text-center";
        const apt = (0, $cstaF.agentProductionTerms);
        const addHeaderWithClass = (classToUse)=>{
            return (lowers, count, title, addTabHeader)=>(0, $7jSpM.addAdditionalTableHeader)(lowers, count, title, addTabHeader, classToUse);
        };
        const addHeader = addHeaderWithClass(classHeader);
        headersRow2 = addHeader(headersRow2, countDisplayedColumnsContact, apt.officeInformation, (0, $eHBjM.additionalTableHeaders).contact);
        headersRow2 = addHeader(headersRow2, countDisplayedColumnsTotalSell, apt.totalSell, (0, $eHBjM.additionalTableHeaders).column1);
        headersRow2 = addHeader(headersRow2, countDisplayedColumnsTotalList, apt.totalList, (0, $eHBjM.additionalTableHeaders).column2);
        headersRow2 = addHeader(headersRow2, countDisplayedColumnsNoPriceChange, apt.noPriceChangeListings, (0, $eHBjM.additionalTableHeaders).column3);
        headersRow2 = addHeader(headersRow2, countDisplayedColumnsPriceChange, apt.priceChangeListings, (0, $eHBjM.additionalTableHeaders).column4);
        const nonContactSuperheader = (0, $2292da915057cb56$export$359879b5b60b4c62)();
        if (countDisplayedNonContactHeaders) headers.push({
            column1: {
                title: (0, $eHBjM.listingProficiencyColTitles).officeInformation,
                attrs: {
                    colSpan: countDisplayedColumnsContact,
                    className: classHeader
                }
            },
            column2: {
                title: (0, $eHBjM.listingProficiencyColTitles).totalSell,
                attrs: {
                    colSpan: countDisplayedNonContactHeaders,
                    className: classHeader
                }
            },
            column3: {
                title: (0, $eHBjM.listingProficiencyColTitles).totalList,
                attrs: {
                    colSpan: countDisplayedColumnsContact,
                    className: classHeader
                }
            },
            column4: {
                title: (0, $eHBjM.listingProficiencyColTitles).noPriceChangeListings,
                attrs: {
                    colSpan: countDisplayedColumnsContact,
                    className: classHeader
                }
            },
            column5: {
                title: (0, $eHBjM.listingProficiencyColTitles).priceChangeListings,
                attrs: {
                    colSpan: countDisplayedColumnsContact,
                    className: classHeader
                }
            },
            column6: {
                title: nonContactSuperheader,
                attrs: {
                    colSpan: countDisplayedNonContactHeaders,
                    className: classHeader
                }
            },
            column7: {
                title: (0, $eHBjM.listingProficiencyColTitles).emptyString,
                attrs: {
                    colSpan: countDisplayedNonContactHeaders,
                    className: classHeader
                }
            }
        });
        headers.push(headersRow2);
        return headers;
    };
    const contactColumnsToAlwaysDisplay = [
        "agentName",
        "office"
    ];
    const additionalTableHeaders = getAdditionalTableHeaders(columns, contactColumnsToAlwaysDisplay);
    return additionalTableHeaders;
};



var $cstaF = parcelRequire("cstaF");

var $eHBjM = parcelRequire("eHBjM");

var $fPGDZ = parcelRequire("fPGDZ");

var $7jSpM = parcelRequire("7jSpM");
const $633c457f4ca5f67b$export$ac9e8effade4c667 = (columns, dateRangesText, activityCount)=>{
    (0, $7jSpM.transformSchemaTableColumns)((0, $eHBjM.activityToolTips), (0, $eHBjM.tabModes).ACTIVITY);
    const getCountDisplayedColumns = (headerPlacement)=>columns.filter((c)=>c.isDisplayed && c.headerPlacement === headerPlacement).length;
    const addHeaderColumn = ({ headerColumns: headerColumns, title: title, colSpan: colSpan, columnObjectName: columnObjectName })=>{
        return {
            ...headerColumns,
            [columnObjectName]: {
                title: title,
                attrs: {
                    colSpan: colSpan,
                    className: "border text-center"
                }
            }
        };
    };
    let headerColumns = {};
    const countDisplayedColumnsSearch = getCountDisplayedColumns((0, $fPGDZ.COLUMN_GROUP_SEARCH));
    if (countDisplayedColumnsSearch) headerColumns = addHeaderColumn({
        headerColumns: headerColumns,
        title: `${(0, $cstaF.agentProductionTerms).currentSearch} (${dateRangesText.currentSearch.lastIntervalText}: ${dateRangesText.currentSearch.from} - ${dateRangesText.currentSearch.to}) - ${activityCount} ACTIVITIES`,
        colSpan: countDisplayedColumnsSearch,
        columnObjectName: (0, $fPGDZ.COLUMN_GROUP_SEARCH)
    });
    const countDisplayedColumnsMls = getCountDisplayedColumns((0, $fPGDZ.COLUMN_GROUP_MLS));
    if (countDisplayedColumnsMls) headerColumns = addHeaderColumn({
        headerColumns: headerColumns,
        title: `${(0, $cstaF.agentProductionTerms).allMlsTransactions} ${dateRangesText.allMls.lastIntervalText} (${dateRangesText.allMls.from} - ${dateRangesText.allMls.to})`,
        colSpan: countDisplayedColumnsMls,
        columnObjectName: (0, $fPGDZ.COLUMN_GROUP_MLS)
    });
    return [
        headerColumns
    ];
};


const $42d942163c9a4de3$export$54862a28ed3d9ca = (columns, rowData, dateRangesText, col1TitlePrefix, tooltips)=>(0, $acw62.useMemo)(()=>(0, $07235befa2e2f940$export$892433a963901c8)(columns, rowData, dateRangesText, col1TitlePrefix, tooltips), [
        columns,
        rowData,
        dateRangesText
    ]);
const $42d942163c9a4de3$export$4b5edb945bac761c = (columns, dateRangesText, tooltips)=>(0, $acw62.useMemo)(()=>(0, $fddbe63d1671f392$export$86d53fa14874f5e0)(columns, dateRangesText, tooltips), [
        columns,
        dateRangesText
    ]);
const $42d942163c9a4de3$export$76e7236166af5295 = (columns)=>(0, $acw62.useMemo)(()=>(0, $a7847c85305f76ce$export$6593394e45fc102d)(columns), [
        columns
    ]);
const $42d942163c9a4de3$export$e96f0ad03a836f4a = (columns, tooltips)=>(0, $acw62.useMemo)(()=>(0, $0b1af5b1a4885ca1$export$1a74ad8885329fc4)({
            columns: columns,
            tooltips: tooltips
        }), [
        columns
    ]);
const $42d942163c9a4de3$export$13fc03f12ee9132d = (columns, dateRangesText, activityCount)=>(0, $acw62.useMemo)(()=>(0, $633c457f4ca5f67b$export$ac9e8effade4c667)(columns, dateRangesText, activityCount), [
        columns,
        dateRangesText,
        activityCount
    ]);



var $94cVo = parcelRequire("94cVo");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $f61ig = parcelRequire("f61ig");

var $2Xlz6 = parcelRequire("2Xlz6");

var $7tOHe = parcelRequire("7tOHe");
parcelRequire("fHiKR");
var $1BYDb = parcelRequire("1BYDb");
var $5txPe = parcelRequire("5txPe");
var $kN5vy = parcelRequire("kN5vy");

var $90ISC = parcelRequire("90ISC");

var $eHBjM = parcelRequire("eHBjM");

var $cstaF = parcelRequire("cstaF");

var $ivaD7 = parcelRequire("ivaD7");

var $lMblH = parcelRequire("lMblH");

var $jeANf = parcelRequire("jeANf");

var $etdjB = parcelRequire("etdjB");
const $0708f7349a857d02$var$AddAgentListPopover = ()=>{
    const listNameInput = (0, $acw62.useRef)();
    const { agentLists: agentLists, agentListToUpdate: agentListToUpdate, agentListsCheckedValues: agentListsCheckedValues, createAgentsList: createAgentsList, handleUpdateAgentNameSelectedList: handleUpdateAgentNameSelectedList, popoverDataForAddAgentList: popoverDataForAddAgentList, toggleAgentListsPopover: toggleAgentListsPopover } = (0, $90ISC.useCommonStore)((state)=>({
            agentLists: state.agentLists,
            agentListToUpdate: state.agentListToUpdate,
            agentListsCheckedValues: state.agentListsCheckedValues,
            createAgentsList: state.createAgentsList,
            handleUpdateAgentNameSelectedList: state.handleUpdateAgentNameSelectedList,
            popoverDataForAddAgentList: state.popoverDataForAddAgentList,
            toggleAgentListsPopover: state.toggleAgentListsPopover
        }));
    const currentModule = (0, $90ISC.useSearchStore)((state)=>state.selectedModule);
    const { selectedList: selectedList, isLoading: isLoading } = (0, $90ISC.useSavedAgentsStore)((state)=>({
            selectedList: state.selectedListByModule[currentModule],
            isLoading: state.isLoading
        }));
    let mlsId = (0, $90ISC.useSearchStore)((state)=>state[state.selectedModule]?.search)?.mlsId;
    const agentNameSearch = (0, $90ISC.useSearchStore)((state)=>state[(0, $cstaF.modules).proficiencyMetrics.agents]);
    const setListInSearchByAgentSearch = (0, $90ISC.useSearchStore)((state)=>state.setListInSearchByAgentSearch);
    const { agentId: agentId, rowIndex: rowIndex, tableId: tableId, popoverIsOpen: popoverIsOpen, suggAgentsTabId: suggAgentsTabId } = popoverDataForAddAgentList;
    const [state, setState] = (0, $acw62.useState)({
        agentListName: undefined,
        savedAgentLists: agentLists,
        shouldShowModal: false,
        popoverIsOpen: false,
        toastProps: undefined,
        currentRowIndex: undefined,
        reservedNameWarning: ""
    });
    (0, $acw62.useEffect)(()=>{
        if ((currentModule === (0, $cstaF.modules).proficiencyMetrics.suggestedAgents || currentModule === (0, $cstaF.modules).proficiencyMetrics.savedAgents) && selectedList && agentLists?.length) {
            const mlsId = selectedList.mlsId;
            (0, $ivaD7.setStateData)("savedAgentLists", agentLists.filter((list)=>list?.mlsId === mlsId), setState);
        }
    }, [
        currentModule,
        selectedList,
        agentLists
    ]);
    const setToastProps = (type, message)=>(0, $jeANf.showToast)(type, message, setState);
    const toggleModal = ()=>(0, $ivaD7.setStateData)("shouldShowModal", !state.shouldShowModal, setState);
    const handleAgentListNameChange = (e)=>{
        const value = e.target.value.trim();
        (0, $ivaD7.setStateData)("agentListName", value, setState);
        if (value.toLowerCase() === (0, $eHBjM.favoriteAgentTerms).reservedListName.toLowerCase()) (0, $ivaD7.setStateData)("reservedNameWarning", (0, $eHBjM.favoriteAgentTerms).reservedListWarning, setState);
        else (0, $ivaD7.setStateData)("reservedNameWarning", "", setState);
    };
    const handleChecked = (event, listId, listName)=>{
        event.preventDefault();
        (async ()=>{
            const list = agentLists.find((list)=>list?.agentListId === listId);
            const wasAgentRemoved = list?.agentIds.includes(agentId);
            const minAgentsAllowed = 1;
            if (!event.target.checked && list.agentIds.length === minAgentsAllowed) {
                toggleAgentListsPopover();
                setToastProps("error", (0, $eHBjM.popoverTerms).atLeastOneAgentInList);
                return;
            }
            await handleUpdateAgentNameSelectedList(listId, agentId, listName, agentNameSearch, setListInSearchByAgentSearch);
            toggleAgentListsPopover();
            setToastProps("success", wasAgentRemoved ? (0, $eHBjM.popoverTerms).agentRemovedFromList : (0, $eHBjM.popoverTerms).agentAddedToList);
        })();
    };
    const showAgentListModal = ()=>{
        (0, $ivaD7.setStateData)("reservedNameWarning", "", setState);
        toggleModal();
    };
    const cancelAddAgentList = ()=>{
        toggleModal();
        (0, $ivaD7.setStateData)("agentListName", "", setState);
        (0, $ivaD7.setStateData)("reservedNameWarning", "", setState);
    };
    const createAddAgentList = async ()=>{
        if (isLoading) return;
        const agentListName = listNameInput.current.value.trim();
        if (agentListName.toLowerCase() === (0, $eHBjM.favoriteAgentTerms).reservedListName.toLowerCase()) {
            (0, $ivaD7.setStateData)("reservedNameWarning", (0, $eHBjM.favoriteAgentTerms).reservedListWarning, setState);
            return;
        }
        const agentListNameExists = agentLists.filter((list)=>list?.mlsId === mlsId).find((list)=>list?.name.toLowerCase() === agentListName.toLowerCase());
        if (!agentListNameExists) {
            (0, $ivaD7.setStateData)("popoverIsOpen", false, setState);
            toggleAgentListsPopover();
            await createAgentsList(mlsId, agentListName, agentId);
            (0, $ivaD7.setStateData)("agentListName", undefined, setState);
            toggleModal();
        }
        setToastProps(agentListNameExists ? "error" : "success", agentListNameExists ? (0, $eHBjM.favoriteAgentTerms).chooseDifferentName : (0, $eHBjM.favoriteAgentTerms).agentListCreated(agentListName));
    };
    const modalButtons = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                dataLwtId: "cancel-add-agent-list",
                color: "secondary",
                onClick: cancelAddAgentList,
                disabled: isLoading,
                children: (0, $cstaF.buttonTerms).cancel
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                dataLwtId: "save-add-agent-list",
                color: "primary",
                onClick: createAddAgentList,
                disabled: !state.agentListName || isLoading || !!state.reservedNameWarning,
                children: (0, $cstaF.buttonTerms).save
            })
        ]
    });
    const modalChildren = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "modal-warning",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "m-0 text-danger warning-container",
                children: state.reservedNameWarning
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kN5vy))), {
                dataLwtId: "list-name-label",
                className: "font-weight-bold",
                children: (0, $cstaF.searchTerms).nameYourList
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5txPe))), {
                className: "mt-2",
                dataLwtId: "list-name-input",
                defaultValue: state.agentListName,
                innerRef: listNameInput,
                maxLength: 55,
                onChange: handleAgentListNameChange,
                placeholder: (0, $eHBjM.favoriteAgentTerms).enterListName
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                className: "text-muted",
                children: [
                    (0, $eHBjM.favoriteAgentTerms).chooseAName55Char,
                    "."
                ]
            })
        ]
    });
    (0, $acw62.useEffect)(()=>{
        if (!agentLists) return;
        (0, $ivaD7.setStateData)("savedAgentLists", agentLists.filter((list)=>list?.mlsId === mlsId), setState);
    }, [
        agentLists,
        mlsId
    ]);
    const renderedAgentLists = state.savedAgentLists?.map((list)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, {
            children: list?.name === agentListToUpdate ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "d-flex align-items-start checkbox-loader",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: list?.name
                    })
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1BYDb))), {
                checked: agentListsCheckedValues?.[list?.agentListId] || false,
                id: list?.agentListId,
                label: list?.name,
                onChange: (event)=>handleChecked(event, list?.agentListId, list?.name),
                type: (0, $eHBjM.popoverTerms).checkbox
            })
        }, list?.agentListId));
    const popoverBody = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "fav-agents-lists-popover",
                children: mlsId && renderedAgentLists
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("hr", {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "d-flex justify-content-center w-100",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                    className: "btn btn-light text-capitalize",
                    onClick: showAgentListModal,
                    children: (0, $eHBjM.popoverTerms).addList
                })
            })
        ]
    });
    const targetId = (0, $eHBjM.popoverTerms).starIcon(tableId, rowIndex, suggAgentsTabId);
    const targetElement = document.getElementById(targetId);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            popoverIsOpen && !!targetElement && /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Xlz6))), {
                id: (0, $eHBjM.popoverTerms).favoriteAgentPopover,
                target: targetElement,
                placement: (0, $eHBjM.popoverTerms).bottom,
                trigger: !state.shouldShowModal ? (0, $eHBjM.popoverTerms).legacy : undefined,
                header: (0, $eHBjM.favoriteAgentTerms).savedAgentLists,
                toggle: toggleAgentListsPopover,
                isOpen: popoverIsOpen,
                size: (0, $eHBjM.popoverTerms).auto,
                body: popoverBody,
                modifiers: {
                    preventOverflow: {
                        boundariesElement: "viewport"
                    },
                    computeStyle: {
                        adaptive: false,
                        gpuAcceleration: false,
                        maxHeight: 800
                    }
                }
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $lMblH.default), {
                toastProps: state.toastProps
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f61ig.default), {
                children: modalChildren,
                buttons: modalButtons,
                onClose: toggleModal,
                onOpened: ()=>(0, $etdjB.checkReservedName)(listNameInput, setState, (0, $ivaD7.setStateData)),
                show: state.shouldShowModal,
                title: (0, $eHBjM.favoriteAgentTerms).addAgentList
            })
        ]
    });
};
var $0708f7349a857d02$export$2e2bcd8739ae039 = $0708f7349a857d02$var$AddAgentListPopover;



var $i1BZc = parcelRequire("i1BZc");

var $dqgmD = parcelRequire("dqgmD");

var $5269x = parcelRequire("5269x");

var $cstaF = parcelRequire("cstaF");

var $dpjX2 = parcelRequire("dpjX2");
const $0143275b912eedd1$export$776d48afc537e43d = (timeIntervals, period, timePeriod)=>{
    if (period === (0, $cstaF.TimePeriods)["Custom Date"]) {
        if (!timePeriod?.startDate || !timePeriod?.endDate) return null;
        return {
            from: (0, $dpjX2.default)(timePeriod.startDate),
            to: (0, $dpjX2.default)(timePeriod.endDate),
            lastIntervalText: (0, $cstaF.TimePeriods)["Custom Date"]
        };
    }
    const interval = timeIntervals?.find((t)=>t?.intervalType === period);
    if (!interval) return null;
    return {
        from: interval.last?.from ? new Date(interval.last.from) : undefined,
        to: interval.last?.to ? new Date(interval.last.to) : undefined,
        lastIntervalText: interval.lastIntervalText || period
    };
};


const $ef041f3a12ef845d$var$AgentProduction = ({ agentData: agentData, module: module })=>{
    const { selectedMls: selectedMls, selectedSavedSearch: selectedSavedSearch, loadedSearchCriteria: loadedSearchCriteria, isLoadingSearchData: isLoadingSearchData, setSummaryPinnedData: setSummaryPinnedData, searchStatus: searchStatus, currentTab: currentTab, setCurrentTab: setCurrentTab, viewHideAgentsDropdownValue: viewHideAgentsDropdownValue, crossSortOrder: crossSortOrder, sortByStoredOrder: sortByStoredOrder, period: period, timePeriod: timePeriod, clearPMSelectedColumnIds: clearPMSelectedColumnIds } = (0, $90ISC.useSearchStore)((state)=>({
            selectedMls: state[module]?.selectedMls,
            selectedSavedSearch: state[module]?.selectedSavedSearch,
            loadedSearchCriteria: state[module]?.loadedSearchCriteria,
            isLoadingSearchData: state.isLoadingSearchData,
            setSummaryPinnedData: state.setSummaryPinnedData,
            searchStatus: state[module]?.searchStatus,
            currentTab: state[module].currentTab,
            setCurrentTab: state.setCurrentTab,
            viewHideAgentsDropdownValue: state[module]?.selectedViewHideAgentsFilter,
            crossSortOrder: state[module]?.crossSortOrder,
            sortByStoredOrder: state.sortByStoredOrder,
            period: state[state.selectedModule]?.loadedSearchCriteria?.timePeriod?.intervalType?.toString(),
            timePeriod: state[state.selectedModule]?.loadedSearchCriteria?.timePeriod,
            clearPMSelectedColumnIds: state.clearPMSelectedColumnIds
        }));
    const { officeInfo: officeInfo, timeIntervals: timeIntervals, clearAgentListPopover: clearAgentListPopover } = (0, $90ISC.useCommonStore)((state)=>({
            officeInfo: state.officeInfo,
            timeIntervals: state.timeIntervals,
            clearAgentListPopover: state.clearAgentListPopover
        }));
    const restrictedMlsSettings = (0, $fPGDZ.getMlsRestrictionSettings)(selectedMls?.mlsId);
    const applyStoredColumns = (defaultCols, tabMode)=>{
        const state = (0, $90ISC.useSearchStore).getState();
        const storedIds = state[state.selectedModule]?.selectedColumnIds?.[tabMode]?.columns;
        if (!storedIds) return defaultCols;
        return defaultCols.map((col)=>({
                ...col,
                isDisplayed: storedIds.includes(col.id) || storedIds.includes(col.parentColumnId)
            }));
    };
    const [state, setState] = (0, $acw62.useState)({
        showModal: false,
        modalProps: {
            dataLwtId: "agent-production-modal",
            show: false,
            size: "",
            title: "",
            footerClassName: "",
            showFooter: false,
            onClose: ()=>null,
            children: null
        },
        currentAgentChart: null,
        growthAnalysisPeriod: (0, $cstaF.agentProductionTerms).last12Months,
        listingProficiencyColumns: applyStoredColumns((0, $2292da915057cb56$export$7aa1788812152cb5)(), (0, $eHBjM.tabModes).LISTING_PROFICIENCY),
        overviewColumns: applyStoredColumns((0, $fPGDZ.getDefaultOverviewColumns)(), (0, $eHBjM.tabModes).OVERVIEW),
        contactInfoColumns: applyStoredColumns((0, $fPGDZ.getDefaultContactInfoColumns)(restrictedMlsSettings), (0, $eHBjM.tabModes).CONTACT_INFORMATION),
        growthAnalysisColumnsLtm: applyStoredColumns((0, $8E8vr.getDefaultGrowthAnalysisColumnsLtm)(), (0, $eHBjM.tableViewNames).growthAnalysisLtm),
        growthAnalysisColumnsYtd: applyStoredColumns((0, $8E8vr.getDefaultGrowthAnalysisColumnsYtd)(), (0, $eHBjM.tableViewNames).growthAnalysisYtd),
        sortedLtmGrowthAnalysisColumn: (0, $eHBjM.agentsColumns).totalVolume.id,
        sortedYtdGrowthAnalysisColumn: (0, $eHBjM.agentsColumns).totalVolume.id,
        sortedListingProfColumn: (0, $eHBjM.agentsColumns).totalVolume.id,
        selectedTimePeriod: null,
        currentSearchDates: {
            lastIntervalText: "",
            from: null,
            to: null
        },
        timeIntervals: [],
        accessibleOfficeList: [],
        selectedData: agentData,
        userPrivileges: undefined,
        agentInfo: undefined
    });
    const sortedSelectedData = (0, $acw62.useMemo)(()=>{
        return sortByStoredOrder(state.selectedData)?.map((d)=>({
                ...d,
                hasFavStar: true
            }));
    }, [
        state.selectedData,
        crossSortOrder
    ]);
    (0, $acw62.useEffect)(()=>{
        const tabIndexedView = (0, $fPGDZ.tabIndexedViews)[currentTab];
        loadedSearchCriteria && !searchStatus && setSummaryPinnedData(tabIndexedView, (0, $i1BZc.responseKeys).recruitingSoldTotals);
    }, [
        state.selectedData,
        currentTab
    ]);
    const accessibleOfficeSet = state?.accessibleOfficeList?.length ? new Set(state?.accessibleOfficeList?.map((obj)=>obj.mlsOfficeId?.officeId)) : new Set();
    const toggleModal = ()=>{
        (0, $ivaD7.setStateData)("showModal", !state.showModal, setState);
    };
    (0, $acw62.useEffect)(()=>clearAgentListPopover(), []);
    (0, $acw62.useEffect)(()=>{
        officeInfo && (0, $ivaD7.setStateData)("accessibleOfficeList", officeInfo, setState);
    }, [
        officeInfo
    ]);
    (0, $acw62.useEffect)(()=>{
        if (timeIntervals) {
            (0, $ivaD7.setStateData)("timeIntervals", timeIntervals, setState);
            (0, $b77Er.setTimeIntervalData)(timeIntervals);
        }
    }, [
        timeIntervals
    ]);
    (0, $acw62.useEffect)(()=>{
        (0, $ivaD7.setStateData)("title", selectedSavedSearch?.savedSearch?.searchName || (0, $cstaF.agentProductionTerms).proficiencyMetrics, setState);
    }, [
        selectedSavedSearch
    ]);
    (0, $acw62.useEffect)(()=>{
        if (loadedSearchCriteria?.timePeriod && !state.selectedTimePeriod) (0, $ivaD7.setStateData)("selectedTimePeriod", loadedSearchCriteria.timePeriod, setState);
    }, [
        loadedSearchCriteria,
        state.selectedTimePeriod
    ]);
    (0, $acw62.useEffect)(()=>{
        if (agentData === undefined) (0, $ivaD7.setStateData)("selectedData", undefined, setState);
        else if (agentData.constructor.name === "Object" && agentData.error) (0, $ivaD7.setStateData)("showModal", true, setState);
        resetTableColsAndSortsToDefault();
    }, [
        agentData
    ]);
    const prevMlsIdRef = (0, $acw62.useRef)(selectedMls?.mlsId);
    (0, $acw62.useEffect)(()=>{
        const prevMlsId = prevMlsIdRef.current;
        prevMlsIdRef.current = selectedMls?.mlsId;
        if (!selectedMls?.mlsId || prevMlsId === selectedMls?.mlsId || !prevMlsId) return;
        clearPMSelectedColumnIds();
        setState((prevState)=>({
                ...prevState,
                overviewColumns: (0, $fPGDZ.getDefaultOverviewColumns)(),
                contactInfoColumns: (0, $fPGDZ.getDefaultContactInfoColumns)(restrictedMlsSettings),
                growthAnalysisColumnsLtm: (0, $8E8vr.getDefaultGrowthAnalysisColumnsLtm)(),
                growthAnalysisColumnsYtd: (0, $8E8vr.getDefaultGrowthAnalysisColumnsYtd)(),
                listingProficiencyColumns: (0, $2292da915057cb56$export$7aa1788812152cb5)()
            }));
    }, [
        selectedMls?.mlsId,
        restrictedMlsSettings
    ]);
    (0, $acw62.useEffect)(()=>{
        if (agentData) {
            const sortedData = (0, $94cVo.getSortedObjectsNumeric)(agentData, (0, $eHBjM.agentsColumns).totalVolume.id);
            const revisedData = (0, $dqgmD.getRankedData)(sortedData, (0, $eHBjM.agentsColumns).totalVolume.id);
            switch(viewHideAgentsDropdownValue){
                case (0, $eHBjM.viewHideAgentsDropdownLabels).viewOnlyMyAgents:
                    (0, $ivaD7.setStateData)("selectedData", revisedData?.filter((element)=>accessibleOfficeSet?.has(element.officeId)), setState);
                    break;
                case (0, $eHBjM.viewHideAgentsDropdownLabels).hideMyAgents:
                    (0, $ivaD7.setStateData)("selectedData", revisedData?.filter((element)=>!accessibleOfficeSet?.has(element.officeId)), setState);
                    break;
                case (0, $eHBjM.viewHideAgentsDropdownLabels).viewHideAgents:
                    (0, $ivaD7.setStateData)("selectedData", revisedData, setState);
                    break;
                default:
                    (0, $ivaD7.setStateData)("selectedData", revisedData, setState);
            }
        }
    }, [
        viewHideAgentsDropdownValue,
        agentData,
        state.accessibleOfficeList
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!state.selectedTimePeriod || !state.timeIntervals.length) return;
        let currentSearchDates;
        if (state.selectedTimePeriod.intervalType !== (0, $cstaF.TimePeriods)["Custom Date"]) {
            const interval = state.timeIntervals?.find((i)=>i?.intervalType === state.selectedTimePeriod.intervalType);
            if (interval) {
                const lastIntervalText = (0, $dlZsJ.getKeyByValue)((0, $cstaF.TimePeriods), state.selectedTimePeriod.intervalType);
                const from = new Date(`${interval.last.from}Z`);
                const to = new Date(`${interval.last.to}Z`);
                currentSearchDates = {
                    lastIntervalText: lastIntervalText,
                    from: from,
                    to: to
                };
            }
        } else {
            const lastIntervalText = state.selectedTimePeriod.intervalType;
            const from = new Date(state.selectedTimePeriod.startDate);
            const to = new Date(state.selectedTimePeriod.endDate);
            currentSearchDates = {
                lastIntervalText: lastIntervalText,
                from: from,
                to: to
            };
        }
        (0, $ivaD7.setStateData)("currentSearchDates", currentSearchDates, setState);
    }, [
        state.selectedTimePeriod,
        state.timeIntervals
    ]);
    (0, $acw62.useEffect)(()=>{
        (0, $ivaD7.setStateData)("currentAgentChart", state.selectedData?.length > 0 ? state.selectedData[0] : null, setState);
        !state.selectedData && (0, $ivaD7.setStateData)("showModal", false, setState);
    }, [
        state.selectedData
    ]);
    const handleAgentChart = (agent)=>(0, $ivaD7.setStateData)("currentAgentChart", agent, setState);
    const { chartOptions: chartOptions, chartSchema: chartSchema } = (0, $7735f71d5623fcf5$export$2e2bcd8739ae039)(handleAgentChart);
    const searchPeriodDates = timeIntervals?.length && (0, $0143275b912eedd1$export$776d48afc537e43d)(timeIntervals, period, timePeriod);
    const last12MonthsDates = timeIntervals?.length && (0, $0143275b912eedd1$export$776d48afc537e43d)(timeIntervals, (0, $cstaF.agentProductionTerms).annually);
    const dateRangesText = {
        currentSearch: (0, $5269x.getDateRangeText)(searchPeriodDates),
        allMls: (0, $5269x.getDateRangeText)(last12MonthsDates)
    };
    const setSortedLtmGrowthAnalysisColumn = (field)=>{
        (0, $ivaD7.setStateData)("sortedLtmGrowthAnalysisColumn", field, setState);
    };
    const setSortedYtdGrowthAnalysisColumn = (field)=>{
        (0, $ivaD7.setStateData)("sortedYtdGrowthAnalysisColumn", field, setState);
    };
    const setSortedListingProfColumn = (field)=>{
        (0, $ivaD7.setStateData)("sortedListingProfColumn", field, setState);
    };
    const resetTableColsAndSortsToDefault = ()=>{
        [
            setSortedLtmGrowthAnalysisColumn,
            setSortedYtdGrowthAnalysisColumn,
            setSortedListingProfColumn
        ].map((setOption)=>{
            setOption("totalVolume");
        });
    };
    const additionalTableHeaders = (0, $42d942163c9a4de3$export$54862a28ed3d9ca)(state.overviewColumns, state.selectedData?.length, dateRangesText);
    const growthTableHeadersLtm = (0, $42d942163c9a4de3$export$76e7236166af5295)(state.growthAnalysisColumnsLtm);
    const growthTableHeadersYtd = (0, $42d942163c9a4de3$export$76e7236166af5295)(state.growthAnalysisColumnsYtd);
    const contactInfoAdditionalHeaders = (0, $42d942163c9a4de3$export$4b5edb945bac761c)(state.contactInfoColumns, dateRangesText);
    const proficiencyTableHeaders = (0, $42d942163c9a4de3$export$e96f0ad03a836f4a)(state.listingProficiencyColumns);
    const isExportDisabled = state.selectedData?.length === 0;
    const setListingProficiencyColumns = (columns)=>{
        (0, $ivaD7.setStateData)("listingProficiencyColumns", columns, setState);
    };
    const setOverviewColumns = (overviewColumns)=>{
        (0, $ivaD7.setStateData)("overviewColumns", overviewColumns, setState);
    };
    const setContactInfoColumns = (contactInfoColumns)=>{
        (0, $ivaD7.setStateData)("contactInfoColumns", contactInfoColumns, setState);
    };
    const setGrowthAnalysisColumnsYtd = (cols)=>{
        (0, $ivaD7.setStateData)("growthAnalysisColumnsYtd", cols, setState);
    };
    const setGrowthAnalysisColumnsLtm = (growthAnalysisColumnsLtm)=>{
        (0, $ivaD7.setStateData)("growthAnalysisColumnsLtm", growthAnalysisColumnsLtm, setState);
    };
    const setGrowthAnalysisPeriod = (period)=>{
        (0, $ivaD7.setStateData)("growthAnalysisPeriod", period, setState);
    };
    const yearDetails = (0, $fPGDZ.getSearchDateYearDetails)(state.currentSearchDates, currentTab);
    const headerProps = {
        module: module,
        isExportDisabled: isExportDisabled,
        exportCsv: ()=>(0, $ba4fc233a0a159d1$export$6a3b3e40f9ef1478)(state, setState, currentTab, state.selectedData),
        showExportButton: true,
        title: state.title,
        tab: currentTab,
        growthAnalysisPeriod: state.growthAnalysisPeriod,
        agentData: state.selectedData,
        year: yearDetails,
        showShareButton: false
    };
    const initialSearchNotRun = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3c17adf0ba4aae41$export$2e2bcd8739ae039), {
                title: state.title,
                module: module,
                showExportButton: false,
                showHideAgentsDropdown: false
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "text-center",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "initial-search",
                        children: (0, $cstaF.agentProductionTerms).initialLoad
                    })
                ]
            })
        ]
    });
    const loader = /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "py-3",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {})
    });
    const resultsFound = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f61ig.default), {
                ...state.modalProps,
                show: state.showModal
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3c17adf0ba4aae41$export$2e2bcd8739ae039), {
                ...headerProps,
                showHideAgentsDropdown: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "content",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8f390b0d641c1be9$export$2e2bcd8739ae039), {
                        navSize: 4,
                        contentSize: 4,
                        items: [
                            {
                                title: (0, $cstaF.agentProductionTerms).overview,
                                content: {
                                    jsx: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ab5abed591bd149f$export$2e2bcd8739ae039), {
                                        agentData: sortedSelectedData,
                                        chartOptions: chartOptions,
                                        chartSchema: chartSchema,
                                        currentAgentChart: state.currentAgentChart,
                                        additionalTableHeaders: additionalTableHeaders,
                                        columns: state.overviewColumns,
                                        setColumns: setOverviewColumns,
                                        module: module,
                                        state: state,
                                        setState: setState,
                                        isActive: currentTab === (0, $fPGDZ.tabIndexes).OVERVIEW
                                    })
                                }
                            },
                            {
                                title: (0, $cstaF.agentProductionTerms).contactInformation,
                                content: {
                                    jsx: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6b203572ebe7b0e2$export$2e2bcd8739ae039), {
                                        additionalTableHeaders: contactInfoAdditionalHeaders,
                                        agentData: sortedSelectedData,
                                        columns: state.contactInfoColumns,
                                        setColumns: setContactInfoColumns,
                                        state: state,
                                        setState: setState,
                                        isActive: currentTab === (0, $fPGDZ.tabIndexes).CONTACT_INFORMATION
                                    })
                                }
                            },
                            {
                                title: (0, $cstaF.agentProductionTerms).growthAnalysis,
                                content: {
                                    jsx: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $c4d8c3e8dac261fa$export$2e2bcd8739ae039), {
                                        agentData: sortedSelectedData,
                                        additionalTableHeadersLtm: growthTableHeadersLtm,
                                        additionalTableHeadersYtd: growthTableHeadersYtd,
                                        growthAnalysisPeriod: state.growthAnalysisPeriod,
                                        setGrowthAnalysisPeriod: setGrowthAnalysisPeriod,
                                        ltmColumns: state.growthAnalysisColumnsLtm,
                                        ytdColumns: state.growthAnalysisColumnsYtd,
                                        setColumnsLtm: setGrowthAnalysisColumnsLtm,
                                        setColumnsYtd: setGrowthAnalysisColumnsYtd,
                                        currentSearchDates: state.currentSearchDates,
                                        state: state,
                                        setState: setState,
                                        isActive: currentTab === (0, $fPGDZ.tabIndexes).GROWTH_ANALYSIS
                                    })
                                }
                            },
                            {
                                title: (0, $cstaF.agentProductionTerms).listingProficiency,
                                content: {
                                    jsx: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3dced25acf3161ee$export$2e2bcd8739ae039), {
                                        agentData: sortedSelectedData,
                                        additionalTableHeaders: proficiencyTableHeaders,
                                        setColumns: setListingProficiencyColumns,
                                        columns: state.listingProficiencyColumns,
                                        state: state,
                                        setState: setState,
                                        isActive: currentTab === (0, $fPGDZ.tabIndexes).LISTING_PROFICIENCY
                                    })
                                }
                            }
                        ],
                        tabs: true,
                        currentIndex: currentTab,
                        setCurrentIndex: (index)=>setCurrentTab(index)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0708f7349a857d02$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
    const noResultsFound = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3c17adf0ba4aae41$export$2e2bcd8739ae039), {
                title: state.title,
                module: module,
                showExportButton: false,
                showHideAgentsDropdown: false
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "text-center",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $126e7d6ff1f55059$export$3f0134fa5c63d52e), {})
                ]
            })
        ]
    });
    const errorCodes = [
        (0, $i1BZc.HTTP_RESPONSES).badRequest,
        (0, $i1BZc.HTTP_RESPONSES).notFound,
        (0, $i1BZc.HTTP_RESPONSES).conflict
    ];
    const noResponse = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3c17adf0ba4aae41$export$2e2bcd8739ae039), {
                title: state.title,
                module: module,
                showExportButton: false,
                showHideAgentsDropdown: false
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "content text-center",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "initial-search",
                        children: (0, $cstaF.agentProductionTerms).initialLoad
                    })
                ]
            }),
            !errorCodes.includes(state.selectedData?.response) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f61ig.default), {
                ...state.modalProps,
                title: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "font-weight-bold",
                    children: "Error"
                }),
                showFooter: true,
                show: state.showModal,
                onClose: toggleModal,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "pb-30",
                    children: !state.selectedData?.response || state.selectedData?.response !== (0, $i1BZc.HTTP_RESPONSES).payloadTooLarge ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            (0, $cstaF.agentProductionTerms).errorServerNoResponse,
                            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                href: `mailto:${(0, $cstaF.emails).lwolfSupport}`,
                                className: "underlined-text",
                                children: (0, $cstaF.emails).lwolfSupport
                            }),
                            "."
                        ]
                    }) : state.selectedData?.response === (0, $i1BZc.HTTP_RESPONSES).payloadTooLarge && (0, $cstaF.agentProductionTerms).errorServer413
                })
            })
        ]
    });
    const noOnlyMyAgentsResultsFound = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3c17adf0ba4aae41$export$2e2bcd8739ae039), {
                ...headerProps,
                title: state.title,
                showHideAgentsDropdown: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "content text-center",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "no-search-results-suggestion",
                        children: (0, $cstaF.agentProductionTerms).viewOnlyMyAgentsNoData
                    })
                ]
            })
        ]
    });
    const isInitialSearchNotRun = loadedSearchCriteria === undefined;
    const hasResults = !!state.selectedData?.length;
    const hasNoResults = state.selectedData?.length === 0;
    const hasNoResponse = state.selectedData?.constructor.name === "Object";
    const hasNoOnlyMyAgentsResults = viewHideAgentsDropdownValue === (0, $eHBjM.viewHideAgentsDropdownLabels).viewOnlyMyAgents && state.selectedData?.constructor.name === "Array" && state.selectedData?.length === 0;
    if (isLoadingSearchData) return loader;
    if (isInitialSearchNotRun) return initialSearchNotRun;
    if (hasNoResponse) return noResponse;
    if (hasResults) return resultsFound;
    if (hasNoOnlyMyAgentsResults) return noOnlyMyAgentsResultsFound;
    if (hasNoResults) return noResultsFound;
    return loader;
};
$ef041f3a12ef845d$var$AgentProduction.propTypes = {
    agentData: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    module: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};
var $ef041f3a12ef845d$export$2e2bcd8739ae039 = $ef041f3a12ef845d$var$AgentProduction;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $kfZjc = parcelRequire("kfZjc");

parcelRequire("3lOdM");
var $e155p = parcelRequire("e155p");
var $1279088ab0041e70$exports = {};
"use strict";
var $1279088ab0041e70$var$__importDefault = $1279088ab0041e70$exports && $1279088ab0041e70$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($1279088ab0041e70$exports, "__esModule", {
    value: true
});

const $1279088ab0041e70$var$react_1 = $1279088ab0041e70$var$__importDefault((parcelRequire("acw62")));
var $8df5923a085678de$exports = {};
"use strict";
var $8df5923a085678de$var$__importDefault = $8df5923a085678de$exports && $8df5923a085678de$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($8df5923a085678de$exports, "__esModule", {
    value: true
});

const $8df5923a085678de$var$react_1 = $8df5923a085678de$var$__importDefault((parcelRequire("acw62")));

var $2FwhD = parcelRequire("2FwhD");
const $8df5923a085678de$var$Row = (props)=>$8df5923a085678de$var$react_1.default.createElement($2FwhD.default, {
        ...props
    });
$8df5923a085678de$exports.default = $8df5923a085678de$var$Row;


var $6c7f621558e355ca$exports = {};
"use strict";
var $6c7f621558e355ca$var$__importDefault = $6c7f621558e355ca$exports && $6c7f621558e355ca$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($6c7f621558e355ca$exports, "__esModule", {
    value: true
});

const $6c7f621558e355ca$var$react_1 = $6c7f621558e355ca$var$__importDefault((parcelRequire("acw62")));

var $aKUQz = parcelRequire("aKUQz");
const $6c7f621558e355ca$var$Col = (props)=>$6c7f621558e355ca$var$react_1.default.createElement($aKUQz.default, {
        ...props
    });
$6c7f621558e355ca$exports.default = $6c7f621558e355ca$var$Col;





const $1279088ab0041e70$var$classnames_1 = $1279088ab0041e70$var$__importDefault((parcelRequire("8g1PZ")));
const $1279088ab0041e70$var$StickyFooter = (props)=>{
    const { className: className, columnProps: columnProps, isPanelFooter: isPanelFooter, dataLwtId: dataLwtId } = props;
    const stickyFooterClasses = (0, $1279088ab0041e70$var$classnames_1.default)("sticky-footer", className, "border-top position-fixed px-4 py-2", isPanelFooter ? "panel-footer bg-light" : "page-footer bg-white");
    const columns = columnProps.map((columnProp, index)=>{
        return $1279088ab0041e70$var$react_1.default.createElement($6c7f621558e355ca$exports.default, {
            key: index,
            ...columnProp
        });
    });
    return $1279088ab0041e70$var$react_1.default.createElement("div", {
        className: stickyFooterClasses,
        "data-lwt-id": dataLwtId
    }, $1279088ab0041e70$var$react_1.default.createElement($8df5923a085678de$exports.default, null, columns));
};
$1279088ab0041e70$exports.default = $1279088ab0041e70$var$StickyFooter;


var $859b3aeec7a854d9$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($1279088ab0041e70$exports)));



var $cstaF = parcelRequire("cstaF");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $kfZjc = parcelRequire("kfZjc");

var $c9Z8w = parcelRequire("c9Z8w");

var $aTLkh = parcelRequire("aTLkh");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $ghmpR = parcelRequire("ghmpR");

var $cstaF = parcelRequire("cstaF");

var $bq4QZ = parcelRequire("bq4QZ");

var $c7dF9 = parcelRequire("c7dF9");

var $eHBjM = parcelRequire("eHBjM");

var $ekOct = parcelRequire("ekOct");

var $90ISC = parcelRequire("90ISC");

var $dDBOF = parcelRequire("dDBOF");

var $eOjgM = parcelRequire("eOjgM");

var $dI25G = parcelRequire("dI25G");

var $acw62 = parcelRequire("acw62");

var $i95vK = parcelRequire("i95vK");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $dqgmD = parcelRequire("dqgmD");

var $htzEo = parcelRequire("htzEo");

var $3etjB = parcelRequire("3etjB");

var $cstaF = parcelRequire("cstaF");


var $i95vK = parcelRequire("i95vK");

const $6b56815170881da9$export$7661b236e66dd51f = {
    totalVolume: {
        exportLabel: (0, $cstaF.marketShareListingStatuses).SoldBothSides
    },
    totalUnits: {
        exportLabel: (0, $cstaF.marketShareListingStatuses).SoldBothSides
    },
    listVolume: {
        exportLabel: (0, $cstaF.marketShareListingStatuses).SoldListSide
    },
    listUnits: {
        exportLabel: (0, $cstaF.marketShareListingStatuses).SoldListSide
    },
    sellVolume: {
        exportLabel: (0, $cstaF.marketShareListingStatuses).SoldSellSide
    },
    sellUnits: {
        exportLabel: (0, $cstaF.marketShareListingStatuses).SoldSellSide
    },
    soldVolume: {
        exportLabel: (0, $cstaF.marketShareListingStatuses).SoldSellSide
    },
    soldUnits: {
        exportLabel: (0, $cstaF.marketShareListingStatuses).SoldSellSide
    },
    actVolume: {
        exportLabel: (0, $cstaF.marketShareListingStatuses).ForSale
    },
    actUnits: {
        exportLabel: (0, $cstaF.marketShareListingStatuses).ForSale
    },
    ucVolume: {
        exportLabel: (0, $cstaF.marketShareListingStatuses).UnderContract
    },
    ucUnits: {
        exportLabel: (0, $cstaF.marketShareListingStatuses).UnderContract
    },
    newListVolume: {
        exportLabel: (0, $cstaF.marketShareListingStatuses).New
    },
    newListUnits: {
        exportLabel: (0, $cstaF.marketShareListingStatuses).New
    }
};
const $6b56815170881da9$export$a68f81111632e1d = (searchType, listingStatus, listingType)=>{
    const date = (0, $htzEo.csvExportDateFormat)(new Date());
    const template = listingType ? (0, $3etjB.exportFilenameTemplates).totals : (0, $3etjB.exportFilenameTemplates).coverage;
    return (0, $0d036ea0861162a7$export$7b8815dbb577b4ee)(template, {
        [(0, $i95vK.fieldMarkers).SEARCH_TYPE]: searchType,
        [(0, $i95vK.fieldMarkers).LISTING_STATUS_FILTER]: listingStatus,
        ...listingType && {
            [(0, $i95vK.fieldMarkers).LISTING_TYPE]: listingType
        },
        [(0, $i95vK.fieldMarkers).DATE]: date
    });
};
const $6b56815170881da9$export$110b0004069db2f8 = ({ tableName: tableName, listingViewId: listingViewId, listingStatusTitle: listingStatusTitle })=>{
    const listingType = listingViewId ? $6b56815170881da9$export$7661b236e66dd51f[listingViewId]?.exportLabel : listingStatusTitle;
    return (0, $0d036ea0861162a7$export$7b8815dbb577b4ee)((0, $3etjB.exportFilenameTemplates).officeBreakdown, {
        [(0, $i95vK.fieldMarkers).OWNER]: tableName,
        [(0, $i95vK.fieldMarkers).LISTING_TYPE]: listingType
    });
};
const $6b56815170881da9$export$1cdb6306c38153be = (tableName, listingType)=>(0, $0d036ea0861162a7$export$7b8815dbb577b4ee)((0, $3etjB.exportFilenameTemplates).listingBreakdown, {
        [(0, $i95vK.fieldMarkers).OWNER]: tableName,
        [(0, $i95vK.fieldMarkers).LISTING_TYPE]: listingType
    });
const $6b56815170881da9$export$8689ed52bebb9688 = (agentName, selectedTabName, mlsName, period)=>(0, $0d036ea0861162a7$export$7b8815dbb577b4ee)((0, $3etjB.exportFilenameTemplates).agentDetails, {
        [(0, $i95vK.fieldMarkers).AGENT_NAME]: agentName,
        [(0, $i95vK.fieldMarkers).TAB_LABEL]: selectedTabName,
        [(0, $i95vK.fieldMarkers).MLS_NAME]: mlsName,
        [(0, $i95vK.fieldMarkers).PERIOD]: period
    });
const $6b56815170881da9$export$382f55aa456f5721 = Object.freeze({
    msSearchResults: "msSearchResults",
    msOfficesBreakdown: "msOfficesBreakdown",
    msListingsBreakdown: "msListingsBreakdown"
});
const $6b56815170881da9$export$98b10a764a190f3d = (exportDetails)=>({
        [$6b56815170881da9$export$382f55aa456f5721.msSearchResults]: $6b56815170881da9$export$a68f81111632e1d(exportDetails.searchType, exportDetails.listingStatus, exportDetails.listingType),
        [$6b56815170881da9$export$382f55aa456f5721.msOfficesBreakdown]: $6b56815170881da9$export$110b0004069db2f8(exportDetails),
        [$6b56815170881da9$export$382f55aa456f5721.msListingsBreakdown]: $6b56815170881da9$export$1cdb6306c38153be(exportDetails.tableName, exportDetails.listingBreakdownStatus),
        [(0, $e70e792f19abcc91$export$382f55aa456f5721).agentDetailSearchResults]: $6b56815170881da9$export$8689ed52bebb9688(exportDetails.agentName, exportDetails.selectedTabName, exportDetails.mlsName, exportDetails.period)
    });



var $htzEo = parcelRequire("htzEo");


var $i95vK = parcelRequire("i95vK");

var $i95vK = parcelRequire("i95vK");
const $b937fb8a7aa66613$export$b02d86cbb3d565d5 = {
    searchResults: `Market Dynamics ${(0, $i95vK.fieldMarkers).LISTING_VIEW} - Export - ${(0, $i95vK.fieldMarkers).DATE}`,
    officeBreakdown: `Market Dynamics Office Breakdown for ${(0, $i95vK.fieldMarkers).LISTING_TYPE} - ${(0, $i95vK.fieldMarkers).DATE}`,
    listingsBreakdown: `Market Dynamics Listings Breakdown for ${(0, $i95vK.fieldMarkers).LISTING_TYPE}, ${(0, $i95vK.fieldMarkers).LISTING_STATUS_FILTER} - ${(0, $i95vK.fieldMarkers).DATE}`
};


const $7eeaa9977bfe14b6$export$382f55aa456f5721 = Object.freeze({
    mdSearchResults: "mdSearchResults",
    mdOfficeBreakdown: "mdOfficeBreakdown",
    mdListingsBreakdown: "mdListingsBreakdown"
});
const $7eeaa9977bfe14b6$export$110b0004069db2f8 = (listingType)=>{
    const date = (0, $htzEo.csvExportDateFormat)(new Date());
    return (0, $0d036ea0861162a7$export$7b8815dbb577b4ee)((0, $b937fb8a7aa66613$export$b02d86cbb3d565d5).officeBreakdown, {
        [(0, $i95vK.fieldMarkers).LISTING_TYPE]: listingType,
        [(0, $i95vK.fieldMarkers).DATE]: date
    });
};
const $7eeaa9977bfe14b6$export$9362f3c259d783c3 = (listingType, listingStatus)=>{
    const date = (0, $htzEo.csvExportDateFormat)(new Date());
    return (0, $0d036ea0861162a7$export$7b8815dbb577b4ee)((0, $b937fb8a7aa66613$export$b02d86cbb3d565d5).listingsBreakdown, {
        [(0, $i95vK.fieldMarkers).LISTING_TYPE]: listingType,
        [(0, $i95vK.fieldMarkers).DATE]: date,
        [(0, $i95vK.fieldMarkers).LISTING_STATUS_FILTER]: listingStatus
    });
};
const $7eeaa9977bfe14b6$export$2e1a842522d50ad8 = (listingView)=>{
    const date = (0, $htzEo.csvExportDateFormat)(new Date());
    return (0, $0d036ea0861162a7$export$7b8815dbb577b4ee)((0, $b937fb8a7aa66613$export$b02d86cbb3d565d5).searchResults, {
        [(0, $i95vK.fieldMarkers).LISTING_VIEW]: listingView,
        [(0, $i95vK.fieldMarkers).DATE]: date
    });
};
const $7eeaa9977bfe14b6$export$98b10a764a190f3d = (exportDetails)=>({
        [$7eeaa9977bfe14b6$export$382f55aa456f5721.mdSearchResults]: $7eeaa9977bfe14b6$export$2e1a842522d50ad8(exportDetails.listingView),
        [$7eeaa9977bfe14b6$export$382f55aa456f5721.mdOfficeBreakdown]: $7eeaa9977bfe14b6$export$110b0004069db2f8(exportDetails.listingType),
        [$7eeaa9977bfe14b6$export$382f55aa456f5721.mdListingsBreakdown]: $7eeaa9977bfe14b6$export$9362f3c259d783c3(exportDetails.listingType, exportDetails.listingStatus)
    });



var $i95vK = parcelRequire("i95vK");


var $hQz0O = parcelRequire("hQz0O");
const $94088b34ebad1923$export$382f55aa456f5721 = Object.freeze({
    searchResults: "amSearchResults",
    breakdownResults: "breakdownResults",
    fromBreakdownGrowthResults: "fromBreakdownGrowthResults"
});
const $94088b34ebad1923$export$d55a78a21c0d3e97 = ({ date: date, exportType: exportType, office: office, currentBreakdownTab: currentBreakdownTab, isOfficeListBreakdown: isOfficeListBreakdown, fromOfficeBreakdownAndGrowthTab: fromOfficeBreakdownAndGrowthTab })=>{
    const fromOrTo = currentBreakdownTab?.title === (0, $hQz0O.terms).gainedAgents ? (0, $hQz0O.terms).from : (0, $hQz0O.terms).to;
    return (0, $0d036ea0861162a7$export$7b8815dbb577b4ee)((0, $hQz0O.exportFilenameTemplates)[exportType] || "", {
        [(0, $i95vK.fieldMarkers).DATE]: date,
        [(0, $i95vK.fieldMarkers).OFFICE]: office?.name || "",
        [(0, $i95vK.fieldMarkers).AM_BREAKDOWN_TAB]: currentBreakdownTab?.title,
        [(0, $i95vK.fieldMarkers).FROM_OR_TO]: isOfficeListBreakdown || fromOfficeBreakdownAndGrowthTab ? "" : fromOrTo
    });
};
const $94088b34ebad1923$export$98b10a764a190f3d = (exportDetails)=>({
        [$94088b34ebad1923$export$382f55aa456f5721.searchResults]: $94088b34ebad1923$export$d55a78a21c0d3e97(exportDetails),
        [$94088b34ebad1923$export$382f55aa456f5721.breakdownResults]: $94088b34ebad1923$export$d55a78a21c0d3e97(exportDetails),
        [$94088b34ebad1923$export$382f55aa456f5721.fromBreakdownGrowthResults]: $94088b34ebad1923$export$d55a78a21c0d3e97(exportDetails)
    });




var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $cstaF = parcelRequire("cstaF");

var $dI25G = parcelRequire("dI25G");

var $eOjgM = parcelRequire("eOjgM");

var $i95vK = parcelRequire("i95vK");

var $7tOHe = parcelRequire("7tOHe");
const $6bacc575af55714b$var$ExportButton = ({ onClick: onClick, isDisabled: isDisabled, type: type, isLoading: isLoading })=>{
    const primaryProps = {
        color: (0, $i95vK.exportButtonTypes).primary
    };
    const secondaryProps = {
        color: (0, $i95vK.exportButtonTypes).secondary,
        className: "bg-dark m-0 btn-sm mr-1 downloadBtn"
    };
    const primaryContent = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "d-flex align-items-center justify-content-center xs-spinner",
        children: [
            isLoading && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {}),
            (0, $cstaF.buttonTerms).download
        ]
    });
    const secondaryContent = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "d-flex align-items-center justify-content-center xs-spinner",
        children: [
            isLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mr-2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {})
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                icon: (0, $eOjgM.inbox),
                className: "mr-2"
            }),
            (0, $cstaF.buttonTerms).download
        ]
    });
    const configByType = {
        primary: {
            props: primaryProps,
            content: primaryContent
        },
        secondary: {
            props: secondaryProps,
            content: secondaryContent
        }
    };
    const config = configByType[type];
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "export-button-with-logo",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
            id: "downloadButton",
            dataLwtId: "export",
            onClick: onClick,
            disabled: isDisabled || isLoading,
            ...config.props,
            children: config.content
        })
    });
};
$6bacc575af55714b$var$ExportButton.propTypes = {
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
var $6bacc575af55714b$export$2e2bcd8739ae039 = $6bacc575af55714b$var$ExportButton;



var $90ISC = parcelRequire("90ISC");

var $cstaF = parcelRequire("cstaF");

var $ekOct = parcelRequire("ekOct");

var $bA5Mi = parcelRequire("bA5Mi");
const $0d036ea0861162a7$var$getStoreStatuses = ()=>{
    const fileType = (0, $bA5Mi.usePDFStore).getState()?.downloadModalStatus?.fileType;
    const exportPdf = (0, $90ISC.useCommonStore).getState()?.handleConvertToPDF;
    const selectedModule = (0, $90ISC.useSearchStore).getState()?.selectedModule;
    const isModalExportRoute = (0, $ekOct.exportModalByRoute).includes(window.location.pathname);
    return {
        exportPdf: exportPdf,
        fileType: fileType,
        isModalExportRoute: isModalExportRoute,
        selectedModule: selectedModule
    };
};
const $0d036ea0861162a7$export$7b8815dbb577b4ee = (template, markers)=>{
    let filename = template;
    Object.keys(markers).forEach((marker)=>{
        filename = filename.replace(marker, markers[marker]);
    });
    return filename;
};
const $0d036ea0861162a7$var$handleExportAction = ({ gridRef: gridRef, fileName: fileName, isDirectPdf: isDirectPdf, isTabExport: isTabExport, shouldUsePrimaryColumns: shouldUsePrimaryColumns })=>{
    const { exportPdf: exportPdf, fileType: fileType, isModalExportRoute: isModalExportRoute } = $0d036ea0861162a7$var$getStoreStatuses();
    const columnDefs = shouldUsePrimaryColumns ? gridRef.current?.columnApi?.api?.columnModel?.primaryColumns : gridRef.current?.columnApi?.api?.columnModel?.columnDefs;
    let exportedColumns = [];
    columnDefs?.forEach((col)=>{
        if ((0, $dqgmD.shouldExportColumn)(col)) exportedColumns.push(col?.field || col?.colId);
    });
    const exportParams = {
        fileName: fileName,
        columnKeys: exportedColumns,
        processCellCallback: (0, $dqgmD.getExportCellValue),
        processHeaderCallback: (0, $dqgmD.getExportHeaderText),
        skipColumnGroupHeaders: shouldUsePrimaryColumns
    };
    const exportCsv = ()=>isTabExport ? gridRef?.api?.exportDataAsCsv(exportParams) : gridRef.current?.api?.exportDataAsCsv(exportParams);
    if (isDirectPdf || isModalExportRoute && fileType === (0, $cstaF.downloadFileTypes).pdf) exportPdf();
    if (!isModalExportRoute || isModalExportRoute && fileType === (0, $cstaF.downloadFileTypes).csv) exportCsv();
};
const $0d036ea0861162a7$export$1396dd911f86baee = (exportDetails)=>{
    const filename = {
        ...(0, $6b56815170881da9$export$98b10a764a190f3d)(exportDetails),
        ...(0, $7eeaa9977bfe14b6$export$98b10a764a190f3d)(exportDetails),
        ...(0, $94088b34ebad1923$export$98b10a764a190f3d)(exportDetails),
        ...(0, $e70e792f19abcc91$export$98b10a764a190f3d)(exportDetails)
    }[exportDetails.exportType];
    return (0, $dqgmD.getScrubbedFilenameForExport)(filename);
};
const $0d036ea0861162a7$var$handleModalExportAction = ({ gridRef: gridRef, fileName: fileName, shouldUsePrimaryColumns: shouldUsePrimaryColumns })=>{
    (0, $bA5Mi.usePDFStore).getState().setDownloadModalStatus({
        isOpen: true,
        fileType: (0, $cstaF.downloadFileTypes).csv,
        fileName: fileName,
        clickAction: ()=>$0d036ea0861162a7$var$handleExportAction({
                gridRef: gridRef,
                fileName: fileName,
                shouldUsePrimaryColumns: shouldUsePrimaryColumns
            })
    });
};
const $0d036ea0861162a7$export$e89cb83db8826f3 = ({ exportDetails: exportDetails, gridRef: gridRef, type: type, isDisabled: isDisabled, isDirectPdf: isDirectPdf, isLoading: isLoading, isTabExport: isTabExport, shouldUsePrimaryColumns: shouldUsePrimaryColumns, filename: filename })=>{
    const handleClick = ()=>{
        const { isModalExportRoute: isModalExportRoute } = $0d036ea0861162a7$var$getStoreStatuses();
        const exportFilename = filename || $0d036ea0861162a7$export$1396dd911f86baee(exportDetails);
        isModalExportRoute && !isDirectPdf ? $0d036ea0861162a7$var$handleModalExportAction({
            gridRef: gridRef,
            fileName: exportFilename,
            shouldUsePrimaryColumns: shouldUsePrimaryColumns
        }) : $0d036ea0861162a7$var$handleExportAction({
            gridRef: gridRef,
            fileName: exportFilename,
            isDirectPdf: isDirectPdf,
            isTabExport: isTabExport,
            shouldUsePrimaryColumns: shouldUsePrimaryColumns
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6bacc575af55714b$export$2e2bcd8739ae039), {
        onClick: handleClick,
        type: type,
        isDisabled: isDisabled,
        isLoading: isLoading
    });
};
const $0d036ea0861162a7$export$bab0ef488509bc69 = ({ chartProps: chartProps, dataLabelsFontSize: dataLabelsFontSize, dataLabelsOffsetY: dataLabelsOffsetY, gridPadding: gridPadding, height: height, xAxisLabelsFontSize: xAxisLabelsFontSize })=>({
        ...chartProps,
        options: {
            ...chartProps.options,
            grid: {
                ...chartProps.options.grid,
                padding: gridPadding || chartProps.options.grid.padding || {
                    top: 0,
                    bottom: 60
                }
            },
            xaxis: {
                ...chartProps.options.xaxis,
                labels: {
                    ...chartProps.options.xaxis?.labels,
                    style: {
                        ...chartProps.options.xaxis?.labels && chartProps.options.xaxis.labels.style || {},
                        fontSize: xAxisLabelsFontSize || chartProps.options.xaxis.labels.style.fontSize || "19px"
                    },
                    rotate: -45,
                    offsetY: 10
                }
            },
            dataLabels: {
                ...chartProps.options.dataLabels || {},
                style: {
                    ...chartProps.options.dataLabels?.style || {},
                    fontSize: dataLabelsFontSize || chartProps.options.dataLabels.style.fontSize || "22px"
                },
                offsetY: (typeof chartProps.options.dataLabels?.offsetY === "number" ? chartProps.options.dataLabels.offsetY : dataLabelsOffsetY || chartProps.options.dataLabels.offsetY || -20) - 10
            }
        },
        height: height || chartProps.height || 700
    });



var $eHBjM = parcelRequire("eHBjM");
const $e70e792f19abcc91$export$382f55aa456f5721 = Object.freeze({
    agentDetailSearchResults: "agentDetailSearchResults"
});
const $e70e792f19abcc91$export$b02d86cbb3d565d5 = {
    agentDetailSearchResults: `${(0, $i95vK.fieldMarkers).AGENT_NAME} ${(0, $i95vK.fieldMarkers).TAB_LABEL} in ${(0, $i95vK.fieldMarkers).MLS_NAME} for ${(0, $i95vK.fieldMarkers).PERIOD}`
};
const $e70e792f19abcc91$export$8689ed52bebb9688 = ({ exportType: exportType, agentName: agentName, selectedTabLabel: selectedTabLabel, mlsName: mlsName, periods: periods })=>{
    return (0, $0d036ea0861162a7$export$7b8815dbb577b4ee)($e70e792f19abcc91$export$b02d86cbb3d565d5[exportType] || "", {
        [(0, $i95vK.fieldMarkers).AGENT_NAME]: agentName,
        [(0, $i95vK.fieldMarkers).TAB_LABEL]: selectedTabLabel,
        [(0, $i95vK.fieldMarkers).PERIOD]: periods,
        [(0, $i95vK.fieldMarkers).MLS_NAME]: mlsName
    });
};
const $e70e792f19abcc91$export$98b10a764a190f3d = (exportDetails)=>({
        [$e70e792f19abcc91$export$382f55aa456f5721.agentDetailSearchResults]: $e70e792f19abcc91$export$8689ed52bebb9688(exportDetails)
    });
const $e70e792f19abcc91$export$933029b93a5d9f63 = (node, cellText)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).isValidElement(node) && !cellText) return node;
    const text = node?.props?.children || cellText;
    if (typeof text !== "string" || text.length <= 10 && node) return node;
    if (node) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(node, {
        children: `${text.substring(0, 10)}...`
    });
    const TEXT_LENGTH_LIMIT = 27;
    if (text.length > TEXT_LENGTH_LIMIT) return `${text.substring(0, TEXT_LENGTH_LIMIT)}...`;
    return text;
};
const $e70e792f19abcc91$export$b0eda28bd2f81616 = {
    [(0, $eHBjM.dealStatusCodes).SOLD.value]: (0, $eHBjM.dealStatusCodes).SOLD,
    [(0, $eHBjM.dealStatusCodes).ACTIVE.value]: (0, $eHBjM.dealStatusCodes).ACTIVE,
    [(0, $eHBjM.dealStatusCodes).UNDER_CONTRACT.value]: (0, $eHBjM.dealStatusCodes).UNDER_CONTRACT
};
const $e70e792f19abcc91$export$370ac808da2cd312 = [
    {
        value: (0, $eHBjM.coverageChartTooltips).volumeBtn.id,
        label: (0, $eHBjM.coverageChartTooltips).volumeBtn.label
    },
    {
        value: (0, $eHBjM.coverageChartTooltips).unitsBtn.id,
        label: (0, $eHBjM.coverageChartTooltips).unitsBtn.label
    }
];


const $a4e7f1cc759aedc8$var$AgentContactInfo = (props)=>{
    const { agent: agent, index: index, statusType: statusType, isUnits: isUnits, intervalType: intervalType, areaType: areaType, displayMode: displayMode, module: module, shouldShowBackButton: shouldShowBackButton } = props;
    const setSelectedModule = (0, $90ISC.useSearchStore)((state)=>state.setSelectedModule);
    const { navIncomingPage: navIncomingPage } = (0, $90ISC.useCommonStore)((state)=>({
            navIncomingPage: state.agentDetailNavigation?.incomingPage
        }));
    const isAgMovBreakdownRoutes = [
        (0, $cstaF.searchRoutes).agentBreakdown,
        (0, $cstaF.searchRoutes).officeListBreakdown
    ].includes(navIncomingPage);
    const { agentId: agentId, officeAddress: officeAddress, officeCity: officeCity, officeState: officeState, officeZipCode: officeZipCode, agentEmail: agentEmail, agentPhone1: agentPhone1, agentPhone2: agentPhone2 } = agent ?? {};
    const history = (0, $kfZjc.useHistory)();
    const query = (0, $bq4QZ.useQuery)();
    const location = (0, $kfZjc.useLocation)();
    const fromOfficeBreakdownAndGrowthTab = location.state?.fromOfficeBreakdownAndGrowthTab;
    const anchorElements = {
        agentEmail: agentEmail ? /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
            href: `mailto:${agentEmail}`,
            children: agentEmail
        }) : (0, $cstaF.agentProductionTerms).notApplicableAbbrv,
        agentPhone1: agentPhone1 ? /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
            href: `tel:${agentPhone1.split(" ")[0]}`,
            children: agentPhone1
        }) : (0, $cstaF.agentProductionTerms).notApplicableAbbrv,
        agentPhone2: agentPhone2 ? /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
            href: `tel:${agentPhone2.split(" ")[0]}`,
            children: agentPhone2
        }) : (0, $cstaF.agentProductionTerms).notApplicableAbbrv
    };
    const handleBackClick = async ()=>{
        const graphModeParam = query.get("graph");
        const chartModeParam = query.get("chartMode");
        const period = query.get("period");
        const tabIndex = query.get("tabIndex");
        const queryIsShowBarLabels = query.get("isShowBarLabels");
        let location = (0, $c7dF9.Routes).PROF_METRICS.BASE;
        let pathname = window.location.pathname;
        const selectedArea = (0, $ekOct.unmaskUrlVar)(query.get("selectedArea"));
        if (query.get("incomingPage") === (0, $c7dF9.Routes).PROF_METRICS.COVERAGE_LISTING) history.push({
            pathname: (0, $eHBjM.coverageListingRoute),
            state: {
                selectedArea: selectedArea,
                agent: agent,
                displayMode: displayMode
            }
        });
        else if (period && pathname === (0, $eHBjM.agentListingInfoRoute)) {
            location = `${0, $eHBjM.agentProductionListingRoute}?id=${agentId}` + `&period=${period}` + `&tabIndex=${tabIndex || ""}` + `&graph=${graphModeParam}` + `&chartMode=${chartModeParam}` + `&isShowBarLabels=${queryIsShowBarLabels}` + `&intervalType=${intervalType}`;
            return history.push(location);
        } else if (pathname === (0, $eHBjM.agentProfileRoute)) {
            await setSelectedModule(module);
            return history.push(isAgMovBreakdownRoutes ? navIncomingPage : (0, $cstaF.moduleRoutes)[module], {
                fromOfficeBreakdownAndGrowthTab: fromOfficeBreakdownAndGrowthTab
            });
        } else if (index < (0, $eHBjM.agentProfileTabs).TRANSACTION_COVERAGE) {
            location = `${0, $eHBjM.agentProfileRoute}?id=${agentId}` + `&tabIndex=${index}&graph=${graphModeParam || ""}` + `&chartMode=${chartModeParam || ""}` + `&graphStatusType=${statusType || ""}` + `&isShowBarLabels=${queryIsShowBarLabels}` + `&timeInterval=${intervalType}`;
            history.push(location, {
                fromOfficeBreakdownAndGrowthTab: fromOfficeBreakdownAndGrowthTab
            });
        } else if (index === (0, $eHBjM.agentProfileTabs).TRANSACTION_COVERAGE) {
            location = `${0, $eHBjM.agentProfileRoute}?id=${agentId}&tabIndex=${index}&graphStatusType=${statusType}&isUnits=${isUnits}&timeInterval=${intervalType}&areaType=${areaType}&displayMode=${displayMode}`;
            history.push(location);
        } else history.push(location);
    };
    const getFormattedAddress = ()=>{
        const hasAnyValue = officeAddress || officeCity || officeState || officeZipCode;
        if (!hasAnyValue) return (0, $cstaF.agentProductionTerms).notApplicableAbbrv;
        const parts = [
            officeAddress,
            officeCity,
            officeState?.length > 1 ? officeState : null,
            officeZipCode
        ].filter(Boolean);
        return parts.join(", ");
    };
    const InfoField = ({ label: label, value: value, icon: icon, showIcon: showIcon = true, className: className = "" })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: `d-flex align-items-center contact-info-field ${className}`,
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "d-flex helix-body flex-column",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "gray-text",
                            children: label
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "bold-font-500",
                            children: className === "ellipsis" ? (0, $e70e792f19abcc91$export$933029b93a5d9f63)(value) : value
                        })
                    ]
                }),
                showIcon && icon && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "circle-icon ml-2",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                        icon: icon
                    })
                })
            ]
        });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "d-flex align-items-center agent-contact-info-wrapper p-3 w-100 justify-content-between",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "d-flex align-items-center w-100",
            children: [
                ((0, $dDBOF.isAgentMetrics) && shouldShowBackButton || !(0, $dDBOF.isAgentMetrics)) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                    dataLwtId: "back-button",
                    color: "secondary",
                    size: "lg",
                    className: "bg-dark p-1 d-flex align-self-stretch align-items-center",
                    onClick: handleBackClick,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aTLkh.default), {
                        className: "mr-1",
                        iconName: "navigate_before",
                        dataLwtId: "previous-icon"
                    })
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "d-flex w-100 justify-content-between flex-wrap",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ghmpR.default), {
                            selectedAgent: agent
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "d-flex",
                            children: !(0, $dDBOF.isAgentMetrics) && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "contact-info-grid",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)(InfoField, {
                                        label: "Agent ID",
                                        value: agentId ?? (0, $cstaF.agentProductionTerms).notApplicableAbbrv,
                                        showIcon: false
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)(InfoField, {
                                        className: "ellipsis",
                                        label: "Email",
                                        value: anchorElements.agentEmail,
                                        icon: (0, $eOjgM.email)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)(InfoField, {
                                        className: "not-ellipsis",
                                        label: "Email",
                                        value: anchorElements.agentEmail,
                                        icon: (0, $eOjgM.email)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)(InfoField, {
                                        label: "Phone 1",
                                        value: anchorElements.agentPhone1,
                                        icon: (0, $eOjgM.phone)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)(InfoField, {
                                        label: "Phone 2",
                                        value: anchorElements.agentPhone2,
                                        icon: (0, $eOjgM.phone)
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)(InfoField, {
                                        label: "Office",
                                        value: getFormattedAddress(),
                                        showIcon: false
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
$a4e7f1cc759aedc8$var$AgentContactInfo.propTypes = {
    agent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object.isRequired,
    index: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired,
    statusType: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    isUnits: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    intervalType: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    areaType: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    displayMode: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    module: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    shouldShowBackButton: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
var $a4e7f1cc759aedc8$export$2e2bcd8739ae039 = $a4e7f1cc759aedc8$var$AgentContactInfo;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7tOHe = parcelRequire("7tOHe");
parcelRequire("fHiKR");
var $1BYDb = parcelRequire("1BYDb");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $kfZjc = parcelRequire("kfZjc");

var $c9Z8w = parcelRequire("c9Z8w");

var $3r6bj = parcelRequire("3r6bj");

var $htzEo = parcelRequire("htzEo");

var $cstaF = parcelRequire("cstaF");

var $eHBjM = parcelRequire("eHBjM");

var $7jSpM = parcelRequire("7jSpM");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $cstaF = parcelRequire("cstaF");

var $90ISC = parcelRequire("90ISC");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $7f13c7b25e4f4e6c$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
typeof SuppressedError === "function" && SuppressedError;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $c4a900b25e0846c6$var$initialState = {
    activeKey: "",
    activeItemElement: undefined,
    activeKeys: [],
    size: "small"
};
const $c4a900b25e0846c6$export$c083c44d8a07dd35 = (0, $acw62.createContext)({
    state: $c4a900b25e0846c6$var$initialState,
    dispatch: (payload)=>payload
});
// reducer for tab context
const $c4a900b25e0846c6$var$reducer = (state, action)=>{
    switch(action.type){
        case "SET_ACTIVE_KEY":
            return Object.assign(Object.assign({}, state), {
                activeKey: action.payload
            });
        case "SET_ACTIVE_ITEM_ELEMENT":
            return Object.assign(Object.assign({}, state), {
                activeItemElement: action.payload
            });
        case "SET_SIZE":
            return Object.assign(Object.assign({}, state), {
                size: action.payload
            });
        case "SET_ON_ITEM_CHANGE":
            return Object.assign(Object.assign({}, state), {
                onItemChange: action.payload
            });
        default:
            return state;
    }
};
$c4a900b25e0846c6$export$c083c44d8a07dd35.Consumer;
const $c4a900b25e0846c6$export$d9faa5dc7fd8a68b = ({ children: children, value: value })=>{
    const [state, dispatch] = (0, $acw62.useReducer)($c4a900b25e0846c6$var$reducer, Object.assign(Object.assign({}, $c4a900b25e0846c6$var$initialState), value.state));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($c4a900b25e0846c6$export$c083c44d8a07dd35.Provider, {
        value: {
            state: state,
            dispatch: dispatch
        }
    }, children);
};


const $d0f280f2d67de5a2$export$2e2bcd8739ae039 = (_a)=>{
    var { defaultActiveKey: defaultActiveKey } = _a, rest = (0, $7f13c7b25e4f4e6c$export$3c9a16f847548506)(_a, [
        "defaultActiveKey"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $c4a900b25e0846c6$export$d9faa5dc7fd8a68b), {
        value: {
            state: {
                activeKey: defaultActiveKey
            }
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($d0f280f2d67de5a2$var$SegmentedControlInner, Object.assign({}, rest, {
        defaultActiveKey: defaultActiveKey
    })));
};
// eslint-disable-next-line no-empty-pattern
const $d0f280f2d67de5a2$var$SegmentedControlInner = ({ children: children, defaultActiveKey: defaultActiveKey, onItemChange: onItemChange, size: size })=>{
    const { dispatch: dispatch, state: state } = (0, $acw62.useContext)((0, $c4a900b25e0846c6$export$c083c44d8a07dd35));
    const [defaultActiveKeySet, setDefaultActiveKey] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const firstRender = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(true);
    (0, $acw62.useEffect)(()=>{
        if (!state.activeKey) return;
        setDefaultActiveKey(true);
    }, [
        state.activeKey
    ]);
    (0, $acw62.useEffect)(()=>{
        dispatch({
            type: "SET_SIZE",
            payload: size
        });
    }, [
        size,
        dispatch
    ]);
    (0, $acw62.useEffect)(()=>{
        onItemChange && dispatch({
            type: "SET_ON_ITEM_CHANGE",
            payload: onItemChange
        });
    }, [
        onItemChange,
        dispatch
    ]);
    (0, $acw62.useEffect)(()=>{
        dispatch({
            type: "SET_ACTIVE_KEY",
            payload: defaultActiveKey
        });
    }, [
        defaultActiveKey
    ]);
    (0, $acw62.useEffect)(()=>{
        firstRender.current = false;
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, children);
};
$d0f280f2d67de5a2$export$2e2bcd8739ae039.displayName = "SegmentedControl";



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");
const $be394eabd763935a$export$6e7006a3f70b1f76 = (0, $lmFrL.default).div`
    position: relative;
    background-color: ${({ theme: theme })=>{
    var _a, _b;
    return (_b = (_a = theme.colors) === null || _a === void 0 ? void 0 : _a.gray) === null || _b === void 0 ? void 0 : _b[100];
}};
    padding: 2px;
    color: ${({ theme: theme })=>{
    var _a, _b;
    return (_b = (_a = theme.colors) === null || _a === void 0 ? void 0 : _a.gray) === null || _b === void 0 ? void 0 : _b[600];
}};
    border-radius: 8px;
    gap: 4px;
    display: inline-flex;
    height: fit-content;
`;
const $be394eabd763935a$export$c7f8e0b55ba5907c = (0, $lmFrL.default).button`
    background-color: transparent;
    border-radius: 6px !important;
    margin: 0;
    font-size: 12px;
    line-height: 16px;
    height: ${({ $size: $size })=>$size === "tiny" ? "20px" : "24px"};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: ${({ $size: $size })=>$size === "tiny" ? "2px 8px" : "4px 8px"};
    z-index: 1;
    border: none;
    ${({ $active: $active, theme: theme })=>{
    var _a, _b, _c;
    return !$active && (0, $lmFrL.css)`
            &:hover:not(:disabled) {
                cursor: ${$active ? "default" : "pointer"};
                color: ${(_a = theme.colors) === null || _a === void 0 ? void 0 : _a.brand};
                svg {
                    fill: ${(_b = theme.colors) === null || _b === void 0 ? void 0 : _b.brand};
                    path {
                        fill: ${(_c = theme.colors) === null || _c === void 0 ? void 0 : _c.brand};
                    }
                }
            }
        `;
}}
    &:focus {
        outline: none;
    }
`;
const $be394eabd763935a$export$898b1568e41253c4 = (0, $lmFrL.default).div`
    display: none;
    flex: 1 1 100%;
    margin-top: 12px;
    ${({ $active: $active })=>$active && (0, $lmFrL.css)`
            display: block;
        `}
`;
const $be394eabd763935a$export$5862091fa9d7ae47 = (0, $lmFrL.default).div`
    position: absolute;
    top: 2px;
    left: ${({ $left: $left })=>$left}px;
    border-radius: 6px !important;
    margin: 0;
    height: ${({ $size: $size })=>$size === "tiny" ? "20px" : "24px"};
    width: ${({ $itemWidth: $itemWidth })=>$itemWidth}px;
    z-index: 0;
    color: ${({ theme: theme })=>{
    var _a, _b;
    return (_b = (_a = theme.colors) === null || _a === void 0 ? void 0 : _a.gray) === null || _b === void 0 ? void 0 : _b[900];
}};
    background-color: ${({ theme: theme })=>{
    var _a;
    return (_a = theme.colors) === null || _a === void 0 ? void 0 : _a.white;
}};
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.1), 0px 0px 1px 0px rgba(0, 0, 0, 0.2);
    // animate left
    transition: left 0.2s ease-in-out;
`;



const $74b6c675b9157773$export$2e2bcd8739ae039 = (0, $acw62.forwardRef)((_a, ref)=>{
    var { children: children, eventKey: eventKey, disabled: disabled, onClick: onClick } = _a, rest = (0, $7f13c7b25e4f4e6c$export$3c9a16f847548506)(_a, [
        "children",
        "eventKey",
        "disabled",
        "onClick"
    ]);
    const { state: state, dispatch: dispatch } = (0, $acw62.useContext)((0, $c4a900b25e0846c6$export$c083c44d8a07dd35));
    const itemRef = (0, $acw62.useRef)(null);
    // Add window width state
    const [windowWidth, setWindowWidth] = (0, $acw62.useState)(window.innerWidth);
    (0, $acw62.useImperativeHandle)(ref, ()=>itemRef.current);
    // Listen for window resize
    (0, $acw62.useEffect)(()=>{
        const handleResize = ()=>setWindowWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return ()=>window.removeEventListener("resize", handleResize);
    }, []);
    const handleClick = (e)=>{
        state.onItemChange && state.onItemChange(eventKey);
        dispatch({
            type: "SET_ACTIVE_KEY",
            payload: eventKey
        });
        if (onClick) onClick(e);
    };
    const checkIfActive = ()=>{
        return state.activeKey === eventKey;
    };
    (0, $acw62.useEffect)(()=>{
        if (state.activeKey === eventKey) dispatch({
            type: "SET_ACTIVE_ITEM_ELEMENT",
            payload: itemRef.current
        });
    }, [
        state.activeKey,
        eventKey,
        dispatch,
        windowWidth
    ]); // Add windowWidth here
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $be394eabd763935a$export$c7f8e0b55ba5907c), Object.assign({
        "$active": checkIfActive()
    }, rest, {
        onClick: handleClick,
        ref: itemRef,
        disabled: disabled,
        "$size": state.size
    }), children);
});
$74b6c675b9157773$export$2e2bcd8739ae039.displayName = "SegmentedControlItem";



var $acw62 = parcelRequire("acw62");


const $619708240f4690e2$export$1ace7127e536b2b8 = (_a)=>{
    var _b, _c;
    var { children: children } = _a, rest = (0, $7f13c7b25e4f4e6c$export$3c9a16f847548506)(_a, [
        "children"
    ]);
    const { state: state } = (0, $acw62.useContext)((0, $c4a900b25e0846c6$export$c083c44d8a07dd35));
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $be394eabd763935a$export$6e7006a3f70b1f76), Object.assign({
        role: "group",
        "$size": state.size
    }, rest), children, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $be394eabd763935a$export$5862091fa9d7ae47), {
        "$size": state.size,
        "$itemWidth": (_b = state.activeItemElement) === null || _b === void 0 ? void 0 : _b.offsetWidth,
        "$left": (_c = state.activeItemElement) === null || _c === void 0 ? void 0 : _c.offsetLeft
    }));
};
$619708240f4690e2$export$1ace7127e536b2b8.displayName = "SegmentControlItemBar";


const $0640a9c1d6a50c50$var$HelixSegmentedControl = ({ setOption: setOption, optionsList: optionsList, defaultOption: defaultOption, size: size = "medium" })=>{
    const options = optionsList.map((option, i)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $74b6c675b9157773$export$2e2bcd8739ae039), {
            eventKey: option.value,
            onClick: ()=>setOption(option.value),
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "toggle-item",
                children: option.label
            })
        }, i));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d0f280f2d67de5a2$export$2e2bcd8739ae039), {
        defaultActiveKey: defaultOption,
        size: size,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $619708240f4690e2$export$1ace7127e536b2b8), {
            children: options
        })
    });
};
$0640a9c1d6a50c50$var$HelixSegmentedControl.propTypes = {
    setOption: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    optionList: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    defaultOption: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};
var $0640a9c1d6a50c50$export$2e2bcd8739ae039 = $0640a9c1d6a50c50$var$HelixSegmentedControl;


const $147dc1a4bec01de2$export$36b7723857d3a645 = Object.freeze({
    TABLE: "table",
    CHART: "chart"
});
const $147dc1a4bec01de2$var$TableChartToggle = ({ defaultMode: defaultMode, parentSetMode: parentSetMode, mlsName: mlsName })=>{
    const { setDisplayMode: setDisplayMode, displayMode: displayMode } = (0, $90ISC.useAgentProfileStore)();
    const [mode, setMode] = (0, $acw62.useState)(displayMode || defaultMode || $147dc1a4bec01de2$export$36b7723857d3a645.CHART);
    (0, $acw62.useEffect)(()=>{
        parentSetMode(mode);
        setDisplayMode(mode);
    }, [
        mode
    ]);
    const handleModeClick = (modeToSet)=>{
        setMode(modeToSet);
        parentSetMode(modeToSet);
    };
    const options = [
        {
            value: $147dc1a4bec01de2$export$36b7723857d3a645.CHART,
            label: (0, $cstaF.agentProductionTerms).chart
        },
        {
            value: $147dc1a4bec01de2$export$36b7723857d3a645.TABLE,
            label: (0, $cstaF.agentProductionTerms).table
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "d-flex align-items-center",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "helix-body--strong mr-3",
                children: mlsName
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0640a9c1d6a50c50$export$2e2bcd8739ae039), {
                setOption: handleModeClick,
                optionsList: options,
                defaultOption: mode
            })
        ]
    });
};
var $147dc1a4bec01de2$export$2e2bcd8739ae039 = $147dc1a4bec01de2$var$TableChartToggle;



var $90ISC = parcelRequire("90ISC");

var $jUjGS = parcelRequire("jUjGS");
const $f3601c277edc0231$var$AgentTransactionCoverageChart = (props)=>{
    const { agentData: agentData, isUnits: isUnits, statusType: statusType, areaType: areaType, shouldDisplayAreaPercentage: shouldDisplayAreaPercentage, agent: agent, tableType: tableType, timePeriod: timePeriod, isPDF: isPDF } = props;
    const { setAreaList: setAreaList, setSelectedMlsId: setSelectedMlsId, setSelectedArea: setSelectedArea, setAreaType: setAreaType, setTableType: setTableType, setIsUnits: setIsUnits, setAgentCoverageListingTab: setAgentCoverageListingTab, setTimePeriod: setTimePeriod } = (0, $90ISC.useAgentProfileStore)((state)=>({
            setAreaList: state.setAreaList,
            setSelectedAgentId: state.setSelectedAgentId,
            setSelectedMlsId: state.setSelectedMlsId,
            setSelectedArea: state.setSelectedArea,
            setAreaType: state.setAreaType,
            setTableType: state.setTableType,
            setIsUnits: state.setIsUnits,
            setAgentCoverageListingTab: state.setAgentCoverageListingTab,
            setTimePeriod: state.setTimePeriod
        }));
    const history = (0, $kfZjc.useHistory)();
    const CONTAINER_WIDTH_MAX = "100%";
    const MINIMUM_COLUMN_WIDTH_IN_PIXELS = 85;
    const ONE_MILLION = 1000000;
    const PDF_WIDTH = 1879;
    const [widthGraph, setWidthGraph] = (0, $acw62.useState)(CONTAINER_WIDTH_MAX);
    const refGraphContainer = (0, $acw62.useRef)(null);
    const countColumns = agentData ? agentData.length : null;
    const widthGraphContent = countColumns * MINIMUM_COLUMN_WIDTH_IN_PIXELS;
    const widthContainer = refGraphContainer.current?.clientWidth ?? 0;
    (0, $acw62.useEffect)(()=>{
        if (widthGraphContent > widthContainer) setWidthGraph(`${widthGraphContent}px`);
        else setWidthGraph(CONTAINER_WIDTH_MAX);
    }, [
        widthGraphContent,
        widthContainer
    ]);
    const xAxisLabels = agentData?.map((d)=>d.area);
    const dataPointGroups = [];
    if (statusType === (0, $eHBjM.dealStatusCodes).SOLD.value) {
        const listSideSoldVolume = agentData?.map((d)=>d.listVolume);
        const sellSideSoldVolume = agentData?.map((d)=>d.sellVolume);
        const listSideSoldUnits = agentData?.map((d)=>d.listUnits);
        const sellSideSoldUnits = agentData?.map((d)=>d.sellUnits);
        dataPointGroups.push({
            name: "List Side (Sold)",
            data: isUnits ? listSideSoldUnits : listSideSoldVolume
        });
        dataPointGroups.push({
            name: "Sell Side (Sold)",
            data: isUnits ? sellSideSoldUnits : sellSideSoldVolume
        });
    } else {
        const chartName = isUnits ? "Total #" : "Total $";
        const dataPoints = isUnits ? agentData?.map((d)=>d.totalUnits) : agentData?.map((d)=>d.totalVolume);
        dataPointGroups.push({
            name: chartName,
            data: dataPoints
        });
    }
    const getTooltipContent = (series, dataPointIndex)=>{
        const data = agentData[dataPointIndex];
        const percentage = isUnits ? (0, $htzEo.percentChangeFormatter)(data.totalUnitsPct) : (0, $htzEo.percentChangeFormatter)(data.totalVolumePct);
        const percentageElement = statusType === (0, $eHBjM.dealStatusCodes).SOLD.value ? `<div class='total-percent'>
                <span>${percentage}</span>
            </div>` : `<span>${percentage}</span>`;
        const soldTooltipInfo = statusType === (0, $eHBjM.dealStatusCodes).SOLD.value ? `<div class='items'>
                <span class='bullet' style='background-color: ${0, $jUjGS.COLOR_SECONDARY_GREEN}'></span>
                ${isUnits ? (0, $htzEo.getNumberWithComas)(data.sellUnits) : (0, $htzEo.getCurrencyFormat)(data.sellVolume)} <br />
                <span class='bullet' style='background-color: ${0, $jUjGS.COLOR_PRIMARY_GREEN}'></span>
                ${isUnits ? (0, $htzEo.getNumberWithComas)(data.listUnits) : (0, $htzEo.getCurrencyFormat)(data.listVolume)}
            </div>` : "";
        return `<div class='arrow_box volume-chart-tooltip'>
            <div class='header'>
                ${data.area}
            </div>
            <div class='body'>
                ${percentageElement}
                ${soldTooltipInfo}
                <div class='total'>
                    <span>Total:</span>
                    <span>${isUnits ? (0, $htzEo.getNumberWithComas)(data.totalUnits) : (0, $htzEo.getCurrencyFormat)(data.totalVolume)}</span>
                </div>
            </div>
        </div>`;
    };
    const yAxisLabel = isUnits ? "# Units" : "$ in Millions";
    const colors = [];
    statusType === (0, $eHBjM.dealStatusCodes).SOLD.value && colors.push((0, $jUjGS.COLOR_SECONDARY_GREEN), (0, $jUjGS.COLOR_PRIMARY_GREEN));
    statusType === (0, $eHBjM.dealStatusCodes).UNDER_CONTRACT.value && colors.push((0, $jUjGS.COLOR_PRIMARY_GREEN));
    statusType === (0, $eHBjM.dealStatusCodes).ACTIVE.value && colors.push((0, $jUjGS.COLOR_PRIMARY_GREEN));
    const radius = 1;
    const fontFamily = '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"';
    const getChartOptions = (isPDF)=>({
            chart: {
                type: "bar",
                stacked: true,
                toolbar: {
                    show: false
                },
                fontFamily: fontFamily,
                noData: {
                    text: (0, $cstaF.agentProductionTerms).noDataForSelectedAgent
                },
                zoom: {
                    enabled: false
                },
                events: {
                    mounted: (chart)=>{
                        chart.windowResizeHandler();
                    },
                    dataPointSelection: (event, chartContext, config)=>{
                        setAgentCoverageListingTab((0, $eHBjM.agentCoverageListingTabs).TOTAL_SOLD);
                        setSelectedMlsId(agent.mlsSid);
                        setAreaList(xAxisLabels);
                        setSelectedArea(xAxisLabels[config.dataPointIndex]);
                        setAreaType(areaType);
                        setTableType(tableType);
                        setTimePeriod(timePeriod);
                        setIsUnits(isUnits);
                        history.push({
                            pathname: (0, $eHBjM.coverageListingRoute),
                            state: {
                                agent: agent,
                                selectedArea: xAxisLabels[config.dataPointIndex],
                                displayMode: (0, $147dc1a4bec01de2$export$36b7723857d3a645).CHART
                            }
                        });
                    },
                    dataPointMouseEnter: (0, $7jSpM.dataPointMouseOverStyler)
                }
            },
            responsive: [
                {
                    breakpoint: 480,
                    options: {
                        legend: {
                            position: "left",
                            offsetX: -10,
                            offsetY: 0
                        }
                    }
                }
            ],
            plotOptions: {
                bar: {
                    horizontal: false,
                    borderRadius: radius,
                    columnWidth: "40px",
                    dataLabels: {
                        position: "top",
                        hideOverflowingLabels: false
                    }
                }
            },
            dataLabels: {
                enabled: shouldDisplayAreaPercentage,
                enabledOnSeries: statusType === (0, $eHBjM.dealStatusCodes).SOLD.value ? [
                    1,
                    2
                ] : [
                    0
                ],
                textAnchor: "middle",
                formatter: function(value, { seriesIndex: seriesIndex, dataPointIndex: dataPointIndex, w: w }) {
                    const totalPercentage = isUnits ? (0, $htzEo.percentChangeFormatter)(agentData[dataPointIndex].totalUnitsPct) : (0, $htzEo.percentChangeFormatter)(agentData[dataPointIndex].totalVolumePct);
                    return totalPercentage ?? 0;
                },
                style: {
                    fontSize: "14px",
                    fontFamily: "Helvetica, Arial, sans-serif",
                    fontWeight: "bold",
                    colors: [
                        "#212529"
                    ]
                },
                offsetY: -30
            },
            xaxis: {
                type: "category",
                categories: xAxisLabels,
                labels: {
                    formatter: function(value) {
                        if (areaType === (0, $eHBjM.mlsAreaTypes).MLS_AREAS) return value.split(" ", 1)[0];
                        return value;
                    },
                    trim: true,
                    hideOverlappingLabels: false
                }
            },
            yaxis: {
                labels: {
                    formatter: function(value) {
                        if (isUnits) return (0, $htzEo.formatUnitOrPercentage)(value);
                        else return (0, $htzEo.formatUnitOrPercentage)(parseInt(value) / ONE_MILLION, false, true);
                    }
                },
                tickAmount: 16,
                title: {
                    text: yAxisLabel,
                    style: {
                        cssClass: "agent-coverage-chart-y-label"
                    }
                }
            },
            tooltip: {
                custom: ({ series: series, _: _, dataPointIndex: dataPointIndex })=>getTooltipContent(series, dataPointIndex)
            },
            legend: {
                inverseOrder: false,
                markers: {
                    fillColors: colors,
                    width: 15,
                    height: 15,
                    radius: 10
                },
                fontFamily: fontFamily,
                itemMargin: {
                    horizontal: 10
                },
                position: "top",
                offsetX: 0,
                horizontalAlign: "left",
                fontSize: isPDF ? "16px" : undefined
            },
            fill: {
                opacity: 1,
                colors: colors.reverse()
            }
        });
    const chartProps = {
        options: getChartOptions(isPDF),
        series: dataPointGroups,
        type: "bar",
        height: 400,
        width: isPDF ? PDF_WIDTH : widthGraph
    };
    const overflow = widthGraph === CONTAINER_WIDTH_MAX ? null : "tableOverflow";
    const pdfClasses = isPDF ? "pdf-chart chart-capture-area" : "";
    let outputToShow;
    if (!agentData || agentData.length === 0) outputToShow = /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "mt-3",
        children: "Your search returned no results"
    });
    else if (widthContainer === 0) outputToShow = null;
    else outputToShow = /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3r6bj))), {
        ...chartProps
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        ref: refGraphContainer,
        className: `${overflow} ${pdfClasses} agent-contact-chart-wrapper py-4 px-3`,
        style: isPDF ? {} : {
            maxWidth: "none"
        },
        id: "agent-coverage-chart-container",
        children: outputToShow
    });
};
$f3601c277edc0231$var$AgentTransactionCoverageChart.propTypes = {
    agentData: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    isUnits: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    statusType: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    areaType: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    shouldDisplayAreaPercentage: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    agent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    tableType: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    }),
    timePeriod: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    isPDF: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
var $f3601c277edc0231$export$2e2bcd8739ae039 = $f3601c277edc0231$var$AgentTransactionCoverageChart;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $eHBjM = parcelRequire("eHBjM");

var $kfZjc = parcelRequire("kfZjc");


var $90ISC = parcelRequire("90ISC");
var $a059c45585342af5$export$2e2bcd8739ae039 = (props)=>{
    const { areaType: areaType, agent: agent, tableType: tableType, timePeriod: timePeriod, isUnits: isUnits } = props;
    const { setSelectedMlsId: setSelectedMlsId, setAreaType: setAreaType, setTableType: setTableType, setIsUnits: setIsUnits, setAgentCoverageListingTab: setAgentCoverageListingTab, setTimePeriod: setTimePeriod } = (0, $90ISC.useAgentProfileStore)((state)=>({
            setSelectedAgentId: state.setSelectedAgentId,
            setSelectedMlsId: state.setSelectedMlsId,
            setAreaType: state.setAreaType,
            setTableType: state.setTableType,
            setIsUnits: state.setIsUnits,
            setAgentCoverageListingTab: state.setAgentCoverageListingTab,
            setTimePeriod: state.setTimePeriod
        }));
    const history = (0, $kfZjc.useHistory)();
    const goToCoverageListingsPage = (value)=>{
        setAgentCoverageListingTab((0, $eHBjM.agentCoverageListingTabs).TOTAL_SOLD);
        setSelectedMlsId(agent.mlsSid);
        setAreaType(areaType);
        setTableType(tableType);
        setTimePeriod(timePeriod);
        setIsUnits(isUnits);
        history.push({
            pathname: (0, $eHBjM.coverageListingRoute),
            state: {
                agent: agent,
                selectedArea: value,
                displayMode: (0, $147dc1a4bec01de2$export$36b7723857d3a645).TABLE
            }
        });
    };
    return {
        goToCoverageListingsPage: goToCoverageListingsPage
    };
};



var $90ISC = parcelRequire("90ISC");

var $l05Px = parcelRequire("l05Px");

var $4tbBr = parcelRequire("4tbBr");

var $eHBjM = parcelRequire("eHBjM");
const $cb2d6d84dd4380da$var$TransactionCoverageTable = (props)=>{
    const { areaLabel: areaLabel, data: data, isUnits: isUnits, statusType: statusType, areaType: areaType, agent: agent, tableType: tableType, gridRef: gridRef, timePeriod: timePeriod } = props;
    const { setAreaList: setAreaList } = (0, $90ISC.useAgentProfileStore)((state)=>({
            setAreaList: state.setAreaList
        }));
    const [state, setState] = (0, $acw62.useState)({
        tableView: (0, $4tbBr.tableViews).transactionCoverageSold,
        additionalTableHeaders: (0, $eHBjM.superHeaders).transactionCoverageSold,
        coverageTableTooltips: (0, $eHBjM.coverTableSoldTooltips)
    });
    const { goToCoverageListingsPage: goToCoverageListingsPage } = (0, $a059c45585342af5$export$2e2bcd8739ae039)({
        statusType: statusType,
        areaLabel: areaLabel,
        areaType: areaType,
        agent: agent,
        tableType: tableType,
        timePeriod: timePeriod,
        isUnits: isUnits
    });
    let areaList = data.map((d)=>d.area);
    (0, $acw62.useEffect)(()=>{
        setAreaList(areaList);
    }, []);
    (0, $acw62.useEffect)(()=>{
        const tableByType = {
            [(0, $eHBjM.transactionCoverageTableTypes).soldView]: {
                tableview: {
                    ...(0, $4tbBr.tableViews).transactionCoverageSold,
                    defaultSort: {
                        colId: isUnits ? (0, $eHBjM.transactionCoverageSoldColumns).totalUnits.id : (0, $eHBjM.transactionCoverageSoldColumns).totalVolume.id,
                        sortDir: "desc"
                    }
                },
                tableViewNames: (0, $eHBjM.tableViewNames).transactionCoverageSold,
                tooltip: (0, $eHBjM.coverTableSoldTooltips)
            },
            [(0, $eHBjM.transactionCoverageTableTypes).underContract]: {
                tableview: {
                    ...(0, $4tbBr.tableViews).transactionCoverageUc,
                    defaultSort: {
                        colId: isUnits ? (0, $eHBjM.transactionCoverageUcColumns).listUnits.id : (0, $eHBjM.transactionCoverageUcColumns).listVolume.id,
                        sortDir: "desc"
                    }
                },
                tableViewNames: (0, $eHBjM.tableViewNames).transactionCoverageUc,
                tooltip: (0, $eHBjM.coverTableUcTooltips)
            },
            [(0, $eHBjM.transactionCoverageTableTypes).forSale]: {
                tableview: {
                    ...(0, $4tbBr.tableViews).transactionCoverageForSale,
                    defaultSort: {
                        colId: isUnits ? (0, $eHBjM.transactionCoverageForSaleColumns).listUnits.id : (0, $eHBjM.transactionCoverageForSaleColumns).listVolume.id,
                        sortDir: "desc"
                    }
                },
                tableViewNames: (0, $eHBjM.tableViewNames).transactionCoverageForSale,
                tooltip: (0, $eHBjM.coverTableForSaleTooltips)
            }
        };
        const currentTableType = tableByType[tableType?.value];
        if (!currentTableType) return;
        setState((prevState)=>({
                ...prevState,
                tableView: currentTableType.tableview,
                additionalTableHeaders: (0, $eHBjM.superHeaders)[currentTableType.tableViewNames],
                coverageTableTooltips: {
                    ...currentTableType.tooltip,
                    area: {
                        ...currentTableType.tooltip?.area,
                        label: areaLabel
                    }
                }
            }));
    }, [
        tableType,
        areaType
    ]);
    let mappedData = [];
    if (data.length > 0) mappedData = data.map((d)=>{
        return {
            ...d,
            id: d.area
        };
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l05Px.default), {
        gridRef: gridRef,
        tableView: state.tableView,
        rowData: mappedData,
        additionalTableHeaders: state.additionalTableHeaders,
        tableTitleWithTooltips: state.coverageTableTooltips,
        externalParams: {
            agent: agent,
            goToCoverageListingsPage: goToCoverageListingsPage
        }
    });
};
var $cb2d6d84dd4380da$export$2e2bcd8739ae039 = $cb2d6d84dd4380da$var$TransactionCoverageTable;




var $eHBjM = parcelRequire("eHBjM");

var $cstaF = parcelRequire("cstaF");

var $bq4QZ = parcelRequire("bq4QZ");

var $g3CkB = parcelRequire("g3CkB");

var $24YIE = parcelRequire("24YIE");

var $c9Z8w = parcelRequire("c9Z8w");

var $bA5Mi = parcelRequire("bA5Mi");

var $ivaD7 = parcelRequire("ivaD7");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");



var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $lmFrL = parcelRequire("lmFrL");


var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");

var $3tUi5 = parcelRequire("3tUi5");

var $ai2Pb = parcelRequire("ai2Pb");

var $acw62 = parcelRequire("acw62");
var $10a7ca630b086527$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $10a7ca630b086527$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === "function") {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $10a7ca630b086527$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === "function") return $10a7ca630b086527$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $10a7ca630b086527$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $10a7ca630b086527$export$700979bc83e7db82 = typeof window !== "undefined" && window.document && window.document.createElement ? $acw62.useLayoutEffect : $acw62.useEffect;


var $8a5bbfa6d36bb031$var$EMPTY_MODIFIERS = [];
var $8a5bbfa6d36bb031$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $acw62.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || "bottom",
        strategy: options.strategy || "absolute",
        modifiers: options.modifiers || $8a5bbfa6d36bb031$var$EMPTY_MODIFIERS
    };
    var _React$useState = $acw62.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: "0",
                top: "0"
            },
            arrow: {
                position: "absolute"
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $acw62.useMemo(function() {
        return {
            name: "updateState",
            enabled: true,
            phase: "write",
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $1u0KT.flushSync(function() {
                    setState({
                        styles: (0, $10a7ca630b086527$export$5150077fc2e7c662)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $10a7ca630b086527$export$5150077fc2e7c662)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                "computeStyles"
            ]
        };
    }, []);
    var popperOptions = $acw62.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: "applyStyles",
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ai2Pb)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $acw62.useRef();
    (0, $10a7ca630b086527$export$700979bc83e7db82)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $10a7ca630b086527$export$700979bc83e7db82)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $3tUi5.createPopper);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $31f3d213e7f0e1c2$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $31f3d213e7f0e1c2$var$__awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
typeof SuppressedError === "function" && SuppressedError;
function $31f3d213e7f0e1c2$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $31f3d213e7f0e1c2$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $31f3d213e7f0e1c2$var$clsx() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $31f3d213e7f0e1c2$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
const $31f3d213e7f0e1c2$var$StyledDropdownMenu = (0, $lmFrL.default).div`
    position: relative;
    background-color: ${({ theme: theme })=>{
    var _a;
    return theme.dropdownMenu ? (_a = theme.dropdownMenu) === null || _a === void 0 ? void 0 : _a.backgroundColor : "#fff";
}};
    border-radius: 4px;
    overflow: hidden;
    z-index: 10;
    display: ${({ $isOpen: $isOpen })=>$isOpen ? "block" : "none"};

    // at a small display set the width to 100%
    @media (max-width: 600px) {
        width: calc(100vw - 3px) !important;
        max-width: calc(100vw - 32px);
    }
    ${({ $width: $width })=>$width && (0, $lmFrL.css)`
            width: ${$width}!important;
        `}
    ${({ $maxWidth: $maxWidth })=>$maxWidth && (0, $lmFrL.css)`
            max-width: ${$maxWidth};
        `}
    ${({ $height: $height })=>$height && (0, $lmFrL.css)`
            height: ${$height};
            overflow: auto;
        `}
    ${({ $maxHeight: $maxHeight })=>$maxHeight && (0, $lmFrL.css)`
            max-height: ${$maxHeight};
            overflow: auto;
        `}


    ${({ $isOpen: $isOpen, theme: theme, $condensedMenu: $condensedMenu })=>{
    var _a;
    return $isOpen && (0, $lmFrL.css)`
            box-shadow: ${({ theme: theme })=>{
        var _a;
        return theme.dropdownMenu ? (_a = theme.dropdownMenu) === null || _a === void 0 ? void 0 : _a.boxShadow : "0px 0px 1px rgba(0, 0, 0, 0.2), 0px 4px 8px rgba(0, 0, 0, 0.1)";
    }};
            padding: 8px;
            position: relative;
            z-index: 10;
            li:not(.divider) {
                box-sizing: border-box;
                border-radius: 6px;
                color: inherit;
                display: block;
                text-decoration: none;
                margin-bottom: 2px;
                font-size: ${$condensedMenu ? "12px" : "14px"};
                &:not(.disabled):not(.section-header):not(.divider):hover {
                    cursor: pointer;
                }
                .menu-item-content-wrapper {
                    padding: ${$condensedMenu ? "4px 8px" : "8px"};
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    // increase the padding on mobile to make the touch target bigger
                    @media (max-width: 600px) {
                        padding: 12px 16px;
                    }
                    .helix-dropdown-menu-item__label {
                        text-align: left;
                    }
                    .helix-dropdown-menu-item__active-icon {
                        display: flex;
                        align-items: center;
                        svg,
                        svg path {
                            fill: #2563eb;
                        }
                    }
                    .helix-icon.checkmark-outlined {
                        fill: #2563eb;
                        path {
                            fill: #2563eb;
                        }
                    }
                }
                a {
                    box-sizing: border-box;
                    border-radius: 6px;
                    color: inherit;
                    width: 100%;
                    display: block;
                    text-decoration: none;
                }
                &.highlighted {
                    background-color: ${theme.dropdownMenuItem ? (_a = theme.dropdownMenuItem) === null || _a === void 0 ? void 0 : _a.highlightColor : "#e5e7eb"};
                }
            }
        `;
}}
    &:focus-within {
        outline: none;
    }
    ul {
        padding: 0;
        margin: 0;
        list-style: none;
        &:focus-visible {
            outline: none;
        }
        li {
            &:not(.divider):not(.section-header):not(.disabled) {
                cursor: pointer !important;
            }
            &.disabled {
                .label,
                .description,
                svg,
                .helix-dropdown-menu-item__label {
                    opacity: 0.3;
                }
            }
            &.selected-item {
                outline-width: 0;
                background-color: ${({ theme: theme })=>{
    var _a;
    return theme.dropdownMenuItem ? (_a = theme.dropdownMenuItem) === null || _a === void 0 ? void 0 : _a.selectedColor : "#E5E7EB";
}};
            }
        }
        .divider {
            margin: ${({ $condensedMenu: $condensedMenu })=>$condensedMenu ? "6px 0" : "4px 0"};
        }
        .section-header {
            text-transform: uppercase;
            font-size: 12px;
            color: ${({ theme: theme })=>{
    var _a;
    return theme.dropdownMenu ? (_a = theme.dropdownMenu) === null || _a === void 0 ? void 0 : _a.sectionHeaderColor : "#4B5563";
}};
            letter-spacing: 0.1em;
            padding-top: 0;
        }
        .description {
            color: ${({ theme: theme })=>{
    var _a;
    return theme.dropdownMenuItem ? (_a = theme.dropdownMenuItem) === null || _a === void 0 ? void 0 : _a.descriptionFontColor : "4B5563";
}};
            font-size: 12px;
        }
        + ul {
            margin-left: 16px;
            @media screen and (max-width: ${({ theme: theme })=>{
    var _a;
    return theme.breakPoints ? (_a = theme.breakPoints) === null || _a === void 0 ? void 0 : _a.small : "576px";
}}) {
                margin-left: 0;
                margin-top: 16px;
            }
        }
    }
    .empty-state {
        padding: 16px;
        text-align: center;
    }
    &.helix-dropdown-badge-menu .menu-item-content-wrapper {
        display: grid !important;
        gap: 8px;
        grid-template-columns: 1fr 20px;
    }
`;
const $31f3d213e7f0e1c2$var$StyledDropdownMenuItem = (0, $lmFrL.default).li`
    color: ${({ theme: theme })=>{
    var _a, _b;
    return (_b = (_a = theme.colors) === null || _a === void 0 ? void 0 : _a.gray) === null || _b === void 0 ? void 0 : _b[900];
}};
    list-style: none;
    ${({ $noWrap: $noWrap })=>$noWrap && (0, $lmFrL.css)`
            white-space: nowrap;
        `}
    label {
        pointer-events: none;
    }
    .menu-item-content-wrapper {
        > div {
            width: 100%;
            align-items: center;
            display: flex;
        }
    }
    ${({ $sectionHeader: $sectionHeader })=>$sectionHeader && (0, $lmFrL.css)`
            text-transform: uppercase;
            font-size: 12px !important;
            letter-spacing: 0.04em;
            padding-top: 0;
            font-weight: 600;
            &:hover {
                cursor: default !important;
            }
        `}

    ${({ $hasIcon: $hasIcon })=>{
    if ($hasIcon) return (0, $lmFrL.css)`
                .menu-item-content-wrapper {
                    justify-content: flex-start;
                    gap: 8px;
                    > div {
                        justify-content: flex-start;
                        gap: 8px;
                    }
                }
            `;
}}
    
    ${({ $divider: $divider })=>$divider && (0, $lmFrL.css)`
            padding: 0;
            margin: 0;
            overflow: hidden;
            border-top: 1px solid ${({ theme: theme })=>{
        var _a, _b;
        return (_b = (_a = theme.colors) === null || _a === void 0 ? void 0 : _a.gray) === null || _b === void 0 ? void 0 : _b[200];
    }};
            .menu-item-content-wrapper {
                display: none !important;
            }
        `}

    
    &.helix-btn {
        padding: 0;
        margin-top: 8px;
    }
`;
const $31f3d213e7f0e1c2$var$DropdownMenu = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef((_a, ref)=>{
    var { children: children, isOpen: isOpen, maxWidth: maxWidth, width: width, condensedMenu: condensedMenu, height: height } = _a, rest = $31f3d213e7f0e1c2$var$__rest(_a, [
        "children",
        "isOpen",
        "maxWidth",
        "width",
        "condensedMenu",
        "height"
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($31f3d213e7f0e1c2$var$StyledDropdownMenu, Object.assign({
        ref: ref,
        "$isOpen": isOpen,
        "$maxWidth": maxWidth,
        "$width": width,
        "$height": height,
        "$maxHeight": height,
        "$condensedMenu": condensedMenu
    }, rest), children);
});
$31f3d213e7f0e1c2$var$DropdownMenu.displayName = "DropdownMenu";
const $31f3d213e7f0e1c2$var$DropdownMenuItem = (_a)=>{
    var { menuItem: menuItem, highlightedIndex: highlightedIndex, index: index, getItemProps: getItemProps, children: children, hasIcon: hasIcon = true, checked: checked = false, className: className, noWrap: noWrap } = _a, rest = $31f3d213e7f0e1c2$var$__rest(_a, [
        "menuItem",
        "highlightedIndex",
        "index",
        "getItemProps",
        "children",
        "hasIcon",
        "checked",
        "className",
        "noWrap"
    ]);
    if (!menuItem) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($31f3d213e7f0e1c2$var$StyledDropdownMenuItem, Object.assign({
        "$sectionHeader": menuItem.sectionHeader,
        "$divider": menuItem.divider,
        "$hasIcon": hasIcon,
        "$noWrap": noWrap,
        className: `${index === highlightedIndex ? `highlighted ${className}` : className}
    ${menuItem.disabled ? " disabled" : ""}
${menuItem.divider ? " divider" : ""}
    `,
        "data-item-index": index
    }, rest, getItemProps({
        item: menuItem,
        disabled: menuItem.disabled || menuItem.divider || menuItem.sectionHeader,
        index: index,
        onClick: (event)=>{
            menuItem.onClick && menuItem.onClick(menuItem, event);
        }
    })), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "menu-item-content-wrapper"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", null, children), checked && (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
        icon: (0, $c761e69c8e58189a$exports.checkmark)
    })));
};
$31f3d213e7f0e1c2$var$DropdownMenuItem.__DROPDOWN_MENU_ITEM__ = true; // 👈 special marker
const $31f3d213e7f0e1c2$var$useDropdownMenu = ({ items: items, placement: placement = "bottom-start", itemToString: itemToString = (item)=>item, offset: offset = [
    0,
    10
], resetSelectedItemOnClose: resetSelectedItemOnClose = false, popperModifiers: popperModifiers, strategy: strategy = "absolute", interactive: interactive = false, onMenuClickOutside: onMenuClickOutside, onChange: onChange, id: id })=>{
    const [referenceElement, setReferenceElement] = (0, $acw62.useState)(null);
    const [popperElement, setPopperElement] = (0, $acw62.useState)(null);
    const selectedItemRef = (0, $acw62.useRef)(-1);
    const [selectedItemIndex, setSelectedItemIndex] = (0, $acw62.useState)(-1);
    const [keydownFired, setKeydownFired] = (0, $acw62.useState)(false);
    const [forceClose, setForceClose] = (0, $acw62.useState)(false);
    const itemClicked = (0, $acw62.useRef)(false);
    const getPopperModifiers = ()=>{
        return popperModifiers && popperModifiers.length > 0 ? popperModifiers : [];
    };
    const modifiers = (0, $acw62.useMemo)(()=>[
            {
                name: "sameWidth",
                enabled: true,
                fn: ({ state: state })=>{
                    state.styles.popper.width = `${state.rects.reference.width}px`;
                },
                phase: "beforeWrite",
                requires: [
                    "computeStyles"
                ]
            },
            {
                name: "offset",
                options: {
                    offset: offset
                }
            },
            ...getPopperModifiers()
        ], []);
    const { styles: styles, attributes: attributes, update: update } = (0, $8a5bbfa6d36bb031$export$f4d5bf230a36dd6e)(referenceElement, popperElement, {
        placement: placement,
        strategy: strategy,
        modifiers: modifiers
    });
    const stateReducer = (state, actionAndChanges)=>{
        const { type: type, changes: changes } = actionAndChanges;
        switch(type){
            case (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.MenuKeyDownArrowDown:
                if (state.highlightedIndex === items.length - 1 && items[0]) {
                    // check if first item is a section header
                    const highlightedIndex = items[0].sectionHeader ? 1 : items[0].disabled ? 1 : 0;
                    return Object.assign(Object.assign({}, changes), {
                        isOpen: true,
                        highlightedIndex: highlightedIndex
                    });
                }
                return Object.assign(Object.assign({}, changes), {
                    isOpen: true
                });
            case (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.MenuKeyDownArrowUp:
                if (state.highlightedIndex === 0) return Object.assign(Object.assign({}, changes), {
                    isOpen: true,
                    highlightedIndex: items.length - 1
                });
                return Object.assign(Object.assign({}, changes), {
                    isOpen: true
                });
            case (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.MenuKeyDownEnter:
            case (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.MenuKeyDownSpaceButton:
                {
                    const activeElement = document.activeElement;
                    if (activeElement && (activeElement.tagName === "INPUT" || activeElement.tagName === "TEXTAREA")) {
                        // programatically enter the space in the input
                        if (type === (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.MenuKeyDownSpaceButton) {
                            // insert a space at the correct location
                            const activeElementAsInput = activeElement;
                            const value = activeElementAsInput.value;
                            const selectionStart = activeElementAsInput.selectionStart;
                            const selectionEnd = activeElementAsInput.selectionEnd;
                            if (selectionStart && selectionEnd) {
                                const newValue = `${value.substring(0, selectionStart)} ${value.substring(selectionEnd)}`;
                                activeElementAsInput.value = newValue;
                                activeElementAsInput.selectionStart = selectionStart + 1;
                                activeElementAsInput.selectionEnd = selectionStart + 1;
                            }
                            // if the whole value is selected then add replace the whole value with a space
                            if (selectionStart === 0 && selectionEnd === value.length) {
                                activeElementAsInput.value = " ";
                                activeElementAsInput.selectionStart = 1;
                                activeElementAsInput.selectionEnd = 1;
                            }
                        }
                        return state; // Prevent default behavior and allow space key to register in input
                    }
                    if (interactive && state.isOpen) {
                        setKeydownFired(true);
                        setSelectedItemIndex(state.highlightedIndex);
                        if (type === (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.MenuKeyDownEnter) {
                            if (items[state.highlightedIndex] && items[state.highlightedIndex].onClick) items[state.highlightedIndex].onClick(items[state.highlightedIndex]);
                        }
                        return Object.assign(Object.assign({}, changes), {
                            highlightedIndex: state.highlightedIndex,
                            isOpen: true
                        });
                    }
                    if (items[state.highlightedIndex] && items[state.highlightedIndex].menuItems) return Object.assign(Object.assign({}, changes), {
                        highlightedIndex: state.highlightedIndex,
                        isOpen: true
                    });
                    const indexId = `[data-item-index="${state.highlightedIndex}"]`;
                    // using popper element instead of reference in case popper is created through a portal
                    if (state.highlightedIndex === -1) return Object.assign({}, changes);
                    const itemElement = popperElement === null || popperElement === void 0 ? void 0 : popperElement.querySelector(indexId);
                    if (!itemElement) throw new Error(`[useDropdownMenu]: unable to retrieve itemElement with prop '${indexId}'`);
                    // this is to fix an issue with strict mode
                    // istanbul ignore next
                    if (selectedItemRef.current === state.highlightedIndex) {
                        selectedItemRef.current = -1;
                        return Object.assign({}, changes);
                    }
                    if (type === (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.MenuKeyDownEnter) {
                        if (items[state.highlightedIndex] && items[state.highlightedIndex].onClick) items[state.highlightedIndex].onClick(items[state.highlightedIndex]);
                    }
                    selectedItemRef.current = state.highlightedIndex;
                    // find the selected item element see if it has a a tag if so then click it by attribute data-item-index
                    if (itemElement) {
                        const aTag = itemElement.querySelector("a");
                        if (aTag) aTag.click();
                    }
                    if (resetSelectedItemOnClose) return Object.assign(Object.assign({}, changes), {
                        isOpen: false,
                        selectedItem: -1,
                        highlightedIndex: -1
                    });
                    return Object.assign({}, changes);
                }
            case (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.ItemClick:
                if (itemClicked.current) {
                    itemClicked.current = false;
                    if (interactive && state.isOpen) return Object.assign(Object.assign({}, changes), {
                        isOpen: true,
                        highlightedIndex: state.highlightedIndex
                    });
                    return Object.assign({}, changes);
                }
                if (interactive && state.isOpen) {
                    setSelectedItemIndex(state.highlightedIndex);
                    return Object.assign(Object.assign({}, changes), {
                        highlightedIndex: state.highlightedIndex,
                        isOpen: true
                    });
                }
                if (state.highlightedIndex === -1) return Object.assign({}, changes);
                selectedItemRef.current = state.highlightedIndex;
                return Object.assign({}, changes);
            case (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.MenuKeyDownEscape:
                return Object.assign(Object.assign({}, changes), {
                    isOpen: false
                });
            case (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.MenuBlur:
                // if the focused element is not a child of the menu then close the menu
                if (forceClose && state.isOpen) return Object.assign(Object.assign({}, changes), {
                    isOpen: false
                });
                if (interactive && state.isOpen) {
                    itemClicked.current = true;
                    setSelectedItemIndex(-1);
                    return Object.assign(Object.assign({}, changes), {
                        highlightedIndex: state.highlightedIndex,
                        isOpen: true,
                        selectedItem: null
                    });
                }
                setSelectedItemIndex(-1);
                return Object.assign(Object.assign({}, changes), {
                    selectedItem: null
                });
            case (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.MenuKeyDownCharacter:
            case (0, $6260541dc56be833$export$e64b2f635402ca43).stateChangeTypes.FunctionSetInputValue:
                // if the active element is a input or textarea then do nothing
                if (document.activeElement && [
                    "INPUT",
                    "TEXTAREA"
                ].includes(document.activeElement.tagName) && interactive) return {
                    isOpen: true
                };
                return Object.assign({}, changes);
            default:
                return changes; // otherwise business as usual.
        }
    };
    const { isOpen: isOpen, getToggleButtonProps: getToggleButtonProps, getMenuProps: getMenuProps, highlightedIndex: highlightedIndex, selectedItem: selectedItem, getItemProps: getItemProps, closeMenu: closeMenu, openMenu: openMenu } = (0, $6260541dc56be833$export$e64b2f635402ca43)({
        items: items,
        itemToString: itemToString,
        stateReducer: stateReducer,
        id: id !== null && id !== void 0 ? id : undefined,
        menuId: id ? `${id}-menu` : undefined,
        onSelectedItemChange: (changes)=>{
            onChange && onChange(Object.assign({}, changes.selectedItem));
        }
    });
    const isElementInMenu = (element)=>{
        if (element === popperElement) return true;
        if (element.parentElement) return isElementInMenu(element.parentElement);
        return false;
    };
    const isInReferenceElement = (element)=>{
        if (element === referenceElement) return true;
        if (element.parentElement) return isInReferenceElement(element.parentElement);
        return false;
    };
    const handleOpen = ()=>{
        openMenu();
    };
    const handleClickOutside = (event)=>{
        var _a, _b, _c, _d, _e, _f;
        if (interactive && !isElementInMenu(event.target) && isOpen && event.target !== referenceElement && !isInReferenceElement(event.target)) {
            if ((_b = (_a = event === null || event === void 0 ? void 0 : event.srcElement) === null || _a === void 0 ? void 0 : _a.id) === null || _b === void 0 ? void 0 : _b.includes("pendo-guide-container")) return;
            if ((_d = (_c = event === null || event === void 0 ? void 0 : event.srcElement) === null || _c === void 0 ? void 0 : _c.className) === null || _d === void 0 ? void 0 : _d.includes("react-datepicker")) return;
            onMenuClickOutside && onMenuClickOutside();
            setForceClose(true);
            closeMenu();
        } else {
            if ((_f = (_e = event === null || event === void 0 ? void 0 : event.srcElement) === null || _e === void 0 ? void 0 : _e.id) === null || _f === void 0 ? void 0 : _f.includes("pendo-guide-container")) return;
            setForceClose(false);
        }
    };
    (0, $acw62.useEffect)(()=>{
        document.addEventListener("click", handleClickOutside);
        document.addEventListener("focus", handleClickOutside, true);
        return ()=>{
            document.removeEventListener("click", handleClickOutside);
            document.removeEventListener("focus", handleClickOutside, true);
        };
    }, [
        interactive,
        isOpen,
        popperElement,
        forceClose,
        referenceElement
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!selectedItem) return;
        const indexOf = items.findIndex((item)=>item.id === selectedItem.id);
        if (selectedItemIndex === indexOf && interactive) setSelectedItemIndex(-1);
    }, [
        selectedItem,
        selectedItemIndex,
        interactive
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!selectedItem) return;
        const indexOf = items.findIndex((item)=>item.id === selectedItem.id);
        if (isOpen && keydownFired && indexOf == selectedItemIndex) {
            setKeydownFired(false);
            setSelectedItemIndex(1);
        }
    }, [
        isOpen,
        keydownFired,
        selectedItem,
        selectedItemIndex
    ]);
    return {
        isOpen: isOpen,
        getToggleButtonProps: getToggleButtonProps,
        getMenuProps: getMenuProps,
        highlightedIndex: highlightedIndex,
        selectedItem: selectedItem,
        getItemProps: (_a)=>{
            var { index: index } = _a, rest = $31f3d213e7f0e1c2$var$__rest(_a, [
                "index"
            ]);
            return Object.assign({
                "data-item-index": index
            }, getItemProps(Object.assign(Object.assign({}, rest), {
                index: index
            })));
        },
        setReferenceElement: setReferenceElement,
        setPopperElement: setPopperElement,
        attributes: attributes,
        styles: styles,
        update: update,
        closeMenu: closeMenu,
        openMenu: handleOpen
    };
};
const $31f3d213e7f0e1c2$var$StyledDropdownButtonWrapper = (0, $lmFrL.default).div`
    display: inline-flex;
    align-items: center;
    width: fit-content;

    .helix-dropdown-button__no-split-button {
        display: inline-flex;
        align-items: center;
        svg:not([class*='helix-svg-fill--']) {
            path {
                fill: currentColor !important;
            }
        }

        .chevron-small-down-outlined {
            margin-left: 8px;
        }
    }
    button:first-child:not(:only-child):not(.helix-dropdown-button__no-split-button) {
        border-bottom-right-radius: 0;
        border-top-right-radius: 0;
    }
    button + button {
        border-bottom-left-radius: 0;
        border-top-left-radius: 0;
        margin-left: 1px;
    }
    .helix-dropdown-button__split-toggle {
        padding-left: 8px;
        padding-right: 8px;
        box-sizing: border-box;
        display: inline-flex;
        align-items: center;
        svg {
            margin-left: 0;
            path {
                fill: currentColor !important;
            }
        }
    }

    .helix-btn--large {
        &.helix-dropdown-button__split-toggle {
            padding: 13px 12px 13px 12px;
            height: 100%;
        }
    }

    .helix-btn--secondary + .helix-btn--secondary {
        margin-left: 0;
        border-left: none;
    }
`;
const $31f3d213e7f0e1c2$export$181f40ec41159e56 = (0, $acw62.forwardRef)((_a, ref)=>{
    var _b;
    var { color: color = "tertiary", removeSplit: removeSplit, children: children, className: className, dataLwtId: dataLwtId, disabled: disabled, label: label, size: size = "medium", hideCaret: hideCaret, onClick: onClick, onKeyDown: onKeyDown, placement: placement = "bottom-end", interactive: interactive, onMenuClickOutside: onMenuClickOutside, buttonClasses: buttonClasses, usePortal: usePortal = false, id: id } = _a, rest = $31f3d213e7f0e1c2$var$__rest(_a, [
        "color",
        "removeSplit",
        "children",
        "className",
        "dataLwtId",
        "disabled",
        "label",
        "size",
        "hideCaret",
        "onClick",
        "onKeyDown",
        "placement",
        "interactive",
        "onMenuClickOutside",
        "buttonClasses",
        "usePortal",
        "id"
    ]);
    const [dropdownItems, setDropdownMenuItems] = (0, $acw62.useState)([]);
    const { isOpen: isOpen, getToggleButtonProps: getToggleButtonProps, getMenuProps: getMenuProps, highlightedIndex: highlightedIndex, getItemProps: getItemProps, setReferenceElement: setReferenceElement, setPopperElement: setPopperElement, attributes: attributes, styles: styles, update: update, closeMenu: closeMenu } = $31f3d213e7f0e1c2$var$useDropdownMenu({
        placement: placement,
        items: dropdownItems,
        interactive: interactive,
        onMenuClickOutside: onMenuClickOutside,
        // istanbul ignore next
        itemToString: (item)=>item.label ? item.label : "",
        id: id
    });
    (0, $acw62.useImperativeHandle)(ref, ()=>({
            api: {
                close: ()=>closeMenu()
            }
        }));
    const updateDropdownMenuItems = ()=>$31f3d213e7f0e1c2$var$__awaiter(void 0, void 0, void 0, function*() {
            const items = [];
            const search = (children)=>{
                (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(children, (child)=>{
                    var _a, _b, _c;
                    if (((_a = child === null || child === void 0 ? void 0 : child.type) === null || _a === void 0 ? void 0 : _a.displayName) === "DropdownButtonItem" || ((_c = (_b = child === null || child === void 0 ? void 0 : child.props) === null || _b === void 0 ? void 0 : _b.originalType) === null || _c === void 0 ? void 0 : _c.displayName) === "DropdownButtonItem") {
                        const optionalProps = {};
                        if (child.props.divider) {
                            optionalProps["divider"] = true;
                            optionalProps["disabled"] = true;
                        }
                        if (child.props.sectionHeader) {
                            optionalProps["sectionHeader"] = true;
                            optionalProps["disabled"] = true;
                        }
                        if (child.props.hidden) return;
                        items.push(Object.assign({
                            id: child.props.id,
                            label: child.props.textLabel,
                            onClick: child.props.onClick ? child.props.onClick : null,
                            checked: child.props.checked,
                            disabled: child.props.disabled,
                            className: child.props.className
                        }, optionalProps));
                    } else if (child && child.props && child.props.children) search(child.props.children);
                });
            };
            yield search(children);
            setDropdownMenuItems(items);
        });
    const getDropdownMenuItemById = (id)=>{
        // search recursively for the dropdown menu item with the given id
        const search = (children)=>{
            let foundItem = null;
            (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.forEach(children, (child)=>{
                var _a, _b, _c, _d;
                if (((_a = child === null || child === void 0 ? void 0 : child.props) === null || _a === void 0 ? void 0 : _a.id) === id || ((_c = (_b = child === null || child === void 0 ? void 0 : child.props) === null || _b === void 0 ? void 0 : _b.originalType) === null || _c === void 0 ? void 0 : _c.displayName) === "DropdownButtonItem" && child.props.id === id) foundItem = child.props.children;
                if (((_d = child === null || child === void 0 ? void 0 : child.props) === null || _d === void 0 ? void 0 : _d.children) && !foundItem) foundItem = search(child.props.children);
            });
            return foundItem;
        };
        return search(children);
    };
    const dropdownIcon = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $57af67c4e5d036b3$export$9d6bb52e86a5b54b), {
            icon: (0, $c761e69c8e58189a$exports.chevron_small_down)
        });
    const getDropdownMenuProps = ()=>{
        var _a;
        const menu = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray(children).find((child)=>{
            var _a, _b, _c;
            if (((_a = child === null || child === void 0 ? void 0 : child.type) === null || _a === void 0 ? void 0 : _a.displayName) === "DropdownButtonMenu" || ((_c = (_b = child === null || child === void 0 ? void 0 : child.props) === null || _b === void 0 ? void 0 : _b.originalType) === null || _c === void 0 ? void 0 : _c.displayName) === "DropdownButtonMenu") return child;
            return null;
        });
        return (_a = menu === null || menu === void 0 ? void 0 : menu.props) !== null && _a !== void 0 ? _a : {};
    };
    // Recursive function to render children, handling both items and non-items
    const renderChildren = (children)=>{
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.map(children, (child, index)=>{
            var _a, _b, _c, _d;
            if (((_a = child === null || child === void 0 ? void 0 : child.type) === null || _a === void 0 ? void 0 : _a.displayName) === "DropdownButtonItem" || ((_c = (_b = child === null || child === void 0 ? void 0 : child.props) === null || _b === void 0 ? void 0 : _b.originalType) === null || _c === void 0 ? void 0 : _c.displayName) === "DropdownButtonItem") {
                // Find the corresponding item from the dropdown items
                const dropdownItem = dropdownItems.find((item)=>item.id === child.props.id);
                const calulatedIndex = dropdownItems.indexOf(dropdownItem);
                if (!dropdownItem) return null;
                return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($31f3d213e7f0e1c2$var$DropdownMenuItem, {
                    highlightedIndex: highlightedIndex,
                    index: calulatedIndex,
                    menuItem: dropdownItem,
                    key: (dropdownItem === null || dropdownItem === void 0 ? void 0 : dropdownItem.id) || calulatedIndex,
                    getItemProps: getItemProps,
                    closeMenu: closeMenu,
                    checked: dropdownItem === null || dropdownItem === void 0 ? void 0 : dropdownItem.checked,
                    className: dropdownItem === null || dropdownItem === void 0 ? void 0 : dropdownItem.className
                }, getDropdownMenuItemById(dropdownItem.id));
            } else if ((_d = child === null || child === void 0 ? void 0 : child.props) === null || _d === void 0 ? void 0 : _d.children) // If the child has nested children, render recursively
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(child, {
                children: renderChildren(child.props.children) // Recursively render nested children
            });
            else // Otherwise, render non-MenuItem elements directly (keeping their props)
            return child;
        });
    };
    (0, $acw62.useEffect)(()=>{
        update && update();
    }, [
        isOpen
    ]);
    (0, $acw62.useEffect)(()=>{
        updateDropdownMenuItems();
    }, [
        children
    ]);
    const optionalProps = {};
    if (dataLwtId) optionalProps["data-lwt-id"] = dataLwtId;
    const dropdownButtonMenuChild = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray(children).find((child)=>child.type && child.type.displayName === "DropdownButtonMenu");
    // if there is a dropdownButton menu return dropdownButtonMenuChild?.props?.children else return just children
    const childrenToRender = ((_b = dropdownButtonMenuChild === null || dropdownButtonMenuChild === void 0 ? void 0 : dropdownButtonMenuChild.props) === null || _b === void 0 ? void 0 : _b.children) || children;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($31f3d213e7f0e1c2$var$StyledDropdownButtonWrapper, Object.assign({
        className: `helix-dropdown-button ${className ? className : ""}`,
        ref: setReferenceElement
    }, optionalProps), removeSplit ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", Object.assign({
        className: $31f3d213e7f0e1c2$var$clsx("helix-btn helix-dropdown-button__no-split-button", {
            "helix-btn--small": size === "small",
            "helix-btn--medium": size === "medium",
            "helix-btn--large": size === "large",
            "helix-btn--primary": color === "primary",
            "helix-btn--secondary": color === "secondary",
            "helix-btn--tertiary": color === "tertiary",
            "helix-btn--ghost": color === "ghost",
            "helix-btn--danger": color === "danger"
        }, buttonClasses),
        disabled: disabled
    }, rest, getToggleButtonProps({
        onClick: (e)=>{
            update && update();
            onClick && onClick(e);
        },
        onKeyDown: (e)=>{
            update && update();
            onKeyDown && onKeyDown(e);
        }
    })), label, !hideCaret && dropdownIcon()) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", Object.assign({
        className: $31f3d213e7f0e1c2$var$clsx("helix-btn helix-dropdown-button__button", {
            "helix-btn--small": size === "small",
            "helix-btn--medium": size === "medium",
            "helix-btn--large": size === "large",
            "helix-btn--primary": color === "primary",
            "helix-btn--secondary": color === "secondary",
            "helix-btn--tertiary": color === "tertiary",
            "helix-btn--ghost": color === "ghost",
            "helix-btn--danger": color === "danger"
        }, buttonClasses),
        color: color,
        disabled: disabled,
        onClick: (e)=>{
            onClick && onClick(e);
        },
        onKeyDown: (e)=>{
            onKeyDown && onKeyDown(e);
        }
    }, rest), label), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("button", Object.assign({
        "aria-label": "toggle menu",
        className: $31f3d213e7f0e1c2$var$clsx("helix-btn helix-dropdown-button__split-toggle", {
            "helix-btn--small": size === "small",
            "helix-btn--medium": size === "medium",
            "helix-btn--large": size === "large",
            "helix-btn--primary": color === "primary",
            "helix-btn--secondary": color === "secondary",
            "helix-btn--tertiary": color === "tertiary",
            "helix-btn--ghost": color === "ghost",
            "helix-btn--danger": color === "danger"
        }, buttonClasses),
        color: color,
        disabled: disabled
    }, getToggleButtonProps({
        onClick: (e)=>{
            update && update();
        },
        onKeyDown: (e)=>{
            update && update();
        }
    })), !hideCaret && dropdownIcon())), usePortal ? (0, $1u0KT.createPortal)((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($31f3d213e7f0e1c2$var$DropdownMenu, Object.assign({
        maxWidth: "300px",
        width: "fit-content",
        ref: setPopperElement,
        isOpen: isOpen,
        style: styles.popper
    }, getDropdownMenuProps, {
        condensedMenu: getDropdownMenuProps().menuStyle === "condensed",
        height: getDropdownMenuProps().height,
        className: $31f3d213e7f0e1c2$var$clsx("helix-dropdown-button__dropdown-menu", getDropdownMenuProps().className)
    }, attributes.popper), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({}, getMenuProps({})), renderChildren(childrenToRender))), document.body) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($31f3d213e7f0e1c2$var$DropdownMenu, Object.assign({
        maxWidth: "300px",
        width: "fit-content",
        ref: setPopperElement,
        isOpen: isOpen,
        style: styles.popper
    }, getDropdownMenuProps, {
        condensedMenu: getDropdownMenuProps().menuStyle === "condensed",
        height: getDropdownMenuProps().height,
        className: $31f3d213e7f0e1c2$var$clsx("helix-dropdown-button__dropdown-menu", getDropdownMenuProps().className)
    }, attributes.popper), (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", Object.assign({}, getMenuProps({})), renderChildren(childrenToRender))));
});
$31f3d213e7f0e1c2$export$181f40ec41159e56.displayName = "DropdownButton";
// eslint-disable-next-line no-empty-pattern
const $31f3d213e7f0e1c2$export$37946c7734078e9 = ({})=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
};
$31f3d213e7f0e1c2$export$37946c7734078e9.displayName = "DropdownButtonItem";
// eslint-disable-next-line no-empty-pattern
const $31f3d213e7f0e1c2$export$34f61431aec614a2 = ({})=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null);
};
$31f3d213e7f0e1c2$export$34f61431aec614a2.displayName = "DropdownButtonMenu";


const $7000c743a337c63f$var$HelixDropdown = ({ options: options, currentValue: currentValue, onChange: onChange, isDisabled: isDisabled = false })=>{
    const currentOption = options.find((o)=>o.value === currentValue);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $31f3d213e7f0e1c2$export$181f40ec41159e56), {
            label: currentOption?.label,
            value: currentOption?.value,
            removeSplit: true,
            disabled: isDisabled,
            size: "small",
            children: options?.map((option, index)=>{
                return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $31f3d213e7f0e1c2$export$37946c7734078e9), {
                    id: option?.value,
                    onClick: ({ id: id })=>onChange(id),
                    textLabel: option.label,
                    value: option.value,
                    children: option.label
                }, index);
            })
        })
    });
};
var $7000c743a337c63f$export$2e2bcd8739ae039 = $7000c743a337c63f$var$HelixDropdown;
$7000c743a337c63f$var$HelixDropdown.propTypes = {
    currentValue: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};



const $ec71a1ae736ebe88$var$TransactionCoverageTab = (props)=>{
    const { searchCriteria: searchCriteria, mlsId: mlsId, agentId: agentId, tableChartMode: tableChartMode, timePeriod: timePeriod, setIsTimePeriodSelectorDisabled: setIsTimePeriodSelectorDisabled, sendToParent: sendToParent, isActive: isActive, agent: agent, mappedAreas: mappedAreas, transactionCoverageMode: transactionCoverageMode, mlsName: mlsName, setState: setState, setShouldStickyFooterHide: setShouldStickyFooterHide } = props;
    const gridRef = (0, $acw62.useRef)();
    const query = (0, $bq4QZ.useQuery)();
    const queryAreaType = query.get("areaType");
    const graphStatusType = query.get("graphStatusType");
    const queryIsUnits = query.get("isUnits"); //tracks the volume or units value
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const [data, setData] = (0, $acw62.useState)([]);
    const [areasMap, setAreasMap] = (0, $acw62.useState)([]);
    const [areaType, setAreaType] = (0, $acw62.useState)(null);
    const [statusType, setStatusType] = (0, $acw62.useState)((0, $eHBjM.dealStatusCodes).SOLD);
    const [isUnits, setIsUnits] = (0, $acw62.useState)(queryIsUnits === "true");
    const [shouldDisplayAreaPercentage, setShouldDisplayAreaPercentage] = (0, $acw62.useState)(true);
    const { isPDFLoading: isPDFLoading, setAgentProfileArea: setAgentProfileArea, areasData: areasData, setAreasData: setAreasData } = (0, $bA5Mi.usePDFStore)((state)=>({
            isPDFLoading: state.downloadModalStatus.isPDFLoading,
            setAgentProfileArea: state.setAgentProfileArea,
            areasData: state.areasData,
            setAreasData: state.setAreasData
        }));
    const dataRef = (0, $acw62.useRef)(data);
    (0, $acw62.useEffect)(()=>{
        dataRef.current = data;
    });
    (0, $acw62.useEffect)(()=>{
        switch(graphStatusType){
            case (0, $eHBjM.dealStatusCodes).SOLD.value:
                setStatusType((0, $eHBjM.dealStatusCodes).SOLD);
                break;
            case (0, $eHBjM.dealStatusCodes).ACTIVE.value:
                setStatusType((0, $eHBjM.dealStatusCodes).ACTIVE);
                break;
            case (0, $eHBjM.dealStatusCodes).UNDER_CONTRACT.value:
                setStatusType((0, $eHBjM.dealStatusCodes).UNDER_CONTRACT);
                break;
        }
    }, [
        graphStatusType
    ]);
    (0, $acw62.useEffect)(()=>{
        let areasMap, areaType;
        areasMap = mappedAreas && !!Object.values(mappedAreas).length ? Object.values(mappedAreas) : [];
        const searchFields = searchCriteria?.realEstateDatasourceIdsWithFilters[0].searchFields ?? [];
        const isSearchAllMLS = searchCriteria?.realEstateDatasourceIdsWithFilters[0].searchAllMLS;
        const searchFieldNames = searchFields.map((f)=>f.fieldName) || [];
        // Set areaType to the matching searchField columnName
        searchFieldNames.forEach((fieldName)=>{
            areasMap.forEach((area)=>{
                if ((0, $cstaF.areaRequestTypes)[area.columnName].toLowerCase() === fieldName.toLowerCase()) areaType = area.columnName;
            });
        });
        // Set areaType to areaMap columnName with the viewName "MLS Areas"
        // if searching "All MLS" and areaType is still null
        if (areaType == null && isSearchAllMLS) areasMap.forEach((area)=>{
            if (area.viewName.toLowerCase() === (0, $cstaF.agentProductionTerms).mlsAreas.toLowerCase()) areaType = area.columnName;
        });
        // Default areaType to first option if areaType is still null
        if (areaType == null) areaType = areasMap[0]?.columnName;
        setAreasMap(areasMap);
        setAreaType(queryAreaType || areaType);
    }, [
        mappedAreas
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!mlsId || !agentId || !areaType || !searchCriteria) return;
        const loadTransactionCoverageData = async ()=>{
            setIsLoading(true);
            try {
                const areaRequestType = (0, $cstaF.areaRequestTypes)[areaType];
                const response = await (0, $24YIE.getAgentTransactionCoverage)(searchCriteria, agentId, areaRequestType, statusType.value, timePeriod);
                if (!response.error) setData(response);
            } catch (error) {
                console.error("Failed to load transaction coverage data: ", error);
            } finally{
                setIsLoading(false);
            }
        };
        loadTransactionCoverageData();
    }, [
        agentId,
        areaType,
        statusType,
        timePeriod,
        isActive,
        searchCriteria
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!isActive || isLoading) return;
        setShouldStickyFooterHide(false);
        const area = areasMap.find((a)=>a.columnName === areaType)?.viewName;
        const dataForParent = {
            data: dataRef.current,
            tableChartMode: tableChartMode,
            area: area,
            statusType: statusType,
            gridRef: gridRef,
            shouldDisplayAreaPercentage: shouldDisplayAreaPercentage
        };
        setAgentProfileArea(area);
        sendToParent(dataForParent);
    }, [
        isActive,
        tableChartMode,
        areaType,
        statusType,
        dataRef.current,
        isLoading
    ]);
    const chartButtons = tableChartMode === (0, $147dc1a4bec01de2$export$36b7723857d3a645).CHART ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7000c743a337c63f$export$2e2bcd8739ae039), {
        tooltips: (0, $eHBjM.coverageChartTooltips),
        options: (0, $e70e792f19abcc91$export$370ac808da2cd312),
        currentValue: isUnits ? (0, $eHBjM.coverageChartTooltips).unitsBtn.id : (0, $eHBjM.coverageChartTooltips).volumeBtn.id,
        onChange: (id)=>setIsUnits(id === (0, $eHBjM.coverageChartTooltips).unitsBtn.id)
    }) : null;
    const sortedData = (0, $acw62.useMemo)(()=>{
        const sorted = data?.slice();
        const sortBy = isUnits ? "totalUnits" : "totalVolume";
        sorted?.sort((a, b)=>a[sortBy] < b[sortBy] ? 1 : -1);
        setAreasData(sorted);
        return sorted;
    }, [
        data,
        isUnits
    ]);
    const createChart = ({ isPDF: isPDF })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $f3601c277edc0231$export$2e2bcd8739ae039), {
            agentData: isPDF ? areasData.filter((area)=>area.checked === true) : sortedData,
            isUnits: isUnits,
            statusType: statusType.value,
            areaType: areaType,
            tableType: statusType,
            agent: agent,
            timePeriod: timePeriod,
            shouldDisplayAreaPercentage: shouldDisplayAreaPercentage,
            isPDF: isPDF
        });
    const chartContent = createChart({
        isPDF: false
    });
    const pdfChartContent = isPDFLoading ? createChart({
        isPDF: true
    }) : null;
    const tableContent = (0, $acw62.useMemo)(()=>{
        const label = areaType ? areasMap.find((a)=>a.columnName === areaType)?.viewName : "";
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cb2d6d84dd4380da$export$2e2bcd8739ae039), {
            gridRef: gridRef,
            areaLabel: label,
            data: data,
            isUnits: isUnits,
            statusType: statusType.value,
            areaType: areaType,
            tableType: statusType,
            agent: agent,
            timePeriod: timePeriod
        });
    }, [
        data,
        statusType,
        isUnits
    ]);
    let displayedContent;
    if (isLoading) displayedContent = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {});
    else if (tableChartMode === (0, $147dc1a4bec01de2$export$36b7723857d3a645).TABLE) displayedContent = tableContent;
    else displayedContent = chartContent;
    const areaTypeOptions = [];
    areasMap?.forEach((a)=>{
        areaTypeOptions.push({
            value: a.columnName,
            label: a.viewName
        });
    });
    const statusOptions = [
        {
            value: (0, $eHBjM.dealStatusCodes).ACTIVE.value,
            label: (0, $eHBjM.dealStatusCodes).ACTIVE.label
        },
        {
            value: (0, $eHBjM.dealStatusCodes).UNDER_CONTRACT.value,
            label: (0, $eHBjM.dealStatusCodes).UNDER_CONTRACT.label
        },
        {
            value: (0, $eHBjM.dealStatusCodes).SOLD.value,
            label: (0, $eHBjM.dealStatusCodes).SOLD.label
        }
    ];
    const handleStatusButtonClick = (statusType, isDisabled)=>{
        const selectedStatusTypeOption = statusOptions.find((s)=>s.value === statusType);
        setStatusType((0, $e70e792f19abcc91$export$b0eda28bd2f81616)[selectedStatusTypeOption?.value]);
        setIsTimePeriodSelectorDisabled(isDisabled);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "controls-container mb-3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $147dc1a4bec01de2$export$2e2bcd8739ae039), {
                        defaultMode: transactionCoverageMode,
                        parentSetMode: (m)=>(0, $ivaD7.setStateData)("transactionCoverageMode", m, setState),
                        hasAreaSelector: true,
                        mlsName: mlsName
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "d-flex justify-content-end align-items-center flex-wrap",
                        style: {
                            gap: "8px"
                        },
                        children: [
                            tableChartMode === (0, $147dc1a4bec01de2$export$36b7723857d3a645).CHART && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "d-flex mr-2 align-items-center",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1BYDb))), {
                                    dataLwtId: "areaPercentageCheckbox",
                                    type: "checkbox",
                                    checked: shouldDisplayAreaPercentage,
                                    id: "exampleCustomCheckbox",
                                    label: (0, $g3CkB.getElementTooltip)((0, $eHBjM.coverageChartTooltips).marketAreaCheck),
                                    onChange: ()=>setShouldDisplayAreaPercentage(!shouldDisplayAreaPercentage)
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "agent-coverage-controls-item ml-3",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7000c743a337c63f$export$2e2bcd8739ae039), {
                                    currentValue: areaType,
                                    options: areaTypeOptions,
                                    onChange: setAreaType
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "mx-3",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7000c743a337c63f$export$2e2bcd8739ae039), {
                                    tooltips: (0, $eHBjM.coverageChartTooltips),
                                    options: statusOptions,
                                    currentValue: statusType.value,
                                    onChange: handleStatusButtonClick
                                })
                            }),
                            chartButtons
                        ]
                    })
                ]
            }),
            displayedContent,
            pdfChartContent,
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "hidden-export-table",
                children: tableContent
            })
        ]
    });
};
$ec71a1ae736ebe88$var$TransactionCoverageTab.propTypes = {
    searchCriteria: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    mlsId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    agentId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    tableChartMode: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    timePeriod: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    setIsTimePeriodSelectorDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    sendToParent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    isActive: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    agent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    mappedAreas: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    transactionCoverageMode: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    setState: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    mlsName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    setShouldStickyFooterHide: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired
};
var $ec71a1ae736ebe88$export$2e2bcd8739ae039 = $ec71a1ae736ebe88$var$TransactionCoverageTab;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7tOHe = parcelRequire("7tOHe");

var $cstaF = parcelRequire("cstaF");
var $dae8b86b7593d7e2$export$2e2bcd8739ae039 = ()=>{
    const additionalHeaders = [
        {
            column1: {
                title: (0, $cstaF.agentProductionTerms).currently,
                attrs: {
                    colSpan: 1,
                    className: "border text-center col-wrap"
                }
            },
            column2: {
                title: "Property",
                attrs: {
                    colSpan: 3,
                    className: "border text-center "
                }
            },
            column3: {
                title: "Price Change",
                attrs: {
                    colSpan: 2,
                    className: "border text-center "
                }
            },
            column4: {
                title: "CDOM Breakout",
                attrs: {
                    colSpan: 5,
                    className: "border text-center "
                }
            }
        }
    ];
    return additionalHeaders;
};


var $de58b35869858169$export$2e2bcd8739ae039 = ()=>{
    const forSaleAdditionalHeaders = [
        {
            column1: {
                title: "Currently For Sale",
                attrs: {
                    colSpan: 4,
                    className: "border text-center"
                }
            },
            column2: {
                title: "Price",
                attrs: {
                    colSpan: 3,
                    className: "border text-center"
                }
            },
            column3: {
                title: "Dates",
                attrs: {
                    colSpan: 2,
                    className: "border text-center"
                }
            },
            column4: {
                title: "Property Attributes",
                attrs: {
                    colSpan: 7,
                    className: "border text-center"
                }
            }
        }
    ];
    return forSaleAdditionalHeaders;
};


var $ab68eebcb4b50f5f$export$2e2bcd8739ae039 = ()=>{
    const underContractAdditionalHeaders = [
        {
            column1: {
                title: "Currently Under Contract",
                attrs: {
                    colSpan: 4,
                    className: " border text-center "
                }
            },
            column2: {
                title: "Price",
                attrs: {
                    colSpan: 3,
                    className: " border text-center "
                }
            },
            column3: {
                title: "Dates",
                attrs: {
                    colSpan: 4,
                    className: " border text-center "
                }
            },
            column4: {
                title: "Property Attributes",
                attrs: {
                    colSpan: 8,
                    className: " border text-center "
                }
            }
        }
    ];
    return underContractAdditionalHeaders;
};



var $24YIE = parcelRequire("24YIE");

var $eHBjM = parcelRequire("eHBjM");

var $l05Px = parcelRequire("l05Px");

var $4tbBr = parcelRequire("4tbBr");

var $90ISC = parcelRequire("90ISC");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $90ISC = parcelRequire("90ISC");


var $cstaF = parcelRequire("cstaF");

var $eHBjM = parcelRequire("eHBjM");
const $fe160dfacedfca73$var$ForSaleUnderContractToggle = ({ mlsName: mlsName })=>{
    const { setInventoryTableType: setInventoryTableType, inventoryTableType: inventoryTableType } = (0, $90ISC.useAgentProfileStore)((state)=>({
            setInventoryTableType: state.setInventoryTableType,
            inventoryTableType: state.inventoryTableType
        }));
    const handleTableTypeChange = (tableStatus)=>{
        setInventoryTableType(tableStatus);
    };
    const options = [
        {
            value: (0, $cstaF.agentProductionTerms).forSaleListing,
            label: (0, $eHBjM.inventoryTables).FOR_SALE
        },
        {
            value: (0, $cstaF.agentProductionTerms).underContractListing,
            label: (0, $eHBjM.inventoryTables).UNDER_CONTRACT
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "d-flex align-items-center",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                className: "mr-3",
                children: mlsName
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0640a9c1d6a50c50$export$2e2bcd8739ae039), {
                setOption: handleTableTypeChange,
                optionsList: options,
                defaultOption: inventoryTableType
            })
        ]
    });
};
$fe160dfacedfca73$var$ForSaleUnderContractToggle.propTypes = {
    mlsName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};
var $fe160dfacedfca73$export$2e2bcd8739ae039 = $fe160dfacedfca73$var$ForSaleUnderContractToggle;



var $cstaF = parcelRequire("cstaF");
const $1bcd6cefddc1733f$var$Inventory = ({ mlsId: mlsId, agentId: agentId, mlsName: mlsName, sendToParent: sendToParent, isActive: isActive, setShouldStickyFooterHide: setShouldStickyFooterHide })=>{
    const additionalHeaders = (0, $dae8b86b7593d7e2$export$2e2bcd8739ae039)();
    const forSaleAdditionalHeaders = (0, $de58b35869858169$export$2e2bcd8739ae039)();
    const underContractAdditionalHeaders = (0, $ab68eebcb4b50f5f$export$2e2bcd8739ae039)();
    const [isLoading, setIsLoading] = (0, $acw62.useState)(true);
    const [inventoryMappedData, setInventoryMappedData] = (0, $acw62.useState)([]);
    const [forSaleRawData, setForSaleRawData] = (0, $acw62.useState)([]);
    const [underContractRawData, setUnderContractRawData] = (0, $acw62.useState)([]);
    const [inventoryTableData, setInventoryTableData] = (0, $acw62.useState)([]);
    const { inventoryTableType: inventoryTableType } = (0, $90ISC.useAgentProfileStore)((state)=>({
            inventoryTableType: state.inventoryTableType
        }));
    const gridRef = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(()=>{
        if (!agentId || !mlsId) return;
        const loadProductionData = async ()=>{
            setIsLoading(true);
            const data = await (0, $24YIE.getAgentInventoryHistory)({
                agentId: agentId,
                mlsId: mlsId
            });
            setInventoryTableData(data);
            setIsLoading(false);
        };
        const handleErrorInFutureTicket = (e)=>console.log(e);
        loadProductionData().catch(handleErrorInFutureTicket);
    }, [
        mlsId,
        agentId
    ]);
    (0, $acw62.useEffect)(()=>{
        if (inventoryTableData !== null) {
            let forSale = {
                id: 1,
                status: (0, $eHBjM.inventoryTables).FOR_SALE,
                totalUnits: 0,
                listPriceVolume: 0,
                originalPriceVolume: 0,
                pcUnits: 0,
                cdomTier1: 0,
                cdomTier2: 0,
                cdomTier3: 0,
                cdomTier4: 0,
                cdomTier5: 0
            };
            let underContract = {
                id: 2,
                status: (0, $eHBjM.inventoryTables).UNDER_CONTRACT,
                totalUnits: 0,
                listPriceVolume: 0,
                originalPriceVolume: 0,
                pcUnits: 0,
                cdomTier1: 0,
                cdomTier2: 0,
                cdomTier3: 0,
                cdomTier4: 0,
                cdomTier5: 0
            };
            const temp1 = [];
            const temp2 = [];
            inventoryTableData?.inventoryItems?.forEach((property)=>{
                const revisedProperty = {
                    ...property,
                    dollarPerSquareFt: property.squareFt ? property.listPrice / property.squareFt : 0
                };
                if (!property.dateCont) {
                    forSale.totalUnits++;
                    forSale.listPriceVolume += property.listPrice;
                    forSale.originalPriceVolume += property.orgPrice;
                    property.listPrice !== property.orgPrice && forSale.pcUnits++;
                    property.cdom <= 30 && forSale.cdomTier1++;
                    property.cdom >= 31 && property.cdom <= 90 && forSale.cdomTier2++;
                    property.cdom >= 91 && property.cdom <= 180 && forSale.cdomTier3++;
                    property.cdom >= 181 && property.cdom <= 360 && forSale.cdomTier4++;
                    property.cdom > 360 && forSale.cdomTier5++;
                    temp1.push(revisedProperty);
                } else {
                    underContract.totalUnits++;
                    underContract.listPriceVolume += property.listPrice;
                    underContract.originalPriceVolume += property.orgPrice;
                    property.listPrice !== property.orgPrice && underContract.pcUnits++;
                    property.cdom <= 30 && underContract.cdomTier1++;
                    property.cdom >= 31 && property.cdom <= 90 && underContract.cdomTier2++;
                    property.cdom >= 91 && property.cdom <= 180 && underContract.cdomTier3++;
                    property.cdom >= 181 && property.cdom <= 360 && underContract.cdomTier4++;
                    property.cdom > 360 && underContract.cdomTier5++;
                    temp2.push(revisedProperty);
                }
            });
            setForSaleRawData(temp1);
            setUnderContractRawData(temp2);
            forSale.avgPrice = forSale.totalUnits ? forSale.listPriceVolume / forSale.totalUnits : 0;
            forSale.lpop = forSale.originalPriceVolume ? forSale.listPriceVolume / forSale.originalPriceVolume * 100 : 0;
            underContract.avgPrice = underContract.totalUnits ? underContract.listPriceVolume / underContract.totalUnits : 0;
            underContract.lpop = underContract.originalPriceVolume ? underContract.listPriceVolume / underContract.originalPriceVolume * 100 : 0;
            const combined = [];
            inventoryTableType === (0, $cstaF.agentProductionTerms).forSaleListing && combined.push(forSale);
            inventoryTableType === (0, $cstaF.agentProductionTerms).underContractListing && combined.push(underContract);
            setInventoryMappedData(combined);
        }
    }, [
        inventoryTableData,
        inventoryTableType
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!isActive || isLoading) return;
        const hasOneOrMoreRowsToShow = inventoryTableType === (0, $cstaF.agentProductionTerms).forSaleListing && !!forSaleRawData.length || inventoryTableType === (0, $cstaF.agentProductionTerms).underContractListing && !!underContractRawData.length;
        const forParent = {
            forSaleRawData: forSaleRawData,
            underContractRawData: underContractRawData,
            gridRef: gridRef,
            shouldShowExportButton: hasOneOrMoreRowsToShow
        };
        sendToParent(forParent);
        setShouldStickyFooterHide(!inventoryTableType);
    }, [
        isLoading,
        inventoryTableType,
        forSaleRawData,
        underContractRawData,
        isActive
    ]);
    return !isLoading ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "d-flex justify-content-start helix-body--strong mb-3",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fe160dfacedfca73$export$2e2bcd8739ae039), {
                    mlsName: mlsName
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "white-background p-3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l05Px.default), {
                            tableView: (0, $4tbBr.tableViews).inventory,
                            rowData: inventoryMappedData || [],
                            additionalTableHeaders: additionalHeaders,
                            tableTitleWithTooltips: (0, $eHBjM.inventoryTableTooltips)
                        })
                    }),
                    inventoryTableType === (0, $cstaF.agentProductionTerms).forSaleListing ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        id: "inventory-for-sale",
                        className: "pt-2",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l05Px.default), {
                            tableView: (0, $4tbBr.tableViews).forSale,
                            rowData: forSaleRawData || [],
                            additionalTableHeaders: forSaleAdditionalHeaders,
                            tableTitleWithTooltips: (0, $eHBjM.currentlyFSTooltips)
                        })
                    }) : inventoryTableType === (0, $cstaF.agentProductionTerms).underContractListing ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        id: "inventory-under-contract",
                        className: "pt-2",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l05Px.default), {
                            tableView: (0, $4tbBr.tableViews).underContract,
                            rowData: underContractRawData || [],
                            additionalTableHeaders: underContractAdditionalHeaders,
                            tableTitleWithTooltips: (0, $eHBjM.currentlyUCTooltips)
                        })
                    }) : ""
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "hidden-export-table",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l05Px.default), {
                    gridRef: gridRef,
                    tableView: (0, $4tbBr.tableViews).underContract,
                    rowData: [
                        ...forSaleRawData,
                        ...underContractRawData
                    ],
                    additionalTableHeaders: underContractAdditionalHeaders,
                    tableTitleWithTooltips: (0, $eHBjM.currentlyUCTooltips)
                })
            })
        ]
    }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {});
};
var $1bcd6cefddc1733f$export$2e2bcd8739ae039 = $1bcd6cefddc1733f$var$Inventory;



var $bq4QZ = parcelRequire("bq4QZ");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $dLTlW = parcelRequire("dLTlW");
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $75ac014bbcc7d182$var$arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
var $75ac014bbcc7d182$export$2e2bcd8739ae039 = $75ac014bbcc7d182$var$arrayAggregator;



var $irzyZ = parcelRequire("irzyZ");
/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function $28bd304b81113b21$var$baseAggregator(collection, setter, iteratee, accumulator) {
    (0, $irzyZ.default)(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
var $28bd304b81113b21$export$2e2bcd8739ae039 = $28bd304b81113b21$var$baseAggregator;



var $dKmGr = parcelRequire("dKmGr");

var $hf0C9 = parcelRequire("hf0C9");
/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function $d11e62598dffb211$var$createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = (0, $hf0C9.default)(collection) ? (0, $75ac014bbcc7d182$export$2e2bcd8739ae039) : (0, $28bd304b81113b21$export$2e2bcd8739ae039), accumulator = initializer ? initializer() : {};
        return func(collection, setter, (0, $dKmGr.default)(iteratee, 2), accumulator);
    };
}
var $d11e62598dffb211$export$2e2bcd8739ae039 = $d11e62598dffb211$var$createAggregator;


/** Used for built-in method references. */ var $44edd66c0b20008c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $44edd66c0b20008c$var$hasOwnProperty = $44edd66c0b20008c$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */ var $44edd66c0b20008c$var$groupBy = (0, $d11e62598dffb211$export$2e2bcd8739ae039)(function(result, value, key) {
    if ($44edd66c0b20008c$var$hasOwnProperty.call(result, key)) result[key].push(value);
    else (0, $dLTlW.default)(result, key, [
        value
    ]);
});
var $44edd66c0b20008c$export$2e2bcd8739ae039 = $44edd66c0b20008c$var$groupBy;



var $7tOHe = parcelRequire("7tOHe");
parcelRequire("7hEbZ");
var $iDoBR = parcelRequire("iDoBR");
parcelRequire("fHiKR");
var $1BYDb = parcelRequire("1BYDb");

var $l05Px = parcelRequire("l05Px");

var $4tbBr = parcelRequire("4tbBr");

var $eHBjM = parcelRequire("eHBjM");

var $htzEo = parcelRequire("htzEo");

var $59GDU = parcelRequire("59GDU");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $bGkwn = parcelRequire("bGkwn");

var $eHBjM = parcelRequire("eHBjM");

const $a6be97feeb3a9d43$var$VolumeUnitsToggle = ({ defaultMode: defaultMode, parentSetMode: parentSetMode })=>{
    if (!defaultMode || !parentSetMode) return;
    const [mode, setMode] = (0, $acw62.useState)(defaultMode);
    const handleModeClick = (modeToSet)=>{
        setMode(modeToSet);
        parentSetMode(modeToSet);
    };
    (0, $acw62.useEffect)(()=>{
        if (!defaultMode) return;
        setMode(defaultMode);
        parentSetMode(defaultMode);
    }, [
        defaultMode
    ]);
    const options = [
        {
            label: (0, $eHBjM.agentProfileButtons).volumeBtn.label,
            value: (0, $bGkwn.chartModes).VOLUME
        },
        {
            label: (0, $eHBjM.agentProfileButtons).unitsBtn.label,
            value: (0, $bGkwn.chartModes).UNITS
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "volume-units-toggle-wrapper ml-3",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $31f3d213e7f0e1c2$export$181f40ec41159e56), {
            label: options.find((opt)=>opt.value === mode)?.label,
            value: mode,
            removeSplit: true,
            size: "small",
            children: options?.map((option, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $31f3d213e7f0e1c2$export$37946c7734078e9), {
                    id: option.value,
                    onClick: ({ id: id })=>handleModeClick(id),
                    textLabel: option.label,
                    value: option.value,
                    size: "small",
                    children: option.label
                }, index))
        })
    });
};
var $a6be97feeb3a9d43$export$2e2bcd8739ae039 = $a6be97feeb3a9d43$var$VolumeUnitsToggle;



var $bGkwn = parcelRequire("bGkwn");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("7hEbZ");
var $iDoBR = parcelRequire("iDoBR");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $g3CkB = parcelRequire("g3CkB");

var $eHBjM = parcelRequire("eHBjM");
const $1fd7ccae28acc2c0$export$a12cb01701b6e255 = ({ id: id, value: value, children: children })=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "helix-card ",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "helix-card__body",
            children: children ?? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "helix-body my-3",
                        children: (0, $g3CkB.getElementTooltip)((0, $eHBjM.productionChartTabToolTips)[id], true)
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "my-3 text-nowrap helix-display-x-small",
                        children: value
                    })
                ]
            })
        })
    });
$1fd7ccae28acc2c0$export$a12cb01701b6e255.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};


const $6281442acb41944d$export$2e58c2d5c54ab58d = ({ cardData: cardData })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "mb-3",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iDoBR))), {
                dataLwtId: "summary-row-detail",
                className: "summary-row-detail",
                type: "group",
                children: cardData?.map(({ id: id, value: value }, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "summary-card-wrapper",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1fd7ccae28acc2c0$export$a12cb01701b6e255), {
                            id: id,
                            value: value
                        })
                    }, index))
            })
        })
    });



var $ayMG0 = parcelRequire("ayMG0");

var $cstaF = parcelRequire("cstaF");

var $htzEo = parcelRequire("htzEo");

var $bGkwn = parcelRequire("bGkwn");

var $59GDU = parcelRequire("59GDU");
parcelRequire("acw62");

var $eHBjM = parcelRequire("eHBjM");
const $60634583ab814cee$var$getLwtId = (dataLwtIdSuffix, prefix)=>`prod-${prefix}-${dataLwtIdSuffix}`;
const $60634583ab814cee$var$getLwtIdUnits = (dataLwtIdSuffix)=>$60634583ab814cee$var$getLwtId(dataLwtIdSuffix, "units");
const $60634583ab814cee$var$getLwtIdVolume = (dataLwtIdSuffix)=>$60634583ab814cee$var$getLwtId(dataLwtIdSuffix, "volume");
const $60634583ab814cee$var$getCard = (id, value, dataLwtId)=>{
    return {
        id: id,
        value: value,
        dataLwtId: dataLwtId
    };
};
const $60634583ab814cee$var$getVolumeSummaryCardData = (chartData, dataIndexes)=>{
    const productionChartKeys = Object.keys((0, $eHBjM.productionChartTabToolTips));
    productionChartKeys.forEach((el)=>{
        (0, $eHBjM.productionChartTabToolTips)[el].id = el;
    });
    const points = $60634583ab814cee$export$1dedb19c2ca0111e({
        chartData: chartData,
        dataIndexes: dataIndexes
    });
    const cardData = [];
    const cardList = $60634583ab814cee$var$getCard((0, $eHBjM.productionChartTabToolTips).summaryVolListSide.id, (0, $htzEo.getCurrencyFormat)(points.totalListVol), $60634583ab814cee$var$getLwtIdVolume("dollarVolumeListSide"));
    cardData.push(cardList);
    const cardSell = $60634583ab814cee$var$getCard((0, $eHBjM.productionChartTabToolTips).summaryVolSellSide.id, (0, $htzEo.getCurrencyFormat)(points.totalSellVol), $60634583ab814cee$var$getLwtIdVolume("dollarVolumeSellSide"));
    cardData.push(cardSell);
    const cardTotal = $60634583ab814cee$var$getCard((0, $eHBjM.productionChartTabToolTips).summaryTotalVolume.id, (0, $htzEo.getCurrencyFormat)(points.totalListSellVol), $60634583ab814cee$var$getLwtIdVolume("totalDollarVolume"));
    cardData.push(cardTotal);
    const cardMonthly = $60634583ab814cee$var$getCard((0, $eHBjM.productionChartTabToolTips).summaryVolPerMonth.id, (0, $htzEo.getCurrencyFormat)(points.avgPerMonthVol), $60634583ab814cee$var$getLwtIdVolume("dollarVolumePerMonth"));
    cardData.push(cardMonthly);
    const cardAvgPrice = $60634583ab814cee$var$getCard((0, $eHBjM.productionChartTabToolTips).summaryAvgPrice.id, (0, $htzEo.getCurrencyFormat)(points.avgPrice), $60634583ab814cee$var$getLwtIdVolume("averagePrice"));
    cardData.push(cardAvgPrice);
    return cardData;
};
const $60634583ab814cee$var$getUnitSummaryCardData = (chartData, dataIndexes)=>{
    const productionChartKeys = Object.keys((0, $eHBjM.productionChartTabToolTips));
    productionChartKeys.forEach((el)=>{
        (0, $eHBjM.productionChartTabToolTips)[el].id = el;
    });
    const points = $60634583ab814cee$export$1dedb19c2ca0111e({
        chartData: chartData,
        dataIndexes: dataIndexes
    });
    const cardData = [];
    const cardList = $60634583ab814cee$var$getCard((0, $eHBjM.productionChartTabToolTips).summaryUnitsListSide.id, points.totalListUnits, $60634583ab814cee$var$getLwtIdUnits("numberUnitsListSide"));
    cardData.push(cardList);
    const cardSell = $60634583ab814cee$var$getCard((0, $eHBjM.productionChartTabToolTips).summaryUnitsSellSide.id, points.totalSellUnits, $60634583ab814cee$var$getLwtIdUnits("numberUnitsSellSide"));
    cardData.push(cardSell);
    const cardTotal = $60634583ab814cee$var$getCard((0, $eHBjM.productionChartTabToolTips).summaryTotalUnits.id, points.totalListSellUnits, $60634583ab814cee$var$getLwtIdUnits("totalNumberUnits"));
    cardData.push(cardTotal);
    const cardMonthly = $60634583ab814cee$var$getCard((0, $eHBjM.productionChartTabToolTips).summaryUnitsPerMonth.id, (0, $htzEo.maxTwoDecimals)(points.avgPerMonthUnits), $60634583ab814cee$var$getLwtIdUnits("numberUnitsPerMonth"));
    cardData.push(cardMonthly);
    const cardAvgPrice = $60634583ab814cee$var$getCard((0, $eHBjM.productionChartTabToolTips).summaryAvgPrice.id, (0, $htzEo.getCurrencyFormat)(points.avgPrice), $60634583ab814cee$var$getLwtIdUnits("averagePrice"));
    cardData.push(cardAvgPrice);
    return cardData;
};
const $60634583ab814cee$export$daca81188ad23fe3 = ({ graphData: chartData, dataIndexes: dataIndexes, graphMode: graphMode })=>{
    let title, cardData;
    if (graphMode === (0, $bGkwn.chartModes).VOLUME) {
        title = (0, $cstaF.agentProductionTerms).totalVolume;
        cardData = $60634583ab814cee$var$getVolumeSummaryCardData(chartData, dataIndexes);
    } else {
        title = (0, $cstaF.agentProductionTerms).totalUnits;
        cardData = $60634583ab814cee$var$getUnitSummaryCardData(chartData, dataIndexes);
    }
    return {
        title: title,
        cardData: cardData
    };
};
const $60634583ab814cee$export$1dedb19c2ca0111e = ({ chartData: chartData, dataIndexes: dataIndexes })=>{
    const dataToMap = chartData?.slice(dataIndexes.lastPeriodStart, dataIndexes.lastPeriodFinish + 1);
    let totalListVol = 0, totalSellVol = 0, totalListSellVol, avgPerMonthVol, avgPrice, totalListUnits = 0, totalSellUnits = 0, avgPerMonthUnits, totalUnits = 0;
    dataToMap?.forEach((d)=>{
        totalListVol += d.listVolume;
        totalSellVol += d.sellVolume;
        totalUnits += d.totalUnits;
        totalListUnits += d.listUnits;
        totalSellUnits += d.sellUnits;
    });
    totalListSellVol = totalListVol + totalSellVol;
    avgPerMonthVol = !dataToMap || dataToMap?.length === 0 ? 0 : totalListSellVol / dataToMap.length;
    avgPerMonthUnits = !dataToMap || dataToMap?.length === 0 ? 0 : totalUnits / dataToMap.length;
    avgPrice = totalUnits ? totalListSellVol / totalUnits : 0;
    return {
        totalListVol: totalListVol,
        totalSellVol: totalSellVol,
        totalListSellVol: totalListSellVol,
        avgPerMonthVol: avgPerMonthVol,
        avgPrice: avgPrice,
        totalListUnits: totalListUnits,
        totalSellUnits: totalSellUnits,
        totalListSellUnits: totalUnits,
        avgPerMonthUnits: avgPerMonthUnits
    };
};
const $60634583ab814cee$export$da37688e49d6b659 = ({ timePeriod: timePeriod, graphMode: graphMode, chartData: chartData, dataIndexes: dataIndexes })=>{
    if (!timePeriod) return null;
    const graphProps = (0, $bGkwn.getOverviewGraphProps)({
        chartData: chartData || [],
        timePeriod: timePeriod,
        dataIndexes: dataIndexes,
        widthPixelsOutsideGraph: 100,
        graphMode: graphMode
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $59GDU.OverviewChartGraph), {
        ...graphProps
    });
};
const $60634583ab814cee$export$830d293300b6d56d = (timePeriodInterval)=>{
    const firstPeriod = new Date(timePeriodInterval[0]);
    let lastPeriod = new Date(timePeriodInterval[1]);
    const lastDayMonth = new Date(lastPeriod.getFullYear(), lastPeriod.getMonth() + 1, 0).getDate();
    lastPeriod.setDate(lastDayMonth);
    const dateOptions = {
        year: "numeric",
        month: "short",
        day: "numeric"
    };
    return `${firstPeriod.toLocaleDateString("default", dateOptions)} - ${lastPeriod.toLocaleDateString("default", dateOptions)}`;
};



var $g3CkB = parcelRequire("g3CkB");

var $24YIE = parcelRequire("24YIE");

var $bA5Mi = parcelRequire("bA5Mi");

var $fPGDZ = parcelRequire("fPGDZ");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");


var $cstaF = parcelRequire("cstaF");

var $aYbF1 = parcelRequire("aYbF1");
const $0fad71a469270d71$var$TimePeriodSelector = ({ options: options, currentValue: currentValue, setTimePeriod: setTimePeriod, isDisabled: isDisabled })=>{
    const currentValueOption = (0, $aYbF1.getTimePeriodLabelKey)(currentValue);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $31f3d213e7f0e1c2$export$181f40ec41159e56), {
        label: currentValueOption,
        value: (0, $cstaF.TimePeriods)[currentValueOption],
        removeSplit: true,
        disabled: isDisabled,
        size: "small",
        children: options?.map((option, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $31f3d213e7f0e1c2$export$37946c7734078e9), {
                id: (0, $cstaF.TimePeriods)[option.label],
                onClick: ({ id: id })=>setTimePeriod(id),
                textLabel: option.label,
                value: (0, $cstaF.TimePeriods)[option.label],
                children: option.label
            }, index))
    });
};
var $0fad71a469270d71$export$2e2bcd8739ae039 = $0fad71a469270d71$var$TimePeriodSelector;
$0fad71a469270d71$var$TimePeriodSelector.propTypes = {
    currentValue: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    setTimePeriod: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};



var $ivaD7 = parcelRequire("ivaD7");



var $cstaF = parcelRequire("cstaF");

var $90ISC = parcelRequire("90ISC");
const $cf0deb29d93490f5$var$ProductionTab = (props)=>{
    const { mlsId: mlsId, agentId: agentId, timePeriod: timePeriod, tableChartMode: tableChartMode, setState: setState, isXamInternalUser: isXamInternalUser, state: state, handleClickChartGraph: handleClickChartGraph, sendToParent: sendToParent, isActive: isActive, productionGraphMode: productionGraphMode, setProductionGraphView: setProductionGraphView, productionIsLabelEnabled: productionIsLabelEnabled, setProductionLabels: setProductionLabels, setShouldStickyFooterHide: setShouldStickyFooterHide, currentTabIndex: currentTabIndex, timePeriodSelector: timePeriodSelector } = props;
    const [chartData, setChartData] = (0, $acw62.useState)(null);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(true);
    const [graphMode, setGraphMode] = (0, $acw62.useState)(productionGraphMode);
    const [summaryTimePeriodData, setSummaryTimePeriodData] = (0, $acw62.useState)({});
    const [tableTimePeriodData, setTableTimePeriodData] = (0, $acw62.useState)([]);
    const [currentIntervalTimePeriod, setCurrentIntervalTimePeriod] = (0, $acw62.useState)("");
    const [isShowChartColumnLabels, setIsShowChartColumnLabels] = (0, $acw62.useState)(productionIsLabelEnabled);
    const gridRef = (0, $acw62.useRef)();
    const { membership: membership, agentMetricsMlsId: agentMetricsMlsId } = (0, $90ISC.useCommonStore)((state)=>{
        const mlsAgent = state?.agentInfo?.[0]?.mlsAgentId;
        return {
            membership: state.membership,
            agentMetricsMlsId: mlsAgent?.mlsId
        };
    });
    const { isPDFLoading: isPDFLoading, setAgentProfileProductionTableData: setAgentProfileProductionTableData, setProductionSummary: setProductionSummary } = (0, $bA5Mi.usePDFStore)((state)=>({
            isPDFLoading: state.downloadModalStatus.isPDFLoading,
            setAgentProfileProductionTableData: state.setAgentProfileProductionTableData,
            setProductionSummary: state.setProductionSummary
        }));
    const sortProductionTableData = (data)=>{
        const dataSortedByYears = $44edd66c0b20008c$export$2e2bcd8739ae039(data, ({ month: month })=>new Date(month).getFullYear());
        let result = [];
        for(let year in dataSortedByYears){
            const sortedByMonths = $44edd66c0b20008c$export$2e2bcd8739ae039(dataSortedByYears[year], ({ month: month })=>new Date(month).getMonth());
            for(let obj in sortedByMonths){
                const arrayMonth = sortedByMonths[obj];
                let objectResult = {
                    id: "",
                    month: "",
                    listUnits: 0,
                    sellUnits: 0,
                    totalUnits: 0,
                    listVolume: 0,
                    sellVolume: 0,
                    totalVolume: 0
                };
                arrayMonth.forEach((el, index)=>{
                    objectResult = {
                        ...objectResult,
                        id: el.month,
                        month: el.month,
                        listUnits: objectResult.listUnits + el.listUnits,
                        sellUnits: objectResult.sellUnits + el.sellUnits,
                        totalUnits: el.listUnits + el.sellUnits,
                        listVolume: objectResult.listVolume + el.listVolume,
                        sellVolume: objectResult.sellVolume + el.sellVolume,
                        totalVolume: el.listVolume + el.sellVolume
                    };
                    if (arrayMonth.length - 1 === index) result.push(objectResult);
                });
            }
        }
        return result;
    };
    const getSummaryTableData = (data)=>{
        let summaryResult = {
            listVolume: 0,
            listUnits: 0,
            sellVolume: 0,
            sellUnits: 0,
            totalVolume: 0,
            totalUnits: 0
        };
        data.forEach((obj)=>{
            summaryResult = {
                ...summaryResult,
                listVolume: summaryResult.listVolume + obj.listVolume,
                listUnits: summaryResult.listUnits + obj.listUnits,
                sellVolume: summaryResult.sellVolume + obj.sellVolume,
                sellUnits: summaryResult.sellUnits + obj.sellUnits,
                totalVolume: summaryResult.totalVolume + obj.totalVolume,
                totalUnits: summaryResult.totalUnits + obj.totalUnits
            };
        });
        return summaryResult;
    };
    (0, $acw62.useEffect)(()=>{
        if (!agentId || !mlsId) return;
        const loadProductionData = async ()=>{
            setIsLoading(true);
            const data = await (0, $24YIE.getAgentHistory)({
                mlsId: mlsId,
                agentId: agentId
            });
            setChartData(data);
            setIsLoading(false);
        };
        const handleErrorInFutureTicket = (e)=>e; // todo - add error handling
        loadProductionData().catch(handleErrorInFutureTicket);
    }, [
        mlsId,
        agentId
    ]);
    const handleVolumeUnitsModeChange = (mode)=>{
        setProductionGraphView(mode);
        setGraphMode(mode);
    };
    const handleShowLabelsSelection = (mode)=>{
        setProductionLabels(mode);
        setIsShowChartColumnLabels(mode);
    };
    const graphData = (0, $acw62.useMemo)(()=>(0, $bGkwn.calculateChartData)(chartData || {}), [
        chartData
    ]);
    const dataIndexes = (0, $acw62.useMemo)(()=>{
        return (0, $bGkwn.getChartDataIndexes)({
            timePeriod: timePeriod,
            chartData: graphData
        });
    }, [
        timePeriod,
        graphData
    ]);
    const memoChartGraph = (0, $acw62.useMemo)(()=>{
        if (!timePeriod || !dataIndexes || !graphData) return null;
        const graphProps = (0, $bGkwn.getOverviewGraphProps)({
            chartData: graphData || [],
            timePeriod: timePeriod,
            dataIndexes: dataIndexes,
            widthPixelsOutsideGraph: 100,
            graphMode: graphMode
        });
        const dataToMap = graphData?.slice(dataIndexes.lastPeriodStart, dataIndexes.lastPeriodFinish + 1);
        const timePeriodInterval = [
            dataToMap[0].month,
            dataToMap[dataToMap.length - 1].month
        ];
        setSummaryTimePeriodData(getSummaryTableData(dataToMap));
        const sortedData = sortProductionTableData(dataToMap).map((term)=>({
                ...term,
                agentId: agentId,
                chartMode: (0, $147dc1a4bec01de2$export$36b7723857d3a645).TABLE
            }));
        setTableTimePeriodData(sortedData);
        const formattedSearchResults = (0, $fPGDZ.getDataWithTotalsRow)(sortedData?.map((p)=>({
                ...p,
                month: (0, $htzEo.monthAndYearFormat)(p.month)
            })).reverse());
        setAgentProfileProductionTableData(formattedSearchResults);
        setCurrentIntervalTimePeriod((0, $60634583ab814cee$export$830d293300b6d56d)(timePeriodInterval, timePeriod));
        if (isActive) {
            setShouldStickyFooterHide(false);
            const dataForParent = {
                data: sortedData,
                currentIntervalDates: timePeriodInterval,
                gridRef: gridRef,
                tableChartMode: tableChartMode
            };
            sendToParent(dataForParent);
        }
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $59GDU.OverviewChartGraph), {
            ...graphProps,
            isShowColumnLabels: isShowChartColumnLabels,
            handleClickChartGraph: handleClickChartGraph,
            currentTabIndex: currentTabIndex
        });
    }, [
        timePeriod,
        graphMode,
        chartData,
        dataIndexes,
        tableChartMode,
        isActive,
        isShowChartColumnLabels
    ]);
    const isDataNotLoaded = isLoading || !dataIndexes;
    const chartGraph = isDataNotLoaded ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {}) : memoChartGraph;
    const getSummaryDetails = (data, tips)=>{
        const summaryDetails = [];
        summaryDetails.push({
            volume: data.listVolume,
            units: data.listUnits,
            tip: tips.summaryListSide,
            dataLwtId: "list"
        });
        summaryDetails.push({
            volume: data.sellVolume,
            units: data.sellUnits,
            tip: tips.summarySellSide,
            dataLwtId: "sell"
        });
        summaryDetails.push({
            volume: data.totalVolume,
            units: data.totalUnits,
            tip: tips.summaryTotal,
            dataLwtId: "total"
        });
        return summaryDetails;
    };
    const summaryDetails = getSummaryDetails(summaryTimePeriodData, (0, $eHBjM.productionTableTabToolTips));
    const propsSummary = (0, $acw62.useMemo)(()=>{
        const summary = graphData && dataIndexes && graphMode ? (0, $60634583ab814cee$export$daca81188ad23fe3)({
            graphData: graphData,
            dataIndexes: dataIndexes,
            graphMode: graphMode
        }) : null;
        setProductionSummary(summary);
        return summary;
    }, [
        graphData,
        dataIndexes,
        graphMode
    ]);
    const shouldShowSummaryRow = !isLoading && timePeriod;
    /* This 'bridge-purpose' component will force 'Table' to re-render all table rows and thereby all the
    * anchor tag urls will contain updated 'intervalType' query according to the timePeriod selected option.
    * When user clicks an updated anchor tag the triggered 'Recruiting_agent_listing_detail_drilldown' endpoint
    * will get data just for the selected timePeriod, e.g. Last6Months, Annually, Last24Months. */ const TableBridge = ({ tableView: tableView, rowData: rowData, externalParams: externalParams, tableTitleWithTooltips: tableTitleWithTooltips })=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l05Px.default), {
            tableView: tableView,
            rowData: rowData,
            externalParams: externalParams,
            tableTitleWithTooltips: tableTitleWithTooltips,
            gridRef: gridRef
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "d-flex flex-column",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "controls-container mb-3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $147dc1a4bec01de2$export$2e2bcd8739ae039), {
                        defaultMode: tableChartMode,
                        parentSetMode: (m)=>(0, $ivaD7.setStateData)("productionMode", m, setState),
                        mlsName: isXamInternalUser ? membership?.find((p)=>p?.mlsId === agentMetricsMlsId)?.shortDescription : state.mlsName
                    }),
                    tableChartMode === (0, $147dc1a4bec01de2$export$36b7723857d3a645).TABLE && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "font-weight-bold gray-text",
                        children: currentIntervalTimePeriod
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "d-flex justify-content-end align-items-center flex-wrap",
                        style: {
                            gap: "8px"
                        },
                        children: [
                            tableChartMode === (0, $147dc1a4bec01de2$export$36b7723857d3a645).CHART && /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1BYDb))), {
                                dataLwtId: "areaPercentageCheckbox",
                                type: "checkbox",
                                checked: isShowChartColumnLabels,
                                id: "productionLabelsCheckbox",
                                label: graphMode === (0, $bGkwn.chartModes).UNITS ? (0, $g3CkB.getElementTooltip)((0, $eHBjM.productionTableTabToolTips).unitsCheckBox) : (0, $g3CkB.getElementTooltip)((0, $eHBjM.productionTableTabToolTips).volumeCheckBox),
                                onChange: ()=>handleShowLabelsSelection(!isShowChartColumnLabels)
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0fad71a469270d71$export$2e2bcd8739ae039), {
                                options: timePeriodSelector.timePeriodOptions,
                                currentValue: timePeriodSelector.currentValue,
                                setTimePeriod: timePeriodSelector.setTimePeriod,
                                isDisabled: timePeriodSelector.isDisabled
                            }),
                            tableChartMode === (0, $147dc1a4bec01de2$export$36b7723857d3a645).CHART && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a6be97feeb3a9d43$export$2e2bcd8739ae039), {
                                parentSetMode: handleVolumeUnitsModeChange,
                                defaultMode: graphMode
                            })
                        ]
                    })
                ]
            }),
            tableChartMode === (0, $147dc1a4bec01de2$export$36b7723857d3a645).TABLE ? /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    isPDFLoading && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "pdf-chart pdf-chart-agent-detail",
                        children: chartGraph
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mb-3",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($iDoBR))), {
                            dataLwtId: "agent-profile-production-card-detail",
                            className: "agent-profile-production-summary-table",
                            type: "group",
                            children: summaryDetails?.map(({ volume: volume, units: units, tip: tip, dataLwtId: dataLwtId }, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "summary-card-wrapper",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1fd7ccae28acc2c0$export$a12cb01701b6e255), {
                                        id: dataLwtId,
                                        value: volume?.toString(),
                                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                (0, $g3CkB.getElementTooltip)(tip, true),
                                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                                    className: "helix-body",
                                                    children: [
                                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                                            className: "mb-1 text-nowrap helix-display-x-small",
                                                            children: [
                                                                (0, $htzEo.getCurrencyFormat)(volume),
                                                                /*#__PURE__*/ (0, $ayMG0.jsx)("br", {})
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                            className: "font-weight-bold",
                                                            children: `${units} ${(0, $cstaF.agentProductionTerms).units}`
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                }, index))
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)(TableBridge, {
                        tableView: (0, $4tbBr.tableViews).agentDetailProduction,
                        rowData: tableTimePeriodData,
                        externalParams: {
                            timePeriod: timePeriod,
                            productionGraphMode: productionGraphMode
                        },
                        tableTitleWithTooltips: (0, $eHBjM.productionTableTabToolTips)
                    })
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mb-2",
                        children: shouldShowSummaryRow && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6281442acb41944d$export$2e58c2d5c54ab58d), {
                            ...propsSummary
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "agent-contact-chart-wrapper py-4 px-2",
                        children: chartGraph
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "hidden-export-table",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)(TableBridge, {
                            tableView: (0, $4tbBr.tableViews).agentDetailProduction,
                            rowData: tableTimePeriodData,
                            externalParams: {
                                timePeriod: timePeriod,
                                productionGraphMode: productionGraphMode
                            },
                            tableTitleWithTooltips: (0, $eHBjM.productionTableTabToolTips)
                        })
                    })
                ]
            })
        ]
    });
};
var $cf0deb29d93490f5$export$2e2bcd8739ae039 = $cf0deb29d93490f5$var$ProductionTab;




var $ivaD7 = parcelRequire("ivaD7");


var $htzEo = parcelRequire("htzEo");

var $eHBjM = parcelRequire("eHBjM");

var $5GRJ8 = parcelRequire("5GRJ8");

var $cstaF = parcelRequire("cstaF");


var $5GRJ8 = parcelRequire("5GRJ8");
const $8bb90f3c21ded803$var$getFilename = ({ agent: agent, mlsName: mlsName, dates: dates })=>{
    const dateStart = (0, $5GRJ8.getParsedDate)(dates[0]);
    const dateFinish = (0, $5GRJ8.getParsedDate)(dates[1]);
    const periodStart = (0, $5GRJ8.getDateForAgentProductionFilename)(dateStart), periodFinish = (0, $5GRJ8.getDateForAgentProductionFilename)(dateFinish);
    return (0, $cstaF.agentProductionTemplates).exportFilenames.production.replace("[AGENT_NAME]", agent?.agentName ?? "Agent").replace("[MLS_NAME]", mlsName).replace("[PERIOD_START]", periodStart).replace("[PERIOD_FINISH]", periodFinish) + ".csv";
};
const $8bb90f3c21ded803$var$getContentForExport = (data)=>{
    const apt = (0, $cstaF.agentProductionTerms);
    const headers = [
        {
            label: apt.month,
            key: "month"
        },
        {
            label: apt.listNumber,
            key: "listUnits"
        },
        {
            label: apt.listDollars,
            key: "listVolume"
        },
        {
            label: apt.sellNumber,
            key: "sellUnits"
        },
        {
            label: apt.sellDollars,
            key: "sellVolume"
        },
        {
            label: apt.totalNumber,
            key: "totalUnits"
        },
        {
            label: apt.totalDollars,
            key: "totalVolume"
        }
    ];
    const mappedData = data.map((d)=>{
        const parsedDate = (0, $5GRJ8.getParsedDate)(d.month);
        const dateForExport = (0, $5GRJ8.getDateForTable)(parsedDate);
        return {
            month: dateForExport,
            listUnits: d.listUnits,
            listVolume: d.listVolume,
            sellUnits: d.sellUnits,
            sellVolume: d.sellVolume,
            totalUnits: d.totalUnits,
            totalVolume: d.totalVolume
        };
    });
    return {
        headers: headers,
        data: mappedData
    };
};
const $8bb90f3c21ded803$export$fffd2ec7c8817fdd = ({ data: data, agent: agent, mlsName: mlsName, dates: dates, tableChartMode: tableChartMode })=>{
    if (!data || !data.length) return {
        isVisible: false
    };
    const filename = $8bb90f3c21ded803$var$getFilename({
        agent: agent,
        mlsName: mlsName,
        dates: dates
    });
    const dataForExport = $8bb90f3c21ded803$var$getContentForExport(data);
    return {
        headers: dataForExport.headers,
        data: dataForExport.data,
        filename: filename,
        isVisible: tableChartMode === (0, $147dc1a4bec01de2$export$36b7723857d3a645).TABLE
    };
};



var $cstaF = parcelRequire("cstaF");

var $htzEo = parcelRequire("htzEo");

var $5GRJ8 = parcelRequire("5GRJ8");
const $34862ccd5c463f6a$var$getFilename = ({ agent: agent, mlsName: mlsName, date: date })=>{
    const dateForFilename = (0, $5GRJ8.getDateForFilename)(date);
    return (0, $cstaF.agentProductionTemplates).exportFilenames.inventory.replace("[AGENT_NAME]", agent?.agentName ?? "Agent").replace("[SEARCH_AREA/MLS_NAME]", mlsName).replace("[DOWNLOAD_DATE]", dateForFilename) + ".csv";
};
const $34862ccd5c463f6a$var$getContentForExport = (data)=>{
    const apt = (0, $cstaF.agentProductionTerms);
    const headers = [
        {
            label: apt.type,
            key: "typeName"
        },
        {
            label: apt.address,
            key: "address"
        },
        {
            label: apt.city,
            key: "city"
        },
        {
            label: apt.zip,
            key: "zipCode"
        },
        {
            label: apt.originalPrice,
            key: "orgPrice"
        },
        {
            label: apt.listPrice,
            key: "listPrice"
        },
        {
            label: apt.numPriceChanges,
            key: "priceChangeCnt"
        },
        {
            label: apt.listDate,
            key: "dateList"
        },
        {
            label: apt.ucDate,
            key: "dateCont"
        },
        {
            label: apt.daysUnderContract,
            key: "duc"
        },
        {
            label: apt.cdom,
            key: "cdom"
        },
        {
            label: apt.status,
            key: "statusCode"
        },
        {
            label: apt.bd,
            key: "bedrooms"
        },
        {
            label: apt.ba,
            key: "fullBaths"
        },
        {
            label: apt.sqft,
            key: "squareFt"
        },
        {
            label: apt.dollarsPerSqft,
            key: "dollarPerSquareFt"
        },
        {
            label: apt.lotSizeAcres,
            key: "lotSizeAcres"
        },
        {
            label: apt.yearBuilt,
            key: "yearBuilt"
        },
        {
            label: apt.mlsNum,
            key: "mlsNum"
        }
    ];
    const mappedData = data.map((d)=>{
        return {
            typeName: d.typeName,
            address: d.address,
            city: d.city,
            zipCode: d.zipCode,
            orgPrice: d.orgPrice,
            listPrice: d.listPrice,
            priceChangeCnt: d.priceChangeCnt,
            dateList: d.dateList,
            dateCont: d.dateCont,
            duc: d.duc,
            cdom: d.cdom,
            statusCode: d.statusCode,
            bedrooms: d.bedrooms,
            fullBaths: d.fullBaths,
            squareFt: d.squareFt,
            dollarPerSquareFt: (0, $htzEo.getUngroupedNoDecimals)(d.dollarPerSquareFt),
            lotSizeAcres: (0, $htzEo.getUngroupedMax2Decimals)(d.lotSizeAcres),
            yearBuilt: d.yearBuilt,
            mlsNum: d.mlsNum
        };
    });
    return {
        headers: headers,
        data: mappedData
    };
};
const $34862ccd5c463f6a$export$fffd2ec7c8817fdd = ({ data: data, agent: agent, mlsName: mlsName, isShowExportButton: isShowExportButton })=>{
    if (!data || !data.length) return {
        isVisible: false
    };
    const filename = $34862ccd5c463f6a$var$getFilename({
        agent: agent,
        mlsName: mlsName,
        date: new Date()
    });
    const dataForExport = $34862ccd5c463f6a$var$getContentForExport(data);
    return {
        headers: dataForExport.headers,
        data: dataForExport.data,
        filename: filename,
        isVisible: isShowExportButton
    };
};



var $cstaF = parcelRequire("cstaF");

var $eHBjM = parcelRequire("eHBjM");

var $htzEo = parcelRequire("htzEo");

var $5GRJ8 = parcelRequire("5GRJ8");

const $c8b36919e7fca0a1$var$getFilename = ({ agent: agent, mlsName: mlsName, date: date, statusType: statusType })=>{
    const dateForFilename = (0, $5GRJ8.getDateForFilename)(date);
    return (0, $cstaF.agentProductionTemplates).exportFilenames.transactionCoverage.replace("[AGENT_NAME]", agent?.agentName ?? "Agent").replace("[DEAL_STATUS]", statusType.label).replace("[SEARCH_AREA/MLS_NAME]", mlsName).replace("[DOWNLOAD_DATE]", dateForFilename) + ".csv";
};
const $c8b36919e7fca0a1$var$getContentForExport = (data, area, statusType)=>{
    const apt = (0, $cstaF.agentProductionTerms);
    const headers = {
        [(0, $eHBjM.dealStatusCodes).SOLD.value]: [
            {
                label: [
                    area
                ],
                key: "area"
            },
            {
                label: apt.listNumber,
                key: "listUnits"
            },
            {
                label: apt.listDollars,
                key: "listVolume"
            },
            {
                label: apt.sellNumber,
                key: "sellUnits"
            },
            {
                label: apt.sellDollars,
                key: "sellVolume"
            },
            {
                label: apt.totalNumber,
                key: "totalUnits"
            },
            {
                label: apt.totalDollars,
                key: "totalVolume"
            },
            {
                label: apt.totalNumberPct,
                key: "totalUnitsPct"
            },
            {
                label: apt.totalDollarsPct,
                key: "totalVolumePct"
            }
        ],
        [(0, $eHBjM.dealStatusCodes).ACTIVE.value]: [
            {
                label: [
                    area
                ],
                key: "area"
            },
            {
                label: "Currently For Sale #",
                key: "totalUnits"
            },
            {
                label: "Currently For Sale $",
                key: "totalVolume"
            },
            {
                label: apt.totalNumberPct,
                key: "totalUnitsPct"
            },
            {
                label: apt.totalDollarsPct,
                key: "totalVolumePct"
            }
        ],
        [(0, $eHBjM.dealStatusCodes).UNDER_CONTRACT.value]: [
            {
                label: [
                    area
                ],
                key: "area"
            },
            {
                label: "Currently Under Contract #",
                key: "totalUnits"
            },
            {
                label: "Currently Under Contract $",
                key: "totalVolume"
            },
            {
                label: apt.totalNumberPct,
                key: "totalUnitsPct"
            },
            {
                label: apt.totalDollarsPct,
                key: "totalVolumePct"
            }
        ]
    }[statusType.value];
    const mappedData = statusType.value === (0, $eHBjM.dealStatusCodes).SOLD.value ? data.map((d)=>{
        return {
            area: d.area,
            listUnits: (0, $htzEo.formatUnitOrPercentage)(d.listUnits, true),
            listVolume: d.listVolume,
            sellUnits: (0, $htzEo.formatUnitOrPercentage)(d.sellUnits, true),
            sellVolume: d.sellVolume,
            totalUnits: (0, $htzEo.formatUnitOrPercentage)(d.totalUnits, true),
            totalVolume: d.totalVolume,
            totalUnitsPct: (0, $htzEo.addPctSymbol)((0, $htzEo.getUngrouped2Decimals)(d.totalUnitsPct)),
            totalVolumePct: (0, $htzEo.addPctSymbol)((0, $htzEo.getUngrouped2Decimals)(d.totalVolumePct))
        };
    }) : data.map((d)=>{
        return {
            area: d.area,
            totalUnits: (0, $htzEo.formatUnitOrPercentage)(d.totalUnits, true),
            totalVolume: (0, $htzEo.formatUnitOrPercentage)(d.totalVolume, true),
            totalUnitsPct: (0, $htzEo.addPctSymbol)((0, $htzEo.getUngrouped2Decimals)(d.totalUnitsPct)),
            totalVolumePct: (0, $htzEo.addPctSymbol)((0, $htzEo.getUngrouped2Decimals)(d.totalVolumePct))
        };
    });
    return {
        headers: headers,
        data: mappedData
    };
};
const $c8b36919e7fca0a1$export$fffd2ec7c8817fdd = ({ data: data, agent: agent, mlsName: mlsName, tableChartMode: tableChartMode, statusType: statusType, area: area })=>{
    if (!data || !data.length || !agent) return {
        isVisible: false
    };
    const filename = $c8b36919e7fca0a1$var$getFilename({
        agent: agent,
        mlsName: mlsName,
        date: new Date(),
        statusType: statusType
    });
    if (!filename) return {
        isVisible: false
    };
    const dataForExport = $c8b36919e7fca0a1$var$getContentForExport(data, area, statusType);
    return {
        headers: dataForExport.headers,
        data: dataForExport.data,
        filename: filename,
        isVisible: tableChartMode === (0, $147dc1a4bec01de2$export$36b7723857d3a645).TABLE
    };
};



var $bGkwn = parcelRequire("bGkwn");

var $c7dF9 = parcelRequire("c7dF9");

var $b77Er = parcelRequire("b77Er");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $cstaF = parcelRequire("cstaF");

var $4tbBr = parcelRequire("4tbBr");

var $l05Px = parcelRequire("l05Px");

var $eHBjM = parcelRequire("eHBjM");
const $7e010ba1a4be84e7$var$OfficeHistoryTab = ({ agent: agent, isActive: isActive, sendToParent: sendToParent, setShouldStickyFooterHide: setShouldStickyFooterHide })=>{
    const getOfficeHistoryData = ()=>{
        const officeHistoryData = agent?.history?.history?.map((office)=>({
                ...office,
                display: true
            })) || [];
        officeHistoryData?.push({
            moveDate: new Date().toISOString(),
            officeId: agent.officeId,
            officeName: agent.officeName,
            display: false
        });
        return officeHistoryData;
    };
    (0, $acw62.useEffect)(()=>{
        if (!isActive) return;
        setShouldStickyFooterHide(true);
        sendToParent();
    }, [
        isActive
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "mt-4",
            children: !getOfficeHistoryData().length && !agent.officeName.length ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "no-Office-data",
                children: (0, $cstaF.agentProductionTerms).officeHistoryNoData
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l05Px.default), {
                tableView: (0, $4tbBr.tableViews).officeHistory,
                rowData: getOfficeHistoryData(),
                tableTitleWithTooltips: (0, $eHBjM.officeHistoryTooltips)
            })
        })
    });
};
$7e010ba1a4be84e7$var$OfficeHistoryTab.propTypes = {
    agent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    isActive: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    sendToParent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};
var $7e010ba1a4be84e7$export$2e2bcd8739ae039 = $7e010ba1a4be84e7$var$OfficeHistoryTab;



var $90ISC = parcelRequire("90ISC");


var $bA5Mi = parcelRequire("bA5Mi");


var $i95vK = parcelRequire("i95vK");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $f61ig = parcelRequire("f61ig");

var $7tOHe = parcelRequire("7tOHe");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
const $f5421133b9d89441$export$f4422ae58352e179 = ({ id: id, name: name, labelText: labelText, description: description, disabled: disabled, isChecked: isChecked, handleSelection: handleSelection })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
        htmlFor: id,
        className: `download-radio-button ${isChecked && !disabled ? "border-primary" : "border-secondary"}`,
        onClick: handleSelection,
        disabled: isChecked,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "d-flex justify-content-between align-items-center",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h6", {
                        className: "text-muted",
                        children: labelText
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        id: id,
                        name: name,
                        type: "radio",
                        checked: isChecked,
                        disabled: disabled,
                        onChange: handleSelection,
                        readOnly: disabled
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                children: description
            })
        ]
    });
$f5421133b9d89441$export$f4422ae58352e179.propTypes = {
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    labelText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    description: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    isChecked: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    handleSelection: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired
};



var $cstaF = parcelRequire("cstaF");

var $bA5Mi = parcelRequire("bA5Mi");

var $kLrt8 = parcelRequire("kLrt8");

var $c9Z8w = parcelRequire("c9Z8w");

var $6M53k = parcelRequire("6M53k");
const $9b760a8ddf238ef9$export$a1bb54ba7ed9cdd6 = ({ shouldShowAreaSelector: shouldShowAreaSelector })=>{
    const { isPdfUnderConstruction: isPdfUnderConstruction } = (0, $kLrt8.useFeatureToggles)();
    const { downloadModalStatus: downloadModalStatus, setDownloadModalStatus: setDownloadModalStatus, areasData: areasData, handleCheckArea: handleCheckArea } = (0, $bA5Mi.usePDFStore)((state)=>{
        const areasData = state?.areasData || [];
        return {
            downloadModalStatus: state.downloadModalStatus,
            setDownloadModalStatus: state.setDownloadModalStatus,
            areasData: areasData,
            handleCheckArea: state.handleCheckArea
        };
    });
    const isCsvSelected = downloadModalStatus.fileType === (0, $cstaF.downloadFileTypes).csv;
    const isPdfSelected = downloadModalStatus.fileType === (0, $cstaF.downloadFileTypes).pdf;
    const areasSelected = areasData.filter((area)=>area.checked).length;
    const isAreasPdfDisabled = shouldShowAreaSelector && isPdfSelected && areasSelected < (0, $6M53k.COVERAGE_AREA_MIN_COUNT_SELECTIONS);
    const handleClose = ()=>{
        setDownloadModalStatus({
            [(0, $cstaF.downloadModalTerms).isOpen]: false,
            [(0, $cstaF.downloadModalTerms).fileType]: (0, $cstaF.downloadFileTypes).csv
        });
    };
    const handleDownload = ()=>{
        if (downloadModalStatus?.isPDFLoading) return;
        downloadModalStatus.clickAction();
        isCsvSelected && handleClose();
    };
    const handleSelection = (e)=>{
        const radioId = e.target.tagName === "INPUT" && e.target.id;
        if (radioId) setDownloadModalStatus({
            [(0, $cstaF.downloadModalTerms).fileType]: radioId.split("-")[0]
        });
    };
    const handleAreaOptionClick = ({ target: target })=>handleCheckArea(target.id, target.checked);
    const modalButtons = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            isAreasPdfDisabled && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "m-0 mr-3 text-danger font-weight-bold",
                children: (0, $cstaF.downloadModalTerms).noCoverageAreasSelected
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                dataLwtId: "modal-btn-cancel",
                color: "secondary",
                disabled: downloadModalStatus.isPDFLoading,
                onClick: handleClose,
                children: (0, $cstaF.buttonTerms).cancel
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                dataLwtId: "modal-btn-download",
                color: "primary",
                disabled: downloadModalStatus.isPDFLoading || isAreasPdfDisabled,
                onClick: handleDownload,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "d-flex justify-content-center align-items-center xs-spinner",
                    children: [
                        downloadModalStatus.isPDFLoading && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {}),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "pl-2 pr-1 m-0",
                            children: (0, $cstaF.buttonTerms).download
                        })
                    ]
                })
            })
        ]
    });
    const selectedAreasDataCount = areasData?.filter((area)=>area.checked)?.length;
    const pdfReportDescription = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            (0, $cstaF.downloadModalTerms).pdfDescription,
            /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
            shouldShowAreaSelector && /*#__PURE__*/ (0, $ayMG0.jsx)("small", {
                className: "coverage-disclaimer",
                children: (0, $cstaF.downloadModalTerms).coverageAreaDisclaimer
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $f61ig.default), {
        title: (0, $cstaF.buttonTerms).download,
        size: "lg",
        show: downloadModalStatus.isPDFLoading || downloadModalStatus.isOpen,
        onClose: !downloadModalStatus.isPDFLoading ? handleClose : ()=>{},
        buttons: modalButtons,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                children: (0, $cstaF.downloadModalTerms).choseType
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "d-flex justify-content-between align-items-center mt-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f5421133b9d89441$export$f4422ae58352e179), {
                        id: "csv-radio",
                        name: "fileType",
                        labelText: (0, $cstaF.downloadModalTerms).csvLabel,
                        description: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                (0, $cstaF.downloadModalTerms).csvDescription,
                                shouldShowAreaSelector && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                        "\xa0"
                                    ]
                                })
                            ]
                        }),
                        isChecked: isCsvSelected,
                        handleSelection: handleSelection,
                        disabled: downloadModalStatus.isPDFLoading,
                        shouldShowAreaSelector: shouldShowAreaSelector
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f5421133b9d89441$export$f4422ae58352e179), {
                        id: "pdf-radio",
                        name: "fileType",
                        labelText: (0, $cstaF.downloadModalTerms).pdfLabel,
                        description: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                            children: isPdfUnderConstruction ? (0, $cstaF.downloadModalTerms).comingSoon : pdfReportDescription
                        }),
                        isChecked: isPdfSelected,
                        handleSelection: handleSelection,
                        disabled: isPdfUnderConstruction || downloadModalStatus.isPDFLoading
                    })
                ]
            }),
            isPdfSelected && shouldShowAreaSelector && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "mt-3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                        children: (0, $cstaF.downloadModalTerms).chooseCoverageArea
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("h6", {
                        children: [
                            (0, $cstaF.downloadModalTerms).coverageAreas,
                            " (",
                            selectedAreasDataCount,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "areas-select-container",
                        children: (0, $6M53k.getRenderedStatusOptions)(areasData, handleAreaOptionClick, areasSelected, (0, $6M53k.COVERAGE_AREA_MAX_COUNT_SELECTIONS))
                    })
                ]
            })
        ]
    });
};
$9b760a8ddf238ef9$export$a1bb54ba7ed9cdd6.propTypes = {
    shouldShowAreaSelector: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};



var $c9Z8w = parcelRequire("c9Z8w");

var $dDBOF = parcelRequire("dDBOF");

var $fPGDZ = parcelRequire("fPGDZ");

var $3T9wI = parcelRequire("3T9wI");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $kfZjc = parcelRequire("kfZjc");

var $4TPr9 = parcelRequire("4TPr9");

var $90ISC = parcelRequire("90ISC");

var $8U25g = parcelRequire("8U25g");

var $c7dF9 = parcelRequire("c7dF9");

var $c9Z8w = parcelRequire("c9Z8w");
const $0599250ef8da3fea$var$XamAgentSelector = ({ setState: setState, setSelectedAgentId: setSelectedAgentId, agentMetricsAgentId: agentMetricsAgentId, agentIdQuery: agentIdQuery })=>{
    const history = (0, $kfZjc.useHistory)();
    const { xamSelectedAgent: xamSelectedAgent, getAgentInfo: getAgentInfo } = (0, $90ISC.useCommonStore)((state)=>{
        const mlsAgent = state?.agentInfo?.[0]?.mlsAgentId;
        const xamSelectedAgent = (0, $8U25g.topPerformerAgentsOptions).filter((agent)=>agent.agentId === mlsAgent?.agentId)[0];
        return {
            xamSelectedAgent: xamSelectedAgent,
            getAgentInfo: state.getAgentInfo
        };
    });
    const [selectedAgent, setSelectedAgent] = (0, $acw62.useState)(null);
    const handleChange = async (value)=>{
        if (value.agentId === agentMetricsAgentId) return;
        if (agentIdQuery === agentMetricsAgentId) history.replace(`${(0, $c7dF9.Routes).AGENT_PRODUCTION.BASE}`);
        const agentInfoPayload = [
            {
                agentId: value.agentId,
                mlsId: value.mlsId
            }
        ];
        setState((prevState)=>({
                ...prevState,
                mlsId: value.mlsId,
                agentId: value.agentId,
                agent: {
                    agentId: value.agentId,
                    agentName: value.agentName,
                    id: value.agentId,
                    mlsSid: value.mlsId,
                    officeName: value.officeName
                }
            }));
        setSelectedAgent((0, $8U25g.topPerformerAgentsOptions).filter((agent)=>agent.agentId === value.agentId)[0]);
        setSelectedAgentId(value.agentId);
        await getAgentInfo(agentInfoPayload);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "d-flex mt-3 ml-1",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4TPr9.default), {
            className: "xam-agent-selector",
            isClearable: false,
            value: selectedAgent ?? xamSelectedAgent,
            options: (0, $8U25g.topPerformerAgentsOptions),
            onChange: handleChange
        })
    });
};
$0599250ef8da3fea$var$XamAgentSelector.propTypes = {
    setState: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    setSelectedAgentId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    agentMetricsAgentId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    agentIdQuery: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};
var $0599250ef8da3fea$export$2e2bcd8739ae039 = $0599250ef8da3fea$var$XamAgentSelector;


const $694a1c0f59c8cc58$var$ChartTabWrapper = ({ children: children })=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        style: {
            width: "100%"
        },
        children: children
    });
const $694a1c0f59c8cc58$var$AgentProfile = ({ agentData: agentData, module: module, mlsProps: mlsProps, tokenInfo: tokenInfo })=>{
    const isXamInternalUser = (0, $dDBOF.isAgentMetrics) && (0, $3T9wI.getIsInternalEmailAddress)(tokenInfo?.email);
    const isAgMovement = module === (0, $cstaF.modules).proficiencyMetrics.agentMovement;
    const agentProfileData = isAgMovement ? agentData?.agMovAgentBreakdownSearch : agentData;
    const query = (0, $bq4QZ.useQuery)();
    const agentId = query.get("id");
    const chosenIndex = parseInt(query.get("tabIndex"));
    const graphModeParam = query.get("graph");
    const chartModeParam = query.get("chartMode");
    const queryIntervalType = query.get("timeInterval");
    const queryIsShowBarLabels = query.get("isShowBarLabels") !== "false";
    const history = (0, $kfZjc.useHistory)();
    const { setSelectedAgentId: setSelectedAgentId } = (0, $90ISC.useAgentProfileStore)((state)=>({
            setSelectedAgentId: state.setSelectedAgentId
        }));
    const { membership: membership, setAgentDetailNavigation: setAgentDetailNavigation, agentMetricsAgentId: agentMetricsAgentId, agentMetricsMlsId: agentMetricsMlsId } = (0, $90ISC.useCommonStore)((state)=>{
        const mlsAgent = state?.agentInfo?.[0]?.mlsAgentId;
        return {
            membership: state.membership,
            setAgentDetailNavigation: state.setAgentDetailNavigation,
            agentMetricsAgentId: mlsAgent?.agentId,
            agentMetricsMlsId: mlsAgent?.mlsId
        };
    });
    const { search: search, loadedSearchCriteria: loadedSearchCriteria } = (0, $90ISC.useSearchStore)((state)=>({
            search: state[module]?.search,
            loadedSearchCriteria: state[module]?.loadedSearchCriteria
        }));
    const { timeIntervals: timeIntervals } = (0, $90ISC.useCommonStore)((state)=>({
            timeIntervals: state.timeIntervals
        }));
    const { setAgentProfileExportDetails: setAgentProfileExportDetails, setAgentProfileTabIndex: setAgentProfileTabIndex, setAgentProfileTimePeriod: setAgentProfileTimePeriod } = (0, $bA5Mi.usePDFStore)((state)=>({
            setAgentProfileExportDetails: state.setAgentProfileExportDetails,
            setAgentProfileTabIndex: state.setAgentProfileTabIndex,
            setAgentProfileTimePeriod: state.setAgentProfileTimePeriod
        }));
    const [state, setState] = (0, $acw62.useState)({
        agent: null,
        agentsData: null,
        mlsId: agentMetricsMlsId ?? null,
        agentId: agentMetricsAgentId ?? null,
        productionTimePeriod: (0, $b77Er.getTimePeriodData)() || (0, $cstaF.TimePeriods)["Last 24 Months"],
        productionMode: chartModeParam || (0, $147dc1a4bec01de2$export$36b7723857d3a645).CHART,
        productionGraphMode: graphModeParam || (0, $bGkwn.chartModes).VOLUME,
        productionIsLabelEnabled: queryIsShowBarLabels,
        transactionTimePeriod: (0, $cstaF.TimePeriods)["Last 12 Months"],
        transactionCoverageMode: (0, $147dc1a4bec01de2$export$36b7723857d3a645).CHART,
        currentTabIndex: chosenIndex ? chosenIndex : (0, $eHBjM.agentProfileTabs).PRODUCTION,
        isShowTimePeriodSelector: chosenIndex !== (0, $eHBjM.agentProfileTabs).INVENTORY,
        currentListingMonth: null,
        isTimePeriodSelectorDisabled: false,
        searchCriteria: null,
        mlsName: null,
        exportProps: {
            headers: null,
            data: null,
            filename: null,
            isVisible: false
        },
        shouldStickyFooterHide: false
    });
    (0, $acw62.useEffect)(()=>{
        setSelectedAgentId(agentId);
    }, [
        agentId
    ]);
    const xamAgentSelectorProps = {
        setState: setState,
        setSelectedAgentId: setSelectedAgentId,
        agentMetricsAgentId: agentMetricsAgentId,
        agentIdQuery: agentId
    };
    const setShouldStickyFooterHide = (shouldHide)=>(0, $ivaD7.setStateData)("shouldStickyFooterHide", shouldHide, setState);
    const processFromProduction = (fromProduction)=>{
        const paramsGetExportButtonProps = {
            data: sortExportData(fromProduction.data),
            dates: fromProduction.currentIntervalDates,
            tableChartMode: fromProduction.tableChartMode,
            agent: state.agent,
            gridRef: fromProduction.gridRef,
            mlsName: state.mlsName
        };
        const exportProps = (0, $8bb90f3c21ded803$export$fffd2ec7c8817fdd)(paramsGetExportButtonProps);
        return setState((prevState)=>{
            return {
                ...prevState,
                exportProps: {
                    ...exportProps,
                    gridRef: paramsGetExportButtonProps.gridRef
                }
            };
        });
    };
    const sortExportData = (exportData)=>{
        return [
            ...exportData
        ].sort((a, b)=>new Date(b.month) - new Date(a.month));
    };
    const processFromInventory = (fromInventory)=>{
        const { underContractRawData: underContractRawData, forSaleRawData: forSaleRawData, shouldShowExportButton: shouldShowExportButton, gridRef: gridRef } = fromInventory;
        const data = [];
        const transformForExport = (d)=>{
            const item = {
                ...d,
                dateList: (0, $5GRJ8.maskNullDate)(d.dateList),
                dateCont: (0, $5GRJ8.maskNullDate)(d.dateCont)
            };
            data.push(item);
        };
        forSaleRawData?.forEach(transformForExport);
        underContractRawData?.forEach(transformForExport);
        const isShowExportButton = shouldShowExportButton && !!data?.length;
        const paramsGetExportButtonProps = {
            data: data,
            agent: state.agent,
            mlsName: state.mlsName,
            isShowExportButton: isShowExportButton
        };
        const exportProps = (0, $34862ccd5c463f6a$export$fffd2ec7c8817fdd)(paramsGetExportButtonProps);
        setState((prevState)=>{
            return {
                ...prevState,
                exportProps: {
                    ...exportProps,
                    gridRef: gridRef
                }
            };
        });
    };
    const processFromTransactionCoverage = (fromTransactionCoverage)=>{
        const paramsGetExportButtonProps = {
            data: fromTransactionCoverage.data,
            area: fromTransactionCoverage.area,
            statusType: fromTransactionCoverage.statusType,
            tableChartMode: state.transactionCoverageMode,
            agent: state.agent,
            gridRef: fromTransactionCoverage.gridRef,
            mlsName: state.mlsName
        };
        const exportProps = (0, $c8b36919e7fca0a1$export$fffd2ec7c8817fdd)(paramsGetExportButtonProps);
        setState((prevState)=>{
            return {
                ...prevState,
                exportProps: {
                    ...exportProps,
                    gridRef: paramsGetExportButtonProps.gridRef
                }
            };
        });
    };
    const processFromOfficeHistory = ()=>{
        const exportProps = {
            isVisible: false
        };
        setState((prevState)=>{
            return {
                ...prevState,
                exportProps: exportProps
            };
        });
    };
    const mlsProviders = (0, $acw62.useRef)([]);
    const shouldRender = !!module;
    (0, $acw62.useEffect)(()=>{
        if (!shouldRender) history.push("/");
    }, []);
    (0, $acw62.useEffect)(()=>{
        mlsProviders.current = membership;
    }, [
        membership
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!shouldRender) return;
        const mlsId = (0, $dDBOF.isAgentMetrics) ? agentMetricsMlsId : search?.mlsId;
        if (mlsId && Array.isArray(mlsProviders.current) && mlsProviders.current.length) {
            const mlsName = mlsProviders.current.find((p)=>p?.mlsId === mlsId)?.shortDescription;
            (0, $ivaD7.setStateData)("mlsName", mlsName, setState);
        }
    }, [
        mlsProviders.current,
        search,
        agentMetricsMlsId
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!loadedSearchCriteria?.realEstateDatasourceIdsWithFilters?.length && !(0, $dDBOF.isAgentMetrics)) return;
        const searchCriteria = loadedSearchCriteria ?? (0, $fPGDZ.getAmSearchCriteria)(state.mlsId);
        const mlsId = searchCriteria.realEstateDatasourceIdsWithFilters[0].realEstateDatasourceId;
        const intervalType = queryIntervalType || searchCriteria.timePeriod.intervalType;
        const productionTimePeriod = (0, $b77Er.getTimePeriodData)() || (0, $cstaF.TimePeriods)["Last 24 Months"];
        const transactionTimePeriod = (0, $eHBjM.transactionCoverageOptions).some((o)=>o.value === intervalType) && intervalType || (0, $cstaF.TimePeriods)["Last 12 Months"];
        setState((prevState)=>({
                ...prevState,
                searchCriteria: searchCriteria,
                mlsId: mlsId,
                productionTimePeriod: productionTimePeriod,
                transactionTimePeriod: transactionTimePeriod,
                agentId: agentId ?? state.agentId
            }));
    }, [
        loadedSearchCriteria
    ]);
    (0, $acw62.useEffect)(()=>{
        const revisedAgentData = (0, $htzEo.mapIdToTableData)(agentProfileData);
        (0, $ivaD7.setStateData)("agentsData", revisedAgentData || [], setState);
    }, [
        agentProfileData
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!shouldRender) return;
        const idParam = new URL(window.location.href).searchParams.get("id") ?? state.agentId;
        if (state.agentsData != null) {
            const agentFound = state.agentsData.find((agent)=>agent.agentId === idParam);
            if (agentFound || (0, $dDBOF.isAgentMetrics)) (0, $ivaD7.setStateData)("agent", agentFound, setState);
            else window.location.replace((0, $c7dF9.Routes).PROF_METRICS.BASE);
        }
    }, [
        state.agentsData
    ]);
    const getExportPeriodsLabel = (exportProps)=>{
        if (state.currentTabIndex === (0, $eHBjM.agentProfileTabs).INVENTORY) return "";
        if (state.currentTabIndex === (0, $eHBjM.agentProfileTabs).TRANSACTION_COVERAGE) {
            const selectedTimeInterval = timeIntervals && timeIntervals.find((ti)=>ti.intervalType === state.transactionTimePeriod);
            const startPeriod = (0, $htzEo.monthAndYearFormat)(selectedTimeInterval?.last?.from.replace("T", " "));
            const endPeriod = (0, $htzEo.monthAndYearFormat)(selectedTimeInterval?.last?.to.replace("T", " "));
            return `${startPeriod} - ${endPeriod}`;
        }
        if (state.currentTabIndex === (0, $eHBjM.agentProfileTabs).PRODUCTION) {
            const endPeriod = (0, $htzEo.monthAndYearFormat)(exportProps?.data?.[0]?.month);
            const startPeriod = (0, $htzEo.monthAndYearFormat)(exportProps?.data?.[exportProps?.data?.length - 1]?.month);
            return `${startPeriod} - ${endPeriod}`;
        }
        return "";
    };
    const exportDetails = {
        exportType: (0, $e70e792f19abcc91$export$382f55aa456f5721).agentDetailSearchResults,
        agentName: state.agent?.agentName,
        selectedTabLabel: (0, $eHBjM.agentProfileTabNamesByIndex)[state.currentTabIndex],
        mlsName: state.mlsName,
        periods: getExportPeriodsLabel(state.exportProps),
        agentData: state.agent
    };
    (0, $acw62.useEffect)(()=>{
        const { productionTimePeriod: productionTimePeriod, transactionTimePeriod: transactionTimePeriod, currentTabIndex: currentTabIndex } = state;
        const timePeriodMap = {
            0: productionTimePeriod,
            2: transactionTimePeriod
        };
        setAgentProfileExportDetails(exportDetails);
        timePeriodMap?.[currentTabIndex] && setAgentProfileTimePeriod(timePeriodMap[currentTabIndex]);
    }, [
        state.exportProps,
        state.productionTimePeriod,
        state.transactionTimePeriod,
        state.currentTabIndex,
        state.mlsName
    ]);
    const transactionSearchCriteria = (0, $acw62.useMemo)(()=>(0, $dDBOF.isAgentMetrics) ? (0, $fPGDZ.getAmSearchCriteria)(state.mlsId) : state.searchCriteria, [
        state.mlsId,
        state.searchCriteria
    ]);
    if (!shouldRender) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {});
    const profileProps = {
        agentId: state.agentId,
        mlsId: state.mlsId,
        timePeriod: state.timePeriod,
        module: module
    };
    const agentProductionListingRoute = `${(0, $dDBOF.isAgentMetrics) ? (0, $c7dF9.Routes).AGENT_PRODUCTION.BASE : (0, $c7dF9.Routes).PROF_METRICS.BASE}${(0, $c7dF9.Routes).PROF_METRICS.PROD_LISTING}`;
    const handleClickChartGraph = (period)=>history.push(`${agentProductionListingRoute}?id=${state.agentId}` + `&period=${period}&graph=${state.productionGraphMode}` + `&chartMode=${state.productionMode}` + `&isShowBarLabels=${state.productionIsLabelEnabled}` + `&intervalType=${state.productionTimePeriod.replaceAll(" ", "")}`);
    const getIsActive = (index)=>state.currentTabIndex === index;
    const transactionCoverageProps = {
        ...profileProps,
        tableChartMode: state.transactionCoverageMode,
        searchCriteria: transactionSearchCriteria,
        timePeriod: state.transactionTimePeriod,
        agent: state.agent,
        setIsTimePeriodSelectorDisabled: (b)=>(0, $ivaD7.setStateData)("isTimePeriodSelectorDisabled", b, setState),
        sendToParent: processFromTransactionCoverage,
        isActive: getIsActive((0, $eHBjM.agentProfileTabs).TRANSACTION_COVERAGE),
        currentTabIndex: state.currentTabIndex,
        mappedAreas: mlsProps?.mappedAreas,
        setShouldStickyFooterHide: setShouldStickyFooterHide,
        setState: setState,
        transactionCoverageMode: state.transactionCoverageMode,
        mlsName: state.mlsName
    };
    const officeHistoryProps = {
        ...profileProps,
        agent: state.agent,
        setIsTimePeriodSelectorDisabled: (b)=>(0, $ivaD7.setStateData)("isTimePeriodSelectorDisabled", b, setState),
        sendToParent: processFromOfficeHistory,
        isActive: getIsActive((0, $eHBjM.agentProfileTabs).OFFICE_HISTORY),
        currentTabIndex: state.currentTabIndex,
        setShouldStickyFooterHide: setShouldStickyFooterHide
    };
    let timePeriodOptions, timePeriodToSet, currentTabPeriod;
    if (state.currentTabIndex === (0, $eHBjM.agentProfileTabs).PRODUCTION) {
        timePeriodOptions = (0, $eHBjM.productionOptions);
        timePeriodToSet = "productionTimePeriod";
        currentTabPeriod = state.productionTimePeriod;
        (0, $b77Er.setTimePeriodData)(state.productionTimePeriod);
    }
    if (state.currentTabIndex === (0, $eHBjM.agentProfileTabs).TRANSACTION_COVERAGE) {
        timePeriodOptions = (0, $eHBjM.transactionCoverageOptions);
        timePeriodToSet = "transactionTimePeriod";
        currentTabPeriod = state.transactionTimePeriod;
        (0, $b77Er.setTimePeriodData)(state.transactionTimePeriod);
    }
    const productionProps = {
        ...profileProps,
        agentData: state.agent,
        mlsId: state.mlsId,
        agentId: state.agentId,
        handleClickChartGraph: handleClickChartGraph,
        tableChartMode: state.productionMode,
        state: state,
        setState: setState,
        isXamInternalUser: isXamInternalUser,
        timePeriod: state.productionTimePeriod,
        sendToParent: processFromProduction,
        isActive: getIsActive((0, $eHBjM.agentProfileTabs).PRODUCTION),
        productionGraphMode: state.productionGraphMode,
        productionIsLabelEnabled: state.productionIsLabelEnabled,
        setProductionLabels: (mode)=>setState((prevState)=>({
                    ...prevState,
                    productionIsLabelEnabled: mode
                })),
        setProductionGraphView: (mode)=>setState((prevState)=>({
                    ...prevState,
                    productionGraphMode: mode
                })),
        currentTabIndex: state.currentTabIndex,
        setShouldStickyFooterHide: setShouldStickyFooterHide,
        timePeriodSelector: {
            timePeriodOptions: timePeriodOptions,
            currentValue: currentTabPeriod,
            setTimePeriod: (t)=>{
                (0, $b77Er.setTimePeriodData)(t);
                (0, $ivaD7.setStateData)(timePeriodToSet, t, setState);
            },
            isDisabled: state.isTimePeriodSelectorDisabled && state.currentTabIndex !== (0, $eHBjM.agentProfileTabs).PRODUCTION
        }
    };
    const setCurrentTabIndex = (currentTabIndex)=>{
        const isShowTimePeriodSelector = [
            (0, $eHBjM.agentProfileTabs).PRODUCTION,
            (0, $eHBjM.agentProfileTabs).TRANSACTION_COVERAGE
        ].includes(currentTabIndex);
        setState((prevState)=>({
                ...prevState,
                isShowTimePeriodSelector: isShowTimePeriodSelector,
                currentTabIndex: currentTabIndex
            }));
        setAgentProfileTabIndex(currentTabIndex);
        setAgentDetailNavigation({
            tabIndex: currentTabIndex
        });
    };
    const exportButton = (0, $0d036ea0861162a7$export$e89cb83db8826f3)({
        gridRef: state.exportProps.gridRef,
        type: (0, $i95vK.exportButtonTypes).primary,
        shouldUsePrimaryColumns: true,
        filename: state.currentTabIndex === (0, $eHBjM.agentProfileTabs).PRODUCTION && state.exportProps.filename,
        exportDetails: exportDetails
    });
    const hasExportData = !!state.exportProps?.data?.length;
    const shouldShowAreaSelector = state.currentTabIndex === (0, $eHBjM.agentProfileTabs).TRANSACTION_COVERAGE && hasExportData;
    const columnProps = [
        {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "footer-container-wrapper d-flex justify-content-end align-items-center",
                children: hasExportData && exportButton
            }),
            sm: 12,
            align: "right"
        }
    ];
    const chartWrapperClass = state.productionMode === (0, $147dc1a4bec01de2$export$36b7723857d3a645).CHART ? "chart-wrapper-margin" : "";
    const buildTabs = ()=>{
        const tabs = [
            {
                title: (0, $cstaF.agentProductionTerms).production,
                content: {
                    jsx: /*#__PURE__*/ (0, $ayMG0.jsx)($694a1c0f59c8cc58$var$ChartTabWrapper, {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $cf0deb29d93490f5$export$2e2bcd8739ae039), {
                            ...productionProps
                        })
                    })
                }
            },
            {
                title: (0, $cstaF.agentProductionTerms).inventory,
                content: {
                    jsx: /*#__PURE__*/ (0, $ayMG0.jsx)($694a1c0f59c8cc58$var$ChartTabWrapper, {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1bcd6cefddc1733f$export$2e2bcd8739ae039), {
                            mlsId: state.mlsId,
                            agentId: state.agentId,
                            mlsName: state.mlsName,
                            isActive: getIsActive((0, $eHBjM.agentProfileTabs).INVENTORY),
                            sendToParent: processFromInventory,
                            setShouldStickyFooterHide: setShouldStickyFooterHide
                        })
                    })
                }
            },
            {
                title: (0, $cstaF.agentProductionTerms).transactionCoverage,
                content: {
                    jsx: /*#__PURE__*/ (0, $ayMG0.jsx)($694a1c0f59c8cc58$var$ChartTabWrapper, {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ec71a1ae736ebe88$export$2e2bcd8739ae039), {
                            ...transactionCoverageProps
                        })
                    })
                }
            }
        ];
        if (!(0, $dDBOF.isAgentMetrics)) tabs.push({
            title: (0, $cstaF.agentProductionTerms).officeHistory,
            content: {
                jsx: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: state.agent && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7e010ba1a4be84e7$export$2e2bcd8739ae039), {
                            ...officeHistoryProps
                        })
                    })
                })
            }
        });
        return tabs;
    };
    const shouldDisplayTimePeriodSelector = false;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            isXamInternalUser && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0599250ef8da3fea$export$2e2bcd8739ae039), {
                ...xamAgentSelectorProps
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($e155p))), {
                className: "mx-0 my-2",
                children: [
                    state.agent && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a4e7f1cc759aedc8$export$2e2bcd8739ae039), {
                        index: state.currentTabIndex,
                        agent: state.agent,
                        setCurrentTabIndex: setCurrentTabIndex,
                        handleClickChartGraph: handleClickChartGraph,
                        module: module
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "ml-auto d-flex w-auto align-self-center",
                        children: shouldDisplayTimePeriodSelector && state.isShowTimePeriodSelector && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0fad71a469270d71$export$2e2bcd8739ae039), {
                            options: timePeriodOptions,
                            currentValue: currentTabPeriod,
                            setTimePeriod: (t)=>{
                                (0, $b77Er.setTimePeriodData)(t.target.value);
                                (0, $ivaD7.setStateData)(timePeriodToSet, t.target.value, setState);
                            },
                            isDisabled: state.isTimePeriodSelectorDisabled && state.currentTabIndex !== (0, $eHBjM.agentProfileTabs).PRODUCTION
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: `agent-detail-tabs-wrapper mt-2 pb-5 ${chartWrapperClass}`,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8f390b0d641c1be9$export$2e2bcd8739ae039), {
                    id: "agent-detail-tabs",
                    tabTextTransform: "none",
                    navSize: 2,
                    contentSize: 2,
                    className: "secondary mb-3",
                    items: buildTabs(),
                    tabs: true,
                    currentIndex: state.currentTabIndex,
                    setCurrentIndex: setCurrentTabIndex
                })
            }),
            !state.shouldStickyFooterHide && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $859b3aeec7a854d9$export$2e2bcd8739ae039), {
                columnProps: columnProps
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9b760a8ddf238ef9$export$a1bb54ba7ed9cdd6), {
                shouldShowAreaSelector: shouldShowAreaSelector
            })
        ]
    });
};
$694a1c0f59c8cc58$var$AgentProfile.propTypes = {
    agentData: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        agentId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired
    })),
    module: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    mlsProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        mappedAreas: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    }),
    tokenInfo: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        email: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired
    })
};
var $694a1c0f59c8cc58$export$2e2bcd8739ae039 = $694a1c0f59c8cc58$var$AgentProfile;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $f61ig = parcelRequire("f61ig");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $aypMh = parcelRequire("aypMh");

var $cstaF = parcelRequire("cstaF");

var $c9Z8w = parcelRequire("c9Z8w");

var $90ISC = parcelRequire("90ISC");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $dI25G = parcelRequire("dI25G");

var $eOjgM = parcelRequire("eOjgM");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $2Xlz6 = parcelRequire("2Xlz6");

var $eHBjM = parcelRequire("eHBjM");

var $c9Z8w = parcelRequire("c9Z8w");
const $663ae31d31f02628$var$DropDownOption = ({ popoverBody: popoverBody, dataLwtId: dataLwtId, mainTitle: mainTitle, popoverInnerClassName: popoverInnerClassName, popoverClassName: popoverClassName, popoverIsOpen: popoverIsOpen, popoverHeader: popoverHeader, popoverPlacement: popoverPlacement, togglePopover: togglePopover })=>{
    const mainTitleContent = typeof mainTitle === "string" ? /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
        className: "text-capitalize",
        children: mainTitle
    }) : mainTitle;
    const popoverClass = popoverClassName ? `metrics-selector ${popoverClassName}` : "";
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                color: "secondary",
                dataLwtId: dataLwtId,
                id: dataLwtId,
                size: "sm",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "d-flex align-items-center",
                    children: [
                        mainTitleContent,
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                            icon: (0, $eOjgM.chevron_small_down),
                            className: "ml-1"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Xlz6))), {
                innerClassName: popoverInnerClassName,
                className: popoverClass,
                body: popoverBody,
                placement: popoverPlacement,
                header: popoverHeader,
                size: (0, $eHBjM.popoverTerms).auto,
                target: dataLwtId,
                id: dataLwtId,
                trigger: (0, $eHBjM.popoverTerms).legacy,
                toggle: togglePopover,
                isOpen: popoverIsOpen,
                modifiers: {
                    arrow: {
                        enabled: false
                    },
                    flip: {
                        enabled: false
                    }
                }
            })
        ]
    });
};
$663ae31d31f02628$var$DropDownOption.propTypes = {
    popoverBody: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node.isRequired,
    dataLwtId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    mainTitle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node
    ]).isRequired,
    popoverInnerClassName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    popoverIsOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    popoverPlacement: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    togglePopover: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired
};
var $663ae31d31f02628$export$2e2bcd8739ae039 = $663ae31d31f02628$var$DropDownOption;



var $bnHw5 = parcelRequire("bnHw5");

var $eHBjM = parcelRequire("eHBjM");

var $cstaF = parcelRequire("cstaF");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $4TPr9 = parcelRequire("4TPr9");
parcelRequire("fHiKR");
var $kN5vy = parcelRequire("kN5vy");

var $aypMh = parcelRequire("aypMh");

var $bnHw5 = parcelRequire("bnHw5");

var $90ISC = parcelRequire("90ISC");

var $i1BZc = parcelRequire("i1BZc");
const $65da24eca345c817$var$Display = ({ handleShowHideChange: handleShowHideChange, selectedAgentsView: selectedAgentsView, togglePopover: togglePopover })=>{
    const { setSummaryPinnedData: setSummaryPinnedData } = (0, $90ISC.useSearchStore)((state)=>({
            setSummaryPinnedData: state.setSummaryPinnedData
        }));
    const { selectedView: selectedView, setSelectedView: setSelectedView } = (0, $90ISC.useSavedAgentsStore)((state)=>({
            selectedView: state.selectedView,
            setSelectedView: state.setSelectedView
        }));
    const handleAgentsViewChange = (view, dataLwtId)=>{
        setSelectedView(view);
        setSummaryPinnedData(view.value, (0, $i1BZc.responseKeys).recruitingSoldTotals);
        togglePopover(view, dataLwtId);
    };
    const handleAgentsShowChange = (show)=>{
        handleShowHideChange(show.value);
        togglePopover();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "py-2",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kN5vy))), {
                dataLwtId: "select-agents-view-label",
                for: "select-agents-view",
                className: "mb-1 helix-heading text-capitalize",
                children: (0, $aypMh.terms).view
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4TPr9.default), {
                id: "select-agents-view",
                dataLwtId: "select-agents-view",
                className: "mb-2",
                isClearable: false,
                options: (0, $aypMh.viewOptions),
                defaultValue: selectedView,
                matchFrom: "start",
                value: selectedView,
                onChange: (view)=>handleAgentsViewChange(view, (0, $bnHw5.popoverIds).display)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kN5vy))), {
                dataLwtId: "select-agents-groups-label",
                for: "select-agents-groups",
                className: "mb-1 helix-heading text-capitalize",
                children: (0, $aypMh.terms).agents
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4TPr9.default), {
                id: "select-agents-groups",
                dataLwtId: "select-agents-groups",
                isClearable: false,
                options: (0, $aypMh.showOptions),
                defaultValue: selectedAgentsView,
                matchFrom: "start",
                value: (0, $aypMh.showOptions).find((show)=>show.value === selectedAgentsView),
                onChange: (view)=>handleAgentsShowChange(view)
            })
        ]
    });
};
$65da24eca345c817$var$Display.propTypes = {
    handleShowHideChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    selectedAgentsView: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    togglePopover: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired
};
var $65da24eca345c817$export$2e2bcd8739ae039 = $65da24eca345c817$var$Display;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
parcelRequire("3PprX");
var $90ODN = parcelRequire("90ODN");

var $cstaF = parcelRequire("cstaF");
const $eeda1f19d885be1f$var$GrowthAnalysisPeriodDropdown = ({ growthAnalysisPeriod: growthAnalysisPeriod, setGrowthAnalysisPeriod: setGrowthAnalysisPeriod })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "mr-2 d-inline-block",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($90ODN))), {
                dataLwtId: "growth-analysis-period-dropdown",
                items: [
                    {
                        dataLwtId: "no-split-item1",
                        itemText: (0, $cstaF.agentProductionTerms).last12Months,
                        key: "item_1",
                        onClick: ()=>setGrowthAnalysisPeriod((0, $cstaF.agentProductionTerms).last12Months)
                    },
                    {
                        dataLwtId: "no-split-item2",
                        divider: true,
                        key: "item_2"
                    },
                    {
                        dataLwtId: "no-split-item3",
                        itemText: (0, $cstaF.agentProductionTerms).yearToDate,
                        key: "item_3",
                        onClick: ()=>setGrowthAnalysisPeriod((0, $cstaF.agentProductionTerms).yearToDate)
                    }
                ],
                menuProps: {
                    dataLwtId: "share-menu",
                    right: true
                },
                toggleProps: {
                    dataLwtId: "no-split-toggle",
                    id: "caret",
                    color: "secondary",
                    caret: true,
                    children: growthAnalysisPeriod,
                    className: "btn btn-sm btn-secondary"
                }
            })
        })
    });
};
var $eeda1f19d885be1f$export$2e2bcd8739ae039 = $eeda1f19d885be1f$var$GrowthAnalysisPeriodDropdown;
$eeda1f19d885be1f$var$GrowthAnalysisPeriodDropdown.propTypes = {
    growthAnalysisPeriod: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    setGrowthAnalysisPeriod: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired
};



var $aypMh = parcelRequire("aypMh");

var $dI25G = parcelRequire("dI25G");


var $eOjgM = parcelRequire("eOjgM");

parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $ivaD7 = parcelRequire("ivaD7");

var $90ISC = parcelRequire("90ISC");
const $e084fafc54d42924$export$92d87c1237cad264 = (props)=>{
    const { currentColumns: currentColumns, currentSearchDates: currentSearchDates, growthAnalysisPeriod: growthAnalysisPeriod, handleShowHideChange: handleShowHideChange, isPeriodLast12Months: isPeriodLast12Months, selectedAgentsView: selectedAgentsView, className: className, setColumns: setColumns, setGrowthAnalysisPeriod: setGrowthAnalysisPeriod, exportCsv: exportCsv } = props;
    const { selectedView: selectedView } = (0, $90ISC.useSavedAgentsStore)((state)=>({
            selectedView: state.selectedView
        }));
    const [state, setState] = (0, $acw62.useState)({
        showDisplayPopover: false,
        showMetricsPopover: false
    });
    const togglePopover = (stateToSet)=>(0, $ivaD7.setStateData)(stateToSet, !state[stateToSet], setState);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "d-flex justify-content-center align-items-center px-2",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $663ae31d31f02628$export$2e2bcd8739ae039), {
                dataLwtId: (0, $bnHw5.popoverIds).display,
                popoverInnerClassName: "popover-menu-width-224",
                popoverPlacement: (0, $eHBjM.popoverTerms).bottomEnd,
                popoverIsOpen: state.showDisplayPopover,
                togglePopover: ()=>togglePopover("showDisplayPopover"),
                mainTitle: (0, $cstaF.agentProductionTerms)[selectedView.value],
                popoverBody: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $65da24eca345c817$export$2e2bcd8739ae039), {
                    handleShowHideChange: handleShowHideChange,
                    selectedAgentsView: selectedAgentsView,
                    togglePopover: ()=>togglePopover("showDisplayPopover")
                })
            }),
            selectedView.value === (0, $aypMh.views).growthAnalysis && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eeda1f19d885be1f$export$2e2bcd8739ae039), {
                growthAnalysisPeriod: growthAnalysisPeriod,
                setGrowthAnalysisPeriod: setGrowthAnalysisPeriod
            }),
            selectedView.value !== (0, $aypMh.views).activity && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $663ae31d31f02628$export$2e2bcd8739ae039), {
                dataLwtId: (0, $bnHw5.popoverIds).metrics,
                popoverInnerClassName: "popover-menu-width-800 helix-heading",
                popoverPlacement: (0, $eHBjM.popoverTerms).bottomEnd,
                popoverIsOpen: state.showMetricsPopover,
                popoverClassName: className,
                popoverHeader: selectedView.value === (0, $aypMh.views).listingProficiency ? (0, $2292da915057cb56$export$359879b5b60b4c62)() : null,
                togglePopover: ()=>togglePopover("showMetricsPopover"),
                mainTitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                    icon: (0, $eOjgM.columns),
                    className: "mr-2"
                }),
                popoverBody: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $41bbbe2b4d964901$export$2e2bcd8739ae039), {
                    columns: currentColumns,
                    customSettings: {
                        currentSearchDates: currentSearchDates,
                        isPeriodLast12Months: isPeriodLast12Months
                    },
                    setColumns: setColumns,
                    tabMode: selectedView.value
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                color: "secondary",
                dataLwtId: "agents-download-btn",
                id: "agents-download-btn",
                size: "sm",
                onClick: exportCsv,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "d-flex align-items-center",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                            icon: (0, $eOjgM.inbox),
                            className: "mr-2"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "text-capitalize",
                            children: (0, $cstaF.buttonTerms).download
                        })
                    ]
                })
            })
        ]
    });
};
$e084fafc54d42924$export$92d87c1237cad264.propTypes = {
    currentColumns: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array.isRequired,
    currentSearchDates: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object.isRequired,
    growthAnalysisPeriod: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    handleShowHideChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    isPeriodLast12Months: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    selectedAgentsView: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    setColumns: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    setGrowthAnalysisPeriod: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    exportCsv: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};


const $01c8946731fc56f7$var$SearchOptionsRow = (props)=>{
    const { agentLists: agentLists } = (0, $90ISC.useCommonStore)((state)=>({
            agentLists: state.agentLists
        }));
    const hasResults = !!agentLists?.length;
    const { selectedList: selectedList } = (0, $90ISC.useSavedAgentsStore)((state)=>({
            selectedList: state.selectedListByModule[(0, $cstaF.modules).proficiencyMetrics.savedAgents]
        }));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "py-2 d-flex justify-content-between align-items-center",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "d-flex align-items-center",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                        className: "title-row text-truncate text-capitalize mb-0 font-gray-primary",
                        children: (0, $aypMh.terms).savedAgents
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h6", {
                        className: "text-truncate mb-0 helix-body text-truncate text-capitalize",
                        children: selectedList && selectedList.name
                    })
                ]
            }),
            hasResults && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e084fafc54d42924$export$92d87c1237cad264), {
                ...props
            })
        ]
    });
};
$01c8946731fc56f7$var$SearchOptionsRow.propTypes = {
    selectedList: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    currentColumns: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array.isRequired,
    currentSearchDates: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object.isRequired,
    growthAnalysisPeriod: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    handleShowHideChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    isPeriodLast12Months: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    selectedAgentsView: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    setColumns: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    setGrowthAnalysisPeriod: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    exportCsv: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};
var $01c8946731fc56f7$export$2e2bcd8739ae039 = $01c8946731fc56f7$var$SearchOptionsRow;



var $ivaD7 = parcelRequire("ivaD7");



var $4tbBr = parcelRequire("4tbBr");

var $ivaD7 = parcelRequire("ivaD7");

var $90ISC = parcelRequire("90ISC");

var $8E8vr = parcelRequire("8E8vr");


var $eHBjM = parcelRequire("eHBjM");

var $aypMh = parcelRequire("aypMh");


var $cstaF = parcelRequire("cstaF");

var $5269x = parcelRequire("5269x");

var $eickZ = parcelRequire("eickZ");
const $1d585e98db9b73bc$export$aed6a7a8faddd412 = (state, setState)=>{
    const { timeIntervals: timeIntervals } = (0, $90ISC.useCommonStore)((state)=>({
            timeIntervals: state.timeIntervals
        }));
    const searchStore = (0, $90ISC.useSearchStore)();
    const module = searchStore.selectedModule;
    const timePeriod = searchStore[module]?.loadedSearchCriteria?.timePeriod;
    const savedAgentsModule = (0, $cstaF.modules).proficiencyMetrics.savedAgents;
    const { selectedList: selectedList } = (0, $90ISC.useSavedAgentsStore)((state)=>({
            selectedList: state.selectedListByModule[savedAgentsModule]
        }));
    const { searchResults: searchResults } = (0, $eickZ.useSearchResultsStore)((state)=>({
            searchResults: state[module]?.searchResults
        }));
    const period = searchStore[module]?.loadedSearchCriteria?.timePeriod?.intervalType.toString();
    const searchPeriodDates = timeIntervals?.length && (0, $0143275b912eedd1$export$776d48afc537e43d)(timeIntervals, period, timePeriod);
    const allMlsTransactionsDates = timeIntervals?.length && (0, $0143275b912eedd1$export$776d48afc537e43d)(timeIntervals, (0, $cstaF.agentProductionTerms).annually);
    const dateRangesText = {
        currentSearch: (0, $5269x.getDateRangeText)(searchPeriodDates),
        allMls: (0, $5269x.getDateRangeText)(allMlsTransactionsDates)
    };
    const setActivityColumns = (activityColumns)=>{
        (0, $ivaD7.setStateData)("activityColumns", activityColumns, setState);
    };
    const setOverviewColumns = (overviewColumns)=>{
        (0, $ivaD7.setStateData)("overviewColumns", overviewColumns, setState);
    };
    const setContactInfoColumns = (contactInfoColumns)=>{
        (0, $ivaD7.setStateData)("contactInfoColumns", contactInfoColumns, setState);
    };
    const setGrowthAnalysisColumns = (growthAnalysisColumns)=>{
        (0, $ivaD7.setStateData)("growthAnalysisColumns", growthAnalysisColumns, setState);
    };
    const setListingProfColumns = (listingProfColumns)=>{
        (0, $ivaD7.setStateData)("listingProfColumns", listingProfColumns, setState);
    };
    const allListPaginationConfig = {
        showPagination: true,
        paginationOptions: {
            sizePerPage: 100,
            sizePerPageList: [
                10,
                20,
                50,
                100
            ]
        }
    };
    const tableSettingsByView = {
        [(0, $aypMh.views).overview]: {
            additionalTableHeaders: (0, $42d942163c9a4de3$export$54862a28ed3d9ca)(state.overviewColumns, searchResults?.length, dateRangesText),
            tableTitleWithTooltips: (0, $eHBjM.overviewToolTips),
            columns: state.overviewColumns,
            setColumns: setOverviewColumns,
            tableView: {
                ...(0, $4tbBr.tableViews).overview,
                ...allListPaginationConfig
            },
            className: "overview"
        },
        [(0, $aypMh.views).contactInformation]: {
            additionalTableHeaders: (0, $42d942163c9a4de3$export$4b5edb945bac761c)(state.contactInfoColumns, dateRangesText),
            tableTitleWithTooltips: (0, $eHBjM.contactToolTips),
            columns: state.contactInfoColumns,
            setColumns: setContactInfoColumns,
            tableView: {
                ...(0, $4tbBr.tableViews).contactInformation,
                ...allListPaginationConfig
            },
            className: "contact-information"
        },
        [(0, $aypMh.views).growthAnalysis]: {
            additionalTableHeaders: (0, $42d942163c9a4de3$export$76e7236166af5295)(state.growthAnalysisColumns ?? []),
            tableTitleWithTooltips: (0, $eHBjM.growthAnalysisTooltips),
            columns: state.growthAnalysisColumns,
            setColumns: setGrowthAnalysisColumns,
            tableView: {
                ...(0, $8E8vr.getGrowthAnalysisTableSettingsByPeriod)(state.growthAnalysisPeriod),
                ...allListPaginationConfig
            },
            className: "growth-analysis"
        },
        [(0, $aypMh.views).listingProficiency]: {
            additionalTableHeaders: (0, $42d942163c9a4de3$export$e96f0ad03a836f4a)(state.listingProfColumns),
            tableTitleWithTooltips: (0, $eHBjM.listingProficiencyTooltips),
            columns: state.listingProfColumns,
            setColumns: setListingProfColumns,
            tableView: {
                ...(0, $4tbBr.tableViews).listingProficiency,
                ...allListPaginationConfig
            },
            className: "listing-proficiency"
        },
        [(0, $aypMh.views).activity]: {
            additionalTableHeaders: (0, $42d942163c9a4de3$export$13fc03f12ee9132d)(state.activityColumns, dateRangesText, state.activityRowData?.length),
            tableTitleWithTooltips: (0, $eHBjM.activityToolTips),
            columns: state.activityColumns,
            setColumns: setActivityColumns,
            tableView: (0, $4tbBr.tableViews).activity,
            className: "activity"
        }
    };
    return tableSettingsByView;
};



var $acw62 = parcelRequire("acw62");

var $aypMh = parcelRequire("aypMh");

var $fPGDZ = parcelRequire("fPGDZ");

var $90ISC = parcelRequire("90ISC");


var $8E8vr = parcelRequire("8E8vr");

var $dqgmD = parcelRequire("dqgmD");

var $ivaD7 = parcelRequire("ivaD7");

var $dlZsJ = parcelRequire("dlZsJ");

var $cstaF = parcelRequire("cstaF");

var $5269x = parcelRequire("5269x");
const $eb63a8f78062ce4d$export$4003144e7c4fee0 = (agentsRowData = [], activities = [])=>{
    if (!agentsRowData.length || !activities.length) return [];
    const agentMap = new Map(agentsRowData.map((agent)=>[
            agent.agentId,
            agent
        ]));
    const validActivities = activities.filter((activity)=>agentMap.has(activity.agentId));
    validActivities.sort((a, b)=>new Date(b.activityDate).getTime() - new Date(a.activityDate).getTime());
    return validActivities.map((activity, index)=>{
        const agent = agentMap.get(activity.agentId);
        return {
            ...agent,
            rank: index + 1,
            agentId: agent.agentId,
            agentName: agent.agentName,
            officeName: activity.officeName || agent.officeName,
            favorite: agent.favorite,
            activity: (0, $5269x.getActivityText)(activity),
            date: activity.activityDate,
            listVolume: agent.listVolume,
            sellVolume: agent.sellVolume,
            totalVolume: agent.totalVolume
        };
    });
};



var $eickZ = parcelRequire("eickZ");

var $bnHw5 = parcelRequire("bnHw5");

var $f6CJ4 = parcelRequire("f6CJ4");

var $cghEn = parcelRequire("cghEn");

var $iCDWi = parcelRequire("iCDWi");
const $8a1c1c8fdc08ce72$export$519d0ee8aa426c33 = ({ setModuleAgentData: setModuleAgentData, isActivityRoute: isActivityRoute })=>{
    const savedAgentsModule = (0, $cstaF.modules).proficiencyMetrics.savedAgents;
    const gridRef = (0, $acw62.useRef)();
    const { currentModule: currentModule, isManualSearch: isManualSearch, clearSavedAgentsOptionalFilterTitles: clearSavedAgentsOptionalFilterTitles, clearSavedAgentsSearch: clearSavedAgentsSearch, clearSelectedAgentIds: clearSelectedAgentIds, selectedViewHideAgentsFilter: selectedViewHideAgentsFilter, selectedSavedAgentListId: selectedSavedAgentListId } = (0, $90ISC.useSearchStore)((state)=>({
            currentModule: state.selectedModule,
            isManualSearch: state.isManualSearch,
            clearSavedAgentsOptionalFilterTitles: state.clearSavedAgentsOptionalFilterTitles,
            clearSavedAgentsSearch: state.clearSavedAgentsSearch,
            clearSelectedAgentIds: state.clearSelectedAgentIds,
            selectedViewHideAgentsFilter: state[state.selectedModule]?.selectedViewHideAgentsFilter,
            selectedSavedAgentListId: (0, $iCDWi.getCriteriaObject)(state[(0, $cstaF.modules).proficiencyMetrics.savedAgents]?.search?.searchCriteria)?.idFiltering[0]?.listId
        }));
    const { currentAgentList: currentAgentList, timeIntervals: timeIntervals, agentLists: agentLists, getAgentLists: getAgentLists, popoverDataForAddAgentList: popoverDataForAddAgentList, toggleAgentListsPopover: toggleAgentListsPopover, lastUpdatedAgentList: lastUpdatedAgentList, privileges: privileges } = (0, $90ISC.useCommonStore)((state)=>({
            currentAgentList: state?.agentLists?.find((l)=>l.agentListId === selectedSavedAgentListId)?.agentIds,
            timeIntervals: state.timeIntervals,
            agentLists: state.agentLists,
            getAgentLists: state.getAgentLists,
            popoverDataForAddAgentList: state.popoverDataForAddAgentList,
            toggleAgentListsPopover: state.toggleAgentListsPopover,
            lastUpdatedAgentList: state.lastUpdatedAgentList,
            privileges: state.privileges
        }));
    const { savedAgentsSelectedList: savedAgentsSelectedList, globalSavedAgentListId: globalSavedAgentListId, runSelectedList: runSelectedList, setSelectedListByModule: setSelectedListByModule, selectedView: selectedView, manualSearchData: manualSearchData, activities: activities, dirtyListIds: dirtyListIds, setSelectedView: setSelectedView } = (0, $90ISC.useSavedAgentsStore)((state)=>({
            savedAgentsSelectedList: state.selectedListByModule[savedAgentsModule],
            globalSavedAgentListId: state.globalSavedAgentListId,
            runSelectedList: state.runSelectedList,
            setSelectedListByModule: state.setSelectedListByModule,
            selectedView: state.selectedView,
            manualSearchData: state.manualSearchData,
            activities: state.activities,
            dirtyListIds: state.dirtyListIds,
            setSelectedView: state.setSelectedView
        }));
    const { tokenInfo: tokenInfo, tokenType: tokenType } = (0, $f6CJ4.useAuthStore)((state)=>({
            tokenInfo: state.tokenInfo,
            tokenType: state.tokenType
        }));
    const restrictedMlsSettings = (0, $fPGDZ.getMlsRestrictionSettings)(savedAgentsSelectedList?.mlsId);
    const { searchResults: searchResults, setSavedAgentsSearchResults: setSavedAgentsSearchResults, resetSavedAgentsSearchResults: resetSavedAgentsSearchResults } = (0, $eickZ.useSearchResultsStore)((state)=>({
            searchResults: state[currentModule]?.searchResults,
            setSavedAgentsSearchResults: state.setSavedAgentsSearchResults,
            resetSavedAgentsSearchResults: state.resetSavedAgentsSearchResults
        }));
    const [state, setState] = (0, $acw62.useState)({
        rowData: [],
        activityRowData: [],
        overviewColumns: (0, $fPGDZ.getDefaultOverviewColumns)(),
        contactInfoColumns: (0, $fPGDZ.getDefaultContactInfoColumns)(restrictedMlsSettings),
        listingProfColumns: (0, $2292da915057cb56$export$7aa1788812152cb5)(),
        activityColumns: (0, $fPGDZ.getDefaultActivityColumns)(),
        currentSearchDates: {
            lastIntervalText: "",
            from: null,
            to: null
        },
        growthAnalysisColumns: (0, $8E8vr.growthAnalysisColumnsByPeriod)[(0, $cstaF.agentProductionTerms).last12Months],
        growthAnalysisPeriod: (0, $cstaF.agentProductionTerms).last12Months,
        timeIntervals: timeIntervals,
        searchCriteria: undefined,
        showModal: false,
        modalProps: {
            dataLwtId: "agent-production-modal",
            show: false,
            size: "",
            title: "",
            footerClassName: "",
            showFooter: false,
            onClose: ()=>null,
            children: null
        },
        prevSelectedList: savedAgentsSelectedList,
        agentData: []
    });
    const removeAgentInSearchStoreData = (agentId)=>{
        const updatedAgentData = state.agentData?.filter((agent)=>agent.agentId !== agentId);
        (0, $ivaD7.setStateData)("agentData", updatedAgentData, setState);
    };
    const removeAgentFromTableAndModuleSearch = (gridRef, agentId)=>{
        if (!gridRef.current || !gridRef.current?.api) return;
        (0, $dqgmD.removeRowByKey)(gridRef, "agentId", agentId);
        toggleAgentListsPopover();
        removeAgentInSearchStoreData(agentId);
    };
    const manualSearchDataRef = (0, $acw62.useRef)(manualSearchData);
    (0, $acw62.useEffect)(()=>{
        manualSearchDataRef.current = manualSearchData;
    }, [
        manualSearchData
    ]);
    const lastRunListIdRef = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(()=>{
        const ownerId = tokenType && (0, $cghEn.getOwnerIdByTokenInfo)[tokenType](tokenInfo);
        if (agentLists?.length && !selectedSavedAgentListId) return;
        getAgentLists(ownerId);
    }, [
        tokenInfo,
        tokenType,
        selectedSavedAgentListId
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isActivityRoute) {
            setSelectedView((0, $aypMh.viewOptions)[0]);
            (0, $90ISC.useSavedAgentsStore).setState({
                activities: null
            });
        }
    }, [
        isActivityRoute
    ]);
    (0, $acw62.useEffect)(()=>{
        // Important: Use manual search data if available, otherwise use local agentData
        const dataToUse = isManualSearch ? searchResults : state.agentData;
        if (!dataToUse?.length || dataToUse.error) return;
        const sortedData = (0, $fPGDZ.getRowDataSortedAndRanked)(dataToUse);
        (0, $ivaD7.setStateData)("rowData", sortedData, setState);
        if (JSON.stringify(searchResults) !== JSON.stringify(sortedData)) setSavedAgentsSearchResults(sortedData);
    }, [
        state.agentData,
        isManualSearch
    ]);
    (0, $acw62.useEffect)(()=>{
        const shouldClearData = selectedView?.value !== (0, $aypMh.views).activity || !activities?.length || !state.agentData?.length;
        if (shouldClearData) {
            (0, $ivaD7.setStateData)("activityRowData", [], setState);
            return;
        }
        const enrichedRowData = (0, $eb63a8f78062ce4d$export$4003144e7c4fee0)(state.rowData, activities);
        (0, $ivaD7.setStateData)("activityRowData", enrichedRowData, setState);
    }, [
        activities,
        selectedView?.value,
        state.rowData
    ]);
    (0, $acw62.useEffect)(()=>{
        // Important:Clear computedFields before running search when new saved agent list is chosen.
        const currentListId = savedAgentsSelectedList?.agentListId;
        const ALL_LISTS_PATTERN = /^all-lists(-\d+)?$/;
        const isAllLists = ALL_LISTS_PATTERN.test(currentListId?.toString());
        const hasListChanged = currentListId !== state.prevSelectedList?.agentListId || !isAllLists && currentAgentList?.length !== manualSearchDataRef.current?.map((l)=>l.agentId)?.length;
        const isListDirty = currentListId && dirtyListIds[currentListId];
        const shouldRefetch = hasListChanged || isListDirty;
        if (lastRunListIdRef.current === currentListId && !isListDirty) return;
        if (shouldRefetch) {
            (0, $90ISC.useSearchStore).getState().resetSearchCriteria();
            clearSavedAgentsSearch();
            clearSavedAgentsOptionalFilterTitles();
            resetSavedAgentsSearchResults();
            clearSelectedAgentIds();
            (0, $ivaD7.setStateData)("activityRowData", [], setState);
        }
        lastRunListIdRef.current = currentListId;
        runSelectedList(setState, setModuleAgentData, shouldRefetch);
    }, [
        runSelectedList,
        savedAgentsSelectedList?.agentListId,
        state.prevSelectedList,
        dirtyListIds
    ]);
    (0, $acw62.useEffect)(()=>{
        (0, $ivaD7.setStateData)("growthAnalysisColumns", (0, $8E8vr.growthAnalysisColumnsByPeriod)[state.growthAnalysisPeriod], setState);
    }, [
        state.growthAnalysisPeriod
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!timeIntervals?.length) return;
        let currentSearchDates;
        const interval = timeIntervals?.find((i)=>i?.intervalType === (0, $cstaF.agentProductionTerms).annually);
        if (interval) {
            const lastIntervalText = (0, $dlZsJ.getKeyByValue)((0, $cstaF.TimePeriods), (0, $cstaF.agentProductionTerms).annually);
            const from = new Date(`${interval.last.from}Z`);
            const to = new Date(`${interval.last.to}Z`);
            currentSearchDates = {
                lastIntervalText: lastIntervalText,
                from: from,
                to: to
            };
        }
        (0, $ivaD7.setStateData)("currentSearchDates", currentSearchDates, setState);
    }, [
        timeIntervals
    ]);
    (0, $acw62.useEffect)(()=>{
        if (currentModule === savedAgentsModule) {
            const { agentId: agentId } = popoverDataForAddAgentList;
            const isAgentInList = savedAgentsSelectedList?.agentIds?.includes(agentId);
            const lastUpdatedAgentListMatch = lastUpdatedAgentList === savedAgentsSelectedList?.agentListId;
            lastUpdatedAgentListMatch && isAgentInList && removeAgentFromTableAndModuleSearch(gridRef, agentId);
        }
        if (!agentLists?.length) return;
        const selectedAgentListId = savedAgentsSelectedList?.agentListId || globalSavedAgentListId;
        setSelectedListByModule(savedAgentsModule, (0, $bnHw5.getSelectedAgentList)(agentLists, selectedAgentListId));
    }, [
        agentLists,
        savedAgentsSelectedList?.agentListId,
        globalSavedAgentListId
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!savedAgentsSelectedList || !state.agentData || state.agentData.error) return;
        const { userOffices: userOffices = [] } = privileges || {};
        const userMlsOffices = userOffices.filter((office)=>office.mlsId === savedAgentsSelectedList.mlsId);
        const userFilteredOffices = userMlsOffices.map((office)=>office.officeIds)[0];
        const agentResults = (0, $fPGDZ.getRowDataSortedAndRanked)(state.agentData);
        const filteredAgents = agentResults.filter((agent)=>{
            if (selectedViewHideAgentsFilter === (0, $aypMh.types).ONLY_SHOW_MY_AGENTS) return userFilteredOffices.includes(agent.officeId);
            if (selectedViewHideAgentsFilter === (0, $aypMh.types).HIDE_MY_AGENTS) return !userFilteredOffices.includes(agent.officeId);
            return true;
        });
        const shouldNotRank = true;
        (0, $ivaD7.setStateData)("rowData", (0, $fPGDZ.getRowDataSortedAndRanked)(filteredAgents, shouldNotRank), setState);
    }, [
        selectedViewHideAgentsFilter,
        privileges,
        savedAgentsSelectedList,
        state.agentData
    ]);
    return {
        state: {
            ...state,
            selectedView: selectedView
        },
        setState: setState,
        gridRef: gridRef
    };
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $aypMh = parcelRequire("aypMh");

var $7tOHe = parcelRequire("7tOHe");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $cstaF = parcelRequire("cstaF");
const $da5c62ebce2f71f5$export$5de9493abab0a330 = ({ isDropdown: isDropdown })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "text-center",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: `no-search-results${isDropdown ? "-dropdown" : ""} font-weight-bold`,
                children: (0, $cstaF.agentProductionTerms).noSavedAgents
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: `no-search-results-suggestion${isDropdown ? "-dropdown" : ""}`,
                children: (0, $cstaF.agentProductionTerms).noSavedAgentsSuggestion
            })
        ]
    });
};



var $cstaF = parcelRequire("cstaF");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4EYT7 = parcelRequire("4EYT7");
const $ca8d243229e77996$export$48d94d386697372e = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "d-flex flex-column justify-content-center align-items-center text-center",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                className: "helix-body--strong mb-2",
                children: (0, $4EYT7.terms).noNewActivity
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "helix-text-gray-500 mb-0",
                children: (0, $4EYT7.terms).noNewActivityMessage
            })
        ]
    });
};



var $l05Px = parcelRequire("l05Px");

var $acw62 = parcelRequire("acw62");

var $90ISC = parcelRequire("90ISC");

var $aypMh = parcelRequire("aypMh");

var $htzEo = parcelRequire("htzEo");


var $jilhO = parcelRequire("jilhO");

var $cstaF = parcelRequire("cstaF");
const $93bde42b3cac184a$export$b6d0ec7ad1b9a48 = ({ savedAgentState: savedAgentState })=>{
    const { selectedView: selectedView } = savedAgentState;
    const { isAgentDataLoading: isAgentDataLoading, agentLists: agentLists, timeIntervals: timeIntervals } = (0, $90ISC.useCommonStore)((state)=>({
            isAgentDataLoading: state.isLoading,
            agentLists: state.agentLists,
            timeIntervals: state.timeIntervals
        }));
    const { isLoading: isLoading, getSavedAgentsActivities: getSavedAgentsActivities, activities: activities, isLoadingActivities: isLoadingActivities, savedAgentsSelectedList: savedAgentsSelectedList } = (0, $90ISC.useSavedAgentsStore)((state)=>({
            isLoading: state.isLoading,
            getSavedAgentsActivities: state.getSavedAgentsActivities,
            activities: state.activities,
            isLoadingActivities: state.isLoadingActivities,
            savedAgentsSelectedList: state.selectedListByModule[(0, $cstaF.modules).proficiencyMetrics.savedAgents]
        }));
    const { selectedMls: selectedMls, summaryPinnedData: summaryPinnedData, isLoadingSearchData: isLoadingSearchData, period: period, timePeriod: timePeriod } = (0, $90ISC.useSearchStore)((state)=>({
            selectedMls: state[state.selectedModule]?.selectedMls,
            summaryPinnedData: state[state.selectedModule]?.summaryPinnedData,
            isLoadingSearchData: state.isLoadingSearchData,
            period: state[state.selectedModule]?.loadedSearchCriteria?.timePeriod?.intervalType?.toString(),
            timePeriod: state[state.selectedModule]?.loadedSearchCriteria?.timePeriod
        }));
    const mlsId = selectedMls?.mlsId?.toString();
    const periodDates = (0, $acw62.useMemo)(()=>{
        if (!timeIntervals?.length || !period) return null;
        return (0, $0143275b912eedd1$export$776d48afc537e43d)(timeIntervals, period, timePeriod);
    }, [
        timeIntervals,
        period,
        timePeriod
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!savedAgentsSelectedList?.agentListId || selectedView?.value !== (0, $aypMh.views).activity || !mlsId || !periodDates) return;
        getSavedAgentsActivities(mlsId, {
            from: (0, $htzEo.yearMonthDayDashDateFormat)(periodDates.from),
            to: (0, $htzEo.yearMonthDayDashDateFormat)(periodDates.to)
        });
    }, [
        selectedView?.value,
        mlsId,
        periodDates,
        getSavedAgentsActivities,
        savedAgentsSelectedList?.agentListId
    ]);
    const summaryPinnedConfig = (0, $jilhO.getSummaryPinnedConfig)(selectedView.value);
    const shouldShowPinnedRow = [
        (0, $aypMh.views).overview,
        (0, $aypMh.views).listingProficiency
    ].includes(selectedView.value);
    const isPageLoading = isLoading || isAgentDataLoading || isLoadingSearchData || isLoadingActivities;
    return {
        summaryPinnedConfig: summaryPinnedConfig,
        summaryPinnedData: summaryPinnedData,
        shouldShowPinnedRow: shouldShowPinnedRow,
        isPageLoading: isPageLoading,
        activities: activities,
        agentLists: agentLists
    };
};



var $90ISC = parcelRequire("90ISC");

var $eickZ = parcelRequire("eickZ");



const $8a2ae9b17ce2cbb4$export$10e512f89bf0f720 = ({ savedAgentState: savedAgentState, gridRef: gridRef, tableSettingsByView: tableSettingsByView, setState: setState })=>{
    const { currentModule: currentModule } = (0, $90ISC.useSearchStore)((state)=>({
            currentModule: state.selectedModule
        }));
    const { searchResults: searchResults } = (0, $eickZ.useSearchResultsStore)((state)=>({
            searchResults: state[currentModule]?.searchResults
        }));
    const { selectedView: selectedView } = (0, $90ISC.useSavedAgentsStore)((state)=>({
            selectedView: state.selectedView
        }));
    const { crossSortOrder: crossSortOrder, sortByStoredOrder: sortByStoredOrder } = (0, $90ISC.useSearchStore)((state)=>({
            crossSortOrder: state[state.selectedModule]?.crossSortOrder,
            sortByStoredOrder: state.sortByStoredOrder
        }));
    const { timeIntervals: timeIntervals } = (0, $90ISC.useCommonStore)((state)=>({
            timeIntervals: state.timeIntervals
        }));
    const handleDownload = (selectedAgents)=>{
        (0, $ba4fc233a0a159d1$export$6a3b3e40f9ef1478)({
            ...savedAgentState,
            timeIntervals: timeIntervals
        }, setState, selectedView.value, selectedAgents, selectedView.value);
    };
    const { selectedCount: selectedCount, showAddToListModal: showAddToListModal, setShowAddToListModal: setShowAddToListModal, handleDismiss: handleDismiss, handleDownloadClick: handleDownloadClick } = (0, $14b4389b323bef2f$export$2bf58a042e4e0b44)(gridRef, handleDownload);
    const { activityRowData: activityRowData } = savedAgentState;
    const { summaryPinnedConfig: summaryPinnedConfig, shouldShowPinnedRow: shouldShowPinnedRow, summaryPinnedData: summaryPinnedData, isPageLoading: isPageLoading, activities: activities, agentLists: agentLists } = (0, $93bde42b3cac184a$export$b6d0ec7ad1b9a48)({
        savedAgentState: savedAgentState
    });
    const sortedRowData = (0, $acw62.useMemo)(()=>{
        const data = Array.isArray(searchResults) ? searchResults : searchResults?.results;
        return sortByStoredOrder(data) ?? [];
    }, [
        crossSortOrder,
        searchResults
    ]);
    const adjustedRowData = (selectedView.value === (0, $aypMh.views).activity ? activityRowData : sortedRowData)?.map((d)=>({
            ...d,
            hasFavStar: true
        }));
    if (agentLists !== undefined && !agentLists.length) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "mt-5",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $da5c62ebce2f71f5$export$5de9493abab0a330), {
            isDropdown: false
        })
    });
    if (isPageLoading || agentLists === undefined) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "py-3",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {})
    });
    if (selectedView.value === (0, $aypMh.views).activity && activities?.length === 0 && searchResults?.length > 0) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ca8d243229e77996$export$48d94d386697372e), {});
    const hasResults = !!searchResults?.length;
    if (!hasResults) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "py-5 d-flex justify-content-center",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
            className: "no-search-results-suggestion",
            children: (0, $cstaF.agentProductionTerms).viewOnlyMyAgentsNoData
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "px-2 mb-5",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l05Px.default), {
                additionalTableHeaders: tableSettingsByView[selectedView.value]?.additionalTableHeaders,
                columns: tableSettingsByView[selectedView.value]?.columns,
                gridRef: gridRef,
                rowData: adjustedRowData,
                tableTitleWithTooltips: tableSettingsByView[selectedView.value]?.tableTitleWithTooltips,
                tableView: tableSettingsByView[selectedView.value]?.tableView,
                pinnedBottomRowData: shouldShowPinnedRow && [
                    {
                        ...summaryPinnedData
                    }
                ],
                externalParams: shouldShowPinnedRow && {
                    summaryPinnedConfig: summaryPinnedConfig
                },
                hasFooter: selectedView.value !== (0, $aypMh.views).activity,
                rowSelection: "multiple",
                suppressRowClickSelection: true,
                rowMultiSelectWithClick: true
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0eb783070ef68771$export$2e2bcd8739ae039), {
                selectedCount: selectedCount,
                showAddToListModal: showAddToListModal,
                setShowAddToListModal: setShowAddToListModal,
                onDismiss: handleDismiss,
                onDownloadClick: handleDownloadClick
            })
        ]
    });
};
$8a2ae9b17ce2cbb4$export$10e512f89bf0f720.propTypes = {
    savedAgentState: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    gridRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    tableSettingsByView: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    setState: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};



var $cstaF = parcelRequire("cstaF");

var $90ISC = parcelRequire("90ISC");

var $c9Z8w = parcelRequire("c9Z8w");

var $kfZjc = parcelRequire("kfZjc");

var $aypMh = parcelRequire("aypMh");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $cstaF = parcelRequire("cstaF");

var $9QX0f = parcelRequire("9QX0f");
const $2d072b31e1c166df$var$Footer = ({ timePeriodTitle: timePeriodTitle, propertyTypeNames: propertyTypeNames = [], mlsName: mlsName, productionTitle: productionTitle, area: area, detailedPropertyType: detailedPropertyType, hasEllipsis: hasEllipsis = false })=>{
    const allResidential = `${(0, $cstaF.searchTerms).allResidential}: (${propertyTypeNames.join(", ")})`;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "footer-wrapper",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                className: "d-inline helix-text-gray-500",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "helix-body--strong",
                        children: [
                            (0, $cstaF.searchTerms).mls,
                            ":"
                        ]
                    }),
                    " ",
                    `${mlsName} `,
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "helix-body--strong ml-1",
                        children: [
                            (0, $cstaF.agentProductionTerms).area,
                            ":",
                            " "
                        ]
                    }),
                    " ",
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: `${hasEllipsis ? "footer-text-area" : ""}`,
                        children: `${area ?? (0, $cstaF.searchTerms).allMls} `
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "helix-body--strong ml-1",
                        children: [
                            (0, $cstaF.searchTerms).timeFrame,
                            ":",
                            " "
                        ]
                    }),
                    `${timePeriodTitle} `,
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "helix-body--strong ml-1",
                        children: [
                            (0, $cstaF.searchTerms).propertyTypesSA,
                            ":",
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: `${hasEllipsis ? "footer-text-area" : ""}`,
                        children: detailedPropertyType ?? allResidential
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                        className: "helix-body--strong ml-1",
                        children: [
                            productionTitle && `${(0, $9QX0f.terms).production}: `,
                            " "
                        ]
                    }),
                    " ",
                    productionTitle
                ]
            })
        })
    });
};
var $2d072b31e1c166df$export$2e2bcd8739ae039 = $2d072b31e1c166df$var$Footer;
$2d072b31e1c166df$var$Footer.propTypes = {
    productionTitle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    mlsName: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    propertyTypeNames: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    timePeriodTitle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    area: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    detailedPropertyType: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    hasEllipsis: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};




var $iCDWi = parcelRequire("iCDWi");

var $bnHw5 = parcelRequire("bnHw5");
const $6595e2041614f54d$var$SavedAgents = ({ setModuleAgentData: setModuleAgentData })=>{
    const location = (0, $kfZjc.useLocation)();
    const isActivityRoute = location.pathname === (0, $cstaF.searchRoutes).savedAgentsActivity;
    const clearAgentListPopover = (0, $90ISC.useCommonStore)((state)=>state.clearAgentListPopover);
    const { state: state, setState: setState, gridRef: gridRef } = (0, $8a1c1c8fdc08ce72$export$519d0ee8aa426c33)({
        setModuleAgentData: setModuleAgentData,
        isActivityRoute: isActivityRoute
    });
    const { selectedViewHideAgentsFilter: selectedViewHideAgentsFilter, setViewHideAgentsFilter: setViewHideAgentsFilter } = (0, $90ISC.useSearchStore)((state)=>({
            selectedViewHideAgentsFilter: state[state.selectedModule]?.selectedViewHideAgentsFilter,
            setViewHideAgentsFilter: state.setViewHideAgentsFilter
        }));
    const selectedMlsDescription = (0, $90ISC.useSearchStore)((state)=>state[state.selectedModule]?.selectedMls?.shortDescription);
    const loadedSearchFields = (0, $90ISC.useSearchStore)((state)=>(0, $iCDWi.getCriteriaObject)({
            criteria: state[state.selectedModule]?.loadedSearchCriteria
        }));
    const propertyTypes = (0, $90ISC.useCommonStore)((state)=>state.propertyTypes);
    const isLoading = (0, $90ISC.useSavedAgentsStore)((state)=>state.isLoading);
    const selectedTimePeriod = (0, $90ISC.useSearchStore)((storeState)=>state.timeIntervals?.find((ti)=>ti.intervalType === storeState[storeState.selectedModule]?.loadedSearchCriteria?.timePeriod?.intervalType));
    const { areaLabel: areaLabel, timePeriodTitle: timePeriodTitle, propertyTypeFooterLabel: propertyTypeFooterLabel } = (0, $bnHw5.getFooterLabels)({
        loadedSearchFields: loadedSearchFields,
        selectedTimePeriod: selectedTimePeriod,
        propertyTypes: propertyTypes
    });
    const tableSettingsByView = (0, $1d585e98db9b73bc$export$aed6a7a8faddd412)(state, setState);
    const isGrowthAnalysisLast12MonthsPeriod = state.growthAnalysisPeriod === (0, $cstaF.agentProductionTerms).last12Months;
    const handleShowHideChange = (view)=>setViewHideAgentsFilter((0, $cstaF.modules).proficiencyMetrics.savedAgents, view);
    const setGrowthAnalysisPeriod = (period)=>{
        (0, $ivaD7.setStateData)("growthAnalysisPeriod", period, setState);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $acw62.useEffect)(()=>clearAgentListPopover(), []);
    const rowDataToExport = state.selectedView?.value === (0, $aypMh.views).activity ? state.activityRowData : state.rowData;
    const columnProps = [
        {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d072b31e1c166df$export$2e2bcd8739ae039), {
                area: areaLabel || "",
                mlsName: selectedMlsDescription || "",
                timePeriodTitle: timePeriodTitle || "",
                detailedPropertyType: propertyTypeFooterLabel,
                hasEllipsis: true
            }),
            sm: 12,
            align: "left"
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f61ig.default), {
                ...state.modalProps,
                show: state.showModal
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $01c8946731fc56f7$export$2e2bcd8739ae039), {
                currentColumns: tableSettingsByView[state.selectedView.value]?.columns,
                currentSearchDates: state.currentSearchDates,
                isPeriodLast12Months: isGrowthAnalysisLast12MonthsPeriod,
                growthAnalysisPeriod: state.growthAnalysisPeriod,
                handleShowHideChange: handleShowHideChange,
                selectedAgentsView: selectedViewHideAgentsFilter,
                className: tableSettingsByView[state.selectedView.value].className,
                setColumns: tableSettingsByView[state.selectedView.value]?.setColumns,
                exportCsv: ()=>(0, $ba4fc233a0a159d1$export$6a3b3e40f9ef1478)(state, setState, state.selectedView.value, rowDataToExport),
                setGrowthAnalysisPeriod: setGrowthAnalysisPeriod
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8a2ae9b17ce2cbb4$export$10e512f89bf0f720), {
                gridRef: gridRef,
                tableSettingsByView: tableSettingsByView,
                savedAgentState: state,
                setState: setState
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0708f7349a857d02$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                id: "saved-agents-footer-wrapper",
                children: !isLoading && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $859b3aeec7a854d9$export$2e2bcd8739ae039), {
                    columnProps: columnProps
                })
            })
        ]
    });
};
var $6595e2041614f54d$export$2e2bcd8739ae039 = $6595e2041614f54d$var$SavedAgents;
$6595e2041614f54d$var$SavedAgents.propTypes = {
    setModuleAgentData: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};



var $cstaF = parcelRequire("cstaF");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $kfZjc = parcelRequire("kfZjc");

parcelRequire("3lOdM");
var $e155p = parcelRequire("e155p");

var $7tOHe = parcelRequire("7tOHe");


var $cstaF = parcelRequire("cstaF");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $cstaF = parcelRequire("cstaF");
var $f9135656e0790621$exports = {};
"use strict";
var $f9135656e0790621$var$__createBinding = $f9135656e0790621$exports && $f9135656e0790621$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, {
        enumerable: true,
        get: function() {
            return m[k];
        }
    });
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f9135656e0790621$var$__setModuleDefault = $f9135656e0790621$exports && $f9135656e0790621$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $f9135656e0790621$var$__importStar = $f9135656e0790621$exports && $f9135656e0790621$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $f9135656e0790621$var$__createBinding(result, mod, k);
    }
    $f9135656e0790621$var$__setModuleDefault(result, mod);
    return result;
};
var $f9135656e0790621$var$__importDefault = $f9135656e0790621$exports && $f9135656e0790621$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($f9135656e0790621$exports, "__esModule", {
    value: true
});

const $f9135656e0790621$var$react_1 = $f9135656e0790621$var$__importStar((parcelRequire("acw62")));

const $f9135656e0790621$var$card_1 = $f9135656e0790621$var$__importDefault((parcelRequire("kTdhz")));
const $f9135656e0790621$var$EntryTable = (props)=>{
    const { dataLwtId: dataLwtId, data: data, applyEntryCssClass: applyEntryCssClass, className: className, renderEntry: renderEntry } = props;
    const [entries, setEntries] = (0, $f9135656e0790621$var$react_1.useState)([]);
    (0, $f9135656e0790621$var$react_1.useEffect)(()=>{
        /**
         * This cleanup object addresses the React warning below:
         *
         * "Warning: Can't perform a React state update on an unmounted component.
         * This is a no-op, but it indicates a memory leak in your application.
         * To fix, cancel all subscriptions and asynchronous tasks in a useEffect cleanup function."
         *
         * It is an object and not just a boolean variable, because we are passing it into effect(...),
         * so we need an object in order to pass it by reference.
         *
         * ALWAYS CHECK !cleanup.didCancel INSIDE THE effect CALLBACK FUNCTION BODY,
         * BEFORE EACH UPDATE TO LOCAL STATE
         */ const cleanup = {
            didCancel: false
        };
        const nodes = [];
        if (renderEntry) data.forEach((entry, index)=>{
            nodes.push($f9135656e0790621$var$react_1.default.createElement("div", {
                className: `${applyEntryCssClass ? "entry" : ""}`,
                key: index
            }, renderEntry(entry)));
        });
        !cleanup.didCancel && setEntries(nodes);
        return ()=>{
            cleanup.didCancel = true;
        };
    }, [
        data
    ]);
    return $f9135656e0790621$var$react_1.default.createElement($f9135656e0790621$var$card_1.default, {
        className: className,
        dataLwtId: dataLwtId
    }, entries);
};
$f9135656e0790621$exports.default = $f9135656e0790621$var$EntryTable;


var $83e1bef4b926bdd3$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($f9135656e0790621$exports)));


parcelRequire("3lOdM");
var $1iwUl = parcelRequire("1iwUl");
var $e155p = parcelRequire("e155p");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $f61ig = parcelRequire("f61ig");

parcelRequire("3lOdM");
var $1iwUl = parcelRequire("1iwUl");
var $e155p = parcelRequire("e155p");

var $24YIE = parcelRequire("24YIE");

var $cstaF = parcelRequire("cstaF");

var $ivaD7 = parcelRequire("ivaD7");

const $01d8bdcd0cbabf17$var$PropertyInfoDetail = ({ data: data, entry: entry, mlsName: mlsName, renderEntryCode: renderEntryCode, entryValueClassName: entryValueClassName })=>{
    const [state, setState] = (0, $acw62.useState)({
        agentDetails: null,
        officeDetails: null,
        requestParams: null,
        showModal: false
    });
    (0, $acw62.useEffect)(()=>{
        const getDetailData = async ()=>{
            if (!state.requestParams) return;
            try {
                if ((0, $7ea0df6fe6bf1196$export$533db429d2c2033d).includes(state.requestParams.entry)) {
                    const agentDetail = await (0, $24YIE.getAgentInfoDetail)(state.requestParams.mlsId, state.requestParams.idValue);
                    (0, $ivaD7.setStateData)("agentDetails", agentDetail, setState);
                    const officeDetail = await (0, $24YIE.getOfficeInfoDetail)(state.requestParams.mlsId, agentDetail.officeId);
                    (0, $ivaD7.setStateData)("officeDetails", officeDetail, setState);
                } else {
                    let officeDetail = await (0, $24YIE.getOfficeInfoDetail)(state.requestParams.mlsId, state.requestParams.idValue);
                    (0, $ivaD7.setStateData)("officeDetails", officeDetail, setState);
                }
            } catch (error) {
                throw new Error(`Listing Information Detail error: ${error}`);
            }
        };
        const detailError = (error)=>console.log(error);
        getDetailData().catch(detailError);
    }, [
        state.requestParams
    ]);
    let columns, title;
    if ((0, $7ea0df6fe6bf1196$export$533db429d2c2033d).includes(state.requestParams?.entry)) {
        columns = (0, $7ea0df6fe6bf1196$export$80a7b78180eee4fe)(state.agentDetails, state.officeDetails);
        title = (0, $cstaF.agentProductionTerms).agentContactInformation;
    } else {
        columns = (0, $7ea0df6fe6bf1196$export$5a6d863506628af2)(state.officeDetails, mlsName);
        title = (0, $cstaF.agentProductionTerms).officeDetail;
    }
    const renderEntry = (entry)=>{
        let className = "border-top m-0";
        if (entry.isLastRow) className += " border-bottom";
        if (entry.isAltData) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($e155p))), {
                className: className,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1iwUl))), {
                        className: "property-detail-description",
                        children: entry.description
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1iwUl))), {
                        children: Array.isArray(entry.value) && entry.value.length > 0 ? entry.value.map((item, index)=>{
                            return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($e155p))), {
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1iwUl))), {
                                        className: "property-detail-description",
                                        children: item.description
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1iwUl))), {
                                        className: "property-detail-value",
                                        children: item.value
                                    })
                                ]
                            }, index);
                        }) : "-"
                    })
                ]
            })
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($e155p))), {
                className: className,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1iwUl))), {
                        className: "property-detail-description",
                        children: entry.description
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1iwUl))), {
                        className: "property-detail-value",
                        children: entry.value
                    })
                ]
            })
        });
    };
    const toggleModal = ()=>(0, $ivaD7.setStateData)("showModal", !state.showModal, setState);
    const inputParamConfig = (0, $7ea0df6fe6bf1196$export$4e67d6f29dad3fab)(data);
    const handleDetailInformation = (entry)=>{
        (0, $ivaD7.setStateData)("requestParams", inputParamConfig[entry], setState);
        toggleModal();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                className: `btn-link ${entryValueClassName}`,
                onClick: ()=>handleDetailInformation(entry.description),
                children: [
                    entry.value ?? "",
                    " ",
                    renderEntryCode(entry.code)
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f61ig.default), {
                onClose: toggleModal,
                show: state.showModal,
                showFooter: false,
                size: "lg",
                title: title,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    id: "property-info",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $83e1bef4b926bdd3$export$2e2bcd8739ae039), {
                        dataLwtId: "property-info",
                        data: columns,
                        renderEntry: renderEntry,
                        className: "card-body"
                    })
                })
            })
        ]
    });
};
var $01d8bdcd0cbabf17$export$2e2bcd8739ae039 = $01d8bdcd0cbabf17$var$PropertyInfoDetail;




const $06a5872b702ded2f$var$PropertyInformation = ({ data: data, module: module, mlsName: mlsName })=>{
    const isMarketShare = module.includes((0, $cstaF.moduleNames).marketShare);
    const column1 = isMarketShare ? (0, $5f95247c68892fb4$export$a702574b38ecbcc8)(data) : (0, $7ea0df6fe6bf1196$export$a702574b38ecbcc8)(data);
    const column2 = isMarketShare ? (0, $5f95247c68892fb4$export$fd64a1f33de3651a)(data) : (0, $7ea0df6fe6bf1196$export$fd64a1f33de3651a)(data);
    const entryValueClassName = isMarketShare ? "property-value" : "helix-body--strong";
    const entryDescriptionClassName = isMarketShare ? "property-description" : "";
    const columns = [
        column1,
        column2
    ];
    const renderEntry = (entry)=>{
        if (entry.header) return /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
            className: "text-uppercase font-italic",
            children: entry.header
        });
        let className;
        if (!isMarketShare) {
            className = "border-top m-0";
            if (entry.isLastRow) className += " border-bottom";
        }
        const code = entry.code && `(${entry.code})`;
        const value = entry.value ?? "";
        const renderEntryCode = (entryCode)=>{
            if (!entryCode) return "";
            if (isMarketShare) return `(${entryCode})`;
            else return entryCode;
        };
        if (code) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($e155p))), {
                className: className,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1iwUl))), {
                        className: entryDescriptionClassName,
                        children: entry.description
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1iwUl))), {
                        className: entryValueClassName,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $01d8bdcd0cbabf17$export$2e2bcd8739ae039), {
                            data: data,
                            entry: entry,
                            entryValueClassName: entryValueClassName,
                            mlsName: mlsName,
                            renderEntryCode: renderEntryCode
                        })
                    })
                ]
            })
        });
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($e155p))), {
                className: className,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1iwUl))), {
                        className: entryDescriptionClassName,
                        children: entry.description
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($1iwUl))), {
                        className: entryValueClassName,
                        children: [
                            value,
                            " ",
                            code
                        ]
                    })
                ]
            })
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        id: isMarketShare ? "property-info-market-share" : "property-info",
        children: columns.map((column, index)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "col-lg-6 col-md-12 pd-0",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $83e1bef4b926bdd3$export$2e2bcd8739ae039), {
                    dataLwtId: `property-info-column-${index}`,
                    data: column,
                    renderEntry: renderEntry,
                    className: isMarketShare ? "" : "card-body"
                })
            }, index);
        })
    });
};
var $06a5872b702ded2f$export$2e2bcd8739ae039 = $06a5872b702ded2f$var$PropertyInformation;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $eHBjM = parcelRequire("eHBjM");
var $e435ccad5943e6d1$export$2e2bcd8739ae039 = ()=>{
    const pricingHistoryColumns = (0, $eHBjM.pricingHistoryTooltips);
    const pricingHistoryCols = [
        pricingHistoryColumns.date,
        pricingHistoryColumns.status,
        pricingHistoryColumns.price,
        pricingHistoryColumns.priceChange,
        pricingHistoryColumns.priceChangePct,
        pricingHistoryColumns.days,
        pricingHistoryColumns.changeType,
        pricingHistoryColumns.spop,
        pricingHistoryColumns.splp
    ];
    const pricingHistoryColDefs = pricingHistoryCols.map((col)=>({
            ...col,
            isDisplayed: true
        }));
    return {
        pricingHistoryColDefs: pricingHistoryColDefs,
        pricingHistoryTooltips: $eHBjM.pricingHistoryTooltips
    };
};



var $l05Px = parcelRequire("l05Px");

var $4tbBr = parcelRequire("4tbBr");
const $dcaf3ebd1524c1f3$var$PricingHistory = ({ data: data })=>{
    const { pricingHistoryColDefs: pricingHistoryColDefs, pricingHistoryTooltips: pricingHistoryTooltips } = (0, $e435ccad5943e6d1$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: data?.length && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l05Px.default), {
            tableView: (0, $4tbBr.tableViews).pricingHistory,
            rowData: data,
            columns: pricingHistoryColDefs,
            tableTitleWithTooltips: pricingHistoryTooltips
        })
    });
};
$dcaf3ebd1524c1f3$var$PricingHistory.propTypes = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array.isRequired
};
var $dcaf3ebd1524c1f3$export$2e2bcd8739ae039 = $dcaf3ebd1524c1f3$var$PricingHistory;



var $bq4QZ = parcelRequire("bq4QZ");

var $ivaD7 = parcelRequire("ivaD7");

var $htzEo = parcelRequire("htzEo");

var $ekOct = parcelRequire("ekOct");

var $90ISC = parcelRequire("90ISC");

var $24YIE = parcelRequire("24YIE");
const $deb2942a8ffbb165$var$ListingInformationPage = ({ agentData: agentData, module: module })=>{
    const history = (0, $kfZjc.useHistory)();
    let query = (0, $bq4QZ.useQuery)();
    const queryTabIndex = query.get("tabIndex");
    const displayMode = query.get("displayMode");
    const intervalType = query.get("intervalType");
    const tabIndex = Object.freeze({
        LISTING_INFORMATION: 0,
        PRICING_HISTORY: 1
    });
    const { search: search, loadedSearchCriteria: loadedSearchCriteria } = (0, $90ISC.useSearchStore)((state)=>({
            search: state[module]?.search,
            loadedSearchCriteria: state[module]?.loadedSearchCriteria
        }));
    const { membership: membership, agentMetricsMlsId: agentMetricsMlsId, agentMetricsAgentProfileData: agentMetricsAgentProfileData } = (0, $90ISC.useCommonStore)((state)=>{
        const mlsAgent = state?.agentInfo?.[0]?.mlsAgentId;
        const agentInfo = state?.agentInfo?.[0];
        const agentMetricsAgentProfileData = {
            agentId: agentInfo?.mlsAgentId?.agentId,
            mlsSid: agentInfo?.mlsAgentId?.mlsId,
            agentName: `${agentInfo?.firstName} ${agentInfo?.lastName}`,
            officeName: agentInfo?.office?.name
        };
        return {
            membership: state.membership,
            agentMetricsMlsId: mlsAgent?.mlsId,
            agentMetricsAgentProfileData: agentMetricsAgentProfileData
        };
    });
    const [state, setState] = (0, $acw62.useState)({
        agent: null,
        agentsData: null,
        mlsNum: query.get("mlsNum"),
        mlsId: null,
        agentId: query.get("agentId") ?? agentMetricsAgentProfileData?.agentId,
        currentTabIndex: tabIndex.LISTING_INFORMATION,
        searchCriteria: null,
        mlsName: null
    });
    const setCurrentTabIndex = (currentTabIndex)=>{
        setState({
            ...state,
            currentTabIndex: currentTabIndex
        });
    };
    const [listingDetailData, setListingDetailData] = (0, $acw62.useState)(null);
    const [listingHistoryData, setListingHistoryData] = (0, $acw62.useState)(null);
    const redirectToHome = ()=>{
        window.location.href = (0, $ekOct.getFirstToolRoute)();
    };
    const shouldRender = !!module;
    const mlsId = search?.mlsId || agentMetricsMlsId;
    const agent = state.agent ?? agentMetricsAgentProfileData;
    (0, $acw62.useEffect)(()=>{
        if (!shouldRender) return;
        if (!state.mlsNum || !mlsId) return;
        const loadDetailData = async ()=>{
            let error = null;
            const response = await (0, $24YIE.getListingDetailRequest)(state.mlsNum, mlsId);
            if (!response) {
                redirectToHome();
                return;
            }
            if (response.error) {
                console.error("Listing Information error:", error);
                redirectToHome();
                return;
            }
            setListingDetailData(response);
        };
        const detailError = (e)=>console.log(e);
        loadDetailData().catch(detailError);
        const loadHistoryData = async ()=>{
            let error = null;
            const response = await (0, $24YIE.getListingHistoryRequest)(state.mlsNum, mlsId);
            if (!response) {
                redirectToHome();
                return;
            }
            if (response.error) {
                console.error("Listing Information error:", error);
                redirectToHome();
                return;
            }
            setListingHistoryData(response);
        };
        const historyError = (e)=>console.log(e);
        loadHistoryData().catch(historyError);
    }, [
        mlsId,
        state.mlsNum
    ]);
    const mlsProviders = (0, $acw62.useRef)([]);
    (0, $acw62.useEffect)(()=>{
        if (agentData) {
            const revisedData = (0, $htzEo.mapIdToTableData)(agentData?.agMovAgentBreakdownSearch || agentData);
            (0, $ivaD7.setStateData)("agentsData", revisedData || [], setState);
        }
    }, [
        agentData
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!shouldRender) history.push("/");
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!loadedSearchCriteria?.realEstateDatasourceIdsWithFilters?.length) return;
        (0, $ivaD7.setStateData)("mlsId", loadedSearchCriteria.realEstateDatasourceIdsWithFilters[0].realEstateDatasourceId, setState);
        (0, $ivaD7.setStateData)("searchCriteria", loadedSearchCriteria, setState);
    }, [
        loadedSearchCriteria
    ]);
    (0, $acw62.useEffect)(()=>{
        mlsProviders.current = membership;
    }, [
        membership
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!shouldRender) return;
        if (mlsId && mlsProviders.current) {
            const mlsName = mlsProviders.current.find((p)=>p?.mlsId === mlsId)?.shortDescription;
            (0, $ivaD7.setStateData)("mlsName", mlsName, setState);
        }
    }, [
        mlsProviders.current,
        search
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!shouldRender) return;
        if (state.agentsData != null) {
            const agentFound = state.agentsData.find((agent)=>agent.agentId === state.agentId);
            if (!agentFound) {
                redirectToHome();
                return;
            }
            (0, $ivaD7.setStateData)("agent", agentFound, setState);
        }
    }, [
        state.agentsData,
        state.agentId
    ]);
    if (!shouldRender) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {});
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e155p))), {
                className: "m-1 mb-2",
                children: !agent ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a4e7f1cc759aedc8$export$2e2bcd8739ae039), {
                    agent: agent,
                    index: queryTabIndex,
                    displayMode: displayMode,
                    intervalType: intervalType,
                    module: module,
                    shouldShowBackButton: true
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "content mt-2 pb-3 flex-grow-0",
                children: !listingDetailData ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {}) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                            className: "helix-display-small",
                            children: listingDetailData.address
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            children: [
                                listingDetailData.city,
                                ", ",
                                listingDetailData.state,
                                " ",
                                listingDetailData.zipCode,
                                " ",
                                listingDetailData.county
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "width-100",
                children: !listingDetailData ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8f390b0d641c1be9$export$2e2bcd8739ae039), {
                        tabTextTransform: "none",
                        navSize: 2,
                        contentSize: 2,
                        className: "secondary",
                        items: [
                            {
                                title: (0, $cstaF.agentProductionTerms).propertyInformation,
                                content: {
                                    jsx: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $06a5872b702ded2f$export$2e2bcd8739ae039), {
                                        data: listingDetailData,
                                        module: module,
                                        mlsName: state.mlsName
                                    })
                                }
                            },
                            {
                                title: (0, $cstaF.agentProductionTerms).pricingHistory,
                                content: {
                                    jsx: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dcaf3ebd1524c1f3$export$2e2bcd8739ae039), {
                                        data: listingHistoryData
                                    })
                                }
                            }
                        ],
                        tabs: true,
                        currentIndex: state.currentTabIndex,
                        setCurrentIndex: setCurrentTabIndex
                    })
                })
            })
        ]
    });
};
$deb2942a8ffbb165$var$ListingInformationPage.propTypes = {
    agentData: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        agentId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired
    })),
    module: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired
};
var $deb2942a8ffbb165$export$2e2bcd8739ae039 = $deb2942a8ffbb165$var$ListingInformationPage;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $4TPr9 = parcelRequire("4TPr9");

var $4fGPb = parcelRequire("4fGPb");
var $kfZjc = parcelRequire("kfZjc");

var $7tOHe = parcelRequire("7tOHe");



var $ivaD7 = parcelRequire("ivaD7");

var $cstaF = parcelRequire("cstaF");

var $cstaF = parcelRequire("cstaF");

var $eHBjM = parcelRequire("eHBjM");

var $htzEo = parcelRequire("htzEo");
const $37da398c10ef3899$var$getFilename = ({ agent: agent, mlsName: mlsName, dealStatus: dealStatus, selectedArea: selectedArea, timePeriod: timePeriod, timeIntervals: timeIntervals })=>{
    return (0, $cstaF.agentProductionTemplates).exportFilenames.transactionCoverageListings.replace("[AGENT_NAME]", agent?.agentName ?? "Agent").replace("[DEAL_STATUS]", dealStatus).replace("[SEARCH_AREA/MLS_NAME]", selectedArea.split((0, $cstaF.agentProductionTerms).listings)[0].trim() || mlsName).replace("[DOWNLOAD_DATE]", timePeriod ? $37da398c10ef3899$var$calcIntervalPeriod({
        timePeriod: timePeriod,
        timeIntervals: timeIntervals
    }) : (0, $htzEo.longDateFormat)(new Date())) + ".csv";
};
const $37da398c10ef3899$var$calcIntervalPeriod = ({ timePeriod: timePeriod, timeIntervals: timeIntervals })=>{
    if (!timeIntervals) return;
    if (timePeriod === (0, $cstaF.agentProductionTerms).last24Months) {
        const endDate = new Date();
        endDate.setDate(0);
        const startDate = new Date(endDate);
        startDate.setDate(1);
        startDate.setFullYear(endDate.getFullYear() - 2);
        return `${(0, $htzEo.monthAndYearFormat)(startDate)} - ${(0, $htzEo.monthAndYearFormat)(endDate)}`;
    } else {
        let selectedInterval = timeIntervals.find((t)=>t.intervalType === timePeriod);
        return `${(0, $htzEo.monthAndYearFormat)(selectedInterval.last.from)} - ${(0, $htzEo.monthAndYearFormat)(selectedInterval.last.to)}`;
    }
};
const $37da398c10ef3899$var$sortListingsByDate = (listingData, listingType)=>{
    return listingData.map((listing)=>({
            ...listing,
            listingType: listingType,
            formattedDate: (0, $htzEo.shortDateFormat)(listing.dateLast),
            bankProperty: (0, $htzEo.boolToShortString)(listing.bankProperty),
            pcDom: listing.pcDom ?? 0,
            lotSizeSquareFt: listing.lotSizeSquareFt ?? 0,
            lotSizeAcres: listing.lotSizeAcres ?? 0,
            ...listingType !== (0, $cstaF.agentProductionTerms).underContractListing && listingType !== (0, $cstaF.agentProductionTerms).forSaleListing && {
                splp: (0, $htzEo.percentChangeFormatter)(listing.splp),
                spop: (0, $htzEo.percentChangeFormatter)(listing.spop)
            }
        })).sort((a, b)=>new Date(b.dateLast).getTime() - new Date(a.dateLast).getTime());
};
const $37da398c10ef3899$var$getContentForExport = (data, dealStatus)=>{
    let headers = [];
    let listingData = [];
    const apt = (0, $cstaF.agentProductionTerms);
    const { totalSold: totalSold, sellSide: sellSide, listSide: listSide, underContract: underContract, forSale: forSale } = data;
    switch(dealStatus){
        case (0, $eHBjM.dealStatusCodes).SOLD.label:
            headers = [
                {
                    label: apt.status,
                    key: "listingType"
                },
                {
                    label: apt.mlsNum,
                    key: "mlsNum"
                },
                {
                    label: apt.type,
                    key: "typeName"
                },
                {
                    label: apt.stNumber,
                    key: "streetNum"
                },
                {
                    label: apt.street,
                    key: "streetName"
                },
                {
                    label: apt.address,
                    key: "address"
                },
                {
                    label: apt.city,
                    key: "city"
                },
                {
                    label: apt.zipCode,
                    key: "zipCode"
                },
                {
                    label: apt.area,
                    key: "areaId"
                },
                {
                    label: apt.bankProperty,
                    key: "bankProperty"
                },
                {
                    label: apt.originalPrice,
                    key: "orgPrice"
                },
                {
                    label: apt.listPrice,
                    key: "listPrice"
                },
                {
                    label: apt.soldPrice,
                    key: "lastPrice"
                },
                {
                    label: apt.priceChangeCnt,
                    key: "priceChangeCnt"
                },
                {
                    label: apt.spop,
                    key: "spop"
                },
                {
                    label: apt.splp,
                    key: "splp"
                },
                {
                    label: apt.soldDate,
                    key: "formattedDate"
                },
                {
                    label: apt.dom,
                    key: "dom"
                },
                {
                    label: apt.cdom,
                    key: "cdom"
                },
                {
                    label: apt.pcdom,
                    key: "pcDom"
                },
                {
                    label: apt.bd,
                    key: "bedrooms"
                },
                {
                    label: apt.ba,
                    key: "fullBaths"
                },
                {
                    label: apt.sqft,
                    key: "squareFt"
                },
                {
                    label: apt.dollarsPerSqft,
                    key: "pricePerSquareFt"
                },
                {
                    label: apt.lotSizeSqft,
                    key: "lotSizeSquareFt"
                },
                {
                    label: apt.lotSizeAcres,
                    key: "lotSizeAcres"
                },
                {
                    label: apt.yearBuilt,
                    key: "yearBuilt"
                },
                {
                    label: apt.listAgent,
                    key: "listAgent"
                },
                {
                    label: apt.sellAgent,
                    key: "sellAgent"
                },
                {
                    label: apt.dbl,
                    key: "doubleSided"
                }
            ];
            const total = $37da398c10ef3899$var$sortListingsByDate(totalSold, apt.totalSoldListing);
            const list = $37da398c10ef3899$var$sortListingsByDate(listSide, apt.listSoldListing);
            const sell = $37da398c10ef3899$var$sortListingsByDate(sellSide, apt.sellSoldListing);
            listingData = [
                ...total,
                ...list,
                ...sell
            ];
            break;
        case (0, $eHBjM.dealStatusCodes).UNDER_CONTRACT.label:
            headers = [
                {
                    label: apt.status,
                    key: "listingType"
                },
                {
                    label: apt.officeId,
                    key: "officeId"
                },
                {
                    label: apt.officeName,
                    key: "officeName"
                },
                {
                    label: apt.mlsNum,
                    key: "mlsNum"
                },
                {
                    label: apt.type,
                    key: "typeName"
                },
                {
                    label: apt.stNumber,
                    key: "streetNum"
                },
                {
                    label: apt.street,
                    key: "streetName"
                },
                {
                    label: apt.address,
                    key: "address"
                },
                {
                    label: apt.city,
                    key: "city"
                },
                {
                    label: apt.zipCode,
                    key: "zipCode"
                },
                {
                    label: apt.area,
                    key: "areaId"
                },
                {
                    label: apt.originalPrice,
                    key: "orgPrice"
                },
                {
                    label: apt.listPrice,
                    key: "listPrice"
                },
                {
                    label: apt.price,
                    key: "lastPrice"
                },
                {
                    label: apt.ucDate,
                    key: "formattedDate"
                },
                {
                    label: apt.dom,
                    key: "dom"
                },
                {
                    label: apt.cdom,
                    key: "cdom"
                },
                {
                    label: apt.bankProperty,
                    key: "bankProperty"
                },
                {
                    label: apt.listAgent,
                    key: "listAgent"
                }
            ];
            const under = $37da398c10ef3899$var$sortListingsByDate(underContract, apt.underContractListing);
            listingData = [
                ...under
            ];
            break;
        case (0, $eHBjM.dealStatusCodes).ACTIVE.label:
            headers = [
                {
                    label: apt.status,
                    key: "listingType"
                },
                {
                    label: apt.officeId,
                    key: "officeId"
                },
                {
                    label: apt.officeName,
                    key: "officeName"
                },
                {
                    label: apt.mlsNum,
                    key: "mlsNum"
                },
                {
                    label: apt.type,
                    key: "typeName"
                },
                {
                    label: apt.stNumber,
                    key: "streetNum"
                },
                {
                    label: apt.street,
                    key: "streetName"
                },
                {
                    label: apt.address,
                    key: "address"
                },
                {
                    label: apt.city,
                    key: "city"
                },
                {
                    label: apt.zipCode,
                    key: "zipCode"
                },
                {
                    label: apt.area,
                    key: "areaId"
                },
                {
                    label: apt.originalPrice,
                    key: "orgPrice"
                },
                {
                    label: apt.listPrice,
                    key: "listPrice"
                },
                {
                    label: apt.price,
                    key: "lastPrice"
                },
                {
                    label: apt.listDate,
                    key: "formattedDate"
                },
                {
                    label: apt.dom,
                    key: "dom"
                },
                {
                    label: apt.cdom,
                    key: "cdom"
                },
                {
                    label: apt.bankProperty,
                    key: "bankProperty"
                },
                {
                    label: apt.listAgent,
                    key: "listAgent"
                }
            ];
            const sale = $37da398c10ef3899$var$sortListingsByDate(forSale, apt.forSaleListing);
            listingData = [
                ...sale
            ];
            break;
    }
    return {
        headers: headers,
        data: listingData
    };
};
const $37da398c10ef3899$export$fffd2ec7c8817fdd = ({ data: data, agent: agent, mlsName: mlsName, isShowExportButton: isShowExportButton, dealStatus: dealStatus, selectedArea: selectedArea, timePeriod: timePeriod, timeIntervals: timeIntervals })=>{
    const dataForExport = $37da398c10ef3899$var$getContentForExport(data, dealStatus);
    if (!dataForExport.data || !dataForExport.data.length) return {
        isVisible: false
    };
    const filename = $37da398c10ef3899$var$getFilename({
        agent: agent,
        mlsName: mlsName,
        dealStatus: dealStatus,
        selectedArea: selectedArea,
        timePeriod: timePeriod,
        timeIntervals: timeIntervals
    });
    return {
        headers: dataForExport.headers,
        data: dataForExport.data,
        filename: filename,
        isVisible: isShowExportButton
    };
};



var $eHBjM = parcelRequire("eHBjM");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $cstaF = parcelRequire("cstaF");
const $28e0eba33e84b50e$export$a254f259142c82e8 = {
    dataLwtId: "export",
    color: "secondary",
    className: "bg-dark export-share-button m-0 btn-sm mr-1 mt-2",
    disabled: true,
    isVisible: false
};
const $28e0eba33e84b50e$var$ExportButton = (props)=>{
    const { headers: headers, data: data = "", filename: filename, isVisible: isVisible } = props;
    const csvLink = (0, $acw62.useRef)();
    if (!isVisible) return null;
    const handleDirectExportClick = ()=>{
        csvLink.current?.link?.click();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                ...$28e0eba33e84b50e$export$a254f259142c82e8,
                disabled: data?.length === 0,
                onClick: handleDirectExportClick,
                children: (0, $cstaF.agentProductionTerms).export
            }),
            headers && data && filename && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8ad2a4b51964960$exports.CSVLink), {
                headers: headers,
                data: data,
                ref: csvLink,
                filename: filename,
                className: "hidden",
                target: "_blank"
            })
        ]
    });
};
var $28e0eba33e84b50e$export$2e2bcd8739ae039 = $28e0eba33e84b50e$var$ExportButton;



var $g3CkB = parcelRequire("g3CkB");

var $ekOct = parcelRequire("ekOct");

var $90ISC = parcelRequire("90ISC");

var $24YIE = parcelRequire("24YIE");

var $l05Px = parcelRequire("l05Px");

var $4tbBr = parcelRequire("4tbBr");

var $dDBOF = parcelRequire("dDBOF");

var $fPGDZ = parcelRequire("fPGDZ");
const $e37a02ae50f645aa$var$AgentCoverageListing = ({ module: module })=>{
    const history = (0, $kfZjc.useHistory)();
    const location = (0, $kfZjc.useLocation)();
    const { membership: membership, timeIntervals: timeIntervals, agentMetricsAgentProfileData: agentMetricsAgentProfileData } = (0, $90ISC.useCommonStore)((state)=>{
        const agentInfo = state?.agentInfo?.[0];
        const agentMetricsAgentProfileData = {
            agentId: agentInfo?.mlsAgentId?.agentId,
            mlsSid: agentInfo?.mlsAgentId?.mlsId,
            agentName: `${agentInfo?.firstName} ${agentInfo?.lastName}`,
            officeName: agentInfo?.office?.name
        };
        return {
            membership: state.membership,
            timeIntervals: state.timeIntervals,
            agentMetricsAgentProfileData: agentMetricsAgentProfileData
        };
    });
    const incomingState = (0, $acw62.useRef)(location.state);
    const [state, setState] = (0, $acw62.useState)({
        isShowAgentListingView: true,
        intervalType: null,
        agent: incomingState.current?.agent ?? agentMetricsAgentProfileData,
        criteriaObj: null,
        mlsId: null,
        mlsName: null,
        agentId: null,
        areaType: null,
        areaList: null,
        tableType: null,
        currentTab: null,
        selectOptions: [],
        timeIntervals: null,
        exportProps: {
            headers: null,
            data: null,
            filename: null,
            isVisible: true
        }
    });
    const { selectedAgentId: selectedAgentId, selectedMlsId: selectedMlsId, areaType: areaType, areaList: areaList, tableType: tableType, isUnits: isUnits, agentCoverageListingTab: agentCoverageListingTab, timePeriod: timePeriod, selectedArea: selectedArea, displayMode: displayMode, setSelectedArea: setSelectedArea, setAgentCoverageListingTab: setAgentCoverageListingTab } = (0, $90ISC.useAgentProfileStore)((state)=>({
            selectedAgentId: state.selectedAgentId ?? agentMetricsAgentProfileData?.agentId,
            selectedMlsid: state.selectedMlsId,
            areaType: state.areaType,
            areaList: state.areaList,
            tableType: state.tableType,
            isUnits: state.isUnits,
            agentCoverageListingTab: state.agentCoverageListingTab,
            timePeriod: state.timePeriod,
            selectedArea: state.selectedArea,
            displayMode: state.displayMode,
            setSelectedArea: state.setSelectedArea,
            setAgentCoverageListingTab: state.setAgentCoverageListingTab
        }));
    const { search: search, loadedSearchCriteria: loadedSearchCriteria } = (0, $90ISC.useSearchStore)((state)=>({
            search: state[module]?.search,
            loadedSearchCriteria: state[module]?.loadedSearchCriteria
        }));
    const [isLoading, setIsLoading] = (0, $acw62.useState)(true);
    const [totalSoldData, setTotalSoldData] = (0, $acw62.useState)([]);
    const [listSideData, setListSideData] = (0, $acw62.useState)([]);
    const [sellSideData, setSellSideData] = (0, $acw62.useState)([]);
    const [forSaleData, setForSaleDataData] = (0, $acw62.useState)([]);
    const [underContractData, setUnderContractDataData] = (0, $acw62.useState)([]);
    const shouldRender = !!module;
    (0, $acw62.useEffect)(()=>{
        setSelectedArea({
            value: incomingState.current?.selectedArea,
            label: `${incomingState.current?.selectedArea} ${(0, $cstaF.agentProductionTerms).listings}`
        });
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!shouldRender) history.push("/");
    }, []);
    (0, $acw62.useEffect)(()=>{
        (0, $ivaD7.setStateData)("agentId", selectedAgentId, setState);
    }, [
        selectedAgentId
    ]);
    (0, $acw62.useEffect)(()=>{
        (0, $ivaD7.setStateData)("mlsId", selectedMlsId, setState);
    }, [
        selectedMlsId
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!shouldRender) return;
        let selectOptions = state.areaList?.length && state.areaList?.map((area)=>{
            return {
                value: area,
                label: `${area} ${(0, $cstaF.agentProductionTerms).listings}`
            };
        });
        let option;
        if (incomingState.current.selectedArea === selectedArea?.value) option = selectOptions?.splice(selectOptions?.findIndex((option)=>option.value === incomingState.current.selectedArea), 1);
        else option = selectOptions?.splice(selectOptions?.findIndex((option)=>option.value === selectedArea?.value), 1);
        selectOptions?.unshift(option[0]);
        setState((prevState)=>{
            return {
                ...prevState,
                selectOptions: selectOptions
            };
        });
    }, [
        selectedArea,
        state.areaList
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!shouldRender) return;
        if (!incomingState.current) window.location.replace((0, $ekOct.getFirstToolRoute)());
    }, [
        incomingState
    ]);
    let mlsProviders = (0, $acw62.useRef)([]);
    (0, $acw62.useEffect)(()=>{
        (0, $ivaD7.setStateData)("areaList", areaList, setState);
    }, [
        areaList
    ]);
    (0, $acw62.useEffect)(()=>{
        (0, $ivaD7.setStateData)("areaType", areaType, setState);
    }, [
        areaType
    ]);
    (0, $acw62.useEffect)(()=>{
        (0, $ivaD7.setStateData)("tableType", tableType, setState);
    }, [
        tableType
    ]);
    (0, $acw62.useEffect)(()=>{
        (0, $ivaD7.setStateData)("intervalType", timePeriod, setState);
    }, [
        timePeriod
    ]);
    (0, $acw62.useEffect)(()=>{
        (0, $ivaD7.setStateData)("isUnits", isUnits, setState);
    }, [
        isUnits
    ]);
    (0, $acw62.useEffect)(()=>{
        (0, $ivaD7.setStateData)("currentTab", agentCoverageListingTab, setState);
    }, [
        agentCoverageListingTab
    ]);
    (0, $acw62.useEffect)(()=>{
        mlsProviders.current = membership;
    }, [
        membership
    ]);
    (0, $acw62.useEffect)(()=>{
        if (loadedSearchCriteria?.realEstateDatasourceIdsWithFilters?.length) setState((prevState)=>({
                ...prevState,
                criteriaObj: loadedSearchCriteria
            }));
        if (0, $dDBOF.isAgentMetrics) (0, $ivaD7.setStateData)("criteriaObj", (0, $fPGDZ.getAmSearchCriteria)(agentMetricsAgentProfileData.mlsSid), setState);
    }, [
        loadedSearchCriteria
    ]);
    (0, $acw62.useEffect)(()=>{
        if (search?.mlsId && mlsProviders.current) {
            const mlsName = mlsProviders.current.find((p)=>p?.mlsId === search.mlsId)?.shortDescription;
            (0, $ivaD7.setStateData)("mlsName", mlsName, setState);
        }
    }, [
        search
    ]);
    (0, $acw62.useEffect)(()=>{
        if (timeIntervals) (0, $ivaD7.setStateData)("timeIntervals", timeIntervals, setState);
    }, [
        timeIntervals
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!shouldRender) return;
        let forParent = {};
        switch(state.tableType?.label){
            case (0, $eHBjM.dealStatusCodes).SOLD.label:
                forParent = {
                    shouldShowExportButton: true,
                    data: {
                        totalSold: totalSoldData,
                        listSide: listSideData,
                        sellSide: sellSideData
                    },
                    period: state.intervalType,
                    timeIntervals: state.timeIntervals
                };
                processExportProps(forParent);
                break;
            case (0, $eHBjM.dealStatusCodes).UNDER_CONTRACT.label:
                forParent = {
                    shouldShowExportButton: true,
                    data: {
                        underContract: underContractData
                    }
                };
                processExportProps(forParent);
                break;
            case (0, $eHBjM.dealStatusCodes).ACTIVE.label:
                forParent = {
                    shouldShowExportButton: true,
                    data: {
                        forSale: forSaleData
                    }
                };
                processExportProps(forParent);
                break;
        }
    }, [
        totalSoldData,
        sellSideData,
        listSideData,
        underContractData,
        forSaleData,
        selectedArea,
        state.tableType,
        state.intervalType,
        state.timeIntervals
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!shouldRender) return;
        if (state.intervalType && state.criteriaObj) {
            const getRequestProps = (statusCode)=>{
                const areaName = selectedArea.value.split(" ");
                const areaType = state.areaType === "area_id";
                return {
                    criteria: state.criteriaObj,
                    agentId: state.agentId,
                    mlsId: state.mlsId,
                    areaType: (0, $cstaF.areaRequestTypes)[state.areaType],
                    statusCode: statusCode,
                    areaName: areaType ? areaName[0] : selectedArea.value,
                    intervalType: state.intervalType
                };
            };
            setIsLoading(true);
            switch(state.tableType?.label){
                case (0, $eHBjM.dealStatusCodes).SOLD.label:
                    (0, $24YIE.getAgentTransactionCoverageDrillDown)(getRequestProps("SoldBothSides")).then((data)=>{
                        setTotalSoldData(data);
                        setIsLoading(false);
                    });
                    (0, $24YIE.getAgentTransactionCoverageDrillDown)(getRequestProps("SoldListSide")).then((data)=>{
                        setListSideData(data);
                        setIsLoading(false);
                    });
                    (0, $24YIE.getAgentTransactionCoverageDrillDown)(getRequestProps("SoldSellSide")).then((data)=>{
                        setSellSideData(data);
                        setIsLoading(false);
                    });
                    break;
                case (0, $eHBjM.dealStatusCodes).UNDER_CONTRACT.label:
                    (0, $24YIE.getAgentTransactionCoverageDrillDown)(getRequestProps("UnderContract")).then((data)=>{
                        setUnderContractDataData(data);
                        setIsLoading(false);
                    });
                    break;
                case (0, $eHBjM.dealStatusCodes).ACTIVE.label:
                    (0, $24YIE.getAgentTransactionCoverageDrillDown)(getRequestProps("ForSale")).then((data)=>{
                        setForSaleDataData(data);
                        setIsLoading(false);
                    });
                    break;
            }
        }
    }, [
        state.intervalType,
        state.criteriaObj,
        selectedArea
    ]);
    if (!shouldRender) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {});
    const changeSelectedArea = (option)=>{
        setSelectedArea(option);
    };
    const processExportProps = (fromAgentListings)=>{
        const { shouldShowExportButton: shouldShowExportButton, data: data, period: period, timeIntervals: timeIntervals } = fromAgentListings;
        const isShowExportButton = shouldShowExportButton;
        const paramsGetExportButtonProps = {
            isShowExportButton: isShowExportButton,
            agent: state.agent,
            mlsName: state.mlsName,
            dealStatus: state.tableType.label,
            selectedArea: selectedArea.label,
            data: data,
            timePeriod: period,
            timeIntervals: timeIntervals
        };
        const exportProps = (0, $37da398c10ef3899$export$fffd2ec7c8817fdd)(paramsGetExportButtonProps);
        (0, $ivaD7.setStateData)("exportProps", exportProps, setState);
    };
    const selectDefaultValue = {
        value: incomingState.current?.selectedArea,
        label: `${incomingState.current?.selectedArea} ${(0, $cstaF.agentProductionTerms).listings}`
    };
    const setCurrentTab = (index)=>{
        setAgentCoverageListingTab(index);
    };
    const selectStyles = {
        control: (0, $g3CkB.selectMouseoverStyle),
        option: (0, $g3CkB.selectMouseoverStyle)
    };
    const tabByStatus = {
        [(0, $eHBjM.dealStatusCodes).SOLD.label]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8f390b0d641c1be9$export$2e2bcd8739ae039), {
            tabTextTransform: "none",
            className: "mt-2 secondary",
            navSize: 2,
            contentSize: 2,
            tabs: true,
            currentIndex: state.currentTab,
            setCurrentIndex: (index)=>setCurrentTab(index),
            items: [
                {
                    title: (0, $eHBjM.listingOptions).totalSold,
                    content: {
                        jsx: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt-3",
                            children: isLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l05Px.default), {
                                tableView: (0, $4tbBr.tableViews).agentCoverageListingSold,
                                rowData: totalSoldData,
                                tableTitleWithTooltips: (0, $eHBjM.coverageListingsTooltips)
                            })
                        })
                    }
                },
                {
                    title: (0, $eHBjM.listingOptions).listSide,
                    content: {
                        jsx: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt-3",
                            children: isLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l05Px.default), {
                                tableView: (0, $4tbBr.tableViews).agentCoverageListingSold,
                                tableTitleWithTooltips: (0, $eHBjM.coverageListingsTooltips),
                                rowData: listSideData
                            })
                        })
                    }
                },
                {
                    title: (0, $eHBjM.listingOptions).sellSide,
                    content: {
                        jsx: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt-3",
                            children: isLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l05Px.default), {
                                tableView: (0, $4tbBr.tableViews).agentCoverageListingSold,
                                tableTitleWithTooltips: (0, $eHBjM.coverageListingsTooltips),
                                rowData: sellSideData
                            })
                        })
                    }
                }
            ]
        }),
        [(0, $eHBjM.dealStatusCodes).UNDER_CONTRACT.label]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8f390b0d641c1be9$export$2e2bcd8739ae039), {
            tabTextTransform: "none",
            className: "mt-2 secondary",
            navSize: 2,
            contentSize: 2,
            tabs: true,
            currentIndex: 0,
            items: [
                {
                    title: (0, $eHBjM.dealStatusCodes).UNDER_CONTRACT.label,
                    content: {
                        jsx: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt-3",
                            children: isLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l05Px.default), {
                                tableView: (0, $4tbBr.tableViews).agentCoverageListingUc,
                                tableTitleWithTooltips: (0, $eHBjM.coverageListingsTooltips),
                                rowData: underContractData
                            })
                        })
                    }
                }
            ]
        }),
        [(0, $eHBjM.dealStatusCodes).ACTIVE.label]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8f390b0d641c1be9$export$2e2bcd8739ae039), {
            tabTextTransform: "none",
            className: "mt-2 secondary",
            navSize: 2,
            contentSize: 2,
            tabs: true,
            currentIndex: 0,
            items: [
                {
                    title: (0, $eHBjM.dealStatusCodes).ACTIVE.label,
                    content: {
                        jsx: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt-3",
                            children: isLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l05Px.default), {
                                tableView: (0, $4tbBr.tableViews).agentCoverageListingForSale,
                                tableTitleWithTooltips: (0, $eHBjM.coverageListingsTooltips),
                                rowData: forSaleData
                            })
                        })
                    }
                }
            ]
        })
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "m-1 mb-2 row",
                children: [
                    incomingState.current?.agent && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a4e7f1cc759aedc8$export$2e2bcd8739ae039), {
                        agent: incomingState.current?.agent,
                        isShowAgentListingView: state.isShowAgentListingView,
                        isCoverageListing: true,
                        index: 2,
                        displayMode: displayMode,
                        statusType: state.tableType?.value,
                        isUnits: isUnits,
                        intervalType: state.intervalType,
                        areaType: state.areaType,
                        module: module,
                        shouldShowBackButton: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "d-flex ml-sm-auto align-self-center",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $28e0eba33e84b50e$export$2e2bcd8739ae039), {
                            ...state.exportProps
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "content mt-2 pb-3 d-flex flex-column listing-content",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "agent-coverage-listings-header",
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "d-flex align-items-center",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $4fGPb.Link), {
                                    className: "btn btn-link w-max text-decoration-none agent-coverage-listing-breadcrumb",
                                    to: (0, $eHBjM.agentProfileRoute) + "?id=" + incomingState.current?.agent.agentId + "&tabIndex=2&graphStatusType=" + state.tableType?.value + "&isUnits=" + isUnits + "&timeInterval=" + state?.intervalType + "&areaType=" + state?.areaType + "&displayMode=" + displayMode,
                                    children: [
                                        "Transaction Coverage ",
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                            children: ">"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4TPr9.default), {
                                    dataLwtId: "agent-coverage-listing",
                                    onChange: changeSelectedArea,
                                    className: "agent-coverage-listing-select",
                                    isClearable: false,
                                    options: state.selectOptions,
                                    defaultValue: selectDefaultValue,
                                    styles: selectStyles
                                })
                            ]
                        })
                    }),
                    tabByStatus[state.tableType?.label]
                ]
            })
        ]
    });
};
$e37a02ae50f645aa$var$AgentCoverageListing.propTypes = {
    module: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};
var $e37a02ae50f645aa$export$2e2bcd8739ae039 = $e37a02ae50f645aa$var$AgentCoverageListing;



var $ivaD7 = parcelRequire("ivaD7");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $kfZjc = parcelRequire("kfZjc");

var $4TPr9 = parcelRequire("4TPr9");

parcelRequire("3lOdM");
var $e155p = parcelRequire("e155p");

var $7tOHe = parcelRequire("7tOHe");

var $ivaD7 = parcelRequire("ivaD7");


var $htzEo = parcelRequire("htzEo");

var $6IhJz = parcelRequire("6IhJz");

var $cstaF = parcelRequire("cstaF");

var $htzEo = parcelRequire("htzEo");
const $98f29f429b581579$var$getFilename = ({ agent: agent, mlsName: mlsName, period: period })=>{
    return (0, $cstaF.agentProductionTemplates).exportFilenames.productionAgentListings.replace("[AGENT_NAME]", agent?.agentName).replace("[SEARCH_AREA/MLS_NAME]", mlsName).replace("[TIME_PERIOD]", period) + ".csv";
};
const $98f29f429b581579$var$getContentForExport = (data)=>{
    const { totalSold: totalSold, sellSide: sellSide, listSide: listSide } = data;
    const apt = (0, $cstaF.agentProductionTerms);
    const headers = [
        {
            label: apt.status,
            key: "listingType"
        },
        {
            label: apt.mlsNum,
            key: "mlsNum"
        },
        {
            label: apt.type,
            key: "typeName"
        },
        {
            label: apt.stNumber,
            key: "streetNum"
        },
        {
            label: apt.street,
            key: "streetName"
        },
        {
            label: apt.address,
            key: "address"
        },
        {
            label: apt.city,
            key: "city"
        },
        {
            label: apt.zip,
            key: "zipCode"
        },
        {
            label: apt.area,
            key: "areaId"
        },
        {
            label: apt.bankProperty,
            key: "bankProperty"
        },
        {
            label: apt.originalPrice,
            key: "orgPrice"
        },
        {
            label: apt.listPrice,
            key: "listPrice"
        },
        {
            label: apt.soldPrice,
            key: "lastPrice"
        },
        {
            label: apt.priceChangeCnt,
            key: "priceChangeCnt"
        },
        {
            label: apt.spop,
            key: "spop"
        },
        {
            label: apt.splp,
            key: "splp"
        },
        {
            label: apt.soldDate,
            key: "formattedSoldDate"
        },
        {
            label: apt.dom,
            key: "dom"
        },
        {
            label: apt.cdom,
            key: "cdom"
        },
        {
            label: apt.pcdom,
            key: "pcDom"
        },
        {
            label: apt.bd,
            key: "bedrooms"
        },
        {
            label: apt.ba,
            key: "bathrooms"
        },
        {
            label: apt.sqft,
            key: "squareFt"
        },
        {
            label: apt.dollarsPerSqft,
            key: "pricePerSquareFt"
        },
        {
            label: apt.lotSizeSqft,
            key: "lotSizeSquareFt"
        },
        {
            label: apt.lotSizeAcres,
            key: "lotSizeAcres"
        },
        {
            label: apt.yearBuilt,
            key: "yearBuilt"
        },
        {
            label: apt.listAgent,
            key: "listAgent"
        },
        {
            label: apt.sellAgent,
            key: "sellAgent"
        },
        {
            label: apt.dbl,
            key: "doubleSided"
        }
    ];
    const total = totalSold.map((listing)=>({
            ...listing,
            listingType: "Total Sold List + Sell",
            formattedSoldDate: (0, $6IhJz.default)(new Date(listing.dateLast), "MM-dd-yyyy"),
            bankProperty: (0, $htzEo.boolToShortString)(listing.bankStatus),
            splp: (0, $htzEo.formatStandardPct)(listing.splp),
            spop: (0, $htzEo.formatStandardPct)(listing.spop)
        })).sort((a, b)=>new Date(b.dateLast).getTime() - new Date(a.dateLast).getTime());
    const list = listSide.map((listing)=>({
            ...listing,
            listingType: "Sold List-Side",
            formattedSoldDate: (0, $6IhJz.default)(new Date(listing.dateLast), "MM-dd-yyyy"),
            bankProperty: (0, $htzEo.boolToShortString)(listing.bankStatus),
            splp: (0, $htzEo.formatStandardPct)(listing.splp),
            spop: (0, $htzEo.formatStandardPct)(listing.spop)
        })).sort((a, b)=>new Date(b.dateLast).getTime() - new Date(a.dateLast).getTime());
    const sell = sellSide.map((listing)=>({
            ...listing,
            listingType: "Sold Sell-Side",
            formattedSoldDate: (0, $6IhJz.default)(new Date(listing.dateLast), "MM-dd-yyyy"),
            bankProperty: (0, $htzEo.boolToShortString)(listing.bankStatus),
            splp: (0, $htzEo.formatStandardPct)(listing.splp),
            spop: (0, $htzEo.formatStandardPct)(listing.spop)
        })).sort((a, b)=>new Date(b.dateLast).getTime() - new Date(a.dateLast).getTime());
    const listingData = [
        ...total,
        ...list,
        ...sell
    ];
    return {
        headers: headers,
        data: listingData
    };
};
const $98f29f429b581579$export$fffd2ec7c8817fdd = ({ data: data, agent: agent, mlsName: mlsName, isShowExportButton: isShowExportButton, period: period })=>{
    const dataForExport = $98f29f429b581579$var$getContentForExport(data);
    if (!dataForExport.data || !dataForExport.data.length) return {
        isVisible: false
    };
    const filename = $98f29f429b581579$var$getFilename({
        agent: agent,
        mlsName: mlsName,
        period: period
    });
    return {
        headers: dataForExport.headers,
        data: dataForExport.data,
        filename: filename,
        isVisible: isShowExportButton
    };
};




var $bq4QZ = parcelRequire("bq4QZ");

var $c7dF9 = parcelRequire("c7dF9");

var $g3CkB = parcelRequire("g3CkB");

var $eHBjM = parcelRequire("eHBjM");

var $90ISC = parcelRequire("90ISC");

var $24YIE = parcelRequire("24YIE");

var $4tbBr = parcelRequire("4tbBr");

var $l05Px = parcelRequire("l05Px");

var $dDBOF = parcelRequire("dDBOF");
const $a18a0232cc648c72$export$dfc0309301032959 = ({ agentData: agentData, module: module })=>{
    let query = (0, $bq4QZ.useQuery)();
    const id = query.get("id");
    const selectedPeriod = query.get("period")?.split(" ").join(" 20");
    const queryTabIndex = query.get("tabIndex");
    const queryIntervalType = query.get("intervalType");
    const history = (0, $kfZjc.useHistory)();
    const { membership: membership, agentMetricsMlsId: agentMetricsMlsId, agentMetricsAgentProfileData: agentMetricsAgentProfileData } = (0, $90ISC.useCommonStore)((state)=>{
        const mlsAgent = state?.agentInfo?.[0]?.mlsAgentId;
        const agentInfo = state?.agentInfo?.[0];
        const agentMetricsAgentProfileData = {
            agentId: agentInfo?.mlsAgentId?.agentId,
            mlsSid: agentInfo?.mlsAgentId?.mlsId,
            agentName: `${agentInfo?.firstName} ${agentInfo?.lastName}`,
            officeName: agentInfo?.office?.name
        };
        return {
            membership: state.membership,
            agentMetricsMlsId: mlsAgent?.mlsId,
            agentMetricsAgentProfileData: agentMetricsAgentProfileData
        };
    });
    const { search: search, loadedSearchCriteria: loadedSearchCriteria } = (0, $90ISC.useSearchStore)((state)=>({
            search: state[module]?.search,
            loadedSearchCriteria: state[module]?.loadedSearchCriteria
        }));
    const { currentTab: currentTab, setCurrentTab: setCurrentTab, setTimePeriod: setTimePeriod } = (0, $90ISC.useAgentProfileStore)((state)=>({
            currentTab: state.currentTab,
            setCurrentTab: state.setCurrentTab,
            setTimePeriod: state.setTimePeriod
        }));
    const [state, setState] = (0, $acw62.useState)({
        agentsData: null,
        agentId: id,
        agent: null,
        mlsId: null,
        mlsName: null,
        monthlyProductions: [],
        selectOptions: [],
        intervalType: null,
        totalSoldData: [],
        selectedPeriod: selectedPeriod,
        exportProps: {
            headers: null,
            data: null,
            filename: null,
            isVisible: false
        }
    });
    const [totalSoldData, setTotalSoldData] = (0, $acw62.useState)([]);
    const [listSideData, setListSideData] = (0, $acw62.useState)([]);
    const [sellSideData, setSellSideData] = (0, $acw62.useState)([]);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(true);
    const dateOptions = {
        year: "numeric",
        month: "short"
    };
    const getListingsByPeriod = (data)=>{
        return data.map((listing)=>({
                ...listing,
                id: "id" + Math.random().toString(16).slice(2),
                soldDateShort: new Date(listing.dateLast).toLocaleDateString("default", dateOptions),
                bankStatus: (0, $htzEo.boolToShortString)(listing.bankStatus),
                pcDom: listing.pcDom ?? 0,
                bedrooms: listing.bedrooms ?? 0,
                bathrooms: listing.fullBaths ?? 0,
                pricePerSquareFt: listing.pricePerSquareFt ? (0, $htzEo.formatVolumeOrDays)(listing.pricePerSquareFt, true) : "",
                squareFt: listing.squareFt ?? 0,
                lotSizeSquareFt: listing.lotSizeSquareFt ?? 0,
                lotSizeAcres: listing.lotSizeAcres ?? 0,
                yearBuilt: listing.yearBuilt > 0 ? listing.yearBuilt : ""
            })).filter((listing)=>state.selectedPeriod.toLowerCase() === listing.soldDateShort.toLowerCase());
    };
    const agent = state.agent ?? agentMetricsAgentProfileData;
    const processExportProps = (fromAgentListings)=>{
        const { shouldShowExportButton: shouldShowExportButton, data: data, period: period } = fromAgentListings;
        const isShowExportButton = shouldShowExportButton;
        let agentMlsName = state.mlsName;
        if ((0, $dDBOF.isAgentMetrics) && agent && Array.isArray(mlsProviders.current)) {
            const agentMls = mlsProviders.current?.find((p)=>p?.mlsId === agent.mlsId);
            agentMlsName = agentMls?.shortDescription || agent.mlsName || state.mlsName;
        }
        const paramsGetExportButtonProps = {
            isShowExportButton: isShowExportButton,
            agent: agent,
            mlsName: agentMlsName,
            period: period,
            data: data,
            timePeriod: state.productionTimePeriod
        };
        const exportProps = (0, $98f29f429b581579$export$fffd2ec7c8817fdd)(paramsGetExportButtonProps);
        (0, $ivaD7.setStateData)("exportProps", exportProps, setState);
    };
    let mlsProviders = (0, $acw62.useRef)([]);
    const shouldRender = !!module;
    (0, $acw62.useEffect)(()=>{
        if (!shouldRender) history.push("/");
        setCurrentTab(parseInt(queryTabIndex) || 0);
        setTimePeriod(selectedPeriod);
    }, []);
    (0, $acw62.useEffect)(()=>{
        mlsProviders.current = membership;
    }, [
        membership
    ]);
    (0, $acw62.useEffect)(()=>{
        if (loadedSearchCriteria?.realEstateDatasourceIdsWithFilters?.length) {
            (0, $ivaD7.setStateData)("mlsId", loadedSearchCriteria.realEstateDatasourceIdsWithFilters[0].realEstateDatasourceId, setState);
            (0, $ivaD7.setStateData)("intervalType", loadedSearchCriteria.timePeriod.intervalType, setState);
        }
    }, [
        loadedSearchCriteria
    ]);
    (0, $acw62.useEffect)(()=>{
        if (agentData) {
            const revisedData = (0, $htzEo.mapIdToTableData)(agentData?.agMovAgentBreakdownSearch || agentData);
            (0, $ivaD7.setStateData)("agentsData", revisedData || [], setState);
        }
    }, [
        agentData
    ]);
    (0, $acw62.useEffect)(()=>{
        const mlsId = state.mlsId || agentMetricsMlsId;
        if (mlsId && Array.isArray(mlsProviders.current) && mlsProviders.current.length) {
            const mlsName = mlsProviders.current.find((p)=>p?.mlsId === mlsId)?.shortDescription;
            (0, $ivaD7.setStateData)("mlsName", mlsName, setState);
        }
    }, [
        search
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!shouldRender) return;
        if (state.agentsData != null) {
            const agentFound = state.agentsData.find((agent)=>agent.agentId === state.agentId);
            if (agentFound) setState({
                ...state,
                agent: agentFound
            });
            else window.location.replace((0, $c7dF9.Routes).PROF_METRICS.BASE);
        }
    }, [
        state.agentsData
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!shouldRender) return;
        const mlsId = state.mlsId || agentMetricsMlsId;
        const historyRequestProps = {
            agentId: state.agentId,
            mlsId: mlsId
        };
        if (mlsId) (0, $24YIE.getAgentHistory)(historyRequestProps).then((data)=>{
            (0, $ivaD7.setStateData)("monthlyProductions", data.monthlyProductions, setState);
        });
    }, [
        state.mlsId
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!shouldRender) return;
        if (state.intervalType || (0, $dDBOF.isAgentMetrics)) {
            const getRequestProps = (listingType)=>{
                return {
                    agentId: state.agentId,
                    realEstateDatasourceId: state.mlsId ?? agentMetricsMlsId,
                    intervalType: queryIntervalType,
                    listingType: listingType
                };
            };
            const getTotalSoldData = (0, $24YIE.getAgentListingDetailDrillDown)(getRequestProps("SoldBothSides")).then((data)=>setTotalSoldData(data));
            const getListSideData = (0, $24YIE.getAgentListingDetailDrillDown)(getRequestProps("SoldListSide")).then((data)=>setListSideData(data));
            const getSellSideData = (0, $24YIE.getAgentListingDetailDrillDown)(getRequestProps("SoldSellSide")).then((data)=>setSellSideData(data));
            Promise.all([
                getTotalSoldData,
                getListSideData,
                getSellSideData
            ]).then(()=>setIsLoading(false));
        }
    }, [
        state.intervalType
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!shouldRender) return;
        const datePeriodOption = {
            year: "numeric",
            month: "long"
        };
        const period = totalSoldData.length ? new Date(getListingsByPeriod(totalSoldData)[0]?.dateLast).toLocaleDateString("default", datePeriodOption) : state.selectedPeriod;
        const forParent = {
            shouldShowExportButton: true,
            data: {
                totalSold: [
                    ...getListingsByPeriod(totalSoldData)
                ],
                listSide: [
                    ...getListingsByPeriod(listSideData)
                ],
                sellSide: [
                    ...getListingsByPeriod(sellSideData)
                ]
            },
            period: period
        };
        processExportProps(forParent);
    }, [
        totalSoldData,
        sellSideData,
        listSideData,
        state.selectedPeriod
    ]);
    if (!shouldRender) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {});
    const selectDefaultValue = {
        value: state.selectedPeriod,
        label: `${state.selectedPeriod} Listings`
    };
    let selectOptions = state.monthlyProductions.length && state.monthlyProductions?.sort((a, b)=>new Date(b.month) - new Date(a.month)).map((month)=>{
        const date = new Date(month.month).toLocaleDateString("default", dateOptions);
        return {
            value: date,
            label: `${date} Listings`
        };
    }).filter((period)=>period.value !== state.selectedPeriod);
    selectOptions.length && selectOptions.unshift({
        value: state.selectedPeriod,
        label: `${state.selectedPeriod} Listings`
    });
    const totalSoldTableData = getListingsByPeriod(totalSoldData);
    const listSideTableData = getListingsByPeriod(listSideData);
    const sellSideTableData = getListingsByPeriod(sellSideData);
    const handleSelectedPeriod = (period)=>{
        setState({
            ...state,
            selectedPeriod: period.value
        });
        setTimePeriod(period.value);
    };
    const handleBackClick = ()=>{
        const graphModeParam = query.get("graph");
        const chartMode = query.get("chartMode");
        const queryIsShowBarLabels = query.get("isShowBarLabels");
        history.push(`${(0, $eHBjM.agentProfileRoute)}?id=${state.agentId}&tabIndex=${0}` + `${graphModeParam ? `&graph=${graphModeParam}` : ""}` + `${chartMode ? `&chartMode=${chartMode}` : ""}` + `${queryIsShowBarLabels ? `&isShowBarLabels=${queryIsShowBarLabels}` : ""}`);
    };
    const selectStyles = {
        control: (0, $g3CkB.selectMouseoverStyle),
        option: (0, $g3CkB.selectMouseoverStyle)
    };
    const renderAgentProductionListingsTab = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $8f390b0d641c1be9$export$2e2bcd8739ae039), {
            tabTextTransform: "none",
            navSize: 2,
            contentSize: 2,
            className: "secondary",
            tabs: true,
            currentIndex: currentTab,
            setCurrentIndex: setCurrentTab,
            items: [
                {
                    title: (0, $eHBjM.listingOptions).totalSold,
                    content: {
                        jsx: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt-3",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l05Px.default), {
                                tableView: (0, $4tbBr.tableViews).agentProductionListingTotalSold,
                                rowData: totalSoldTableData,
                                tableTitleWithTooltips: (0, $eHBjM.productionListingsTooltips)
                            })
                        })
                    }
                },
                {
                    title: (0, $eHBjM.listingOptions).listSide,
                    content: {
                        jsx: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt-3",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l05Px.default), {
                                tableView: (0, $4tbBr.tableViews).agentProductionListingListSide,
                                rowData: listSideTableData,
                                tableTitleWithTooltips: (0, $eHBjM.productionListingsTooltips)
                            })
                        })
                    }
                },
                {
                    title: (0, $eHBjM.listingOptions).sellSide,
                    content: {
                        jsx: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "mt-3",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l05Px.default), {
                                tableView: (0, $4tbBr.tableViews).agentProductionListingSellSide,
                                rowData: sellSideTableData,
                                tableTitleWithTooltips: (0, $eHBjM.productionListingsTooltips)
                            })
                        })
                    }
                }
            ]
        });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($e155p))), {
                className: "m-1 mb-2",
                children: [
                    agent && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a4e7f1cc759aedc8$export$2e2bcd8739ae039), {
                        agent: agent,
                        index: 0,
                        module: module,
                        shouldShowBackButton: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "d-flex ml-sm-auto align-self-center",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $28e0eba33e84b50e$export$2e2bcd8739ae039), {
                            ...state.exportProps
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "content listing-content",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "mt-2 mb-4 d-flex align-items-center",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "d-flex",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        id: "listing-breadcrumb",
                                        onClick: ()=>handleBackClick(),
                                        children: "Production"
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                        className: "mx-2",
                                        children: " > "
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4TPr9.default), {
                                dataLwtId: "agent-listing-time-periods",
                                className: "listing-period-select",
                                isClearable: false,
                                options: selectOptions,
                                defaultValue: selectDefaultValue,
                                onChange: (period)=>handleSelectedPeriod(period),
                                matchFrom: "start",
                                styles: selectStyles
                            })
                        ]
                    }),
                    isLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "align-top",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {})
                    }) : renderAgentProductionListingsTab()
                ]
            })
        ]
    });
};
$a18a0232cc648c72$export$dfc0309301032959.propTypes = {
    module: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    agentData: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("amkL4");
var $3QXz5 = parcelRequire("3QXz5");

var $7tOHe = parcelRequire("7tOHe");

var $ivaD7 = parcelRequire("ivaD7");

var $cstaF = parcelRequire("cstaF");

var $94cVo = parcelRequire("94cVo");

var $4UTP7 = parcelRequire("4UTP7");

var $c3iqc = parcelRequire("c3iqc");

var $7fq2m = parcelRequire("7fq2m");

var $3etjB = parcelRequire("3etjB");

var $4UTP7 = parcelRequire("4UTP7");
const $01f64c3c0adc58a7$var$defaultShowHideOptions = [
    {
        ...(0, $3etjB.showHideTypes).onlyShowSelectedAreas,
        hide: true
    },
    {
        ...(0, $3etjB.showHideTypes).chart,
        isDefault: true,
        hide: false
    }
];
const $01f64c3c0adc58a7$var$showHideForSaleCols = [
    {
        ...(0, $7fq2m.gridColumnDefinitions).avgListDom,
        hide: false
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).totalAvgPrice,
        hide: false,
        isCoverage: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).mlsAgentCount,
        hide: false
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).mlsOfficeCount,
        hide: false
    }
];
const $01f64c3c0adc58a7$var$settingsTotalVolumeUnits = {
    showHideOptions: {
        options: $01f64c3c0adc58a7$var$defaultShowHideOptions,
        columns: [
            {
                ...(0, $c3iqc.marketShareColumns).marketSharePct,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).totalAvgPrice,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).totalProdAgentSearchCount,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).mlsOfficeCount,
                isDefault: true,
                hide: false
            }
        ]
    },
    columns: [
        (0, $7fq2m.gridColumnDefinitions).isSelected,
        (0, $7fq2m.gridColumnDefinitions).rank,
        (0, $7fq2m.gridColumnDefinitions).area,
        (0, $7fq2m.gridColumnDefinitions).listVolume,
        (0, $7fq2m.gridColumnDefinitions).listUnits,
        (0, $7fq2m.gridColumnDefinitions).sellVolume,
        (0, $7fq2m.gridColumnDefinitions).sellUnits,
        (0, $7fq2m.gridColumnDefinitions).totalVolume,
        (0, $7fq2m.gridColumnDefinitions).totalUnits,
        {
            ...(0, $7fq2m.gridColumnDefinitions).marketSharePct,
            hide: false,
            isCoverage: true
        },
        {
            ...(0, $7fq2m.gridColumnDefinitions).totalAvgPrice,
            hide: false,
            isCoverage: true
        },
        {
            ...(0, $7fq2m.gridColumnDefinitions).totalProdAgentSearchCount,
            hide: false
        },
        {
            ...(0, $7fq2m.gridColumnDefinitions).mlsOfficeCount,
            hide: false
        }
    ]
};
const $01f64c3c0adc58a7$var$settingsForSaleVolume = {
    showHideOptions: {
        options: $01f64c3c0adc58a7$var$defaultShowHideOptions,
        columns: [
            {
                ...(0, $c3iqc.marketShareColumns).unitSharePct,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).marketSharePct,
                isDefault: true,
                hide: false,
                label: (0, $3etjB.marketShareTerms).volumePct
            },
            {
                ...(0, $c3iqc.marketShareColumns).avgListDom,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).totalAvgPrice,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).mlsAgentCount,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).mlsOfficeCount,
                isDefault: true,
                hide: false
            }
        ]
    },
    columns: [
        (0, $7fq2m.gridColumnDefinitions).isSelected,
        (0, $7fq2m.gridColumnDefinitions).rank,
        (0, $7fq2m.gridColumnDefinitions).area,
        {
            ...(0, $7fq2m.gridColumnDefinitions).actVolume,
            isCoverage: true
        },
        {
            ...(0, $7fq2m.gridColumnDefinitions).actUnits,
            isCoverage: true
        },
        (0, $7fq2m.gridColumnDefinitions).unitSharePct,
        {
            ...(0, $7fq2m.gridColumnDefinitions).marketSharePct,
            hide: false,
            headerName: (0, $3etjB.marketShareTerms).volumePct,
            tooltip: (0, $7fq2m.gridColumnDefinitions).volumeSharePct.field,
            minWidth: 140
        },
        ...$01f64c3c0adc58a7$var$showHideForSaleCols
    ]
};
const $01f64c3c0adc58a7$var$settingsForSaleUnits = {
    showHideOptions: {
        options: $01f64c3c0adc58a7$var$defaultShowHideOptions,
        columns: [
            {
                ...(0, $c3iqc.marketShareColumns).marketSharePct,
                isDefault: true,
                hide: false,
                label: (0, $3etjB.marketShareTerms).unitPct
            },
            {
                ...(0, $c3iqc.marketShareColumns).volumeSharePct,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).avgListDom,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).totalAvgPrice,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).mlsAgentCount,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).mlsOfficeCount,
                isDefault: true,
                hide: false
            }
        ]
    },
    columns: [
        (0, $7fq2m.gridColumnDefinitions).isSelected,
        (0, $7fq2m.gridColumnDefinitions).rank,
        (0, $7fq2m.gridColumnDefinitions).area,
        {
            ...(0, $7fq2m.gridColumnDefinitions).actVolume,
            isCoverage: true
        },
        {
            ...(0, $7fq2m.gridColumnDefinitions).actUnits,
            isCoverage: true
        },
        {
            ...(0, $7fq2m.gridColumnDefinitions).marketSharePct,
            hide: false,
            headerName: (0, $3etjB.marketShareTerms).unitPct,
            tooltip: (0, $7fq2m.gridColumnDefinitions).unitSharePct.field,
            minWidth: 110
        },
        (0, $7fq2m.gridColumnDefinitions).volumeSharePct,
        ...$01f64c3c0adc58a7$var$showHideForSaleCols
    ]
};
const $01f64c3c0adc58a7$var$settingsListSide = {
    showHideOptions: {
        options: $01f64c3c0adc58a7$var$defaultShowHideOptions,
        columns: [
            {
                ...(0, $c3iqc.marketShareColumns).marketSharePct,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).avgListDom,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).listAvgPrice,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).listSpop,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).clr,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).mlsAgentCount,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).listProdAgentSearchCount,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).mlsOfficeCount,
                isDefault: true,
                hide: false
            }
        ]
    },
    columns: [
        (0, $7fq2m.gridColumnDefinitions).isSelected,
        (0, $7fq2m.gridColumnDefinitions).rank,
        (0, $7fq2m.gridColumnDefinitions).area,
        (0, $7fq2m.gridColumnDefinitions).listVolume,
        (0, $7fq2m.gridColumnDefinitions).listUnits,
        {
            ...(0, $7fq2m.gridColumnDefinitions).marketSharePct,
            hide: false,
            isCoverage: true
        },
        {
            ...(0, $7fq2m.gridColumnDefinitions).clr,
            hide: false,
            isCoverage: true
        },
        {
            ...(0, $7fq2m.gridColumnDefinitions).avgListDom,
            hide: false
        },
        {
            ...(0, $7fq2m.gridColumnDefinitions).listAvgPrice,
            hide: false
        },
        {
            ...(0, $7fq2m.gridColumnDefinitions).listSpop,
            hide: false
        },
        {
            ...(0, $7fq2m.gridColumnDefinitions).mlsAgentCount,
            hide: false
        },
        {
            ...(0, $7fq2m.gridColumnDefinitions).listProdAgentSearchCount,
            hide: false
        },
        {
            ...(0, $7fq2m.gridColumnDefinitions).mlsOfficeCount,
            hide: false
        }
    ]
};
const $01f64c3c0adc58a7$var$settingsSellSide = {
    showHideOptions: {
        options: $01f64c3c0adc58a7$var$defaultShowHideOptions,
        columns: [
            {
                ...(0, $c3iqc.marketShareColumns).marketSharePct,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).sellAvgPrice,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).sellSpop,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).mlsAgentCount,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).sellProdAgentSearchCount,
                isDefault: true,
                hide: false
            },
            {
                ...(0, $c3iqc.marketShareColumns).mlsOfficeCount,
                isDefault: true,
                hide: false
            }
        ]
    },
    columns: [
        (0, $7fq2m.gridColumnDefinitions).isSelected,
        (0, $7fq2m.gridColumnDefinitions).rank,
        (0, $7fq2m.gridColumnDefinitions).area,
        (0, $7fq2m.gridColumnDefinitions).sellVolume,
        (0, $7fq2m.gridColumnDefinitions).sellUnits,
        {
            ...(0, $7fq2m.gridColumnDefinitions).marketSharePct,
            hide: false,
            isCoverage: true
        },
        {
            ...(0, $7fq2m.gridColumnDefinitions).sellAvgPrice,
            hide: false
        },
        {
            ...(0, $7fq2m.gridColumnDefinitions).sellSpop,
            hide: false
        },
        {
            ...(0, $7fq2m.gridColumnDefinitions).mlsAgentCount,
            hide: false
        },
        {
            ...(0, $7fq2m.gridColumnDefinitions).sellProdAgentSearchCount,
            hide: false
        },
        {
            ...(0, $7fq2m.gridColumnDefinitions).mlsOfficeCount,
            hide: false
        }
    ]
};
const $01f64c3c0adc58a7$export$91a05cc3bc177012 = Object.freeze({
    total$Volume: {
        ...(0, $4UTP7.listingViews).total$Volume,
        settings: $01f64c3c0adc58a7$var$settingsTotalVolumeUnits
    },
    totalNumUnits: {
        ...(0, $4UTP7.listingViews).totalNumUnits,
        settings: $01f64c3c0adc58a7$var$settingsTotalVolumeUnits
    },
    listSide$Volume: {
        ...(0, $4UTP7.listingViews).listSide$Volume,
        settings: $01f64c3c0adc58a7$var$settingsListSide
    },
    listSideNumUnits: {
        ...(0, $4UTP7.listingViews).listSideNumUnits,
        settings: $01f64c3c0adc58a7$var$settingsListSide
    },
    sellSide$Volume: {
        ...(0, $4UTP7.listingViews).sellSide$Volume,
        settings: $01f64c3c0adc58a7$var$settingsSellSide
    },
    sellSideNumUnits: {
        ...(0, $4UTP7.listingViews).sellSideNumUnits,
        settings: $01f64c3c0adc58a7$var$settingsSellSide
    },
    forSale$Volume: {
        ...(0, $4UTP7.listingViews).forSale$Volume,
        label: (0, $3etjB.marketShareTerms).coverageForSale$Volume,
        settings: $01f64c3c0adc58a7$var$settingsForSaleVolume
    },
    forSaleNumUnits: {
        ...(0, $4UTP7.listingViews).forSaleNumUnits,
        label: (0, $3etjB.marketShareTerms).coverageForSaleNumUnits,
        settings: $01f64c3c0adc58a7$var$settingsForSaleUnits
    }
});



var $cstaF = parcelRequire("cstaF");

var $3etjB = parcelRequire("3etjB");
const $18776b3ee2cfdc05$export$88b4894c2b970899 = Object.freeze({
    [(0, $cstaF.marketShareListingStatuses).SoldBothSides]: {
        listingTypes: [
            {
                ...(0, $3etjB.listingTypes).byOffice,
                isDefault: true
            },
            (0, $3etjB.listingTypes).byBrokerage,
            (0, $3etjB.listingTypes).comparisonSet
        ],
        listingViews: [
            {
                ...(0, $4UTP7.listingViews).total$Volume,
                isDefault: true
            },
            {
                ...(0, $4UTP7.listingViews).totalNumUnits
            },
            {
                ...(0, $4UTP7.listingViews).listSide$Volume
            },
            {
                ...(0, $4UTP7.listingViews).listSideNumUnits
            },
            {
                ...(0, $4UTP7.listingViews).sellSide$Volume
            },
            {
                ...(0, $4UTP7.listingViews).sellSideNumUnits
            }
        ]
    },
    [(0, $cstaF.marketShareListingStatuses).ForSale]: {
        listingTypes: [
            {
                ...(0, $3etjB.listingTypes).byOffice,
                isDefault: true
            },
            (0, $3etjB.listingTypes).byBrokerage,
            (0, $3etjB.listingTypes).comparisonSet
        ],
        listingViews: [
            {
                ...(0, $4UTP7.listingViews).forSale$Volume,
                isDefault: true
            },
            {
                ...(0, $4UTP7.listingViews).forSaleNumUnits
            }
        ]
    },
    [(0, $cstaF.marketShareListingStatuses).UnderContract]: {
        listingTypes: [
            {
                ...(0, $3etjB.listingTypes).byOffice,
                isDefault: true
            },
            (0, $3etjB.listingTypes).byBrokerage,
            (0, $3etjB.listingTypes).comparisonSet
        ],
        listingViews: [
            {
                ...(0, $4UTP7.listingViews).underContract$Volume,
                isDefault: true
            },
            {
                ...(0, $4UTP7.listingViews).underContractNumUnits
            }
        ]
    },
    [(0, $cstaF.marketShareListingStatuses).New]: {
        listingTypes: [
            {
                ...(0, $3etjB.listingTypes).byOffice,
                isDefault: true
            },
            (0, $3etjB.listingTypes).byBrokerage,
            (0, $3etjB.listingTypes).comparisonSet
        ],
        listingViews: [
            {
                ...(0, $4UTP7.listingViews).newListing$Volume,
                isDefault: true
            },
            {
                ...(0, $4UTP7.listingViews).newListingNumUnits
            }
        ]
    },
    [(0, $cstaF.marketShareListingStatuses).SoldListSide]: {
        listingTypes: [
            {
                ...(0, $3etjB.listingTypes).byOffice,
                isDefault: true
            },
            (0, $3etjB.listingTypes).byBrokerage,
            (0, $3etjB.listingTypes).comparisonSet
        ],
        listingViews: [
            {
                ...(0, $4UTP7.listingViews).listSide$Volume,
                isDefault: true
            },
            {
                ...(0, $4UTP7.listingViews).listSideNumUnits
            }
        ]
    },
    [(0, $cstaF.marketShareListingStatuses).SoldSellSide]: {
        listingTypes: [
            {
                ...(0, $3etjB.listingTypes).byOffice,
                isDefault: true
            },
            (0, $3etjB.listingTypes).byBrokerage,
            (0, $3etjB.listingTypes).comparisonSet
        ],
        listingViews: [
            {
                ...(0, $4UTP7.listingViews).sellSide$Volume,
                isDefault: true
            },
            {
                ...(0, $4UTP7.listingViews).sellSideNumUnits
            }
        ]
    }
});
const $18776b3ee2cfdc05$export$e2afa9016f83d5f9 = Object.freeze({
    [(0, $cstaF.marketShareListingStatuses).SoldBothSides]: {
        coverageListingViews: [
            {
                ...(0, $01f64c3c0adc58a7$export$91a05cc3bc177012).total$Volume,
                isDefault: true
            },
            {
                ...(0, $01f64c3c0adc58a7$export$91a05cc3bc177012).totalNumUnits
            },
            {
                ...(0, $01f64c3c0adc58a7$export$91a05cc3bc177012).listSide$Volume
            },
            {
                ...(0, $01f64c3c0adc58a7$export$91a05cc3bc177012).listSideNumUnits
            },
            {
                ...(0, $01f64c3c0adc58a7$export$91a05cc3bc177012).sellSide$Volume
            },
            {
                ...(0, $01f64c3c0adc58a7$export$91a05cc3bc177012).sellSideNumUnits
            }
        ]
    },
    [(0, $cstaF.marketShareListingStatuses).ForSale]: {
        coverageListingViews: [
            {
                ...(0, $01f64c3c0adc58a7$export$91a05cc3bc177012).forSale$Volume,
                isDefault: true
            },
            {
                ...(0, $01f64c3c0adc58a7$export$91a05cc3bc177012).forSaleNumUnits
            }
        ]
    }
});
const $18776b3ee2cfdc05$export$69d919c64c2c5ff4 = (searchType)=>{
    return (0, $cstaF.marketShareListingStatuses)[(0, $3etjB.searchTypes)[searchType]];
};
const $18776b3ee2cfdc05$export$c375922b4ac39423 = (listingStatuses, listingStatusId, module)=>{
    if (module === (0, $cstaF.modules).marketShare.totals) return listingStatuses[listingStatusId];
    return $18776b3ee2cfdc05$export$e2afa9016f83d5f9[listingStatusId];
};



var $3etjB = parcelRequire("3etjB");
const $957b68cbce8bf062$export$14704afe46241bc3 = (listingTypeId, listingStatuses, isComparisonSetView)=>{
    if (!listingTypeId && !isComparisonSetView) return listingStatuses.listingTypes.find((lt)=>lt.isDefault);
    if (!listingTypeId && isComparisonSetView) return listingStatuses.listingTypes.find((lt)=>lt.id === (0, $3etjB.listingTypes).comparisonSet.id);
    return listingStatuses.listingTypes.find((lt)=>lt.id === listingTypeId);
};



var $4UTP7 = parcelRequire("4UTP7");

var $3etjB = parcelRequire("3etjB");
const $343de85839542046$export$44487a86467333c3 = ({ listingStatus: listingStatus, data: data, listingTypeId: listingTypeId, listingViewId: listingViewId, module: module, isComparisonSetView: isComparisonSetView })=>{
    if (listingStatus === (0, $cstaF.marketShareListingStatuses).SoldBothSides || listingStatus === (0, $cstaF.marketShareListingStatuses).New || listingStatus === (0, $cstaF.marketShareListingStatuses).UnderContract || listingStatus === (0, $cstaF.marketShareListingStatuses).ForSale || listingStatus === (0, $cstaF.marketShareListingStatuses).SoldListSide || listingStatus === (0, $cstaF.marketShareListingStatuses).SoldSellSide) {
        const currentListingStatus = (0, $18776b3ee2cfdc05$export$c375922b4ac39423)((0, $18776b3ee2cfdc05$export$88b4894c2b970899), listingStatus, module);
        const listingType = (0, $957b68cbce8bf062$export$14704afe46241bc3)(listingTypeId, currentListingStatus, isComparisonSetView);
        const listingTypesTemp = (0, $94cVo.getListingTypes)(currentListingStatus.listingTypes, listingType);
        const searchType = (0, $94cVo.getSearchType)(module);
        const listingView = (0, $4UTP7.getCurrentListingView)(listingViewId, currentListingStatus.listingViews);
        const stats = (0, $94cVo.getDataStats)(data, listingType, listingView);
        const chart = (0, $94cVo.getChart)(listingType, currentListingStatus.listingViews, listingView);
        const tableSettingsColumns = (0, $94cVo.getRevisedColumns)(listingView, listingType);
        const transformData = listingType.getTransformData(stats, listingView.keyField);
        const sumOfColumns = {
            byOffice: (0, $94cVo.getSum)(data.offices, listingView.keyField),
            byBrokerage: (0, $94cVo.getSum)(data.brokers, listingView.keyField),
            comparisonSet: (0, $94cVo.getSum)(data.comparisonSetData, listingView.keyField)
        };
        return {
            rowCount: stats.rowCount,
            searchType: searchType,
            rank: listingView.label,
            listingTypes: listingTypesTemp,
            listingViews: currentListingStatus.listingViews,
            chart: chart,
            showHideOptions: listingView.settings[listingType.id].showHideOptions,
            tableSettings: {
                columns: tableSettingsColumns
            },
            dataTransforms: [
                transformData
            ],
            sumOfColumns: sumOfColumns
        };
    }
    return null;
};
const $343de85839542046$export$5727106279b181b = ({ listingStatus: listingStatus, listingViewId: listingViewId, data: data, module: module })=>{
    if (listingStatus === (0, $cstaF.marketShareListingStatuses).SoldBothSides || listingStatus === (0, $cstaF.marketShareListingStatuses).ForSale) {
        const currentListingStatus = (0, $18776b3ee2cfdc05$export$c375922b4ac39423)((0, $18776b3ee2cfdc05$export$e2afa9016f83d5f9), listingStatus, module);
        const rowCount = data?.length || 0;
        const listingView = (0, $4UTP7.getCurrentListingView)(listingViewId, currentListingStatus.coverageListingViews);
        const stats = (0, $94cVo.getCoverageDataStats)(data, listingView);
        const chart = (0, $94cVo.getCoverageChart)(currentListingStatus.coverageListingViews, listingView);
        const searchType = (0, $94cVo.getSearchType)(module);
        const tableSettingsColumns = (0, $94cVo.getRevisedCoverageColumns)(listingView);
        const transformData = (0, $3etjB.coverageTransforms).getTransformData(stats, listingView.keyField);
        return {
            sumOfColumn: stats.sumOfColumn,
            rowCount: rowCount,
            searchType: searchType,
            rank: listingView.label,
            listingViews: currentListingStatus.coverageListingViews,
            chart: chart,
            showHideOptions: listingView.settings.showHideOptions,
            tableSettings: {
                columns: tableSettingsColumns
            },
            dataTransforms: [
                transformData
            ]
        };
    }
    return null;
};



var $94cVo = parcelRequire("94cVo");

var $3etjB = parcelRequire("3etjB");

var $cstaF = parcelRequire("cstaF");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("3PprX");
var $90ODN = parcelRequire("90ODN");

var $c9Z8w = parcelRequire("c9Z8w");
parcelRequire("fHiKR");
var $1BYDb = parcelRequire("1BYDb");

var $3etjB = parcelRequire("3etjB");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $2Xlz6 = parcelRequire("2Xlz6");

var $dI25G = parcelRequire("dI25G");

var $eOjgM = parcelRequire("eOjgM");

var $3etjB = parcelRequire("3etjB");
const $d8e2ae6b105498f5$var$OptionsSelector = (props)=>{
    const { options: options } = props;
    const [popoverIsOpen, setPopoverIsOpen] = (0, $acw62.useState)(false);
    const togglePopover = ()=>{
        setPopoverIsOpen(!popoverIsOpen);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                id: "showAndHideOptionsBtn",
                dataLwtId: "showAndHideOptionsBtn",
                className: "bg-dark d-flex align-items-center justify-content-between",
                size: "sm",
                onClick: togglePopover,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: (0, $3etjB.marketShareTerms).metrics
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                        icon: (0, $eOjgM.chevron_small_down),
                        className: "metrics-arrow-icon"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Xlz6))), {
                target: "showAndHideOptionsBtn",
                popperClassName: "showAndHideOptionsPopover",
                size: "lg",
                placement: "bottom",
                trigger: "legacy",
                toggle: togglePopover,
                isOpen: popoverIsOpen,
                body: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: options
                })
            })
        ]
    });
};
$d8e2ae6b105498f5$var$OptionsSelector.propTypes = {
    options: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array
};
var $d8e2ae6b105498f5$export$2e2bcd8739ae039 = $d8e2ae6b105498f5$var$OptionsSelector;



var $cstaF = parcelRequire("cstaF");

var $90ISC = parcelRequire("90ISC");

var $ivaD7 = parcelRequire("ivaD7");

var $94cVo = parcelRequire("94cVo");
const $9530275eab7f1dee$var$TitleRow = (props)=>{
    const { titleContent: titleContent, exportButton: exportButton, module: module, hasInitialSearchRun: hasInitialSearchRun, isComparisonSetView: isComparisonSetView, isCoverageSearch: isCoverageSearch } = props;
    const { selectedSavedSearch: selectedSavedSearch, listingType: listingType, setListingType: setListingType, setMSListingViewId: setMSListingViewId, setMSshowHideOptions: setMSshowHideOptions, setMSselectedColumnId: setMSselectedColumnId, showHideOptions: showHideOptions, shouldShowChart: shouldShowChart, setShouldShowChart: setShouldShowChart } = (0, $90ISC.useSearchStore)((state)=>({
            selectedSavedSearch: state[module]?.selectedSavedSearch,
            listingType: state[module]?.listingType,
            setListingType: state.setListingType,
            setMSListingViewId: state.setMSListingViewId,
            setMSshowHideOptions: state.setMSshowHideOptions,
            setMSselectedColumnId: state.setMSselectedColumnId,
            showHideOptions: state[module]?.showHideOptions,
            shouldShowChart: state[module]?.shouldShowChart,
            setShouldShowChart: state.setShouldShowChart
        }));
    const [state, setState] = (0, $acw62.useState)({
        selectedSearch: null,
        listingView: null
    });
    const effectiveListingType = (0, $94cVo.getEffectiveListingType)(isCoverageSearch, isComparisonSetView, listingType);
    const currentShowHideOptions = showHideOptions?.[(0, $94cVo.getShowHideKey)(effectiveListingType, state.listingView)] || {
        options: [],
        columns: []
    };
    (0, $acw62.useEffect)(()=>{
        setState((prevState)=>{
            const listingView = titleContent?.listingViews?.find((lv)=>lv.label === titleContent.rank)?.id;
            return {
                ...prevState,
                listingView: listingView
            };
        });
        if (!effectiveListingType) {
            const listingTypeValue = titleContent?.listingTypes?.find((lt)=>lt.isDefault)?.id;
            listingTypeValue && setListingType(listingTypeValue);
        }
    }, [
        titleContent
    ]);
    (0, $acw62.useEffect)(()=>{
        (0, $ivaD7.setStateData)("selectedSearch", selectedSavedSearch, setState);
    }, [
        selectedSavedSearch
    ]);
    const listingTypeOptions = titleContent?.listingTypes?.map((option)=>{
        return {
            dataLwtId: option.id,
            itemText: option.label,
            key: option.id,
            onClick: ()=>{
                setListingType(option.id);
            }
        };
    }).filter((option)=>option.key !== (0, $3etjB.listingTypes).comparisonSet.id);
    const listingViewOptions = titleContent?.listingViews?.map((option)=>{
        return {
            dataLwtId: option.id,
            itemText: option.label,
            key: option.id,
            onClick: ()=>{
                setMSListingViewId(option.id);
                (0, $ivaD7.setStateData)("listingView", option.id, setState);
            }
        };
    });
    const handleShowHideOptionsClick = (e)=>{
        const item = e.target;
        const clickedOptionId = item.value;
        const isChecked = item.checked;
        const updatedColumns = currentShowHideOptions.columns.map((option)=>{
            if (option.id === clickedOptionId) return {
                ...option,
                hide: !isChecked
            };
            return option;
        });
        const updatedOptions = currentShowHideOptions.options.map((option)=>{
            if (option.id === clickedOptionId) return {
                ...option,
                hide: !isChecked
            };
            return option;
        });
        const updatedShowHideOptions = {
            options: updatedOptions,
            columns: updatedColumns
        };
        setMSshowHideOptions(effectiveListingType, state.listingView, updatedShowHideOptions);
        setMSselectedColumnId(clickedOptionId);
    };
    const showHideMetricsList = [];
    const showHideMetricsOptions = currentShowHideOptions?.options?.map((option)=>{
        if (option.id === (0, $3etjB.showHideTypes).chart.id) return;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "border-bottom py-2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1BYDb))), {
                    dataLwtId: option.id,
                    type: "checkbox",
                    checked: !option.hide,
                    id: option.id,
                    value: option.id,
                    label: option.label,
                    onClick: handleShowHideOptionsClick
                })
            })
        });
    });
    const showHideMetricsColumns = currentShowHideOptions?.columns?.map((option)=>{
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "py-2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1BYDb))), {
                    dataLwtId: option.id,
                    type: "checkbox",
                    checked: !option?.hide,
                    id: option.id,
                    value: option.id,
                    label: option.label,
                    onClick: handleShowHideOptionsClick
                })
            })
        });
    });
    showHideMetricsList.push(showHideMetricsOptions);
    showHideMetricsList.push(showHideMetricsColumns);
    const isShowOptions = !!(titleContent?.rowCount && hasInitialSearchRun);
    const searchName = state.selectedSearch ? state.selectedSearch.savedSearch?.searchName : (0, $cstaF.searchTerms).newSearch;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "row w-100 ml-2 my-2 pr-1 py-0",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "labels-buttons-container",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "d-flex align-items-center",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                            style: {
                                marginRight: "10px"
                            },
                            className: "text-truncate mb-0 font-gray-primary",
                            children: (0, $3etjB.marketShareTerms).getSearchSubtitle((0, $cstaF.searchTypes)[location.pathname]?.title)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h6", {
                            className: "text-truncate mb-0 helix-body",
                            children: searchName
                        })
                    ]
                }),
                isShowOptions && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "d-flex flex-row",
                        id: "market-share-title-row",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "d-flex align-items-center justify-content-center",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                        className: "mr-2 clickable",
                                        onClick: setShouldShowChart,
                                        children: (0, $3etjB.marketShareTerms).chart
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1BYDb))), {
                                        dataLwtId: "market-share-chart-toggle",
                                        type: "switch",
                                        id: "market-share-chart-toggle",
                                        onChange: setShouldShowChart,
                                        checked: shouldShowChart
                                    })
                                ]
                            }),
                            listingTypeOptions?.length && !isComparisonSetView && /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($90ODN))), {
                                className: "listing-options",
                                dataLwtId: "listingTypeOptions",
                                toggleProps: {
                                    dataLwtId: "no-split-toggle",
                                    id: "caret",
                                    caret: true,
                                    children: titleContent.listingTypes?.find((lt)=>lt.id === effectiveListingType)?.label || (0, $3etjB.marketShareTerms).listingType,
                                    className: "bg-dark btn btn-sm btn-secondary mr-2"
                                },
                                items: listingTypeOptions,
                                menuProps: {
                                    dataLwtId: "share-menu",
                                    right: true
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($90ODN))), {
                                className: "listing-options",
                                dataLwtId: "listingViewOptions",
                                toggleProps: {
                                    dataLwtId: "no-split-toggle",
                                    id: "caret",
                                    caret: true,
                                    children: titleContent.listingViews.find((lv)=>lv.id === state.listingView)?.label || (0, $3etjB.marketShareTerms).listingView,
                                    className: "bg-dark btn btn-sm btn-secondary mr-2"
                                },
                                items: listingViewOptions,
                                menuProps: {
                                    dataLwtId: "share-menu",
                                    right: true
                                }
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d8e2ae6b105498f5$export$2e2bcd8739ae039), {
                                options: showHideMetricsList
                            }),
                            exportButton
                        ]
                    })
                })
            ]
        })
    });
};
$9530275eab7f1dee$var$TitleRow.propTypes = {
    titleContent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    showHideOptions: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    module: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    hasInitialSearchRun: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    exportButton: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).element,
    isComparisonSetView: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    isCoverageSearch: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
var $9530275eab7f1dee$export$2e2bcd8739ae039 = $9530275eab7f1dee$var$TitleRow;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $3r6bj = parcelRequire("3r6bj");

var $cstaF = parcelRequire("cstaF");

var $94cVo = parcelRequire("94cVo");

var $htzEo = parcelRequire("htzEo");

var $3etjB = parcelRequire("3etjB");
const $7466b5e2f3d81c23$var$MAX_BAR_STACK_COUNT = 2;
const $7466b5e2f3d81c23$export$25309bb3f4dfcfa9 = (chartRowCount)=>{
    return chartRowCount && `${chartRowCount * 5}%`;
};
const $7466b5e2f3d81c23$export$8b6a117030db0f9d = (seriesIndex, dataPointIndex, w, data)=>{
    const series = w.config.series;
    const hasFullData = series.length === $7466b5e2f3d81c23$var$MAX_BAR_STACK_COUNT && series[0].data[dataPointIndex] > 0 && series[1].data[dataPointIndex] > 0;
    const hasPartialData = series.length === $7466b5e2f3d81c23$var$MAX_BAR_STACK_COUNT && (series[0].data[dataPointIndex] > 0 && series[1].data[dataPointIndex] === 0 || series[0].data[dataPointIndex] === 0 && series[1].data[dataPointIndex] > 0);
    if (series.length === 1 || hasFullData && seriesIndex === 1 || hasPartialData && series[seriesIndex].data[dataPointIndex] > 0) return `${(0, $3etjB.marketShareTerms).mkt} ${(0, $htzEo.formatPercentage)(data[dataPointIndex]?.marketSharePct)}`;
    return "";
};



var $3etjB = parcelRequire("3etjB");

var $7tOHe = parcelRequire("7tOHe");

var $acw62 = parcelRequire("acw62");
const $0fd5bff891bbaebc$var$SIDEBAR_SELECTOR = '[class*="sidebar-nav-container"]';
const $0fd5bff891bbaebc$var$SIDEBAR_COLLAPSED_CLASS = "collapsed";
const $0fd5bff891bbaebc$var$TRANSITION_DELAY_MS = 300;
const $0fd5bff891bbaebc$export$417cdd20f97a1a9 = ()=>{
    const [isSideNavExpanded, setIsSideNavExpanded] = (0, $acw62.useState)(true);
    const [isTransitioning, setIsTransitioning] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        let timer;
        let classObserver;
        const attachToSidebar = (sidebarNavContainer)=>{
            const isExpanded = ()=>![
                    ...sidebarNavContainer.classList
                ].some((c)=>c.includes($0fd5bff891bbaebc$var$SIDEBAR_COLLAPSED_CLASS));
            setIsSideNavExpanded(isExpanded());
            classObserver = new MutationObserver(()=>{
                setIsSideNavExpanded(isExpanded());
                setIsTransitioning(true);
                clearTimeout(timer);
                timer = setTimeout(()=>setIsTransitioning(false), $0fd5bff891bbaebc$var$TRANSITION_DELAY_MS);
            });
            classObserver.observe(sidebarNavContainer, {
                attributes: true,
                attributeFilter: [
                    "class"
                ]
            });
        };
        const sidebarNavContainer = document.querySelector($0fd5bff891bbaebc$var$SIDEBAR_SELECTOR);
        if (sidebarNavContainer) attachToSidebar(sidebarNavContainer);
        else {
            // Sidebar not in DOM yet — wait for it
            const domObserver = new MutationObserver(()=>{
                const sidebarNavContainer = document.querySelector($0fd5bff891bbaebc$var$SIDEBAR_SELECTOR);
                if (sidebarNavContainer) {
                    domObserver.disconnect();
                    attachToSidebar(sidebarNavContainer);
                }
            });
            domObserver.observe(document.body, {
                childList: true,
                subtree: true
            });
            return ()=>{
                domObserver.disconnect();
                clearTimeout(timer);
                classObserver?.disconnect();
            };
        }
        return ()=>{
            clearTimeout(timer);
            classObserver?.disconnect();
        };
    }, []);
    return {
        isSideNavExpanded: isSideNavExpanded,
        isTransitioning: isTransitioning
    };
};


const $e9786093f64294c7$var$SIDEBAR_EXPANDED_WIDTH = 300;
const $e9786093f64294c7$var$SIDEBAR_COLLAPSED_WIDTH = 68;
const $e9786093f64294c7$var$SCROLL_BREAKPOINT = 1200;
const $e9786093f64294c7$var$MINIMUM_CHART_WIDTH = 1200;
const $e9786093f64294c7$export$6d263b5c0f11fd3d = (props)=>{
    const { data: data, config: { rank: rank, chart: chartConfig }, hasSelectedRows: hasSelectedRows, isRenderingToFile: isRenderingToFile } = props;
    const { isSideNavExpanded: isSideNavExpanded, isTransitioning: isTransitioning } = (0, $0fd5bff891bbaebc$export$417cdd20f97a1a9)();
    const [windowWidth, setWindowWidth] = (0, $acw62.useState)(window.innerWidth);
    const wasSidebarTransitioning = (0, $acw62.useRef)(false);
    const sidebarWidth = isSideNavExpanded ? $e9786093f64294c7$var$SIDEBAR_EXPANDED_WIDTH : $e9786093f64294c7$var$SIDEBAR_COLLAPSED_WIDTH;
    const availableWidth = windowWidth - sidebarWidth + 200;
    const needsScroll = !isRenderingToFile && availableWidth < $e9786093f64294c7$var$SCROLL_BREAKPOINT;
    const yAxisLabels = data?.map((item)=>chartConfig.yAxisLabelMapper(item) ?? "") ?? [];
    const getDataPointGroups = (groups)=>{
        return groups?.map((group)=>{
            const groupData = data?.map(group.dataMapper);
            return {
                name: group.label,
                data: groupData
            };
        });
    };
    const barColors = chartConfig?.dataPointGroups?.map((dataGroup)=>dataGroup.color);
    const dataPointGroups = getDataPointGroups(chartConfig?.dataPointGroups);
    const fontFamily = '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"';
    const options = {
        rank: rank,
        grid: {
            yaxis: {
                lines: {
                    show: false
                }
            },
            xaxis: {
                lines: {
                    show: true
                }
            },
            strokeDashArray: 3
        },
        chart: {
            background: "#fff",
            animations: {
                enabled: false
            },
            type: "bar",
            stacked: true,
            toolbar: {
                show: false
            },
            fontFamily: fontFamily,
            noData: {
                text: (0, $cstaF.agentProductionTerms).noDataForSelectedAgent
            },
            zoom: {
                enabled: false
            }
        },
        tooltip: {
            custom: ({ series: series, dataPointIndex: dataPointIndex, w: graphInfo })=>{
                return (0, $94cVo.getTooltipContent)(series, dataPointIndex, graphInfo, barColors, chartConfig);
            }
        },
        responsive: [
            {
                breakpoint: 480,
                options: {
                    legend: {
                        position: "left",
                        offsetX: -10,
                        offsetY: 0
                    }
                }
            }
        ],
        plotOptions: {
            bar: {
                horizontal: true,
                borderRadius: 1,
                barHeight: (0, $7466b5e2f3d81c23$export$25309bb3f4dfcfa9)(yAxisLabels?.length),
                dataLabels: {
                    position: "top",
                    hideOverflowingLabels: false
                }
            }
        },
        dataLabels: {
            enabled: true,
            offsetX: isRenderingToFile ? 100 : 70,
            offsetY: isRenderingToFile ? -3 : 0,
            formatter: function(_, { seriesIndex: seriesIndex, dataPointIndex: dataPointIndex, w: w }) {
                return (0, $7466b5e2f3d81c23$export$8b6a117030db0f9d)(seriesIndex, dataPointIndex, w, data);
            },
            style: {
                colors: [
                    "#000000"
                ],
                fontSize: isRenderingToFile ? "20px" : "12px"
            }
        },
        xaxis: {
            categories: yAxisLabels,
            labels: {
                offsetY: isRenderingToFile ? 3 : 0,
                formatter: chartConfig?.xAxisLabelFormatter,
                style: {
                    fontWeight: 400,
                    fontSize: isRenderingToFile ? "20px" : "16px",
                    colors: isRenderingToFile ? "#000" : "#9CA3AF"
                }
            }
        },
        yaxis: {
            title: {
                text: undefined
            },
            labels: {
                maxWidth: screen.width * 0.40,
                style: {
                    fontWeight: 400,
                    fontSize: isRenderingToFile ? "20px" : "16px",
                    colors: isRenderingToFile ? "#000" : "#4B5563"
                },
                offsetX: 10
            }
        },
        legend: {
            inverseOrder: false,
            markers: {
                fillColors: barColors,
                width: 15,
                height: 15,
                radius: 10
            },
            fontFamily: fontFamily,
            itemMargin: {
                horizontal: 10
            },
            onItemClick: {
                toggleDataSeries: false
            },
            position: "bottom",
            horizontalAlign: "left",
            showForSingleSeries: true,
            fontSize: "16px",
            labels: {
                colors: "#4B5563"
            }
        },
        fill: {
            opacity: 1,
            colors: barColors
        }
    };
    (0, $acw62.useEffect)(()=>{
        const handleResize = ()=>setWindowWidth(window.innerWidth);
        window.addEventListener("resize", handleResize, true);
        return ()=>window.removeEventListener("resize", handleResize, true);
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (wasSidebarTransitioning.current && !isTransitioning && !isRenderingToFile) window.dispatchEvent(new Event("resize"));
        wasSidebarTransitioning.current = isTransitioning;
    }, [
        isTransitioning,
        isRenderingToFile
    ]);
    const isShowEmptyState = data === undefined;
    const chartProps = {
        options: options,
        series: dataPointGroups,
        type: "bar",
        height: 372,
        width: needsScroll ? `${$e9786093f64294c7$var$MINIMUM_CHART_WIDTH}px` : "100%"
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "market-share-chart-container",
        children: isShowEmptyState ? null : !hasSelectedRows ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "content text-center",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "initial-search mb-5 mt-5",
                children: (0, $3etjB.marketShareTerms).noRowsSelected
            })
        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            id: "market-share-chart-graph",
            className: `raised-border mb-3 bg-white market-share-chart ${isRenderingToFile ? "chart-capture-area-0" : ""} ${needsScroll ? "needs-scroll" : "no-scroll"}`,
            children: !isRenderingToFile && isTransitioning ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "chart-loader",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {})
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: `chart-wrapper ${needsScroll ? "needs-scroll" : ""}`,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3r6bj))), {
                    ...chartProps
                })
            })
        })
    });
};
$e9786093f64294c7$export$6d263b5c0f11fd3d.propTypes = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    config: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    hasSelectedRows: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number.isRequired,
    rank: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    isRenderingToFile: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $2z9GT = parcelRequire("2z9GT");

var $7fq2m = parcelRequire("7fq2m");

var $dqgmD = parcelRequire("dqgmD");

var $94cVo = parcelRequire("94cVo");

var $bA5Mi = parcelRequire("bA5Mi");

var $90ISC = parcelRequire("90ISC");

var $dQwVS = parcelRequire("dQwVS");

var $3etjB = parcelRequire("3etjB");

var $cstaF = parcelRequire("cstaF");

var $c9Z8w = parcelRequire("c9Z8w");
const $0d10d25c347bf887$var$ResultsTable = (props)=>{
    const { columnDefs: columnDefs, rowData: rowData, gridRef: gridRef, listingStatus: listingStatus, isShowSelectedRows: isShowSelectedRows, setSelectedRowsIds: setSelectedRowsIds, showToast: showToast, noRowsComponent: noRowsComponent, noRowMessage: noRowMessage, rank: rank, hasHeaderTooltips: hasHeaderTooltips, onSortChanged: onSortChanged, getBottomRowSettings: getBottomRowSettings } = props;
    const [selectedData, setSelectedData] = (0, $acw62.useState)([]);
    const { setPinnedBottomRowData: setPinnedBottomRowData } = (0, $bA5Mi.usePDFStore)((state)=>({
            setPinnedBottomRowData: state.setPinnedBottomRowData
        }));
    const { restoreTableRetainedStateByType: restoreTableRetainedStateByType, handleFloatingFilterRetain: handleFloatingFilterRetain, setTableRetainedStateByType: setTableRetainedStateByType, selectedModule: selectedModule } = (0, $90ISC.useSearchStore)((state)=>({
            restoreTableRetainedStateByType: state.restoreTableRetainedStateByType,
            handleFloatingFilterRetain: state.handleFloatingFilterRetain,
            setTableRetainedStateByType: state.setTableRetainedStateByType,
            selectedModule: state.selectedModule
        }));
    const tableViewId = (0, $3etjB.msTableViewNames)[(0, $cstaF.normalizedModuleNames)[selectedModule]?.toLowerCase()];
    const handleGridReady = (e)=>{
        if (!tableViewId) return;
        restoreTableRetainedStateByType({
            api: e.api,
            tableId: tableViewId,
            type: (0, $dQwVS.retainTerms).floatingFilter
        });
    };
    const handleFilterChanged = (e)=>{
        if (!tableViewId) return;
        handleFloatingFilterRetain({
            tableViewId: tableViewId,
            api: e.api,
            setTableRetainedStateByType: setTableRetainedStateByType
        });
    };
    const onFirstDataRendered = (0, $acw62.useCallback)((params)=>{
        params.api.forEachNode((node)=>node.setSelected(!!node.data && node.data.isSelected));
        if (getBottomRowSettings) {
            gridRef.current.api.setPinnedBottomRowData(getBottomRowSettings());
            setPinnedBottomRowData(getBottomRowSettings());
        }
        if (setSelectedRowsIds) {
            const initialCheckedRows = params.api.getSelectedRows().map((row)=>{
                return row.officeId || row.brokerId || row.areaId || row.groupId;
            });
            setSelectedRowsIds(initialCheckedRows);
        }
    }, []);
    const pinnedBottomRowData = getBottomRowSettings && getBottomRowSettings();
    (0, $acw62.useEffect)(()=>{
        if (!pinnedBottomRowData) return;
        setPinnedBottomRowData(pinnedBottomRowData);
    }, [
        columnDefs
    ]);
    (0, $acw62.useEffect)(()=>{
        const revisedData = isShowSelectedRows ? rowData?.filter((row)=>row.isSelected) : rowData;
        if (JSON.stringify(selectedData) !== JSON.stringify(revisedData)) setSelectedData(revisedData);
    }, [
        isShowSelectedRows,
        rowData
    ]);
    const context = {
        maxRows: (0, $94cVo.MAX_COUNT_SELECTED_ROWS),
        setSelectedRowsIds: setSelectedRowsIds,
        showToast: showToast,
        listingStatus: listingStatus,
        listingView: rank,
        hasHeaderTooltips: hasHeaderTooltips
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2z9GT.AGGridHelix), {
        ref: gridRef,
        rowData: selectedData,
        columnDefs: columnDefs,
        gridOptions: {
            context: context
        },
        onSortChanged: (e)=>{
            onSortChanged && onSortChanged(e);
            (0, $dqgmD.handleSortedHighlight)(e);
        },
        onComponentStateChanged: (0, $dqgmD.handleSortedHighlight),
        onFirstDataRendered: onFirstDataRendered,
        onGridReady: handleGridReady,
        onFilterChanged: handleFilterChanged,
        suppressCsvExport: false,
        components: (0, $7fq2m.agGridComponents),
        noRowsOverlayComponent: noRowsComponent,
        noRowsOverlayComponentParams: noRowMessage,
        pinnedBottomRowData: pinnedBottomRowData,
        suppressPropertyNamesCheck: true
    });
};
$0d10d25c347bf887$var$ResultsTable.propTypes = {
    columnDefs: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    rowData: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    gridRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    listingStatus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    isShowSelectedRows: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    setSelectedRowsIds: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    showToast: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    noRowsComponent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).elementType,
    noRowMessage: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    rank: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    hasHeaderTooltips: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    onSortChanged: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    getBottomRowSettings: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};
var $0d10d25c347bf887$export$2e2bcd8739ae039 = $0d10d25c347bf887$var$ResultsTable;





var $7fq2m = parcelRequire("7fq2m");
const $49ccf15f739ed441$export$87bad144e6e5baa5 = (resultsTableBottomParams)=>{
    const { pinnedRowData: pinnedRowData, bottomRowType: bottomRowType, gridRef: gridRef, pinnedRowDrilldownSettingsType: pinnedRowDrilldownSettingsType } = resultsTableBottomParams;
    let pinnedRowSettings = {};
    const columnDefs = gridRef.current?.columnApi?.api?.columnModel?.columnDefs;
    columnDefs?.forEach((colDef)=>{
        const settings = colDef.pinnedRowSettings;
        if (!settings) {
            const cellSetting = {
                [colDef.field]: pinnedRowData?.[colDef.field] || null
            };
            pinnedRowSettings = {
                ...pinnedRowSettings,
                ...cellSetting
            };
            return;
        }
        const settingsToUse = settings.default ? "default" : bottomRowType;
        if (!colDef.cellClass.includes((0, $7fq2m.gridClasses).cellNumber)) {
            const cellSetting = {
                [colDef.field]: settings[settingsToUse]?.cellValue || null
            };
            pinnedRowSettings = {
                ...pinnedRowSettings,
                ...cellSetting
            };
            return;
        }
        if (settings[settingsToUse]?.cellValue !== undefined) {
            const cellSetting = {
                [colDef.field]: settings[settingsToUse]?.cellValue
            };
            pinnedRowSettings = {
                ...pinnedRowSettings,
                ...cellSetting
            };
            return;
        }
        if (settings[settingsToUse]?.getFieldValue) {
            const cellSetting = {
                [colDef.field]: settings[settingsToUse].getFieldValue({
                    ...resultsTableBottomParams,
                    keyField: settings[settingsToUse]?.keyField,
                    colDef: colDef
                })
            };
            pinnedRowSettings = {
                ...pinnedRowSettings,
                ...cellSetting
            };
            return;
        }
        const hasDrilldownSettings = settings[settingsToUse]?.total || settings[settingsToUse]?.breakdown;
        const pinnedDataKeyField = hasDrilldownSettings && settings[settingsToUse][pinnedRowDrilldownSettingsType]?.keyField;
        if (hasDrilldownSettings) {
            const cellSetting = {
                [colDef.field]: settings[settingsToUse][pinnedRowDrilldownSettingsType]?.getFieldValue({
                    ...resultsTableBottomParams,
                    keyField: pinnedDataKeyField,
                    colDef: colDef
                })
            };
            pinnedRowSettings = {
                ...pinnedRowSettings,
                ...cellSetting
            };
            return;
        }
        const pinnedDataAlternativeKeyField = settings[settingsToUse]?.altKeyField;
        const keyField = pinnedRowData?.[pinnedDataAlternativeKeyField] !== undefined ? pinnedDataAlternativeKeyField : settings[settingsToUse]?.keyField;
        const cellSetting = {
            [colDef.field]: pinnedRowData?.[pinnedDataKeyField || keyField || colDef.field]
        };
        pinnedRowSettings = {
            ...pinnedRowSettings,
            ...cellSetting
        };
    });
    return [
        pinnedRowSettings
    ];
};



var $jenAg = parcelRequire("jenAg");

var $kfZjc = parcelRequire("kfZjc");

var $c7dF9 = parcelRequire("c7dF9");

var $90ISC = parcelRequire("90ISC");


var $ae040 = parcelRequire("ae040");

var $24YIE = parcelRequire("24YIE");
const $f2afd5e1d9122573$export$48f28d42df82963d = async (selectedComparisonSetSearch)=>{
    const allGroupOfficesIds = selectedComparisonSetSearch?.groups.flatMap((group)=>group.offices.map((office)=>office.officeId));
    return allGroupOfficesIds;
};
const $f2afd5e1d9122573$export$c3217f7fa012939b = async (brokerId, selectedComparisonSetSearch, officeGroupName, state)=>{
    try {
        if (brokerId) return await (0, $24YIE.getOfficeBreakdownList)(brokerId, state.searchCriteria);
        const selectedOfficeGroup = selectedComparisonSetSearch?.groups.find((group)=>group.name === officeGroupName);
        let officesIds = [];
        if (selectedOfficeGroup) officesIds = selectedOfficeGroup?.offices.map((office)=>office.officeId);
        else officesIds = await $f2afd5e1d9122573$export$48f28d42df82963d(selectedComparisonSetSearch);
        return await (0, $24YIE.getCompSetOfficeBreakdownList)(officesIds, state.searchCriteria, !selectedOfficeGroup);
    } catch (error) {
        console.error(error);
    }
};



var $i95vK = parcelRequire("i95vK");


var $bA5Mi = parcelRequire("bA5Mi");

var $jeANf = parcelRequire("jeANf");
const $fe3c308a0b1fa260$var$MarketShare = ({ module: module, agentData: agentData })=>{
    const { areaTypeTitle: areaTypeTitle, loadedSearchCriteria: loadedSearchCriteria, isLoadingSearchData: isLoadingSearchData, selectedComparisonSetSearch: selectedComparisonSetSearch, isSelectedCompSetAllOtherGroupClickable: isSelectedCompSetAllOtherGroupClickable, listingType: listingType, currentListingViewId: currentListingViewId, showHideOptions: showHideOptions, selectedColumnId: selectedColumnId, setMSselectedColumnId: setMSselectedColumnId, setMSshowHideOptions: setMSshowHideOptions, shouldShowChart: shouldShowChart } = (0, $90ISC.useSearchStore)((state)=>({
            areaTypeTitle: state[module]?.areaTypeTitle,
            loadedSearchCriteria: state[module]?.loadedSearchCriteria,
            selectedMls: state[module]?.selectedMls,
            isLoadingSearchData: state.isLoadingSearchData,
            selectedComparisonSetSearch: state[module]?.selectedComparisonSetSearch,
            isSelectedCompSetAllOtherGroupClickable: state[module]?.isSelectedCompSetAllOtherGroupClickable,
            listingType: state[module]?.listingType,
            currentListingViewId: state[module]?.listingViewId,
            showHideOptions: state[module]?.showHideOptions,
            selectedColumnId: state[module]?.selectedColumnId,
            setMSselectedColumnId: state.setMSselectedColumnId,
            setMSshowHideOptions: state.setMSshowHideOptions,
            shouldShowChart: state[module]?.shouldShowChart
        }));
    const { setListingViewTitle: setListingViewTitle, setResults: setResults, setColumnDefs: setColumnDefs, isPDFLoading: isPDFLoading } = (0, $bA5Mi.usePDFStore)((state)=>({
            setListingViewTitle: state.setListingViewTitle,
            setResults: state.setResults,
            setColumnDefs: state.setColumnDefs,
            isPDFLoading: state.downloadModalStatus.isPDFLoading
        }));
    const { isComparisonSetView: isComparisonSetView } = (0, $ae040.useComparisonSetsStore)((state)=>({
            isComparisonSetView: state.isComparisonSetView
        }));
    const [state, setState] = (0, $acw62.useState)({
        offices: [],
        brokers: [],
        comparisonSets: [],
        columnDefs: [],
        titleContent: null,
        isShowExportBtn: false,
        selectedRowsIds: [],
        toast: {},
        tostProps: null,
        coverageSearchData: [],
        selectedAreaType: null
    });
    const listingViewId = currentListingViewId || state.titleContent?.listingViews?.find((lv)=>lv.isDefault)?.id;
    const comparisonSetsData = state.comparisonSets?.results;
    const [rowData, setRowData] = (0, $acw62.useState)();
    const [coverageRowData, setCoverageRowData] = (0, $acw62.useState)();
    const listingStatus = (0, $jenAg.getListingStatus)(module, loadedSearchCriteria);
    const isCoverageSearch = module === (0, $cstaF.modules).marketShare.coverage;
    const effectiveListingType = (0, $94cVo.getEffectiveListingType)(isCoverageSearch, isComparisonSetView, listingType);
    const currentShowHideOptions = showHideOptions?.[(0, $94cVo.getShowHideKey)(effectiveListingType, listingViewId)] || {
        options: [],
        columns: []
    };
    const gridRef = (0, $acw62.useRef)();
    const location = (0, $kfZjc.useLocation)();
    const hasData = !!(state.offices || state.brokers || comparisonSetsData);
    (0, $acw62.useEffect)(()=>{
        if (location.state?.fromValidation) (0, $jeANf.showToast)((0, $jeANf.toastTypes).success, (0, $cstaF.toastMessages).success.agentValidated, setState);
    }, []);
    (0, $acw62.useEffect)(()=>{
        (0, $ivaD7.setStateData)("selectedAreaType", areaTypeTitle?.mainTitle.slice((0, $cstaF.searchTerms).selectedAreaTypeTitle.length), setState);
    }, [
        areaTypeTitle
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!loadedSearchCriteria) return;
        (0, $ivaD7.setStateData)("searchCriteria", loadedSearchCriteria, setState);
    }, [
        loadedSearchCriteria
    ]);
    (0, $acw62.useEffect)(()=>{
        setState((state)=>({
                ...state,
                offices: agentData?.officeSearch,
                brokers: agentData?.brokerSearch,
                coverageSearchData: agentData?.coverageSearch,
                comparisonSets: agentData?.comparisonSetSearch
            }));
    }, [
        agentData
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isCoverageSearch) {
            if (!listingStatus) return;
        } else {
            if (!listingStatus || !hasData) return;
        }
        let titleContent, coverageColumnDefs;
        if (isCoverageSearch) titleContent = (0, $343de85839542046$export$5727106279b181b)({
            listingStatus: listingStatus,
            listingViewId: listingViewId,
            data: state.coverageSearchData?.results,
            module: module
        });
        else titleContent = (0, $343de85839542046$export$44487a86467333c3)({
            listingStatus: listingStatus,
            listingTypeId: isComparisonSetView ? (0, $3etjB.listingTypes).comparisonSet.id : listingType,
            listingViewId: listingViewId,
            data: {
                offices: state.offices?.results,
                brokers: state.brokers?.results,
                comparisonSetData: comparisonSetsData
            },
            module: module,
            isComparisonSetView: isComparisonSetView
        });
        if (isCoverageSearch && titleContent?.tableSettings) {
            let areaColumn;
            let updatedAreaColumn;
            areaColumn = titleContent.tableSettings?.columns.find((column)=>column.field === "area");
            updatedAreaColumn = {
                ...areaColumn,
                headerName: state.selectedAreaType
            };
            coverageColumnDefs = titleContent.tableSettings?.columns.map((column)=>{
                if (column.field === "area") return {
                    ...column,
                    ...updatedAreaColumn
                };
                return column;
            });
        }
        const hasDefaultShowHideOptions = currentShowHideOptions?.options?.length && currentShowHideOptions?.columns?.length;
        if (!hasDefaultShowHideOptions) {
            const options = titleContent.showHideOptions.options;
            const columns = titleContent.showHideOptions.columns;
            setMSshowHideOptions(effectiveListingType, listingViewId, {
                options: options,
                columns: columns
            });
        }
        let columnDefs = isCoverageSearch ? coverageColumnDefs : titleContent?.tableSettings.columns;
        if (currentShowHideOptions?.columns?.length && columnDefs?.length) columnDefs = columnDefs.map((col)=>{
            const matchingOption = currentShowHideOptions.columns.find((option)=>option.id === col.field || col.groupId && option.groupId === col.groupId);
            if (matchingOption !== undefined) return {
                ...col,
                hide: matchingOption.hide
            };
            return col;
        });
        setColumnDefs(columnDefs);
        setListingViewTitle(titleContent.rank);
        setState((prevState)=>({
                ...prevState,
                titleContent: titleContent,
                columnDefs: columnDefs
            }));
    }, [
        state.offices,
        state.brokers,
        listingType,
        listingViewId,
        state.coverageSearchData,
        listingStatus,
        isComparisonSetView,
        comparisonSetsData,
        module
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!selectedColumnId) return;
        const clickedColumn = currentShowHideOptions?.columns?.find((col)=>col.id === selectedColumnId);
        const columnDefs = state.columnDefs?.map((col)=>{
            if (col.field === clickedColumn?.id) return {
                ...col,
                hide: !!clickedColumn?.hide
            };
            if (col.groupId && col.groupId === clickedColumn?.groupId) return {
                ...col,
                hide: !!clickedColumn?.hide
            };
            return col;
        });
        if (!columnDefs?.length > 0) return;
        setMSselectedColumnId(null);
        setState((prevState)=>({
                ...prevState,
                columnDefs: columnDefs
            }));
        setColumnDefs(columnDefs);
    }, [
        currentShowHideOptions?.columns
    ]);
    const setSelectedRowsIds = (data)=>{
        (0, $ivaD7.setStateData)("selectedRowsIds", data, setState);
        (0, $90ISC.useCommonStore).setState({
            selectedRowsIds: data
        });
    };
    (0, $acw62.useEffect)(()=>{
        if (isCoverageSearch || !state?.titleContent?.dataTransforms || !hasData) return;
        const listingTypeId = listingType || (0, $3etjB.listingTypes).byOffice.id;
        const supplementalData = {
            listingViewId: state?.titleContent?.listingViews?.find((lv)=>lv.id === listingViewId)?.keyField || state?.titleContent?.listingViews?.find((lv)=>lv.isDefault).keyField,
            listingTypeId: isComparisonSetView ? (0, $3etjB.listingTypes).byBrokerage.id : listingTypeId,
            sumOfColumn: state?.titleContent?.sumOfColumns?.[isComparisonSetView ? (0, $3etjB.listingTypes).comparisonSet.id : listingTypeId],
            rowCount: (0, $94cVo.getRowCount)(state[(0, $3etjB.listingTypes)[listingTypeId].collectionKey])
        };
        let loopTransformedData = {
            offices: state.offices?.results.map((office)=>({
                    ...office,
                    ...supplementalData
                })) ?? [],
            brokers: state.brokers?.results.map((broker)=>({
                    ...broker,
                    ...supplementalData
                })) ?? [],
            comparisonSetData: comparisonSetsData?.map((group, i)=>({
                    ...group,
                    supplementalData: supplementalData,
                    groupId: i
                })) ?? []
        };
        state.titleContent?.dataTransforms?.forEach((transform)=>{
            loopTransformedData = transform(loopTransformedData);
        });
        setState((prevState)=>({
                ...prevState,
                selectedRowsIds: loopTransformedData?.filter((row)=>row.isSelected === true).map((row)=>row.officeId || row.brokerId || row.groupId),
                isShowExportBtn: !!loopTransformedData?.length
            }));
        setRowData(loopTransformedData?.length ? loopTransformedData : null);
        setResults(loopTransformedData?.length ? loopTransformedData : null);
        setTimeout(()=>{
            (0, $90ISC.useCommonStore).setState({
                selectedRowsIds: loopTransformedData?.length ? loopTransformedData?.filter((row)=>row.isSelected === true).map((row)=>row.officeId || row.brokerId || row.groupId) : null
            });
        }, 500);
    }, [
        state.titleContent,
        state.offices,
        state.brokers,
        listingType,
        listingViewId,
        isCoverageSearch,
        comparisonSetsData
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!isCoverageSearch || !state?.titleContent?.dataTransforms || !state.coverageSearchData) return;
        const supplementalData = {
            listingViewId: state?.titleContent?.listingViews?.find((lv)=>lv.id === listingViewId)?.keyField || state?.titleContent?.listingViews?.find((lv)=>lv.isDefault).keyField,
            sumOfColumn: state?.titleContent?.sumOfColumn,
            rowCount: state.titleContent?.rowCount
        };
        let transformedData = {
            data: (state.coverageSearchData?.results ?? []).map((entry)=>({
                    ...entry,
                    ...supplementalData
                }))
        };
        state.titleContent?.dataTransforms?.forEach((transform)=>{
            transformedData = transform(transformedData);
        });
        setSelectedRowsIds(transformedData?.filter((row)=>row.isSelected === true).map((row)=>row.areaId));
        setCoverageRowData(transformedData?.length && transformedData[0]?.marketSharePct ? transformedData : null);
        setResults(transformedData?.length && transformedData[0]?.marketSharePct ? transformedData : null);
    }, [
        state.titleContent,
        state.coverageSearchData,
        isCoverageSearch,
        listingViewId
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!isLoadingSearchData) return;
        const fetchOfficesIds = async ()=>{
            const officesIds = await (0, $f2afd5e1d9122573$export$48f28d42df82963d)(selectedComparisonSetSearch);
            (0, $90ISC.useSearchStore).setState((prevState)=>({
                    ...prevState,
                    [module]: {
                        ...prevState[module],
                        isSelectedCompSetAllOtherGroupClickable: officesIds?.length > 0
                    }
                }));
        };
        fetchOfficesIds();
    }, [
        isLoadingSearchData
    ]);
    const makeRowLinkClickable = (row, rowId)=>({
            ...row,
            isSelected: state.selectedRowsIds?.includes(rowId),
            isClickable: row.groupName === (0, $3etjB.marketShareTerms).allOther ? isSelectedCompSetAllOtherGroupClickable : true
        });
    const updatedRowData = rowData?.map((row)=>{
        const rowId = row.officeId || row.brokerId || row.groupId;
        return makeRowLinkClickable(row, rowId);
    });
    const updatedCoverageSearchData = coverageRowData?.map((row)=>{
        const rowId = row.areaId;
        return {
            ...row,
            isSelected: state.selectedRowsIds?.includes(rowId)
        };
    });
    const isShowSelectedRows = currentShowHideOptions?.options && !currentShowHideOptions?.options.find((option)=>option.id === (0, $3etjB.showHideTypes).onlyShowSelectedOffices.id || option.id === (0, $3etjB.showHideTypes).onlyShowSelectedBrokerages.id || option.id === (0, $3etjB.showHideTypes).onlyShowSelectedAreas.id || option.id === (0, $3etjB.showHideTypes).onlyShowSelectedGroups.id)?.hide;
    const showToastDeprecated = (toastType)=>{
        let toastProperties;
        if (toastType === (0, $3etjB.marketShareTerms).MAX_ROWS_ARE_SELECTED) toastProperties = {
            id: 1,
            message: (0, $3etjB.marketShareTerms).maxReached,
            color: "danger",
            icon: "error_outline_icon",
            border: "left",
            dismissTime: 3000
        };
        // The second setState prevents the toast from reappearing on a subsequent search.
        // The toast object gets reset, but this does not remove an already visible toast
        (0, $ivaD7.setStateData)("toast", toastProperties, setState);
        setTimeout(()=>(0, $ivaD7.setStateData)("toast", {}, setState), 500);
    };
    const getStatusMessage = ({ hasInitialSearchRun: hasInitialSearchRun, messageContent: messageContent })=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9530275eab7f1dee$export$2e2bcd8739ae039), {
                    titleContent: state.titleContent,
                    module: module,
                    hasInitialSearchRun: hasInitialSearchRun
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "text-center",
                    children: messageContent
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3QXz5))), {
                    dataLwtId: "marketShare-toast",
                    toastProps: state.toastProps,
                    position: "toast-bottom-right"
                })
            ]
        });
    };
    const pinnedRowDrilldownSettingsType = (0, $c7dF9.getPinnedRowRouteSettings)(location.pathname);
    let updatedData, searchNotRunMessage, chartData, bottomRowParams, resultsTableBottomRowData, bottomRowType;
    if (isCoverageSearch) {
        bottomRowType = "coverageSearch";
        chartData = updatedCoverageSearchData?.filter((row)=>row.isSelected);
        updatedData = updatedCoverageSearchData;
        searchNotRunMessage = (0, $3etjB.marketShareTerms).searchFilterAdjustCoverage;
        resultsTableBottomRowData = state.coverageSearchData?.totals;
        bottomRowParams = {
            bottomRowType: bottomRowType,
            pinnedRowDrilldownSettingsType: pinnedRowDrilldownSettingsType,
            gridRef: gridRef,
            rowData: coverageRowData,
            pinnedRowData: resultsTableBottomRowData
        };
    } else {
        bottomRowType = "totalsSearch";
        chartData = updatedRowData?.filter((row)=>row.isSelected);
        updatedData = updatedRowData;
        searchNotRunMessage = (0, $3etjB.marketShareTerms).searchFilterAdjust;
        const nonComparisonSetsTotals = state[(0, $3etjB.listingTypes)[listingType]?.collectionKey || (0, $3etjB.listingTypes).byOffice?.collectionKey]?.totals;
        resultsTableBottomRowData = isComparisonSetView ? state.comparisonSets?.totals : nonComparisonSetsTotals;
        bottomRowParams = {
            bottomRowType: bottomRowType,
            pinnedRowDrilldownSettingsType: pinnedRowDrilldownSettingsType,
            gridRef: gridRef,
            rowData: rowData,
            pinnedRowData: resultsTableBottomRowData
        };
    }
    const initialSearchNotRun = getStatusMessage({
        hasInitialSearchRun: false,
        messageContent: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
            className: "initial-search",
            children: [
                " ",
                searchNotRunMessage
            ]
        })
    });
    const noResultsFound = getStatusMessage({
        hasInitialSearchRun: true,
        messageContent: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $126e7d6ff1f55059$export$3f0134fa5c63d52e), {})
        })
    });
    const chart = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e9786093f64294c7$export$6d263b5c0f11fd3d), {
        data: chartData,
        config: state.titleContent,
        hasSelectedRows: state.selectedRowsIds?.length
    });
    const pdfChart = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e9786093f64294c7$export$6d263b5c0f11fd3d), {
        data: chartData,
        config: state.titleContent,
        hasSelectedRows: state.selectedRowsIds?.length,
        isRenderingToFile: isPDFLoading
    });
    const hasRowData = rowData || coverageRowData;
    let exportButton;
    if (hasRowData) {
        const exportDetails = {
            exportType: (0, $6b56815170881da9$export$382f55aa456f5721).msSearchResults,
            listingStatus: state.titleContent?.rank,
            searchType: state.titleContent?.searchType,
            listingType: state.titleContent?.listingTypes?.find((listing)=>listing.isDefault)?.label
        };
        exportButton = (0, $0d036ea0861162a7$export$e89cb83db8826f3)({
            exportDetails: exportDetails,
            gridRef: gridRef,
            type: (0, $i95vK.exportButtonTypes).secondary
        });
    }
    const resultsFound = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9530275eab7f1dee$export$2e2bcd8739ae039), {
                titleContent: state.titleContent,
                module: module,
                exportButton: exportButton,
                hasInitialSearchRun: true,
                isComparisonSetView: isComparisonSetView,
                isCoverageSearch: isCoverageSearch
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9b760a8ddf238ef9$export$a1bb54ba7ed9cdd6), {}),
            listingStatus && hasRowData && updatedData && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    shouldShowChart && chart,
                    shouldShowChart && isPDFLoading && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "pdf-chart chart-capture-area",
                        children: pdfChart
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d10d25c347bf887$export$2e2bcd8739ae039), {
                        gridRef: gridRef,
                        rowData: updatedData,
                        columnDefs: state.columnDefs,
                        setSelectedRowsIds: setSelectedRowsIds,
                        showToast: showToastDeprecated,
                        isShowSelectedRows: isShowSelectedRows,
                        listingStatus: listingStatus,
                        rank: state.titleContent?.rank,
                        hasHeaderTooltips: true,
                        selectedRowsIds: state.selectedRowsIds,
                        getBottomRowSettings: ()=>bottomRowParams && (0, $49ccf15f739ed441$export$87bad144e6e5baa5)(bottomRowParams)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3QXz5))), {
                dataLwtId: "marketShare-toast",
                toastProps: state.toast,
                position: "toast-bottom-right"
            })
        ]
    });
    const loader = /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "py-3",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {})
    });
    const isInitialSearchNotRun = loadedSearchCriteria === undefined;
    const hasResults = isCoverageSearch && listingStatus && !!state.coverageSearchData?.results?.length || listingStatus && (!!state.brokers?.results?.length || !!state.offices?.results?.length) || comparisonSetsData?.length;
    const searchWithNoResults = isCoverageSearch && state.coverageSearchData?.results?.length === 0 || state.offices?.results?.length === 0 || state.brokers?.results?.length === 0 || comparisonSetsData?.length === 0;
    if (isLoadingSearchData) return loader;
    if (isInitialSearchNotRun) return initialSearchNotRun;
    if (hasResults) return resultsFound;
    if (searchWithNoResults) return noResultsFound;
    return loader;
};
var $fe3c308a0b1fa260$export$2e2bcd8739ae039 = $fe3c308a0b1fa260$var$MarketShare;



var $c7dF9 = parcelRequire("c7dF9");

var $ekOct = parcelRequire("ekOct");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $kfZjc = parcelRequire("kfZjc");


var $24YIE = parcelRequire("24YIE");

var $ivaD7 = parcelRequire("ivaD7");

var $bq4QZ = parcelRequire("bq4QZ");

var $3etjB = parcelRequire("3etjB");

var $3etjB = parcelRequire("3etjB");

var $cstaF = parcelRequire("cstaF");

var $7fq2m = parcelRequire("7fq2m");

var $dqgmD = parcelRequire("dqgmD");
const $a74a1a6b59911d8e$var$additionalOfficeInfoColumnsSettings = [
    {
        ...(0, $7fq2m.gridColumnDefinitions).officeId,
        isAdditionalInfo: true,
        shouldExport: true
    },
    (0, $7fq2m.gridColumnDefinitions).officeName,
    {
        ...(0, $7fq2m.gridColumnDefinitions).streetName,
        isAdditionalInfo: true,
        headerName: (0, $cstaF.agentProductionTerms).address,
        shouldExport: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).city,
        isAdditionalInfo: true,
        shouldExport: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).stateCode,
        isAdditionalInfo: true,
        shouldExport: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).zipcode,
        isAdditionalInfo: true,
        shouldExport: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).county,
        isAdditionalInfo: true,
        shouldExport: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).phoneNumber,
        isAdditionalInfo: true,
        shouldExport: true
    }
];
const $a74a1a6b59911d8e$var$additionalInfoListingsBothSidesColumnsSettings = [
    {
        ...(0, $7fq2m.gridColumnDefinitions).priceChangeCnt,
        isAdditionalInfo: true,
        shouldExport: true
    },
    (0, $7fq2m.gridColumnDefinitions).spop,
    (0, $7fq2m.gridColumnDefinitions).splp,
    {
        ...(0, $7fq2m.gridColumnDefinitions).bedrooms,
        isAdditionalInfo: true,
        shouldExport: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).fullBaths,
        isAdditionalInfo: true,
        shouldExport: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).squareFt,
        isAdditionalInfo: true,
        shouldExport: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).costPerSqft,
        isAdditionalInfo: true,
        shouldExport: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).lotSizeSquareFt,
        isAdditionalInfo: true,
        shouldExport: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).lotSizeAcres,
        hide: true,
        shouldExport: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).yearBuilt,
        isAdditionalInfo: true,
        shouldExport: true
    }
];
const $a74a1a6b59911d8e$var$additionalInfoListingsForNewUnderColumnsSettings = [
    {
        ...(0, $7fq2m.gridColumnDefinitions).priceChangeCnt,
        isAdditionalInfo: true,
        shouldExport: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).bedrooms,
        isAdditionalInfo: true,
        shouldExport: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).fullBaths,
        isAdditionalInfo: true,
        shouldExport: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).squareFt,
        isAdditionalInfo: true,
        shouldExport: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).costPerSqft,
        isAdditionalInfo: true,
        shouldExport: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).lotSizeSquareFt,
        isAdditionalInfo: true,
        shouldExport: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).lotSizeAcres,
        hide: true,
        shouldExport: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).yearBuilt,
        isAdditionalInfo: true,
        shouldExport: true
    }
];
const $a74a1a6b59911d8e$var$settingsTotalVolumeUnits = {
    columns: [
        ...$a74a1a6b59911d8e$var$additionalOfficeInfoColumnsSettings,
        {
            ...(0, $7fq2m.gridColumnDefinitions).listVolume,
            exportHeaderLabel: (0, $3etjB.marketShareTerms).list$Volume
        },
        {
            ...(0, $7fq2m.gridColumnDefinitions).listUnits,
            exportHeaderLabel: (0, $3etjB.marketShareTerms).listNumUnits
        },
        {
            ...(0, $7fq2m.gridColumnDefinitions).sellVolume,
            exportHeaderLabel: (0, $3etjB.marketShareTerms).sell$Volume
        },
        {
            ...(0, $7fq2m.gridColumnDefinitions).sellUnits,
            exportHeaderLabel: (0, $3etjB.marketShareTerms).sellNumUnits
        },
        {
            ...(0, $7fq2m.gridColumnDefinitions).totalVolume,
            exportHeaderLabel: (0, $3etjB.marketShareTerms).total$Volume
        },
        {
            ...(0, $7fq2m.gridColumnDefinitions).totalUnits,
            exportHeaderLabel: (0, $3etjB.marketShareTerms).totalNumUnits
        },
        (0, $7fq2m.gridColumnDefinitions).marketSharePct,
        (0, $7fq2m.gridColumnDefinitions).listAverageDom,
        (0, $7fq2m.gridColumnDefinitions).totalAveragePrice,
        (0, $7fq2m.gridColumnDefinitions).agentCount,
        {
            ...(0, $7fq2m.gridColumnDefinitions).prodAgentSearchCount,
            exportHeaderLabel: (0, $3etjB.marketShareTerms).prodAgentsCurrentSearch
        }
    ],
    translatedFieldViews: {
        totalVolume: "totalVolume",
        totalUnits: "totalUnits"
    }
};
const $a74a1a6b59911d8e$var$settingsListSide = {
    columns: [
        ...$a74a1a6b59911d8e$var$additionalOfficeInfoColumnsSettings,
        {
            ...(0, $7fq2m.gridColumnDefinitions).listVolume,
            exportHeaderLabel: (0, $3etjB.marketShareTerms).list$Volume
        },
        {
            ...(0, $7fq2m.gridColumnDefinitions).listUnits,
            exportHeaderLabel: (0, $3etjB.marketShareTerms).listNumUnits
        },
        (0, $7fq2m.gridColumnDefinitions).marketSharePct,
        {
            ...(0, $7fq2m.gridColumnDefinitions).clr,
            exportFormatter: (0, $dqgmD.csvFormats).centuplePercentage.format,
            exportHeaderLabel: (0, $3etjB.marketShareTerms).clr
        },
        (0, $7fq2m.gridColumnDefinitions).listAverageDom,
        (0, $7fq2m.gridColumnDefinitions).listSpop,
        (0, $7fq2m.gridColumnDefinitions).listAveragePrice,
        (0, $7fq2m.gridColumnDefinitions).agentCount,
        {
            ...(0, $7fq2m.gridColumnDefinitions).prodAgentSearchCount,
            exportHeaderLabel: (0, $3etjB.marketShareTerms).prodAgentsCurrentSearch
        }
    ],
    translatedFieldViews: {
        listVolume: "listVolume",
        listUnits: "listUnits"
    }
};
const $a74a1a6b59911d8e$var$settingsSellSide = {
    columns: [
        ...$a74a1a6b59911d8e$var$additionalOfficeInfoColumnsSettings,
        {
            ...(0, $7fq2m.gridColumnDefinitions).sellVolume,
            exportHeaderLabel: (0, $3etjB.marketShareTerms).sell$Volume
        },
        {
            ...(0, $7fq2m.gridColumnDefinitions).sellUnits,
            exportHeaderLabel: (0, $3etjB.marketShareTerms).sellNumUnits
        },
        (0, $7fq2m.gridColumnDefinitions).marketSharePct,
        (0, $7fq2m.gridColumnDefinitions).sellSpop,
        (0, $7fq2m.gridColumnDefinitions).sellAveragePrice,
        (0, $7fq2m.gridColumnDefinitions).agentCount,
        {
            ...(0, $7fq2m.gridColumnDefinitions).prodAgentSearchCount,
            exportHeaderLabel: (0, $3etjB.marketShareTerms).prodAgentsCurrentSearch
        }
    ],
    translatedFieldViews: {
        sellVolume: "sellVolume",
        sellUnits: "sellUnits"
    }
};
const $a74a1a6b59911d8e$var$settingsUnderContract = {
    columns: [
        ...$a74a1a6b59911d8e$var$additionalOfficeInfoColumnsSettings,
        (0, $7fq2m.gridColumnDefinitions).ucVolumeAlt,
        (0, $7fq2m.gridColumnDefinitions).ucUnitsAlt,
        (0, $7fq2m.gridColumnDefinitions).marketSharePct,
        (0, $7fq2m.gridColumnDefinitions).averageDom,
        (0, $7fq2m.gridColumnDefinitions).averagePrice,
        (0, $7fq2m.gridColumnDefinitions).agentCount
    ],
    translatedFieldViews: {
        ucVolume: "volume",
        ucUnits: "units"
    }
};
const $a74a1a6b59911d8e$var$settingsForSale = {
    columns: [
        ...$a74a1a6b59911d8e$var$additionalOfficeInfoColumnsSettings,
        (0, $7fq2m.gridColumnDefinitions).fsVolume,
        (0, $7fq2m.gridColumnDefinitions).fsUnits,
        (0, $7fq2m.gridColumnDefinitions).marketSharePct,
        (0, $7fq2m.gridColumnDefinitions).averageDom,
        (0, $7fq2m.gridColumnDefinitions).averagePrice,
        (0, $7fq2m.gridColumnDefinitions).agentCount
    ],
    translatedFieldViews: {
        actVolume: "volume",
        actUnits: "units"
    }
};
const $a74a1a6b59911d8e$var$settingsNewListings = {
    columns: [
        ...$a74a1a6b59911d8e$var$additionalOfficeInfoColumnsSettings,
        (0, $7fq2m.gridColumnDefinitions).newVolume,
        (0, $7fq2m.gridColumnDefinitions).newUnits,
        (0, $7fq2m.gridColumnDefinitions).marketSharePct,
        (0, $7fq2m.gridColumnDefinitions).averageDom,
        (0, $7fq2m.gridColumnDefinitions).averagePrice,
        (0, $7fq2m.gridColumnDefinitions).agentCount
    ],
    translatedFieldViews: {
        newListVolume: "volume",
        newListUnits: "units"
    }
};
const $a74a1a6b59911d8e$var$soldSellSideColumns = [
    {
        ...(0, $7fq2m.gridColumnDefinitions).listingStatus,
        hide: true,
        shouldExport: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).officeId,
        hide: true,
        shouldExport: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).office,
        hide: true,
        shouldExport: true
    },
    (0, $7fq2m.gridColumnDefinitions).mlsNum,
    (0, $7fq2m.gridColumnDefinitions).typeName,
    {
        ...(0, $7fq2m.gridColumnDefinitions).streetNum,
        hide: true,
        shouldExport: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).streetName,
        hide: true,
        shouldExport: true
    },
    (0, $7fq2m.gridColumnDefinitions).address,
    (0, $7fq2m.gridColumnDefinitions).city,
    (0, $7fq2m.gridColumnDefinitions).zipcode,
    (0, $7fq2m.gridColumnDefinitions).areaId,
    (0, $7fq2m.gridColumnDefinitions).orgPrice,
    (0, $7fq2m.gridColumnDefinitions).listPrice,
    {
        ...(0, $7fq2m.gridColumnDefinitions).price,
        exportHeaderLabel: (0, $cstaF.agentProductionTerms).soldPrice
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).date,
        exportHeaderLabel: (0, $cstaF.agentProductionTerms).soldDate
    },
    (0, $7fq2m.gridColumnDefinitions).dom,
    (0, $7fq2m.gridColumnDefinitions).cdom,
    (0, $7fq2m.gridColumnDefinitions).bankStatus,
    ...$a74a1a6b59911d8e$var$additionalInfoListingsBothSidesColumnsSettings,
    (0, $7fq2m.gridColumnDefinitions).sellAgent
];
const $a74a1a6b59911d8e$var$soldListSideColumns = [
    {
        ...(0, $7fq2m.gridColumnDefinitions).listingStatus,
        hide: true,
        shouldExport: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).officeId,
        hide: true,
        shouldExport: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).office,
        hide: true,
        shouldExport: true
    },
    (0, $7fq2m.gridColumnDefinitions).mlsNum,
    (0, $7fq2m.gridColumnDefinitions).typeName,
    {
        ...(0, $7fq2m.gridColumnDefinitions).streetNum,
        hide: true,
        shouldExport: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).streetName,
        hide: true,
        shouldExport: true
    },
    (0, $7fq2m.gridColumnDefinitions).address,
    (0, $7fq2m.gridColumnDefinitions).city,
    (0, $7fq2m.gridColumnDefinitions).zipcode,
    (0, $7fq2m.gridColumnDefinitions).areaId,
    (0, $7fq2m.gridColumnDefinitions).orgPrice,
    (0, $7fq2m.gridColumnDefinitions).listPrice,
    {
        ...(0, $7fq2m.gridColumnDefinitions).price,
        exportHeaderLabel: (0, $cstaF.agentProductionTerms).soldPrice
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).date,
        exportHeaderLabel: (0, $cstaF.agentProductionTerms).soldDate
    },
    (0, $7fq2m.gridColumnDefinitions).dom,
    (0, $7fq2m.gridColumnDefinitions).cdom,
    (0, $7fq2m.gridColumnDefinitions).bankStatus,
    ...$a74a1a6b59911d8e$var$additionalInfoListingsBothSidesColumnsSettings,
    (0, $7fq2m.gridColumnDefinitions).listAgent
];
const $a74a1a6b59911d8e$var$forUnderNewListingColumns = [
    {
        ...(0, $7fq2m.gridColumnDefinitions).listingStatus,
        hide: true,
        shouldExport: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).officeId,
        hide: true,
        shouldExport: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).office,
        hide: true,
        shouldExport: true
    },
    (0, $7fq2m.gridColumnDefinitions).mlsNum,
    (0, $7fq2m.gridColumnDefinitions).typeName,
    {
        ...(0, $7fq2m.gridColumnDefinitions).streetNum,
        hide: true,
        shouldExport: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).streetName,
        hide: true,
        shouldExport: true
    },
    (0, $7fq2m.gridColumnDefinitions).address,
    (0, $7fq2m.gridColumnDefinitions).city,
    (0, $7fq2m.gridColumnDefinitions).zipcode,
    (0, $7fq2m.gridColumnDefinitions).areaId,
    (0, $7fq2m.gridColumnDefinitions).orgPrice,
    {
        ...(0, $7fq2m.gridColumnDefinitions).listPrice,
        headerName: (0, $cstaF.agentProductionTerms).price,
        exportHeaderLabel: (0, $cstaF.agentProductionTerms).listPrice
    }
];
const $a74a1a6b59911d8e$var$forSaleColumns = [
    ...$a74a1a6b59911d8e$var$forUnderNewListingColumns,
    {
        ...(0, $7fq2m.gridColumnDefinitions).date,
        headerName: (0, $cstaF.agentProductionTerms).listDate
    },
    (0, $7fq2m.gridColumnDefinitions).dom,
    (0, $7fq2m.gridColumnDefinitions).cdom,
    (0, $7fq2m.gridColumnDefinitions).bankStatus,
    ...$a74a1a6b59911d8e$var$additionalInfoListingsForNewUnderColumnsSettings,
    (0, $7fq2m.gridColumnDefinitions).listAgent
];
const $a74a1a6b59911d8e$var$underContractColumns = [
    ...$a74a1a6b59911d8e$var$forUnderNewListingColumns,
    {
        ...(0, $7fq2m.gridColumnDefinitions).date,
        headerName: (0, $cstaF.agentProductionTerms).ucDate
    },
    (0, $7fq2m.gridColumnDefinitions).dom,
    (0, $7fq2m.gridColumnDefinitions).cdom,
    (0, $7fq2m.gridColumnDefinitions).bankStatus,
    ...$a74a1a6b59911d8e$var$additionalInfoListingsForNewUnderColumnsSettings,
    (0, $7fq2m.gridColumnDefinitions).listAgent
];
const $a74a1a6b59911d8e$var$newListingsColumns = $a74a1a6b59911d8e$var$forSaleColumns;
const $a74a1a6b59911d8e$var$officeDetailsTab = {
    id: (0, $3etjB.listingsBreakdownKeys).officeDetails,
    label: (0, $cstaF.searchTerms).officeDetails,
    columns: {
        byOffice: [],
        byBrokerage: []
    }
};
const $a74a1a6b59911d8e$var$soldBothSidesTabs = Object.freeze([
    {
        id: "soldBothSides",
        label: (0, $cstaF.searchTerms).soldBothSides,
        columns: {
            byOffice: [
                {
                    ...(0, $7fq2m.gridColumnDefinitions).listingStatus,
                    hide: true,
                    shouldExport: true
                },
                {
                    ...(0, $7fq2m.gridColumnDefinitions).officeId,
                    hide: true,
                    shouldExport: true
                },
                {
                    ...(0, $7fq2m.gridColumnDefinitions).office,
                    hide: true,
                    shouldExport: true
                },
                (0, $7fq2m.gridColumnDefinitions).mlsNum,
                (0, $7fq2m.gridColumnDefinitions).typeName,
                {
                    ...(0, $7fq2m.gridColumnDefinitions).streetNum,
                    hide: true,
                    shouldExport: true
                },
                {
                    ...(0, $7fq2m.gridColumnDefinitions).streetName,
                    hide: true,
                    shouldExport: true
                },
                (0, $7fq2m.gridColumnDefinitions).address,
                (0, $7fq2m.gridColumnDefinitions).city,
                (0, $7fq2m.gridColumnDefinitions).zipcode,
                (0, $7fq2m.gridColumnDefinitions).areaId,
                (0, $7fq2m.gridColumnDefinitions).orgPrice,
                (0, $7fq2m.gridColumnDefinitions).listPrice,
                (0, $7fq2m.gridColumnDefinitions).price,
                (0, $7fq2m.gridColumnDefinitions).date,
                (0, $7fq2m.gridColumnDefinitions).dom,
                (0, $7fq2m.gridColumnDefinitions).cdom,
                (0, $7fq2m.gridColumnDefinitions).bankStatus,
                ...$a74a1a6b59911d8e$var$additionalInfoListingsBothSidesColumnsSettings,
                (0, $7fq2m.gridColumnDefinitions).listAgent,
                (0, $7fq2m.gridColumnDefinitions).sellAgent,
                (0, $7fq2m.gridColumnDefinitions).doubleSided
            ],
            byBrokerage: [
                {
                    ...(0, $7fq2m.gridColumnDefinitions).listingStatus,
                    hide: true,
                    shouldExport: true
                },
                (0, $7fq2m.gridColumnDefinitions).mlsNum,
                (0, $7fq2m.gridColumnDefinitions).typeName,
                {
                    ...(0, $7fq2m.gridColumnDefinitions).streetNum,
                    hide: true,
                    shouldExport: true
                },
                {
                    ...(0, $7fq2m.gridColumnDefinitions).streetName,
                    hide: true,
                    shouldExport: true
                },
                (0, $7fq2m.gridColumnDefinitions).address,
                (0, $7fq2m.gridColumnDefinitions).city,
                (0, $7fq2m.gridColumnDefinitions).zipcode,
                (0, $7fq2m.gridColumnDefinitions).areaId,
                (0, $7fq2m.gridColumnDefinitions).orgPrice,
                (0, $7fq2m.gridColumnDefinitions).listPrice,
                (0, $7fq2m.gridColumnDefinitions).price,
                (0, $7fq2m.gridColumnDefinitions).date,
                (0, $7fq2m.gridColumnDefinitions).dom,
                (0, $7fq2m.gridColumnDefinitions).cdom,
                (0, $7fq2m.gridColumnDefinitions).bankStatus,
                ...$a74a1a6b59911d8e$var$additionalInfoListingsBothSidesColumnsSettings,
                {
                    ...(0, $7fq2m.gridColumnDefinitions).listAgent,
                    hide: true,
                    shouldExport: true
                },
                {
                    ...(0, $7fq2m.gridColumnDefinitions).sellAgent,
                    hide: true,
                    shouldExport: true
                },
                (0, $7fq2m.gridColumnDefinitions).listOfficeId,
                (0, $7fq2m.gridColumnDefinitions).listOfficeName,
                (0, $7fq2m.gridColumnDefinitions).sellOfficeId,
                (0, $7fq2m.gridColumnDefinitions).sellOfficeName
            ]
        }
    },
    {
        id: "soldListSide",
        label: (0, $cstaF.searchTerms).soldListSide,
        columns: {
            byOffice: [
                ...$a74a1a6b59911d8e$var$soldListSideColumns,
                {
                    ...(0, $7fq2m.gridColumnDefinitions).sellAgent,
                    hide: true,
                    shouldExport: true
                },
                {
                    ...(0, $7fq2m.gridColumnDefinitions).doubleSided,
                    hide: true,
                    shouldExport: true
                }
            ],
            byBrokerage: [
                ...$a74a1a6b59911d8e$var$soldListSideColumns,
                {
                    ...(0, $7fq2m.gridColumnDefinitions).sellAgent,
                    hide: true,
                    shouldExport: true
                },
                {
                    ...(0, $7fq2m.gridColumnDefinitions).listOfficeId,
                    hide: true,
                    shouldExport: true
                },
                {
                    ...(0, $7fq2m.gridColumnDefinitions).listOfficeName,
                    hide: true,
                    shouldExport: true
                },
                {
                    ...(0, $7fq2m.gridColumnDefinitions).sellOfficeId,
                    hide: true,
                    shouldExport: true
                },
                {
                    ...(0, $7fq2m.gridColumnDefinitions).sellOfficeName,
                    hide: true,
                    shouldExport: true
                }
            ]
        }
    },
    {
        id: "soldSellSide",
        label: (0, $cstaF.searchTerms).soldSellSide,
        columns: {
            byOffice: [
                {
                    ...(0, $7fq2m.gridColumnDefinitions).listingStatus,
                    hide: true,
                    shouldExport: true
                },
                {
                    ...(0, $7fq2m.gridColumnDefinitions).officeId,
                    hide: true,
                    shouldExport: true
                },
                {
                    ...(0, $7fq2m.gridColumnDefinitions).office,
                    hide: true,
                    shouldExport: true
                },
                (0, $7fq2m.gridColumnDefinitions).mlsNum,
                (0, $7fq2m.gridColumnDefinitions).typeName,
                {
                    ...(0, $7fq2m.gridColumnDefinitions).streetNum,
                    hide: true,
                    shouldExport: true
                },
                {
                    ...(0, $7fq2m.gridColumnDefinitions).streetName,
                    hide: true,
                    shouldExport: true
                },
                (0, $7fq2m.gridColumnDefinitions).address,
                (0, $7fq2m.gridColumnDefinitions).city,
                (0, $7fq2m.gridColumnDefinitions).zipcode,
                (0, $7fq2m.gridColumnDefinitions).areaId,
                (0, $7fq2m.gridColumnDefinitions).orgPrice,
                (0, $7fq2m.gridColumnDefinitions).listPrice,
                {
                    ...(0, $7fq2m.gridColumnDefinitions).price,
                    exportHeaderLabel: (0, $cstaF.agentProductionTerms).soldPrice
                },
                {
                    ...(0, $7fq2m.gridColumnDefinitions).date,
                    exportHeaderLabel: (0, $cstaF.agentProductionTerms).soldDate
                },
                (0, $7fq2m.gridColumnDefinitions).dom,
                (0, $7fq2m.gridColumnDefinitions).cdom,
                (0, $7fq2m.gridColumnDefinitions).bankStatus,
                ...$a74a1a6b59911d8e$var$additionalInfoListingsBothSidesColumnsSettings,
                {
                    ...(0, $7fq2m.gridColumnDefinitions).listAgent,
                    hide: true,
                    shouldExport: true
                },
                (0, $7fq2m.gridColumnDefinitions).sellAgent,
                {
                    ...(0, $7fq2m.gridColumnDefinitions).doubleSided,
                    hide: true,
                    shouldExport: true
                }
            ],
            byBrokerage: [
                {
                    ...(0, $7fq2m.gridColumnDefinitions).listingStatus,
                    hide: true,
                    shouldExport: true
                },
                {
                    ...(0, $7fq2m.gridColumnDefinitions).officeId,
                    hide: true,
                    shouldExport: true
                },
                {
                    ...(0, $7fq2m.gridColumnDefinitions).office,
                    hide: true,
                    shouldExport: true
                },
                (0, $7fq2m.gridColumnDefinitions).mlsNum,
                (0, $7fq2m.gridColumnDefinitions).typeName,
                {
                    ...(0, $7fq2m.gridColumnDefinitions).streetNum,
                    hide: true,
                    shouldExport: true
                },
                {
                    ...(0, $7fq2m.gridColumnDefinitions).streetName,
                    hide: true,
                    shouldExport: true
                },
                (0, $7fq2m.gridColumnDefinitions).address,
                (0, $7fq2m.gridColumnDefinitions).city,
                (0, $7fq2m.gridColumnDefinitions).zipcode,
                (0, $7fq2m.gridColumnDefinitions).areaId,
                (0, $7fq2m.gridColumnDefinitions).orgPrice,
                (0, $7fq2m.gridColumnDefinitions).listPrice,
                {
                    ...(0, $7fq2m.gridColumnDefinitions).price,
                    exportHeaderLabel: (0, $cstaF.agentProductionTerms).soldPrice
                },
                {
                    ...(0, $7fq2m.gridColumnDefinitions).date,
                    exportHeaderLabel: (0, $cstaF.agentProductionTerms).soldDate
                },
                (0, $7fq2m.gridColumnDefinitions).dom,
                (0, $7fq2m.gridColumnDefinitions).cdom,
                (0, $7fq2m.gridColumnDefinitions).bankStatus,
                ...$a74a1a6b59911d8e$var$additionalInfoListingsBothSidesColumnsSettings,
                {
                    ...(0, $7fq2m.gridColumnDefinitions).listAgent,
                    hide: true,
                    shouldExport: true
                },
                (0, $7fq2m.gridColumnDefinitions).sellAgent,
                {
                    ...(0, $7fq2m.gridColumnDefinitions).listOfficeId,
                    hide: true,
                    shouldExport: true
                },
                {
                    ...(0, $7fq2m.gridColumnDefinitions).listOfficeName,
                    hide: true,
                    shouldExport: true
                },
                {
                    ...(0, $7fq2m.gridColumnDefinitions).sellOfficeId,
                    hide: true,
                    shouldExport: true
                },
                {
                    ...(0, $7fq2m.gridColumnDefinitions).sellOfficeName,
                    hide: true,
                    shouldExport: true
                }
            ]
        }
    },
    $a74a1a6b59911d8e$var$officeDetailsTab
]);
const $a74a1a6b59911d8e$var$soldListSideTabs = Object.freeze([
    {
        id: "soldListSide",
        label: (0, $cstaF.searchTerms).soldListSide,
        columns: {
            byOffice: $a74a1a6b59911d8e$var$soldListSideColumns,
            byBrokerage: $a74a1a6b59911d8e$var$soldListSideColumns
        }
    },
    $a74a1a6b59911d8e$var$officeDetailsTab
]);
const $a74a1a6b59911d8e$var$soldSellSideTabs = Object.freeze([
    {
        id: "soldSellSide",
        label: (0, $cstaF.searchTerms).soldSellSide,
        columns: {
            byOffice: $a74a1a6b59911d8e$var$soldSellSideColumns,
            byBrokerage: $a74a1a6b59911d8e$var$soldSellSideColumns
        }
    },
    $a74a1a6b59911d8e$var$officeDetailsTab
]);
const $a74a1a6b59911d8e$var$forSaleTabs = Object.freeze([
    {
        id: "forSale",
        label: (0, $cstaF.searchTerms).forSale,
        columns: {
            byOffice: $a74a1a6b59911d8e$var$forSaleColumns,
            byBrokerage: $a74a1a6b59911d8e$var$forSaleColumns
        }
    },
    $a74a1a6b59911d8e$var$officeDetailsTab
]);
const $a74a1a6b59911d8e$var$underContractTabs = Object.freeze([
    {
        id: "underContract",
        label: (0, $cstaF.agentProductionTerms).underContractListing,
        columns: {
            byOffice: $a74a1a6b59911d8e$var$underContractColumns,
            byBrokerage: $a74a1a6b59911d8e$var$underContractColumns
        }
    },
    $a74a1a6b59911d8e$var$officeDetailsTab
]);
const $a74a1a6b59911d8e$var$newListingsTabs = Object.freeze([
    {
        id: (0, $3etjB.listingsBreakdownKeys).newListings,
        label: (0, $cstaF.marketShareListingStatuses).New,
        columns: {
            byOffice: $a74a1a6b59911d8e$var$newListingsColumns,
            byBrokerage: $a74a1a6b59911d8e$var$newListingsColumns
        }
    },
    $a74a1a6b59911d8e$var$officeDetailsTab
]);
const $a74a1a6b59911d8e$export$a93bf2e14f18e252 = Object.freeze({
    totalVolume: {
        settings: $a74a1a6b59911d8e$var$soldBothSidesTabs
    },
    totalUnits: {
        settings: $a74a1a6b59911d8e$var$soldBothSidesTabs
    },
    listVolume: {
        settings: $a74a1a6b59911d8e$var$soldListSideTabs
    },
    listUnits: {
        settings: $a74a1a6b59911d8e$var$soldListSideTabs
    },
    sellVolume: {
        settings: $a74a1a6b59911d8e$var$soldSellSideTabs
    },
    sellUnits: {
        settings: $a74a1a6b59911d8e$var$soldSellSideTabs
    },
    ucVolume: {
        settings: $a74a1a6b59911d8e$var$underContractTabs
    },
    ucUnits: {
        settings: $a74a1a6b59911d8e$var$underContractTabs
    },
    actVolume: {
        settings: $a74a1a6b59911d8e$var$forSaleTabs
    },
    actUnits: {
        settings: $a74a1a6b59911d8e$var$forSaleTabs
    },
    newListVolume: {
        settings: $a74a1a6b59911d8e$var$newListingsTabs
    },
    newListUnits: {
        settings: $a74a1a6b59911d8e$var$newListingsTabs
    }
});
const $a74a1a6b59911d8e$export$f1733b8733c67277 = Object.freeze({
    totalVolume: {
        settings: $a74a1a6b59911d8e$var$settingsTotalVolumeUnits
    },
    totalUnits: {
        settings: $a74a1a6b59911d8e$var$settingsTotalVolumeUnits
    },
    listVolume: {
        settings: $a74a1a6b59911d8e$var$settingsListSide
    },
    listUnits: {
        settings: $a74a1a6b59911d8e$var$settingsListSide
    },
    sellVolume: {
        settings: $a74a1a6b59911d8e$var$settingsSellSide
    },
    sellUnits: {
        settings: $a74a1a6b59911d8e$var$settingsSellSide
    },
    ucVolume: {
        settings: $a74a1a6b59911d8e$var$settingsUnderContract
    },
    ucUnits: {
        settings: $a74a1a6b59911d8e$var$settingsUnderContract
    },
    actVolume: {
        settings: $a74a1a6b59911d8e$var$settingsForSale
    },
    actUnits: {
        settings: $a74a1a6b59911d8e$var$settingsForSale
    },
    newListVolume: {
        settings: $a74a1a6b59911d8e$var$settingsNewListings
    },
    newListUnits: {
        settings: $a74a1a6b59911d8e$var$settingsNewListings
    }
});



var $94cVo = parcelRequire("94cVo");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $kfZjc = parcelRequire("kfZjc");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $aTLkh = parcelRequire("aTLkh");

var $3etjB = parcelRequire("3etjB");
parcelRequire("fHiKR");
var $1BYDb = parcelRequire("1BYDb");
const $11925ad2fab8b02a$var$TitleInfo = (props)=>{
    const { exportButton: exportButton, subtitle: subtitle, title: title, areaType: areaType, hasToggle: hasToggle, handleAdditionalInfoToggleChange: handleAdditionalInfoToggleChange, isAdditionalInfoToggleChecked: isAdditionalInfoToggleChecked } = props;
    const history = (0, $kfZjc.useHistory)();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "d-flex my-2",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                dataLwtId: "back-button",
                color: "secondary",
                size: "lg",
                className: "bg-dark p-1 d-flex align-self-stretch align-items-center",
                onClick: ()=>history.goBack(),
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aTLkh.default), {
                    className: "mr-1",
                    iconName: "navigate_before",
                    dataLwtId: "previous-icon"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "d-flex mt-2",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                            className: "mb-0 pb-0 font-weight-bold",
                            children: `${title} ${areaType ? `(${areaType})` : ""}`
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "mb-0 text-secondary",
                            children: subtitle
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "ml-auto d-flex w-auto align-self-center",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "ml-auto d-flex justify-content-center align-items-center",
                        children: hasToggle && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                    className: "mb-0 mr-2 clickable font-weight-normal font-gray-primary",
                                    onClick: handleAdditionalInfoToggleChange,
                                    children: (0, $3etjB.marketShareTerms).additionalInfo
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1BYDb))), {
                                    dataLwtId: "additional-info-toggle",
                                    type: "switch",
                                    id: "additional-info-toggle",
                                    onChange: handleAdditionalInfoToggleChange,
                                    checked: isAdditionalInfoToggleChecked
                                })
                            ]
                        })
                    }),
                    exportButton
                ]
            })
        ]
    });
};
var $11925ad2fab8b02a$export$2e2bcd8739ae039 = $11925ad2fab8b02a$var$TitleInfo;




var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
const $5435ed106b5768ed$var$NoRowsTitle = ({ message: message })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
        className: "no-search-results font-weight-bold",
        children: message
    });
};
var $5435ed106b5768ed$export$2e2bcd8739ae039 = $5435ed106b5768ed$var$NoRowsTitle;



var $7tOHe = parcelRequire("7tOHe");
parcelRequire("3lOdM");
var $e155p = parcelRequire("e155p");

var $cstaF = parcelRequire("cstaF");

var $7fq2m = parcelRequire("7fq2m");

var $3etjB = parcelRequire("3etjB");
const $6c17a48110cb28c5$var$officeColumns = [
    {
        ...(0, $7fq2m.gridColumnDefinitions).officeId,
        isAdditionalInfo: true,
        shouldExport: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).officeName,
        exportHeaderLabel: (0, $3etjB.marketShareTerms).office
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).streetName,
        isAdditionalInfo: true,
        shouldExport: true,
        headerName: (0, $3etjB.marketShareTerms).address
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).city,
        isAdditionalInfo: true,
        shouldExport: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).stateCode,
        isAdditionalInfo: true,
        shouldExport: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).zipcode,
        isAdditionalInfo: true,
        shouldExport: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).county,
        isAdditionalInfo: true,
        shouldExport: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).phoneNumber,
        isAdditionalInfo: true,
        shouldExport: true
    }
];
const $6c17a48110cb28c5$var$listingsColumns = [
    (0, $7fq2m.gridColumnDefinitions).mlsNum,
    (0, $7fq2m.gridColumnDefinitions).typeName,
    {
        ...(0, $7fq2m.gridColumnDefinitions).streetNum,
        hide: true,
        shouldExport: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).streetName,
        hide: true,
        shouldExport: true
    },
    (0, $7fq2m.gridColumnDefinitions).address,
    (0, $7fq2m.gridColumnDefinitions).city,
    (0, $7fq2m.gridColumnDefinitions).zipcode,
    (0, $7fq2m.gridColumnDefinitions).mlsArea
];
const $6c17a48110cb28c5$var$additionalInfoListingsColumns = [
    {
        ...(0, $7fq2m.gridColumnDefinitions).bedrooms,
        isAdditionalInfo: true,
        shouldExport: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).fullBaths,
        isAdditionalInfo: true,
        shouldExport: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).squareFt,
        isAdditionalInfo: true,
        shouldExport: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).costPerSqft,
        isAdditionalInfo: true,
        shouldExport: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).lotSizeSquareFt,
        isAdditionalInfo: true,
        shouldExport: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).lotSizeAcres,
        hide: true,
        shouldExport: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).yearBuilt,
        isAdditionalInfo: true,
        shouldExport: true
    }
];
const $6c17a48110cb28c5$var$settingsTotalVolumeUnits = {
    columns: [
        ...$6c17a48110cb28c5$var$officeColumns,
        {
            ...(0, $7fq2m.gridColumnDefinitions).listVolume,
            exportHeaderLabel: (0, $3etjB.marketShareTerms).list$Volume
        },
        {
            ...(0, $7fq2m.gridColumnDefinitions).listUnits,
            exportHeaderLabel: (0, $3etjB.marketShareTerms).listNumUnits
        },
        {
            ...(0, $7fq2m.gridColumnDefinitions).sellVolume,
            exportHeaderLabel: (0, $3etjB.marketShareTerms).sell$Volume
        },
        {
            ...(0, $7fq2m.gridColumnDefinitions).sellUnits,
            exportHeaderLabel: (0, $3etjB.marketShareTerms).sellNumUnits
        },
        {
            ...(0, $7fq2m.gridColumnDefinitions).totalVolume,
            exportHeaderLabel: (0, $3etjB.marketShareTerms).total$Volume
        },
        {
            ...(0, $7fq2m.gridColumnDefinitions).totalUnits,
            exportHeaderLabel: (0, $3etjB.marketShareTerms).totalNumUnits
        },
        (0, $7fq2m.gridColumnDefinitions).marketSharePct,
        (0, $7fq2m.gridColumnDefinitions).totalAveragePrice,
        (0, $7fq2m.gridColumnDefinitions).agentCount,
        {
            ...(0, $7fq2m.gridColumnDefinitions).prodAgentSearchCount,
            exportHeaderLabel: (0, $3etjB.marketShareTerms).prodAgentsCurrentSearch
        }
    ],
    translatedFieldViews: {
        totalVolume: "totalVolume",
        totalUnits: "totalUnits"
    }
};
const $6c17a48110cb28c5$var$settingsListSide = {
    columns: [
        ...$6c17a48110cb28c5$var$officeColumns,
        {
            ...(0, $7fq2m.gridColumnDefinitions).listVolume,
            exportHeaderLabel: (0, $cstaF.agentProductionTerms).listDollars
        },
        {
            ...(0, $7fq2m.gridColumnDefinitions).listUnits,
            exportHeaderLabel: (0, $cstaF.agentProductionTerms).listNumber
        },
        (0, $7fq2m.gridColumnDefinitions).marketSharePct,
        (0, $7fq2m.gridColumnDefinitions).closeListRatio,
        (0, $7fq2m.gridColumnDefinitions).listAverageDom,
        (0, $7fq2m.gridColumnDefinitions).listSpop,
        (0, $7fq2m.gridColumnDefinitions).listAveragePrice,
        (0, $7fq2m.gridColumnDefinitions).agentCount,
        {
            ...(0, $7fq2m.gridColumnDefinitions).prodAgentSearchCount,
            exportHeaderLabel: (0, $3etjB.marketShareTerms).prodAgentsCurrentSearch
        }
    ],
    translatedFieldViews: {
        listVolume: "listVolume",
        listUnits: "listUnits"
    }
};
const $6c17a48110cb28c5$var$settingsSellSide = {
    columns: [
        ...$6c17a48110cb28c5$var$officeColumns,
        {
            ...(0, $7fq2m.gridColumnDefinitions).sellVolume,
            exportHeaderLabel: (0, $cstaF.agentProductionTerms).sellDollars
        },
        {
            ...(0, $7fq2m.gridColumnDefinitions).sellUnits,
            exportHeaderLabel: (0, $cstaF.agentProductionTerms).sellNumber
        },
        (0, $7fq2m.gridColumnDefinitions).marketSharePct,
        (0, $7fq2m.gridColumnDefinitions).sellSpop,
        (0, $7fq2m.gridColumnDefinitions).sellAveragePrice,
        (0, $7fq2m.gridColumnDefinitions).agentCount,
        {
            ...(0, $7fq2m.gridColumnDefinitions).prodAgentSearchCount,
            exportHeaderLabel: (0, $3etjB.marketShareTerms).prodAgentsCurrentSearch
        }
    ],
    translatedFieldViews: {
        sellVolume: "sellVolume",
        sellUnits: "sellUnits"
    }
};
const $6c17a48110cb28c5$var$settingsForSale = {
    columns: [
        ...$6c17a48110cb28c5$var$officeColumns,
        {
            ...(0, $7fq2m.gridColumnDefinitions).fsVolume,
            exportHeaderLabel: (0, $3etjB.marketShareTerms).forSaleVolume
        },
        {
            ...(0, $7fq2m.gridColumnDefinitions).fsUnits,
            exportHeaderLabel: (0, $3etjB.marketShareTerms).forSaleUnits
        },
        (0, $7fq2m.gridColumnDefinitions).marketSharePct,
        (0, $7fq2m.gridColumnDefinitions).averageDom,
        (0, $7fq2m.gridColumnDefinitions).averagePrice,
        {
            ...(0, $7fq2m.gridColumnDefinitions).prodAgentSearchCount,
            exportHeaderLabel: (0, $3etjB.marketShareTerms).mlsIds
        }
    ],
    translatedFieldViews: {
        actVolume: "volume",
        actUnits: "units"
    }
};
const $6c17a48110cb28c5$var$settingsNewListings = {
    columns: [
        ...$6c17a48110cb28c5$var$officeColumns,
        (0, $7fq2m.gridColumnDefinitions).newVolume,
        (0, $7fq2m.gridColumnDefinitions).newUnits,
        (0, $7fq2m.gridColumnDefinitions).marketSharePct,
        (0, $7fq2m.gridColumnDefinitions).averageDom,
        (0, $7fq2m.gridColumnDefinitions).averagePrice,
        (0, $7fq2m.gridColumnDefinitions).agentCount
    ],
    translatedFieldViews: {
        newListVolume: "volume",
        newListUnits: "units"
    }
};
const $6c17a48110cb28c5$var$settingsUnderContract = {
    columns: [
        ...$6c17a48110cb28c5$var$officeColumns,
        (0, $7fq2m.gridColumnDefinitions).ucVolumeAlt,
        (0, $7fq2m.gridColumnDefinitions).ucUnitsAlt,
        (0, $7fq2m.gridColumnDefinitions).marketSharePct,
        (0, $7fq2m.gridColumnDefinitions).averageDom,
        (0, $7fq2m.gridColumnDefinitions).averagePrice,
        (0, $7fq2m.gridColumnDefinitions).agentCount
    ],
    translatedFieldViews: {
        ucVolume: "volume",
        ucUnits: "units"
    }
};
const $6c17a48110cb28c5$var$soldBothSidesColumns = [
    ...$6c17a48110cb28c5$var$listingsColumns,
    (0, $7fq2m.gridColumnDefinitions).orgPrice,
    (0, $7fq2m.gridColumnDefinitions).listPrice,
    (0, $7fq2m.gridColumnDefinitions).soldPrice,
    (0, $7fq2m.gridColumnDefinitions).date,
    (0, $7fq2m.gridColumnDefinitions).dom,
    (0, $7fq2m.gridColumnDefinitions).cdom,
    (0, $7fq2m.gridColumnDefinitions).bankStatus,
    {
        ...(0, $7fq2m.gridColumnDefinitions).priceChangeCnt,
        isAdditionalInfo: true,
        shouldExport: true
    },
    (0, $7fq2m.gridColumnDefinitions).spop,
    (0, $7fq2m.gridColumnDefinitions).splp,
    ...$6c17a48110cb28c5$var$additionalInfoListingsColumns,
    {
        ...(0, $7fq2m.gridColumnDefinitions).listAgent,
        hide: true,
        shouldExport: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).sellAgent,
        hide: true,
        shouldExport: true
    },
    (0, $7fq2m.gridColumnDefinitions).listOfficeId,
    (0, $7fq2m.gridColumnDefinitions).listOfficeName,
    (0, $7fq2m.gridColumnDefinitions).sellOfficeId,
    (0, $7fq2m.gridColumnDefinitions).sellOfficeName
];
const $6c17a48110cb28c5$var$soldSellSideColumns = [
    ...$6c17a48110cb28c5$var$listingsColumns,
    (0, $7fq2m.gridColumnDefinitions).orgPrice,
    (0, $7fq2m.gridColumnDefinitions).listPrice,
    (0, $7fq2m.gridColumnDefinitions).soldPrice,
    (0, $7fq2m.gridColumnDefinitions).date,
    (0, $7fq2m.gridColumnDefinitions).dom,
    (0, $7fq2m.gridColumnDefinitions).cdom,
    (0, $7fq2m.gridColumnDefinitions).bankStatus,
    {
        ...(0, $7fq2m.gridColumnDefinitions).priceChangeCnt,
        isAdditionalInfo: true,
        shouldExport: true
    },
    (0, $7fq2m.gridColumnDefinitions).spop,
    (0, $7fq2m.gridColumnDefinitions).splp,
    ...$6c17a48110cb28c5$var$additionalInfoListingsColumns,
    (0, $7fq2m.gridColumnDefinitions).sellAgent
];
const $6c17a48110cb28c5$var$soldListSideColumns = [
    (0, $7fq2m.gridColumnDefinitions).mlsNum,
    (0, $7fq2m.gridColumnDefinitions).typeName,
    {
        ...(0, $7fq2m.gridColumnDefinitions).streetNum,
        hide: true,
        shouldExport: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).streetName,
        hide: true,
        shouldExport: true
    },
    (0, $7fq2m.gridColumnDefinitions).address,
    (0, $7fq2m.gridColumnDefinitions).city,
    (0, $7fq2m.gridColumnDefinitions).zipcode,
    (0, $7fq2m.gridColumnDefinitions).mlsArea,
    (0, $7fq2m.gridColumnDefinitions).orgPrice,
    (0, $7fq2m.gridColumnDefinitions).listPrice,
    (0, $7fq2m.gridColumnDefinitions).soldPrice,
    (0, $7fq2m.gridColumnDefinitions).date,
    (0, $7fq2m.gridColumnDefinitions).dom,
    (0, $7fq2m.gridColumnDefinitions).cdom,
    (0, $7fq2m.gridColumnDefinitions).bankStatus,
    {
        ...(0, $7fq2m.gridColumnDefinitions).priceChangeCnt,
        isAdditionalInfo: true,
        shouldExport: true
    },
    (0, $7fq2m.gridColumnDefinitions).spop,
    (0, $7fq2m.gridColumnDefinitions).splp,
    ...$6c17a48110cb28c5$var$additionalInfoListingsColumns,
    (0, $7fq2m.gridColumnDefinitions).listAgent
];
const $6c17a48110cb28c5$var$forSaleColumns = [
    (0, $7fq2m.gridColumnDefinitions).mlsNum,
    (0, $7fq2m.gridColumnDefinitions).typeName,
    {
        ...(0, $7fq2m.gridColumnDefinitions).streetNum,
        hide: true,
        shouldExport: true
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).streetName,
        hide: true,
        shouldExport: true
    },
    (0, $7fq2m.gridColumnDefinitions).address,
    (0, $7fq2m.gridColumnDefinitions).city,
    (0, $7fq2m.gridColumnDefinitions).zipcode,
    (0, $7fq2m.gridColumnDefinitions).mlsArea,
    (0, $7fq2m.gridColumnDefinitions).orgPrice,
    {
        ...(0, $7fq2m.gridColumnDefinitions).listPrice,
        headerName: (0, $cstaF.agentProductionTerms).price,
        exportHeaderLabel: (0, $cstaF.agentProductionTerms).price
    },
    {
        ...(0, $7fq2m.gridColumnDefinitions).date,
        headerName: (0, $cstaF.agentProductionTerms).listDate
    },
    (0, $7fq2m.gridColumnDefinitions).dom,
    (0, $7fq2m.gridColumnDefinitions).cdom,
    (0, $7fq2m.gridColumnDefinitions).bankStatus,
    {
        ...(0, $7fq2m.gridColumnDefinitions).priceChangeCnt,
        isAdditionalInfo: true,
        shouldExport: true
    },
    ...$6c17a48110cb28c5$var$additionalInfoListingsColumns,
    (0, $7fq2m.gridColumnDefinitions).listAgent
];
const $6c17a48110cb28c5$var$officeDetailsTab = {
    id: (0, $3etjB.listingsBreakdownKeys).officeDetails,
    label: (0, $cstaF.searchTerms).officeDetails,
    columns: {
        byOffice: [],
        byBrokerage: []
    }
};
const $6c17a48110cb28c5$var$soldBothSidesTabs = Object.freeze([
    {
        id: "soldBothSides",
        label: (0, $cstaF.searchTerms).soldBothSides,
        columns: $6c17a48110cb28c5$var$soldBothSidesColumns
    },
    {
        id: "soldListSide",
        label: (0, $cstaF.searchTerms).soldListSide,
        columns: $6c17a48110cb28c5$var$soldListSideColumns
    },
    {
        id: "soldSellSide",
        label: (0, $cstaF.searchTerms).soldSellSide,
        columns: $6c17a48110cb28c5$var$soldSellSideColumns
    },
    $6c17a48110cb28c5$var$officeDetailsTab
]);
const $6c17a48110cb28c5$var$soldListSideTabs = Object.freeze([
    {
        id: "soldListSide",
        label: (0, $cstaF.searchTerms).soldListSide,
        columns: $6c17a48110cb28c5$var$soldListSideColumns
    },
    $6c17a48110cb28c5$var$officeDetailsTab
]);
const $6c17a48110cb28c5$var$soldSellSideTabs = Object.freeze([
    {
        id: "soldSellSide",
        label: (0, $cstaF.searchTerms).soldSellSide,
        columns: $6c17a48110cb28c5$var$soldSellSideColumns
    },
    $6c17a48110cb28c5$var$officeDetailsTab
]);
const $6c17a48110cb28c5$var$forSaleTabs = Object.freeze([
    {
        id: "forSale",
        label: (0, $cstaF.searchTerms).forSale,
        columns: $6c17a48110cb28c5$var$forSaleColumns
    },
    $6c17a48110cb28c5$var$officeDetailsTab
]);
const $6c17a48110cb28c5$export$2dfc6377a2490f01 = Object.freeze({
    totalVolume: {
        settings: $6c17a48110cb28c5$var$soldBothSidesTabs
    },
    totalUnits: {
        settings: $6c17a48110cb28c5$var$soldBothSidesTabs
    },
    listVolume: {
        settings: $6c17a48110cb28c5$var$soldListSideTabs
    },
    listUnits: {
        settings: $6c17a48110cb28c5$var$soldListSideTabs
    },
    sellVolume: {
        settings: $6c17a48110cb28c5$var$soldSellSideTabs
    },
    sellUnits: {
        settings: $6c17a48110cb28c5$var$soldSellSideTabs
    },
    actVolume: {
        settings: $6c17a48110cb28c5$var$forSaleTabs
    },
    actUnits: {
        settings: $6c17a48110cb28c5$var$forSaleTabs
    }
});
const $6c17a48110cb28c5$export$6f1182a788c243af = Object.freeze({
    totalVolume: {
        settings: $6c17a48110cb28c5$var$settingsTotalVolumeUnits
    },
    totalUnits: {
        settings: $6c17a48110cb28c5$var$settingsTotalVolumeUnits
    },
    listVolume: {
        settings: $6c17a48110cb28c5$var$settingsListSide
    },
    listUnits: {
        settings: $6c17a48110cb28c5$var$settingsListSide
    },
    sellVolume: {
        settings: $6c17a48110cb28c5$var$settingsSellSide
    },
    sellUnits: {
        settings: $6c17a48110cb28c5$var$settingsSellSide
    },
    ucVolume: {
        settings: $6c17a48110cb28c5$var$settingsUnderContract
    },
    ucUnits: {
        settings: $6c17a48110cb28c5$var$settingsUnderContract
    },
    actVolume: {
        settings: $6c17a48110cb28c5$var$settingsForSale
    },
    actUnits: {
        settings: $6c17a48110cb28c5$var$settingsForSale
    },
    newListVolume: {
        settings: $6c17a48110cb28c5$var$settingsNewListings
    },
    newListUnits: {
        settings: $6c17a48110cb28c5$var$settingsNewListings
    }
});



var $cstaF = parcelRequire("cstaF");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

parcelRequire("3lOdM");
var $1iwUl = parcelRequire("1iwUl");
var $e155p = parcelRequire("e155p");

const $9a31112952bcfc13$var$OfficeDetails = (data)=>{
    const column1 = (0, $5f95247c68892fb4$export$c84a608021307b6c)(data);
    const column2 = (0, $5f95247c68892fb4$export$34fd9c81845a7922)(data);
    const columns = [
        column1,
        column2
    ];
    const renderEntry = (entry)=>{
        const value = entry.value ?? "";
        let className = "border-top m-0";
        if (entry.isLastRow) className += " border-bottom";
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($e155p))), {
                className: className,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1iwUl))), {
                        children: entry.description
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1iwUl))), {
                        className: "font-weight-bold",
                        children: value
                    })
                ]
            })
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: columns.map((column, index)=>{
            return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "col-lg-6 col-md-12 pd-0",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $83e1bef4b926bdd3$export$2e2bcd8739ae039), {
                    dataLwtId: `office-details-column-${index}`,
                    data: column,
                    renderEntry: renderEntry
                })
            }, index);
        })
    });
};
var $9a31112952bcfc13$export$2e2bcd8739ae039 = $9a31112952bcfc13$var$OfficeDetails;




const $caae81a603f93a4a$var$toggleVisibilityForAdditionalInfo = (column, shouldHide)=>{
    if (column.isAdditionalInfo) return {
        ...column,
        hide: shouldHide
    };
    return column;
};
const $caae81a603f93a4a$export$e8e5dae2653ea5d8 = (colDefs, shouldShowAdditionalInfo)=>{
    return colDefs.map((col)=>$caae81a603f93a4a$var$toggleVisibilityForAdditionalInfo(col, !shouldShowAdditionalInfo));
};




var $90ISC = parcelRequire("90ISC");

var $i95vK = parcelRequire("i95vK");
const $58520067ba3cbcf2$var$ListingsBreakdown = ({ module: module })=>{
    const gridRef = (0, $acw62.useRef)();
    const query = (0, $bq4QZ.useQuery)();
    const location = (0, $kfZjc.useLocation)();
    const history = (0, $kfZjc.useHistory)();
    const title = (0, $94cVo.useURIDecoder)("office");
    const officeId = query.get("id");
    const listingTypeId = location.state?.listingTypeId;
    const listingViewId = location.state?.view;
    const areaId = location.state?.area;
    const isCoverageSearch = module === (0, $cstaF.modules).marketShare.coverage;
    const { search: search, loadedSearchCriteria: loadedSearchCriteria } = (0, $90ISC.useSearchStore)((state)=>({
            search: state[module]?.search,
            loadedSearchCriteria: state[module]?.loadedSearchCriteria
        }));
    const mlsProviders = (0, $90ISC.useCommonStore)((state)=>state.mlsProviders);
    const [state, setState] = (0, $acw62.useState)({
        soldBothSides: [],
        soldListSide: [],
        soldSellSide: [],
        forSale: [],
        underContract: [],
        newListings: [],
        officeDetails: [],
        searchCriteria: null,
        isLoading: true,
        selectedMlsId: null,
        isShowAdditionalInfo: false,
        sortedColumns: {
            0: undefined
        },
        currentTabIndex: 0
    });
    const searchType = state.searchCriteria?.realEstateDatasourceIdsWithFilters[0]?.computedFields.find((computedField)=>computedField.fieldName === "transactionStatus")?.fieldValues[0];
    const shouldRender = !!module;
    (0, $acw62.useEffect)(()=>{
        if (!shouldRender) history.push("/");
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (search?.searchCriteria?.criteria === undefined) {
            setState((prevState)=>({
                    ...prevState,
                    isLoading: false
                }));
            history.goBack();
        }
    }, [
        search
    ]);
    (0, $acw62.useEffect)(()=>{
        (0, $ivaD7.setStateData)("searchCriteria", loadedSearchCriteria, setState);
    }, [
        loadedSearchCriteria
    ]);
    (0, $acw62.useEffect)(()=>{
        (0, $ivaD7.setStateData)("selectedMlsId", search?.mlsId, setState);
    }, [
        search
    ]);
    const getRows = async (transactionStatus, officeId, searchCriteria, selectedMlsId)=>{
        let error;
        const getListings = isCoverageSearch ? (0, $24YIE.getCoverageListingBreakdown) : (0, $24YIE.getListingBreakdown);
        const listingsRows = await getListings(officeId, searchCriteria, transactionStatus, areaId).catch((e)=>{
            error = e;
        });
        let officeDetailsRow = await (0, $24YIE.getBreakdownOfficeDetails)(selectedMlsId, officeId).catch((e)=>{
            error = e;
        });
        const brokerId = officeDetailsRow?.brokerId;
        const offices = await (0, $24YIE.getOfficeBreakdownList)(brokerId, state.searchCriteria).catch((e)=>{
            error = e;
        });
        const selectedMls = mlsProviders.find((mls)=>mls.mlsId === selectedMlsId)?.shortDescription;
        const agentCount = offices?.results?.find((office)=>office.officeId === officeId)?.agentCount;
        officeDetailsRow = {
            ...officeDetailsRow,
            mlsId: agentCount,
            mls: selectedMls
        };
        return {
            listingsRows: listingsRows,
            officeDetailsRow: officeDetailsRow,
            error: error
        };
    };
    const processError = (e, errorType)=>console.log(`Listing Breakdown ${errorType} error: ${e}`);
    (0, $acw62.useEffect)(()=>{
        if (!shouldRender) return;
        if (!state.searchCriteria) return;
        let soldBothSides = [];
        let soldListSide = [];
        let soldSellSide = [];
        let forSale = [];
        let underContract = [];
        let newListings = [];
        let officeDetails = [];
        const loadListings = async ()=>{
            (0, $ivaD7.setStateData)("isLoading", true, setState);
            if (searchType === (0, $3etjB.searchTypes).soldBothSides) {
                const result = await getRows((0, $3etjB.searchTypes).soldBothSides, officeId, state.searchCriteria, state.selectedMlsId);
                if (result.error) {
                    processError(result.error, (0, $3etjB.searchTypes).soldBothSides);
                    return;
                }
                soldBothSides = result.listingsRows;
                officeDetails = result.officeDetailsRow;
            }
            if ([
                (0, $3etjB.searchTypes).soldListSide,
                (0, $3etjB.searchTypes).soldBothSides
            ].find((t)=>t === searchType)) {
                const result = await getRows((0, $3etjB.searchTypes).soldListSide, officeId, state.searchCriteria, state.selectedMlsId);
                if (result.error) {
                    processError(result.error, (0, $3etjB.searchTypes).soldListSide);
                    return;
                }
                soldListSide = result.listingsRows;
                officeDetails = result.officeDetailsRow;
            }
            if ([
                (0, $3etjB.searchTypes).soldSellSide,
                (0, $3etjB.searchTypes).soldBothSides
            ].find((t)=>t === searchType)) {
                const result = await getRows((0, $3etjB.searchTypes).soldSellSide, officeId, state.searchCriteria, state.selectedMlsId);
                if (result.error) {
                    processError(result.error, (0, $3etjB.searchTypes).soldSellSide);
                    return;
                }
                soldSellSide = result.listingsRows;
                officeDetails = result.officeDetailsRow;
            }
            if (searchType === (0, $3etjB.searchTypes).forSale) {
                const result = await getRows((0, $3etjB.searchTypes).forSale, officeId, state.searchCriteria, state.selectedMlsId);
                if (result.error) {
                    processError(result.error, (0, $3etjB.searchTypes).forSale);
                    return;
                }
                forSale = result.listingsRows;
                officeDetails = result.officeDetailsRow;
            }
            if (searchType === (0, $3etjB.searchTypes).underContract) {
                const result = await getRows((0, $3etjB.searchTypes).underContract, officeId, state.searchCriteria, state.selectedMlsId);
                if (result.error) {
                    processError(result.error, (0, $3etjB.searchTypes).underContract);
                    return;
                }
                underContract = result.listingsRows;
                officeDetails = result.officeDetailsRow;
            }
            if (searchType === (0, $3etjB.searchTypes).newListings) {
                const result = await getRows((0, $3etjB.searchTypes).newListings, officeId, state.searchCriteria, state.selectedMlsId);
                if (result.error) {
                    processError(result.error, (0, $3etjB.searchTypes).newListings);
                    return;
                }
                newListings = result.listingsRows;
                officeDetails = result.officeDetailsRow;
            }
            Promise.all([
                soldBothSides,
                soldListSide,
                soldSellSide,
                forSale,
                underContract,
                newListings,
                officeDetails
            ]).then(()=>(0, $ivaD7.setStateData)("isLoading", false, setState));
            setState({
                ...state,
                soldBothSides: soldBothSides,
                soldListSide: soldListSide,
                soldSellSide: soldSellSide,
                forSale: forSale,
                underContract: underContract,
                newListings: newListings,
                officeDetails: officeDetails
            });
        };
        const detailError = (e)=>console.error(e);
        loadListings().catch(detailError);
    }, [
        state.searchCriteria
    ]);
    if (!shouldRender) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {});
    const tabItems = isCoverageSearch ? (0, $6c17a48110cb28c5$export$2dfc6377a2490f01)[listingViewId]?.settings : (0, $a74a1a6b59911d8e$export$a93bf2e14f18e252)[listingViewId]?.settings;
    const onSortChanged = (e)=>{
        const sortedColumn = e?.columnApi.api.columnModel.gridColumns.find((colDef)=>colDef.sort);
        const sortedColumnsByTab = {
            ...state.sortedColumns,
            [state.currentTabIndex]: sortedColumn
        };
        (0, $ivaD7.setStateData)("sortedColumns", sortedColumnsByTab, setState);
    };
    const updatedTabItems = tabItems?.map((listing, tabIndex)=>{
        if (tabIndex !== state.currentTabIndex) return {
            title: listing.label,
            content: {
                jsx: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {})
            }
        };
        if (listing.id === (0, $3etjB.listingsBreakdownKeys).officeDetails) return {
            title: listing.label,
            content: {
                jsx: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "d-flex mt-2",
                    id: "office-details",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9a31112952bcfc13$export$2e2bcd8739ae039), {
                        data: state.officeDetails,
                        mlsProviders: mlsProviders
                    })
                })
            }
        };
        const colDefs = isCoverageSearch ? listing.columns : listing.columns[listingTypeId];
        const rowData = state[listing.id];
        const currentSortedColumn = state.sortedColumns[state.currentTabIndex];
        const sortedColumnsDefs = rowData?.length ? (0, $94cVo.getSortedColumns)(colDefs, currentSortedColumn?.colId || "date", currentSortedColumn?.sort) : [];
        const columnDefs = (0, $caae81a603f93a4a$export$e8e5dae2653ea5d8)(sortedColumnsDefs, state.isShowAdditionalInfo);
        let noRowMessage = null;
        if (listing.id.toLowerCase() === (0, $3etjB.searchTypes).soldListSide.toLowerCase() || listing.id.toLowerCase() === (0, $3etjB.searchTypes).soldSellSide.toLowerCase()) noRowMessage = {
            message: (0, $3etjB.marketShareTerms).noListingRowsToShow(listing.label)
        };
        return {
            title: listing.label,
            content: {
                jsx: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "mt-2",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d10d25c347bf887$export$2e2bcd8739ae039), {
                        gridRef: gridRef,
                        rowData: rowData,
                        columnDefs: columnDefs,
                        noRowsComponent: (0, $5435ed106b5768ed$export$2e2bcd8739ae039),
                        noRowMessage: noRowMessage,
                        onSortChanged: onSortChanged
                    })
                })
            }
        };
    }) || [];
    const handleAdditionalInfoToggleChange = ()=>(0, $ivaD7.setStateData)("isShowAdditionalInfo", !state.isShowAdditionalInfo, setState);
    const setCurrentTabIndex = (tabIndex)=>(0, $ivaD7.setStateData)("currentTabIndex", tabIndex, setState);
    const hasToggle = tabItems && tabItems[state.currentTabIndex].id !== (0, $3etjB.listingsBreakdownKeys).officeDetails;
    let exportButton;
    const currentTabHasRows = tabItems && state[tabItems[state.currentTabIndex]?.id]?.length;
    if (currentTabHasRows) {
        const searchType = tabItems[state.currentTabIndex]?.id;
        const listingBreakdownStatus = (0, $18776b3ee2cfdc05$export$69d919c64c2c5ff4)(searchType);
        const exportDetails = {
            exportType: (0, $6b56815170881da9$export$382f55aa456f5721).msListingsBreakdown,
            tableName: title,
            listingBreakdownStatus: listingBreakdownStatus
        };
        exportButton = (0, $0d036ea0861162a7$export$e89cb83db8826f3)({
            exportDetails: exportDetails,
            gridRef: gridRef,
            type: (0, $i95vK.exportButtonTypes).secondary
        });
    }
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $11925ad2fab8b02a$export$2e2bcd8739ae039), {
                title: title,
                subtitle: (0, $3etjB.marketShareTerms).listingBreakdown,
                hasToggle: hasToggle,
                exportButton: exportButton,
                isAdditionalInfoToggleChecked: state.isShowAdditionalInfo,
                handleAdditionalInfoToggleChange: handleAdditionalInfoToggleChange
            }),
            state.isLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e155p))), {
                className: "align-items-center justify-content-center mr-0 m-1 pt-5",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {})
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8f390b0d641c1be9$export$2e2bcd8739ae039), {
                tabTextTransform: "none",
                items: updatedTabItems,
                currentIndex: state.currentTabIndex,
                setCurrentIndex: setCurrentTabIndex,
                contentSize: updatedTabItems?.length,
                navSize: updatedTabItems?.length
            })
        ]
    });
};
$58520067ba3cbcf2$var$ListingsBreakdown.propTypes = {
    module: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    mlsProviders: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array
};
var $58520067ba3cbcf2$export$2e2bcd8739ae039 = $58520067ba3cbcf2$var$ListingsBreakdown;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $kfZjc = parcelRequire("kfZjc");

var $7tOHe = parcelRequire("7tOHe");

var $24YIE = parcelRequire("24YIE");

var $ivaD7 = parcelRequire("ivaD7");

var $bq4QZ = parcelRequire("bq4QZ");

var $3etjB = parcelRequire("3etjB");


var $94cVo = parcelRequire("94cVo");



var $cstaF = parcelRequire("cstaF");





var $jenAg = parcelRequire("jenAg");


var $c7dF9 = parcelRequire("c7dF9");

var $90ISC = parcelRequire("90ISC");


var $i95vK = parcelRequire("i95vK");
const $468bbfe6e98eaf46$var$OfficesBreakdown = ({ module: module })=>{
    const query = (0, $bq4QZ.useQuery)();
    const gridRef = (0, $acw62.useRef)();
    const location = (0, $kfZjc.useLocation)();
    const history = (0, $kfZjc.useHistory)();
    const areaId = query.get("areaId");
    const areaName = location.state?.area;
    const isCoverageSearch = module === (0, $cstaF.modules).marketShare.coverage;
    const officeGroupName = query.get("officeGroupName");
    const title = isCoverageSearch ? areaName : query.get("brokerage") || officeGroupName;
    const brokerId = query.get("id");
    const listingViewId = query.get("view");
    const listingTypeId = location.state?.type;
    const sumOfColumn = location.state?.sumOfColumn;
    const rowCount = location.state?.rowCount;
    const { loadedSearchCriteria: loadedSearchCriteria, search: search, areaTypeTitle: areaTypeTitle, selectedComparisonSetSearch: selectedComparisonSetSearch } = (0, $90ISC.useSearchStore)((state)=>({
            loadedSearchCriteria: state[module]?.loadedSearchCriteria,
            search: state[module]?.search,
            areaTypeTitle: state[module]?.areaTypeTitle,
            selectedComparisonSetSearch: state[module]?.selectedComparisonSetSearch
        }));
    const [state, setState] = (0, $acw62.useState)({
        searchCriteria: null,
        offices: [],
        columnDefs: [],
        isShowAdditionalInfo: false,
        isLoading: true,
        selectedAreaType: null,
        totalsAverages: {}
    });
    const listingStatus = (0, $jenAg.getListingStatus)(module, state.searchCriteria);
    const shouldRender = !!module;
    (0, $acw62.useEffect)(()=>{
        if (!shouldRender) history.push("/");
    }, []);
    (0, $acw62.useEffect)(()=>{
        (0, $ivaD7.setStateData)("searchCriteria", loadedSearchCriteria, setState);
    }, [
        loadedSearchCriteria
    ]);
    (0, $acw62.useEffect)(()=>{
        const criteria = search.searchCriteria.criteria;
        if (criteria === undefined) return history.goBack();
        setState((prevState)=>({
                ...prevState,
                searchCriteria: criteria
            }));
    }, [
        search
    ]);
    (0, $acw62.useEffect)(()=>{
        (0, $ivaD7.setStateData)("selectedAreaType", areaTypeTitle?.mainTitle.slice((0, $cstaF.searchTerms).selectedAreaTypeTitle.length), setState);
    }, [
        areaTypeTitle
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!shouldRender) return;
        if (!state.searchCriteria) return;
        const columnToRankBy = isCoverageSearch ? (0, $6c17a48110cb28c5$export$6f1182a788c243af)[listingViewId]?.settings.translatedFieldViews[listingViewId] : (0, $a74a1a6b59911d8e$export$f1733b8733c67277)[listingViewId]?.settings.translatedFieldViews[listingViewId];
        const sortedColumns = isCoverageSearch ? (0, $94cVo.getSortedColumns)((0, $6c17a48110cb28c5$export$6f1182a788c243af)[listingViewId]?.settings.columns, columnToRankBy) : (0, $94cVo.getSortedColumns)((0, $a74a1a6b59911d8e$export$f1733b8733c67277)[listingViewId]?.settings.columns, columnToRankBy);
        const columnDefs = (0, $caae81a603f93a4a$export$e8e5dae2653ea5d8)(sortedColumns, false);
        let transformedData = null;
        const loadOfficesListings = async ()=>{
            let error = null;
            let data;
            if (isCoverageSearch) {
                data = await (0, $24YIE.getCoverageOfficeBreakdownList)(areaId, state.searchCriteria).catch((e)=>{
                    error = e;
                });
                const stats = {
                    sumOfColumn: sumOfColumn,
                    rowCount: rowCount
                };
                transformedData = (0, $94cVo.transformData)(data?.results, stats, columnToRankBy, isCoverageSearch).map((area)=>({
                        ...area,
                        areaId: areaId,
                        listingViewId: listingViewId,
                        isCoverageSearch: isCoverageSearch
                    }));
            } else {
                data = await (0, $f2afd5e1d9122573$export$c3217f7fa012939b)(brokerId, selectedComparisonSetSearch, officeGroupName, state);
                const stats = {
                    sumOfColumn: sumOfColumn,
                    rowCount: rowCount
                };
                transformedData = (0, $94cVo.transformData)(data?.results, stats, columnToRankBy, isCoverageSearch).map((office)=>({
                        ...office,
                        listingTypeId: listingTypeId,
                        listingViewId: listingViewId
                    }));
            }
            if (error) {
                console.log("Office Breakdown error: ", error);
                return;
            }
            Promise.resolve(data).then(()=>(0, $ivaD7.setStateData)("isLoading", false, setState));
            setState((prevState)=>({
                    ...prevState,
                    columnDefs: columnDefs,
                    offices: transformedData,
                    totalsAverages: data?.totals
                }));
        };
        const detailError = (e)=>console.log(e);
        loadOfficesListings().catch(detailError);
    }, [
        state.searchCriteria
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!shouldRender) return;
        if (!listingViewId || !gridRef.current?.columnApi) return;
        const sortedColumn = gridRef.current.columnApi.api.columnModel.gridColumns.find((colDef)=>colDef.sort);
        const defaultColumnDefs = isCoverageSearch ? (0, $94cVo.getSortedColumns)((0, $6c17a48110cb28c5$export$6f1182a788c243af)[listingViewId]?.settings.columns, sortedColumn?.colId, sortedColumn?.sort) : (0, $94cVo.getSortedColumns)((0, $a74a1a6b59911d8e$export$f1733b8733c67277)[listingViewId]?.settings.columns, sortedColumn?.colId, sortedColumn?.sort);
        const columnDefs = (0, $caae81a603f93a4a$export$e8e5dae2653ea5d8)(defaultColumnDefs, state.isShowAdditionalInfo);
        (0, $ivaD7.setStateData)("columnDefs", columnDefs, setState);
    }, [
        listingViewId,
        state.isShowAdditionalInfo
    ]);
    if (!shouldRender) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {});
    const handleAdditionalInfoToggleChange = ()=>(0, $ivaD7.setStateData)("isShowAdditionalInfo", !state.isShowAdditionalInfo, setState);
    const exportDetails = {
        exportType: (0, $6b56815170881da9$export$382f55aa456f5721).msOfficesBreakdown,
        listingViewId: listingViewId,
        tableName: title,
        listingStatusTitle: listingStatus
    };
    const exportButton = state.offices?.length ? (0, $0d036ea0861162a7$export$e89cb83db8826f3)({
        exportDetails: exportDetails,
        gridRef: gridRef,
        type: (0, $i95vK.exportButtonTypes).secondary
    }) : null;
    const bottomRowType = isCoverageSearch ? "coverageSearch" : "totalsSearch";
    const pinnedRowDrilldownSettingsType = (0, $c7dF9.getPinnedRowRouteSettings)(location.pathname);
    const bottomRowParams = {
        bottomRowType: bottomRowType,
        pinnedRowDrilldownSettingsType: pinnedRowDrilldownSettingsType,
        gridRef: gridRef,
        rowData: state.offices,
        pinnedRowData: state.totalsAverages
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $11925ad2fab8b02a$export$2e2bcd8739ae039), {
                title: title,
                areaType: isCoverageSearch && state.selectedAreaType,
                subtitle: (0, $3etjB.marketShareTerms).officeBreakdown,
                hasToggle: true,
                module: module,
                exportButton: exportButton,
                handleAdditionalInfoToggleChange: handleAdditionalInfoToggleChange,
                isAdditionalInfoToggleChecked: state.isShowAdditionalInfo
            }),
            state.isLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0d10d25c347bf887$export$2e2bcd8739ae039), {
                gridRef: gridRef,
                rowData: state.offices,
                columnDefs: state.columnDefs,
                getBottomRowSettings: ()=>bottomRowParams && (0, $49ccf15f739ed441$export$87bad144e6e5baa5)(bottomRowParams)
            })
        ]
    });
};
$468bbfe6e98eaf46$var$OfficesBreakdown.propTypes = {
    module: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};
var $468bbfe6e98eaf46$export$2e2bcd8739ae039 = $468bbfe6e98eaf46$var$OfficesBreakdown;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $cstaF = parcelRequire("cstaF");
parcelRequire("fHiKR");
var $1BYDb = parcelRequire("1BYDb");

var $90ISC = parcelRequire("90ISC");

var $kfZjc = parcelRequire("kfZjc");
const $40ec4f66f8138737$var$ShowAdditionalInfo = ()=>{
    const location = (0, $kfZjc.useLocation)();
    const { shouldShowAdditionalInfo: shouldShowAdditionalInfo, setToggleShouldShowAdditionalInfo: setToggleShouldShowAdditionalInfo, isFooterDisabled: isFooterDisabled } = (0, $90ISC.useSearchStore)((state)=>{
        const { [state.selectedModule]: moduleState } = state;
        const { breakdowns: breakdowns } = moduleState;
        const { selectedBreakdownTab: selectedBreakdownTab, tabsByRoute: tabsByRoute } = breakdowns;
        const breakdownTabData = tabsByRoute[location.pathname]?.[selectedBreakdownTab];
        return {
            shouldShowAdditionalInfo: breakdownTabData?.shouldShowAdditionalInfo,
            setToggleShouldShowAdditionalInfo: state.setToggleShouldShowAdditionalInfo,
            isFooterDisabled: breakdownTabData?.isFooterDisabled
        };
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "ml-auto d-flex justify-content-center align-items-center",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "mb-0 mr-2 clickable font-weight-normal font-gray-primary",
                onClick: ()=>setToggleShouldShowAdditionalInfo(location.pathname),
                children: (0, $cstaF.searchTerms).additionalInfo
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1BYDb))), {
                dataLwtId: "additional-info-toggle",
                type: "switch",
                id: "additional-info-toggle",
                onChange: ()=>setToggleShouldShowAdditionalInfo(location.pathname),
                checked: shouldShowAdditionalInfo,
                disabled: isFooterDisabled
            })
        ]
    });
};
var $40ec4f66f8138737$export$2e2bcd8739ae039 = $40ec4f66f8138737$var$ShowAdditionalInfo;




var $ivaD7 = parcelRequire("ivaD7");

var $90ISC = parcelRequire("90ISC");

var $cstaF = parcelRequire("cstaF");

var $70q5f = parcelRequire("70q5f");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $htzEo = parcelRequire("htzEo");

var $98ROn = parcelRequire("98ROn");

var $cL3O2 = parcelRequire("cL3O2");

var $1PiL9 = parcelRequire("1PiL9");

var $bLQRh = parcelRequire("bLQRh");

var $98ROn = parcelRequire("98ROn");

var $70q5f = parcelRequire("70q5f");

var $dBG6V = parcelRequire("dBG6V");

var $2t1vB = parcelRequire("2t1vB");

var $1PiL9 = parcelRequire("1PiL9");
const $5f74645e031a2bff$export$e7289dcec9cac0ab = {
    [(0, $dBG6V.soldAvgVsMedianPrice).tableSettings.id]: ()=>[
            {
                col: (0, $1PiL9.marketDynamicsColumns).timePeriodStart,
                colDef: (0, $98ROn.colSettings).quarterNumYearFormat
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).soldUnits,
                colDef: (0, $98ROn.colSettings).numberSmInteger,
                measureType: (0, $bLQRh.measureTypes).units
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).soldMedianVolume,
                colDef: (0, $98ROn.colSettings).numberSmVolume
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).soldAvgVolume,
                colDef: (0, $98ROn.colSettings).numberSmVolume
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).soldChangeVolume,
                colDef: (0, $98ROn.colSettings).numberSmVolume
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).soldGrowthVolumePct,
                colDef: (0, $98ROn.colSettings).numberSmPercentage
            },
            {
                col: (0, $1PiL9.marketDynamicsColumns).soldAvgDom,
                colDef: (0, $98ROn.colSettings).numberSmInteger
            }
        ],
    [(0, $2t1vB.supplyAmpDemandNumUnits).tableSettings.id]: ()=>{
        const selectedStatusOptionsIds = (0, $70q5f.useMarketDynamicsStore).getState()?.checkedStatusOptions.map((item)=>item.id);
        const cols = (0, $2t1vB.supplyAmpDemandNumUnits).tableSettings.tables;
        const revisedCols = [
            {
                col: (0, $1PiL9.marketDynamicsColumns).timePeriodStart
            },
            ...cols.filter((col)=>selectedStatusOptionsIds.includes(col?.statusId))
        ];
        return revisedCols;
    }
};
const $5f74645e031a2bff$export$92177893f0ee7c87 = [
    {
        col: (0, $1PiL9.marketDynamicsColumns).officeId,
        colDef: (0, $98ROn.colSettings).textMd
    },
    {
        col: (0, $1PiL9.marketDynamicsColumns).streetName,
        colDef: (0, $98ROn.colSettings).textLg
    },
    {
        col: (0, $1PiL9.marketDynamicsColumns).city,
        colDef: (0, $98ROn.colSettings).textMd
    },
    {
        col: (0, $1PiL9.marketDynamicsColumns).zipCode,
        colDef: (0, $98ROn.colSettings).textSm
    }
];



var $cstaF = parcelRequire("cstaF");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4fGPb = parcelRequire("4fGPb");

var $c7dF9 = parcelRequire("c7dF9");

var $c9Z8w = parcelRequire("c9Z8w");

var $90ISC = parcelRequire("90ISC");
const $d08592c71a716c27$export$d09442a82887660a = (props)=>{
    const { data: data, value: value } = props;
    const { setSelectedBreakdownOffice: setSelectedBreakdownOffice } = (0, $90ISC.useSearchStore)((state)=>({
            setSelectedBreakdownOffice: state.setSelectedBreakdownOffice
        }));
    const handleClick = ()=>{
        setSelectedBreakdownOffice({
            officeId: data.officeId,
            name: value
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fGPb.Link), {
        to: {
            pathname: `${(0, $c7dF9.Routes).MARKET_DYNAMICS.BASE}${(0, $c7dF9.Routes).MARKET_DYNAMICS.OFFICE_LISTING}`
        },
        onClick: handleClick,
        children: props.value
    });
};
$d08592c71a716c27$export$d09442a82887660a.propTypes = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};


const $c65a2deda8c5a6cc$export$4328921da4f8a2eb = ({ tableView: tableView, periodColumnSettings: periodColumnSettings, marketDynamicsTooltips: marketDynamicsTooltips })=>{
    if (!periodColumnSettings || !tableView) return;
    let tooltipSettings;
    tableView?.tables.forEach((column)=>{
        if (column.col.id === periodColumnSettings.keyField) {
            const currentTimePeriodTooltipSettings = {
                ...marketDynamicsTooltips.timePeriodStart,
                label: periodColumnSettings.label
            };
            tooltipSettings = {
                ...marketDynamicsTooltips,
                timePeriodStart: currentTimePeriodTooltipSettings
            };
        }
    });
    return tooltipSettings;
};
const $c65a2deda8c5a6cc$var$getBreakoutStatusOptions = (statusOptions)=>{
    if (!statusOptions || statusOptions.length < 2) return statusOptions;
    const firstStatusOption = statusOptions[0];
    const breakoutOptions = statusOptions.slice(1).map((element)=>firstStatusOption + element);
    return [
        firstStatusOption,
        ...breakoutOptions
    ];
};
const $c65a2deda8c5a6cc$export$c57c272c3cdaa333 = (tableView, periodColumnSettings, selectedStatusOptionsIds)=>{
    if (!tableView || !periodColumnSettings) return;
    const colDefs = tableView?.tables.map((col)=>{
        if (col.col.id === (0, $1PiL9.marketDynamicsColumns).timePeriodStart.id) return {
            ...col,
            colDef: periodColumnSettings
        };
        return col;
    });
    const revisedColDefs = colDefs.filter((col)=>{
        if (!col?.statusId) return true; //This can be removed after implemented status options in other tables
        if (tableView.isBreakout) return $c65a2deda8c5a6cc$var$getBreakoutStatusOptions(selectedStatusOptionsIds).includes(col.statusId);
        return selectedStatusOptionsIds.includes(col.statusId);
    });
    return {
        ...tableView,
        tables: revisedColDefs
    };
};
const $c65a2deda8c5a6cc$export$c0be58b3faa55bd7 = (tableView)=>{
    if (!tableView) return;
    const colsByListing = (0, $5f74645e031a2bff$export$e7289dcec9cac0ab)?.[tableView.id] && (0, $5f74645e031a2bff$export$e7289dcec9cac0ab)[tableView.id]();
    const editedTableView = colsByListing ? {
        ...tableView,
        tables: colsByListing
    } : tableView;
    return editedTableView?.tables.map((col)=>{
        if (col.col.id === (0, $1PiL9.marketDynamicsColumns).timePeriodStart.id) return {
            col: (0, $1PiL9.marketDynamicsColumns).officeName,
            colDef: (0, $98ROn.colSettings).textLg,
            cellRenderer: (props)=>props.value !== (0, $cstaF.searchTerms).totals ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d08592c71a716c27$export$d09442a82887660a), {
                    ...props
                }) : props.value
        };
        const defaultColSettings = Object.entries((0, $cL3O2.listingViews)).map((view)=>view[1].tableSettings.tables).flat().find((column)=>column?.col?.id === col?.col?.id);
        const valueFormatter = (v)=>(0, $htzEo.getBlankZeroFormatter)(v.value, defaultColSettings?.colDef?.valueFormatter);
        return {
            ...col,
            colDef: {
                ...defaultColSettings?.colDef,
                valueFormatter: valueFormatter
            }
        };
    });
};
const $c65a2deda8c5a6cc$export$c9c421565309e76 = (columns)=>{
    const firstUnitColumn = columns.find((col)=>col?.measureType === "units");
    return {
        colId: firstUnitColumn?.col.id,
        sortDir: "desc",
        isBreakdown: true
    };
};
const $c65a2deda8c5a6cc$export$9768df2d4aa507e5 = (arrayOfObjects, columns)=>{
    if (!arrayOfObjects || !columns) return [];
    const columnsToFilter = (0, $5f74645e031a2bff$export$92177893f0ee7c87).map((item)=>item.col.id);
    const filteredColumns = columns.filter((col)=>!columnsToFilter.includes(col.col.id)).slice(1);
    const dataKeys = filteredColumns.map((col)=>col.col.id);
    return arrayOfObjects.filter((object)=>dataKeys.some((dataKey)=>object?.[dataKey] > 0));
};
const $c65a2deda8c5a6cc$export$2378d1fc357dcc13 = (cols)=>{
    const officeIdCol = (0, $5f74645e031a2bff$export$92177893f0ee7c87).slice(0, 1);
    const officeNameCol = cols.slice(0, 1);
    const restAdditionalCols = (0, $5f74645e031a2bff$export$92177893f0ee7c87).slice(1);
    const restCols = cols.slice(1);
    return [
        ...officeIdCol,
        ...officeNameCol,
        ...restAdditionalCols,
        ...restCols
    ];
};
const $c65a2deda8c5a6cc$export$2aef2fd44cda702c = (tableViewId, columns, defaultSortColId)=>{
    return {
        id: tableViewId,
        showPagination: false,
        defaultSort: {
            colId: defaultSortColId,
            sortDir: "desc"
        },
        tables: columns
    };
};



var $iCDWi = parcelRequire("iCDWi");

var $htzEo = parcelRequire("htzEo");

var $eNmV5 = parcelRequire("eNmV5");

var $jilhO = parcelRequire("jilhO");

var $i1BZc = parcelRequire("i1BZc");

var $kfZjc = parcelRequire("kfZjc");

var $g7mFm = parcelRequire("g7mFm");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $kfZjc = parcelRequire("kfZjc");

var $c9Z8w = parcelRequire("c9Z8w");


var $ikyhZ = parcelRequire("ikyhZ");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $jLmfc = parcelRequire("jLmfc");

var $98ROn = parcelRequire("98ROn");

var $1PiL9 = parcelRequire("1PiL9");

var $cstaF = parcelRequire("cstaF");
const $8d1c34270d836835$export$2b6717690ea0c7f2 = [
    {
        col: (0, $1PiL9.marketDynamicsColumns).mlsNum,
        colDef: (0, $98ROn.colSettings).textSmall
    },
    {
        col: (0, $1PiL9.marketDynamicsColumns).typeName,
        colDef: (0, $98ROn.colSettings).textSmall
    },
    {
        col: (0, $1PiL9.marketDynamicsColumns).address,
        colDef: (0, $98ROn.colSettings).textMd,
        cellRenderer: (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $jLmfc.AddressLink), {
                ...props,
                pathname: `${(0, $cstaF.drillDownRoutesByModule)[(0, $cstaF.moduleNames).marketDynamics].listingInfo}`
            })
    },
    {
        col: (0, $1PiL9.marketDynamicsColumns).city,
        colDef: (0, $98ROn.colSettings).textMd
    },
    {
        col: (0, $1PiL9.marketDynamicsColumns).zipcode,
        colDef: (0, $98ROn.colSettings).textSmall
    },
    {
        col: (0, $1PiL9.marketDynamicsColumns).areaId,
        colDef: (0, $98ROn.colSettings).textSmall
    },
    {
        col: (0, $1PiL9.marketDynamicsColumns).orgPrice,
        colDef: (0, $98ROn.colSettings).numberSmVolume
    }
];
const $8d1c34270d836835$export$c3f397b0633f5a53 = (shouldShowAdditionalInfoCols)=>[
        {
            col: (0, $1PiL9.marketDynamicsColumns).dom,
            colDef: (0, $98ROn.colSettings).blankEmptyXsInteger
        },
        {
            col: (0, $1PiL9.marketDynamicsColumns).cdom,
            colDef: (0, $98ROn.colSettings).blankEmptyXsInteger
        },
        {
            col: (0, $1PiL9.marketDynamicsColumns).bankStatus,
            colDef: (0, $98ROn.colSettings).bankStatus
        },
        ...shouldShowAdditionalInfoCols ? $8d1c34270d836835$export$9547de440e4af05a : [],
        {
            col: (0, $1PiL9.marketDynamicsColumns).listAgent,
            colDef: (0, $98ROn.colSettings).textMd
        }
    ];
const $8d1c34270d836835$export$9547de440e4af05a = [
    {
        col: (0, $1PiL9.marketDynamicsColumns).priceChangeCnt,
        colDef: (0, $98ROn.colSettings).numberLgInteger
    },
    {
        col: (0, $1PiL9.marketDynamicsColumns).bedrooms,
        colDef: (0, $98ROn.colSettings).numberXsInteger
    },
    {
        col: (0, $1PiL9.marketDynamicsColumns).fullBaths,
        colDef: (0, $98ROn.colSettings).numberXsInteger
    },
    {
        col: (0, $1PiL9.marketDynamicsColumns).squareFt,
        colDef: (0, $98ROn.colSettings).numberXsInteger
    },
    {
        col: (0, $1PiL9.marketDynamicsColumns).costPerSqft,
        colDef: (0, $98ROn.colSettings).numberXsVolume
    },
    {
        col: (0, $1PiL9.marketDynamicsColumns).lotSizeSquareFt,
        colDef: (0, $98ROn.colSettings).numberSmInteger
    },
    {
        col: (0, $1PiL9.marketDynamicsColumns).yearBuilt,
        colDef: (0, $98ROn.colSettings).numberSmRightAlign
    }
];



var $98ROn = parcelRequire("98ROn");

var $1PiL9 = parcelRequire("1PiL9");
const $d201591081e6bd18$export$f4f31b7b4f82d462 = (shouldShowAdditionalInfoCols)=>[
        ...(0, $8d1c34270d836835$export$2b6717690ea0c7f2),
        {
            col: (0, $1PiL9.marketDynamicsColumns).price,
            colDef: (0, $98ROn.colSettings).numberSmVolume
        },
        {
            col: (0, $1PiL9.marketDynamicsColumns).offMarketDate,
            colDef: (0, $98ROn.colSettings).dateMd
        },
        ...(0, $8d1c34270d836835$export$c3f397b0633f5a53)(shouldShowAdditionalInfoCols)
    ];




var $98ROn = parcelRequire("98ROn");

var $1PiL9 = parcelRequire("1PiL9");
const $8e091fd118609831$export$e2223ef9b8024248 = (shouldShowAdditionalInfoCols)=>[
        ...(0, $8d1c34270d836835$export$2b6717690ea0c7f2),
        {
            col: (0, $1PiL9.marketDynamicsColumns).price,
            colDef: (0, $98ROn.colSettings).numberMdVolume
        },
        {
            col: (0, $1PiL9.marketDynamicsColumns).listDate,
            colDef: (0, $98ROn.colSettings).dateSm
        },
        ...(0, $8d1c34270d836835$export$c3f397b0633f5a53)(shouldShowAdditionalInfoCols)
    ];




var $98ROn = parcelRequire("98ROn");

var $1PiL9 = parcelRequire("1PiL9");
const $946bafdb65ae56f6$export$9abafbf64825efb6 = (shouldShowAdditionalInfoCols)=>[
        ...(0, $8d1c34270d836835$export$2b6717690ea0c7f2),
        {
            col: (0, $1PiL9.marketDynamicsColumns).listPrice,
            colDef: (0, $98ROn.colSettings).numberMdVolume
        },
        {
            col: (0, $1PiL9.marketDynamicsColumns).soldPrice,
            colDef: (0, $98ROn.colSettings).numberMdVolume
        },
        {
            col: (0, $1PiL9.marketDynamicsColumns).soldDate,
            colDef: (0, $98ROn.colSettings).dateSm
        },
        ...(0, $8d1c34270d836835$export$c3f397b0633f5a53)(shouldShowAdditionalInfoCols)
    ];




var $98ROn = parcelRequire("98ROn");

var $1PiL9 = parcelRequire("1PiL9");
const $181b00448f95efe9$export$23a2f1c66966a68b = (shouldShowAdditionalInfoCols)=>[
        ...(0, $8d1c34270d836835$export$2b6717690ea0c7f2),
        {
            col: (0, $1PiL9.marketDynamicsColumns).price,
            colDef: (0, $98ROn.colSettings).numberMdVolume
        },
        {
            col: (0, $1PiL9.marketDynamicsColumns).ucDate,
            colDef: (0, $98ROn.colSettings).dateSm
        },
        ...(0, $8d1c34270d836835$export$c3f397b0633f5a53)(shouldShowAdditionalInfoCols)
    ];



var $1PiL9 = parcelRequire("1PiL9");
const $84f4c3bfb65379d9$export$ac3a45f371207d91 = (shouldShowAdditionalInfo)=>({
        [(0, $ikyhZ.listingStatuses).newListings.id]: (0, $c65a2deda8c5a6cc$export$2aef2fd44cda702c)((0, $ikyhZ.listingStatuses).newListings.id, (0, $8e091fd118609831$export$e2223ef9b8024248)(shouldShowAdditionalInfo), (0, $1PiL9.marketDynamicsColumns).listDate.id),
        [(0, $ikyhZ.listingStatuses).forSale.id]: (0, $c65a2deda8c5a6cc$export$2aef2fd44cda702c)((0, $ikyhZ.listingStatuses).forSale.id, (0, $8e091fd118609831$export$e2223ef9b8024248)(shouldShowAdditionalInfo), (0, $1PiL9.marketDynamicsColumns).listDate.id),
        [(0, $ikyhZ.listingStatuses).underContract.id]: (0, $c65a2deda8c5a6cc$export$2aef2fd44cda702c)((0, $ikyhZ.listingStatuses).underContract.id, (0, $181b00448f95efe9$export$23a2f1c66966a68b)(shouldShowAdditionalInfo), (0, $1PiL9.marketDynamicsColumns).ucDate.id),
        [(0, $ikyhZ.listingStatuses).sold.id]: (0, $c65a2deda8c5a6cc$export$2aef2fd44cda702c)((0, $ikyhZ.listingStatuses).sold.id, (0, $946bafdb65ae56f6$export$9abafbf64825efb6)(shouldShowAdditionalInfo), (0, $1PiL9.marketDynamicsColumns).soldDate.id),
        [(0, $ikyhZ.listingStatuses).expired.id]: (0, $c65a2deda8c5a6cc$export$2aef2fd44cda702c)((0, $ikyhZ.listingStatuses).expired.id, (0, $d201591081e6bd18$export$f4f31b7b4f82d462)(shouldShowAdditionalInfo), (0, $1PiL9.marketDynamicsColumns).offMarketDate.id),
        [(0, $ikyhZ.listingStatuses).forSaleLdm.id]: (0, $c65a2deda8c5a6cc$export$2aef2fd44cda702c)((0, $ikyhZ.listingStatuses).forSaleLdm.id, (0, $8e091fd118609831$export$e2223ef9b8024248)(shouldShowAdditionalInfo), (0, $1PiL9.marketDynamicsColumns).listDate.id)
    });



var $70q5f = parcelRequire("70q5f");

var $ikyhZ = parcelRequire("ikyhZ");
const $10162eb265822cae$export$c3f5b6d58767b7ff = {
    [(0, $ikyhZ.listingStatuses).sold.id]: "SoldListSide",
    [(0, $ikyhZ.listingStatuses).forSale.id]: "ForSale",
    [(0, $ikyhZ.listingStatuses).newListings.id]: "New",
    [(0, $ikyhZ.listingStatuses).underContract.id]: "UnderContract",
    [(0, $ikyhZ.listingStatuses).expired.id]: "Expired",
    [(0, $ikyhZ.listingStatuses).forSaleLdm.id]: "ForSaleLastDay"
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $l05Px = parcelRequire("l05Px");

var $7tOHe = parcelRequire("7tOHe");
const $1d43e0e734212be6$export$1c6dac8fe8da9e14 = (props)=>{
    const { tableView: tableView, rowData: rowData, tableTitleWithTooltips: tableTitleWithTooltips, pinnedBottomRowData: pinnedBottomRowData, externalParams: externalParams, gridRef: gridRef, isLoading: isLoading } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "bg-white mb-3 raised-border mt-12",
        children: !isLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l05Px.default), {
            gridRef: gridRef,
            tableView: tableView,
            rowData: rowData,
            tableTitleWithTooltips: tableTitleWithTooltips,
            pinnedBottomRowData: pinnedBottomRowData,
            externalParams: externalParams,
            isTableAutoHeight: false
        }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "py-3 office-breakdown-wrapper d-flex justify-content-center",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {})
        })
    });
};
$1d43e0e734212be6$export$1c6dac8fe8da9e14.propTypes = {
    externalParams: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    pinnedBottomRowData: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    rowData: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    tableTitleWithTooltips: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object.isRequired,
    tableView: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    gridRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired
};



var $90ISC = parcelRequire("90ISC");
const $48aadad13f979dd6$var$ListingsBreakdownTable = ({ listingStatus: listingStatus, tableTitleWithTooltips: tableTitleWithTooltips, searchCriteria: searchCriteria, gridRef: gridRef, tabIndex: tabIndex, isOfficeListing: isOfficeListing })=>{
    const location = (0, $kfZjc.useLocation)();
    const { getListingsBreakdown: getListingsBreakdown, selectedBreakdownPeriod: selectedBreakdownPeriod } = (0, $70q5f.useMarketDynamicsStore)((state)=>({
            getListingsBreakdown: state.getListingsBreakdown,
            selectedBreakdownPeriod: state.selectedBreakdownPeriod
        }));
    const { shouldShowAdditionalInfo: shouldShowAdditionalInfo, setIsFooterDisabled: setIsFooterDisabled, setTabListingStatus: setTabListingStatus, selectedBreakdownOffice: selectedBreakdownOffice } = (0, $90ISC.useSearchStore)((state)=>{
        const { [state.selectedModule]: moduleState } = state;
        const { breakdowns: breakdowns } = moduleState;
        const { selectedBreakdownTab: selectedBreakdownTab, tabsByRoute: tabsByRoute, selectedBreakdownOffice: selectedBreakdownOffice } = breakdowns;
        const breakdownTabData = tabsByRoute[location.pathname]?.[selectedBreakdownTab];
        return {
            shouldShowAdditionalInfo: breakdownTabData?.shouldShowAdditionalInfo,
            setIsFooterDisabled: state.setIsFooterDisabled,
            setTabListingStatus: state.setTabListingStatus,
            selectedBreakdownOffice: selectedBreakdownOffice
        };
    });
    const [state, setState] = (0, $acw62.useState)({
        listings: [],
        isLoading: true
    });
    const tableView = (0, $84f4c3bfb65379d9$export$ac3a45f371207d91)(shouldShowAdditionalInfo)[listingStatus.id];
    const getTabIndex = ()=>isOfficeListing ? tabIndex - 1 : tabIndex;
    (0, $acw62.useEffect)(()=>{
        if (!searchCriteria || !selectedBreakdownPeriod) return;
        setState((state)=>({
                ...state,
                listings: [],
                isLoading: true
            }));
        const getListings = async ()=>{
            setIsFooterDisabled(getTabIndex(), true, location.pathname);
            setTabListingStatus(getTabIndex(), listingStatus, location.pathname);
            const listings = await getListingsBreakdown(searchCriteria, (0, $10162eb265822cae$export$c3f5b6d58767b7ff)[listingStatus.id], isOfficeListing, selectedBreakdownOffice?.officeId);
            setState((state)=>({
                    ...state,
                    listings: listings,
                    isLoading: false
                }));
        };
        getListings();
    }, [
        searchCriteria,
        selectedBreakdownPeriod,
        listingStatus.id,
        isOfficeListing,
        selectedBreakdownOffice
    ]);
    (0, $acw62.useEffect)(()=>{
        setIsFooterDisabled(getTabIndex(), state.isLoading, location.pathname);
    }, [
        state.isLoading,
        location.pathname
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1d43e0e734212be6$export$1c6dac8fe8da9e14), {
        gridRef: gridRef,
        rowData: state.listings,
        tableTitleWithTooltips: tableTitleWithTooltips,
        tableView: tableView,
        isLoading: state.isLoading
    });
};
var $48aadad13f979dd6$export$2e2bcd8739ae039 = $48aadad13f979dd6$var$ListingsBreakdownTable;
$48aadad13f979dd6$var$ListingsBreakdownTable.propTypes = {
    listingStatus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    tableTitleWithTooltips: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    searchCriteria: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    gridRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    tabIndex: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    isOfficeListing: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};



var $cL3O2 = parcelRequire("cL3O2");

var $42prG = parcelRequire("42prG");



var $i95vK = parcelRequire("i95vK");


var $gzAOa = parcelRequire("gzAOa");
const $16f0cc997409f2ba$var$Breakdowns = ()=>{
    const gridRefs = (0, $acw62.useRef)([]);
    const location = (0, $kfZjc.useLocation)();
    const { searchCriteria: searchCriteria, timeFrameTitle: timeFrameTitle, summaryPinnedData: summaryPinnedData, setTotalsRowData: setTotalsRowData, setSummaryPinnedData: setSummaryPinnedData, selectedBreakdownTab: selectedBreakdownTab, setSelectedBreakdownTab: setSelectedBreakdownTab, shouldShowAdditionalInfo: shouldShowAdditionalInfo, isFooterDisabled: isFooterDisabled, setIsFooterDisabled: setIsFooterDisabled, resetDisabledFooterTabs: resetDisabledFooterTabs, listingStatusLabel: listingStatusLabel } = (0, $90ISC.useSearchStore)((state)=>{
        const { [state.selectedModule]: moduleState } = state;
        const { breakdowns: breakdowns } = moduleState;
        const { selectedBreakdownTab: selectedBreakdownTab, tabsByRoute: tabsByRoute } = breakdowns;
        const breakdownTabData = tabsByRoute[location.pathname]?.[selectedBreakdownTab];
        return {
            searchCriteria: moduleState?.search?.searchCriteria,
            timeFrameTitle: moduleState?.timeFrameTitle,
            summaryPinnedData: moduleState?.summaryPinnedData,
            setTotalsRowData: state.setTotalsRowData,
            setSummaryPinnedData: state.setSummaryPinnedData,
            selectedBreakdownTab: selectedBreakdownTab,
            setSelectedBreakdownTab: state.setSelectedBreakdownTab,
            shouldShowAdditionalInfo: breakdownTabData?.shouldShowAdditionalInfo,
            isFooterDisabled: breakdownTabData?.isFooterDisabled,
            setIsFooterDisabled: state.setIsFooterDisabled,
            resetDisabledFooterTabs: state.resetDisabledFooterTabs,
            listingStatusLabel: breakdownTabData?.listingStatus?.label
        };
    });
    const { checkedStatusOptions: checkedStatusOptions, getOfficesBreakdown: getOfficesBreakdown, selectedBreakdownPeriod: selectedBreakdownPeriod, tableView: tableView, selectedListingView: selectedListingView } = (0, $70q5f.useMarketDynamicsStore)((state)=>({
            checkedStatusOptions: state.checkedStatusOptions,
            getOfficesBreakdown: state.getOfficesBreakdown,
            selectedBreakdownPeriod: state.selectedBreakdownPeriod,
            tableView: state.tableView,
            selectedListingView: state.selectedListingView,
            selectedBreakdownTab: state.selectedBreakdownTab
        }));
    const [state, setState] = (0, $acw62.useState)({
        breakdownTooltips: {},
        offices: [],
        revisedSearchCriteria: null,
        isLoading: true
    });
    const history = (0, $kfZjc.useHistory)();
    const isOfficeListing = location.pathname === (0, $g7mFm.officeListingsRoute);
    const revisedTableView = (0, $acw62.useMemo)(()=>{
        const revisedColumnDefs = (0, $c65a2deda8c5a6cc$export$c0be58b3faa55bd7)(tableView);
        const additionalColumnsColDefs = shouldShowAdditionalInfo ? (0, $c65a2deda8c5a6cc$export$2378d1fc357dcc13)(revisedColumnDefs) : revisedColumnDefs;
        return {
            ...tableView,
            tables: additionalColumnsColDefs,
            defaultSort: (0, $c65a2deda8c5a6cc$export$c9c421565309e76)(revisedColumnDefs, tableView.id)
        };
    }, [
        tableView,
        state.offices,
        shouldShowAdditionalInfo
    ]);
    const revisedOfficesData = (0, $acw62.useMemo)(()=>{
        if (!revisedTableView || !state.offices?.results) return [];
        return (0, $c65a2deda8c5a6cc$export$9768df2d4aa507e5)((0, $42prG.getTransformData)(state.offices?.results), revisedTableView.tables);
    }, [
        state.offices,
        revisedTableView
    ]);
    const summaryPinnedConfig = (0, $jilhO.getSummaryPinnedConfig)(tableView.id);
    const isOfficeBreakdownTab = !isOfficeListing && selectedBreakdownTab === (0, $gzAOa.breakdownTabs).OFFICE;
    const exportDetails = {
        exportType: isOfficeBreakdownTab ? (0, $7eeaa9977bfe14b6$export$382f55aa456f5721).mdOfficeBreakdown : (0, $7eeaa9977bfe14b6$export$382f55aa456f5721).mdListingsBreakdown,
        listingType: selectedListingView,
        listingStatus: !isOfficeBreakdownTab ? listingStatusLabel : ""
    };
    const exportButton = (0, $0d036ea0861162a7$export$e89cb83db8826f3)({
        exportDetails: exportDetails,
        gridRef: gridRefs.current[isOfficeListing ? selectedBreakdownTab + 1 : selectedBreakdownTab],
        type: (0, $i95vK.exportButtonTypes).primary,
        isDisabled: isFooterDisabled,
        isTabExport: true
    });
    const columnProps = [
        {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "ml-auto d-flex w-auto align-self-center",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $40ec4f66f8138737$export$2e2bcd8739ae039), {}),
                    exportButton
                ]
            }),
            sm: 12,
            align: "right"
        }
    ];
    const setCurrentTab = (currentTab)=>{
        if (!isOfficeListing) history.push((0, $g7mFm.getBreakdownRoute)(currentTab));
        setSelectedBreakdownTab(currentTab);
    };
    const listingStatusTabs = (0, $cL3O2.listingBreakdownViewsIds).includes(tableView?.id) ? checkedStatusOptions.map((status, index)=>({
            title: `${(0, $cstaF.agentProductionTerms).listings} (${status.label})`,
            content: {
                jsx: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $48aadad13f979dd6$export$2e2bcd8739ae039), {
                    gridRef: (ref)=>gridRefs.current[index + 1] = ref,
                    tabIndex: index + 1,
                    listingStatus: status,
                    tableTitleWithTooltips: state.breakdownTooltips,
                    searchCriteria: state.revisedSearchCriteria,
                    isOfficeListing: isOfficeListing
                })
            }
        })) : (0, $cL3O2.getListingTabsByStatus)({
        selectedListingViewId: tableView?.id,
        tableTitleWithTooltips: state.breakdownTooltips,
        searchCriteria: state.revisedSearchCriteria,
        component: (0, $48aadad13f979dd6$export$2e2bcd8739ae039),
        checkedStatusOptions: checkedStatusOptions,
        gridRefs: gridRefs,
        isOfficeListing: isOfficeListing
    });
    (0, $acw62.useEffect)(()=>{
        if (!searchCriteria || !selectedBreakdownPeriod) return;
        const timePeriodParameter = {
            intervalType: "Custom",
            startDate: (0, $htzEo.yearMonthDayDashDateFormat)(selectedBreakdownPeriod.timePeriodStart),
            endDate: (0, $htzEo.yearMonthDayDashDateFormat)(selectedBreakdownPeriod.timePeriodEnd)
        };
        const revisedSearchCriteria = (0, $iCDWi.getUpdatedObjectByKeyfield)(searchCriteria, "timePeriod", timePeriodParameter);
        const getOffices = async ()=>{
            resetDisabledFooterTabs(location.pathname);
            const offices = await getOfficesBreakdown(revisedSearchCriteria);
            setTotalsRowData((0, $42prG.getTransformData)(offices?.totals), (0, $i1BZc.responseKeys).totals);
            setSummaryPinnedData(tableView.id, (0, $i1BZc.responseKeys).totals);
            setState((state)=>({
                    ...state,
                    offices: offices,
                    revisedSearchCriteria: revisedSearchCriteria,
                    isLoading: false
                }));
        };
        getOffices();
    }, [
        searchCriteria,
        selectedBreakdownPeriod
    ]);
    (0, $acw62.useEffect)(()=>{
        setIsFooterDisabled((0, $gzAOa.breakdownTabs).OFFICE, state.isLoading, location.pathname);
    }, [
        state.isLoading,
        isOfficeListing,
        location.pathname
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!timeFrameTitle) return;
        const breakdownTooltips = (0, $eNmV5.getBreakdownTooltips)(timeFrameTitle.mainTitle, tableView.id);
        (0, $ivaD7.setStateData)("breakdownTooltips", breakdownTooltips, setState);
    }, [
        timeFrameTitle
    ]);
    const officeBreakdownProps = {
        gridRef: (ref)=>gridRefs.current[(0, $gzAOa.breakdownTabs).OFFICE] = ref,
        tableView: revisedTableView,
        rowData: revisedOfficesData,
        tableTitleWithTooltips: state.breakdownTooltips,
        pinnedBottomRowData: summaryPinnedConfig && [
            {
                ...summaryPinnedData
            }
        ],
        externalParams: {
            summaryPinnedConfig: summaryPinnedConfig
        },
        isLoading: state.isLoading
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "px-3 office-breakdown-wrapper",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                className: "title-row text-truncate mb-0 font-gray-primary font-weight-600",
                children: selectedListingView
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8f390b0d641c1be9$export$2e2bcd8739ae039), {
                className: "mt-4 mb-4",
                tabTextTransform: "none",
                navSize: checkedStatusOptions.length,
                contentSize: checkedStatusOptions.length,
                items: isOfficeListing ? [
                    ...listingStatusTabs
                ] : [
                    {
                        title: (0, $cstaF.searchTerms).offices,
                        content: {
                            jsx: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1d43e0e734212be6$export$1c6dac8fe8da9e14), {
                                ...officeBreakdownProps
                            })
                        }
                    },
                    ...listingStatusTabs
                ],
                tabs: true,
                currentIndex: selectedBreakdownTab,
                setCurrentIndex: (index)=>setCurrentTab(index)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $859b3aeec7a854d9$export$2e2bcd8739ae039), {
                columnProps: columnProps
            })
        ]
    });
};
var $16f0cc997409f2ba$export$2e2bcd8739ae039 = $16f0cc997409f2ba$var$Breakdowns;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $kfZjc = parcelRequire("kfZjc");
parcelRequire("3PprX");
var $90ODN = parcelRequire("90ODN");
parcelRequire("3lOdM");
var $e155p = parcelRequire("e155p");

var $7tOHe = parcelRequire("7tOHe");

var $94cVo = parcelRequire("94cVo");

var $ivaD7 = parcelRequire("ivaD7");

var $ekOct = parcelRequire("ekOct");

var $cstaF = parcelRequire("cstaF");

var $bq4QZ = parcelRequire("bq4QZ");




var $90ISC = parcelRequire("90ISC");

var $24YIE = parcelRequire("24YIE");
const $38d5efb10347c946$var$ListingInformation = ({ module: module })=>{
    const history = (0, $kfZjc.useHistory)();
    let query = (0, $bq4QZ.useQuery)();
    const { loadedSearchCriteria: loadedSearchCriteria } = (0, $90ISC.useSearchStore)((state)=>({
            loadedSearchCriteria: state[module]?.loadedSearchCriteria
        }));
    const { mlsProviders: mlsProviders } = (0, $90ISC.useCommonStore)();
    const [state, setState] = (0, $acw62.useState)({
        listingDetailData: null,
        listingHistoryData: null,
        listingView: (0, $cstaF.agentProductionTerms).propertyInformation,
        listingViews: [
            (0, $cstaF.agentProductionTerms).propertyInformation,
            (0, $cstaF.agentProductionTerms).pricingHistory
        ],
        mlsId: null,
        mlsName: undefined,
        mlsNum: query.get("mlsNum")
    });
    const title = (0, $94cVo.useURIDecoder)("address");
    const listingViewOptions = state.listingViews?.map((option)=>{
        return {
            dataLwtId: option,
            itemText: option,
            key: option,
            onClick: ()=>{
                (0, $ivaD7.setStateData)("listingView", option, setState);
            }
        };
    });
    const redirectToHome = ()=>{
        window.location.href = (0, $ekOct.getFirstToolRoute)();
    };
    const shouldRender = !!module;
    (0, $acw62.useEffect)(()=>{
        if (!shouldRender) return;
        if (!state.mlsNum || !state.mlsId) return;
        const loadDetailData = async ()=>{
            let error = null;
            const response = await (0, $24YIE.getListingDetailRequest)(state.mlsNum, state.mlsId);
            if (!response) {
                redirectToHome();
                return;
            }
            if (response.error) {
                console.error("Listing Information error:", error);
                redirectToHome();
                return;
            }
            (0, $ivaD7.setStateData)("listingDetailData", response, setState);
        };
        const detailError = (e)=>console.log(e);
        loadDetailData().catch(detailError);
        const loadHistoryData = async ()=>{
            let error = null;
            const response = await (0, $24YIE.getListingHistoryRequest)(state.mlsNum, state.mlsId);
            if (!response) {
                redirectToHome();
                return;
            }
            if (response.error) {
                console.error("Listing Information error:", error);
                redirectToHome();
                return;
            }
            (0, $ivaD7.setStateData)("listingHistoryData", response, setState);
        };
        const historyError = (error)=>console.log(error);
        loadHistoryData().catch(historyError);
    }, [
        state.mlsId,
        state.mlsNum
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!shouldRender) history.push("/");
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!loadedSearchCriteria?.realEstateDatasourceIdsWithFilters?.length) return;
        (0, $ivaD7.setStateData)("mlsId", loadedSearchCriteria.realEstateDatasourceIdsWithFilters[0].realEstateDatasourceId, setState);
    }, [
        loadedSearchCriteria
    ]);
    (0, $acw62.useEffect)(()=>{
        const mlsName = mlsProviders?.find((mls)=>mls?.mlsId === state.mlsId)?.shortDescription;
        (0, $ivaD7.setStateData)("mlsName", mlsName, setState);
    }, [
        mlsProviders,
        state.mlsId
    ]);
    if (!shouldRender) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {});
    let subtitle = state.listingView;
    if (state.listingDetailData) {
        const ldd = state.listingDetailData;
        subtitle = `${ldd?.address} ${ldd?.city}, ${ldd?.state} ${ldd?.zipCode} ${ldd?.county}`;
    }
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($e155p))), {
                className: "mr-0 m-1 mb-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $11925ad2fab8b02a$export$2e2bcd8739ae039), {
                        title: title,
                        subtitle: subtitle
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "ml-auto d-flex w-auto align-self-center",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($90ODN))), {
                            className: "listing-options",
                            dataLwtId: "listingViewOptions",
                            toggleProps: {
                                dataLwtId: "no-split-toggle",
                                id: "caret",
                                caret: true,
                                children: state.listingView
                            },
                            items: listingViewOptions,
                            menuProps: {
                                dataLwtId: "share-menu",
                                right: true
                            }
                        })
                    })
                ]
            }),
            state.listingDetailData && state.listingHistoryData ? state.listingView === (0, $cstaF.agentProductionTerms).propertyInformation ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $06a5872b702ded2f$export$2e2bcd8739ae039), {
                data: state.listingDetailData,
                module: module,
                mlsName: state.mlsName
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dcaf3ebd1524c1f3$export$2e2bcd8739ae039), {
                data: state.listingHistoryData
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e155p))), {
                className: "align-items-center justify-content-center mr-0 m-1 pt-5",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {})
            })
        ]
    });
};
$38d5efb10347c946$var$ListingInformation.propTypes = {
    module: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};
var $38d5efb10347c946$export$2e2bcd8739ae039 = $38d5efb10347c946$var$ListingInformation;




var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $kfZjc = parcelRequire("kfZjc");

var $7tOHe = parcelRequire("7tOHe");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $cstaF = parcelRequire("cstaF");

var $90ISC = parcelRequire("90ISC");
const $1ddd30bd02785e34$var$TitleRow = (props)=>{
    const { exportButton: exportButton, statusOptionsSelector: statusOptionsSelector, listingViewOptions: listingViewOptions, chartToggle: chartToggle, module: module } = props;
    const shouldShowOptions = !!chartToggle || !!listingViewOptions || !!statusOptionsSelector || !!exportButton;
    const { selectedSavedSearch: selectedSavedSearch } = (0, $90ISC.useSearchStore)((state)=>({
            selectedSavedSearch: state[module]?.selectedSavedSearch
        }));
    const searchName = selectedSavedSearch ? selectedSavedSearch?.savedSearch?.searchName : (0, $cstaF.marketDynamicsTerms).newSearch;
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "row w-100 ml-2 my-2 pr-1 py-0",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "labels-buttons-container d-flex flex-wrap align-items-start",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "d-flex align-items-center",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                            className: "title-row text-truncate mb-0 font-gray-primary",
                            children: (0, $cstaF.searchTypes)[location.pathname].title
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h6", {
                            className: "text-truncate mb-0 helix-body",
                            children: searchName
                        })
                    ]
                }),
                shouldShowOptions && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "d-flex flex-row",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "d-flex align-items-center justify-content-center",
                            children: chartToggle
                        }),
                        listingViewOptions,
                        statusOptionsSelector,
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "md-title-row",
                            children: [
                                " ",
                                exportButton,
                                " "
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
$1ddd30bd02785e34$var$TitleRow.propTypes = {
    chartToggle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).element,
    exportButton: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).element,
    listingViewOptions: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).element,
    module: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    statusOptionsSelector: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).element
};
var $1ddd30bd02785e34$export$2e2bcd8739ae039 = $1ddd30bd02785e34$var$TitleRow;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $3etjB = parcelRequire("3etjB");
parcelRequire("fHiKR");
var $1BYDb = parcelRequire("1BYDb");
const $191cc371646f013d$var$ChartToggle = (props)=>{
    const { shouldShowChart: shouldShowChart, setShouldShowChart: setShouldShowChart } = props;
    const toggleShowHideChart = ()=>setShouldShowChart(!shouldShowChart);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                className: "mr-2 clickable",
                onClick: toggleShowHideChart,
                children: (0, $3etjB.marketShareTerms).chart
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1BYDb))), {
                dataLwtId: "market-share-chart-toggle",
                type: "switch",
                checked: shouldShowChart,
                onClick: setShouldShowChart,
                id: "chart-toggle"
            })
        ]
    });
};
$191cc371646f013d$var$ChartToggle.propTypes = {
    shouldShowChart: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    setShouldShowChart: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};
var $191cc371646f013d$export$2e2bcd8739ae039 = $191cc371646f013d$var$ChartToggle;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $2Xlz6 = parcelRequire("2Xlz6");

var $dI25G = parcelRequire("dI25G");

var $eOjgM = parcelRequire("eOjgM");

var $6M53k = parcelRequire("6M53k");

var $ivaD7 = parcelRequire("ivaD7");

var $bLQRh = parcelRequire("bLQRh");
parcelRequire("amkL4");
var $3QXz5 = parcelRequire("3QXz5");

var $cstaF = parcelRequire("cstaF");

var $90ISC = parcelRequire("90ISC");
const $332983f7b8b90e11$var$OptionsSelector = (props)=>{
    const { options: options, id: id, title: title, setOptions: setOptions } = props;
    const { resetBreakdowns: resetBreakdowns } = (0, $90ISC.useSearchStore)((state)=>({
            resetBreakdowns: state.resetBreakdowns
        }));
    const [state, setState] = (0, $acw62.useState)({
        isPopoverOpen: false,
        renderedOptions: [],
        countChecked: (0, $6M53k.getCountChecked)(options),
        toast: {}
    });
    const togglePopover = ()=>{
        (0, $ivaD7.setStateData)("isPopoverOpen", !state.isPopoverOpen, setState);
        return null;
    };
    const showToast = (toastType)=>{
        let toastProperties;
        if (toastType === (0, $cstaF.marketDynamicsTerms).atLeastOneStatusMustBeSelected) toastProperties = {
            id: 1,
            message: (0, $cstaF.marketDynamicsTerms).atLeastOneStatusMustBeSelected,
            color: "danger",
            icon: "error_outline_icon",
            border: "left"
        };
        (0, $ivaD7.setStateData)("toast", toastProperties, setState);
    };
    const handleOptionClick = (e)=>{
        const clickedOption = e.target;
        if (!clickedOption.checked && state.countChecked === (0, $6M53k.MIN_COUNT_SELECTIONS)) {
            showToast((0, $cstaF.marketDynamicsTerms).atLeastOneStatusMustBeSelected);
            return;
        }
        const updatedOptions = options.map((option)=>{
            if (clickedOption.type === "radio" && option.isRadio) {
                const { value: value, checked: checked } = clickedOption;
                return {
                    ...option,
                    checked: option.id === value ? checked : false
                };
            }
            if (option.id === clickedOption.value) return {
                ...option,
                checked: clickedOption.checked
            };
            return option;
        });
        (0, $ivaD7.setStateData)("countChecked", (0, $6M53k.getCountChecked)(options), setState);
        setOptions(updatedOptions);
        resetBreakdowns();
    };
    const buttonId = `options-selector-${id}`;
    (0, $acw62.useEffect)(()=>{
        const renderedOptions = (0, $6M53k.getRenderedStatusOptions)(options, handleOptionClick, state.countChecked);
        (0, $ivaD7.setStateData)("renderedOptions", renderedOptions, setState);
        (0, $ivaD7.setStateData)("countChecked", (0, $6M53k.getCountChecked)(options), setState);
    }, [
        options,
        state.countChecked
    ]);
    const buttonLabel = (0, $bLQRh.terms).itemTypeCount(title, state.countChecked);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                id: buttonId,
                dataLwtId: buttonId,
                className: "bg-dark d-flex align-items-center justify-content-between",
                size: "sm",
                onClick: togglePopover,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        children: buttonLabel
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                        icon: (0, $eOjgM.chevron_small_down),
                        className: "metrics-arrow-icon"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Xlz6))), {
                target: buttonId,
                popperClassName: "options-selector-popover",
                size: "lg",
                placement: "bottom",
                trigger: "legacy",
                toggle: togglePopover,
                isOpen: state.isPopoverOpen,
                body: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: state.renderedOptions
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3QXz5))), {
                dataLwtId: "market-dynamics-options-selector-toast",
                toastProps: state.toast,
                position: "toast-bottom-right"
            })
        ]
    });
};
$332983f7b8b90e11$var$OptionsSelector.propTypes = {
    setOptions: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};
var $332983f7b8b90e11$export$2e2bcd8739ae039 = $332983f7b8b90e11$var$OptionsSelector;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
parcelRequire("3PprX");
var $90ODN = parcelRequire("90ODN");
const $fd808f3d16d830ec$var$ListingViewOptions = (props)=>{
    const { options: options, listingViewId: listingViewId, title: title, isDisabled: isDisabled } = props;
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($90ODN))), {
            dataLwtId: "listing-view-options",
            toggleProps: {
                dataLwtId: "no-split-toggle",
                disabled: isDisabled,
                id: "listing-view-options",
                caret: true,
                children: options?.find((option)=>option.dataLwtId === listingViewId)?.itemText || title,
                className: "bg-dark btn btn-sm btn-secondary mr-2 md-title-row"
            },
            items: options,
            menuProps: {
                dataLwtId: "listing-view-options-menu",
                right: true
            }
        })
    });
};
$fd808f3d16d830ec$var$ListingViewOptions.propTypes = {
    options: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).element,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    listingViewId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number || null,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
var $fd808f3d16d830ec$export$2e2bcd8739ae039 = $fd808f3d16d830ec$var$ListingViewOptions;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $2z9GT = parcelRequire("2z9GT");

var $cstaF = parcelRequire("cstaF");

var $bLQRh = parcelRequire("bLQRh");

var $htzEo = parcelRequire("htzEo");

var $1PiL9 = parcelRequire("1PiL9");

var $cL3O2 = parcelRequire("cL3O2");

var $eNmV5 = parcelRequire("eNmV5");

var $42prG = parcelRequire("42prG");
const $e6a1117321b48a78$var$wholeTimePeriodTooltipIdsByMeasureType = {
    [(0, $bLQRh.measureTypeKeys).percent]: {
        periodChange: (0, $1PiL9.marketDynamicsColumns).periodChangePercent.id,
        periodPercentChange: (0, $1PiL9.marketDynamicsColumns).periodPercentChangePercent.id,
        totalChange: (0, $1PiL9.marketDynamicsColumns).totalChangePercent.id,
        totalPercentChange: (0, $1PiL9.marketDynamicsColumns).totalPercentChangePercent.id
    },
    [(0, $bLQRh.measureTypeKeys).unit]: {
        periodChange: (0, $1PiL9.marketDynamicsColumns).periodChange.id,
        periodPercentChange: (0, $1PiL9.marketDynamicsColumns).periodPercentChangeUnits.id,
        totalChange: (0, $1PiL9.marketDynamicsColumns).totalChangeUnits.id,
        totalPercentChange: (0, $1PiL9.marketDynamicsColumns).totalPercentChangeUnits.id
    },
    [(0, $bLQRh.measureTypeKeys).volume]: {
        periodChange: (0, $1PiL9.marketDynamicsColumns).periodChangeVolume.id,
        periodPercentChange: (0, $1PiL9.marketDynamicsColumns).periodPercentChange.id,
        totalChange: (0, $1PiL9.marketDynamicsColumns).totalChange.id,
        totalPercentChange: (0, $1PiL9.marketDynamicsColumns).totalPercentChange.id
    }
};
const $e6a1117321b48a78$export$ac20374c2c0711dd = (data, date, isBeginDate)=>{
    return data?.find((obj)=>isBeginDate ? obj.timePeriodStart === date : obj.timePeriodEnd === date);
};
const $e6a1117321b48a78$var$filterDataByCheckedOptions = (statusOptions, data)=>{
    const checkedOptions = statusOptions?.filter((option)=>!option.isRadio && option.checked === true).map((o)=>o.id);
    return data?.filter((obj)=>checkedOptions.includes(obj.id));
};
const $e6a1117321b48a78$var$timePeriodSearchType = (timeInterval)=>({
        monthly: timeInterval === (0, $cstaF.marketDynamicsTimePeriods)[(0, $cstaF.marketDynamicsTerms).years2Monthly] || timeInterval === (0, $cstaF.marketDynamicsTimePeriods)[(0, $cstaF.marketDynamicsTerms).years1Monthly],
        weekly: timeInterval === (0, $cstaF.marketDynamicsTimePeriods)[(0, $cstaF.marketDynamicsTerms).months6Weekly],
        quarterly: timeInterval === (0, $cstaF.marketDynamicsTimePeriods)[(0, $cstaF.marketDynamicsTerms).years3Quarterly]
    });
const $e6a1117321b48a78$var$getWholeTimePeriodTitle = (timeInterval)=>{
    if ($e6a1117321b48a78$var$timePeriodSearchType(timeInterval).monthly) return (0, $bLQRh.terms).monthly;
    if ($e6a1117321b48a78$var$timePeriodSearchType(timeInterval).weekly) return (0, $bLQRh.terms).weekly;
    if ($e6a1117321b48a78$var$timePeriodSearchType(timeInterval).quarterly) return (0, $bLQRh.terms).quarterly;
};
const $e6a1117321b48a78$var$getTooltipTimePeriodTitle = (timeInterval)=>{
    if ($e6a1117321b48a78$var$timePeriodSearchType(timeInterval).monthly) return (0, $bLQRh.terms).month;
    if ($e6a1117321b48a78$var$timePeriodSearchType(timeInterval).quarterly) return (0, $bLQRh.terms).quarter;
};
const $e6a1117321b48a78$export$592bce5f8a5ebac7 = (props)=>{
    const { listingConfig: listingConfig, timeInterval: timeInterval, beginPeriodDate: beginPeriodDate, endPeriodDate: endPeriodDate, selectedPeriodComparison: selectedPeriodComparison } = props;
    const keyInfoConfig = listingConfig?.listingConfig?.keyInformation;
    const matchedConfigKey = Object.keys((0, $bLQRh.measureTypeByConfigKey)).find((configKey)=>keyInfoConfig?.[configKey]);
    const measureType = (0, $bLQRh.measureTypeByConfigKey)[matchedConfigKey] ?? (0, $bLQRh.measureTypeKeys).volume;
    const wholeTimePeriodTooltipIds = $e6a1117321b48a78$var$wholeTimePeriodTooltipIdsByMeasureType[measureType];
    const wholeTimePeriodAmountType = keyInfoConfig?.[matchedConfigKey];
    const changeValueHeader = listingConfig.listingConfig?.keyInformation?.changeColumnHeaderName || (0, $bLQRh.terms).change$;
    const columnDefs = listingConfig?.groupConfig?.keyInfo[selectedPeriodComparison];
    const dateFormatter = $e6a1117321b48a78$var$timePeriodSearchType(timeInterval).monthly ? (0, $htzEo.monthAndYearFormat) : (0, $htzEo.getQuarterFormatted);
    const timePeriodTitle = $e6a1117321b48a78$var$getTooltipTimePeriodTitle(timeInterval);
    columnDefs?.map((column)=>{
        const endPeriodHeaderComponentParam = ()=>{
            if ($e6a1117321b48a78$var$timePeriodSearchType(timeInterval).monthly && endPeriodDate) {
                const baseTooltip = {
                    ...(0, $eNmV5.marketDynamicsTooltips).endPeriod,
                    label: dateFormatter(endPeriodDate)
                };
                return (0, $42prG.getHeaderAndTooltip)(baseTooltip, timePeriodTitle, dateFormatter(endPeriodDate));
            }
            if ($e6a1117321b48a78$var$timePeriodSearchType(timeInterval).quarterly) {
                const baseTooltip = {
                    ...(0, $eNmV5.marketDynamicsTooltips).endPeriod,
                    label: dateFormatter(endPeriodDate, (0, $htzEo.longQuarterNumberAndYear))
                };
                return (0, $42prG.getHeaderAndTooltip)(baseTooltip, timePeriodTitle, dateFormatter(endPeriodDate, (0, $htzEo.quarterNumberAndYear)));
            }
        };
        const beginPeriodHeaderComponentParam = ()=>{
            if ($e6a1117321b48a78$var$timePeriodSearchType(timeInterval).monthly && beginPeriodDate) {
                const baseTooltip = {
                    ...(0, $eNmV5.marketDynamicsTooltips).beginPeriod,
                    label: dateFormatter(beginPeriodDate)
                };
                return (0, $42prG.getHeaderAndTooltip)(baseTooltip, timePeriodTitle, dateFormatter(beginPeriodDate));
            }
            if ($e6a1117321b48a78$var$timePeriodSearchType(timeInterval).quarterly) {
                const baseTooltip = {
                    ...(0, $eNmV5.marketDynamicsTooltips).beginPeriod,
                    label: dateFormatter(beginPeriodDate, (0, $htzEo.longQuarterNumberAndYear))
                };
                return (0, $42prG.getHeaderAndTooltip)(baseTooltip, timePeriodTitle, dateFormatter(beginPeriodDate, (0, $htzEo.quarterNumberAndYear)));
            }
        };
        const columnHeaderComponentParamsByField = {
            [(0, $1PiL9.marketDynamicsColumns).status.id]: (0, $42prG.getHeaderAndTooltip)((0, $eNmV5.marketDynamicsTooltips).status),
            [(0, $1PiL9.marketDynamicsColumns).previousWeeksAvg.id]: (0, $42prG.getHeaderAndTooltip)((0, $eNmV5.marketDynamicsTooltips).previousWeeksAvg),
            [(0, $1PiL9.marketDynamicsColumns).lastWeeksAvg.id]: (0, $42prG.getHeaderAndTooltip)((0, $eNmV5.marketDynamicsTooltips).lastWeeksAvg),
            [(0, $1PiL9.marketDynamicsColumns).changeAvg.id]: (0, $42prG.getHeaderAndTooltip)({
                ...(0, $eNmV5.marketDynamicsTooltips).changeAvg,
                label: changeValueHeader
            }),
            [(0, $1PiL9.marketDynamicsColumns).changeAvgPercentage.id]: (0, $42prG.getHeaderAndTooltip)((0, $eNmV5.marketDynamicsTooltips).changeAvgPercentage),
            [(0, $1PiL9.marketDynamicsColumns).changeValue.id]: (0, $42prG.getHeaderAndTooltip)({
                ...(0, $eNmV5.marketDynamicsTooltips).changeValue,
                label: changeValueHeader
            }, dateFormatter(beginPeriodDate, (0, $htzEo.quarterNumberAndYear)), dateFormatter(endPeriodDate, (0, $htzEo.quarterNumberAndYear)), timePeriodTitle),
            [(0, $bLQRh.periodKeys).endPeriodValue]: endPeriodHeaderComponentParam(),
            [(0, $bLQRh.periodKeys).beginPeriodValue]: beginPeriodHeaderComponentParam(),
            [(0, $1PiL9.marketDynamicsColumns).periodChange.id]: (0, $42prG.getHeaderAndTooltip)({
                ...(0, $eNmV5.marketDynamicsTooltips)[wholeTimePeriodTooltipIds.periodChange],
                label: (0, $bLQRh.terms).periodChange($e6a1117321b48a78$var$getWholeTimePeriodTitle(timeInterval))
            }, timePeriodTitle, wholeTimePeriodAmountType),
            [(0, $1PiL9.marketDynamicsColumns).periodPercentChange.id]: (0, $42prG.getHeaderAndTooltip)({
                ...(0, $eNmV5.marketDynamicsTooltips)[wholeTimePeriodTooltipIds.periodPercentChange],
                label: (0, $bLQRh.terms).periodPercentChange($e6a1117321b48a78$var$getWholeTimePeriodTitle(timeInterval))
            }, timePeriodTitle, wholeTimePeriodAmountType),
            [(0, $1PiL9.marketDynamicsColumns).totalChange.id]: (0, $42prG.getHeaderAndTooltip)({
                ...(0, $eNmV5.marketDynamicsTooltips)[wholeTimePeriodTooltipIds.totalChange]
            }, wholeTimePeriodAmountType),
            [(0, $1PiL9.marketDynamicsColumns).totalPercentChange.id]: (0, $42prG.getHeaderAndTooltip)({
                ...(0, $eNmV5.marketDynamicsTooltips)[wholeTimePeriodTooltipIds.totalPercentChange]
            }, wholeTimePeriodAmountType),
            [(0, $1PiL9.marketDynamicsColumns).changeValuePercentage.id]: (0, $42prG.getHeaderAndTooltip)((0, $eNmV5.marketDynamicsTooltips).changeValuePercentage, timePeriodTitle, dateFormatter(beginPeriodDate, (0, $htzEo.quarterNumberAndYear)))
        };
        column.headerComponentParams = columnHeaderComponentParamsByField[column.field];
        return column;
    });
    return columnDefs;
};
const $e6a1117321b48a78$export$d934dd3ab03eff49 = (props)=>{
    const { timeInterval: timeInterval, endPeriodData: endPeriodData, beginPeriodData: beginPeriodData, previousWeeksData: previousWeeksData, lastWeeksData: lastWeeksData, featureToggles: featureToggles, listingConfig: listingConfig, statusOptions: statusOptions, searchResults: searchResults, selectedPeriodComparison: selectedPeriodComparison } = props;
    const calculateRows = statusOptions?.map((row)=>{
        const { id: id, label: label, keyField: keyField, keyInfoLabel: keyInfoLabel } = row;
        const statusLabel = keyInfoLabel || label;
        const formatter = listingConfig?.listingConfig?.keyInformation?.formatter || (0, $htzEo.formatVolume);
        const listingsWithPercentageValues = [
            (0, $cL3O2.listingViews).avgSpLpComparison.value,
            (0, $cL3O2.listingViews).avgSpOpComparison.value,
            (0, $cL3O2.listingViews).avgSpOpAllProperties.value,
            (0, $cL3O2.listingViews).salesAbsorption.value
        ];
        const isPercentageListing = listingsWithPercentageValues.includes(listingConfig.listingConfig.value);
        const changeFormatter = isPercentageListing ? (0, $htzEo.blankEmptyFormatPercentage) : formatter;
        if ($e6a1117321b48a78$var$timePeriodSearchType(timeInterval).weekly) return (0, $42prG.getWeeklyData)(formatter, previousWeeksData, lastWeeksData, keyField, changeFormatter, id, label);
        return (0, $42prG.getQuarterlyOrMonthlyData)({
            selectedPeriodComparison: selectedPeriodComparison,
            beginPeriodData: beginPeriodData,
            endPeriodData: endPeriodData,
            searchResults: searchResults,
            featureToggles: featureToggles,
            id: id,
            statusLabel: statusLabel,
            keyField: keyField,
            formatter: formatter,
            changeFormatter: changeFormatter
        });
    });
    const rows = $e6a1117321b48a78$var$filterDataByCheckedOptions(statusOptions, calculateRows);
    for(let i = 0; i < rows?.length; i++)rows[i].color = (0, $bLQRh.marketDynamicsColors).bars[i];
    return rows;
};



var $dSrCm = parcelRequire("dSrCm");

var $kLrt8 = parcelRequire("kLrt8");
const $bf4a317edb245a5a$var$KeyInformation = (props)=>{
    const { searchCriteria: searchCriteria, searchResults: searchResults, statusOptions: statusOptions, listingConfig: listingConfig, selectedPeriodComparison: selectedPeriodComparison, beginPeriodDate: beginPeriodDate, endPeriodDate: endPeriodDate, isPDFTable: isPDFTable } = props;
    const [state, setState] = (0, $acw62.useState)({
        beginPeriodData: undefined,
        columnDefs: [],
        endPeriodData: undefined,
        lastWeeksData: undefined,
        previousWeeksData: undefined,
        rowData: []
    });
    const gridRef = (0, $acw62.useRef)();
    const featureToggles = (0, $kLrt8.useFeatureToggles)();
    const timeInterval = searchCriteria?.timePeriod.intervalType;
    (0, $acw62.useEffect)(()=>{
        if (searchResults) {
            const endPeriodData = (0, $e6a1117321b48a78$export$ac20374c2c0711dd)(searchResults, endPeriodDate, false);
            const beginPeriodData = (0, $e6a1117321b48a78$export$ac20374c2c0711dd)(searchResults, beginPeriodDate, true);
            const lastWeeksData = searchResults?.slice(0, searchResults.length / 2);
            const previousWeeksData = searchResults?.slice(searchResults.length / 2);
            setState((prevState)=>({
                    ...prevState,
                    endPeriodData: endPeriodData,
                    beginPeriodData: beginPeriodData,
                    previousWeeksData: previousWeeksData,
                    lastWeeksData: lastWeeksData
                }));
        }
    }, [
        searchResults
    ]);
    (0, $acw62.useEffect)(()=>{
        const defineColumnsProps = {
            listingConfig: listingConfig,
            timeInterval: timeInterval,
            beginPeriodDate: beginPeriodDate,
            endPeriodDate: endPeriodDate,
            selectedPeriodComparison: selectedPeriodComparison
        };
        const columnDefs = (0, $e6a1117321b48a78$export$592bce5f8a5ebac7)(defineColumnsProps);
        setState((prevState)=>({
                ...prevState,
                columnDefs: columnDefs
            }));
        gridRef?.current?.api?.setGridOption("columnDefs", columnDefs);
    }, [
        listingConfig,
        selectedPeriodComparison,
        state.beginPeriodData,
        state.endPeriodData
    ]);
    (0, $acw62.useEffect)(()=>{
        let rowData;
        if (searchResults) {
            const calculateRowProps = {
                timeInterval: timeInterval,
                endPeriodData: state.endPeriodData,
                beginPeriodData: state.beginPeriodData,
                previousWeeksData: state.previousWeeksData,
                lastWeeksData: state.lastWeeksData,
                listingConfig: listingConfig,
                statusOptions: statusOptions,
                featureToggles: featureToggles,
                searchResults: searchResults,
                selectedPeriodComparison: selectedPeriodComparison
            };
            rowData = (0, $e6a1117321b48a78$export$d934dd3ab03eff49)(calculateRowProps);
        }
        setState((prevState)=>({
                ...prevState,
                rowData: rowData
            }));
    }, [
        searchResults,
        state.endPeriodData,
        state.beginPeriodData,
        state.previousWeeksData,
        state.lastWeeksData,
        listingConfig,
        featureToggles.trendAnalysisDebugOutput.isEnabled
    ]);
    const agGridComponents = (0, $acw62.useMemo)(()=>{
        return {
            agColumnHeader: (props)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $dSrCm.default), {
                    isKeyInfoTable: true,
                    ...props
                })
        };
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: state.rowData && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: isPDFTable ? "pdf-mode" : "",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2z9GT.AGGridHelix), {
                ref: gridRef,
                rowData: state.rowData,
                columnDefs: state.columnDefs,
                suppressMultiSort: true,
                domLayout: "autoHeight",
                suppressClickEdit: true,
                components: agGridComponents
            })
        })
    });
};
$bf4a317edb245a5a$var$KeyInformation.PropTypes = {
    searchCriteria: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    searchResults: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object),
    statusOptions: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object),
    listingConfig: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    beginPeriodDate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    endPeriodDate: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};
var $bf4a317edb245a5a$export$2e2bcd8739ae039 = $bf4a317edb245a5a$var$KeyInformation;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $3r6bj = parcelRequire("3r6bj");

var $c9Z8w = parcelRequire("c9Z8w");

var $bLQRh = parcelRequire("bLQRh");


var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("fHiKR");
var $1BYDb = parcelRequire("1BYDb");

var $bLQRh = parcelRequire("bLQRh");
parcelRequire("3PprX");
var $90ODN = parcelRequire("90ODN");

var $htzEo = parcelRequire("htzEo");

var $bLQRh = parcelRequire("bLQRh");
const $281b635a8b12a7e2$export$ed294cdc8187f740 = (optionType, agentData, formatter, setSelectedValue, selectedComplementValue)=>agentData?.map((period, index)=>{
        return {
            dataLwtId: `${optionType === (0, $bLQRh.terms).begin ? "begin-option" : "end-option"}${index}`,
            value: optionType === (0, $bLQRh.terms).begin ? period.timePeriodStart : period.timePeriodEnd,
            itemText: formatter(period.timePeriodStart, (0, $htzEo.longQuarterNumberAndYear)),
            key: `item_${index}`,
            onClick: ()=>setSelectedValue(optionType === (0, $bLQRh.terms).begin ? period.timePeriodStart : period.timePeriodEnd)
        };
    }).reverse().filter((option)=>{
        if (optionType === (0, $bLQRh.terms).begin) return new Date(selectedComplementValue) > new Date(option.value);
        return new Date(selectedComplementValue) < new Date(option.value);
    });



var $htzEo = parcelRequire("htzEo");

var $jKEVi = parcelRequire("jKEVi");

var $cstaF = parcelRequire("cstaF");

var $c9Z8w = parcelRequire("c9Z8w");
const $37428aee1960f242$var$PeriodComparison = ({ setSelectedPeriodComparison: setSelectedPeriodComparison, selectedPeriodComparison: selectedPeriodComparison, agentData: agentData, intervalType: intervalType, onBeginChange: onBeginChange, onEndChange: onEndChange })=>{
    const { storedChartFilters: storedChartFilters } = (0, $jKEVi.useSearchStore)((state)=>({
            storedChartFilters: state[(0, $cstaF.modules).marketDynamics.marketDynamics]?.chartFilters
        }));
    const formatter = intervalType === (0, $bLQRh.terms).quarter ? (0, $htzEo.getQuarterFormatted) : (0, $htzEo.monthAndYearFormat);
    const defaultBeginValue = agentData ? agentData[agentData?.length - 1]?.timePeriodStart : "";
    const defaultEndValue = agentData ? agentData[0]?.timePeriodEnd : "";
    const selectedBeginValue = storedChartFilters?.selectedBeginValue ?? defaultBeginValue;
    const selectedEndValue = storedChartFilters?.selectedEndValue ?? defaultEndValue;
    const beginOptions = selectedEndValue ? (0, $281b635a8b12a7e2$export$ed294cdc8187f740)((0, $bLQRh.terms).begin, agentData, formatter, onBeginChange, selectedEndValue) : [];
    const endOptions = selectedBeginValue ? (0, $281b635a8b12a7e2$export$ed294cdc8187f740)((0, $bLQRh.terms).end, agentData, formatter, onEndChange, selectedBeginValue) : [];
    return selectedBeginValue ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "period-comparison",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1BYDb))), {
                className: "d-inline-block mr-4",
                dataLwtId: "begin-end",
                id: "begin-end",
                value: (0, $bLQRh.periodKeys).beginVsEndMonth,
                type: "radio",
                name: "period-comparison",
                label: (0, $bLQRh.terms).beginVsEndMonthLabel,
                checked: selectedPeriodComparison === (0, $bLQRh.periodKeys).beginVsEndMonth,
                onChange: (event)=>setSelectedPeriodComparison(event.target.value)
            }, 1),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1BYDb))), {
                className: "d-inline-block mr-5",
                dataLwtId: "whole-time-period",
                id: "whole-time-period",
                value: (0, $bLQRh.periodKeys).wholeTimePeriod,
                type: "radio",
                name: "period-comparison",
                label: (0, $bLQRh.terms).wholeTimePeriodLabel,
                checked: selectedPeriodComparison === (0, $bLQRh.periodKeys).wholeTimePeriod,
                onChange: (event)=>setSelectedPeriodComparison(event.target.value)
            }, 2),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($90ODN))), {
                className: "d-inline-block mr-3",
                dataLwtId: "periodComparisonBeginOptions",
                toggleProps: {
                    dataLwtId: "no-split-toggle",
                    id: "caret",
                    caret: true,
                    children: (0, $bLQRh.terms).beginPeriod(formatter(selectedBeginValue, (0, $htzEo.longQuarterNumberAndYear)))
                },
                items: beginOptions,
                menuProps: {
                    dataLwtId: "share-menu",
                    right: true,
                    className: "periodComparisonDropdown"
                },
                size: "sm"
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($90ODN))), {
                className: "d-inline-block",
                dataLwtId: "periodComparisonEndOptions",
                toggleProps: {
                    dataLwtId: "no-split-toggle",
                    id: "caret",
                    caret: true,
                    children: (0, $bLQRh.terms).endPeriod(formatter(selectedEndValue, (0, $htzEo.longQuarterNumberAndYear)))
                },
                items: endOptions,
                menuProps: {
                    dataLwtId: "share-menu",
                    right: true,
                    className: "periodComparisonDropdown"
                },
                size: "sm"
            })
        ]
    }) : null;
};
$37428aee1960f242$var$PeriodComparison.propTypes = {
    setSelectedPeriodComparison: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    selectedPeriodComparison: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    agentData: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    intervalType: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    onBeginChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onEndChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};
var $37428aee1960f242$export$2e2bcd8739ae039 = $37428aee1960f242$var$PeriodComparison;



var $42prG = parcelRequire("42prG");

var $7jSpM = parcelRequire("7jSpM");

var $cwutX = parcelRequire("cwutX");

var $7tOHe = parcelRequire("7tOHe");

const $b50ef959f12cf33d$var$SIDEBAR_EXPANDED_WIDTH = 300;
const $b50ef959f12cf33d$var$SIDEBAR_COLLAPSED_WIDTH = 68;
const $b50ef959f12cf33d$var$SCROLL_BREAKPOINT = 1200;
const $b50ef959f12cf33d$var$MINIMUM_CHART_WIDTH = 1100;
const $b50ef959f12cf33d$var$ResultsChart = ({ data: data, checkedStatusOptions: checkedStatusOptions, config: config, setSelectedPeriodComparison: setSelectedPeriodComparison, selectedPeriodComparison: selectedPeriodComparison, onBeginChange: onBeginChange, onEndChange: onEndChange, agentData: agentData, selectedBeginIndex: selectedBeginIndex, selectedEndIndex: selectedEndIndex, handleBarClick: handleBarClick, isPDFChart: isPDFChart, index: index, timePeriod: timePeriod, isOverview: isOverview, overviewStatus: overviewStatus })=>{
    const { isSideNavExpanded: isSideNavExpanded, isTransitioning: isTransitioning } = (0, $0fd5bff891bbaebc$export$417cdd20f97a1a9)();
    const { threshold: threshold, lowHexColor: lowHexColor, highHexColor: highHexColor, auxHexColor: auxHexColor, xAxisLegends: xAxisLegends } = isOverview && config?.listingConfig?.chart || {};
    const intervalType = config?.groupConfig?.columnSettings?.label;
    const isStacked = config?.listingConfig?.chart?.isStacked;
    const options = (0, $f04533a6b7242ef6$export$d2312e68e1f5ad00)({
        chartLabelStyles: $bLQRh.chartLabelStyles,
        checkedStatusOptions: checkedStatusOptions,
        config: config,
        data: data,
        dataPointMouseOverStyler: $7jSpM.dataPointMouseOverStyler,
        fontFamily: $bLQRh.chartFontFamily,
        getBeginVsEndMonthColors: $f04533a6b7242ef6$export$c5345ac482c7c12d,
        getChartTooltipContent: $42prG.getChartTooltipContent,
        handleBarClick: handleBarClick,
        handleDataPointMouseEnter: $f04533a6b7242ef6$export$ab850d5420cc66e4,
        handleDataPointSelection: $f04533a6b7242ef6$export$14e49c3a0d832ed8,
        highHexColor: highHexColor,
        intervalType: intervalType,
        isOverview: isOverview,
        isStacked: isStacked,
        lowHexColor: lowHexColor,
        overviewStatus: overviewStatus,
        selectedBeginIndex: selectedBeginIndex,
        selectedEndIndex: selectedEndIndex,
        selectedPeriodComparison: selectedPeriodComparison,
        threshold: threshold,
        xAxisLegends: xAxisLegends,
        isPDFChart: isPDFChart,
        auxHexColor: auxHexColor,
        timePeriod: timePeriod
    });
    const series = (0, $f04533a6b7242ef6$export$d1e5b04bb29aee87)(checkedStatusOptions, data);
    const keyIncrement = 1;
    const [key, setKey] = (0, $acw62.useState)(keyIncrement);
    const [windowWidth, setWindowWidth] = (0, $acw62.useState)(window.innerWidth);
    const sidebarWidth = isSideNavExpanded ? $b50ef959f12cf33d$var$SIDEBAR_EXPANDED_WIDTH : $b50ef959f12cf33d$var$SIDEBAR_COLLAPSED_WIDTH;
    const availableWidth = windowWidth - sidebarWidth + 200;
    const needsScroll = !isPDFChart && availableWidth < $b50ef959f12cf33d$var$SCROLL_BREAKPOINT;
    const getAdjustedChartProps = (baseProps, needsScroll)=>{
        const adjustedProps = {
            ...baseProps
        };
        adjustedProps.width = needsScroll ? `${$b50ef959f12cf33d$var$MINIMUM_CHART_WIDTH}px` : "100%";
        return adjustedProps;
    };
    const chartProps = {
        key: key,
        options: options,
        series: series,
        type: "bar",
        height: 390,
        width: "100%"
    };
    const adjustedChartProps = getAdjustedChartProps(chartProps, needsScroll);
    const shouldShowChart = data !== undefined;
    const isFirstRender = (0, $acw62.useRef)(true);
    const isConfigReady = !!config?.listingConfig && !!config?.groupConfig;
    const wasSidebarTransitioning = (0, $acw62.useRef)(false);
    (0, $acw62.useEffect)(()=>{
        const handleResize = ()=>setWindowWidth(window.innerWidth);
        window.addEventListener("resize", handleResize, true);
        return ()=>window.removeEventListener("resize", handleResize, true);
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        setKey((prevKey)=>prevKey + keyIncrement);
    }, [
        selectedBeginIndex,
        selectedEndIndex,
        selectedPeriodComparison
    ]);
    (0, $acw62.useEffect)(()=>{
        if (wasSidebarTransitioning.current && !isTransitioning && !isPDFChart) window.dispatchEvent(new Event("resize"));
        wasSidebarTransitioning.current = isTransitioning;
    }, [
        isTransitioning,
        isPDFChart
    ]);
    return shouldShowChart && isConfigReady && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        id: "market-dynamics-chart-graph",
        className: `raised-border mb-3 bg-white market-dynamics-chart ${needsScroll ? "needs-scroll" : "no-scroll"}`,
        children: [
            config?.groupConfig?.periodSelection && !isPDFChart && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "d-flex align-items-center",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $37428aee1960f242$export$2e2bcd8739ae039), {
                    setSelectedPeriodComparison: setSelectedPeriodComparison,
                    selectedPeriodComparison: selectedPeriodComparison,
                    agentData: agentData,
                    intervalType: config?.groupConfig?.columnSettings?.label,
                    onBeginChange: onBeginChange,
                    onEndChange: onEndChange
                })
            }),
            !isPDFChart && isTransitioning ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "chart-loader",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {})
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: `chart-wrapper ${needsScroll ? "needs-scroll" : ""}`,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: isPDFChart ? (0, $cwutX.getPdfClassname)(isOverview, index) : "",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3r6bj))), {
                        ...adjustedChartProps,
                        width: needsScroll ? `${$b50ef959f12cf33d$var$MINIMUM_CHART_WIDTH}px` : "100%",
                        options: {
                            ...adjustedChartProps.options,
                            chart: {
                                ...adjustedChartProps.options.chart,
                                width: `${$b50ef959f12cf33d$var$MINIMUM_CHART_WIDTH}px`
                            }
                        }
                    })
                })
            })
        ]
    });
};
$b50ef959f12cf33d$var$ResultsChart.propTypes = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array.isRequired,
    checkedStatusOptions: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    config: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    setSelectedPeriodComparison: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    selectedPeriodComparison: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    onBeginChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    onEndChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    agentData: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    selectedBeginIndex: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    selectedEndIndex: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    handleBarClick: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    isPDFChart: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    index: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
    timePeriod: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    isOverview: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    overviewStatus: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $b50ef959f12cf33d$export$2e2bcd8739ae039 = $b50ef959f12cf33d$var$ResultsChart;



var $cstaF = parcelRequire("cstaF");

var $90ISC = parcelRequire("90ISC");

var $70q5f = parcelRequire("70q5f");

var $ivaD7 = parcelRequire("ivaD7");


var $cstaF = parcelRequire("cstaF");
const $6047ab56c7d0bbc4$export$44487a86467333c3 = ({ timePeriod: timePeriod })=>{
    if (!timePeriod) return [];
    return (0, $8a7be9347dd0737e$export$35767bc2eeba0585)[timePeriod];
};
const $6047ab56c7d0bbc4$export$dfcf34fd921a7054 = (timeFrameTitle)=>{
    return (0, $cstaF.marketDynamicsTimePeriods)[timeFrameTitle] || null;
};


const $738b9aa0a88b316d$export$6bccf68291158557 = ({ listingViewGroups: listingViewGroups, handleListingViewItemClick: handleListingViewItemClick, selectedListingViewId: selectedListingViewId })=>{
    const listingViewOptions = [];
    let statusOptions, defaultListingViewId;
    listingViewGroups?.map((listingViewGroup)=>{
        if (listingViewGroup?.group) listingViewOptions.push({
            dataLwtId: listingViewGroup?.group,
            itemText: listingViewGroup?.group.toUpperCase(),
            disabled: true,
            key: listingViewGroup?.group
        });
        listingViewGroup?.options.map((listingViewOption)=>{
            if (!defaultListingViewId && listingViewOption?.isDefault) defaultListingViewId = listingViewOption?.value;
            const isChecked = selectedListingViewId === listingViewOption?.value || !selectedListingViewId && listingViewOption?.isDefault;
            if (isChecked && listingViewOption?.statusOptions) statusOptions = listingViewOption?.statusOptions;
            listingViewOptions.push({
                dataLwtId: listingViewOption?.value,
                itemText: listingViewOption?.label,
                checked: isChecked,
                key: listingViewOption?.value,
                tooltip: listingViewOption?.tooltip,
                onClick: ()=>handleListingViewItemClick(listingViewOption?.value)
            });
        });
    });
    return {
        listingViewOptions: listingViewOptions,
        defaultListingViewId: defaultListingViewId,
        statusOptions: statusOptions
    };
};


const $521f88fca3d2f796$export$e179d5100d3d1a9b = (listingViewGroups, listingViewId)=>{
    for(let i = 0; i < listingViewGroups?.length; i++){
        const lvg = listingViewGroups[i];
        const foundListingView = lvg?.options?.find((listingView)=>listingView.value === listingViewId);
        if (foundListingView) return foundListingView.statusOptions;
    }
    return null;
};
const $521f88fca3d2f796$export$6cfadc73a5371a51 = (statusOptions, shouldHideCdomOption)=>{
    let optionsToReturn = [];
    statusOptions?.groups?.map((group)=>{
        group?.options?.map((option)=>{
            if (shouldHideCdomOption(option)) return;
            optionsToReturn.push({
                ...option,
                checked: option.isDefault
            });
        });
    });
    return optionsToReturn;
};



var $bLQRh = parcelRequire("bLQRh");


var $42prG = parcelRequire("42prG");


var $eNmV5 = parcelRequire("eNmV5");

var $l05Px = parcelRequire("l05Px");



var $ikyhZ = parcelRequire("ikyhZ");

var $1PiL9 = parcelRequire("1PiL9");

var $g7mFm = parcelRequire("g7mFm");

var $kwMiU = parcelRequire("kwMiU");

var $kLrt8 = parcelRequire("kLrt8");

var $i95vK = parcelRequire("i95vK");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");


var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $fCBgX = parcelRequire("fCBgX");


var $42prG = parcelRequire("42prG");

var $90ISC = parcelRequire("90ISC");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $3r6bj = parcelRequire("3r6bj");

var $c9Z8w = parcelRequire("c9Z8w");

var $42prG = parcelRequire("42prG");

var $2DB2D = parcelRequire("2DB2D");
const $7ef1418e65e311ba$var$Card = ({ card: card, chartProps: chartProps, dashboardData: dashboardData, isPDF: isPDF })=>{
    const { formatter: formatter, keyField: keyField, title: title, labelUnitType: labelUnitType = "", changeFormatter: changeFormatter = formatter } = card;
    const beginPeriodData = dashboardData[0]?.[keyField];
    const endPeriodData = dashboardData[1]?.[keyField];
    const shouldShowEmptyCard = !beginPeriodData || !endPeriodData;
    const titleClassNames = "helix-text-gray-500 mb-0";
    const bodyClassNames = "helix-text-gray-500 helix-body--strong mb-0";
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `card-wrapper content mb-3 px-4 pt-4 ${shouldShowEmptyCard ? "card-wrapper--empty" : ""} ${isPDF ? "dashboard-card" : "card-wrapper--responsive"}`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                className: "mb-0 title",
                children: title
            }),
            shouldShowEmptyCard ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "d-flex flex-column justify-content-center align-items-center w-100 h-100 px-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                        className: `${titleClassNames} text-center mb-2`,
                        style: {
                            wordBreak: "break-word",
                            overflowWrap: "break-word"
                        },
                        children: (0, $2DB2D.displayInfo).noDataToDisplayTitle
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: `${bodyClassNames} text-center`,
                        style: {
                            wordBreak: "break-word",
                            overflowWrap: "break-word"
                        },
                        children: (0, $2DB2D.displayInfo).noDataToDisplayMessage
                    })
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        className: titleClassNames,
                        children: `${formatter(endPeriodData)} ${labelUnitType}`
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: `${bodyClassNames} ${isPDF ? "percentage" : ""}`,
                        children: (0, $42prG.getIncreaseDecreaseValue)({
                            beginPeriodData: dashboardData[0],
                            endPeriodData: dashboardData[1],
                            formatter: formatter,
                            keyField: keyField,
                            changeFormatter: changeFormatter,
                            isOverview: true
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        id: "chart-wrapper",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3r6bj))), {
                            type: "bar",
                            ...chartProps
                        })
                    })
                ]
            })
        ]
    });
};
$7ef1418e65e311ba$var$Card.propTypes = {
    card: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    chartProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    dashboardData: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    isPDF: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired
};
var $7ef1418e65e311ba$export$2e2bcd8739ae039 = $7ef1418e65e311ba$var$Card;



var $bA5Mi = parcelRequire("bA5Mi");

var $4fYAk = parcelRequire("4fYAk");
const $42a157af135db3bb$var$Dashboard = ({ chartData: chartData, currentTab: currentTab })=>{
    const { isPDFLoading: isPDFLoading } = (0, $bA5Mi.usePDFStore)((state)=>({
            isPDFLoading: state.downloadModalStatus.isPDFLoading
        }));
    const timePeriod = (0, $90ISC.useSearchStore)((state)=>state[state.selectedModule].loadedSearchCriteria?.timePeriod?.intervalType);
    const isInventory = currentTab.title === (0, $4fYAk.tabNames).inventory;
    const dashboardData = chartData?.length && (0, $42prG.getBeginAndEndPeriodsData)(chartData);
    const currentTabSettings = (0, $fCBgX.settingsByTab)[currentTab.title];
    const revisedCardsSettings = currentTabSettings?.cards.filter((card)=>card?.timePeriods ? (0, $fCBgX.getIsValidTimePeriod)(timePeriod, card.timePeriods) : true);
    const cards = dashboardData && revisedCardsSettings?.map((card)=>{
        const chartProps = (0, $f04533a6b7242ef6$export$872649a079dabedf)(dashboardData, card, timePeriod);
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7ef1418e65e311ba$export$2e2bcd8739ae039), {
            card: card,
            chartProps: chartProps,
            dashboardData: dashboardData,
            isPDF: false
        }, card.title);
    });
    const pdfCards = dashboardData && revisedCardsSettings?.map((card)=>{
        const chartProps = (0, $f04533a6b7242ef6$export$8e90c65715766165)(dashboardData, card, timePeriod, isInventory);
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7ef1418e65e311ba$export$2e2bcd8739ae039), {
            card: card,
            chartProps: chartProps,
            dashboardData: dashboardData,
            isPDF: true
        }, card.title);
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: `dashboard-wrapper ${currentTabSettings.gridClass} mb-3`,
                children: cards
            }),
            isPDFLoading && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: `dashboard-capture-area ${currentTabSettings.gridClass} mb-3`,
                children: pdfCards
            })
        ]
    });
};
$42a157af135db3bb$var$Dashboard.propTypes = {
    chartData: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    currentTab: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $42a157af135db3bb$export$2e2bcd8739ae039 = $42a157af135db3bb$var$Dashboard;



var $4fYAk = parcelRequire("4fYAk");

var $fCBgX = parcelRequire("fCBgX");

var $70q5f = parcelRequire("70q5f");
const $831320751e4ae3d8$export$cc2318af383a4e33 = ({ renderChart: renderChart, chartData: chartData, totalsResult: totalsResult })=>{
    const { overviewStatus: overviewStatus, setOverviewStatusKey: setOverviewStatusKey, marketIndicatorContent: marketIndicatorContent, setMarketIndicatorContent: setMarketIndicatorContent } = (0, $70q5f.useMarketDynamicsStore)((state)=>({
            overviewStatus: state.overviewStatus,
            setOverviewStatusKey: state.setOverviewStatusKey,
            marketIndicatorContent: state.marketIndicatorContent,
            setMarketIndicatorContent: state.setMarketIndicatorContent
        }));
    (0, $acw62.useEffect)(()=>{
        setMarketIndicatorContent((0, $fCBgX.getMarketIndicatorContent)(totalsResult?.ucAvgDom));
    }, [
        totalsResult
    ]);
    const tabItems = Object.keys((0, $fCBgX.settingsByTab)).map((key, index)=>({
            title: key,
            content: {
                jsx: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "pt-3",
                    children: renderChart(index)
                })
            }
        }));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "flex-grow-0",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8f390b0d641c1be9$export$2e2bcd8739ae039), {
                tabTextTransform: "none",
                navSize: 2,
                contentSize: 2,
                className: "secondary",
                items: tabItems,
                tabs: true,
                currentIndex: overviewStatus.currentTab,
                setCurrentIndex: (index)=>setOverviewStatusKey((0, $4fYAk.overviewStatusKeys).currentTab, index)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "content text-center",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                        className: "mb-4",
                        children: marketIndicatorContent.title
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        children: marketIndicatorContent.description
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $42a157af135db3bb$export$2e2bcd8739ae039), {
                currentTab: tabItems[overviewStatus.currentTab],
                chartData: chartData
            })
        ]
    });
};
$831320751e4ae3d8$export$cc2318af383a4e33.propTypes = {
    chartData: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    renderChart: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    totalsResult: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};




var $4fYAk = parcelRequire("4fYAk");

var $bA5Mi = parcelRequire("bA5Mi");
const $a35b0e2d70079ed9$var$MarketDynamics = ({ module: module, agentData: agentData })=>{
    const { isLoading: isLoading, loadedSearchCriteria: loadedSearchCriteria, totalsResult: totalsResult, listingViewId: listingViewId, setMDListingViewId: setMDListingViewId, resetBreakdowns: resetBreakdowns, mergeStoredOptionsWithDefaults: mergeStoredOptionsWithDefaults, setShouldShowChart: setShouldShowChart, shouldShowChart: shouldShowChart, storedChartFilters: storedChartFilters, setMDChartFilters: setMDChartFilters, listingStatusByView: listingStatusByView, setMDListingStatusByView: setMDListingStatusByView, clearMDSortByView: clearMDSortByView } = (0, $90ISC.useSearchStore)((state)=>({
            isLoading: state.isLoading,
            loadedSearchCriteria: state[module]?.loadedSearchCriteria,
            totalsResult: state[module]?.totals,
            listingViewId: state[module]?.listingViewId,
            setMDListingViewId: state.setMDListingViewId,
            resetBreakdowns: state.resetBreakdowns,
            mergeStoredOptionsWithDefaults: state.mergeStoredOptionsWithDefaults,
            setShouldShowChart: state.setShouldShowChart,
            shouldShowChart: state[module]?.shouldShowChart,
            storedChartFilters: state[module]?.chartFilters,
            setMDChartFilters: state.setMDChartFilters,
            listingStatusByView: state[module]?.listingStatusByView,
            setMDListingStatusByView: state.setMDListingStatusByView,
            clearMDSortByView: state.clearMDSortByView
        }));
    const { checkedStatusOptions: checkedStatusOptions, setSelectedBreakdownPeriod: setSelectedBreakdownPeriod, setTableView: setTableView, setCheckedStatusOptions: setCheckedStatusOptions, tableView: tableView, overviewStatus: overviewStatus, setOverviewStatusKey: setOverviewStatusKey } = (0, $70q5f.useMarketDynamicsStore)((state)=>({
            checkedStatusOptions: state.checkedStatusOptions,
            setSelectedBreakdownPeriod: state.setSelectedBreakdownPeriod,
            setTableView: state.setTableView,
            setCheckedStatusOptions: state.setCheckedStatusOptions,
            tableView: state.tableView,
            overviewStatus: state.overviewStatus,
            setOverviewStatusKey: state.setOverviewStatusKey
        }));
    const overviewTabIds = [
        (0, $4fYAk.overviewStatusKeys).inventory,
        (0, $4fYAk.overviewStatusKeys).prices,
        (0, $4fYAk.overviewStatusKeys).activity
    ];
    const overviewCurrentTabId = overviewTabIds[overviewStatus.currentTab];
    const history = (0, $kfZjc.useHistory)();
    const featureToggles = (0, $kLrt8.useFeatureToggles)();
    const { setBackNavbarTitle: setBackNavbarTitle } = (0, $90ISC.useCommonStore)((state)=>({
            setBackNavbarTitle: state.setBackNavbarTitle
        }));
    const { isPDFLoading: isPDFLoading } = (0, $bA5Mi.usePDFStore)((state)=>({
            isPDFLoading: state.downloadModalStatus.isPDFLoading
        }));
    const [state, setState] = (0, $acw62.useState)({
        config: undefined,
        listingViewOptions: undefined,
        overviewStatusOptions: undefined,
        tooltipsSettings: {}
    });
    const gridRef = (0, $acw62.useRef)();
    const listingConfig = (0, $42prG.getConfigData)(listingViewId, state.config);
    const selectedBeginValue = storedChartFilters?.selectedBeginValue;
    const selectedEndValue = storedChartFilters?.selectedEndValue;
    const searchResults = (0, $42prG.getTransformData)(agentData?.marketDynamicsSearch);
    const keysToDisregard = [
        (0, $1PiL9.marketDynamicsColumns).timePeriodStart.id,
        "timePeriodEnd"
    ];
    const hasSearchResults = (0, $acw62.useMemo)(()=>!(0, $42prG.hasAllZeroValues)(searchResults, keysToDisregard), [
        searchResults
    ]);
    const isOverview = listingViewId === (0, $4fYAk.listingOptions).overview.value;
    const handleListingViewItemClick = (id)=>{
        resetBreakdowns();
        setMDListingViewId(id);
    };
    const shouldHideCdomOption = (option)=>{
        const { keyField: keyField } = option;
        return option.id === (0, $ikyhZ.listingStatuses).averageCdom.id && searchResults?.every((result)=>!result?.[keyField]);
    };
    const statusOptions = (0, $acw62.useMemo)(()=>{
        if (!state.config || !listingViewId || isOverview) return [];
        const statusDefaultOptions = (0, $521f88fca3d2f796$export$6cfadc73a5371a51)((0, $521f88fca3d2f796$export$e179d5100d3d1a9b)(state.config, listingViewId), shouldHideCdomOption);
        const storedOptions = listingStatusByView?.[listingViewId];
        return storedOptions?.length > 0 ? mergeStoredOptionsWithDefaults(statusDefaultOptions, storedOptions) : statusDefaultOptions;
    }, [
        state.config,
        listingViewId,
        listingStatusByView
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!isOverview) return;
        const overviewSettings = overviewStatus?.chartSettings?.[overviewCurrentTabId];
        const currentTabOptions = overviewSettings?.options?.[0]?.statusOptions ?? {};
        setState((prevState)=>({
                ...prevState,
                config: prevState?.config ? [
                    overviewSettings,
                    ...prevState.config.slice(1)
                ] : [
                    overviewSettings
                ],
                overviewStatusOptions: currentTabOptions
            }));
    }, [
        isOverview,
        overviewCurrentTabId
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isOverview) {
            const overviewOptions = state.overviewStatusOptions?.groups?.[0]?.options ?? [];
            const transformedKeyFields = (0, $42prG.getTransformKeyFields)(overviewOptions, listingViewId);
            setCheckedStatusOptions(transformedKeyFields.filter((s)=>s.isDefault) ?? []);
            return;
        }
        if (statusOptions.length > 0) {
            const transformedKeyFields = (0, $42prG.getTransformKeyFields)(statusOptions, listingViewId);
            setCheckedStatusOptions(transformedKeyFields.filter((s)=>s.checked) ?? []);
        }
    }, [
        statusOptions,
        listingViewId,
        state.overviewStatusOptions
    ]);
    (0, $acw62.useEffect)(()=>{
        const timePeriod = loadedSearchCriteria?.timePeriod.intervalType;
        const listingsConfig = (0, $6047ab56c7d0bbc4$export$44487a86467333c3)({
            timePeriod: timePeriod
        });
        const overviewConfig = (0, $42prG.addOverviewConfig)(listingsConfig, loadedSearchCriteria);
        const config = [
            overviewConfig?.inventory,
            ...listingsConfig
        ];
        setOverviewStatusKey((0, $4fYAk.overviewStatusKeys).currentTab, (0, $4fYAk.tabIndex).inventory);
        setOverviewStatusKey((0, $4fYAk.overviewStatusKeys).chartSettings, overviewConfig);
        const { listingViewOptions: listingViewOptions, defaultListingViewId: defaultListingViewId, statusOptions: overviewStatusOptions } = (0, $738b9aa0a88b316d$export$6bccf68291158557)({
            listingViewGroups: config,
            selectedListingViewId: null,
            handleListingViewItemClick: handleListingViewItemClick
        });
        setState((prevState)=>({
                ...prevState,
                config: config,
                listingViewOptions: listingViewOptions,
                overviewStatusOptions: overviewStatusOptions
            }));
        if (!listingViewId) setMDListingViewId(defaultListingViewId);
    }, [
        loadedSearchCriteria
    ]);
    (0, $acw62.useEffect)(()=>{
        const defaultBeginValue = agentData?.marketDynamicsSearch?.slice(-1)[0]?.timePeriodStart ?? "";
        const defaultEndValue = agentData?.marketDynamicsSearch?.[0]?.timePeriodEnd ?? "";
        if (!storedChartFilters?.selectedBeginValue) setMDChartFilters({
            selectedBeginValue: defaultBeginValue
        });
        if (!storedChartFilters?.selectedEndValue) setMDChartFilters({
            selectedEndValue: defaultEndValue
        });
    }, [
        agentData
    ]);
    (0, $acw62.useEffect)(()=>{
        const periodColumnSettings = listingConfig?.groupConfig?.columnSettings;
        const tableView = listingConfig?.listingConfig?.tableSettings;
        const periodType = (0, $eNmV5.normalizePeriodType)(periodColumnSettings?.label);
        const tooltipsSettings = (0, $c65a2deda8c5a6cc$export$4328921da4f8a2eb)({
            tableView: tableView,
            periodColumnSettings: periodColumnSettings,
            marketDynamicsTooltips: (0, $eNmV5.getResolvedTooltips)(periodType, tableView?.id)
        });
        const selectedStatusOptionsIds = statusOptions?.filter((status)=>status.checked).map((status)=>status.id);
        const revisedColumnDefs = (0, $c65a2deda8c5a6cc$export$c57c272c3cdaa333)(tableView, periodColumnSettings, selectedStatusOptionsIds);
        setTableView({
            tableView: revisedColumnDefs
        });
        (0, $70q5f.useMarketDynamicsStore).setState({
            selectedListingView: listingConfig?.listingConfig?.label
        });
        (0, $ivaD7.setStateData)("tooltipsSettings", tooltipsSettings, setState);
    }, [
        listingViewId,
        loadedSearchCriteria,
        listingConfig?.groupConfig,
        statusOptions,
        selectedBeginValue,
        selectedEndValue
    ]);
    const getStatusMessage = ({ messageContent: messageContent })=>{
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ddd30bd02785e34$export$2e2bcd8739ae039), {
                    module: module
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "text-center",
                    children: [
                        " ",
                        messageContent,
                        " "
                    ]
                })
            ]
        });
    };
    const isInitialSearchNotRun = loadedSearchCriteria === undefined;
    const loader = /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "py-3",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {})
    });
    const initialSearchNotRun = getStatusMessage({
        messageContent: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
            className: "initial-search",
            children: [
                " ",
                (0, $cstaF.marketDynamicsTerms).searchFilterAdjust,
                " "
            ]
        })
    });
    if (isLoading || !searchResults && !isInitialSearchNotRun) return loader;
    if (isInitialSearchNotRun) return initialSearchNotRun;
    if (!hasSearchResults) return getStatusMessage({
        messageContent: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $126e7d6ff1f55059$export$3f0134fa5c63d52e), {})
    });
    let listingViewOptions, statusOptionsSelector, chartToggle, exportButton;
    const setSelectedStatusOptions = (options)=>{
        setMDListingStatusByView(listingViewId, options);
        clearMDSortByView(listingViewId);
        const defaultSort = listingConfig?.listingConfig?.tableSettings?.defaultSort;
        gridRef.current?.api?.applyColumnState({
            state: [
                {
                    colId: defaultSort.colId,
                    sort: defaultSort.sortDir
                }
            ],
            defaultState: {
                sort: null
            }
        });
    };
    if (state.listingViewOptions?.length) {
        const isDisabled = isPDFLoading;
        listingViewOptions = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fd808f3d16d830ec$export$2e2bcd8739ae039), {
            options: state.listingViewOptions,
            listingViewId: listingViewId,
            title: (0, $bLQRh.terms).listingViews,
            isDisabled: isDisabled
        });
    }
    if (!isOverview && statusOptions?.length) {
        chartToggle = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $191cc371646f013d$export$2e2bcd8739ae039), {
            shouldShowChart: shouldShowChart,
            setShouldShowChart: setShouldShowChart
        });
        statusOptionsSelector = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $332983f7b8b90e11$export$2e2bcd8739ae039), {
            id: "statusOptions",
            setOptions: setSelectedStatusOptions,
            options: statusOptions,
            title: (0, $cstaF.buttonTerms).statuses
        });
    }
    if (hasSearchResults) {
        const exportDetails = {
            exportType: (0, $7eeaa9977bfe14b6$export$382f55aa456f5721).mdSearchResults,
            listingView: (0, $bLQRh.terms)[listingViewId]
        };
        exportButton = statusOptions && (0, $0d036ea0861162a7$export$e89cb83db8826f3)({
            exportDetails: exportDetails,
            gridRef: gridRef,
            type: (0, $i95vK.exportButtonTypes).secondary,
            isDirectPdf: isOverview,
            isLoading: isPDFLoading && isOverview
        });
    }
    const titleRowProps = {
        exportButton: exportButton,
        statusOptionsSelector: statusOptionsSelector,
        chartToggle: chartToggle,
        listingViewOptions: listingViewOptions,
        module: module
    };
    const handleBarClick = (index)=>{
        const isMDOfficeBreakdownEnabled = featureToggles.mdOfficeBreakdown.isEnabled;
        const isCdomBreakoutView = listingViewId === (0, $kwMiU.cdomBreakout).value;
        if (!isMDOfficeBreakdownEnabled || isCdomBreakoutView) return;
        const chartData = searchResults.slice().reverse();
        const period = chartData[index].timePeriodStart;
        const formatter = tableView.tables[0].colDef.valueFormatter;
        const valueFormatted = formatter({
            value: period
        });
        setBackNavbarTitle(valueFormatted);
        setSelectedBreakdownPeriod(chartData[index]);
        history.push((0, $g7mFm.officeBreakdownRoute));
    };
    const updatedStatusOptions = (0, $42prG.getTransformKeyFields)(statusOptions, listingViewId);
    const chartData = (searchResults && [
        ...searchResults
    ])?.slice().reverse();
    const getKeyInformation = (options = {})=>{
        const { isPDFTable: isPDFTable = false } = options;
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bf4a317edb245a5a$export$2e2bcd8739ae039), {
            selectedPeriodComparison: storedChartFilters?.selectedPeriodComparison,
            searchResults: searchResults,
            statusOptions: updatedStatusOptions,
            searchCriteria: loadedSearchCriteria,
            listingConfig: listingConfig,
            beginPeriodDate: selectedBeginValue,
            endPeriodDate: selectedEndValue,
            isPDFTable: isPDFTable
        });
    };
    const renderChart = (index)=>{
        const selectedBeginIndex = chartData?.findIndex((data)=>data.timePeriodStart === selectedBeginValue);
        const selectedEndIndex = chartData?.findIndex((data)=>data.timePeriodEnd === selectedEndValue);
        const getResultsChart = (options = {})=>{
            const { isPDFChart: isPDFChart = false } = options;
            return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b50ef959f12cf33d$export$2e2bcd8739ae039), {
                isOverview: isOverview,
                overviewStatus: overviewStatus,
                data: chartData,
                checkedStatusOptions: checkedStatusOptions,
                config: listingConfig,
                selectedPeriodComparison: storedChartFilters?.selectedPeriodComparison,
                setSelectedPeriodComparison: (value)=>setMDChartFilters({
                        selectedPeriodComparison: value
                    }),
                onBeginChange: (value)=>setMDChartFilters({
                        selectedBeginValue: value
                    }),
                onEndChange: (value)=>setMDChartFilters({
                        selectedEndValue: value
                    }),
                agentData: agentData?.marketDynamicsSearch,
                selectedBeginIndex: selectedBeginIndex,
                selectedEndIndex: selectedEndIndex,
                handleBarClick: handleBarClick,
                isPDFChart: isPDFChart,
                timePeriod: loadedSearchCriteria?.timePeriod.intervalType,
                index: index
            });
        };
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                getResultsChart(),
                isPDFLoading && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "pdf-chart",
                    children: getResultsChart({
                        isPDFChart: true
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ddd30bd02785e34$export$2e2bcd8739ae039), {
                ...titleRowProps
            }),
            !isOverview && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9b760a8ddf238ef9$export$a1bb54ba7ed9cdd6), {}),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    isOverview && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $831320751e4ae3d8$export$cc2318af383a4e33), {
                        chartData: chartData,
                        renderChart: renderChart,
                        totalsResult: totalsResult
                    }),
                    !isOverview && tableView && shouldShowChart && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            renderChart(),
                            getKeyInformation(),
                            isPDFLoading && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "key-info-capture-area",
                                children: getKeyInformation({
                                    isPDFTable: true
                                })
                            })
                        ]
                    })
                ]
            }),
            !isOverview && searchResults && tableView && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "mt-2",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l05Px.default), {
                    gridRef: gridRef,
                    tableView: tableView,
                    rowData: searchResults,
                    tableTitleWithTooltips: state.tooltipsSettings
                })
            })
        ]
    });
};
$a35b0e2d70079ed9$var$MarketDynamics.propTypes = {
    module: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    agentData: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array
};
var $a35b0e2d70079ed9$export$2e2bcd8739ae039 = $a35b0e2d70079ed9$var$MarketDynamics;



var $90ISC = parcelRequire("90ISC");

var $f6CJ4 = parcelRequire("f6CJ4");

var $caGGw = parcelRequire("caGGw");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $kfZjc = parcelRequire("kfZjc");

var $7tOHe = parcelRequire("7tOHe");

var $f6CJ4 = parcelRequire("f6CJ4");
const $6cb258770e98d306$var$Logout = ()=>{
    const history = (0, $kfZjc.useHistory)();
    const { logout: logout } = (0, $f6CJ4.useAuthStore)(({ logout: logout })=>({
            logout: logout
        }));
    (0, $acw62.useEffect)(()=>{
        logout(history);
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {});
};
var $6cb258770e98d306$export$2e2bcd8739ae039 = $6cb258770e98d306$var$Logout;



var $iCDWi = parcelRequire("iCDWi");

var $lxCva = parcelRequire("lxCva");

var $dFPJJ = parcelRequire("dFPJJ");

var $dlZsJ = parcelRequire("dlZsJ");

var $8QuU9 = parcelRequire("8QuU9");

var $luxkV = parcelRequire("luxkV");

var $24YIE = parcelRequire("24YIE");

var $acw62 = parcelRequire("acw62");

var $fpekr = parcelRequire("fpekr");

var $cstaF = parcelRequire("cstaF");

var $5NVz0 = parcelRequire("5NVz0");

var $90ISC = parcelRequire("90ISC");

var $bxSLe = parcelRequire("bxSLe");
const $aa9764060f6e10ce$export$65c94bb0e14ddf31 = (mlsId, selectedModule, options = {})=>{
    const [propTypes, setPropTypes] = (0, $acw62.useState)({});
    const [mappedAreas, setMappedAreas] = (0, $acw62.useState)({});
    const [offices, setOffices] = (0, $acw62.useState)({});
    const { isSilentLoad: isSilentLoad = false } = options;
    const setIsLoading = (0, $90ISC.useSearchStore)((state)=>state.setIsLoading);
    const fetchMlsProperties = async (mlsId, selectedModule)=>{
        if (mlsId && selectedModule) {
            //propTypes
            //every module except offices
            if (!propTypes[mlsId] && selectedModule !== (0, $cstaF.modules).proficiencyMetrics.offices) {
                const propertyTypesResponse = await (0, $5NVz0.getPropertyTypes)(mlsId);
                if (!propertyTypesResponse.error) {
                    const sorted = $7d000bb06f6c7a0a$export$2e2bcd8739ae039(propertyTypesResponse, [
                        (o)=>o.classId
                    ]);
                    $fpekr.default(sorted, (o)=>o.types = $7d000bb06f6c7a0a$export$2e2bcd8739ae039(o.types, [
                            (t)=>t.typeId
                        ]));
                    setPropTypes({
                        ...propTypes,
                        [mlsId]: sorted
                    });
                }
            }
            //areasMap
            //every module
            if (!mappedAreas[mlsId]) {
                const mappedAreasResponse = await (0, $5NVz0.getAreasMap)(mlsId);
                if (!mappedAreasResponse.error) setMappedAreas({
                    ...mappedAreas,
                    [mlsId]: mappedAreasResponse
                });
            }
            //offices
            if (!offices[mlsId] && [
                (0, $cstaF.modules).proficiencyMetrics.offices,
                (0, $cstaF.modules).marketShare.coverage,
                (0, $cstaF.modules).proficiencyMetrics.agentMovement
            ].includes(selectedModule)) {
                const officesResponse = await (0, $bxSLe.getOfficesByModule)(mlsId)[selectedModule]();
                if (!officesResponse.error) setOffices({
                    ...offices,
                    [mlsId]: officesResponse
                });
            }
        }
    };
    (0, $acw62.useEffect)(()=>{
        const fetchData = async ()=>{
            if (!isSilentLoad) setIsLoading(true);
            if (mlsId && selectedModule) await fetchMlsProperties(mlsId, selectedModule);
            if (!isSilentLoad) setIsLoading(false);
        };
        fetchData();
    }, [
        mlsId,
        selectedModule
    ]);
    return {
        propTypes: mlsId && propTypes[mlsId],
        mappedAreas: mlsId && mappedAreas[mlsId],
        offices: mlsId && offices[mlsId]
    };
};




var $cghEn = parcelRequire("cghEn");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $f61ig = parcelRequire("f61ig");

var $f6CJ4 = parcelRequire("f6CJ4");

var $cstaF = parcelRequire("cstaF");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $f6CJ4 = parcelRequire("f6CJ4");

var $cstaF = parcelRequire("cstaF");

var $cghEn = parcelRequire("cghEn");

var $90ISC = parcelRequire("90ISC");
const $d67550c16d1a632b$export$2504f061ec0c9314 = ()=>{
    const { askMeLaterAttempts: askMeLaterAttempts, incrementAskMeLaterAttempt: incrementAskMeLaterAttempt, isLoadingLinkLwa: isLoadingLinkLwa, handleLinkLwa: handleLinkLwa } = (0, $f6CJ4.useAuthStore)((state)=>({
            askMeLaterAttempts: state.askMeLaterAttempts,
            incrementAskMeLaterAttempt: state.incrementAskMeLaterAttempt,
            isLoadingLinkLwa: state.isLoadingLinkLwa,
            handleLinkLwa: state.handleLinkLwa
        }));
    const { userInfo: userInfo } = (0, $90ISC.useCommonStore)(({ userInfo: userInfo })=>({
            userInfo: userInfo
        }));
    const shouldShowAskMeLaterBtn = askMeLaterAttempts < (0, $cghEn.ASK_ME_LATER_MAX_ATTEMPTS);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            shouldShowAskMeLaterBtn && /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                dataLwtId: "ask-later-btn",
                color: "text",
                onClick: incrementAskMeLaterAttempt,
                disabled: isLoadingLinkLwa,
                children: (0, $cstaF.buttonTerms).askLater
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                dataLwtId: "link-lwa-btn",
                className: "link-my-account-btn d-flex justify-content-center align-items-center",
                color: "primary",
                onClick: ()=>handleLinkLwa(userInfo),
                disabled: isLoadingLinkLwa,
                children: (0, $cstaF.buttonTerms).linkLwa
            })
        ]
    });
};


const $daccc500b983ffac$export$4a40f9d7230f4d5f = ()=>{
    const { errorLinkingLwa: errorLinkingLwa, shouldShowLinkLwaModal: shouldShowLinkLwaModal } = (0, $f6CJ4.useAuthStore)((state)=>({
            errorLinkingLwa: state.errorLinkingLwa,
            shouldShowLinkLwaModal: state.shouldShowLinkLwaModal
        }));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $f61ig.default), {
        show: shouldShowLinkLwaModal,
        title: (0, $cstaF.modalTitles).linkLwaModal,
        buttons: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d67550c16d1a632b$export$2504f061ec0c9314), {}),
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h6", {
                children: (0, $cstaF.modalTerms).linkLwaModalsubtitle
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                className: "text-modal-msg",
                children: [
                    (0, $cstaF.modalTerms).linkLwaModalBody1,
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    (0, $cstaF.modalTerms).linkLwaModalBody2
                ]
            }),
            errorLinkingLwa && /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                className: "text-danger text-center",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                    errorLinkingLwa
                ]
            })
        ]
    });
};



var $7D4kr = parcelRequire("7D4kr");

var $g7mFm = parcelRequire("g7mFm");

var $aypMh = parcelRequire("aypMh");

var $i1BZc = parcelRequire("i1BZc");

var $dDBOF = parcelRequire("dDBOF");

var $70q5f = parcelRequire("70q5f");

var $42prG = parcelRequire("42prG");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $90ISC = parcelRequire("90ISC");

var $9QX0f = parcelRequire("9QX0f");


var $7tOHe = parcelRequire("7tOHe");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $l05Px = parcelRequire("l05Px");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $dI25G = parcelRequire("dI25G");

var $eOjgM = parcelRequire("eOjgM");

var $cstaF = parcelRequire("cstaF");

var $9QX0f = parcelRequire("9QX0f");

var $jKEVi = parcelRequire("jKEVi");

var $fVDYX = parcelRequire("fVDYX");


var $90ISC = parcelRequire("90ISC");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $9QX0f = parcelRequire("9QX0f");

var $eOjgM = parcelRequire("eOjgM");

var $aypMh = parcelRequire("aypMh");

var $cstaF = parcelRequire("cstaF");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $4TPr9 = parcelRequire("4TPr9");
parcelRequire("fHiKR");
var $kN5vy = parcelRequire("kN5vy");

var $c9Z8w = parcelRequire("c9Z8w");
const $7c4e13b77bde4175$export$f973f3c28d5d9390 = ({ containerClass: containerClass = "", dataLwtId: dataLwtId, defaultValue: defaultValue, labelText: labelText, options: options, onChange: onChange, value: value })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: containerClass,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kN5vy))), {
                dataLwtId: `${dataLwtId}-label`,
                for: dataLwtId,
                className: "mb-1 helix-heading",
                children: labelText
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4TPr9.default), {
                id: dataLwtId,
                dataLwtId: dataLwtId,
                className: "mt-1 mb-2",
                isClearable: false,
                options: options,
                defaultValue: defaultValue,
                matchFrom: "start",
                value: value,
                onChange: (option)=>onChange(option)
            })
        ]
    });
$7c4e13b77bde4175$export$f973f3c28d5d9390.propTypes = {
    containerClass: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    dataLwtId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    labelText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};



var $jKEVi = parcelRequire("jKEVi");

var $aypMh = parcelRequire("aypMh");

var $9QX0f = parcelRequire("9QX0f");
const $8c7b4497e38776bc$export$76748c987176663a = ({ togglePopover: togglePopover })=>{
    const { selectedView: selectedView, selectedAgentsView: selectedAgentsView, setSearchFilterState: setSearchFilterState, currentTabId: currentTabId } = (0, $jKEVi.useSearchStore)((state)=>{
        const { [state.selectedModule]: moduleState } = state;
        const { currentTabId: currentTabId } = moduleState;
        const { [currentTabId]: tabState } = moduleState?.searchOptions;
        return {
            selectedView: tabState?.display?.selectedView,
            selectedAgentsView: tabState?.display?.selectedAgentsView,
            setSearchFilterState: state.setSearchFilterState,
            currentTabId: currentTabId
        };
    });
    const viewOptions = (0, $9QX0f.viewOptionsByTab)[currentTabId];
    const handleViewChange = (option, filterId, stateId)=>{
        const selectedView = viewOptions.find((view)=>view.value === option.value) || (0, $aypMh.showOptions).find((view)=>view.value === option.value);
        setSearchFilterState(selectedView, filterId, stateId);
        togglePopover();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "py-2",
        dataLwtId: "suggested-agents-display-dropdown",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7c4e13b77bde4175$export$f973f3c28d5d9390), {
                dataLwtId: "select-agents-view",
                defaultValue: selectedView,
                labelText: (0, $aypMh.terms).view,
                options: viewOptions,
                onChange: (option)=>handleViewChange(option, (0, $9QX0f.filterIds).display, (0, $9QX0f.searchfilterStateId).selectedView)
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7c4e13b77bde4175$export$f973f3c28d5d9390), {
                dataLwtId: "select-agents-groups",
                defaultValue: selectedAgentsView,
                labelText: (0, $aypMh.terms).agents,
                options: (0, $aypMh.showOptions),
                onChange: (option)=>handleViewChange(option, (0, $9QX0f.filterIds).display, (0, $9QX0f.searchfilterStateId).selectedAgentsView)
            })
        ]
    });
};
$8c7b4497e38776bc$export$76748c987176663a.propTypes = {
    togglePopover: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired
};



var $dI25G = parcelRequire("dI25G");




const $e664c7e6c3d24385$export$5a9f4106c0710100 = (args)=>{
    const { tabKey: tabKey, shouldShowPopoverById: shouldShowPopoverById, togglePopover: togglePopover, searchOptions: searchOptions, hasResults: hasResults, tableSettings: tableSettings, selectedListingViewId: selectedListingViewId, growthAnalysisPeriod: growthAnalysisPeriod } = args;
    const { display: display, metrics: metrics } = (0, $9QX0f.popoverIds);
    return [
        ...hasResults ? [
            {
                dataLwtId: `${tabKey}-${display}`,
                popoverInnerClassName: "popover-menu-width-224",
                popoverPlacement: (0, $9QX0f.popoverTerms).bottomEnd,
                popoverIsOpen: shouldShowPopoverById[display],
                togglePopover: ()=>togglePopover(display),
                mainTitle: (0, $cstaF.agentProductionTerms)?.[searchOptions?.[tabKey]?.display?.selectedView?.value] ?? "",
                popoverBody: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8c7b4497e38776bc$export$76748c987176663a), {
                    togglePopover: ()=>togglePopover(display)
                })
            },
            {
                dataLwtId: `${tabKey}-${metrics}`,
                popoverInnerClassName: "popover-menu-width-800 helix-heading",
                popoverPlacement: (0, $9QX0f.popoverTerms).bottomEnd,
                popoverIsOpen: shouldShowPopoverById[metrics],
                popoverClassName: tableSettings?.className,
                popoverHeader: selectedListingViewId === (0, $aypMh.views).listingProficiency ? (0, $2292da915057cb56$export$359879b5b60b4c62)() : (0, $cstaF.agentProductionTerms).metrics,
                togglePopover: ()=>togglePopover(metrics),
                mainTitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                    icon: (0, $eOjgM.columns),
                    className: "mr-2"
                }),
                popoverBody: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $41bbbe2b4d964901$export$2e2bcd8739ae039), {
                    columns: tableSettings?.columns,
                    setColumns: tableSettings?.setColumns,
                    tabMode: selectedListingViewId,
                    customSettings: {
                        growthAnalysisPeriod: growthAnalysisPeriod,
                        currentTabId: tabKey
                    }
                })
            }
        ] : []
    ];
};
const $e664c7e6c3d24385$export$43ba060dea08ae12 = (args)=>{
    const { growthAnalysisPeriod: growthAnalysisPeriod, setGrowthAnalysisPeriod: setGrowthAnalysisPeriod, tabKey: tabKey, searchOptions: searchOptions, suggestedAgentsState: suggestedAgentsState } = args;
    const validationMessage = suggestedAgentsState?.validationSettings?.validationMessage;
    const filters = $e664c7e6c3d24385$export$5a9f4106c0710100(args).map((props)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $663ae31d31f02628$export$2e2bcd8739ae039), {
            ...props,
            validationMessage: validationMessage
        }, props.dataLwtId));
    const shouldShowGrowthAnalysisTimePeriod = ![
        (0, $9QX0f.tabs).incProducers.id,
        (0, $9QX0f.tabs).decProducers.id
    ].includes(tabKey);
    const isGrowthAnalysisView = searchOptions[tabKey].display.selectedView.value === (0, $aypMh.views).growthAnalysis;
    if (shouldShowGrowthAnalysisTimePeriod && isGrowthAnalysisView) return [
        filters[0],
        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eeda1f19d885be1f$export$2e2bcd8739ae039), {
            growthAnalysisPeriod: growthAnalysisPeriod,
            setGrowthAnalysisPeriod: setGrowthAnalysisPeriod
        }, `${tabKey}-${(0, $9QX0f.popoverIds).growthAnalysisPeriod}`),
        ...filters.slice(1)
    ];
    return filters;
};


const $6de7e6f34ab2a8a5$export$1b965fa6b537eae3 = ({ setSuggestedAgentsState: setSuggestedAgentsState, suggestedAgentsState: suggestedAgentsState, tableSettings: tableSettings })=>{
    const timeIntervals = (0, $90ISC.useCommonStore)((state)=>state.timeIntervals);
    const { currentTabId: currentTabId, searchOptions: searchOptions, growthAnalysisPeriod: growthAnalysisPeriod, setSearchFilterState: setSearchFilterState, selectedListingViewId: selectedListingViewId, currentTimeFrame: currentTimeFrame } = (0, $jKEVi.useSearchStore)((state)=>{
        const { [state.selectedModule]: moduleState, setSearchFilterState: setSearchFilterState } = state;
        const currentTabId = moduleState?.currentTabId;
        const searchOptions = moduleState?.searchOptions;
        const currentTabState = moduleState?.searchOptions?.[currentTabId];
        const isIncDecProducers = currentTabId === (0, $9QX0f.tabs).incProducers.id || currentTabId === (0, $9QX0f.tabs).decProducers.id;
        const growthAnalysisPeriod = isIncDecProducers ? currentTabState?.producers?.growthTimeFrame?.value : currentTabState?.growthAnalysisPeriod?.value;
        return {
            currentTabId: currentTabId,
            searchOptions: searchOptions,
            growthAnalysisPeriod: growthAnalysisPeriod,
            setSearchFilterState: setSearchFilterState,
            selectedListingViewId: currentTabState?.display.selectedView.value,
            currentTimeFrame: currentTabState?.producers?.timeFrame?.value
        };
    });
    const hasResults = (0, $fVDYX.getHasResults)(suggestedAgentsState?.rowDataByTab[currentTabId]);
    const [state, setState] = (0, $acw62.useState)({
        shouldShowPopoverById: {
            [(0, $9QX0f.popoverIds).display]: false,
            [(0, $9QX0f.popoverIds).metrics]: false,
            [(0, $9QX0f.popoverIds).producers]: false,
            [(0, $9QX0f.popoverIds).growthAnalysisPeriod]: false
        }
    });
    const togglePopover = (popoverId)=>{
        setState((prevState)=>({
                ...prevState,
                shouldShowPopoverById: {
                    ...prevState.shouldShowPopoverById,
                    [popoverId]: !prevState.shouldShowPopoverById[popoverId]
                }
            }));
    };
    const isIncOrDecProducersTab = currentTabId === (0, $9QX0f.tabs).incProducers.id || currentTabId === (0, $9QX0f.tabs).decProducers.id;
    const setGrowthAnalysisPeriod = (period)=>setSearchFilterState(period, (0, $9QX0f.filterIds).growthAnalysisPeriod, (0, $9QX0f.searchfilterStateId).value);
    (0, $acw62.useEffect)(()=>{
        if (isIncOrDecProducersTab) setGrowthAnalysisPeriod((0, $9QX0f.timeFrameToGrowthPeriod)[currentTimeFrame]);
    }, [
        isIncOrDecProducersTab
    ]);
    const handleExportCsv = ()=>(0, $ba4fc233a0a159d1$export$6a3b3e40f9ef1478)({
            ...suggestedAgentsState,
            growthAnalysisPeriod: growthAnalysisPeriod,
            listingProfColumns: suggestedAgentsState.listingProficiencyColumns,
            timeIntervals: timeIntervals
        }, setSuggestedAgentsState, selectedListingViewId, suggestedAgentsState.rowDataByTab[currentTabId].results, currentTabId);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "d-flex justify-content-center align-items-center px-2",
        children: [
            (0, $e664c7e6c3d24385$export$43ba060dea08ae12)({
                tabKey: currentTabId,
                shouldShowPopoverById: state.shouldShowPopoverById,
                togglePopover: togglePopover,
                searchOptions: searchOptions,
                growthAnalysisPeriod: growthAnalysisPeriod,
                setGrowthAnalysisPeriod: setGrowthAnalysisPeriod,
                setState: setSuggestedAgentsState,
                suggestedAgentsState: suggestedAgentsState,
                hasResults: hasResults,
                tableSettings: tableSettings,
                selectedListingViewId: selectedListingViewId
            }),
            hasResults && /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                color: "secondary",
                dataLwtId: "suggested-agents-download-btn",
                id: "suggested-agents-download-btn",
                size: "sm",
                onClick: handleExportCsv,
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "d-flex align-items-center",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                            icon: (0, $eOjgM.inbox),
                            className: "mr-2"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "text-capitalize",
                            children: (0, $cstaF.buttonTerms).download
                        })
                    ]
                })
            })
        ]
    });
};
$6de7e6f34ab2a8a5$export$1b965fa6b537eae3.propTypes = {
    setSuggestedAgentsState: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    suggestedAgentsState: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    tableSettings: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};


const $86502fed282e9eb2$export$b588262edeb4b32f = ({ setState: setState, state: state, tabDescription: tabDescription, tabTitle: tabTitle, tableSettings: tableSettings })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "py-2 d-flex justify-content-between align-items-center",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "d-flex flex-column search-row-header",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                        className: "title-row text-truncate text-capitalize mb-0 font-gray-primary",
                        children: tabTitle
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "mr-1 font-gray-primary tab-description",
                        children: tabDescription
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6de7e6f34ab2a8a5$export$1b965fa6b537eae3), {
                setSuggestedAgentsState: setState,
                suggestedAgentsState: state,
                tableSettings: tableSettings
            })
        ]
    });
};
$86502fed282e9eb2$export$b588262edeb4b32f.propTypes = {
    setState: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    state: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    tabTitle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    tabDescription: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    tableSettings: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};



var $fVDYX = parcelRequire("fVDYX");

var $90ISC = parcelRequire("90ISC");

var $aypMh = parcelRequire("aypMh");

var $jilhO = parcelRequire("jilhO");

var $9QX0f = parcelRequire("9QX0f");



const $bf2e71c2e8fcb319$export$59fd058eaac8b5f9 = (props)=>{
    const { tableSettings: tableSettings, gridRef: gridRef, rowData: rowData = [], setState: setState, state: state } = props;
    const { timeIntervals: timeIntervals } = (0, $90ISC.useCommonStore)((state)=>({
            timeIntervals: state.timeIntervals
        }));
    const { currentInactivityPeriod: currentInactivityPeriod, currentTabId: currentTabId, currentTabIndex: currentTabIndex, currentTabTimePeriod: currentTabTimePeriod, currentTabProducers: currentTabProducers, highProducingAgents: highProducingAgents, selectedListingViewId: selectedListingViewId, summaryPinnedData: summaryPinnedData, tabDescription: tabDescription, setTabDescription: setTabDescription, minGrowth: minGrowth, maxGrowth: maxGrowth, growthAnalysisPeriod: growthAnalysisPeriod } = (0, $90ISC.useSearchStore)((state)=>{
        const moduleState = state[state.selectedModule];
        const { currentTabId: currentTabId, searchOptions: searchOptions } = moduleState;
        const currentTabState = searchOptions?.[currentTabId];
        const { display: display, producers: producers } = currentTabState;
        const selectedListingViewId = display.selectedView.value;
        const isGrowthAnalysisView = selectedListingViewId === (0, $aypMh.views).growthAnalysis;
        const currentTabTimePeriod = (0, $fVDYX.getCurrentTabTimePeriod)(producers, isGrowthAnalysisView);
        const currentInactivityPeriod = producers?.inactivity?.label || null;
        const highProducingAgents = state.selectedFilterValues?.[currentTabId]?.lowPos?.label || producers?.lowPos?.label;
        const isIncDecProducers = currentTabId === (0, $9QX0f.tabs).incProducers.id || currentTabId === (0, $9QX0f.tabs).decProducers.id;
        return {
            currentInactivityPeriod: currentInactivityPeriod,
            currentTabId: currentTabId,
            currentTabIndex: moduleState?.currentTabIndex,
            currentTabTimePeriod: currentTabTimePeriod,
            currentTabProducers: producers,
            selectedListingViewId: selectedListingViewId,
            summaryPinnedData: moduleState?.summaryPinnedData,
            highProducingAgents: highProducingAgents,
            tabDescription: currentTabState?.tabDescription || "",
            setTabDescription: state.setTabDescription,
            minGrowth: producers?.minGrowth,
            maxGrowth: producers?.maxGrowth,
            growthAnalysisPeriod: isIncDecProducers ? producers?.growthTimeFrame?.value : currentTabState?.growthAnalysisPeriod?.value
        };
    });
    const handleDownload = (selectedAgents)=>{
        (0, $ba4fc233a0a159d1$export$6a3b3e40f9ef1478)({
            ...state,
            listingProfColumns: state.listingProficiencyColumns,
            timeIntervals: timeIntervals,
            growthAnalysisPeriod: growthAnalysisPeriod
        }, setState, selectedListingViewId, selectedAgents, currentTabId);
    };
    const { selectedCount: selectedCount, showAddToListModal: showAddToListModal, setShowAddToListModal: setShowAddToListModal, handleDownloadClick: handleDownloadClick, handleDismiss: handleDismiss } = (0, $14b4389b323bef2f$export$2bf58a042e4e0b44)(gridRef, handleDownload);
    const revisedRowDataByTab = (0, $fVDYX.getTabFilters)(rowData, currentTabProducers)?.[currentTabId] ?? rowData;
    const shouldShowPinnedRow = [
        (0, $aypMh.views).overview,
        (0, $aypMh.views).listingProficiency
    ].includes(selectedListingViewId);
    const summaryPinnedConfig = (0, $jilhO.getSummaryPinnedConfig)(selectedListingViewId);
    const hasResults = (0, $fVDYX.getHasResults)(state?.rowDataByTab[currentTabId]);
    const tabTitle = Object.values((0, $9QX0f.tabs)).map((tab)=>tab.label)[currentTabIndex];
    (0, $acw62.useEffect)(()=>{
        const tabDescription = (0, $fVDYX.getTabDescription)(currentTabId, {
            inactivityPeriod: currentInactivityPeriod,
            timePeriod: currentTabTimePeriod?.label,
            highProducingAgents: highProducingAgents,
            minGrowth: minGrowth,
            maxGrowth: maxGrowth
        });
        setTabDescription(tabDescription);
    }, []);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "pt-3",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $86502fed282e9eb2$export$b588262edeb4b32f), {
                ...hasResults && {
                    tabDescription: tabDescription
                },
                tabTitle: tabTitle,
                tabKey: currentTabId,
                setState: setState,
                state: state,
                tableSettings: tableSettings,
                selectedListingViewId: selectedListingViewId,
                growthAnalysisPeriod: growthAnalysisPeriod
            }),
            hasResults ? /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "suggested-agents-table",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l05Px.default), {
                        additionalTableHeaders: tableSettings?.additionalTableHeaders,
                        columns: tableSettings?.columns,
                        externalParams: shouldShowPinnedRow && {
                            summaryPinnedConfig: summaryPinnedConfig
                        },
                        gridRef: gridRef,
                        pinnedBottomRowData: shouldShowPinnedRow ? [
                            {
                                ...summaryPinnedData
                            }
                        ] : [],
                        rowData: revisedRowDataByTab,
                        tableTitleWithTooltips: tableSettings?.tooltips,
                        tableView: tableSettings?.tableView,
                        rowSelection: "multiple",
                        suppressRowClickSelection: true,
                        rowMultiSelectWithClick: true
                    }, tableSettings?.tableView),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0eb783070ef68771$export$2e2bcd8739ae039), {
                        selectedCount: selectedCount,
                        showAddToListModal: showAddToListModal,
                        setShowAddToListModal: setShowAddToListModal,
                        onDismiss: handleDismiss,
                        onDownloadClick: handleDownloadClick
                    })
                ]
            }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "sugg-agents-no-results d-flex justify-content-center align-items-center",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "text-center",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                            children: (0, $9QX0f.terms).noTabResultsFound(tabTitle)
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "font-gray-primary",
                            children: (0, $9QX0f.terms).adjustFilters
                        })
                    ]
                })
            })
        ]
    });
};
$bf2e71c2e8fcb319$export$59fd058eaac8b5f9.propTypes = {
    tableSettings: (0, $c9Z8w.PropTypes).object,
    gridRef: (0, $c9Z8w.PropTypes).object,
    rowData: (0, $c9Z8w.PropTypes).array,
    setState: (0, $c9Z8w.PropTypes).func,
    state: (0, $c9Z8w.PropTypes).object
};



var $acw62 = parcelRequire("acw62");

var $iCDWi = parcelRequire("iCDWi");

var $ivaD7 = parcelRequire("ivaD7");

var $90ISC = parcelRequire("90ISC");

var $fPGDZ = parcelRequire("fPGDZ");


var $i1BZc = parcelRequire("i1BZc");

var $8E8vr = parcelRequire("8E8vr");

var $cstaF = parcelRequire("cstaF");

var $9QX0f = parcelRequire("9QX0f");

var $aypMh = parcelRequire("aypMh");
const $5a0ca2dd63367f84$export$13536ee55f1995a1 = ()=>{
    const { timeIntervals: timeIntervals, clearAgentListPopover: clearAgentListPopover } = (0, $90ISC.useCommonStore)((state)=>({
            timeIntervals: state.timeIntervals,
            clearAgentListPopover: state.clearAgentListPopover
        }));
    const { currentTabId: currentTabId, selectedMls: selectedMls, selectedTimePeriod: selectedTimePeriod, setSuggestedAgentsData: setSuggestedAgentsData, setSummaryPinnedData: setSummaryPinnedData, selectedListingViewId: selectedListingViewId, moduleState: moduleState } = (0, $90ISC.useSearchStore)((state)=>{
        const moduleState = state[state.selectedModule];
        const currentTabId = moduleState?.currentTabId;
        const currentTabState = moduleState?.searchOptions?.[currentTabId];
        const selectedListingViewId = currentTabState?.display.selectedView.value;
        const isGrowthAnalysisView = selectedListingViewId === (0, $aypMh.views).growthAnalysis;
        const selectedTimePeriod = (0, $iCDWi.getCurrentTabTimePeriod)(currentTabState?.producers, isGrowthAnalysisView);
        return {
            currentTabId: currentTabId,
            selectedMls: currentTabState?.producers?.mls || moduleState?.selectedMls,
            selectedTimePeriod: selectedTimePeriod,
            setSuggestedAgentsData: state.setSuggestedAgentsData,
            setSummaryPinnedData: state.setSummaryPinnedData,
            selectedListingViewId: selectedListingViewId,
            moduleState: moduleState
        };
    });
    const gridRef = (0, $acw62.useRef)();
    const restrictedMlsSettings = (0, $fPGDZ.getMlsRestrictionSettings)(selectedMls?.mlsId);
    const initialState = {
        rowDataByTab: {
            [(0, $9QX0f.tabs).topProducers.id]: {
                totals: undefined,
                results: undefined
            },
            [(0, $9QX0f.tabs).newProducers.id]: {
                totals: undefined,
                results: undefined
            },
            [(0, $9QX0f.tabs).incProducers.id]: {
                totals: undefined,
                results: undefined
            },
            [(0, $9QX0f.tabs).decProducers.id]: {
                totals: undefined,
                results: undefined
            },
            [(0, $9QX0f.tabs).coopAgents.id]: {
                totals: undefined,
                results: undefined
            }
        },
        currentSearchDates: (0, $iCDWi.getCurrentSearchDates)(timeIntervals, selectedTimePeriod),
        overviewColumns: (0, $fPGDZ.getDefaultOverviewColumns)(),
        newProducersOverviewColumns: (0, $fPGDZ.getDefaultOverviewColumns)(true),
        coopAgentsOverviewColumns: (0, $fPGDZ.getDefaultOverviewColumns)(false, false, true),
        incDecOverviewColumns: (0, $fPGDZ.getDefaultOverviewColumns)(false, true),
        contactInfoColumns: (0, $fPGDZ.getDefaultContactInfoColumns)(restrictedMlsSettings),
        newProducersContactInfoColumns: (0, $fPGDZ.getDefaultContactInfoColumns)(restrictedMlsSettings, true),
        listingProficiencyColumns: (0, $2292da915057cb56$export$7aa1788812152cb5)(),
        growthAnalysisColumnsLtm: (0, $8E8vr.getDefaultGrowthAnalysisColumnsLtm)(),
        growthAnalysisColumnsYtd: (0, $8E8vr.getDefaultGrowthAnalysisColumnsYtd)(),
        growthAnalysisColumnsL90: (0, $8E8vr.getDefaultGrowthAnalysisColumnsL90)(),
        growthAnalysisColumnsLtmIncDec: (0, $8E8vr.getDefaultGrowthAnalysisColumnsLtmIncDec)(),
        growthAnalysisColumnsYtdIncDec: (0, $8E8vr.getDefaultGrowthAnalysisColumnsYtdIncDec)(),
        selectedFilterValues: {},
        propertyTypeNames: [],
        validationSettings: {}
    };
    const [state, setState] = (0, $acw62.useState)(initialState);
    const currentTabData = state.rowDataByTab[currentTabId];
    (0, $acw62.useEffect)(()=>{
        (0, $ivaD7.setStateData)("currentSearchDates", (0, $iCDWi.getCurrentSearchDates)(timeIntervals, selectedTimePeriod), setState);
    }, [
        timeIntervals,
        selectedTimePeriod
    ]);
    (0, $acw62.useEffect)(()=>{
        clearAgentListPopover();
        if (!selectedMls?.mlsId || moduleState.id !== (0, $cstaF.modules).proficiencyMetrics.suggestedAgents) return;
        (0, $ivaD7.setStateData)("currentSearchDates", (0, $iCDWi.getCurrentSearchDates)(timeIntervals, selectedTimePeriod), setState);
        if (currentTabData?.results !== undefined) return;
        setSuggestedAgentsData({
            mlsId: selectedMls?.mlsId,
            setState: setState,
            currentTabId: currentTabId
        });
    }, [
        selectedMls?.mlsId,
        currentTabId,
        timeIntervals
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!selectedMls?.mlsId) return;
        setSummaryPinnedData(selectedListingViewId, (0, $i1BZc.responseKeys).recruitingSoldTotals, currentTabData?.totals);
        setState((state)=>({
                ...state,
                contactInfoColumns: (0, $fPGDZ.getDefaultContactInfoColumns)(restrictedMlsSettings)
            }));
    }, [
        selectedListingViewId,
        selectedMls?.mlsId,
        currentTabId,
        currentTabData
    ]);
    (0, $acw62.useEffect)(()=>setState(initialState), [
        selectedMls?.mlsId
    ]);
    return {
        gridRef: gridRef,
        state: state,
        setState: setState
    };
};



var $4tbBr = parcelRequire("4tbBr");

var $ivaD7 = parcelRequire("ivaD7");

var $cstaF = parcelRequire("cstaF");

var $90ISC = parcelRequire("90ISC");


var $eHBjM = parcelRequire("eHBjM");

var $aypMh = parcelRequire("aypMh");


var $9QX0f = parcelRequire("9QX0f");

var $fPGDZ = parcelRequire("fPGDZ");

var $5269x = parcelRequire("5269x");
const $f22a7abd90352299$export$cfee0069488e0cdc = ({ state: state, setState: setState, growthAnalysisPeriod: growthAnalysisPeriod, currentTabId: currentTabId, selectedListingViewId: selectedListingViewId })=>{
    const isCoopAgents = currentTabId === (0, $9QX0f.tabs).coopAgents.id;
    const timeIntervals = (0, $90ISC.useCommonStore)((state)=>state.timeIntervals);
    const last12MonthsDates = timeIntervals?.length && (0, $0143275b912eedd1$export$776d48afc537e43d)(timeIntervals, (0, $cstaF.agentProductionTerms).annually);
    const dateRangesText = {
        currentSearch: (0, $5269x.getDateRangeText)(last12MonthsDates),
        allMls: (0, $5269x.getDateRangeText)(last12MonthsDates)
    };
    const setOverviewColumns = (overviewColumns)=>{
        (0, $ivaD7.setStateData)("overviewColumns", overviewColumns, setState);
    };
    const setNewProducersOverviewColumns = (newProducersOverviewColumns)=>{
        (0, $ivaD7.setStateData)("newProducersOverviewColumns", newProducersOverviewColumns, setState);
    };
    const setCoopAgentsOverviewColumns = (coopAgentsOverviewColumns)=>{
        (0, $ivaD7.setStateData)("coopAgentsOverviewColumns", coopAgentsOverviewColumns, setState);
    };
    const setOverviewColumnsIncDec = (incDecOverviewColumns)=>{
        (0, $ivaD7.setStateData)("incDecOverviewColumns", incDecOverviewColumns, setState);
    };
    const setContactInfoColumns = (contactInfoColumns)=>{
        (0, $ivaD7.setStateData)("contactInfoColumns", contactInfoColumns, setState);
    };
    const setNewProducersContactInfoColumns = (newProducersContactInfoColumns)=>{
        (0, $ivaD7.setStateData)("newProducersContactInfoColumns", newProducersContactInfoColumns, setState);
    };
    const setGrowthAnalysisColumnsYtd = (growthAnalysisColumnsYtd)=>{
        (0, $ivaD7.setStateData)("growthAnalysisColumnsYtd", growthAnalysisColumnsYtd, setState);
    };
    const setGrowthAnalysisColumnsLtm = (growthAnalysisColumnsLtm)=>{
        (0, $ivaD7.setStateData)("growthAnalysisColumnsLtm", growthAnalysisColumnsLtm, setState);
    };
    const setGrowthAnalysisColumnsL90 = (growthAnalysisColumnsL90)=>{
        (0, $ivaD7.setStateData)("growthAnalysisColumnsL90", growthAnalysisColumnsL90, setState);
    };
    const setGrowthAnalysisColumnsLtmIncDec = (growthAnalysisColumnsLtmIncDec)=>{
        (0, $ivaD7.setStateData)("growthAnalysisColumnsLtmIncDec", growthAnalysisColumnsLtmIncDec, setState);
    };
    const setGrowthAnalysisColumnsYtdIncDec = (growthAnalysisColumnsYtdIncDec)=>{
        (0, $ivaD7.setStateData)("growthAnalysisColumnsYtdIncDec", growthAnalysisColumnsYtdIncDec, setState);
    };
    const setListingProficiencyColumns = (listingProficiencyColumns)=>{
        (0, $ivaD7.setStateData)("listingProficiencyColumns", listingProficiencyColumns, setState);
    };
    const isIncDecProducers = currentTabId === (0, $9QX0f.tabs).incProducers.id || currentTabId === (0, $9QX0f.tabs).decProducers.id;
    const growthAnalysisTableSettings = {
        [(0, $cstaF.TimePeriods)[(0, $cstaF.agentProductionTerms).annually]]: {
            additionalTableHeaders: (0, $42d942163c9a4de3$export$76e7236166af5295)(state.growthAnalysisColumnsLtm),
            className: "growth-analysis",
            columns: isIncDecProducers ? state.growthAnalysisColumnsLtmIncDec : state.growthAnalysisColumnsLtm,
            tableView: isIncDecProducers ? (0, $4tbBr.tableViews).incDecGrowthAnalysisLtm : (0, $4tbBr.tableViews).growthAnalysisLtm,
            tooltips: (0, $eHBjM.incDecLtmGrowthAnalysisTooltips),
            setColumns: isIncDecProducers ? setGrowthAnalysisColumnsLtmIncDec : setGrowthAnalysisColumnsLtm
        },
        [(0, $cstaF.TimePeriods)[(0, $cstaF.agentProductionTerms).YTD]]: {
            additionalTableHeaders: (0, $42d942163c9a4de3$export$76e7236166af5295)(state.growthAnalysisColumnsYtd),
            className: "growth-analysis",
            columns: isIncDecProducers ? state.growthAnalysisColumnsYtdIncDec : state.growthAnalysisColumnsYtd,
            tableView: isIncDecProducers ? (0, $4tbBr.tableViews).incDecGrowthAnalysisYtd : (0, $4tbBr.tableViews).growthAnalysisYtd,
            tooltips: (0, $eHBjM.incDecYtdGrowthAnalysisTooltips),
            setColumns: isIncDecProducers ? setGrowthAnalysisColumnsYtdIncDec : setGrowthAnalysisColumnsYtd
        },
        [(0, $cstaF.TimePeriods)[(0, $cstaF.agentProductionTerms).last90Days]]: {
            additionalTableHeaders: (0, $42d942163c9a4de3$export$76e7236166af5295)(state.growthAnalysisColumnsL90),
            className: "growth-analysis",
            columns: state.growthAnalysisColumnsL90,
            tableView: (0, $4tbBr.tableViews).growthAnalysisL90,
            tooltips: (0, $eHBjM.growthAnalysisTooltipsL90d),
            setColumns: setGrowthAnalysisColumnsL90
        }
    }?.[growthAnalysisPeriod];
    const headerParentsToRemove = (0, $9QX0f.headerParentIndexesToRemoveByTabAndView)?.[currentTabId]?.[selectedListingViewId];
    const isNewProducers = currentTabId === (0, $9QX0f.tabs).newProducers.id;
    const getOverviewColumns = ()=>{
        if (isNewProducers) return state.newProducersOverviewColumns;
        if (isCoopAgents) return state.coopAgentsOverviewColumns;
        if (isIncDecProducers) return state.incDecOverviewColumns;
        return state.overviewColumns;
    };
    const getOverviewTableView = ()=>{
        if (isCoopAgents) return (0, $4tbBr.tableViews).overviewCoopAgents;
        if (isIncDecProducers) return (0, $4tbBr.tableViews).incDecOverview;
        return (0, $4tbBr.tableViews).overview;
    };
    const getOverviewSetColumns = ()=>{
        if (isNewProducers) return setNewProducersOverviewColumns;
        if (isCoopAgents) return setCoopAgentsOverviewColumns;
        if (isIncDecProducers) return setOverviewColumnsIncDec;
        return setOverviewColumns;
    };
    const tableSettings = {
        [(0, $aypMh.views).overview]: {
            additionalTableHeaders: (0, $42d942163c9a4de3$export$54862a28ed3d9ca)(state.overviewColumns, state.rowDataByTab[currentTabId]?.results?.length, dateRangesText, isCoopAgents && (0, $cstaF.agentProductionTerms).recentCoopTransactions, (0, $eHBjM.overviewToolTipsSA)),
            className: "overview",
            columns: getOverviewColumns(),
            tableView: (0, $fPGDZ.getTableViewConfig)(getOverviewTableView(), headerParentsToRemove),
            tooltips: (0, $eHBjM.overviewToolTipsSA),
            setColumns: getOverviewSetColumns()
        },
        [(0, $aypMh.views).contactInformation]: {
            additionalTableHeaders: (0, $42d942163c9a4de3$export$4b5edb945bac761c)(state.contactInfoColumns, dateRangesText, (0, $eHBjM.contactToolTipsSA)),
            className: "contact-information",
            columns: isNewProducers ? state.newProducersContactInfoColumns : state.contactInfoColumns,
            tableView: (0, $fPGDZ.getTableViewConfig)((0, $4tbBr.tableViews).contactInformation, headerParentsToRemove),
            tooltips: (0, $eHBjM.contactToolTipsSA),
            setColumns: isNewProducers ? setNewProducersContactInfoColumns : setContactInfoColumns
        },
        [(0, $aypMh.views).growthAnalysis]: growthAnalysisTableSettings,
        [(0, $aypMh.views).listingProficiency]: {
            additionalTableHeaders: (0, $42d942163c9a4de3$export$e96f0ad03a836f4a)(state.listingProficiencyColumns, (0, $eHBjM.listingProficiencyTooltipsSA)),
            className: "listing-proficiency",
            columns: state.listingProficiencyColumns,
            tableView: (0, $4tbBr.tableViews).listingProficiency,
            tooltips: (0, $eHBjM.listingProficiencyTooltipsSA),
            setColumns: setListingProficiencyColumns
        }
    };
    return tableSettings?.[selectedListingViewId];
};



var $aypMh = parcelRequire("aypMh");

var $fVDYX = parcelRequire("fVDYX");

var $cstaF = parcelRequire("cstaF");
parcelRequire("amkL4");
var $3QXz5 = parcelRequire("3QXz5");


var $f61ig = parcelRequire("f61ig");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7tOHe = parcelRequire("7tOHe");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $dI25G = parcelRequire("dI25G");

var $ajR31 = parcelRequire("ajR31");

var $eOjgM = parcelRequire("eOjgM");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


var $c9Z8w = parcelRequire("c9Z8w");

var $9QX0f = parcelRequire("9QX0f");
const $6a10eb099137b438$var$getBarColorClass = (activeLevel, barLevel)=>{
    const levels = {
        low: 0,
        medium: 1,
        high: 2
    };
    const activeIndex = levels[activeLevel];
    const barIndex = levels[barLevel];
    if (barIndex > activeIndex) return null;
    const distance = activeIndex - barIndex;
    if (distance === 0) return "likelihood-chart-bar--brand";
    if (distance === 1) return "likelihood-chart-bar--brand-light";
    return "likelihood-chart-bar--brand-alt-light";
};
const $6a10eb099137b438$export$f30c43bca34845b = ({ likelihood: likelihood })=>{
    const activeLevel = likelihood?.toLowerCase();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "helix-text-gray-500 likelihood-chart-title m-0",
                children: (0, $9QX0f.todaysPicksTerms).likelihoodChartTitle
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "helix-d-flex helix-align--end likelihood-chart-container",
                children: [
                    "low",
                    "medium",
                    "high"
                ].map((level)=>{
                    const colorClass = $6a10eb099137b438$var$getBarColorClass(activeLevel, level);
                    const isCurrentLevel = level === activeLevel;
                    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "helix-d-flex helix-flex--column helix-align--center helix-flex-1",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("likelihood-chart-bar", `likelihood-chart-bar--${level}`, colorClass ?? "likelihood-chart-bar--inactive")
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("helix-mt-1 likelihood-chart-label", isCurrentLevel ? "helix-text-gray-900" : "helix-text-gray-400"),
                                children: (0, $9QX0f.todaysPicksTerms)[level]
                            })
                        ]
                    }, level);
                })
            })
        ]
    });
};
$6a10eb099137b438$export$f30c43bca34845b.propTypes = {
    likelihood: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "low",
        "medium",
        "high"
    ]).isRequired
};
var $6a10eb099137b438$export$2e2bcd8739ae039 = $6a10eb099137b438$export$f30c43bca34845b;



var $htzEo = parcelRequire("htzEo");

var $cstaF = parcelRequire("cstaF");

var $9QX0f = parcelRequire("9QX0f");
const $2df953c0f20c1302$export$70fe97b3a32f293f = ({ agent: agent })=>{
    const fullName = `${agent.firstName} ${agent.lastName}`;
    const projectedRange = (0, $9QX0f.todaysPicksTerms).projectedRange(agent.projectedVolumeMin, agent.projectedVolumeMax);
    const projectedUnitsRange = (0, $9QX0f.todaysPicksTerms).projectedUnitsRange(agent.projectedUnitsMin, agent.projectedUnitsMax);
    const volumeFormatted = `${(0, $htzEo.getCurrencyFormat)(agent.volume)}`;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "helix-card helix-h-100-percent helix-overflow--hidden helix-position--relative p-2",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                className: "todays-picks-add-btn",
                type: "button",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                    icon: (0, $ajR31.add)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "helix-d-flex helix-flex--column helix-gap-3 helix-p-3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "helix-d-flex helix-flex--column mb-2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "helix-text-gray-900 helix-line-clamp-1 todays-picks-agent-name",
                                children: fullName
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "helix-text-gray-500 helix-line-clamp-1 helix-text--hint helix-small",
                                children: agent.officeName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6a10eb099137b438$export$f30c43bca34845b), {
                        likelihood: agent.likelihoodOfMovement
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "helix-d-flex mt-2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "helix-d-flex helix-flex--column helix-align--center todays-picks-stat-col",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "helix-text-gray-500 todays-picks-label",
                                        children: (0, $9QX0f.todaysPicksTerms).volume
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "helix-text-gray-900 todays-picks-value",
                                        children: volumeFormatted
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                className: "helix-d-flex helix-flex--column helix-align--center todays-picks-stat-col",
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "helix-text-gray-500 todays-picks-label",
                                        children: (0, $9QX0f.todaysPicksTerms).units
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "helix-text-gray-900 todays-picks-value",
                                        children: agent.units ?? (0, $cstaF.agentProductionTerms).notApplicableAbbrv
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "todays-picks-divider"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "helix-d-flex helix-justify--center helix-text-gray-500 todays-picks-label",
                        children: (0, $9QX0f.todaysPicksTerms).eoyPerformanceProjections
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "helix-d-flex",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "helix-d-flex helix-flex--column helix-align--center todays-picks-stat-col",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    className: "helix-badge helix-badge--secondary-inverted helix-small",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                                            icon: (0, $eOjgM.sparkle),
                                            className: "helix-svg-fill--brand"
                                        }),
                                        projectedRange
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "helix-d-flex helix-flex--column helix-align--center todays-picks-stat-col",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                    className: "helix-badge helix-badge--secondary-inverted helix-small",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                                            icon: (0, $eOjgM.sparkle),
                                            className: "helix-svg-fill--brand"
                                        }),
                                        projectedUnitsRange
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
$2df953c0f20c1302$export$70fe97b3a32f293f.propTypes = {
    agent: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $2df953c0f20c1302$export$2e2bcd8739ae039 = $2df953c0f20c1302$export$70fe97b3a32f293f;



var $8QuU9 = parcelRequire("8QuU9");

var $9QX0f = parcelRequire("9QX0f");
const $05aff448789b0cea$export$ec5a714b701e74c1 = ()=>{
    const [agents, setAgents] = (0, $acw62.useState)([]);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(true);
    const [error, setError] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        setIsLoading(true);
        (0, $8QuU9.getTodaysPicks)().then(({ error: error, results: results })=>{
            error ? setError(error) : setAgents(results || []);
        }).catch((err)=>setError(err.message)).finally(()=>setIsLoading(false));
    }, []);
    const renderCenteredMessage = (title, body, isLoading)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "helix-d-flex helix-justify--center helix-align--center helix-py-5",
            children: isLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {}) : /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "helix-text--center",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                        className: "helix-text-gray-900",
                        children: title
                    }),
                    body && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "helix-text-gray-500",
                        children: body
                    })
                ]
            })
        });
    if (isLoading) return renderCenteredMessage(null, null, true);
    if (!agents.length) return renderCenteredMessage((0, $9QX0f.todaysPicksTerms).noTodaysPicksTitle, (0, $9QX0f.todaysPicksTerms).noTodaysPicksBody);
    //TODO: Add if needed after further discussion
    if (error) return renderCenteredMessage((0, $9QX0f.todaysPicksTerms).failedLoad, error);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "helix-pt-3",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "todays-picks-grid",
            children: agents.map((agent)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $2df953c0f20c1302$export$70fe97b3a32f293f), {
                    agent: agent
                }, agent.agentId))
        })
    });
};
var $05aff448789b0cea$export$2e2bcd8739ae039 = $05aff448789b0cea$export$ec5a714b701e74c1;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $f61ig = parcelRequire("f61ig");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $4TPr9 = parcelRequire("4TPr9");

var $9QX0f = parcelRequire("9QX0f");

var $cstaF = parcelRequire("cstaF");

var $90ISC = parcelRequire("90ISC");

var $5269x = parcelRequire("5269x");

var $aYbF1 = parcelRequire("aYbF1");

var $cstaF = parcelRequire("cstaF");


var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $9GSMu = parcelRequire("9GSMu");
var $eA2p4 = parcelRequire("eA2p4");
var $kXn8S = parcelRequire("kXn8S");

var $9QX0f = parcelRequire("9QX0f");

var $cstaF = parcelRequire("cstaF");

var $5269x = parcelRequire("5269x");

const $03691ab5ec41c43b$var$PropertyTypeDropdown = ({ mlsPropertyTypes: mlsPropertyTypes, selectedPropertyTypes: selectedPropertyTypes, onPropertyTypesChange: onPropertyTypesChange, onRegisterClose: onRegisterClose })=>{
    const [isPropertyTypeOpen, setIsPropertyTypeOpen] = (0, $acw62.useState)(false);
    const hasPropertyTypes = mlsPropertyTypes.length > 0;
    const buttonLabel = (0, $acw62.useMemo)(()=>{
        const selectedAsStrings = selectedPropertyTypes.map((id)=>id.toString());
        return (0, $5269x.getPropertyTypeTitle)(mlsPropertyTypes, selectedAsStrings).mainTitle;
    }, [
        selectedPropertyTypes,
        mlsPropertyTypes
    ]);
    const toggle = ()=>setIsPropertyTypeOpen((prev)=>!prev);
    onRegisterClose?.(()=>setIsPropertyTypeOpen(false));
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $9GSMu.default), {
        isOpen: isPropertyTypeOpen,
        toggle: toggle,
        className: "w-100",
        inNavbar: true,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kXn8S.default), {
                id: "prop-type-btn",
                dataLwtId: "edit-criteria-property-types",
                tag: "button",
                type: "button",
                className: `prop-type-btn btn btn-outline-secondary w-100 text-left d-flex justify-content-between align-items-center ${isPropertyTypeOpen ? "is-open" : ""}`,
                disabled: !hasPropertyTypes,
                caret: true,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: selectedPropertyTypes?.length ? "" : "text-muted",
                    children: buttonLabel
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $eA2p4.default), {
                className: "w-100 p-2 mt-2 border no-transition",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                        className: "d-block mb-2",
                        children: (0, $9QX0f.editCriteriaTerms).propertyTypesLabel
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f0cfd8232f8220cd$export$2e2bcd8739ae039), {
                        module: (0, $cstaF.modules).proficiencyMetrics.suggestedAgents,
                        initialPropTypes: selectedPropertyTypes.map((id)=>Number(id)),
                        setPropTypes: (ids)=>hasPropertyTypes && onPropertyTypesChange(ids),
                        toggleInvalid: ()=>{},
                        invalid: false,
                        propTypes: mlsPropertyTypes
                    })
                ]
            })
        ]
    });
};
$03691ab5ec41c43b$var$PropertyTypeDropdown.propTypes = {
    mlsPropertyTypes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array.isRequired,
    selectedPropertyTypes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array.isRequired,
    onPropertyTypesChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    onRegisterClose: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};
var $03691ab5ec41c43b$export$2e2bcd8739ae039 = $03691ab5ec41c43b$var$PropertyTypeDropdown;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");


var $4TPr9 = parcelRequire("4TPr9");

var $9QX0f = parcelRequire("9QX0f");
const $611708087d85719c$var$MenuList = ({ children: children })=>{
    const listRef = (0, $acw62.useRef)(null);
    const items = Array.isArray(children) ? children : [
        children
    ];
    const focusedIndex = items.findIndex((item)=>item.props?.isFocused);
    (0, $acw62.useEffect)(()=>{
        if (focusedIndex >= 0) listRef.current?.scrollToItem(focusedIndex);
    }, [
        focusedIndex
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $44fd68b3b250de87$export$ae9e55e1d8a2f4b7), {
        ref: listRef,
        height: Math.min((0, $9QX0f.areaSelectDropdown).maxMenuHeight, items.length * (0, $9QX0f.areaSelectDropdown).itemHeight),
        itemCount: items.length,
        itemSize: (0, $9QX0f.areaSelectDropdown).itemHeight,
        initialScrollOffset: Math.max(0, focusedIndex) * (0, $9QX0f.areaSelectDropdown).itemHeight,
        children: ({ index: index, style: style })=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                style: style,
                children: items[index]
            })
    });
};
$611708087d85719c$var$MenuList.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node
};
const $611708087d85719c$var$AreaSelectDropdown = ({ value: value, onChange: onChange, options: options, dataLwtId: dataLwtId, onMenuOpen: onMenuOpen, isDisabled: isDisabled })=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, $4TPr9.default), {
        dataLwtId: dataLwtId,
        value: value,
        onChange: onChange,
        options: options,
        components: {
            MenuList: $611708087d85719c$var$MenuList
        },
        isClearable: false,
        isDisabled: isDisabled,
        onMenuOpen: onMenuOpen
    });
$611708087d85719c$var$AreaSelectDropdown.propTypes = {
    value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    options: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array.isRequired,
    dataLwtId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    onMenuOpen: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
var $611708087d85719c$export$2e2bcd8739ae039 = $611708087d85719c$var$AreaSelectDropdown;


const $b20121513b16fece$var$EditCriteriaModal = ({ show: show, onClose: onClose })=>{
    const [formData, setFormData] = (0, $acw62.useState)({
        mls: null,
        timePeriod: null,
        volume: null,
        units: null,
        propertyTypes: null,
        areaType: null,
        area: null
    });
    const closeDropdownRef = (0, $acw62.useRef)(null);
    const { mlsProviders: mlsProviders, timeIntervals: timeIntervals } = (0, $90ISC.useCommonStore)((state)=>({
            mlsProviders: state.mlsProviders || [],
            timeIntervals: state.timeIntervals
        }));
    const mlsOptions = (0, $acw62.useMemo)(()=>{
        return mlsProviders.map((mls)=>({
                value: mls.mlsId,
                label: `${mls.shortDescription} (${mls.longDescription})`
            })).sort((a, b)=>a.label.localeCompare(b.label));
    }, [
        mlsProviders
    ]);
    const defaultMls = mlsOptions[0] || null;
    const selectedMls = formData.mls ?? defaultMls;
    const mlsProps = (0, $aa9764060f6e10ce$export$65c94bb0e14ddf31)(selectedMls?.value, (0, $cstaF.modules).proficiencyMetrics.suggestedAgents, {
        isSilentLoad: true
    });
    const mlsPropertyTypes = (0, $acw62.useMemo)(()=>mlsProps?.propTypes || [], [
        mlsProps?.propTypes
    ]);
    const areasByType = (0, $acw62.useMemo)(()=>mlsProps?.mappedAreas || {}, [
        mlsProps?.mappedAreas
    ]);
    const isMarketAreaLoading = !!selectedMls?.value && !mlsProps?.mappedAreas;
    const allPropertyTypeIds = (0, $acw62.useMemo)(()=>{
        return mlsPropertyTypes.flatMap((propertyType)=>propertyType.types?.map((t)=>Number(t.typeId)) || []);
    }, [
        mlsPropertyTypes
    ]);
    const timePeriodOptions = (0, $acw62.useMemo)(()=>{
        const options = selectedMls && mlsProviders && (0, $aYbF1.getTimePeriodsByModule)({
            module: (0, $cstaF.modules).proficiencyMetrics.suggestedAgents,
            selectedMlsId: selectedMls?.value,
            mlsMembershipList: mlsProviders
        });
        return options?.filter((opt)=>opt.value !== (0, $cstaF.TimePeriods)["Custom Date"]) || [];
    }, [
        selectedMls,
        mlsProviders
    ]);
    const defaultTimePeriod = timePeriodOptions.find((opt)=>opt.value === (0, $cstaF.agentProductionTerms).annually) || timePeriodOptions[0] || null;
    const selectedTimePeriod = formData.timePeriod ?? defaultTimePeriod;
    const selectedPropertyTypes = formData.propertyTypes ?? allPropertyTypeIds;
    const areaTypeOptions = (0, $acw62.useMemo)(()=>{
        return Object.entries(areasByType).filter(([, data])=>(data?.mappedAreas?.length ?? 0) > 0).map(([type])=>({
                value: type,
                label: type.charAt(0).toUpperCase() + type.slice(1)
            }));
    }, [
        areasByType
    ]);
    const defaultAreaType = areaTypeOptions.find((opt)=>opt.value === (0, $9QX0f.areaSelectDropdown).defaultAreaType) || areaTypeOptions[0] || null;
    const selectedAreaType = formData.areaType ?? defaultAreaType;
    const areaOptions = (0, $acw62.useMemo)(()=>{
        if (!selectedAreaType?.value) return [];
        const areas = areasByType[selectedAreaType.value]?.mappedAreas || [];
        return [
            ...areas
        ].sort((a, b)=>(b.soldCount ?? 0) - (a.soldCount ?? 0)).map((area)=>({
                value: area.areaValue,
                label: `${area.areaValue} (${(area.soldCount ?? 0).toLocaleString()})`,
                soldCount: area.soldCount
            }));
    }, [
        selectedAreaType,
        areasByType
    ]);
    const defaultArea = areaOptions[0] || null;
    const selectedArea = formData.area ?? defaultArea;
    const handleSelectChange = (field, value)=>{
        if (field === (0, $9QX0f.editCriteriaTerms).mlsKey) {
            setFormData((prev)=>({
                    ...prev,
                    [field]: value,
                    timePeriod: null,
                    propertyTypes: null,
                    areaType: null,
                    area: null
                }));
            return;
        }
        setFormData((prev)=>({
                ...prev,
                [field]: value
            }));
    };
    const handleAreaTypeChange = (value)=>{
        setFormData((prev)=>({
                ...prev,
                areaType: value,
                area: null
            }));
    };
    const handlePropertyTypesChange = (selectedPropertyTypes)=>{
        setFormData((prev)=>({
                ...prev,
                propertyTypes: selectedPropertyTypes.map((id)=>Number(id))
            }));
    };
    const handleSave = ()=>{
        onClose();
    };
    const handleCancel = ()=>{
        setFormData({
            mls: null,
            timePeriod: null,
            volume: null,
            units: null,
            propertyTypes: null,
            areaType: null,
            area: null
        });
        onClose();
    };
    const formatTimePeriodLabel = (option, { context: context })=>{
        if (context === "value" && timeIntervals) {
            const titleObj = (0, $5269x.getTimeFrameTitle)({
                intervalType: option.value
            }, timeIntervals);
            if (titleObj?.subtitle) return `${option.label}: ${titleObj.subtitle}`;
        }
        return option.label;
    };
    /**
     * Mock data for Edit Criteria Modal.
     * TODO: Replace with real data from store.
     */ const volumeOptions = [
        {
            value: "low",
            label: "0 - 1M"
        },
        {
            value: "medium",
            label: "1M - 5M"
        },
        {
            value: "high",
            label: "5M+"
        }
    ];
    const unitsOptions = [
        {
            value: "low",
            label: "0 - 10"
        },
        {
            value: "medium",
            label: "10 - 50"
        },
        {
            value: "high",
            label: "50+"
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f61ig.default), {
        dataLwtId: "edit-criteria-modal",
        show: show,
        onClose: onClose,
        title: (0, $9QX0f.editCriteriaTerms).editCriteria,
        size: "md",
        showFooter: true,
        buttons: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                    className: "helix-text-gray-500 text-dark",
                    onClick: handleCancel,
                    children: (0, $9QX0f.editCriteriaTerms).cancel
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                    className: "helix-bg-brand persist-bg text-white",
                    onClick: handleSave,
                    children: (0, $9QX0f.editCriteriaTerms).save
                })
            ]
        }),
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mb-3",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                            className: "d-block font-weight-bold mb-1",
                            children: (0, $9QX0f.editCriteriaTerms).mls
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4TPr9.default), {
                            dataLwtId: "edit-criteria-mls",
                            placeholder: (0, $9QX0f.editCriteriaTerms).selectMls,
                            value: selectedMls,
                            onChange: (value)=>handleSelectChange((0, $9QX0f.editCriteriaTerms).mlsKey, value),
                            options: mlsOptions,
                            isClearable: false,
                            onMenuOpen: ()=>closeDropdownRef.current?.()
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mb-3",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                            className: "d-block font-weight-bold mb-1",
                            children: (0, $9QX0f.editCriteriaTerms).marketArea
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "row gap-1",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "col-4",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4TPr9.default), {
                                        dataLwtId: "edit-criteria-area-type",
                                        value: selectedAreaType,
                                        onChange: handleAreaTypeChange,
                                        options: areaTypeOptions,
                                        isClearable: false,
                                        isDisabled: isMarketAreaLoading,
                                        onMenuOpen: ()=>closeDropdownRef.current?.()
                                    })
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "col-8",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $611708087d85719c$export$2e2bcd8739ae039), {
                                        dataLwtId: "edit-criteria-area",
                                        value: selectedArea,
                                        onChange: (value)=>handleSelectChange((0, $9QX0f.editCriteriaTerms).areaKey, value),
                                        options: areaOptions,
                                        isDisabled: isMarketAreaLoading,
                                        onMenuOpen: ()=>closeDropdownRef.current?.()
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mb-3",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                            className: "d-block font-weight-bold mb-1",
                            children: (0, $9QX0f.editCriteriaTerms).timePeriod
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4TPr9.default), {
                            dataLwtId: "edit-criteria-time-period",
                            placeholder: (0, $9QX0f.editCriteriaTerms).selectTimePeriod,
                            value: selectedTimePeriod,
                            onChange: (value)=>handleSelectChange((0, $9QX0f.editCriteriaTerms).timePeriodKey, value),
                            options: timePeriodOptions,
                            formatOptionLabel: formatTimePeriodLabel,
                            isClearable: false,
                            onMenuOpen: ()=>closeDropdownRef.current?.()
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "row mb-3",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "col-6",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    className: "d-block font-weight-bold mb-1",
                                    children: (0, $9QX0f.editCriteriaTerms).volume
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4TPr9.default), {
                                    dataLwtId: "edit-criteria-volume",
                                    placeholder: (0, $9QX0f.editCriteriaTerms).selectVolume,
                                    value: formData.volume,
                                    onChange: (value)=>handleSelectChange((0, $9QX0f.editCriteriaTerms).volumeKey, value),
                                    options: volumeOptions,
                                    isClearable: false,
                                    onMenuOpen: ()=>closeDropdownRef.current?.()
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "col-6",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                                    className: "d-block font-weight-bold mb-1",
                                    children: (0, $9QX0f.editCriteriaTerms).units
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4TPr9.default), {
                                    dataLwtId: "edit-criteria-units",
                                    placeholder: (0, $9QX0f.editCriteriaTerms).selectUnits,
                                    value: formData.units,
                                    onChange: (value)=>handleSelectChange((0, $9QX0f.editCriteriaTerms).unitsKey, value),
                                    options: unitsOptions,
                                    isClearable: false,
                                    onMenuOpen: ()=>closeDropdownRef.current?.()
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "mb-3",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("label", {
                            className: "d-block font-weight-bold mb-1",
                            children: (0, $9QX0f.editCriteriaTerms).propertyTypes
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03691ab5ec41c43b$export$2e2bcd8739ae039), {
                            mlsPropertyTypes: mlsPropertyTypes,
                            selectedPropertyTypes: selectedPropertyTypes,
                            onPropertyTypesChange: handlePropertyTypesChange,
                            onRegisterClose: (fn)=>{
                                closeDropdownRef.current = fn;
                            }
                        }, `${selectedMls?.value}-${allPropertyTypeIds.length}`)
                    ]
                })
            ]
        })
    });
};
$b20121513b16fece$var$EditCriteriaModal.propTypes = {
    show: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired
};
var $b20121513b16fece$export$2e2bcd8739ae039 = $b20121513b16fece$var$EditCriteriaModal;



var $kLrt8 = parcelRequire("kLrt8");

var $ivaD7 = parcelRequire("ivaD7");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");


var $9QX0f = parcelRequire("9QX0f");

var $90ISC = parcelRequire("90ISC");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("fHiKR");
var $5txPe = parcelRequire("5txPe");
var $kN5vy = parcelRequire("kN5vy");

var $c9Z8w = parcelRequire("c9Z8w");

var $9QX0f = parcelRequire("9QX0f");
const $62967431bf21b460$export$d7f5dbeae8f5aabf = ({ className: className, dataLwtId: dataLwtId, defaultValue: defaultValue, labelText: labelText, onChange: onChange, value: value, currentTabId: currentTabId })=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: `${className} mt-1 mb-3`,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kN5vy))), {
                dataLwtId: `${dataLwtId}-label`,
                className: "mb-1 helix-heading",
                children: labelText
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5txPe))), {
                className: "",
                dataLwtId: dataLwtId,
                defaultValue: defaultValue,
                type: "text",
                maxLength: (0, $9QX0f.tabs)[currentTabId]?.inputMaxLength,
                onChange: (event)=>onChange(event.target.value),
                value: value
            })
        ]
    });
$62967431bf21b460$export$d7f5dbeae8f5aabf.propTypes = {
    className: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    dataLwtId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    labelText: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any
};




var $9QX0f = parcelRequire("9QX0f");

var $c9Z8w = parcelRequire("c9Z8w");

var $cstaF = parcelRequire("cstaF");
const $f38ff393b37e8999$export$6263cf41abb5cdf8 = ({ currentTabId: currentTabId, minGrowth: minGrowth, maxGrowth: maxGrowth, minLabel: minLabel, maxLabel: maxLabel, minDefault: minDefault, maxDefault: maxDefault, onMinInputChange: onMinInputChange, onMaxInputChange: onMaxInputChange, onSelectorChange: onSelectorChange, selectorDefault: selectorDefault, selectedMlsId: selectedMlsId, validationMessage: validationMessage, isGrowthAnalysisView: isGrowthAnalysisView, handleFilterChange: handleFilterChange, mlsOptions: mlsOptions, selectedFilterValues: selectedFilterValues })=>{
    const timeFrameOptions = isGrowthAnalysisView ? (0, $9QX0f.growthAnalysisIncDecTimeFrame) : (0, $9QX0f.producerOptions).timeFrame;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7c4e13b77bde4175$export$f973f3c28d5d9390), {
                containerClass: "mb-3",
                dataLwtId: "select-producers-mls",
                defaultValue: mlsOptions.find((mls)=>mls.value === selectedMlsId),
                labelText: (0, $cstaF.searchTerms).mls,
                options: mlsOptions,
                onChange: (option)=>handleFilterChange(option, (0, $9QX0f.filterIds).producers, (0, $9QX0f.searchfilterStateId).mls),
                value: mlsOptions.find((mls)=>mls.value === (selectedFilterValues?.mls?.value ?? selectedMlsId))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "d-flex align-items-center justify-content-between",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $62967431bf21b460$export$d7f5dbeae8f5aabf), {
                        className: "pr-3",
                        currentTabId: currentTabId,
                        dataLwtId: "input-producers-min-value",
                        labelText: `${minLabel} %`,
                        defaultValue: minDefault,
                        onChange: onMinInputChange,
                        value: minGrowth
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $62967431bf21b460$export$d7f5dbeae8f5aabf), {
                        dataLwtId: "input-producers-max-value",
                        currentTabId: currentTabId,
                        labelText: `${maxLabel} %`,
                        defaultValue: maxDefault,
                        onChange: onMaxInputChange,
                        value: maxGrowth
                    })
                ]
            }),
            !!validationMessage && /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "text-danger mb-4 validation-text-wrapper",
                children: validationMessage
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7c4e13b77bde4175$export$f973f3c28d5d9390), {
                dataLwtId: "select-producers-time-frame",
                defaultValue: selectorDefault,
                labelText: (0, $9QX0f.terms).timeFrame,
                options: timeFrameOptions,
                onChange: onSelectorChange
            })
        ]
    });
};
$f38ff393b37e8999$export$6263cf41abb5cdf8.propTypes = {
    currentTabId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    minGrowth: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    maxGrowth: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    maxGrowthValue: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    minGrowthValue: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    minLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    maxLabel: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    minDefault: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    maxDefault: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any,
    onMinInputChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    onMaxInputChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    onSelectorChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    selectorDefault: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    validationMessage: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    isGrowthAnalysisView: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


var $9QX0f = parcelRequire("9QX0f");

var $c9Z8w = parcelRequire("c9Z8w");

var $cstaF = parcelRequire("cstaF");
const $7acb79c8ce817a82$export$a7aa50b9537522c2 = ({ inactivityDefault: inactivityDefault, newProdDefault: newProdDefault, onInactivityChange: onInactivityChange, onNewProdChange: onNewProdChange, value: value, handleFilterChange: handleFilterChange, mlsOptions: mlsOptions, selectedFilterValues: selectedFilterValues, selectedMlsId: selectedMlsId })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7c4e13b77bde4175$export$f973f3c28d5d9390), {
                containerClass: "mb-3",
                dataLwtId: "select-producers-mls",
                defaultValue: mlsOptions.find((mls)=>mls.value === selectedMlsId),
                labelText: (0, $cstaF.searchTerms).mls,
                options: mlsOptions,
                onChange: (option)=>handleFilterChange(option, (0, $9QX0f.filterIds).producers, (0, $9QX0f.searchfilterStateId).mls),
                value: mlsOptions.find((mls)=>mls.value === (selectedFilterValues?.mls?.value ?? selectedMlsId))
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7c4e13b77bde4175$export$f973f3c28d5d9390), {
                dataLwtId: "select-producers-new-production",
                defaultValue: newProdDefault,
                labelText: `${(0, $9QX0f.terms).hasNewProductionOver}:`,
                options: (0, $9QX0f.producerOptions).newProd,
                onChange: onNewProdChange,
                value: value?.newProd
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7c4e13b77bde4175$export$f973f3c28d5d9390), {
                dataLwtId: "select-producers-inactivity",
                defaultValue: inactivityDefault,
                labelText: `${(0, $9QX0f.terms).afterAnInactivityPeriodOf}:`,
                options: (0, $9QX0f.producerOptions).inactivity,
                onChange: onInactivityChange,
                value: value?.inactivity
            })
        ]
    });
};
$7acb79c8ce817a82$export$a7aa50b9537522c2.propTypes = {
    inactivityDefault: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    newProdDefault: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    onInactivityChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    onNewProdChange: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};



var $fVDYX = parcelRequire("fVDYX");

var $aypMh = parcelRequire("aypMh");

var $cstaF = parcelRequire("cstaF");
const $f1c6db78445d75dc$export$1311b4dc258bdc17 = ({ setState: setState, suggestedAgentsState: suggestedAgentsState })=>{
    const mlsProviders = (0, $90ISC.useCommonStore)((state)=>state.mlsProviders);
    const { currentInactivityPeriod: currentInactivityPeriod, currentTabId: currentTabId, currentTabTimePeriod: currentTabTimePeriod, minGrowth: minGrowth, maxGrowth: maxGrowth, selectedLowPos: selectedLowPos, selectedMlsId: selectedMlsId, selectedTimeFrame: selectedTimeFrame, selectedNewProd: selectedNewProd, selectedInactivity: selectedInactivity, selectedTimePeriod: selectedTimePeriod, isGrowthAnalysisView: isGrowthAnalysisView } = (0, $90ISC.useSearchStore)((state)=>{
        const { [state.selectedModule]: moduleState } = state;
        const { [moduleState.currentTabId]: tabState } = moduleState.searchOptions;
        const { producers: producers } = tabState;
        const currentInactivityPeriod = producers?.inactivity?.label || null;
        const selectedListingViewId = tabState?.display.selectedView.value;
        const isGrowthAnalysisView = selectedListingViewId === (0, $aypMh.views).growthAnalysis;
        const currentTabTimePeriod = (0, $fVDYX.getCurrentTabTimePeriod)(producers, isGrowthAnalysisView);
        const selectedTimeFrame = isGrowthAnalysisView ? producers?.growthTimeFrame : producers?.timeFrame;
        return {
            currentInactivityPeriod: currentInactivityPeriod,
            currentTabId: moduleState.currentTabId,
            currentTabTimePeriod: currentTabTimePeriod,
            minGrowth: tabState.producers?.minGrowth,
            maxGrowth: tabState.producers?.maxGrowth,
            selectedLowPos: tabState.producers?.lowPos,
            selectedTimeFrame: selectedTimeFrame,
            selectedMlsId: tabState?.producers?.mls?.mlsId || moduleState?.selectedMls?.mlsId,
            selectedNewProd: tabState.producers?.newProd,
            selectedInactivity: tabState.producers?.inactivity,
            selectedTimePeriod: tabState.producers?.timePeriod || tabState.producers?.newProd || tabState.producers?.timeFrame,
            isGrowthAnalysisView: isGrowthAnalysisView
        };
    });
    const isTopProducersTab = currentTabId === (0, $9QX0f.tabs).topProducers.id;
    const isIncOrDecProducersTab = currentTabId === (0, $9QX0f.tabs).incProducers.id || currentTabId === (0, $9QX0f.tabs).decProducers.id;
    (0, $acw62.useEffect)(()=>{
        if (isIncOrDecProducersTab) setState((state)=>({
                ...state,
                selectedFilterValues: {
                    ...state.selectedFilterValues,
                    [currentTabId]: {
                        ...state.selectedFilterValues?.[currentTabId],
                        minGrowth: minGrowth,
                        maxGrowth: maxGrowth
                    },
                    filterId: (0, $9QX0f.filterIds).producers
                }
            }));
    }, [
        currentTabId
    ]);
    const handleFilterChange = (option, filterId, stateId)=>{
        const optionValue = (0, $fVDYX.getOptionValue)(option, stateId);
        setState((state)=>({
                ...state,
                selectedFilterValues: {
                    ...state.selectedFilterValues,
                    [currentTabId]: {
                        ...state.selectedFilterValues?.[currentTabId],
                        [stateId]: optionValue
                    },
                    filterId: filterId,
                    stateId: stateId
                }
            }));
    };
    const selectedFilterValues = suggestedAgentsState?.selectedFilterValues[currentTabId];
    const validationSettings = (0, $fVDYX.getValidationSettings)({
        minGrowth: selectedFilterValues?.minGrowth ?? minGrowth,
        maxGrowth: selectedFilterValues?.maxGrowth ?? maxGrowth,
        currentTabId: currentTabId
    });
    const mlsOptions = mlsProviders.map((mls)=>({
            value: mls.mlsId,
            label: mls.shortDescription
        }));
    const incDecTimeFrame = isGrowthAnalysisView ? (0, $9QX0f.searchfilterStateId).growthTimeFrame : (0, $9QX0f.searchfilterStateId).timeFrame;
    const filterByTab = {
        [(0, $9QX0f.tabs).topProducers.id]: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7c4e13b77bde4175$export$f973f3c28d5d9390), {
                    containerClass: "mb-3",
                    dataLwtId: "select-producers-mls",
                    defaultValue: mlsOptions.find((mls)=>mls.value === selectedMlsId),
                    labelText: (0, $cstaF.searchTerms).mls,
                    options: mlsOptions,
                    onChange: (option)=>handleFilterChange(option, (0, $9QX0f.filterIds).producers, (0, $9QX0f.searchfilterStateId).mls),
                    value: mlsOptions.find((mls)=>mls.value === (selectedFilterValues?.mls?.value ?? selectedMlsId))
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7c4e13b77bde4175$export$f973f3c28d5d9390), {
                    dataLwtId: "select-producers-lowest-position",
                    defaultValue: selectedLowPos,
                    labelText: (0, $9QX0f.terms).lowestPosition,
                    options: (0, $9QX0f.producerOptions).lowPos,
                    onChange: (option)=>handleFilterChange(option, (0, $9QX0f.filterIds).producers, (0, $9QX0f.searchfilterStateId).lowPos),
                    value: selectedFilterValues?.lowPos ?? selectedLowPos?.lowPos
                })
            ]
        }),
        [(0, $9QX0f.tabs).incProducers.id]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f38ff393b37e8999$export$6263cf41abb5cdf8), {
            currentTabId: currentTabId,
            minLabel: (0, $9QX0f.terms).minIncrease,
            maxLabel: (0, $9QX0f.terms).maxIncrease,
            minDefault: minGrowth,
            maxDefault: maxGrowth,
            minGrowth: selectedFilterValues?.minGrowth ?? minGrowth,
            maxGrowth: selectedFilterValues?.maxGrowth ?? maxGrowth,
            onMinInputChange: (value)=>handleFilterChange(value, (0, $9QX0f.filterIds).producers, (0, $9QX0f.searchfilterStateId).minGrowth),
            onMaxInputChange: (value)=>handleFilterChange(value, (0, $9QX0f.filterIds).producers, (0, $9QX0f.searchfilterStateId).maxGrowth),
            onSelectorChange: (option)=>handleFilterChange(option, (0, $9QX0f.filterIds).producers, incDecTimeFrame),
            selectorDefault: selectedTimeFrame,
            validationMessage: validationSettings?.validationMessage,
            isGrowthAnalysisView: isGrowthAnalysisView,
            handleFilterChange: handleFilterChange,
            mlsOptions: mlsOptions,
            selectedMlsId: selectedMlsId,
            selectedFilterValues: selectedFilterValues
        }),
        [(0, $9QX0f.tabs).decProducers.id]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f38ff393b37e8999$export$6263cf41abb5cdf8), {
            currentTabId: currentTabId,
            minLabel: (0, $9QX0f.terms).minDecrease,
            maxLabel: (0, $9QX0f.terms).maxDecrease,
            minDefault: minGrowth,
            maxDefault: maxGrowth,
            minGrowth: selectedFilterValues?.minGrowth ?? minGrowth,
            maxGrowth: selectedFilterValues?.maxGrowth ?? maxGrowth,
            onMinInputChange: (value)=>handleFilterChange(value, (0, $9QX0f.filterIds).producers, (0, $9QX0f.searchfilterStateId).minGrowth),
            onMaxInputChange: (value)=>handleFilterChange(value, (0, $9QX0f.filterIds).producers, (0, $9QX0f.searchfilterStateId).maxGrowth),
            onSelectorChange: (option)=>handleFilterChange(option, (0, $9QX0f.filterIds).producers, incDecTimeFrame),
            selectorDefault: selectedTimeFrame,
            validationMessage: validationSettings?.validationMessage,
            isGrowthAnalysisView: isGrowthAnalysisView,
            handleFilterChange: handleFilterChange,
            mlsOptions: mlsOptions,
            selectedMlsId: selectedMlsId,
            selectedFilterValues: selectedFilterValues
        }),
        [(0, $9QX0f.tabs).newProducers.id]: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7acb79c8ce817a82$export$a7aa50b9537522c2), {
            inactivityDefault: selectedInactivity,
            newProdDefault: selectedNewProd,
            onInactivityChange: (option)=>handleFilterChange(option, (0, $9QX0f.filterIds).producers, (0, $9QX0f.searchfilterStateId).inactivity),
            onNewProdChange: (option)=>handleFilterChange(option, (0, $9QX0f.filterIds).producers, (0, $9QX0f.searchfilterStateId).newProd),
            value: suggestedAgentsState?.selectedFilterValues[currentTabId] || {
                currentTabTimePeriod: currentTabTimePeriod,
                currentInactivityPeriod: currentInactivityPeriod
            },
            mlsOptions: mlsOptions,
            selectedMlsId: selectedMlsId,
            selectedFilterValues: selectedFilterValues,
            handleFilterChange: handleFilterChange
        }),
        [(0, $9QX0f.tabs).coopAgents.id]: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7c4e13b77bde4175$export$f973f3c28d5d9390), {
                    containerClass: "mb-3",
                    dataLwtId: "select-producers-mls",
                    defaultValue: mlsOptions.find((mls)=>mls.value === selectedMlsId),
                    labelText: (0, $cstaF.searchTerms).mls,
                    options: mlsOptions,
                    onChange: (option)=>handleFilterChange(option, (0, $9QX0f.filterIds).producers, (0, $9QX0f.searchfilterStateId).mls),
                    value: mlsOptions.find((mls)=>mls.value === (selectedFilterValues?.mls?.value ?? selectedMlsId))
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7c4e13b77bde4175$export$f973f3c28d5d9390), {
                    dataLwtId: "select-producers-time-period",
                    defaultValue: selectedTimePeriod,
                    labelText: (0, $9QX0f.terms).timePeriod,
                    options: (0, $9QX0f.producerOptions).timePeriod,
                    onChange: (option)=>handleFilterChange(option, (0, $9QX0f.filterIds).producers, (0, $9QX0f.searchfilterStateId).timePeriod),
                    value: suggestedAgentsState?.selectedFilterValues[currentTabId]?.timePeriod || currentTabTimePeriod
                })
            ]
        })
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "producer-filter py-2",
        dataLwtId: "suggested-agents-producers-filter",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: `${isTopProducersTab ? "pb-1" : "pb-3"}`,
            children: filterByTab[currentTabId]
        })
    });
};
$f1c6db78445d75dc$export$1311b4dc258bdc17.propTypes = {
    filterSettings: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    setFilterSettings: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    setState: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    togglePopover: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    suggestedAgentsState: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};



var $jeANf = parcelRequire("jeANf");

var $iCDWi = parcelRequire("iCDWi");
const $04b81e2666a3f445$export$dd3db22492f1dcde = ()=>{
    const [showEditCriteriaModal, setShowEditCriteriaModal] = (0, $acw62.useState)(false);
    const [localMlsByTab, setLocalMlsByTab] = (0, $acw62.useState)({});
    const { currentTabId: currentTabId, currentTabIndex: currentTabIndex, currentInactivityPeriod: currentInactivityPeriod, currentTabTimePeriod: currentTabTimePeriod, growthAnalysisPeriod: growthAnalysisPeriod, maxGrowth: maxGrowth, minGrowth: minGrowth, selectedListingViewId: selectedListingViewId, selectedModule: selectedModule, clearSelectedAgentIds: clearSelectedAgentIds, setCurrentTabIndex: setCurrentTabIndex, setSearchFilterState: setSearchFilterState, setSuggestedAgentsData: setSuggestedAgentsData, setTabDescription: setTabDescription, setSuggestedAgentsMlsByTab: setSuggestedAgentsMlsByTab, selectedMls: selectedMls, selectedLowPos: selectedLowPos, selectedNewProdPeriod: selectedNewProdPeriod, selectedInactivityPeriod: selectedInactivityPeriod, selectedTimePeriod: selectedTimePeriod, isLoading: isLoading } = (0, $90ISC.useSearchStore)((state)=>{
        const moduleState = state[state.selectedModule];
        const currentTabId = moduleState?.currentTabId;
        const currentTabState = moduleState?.searchOptions?.[currentTabId];
        const producers = currentTabState?.producers;
        const currentInactivityPeriod = producers?.inactivity?.label || null;
        const isIncDecProducers = currentTabId === (0, $9QX0f.tabs).incProducers.id || currentTabId === (0, $9QX0f.tabs).decProducers.id;
        const selectedListingViewId = currentTabState?.display.selectedView.value;
        const isGrowthAnalysisView = selectedListingViewId === (0, $aypMh.views).growthAnalysis;
        const currentTabTimePeriod = (0, $fVDYX.getCurrentTabTimePeriod)(producers, isGrowthAnalysisView);
        const growthAnalysisPeriod = isIncDecProducers ? currentTabState?.producers?.growthTimeFrame?.value : (0, $cstaF.TimePeriods)[currentTabState?.growthAnalysisPeriod?.value];
        return {
            currentTabId: currentTabId,
            currentTabIndex: moduleState?.currentTabIndex,
            currentInactivityPeriod: currentInactivityPeriod,
            currentTabTimePeriod: currentTabTimePeriod,
            growthAnalysisPeriod: growthAnalysisPeriod,
            maxGrowth: currentTabState?.producers?.maxGrowth,
            minGrowth: currentTabState?.producers?.minGrowth,
            searchOptions: moduleState?.searchOptions,
            selectedModule: state.selectedModule,
            clearSelectedAgentIds: state.clearSelectedAgentIds,
            setCurrentTabIndex: state.setCurrentTabIndex,
            setSearchFilterState: state.setSearchFilterState,
            setSuggestedAgentsData: state.setSuggestedAgentsData,
            setTabDescription: state.setTabDescription,
            setSuggestedAgentsMlsByTab: state.setSuggestedAgentsMlsByTab,
            selectedListingViewId: selectedListingViewId,
            selectedLowPos: producers?.lowPos || producers?.lowPos,
            selectedMls: currentTabState?.producers?.mls || moduleState.selectedMls,
            selectedNewProdPeriod: currentTabState?.producers?.newProd,
            selectedInactivityPeriod: currentTabState?.producers?.inactivity,
            selectedTimePeriod: currentTabState?.producers?.timePeriod || currentTabState?.producers?.newProd || currentTabState?.producers?.timeFrame,
            isLoading: state.isLoading
        };
    });
    const { timeIntervals: timeIntervals, mlsProviders: mlsProviders } = (0, $90ISC.useCommonStore)((state)=>({
            timeIntervals: state.timeIntervals,
            mlsProviders: state.mlsProviders
        }));
    // Switch to hide todays picks temporarily
    const { todaysPicks: todaysPicks } = (0, $kLrt8.useFeatureToggles)();
    const HIDE_TODAYS_PICKS = !todaysPicks.isEnabled;
    const tabValues = Object.values((0, $9QX0f.tabs)).filter((tab)=>HIDE_TODAYS_PICKS ? tab.id !== (0, $9QX0f.tabs).todaysPicks.id : true);
    const isHiddenTab = HIDE_TODAYS_PICKS && currentTabId === (0, $9QX0f.tabs).todaysPicks.id;
    const safeTabId = isHiddenTab ? (0, $9QX0f.tabs).topProducers.id : currentTabId;
    const adjustedTabIndex = HIDE_TODAYS_PICKS ? currentTabIndex - 1 : currentTabIndex;
    const isCoopAgents = safeTabId === (0, $9QX0f.tabs).coopAgents.id;
    const isTodaysPicks = safeTabId === (0, $9QX0f.tabs).todaysPicks.id;
    const { gridRef: gridRef, state: state, setState: setState } = (0, $5a0ca2dd63367f84$export$13536ee55f1995a1)();
    const tableSettings = (0, $f22a7abd90352299$export$cfee0069488e0cdc)({
        state: state,
        setState: setState,
        growthAnalysisPeriod: growthAnalysisPeriod,
        currentTabId: currentTabId,
        selectedListingViewId: selectedListingViewId
    });
    if (isCoopAgents && tableSettings.tableView.id === (0, $aypMh.views).contactInformation) tableSettings.tableView.defaultSort = {};
    const timePeriodFooterTitle = (0, $fVDYX.getFooterTimePeriodValue)(state.currentSearchDates, safeTabId);
    const selectedTimeFrameTitle = Object.keys((0, $cstaF.TimePeriods)).find((key)=>(0, $cstaF.TimePeriods)[key] === selectedNewProdPeriod?.value);
    const productionTitle = (0, $fVDYX.getFooterIncDecProducerValue)({
        currentTabId: currentTabId,
        inactivityPeriod: selectedInactivityPeriod?.label,
        minGrowth: minGrowth,
        maxGrowth: maxGrowth,
        timeFrame: selectedTimeFrameTitle
    });
    const columnProps = [
        {
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2d072b31e1c166df$export$2e2bcd8739ae039), {
                mlsName: localMlsByTab?.[currentTabId]?.shortDescription || selectedMls?.shortDescription,
                propertyTypeNames: state.propertyTypeNames,
                timePeriodTitle: timePeriodFooterTitle,
                productionTitle: productionTitle
            }),
            sm: 12,
            align: "left"
        }
    ];
    const renderTabTitle = (tab)=>{
        if (tab.id === (0, $9QX0f.tabs).todaysPicks.id && tab.badgeCount) return /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
            className: "d-flex align-items-center",
            children: [
                tab.label,
                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "todays-picks-badge",
                    children: tab.badgeCount
                })
            ]
        });
        return tab.label;
    };
    const onClose = ()=>{
        (0, $ivaD7.setStateData)("showModal", false, setState);
        (0, $ivaD7.setStateData)("selectedFilterValues", {}, setState);
    };
    const handleSave = ()=>{
        const selectedTabState = state.selectedFilterValues;
        const isGrowthField = (0, $fVDYX.validateGrowthFields)(selectedTabState, currentTabId);
        if (isGrowthField) {
            (0, $jeANf.showToast)((0, $jeANf.toastTypes).error, (0, $cstaF.toastMessages).error.emptyProducers(currentTabId === (0, $9QX0f.tabs).incProducers.id), setState);
            return;
        }
        (0, $ivaD7.setStateData)("toastProps", {}, setState);
        clearSelectedAgentIds();
        const selectedMlsId = selectedTabState?.[currentTabId]?.mls?.value || selectedMls?.mlsId;
        setLocalMlsByTab((state)=>({
                ...state,
                [currentTabId]: mlsProviders.find((mls)=>mls.mlsId === selectedMlsId)
            }));
        setSearchFilterState(selectedTabState?.[currentTabId], selectedTabState.filterId, selectedTabState.stateId, (0, $9QX0f.tabs)[currentTabId].hasRefreshSearchBtn);
        (0, $ivaD7.setStateData)("currentSearchDates", (0, $iCDWi.getCurrentSearchDates)(timeIntervals, selectedTimePeriod?.value), setState);
        setSuggestedAgentsData({
            mlsId: selectedMlsId,
            setState: setState,
            currentTabId: currentTabId
        });
        setTabDescription((0, $fVDYX.resolveTabDescription)({
            selectedTabState: selectedTabState,
            currentTabId: currentTabId,
            currentTabTimePeriod: currentTabTimePeriod,
            currentInactivityPeriod: currentInactivityPeriod,
            selectedLowPos: selectedLowPos
        }));
        const mlsToUpdate = (0, $fVDYX.getMlsToUpdate)({
            selectedTabState: selectedTabState,
            currentTabId: currentTabId,
            mlsProviders: mlsProviders
        });
        if (mlsToUpdate) setSuggestedAgentsMlsByTab(mlsToUpdate, selectedModule, currentTabId);
        onClose();
    };
    const tabItems = tabValues.map((tab, i)=>{
        const isTodaysPicksTab = tab.id === (0, $9QX0f.tabs).todaysPicks.id;
        return {
            title: renderTabTitle(tab),
            content: {
                jsx: adjustedTabIndex === i && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
                    children: isTodaysPicksTab ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $05aff448789b0cea$export$ec5a714b701e74c1), {}) : /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bf2e71c2e8fcb319$export$59fd058eaac8b5f9), {
                                tabId: tab.id,
                                tableSettings: tableSettings,
                                gridRef: gridRef,
                                rowData: state.rowDataByTab[safeTabId]?.results,
                                setState: setState,
                                state: state,
                                tabIndex: adjustedTabIndex
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3QXz5))), {
                                position: "toast-bottom-right",
                                dataLwtId: "validation-toast",
                                toastProps: state.toastProps
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $859b3aeec7a854d9$export$2e2bcd8739ae039), {
                                columnProps: columnProps
                            })
                        ]
                    })
                })
            }
        };
    });
    const isSaveBtnDisabled = !state.selectedFilterValues?.[currentTabId] || !state.selectedFilterValues.filterId || !state.selectedFilterValues.stateId;
    const modalButtons = /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                dataLwtId: "cancel-edit-criteria",
                color: "secondary",
                onClick: onClose,
                children: (0, $cstaF.buttonTerms).cancel
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                dataLwtId: "save-edit-criteria",
                color: "primary",
                onClick: handleSave,
                disabled: isSaveBtnDisabled,
                children: (0, $cstaF.buttonTerms).save
            })
        ]
    });
    const shouldShowLoader = !isTodaysPicks && (isLoading || !state.rowDataByTab[currentTabId]?.results || state.rowDataByTab[currentTabId]?.results?.length === undefined);
    const handleEditCriteriaClick = ()=>{
        if (currentTabId !== (0, $9QX0f.tabs).todaysPicks.id) {
            const modalProps = {
                onClose: onClose,
                show: true,
                showFooter: true,
                size: "sm",
                title: (0, $cstaF.buttonTerms).editCriteria
            };
            setState((state)=>({
                    ...state,
                    modalProps: modalProps,
                    showModal: true
                }));
            return;
        }
        setShowEditCriteriaModal(true);
    };
    const handleCloseEditCriteria = ()=>{
        setShowEditCriteriaModal(false);
        (0, $ivaD7.setStateData)("modalProps", undefined, setState);
    };
    const revisedModalProps = state.modalProps?.title === (0, $cstaF.buttonTerms).editCriteria ? {
        ...state.modalProps,
        buttons: modalButtons,
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f1c6db78445d75dc$export$1311b4dc258bdc17), {
            togglePopover: ()=>(0, $ivaD7.setStateData)("showModal", !state.showModal, setState),
            setState: setState,
            suggestedAgentsState: state
        })
    } : state.modalProps;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f61ig.default), {
                ...revisedModalProps,
                show: state.showModal
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b20121513b16fece$export$2e2bcd8739ae039), {
                show: showEditCriteriaModal,
                onClose: handleCloseEditCriteria
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                id: "suggested-agents",
                className: "py-2",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "d-flex justify-content-between align-items-center mb-2 mt-2",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                className: "mr-1 font-gray-primary",
                                children: (0, $9QX0f.terms).suggestedAgents
                            }),
                            !isLoading && /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                                onClick: handleEditCriteriaClick,
                                className: "helix-bg-brand persist-bg text-white",
                                color: "primary",
                                children: (0, $9QX0f.editCriteriaTerms).editCriteria
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "flex-grow-0",
                        children: shouldShowLoader ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8f390b0d641c1be9$export$2e2bcd8739ae039), {
                            tabTextTransform: "none",
                            navSize: 2,
                            contentSize: 2,
                            className: "secondary",
                            items: tabItems,
                            tabs: tabValues,
                            currentIndex: adjustedTabIndex,
                            setCurrentIndex: (i)=>{
                                const storeIndex = HIDE_TODAYS_PICKS ? i + 1 : i;
                                setCurrentTabIndex(storeIndex, Object.values((0, $9QX0f.tabs)));
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0708f7349a857d02$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
};



var $kLrt8 = parcelRequire("kLrt8");

var $9QX0f = parcelRequire("9QX0f");


var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $8U25g = parcelRequire("8U25g");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $7D4kr = parcelRequire("7D4kr");
const $adda3979c5c6d7f7$export$bba808db88f96979 = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "verification-error-wrapper",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "bg-white raised-border d-flex flex-column align-items-center p-5 mt-5",
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "text-center mb-3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                        height: "40",
                        src: "https://assets.lwolf.com/img/lw-logo-dark.svg",
                        alt: "Logo",
                        className: "mb-5"
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        children: (0, $8U25g.terms).verificationErrorP1
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        children: (0, $8U25g.terms).verificationErrorP2
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                        dataLwtId: "go-to-lone-wolf-home-button",
                        className: "btn btn-primary go-to-lone-wolf-home-button w-100",
                        onClick: (0, $7D4kr.navigateToPlatformHome),
                        children: (0, $8U25g.terms).goToLoneWolfHome
                    })
                ]
            })
        })
    });



var $cIUhV = parcelRequire("cIUhV");

var $ayMG0 = parcelRequire("ayMG0");



var $acw62 = parcelRequire("acw62");

var $kfZjc = parcelRequire("kfZjc");


var $i95vK = parcelRequire("i95vK");


var $90ISC = parcelRequire("90ISC");

var $hQz0O = parcelRequire("hQz0O");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $7tOHe = parcelRequire("7tOHe");

var $l05Px = parcelRequire("l05Px");

var $4tbBr = parcelRequire("4tbBr");

var $hQz0O = parcelRequire("hQz0O");

var $iQ57b = parcelRequire("iQ57b");

var $c9Z8w = parcelRequire("c9Z8w");
const $8a7a072219adb782$export$b6650e702502dd47 = (tableView)=>tableView.tables.flatMap((table, parentIndex)=>{
        const flattenCols = (children)=>{
            return children.flatMap((child)=>{
                if (child.children) return flattenCols(child.children);
                if (child.col) {
                    // Removing initialHide from the col, we should use isDisplayed instead
                    // eslint-disable-next-line no-unused-vars
                    const { initialHide: initialHide, ...colWithoutInitialHide } = child.col;
                    return [
                        {
                            ...colWithoutInitialHide,
                            parentIndex: parentIndex
                        }
                    ];
                }
                return [];
            });
        };
        return flattenCols(table.children);
    });


const $1ba502fa32b20b43$export$58e3d2ed27201b6e = ({ data: data, isLoading: isLoading, tableView: tableView, gridRef: gridRef, isOfficeListBreakdown: isOfficeListBreakdown })=>{
    if (isLoading) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {});
    const settingsbyTableViewId = {
        [(0, $4tbBr.tableViews).agentsGainedBreakdown().id]: {
            tooltips: (0, $hQz0O.agentsGainedTooltips),
            filterFunction: (agent)=>isOfficeListBreakdown ? !agent.didLeaveSelectedOffices : agent.didLeaveSelectedOffices
        },
        [(0, $4tbBr.tableViews).lostAgentsBreakdown().id]: {
            tooltips: (0, $hQz0O.lostAgentsTooltips),
            filterFunction: (agent)=>isOfficeListBreakdown ? agent.didLeaveSelectedOffices : !agent.didLeaveSelectedOffices
        }
    };
    const filteredAgents = data?.results?.filter((agent)=>settingsbyTableViewId[tableView.id].filterFunction(agent)) || [];
    const tooltips = settingsbyTableViewId[tableView.id]?.tooltips;
    const columns = (0, $8a7a072219adb782$export$b6650e702502dd47)(tableView);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l05Px.default), {
        gridRef: gridRef,
        tableView: tableView,
        rowData: filteredAgents,
        tableTitleWithTooltips: tooltips,
        additionalTableHeaders: (0, $iQ57b.breakdownAdditionalHeaders),
        externalParams: {
            tooltipTargetPrefix: tableView.id
        },
        columns: columns
    });
};
$1ba502fa32b20b43$export$58e3d2ed27201b6e.propTypes = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        results: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
        totals: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
        error: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).any
    }),
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    tableView: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object.isRequired,
    gridRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object.isRequired,
    isOfficeListBreakdown: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired
};



var $acw62 = parcelRequire("acw62");

var $90ISC = parcelRequire("90ISC");

var $8QuU9 = parcelRequire("8QuU9");

var $ivaD7 = parcelRequire("ivaD7");
function $b1947d5b053c1dba$export$8780a8ebd57443d0({ parameterName: parameterName, pathname: pathname, isOfficeListBreakdown: isOfficeListBreakdown, setAgentData: setAgentData }) {
    const [state, setState] = (0, $acw62.useState)({
        data: {
            results: [],
            totals: {},
            error: null
        },
        isLoading: false,
        isOfficeListBreakdown: isOfficeListBreakdown
    });
    const { search: search, selectedBreakdownOffice: selectedBreakdownOffice, selectedModule: selectedModule, setIsFooterDisabled: setIsFooterDisabled, selectedBreakdownTab: selectedBreakdownTab } = (0, $90ISC.useSearchStore)((state)=>{
        const { [state.selectedModule]: moduleState } = state;
        const { breakdowns: breakdowns = {} } = moduleState;
        return {
            search: moduleState?.search,
            selectedBreakdownOffice: breakdowns?.selectedBreakdownOffice,
            selectedModule: state.selectedModule,
            selectedBreakdownTab: breakdowns?.selectedBreakdownTab,
            setIsFooterDisabled: state.setIsFooterDisabled
        };
    });
    const officeId = selectedBreakdownOffice?.officeId;
    const searchCriteria = (0, $acw62.useRef)(search?.searchCriteria);
    (0, $acw62.useEffect)(()=>{
        searchCriteria.current = search?.searchCriteria;
    }, [
        search?.searchCriteria
    ]);
    const fetchData = (additionalParams = [])=>{
        setState((state)=>({
                ...state,
                data: {
                    results: [],
                    totals: {},
                    error: null
                },
                isLoading: true
            }));
        setIsFooterDisabled(selectedBreakdownTab, true, pathname);
        (0, $8QuU9.getAgentBreakdown)(searchCriteria.current, additionalParams).then((data)=>{
            (0, $ivaD7.setStateData)("data", data, setState);
            setAgentData((agentData)=>({
                    ...agentData,
                    [selectedModule]: {
                        ...agentData?.[selectedModule],
                        agMovAgentBreakdownSearch: data.results
                    }
                }));
        }).catch((error)=>{
            (0, $ivaD7.setStateData)("data", {
                ...state.data,
                error: error.message || error
            }, setState);
            console.error(error);
        }).finally(()=>{
            (0, $ivaD7.setStateData)("isLoading", false, setState);
            setIsFooterDisabled(selectedBreakdownTab, false, pathname);
        });
    };
    (0, $acw62.useEffect)(()=>{
        if (!isOfficeListBreakdown && (!officeId || !searchCriteria.current)) return;
        if (!isOfficeListBreakdown) fetchData([
            {
                parameter: parameterName,
                value: officeId
            }
        ]);
    }, [
        officeId,
        isOfficeListBreakdown
    ]);
    (0, $acw62.useEffect)(()=>{
        if (isOfficeListBreakdown && searchCriteria.current) fetchData([]);
    }, [
        isOfficeListBreakdown,
        searchCriteria.current
    ]);
    return state;
}




var $4tbBr = parcelRequire("4tbBr");

var $acw62 = parcelRequire("acw62");

var $kfZjc = parcelRequire("kfZjc");

var $24YIE = parcelRequire("24YIE");

var $90ISC = parcelRequire("90ISC");


var $cstaF = parcelRequire("cstaF");
const $d64c72da30dddc73$export$5f720e4455b11fac = ()=>{
    const location = (0, $kfZjc.useLocation)();
    const [officeDetails, setOfficeDetails] = (0, $acw62.useState)(null);
    const { search: search, selectedBreakdownOffice: selectedBreakdownOffice, loadedSearchCriteria: loadedSearchCriteria } = (0, $90ISC.useSearchStore)((state)=>({
            search: state[state.selectedModule]?.search,
            selectedBreakdownOffice: state[state.selectedModule]?.breakdowns?.selectedBreakdownOffice,
            loadedSearchCriteria: state[state.selectedModule]?.loadedSearchCriteria
        }));
    const mlsProviders = (0, $90ISC.useCommonStore)((state)=>state.mlsProviders);
    const isAgMovAgentBreakdownRoute = location.pathname === (0, $cstaF.searchRoutes).agentBreakdown;
    const selectedMlsId = search?.mlsId;
    const officeId = selectedBreakdownOffice?.officeId;
    (0, $acw62.useEffect)(()=>{
        const getOfficeDetails = async ()=>{
            try {
                const officeDetailsRow = isAgMovAgentBreakdownRoute && await (0, $24YIE.getBreakdownOfficeDetails)(selectedMlsId, officeId);
                const selectedMls = mlsProviders.find((mls)=>mls.mlsId === selectedMlsId)?.shortDescription;
                const updatedOfficeDetailsRow = {
                    ...officeDetailsRow,
                    mls: selectedMls
                };
                setOfficeDetails((0, $1fa46cf08ea2571a$export$17a9970356c0cb59)(updatedOfficeDetailsRow));
            } catch (e) {
                console.error("Error fetching office details:", e);
            }
        };
        getOfficeDetails();
    }, [
        loadedSearchCriteria,
        officeId
    ]);
    return officeDetails;
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

parcelRequire("3lOdM");
var $1iwUl = parcelRequire("1iwUl");
var $e155p = parcelRequire("e155p");

var $c9Z8w = parcelRequire("c9Z8w");
const $8f79bf419c55fe4c$export$b30da04fadebe02d = ({ data: data })=>{
    const renderEntry = (entry)=>{
        const value = entry.value ?? "";
        let className = "border-top m-0";
        if (entry.isLastRow) className += " border-bottom";
        return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($e155p))), {
                className: className,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1iwUl))), {
                        children: entry.description
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1iwUl))), {
                        className: "font-weight-bold",
                        children: value
                    })
                ]
            })
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "col-md-12 pd-0",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $83e1bef4b926bdd3$export$2e2bcd8739ae039), {
            dataLwtId: `office-details-column`,
            data: data,
            renderEntry: renderEntry
        })
    });
};
$8f79bf419c55fe4c$export$b30da04fadebe02d.propTypes = {
    data: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array
};



var $53A0d = parcelRequire("53A0d");


var $htzEo = parcelRequire("htzEo");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $l05Px = parcelRequire("l05Px");

var $acw62 = parcelRequire("acw62");

var $kfZjc = parcelRequire("kfZjc");

var $iQ57b = parcelRequire("iQ57b");

var $eHBjM = parcelRequire("eHBjM");

var $cIUhV = parcelRequire("cIUhV");
const $3488f7483fc3d043$export$d9985c9c0ab3725e = ({ defaultSort: defaultSort })=>Object.freeze({
        id: (0, $eHBjM.tableViewNames).agentMovement,
        defaultSort: defaultSort,
        tables: [
            {
                children: [
                    (0, $iQ57b.officeNameColumn)
                ]
            },
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)((0, $iQ57b.additionalTableHeaderIds).officeInformation, props),
                children: (0, $iQ57b.officeInformationArrayColumns)(false)
            },
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)((0, $iQ57b.additionalTableHeaderIds).agents, props),
                children: (0, $iQ57b.agentsArrayColumns)
            },
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)((0, $iQ57b.additionalTableHeaderIds).potentialImpact, props),
                children: (0, $iQ57b.potentialImpactArrayColumns)
            }
        ]
    });
const $3488f7483fc3d043$export$22e18c49b68c7e = (shouldShowAdditionalInfo)=>Object.freeze({
        id: (0, $eHBjM.tableViewNames).officeBreakdown,
        defaultSort: {
            colId: (0, $iQ57b.agentsParentColumns).agentsLost.id,
            sortDir: "desc"
        },
        tables: [
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)((0, $iQ57b.additionalTableHeaderIds).officeInformation, props),
                children: (0, $iQ57b.officeInformationColumnsOfficeBreakdown)(shouldShowAdditionalInfo)
            },
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)((0, $iQ57b.additionalTableHeaderIds).agents, props),
                children: (0, $iQ57b.agentsColumnsOfficeBreakdown)
            },
            {
                headerGroupTitle: (props)=>(0, $cIUhV.getAdditionalTableHeader)((0, $iQ57b.additionalTableHeaderIds).potentialImpact, props),
                children: (0, $iQ57b.potentialImpactArrayColumns)
            }
        ]
    });



var $iQ57b = parcelRequire("iQ57b");


var $90ISC = parcelRequire("90ISC");

var $8QuU9 = parcelRequire("8QuU9");
const $34e14d41b659defc$export$dd09d560197f8b22 = ()=>{
    const { pathname: pathname } = (0, $kfZjc.useLocation)();
    const { shouldShowAdditionalInfo: shouldShowAdditionalInfo, searchCriteria: searchCriteria } = (0, $90ISC.useSearchStore)((state)=>{
        const { [state.selectedModule]: moduleState } = state;
        const { breakdowns: breakdowns = {} } = moduleState;
        const { selectedBreakdownTab: selectedBreakdownTab, tabsByRoute: tabsByRoute } = breakdowns;
        const breakdownTabData = tabsByRoute?.[pathname]?.[selectedBreakdownTab];
        return {
            shouldShowAdditionalInfo: breakdownTabData?.shouldShowAdditionalInfo ?? false,
            searchCriteria: moduleState?.search?.searchCriteria
        };
    });
    const [rowData, setRowData] = (0, $acw62.useState)([]);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const tableView = (0, $3488f7483fc3d043$export$22e18c49b68c7e)(shouldShowAdditionalInfo);
    const columns = (0, $8a7a072219adb782$export$b6650e702502dd47)(tableView);
    (0, $acw62.useEffect)(()=>{
        const fetchOfficeBreakdown = async ()=>{
            setIsLoading(true);
            try {
                const result = await (0, $8QuU9.getAgentMovementOfficeBreakdown)(searchCriteria);
                setRowData(result.results);
            } catch (error) {
                console.error(error);
            } finally{
                setIsLoading(false);
            }
        };
        fetchOfficeBreakdown();
    }, [
        searchCriteria
    ]);
    const tableProps = {
        key: tableView?.id,
        additionalTableHeaders: $iQ57b.additionalTableHeaders,
        rowData: rowData,
        tableTitleWithTooltips: (0, $iQ57b.officeBreakdownColumns),
        tableView: tableView,
        isTableAutoHeight: false,
        columns: columns
    };
    return {
        tableProps: tableProps,
        isLoading: isLoading
    };
};



var $7tOHe = parcelRequire("7tOHe");

var $c9Z8w = parcelRequire("c9Z8w");
const $8383c6ec8370a1a6$export$82355be54893c04f = ({ gridRef: gridRef })=>{
    const { tableProps: tableProps, isLoading: isLoading } = (0, $34e14d41b659defc$export$dd09d560197f8b22)();
    if (isLoading) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {});
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l05Px.default), {
        ...tableProps,
        gridRef: gridRef
    });
};
$8383c6ec8370a1a6$export$82355be54893c04f.propTypes = {
    gridRef: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};



var $c9Z8w = parcelRequire("c9Z8w");
const $05c0055ebf9e635e$var$Breakdown = ({ setAgentData: setAgentData })=>{
    const firstTabRef = (0, $acw62.useRef)();
    const secondTabRef = (0, $acw62.useRef)();
    const thirdTabRef = (0, $acw62.useRef)();
    const { pathname: pathname, state: locationState } = (0, $kfZjc.useLocation)();
    const isOfficeListBreakdown = (0, $1fa46cf08ea2571a$export$4cf4f9869242a323)(pathname);
    const fromOfficeBreakdownAndGrowthTab = locationState?.fromOfficeBreakdownAndGrowthTab;
    const gridRefByTab = {
        [(0, $53A0d.tabs).GAINED_AGENTS]: firstTabRef,
        [(0, $53A0d.tabs).LOST_AGENTS]: secondTabRef,
        [(0, $53A0d.tabs).OFFICE_DETAILS]: thirdTabRef
    };
    const { selectedBreakdownTab: selectedBreakdownTab, setSelectedBreakdownTab: setSelectedBreakdownTab, shouldShowAdditionalInfo: shouldShowAdditionalInfo, isFooterDisabled: isFooterDisabled, selectedBreakdownOffice: selectedBreakdownOffice } = (0, $90ISC.useSearchStore)((state)=>{
        const { [state.selectedModule]: moduleState } = state;
        const { breakdowns: breakdowns = {} } = moduleState;
        const { selectedBreakdownTab: selectedBreakdownTab, tabsByRoute: tabsByRoute, selectedBreakdownOffice: selectedBreakdownOffice } = breakdowns;
        const breakdownTabData = tabsByRoute?.[pathname]?.[selectedBreakdownTab];
        return {
            selectedBreakdownTab: selectedBreakdownTab,
            setSelectedBreakdownTab: state.setSelectedBreakdownTab,
            shouldShowAdditionalInfo: breakdownTabData?.shouldShowAdditionalInfo ?? false,
            isFooterDisabled: breakdownTabData?.isFooterDisabled ?? false,
            selectedBreakdownOffice: selectedBreakdownOffice
        };
    });
    const isOfficeDetailsTab = selectedBreakdownTab === (0, $53A0d.tabs).OFFICE_DETAILS;
    const { data: data, isLoading: isLoading } = (0, $b1947d5b053c1dba$export$8780a8ebd57443d0)({
        parameterName: "targetOffice",
        pathname: pathname,
        isOfficeListBreakdown: isOfficeListBreakdown,
        setAgentData: setAgentData
    });
    const officeInfoData = (0, $d64c72da30dddc73$export$5f720e4455b11fac)();
    const setCurrentTab = (currentTab)=>{
        setSelectedBreakdownTab(currentTab);
    };
    const officeTabItem = {
        title: (0, $hQz0O.terms).officeDetails,
        content: {
            jsx: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                children: officeInfoData && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8f79bf419c55fe4c$export$b30da04fadebe02d), {
                    data: officeInfoData
                })
            })
        }
    };
    const officeBreakdownAndGrowthTabItem = {
        title: (0, $hQz0O.terms).officeBreakdownAndGrowth,
        content: {
            jsx: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8383c6ec8370a1a6$export$82355be54893c04f), {
                    gridRef: thirdTabRef
                })
            })
        }
    };
    const commonBreakdownResultsProps = {
        data: data,
        isLoading: isLoading,
        isOfficeListBreakdown: isOfficeListBreakdown
    };
    const tabItems = [
        {
            title: (0, $hQz0O.terms).gainedAgents,
            content: {
                jsx: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ba502fa32b20b43$export$58e3d2ed27201b6e), {
                    ...commonBreakdownResultsProps,
                    gridRef: firstTabRef,
                    tableView: (0, $4tbBr.tableViews).agentsGainedBreakdown(shouldShowAdditionalInfo)
                })
            }
        },
        {
            title: (0, $hQz0O.terms).lostAgents,
            content: {
                jsx: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1ba502fa32b20b43$export$58e3d2ed27201b6e), {
                    ...commonBreakdownResultsProps,
                    gridRef: secondTabRef,
                    tableView: (0, $4tbBr.tableViews).lostAgentsBreakdown(shouldShowAdditionalInfo)
                })
            }
        },
        isOfficeListBreakdown ? officeBreakdownAndGrowthTabItem : officeTabItem
    ];
    const exportDetails = {
        exportType: fromOfficeBreakdownAndGrowthTab ? (0, $94088b34ebad1923$export$382f55aa456f5721).fromBreakdownGrowthResults : (0, $94088b34ebad1923$export$382f55aa456f5721).breakdownResults,
        listingType: "agents",
        listingStatus: "",
        currentBreakdownTab: tabItems[selectedBreakdownTab],
        office: selectedBreakdownOffice,
        date: (0, $htzEo.csvExportDateFormat)(new Date),
        isOfficeListBreakdown: isOfficeListBreakdown,
        fromOfficeBreakdownAndGrowthTab: fromOfficeBreakdownAndGrowthTab
    };
    const exportButton = (0, $0d036ea0861162a7$export$e89cb83db8826f3)({
        exportDetails: exportDetails,
        shouldUsePrimaryColumns: true,
        gridRef: gridRefByTab?.[selectedBreakdownTab].current,
        type: (0, $i95vK.exportButtonTypes).primary,
        isDisabled: isFooterDisabled,
        isTabExport: true
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "px-3 agent-breakdown-wrapper",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8f390b0d641c1be9$export$2e2bcd8739ae039), {
                tabs: true,
                currentIndex: selectedBreakdownTab,
                setCurrentIndex: setCurrentTab,
                className: "mt-4 mb-4",
                items: tabItems
            }),
            !isOfficeDetailsTab && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $859b3aeec7a854d9$export$2e2bcd8739ae039), {
                columnProps: [
                    {
                        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "ml-auto d-flex w-auto align-self-center",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "ml-auto d-flex justify-content-center align-items-center",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $40ec4f66f8138737$export$2e2bcd8739ae039), {})
                                }),
                                exportButton
                            ]
                        }),
                        sm: 12,
                        align: "right"
                    }
                ]
            })
        ]
    });
};
$05c0055ebf9e635e$var$Breakdown.propTypes = {
    setAgentData: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired
};
var $05c0055ebf9e635e$export$2e2bcd8739ae039 = $05c0055ebf9e635e$var$Breakdown;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $cstaF = parcelRequire("cstaF");
parcelRequire("3PprX");
var $90ODN = parcelRequire("90ODN");

var $c9Z8w = parcelRequire("c9Z8w");

var $1byMr = parcelRequire("1byMr");

var $ivaD7 = parcelRequire("ivaD7");


var $eHBjM = parcelRequire("eHBjM");

var $dI25G = parcelRequire("dI25G");

var $eOjgM = parcelRequire("eOjgM");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");


var $kZ6Rz = parcelRequire("kZ6Rz");

var $g3CkB = parcelRequire("g3CkB");
parcelRequire("fHiKR");
var $1BYDb = parcelRequire("1BYDb");
parcelRequire("3lOdM");
var $1iwUl = parcelRequire("1iwUl");
var $e155p = parcelRequire("e155p");
parcelRequire("2OwWq");
var $7kkwd = parcelRequire("7kkwd");
const $7d6307edad225e5c$export$db2ac62fc77a895b = ({ columns: columns, setColumns: setColumns })=>{
    const ref = (0, $acw62.useRef)();
    const metricsGroups = columns.reduce((acc, column)=>{
        if (!column.metrics?.id) return acc;
        if (!acc[column.metrics.id]) acc[column.metrics.id] = {
            ...column.metrics,
            columns: []
        };
        acc[column.metrics.id].columns.push(column);
        return acc;
    }, {});
    (0, $acw62.useEffect)(()=>{
        (0, $dc8851251b4817c5$export$2e2bcd8739ae039).rebuild();
    }, []);
    const renderMetricsTooltip = (data)=>{
        const metricDescription = JSON.parse(data);
        return metricDescription?.metricDescription && (0, (/*@__PURE__*/$parcel$interopDefault($kZ6Rz))).renderToString(/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "text-left",
            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "w-100",
                children: metricDescription.metricDescription
            })
        }));
    };
    const writeInput = (column, index)=>{
        const elementId = `agent-movement-metrics-selector-${column.id}`;
        const label = (0, $g3CkB.getLabelTextWithDate)(column);
        const tooltipProps = {
            "data-for": "metrics-selector-tooltip",
            "data-tip": JSON.stringify({
                metricDescription: (0, $g3CkB.getTooltipText)(column)
            })
        };
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    ...tooltipProps,
                    ref: ref,
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1BYDb))), {
                        dataLwtId: elementId,
                        id: elementId,
                        value: column.id,
                        defaultChecked: column.isDisplayed,
                        disabled: false,
                        type: "checkbox",
                        label: label,
                        onClick: (e)=>setColumns({
                                columnId: column.id,
                                isDisplayed: e.target.checked
                            })
                    }, index)
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dc8851251b4817c5$export$2e2bcd8739ae039), {
                    id: "metrics-selector-tooltip",
                    className: "metrics-selector-tooltip",
                    type: "info",
                    effect: "solid",
                    place: "left",
                    backgroundColor: "black",
                    getContent: renderMetricsTooltip,
                    html: true
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e155p))), {
            children: Object.values(metricsGroups).map((group, index)=>/*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1iwUl))), {
                    ...group.colProps,
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($7kkwd))), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                dataLwtId: "lbl-total-list",
                                className: "filter-header",
                                children: group.label
                            }),
                            group.columns.map((column, index)=>writeInput(column, index))
                        ]
                    })
                }, index))
        })
    });
};
$7d6307edad225e5c$export$db2ac62fc77a895b.propTypes = {
    columns: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array.isRequired,
    setColumns: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired
};



var $cstaF = parcelRequire("cstaF");
const $6e9ec9aef85e470e$var$Metrics = ({ columns: columns, setColumns: setColumns })=>{
    const handleSetColumns = ({ columnId: columnId, isDisplayed: isDisplayed })=>{
        setColumns(columnId, {
            isDisplayed: isDisplayed
        });
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "pt-3",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h6", {
                children: (0, $cstaF.agentProductionTerms).metrics
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7d6307edad225e5c$export$db2ac62fc77a895b), {
                columns: columns,
                setColumns: handleSetColumns
            })
        ]
    });
};
$6e9ec9aef85e470e$var$Metrics.propTypes = {
    columns: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    setColumns: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func
};
var $6e9ec9aef85e470e$export$2e2bcd8739ae039 = $6e9ec9aef85e470e$var$Metrics;


const $b45af4c0b62bef82$var$TitleRow = ({ hasResults: hasResults, selectedPeriod: selectedPeriod, setState: setState, shouldDisplayMetricsPopover: shouldDisplayMetricsPopover, exportButton: exportButton, savedSearchTitle: savedSearchTitle, loadedSearchCriteria: loadedSearchCriteria, columns: columns, setColumns: setColumns })=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "row w-100 ml-0 my-2 pr-1 py-0",
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "labels-buttons-container",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "d-flex align-items-center",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                            className: "title-row text-truncate mb-0 font-gray-primary",
                            children: (0, $cstaF.searchTypes)[location.pathname].title
                        }),
                        hasResults && /*#__PURE__*/ (0, $ayMG0.jsx)("h6", {
                            className: "text-truncate mb-0 helix-body",
                            children: savedSearchTitle ?? (0, $cstaF.searchTerms).unsaved
                        })
                    ]
                }),
                hasResults && !!loadedSearchCriteria && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "d-flex",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($90ODN))), {
                            dataLwtId: (0, $1byMr.filterIds).period,
                            toggleProps: {
                                dataLwtId: "no-split-toggle",
                                id: "caret",
                                caret: true,
                                children: selectedPeriod,
                                className: "bg-dark btn btn-sm btn-secondary mr-2"
                            },
                            items: [
                                {
                                    dataLwtId: (0, $1byMr.filterIds).last365,
                                    itemText: (0, $1byMr.terms).last365Days,
                                    key: "item_1",
                                    onClick: ()=>(0, $ivaD7.setStateData)("selectedPeriod", (0, $1byMr.terms).last365Days, setState)
                                }
                            ],
                            menuProps: {
                                dataLwtId: (0, $1byMr.filterIds).menu,
                                right: true
                            }
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $663ae31d31f02628$export$2e2bcd8739ae039), {
                            dataLwtId: (0, $1byMr.filterIds).metrics,
                            popoverInnerClassName: "popover-menu-width-800 helix-heading",
                            popoverPlacement: (0, $eHBjM.popoverTerms).bottomEnd,
                            popoverIsOpen: shouldDisplayMetricsPopover,
                            togglePopover: ()=>(0, $ivaD7.setStateData)("shouldDisplayMetricsPopover", !shouldDisplayMetricsPopover, setState),
                            mainTitle: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                                icon: (0, $eOjgM.columns),
                                className: "mr-2"
                            }),
                            popoverBody: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6e9ec9aef85e470e$export$2e2bcd8739ae039), {
                                columns: columns,
                                setColumns: setColumns
                            })
                        }),
                        exportButton
                    ]
                })
            ]
        })
    });
$b45af4c0b62bef82$var$TitleRow.propTypes = {
    hasResults: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    selectedPeriod: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    setState: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired,
    shouldDisplayMetricsPopover: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool.isRequired,
    exportButton: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node,
    savedSearchTitle: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    loadedSearchCriteria: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    columns: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array.isRequired,
    setColumns: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func.isRequired
};
var $b45af4c0b62bef82$export$2e2bcd8739ae039 = $b45af4c0b62bef82$var$TitleRow;



var $1byMr = parcelRequire("1byMr");

var $90ISC = parcelRequire("90ISC");

var $7tOHe = parcelRequire("7tOHe");



var $i95vK = parcelRequire("i95vK");


var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");


var $l05Px = parcelRequire("l05Px");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
parcelRequire("3lOdM");
var $1iwUl = parcelRequire("1iwUl");
var $e155p = parcelRequire("e155p");

var $3r6bj = parcelRequire("3r6bj");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $rMeTm = parcelRequire("rMeTm");

var $htzEo = parcelRequire("htzEo");

var $c9Z8w = parcelRequire("c9Z8w");
const $00fe793f172dcbc3$export$57c8021ffdd2c698 = ({ label: label, value: value, isCurrency: isCurrency, tooltip: tooltip })=>{
    const formattedValue = isCurrency ? (0, $htzEo.getCurrencyFormat)(value) : value;
    const className = `agent-movement-indicator p-3 ${isCurrency ? "currency-value" : ""}`;
    const tooltipId = `agent-movement-${label.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: className,
        children: [
            tooltip && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $rMeTm.default), {
                target: tooltipId,
                placement: "top",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "helix-small",
                    children: tooltip
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "helix-display-x-small",
                children: formattedValue
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                id: tooltipId,
                className: "helix-body",
                children: label
            })
        ]
    });
};
$00fe793f172dcbc3$export$57c8021ffdd2c698.propTypes = {
    label: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
    ]).isRequired,
    isCurrency: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool,
    tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired
};



var $jKEVi = parcelRequire("jKEVi");

var $htzEo = parcelRequire("htzEo");

var $hQz0O = parcelRequire("hQz0O");
var $f7b5084cb6aad888$exports = {};
"use strict";
function $f7b5084cb6aad888$var$_interopDefault(ex) {
    return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
}

var $kfZjc = parcelRequire("kfZjc");

var $f7b5084cb6aad888$var$React = $f7b5084cb6aad888$var$_interopDefault((parcelRequire("acw62")));

var $3np4r = parcelRequire("3np4r");

var $f7b5084cb6aad888$var$PropTypes = $f7b5084cb6aad888$var$_interopDefault((parcelRequire("c9Z8w")));

var $f7b5084cb6aad888$var$warning = $f7b5084cb6aad888$var$_interopDefault((parcelRequire("9RYKL")));

var $f7b5084cb6aad888$var$invariant = $f7b5084cb6aad888$var$_interopDefault((parcelRequire("bv4qN")));
function $f7b5084cb6aad888$var$_extends() {
    $f7b5084cb6aad888$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f7b5084cb6aad888$var$_extends.apply(this, arguments);
}
function $f7b5084cb6aad888$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $f7b5084cb6aad888$var$_setPrototypeOf(subClass, superClass);
}
function $f7b5084cb6aad888$var$_setPrototypeOf(o, p) {
    $f7b5084cb6aad888$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $f7b5084cb6aad888$var$_setPrototypeOf(o, p);
}
function $f7b5084cb6aad888$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * The public API for a <Router> that uses HTML5 history.
 */ var $f7b5084cb6aad888$var$BrowserRouter = /*#__PURE__*/ function(_React$Component) {
    $f7b5084cb6aad888$var$_inheritsLoose(BrowserRouter, _React$Component);
    function BrowserRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = $3np4r.createBrowserHistory(_this.props);
        return _this;
    }
    var _proto = BrowserRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ $f7b5084cb6aad888$var$React.createElement($kfZjc.Router, {
            history: this.history,
            children: this.props.children
        });
    };
    return BrowserRouter;
}($f7b5084cb6aad888$var$React.Component);
$f7b5084cb6aad888$var$BrowserRouter.propTypes = {
    basename: $f7b5084cb6aad888$var$PropTypes.string,
    children: $f7b5084cb6aad888$var$PropTypes.node,
    forceRefresh: $f7b5084cb6aad888$var$PropTypes.bool,
    getUserConfirmation: $f7b5084cb6aad888$var$PropTypes.func,
    keyLength: $f7b5084cb6aad888$var$PropTypes.number
};
$f7b5084cb6aad888$var$BrowserRouter.prototype.componentDidMount = function() {
    $f7b5084cb6aad888$var$warning(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, use `import { Router }` instead of `import { BrowserRouter as Router }`.");
};
/**
 * The public API for a <Router> that uses window.location.hash.
 */ var $f7b5084cb6aad888$var$HashRouter = /*#__PURE__*/ function(_React$Component) {
    $f7b5084cb6aad888$var$_inheritsLoose(HashRouter, _React$Component);
    function HashRouter() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.history = $3np4r.createHashHistory(_this.props);
        return _this;
    }
    var _proto = HashRouter.prototype;
    _proto.render = function render() {
        return /*#__PURE__*/ $f7b5084cb6aad888$var$React.createElement($kfZjc.Router, {
            history: this.history,
            children: this.props.children
        });
    };
    return HashRouter;
}($f7b5084cb6aad888$var$React.Component);
$f7b5084cb6aad888$var$HashRouter.propTypes = {
    basename: $f7b5084cb6aad888$var$PropTypes.string,
    children: $f7b5084cb6aad888$var$PropTypes.node,
    getUserConfirmation: $f7b5084cb6aad888$var$PropTypes.func,
    hashType: $f7b5084cb6aad888$var$PropTypes.oneOf([
        "hashbang",
        "noslash",
        "slash"
    ])
};
$f7b5084cb6aad888$var$HashRouter.prototype.componentDidMount = function() {
    $f7b5084cb6aad888$var$warning(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, use `import { Router }` instead of `import { HashRouter as Router }`.");
};
var $f7b5084cb6aad888$var$resolveToLocation = function resolveToLocation(to, currentLocation) {
    return typeof to === "function" ? to(currentLocation) : to;
};
var $f7b5084cb6aad888$var$normalizeToLocation = function normalizeToLocation(to, currentLocation) {
    return typeof to === "string" ? $3np4r.createLocation(to, null, null, currentLocation) : to;
};
var $f7b5084cb6aad888$var$forwardRefShim = function forwardRefShim(C) {
    return C;
};
var $f7b5084cb6aad888$var$forwardRef = $f7b5084cb6aad888$var$React.forwardRef;
if (typeof $f7b5084cb6aad888$var$forwardRef === "undefined") $f7b5084cb6aad888$var$forwardRef = $f7b5084cb6aad888$var$forwardRefShim;
function $f7b5084cb6aad888$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
var $f7b5084cb6aad888$var$LinkAnchor = $f7b5084cb6aad888$var$forwardRef(function(_ref, forwardedRef) {
    var innerRef = _ref.innerRef, navigate = _ref.navigate, _onClick = _ref.onClick, rest = $f7b5084cb6aad888$var$_objectWithoutPropertiesLoose(_ref, [
        "innerRef",
        "navigate",
        "onClick"
    ]);
    var target = rest.target;
    var props = $f7b5084cb6aad888$var$_extends({}, rest, {
        onClick: function onClick(event) {
            try {
                if (_onClick) _onClick(event);
            } catch (ex) {
                event.preventDefault();
                throw ex;
            }
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && (!target || target === "_self") && // let browser handle "target=_blank" etc.
            !$f7b5084cb6aad888$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                navigate();
            }
        }
    }); // React 15 compat
    if ($f7b5084cb6aad888$var$forwardRefShim !== $f7b5084cb6aad888$var$forwardRef) props.ref = forwardedRef || innerRef;
    else props.ref = innerRef;
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */ return /*#__PURE__*/ $f7b5084cb6aad888$var$React.createElement("a", props);
});
$f7b5084cb6aad888$var$LinkAnchor.displayName = "LinkAnchor";
/**
 * The public API for rendering a history-aware <a>.
 */ var $f7b5084cb6aad888$var$Link = $f7b5084cb6aad888$var$forwardRef(function(_ref2, forwardedRef) {
    var _ref2$component = _ref2.component, component = _ref2$component === void 0 ? $f7b5084cb6aad888$var$LinkAnchor : _ref2$component, replace = _ref2.replace, to = _ref2.to, innerRef = _ref2.innerRef, rest = $f7b5084cb6aad888$var$_objectWithoutPropertiesLoose(_ref2, [
        "component",
        "replace",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ $f7b5084cb6aad888$var$React.createElement($kfZjc.__RouterContext.Consumer, null, function(context) {
        !context && $f7b5084cb6aad888$var$invariant(false, "You should not use <Link> outside a <Router>");
        var history$1 = context.history;
        var location = $f7b5084cb6aad888$var$normalizeToLocation($f7b5084cb6aad888$var$resolveToLocation(to, context.location), context.location);
        var href = location ? history$1.createHref(location) : "";
        var props = $f7b5084cb6aad888$var$_extends({}, rest, {
            href: href,
            navigate: function navigate() {
                var location = $f7b5084cb6aad888$var$resolveToLocation(to, context.location);
                var isDuplicateNavigation = $3np4r.createPath(context.location) === $3np4r.createPath($f7b5084cb6aad888$var$normalizeToLocation(location));
                var method = replace || isDuplicateNavigation ? history$1.replace : history$1.push;
                method(location);
            }
        }); // React 15 compat
        if ($f7b5084cb6aad888$var$forwardRefShim !== $f7b5084cb6aad888$var$forwardRef) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ $f7b5084cb6aad888$var$React.createElement(component, props);
    });
});
var $f7b5084cb6aad888$var$toType = $f7b5084cb6aad888$var$PropTypes.oneOfType([
    $f7b5084cb6aad888$var$PropTypes.string,
    $f7b5084cb6aad888$var$PropTypes.object,
    $f7b5084cb6aad888$var$PropTypes.func
]);
var $f7b5084cb6aad888$var$refType = $f7b5084cb6aad888$var$PropTypes.oneOfType([
    $f7b5084cb6aad888$var$PropTypes.string,
    $f7b5084cb6aad888$var$PropTypes.func,
    $f7b5084cb6aad888$var$PropTypes.shape({
        current: $f7b5084cb6aad888$var$PropTypes.any
    })
]);
$f7b5084cb6aad888$var$Link.displayName = "Link";
$f7b5084cb6aad888$var$Link.propTypes = {
    innerRef: $f7b5084cb6aad888$var$refType,
    onClick: $f7b5084cb6aad888$var$PropTypes.func,
    replace: $f7b5084cb6aad888$var$PropTypes.bool,
    target: $f7b5084cb6aad888$var$PropTypes.string,
    to: $f7b5084cb6aad888$var$toType.isRequired
};
var $f7b5084cb6aad888$var$forwardRefShim$1 = function forwardRefShim(C) {
    return C;
};
var $f7b5084cb6aad888$var$forwardRef$1 = $f7b5084cb6aad888$var$React.forwardRef;
if (typeof $f7b5084cb6aad888$var$forwardRef$1 === "undefined") $f7b5084cb6aad888$var$forwardRef$1 = $f7b5084cb6aad888$var$forwardRefShim$1;
function $f7b5084cb6aad888$var$joinClassnames() {
    for(var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++)classnames[_key] = arguments[_key];
    return classnames.filter(function(i) {
        return i;
    }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var $f7b5084cb6aad888$var$NavLink = $f7b5084cb6aad888$var$forwardRef$1(function(_ref, forwardedRef) {
    var _ref$ariaCurrent = _ref["aria-current"], ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent, _ref$activeClassName = _ref.activeClassName, activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName, activeStyle = _ref.activeStyle, classNameProp = _ref.className, exact = _ref.exact, isActiveProp = _ref.isActive, locationProp = _ref.location, sensitive = _ref.sensitive, strict = _ref.strict, styleProp = _ref.style, to = _ref.to, innerRef = _ref.innerRef, rest = $f7b5084cb6aad888$var$_objectWithoutPropertiesLoose(_ref, [
        "aria-current",
        "activeClassName",
        "activeStyle",
        "className",
        "exact",
        "isActive",
        "location",
        "sensitive",
        "strict",
        "style",
        "to",
        "innerRef"
    ]);
    return /*#__PURE__*/ $f7b5084cb6aad888$var$React.createElement($kfZjc.__RouterContext.Consumer, null, function(context) {
        !context && $f7b5084cb6aad888$var$invariant(false, "You should not use <NavLink> outside a <Router>");
        var currentLocation = locationProp || context.location;
        var toLocation = $f7b5084cb6aad888$var$normalizeToLocation($f7b5084cb6aad888$var$resolveToLocation(to, currentLocation), currentLocation);
        var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
        var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
        var match = escapedPath ? $kfZjc.matchPath(currentLocation.pathname, {
            path: escapedPath,
            exact: exact,
            sensitive: sensitive,
            strict: strict
        }) : null;
        var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
        var className = typeof classNameProp === "function" ? classNameProp(isActive) : classNameProp;
        var style = typeof styleProp === "function" ? styleProp(isActive) : styleProp;
        if (isActive) {
            className = $f7b5084cb6aad888$var$joinClassnames(className, activeClassName);
            style = $f7b5084cb6aad888$var$_extends({}, style, activeStyle);
        }
        var props = $f7b5084cb6aad888$var$_extends({
            "aria-current": isActive && ariaCurrent || null,
            className: className,
            style: style,
            to: toLocation
        }, rest); // React 15 compat
        if ($f7b5084cb6aad888$var$forwardRefShim$1 !== $f7b5084cb6aad888$var$forwardRef$1) props.ref = forwardedRef || innerRef;
        else props.innerRef = innerRef;
        return /*#__PURE__*/ $f7b5084cb6aad888$var$React.createElement($f7b5084cb6aad888$var$Link, props);
    });
});
$f7b5084cb6aad888$var$NavLink.displayName = "NavLink";
var $f7b5084cb6aad888$var$ariaCurrentType = $f7b5084cb6aad888$var$PropTypes.oneOf([
    "page",
    "step",
    "location",
    "date",
    "time",
    "true",
    "false"
]);
$f7b5084cb6aad888$var$NavLink.propTypes = $f7b5084cb6aad888$var$_extends({}, $f7b5084cb6aad888$var$Link.propTypes, {
    "aria-current": $f7b5084cb6aad888$var$ariaCurrentType,
    activeClassName: $f7b5084cb6aad888$var$PropTypes.string,
    activeStyle: $f7b5084cb6aad888$var$PropTypes.object,
    className: $f7b5084cb6aad888$var$PropTypes.oneOfType([
        $f7b5084cb6aad888$var$PropTypes.string,
        $f7b5084cb6aad888$var$PropTypes.func
    ]),
    exact: $f7b5084cb6aad888$var$PropTypes.bool,
    isActive: $f7b5084cb6aad888$var$PropTypes.func,
    location: $f7b5084cb6aad888$var$PropTypes.object,
    sensitive: $f7b5084cb6aad888$var$PropTypes.bool,
    strict: $f7b5084cb6aad888$var$PropTypes.bool,
    style: $f7b5084cb6aad888$var$PropTypes.oneOfType([
        $f7b5084cb6aad888$var$PropTypes.object,
        $f7b5084cb6aad888$var$PropTypes.func
    ])
});
Object.defineProperty($f7b5084cb6aad888$exports, "MemoryRouter", {
    enumerable: true,
    get: function() {
        return $kfZjc.MemoryRouter;
    }
});
Object.defineProperty($f7b5084cb6aad888$exports, "Prompt", {
    enumerable: true,
    get: function() {
        return $kfZjc.Prompt;
    }
});
Object.defineProperty($f7b5084cb6aad888$exports, "Redirect", {
    enumerable: true,
    get: function() {
        return $kfZjc.Redirect;
    }
});
Object.defineProperty($f7b5084cb6aad888$exports, "Route", {
    enumerable: true,
    get: function() {
        return $kfZjc.Route;
    }
});
Object.defineProperty($f7b5084cb6aad888$exports, "Router", {
    enumerable: true,
    get: function() {
        return $kfZjc.Router;
    }
});
Object.defineProperty($f7b5084cb6aad888$exports, "StaticRouter", {
    enumerable: true,
    get: function() {
        return $kfZjc.StaticRouter;
    }
});
Object.defineProperty($f7b5084cb6aad888$exports, "Switch", {
    enumerable: true,
    get: function() {
        return $kfZjc.Switch;
    }
});
Object.defineProperty($f7b5084cb6aad888$exports, "generatePath", {
    enumerable: true,
    get: function() {
        return $kfZjc.generatePath;
    }
});
Object.defineProperty($f7b5084cb6aad888$exports, "matchPath", {
    enumerable: true,
    get: function() {
        return $kfZjc.matchPath;
    }
});
Object.defineProperty($f7b5084cb6aad888$exports, "useHistory", {
    enumerable: true,
    get: function() {
        return $kfZjc.useHistory;
    }
});
Object.defineProperty($f7b5084cb6aad888$exports, "useLocation", {
    enumerable: true,
    get: function() {
        return $kfZjc.useLocation;
    }
});
Object.defineProperty($f7b5084cb6aad888$exports, "useParams", {
    enumerable: true,
    get: function() {
        return $kfZjc.useParams;
    }
});
Object.defineProperty($f7b5084cb6aad888$exports, "useRouteMatch", {
    enumerable: true,
    get: function() {
        return $kfZjc.useRouteMatch;
    }
});
Object.defineProperty($f7b5084cb6aad888$exports, "withRouter", {
    enumerable: true,
    get: function() {
        return $kfZjc.withRouter;
    }
});
$f7b5084cb6aad888$exports.BrowserRouter = $f7b5084cb6aad888$var$BrowserRouter;
$f7b5084cb6aad888$exports.HashRouter = $f7b5084cb6aad888$var$HashRouter;
$f7b5084cb6aad888$exports.Link = $f7b5084cb6aad888$var$Link;
$f7b5084cb6aad888$exports.NavLink = $f7b5084cb6aad888$var$NavLink;



var $cstaF = parcelRequire("cstaF");



var $bA5Mi = parcelRequire("bA5Mi");

var $7tOHe = parcelRequire("7tOHe");

const $637cfe3baffbf6c1$var$SIDEBAR_EXPANDED_WIDTH = 300;
const $637cfe3baffbf6c1$var$SIDEBAR_COLLAPSED_WIDTH = 68;
const $637cfe3baffbf6c1$var$SCROLL_BREAKPOINT = 1200;
const $637cfe3baffbf6c1$var$MINIMUM_CHART_WIDTH = 1100;
const $637cfe3baffbf6c1$var$CHART_SCROLL_VIEWPORT_WIDTH = 500;
const $637cfe3baffbf6c1$var$AVAILABLE_WIDTH_BUFFER = 200;
const $637cfe3baffbf6c1$var$COL_HORIZONTAL_PADDING = 30;
const $637cfe3baffbf6c1$export$f12ccd636093532e = ({ chartProps: chartProps })=>{
    const history = (0, $f7b5084cb6aad888$exports.useHistory)();
    const { isSideNavExpanded: isSideNavExpanded, isTransitioning: isTransitioning } = (0, $0fd5bff891bbaebc$export$417cdd20f97a1a9)();
    const [windowWidth, setWindowWidth] = (0, $acw62.useState)(window.innerWidth);
    const sidebarWidth = isSideNavExpanded ? $637cfe3baffbf6c1$var$SIDEBAR_EXPANDED_WIDTH : $637cfe3baffbf6c1$var$SIDEBAR_COLLAPSED_WIDTH;
    const availableWidth = windowWidth - sidebarWidth + $637cfe3baffbf6c1$var$AVAILABLE_WIDTH_BUFFER - $637cfe3baffbf6c1$var$COL_HORIZONTAL_PADDING;
    const needsScroll = availableWidth < $637cfe3baffbf6c1$var$SCROLL_BREAKPOINT;
    const getAdjustedChartProps = (baseProps, needsScroll)=>{
        const adjustedProps = {
            ...baseProps
        };
        adjustedProps.width = needsScroll ? `${$637cfe3baffbf6c1$var$MINIMUM_CHART_WIDTH}px` : "100%";
        return adjustedProps;
    };
    const adjustedChartProps = getAdjustedChartProps(chartProps, needsScroll);
    (0, $acw62.useEffect)(()=>{
        const handleResize = ()=>setWindowWidth(window.innerWidth);
        window.addEventListener("resize", handleResize, true);
        return ()=>window.removeEventListener("resize", handleResize, true);
    }, []);
    const chartPropsPDF = (0, $0d036ea0861162a7$export$bab0ef488509bc69)({
        chartProps: chartProps,
        dataLabelsFontSize: "22px",
        dataLabelsOffsetY: -20,
        gridPadding: {
            top: 0,
            bottom: 60
        },
        height: 700,
        xAxisLabelsFontSize: "19px"
    });
    const { indicators: indicators, selectedOfficeListSearch: selectedOfficeListSearch } = (0, $jKEVi.useSearchStore)((state)=>{
        const moduleState = state[state.selectedModule];
        return {
            indicators: (0, $htzEo.getDashboardIndicators)(moduleState?.totals, (0, $hQz0O.indicatorsSettingsByKeyName)),
            selectedOfficeListSearch: moduleState.search.selectedOfficeListSearch
        };
    });
    const { isPDFLoading: isPDFLoading } = (0, $bA5Mi.usePDFStore)((state)=>({
            isPDFLoading: state.downloadModalStatus.isPDFLoading
        }));
    const handleOfficeListBreakdownRedirect = ()=>history.push((0, $cstaF.searchRoutes).officeListBreakdown);
    const searchDescriptionTitle = (0, $1fa46cf08ea2571a$export$57f655b15acb7f3c)(indicators, selectedOfficeListSearch);
    const renderIndicators = ()=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
            className: "indicators-container",
            style: {
                display: "flex",
                flexWrap: "wrap",
                gap: "1rem",
                justifyContent: "flex-end"
            },
            children: indicators.map((total)=>/*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    style: {
                        flex: "0 0 250px",
                        minWidth: "250px"
                    },
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $00fe793f172dcbc3$export$57c8021ffdd2c698), {
                        label: total.label,
                        value: total.value,
                        tooltip: total.tooltip,
                        isCurrency: total.isCurrency
                    })
                }, total.key))
        });
    const chartIndicators = renderIndicators();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "agent-movement-dashboard raised-border",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($e155p))), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1iwUl))), {
                                xs: 12,
                                md: 5,
                                lg: 4,
                                className: "d-flex justify-content-center",
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "gained-agents",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                                            className: "helix-display-x-small mb-0",
                                            children: searchDescriptionTitle
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                            onClick: handleOfficeListBreakdownRedirect,
                                            className: "view-breakdown clickable mb-0",
                                            children: (0, $hQz0O.terms).viewBreakdown
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1iwUl))), {
                                xs: 12,
                                md: 7,
                                lg: 8,
                                className: "d-flex justify-content-center justify-content-lg-end",
                                children: chartIndicators
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e155p))), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1iwUl))), {
                            xs: 12,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                id: "agent-movement-chart-graph",
                                className: `raised-border mb-3 bg-white ${needsScroll ? "needs-scroll" : "no-scroll"}`,
                                children: !isTransitioning ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: `chart-wrapper ${needsScroll ? "needs-scroll" : ""}`,
                                    style: needsScroll ? {
                                        width: `${$637cfe3baffbf6c1$var$CHART_SCROLL_VIEWPORT_WIDTH}px`
                                    } : {},
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3r6bj))), {
                                        ...adjustedChartProps,
                                        width: needsScroll ? `${$637cfe3baffbf6c1$var$MINIMUM_CHART_WIDTH}px` : "100%",
                                        options: {
                                            ...adjustedChartProps.options,
                                            chart: {
                                                ...adjustedChartProps.options.chart,
                                                width: needsScroll ? `${$637cfe3baffbf6c1$var$MINIMUM_CHART_WIDTH}px` : "100%"
                                            }
                                        }
                                    })
                                }) : /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    style: {
                                        minHeight: `${chartProps?.height || 390}px`,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center"
                                    },
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {})
                                })
                            })
                        })
                    })
                ]
            }),
            isPDFLoading && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "pdf-chart-agent-movement chart-capture-area",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($e155p))), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1iwUl))), {
                                sm: 12,
                                md: 5,
                                lg: 4,
                                className: "d-flex justify-content-left",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("h5", {
                                        className: "helix-display-x-small mb-0",
                                        children: searchDescriptionTitle
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1iwUl))), {
                                sm: 12,
                                md: 7,
                                lg: 8,
                                className: "d-flex justify-content-center justify-content-lg-end",
                                children: chartIndicators
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e155p))), {
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1iwUl))), {
                            xs: 12,
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3r6bj))), {
                                ...chartPropsPDF
                            })
                        })
                    })
                ]
            })
        ]
    });
};
$637cfe3baffbf6c1$export$f12ccd636093532e.propTypes = {
    chartProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $637cfe3baffbf6c1$export$2e2bcd8739ae039 = $637cfe3baffbf6c1$export$f12ccd636093532e;



const $16baeecc2d754d44$export$ec0b9adac8c32387 = ({ titleRowProps: titleRowProps, tableProps: tableProps, chartProps: chartProps })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b45af4c0b62bef82$export$2e2bcd8739ae039), {
                ...titleRowProps,
                columns: tableProps?.columns,
                setColumns: tableProps?.setColumns
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $637cfe3baffbf6c1$export$f12ccd636093532e), {
                chartProps: chartProps
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "agent-movement-table",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $l05Px.default), {
                    ...tableProps
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $9b760a8ddf238ef9$export$a1bb54ba7ed9cdd6), {})
        ]
    });
};
$16baeecc2d754d44$export$ec0b9adac8c32387.propTypes = {
    titleRowProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    tableProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    chartProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $16baeecc2d754d44$export$2e2bcd8739ae039 = $16baeecc2d754d44$export$ec0b9adac8c32387;



var $cstaF = parcelRequire("cstaF");

var $acw62 = parcelRequire("acw62");

var $90ISC = parcelRequire("90ISC");

var $9phu9 = parcelRequire("9phu9");

var $cstaF = parcelRequire("cstaF");

var $iQ57b = parcelRequire("iQ57b");


const $c9ddc0abb4dc6398$export$e57871e50d630995 = Object.freeze({
    defaultSort: "defaultSort",
    columns: "columns"
});
const $c9ddc0abb4dc6398$export$a81aa1891c137cbf = Object.freeze({
    colId: (0, $iQ57b.agentsParentColumns).agentsLost.id,
    sortDir: "desc"
});
const $c9ddc0abb4dc6398$export$8746637ab861831a = (0, $8a7a072219adb782$export$b6650e702502dd47)((0, $3488f7483fc3d043$export$d9985c9c0ab3725e)({
    defaultSort: $c9ddc0abb4dc6398$export$a81aa1891c137cbf
}));
const $c9ddc0abb4dc6398$export$659ffdb3794f02f9 = Object.freeze({
    [$c9ddc0abb4dc6398$export$e57871e50d630995.defaultSort]: $c9ddc0abb4dc6398$export$a81aa1891c137cbf,
    [$c9ddc0abb4dc6398$export$e57871e50d630995.columns]: $c9ddc0abb4dc6398$export$8746637ab861831a
});



var $8cYiI = parcelRequire("8cYiI");

var $jKEVi = parcelRequire("jKEVi");


var $cstaF = parcelRequire("cstaF");
const $1ad9ce055590e340$export$e324594224ef24da = (set, get)=>({
        getSelectedModule: ()=>(0, $jKEVi.useSearchStore).getState().selectedModule,
        setPropertyValue: (propertyName, value)=>set((0, $8cYiI.produce)((state)=>{
                const module = state[get().getSelectedModule];
                module[propertyName] = value;
            }), false, "setPropertyValue"),
        setSortColumn: (colId, sortDir)=>get().setPropertyValue((0, $c9ddc0abb4dc6398$export$e57871e50d630995).defaultSort, {
                colId: colId,
                sortDir: sortDir
            }),
        setColumns: (colId, newstate)=>set((0, $8cYiI.produce)((state)=>{
                const selectedModule = (0, $jKEVi.useSearchStore).getState().selectedModule;
                const module = state[selectedModule];
                const columns = module.columns.map((col)=>{
                    if (col.id === colId || col?.boundMetricId === colId) return {
                        ...col,
                        ...newstate
                    };
                    return col;
                });
                module.columns = columns;
            }), false, "setColumns"),
        resetTableSettings: ()=>set((0, $8cYiI.produce)((state)=>{
                const selectedModule = (0, $jKEVi.useSearchStore).getState().selectedModule;
                if (selectedModule === (0, $cstaF.modules).proficiencyMetrics.agentMovement) state[selectedModule] = (0, $c9ddc0abb4dc6398$export$659ffdb3794f02f9);
            }), false, "resetTableSettings")
    });



var $88tPr = parcelRequire("88tPr");
const $05517877e446f741$export$d4c72bab9d6cc13a = {
    [(0, $cstaF.modules).proficiencyMetrics.agentMovement]: (0, $c9ddc0abb4dc6398$export$659ffdb3794f02f9)
};
const $05517877e446f741$var$tableSettingsStore = (set, get)=>({
        ...$05517877e446f741$export$d4c72bab9d6cc13a,
        ...(0, $1ad9ce055590e340$export$e324594224ef24da)(set, get)
    });
const $05517877e446f741$export$ebc48288de47ba8d = (0, $9phu9.createWithEqualityFn)((0, $88tPr.devtools)((0, $88tPr.persist)($05517877e446f741$var$tableSettingsStore, {
    name: "table_settings_state",
    storage: (0, $88tPr.createJSONStorage)(()=>localStorage)
})));



var $eHBjM = parcelRequire("eHBjM");

var $iQ57b = parcelRequire("iQ57b");

var $jilhO = parcelRequire("jilhO");

const $88327a85589e4c09$export$25bceaac3c7e4dc7 = (agentData)=>{
    const gridRef = (0, $acw62.useRef)();
    const { defaultSort: defaultSort, columns: columns, totals: totals, setColumns: setColumns } = (0, $05517877e446f741$export$ebc48288de47ba8d)((state)=>{
        const selectedModule = (0, $90ISC.useSearchStore).getState().selectedModule;
        const totals = (0, $90ISC.useSearchStore).getState()[selectedModule]?.totals;
        const moduleState = state[selectedModule];
        return {
            defaultSort: moduleState?.defaultSort,
            columns: moduleState?.columns,
            totals: totals,
            setColumns: state.setColumns
        };
    });
    const summaryPinnedConfig = (0, $jilhO.getSummaryPinnedConfig)((0, $eHBjM.tableViewNames).agentMovement);
    const tableView = (0, $3488f7483fc3d043$export$d9985c9c0ab3725e)({
        defaultSort: defaultSort
    });
    const tableProps = {
        key: tableView?.id,
        additionalTableHeaders: $iQ57b.additionalTableHeaders,
        columns: columns,
        setColumns: setColumns,
        gridRef: gridRef,
        rowData: agentData,
        tableTitleWithTooltips: (0, $iQ57b.columns),
        tableView: tableView,
        pinnedBottomRowData: [
            {
                ...totals
            }
        ],
        externalParams: {
            summaryPinnedConfig: summaryPinnedConfig
        },
        isTableAutoHeight: false
    };
    return tableProps;
};



var $htzEo = parcelRequire("htzEo");

var $htzEo = parcelRequire("htzEo");

var $hQz0O = parcelRequire("hQz0O");

var $jUjGS = parcelRequire("jUjGS");
const $696f40fb6f9a5383$export$1572c1bbbe4962da = (chartData)=>{
    const options = {
        chart: {
            borderRadiusWhenStacked: "last",
            toolbar: {
                show: false
            },
            stacked: true,
            offsetY: 10,
            animations: {
                enabled: false
            }
        },
        colors: [
            (0, $jUjGS.COLOR_SECONDARY_GREEN),
            (0, $jUjGS.COLOR_PRIMARY_GREEN)
        ],
        dataLabels: {
            enabled: true,
            style: {
                colors: [
                    "#000000"
                ]
            },
            offsetY: -20,
            offsetX: -4,
            formatter: function(val) {
                if (val === 0) return "";
                return Math.abs(val);
            }
        },
        plotOptions: {
            bar: {
                horizontal: false,
                borderRaidusApplication: "end",
                borderRadiusWhenStacked: "all",
                borderRadius: 0,
                dataLabels: {
                    position: "top",
                    hideOverflowingLabels: false
                }
            }
        },
        xaxis: {
            categories: chartData?.map((month, index)=>{
                if (index === 0) return (0, $htzEo.monthWithDayAndYearArray)((0, $htzEo.shortMonthYearAndDayFormat)(month.startDate));
                if (index === chartData.length - 1) {
                    const endDate = new Date(month.endDate);
                    endDate.setDate(endDate.getDate() - 1);
                    return (0, $htzEo.monthWithDayAndYearArray)((0, $htzEo.shortMonthYearAndDayFormat)(endDate.toISOString()));
                }
                return (0, $htzEo.shortMonthAndYearFormat)(month.startDate).split(" ");
            }),
            offsetY: 15,
            axisTicks: {
                show: false
            },
            axisBorder: {
                show: false
            }
        },
        yaxis: {
            labels: {
                show: false
            }
        },
        legend: {
            show: false
        },
        stroke: {
            colors: [
                "transparent"
            ],
            width: 5
        },
        grid: {
            yaxis: {
                lines: {
                    show: false
                }
            },
            xaxis: {
                lines: {
                    show: false
                }
            },
            padding: {
                bottom: 20
            }
        },
        tooltip: {
            y: {
                formatter: function(val) {
                    return Math.abs(val);
                }
            },
            x: {
                show: false
            }
        },
        annotations: {
            yaxis: [
                {
                    y: 0,
                    strokeDashArray: 0,
                    borderColor: "#C2C2C2",
                    borderWidth: 1,
                    opacity: 1,
                    label: {
                        show: false
                    }
                }
            ]
        }
    };
    const getSeries = (chartData)=>{
        return [
            {
                name: (0, $hQz0O.terms).gained,
                data: chartData?.map((month)=>month.agentsGained) || []
            },
            {
                name: (0, $hQz0O.terms).lost,
                data: chartData?.map((month)=>month.agentsLost * -1) || []
            }
        ];
    };
    const chartProps = {
        options: options,
        series: getSeries(chartData),
        type: "bar",
        height: 390,
        width: "100%"
    };
    return chartProps;
};



var $bA5Mi = parcelRequire("bA5Mi");
const $6d46344e47d84f54$var$AgentMovement = ({ agentData: agentData })=>{
    const results = agentData?.results;
    const agentsPerMonth = agentData?.agentsPerMonth;
    const { isLoading: isLoading, selectedModule: selectedModule, savedSearchTitle: savedSearchTitle, loadedSearchCriteria: loadedSearchCriteria } = (0, $90ISC.useSearchStore)((state)=>{
        const { isLoading: isLoading, selectedModule: selectedModule } = state;
        const moduleState = state[selectedModule];
        const loadedSearchCriteria = moduleState?.loadedSearchCriteria;
        const savedSearchTitle = moduleState?.selectedSavedSearch?.savedSearch?.searchName;
        return {
            isLoading: isLoading,
            selectedModule: selectedModule,
            savedSearchTitle: savedSearchTitle,
            loadedSearchCriteria: loadedSearchCriteria
        };
    });
    const { setColumnDefs: setColumnDefs, setResults: setResults } = (0, $bA5Mi.usePDFStore)((state)=>({
            setColumnDefs: state.setColumnDefs,
            setResults: state.setResults
        }));
    const [state, setState] = (0, $acw62.useState)({
        selectedPeriod: (0, $1byMr.terms).last365Days,
        shouldDisplayMetricsPopover: false
    });
    const tableProps = (0, $88327a85589e4c09$export$25bceaac3c7e4dc7)(results);
    const chartProps = (0, $696f40fb6f9a5383$export$1572c1bbbe4962da)(agentsPerMonth);
    (0, $acw62.useEffect)(()=>{
        setColumnDefs(tableProps.tableView.tables);
        setResults(agentData?.results);
    }, [
        agentData
    ]);
    const loader = /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "py-3",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {})
    });
    const hasResults = selectedModule === (0, $cstaF.modules).proficiencyMetrics.agentMovement && results?.length > 0;
    const exportDetails = {
        exportType: (0, $94088b34ebad1923$export$382f55aa456f5721).searchResults,
        listingType: "agents",
        listingStatus: "",
        date: (0, $htzEo.csvExportDateFormat)(new Date)
    };
    const exportButton = (0, $0d036ea0861162a7$export$e89cb83db8826f3)({
        exportDetails: exportDetails,
        shouldUsePrimaryColumns: true,
        gridRef: tableProps.gridRef,
        type: (0, $i95vK.exportButtonTypes).secondary,
        isDisabled: isLoading
    });
    const titleRowProps = {
        hasResults: hasResults,
        selectedPeriod: state.selectedPeriod,
        setState: setState,
        shouldDisplayMetricsPopover: state.shouldDisplayMetricsPopover,
        exportButton: exportButton,
        savedSearchTitle: savedSearchTitle,
        loadedSearchCriteria: loadedSearchCriteria
    };
    const getStatusMessage = ({ messageContent: messageContent })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b45af4c0b62bef82$export$2e2bcd8739ae039), {
                    ...titleRowProps
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "text-center",
                    children: [
                        " ",
                        messageContent,
                        " "
                    ]
                })
            ]
        });
    const initialSearchNotRun = getStatusMessage({
        messageContent: /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
            className: "initial-search",
            children: [
                " ",
                (0, $1byMr.terms).searchFilterAdjust,
                " "
            ]
        })
    });
    if (isLoading) return loader;
    if (!hasResults && !!results) return getStatusMessage({
        messageContent: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $126e7d6ff1f55059$export$3f0134fa5c63d52e), {})
    });
    if (hasResults && !!loadedSearchCriteria) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $16baeecc2d754d44$export$ec0b9adac8c32387), {
        titleRowProps: titleRowProps,
        tableProps: tableProps,
        chartProps: chartProps
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: initialSearchNotRun
    });
};
$6d46344e47d84f54$var$AgentMovement.propTypes = {
    agentData: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        results: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
        agentsPerMonth: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array
    })
};
var $6d46344e47d84f54$export$2e2bcd8739ae039 = $6d46344e47d84f54$var$AgentMovement;



var $1byMr = parcelRequire("1byMr");

var $eickZ = parcelRequire("eickZ");


var $6g8wQ = parcelRequire("6g8wQ");

var $bA5Mi = parcelRequire("bA5Mi");

var $ddjPx = parcelRequire("ddjPx");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $90ISC = parcelRequire("90ISC");


var $cstaF = parcelRequire("cstaF");
const $d173e9199011f5b6$var$MLSSelector = ({ module: module, userId: userId, mlsMembershipInfo: mlsMembershipInfo, mlsProps: mlsProps })=>{
    const { selectedMls: selectedMls, setSelectedMls: setSelectedMls, isLoading: isLoading } = (0, $90ISC.useSearchStore)((state)=>({
            selectedMls: state[state.selectedModule]?.selectedMls,
            setSelectedMls: state.setSelectedMls,
            isLoading: state.isLoading
        }));
    const { mlsProviders: mlsProviders, timeIntervals: timeIntervals } = (0, $90ISC.useCommonStore)((state)=>({
            mlsProviders: state.mlsProviders,
            timeIntervals: state.timeIntervals
        }));
    (0, $acw62.useEffect)(()=>{
        if (!selectedMls && !!mlsProviders?.length && !!timeIntervals?.length) setSelectedMls(mlsProviders[0], (0, $cstaF.modules).dashboard.dashboard, timeIntervals);
    }, [
        selectedMls
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3cd9af9ffb7cfa9c$export$2e2bcd8739ae039), {
        disabled: isLoading,
        module: module,
        selectedMls: selectedMls,
        mlsMembershipInfo: Array.isArray(mlsMembershipInfo) ? mlsMembershipInfo.find((mls)=>mls.mlsId === selectedMls?.mlsId) : undefined,
        userId: userId,
        mlsProps: mlsProps
    }, "mls");
};
$d173e9199011f5b6$var$MLSSelector.propTypes = {
    module: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string.isRequired,
    userId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    mlsMembershipInfo: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    mlsProps: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object,
    timeIntervals: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array,
    mlsProviders: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).array
};
var $d173e9199011f5b6$export$2e2bcd8739ae039 = $d173e9199011f5b6$var$MLSSelector;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("3PprX");
var $90ODN = parcelRequire("90ODN");

var $4EYT7 = parcelRequire("4EYT7");
const $505ca3cf92fcabae$var$PeriodDropdown = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($90ODN))), {
        dataLwtId: "dashboard-period-dropdown",
        items: (0, $4EYT7.periodDropdownItems),
        className: "mb-1 mr-2 d-inline-block align-top",
        menuProps: {
            dataLwtId: "share-menu",
            right: true
        },
        toggleProps: {
            dataLwtId: "no-split-toggle",
            id: "caret",
            color: "secondary",
            caret: true,
            children: (0, $4EYT7.terms).last12Months,
            className: "btn btn-sm btn-secondary",
            disabled: true
        }
    });
};
var $505ca3cf92fcabae$export$2e2bcd8739ae039 = $505ca3cf92fcabae$var$PeriodDropdown;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");
parcelRequire("3PprX");
var $90ODN = parcelRequire("90ODN");

var $4EYT7 = parcelRequire("4EYT7");

var $jKEVi = parcelRequire("jKEVi");
const $2c2d6163f27147f2$var$ViewTypesSelector = ()=>{
    const { setSelectedViewTypeId: setSelectedViewTypeId, viewTypeId: viewTypeId } = (0, $jKEVi.useSearchStore)((state)=>({
            setSelectedViewTypeId: state.setSelectedViewTypeId,
            viewTypeId: state[state.selectedModule]?.viewTypeId
        }));
    const viewTypeOptions = [
        {
            dataLwtId: "by-office-item",
            itemText: (0, $4EYT7.viewTypes).byOffice.label,
            key: (0, $4EYT7.viewTypes).byOffice.id,
            onClick: ()=>setSelectedViewTypeId((0, $4EYT7.viewTypes).byOffice.id)
        },
        {
            dataLwtId: "by-brokerage-item",
            itemText: (0, $4EYT7.viewTypes).byBrokerage.label,
            key: (0, $4EYT7.viewTypes).byBrokerage.id,
            onClick: ()=>setSelectedViewTypeId((0, $4EYT7.viewTypes).byBrokerage.id)
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($90ODN))), {
        dataLwtId: "view-type-dropdown",
        items: viewTypeOptions,
        menuProps: {
            dataLwtId: "share-menu",
            right: true
        },
        toggleProps: {
            dataLwtId: "no-split-toggle",
            id: "caret",
            color: "secondary",
            caret: true,
            children: viewTypeOptions.find((vt)=>vt.key === viewTypeId)?.itemText,
            className: "btn btn-sm btn-secondary mb-1 mr-2"
        }
    });
};
var $2c2d6163f27147f2$export$2e2bcd8739ae039 = $2c2d6163f27147f2$var$ViewTypesSelector;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");
parcelRequire("3PprX");
var $90ODN = parcelRequire("90ODN");

var $90ISC = parcelRequire("90ISC");

var $4EYT7 = parcelRequire("4EYT7");
const $eae1db5bb557055e$var$OfficesDropdown = ()=>{
    const { selectedMls: selectedMls, selectedOffice: selectedOffice, setSelectedOffice: setSelectedOffice, viewTypeId: viewTypeId } = (0, $90ISC.useSearchStore)((state)=>({
            selectedMls: state[state.selectedModule]?.selectedMls,
            selectedOffice: state[state.selectedModule]?.selectedOffice,
            setSelectedOffice: state.setSelectedOffice,
            viewTypeId: state[state.selectedModule]?.viewTypeId
        }));
    const { officesInfo: officesInfo } = (0, $90ISC.useCommonStore)((state)=>({
            officesInfo: [
                ...Array.isArray(state.officeInfo) ? state.officeInfo : []
            ].sort((a, b)=>a.name.toUpperCase().localeCompare(b.name.toUpperCase())).filter((o)=>o?.isOfficeActive && o.mlsOfficeId.mlsId === selectedMls?.mlsId)
        }));
    (0, $acw62.useEffect)(()=>{
        if (!officesInfo?.length) return;
        const defaultOffice = [
            ...officesInfo
        ].filter((o)=>o.mlsOfficeId.mlsId === selectedMls?.mlsId)[0];
        setSelectedOffice(defaultOffice);
    }, [
        selectedMls?.mlsId
    ]);
    const officeOptions = officesInfo.map((office, i)=>({
            dataLwtId: `${i}-office-item-${office.mlsOfficeId.officeId}`,
            itemText: office.name,
            key: `${i}-office-${office.mlsOfficeId.officeId}`,
            onClick: ()=>setSelectedOffice(office)
        }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {
        children: viewTypeId === (0, $4EYT7.viewTypes).byOffice.id && /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($90ODN))), {
            dataLwtId: "offices-dropdown",
            items: officeOptions,
            menuProps: {
                dataLwtId: "share-menu",
                right: true,
                className: "office-menu-dropdown"
            },
            toggleProps: {
                dataLwtId: "no-split-toggle",
                id: "caret",
                color: "secondary",
                caret: true,
                children: selectedOffice?.name,
                className: "btn btn-sm btn-secondary mb-1 mr-2"
            }
        })
    });
};
var $eae1db5bb557055e$export$2e2bcd8739ae039 = $eae1db5bb557055e$var$OfficesDropdown;



var $4EYT7 = parcelRequire("4EYT7");
const $a9e4d0cdcdd5a785$var$TitleRow = (props)=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "grid p-4",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "float-left",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                    className: "text-truncate mb-0 helix-display-small",
                    children: (0, $4EYT7.terms).welcome.replace("[AGENT_NAME]", props.userInfo?.firstName || props.userInfo?.given_name)
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "align-items-center float-right d-flex",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d173e9199011f5b6$export$2e2bcd8739ae039), {
                        ...props
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2c2d6163f27147f2$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eae1db5bb557055e$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $505ca3cf92fcabae$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
};
$a9e4d0cdcdd5a785$var$TitleRow.propTypes = {
    userInfo: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $a9e4d0cdcdd5a785$export$2e2bcd8739ae039 = $a9e4d0cdcdd5a785$var$TitleRow;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $24YIE = parcelRequire("24YIE");

var $dI25G = parcelRequire("dI25G");

var $eOjgM = parcelRequire("eOjgM");

var $90ISC = parcelRequire("90ISC");

var $7tOHe = parcelRequire("7tOHe");

var $htzEo = parcelRequire("htzEo");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
const $98ebd14d329df3b5$export$420ac06db41dd9da = ({ children: children })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "d-flex helix-flex--column mr-2",
        children: children
    });
};
$98ebd14d329df3b5$export$420ac06db41dd9da.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).element
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


var $c9Z8w = parcelRequire("c9Z8w");
const $d27b86e0e1d6cdc3$export$e1e2088b0a8a7a69 = ({ variant: variant = "neutral", shape: shape = "square", children: children, ...props })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "d-flex align-items-center mr-2",
        ...props,
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("dashboard-chart-legend", "helix-flex-no-shrink", "mr-2", {
                    "helix-bg-brand": variant === "dark",
                    "helix-bg-brand-2": variant === "medium",
                    "helix-bg-brand-3": variant === "light",
                    "helix-gray-300": variant === "neutral",
                    "helix-bg-blue": variant === "blue",
                    "border-radius--rounded": shape === "circle",
                    "dashboard-chart-square": shape === "square",
                    "dashboard-chart-line": shape === "line"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "helix-legend-label",
                children: children
            })
        ]
    });
};
$d27b86e0e1d6cdc3$export$e1e2088b0a8a7a69.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
    variant: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "dark",
        "medium",
        "light",
        "neutral",
        "blue"
    ]),
    shape: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).oneOf([
        "circle",
        "square",
        "line"
    ])
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");
const $2f21cbb378255e48$export$d303b0996bb1e4f1 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "helix-legend-value mt-2",
        children: children
    });
};
$2f21cbb378255e48$export$d303b0996bb1e4f1.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};



var $cstaF = parcelRequire("cstaF");

var $4EYT7 = parcelRequire("4EYT7");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $3r6bj = parcelRequire("3r6bj");

var $htzEo = parcelRequire("htzEo");

var $bLQRh = parcelRequire("bLQRh");

var $4EYT7 = parcelRequire("4EYT7");

var $c9Z8w = parcelRequire("c9Z8w");
const $aeea25cf764dbae2$var$TransactionVolumeChart = ({ chartData: chartData, selectedOffice: selectedOffice, viewTypeId: viewTypeId })=>{
    const chartOptions = {
        chart: {
            type: "line",
            toolbar: {
                show: false
            },
            fontFamily: (0, $bLQRh.chartFontFamily),
            offsetX: 20
        },
        grid: {
            borderColor: "#E5E7EB"
        },
        stroke: {
            width: [
                0,
                2
            ],
            curve: "smooth"
        },
        plotOptions: {
            bar: {
                columnWidth: "20%",
                borderRadius: 6,
                borderRadiusApplication: "end"
            }
        },
        colors: [
            "#236847",
            "#0284C7"
        ],
        dataLabels: {
            enabled: false
        },
        labels: chartData.categories,
        xaxis: {
            type: "category",
            labels: {
                style: {
                    colors: "#9CA3AF",
                    fontWeight: "600",
                    lineHeight: "16px",
                    cssClass: "apexcharts-xaxis-dashboard-label"
                }
            },
            axisBorder: {
                show: false
            },
            axisTicks: {
                show: false
            }
        },
        yaxis: {
            labels: {
                formatter: function(value) {
                    return (0, $htzEo.getCompactDollars)(value);
                },
                style: {
                    colors: "#9CA3AF",
                    fontSize: "14px",
                    lineHeight: "20px"
                }
            }
        },
        tooltip: {
            enabled: false
        },
        legend: {
            show: false
        },
        fill: {
            opacity: 1
        }
    };
    const chartSeries = [
        {
            name: viewTypeId === (0, $4EYT7.viewTypes).byOffice ? selectedOffice?.name || (0, $4EYT7.terms).selectedOffice : (0, $4EYT7.viewTypes).byBrokerage,
            type: "column",
            data: chartData.transactionVolumes
        },
        {
            name: (0, $4EYT7.terms).marketAverage,
            type: "line",
            data: chartData.marketAverages
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "mt-3",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3r6bj))), {
            options: chartOptions,
            series: chartSeries,
            type: "line",
            width: "100%",
            height: "245px"
        })
    });
};
$aeea25cf764dbae2$var$TransactionVolumeChart.propTypes = {
    chartData: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        categories: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string).isRequired,
        transactionVolumes: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number).isRequired,
        marketAverages: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number).isRequired
    }).isRequired,
    selectedOffice: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        name: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string,
        mlsOfficeId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
    }),
    viewTypeId: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).string
};
var $aeea25cf764dbae2$export$2e2bcd8739ae039 = $aeea25cf764dbae2$var$TransactionVolumeChart;



var $6IhJz = parcelRequire("6IhJz");
var $dpjX2 = parcelRequire("dpjX2");


var $kfZjc = parcelRequire("kfZjc");

var $f6CJ4 = parcelRequire("f6CJ4");
const $943ea99297ef765c$var$TransactionVolume = ()=>{
    const [isLoadingData, setIsLoadingData] = (0, $acw62.useState)(false);
    const [transactionVolumeData, setTransactionVolumeData] = (0, $acw62.useState)(null);
    const [marketAverageVolumeData, setMarketAverageVolumeData] = (0, $acw62.useState)(null);
    const [chartData, setChartData] = (0, $acw62.useState)({
        categories: [],
        transactionVolumes: [],
        marketAverages: []
    });
    const history = (0, $kfZjc.useHistory)();
    const { selectedMls: selectedMls, selectedOffice: selectedOffice, viewTypeId: viewTypeId } = (0, $90ISC.useSearchStore)((state)=>({
            selectedMls: state[state.selectedModule]?.selectedMls,
            selectedOffice: state[state.selectedModule]?.selectedOffice,
            viewTypeId: state[state.selectedModule]?.viewTypeId
        }));
    const { getAssociatedBrokerageId: getAssociatedBrokerageId, userProducts: userProducts } = (0, $90ISC.useCommonStore)((state)=>({
            getAssociatedBrokerageId: state.getAssociatedBrokerageId,
            userProducts: state.privileges?.userProducts
        }));
    const isLegacyUser = (0, $f6CJ4.useAuthStore)((state)=>state.isLegacyUser);
    const hasProficiencyMetricsAccess = !!(userProducts?.includes((0, $cstaF.moduleNames).proficiencyMetrics) || isLegacyUser);
    const selectedBrokerId = getAssociatedBrokerageId();
    (0, $acw62.useEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            const fetchData = async ()=>{
                const selectedMlsId = selectedMls?.mlsId.toString();
                const selectedOfficeId = selectedOffice?.mlsOfficeId?.officeId?.toString();
                if (!selectedMlsId) return;
                setIsLoadingData(true);
                try {
                    const officeIdParam = viewTypeId === (0, $4EYT7.viewTypes).byOffice.id ? selectedOfficeId : null;
                    const brokerIdParam = viewTypeId === (0, $4EYT7.viewTypes).byBrokerage.id ? selectedBrokerId : null;
                    const [transactionResponse, marketAverageResponse] = await Promise.all([
                        (0, $24YIE.getTransactionVolume)(selectedMlsId, officeIdParam, brokerIdParam),
                        (0, $24YIE.getMarketAverageVolume)(selectedMlsId, officeIdParam, brokerIdParam)
                    ]);
                    const transactionVolume = (transactionResponse?.transaction_volume || []).reduce((sum, month)=>sum + month.total_volume, 0);
                    setTransactionVolumeData(transactionVolume);
                    const monthLabels = transactionResponse?.transaction_volume?.map((item)=>(0, $6IhJz.default)((0, $dpjX2.default)(item.startDate), "MMM").toUpperCase());
                    const transactionVolumes = transactionResponse?.transaction_volume?.map((item)=>item.total_volume || 0);
                    setMarketAverageVolumeData(marketAverageResponse?.total_market_average);
                    const monthlyMarketAverage = marketAverageResponse?.monthly_market_average || [];
                    const marketAverages = monthlyMarketAverage.map((month)=>month.average || 0);
                    setChartData({
                        categories: monthLabels,
                        transactionVolumes: transactionVolumes,
                        marketAverages: marketAverages
                    });
                } catch (err) {
                    console.error(err);
                    setTransactionVolumeData(null);
                    setMarketAverageVolumeData(null);
                } finally{
                    setIsLoadingData(false);
                }
            };
            fetchData();
        }, 10);
        return ()=>clearTimeout(timeoutId);
    }, [
        selectedMls?.mlsId,
        selectedOffice?.mlsOfficeId?.officeId,
        viewTypeId,
        selectedBrokerId
    ]);
    const chartLegend = /*#__PURE__*/ (0, $ayMG0.jsx)((0, $98ebd14d329df3b5$export$420ac06db41dd9da), {
        children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "d-flex gap-4",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "d-flex flex-column mr-4",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d27b86e0e1d6cdc3$export$e1e2088b0a8a7a69), {
                            variant: "dark",
                            shape: "square",
                            children: viewTypeId === "byOffice" ? selectedOffice?.name || (0, $4EYT7.terms).selectedOffice : "Your Brokerage"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f21cbb378255e48$export$d303b0996bb1e4f1), {
                            children: (0, $htzEo.getCurrencyFormat)(transactionVolumeData)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "d-flex flex-column",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d27b86e0e1d6cdc3$export$e1e2088b0a8a7a69), {
                            variant: "blue",
                            shape: "line",
                            children: (0, $4EYT7.terms).marketAverage
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2f21cbb378255e48$export$d303b0996bb1e4f1), {
                            children: (0, $htzEo.getCurrencyFormat)(marketAverageVolumeData)
                        })
                    ]
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "content d-flex flex-column h-100 p-4 dashboard-card",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "d-flex justify-content-between align-items-start mb-4",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "d-flex align-items-center",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "helix-legend-value mb-1 mr-2",
                                children: (0, $4EYT7.terms).transactionVolume
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                                icon: (0, $eOjgM.circle_info),
                                className: "helix-icon--small helix-text-gray-400 mr-2"
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "helix-info-text mb-0",
                                children: (0, $4EYT7.terms).allMlsAndPropertyTypes
                            })
                        ]
                    }),
                    hasProficiencyMetricsAccess && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        className: "helix-body--strong dashboard-nav-btn helix-brand-color",
                        onClick: ()=>history.push((0, $c8257d18c4a1050f$export$cbd12ebcc216e09a)({
                                product: (0, $cstaF.moduleNames).proficiencyMetrics,
                                userProducts: userProducts,
                                isLegacyUser: isLegacyUser
                            })),
                        children: [
                            (0, $cstaF.agentProductionTerms).proficiencyMetrics,
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                                icon: (0, $eOjgM.chevron_small_right),
                                className: "ml-1"
                            })
                        ]
                    })
                ]
            }),
            isLoadingData ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "d-flex justify-content-center align-items-center pb-4",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {})
            }) : chartLegend,
            isLoadingData ? null : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $aeea25cf764dbae2$export$2e2bcd8739ae039), {
                chartData: chartData,
                selectedOffice: selectedOffice,
                viewTypeId: viewTypeId
            })
        ]
    });
};
var $943ea99297ef765c$export$2e2bcd8739ae039 = $943ea99297ef765c$var$TransactionVolume;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $7tOHe = parcelRequire("7tOHe");

var $dI25G = parcelRequire("dI25G");

var $eOjgM = parcelRequire("eOjgM");

var $90ISC = parcelRequire("90ISC");

var $24YIE = parcelRequire("24YIE");

var $5269x = parcelRequire("5269x");

var $4EYT7 = parcelRequire("4EYT7");

var $cstaF = parcelRequire("cstaF");

var $kfZjc = parcelRequire("kfZjc");

var $c7dF9 = parcelRequire("c7dF9");

var $eHBjM = parcelRequire("eHBjM");

var $f6CJ4 = parcelRequire("f6CJ4");
const $3f7df0ed892da27d$var$RecruitingActivity = ()=>{
    const [activityData, setActivityData] = (0, $acw62.useState)(null);
    const [isLoadingData, setIsLoadingData] = (0, $acw62.useState)(false);
    const [error, setError] = (0, $acw62.useState)(null);
    const { agentLists: agentLists, timeIntervals: timeIntervals, userProducts: userProducts } = (0, $90ISC.useCommonStore)((state)=>({
            agentLists: state.agentLists,
            timeIntervals: state.timeIntervals,
            userProducts: state.privileges?.userProducts
        }));
    const history = (0, $kfZjc.useHistory)();
    const isLegacyUser = (0, $f6CJ4.useAuthStore)((state)=>state.isLegacyUser);
    const savedAgentsModule = (0, $cstaF.modules).proficiencyMetrics.savedAgents;
    const { selectedMls: selectedMls, setSelectedMls: setSelectedMls } = (0, $90ISC.useSearchStore)((state)=>({
            selectedMls: state[state.selectedModule]?.selectedMls,
            setSelectedMls: state.setSelectedMls
        }));
    const { setSelectedListByModule: setSelectedListByModule } = (0, $90ISC.useSavedAgentsStore)((state)=>({
            setSelectedListByModule: state.setSelectedListByModule
        }));
    (0, $acw62.useEffect)(()=>{
        const fetchActivityData = async ()=>{
            const selectedMlsId = selectedMls?.mlsId.toString();
            if (!selectedMlsId) return;
            setIsLoadingData(true);
            setError(null);
            try {
                const response = await (0, $24YIE.getDashboardRecentActivity)(selectedMlsId);
                if (response?.error) throw new Error((0, $4EYT7.terms).errorLoadingData);
                setActivityData(response);
            } catch (err) {
                setError((0, $4EYT7.terms).errorLoadingData);
                setActivityData(null);
            } finally{
                setIsLoadingData(false);
            }
        };
        fetchActivityData();
    }, [
        selectedMls?.mlsId
    ]);
    const handleOnClick = async ()=>{
        const dashboardMlsId = selectedMls?.mlsId;
        const membership = (0, $90ISC.useCommonStore).getState().membership;
        const selectedMlsObject = membership.find((m)=>m.mlsId === dashboardMlsId);
        const agentIdsForMls = agentLists?.filter((list)=>list.mlsId === dashboardMlsId).map((list)=>list.agentIds).flat() || [];
        const uniqueAgentIds = [
            ...new Set(agentIdsForMls)
        ];
        const allListsForMls = {
            agentListId: `all-lists-${dashboardMlsId}`,
            name: (0, $eHBjM.favoriteAgentTerms).reservedListName,
            mlsId: dashboardMlsId,
            agentIds: uniqueAgentIds
        };
        setSelectedMls(selectedMlsObject, savedAgentsModule, timeIntervals);
        setSelectedListByModule(savedAgentsModule, allListsForMls);
        history.push((0, $c7dF9.Routes).PROF_METRICS.BASE + (0, $c7dF9.Routes).PROF_METRICS.SAVED_AGENTS + (0, $c7dF9.Routes).PROF_METRICS.ACTIVITY);
    };
    const renderEmptyState = ()=>{
        const hasNoSavedAgents = activityData?.savedAgentCount === 0;
        if (hasNoSavedAgents) return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "d-flex flex-column justify-content-center align-items-center text-center h-100 pb-5 px-3",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                    className: "helix-body--strong mb-2",
                    children: (0, $4EYT7.terms).noAgentsTrackedYet
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "helix-text-gray-500 mb-1",
                    children: (0, $4EYT7.terms).noAgentsOnYourRadarYet
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "helix-text-gray-500 mb-0",
                    children: (0, $4EYT7.terms).saveOneToFollowTheirActivity
                })
            ]
        });
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "d-flex flex-column justify-content-center align-items-center text-center h-100 pb-5 px-3",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                    className: "helix-body--strong mb-2",
                    children: (0, $4EYT7.terms).noNewActivity
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    className: "helix-text-gray-500 mb-0",
                    children: (0, $4EYT7.terms).noNewActivityMessage
                })
            ]
        });
    };
    const renderActivities = ()=>{
        if (!activityData?.activities?.length) return renderEmptyState();
        const sortedActivities = [
            ...activityData.activities
        ].sort((a, b)=>{
            return new Date(b.date) - new Date(a.date);
        }).slice(0, 10);
        return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "text-center py-3 mb-3",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "mb-2",
                            children: activityData?.summary?.activityCount || 0
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "helix-body--strong helix-text-gray-500",
                            children: (0, $4EYT7.terms).savedAgentActivities
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "d-flex flex-column",
                    children: sortedActivities.map((activity, index)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "pb-3 mb-3 recruiting-activity-item",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "helix-body--strong mb-1",
                                    children: `${activity?.agentFirstName} ${activity?.agentLastName}`
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "helix-text-gray-500 helix-body",
                                    children: (0, $5269x.getActivityText)(activity)
                                })
                            ]
                        }, index))
                })
            ]
        });
    };
    const hasProficiencyMetricsAccess = !!(userProducts?.includes((0, $cstaF.moduleNames).proficiencyMetrics) || isLegacyUser);
    const shouldShowSeeAllButton = !isLoadingData && !error && !!activityData?.activities?.length && hasProficiencyMetricsAccess;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "content d-flex flex-column h-100 p-4",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "d-flex justify-content-between align-items-start mb-4",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "helix-display-x-small mb-1",
                                children: (0, $4EYT7.terms).recruitingActivity
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "helix-small helix-text-gray-500 mb-0",
                                children: (0, $4EYT7.terms).last30Days
                            })
                        ]
                    }),
                    shouldShowSeeAllButton && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        className: "helix-body--strong dashboard-nav-btn helix-brand-color",
                        onClick: handleOnClick,
                        children: [
                            (0, $4EYT7.terms).seeAll,
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                                icon: (0, $eOjgM.chevron_small_right),
                                className: "ml-1"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "d-flex flex-column flex-grow-1",
                children: isLoadingData ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "d-flex justify-content-center align-items-center pb-4",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {})
                }) : error ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "text-danger text-center p-3",
                    children: error
                }) : renderActivities()
            })
        ]
    });
};
var $3f7df0ed892da27d$export$2e2bcd8739ae039 = $3f7df0ed892da27d$var$RecruitingActivity;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4EYT7 = parcelRequire("4EYT7");

var $dI25G = parcelRequire("dI25G");

var $eOjgM = parcelRequire("eOjgM");

var $cstaF = parcelRequire("cstaF");


var $5FKEE = parcelRequire("5FKEE");

var $gDxKE = parcelRequire("gDxKE");

var $75U5M = parcelRequire("75U5M");

var $i1BZc = parcelRequire("i1BZc");

var $7AubO = parcelRequire("7AubO");

var $f6CJ4 = parcelRequire("f6CJ4");
const $ccff02e229379ab0$var$defaultRequestTimeout = 10000;
const $ccff02e229379ab0$export$211c770659d30481 = async ({ endpoint: endpoint, inputParameters: inputParameters, requestTimeout: requestTimeout, propsToken: propsToken, isJsonResponse: isJsonResponse = true, propsActiveClientId: propsActiveClientId, requestType: requestType = (0, $i1BZc.apiRequestTypes).post, queryString: queryString, isPlainResponse: isPlainResponse, customErrorMessage: customErrorMessage = null, suppressToast: suppressToast = false })=>{
    const controller = new AbortController();
    const timeoutId = setTimeout(()=>{
        controller.abort();
    }, requestTimeout ?? $ccff02e229379ab0$var$defaultRequestTimeout);
    const authStore = (0, $f6CJ4.useAuthStore).getState();
    const token = propsToken || authStore.token;
    const activeClientId = propsActiveClientId || authStore.activeClientId;
    if (!token) return {
        error: "No token has been provided. Unable to process request."
    };
    const url = `${(0, $7AubO.getEndpoint)((0, $7AubO.BROKER_METRICS_API))}/v1/${endpoint}`;
    try {
        const response = await fetch((0, $gDxKE.getRequestObjectByMethodType)({
            url: url,
            token: token,
            activeClientId: activeClientId,
            data: {
                inputParameters: inputParameters
            },
            queryString: queryString
        })[requestType], {
            signal: controller.signal
        });
        if (response.status === 403 || response.status == 401) {
            (0, $f6CJ4.useAuthStore).getState().handleExpiredToken();
            return {
                error: response.status
            };
        }
        (0, $gDxKE.handleApiError)({
            response: response,
            endpoint: endpoint,
            customErrorMessage: customErrorMessage,
            suppressToast: suppressToast
        });
        if (!response.ok) return response.status;
        if (isPlainResponse) return response;
        return isJsonResponse ? response.json() : response.body;
    } catch (error) {
        return {
            error: error
        };
    } finally{
        clearTimeout(timeoutId);
    }
};
const $ccff02e229379ab0$export$386371e29f4c75e0 = async ({ mlsId: mlsId, officeIds: officeIds, brokerIds: brokerIds })=>{
    const { startDate: startDate, endDate: endDate } = (0, $75U5M.getDateRangeFromRecurrence)((0, $5FKEE.recurrences).lastTwelveMonths);
    return await $ccff02e229379ab0$export$211c770659d30481({
        endpoint: "office/agent-performance",
        requestType: (0, $i1BZc.apiRequestTypes).get,
        queryString: `mlsId=${mlsId}${officeIds ? "&officeIds=" + officeIds : ""}${brokerIds ? "&brokerIds=" + brokerIds : ""}&startDate=${(0, $75U5M.formatShortDate)(startDate)}&endDate=${(0, $75U5M.formatShortDate)(endDate)}&Periods=${(0, $5FKEE.periods).lastTwelveMonths}`
    });
};



var $90ISC = parcelRequire("90ISC");


var $htzEo = parcelRequire("htzEo");

var $7tOHe = parcelRequire("7tOHe");

var $kfZjc = parcelRequire("kfZjc");


var $f6CJ4 = parcelRequire("f6CJ4");
const $1d98f57976b4f2ca$var$AgentProductivity = ()=>{
    const history = (0, $kfZjc.useHistory)();
    const userProducts = (0, $90ISC.useCommonStore)((state)=>state.privileges?.userProducts);
    const isLegacyUser = (0, $f6CJ4.useAuthStore)((state)=>state.isLegacyUser);
    const { selectedMls: selectedMls, selectedOffice: selectedOffice, viewTypeId: viewTypeId } = (0, $90ISC.useSearchStore)((state)=>({
            selectedMls: state[state.selectedModule]?.selectedMls,
            selectedOffice: state?.[state.selectedModule]?.selectedOffice,
            viewTypeId: state?.[state.selectedModule]?.viewTypeId
        }));
    const [state, setState] = (0, $acw62.useState)({
        activeTab: "top-producers",
        ["top-producers"]: [],
        ["at-risk"]: [],
        isLoading: true,
        error: null
    });
    const agentData = state[state.activeTab] ?? [];
    const sortedAgentData = agentData?.slice().sort((a, b)=>{
        if (state.activeTab === "top-producers") return b.volume - a.volume;
        else return a.percentChange - b.percentChange;
    }).map((agent, index)=>({
            id: agent.agentId,
            initials: agent?.agentName?.split(" ").map((name)=>name[0]).join("").slice(0, 2) ?? "",
            name: agent?.agentName ?? "Agent",
            rank: index + 1,
            sales: (0, $htzEo.getCompactDollars)(agent.volume),
            percentChange: agent.percentChange
        })) || [];
    const hasAgentData = agentData.length > 0;
    (0, $acw62.useEffect)(()=>{
        const fetchAgentProductivity = async ()=>{
            const selectedMlsId = selectedMls?.mlsId.toString();
            setState((prevState)=>({
                    ...prevState,
                    activeTab: "top-producers",
                    ["at-risk"]: [],
                    ["top-producers"]: []
                }));
            if (isLegacyUser) {
                setState((prevState)=>({
                        ...prevState,
                        isLoading: false
                    }));
                return;
            }
            if (!selectedMlsId) return;
            const officeIds = viewTypeId === (0, $4EYT7.viewTypes).byOffice.id && selectedOffice?.mlsOfficeId?.officeId;
            const brokerIds = viewTypeId === (0, $4EYT7.viewTypes).byBrokerage.id && selectedOffice?.mlsBrokerId?.brokerId;
            if (!officeIds && !brokerIds) return;
            setState((prevState)=>({
                    ...prevState,
                    isLoading: true
                }));
            try {
                const response = await (0, $ccff02e229379ab0$export$386371e29f4c75e0)({
                    mlsId: selectedMlsId,
                    officeIds: officeIds,
                    brokerIds: brokerIds
                });
                const atRiskAgents = response.ltmPtmAnalysis?.atRiskAgents?.agentList ?? [];
                const topProducingAgents = response.ltmPtmAnalysis?.topProducingAgents?.agentList ?? [];
                setState((prevState)=>({
                        ...prevState,
                        ["at-risk"]: atRiskAgents,
                        ["top-producers"]: topProducingAgents
                    }));
            } catch (error) {
                setState((prevState)=>({
                        ...prevState,
                        error: error
                    }));
                console.error(error);
            } finally{
                setState((prevState)=>({
                        ...prevState,
                        isLoading: false
                    }));
            }
        };
        fetchAgentProductivity();
    }, [
        selectedMls,
        selectedOffice?.mlsOfficeId?.officeId,
        viewTypeId,
        selectedOffice?.mlsBrokerId?.brokerId
    ]);
    const handleNavigateToProficiencyMetrics = ()=>{
        history.push((0, $c8257d18c4a1050f$export$cbd12ebcc216e09a)({
            product: (0, $cstaF.moduleNames).proficiencyMetrics,
            userProducts: userProducts,
            isLegacyUser: isLegacyUser
        }));
    };
    const hasProficiencyMetricsAccess = !!(userProducts?.includes((0, $cstaF.moduleNames).proficiencyMetrics) || isLegacyUser);
    if (state.isLoading) return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "content dashboard-card p-4 h-100",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {})
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "content dashboard-card p-4 h-100",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "d-flex justify-content-between align-items-start mb-3",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                        className: "helix-display-x-small mb-1",
                        children: (0, $4EYT7.terms).agentProductivity
                    }),
                    hasProficiencyMetricsAccess && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        className: "helix-body--strong dashboard-nav-btn helix-brand-color",
                        onClick: handleNavigateToProficiencyMetrics,
                        children: [
                            (0, $cstaF.agentProductionTerms).proficiencyMetrics,
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                                icon: (0, $eOjgM.chevron_small_right),
                                className: "ml-1"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "d-flex justify-content-center mb-4",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $d0f280f2d67de5a2$export$2e2bcd8739ae039), {
                    defaultActiveKey: "top-producers",
                    onItemChange: (item)=>setState((prevState)=>({
                                ...prevState,
                                activeTab: item
                            })),
                    children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $619708240f4690e2$export$1ace7127e536b2b8), {
                        className: "helix-flex-no-shrink",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74b6c675b9157773$export$2e2bcd8739ae039), {
                                eventKey: "top-producers",
                                "aria-checked": state.activeTab === "top-producers",
                                style: {
                                    backgroundColor: "var(--helix-grey)"
                                },
                                children: (0, $4EYT7.terms).topProducers
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $74b6c675b9157773$export$2e2bcd8739ae039), {
                                eventKey: "at-risk",
                                "aria-checked": state.activeTab === "at-risk",
                                children: (0, $4EYT7.terms).atRisk
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "agent-productivity agent-list",
                children: [
                    !state.isLoading && hasAgentData && sortedAgentData.map((agent)=>{
                        const difference = agent.percentChange;
                        const isIncrease = difference > 0;
                        const isDecrease = difference < 0;
                        const isEqual = difference === 0;
                        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            id: agent.id,
                            className: "agent-productivity agent-row",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "agent-productivity agent-info",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "agent-productivity agent-rank",
                                            children: agent.rank
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "agent-productivity agent-initials",
                                            children: agent.initials
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "agent-productivity agent-name",
                                            children: agent.name
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "agent-productivity agent-stats",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsxs)("strong", {
                                            "data-testid": "small-widget-difference",
                                            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)("d-flex align-items-center font-weight-bold agent-productivity", {
                                                "increase-agent-sales-volume": isIncrease,
                                                "decrease-agent-sales-volume": isDecrease,
                                                "equal-agent-sales-volume": isEqual
                                            }),
                                            children: [
                                                isIncrease && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                                                    icon: (0, $eOjgM.arrow_chart_line),
                                                    className: "agent-productivity agent-icon"
                                                }),
                                                isDecrease && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                                                    icon: (0, $eOjgM.arrow_chart_line_down),
                                                    className: "agent-productivity agent-icon"
                                                }),
                                                isEqual && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                                                    icon: (0, $eOjgM.dash_indeterminate)
                                                }),
                                                (0, $htzEo.formatPercentageWithMultiplier)(Math.abs(difference), false, true)
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "agent-productivity agent-sales",
                                            children: agent.sales
                                        })
                                    ]
                                })
                            ]
                        }, agent.id);
                    }),
                    !state.isLoading && !hasAgentData && /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                                className: "helix-display-x-small mb-1 text-center",
                                children: (0, $4EYT7.terms).noAgentActivityTitle
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                                className: "text-center",
                                children: [
                                    (0, $4EYT7.terms).noAgentActivityMessage1,
                                    " ",
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("br", {}),
                                    (0, $4EYT7.terms).noAgentActivityMessage2
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $1d98f57976b4f2ca$export$2e2bcd8739ae039 = $1d98f57976b4f2ca$var$AgentProductivity;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $4EYT7 = parcelRequire("4EYT7");

var $cstaF = parcelRequire("cstaF");

var $dI25G = parcelRequire("dI25G");

var $eOjgM = parcelRequire("eOjgM");

var $7tOHe = parcelRequire("7tOHe");

var $24YIE = parcelRequire("24YIE");

var $90ISC = parcelRequire("90ISC");

var $6IhJz = parcelRequire("6IhJz");
var $b27pX = parcelRequire("b27pX");
var $5E40x = parcelRequire("5E40x");
var $lXe7Q = parcelRequire("lXe7Q");

var $htzEo = parcelRequire("htzEo");

var $4EYT7 = parcelRequire("4EYT7");
const $d954fb7686041418$export$fcce7887255d1c69 = (current, prior)=>{
    if (current !== undefined && prior !== undefined && prior !== 0) {
        const percentChange = (current - prior) / prior * 100;
        if (percentChange > 0) return (0, $4EYT7.terms).upwardShift;
        if (percentChange < 0) return (0, $4EYT7.terms).downwardShift;
        if (percentChange === 0) return (0, $4EYT7.terms).noChange;
    }
    return null;
};



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $3r6bj = parcelRequire("3r6bj");

var $c9Z8w = parcelRequire("c9Z8w");
const $bb361fe98e7c30c6$var$SupplyAndDemandChart = ({ chartData: chartData })=>{
    const chartOptions = {
        chart: {
            type: "line",
            toolbar: {
                show: false
            },
            sparkline: {
                enabled: true
            }
        },
        stroke: {
            width: 3,
            curve: "straight"
        },
        colors: [
            "#236847"
        ],
        tooltip: {
            enabled: false
        },
        legend: {
            show: false
        }
    };
    const values = chartData.msiValues || chartData.avgDomValues || [];
    const chartSeries = [
        {
            name: "Value",
            data: values
        }
    ];
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3r6bj))), {
        options: chartOptions,
        series: chartSeries,
        type: "line",
        width: "100%",
        height: "60px"
    });
};
$bb361fe98e7c30c6$var$SupplyAndDemandChart.propTypes = {
    chartData: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).shape({
        msiValues: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number),
        avgDomValues: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).number)
    }).isRequired
};
var $bb361fe98e7c30c6$export$2e2bcd8739ae039 = $bb361fe98e7c30c6$var$SupplyAndDemandChart;




var $kfZjc = parcelRequire("kfZjc");

var $f6CJ4 = parcelRequire("f6CJ4");
const $95e8e476ab85bc72$var$SupplyDemand = ()=>{
    const history = (0, $kfZjc.useHistory)();
    const userProducts = (0, $90ISC.useCommonStore)((state)=>state.privileges?.userProducts);
    const isLegacyUser = (0, $f6CJ4.useAuthStore)((state)=>state.isLegacyUser);
    const hasProficiencyMetricsAccess = !!(userProducts?.includes((0, $cstaF.moduleNames).proficiencyMetrics) || isLegacyUser);
    const [isLoadingData, setIsLoadingData] = (0, $acw62.useState)(false);
    const [supplyDemandData, setSupplyDemandData] = (0, $acw62.useState)({
        currentMsi: null,
        priorYearMsi: null,
        msiDirection: null,
        currentAvgDom: null,
        priorYearAvgDom: null,
        avgDomDirection: null,
        monthName: null
    });
    const [msiChartData, setMsiChartData] = (0, $acw62.useState)({
        msiValues: []
    });
    const [avgDomChartData, setAvgDomChartData] = (0, $acw62.useState)({
        avgDomValues: []
    });
    const [hasData, setHasData] = (0, $acw62.useState)(true);
    const { selectedMls: selectedMls } = (0, $90ISC.useSearchStore)((state)=>({
            selectedMls: state[state.selectedModule]?.selectedMls
        }));
    (0, $acw62.useEffect)(()=>{
        const fetchData = async ()=>{
            const selectedMlsId = selectedMls?.mlsId.toString();
            if (!selectedMlsId) return;
            setIsLoadingData(true);
            try {
                const response = await (0, $24YIE.getMonthlySupplyDemand)(selectedMlsId);
                if (!response?.results || response.results.length === 0) {
                    setHasData(false);
                    setIsLoadingData(false);
                    return;
                }
                const currentDate = new Date();
                const previousMonth = (0, $5E40x.default)((0, $lXe7Q.default)(currentDate, 1));
                const previousYearMonth = (0, $5E40x.default)((0, $lXe7Q.default)(previousMonth, 12));
                const chartStartMonth = (0, $5E40x.default)((0, $lXe7Q.default)(previousMonth, 11));
                const chartRangeData = (response?.results ?? []).filter((item)=>{
                    const itemDate = new Date(item.firstday);
                    return itemDate >= chartStartMonth && itemDate <= previousMonth;
                }).sort((a, b)=>new Date(a.firstday) - new Date(b.firstday));
                const monthName = (0, $6IhJz.default)(previousMonth, "MMMM");
                const previousMonthData = response.results.find((item)=>{
                    const itemDate = new Date(item.firstday);
                    return (0, $b27pX.default)(itemDate, previousMonth);
                });
                const previousYearData = response.results.find((item)=>{
                    const itemDate = new Date(item.firstday);
                    return (0, $b27pX.default)(itemDate, previousYearMonth);
                });
                const currentMsi = previousMonthData?.msi;
                const priorYearMsi = previousYearData?.msi;
                const currentAvgDom = previousMonthData?.avgDom;
                const priorYearAvgDom = previousYearData?.avgDom;
                setSupplyDemandData({
                    currentMsi: currentMsi,
                    priorYearMsi: priorYearMsi,
                    msiDirection: (0, $d954fb7686041418$export$fcce7887255d1c69)(currentMsi, priorYearMsi),
                    currentAvgDom: currentAvgDom,
                    priorYearAvgDom: priorYearAvgDom,
                    avgDomDirection: (0, $d954fb7686041418$export$fcce7887255d1c69)(currentAvgDom, priorYearAvgDom),
                    monthName: monthName
                });
                setMsiChartData({
                    msiValues: chartRangeData.map((item)=>item.msi)
                });
                setAvgDomChartData({
                    avgDomValues: chartRangeData.map((item)=>item.avgDom)
                });
                setHasData(true);
            } catch (error) {
                console.error(error);
                setHasData(false);
            } finally{
                setIsLoadingData(false);
            }
        };
        fetchData();
    }, [
        selectedMls?.mlsId
    ]);
    const emptyState = /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "d-flex flex-column justify-content-center align-items-center py-5",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
            className: "helix-gray-6 text-center mb-0",
            children: (0, $4EYT7.terms).emptySupplyAndDemandData
        })
    });
    const metricsContent = /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "d-flex flex-column supply-demand-content",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "d-flex align-items-start mb-4",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "mr-4 supply-demand-chart d-flex justify-content-center align-items-center",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bb361fe98e7c30c6$export$2e2bcd8739ae039), {
                            chartData: msiChartData
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "supply-demand-text",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                className: "d-flex supply-demand-subtitle mb-2 justify-content-start",
                                children: (0, $4EYT7.terms).supplyOfInventoryTitle((0, $htzEo.formatUnits)(supplyDemandData.currentMsi))
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "supply-demand-metrics-text helix-gray-6 mb-0",
                                children: (0, $4EYT7.terms).supplyOfInventory(supplyDemandData.monthName, (0, $htzEo.formatUnits)(supplyDemandData.currentMsi), supplyDemandData.msiDirection)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "d-flex align-items-start",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "d-flex mr-4 supply-demand-chart align-items-center justify-content-center",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $bb361fe98e7c30c6$export$2e2bcd8739ae039), {
                            chartData: avgDomChartData
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "supply-demand-text",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                                className: "d-flex supply-demand-subtitle mb-2 justify-content-start",
                                children: (0, $4EYT7.terms).averageDaysOnMarketTitle((0, $htzEo.formatUnits)(supplyDemandData.currentAvgDom))
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                                className: "supply-demand-metrics-text helix-gray-6 mb-0",
                                children: (0, $4EYT7.terms).averageDaysOnMarket(supplyDemandData.monthName, (0, $htzEo.formatUnits)(supplyDemandData.currentAvgDom), supplyDemandData.avgDomDirection)
                            })
                        ]
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "content dashboard-card d-flex flex-column h-100 p-4",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "d-flex justify-content-between align-items-start mb-4",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "d-flex align-items-center",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("h2", {
                            className: "helix-legend-value mb-1 mr-2",
                            children: (0, $4EYT7.terms).supplyAmpDemand
                        })
                    }),
                    hasProficiencyMetricsAccess && /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                        className: "helix-body--strong dashboard-nav-btn helix-brand-color",
                        onClick: ()=>history.push((0, $c8257d18c4a1050f$export$cbd12ebcc216e09a)({
                                product: (0, $cstaF.moduleNames).marketDynamics,
                                userProducts: userProducts,
                                isLegacyUser: isLegacyUser
                            })),
                        children: [
                            (0, $cstaF.marketDynamicsTerms).marketDynamics,
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                                icon: (0, $eOjgM.chevron_small_right),
                                className: "ml-1"
                            })
                        ]
                    })
                ]
            }),
            isLoadingData ? /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "d-flex justify-content-center align-items-center pb-4 recruiting-card-size",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {})
            }) : hasData ? metricsContent : emptyState
        ]
    });
};
var $95e8e476ab85bc72$export$2e2bcd8739ae039 = $95e8e476ab85bc72$var$SupplyDemand;


const $264c90c808adef20$var$Dashboard = (props)=>{
    if (!props?.userInfo) return null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a9e4d0cdcdd5a785$export$2e2bcd8739ae039), {
                ...props
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "p-4",
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "dashboard row",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                            className: "col-lg-4",
                            children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                className: "h-100",
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $3f7df0ed892da27d$export$2e2bcd8739ae039), {})
                            })
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "col-lg-8",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "row mb-4",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "col-md-6 mb-4 mb-md-0",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $1d98f57976b4f2ca$export$2e2bcd8739ae039), {})
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                            className: "col-md-6",
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $95e8e476ab85bc72$export$2e2bcd8739ae039), {})
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                    className: "row",
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                                        className: "col-12",
                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $943ea99297ef765c$export$2e2bcd8739ae039), {})
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
$264c90c808adef20$var$Dashboard.propTypes = {
    userInfo: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).object
};
var $264c90c808adef20$export$2e2bcd8739ae039 = $264c90c808adef20$var$Dashboard;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");


var $cstaF = parcelRequire("cstaF");
const $ed7221e62f17074a$var$Settings = ({ isMarketShareAllowed: isMarketShareAllowed })=>{
    const getTabSettings = ()=>[
            {
                title: (0, $cstaF.agentProductionTerms).profile,
                content: {
                    jsx: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {})
                }
            },
            {
                title: (0, $cstaF.agentProductionTerms).office,
                content: {
                    jsx: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {})
                }
            },
            {
                title: (0, $cstaF.agentProductionTerms).mls,
                content: {
                    jsx: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {})
                }
            },
            {
                title: (0, $cstaF.marketShareTerms).comparisonSets,
                content: {
                    jsx: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ayMG0.Fragment), {})
                }
            }
        ].filter((tab)=>isMarketShareAllowed || tab.title !== (0, $cstaF.marketShareTerms).comparisonSets);
    const tabItems = getTabSettings();
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("h4", {
                children: (0, $cstaF.agentProductionTerms).settings
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "d-flex w-100",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8f390b0d641c1be9$export$2e2bcd8739ae039), {
                    contentSize: tabItems.length,
                    items: tabItems,
                    tabs: true,
                    navSize: tabItems.length
                })
            })
        ]
    });
};
$ed7221e62f17074a$var$Settings.propTypes = {
    isMarketShareAllowed: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).bool
};
var $ed7221e62f17074a$export$2e2bcd8739ae039 = $ed7221e62f17074a$var$Settings;


const $4c8cda5d2c6d1d8b$var$App = ()=>{
    const [state, setState] = (0, $acw62.useState)({
        agentList: {},
        userInactive: false,
        mlsId: undefined,
        propTypes: undefined,
        mappedAreas: undefined,
        offices: undefined,
        selectedSearchApplied: undefined,
        selectedSavedMarketArea: undefined,
        selectedMarketAreaApplied: undefined,
        allowedModules: undefined,
        navItems: undefined,
        userOffices: undefined,
        userAccounts: undefined,
        userAccount: undefined,
        privileges: undefined,
        isPendoReady: false
    });
    const [agentData, setAgentData] = (0, $acw62.useState)({});
    let location = (0, $kfZjc.useLocation)();
    const history = (0, $kfZjc.useHistory)();
    const { membership: membership, officeInfo: officeInfo, timeIntervals: timeIntervals, getPrivileges: getPrivileges, getUserProfile: getUserProfile, getOfficeInfo: getOfficeInfo, getMembership: getMembership, getTimeIntervals: getTimeIntervals, pendoDataLayers: pendoDataLayers, setMlsProviders: setMlsProviders, setPendoDataLayers: setPendoDataLayers, getMarketAreaLists: getMarketAreaLists, getOfficeLists: getOfficeLists, getAgentLists: getAgentLists, setAccountInfo: setAccountInfo, setUserInfo: setUserInfo, agentMetricsAgentProfileData: agentMetricsAgentProfileData } = (0, $90ISC.useCommonStore)((state)=>{
        const agentInfo = state?.agentInfo?.[0];
        const agentMetricsAgentProfileData = {
            agentId: agentInfo?.mlsAgentId?.agentId,
            mlsSid: agentInfo?.mlsAgentId?.mlsId,
            agentName: `${agentInfo?.firstName} ${agentInfo?.lastName}`,
            officeName: agentInfo?.office?.name
        };
        return {
            userInfo: state.userInfo,
            membership: state.membership,
            officeInfo: state.officeInfo,
            timeIntervals: state.timeIntervals,
            getPrivileges: state.getPrivileges,
            getUserProfile: state.getUserProfile,
            getOfficeInfo: state.getOfficeInfo,
            getMembership: state.getMembership,
            getTimeIntervals: state.getTimeIntervals,
            pendoDataLayers: state.pendoDataLayers,
            setMlsProviders: state.setMlsProviders,
            setPendoDataLayers: state.setPendoDataLayers,
            getMarketAreaLists: state.getMarketAreaLists,
            getOfficeLists: state.getOfficeLists,
            getAgentLists: state.getAgentLists,
            setAccountInfo: state.setAccountInfo,
            setUserInfo: state.setUserInfo,
            agentMetricsAgentProfileData: agentMetricsAgentProfileData
        };
    });
    const selectedModule = (0, $90ISC.useSearchStore)((state)=>state.selectedModule);
    const setModuleAgentData = (data)=>{
        setAgentData((prev)=>({
                ...prev,
                [selectedModule]: data
            }));
    };
    const { tokenInfo: tokenInfo, tokenType: tokenType, handleShouldShowLinkLwaModal: handleShouldShowLinkLwaModal, isLegacyUser: isLegacyUser, initAgentMetricsApp: initAgentMetricsApp, isXamUserValidated: isXamUserValidated } = (0, $f6CJ4.useAuthStore)((state)=>({
            tokenInfo: state.tokenInfo,
            tokenType: state.tokenType,
            handleShouldShowLinkLwaModal: state.handleShouldShowLinkLwaModal,
            isLegacyUser: state.isLegacyUser,
            initAgentMetricsApp: state.initAgentMetricsApp,
            isXamUserValidated: state.isXamUserValidated
        }));
    const isLWAAuthenticated = tokenType === (0, $cghEn.tokenTypes).LWA;
    const { data: platformService } = (0, $4862a4c3c2140fd6$export$4536ea3a6fa70195)(isLWAAuthenticated);
    const [lwaClients, setLwaClients] = (0, $acw62.useState)(undefined);
    (0, $acw62.useEffect)(()=>{
        if (!platformService) return;
        platformService.getLwaClients().then(setLwaClients);
    }, [
        platformService
    ]);
    const { agentDataStore: agentDataStore, setTotalsRowData: setTotalsRowData, setSummaryPinnedData: setSummaryPinnedData, selectedMls: selectedMls, setSelectedModule: setSelectedModule, getSavedSearchList: getSavedSearchList, setSelectedMls: setSelectedMls, searchStatus: searchStatus, setLoadedSearch: setLoadedSearch, setIsLoading: setIsLoading, setIsLoadingSearchData: setIsLoadingSearchData, setSearchStatus: setSearchStatus, search: search, loadedSearchCriteria: loadedSearchCriteria, selectedSavedSearch: selectedSavedSearch, runMarketShareTotalsSearch: runMarketShareTotalsSearch, isManualSearch: isManualSearch, clearSavedAgentsOptionalFilterTitles: clearSavedAgentsOptionalFilterTitles, clearSelectedAgentIds: clearSelectedAgentIds } = (0, $90ISC.useSearchStore)((state)=>({
            agentDataStore: state[selectedModule]?.agentData,
            setTotalsRowData: state.setTotalsRowData,
            setSummaryPinnedData: state.setSummaryPinnedData,
            selectedMls: state[selectedModule]?.selectedMls,
            setSelectedModule: state.setSelectedModule,
            getSavedSearchList: state.getSavedSearchList,
            setSelectedMls: state.setSelectedMls,
            searchStatus: state[selectedModule]?.searchStatus,
            setLoadedSearch: state.setLoadedSearch,
            setIsLoading: state.setIsLoading,
            setIsLoadingSearchData: state.setIsLoadingSearchData,
            setSearchStatus: state.setSearchStatus,
            search: state[selectedModule]?.search,
            loadedSearchCriteria: state[selectedModule]?.loadedSearchCriteria,
            selectedSavedSearch: state[selectedModule]?.selectedSavedSearch,
            runMarketShareTotalsSearch: state.runMarketShareTotalsSearch,
            isManualSearch: state.isManualSearch,
            clearSavedAgentsOptionalFilterTitles: state.clearSavedAgentsOptionalFilterTitles,
            clearSelectedAgentIds: state.clearSelectedAgentIds
        }));
    const { searchResultsStore: searchResultsStore, setSearchResults: setSearchResults } = (0, $eickZ.useSearchResultsStore)((state)=>({
            searchResultsStore: state[selectedModule]?.searchResults?.results,
            setSearchResults: state.setSearchResults
        }));
    const agentNameModule = (0, $cstaF.modules).proficiencyMetrics.agents;
    const savedAgentsModule = (0, $cstaF.modules).proficiencyMetrics.savedAgents;
    const { findAgentListById: findAgentListById, setGlobalSavedAgentListId: setGlobalSavedAgentListId, setSelectedListByModule: setSelectedListByModule } = (0, $90ISC.useSavedAgentsStore)((state)=>({
            findAgentListById: state.findAgentListById,
            setGlobalSavedAgentListId: state.setGlobalSavedAgentListId,
            setSelectedListByModule: state.setSelectedListByModule
        }));
    const runMarketDynamicsSearch = (0, $70q5f.useMarketDynamicsStore)((state)=>state.runMarketDynamicsSearch);
    const { resetTableSettings: resetTableSettings } = (0, $05517877e446f741$export$ebc48288de47ba8d)((state)=>({
            resetTableSettings: state.resetTableSettings
        }));
    const fetchLogo = (0, $bA5Mi.usePDFStore)((state)=>state.fetchLogo);
    const { toastProps: toastProps } = (0, $ddjPx.useToastStore)((state)=>({
            toastProps: state.toastProps
        }));
    (0, $acw62.useEffect)(()=>{
        const checkPendoReady = ()=>{
            if (window.pendo) (0, $ivaD7.setStateData)("isPendoReady", true, setState);
            else setTimeout(checkPendoReady, 50);
        };
        checkPendoReady();
        clearSavedAgentsOptionalFilterTitles();
    }, []);
    const ownerId = tokenType && (0, $cghEn.getOwnerIdByTokenInfo)[tokenType](tokenInfo);
    // We have different Agent Data location, depending of the module.
    const agentDataState = agentData?.[selectedModule];
    const selectedAgentData = agentDataState || agentDataStore || searchResultsStore || agentDataState?.agentMovementSearch;
    const featureToggles = (0, $kLrt8.useFeatureToggles)();
    const initializePendo = (pendoDataLayers)=>{
        window.pendo?.initialize(pendoDataLayers);
    };
    const localToken = JSON.parse(localStorage.getItem("auth_state"))?.state?.token;
    // This checks if the session was ended in another tab
    (0, $acw62.useEffect)(()=>{
        if (!localToken) (0, $7D4kr.navigateToLogout)();
    }, [
        localToken
    ]);
    const isAgentProductionModule = selectedModule === (0, $cstaF.modules).agentProduction.agentProduction;
    const mlsId = (0, $dDBOF.isAgentMetrics) && isAgentProductionModule ? agentMetricsAgentProfileData.mlsSid : selectedMls?.mlsId;
    const mlsProps = (0, $aa9764060f6e10ce$export$65c94bb0e14ddf31)(mlsId, selectedModule);
    (0, $acw62.useEffect)(()=>{
        if (!pendoDataLayers && !isLegacyUser && !state.isPendoReady) return;
        initializePendo(pendoDataLayers);
        window.pendo?.updateOptions(pendoDataLayers);
    }, [
        pendoDataLayers,
        state.isPendoReady
    ]);
    const isAgentProductionEnabled = featureToggles.agentProduction.isEnabled;
    (0, $acw62.useEffect)(async ()=>{
        if (!tokenInfo || !state.isPendoReady) return;
        await fetchLogo();
        if (mlsProps && officeInfo && timeIntervals && loadedSearchCriteria && (searchStatus !== (0, $cstaF.searchStatuses).running || searchStatus !== (0, $cstaF.searchStatuses).ran)) {
            setSearchStatus((0, $cstaF.searchStatuses).run);
            setIsLoadingSearchData(true);
            setIsLoading(true);
        }
        if (0, $dDBOF.isAgentMetrics) {
            initAgentMetricsApp({
                setState: setState,
                setPendoDataLayers: setPendoDataLayers,
                tokenInfo: tokenInfo,
                getUserLists: getUserLists,
                history: history,
                isLegacyUser: isLegacyUser,
                runningApp: $dDBOF.runningApp,
                ownerId: ownerId,
                isAgentProductionEnabled: isAgentProductionEnabled
            });
            return;
        }
        let userAccounts;
        if (tokenType === (0, $cghEn.tokenTypes).LWA) {
            const xbmUserIdFromToken = tokenInfo[0, $cghEn.LWA_TOKEN_OBJECT_IDENTIFIER]?.apps?.xbm?.uid;
            const lwaId = (0, $6g8wQ.getLwaIdFromTokenInfo)(tokenInfo);
            userAccounts = await (0, $caGGw.getUserAccountsById)(xbmUserIdFromToken, lwaId);
            if (userAccounts.error === 404) (0, $7D4kr.navigateToLogout)();
            (0, $ivaD7.setStateData)("userAccounts", userAccounts, setState);
        }
        if (tokenType === (0, $cghEn.tokenTypes).KEYCLOAK) userAccounts = await (0, $caGGw.getUserAccounts)(tokenInfo.email);
        if (userAccounts.error && userAccounts.error !== 404) return;
        // if there are no userAccounts returned, then this indicates old legacy setup
        if (!userAccounts.accounts?.length) {
            const userProducts = (0, $dFPJJ.getUserProducts)({
                isLegacyUser: true
            });
            (0, $ivaD7.setStateData)("allowedModules", userProducts, setState);
            const profile = await getUserProfile(tokenInfo.preferred_username);
            if (profile.error) return;
            if (!profile.isSetupActive || !profile.isUserActive) {
                (0, $ivaD7.setStateData)("userInactive", true, setState);
                return;
            }
            const productFlags = (0, $lxCva.getProductFlags)(userProducts);
            setPendoDataLayers({
                tokenInfo: tokenInfo,
                productFlags: productFlags,
                isLegacyUser: isLegacyUser,
                runningApp: $dDBOF.runningApp,
                ownerId: ownerId
            });
            if (!!profile?.accessibleOfficeList?.length) await getOfficeInfo(profile?.accessibleOfficeList);
            await getMembership(profile.mlsList);
            await getTimeIntervals();
            await getUserLists(ownerId);
            const userOffices = profile.accessibleOfficeList.reduce((acc, office)=>{
                const existingMls = acc.find((item)=>item.mlsId === office.mlsId);
                if (existingMls) existingMls.officeIds.push(office.officeId);
                else acc.push({
                    mlsId: office.mlsId,
                    officeIds: [
                        office.officeId
                    ]
                });
                return acc;
            }, []);
            (0, $90ISC.useCommonStore).setState({
                privileges: {
                    userOffices: userOffices
                }
            });
            return;
        }
        //TODO: add account selector logic here, right now select the first option
        const selectedAccount = userAccounts?.accounts[0];
        const isAccountUserInactive = !selectedAccount.accountActive || !selectedAccount.userActive;
        // This is part of the A/C of XBM-7408 and could be modified after the demo
        if (isAccountUserInactive && !(0, $dDBOF.isAgentMetrics)) {
            (0, $ivaD7.setStateData)("userInactive", true, setState);
            return;
        }
        const hasLwaId = !!userAccounts?.user?.lwaId;
        (0, $ivaD7.setStateData)("userAccount", selectedAccount, setState);
        setAccountInfo(selectedAccount);
        setUserInfo(userAccounts?.user);
        handleShouldShowLinkLwaModal(hasLwaId);
        const privileges = await getPrivileges(selectedAccount.id, userAccounts.user.id);
        const userProducts = (0, $dFPJJ.getUserProducts)({
            privileges: privileges
        });
        const productFlags = (0, $lxCva.getProductFlags)(userProducts);
        setPendoDataLayers({
            tokenInfo: tokenInfo,
            selectedAccount: selectedAccount,
            productFlags: productFlags,
            isLegacyUser: isLegacyUser,
            runningApp: $dDBOF.runningApp,
            ownerId: ownerId
        });
        if (privileges?.error) return;
        (0, $ivaD7.setStateData)("allowedModules", privileges.userProducts, setState);
        if (searchStatus === (0, $cstaF.searchStatuses).running) setSearchStatus((0, $cstaF.searchStatuses).run);
        const activeValidOffices = await setMlsListForMembershipLookup(privileges);
        activeValidOffices && await getMembership(activeValidOffices?.map((o)=>o.mlsOfficeId.mlsId));
        await getTimeIntervals();
        await getUserLists(ownerId);
    }, [
        tokenInfo,
        state.isPendoReady,
        isXamUserValidated
    ]);
    (0, $acw62.useEffect)(()=>{
        membership && (0, $ivaD7.setStateData)("mlsList", membership, setState);
    }, [
        membership
    ]);
    (0, $acw62.useEffect)(()=>{
        officeInfo && (0, $ivaD7.setStateData)("userOffices", officeInfo, setState);
    }, [
        officeInfo
    ]);
    (0, $acw62.useEffect)(async ()=>{
        //run search again if not already loaded (refresh)
        //we dont want this for suggestedAgents module, since we are not running a search manually.
        if (selectedModule === (0, $cstaF.modules).proficiencyMetrics.suggestedAgents) return;
        if (loadedSearchCriteria && !agentData?.[selectedModule] && (!searchStatus || searchStatus === (0, $cstaF.searchStatuses).ran)) {
            setLoadedSearch();
            setSearchStatus((0, $cstaF.searchStatuses).run);
        }
    }, [
        loadedSearchCriteria,
        agentData
    ]);
    (0, $acw62.useEffect)(async ()=>{
        if (!tokenInfo) return;
        if (searchStatus === (0, $cstaF.searchStatuses).run) {
            setIsLoading(true);
            setIsLoadingSearchData(true);
            setLoadedSearch();
            if (isManualSearch) clearSelectedAgentIds();
            setModuleAgentData(undefined);
            (0, $ivaD7.setStateData)("agentList", undefined, setState);
            try {
                resetTableSettings();
                await runSearch();
            } catch  {
                setIsLoadingSearchData(false);
            }
        } else if (searchStatus === (0, $cstaF.searchStatuses).ran) {
            setIsLoading(false);
            setIsLoadingSearchData(false);
            setSearchStatus(undefined);
            if (isManualSearch) (0, $90ISC.useSearchStore).setState({
                isManualSearch: false
            });
        }
    }, [
        searchStatus
    ]);
    (0, $acw62.useEffect)(async ()=>{
        if (!!state.mlsList?.length) {
            const activeMlsList = state.mlsList.filter((mls)=>mls.isActive);
            const activeMlsListWithActiveOffices = !state.userOffices?.length ? activeMlsList : activeMlsList.filter((mls)=>!!state.userOffices.find((office)=>office.isOfficeActive && office.mlsOfficeId.mlsId === mls.mlsId));
            if (activeMlsListWithActiveOffices?.length === 1) {
                if (selectedModule === (0, $cstaF.modules).proficiencyMetrics.suggestedAgents || selectedModule === (0, $cstaF.modules).dashboard.dashboard) setSelectedMls(activeMlsListWithActiveOffices[0], selectedModule, timeIntervals, activeMlsListWithActiveOffices?.length);
                else {
                    if (selectedSavedSearch) return;
                    setMlsProviders(activeMlsListWithActiveOffices);
                    !loadedSearchCriteria && await setSelectedMls(activeMlsListWithActiveOffices[0], selectedModule, timeIntervals, activeMlsListWithActiveOffices?.length);
                }
            } else {
                const sortFunction = (a, b)=>a.shortDescription.localeCompare(b.shortDescription);
                activeMlsListWithActiveOffices && setMlsProviders(activeMlsListWithActiveOffices.sort(sortFunction));
                if ((selectedModule === (0, $cstaF.modules).proficiencyMetrics.suggestedAgents || selectedModule === (0, $cstaF.modules).dashboard.dashboard) && !selectedMls?.mlsId) setSelectedMls(activeMlsListWithActiveOffices[0], selectedModule, timeIntervals, activeMlsListWithActiveOffices?.length);
            }
        }
    }, [
        state.mlsList,
        state.userOffices,
        selectedModule,
        selectedMls
    ]);
    const handleDashboardRedirect = async ()=>{
        const isDashboardEnabled = featureToggles.dashboard.isEnabled;
        const isOnRootPath = location.pathname === "/";
        const isOnDashboardPath = location.pathname === (0, $c7dF9.Routes).HOME.DASHBOARD;
        if (isDashboardEnabled && (isOnRootPath || isOnDashboardPath)) {
            await setSelectedModule((0, $cstaF.modules).dashboard.dashboard);
            await navTo((0, $cstaF.moduleRoutes)[(0, $cstaF.modules).dashboard.dashboard], (0, $cstaF.modules).dashboard.dashboard);
            return true;
        }
        return false;
    };
    (0, $acw62.useEffect)(async ()=>{
        if (state.allowedModules && !selectedModule) {
            const isNonModuleRoute = (0, $c7dF9.nonModuleRoutes).some((route)=>location.pathname.startsWith(route));
            if (isNonModuleRoute) return;
            const redirectedToDashboard = await handleDashboardRedirect();
            if (redirectedToDashboard) return;
            const initialModuleToLoad = (0, $ekOct.getAllowedModuleByUrl)({
                url: location.pathname,
                allowedModules: state.allowedModules,
                modulesByRouteAndNameAssociation: (0, $cstaF.modulesByRouteAndNameAssociation)
            });
            await setSelectedModule(initialModuleToLoad);
            await navTo((0, $cstaF.moduleRoutes)[initialModuleToLoad], initialModuleToLoad);
        }
    }, [
        state.allowedModules,
        selectedModule
    ]);
    (0, $acw62.useEffect)(()=>{
        if (!state.allowedModules) return;
        const isDashboardEnabled = featureToggles.dashboard.isEnabled;
        const isTalentEnabled = featureToggles.talent.isEnabled;
        let filteredNavItems = (0, $c8257d18c4a1050f$export$d06a4cb77a922f24)({
            allowedModules: state.allowedModules,
            navTo: navTo,
            isAgentProductionEnabled: isAgentProductionEnabled,
            isDashboardEnabled: isDashboardEnabled,
            isLegacyUser: isLegacyUser,
            isTalentEnabled: isTalentEnabled,
            lwaClients: lwaClients
        });
        if (!featureToggles.suggestedAgents.isEnabled) filteredNavItems = filteredNavItems.map((item)=>({
                ...item,
                menuItems: item?.menuItems?.filter((item)=>item.label !== (0, $9QX0f.terms).suggestedAgents)
            }));
        if (!featureToggles.agentMovement.isEnabled) filteredNavItems = filteredNavItems.map((item)=>({
                ...item,
                menuItems: item?.menuItems?.filter((item)=>item.label !== (0, $1byMr.terms).agentMovement)
            }));
        (0, $ivaD7.setStateData)("navItems", filteredNavItems, setState);
    }, [
        state.allowedModules,
        isLegacyUser,
        lwaClients
    ]);
    (0, $acw62.useEffect)(async ()=>{
        if (location && location.pathname !== "/" && selectedModule && location.pathname !== (0, $cstaF.moduleRoutes)[selectedModule]) {
            const nextModule = (0, $dlZsJ.getKeyByValue)((0, $cstaF.moduleRoutes), location.pathname) || Object.keys((0, $cstaF.moduleRoutes)).find((key)=>location.pathname.startsWith((0, $cstaF.moduleRoutes)[key]));
            if (nextModule) await setSelectedModule(nextModule);
        }
    }, [
        location
    ]);
    const validateIsManualSearch = ()=>{
        if (isManualSearch) {
            (0, $90ISC.useSearchStore).setState({
                isManualSearch: false
            });
            setIsLoading(false);
            setIsLoadingSearchData(false);
        }
    };
    const runSearch = async ()=>{
        const searchCriteria = search?.searchCriteria;
        if (searchCriteria) {
            setSearchStatus((0, $cstaF.searchStatuses).running);
            switch(selectedModule){
                case (0, $cstaF.modules).proficiencyMetrics.transactions:
                case (0, $cstaF.modules).proficiencyMetrics.offices:
                case (0, $cstaF.modules).proficiencyMetrics.savedAgents:
                case agentNameModule:
                    try {
                        const { recruitingSoldResponse: recruitingSoldResponse, recruitingSoldTotals: recruitingSoldTotals, error: error } = await (0, $8QuU9.getProficiencyMetrics)(searchCriteria);
                        if (!error) {
                            setModuleAgentData(recruitingSoldResponse);
                            setTotalsRowData(recruitingSoldTotals, (0, $i1BZc.responseKeys).recruitingSoldTotals);
                            setSummaryPinnedData((0, $aypMh.views).overview, (0, $i1BZc.responseKeys).recruitingSoldTotals);
                            if (selectedModule === savedAgentsModule) break;
                            if (selectedModule !== agentNameModule) break;
                            const selectedAgentList = findAgentListById();
                            if (selectedAgentList) {
                                setSelectedListByModule(selectedModule, selectedAgentList);
                                setSelectedListByModule((0, $cstaF.modules).proficiencyMetrics.savedAgents, {});
                                setGlobalSavedAgentListId(selectedAgentList?.agentListId);
                                (0, $24YIE.recordAgentListLoad)(selectedAgentList.agentListId).catch(()=>{});
                            }
                        }
                    } catch (err) {
                        console.log(err);
                    }
                    break;
                case (0, $cstaF.modules).proficiencyMetrics.agentMovement:
                    try {
                        const { results: results, totals: totals } = await (0, $8QuU9.getAgentMovement)(searchCriteria);
                        setModuleAgentData({
                            agentMovementSearch: results
                        });
                        setTotalsRowData(totals, (0, $i1BZc.responseKeys).totals);
                        setSearchResults(results.results);
                    } catch (error) {
                        console.error({
                            error: error
                        });
                    }
                    break;
                case (0, $cstaF.modules).marketShare.totals:
                    await runMarketShareTotalsSearch(searchCriteria, setAgentData);
                    validateIsManualSearch();
                    break;
                case (0, $cstaF.modules).marketShare.coverage:
                    const coverageSearchResponse = await (0, $luxkV.getCoverageSearch)(searchCriteria);
                    if (!coverageSearchResponse.error) setModuleAgentData({
                        coverageSearch: coverageSearchResponse
                    });
                    validateIsManualSearch();
                    break;
                case (0, $cstaF.modules).marketDynamics.marketDynamics:
                    const { results: results, totals: totals } = await runMarketDynamicsSearch(searchCriteria);
                    setModuleAgentData({
                        marketDynamicsSearch: results
                    });
                    (0, $90ISC.useCommonStore).setState({
                        getSearchResults: ()=>(0, $42prG.getTransformData)(results)
                    });
                    setTotalsRowData(totals, (0, $i1BZc.responseKeys).totals);
                    break;
                default:
                    break;
            }
            setSearchStatus((0, $cstaF.searchStatuses).ran);
        }
    };
    const getUserLists = async (ownerId)=>{
        await getMarketAreaLists(ownerId);
        await getSavedSearchList(ownerId);
        setIsLoadingSearchData(false);
        if (0, $dDBOF.isAgentMetrics) return;
        await getOfficeLists(ownerId);
        await getAgentLists(ownerId);
    };
    const userAllowedTo = (module)=>{
        return module && (!state.allowedModules?.length || state.allowedModules.includes(module));
    };
    const navTo = async (destination, module)=>{
        history.replace(destination);
        module && await setSelectedModule(module);
    };
    /// validate the user's settings, so we're only using the MLSs for which the user belongs to an active office
    const setMlsListForMembershipLookup = async (privileges)=>{
        let activeOffices = [];
        let mlsOffices = [];
        if (!!privileges.userOffices?.length) mlsOffices = [].concat(...privileges.userOffices.map((group)=>{
            return [].concat(...group.officeIds.map((officeId)=>({
                    officeId: officeId,
                    mlsId: group.mlsId
                })));
        }));
        if (mlsOffices) {
            const response = await getOfficeInfo((0, $iCDWi.removeDuplicates)(mlsOffices));
            if (!response?.error) {
                activeOffices = response.filter((office)=>!!office.isOfficeActive);
                activeOffices.length === 0 && (0, $ivaD7.setStateData)("userInactive", true, setState);
            }
        }
        return activeOffices;
    };
    const shouldShowNavBar = !(0, $7D4kr.routesToHideNavBar).includes(location.pathname);
    const isAppInitialized = state.navItems && tokenInfo;
    const navItemsForLayout = shouldShowNavBar && state.navItems ? state.navItems : null;
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "App",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $f61ig.default), {
                title: "Your login credential is inactive",
                show: state.userInactive,
                onClose: (0, $7D4kr.navigateToLogout),
                buttons: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    className: "w-100 text-center",
                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                        dataLwtId: "logout-button",
                        color: "primary",
                        onClick: (0, $7D4kr.navigateToLogout),
                        children: (0, $cstaF.buttonTerms).ok
                    })
                }),
                children: /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "text-center",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            children: "Please contact our Customer Support at"
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("p", {
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                                    href: `mailto:${(0, $cstaF.emails).terradatumSupport}`,
                                    children: (0, $cstaF.emails).terradatumSupport
                                }),
                                " or call 888-212-4793"
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $daccc500b983ffac$export$4a40f9d7230f4d5f), {}),
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $acw62.Suspense), {
                fallback: /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                    children: "Loading..."
                }),
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfZjc.Route), {
                        exact: true,
                        path: (0, $c7dF9.Routes).AUTH.LOG_OUT,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6cb258770e98d306$export$2e2bcd8739ae039), {})
                    }),
                    (0, $dDBOF.isAgentMetrics) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $kfZjc.Switch), {
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfZjc.Route), {
                                exact: true,
                                path: (0, $c7dF9.Routes).VALIDATION.BASE,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $219bd90e679fe86d$export$2e2bcd8739ae039), {
                                    fluid: true,
                                    hero: true,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6442aa249f054a6a$export$2e2bcd8739ae039), {})
                                })
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfZjc.Route), {
                                exact: true,
                                path: (0, $c7dF9.Routes).AUTH.VERIFICATION_ERROR,
                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $219bd90e679fe86d$export$2e2bcd8739ae039), {
                                    fluid: true,
                                    hero: true,
                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $adda3979c5c6d7f7$export$bba808db88f96979), {})
                                })
                            })
                        ]
                    }),
                    shouldShowNavBar && state.navItems && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4b4e4bde66bae2d5$export$2e2bcd8739ae039), {
                        module: selectedModule,
                        userItems: (0, $c8257d18c4a1050f$export$7d00983a04b3bc19)(navTo, isLegacyUser),
                        helpItems: (0, $c8257d18c4a1050f$export$b344df7b232ea070),
                        navItems: state.navItems,
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ffd7ca5b192a402e$export$2e2bcd8739ae039), {
                            navItems: navItemsForLayout,
                            children: isAppInitialized && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2z9GT.AGGridProvider), {
                                license: (0, $cIUhV.AG_GRID_LICENSE),
                                children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $kfZjc.Switch), {
                                    children: [
                                        featureToggles.dashboard.isEnabled && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfZjc.Route), {
                                            exact: true,
                                            path: (0, $c7dF9.Routes).HOME.DASHBOARD,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $219bd90e679fe86d$export$2e2bcd8739ae039), {
                                                fluid: true,
                                                hero: true,
                                                showFooter: false,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $264c90c808adef20$export$2e2bcd8739ae039), {
                                                    module: selectedModule,
                                                    mlsMembershipInfo: membership,
                                                    mlsProps: mlsProps,
                                                    userId: ownerId,
                                                    userInfo: isLegacyUser ? tokenInfo : state.userAccounts?.user
                                                })
                                            })
                                        }),
                                        userAllowedTo((0, $cstaF.moduleNames).proficiencyMetrics) && [
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $kfZjc.Route), {
                                                exact: true,
                                                path: (0, $cstaF.searchRoutes).transactions,
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b0b6e0361604aa18$export$2e2bcd8739ae039), {
                                                        module: selectedModule,
                                                        mlsProps: mlsProps
                                                    }, "agent-production"),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $219bd90e679fe86d$export$2e2bcd8739ae039), {
                                                        fluid: true,
                                                        hero: true,
                                                        showFooter: false,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ef041f3a12ef845d$export$2e2bcd8739ae039), {
                                                            agentData: selectedAgentData,
                                                            module: (0, $cstaF.modules).proficiencyMetrics.transactions
                                                        })
                                                    })
                                                ]
                                            }, (0, $cstaF.searchRoutes).transactions),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $kfZjc.Route), {
                                                exact: true,
                                                strict: true,
                                                path: (0, $cstaF.searchRoutes).officeName,
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b0b6e0361604aa18$export$2e2bcd8739ae039), {
                                                        module: selectedModule,
                                                        mlsProps: mlsProps
                                                    }, "office-name"),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $219bd90e679fe86d$export$2e2bcd8739ae039), {
                                                        fluid: true,
                                                        hero: true,
                                                        showFooter: false,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ef041f3a12ef845d$export$2e2bcd8739ae039), {
                                                            agentData: selectedAgentData,
                                                            module: (0, $cstaF.modules).proficiencyMetrics.offices
                                                        })
                                                    })
                                                ]
                                            }, (0, $cstaF.searchRoutes).officeName),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $kfZjc.Route), {
                                                exact: true,
                                                strict: true,
                                                path: (0, $cstaF.searchRoutes).agentName,
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b0b6e0361604aa18$export$2e2bcd8739ae039), {
                                                        module: selectedModule,
                                                        mlsProps: mlsProps
                                                    }, "agent-name"),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $219bd90e679fe86d$export$2e2bcd8739ae039), {
                                                        fluid: true,
                                                        hero: true,
                                                        showFooter: false,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ef041f3a12ef845d$export$2e2bcd8739ae039), {
                                                            agentData: selectedAgentData,
                                                            module: agentNameModule
                                                        })
                                                    })
                                                ]
                                            }, (0, $cstaF.searchRoutes).agentName),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfZjc.Route), {
                                                path: (0, $c7dF9.Routes).PROF_METRICS.BASE + (0, $c7dF9.Routes).PROF_METRICS.AGENT_PROFILE,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $219bd90e679fe86d$export$2e2bcd8739ae039), {
                                                    fluid: true,
                                                    hero: true,
                                                    showFooter: false,
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $694a1c0f59c8cc58$export$2e2bcd8739ae039), {
                                                        agentData: selectedAgentData,
                                                        module: selectedModule,
                                                        mlsProps: mlsProps,
                                                        tokenInfo: tokenInfo
                                                    })
                                                })
                                            }, (0, $c7dF9.Routes).PROF_METRICS.BASE + (0, $c7dF9.Routes).PROF_METRICS.AGENT_PROFILE),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfZjc.Route), {
                                                path: (0, $c7dF9.Routes).PROF_METRICS.BASE + (0, $c7dF9.Routes).PROF_METRICS.COVERAGE_LISTING,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $219bd90e679fe86d$export$2e2bcd8739ae039), {
                                                    fluid: true,
                                                    hero: true,
                                                    showFooter: false,
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e37a02ae50f645aa$export$2e2bcd8739ae039), {
                                                        module: selectedModule
                                                    })
                                                })
                                            }, (0, $c7dF9.Routes).PROF_METRICS.BASE + (0, $c7dF9.Routes).PROF_METRICS.COVERAGE_LISTING),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfZjc.Route), {
                                                path: (0, $c7dF9.Routes).PROF_METRICS.BASE + (0, $c7dF9.Routes).PROF_METRICS.LISTING_INFO,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $219bd90e679fe86d$export$2e2bcd8739ae039), {
                                                    fluid: true,
                                                    hero: true,
                                                    showFooter: false,
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $deb2942a8ffbb165$export$2e2bcd8739ae039), {
                                                        agentData: selectedAgentData,
                                                        module: selectedModule
                                                    })
                                                })
                                            }, (0, $c7dF9.Routes).PROF_METRICS.BASE + (0, $c7dF9.Routes).PROF_METRICS.LISTING_INFO),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfZjc.Route), {
                                                path: (0, $c7dF9.Routes).PROF_METRICS.BASE + (0, $c7dF9.Routes).PROF_METRICS.PROD_LISTING,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $219bd90e679fe86d$export$2e2bcd8739ae039), {
                                                    fluid: true,
                                                    hero: true,
                                                    showFooter: false,
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a18a0232cc648c72$export$dfc0309301032959), {
                                                        agentData: selectedAgentData,
                                                        module: selectedModule
                                                    })
                                                })
                                            }, (0, $c7dF9.Routes).PROF_METRICS.BASE + (0, $c7dF9.Routes).PROF_METRICS.PROD_LISTING),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $kfZjc.Route), {
                                                exact: true,
                                                path: (0, $cstaF.searchRoutes).agentMovement,
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b0b6e0361604aa18$export$2e2bcd8739ae039), {
                                                        module: selectedModule,
                                                        mlsProps: mlsProps
                                                    }, "agent-movement"),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $219bd90e679fe86d$export$2e2bcd8739ae039), {
                                                        fluid: true,
                                                        hero: true,
                                                        showFooter: false,
                                                        children: featureToggles.agentMovement.isEnabled ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6d46344e47d84f54$export$2e2bcd8739ae039), {
                                                            agentData: selectedAgentData?.agentMovementSearch
                                                        }) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfZjc.Redirect), {
                                                            to: (0, $cstaF.searchRoutes).transactions
                                                        })
                                                    })
                                                ]
                                            }, (0, $cstaF.searchRoutes).agentMovement),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfZjc.Route), {
                                                exact: true,
                                                path: [
                                                    (0, $cstaF.searchRoutes).agentsGainedBreakdown,
                                                    (0, $cstaF.searchRoutes).officeListBreakdown
                                                ],
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $219bd90e679fe86d$export$2e2bcd8739ae039), {
                                                    fluid: true,
                                                    hero: true,
                                                    showFooter: false,
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $05c0055ebf9e635e$export$2e2bcd8739ae039), {
                                                        setAgentData: setAgentData
                                                    })
                                                })
                                            }, (0, $cstaF.searchRoutes).agentsGainedBreakdown),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $kfZjc.Route), {
                                                exact: true,
                                                path: [
                                                    (0, $cstaF.searchRoutes).savedAgents,
                                                    (0, $cstaF.searchRoutes).savedAgentsActivity
                                                ],
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b0b6e0361604aa18$export$2e2bcd8739ae039), {
                                                        module: selectedModule,
                                                        mlsProps: mlsProps
                                                    }, "saved-agents"),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $219bd90e679fe86d$export$2e2bcd8739ae039), {
                                                        fluid: true,
                                                        hero: true,
                                                        showFooter: false,
                                                        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $6595e2041614f54d$export$2e2bcd8739ae039), {
                                                            setModuleAgentData: setModuleAgentData
                                                        })
                                                    })
                                                ]
                                            }, (0, $cstaF.searchRoutes).savedAgents),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $kfZjc.Route), {
                                                exact: true,
                                                strict: true,
                                                path: (0, $cstaF.searchRoutes).suggestedAgents,
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b0b6e0361604aa18$export$2e2bcd8739ae039), {
                                                        module: selectedModule,
                                                        mlsProps: mlsProps
                                                    }, "suggested-agents-name"),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $219bd90e679fe86d$export$2e2bcd8739ae039), {
                                                        fluid: true,
                                                        hero: true,
                                                        showFooter: false,
                                                        children: featureToggles.suggestedAgents.isEnabled ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $04b81e2666a3f445$export$dd3db22492f1dcde), {}) : /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfZjc.Redirect), {
                                                            to: (0, $cstaF.searchRoutes).transactions
                                                        })
                                                    })
                                                ]
                                            }, (0, $cstaF.searchRoutes).suggestedAgents),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfZjc.Route), {
                                                path: (0, $c7dF9.Routes).PROF_METRICS.BASE + (0, $c7dF9.Routes).PROF_METRICS.SETTINGS,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $219bd90e679fe86d$export$2e2bcd8739ae039), {
                                                    fluid: true,
                                                    hero: true,
                                                    showFooter: false,
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $ed7221e62f17074a$export$2e2bcd8739ae039), {
                                                        isMarketShareAllowed: userAllowedTo((0, $cstaF.moduleNames).marketShare)
                                                    })
                                                })
                                            }, (0, $c7dF9.Routes).PROF_METRICS.BASE + (0, $c7dF9.Routes).PROF_METRICS.SETTINGS)
                                        ],
                                        userAllowedTo((0, $cstaF.moduleNames).marketShare) && [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfZjc.Route), {
                                                path: [
                                                    (0, $cstaF.searchRoutes).totals + (0, $c7dF9.Routes).MARKET_SHARE.OFFICE_LISTING,
                                                    (0, $cstaF.searchRoutes).coverage + (0, $c7dF9.Routes).MARKET_SHARE.OFFICE_LISTING
                                                ],
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $219bd90e679fe86d$export$2e2bcd8739ae039), {
                                                    fluid: true,
                                                    hero: true,
                                                    showFooter: false,
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $58520067ba3cbcf2$export$2e2bcd8739ae039), {
                                                        module: selectedModule
                                                    })
                                                })
                                            }, (0, $cstaF.searchRoutes).totals + (0, $c7dF9.Routes).MARKET_SHARE.OFFICE_LISTING),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfZjc.Route), {
                                                path: [
                                                    (0, $cstaF.searchRoutes).totals + (0, $c7dF9.Routes).MARKET_SHARE.OFFICES_BREAKDOWN,
                                                    (0, $cstaF.searchRoutes).coverage + (0, $c7dF9.Routes).MARKET_SHARE.OFFICES_BREAKDOWN
                                                ],
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $219bd90e679fe86d$export$2e2bcd8739ae039), {
                                                    fluid: true,
                                                    hero: true,
                                                    showFooter: false,
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $468bbfe6e98eaf46$export$2e2bcd8739ae039), {
                                                        module: selectedModule
                                                    })
                                                })
                                            }, (0, $cstaF.searchRoutes).totals + (0, $c7dF9.Routes).MARKET_SHARE.OFFICES_BREAKDOWN),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $kfZjc.Route), {
                                                path: (0, $cstaF.searchRoutes).totals,
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b0b6e0361604aa18$export$2e2bcd8739ae039), {
                                                        module: selectedModule,
                                                        mlsProps: mlsProps
                                                    }, "market-share-totals"),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $219bd90e679fe86d$export$2e2bcd8739ae039), {
                                                        fluid: true,
                                                        hero: true,
                                                        showFooter: false,
                                                        children: selectedModule === (0, $cstaF.modules).marketShare.totals && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2z9GT.AGGridProvider), {
                                                            license: (0, $cIUhV.AG_GRID_LICENSE),
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fe3c308a0b1fa260$export$2e2bcd8739ae039), {
                                                                agentData: agentData?.[(0, $cstaF.modules).marketShare.totals],
                                                                module: (0, $cstaF.modules).marketShare.totals
                                                            })
                                                        })
                                                    })
                                                ]
                                            }, (0, $cstaF.searchRoutes).totals),
                                            !(0, $dDBOF.isAgentMetrics) && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $kfZjc.Route), {
                                                path: (0, $cstaF.searchRoutes).coverage,
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b0b6e0361604aa18$export$2e2bcd8739ae039), {
                                                        module: selectedModule,
                                                        mlsProps: mlsProps
                                                    }, "market-share-coverage"),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $219bd90e679fe86d$export$2e2bcd8739ae039), {
                                                        fluid: true,
                                                        hero: true,
                                                        showFooter: false,
                                                        children: selectedModule === (0, $cstaF.modules).marketShare.coverage && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2z9GT.AGGridProvider), {
                                                            license: (0, $cIUhV.AG_GRID_LICENSE),
                                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $fe3c308a0b1fa260$export$2e2bcd8739ae039), {
                                                                agentData: agentData?.[(0, $cstaF.modules).marketShare.coverage],
                                                                module: (0, $cstaF.modules).marketShare.coverage
                                                            })
                                                        })
                                                    })
                                                ]
                                            }, (0, $cstaF.searchRoutes).coverage),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfZjc.Route), {
                                                path: (0, $c7dF9.Routes).MARKET_SHARE.BASE + (0, $c7dF9.Routes).MARKET_SHARE.LISTING_INFO,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $219bd90e679fe86d$export$2e2bcd8739ae039), {
                                                    fluid: true,
                                                    hero: true,
                                                    showFooter: false,
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $38d5efb10347c946$export$2e2bcd8739ae039), {
                                                        module: selectedModule
                                                    })
                                                })
                                            }, (0, $c7dF9.Routes).MARKET_SHARE.BASE + (0, $c7dF9.Routes).MARKET_SHARE.LISTING_INFO)
                                        ],
                                        userAllowedTo((0, $cstaF.moduleNames).marketDynamics) && [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfZjc.Route), {
                                                path: [
                                                    (0, $cstaF.drillDownRoutesByModule)[(0, $cstaF.moduleNames).marketDynamics].listingInfo
                                                ],
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $219bd90e679fe86d$export$2e2bcd8739ae039), {
                                                    fluid: true,
                                                    hero: true,
                                                    showFooter: false,
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $38d5efb10347c946$export$2e2bcd8739ae039), {
                                                        module: selectedModule
                                                    })
                                                })
                                            }, [
                                                (0, $cstaF.drillDownRoutesByModule)[(0, $cstaF.moduleNames).marketDynamics].listingInfo
                                            ]),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfZjc.Route), {
                                                path: [
                                                    (0, $g7mFm.officeBreakdownRoute),
                                                    (0, $g7mFm.listingsBreakdownRoute),
                                                    (0, $g7mFm.officeListingsRoute)
                                                ],
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $219bd90e679fe86d$export$2e2bcd8739ae039), {
                                                    fluid: true,
                                                    hero: true,
                                                    showFooter: false,
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $16f0cc997409f2ba$export$2e2bcd8739ae039), {})
                                                })
                                            }, [
                                                (0, $g7mFm.officeBreakdownRoute),
                                                (0, $g7mFm.listingsBreakdownRoute),
                                                (0, $g7mFm.officeListingsRoute)
                                            ]),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $kfZjc.Route), {
                                                path: (0, $c7dF9.Routes).MARKET_DYNAMICS.BASE,
                                                children: [
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b0b6e0361604aa18$export$2e2bcd8739ae039), {
                                                        module: selectedModule,
                                                        mlsProps: mlsProps
                                                    }, "market-dynamics"),
                                                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $219bd90e679fe86d$export$2e2bcd8739ae039), {
                                                        fluid: true,
                                                        hero: true,
                                                        showFooter: false,
                                                        children: selectedModule === (0, $cstaF.moduleNames).marketDynamics && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a35b0e2d70079ed9$export$2e2bcd8739ae039), {
                                                            agentData: agentData?.[(0, $cstaF.modules).marketDynamics.marketDynamics],
                                                            module: selectedModule
                                                        })
                                                    })
                                                ]
                                            }, (0, $c7dF9.Routes).MARKET_DYNAMICS.BASE)
                                        ],
                                        userAllowedTo((0, $cstaF.moduleNames).agentProduction) && [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfZjc.Route), {
                                                exact: true,
                                                path: (0, $c7dF9.Routes).AGENT_PRODUCTION.BASE,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $219bd90e679fe86d$export$2e2bcd8739ae039), {
                                                    fluid: true,
                                                    hero: true,
                                                    showFooter: false,
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $694a1c0f59c8cc58$export$2e2bcd8739ae039), {
                                                        agentData: [
                                                            agentMetricsAgentProfileData
                                                        ],
                                                        module: selectedModule,
                                                        mlsProps: mlsProps,
                                                        tokenInfo: tokenInfo
                                                    })
                                                })
                                            }, (0, $c7dF9.Routes).AGENT_PRODUCTION.BASE),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfZjc.Route), {
                                                exact: true,
                                                path: (0, $c7dF9.Routes).AGENT_PRODUCTION.BASE + (0, $c7dF9.Routes).PROF_METRICS.PROD_LISTING,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $219bd90e679fe86d$export$2e2bcd8739ae039), {
                                                    fluid: true,
                                                    hero: true,
                                                    showFooter: false,
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $a18a0232cc648c72$export$dfc0309301032959), {
                                                        agentData: selectedAgentData,
                                                        module: selectedModule
                                                    })
                                                })
                                            }, (0, $c7dF9.Routes).AGENT_PRODUCTION.BASE + (0, $c7dF9.Routes).PROF_METRICS.PROD_LISTING),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfZjc.Route), {
                                                exact: true,
                                                path: (0, $c7dF9.Routes).AGENT_PRODUCTION.BASE + (0, $c7dF9.Routes).PROF_METRICS.COVERAGE_LISTING,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $219bd90e679fe86d$export$2e2bcd8739ae039), {
                                                    fluid: true,
                                                    hero: true,
                                                    showFooter: false,
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e37a02ae50f645aa$export$2e2bcd8739ae039), {
                                                        module: selectedModule
                                                    })
                                                })
                                            }, (0, $c7dF9.Routes).AGENT_PRODUCTION.BASE + (0, $c7dF9.Routes).PROF_METRICS.COVERAGE_LISTING),
                                            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfZjc.Route), {
                                                exact: true,
                                                path: (0, $c7dF9.Routes).AGENT_PRODUCTION.BASE + (0, $c7dF9.Routes).PROF_METRICS.LISTING_INFO,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $219bd90e679fe86d$export$2e2bcd8739ae039), {
                                                    fluid: true,
                                                    hero: true,
                                                    showFooter: false,
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $deb2942a8ffbb165$export$2e2bcd8739ae039), {
                                                        agentData: selectedAgentData,
                                                        module: selectedModule
                                                    })
                                                })
                                            }, (0, $c7dF9.Routes).AGENT_PRODUCTION.BASE + (0, $c7dF9.Routes).PROF_METRICS.LISTING_INFO)
                                        ],
                                        /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfZjc.Route), {
                                            path: (0, $c7dF9.Routes).MY_PROFILE.BASE,
                                            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $219bd90e679fe86d$export$2e2bcd8739ae039), {
                                                fluid: true,
                                                hero: true,
                                                showFooter: false,
                                                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $414de6bd784de6b8$export$2e2bcd8739ae039), {
                                                    userAccounts: state.userAccounts,
                                                    isMarketShareAllowed: userAllowedTo((0, $cstaF.moduleNames).marketShare)
                                                })
                                            })
                                        }),
                                        state.allowedModules && /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfZjc.Route), {
                                                    exact: true,
                                                    path: "/",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfZjc.Redirect), {
                                                        to: (0, $ekOct.getFirstToolRoute)(state.allowedModules)
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfZjc.Route), {
                                                    path: "*",
                                                    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfZjc.Redirect), {
                                                        to: (0, $ekOct.getFirstToolRoute)(state.allowedModules)
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    })
                ]
            }),
            toastProps && /*#__PURE__*/ (0, $ayMG0.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3QXz5))), {
                dataLwtId: "global-api-error-toast",
                toastProps: toastProps,
                position: "toast-bottom-right"
            })
        ]
    });
};
var $4c8cda5d2c6d1d8b$export$2e2bcd8739ae039 = $4c8cda5d2c6d1d8b$var$App;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $f6CJ4 = parcelRequire("f6CJ4");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $cstaF = parcelRequire("cstaF");
const $09d25ce386072bb8$var$Footer = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "login-footer ",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "d-inline",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                        href: "https://terradatum.com/terms-of-use/",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: [
                            " ",
                            (0, $cstaF.loginTerms).termsOfUse,
                            " "
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("a", {
                        href: "https://terradatum.com/privacy-policy/",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: [
                            " ",
                            (0, $cstaF.loginTerms).privacyPolicy,
                            " "
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                    className: "d-inline",
                    children: (0, $cstaF.loginTerms).allRightsReserved
                })
            })
        ]
    });
};
var $09d25ce386072bb8$export$2e2bcd8739ae039 = $09d25ce386072bb8$var$Footer;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $dDBOF = parcelRequire("dDBOF");
const $17603e47823d3972$var$Header = ()=>{
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "login-header",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("a", {
                href: "/login",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("img", {
                    height: "50",
                    src: "https://assets.lwolf.com/img/lw-logo-dark.svg",
                    alt: "Logo",
                    className: "logo-wrapper"
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                children: (0, $dDBOF.appLabels)[(0, $dDBOF.appNames).XBM]
            })
        ]
    });
};
var $17603e47823d3972$export$2e2bcd8739ae039 = $17603e47823d3972$var$Header;


const $34e39bac6bdc4c92$var$LoginFormContainer = ({ children: children })=>/*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "login-page",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $17603e47823d3972$export$2e2bcd8739ae039), {}),
                    children
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $09d25ce386072bb8$export$2e2bcd8739ae039), {})
        ]
    });
$34e39bac6bdc4c92$var$LoginFormContainer.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node
};
var $34e39bac6bdc4c92$export$2e2bcd8739ae039 = $34e39bac6bdc4c92$var$LoginFormContainer;



var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $c9Z8w = parcelRequire("c9Z8w");

var $kfZjc = parcelRequire("kfZjc");

var $f6CJ4 = parcelRequire("f6CJ4");

var $cghEn = parcelRequire("cghEn");

var $7tOHe = parcelRequire("7tOHe");

var $9S3rS = parcelRequire("9S3rS");

var $cstaF = parcelRequire("cstaF");

var $ivaD7 = parcelRequire("ivaD7");

var $90ISC = parcelRequire("90ISC");
const $8beffa8a07ee60ee$var$LoginForm = ({ submitForm: submitForm, children: children })=>{
    const history = (0, $kfZjc.useHistory)();
    const currentRoute = history.location.pathname;
    const { authError: authError, isLoading: isLoading, setAuthErrorByRoute: setAuthErrorByRoute } = (0, $f6CJ4.useAuthStore)((state)=>({
            authError: state.authErrorByRoute[currentRoute],
            isLoading: state.isLoadingByRoute[currentRoute],
            setAuthErrorByRoute: state.setAuthErrorByRoute
        }));
    const isAuthLoading = (0, $90ISC.useCommonStore)((state)=>state.isLoading);
    const [state, setState] = (0, $acw62.useState)({
        credentialsValidationMsg: undefined,
        emailValidationMsg: undefined,
        emailValue: undefined,
        passwordValidationMsg: undefined,
        passwordValue: undefined
    });
    (0, $acw62.useEffect)(()=>{
        const isInvalidPassword = state.passwordValue?.length < (0, $cghEn.PASSWORD_MIN_LENGTH);
        const isInvalidEmail = state.emailValue?.length && !(0, $9S3rS.validateEmail)(state.emailValue);
        const validationConfig = [
            {
                isInvalid: isInvalidPassword,
                field: "passwordValidationMsg",
                errorMsg: (0, $cstaF.validationMessages).invalidPassword
            },
            {
                isInvalid: isInvalidEmail,
                field: "emailValidationMsg",
                errorMsg: (0, $cstaF.validationMessages).invalidEmail
            },
            {
                isInvalid: state.passwordValue?.length === 0,
                field: "passwordValidationMsg",
                errorMsg: (0, $cstaF.validationMessages).requiredPassword
            },
            {
                isInvalid: state.emailValue?.length === 0,
                field: "emailValidationMsg",
                errorMsg: (0, $cstaF.validationMessages).requiredEmail
            },
            {
                isInvalid: state.userType === (0, $cghEn.userTypes).invalid,
                field: "credentialsValidationMsg",
                errorMsg: (0, $cstaF.validationMessages).authenticationFailed
            },
            {
                isInvalid: state.userType === (0, $cghEn.userTypes).inactiveXbm,
                field: "credentialsValidationMsg",
                errorMsg: (0, $cstaF.validationMessages).invalidLogin
            },
            {
                isInvalid: state.userType === (0, $cghEn.userTypes).inactiveKeycloak,
                field: "credentialsValidationMsg",
                errorMsg: (0, $cstaF.validationMessages).inactiveKeycloak
            }
        ];
        (0, $ivaD7.setStateData)("emailValidationMsg", undefined, setState);
        (0, $ivaD7.setStateData)("passwordValidationMsg", undefined, setState);
        (0, $ivaD7.setStateData)("credentialsValidationMsg", undefined, setState);
        validationConfig.forEach((config)=>{
            const { isInvalid: isInvalid, field: field, errorMsg: errorMsg } = config;
            setState((prevState)=>({
                    ...prevState,
                    [field]: isInvalid ? errorMsg : prevState[field]
                }));
        });
    }, [
        state.passwordValue,
        state.emailValue,
        state.userType
    ]);
    const handleLogInButton = async (e)=>{
        e.preventDefault();
        if (!isLoginDataValid) return;
        submitForm(state, setState, history);
    };
    const handleInputChange = (e, type)=>{
        setAuthErrorByRoute(undefined, currentRoute);
        (0, $ivaD7.setStateData)(`${type}Value`, e.target.value, setState);
    };
    const isLoginDataValid = !isLoading && !!state.passwordValue?.length && !!state.emailValue?.length && (0, $cghEn.getLoginInputs)(state).map((input)=>input.errorMessage).every((val)=>!val);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)("form", {
        className: "login-form d-flex flex-column",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                className: "form-header",
                children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                    children: (0, $cstaF.loginTerms).signInBM
                })
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                className: "text-danger text-center",
                children: state.credentialsValidationMsg || authError
            }),
            isAuthLoading ? /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {}) : (0, $cghEn.getLoginInputs)(state).map((input)=>{
                const { id: id, type: type, errorMessage: errorMessage, ...inputProps } = input;
                return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "form-item",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                            ...inputProps,
                            type: type,
                            className: `login-input ${errorMessage ? "input-error" : ""}`,
                            maxLength: (0, $cghEn.PASSWORD_MAX_LENGTH),
                            autoComplete: "off",
                            onChange: (e)=>handleInputChange(e, type),
                            disabled: isLoading,
                            value: state[`${type}Value`] || ""
                        }),
                        errorMessage && /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                            className: "msg-error",
                            children: errorMessage
                        })
                    ]
                }, id);
            }),
            /*#__PURE__*/ (0, $ayMG0.jsxs)("button", {
                className: "login-btn d-flex justify-content-center mb-4",
                disabled: isAuthLoading || !isLoginDataValid,
                onClick: handleLogInButton,
                children: [
                    isLoading && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {}),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                        className: "mx-2",
                        children: (0, $cstaF.loginTerms).login
                    })
                ]
            }),
            children
        ]
    });
};
$8beffa8a07ee60ee$var$LoginForm.propTypes = {
    submitForm: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).func,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($c9Z8w))).node
};
var $8beffa8a07ee60ee$export$2e2bcd8739ae039 = $8beffa8a07ee60ee$var$LoginForm;



var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $dI25G = parcelRequire("dI25G");

var $eOjgM = parcelRequire("eOjgM");
parcelRequire("hUt4I");
var $6thlO = parcelRequire("6thlO");

var $rMeTm = parcelRequire("rMeTm");

var $cstaF = parcelRequire("cstaF");

var $7D4kr = parcelRequire("7D4kr");

var $f6CJ4 = parcelRequire("f6CJ4");

var $c7dF9 = parcelRequire("c7dF9");

var $7AubO = parcelRequire("7AubO");

var $90ISC = parcelRequire("90ISC");
const $e3a77c1371de41c3$var$SignInLWAButton = ()=>{
    const { isLoading: isLoading } = (0, $f6CJ4.useAuthStore)(({ isLoadingByRoute: isLoadingByRoute })=>({
            isLoading: isLoadingByRoute[(0, $c7dF9.Routes).AUTH.LOG_IN]
        }));
    const isAuthLoading = (0, $90ISC.useCommonStore)((state)=>state.isLoading);
    const handleSignInClick = (e)=>{
        (0, $90ISC.useCommonStore).setState({
            isLoading: true
        });
        if (isLoading) return;
        e.preventDefault();
        (0, $f6CJ4.useAuthStore).setState({
            authError: undefined
        });
        // We use this locally while pointing to stage or pre to make it easier to login with platform since those environments doesn't allow to redirect to a custom URL like dev does.
        if ((0, $7AubO.isLocal) && !(0, $7AubO.isDev)) {
            (0, $7D4kr.navigateToAuth)();
            return;
        }
        (0, $7D4kr.navigateToPlatformUI)();
    };
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($6thlO))), {
                id: "lwa-sign-in-btn",
                dataLwtId: "lwa-sign-in-btn",
                onClick: handleSignInClick,
                className: `sign-lwa d-flex justify-content-center align-items-center mt-4 p-0`,
                color: "text",
                disabled: isLoading || isAuthLoading,
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $dI25G.HelixIcon), {
                        icon: (0, $eOjgM.wolfie),
                        className: "wolfie-icon mr-2"
                    }),
                    (0, $cstaF.loginTerms).signInLWA
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $rMeTm.default), {
                id: "lwa-tooltip",
                target: "lwa-sign-in-btn",
                placement: "bottom",
                children: (0, $cstaF.loginTerms).lwaTooltip
            })
        ]
    });
};
var $e3a77c1371de41c3$export$2e2bcd8739ae039 = $e3a77c1371de41c3$var$SignInLWAButton;



var $cstaF = parcelRequire("cstaF");

var $bq4QZ = parcelRequire("bq4QZ");
const $b6b0287f6135dcd7$var$Login = ()=>{
    const { authKeycloakUser: authKeycloakUser } = (0, $f6CJ4.useAuthStore)((state)=>({
            authKeycloakUser: state.authKeycloakUser
        }));
    const query = (0, $bq4QZ.useQuery)();
    const redirectPath = query.get("redirect");
    const handleSubmitForm = (state, setState, history)=>{
        authKeycloakUser(state, setState, history, redirectPath);
    };
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $34e39bac6bdc4c92$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8beffa8a07ee60ee$export$2e2bcd8739ae039), {
            submitForm: handleSubmitForm,
            children: /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $ayMG0.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
                        className: "d-flex justify-content-center",
                        children: /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "or-divider m-0",
                            children: (0, $cstaF.loginTerms).or
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)((0, $e3a77c1371de41c3$export$2e2bcd8739ae039), {})
                ]
            })
        })
    });
};
var $b6b0287f6135dcd7$export$2e2bcd8739ae039 = $b6b0287f6135dcd7$var$Login;



var $cIUhV = parcelRequire("cIUhV");

var $c7dF9 = parcelRequire("c7dF9");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");


var $bq4QZ = parcelRequire("bq4QZ");

var $7tOHe = parcelRequire("7tOHe");

var $f6CJ4 = parcelRequire("f6CJ4");
const $47cf556aec9eca1b$var$Auth = ()=>{
    const { initPlatform: initPlatform } = (0, $f6CJ4.useAuthStore)(({ initPlatform: initPlatform })=>({
            initPlatform: initPlatform
        }));
    const query = (0, $bq4QZ.useQuery)();
    const history = (0, $f7b5084cb6aad888$exports.useHistory)();
    const activeClientId = query.get("ac");
    const redirectPath = query.get("redirect");
    (0, $acw62.useEffect)(()=>{
        const initPlatformClient = async (activeClientId)=>{
            await initPlatform({
                history: history,
                activeClientId: activeClientId,
                redirectPath: redirectPath
            });
        };
        initPlatformClient(activeClientId);
    }, [
        initPlatform,
        history,
        activeClientId,
        redirectPath
    ]);
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "d-flex flex-grow-1 align-items-center justify-content-center",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $7tOHe.default), {})
    });
};
var $47cf556aec9eca1b$export$2e2bcd8739ae039 = $47cf556aec9eca1b$var$Auth;



var $cghEn = parcelRequire("cghEn");

var $7D4kr = parcelRequire("7D4kr");

var $f6CJ4 = parcelRequire("f6CJ4");

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");


var $f6CJ4 = parcelRequire("f6CJ4");

const $8d76f7c357d56ec8$var$Connect = ()=>{
    const { connectKeycloakUser: connectKeycloakUser } = (0, $f6CJ4.useAuthStore)(({ connectKeycloakUser: connectKeycloakUser })=>({
            connectKeycloakUser: connectKeycloakUser
        }));
    return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $34e39bac6bdc4c92$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8beffa8a07ee60ee$export$2e2bcd8739ae039), {
            submitForm: connectKeycloakUser
        })
    });
};
var $8d76f7c357d56ec8$export$2e2bcd8739ae039 = $8d76f7c357d56ec8$var$Connect;



var $dDBOF = parcelRequire("dDBOF");
const $f17f15f32c892e51$export$cd80471b8ced8783 = "26.11.00";


function $73e681bce228b3f7$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $c93aa07262cefe21$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $c93aa07262cefe21$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $73e681bce228b3f7$export$2e2bcd8739ae039)(function(prop) {
    return $c93aa07262cefe21$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});



var $acw62 = parcelRequire("acw62");

var $lmFrL = parcelRequire("lmFrL");
const $521aa2d3326b5ef8$export$ea160f89b98e1fc1 = (colors)=>{
    var _a;
    return {
        primaryColor: colors.brand,
        primaryForegroundColor: colors.white,
        primaryButtonBackgroundColor: colors.brand,
        primaryButtonTextColor: colors.white,
        primaryButtonHoverTextColor: colors.white,
        primaryButtonHoverBackgroundColor: (_a = colors["brand-light"]) !== null && _a !== void 0 ? _a : "darken($brand, 50%)",
        primaryButtonActiveBackgroundColor: colors["brand-dark"],
        primaryButtonOutlineBorderColor: colors.brand,
        primaryButtonOutlineTextColor: colors.brand,
        primaryButtonOutlineHoverTextColor: colors["brand-light"],
        primaryButtonOutlineHoverBorderColor: colors["brand-light"],
        primaryButtonOutlineActiveBorderColor: colors["brand-dark"],
        colors: Object.assign({}, colors)
    };
};


const $1adef4cdbbf315e5$export$8f45430ccf837300 = {
    "brand-dark": "#233d2d",
    brand: "#236847",
    "brand-light": "#488563",
    "brand-alt-light": "#b7dbb6",
    "brand-pale": "#e5ede7",
    "brand-accent": "#f15423",
    "brand-accent-light": "#f8baa7",
    "brand-accent-pale": "#fdede9",
    "brand-secondary": "#3e6fdf",
    "brand-secondary-light": "#a6cdf4",
    "brand-secondary-pale": "#f1f5ff",
    "white-alpha": {
        200: "rgba(255, 255, 255, 0.2)",
        800: "rgba(255, 255, 255, 0.8)"
    },
    white: "#fff",
    black: "#000",
    gray: {
        50: "#F9FAFB",
        100: "#F3F4F6",
        200: "#E5E7EB",
        300: "#D1D5DB",
        400: "#9CA3AF",
        500: "#6B7280",
        600: "#4B5563",
        700: "#374151",
        800: "#1F2937",
        900: "#111827"
    },
    red: {
        50: "#FEF2F2",
        100: "#FEE2E2",
        200: "#FECACA",
        300: "#FCA5A5",
        400: "#F87171",
        500: "#EF4444",
        600: "#DC2626",
        700: "#B91C1C",
        800: "#991B1B",
        900: "#7F1D1D"
    },
    orange: {
        50: "#FFF7ED",
        100: "#FFEDD5",
        200: "#FED7AA",
        300: "#FDBA74",
        400: "#FB923C",
        500: "#F97316",
        600: "#EA580C",
        700: "#C2410C",
        800: "#9A3412",
        900: "#7C2D12"
    },
    yellow: {
        50: "#FFFBEB",
        100: "#FEF3C7",
        200: "#FDE68A",
        300: "#FCD34D",
        400: "#FBBF24",
        500: "#F59E0B",
        600: "#DA870B",
        700: "#B45309",
        800: "#92400E",
        900: "#78350F"
    },
    green: {
        50: "#ECFDF5",
        100: "#D1FAE5",
        200: "#A7F3D0",
        300: "#6EE7B7",
        400: "#34D399",
        500: "#10B981",
        600: "#059669",
        700: "#047857",
        800: "#065F46",
        900: "#064E3B"
    },
    teal: {
        50: "#F0FDFA",
        100: "#CCFBF1",
        200: "#99F6E4",
        300: "#5EEAD4",
        400: "#2DD4BF",
        500: "#14B8A6",
        600: "#0D9488",
        700: "#0F766E",
        800: "#115E59",
        900: "#134E4A"
    },
    cyan: {
        50: "#ECFEFF",
        100: "#CFFAFE",
        200: "#A5F3FC",
        300: "#67E8F9",
        400: "#22D3EE",
        500: "#06B6D4",
        600: "#0891B2",
        700: "#0E7490",
        800: "#155E75",
        900: "#164E63"
    },
    "light-blue": {
        50: "#F0F9FF",
        100: "#E0F2FE",
        200: "#BAE6FD",
        300: "#7DD3FC",
        400: "#38BDF8",
        500: "#0EA5E9",
        600: "#0284C7",
        700: "#0369A1",
        800: "#075985",
        900: "#0C4A6E"
    },
    blue: {
        50: "#eff6ff",
        100: "#dbeafe",
        200: "#bfdbfe",
        300: "#93c5fd",
        400: "#60a5fa",
        500: "#3b82f6",
        600: "#2563eb",
        700: "#1d4ed8",
        800: "#1e40af",
        900: "#1e3a8a"
    },
    indigo: {
        50: "#EEF2FF",
        100: "#E0E7FF",
        200: "#C7D2FE",
        300: "#A5B4FC",
        400: "#818CF8",
        500: "#6366F1",
        600: "#4F46E5",
        700: "#4338CA",
        800: "#3730A3",
        900: "#312E81"
    },
    purple: {
        50: "#F5F3FF",
        100: "#EDE9FE",
        200: "#DDD6FE",
        300: "#C4B5FD",
        400: "#A78BFA",
        500: "#8B5CF6",
        600: "#7C3AED",
        700: "#6D28D9",
        800: "#5B21B6",
        900: "#4C1D95"
    },
    pink: {
        50: "#FDF2F8",
        100: "#FCE7F3",
        200: "#FBCFE8",
        300: "#F9A8D4",
        400: "#F472B6",
        500: "#EC4899",
        600: "#DB2777",
        700: "#BE185D",
        800: "#9D174D",
        900: "#831843"
    },
    rose: {
        50: "#FFF1F2",
        100: "#FFE4E6",
        200: "#FECDD3",
        300: "#FDA4AF",
        400: "#FB7185",
        500: "#F43F5E",
        600: "#E11D48",
        700: "#BE123C",
        800: "#9F1239",
        900: "#881337"
    },
    get primary () {
        return this.brand;
    }
};


const $2fb3ab26f7ac17a4$var$colourMixCss = (color1, color2, weight)=>{
    return `color-mix(in srgb, ${color1}, ${color2} ${weight}%)`;
};
const $2fb3ab26f7ac17a4$export$2e2bcd8739ae039 = ({ themeName: themeName = "default", themeOptions: themeOptions = (0, $521aa2d3326b5ef8$export$ea160f89b98e1fc1)((0, $1adef4cdbbf315e5$export$8f45430ccf837300)) })=>{
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    return {
        themeName: themeName,
        colors: Object.assign(Object.assign(Object.assign({}, (0, $1adef4cdbbf315e5$export$8f45430ccf837300)), themeOptions.colors), {
            "brand-light": (_b = (_a = themeOptions.colors) === null || _a === void 0 ? void 0 : _a["brand-light"]) !== null && _b !== void 0 ? _b : $2fb3ab26f7ac17a4$var$colourMixCss((_d = (_c = themeOptions.colors) === null || _c === void 0 ? void 0 : _c.brand) !== null && _d !== void 0 ? _d : (0, $1adef4cdbbf315e5$export$8f45430ccf837300).brand, "#ffffff", 25),
            "brand-alt-light": (_f = (_e = themeOptions.colors) === null || _e === void 0 ? void 0 : _e["brand-alt-light"]) !== null && _f !== void 0 ? _f : $2fb3ab26f7ac17a4$var$colourMixCss((_h = (_g = themeOptions.colors) === null || _g === void 0 ? void 0 : _g.brand) !== null && _h !== void 0 ? _h : (0, $1adef4cdbbf315e5$export$8f45430ccf837300).brand, "#ffffff", 80),
            "brand-dark": (_k = (_j = themeOptions.colors) === null || _j === void 0 ? void 0 : _j["brand-dark"]) !== null && _k !== void 0 ? _k : $2fb3ab26f7ac17a4$var$colourMixCss((_m = (_l = themeOptions.colors) === null || _l === void 0 ? void 0 : _l.brand) !== null && _m !== void 0 ? _m : (0, $1adef4cdbbf315e5$export$8f45430ccf837300).brand, "#000000", 20),
            "brand-pale": (_p = (_o = themeOptions.colors) === null || _o === void 0 ? void 0 : _o["brand-pale"]) !== null && _p !== void 0 ? _p : $2fb3ab26f7ac17a4$var$colourMixCss((_r = (_q = themeOptions.colors) === null || _q === void 0 ? void 0 : _q.brand) !== null && _r !== void 0 ? _r : (0, $1adef4cdbbf315e5$export$8f45430ccf837300).brand, "#ffffff", 90)
        }),
        get themeOptions () {
            return Object.assign(Object.assign({}, (0, $521aa2d3326b5ef8$export$ea160f89b98e1fc1)(this.colors)), themeOptions);
        },
        baseFontSize: "100%",
        breakPoints: {
            small: "576px"
        },
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Open Sans", "Ubuntu", "Droid Sans", "Helvetica Neue", sans-serif',
        fontFamilyMonospace: 'SFMono-Medium, "SF Mono", "Segoe UI Mono", "Roboto Mono", "Ubuntu Mono", Menlo, Courier, monospace',
        get alert () {
            var _a1, _b1, _c1, _d1, _e1, _f1, _g1, _h1, _j1, _k1, _l1, _m1, _o1, _p1, _q1, _r1, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4;
            return {
                secondary: {
                    backgroundColor: (_a1 = this.colors) === null || _a1 === void 0 ? void 0 : _a1.gray[50],
                    textColor: (_c1 = (_b1 = this.colors) === null || _b1 === void 0 ? void 0 : _b1.gray) === null || _c1 === void 0 ? void 0 : _c1[900],
                    borderColor: "transparent",
                    iconColor: (_e1 = (_d1 = this.colors) === null || _d1 === void 0 ? void 0 : _d1.gray) === null || _e1 === void 0 ? void 0 : _e1[600]
                },
                success: {
                    backgroundColor: (_g1 = (_f1 = this.colors) === null || _f1 === void 0 ? void 0 : _f1.green) === null || _g1 === void 0 ? void 0 : _g1[50],
                    textColor: (_j1 = (_h1 = this.colors) === null || _h1 === void 0 ? void 0 : _h1.green) === null || _j1 === void 0 ? void 0 : _j1[900],
                    borderColor: "transparent",
                    iconColor: (_l1 = (_k1 = this.colors) === null || _k1 === void 0 ? void 0 : _k1.green) === null || _l1 === void 0 ? void 0 : _l1[600]
                },
                warning: {
                    backgroundColor: (_o1 = (_m1 = this.colors) === null || _m1 === void 0 ? void 0 : _m1.yellow) === null || _o1 === void 0 ? void 0 : _o1[50],
                    textColor: (_q1 = (_p1 = this.colors) === null || _p1 === void 0 ? void 0 : _p1.yellow) === null || _q1 === void 0 ? void 0 : _q1[900],
                    borderColor: "transparent",
                    iconColor: (_s = (_r1 = this.colors) === null || _r1 === void 0 ? void 0 : _r1.yellow) === null || _s === void 0 ? void 0 : _s[600]
                },
                danger: {
                    backgroundColor: (_u = (_t = this.colors) === null || _t === void 0 ? void 0 : _t.red) === null || _u === void 0 ? void 0 : _u[50],
                    textColor: (_w = (_v = this.colors) === null || _v === void 0 ? void 0 : _v.red) === null || _w === void 0 ? void 0 : _w[900],
                    borderColor: "transparent",
                    iconColor: (_y = (_x = this.colors) === null || _x === void 0 ? void 0 : _x.red) === null || _y === void 0 ? void 0 : _y[600]
                },
                info: {
                    backgroundColor: (_0 = (_z = this.colors) === null || _z === void 0 ? void 0 : _z.blue) === null || _0 === void 0 ? void 0 : _0[50],
                    textColor: (_2 = (_1 = this.colors) === null || _1 === void 0 ? void 0 : _1.blue) === null || _2 === void 0 ? void 0 : _2[900],
                    borderColor: "transparent",
                    iconColor: (_4 = (_3 = this.colors) === null || _3 === void 0 ? void 0 : _3.blue) === null || _4 === void 0 ? void 0 : _4[600]
                }
            };
        },
        get backgroundColor () {
            var _a2, _b2;
            return (_b2 = (_a2 = this.colors) === null || _a2 === void 0 ? void 0 : _a2.gray) === null || _b2 === void 0 ? void 0 : _b2[50];
        },
        get baseTextColor () {
            var _a3, _b3;
            return (_b3 = (_a3 = this.colors) === null || _a3 === void 0 ? void 0 : _a3.gray) === null || _b3 === void 0 ? void 0 : _b3[900];
        },
        // addressed in @styles
        get badge () {
            var _a4, _b4, _c2, _d2, _e2, _f2, _g2, _h2, _j2, _k2, _l2, _m2, _o2, _p2, _q2, _r2, _s1, _t1, _u1, _v1, _w1, _x1;
            return {
                default: {
                    backgroundColor: this.themeOptions.primaryColor,
                    textColor: (_b4 = (_a4 = this.colors) === null || _a4 === void 0 ? void 0 : _a4.gray) === null || _b4 === void 0 ? void 0 : _b4[100]
                },
                inverted: {
                    backgroundColor: (_d2 = (_c2 = this.colors) === null || _c2 === void 0 ? void 0 : _c2.gray) === null || _d2 === void 0 ? void 0 : _d2[200],
                    textColor: (_f2 = (_e2 = this.colors) === null || _e2 === void 0 ? void 0 : _e2.gray) === null || _f2 === void 0 ? void 0 : _f2[800]
                },
                success: {
                    backgroundColor: (_h2 = (_g2 = this.colors) === null || _g2 === void 0 ? void 0 : _g2.green) === null || _h2 === void 0 ? void 0 : _h2[100],
                    textColor: (_k2 = (_j2 = this.colors) === null || _j2 === void 0 ? void 0 : _j2.green) === null || _k2 === void 0 ? void 0 : _k2[900]
                },
                warning: {
                    backgroundColor: (_m2 = (_l2 = this.colors) === null || _l2 === void 0 ? void 0 : _l2.orange) === null || _m2 === void 0 ? void 0 : _m2[100],
                    textColor: (_p2 = (_o2 = this.colors) === null || _o2 === void 0 ? void 0 : _o2.yellow) === null || _p2 === void 0 ? void 0 : _p2[900]
                },
                danger: {
                    backgroundColor: (_r2 = (_q2 = this.colors) === null || _q2 === void 0 ? void 0 : _q2.red) === null || _r2 === void 0 ? void 0 : _r2[100],
                    textColor: (_t1 = (_s1 = this.colors) === null || _s1 === void 0 ? void 0 : _s1.red) === null || _t1 === void 0 ? void 0 : _t1[900]
                },
                info: {
                    backgroundColor: (_v1 = (_u1 = this.colors) === null || _u1 === void 0 ? void 0 : _u1["light-blue"]) === null || _v1 === void 0 ? void 0 : _v1[100],
                    textColor: (_x1 = (_w1 = this.colors) === null || _w1 === void 0 ? void 0 : _w1["light-blue"]) === null || _x1 === void 0 ? void 0 : _x1[900]
                }
            };
        },
        get comboBox () {
            var _a5, _b5;
            return {
                backgroundColor: (_b5 = (_a5 = this.colors) === null || _a5 === void 0 ? void 0 : _a5.gray) === null || _b5 === void 0 ? void 0 : _b5[200]
            };
        },
        // addressed in @styles
        get dashboardWidget () {
            var _a6, _b6, _c3, _d3, _e3, _f3, _g3, _h3, _j3, _k3, _l3;
            return {
                backgroundColor: (_a6 = this.colors) === null || _a6 === void 0 ? void 0 : _a6.white,
                boxShadow: "0px 0px 1px rgba(0, 0, 0, 0.36)",
                label: {
                    textColor: (_c3 = (_b6 = this.colors) === null || _b6 === void 0 ? void 0 : _b6.gray) === null || _c3 === void 0 ? void 0 : _c3[600]
                },
                default: {
                    value: {
                        textColor: (_d3 = this.colors) === null || _d3 === void 0 ? void 0 : _d3.black
                    }
                },
                primary: {
                    value: {
                        textColor: this.themeOptions.primaryColor ? this.themeOptions.primaryColor : (_e3 = this.colors) === null || _e3 === void 0 ? void 0 : _e3.primary
                    }
                },
                danger: {
                    value: {
                        textColor: (_g3 = (_f3 = this.colors) === null || _f3 === void 0 ? void 0 : _f3.red) === null || _g3 === void 0 ? void 0 : _g3[600]
                    }
                },
                warning: {
                    value: {
                        textColor: (_j3 = (_h3 = this.colors) === null || _h3 === void 0 ? void 0 : _h3.yellow) === null || _j3 === void 0 ? void 0 : _j3[600]
                    }
                },
                success: {
                    value: {
                        textColor: (_l3 = (_k3 = this.colors) === null || _k3 === void 0 ? void 0 : _k3.green) === null || _l3 === void 0 ? void 0 : _l3[600]
                    }
                }
            };
        },
        // addressed in @styles
        get input () {
            var _a7, _b7, _c4, _d4, _e4, _f4, _g4, _h4, _j4;
            return {
                borderColor: (_b7 = (_a7 = this.colors) === null || _a7 === void 0 ? void 0 : _a7.gray) === null || _b7 === void 0 ? void 0 : _b7[300],
                focusColor: (_c4 = this.colors) === null || _c4 === void 0 ? void 0 : _c4.brand,
                invalidBorderColor: (_e4 = (_d4 = this.colors) === null || _d4 === void 0 ? void 0 : _d4.red) === null || _e4 === void 0 ? void 0 : _e4[500],
                validBorderColor: (_g4 = (_f4 = this.colors) === null || _f4 === void 0 ? void 0 : _f4.green) === null || _g4 === void 0 ? void 0 : _g4[500],
                prefilledTextColor: (_j4 = (_h4 = this.colors) === null || _h4 === void 0 ? void 0 : _h4.purple) === null || _j4 === void 0 ? void 0 : _j4[600]
            };
        },
        // addressed in @styles
        get inputGroup () {
            var _a8, _b8, _c5, _d5;
            return {
                backgroundColor: (_a8 = this.colors) === null || _a8 === void 0 ? void 0 : _a8.white,
                borderColor: (_c5 = (_b8 = this.colors) === null || _b8 === void 0 ? void 0 : _b8.gray) === null || _c5 === void 0 ? void 0 : _c5[300],
                focusBorderColor: (_d5 = this.colors) === null || _d5 === void 0 ? void 0 : _d5.brand
            };
        },
        // addressed in @styles
        get button () {
            var _a9, _b9, _c6, _d6, _e5, _f5, _g5, _h5, _j5, _k4, _l4, _m3, _o3, _p3, _q3, _r3, _s2, _t2, _u2, _v2, _w2, _x2, _y1, _z1, _01, _11, _21, _31, _41, _5, _6, _7, _8, _9, _10, _111, _12, _13, _14, _15, _16, _17, _18, _19;
            return {
                tertiary: {
                    backgroundColor: (_b9 = (_a9 = this.colors) === null || _a9 === void 0 ? void 0 : _a9.gray) === null || _b9 === void 0 ? void 0 : _b9[200],
                    hoverBackgroundColor: (_d6 = (_c6 = this.colors) === null || _c6 === void 0 ? void 0 : _c6.gray) === null || _d6 === void 0 ? void 0 : _d6[100],
                    textColor: (_f5 = (_e5 = this.colors) === null || _e5 === void 0 ? void 0 : _e5.gray) === null || _f5 === void 0 ? void 0 : _f5[900],
                    hoverTextColor: (_h5 = (_g5 = this.colors) === null || _g5 === void 0 ? void 0 : _g5.gray) === null || _h5 === void 0 ? void 0 : _h5[700],
                    activeBackgroundColor: (_k4 = (_j5 = this.colors) === null || _j5 === void 0 ? void 0 : _j5.gray) === null || _k4 === void 0 ? void 0 : _k4[300],
                    outlineBorderColor: (_m3 = (_l4 = this.colors) === null || _l4 === void 0 ? void 0 : _l4.gray) === null || _m3 === void 0 ? void 0 : _m3[300],
                    outlineTextColor: (_p3 = (_o3 = this.colors) === null || _o3 === void 0 ? void 0 : _o3.gray) === null || _p3 === void 0 ? void 0 : _p3[900],
                    outlineHoverTextColor: (_r3 = (_q3 = this.colors) === null || _q3 === void 0 ? void 0 : _q3.gray) === null || _r3 === void 0 ? void 0 : _r3[700],
                    outlineHoverBorderColor: (_t2 = (_s2 = this.colors) === null || _s2 === void 0 ? void 0 : _s2.gray) === null || _t2 === void 0 ? void 0 : _t2[400],
                    outlineActiveBorderColor: (_v2 = (_u2 = this.colors) === null || _u2 === void 0 ? void 0 : _u2.gray) === null || _v2 === void 0 ? void 0 : _v2[500]
                },
                primary: {
                    backgroundColor: (_w2 = this.themeOptions) === null || _w2 === void 0 ? void 0 : _w2.primaryButtonBackgroundColor,
                    hoverBackgroundColor: (_x2 = this.themeOptions) === null || _x2 === void 0 ? void 0 : _x2.primaryButtonHoverBackgroundColor,
                    textColor: (_y1 = this.themeOptions) === null || _y1 === void 0 ? void 0 : _y1.primaryButtonTextColor,
                    hoverTextColor: (_z1 = this.themeOptions) === null || _z1 === void 0 ? void 0 : _z1.primaryButtonHoverTextColor,
                    activeBackgroundColor: (_01 = this.themeOptions) === null || _01 === void 0 ? void 0 : _01.primaryButtonActiveBackgroundColor,
                    outlineBorderColor: (_11 = this.themeOptions) === null || _11 === void 0 ? void 0 : _11.primaryButtonOutlineBorderColor,
                    outlineTextColor: (_21 = this.themeOptions) === null || _21 === void 0 ? void 0 : _21.primaryButtonOutlineTextColor,
                    outlineHoverTextColor: (_31 = this.themeOptions) === null || _31 === void 0 ? void 0 : _31.primaryButtonOutlineHoverTextColor,
                    outlineHoverBorderColor: (_41 = this.themeOptions) === null || _41 === void 0 ? void 0 : _41.primaryButtonOutlineHoverBorderColor,
                    outlineActiveBorderColor: (_5 = this.themeOptions) === null || _5 === void 0 ? void 0 : _5.primaryButtonOutlineActiveBorderColor
                },
                secondary: {
                    backgroundColor: "transparent",
                    hoverBackgroundColor: "transparent",
                    borderColor: (_7 = (_6 = this.colors) === null || _6 === void 0 ? void 0 : _6.gray) === null || _7 === void 0 ? void 0 : _7[900],
                    borderHoverColor: (_9 = (_8 = this.colors) === null || _8 === void 0 ? void 0 : _8.gray) === null || _9 === void 0 ? void 0 : _9[600],
                    textColor: (_111 = (_10 = this.colors) === null || _10 === void 0 ? void 0 : _10.gray) === null || _111 === void 0 ? void 0 : _111[900],
                    hoverTextColor: (_13 = (_12 = this.colors) === null || _12 === void 0 ? void 0 : _12.gray) === null || _13 === void 0 ? void 0 : _13[700],
                    activeBackgroundColor: (_15 = (_14 = this.colors) === null || _14 === void 0 ? void 0 : _14.gray) === null || _15 === void 0 ? void 0 : _15[100]
                },
                ghost: {
                    backgroundColor: "transparent",
                    textColor: (_17 = (_16 = this.colors) === null || _16 === void 0 ? void 0 : _16.gray) === null || _17 === void 0 ? void 0 : _17[900],
                    activeBackgroundColor: (_19 = (_18 = this.colors) === null || _18 === void 0 ? void 0 : _18.gray) === null || _19 === void 0 ? void 0 : _19[300]
                }
            };
        },
        // addressed in @styles
        get card () {
            return {
                backgroundColor: "#fff",
                boxShadow: "0px 0px 1px rgba(0, 0, 0, 0.2)"
            };
        },
        get dropdownMenu () {
            var _a10, _b10, _c7, _d7;
            return {
                backgroundColor: "#fff",
                borderColor: (_b10 = (_a10 = this.colors) === null || _a10 === void 0 ? void 0 : _a10.gray) === null || _b10 === void 0 ? void 0 : _b10[300],
                boxShadow: "0px 0px 1px rgba(0, 0, 0, 0.2), 0px 4px 8px rgba(0, 0, 0, 0.1)",
                sectionHeaderColor: (_d7 = (_c7 = this.colors) === null || _c7 === void 0 ? void 0 : _c7.gray) === null || _d7 === void 0 ? void 0 : _d7[600]
            };
        },
        get dropdownMenuItem () {
            var _a11, _b11, _c8, _d8, _e6, _f6;
            return {
                highlightColor: (_b11 = (_a11 = this.colors) === null || _a11 === void 0 ? void 0 : _a11.gray) === null || _b11 === void 0 ? void 0 : _b11[100],
                selectedColor: (_d8 = (_c8 = this.colors) === null || _c8 === void 0 ? void 0 : _c8.gray) === null || _d8 === void 0 ? void 0 : _d8[200],
                descriptionFontColor: (_f6 = (_e6 = this.colors) === null || _e6 === void 0 ? void 0 : _e6.gray) === null || _f6 === void 0 ? void 0 : _f6[600]
            };
        },
        // addressed in @styles
        get checkbox () {
            var _a12, _b12, _c9, _d9, _e7, _f7, _g6;
            return {
                backgroundColor: (_a12 = this.colors) === null || _a12 === void 0 ? void 0 : _a12.white,
                borderColor: (_c9 = (_b12 = this.colors) === null || _b12 === void 0 ? void 0 : _b12.gray) === null || _c9 === void 0 ? void 0 : _c9[300],
                checkedBackgroundColor: this.themeOptions.primaryColor ? this.themeOptions.primaryColor : (_d9 = this.colors) === null || _d9 === void 0 ? void 0 : _d9.primary,
                checkColor: (_e7 = this.colors) === null || _e7 === void 0 ? void 0 : _e7.white,
                focusColor: (_g6 = (_f7 = this.colors) === null || _f7 === void 0 ? void 0 : _f7.gray) === null || _g6 === void 0 ? void 0 : _g6[300]
            };
        },
        // addressed in @styles
        get radio () {
            var _a13, _b13, _c10, _d10, _e8, _f8, _g7, _h6;
            return {
                backgroundColor: (_a13 = this.colors) === null || _a13 === void 0 ? void 0 : _a13.white,
                borderColor: (_c10 = (_b13 = this.colors) === null || _b13 === void 0 ? void 0 : _b13.gray) === null || _c10 === void 0 ? void 0 : _c10[300],
                checkedBackgroundColor: this.themeOptions.primaryColor ? this.themeOptions.primaryColor : (_d10 = this.colors) === null || _d10 === void 0 ? void 0 : _d10.primary,
                checkedBorderColor: this.themeOptions.primaryColor ? this.themeOptions.primaryColor : (_e8 = this.colors) === null || _e8 === void 0 ? void 0 : _e8.primary,
                checkColor: (_f8 = this.colors) === null || _f8 === void 0 ? void 0 : _f8.white,
                focusColor: (_h6 = (_g7 = this.colors) === null || _g7 === void 0 ? void 0 : _g7.gray) === null || _h6 === void 0 ? void 0 : _h6[300]
            };
        },
        // addressed in @styles
        get switch () {
            var _a14, _b14, _c11, _d11, _e9, _f9;
            return {
                backgroundColor: (_a14 = this.colors) === null || _a14 === void 0 ? void 0 : _a14.gray[400],
                boxShadow: "inset 0px 0px 1px rgba(0, 0, 0, 0.2), inset 0px 1px 2px rgba(0, 0, 0, 0.1);",
                checkedBackgroundColor: (_c11 = (_b14 = this.colors) === null || _b14 === void 0 ? void 0 : _b14.gray) === null || _c11 === void 0 ? void 0 : _c11[900],
                toggleBackgroundColor: (_d11 = this.colors) === null || _d11 === void 0 ? void 0 : _d11.white,
                focusColor: (_f9 = (_e9 = this.colors) === null || _e9 === void 0 ? void 0 : _e9.gray) === null || _f9 === void 0 ? void 0 : _f9[300]
            };
        },
        get clientSwitcher () {
            var _a15, _b15;
            return {
                rowBoxShadowColor: "rgba(0, 0, 0, 0.05)",
                clientIdTextColor: (_b15 = (_a15 = this.colors) === null || _a15 === void 0 ? void 0 : _a15.gray) === null || _b15 === void 0 ? void 0 : _b15[600]
            };
        },
        get slideoutPanel () {
            var _a16, _b16;
            return {
                backgroundColor: (_a16 = this.colors) === null || _a16 === void 0 ? void 0 : _a16.white,
                boxShadow: "0px 0px 1px rgba(0, 0, 0, 0.2), 0px 4px 8px rgba(0, 0, 0, 0.1)",
                footerBorderColor: (_b16 = this.colors.gray) === null || _b16 === void 0 ? void 0 : _b16[300]
            };
        },
        get modal () {
            var _a17;
            return {
                backgroundColor: (_a17 = this.colors) === null || _a17 === void 0 ? void 0 : _a17.white,
                boxShadow: "0px 0px 1px rgba(0, 0, 0, 0.2), 0px 12px 24px rgba(0, 0, 0, 0.1)"
            };
        },
        // addressed in @styles
        get breadcrumb () {
            var _a18, _b17, _c12, _d12;
            return {
                textColor: (_b17 = (_a18 = this.colors) === null || _a18 === void 0 ? void 0 : _a18.gray) === null || _b17 === void 0 ? void 0 : _b17[600],
                activeTextColor: (_c12 = this.colors) === null || _c12 === void 0 ? void 0 : _c12.brand,
                hoverTextColor: (_d12 = this.colors) === null || _d12 === void 0 ? void 0 : _d12["brand-dark"]
            };
        },
        get toast () {
            var _a19, _b18, _c13, _d13, _e10, _f10, _g8, _h7, _j6, _k5, _l5, _m4, _o4, _p4, _q4, _r4, _s3, _t3, _u3, _v3, _w3, _x3, _y2, _z2, _02, _110, _22, _32, _42, _51, _61, _71, _81, _91, _101, _112, _121, _131, _141, _151, _161, _171, _181, _191, _20, _211, _221, _23, _24, _25, _26, _27, _28, _29, _30, _311, _321, _33, _34;
            return {
                boxShadow: " 0px 0px 1px rgba(0, 0, 0, 0.2), 0px 4px 8px rgba(0, 0, 0, 0.1);",
                secondary_bold: {
                    backgroundColor: (_b18 = (_a19 = this.colors) === null || _a19 === void 0 ? void 0 : _a19.gray) === null || _b18 === void 0 ? void 0 : _b18[700],
                    textColor: (_c13 = this.colors) === null || _c13 === void 0 ? void 0 : _c13.white,
                    iconColor: (_d13 = this.colors) === null || _d13 === void 0 ? void 0 : _d13.white
                },
                success_bold: {
                    backgroundColor: (_f10 = (_e10 = this.colors) === null || _e10 === void 0 ? void 0 : _e10.green) === null || _f10 === void 0 ? void 0 : _f10[700],
                    textColor: (_g8 = this.colors) === null || _g8 === void 0 ? void 0 : _g8.white,
                    iconColor: (_h7 = this.colors) === null || _h7 === void 0 ? void 0 : _h7.white
                },
                warning_bold: {
                    backgroundColor: (_k5 = (_j6 = this.colors) === null || _j6 === void 0 ? void 0 : _j6.yellow) === null || _k5 === void 0 ? void 0 : _k5[700],
                    textColor: (_l5 = this.colors) === null || _l5 === void 0 ? void 0 : _l5.white,
                    iconColor: (_m4 = this.colors) === null || _m4 === void 0 ? void 0 : _m4.white
                },
                danger_bold: {
                    backgroundColor: (_p4 = (_o4 = this.colors) === null || _o4 === void 0 ? void 0 : _o4.red) === null || _p4 === void 0 ? void 0 : _p4[700],
                    textColor: (_q4 = this.colors) === null || _q4 === void 0 ? void 0 : _q4.white,
                    iconColor: (_r4 = this.colors) === null || _r4 === void 0 ? void 0 : _r4.white
                },
                info_bold: {
                    backgroundColor: (_t3 = (_s3 = this.colors) === null || _s3 === void 0 ? void 0 : _s3.blue) === null || _t3 === void 0 ? void 0 : _t3[700],
                    textColor: (_u3 = this.colors) === null || _u3 === void 0 ? void 0 : _u3.white,
                    iconColor: (_v3 = this.colors) === null || _v3 === void 0 ? void 0 : _v3.white
                },
                secondary: {
                    backgroundColor: (_x3 = (_w3 = this.colors) === null || _w3 === void 0 ? void 0 : _w3.gray) === null || _x3 === void 0 ? void 0 : _x3[50],
                    textColor: (_z2 = (_y2 = this.colors) === null || _y2 === void 0 ? void 0 : _y2.gray) === null || _z2 === void 0 ? void 0 : _z2[900],
                    iconColor: (_110 = (_02 = this.colors) === null || _02 === void 0 ? void 0 : _02.gray) === null || _110 === void 0 ? void 0 : _110[600]
                },
                success: {
                    backgroundColor: (_32 = (_22 = this.colors) === null || _22 === void 0 ? void 0 : _22.green) === null || _32 === void 0 ? void 0 : _32[50],
                    textColor: (_51 = (_42 = this.colors) === null || _42 === void 0 ? void 0 : _42.green) === null || _51 === void 0 ? void 0 : _51[900],
                    iconColor: (_71 = (_61 = this.colors) === null || _61 === void 0 ? void 0 : _61.green) === null || _71 === void 0 ? void 0 : _71[600]
                },
                info: {
                    backgroundColor: (_91 = (_81 = this.colors) === null || _81 === void 0 ? void 0 : _81.blue) === null || _91 === void 0 ? void 0 : _91[50],
                    textColor: (_112 = (_101 = this.colors) === null || _101 === void 0 ? void 0 : _101.blue) === null || _112 === void 0 ? void 0 : _112[900],
                    iconColor: (_121 = this.colors) === null || _121 === void 0 ? void 0 : _121.brand
                },
                warning: {
                    backgroundColor: (_141 = (_131 = this.colors) === null || _131 === void 0 ? void 0 : _131.yellow) === null || _141 === void 0 ? void 0 : _141[50],
                    textColor: (_161 = (_151 = this.colors) === null || _151 === void 0 ? void 0 : _151.yellow) === null || _161 === void 0 ? void 0 : _161[900],
                    iconColor: (_181 = (_171 = this.colors) === null || _171 === void 0 ? void 0 : _171.yellow) === null || _181 === void 0 ? void 0 : _181[600]
                },
                danger: {
                    backgroundColor: (_20 = (_191 = this.colors) === null || _191 === void 0 ? void 0 : _191.red) === null || _20 === void 0 ? void 0 : _20[50],
                    textColor: (_221 = (_211 = this.colors) === null || _211 === void 0 ? void 0 : _211.red) === null || _221 === void 0 ? void 0 : _221[900],
                    iconColor: (_24 = (_23 = this.colors) === null || _23 === void 0 ? void 0 : _23.red) === null || _24 === void 0 ? void 0 : _24[600]
                },
                neutral: {
                    backgroundColor: (_26 = (_25 = this.colors) === null || _25 === void 0 ? void 0 : _25.gray) === null || _26 === void 0 ? void 0 : _26[50],
                    textColor: (_28 = (_27 = this.colors) === null || _27 === void 0 ? void 0 : _27.gray) === null || _28 === void 0 ? void 0 : _28[900],
                    iconColor: (_30 = (_29 = this.colors) === null || _29 === void 0 ? void 0 : _29.gray) === null || _30 === void 0 ? void 0 : _30[600]
                },
                neutral_bold: {
                    backgroundColor: (_321 = (_311 = this.colors) === null || _311 === void 0 ? void 0 : _311.gray) === null || _321 === void 0 ? void 0 : _321[700],
                    textColor: (_33 = this.colors) === null || _33 === void 0 ? void 0 : _33.white,
                    iconColor: (_34 = this.colors) === null || _34 === void 0 ? void 0 : _34.white
                }
            };
        },
        get datePicker () {
            var _a20, _b19, _c14, _d14, _e11, _f11;
            return {
                dropdownMenuBackgroundColor: (_a20 = this.colors) === null || _a20 === void 0 ? void 0 : _a20.white,
                dropdownMenuTextColor: (_c14 = (_b19 = this.colors) === null || _b19 === void 0 ? void 0 : _b19.gray) === null || _c14 === void 0 ? void 0 : _c14[900],
                dropdownMenuBoxShadow: "0px 0px 1px rgba(0, 0, 0, 0.2), 0px 4px 8px rgba(0, 0, 0, 0.1)",
                dateHoverColor: (_e11 = (_d14 = this.colors) === null || _d14 === void 0 ? void 0 : _d14.gray) === null || _e11 === void 0 ? void 0 : _e11[100],
                dateSelectedColor: (_f11 = this.colors) === null || _f11 === void 0 ? void 0 : _f11.brand
            };
        },
        // addressed in @styles
        get pagination () {
            var _a21, _b20, _c15, _d15, _e12, _f12, _g9, _h8, _j7, _k6, _l6, _m5, _o5, _p5, _q5, _r5;
            return {
                backgroundColor: (_a21 = this.colors) === null || _a21 === void 0 ? void 0 : _a21.white,
                borderColor: (_c15 = (_b20 = this.colors) === null || _b20 === void 0 ? void 0 : _b20.gray) === null || _c15 === void 0 ? void 0 : _c15[200],
                textColor: (_e12 = (_d15 = this.colors) === null || _d15 === void 0 ? void 0 : _d15.gray) === null || _e12 === void 0 ? void 0 : _e12[600],
                hoverBackgroundColor: (_g9 = (_f12 = this.colors) === null || _f12 === void 0 ? void 0 : _f12.gray) === null || _g9 === void 0 ? void 0 : _g9[100],
                hoverTextColor: (_j7 = (_h8 = this.colors) === null || _h8 === void 0 ? void 0 : _h8.gray) === null || _j7 === void 0 ? void 0 : _j7[600],
                activeBackgroundColor: (_k6 = this.colors) === null || _k6 === void 0 ? void 0 : _k6["brand-pale"],
                activeTextColor: (_l6 = this.colors) === null || _l6 === void 0 ? void 0 : _l6.brand,
                activeBorderColor: (_m5 = this.colors) === null || _m5 === void 0 ? void 0 : _m5.brand,
                disabledBackgroundColor: (_p5 = (_o5 = this.colors) === null || _o5 === void 0 ? void 0 : _o5.gray) === null || _p5 === void 0 ? void 0 : _p5[200],
                disabledTextColor: (_r5 = (_q5 = this.colors) === null || _q5 === void 0 ? void 0 : _q5.gray) === null || _r5 === void 0 ? void 0 : _r5[300]
            };
        },
        get popover () {
            var _a22;
            return {
                backgroundColor: (_a22 = this.colors) === null || _a22 === void 0 ? void 0 : _a22.white,
                boxShadow: "0px 0px 1px rgba(0, 0, 0, 0.2), 0px 4px 8px rgba(0, 0, 0, 0.1)"
            };
        },
        // addressed in @styles
        get progressBar () {
            var _a23, _b21, _c16;
            return {
                backgroundColor: (_b21 = (_a23 = this.colors) === null || _a23 === void 0 ? void 0 : _a23.gray) === null || _b21 === void 0 ? void 0 : _b21[200],
                barBackgroundColor: this.themeOptions.primaryColor ? this.themeOptions.primaryColor : (_c16 = this.colors) === null || _c16 === void 0 ? void 0 : _c16.brand
            };
        },
        get select () {
            var _a24, _b22, _c17, _d16, _e13, _f13, _g10, _h9, _j8, _k7, _l7, _m6;
            return {
                borderColor: (_b22 = (_a24 = this.colors) === null || _a24 === void 0 ? void 0 : _a24.gray) === null || _b22 === void 0 ? void 0 : _b22[400],
                backgroundColor: (_c17 = this.colors) === null || _c17 === void 0 ? void 0 : _c17.white,
                multiValueBackgroundColor: (_e13 = (_d16 = this.colors) === null || _d16 === void 0 ? void 0 : _d16.gray) === null || _e13 === void 0 ? void 0 : _e13[200],
                multiValueRemoveHoverColor: (_g10 = (_f13 = this.colors) === null || _f13 === void 0 ? void 0 : _f13.gray) === null || _g10 === void 0 ? void 0 : _g10[900],
                focusedBoxShadowColor: (_h9 = this.colors) === null || _h9 === void 0 ? void 0 : _h9.brand,
                menuFilterColor: "drop-shadow(0px 0px 1px rgba(0, 0, 0, 0.2)) drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.1))",
                optionHoverBackgroundColor: (_k7 = (_j8 = this.colors) === null || _j8 === void 0 ? void 0 : _j8.gray) === null || _k7 === void 0 ? void 0 : _k7[100],
                groupHeadingColor: (_m6 = (_l7 = this.colors) === null || _l7 === void 0 ? void 0 : _l7.gray) === null || _m6 === void 0 ? void 0 : _m6[900]
            };
        },
        get tooltip () {
            var _a25;
            return {
                backgroundColor: "rgba(17, 24, 39, 0.8)",
                textColor: (_a25 = this.colors) === null || _a25 === void 0 ? void 0 : _a25.white
            };
        },
        // addressed in @styles
        get listGroup () {
            var _a26, _b23, _c18, _d17, _e14;
            return {
                itemBackgroundColor: (_a26 = this.colors) === null || _a26 === void 0 ? void 0 : _a26.white,
                itemHoverBackgroundColor: (_c18 = (_b23 = this.colors) === null || _b23 === void 0 ? void 0 : _b23.gray) === null || _c18 === void 0 ? void 0 : _c18[100],
                itemActiveBackgroundColor: (_e14 = (_d17 = this.colors) === null || _d17 === void 0 ? void 0 : _d17.gray) === null || _e14 === void 0 ? void 0 : _e14[200]
            };
        },
        get tabs () {
            var _a27, _b24, _c19, _d18, _e15, _f14;
            return {
                textColor: (_b24 = (_a27 = this.colors) === null || _a27 === void 0 ? void 0 : _a27.gray) === null || _b24 === void 0 ? void 0 : _b24[600],
                activeTextColor: this.themeOptions.primaryColor ? this.themeOptions.primaryColor : (_c19 = this.colors) === null || _c19 === void 0 ? void 0 : _c19.primary,
                hoverTextColor: (_e15 = (_d18 = this.colors) === null || _d18 === void 0 ? void 0 : _d18.gray) === null || _e15 === void 0 ? void 0 : _e15[800],
                activeBorderColor: this.themeOptions.primaryColor ? this.themeOptions.primaryColor : (_f14 = this.colors) === null || _f14 === void 0 ? void 0 : _f14.primary
            };
        },
        get searchToken () {
            var _a28, _b25, _c20, _d19, _e16, _f15, _g11, _h10, _j9, _k8, _l8, _m7, _o6, _p6, _q6, _r6, _s4, _t4, _u4, _v4, _w4, _x4;
            return {
                padding: "4px 6px",
                borderRadius: "6px",
                fontSize: "14px",
                lineHeight: "20px",
                fontWeight: "600",
                iconIconColor: (_b25 = (_a28 = this.colors) === null || _a28 === void 0 ? void 0 : _a28.gray) === null || _b25 === void 0 ? void 0 : _b25[600],
                dismissIconColor: (_d19 = (_c20 = this.colors) === null || _c20 === void 0 ? void 0 : _c20.gray) === null || _d19 === void 0 ? void 0 : _d19[500],
                gray: {
                    backgroundColor: (_f15 = (_e16 = this.colors) === null || _e16 === void 0 ? void 0 : _e16.gray) === null || _f15 === void 0 ? void 0 : _f15[100],
                    textColor: (_h10 = (_g11 = this.colors) === null || _g11 === void 0 ? void 0 : _g11.gray) === null || _h10 === void 0 ? void 0 : _h10[900],
                    boxShadow: "none",
                    hoverBackgroundColor: (_j9 = this.colors) === null || _j9 === void 0 ? void 0 : _j9["brand-pale"],
                    hoverTextColor: (_k8 = this.colors) === null || _k8 === void 0 ? void 0 : _k8.brand,
                    disabledBackgroundColor: (_m7 = (_l8 = this.colors) === null || _l8 === void 0 ? void 0 : _l8.gray) === null || _m7 === void 0 ? void 0 : _m7[100],
                    disabledTextColor: (_p6 = (_o6 = this.colors) === null || _o6 === void 0 ? void 0 : _o6.gray) === null || _p6 === void 0 ? void 0 : _p6[400]
                },
                white: {
                    backgroundColor: (_q6 = this.colors) === null || _q6 === void 0 ? void 0 : _q6.white,
                    textColor: (_s4 = (_r6 = this.colors) === null || _r6 === void 0 ? void 0 : _r6.gray) === null || _s4 === void 0 ? void 0 : _s4[900],
                    boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.10), 0px 0px 1px 0px rgba(0, 0, 0, 0.20)",
                    hoverBackgroundColor: (_t4 = this.colors) === null || _t4 === void 0 ? void 0 : _t4["brand-pale"],
                    hoverTextColor: (_u4 = this.colors) === null || _u4 === void 0 ? void 0 : _u4["brand-dark"],
                    disabledBackgroundColor: (_v4 = this.colors) === null || _v4 === void 0 ? void 0 : _v4.white,
                    disabledTextColor: (_x4 = (_w4 = this.colors) === null || _w4 === void 0 ? void 0 : _w4.gray) === null || _x4 === void 0 ? void 0 : _x4[400]
                }
            };
        },
        get sidebarNav () {
            var _a29, _b26, _c21, _d20, _e17, _f16, _g12, _h11, _j10, _k9, _l9, _m8, _o7, _p7, _q7, _r7, _s5, _t5, _u5, _v5;
            return {
                backgroundColor: (_a29 = this.colors) === null || _a29 === void 0 ? void 0 : _a29.white,
                borderColor: (_c21 = (_b26 = this.colors) === null || _b26 === void 0 ? void 0 : _b26.gray) === null || _c21 === void 0 ? void 0 : _c21[300],
                boxShadow: "0px 0px 1px 0px rgba(0, 0, 0, 0.36)",
                textColor: (_e17 = (_d20 = this.colors) === null || _d20 === void 0 ? void 0 : _d20.gray) === null || _e17 === void 0 ? void 0 : _e17[900],
                navItem: {
                    selectedBackgroundColor: (_f16 = this.colors) === null || _f16 === void 0 ? void 0 : _f16["brand-pale"],
                    selectedTextColor: (_g12 = this.colors) === null || _g12 === void 0 ? void 0 : _g12.brand,
                    hoverTextColor: (_h11 = this.colors) === null || _h11 === void 0 ? void 0 : _h11.brand
                },
                header: {
                    borderColor: (_k9 = (_j10 = this.colors) === null || _j10 === void 0 ? void 0 : _j10.gray) === null || _k9 === void 0 ? void 0 : _k9[100],
                    separatorColor: (_m8 = (_l9 = this.colors) === null || _l9 === void 0 ? void 0 : _l9.gray) === null || _m8 === void 0 ? void 0 : _m8[200],
                    backgroundColor: "rgba(255, 255, 255, 0.8)",
                    breadcrumb: {
                        textColor: (_p7 = (_o7 = this.colors) === null || _o7 === void 0 ? void 0 : _o7.gray) === null || _p7 === void 0 ? void 0 : _p7[500],
                        activeTextColor: (_r7 = (_q7 = this.colors) === null || _q7 === void 0 ? void 0 : _q7.gray) === null || _r7 === void 0 ? void 0 : _r7[900],
                        hoverTextColor: (_s5 = this.colors) === null || _s5 === void 0 ? void 0 : _s5.brand
                    }
                },
                badge: {
                    textColor: (_t5 = this.colors) === null || _t5 === void 0 ? void 0 : _t5.brand,
                    borderColor: (_v5 = (_u5 = this.colors) === null || _u5 === void 0 ? void 0 : _u5.gray) === null || _v5 === void 0 ? void 0 : _v5[200]
                }
            };
        },
        get actionSheet () {
            var _a30, _b27, _c22;
            return {
                backgroundColor: (_a30 = this.colors) === null || _a30 === void 0 ? void 0 : _a30.white,
                borderRadius: "6px",
                boxShadow: "0px 0px 1px rgba(0, 0, 0, 0.2), 0px 4px 8px rgba(0, 0, 0, 0.1)",
                footerBorderColor: (_b27 = this.colors) === null || _b27 === void 0 ? void 0 : _b27.gray[200],
                footerButtonTextColor: (_c22 = this.colors) === null || _c22 === void 0 ? void 0 : _c22.gray[600]
            };
        }
    };
};


const $dc2e6fc2a1e7cab3$export$2e2bcd8739ae039 = (0, $2fb3ab26f7ac17a4$export$2e2bcd8739ae039)({
    themeName: "default",
    themeOptions: {}
});



var $lmFrL = parcelRequire("lmFrL");
/* eslint-disable max-len */ const $38daacbabd464074$export$c507fb1c2e1ac13a = (0, $lmFrL.createGlobalStyle)`
  body{
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  }
  a{
    color: ${({ theme: theme })=>{
    var _a, _b;
    return ((_a = theme.themeOptions) === null || _a === void 0 ? void 0 : _a.primaryColor) || ((_b = theme.colors) === null || _b === void 0 ? void 0 : _b.primary);
}};
    text-decoration: none;
    &:hover{
      color: ${({ theme: theme })=>{
    var _a, _b;
    return ((_a = theme.themeOptions) === null || _a === void 0 ? void 0 : _a.primaryColor) || ((_b = theme.colors) === null || _b === void 0 ? void 0 : _b.primary);
}};
      text-decoration: underline;
    }
  }
  :root {
  // crete css variables for colors
  ${({ theme: theme })=>theme && theme.colors && Object.keys(theme.colors).map((color)=>{
        var _a, _b;
        return typeof ((_a = theme.colors) === null || _a === void 0 ? void 0 : _a[color]) === "object" ? Object.keys(theme.colors[color]).map((shade)=>{
            var _a;
            return `--helix-${color}-${shade}: ${(_a = theme.colors) === null || _a === void 0 ? void 0 : _a[color][shade]};`;
        }).join("\n") : `--helix-${color}: ${(_b = theme.colors) === null || _b === void 0 ? void 0 : _b[color]};`;
    }).join("\n")}
  --helix-primary-color: ${({ theme: theme })=>{
    var _a, _b;
    return ((_a = theme.themeOptions) === null || _a === void 0 ? void 0 : _a.primaryColor) || ((_b = theme.colors) === null || _b === void 0 ? void 0 : _b.primary);
}};
  --helix-primary-btn-bg-color: ${({ theme: theme })=>{
    var _a, _b;
    return ((_a = theme.themeOptions) === null || _a === void 0 ? void 0 : _a.primaryButtonBackgroundColor) || ((_b = theme.colors) === null || _b === void 0 ? void 0 : _b.primary);
}};
  --helix-primary-btn-text-color: ${({ theme: theme })=>{
    var _a, _b;
    return ((_a = theme.themeOptions) === null || _a === void 0 ? void 0 : _a.primaryButtonTextColor) || ((_b = theme.colors) === null || _b === void 0 ? void 0 : _b.white);
}};
  --helix-primary-btn-hover-bg-color: ${({ theme: theme })=>{
    var _a, _b;
    return ((_a = theme.themeOptions) === null || _a === void 0 ? void 0 : _a.primaryButtonHoverBackgroundColor) || ((_b = theme.colors) === null || _b === void 0 ? void 0 : _b.blue[700]);
}};
  --helix-primary-btn-hover-text-color: ${({ theme: theme })=>{
    var _a, _b;
    return ((_a = theme.themeOptions) === null || _a === void 0 ? void 0 : _a.primaryButtonHoverTextColor) || ((_b = theme.colors) === null || _b === void 0 ? void 0 : _b.white);
}};
  --helix-primary-btn-active-bg-color: ${({ theme: theme })=>{
    var _a, _b;
    return ((_a = theme.themeOptions) === null || _a === void 0 ? void 0 : _a.primaryButtonActiveBackgroundColor) || ((_b = theme.colors) === null || _b === void 0 ? void 0 : _b.blue[800]);
}};
  --helix-primary-btn-active-text-color: ${({ theme: theme })=>{
    var _a, _b;
    return ((_a = theme.themeOptions) === null || _a === void 0 ? void 0 : _a.primaryButtonActiveTextColor) || ((_b = theme.colors) === null || _b === void 0 ? void 0 : _b.white);
}};
 
    --helix-breakpoint-xs: 0;
    --helix-breakpoint-sm: 576px;
    --helix-breakpoint-md: 768px;
    --helix-breakpoint-lg: 992px;
    --helix-breakpoint-xl: 1200px;
    --helix-breakpoint-xxl: 1442px;

  

  }
 `;


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $e6c0f9ed516fb43d$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
typeof SuppressedError === "function" && SuppressedError;



var $acw62 = parcelRequire("acw62");
const $5089040b2761cdf1$var$apiDomains = {
    dev: "https://platform.api.dev.lwolf.com",
    stg: "https://platform.api.stg.lwolf.com",
    pre: "https://platform.api.pre.lwolf.com",
    prod: "https://platform.api.lwolf.com"
};
const $5089040b2761cdf1$export$2e2bcd8739ae039 = ({ environment: environment = "dev", localStorageTokenKey: localStorageTokenKey = "lwaToken", userToken: userToken = "", activeClientId: activeClientId = "" })=>{
    let brandingCache = null;
    const [branding, setBranding] = (0, $acw62.useState)(brandingCache);
    // New format: lwaToken_{env.}lwolf.com
    const newTokenCookieName = environment === "prod" ? "lwaToken_lwolf.com" : `lwaToken_${environment}.lwolf.com`;
    // Fallback format: lwaToken@@{env.}lwolf.com
    const fallbackTokenCookieName = environment === "prod" ? "lwaToken@@lwolf.com" : `lwaToken@@${environment}.lwolf.com`;
    const getTokenFromCookie = ()=>{
        if (!document || !document.cookie) return "";
        const cookies = document.cookie.split(";");
        // First try the new format
        const newFormatCookie = cookies.find((item)=>item.trim().startsWith(newTokenCookieName));
        if (newFormatCookie) return newFormatCookie.split("=")[1] || "";
        // Fall back to the old format
        const fallbackCookie = cookies.find((item)=>item.trim().startsWith(fallbackTokenCookieName));
        if (fallbackCookie) return fallbackCookie.split("=")[1] || "";
        return "";
    };
    const tokenCookie = getTokenFromCookie();
    const getUserToken = ()=>{
        // get the token from the local storage or the cookie or the userToken
        return typeof window !== "undefined" ? window.localStorage.getItem(localStorageTokenKey) || tokenCookie || userToken : "";
    };
    const token = getUserToken();
    const APIEndPoint = `${$5089040b2761cdf1$var$apiDomains[environment]}/v1/clients/${activeClientId}/branding`;
    const fetchBranding = ()=>(0, $e6c0f9ed516fb43d$export$1050f835b63b671e)(void 0, void 0, void 0, function*() {
            try {
                const res = yield fetch(APIEndPoint, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                if (!res.ok) console.log(`Failed to fetch branding: ${res.status}`);
                const data = yield res.json();
                brandingCache = data;
                setBranding(data);
            } catch (error) {
                console.error(error);
            }
        });
    (0, $acw62.useEffect)(()=>{
        if (!activeClientId || branding) return;
        fetchBranding();
    }, [
        environment,
        activeClientId
    ]);
    return {
        branding: branding,
        setBranding: setBranding
    };
};



const $0244c5ae0c15d461$export$5745dc322a60539e = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext({});
const $0244c5ae0c15d461$var$shouldForwardProp = (propName, target)=>{
    if (typeof target === "string") // For HTML elements, forward the prop if it is a valid HTML attribute
    return (0, $c93aa07262cefe21$export$2e2bcd8739ae039)(propName);
    // For other elements, forward all props
    return true;
};
const $0244c5ae0c15d461$export$1afb59dd31f2a570 = ({ theme: theme = (0, $dc2e6fc2a1e7cab3$export$2e2bcd8739ae039), children: children, activeClientId: activeClientId, environment: environment })=>{
    const { branding: branding } = (0, $5089040b2761cdf1$export$2e2bcd8739ae039)({
        environment: environment,
        activeClientId: activeClientId
    });
    const dynamicTheme = (0, $acw62.useMemo)(()=>{
        if (branding === null || branding === void 0 ? void 0 : branding.primaryColor) return (0, $2fb3ab26f7ac17a4$export$2e2bcd8739ae039)({
            themeName: "clientTheme",
            themeOptions: {
                colors: {
                    brand: branding.primaryColor
                }
            }
        });
        return theme;
    }, [
        branding,
        theme
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lmFrL.StyleSheetManager), {
        shouldForwardProp: $0244c5ae0c15d461$var$shouldForwardProp
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $lmFrL.ThemeProvider), {
        theme: dynamicTheme
    }, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $38daacbabd464074$export$c507fb1c2e1ac13a), null), children)));
};
$0244c5ae0c15d461$export$5745dc322a60539e.Consumer;




const { token: $35da740d59af89ba$var$token, tokenType: $35da740d59af89ba$var$tokenType, platformServiceClient: $35da740d59af89ba$var$platformServiceClient } = (0, $f6CJ4.useAuthStore).getState();
const $35da740d59af89ba$var$isLwaAuthenticated = $35da740d59af89ba$var$token && $35da740d59af89ba$var$platformServiceClient?.token === $35da740d59af89ba$var$token;
const $35da740d59af89ba$var$isKeycloakAuthenticated = $35da740d59af89ba$var$token && $35da740d59af89ba$var$tokenType === (0, $cghEn.tokenTypes).KEYCLOAK;
const $35da740d59af89ba$var$isAuthenticated = $35da740d59af89ba$var$isLwaAuthenticated || $35da740d59af89ba$var$isKeycloakAuthenticated;
const $35da740d59af89ba$var$pathname = window.location.pathname;
const $35da740d59af89ba$var$redirectAuth = ()=>{
    if (0, $dDBOF.isAgentMetrics) return;
    (0, $f6CJ4.useAuthStore).setState({
        authError: undefined
    });
    if (!(0, $cghEn.unprotectedRoutes).includes($35da740d59af89ba$var$pathname) && !$35da740d59af89ba$var$isAuthenticated) (0, $7D4kr.navigateToLogin)();
    if ($35da740d59af89ba$var$isAuthenticated && $35da740d59af89ba$var$isLoginPage) {
        const redirectPath = new URLSearchParams(window.location.search).get("redirect");
        if (redirectPath) {
            window.location.replace(redirectPath);
            return;
        }
    }
};
const $35da740d59af89ba$var$isLoginPage = (0, $dDBOF.getIsLoginPage)(window.location.pathname);
document.title = (0, $dDBOF.getDocumentTitle)({
    appLabel: (0, $dDBOF.appLabels)[0, $dDBOF.runningApp],
    softwareVersion: (0, $f17f15f32c892e51$export$cd80471b8ced8783),
    isLoginPage: $35da740d59af89ba$var$isLoginPage
});
const $35da740d59af89ba$var$redirectAgentMetrics = ()=>{
    if (!(0, $dDBOF.isAgentMetrics)) return;
    const isValidationRoute = $35da740d59af89ba$var$pathname === (0, $c7dF9.Routes).VALIDATION.BASE;
    const isAuthRoute = $35da740d59af89ba$var$pathname === (0, $c7dF9.Routes).AUTH.BASE;
    if (!$35da740d59af89ba$var$isLwaAuthenticated && !isValidationRoute && !isAuthRoute) {
        (0, $7D4kr.navigateToPlatformHome)();
        return;
    }
    const isLoginRoute = $35da740d59af89ba$var$pathname === (0, $c7dF9.Routes).AUTH.LOG_IN;
    if (isLoginRoute) (0, $7D4kr.navigateToHome)();
};
!(0, $dDBOF.isAgentMetrics) && $35da740d59af89ba$var$redirectAuth();
(0, $dDBOF.isAgentMetrics) && $35da740d59af89ba$var$redirectAgentMetrics();
const $35da740d59af89ba$var$queryClient = new (0, $993a0f6ad9d6681b$export$405d0624ed55a03f)();
const $35da740d59af89ba$var$Root = ()=>{
    const token = (0, $f6CJ4.useAuthStore)((state)=>state.token);
    return /*#__PURE__*/ (0, $ayMG0.jsxs)((0, $kfZjc.Switch), {
        children: [
            !(0, $dDBOF.isAgentMetrics) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfZjc.Route), {
                exact: true,
                path: (0, $c7dF9.Routes).AUTH.CONNECT,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $8d76f7c357d56ec8$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfZjc.Route), {
                exact: true,
                path: (0, $c7dF9.Routes).AUTH.BASE,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $47cf556aec9eca1b$export$2e2bcd8739ae039), {})
            }),
            token && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4c8cda5d2c6d1d8b$export$2e2bcd8739ae039), {}),
            !(0, $dDBOF.isAgentMetrics) && /*#__PURE__*/ (0, $ayMG0.jsx)((0, $kfZjc.Route), {
                exact: true,
                path: (0, $c7dF9.Routes).AUTH.LOG_IN,
                children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $b6b0287f6135dcd7$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
(0, $1u0KT.render)(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $0126047dd734bc33$export$45604f0cc8ae667b), {
    client: $35da740d59af89ba$var$queryClient,
    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $0244c5ae0c15d461$export$1afb59dd31f2a570), {
        children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $2z9GT.AGGridProvider), {
            license: (0, $cIUhV.AG_GRID_LICENSE),
            children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $4fGPb.BrowserRouter), {
                children: /*#__PURE__*/ (0, $ayMG0.jsx)($35da740d59af89ba$var$Root, {})
            })
        })
    })
}), document.querySelector("#root"));


//# sourceMappingURL=index.757d178c.js.map
